/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(337);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var ReactIs = require('react-is');
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(408)();
	}


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(501);
	} else {
	  module.exports = require('./cjs/react.development.js');
	}


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _theme = __webpack_require__(132);
	
	Object.keys(_theme).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _theme[key];
	    }
	  });
	});
	
	var _mixins = __webpack_require__(626);
	
	Object.keys(_mixins).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _mixins[key];
	    }
	  });
	});
	
	var _styleFunctions = __webpack_require__(211);
	
	Object.keys(_styleFunctions).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _styleFunctions[key];
	    }
	  });
	});
	
	var _styleHelpers = __webpack_require__(632);
	
	Object.keys(_styleHelpers).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _styleHelpers[key];
	    }
	  });
	});
	
	var _utils = __webpack_require__(633);
	
	Object.keys(_utils).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _utils[key];
	    }
	  });
	});
	
	var _constants = __webpack_require__(131);
	
	Object.keys(_constants).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _constants[key];
	    }
	  });
	});
	
	var _withExternalProps = __webpack_require__(625);
	
	Object.keys(_withExternalProps).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _withExternalProps[key];
	    }
	  });
	});
	
	var _globalStyles = __webpack_require__(624);
	
	Object.keys(_globalStyles).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _globalStyles[key];
	    }
	  });
	});
	
	var _resetStyles = __webpack_require__(631);
	
	Object.keys(_resetStyles).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _resetStyles[key];
	    }
	  });
	});
	
	var _Theme = __webpack_require__(622);
	
	Object.keys(_Theme).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Theme[key];
	    }
	  });
	});
	
	var _withTheme = __webpack_require__(623);
	
	Object.keys(_withTheme).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _withTheme[key];
	    }
	  });
	});

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var Stylis = _interopDefault(__webpack_require__(915));
	var _insertRulePlugin = _interopDefault(__webpack_require__(914));
	var React = __webpack_require__(2);
	var React__default = _interopDefault(React);
	var unitless = _interopDefault(__webpack_require__(145));
	var reactIs = __webpack_require__(123);
	var memoize = _interopDefault(__webpack_require__(117));
	var PropTypes = _interopDefault(__webpack_require__(1));
	var validAttr = _interopDefault(__webpack_require__(258));
	var merge = _interopDefault(__webpack_require__(404));
	
	// 
	
	var interleave = (function (strings, interpolations) {
	  var result = [strings[0]];
	
	  for (var i = 0, len = interpolations.length; i < len; i += 1) {
	    result.push(interpolations[i], strings[i + 1]);
	  }
	
	  return result;
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	  return typeof obj;
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	};
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	var inherits = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	var objectWithoutProperties = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};
	
	var possibleConstructorReturn = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};
	
	// 
	var isPlainObject = (function (x) {
	  return (typeof x === 'undefined' ? 'undefined' : _typeof(x)) === 'object' && x.constructor === Object;
	});
	
	// 
	var EMPTY_ARRAY = Object.freeze([]);
	var EMPTY_OBJECT = Object.freeze({});
	
	// 
	function isFunction(test) {
	  return typeof test === 'function';
	}
	
	// 
	
	function getComponentName(target) {
	  return ( false ? typeof target === 'string' && target : false) || target.displayName || target.name || 'Component';
	}
	
	// 
	function isStatelessFunction(test) {
	  return typeof test === 'function' && !(test.prototype && test.prototype.isReactComponent);
	}
	
	// 
	function isStyledComponent(target) {
	  return target && typeof target.styledComponentId === 'string';
	}
	
	// 
	
	var SC_ATTR = typeof process !== 'undefined' && (({"NODE_ENV":"production"}).REACT_APP_SC_ATTR || ({"NODE_ENV":"production"}).SC_ATTR) || 'data-styled';
	
	var SC_VERSION_ATTR = 'data-styled-version';
	
	var SC_STREAM_ATTR = 'data-styled-streamed';
	
	var IS_BROWSER = typeof window !== 'undefined' && 'HTMLElement' in window;
	
	var DISABLE_SPEEDY = typeof SC_DISABLE_SPEEDY === 'boolean' && SC_DISABLE_SPEEDY || typeof process !== 'undefined' && (({"NODE_ENV":"production"}).REACT_APP_SC_DISABLE_SPEEDY || ({"NODE_ENV":"production"}).SC_DISABLE_SPEEDY) || ("production") !== 'production';
	
	// Shared empty execution context when generating static styles
	var STATIC_EXECUTION_CONTEXT = {};
	
	// 
	
	
	/**
	 * Parse errors.md and turn it into a simple hash of code: message
	 */
	var ERRORS =  false ? {
	  "1": "Cannot create styled-component for component: %s.\n\n",
	  "2": "Can't collect styles once you've consumed a `ServerStyleSheet`'s styles! `ServerStyleSheet` is a one off instance for each server-side render cycle.\n\n- Are you trying to reuse it across renders?\n- Are you accidentally calling collectStyles twice?\n\n",
	  "3": "Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.\n\n",
	  "4": "The `StyleSheetManager` expects a valid target or sheet prop!\n\n- Does this error occur on the client and is your target falsy?\n- Does this error occur on the server and is the sheet falsy?\n\n",
	  "5": "The clone method cannot be used on the client!\n\n- Are you running in a client-like environment on the server?\n- Are you trying to run SSR on the client?\n\n",
	  "6": "Trying to insert a new style tag, but the given Node is unmounted!\n\n- Are you using a custom target that isn't mounted?\n- Does your document not have a valid head element?\n- Have you accidentally removed a style tag manually?\n\n",
	  "7": "ThemeProvider: Please return an object from your \"theme\" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n",
	  "8": "ThemeProvider: Please make your \"theme\" prop an object.\n\n",
	  "9": "Missing document `<head>`\n\n",
	  "10": "Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021\n\n",
	  "11": "_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.\n\n",
	  "12": "It seems you are interpolating a keyframe declaration (%s) into an untagged string. This was supported in styled-components v3, but is not longer supported in v4 as keyframes are now injected on-demand. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://www.styled-components.com/docs/api#css\n\n",
	  "13": "%s is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.\n"
	} : {};
	
	/**
	 * super basic version of sprintf
	 */
	function format() {
	  var a = arguments.length <= 0 ? undefined : arguments[0];
	  var b = [];
	
	  for (var c = 1, len = arguments.length; c < len; c += 1) {
	    b.push(arguments.length <= c ? undefined : arguments[c]);
	  }
	
	  b.forEach(function (d) {
	    a = a.replace(/%[a-z]/, d);
	  });
	
	  return a;
	}
	
	/**
	 * Create an error file out of errors.md for development and a simple web link to the full errors
	 * in production mode.
	 */
	
	var StyledComponentsError = function (_Error) {
	  inherits(StyledComponentsError, _Error);
	
	  function StyledComponentsError(code) {
	    classCallCheck(this, StyledComponentsError);
	
	    for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      interpolations[_key - 1] = arguments[_key];
	    }
	
	    if (true) {
	      var _this = possibleConstructorReturn(this, _Error.call(this, 'An error occurred. See https://github.com/styled-components/styled-components/blob/master/packages/styled-components/src/utils/errors.md#' + code + ' for more information.' + (interpolations.length > 0 ? ' Additional arguments: ' + interpolations.join(', ') : '')));
	    } else {
	      var _this = possibleConstructorReturn(this, _Error.call(this, format.apply(undefined, [ERRORS[code]].concat(interpolations)).trim()));
	    }
	    return possibleConstructorReturn(_this);
	  }
	
	  return StyledComponentsError;
	}(Error);
	
	// 
	var SC_COMPONENT_ID = /^[^\S\n]*?\/\* sc-component-id:\s*(\S+)\s+\*\//gm;
	
	var extractComps = (function (maybeCSS) {
	  var css = '' + (maybeCSS || ''); // Definitely a string, and a clone
	  var existingComponents = [];
	  css.replace(SC_COMPONENT_ID, function (match, componentId, matchIndex) {
	    existingComponents.push({ componentId: componentId, matchIndex: matchIndex });
	    return match;
	  });
	  return existingComponents.map(function (_ref, i) {
	    var componentId = _ref.componentId,
	        matchIndex = _ref.matchIndex;
	
	    var nextComp = existingComponents[i + 1];
	    var cssFromDOM = nextComp ? css.slice(matchIndex, nextComp.matchIndex) : css.slice(matchIndex);
	    return { componentId: componentId, cssFromDOM: cssFromDOM };
	  });
	});
	
	// 
	
	var COMMENT_REGEX = /^\s*\/\/.*$/gm;
	
	// NOTE: This stylis instance is only used to split rules from SSR'd style tags
	var stylisSplitter = new Stylis({
	  global: false,
	  cascade: true,
	  keyframe: false,
	  prefix: false,
	  compress: false,
	  semicolon: true
	});
	
	var stylis = new Stylis({
	  global: false,
	  cascade: true,
	  keyframe: false,
	  prefix: true,
	  compress: false,
	  semicolon: false // NOTE: This means "autocomplete missing semicolons"
	});
	
	// Wrap `insertRulePlugin to build a list of rules,
	// and then make our own plugin to return the rules. This
	// makes it easier to hook into the existing SSR architecture
	
	var parsingRules = [];
	
	// eslint-disable-next-line consistent-return
	var returnRulesPlugin = function returnRulesPlugin(context) {
	  if (context === -2) {
	    var parsedRules = parsingRules;
	    parsingRules = [];
	    return parsedRules;
	  }
	};
	
	var parseRulesPlugin = _insertRulePlugin(function (rule) {
	  parsingRules.push(rule);
	});
	
	var _componentId = void 0;
	var _selector = void 0;
	var _selectorRegexp = void 0;
	
	var selfReferenceReplacer = function selfReferenceReplacer(match, offset, string) {
	  if (
	  // the first self-ref is always untouched
	  offset > 0 &&
	  // there should be at least two self-refs to do a replacement (.b > .b)
	  string.slice(0, offset).indexOf(_selector) !== -1 &&
	  // no consecutive self refs (.b.b); that is a precedence boost and treated differently
	  string.slice(offset - _selector.length, offset) !== _selector) {
	    return '.' + _componentId;
	  }
	
	  return match;
	};
	
	/**
	 * When writing a style like
	 *
	 * & + & {
	 *   color: red;
	 * }
	 *
	 * The second ampersand should be a reference to the static component class. stylis
	 * has no knowledge of static class so we have to intelligently replace the base selector.
	 */
	var selfReferenceReplacementPlugin = function selfReferenceReplacementPlugin(context, _, selectors) {
	  if (context === 2 && selectors.length && selectors[0].lastIndexOf(_selector) > 0) {
	    // eslint-disable-next-line no-param-reassign
	    selectors[0] = selectors[0].replace(_selectorRegexp, selfReferenceReplacer);
	  }
	};
	
	stylis.use([selfReferenceReplacementPlugin, parseRulesPlugin, returnRulesPlugin]);
	stylisSplitter.use([parseRulesPlugin, returnRulesPlugin]);
	
	var splitByRules = function splitByRules(css) {
	  return stylisSplitter('', css);
	};
	
	function stringifyRules(rules, selector, prefix) {
	  var componentId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '&';
	
	  var flatCSS = rules.join('').replace(COMMENT_REGEX, ''); // replace JS comments
	
	  var cssStr = selector && prefix ? prefix + ' ' + selector + ' { ' + flatCSS + ' }' : flatCSS;
	
	  // stylis has no concept of state to be passed to plugins
	  // but since JS is single=threaded, we can rely on that to ensure
	  // these properties stay in sync with the current stylis run
	  _componentId = componentId;
	  _selector = selector;
	  _selectorRegexp = new RegExp('\\' + _selector + '\\b', 'g');
	
	  return stylis(prefix || !selector ? '' : selector, cssStr);
	}
	
	// 
	/* eslint-disable camelcase, no-undef */
	
	var getNonce = (function () {
	  return typeof __webpack_nonce__ !== 'undefined' ? __webpack_nonce__ : null;
	});
	
	// 
	/* These are helpers for the StyleTags to keep track of the injected
	 * rule names for each (component) ID that they're keeping track of.
	 * They're crucial for detecting whether a name has already been
	 * injected.
	 * (This excludes rehydrated names) */
	
	/* adds a new ID:name pairing to a names dictionary */
	var addNameForId = function addNameForId(names, id, name) {
	  if (name) {
	    // eslint-disable-next-line no-param-reassign
	    var namesForId = names[id] || (names[id] = Object.create(null));
	    namesForId[name] = true;
	  }
	};
	
	/* resets an ID entirely by overwriting it in the dictionary */
	var resetIdNames = function resetIdNames(names, id) {
	  // eslint-disable-next-line no-param-reassign
	  names[id] = Object.create(null);
	};
	
	/* factory for a names dictionary checking the existance of an ID:name pairing */
	var hasNameForId = function hasNameForId(names) {
	  return function (id, name) {
	    return names[id] !== undefined && names[id][name];
	  };
	};
	
	/* stringifies names for the html/element output */
	var stringifyNames = function stringifyNames(names) {
	  var str = '';
	  // eslint-disable-next-line guard-for-in
	  for (var id in names) {
	    str += Object.keys(names[id]).join(' ') + ' ';
	  }
	  return str.trim();
	};
	
	/* clones the nested names dictionary */
	var cloneNames = function cloneNames(names) {
	  var clone = Object.create(null);
	  // eslint-disable-next-line guard-for-in
	  for (var id in names) {
	    clone[id] = _extends({}, names[id]);
	  }
	  return clone;
	};
	
	// 
	
	/* These are helpers that deal with the insertRule (aka speedy) API
	 * They are used in the StyleTags and specifically the speedy tag
	 */
	
	/* retrieve a sheet for a given style tag */
	var sheetForTag = function sheetForTag(tag) {
	  // $FlowFixMe
	  if (tag.sheet) return tag.sheet;
	
	  /* Firefox quirk requires us to step through all stylesheets to find one owned by the given tag */
	  var size = tag.ownerDocument.styleSheets.length;
	  for (var i = 0; i < size; i += 1) {
	    var sheet = tag.ownerDocument.styleSheets[i];
	    // $FlowFixMe
	    if (sheet.ownerNode === tag) return sheet;
	  }
	
	  /* we should always be able to find a tag */
	  throw new StyledComponentsError(10);
	};
	
	/* insert a rule safely and return whether it was actually injected */
	var safeInsertRule = function safeInsertRule(sheet, cssRule, index) {
	  /* abort early if cssRule string is falsy */
	  if (!cssRule) return false;
	
	  var maxIndex = sheet.cssRules.length;
	
	  try {
	    /* use insertRule and cap passed index with maxIndex (no of cssRules) */
	    sheet.insertRule(cssRule, index <= maxIndex ? index : maxIndex);
	  } catch (err) {
	    /* any error indicates an invalid rule */
	    return false;
	  }
	
	  return true;
	};
	
	/* deletes `size` rules starting from `removalIndex` */
	var deleteRules = function deleteRules(sheet, removalIndex, size) {
	  var lowerBound = removalIndex - size;
	  for (var i = removalIndex; i > lowerBound; i -= 1) {
	    sheet.deleteRule(i);
	  }
	};
	
	// 
	
	/* this marker separates component styles and is important for rehydration */
	var makeTextMarker = function makeTextMarker(id) {
	  return '\n/* sc-component-id: ' + id + ' */\n';
	};
	
	/* add up all numbers in array up until and including the index */
	var addUpUntilIndex = function addUpUntilIndex(sizes, index) {
	  var totalUpToIndex = 0;
	  for (var i = 0; i <= index; i += 1) {
	    totalUpToIndex += sizes[i];
	  }
	
	  return totalUpToIndex;
	};
	
	/* create a new style tag after lastEl */
	var makeStyleTag = function makeStyleTag(target, tagEl, insertBefore) {
	  var targetDocument = document;
	  if (target) targetDocument = target.ownerDocument;else if (tagEl) targetDocument = tagEl.ownerDocument;
	
	  var el = targetDocument.createElement('style');
	  el.setAttribute(SC_ATTR, '');
	  el.setAttribute(SC_VERSION_ATTR, "4.4.0");
	
	  var nonce = getNonce();
	  if (nonce) {
	    el.setAttribute('nonce', nonce);
	  }
	
	  /* Work around insertRule quirk in EdgeHTML */
	  el.appendChild(targetDocument.createTextNode(''));
	
	  if (target && !tagEl) {
	    /* Append to target when no previous element was passed */
	    target.appendChild(el);
	  } else {
	    if (!tagEl || !target || !tagEl.parentNode) {
	      throw new StyledComponentsError(6);
	    }
	
	    /* Insert new style tag after the previous one */
	    tagEl.parentNode.insertBefore(el, insertBefore ? tagEl : tagEl.nextSibling);
	  }
	
	  return el;
	};
	
	/* takes a css factory function and outputs an html styled tag factory */
	var wrapAsHtmlTag = function wrapAsHtmlTag(css, names) {
	  return function (additionalAttrs) {
	    var nonce = getNonce();
	    var attrs = [nonce && 'nonce="' + nonce + '"', SC_ATTR + '="' + stringifyNames(names) + '"', SC_VERSION_ATTR + '="' + "4.4.0" + '"', additionalAttrs];
	
	    var htmlAttr = attrs.filter(Boolean).join(' ');
	    return '<style ' + htmlAttr + '>' + css() + '</style>';
	  };
	};
	
	/* takes a css factory function and outputs an element factory */
	var wrapAsElement = function wrapAsElement(css, names) {
	  return function () {
	    var _props;
	
	    var props = (_props = {}, _props[SC_ATTR] = stringifyNames(names), _props[SC_VERSION_ATTR] = "4.4.0", _props);
	
	    var nonce = getNonce();
	    if (nonce) {
	      // $FlowFixMe
	      props.nonce = nonce;
	    }
	
	    // eslint-disable-next-line react/no-danger
	    return React__default.createElement('style', _extends({}, props, { dangerouslySetInnerHTML: { __html: css() } }));
	  };
	};
	
	var getIdsFromMarkersFactory = function getIdsFromMarkersFactory(markers) {
	  return function () {
	    return Object.keys(markers);
	  };
	};
	
	/* speedy tags utilise insertRule */
	var makeSpeedyTag = function makeSpeedyTag(el, getImportRuleTag) {
	  var names = Object.create(null);
	  var markers = Object.create(null);
	  var sizes = [];
	
	  var extractImport = getImportRuleTag !== undefined;
	  /* indicates whether getImportRuleTag was called */
	  var usedImportRuleTag = false;
	
	  var insertMarker = function insertMarker(id) {
	    var prev = markers[id];
	    if (prev !== undefined) {
	      return prev;
	    }
	
	    markers[id] = sizes.length;
	    sizes.push(0);
	    resetIdNames(names, id);
	
	    return markers[id];
	  };
	
	  var insertRules = function insertRules(id, cssRules, name) {
	    var marker = insertMarker(id);
	    var sheet = sheetForTag(el);
	    var insertIndex = addUpUntilIndex(sizes, marker);
	
	    var injectedRules = 0;
	    var importRules = [];
	    var cssRulesSize = cssRules.length;
	
	    for (var i = 0; i < cssRulesSize; i += 1) {
	      var cssRule = cssRules[i];
	      var mayHaveImport = extractImport; /* @import rules are reordered to appear first */
	      if (mayHaveImport && cssRule.indexOf('@import') !== -1) {
	        importRules.push(cssRule);
	      } else if (safeInsertRule(sheet, cssRule, insertIndex + injectedRules)) {
	        mayHaveImport = false;
	        injectedRules += 1;
	      }
	    }
	
	    if (extractImport && importRules.length > 0) {
	      usedImportRuleTag = true;
	      // $FlowFixMe
	      getImportRuleTag().insertRules(id + '-import', importRules);
	    }
	
	    sizes[marker] += injectedRules; /* add up no of injected rules */
	    addNameForId(names, id, name);
	  };
	
	  var removeRules = function removeRules(id) {
	    var marker = markers[id];
	    if (marker === undefined) return;
	    // $FlowFixMe
	    if (el.isConnected === false) return;
	
	    var size = sizes[marker];
	    var sheet = sheetForTag(el);
	    var removalIndex = addUpUntilIndex(sizes, marker) - 1;
	    deleteRules(sheet, removalIndex, size);
	    sizes[marker] = 0;
	    resetIdNames(names, id);
	
	    if (extractImport && usedImportRuleTag) {
	      // $FlowFixMe
	      getImportRuleTag().removeRules(id + '-import');
	    }
	  };
	
	  var css = function css() {
	    var _sheetForTag = sheetForTag(el),
	        cssRules = _sheetForTag.cssRules;
	
	    var str = '';
	
	    // eslint-disable-next-line guard-for-in
	    for (var id in markers) {
	      str += makeTextMarker(id);
	      var marker = markers[id];
	      var end = addUpUntilIndex(sizes, marker);
	      var size = sizes[marker];
	      for (var i = end - size; i < end; i += 1) {
	        var rule = cssRules[i];
	        if (rule !== undefined) {
	          str += rule.cssText;
	        }
	      }
	    }
	
	    return str;
	  };
	
	  return {
	    clone: function clone() {
	      throw new StyledComponentsError(5);
	    },
	
	    css: css,
	    getIds: getIdsFromMarkersFactory(markers),
	    hasNameForId: hasNameForId(names),
	    insertMarker: insertMarker,
	    insertRules: insertRules,
	    removeRules: removeRules,
	    sealed: false,
	    styleTag: el,
	    toElement: wrapAsElement(css, names),
	    toHTML: wrapAsHtmlTag(css, names)
	  };
	};
	
	var makeTextNode = function makeTextNode(targetDocument, id) {
	  return targetDocument.createTextNode(makeTextMarker(id));
	};
	
	var makeBrowserTag = function makeBrowserTag(el, getImportRuleTag) {
	  var names = Object.create(null);
	  var markers = Object.create(null);
	
	  var extractImport = getImportRuleTag !== undefined;
	
	  /* indicates whether getImportRuleTag was called */
	  var usedImportRuleTag = false;
	
	  var insertMarker = function insertMarker(id) {
	    var prev = markers[id];
	    if (prev !== undefined) {
	      return prev;
	    }
	
	    markers[id] = makeTextNode(el.ownerDocument, id);
	    el.appendChild(markers[id]);
	    names[id] = Object.create(null);
	
	    return markers[id];
	  };
	
	  var insertRules = function insertRules(id, cssRules, name) {
	    var marker = insertMarker(id);
	    var importRules = [];
	    var cssRulesSize = cssRules.length;
	
	    for (var i = 0; i < cssRulesSize; i += 1) {
	      var rule = cssRules[i];
	      var mayHaveImport = extractImport;
	      if (mayHaveImport && rule.indexOf('@import') !== -1) {
	        importRules.push(rule);
	      } else {
	        mayHaveImport = false;
	        var separator = i === cssRulesSize - 1 ? '' : ' ';
	        marker.appendData('' + rule + separator);
	      }
	    }
	
	    addNameForId(names, id, name);
	
	    if (extractImport && importRules.length > 0) {
	      usedImportRuleTag = true;
	      // $FlowFixMe
	      getImportRuleTag().insertRules(id + '-import', importRules);
	    }
	  };
	
	  var removeRules = function removeRules(id) {
	    var marker = markers[id];
	    if (marker === undefined) return;
	
	    /* create new empty text node and replace the current one */
	    var newMarker = makeTextNode(el.ownerDocument, id);
	    el.replaceChild(newMarker, marker);
	    markers[id] = newMarker;
	    resetIdNames(names, id);
	
	    if (extractImport && usedImportRuleTag) {
	      // $FlowFixMe
	      getImportRuleTag().removeRules(id + '-import');
	    }
	  };
	
	  var css = function css() {
	    var str = '';
	
	    // eslint-disable-next-line guard-for-in
	    for (var id in markers) {
	      str += markers[id].data;
	    }
	
	    return str;
	  };
	
	  return {
	    clone: function clone() {
	      throw new StyledComponentsError(5);
	    },
	
	    css: css,
	    getIds: getIdsFromMarkersFactory(markers),
	    hasNameForId: hasNameForId(names),
	    insertMarker: insertMarker,
	    insertRules: insertRules,
	    removeRules: removeRules,
	    sealed: false,
	    styleTag: el,
	    toElement: wrapAsElement(css, names),
	    toHTML: wrapAsHtmlTag(css, names)
	  };
	};
	
	var makeServerTag = function makeServerTag(namesArg, markersArg) {
	  var names = namesArg === undefined ? Object.create(null) : namesArg;
	  var markers = markersArg === undefined ? Object.create(null) : markersArg;
	
	  var insertMarker = function insertMarker(id) {
	    var prev = markers[id];
	    if (prev !== undefined) {
	      return prev;
	    }
	
	    return markers[id] = [''];
	  };
	
	  var insertRules = function insertRules(id, cssRules, name) {
	    var marker = insertMarker(id);
	    marker[0] += cssRules.join(' ');
	    addNameForId(names, id, name);
	  };
	
	  var removeRules = function removeRules(id) {
	    var marker = markers[id];
	    if (marker === undefined) return;
	    marker[0] = '';
	    resetIdNames(names, id);
	  };
	
	  var css = function css() {
	    var str = '';
	    // eslint-disable-next-line guard-for-in
	    for (var id in markers) {
	      var cssForId = markers[id][0];
	      if (cssForId) {
	        str += makeTextMarker(id) + cssForId;
	      }
	    }
	    return str;
	  };
	
	  var clone = function clone() {
	    var namesClone = cloneNames(names);
	    var markersClone = Object.create(null);
	
	    // eslint-disable-next-line guard-for-in
	    for (var id in markers) {
	      markersClone[id] = [markers[id][0]];
	    }
	
	    return makeServerTag(namesClone, markersClone);
	  };
	
	  var tag = {
	    clone: clone,
	    css: css,
	    getIds: getIdsFromMarkersFactory(markers),
	    hasNameForId: hasNameForId(names),
	    insertMarker: insertMarker,
	    insertRules: insertRules,
	    removeRules: removeRules,
	    sealed: false,
	    styleTag: null,
	    toElement: wrapAsElement(css, names),
	    toHTML: wrapAsHtmlTag(css, names)
	  };
	
	  return tag;
	};
	
	var makeTag = function makeTag(target, tagEl, forceServer, insertBefore, getImportRuleTag) {
	  if (IS_BROWSER && !forceServer) {
	    var el = makeStyleTag(target, tagEl, insertBefore);
	
	    if (DISABLE_SPEEDY) {
	      return makeBrowserTag(el, getImportRuleTag);
	    } else {
	      return makeSpeedyTag(el, getImportRuleTag);
	    }
	  }
	
	  return makeServerTag();
	};
	
	var rehydrate = function rehydrate(tag, els, extracted) {
	  /* add all extracted components to the new tag */
	  for (var i = 0, len = extracted.length; i < len; i += 1) {
	    var _extracted$i = extracted[i],
	        componentId = _extracted$i.componentId,
	        cssFromDOM = _extracted$i.cssFromDOM;
	
	    var cssRules = splitByRules(cssFromDOM);
	    tag.insertRules(componentId, cssRules);
	  }
	
	  /* remove old HTMLStyleElements, since they have been rehydrated */
	  for (var _i = 0, _len = els.length; _i < _len; _i += 1) {
	    var el = els[_i];
	    if (el.parentNode) {
	      el.parentNode.removeChild(el);
	    }
	  }
	};
	
	// 
	
	var SPLIT_REGEX = /\s+/;
	
	/* determine the maximum number of components before tags are sharded */
	var MAX_SIZE = void 0;
	if (IS_BROWSER) {
	  /* in speedy mode we can keep a lot more rules in a sheet before a slowdown can be expected */
	  MAX_SIZE = DISABLE_SPEEDY ? 40 : 1000;
	} else {
	  /* for servers we do not need to shard at all */
	  MAX_SIZE = -1;
	}
	
	var sheetRunningId = 0;
	var master = void 0;
	
	var StyleSheet = function () {
	
	  /* a map from ids to tags */
	
	  /* deferred rules for a given id */
	
	  /* this is used for not reinjecting rules via hasNameForId() */
	
	  /* when rules for an id are removed using remove() we have to ignore rehydratedNames for it */
	
	  /* a list of tags belonging to this StyleSheet */
	
	  /* a tag for import rules */
	
	  /* current capacity until a new tag must be created */
	
	  /* children (aka clones) of this StyleSheet inheriting all and future injections */
	
	  function StyleSheet() {
	    var _this = this;
	
	    var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : IS_BROWSER ? document.head : null;
	    var forceServer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	    classCallCheck(this, StyleSheet);
	
	    this.getImportRuleTag = function () {
	      var importRuleTag = _this.importRuleTag;
	
	      if (importRuleTag !== undefined) {
	        return importRuleTag;
	      }
	
	      var firstTag = _this.tags[0];
	      var insertBefore = true;
	
	      return _this.importRuleTag = makeTag(_this.target, firstTag ? firstTag.styleTag : null, _this.forceServer, insertBefore);
	    };
	
	    sheetRunningId += 1;
	    this.id = sheetRunningId;
	    this.forceServer = forceServer;
	    this.target = forceServer ? null : target;
	    this.tagMap = {};
	    this.deferred = {};
	    this.rehydratedNames = {};
	    this.ignoreRehydratedNames = {};
	    this.tags = [];
	    this.capacity = 1;
	    this.clones = [];
	  }
	
	  /* rehydrate all SSR'd style tags */
	
	
	  StyleSheet.prototype.rehydrate = function rehydrate$$1() {
	    if (!IS_BROWSER || this.forceServer) return this;
	
	    var els = [];
	    var extracted = [];
	    var isStreamed = false;
	
	    /* retrieve all of our SSR style elements from the DOM */
	    var nodes = document.querySelectorAll('style[' + SC_ATTR + '][' + SC_VERSION_ATTR + '="' + "4.4.0" + '"]');
	
	    var nodesSize = nodes.length;
	
	    /* abort rehydration if no previous style tags were found */
	    if (!nodesSize) return this;
	
	    for (var i = 0; i < nodesSize; i += 1) {
	      var el = nodes[i];
	
	      /* check if style tag is a streamed tag */
	      if (!isStreamed) isStreamed = !!el.getAttribute(SC_STREAM_ATTR);
	
	      /* retrieve all component names */
	      var elNames = (el.getAttribute(SC_ATTR) || '').trim().split(SPLIT_REGEX);
	      var elNamesSize = elNames.length;
	      for (var j = 0, name; j < elNamesSize; j += 1) {
	        name = elNames[j];
	        /* add rehydrated name to sheet to avoid re-adding styles */
	        this.rehydratedNames[name] = true;
	      }
	
	      /* extract all components and their CSS */
	      extracted.push.apply(extracted, extractComps(el.textContent));
	
	      /* store original HTMLStyleElement */
	      els.push(el);
	    }
	
	    /* abort rehydration if nothing was extracted */
	    var extractedSize = extracted.length;
	    if (!extractedSize) return this;
	
	    /* create a tag to be used for rehydration */
	    var tag = this.makeTag(null);
	
	    rehydrate(tag, els, extracted);
	
	    /* reset capacity and adjust MAX_SIZE by the initial size of the rehydration */
	    this.capacity = Math.max(1, MAX_SIZE - extractedSize);
	    this.tags.push(tag);
	
	    /* retrieve all component ids */
	    for (var _j = 0; _j < extractedSize; _j += 1) {
	      this.tagMap[extracted[_j].componentId] = tag;
	    }
	
	    return this;
	  };
	
	  /* retrieve a "master" instance of StyleSheet which is typically used when no other is available
	   * The master StyleSheet is targeted by createGlobalStyle, keyframes, and components outside of any
	    * StyleSheetManager's context */
	
	
	  /* reset the internal "master" instance */
	  StyleSheet.reset = function reset() {
	    var forceServer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    master = new StyleSheet(undefined, forceServer).rehydrate();
	  };
	
	  /* adds "children" to the StyleSheet that inherit all of the parents' rules
	   * while their own rules do not affect the parent */
	
	
	  StyleSheet.prototype.clone = function clone() {
	    var sheet = new StyleSheet(this.target, this.forceServer);
	
	    /* add to clone array */
	    this.clones.push(sheet);
	
	    /* clone all tags */
	    sheet.tags = this.tags.map(function (tag) {
	      var ids = tag.getIds();
	      var newTag = tag.clone();
	
	      /* reconstruct tagMap */
	      for (var i = 0; i < ids.length; i += 1) {
	        sheet.tagMap[ids[i]] = newTag;
	      }
	
	      return newTag;
	    });
	
	    /* clone other maps */
	    sheet.rehydratedNames = _extends({}, this.rehydratedNames);
	    sheet.deferred = _extends({}, this.deferred);
	
	    return sheet;
	  };
	
	  /* force StyleSheet to create a new tag on the next injection */
	
	
	  StyleSheet.prototype.sealAllTags = function sealAllTags() {
	    this.capacity = 1;
	
	    this.tags.forEach(function (tag) {
	      // eslint-disable-next-line no-param-reassign
	      tag.sealed = true;
	    });
	  };
	
	  StyleSheet.prototype.makeTag = function makeTag$$1(tag) {
	    var lastEl = tag ? tag.styleTag : null;
	    var insertBefore = false;
	
	    return makeTag(this.target, lastEl, this.forceServer, insertBefore, this.getImportRuleTag);
	  };
	
	  /* get a tag for a given componentId, assign the componentId to one, or shard */
	  StyleSheet.prototype.getTagForId = function getTagForId(id) {
	    /* simply return a tag, when the componentId was already assigned one */
	    var prev = this.tagMap[id];
	    if (prev !== undefined && !prev.sealed) {
	      return prev;
	    }
	
	    var tag = this.tags[this.tags.length - 1];
	
	    /* shard (create a new tag) if the tag is exhausted (See MAX_SIZE) */
	    this.capacity -= 1;
	
	    if (this.capacity === 0) {
	      this.capacity = MAX_SIZE;
	      tag = this.makeTag(tag);
	      this.tags.push(tag);
	    }
	
	    return this.tagMap[id] = tag;
	  };
	
	  /* mainly for createGlobalStyle to check for its id */
	
	
	  StyleSheet.prototype.hasId = function hasId(id) {
	    return this.tagMap[id] !== undefined;
	  };
	
	  /* caching layer checking id+name to already have a corresponding tag and injected rules */
	
	
	  StyleSheet.prototype.hasNameForId = function hasNameForId(id, name) {
	    /* exception for rehydrated names which are checked separately */
	    if (this.ignoreRehydratedNames[id] === undefined && this.rehydratedNames[name]) {
	      return true;
	    }
	
	    var tag = this.tagMap[id];
	    return tag !== undefined && tag.hasNameForId(id, name);
	  };
	
	  /* registers a componentId and registers it on its tag */
	
	
	  StyleSheet.prototype.deferredInject = function deferredInject(id, cssRules) {
	    /* don't inject when the id is already registered */
	    if (this.tagMap[id] !== undefined) return;
	
	    var clones = this.clones;
	
	    for (var i = 0; i < clones.length; i += 1) {
	      clones[i].deferredInject(id, cssRules);
	    }
	
	    this.getTagForId(id).insertMarker(id);
	    this.deferred[id] = cssRules;
	  };
	
	  /* injects rules for a given id with a name that will need to be cached */
	
	
	  StyleSheet.prototype.inject = function inject(id, cssRules, name) {
	    var clones = this.clones;
	
	
	    for (var i = 0; i < clones.length; i += 1) {
	      clones[i].inject(id, cssRules, name);
	    }
	
	    var tag = this.getTagForId(id);
	
	    /* add deferred rules for component */
	    if (this.deferred[id] !== undefined) {
	      // Combine passed cssRules with previously deferred CSS rules
	      // NOTE: We cannot mutate the deferred array itself as all clones
	      // do the same (see clones[i].inject)
	      var rules = this.deferred[id].concat(cssRules);
	      tag.insertRules(id, rules, name);
	
	      this.deferred[id] = undefined;
	    } else {
	      tag.insertRules(id, cssRules, name);
	    }
	  };
	
	  /* removes all rules for a given id, which doesn't remove its marker but resets it */
	
	
	  StyleSheet.prototype.remove = function remove(id) {
	    var tag = this.tagMap[id];
	    if (tag === undefined) return;
	
	    var clones = this.clones;
	
	    for (var i = 0; i < clones.length; i += 1) {
	      clones[i].remove(id);
	    }
	
	    /* remove all rules from the tag */
	    tag.removeRules(id);
	
	    /* ignore possible rehydrated names */
	    this.ignoreRehydratedNames[id] = true;
	
	    /* delete possible deferred rules */
	    this.deferred[id] = undefined;
	  };
	
	  StyleSheet.prototype.toHTML = function toHTML() {
	    return this.tags.map(function (tag) {
	      return tag.toHTML();
	    }).join('');
	  };
	
	  StyleSheet.prototype.toReactElements = function toReactElements() {
	    var id = this.id;
	
	
	    return this.tags.map(function (tag, i) {
	      var key = 'sc-' + id + '-' + i;
	      return React.cloneElement(tag.toElement(), { key: key });
	    });
	  };
	
	  createClass(StyleSheet, null, [{
	    key: 'master',
	    get: function get$$1() {
	      return master || (master = new StyleSheet().rehydrate());
	    }
	
	    /* NOTE: This is just for backwards-compatibility with jest-styled-components */
	
	  }, {
	    key: 'instance',
	    get: function get$$1() {
	      return StyleSheet.master;
	    }
	  }]);
	  return StyleSheet;
	}();
	
	// 
	
	var Keyframes = function () {
	  function Keyframes(name, rules) {
	    var _this = this;
	
	    classCallCheck(this, Keyframes);
	
	    this.inject = function (styleSheet) {
	      if (!styleSheet.hasNameForId(_this.id, _this.name)) {
	        styleSheet.inject(_this.id, _this.rules, _this.name);
	      }
	    };
	
	    this.toString = function () {
	      throw new StyledComponentsError(12, String(_this.name));
	    };
	
	    this.name = name;
	    this.rules = rules;
	
	    this.id = 'sc-keyframes-' + name;
	  }
	
	  Keyframes.prototype.getName = function getName() {
	    return this.name;
	  };
	
	  return Keyframes;
	}();
	
	// 
	
	/**
	 * inlined version of
	 * https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/hyphenateStyleName.js
	 */
	
	var uppercasePattern = /([A-Z])/g;
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return string.replace(uppercasePattern, '-$1').toLowerCase().replace(msPattern, '-ms-');
	}
	
	// 
	
	// Taken from https://github.com/facebook/react/blob/b87aabdfe1b7461e7331abb3601d9e6bb27544bc/packages/react-dom/src/shared/dangerousStyleValue.js
	function addUnitIfNeeded(name, value) {
	  // https://github.com/amilajack/eslint-plugin-flowtype-errors/issues/133
	  // $FlowFixMe
	  if (value == null || typeof value === 'boolean' || value === '') {
	    return '';
	  }
	
	  if (typeof value === 'number' && value !== 0 && !(name in unitless)) {
	    return value + 'px'; // Presumes implicit 'px' suffix for unitless numbers
	  }
	
	  return String(value).trim();
	}
	
	// 
	
	/**
	 * It's falsish not falsy because 0 is allowed.
	 */
	var isFalsish = function isFalsish(chunk) {
	  return chunk === undefined || chunk === null || chunk === false || chunk === '';
	};
	
	var objToCssArray = function objToCssArray(obj, prevKey) {
	  var rules = [];
	  var keys = Object.keys(obj);
	
	  keys.forEach(function (key) {
	    if (!isFalsish(obj[key])) {
	      if (isPlainObject(obj[key])) {
	        rules.push.apply(rules, objToCssArray(obj[key], key));
	
	        return rules;
	      } else if (isFunction(obj[key])) {
	        rules.push(hyphenateStyleName(key) + ':', obj[key], ';');
	
	        return rules;
	      }
	      rules.push(hyphenateStyleName(key) + ': ' + addUnitIfNeeded(key, obj[key]) + ';');
	    }
	    return rules;
	  });
	
	  return prevKey ? [prevKey + ' {'].concat(rules, ['}']) : rules;
	};
	
	function flatten(chunk, executionContext, styleSheet) {
	  if (Array.isArray(chunk)) {
	    var ruleSet = [];
	
	    for (var i = 0, len = chunk.length, result; i < len; i += 1) {
	      result = flatten(chunk[i], executionContext, styleSheet);
	
	      if (result === null) continue;else if (Array.isArray(result)) ruleSet.push.apply(ruleSet, result);else ruleSet.push(result);
	    }
	
	    return ruleSet;
	  }
	
	  if (isFalsish(chunk)) {
	    return null;
	  }
	
	  /* Handle other components */
	  if (isStyledComponent(chunk)) {
	    return '.' + chunk.styledComponentId;
	  }
	
	  /* Either execute or defer the function */
	  if (isFunction(chunk)) {
	    if (isStatelessFunction(chunk) && executionContext) {
	      var _result = chunk(executionContext);
	
	      if (false) {
	        // eslint-disable-next-line no-console
	        console.warn(getComponentName(chunk) + ' is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.');
	      }
	
	      return flatten(_result, executionContext, styleSheet);
	    } else return chunk;
	  }
	
	  if (chunk instanceof Keyframes) {
	    if (styleSheet) {
	      chunk.inject(styleSheet);
	      return chunk.getName();
	    } else return chunk;
	  }
	
	  /* Handle objects */
	  return isPlainObject(chunk) ? objToCssArray(chunk) : chunk.toString();
	}
	
	// 
	
	function css(styles) {
	  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    interpolations[_key - 1] = arguments[_key];
	  }
	
	  if (isFunction(styles) || isPlainObject(styles)) {
	    // $FlowFixMe
	    return flatten(interleave(EMPTY_ARRAY, [styles].concat(interpolations)));
	  }
	
	  // $FlowFixMe
	  return flatten(interleave(styles, interpolations));
	}
	
	// 
	
	function constructWithOptions(componentConstructor, tag) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EMPTY_OBJECT;
	
	  if (!reactIs.isValidElementType(tag)) {
	    throw new StyledComponentsError(1, String(tag));
	  }
	
	  /* This is callable directly as a template function */
	  // $FlowFixMe: Not typed to avoid destructuring arguments
	  var templateFunction = function templateFunction() {
	    return componentConstructor(tag, options, css.apply(undefined, arguments));
	  };
	
	  /* If config methods are called, wrap up a new template function and merge options */
	  templateFunction.withConfig = function (config) {
	    return constructWithOptions(componentConstructor, tag, _extends({}, options, config));
	  };
	
	  /* Modify/inject new props at runtime */
	  templateFunction.attrs = function (attrs) {
	    return constructWithOptions(componentConstructor, tag, _extends({}, options, {
	      attrs: Array.prototype.concat(options.attrs, attrs).filter(Boolean)
	    }));
	  };
	
	  return templateFunction;
	}
	
	// 
	// Source: https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
	function murmurhash(c) {
	  for (var e = c.length | 0, a = e | 0, d = 0, b; e >= 4;) {
	    b = c.charCodeAt(d) & 255 | (c.charCodeAt(++d) & 255) << 8 | (c.charCodeAt(++d) & 255) << 16 | (c.charCodeAt(++d) & 255) << 24, b = 1540483477 * (b & 65535) + ((1540483477 * (b >>> 16) & 65535) << 16), b ^= b >>> 24, b = 1540483477 * (b & 65535) + ((1540483477 * (b >>> 16) & 65535) << 16), a = 1540483477 * (a & 65535) + ((1540483477 * (a >>> 16) & 65535) << 16) ^ b, e -= 4, ++d;
	  }
	  switch (e) {
	    case 3:
	      a ^= (c.charCodeAt(d + 2) & 255) << 16;
	    case 2:
	      a ^= (c.charCodeAt(d + 1) & 255) << 8;
	    case 1:
	      a ^= c.charCodeAt(d) & 255, a = 1540483477 * (a & 65535) + ((1540483477 * (a >>> 16) & 65535) << 16);
	  }
	  a ^= a >>> 13;
	  a = 1540483477 * (a & 65535) + ((1540483477 * (a >>> 16) & 65535) << 16);
	  return (a ^ a >>> 15) >>> 0;
	}
	
	// 
	/* eslint-disable no-bitwise */
	
	/* This is the "capacity" of our alphabet i.e. 2x26 for all letters plus their capitalised
	 * counterparts */
	var charsLength = 52;
	
	/* start at 75 for 'a' until 'z' (25) and then start at 65 for capitalised letters */
	var getAlphabeticChar = function getAlphabeticChar(code) {
	  return String.fromCharCode(code + (code > 25 ? 39 : 97));
	};
	
	/* input a number, usually a hash and convert it to base-52 */
	function generateAlphabeticName(code) {
	  var name = '';
	  var x = void 0;
	
	  /* get a char and divide by alphabet-length */
	  for (x = code; x > charsLength; x = Math.floor(x / charsLength)) {
	    name = getAlphabeticChar(x % charsLength) + name;
	  }
	
	  return getAlphabeticChar(x % charsLength) + name;
	}
	
	// 
	
	function hasFunctionObjectKey(obj) {
	  // eslint-disable-next-line guard-for-in, no-restricted-syntax
	  for (var key in obj) {
	    if (isFunction(obj[key])) {
	      return true;
	    }
	  }
	
	  return false;
	}
	
	function isStaticRules(rules, attrs) {
	  for (var i = 0; i < rules.length; i += 1) {
	    var rule = rules[i];
	
	    // recursive case
	    if (Array.isArray(rule) && !isStaticRules(rule, attrs)) {
	      return false;
	    } else if (isFunction(rule) && !isStyledComponent(rule)) {
	      // functions are allowed to be static if they're just being
	      // used to get the classname of a nested styled component
	      return false;
	    }
	  }
	
	  if (attrs.some(function (x) {
	    return isFunction(x) || hasFunctionObjectKey(x);
	  })) return false;
	
	  return true;
	}
	
	// 
	
	/* combines hashStr (murmurhash) and nameGenerator for convenience */
	var hasher = function hasher(str) {
	  return generateAlphabeticName(murmurhash(str));
	};
	
	/*
	 ComponentStyle is all the CSS-specific stuff, not
	 the React-specific stuff.
	 */
	
	var ComponentStyle = function () {
	  function ComponentStyle(rules, attrs, componentId) {
	    classCallCheck(this, ComponentStyle);
	
	    this.rules = rules;
	    this.isStatic = ("production") === 'production' && isStaticRules(rules, attrs);
	    this.componentId = componentId;
	
	    if (!StyleSheet.master.hasId(componentId)) {
	      StyleSheet.master.deferredInject(componentId, []);
	    }
	  }
	
	  /*
	   * Flattens a rule set into valid CSS
	   * Hashes it, wraps the whole chunk in a .hash1234 {}
	   * Returns the hash to be injected on render()
	   * */
	
	
	  ComponentStyle.prototype.generateAndInjectStyles = function generateAndInjectStyles(executionContext, styleSheet) {
	    var isStatic = this.isStatic,
	        componentId = this.componentId,
	        lastClassName = this.lastClassName;
	
	    if (IS_BROWSER && isStatic && typeof lastClassName === 'string' && styleSheet.hasNameForId(componentId, lastClassName)) {
	      return lastClassName;
	    }
	
	    var flatCSS = flatten(this.rules, executionContext, styleSheet);
	    var name = hasher(this.componentId + flatCSS.join(''));
	    if (!styleSheet.hasNameForId(componentId, name)) {
	      styleSheet.inject(this.componentId, stringifyRules(flatCSS, '.' + name, undefined, componentId), name);
	    }
	
	    this.lastClassName = name;
	    return name;
	  };
	
	  ComponentStyle.generateName = function generateName(str) {
	    return hasher(str);
	  };
	
	  return ComponentStyle;
	}();
	
	// 
	
	var LIMIT = 200;
	
	var createWarnTooManyClasses = (function (displayName) {
	  var generatedClasses = {};
	  var warningSeen = false;
	
	  return function (className) {
	    if (!warningSeen) {
	      generatedClasses[className] = true;
	      if (Object.keys(generatedClasses).length >= LIMIT) {
	        // Unable to find latestRule in test environment.
	        /* eslint-disable no-console, prefer-template */
	        console.warn('Over ' + LIMIT + ' classes were generated for component ' + displayName + '. \n' + 'Consider using the attrs method, together with a style object for frequently changed styles.\n' + 'Example:\n' + '  const Component = styled.div.attrs(props => ({\n' + '    style: {\n' + '      background: props.background,\n' + '    },\n' + '  }))`width: 100%;`\n\n' + '  <Component />');
	        warningSeen = true;
	        generatedClasses = {};
	      }
	    }
	  };
	});
	
	// 
	
	var determineTheme = (function (props, fallbackTheme) {
	  var defaultProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EMPTY_OBJECT;
	
	  // Props should take precedence over ThemeProvider, which should take precedence over
	  // defaultProps, but React automatically puts defaultProps on props.
	
	  /* eslint-disable react/prop-types, flowtype-errors/show-errors */
	  var isDefaultTheme = defaultProps ? props.theme === defaultProps.theme : false;
	  var theme = props.theme && !isDefaultTheme ? props.theme : fallbackTheme || defaultProps.theme;
	  /* eslint-enable */
	
	  return theme;
	});
	
	// 
	var escapeRegex = /[[\].#*$><+~=|^:(),"'`-]+/g;
	var dashesAtEnds = /(^-|-$)/g;
	
	/**
	 * TODO: Explore using CSS.escape when it becomes more available
	 * in evergreen browsers.
	 */
	function escape(str) {
	  return str
	  // Replace all possible CSS selectors
	  .replace(escapeRegex, '-')
	
	  // Remove extraneous hyphens at the start and end
	  .replace(dashesAtEnds, '');
	}
	
	// 
	
	function isTag(target) {
	  return typeof target === 'string' && ( false ? target.charAt(0) === target.charAt(0).toLowerCase() : true);
	}
	
	// 
	
	function generateDisplayName(target) {
	  // $FlowFixMe
	  return isTag(target) ? 'styled.' + target : 'Styled(' + getComponentName(target) + ')';
	}
	
	var _TYPE_STATICS;
	
	var REACT_STATICS = {
	  childContextTypes: true,
	  contextTypes: true,
	  defaultProps: true,
	  displayName: true,
	  getDerivedStateFromProps: true,
	  propTypes: true,
	  type: true
	};
	
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	
	var TYPE_STATICS = (_TYPE_STATICS = {}, _TYPE_STATICS[reactIs.ForwardRef] = {
	  $$typeof: true,
	  render: true
	}, _TYPE_STATICS);
	
	var defineProperty$1 = Object.defineProperty,
	    getOwnPropertyNames = Object.getOwnPropertyNames,
	    _Object$getOwnPropert = Object.getOwnPropertySymbols,
	    getOwnPropertySymbols = _Object$getOwnPropert === undefined ? function () {
	  return [];
	} : _Object$getOwnPropert,
	    getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor,
	    getPrototypeOf = Object.getPrototypeOf,
	    objectPrototype = Object.prototype;
	var arrayPrototype = Array.prototype;
	
	
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	  if (typeof sourceComponent !== 'string') {
	    // don't hoist over string (html) components
	
	    var inheritedComponent = getPrototypeOf(sourceComponent);
	
	    if (inheritedComponent && inheritedComponent !== objectPrototype) {
	      hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	    }
	
	    var keys = arrayPrototype.concat(getOwnPropertyNames(sourceComponent),
	    // $FlowFixMe
	    getOwnPropertySymbols(sourceComponent));
	
	    var targetStatics = TYPE_STATICS[targetComponent.$$typeof] || REACT_STATICS;
	
	    var sourceStatics = TYPE_STATICS[sourceComponent.$$typeof] || REACT_STATICS;
	
	    var i = keys.length;
	    var descriptor = void 0;
	    var key = void 0;
	
	    // eslint-disable-next-line no-plusplus
	    while (i--) {
	      key = keys[i];
	
	      if (
	      // $FlowFixMe
	      !KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) &&
	      // $FlowFixMe
	      !(targetStatics && targetStatics[key])) {
	        descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	
	        if (descriptor) {
	          try {
	            // Avoid failures from read-only properties
	            defineProperty$1(targetComponent, key, descriptor);
	          } catch (e) {
	            /* fail silently */
	          }
	        }
	      }
	    }
	
	    return targetComponent;
	  }
	
	  return targetComponent;
	}
	
	// 
	function isDerivedReactComponent(fn) {
	  return !!(fn && fn.prototype && fn.prototype.isReactComponent);
	}
	
	// 
	// Helper to call a given function, only once
	var once = (function (cb) {
	  var called = false;
	
	  return function () {
	    if (!called) {
	      called = true;
	      cb.apply(undefined, arguments);
	    }
	  };
	});
	
	// 
	
	var ThemeContext = React.createContext();
	
	var ThemeConsumer = ThemeContext.Consumer;
	
	/**
	 * Provide a theme to an entire react component tree via context
	 */
	
	var ThemeProvider = function (_Component) {
	  inherits(ThemeProvider, _Component);
	
	  function ThemeProvider(props) {
	    classCallCheck(this, ThemeProvider);
	
	    var _this = possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.getContext = memoize(_this.getContext.bind(_this));
	    _this.renderInner = _this.renderInner.bind(_this);
	    return _this;
	  }
	
	  ThemeProvider.prototype.render = function render() {
	    if (!this.props.children) return null;
	
	    return React__default.createElement(
	      ThemeContext.Consumer,
	      null,
	      this.renderInner
	    );
	  };
	
	  ThemeProvider.prototype.renderInner = function renderInner(outerTheme) {
	    var context = this.getContext(this.props.theme, outerTheme);
	
	    return React__default.createElement(
	      ThemeContext.Provider,
	      { value: context },
	      this.props.children
	    );
	  };
	
	  /**
	   * Get the theme from the props, supporting both (outerTheme) => {}
	   * as well as object notation
	   */
	
	
	  ThemeProvider.prototype.getTheme = function getTheme(theme, outerTheme) {
	    if (isFunction(theme)) {
	      var mergedTheme = theme(outerTheme);
	
	      if (false) {
	        throw new StyledComponentsError(7);
	      }
	
	      return mergedTheme;
	    }
	
	    if (theme === null || Array.isArray(theme) || (typeof theme === 'undefined' ? 'undefined' : _typeof(theme)) !== 'object') {
	      throw new StyledComponentsError(8);
	    }
	
	    return _extends({}, outerTheme, theme);
	  };
	
	  ThemeProvider.prototype.getContext = function getContext(theme, outerTheme) {
	    return this.getTheme(theme, outerTheme);
	  };
	
	  return ThemeProvider;
	}(React.Component);
	
	// 
	
	var CLOSING_TAG_R = /^\s*<\/[a-z]/i;
	
	var ServerStyleSheet = function () {
	  function ServerStyleSheet() {
	    classCallCheck(this, ServerStyleSheet);
	
	    /* The master sheet might be reset, so keep a reference here */
	    this.masterSheet = StyleSheet.master;
	    this.instance = this.masterSheet.clone();
	    this.sealed = false;
	  }
	
	  /**
	   * Mark the ServerStyleSheet as being fully emitted and manually GC it from the
	   * StyleSheet singleton.
	   */
	
	
	  ServerStyleSheet.prototype.seal = function seal() {
	    if (!this.sealed) {
	      /* Remove sealed StyleSheets from the master sheet */
	      var index = this.masterSheet.clones.indexOf(this.instance);
	      this.masterSheet.clones.splice(index, 1);
	      this.sealed = true;
	    }
	  };
	
	  ServerStyleSheet.prototype.collectStyles = function collectStyles(children) {
	    if (this.sealed) {
	      throw new StyledComponentsError(2);
	    }
	
	    return React__default.createElement(
	      StyleSheetManager,
	      { sheet: this.instance },
	      children
	    );
	  };
	
	  ServerStyleSheet.prototype.getStyleTags = function getStyleTags() {
	    this.seal();
	    return this.instance.toHTML();
	  };
	
	  ServerStyleSheet.prototype.getStyleElement = function getStyleElement() {
	    this.seal();
	    return this.instance.toReactElements();
	  };
	
	  ServerStyleSheet.prototype.interleaveWithNodeStream = function interleaveWithNodeStream(readableStream) {
	    var _this = this;
	
	    {
	      throw new StyledComponentsError(3);
	    }
	
	    /* the tag index keeps track of which tags have already been emitted */
	    var instance = this.instance;
	
	    var instanceTagIndex = 0;
	
	    var streamAttr = SC_STREAM_ATTR + '="true"';
	
	    var transformer = new stream.Transform({
	      transform: function appendStyleChunks(chunk, /* encoding */_, callback) {
	        var tags = instance.tags;
	
	        var html = '';
	
	        /* retrieve html for each new style tag */
	        for (; instanceTagIndex < tags.length; instanceTagIndex += 1) {
	          var tag = tags[instanceTagIndex];
	          html += tag.toHTML(streamAttr);
	        }
	
	        /* force our StyleSheets to emit entirely new tags */
	        instance.sealAllTags();
	
	        var renderedHtml = chunk.toString();
	
	        /* prepend style html to chunk, unless the start of the chunk is a closing tag in which case append right after that */
	        if (CLOSING_TAG_R.test(renderedHtml)) {
	          var endOfClosingTag = renderedHtml.indexOf('>');
	
	          this.push(renderedHtml.slice(0, endOfClosingTag + 1) + html + renderedHtml.slice(endOfClosingTag + 1));
	        } else this.push(html + renderedHtml);
	
	        callback();
	      }
	    });
	
	    readableStream.on('end', function () {
	      return _this.seal();
	    });
	
	    readableStream.on('error', function (err) {
	      _this.seal();
	
	      // forward the error to the transform stream
	      transformer.emit('error', err);
	    });
	
	    return readableStream.pipe(transformer);
	  };
	
	  return ServerStyleSheet;
	}();
	
	// 
	
	var StyleSheetContext = React.createContext();
	var StyleSheetConsumer = StyleSheetContext.Consumer;
	
	var StyleSheetManager = function (_Component) {
	  inherits(StyleSheetManager, _Component);
	
	  function StyleSheetManager(props) {
	    classCallCheck(this, StyleSheetManager);
	
	    var _this = possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.getContext = memoize(_this.getContext);
	    return _this;
	  }
	
	  StyleSheetManager.prototype.getContext = function getContext(sheet, target) {
	    if (sheet) {
	      return sheet;
	    } else if (target) {
	      return new StyleSheet(target);
	    } else {
	      throw new StyledComponentsError(4);
	    }
	  };
	
	  StyleSheetManager.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        sheet = _props.sheet,
	        target = _props.target;
	
	
	    return React__default.createElement(
	      StyleSheetContext.Provider,
	      { value: this.getContext(sheet, target) },
	       false ? React__default.Children.only(children) : children
	    );
	  };
	
	  return StyleSheetManager;
	}(React.Component);
	 false ? StyleSheetManager.propTypes = {
	  sheet: PropTypes.oneOfType([PropTypes.instanceOf(StyleSheet), PropTypes.instanceOf(ServerStyleSheet)]),
	
	  target: PropTypes.shape({
	    appendChild: PropTypes.func.isRequired
	  })
	} : void 0;
	
	// 
	
	var THEME_PROP_REGEX = /\.theme[.[]/;
	var identifiers = {};
	
	/* We depend on components having unique IDs */
	function generateId(_ComponentStyle, _displayName, parentComponentId) {
	  var displayName = typeof _displayName !== 'string' ? 'sc' : escape(_displayName);
	
	  /**
	   * This ensures uniqueness if two components happen to share
	   * the same displayName.
	   */
	  var nr = (identifiers[displayName] || 0) + 1;
	  identifiers[displayName] = nr;
	
	  var componentId = displayName + '-' + _ComponentStyle.generateName(displayName + nr);
	
	  return parentComponentId ? parentComponentId + '-' + componentId : componentId;
	}
	
	// $FlowFixMe
	
	var StyledComponent = function (_Component) {
	  inherits(StyledComponent, _Component);
	
	  function StyledComponent() {
	    classCallCheck(this, StyledComponent);
	
	    var _this = possibleConstructorReturn(this, _Component.call(this));
	
	    _this.attrs = {};
	
	    _this.renderOuter = _this.renderOuter.bind(_this);
	    _this.renderInner = _this.renderInner.bind(_this);
	
	    if (false) {
	      _this.warnInnerRef = once(function (displayName) {
	        return (
	          // eslint-disable-next-line no-console
	          console.warn('The "innerRef" API has been removed in styled-components v4 in favor of React 16 ref forwarding, use "ref" instead like a typical component. "innerRef" was detected on component "' + displayName + '".')
	        );
	      });
	
	      _this.warnAttrsFnObjectKeyDeprecated = once(function (key, displayName) {
	        return (
	          // eslint-disable-next-line no-console
	          console.warn('Functions as object-form attrs({}) keys are now deprecated and will be removed in a future version of styled-components. Switch to the new attrs(props => ({})) syntax instead for easier and more powerful composition. The attrs key in question is "' + key + '" on component "' + displayName + '".', '\n ' + new Error().stack)
	        );
	      });
	
	      _this.warnNonStyledComponentAttrsObjectKey = once(function (key, displayName) {
	        return (
	          // eslint-disable-next-line no-console
	          console.warn('It looks like you\'ve used a non styled-component as the value for the "' + key + '" prop in an object-form attrs constructor of "' + displayName + '".\n' + 'You should use the new function-form attrs constructor which avoids this issue: attrs(props => ({ yourStuff }))\n' + "To continue using the deprecated object syntax, you'll need to wrap your component prop in a function to make it available inside the styled component (you'll still get the deprecation warning though.)\n" + ('For example, { ' + key + ': () => InnerComponent } instead of { ' + key + ': InnerComponent }'))
	        );
	      });
	    }
	    return _this;
	  }
	
	  StyledComponent.prototype.render = function render() {
	    return React__default.createElement(
	      StyleSheetConsumer,
	      null,
	      this.renderOuter
	    );
	  };
	
	  StyledComponent.prototype.renderOuter = function renderOuter() {
	    var styleSheet = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : StyleSheet.master;
	
	    this.styleSheet = styleSheet;
	
	    // No need to subscribe a static component to theme changes, it won't change anything
	    if (this.props.forwardedComponent.componentStyle.isStatic) return this.renderInner();
	
	    return React__default.createElement(
	      ThemeConsumer,
	      null,
	      this.renderInner
	    );
	  };
	
	  StyledComponent.prototype.renderInner = function renderInner(theme) {
	    var _props$forwardedCompo = this.props.forwardedComponent,
	        componentStyle = _props$forwardedCompo.componentStyle,
	        defaultProps = _props$forwardedCompo.defaultProps,
	        displayName = _props$forwardedCompo.displayName,
	        foldedComponentIds = _props$forwardedCompo.foldedComponentIds,
	        styledComponentId = _props$forwardedCompo.styledComponentId,
	        target = _props$forwardedCompo.target,
	        usesTheme = _props$forwardedCompo.usesTheme;
	
	
	    var generatedClassName = void 0;
	    var rawTheme = void 0;
	
	    if (componentStyle.isStatic) {
	      generatedClassName = this.generateAndInjectStyles(EMPTY_OBJECT, this.props);
	    } else {
	      rawTheme = determineTheme(this.props, theme, defaultProps);
	      generatedClassName = this.generateAndInjectStyles(rawTheme || EMPTY_OBJECT, this.props);
	
	      if (false) {
	        console.error('Component \'' +
	        // $FlowFixMe
	        displayName + '\' (.' + styledComponentId + ') references the \'theme\' prop in its styles but no theme was provided via prop or <ThemeProvider>.');
	      }
	    }
	
	    var elementToBeCreated = this.props.as || this.attrs.as || target;
	    var isTargetTag = isTag(elementToBeCreated);
	
	    var propsForElement = {};
	    var computedProps = _extends({}, this.props, this.attrs);
	
	    var key = void 0;
	    // eslint-disable-next-line guard-for-in
	    for (key in computedProps) {
	      if (false) {
	        this.warnInnerRef(displayName);
	      }
	
	      if (key === 'forwardedComponent' || key === 'as') {
	        continue;
	      } else if (key === 'forwardedRef') propsForElement.ref = computedProps[key];else if (key === 'forwardedAs') propsForElement.as = computedProps[key];else if (!isTargetTag || validAttr(key)) {
	        // Don't pass through non HTML tags through to HTML elements
	        propsForElement[key] = computedProps[key];
	      }
	    }
	
	    if (this.props.style && this.attrs.style) {
	      propsForElement.style = _extends({}, this.attrs.style, this.props.style);
	    }
	
	    propsForElement.className = Array.prototype.concat(foldedComponentIds, styledComponentId, generatedClassName !== styledComponentId ? generatedClassName : null, this.props.className, this.attrs.className).filter(Boolean).join(' ');
	
	    return React.createElement(elementToBeCreated, propsForElement);
	  };
	
	  StyledComponent.prototype.buildExecutionContext = function buildExecutionContext(theme, props, attrs) {
	    var _this2 = this;
	
	    var context = _extends({}, props, { theme: theme });
	
	    if (!attrs.length) return context;
	
	    this.attrs = {};
	
	    attrs.forEach(function (attrDef) {
	      var resolvedAttrDef = attrDef;
	      var attrDefWasFn = false;
	      var attr = void 0;
	      var key = void 0;
	
	      if (isFunction(resolvedAttrDef)) {
	        // $FlowFixMe
	        resolvedAttrDef = resolvedAttrDef(context);
	        attrDefWasFn = true;
	      }
	
	      /* eslint-disable guard-for-in */
	      // $FlowFixMe
	      for (key in resolvedAttrDef) {
	        attr = resolvedAttrDef[key];
	
	        if (!attrDefWasFn) {
	          if (isFunction(attr) && !isDerivedReactComponent(attr) && !isStyledComponent(attr)) {
	            if (false) {
	              _this2.warnAttrsFnObjectKeyDeprecated(key, props.forwardedComponent.displayName);
	            }
	
	            attr = attr(context);
	
	            if (false) {
	              _this2.warnNonStyledComponentAttrsObjectKey(key, props.forwardedComponent.displayName);
	            }
	          }
	        }
	
	        _this2.attrs[key] = attr;
	        context[key] = attr;
	      }
	      /* eslint-enable */
	    });
	
	    return context;
	  };
	
	  StyledComponent.prototype.generateAndInjectStyles = function generateAndInjectStyles(theme, props) {
	    var _props$forwardedCompo2 = props.forwardedComponent,
	        attrs = _props$forwardedCompo2.attrs,
	        componentStyle = _props$forwardedCompo2.componentStyle,
	        warnTooManyClasses = _props$forwardedCompo2.warnTooManyClasses;
	
	    // statically styled-components don't need to build an execution context object,
	    // and shouldn't be increasing the number of class names
	
	    if (componentStyle.isStatic && !attrs.length) {
	      return componentStyle.generateAndInjectStyles(EMPTY_OBJECT, this.styleSheet);
	    }
	
	    var className = componentStyle.generateAndInjectStyles(this.buildExecutionContext(theme, props, attrs), this.styleSheet);
	
	    if (false) warnTooManyClasses(className);
	
	    return className;
	  };
	
	  return StyledComponent;
	}(React.Component);
	
	function createStyledComponent(target, options, rules) {
	  var isTargetStyledComp = isStyledComponent(target);
	  var isClass = !isTag(target);
	
	  var _options$displayName = options.displayName,
	      displayName = _options$displayName === undefined ? generateDisplayName(target) : _options$displayName,
	      _options$componentId = options.componentId,
	      componentId = _options$componentId === undefined ? generateId(ComponentStyle, options.displayName, options.parentComponentId) : _options$componentId,
	      _options$ParentCompon = options.ParentComponent,
	      ParentComponent = _options$ParentCompon === undefined ? StyledComponent : _options$ParentCompon,
	      _options$attrs = options.attrs,
	      attrs = _options$attrs === undefined ? EMPTY_ARRAY : _options$attrs;
	
	
	  var styledComponentId = options.displayName && options.componentId ? escape(options.displayName) + '-' + options.componentId : options.componentId || componentId;
	
	  // fold the underlying StyledComponent attrs up (implicit extend)
	  var finalAttrs =
	  // $FlowFixMe
	  isTargetStyledComp && target.attrs ? Array.prototype.concat(target.attrs, attrs).filter(Boolean) : attrs;
	
	  var componentStyle = new ComponentStyle(isTargetStyledComp ? // fold the underlying StyledComponent rules up (implicit extend)
	  // $FlowFixMe
	  target.componentStyle.rules.concat(rules) : rules, finalAttrs, styledComponentId);
	
	  /**
	   * forwardRef creates a new interim component, which we'll take advantage of
	   * instead of extending ParentComponent to create _another_ interim class
	   */
	  var WrappedStyledComponent = void 0;
	  var forwardRef = function forwardRef(props, ref) {
	    return React__default.createElement(ParentComponent, _extends({}, props, { forwardedComponent: WrappedStyledComponent, forwardedRef: ref }));
	  };
	  forwardRef.displayName = displayName;
	  WrappedStyledComponent = React__default.forwardRef(forwardRef);
	  WrappedStyledComponent.displayName = displayName;
	
	  // $FlowFixMe
	  WrappedStyledComponent.attrs = finalAttrs;
	  // $FlowFixMe
	  WrappedStyledComponent.componentStyle = componentStyle;
	
	  // $FlowFixMe
	  WrappedStyledComponent.foldedComponentIds = isTargetStyledComp ? // $FlowFixMe
	  Array.prototype.concat(target.foldedComponentIds, target.styledComponentId) : EMPTY_ARRAY;
	
	  // $FlowFixMe
	  WrappedStyledComponent.styledComponentId = styledComponentId;
	
	  // fold the underlying StyledComponent target up since we folded the styles
	  // $FlowFixMe
	  WrappedStyledComponent.target = isTargetStyledComp ? target.target : target;
	
	  // $FlowFixMe
	  WrappedStyledComponent.withComponent = function withComponent(tag) {
	    var previousComponentId = options.componentId,
	        optionsToCopy = objectWithoutProperties(options, ['componentId']);
	
	
	    var newComponentId = previousComponentId && previousComponentId + '-' + (isTag(tag) ? tag : escape(getComponentName(tag)));
	
	    var newOptions = _extends({}, optionsToCopy, {
	      attrs: finalAttrs,
	      componentId: newComponentId,
	      ParentComponent: ParentComponent
	    });
	
	    return createStyledComponent(tag, newOptions, rules);
	  };
	
	  // $FlowFixMe
	  Object.defineProperty(WrappedStyledComponent, 'defaultProps', {
	    get: function get$$1() {
	      return this._foldedDefaultProps;
	    },
	    set: function set$$1(obj) {
	      // $FlowFixMe
	      this._foldedDefaultProps = isTargetStyledComp ? merge(target.defaultProps, obj) : obj;
	    }
	  });
	
	  if (false) {
	    // $FlowFixMe
	    WrappedStyledComponent.usesTheme = componentStyle.rules.some(function (x) {
	      return isFunction(x) && THEME_PROP_REGEX.test(x.toString());
	    });
	
	    // $FlowFixMe
	    WrappedStyledComponent.warnTooManyClasses = createWarnTooManyClasses(displayName);
	  }
	
	  // $FlowFixMe
	  WrappedStyledComponent.toString = function () {
	    return '.' + WrappedStyledComponent.styledComponentId;
	  };
	
	  if (isClass) {
	    hoistNonReactStatics(WrappedStyledComponent, target, {
	      // all SC-specific things should not be hoisted
	      attrs: true,
	      componentStyle: true,
	      displayName: true,
	      foldedComponentIds: true,
	      styledComponentId: true,
	      target: true,
	      withComponent: true
	    });
	  }
	
	  return WrappedStyledComponent;
	}
	
	// 
	// Thanks to ReactDOMFactories for this handy list!
	
	var domElements = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr',
	
	// SVG
	'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'marker', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];
	
	// 
	
	var styled = function styled(tag) {
	  return constructWithOptions(createStyledComponent, tag);
	};
	
	// Shorthands for all valid HTML Elements
	domElements.forEach(function (domElement) {
	  styled[domElement] = styled(domElement);
	});
	
	// 
	
	var GlobalStyle = function () {
	  function GlobalStyle(rules, componentId) {
	    classCallCheck(this, GlobalStyle);
	
	    this.rules = rules;
	    this.componentId = componentId;
	    this.isStatic = isStaticRules(rules, EMPTY_ARRAY);
	
	    if (!StyleSheet.master.hasId(componentId)) {
	      StyleSheet.master.deferredInject(componentId, []);
	    }
	  }
	
	  GlobalStyle.prototype.createStyles = function createStyles(executionContext, styleSheet) {
	    var flatCSS = flatten(this.rules, executionContext, styleSheet);
	    var css = stringifyRules(flatCSS, '');
	
	    styleSheet.inject(this.componentId, css);
	  };
	
	  GlobalStyle.prototype.removeStyles = function removeStyles(styleSheet) {
	    var componentId = this.componentId;
	
	    if (styleSheet.hasId(componentId)) {
	      styleSheet.remove(componentId);
	    }
	  };
	
	  // TODO: overwrite in-place instead of remove+create?
	
	
	  GlobalStyle.prototype.renderStyles = function renderStyles(executionContext, styleSheet) {
	    this.removeStyles(styleSheet);
	    this.createStyles(executionContext, styleSheet);
	  };
	
	  return GlobalStyle;
	}();
	
	// 
	
	// place our cache into shared context so it'll persist between HMRs
	if (IS_BROWSER) {
	  window.scCGSHMRCache = {};
	}
	
	function createGlobalStyle(strings) {
	  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    interpolations[_key - 1] = arguments[_key];
	  }
	
	  var rules = css.apply(undefined, [strings].concat(interpolations));
	  var id = 'sc-global-' + murmurhash(JSON.stringify(rules));
	  var style = new GlobalStyle(rules, id);
	
	  var GlobalStyleComponent = function (_React$Component) {
	    inherits(GlobalStyleComponent, _React$Component);
	
	    function GlobalStyleComponent(props) {
	      classCallCheck(this, GlobalStyleComponent);
	
	      var _this = possibleConstructorReturn(this, _React$Component.call(this, props));
	
	      var _this$constructor = _this.constructor,
	          globalStyle = _this$constructor.globalStyle,
	          styledComponentId = _this$constructor.styledComponentId;
	
	
	      if (IS_BROWSER) {
	        window.scCGSHMRCache[styledComponentId] = (window.scCGSHMRCache[styledComponentId] || 0) + 1;
	      }
	
	      /**
	       * This fixes HMR compatibility. Don't ask me why, but this combination of
	       * caching the closure variables via statics and then persisting the statics in
	       * state works across HMR where no other combination did. ¯\_(ツ)_/¯
	       */
	      _this.state = {
	        globalStyle: globalStyle,
	        styledComponentId: styledComponentId
	      };
	      return _this;
	    }
	
	    GlobalStyleComponent.prototype.componentWillUnmount = function componentWillUnmount() {
	      if (window.scCGSHMRCache[this.state.styledComponentId]) {
	        window.scCGSHMRCache[this.state.styledComponentId] -= 1;
	      }
	      /**
	       * Depending on the order "render" is called this can cause the styles to be lost
	       * until the next render pass of the remaining instance, which may
	       * not be immediate.
	       */
	      if (window.scCGSHMRCache[this.state.styledComponentId] === 0) {
	        this.state.globalStyle.removeStyles(this.styleSheet);
	      }
	    };
	
	    GlobalStyleComponent.prototype.render = function render() {
	      var _this2 = this;
	
	      if (false) {
	        // eslint-disable-next-line no-console
	        console.warn('The global style component ' + this.state.styledComponentId + ' was given child JSX. createGlobalStyle does not render children.');
	      }
	
	      return React__default.createElement(
	        StyleSheetConsumer,
	        null,
	        function (styleSheet) {
	          _this2.styleSheet = styleSheet || StyleSheet.master;
	
	          var globalStyle = _this2.state.globalStyle;
	
	
	          if (globalStyle.isStatic) {
	            globalStyle.renderStyles(STATIC_EXECUTION_CONTEXT, _this2.styleSheet);
	
	            return null;
	          } else {
	            return React__default.createElement(
	              ThemeConsumer,
	              null,
	              function (theme) {
	                // $FlowFixMe
	                var defaultProps = _this2.constructor.defaultProps;
	
	
	                var context = _extends({}, _this2.props);
	
	                if (typeof theme !== 'undefined') {
	                  context.theme = determineTheme(_this2.props, theme, defaultProps);
	                }
	
	                globalStyle.renderStyles(context, _this2.styleSheet);
	
	                return null;
	              }
	            );
	          }
	        }
	      );
	    };
	
	    return GlobalStyleComponent;
	  }(React__default.Component);
	
	  GlobalStyleComponent.globalStyle = style;
	  GlobalStyleComponent.styledComponentId = id;
	
	
	  return GlobalStyleComponent;
	}
	
	// 
	
	var replaceWhitespace = function replaceWhitespace(str) {
	  return str.replace(/\s|\\n/g, '');
	};
	
	function keyframes(strings) {
	  /* Warning if you've used keyframes on React Native */
	  if (false) {
	    // eslint-disable-next-line no-console
	    console.warn('`keyframes` cannot be used on ReactNative, only on the web. To do animation in ReactNative please use Animated.');
	  }
	
	  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    interpolations[_key - 1] = arguments[_key];
	  }
	
	  var rules = css.apply(undefined, [strings].concat(interpolations));
	
	  var name = generateAlphabeticName(murmurhash(replaceWhitespace(JSON.stringify(rules))));
	
	  return new Keyframes(name, stringifyRules(rules, name, '@keyframes'));
	}
	
	// 
	
	var withTheme = (function (Component) {
	  var WithTheme = React__default.forwardRef(function (props, ref) {
	    return React__default.createElement(
	      ThemeConsumer,
	      null,
	      function (theme) {
	        // $FlowFixMe
	        var defaultProps = Component.defaultProps;
	
	        var themeProp = determineTheme(props, theme, defaultProps);
	
	        if (false) {
	          // eslint-disable-next-line no-console
	          console.warn('[withTheme] You are not using a ThemeProvider nor passing a theme prop or a theme in defaultProps in component class "' + getComponentName(Component) + '"');
	        }
	
	        return React__default.createElement(Component, _extends({}, props, { theme: themeProp, ref: ref }));
	      }
	    );
	  });
	
	  hoistNonReactStatics(WithTheme, Component);
	
	  WithTheme.displayName = 'WithTheme(' + getComponentName(Component) + ')';
	
	  return WithTheme;
	});
	
	// 
	
	/* eslint-disable */
	var __DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS = {
	  StyleSheet: StyleSheet
	};
	
	// 
	
	/* Warning if you've imported this file on React Native */
	if (false) {
	  // eslint-disable-next-line no-console
	  console.warn("It looks like you've imported 'styled-components' on React Native.\n" + "Perhaps you're looking to import 'styled-components/native'?\n" + 'Read more about this at https://www.styled-components.com/docs/basics#react-native');
	}
	
	/* Warning if there are several instances of styled-components */
	if (false) {
	  window['__styled-components-init__'] = window['__styled-components-init__'] || 0;
	
	  if (window['__styled-components-init__'] === 1) {
	    // eslint-disable-next-line no-console
	    console.warn("It looks like there are several instances of 'styled-components' initialized in this application. " + 'This may cause dynamic styles not rendering properly, errors happening during rehydration process ' + 'and makes your application bigger without a good reason.\n\n' + 'See https://s-c.sh/2BAXzed for more info.');
	  }
	
	  window['__styled-components-init__'] += 1;
	}
	
	//
	
	exports.default = styled;
	exports.createGlobalStyle = createGlobalStyle;
	exports.css = css;
	exports.isStyledComponent = isStyledComponent;
	exports.keyframes = keyframes;
	exports.ServerStyleSheet = ServerStyleSheet;
	exports.StyleSheetConsumer = StyleSheetConsumer;
	exports.StyleSheetContext = StyleSheetContext;
	exports.StyleSheetManager = StyleSheetManager;
	exports.ThemeConsumer = ThemeConsumer;
	exports.ThemeContext = ThemeContext;
	exports.ThemeProvider = ThemeProvider;
	exports.withTheme = withTheme;
	exports.__DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS = __DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS;
	//# sourceMappingURL=styled-components.browser.cjs.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(45)))

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactackleApp = __webpack_require__(539);
	
	Object.keys(_reactackleApp).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _reactackleApp[key];
	    }
	  });
	});
	
	var _reactackleAutoposition = __webpack_require__(65);
	
	Object.keys(_reactackleAutoposition).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _reactackleAutoposition[key];
	    }
	  });
	});
	
	var _reactackleButton = __webpack_require__(94);
	
	Object.keys(_reactackleButton).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _reactackleButton[key];
	    }
	  });
	});
	
	var _reactackleCard = __webpack_require__(608);
	
	Object.keys(_reactackleCard).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _reactackleCard[key];
	    }
	  });
	});
	
	var _reactackleCheckbox = __webpack_require__(613);
	
	Object.keys(_reactackleCheckbox).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _reactackleCheckbox[key];
	    }
	  });
	});
	
	var _reactackleCore = __webpack_require__(3);
	
	Object.keys(_reactackleCore).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _reactackleCore[key];
	    }
	  });
	});
	
	var _reactackleDialog = __webpack_require__(663);
	
	Object.keys(_reactackleDialog).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _reactackleDialog[key];
	    }
	  });
	});
	
	var _reactackleForm = __webpack_require__(679);
	
	Object.keys(_reactackleForm).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _reactackleForm[key];
	    }
	  });
	});
	
	var _reactackleGrid = __webpack_require__(693);
	
	Object.keys(_reactackleGrid).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _reactackleGrid[key];
	    }
	  });
	});
	
	var _reactackleHeader = __webpack_require__(702);
	
	Object.keys(_reactackleHeader).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _reactackleHeader[key];
	    }
	  });
	});
	
	var _reactackleIcons = __webpack_require__(7);
	
	Object.keys(_reactackleIcons).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _reactackleIcons[key];
	    }
	  });
	});
	
	var _reactackleInputAutocomplete = __webpack_require__(726);
	
	Object.keys(_reactackleInputAutocomplete).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _reactackleInputAutocomplete[key];
	    }
	  });
	});
	
	var _reactackleRadioGroup = __webpack_require__(779);
	
	Object.keys(_reactackleRadioGroup).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _reactackleRadioGroup[key];
	    }
	  });
	});
	
	var _reactackleSelectbox = __webpack_require__(796);
	
	Object.keys(_reactackleSelectbox).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _reactackleSelectbox[key];
	    }
	  });
	});
	
	var _reactackleSidebar = __webpack_require__(807);
	
	Object.keys(_reactackleSidebar).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _reactackleSidebar[key];
	    }
	  });
	});
	
	var _reactackleTabs = __webpack_require__(822);
	
	Object.keys(_reactackleTabs).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _reactackleTabs[key];
	    }
	  });
	});
	
	var _reactackleText = __webpack_require__(859);
	
	Object.keys(_reactackleText).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _reactackleText[key];
	    }
	  });
	});
	
	var _reactackleTextField = __webpack_require__(232);
	
	Object.keys(_reactackleTextField).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _reactackleTextField[key];
	    }
	  });
	});
	
	var _reactackleToggleButton = __webpack_require__(864);
	
	Object.keys(_reactackleToggleButton).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _reactackleToggleButton[key];
	    }
	  });
	});
	
	var _reactackleTooltip = __webpack_require__(66);
	
	Object.keys(_reactackleTooltip).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _reactackleTooltip[key];
	    }
	  });
	});
	
	var _reactackleTooltipIcon = __webpack_require__(52);
	
	Object.keys(_reactackleTooltipIcon).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _reactackleTooltipIcon[key];
	    }
	  });
	});
	
	var _reactackleProgress = __webpack_require__(773);
	
	Object.keys(_reactackleProgress).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _reactackleProgress[key];
	    }
	  });
	});
	
	var _reactackleBreadcrumbs = __webpack_require__(555);
	
	Object.keys(_reactackleBreadcrumbs).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _reactackleBreadcrumbs[key];
	    }
	  });
	});
	
	var _reactackleTag = __webpack_require__(828);
	
	Object.keys(_reactackleTag).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _reactackleTag[key];
	    }
	  });
	});
	
	var _reactackleAccordion = __webpack_require__(511);
	
	Object.keys(_reactackleAccordion).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _reactackleAccordion[key];
	    }
	  });
	});
	
	var _reactackleAlertArea = __webpack_require__(521);
	
	Object.keys(_reactackleAlertArea).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _reactackleAlertArea[key];
	    }
	  });
	});
	
	var _reactackleMenu = __webpack_require__(754);
	
	Object.keys(_reactackleMenu).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _reactackleMenu[key];
	    }
	  });
	});

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(2);
	var React__default = _interopDefault(React);
	
	var UAParser = __webpack_require__(918);
	
	var UA = new UAParser();
	var browser = UA.getBrowser();
	var cpu = UA.getCPU();
	var device = UA.getDevice();
	var engine = UA.getEngine();
	var os = UA.getOS();
	var ua = UA.getUA();
	
	var setDefaults = function setDefaults(p) {
	  var d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'none';
	  return p ? p : d;
	};
	var getNavigatorInstance = function getNavigatorInstance() {
	  if (typeof window !== 'undefined') {
	    if (window.navigator || navigator) {
	      return window.navigator || navigator;
	    }
	  }
	
	  return false;
	};
	var isIOS13Check = function isIOS13Check(type) {
	  var nav = getNavigatorInstance();
	  return nav && (nav.platform.includes(type) || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1 && !window.MSStream);
	};
	
	function _typeof(obj) {
	  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
	    _typeof = function (obj) {
	      return typeof obj;
	    };
	  } else {
	    _typeof = function (obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	    };
	  }
	
	  return _typeof(obj);
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];
	    descriptor.enumerable = descriptor.enumerable || false;
	    descriptor.configurable = true;
	    if ("value" in descriptor) descriptor.writable = true;
	    Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	  if (staticProps) _defineProperties(Constructor, staticProps);
	  return Constructor;
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	}
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  return _extends.apply(this, arguments);
	}
	
	function ownKeys(object, enumerableOnly) {
	  var keys = Object.keys(object);
	
	  if (Object.getOwnPropertySymbols) {
	    var symbols = Object.getOwnPropertySymbols(object);
	    if (enumerableOnly) symbols = symbols.filter(function (sym) {
	      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
	    });
	    keys.push.apply(keys, symbols);
	  }
	
	  return keys;
	}
	
	function _objectSpread2(target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i] != null ? arguments[i] : {};
	
	    if (i % 2) {
	      ownKeys(source, true).forEach(function (key) {
	        _defineProperty(target, key, source[key]);
	      });
	    } else if (Object.getOwnPropertyDescriptors) {
	      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
	    } else {
	      ownKeys(source).forEach(function (key) {
	        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
	      });
	    }
	  }
	
	  return target;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };
	  return _getPrototypeOf(o);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;
	    return o;
	  };
	
	  return _setPrototypeOf(o, p);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return self;
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (typeof call === "object" || typeof call === "function")) {
	    return call;
	  }
	
	  return _assertThisInitialized(self);
	}
	
	var DEVICE_TYPES = {
	  MOBILE: 'mobile',
	  TABLET: 'tablet',
	  SMART_TV: 'smarttv',
	  CONSOLE: 'console',
	  WEARABLE: 'wearable',
	  BROWSER: undefined
	};
	var BROWSER_TYPES = {
	  CHROME: 'Chrome',
	  FIREFOX: "Firefox",
	  OPERA: "Opera",
	  YANDEX: "Yandex",
	  SAFARI: "Safari",
	  INTERNET_EXPLORER: "Internet Explorer",
	  EDGE: "Edge",
	  CHROMIUM: "Chromium",
	  IE: 'IE',
	  MOBILE_SAFARI: "Mobile Safari"
	};
	var OS_TYPES = {
	  IOS: 'iOS',
	  ANDROID: "Android",
	  WINDOWS_PHONE: "Windows Phone"
	};
	var initialData = {
	  isMobile: false,
	  isTablet: false,
	  isBrowser: false,
	  isSmartTV: false,
	  isConsole: false,
	  isWearable: false
	};
	var checkType = function checkType(type) {
	  switch (type) {
	    case DEVICE_TYPES.MOBILE:
	      return {
	        isMobile: true
	      };
	
	    case DEVICE_TYPES.TABLET:
	      return {
	        isTablet: true
	      };
	
	    case DEVICE_TYPES.SMART_TV:
	      return {
	        isSmartTV: true
	      };
	
	    case DEVICE_TYPES.CONSOLE:
	      return {
	        isConsole: true
	      };
	
	    case DEVICE_TYPES.WEARABLE:
	      return {
	        isWearable: true
	      };
	
	    case DEVICE_TYPES.BROWSER:
	      return {
	        isBrowser: true
	      };
	
	    default:
	      return initialData;
	  }
	};
	var broPayload = function broPayload(isBrowser, browser, engine, os, ua) {
	  return {
	    isBrowser: isBrowser,
	    browserMajorVersion: setDefaults(browser.major),
	    browserFullVersion: setDefaults(browser.version),
	    browserName: setDefaults(browser.name),
	    engineName: setDefaults(engine.name),
	    engineVersion: setDefaults(engine.version),
	    osName: setDefaults(os.name),
	    osVersion: setDefaults(os.version),
	    userAgent: setDefaults(ua)
	  };
	};
	var mobilePayload = function mobilePayload(type, device, os, ua) {
	  return _objectSpread2({}, type, {
	    vendor: setDefaults(device.vendor),
	    model: setDefaults(device.model),
	    os: setDefaults(os.name),
	    osVersion: setDefaults(os.version),
	    ua: setDefaults(ua)
	  });
	};
	var stvPayload = function stvPayload(isSmartTV, engine, os, ua) {
	  return {
	    isSmartTV: isSmartTV,
	    engineName: setDefaults(engine.name),
	    engineVersion: setDefaults(engine.version),
	    osName: setDefaults(os.name),
	    osVersion: setDefaults(os.version),
	    userAgent: setDefaults(ua)
	  };
	};
	var consolePayload = function consolePayload(isConsole, engine, os, ua) {
	  return {
	    isConsole: isConsole,
	    engineName: setDefaults(engine.name),
	    engineVersion: setDefaults(engine.version),
	    osName: setDefaults(os.name),
	    osVersion: setDefaults(os.version),
	    userAgent: setDefaults(ua)
	  };
	};
	var wearPayload = function wearPayload(isWearable, engine, os, ua) {
	  return {
	    isWearable: isWearable,
	    engineName: setDefaults(engine.name),
	    engineVersion: setDefaults(engine.version),
	    osName: setDefaults(os.name),
	    osVersion: setDefaults(os.version),
	    userAgent: setDefaults(ua)
	  };
	};
	
	var type = checkType(device.type);
	
	function deviceDetect() {
	  var isBrowser = type.isBrowser,
	      isMobile = type.isMobile,
	      isTablet = type.isTablet,
	      isSmartTV = type.isSmartTV,
	      isConsole = type.isConsole,
	      isWearable = type.isWearable;
	
	  if (isBrowser) {
	    return broPayload(isBrowser, browser, engine, os, ua);
	  }
	
	  if (isSmartTV) {
	    return stvPayload(isSmartTV, engine, os, ua);
	  }
	
	  if (isConsole) {
	    return consolePayload(isConsole, engine, os, ua);
	  }
	
	  if (isMobile) {
	    return mobilePayload(type, device, os, ua);
	  }
	
	  if (isTablet) {
	    return mobilePayload(type, device, os, ua);
	  }
	
	  if (isWearable) {
	    return wearPayload(isWearable, engine, os, ua);
	  }
	}
	
	var isMobileType = function isMobileType() {
	  return device.type === DEVICE_TYPES.MOBILE;
	};
	
	var isTabletType = function isTabletType() {
	  return device.type === DEVICE_TYPES.TABLET;
	};
	
	var isMobileAndTabletType = function isMobileAndTabletType() {
	  switch (device.type) {
	    case DEVICE_TYPES.MOBILE:
	    case DEVICE_TYPES.TABLET:
	      return true;
	
	    default:
	      return false;
	  }
	};
	
	var isSmartTVType = function isSmartTVType() {
	  return device.type === DEVICE_TYPES.SMART_TV;
	};
	
	var isBrowserType = function isBrowserType() {
	  return device.type === DEVICE_TYPES.BROWSER;
	};
	
	var isWearableType = function isWearableType() {
	  return device.type === DEVICE_TYPES.WEARABLE;
	};
	
	var isConsoleType = function isConsoleType() {
	  return device.type === DEVICE_TYPES.CONSOLE;
	};
	
	var isAndroidType = function isAndroidType() {
	  return os.name === OS_TYPES.ANDROID;
	};
	
	var isWinPhoneType = function isWinPhoneType() {
	  return os.name === OS_TYPES.WINDOWS_PHONE;
	};
	
	var isIOSType = function isIOSType() {
	  return os.name === OS_TYPES.IOS;
	};
	
	var isChromeType = function isChromeType() {
	  return browser.name === BROWSER_TYPES.CHROME;
	};
	
	var isFirefoxType = function isFirefoxType() {
	  return browser.name === BROWSER_TYPES.FIREFOX;
	};
	
	var isChromiumType = function isChromiumType() {
	  return browser.name === BROWSER_TYPES.CHROMIUM;
	};
	
	var isEdgeType = function isEdgeType() {
	  return browser.name === BROWSER_TYPES.EDGE;
	};
	
	var isYandexType = function isYandexType() {
	  return browser.name === BROWSER_TYPES.YANDEX;
	};
	
	var isSafariType = function isSafariType() {
	  return browser.name === BROWSER_TYPES.SAFARI || browser.name === BROWSER_TYPES.MOBILE_SAFARI;
	};
	
	var isMobileSafariType = function isMobileSafariType() {
	  return browser.name === BROWSER_TYPES.MOBILE_SAFARI;
	};
	
	var isOperaType = function isOperaType() {
	  return browser.name === BROWSER_TYPES.OPERA;
	};
	
	var isIEType = function isIEType() {
	  return browser.name === BROWSER_TYPES.INTERNET_EXPLORER || browser.name === BROWSER_TYPES.IE;
	};
	
	var isElectronType = function isElectronType() {
	  var nav = getNavigatorInstance();
	  var ua = nav && nav.userAgent.toLowerCase();
	  return typeof ua === 'string' ? ua.includes('electron') : false;
	};
	
	var getIOS13 = function getIOS13() {
	  var nav = getNavigatorInstance();
	  return nav && (/iPad|iPhone|iPod/.test(nav.platform) || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1) && !window.MSStream;
	};
	
	var getIPad13 = function getIPad13() {
	  return isIOS13Check('iPad');
	};
	
	var getIphone13 = function getIphone13() {
	  return isIOS13Check('iPhone');
	};
	
	var getIPod13 = function getIPod13() {
	  return isIOS13Check('iPod');
	};
	
	var getBrowserFullVersion = function getBrowserFullVersion() {
	  return setDefaults(browser.version);
	};
	
	var getBrowserVersion = function getBrowserVersion() {
	  return setDefaults(browser.major);
	};
	
	var getOsVersion = function getOsVersion() {
	  return setDefaults(os.version);
	};
	
	var getOsName = function getOsName() {
	  return setDefaults(os.name);
	};
	
	var getBrowserName = function getBrowserName() {
	  return setDefaults(browser.name);
	};
	
	var getMobileVendor = function getMobileVendor() {
	  return setDefaults(device.vendor);
	};
	
	var getMobileModel = function getMobileModel() {
	  return setDefaults(device.model);
	};
	
	var getEngineName = function getEngineName() {
	  return setDefaults(engine.name);
	};
	
	var getEngineVersion = function getEngineVersion() {
	  return setDefaults(engine.version);
	};
	
	var getUseragent = function getUseragent() {
	  return setDefaults(ua);
	};
	
	var getDeviceType = function getDeviceType() {
	  return setDefaults(device.type, 'browser');
	};
	
	var isSmartTV = isSmartTVType();
	var isConsole = isConsoleType();
	var isWearable = isWearableType();
	var isMobileSafari = isMobileSafariType();
	var isChromium = isChromiumType();
	var isMobile = isMobileAndTabletType();
	var isMobileOnly = isMobileType();
	var isTablet = isTabletType();
	var isBrowser = isBrowserType();
	var isAndroid = isAndroidType();
	var isWinPhone = isWinPhoneType();
	var isIOS = isIOSType();
	var isChrome = isChromeType();
	var isFirefox = isFirefoxType();
	var isSafari = isSafariType();
	var isOpera = isOperaType();
	var isIE = isIEType();
	var osVersion = getOsVersion();
	var osName = getOsName();
	var fullBrowserVersion = getBrowserFullVersion();
	var browserVersion = getBrowserVersion();
	var browserName = getBrowserName();
	var mobileVendor = getMobileVendor();
	var mobileModel = getMobileModel();
	var engineName = getEngineName();
	var engineVersion = getEngineVersion();
	var getUA = getUseragent();
	var isEdge = isEdgeType();
	var isYandex = isYandexType();
	var deviceType = getDeviceType();
	var isIOS13 = getIOS13();
	var isIPad13 = getIPad13();
	var isIPhone13 = getIphone13();
	var isIPod13 = getIPod13();
	var isElectron = isElectronType();
	
	var AndroidView = function AndroidView(_ref) {
	  var renderWithFragment = _ref.renderWithFragment,
	      children = _ref.children,
	      viewClassName = _ref.viewClassName,
	      style = _ref.style;
	  return isAndroid ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
	    className: viewClassName,
	    style: style
	  }, children) : null;
	};
	var BrowserView = function BrowserView(_ref2) {
	  var renderWithFragment = _ref2.renderWithFragment,
	      children = _ref2.children,
	      viewClassName = _ref2.viewClassName,
	      style = _ref2.style;
	  return isBrowser ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
	    className: viewClassName,
	    style: style
	  }, children) : null;
	};
	var IEView = function IEView(_ref3) {
	  var renderWithFragment = _ref3.renderWithFragment,
	      children = _ref3.children,
	      viewClassName = _ref3.viewClassName,
	      style = _ref3.style;
	  return isIE ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
	    className: viewClassName,
	    style: style
	  }, children) : null;
	};
	var IOSView = function IOSView(_ref4) {
	  var renderWithFragment = _ref4.renderWithFragment,
	      children = _ref4.children,
	      viewClassName = _ref4.viewClassName,
	      style = _ref4.style;
	  return isIOS ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
	    className: viewClassName,
	    style: style
	  }, children) : null;
	};
	var MobileView = function MobileView(_ref5) {
	  var renderWithFragment = _ref5.renderWithFragment,
	      children = _ref5.children,
	      viewClassName = _ref5.viewClassName,
	      style = _ref5.style;
	  return isMobile ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
	    className: viewClassName,
	    style: style
	  }, children) : null;
	};
	var TabletView = function TabletView(_ref6) {
	  var renderWithFragment = _ref6.renderWithFragment,
	      children = _ref6.children,
	      viewClassName = _ref6.viewClassName,
	      style = _ref6.style;
	  return isTablet ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
	    className: viewClassName,
	    style: style
	  }, children) : null;
	};
	var WinPhoneView = function WinPhoneView(_ref7) {
	  var renderWithFragment = _ref7.renderWithFragment,
	      children = _ref7.children,
	      viewClassName = _ref7.viewClassName,
	      style = _ref7.style;
	  return isWinPhone ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
	    className: viewClassName,
	    style: style
	  }, children) : null;
	};
	var MobileOnlyView = function MobileOnlyView(_ref8) {
	  var renderWithFragment = _ref8.renderWithFragment,
	      children = _ref8.children,
	      viewClassName = _ref8.viewClassName,
	      style = _ref8.style;
	  return isMobileOnly ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
	    className: viewClassName,
	    style: style
	  }, children) : null;
	};
	var SmartTVView = function SmartTVView(_ref9) {
	  var renderWithFragment = _ref9.renderWithFragment,
	      children = _ref9.children,
	      viewClassName = _ref9.viewClassName,
	      style = _ref9.style;
	  return isSmartTV ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
	    className: viewClassName,
	    style: style
	  }, children) : null;
	};
	var ConsoleView = function ConsoleView(_ref10) {
	  var renderWithFragment = _ref10.renderWithFragment,
	      children = _ref10.children,
	      viewClassName = _ref10.viewClassName,
	      style = _ref10.style;
	  return isConsole ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
	    className: viewClassName,
	    style: style
	  }, children) : null;
	};
	var WearableView = function WearableView(_ref11) {
	  var renderWithFragment = _ref11.renderWithFragment,
	      children = _ref11.children,
	      viewClassName = _ref11.viewClassName,
	      style = _ref11.style;
	  return isWearable ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
	    className: viewClassName,
	    style: style
	  }, children) : null;
	};
	var CustomView = function CustomView(_ref12) {
	  var renderWithFragment = _ref12.renderWithFragment,
	      children = _ref12.children,
	      viewClassName = _ref12.viewClassName,
	      style = _ref12.style,
	      condition = _ref12.condition;
	  return condition ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
	    className: viewClassName,
	    style: style
	  }, children) : null;
	};
	
	function withOrientationChange(WrappedComponent) {
	  return (
	    /*#__PURE__*/
	    function (_React$Component) {
	      _inherits(_class, _React$Component);
	
	      function _class(props) {
	        var _this;
	
	        _classCallCheck(this, _class);
	
	        _this = _possibleConstructorReturn(this, _getPrototypeOf(_class).call(this, props));
	        _this.isEventListenerAdded = false;
	        _this.handleOrientationChange = _this.handleOrientationChange.bind(_assertThisInitialized(_this));
	        _this.onOrientationChange = _this.onOrientationChange.bind(_assertThisInitialized(_this));
	        _this.onPageLoad = _this.onPageLoad.bind(_assertThisInitialized(_this));
	        _this.state = {
	          isLandscape: false,
	          isPortrait: false
	        };
	        return _this;
	      }
	
	      _createClass(_class, [{
	        key: "handleOrientationChange",
	        value: function handleOrientationChange() {
	          if (!this.isEventListenerAdded) {
	            this.isEventListenerAdded = true;
	          }
	
	          var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
	          this.setState({
	            isPortrait: orientation === 0,
	            isLandscape: orientation === 90
	          });
	        }
	      }, {
	        key: "onOrientationChange",
	        value: function onOrientationChange() {
	          this.handleOrientationChange();
	        }
	      }, {
	        key: "onPageLoad",
	        value: function onPageLoad() {
	          this.handleOrientationChange();
	        }
	      }, {
	        key: "componentDidMount",
	        value: function componentDidMount() {
	          if ((typeof window === "undefined" ? "undefined" : _typeof(window)) !== undefined && isMobile) {
	            if (!this.isEventListenerAdded) {
	              this.handleOrientationChange();
	              window.addEventListener("load", this.onPageLoad, false);
	            } else {
	              window.removeEventListener("load", this.onPageLoad, false);
	            }
	
	            window.addEventListener("resize", this.onOrientationChange, false);
	          }
	        }
	      }, {
	        key: "componentWillUnmount",
	        value: function componentWillUnmount() {
	          window.removeEventListener("resize", this.onOrientationChange, false);
	        }
	      }, {
	        key: "render",
	        value: function render() {
	          return React__default.createElement(WrappedComponent, _extends({}, this.props, {
	            isLandscape: this.state.isLandscape,
	            isPortrait: this.state.isPortrait
	          }));
	        }
	      }]);
	
	      return _class;
	    }(React__default.Component)
	  );
	}
	
	exports.AndroidView = AndroidView;
	exports.BrowserView = BrowserView;
	exports.ConsoleView = ConsoleView;
	exports.CustomView = CustomView;
	exports.IEView = IEView;
	exports.IOSView = IOSView;
	exports.MobileOnlyView = MobileOnlyView;
	exports.MobileView = MobileView;
	exports.SmartTVView = SmartTVView;
	exports.TabletView = TabletView;
	exports.WearableView = WearableView;
	exports.WinPhoneView = WinPhoneView;
	exports.browserName = browserName;
	exports.browserVersion = browserVersion;
	exports.deviceDetect = deviceDetect;
	exports.deviceType = deviceType;
	exports.engineName = engineName;
	exports.engineVersion = engineVersion;
	exports.fullBrowserVersion = fullBrowserVersion;
	exports.getUA = getUA;
	exports.isAndroid = isAndroid;
	exports.isBrowser = isBrowser;
	exports.isChrome = isChrome;
	exports.isChromium = isChromium;
	exports.isConsole = isConsole;
	exports.isEdge = isEdge;
	exports.isElectron = isElectron;
	exports.isFirefox = isFirefox;
	exports.isIE = isIE;
	exports.isIOS = isIOS;
	exports.isIOS13 = isIOS13;
	exports.isIPad13 = isIPad13;
	exports.isIPhone13 = isIPhone13;
	exports.isIPod13 = isIPod13;
	exports.isMobile = isMobile;
	exports.isMobileOnly = isMobileOnly;
	exports.isMobileSafari = isMobileSafari;
	exports.isOpera = isOpera;
	exports.isSafari = isSafari;
	exports.isSmartTV = isSmartTV;
	exports.isTablet = isTablet;
	exports.isWearable = isWearable;
	exports.isWinPhone = isWinPhone;
	exports.isYandex = isYandex;
	exports.mobileModel = mobileModel;
	exports.mobileVendor = mobileVendor;
	exports.osName = osName;
	exports.osVersion = osVersion;
	exports.withOrientationChange = withOrientationChange;


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _IconCustom = __webpack_require__(709);
	
	Object.keys(_IconCustom).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _IconCustom[key];
	    }
	  });
	});
	
	var _IconSvg = __webpack_require__(721);
	
	Object.keys(_IconSvg).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _IconSvg[key];
	    }
	  });
	});
	
	var _iconStyleMixin = __webpack_require__(723);
	
	Object.keys(_iconStyleMixin).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _iconStyleMixin[key];
	    }
	  });
	});
	
	var _iconsPropType = __webpack_require__(134);
	
	Object.keys(_iconsPropType).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _iconsPropType[key];
	    }
	  });
	});
	
	var _reactackleCore = __webpack_require__(3);
	
	var _theme = __webpack_require__(724);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _reactackleCore.registerDefaultComponentTheme)('icon', _theme2.default);

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	    var hookCallback;
	
	    function hooks () {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback (callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	    }
	
	    function isObject(input) {
	        // IE8 will treat undefined and null as object if it wasn't for
	        // input != null
	        return input != null && Object.prototype.toString.call(input) === '[object Object]';
	    }
	
	    function isObjectEmpty(obj) {
	        if (Object.getOwnPropertyNames) {
	            return (Object.getOwnPropertyNames(obj).length === 0);
	        } else {
	            var k;
	            for (k in obj) {
	                if (obj.hasOwnProperty(k)) {
	                    return false;
	                }
	            }
	            return true;
	        }
	    }
	
	    function isUndefined(input) {
	        return input === void 0;
	    }
	
	    function isNumber(input) {
	        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
	    }
	
	    function isDate(input) {
	        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	    }
	
	    function map(arr, fn) {
	        var res = [], i;
	        for (i = 0; i < arr.length; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function createUTC (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty           : false,
	            unusedTokens    : [],
	            unusedInput     : [],
	            overflow        : -2,
	            charsLeftOver   : 0,
	            nullInput       : false,
	            invalidMonth    : null,
	            invalidFormat   : false,
	            userInvalidated : false,
	            iso             : false,
	            parsedDateParts : [],
	            meridiem        : null,
	            rfc2822         : false,
	            weekdayMismatch : false
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this);
	            var len = t.length >>> 0;
	
	            for (var i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }
	
	            return false;
	        };
	    }
	
	    function isValid(m) {
	        if (m._isValid == null) {
	            var flags = getParsingFlags(m);
	            var parsedParts = some.call(flags.parsedDateParts, function (i) {
	                return i != null;
	            });
	            var isNowValid = !isNaN(m._d.getTime()) &&
	                flags.overflow < 0 &&
	                !flags.empty &&
	                !flags.invalidMonth &&
	                !flags.invalidWeekday &&
	                !flags.weekdayMismatch &&
	                !flags.nullInput &&
	                !flags.invalidFormat &&
	                !flags.userInvalidated &&
	                (!flags.meridiem || (flags.meridiem && parsedParts));
	
	            if (m._strict) {
	                isNowValid = isNowValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	
	            if (Object.isFrozen == null || !Object.isFrozen(m)) {
	                m._isValid = isNowValid;
	            }
	            else {
	                return isNowValid;
	            }
	        }
	        return m._isValid;
	    }
	
	    function createInvalid (flags) {
	        var m = createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        }
	        else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = hooks.momentProperties = [];
	
	    function copyConfig(to, from) {
	        var i, prop, val;
	
	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }
	
	        if (momentProperties.length > 0) {
	            for (i = 0; i < momentProperties.length; i++) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    var updateInProgress = false;
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        if (!this.isValid()) {
	            this._d = new Date(NaN);
	        }
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment (obj) {
	        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	    }
	
	    function absFloor (number) {
	        if (number < 0) {
	            // -0 -> 0
	            return Math.ceil(number) || 0;
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if ((dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    function warn(msg) {
	        if (hooks.suppressDeprecationWarnings === false &&
	                (typeof console !==  'undefined') && console.warn) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (hooks.deprecationHandler != null) {
	                hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                var args = [];
	                var arg;
	                for (var i = 0; i < arguments.length; i++) {
	                    arg = '';
	                    if (typeof arguments[i] === 'object') {
	                        arg += '\n[' + i + '] ';
	                        for (var key in arguments[0]) {
	                            arg += key + ': ' + arguments[0][key] + ', ';
	                        }
	                        arg = arg.slice(0, -2); // Remove trailing comma and space
	                    } else {
	                        arg = arguments[i];
	                    }
	                    args.push(arg);
	                }
	                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    hooks.suppressDeprecationWarnings = false;
	    hooks.deprecationHandler = null;
	
	    function isFunction(input) {
	        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	    }
	
	    function set (config) {
	        var prop, i;
	        for (i in config) {
	            prop = config[i];
	            if (isFunction(prop)) {
	                this[i] = prop;
	            } else {
	                this['_' + i] = prop;
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        this._dayOfMonthOrdinalParseLenient = new RegExp(
	            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	                '|' + (/\d{1,2}/).source);
	    }
	
	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig), prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        for (prop in parentConfig) {
	            if (hasOwnProp(parentConfig, prop) &&
	                    !hasOwnProp(childConfig, prop) &&
	                    isObject(parentConfig[prop])) {
	                // make sure changes to properties don't modify parent config
	                res[prop] = extend({}, res[prop]);
	            }
	        }
	        return res;
	    }
	
	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }
	
	    var keys;
	
	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i, res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }
	
	    var defaultCalendar = {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    };
	
	    function calendar (key, mom, now) {
	        var output = this._calendar[key] || this._calendar['sameElse'];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }
	
	    var defaultLongDateFormat = {
	        LTS  : 'h:mm:ss A',
	        LT   : 'h:mm A',
	        L    : 'MM/DD/YYYY',
	        LL   : 'MMMM D, YYYY',
	        LLL  : 'MMMM D, YYYY h:mm A',
	        LLLL : 'dddd, MMMM D, YYYY h:mm A'
	    };
	
	    function longDateFormat (key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	            return val.slice(1);
	        });
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate () {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d';
	    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	    function ordinal (number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    var defaultRelativeTime = {
	        future : 'in %s',
	        past   : '%s ago',
	        s  : 'a few seconds',
	        ss : '%d seconds',
	        m  : 'a minute',
	        mm : '%d minutes',
	        h  : 'an hour',
	        hh : '%d hours',
	        d  : 'a day',
	        dd : '%d days',
	        M  : 'a month',
	        MM : '%d months',
	        y  : 'a year',
	        yy : '%d years'
	    };
	
	    function relativeTime (number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return (isFunction(output)) ?
	            output(number, withoutSuffix, string, isFuture) :
	            output.replace(/%d/i, number);
	    }
	
	    function pastFuture (diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }
	
	    var aliases = {};
	
	    function addUnitAlias (unit, shorthand) {
	        var lowerCase = unit.toLowerCase();
	        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	    }
	
	    function normalizeUnits(units) {
	        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    var priorities = {};
	
	    function addUnitPriority(unit, priority) {
	        priorities[unit] = priority;
	    }
	
	    function getPrioritizedUnits(unitsObj) {
	        var units = [];
	        for (var u in unitsObj) {
	            units.push({unit: u, priority: priorities[u]});
	        }
	        units.sort(function (a, b) {
	            return a.priority - b.priority;
	        });
	        return units;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	    }
	
	    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	    var formatFunctions = {};
	
	    var formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken (token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(func.apply(this, arguments), token);
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens), i, length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '', i;
	            for (i = 0; i < length; i++) {
	                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var match1         = /\d/;            //       0 - 9
	    var match2         = /\d\d/;          //      00 - 99
	    var match3         = /\d{3}/;         //     000 - 999
	    var match4         = /\d{4}/;         //    0000 - 9999
	    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	    var match1to2      = /\d\d?/;         //       0 - 99
	    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
	    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
	    var match1to3      = /\d{1,3}/;       //       0 - 999
	    var match1to4      = /\d{1,4}/;       //       0 - 9999
	    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	    var matchUnsigned  = /\d+/;           //       0 - inf
	    var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	
	    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	    // any word (or two) characters or numbers including two/three word month in arabic.
	    // includes scottish gaelic two word and hyphenated months
	    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;
	
	    var regexes = {};
	
	    function addRegexToken (token, regex, strictRegex) {
	        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	            return (isStrict && strictRegex) ? strictRegex : regex;
	        };
	    }
	
	    function getParseRegexForToken (token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	            return p1 || p2 || p3 || p4;
	        }));
	    }
	
	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    var tokens = {};
	
	    function addParseToken (token, callback) {
	        var i, func = callback;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (isNumber(callback)) {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        for (i = 0; i < token.length; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken (token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    var YEAR = 0;
	    var MONTH = 1;
	    var DATE = 2;
	    var HOUR = 3;
	    var MINUTE = 4;
	    var SECOND = 5;
	    var MILLISECOND = 6;
	    var WEEK = 7;
	    var WEEKDAY = 8;
	
	    // FORMATTING
	
	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? '' + y : '+' + y;
	    });
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY',   4],       0, 'year');
	    addFormatToken(0, ['YYYYY',  5],       0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // ALIASES
	
	    addUnitAlias('year', 'y');
	
	    // PRIORITIES
	
	    addUnitPriority('year', 1);
	
	    // PARSING
	
	    addRegexToken('Y',      matchSigned);
	    addRegexToken('YY',     match1to2, match2);
	    addRegexToken('YYYY',   match1to4, match4);
	    addRegexToken('YYYYY',  match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    // HOOKS
	
	    hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', true);
	
	    function getIsLeapYear () {
	        return isLeapYear(this.year());
	    }
	
	    function makeGetSet (unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                set$1(this, unit, value);
	                hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get(this, unit);
	            }
	        };
	    }
	
	    function get (mom, unit) {
	        return mom.isValid() ?
	            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	    }
	
	    function set$1 (mom, unit, value) {
	        if (mom.isValid() && !isNaN(value)) {
	            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
	            }
	            else {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function stringGet (units) {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units]();
	        }
	        return this;
	    }
	
	
	    function stringSet (units, value) {
	        if (typeof units === 'object') {
	            units = normalizeObjectUnits(units);
	            var prioritized = getPrioritizedUnits(units);
	            for (var i = 0; i < prioritized.length; i++) {
	                this[prioritized[i].unit](units[prioritized[i].unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    function mod(n, x) {
	        return ((n % x) + x) % x;
	    }
	
	    var indexOf;
	
	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }
	
	    function daysInMonth(year, month) {
	        if (isNaN(year) || isNaN(month)) {
	            return NaN;
	        }
	        var modMonth = mod(month, 12);
	        year += (month - modMonth) / 12;
	        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // ALIASES
	
	    addUnitAlias('month', 'M');
	
	    // PRIORITY
	
	    addUnitPriority('month', 8);
	
	    // PARSING
	
	    addRegexToken('M',    match1to2);
	    addRegexToken('MM',   match1to2, match2);
	    addRegexToken('MMM',  function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
	    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	    function localeMonths (m, format) {
	        if (!m) {
	            return isArray(this._months) ? this._months :
	                this._months['standalone'];
	        }
	        return isArray(this._months) ? this._months[m.month()] :
	            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
	    }
	
	    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	    function localeMonthsShort (m, format) {
	        if (!m) {
	            return isArray(this._monthsShort) ? this._monthsShort :
	                this._monthsShort['standalone'];
	        }
	        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
	            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	    }
	
	    function handleStrictParse(monthName, format, strict) {
	        var i, ii, mom, llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeMonthsParse (monthName, format, strict) {
	        var i, mom, regex;
	
	        if (this._monthsParseExact) {
	            return handleStrictParse.call(this, monthName, format, strict);
	        }
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth (mom, value) {
	        var dayOfMonth;
	
	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }
	
	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (!isNumber(value)) {
	                    return mom;
	                }
	            }
	        }
	
	        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	        return mom;
	    }
	
	    function getSetMonth (value) {
	        if (value != null) {
	            setMonth(this, value);
	            hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth () {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    var defaultMonthsShortRegex = matchWord;
	    function monthsShortRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsShortRegex')) {
	                this._monthsShortRegex = defaultMonthsShortRegex;
	            }
	            return this._monthsShortStrictRegex && isStrict ?
	                this._monthsShortStrictRegex : this._monthsShortRegex;
	        }
	    }
	
	    var defaultMonthsRegex = matchWord;
	    function monthsRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                this._monthsRegex = defaultMonthsRegex;
	            }
	            return this._monthsStrictRegex && isStrict ?
	                this._monthsStrictRegex : this._monthsRegex;
	        }
	    }
	
	    function computeMonthsParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            shortPieces.push(this.monthsShort(mom, ''));
	            longPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.monthsShort(mom, ''));
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 12; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	        }
	        for (i = 0; i < 24; i++) {
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	    }
	
	    function createDate (y, m, d, h, M, s, ms) {
	        // can't just apply() to create a date:
	        // https://stackoverflow.com/q/181348
	        var date;
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            date = new Date(y + 400, m, d, h, M, s, ms);
	            if (isFinite(date.getFullYear())) {
	                date.setFullYear(y);
	            }
	        } else {
	            date = new Date(y, m, d, h, M, s, ms);
	        }
	
	        return date;
	    }
	
	    function createUTCDate (y) {
	        var date;
	        // the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            var args = Array.prototype.slice.call(arguments);
	            // preserve leap years using a full 400 year cycle, then reset
	            args[0] = y + 400;
	            date = new Date(Date.UTC.apply(null, args));
	            if (isFinite(date.getUTCFullYear())) {
	                date.setUTCFullYear(y);
	            }
	        } else {
	            date = new Date(Date.UTC.apply(null, arguments));
	        }
	
	        return date;
	    }
	
	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	        return -fwdlw + fwd - 1;
	    }
	
	    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear, resDayOfYear;
	
	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }
	
	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear
	        };
	    }
	
	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek, resYear;
	
	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }
	
	        return {
	            week: resWeek,
	            year: resYear
	        };
	    }
	
	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }
	
	    // FORMATTING
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // ALIASES
	
	    addUnitAlias('week', 'w');
	    addUnitAlias('isoWeek', 'W');
	
	    // PRIORITIES
	
	    addUnitPriority('week', 5);
	    addUnitPriority('isoWeek', 5);
	
	    // PARSING
	
	    addRegexToken('w',  match1to2);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W',  match1to2);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	        week[token.substr(0, 1)] = toInt(input);
	    });
	
	    // HELPERS
	
	    // LOCALES
	
	    function localeWeek (mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 6th is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek () {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear () {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek (input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek (input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // ALIASES
	
	    addUnitAlias('day', 'd');
	    addUnitAlias('weekday', 'e');
	    addUnitAlias('isoWeekday', 'E');
	
	    // PRIORITY
	    addUnitPriority('day', 11);
	    addUnitPriority('weekday', 11);
	    addUnitPriority('isoWeekday', 11);
	
	    // PARSING
	
	    addRegexToken('d',    match1to2);
	    addRegexToken('e',    match1to2);
	    addRegexToken('E',    match1to2);
	    addRegexToken('dd',   function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd',   function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd',   function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    function parseIsoWeekday(input, locale) {
	        if (typeof input === 'string') {
	            return locale.weekdaysParse(input) % 7 || 7;
	        }
	        return isNaN(input) ? null : input;
	    }
	
	    // LOCALES
	    function shiftWeekdays (ws, n) {
	        return ws.slice(n, 7).concat(ws.slice(0, n));
	    }
	
	    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	    function localeWeekdays (m, format) {
	        var weekdays = isArray(this._weekdays) ? this._weekdays :
	            this._weekdays[(m && m !== true && this._weekdays.isFormat.test(format)) ? 'format' : 'standalone'];
	        return (m === true) ? shiftWeekdays(weekdays, this._week.dow)
	            : (m) ? weekdays[m.day()] : weekdays;
	    }
	
	    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	    function localeWeekdaysShort (m) {
	        return (m === true) ? shiftWeekdays(this._weekdaysShort, this._week.dow)
	            : (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
	    }
	
	    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	    function localeWeekdaysMin (m) {
	        return (m === true) ? shiftWeekdays(this._weekdaysMin, this._week.dow)
	            : (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
	    }
	
	    function handleStrictParse$1(weekdayName, format, strict) {
	        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];
	
	            for (i = 0; i < 7; ++i) {
	                mom = createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeWeekdaysParse (weekdayName, format, strict) {
	        var i, mom, regex;
	
	        if (this._weekdaysParseExact) {
	            return handleStrictParse$1.call(this, weekdayName, format, strict);
	        }
	
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	
	            mom = createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
	                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
	                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
	            }
	            if (!this._weekdaysParse[i]) {
	                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	
	        if (input != null) {
	            var weekday = parseIsoWeekday(input, this.localeData());
	            return this.day(this.day() % 7 ? weekday : weekday - 7);
	        } else {
	            return this.day() || 7;
	        }
	    }
	
	    var defaultWeekdaysRegex = matchWord;
	    function weekdaysRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                this._weekdaysRegex = defaultWeekdaysRegex;
	            }
	            return this._weekdaysStrictRegex && isStrict ?
	                this._weekdaysStrictRegex : this._weekdaysRegex;
	        }
	    }
	
	    var defaultWeekdaysShortRegex = matchWord;
	    function weekdaysShortRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	            }
	            return this._weekdaysShortStrictRegex && isStrict ?
	                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	        }
	    }
	
	    var defaultWeekdaysMinRegex = matchWord;
	    function weekdaysMinRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	            }
	            return this._weekdaysMinStrictRegex && isStrict ?
	                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	        }
	    }
	
	
	    function computeWeekdaysParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom, minp, shortp, longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, 1]).day(i);
	            minp = this.weekdaysMin(mom, '');
	            shortp = this.weekdaysShort(mom, '');
	            longp = this.weekdays(mom, '');
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 7; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;
	
	        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
	    }
	
	    // FORMATTING
	
	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }
	
	    function kFormat() {
	        return this.hours() || 24;
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);
	
	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('hmmss', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });
	
	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('Hmmss', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });
	
	    function meridiem (token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // ALIASES
	
	    addUnitAlias('hour', 'h');
	
	    // PRIORITY
	    addUnitPriority('hour', 13);
	
	    // PARSING
	
	    function matchMeridiem (isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a',  matchMeridiem);
	    addRegexToken('A',  matchMeridiem);
	    addRegexToken('H',  match1to2);
	    addRegexToken('h',  match1to2);
	    addRegexToken('k',  match1to2);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	    addRegexToken('kk', match1to2, match2);
	
	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['k', 'kk'], function (input, array, config) {
	        var kInput = toInt(input);
	        array[HOUR] = kInput === 24 ? 0 : kInput;
	    });
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });
	
	    // LOCALES
	
	    function localeIsPM (input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return ((input + '').toLowerCase().charAt(0) === 'p');
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	    function localeMeridiem (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	
	    // MOMENTS
	
	    // Setting the hour should keep the time, because the user explicitly
	    // specified which hour they want. So trying to maintain the same hour (in
	    // a new timezone) makes sense. Adding/subtracting hours does not follow
	    // this rule.
	    var getSetHour = makeGetSet('Hours', true);
	
	    var baseConfig = {
	        calendar: defaultCalendar,
	        longDateFormat: defaultLongDateFormat,
	        invalidDate: defaultInvalidDate,
	        ordinal: defaultOrdinal,
	        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	        relativeTime: defaultRelativeTime,
	
	        months: defaultLocaleMonths,
	        monthsShort: defaultLocaleMonthsShort,
	
	        week: defaultLocaleWeek,
	
	        weekdays: defaultLocaleWeekdays,
	        weekdaysMin: defaultLocaleWeekdaysMin,
	        weekdaysShort: defaultLocaleWeekdaysShort,
	
	        meridiemParse: defaultLocaleMeridiemParse
	    };
	
	    // internal storage for locale config files
	    var locales = {};
	    var localeFamilies = {};
	    var globalLocale;
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0, j, next, locale, split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return globalLocale;
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (!locales[name] && (typeof module !== 'undefined') &&
	                module && module.exports) {
	            try {
	                oldLocale = globalLocale._abbr;
	                var aliasedRequire = require;
	                __webpack_require__(405)("./" + name);
	                getSetGlobalLocale(oldLocale);
	            } catch (e) {}
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function getSetGlobalLocale (key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = getLocale(key);
	            }
	            else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            }
	            else {
	                if ((typeof console !==  'undefined') && console.warn) {
	                    //warn user if arguments are passed but the locale could not be set
	                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
	                }
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale (name, config) {
	        if (config !== null) {
	            var locale, parentConfig = baseConfig;
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple('defineLocaleOverride',
	                        'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale ' +
	                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
	                parentConfig = locales[name]._config;
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    parentConfig = locales[config.parentLocale]._config;
	                } else {
	                    locale = loadLocale(config.parentLocale);
	                    if (locale != null) {
	                        parentConfig = locale._config;
	                    } else {
	                        if (!localeFamilies[config.parentLocale]) {
	                            localeFamilies[config.parentLocale] = [];
	                        }
	                        localeFamilies[config.parentLocale].push({
	                            name: name,
	                            config: config
	                        });
	                        return null;
	                    }
	                }
	            }
	            locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	            if (localeFamilies[name]) {
	                localeFamilies[name].forEach(function (x) {
	                    defineLocale(x.name, x.config);
	                });
	            }
	
	            // backwards compat for now: also set the locale
	            // make sure we set the locale AFTER all child locales have been
	            // created, so we won't end up with the child locale set.
	            getSetGlobalLocale(name);
	
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale, tmpLocale, parentConfig = baseConfig;
	            // MERGE
	            tmpLocale = loadLocale(name);
	            if (tmpLocale != null) {
	                parentConfig = tmpLocale._config;
	            }
	            config = mergeConfigs(parentConfig, config);
	            locale = new Locale(config);
	            locale.parentLocale = locales[name];
	            locales[name] = locale;
	
	            // backwards compat for now: also set the locale
	            getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }
	
	    // returns locale data
	    function getLocale (key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    function listLocales() {
	        return keys(locales);
	    }
	
	    function checkOverflow (m) {
	        var overflow;
	        var a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	                -1;
	
	            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(hooks.now());
	        if (config._useUTC) {
	            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray (config) {
	        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear != null) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (config._a[HOUR] === 24 &&
	                config._a[MINUTE] === 0 &&
	                config._a[SECOND] === 0 &&
	                config._a[MILLISECOND] === 0) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
	
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	
	        // check for mismatching day of week
	        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
	            getParsingFlags(config).weekdayMismatch = true;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            var curWeek = weekOfYear(createLocal(), dow, doy);
	
	            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	            // Default to current week.
	            week = defaults(w.w, curWeek.week);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from beginning of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to beginning of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }
	
	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	
	    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
	
	    var isoDates = [
	        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	        ['YYYY-DDD', /\d{4}-\d{3}/],
	        ['YYYY-MM', /\d{4}-\d\d/, false],
	        ['YYYYYYMMDD', /[+-]\d{10}/],
	        ['YYYYMMDD', /\d{8}/],
	        // YYYYMM is NOT allowed by the standard
	        ['GGGG[W]WWE', /\d{4}W\d{3}/],
	        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	        ['YYYYDDD', /\d{7}/]
	    ];
	
	    // iso time formats and regexes
	    var isoTimes = [
	        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	        ['HH:mm', /\d\d:\d\d/],
	        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	        ['HHmmss', /\d\d\d\d\d\d/],
	        ['HHmm', /\d\d\d\d/],
	        ['HH', /\d\d/]
	    ];
	
	    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	    // date from iso format
	    function configFromISO(config) {
	        var i, l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime, dateFormat, timeFormat, tzFormat;
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	
	            for (i = 0, l = isoDates.length; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimes.length; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;
	
	    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
	        var result = [
	            untruncateYear(yearStr),
	            defaultLocaleMonthsShort.indexOf(monthStr),
	            parseInt(dayStr, 10),
	            parseInt(hourStr, 10),
	            parseInt(minuteStr, 10)
	        ];
	
	        if (secondStr) {
	            result.push(parseInt(secondStr, 10));
	        }
	
	        return result;
	    }
	
	    function untruncateYear(yearStr) {
	        var year = parseInt(yearStr, 10);
	        if (year <= 49) {
	            return 2000 + year;
	        } else if (year <= 999) {
	            return 1900 + year;
	        }
	        return year;
	    }
	
	    function preprocessRFC2822(s) {
	        // Remove comments and folding whitespace and replace multiple-spaces with a single space
	        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
	    }
	
	    function checkWeekday(weekdayStr, parsedInput, config) {
	        if (weekdayStr) {
	            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
	            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
	            if (weekdayProvided !== weekdayActual) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return false;
	            }
	        }
	        return true;
	    }
	
	    var obsOffsets = {
	        UT: 0,
	        GMT: 0,
	        EDT: -4 * 60,
	        EST: -5 * 60,
	        CDT: -5 * 60,
	        CST: -6 * 60,
	        MDT: -6 * 60,
	        MST: -7 * 60,
	        PDT: -7 * 60,
	        PST: -8 * 60
	    };
	
	    function calculateOffset(obsOffset, militaryOffset, numOffset) {
	        if (obsOffset) {
	            return obsOffsets[obsOffset];
	        } else if (militaryOffset) {
	            // the only allowed military tz is Z
	            return 0;
	        } else {
	            var hm = parseInt(numOffset, 10);
	            var m = hm % 100, h = (hm - m) / 100;
	            return h * 60 + m;
	        }
	    }
	
	    // date and time from ref 2822 format
	    function configFromRFC2822(config) {
	        var match = rfc2822.exec(preprocessRFC2822(config._i));
	        if (match) {
	            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
	            if (!checkWeekday(match[1], parsedArray, config)) {
	                return;
	            }
	
	            config._a = parsedArray;
	            config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	            config._d = createUTCDate.apply(null, config._a);
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	            getParsingFlags(config).rfc2822 = true;
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from iso format or fallback
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        configFromRFC2822(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        // Final attempt, use Input Fallback
	        hooks.createFromInputFallback(config);
	    }
	
	    hooks.createFromInputFallback = deprecate(
	        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	        'discouraged and will be removed in an upcoming major release. Please refer to ' +
	        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    // constant that refers to the ISO standard
	    hooks.ISO_8601 = function () {};
	
	    // constant that refers to the RFC 2822 form
	    hooks.RFC_2822 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	        if (config._f === hooks.RFC_2822) {
	            configFromRFC2822(config);
	            return;
	        }
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i, parsedInput, tokens, token, skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0;
	
	        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	        for (i = 0; i < tokens.length; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	            // console.log('token', token, 'parsedInput', parsedInput,
	            //         'regex', getParseRegexForToken(token, config));
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                }
	                else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            }
	            else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (config._a[HOUR] <= 12 &&
	            getParsingFlags(config).bigHour === true &&
	            config._a[HOUR] > 0) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	
	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	
	    function meridiemFixWrap (locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	
	            scoreToBeat,
	            i,
	            currentScore;
	
	        if (config._f.length === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < config._f.length; i++) {
	            currentScore = 0;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (!isValid(tempConfig)) {
	                continue;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (scoreToBeat == null || currentScore < scoreToBeat) {
	                scoreToBeat = currentScore;
	                bestMoment = tempConfig;
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i);
	        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	            return obj && parseInt(obj, 10);
	        });
	
	        configFromArray(config);
	    }
	
	    function createFromConfig (config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig (config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return createInvalid({nullInput: true});
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isDate(input)) {
	            config._d = input;
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        }  else {
	            configFromInput(config);
	        }
	
	        if (!isValid(config)) {
	            config._d = null;
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (isUndefined(input)) {
	            config._d = new Date(hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (isObject(input)) {
	            configFromObject(config);
	        } else if (isNumber(input)) {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC (input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (locale === true || locale === false) {
	            strict = locale;
	            locale = undefined;
	        }
	
	        if ((isObject(input) && isObjectEmpty(input)) ||
	                (isArray(input) && input.length === 0)) {
	            input = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function createLocal (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	        function () {
	            var other = createLocal.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other < this ? this : other;
	            } else {
	                return createInvalid();
	            }
	        }
	    );
	
	    var prototypeMax = deprecate(
	        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	        function () {
	            var other = createLocal.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other > this ? this : other;
	            } else {
	                return createInvalid();
	            }
	        }
	    );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    var now = function () {
	        return Date.now ? Date.now() : +(new Date());
	    };
	
	    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];
	
	    function isDurationValid(m) {
	        for (var key in m) {
	            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
	                return false;
	            }
	        }
	
	        var unitHasDecimal = false;
	        for (var i = 0; i < ordering.length; ++i) {
	            if (m[ordering[i]]) {
	                if (unitHasDecimal) {
	                    return false; // only allow non-integers for smallest unit
	                }
	                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                    unitHasDecimal = true;
	                }
	            }
	        }
	
	        return true;
	    }
	
	    function isValid$1() {
	        return this._isValid;
	    }
	
	    function createInvalid$1() {
	        return createDuration(NaN);
	    }
	
	    function Duration (duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        this._isValid = isDurationValid(normalizedInput);
	
	        // representation for dateAddRemove
	        this._milliseconds = +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days +
	            weeks * 7;
	        // It is impossible to translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months +
	            quarters * 3 +
	            years * 12;
	
	        this._data = {};
	
	        this._locale = getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration (obj) {
	        return obj instanceof Duration;
	    }
	
	    function absRound (number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }
	
	    // FORMATTING
	
	    function offset (token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset();
	            var sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z',  matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(matcher, string) {
	        var matches = (string || '').match(matcher);
	
	        if (matches === null) {
	            return null;
	        }
	
	        var chunk   = matches[matches.length - 1] || [];
	        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return minutes === 0 ?
	          0 :
	          parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return createLocal(input).local();
	        }
	    }
	
	    function getDateOffset (m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset (input, keepLocalTime, keepMinutes) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	                if (input === null) {
	                    return this;
	                }
	            } else if (Math.abs(input) < 16 && !keepMinutes) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone (input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC (keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal (keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset () {
	        if (this._tzm != null) {
	            this.utcOffset(this._tzm, false, true);
	        } else if (typeof this._i === 'string') {
	            var tZone = offsetFromString(matchOffset, this._i);
	            if (tZone != null) {
	                this.utcOffset(tZone);
	            }
	            else {
	                this.utcOffset(0, true);
	            }
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset (input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime () {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted () {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }
	
	        var c = {};
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	            this._isDSTShifted = this.isValid() &&
	                compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal () {
	        return this.isValid() ? !this._isUTC : false;
	    }
	
	    function isUtcOffset () {
	        return this.isValid() ? this._isUTC : false;
	    }
	
	    function isUtc () {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }
	
	    // ASP.NET json date format regex
	    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;
	
	    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	    // and further modified to allow for strings containing both week and day
	    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	    function createDuration (input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms : input._milliseconds,
	                d  : input._days,
	                M  : input._months
	            };
	        } else if (isNumber(input)) {
	            duration = {};
	            if (key) {
	                duration[key] = input;
	            } else {
	                duration.milliseconds = input;
	            }
	        } else if (!!(match = aspNetRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y  : 0,
	                d  : toInt(match[DATE])                         * sign,
	                h  : toInt(match[HOUR])                         * sign,
	                m  : toInt(match[MINUTE])                       * sign,
	                s  : toInt(match[SECOND])                       * sign,
	                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
	            };
	        } else if (!!(match = isoRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y : parseIso(match[2], sign),
	                M : parseIso(match[3], sign),
	                w : parseIso(match[4], sign),
	                d : parseIso(match[5], sign),
	                h : parseIso(match[6], sign),
	                m : parseIso(match[7], sign),
	                s : parseIso(match[8], sign)
	            };
	        } else if (duration == null) {// checks for null or undefined
	            duration = {};
	        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        return ret;
	    }
	
	    createDuration.fn = Duration.prototype;
	    createDuration.invalid = createInvalid$1;
	
	    function parseIso (inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {};
	
	        res.months = other.month() - base.month() +
	            (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return {milliseconds: 0, months: 0};
	        }
	
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
	                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
	                tmp = val; val = period; period = tmp;
	            }
	
	            val = typeof val === 'string' ? +val : val;
	            dur = createDuration(val, period);
	            addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function addSubtract (mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);
	
	        if (!mom.isValid()) {
	            // No op
	            return;
	        }
	
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (months) {
	            setMonth(mom, get(mom, 'Month') + months * isAdding);
	        }
	        if (days) {
	            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	        }
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (updateOffset) {
	            hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add      = createAdder(1, 'add');
	    var subtract = createAdder(-1, 'subtract');
	
	    function getCalendarFormat(myMoment, now) {
	        var diff = myMoment.diff(now, 'days', true);
	        return diff < -6 ? 'sameElse' :
	                diff < -1 ? 'lastWeek' :
	                diff < 0 ? 'lastDay' :
	                diff < 1 ? 'sameDay' :
	                diff < 2 ? 'nextDay' :
	                diff < 7 ? 'nextWeek' : 'sameElse';
	    }
	
	    function calendar$1 (time, formats) {
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            format = hooks.calendarFormat(this, sod) || 'sameElse';
	
	        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
	
	        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
	    }
	
	    function clone () {
	        return new Moment(this);
	    }
	
	    function isAfter (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }
	
	    function isBefore (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }
	
	    function isBetween (from, to, units, inclusivity) {
	        var localFrom = isMoment(from) ? from : createLocal(from),
	            localTo = isMoment(to) ? to : createLocal(to);
	        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
	            return false;
	        }
	        inclusivity = inclusivity || '()';
	        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) &&
	            (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
	    }
	
	    function isSame (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
	        }
	    }
	
	    function isSameOrAfter (input, units) {
	        return this.isSame(input, units) || this.isAfter(input, units);
	    }
	
	    function isSameOrBefore (input, units) {
	        return this.isSame(input, units) || this.isBefore(input, units);
	    }
	
	    function diff (input, units, asFloat) {
	        var that,
	            zoneDelta,
	            output;
	
	        if (!this.isValid()) {
	            return NaN;
	        }
	
	        that = cloneWithOffset(input, this);
	
	        if (!that.isValid()) {
	            return NaN;
	        }
	
	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	        units = normalizeUnits(units);
	
	        switch (units) {
	            case 'year': output = monthDiff(this, that) / 12; break;
	            case 'month': output = monthDiff(this, that); break;
	            case 'quarter': output = monthDiff(this, that) / 3; break;
	            case 'second': output = (this - that) / 1e3; break; // 1000
	            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
	            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
	            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
	            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
	            default: output = this - that;
	        }
	
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff (a, b) {
	        // difference in months
	        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2, adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }
	
	    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	    function toString () {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function toISOString(keepOffset) {
	        if (!this.isValid()) {
	            return null;
	        }
	        var utc = keepOffset !== true;
	        var m = utc ? this.clone().utc() : this;
	        if (m.year() < 0 || m.year() > 9999) {
	            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
	        }
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            if (utc) {
	                return this.toDate().toISOString();
	            } else {
	                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
	            }
	        }
	        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
	    }
	
	    /**
	     * Return a human readable representation of a moment that can
	     * also be evaluated to get a new moment which is the same
	     *
	     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	     */
	    function inspect () {
	        if (!this.isValid()) {
	            return 'moment.invalid(/* ' + this._i + ' */)';
	        }
	        var func = 'moment';
	        var zone = '';
	        if (!this.isLocal()) {
	            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	            zone = 'Z';
	        }
	        var prefix = '[' + func + '("]';
	        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
	        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
	        var suffix = zone + '[")]';
	
	        return this.format(prefix + year + datetime + suffix);
	    }
	
	    function format (inputString) {
	        if (!inputString) {
	            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }
	
	    function from (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 createLocal(time).isValid())) {
	            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function fromNow (withoutSuffix) {
	        return this.from(createLocal(), withoutSuffix);
	    }
	
	    function to (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 createLocal(time).isValid())) {
	            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function toNow (withoutSuffix) {
	        return this.to(createLocal(), withoutSuffix);
	    }
	
	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale (key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData () {
	        return this._locale;
	    }
	
	    var MS_PER_SECOND = 1000;
	    var MS_PER_MINUTE = 60 * MS_PER_SECOND;
	    var MS_PER_HOUR = 60 * MS_PER_MINUTE;
	    var MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
	
	    // actual modulo - handles negative numbers (for dates before 1970):
	    function mod$1(dividend, divisor) {
	        return (dividend % divisor + divisor) % divisor;
	    }
	
	    function localStartOfDate(y, m, d) {
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return new Date(y, m, d).valueOf();
	        }
	    }
	
	    function utcStartOfDate(y, m, d) {
	        // Date.UTC remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return Date.UTC(y, m, d);
	        }
	    }
	
	    function startOf (units) {
	        var time;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year(), 0, 1);
	                break;
	            case 'quarter':
	                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month(), 1);
	                break;
	            case 'week':
	                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
	                break;
	            case 'isoWeek':
	                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date());
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_MINUTE);
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_SECOND);
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function endOf (units) {
	        var time;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year() + 1, 0, 1) - 1;
	                break;
	            case 'quarter':
	                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
	                break;
	            case 'week':
	                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
	                break;
	            case 'isoWeek':
	                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function valueOf () {
	        return this._d.valueOf() - ((this._offset || 0) * 60000);
	    }
	
	    function unix () {
	        return Math.floor(this.valueOf() / 1000);
	    }
	
	    function toDate () {
	        return new Date(this.valueOf());
	    }
	
	    function toArray () {
	        var m = this;
	        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	    }
	
	    function toObject () {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds()
	        };
	    }
	
	    function toJSON () {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }
	
	    function isValid$2 () {
	        return isValid(this);
	    }
	
	    function parsingFlags () {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt () {
	        return getParsingFlags(this).overflow;
	    }
	
	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict
	        };
	    }
	
	    // FORMATTING
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken (token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg',     'weekYear');
	    addWeekYearFormatToken('ggggg',    'weekYear');
	    addWeekYearFormatToken('GGGG',  'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    addUnitAlias('weekYear', 'gg');
	    addUnitAlias('isoWeekYear', 'GG');
	
	    // PRIORITY
	
	    addUnitPriority('weekYear', 1);
	    addUnitPriority('isoWeekYear', 1);
	
	
	    // PARSING
	
	    addRegexToken('G',      matchSigned);
	    addRegexToken('g',      matchSigned);
	    addRegexToken('GG',     match1to2, match2);
	    addRegexToken('gg',     match1to2, match2);
	    addRegexToken('GGGG',   match1to4, match4);
	    addRegexToken('gggg',   match1to4, match4);
	    addRegexToken('GGGGG',  match1to6, match6);
	    addRegexToken('ggggg',  match1to6, match6);
	
	    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	        week[token.substr(0, 2)] = toInt(input);
	    });
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = hooks.parseTwoDigitYear(input);
	    });
	
	    // MOMENTS
	
	    function getSetWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input,
	                this.week(),
	                this.weekday(),
	                this.localeData()._week.dow,
	                this.localeData()._week.doy);
	    }
	
	    function getSetISOWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input, this.isoWeek(), this.isoWeekday(), 1, 4);
	    }
	
	    function getISOWeeksInYear () {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getWeeksInYear () {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }
	
	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Q', 0, 'Qo', 'quarter');
	
	    // ALIASES
	
	    addUnitAlias('quarter', 'Q');
	
	    // PRIORITY
	
	    addUnitPriority('quarter', 7);
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter (input) {
	        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	    }
	
	    // FORMATTING
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // ALIASES
	
	    addUnitAlias('date', 'D');
	
	    // PRIORITY
	    addUnitPriority('date', 9);
	
	    // PARSING
	
	    addRegexToken('D',  match1to2);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        return isStrict ?
	          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
	          locale._dayOfMonthOrdinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0]);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    // FORMATTING
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // ALIASES
	
	    addUnitAlias('dayOfYear', 'DDD');
	
	    // PRIORITY
	    addUnitPriority('dayOfYear', 4);
	
	    // PARSING
	
	    addRegexToken('DDD',  match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    // MOMENTS
	
	    function getSetDayOfYear (input) {
	        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // ALIASES
	
	    addUnitAlias('minute', 'm');
	
	    // PRIORITY
	
	    addUnitPriority('minute', 14);
	
	    // PARSING
	
	    addRegexToken('m',  match1to2);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    // FORMATTING
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // ALIASES
	
	    addUnitAlias('second', 's');
	
	    // PRIORITY
	
	    addUnitPriority('second', 15);
	
	    // PARSING
	
	    addRegexToken('s',  match1to2);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    // FORMATTING
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	
	    // ALIASES
	
	    addUnitAlias('millisecond', 'ms');
	
	    // PRIORITY
	
	    addUnitPriority('millisecond', 16);
	
	    // PARSING
	
	    addRegexToken('S',    match1to3, match1);
	    addRegexToken('SS',   match1to3, match2);
	    addRegexToken('SSS',  match1to3, match3);
	
	    var token;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	    // MOMENTS
	
	    var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    // FORMATTING
	
	    addFormatToken('z',  0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr () {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName () {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var proto = Moment.prototype;
	
	    proto.add               = add;
	    proto.calendar          = calendar$1;
	    proto.clone             = clone;
	    proto.diff              = diff;
	    proto.endOf             = endOf;
	    proto.format            = format;
	    proto.from              = from;
	    proto.fromNow           = fromNow;
	    proto.to                = to;
	    proto.toNow             = toNow;
	    proto.get               = stringGet;
	    proto.invalidAt         = invalidAt;
	    proto.isAfter           = isAfter;
	    proto.isBefore          = isBefore;
	    proto.isBetween         = isBetween;
	    proto.isSame            = isSame;
	    proto.isSameOrAfter     = isSameOrAfter;
	    proto.isSameOrBefore    = isSameOrBefore;
	    proto.isValid           = isValid$2;
	    proto.lang              = lang;
	    proto.locale            = locale;
	    proto.localeData        = localeData;
	    proto.max               = prototypeMax;
	    proto.min               = prototypeMin;
	    proto.parsingFlags      = parsingFlags;
	    proto.set               = stringSet;
	    proto.startOf           = startOf;
	    proto.subtract          = subtract;
	    proto.toArray           = toArray;
	    proto.toObject          = toObject;
	    proto.toDate            = toDate;
	    proto.toISOString       = toISOString;
	    proto.inspect           = inspect;
	    proto.toJSON            = toJSON;
	    proto.toString          = toString;
	    proto.unix              = unix;
	    proto.valueOf           = valueOf;
	    proto.creationData      = creationData;
	    proto.year       = getSetYear;
	    proto.isLeapYear = getIsLeapYear;
	    proto.weekYear    = getSetWeekYear;
	    proto.isoWeekYear = getSetISOWeekYear;
	    proto.quarter = proto.quarters = getSetQuarter;
	    proto.month       = getSetMonth;
	    proto.daysInMonth = getDaysInMonth;
	    proto.week           = proto.weeks        = getSetWeek;
	    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
	    proto.weeksInYear    = getWeeksInYear;
	    proto.isoWeeksInYear = getISOWeeksInYear;
	    proto.date       = getSetDayOfMonth;
	    proto.day        = proto.days             = getSetDayOfWeek;
	    proto.weekday    = getSetLocaleDayOfWeek;
	    proto.isoWeekday = getSetISODayOfWeek;
	    proto.dayOfYear  = getSetDayOfYear;
	    proto.hour = proto.hours = getSetHour;
	    proto.minute = proto.minutes = getSetMinute;
	    proto.second = proto.seconds = getSetSecond;
	    proto.millisecond = proto.milliseconds = getSetMillisecond;
	    proto.utcOffset            = getSetOffset;
	    proto.utc                  = setOffsetToUTC;
	    proto.local                = setOffsetToLocal;
	    proto.parseZone            = setOffsetToParsedOffset;
	    proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    proto.isDST                = isDaylightSavingTime;
	    proto.isLocal              = isLocal;
	    proto.isUtcOffset          = isUtcOffset;
	    proto.isUtc                = isUtc;
	    proto.isUTC                = isUtc;
	    proto.zoneAbbr = getZoneAbbr;
	    proto.zoneName = getZoneName;
	    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
	    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
	
	    function createUnix (input) {
	        return createLocal(input * 1000);
	    }
	
	    function createInZone () {
	        return createLocal.apply(null, arguments).parseZone();
	    }
	
	    function preParsePostFormat (string) {
	        return string;
	    }
	
	    var proto$1 = Locale.prototype;
	
	    proto$1.calendar        = calendar;
	    proto$1.longDateFormat  = longDateFormat;
	    proto$1.invalidDate     = invalidDate;
	    proto$1.ordinal         = ordinal;
	    proto$1.preparse        = preParsePostFormat;
	    proto$1.postformat      = preParsePostFormat;
	    proto$1.relativeTime    = relativeTime;
	    proto$1.pastFuture      = pastFuture;
	    proto$1.set             = set;
	
	    proto$1.months            =        localeMonths;
	    proto$1.monthsShort       =        localeMonthsShort;
	    proto$1.monthsParse       =        localeMonthsParse;
	    proto$1.monthsRegex       = monthsRegex;
	    proto$1.monthsShortRegex  = monthsShortRegex;
	    proto$1.week = localeWeek;
	    proto$1.firstDayOfYear = localeFirstDayOfYear;
	    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	    proto$1.weekdays       =        localeWeekdays;
	    proto$1.weekdaysMin    =        localeWeekdaysMin;
	    proto$1.weekdaysShort  =        localeWeekdaysShort;
	    proto$1.weekdaysParse  =        localeWeekdaysParse;
	
	    proto$1.weekdaysRegex       =        weekdaysRegex;
	    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
	    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;
	
	    proto$1.isPM = localeIsPM;
	    proto$1.meridiem = localeMeridiem;
	
	    function get$1 (format, index, field, setter) {
	        var locale = getLocale();
	        var utc = createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function listMonthsImpl (format, index, field) {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return get$1(format, index, field, 'month');
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = get$1(format, i, field, 'month');
	        }
	        return out;
	    }
	
	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl (localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;
	
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        }
	
	        var locale = getLocale(),
	            shift = localeSorted ? locale._week.dow : 0;
	
	        if (index != null) {
	            return get$1(format, (index + shift) % 7, field, 'day');
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < 7; i++) {
	            out[i] = get$1(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }
	
	    function listMonths (format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }
	
	    function listMonthsShort (format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }
	
	    function listWeekdays (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }
	
	    function listWeekdaysShort (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }
	
	    function listWeekdaysMin (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }
	
	    getSetGlobalLocale('en', {
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (toInt(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    // Side effect imports
	
	    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
	    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
	
	    var mathAbs = Math.abs;
	
	    function abs () {
	        var data           = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days         = mathAbs(this._days);
	        this._months       = mathAbs(this._months);
	
	        data.milliseconds  = mathAbs(data.milliseconds);
	        data.seconds       = mathAbs(data.seconds);
	        data.minutes       = mathAbs(data.minutes);
	        data.hours         = mathAbs(data.hours);
	        data.months        = mathAbs(data.months);
	        data.years         = mathAbs(data.years);
	
	        return this;
	    }
	
	    function addSubtract$1 (duration, input, value, direction) {
	        var other = createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days         += direction * other._days;
	        duration._months       += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function add$1 (input, value) {
	        return addSubtract$1(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function subtract$1 (input, value) {
	        return addSubtract$1(this, input, value, -1);
	    }
	
	    function absCeil (number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble () {
	        var milliseconds = this._milliseconds;
	        var days         = this._days;
	        var months       = this._months;
	        var data         = this._data;
	        var seconds, minutes, hours, years, monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0))) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds           = absFloor(milliseconds / 1000);
	        data.seconds      = seconds % 60;
	
	        minutes           = absFloor(seconds / 60);
	        data.minutes      = minutes % 60;
	
	        hours             = absFloor(minutes / 60);
	        data.hours        = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days   = days;
	        data.months = months;
	        data.years  = years;
	
	        return this;
	    }
	
	    function daysToMonths (days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return days * 4800 / 146097;
	    }
	
	    function monthsToDays (months) {
	        // the reverse of daysToMonths
	        return months * 146097 / 4800;
	    }
	
	    function as (units) {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        var days;
	        var months;
	        var milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'quarter' || units === 'year') {
	            days = this._days + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            switch (units) {
	                case 'month':   return months;
	                case 'quarter': return months / 3;
	                case 'year':    return months / 12;
	            }
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week'   : return days / 7     + milliseconds / 6048e5;
	                case 'day'    : return days         + milliseconds / 864e5;
	                case 'hour'   : return days * 24    + milliseconds / 36e5;
	                case 'minute' : return days * 1440  + milliseconds / 6e4;
	                case 'second' : return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	                default: throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    // TODO: Use this.as('ms')?
	    function valueOf$1 () {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        return (
	            this._milliseconds +
	            this._days * 864e5 +
	            (this._months % 12) * 2592e6 +
	            toInt(this._months / 12) * 31536e6
	        );
	    }
	
	    function makeAs (alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms');
	    var asSeconds      = makeAs('s');
	    var asMinutes      = makeAs('m');
	    var asHours        = makeAs('h');
	    var asDays         = makeAs('d');
	    var asWeeks        = makeAs('w');
	    var asMonths       = makeAs('M');
	    var asQuarters     = makeAs('Q');
	    var asYears        = makeAs('y');
	
	    function clone$1 () {
	        return createDuration(this);
	    }
	
	    function get$2 (units) {
	        units = normalizeUnits(units);
	        return this.isValid() ? this[units + 's']() : NaN;
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this.isValid() ? this._data[name] : NaN;
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds');
	    var seconds      = makeGetter('seconds');
	    var minutes      = makeGetter('minutes');
	    var hours        = makeGetter('hours');
	    var days         = makeGetter('days');
	    var months       = makeGetter('months');
	    var years        = makeGetter('years');
	
	    function weeks () {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round;
	    var thresholds = {
	        ss: 44,         // a few seconds to seconds
	        s : 45,         // seconds to minute
	        m : 45,         // minutes to hour
	        h : 22,         // hours to day
	        d : 26,         // days to month
	        M : 11          // months to year
	    };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
	        var duration = createDuration(posNegDuration).abs();
	        var seconds  = round(duration.as('s'));
	        var minutes  = round(duration.as('m'));
	        var hours    = round(duration.as('h'));
	        var days     = round(duration.as('d'));
	        var months   = round(duration.as('M'));
	        var years    = round(duration.as('y'));
	
	        var a = seconds <= thresholds.ss && ['s', seconds]  ||
	                seconds < thresholds.s   && ['ss', seconds] ||
	                minutes <= 1             && ['m']           ||
	                minutes < thresholds.m   && ['mm', minutes] ||
	                hours   <= 1             && ['h']           ||
	                hours   < thresholds.h   && ['hh', hours]   ||
	                days    <= 1             && ['d']           ||
	                days    < thresholds.d   && ['dd', days]    ||
	                months  <= 1             && ['M']           ||
	                months  < thresholds.M   && ['MM', months]  ||
	                years   <= 1             && ['y']           || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set the rounding function for relative time strings
	    function getSetRelativeTimeRounding (roundingFunction) {
	        if (roundingFunction === undefined) {
	            return round;
	        }
	        if (typeof(roundingFunction) === 'function') {
	            round = roundingFunction;
	            return true;
	        }
	        return false;
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function getSetRelativeTimeThreshold (threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        if (threshold === 's') {
	            thresholds.ss = limit - 1;
	        }
	        return true;
	    }
	
	    function humanize (withSuffix) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var locale = this.localeData();
	        var output = relativeTime$1(this, !withSuffix, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var abs$1 = Math.abs;
	
	    function sign(x) {
	        return ((x > 0) - (x < 0)) || +x;
	    }
	
	    function toISOString$1() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var seconds = abs$1(this._milliseconds) / 1000;
	        var days         = abs$1(this._days);
	        var months       = abs$1(this._months);
	        var minutes, hours, years;
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes           = absFloor(seconds / 60);
	        hours             = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years  = absFloor(months / 12);
	        months %= 12;
	
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        var Y = years;
	        var M = months;
	        var D = days;
	        var h = hours;
	        var m = minutes;
	        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	        var total = this.asSeconds();
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        var totalSign = total < 0 ? '-' : '';
	        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
	        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
	        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	        return totalSign + 'P' +
	            (Y ? ymSign + Y + 'Y' : '') +
	            (M ? ymSign + M + 'M' : '') +
	            (D ? daysSign + D + 'D' : '') +
	            ((h || m || s) ? 'T' : '') +
	            (h ? hmsSign + h + 'H' : '') +
	            (m ? hmsSign + m + 'M' : '') +
	            (s ? hmsSign + s + 'S' : '');
	    }
	
	    var proto$2 = Duration.prototype;
	
	    proto$2.isValid        = isValid$1;
	    proto$2.abs            = abs;
	    proto$2.add            = add$1;
	    proto$2.subtract       = subtract$1;
	    proto$2.as             = as;
	    proto$2.asMilliseconds = asMilliseconds;
	    proto$2.asSeconds      = asSeconds;
	    proto$2.asMinutes      = asMinutes;
	    proto$2.asHours        = asHours;
	    proto$2.asDays         = asDays;
	    proto$2.asWeeks        = asWeeks;
	    proto$2.asMonths       = asMonths;
	    proto$2.asQuarters     = asQuarters;
	    proto$2.asYears        = asYears;
	    proto$2.valueOf        = valueOf$1;
	    proto$2._bubble        = bubble;
	    proto$2.clone          = clone$1;
	    proto$2.get            = get$2;
	    proto$2.milliseconds   = milliseconds;
	    proto$2.seconds        = seconds;
	    proto$2.minutes        = minutes;
	    proto$2.hours          = hours;
	    proto$2.days           = days;
	    proto$2.weeks          = weeks;
	    proto$2.months         = months;
	    proto$2.years          = years;
	    proto$2.humanize       = humanize;
	    proto$2.toISOString    = toISOString$1;
	    proto$2.toString       = toISOString$1;
	    proto$2.toJSON         = toISOString$1;
	    proto$2.locale         = locale;
	    proto$2.localeData     = localeData;
	
	    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
	    proto$2.lang = lang;
	
	    // Side effect imports
	
	    // FORMATTING
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input, 10) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    // Side effect imports
	
	
	    hooks.version = '2.24.0';
	
	    setHookCallback(createLocal);
	
	    hooks.fn                    = proto;
	    hooks.min                   = min;
	    hooks.max                   = max;
	    hooks.now                   = now;
	    hooks.utc                   = createUTC;
	    hooks.unix                  = createUnix;
	    hooks.months                = listMonths;
	    hooks.isDate                = isDate;
	    hooks.locale                = getSetGlobalLocale;
	    hooks.invalid               = createInvalid;
	    hooks.duration              = createDuration;
	    hooks.isMoment              = isMoment;
	    hooks.weekdays              = listWeekdays;
	    hooks.parseZone             = createInZone;
	    hooks.localeData            = getLocale;
	    hooks.isDuration            = isDuration;
	    hooks.monthsShort           = listMonthsShort;
	    hooks.weekdaysMin           = listWeekdaysMin;
	    hooks.defineLocale          = defineLocale;
	    hooks.updateLocale          = updateLocale;
	    hooks.locales               = listLocales;
	    hooks.weekdaysShort         = listWeekdaysShort;
	    hooks.normalizeUnits        = normalizeUnits;
	    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
	    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	    hooks.calendarFormat        = getCalendarFormat;
	    hooks.prototype             = proto;
	
	    // currently HTML5 input type only supports 24-hour formats
	    hooks.HTML5_FMT = {
	        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
	        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
	        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
	        DATE: 'YYYY-MM-DD',                             // <input type="date" />
	        TIME: 'HH:mm',                                  // <input type="time" />
	        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
	        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
	        WEEK: 'GGGG-[W]WW',                             // <input type="week" />
	        MONTH: 'YYYY-MM'                                // <input type="month" />
	    };
	
	    return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(33)(module)))

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.connect = exports.Provider = undefined;
	
	var _Provider = __webpack_require__(456);
	
	var _Provider2 = _interopRequireDefault(_Provider);
	
	var _connect = __webpack_require__(457);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	exports.Provider = _Provider2["default"];
	exports.connect = _connect2["default"];

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.withFirebase = exports.FirebaseContext = undefined;
	
	var _context = __webpack_require__(274);
	
	var _context2 = _interopRequireDefault(_context);
	
	var _firebase = __webpack_require__(275);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	exports.default = _firebase2.default;
	exports.FirebaseContext = _context2.default;
	exports.withFirebase = _context.withFirebase;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(2);
	var React__default = _interopDefault(React);
	var _extends = _interopDefault(__webpack_require__(57));
	var shallowEqual = _interopDefault(__webpack_require__(385));
	var _inheritsLoose = _interopDefault(__webpack_require__(99));
	var reactLifecyclesCompat = __webpack_require__(91);
	var _objectWithoutPropertiesLoose = _interopDefault(__webpack_require__(138));
	var hoistNonReactStatics = _interopDefault(__webpack_require__(886));
	var changeEmitter = __webpack_require__(360);
	var $$observable = _interopDefault(__webpack_require__(247));
	
	var setStatic = function setStatic(key, value) {
	  return function (BaseComponent) {
	    /* eslint-disable no-param-reassign */
	    BaseComponent[key] = value;
	    /* eslint-enable no-param-reassign */
	
	    return BaseComponent;
	  };
	};
	
	var setDisplayName = function setDisplayName(displayName) {
	  return setStatic('displayName', displayName);
	};
	
	var getDisplayName = function getDisplayName(Component) {
	  if (typeof Component === 'string') {
	    return Component;
	  }
	
	  if (!Component) {
	    return undefined;
	  }
	
	  return Component.displayName || Component.name || 'Component';
	};
	
	var wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
	  return hocName + "(" + getDisplayName(BaseComponent) + ")";
	};
	
	var mapProps = function mapProps(propsMapper) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	
	    var MapProps = function MapProps(props) {
	      return factory(propsMapper(props));
	    };
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'mapProps'))(MapProps);
	    }
	
	    return MapProps;
	  };
	};
	
	var withProps = function withProps(input) {
	  var hoc = mapProps(function (props) {
	    return _extends({}, props, typeof input === 'function' ? input(props) : input);
	  });
	
	  if (false) {
	    return function (BaseComponent) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'withProps'))(hoc(BaseComponent));
	    };
	  }
	
	  return hoc;
	};
	
	var pick = function pick(obj, keys) {
	  var result = {};
	
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	
	    if (obj.hasOwnProperty(key)) {
	      result[key] = obj[key];
	    }
	  }
	
	  return result;
	};
	
	var withPropsOnChange = function withPropsOnChange(shouldMapOrKeys, propsMapper) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	    var shouldMap = typeof shouldMapOrKeys === 'function' ? shouldMapOrKeys : function (props, nextProps) {
	      return !shallowEqual(pick(props, shouldMapOrKeys), pick(nextProps, shouldMapOrKeys));
	    };
	
	    var WithPropsOnChange =
	    /*#__PURE__*/
	    function (_Component) {
	      _inheritsLoose(WithPropsOnChange, _Component);
	
	      function WithPropsOnChange() {
	        var _this;
	
	        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        _this = _Component.call.apply(_Component, [this].concat(args)) || this;
	        _this.state = {
	          computedProps: propsMapper(_this.props),
	          prevProps: _this.props
	        };
	        return _this;
	      }
	
	      WithPropsOnChange.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
	        if (shouldMap(prevState.prevProps, nextProps)) {
	          return {
	            computedProps: propsMapper(nextProps),
	            prevProps: nextProps
	          };
	        }
	
	        return {
	          prevProps: nextProps
	        };
	      };
	
	      var _proto = WithPropsOnChange.prototype;
	
	      _proto.render = function render() {
	        return factory(_extends({}, this.props, this.state.computedProps));
	      };
	
	      return WithPropsOnChange;
	    }(React.Component);
	
	    reactLifecyclesCompat.polyfill(WithPropsOnChange);
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'withPropsOnChange'))(WithPropsOnChange);
	    }
	
	    return WithPropsOnChange;
	  };
	};
	
	var mapValues = function mapValues(obj, func) {
	  var result = {};
	  /* eslint-disable no-restricted-syntax */
	
	  for (var key in obj) {
	    if (obj.hasOwnProperty(key)) {
	      result[key] = func(obj[key], key);
	    }
	  }
	  /* eslint-enable no-restricted-syntax */
	
	
	  return result;
	};
	
	var withHandlers = function withHandlers(handlers) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	
	    var WithHandlers =
	    /*#__PURE__*/
	    function (_Component) {
	      _inheritsLoose(WithHandlers, _Component);
	
	      function WithHandlers() {
	        var _this;
	
	        for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
	          _args[_key] = arguments[_key];
	        }
	
	        _this = _Component.call.apply(_Component, [this].concat(_args)) || this;
	        _this.handlers = mapValues(typeof handlers === 'function' ? handlers(_this.props) : handlers, function (createHandler) {
	          return function () {
	            var handler = createHandler(_this.props);
	
	            if (false) {
	              console.error( // eslint-disable-line no-console
	              'withHandlers(): Expected a map of higher-order functions. ' + 'Refer to the docs for more info.');
	            }
	
	            return handler.apply(void 0, arguments);
	          };
	        });
	        return _this;
	      }
	
	      var _proto = WithHandlers.prototype;
	
	      _proto.render = function render() {
	        return factory(_extends({}, this.props, this.handlers));
	      };
	
	      return WithHandlers;
	    }(React.Component);
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'withHandlers'))(WithHandlers);
	    }
	
	    return WithHandlers;
	  };
	};
	
	var defaultProps = function defaultProps(props) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	
	    var DefaultProps = function DefaultProps(ownerProps) {
	      return factory(ownerProps);
	    };
	
	    DefaultProps.defaultProps = props;
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'defaultProps'))(DefaultProps);
	    }
	
	    return DefaultProps;
	  };
	};
	
	var omit = function omit(obj, keys) {
	  var rest = _extends({}, obj);
	
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	
	    if (rest.hasOwnProperty(key)) {
	      delete rest[key];
	    }
	  }
	
	  return rest;
	};
	
	var renameProp = function renameProp(oldName, newName) {
	  var hoc = mapProps(function (props) {
	    var _extends2;
	
	    return _extends({}, omit(props, [oldName]), (_extends2 = {}, _extends2[newName] = props[oldName], _extends2));
	  });
	
	  if (false) {
	    return function (BaseComponent) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'renameProp'))(hoc(BaseComponent));
	    };
	  }
	
	  return hoc;
	};
	
	var keys = Object.keys;
	
	var mapKeys = function mapKeys(obj, func) {
	  return keys(obj).reduce(function (result, key) {
	    var val = obj[key];
	    /* eslint-disable no-param-reassign */
	
	    result[func(val, key)] = val;
	    /* eslint-enable no-param-reassign */
	
	    return result;
	  }, {});
	};
	
	var renameProps = function renameProps(nameMap) {
	  var hoc = mapProps(function (props) {
	    return _extends({}, omit(props, keys(nameMap)), mapKeys(pick(props, keys(nameMap)), function (_, oldName) {
	      return nameMap[oldName];
	    }));
	  });
	
	  if (false) {
	    return function (BaseComponent) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'renameProps'))(hoc(BaseComponent));
	    };
	  }
	
	  return hoc;
	};
	
	var flattenProp = function flattenProp(propName) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	
	    var FlattenProp = function FlattenProp(props) {
	      return factory(_extends({}, props, props[propName]));
	    };
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'flattenProp'))(FlattenProp);
	    }
	
	    return FlattenProp;
	  };
	};
	
	var withState = function withState(stateName, stateUpdaterName, initialState) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	
	    var WithState =
	    /*#__PURE__*/
	    function (_Component) {
	      _inheritsLoose(WithState, _Component);
	
	      function WithState() {
	        var _this;
	
	        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        _this = _Component.call.apply(_Component, [this].concat(args)) || this;
	        _this.state = {
	          stateValue: typeof initialState === 'function' ? initialState(_this.props) : initialState
	        };
	
	        _this.updateStateValue = function (updateFn, callback) {
	          return _this.setState(function (_ref) {
	            var stateValue = _ref.stateValue;
	            return {
	              stateValue: typeof updateFn === 'function' ? updateFn(stateValue) : updateFn
	            };
	          }, callback);
	        };
	
	        return _this;
	      }
	
	      var _proto = WithState.prototype;
	
	      _proto.render = function render() {
	        var _extends2;
	
	        return factory(_extends({}, this.props, (_extends2 = {}, _extends2[stateName] = this.state.stateValue, _extends2[stateUpdaterName] = this.updateStateValue, _extends2)));
	      };
	
	      return WithState;
	    }(React.Component);
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'withState'))(WithState);
	    }
	
	    return WithState;
	  };
	};
	
	var withStateHandlers = function withStateHandlers(initialState, stateUpdaters) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	
	    var WithStateHandlers =
	    /*#__PURE__*/
	    function (_Component) {
	      _inheritsLoose(WithStateHandlers, _Component);
	
	      function WithStateHandlers() {
	        var _this;
	
	        for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
	          _args[_key] = arguments[_key];
	        }
	
	        _this = _Component.call.apply(_Component, [this].concat(_args)) || this;
	        _this.state = typeof initialState === 'function' ? initialState(_this.props) : initialState;
	        _this.stateUpdaters = mapValues(stateUpdaters, function (handler) {
	          return function (mayBeEvent) {
	            for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	              args[_key2 - 1] = arguments[_key2];
	            }
	
	            // Having that functional form of setState can be called async
	            // we need to persist SyntheticEvent
	            if (mayBeEvent && typeof mayBeEvent.persist === 'function') {
	              mayBeEvent.persist();
	            }
	
	            _this.setState(function (state, props) {
	              return handler(state, props).apply(void 0, [mayBeEvent].concat(args));
	            });
	          };
	        });
	        return _this;
	      }
	
	      var _proto = WithStateHandlers.prototype;
	
	      _proto.render = function render() {
	        return factory(_extends({}, this.props, this.state, this.stateUpdaters));
	      };
	
	      return WithStateHandlers;
	    }(React.Component);
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'withStateHandlers'))(WithStateHandlers);
	    }
	
	    return WithStateHandlers;
	  };
	};
	
	var noop = function noop() {};
	
	var withReducer = function withReducer(stateName, dispatchName, reducer, initialState) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	
	    var WithReducer =
	    /*#__PURE__*/
	    function (_Component) {
	      _inheritsLoose(WithReducer, _Component);
	
	      function WithReducer() {
	        var _this;
	
	        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        _this = _Component.call.apply(_Component, [this].concat(args)) || this;
	        _this.state = {
	          stateValue: _this.initializeStateValue()
	        };
	
	        _this.dispatch = function (action, callback) {
	          if (callback === void 0) {
	            callback = noop;
	          }
	
	          return _this.setState(function (_ref) {
	            var stateValue = _ref.stateValue;
	            return {
	              stateValue: reducer(stateValue, action)
	            };
	          }, function () {
	            return callback(_this.state.stateValue);
	          });
	        };
	
	        return _this;
	      }
	
	      var _proto = WithReducer.prototype;
	
	      _proto.initializeStateValue = function initializeStateValue() {
	        if (initialState !== undefined) {
	          return typeof initialState === 'function' ? initialState(this.props) : initialState;
	        }
	
	        return reducer(undefined, {
	          type: '@@recompose/INIT'
	        });
	      };
	
	      _proto.render = function render() {
	        var _extends2;
	
	        return factory(_extends({}, this.props, (_extends2 = {}, _extends2[stateName] = this.state.stateValue, _extends2[dispatchName] = this.dispatch, _extends2)));
	      };
	
	      return WithReducer;
	    }(React.Component);
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'withReducer'))(WithReducer);
	    }
	
	    return WithReducer;
	  };
	};
	
	var identity = function identity(Component) {
	  return Component;
	};
	
	var branch = function branch(test, left, right) {
	  if (right === void 0) {
	    right = identity;
	  }
	
	  return function (BaseComponent) {
	    var leftFactory;
	    var rightFactory;
	
	    var Branch = function Branch(props) {
	      if (test(props)) {
	        leftFactory = leftFactory || React.createFactory(left(BaseComponent));
	        return leftFactory(props);
	      }
	
	      rightFactory = rightFactory || React.createFactory(right(BaseComponent));
	      return rightFactory(props);
	    };
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'branch'))(Branch);
	    }
	
	    return Branch;
	  };
	};
	
	var renderComponent = function renderComponent(Component) {
	  return function (_) {
	    var factory = React.createFactory(Component);
	
	    var RenderComponent = function RenderComponent(props) {
	      return factory(props);
	    };
	
	    if (false) {
	      RenderComponent.displayName = wrapDisplayName(Component, 'renderComponent');
	    }
	
	    return RenderComponent;
	  };
	};
	
	var Nothing =
	/*#__PURE__*/
	function (_Component) {
	  _inheritsLoose(Nothing, _Component);
	
	  function Nothing() {
	    return _Component.apply(this, arguments) || this;
	  }
	
	  var _proto = Nothing.prototype;
	
	  _proto.render = function render() {
	    return null;
	  };
	
	  return Nothing;
	}(React.Component);
	
	var renderNothing = function renderNothing(_) {
	  return Nothing;
	};
	
	var shouldUpdate = function shouldUpdate(test) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	
	    var ShouldUpdate =
	    /*#__PURE__*/
	    function (_Component) {
	      _inheritsLoose(ShouldUpdate, _Component);
	
	      function ShouldUpdate() {
	        return _Component.apply(this, arguments) || this;
	      }
	
	      var _proto = ShouldUpdate.prototype;
	
	      _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return test(this.props, nextProps);
	      };
	
	      _proto.render = function render() {
	        return factory(this.props);
	      };
	
	      return ShouldUpdate;
	    }(React.Component);
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'shouldUpdate'))(ShouldUpdate);
	    }
	
	    return ShouldUpdate;
	  };
	};
	
	var pure = function pure(BaseComponent) {
	  var hoc = shouldUpdate(function (props, nextProps) {
	    return !shallowEqual(props, nextProps);
	  });
	
	  if (false) {
	    return setDisplayName(wrapDisplayName(BaseComponent, 'pure'))(hoc(BaseComponent));
	  }
	
	  return hoc(BaseComponent);
	};
	
	var onlyUpdateForKeys = function onlyUpdateForKeys(propKeys) {
	  var hoc = shouldUpdate(function (props, nextProps) {
	    return !shallowEqual(pick(nextProps, propKeys), pick(props, propKeys));
	  });
	
	  if (false) {
	    return function (BaseComponent) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'onlyUpdateForKeys'))(hoc(BaseComponent));
	    };
	  }
	
	  return hoc;
	};
	
	var onlyUpdateForPropTypes = function onlyUpdateForPropTypes(BaseComponent) {
	  var propTypes = BaseComponent.propTypes;
	
	  if (false) {
	    if (!propTypes) {
	      /* eslint-disable */
	      console.error('A component without any `propTypes` was passed to ' + '`onlyUpdateForPropTypes()`. Check the implementation of the ' + ("component with display name \"" + getDisplayName(BaseComponent) + "\"."));
	      /* eslint-enable */
	    }
	  }
	
	  var propKeys = Object.keys(propTypes || {});
	  var OnlyUpdateForPropTypes = onlyUpdateForKeys(propKeys)(BaseComponent);
	
	  if (false) {
	    return setDisplayName(wrapDisplayName(BaseComponent, 'onlyUpdateForPropTypes'))(OnlyUpdateForPropTypes);
	  }
	
	  return OnlyUpdateForPropTypes;
	};
	
	var withContext = function withContext(childContextTypes, getChildContext) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	
	    var WithContext =
	    /*#__PURE__*/
	    function (_Component) {
	      _inheritsLoose(WithContext, _Component);
	
	      function WithContext() {
	        var _this;
	
	        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        _this = _Component.call.apply(_Component, [this].concat(args)) || this;
	
	        _this.getChildContext = function () {
	          return getChildContext(_this.props);
	        };
	
	        return _this;
	      }
	
	      var _proto = WithContext.prototype;
	
	      _proto.render = function render() {
	        return factory(this.props);
	      };
	
	      return WithContext;
	    }(React.Component);
	
	    WithContext.childContextTypes = childContextTypes;
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'withContext'))(WithContext);
	    }
	
	    return WithContext;
	  };
	};
	
	var getContext = function getContext(contextTypes) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	
	    var GetContext = function GetContext(ownerProps, context) {
	      return factory(_extends({}, ownerProps, context));
	    };
	
	    GetContext.contextTypes = contextTypes;
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'getContext'))(GetContext);
	    }
	
	    return GetContext;
	  };
	};
	
	var lifecycle = function lifecycle(spec) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	
	    if (false) {
	      console.error('lifecycle() does not support the render method; its behavior is to ' + 'pass all props and state to the base component.');
	    }
	
	    var Lifecycle =
	    /*#__PURE__*/
	    function (_Component) {
	      _inheritsLoose(Lifecycle, _Component);
	
	      function Lifecycle() {
	        return _Component.apply(this, arguments) || this;
	      }
	
	      var _proto = Lifecycle.prototype;
	
	      _proto.render = function render() {
	        return factory(_extends({}, this.props, this.state));
	      };
	
	      return Lifecycle;
	    }(React.Component);
	
	    Object.keys(spec).forEach(function (hook) {
	      return Lifecycle.prototype[hook] = spec[hook];
	    });
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'lifecycle'))(Lifecycle);
	    }
	
	    return Lifecycle;
	  };
	};
	
	var isClassComponent = function isClassComponent(Component) {
	  return Boolean(Component && Component.prototype && typeof Component.prototype.render === 'function');
	};
	
	var toClass = function toClass(baseComponent) {
	  var _class, _temp;
	
	  return isClassComponent(baseComponent) ? baseComponent : (_temp = _class =
	  /*#__PURE__*/
	  function (_Component) {
	    _inheritsLoose(ToClass, _Component);
	
	    function ToClass() {
	      return _Component.apply(this, arguments) || this;
	    }
	
	    var _proto = ToClass.prototype;
	
	    _proto.render = function render() {
	      if (typeof baseComponent === 'string') {
	        return React__default.createElement(baseComponent, this.props);
	      }
	
	      return baseComponent(this.props, this.context);
	    };
	
	    return ToClass;
	  }(React.Component), _class.displayName = getDisplayName(baseComponent), _class.propTypes = baseComponent.propTypes, _class.contextTypes = baseComponent.contextTypes, _class.defaultProps = baseComponent.defaultProps, _temp);
	};
	
	function toRenderProps(hoc) {
	  var RenderPropsComponent = function RenderPropsComponent(props) {
	    return props.children(props);
	  };
	
	  return hoc(RenderPropsComponent);
	}
	
	var fromRenderProps = function fromRenderProps(RenderPropsComponent, propsMapper, renderPropName) {
	  if (renderPropName === void 0) {
	    renderPropName = 'children';
	  }
	
	  return function (BaseComponent) {
	    var baseFactory = React__default.createFactory(BaseComponent);
	    var renderPropsFactory = React__default.createFactory(RenderPropsComponent);
	
	    var FromRenderProps = function FromRenderProps(ownerProps) {
	      var _renderPropsFactory;
	
	      return renderPropsFactory((_renderPropsFactory = {}, _renderPropsFactory[renderPropName] = function () {
	        return baseFactory(_extends({}, ownerProps, propsMapper.apply(void 0, arguments)));
	      }, _renderPropsFactory));
	    };
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'fromRenderProps'))(FromRenderProps);
	    }
	
	    return FromRenderProps;
	  };
	};
	
	var setPropTypes = function setPropTypes(propTypes) {
	  return setStatic('propTypes', propTypes);
	};
	
	var compose = function compose() {
	  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(void 0, arguments));
	    };
	  }, function (arg) {
	    return arg;
	  });
	};
	
	var createSink = function createSink(callback) {
	  var Sink =
	  /*#__PURE__*/
	  function (_Component) {
	    _inheritsLoose(Sink, _Component);
	
	    function Sink() {
	      var _this;
	
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      _this = _Component.call.apply(_Component, [this].concat(args)) || this;
	      _this.state = {};
	      return _this;
	    }
	
	    Sink.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps) {
	      callback(nextProps);
	      return null;
	    };
	
	    var _proto = Sink.prototype;
	
	    _proto.render = function render() {
	      return null;
	    };
	
	    return Sink;
	  }(React.Component);
	
	  reactLifecyclesCompat.polyfill(Sink);
	  return Sink;
	};
	
	var componentFromProp = function componentFromProp(propName) {
	  var Component = function Component(props) {
	    return React.createElement(props[propName], omit(props, [propName]));
	  };
	
	  Component.displayName = "componentFromProp(" + propName + ")";
	  return Component;
	};
	
	var nest = function nest() {
	  for (var _len = arguments.length, Components = new Array(_len), _key = 0; _key < _len; _key++) {
	    Components[_key] = arguments[_key];
	  }
	
	  var factories = Components.map(React.createFactory);
	
	  var Nest = function Nest(_ref) {
	    var children = _ref.children,
	        props = _objectWithoutPropertiesLoose(_ref, ["children"]);
	
	    return factories.reduceRight(function (child, factory) {
	      return factory(props, child);
	    }, children);
	  };
	
	  if (false) {
	    var displayNames = Components.map(getDisplayName);
	    Nest.displayName = "nest(" + displayNames.join(', ') + ")";
	  }
	
	  return Nest;
	};
	
	var hoistStatics = function hoistStatics(higherOrderComponent, blacklist) {
	  return function (BaseComponent) {
	    var NewComponent = higherOrderComponent(BaseComponent);
	    hoistNonReactStatics(NewComponent, BaseComponent, blacklist);
	    return NewComponent;
	  };
	};
	
	var _config = {
	  fromESObservable: null,
	  toESObservable: null
	};
	
	var configureObservable = function configureObservable(c) {
	  _config = c;
	};
	
	var config = {
	  fromESObservable: function fromESObservable(observable) {
	    return typeof _config.fromESObservable === 'function' ? _config.fromESObservable(observable) : observable;
	  },
	  toESObservable: function toESObservable(stream) {
	    return typeof _config.toESObservable === 'function' ? _config.toESObservable(stream) : stream;
	  }
	};
	
	var componentFromStreamWithConfig = function componentFromStreamWithConfig(config$$1) {
	  return function (propsToVdom) {
	    return (
	      /*#__PURE__*/
	      function (_Component) {
	        _inheritsLoose(ComponentFromStream, _Component);
	
	        function ComponentFromStream() {
	          var _config$fromESObserva;
	
	          var _this;
	
	          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	          }
	
	          _this = _Component.call.apply(_Component, [this].concat(args)) || this;
	          _this.state = {
	            vdom: null
	          };
	          _this.propsEmitter = changeEmitter.createChangeEmitter();
	          _this.props$ = config$$1.fromESObservable((_config$fromESObserva = {
	            subscribe: function subscribe(observer) {
	              var unsubscribe = _this.propsEmitter.listen(function (props) {
	                if (props) {
	                  observer.next(props);
	                } else {
	                  observer.complete();
	                }
	              });
	
	              return {
	                unsubscribe: unsubscribe
	              };
	            }
	          }, _config$fromESObserva[$$observable] = function () {
	            return this;
	          }, _config$fromESObserva));
	          _this.vdom$ = config$$1.toESObservable(propsToVdom(_this.props$));
	          return _this;
	        }
	
	        var _proto = ComponentFromStream.prototype;
	
	        _proto.componentWillMount = function componentWillMount() {
	          var _this2 = this;
	
	          // Subscribe to child prop changes so we know when to re-render
	          this.subscription = this.vdom$.subscribe({
	            next: function next(vdom) {
	              _this2.setState({
	                vdom: vdom
	              });
	            }
	          });
	          this.propsEmitter.emit(this.props);
	        };
	
	        _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	          // Receive new props from the owner
	          this.propsEmitter.emit(nextProps);
	        };
	
	        _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
	          return nextState.vdom !== this.state.vdom;
	        };
	
	        _proto.componentWillUnmount = function componentWillUnmount() {
	          // Call without arguments to complete stream
	          this.propsEmitter.emit(); // Clean-up subscription before un-mounting
	
	          this.subscription.unsubscribe();
	        };
	
	        _proto.render = function render() {
	          return this.state.vdom;
	        };
	
	        return ComponentFromStream;
	      }(React.Component)
	    );
	  };
	};
	
	var componentFromStream = function componentFromStream(propsToVdom) {
	  return componentFromStreamWithConfig(config)(propsToVdom);
	};
	
	var identity$1 = function identity(t) {
	  return t;
	};
	
	var mapPropsStreamWithConfig = function mapPropsStreamWithConfig(config$$1) {
	  var componentFromStream$$1 = componentFromStreamWithConfig({
	    fromESObservable: identity$1,
	    toESObservable: identity$1
	  });
	  return function (transform) {
	    return function (BaseComponent) {
	      var factory = React.createFactory(BaseComponent);
	      var fromESObservable = config$$1.fromESObservable,
	          toESObservable = config$$1.toESObservable;
	      return componentFromStream$$1(function (props$) {
	        var _ref;
	
	        return _ref = {
	          subscribe: function subscribe(observer) {
	            var subscription = toESObservable(transform(fromESObservable(props$))).subscribe({
	              next: function next(childProps) {
	                return observer.next(factory(childProps));
	              }
	            });
	            return {
	              unsubscribe: function unsubscribe() {
	                return subscription.unsubscribe();
	              }
	            };
	          }
	        }, _ref[$$observable] = function () {
	          return this;
	        }, _ref;
	      });
	    };
	  };
	};
	
	var mapPropsStream = function mapPropsStream(transform) {
	  var hoc = mapPropsStreamWithConfig(config)(transform);
	
	  if (false) {
	    return function (BaseComponent) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'mapPropsStream'))(hoc(BaseComponent));
	    };
	  }
	
	  return hoc;
	};
	
	var createEventHandlerWithConfig = function createEventHandlerWithConfig(config$$1) {
	  return function () {
	    var _config$fromESObserva;
	
	    var emitter = changeEmitter.createChangeEmitter();
	    var stream = config$$1.fromESObservable((_config$fromESObserva = {
	      subscribe: function subscribe(observer) {
	        var unsubscribe = emitter.listen(function (value) {
	          return observer.next(value);
	        });
	        return {
	          unsubscribe: unsubscribe
	        };
	      }
	    }, _config$fromESObserva[$$observable] = function () {
	      return this;
	    }, _config$fromESObserva));
	    return {
	      handler: emitter.emit,
	      stream: stream
	    };
	  };
	};
	var createEventHandler = createEventHandlerWithConfig(config);
	
	// Higher-order component helpers
	
	exports.mapProps = mapProps;
	exports.withProps = withProps;
	exports.withPropsOnChange = withPropsOnChange;
	exports.withHandlers = withHandlers;
	exports.defaultProps = defaultProps;
	exports.renameProp = renameProp;
	exports.renameProps = renameProps;
	exports.flattenProp = flattenProp;
	exports.withState = withState;
	exports.withStateHandlers = withStateHandlers;
	exports.withReducer = withReducer;
	exports.branch = branch;
	exports.renderComponent = renderComponent;
	exports.renderNothing = renderNothing;
	exports.shouldUpdate = shouldUpdate;
	exports.pure = pure;
	exports.onlyUpdateForKeys = onlyUpdateForKeys;
	exports.onlyUpdateForPropTypes = onlyUpdateForPropTypes;
	exports.withContext = withContext;
	exports.getContext = getContext;
	exports.lifecycle = lifecycle;
	exports.toClass = toClass;
	exports.toRenderProps = toRenderProps;
	exports.fromRenderProps = fromRenderProps;
	exports.setStatic = setStatic;
	exports.setPropTypes = setPropTypes;
	exports.setDisplayName = setDisplayName;
	exports.compose = compose;
	exports.getDisplayName = getDisplayName;
	exports.wrapDisplayName = wrapDisplayName;
	exports.shallowEqual = shallowEqual;
	exports.isClassComponent = isClassComponent;
	exports.createSink = createSink;
	exports.componentFromProp = componentFromProp;
	exports.nest = nest;
	exports.hoistStatics = hoistStatics;
	exports.componentFromStream = componentFromStream;
	exports.componentFromStreamWithConfig = componentFromStreamWithConfig;
	exports.mapPropsStream = mapPropsStream;
	exports.mapPropsStreamWithConfig = mapPropsStreamWithConfig;
	exports.createEventHandler = createEventHandler;
	exports.createEventHandlerWithConfig = createEventHandlerWithConfig;
	exports.setObservableConfig = configureObservable;


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.tileProps = exports.tileGroupProps = exports.isView = exports.isClassName = exports.isViews = exports.isValue = exports.isMaxDate = exports.isMinDate = exports.isCalendarType = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	var calendarTypes = ['ISO 8601', 'US', 'Arabic', 'Hebrew'];
	var allViews = ['century', 'decade', 'year', 'month'];
	
	var isCalendarType = _propTypes["default"].oneOf(calendarTypes);
	
	exports.isCalendarType = isCalendarType;
	
	var isMinDate = function isMinDate(props, propName, componentName) {
	  var minDate = props[propName];
	
	  if (minDate) {
	    if (!(minDate instanceof Date)) {
	      return new Error("Invalid prop `".concat(propName, "` of type `").concat(_typeof(minDate), "` supplied to `").concat(componentName, "`, expected instance of `Date`."));
	    }
	
	    var maxDate = props.maxDate;
	
	    if (maxDate && minDate > maxDate) {
	      return new Error("Invalid prop `".concat(propName, "` of type `").concat(_typeof(minDate), "` supplied to `").concat(componentName, "`, minDate cannot be larger than maxDate."));
	    }
	  } // Everything is fine
	
	
	  return null;
	};
	
	exports.isMinDate = isMinDate;
	
	var isMaxDate = function isMaxDate(props, propName, componentName) {
	  var maxDate = props[propName];
	
	  if (maxDate) {
	    if (!(maxDate instanceof Date)) {
	      return new Error("Invalid prop `".concat(propName, "` of type `").concat(_typeof(maxDate), "` supplied to `").concat(componentName, "`, expected instance of `Date`."));
	    }
	
	    var minDate = props.minDate;
	
	    if (minDate && maxDate < minDate) {
	      return new Error("Invalid prop `".concat(propName, "` of type `").concat(_typeof(maxDate), "` supplied to `").concat(componentName, "`, maxDate cannot be smaller than minDate."));
	    }
	  } // Everything is fine
	
	
	  return null;
	};
	
	exports.isMaxDate = isMaxDate;
	
	var isValue = _propTypes["default"].oneOfType([_propTypes["default"].instanceOf(Date), _propTypes["default"].arrayOf(_propTypes["default"].instanceOf(Date))]);
	
	exports.isValue = isValue;
	
	var isViews = _propTypes["default"].arrayOf(_propTypes["default"].oneOf(allViews));
	
	exports.isViews = isViews;
	
	var isClassName = _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].arrayOf(_propTypes["default"].string)]);
	
	exports.isClassName = isClassName;
	
	var isView = function isView(props, propName, componentName) {
	  var view = props[propName];
	  var views = props.views;
	  var allowedViews = views || allViews;
	
	  if (view !== undefined && allowedViews.indexOf(view) === -1) {
	    return new Error("Invalid prop `".concat(propName, "` of value `").concat(view, "` supplied to `").concat(componentName, "`, expected one of [").concat(allowedViews.map(function (a) {
	      return "\"".concat(a, "\"");
	    }).join(', '), "]."));
	  } // Everything is fine
	
	
	  return null;
	};
	
	exports.isView = isView;
	
	isView.isRequired = function (props, propName, componentName) {
	  var view = props[propName];
	
	  if (!view) {
	    return new Error("The prop `".concat(propName, "` is marked as required in `").concat(componentName, "`, but its value is `").concat(view, "`."));
	  }
	
	  return isView(props, propName, componentName);
	};
	
	var tileGroupProps = {
	  activeStartDate: _propTypes["default"].instanceOf(Date).isRequired,
	  hover: _propTypes["default"].instanceOf(Date),
	  locale: _propTypes["default"].string,
	  maxDate: isMaxDate,
	  minDate: isMinDate,
	  onClick: _propTypes["default"].func,
	  onMouseOver: _propTypes["default"].func,
	  tileClassName: _propTypes["default"].oneOfType([_propTypes["default"].func, isClassName]),
	  tileContent: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].node]),
	  value: isValue,
	  valueType: _propTypes["default"].string
	};
	exports.tileGroupProps = tileGroupProps;
	var tileProps = {
	  activeStartDate: _propTypes["default"].instanceOf(Date).isRequired,
	  classes: _propTypes["default"].arrayOf(_propTypes["default"].string).isRequired,
	  date: _propTypes["default"].instanceOf(Date).isRequired,
	  locale: _propTypes["default"].string,
	  maxDate: isMaxDate,
	  minDate: isMinDate,
	  onClick: _propTypes["default"].func,
	  onMouseOver: _propTypes["default"].func,
	  style: _propTypes["default"].objectOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])),
	  tileClassName: _propTypes["default"].oneOfType([_propTypes["default"].func, isClassName]),
	  tileContent: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].node]),
	  tileDisabled: _propTypes["default"].func
	};
	exports.tileProps = tileProps;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ui = __webpack_require__(160);
	
	Object.defineProperty(exports, "uiStartLoading", {
	  enumerable: true,
	  get: function get() {
	    return _ui.uiStartLoading;
	  }
	});
	Object.defineProperty(exports, "uiStopLoading", {
	  enumerable: true,
	  get: function get() {
	    return _ui.uiStopLoading;
	  }
	});
	Object.defineProperty(exports, "uiHideBar", {
	  enumerable: true,
	  get: function get() {
	    return _ui.uiHideBar;
	  }
	});
	Object.defineProperty(exports, "uiShowBar", {
	  enumerable: true,
	  get: function get() {
	    return _ui.uiShowBar;
	  }
	});
	Object.defineProperty(exports, "editModeOn", {
	  enumerable: true,
	  get: function get() {
	    return _ui.editModeOn;
	  }
	});
	Object.defineProperty(exports, "editModeOff", {
	  enumerable: true,
	  get: function get() {
	    return _ui.editModeOff;
	  }
	});
	Object.defineProperty(exports, "pullRefreshOn", {
	  enumerable: true,
	  get: function get() {
	    return _ui.pullRefreshOn;
	  }
	});
	Object.defineProperty(exports, "pullRefreshOff", {
	  enumerable: true,
	  get: function get() {
	    return _ui.pullRefreshOff;
	  }
	});
	Object.defineProperty(exports, "setUiFlag", {
	  enumerable: true,
	  get: function get() {
	    return _ui.setUiFlag;
	  }
	});
	
	var _db = __webpack_require__(357);
	
	Object.defineProperty(exports, "fetchRecords", {
	  enumerable: true,
	  get: function get() {
	    return _db.fetchRecords;
	  }
	});
	Object.defineProperty(exports, "addRecord", {
	  enumerable: true,
	  get: function get() {
	    return _db.addRecord;
	  }
	});
	Object.defineProperty(exports, "updateRecord", {
	  enumerable: true,
	  get: function get() {
	    return _db.updateRecord;
	  }
	});
	Object.defineProperty(exports, "deleteRecord", {
	  enumerable: true,
	  get: function get() {
	    return _db.deleteRecord;
	  }
	});
	Object.defineProperty(exports, "selectARecord", {
	  enumerable: true,
	  get: function get() {
	    return _db.selectARecord;
	  }
	});
	Object.defineProperty(exports, "initSelectedRecord", {
	  enumerable: true,
	  get: function get() {
	    return _db.initSelectedRecord;
	  }
	});
	Object.defineProperty(exports, "resetRedux", {
	  enumerable: true,
	  get: function get() {
	    return _db.resetRedux;
	  }
	});
	Object.defineProperty(exports, "actionAddSingleRecord", {
	  enumerable: true,
	  get: function get() {
	    return _db.actionAddSingleRecord;
	  }
	});
	Object.defineProperty(exports, "actionAddArray2Redux", {
	  enumerable: true,
	  get: function get() {
	    return _db.actionAddArray2Redux;
	  }
	});
	Object.defineProperty(exports, "actionAddRecord2Redux", {
	  enumerable: true,
	  get: function get() {
	    return _db.actionAddRecord2Redux;
	  }
	});
	Object.defineProperty(exports, "actionUpdateRecord2Redux", {
	  enumerable: true,
	  get: function get() {
	    return _db.actionUpdateRecord2Redux;
	  }
	});
	Object.defineProperty(exports, "fetchStats", {
	  enumerable: true,
	  get: function get() {
	    return _db.fetchStats;
	  }
	});
	Object.defineProperty(exports, "linkTable", {
	  enumerable: true,
	  get: function get() {
	    return _db.linkTable;
	  }
	});
	Object.defineProperty(exports, "loadAllStats", {
	  enumerable: true,
	  get: function get() {
	    return _db.loadAllStats;
	  }
	});
	Object.defineProperty(exports, "getId", {
	  enumerable: true,
	  get: function get() {
	    return _db.getId;
	  }
	});
	Object.defineProperty(exports, "getStatement", {
	  enumerable: true,
	  get: function get() {
	    return _db.getStatement;
	  }
	});
	Object.defineProperty(exports, "getStatementB64", {
	  enumerable: true,
	  get: function get() {
	    return _db.getStatementB64;
	  }
	});
	Object.defineProperty(exports, "setupUsers", {
	  enumerable: true,
	  get: function get() {
	    return _db.setupUsers;
	  }
	});
	Object.defineProperty(exports, "loadFbData", {
	  enumerable: true,
	  get: function get() {
	    return _db.loadFbData;
	  }
	});
	Object.defineProperty(exports, "notifyUsers", {
	  enumerable: true,
	  get: function get() {
	    return _db.notifyUsers;
	  }
	});
	Object.defineProperty(exports, "getAcctStatement", {
	  enumerable: true,
	  get: function get() {
	    return _db.getAcctStatement;
	  }
	});
	Object.defineProperty(exports, "getAcctBalance", {
	  enumerable: true,
	  get: function get() {
	    return _db.getAcctBalance;
	  }
	});
	Object.defineProperty(exports, "uploadPhoto", {
	  enumerable: true,
	  get: function get() {
	    return _db.uploadPhoto;
	  }
	});
	Object.defineProperty(exports, "deletePhoto", {
	  enumerable: true,
	  get: function get() {
	    return _db.deletePhoto;
	  }
	});
	Object.defineProperty(exports, "fetchDistance", {
	  enumerable: true,
	  get: function get() {
	    return _db.fetchDistance;
	  }
	});
	Object.defineProperty(exports, "initialFetch", {
	  enumerable: true,
	  get: function get() {
	    return _db.initialFetch;
	  }
	});
	Object.defineProperty(exports, "initialProductsFetch", {
	  enumerable: true,
	  get: function get() {
	    return _db.initialProductsFetch;
	  }
	});
	Object.defineProperty(exports, "reachApi", {
	  enumerable: true,
	  get: function get() {
	    return _db.reachApi;
	  }
	});
	Object.defineProperty(exports, "reachApiExtended", {
	  enumerable: true,
	  get: function get() {
	    return _db.reachApiExtended;
	  }
	});

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ }),
/* 15 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getYear = getYear;
	exports.getMonth = getMonth;
	exports.getMonthIndex = getMonthIndex;
	exports.getDay = getDay;
	exports.getDayOfWeek = getDayOfWeek;
	exports.getBeginOfCenturyYear = getBeginOfCenturyYear;
	exports.getBeginOfCentury = getBeginOfCentury;
	exports.getEndOfCentury = getEndOfCentury;
	exports.getCenturyRange = getCenturyRange;
	exports.getBeginOfPreviousCentury = getBeginOfPreviousCentury;
	exports.getEndOfPreviousCentury = getEndOfPreviousCentury;
	exports.getBeginOfNextCentury = getBeginOfNextCentury;
	exports.getBeginOfDecadeYear = getBeginOfDecadeYear;
	exports.getBeginOfDecade = getBeginOfDecade;
	exports.getEndOfDecade = getEndOfDecade;
	exports.getDecadeRange = getDecadeRange;
	exports.getBeginOfPreviousDecade = getBeginOfPreviousDecade;
	exports.getEndOfPreviousDecade = getEndOfPreviousDecade;
	exports.getBeginOfNextDecade = getBeginOfNextDecade;
	exports.getBeginOfYear = getBeginOfYear;
	exports.getEndOfYear = getEndOfYear;
	exports.getYearRange = getYearRange;
	exports.getBeginOfPreviousYear = getBeginOfPreviousYear;
	exports.getEndOfPreviousYear = getEndOfPreviousYear;
	exports.getBeginOfNextYear = getBeginOfNextYear;
	exports.getBeginOfMonth = getBeginOfMonth;
	exports.getEndOfMonth = getEndOfMonth;
	exports.getBeginOfWeek = getBeginOfWeek;
	exports.getMonthRange = getMonthRange;
	exports.getBeginOfPreviousMonth = getBeginOfPreviousMonth;
	exports.getEndOfPreviousMonth = getEndOfPreviousMonth;
	exports.getBeginOfNextMonth = getBeginOfNextMonth;
	exports.getBeginOfDay = getBeginOfDay;
	exports.getEndOfDay = getEndOfDay;
	exports.getDayRange = getDayRange;
	exports.getWeekNumber = getWeekNumber;
	exports.getBegin = getBegin;
	exports.getBeginPrevious = getBeginPrevious;
	exports.getBeginNext = getBeginNext;
	exports.getEnd = getEnd;
	exports.getEndPrevious = getEndPrevious;
	exports.getRange = getRange;
	exports.getValueRange = getValueRange;
	exports.getDaysInMonth = getDaysInMonth;
	exports.getCenturyLabel = getCenturyLabel;
	exports.getDecadeLabel = getDecadeLabel;
	exports.isWeekend = isWeekend;
	exports.getISOLocalMonth = getISOLocalMonth;
	exports.getISOLocalDate = getISOLocalDate;
	exports.getEndPrevious2 = exports.getBeginNext2 = exports.getBeginPrevious2 = void 0;
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }
	
	function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	var _map = _toConsumableArray(Array(7)).map(function (el, index) {
	  return index;
	}),
	    _map2 = _slicedToArray(_map, 7),
	    // eslint-disable-next-line no-unused-vars
	SUNDAY = _map2[0],
	    MONDAY = _map2[1],
	    TUESDAY = _map2[2],
	    WEDNESDAY = _map2[3],
	    THURSDAY = _map2[4],
	    FRIDAY = _map2[5],
	    SATURDAY = _map2[6];
	/* Simple getters - getting a property of a given point in time */
	
	
	function getYear(date) {
	  if (date instanceof Date) {
	    return date.getFullYear();
	  }
	
	  if (typeof date === 'number') {
	    return date;
	  }
	
	  var year = parseInt(date, 10);
	
	  if (typeof date === 'string' && !isNaN(year)) {
	    return year;
	  }
	
	  throw new Error("Failed to get year from date: ".concat(date, "."));
	}
	
	function getMonth(date) {
	  return date.getMonth() + 1;
	}
	
	function getMonthIndex(date) {
	  return date.getMonth();
	}
	
	function getDay(date) {
	  return date.getDate();
	}
	
	function getDayOfWeek(date) {
	  var calendarType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ISO 8601';
	  var weekday = date.getDay();
	
	  switch (calendarType) {
	    case 'ISO 8601':
	      // Shifts days of the week so that Monday is 0, Sunday is 6
	      return (weekday + 6) % 7;
	
	    case 'Arabic':
	      return (weekday + 1) % 7;
	
	    case 'Hebrew':
	    case 'US':
	      return weekday;
	
	    default:
	      throw new Error('Unsupported calendar type.');
	  }
	}
	/* Complex getters - getting a property somehow related to a given point in time */
	
	
	function getBeginOfCenturyYear(date) {
	  var year = getYear(date) - 1;
	  return year + -year % 100 + 1;
	}
	
	function getBeginOfCentury(date) {
	  var beginOfCenturyYear = getBeginOfCenturyYear(date);
	  return new Date(beginOfCenturyYear, 0, 1);
	}
	
	function getEndOfCentury(date) {
	  var beginOfCenturyYear = getBeginOfCenturyYear(date);
	  return new Date(beginOfCenturyYear + 100, 0, 1, 0, 0, 0, -1);
	}
	
	function getCenturyRange(date) {
	  return [getBeginOfCentury(date), getEndOfCentury(date)];
	}
	
	function getBeginOfPreviousCentury(date) {
	  var previousCenturyYear = getYear(date) - 100;
	  return getBeginOfCentury(previousCenturyYear);
	}
	
	function getEndOfPreviousCentury(date) {
	  var previousCenturyYear = getYear(date) - 100;
	  return getEndOfCentury(previousCenturyYear);
	}
	
	function getBeginOfNextCentury(date) {
	  var nextCenturyYear = getYear(date) + 100;
	  return getBeginOfCentury(nextCenturyYear);
	}
	
	function getBeginOfDecadeYear(date) {
	  var year = getYear(date) - 1;
	  return year + -year % 10 + 1;
	}
	
	function getBeginOfDecade(date) {
	  var beginOfDecadeYear = getBeginOfDecadeYear(date);
	  return new Date(beginOfDecadeYear, 0, 1);
	}
	
	function getEndOfDecade(date) {
	  var beginOfDecadeYear = getBeginOfDecadeYear(date);
	  return new Date(beginOfDecadeYear + 10, 0, 1, 0, 0, 0, -1);
	}
	
	function getDecadeRange(date) {
	  return [getBeginOfDecade(date), getEndOfDecade(date)];
	}
	
	function getBeginOfPreviousDecade(date) {
	  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
	  var previousDecadeYear = getBeginOfDecadeYear(date) - offset;
	  return getBeginOfDecade(previousDecadeYear);
	}
	
	function getEndOfPreviousDecade(date) {
	  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
	  var previousDecadeYear = getBeginOfDecadeYear(date) - offset;
	  return getEndOfDecade(previousDecadeYear);
	}
	
	function getBeginOfNextDecade(date) {
	  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
	  var nextDecadeYear = getBeginOfDecadeYear(date) + offset;
	  return getBeginOfDecade(nextDecadeYear);
	}
	/**
	 * Returns the beginning of a given year.
	 *
	 * @param {Date} date Date.
	 */
	
	
	function getBeginOfYear(date) {
	  var year = getYear(date);
	  return new Date(year, 0, 1);
	}
	/**
	 * Returns the end of a given year.
	 *
	 * @param {Date} date Date.
	 */
	
	
	function getEndOfYear(date) {
	  var year = getYear(date);
	  return new Date(year + 1, 0, 1, 0, 0, 0, -1);
	}
	/**
	 * Returns an array with the beginning and the end of a given year.
	 *
	 * @param {Date} date Date.
	 */
	
	
	function getYearRange(date) {
	  return [getBeginOfYear(date), getEndOfYear(date)];
	}
	
	function getBeginOfPreviousYear(date) {
	  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	  var previousYear = getYear(date) - offset;
	  return getBeginOfYear(previousYear);
	}
	
	function getEndOfPreviousYear(date) {
	  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	  var previousYear = getYear(date) - offset;
	  return getEndOfYear(previousYear);
	}
	
	function getBeginOfNextYear(date) {
	  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	  var nextYear = getYear(date) + offset;
	  return getBeginOfYear(nextYear);
	}
	/**
	 * Returns the beginning of a given month.
	 *
	 * @param {Date} date Date.
	 */
	
	
	function getBeginOfMonth(date) {
	  var year = getYear(date);
	  var monthIndex = getMonthIndex(date);
	  return new Date(year, monthIndex, 1);
	}
	/**
	 * Returns the end of a given month.
	 *
	 * @param {Date} date Date.
	 */
	
	
	function getEndOfMonth(date) {
	  var year = getYear(date);
	  var monthIndex = getMonthIndex(date);
	  return new Date(year, monthIndex + 1, 1, 0, 0, 0, -1);
	}
	/**
	 * Returns the beginning of a given week.
	 *
	 * @param {Date} date Date.
	 * @param {String} calendarType Calendar type. Can be ISO 8601 or US.
	 */
	
	
	function getBeginOfWeek(date) {
	  var calendarType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ISO 8601';
	  var year = getYear(date);
	  var monthIndex = getMonthIndex(date);
	  var day = date.getDate() - getDayOfWeek(date, calendarType);
	  return new Date(year, monthIndex, day);
	}
	/**
	 * Returns an array with the beginning and the end of a given month.
	 *
	 * @param {Date} date Date.
	 */
	
	
	function getMonthRange(date) {
	  return [getBeginOfMonth(date), getEndOfMonth(date)];
	}
	
	function getDifferentMonth(date, offset) {
	  var year = getYear(date);
	  var previousMonthIndex = getMonthIndex(date) + offset;
	  return new Date(year, previousMonthIndex, 1);
	}
	
	function getBeginOfPreviousMonth(date) {
	  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	  var previousMonth = getDifferentMonth(date, -offset);
	  return getBeginOfMonth(previousMonth);
	}
	
	function getEndOfPreviousMonth(date) {
	  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	  var previousMonth = getDifferentMonth(date, -offset);
	  return getEndOfMonth(previousMonth);
	}
	
	function getBeginOfNextMonth(date) {
	  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	  var nextMonth = getDifferentMonth(date, offset);
	  return getBeginOfMonth(nextMonth);
	}
	
	function getBeginOfDay(date) {
	  var year = getYear(date);
	  var monthIndex = getMonthIndex(date);
	  var day = getDay(date);
	  return new Date(year, monthIndex, day);
	}
	
	function getEndOfDay(date) {
	  var year = getYear(date);
	  var monthIndex = getMonthIndex(date);
	  var day = getDay(date);
	  return new Date(year, monthIndex, day + 1, 0, 0, 0, -1);
	}
	/**
	 * Returns an array with the beginning and the end of a given day.
	 *
	 * @param {Date} date Date.
	 */
	
	
	function getDayRange(date) {
	  return [getBeginOfDay(date), getEndOfDay(date)];
	}
	/**
	 * Gets week number according to ISO 8601 or US standard.
	 * In ISO 8601, Arabic and Hebrew week 1 is the one with January 4.
	 * In US calendar week 1 is the one with January 1.
	 *
	 * @param {Date} date Date.
	 * @param {String} calendarType Calendar type. Can be ISO 8601 or US.
	 */
	
	
	function getWeekNumber(date) {
	  var calendarType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ISO 8601';
	  var calendarTypeForWeekNumber = calendarType === 'US' ? 'US' : 'ISO 8601';
	  var beginOfWeek = getBeginOfWeek(date, calendarTypeForWeekNumber);
	  var year = getYear(date) + 1;
	  var dayInWeekOne;
	  var beginOfFirstWeek; // Look for the first week one that does not come after a given date
	
	  do {
	    dayInWeekOne = new Date(year, 0, calendarTypeForWeekNumber === 'ISO 8601' ? 4 : 1);
	    beginOfFirstWeek = getBeginOfWeek(dayInWeekOne, calendarTypeForWeekNumber);
	    year -= 1;
	  } while (date - beginOfFirstWeek < 0);
	
	  return Math.round((beginOfWeek - beginOfFirstWeek) / (8.64e7 * 7)) + 1;
	}
	/**
	 * Returns the beginning of a given range.
	 *
	 * @param {String} rangeType Range type (e.g. 'day')
	 * @param {Date} date Date.
	 */
	
	
	function getBegin(rangeType, date) {
	  switch (rangeType) {
	    case 'century':
	      return getBeginOfCentury(date);
	
	    case 'decade':
	      return getBeginOfDecade(date);
	
	    case 'year':
	      return getBeginOfYear(date);
	
	    case 'month':
	      return getBeginOfMonth(date);
	
	    case 'day':
	      return getBeginOfDay(date);
	
	    default:
	      throw new Error("Invalid rangeType: ".concat(rangeType));
	  }
	}
	
	function getBeginPrevious(rangeType, date) {
	  switch (rangeType) {
	    case 'century':
	      return getBeginOfPreviousCentury(date);
	
	    case 'decade':
	      return getBeginOfPreviousDecade(date);
	
	    case 'year':
	      return getBeginOfPreviousYear(date);
	
	    case 'month':
	      return getBeginOfPreviousMonth(date);
	
	    default:
	      throw new Error("Invalid rangeType: ".concat(rangeType));
	  }
	}
	
	function getBeginNext(rangeType, date) {
	  switch (rangeType) {
	    case 'century':
	      return getBeginOfNextCentury(date);
	
	    case 'decade':
	      return getBeginOfNextDecade(date);
	
	    case 'year':
	      return getBeginOfNextYear(date);
	
	    case 'month':
	      return getBeginOfNextMonth(date);
	
	    default:
	      throw new Error("Invalid rangeType: ".concat(rangeType));
	  }
	}
	
	var getBeginPrevious2 = function getBeginPrevious2(rangeType, date) {
	  switch (rangeType) {
	    case 'decade':
	      return getBeginOfPreviousDecade(date, 100);
	
	    case 'year':
	      return getBeginOfPreviousYear(date, 10);
	
	    case 'month':
	      return getBeginOfPreviousMonth(date, 12);
	
	    default:
	      throw new Error("Invalid rangeType: ".concat(rangeType));
	  }
	};
	
	exports.getBeginPrevious2 = getBeginPrevious2;
	
	var getBeginNext2 = function getBeginNext2(rangeType, date) {
	  switch (rangeType) {
	    case 'decade':
	      return getBeginOfNextDecade(date, 100);
	
	    case 'year':
	      return getBeginOfNextYear(date, 10);
	
	    case 'month':
	      return getBeginOfNextMonth(date, 12);
	
	    default:
	      throw new Error("Invalid rangeType: ".concat(rangeType));
	  }
	};
	/**
	 * Returns the end of a given range.
	 *
	 * @param {String} rangeType Range type (e.g. 'day')
	 * @param {Date} date Date.
	 */
	
	
	exports.getBeginNext2 = getBeginNext2;
	
	function getEnd(rangeType, date) {
	  switch (rangeType) {
	    case 'century':
	      return getEndOfCentury(date);
	
	    case 'decade':
	      return getEndOfDecade(date);
	
	    case 'year':
	      return getEndOfYear(date);
	
	    case 'month':
	      return getEndOfMonth(date);
	
	    case 'day':
	      return getEndOfDay(date);
	
	    default:
	      throw new Error("Invalid rangeType: ".concat(rangeType));
	  }
	}
	
	function getEndPrevious(rangeType, date) {
	  switch (rangeType) {
	    case 'century':
	      return getEndOfPreviousCentury(date);
	
	    case 'decade':
	      return getEndOfPreviousDecade(date);
	
	    case 'year':
	      return getEndOfPreviousYear(date);
	
	    case 'month':
	      return getEndOfPreviousMonth(date);
	
	    default:
	      throw new Error("Invalid rangeType: ".concat(rangeType));
	  }
	}
	
	var getEndPrevious2 = function getEndPrevious2(rangeType, date) {
	  switch (rangeType) {
	    case 'decade':
	      return getEndOfPreviousDecade(date, 100);
	
	    case 'year':
	      return getEndOfPreviousYear(date, 10);
	
	    case 'month':
	      return getEndOfPreviousMonth(date, 12);
	
	    default:
	      throw new Error("Invalid rangeType: ".concat(rangeType));
	  }
	};
	/**
	 * Returns an array with the beginning and the end of a given range.
	 *
	 * @param {String} rangeType Range type (e.g. 'day')
	 * @param {Date} date Date.
	 */
	
	
	exports.getEndPrevious2 = getEndPrevious2;
	
	function getRange(rangeType, date) {
	  switch (rangeType) {
	    case 'century':
	      return getCenturyRange(date);
	
	    case 'decade':
	      return getDecadeRange(date);
	
	    case 'year':
	      return getYearRange(date);
	
	    case 'month':
	      return getMonthRange(date);
	
	    case 'day':
	      return getDayRange(date);
	
	    default:
	      throw new Error("Invalid rangeType: ".concat(rangeType));
	  }
	}
	/**
	 * Creates a range out of two values, ensuring they are in order and covering entire period ranges.
	 *
	 * @param {String} rangeType Range type (e.g. 'day')
	 * @param {Date} date1 First date.
	 * @param {Date} date2 Second date.
	 */
	
	
	function getValueRange(rangeType, date1, date2) {
	  var rawNextValue = [date1, date2].sort(function (a, b) {
	    return a - b;
	  });
	  return [getBegin(rangeType, rawNextValue[0]), getEnd(rangeType, rawNextValue[1])];
	}
	/**
	 * Returns a number of days in a month of a given date.
	 *
	 * @param {Date} date Date.
	 */
	
	
	function getDaysInMonth(date) {
	  var year = getYear(date);
	  var monthIndex = getMonthIndex(date);
	  return new Date(year, monthIndex + 1, 0).getDate();
	}
	
	function toYearLabel(_ref) {
	  var _ref2 = _slicedToArray(_ref, 2),
	      start = _ref2[0],
	      end = _ref2[1];
	
	  return "".concat(getYear(start), " \u2013 ").concat(getYear(end));
	}
	/**
	 * Returns a string labelling a century of a given date.
	 * For example, for 2017 it will return 2001-2100.
	 *
	 * @param {Date|String|Number} date Date or a year as a string or as a number.
	 */
	
	
	function getCenturyLabel(date) {
	  return toYearLabel(getCenturyRange(date));
	}
	/**
	 * Returns a string labelling a century of a given date.
	 * For example, for 2017 it will return 2011-2020.
	 *
	 * @param {Date|String|Number} date Date or a year as a string or as a number.
	 */
	
	
	function getDecadeLabel(date) {
	  return toYearLabel(getDecadeRange(date));
	}
	/**
	 * Returns a boolean determining whether a given date is on Saturday or Sunday.
	 *
	 * @param {Date} date Date.
	 */
	
	
	function isWeekend(date) {
	  var calendarType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ISO 8601';
	  var weekday = date.getDay();
	
	  switch (calendarType) {
	    case 'Arabic':
	    case 'Hebrew':
	      return weekday === FRIDAY || weekday === SATURDAY;
	
	    case 'ISO 8601':
	    case 'US':
	      return weekday === SATURDAY || weekday === SUNDAY;
	
	    default:
	      throw new Error('Unsupported calendar type.');
	  }
	}
	/**
	 * Returns local month in ISO-like format (YYYY-MM).
	 */
	
	
	function getISOLocalMonth(value) {
	  if (!value) {
	    return value;
	  }
	
	  var date = new Date(value);
	
	  if (isNaN(date.getTime())) {
	    throw new Error("Invalid date: ".concat(value));
	  }
	
	  var year = getYear(date);
	  var month = "0".concat(getMonth(date)).slice(-2);
	  return "".concat(year, "-").concat(month);
	}
	/**
	 * Returns local date in ISO-like format (YYYY-MM-DD).
	 */
	
	
	function getISOLocalDate(value) {
	  if (!value) {
	    return value;
	  }
	
	  var date = new Date(value);
	
	  if (isNaN(date.getTime())) {
	    throw new Error("Invalid date: ".concat(value));
	  }
	
	  var year = getYear(date);
	  var month = "0".concat(getMonth(date)).slice(-2);
	  var day = "0".concat(getDay(date)).slice(-2);
	  return "".concat(year, "-").concat(month, "-").concat(day);
	}

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! @preserve
	 * numeral.js
	 * version : 2.0.6
	 * author : Adam Draper
	 * license : MIT
	 * http://adamwdraper.github.com/Numeral-js/
	 */
	
	(function (global, factory) {
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof module === 'object' && module.exports) {
	        module.exports = factory();
	    } else {
	        global.numeral = factory();
	    }
	}(this, function () {
	    /************************************
	        Variables
	    ************************************/
	
	    var numeral,
	        _,
	        VERSION = '2.0.6',
	        formats = {},
	        locales = {},
	        defaults = {
	            currentLocale: 'en',
	            zeroFormat: null,
	            nullFormat: null,
	            defaultFormat: '0,0',
	            scalePercentBy100: true
	        },
	        options = {
	            currentLocale: defaults.currentLocale,
	            zeroFormat: defaults.zeroFormat,
	            nullFormat: defaults.nullFormat,
	            defaultFormat: defaults.defaultFormat,
	            scalePercentBy100: defaults.scalePercentBy100
	        };
	
	
	    /************************************
	        Constructors
	    ************************************/
	
	    // Numeral prototype object
	    function Numeral(input, number) {
	        this._input = input;
	
	        this._value = number;
	    }
	
	    numeral = function(input) {
	        var value,
	            kind,
	            unformatFunction,
	            regexp;
	
	        if (numeral.isNumeral(input)) {
	            value = input.value();
	        } else if (input === 0 || typeof input === 'undefined') {
	            value = 0;
	        } else if (input === null || _.isNaN(input)) {
	            value = null;
	        } else if (typeof input === 'string') {
	            if (options.zeroFormat && input === options.zeroFormat) {
	                value = 0;
	            } else if (options.nullFormat && input === options.nullFormat || !input.replace(/[^0-9]+/g, '').length) {
	                value = null;
	            } else {
	                for (kind in formats) {
	                    regexp = typeof formats[kind].regexps.unformat === 'function' ? formats[kind].regexps.unformat() : formats[kind].regexps.unformat;
	
	                    if (regexp && input.match(regexp)) {
	                        unformatFunction = formats[kind].unformat;
	
	                        break;
	                    }
	                }
	
	                unformatFunction = unformatFunction || numeral._.stringToNumber;
	
	                value = unformatFunction(input);
	            }
	        } else {
	            value = Number(input)|| null;
	        }
	
	        return new Numeral(input, value);
	    };
	
	    // version number
	    numeral.version = VERSION;
	
	    // compare numeral object
	    numeral.isNumeral = function(obj) {
	        return obj instanceof Numeral;
	    };
	
	    // helper functions
	    numeral._ = _ = {
	        // formats numbers separators, decimals places, signs, abbreviations
	        numberToFormat: function(value, format, roundingFunction) {
	            var locale = locales[numeral.options.currentLocale],
	                negP = false,
	                optDec = false,
	                leadingCount = 0,
	                abbr = '',
	                trillion = 1000000000000,
	                billion = 1000000000,
	                million = 1000000,
	                thousand = 1000,
	                decimal = '',
	                neg = false,
	                abbrForce, // force abbreviation
	                abs,
	                min,
	                max,
	                power,
	                int,
	                precision,
	                signed,
	                thousands,
	                output;
	
	            // make sure we never format a null value
	            value = value || 0;
	
	            abs = Math.abs(value);
	
	            // see if we should use parentheses for negative number or if we should prefix with a sign
	            // if both are present we default to parentheses
	            if (numeral._.includes(format, '(')) {
	                negP = true;
	                format = format.replace(/[\(|\)]/g, '');
	            } else if (numeral._.includes(format, '+') || numeral._.includes(format, '-')) {
	                signed = numeral._.includes(format, '+') ? format.indexOf('+') : value < 0 ? format.indexOf('-') : -1;
	                format = format.replace(/[\+|\-]/g, '');
	            }
	
	            // see if abbreviation is wanted
	            if (numeral._.includes(format, 'a')) {
	                abbrForce = format.match(/a(k|m|b|t)?/);
	
	                abbrForce = abbrForce ? abbrForce[1] : false;
	
	                // check for space before abbreviation
	                if (numeral._.includes(format, ' a')) {
	                    abbr = ' ';
	                }
	
	                format = format.replace(new RegExp(abbr + 'a[kmbt]?'), '');
	
	                if (abs >= trillion && !abbrForce || abbrForce === 't') {
	                    // trillion
	                    abbr += locale.abbreviations.trillion;
	                    value = value / trillion;
	                } else if (abs < trillion && abs >= billion && !abbrForce || abbrForce === 'b') {
	                    // billion
	                    abbr += locale.abbreviations.billion;
	                    value = value / billion;
	                } else if (abs < billion && abs >= million && !abbrForce || abbrForce === 'm') {
	                    // million
	                    abbr += locale.abbreviations.million;
	                    value = value / million;
	                } else if (abs < million && abs >= thousand && !abbrForce || abbrForce === 'k') {
	                    // thousand
	                    abbr += locale.abbreviations.thousand;
	                    value = value / thousand;
	                }
	            }
	
	            // check for optional decimals
	            if (numeral._.includes(format, '[.]')) {
	                optDec = true;
	                format = format.replace('[.]', '.');
	            }
	
	            // break number and format
	            int = value.toString().split('.')[0];
	            precision = format.split('.')[1];
	            thousands = format.indexOf(',');
	            leadingCount = (format.split('.')[0].split(',')[0].match(/0/g) || []).length;
	
	            if (precision) {
	                if (numeral._.includes(precision, '[')) {
	                    precision = precision.replace(']', '');
	                    precision = precision.split('[');
	                    decimal = numeral._.toFixed(value, (precision[0].length + precision[1].length), roundingFunction, precision[1].length);
	                } else {
	                    decimal = numeral._.toFixed(value, precision.length, roundingFunction);
	                }
	
	                int = decimal.split('.')[0];
	
	                if (numeral._.includes(decimal, '.')) {
	                    decimal = locale.delimiters.decimal + decimal.split('.')[1];
	                } else {
	                    decimal = '';
	                }
	
	                if (optDec && Number(decimal.slice(1)) === 0) {
	                    decimal = '';
	                }
	            } else {
	                int = numeral._.toFixed(value, 0, roundingFunction);
	            }
	
	            // check abbreviation again after rounding
	            if (abbr && !abbrForce && Number(int) >= 1000 && abbr !== locale.abbreviations.trillion) {
	                int = String(Number(int) / 1000);
	
	                switch (abbr) {
	                    case locale.abbreviations.thousand:
	                        abbr = locale.abbreviations.million;
	                        break;
	                    case locale.abbreviations.million:
	                        abbr = locale.abbreviations.billion;
	                        break;
	                    case locale.abbreviations.billion:
	                        abbr = locale.abbreviations.trillion;
	                        break;
	                }
	            }
	
	
	            // format number
	            if (numeral._.includes(int, '-')) {
	                int = int.slice(1);
	                neg = true;
	            }
	
	            if (int.length < leadingCount) {
	                for (var i = leadingCount - int.length; i > 0; i--) {
	                    int = '0' + int;
	                }
	            }
	
	            if (thousands > -1) {
	                int = int.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + locale.delimiters.thousands);
	            }
	
	            if (format.indexOf('.') === 0) {
	                int = '';
	            }
	
	            output = int + decimal + (abbr ? abbr : '');
	
	            if (negP) {
	                output = (negP && neg ? '(' : '') + output + (negP && neg ? ')' : '');
	            } else {
	                if (signed >= 0) {
	                    output = signed === 0 ? (neg ? '-' : '+') + output : output + (neg ? '-' : '+');
	                } else if (neg) {
	                    output = '-' + output;
	                }
	            }
	
	            return output;
	        },
	        // unformats numbers separators, decimals places, signs, abbreviations
	        stringToNumber: function(string) {
	            var locale = locales[options.currentLocale],
	                stringOriginal = string,
	                abbreviations = {
	                    thousand: 3,
	                    million: 6,
	                    billion: 9,
	                    trillion: 12
	                },
	                abbreviation,
	                value,
	                i,
	                regexp;
	
	            if (options.zeroFormat && string === options.zeroFormat) {
	                value = 0;
	            } else if (options.nullFormat && string === options.nullFormat || !string.replace(/[^0-9]+/g, '').length) {
	                value = null;
	            } else {
	                value = 1;
	
	                if (locale.delimiters.decimal !== '.') {
	                    string = string.replace(/\./g, '').replace(locale.delimiters.decimal, '.');
	                }
	
	                for (abbreviation in abbreviations) {
	                    regexp = new RegExp('[^a-zA-Z]' + locale.abbreviations[abbreviation] + '(?:\\)|(\\' + locale.currency.symbol + ')?(?:\\))?)?$');
	
	                    if (stringOriginal.match(regexp)) {
	                        value *= Math.pow(10, abbreviations[abbreviation]);
	                        break;
	                    }
	                }
	
	                // check for negative number
	                value *= (string.split('-').length + Math.min(string.split('(').length - 1, string.split(')').length - 1)) % 2 ? 1 : -1;
	
	                // remove non numbers
	                string = string.replace(/[^0-9\.]+/g, '');
	
	                value *= Number(string);
	            }
	
	            return value;
	        },
	        isNaN: function(value) {
	            return typeof value === 'number' && isNaN(value);
	        },
	        includes: function(string, search) {
	            return string.indexOf(search) !== -1;
	        },
	        insert: function(string, subString, start) {
	            return string.slice(0, start) + subString + string.slice(start);
	        },
	        reduce: function(array, callback /*, initialValue*/) {
	            if (this === null) {
	                throw new TypeError('Array.prototype.reduce called on null or undefined');
	            }
	
	            if (typeof callback !== 'function') {
	                throw new TypeError(callback + ' is not a function');
	            }
	
	            var t = Object(array),
	                len = t.length >>> 0,
	                k = 0,
	                value;
	
	            if (arguments.length === 3) {
	                value = arguments[2];
	            } else {
	                while (k < len && !(k in t)) {
	                    k++;
	                }
	
	                if (k >= len) {
	                    throw new TypeError('Reduce of empty array with no initial value');
	                }
	
	                value = t[k++];
	            }
	            for (; k < len; k++) {
	                if (k in t) {
	                    value = callback(value, t[k], k, t);
	                }
	            }
	            return value;
	        },
	        /**
	         * Computes the multiplier necessary to make x >= 1,
	         * effectively eliminating miscalculations caused by
	         * finite precision.
	         */
	        multiplier: function (x) {
	            var parts = x.toString().split('.');
	
	            return parts.length < 2 ? 1 : Math.pow(10, parts[1].length);
	        },
	        /**
	         * Given a variable number of arguments, returns the maximum
	         * multiplier that must be used to normalize an operation involving
	         * all of them.
	         */
	        correctionFactor: function () {
	            var args = Array.prototype.slice.call(arguments);
	
	            return args.reduce(function(accum, next) {
	                var mn = _.multiplier(next);
	                return accum > mn ? accum : mn;
	            }, 1);
	        },
	        /**
	         * Implementation of toFixed() that treats floats more like decimals
	         *
	         * Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
	         * problems for accounting- and finance-related software.
	         */
	        toFixed: function(value, maxDecimals, roundingFunction, optionals) {
	            var splitValue = value.toString().split('.'),
	                minDecimals = maxDecimals - (optionals || 0),
	                boundedPrecision,
	                optionalsRegExp,
	                power,
	                output;
	
	            // Use the smallest precision value possible to avoid errors from floating point representation
	            if (splitValue.length === 2) {
	              boundedPrecision = Math.min(Math.max(splitValue[1].length, minDecimals), maxDecimals);
	            } else {
	              boundedPrecision = minDecimals;
	            }
	
	            power = Math.pow(10, boundedPrecision);
	
	            // Multiply up by precision, round accurately, then divide and use native toFixed():
	            output = (roundingFunction(value + 'e+' + boundedPrecision) / power).toFixed(boundedPrecision);
	
	            if (optionals > maxDecimals - boundedPrecision) {
	                optionalsRegExp = new RegExp('\\.?0{1,' + (optionals - (maxDecimals - boundedPrecision)) + '}$');
	                output = output.replace(optionalsRegExp, '');
	            }
	
	            return output;
	        }
	    };
	
	    // avaliable options
	    numeral.options = options;
	
	    // avaliable formats
	    numeral.formats = formats;
	
	    // avaliable formats
	    numeral.locales = locales;
	
	    // This function sets the current locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    numeral.locale = function(key) {
	        if (key) {
	            options.currentLocale = key.toLowerCase();
	        }
	
	        return options.currentLocale;
	    };
	
	    // This function provides access to the loaded locale data.  If
	    // no arguments are passed in, it will simply return the current
	    // global locale object.
	    numeral.localeData = function(key) {
	        if (!key) {
	            return locales[options.currentLocale];
	        }
	
	        key = key.toLowerCase();
	
	        if (!locales[key]) {
	            throw new Error('Unknown locale : ' + key);
	        }
	
	        return locales[key];
	    };
	
	    numeral.reset = function() {
	        for (var property in defaults) {
	            options[property] = defaults[property];
	        }
	    };
	
	    numeral.zeroFormat = function(format) {
	        options.zeroFormat = typeof(format) === 'string' ? format : null;
	    };
	
	    numeral.nullFormat = function (format) {
	        options.nullFormat = typeof(format) === 'string' ? format : null;
	    };
	
	    numeral.defaultFormat = function(format) {
	        options.defaultFormat = typeof(format) === 'string' ? format : '0.0';
	    };
	
	    numeral.register = function(type, name, format) {
	        name = name.toLowerCase();
	
	        if (this[type + 's'][name]) {
	            throw new TypeError(name + ' ' + type + ' already registered.');
	        }
	
	        this[type + 's'][name] = format;
	
	        return format;
	    };
	
	
	    numeral.validate = function(val, culture) {
	        var _decimalSep,
	            _thousandSep,
	            _currSymbol,
	            _valArray,
	            _abbrObj,
	            _thousandRegEx,
	            localeData,
	            temp;
	
	        //coerce val to string
	        if (typeof val !== 'string') {
	            val += '';
	
	            if (console.warn) {
	                console.warn('Numeral.js: Value is not string. It has been co-erced to: ', val);
	            }
	        }
	
	        //trim whitespaces from either sides
	        val = val.trim();
	
	        //if val is just digits return true
	        if (!!val.match(/^\d+$/)) {
	            return true;
	        }
	
	        //if val is empty return false
	        if (val === '') {
	            return false;
	        }
	
	        //get the decimal and thousands separator from numeral.localeData
	        try {
	            //check if the culture is understood by numeral. if not, default it to current locale
	            localeData = numeral.localeData(culture);
	        } catch (e) {
	            localeData = numeral.localeData(numeral.locale());
	        }
	
	        //setup the delimiters and currency symbol based on culture/locale
	        _currSymbol = localeData.currency.symbol;
	        _abbrObj = localeData.abbreviations;
	        _decimalSep = localeData.delimiters.decimal;
	        if (localeData.delimiters.thousands === '.') {
	            _thousandSep = '\\.';
	        } else {
	            _thousandSep = localeData.delimiters.thousands;
	        }
	
	        // validating currency symbol
	        temp = val.match(/^[^\d]+/);
	        if (temp !== null) {
	            val = val.substr(1);
	            if (temp[0] !== _currSymbol) {
	                return false;
	            }
	        }
	
	        //validating abbreviation symbol
	        temp = val.match(/[^\d]+$/);
	        if (temp !== null) {
	            val = val.slice(0, -1);
	            if (temp[0] !== _abbrObj.thousand && temp[0] !== _abbrObj.million && temp[0] !== _abbrObj.billion && temp[0] !== _abbrObj.trillion) {
	                return false;
	            }
	        }
	
	        _thousandRegEx = new RegExp(_thousandSep + '{2}');
	
	        if (!val.match(/[^\d.,]/g)) {
	            _valArray = val.split(_decimalSep);
	            if (_valArray.length > 2) {
	                return false;
	            } else {
	                if (_valArray.length < 2) {
	                    return ( !! _valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx));
	                } else {
	                    if (_valArray[0].length === 1) {
	                        return ( !! _valArray[0].match(/^\d+$/) && !_valArray[0].match(_thousandRegEx) && !! _valArray[1].match(/^\d+$/));
	                    } else {
	                        return ( !! _valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx) && !! _valArray[1].match(/^\d+$/));
	                    }
	                }
	            }
	        }
	
	        return false;
	    };
	
	
	    /************************************
	        Numeral Prototype
	    ************************************/
	
	    numeral.fn = Numeral.prototype = {
	        clone: function() {
	            return numeral(this);
	        },
	        format: function(inputString, roundingFunction) {
	            var value = this._value,
	                format = inputString || options.defaultFormat,
	                kind,
	                output,
	                formatFunction;
	
	            // make sure we have a roundingFunction
	            roundingFunction = roundingFunction || Math.round;
	
	            // format based on value
	            if (value === 0 && options.zeroFormat !== null) {
	                output = options.zeroFormat;
	            } else if (value === null && options.nullFormat !== null) {
	                output = options.nullFormat;
	            } else {
	                for (kind in formats) {
	                    if (format.match(formats[kind].regexps.format)) {
	                        formatFunction = formats[kind].format;
	
	                        break;
	                    }
	                }
	
	                formatFunction = formatFunction || numeral._.numberToFormat;
	
	                output = formatFunction(value, format, roundingFunction);
	            }
	
	            return output;
	        },
	        value: function() {
	            return this._value;
	        },
	        input: function() {
	            return this._input;
	        },
	        set: function(value) {
	            this._value = Number(value);
	
	            return this;
	        },
	        add: function(value) {
	            var corrFactor = _.correctionFactor.call(null, this._value, value);
	
	            function cback(accum, curr, currI, O) {
	                return accum + Math.round(corrFactor * curr);
	            }
	
	            this._value = _.reduce([this._value, value], cback, 0) / corrFactor;
	
	            return this;
	        },
	        subtract: function(value) {
	            var corrFactor = _.correctionFactor.call(null, this._value, value);
	
	            function cback(accum, curr, currI, O) {
	                return accum - Math.round(corrFactor * curr);
	            }
	
	            this._value = _.reduce([value], cback, Math.round(this._value * corrFactor)) / corrFactor;
	
	            return this;
	        },
	        multiply: function(value) {
	            function cback(accum, curr, currI, O) {
	                var corrFactor = _.correctionFactor(accum, curr);
	                return Math.round(accum * corrFactor) * Math.round(curr * corrFactor) / Math.round(corrFactor * corrFactor);
	            }
	
	            this._value = _.reduce([this._value, value], cback, 1);
	
	            return this;
	        },
	        divide: function(value) {
	            function cback(accum, curr, currI, O) {
	                var corrFactor = _.correctionFactor(accum, curr);
	                return Math.round(accum * corrFactor) / Math.round(curr * corrFactor);
	            }
	
	            this._value = _.reduce([this._value, value], cback);
	
	            return this;
	        },
	        difference: function(value) {
	            return Math.abs(numeral(this._value).subtract(value).value());
	        }
	    };
	
	    /************************************
	        Default Locale && Format
	    ************************************/
	
	    numeral.register('locale', 'en', {
	        delimiters: {
	            thousands: ',',
	            decimal: '.'
	        },
	        abbreviations: {
	            thousand: 'k',
	            million: 'm',
	            billion: 'b',
	            trillion: 't'
	        },
	        ordinal: function(number) {
	            var b = number % 10;
	            return (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	        },
	        currency: {
	            symbol: '$'
	        }
	    });
	
	    
	
	(function() {
	        numeral.register('format', 'bps', {
	            regexps: {
	                format: /(BPS)/,
	                unformat: /(BPS)/
	            },
	            format: function(value, format, roundingFunction) {
	                var space = numeral._.includes(format, ' BPS') ? ' ' : '',
	                    output;
	
	                value = value * 10000;
	
	                // check for space before BPS
	                format = format.replace(/\s?BPS/, '');
	
	                output = numeral._.numberToFormat(value, format, roundingFunction);
	
	                if (numeral._.includes(output, ')')) {
	                    output = output.split('');
	
	                    output.splice(-1, 0, space + 'BPS');
	
	                    output = output.join('');
	                } else {
	                    output = output + space + 'BPS';
	                }
	
	                return output;
	            },
	            unformat: function(string) {
	                return +(numeral._.stringToNumber(string) * 0.0001).toFixed(15);
	            }
	        });
	})();
	
	
	(function() {
	        var decimal = {
	            base: 1000,
	            suffixes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
	        },
	        binary = {
	            base: 1024,
	            suffixes: ['B', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']
	        };
	
	    var allSuffixes =  decimal.suffixes.concat(binary.suffixes.filter(function (item) {
	            return decimal.suffixes.indexOf(item) < 0;
	        }));
	        var unformatRegex = allSuffixes.join('|');
	        // Allow support for BPS (http://www.investopedia.com/terms/b/basispoint.asp)
	        unformatRegex = '(' + unformatRegex.replace('B', 'B(?!PS)') + ')';
	
	    numeral.register('format', 'bytes', {
	        regexps: {
	            format: /([0\s]i?b)/,
	            unformat: new RegExp(unformatRegex)
	        },
	        format: function(value, format, roundingFunction) {
	            var output,
	                bytes = numeral._.includes(format, 'ib') ? binary : decimal,
	                suffix = numeral._.includes(format, ' b') || numeral._.includes(format, ' ib') ? ' ' : '',
	                power,
	                min,
	                max;
	
	            // check for space before
	            format = format.replace(/\s?i?b/, '');
	
	            for (power = 0; power <= bytes.suffixes.length; power++) {
	                min = Math.pow(bytes.base, power);
	                max = Math.pow(bytes.base, power + 1);
	
	                if (value === null || value === 0 || value >= min && value < max) {
	                    suffix += bytes.suffixes[power];
	
	                    if (min > 0) {
	                        value = value / min;
	                    }
	
	                    break;
	                }
	            }
	
	            output = numeral._.numberToFormat(value, format, roundingFunction);
	
	            return output + suffix;
	        },
	        unformat: function(string) {
	            var value = numeral._.stringToNumber(string),
	                power,
	                bytesMultiplier;
	
	            if (value) {
	                for (power = decimal.suffixes.length - 1; power >= 0; power--) {
	                    if (numeral._.includes(string, decimal.suffixes[power])) {
	                        bytesMultiplier = Math.pow(decimal.base, power);
	
	                        break;
	                    }
	
	                    if (numeral._.includes(string, binary.suffixes[power])) {
	                        bytesMultiplier = Math.pow(binary.base, power);
	
	                        break;
	                    }
	                }
	
	                value *= (bytesMultiplier || 1);
	            }
	
	            return value;
	        }
	    });
	})();
	
	
	(function() {
	        numeral.register('format', 'currency', {
	        regexps: {
	            format: /(\$)/
	        },
	        format: function(value, format, roundingFunction) {
	            var locale = numeral.locales[numeral.options.currentLocale],
	                symbols = {
	                    before: format.match(/^([\+|\-|\(|\s|\$]*)/)[0],
	                    after: format.match(/([\+|\-|\)|\s|\$]*)$/)[0]
	                },
	                output,
	                symbol,
	                i;
	
	            // strip format of spaces and $
	            format = format.replace(/\s?\$\s?/, '');
	
	            // format the number
	            output = numeral._.numberToFormat(value, format, roundingFunction);
	
	            // update the before and after based on value
	            if (value >= 0) {
	                symbols.before = symbols.before.replace(/[\-\(]/, '');
	                symbols.after = symbols.after.replace(/[\-\)]/, '');
	            } else if (value < 0 && (!numeral._.includes(symbols.before, '-') && !numeral._.includes(symbols.before, '('))) {
	                symbols.before = '-' + symbols.before;
	            }
	
	            // loop through each before symbol
	            for (i = 0; i < symbols.before.length; i++) {
	                symbol = symbols.before[i];
	
	                switch (symbol) {
	                    case '$':
	                        output = numeral._.insert(output, locale.currency.symbol, i);
	                        break;
	                    case ' ':
	                        output = numeral._.insert(output, ' ', i + locale.currency.symbol.length - 1);
	                        break;
	                }
	            }
	
	            // loop through each after symbol
	            for (i = symbols.after.length - 1; i >= 0; i--) {
	                symbol = symbols.after[i];
	
	                switch (symbol) {
	                    case '$':
	                        output = i === symbols.after.length - 1 ? output + locale.currency.symbol : numeral._.insert(output, locale.currency.symbol, -(symbols.after.length - (1 + i)));
	                        break;
	                    case ' ':
	                        output = i === symbols.after.length - 1 ? output + ' ' : numeral._.insert(output, ' ', -(symbols.after.length - (1 + i) + locale.currency.symbol.length - 1));
	                        break;
	                }
	            }
	
	
	            return output;
	        }
	    });
	})();
	
	
	(function() {
	        numeral.register('format', 'exponential', {
	        regexps: {
	            format: /(e\+|e-)/,
	            unformat: /(e\+|e-)/
	        },
	        format: function(value, format, roundingFunction) {
	            var output,
	                exponential = typeof value === 'number' && !numeral._.isNaN(value) ? value.toExponential() : '0e+0',
	                parts = exponential.split('e');
	
	            format = format.replace(/e[\+|\-]{1}0/, '');
	
	            output = numeral._.numberToFormat(Number(parts[0]), format, roundingFunction);
	
	            return output + 'e' + parts[1];
	        },
	        unformat: function(string) {
	            var parts = numeral._.includes(string, 'e+') ? string.split('e+') : string.split('e-'),
	                value = Number(parts[0]),
	                power = Number(parts[1]);
	
	            power = numeral._.includes(string, 'e-') ? power *= -1 : power;
	
	            function cback(accum, curr, currI, O) {
	                var corrFactor = numeral._.correctionFactor(accum, curr),
	                    num = (accum * corrFactor) * (curr * corrFactor) / (corrFactor * corrFactor);
	                return num;
	            }
	
	            return numeral._.reduce([value, Math.pow(10, power)], cback, 1);
	        }
	    });
	})();
	
	
	(function() {
	        numeral.register('format', 'ordinal', {
	        regexps: {
	            format: /(o)/
	        },
	        format: function(value, format, roundingFunction) {
	            var locale = numeral.locales[numeral.options.currentLocale],
	                output,
	                ordinal = numeral._.includes(format, ' o') ? ' ' : '';
	
	            // check for space before
	            format = format.replace(/\s?o/, '');
	
	            ordinal += locale.ordinal(value);
	
	            output = numeral._.numberToFormat(value, format, roundingFunction);
	
	            return output + ordinal;
	        }
	    });
	})();
	
	
	(function() {
	        numeral.register('format', 'percentage', {
	        regexps: {
	            format: /(%)/,
	            unformat: /(%)/
	        },
	        format: function(value, format, roundingFunction) {
	            var space = numeral._.includes(format, ' %') ? ' ' : '',
	                output;
	
	            if (numeral.options.scalePercentBy100) {
	                value = value * 100;
	            }
	
	            // check for space before %
	            format = format.replace(/\s?\%/, '');
	
	            output = numeral._.numberToFormat(value, format, roundingFunction);
	
	            if (numeral._.includes(output, ')')) {
	                output = output.split('');
	
	                output.splice(-1, 0, space + '%');
	
	                output = output.join('');
	            } else {
	                output = output + space + '%';
	            }
	
	            return output;
	        },
	        unformat: function(string) {
	            var number = numeral._.stringToNumber(string);
	            if (numeral.options.scalePercentBy100) {
	                return number * 0.01;
	            }
	            return number;
	        }
	    });
	})();
	
	
	(function() {
	        numeral.register('format', 'time', {
	        regexps: {
	            format: /(:)/,
	            unformat: /(:)/
	        },
	        format: function(value, format, roundingFunction) {
	            var hours = Math.floor(value / 60 / 60),
	                minutes = Math.floor((value - (hours * 60 * 60)) / 60),
	                seconds = Math.round(value - (hours * 60 * 60) - (minutes * 60));
	
	            return hours + ':' + (minutes < 10 ? '0' + minutes : minutes) + ':' + (seconds < 10 ? '0' + seconds : seconds);
	        },
	        unformat: function(string) {
	            var timeArray = string.split(':'),
	                seconds = 0;
	
	            // turn hours and minutes into seconds and add them all up
	            if (timeArray.length === 3) {
	                // hours
	                seconds = seconds + (Number(timeArray[0]) * 60 * 60);
	                // minutes
	                seconds = seconds + (Number(timeArray[1]) * 60);
	                // seconds
	                seconds = seconds + Number(timeArray[2]);
	            } else if (timeArray.length === 2) {
	                // minutes
	                seconds = seconds + (Number(timeArray[0]) * 60);
	                // seconds
	                seconds = seconds + Number(timeArray[1]);
	            }
	            return Number(seconds);
	        }
	    });
	})();
	
	return numeral;
	}));


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function checkDCE() {
	  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
	  if (
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
	  ) {
	    return;
	  }
	  if (false) {
	    // This branch is unreachable because this function is only called
	    // in production, but the condition is true only in development.
	    // Therefore if the branch is still here, dead code elimination wasn't
	    // properly applied.
	    // Don't change the message. React DevTools relies on it. Also make sure
	    // this message doesn't occur elsewhere in this function, or it will cause
	    // a false positive.
	    throw new Error('^_^');
	  }
	  try {
	    // Verify that the code above has been dead code eliminated (DCE'd).
	    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
	  } catch (err) {
	    // DevTools shouldn't crash React, no matter what.
	    // We should still report in case we break this code.
	    console.error(err);
	  }
	}
	
	if (true) {
	  // DCE check should happen before ReactDOM bundle executes so that
	  // DevTools can report bad minification during injection.
	  checkDCE();
	  module.exports = __webpack_require__(436);
	} else {
	  module.exports = require('./cjs/react-dom.development.js');
	}


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SelectDropdown = __webpack_require__(106);
	
	var _SelectDropdown2 = _interopRequireDefault(_SelectDropdown);
	
	var _DateDropdown = __webpack_require__(105);
	
	var _DateDropdown2 = _interopRequireDefault(_DateDropdown);
	
	var _TextInputField = __webpack_require__(150);
	
	var _TextInputField2 = _interopRequireDefault(_TextInputField);
	
	var _SubGridVanilla = __webpack_require__(302);
	
	var _SubGridVanilla2 = _interopRequireDefault(_SubGridVanilla);
	
	var _SubGridVanillaMobile = __webpack_require__(303);
	
	var _SubGridVanillaMobile2 = _interopRequireDefault(_SubGridVanillaMobile);
	
	var _PhotoUpload = __webpack_require__(301);
	
	var _PhotoUpload2 = _interopRequireDefault(_PhotoUpload);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var getMandatoryAstric = function getMandatoryAstric(fieldDef) {
	  if (fieldDef && fieldDef.isMust && fieldDef.isMust === "true") {
	    //console.log(fieldDef.caption + "=" + fieldDef.isMust);
	    return "*";
	  } else {
	    //console.log(fieldDef.caption + "=" + fieldDef.isMust);
	    return "";
	  }
	};
	
	var getInputField = function getInputField(fieldName, tableName, stateRcvd, statehandler, disabled, tableOgDef, db, isMobile) {
	  if (!tableOgDef || !tableOgDef[tableName]) {
	    console.log(tableName + " | " + fieldName + " | " + JSON.stringify(tableOgDef.projectPos));
	    console.log("~~~~~~~~");
	    return _react2.default.createElement("div", null);
	  }
	
	  var fieldDef = tableOgDef[tableName][fieldName];
	  if (fieldDef && fieldDef.isHidden === "true") {
	    return _react2.default.createElement("div", null);
	  }
	  //console.log("~~~ " + fieldDef.caption + ">> " + getMandatoryAstric(fieldDef));
	  if (fieldDef) {
	    if (fieldDef.type === "input" || fieldDef.type === "calculation") {
	      return _react2.default.createElement(_TextInputField2.default, {
	        title: fieldDef.caption + getMandatoryAstric(fieldDef),
	        value: stateRcvd.payload && stateRcvd.payload !== undefined ? stateRcvd.payload[fieldName] : null,
	        stateChangeHandler: statehandler,
	        fieldName: fieldName,
	        disabled: fieldDef.enabled === "false",
	        type: fieldDef.isSecure === "true" ? "password" : null,
	        message: stateRcvd.validationError,
	        placeholder: fieldDef.placeholder
	      });
	    } else if (fieldDef.type === "photoUpload") {
	      return _react2.default.createElement(_PhotoUpload2.default, {
	        title: fieldDef.caption + getMandatoryAstric(fieldDef),
	        images: stateRcvd.payload && stateRcvd.payload !== undefined ? stateRcvd.payload[fieldName] : [],
	        fieldName: fieldName,
	        isPayload: true,
	        stateChangeHandler: statehandler,
	        disabled: fieldDef.enabled === "false"
	      });
	    } else if (fieldDef.type === "textarea") {
	      return _react2.default.createElement(_TextInputField2.default, {
	        title: fieldDef.caption + getMandatoryAstric(fieldDef),
	        value: stateRcvd.payload && stateRcvd.payload !== undefined ? stateRcvd.payload[fieldName] : null,
	        stateChangeHandler: statehandler,
	        fieldName: fieldName,
	        multiline: true,
	        multilineRows: { min: parseInt(fieldDef.numOfLines) },
	        resize: "manual",
	        disabled: fieldDef.enabled === "false",
	        placeholder: fieldDef.placeholder
	      });
	    } else if (fieldDef.type === "search") {
	      if (fieldDef.selectorSource.type === "static") {
	        var sourceFieldName = fieldDef.selectorSource.tableField;
	        return _react2.default.createElement(_SelectDropdown2.default, {
	          title: fieldDef.caption + getMandatoryAstric(fieldDef),
	          data: fieldDef.selectorSource.staticSource,
	          label: fieldDef.caption,
	          placeholder: fieldDef.placeholder,
	          value: stateRcvd.payload && stateRcvd.payload !== undefined ? stateRcvd.payload[fieldName] : null,
	          stateFieldName: fieldName,
	          isPayload: true,
	          fieldName: sourceFieldName,
	          stateHandler: statehandler,
	          disabled: fieldDef.enabled === "false" ? true : false
	        });
	      } else {
	        var sourceTableName = fieldDef.selectorSource.table;
	        var _sourceFieldName = fieldDef.selectorSource.tableField;
	        return _react2.default.createElement(_SelectDropdown2.default, {
	          title: fieldDef.caption + getMandatoryAstric(fieldDef),
	          data: db[sourceTableName],
	          label: fieldDef.caption,
	          placeholder: fieldDef.caption,
	          value: stateRcvd.payload && stateRcvd.payload !== undefined ? stateRcvd.payload[fieldName] : null,
	          stateFieldName: fieldName,
	          isPayload: true,
	          fieldName: _sourceFieldName,
	          stateHandler: statehandler,
	          disabled: fieldDef.enabled === "false" ? true : false,
	          otherFields: fieldDef.otherFieldsToUpdate,
	          filter: fieldDef.filters,
	          stateRcvd: stateRcvd
	        });
	      }
	    } else if (fieldDef.type === "accountingRule") {
	      return _react2.default.createElement(AccRuleGridVanilla, {
	        title: fieldDef.caption + getMandatoryAstric(fieldDef),
	        data: stateRcvd.payload && stateRcvd.payload !== undefined ? stateRcvd.payload[fieldName] : [],
	        stateChangeHandler: statehandler,
	        stateFieldName: fieldName,
	        isPayload: true,
	        emptyRow: {
	          accSide: "",
	          targetTable: "",
	          amountField: "",
	          matchField: "",
	          referencField: "",
	          acctDateField: ""
	        },
	        emptyTitle: "Add Accounting Rule",
	        tableOgDef: tableOgDef
	      });
	    } else if (fieldDef.type === "calendar") {
	      return _react2.default.createElement(_DateDropdown2.default, {
	        title: fieldDef.caption + getMandatoryAstric(fieldDef)
	        //maxDetail={fieldDef.dateMaxDetail === "minute" ? "minute" : ""}
	        , format: fieldDef.dateFormat,
	        formatOut: fieldDef.dateFormatOut,
	        onChange: statehandler,
	        fieldName: fieldName,
	        value: stateRcvd.payload && stateRcvd.payload !== undefined ? stateRcvd.payload[fieldName] : null,
	        disabled: fieldDef.enabled === "false"
	      });
	    } else if (fieldDef.type === "array") {
	      // if (fieldName === "requestedItems") {
	      //   console.log("generating field: " + fieldName);
	      // }
	      if (isMobile) {
	        if (fieldName === "requestedItems") {
	          console.log("it is mobile generating field: " + fieldName);
	        }
	        return _react2.default.createElement("div", {
	          style: {
	            textAlign: "center"
	          }
	        }, _react2.default.createElement(_SubGridVanillaMobile2.default, {
	          data: stateRcvd.payload && stateRcvd.payload !== undefined ? stateRcvd.payload[fieldName] : [],
	          stateChangeHandler: statehandler,
	          fieldName: fieldName,
	          isPayload: true,
	          colDefs: fieldDef.colDefs,
	          emptyRow: fieldDef.emptyRow,
	          caption: fieldDef.caption
	        }));
	      } else {
	        return _react2.default.createElement("div", {
	          style: {
	            textAlign: "center",
	            padding: "5px"
	          }
	        }, _react2.default.createElement(_SubGridVanilla2.default, {
	          data: stateRcvd.payload && stateRcvd.payload !== undefined ? stateRcvd.payload[fieldName] : [],
	          stateChangeHandler: statehandler,
	          fieldName: fieldName,
	          isPayload: true,
	          colDefs: fieldDef.colDefs,
	          emptyRow: fieldDef.emptyRow,
	          caption: fieldDef.caption
	        }));
	      }
	      // return (
	      //   <div
	      //     style={{
	      //       textAlign: "center",
	      //       padding: "5px"
	      //     }}
	      //   >
	      //     <SubGrid
	      //       data={
	      //         stateRcvd.payload && stateRcvd.payload !== undefined
	      //           ? stateRcvd.payload[fieldName]
	      //           : []
	      //       }
	      //       stateChangeHandler={statehandler}
	      //       fieldName={fieldName}
	      //       isPayload={true}
	      //       colDefs={fieldDef.colDefs}
	      //       emptyRow={fieldDef.emptyRow}
	      //     />
	      //   </div>
	      // );
	    }
	  }
	};
	
	exports.default = getInputField;

/***/ }),
/* 19 */
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.IconSvg = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _IconSvgStyled = __webpack_require__(722);
	
	var _IconSvgStyled2 = _interopRequireDefault(_IconSvgStyled);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var propTypes = {
	  /** Turns on/off icon's border */
	  border: _propTypes.PropTypes.bool,
	  /** Set icon's border width */
	  borderWidth: _propTypes.PropTypes.number,
	  /** Make icon rounded */
	  rounded: _propTypes.PropTypes.bool,
	  /** Set icon size */
	  size: _propTypes.PropTypes.oneOf(['custom', 'small', 'normal', 'large', 'xlarge']),
	  /** Set icon's color scheme */
	  colorScheme: _propTypes.PropTypes.oneOf(['light', 'dark', 'default']),
	  /** Set exact icon's border color */
	  color: _propTypes.PropTypes.string,
	  /** Set icon's background color */
	  backgroundColor: _propTypes.PropTypes.string,
	  /** Set icon's flipping plane */
	  flip: _propTypes.PropTypes.oneOf(['none', 'horizontal', 'vertical']),
	  /** Rotate icon by some degree */
	  rotate: _propTypes.PropTypes.number
	};
	
	var defaultProps = {
	  border: false,
	  borderWidth: 0,
	  rounded: false,
	  size: 'normal',
	  colorScheme: 'default',
	  color: '',
	  backgroundColor: '',
	  flip: 'none',
	  rotate: 0
	};
	
	var ICON_DEFAULT = _react2.default.createElement(
	  'svg',
	  { viewBox: '0 0 24 24' },
	  _react2.default.createElement('path', { d: 'M19,5.5c0-0.1,0-0.1,0-0.2c-0.1-0.1-0.1-0.2-0.3-0.3c-0.1,0-0.1,0-0.2,0h-10C8.4,5,8.4,5,8.3,5c-0.1,0-0.1,0.1-0.2,0.1l-3,3 c0,0-0.1,0.1-0.1,0.2c0,0.1,0,0.1,0,0.2v10C5,18.8,5.2,19,5.5,19h10c0.1,0,0.1,0,0.2,0c0.1,0,0.1-0.1,0.2-0.1l3-3 c0,0,0.1-0.1,0.1-0.2c0-0.1,0-0.1,0-0.2V5.5z M16,16h1.3L16,17.3V16z M18,15h-2V8.7l2-2V15z M9,9h6v6H9V9z M8,8H6.7L8,6.7V8z M9,6 h8.3l-2,2H9V6z M6,9h2v6.5C8,15.8,8.2,16,8.5,16H15v2H6V9z' })
	);
	
	var IconSvg = function IconSvg(_ref) {
	  var children = _ref.children,
	      backgroundColor = _ref.backgroundColor,
	      colorScheme = _ref.colorScheme,
	      color = _ref.color,
	      size = _ref.size,
	      border = _ref.border,
	      borderWidth = _ref.borderWidth,
	      flip = _ref.flip,
	      rounded = _ref.rounded,
	      rotate = _ref.rotate,
	      props = _objectWithoutProperties(_ref, ['children', 'backgroundColor', 'colorScheme', 'color', 'size', 'border', 'borderWidth', 'flip', 'rounded', 'rotate']);
	
	  return _react2.default.createElement(
	    _IconSvgStyled2.default,
	    _extends({
	      backgroundColor: backgroundColor,
	      customColor: color,
	      colorScheme: colorScheme,
	      flip: flip,
	      sizeKey: size,
	      rotate: rotate,
	      border: border,
	      borderWidth: borderWidth,
	      rounded: rounded
	    }, props),
	    children || ICON_DEFAULT
	  );
	};
	
	exports.IconSvg = IconSvg;
	IconSvg.propTypes = propTypes;
	IconSvg.defaultProps = defaultProps;
	IconSvg.displayName = 'IconSvg';

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/**
	 * @license
	 * lodash 3.10.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern -d -o ./index.js`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '3.10.1';
	
	  /** Used to compose bitmasks for wrapper metadata. */
	  var BIND_FLAG = 1,
	      BIND_KEY_FLAG = 2,
	      CURRY_BOUND_FLAG = 4,
	      CURRY_FLAG = 8,
	      CURRY_RIGHT_FLAG = 16,
	      PARTIAL_FLAG = 32,
	      PARTIAL_RIGHT_FLAG = 64,
	      ARY_FLAG = 128,
	      REARG_FLAG = 256;
	
	  /** Used as default options for `_.trunc`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect when a function becomes hot. */
	  var HOT_COUNT = 150,
	      HOT_SPAN = 16;
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2;
	
	  /** Used as the `TypeError` message for "Functions" methods. */
	  var FUNC_ERROR_TEXT = 'Expected a function';
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      objectTag = '[object Object]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      weakMapTag = '[object WeakMap]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39|#96);/g,
	      reUnescapedHtml = /[&<>"'`]/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\n\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\n\\]|\\.)*?)\2)\]/g;
	
	  /**
	   * Used to match `RegExp` [syntax characters](http://ecma-international.org/ecma-262/6.0/#sec-patterns)
	   * and those outlined by [`EscapeRegExpPattern`](http://ecma-international.org/ecma-262/6.0/#sec-escaperegexppattern).
	   */
	  var reRegExpChars = /^[:!,]|[\\^$.*+?()[\]{}|\/]|(^[0-9a-fA-Fnrtuvx])|([\n\r\u2028\u2029])/g,
	      reHasRegExpChars = RegExp(reRegExpChars.source);
	
	  /** Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks). */
	  var reComboMark = /[\u0300-\u036f\ufe20-\ufe23]/g;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /** Used to match [ES template delimiters](http://ecma-international.org/ecma-262/6.0/#sec-template-literal-lexical-components). */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect hexadecimal string values. */
	  var reHasHexPrefix = /^0[xX]/;
	
	  /** Used to detect host constructors (Safari > 5). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^\d+$/;
	
	  /** Used to match latin-1 supplementary letters (excluding mathematical operators). */
	  var reLatin1 = /[\xc0-\xd6\xd8-\xde\xdf-\xf6\xf8-\xff]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to match words to create compound words. */
	  var reWords = (function() {
	    var upper = '[A-Z\\xc0-\\xd6\\xd8-\\xde]',
	        lower = '[a-z\\xdf-\\xf6\\xf8-\\xff]+';
	
	    return RegExp(upper + '+(?=' + upper + lower + ')|' + upper + '?' + lower + '|' + upper + '+|[0-9]+', 'g');
	  }());
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'ArrayBuffer', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Math', 'Number',
	    'Object', 'RegExp', 'Set', 'String', '_', 'clearTimeout', 'isFinite',
	    'parseFloat', 'parseInt', 'setTimeout', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dateTag] = typedArrayTags[errorTag] =
	  typedArrayTags[funcTag] = typedArrayTags[mapTag] =
	  typedArrayTags[numberTag] = typedArrayTags[objectTag] =
	  typedArrayTags[regexpTag] = typedArrayTags[setTag] =
	  typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[boolTag] =
	  cloneableTags[dateTag] = cloneableTags[float32Tag] =
	  cloneableTags[float64Tag] = cloneableTags[int8Tag] =
	  cloneableTags[int16Tag] = cloneableTags[int32Tag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[stringTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[mapTag] = cloneableTags[setTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map latin-1 supplementary letters to basic latin letters. */
	  var deburredLetters = {
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcC': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xeC': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;',
	    '`': '&#96;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'",
	    '&#96;': '`'
	  };
	
	  /** Used to determine if values are of the language type `Object`. */
	  var objectTypes = {
	    'function': true,
	    'object': true
	  };
	
	  /** Used to escape characters for inclusion in compiled regexes. */
	  var regexpEscapes = {
	    '0': 'x30', '1': 'x31', '2': 'x32', '3': 'x33', '4': 'x34',
	    '5': 'x35', '6': 'x36', '7': 'x37', '8': 'x38', '9': 'x39',
	    'A': 'x41', 'B': 'x42', 'C': 'x43', 'D': 'x44', 'E': 'x45', 'F': 'x46',
	    'a': 'x61', 'b': 'x62', 'c': 'x63', 'd': 'x64', 'e': 'x65', 'f': 'x66',
	    'n': 'x6e', 'r': 'x72', 't': 'x74', 'u': 'x75', 'v': 'x76', 'x': 'x78'
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Detect free variable `exports`. */
	  var freeExports = objectTypes[typeof exports] && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = objectTypes[typeof module] && module && !module.nodeType && module;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = freeExports && freeModule && typeof global == 'object' && global && global.Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = objectTypes[typeof self] && self && self.Object && self;
	
	  /** Detect free variable `window`. */
	  var freeWindow = objectTypes[typeof window] && window && window.Object && window;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports && freeExports;
	
	  /**
	   * Used as a reference to the global object.
	   *
	   * The `this` value is used if it's the global object to avoid Greasemonkey's
	   * restricted `window` object, otherwise the `window` object is used.
	   */
	  var root = freeGlobal || ((freeWindow !== (this && this.window)) && freeWindow) || freeSelf || this;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * The base implementation of `compareAscending` which compares values and
	   * sorts them in ascending order without guaranteeing a stable sort.
	   *
	   * @private
	   * @param {*} value The value to compare.
	   * @param {*} other The other value to compare.
	   * @returns {number} Returns the sort order indicator for `value`.
	   */
	  function baseCompareAscending(value, other) {
	    if (value !== other) {
	      var valIsNull = value === null,
	          valIsUndef = value === undefined,
	          valIsReflexive = value === value;
	
	      var othIsNull = other === null,
	          othIsUndef = other === undefined,
	          othIsReflexive = other === other;
	
	      if ((value > other && !othIsNull) || !valIsReflexive ||
	          (valIsNull && !othIsUndef && othIsReflexive) ||
	          (valIsUndef && othIsReflexive)) {
	        return 1;
	      }
	      if ((value < other && !valIsNull) || !othIsReflexive ||
	          (othIsNull && !valIsUndef && valIsReflexive) ||
	          (othIsUndef && valIsReflexive)) {
	        return -1;
	      }
	    }
	    return 0;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for callback shorthands and `this` binding.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromRight) {
	    var length = array.length,
	        index = fromRight ? length : -1;
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without support for binary searches.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    if (value !== value) {
	      return indexOfNaN(array, fromIndex);
	    }
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isFunction` without support for environments
	   * with incorrect `typeof` results.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	   */
	  function baseIsFunction(value) {
	    // Avoid a Chakra JIT bug in compatibility modes of IE 11.
	    // See https://github.com/jashkenas/underscore/issues/1621 for more details.
	    return typeof value == 'function' || false;
	  }
	
	  /**
	   * Converts `value` to a string if it's not one. An empty string is returned
	   * for `null` or `undefined` values.
	   *
	   * @private
	   * @param {*} value The value to process.
	   * @returns {string} Returns the string.
	   */
	  function baseToString(value) {
	    return value == null ? '' : (value + '');
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimLeft` to get the index of the first character
	   * of `string` that is not found in `chars`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @param {string} chars The characters to find.
	   * @returns {number} Returns the index of the first character not found in `chars`.
	   */
	  function charsLeftIndex(string, chars) {
	    var index = -1,
	        length = string.length;
	
	    while (++index < length && chars.indexOf(string.charAt(index)) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimRight` to get the index of the last character
	   * of `string` that is not found in `chars`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @param {string} chars The characters to find.
	   * @returns {number} Returns the index of the last character not found in `chars`.
	   */
	  function charsRightIndex(string, chars) {
	    var index = string.length;
	
	    while (index-- && chars.indexOf(string.charAt(index)) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.sortBy` to compare transformed elements of a collection and stable
	   * sort them in ascending order.
	   *
	   * @private
	   * @param {Object} object The object to compare.
	   * @param {Object} other The other object to compare.
	   * @returns {number} Returns the sort order indicator for `object`.
	   */
	  function compareAscending(object, other) {
	    return baseCompareAscending(object.criteria, other.criteria) || (object.index - other.index);
	  }
	
	  /**
	   * Used by `_.sortByOrder` to compare multiple properties of a value to another
	   * and stable sort them.
	   *
	   * If `orders` is unspecified, all valuess are sorted in ascending order. Otherwise,
	   * a value is sorted in ascending order if its corresponding order is "asc", and
	   * descending if "desc".
	   *
	   * @private
	   * @param {Object} object The object to compare.
	   * @param {Object} other The other object to compare.
	   * @param {boolean[]} orders The order to sort by for each property.
	   * @returns {number} Returns the sort order indicator for `object`.
	   */
	  function compareMultiple(object, other, orders) {
	    var index = -1,
	        objCriteria = object.criteria,
	        othCriteria = other.criteria,
	        length = objCriteria.length,
	        ordersLength = orders.length;
	
	    while (++index < length) {
	      var result = baseCompareAscending(objCriteria[index], othCriteria[index]);
	      if (result) {
	        if (index >= ordersLength) {
	          return result;
	        }
	        var order = orders[index];
	        return result * ((order === 'asc' || order === true) ? 1 : -1);
	      }
	    }
	    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	    // that causes it, under certain circumstances, to provide the same value for
	    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	    // for more details.
	    //
	    // This also ensures a stable sort in V8 and other engines.
	    // See https://code.google.com/p/v8/issues/detail?id=90 for more details.
	    return object.index - other.index;
	  }
	
	  /**
	   * Used by `_.deburr` to convert latin-1 supplementary letters to basic latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  function deburrLetter(letter) {
	    return deburredLetters[letter];
	  }
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeHtmlChar(chr) {
	    return htmlEscapes[chr];
	  }
	
	  /**
	   * Used by `_.escapeRegExp` to escape characters for inclusion in compiled regexes.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @param {string} leadingChar The capture group for a leading character.
	   * @param {string} whitespaceChar The capture group for a whitespace character.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeRegExpChar(chr, leadingChar, whitespaceChar) {
	    if (leadingChar) {
	      chr = regexpEscapes[chr];
	    } else if (whitespaceChar) {
	      chr = stringEscapes[chr];
	    }
	    return '\\' + chr;
	  }
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the index at which the first occurrence of `NaN` is found in `array`.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched `NaN`, else `-1`.
	   */
	  function indexOfNaN(array, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 0 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      var other = array[index];
	      if (other !== other) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * Checks if `value` is object-like.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	   */
	  function isObjectLike(value) {
	    return !!value && typeof value == 'object';
	  }
	
	  /**
	   * Used by `trimmedLeftIndex` and `trimmedRightIndex` to determine if a
	   * character code is whitespace.
	   *
	   * @private
	   * @param {number} charCode The character code to inspect.
	   * @returns {boolean} Returns `true` if `charCode` is whitespace, else `false`.
	   */
	  function isSpace(charCode) {
	    return ((charCode <= 160 && (charCode >= 9 && charCode <= 13) || charCode == 32 || charCode == 160) || charCode == 5760 || charCode == 6158 ||
	      (charCode >= 8192 && (charCode <= 8202 || charCode == 8232 || charCode == 8233 || charCode == 8239 || charCode == 8287 || charCode == 12288 || charCode == 65279)));
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = -1,
	        result = [];
	
	    while (++index < length) {
	      if (array[index] === placeholder) {
	        array[index] = PLACEHOLDER;
	        result[++resIndex] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * An implementation of `_.uniq` optimized for sorted arrays without support
	   * for callback shorthands and `this` binding.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} [iteratee] The function invoked per iteration.
	   * @returns {Array} Returns the new duplicate-value-free array.
	   */
	  function sortedUniq(array, iteratee) {
	    var seen,
	        index = -1,
	        length = array.length,
	        resIndex = -1,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index],
	          computed = iteratee ? iteratee(value, index, array) : value;
	
	      if (!index || seen !== computed) {
	        seen = computed;
	        result[++resIndex] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimLeft` to get the index of the first non-whitespace
	   * character of `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the index of the first non-whitespace character.
	   */
	  function trimmedLeftIndex(string) {
	    var index = -1,
	        length = string.length;
	
	    while (++index < length && isSpace(string.charCodeAt(index))) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimRight` to get the index of the last non-whitespace
	   * character of `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the index of the last non-whitespace character.
	   */
	  function trimmedRightIndex(string) {
	    var index = string.length;
	
	    while (index-- && isSpace(string.charCodeAt(index))) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  function unescapeHtmlChar(chr) {
	    return htmlUnescapes[chr];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the given `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @category Utility
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // using `context` to mock `Date#getTime` use in `_.now`
	   * var mock = _.runInContext({
	   *   'Date': function() {
	   *     return { 'getTime': getTimeMock };
	   *   }
	   * });
	   *
	   * // or creating a suped-up `defer` in Node.js
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  function runInContext(context) {
	    // Avoid issues with some ES3 environments that attempt to use values, named
	    // after built-in constructors like `Object`, for the creation of literals.
	    // ES5 clears this up by stating that literals must use built-in constructors.
	    // See https://es5.github.io/#x11.1.5 for more details.
	    context = context ? _.defaults(root.Object(), context, _.pick(root, contextProps)) : root;
	
	    /** Native constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Number = context.Number,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for native method references. */
	    var arrayProto = Array.prototype,
	        objectProto = Object.prototype,
	        stringProto = String.prototype;
	
	    /** Used to resolve the decompiled source of functions. */
	    var fnToString = Function.prototype.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /**
	     * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var objToString = objectProto.toString;
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Native method references. */
	    var ArrayBuffer = context.ArrayBuffer,
	        clearTimeout = context.clearTimeout,
	        parseFloat = context.parseFloat,
	        pow = Math.pow,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        Set = getNative(context, 'Set'),
	        setTimeout = context.setTimeout,
	        splice = arrayProto.splice,
	        Uint8Array = context.Uint8Array,
	        WeakMap = getNative(context, 'WeakMap');
	
	    /* Native method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeCreate = getNative(Object, 'create'),
	        nativeFloor = Math.floor,
	        nativeIsArray = getNative(Array, 'isArray'),
	        nativeIsFinite = context.isFinite,
	        nativeKeys = getNative(Object, 'keys'),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = getNative(Date, 'now'),
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random;
	
	    /** Used as references for `-Infinity` and `Infinity`. */
	    var NEGATIVE_INFINITY = Number.NEGATIVE_INFINITY,
	        POSITIVE_INFINITY = Number.POSITIVE_INFINITY;
	
	    /** Used as references for the maximum length and index of an array. */
	    var MAX_ARRAY_LENGTH = 4294967295,
	        MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	        HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	    /**
	     * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	     * of an array-like value.
	     */
	    var MAX_SAFE_INTEGER = 9007199254740991;
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit chaining.
	     * Methods that operate on and return arrays, collections, and functions can
	     * be chained together. Methods that retrieve a single value or may return a
	     * primitive value will automatically end the chain returning the unwrapped
	     * value. Explicit chaining may be enabled using `_.chain`. The execution of
	     * chained methods is lazy, that is, execution is deferred until `_#value`
	     * is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion. Shortcut
	     * fusion is an optimization strategy which merge iteratee calls; this can help
	     * to avoid the creation of intermediate data structures and greatly reduce the
	     * number of iteratee executions.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `reverse`, `shift`, `slice`, `sort`,
	     * `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `compact`, `drop`, `dropRight`, `dropRightWhile`, `dropWhile`, `filter`,
	     * `first`, `initial`, `last`, `map`, `pluck`, `reject`, `rest`, `reverse`,
	     * `slice`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, `toArray`,
	     * and `where`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `at`, `before`, `bind`, `bindAll`, `bindKey`,
	     * `callback`, `chain`, `chunk`, `commit`, `compact`, `concat`, `constant`,
	     * `countBy`, `create`, `curry`, `debounce`, `defaults`, `defaultsDeep`,
	     * `defer`, `delay`, `difference`, `drop`, `dropRight`, `dropRightWhile`,
	     * `dropWhile`, `fill`, `filter`, `flatten`, `flattenDeep`, `flow`, `flowRight`,
	     * `forEach`, `forEachRight`, `forIn`, `forInRight`, `forOwn`, `forOwnRight`,
	     * `functions`, `groupBy`, `indexBy`, `initial`, `intersection`, `invert`,
	     * `invoke`, `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`,
	     * `matchesProperty`, `memoize`, `merge`, `method`, `methodOf`, `mixin`,
	     * `modArgs`, `negate`, `omit`, `once`, `pairs`, `partial`, `partialRight`,
	     * `partition`, `pick`, `plant`, `pluck`, `property`, `propertyOf`, `pull`,
	     * `pullAt`, `push`, `range`, `rearg`, `reject`, `remove`, `rest`, `restParam`,
	     * `reverse`, `set`, `shuffle`, `slice`, `sort`, `sortBy`, `sortByAll`,
	     * `sortByOrder`, `splice`, `spread`, `take`, `takeRight`, `takeRightWhile`,
	     * `takeWhile`, `tap`, `throttle`, `thru`, `times`, `toArray`, `toPlainObject`,
	     * `transform`, `union`, `uniq`, `unshift`, `unzip`, `unzipWith`, `values`,
	     * `valuesIn`, `where`, `without`, `wrap`, `xor`, `zip`, `zipObject`, `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clone`, `cloneDeep`,
	     * `deburr`, `endsWith`, `escape`, `escapeRegExp`, `every`, `find`, `findIndex`,
	     * `findKey`, `findLast`, `findLastIndex`, `findLastKey`, `findWhere`, `first`,
	     * `floor`, `get`, `gt`, `gte`, `has`, `identity`, `includes`, `indexOf`,
	     * `inRange`, `isArguments`, `isArray`, `isBoolean`, `isDate`, `isElement`,
	     * `isEmpty`, `isEqual`, `isError`, `isFinite` `isFunction`, `isMatch`,
	     * `isNative`, `isNaN`, `isNull`, `isNumber`, `isObject`, `isPlainObject`,
	     * `isRegExp`, `isString`, `isUndefined`, `isTypedArray`, `join`, `kebabCase`,
	     * `last`, `lastIndexOf`, `lt`, `lte`, `max`, `min`, `noConflict`, `noop`,
	     * `now`, `pad`, `padLeft`, `padRight`, `parseInt`, `pop`, `random`, `reduce`,
	     * `reduceRight`, `repeat`, `result`, `round`, `runInContext`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedLastIndex`, `startCase`,
	     * `startsWith`, `sum`, `template`, `trim`, `trimLeft`, `trimRight`, `trunc`,
	     * `unescape`, `uniqueId`, `value`, and `words`
	     *
	     * The wrapper method `sample` will return a wrapped value when `n` is provided,
	     * otherwise an unwrapped value is returned.
	     *
	     * @name _
	     * @constructor
	     * @category Chain
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // returns an unwrapped value
	     * wrapped.reduce(function(total, n) {
	     *   return total + n;
	     * });
	     * // => 6
	     *
	     * // returns a wrapped value
	     * var squares = wrapped.map(function(n) {
	     *   return n * n;
	     * });
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__chain__') && hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The function whose prototype all chaining wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable chaining for all wrapper methods.
	     * @param {Array} [actions=[]] Actions to peform to resolve the unwrapped value.
	     */
	    function LodashWrapper(value, chainAll, actions) {
	      this.__wrapped__ = value;
	      this.__actions__ = actions || [];
	      this.__chain__ = !!chainAll;
	    }
	
	    /**
	     * An object environment feature flags.
	     *
	     * @static
	     * @memberOf _
	     * @type Object
	     */
	    var support = lodash.support = {};
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB). Change the following template settings to use
	     * alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type Object
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type RegExp
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type RegExp
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type RegExp
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type string
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type Object
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type Function
	         */
	        '_': lodash
	      }
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = POSITIVE_INFINITY;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = arrayCopy(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = arrayCopy(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = arrayCopy(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || arrLength < LARGE_ARRAY_SIZE || (arrLength == length && takeCount == length)) {
	        return baseWrapperValue((isRight && isArr) ? array.reverse() : array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a cache object to store key/value pairs.
	     *
	     * @private
	     * @static
	     * @name Cache
	     * @memberOf _.memoize
	     */
	    function MapCache() {
	      this.__data__ = {};
	    }
	
	    /**
	     * Removes `key` and its value from the cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf _.memoize.Cache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed successfully, else `false`.
	     */
	    function mapDelete(key) {
	      return this.has(key) && delete this.__data__[key];
	    }
	
	    /**
	     * Gets the cached value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf _.memoize.Cache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the cached value.
	     */
	    function mapGet(key) {
	      return key == '__proto__' ? undefined : this.__data__[key];
	    }
	
	    /**
	     * Checks if a cached value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf _.memoize.Cache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapHas(key) {
	      return key != '__proto__' && hasOwnProperty.call(this.__data__, key);
	    }
	
	    /**
	     * Sets `value` to `key` of the cache.
	     *
	     * @private
	     * @name set
	     * @memberOf _.memoize.Cache
	     * @param {string} key The key of the value to cache.
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache object.
	     */
	    function mapSet(key, value) {
	      if (key != '__proto__') {
	        this.__data__[key] = value;
	      }
	      return this;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates a cache object to store unique values.
	     *
	     * @private
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var length = values ? values.length : 0;
	
	      this.data = { 'hash': nativeCreate(null), 'set': new Set };
	      while (length--) {
	        this.push(values[length]);
	      }
	    }
	
	    /**
	     * Checks if `value` is in `cache` mimicking the return signature of
	     * `_.indexOf` by returning `0` if the value is found, else `-1`.
	     *
	     * @private
	     * @param {Object} cache The cache to search.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `0` if `value` is found, else `-1`.
	     */
	    function cacheIndexOf(cache, value) {
	      var data = cache.data,
	          result = (typeof value == 'string' || isObject(value)) ? data.set.has(value) : data.hash[value];
	
	      return result ? 0 : -1;
	    }
	
	    /**
	     * Adds `value` to the cache.
	     *
	     * @private
	     * @name push
	     * @memberOf SetCache
	     * @param {*} value The value to cache.
	     */
	    function cachePush(value) {
	      var data = this.data;
	      if (typeof value == 'string' || isObject(value)) {
	        data.set.add(value);
	      } else {
	        data.hash[value] = true;
	      }
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a new array joining `array` with `other`.
	     *
	     * @private
	     * @param {Array} array The array to join.
	     * @param {Array} other The other array to join.
	     * @returns {Array} Returns the new concatenated array.
	     */
	    function arrayConcat(array, other) {
	      var index = -1,
	          length = array.length,
	          othIndex = -1,
	          othLength = other.length,
	          result = Array(length + othLength);
	
	      while (++index < length) {
	        result[index] = array[index];
	      }
	      while (++othIndex < othLength) {
	        result[index++] = other[othIndex];
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function arrayCopy(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * A specialized version of `_.forEach` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns `array`.
	     */
	    function arrayEach(array, iteratee) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        if (iteratee(array[index], index, array) === false) {
	          break;
	        }
	      }
	      return array;
	    }
	
	    /**
	     * A specialized version of `_.forEachRight` for arrays without support for
	     * callback shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns `array`.
	     */
	    function arrayEachRight(array, iteratee) {
	      var length = array.length;
	
	      while (length--) {
	        if (iteratee(array[length], length, array) === false) {
	          break;
	        }
	      }
	      return array;
	    }
	
	    /**
	     * A specialized version of `_.every` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     */
	    function arrayEvery(array, predicate) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        if (!predicate(array[index], index, array)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * A specialized version of `baseExtremum` for arrays which invokes `iteratee`
	     * with one argument: (value).
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} comparator The function used to compare values.
	     * @param {*} exValue The initial extremum value.
	     * @returns {*} Returns the extremum value.
	     */
	    function arrayExtremum(array, iteratee, comparator, exValue) {
	      var index = -1,
	          length = array.length,
	          computed = exValue,
	          result = computed;
	
	      while (++index < length) {
	        var value = array[index],
	            current = +iteratee(value);
	
	        if (comparator(current, computed)) {
	          computed = current;
	          result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.filter` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function arrayFilter(array, predicate) {
	      var index = -1,
	          length = array.length,
	          resIndex = -1,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result[++resIndex] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.map` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function arrayMap(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          result = Array(length);
	
	      while (++index < length) {
	        result[index] = iteratee(array[index], index, array);
	      }
	      return result;
	    }
	
	    /**
	     * Appends the elements of `values` to `array`.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to append.
	     * @returns {Array} Returns `array`.
	     */
	    function arrayPush(array, values) {
	      var index = -1,
	          length = values.length,
	          offset = array.length;
	
	      while (++index < length) {
	        array[offset + index] = values[index];
	      }
	      return array;
	    }
	
	    /**
	     * A specialized version of `_.reduce` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @param {boolean} [initFromArray] Specify using the first element of `array`
	     *  as the initial value.
	     * @returns {*} Returns the accumulated value.
	     */
	    function arrayReduce(array, iteratee, accumulator, initFromArray) {
	      var index = -1,
	          length = array.length;
	
	      if (initFromArray && length) {
	        accumulator = array[++index];
	      }
	      while (++index < length) {
	        accumulator = iteratee(accumulator, array[index], index, array);
	      }
	      return accumulator;
	    }
	
	    /**
	     * A specialized version of `_.reduceRight` for arrays without support for
	     * callback shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @param {boolean} [initFromArray] Specify using the last element of `array`
	     *  as the initial value.
	     * @returns {*} Returns the accumulated value.
	     */
	    function arrayReduceRight(array, iteratee, accumulator, initFromArray) {
	      var length = array.length;
	      if (initFromArray && length) {
	        accumulator = array[--length];
	      }
	      while (length--) {
	        accumulator = iteratee(accumulator, array[length], length, array);
	      }
	      return accumulator;
	    }
	
	    /**
	     * A specialized version of `_.some` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function arraySome(array, predicate) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        if (predicate(array[index], index, array)) {
	          return true;
	        }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `_.sum` for arrays without support for callback
	     * shorthands and `this` binding..
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {number} Returns the sum.
	     */
	    function arraySum(array, iteratee) {
	      var length = array.length,
	          result = 0;
	
	      while (length--) {
	        result += +iteratee(array[length]) || 0;
	      }
	      return result;
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assign` use.
	     *
	     * @private
	     * @param {*} objectValue The destination object property value.
	     * @param {*} sourceValue The source object property value.
	     * @returns {*} Returns the value to assign to the destination object.
	     */
	    function assignDefaults(objectValue, sourceValue) {
	      return objectValue === undefined ? sourceValue : objectValue;
	    }
	
	    /**
	     * Used by `_.template` to customize its `_.assign` use.
	     *
	     * **Note:** This function is like `assignDefaults` except that it ignores
	     * inherited property values when checking if a property is `undefined`.
	     *
	     * @private
	     * @param {*} objectValue The destination object property value.
	     * @param {*} sourceValue The source object property value.
	     * @param {string} key The key associated with the object and source values.
	     * @param {Object} object The destination object.
	     * @returns {*} Returns the value to assign to the destination object.
	     */
	    function assignOwnDefaults(objectValue, sourceValue, key, object) {
	      return (objectValue === undefined || !hasOwnProperty.call(object, key))
	        ? sourceValue
	        : objectValue;
	    }
	
	    /**
	     * A specialized version of `_.assign` for customizing assigned values without
	     * support for argument juggling, multiple sources, and `this` binding `customizer`
	     * functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     */
	    function assignWith(object, source, customizer) {
	      var index = -1,
	          props = keys(source),
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index],
	            value = object[key],
	            result = customizer(value, source[key], key, object, source);
	
	        if ((result === result ? (result !== value) : (value === value)) ||
	            (value === undefined && !(key in object))) {
	          object[key] = result;
	        }
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for argument juggling,
	     * multiple sources, and `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return source == null
	        ? object
	        : baseCopy(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.at` without support for string collections
	     * and individual key arguments.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {number[]|string[]} props The property names or indexes of elements to pick.
	     * @returns {Array} Returns the new array of picked elements.
	     */
	    function baseAt(collection, props) {
	      var index = -1,
	          isNil = collection == null,
	          isArr = !isNil && isArrayLike(collection),
	          length = isArr ? collection.length : 0,
	          propsLength = props.length,
	          result = Array(propsLength);
	
	      while(++index < propsLength) {
	        var key = props[index];
	        if (isArr) {
	          result[index] = isIndex(key, length) ? collection[key] : undefined;
	        } else {
	          result[index] = isNil ? undefined : collection[key];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property names to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @returns {Object} Returns `object`.
	     */
	    function baseCopy(source, props, object) {
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	        object[key] = source[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `_.callback` which supports specifying the
	     * number of arguments to provide to `func`.
	     *
	     * @private
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {number} [argCount] The number of arguments to provide to `func`.
	     * @returns {Function} Returns the callback.
	     */
	    function baseCallback(func, thisArg, argCount) {
	      var type = typeof func;
	      if (type == 'function') {
	        return thisArg === undefined
	          ? func
	          : bindCallback(func, thisArg, argCount);
	      }
	      if (func == null) {
	        return identity;
	      }
	      if (type == 'object') {
	        return baseMatches(func);
	      }
	      return thisArg === undefined
	        ? property(func)
	        : baseMatchesProperty(func, thisArg);
	    }
	
	    /**
	     * The base implementation of `_.clone` without support for argument juggling
	     * and `this` binding `customizer` functions.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @param {Function} [customizer] The function to customize cloning values.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The object `value` belongs to.
	     * @param {Array} [stackA=[]] Tracks traversed source objects.
	     * @param {Array} [stackB=[]] Associates clones with source counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, isDeep, customizer, key, object, stackA, stackB) {
	      var result;
	      if (customizer) {
	        result = object ? customizer(value, key, object) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return arrayCopy(value, result);
	        }
	      } else {
	        var tag = objToString.call(value),
	            isFunc = tag == funcTag;
	
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = initCloneObject(isFunc ? {} : value);
	          if (!isDeep) {
	            return baseAssign(result, value);
	          }
	        } else {
	          return cloneableTags[tag]
	            ? initCloneByTag(value, tag, isDeep)
	            : (object ? value : {});
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stackA || (stackA = []);
	      stackB || (stackB = []);
	
	      var length = stackA.length;
	      while (length--) {
	        if (stackA[length] == value) {
	          return stackB[length];
	        }
	      }
	      // Add the source value to the stack of traversed objects and associate it with its clone.
	      stackA.push(value);
	      stackB.push(result);
	
	      // Recursively populate clone (susceptible to call stack limits).
	      (isArr ? arrayEach : baseForOwn)(value, function(subValue, key) {
	        result[key] = baseClone(subValue, isDeep, customizer, key, value, stackA, stackB);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} prototype The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(prototype) {
	        if (isObject(prototype)) {
	          object.prototype = prototype;
	          var result = new object;
	          object.prototype = undefined;
	        }
	        return result || {};
	      };
	    }());
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts an index
	     * of where to slice the arguments to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Object} args The arguments provide to `func`.
	     * @returns {number} Returns the timer id.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of `_.difference` which accepts a single array
	     * of values to exclude.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values) {
	      var length = array ? array.length : 0,
	          result = [];
	
	      if (!length) {
	        return result;
	      }
	      var index = -1,
	          indexOf = getIndexOf(),
	          isCommon = indexOf == baseIndexOf,
	          cache = (isCommon && values.length >= LARGE_ARRAY_SIZE) ? createCache(values) : null,
	          valuesLength = values.length;
	
	      if (cache) {
	        indexOf = cacheIndexOf;
	        isCommon = false;
	        values = cache;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index];
	
	        if (isCommon && value === value) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === value) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (indexOf(values, value, 0) < 0) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object|string} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object|string} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * Gets the extremum value of `collection` invoking `iteratee` for each value
	     * in `collection` to generate the criterion by which the value is ranked.
	     * The `iteratee` is invoked with three arguments: (value, index|key, collection).
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} comparator The function used to compare values.
	     * @param {*} exValue The initial extremum value.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(collection, iteratee, comparator, exValue) {
	      var computed = exValue,
	          result = computed;
	
	      baseEach(collection, function(value, index, collection) {
	        var current = +iteratee(value, index, collection);
	        if (comparator(current, computed) || (current === exValue && current === result)) {
	          computed = current;
	          result = value;
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = start == null ? 0 : (+start || 0);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : (+end || 0);
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : (end >>> 0);
	      start >>>= 0;
	
	      while (start < length) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.find`, `_.findLast`, `_.findKey`, and `_.findLastKey`,
	     * without support for callback shorthands and `this` binding, which iterates
	     * over `collection` using the provided `eachFunc`.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {Function} eachFunc The function to iterate over `collection`.
	     * @param {boolean} [retKey] Specify returning the key of the found element
	     *  instead of the element itself.
	     * @returns {*} Returns the found element or its key, else `undefined`.
	     */
	    function baseFind(collection, predicate, eachFunc, retKey) {
	      var result;
	      eachFunc(collection, function(value, key, collection) {
	        if (predicate(value, key, collection)) {
	          result = retKey ? key : value;
	          return false;
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with added support for restricting
	     * flattening and specifying the start index.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {boolean} [isDeep] Specify a deep flatten.
	     * @param {boolean} [isStrict] Restrict flattening to arrays-like objects.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, isDeep, isStrict, result) {
	      result || (result = []);
	
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index];
	        if (isObjectLike(value) && isArrayLike(value) &&
	            (isStrict || isArray(value) || isArguments(value))) {
	          if (isDeep) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, isDeep, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForIn` and `baseForOwn` which iterates
	     * over `object` properties returned by `keysFunc` invoking `iteratee` for
	     * each property. Iteratee functions may exit iteration early by explicitly
	     * returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forIn` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForIn(object, iteratee) {
	      return baseFor(object, iteratee, keysIn);
	    }
	
	    /**
	     * The base implementation of `_.forOwn` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from those provided.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the new array of filtered property names.
	     */
	    function baseFunctions(object, props) {
	      var index = -1,
	          length = props.length,
	          resIndex = -1,
	          result = [];
	
	      while (++index < length) {
	        var key = props[index];
	        if (isFunction(object[key])) {
	          result[++resIndex] = key;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `get` without support for string paths
	     * and default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path of the property to get.
	     * @param {string} [pathKey] The key representation of path.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path, pathKey) {
	      if (object == null) {
	        return;
	      }
	      if (pathKey !== undefined && pathKey in toObject(object)) {
	        path = [pathKey];
	      }
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[path[index++]];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` without support for `this` binding
	     * `customizer` functions.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparing values.
	     * @param {boolean} [isLoose] Specify performing partial comparisons.
	     * @param {Array} [stackA] Tracks traversed `value` objects.
	     * @param {Array} [stackB] Tracks traversed `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, customizer, isLoose, stackA, stackB) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, baseIsEqual, customizer, isLoose, stackA, stackB);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} [customizer] The function to customize comparing objects.
	     * @param {boolean} [isLoose] Specify performing partial comparisons.
	     * @param {Array} [stackA=[]] Tracks traversed `value` objects.
	     * @param {Array} [stackB=[]] Tracks traversed `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = arrayTag,
	          othTag = arrayTag;
	
	      if (!objIsArr) {
	        objTag = objToString.call(object);
	        if (objTag == argsTag) {
	          objTag = objectTag;
	        } else if (objTag != objectTag) {
	          objIsArr = isTypedArray(object);
	        }
	      }
	      if (!othIsArr) {
	        othTag = objToString.call(other);
	        if (othTag == argsTag) {
	          othTag = objectTag;
	        } else if (othTag != objectTag) {
	          othIsArr = isTypedArray(other);
	        }
	      }
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && !(objIsArr || objIsObj)) {
	        return equalByTag(object, other, objTag);
	      }
	      if (!isLoose) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          return equalFunc(objIsWrapped ? object.value() : object, othIsWrapped ? other.value() : other, customizer, isLoose, stackA, stackB);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      // For more information on detecting circular references see https://es5.github.io/#JO.
	      stackA || (stackA = []);
	      stackB || (stackB = []);
	
	      var length = stackA.length;
	      while (length--) {
	        if (stackA[length] == object) {
	          return stackB[length] == other;
	        }
	      }
	      // Add `object` and `other` to the stack of traversed objects.
	      stackA.push(object);
	      stackB.push(other);
	
	      var result = (objIsArr ? equalArrays : equalObjects)(object, other, equalFunc, customizer, isLoose, stackA, stackB);
	
	      stackA.pop();
	      stackB.pop();
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} matchData The propery names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparing objects.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = toObject(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var result = customizer ? customizer(objValue, srcValue, key) : undefined;
	          if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, true) : result)) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for callback shorthands
	     * and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which does not clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        var key = matchData[0][0],
	            value = matchData[0][1];
	
	        return function(object) {
	          if (object == null) {
	            return false;
	          }
	          return object[key] === value && (value !== undefined || (key in toObject(object)));
	        };
	      }
	      return function(object) {
	        return baseIsMatch(object, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which does not clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to compare.
	     * @returns {Function} Returns the new function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      var isArr = isArray(path),
	          isCommon = isKey(path) && isStrictComparable(srcValue),
	          pathKey = (path + '');
	
	      path = toPath(path);
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        var key = pathKey;
	        object = toObject(object);
	        if ((isArr || !isCommon) && !(key in object)) {
	          object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	          if (object == null) {
	            return false;
	          }
	          key = last(path);
	          object = toObject(object);
	        }
	        return object[key] === srcValue
	          ? (srcValue !== undefined || (key in object))
	          : baseIsEqual(srcValue, object[key], undefined, true);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for argument juggling,
	     * multiple sources, and `this` binding `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Array} [stackA=[]] Tracks traversed source objects.
	     * @param {Array} [stackB=[]] Associates values with source counterparts.
	     * @returns {Object} Returns `object`.
	     */
	    function baseMerge(object, source, customizer, stackA, stackB) {
	      if (!isObject(object)) {
	        return object;
	      }
	      var isSrcArr = isArrayLike(source) && (isArray(source) || isTypedArray(source)),
	          props = isSrcArr ? undefined : keys(source);
	
	      arrayEach(props || source, function(srcValue, key) {
	        if (props) {
	          key = srcValue;
	          srcValue = source[key];
	        }
	        if (isObjectLike(srcValue)) {
	          stackA || (stackA = []);
	          stackB || (stackB = []);
	          baseMergeDeep(object, source, key, baseMerge, customizer, stackA, stackB);
	        }
	        else {
	          var value = object[key],
	              result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
	              isCommon = result === undefined;
	
	          if (isCommon) {
	            result = srcValue;
	          }
	          if ((result !== undefined || (isSrcArr && !(key in object))) &&
	              (isCommon || (result === result ? (result !== value) : (value === value)))) {
	            object[key] = result;
	          }
	        }
	      });
	      return object;
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Array} [stackA=[]] Tracks traversed source objects.
	     * @param {Array} [stackB=[]] Associates values with source counterparts.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseMergeDeep(object, source, key, mergeFunc, customizer, stackA, stackB) {
	      var length = stackA.length,
	          srcValue = source[key];
	
	      while (length--) {
	        if (stackA[length] == srcValue) {
	          object[key] = stackB[length];
	          return;
	        }
	      }
	      var value = object[key],
	          result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
	          isCommon = result === undefined;
	
	      if (isCommon) {
	        result = srcValue;
	        if (isArrayLike(srcValue) && (isArray(srcValue) || isTypedArray(srcValue))) {
	          result = isArray(value)
	            ? value
	            : (isArrayLike(value) ? arrayCopy(value) : []);
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          result = isArguments(value)
	            ? toPlainObject(value)
	            : (isPlainObject(value) ? value : {});
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      // Add the source value to the stack of traversed objects and associate
	      // it with its merged value.
	      stackA.push(srcValue);
	      stackB.push(result);
	
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        object[key] = mergeFunc(result, srcValue, customizer, stackA, stackB);
	      } else if (result === result ? (result !== value) : (value === value)) {
	        object[key] = result;
	      }
	    }
	
	    /**
	     * The base implementation of `_.property` without support for deep paths.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @returns {Function} Returns the new function.
	     */
	    function baseProperty(key) {
	      return function(object) {
	        return object == null ? undefined : object[key];
	      };
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new function.
	     */
	    function basePropertyDeep(path) {
	      var pathKey = (path + '');
	      path = toPath(path);
	      return function(object) {
	        return baseGet(object, path, pathKey);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * index arguments and capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0;
	      while (length--) {
	        var index = indexes[length];
	        if (index != previous && isIndex(index)) {
	          var previous = index;
	          splice.call(array, index, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for argument juggling
	     * and returning floating-point numbers.
	     *
	     * @private
	     * @param {number} min The minimum possible value.
	     * @param {number} max The maximum possible value.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(min, max) {
	      return min + nativeFloor(nativeRandom() * (max - min + 1));
	    }
	
	    /**
	     * The base implementation of `_.reduce` and `_.reduceRight` without support
	     * for callback shorthands and `this` binding, which iterates over `collection`
	     * using the provided `eachFunc`.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {*} accumulator The initial value.
	     * @param {boolean} initFromCollection Specify using the first or last element
	     *  of `collection` as the initial value.
	     * @param {Function} eachFunc The function to iterate over `collection`.
	     * @returns {*} Returns the accumulated value.
	     */
	    function baseReduce(collection, iteratee, accumulator, initFromCollection, eachFunc) {
	      eachFunc(collection, function(value, index, collection) {
	        accumulator = initFromCollection
	          ? (initFromCollection = false, value)
	          : iteratee(accumulator, value, index, collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop detection.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      start = start == null ? 0 : (+start || 0);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : (+end || 0);
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for callback shorthands
	     * and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortBy` which uses `comparer` to define
	     * the sort order of `array` and replaces criteria objects with their
	     * corresponding values.
	     *
	     * @private
	     * @param {Array} array The array to sort.
	     * @param {Function} comparer The function to define sort order.
	     * @returns {Array} Returns `array`.
	     */
	    function baseSortBy(array, comparer) {
	      var length = array.length;
	
	      array.sort(comparer);
	      while (length--) {
	        array[length] = array[length].value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.sortByOrder` without param guards.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {boolean[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseSortByOrder(collection, iteratees, orders) {
	      var callback = getCallback(),
	          index = -1;
	
	      iteratees = arrayMap(iteratees, function(iteratee) { return callback(iteratee); });
	
	      var result = baseMap(collection, function(value) {
	        var criteria = arrayMap(iteratees, function(iteratee) { return iteratee(value); });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.sum` without support for callback shorthands
	     * and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {number} Returns the sum.
	     */
	    function baseSum(collection, iteratee) {
	      var result = 0;
	      baseEach(collection, function(value, index, collection) {
	        result += +iteratee(value, index, collection) || 0;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.uniq` without support for callback shorthands
	     * and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The function invoked per iteration.
	     * @returns {Array} Returns the new duplicate-value-free array.
	     */
	    function baseUniq(array, iteratee) {
	      var index = -1,
	          indexOf = getIndexOf(),
	          length = array.length,
	          isCommon = indexOf == baseIndexOf,
	          isLarge = isCommon && length >= LARGE_ARRAY_SIZE,
	          seen = isLarge ? createCache() : null,
	          result = [];
	
	      if (seen) {
	        indexOf = cacheIndexOf;
	        isCommon = false;
	      } else {
	        isLarge = false;
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value, index, array) : value;
	
	        if (isCommon && value === value) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (indexOf(seen, computed, 0) < 0) {
	          if (iteratee || isLarge) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.values` and `_.valuesIn` which creates an
	     * array of `object` property values corresponding to the property names
	     * of `props`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} props The property names to get values for.
	     * @returns {Object} Returns the array of property values.
	     */
	    function baseValues(object, props) {
	      var index = -1,
	          length = props.length,
	          result = Array(length);
	
	      while (++index < length) {
	        result[index] = object[props[index]];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.dropRightWhile`, `_.dropWhile`, `_.takeRightWhile`,
	     * and `_.takeWhile` without support for callback shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) && predicate(array[index], index, array)) {}
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to peform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      var index = -1,
	          length = actions.length;
	
	      while (++index < length) {
	        var action = actions[index];
	        result = action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }
	      return result;
	    }
	
	    /**
	     * Performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function binaryIndex(array, value, retHighest) {
	      var low = 0,
	          high = array ? array.length : low;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if ((retHighest ? (computed <= value) : (computed < value)) && computed !== null) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return binaryIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * This function is like `binaryIndex` except that it invokes `iteratee` for
	     * `value` and each element of `array` to compute their sort ranking. The
	     * iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function binaryIndexBy(array, value, iteratee, retHighest) {
	      value = iteratee(value);
	
	      var low = 0,
	          high = array ? array.length : 0,
	          valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsUndef = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            isDef = computed !== undefined,
	            isReflexive = computed === computed;
	
	        if (valIsNaN) {
	          var setLow = isReflexive || retHighest;
	        } else if (valIsNull) {
	          setLow = isReflexive && isDef && (retHighest || computed != null);
	        } else if (valIsUndef) {
	          setLow = isReflexive && (retHighest || isDef);
	        } else if (computed == null) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * A specialized version of `baseCallback` which only supports `this` binding
	     * and specifying the number of arguments to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {number} [argCount] The number of arguments to provide to `func`.
	     * @returns {Function} Returns the callback.
	     */
	    function bindCallback(func, thisArg, argCount) {
	      if (typeof func != 'function') {
	        return identity;
	      }
	      if (thisArg === undefined) {
	        return func;
	      }
	      switch (argCount) {
	        case 1: return function(value) {
	          return func.call(thisArg, value);
	        };
	        case 3: return function(value, index, collection) {
	          return func.call(thisArg, value, index, collection);
	        };
	        case 4: return function(accumulator, value, index, collection) {
	          return func.call(thisArg, accumulator, value, index, collection);
	        };
	        case 5: return function(value, other, key, object, source) {
	          return func.call(thisArg, value, other, key, object, source);
	        };
	      }
	      return function() {
	        return func.apply(thisArg, arguments);
	      };
	    }
	
	    /**
	     * Creates a clone of the given array buffer.
	     *
	     * @private
	     * @param {ArrayBuffer} buffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function bufferClone(buffer) {
	      var result = new ArrayBuffer(buffer.byteLength),
	          view = new Uint8Array(result);
	
	      view.set(new Uint8Array(buffer));
	      return result;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array|Object} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders) {
	      var holdersLength = holders.length,
	          argsIndex = -1,
	          argsLength = nativeMax(args.length - holdersLength, 0),
	          leftIndex = -1,
	          leftLength = partials.length,
	          result = Array(leftLength + argsLength);
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        result[holders[argsIndex]] = args[argsIndex];
	      }
	      while (argsLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array|Object} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders) {
	      var holdersIndex = -1,
	          holdersLength = holders.length,
	          argsIndex = -1,
	          argsLength = nativeMax(args.length - holdersLength, 0),
	          rightIndex = -1,
	          rightLength = partials.length,
	          result = Array(argsLength + rightLength);
	
	      while (++argsIndex < argsLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        result[offset + holders[holdersIndex]] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * Creates a `_.countBy`, `_.groupBy`, `_.indexBy`, or `_.partition` function.
	     *
	     * @private
	     * @param {Function} setter The function to set keys and values of the accumulator object.
	     * @param {Function} [initializer] The function to initialize the accumulator object.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee, thisArg) {
	        var result = initializer ? initializer() : {};
	        iteratee = getCallback(iteratee, thisArg, 3);
	
	        if (isArray(collection)) {
	          var index = -1,
	              length = collection.length;
	
	          while (++index < length) {
	            var value = collection[index];
	            setter(result, value, iteratee(value, index, collection), collection);
	          }
	        } else {
	          baseEach(collection, function(value, key, collection) {
	            setter(result, value, iteratee(value, key, collection), collection);
	          });
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a `_.assign`, `_.defaults`, or `_.merge` function.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return restParam(function(object, sources) {
	        var index = -1,
	            length = object == null ? 0 : sources.length,
	            customizer = length > 2 ? sources[length - 2] : undefined,
	            guard = length > 2 ? sources[2] : undefined,
	            thisArg = length > 1 ? sources[length - 1] : undefined;
	
	        if (typeof customizer == 'function') {
	          customizer = bindCallback(customizer, thisArg, 5);
	          length -= 2;
	        } else {
	          customizer = typeof thisArg == 'function' ? thisArg : undefined;
	          length -= (customizer ? 1 : 0);
	        }
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        var length = collection ? getLength(collection) : 0;
	        if (!isLength(length)) {
	          return eachFunc(collection, iteratee);
	        }
	        var index = fromRight ? length : -1,
	            iterable = toObject(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for `_.forIn` or `_.forInRight`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var iterable = toObject(object),
	            props = keysFunc(object),
	            length = props.length,
	            index = fromRight ? length : -1;
	
	        while ((fromRight ? index-- : ++index < length)) {
	          var key = props[index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` and invokes it with the `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to bind.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new bound function.
	     */
	    function createBindWrapper(func, thisArg) {
	      var Ctor = createCtorWrapper(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(thisArg, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `Set` cache object to optimize linear searches of large arrays.
	     *
	     * @private
	     * @param {Array} [values] The values to cache.
	     * @returns {null|Object} Returns the new cache object if `Set` is supported, else `null`.
	     */
	    function createCache(values) {
	      return (nativeCreate && Set) ? new SetCache(values) : null;
	    }
	
	    /**
	     * Creates a function that produces compound words out of the words in a
	     * given string.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        var index = -1,
	            array = words(deburr(string)),
	            length = array.length,
	            result = '';
	
	        while (++index < length) {
	          result = callback(result, array[index], index);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtorWrapper(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors.
	        // See http://ecma-international.org/ecma-262/6.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a `_.curry` or `_.curryRight` function.
	     *
	     * @private
	     * @param {boolean} flag The curry bit flag.
	     * @returns {Function} Returns the new curry function.
	     */
	    function createCurry(flag) {
	      function curryFunc(func, arity, guard) {
	        if (guard && isIterateeCall(func, arity, guard)) {
	          arity = undefined;
	        }
	        var result = createWrapper(func, flag, undefined, undefined, undefined, undefined, undefined, arity);
	        result.placeholder = curryFunc.placeholder;
	        return result;
	      }
	      return curryFunc;
	    }
	
	    /**
	     * Creates a `_.defaults` or `_.defaultsDeep` function.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Function} Returns the new defaults function.
	     */
	    function createDefaults(assigner, customizer) {
	      return restParam(function(args) {
	        var object = args[0];
	        if (object == null) {
	          return object;
	        }
	        args.push(customizer);
	        return assigner.apply(undefined, args);
	      });
	    }
	
	    /**
	     * Creates a `_.max` or `_.min` function.
	     *
	     * @private
	     * @param {Function} comparator The function used to compare values.
	     * @param {*} exValue The initial extremum value.
	     * @returns {Function} Returns the new extremum function.
	     */
	    function createExtremum(comparator, exValue) {
	      return function(collection, iteratee, thisArg) {
	        if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
	          iteratee = undefined;
	        }
	        iteratee = getCallback(iteratee, thisArg, 3);
	        if (iteratee.length == 1) {
	          collection = isArray(collection) ? collection : toIterable(collection);
	          var result = arrayExtremum(collection, iteratee, comparator, exValue);
	          if (!(collection.length && result === exValue)) {
	            return result;
	          }
	        }
	        return baseExtremum(collection, iteratee, comparator, exValue);
	      };
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(eachFunc, fromRight) {
	      return function(collection, predicate, thisArg) {
	        predicate = getCallback(predicate, thisArg, 3);
	        if (isArray(collection)) {
	          var index = baseFindIndex(collection, predicate, fromRight);
	          return index > -1 ? collection[index] : undefined;
	        }
	        return baseFind(collection, predicate, eachFunc);
	      };
	    }
	
	    /**
	     * Creates a `_.findIndex` or `_.findLastIndex` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFindIndex(fromRight) {
	      return function(array, predicate, thisArg) {
	        if (!(array && array.length)) {
	          return -1;
	        }
	        predicate = getCallback(predicate, thisArg, 3);
	        return baseFindIndex(array, predicate, fromRight);
	      };
	    }
	
	    /**
	     * Creates a `_.findKey` or `_.findLastKey` function.
	     *
	     * @private
	     * @param {Function} objectFunc The function to iterate over an object.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFindKey(objectFunc) {
	      return function(object, predicate, thisArg) {
	        predicate = getCallback(predicate, thisArg, 3);
	        return baseFind(object, predicate, objectFunc, true);
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return function() {
	        var wrapper,
	            length = arguments.length,
	            index = fromRight ? length : -1,
	            leftIndex = 0,
	            funcs = Array(length);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          var func = funcs[leftIndex++] = arguments[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (!wrapper && LodashWrapper.prototype.thru && getFuncName(func) == 'wrapper') {
	            wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? -1 : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) && data[1] == (ARY_FLAG | CURRY_FLAG | PARTIAL_FLAG | REARG_FLAG) && !data[4].length && data[9] == 1) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func)) ? wrapper[funcName]() : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 && isArray(value) && value.length >= LARGE_ARRAY_SIZE) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      };
	    }
	
	    /**
	     * Creates a function for `_.forEach` or `_.forEachRight`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over an array.
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @returns {Function} Returns the new each function.
	     */
	    function createForEach(arrayFunc, eachFunc) {
	      return function(collection, iteratee, thisArg) {
	        return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
	          ? arrayFunc(collection, iteratee)
	          : eachFunc(collection, bindCallback(iteratee, thisArg, 3));
	      };
	    }
	
	    /**
	     * Creates a function for `_.forIn` or `_.forInRight`.
	     *
	     * @private
	     * @param {Function} objectFunc The function to iterate over an object.
	     * @returns {Function} Returns the new each function.
	     */
	    function createForIn(objectFunc) {
	      return function(object, iteratee, thisArg) {
	        if (typeof iteratee != 'function' || thisArg !== undefined) {
	          iteratee = bindCallback(iteratee, thisArg, 3);
	        }
	        return objectFunc(object, iteratee, keysIn);
	      };
	    }
	
	    /**
	     * Creates a function for `_.forOwn` or `_.forOwnRight`.
	     *
	     * @private
	     * @param {Function} objectFunc The function to iterate over an object.
	     * @returns {Function} Returns the new each function.
	     */
	    function createForOwn(objectFunc) {
	      return function(object, iteratee, thisArg) {
	        if (typeof iteratee != 'function' || thisArg !== undefined) {
	          iteratee = bindCallback(iteratee, thisArg, 3);
	        }
	        return objectFunc(object, iteratee);
	      };
	    }
	
	    /**
	     * Creates a function for `_.mapKeys` or `_.mapValues`.
	     *
	     * @private
	     * @param {boolean} [isMapKeys] Specify mapping keys instead of values.
	     * @returns {Function} Returns the new map function.
	     */
	    function createObjectMapper(isMapKeys) {
	      return function(object, iteratee, thisArg) {
	        var result = {};
	        iteratee = getCallback(iteratee, thisArg, 3);
	
	        baseForOwn(object, function(value, key, object) {
	          var mapped = iteratee(value, key, object);
	          key = isMapKeys ? mapped : key;
	          value = isMapKeys ? value : mapped;
	          result[key] = value;
	        });
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function for `_.padLeft` or `_.padRight`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify padding from the right.
	     * @returns {Function} Returns the new pad function.
	     */
	    function createPadDir(fromRight) {
	      return function(string, length, chars) {
	        string = baseToString(string);
	        return (fromRight ? string : '') + createPadding(string, length, chars) + (fromRight ? '' : string);
	      };
	    }
	
	    /**
	     * Creates a `_.partial` or `_.partialRight` function.
	     *
	     * @private
	     * @param {boolean} flag The partial bit flag.
	     * @returns {Function} Returns the new partial function.
	     */
	    function createPartial(flag) {
	      var partialFunc = restParam(function(func, partials) {
	        var holders = replaceHolders(partials, partialFunc.placeholder);
	        return createWrapper(func, flag, undefined, partials, holders);
	      });
	      return partialFunc;
	    }
	
	    /**
	     * Creates a function for `_.reduce` or `_.reduceRight`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over an array.
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @returns {Function} Returns the new each function.
	     */
	    function createReduce(arrayFunc, eachFunc) {
	      return function(collection, iteratee, accumulator, thisArg) {
	        var initFromArray = arguments.length < 3;
	        return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
	          ? arrayFunc(collection, iteratee, accumulator, initFromArray)
	          : baseReduce(collection, getCallback(iteratee, thisArg, 4), accumulator, initFromArray, eachFunc);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` and invokes it with optional `this`
	     * binding of, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to reference.
	     * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybridWrapper(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & ARY_FLAG,
	          isBind = bitmask & BIND_FLAG,
	          isBindKey = bitmask & BIND_KEY_FLAG,
	          isCurry = bitmask & CURRY_FLAG,
	          isCurryBound = bitmask & CURRY_BOUND_FLAG,
	          isCurryRight = bitmask & CURRY_RIGHT_FLAG,
	          Ctor = isBindKey ? undefined : createCtorWrapper(func);
	
	      function wrapper() {
	        // Avoid `arguments` object use disqualifying optimizations by
	        // converting it to an array before providing it to other functions.
	        var length = arguments.length,
	            index = length,
	            args = Array(length);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight);
	        }
	        if (isCurry || isCurryRight) {
	          var placeholder = wrapper.placeholder,
	              argsHolders = replaceHolders(args, placeholder);
	
	          length -= argsHolders.length;
	          if (length < arity) {
	            var newArgPos = argPos ? arrayCopy(argPos) : undefined,
	                newArity = nativeMax(arity - length, 0),
	                newsHolders = isCurry ? argsHolders : undefined,
	                newHoldersRight = isCurry ? undefined : argsHolders,
	                newPartials = isCurry ? args : undefined,
	                newPartialsRight = isCurry ? undefined : args;
	
	            bitmask |= (isCurry ? PARTIAL_FLAG : PARTIAL_RIGHT_FLAG);
	            bitmask &= ~(isCurry ? PARTIAL_RIGHT_FLAG : PARTIAL_FLAG);
	
	            if (!isCurryBound) {
	              bitmask &= ~(BIND_FLAG | BIND_KEY_FLAG);
	            }
	            var newData = [func, bitmask, thisArg, newPartials, newsHolders, newPartialsRight, newHoldersRight, newArgPos, ary, newArity],
	                result = createHybridWrapper.apply(undefined, newData);
	
	            if (isLaziable(func)) {
	              setData(result, newData);
	            }
	            result.placeholder = placeholder;
	            return result;
	          }
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        if (argPos) {
	          args = reorder(args, argPos);
	        }
	        if (isAry && ary < args.length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtorWrapper(func);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates the padding required for `string` based on the given `length`.
	     * The `chars` string is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {string} string The string to create padding for.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the pad for `string`.
	     */
	    function createPadding(string, length, chars) {
	      var strLength = string.length;
	      length = +length;
	
	      if (strLength >= length || !nativeIsFinite(length)) {
	        return '';
	      }
	      var padLength = length - strLength;
	      chars = chars == null ? ' ' : (chars + '');
	      return repeat(chars, nativeCeil(padLength / chars.length)).slice(0, padLength);
	    }
	
	    /**
	     * Creates a function that wraps `func` and invokes it with the optional `this`
	     * binding of `thisArg` and the `partials` prepended to those provided to
	     * the wrapper.
	     *
	     * @private
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to the new function.
	     * @returns {Function} Returns the new bound function.
	     */
	    function createPartialWrapper(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & BIND_FLAG,
	          Ctor = createCtorWrapper(func);
	
	      function wrapper() {
	        // Avoid `arguments` object use disqualifying optimizations by
	        // converting it to an array before providing it `func`.
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength);
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.ceil`, `_.floor`, or `_.round` function.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        precision = precision === undefined ? 0 : (+precision || 0);
	        if (precision) {
	          precision = pow(10, precision);
	          return func(number * precision) / precision;
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a `_.sortedIndex` or `_.sortedLastIndex` function.
	     *
	     * @private
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {Function} Returns the new index function.
	     */
	    function createSortedIndex(retHighest) {
	      return function(array, value, iteratee, thisArg) {
	        var callback = getCallback(iteratee);
	        return (iteratee == null && callback === baseCallback)
	          ? binaryIndex(array, value, retHighest)
	          : binaryIndexBy(array, value, callback(iteratee, thisArg, 1), retHighest);
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to reference.
	     * @param {number} bitmask The bitmask of flags.
	     *  The bitmask may be composed of the following flags:
	     *     1 - `_.bind`
	     *     2 - `_.bindKey`
	     *     4 - `_.curry` or `_.curryRight` of a bound function
	     *     8 - `_.curry`
	     *    16 - `_.curryRight`
	     *    32 - `_.partial`
	     *    64 - `_.partialRight`
	     *   128 - `_.rearg`
	     *   256 - `_.ary`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrapper(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(PARTIAL_FLAG | PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      length -= (holders ? holders.length : 0);
	      if (bitmask & PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func),
	          newData = [func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity];
	
	      if (data) {
	        mergeData(newData, data);
	        bitmask = newData[1];
	        arity = newData[9];
	      }
	      newData[9] = arity == null
	        ? (isBindKey ? 0 : func.length)
	        : (nativeMax(arity - length, 0) || 0);
	
	      if (bitmask == BIND_FLAG) {
	        var result = createBindWrapper(newData[0], newData[2]);
	      } else if ((bitmask == PARTIAL_FLAG || bitmask == (BIND_FLAG | PARTIAL_FLAG)) && !newData[4].length) {
	        result = createPartialWrapper.apply(undefined, newData);
	      } else {
	        result = createHybridWrapper.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setter(result, newData);
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} [customizer] The function to customize comparing arrays.
	     * @param {boolean} [isLoose] Specify performing partial comparisons.
	     * @param {Array} [stackA] Tracks traversed `value` objects.
	     * @param {Array} [stackB] Tracks traversed `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, equalFunc, customizer, isLoose, stackA, stackB) {
	      var index = -1,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isLoose && othLength > arrLength)) {
	        return false;
	      }
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index],
	            result = customizer ? customizer(isLoose ? othValue : arrValue, isLoose ? arrValue : othValue, index) : undefined;
	
	        if (result !== undefined) {
	          if (result) {
	            continue;
	          }
	          return false;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (isLoose) {
	          if (!arraySome(other, function(othValue) {
	                return arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB);
	              })) {
	            return false;
	          }
	        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB))) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag) {
	      switch (tag) {
	        case boolTag:
	        case dateTag:
	          // Coerce dates and booleans to numbers, dates to milliseconds and booleans
	          // to `1` or `0` treating invalid dates coerced to `NaN` as not equal.
	          return +object == +other;
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case numberTag:
	          // Treat `NaN` vs. `NaN` as equal.
	          return (object != +object)
	            ? other != +other
	            : object == +other;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings primitives and string
	          // objects as equal. See https://es5.github.io/#x15.10.6.4 for more details.
	          return object == (other + '');
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} [customizer] The function to customize comparing values.
	     * @param {boolean} [isLoose] Specify performing partial comparisons.
	     * @param {Array} [stackA] Tracks traversed `value` objects.
	     * @param {Array} [stackB] Tracks traversed `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
	      var objProps = keys(object),
	          objLength = objProps.length,
	          othProps = keys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isLoose) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isLoose ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      var skipCtor = isLoose;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key],
	            result = customizer ? customizer(isLoose ? othValue : objValue, isLoose? objValue : othValue, key) : undefined;
	
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(result === undefined ? equalFunc(objValue, othValue, customizer, isLoose, stackA, stackB) : result)) {
	          return false;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (!skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Gets the appropriate "callback" function. If the `_.callback` method is
	     * customized this function returns the custom method, otherwise it returns
	     * the `baseCallback` function. If arguments are provided the chosen function
	     * is invoked with them and its result is returned.
	     *
	     * @private
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getCallback(func, thisArg, argCount) {
	      var result = lodash.callback || callback;
	      result = result === callback ? baseCallback : result;
	      return argCount ? result(func, thisArg, argCount) : result;
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = func.name,
	          array = realNames[result],
	          length = array ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the appropriate "indexOf" function. If the `_.indexOf` method is
	     * customized this function returns the custom method, otherwise it returns
	     * the `baseIndexOf` function. If arguments are provided the chosen function
	     * is invoked with them and its result is returned.
	     *
	     * @private
	     * @returns {Function|number} Returns the chosen function or its result.
	     */
	    function getIndexOf(collection, target, fromIndex) {
	      var result = lodash.indexOf || indexOf;
	      result = result === indexOf ? baseIndexOf : result;
	      return collection ? result(collection, target, fromIndex) : result;
	    }
	
	    /**
	     * Gets the "length" property value of `object`.
	     *
	     * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
	     * that affects Safari on at least iOS 8.1-8.3 ARM64.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {*} Returns the "length" value.
	     */
	    var getLength = baseProperty('length');
	
	    /**
	     * Gets the propery names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = pairs(object),
	          length = result.length;
	
	      while (length--) {
	        result[length][2] = isStrictComparable(result[length][1]);
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = object == null ? undefined : object[key];
	      return isNative(value) ? value : undefined;
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = new array.constructor(length);
	
	      // Add array properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      var Ctor = object.constructor;
	      if (!(typeof Ctor == 'function' && Ctor instanceof Ctor)) {
	        Ctor = Object;
	      }
	      return new Ctor;
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return bufferClone(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          var buffer = object.buffer;
	          return new Ctor(isDeep ? bufferClone(buffer) : buffer, object.byteOffset, object.length);
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          var result = new Ctor(object.source, reFlags.exec(object));
	          result.lastIndex = object.lastIndex;
	      }
	      return result;
	    }
	
	    /**
	     * Invokes the method at `path` on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function invokePath(object, path, args) {
	      if (object != null && !isKey(path, object)) {
	        path = toPath(path);
	        object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	        path = last(path);
	      }
	      var func = object == null ? object : object[path];
	      return func == null ? undefined : func.apply(object, args);
	    }
	
	    /**
	     * Checks if `value` is array-like.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(getLength(value));
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
	      length = length == null ? MAX_SAFE_INTEGER : length;
	      return value > -1 && value % 1 == 0 && value < length;
	    }
	
	    /**
	     * Checks if the provided arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call, else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	          ? (isArrayLike(object) && isIndex(index, object.length))
	          : (type == 'string' && index in object)) {
	        var other = object[index];
	        return value === value ? (value === other) : (other !== other);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      var type = typeof value;
	      if ((type == 'string' && reIsPlainProp.test(value)) || type == 'number') {
	        return true;
	      }
	      if (isArray(value)) {
	        return false;
	      }
	      var result = !reIsDeepProp.test(value);
	      return result || (object != null && value in toObject(object));
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart, else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func);
	      if (!(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      var other = lodash[funcName];
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     */
	    function isLength(value) {
	      return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers required to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and `_.rearg`
	     * augment function arguments, making the order in which they are executed important,
	     * preventing the merging of metadata. However, we make an exception for a safe
	     * common case where curried functions have `_.ary` and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < ARY_FLAG;
	
	      var isCombo =
	        (srcBitmask == ARY_FLAG && bitmask == CURRY_FLAG) ||
	        (srcBitmask == ARY_FLAG && bitmask == REARG_FLAG && data[7].length <= source[8]) ||
	        (srcBitmask == (ARY_FLAG | REARG_FLAG) && bitmask == CURRY_FLAG);
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= (bitmask & BIND_FLAG) ? 0 : CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : arrayCopy(value);
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : arrayCopy(source[4]);
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : arrayCopy(value);
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : arrayCopy(source[6]);
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = arrayCopy(value);
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use.
	     *
	     * @private
	     * @param {*} objectValue The destination object property value.
	     * @param {*} sourceValue The source object property value.
	     * @returns {*} Returns the value to assign to the destination object.
	     */
	    function mergeDefaults(objectValue, sourceValue) {
	      return objectValue === undefined ? sourceValue : merge(objectValue, sourceValue, mergeDefaults);
	    }
	
	    /**
	     * A specialized version of `_.pick` which picks `object` properties specified
	     * by `props`.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} props The property names to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function pickByArray(object, props) {
	      object = toObject(object);
	
	      var index = -1,
	          length = props.length,
	          result = {};
	
	      while (++index < length) {
	        var key = props[index];
	        if (key in object) {
	          result[key] = object[key];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.pick` which picks `object` properties `predicate`
	     * returns truthy for.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Object} Returns the new object.
	     */
	    function pickByCallback(object, predicate) {
	      var result = {};
	      baseForIn(object, function(value, key, object) {
	        if (predicate(value, key, object)) {
	          result[key] = value;
	        }
	      });
	      return result;
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = arrayCopy(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity function
	     * to avoid garbage collection pauses in V8. See [V8 issue 2070](https://code.google.com/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = (function() {
	      var count = 0,
	          lastCalled = 0;
	
	      return function(key, value) {
	        var stamp = now(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return key;
	          }
	        } else {
	          count = 0;
	        }
	        return baseSetData(key, value);
	      };
	    }());
	
	    /**
	     * A fallback implementation of `Object.keys` which creates an array of the
	     * own enumerable property names of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function shimKeys(object) {
	      var props = keysIn(object),
	          propsLength = props.length,
	          length = propsLength && object.length;
	
	      var allowIndexes = !!length && isLength(length) &&
	        (isArray(object) || isArguments(object));
	
	      var index = -1,
	          result = [];
	
	      while (++index < propsLength) {
	        var key = props[index];
	        if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to an array-like object if it's not one.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {Array|Object} Returns the array-like object.
	     */
	    function toIterable(value) {
	      if (value == null) {
	        return [];
	      }
	      if (!isArrayLike(value)) {
	        return values(value);
	      }
	      return isObject(value) ? value : Object(value);
	    }
	
	    /**
	     * Converts `value` to an object if it's not one.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {Object} Returns the object.
	     */
	    function toObject(value) {
	      return isObject(value) ? value : Object(value);
	    }
	
	    /**
	     * Converts `value` to property path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {Array} Returns the property path array.
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return value;
	      }
	      var result = [];
	      baseToString(value).replace(rePropName, function(match, number, quote, string) {
	        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      return wrapper instanceof LazyWrapper
	        ? wrapper.clone()
	        : new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__, arrayCopy(wrapper.__actions__));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `collection` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the new array containing chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if (guard ? isIterateeCall(array, size, guard) : size == null) {
	        size = 1;
	      } else {
	        size = nativeMax(nativeFloor(size) || 1, 1);
	      }
	      var index = 0,
	          length = array ? array.length : 0,
	          resIndex = -1,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[++resIndex] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array ? array.length : 0,
	          resIndex = -1,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[++resIndex] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of unique `array` values not included in the other
	     * provided arrays using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The arrays of values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.difference([1, 2, 3], [4, 2]);
	     * // => [1, 3]
	     */
	    var difference = restParam(function(array, values) {
	      return (isObjectLike(array) && isArrayLike(array))
	        ? baseDifference(array, baseFlatten(values, false, true))
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (guard ? isIterateeCall(array, n, guard) : n == null) {
	        n = 1;
	      }
	      return baseSlice(array, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (guard ? isIterateeCall(array, n, guard) : n == null) {
	        n = 1;
	      }
	      n = length - (+n || 0);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * bound to `thisArg` and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that match the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRightWhile([1, 2, 3], function(n) {
	     *   return n > 1;
	     * });
	     * // => [1]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.dropRightWhile(users, { 'user': 'pebbles', 'active': false }), 'user');
	     * // => ['barney', 'fred']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.dropRightWhile(users, 'active', false), 'user');
	     * // => ['barney']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.dropRightWhile(users, 'active'), 'user');
	     * // => ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate, thisArg) {
	      return (array && array.length)
	        ? baseWhile(array, getCallback(predicate, thisArg, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * bound to `thisArg` and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropWhile([1, 2, 3], function(n) {
	     *   return n < 3;
	     * });
	     * // => [3]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.dropWhile(users, { 'user': 'barney', 'active': false }), 'user');
	     * // => ['fred', 'pebbles']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.dropWhile(users, 'active', false), 'user');
	     * // => ['pebbles']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.dropWhile(users, 'active'), 'user');
	     * // => ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate, thisArg) {
	      return (array && array.length)
	        ? baseWhile(array, getCallback(predicate, thisArg, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8], '*', 1, 2);
	     * // => [4, '*', 8]
	     */
	    function fill(array, value, start, end) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(chr) {
	     *   return chr.user == 'barney';
	     * });
	     * // => 0
	     *
	     * // using the `_.matches` callback shorthand
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.findIndex(users, 'active', false);
	     * // => 0
	     *
	     * // using the `_.property` callback shorthand
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    var findIndex = createFindIndex();
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(chr) {
	     *   return chr.user == 'pebbles';
	     * });
	     * // => 2
	     *
	     * // using the `_.matches` callback shorthand
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.findLastIndex(users, 'active', false);
	     * // => 2
	     *
	     * // using the `_.property` callback shorthand
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    var findLastIndex = createFindIndex(true);
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @alias head
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.first([1, 2, 3]);
	     * // => 1
	     *
	     * _.first([]);
	     * // => undefined
	     */
	    function first(array) {
	      return array ? array[0] : undefined;
	    }
	
	    /**
	     * Flattens a nested array. If `isDeep` is `true` the array is recursively
	     * flattened, otherwise it is only flattened a single level.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {boolean} [isDeep] Specify a deep flatten.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, 3, [4]]]);
	     * // => [1, 2, 3, [4]]
	     *
	     * // using `isDeep`
	     * _.flatten([1, [2, 3, [4]]], true);
	     * // => [1, 2, 3, 4]
	     */
	    function flatten(array, isDeep, guard) {
	      var length = array ? array.length : 0;
	      if (guard && isIterateeCall(array, isDeep, guard)) {
	        isDeep = false;
	      }
	      return length ? baseFlatten(array, isDeep) : [];
	    }
	
	    /**
	     * Recursively flattens a nested array.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to recursively flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, 3, [4]]]);
	     * // => [1, 2, 3, 4]
	     */
	    function flattenDeep(array) {
	      var length = array ? array.length : 0;
	      return length ? baseFlatten(array, true) : [];
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it is used as the offset
	     * from the end of `array`. If `array` is sorted providing `true` for `fromIndex`
	     * performs a faster binary search.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {*} value The value to search for.
	     * @param {boolean|number} [fromIndex=0] The index to search from or `true`
	     *  to perform a binary search on a sorted array.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // using `fromIndex`
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     *
	     * // performing a binary search
	     * _.indexOf([1, 1, 2, 2], 2, true);
	     * // => 2
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return -1;
	      }
	      if (typeof fromIndex == 'number') {
	        fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : fromIndex;
	      } else if (fromIndex) {
	        var index = binaryIndex(array, value);
	        if (index < length &&
	            (value === value ? (value === array[index]) : (array[index] !== array[index]))) {
	          return index;
	        }
	        return -1;
	      }
	      return baseIndexOf(array, value, fromIndex || 0);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      return dropRight(array, 1);
	    }
	
	    /**
	     * Creates an array of unique values that are included in all of the provided
	     * arrays using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of shared values.
	     * @example
	     * _.intersection([1, 2], [4, 2], [2, 1]);
	     * // => [2]
	     */
	    var intersection = restParam(function(arrays) {
	      var othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(length),
	          indexOf = getIndexOf(),
	          isCommon = indexOf == baseIndexOf,
	          result = [];
	
	      while (othIndex--) {
	        var value = arrays[othIndex] = isArrayLike(value = arrays[othIndex]) ? value : [];
	        caches[othIndex] = (isCommon && value.length >= 120) ? createCache(othIndex && value) : null;
	      }
	      var array = arrays[0],
	          index = -1,
	          length = array ? array.length : 0,
	          seen = caches[0];
	
	      outer:
	      while (++index < length) {
	        value = array[index];
	        if ((seen ? cacheIndexOf(seen, value) : indexOf(result, value, 0)) < 0) {
	          var othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if ((cache ? cacheIndexOf(cache, value) : indexOf(arrays[othIndex], value, 0)) < 0) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(value);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    });
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array ? array.length : 0;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {*} value The value to search for.
	     * @param {boolean|number} [fromIndex=array.length-1] The index to search from
	     *  or `true` to perform a binary search on a sorted array.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // using `fromIndex`
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     *
	     * // performing a binary search
	     * _.lastIndexOf([1, 1, 2, 2], 2, true);
	     * // => 3
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (typeof fromIndex == 'number') {
	        index = (fromIndex < 0 ? nativeMax(length + fromIndex, 0) : nativeMin(fromIndex || 0, length - 1)) + 1;
	      } else if (fromIndex) {
	        index = binaryIndex(array, value, true) - 1;
	        var other = array[index];
	        if (value === value ? (value === other) : (other !== other)) {
	          return index;
	        }
	        return -1;
	      }
	      if (value !== value) {
	        return indexOfNaN(array, index, true);
	      }
	      while (index--) {
	        if (array[index] === value) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Removes all provided values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3, 1, 2, 3];
	     *
	     * _.pull(array, 2, 3);
	     * console.log(array);
	     * // => [1, 1]
	     */
	    function pull() {
	      var args = arguments,
	          array = args[0];
	
	      if (!(array && array.length)) {
	        return array;
	      }
	      var index = 0,
	          indexOf = getIndexOf(),
	          length = args.length;
	
	      while (++index < length) {
	        var fromIndex = 0,
	            value = args[index];
	
	        while ((fromIndex = indexOf(array, value, fromIndex)) > -1) {
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to the given indexes and returns
	     * an array of the removed elements. Indexes may be specified as an array of
	     * indexes or as individual arguments.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove,
	     *  specified as individual indexes or arrays of indexes.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [5, 10, 15, 20];
	     * var evens = _.pullAt(array, 1, 3);
	     *
	     * console.log(array);
	     * // => [5, 15]
	     *
	     * console.log(evens);
	     * // => [10, 20]
	     */
	    var pullAt = restParam(function(array, indexes) {
	      indexes = baseFlatten(indexes);
	
	      var result = baseAt(array, indexes);
	      basePullAt(array, indexes.sort(baseCompareAscending));
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is bound to
	     * `thisArg` and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate, thisArg) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getCallback(predicate, thisArg, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @alias tail
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.rest([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function rest(array) {
	      return drop(array, 1);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of `Array#slice` to support node
	     * lists in IE < 9 and to ensure dense arrays are returned.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value` should
	     * be inserted into `array` in order to maintain its sort order. If an iteratee
	     * function is provided it is invoked for `value` and each element of `array`
	     * to compute their sort ranking. The iteratee is bound to `thisArg` and
	     * invoked with one argument; (value).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     *
	     * _.sortedIndex([4, 4, 5, 5], 5);
	     * // => 2
	     *
	     * var dict = { 'data': { 'thirty': 30, 'forty': 40, 'fifty': 50 } };
	     *
	     * // using an iteratee function
	     * _.sortedIndex(['thirty', 'fifty'], 'forty', function(word) {
	     *   return this.data[word];
	     * }, dict);
	     * // => 1
	     *
	     * // using the `_.property` callback shorthand
	     * _.sortedIndex([{ 'x': 30 }, { 'x': 50 }], { 'x': 40 }, 'x');
	     * // => 1
	     */
	    var sortedIndex = createSortedIndex();
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 4, 5, 5], 5);
	     * // => 4
	     */
	    var sortedLastIndex = createSortedIndex(true);
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (guard ? isIterateeCall(array, n, guard) : n == null) {
	        n = 1;
	      }
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (guard ? isIterateeCall(array, n, guard) : n == null) {
	        n = 1;
	      }
	      n = length - (+n || 0);
	      return baseSlice(array, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is bound to `thisArg`
	     * and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRightWhile([1, 2, 3], function(n) {
	     *   return n > 1;
	     * });
	     * // => [2, 3]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.takeRightWhile(users, { 'user': 'pebbles', 'active': false }), 'user');
	     * // => ['pebbles']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.takeRightWhile(users, 'active', false), 'user');
	     * // => ['fred', 'pebbles']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.takeRightWhile(users, 'active'), 'user');
	     * // => []
	     */
	    function takeRightWhile(array, predicate, thisArg) {
	      return (array && array.length)
	        ? baseWhile(array, getCallback(predicate, thisArg, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is bound to
	     * `thisArg` and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeWhile([1, 2, 3], function(n) {
	     *   return n < 3;
	     * });
	     * // => [1, 2]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false},
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.takeWhile(users, { 'user': 'barney', 'active': false }), 'user');
	     * // => ['barney']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.takeWhile(users, 'active', false), 'user');
	     * // => ['barney', 'fred']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.takeWhile(users, 'active'), 'user');
	     * // => []
	     */
	    function takeWhile(array, predicate, thisArg) {
	      return (array && array.length)
	        ? baseWhile(array, getCallback(predicate, thisArg, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all of the provided arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([1, 2], [4, 2], [2, 1]);
	     * // => [1, 2, 4]
	     */
	    var union = restParam(function(arrays) {
	      return baseUniq(baseFlatten(arrays, false, true));
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurence of each element
	     * is kept. Providing `true` for `isSorted` performs a faster search algorithm
	     * for sorted arrays. If an iteratee function is provided it is invoked for
	     * each element in the array to generate the criterion by which uniqueness
	     * is computed. The `iteratee` is bound to `thisArg` and invoked with three
	     * arguments: (value, index, array).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias unique
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {boolean} [isSorted] Specify the array is sorted.
	     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new duplicate-value-free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     *
	     * // using `isSorted`
	     * _.uniq([1, 1, 2], true);
	     * // => [1, 2]
	     *
	     * // using an iteratee function
	     * _.uniq([1, 2.5, 1.5, 2], function(n) {
	     *   return this.floor(n);
	     * }, Math);
	     * // => [1, 2.5]
	     *
	     * // using the `_.property` callback shorthand
	     * _.uniq([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniq(array, isSorted, iteratee, thisArg) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (isSorted != null && typeof isSorted != 'boolean') {
	        thisArg = iteratee;
	        iteratee = isIterateeCall(array, isSorted, thisArg) ? undefined : isSorted;
	        isSorted = false;
	      }
	      var callback = getCallback();
	      if (!(iteratee == null && callback === baseCallback)) {
	        iteratee = callback(iteratee, thisArg, 3);
	      }
	      return (isSorted && getIndexOf() == baseIndexOf)
	        ? sortedUniq(array, iteratee)
	        : baseUniq(array, iteratee);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['fred', 'barney'], [30, 40], [true, false]);
	     * // => [['fred', 30, true], ['barney', 40, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['fred', 'barney'], [30, 40], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var index = -1,
	          length = 0;
	
	      array = arrayFilter(array, function(group) {
	        if (isArrayLike(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = arrayMap(array, baseProperty(index));
	      }
	      return result;
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts an iteratee to specify
	     * how regrouped values should be combined. The `iteratee` is bound to `thisArg`
	     * and invoked with four arguments: (accumulator, value, index, group).
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee] The function to combine regrouped values.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee, thisArg) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      iteratee = bindCallback(iteratee, thisArg, 4);
	      return arrayMap(result, function(group) {
	        return arrayReduce(group, iteratee, undefined, true);
	      });
	    }
	
	    /**
	     * Creates an array excluding all provided values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to filter.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.without([1, 2, 1, 3], 1, 2);
	     * // => [3]
	     */
	    var without = restParam(function(array, values) {
	      return isArrayLike(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the provided arrays.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of values.
	     * @example
	     *
	     * _.xor([1, 2], [4, 2]);
	     * // => [1, 4]
	     */
	    function xor() {
	      var index = -1,
	          length = arguments.length;
	
	      while (++index < length) {
	        var array = arguments[index];
	        if (isArrayLike(array)) {
	          var result = result
	            ? arrayPush(baseDifference(result, array), baseDifference(array, result))
	            : array;
	        }
	      }
	      return result ? baseUniq(result) : [];
	    }
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the first
	     * elements of the given arrays, the second of which contains the second elements
	     * of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['fred', 'barney'], [30, 40], [true, false]);
	     * // => [['fred', 30, true], ['barney', 40, false]]
	     */
	    var zip = restParam(unzip);
	
	    /**
	     * The inverse of `_.pairs`; this method returns an object composed from arrays
	     * of property names and values. Provide either a single two dimensional array,
	     * e.g. `[[key1, value1], [key2, value2]]` or two arrays, one of property names
	     * and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @alias object
	     * @category Array
	     * @param {Array} props The property names.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject([['fred', 30], ['barney', 40]]);
	     * // => { 'fred': 30, 'barney': 40 }
	     *
	     * _.zipObject(['fred', 'barney'], [30, 40]);
	     * // => { 'fred': 30, 'barney': 40 }
	     */
	    function zipObject(props, values) {
	      var index = -1,
	          length = props ? props.length : 0,
	          result = {};
	
	      if (length && !values && !isArray(props[0])) {
	        values = [];
	      }
	      while (++index < length) {
	        var key = props[index];
	        if (values) {
	          result[key] = values[index];
	        } else if (key) {
	          result[key[0]] = key[1];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an iteratee to specify
	     * how grouped values should be combined. The `iteratee` is bound to `thisArg`
	     * and invoked with four arguments: (accumulator, value, index, group).
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee] The function to combine grouped values.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], _.add);
	     * // => [111, 222]
	     */
	    var zipWith = restParam(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 2 ? arrays[length - 2] : undefined,
	          thisArg = length > 1 ? arrays[length - 1] : undefined;
	
	      if (length > 2 && typeof iteratee == 'function') {
	        length -= 2;
	      } else {
	        iteratee = (length > 1 && typeof thisArg == 'function') ? (--length, thisArg) : undefined;
	        thisArg = undefined;
	      }
	      arrays.length = length;
	      return unzipWith(arrays, iteratee, thisArg);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object that wraps `value` with explicit method
	     * chaining enabled.
	     *
	     * @static
	     * @memberOf _
	     * @category Chain
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _.chain(users)
	     *   .sortBy('age')
	     *   .map(function(chr) {
	     *     return chr.user + ' is ' + chr.age;
	     *   })
	     *   .first()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor is
	     * bound to `thisArg` and invoked with one argument; (value). The purpose of
	     * this method is to "tap into" a method chain in order to perform operations
	     * on intermediate results within the chain.
	     *
	     * @static
	     * @memberOf _
	     * @category Chain
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @param {*} [thisArg] The `this` binding of `interceptor`.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor, thisArg) {
	      interceptor.call(thisArg, value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     *
	     * @static
	     * @memberOf _
	     * @category Chain
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @param {*} [thisArg] The `this` binding of `interceptor`.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor, thisArg) {
	      return interceptor.call(thisArg, value);
	    }
	
	    /**
	     * Enables explicit method chaining on the wrapper object.
	     *
	     * @name chain
	     * @memberOf _
	     * @category Chain
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // without explicit chaining
	     * _(users).first();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // with explicit chaining
	     * _(users).chain()
	     *   .first()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chained sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @category Chain
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Creates a new array joining a wrapped array with any additional arrays
	     * and/or values.
	     *
	     * @name concat
	     * @memberOf _
	     * @category Chain
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var wrapped = _(array).concat(2, [3], [[4]]);
	     *
	     * console.log(wrapped.value());
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    var wrapperConcat = restParam(function(values) {
	      values = baseFlatten(values);
	      return this.thru(function(array) {
	        return arrayConcat(isArray(array) ? array : [toObject(array)], values);
	      });
	    });
	
	    /**
	     * Creates a clone of the chained sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @category Chain
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).map(function(value) {
	     *   return Math.pow(value, 2);
	     * });
	     *
	     * var other = [3, 4];
	     * var otherWrapped = wrapped.plant(other);
	     *
	     * otherWrapped.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * Reverses the wrapped array so the first element becomes the last, the
	     * second element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @category Chain
	     * @returns {Object} Returns the new reversed `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	
	      var interceptor = function(value) {
	        return (wrapped && wrapped.__dir__ < 0) ? value : value.reverse();
	      };
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(interceptor);
	    }
	
	    /**
	     * Produces the result of coercing the unwrapped value to a string.
	     *
	     * @name toString
	     * @memberOf _
	     * @category Chain
	     * @returns {string} Returns the coerced string value.
	     * @example
	     *
	     * _([1, 2, 3]).toString();
	     * // => '1,2,3'
	     */
	    function wrapperToString() {
	      return (this.value() + '');
	    }
	
	    /**
	     * Executes the chained sequence to extract the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @alias run, toJSON, valueOf
	     * @category Chain
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements corresponding to the given keys, or indexes,
	     * of `collection`. Keys may be specified as individual arguments or as arrays
	     * of keys.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {...(number|number[]|string|string[])} [props] The property names
	     *  or indexes of elements to pick, specified individually or in arrays.
	     * @returns {Array} Returns the new array of picked elements.
	     * @example
	     *
	     * _.at(['a', 'b', 'c'], [0, 2]);
	     * // => ['a', 'c']
	     *
	     * _.at(['barney', 'fred', 'pebbles'], 0, 2);
	     * // => ['barney', 'pebbles']
	     */
	    var at = restParam(function(collection, props) {
	      return baseAt(collection, baseFlatten(props));
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` through `iteratee`. The corresponding value
	     * of each key is the number of times the key was returned by `iteratee`.
	     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([4.3, 6.1, 6.4], function(n) {
	     *   return Math.floor(n);
	     * });
	     * // => { '4': 1, '6': 2 }
	     *
	     * _.countBy([4.3, 6.1, 6.4], function(n) {
	     *   return this.floor(n);
	     * }, Math);
	     * // => { '4': 1, '6': 2 }
	     *
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      hasOwnProperty.call(result, key) ? ++result[key] : (result[key] = 1);
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * The predicate is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias all
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': false },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.every(users, 'active', false);
	     * // => true
	     *
	     * // using the `_.property` callback shorthand
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, thisArg) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (thisArg && isIterateeCall(collection, predicate, thisArg)) {
	        predicate = undefined;
	      }
	      if (typeof predicate != 'function' || thisArg !== undefined) {
	        predicate = getCallback(predicate, thisArg, 3);
	      }
	      return func(collection, predicate);
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is bound to `thisArg` and
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias select
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the new filtered array.
	     * @example
	     *
	     * _.filter([4, 5, 6], function(n) {
	     *   return n % 2 == 0;
	     * });
	     * // => [4, 6]
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.filter(users, { 'age': 36, 'active': true }), 'user');
	     * // => ['barney']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.filter(users, 'active', false), 'user');
	     * // => ['fred']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.filter(users, 'active'), 'user');
	     * // => ['barney']
	     */
	    function filter(collection, predicate, thisArg) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      predicate = getCallback(predicate, thisArg, 3);
	      return func(collection, predicate);
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is bound to `thisArg` and
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias detect
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.result(_.find(users, function(chr) {
	     *   return chr.age < 40;
	     * }), 'user');
	     * // => 'barney'
	     *
	     * // using the `_.matches` callback shorthand
	     * _.result(_.find(users, { 'age': 1, 'active': true }), 'user');
	     * // => 'pebbles'
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.result(_.find(users, 'active', false), 'user');
	     * // => 'fred'
	     *
	     * // using the `_.property` callback shorthand
	     * _.result(_.find(users, 'active'), 'user');
	     * // => 'barney'
	     */
	    var find = createFind(baseEach);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(baseEachRight, true);
	
	    /**
	     * Performs a deep comparison between each element in `collection` and the
	     * source object, returning the first element that has equivalent property
	     * values.
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties. For comparing a single
	     * own or inherited property value see `_.matchesProperty`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Object} source The object of property values to match.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.result(_.findWhere(users, { 'age': 36, 'active': true }), 'user');
	     * // => 'barney'
	     *
	     * _.result(_.findWhere(users, { 'age': 40, 'active': false }), 'user');
	     * // => 'fred'
	     */
	    function findWhere(collection, source) {
	      return find(collection, baseMatches(source));
	    }
	
	    /**
	     * Iterates over elements of `collection` invoking `iteratee` for each element.
	     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection). Iteratee functions may exit iteration early
	     * by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length" property
	     * are iterated like arrays. To avoid this behavior `_.forIn` or `_.forOwn`
	     * may be used for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @alias each
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array|Object|string} Returns `collection`.
	     * @example
	     *
	     * _([1, 2]).forEach(function(n) {
	     *   console.log(n);
	     * }).value();
	     * // => logs each value from left to right and returns the array
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(n, key) {
	     *   console.log(n, key);
	     * });
	     * // => logs each value-key pair and returns the object (iteration order is not guaranteed)
	     */
	    var forEach = createForEach(arrayEach, baseEach);
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array|Object|string} Returns `collection`.
	     * @example
	     *
	     * _([1, 2]).forEachRight(function(n) {
	     *   console.log(n);
	     * }).value();
	     * // => logs each value from right to left and returns the array
	     */
	    var forEachRight = createForEach(arrayEachRight, baseEachRight);
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` through `iteratee`. The corresponding value
	     * of each key is an array of the elements responsible for generating the key.
	     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([4.2, 6.1, 6.4], function(n) {
	     *   return Math.floor(n);
	     * });
	     * // => { '4': [4.2], '6': [6.1, 6.4] }
	     *
	     * _.groupBy([4.2, 6.1, 6.4], function(n) {
	     *   return this.floor(n);
	     * }, Math);
	     * // => { '4': [4.2], '6': [6.1, 6.4] }
	     *
	     * // using the `_.property` callback shorthand
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        result[key] = [value];
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it is used as the offset
	     * from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @alias contains, include
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {*} target The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.reduce`.
	     * @returns {boolean} Returns `true` if a matching element is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'user': 'fred', 'age': 40 }, 'fred');
	     * // => true
	     *
	     * _.includes('pebbles', 'eb');
	     * // => true
	     */
	    function includes(collection, target, fromIndex, guard) {
	      var length = collection ? getLength(collection) : 0;
	      if (!isLength(length)) {
	        collection = values(collection);
	        length = collection.length;
	      }
	      if (typeof fromIndex != 'number' || (guard && isIterateeCall(target, fromIndex, guard))) {
	        fromIndex = 0;
	      } else {
	        fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : (fromIndex || 0);
	      }
	      return (typeof collection == 'string' || !isArray(collection) && isString(collection))
	        ? (fromIndex <= length && collection.indexOf(target, fromIndex) > -1)
	        : (!!length && getIndexOf(collection, target, fromIndex) > -1);
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` through `iteratee`. The corresponding value
	     * of each key is the last element responsible for generating the key. The
	     * iteratee function is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var keyData = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.indexBy(keyData, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.indexBy(keyData, function(object) {
	     *   return String.fromCharCode(object.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.indexBy(keyData, function(object) {
	     *   return this.fromCharCode(object.code);
	     * }, String);
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     */
	    var indexBy = createAggregator(function(result, value, key) {
	      result[key] = value;
	    });
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `methodName` is a function it is
	     * invoked for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invoke([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invoke([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invoke = restParam(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          isProp = isKey(path),
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        var func = isFunc ? path : ((isProp && value != null) ? value[path] : undefined);
	        result[++index] = func ? func.apply(value, args) : invokePath(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` through
	     * `iteratee`. The `iteratee` is bound to `thisArg` and invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `callback`, `chunk`, `clone`, `create`, `curry`, `curryRight`,
	     * `drop`, `dropRight`, `every`, `fill`, `flatten`, `invert`, `max`, `min`,
	     * `parseInt`, `slice`, `sortBy`, `take`, `takeRight`, `template`, `trim`,
	     * `trimLeft`, `trimRight`, `trunc`, `random`, `range`, `sample`, `some`,
	     * `sum`, `uniq`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @alias collect
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function timesThree(n) {
	     *   return n * 3;
	     * }
	     *
	     * _.map([1, 2], timesThree);
	     * // => [3, 6]
	     *
	     * _.map({ 'a': 1, 'b': 2 }, timesThree);
	     * // => [3, 6] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // using the `_.property` callback shorthand
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee, thisArg) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      iteratee = getCallback(iteratee, thisArg, 3);
	      return func(collection, iteratee);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, while the second of which
	     * contains elements `predicate` returns falsey for. The predicate is bound
	     * to `thisArg` and invoked with three arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * _.partition([1, 2, 3], function(n) {
	     *   return n % 2;
	     * });
	     * // => [[1, 3], [2]]
	     *
	     * _.partition([1.2, 2.3, 3.4], function(n) {
	     *   return this.floor(n) % 2;
	     * }, Math);
	     * // => [[1.2, 3.4], [2.3]]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * var mapper = function(array) {
	     *   return _.pluck(array, 'user');
	     * };
	     *
	     * // using the `_.matches` callback shorthand
	     * _.map(_.partition(users, { 'age': 1, 'active': false }), mapper);
	     * // => [['pebbles'], ['barney', 'fred']]
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.map(_.partition(users, 'active', false), mapper);
	     * // => [['barney', 'pebbles'], ['fred']]
	     *
	     * // using the `_.property` callback shorthand
	     * _.map(_.partition(users, 'active'), mapper);
	     * // => [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Gets the property value of `path` from all elements in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Array|string} path The path of the property to pluck.
	     * @returns {Array} Returns the property values.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * _.pluck(users, 'user');
	     * // => ['barney', 'fred']
	     *
	     * var userIndex = _.indexBy(users, 'user');
	     * _.pluck(userIndex, 'age');
	     * // => [36, 40] (iteration order is not guaranteed)
	     */
	    function pluck(collection, path) {
	      return map(collection, property(path));
	    }
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` through `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not provided the first element of `collection` is used as the initial
	     * value. The `iteratee` is bound to `thisArg` and invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `sortByAll`,
	     * and `sortByOrder`
	     *
	     * @static
	     * @memberOf _
	     * @alias foldl, inject
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.reduce([1, 2], function(total, n) {
	     *   return total + n;
	     * });
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2 }, function(result, n, key) {
	     *   result[key] = n * 3;
	     *   return result;
	     * }, {});
	     * // => { 'a': 3, 'b': 6 } (iteration order is not guaranteed)
	     */
	    var reduce = createReduce(arrayReduce, baseEach);
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @alias foldr
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    var reduceRight = createReduce(arrayReduceRight, baseEachRight);
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the new filtered array.
	     * @example
	     *
	     * _.reject([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 0;
	     * });
	     * // => [1, 3]
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.reject(users, { 'age': 40, 'active': true }), 'user');
	     * // => ['barney']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.reject(users, 'active', false), 'user');
	     * // => ['fred']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.reject(users, 'active'), 'user');
	     * // => ['barney']
	     */
	    function reject(collection, predicate, thisArg) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      predicate = getCallback(predicate, thisArg, 3);
	      return func(collection, function(value, index, collection) {
	        return !predicate(value, index, collection);
	      });
	    }
	
	    /**
	     * Gets a random element or `n` random elements from a collection.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to sample.
	     * @param {number} [n] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {*} Returns the random sample(s).
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     *
	     * _.sample([1, 2, 3, 4], 2);
	     * // => [3, 1]
	     */
	    function sample(collection, n, guard) {
	      if (guard ? isIterateeCall(collection, n, guard) : n == null) {
	        collection = toIterable(collection);
	        var length = collection.length;
	        return length > 0 ? collection[baseRandom(0, length - 1)] : undefined;
	      }
	      var index = -1,
	          result = toArray(collection),
	          length = result.length,
	          lastIndex = length - 1;
	
	      n = nativeMin(n < 0 ? 0 : (+n || 0), length);
	      while (++index < n) {
	        var rand = baseRandom(index, lastIndex),
	            value = result[rand];
	
	        result[rand] = result[index];
	        result[index] = value;
	      }
	      result.length = n;
	      return result;
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      return sample(collection, POSITIVE_INFINITY);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the size of `collection`.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      var length = collection ? getLength(collection) : 0;
	      return isLength(length) ? length : keys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * The function returns as soon as it finds a passing value and does not iterate
	     * over the entire collection. The predicate is bound to `thisArg` and invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias any
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.some(users, 'active', false);
	     * // => true
	     *
	     * // using the `_.property` callback shorthand
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, thisArg) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (thisArg && isIterateeCall(collection, predicate, thisArg)) {
	        predicate = undefined;
	      }
	      if (typeof predicate != 'function' || thisArg !== undefined) {
	        predicate = getCallback(predicate, thisArg, 3);
	      }
	      return func(collection, predicate);
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection through `iteratee`. This method performs
	     * a stable sort, that is, it preserves the original sort order of equal elements.
	     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * _.sortBy([1, 2, 3], function(n) {
	     *   return Math.sin(n);
	     * });
	     * // => [3, 1, 2]
	     *
	     * _.sortBy([1, 2, 3], function(n) {
	     *   return this.sin(n);
	     * }, Math);
	     * // => [3, 1, 2]
	     *
	     * var users = [
	     *   { 'user': 'fred' },
	     *   { 'user': 'pebbles' },
	     *   { 'user': 'barney' }
	     * ];
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.sortBy(users, 'user'), 'user');
	     * // => ['barney', 'fred', 'pebbles']
	     */
	    function sortBy(collection, iteratee, thisArg) {
	      if (collection == null) {
	        return [];
	      }
	      if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
	        iteratee = undefined;
	      }
	      var index = -1;
	      iteratee = getCallback(iteratee, thisArg, 3);
	
	      var result = baseMap(collection, function(value, key, collection) {
	        return { 'criteria': iteratee(value, key, collection), 'index': ++index, 'value': value };
	      });
	      return baseSortBy(result, compareAscending);
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it can sort by multiple iteratees
	     * or property names.
	     *
	     * If a property name is provided for an iteratee the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If an object is provided for an iteratee the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {...(Function|Function[]|Object|Object[]|string|string[])} iteratees
	     *  The iteratees to sort by, specified as individual values or arrays of values.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 42 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.map(_.sortByAll(users, ['user', 'age']), _.values);
	     * // => [['barney', 34], ['barney', 36], ['fred', 42], ['fred', 48]]
	     *
	     * _.map(_.sortByAll(users, 'user', function(chr) {
	     *   return Math.floor(chr.age / 10);
	     * }), _.values);
	     * // => [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
	     */
	    var sortByAll = restParam(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var guard = iteratees[2];
	      if (guard && isIterateeCall(iteratees[0], iteratees[1], guard)) {
	        iteratees.length = 1;
	      }
	      return baseSortByOrder(collection, baseFlatten(iteratees), []);
	    });
	
	    /**
	     * This method is like `_.sortByAll` except that it allows specifying the
	     * sort orders of the iteratees to sort by. If `orders` is unspecified, all
	     * values are sorted in ascending order. Otherwise, a value is sorted in
	     * ascending order if its corresponding order is "asc", and descending if "desc".
	     *
	     * If a property name is provided for an iteratee the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If an object is provided for an iteratee the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {boolean[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 42 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // sort by `user` in ascending order and by `age` in descending order
	     * _.map(_.sortByOrder(users, ['user', 'age'], ['asc', 'desc']), _.values);
	     * // => [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
	     */
	    function sortByOrder(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (guard && isIterateeCall(iteratees, orders, guard)) {
	        orders = undefined;
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseSortByOrder(collection, iteratees, orders);
	    }
	
	    /**
	     * Performs a deep comparison between each element in `collection` and the
	     * source object, returning an array of all elements that have equivalent
	     * property values.
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties. For comparing a single
	     * own or inherited property value see `_.matchesProperty`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Object} source The object of property values to match.
	     * @returns {Array} Returns the new filtered array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false, 'pets': ['hoppy'] },
	     *   { 'user': 'fred',   'age': 40, 'active': true, 'pets': ['baby puss', 'dino'] }
	     * ];
	     *
	     * _.pluck(_.where(users, { 'age': 36, 'active': false }), 'user');
	     * // => ['barney']
	     *
	     * _.pluck(_.where(users, { 'pets': ['dino'] }), 'user');
	     * // => ['fred']
	     */
	    function where(collection, source) {
	      return filter(collection, baseMatches(source));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the number of milliseconds that have elapsed since the Unix epoch
	     * (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @category Date
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => logs the number of milliseconds it took for the deferred function to be invoked
	     */
	    var now = nativeNow || function() {
	      return new Date().getTime();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it is called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => logs 'done saving!' after the two async saves have completed
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        if (typeof n == 'function') {
	          var temp = n;
	          n = func;
	          func = temp;
	        } else {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	      }
	      n = nativeIsFinite(n = +n) ? n : 0;
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that accepts up to `n` arguments ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      if (guard && isIterateeCall(func, n, guard)) {
	        n = undefined;
	      }
	      n = (func && n == null) ? func.length : nativeMax(+n || 0, 0);
	      return createWrapper(func, ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it is called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery('#add').on('click', _.before(5, addContactToList));
	     * // => allows adding up to 4 contacts to the list
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        if (typeof n == 'function') {
	          var temp = n;
	          n = func;
	          func = temp;
	        } else {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	      }
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and prepends any additional `_.bind` arguments to those provided to the
	     * bound function.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind` this method does not set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var greet = function(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * };
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // using placeholders
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = restParam(function(func, thisArg, partials) {
	      var bitmask = BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, bind.placeholder);
	        bitmask |= PARTIAL_FLAG;
	      }
	      return createWrapper(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method. Method names may be specified as individual arguments or as arrays
	     * of method names. If no method names are provided all enumerable function
	     * properties, own and inherited, of `object` are bound.
	     *
	     * **Note:** This method does not set the "length" property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} [methodNames] The object method names to bind,
	     *  specified as individual method names or arrays of method names.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'onClick': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view);
	     * jQuery('#docs').on('click', view.onClick);
	     * // => logs 'clicked docs' when the element is clicked
	     */
	    var bindAll = restParam(function(object, methodNames) {
	      methodNames = methodNames.length ? baseFlatten(methodNames) : functions(object);
	
	      var index = -1,
	          length = methodNames.length;
	
	      while (++index < length) {
	        var key = methodNames[index];
	        object[key] = createWrapper(object[key], BIND_FLAG, object);
	      }
	      return object;
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` and prepends
	     * any additional `_.bindKey` arguments to those provided to the bound function.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist.
	     * See [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Object} object The object the method belongs to.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // using placeholders
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = restParam(function(object, key, partials) {
	      var bitmask = BIND_FLAG | BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, bindKey.placeholder);
	        bitmask |= PARTIAL_FLAG;
	      }
	      return createWrapper(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts one or more arguments of `func` that when
	     * called either invokes `func` returning its result, if all `func` arguments
	     * have been provided, or returns a function that accepts one or more of the
	     * remaining `func` arguments, and so on. The arity of `func` may be specified
	     * if `func.length` is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method does not set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // using placeholders
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    var curry = createCurry(CURRY_FLAG);
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method does not set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // using placeholders
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    var curryRight = createCurry(CURRY_RIGHT_FLAG);
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed invocations. Provide an options object to indicate that `func`
	     * should be invoked on the leading and/or trailing edge of the `wait` timeout.
	     * Subsequent calls to the debounced function return the result of the last
	     * `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
	     * on the trailing edge of the timeout only if the the debounced function is
	     * invoked more than once during the `wait` timeout.
	     *
	     * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options] The options object.
	     * @param {boolean} [options.leading=false] Specify invoking on the leading
	     *  edge of the timeout.
	     * @param {number} [options.maxWait] The maximum time `func` is allowed to be
	     *  delayed before it is invoked.
	     * @param {boolean} [options.trailing=true] Specify invoking on the trailing
	     *  edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // avoid costly calculations while the window size is in flux
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // invoke `sendMail` when the click event is fired, debouncing subsequent calls
	     * jQuery('#postbox').on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // ensure `batchLog` is invoked once after 1 second of debounced calls
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', _.debounce(batchLog, 250, {
	     *   'maxWait': 1000
	     * }));
	     *
	     * // cancel a debounced call
	     * var todoChanges = _.debounce(batchLog, 1000);
	     * Object.observe(models.todo, todoChanges);
	     *
	     * Object.observe(models, function(changes) {
	     *   if (_.find(changes, { 'user': 'todo', 'type': 'delete'})) {
	     *     todoChanges.cancel();
	     *   }
	     * }, ['delete']);
	     *
	     * // ...at some point `models.todo` is changed
	     * models.todo.completed = true;
	     *
	     * // ...before 1 second has passed `models.todo` is deleted
	     * // which cancels the debounced `todoChanges` call
	     * delete models.todo;
	     */
	    function debounce(func, wait, options) {
	      var args,
	          maxTimeoutId,
	          result,
	          stamp,
	          thisArg,
	          timeoutId,
	          trailingCall,
	          lastCalled = 0,
	          maxWait = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = wait < 0 ? 0 : (+wait || 0);
	      if (options === true) {
	        var leading = true;
	        trailing = false;
	      } else if (isObject(options)) {
	        leading = !!options.leading;
	        maxWait = 'maxWait' in options && nativeMax(+options.maxWait || 0, wait);
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function cancel() {
	        if (timeoutId) {
	          clearTimeout(timeoutId);
	        }
	        if (maxTimeoutId) {
	          clearTimeout(maxTimeoutId);
	        }
	        lastCalled = 0;
	        maxTimeoutId = timeoutId = trailingCall = undefined;
	      }
	
	      function complete(isCalled, id) {
	        if (id) {
	          clearTimeout(id);
	        }
	        maxTimeoutId = timeoutId = trailingCall = undefined;
	        if (isCalled) {
	          lastCalled = now();
	          result = func.apply(thisArg, args);
	          if (!timeoutId && !maxTimeoutId) {
	            args = thisArg = undefined;
	          }
	        }
	      }
	
	      function delayed() {
	        var remaining = wait - (now() - stamp);
	        if (remaining <= 0 || remaining > wait) {
	          complete(trailingCall, maxTimeoutId);
	        } else {
	          timeoutId = setTimeout(delayed, remaining);
	        }
	      }
	
	      function maxDelayed() {
	        complete(trailing, timeoutId);
	      }
	
	      function debounced() {
	        args = arguments;
	        stamp = now();
	        thisArg = this;
	        trailingCall = trailing && (timeoutId || !leading);
	
	        if (maxWait === false) {
	          var leadingCall = leading && !timeoutId;
	        } else {
	          if (!maxTimeoutId && !leading) {
	            lastCalled = stamp;
	          }
	          var remaining = maxWait - (stamp - lastCalled),
	              isCalled = remaining <= 0 || remaining > maxWait;
	
	          if (isCalled) {
	            if (maxTimeoutId) {
	              maxTimeoutId = clearTimeout(maxTimeoutId);
	            }
	            lastCalled = stamp;
	            result = func.apply(thisArg, args);
	          }
	          else if (!maxTimeoutId) {
	            maxTimeoutId = setTimeout(maxDelayed, remaining);
	          }
	        }
	        if (isCalled && timeoutId) {
	          timeoutId = clearTimeout(timeoutId);
	        }
	        else if (!timeoutId && wait !== maxWait) {
	          timeoutId = setTimeout(delayed, wait);
	        }
	        if (leadingCall) {
	          isCalled = true;
	          result = func.apply(thisArg, args);
	        }
	        if (isCalled && !timeoutId && !maxTimeoutId) {
	          args = thisArg = undefined;
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it is invoked.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke the function with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // logs 'deferred' after one or more milliseconds
	     */
	    var defer = restParam(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it is invoked.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke the function with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => logs 'later' after one second
	     */
	    var delay = restParam(function(func, wait, args) {
	      return baseDelay(func, wait, args);
	    });
	
	    /**
	     * Creates a function that returns the result of invoking the provided
	     * functions with the `this` binding of the created function, where each
	     * successive invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {...Function} [funcs] Functions to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow(_.add, square);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the provided functions from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @alias backflow, compose
	     * @category Function
	     * @param {...Function} [funcs] Functions to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight(square, _.add);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is coerced to a string and used as the
	     * cache key. The `func` is invoked with the `this` binding of the memoized
	     * function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the [`Map`](http://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoizing function.
	     * @example
	     *
	     * var upperCase = _.memoize(function(string) {
	     *   return string.toUpperCase();
	     * });
	     *
	     * upperCase('fred');
	     * // => 'FRED'
	     *
	     * // modifying the result cache
	     * upperCase.cache.set('fred', 'BARNEY');
	     * upperCase('fred');
	     * // => 'BARNEY'
	     *
	     * // replacing `_.memoize.Cache`
	     * var object = { 'user': 'fred' };
	     * var other = { 'user': 'barney' };
	     * var identity = _.memoize(_.identity);
	     *
	     * identity(object);
	     * // => { 'user': 'fred' }
	     * identity(other);
	     * // => { 'user': 'fred' }
	     *
	     * _.memoize.Cache = WeakMap;
	     * var identity = _.memoize(_.identity);
	     *
	     * identity(object);
	     * // => { 'user': 'fred' }
	     * identity(other);
	     * // => { 'user': 'barney' }
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result);
	        return result;
	      };
	      memoized.cache = new memoize.Cache;
	      return memoized;
	    }
	
	    /**
	     * Creates a function that runs each argument through a corresponding
	     * transform function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms] The functions to transform
	     * arguments, specified as individual functions or arrays of functions.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var modded = _.modArgs(function(x, y) {
	     *   return [x, y];
	     * }, square, doubled);
	     *
	     * modded(1, 2);
	     * // => [1, 4]
	     *
	     * modded(5, 10);
	     * // => [25, 20]
	     */
	    var modArgs = restParam(function(func, transforms) {
	      transforms = baseFlatten(transforms);
	      if (typeof func != 'function' || !arrayEvery(transforms, baseIsFunction)) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = transforms.length;
	      return restParam(function(args) {
	        var index = nativeMin(args.length, length);
	        while (index--) {
	          args[index] = transforms[index](args[index]);
	        }
	        return func.apply(this, args);
	      });
	    });
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        return !predicate.apply(this, arguments);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first call. The `func` is invoked
	     * with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // `initialize` invokes `createApplication` once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with `partial` arguments prepended
	     * to those provided to the new function. This method is like `_.bind` except
	     * it does **not** alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method does not set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * var greet = function(greeting, name) {
	     *   return greeting + ' ' + name;
	     * };
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // using placeholders
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = createPartial(PARTIAL_FLAG);
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to those provided to the new function.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method does not set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * var greet = function(greeting, name) {
	     *   return greeting + ' ' + name;
	     * };
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // using placeholders
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = createPartial(PARTIAL_RIGHT_FLAG);
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified indexes where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes,
	     *  specified as individual indexes or arrays of indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, 2, 0, 1);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     *
	     * var map = _.rearg(_.map, [1, 0]);
	     * map(function(n) {
	     *   return n * 3;
	     * }, [1, 2, 3]);
	     * // => [3, 6, 9]
	     */
	    var rearg = restParam(function(func, indexes) {
	      return createWrapper(func, REARG_FLAG, undefined, undefined, undefined, baseFlatten(indexes));
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as an array.
	     *
	     * **Note:** This method is based on the [rest parameter](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.restParam(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function restParam(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = nativeMax(start === undefined ? (func.length - 1) : (+start || 0), 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            rest = Array(length);
	
	        while (++index < length) {
	          rest[index] = args[start + index];
	        }
	        switch (start) {
	          case 0: return func.call(this, rest);
	          case 1: return func.call(this, args[0], rest);
	          case 2: return func.call(this, args[0], args[1], rest);
	        }
	        var otherArgs = Array(start + 1);
	        index = -1;
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = rest;
	        return func.apply(this, otherArgs);
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the created
	     * function and an array of arguments much like [`Function#apply`](https://es5.github.io/#x15.3.4.3).
	     *
	     * **Note:** This method is based on the [spread operator](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * // with a Promise
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function(array) {
	        return func.apply(this, array);
	      };
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed invocations. Provide an options object to indicate
	     * that `func` should be invoked on the leading and/or trailing edge of the
	     * `wait` timeout. Subsequent calls to the throttled function return the
	     * result of the last `func` call.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
	     * on the trailing edge of the timeout only if the the throttled function is
	     * invoked more than once during the `wait` timeout.
	     *
	     * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options] The options object.
	     * @param {boolean} [options.leading=true] Specify invoking on the leading
	     *  edge of the timeout.
	     * @param {boolean} [options.trailing=true] Specify invoking on the trailing
	     *  edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // avoid excessively updating the position while scrolling
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // invoke `renewToken` when the click event is fired, but not more than once every 5 minutes
	     * jQuery('.interactive').on('click', _.throttle(renewToken, 300000, {
	     *   'trailing': false
	     * }));
	     *
	     * // cancel a trailing throttled call
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (options === false) {
	        leading = false;
	      } else if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, { 'leading': leading, 'maxWait': +wait, 'trailing': trailing });
	    }
	
	    /**
	     * Creates a function that provides `value` to the wrapper function as its
	     * first argument. Any additional arguments provided to the function are
	     * appended to those provided to the wrapper function. The wrapper is invoked
	     * with the `this` binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} wrapper The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      wrapper = wrapper == null ? identity : wrapper;
	      return createWrapper(wrapper, PARTIAL_FLAG, undefined, [value], []);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a clone of `value`. If `isDeep` is `true` nested objects are cloned,
	     * otherwise they are assigned by reference. If `customizer` is provided it is
	     * invoked to produce the cloned values. If `customizer` returns `undefined`
	     * cloning is handled by the method instead. The `customizer` is bound to
	     * `thisArg` and invoked with two argument; (value [, index|key, object]).
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
	     * The enumerable properties of `arguments` objects and objects created by
	     * constructors other than `Object` are cloned to plain `Object` objects. An
	     * empty object is returned for uncloneable values such as functions, DOM nodes,
	     * Maps, Sets, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @param {Function} [customizer] The function to customize cloning values.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {*} Returns the cloned value.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * var shallow = _.clone(users);
	     * shallow[0] === users[0];
	     * // => true
	     *
	     * var deep = _.clone(users, true);
	     * deep[0] === users[0];
	     * // => false
	     *
	     * // using a customizer callback
	     * var el = _.clone(document.body, function(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * });
	     *
	     * el === document.body
	     * // => false
	     * el.nodeName
	     * // => BODY
	     * el.childNodes.length;
	     * // => 0
	     */
	    function clone(value, isDeep, customizer, thisArg) {
	      if (isDeep && typeof isDeep != 'boolean' && isIterateeCall(value, isDeep, customizer)) {
	        isDeep = false;
	      }
	      else if (typeof isDeep == 'function') {
	        thisArg = customizer;
	        customizer = isDeep;
	        isDeep = false;
	      }
	      return typeof customizer == 'function'
	        ? baseClone(value, isDeep, bindCallback(customizer, thisArg, 1))
	        : baseClone(value, isDeep);
	    }
	
	    /**
	     * Creates a deep clone of `value`. If `customizer` is provided it is invoked
	     * to produce the cloned values. If `customizer` returns `undefined` cloning
	     * is handled by the method instead. The `customizer` is bound to `thisArg`
	     * and invoked with two argument; (value [, index|key, object]).
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
	     * The enumerable properties of `arguments` objects and objects created by
	     * constructors other than `Object` are cloned to plain `Object` objects. An
	     * empty object is returned for uncloneable values such as functions, DOM nodes,
	     * Maps, Sets, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to deep clone.
	     * @param {Function} [customizer] The function to customize cloning values.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {*} Returns the deep cloned value.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * var deep = _.cloneDeep(users);
	     * deep[0] === users[0];
	     * // => false
	     *
	     * // using a customizer callback
	     * var el = _.cloneDeep(document.body, function(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * });
	     *
	     * el === document.body
	     * // => false
	     * el.nodeName
	     * // => BODY
	     * el.childNodes.length;
	     * // => 20
	     */
	    function cloneDeep(value, customizer, thisArg) {
	      return typeof customizer == 'function'
	        ? baseClone(value, true, bindCallback(customizer, thisArg, 1))
	        : baseClone(value, true);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`, else `false`.
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    function gt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to `other`, else `false`.
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    function gte(value, other) {
	      return value >= other;
	    }
	
	    /**
	     * Checks if `value` is classified as an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    function isArguments(value) {
	      return isObjectLike(value) && isArrayLike(value) &&
	        hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
	    }
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(function() { return arguments; }());
	     * // => false
	     */
	    var isArray = nativeIsArray || function(value) {
	      return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
	    };
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false || (isObjectLike(value) && objToString.call(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    function isDate(value) {
	      return isObjectLike(value) && objToString.call(value) == dateTag;
	    }
	
	    /**
	     * Checks if `value` is a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return !!value && value.nodeType === 1 && isObjectLike(value) && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is empty. A value is considered empty unless it is an
	     * `arguments` object, array, string, or jQuery-like collection with a length
	     * greater than `0` or an object with own enumerable properties.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {Array|Object|string} value The value to inspect.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) && (isArray(value) || isString(value) || isArguments(value) ||
	          (isObjectLike(value) && isFunction(value.splice)))) {
	        return !value.length;
	      }
	      return !keys(value).length;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent. If `customizer` is provided it is invoked to compare values.
	     * If `customizer` returns `undefined` comparisons are handled by the method
	     * instead. The `customizer` is bound to `thisArg` and invoked with three
	     * arguments: (value, other [, index|key]).
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties. Functions and DOM nodes
	     * are **not** supported. Provide a customizer function to extend support
	     * for comparing other values.
	     *
	     * @static
	     * @memberOf _
	     * @alias eq
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize value comparisons.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     * var other = { 'user': 'fred' };
	     *
	     * object == other;
	     * // => false
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * // using a customizer callback
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqual(array, other, function(value, other) {
	     *   if (_.every([value, other], RegExp.prototype.test, /^h(?:i|ello)$/)) {
	     *     return true;
	     *   }
	     * });
	     * // => true
	     */
	    function isEqual(value, other, customizer, thisArg) {
	      customizer = typeof customizer == 'function' ? bindCallback(customizer, thisArg, 3) : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return  result === undefined ? baseIsEqual(value, other, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      return isObjectLike(value) && typeof value.message == 'string' && objToString.call(value) == errorTag;
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on [`Number.isFinite`](http://ecma-international.org/ecma-262/6.0/#sec-number.isfinite).
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(10);
	     * // => true
	     *
	     * _.isFinite('10');
	     * // => false
	     *
	     * _.isFinite(true);
	     * // => false
	     *
	     * _.isFinite(Object(10));
	     * // => false
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in older versions of Chrome and Safari which return 'function' for regexes
	      // and Safari 8 equivalents which return 'object' for typed array constructors.
	      return isObject(value) && objToString.call(value) == funcTag;
	    }
	
	    /**
	     * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	     * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(1);
	     * // => false
	     */
	    function isObject(value) {
	      // Avoid a V8 JIT bug in Chrome 19-20.
	      // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	      var type = typeof value;
	      return !!value && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Performs a deep comparison between `object` and `source` to determine if
	     * `object` contains equivalent property values. If `customizer` is provided
	     * it is invoked to compare values. If `customizer` returns `undefined`
	     * comparisons are handled by the method instead. The `customizer` is bound
	     * to `thisArg` and invoked with three arguments: (value, other, index|key).
	     *
	     * **Note:** This method supports comparing properties of arrays, booleans,
	     * `Date` objects, numbers, `Object` objects, regexes, and strings. Functions
	     * and DOM nodes are **not** supported. Provide a customizer function to extend
	     * support for comparing other values.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize value comparisons.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'user': 'fred', 'age': 40 };
	     *
	     * _.isMatch(object, { 'age': 40 });
	     * // => true
	     *
	     * _.isMatch(object, { 'age': 36 });
	     * // => false
	     *
	     * // using a customizer callback
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatch(object, source, function(value, other) {
	     *   return _.every([value, other], RegExp.prototype.test, /^h(?:i|ello)$/) || undefined;
	     * });
	     * // => true
	     */
	    function isMatch(object, source, customizer, thisArg) {
	      customizer = typeof customizer == 'function' ? bindCallback(customizer, thisArg, 3) : undefined;
	      return baseIsMatch(object, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is not the same as [`isNaN`](https://es5.github.io/#x15.1.2.4)
	     * which returns `true` for `undefined` and other non-numeric values.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some host objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a native function.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (value == null) {
	        return false;
	      }
	      if (isFunction(value)) {
	        return reIsNative.test(fnToString.call(value));
	      }
	      return isObjectLike(value) && reIsHostCtor.test(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are classified
	     * as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isNumber(8.4);
	     * // => true
	     *
	     * _.isNumber(NaN);
	     * // => true
	     *
	     * _.isNumber('8.4');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' || (isObjectLike(value) && objToString.call(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * **Note:** This method assumes objects created by the `Object` constructor
	     * have no inherited enumerable properties.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      var Ctor;
	
	      // Exit early for non `Object` objects.
	      if (!(isObjectLike(value) && objToString.call(value) == objectTag && !isArguments(value)) ||
	          (!hasOwnProperty.call(value, 'constructor') && (Ctor = value.constructor, typeof Ctor == 'function' && !(Ctor instanceof Ctor)))) {
	        return false;
	      }
	      // IE < 9 iterates inherited properties before own properties. If the first
	      // iterated property is an object's own property then there are no inherited
	      // enumerable properties.
	      var result;
	      // In most environments an object's own properties are iterated before
	      // its inherited properties. If the last iterated property is an object's
	      // own property then there are no inherited enumerable properties.
	      baseForIn(value, function(subValue, key) {
	        result = key;
	      });
	      return result === undefined || hasOwnProperty.call(value, result);
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    function isRegExp(value) {
	      return isObject(value) && objToString.call(value) == regexpTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' || (isObjectLike(value) && objToString.call(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    function isTypedArray(value) {
	      return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objToString.call(value)];
	    }
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`, else `false`.
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    function lt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to `other`, else `false`.
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    function lte(value, other) {
	      return value <= other;
	    }
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * (function() {
	     *   return _.toArray(arguments).slice(1);
	     * }(1, 2, 3));
	     * // => [2, 3]
	     */
	    function toArray(value) {
	      var length = value ? getLength(value) : 0;
	      if (!isLength(length)) {
	        return values(value);
	      }
	      if (!length) {
	        return [];
	      }
	      return arrayCopy(value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable
	     * properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return baseCopy(value, keysIn(value));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Recursively merges own enumerable properties of the source object(s), that
	     * don't resolve to `undefined` into the destination object. Subsequent sources
	     * overwrite property assignments of previous sources. If `customizer` is
	     * provided it is invoked to produce the merged values of the destination and
	     * source properties. If `customizer` returns `undefined` merging is handled
	     * by the method instead. The `customizer` is bound to `thisArg` and invoked
	     * with five arguments: (objectValue, sourceValue, key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var users = {
	     *   'data': [{ 'user': 'barney' }, { 'user': 'fred' }]
	     * };
	     *
	     * var ages = {
	     *   'data': [{ 'age': 36 }, { 'age': 40 }]
	     * };
	     *
	     * _.merge(users, ages);
	     * // => { 'data': [{ 'user': 'barney', 'age': 36 }, { 'user': 'fred', 'age': 40 }] }
	     *
	     * // using a customizer callback
	     * var object = {
	     *   'fruits': ['apple'],
	     *   'vegetables': ['beet']
	     * };
	     *
	     * var other = {
	     *   'fruits': ['banana'],
	     *   'vegetables': ['carrot']
	     * };
	     *
	     * _.merge(object, other, function(a, b) {
	     *   if (_.isArray(a)) {
	     *     return a.concat(b);
	     *   }
	     * });
	     * // => { 'fruits': ['apple', 'banana'], 'vegetables': ['beet', 'carrot'] }
	     */
	    var merge = createAssigner(baseMerge);
	
	    /**
	     * Assigns own enumerable properties of source object(s) to the destination
	     * object. Subsequent sources overwrite property assignments of previous sources.
	     * If `customizer` is provided it is invoked to produce the assigned values.
	     * The `customizer` is bound to `thisArg` and invoked with five arguments:
	     * (objectValue, sourceValue, key, object, source).
	     *
	     * **Note:** This method mutates `object` and is based on
	     * [`Object.assign`](http://ecma-international.org/ecma-262/6.0/#sec-object.assign).
	     *
	     * @static
	     * @memberOf _
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * _.assign({ 'user': 'barney' }, { 'age': 40 }, { 'user': 'fred' });
	     * // => { 'user': 'fred', 'age': 40 }
	     *
	     * // using a customizer callback
	     * var defaults = _.partialRight(_.assign, function(value, other) {
	     *   return _.isUndefined(value) ? other : value;
	     * });
	     *
	     * defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
	     * // => { 'user': 'barney', 'age': 36 }
	     */
	    var assign = createAssigner(function(object, source, customizer) {
	      return customizer
	        ? assignWith(object, source, customizer)
	        : baseAssign(object, source);
	    });
	
	    /**
	     * Creates an object that inherits from the given `prototype` object. If a
	     * `properties` object is provided its own enumerable properties are assigned
	     * to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties, guard) {
	      var result = baseCreate(prototype);
	      if (guard && isIterateeCall(prototype, properties, guard)) {
	        properties = undefined;
	      }
	      return properties ? baseAssign(result, properties) : result;
	    }
	
	    /**
	     * Assigns own enumerable properties of source object(s) to the destination
	     * object for all destination properties that resolve to `undefined`. Once a
	     * property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * _.defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
	     * // => { 'user': 'barney', 'age': 36 }
	     */
	    var defaults = createDefaults(assign, assignDefaults);
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * _.defaultsDeep({ 'user': { 'name': 'barney' } }, { 'user': { 'name': 'fred', 'age': 36 } });
	     * // => { 'user': { 'name': 'barney', 'age': 36 } }
	     *
	     */
	    var defaultsDeep = createDefaults(merge, mergeDefaults);
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(chr) {
	     *   return chr.age < 40;
	     * });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // using the `_.matches` callback shorthand
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.findKey(users, 'active', false);
	     * // => 'fred'
	     *
	     * // using the `_.property` callback shorthand
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    var findKey = createFindKey(baseForOwn);
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(chr) {
	     *   return chr.age < 40;
	     * });
	     * // => returns `pebbles` assuming `_.findKey` returns `barney`
	     *
	     * // using the `_.matches` callback shorthand
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.findLastKey(users, 'active', false);
	     * // => 'fred'
	     *
	     * // using the `_.property` callback shorthand
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    var findLastKey = createFindKey(baseForOwnRight);
	
	    /**
	     * Iterates over own and inherited enumerable properties of an object invoking
	     * `iteratee` for each property. The `iteratee` is bound to `thisArg` and invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'a', 'b', and 'c' (iteration order is not guaranteed)
	     */
	    var forIn = createForIn(baseFor);
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'c', 'b', and 'a' assuming `_.forIn ` logs 'a', 'b', and 'c'
	     */
	    var forInRight = createForIn(baseForRight);
	
	    /**
	     * Iterates over own enumerable properties of an object invoking `iteratee`
	     * for each property. The `iteratee` is bound to `thisArg` and invoked with
	     * three arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'a' and 'b' (iteration order is not guaranteed)
	     */
	    var forOwn = createForOwn(baseForOwn);
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'b' and 'a' assuming `_.forOwn` logs 'a' and 'b'
	     */
	    var forOwnRight = createForOwn(baseForOwnRight);
	
	    /**
	     * Creates an array of function property names from all enumerable properties,
	     * own and inherited, of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @alias methods
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the new array of property names.
	     * @example
	     *
	     * _.functions(_);
	     * // => ['after', 'ary', 'assign', ...]
	     */
	    function functions(object) {
	      return baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the property value at `path` of `object`. If the resolved value is
	     * `undefined` the `defaultValue` is used in its place.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, toPath(path), path + '');
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` is a direct property, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': { 'c': 3 } } };
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b.c');
	     * // => true
	     *
	     * _.has(object, ['a', 'b', 'c']);
	     * // => true
	     */
	    function has(object, path) {
	      if (object == null) {
	        return false;
	      }
	      var result = hasOwnProperty.call(object, path);
	      if (!result && !isKey(path)) {
	        path = toPath(path);
	        object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	        if (object == null) {
	          return false;
	        }
	        path = last(path);
	        result = hasOwnProperty.call(object, path);
	      }
	      return result || (isLength(object.length) && isIndex(path, object.length) &&
	        (isArray(object) || isArguments(object)));
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite property
	     * assignments of previous values unless `multiValue` is `true`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {boolean} [multiValue] Allow multiple values per key.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     *
	     * // with `multiValue`
	     * _.invert(object, true);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function invert(object, multiValue, guard) {
	      if (guard && isIterateeCall(object, multiValue, guard)) {
	        multiValue = undefined;
	      }
	      var index = -1,
	          props = keys(object),
	          length = props.length,
	          result = {};
	
	      while (++index < length) {
	        var key = props[index],
	            value = object[key];
	
	        if (multiValue) {
	          if (hasOwnProperty.call(result, value)) {
	            result[value].push(key);
	          } else {
	            result[value] = [key];
	          }
	        }
	        else {
	          result[value] = key;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    var keys = !nativeKeys ? shimKeys : function(object) {
	      var Ctor = object == null ? undefined : object.constructor;
	      if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
	          (typeof object != 'function' && isArrayLike(object))) {
	        return shimKeys(object);
	      }
	      return isObject(object) ? nativeKeys(object) : [];
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      if (object == null) {
	        return [];
	      }
	      if (!isObject(object)) {
	        object = Object(object);
	      }
	      var length = object.length;
	      length = (length && isLength(length) &&
	        (isArray(object) || isArguments(object)) && length) || 0;
	
	      var Ctor = object.constructor,
	          index = -1,
	          isProto = typeof Ctor == 'function' && Ctor.prototype === object,
	          result = Array(length),
	          skipIndexes = length > 0;
	
	      while (++index < length) {
	        result[index] = (index + '');
	      }
	      for (var key in object) {
	        if (!(skipIndexes && isIndex(key, length)) &&
	            !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * property of `object` through `iteratee`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the new mapped object.
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    var mapKeys = createObjectMapper(true);
	
	    /**
	     * Creates an object with the same keys as `object` and values generated by
	     * running each own enumerable property of `object` through `iteratee`. The
	     * iteratee function is bound to `thisArg` and invoked with three arguments:
	     * (value, key, object).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the new mapped object.
	     * @example
	     *
	     * _.mapValues({ 'a': 1, 'b': 2 }, function(n) {
	     *   return n * 3;
	     * });
	     * // => { 'a': 3, 'b': 6 }
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * // using the `_.property` callback shorthand
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    var mapValues = createObjectMapper();
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable properties of `object` that are not omitted.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function|...(string|string[])} [predicate] The function invoked per
	     *  iteration or property names to omit, specified as individual property
	     *  names or arrays of property names.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'user': 'fred', 'age': 40 };
	     *
	     * _.omit(object, 'age');
	     * // => { 'user': 'fred' }
	     *
	     * _.omit(object, _.isNumber);
	     * // => { 'user': 'fred' }
	     */
	    var omit = restParam(function(object, props) {
	      if (object == null) {
	        return {};
	      }
	      if (typeof props[0] != 'function') {
	        var props = arrayMap(baseFlatten(props), String);
	        return pickByArray(object, baseDifference(keysIn(object), props));
	      }
	      var predicate = bindCallback(props[0], props[1], 3);
	      return pickByCallback(object, function(value, key, object) {
	        return !predicate(value, key, object);
	      });
	    });
	
	    /**
	     * Creates a two dimensional array of the key-value pairs for `object`,
	     * e.g. `[[key1, value1], [key2, value2]]`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the new array of key-value pairs.
	     * @example
	     *
	     * _.pairs({ 'barney': 36, 'fred': 40 });
	     * // => [['barney', 36], ['fred', 40]] (iteration order is not guaranteed)
	     */
	    function pairs(object) {
	      object = toObject(object);
	
	      var index = -1,
	          props = keys(object),
	          length = props.length,
	          result = Array(length);
	
	      while (++index < length) {
	        var key = props[index];
	        result[index] = [key, object[key]];
	      }
	      return result;
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties. Property
	     * names may be specified as individual arguments or as arrays of property
	     * names. If `predicate` is provided it is invoked for each property of `object`
	     * picking the properties `predicate` returns truthy for. The predicate is
	     * bound to `thisArg` and invoked with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function|...(string|string[])} [predicate] The function invoked per
	     *  iteration or property names to pick, specified as individual property
	     *  names or arrays of property names.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'user': 'fred', 'age': 40 };
	     *
	     * _.pick(object, 'user');
	     * // => { 'user': 'fred' }
	     *
	     * _.pick(object, _.isString);
	     * // => { 'user': 'fred' }
	     */
	    var pick = restParam(function(object, props) {
	      if (object == null) {
	        return {};
	      }
	      return typeof props[0] == 'function'
	        ? pickByCallback(object, bindCallback(props[0], props[1], 3))
	        : pickByArray(object, baseFlatten(props));
	    });
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a function
	     * it is invoked with the `this` binding of its parent object and its result
	     * is returned.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a.b.c', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a.b.c', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      var result = object == null ? undefined : object[path];
	      if (result === undefined) {
	        if (object != null && !isKey(path, object)) {
	          path = toPath(path);
	          object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	          result = object == null ? undefined : object[last(path)];
	        }
	        result = result === undefined ? defaultValue : result;
	      }
	      return isFunction(result) ? result.call(object) : result;
	    }
	
	    /**
	     * Sets the property value of `path` on `object`. If a portion of `path`
	     * does not exist it is created.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to augment.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, 'x[0].y.z', 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      if (object == null) {
	        return object;
	      }
	      var pathKey = (path + '');
	      path = (object[pathKey] != null || isKey(path, object)) ? [pathKey] : toPath(path);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = path[index];
	        if (isObject(nested)) {
	          if (index == lastIndex) {
	            nested[key] = value;
	          } else if (nested[key] == null) {
	            nested[key] = isIndex(path[index + 1]) ? [] : {};
	          }
	        }
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own enumerable
	     * properties through `iteratee`, with each invocation potentially mutating
	     * the `accumulator` object. The `iteratee` is bound to `thisArg` and invoked
	     * with four arguments: (accumulator, value, key, object). Iteratee functions
	     * may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Array|Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * });
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2 }, function(result, n, key) {
	     *   result[key] = n * 3;
	     * });
	     * // => { 'a': 3, 'b': 6 }
	     */
	    function transform(object, iteratee, accumulator, thisArg) {
	      var isArr = isArray(object) || isTypedArray(object);
	      iteratee = getCallback(iteratee, thisArg, 4);
	
	      if (accumulator == null) {
	        if (isArr || isObject(object)) {
	          var Ctor = object.constructor;
	          if (isArr) {
	            accumulator = isArray(object) ? new Ctor : [];
	          } else {
	            accumulator = baseCreate(isFunction(Ctor) ? Ctor.prototype : undefined);
	          }
	        } else {
	          accumulator = {};
	        }
	      }
	      (isArr ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Creates an array of the own enumerable property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property values
	     * of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Checks if `n` is between `start` and up to but not including, `end`. If
	     * `end` is not specified it is set to `start` with `start` then set to `0`.
	     *
	     * @static
	     * @memberOf _
	     * @category Number
	     * @param {number} n The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `n` is in the range, else `false`.
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     */
	    function inRange(value, start, end) {
	      start = +start || 0;
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = +end || 0;
	      }
	      return value >= nativeMin(start, end) && value < nativeMax(start, end);
	    }
	
	    /**
	     * Produces a random number between `min` and `max` (inclusive). If only one
	     * argument is provided a number between `0` and the given number is returned.
	     * If `floating` is `true`, or either `min` or `max` are floats, a floating-point
	     * number is returned instead of an integer.
	     *
	     * @static
	     * @memberOf _
	     * @category Number
	     * @param {number} [min=0] The minimum possible value.
	     * @param {number} [max=1] The maximum possible value.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(min, max, floating) {
	      if (floating && isIterateeCall(min, max, floating)) {
	        max = floating = undefined;
	      }
	      var noMin = min == null,
	          noMax = max == null;
	
	      if (floating == null) {
	        if (noMax && typeof min == 'boolean') {
	          floating = min;
	          min = 1;
	        }
	        else if (typeof max == 'boolean') {
	          floating = max;
	          noMax = true;
	        }
	      }
	      if (noMin && noMax) {
	        max = 1;
	        noMax = false;
	      }
	      min = +min || 0;
	      if (noMax) {
	        max = min;
	        min = 0;
	      } else {
	        max = +max || 0;
	      }
	      if (floating || min % 1 || max % 1) {
	        var rand = nativeRandom();
	        return nativeMin(min + (rand * (max - min + parseFloat('1e-' + ((rand + '').length - 1)))), max);
	      }
	      return baseRandom(min, max);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__foo_bar__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? (word.charAt(0).toUpperCase() + word.slice(1)) : word);
	    });
	
	    /**
	     * Capitalizes the first character of `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('fred');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      string = baseToString(string);
	      return string && (string.charAt(0).toUpperCase() + string.slice(1));
	    }
	
	    /**
	     * Deburrs `string` by converting [latin-1 supplementary letters](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * to basic latin letters and removing [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = baseToString(string);
	      return string && string.replace(reLatin1, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to search.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search from.
	     * @returns {boolean} Returns `true` if `string` ends with `target`, else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = baseToString(string);
	      target = (target + '');
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : nativeMin(position < 0 ? 0 : (+position || 0), length);
	
	      position -= target.length;
	      return position >= 0 && string.indexOf(target, position) == position;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', "'", and "\`", in `string` to
	     * their corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional characters
	     * use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value.
	     * See [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * Backticks are escaped because in Internet Explorer < 9, they can break out
	     * of attribute values or HTML comments. See [#59](https://html5sec.org/#59),
	     * [#102](https://html5sec.org/#102), [#108](https://html5sec.org/#108), and
	     * [#133](https://html5sec.org/#133) of the [HTML5 Security Cheatsheet](https://html5sec.org/)
	     * for more details.
	     *
	     * When working with HTML you should always [quote attribute values](http://wonko.com/post/html-escaping)
	     * to reduce XSS vectors.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      // Reset `lastIndex` because in IE < 9 `String#replace` does not.
	      string = baseToString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "\", "/", "^", "$", ".", "|", "?",
	     * "*", "+", "(", ")", "[", "]", "{" and "}" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https:\/\/lodash\.com\/\)'
	     */
	    function escapeRegExp(string) {
	      string = baseToString(string);
	      return (string && reHasRegExpChars.test(string))
	        ? string.replace(reRegExpChars, escapeRegExpChar)
	        : (string || '(?:)');
	    }
	
	    /**
	     * Converts `string` to [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__foo_bar__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = baseToString(string);
	      length = +length;
	
	      var strLength = string.length;
	      if (strLength >= length || !nativeIsFinite(length)) {
	        return string;
	      }
	      var mid = (length - strLength) / 2,
	          leftLength = nativeFloor(mid),
	          rightLength = nativeCeil(mid);
	
	      chars = createPadding('', rightLength, chars);
	      return chars.slice(0, leftLength) + string + chars;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padLeft('abc', 6);
	     * // => '   abc'
	     *
	     * _.padLeft('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padLeft('abc', 3);
	     * // => 'abc'
	     */
	    var padLeft = createPadDir();
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padRight('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padRight('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padRight('abc', 3);
	     * // => 'abc'
	     */
	    var padRight = createPadDir(true);
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a hexadecimal,
	     * in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the [ES5 implementation](https://es5.github.io/#E)
	     * of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      // Firefox < 21 and Opera < 15 follow ES3 for `parseInt`.
	      // Chrome fails to trim leading <BOM> whitespace characters.
	      // See https://code.google.com/p/v8/issues/detail?id=3109 for more details.
	      if (guard ? isIterateeCall(string, radix, guard) : radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      string = trim(string);
	      return nativeParseInt(string, radix || (reHasHexPrefix.test(string) ? 16 : 10));
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=0] The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n) {
	      var result = '';
	      string = baseToString(string);
	      n = +n;
	      if (n < 1 || !string || !nativeIsFinite(n)) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        string += string;
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * Converts `string` to [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--foo-bar');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string` to [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__foo_bar__');
	     * // => 'Foo Bar'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + (word.charAt(0).toUpperCase() + word.slice(1));
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to search.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`, else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = baseToString(string);
	      position = position == null
	        ? 0
	        : nativeMin(position < 0 ? 0 : (+position || 0), string.length);
	
	      return string.lastIndexOf(target, position) == position;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is provided it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options] The options object.
	     * @param {RegExp} [options.escape] The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate] The "evaluate" delimiter.
	     * @param {Object} [options.imports] An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate] The "interpolate" delimiter.
	     * @param {string} [options.sourceURL] The sourceURL of the template's compiled source.
	     * @param {string} [options.variable] The data object variable name.
	     * @param- {Object} [otherOptions] Enables the legacy `options` param signature.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // using the "interpolate" delimiter to create a compiled template
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // using the HTML "escape" delimiter to escape data property values
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // using the "evaluate" delimiter to execute JavaScript and generate HTML
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // using the internal `print` function in "evaluate" delimiters
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // using the ES delimiter as an alternative to the default "interpolate" delimiter
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // using custom template delimiters
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // using backslashes to treat delimiters as plain text
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // using the `imports` option to import `jQuery` as `jq`
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // using the `sourceURL` option to specify a custom sourceURL for the template
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector
	     *
	     * // using the `variable` option to ensure a with-statement isn't used in the compiled template
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // using the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and a stack trace
	     * fs.writeFileSync(path.join(cwd, 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, otherOptions) {
	      // Based on John Resig's `tmpl` implementation (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (otherOptions && isIterateeCall(string, options, otherOptions)) {
	        options = otherOptions = undefined;
	      }
	      string = baseToString(string);
	      options = assignWith(baseAssign({}, otherOptions || options), settings, assignOwnDefaults);
	
	      var imports = assignWith(baseAssign({}, options.imports), settings.imports, assignOwnDefaults),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      var sourceURL = '//# sourceURL=' +
	        ('sourceURL' in options
	          ? options.sourceURL
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products requires returning the `match`
	        // string in order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      var value = string;
	      string = baseToString(string);
	      if (!string) {
	        return string;
	      }
	      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
	        return string.slice(trimmedLeftIndex(string), trimmedRightIndex(string) + 1);
	      }
	      chars = (chars + '');
	      return string.slice(charsLeftIndex(string, chars), charsRightIndex(string, chars) + 1);
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimLeft('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimLeft('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimLeft(string, chars, guard) {
	      var value = string;
	      string = baseToString(string);
	      if (!string) {
	        return string;
	      }
	      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
	        return string.slice(trimmedLeftIndex(string));
	      }
	      return string.slice(charsLeftIndex(string, (chars + '')));
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimRight('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimRight('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimRight(string, chars, guard) {
	      var value = string;
	      string = baseToString(string);
	      if (!string) {
	        return string;
	      }
	      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
	        return string.slice(0, trimmedRightIndex(string) + 1);
	      }
	      return string.slice(0, charsRightIndex(string, (chars + '')) + 1);
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object|number} [options] The options object or maximum string length.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.trunc('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.trunc('hi-diddly-ho there, neighborino', 24);
	     * // => 'hi-diddly-ho there, n...'
	     *
	     * _.trunc('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.trunc('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.trunc('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function trunc(string, options, guard) {
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (options != null) {
	        if (isObject(options)) {
	          var separator = 'separator' in options ? options.separator : separator;
	          length = 'length' in options ? (+options.length || 0) : length;
	          omission = 'omission' in options ? baseToString(options.omission) : omission;
	        } else {
	          length = +options || 0;
	        }
	      }
	      string = baseToString(string);
	      if (length >= string.length) {
	        return string;
	      }
	      var end = length - omission.length;
	      if (end < 1) {
	        return omission;
	      }
	      var result = string.slice(0, end);
	      if (separator == null) {
	        return result + omission;
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              newEnd,
	              substring = string.slice(0, end);
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, (reFlags.exec(separator) || '') + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            newEnd = match.index;
	          }
	          result = result.slice(0, newEnd == null ? end : newEnd);
	        }
	      } else if (string.indexOf(separator, end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, `&#39;`, and `&#96;` in `string` to their
	     * corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional HTML
	     * entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = baseToString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      if (guard && isIterateeCall(string, pattern, guard)) {
	        pattern = undefined;
	      }
	      string = baseToString(string);
	      return string.match(pattern || reWords) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it is invoked.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Function} func The function to attempt.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // avoid throwing errors for invalid selectors
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = restParam(function(func, args) {
	      try {
	        return func.apply(undefined, args);
	      } catch(e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and arguments of the created function. If `func` is a property name the
	     * created callback returns the property value for a given element. If `func`
	     * is an object the created callback returns `true` for elements that contain
	     * the equivalent object properties, otherwise it returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias iteratee
	     * @category Utility
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // wrap to create custom callback shorthands
	     * _.callback = _.wrap(_.callback, function(callback, func, thisArg) {
	     *   var match = /^(.+?)__([gl]t)(.+)$/.exec(func);
	     *   if (!match) {
	     *     return callback(func, thisArg);
	     *   }
	     *   return function(object) {
	     *     return match[2] == 'gt'
	     *       ? object[match[1]] > match[3]
	     *       : object[match[1]] < match[3];
	     *   };
	     * });
	     *
	     * _.filter(users, 'age__gt36');
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     */
	    function callback(func, thisArg, guard) {
	      if (guard && isIterateeCall(func, thisArg, guard)) {
	        thisArg = undefined;
	      }
	      return isObjectLike(func)
	        ? matches(func)
	        : baseCallback(func, thisArg);
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     * var getter = _.constant(object);
	     *
	     * getter() === object;
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * This method returns the first argument provided to it.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * _.identity(object) === object;
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that performs a deep comparison between a given object
	     * and `source`, returning `true` if the given object has equivalent property
	     * values, else `false`.
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties. For comparing a single
	     * own or inherited property value see `_.matchesProperty`.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, _.matches({ 'age': 40, 'active': false }));
	     * // => [{ 'user': 'fred', 'age': 40, 'active': false }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, true));
	    }
	
	    /**
	     * Creates a function that compares the property value of `path` on a given
	     * object to `value`.
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * _.find(users, _.matchesProperty('user', 'fred'));
	     * // => { 'user': 'fred' }
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, true));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` on a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': { 'c': _.constant(2) } } },
	     *   { 'a': { 'b': { 'c': _.constant(1) } } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b.c'));
	     * // => [2, 1]
	     *
	     * _.invoke(_.sortBy(objects, _.method(['a', 'b', 'c'])), 'a.b.c');
	     * // => [1, 2]
	     */
	    var method = restParam(function(path, args) {
	      return function(object) {
	        return invokePath(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path on `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = restParam(function(object, args) {
	      return function(path) {
	        return invokePath(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable function properties of a source object to the
	     * destination object. If `object` is a function then methods are added to
	     * its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options] The options object.
	     * @param {boolean} [options.chain=true] Specify whether the functions added
	     *  are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      if (options == null) {
	        var isObj = isObject(source),
	            props = isObj ? keys(source) : undefined,
	            methodNames = (props && props.length) ? baseFunctions(source, props) : undefined;
	
	        if (!(methodNames ? methodNames.length : isObj)) {
	          methodNames = false;
	          options = source;
	          source = object;
	          object = this;
	        }
	      }
	      if (!methodNames) {
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = true,
	          index = -1,
	          isFunc = isFunction(object),
	          length = methodNames.length;
	
	      if (options === false) {
	        chain = false;
	      } else if (isObject(options) && 'chain' in options) {
	        chain = options.chain;
	      }
	      while (++index < length) {
	        var methodName = methodNames[index],
	            func = source[methodName];
	
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = (function(func) {
	            return function() {
	              var chainAll = this.__chain__;
	              if (chain || chainAll) {
	                var result = object(this.__wrapped__),
	                    actions = result.__actions__ = arrayCopy(this.__actions__);
	
	                actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	                result.__chain__ = chainAll;
	                return result;
	              }
	              return func.apply(object, arrayPush([this.value()], arguments));
	            };
	          }(func));
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      root._ = oldDash;
	      return this;
	    }
	
	    /**
	     * A no-operation function that returns `undefined` regardless of the
	     * arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * _.noop(object) === undefined;
	     * // => true
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that returns the property value at `path` on a
	     * given object.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': { 'c': 2 } } },
	     *   { 'a': { 'b': { 'c': 1 } } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b.c'));
	     * // => [2, 1]
	     *
	     * _.pluck(_.sortBy(objects, _.property(['a', 'b', 'c'])), 'a.b.c');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(path) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the property value at a given path on `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return baseGet(object, toPath(path), path + '');
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. If `end` is not specified it is
	     * set to `start` with `start` then set to `0`. If `end` is less than `start`
	     * a zero-length range is created unless a negative `step` is specified.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the new array of numbers.
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    function range(start, end, step) {
	      if (step && isIterateeCall(start, end, step)) {
	        end = step = undefined;
	      }
	      start = +start || 0;
	      step = step == null ? 1 : (+step || 0);
	
	      if (end == null) {
	        end = start;
	        start = 0;
	      } else {
	        end = +end || 0;
	      }
	      // Use `Array(length)` so engines like Chakra and V8 avoid slower modes.
	      // See https://youtu.be/XAqIpGU8ZZk#t=17m25s for more details.
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (++index < length) {
	        result[index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * Invokes the iteratee function `n` times, returning an array of the results
	     * of each invocation. The `iteratee` is bound to `thisArg` and invoked with
	     * one argument; (index).
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * var diceRolls = _.times(3, _.partial(_.random, 1, 6, false));
	     * // => [3, 6, 4]
	     *
	     * _.times(3, function(n) {
	     *   mage.castSpell(n);
	     * });
	     * // => invokes `mage.castSpell(n)` three times with `n` of `0`, `1`, and `2`
	     *
	     * _.times(3, function(n) {
	     *   this.cast(n);
	     * }, mage);
	     * // => also invokes `mage.castSpell(n)` three times
	     */
	    function times(n, iteratee, thisArg) {
	      n = nativeFloor(n);
	
	      // Exit early to avoid a JSC JIT bug in Safari 8
	      // where `Array(0)` is treated as `Array(1)`.
	      if (n < 1 || !nativeIsFinite(n)) {
	        return [];
	      }
	      var index = -1,
	          result = Array(nativeMin(n, MAX_ARRAY_LENGTH));
	
	      iteratee = bindCallback(iteratee, thisArg, 1);
	      while (++index < n) {
	        if (index < MAX_ARRAY_LENGTH) {
	          result[index] = iteratee(index);
	        } else {
	          iteratee(index);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is provided the ID is appended to it.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {string} [prefix] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return baseToString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} augend The first number to add.
	     * @param {number} addend The second number to add.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    function add(augend, addend) {
	      return (+augend || 0) + (+addend || 0);
	    }
	
	    /**
	     * Calculates `n` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} n The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Calculates `n` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} n The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Gets the maximum value of `collection`. If `collection` is empty or falsey
	     * `-Infinity` is returned. If an iteratee function is provided it is invoked
	     * for each value in `collection` to generate the criterion by which the value
	     * is ranked. The `iteratee` is bound to `thisArg` and invoked with three
	     * arguments: (value, index, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => -Infinity
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * _.max(users, function(chr) {
	     *   return chr.age;
	     * });
	     * // => { 'user': 'fred', 'age': 40 }
	     *
	     * // using the `_.property` callback shorthand
	     * _.max(users, 'age');
	     * // => { 'user': 'fred', 'age': 40 }
	     */
	    var max = createExtremum(gt, NEGATIVE_INFINITY);
	
	    /**
	     * Gets the minimum value of `collection`. If `collection` is empty or falsey
	     * `Infinity` is returned. If an iteratee function is provided it is invoked
	     * for each value in `collection` to generate the criterion by which the value
	     * is ranked. The `iteratee` is bound to `thisArg` and invoked with three
	     * arguments: (value, index, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => Infinity
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * _.min(users, function(chr) {
	     *   return chr.age;
	     * });
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // using the `_.property` callback shorthand
	     * _.min(users, 'age');
	     * // => { 'user': 'barney', 'age': 36 }
	     */
	    var min = createExtremum(lt, POSITIVE_INFINITY);
	
	    /**
	     * Calculates `n` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} n The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Gets the sum of the values in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 6]);
	     * // => 10
	     *
	     * _.sum({ 'a': 4, 'b': 6 });
	     * // => 10
	     *
	     * var objects = [
	     *   { 'n': 4 },
	     *   { 'n': 6 }
	     * ];
	     *
	     * _.sum(objects, function(object) {
	     *   return object.n;
	     * });
	     * // => 10
	     *
	     * // using the `_.property` callback shorthand
	     * _.sum(objects, 'n');
	     * // => 10
	     */
	    function sum(collection, iteratee, thisArg) {
	      if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
	        iteratee = undefined;
	      }
	      iteratee = getCallback(iteratee, thisArg, 3);
	      return iteratee.length == 1
	        ? arraySum(isArray(collection) ? collection : toIterable(collection), iteratee)
	        : baseSum(collection, iteratee);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    // Add functions to the `Map` cache.
	    MapCache.prototype['delete'] = mapDelete;
	    MapCache.prototype.get = mapGet;
	    MapCache.prototype.has = mapHas;
	    MapCache.prototype.set = mapSet;
	
	    // Add functions to the `Set` cache.
	    SetCache.prototype.push = cachePush;
	
	    // Assign cache to `_.memoize`.
	    memoize.Cache = MapCache;
	
	    // Add functions that return wrapped values when chaining.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.callback = callback;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.functions = functions;
	    lodash.groupBy = groupBy;
	    lodash.indexBy = indexBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.invert = invert;
	    lodash.invoke = invoke;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.modArgs = modArgs;
	    lodash.negate = negate;
	    lodash.omit = omit;
	    lodash.once = once;
	    lodash.pairs = pairs;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pluck = pluck;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.restParam = restParam;
	    lodash.set = set;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortByAll = sortByAll;
	    lodash.sortByOrder = sortByOrder;
	    lodash.spread = spread;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.times = times;
	    lodash.toArray = toArray;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.union = union;
	    lodash.uniq = uniq;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.where = where;
	    lodash.without = without;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.backflow = flowRight;
	    lodash.collect = map;
	    lodash.compose = flowRight;
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.extend = assign;
	    lodash.iteratee = callback;
	    lodash.methods = functions;
	    lodash.object = zipObject;
	    lodash.select = filter;
	    lodash.tail = rest;
	    lodash.unique = uniq;
	
	    // Add functions to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add functions that return unwrapped values when chaining.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.deburr = deburr;
	    lodash.endsWith = endsWith;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.findWhere = findWhere;
	    lodash.first = first;
	    lodash.floor = floor;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isBoolean = isBoolean;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isMatch = isMatch;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isString = isString;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.min = min;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padLeft = padLeft;
	    lodash.padRight = padRight;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.sum = sum;
	    lodash.template = template;
	    lodash.trim = trim;
	    lodash.trimLeft = trimLeft;
	    lodash.trimRight = trimRight;
	    lodash.trunc = trunc;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.words = words;
	
	    // Add aliases.
	    lodash.all = every;
	    lodash.any = some;
	    lodash.contains = includes;
	    lodash.eq = isEqual;
	    lodash.detect = find;
	    lodash.foldl = reduce;
	    lodash.foldr = reduceRight;
	    lodash.head = first;
	    lodash.include = includes;
	    lodash.inject = reduce;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!lodash.prototype[methodName]) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), false);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add functions capable of returning wrapped and unwrapped values when chaining.
	    lodash.sample = sample;
	
	    lodash.prototype.sample = function(n) {
	      if (!this.__chain__ && n == null) {
	        return sample(this.value());
	      }
	      return this.thru(function(value) {
	        return sample(value, n);
	      });
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type string
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        var filtered = this.__filtered__;
	        if (filtered && !index) {
	          return new LazyWrapper(this);
	        }
	        n = n == null ? 1 : nativeMax(nativeFloor(n) || 0, 0);
	
	        var result = this.clone();
	        if (filtered) {
	          result.__takeCount__ = nativeMin(result.__takeCount__, n);
	        } else {
	          result.__views__.push({ 'size': n, 'type': methodName + (result.__dir__ < 0 ? 'Right' : '') });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type != LAZY_MAP_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee, thisArg) {
	        var result = this.clone();
	        result.__iteratees__.push({ 'iteratee': getCallback(iteratee, thisArg, 1), 'type': type });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.first` and `_.last`.
	    arrayEach(['first', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.rest`.
	    arrayEach(['initial', 'rest'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.pluck` and `_.where`.
	    arrayEach(['pluck', 'where'], function(methodName, index) {
	      var operationName = index ? 'filter' : 'map',
	          createCallback = index ? baseMatches : property;
	
	      LazyWrapper.prototype[methodName] = function(value) {
	        return this[operationName](createCallback(value));
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.reject = function(predicate, thisArg) {
	      predicate = getCallback(predicate, thisArg, 1);
	      return this.filter(function(value) {
	        return !predicate(value);
	      });
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = start == null ? 0 : (+start || 0);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = (+end || 0);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate, thisArg) {
	      return this.reverse().takeWhile(predicate, thisArg).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(POSITIVE_INFINITY);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|map|reject)|While$/.test(methodName),
	          retUnwrapped = /^(?:first|last)$/.test(methodName),
	          lodashFunc = lodash[retUnwrapped ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName];
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var args = retUnwrapped ? [1] : arguments,
	            chainAll = this.__chain__,
	            value = this.__wrapped__,
	            isHybrid = !!this.__actions__.length,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var interceptor = function(value) {
	          return (retUnwrapped && chainAll)
	            ? lodashFunc(value, 1)[0]
	            : lodashFunc.apply(undefined, arrayPush([value], args));
	        };
	
	        var action = { 'func': thru, 'args': [interceptor], 'thisArg': undefined },
	            onlyLazy = isLazy && !isHybrid;
	
	        if (retUnwrapped && !chainAll) {
	          if (onlyLazy) {
	            value = value.clone();
	            value.__actions__.push(action);
	            return func.call(value);
	          }
	          return lodashFunc.call(undefined, this.value())[0];
	        }
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push(action);
	          return new LodashWrapper(result, chainAll);
	        }
	        return this.thru(interceptor);
	      };
	    });
	
	    // Add `Array` and `String` methods to `lodash.prototype`.
	    arrayEach(['join', 'pop', 'push', 'replace', 'shift', 'sort', 'splice', 'split', 'unshift'], function(methodName) {
	      var func = (/^(?:replace|split)$/.test(methodName) ? stringProto : arrayProto)[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:join|pop|replace|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          return func.apply(this.value(), args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(value, args);
	        });
	      };
	    });
	
	    // Map minified function names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = lodashFunc.name,
	            names = realNames[key] || (realNames[key] = []);
	
	        names.push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybridWrapper(undefined, BIND_KEY_FLAG).name] = [{ 'name': 'wrapper', 'func': undefined }];
	
	    // Add functions to the lazy wrapper.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chaining functions to the `lodash` wrapper.
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.concat = wrapperConcat;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toString = wrapperToString;
	    lodash.prototype.run = lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add function aliases to the `lodash` wrapper.
	    lodash.prototype.collect = lodash.prototype.map;
	    lodash.prototype.head = lodash.prototype.first;
	    lodash.prototype.select = lodash.prototype.filter;
	    lodash.prototype.tail = lodash.prototype.rest;
	
	    return lodash;
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers like r.js check for condition patterns like the following:
	  if (true) {
	    // Expose lodash to the global object when an AMD loader is present to avoid
	    // errors in cases where lodash is loaded by a script tag and not intended
	    // as an AMD module. See http://requirejs.org/docs/errors.html#mismatch for
	    // more details.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds an `exports` object.
	  else if (freeExports && freeModule) {
	    // Export for Node.js or RingoJS.
	    if (moduleExports) {
	      (freeModule.exports = _)._ = _;
	    }
	    // Export for Rhino with CommonJS support.
	    else {
	      freeExports._ = _;
	    }
	  }
	  else {
	    // Export for a browser or Rhino.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(33)(module), (function() { return this; }())))

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__(136);
	
	var _reduxThunk = __webpack_require__(888);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _ui = __webpack_require__(359);
	
	var _ui2 = _interopRequireDefault(_ui);
	
	var _db = __webpack_require__(358);
	
	var _db2 = _interopRequireDefault(_db);
	
	var _reduxFreeze = __webpack_require__(887);
	
	var _reduxFreeze2 = _interopRequireDefault(_reduxFreeze);
	
	var _lodash = __webpack_require__(22);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	//import LogRocket from "logrocket";
	
	var rootReducer = (0, _redux.combineReducers)({
	  ui: _ui2.default,
	  db: _db2.default
	});
	console.log("adding logger");
	//const middlewares = _.compact([thunk, freeze, LogRocket.reduxMiddleware()]);
	var middlewares = _lodash2.default.compact([_reduxThunk2.default, _reduxFreeze2.default]);
	var createStoreWithMiddleware = _redux.applyMiddleware.apply(undefined, _toConsumableArray(middlewares));
	var composeEnhancer = _redux.compose;
	
	composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || _redux.compose;
	
	var configureStore = (0, _redux.createStore)(rootReducer, composeEnhancer(createStoreWithMiddleware));
	console.log("created store");
	
	exports.default = configureStore;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__(2);
	var factory = __webpack_require__(363);
	
	if (typeof React === 'undefined') {
	  throw Error(
	    'create-react-class could not find the React object. If you are using script tags, ' +
	      'make sure that React is being loaded before create-react-class.'
	  );
	}
	
	// Hack to grab NoopUpdateQueue from isomorphic React
	var ReactNoopUpdateQueue = new React.Component().updater;
	
	module.exports = factory(
	  React.Component,
	  React.isValidElement,
	  ReactNoopUpdateQueue
	);


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.addAudit = undefined;
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var addAudit = exports.addAudit = function addAudit(stateChangeHandler, userId, isCreate) {
	  //console.log("<><><><><><><><><><><><><><><>");
	  //console.log("userID received: " + userId);
	  var date = (0, _moment2.default)().format("ddd DD-MM-YY h:mm a");
	  var updateDateTime = date.toLocaleString();
	  //let sortDateTime = 9999999999999 - date.getTime();
	
	  //stateChangeHandler(sortDateTime, "sortDateTime", true);
	  if (isCreate) {
	    stateChangeHandler(updateDateTime, "createDateTime", true);
	  } else {
	    stateChangeHandler(updateDateTime, "updateDateTime", true);
	  }
	  if (userId !== "") {
	    stateChangeHandler(userId, "author", true);
	  }
	
	  //console.log("<><><><><><><><><><><><><><><>");
	};

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getOgDefs = __webpack_require__(329);
	
	var _getOgDefs2 = _interopRequireDefault(_getOgDefs);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var processSingleItemForOgDef = function processSingleItemForOgDef(singleItem) {
	  var newDefSingleItem = {
	    selectorSource: {
	      type: "",
	      table: "",
	      tableField: "",
	      staticSource: []
	    }
	  };
	  Object.keys(singleItem).map(function (key) {
	    if (key === "selectorType") {
	      newDefSingleItem.selectorSource.type = singleItem.selectorType;
	      if (singleItem.selectorType === "static") {
	        newDefSingleItem.selectorSource.table = "";
	        newDefSingleItem.selectorSource.tableField = "name";
	      } else {
	        newDefSingleItem.selectorSource.table = singleItem.table && singleItem.table !== undefined ? singleItem.table : "";
	        newDefSingleItem.selectorSource.tableField = singleItem.tableField && singleItem.tableField !== undefined ? singleItem.tableField : "";
	      }
	    } else if (key === "staticSource") {
	      newDefSingleItem.selectorSource.staticSource = singleItem.staticSource;
	    } else if (key === "table") {} else if (key === "tableField") {} else {
	      newDefSingleItem[key] = singleItem[key];
	    }
	  });
	  return newDefSingleItem;
	};
	
	var getFormattedInOgDef = function getFormattedInOgDef(fields) {
	  var ogDef = {};
	  if (fields && fields.length > 0) {
	    ogDef = fields.reduce(function (prevValue, currValue, currIndex, fullArray) {
	      if (prevValue !== 0) {
	        prevValue[currValue.name] = processSingleItemForOgDef(currValue);
	        return prevValue;
	      } else {
	        prevValue = {};
	        prevValue[currValue.name] = processSingleItemForOgDef(currValue);
	        return prevValue;
	      }
	    }, 0);
	  }
	  //console.log(JSON.stringify(ogDef));
	  return ogDef;
	};
	
	var getExtendedOgDefs = function getExtendedOgDefs(createTable) {
	  //console.log("~ recvd: createTable: " + JSON.stringify(createTable));
	  //console.log("~ recvd: tableList: " + JSON.stringify(tableList));
	  if (createTable && createTable.length > 0) {
	    for (var i = 0; i < createTable.length; i++) {
	      var genFormDef = getFormattedInOgDef(createTable[i]["fields"]);
	      _getOgDefs2.default[createTable[i].name] = genFormDef;
	    }
	  }
	
	  return _getOgDefs2.default;
	};
	
	exports.default = getExtendedOgDefs;

/***/ }),
/* 27 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = {
		"aliceblue": [240, 248, 255],
		"antiquewhite": [250, 235, 215],
		"aqua": [0, 255, 255],
		"aquamarine": [127, 255, 212],
		"azure": [240, 255, 255],
		"beige": [245, 245, 220],
		"bisque": [255, 228, 196],
		"black": [0, 0, 0],
		"blanchedalmond": [255, 235, 205],
		"blue": [0, 0, 255],
		"blueviolet": [138, 43, 226],
		"brown": [165, 42, 42],
		"burlywood": [222, 184, 135],
		"cadetblue": [95, 158, 160],
		"chartreuse": [127, 255, 0],
		"chocolate": [210, 105, 30],
		"coral": [255, 127, 80],
		"cornflowerblue": [100, 149, 237],
		"cornsilk": [255, 248, 220],
		"crimson": [220, 20, 60],
		"cyan": [0, 255, 255],
		"darkblue": [0, 0, 139],
		"darkcyan": [0, 139, 139],
		"darkgoldenrod": [184, 134, 11],
		"darkgray": [169, 169, 169],
		"darkgreen": [0, 100, 0],
		"darkgrey": [169, 169, 169],
		"darkkhaki": [189, 183, 107],
		"darkmagenta": [139, 0, 139],
		"darkolivegreen": [85, 107, 47],
		"darkorange": [255, 140, 0],
		"darkorchid": [153, 50, 204],
		"darkred": [139, 0, 0],
		"darksalmon": [233, 150, 122],
		"darkseagreen": [143, 188, 143],
		"darkslateblue": [72, 61, 139],
		"darkslategray": [47, 79, 79],
		"darkslategrey": [47, 79, 79],
		"darkturquoise": [0, 206, 209],
		"darkviolet": [148, 0, 211],
		"deeppink": [255, 20, 147],
		"deepskyblue": [0, 191, 255],
		"dimgray": [105, 105, 105],
		"dimgrey": [105, 105, 105],
		"dodgerblue": [30, 144, 255],
		"firebrick": [178, 34, 34],
		"floralwhite": [255, 250, 240],
		"forestgreen": [34, 139, 34],
		"fuchsia": [255, 0, 255],
		"gainsboro": [220, 220, 220],
		"ghostwhite": [248, 248, 255],
		"gold": [255, 215, 0],
		"goldenrod": [218, 165, 32],
		"gray": [128, 128, 128],
		"green": [0, 128, 0],
		"greenyellow": [173, 255, 47],
		"grey": [128, 128, 128],
		"honeydew": [240, 255, 240],
		"hotpink": [255, 105, 180],
		"indianred": [205, 92, 92],
		"indigo": [75, 0, 130],
		"ivory": [255, 255, 240],
		"khaki": [240, 230, 140],
		"lavender": [230, 230, 250],
		"lavenderblush": [255, 240, 245],
		"lawngreen": [124, 252, 0],
		"lemonchiffon": [255, 250, 205],
		"lightblue": [173, 216, 230],
		"lightcoral": [240, 128, 128],
		"lightcyan": [224, 255, 255],
		"lightgoldenrodyellow": [250, 250, 210],
		"lightgray": [211, 211, 211],
		"lightgreen": [144, 238, 144],
		"lightgrey": [211, 211, 211],
		"lightpink": [255, 182, 193],
		"lightsalmon": [255, 160, 122],
		"lightseagreen": [32, 178, 170],
		"lightskyblue": [135, 206, 250],
		"lightslategray": [119, 136, 153],
		"lightslategrey": [119, 136, 153],
		"lightsteelblue": [176, 196, 222],
		"lightyellow": [255, 255, 224],
		"lime": [0, 255, 0],
		"limegreen": [50, 205, 50],
		"linen": [250, 240, 230],
		"magenta": [255, 0, 255],
		"maroon": [128, 0, 0],
		"mediumaquamarine": [102, 205, 170],
		"mediumblue": [0, 0, 205],
		"mediumorchid": [186, 85, 211],
		"mediumpurple": [147, 112, 219],
		"mediumseagreen": [60, 179, 113],
		"mediumslateblue": [123, 104, 238],
		"mediumspringgreen": [0, 250, 154],
		"mediumturquoise": [72, 209, 204],
		"mediumvioletred": [199, 21, 133],
		"midnightblue": [25, 25, 112],
		"mintcream": [245, 255, 250],
		"mistyrose": [255, 228, 225],
		"moccasin": [255, 228, 181],
		"navajowhite": [255, 222, 173],
		"navy": [0, 0, 128],
		"oldlace": [253, 245, 230],
		"olive": [128, 128, 0],
		"olivedrab": [107, 142, 35],
		"orange": [255, 165, 0],
		"orangered": [255, 69, 0],
		"orchid": [218, 112, 214],
		"palegoldenrod": [238, 232, 170],
		"palegreen": [152, 251, 152],
		"paleturquoise": [175, 238, 238],
		"palevioletred": [219, 112, 147],
		"papayawhip": [255, 239, 213],
		"peachpuff": [255, 218, 185],
		"peru": [205, 133, 63],
		"pink": [255, 192, 203],
		"plum": [221, 160, 221],
		"powderblue": [176, 224, 230],
		"purple": [128, 0, 128],
		"rebeccapurple": [102, 51, 153],
		"red": [255, 0, 0],
		"rosybrown": [188, 143, 143],
		"royalblue": [65, 105, 225],
		"saddlebrown": [139, 69, 19],
		"salmon": [250, 128, 114],
		"sandybrown": [244, 164, 96],
		"seagreen": [46, 139, 87],
		"seashell": [255, 245, 238],
		"sienna": [160, 82, 45],
		"silver": [192, 192, 192],
		"skyblue": [135, 206, 235],
		"slateblue": [106, 90, 205],
		"slategray": [112, 128, 144],
		"slategrey": [112, 128, 144],
		"snow": [255, 250, 250],
		"springgreen": [0, 255, 127],
		"steelblue": [70, 130, 180],
		"tan": [210, 180, 140],
		"teal": [0, 128, 128],
		"thistle": [216, 191, 216],
		"tomato": [255, 99, 71],
		"turquoise": [64, 224, 208],
		"violet": [238, 130, 238],
		"wheat": [245, 222, 179],
		"white": [255, 255, 255],
		"whitesmoke": [245, 245, 245],
		"yellow": [255, 255, 0],
		"yellowgreen": [154, 205, 50]
	};


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createPath = exports.parsePath = exports.getQueryStringValueFromPath = exports.stripQueryStringValueFromPath = exports.addQueryStringValueToPath = undefined;
	
	var _warning = __webpack_require__(32);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var addQueryStringValueToPath = exports.addQueryStringValueToPath = function addQueryStringValueToPath(path, key, value) {
	  var _parsePath = parsePath(path),
	      pathname = _parsePath.pathname,
	      search = _parsePath.search,
	      hash = _parsePath.hash;
	
	  return createPath({
	    pathname: pathname,
	    search: search + (search.indexOf('?') === -1 ? '?' : '&') + key + '=' + value,
	    hash: hash
	  });
	};
	
	var stripQueryStringValueFromPath = exports.stripQueryStringValueFromPath = function stripQueryStringValueFromPath(path, key) {
	  var _parsePath2 = parsePath(path),
	      pathname = _parsePath2.pathname,
	      search = _parsePath2.search,
	      hash = _parsePath2.hash;
	
	  return createPath({
	    pathname: pathname,
	    search: search.replace(new RegExp('([?&])' + key + '=[a-zA-Z0-9]+(&?)'), function (match, prefix, suffix) {
	      return prefix === '?' ? prefix : suffix;
	    }),
	    hash: hash
	  });
	};
	
	var getQueryStringValueFromPath = exports.getQueryStringValueFromPath = function getQueryStringValueFromPath(path, key) {
	  var _parsePath3 = parsePath(path),
	      search = _parsePath3.search;
	
	  var match = search.match(new RegExp('[?&]' + key + '=([a-zA-Z0-9]+)'));
	  return match && match[1];
	};
	
	var extractPath = function extractPath(string) {
	  var match = string.match(/^(https?:)?\/\/[^\/]*/);
	  return match == null ? string : string.substring(match[0].length);
	};
	
	var parsePath = exports.parsePath = function parsePath(path) {
	  var pathname = extractPath(path);
	  var search = '';
	  var hash = '';
	
	   false ? (0, _warning2.default)(path === pathname, 'A path must be pathname + search + hash only, not a full URL like "%s"', path) : void 0;
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substring(hashIndex);
	    pathname = pathname.substring(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substring(searchIndex);
	    pathname = pathname.substring(0, searchIndex);
	  }
	
	  if (pathname === '') pathname = '/';
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash
	  };
	};
	
	var createPath = exports.createPath = function createPath(location) {
	  if (location == null || typeof location === 'string') return location;
	
	  var basename = location.basename,
	      pathname = location.pathname,
	      search = location.search,
	      hash = location.hash;
	
	  var path = (basename || '') + pathname;
	
	  if (search && search !== '?') path += search;
	
	  if (hash) path += hash;
	
	  return path;
	};

/***/ }),
/* 29 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = mergeClassNames;
	
	function mergeClassNames() {
	  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  return args.reduce(function (classList, arg) {
	    return typeof arg === 'string' || arg instanceof Array ? classList.concat(arg) : classList;
	  }, []).filter(Boolean).join(' ');
	}

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (function(e) {
		var t = {};
		function r(n) {
			if (t[n]) return t[n].exports;
			var o = (t[n] = { i: n, l: !1, exports: {} });
			return e[n].call(o.exports, o, o.exports, r), (o.l = !0), o.exports;
		}
		return (
			(r.m = e),
			(r.c = t),
			(r.d = function(e, t, n) {
				r.o(e, t) ||
					Object.defineProperty(e, t, { enumerable: !0, get: n });
			}),
			(r.r = function(e) {
				'undefined' != typeof Symbol &&
					Symbol.toStringTag &&
					Object.defineProperty(e, Symbol.toStringTag, {
						value: 'Module',
					}),
					Object.defineProperty(e, '__esModule', { value: !0 });
			}),
			(r.t = function(e, t) {
				if ((1 & t && (e = r(e)), 8 & t)) return e;
				if (4 & t && 'object' == typeof e && e && e.__esModule) return e;
				var n = Object.create(null);
				if (
					(r.r(n),
					Object.defineProperty(n, 'default', {
						enumerable: !0,
						value: e,
					}),
					2 & t && 'string' != typeof e)
				)
					for (var o in e)
						r.d(
							n,
							o,
							function(t) {
								return e[t];
							}.bind(null, o)
						);
				return n;
			}),
			(r.n = function(e) {
				var t =
					e && e.__esModule
						? function() {
								return e.default;
						  }
						: function() {
								return e;
						  };
				return r.d(t, 'a', t), t;
			}),
			(r.o = function(e, t) {
				return Object.prototype.hasOwnProperty.call(e, t);
			}),
			(r.p = ''),
			r((r.s = 8))
		);
	})([
		function(e, t) {
			e.exports = __webpack_require__(2);
		},
		function(e, t, r) {
			e.exports = r(10)();
		},
		function(e, t, r) {
			'use strict';
			Object.defineProperty(t, '__esModule', { value: !0 }),
				(t.default = function() {
					return (
						'undefined' != typeof window &&
						'IntersectionObserver' in window &&
						'isIntersecting' in
							window.IntersectionObserverEntry.prototype
					);
				});
		},
		function(e, t, r) {
			'use strict';
			Object.defineProperty(t, '__esModule', { value: !0 });
			var n = (function() {
					function e(e, t) {
						for (var r = 0; r < t.length; r++) {
							var n = t[r];
							(n.enumerable = n.enumerable || !1),
								(n.configurable = !0),
								'value' in n && (n.writable = !0),
								Object.defineProperty(e, n.key, n);
						}
					}
					return function(t, r, n) {
						return r && e(t.prototype, r), n && e(t, n), t;
					};
				})(),
				o = u(r(0)),
				i = r(1),
				a = u(r(4)),
				s = u(r(12)),
				l = u(r(2));
			function u(e) {
				return e && e.__esModule ? e : { default: e };
			}
			var c = (function(e) {
				function t(e) {
					!(function(e, t) {
						if (!(e instanceof t))
							throw new TypeError(
								'Cannot call a class as a function'
							);
					})(this, t);
					var r = (function(e, t) {
							if (!e)
								throw new ReferenceError(
									"this hasn't been initialised - super() hasn't been called"
								);
							return !t ||
								('object' != typeof t && 'function' != typeof t)
								? e
								: t;
						})(
							this,
							(t.__proto__ || Object.getPrototypeOf(t)).call(this, e)
						),
						n = e.afterLoad,
						o = e.beforeLoad,
						i = e.scrollPosition,
						a = e.visibleByDefault;
					return (
						(r.state = { visible: a }),
						a && (o(), n()),
						(r.onVisible = r.onVisible.bind(r)),
						(r.isScrollTracked = Boolean(
							i &&
								Number.isFinite(i.x) &&
								i.x >= 0 &&
								Number.isFinite(i.y) &&
								i.y >= 0
						)),
						r
					);
				}
				return (
					(function(e, t) {
						if ('function' != typeof t && null !== t)
							throw new TypeError(
								'Super expression must either be null or a function, not ' +
									typeof t
							);
						(e.prototype = Object.create(t && t.prototype, {
							constructor: {
								value: e,
								enumerable: !1,
								writable: !0,
								configurable: !0,
							},
						})),
							t &&
								(Object.setPrototypeOf
									? Object.setPrototypeOf(e, t)
									: (e.__proto__ = t));
					})(t, e),
					n(t, [
						{
							key: 'componentDidUpdate',
							value: function(e, t) {
								t.visible !== this.state.visible &&
									this.props.afterLoad();
							},
						},
						{
							key: 'onVisible',
							value: function() {
								this.props.beforeLoad(),
									this.setState({ visible: !0 });
							},
						},
						{
							key: 'render',
							value: function() {
								if (this.state.visible) return this.props.children;
								var e = this.props,
									t = e.className,
									r = e.delayMethod,
									n = e.delayTime,
									i = e.height,
									u = e.placeholder,
									c = e.scrollPosition,
									f = e.style,
									p = e.threshold,
									d = e.useIntersectionObserver,
									y = e.width;
								return this.isScrollTracked ||
									(d && (0, l.default)())
									? o.default.createElement(a.default, {
											className: t,
											height: i,
											onVisible: this.onVisible,
											placeholder: u,
											scrollPosition: c,
											style: f,
											threshold: p,
											useIntersectionObserver: d,
											width: y,
									  })
									: o.default.createElement(s.default, {
											className: t,
											delayMethod: r,
											delayTime: n,
											height: i,
											onVisible: this.onVisible,
											placeholder: u,
											style: f,
											threshold: p,
											width: y,
									  });
							},
						},
					]),
					t
				);
			})(o.default.Component);
			(c.propTypes = {
				afterLoad: i.PropTypes.func,
				beforeLoad: i.PropTypes.func,
				useIntersectionObserver: i.PropTypes.bool,
				visibleByDefault: i.PropTypes.bool,
			}),
				(c.defaultProps = {
					afterLoad: function() {
						return {};
					},
					beforeLoad: function() {
						return {};
					},
					useIntersectionObserver: !0,
					visibleByDefault: !1,
				}),
				(t.default = c);
		},
		function(e, t, r) {
			'use strict';
			Object.defineProperty(t, '__esModule', { value: !0 });
			var n =
					Object.assign ||
					function(e) {
						for (var t = 1; t < arguments.length; t++) {
							var r = arguments[t];
							for (var n in r)
								Object.prototype.hasOwnProperty.call(r, n) &&
									(e[n] = r[n]);
						}
						return e;
					},
				o = (function() {
					function e(e, t) {
						for (var r = 0; r < t.length; r++) {
							var n = t[r];
							(n.enumerable = n.enumerable || !1),
								(n.configurable = !0),
								'value' in n && (n.writable = !0),
								Object.defineProperty(e, n.key, n);
						}
					}
					return function(t, r, n) {
						return r && e(t.prototype, r), n && e(t, n), t;
					};
				})(),
				i = u(r(0)),
				a = u(r(5)),
				s = r(1),
				l = u(r(2));
			function u(e) {
				return e && e.__esModule ? e : { default: e };
			}
			var c = function(e) {
					e.forEach(function(e) {
						e.isIntersecting && e.target.onVisible();
					});
				},
				f = {},
				p = function(e) {
					return (
						(f[e] =
							f[e] ||
							new IntersectionObserver(c, { rootMargin: e + 'px' })),
						f[e]
					);
				},
				d = (function(e) {
					function t(e) {
						!(function(e, t) {
							if (!(e instanceof t))
								throw new TypeError(
									'Cannot call a class as a function'
								);
						})(this, t);
						var r = (function(e, t) {
							if (!e)
								throw new ReferenceError(
									"this hasn't been initialised - super() hasn't been called"
								);
							return !t ||
								('object' != typeof t && 'function' != typeof t)
								? e
								: t;
						})(
							this,
							(t.__proto__ || Object.getPrototypeOf(t)).call(this, e)
						);
						if (
							((r.supportsObserver =
								!e.scrollPosition &&
								e.useIntersectionObserver &&
								(0, l.default)()),
							r.supportsObserver)
						) {
							var n = e.threshold;
							r.observer = p(n);
						}
						return r;
					}
					return (
						(function(e, t) {
							if ('function' != typeof t && null !== t)
								throw new TypeError(
									'Super expression must either be null or a function, not ' +
										typeof t
								);
							(e.prototype = Object.create(t && t.prototype, {
								constructor: {
									value: e,
									enumerable: !1,
									writable: !0,
									configurable: !0,
								},
							})),
								t &&
									(Object.setPrototypeOf
										? Object.setPrototypeOf(e, t)
										: (e.__proto__ = t));
						})(t, e),
						o(t, [
							{
								key: 'componentDidMount',
								value: function() {
									this.placeholder &&
										this.observer &&
										((this.placeholder.onVisible = this.props.onVisible),
										this.observer.observe(this.placeholder)),
										this.supportsObserver ||
											this.updateVisibility();
								},
							},
							{
								key: 'componentWillUnmount',
								value: function() {
									this.observer &&
										this.observer.unobserve(this.placeholder);
								},
							},
							{
								key: 'componentDidUpdate',
								value: function() {
									this.supportsObserver ||
										this.updateVisibility();
								},
							},
							{
								key: 'getPlaceholderBoundingBox',
								value: function() {
									var e =
											arguments.length > 0 &&
											void 0 !== arguments[0]
												? arguments[0]
												: this.props.scrollPosition,
										t = this.placeholder.getBoundingClientRect(),
										r = a.default.findDOMNode(this.placeholder)
											.style,
										n = {
											left:
												parseInt(
													r.getPropertyValue(
														'margin-left'
													),
													10
												) || 0,
											top:
												parseInt(
													r.getPropertyValue(
														'margin-top'
													),
													10
												) || 0,
										};
									return {
										bottom: e.y + t.bottom + n.top,
										left: e.x + t.left + n.left,
										right: e.x + t.right + n.left,
										top: e.y + t.top + n.top,
									};
								},
							},
							{
								key: 'isPlaceholderInViewport',
								value: function() {
									if (
										'undefined' == typeof window ||
										!this.placeholder
									)
										return !1;
									var e = this.props,
										t = e.scrollPosition,
										r = e.threshold,
										n = this.getPlaceholderBoundingBox(t),
										o = t.y + window.innerHeight,
										i = t.x,
										a = t.x + window.innerWidth,
										s = t.y;
									return Boolean(
										s - r <= n.bottom &&
											o + r >= n.top &&
											i - r <= n.right &&
											a + r >= n.left
									);
								},
							},
							{
								key: 'updateVisibility',
								value: function() {
									this.isPlaceholderInViewport() &&
										this.props.onVisible();
								},
							},
							{
								key: 'render',
								value: function() {
									var e = this,
										t = this.props,
										r = t.className,
										o = t.height,
										a = t.placeholder,
										s = t.style,
										l = t.width;
									if (a && 'function' != typeof a.type)
										return i.default.cloneElement(a, {
											ref: function(t) {
												return (e.placeholder = t);
											},
										});
									var u = n({ display: 'inline-block' }, s);
									return (
										void 0 !== l && (u.width = l),
										void 0 !== o && (u.height = o),
										i.default.createElement(
											'span',
											{
												className: r,
												ref: function(t) {
													return (e.placeholder = t);
												},
												style: u,
											},
											a
										)
									);
								},
							},
						]),
						t
					);
				})(i.default.Component);
			(d.propTypes = {
				onVisible: s.PropTypes.func.isRequired,
				className: s.PropTypes.string,
				height: s.PropTypes.oneOfType([
					s.PropTypes.number,
					s.PropTypes.string,
				]),
				placeholder: s.PropTypes.element,
				threshold: s.PropTypes.number,
				useIntersectionObserver: s.PropTypes.bool,
				scrollPosition: s.PropTypes.shape({
					x: s.PropTypes.number.isRequired,
					y: s.PropTypes.number.isRequired,
				}),
				width: s.PropTypes.oneOfType([
					s.PropTypes.number,
					s.PropTypes.string,
				]),
			}),
				(d.defaultProps = {
					className: '',
					placeholder: null,
					threshold: 100,
					useIntersectionObserver: !0,
				}),
				(t.default = d);
		},
		function(e, t) {
			e.exports = __webpack_require__(17);
		},
		function(e, t, r) {
			'use strict';
			Object.defineProperty(t, '__esModule', { value: !0 });
			var n =
					Object.assign ||
					function(e) {
						for (var t = 1; t < arguments.length; t++) {
							var r = arguments[t];
							for (var n in r)
								Object.prototype.hasOwnProperty.call(r, n) &&
									(e[n] = r[n]);
						}
						return e;
					},
				o = (function() {
					function e(e, t) {
						for (var r = 0; r < t.length; r++) {
							var n = t[r];
							(n.enumerable = n.enumerable || !1),
								(n.configurable = !0),
								'value' in n && (n.writable = !0),
								Object.defineProperty(e, n.key, n);
						}
					}
					return function(t, r, n) {
						return r && e(t.prototype, r), n && e(t, n), t;
					};
				})(),
				i = p(r(0)),
				a = p(r(5)),
				s = r(1),
				l = p(r(13)),
				u = p(r(14)),
				c = p(r(2)),
				f = p(r(15));
			function p(e) {
				return e && e.__esModule ? e : { default: e };
			}
			function d(e, t) {
				if (!e)
					throw new ReferenceError(
						"this hasn't been initialised - super() hasn't been called"
					);
				return !t || ('object' != typeof t && 'function' != typeof t)
					? e
					: t;
			}
			var y = function() {
					return 'undefined' == typeof window
						? 0
						: window.scrollX || window.pageXOffset;
				},
				h = function() {
					return 'undefined' == typeof window
						? 0
						: window.scrollY || window.pageYOffset;
				};
			t.default = function(e) {
				var t = (function(t) {
					function r(e) {
						!(function(e, t) {
							if (!(e instanceof t))
								throw new TypeError(
									'Cannot call a class as a function'
								);
						})(this, r);
						var t = d(
							this,
							(r.__proto__ || Object.getPrototypeOf(r)).call(this, e)
						);
						if (
							((t.useIntersectionObserver =
								e.useIntersectionObserver && (0, c.default)()),
							t.useIntersectionObserver)
						)
							return d(t);
						var n = t.onChangeScroll.bind(t);
						return (
							'debounce' === e.delayMethod
								? (t.delayedScroll = (0, l.default)(n, e.delayTime))
								: 'throttle' === e.delayMethod &&
								  (t.delayedScroll = (0, u.default)(
										n,
										e.delayTime
								  )),
							(t.state = { scrollPosition: { x: y(), y: h() } }),
							(t.baseComponentRef = i.default.createRef()),
							t
						);
					}
					return (
						(function(e, t) {
							if ('function' != typeof t && null !== t)
								throw new TypeError(
									'Super expression must either be null or a function, not ' +
										typeof t
								);
							(e.prototype = Object.create(t && t.prototype, {
								constructor: {
									value: e,
									enumerable: !1,
									writable: !0,
									configurable: !0,
								},
							})),
								t &&
									(Object.setPrototypeOf
										? Object.setPrototypeOf(e, t)
										: (e.__proto__ = t));
						})(r, t),
						o(r, [
							{
								key: 'componentDidMount',
								value: function() {
									this.addListeners();
								},
							},
							{
								key: 'componentWillUnmount',
								value: function() {
									this.removeListeners();
								},
							},
							{
								key: 'componentDidUpdate',
								value: function() {
									'undefined' == typeof window ||
										this.useIntersectionObserver ||
										((0, f.default)(
											a.default.findDOMNode(
												this.baseComponentRef.current
											)
										) !== this.scrollElement &&
											(this.removeListeners(),
											this.addListeners()));
								},
							},
							{
								key: 'addListeners',
								value: function() {
									'undefined' == typeof window ||
										this.useIntersectionObserver ||
										((this.scrollElement = (0, f.default)(
											a.default.findDOMNode(
												this.baseComponentRef.current
											)
										)),
										this.scrollElement.addEventListener(
											'scroll',
											this.delayedScroll,
											{ passive: !0 }
										),
										window.addEventListener(
											'resize',
											this.delayedScroll,
											{ passive: !0 }
										),
										this.scrollElement !== window &&
											window.addEventListener(
												'scroll',
												this.delayedScroll,
												{ passive: !0 }
											));
								},
							},
							{
								key: 'removeListeners',
								value: function() {
									'undefined' == typeof window ||
										this.useIntersectionObserver ||
										(this.scrollElement.removeEventListener(
											'scroll',
											this.delayedScroll
										),
										window.removeEventListener(
											'resize',
											this.delayedScroll
										),
										this.scrollElement !== window &&
											window.removeEventListener(
												'scroll',
												this.delayedScroll
											));
								},
							},
							{
								key: 'onChangeScroll',
								value: function() {
									this.useIntersectionObserver ||
										this.setState({
											scrollPosition: { x: y(), y: h() },
										});
								},
							},
							{
								key: 'render',
								value: function() {
									var t = this.props,
										r =
											(t.delayMethod,
											t.delayTime,
											(function(e, t) {
												var r = {};
												for (var n in e)
													t.indexOf(n) >= 0 ||
														(Object.prototype.hasOwnProperty.call(
															e,
															n
														) &&
															(r[n] = e[n]));
												return r;
											})(t, ['delayMethod', 'delayTime'])),
										o = this.useIntersectionObserver
											? null
											: this.state.scrollPosition;
									return i.default.createElement(
										e,
										n(
											{
												ref: this.baseComponentRef,
												scrollPosition: o,
											},
											r
										)
									);
								},
							},
						]),
						r
					);
				})(i.default.Component);
				return (
					(t.propTypes = {
						delayMethod: s.PropTypes.oneOf(['debounce', 'throttle']),
						delayTime: s.PropTypes.number,
						useIntersectionObserver: s.PropTypes.bool,
					}),
					(t.defaultProps = {
						delayMethod: 'throttle',
						delayTime: 300,
						useIntersectionObserver: !0,
					}),
					t
				);
			};
		},
		function(e, t) {
			var r;
			r = (function() {
				return this;
			})();
			try {
				r = r || new Function('return this')();
			} catch (e) {
				'object' == typeof window && (r = window);
			}
			e.exports = r;
		},
		function(e, t, r) {
			'use strict';
			Object.defineProperty(t, '__esModule', { value: !0 }),
				(t.trackWindowScroll = t.LazyLoadComponent = t.LazyLoadImage = void 0);
			var n = a(r(9)),
				o = a(r(3)),
				i = a(r(6));
			function a(e) {
				return e && e.__esModule ? e : { default: e };
			}
			(t.LazyLoadImage = n.default),
				(t.LazyLoadComponent = o.default),
				(t.trackWindowScroll = i.default);
		},
		function(e, t, r) {
			'use strict';
			Object.defineProperty(t, '__esModule', { value: !0 });
			var n =
					Object.assign ||
					function(e) {
						for (var t = 1; t < arguments.length; t++) {
							var r = arguments[t];
							for (var n in r)
								Object.prototype.hasOwnProperty.call(r, n) &&
									(e[n] = r[n]);
						}
						return e;
					},
				o = (function() {
					function e(e, t) {
						for (var r = 0; r < t.length; r++) {
							var n = t[r];
							(n.enumerable = n.enumerable || !1),
								(n.configurable = !0),
								'value' in n && (n.writable = !0),
								Object.defineProperty(e, n.key, n);
						}
					}
					return function(t, r, n) {
						return r && e(t.prototype, r), n && e(t, n), t;
					};
				})(),
				i = l(r(0)),
				a = r(1),
				s = l(r(3));
			function l(e) {
				return e && e.__esModule ? e : { default: e };
			}
			var u = (function(e) {
				function t(e) {
					!(function(e, t) {
						if (!(e instanceof t))
							throw new TypeError(
								'Cannot call a class as a function'
							);
					})(this, t);
					var r = (function(e, t) {
						if (!e)
							throw new ReferenceError(
								"this hasn't been initialised - super() hasn't been called"
							);
						return !t ||
							('object' != typeof t && 'function' != typeof t)
							? e
							: t;
					})(
						this,
						(t.__proto__ || Object.getPrototypeOf(t)).call(this, e)
					);
					return (r.state = { loaded: !1 }), r;
				}
				return (
					(function(e, t) {
						if ('function' != typeof t && null !== t)
							throw new TypeError(
								'Super expression must either be null or a function, not ' +
									typeof t
							);
						(e.prototype = Object.create(t && t.prototype, {
							constructor: {
								value: e,
								enumerable: !1,
								writable: !0,
								configurable: !0,
							},
						})),
							t &&
								(Object.setPrototypeOf
									? Object.setPrototypeOf(e, t)
									: (e.__proto__ = t));
					})(t, e),
					o(t, [
						{
							key: 'onImageLoad',
							value: function() {
								var e = this;
								return this.state.loaded
									? null
									: function() {
											e.props.afterLoad(),
												e.setState({ loaded: !0 });
									  };
							},
						},
						{
							key: 'getImg',
							value: function() {
								var e = this.props,
									t =
										(e.afterLoad,
										e.beforeLoad,
										e.delayMethod,
										e.delayTime,
										e.effect,
										e.placeholder,
										e.placeholderSrc,
										e.scrollPosition,
										e.threshold,
										e.useIntersectionObserver,
										e.visibleByDefault,
										e.wrapperClassName,
										e.wrapperProps,
										(function(e, t) {
											var r = {};
											for (var n in e)
												t.indexOf(n) >= 0 ||
													(Object.prototype.hasOwnProperty.call(
														e,
														n
													) &&
														(r[n] = e[n]));
											return r;
										})(e, [
											'afterLoad',
											'beforeLoad',
											'delayMethod',
											'delayTime',
											'effect',
											'placeholder',
											'placeholderSrc',
											'scrollPosition',
											'threshold',
											'useIntersectionObserver',
											'visibleByDefault',
											'wrapperClassName',
											'wrapperProps',
										]));
								return i.default.createElement(
									'img',
									n({ onLoad: this.onImageLoad() }, t)
								);
							},
						},
						{
							key: 'getLazyLoadImage',
							value: function() {
								var e = this.props,
									t = e.beforeLoad,
									r = e.className,
									n = e.delayMethod,
									o = e.delayTime,
									a = e.height,
									l = e.placeholder,
									u = e.scrollPosition,
									c = e.style,
									f = e.threshold,
									p = e.useIntersectionObserver,
									d = e.visibleByDefault,
									y = e.width;
								return i.default.createElement(
									s.default,
									{
										beforeLoad: t,
										className: r,
										delayMethod: n,
										delayTime: o,
										height: a,
										placeholder: l,
										scrollPosition: u,
										style: c,
										threshold: f,
										useIntersectionObserver: p,
										visibleByDefault: d,
										width: y,
									},
									this.getImg()
								);
							},
						},
						{
							key: 'getWrappedLazyLoadImage',
							value: function(e) {
								var t = this.props,
									r = t.effect,
									o = t.height,
									a = t.placeholderSrc,
									s = t.width,
									l = t.wrapperClassName,
									u = t.wrapperProps,
									c = this.state.loaded,
									f = c ? ' lazy-load-image-loaded' : '';
								return i.default.createElement(
									'span',
									n(
										{
											className:
												l +
												' lazy-load-image-background ' +
												r +
												f,
											style: {
												backgroundImage:
													c || !a ? '' : 'url(' + a + ')',
												backgroundSize:
													c || !a ? '' : '100% 100%',
												color: 'transparent',
												display: 'inline-block',
												height: o,
												width: s,
											},
										},
										u
									),
									e
								);
							},
						},
						{
							key: 'render',
							value: function() {
								var e = this.props,
									t = e.effect,
									r = e.placeholderSrc,
									n = e.visibleByDefault,
									o = e.wrapperClassName,
									i = e.wrapperProps,
									a = this.getLazyLoadImage();
								return ((t || r) && !n) || o || i
									? this.getWrappedLazyLoadImage(a)
									: a;
							},
						},
					]),
					t
				);
			})(i.default.Component);
			(u.propTypes = {
				afterLoad: a.PropTypes.func,
				beforeLoad: a.PropTypes.func,
				delayMethod: a.PropTypes.string,
				delayTime: a.PropTypes.number,
				effect: a.PropTypes.string,
				placeholderSrc: a.PropTypes.string,
				threshold: a.PropTypes.number,
				useIntersectionObserver: a.PropTypes.bool,
				visibleByDefault: a.PropTypes.bool,
				wrapperClassName: a.PropTypes.string,
				wrapperProps: a.PropTypes.object,
			}),
				(u.defaultProps = {
					afterLoad: function() {
						return {};
					},
					beforeLoad: function() {
						return {};
					},
					delayMethod: 'throttle',
					delayTime: 300,
					effect: '',
					placeholderSrc: null,
					threshold: 100,
					useIntersectionObserver: !0,
					visibleByDefault: !1,
					wrapperClassName: '',
				}),
				(t.default = u);
		},
		function(e, t, r) {
			'use strict';
			var n = r(11);
			function o() {}
			function i() {}
			(i.resetWarningCache = o),
				(e.exports = function() {
					function e(e, t, r, o, i, a) {
						if (a !== n) {
							var s = new Error(
								'Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types'
							);
							throw ((s.name = 'Invariant Violation'), s);
						}
					}
					function t() {
						return e;
					}
					e.isRequired = e;
					var r = {
						array: e,
						bool: e,
						func: e,
						number: e,
						object: e,
						string: e,
						symbol: e,
						any: e,
						arrayOf: t,
						element: e,
						elementType: e,
						instanceOf: t,
						node: e,
						objectOf: t,
						oneOf: t,
						oneOfType: t,
						shape: t,
						exact: t,
						checkPropTypes: i,
						resetWarningCache: o,
					};
					return (r.PropTypes = r), r;
				});
		},
		function(e, t, r) {
			'use strict';
			e.exports = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
		},
		function(e, t, r) {
			'use strict';
			Object.defineProperty(t, '__esModule', { value: !0 });
			var n = (function() {
					function e(e, t) {
						for (var r = 0; r < t.length; r++) {
							var n = t[r];
							(n.enumerable = n.enumerable || !1),
								(n.configurable = !0),
								'value' in n && (n.writable = !0),
								Object.defineProperty(e, n.key, n);
						}
					}
					return function(t, r, n) {
						return r && e(t.prototype, r), n && e(t, n), t;
					};
				})(),
				o = s(r(0)),
				i = s(r(4)),
				a = s(r(6));
			function s(e) {
				return e && e.__esModule ? e : { default: e };
			}
			var l = (function(e) {
				function t(e) {
					return (
						(function(e, t) {
							if (!(e instanceof t))
								throw new TypeError(
									'Cannot call a class as a function'
								);
						})(this, t),
						(function(e, t) {
							if (!e)
								throw new ReferenceError(
									"this hasn't been initialised - super() hasn't been called"
								);
							return !t ||
								('object' != typeof t && 'function' != typeof t)
								? e
								: t;
						})(
							this,
							(t.__proto__ || Object.getPrototypeOf(t)).call(this, e)
						)
					);
				}
				return (
					(function(e, t) {
						if ('function' != typeof t && null !== t)
							throw new TypeError(
								'Super expression must either be null or a function, not ' +
									typeof t
							);
						(e.prototype = Object.create(t && t.prototype, {
							constructor: {
								value: e,
								enumerable: !1,
								writable: !0,
								configurable: !0,
							},
						})),
							t &&
								(Object.setPrototypeOf
									? Object.setPrototypeOf(e, t)
									: (e.__proto__ = t));
					})(t, e),
					n(t, [
						{
							key: 'render',
							value: function() {
								return o.default.createElement(
									i.default,
									this.props
								);
							},
						},
					]),
					t
				);
			})(o.default.Component);
			t.default = (0, a.default)(l);
		},
		function(e, t, r) {
			(function(t) {
				var r = 'Expected a function',
					n = NaN,
					o = '[object Symbol]',
					i = /^\s+|\s+$/g,
					a = /^[-+]0x[0-9a-f]+$/i,
					s = /^0b[01]+$/i,
					l = /^0o[0-7]+$/i,
					u = parseInt,
					c = 'object' == typeof t && t && t.Object === Object && t,
					f =
						'object' == typeof self &&
						self &&
						self.Object === Object &&
						self,
					p = c || f || Function('return this')(),
					d = Object.prototype.toString,
					y = Math.max,
					h = Math.min,
					b = function() {
						return p.Date.now();
					};
				function v(e) {
					var t = typeof e;
					return !!e && ('object' == t || 'function' == t);
				}
				function m(e) {
					if ('number' == typeof e) return e;
					if (
						(function(e) {
							return (
								'symbol' == typeof e ||
								((function(e) {
									return !!e && 'object' == typeof e;
								})(e) &&
									d.call(e) == o)
							);
						})(e)
					)
						return n;
					if (v(e)) {
						var t = 'function' == typeof e.valueOf ? e.valueOf() : e;
						e = v(t) ? t + '' : t;
					}
					if ('string' != typeof e) return 0 === e ? e : +e;
					e = e.replace(i, '');
					var r = s.test(e);
					return r || l.test(e)
						? u(e.slice(2), r ? 2 : 8)
						: a.test(e)
						? n
						: +e;
				}
				e.exports = function(e, t, n) {
					var o,
						i,
						a,
						s,
						l,
						u,
						c = 0,
						f = !1,
						p = !1,
						d = !0;
					if ('function' != typeof e) throw new TypeError(r);
					function w(t) {
						var r = o,
							n = i;
						return (o = i = void 0), (c = t), (s = e.apply(n, r));
					}
					function O(e) {
						var r = e - u;
						return void 0 === u || r >= t || r < 0 || (p && e - c >= a);
					}
					function g() {
						var e = b();
						if (O(e)) return P(e);
						l = setTimeout(
							g,
							(function(e) {
								var r = t - (e - u);
								return p ? h(r, a - (e - c)) : r;
							})(e)
						);
					}
					function P(e) {
						return (l = void 0), d && o ? w(e) : ((o = i = void 0), s);
					}
					function T() {
						var e = b(),
							r = O(e);
						if (((o = arguments), (i = this), (u = e), r)) {
							if (void 0 === l)
								return (function(e) {
									return (
										(c = e),
										(l = setTimeout(g, t)),
										f ? w(e) : s
									);
								})(u);
							if (p) return (l = setTimeout(g, t)), w(u);
						}
						return void 0 === l && (l = setTimeout(g, t)), s;
					}
					return (
						(t = m(t) || 0),
						v(n) &&
							((f = !!n.leading),
							(a = (p = 'maxWait' in n)
								? y(m(n.maxWait) || 0, t)
								: a),
							(d = 'trailing' in n ? !!n.trailing : d)),
						(T.cancel = function() {
							void 0 !== l && clearTimeout(l),
								(c = 0),
								(o = u = i = l = void 0);
						}),
						(T.flush = function() {
							return void 0 === l ? s : P(b());
						}),
						T
					);
				};
			}.call(this, r(7)));
		},
		function(e, t, r) {
			(function(t) {
				var r = 'Expected a function',
					n = NaN,
					o = '[object Symbol]',
					i = /^\s+|\s+$/g,
					a = /^[-+]0x[0-9a-f]+$/i,
					s = /^0b[01]+$/i,
					l = /^0o[0-7]+$/i,
					u = parseInt,
					c = 'object' == typeof t && t && t.Object === Object && t,
					f =
						'object' == typeof self &&
						self &&
						self.Object === Object &&
						self,
					p = c || f || Function('return this')(),
					d = Object.prototype.toString,
					y = Math.max,
					h = Math.min,
					b = function() {
						return p.Date.now();
					};
				function v(e, t, n) {
					var o,
						i,
						a,
						s,
						l,
						u,
						c = 0,
						f = !1,
						p = !1,
						d = !0;
					if ('function' != typeof e) throw new TypeError(r);
					function v(t) {
						var r = o,
							n = i;
						return (o = i = void 0), (c = t), (s = e.apply(n, r));
					}
					function O(e) {
						var r = e - u;
						return void 0 === u || r >= t || r < 0 || (p && e - c >= a);
					}
					function g() {
						var e = b();
						if (O(e)) return P(e);
						l = setTimeout(
							g,
							(function(e) {
								var r = t - (e - u);
								return p ? h(r, a - (e - c)) : r;
							})(e)
						);
					}
					function P(e) {
						return (l = void 0), d && o ? v(e) : ((o = i = void 0), s);
					}
					function T() {
						var e = b(),
							r = O(e);
						if (((o = arguments), (i = this), (u = e), r)) {
							if (void 0 === l)
								return (function(e) {
									return (
										(c = e),
										(l = setTimeout(g, t)),
										f ? v(e) : s
									);
								})(u);
							if (p) return (l = setTimeout(g, t)), v(u);
						}
						return void 0 === l && (l = setTimeout(g, t)), s;
					}
					return (
						(t = w(t) || 0),
						m(n) &&
							((f = !!n.leading),
							(a = (p = 'maxWait' in n)
								? y(w(n.maxWait) || 0, t)
								: a),
							(d = 'trailing' in n ? !!n.trailing : d)),
						(T.cancel = function() {
							void 0 !== l && clearTimeout(l),
								(c = 0),
								(o = u = i = l = void 0);
						}),
						(T.flush = function() {
							return void 0 === l ? s : P(b());
						}),
						T
					);
				}
				function m(e) {
					var t = typeof e;
					return !!e && ('object' == t || 'function' == t);
				}
				function w(e) {
					if ('number' == typeof e) return e;
					if (
						(function(e) {
							return (
								'symbol' == typeof e ||
								((function(e) {
									return !!e && 'object' == typeof e;
								})(e) &&
									d.call(e) == o)
							);
						})(e)
					)
						return n;
					if (m(e)) {
						var t = 'function' == typeof e.valueOf ? e.valueOf() : e;
						e = m(t) ? t + '' : t;
					}
					if ('string' != typeof e) return 0 === e ? e : +e;
					e = e.replace(i, '');
					var r = s.test(e);
					return r || l.test(e)
						? u(e.slice(2), r ? 2 : 8)
						: a.test(e)
						? n
						: +e;
				}
				e.exports = function(e, t, n) {
					var o = !0,
						i = !0;
					if ('function' != typeof e) throw new TypeError(r);
					return (
						m(n) &&
							((o = 'leading' in n ? !!n.leading : o),
							(i = 'trailing' in n ? !!n.trailing : i)),
						v(e, t, { leading: o, maxWait: t, trailing: i })
					);
				};
			}.call(this, r(7)));
		},
		function(e, t, r) {
			'use strict';
			Object.defineProperty(t, '__esModule', { value: !0 });
			var n = function(e, t) {
					return 'undefined' == typeof getComputedStyle
						? e.style[t]
						: getComputedStyle(e, null).getPropertyValue(t);
				},
				o = function(e) {
					return (
						n(e, 'overflow') + n(e, 'overflow-y') + n(e, 'overflow-x')
					);
				};
			t.default = function(e) {
				if (!(e instanceof HTMLElement)) return window;
				for (
					var t = e;
					t &&
					t !== document.body &&
					t !== document.documentElement &&
					t.parentNode;
	
				) {
					if (/(scroll|auto)/.test(o(t))) return t;
					t = t.parentNode;
				}
				return window;
			};
		},
	]);


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.isReactChildren = isReactChildren;
	exports.createRouteFromReactElement = createRouteFromReactElement;
	exports.createRoutesFromReactChildren = createRoutesFromReactChildren;
	exports.createRoutes = createRoutes;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isValidChild(object) {
	  return object == null || _react2.default.isValidElement(object);
	}
	
	function isReactChildren(object) {
	  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
	}
	
	function createRoute(defaultProps, props) {
	  return _extends({}, defaultProps, props);
	}
	
	function createRouteFromReactElement(element) {
	  var type = element.type;
	  var route = createRoute(type.defaultProps, element.props);
	
	  if (route.children) {
	    var childRoutes = createRoutesFromReactChildren(route.children, route);
	
	    if (childRoutes.length) route.childRoutes = childRoutes;
	
	    delete route.children;
	  }
	
	  return route;
	}
	
	/**
	 * Creates and returns a routes object from the given ReactChildren. JSX
	 * provides a convenient way to visualize how routes in the hierarchy are
	 * nested.
	 *
	 *   import { Route, createRoutesFromReactChildren } from 'react-router'
	 *
	 *   const routes = createRoutesFromReactChildren(
	 *     <Route component={App}>
	 *       <Route path="home" component={Dashboard}/>
	 *       <Route path="news" component={NewsFeed}/>
	 *     </Route>
	 *   )
	 *
	 * Note: This method is automatically used when you provide <Route> children
	 * to a <Router> component.
	 */
	function createRoutesFromReactChildren(children, parentRoute) {
	  var routes = [];
	
	  _react2.default.Children.forEach(children, function (element) {
	    if (_react2.default.isValidElement(element)) {
	      // Component classes may have a static create* method.
	      if (element.type.createRouteFromReactElement) {
	        var route = element.type.createRouteFromReactElement(element, parentRoute);
	
	        if (route) routes.push(route);
	      } else {
	        routes.push(createRouteFromReactElement(element));
	      }
	    }
	  });
	
	  return routes;
	}
	
	/**
	 * Creates and returns an array of routes from the given object which
	 * may be a JSX route, a plain object route, or an array of either.
	 */
	function createRoutes(routes) {
	  if (isReactChildren(routes)) {
	    routes = createRoutesFromReactChildren(routes);
	  } else if (routes && !Array.isArray(routes)) {
	    routes = [routes];
	  }
	
	  return routes;
	}

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ }),
/* 33 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getCaption = exports.getInitData = exports.getEnrichedObject = exports.getSideBar = exports.getMenuList = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _db = __webpack_require__(350);
	
	var _Menu = __webpack_require__(276);
	
	var _reactackle = __webpack_require__(5);
	
	var _reactResponsive = __webpack_require__(472);
	
	var _reactResponsive2 = _interopRequireDefault(_reactResponsive);
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var oldObj = {
	  deliveryRequest: {
	    caption: "ORDER"
	  },
	  signout: {
	    caption: "SIGN OUT"
	  }
	};
	
	var menuList = Object.keys(oldObj).map(function (key) {
	  return {
	    tableName: key,
	    menuCaption: oldObj[key].caption,
	    tableCaption: oldObj[key].caption
	  };
	});
	
	//console.log("oldObj: " + JSON.stringify(oldObj));
	//console.log("menuList: " + JSON.stringify(menuList));
	
	var getMenuList = exports.getMenuList = function getMenuList(smallerMedia, isAdmin, switchMenuHandler, currUserRole, allMenusFromDb) {
	  var allMenus = {};
	  //console.log("allMenusFromDb: " + JSON.stringify(allMenusFromDb));
	  if (allMenusFromDb && allMenusFromDb !== undefined) {
	    //console.log("got full list of menus");
	
	    allMenus = allMenusFromDb;
	  } else {
	    //console.log("depending on static menu");
	    allMenus = menuList;
	  }
	
	  //console.log(JSON.stringify(allMenus));
	
	  //console.log("All Menu: " + JSON.stringify(allMenus));
	  if (smallerMedia === true) {
	    return allMenus.map(function (item) {
	      if (item && (item.displayToggle === "YES" || item.displayToggle === undefined)) {
	        return _react2.default.createElement("div", {
	          style: {
	            paddingLeft: "5px"
	          }
	        }, _react2.default.createElement("div", {
	          href: "#",
	          onClick: function onClick() {
	            return switchMenuHandler(item.tableName);
	          },
	          style: {
	            marginLeft: "3px",
	            color: "black"
	          }
	        }, _react2.default.createElement("span", {
	          style: {
	            width: "20px"
	          }
	        }, item.menuIcon && item.menuIcon !== "" && _react2.default.createElement("icon", {
	          className: item.menuIcon,
	          style: {
	            border: "1px solid gainsboror",
	            padding: "5px"
	          }
	        })), _react2.default.createElement("span", null, item.menuCaption)), _react2.default.createElement("hr", {
	          style: {
	            margin: "5px"
	          }
	        }));
	      }
	    });
	  } else {
	    return allMenus.map(function (item) {
	      if (item.displayToggle === "YES" || item.displayToggle === undefined) {
	        return _react2.default.createElement(_Menu.MenuGroupItem, {
	          linkHref: "/",
	          text: item.menuCaption,
	          onPress: function onPress() {
	            return switchMenuHandler(item.tableName);
	          }
	        });
	      }
	    });
	  }
	};
	
	var getSideBar = exports.getSideBar = function getSideBar(smallerMedia, isAdmin, switchMenuHandler, currUserRole, allMenusFromDb) {
	  return _react2.default.createElement(_reactResponsive2.default, { minDeviceWidth: 768 }, _react2.default.createElement(_reactackle.Sidebar, {
	    autoCollapsing: true,
	    haveToggleButton: true,
	    toggleButtonText: "Collapse",
	    attachToRight: false,
	    outlined: true,
	    style: { backgroundColor: "white" }
	  }, _react2.default.createElement(_reactackle.SidebarRegion, null, _react2.default.createElement(_Menu.Menu, null, _react2.default.createElement(_reactackle.Content, null, getMenuList(smallerMedia, isAdmin, switchMenuHandler, currUserRole, allMenusFromDb))))));
	};
	
	var getEnrichedObject = exports.getEnrichedObject = function getEnrichedObject(ogObj, searchObj, userProfile) {
	  var newObj = {};
	  for (var key in ogObj) {
	    var word = ogObj[key];
	    // console.log(
	    //   "key: " + key + " value: " + word + " userProfile: " + userProfile[word]
	    // );
	    if (word) {
	      if (searchObj[word] && searchObj[word] !== undefined) {
	        newObj[key] = searchObj[word];
	      } else if (word === "currentDate") {
	        newObj[key] = (0, _moment2.default)().format("DD-MM-YYYY");
	      } else if (word === "currentDateTime") {
	        newObj[key] = (0, _moment2.default)().format("DD-MM-YYYY h:mm a");
	      } else if (userProfile[word] && userProfile[word] !== undefined) {
	        newObj[key] = userProfile[word];
	      } else {
	        newObj[key] = word;
	      }
	    }
	  }
	  //console.log("~~here is newObj: " + JSON.stringify(newObj));
	  return newObj;
	};
	
	var getInitForOgDef = function getInitForOgDef(fields) {
	  var initRec = fields.reduce(function (prevValue, currValue, currIndex, fullArray) {
	    if (prevValue !== 0) {
	      prevValue[currValue.name] = currValue.defaultValue && currValue.defaultValue !== undefined ? currValue.defaultValue : "";
	      return prevValue;
	    } else {
	      prevValue = {};
	      prevValue[currValue.name] = currValue.defaultValue && currValue.defaultValue !== undefined ? currValue.defaultValue : "";
	      return prevValue;
	    }
	  }, 0);
	  //console.log("~~here is initRec: " + JSON.stringify(initRec));
	  return initRec;
	};
	
	var getInitData = exports.getInitData = function getInitData(tableName, createTableList, currentProfile) {
	  var initData = undefined;
	  //console.log("Table name for init: " + tableName);
	
	  //console.log("Init name for init: " + initName);
	  initData = _db.staticDb[tableName];
	  //console.log("~~ Init data is: " + JSON.stringify(initData));
	  if (!initData || initData === undefined) {
	    if (createTableList && createTableList.length > 0) {
	      var currDefs = createTableList.find(function (item) {
	        return item.name === tableName;
	      });
	      //console.log("currDefs: " + JSON.stringify(currDefs));
	      if (currDefs && currDefs["fields"]) {
	        initData = getInitForOgDef(currDefs["fields"]);
	      }
	    }
	  }
	  if (initData && initData !== undefined) {
	    initData = getEnrichedObject(initData, {}, currentProfile);
	  }
	
	  return initData;
	};
	
	var getCaption = exports.getCaption = function getCaption(tableName, listOfTables, isMobile) {
	  if (tableName && tableName !== "" && listOfTables && listOfTables.length > 0) {
	    var tgtMenu = listOfTables.find(function (item) {
	      return item.name === tableName;
	    });
	    if (tgtMenu && tgtMenu !== undefined) {
	      if (isMobile) {
	        // return _.truncate("long text to be truncated", {
	        //   length: 250,
	        //   separator: " "
	        // });
	        if (tgtMenu.caption !== "" && tgtMenu !== null) {
	          if (tableName === "users") {
	            return "WELCOME TO BCS";
	          } else {
	            return tgtMenu.caption.slice(0, 21);
	          }
	        } else {
	          return "";
	        }
	      } else {
	        if (tableName === "users") {
	          return "WELCOME TO BCS";
	        } else {
	          return tgtMenu.caption;
	        }
	      }
	    } else {
	      return "";
	    }
	  } else {
	    return "";
	  }
	};

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	var conversions = __webpack_require__(162);
	var route = __webpack_require__(361);
	
	var convert = {};
	
	var models = Object.keys(conversions);
	
	function wrapRaw(fn) {
		var wrappedFn = function (args) {
			if (args === undefined || args === null) {
				return args;
			}
	
			if (arguments.length > 1) {
				args = Array.prototype.slice.call(arguments);
			}
	
			return fn(args);
		};
	
		// preserve .conversion property if there is one
		if ('conversion' in fn) {
			wrappedFn.conversion = fn.conversion;
		}
	
		return wrappedFn;
	}
	
	function wrapRounded(fn) {
		var wrappedFn = function (args) {
			if (args === undefined || args === null) {
				return args;
			}
	
			if (arguments.length > 1) {
				args = Array.prototype.slice.call(arguments);
			}
	
			var result = fn(args);
	
			// we're assuming the result is an array here.
			// see notice in conversions.js; don't use box types
			// in conversion functions.
			if (typeof result === 'object') {
				for (var len = result.length, i = 0; i < len; i++) {
					result[i] = Math.round(result[i]);
				}
			}
	
			return result;
		};
	
		// preserve .conversion property if there is one
		if ('conversion' in fn) {
			wrappedFn.conversion = fn.conversion;
		}
	
		return wrappedFn;
	}
	
	models.forEach(function (fromModel) {
		convert[fromModel] = {};
	
		Object.defineProperty(convert[fromModel], 'channels', {value: conversions[fromModel].channels});
		Object.defineProperty(convert[fromModel], 'labels', {value: conversions[fromModel].labels});
	
		var routes = route(fromModel);
		var routeModels = Object.keys(routes);
	
		routeModels.forEach(function (toModel) {
			var fn = routes[toModel];
	
			convert[fromModel][toModel] = wrapRounded(fn);
			convert[fromModel][toModel].raw = wrapRaw(fn);
		});
	});
	
	module.exports = convert;


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createMemoryHistory = exports.hashHistory = exports.browserHistory = exports.applyRouterMiddleware = exports.formatPattern = exports.useRouterHistory = exports.match = exports.routerShape = exports.locationShape = exports.RouterContext = exports.createRoutes = exports.Route = exports.Redirect = exports.IndexRoute = exports.IndexRedirect = exports.withRouter = exports.IndexLink = exports.Link = exports.Router = undefined;
	
	var _RouteUtils = __webpack_require__(31);
	
	Object.defineProperty(exports, 'createRoutes', {
	  enumerable: true,
	  get: function get() {
	    return _RouteUtils.createRoutes;
	  }
	});
	
	var _PropTypes = __webpack_require__(127);
	
	Object.defineProperty(exports, 'locationShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes.locationShape;
	  }
	});
	Object.defineProperty(exports, 'routerShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes.routerShape;
	  }
	});
	
	var _PatternUtils = __webpack_require__(46);
	
	Object.defineProperty(exports, 'formatPattern', {
	  enumerable: true,
	  get: function get() {
	    return _PatternUtils.formatPattern;
	  }
	});
	
	var _Router2 = __webpack_require__(477);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _Link2 = __webpack_require__(194);
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	var _IndexLink2 = __webpack_require__(473);
	
	var _IndexLink3 = _interopRequireDefault(_IndexLink2);
	
	var _withRouter2 = __webpack_require__(488);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	var _IndexRedirect2 = __webpack_require__(474);
	
	var _IndexRedirect3 = _interopRequireDefault(_IndexRedirect2);
	
	var _IndexRoute2 = __webpack_require__(475);
	
	var _IndexRoute3 = _interopRequireDefault(_IndexRoute2);
	
	var _Redirect2 = __webpack_require__(196);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(476);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _RouterContext2 = __webpack_require__(128);
	
	var _RouterContext3 = _interopRequireDefault(_RouterContext2);
	
	var _match2 = __webpack_require__(486);
	
	var _match3 = _interopRequireDefault(_match2);
	
	var _useRouterHistory2 = __webpack_require__(201);
	
	var _useRouterHistory3 = _interopRequireDefault(_useRouterHistory2);
	
	var _applyRouterMiddleware2 = __webpack_require__(479);
	
	var _applyRouterMiddleware3 = _interopRequireDefault(_applyRouterMiddleware2);
	
	var _browserHistory2 = __webpack_require__(480);
	
	var _browserHistory3 = _interopRequireDefault(_browserHistory2);
	
	var _hashHistory2 = __webpack_require__(484);
	
	var _hashHistory3 = _interopRequireDefault(_hashHistory2);
	
	var _createMemoryHistory2 = __webpack_require__(198);
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Router = _Router3.default; /* components */
	
	exports.Link = _Link3.default;
	exports.IndexLink = _IndexLink3.default;
	exports.withRouter = _withRouter3.default;
	
	/* components (configuration) */
	
	exports.IndexRedirect = _IndexRedirect3.default;
	exports.IndexRoute = _IndexRoute3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	
	/* utils */
	
	exports.RouterContext = _RouterContext3.default;
	exports.match = _match3.default;
	exports.useRouterHistory = _useRouterHistory3.default;
	exports.applyRouterMiddleware = _applyRouterMiddleware3.default;
	
	/* histories */
	
	exports.browserHistory = _browserHistory3.default;
	exports.hashHistory = _hashHistory3.default;
	exports.createMemoryHistory = _createMemoryHistory3.default;

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactackleCore = __webpack_require__(3);
	
	exports.default = (0, _reactackleCore.withExternalProps)(_reactackleCore.CARD_CHANNEL);

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isArrayish = __webpack_require__(904);
	
	var concat = Array.prototype.concat;
	var slice = Array.prototype.slice;
	
	var swizzle = module.exports = function swizzle(args) {
		var results = [];
	
		for (var i = 0, len = args.length; i < len; i++) {
			var arg = args[i];
	
			if (isArrayish(arg)) {
				// http://jsperf.com/javascript-array-concat-vs-push/98
				results = concat.call(results, slice.call(arg));
			} else {
				results.push(arg);
			}
		}
	
		return results;
	};
	
	swizzle.wrap = function (fn) {
		return function () {
			return fn(swizzle(arguments));
		};
	};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var tslib = __webpack_require__(262);
	var util = __webpack_require__(59);
	var component = __webpack_require__(58);
	var logger$1 = __webpack_require__(102);
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var _a;
	var ERRORS = (_a = {},
	    _a["no-app" /* NO_APP */] = "No Firebase App '{$appName}' has been created - " +
	        'call Firebase App.initializeApp()',
	    _a["bad-app-name" /* BAD_APP_NAME */] = "Illegal App name: '{$appName}",
	    _a["duplicate-app" /* DUPLICATE_APP */] = "Firebase App named '{$appName}' already exists",
	    _a["app-deleted" /* APP_DELETED */] = "Firebase App named '{$appName}' already deleted",
	    _a["invalid-app-argument" /* INVALID_APP_ARGUMENT */] = 'firebase.{$appName}() takes either no argument or a ' +
	        'Firebase App instance.',
	    _a["invalid-log-argument" /* INVALID_LOG_ARGUMENT */] = 'First argument to `onLog` must be null or a function.',
	    _a);
	var ERROR_FACTORY = new util.ErrorFactory('app', 'Firebase', ERRORS);
	
	var name$1 = "@firebase/app";
	var version = "0.6.4";
	
	var name$2 = "@firebase/analytics";
	
	var name$3 = "@firebase/auth";
	
	var name$4 = "@firebase/database";
	
	var name$5 = "@firebase/functions";
	
	var name$6 = "@firebase/installations";
	
	var name$7 = "@firebase/messaging";
	
	var name$8 = "@firebase/performance";
	
	var name$9 = "@firebase/remote-config";
	
	var name$a = "@firebase/storage";
	
	var name$b = "@firebase/firestore";
	
	var name$c = "firebase-wrapper";
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var _a$1;
	var DEFAULT_ENTRY_NAME = '[DEFAULT]';
	var PLATFORM_LOG_STRING = (_a$1 = {},
	    _a$1[name$1] = 'fire-core',
	    _a$1[name$2] = 'fire-analytics',
	    _a$1[name$3] = 'fire-auth',
	    _a$1[name$4] = 'fire-rtdb',
	    _a$1[name$5] = 'fire-fn',
	    _a$1[name$6] = 'fire-iid',
	    _a$1[name$7] = 'fire-fcm',
	    _a$1[name$8] = 'fire-perf',
	    _a$1[name$9] = 'fire-rc',
	    _a$1[name$a] = 'fire-gcs',
	    _a$1[name$b] = 'fire-fst',
	    _a$1['fire-js'] = 'fire-js',
	    _a$1[name$c] = 'fire-js-all',
	    _a$1);
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var logger = new logger$1.Logger('@firebase/app');
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Global context object for a collection of services using
	 * a shared authentication state.
	 */
	var FirebaseAppImpl = /** @class */ (function () {
	    function FirebaseAppImpl(options, config, firebase_) {
	        var e_1, _a;
	        var _this = this;
	        this.firebase_ = firebase_;
	        this.isDeleted_ = false;
	        this.name_ = config.name;
	        this.automaticDataCollectionEnabled_ =
	            config.automaticDataCollectionEnabled || false;
	        this.options_ = util.deepCopy(options);
	        this.container = new component.ComponentContainer(config.name);
	        // add itself to container
	        this._addComponent(new component.Component('app', function () { return _this; }, "PUBLIC" /* PUBLIC */));
	        try {
	            // populate ComponentContainer with existing components
	            for (var _b = tslib.__values(this.firebase_.INTERNAL.components.values()), _c = _b.next(); !_c.done; _c = _b.next()) {
	                var component$1 = _c.value;
	                this._addComponent(component$1);
	            }
	        }
	        catch (e_1_1) { e_1 = { error: e_1_1 }; }
	        finally {
	            try {
	                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	            }
	            finally { if (e_1) throw e_1.error; }
	        }
	    }
	    Object.defineProperty(FirebaseAppImpl.prototype, "automaticDataCollectionEnabled", {
	        get: function () {
	            this.checkDestroyed_();
	            return this.automaticDataCollectionEnabled_;
	        },
	        set: function (val) {
	            this.checkDestroyed_();
	            this.automaticDataCollectionEnabled_ = val;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FirebaseAppImpl.prototype, "name", {
	        get: function () {
	            this.checkDestroyed_();
	            return this.name_;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FirebaseAppImpl.prototype, "options", {
	        get: function () {
	            this.checkDestroyed_();
	            return this.options_;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    FirebaseAppImpl.prototype.delete = function () {
	        var _this = this;
	        return new Promise(function (resolve) {
	            _this.checkDestroyed_();
	            resolve();
	        })
	            .then(function () {
	            _this.firebase_.INTERNAL.removeApp(_this.name_);
	            return Promise.all(_this.container.getProviders().map(function (provider) { return provider.delete(); }));
	        })
	            .then(function () {
	            _this.isDeleted_ = true;
	        });
	    };
	    /**
	     * Return a service instance associated with this app (creating it
	     * on demand), identified by the passed instanceIdentifier.
	     *
	     * NOTE: Currently storage and functions are the only ones that are leveraging this
	     * functionality. They invoke it by calling:
	     *
	     * ```javascript
	     * firebase.app().storage('STORAGE BUCKET ID')
	     * ```
	     *
	     * The service name is passed to this already
	     * @internal
	     */
	    FirebaseAppImpl.prototype._getService = function (name, instanceIdentifier) {
	        if (instanceIdentifier === void 0) { instanceIdentifier = DEFAULT_ENTRY_NAME; }
	        this.checkDestroyed_();
	        // getImmediate will always succeed because _getService is only called for registered components.
	        return this.container.getProvider(name).getImmediate({
	            identifier: instanceIdentifier
	        });
	    };
	    /**
	     * Remove a service instance from the cache, so we will create a new instance for this service
	     * when people try to get this service again.
	     *
	     * NOTE: currently only firestore is using this functionality to support firestore shutdown.
	     *
	     * @param name The service name
	     * @param instanceIdentifier instance identifier in case multiple instances are allowed
	     * @internal
	     */
	    FirebaseAppImpl.prototype._removeServiceInstance = function (name, instanceIdentifier) {
	        if (instanceIdentifier === void 0) { instanceIdentifier = DEFAULT_ENTRY_NAME; }
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        this.container.getProvider(name).clearInstance(instanceIdentifier);
	    };
	    /**
	     * @param component the component being added to this app's container
	     */
	    FirebaseAppImpl.prototype._addComponent = function (component) {
	        try {
	            this.container.addComponent(component);
	        }
	        catch (e) {
	            logger.debug("Component " + component.name + " failed to register with FirebaseApp " + this.name, e);
	        }
	    };
	    FirebaseAppImpl.prototype._addOrOverwriteComponent = function (component) {
	        this.container.addOrOverwriteComponent(component);
	    };
	    /**
	     * This function will throw an Error if the App has already been deleted -
	     * use before performing API actions on the App.
	     */
	    FirebaseAppImpl.prototype.checkDestroyed_ = function () {
	        if (this.isDeleted_) {
	            throw ERROR_FACTORY.create("app-deleted" /* APP_DELETED */, { appName: this.name_ });
	        }
	    };
	    return FirebaseAppImpl;
	}());
	// Prevent dead-code elimination of these methods w/o invalid property
	// copying.
	(FirebaseAppImpl.prototype.name && FirebaseAppImpl.prototype.options) ||
	    FirebaseAppImpl.prototype.delete ||
	    console.log('dc');
	
	var version$1 = "7.14.5";
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Because auth can't share code with other components, we attach the utility functions
	 * in an internal namespace to share code.
	 * This function return a firebase namespace object without
	 * any utility functions, so it can be shared between the regular firebaseNamespace and
	 * the lite version.
	 */
	function createFirebaseNamespaceCore(firebaseAppImpl) {
	    var apps = {};
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    var components = new Map();
	    // A namespace is a plain JavaScript Object.
	    var namespace = {
	        // Hack to prevent Babel from modifying the object returned
	        // as the firebase namespace.
	        // @ts-ignore
	        __esModule: true,
	        initializeApp: initializeApp,
	        // @ts-ignore
	        app: app,
	        registerVersion: registerVersion,
	        setLogLevel: logger$1.setLogLevel,
	        onLog: onLog,
	        // @ts-ignore
	        apps: null,
	        SDK_VERSION: version$1,
	        INTERNAL: {
	            registerComponent: registerComponent,
	            removeApp: removeApp,
	            components: components,
	            useAsService: useAsService
	        }
	    };
	    // Inject a circular default export to allow Babel users who were previously
	    // using:
	    //
	    //   import firebase from 'firebase';
	    //   which becomes: var firebase = require('firebase').default;
	    //
	    // instead of
	    //
	    //   import * as firebase from 'firebase';
	    //   which becomes: var firebase = require('firebase');
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    namespace['default'] = namespace;
	    // firebase.apps is a read-only getter.
	    Object.defineProperty(namespace, 'apps', {
	        get: getApps
	    });
	    /**
	     * Called by App.delete() - but before any services associated with the App
	     * are deleted.
	     */
	    function removeApp(name) {
	        delete apps[name];
	    }
	    /**
	     * Get the App object for a given name (or DEFAULT).
	     */
	    function app(name) {
	        name = name || DEFAULT_ENTRY_NAME;
	        if (!util.contains(apps, name)) {
	            throw ERROR_FACTORY.create("no-app" /* NO_APP */, { appName: name });
	        }
	        return apps[name];
	    }
	    // @ts-ignore
	    app['App'] = firebaseAppImpl;
	    function initializeApp(options, rawConfig) {
	        if (rawConfig === void 0) { rawConfig = {}; }
	        if (typeof rawConfig !== 'object' || rawConfig === null) {
	            var name_1 = rawConfig;
	            rawConfig = { name: name_1 };
	        }
	        var config = rawConfig;
	        if (config.name === undefined) {
	            config.name = DEFAULT_ENTRY_NAME;
	        }
	        var name = config.name;
	        if (typeof name !== 'string' || !name) {
	            throw ERROR_FACTORY.create("bad-app-name" /* BAD_APP_NAME */, {
	                appName: String(name)
	            });
	        }
	        if (util.contains(apps, name)) {
	            throw ERROR_FACTORY.create("duplicate-app" /* DUPLICATE_APP */, { appName: name });
	        }
	        var app = new firebaseAppImpl(options, config, namespace);
	        apps[name] = app;
	        return app;
	    }
	    /*
	     * Return an array of all the non-deleted FirebaseApps.
	     */
	    function getApps() {
	        // Make a copy so caller cannot mutate the apps list.
	        return Object.keys(apps).map(function (name) { return apps[name]; });
	    }
	    function registerComponent(component) {
	        var e_1, _a;
	        var componentName = component.name;
	        if (components.has(componentName)) {
	            logger.debug("There were multiple attempts to register component " + componentName + ".");
	            return component.type === "PUBLIC" /* PUBLIC */
	                ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
	                    namespace[componentName]
	                : null;
	        }
	        components.set(componentName, component);
	        // create service namespace for public components
	        if (component.type === "PUBLIC" /* PUBLIC */) {
	            // The Service namespace is an accessor function ...
	            var serviceNamespace = function (appArg) {
	                if (appArg === void 0) { appArg = app(); }
	                // eslint-disable-next-line @typescript-eslint/no-explicit-any
	                if (typeof appArg[componentName] !== 'function') {
	                    // Invalid argument.
	                    // This happens in the following case: firebase.storage('gs:/')
	                    throw ERROR_FACTORY.create("invalid-app-argument" /* INVALID_APP_ARGUMENT */, {
	                        appName: componentName
	                    });
	                }
	                // Forward service instance lookup to the FirebaseApp.
	                // eslint-disable-next-line @typescript-eslint/no-explicit-any
	                return appArg[componentName]();
	            };
	            // ... and a container for service-level properties.
	            if (component.serviceProps !== undefined) {
	                util.deepExtend(serviceNamespace, component.serviceProps);
	            }
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	            namespace[componentName] = serviceNamespace;
	            // Patch the FirebaseAppImpl prototype
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	            firebaseAppImpl.prototype[componentName] =
	                // TODO: The eslint disable can be removed and the 'ignoreRestArgs'
	                // option added to the no-explicit-any rule when ESlint releases it.
	                // eslint-disable-next-line @typescript-eslint/no-explicit-any
	                function () {
	                    var args = [];
	                    for (var _i = 0; _i < arguments.length; _i++) {
	                        args[_i] = arguments[_i];
	                    }
	                    var serviceFxn = this._getService.bind(this, componentName);
	                    return serviceFxn.apply(this, component.multipleInstances ? args : []);
	                };
	        }
	        try {
	            // add the component to existing app instances
	            for (var _b = tslib.__values(Object.keys(apps)), _c = _b.next(); !_c.done; _c = _b.next()) {
	                var appName = _c.value;
	                apps[appName]._addComponent(component);
	            }
	        }
	        catch (e_1_1) { e_1 = { error: e_1_1 }; }
	        finally {
	            try {
	                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	            }
	            finally { if (e_1) throw e_1.error; }
	        }
	        return component.type === "PUBLIC" /* PUBLIC */
	            ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
	                namespace[componentName]
	            : null;
	    }
	    function registerVersion(libraryKeyOrName, version, variant) {
	        var _a;
	        // TODO: We can use this check to whitelist strings when/if we set up
	        // a good whitelist system.
	        var library = (_a = PLATFORM_LOG_STRING[libraryKeyOrName]) !== null && _a !== void 0 ? _a : libraryKeyOrName;
	        if (variant) {
	            library += "-" + variant;
	        }
	        var libraryMismatch = library.match(/\s|\//);
	        var versionMismatch = version.match(/\s|\//);
	        if (libraryMismatch || versionMismatch) {
	            var warning = [
	                "Unable to register library \"" + library + "\" with version \"" + version + "\":"
	            ];
	            if (libraryMismatch) {
	                warning.push("library name \"" + library + "\" contains illegal characters (whitespace or \"/\")");
	            }
	            if (libraryMismatch && versionMismatch) {
	                warning.push('and');
	            }
	            if (versionMismatch) {
	                warning.push("version name \"" + version + "\" contains illegal characters (whitespace or \"/\")");
	            }
	            logger.warn(warning.join(' '));
	            return;
	        }
	        registerComponent(new component.Component(library + "-version", function () { return ({ library: library, version: version }); }, "VERSION" /* VERSION */));
	    }
	    function onLog(logCallback, options) {
	        if (logCallback !== null && typeof logCallback !== 'function') {
	            throw ERROR_FACTORY.create("invalid-log-argument" /* INVALID_LOG_ARGUMENT */, {
	                appName: name
	            });
	        }
	        logger$1.setUserLogHandler(logCallback, options);
	    }
	    // Map the requested service to a registered service name
	    // (used to map auth to serverAuth service when needed).
	    function useAsService(app, name) {
	        if (name === 'serverAuth') {
	            return null;
	        }
	        var useService = name;
	        return useService;
	    }
	    return namespace;
	}
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Return a firebase namespace object.
	 *
	 * In production, this will be called exactly once and the result
	 * assigned to the 'firebase' global.  It may be called multiple times
	 * in unit tests.
	 */
	function createFirebaseNamespace() {
	    var namespace = createFirebaseNamespaceCore(FirebaseAppImpl);
	    namespace.INTERNAL = tslib.__assign(tslib.__assign({}, namespace.INTERNAL), { createFirebaseNamespace: createFirebaseNamespace,
	        extendNamespace: extendNamespace,
	        createSubscribe: util.createSubscribe,
	        ErrorFactory: util.ErrorFactory,
	        deepExtend: util.deepExtend });
	    /**
	     * Patch the top-level firebase namespace with additional properties.
	     *
	     * firebase.INTERNAL.extendNamespace()
	     */
	    function extendNamespace(props) {
	        util.deepExtend(namespace, props);
	    }
	    return namespace;
	}
	var firebase = createFirebaseNamespace();
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var PlatformLoggerService = /** @class */ (function () {
	    function PlatformLoggerService(container) {
	        this.container = container;
	    }
	    // In initial implementation, this will be called by installations on
	    // auth token refresh, and installations will send this string.
	    PlatformLoggerService.prototype.getPlatformInfoString = function () {
	        var providers = this.container.getProviders();
	        // Loop through providers and get library/version pairs from any that are
	        // version components.
	        return providers
	            .map(function (provider) {
	            if (isVersionServiceProvider(provider)) {
	                var service = provider.getImmediate();
	                return service.library + "/" + service.version;
	            }
	            else {
	                return null;
	            }
	        })
	            .filter(function (logString) { return logString; })
	            .join(' ');
	    };
	    return PlatformLoggerService;
	}());
	/**
	 *
	 * @param provider check if this provider provides a VersionService
	 *
	 * NOTE: Using Provider<'app-version'> is a hack to indicate that the provider
	 * provides VersionService. The provider is not necessarily a 'app-version'
	 * provider.
	 */
	function isVersionServiceProvider(provider) {
	    var component = provider.getComponent();
	    return (component === null || component === void 0 ? void 0 : component.type) === "VERSION" /* VERSION */;
	}
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function registerCoreComponents(firebase, variant) {
	    firebase.INTERNAL.registerComponent(new component.Component('platform-logger', function (container) { return new PlatformLoggerService(container); }, "PRIVATE" /* PRIVATE */));
	    // Register `app` package.
	    firebase.registerVersion(name$1, version, variant);
	    // Register platform SDK identifier (no version).
	    firebase.registerVersion('fire-js', '');
	}
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	// Firebase Lite detection test
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	if (util.isBrowser() && self.firebase !== undefined) {
	    logger.warn("\n    Warning: Firebase is already defined in the global scope. Please make sure\n    Firebase library is only loaded once.\n  ");
	    // eslint-disable-next-line
	    var sdkVersion = self.firebase.SDK_VERSION;
	    if (sdkVersion && sdkVersion.indexOf('LITE') >= 0) {
	        logger.warn("\n    Warning: You are trying to load Firebase while using Firebase Performance standalone script.\n    You should load Firebase Performance with this instance of Firebase to avoid loading duplicate code.\n    ");
	    }
	}
	var initializeApp = firebase.initializeApp;
	// TODO: This disable can be removed and the 'ignoreRestArgs' option added to
	// the no-explicit-any rule when ESlint releases it.
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	firebase.initializeApp = function () {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    // Environment check before initializing app
	    // Do the check in initializeApp, so people have a chance to disable it by setting logLevel
	    // in @firebase/logger
	    if (util.isNode()) {
	        logger.warn("\n      Warning: This is a browser-targeted Firebase bundle but it appears it is being\n      run in a Node environment.  If running in a Node environment, make sure you\n      are using the bundle specified by the \"main\" field in package.json.\n      \n      If you are using Webpack, you can specify \"main\" as the first item in\n      \"resolve.mainFields\":\n      https://webpack.js.org/configuration/resolve/#resolvemainfields\n      \n      If using Rollup, use the rollup-plugin-node-resolve plugin and specify \"main\"\n      as the first item in \"mainFields\", e.g. ['main', 'module'].\n      https://github.com/rollup/rollup-plugin-node-resolve\n      ");
	    }
	    return initializeApp.apply(undefined, args);
	};
	var firebase$1 = firebase;
	registerCoreComponents(firebase$1);
	
	exports.default = firebase$1;
	exports.firebase = firebase$1;
	//# sourceMappingURL=index.cjs.js.map


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DateDropdown = __webpack_require__(105);
	
	var _DateDropdown2 = _interopRequireDefault(_DateDropdown);
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	//import "./filterStyles.css";
	
	var customStyles = {
	  control: function control(provided, state) {
	    return _extends({}, provided, {
	      width: "100%",
	      borderWidth: "1px",
	      borderRadius: "5px"
	    });
	  },
	  menu: function menu(base) {
	    return _extends({}, base, {
	      zIndex: 100
	    });
	  }
	};
	
	var GridDateFilters = function (_Component) {
	  _inherits(GridDateFilters, _Component);
	
	  function GridDateFilters() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, GridDateFilters);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = GridDateFilters.__proto__ || Object.getPrototypeOf(GridDateFilters)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      tgtFieldName: ""
	    }, _this.getValue = function (fieldName) {
	      var value = _this.props.value[fieldName];
	      if (!value || value === undefined || value === "") {
	        value = (0, _moment2.default)().format("DD-MM-YYYY");
	      }
	      return value;
	    }, _this.handleChange = function (newValue, key, isPayload) {
	      var fieldList = _this.props.ogTableDef[_this.props.path];
	      var tgtFieldName = "";
	      var tgtFieldFormat = "";
	      var dateFieldKey = "";
	      var applyDateFilters = false;
	      Object.keys(fieldList).map(function (key) {
	        var fieldDefs = fieldList[key];
	
	        if (fieldDefs && _this.props.filtersList.includes(key) && fieldDefs.type === "calendar") {
	          dateFieldKey = key;
	          tgtFieldName = key;
	          tgtFieldFormat = fieldDefs.dateFormatOut;
	        }
	        applyDateFilters = true;
	      });
	
	      var newFilterVal = _extends({}, _this.props.value);
	      if (newValue && newValue !== undefined) {
	        newFilterVal[key] = newValue;
	        newFilterVal["tgtDateField"] = tgtFieldName;
	        newFilterVal["tgtDateFormat"] = tgtFieldFormat;
	        _this.props.stateHandler(newFilterVal, "searchDateFilters", false);
	      }
	    }, _this.getFiterFields = function () {
	      var fieldList = _this.props.ogTableDef[_this.props.path];
	      //console.log("path is: " + this.props.path);
	      //console.log("field list " + JSON.stringify(fieldList));
	      if (fieldList && fieldList !== undefined) {
	        var tgtFieldName = "";
	        var tgtFieldFormat = "";
	        var dateFieldKey = "";
	        var applyDateFilters = false;
	        Object.keys(fieldList).map(function (key) {
	          var fieldDefs = fieldList[key];
	          if (fieldDefs && _this.props.filtersList.includes(key) && fieldDefs.type === "calendar") {
	            dateFieldKey = key;
	            tgtFieldName = key;
	            tgtFieldFormat = fieldDefs.dateFormatOut;
	            applyDateFilters = true;
	          }
	        });
	        if (applyDateFilters) {
	          return _react2.default.createElement("tr", null, _react2.default.createElement("td", {
	            style: {
	              borderColor: "black",
	              borderStyle: "solid",
	              borderWidth: "0px",
	              padding: "0px"
	            }
	          }, _react2.default.createElement(_DateDropdown2.default, {
	            title: "FROM",
	            maxDetail: "hour",
	            format: "dd-MM-yyyy",
	            formatOut: "DD-MM-YYYY",
	            onChange: _this.handleChange,
	            fieldName: "FromDate",
	            value: _this.getValue("FromDate")
	          })), _react2.default.createElement("td", {
	            style: {
	              borderColor: "black",
	              borderStyle: "solid",
	              borderWidth: "0px",
	              padding: "0px"
	            }
	          }, _react2.default.createElement(_DateDropdown2.default, {
	            title: "TO",
	            maxDetail: "hour",
	            format: "dd-MM-yyyy",
	            formatOut: "DD-MM-YYYY",
	            onChange: _this.handleChange,
	            fieldName: "ToDate",
	            value: _this.getValue("ToDate")
	          })));
	        }
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(GridDateFilters, [{
	    key: "render",
	    value: function render() {
	      var _ref2;
	
	      return _react2.default.createElement("div", null, _react2.default.createElement("table", {
	        style: (_ref2 = {
	          width: "100%",
	          padding: "0px",
	          margin: "0px"
	        }, _defineProperty(_ref2, "padding", "0px"), _defineProperty(_ref2, "tableLayout", "fixed"), _defineProperty(_ref2, "marginTop", "2px"), _ref2),
	        className: "table table-sm"
	      }, _react2.default.createElement("tbody", null, this.getFiterFields())));
	    }
	  }]);
	
	  return GridDateFilters;
	}(_react.Component);
	
	exports.default = GridDateFilters;

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(92);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _reactDeviceDetect = __webpack_require__(6);
	
	var _reactRedux = __webpack_require__(9);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var customStyles = {
	  control: function control(provided, state) {
	    return _extends({}, provided, {
	      width: "100%",
	      borderWidth: "1px",
	      borderRadius: "5px",
	      margin: "2px"
	    });
	  },
	  menu: function menu(base) {
	    return _extends({}, base, {
	      zIndex: 100
	    });
	  }
	};
	
	var GridFilters = function (_Component) {
	  _inherits(GridFilters, _Component);
	
	  function GridFilters() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, GridFilters);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = GridFilters.__proto__ || Object.getPrototypeOf(GridFilters)).call.apply(_ref, [this].concat(args))), _this), _this.getOptions = function (data, fieldName, key) {
	      var newArray = [];
	      if (!data && data === undefined) {
	        //console.log("Data is undefined for SelectDropdown");
	        return [];
	      }
	
	      //console.log("No of drop down records: " + data.length);
	      for (var i = 0; i < data.length; i++) {
	        var item = data[i];
	        //console.log(JSON.stringify(this.props.filter));
	
	        newArray.push({
	          value: item[fieldName],
	          label: item[fieldName],
	          key: key
	        });
	      }
	      return newArray;
	    }, _this.getValue = function (fieldName) {
	      // console.log(
	      //   "Setting this value: " +
	      //     JSON.stringify({
	      //       value: this.props.value[fieldName],
	      //       label: this.props.value[fieldName]
	      //     })
	      // );
	      return {
	        value: _this.props.value[fieldName],
	        label: _this.props.value[fieldName]
	      };
	    }, _this.handleChange = function (newValue, actionMeta, key) {
	      var newFilterVal = _extends({}, _this.props.value);
	      if (actionMeta && actionMeta.action === "clear") {
	        delete newFilterVal[key];
	        _this.props.stateHandler(newFilterVal, "searchFilters", false);
	      } else {
	        if (newValue && newValue !== undefined) {
	          newFilterVal[key] = newValue.value;
	          _this.props.stateHandler(newFilterVal, "searchFilters", false);
	        }
	      }
	    }, _this.getFiterFields = function () {
	      //console.log(JSON.stringify(this.props.ogTableDef[this.props.path]));
	      var fieldList = _this.props.ogTableDef[_this.props.path];
	      if (fieldList && fieldList !== undefined) {
	        return Object.keys(fieldList).map(function (key) {
	          var fieldDefs = fieldList[key];
	
	          if (fieldDefs && fieldDefs.selectorSource && fieldDefs.selectorSource.type === "static" && fieldDefs.caption !== "SALUTATION" && _this.props.filtersList.includes(key)) {
	            var sourceData = fieldDefs.selectorSource.staticSource;
	            //console.log(JSON.stringify(sourceData));
	            var fieldName = fieldDefs.selectorSource.tableField;
	
	            return _react2.default.createElement(_reactSelect2.default, {
	              isClearable: true,
	              onChange: function onChange(newVal, metaData) {
	                return _this.handleChange(newVal, metaData, key);
	              },
	              options: _this.getOptions(sourceData, fieldName, key),
	              label: fieldDefs.caption,
	              placeholder: "SELECT " + fieldDefs.caption,
	              value: _this.getValue(key),
	              styles: customStyles,
	              defaultValue: "SELECT " + fieldDefs.caption,
	              fullwidth: true,
	              theme: function theme(_theme) {
	                return _extends({}, _theme, {
	                  borderRadius: 5,
	                  colors: _extends({}, _theme.colors, {
	                    primary: "blue"
	                  }),
	                  borderWidth: "1px",
	                  borderColor: "blue"
	                });
	              }
	            });
	          } else if (fieldDefs && fieldDefs.selectorSource && fieldDefs.selectorSource.type === "table" && fieldDefs.caption !== "SALUTATION" && _this.props.filtersList.includes(key)) {
	            var _sourceData = fieldDefs.selectorSource.table;
	            //console.log(JSON.stringify(sourceData));
	            var _fieldName = fieldDefs.selectorSource.tableField;
	
	            return _react2.default.createElement(_reactSelect2.default, {
	              isClearable: true,
	              onChange: function onChange(newVal, metaData) {
	                return _this.handleChange(newVal, metaData, key);
	              },
	              options: _this.getOptions(_this.props[_sourceData], _fieldName, key),
	              label: fieldDefs.caption,
	              placeholder: "SELECT " + fieldDefs.caption,
	              value: _this.getValue(key),
	              styles: customStyles,
	              defaultValue: "SELECT " + fieldDefs.caption,
	              fullwidth: true,
	              theme: function theme(_theme2) {
	                return _extends({}, _theme2, {
	                  borderRadius: 5,
	                  colors: _extends({}, _theme2.colors, {
	                    primary: "blue"
	                  }),
	                  borderWidth: "1px",
	                  borderColor: "blue"
	                });
	              }
	            });
	          }
	        });
	      }
	    }, _this.getMobileStyle = function () {
	      if (_reactDeviceDetect.isMobile) {
	        return {
	          display: "block"
	        };
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(GridFilters, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement("div", null, this.getFiterFields());
	    }
	  }]);
	
	  return GridFilters;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    userProfile: state.db.userProfile,
	    users: state.db.users,
	    projects: state.db.projects,
	    attendance: state.db.attendance,
	    contacts: state.db.contacts,
	    logistics: state.db.logistics,
	    notices: state.db.notices,
	    projectInvoices: state.db.projectInvoices,
	    projectClaims: state.db.projectClaims,
	    projectDos: state.db.projectDos,
	    projectPos: state.db.projectPos,
	    projectQuotes: state.db.projectQuotes,
	    reports: state.db.reports,
	    suppliers: state.db.suppliers,
	    tasks: state.db.tasks,
	    currentUser: state.db.userProfile
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(GridFilters);

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.searchRecords = exports.searchAttendance = exports.searchProjects = undefined;
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var searchProjects = exports.searchProjects = function searchProjects(allProjects, val) {
	  var newProjList = [];
	  var filterVal = val.toLowerCase();
	  //console.log('filter val is: '+filterVal)
	  var searchResult = false;
	  newProjList = allProjects.filter(function (proj) {
	    if (proj.projectAddress && proj.projectAddress !== undefined) {
	      //console.log("Here is address: "+proj.projectAddress+" " +(proj.projectAddress.toLowerCase().includes(filterVal)))
	      searchResult = proj.projectAddress.toLowerCase().includes(filterVal);
	      //console.log(searchResult+ " filterVal: " +filterVal+" actual: "+ proj.projectAddress+" projAddress itemCount in newProjList " + newProjList.length)
	      //console.log(searchResult+ " filterVal: " +filterVal+" actual: "+ proj.projectAddress+" projAddress items in newProjList " + JSON.stringify(newProjList))
	      if (searchResult) {
	        return searchResult;
	      }
	    }
	
	    if (proj.projectPhase && proj.projectPhase !== undefined) {
	      //console.log("Here is phase: "+proj.projectPhase+" " +(proj.projectPhase.toLowerCase().includes(filterVal)))
	      searchResult = proj.projectPhase.toLowerCase().includes(filterVal);
	      //console.log(searchResult + " filter val is: " +filterVal+" actual: "+ proj.projectPhase+" projPhase itemCount in newProjList " + newProjList.length)
	      //console.log(searchResult+ " filter val is: " +filterVal+" actual: "+ proj.projectPhase+"projPhase items in newProjList " + JSON.stringify(newProjList))
	      if (searchResult) {
	        return searchResult;
	      }
	    }
	
	    if (proj.projectName && proj.projectName !== undefined) {
	      //console.log("Here is name: "+proj.projectName+" " +(proj.projectName.toLowerCase().includes(filterVal)))
	      searchResult = proj.projectName.toLowerCase().includes(filterVal);
	      //console.log(searchResult + " filterVal: " +filterVal+" actual: "+ proj.projectName+" projName itemCount in newProjList " + newProjList.length)
	      //console.log(searchResult + " filterVal: " +filterVal+" actual: "+ proj.projectName+" projName items in newProjList " + JSON.stringify(newProjList))
	      if (searchResult) {
	        return searchResult;
	      }
	    }
	
	    return false;
	  });
	
	  return newProjList;
	};
	
	var searchAttendance = exports.searchAttendance = function searchAttendance(allAttendance, val) {
	  var newAttList = [];
	  var filterVal = val.toLowerCase();
	  //console.log('filter val is: '+filterVal)
	  var searchResult = false;
	  newAttList = allAttendance.filter(function (att) {
	    if (att.employeeName && att.employeeName !== undefined) {
	      //console.log("Here is name: "+att.employeeName+" " +(att.employeeName.toLowerCase().includes(filterVal)))
	      searchResult = att.employeeName.toLowerCase().includes(filterVal);
	      //console.log(searchResult+ " filterVal: " +filterVal+" actual: "+ att.employeeName+" projAddress itemCount in newProjList " + newAttList.length)
	      //console.log(searchResult+ " filterVal: " +filterVal+" actual: "+ proj.projectAddress+" projAddress items in newProjList " + JSON.stringify(newProjList))
	      if (searchResult) {
	        return searchResult;
	      }
	    }
	
	    if (att.startDateTime && att.startDateTime !== undefined) {
	      var date1 = (0, _moment2.default)(att.startDateTime, "DD-MM-YYYY h:mm a").format();
	      var dateVal = (0, _moment2.default)(date1).format("DD-MMM-YYYY(dddd)");
	      //console.log("Here is date: "+dateVal+" " +(dateVal.toLowerCase().includes(filterVal)))
	      searchResult = dateVal.toLowerCase().includes(filterVal);
	      //console.log(searchResult+ " filterVal: " +filterVal+" actual: "+ att.employeeName+" projAddress itemCount in newProjList " + newAttList.length)
	      //console.log(searchResult+ " filterVal: " +filterVal+" actual: "+ proj.projectAddress+" projAddress items in newProjList " + JSON.stringify(newProjList))
	      if (searchResult) {
	        return searchResult;
	      }
	    }
	
	    if (att.attStatus && att.attStatus !== undefined) {
	      //console.log("Here is date: "+dateVal+" " +(dateVal.toLowerCase().includes(filterVal)))
	      searchResult = att.attStatus.toLowerCase().includes(filterVal);
	      //console.log(searchResult+ " filterVal: " +filterVal+" actual: "+ att.employeeName+" projAddress itemCount in newProjList " + newAttList.length)
	      //console.log(searchResult+ " filterVal: " +filterVal+" actual: "+ proj.projectAddress+" projAddress items in newProjList " + JSON.stringify(newProjList))
	      if (searchResult) {
	        return searchResult;
	      }
	    }
	
	    if (att.projectName && att.projectName !== undefined) {
	      //console.log("Here is date: "+dateVal+" " +(dateVal.toLowerCase().includes(filterVal)))
	      searchResult = att.projectName.toLowerCase().includes(filterVal);
	      //console.log(searchResult+ " filterVal: " +filterVal+" actual: "+ att.employeeName+" projAddress itemCount in newProjList " + newAttList.length)
	      //console.log(searchResult+ " filterVal: " +filterVal+" actual: "+ proj.projectAddress+" projAddress items in newProjList " + JSON.stringify(newProjList))
	      if (searchResult) {
	        return searchResult;
	      }
	    }
	
	    if (att.attendanceWorkType && att.attendanceWorkType !== undefined) {
	      //console.log("Here is date: "+dateVal+" " +(dateVal.toLowerCase().includes(filterVal)))
	      searchResult = att.attendanceWorkType.toLowerCase().includes(filterVal);
	      //console.log(searchResult+ " filterVal: " +filterVal+" actual: "+ att.employeeName+" projAddress itemCount in newProjList " + newAttList.length)
	      //console.log(searchResult+ " filterVal: " +filterVal+" actual: "+ proj.projectAddress+" projAddress items in newProjList " + JSON.stringify(newProjList))
	      if (searchResult) {
	        return searchResult;
	      }
	    }
	
	    return false;
	  });
	
	  return newAttList;
	};
	
	var applyDateFilters = function applyDateFilters(allRecords, searchDateFilters) {
	  //console.log("Applying Date Filters: " + JSON.stringify(searchDateFilters));
	  var newList = [];
	
	  if (!searchDateFilters || searchDateFilters === undefined || !allRecords || allRecords.length < 1) {
	    return allRecords;
	  }
	
	  var fromDateStr = searchDateFilters.FromDate;
	  var toDateStr = searchDateFilters.ToDate;
	  var momFromDate = (0, _moment2.default)();
	  var momToDate = (0, _moment2.default)();
	
	  if (fromDateStr !== undefined) {
	    momFromDate = (0, _moment2.default)(fromDateStr, "DD-MM-YYYY");
	  }
	  if (toDateStr !== undefined) {
	    momToDate = (0, _moment2.default)(toDateStr, "DD-MM-YYYY");
	    if (searchDateFilters.tgtDateFormat === "DD-MM-YYYY h:mm a") {
	      //console.log("added a day");
	      momToDate = momToDate.add(1, "day");
	    } else {
	      //console.log("no added days: " + searchDateFilters.tgtDateFormat);
	    }
	  }
	
	  // console.log(
	  //   " fromSelection:" +
	  //     momFromDate.toString() +
	  //     " toSelection:" +
	  //     momToDate.toString()
	  // );
	
	  if (!fromDateStr && fromDateStr === undefined && !toDateStr && toDateStr === undefined) {
	    return allRecords;
	  } else {
	    // console.log(
	    //   "tgtFieldIs: " +
	    //     searchDateFilters.tgtDateField +
	    //     " " +
	    //     JSON.stringify(searchDateFilters)
	    // );
	    newList = allRecords.filter(function (rec) {
	      //console.log("this is record: " + JSON.stringify(rec));
	      var tgtDateStr = rec[searchDateFilters.tgtDateField];
	      var momTgtDate = (0, _moment2.default)(tgtDateStr, searchDateFilters.tgtDateFormat);
	
	      var result = true;
	
	      if (fromDateStr && fromDateStr !== undefined) {
	        if (momTgtDate.isBefore(momFromDate)) {
	          result = false;
	        }
	      }
	      if (toDateStr && toDateStr !== undefined) {
	        if (momTgtDate.isAfter(momToDate)) {
	          result = false;
	        }
	      }
	
	      // console.log(
	      //   searchDateFilters.tgtDateField +
	      //     " tgt: " +
	      //     tgtDateStr +
	      //     " fromSelection:" +
	      //     fromDateStr +
	      //     " toSelection:" +
	      //     toDateStr +
	      //     " result:" +
	      //     result
	      // );
	
	      return result;
	    });
	    return newList;
	  }
	};
	
	var applyFilters = function applyFilters(allRecords, searchFilters, searchDateFilters) {
	  //console.log("Applying Filters");
	  var newDatedList = applyDateFilters(allRecords, searchDateFilters);
	  var newFileteredList = [];
	
	  if (!searchFilters || searchFilters === undefined || !allRecords || allRecords.length < 1) {
	    return newDatedList;
	  }
	
	  var filterKeys = Object.keys(searchFilters);
	
	  if (!filterKeys || filterKeys === undefined || filterKeys.length < 1) {
	    return newDatedList;
	  } else {
	    newFileteredList = newDatedList.filter(function (rec) {
	      var result = true;
	      for (var i = 0; i < filterKeys.length; i++) {
	        var str1 = rec[filterKeys[i]];
	        var str2 = searchFilters[filterKeys[i]];
	        if (str1 && str1 !== "" && str2 && str2 !== "") {
	          if (str1.trim() !== str2.trim()) {
	            result = false;
	          }
	        } else {
	          result = false;
	        }
	      }
	      return result;
	    });
	    return newFileteredList;
	  }
	};
	
	var searchRecords = exports.searchRecords = function searchRecords(allSourceRecords, val, fieldsList, searchFilters, searchDateFilters, cellPhone) {
	  // console.log(
	  //   allSourceRecords.length +
	  //     " " +
	  //     val +
	  //     " " +
	  //     JSON.stringify(fieldsList) +
	  //     " " +
	  //     cellPhone
	  // );
	  if (!allSourceRecords || allSourceRecords === undefined || allSourceRecords.length < 1) {
	    return [];
	  }
	  var newList = [];
	  var allRecords = applyFilters(allSourceRecords, searchFilters, searchDateFilters);
	  if (allRecords && allRecords !== undefined && fieldsList !== undefined) {
	    var filterVal = val.toLowerCase();
	    // if (filterVal === "525") {
	    //   console.log("1212: filter val is: " + filterVal);
	    // }
	    var searchResult = false;
	    newList = allRecords.filter(function (rec) {
	      //console.log("filter: " + JSON.stringify(rec));
	      if (cellPhone && cellPhone !== undefined) {
	        //console.log("checking mobile number");
	        if (rec["mobile"] && rec["mobile"] !== undefined) {
	          if (rec["mobile"] !== cellPhone && rec["mobile"] !== "+65" + cellPhone) {
	            return false;
	          }
	        }
	      }
	      //console.log("passed through: " + fieldsList.length);
	      for (var i = 0; i < fieldsList.length; i++) {
	        if (rec[fieldsList[i]] && rec[fieldsList[i]] !== undefined && rec[fieldsList[i]] !== "") {
	          //console.log("checking field val: ");
	          var recVal = rec[fieldsList[i]];
	          // if (filterVal === "nur") {
	          //   console.log("1212: field is : " + fieldsList[i]);
	          //   console.log(
	          //     "1212: value is : " + rec[fieldsList[i]] + typeof recVal
	          //   );
	          // }
	          if (recVal && recVal !== undefined && (typeof recVal === "string" || typeof recVal === "number")) {
	            if (typeof recVal === "number") {
	              recVal = recVal.toString();
	            }
	            searchResult = recVal.toLowerCase().includes(filterVal);
	            // if (filterVal === "nur") {
	            //   console.log(
	            //     "Here is the recVal: " + recVal + " and result: " + searchResult
	            //   );
	            // }
	            if (searchResult) {
	              return searchResult;
	            }
	          } else {}
	        }
	      }
	
	      if (rec.messages && rec.messages !== undefined && rec.messages.length > 0) {
	        for (var _i = 0; _i < rec.messages.length; _i++) {
	          var _recVal = rec.messages[_i].msgText;
	          var msgRes = _recVal.toLowerCase().includes(filterVal);
	          if (msgRes) {
	            return msgRes;
	          }
	        }
	      }
	
	      return false;
	    });
	    return newList.slice(0, 1000);
	  } else {
	    return allRecords.slice(0, 1000);
	  }
	};

/***/ }),
/* 43 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var getDefs = function getDefs(createTableList) {
	  //console.log("~~~ " + JSON.stringify(createTableList));
	  var tableDef = {
	    users: {
	      userName: {
	        caption: "NAME",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	      userEmail: {
	        caption: "EMAIL",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	      userEmployeeId: {
	        caption: "EMPLOYEE ID",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	      roleName: {
	        caption: "ROLE NAME",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	      userDesignation: {
	        caption: "DESIGNITION",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	      userNotes: {
	        caption: "NOTES",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	      searches: ["userName", "roleName", "userDesignation", "userNotes"]
	    },
	    contacts: {
	      contactCompany: {
	        caption: "COMPANY NAME",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	      contactTrade: {
	        caption: "TRADE (CATEGORY)",
	        inputValidator: "",
	        type: "input",
	        enabled: true,
	        selectorSource: {}
	      },
	      contactEmail: {
	        caption: "EMAIL",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	      contactPhone: {
	        caption: "PHONE",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	      contactMailingAddress: {
	        caption: "MAILING ADDRESS",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	      contactName: {
	        caption: "CONTACT NAME",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	      contactFax: {
	        caption: "FAX",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	      contactNotes: {
	        caption: "NOTES",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	      searches: ["contactCompany", "contactEmail", "contactMailingAddress", "contactName", "contactNotes", "contactPhone", "contactTrade"]
	    },
	    suppliers: {
	      supplierCompany: {
	        caption: "COMPANY NAME",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	      supplierTrade: {
	        caption: "TRADE (CATEGORY)",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: "",
	        type: "input",
	        enabled: true
	      },
	      supplierName: {
	        caption: "CONTACT PERSON",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	      supplierEmail: {
	        caption: "EMAIL",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	      supplierFax: {
	        caption: "FAX",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	      supplierMailingAddress: {
	        caption: "MAILING ADDRESS",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	
	      supplierPhone: {
	        caption: "PHONE",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	      searches: ["supplierCompany", "supplierEmail", "supplierMailingAddress", "supplierMailingAddress", "supplierName", "supplierTrade"]
	    },
	    notices: {
	      noticeTitle: {
	        caption: "SUBJECT",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	      noticeDetails: {
	        caption: "NOTICE DETAILS",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	
	      updateDateTime: {
	        caption: "UPDATED AT",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	      searches: ["noticeTitle", "noticeDetails"]
	    },
	    projectInvoices: {
	      invoiceId: {
	        caption: "ID",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	      totalInvoice: {
	        caption: "TOTAL",
	        format: "numeral",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	      invoiceStatus: {
	        caption: "STATUS",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	      clientPo: {
	        caption: "CLIENT PO",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	      invoiceDate: {
	        caption: "ISSUE DATE",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	      projectName: {
	        caption: "PROJECT",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	      companyName: {
	        caption: "COMPANY",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	      contactName: {
	        caption: "CONTACT",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	      contactPhone: {
	        caption: "PHONE",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	      email: {
	        caption: "EMAIL",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	      searches: ["invoiceId", "projectName", "contactName", "totalInvoice", "companyName", "invoiceDate"]
	    },
	    deletedprojectInvoices: {
	      invoiceId: {
	        caption: "ID",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	      totalInvoice: {
	        caption: "TOTAL",
	        format: "numeral",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	      invoiceStatus: {
	        caption: "STATUS",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	      clientPo: {
	        caption: "CLIENT PO",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	      invoiceDate: {
	        caption: "ISSUE DATE",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	      projectName: {
	        caption: "PROJECT",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	      companyName: {
	        caption: "COMPANY",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	      contactName: {
	        caption: "CONTACT",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	      contactPhone: {
	        caption: "PHONE",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	      email: {
	        caption: "EMAIL",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	      searches: ["invoiceId", "projectName", "contactName", "totalInvoice", "companyName", "invoiceDate"]
	    },
	    projectClaims: {
	      claimId: {
	        caption: "ID",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	      accSubConSum: {
	        caption: "ACC SUBCON SUM",
	        format: "numeral",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	      claimDate: {
	        caption: "CLAIM DATE",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	
	      claimStatus: {
	        caption: "STATUS",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	      companyName: {
	        caption: "COMPANY",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	      contactName: {
	        caption: "CONTACT",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	      contactPhone: {
	        caption: "PHONE",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	      discountPercent: {
	        caption: "DISC PERCENT",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	      email: {
	        caption: "EMAIL",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	      projectName: {
	        caption: "PROJECT",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	      quoteId: {
	        caption: "QUOTE ID",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	      retentionPercent: {
	        caption: "RETENTION PERCENT",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	      totPmtRcvd: {
	        caption: "TOT PMT RCVD",
	        format: "numeral",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	      searches: ["claimId", "companyName", "projectName", "contactName"]
	    },
	    projectDos: {
	      doId: {
	        caption: "DO ID",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	      doDate: {
	        caption: "DO DATE",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	      companyName: {
	        caption: "COMPANY",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	      contactName: {
	        caption: "CONTACT NAME",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	      contactPhone: {
	        caption: "CONTACT PHONE",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	      email: {
	        caption: "EMAIL",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	      projectName: {
	        caption: "PROJECT",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	      searches: ["doId", "companyName", "contactName", "projectName"]
	    },
	    projectPos: {
	      poId: {
	        caption: "ID",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	      poDate: {
	        caption: "DATE",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	      poAmount: {
	        caption: "AMOUNT",
	        format: "numeral",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	      companyName: {
	        caption: "SUPPLIER",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	      contactName: {
	        caption: "CONTACT NAME",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	      contactPhone: {
	        caption: "PHONE",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	      projectName: {
	        caption: "PROJECT",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	      searches: ["projectName", "poId", "companyName", "contactName", "poAmount"]
	    },
	    projectQuotes: {
	      quoteId: {
	        caption: "QUOTE ID",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	      quoteDate: {
	        caption: "QUOTE DATE",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	      companyName: {
	        caption: "COMPANY",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	      contactName: {
	        caption: "CONTACT NAME",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	      contactPhone: {
	        caption: "CONTACT PHONE",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	      projectName: {
	        caption: "PROJECT",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	      quoteType: {
	        caption: "TYPE",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	      totalAmount: {
	        caption: "TOTAL AMOUNT",
	        format: "numeral",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	
	      searches: ["quoteId", "companyName", "contactName", "projectName", "quoteType"]
	    },
	    reports: {
	      reportName: {
	        caption: "REPORTNAME",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	      categ: {
	        caption: "CATEG",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	      selectedCategory: {
	        caption: "CATEGORY",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	      selectedGroupBy: {
	        caption: "GROUP BY",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      }
	    },
	    designReports: {
	      reportName: {
	        caption: "REPORTNAME",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	      categ: {
	        caption: "CATEG",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	      selectedCategory: {
	        caption: "CATEGORY",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	      selectedGroupBy: {
	        caption: "GROUP BY",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      }
	    },
	    logistics: {
	      logisticsName: {
	        caption: "NAME",
	        selectorSource: {
	          type: "table",
	          table: "users",
	          tableField: "userName",
	          otherFieldsToUpdate: []
	        },
	        inputValidator: "",
	        type: "search",
	        enabled: true
	      },
	      logisticsDetails: {
	        caption: "DETAILS",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	      logisticsDateTime: {
	        caption: "DATE & TIME",
	        dateFormat: "dd-MM-yyyy h:mm a",
	        dateFormatOut: "DD-MM-YYYY h:mm a",
	        selectorSource: {
	          type: "dateBetween",
	          table: ""
	        },
	        inputValidator: "",
	        type: "calendar",
	        enabled: true
	      },
	      searches: ["logisticsName", "logisticsDetails"]
	    },
	    createFields: {
	      name: {
	        caption: "NAME",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	      searches: ["name"]
	    },
	    createTable: {
	      name: {
	        caption: "TABLE NAME",
	        selectorSource: {
	          type: "",
	          table: ""
	        },
	        inputValidator: ""
	      },
	      searches: ["name"]
	    },
	    listOfTables: {
	      name: {
	        caption: "TABLE NAME",
	        inputValidator: "",
	        type: "input",
	        enabled: true,
	        selectorSource: {
	          staticSource: []
	        }
	      },
	      caption: {
	        caption: "TABLE CAPTION",
	        inputValidator: "",
	        type: "input",
	        enabled: true,
	        selectorSource: {
	          staticSource: []
	        }
	      },
	      menu: {
	        caption: "MENU CAPTION",
	        inputValidator: "",
	        type: "input",
	        enabled: true,
	        selectorSource: {
	          staticSource: []
	        }
	      },
	      searches: ["name", "caption", "menu"]
	    },
	    menuDesigner: {
	      name: {
	        caption: "MENU NAME",
	        inputValidator: "",
	        type: "input",
	        enabled: true,
	        selectorSource: {
	          staticSource: []
	        }
	      },
	      searches: ["name"]
	    }
	  };
	
	  if (createTableList && createTableList.length > 0) {
	    var _loop = function _loop(i) {
	      var dashColDefs = {};
	      var dashColumns = createTableList[i]["dashColumns"];
	      if (dashColumns && dashColumns !== undefined && dashColumns.length > 0) {
	        var _loop2 = function _loop2(j) {
	          dashColDefs[dashColumns[j]] = createTableList[i].fields.find(function (item) {
	            return item.name === dashColumns[j];
	          });
	        };
	
	        for (var j = 0; j < dashColumns.length; j++) {
	          _loop2(j);
	        }
	        tableDef[createTableList[i].name] = dashColDefs;
	
	        dashColDefs["searches"] = createTableList[i]["searchColumns"];
	      }
	    };
	
	    for (var i = 0; i < createTableList.length; i++) {
	      _loop(i);
	    }
	  }
	
	  //console.log("~~~ " + JSON.stringify(tableDef));
	  return tableDef;
	};
	
	exports.default = getDefs;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationsAreEqual = exports.statesAreEqual = exports.createLocation = exports.createQuery = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(14);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _warning = __webpack_require__(32);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _PathUtils = __webpack_require__(28);
	
	var _Actions = __webpack_require__(83);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createQuery = exports.createQuery = function createQuery(props) {
	  return _extends(Object.create(null), props);
	};
	
	var createLocation = exports.createLocation = function createLocation() {
	  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _Actions.POP;
	  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	  var object = typeof input === 'string' ? (0, _PathUtils.parsePath)(input) : input;
	
	   false ? (0, _warning2.default)(!object.path, 'Location descriptor objects should have a `pathname`, not a `path`.') : void 0;
	
	  var pathname = object.pathname || '/';
	  var search = object.search || '';
	  var hash = object.hash || '';
	  var state = object.state;
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash,
	    state: state,
	    action: action,
	    key: key
	  };
	};
	
	var isDate = function isDate(object) {
	  return Object.prototype.toString.call(object) === '[object Date]';
	};
	
	var statesAreEqual = exports.statesAreEqual = function statesAreEqual(a, b) {
	  if (a === b) return true;
	
	  var typeofA = typeof a === 'undefined' ? 'undefined' : _typeof(a);
	  var typeofB = typeof b === 'undefined' ? 'undefined' : _typeof(b);
	
	  if (typeofA !== typeofB) return false;
	
	  !(typeofA !== 'function') ?  false ? (0, _invariant2.default)(false, 'You must not store functions in location state') : (0, _invariant2.default)(false) : void 0;
	
	  // Not the same object, but same type.
	  if (typeofA === 'object') {
	    !!(isDate(a) && isDate(b)) ?  false ? (0, _invariant2.default)(false, 'You must not store Date objects in location state') : (0, _invariant2.default)(false) : void 0;
	
	    if (!Array.isArray(a)) {
	      var keysofA = Object.keys(a);
	      var keysofB = Object.keys(b);
	      return keysofA.length === keysofB.length && keysofA.every(function (key) {
	        return statesAreEqual(a[key], b[key]);
	      });
	    }
	
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return statesAreEqual(item, b[index]);
	    });
	  }
	
	  // All other serializable types (string, number, boolean)
	  // should be strict equal.
	  return false;
	};
	
	var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
	  return a.key === b.key &&
	  // a.action === b.action && // Different action !== location change.
	  a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && statesAreEqual(a.state, b.state);
	};

/***/ }),
/* 45 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compilePattern = compilePattern;
	exports.matchPattern = matchPattern;
	exports.getParamNames = getParamNames;
	exports.getParams = getParams;
	exports.formatPattern = formatPattern;
	
	var _invariant = __webpack_require__(14);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function escapeRegExp(string) {
	  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	}
	
	function _compilePattern(pattern) {
	  var regexpSource = '';
	  var paramNames = [];
	  var tokens = [];
	
	  var match = void 0,
	      lastIndex = 0,
	      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)|\\\(|\\\)/g;
	  while (match = matcher.exec(pattern)) {
	    if (match.index !== lastIndex) {
	      tokens.push(pattern.slice(lastIndex, match.index));
	      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
	    }
	
	    if (match[1]) {
	      regexpSource += '([^/]+)';
	      paramNames.push(match[1]);
	    } else if (match[0] === '**') {
	      regexpSource += '(.*)';
	      paramNames.push('splat');
	    } else if (match[0] === '*') {
	      regexpSource += '(.*?)';
	      paramNames.push('splat');
	    } else if (match[0] === '(') {
	      regexpSource += '(?:';
	    } else if (match[0] === ')') {
	      regexpSource += ')?';
	    } else if (match[0] === '\\(') {
	      regexpSource += '\\(';
	    } else if (match[0] === '\\)') {
	      regexpSource += '\\)';
	    }
	
	    tokens.push(match[0]);
	
	    lastIndex = matcher.lastIndex;
	  }
	
	  if (lastIndex !== pattern.length) {
	    tokens.push(pattern.slice(lastIndex, pattern.length));
	    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
	  }
	
	  return {
	    pattern: pattern,
	    regexpSource: regexpSource,
	    paramNames: paramNames,
	    tokens: tokens
	  };
	}
	
	var CompiledPatternsCache = Object.create(null);
	
	function compilePattern(pattern) {
	  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);
	
	  return CompiledPatternsCache[pattern];
	}
	
	/**
	 * Attempts to match a pattern on the given pathname. Patterns may use
	 * the following special characters:
	 *
	 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
	 *                  captured string is considered a "param"
	 * - ()             Wraps a segment of the URL that is optional
	 * - *              Consumes (non-greedy) all characters up to the next
	 *                  character in the pattern, or to the end of the URL if
	 *                  there is none
	 * - **             Consumes (greedy) all characters up to the next character
	 *                  in the pattern, or to the end of the URL if there is none
	 *
	 *  The function calls callback(error, matched) when finished.
	 * The return value is an object with the following properties:
	 *
	 * - remainingPathname
	 * - paramNames
	 * - paramValues
	 */
	function matchPattern(pattern, pathname) {
	  // Ensure pattern starts with leading slash for consistency with pathname.
	  if (pattern.charAt(0) !== '/') {
	    pattern = '/' + pattern;
	  }
	
	  var _compilePattern2 = compilePattern(pattern),
	      regexpSource = _compilePattern2.regexpSource,
	      paramNames = _compilePattern2.paramNames,
	      tokens = _compilePattern2.tokens;
	
	  if (pattern.charAt(pattern.length - 1) !== '/') {
	    regexpSource += '/?'; // Allow optional path separator at end.
	  }
	
	  // Special-case patterns like '*' for catch-all routes.
	  if (tokens[tokens.length - 1] === '*') {
	    regexpSource += '$';
	  }
	
	  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
	  if (match == null) {
	    return null;
	  }
	
	  var matchedPath = match[0];
	  var remainingPathname = pathname.substr(matchedPath.length);
	
	  if (remainingPathname) {
	    // Require that the match ends at a path separator, if we didn't match
	    // the full path, so any remaining pathname is a new path segment.
	    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
	      return null;
	    }
	
	    // If there is a remaining pathname, treat the path separator as part of
	    // the remaining pathname for properly continuing the match.
	    remainingPathname = '/' + remainingPathname;
	  }
	
	  return {
	    remainingPathname: remainingPathname,
	    paramNames: paramNames,
	    paramValues: match.slice(1).map(function (v) {
	      return v && decodeURIComponent(v);
	    })
	  };
	}
	
	function getParamNames(pattern) {
	  return compilePattern(pattern).paramNames;
	}
	
	function getParams(pattern, pathname) {
	  var match = matchPattern(pattern, pathname);
	  if (!match) {
	    return null;
	  }
	
	  var paramNames = match.paramNames,
	      paramValues = match.paramValues;
	
	  var params = {};
	
	  paramNames.forEach(function (paramName, index) {
	    params[paramName] = paramValues[index];
	  });
	
	  return params;
	}
	
	/**
	 * Returns a version of the given pattern with params interpolated. Throws
	 * if there is a dynamic segment of the pattern for which there is no param.
	 */
	function formatPattern(pattern, params) {
	  params = params || {};
	
	  var _compilePattern3 = compilePattern(pattern),
	      tokens = _compilePattern3.tokens;
	
	  var parenCount = 0,
	      pathname = '',
	      splatIndex = 0,
	      parenHistory = [];
	
	  var token = void 0,
	      paramName = void 0,
	      paramValue = void 0;
	  for (var i = 0, len = tokens.length; i < len; ++i) {
	    token = tokens[i];
	
	    if (token === '*' || token === '**') {
	      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue != null) pathname += encodeURI(paramValue);
	    } else if (token === '(') {
	      parenHistory[parenCount] = '';
	      parenCount += 1;
	    } else if (token === ')') {
	      var parenText = parenHistory.pop();
	      parenCount -= 1;
	
	      if (parenCount) parenHistory[parenCount - 1] += parenText;else pathname += parenText;
	    } else if (token === '\\(') {
	      pathname += '(';
	    } else if (token === '\\)') {
	      pathname += ')';
	    } else if (token.charAt(0) === ':') {
	      paramName = token.substring(1);
	      paramValue = params[paramName];
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue == null) {
	        if (parenCount) {
	          parenHistory[parenCount - 1] = '';
	
	          var curTokenIdx = tokens.indexOf(token);
	          var tokensSubset = tokens.slice(curTokenIdx, tokens.length);
	          var nextParenIdx = -1;
	
	          for (var _i = 0; _i < tokensSubset.length; _i++) {
	            if (tokensSubset[_i] == ')') {
	              nextParenIdx = _i;
	              break;
	            }
	          }
	
	          !(nextParenIdx > 0) ?  false ? (0, _invariant2.default)(false, 'Path "%s" is missing end paren at segment "%s"', pattern, tokensSubset.join('')) : (0, _invariant2.default)(false) : void 0;
	
	          // jump to ending paren
	          i = curTokenIdx + nextParenIdx - 1;
	        }
	      } else if (parenCount) parenHistory[parenCount - 1] += encodeURIComponent(paramValue);else pathname += encodeURIComponent(paramValue);
	    } else {
	      if (parenCount) parenHistory[parenCount - 1] += token;else pathname += token;
	    }
	  }
	
	  !(parenCount <= 0) ?  false ? (0, _invariant2.default)(false, 'Path "%s" is missing end paren', pattern) : (0, _invariant2.default)(false) : void 0;
	
	  return pathname.replace(/\/+/g, '/');
	}

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = routerWarning;
	exports._resetWarned = _resetWarned;
	
	var _warning = __webpack_require__(32);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warned = {};
	
	function routerWarning(falseToWarn, message) {
	  // Only issue deprecation warnings once.
	  if (message.indexOf('deprecated') !== -1) {
	    if (warned[message]) {
	      return;
	    }
	
	    warned[message] = true;
	  }
	
	  message = '[react-router] ' + message;
	
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  _warning2.default.apply(undefined, [falseToWarn, message].concat(args));
	}
	
	function _resetWarned() {
	  warned = {};
	}

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getHoursMinutes = getHoursMinutes;
	exports.getHoursMinutesSeconds = getHoursMinutesSeconds;
	exports.convert12to24 = convert12to24;
	exports.convert24to12 = convert24to12;
	Object.defineProperty(exports, "getHours", {
	  enumerable: true,
	  get: function get() {
	    return _dates.getHours;
	  }
	});
	Object.defineProperty(exports, "getMinutes", {
	  enumerable: true,
	  get: function get() {
	    return _dates.getMinutes;
	  }
	});
	Object.defineProperty(exports, "getSeconds", {
	  enumerable: true,
	  get: function get() {
	    return _dates.getSeconds;
	  }
	});
	
	var _dates = __webpack_require__(120);
	
	function getHoursMinutes(date) {
	  if (!date) {
	    return date;
	  }
	
	  var hours = "0".concat((0, _dates.getHours)(date)).slice(-2);
	  var minutes = "0".concat((0, _dates.getMinutes)(date)).slice(-2);
	  return "".concat(hours, ":").concat(minutes);
	}
	
	function getHoursMinutesSeconds(date) {
	  if (!date) {
	    return date;
	  }
	
	  var hours = "0".concat((0, _dates.getHours)(date)).slice(-2);
	  var minutes = "0".concat((0, _dates.getMinutes)(date)).slice(-2);
	  var seconds = "0".concat((0, _dates.getSeconds)(date)).slice(-2);
	  return "".concat(hours, ":").concat(minutes, ":").concat(seconds);
	}
	
	function convert12to24(hour12, amPm) {
	  var hour24 = parseInt(hour12, 10);
	
	  if (amPm === 'am' && hour24 === 12) {
	    hour24 = 0;
	  } else if (amPm === 'pm' && hour24 < 12) {
	    hour24 += 12;
	  }
	
	  return hour24;
	}
	
	function convert24to12(hour24) {
	  var hour12 = hour24 % 12 || 12;
	  return [hour12, hour24 < 12 ? 'am' : 'pm'];
	}

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isValueType = exports.isTime = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	var allViews = ['hour', 'minute', 'second'];
	var allValueTypes = [].concat(allViews);
	var hourOptionalSecondsRegExp = /^(([0-1])?[0-9]|2[0-3]):[0-5][0-9](:([0-5][0-9]))?$/;
	
	var isTime = function isTime(props, propName, componentName) {
	  var time = props[propName];
	
	  if (time) {
	    if (!hourOptionalSecondsRegExp.test(time)) {
	      return new Error("Invalid prop `".concat(propName, "` of type `").concat(typeof minDate === "undefined" ? "undefined" : _typeof(minDate), "` supplied to `").concat(componentName, "`, expected time in HH:mm(:ss) format."));
	    }
	  } // Everything is fine
	
	
	  return null;
	};
	
	exports.isTime = isTime;
	
	var isValueType = _propTypes["default"].oneOf(allValueTypes);
	
	exports.isValueType = isValueType;

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.callIfDefined = exports.getAmPmLabels = exports.max = exports.min = void 0;
	
	var _dateFormatter = __webpack_require__(499);
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }
	
	function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	var isValidNumber = function isValidNumber(a) {
	  return typeof a === 'number' && !isNaN(a);
	};
	
	var min = function min() {
	  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  return Math.min.apply(Math, _toConsumableArray(args.filter(isValidNumber)));
	};
	
	exports.min = min;
	
	var max = function max() {
	  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    args[_key2] = arguments[_key2];
	  }
	
	  return Math.max.apply(Math, _toConsumableArray(args.filter(isValidNumber)));
	};
	
	exports.max = max;
	var nines = ['9', '٩'];
	var ninesRegExp = new RegExp("[".concat(nines.join(''), "]"));
	var amPmFormatter = (0, _dateFormatter.getFormatter)({
	  hour: 'numeric'
	});
	
	var getAmPmLabels = function getAmPmLabels(locale) {
	  var amString = amPmFormatter(locale, new Date(2017, 0, 1, 9));
	  var pmString = amPmFormatter(locale, new Date(2017, 0, 1, 21));
	
	  var _amString$split = amString.split(ninesRegExp),
	      _amString$split2 = _slicedToArray(_amString$split, 2),
	      am1 = _amString$split2[0],
	      am2 = _amString$split2[1];
	
	  var _pmString$split = pmString.split(ninesRegExp),
	      _pmString$split2 = _slicedToArray(_pmString$split, 2),
	      pm1 = _pmString$split2[0],
	      pm2 = _pmString$split2[1];
	
	  if (pm2 !== undefined) {
	    // If pm2 is undefined, nine was not found in pmString - this locale is not using 12-hour time
	    if (am1 !== pm1) {
	      return [am1, pm1].map(function (el) {
	        return el.trim();
	      });
	    }
	
	    if (am2 !== pm2) {
	      return [am2, pm2].map(function (el) {
	        return el.trim();
	      });
	    }
	  } // Fallback
	
	
	  return ['AM', 'PM'];
	};
	/**
	 * Calls a function, if it's defined, with specified arguments
	 * @param {Function} fn
	 * @param {Object} args
	 */
	
	
	exports.getAmPmLabels = getAmPmLabels;
	
	var callIfDefined = function callIfDefined(fn) {
	  if (fn && typeof fn === 'function') {
	    for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
	      args[_key3 - 1] = arguments[_key3];
	    }
	
	    fn.apply(void 0, args);
	  }
	};
	
	exports.callIfDefined = callIfDefined;

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.externalDefaultProps = exports.externalPropTypes = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var externalPropTypes = exports.externalPropTypes = {
	  externalProps: _propTypes2.default.shape({
	    size: _propTypes2.default.oneOf(['default', 'medium', 'large', 'xlarge'])
	  })
	};
	
	var externalDefaultProps = exports.externalDefaultProps = {
	  externalProps: {
	    size: 'default'
	  }
	};

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TooltipIcon = undefined;
	
	var _TooltipIcon = __webpack_require__(877);
	
	var _TooltipIcon2 = _interopRequireDefault(_TooltipIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.TooltipIcon = _TooltipIcon2.default;

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(376);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(20)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!./landingPage.css", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!./landingPage.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 54 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/* eslint-disable no-undefined,no-param-reassign,no-shadow */
	
	/**
	 * Throttle execution of a function. Especially useful for rate limiting
	 * execution of handlers on events like resize and scroll.
	 *
	 * @param  {Number}    delay          A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
	 * @param  {Boolean}   [noTrailing]   Optional, defaults to false. If noTrailing is true, callback will only execute every `delay` milliseconds while the
	 *                                    throttled-function is being called. If noTrailing is false or unspecified, callback will be executed one final time
	 *                                    after the last throttled-function call. (After the throttled-function has not been called for `delay` milliseconds,
	 *                                    the internal counter is reset)
	 * @param  {Function}  callback       A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
	 *                                    to `callback` when the throttled-function is executed.
	 * @param  {Boolean}   [debounceMode] If `debounceMode` is true (at begin), schedule `clear` to execute after `delay` ms. If `debounceMode` is false (at end),
	 *                                    schedule `callback` to execute after `delay` ms.
	 *
	 * @return {Function}  A new, throttled, function.
	 */
	function throttle (delay, noTrailing, callback, debounceMode) {
	  /*
	   * After wrapper has stopped being called, this timeout ensures that
	   * `callback` is executed at the proper times in `throttle` and `end`
	   * debounce modes.
	   */
	  var timeoutID;
	  var cancelled = false; // Keep track of the last time `callback` was executed.
	
	  var lastExec = 0; // Function to clear existing timeout
	
	  function clearExistingTimeout() {
	    if (timeoutID) {
	      clearTimeout(timeoutID);
	    }
	  } // Function to cancel next exec
	
	
	  function cancel() {
	    clearExistingTimeout();
	    cancelled = true;
	  } // `noTrailing` defaults to falsy.
	
	
	  if (typeof noTrailing !== 'boolean') {
	    debounceMode = callback;
	    callback = noTrailing;
	    noTrailing = undefined;
	  }
	  /*
	   * The `wrapper` function encapsulates all of the throttling / debouncing
	   * functionality and when executed will limit the rate at which `callback`
	   * is executed.
	   */
	
	
	  function wrapper() {
	    var self = this;
	    var elapsed = Date.now() - lastExec;
	    var args = arguments;
	
	    if (cancelled) {
	      return;
	    } // Execute `callback` and update the `lastExec` timestamp.
	
	
	    function exec() {
	      lastExec = Date.now();
	      callback.apply(self, args);
	    }
	    /*
	     * If `debounceMode` is true (at begin) this is used to clear the flag
	     * to allow future `callback` executions.
	     */
	
	
	    function clear() {
	      timeoutID = undefined;
	    }
	
	    if (debounceMode && !timeoutID) {
	      /*
	       * Since `wrapper` is being called for the first time and
	       * `debounceMode` is true (at begin), execute `callback`.
	       */
	      exec();
	    }
	
	    clearExistingTimeout();
	
	    if (debounceMode === undefined && elapsed > delay) {
	      /*
	       * In throttle mode, if `delay` time has been exceeded, execute
	       * `callback`.
	       */
	      exec();
	    } else if (noTrailing !== true) {
	      /*
	       * In trailing throttle mode, since `delay` time has not been
	       * exceeded, schedule `callback` to execute `delay` ms after most
	       * recent execution.
	       *
	       * If `debounceMode` is true (at begin), schedule `clear` to execute
	       * after `delay` ms.
	       *
	       * If `debounceMode` is false (at end), schedule `callback` to
	       * execute after `delay` ms.
	       */
	      timeoutID = setTimeout(debounceMode ? clear : exec, debounceMode === undefined ? delay - elapsed : delay);
	    }
	  }
	
	  wrapper.cancel = cancel; // Return the wrapper function.
	
	  return wrapper;
	}
	
	/* eslint-disable no-undefined */
	/**
	 * Debounce execution of a function. Debouncing, unlike throttling,
	 * guarantees that a function is only executed a single time, either at the
	 * very beginning of a series of calls, or at the very end.
	 *
	 * @param  {Number}   delay         A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
	 * @param  {Boolean}  [atBegin]     Optional, defaults to false. If atBegin is false or unspecified, callback will only be executed `delay` milliseconds
	 *                                  after the last debounced-function call. If atBegin is true, callback will be executed only at the first debounced-function call.
	 *                                  (After the throttled-function has not been called for `delay` milliseconds, the internal counter is reset).
	 * @param  {Function} callback      A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
	 *                                  to `callback` when the debounced-function is executed.
	 *
	 * @return {Function} A new, debounced function.
	 */
	
	function debounce (delay, atBegin, callback) {
	  return callback === undefined ? throttle(delay, atBegin, false) : throttle(delay, callback, atBegin !== false);
	}
	
	exports.throttle = throttle;
	exports.debounce = debounce;


/***/ }),
/* 55 */
/***/ (function(module, exports) {

	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return self;
	}
	
	module.exports = _assertThisInitialized;

/***/ }),
/* 56 */
/***/ (function(module, exports) {

	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	}
	
	module.exports = _defineProperty;

/***/ }),
/* 57 */
/***/ (function(module, exports) {

	function _extends() {
	  module.exports = _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  return _extends.apply(this, arguments);
	}
	
	module.exports = _extends;

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var tslib = __webpack_require__(264);
	var util = __webpack_require__(59);
	
	/**
	 * Component for service name T, e.g. `auth`, `auth-internal`
	 */
	var Component = /** @class */ (function () {
	    /**
	     *
	     * @param name The public service name, e.g. app, auth, firestore, database
	     * @param instanceFactory Service factory responsible for creating the public interface
	     * @param type whether the service provided by the component is public or private
	     */
	    function Component(name, instanceFactory, type) {
	        this.name = name;
	        this.instanceFactory = instanceFactory;
	        this.type = type;
	        this.multipleInstances = false;
	        /**
	         * Properties to be added to the service namespace
	         */
	        this.serviceProps = {};
	        this.instantiationMode = "LAZY" /* LAZY */;
	    }
	    Component.prototype.setInstantiationMode = function (mode) {
	        this.instantiationMode = mode;
	        return this;
	    };
	    Component.prototype.setMultipleInstances = function (multipleInstances) {
	        this.multipleInstances = multipleInstances;
	        return this;
	    };
	    Component.prototype.setServiceProps = function (props) {
	        this.serviceProps = props;
	        return this;
	    };
	    return Component;
	}());
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var DEFAULT_ENTRY_NAME = '[DEFAULT]';
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Provider for instance for service name T, e.g. 'auth', 'auth-internal'
	 * NameServiceMapping[T] is an alias for the type of the instance
	 */
	var Provider = /** @class */ (function () {
	    function Provider(name, container) {
	        this.name = name;
	        this.container = container;
	        this.component = null;
	        this.instances = new Map();
	        this.instancesDeferred = new Map();
	    }
	    /**
	     * @param identifier A provider can provide mulitple instances of a service
	     * if this.component.multipleInstances is true.
	     */
	    Provider.prototype.get = function (identifier) {
	        if (identifier === void 0) { identifier = DEFAULT_ENTRY_NAME; }
	        // if multipleInstances is not supported, use the default name
	        var normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
	        if (!this.instancesDeferred.has(normalizedIdentifier)) {
	            var deferred = new util.Deferred();
	            this.instancesDeferred.set(normalizedIdentifier, deferred);
	            // If the service instance is available, resolve the promise with it immediately
	            try {
	                var instance = this.getOrInitializeService(normalizedIdentifier);
	                if (instance) {
	                    deferred.resolve(instance);
	                }
	            }
	            catch (e) {
	                // when the instance factory throws an exception during get(), it should not cause
	                // a fatal error. We just return the unresolved promise in this case.
	            }
	        }
	        return this.instancesDeferred.get(normalizedIdentifier).promise;
	    };
	    Provider.prototype.getImmediate = function (options) {
	        var _a = tslib.__assign({ identifier: DEFAULT_ENTRY_NAME, optional: false }, options), identifier = _a.identifier, optional = _a.optional;
	        // if multipleInstances is not supported, use the default name
	        var normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
	        try {
	            var instance = this.getOrInitializeService(normalizedIdentifier);
	            if (!instance) {
	                if (optional) {
	                    return null;
	                }
	                throw Error("Service " + this.name + " is not available");
	            }
	            return instance;
	        }
	        catch (e) {
	            if (optional) {
	                return null;
	            }
	            else {
	                throw e;
	            }
	        }
	    };
	    Provider.prototype.getComponent = function () {
	        return this.component;
	    };
	    Provider.prototype.setComponent = function (component) {
	        var e_1, _a;
	        if (component.name !== this.name) {
	            throw Error("Mismatching Component " + component.name + " for Provider " + this.name + ".");
	        }
	        if (this.component) {
	            throw Error("Component for " + this.name + " has already been provided");
	        }
	        this.component = component;
	        // if the service is eager, initialize the default instance
	        if (isComponentEager(component)) {
	            try {
	                this.getOrInitializeService(DEFAULT_ENTRY_NAME);
	            }
	            catch (e) {
	                // when the instance factory for an eager Component throws an exception during the eager
	                // initialization, it should not cause a fatal error.
	                // TODO: Investigate if we need to make it configurable, because some component may want to cause
	                // a fatal error in this case?
	            }
	        }
	        try {
	            // Create service instances for the pending promises and resolve them
	            // NOTE: if this.multipleInstances is false, only the default instance will be created
	            // and all promises with resolve with it regardless of the identifier.
	            for (var _b = tslib.__values(this.instancesDeferred.entries()), _c = _b.next(); !_c.done; _c = _b.next()) {
	                var _d = tslib.__read(_c.value, 2), instanceIdentifier = _d[0], instanceDeferred = _d[1];
	                var normalizedIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
	                try {
	                    // `getOrInitializeService()` should always return a valid instance since a component is guaranteed. use ! to make typescript happy.
	                    var instance = this.getOrInitializeService(normalizedIdentifier);
	                    instanceDeferred.resolve(instance);
	                }
	                catch (e) {
	                    // when the instance factory throws an exception, it should not cause
	                    // a fatal error. We just leave the promise unresolved.
	                }
	            }
	        }
	        catch (e_1_1) { e_1 = { error: e_1_1 }; }
	        finally {
	            try {
	                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	            }
	            finally { if (e_1) throw e_1.error; }
	        }
	    };
	    Provider.prototype.clearInstance = function (identifier) {
	        if (identifier === void 0) { identifier = DEFAULT_ENTRY_NAME; }
	        this.instancesDeferred.delete(identifier);
	        this.instances.delete(identifier);
	    };
	    // app.delete() will call this method on every provider to delete the services
	    // TODO: should we mark the provider as deleted?
	    Provider.prototype.delete = function () {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var services;
	            return tslib.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        services = Array.from(this.instances.values());
	                        return [4 /*yield*/, Promise.all(services
	                                .filter(function (service) { return 'INTERNAL' in service; })
	                                // eslint-disable-next-line @typescript-eslint/no-explicit-any
	                                .map(function (service) { return service.INTERNAL.delete(); }))];
	                    case 1:
	                        _a.sent();
	                        return [2 /*return*/];
	                }
	            });
	        });
	    };
	    Provider.prototype.isComponentSet = function () {
	        return this.component != null;
	    };
	    Provider.prototype.getOrInitializeService = function (identifier) {
	        var instance = this.instances.get(identifier);
	        if (!instance && this.component) {
	            instance = this.component.instanceFactory(this.container, normalizeIdentifierForFactory(identifier));
	            this.instances.set(identifier, instance);
	        }
	        return instance || null;
	    };
	    Provider.prototype.normalizeInstanceIdentifier = function (identifier) {
	        if (this.component) {
	            return this.component.multipleInstances ? identifier : DEFAULT_ENTRY_NAME;
	        }
	        else {
	            return identifier; // assume multiple instances are supported before the component is provided.
	        }
	    };
	    return Provider;
	}());
	// undefined should be passed to the service factory for the default instance
	function normalizeIdentifierForFactory(identifier) {
	    return identifier === DEFAULT_ENTRY_NAME ? undefined : identifier;
	}
	function isComponentEager(component) {
	    return component.instantiationMode === "EAGER" /* EAGER */;
	}
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * ComponentContainer that provides Providers for service name T, e.g. `auth`, `auth-internal`
	 */
	var ComponentContainer = /** @class */ (function () {
	    function ComponentContainer(name) {
	        this.name = name;
	        this.providers = new Map();
	    }
	    /**
	     *
	     * @param component Component being added
	     * @param overwrite When a component with the same name has already been registered,
	     * if overwrite is true: overwrite the existing component with the new component and create a new
	     * provider with the new component. It can be useful in tests where you want to use different mocks
	     * for different tests.
	     * if overwrite is false: throw an exception
	     */
	    ComponentContainer.prototype.addComponent = function (component) {
	        var provider = this.getProvider(component.name);
	        if (provider.isComponentSet()) {
	            throw new Error("Component " + component.name + " has already been registered with " + this.name);
	        }
	        provider.setComponent(component);
	    };
	    ComponentContainer.prototype.addOrOverwriteComponent = function (component) {
	        var provider = this.getProvider(component.name);
	        if (provider.isComponentSet()) {
	            // delete the existing provider from the container, so we can register the new component
	            this.providers.delete(component.name);
	        }
	        this.addComponent(component);
	    };
	    /**
	     * getProvider provides a type safe interface where it can only be called with a field name
	     * present in NameServiceMapping interface.
	     *
	     * Firebase SDKs providing services should extend NameServiceMapping interface to register
	     * themselves.
	     */
	    ComponentContainer.prototype.getProvider = function (name) {
	        if (this.providers.has(name)) {
	            return this.providers.get(name);
	        }
	        // create a Provider for a service that hasn't registered with Firebase
	        var provider = new Provider(name, this);
	        this.providers.set(name, provider);
	        return provider;
	    };
	    ComponentContainer.prototype.getProviders = function () {
	        return Array.from(this.providers.values());
	    };
	    return ComponentContainer;
	}());
	
	exports.Component = Component;
	exports.ComponentContainer = ComponentContainer;
	exports.Provider = Provider;
	//# sourceMappingURL=index.cjs.js.map


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var tslib = __webpack_require__(273);
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
	 */
	var CONSTANTS = {
	    /**
	     * @define {boolean} Whether this is the client Node.js SDK.
	     */
	    NODE_CLIENT: false,
	    /**
	     * @define {boolean} Whether this is the Admin Node.js SDK.
	     */
	    NODE_ADMIN: false,
	    /**
	     * Firebase SDK Version
	     */
	    SDK_VERSION: '${JSCORE_VERSION}'
	};
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Throws an error if the provided assertion is falsy
	 */
	var assert = function (assertion, message) {
	    if (!assertion) {
	        throw assertionError(message);
	    }
	};
	/**
	 * Returns an Error object suitable for throwing.
	 */
	var assertionError = function (message) {
	    return new Error('Firebase Database (' +
	        CONSTANTS.SDK_VERSION +
	        ') INTERNAL ASSERT FAILED: ' +
	        message);
	};
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var stringToByteArray = function (str) {
	    // TODO(user): Use native implementations if/when available
	    var out = [];
	    var p = 0;
	    for (var i = 0; i < str.length; i++) {
	        var c = str.charCodeAt(i);
	        if (c < 128) {
	            out[p++] = c;
	        }
	        else if (c < 2048) {
	            out[p++] = (c >> 6) | 192;
	            out[p++] = (c & 63) | 128;
	        }
	        else if ((c & 0xfc00) === 0xd800 &&
	            i + 1 < str.length &&
	            (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
	            // Surrogate Pair
	            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
	            out[p++] = (c >> 18) | 240;
	            out[p++] = ((c >> 12) & 63) | 128;
	            out[p++] = ((c >> 6) & 63) | 128;
	            out[p++] = (c & 63) | 128;
	        }
	        else {
	            out[p++] = (c >> 12) | 224;
	            out[p++] = ((c >> 6) & 63) | 128;
	            out[p++] = (c & 63) | 128;
	        }
	    }
	    return out;
	};
	/**
	 * Turns an array of numbers into the string given by the concatenation of the
	 * characters to which the numbers correspond.
	 * @param bytes Array of numbers representing characters.
	 * @return Stringification of the array.
	 */
	var byteArrayToString = function (bytes) {
	    // TODO(user): Use native implementations if/when available
	    var out = [];
	    var pos = 0, c = 0;
	    while (pos < bytes.length) {
	        var c1 = bytes[pos++];
	        if (c1 < 128) {
	            out[c++] = String.fromCharCode(c1);
	        }
	        else if (c1 > 191 && c1 < 224) {
	            var c2 = bytes[pos++];
	            out[c++] = String.fromCharCode(((c1 & 31) << 6) | (c2 & 63));
	        }
	        else if (c1 > 239 && c1 < 365) {
	            // Surrogate Pair
	            var c2 = bytes[pos++];
	            var c3 = bytes[pos++];
	            var c4 = bytes[pos++];
	            var u = (((c1 & 7) << 18) | ((c2 & 63) << 12) | ((c3 & 63) << 6) | (c4 & 63)) -
	                0x10000;
	            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
	            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
	        }
	        else {
	            var c2 = bytes[pos++];
	            var c3 = bytes[pos++];
	            out[c++] = String.fromCharCode(((c1 & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
	        }
	    }
	    return out.join('');
	};
	// We define it as an object literal instead of a class because a class compiled down to es5 can't
	// be treeshaked. https://github.com/rollup/rollup/issues/1691
	// Static lookup maps, lazily populated by init_()
	var base64 = {
	    /**
	     * Maps bytes to characters.
	     */
	    byteToCharMap_: null,
	    /**
	     * Maps characters to bytes.
	     */
	    charToByteMap_: null,
	    /**
	     * Maps bytes to websafe characters.
	     * @private
	     */
	    byteToCharMapWebSafe_: null,
	    /**
	     * Maps websafe characters to bytes.
	     * @private
	     */
	    charToByteMapWebSafe_: null,
	    /**
	     * Our default alphabet, shared between
	     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
	     */
	    ENCODED_VALS_BASE: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ' + 'abcdefghijklmnopqrstuvwxyz' + '0123456789',
	    /**
	     * Our default alphabet. Value 64 (=) is special; it means "nothing."
	     */
	    get ENCODED_VALS() {
	        return this.ENCODED_VALS_BASE + '+/=';
	    },
	    /**
	     * Our websafe alphabet.
	     */
	    get ENCODED_VALS_WEBSAFE() {
	        return this.ENCODED_VALS_BASE + '-_.';
	    },
	    /**
	     * Whether this browser supports the atob and btoa functions. This extension
	     * started at Mozilla but is now implemented by many browsers. We use the
	     * ASSUME_* variables to avoid pulling in the full useragent detection library
	     * but still allowing the standard per-browser compilations.
	     *
	     */
	    HAS_NATIVE_SUPPORT: typeof atob === 'function',
	    /**
	     * Base64-encode an array of bytes.
	     *
	     * @param input An array of bytes (numbers with
	     *     value in [0, 255]) to encode.
	     * @param webSafe Boolean indicating we should use the
	     *     alternative alphabet.
	     * @return The base64 encoded string.
	     */
	    encodeByteArray: function (input, webSafe) {
	        if (!Array.isArray(input)) {
	            throw Error('encodeByteArray takes an array as a parameter');
	        }
	        this.init_();
	        var byteToCharMap = webSafe
	            ? this.byteToCharMapWebSafe_
	            : this.byteToCharMap_;
	        var output = [];
	        for (var i = 0; i < input.length; i += 3) {
	            var byte1 = input[i];
	            var haveByte2 = i + 1 < input.length;
	            var byte2 = haveByte2 ? input[i + 1] : 0;
	            var haveByte3 = i + 2 < input.length;
	            var byte3 = haveByte3 ? input[i + 2] : 0;
	            var outByte1 = byte1 >> 2;
	            var outByte2 = ((byte1 & 0x03) << 4) | (byte2 >> 4);
	            var outByte3 = ((byte2 & 0x0f) << 2) | (byte3 >> 6);
	            var outByte4 = byte3 & 0x3f;
	            if (!haveByte3) {
	                outByte4 = 64;
	                if (!haveByte2) {
	                    outByte3 = 64;
	                }
	            }
	            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
	        }
	        return output.join('');
	    },
	    /**
	     * Base64-encode a string.
	     *
	     * @param input A string to encode.
	     * @param webSafe If true, we should use the
	     *     alternative alphabet.
	     * @return The base64 encoded string.
	     */
	    encodeString: function (input, webSafe) {
	        // Shortcut for Mozilla browsers that implement
	        // a native base64 encoder in the form of "btoa/atob"
	        if (this.HAS_NATIVE_SUPPORT && !webSafe) {
	            return btoa(input);
	        }
	        return this.encodeByteArray(stringToByteArray(input), webSafe);
	    },
	    /**
	     * Base64-decode a string.
	     *
	     * @param input to decode.
	     * @param webSafe True if we should use the
	     *     alternative alphabet.
	     * @return string representing the decoded value.
	     */
	    decodeString: function (input, webSafe) {
	        // Shortcut for Mozilla browsers that implement
	        // a native base64 encoder in the form of "btoa/atob"
	        if (this.HAS_NATIVE_SUPPORT && !webSafe) {
	            return atob(input);
	        }
	        return byteArrayToString(this.decodeStringToByteArray(input, webSafe));
	    },
	    /**
	     * Base64-decode a string.
	     *
	     * In base-64 decoding, groups of four characters are converted into three
	     * bytes.  If the encoder did not apply padding, the input length may not
	     * be a multiple of 4.
	     *
	     * In this case, the last group will have fewer than 4 characters, and
	     * padding will be inferred.  If the group has one or two characters, it decodes
	     * to one byte.  If the group has three characters, it decodes to two bytes.
	     *
	     * @param input Input to decode.
	     * @param webSafe True if we should use the web-safe alphabet.
	     * @return bytes representing the decoded value.
	     */
	    decodeStringToByteArray: function (input, webSafe) {
	        this.init_();
	        var charToByteMap = webSafe
	            ? this.charToByteMapWebSafe_
	            : this.charToByteMap_;
	        var output = [];
	        for (var i = 0; i < input.length;) {
	            var byte1 = charToByteMap[input.charAt(i++)];
	            var haveByte2 = i < input.length;
	            var byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
	            ++i;
	            var haveByte3 = i < input.length;
	            var byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
	            ++i;
	            var haveByte4 = i < input.length;
	            var byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
	            ++i;
	            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) {
	                throw Error();
	            }
	            var outByte1 = (byte1 << 2) | (byte2 >> 4);
	            output.push(outByte1);
	            if (byte3 !== 64) {
	                var outByte2 = ((byte2 << 4) & 0xf0) | (byte3 >> 2);
	                output.push(outByte2);
	                if (byte4 !== 64) {
	                    var outByte3 = ((byte3 << 6) & 0xc0) | byte4;
	                    output.push(outByte3);
	                }
	            }
	        }
	        return output;
	    },
	    /**
	     * Lazy static initialization function. Called before
	     * accessing any of the static map variables.
	     * @private
	     */
	    init_: function () {
	        if (!this.byteToCharMap_) {
	            this.byteToCharMap_ = {};
	            this.charToByteMap_ = {};
	            this.byteToCharMapWebSafe_ = {};
	            this.charToByteMapWebSafe_ = {};
	            // We want quick mappings back and forth, so we precompute two maps.
	            for (var i = 0; i < this.ENCODED_VALS.length; i++) {
	                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
	                this.charToByteMap_[this.byteToCharMap_[i]] = i;
	                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
	                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
	                // Be forgiving when decoding and correctly decode both encodings.
	                if (i >= this.ENCODED_VALS_BASE.length) {
	                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
	                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
	                }
	            }
	        }
	    }
	};
	/**
	 * URL-safe base64 encoding
	 */
	var base64Encode = function (str) {
	    var utf8Bytes = stringToByteArray(str);
	    return base64.encodeByteArray(utf8Bytes, true);
	};
	/**
	 * URL-safe base64 decoding
	 *
	 * NOTE: DO NOT use the global atob() function - it does NOT support the
	 * base64Url variant encoding.
	 *
	 * @param str To be decoded
	 * @return Decoded result, if possible
	 */
	var base64Decode = function (str) {
	    try {
	        return base64.decodeString(str, true);
	    }
	    catch (e) {
	        console.error('base64Decode failed: ', e);
	    }
	    return null;
	};
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Do a deep-copy of basic JavaScript Objects or Arrays.
	 */
	function deepCopy(value) {
	    return deepExtend(undefined, value);
	}
	/**
	 * Copy properties from source to target (recursively allows extension
	 * of Objects and Arrays).  Scalar values in the target are over-written.
	 * If target is undefined, an object of the appropriate type will be created
	 * (and returned).
	 *
	 * We recursively copy all child properties of plain Objects in the source- so
	 * that namespace- like dictionaries are merged.
	 *
	 * Note that the target can be a function, in which case the properties in
	 * the source Object are copied onto it as static properties of the Function.
	 */
	function deepExtend(target, source) {
	    if (!(source instanceof Object)) {
	        return source;
	    }
	    switch (source.constructor) {
	        case Date:
	            // Treat Dates like scalars; if the target date object had any child
	            // properties - they will be lost!
	            var dateValue = source;
	            return new Date(dateValue.getTime());
	        case Object:
	            if (target === undefined) {
	                target = {};
	            }
	            break;
	        case Array:
	            // Always copy the array source and overwrite the target.
	            target = [];
	            break;
	        default:
	            // Not a plain Object - treat it as a scalar.
	            return source;
	    }
	    for (var prop in source) {
	        if (!source.hasOwnProperty(prop)) {
	            continue;
	        }
	        target[prop] = deepExtend(target[prop], source[prop]);
	    }
	    return target;
	}
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var Deferred = /** @class */ (function () {
	    function Deferred() {
	        var _this = this;
	        this.reject = function () { };
	        this.resolve = function () { };
	        this.promise = new Promise(function (resolve, reject) {
	            _this.resolve = resolve;
	            _this.reject = reject;
	        });
	    }
	    /**
	     * Our API internals are not promiseified and cannot because our callback APIs have subtle expectations around
	     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
	     * and returns a node-style callback which will resolve or reject the Deferred's promise.
	     */
	    Deferred.prototype.wrapCallback = function (callback) {
	        var _this = this;
	        return function (error, value) {
	            if (error) {
	                _this.reject(error);
	            }
	            else {
	                _this.resolve(value);
	            }
	            if (typeof callback === 'function') {
	                // Attaching noop handler just in case developer wasn't expecting
	                // promises
	                _this.promise.catch(function () { });
	                // Some of our callbacks don't expect a value and our own tests
	                // assert that the parameter length is 1
	                if (callback.length === 1) {
	                    callback(error);
	                }
	                else {
	                    callback(error, value);
	                }
	            }
	        };
	    };
	    return Deferred;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Returns navigator.userAgent string or '' if it's not defined.
	 * @return user agent string
	 */
	function getUA() {
	    if (typeof navigator !== 'undefined' &&
	        typeof navigator['userAgent'] === 'string') {
	        return navigator['userAgent'];
	    }
	    else {
	        return '';
	    }
	}
	/**
	 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
	 *
	 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap
	 * in the Ripple emulator) nor Cordova `onDeviceReady`, which would normally
	 * wait for a callback.
	 */
	function isMobileCordova() {
	    return (typeof window !== 'undefined' &&
	        // @ts-ignore Setting up an broadly applicable index signature for Window
	        // just to deal with this case would probably be a bad idea.
	        !!(window['cordova'] || window['phonegap'] || window['PhoneGap']) &&
	        /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test(getUA()));
	}
	/**
	 * Detect Node.js.
	 *
	 * @return true if Node.js environment is detected.
	 */
	// Node detection logic from: https://github.com/iliakan/detect-node/
	function isNode() {
	    try {
	        return (Object.prototype.toString.call(global.process) === '[object process]');
	    }
	    catch (e) {
	        return false;
	    }
	}
	/**
	 * Detect Browser Environment
	 */
	function isBrowser() {
	    return typeof self === 'object' && self.self === self;
	}
	function isBrowserExtension() {
	    var runtime = typeof chrome === 'object'
	        ? chrome.runtime
	        : typeof browser === 'object'
	            ? browser.runtime
	            : undefined;
	    return typeof runtime === 'object' && runtime.id !== undefined;
	}
	/**
	 * Detect React Native.
	 *
	 * @return true if ReactNative environment is detected.
	 */
	function isReactNative() {
	    return (typeof navigator === 'object' && navigator['product'] === 'ReactNative');
	}
	/** Detects Electron apps. */
	function isElectron() {
	    return getUA().indexOf('Electron/') >= 0;
	}
	/** Detects Internet Explorer. */
	function isIE() {
	    var ua = getUA();
	    return ua.indexOf('MSIE ') >= 0 || ua.indexOf('Trident/') >= 0;
	}
	/** Detects Universal Windows Platform apps. */
	function isUWP() {
	    return getUA().indexOf('MSAppHost/') >= 0;
	}
	/**
	 * Detect whether the current SDK build is the Node version.
	 *
	 * @return true if it's the Node SDK build.
	 */
	function isNodeSdk() {
	    return CONSTANTS.NODE_CLIENT === true || CONSTANTS.NODE_ADMIN === true;
	}
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var ERROR_NAME = 'FirebaseError';
	// Based on code from:
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Custom_Error_Types
	var FirebaseError = /** @class */ (function (_super) {
	    tslib.__extends(FirebaseError, _super);
	    function FirebaseError(code, message) {
	        var _this = _super.call(this, message) || this;
	        _this.code = code;
	        _this.name = ERROR_NAME;
	        // Fix For ES5
	        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
	        Object.setPrototypeOf(_this, FirebaseError.prototype);
	        // Maintains proper stack trace for where our error was thrown.
	        // Only available on V8.
	        if (Error.captureStackTrace) {
	            Error.captureStackTrace(_this, ErrorFactory.prototype.create);
	        }
	        return _this;
	    }
	    return FirebaseError;
	}(Error));
	var ErrorFactory = /** @class */ (function () {
	    function ErrorFactory(service, serviceName, errors) {
	        this.service = service;
	        this.serviceName = serviceName;
	        this.errors = errors;
	    }
	    ErrorFactory.prototype.create = function (code) {
	        var data = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            data[_i - 1] = arguments[_i];
	        }
	        var customData = data[0] || {};
	        var fullCode = this.service + "/" + code;
	        var template = this.errors[code];
	        var message = template ? replaceTemplate(template, customData) : 'Error';
	        // Service Name: Error message (service/code).
	        var fullMessage = this.serviceName + ": " + message + " (" + fullCode + ").";
	        var error = new FirebaseError(fullCode, fullMessage);
	        // Keys with an underscore at the end of their name are not included in
	        // error.data for some reason.
	        // TODO: Replace with Object.entries when lib is updated to es2017.
	        for (var _a = 0, _b = Object.keys(customData); _a < _b.length; _a++) {
	            var key = _b[_a];
	            if (key.slice(-1) !== '_') {
	                if (key in error) {
	                    console.warn("Overwriting FirebaseError base field \"" + key + "\" can cause unexpected behavior.");
	                }
	                error[key] = customData[key];
	            }
	        }
	        return error;
	    };
	    return ErrorFactory;
	}());
	function replaceTemplate(template, data) {
	    return template.replace(PATTERN, function (_, key) {
	        var value = data[key];
	        return value != null ? value.toString() : "<" + key + "?>";
	    });
	}
	var PATTERN = /\{\$([^}]+)}/g;
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Evaluates a JSON string into a javascript object.
	 *
	 * @param {string} str A string containing JSON.
	 * @return {*} The javascript object representing the specified JSON.
	 */
	function jsonEval(str) {
	    return JSON.parse(str);
	}
	/**
	 * Returns JSON representing a javascript object.
	 * @param {*} data Javascript object to be stringified.
	 * @return {string} The JSON contents of the object.
	 */
	function stringify(data) {
	    return JSON.stringify(data);
	}
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Decodes a Firebase auth. token into constituent parts.
	 *
	 * Notes:
	 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
	 * - Doesn't check if the token is actually valid.
	 */
	var decode = function (token) {
	    var header = {}, claims = {}, data = {}, signature = '';
	    try {
	        var parts = token.split('.');
	        header = jsonEval(base64Decode(parts[0]) || '');
	        claims = jsonEval(base64Decode(parts[1]) || '');
	        signature = parts[2];
	        data = claims['d'] || {};
	        delete claims['d'];
	    }
	    catch (e) { }
	    return {
	        header: header,
	        claims: claims,
	        data: data,
	        signature: signature
	    };
	};
	/**
	 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
	 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
	 *
	 * Notes:
	 * - May return a false negative if there's no native base64 decoding support.
	 * - Doesn't check if the token is actually valid.
	 */
	var isValidTimestamp = function (token) {
	    var claims = decode(token).claims;
	    var now = Math.floor(new Date().getTime() / 1000);
	    var validSince = 0, validUntil = 0;
	    if (typeof claims === 'object') {
	        if (claims.hasOwnProperty('nbf')) {
	            validSince = claims['nbf'];
	        }
	        else if (claims.hasOwnProperty('iat')) {
	            validSince = claims['iat'];
	        }
	        if (claims.hasOwnProperty('exp')) {
	            validUntil = claims['exp'];
	        }
	        else {
	            // token will expire after 24h by default
	            validUntil = validSince + 86400;
	        }
	    }
	    return (!!now &&
	        !!validSince &&
	        !!validUntil &&
	        now >= validSince &&
	        now <= validUntil);
	};
	/**
	 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
	 *
	 * Notes:
	 * - May return null if there's no native base64 decoding support.
	 * - Doesn't check if the token is actually valid.
	 */
	var issuedAtTime = function (token) {
	    var claims = decode(token).claims;
	    if (typeof claims === 'object' && claims.hasOwnProperty('iat')) {
	        return claims['iat'];
	    }
	    return null;
	};
	/**
	 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time.
	 *
	 * Notes:
	 * - May return a false negative if there's no native base64 decoding support.
	 * - Doesn't check if the token is actually valid.
	 */
	var isValidFormat = function (token) {
	    var decoded = decode(token), claims = decoded.claims;
	    return !!claims && typeof claims === 'object' && claims.hasOwnProperty('iat');
	};
	/**
	 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
	 *
	 * Notes:
	 * - May return a false negative if there's no native base64 decoding support.
	 * - Doesn't check if the token is actually valid.
	 */
	var isAdmin = function (token) {
	    var claims = decode(token).claims;
	    return typeof claims === 'object' && claims['admin'] === true;
	};
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function contains(obj, key) {
	    return Object.prototype.hasOwnProperty.call(obj, key);
	}
	function safeGet(obj, key) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	        return obj[key];
	    }
	    else {
	        return undefined;
	    }
	}
	function isEmpty(obj) {
	    for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	            return false;
	        }
	    }
	    return true;
	}
	function map(obj, fn, contextObj) {
	    var res = {};
	    for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	            res[key] = fn.call(contextObj, obj[key], key, obj);
	        }
	    }
	    return res;
	}
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a
	 * params object (e.g. {arg: 'val', arg2: 'val2'})
	 * Note: You must prepend it with ? when adding it to a URL.
	 */
	function querystring(querystringParams) {
	    var params = [];
	    var _loop_1 = function (key, value) {
	        if (Array.isArray(value)) {
	            value.forEach(function (arrayVal) {
	                params.push(encodeURIComponent(key) + '=' + encodeURIComponent(arrayVal));
	            });
	        }
	        else {
	            params.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
	        }
	    };
	    for (var _i = 0, _a = Object.entries(querystringParams); _i < _a.length; _i++) {
	        var _b = _a[_i], key = _b[0], value = _b[1];
	        _loop_1(key, value);
	    }
	    return params.length ? '&' + params.join('&') : '';
	}
	/**
	 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object
	 * (e.g. {arg: 'val', arg2: 'val2'})
	 */
	function querystringDecode(querystring) {
	    var obj = {};
	    var tokens = querystring.replace(/^\?/, '').split('&');
	    tokens.forEach(function (token) {
	        if (token) {
	            var key = token.split('=');
	            obj[key[0]] = key[1];
	        }
	    });
	    return obj;
	}
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @fileoverview SHA-1 cryptographic hash.
	 * Variable names follow the notation in FIPS PUB 180-3:
	 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
	 *
	 * Usage:
	 *   var sha1 = new sha1();
	 *   sha1.update(bytes);
	 *   var hash = sha1.digest();
	 *
	 * Performance:
	 *   Chrome 23:   ~400 Mbit/s
	 *   Firefox 16:  ~250 Mbit/s
	 *
	 */
	/**
	 * SHA-1 cryptographic hash constructor.
	 *
	 * The properties declared here are discussed in the above algorithm document.
	 * @constructor
	 * @final
	 * @struct
	 */
	var Sha1 = /** @class */ (function () {
	    function Sha1() {
	        /**
	         * Holds the previous values of accumulated variables a-e in the compress_
	         * function.
	         * @private
	         */
	        this.chain_ = [];
	        /**
	         * A buffer holding the partially computed hash result.
	         * @private
	         */
	        this.buf_ = [];
	        /**
	         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
	         * as the message schedule in the docs.
	         * @private
	         */
	        this.W_ = [];
	        /**
	         * Contains data needed to pad messages less than 64 bytes.
	         * @private
	         */
	        this.pad_ = [];
	        /**
	         * @private {number}
	         */
	        this.inbuf_ = 0;
	        /**
	         * @private {number}
	         */
	        this.total_ = 0;
	        this.blockSize = 512 / 8;
	        this.pad_[0] = 128;
	        for (var i = 1; i < this.blockSize; ++i) {
	            this.pad_[i] = 0;
	        }
	        this.reset();
	    }
	    Sha1.prototype.reset = function () {
	        this.chain_[0] = 0x67452301;
	        this.chain_[1] = 0xefcdab89;
	        this.chain_[2] = 0x98badcfe;
	        this.chain_[3] = 0x10325476;
	        this.chain_[4] = 0xc3d2e1f0;
	        this.inbuf_ = 0;
	        this.total_ = 0;
	    };
	    /**
	     * Internal compress helper function.
	     * @param buf Block to compress.
	     * @param offset Offset of the block in the buffer.
	     * @private
	     */
	    Sha1.prototype.compress_ = function (buf, offset) {
	        if (!offset) {
	            offset = 0;
	        }
	        var W = this.W_;
	        // get 16 big endian words
	        if (typeof buf === 'string') {
	            for (var i = 0; i < 16; i++) {
	                // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
	                // have a bug that turns the post-increment ++ operator into pre-increment
	                // during JIT compilation.  We have code that depends heavily on SHA-1 for
	                // correctness and which is affected by this bug, so I've removed all uses
	                // of post-increment ++ in which the result value is used.  We can revert
	                // this change once the Safari bug
	                // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
	                // most clients have been updated.
	                W[i] =
	                    (buf.charCodeAt(offset) << 24) |
	                        (buf.charCodeAt(offset + 1) << 16) |
	                        (buf.charCodeAt(offset + 2) << 8) |
	                        buf.charCodeAt(offset + 3);
	                offset += 4;
	            }
	        }
	        else {
	            for (var i = 0; i < 16; i++) {
	                W[i] =
	                    (buf[offset] << 24) |
	                        (buf[offset + 1] << 16) |
	                        (buf[offset + 2] << 8) |
	                        buf[offset + 3];
	                offset += 4;
	            }
	        }
	        // expand to 80 words
	        for (var i = 16; i < 80; i++) {
	            var t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
	            W[i] = ((t << 1) | (t >>> 31)) & 0xffffffff;
	        }
	        var a = this.chain_[0];
	        var b = this.chain_[1];
	        var c = this.chain_[2];
	        var d = this.chain_[3];
	        var e = this.chain_[4];
	        var f, k;
	        // TODO(user): Try to unroll this loop to speed up the computation.
	        for (var i = 0; i < 80; i++) {
	            if (i < 40) {
	                if (i < 20) {
	                    f = d ^ (b & (c ^ d));
	                    k = 0x5a827999;
	                }
	                else {
	                    f = b ^ c ^ d;
	                    k = 0x6ed9eba1;
	                }
	            }
	            else {
	                if (i < 60) {
	                    f = (b & c) | (d & (b | c));
	                    k = 0x8f1bbcdc;
	                }
	                else {
	                    f = b ^ c ^ d;
	                    k = 0xca62c1d6;
	                }
	            }
	            var t = (((a << 5) | (a >>> 27)) + f + e + k + W[i]) & 0xffffffff;
	            e = d;
	            d = c;
	            c = ((b << 30) | (b >>> 2)) & 0xffffffff;
	            b = a;
	            a = t;
	        }
	        this.chain_[0] = (this.chain_[0] + a) & 0xffffffff;
	        this.chain_[1] = (this.chain_[1] + b) & 0xffffffff;
	        this.chain_[2] = (this.chain_[2] + c) & 0xffffffff;
	        this.chain_[3] = (this.chain_[3] + d) & 0xffffffff;
	        this.chain_[4] = (this.chain_[4] + e) & 0xffffffff;
	    };
	    Sha1.prototype.update = function (bytes, length) {
	        // TODO(johnlenz): tighten the function signature and remove this check
	        if (bytes == null) {
	            return;
	        }
	        if (length === undefined) {
	            length = bytes.length;
	        }
	        var lengthMinusBlock = length - this.blockSize;
	        var n = 0;
	        // Using local instead of member variables gives ~5% speedup on Firefox 16.
	        var buf = this.buf_;
	        var inbuf = this.inbuf_;
	        // The outer while loop should execute at most twice.
	        while (n < length) {
	            // When we have no data in the block to top up, we can directly process the
	            // input buffer (assuming it contains sufficient data). This gives ~25%
	            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
	            // the data is provided in large chunks (or in multiples of 64 bytes).
	            if (inbuf === 0) {
	                while (n <= lengthMinusBlock) {
	                    this.compress_(bytes, n);
	                    n += this.blockSize;
	                }
	            }
	            if (typeof bytes === 'string') {
	                while (n < length) {
	                    buf[inbuf] = bytes.charCodeAt(n);
	                    ++inbuf;
	                    ++n;
	                    if (inbuf === this.blockSize) {
	                        this.compress_(buf);
	                        inbuf = 0;
	                        // Jump to the outer loop so we use the full-block optimization.
	                        break;
	                    }
	                }
	            }
	            else {
	                while (n < length) {
	                    buf[inbuf] = bytes[n];
	                    ++inbuf;
	                    ++n;
	                    if (inbuf === this.blockSize) {
	                        this.compress_(buf);
	                        inbuf = 0;
	                        // Jump to the outer loop so we use the full-block optimization.
	                        break;
	                    }
	                }
	            }
	        }
	        this.inbuf_ = inbuf;
	        this.total_ += length;
	    };
	    /** @override */
	    Sha1.prototype.digest = function () {
	        var digest = [];
	        var totalBits = this.total_ * 8;
	        // Add pad 0x80 0x00*.
	        if (this.inbuf_ < 56) {
	            this.update(this.pad_, 56 - this.inbuf_);
	        }
	        else {
	            this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
	        }
	        // Add # bits.
	        for (var i = this.blockSize - 1; i >= 56; i--) {
	            this.buf_[i] = totalBits & 255;
	            totalBits /= 256; // Don't use bit-shifting here!
	        }
	        this.compress_(this.buf_);
	        var n = 0;
	        for (var i = 0; i < 5; i++) {
	            for (var j = 24; j >= 0; j -= 8) {
	                digest[n] = (this.chain_[i] >> j) & 255;
	                ++n;
	            }
	        }
	        return digest;
	    };
	    return Sha1;
	}());
	
	/**
	 * Helper to make a Subscribe function (just like Promise helps make a
	 * Thenable).
	 *
	 * @param executor Function which can make calls to a single Observer
	 *     as a proxy.
	 * @param onNoObservers Callback when count of Observers goes to zero.
	 */
	function createSubscribe(executor, onNoObservers) {
	    var proxy = new ObserverProxy(executor, onNoObservers);
	    return proxy.subscribe.bind(proxy);
	}
	/**
	 * Implement fan-out for any number of Observers attached via a subscribe
	 * function.
	 */
	var ObserverProxy = /** @class */ (function () {
	    /**
	     * @param executor Function which can make calls to a single Observer
	     *     as a proxy.
	     * @param onNoObservers Callback when count of Observers goes to zero.
	     */
	    function ObserverProxy(executor, onNoObservers) {
	        var _this = this;
	        this.observers = [];
	        this.unsubscribes = [];
	        this.observerCount = 0;
	        // Micro-task scheduling by calling task.then().
	        this.task = Promise.resolve();
	        this.finalized = false;
	        this.onNoObservers = onNoObservers;
	        // Call the executor asynchronously so subscribers that are called
	        // synchronously after the creation of the subscribe function
	        // can still receive the very first value generated in the executor.
	        this.task
	            .then(function () {
	            executor(_this);
	        })
	            .catch(function (e) {
	            _this.error(e);
	        });
	    }
	    ObserverProxy.prototype.next = function (value) {
	        this.forEachObserver(function (observer) {
	            observer.next(value);
	        });
	    };
	    ObserverProxy.prototype.error = function (error) {
	        this.forEachObserver(function (observer) {
	            observer.error(error);
	        });
	        this.close(error);
	    };
	    ObserverProxy.prototype.complete = function () {
	        this.forEachObserver(function (observer) {
	            observer.complete();
	        });
	        this.close();
	    };
	    /**
	     * Subscribe function that can be used to add an Observer to the fan-out list.
	     *
	     * - We require that no event is sent to a subscriber sychronously to their
	     *   call to subscribe().
	     */
	    ObserverProxy.prototype.subscribe = function (nextOrObserver, error, complete) {
	        var _this = this;
	        var observer;
	        if (nextOrObserver === undefined &&
	            error === undefined &&
	            complete === undefined) {
	            throw new Error('Missing Observer.');
	        }
	        // Assemble an Observer object when passed as callback functions.
	        if (implementsAnyMethods(nextOrObserver, [
	            'next',
	            'error',
	            'complete'
	        ])) {
	            observer = nextOrObserver;
	        }
	        else {
	            observer = {
	                next: nextOrObserver,
	                error: error,
	                complete: complete
	            };
	        }
	        if (observer.next === undefined) {
	            observer.next = noop;
	        }
	        if (observer.error === undefined) {
	            observer.error = noop;
	        }
	        if (observer.complete === undefined) {
	            observer.complete = noop;
	        }
	        var unsub = this.unsubscribeOne.bind(this, this.observers.length);
	        // Attempt to subscribe to a terminated Observable - we
	        // just respond to the Observer with the final error or complete
	        // event.
	        if (this.finalized) {
	            // eslint-disable-next-line @typescript-eslint/no-floating-promises
	            this.task.then(function () {
	                try {
	                    if (_this.finalError) {
	                        observer.error(_this.finalError);
	                    }
	                    else {
	                        observer.complete();
	                    }
	                }
	                catch (e) {
	                    // nothing
	                }
	                return;
	            });
	        }
	        this.observers.push(observer);
	        return unsub;
	    };
	    // Unsubscribe is synchronous - we guarantee that no events are sent to
	    // any unsubscribed Observer.
	    ObserverProxy.prototype.unsubscribeOne = function (i) {
	        if (this.observers === undefined || this.observers[i] === undefined) {
	            return;
	        }
	        delete this.observers[i];
	        this.observerCount -= 1;
	        if (this.observerCount === 0 && this.onNoObservers !== undefined) {
	            this.onNoObservers(this);
	        }
	    };
	    ObserverProxy.prototype.forEachObserver = function (fn) {
	        if (this.finalized) {
	            // Already closed by previous event....just eat the additional values.
	            return;
	        }
	        // Since sendOne calls asynchronously - there is no chance that
	        // this.observers will become undefined.
	        for (var i = 0; i < this.observers.length; i++) {
	            this.sendOne(i, fn);
	        }
	    };
	    // Call the Observer via one of it's callback function. We are careful to
	    // confirm that the observe has not been unsubscribed since this asynchronous
	    // function had been queued.
	    ObserverProxy.prototype.sendOne = function (i, fn) {
	        var _this = this;
	        // Execute the callback asynchronously
	        // eslint-disable-next-line @typescript-eslint/no-floating-promises
	        this.task.then(function () {
	            if (_this.observers !== undefined && _this.observers[i] !== undefined) {
	                try {
	                    fn(_this.observers[i]);
	                }
	                catch (e) {
	                    // Ignore exceptions raised in Observers or missing methods of an
	                    // Observer.
	                    // Log error to console. b/31404806
	                    if (typeof console !== 'undefined' && console.error) {
	                        console.error(e);
	                    }
	                }
	            }
	        });
	    };
	    ObserverProxy.prototype.close = function (err) {
	        var _this = this;
	        if (this.finalized) {
	            return;
	        }
	        this.finalized = true;
	        if (err !== undefined) {
	            this.finalError = err;
	        }
	        // Proxy is no longer needed - garbage collect references
	        // eslint-disable-next-line @typescript-eslint/no-floating-promises
	        this.task.then(function () {
	            _this.observers = undefined;
	            _this.onNoObservers = undefined;
	        });
	    };
	    return ObserverProxy;
	}());
	/** Turn synchronous function into one called asynchronously. */
	function async(fn, onError) {
	    return function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        Promise.resolve(true)
	            .then(function () {
	            fn.apply(void 0, args);
	        })
	            .catch(function (error) {
	            if (onError) {
	                onError(error);
	            }
	        });
	    };
	}
	/**
	 * Return true if the object passed in implements any of the named methods.
	 */
	function implementsAnyMethods(obj, methods) {
	    if (typeof obj !== 'object' || obj === null) {
	        return false;
	    }
	    for (var _i = 0, methods_1 = methods; _i < methods_1.length; _i++) {
	        var method = methods_1[_i];
	        if (method in obj && typeof obj[method] === 'function') {
	            return true;
	        }
	    }
	    return false;
	}
	function noop() {
	    // do nothing
	}
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Check to make sure the appropriate number of arguments are provided for a public function.
	 * Throws an error if it fails.
	 *
	 * @param fnName The function name
	 * @param minCount The minimum number of arguments to allow for the function call
	 * @param maxCount The maximum number of argument to allow for the function call
	 * @param argCount The actual number of arguments provided.
	 */
	var validateArgCount = function (fnName, minCount, maxCount, argCount) {
	    var argError;
	    if (argCount < minCount) {
	        argError = 'at least ' + minCount;
	    }
	    else if (argCount > maxCount) {
	        argError = maxCount === 0 ? 'none' : 'no more than ' + maxCount;
	    }
	    if (argError) {
	        var error = fnName +
	            ' failed: Was called with ' +
	            argCount +
	            (argCount === 1 ? ' argument.' : ' arguments.') +
	            ' Expects ' +
	            argError +
	            '.';
	        throw new Error(error);
	    }
	};
	/**
	 * Generates a string to prefix an error message about failed argument validation
	 *
	 * @param fnName The function name
	 * @param argumentNumber The index of the argument
	 * @param optional Whether or not the argument is optional
	 * @return The prefix to add to the error thrown for validation.
	 */
	function errorPrefix(fnName, argumentNumber, optional) {
	    var argName = '';
	    switch (argumentNumber) {
	        case 1:
	            argName = optional ? 'first' : 'First';
	            break;
	        case 2:
	            argName = optional ? 'second' : 'Second';
	            break;
	        case 3:
	            argName = optional ? 'third' : 'Third';
	            break;
	        case 4:
	            argName = optional ? 'fourth' : 'Fourth';
	            break;
	        default:
	            throw new Error('errorPrefix called with argumentNumber > 4.  Need to update it?');
	    }
	    var error = fnName + ' failed: ';
	    error += argName + ' argument ';
	    return error;
	}
	/**
	 * @param fnName
	 * @param argumentNumber
	 * @param namespace
	 * @param optional
	 */
	function validateNamespace(fnName, argumentNumber, namespace, optional) {
	    if (optional && !namespace) {
	        return;
	    }
	    if (typeof namespace !== 'string') {
	        //TODO: I should do more validation here. We only allow certain chars in namespaces.
	        throw new Error(errorPrefix(fnName, argumentNumber, optional) +
	            'must be a valid firebase namespace.');
	    }
	}
	function validateCallback(fnName, argumentNumber, callback, optional) {
	    if (optional && !callback) {
	        return;
	    }
	    if (typeof callback !== 'function') {
	        throw new Error(errorPrefix(fnName, argumentNumber, optional) +
	            'must be a valid function.');
	    }
	}
	function validateContextObject(fnName, argumentNumber, context, optional) {
	    if (optional && !context) {
	        return;
	    }
	    if (typeof context !== 'object' || context === null) {
	        throw new Error(errorPrefix(fnName, argumentNumber, optional) +
	            'must be a valid context object.');
	    }
	}
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	// Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
	// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
	// so it's been modified.
	// Note that not all Unicode characters appear as single characters in JavaScript strings.
	// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
	// use 2 characters in Javascript.  All 4-byte UTF-8 characters begin with a first
	// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
	// pair).
	// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
	/**
	 * @param {string} str
	 * @return {Array}
	 */
	var stringToByteArray$1 = function (str) {
	    var out = [];
	    var p = 0;
	    for (var i = 0; i < str.length; i++) {
	        var c = str.charCodeAt(i);
	        // Is this the lead surrogate in a surrogate pair?
	        if (c >= 0xd800 && c <= 0xdbff) {
	            var high = c - 0xd800; // the high 10 bits.
	            i++;
	            assert(i < str.length, 'Surrogate pair missing trail surrogate.');
	            var low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
	            c = 0x10000 + (high << 10) + low;
	        }
	        if (c < 128) {
	            out[p++] = c;
	        }
	        else if (c < 2048) {
	            out[p++] = (c >> 6) | 192;
	            out[p++] = (c & 63) | 128;
	        }
	        else if (c < 65536) {
	            out[p++] = (c >> 12) | 224;
	            out[p++] = ((c >> 6) & 63) | 128;
	            out[p++] = (c & 63) | 128;
	        }
	        else {
	            out[p++] = (c >> 18) | 240;
	            out[p++] = ((c >> 12) & 63) | 128;
	            out[p++] = ((c >> 6) & 63) | 128;
	            out[p++] = (c & 63) | 128;
	        }
	    }
	    return out;
	};
	/**
	 * Calculate length without actually converting; useful for doing cheaper validation.
	 * @param {string} str
	 * @return {number}
	 */
	var stringLength = function (str) {
	    var p = 0;
	    for (var i = 0; i < str.length; i++) {
	        var c = str.charCodeAt(i);
	        if (c < 128) {
	            p++;
	        }
	        else if (c < 2048) {
	            p += 2;
	        }
	        else if (c >= 0xd800 && c <= 0xdbff) {
	            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
	            p += 4;
	            i++; // skip trail surrogate.
	        }
	        else {
	            p += 3;
	        }
	    }
	    return p;
	};
	
	exports.CONSTANTS = CONSTANTS;
	exports.Deferred = Deferred;
	exports.ErrorFactory = ErrorFactory;
	exports.FirebaseError = FirebaseError;
	exports.Sha1 = Sha1;
	exports.assert = assert;
	exports.assertionError = assertionError;
	exports.async = async;
	exports.base64 = base64;
	exports.base64Decode = base64Decode;
	exports.base64Encode = base64Encode;
	exports.contains = contains;
	exports.createSubscribe = createSubscribe;
	exports.decode = decode;
	exports.deepCopy = deepCopy;
	exports.deepExtend = deepExtend;
	exports.errorPrefix = errorPrefix;
	exports.getUA = getUA;
	exports.isAdmin = isAdmin;
	exports.isBrowser = isBrowser;
	exports.isBrowserExtension = isBrowserExtension;
	exports.isElectron = isElectron;
	exports.isEmpty = isEmpty;
	exports.isIE = isIE;
	exports.isMobileCordova = isMobileCordova;
	exports.isNode = isNode;
	exports.isNodeSdk = isNodeSdk;
	exports.isReactNative = isReactNative;
	exports.isUWP = isUWP;
	exports.isValidFormat = isValidFormat;
	exports.isValidTimestamp = isValidTimestamp;
	exports.issuedAtTime = issuedAtTime;
	exports.jsonEval = jsonEval;
	exports.map = map;
	exports.querystring = querystring;
	exports.querystringDecode = querystringDecode;
	exports.safeGet = safeGet;
	exports.stringLength = stringLength;
	exports.stringToByteArray = stringToByteArray$1;
	exports.stringify = stringify;
	exports.validateArgCount = validateArgCount;
	exports.validateCallback = validateCallback;
	exports.validateContextObject = validateContextObject;
	exports.validateNamespace = validateNamespace;
	//# sourceMappingURL=index.cjs.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	};
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _numeral = __webpack_require__(16);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var _reactDeviceDetect = __webpack_require__(6);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof2(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var ContentGridVanilla = function (_Component) {
	  _inherits(ContentGridVanilla, _Component);
	
	  function ContentGridVanilla(props) {
	    _classCallCheck(this, ContentGridVanilla);
	
	    var _this = _possibleConstructorReturn(this, (ContentGridVanilla.__proto__ || Object.getPrototypeOf(ContentGridVanilla)).call(this, props));
	
	    _this.getImages = function (images) {
	      try {
	        //console.log("images Obj " + JSON.stringify(imgUrlsObj));
	
	        if (images && images.length > 0) {
	          //console.log("getting images");
	          return images.map(function (image, index) {
	            //console.log("chota image: " + images.url);
	            return _react2.default.createElement("a", { href: image.url, target: "_blank" }, _react2.default.createElement("div", {
	              className: "img",
	              style: {
	                backgroundImage: "url('" + image.url + "')",
	                backgroundSize: "contain",
	                backgroundRepeat: "no-repeat",
	                border: "1px solid gainsboro",
	                maxWidth: "150px",
	                maxHeight: "75px"
	              }
	            }));
	          });
	        }
	      } catch (error) {
	        return "";
	      }
	    };
	
	    _this.getCellValue = function (strFormat, jsonValue, type) {
	      if ((typeof jsonValue === "undefined" ? "undefined" : _typeof(jsonValue)) !== "object") {
	        if (strFormat && strFormat === "numeral") {
	          return _react2.default.createElement("td", { align: "right" }, (0, _numeral2.default)(jsonValue).format("0,0.00"));
	        } else {
	          return jsonValue;
	        }
	      } else {
	        //console.log("this is an object " + JSON.stringify(jsonValue));
	        //let amt = "SGD " + numeral(props.quoteAmount).format("0,0.00");
	        if (type === "photoUpload") {
	          return _react2.default.createElement("td", null, _react2.default.createElement("div", { className: "images" }, _this.getImages(jsonValue)));
	        } else {
	          return JSON.stringify(jsonValue);
	        }
	      }
	    };
	
	    _this.getDivCellValue = function (strFormat, jsonValue, type) {
	      if ((typeof jsonValue === "undefined" ? "undefined" : _typeof(jsonValue)) !== "object") {
	        if (strFormat && strFormat === "numeral") {
	          return (0, _numeral2.default)(jsonValue).format("0,0.00");
	        } else {
	          return jsonValue;
	        }
	      } else {
	        //console.log(type + " this is an object " + JSON.stringify(jsonValue));
	        //let amt = "SGD " + numeral(props.quoteAmount).format("0,0.00");
	        if (type === "photoUpload") {
	          return _react2.default.createElement("div", { className: "images" }, _this.getImages(jsonValue));
	        } else {
	          return JSON.stringify(jsonValue);
	        }
	      }
	    };
	
	    _this.getColumns = function (jObject, tableDef) {
	      //console.log(JSON.stringify(this.state))
	      //console.log(JSON.stringify(tableDef));
	
	      return Object.keys(tableDef).map(function (key, index) {
	        //console.log(key + "=" + tableDef[key]);
	        if (key !== "searches") {
	          if (index === 0) {
	            return _react2.default.createElement("td", {
	              "data-title": tableDef[key].caption,
	              style: {
	                wordBreak: "break-word",
	                wordWrap: "break-word",
	                overflowWrap: "break-word"
	              }
	            }, _react2.default.createElement("a", {
	              href: "#",
	              onClick: function onClick() {
	                return _this.props.handleEdit(jObject.key, _this.props.tableName, jObject);
	              }
	            }, _this.getCellValue(tableDef[key].format, jObject[key], tableDef[key].type)));
	          } else {
	            return _react2.default.createElement("td", {
	              "data-title": tableDef[key].caption,
	              style: {
	                wordBreak: "break-word",
	                wordWrap: "break-word",
	                overflowWrap: "break-word"
	              }
	            }, _this.getCellValue(tableDef[key].format, jObject[key], tableDef[key].type));
	          }
	        }
	      });
	    };
	
	    _this.getDivColumns = function (jObject, tableDef) {
	      //console.log("content grid issue: " + JSON.stringify(tableDef));
	      return Object.keys(tableDef).map(function (key, index) {
	        //console.log("here is the " + key);
	        if (key !== "searches") {
	          return _react2.default.createElement("div", null, _react2.default.createElement("span", {
	            style: {
	              marginLeft: "0px",
	              color: "grey",
	              fontSize: "12px",
	              fontWeight: "bold"
	            }
	          }, tableDef[key].caption, ":"), _react2.default.createElement("span", {
	            style: {
	              wordBreak: "break-word",
	              wordWrap: "break-word",
	              overflowWrap: "break-word",
	              fontSize: "15px",
	              paddingLeft: "15px"
	            }
	          }, _this.getDivCellValue(tableDef[key].format, jObject[key], tableDef[key].type)));
	        }
	      });
	    };
	
	    _this.getHeaderRow = function (tableDef) {
	      return Object.keys(tableDef).map(function (key) {
	        if (key !== "searches" && tableDef[key]) {
	          return _react2.default.createElement("th", null, tableDef[key].caption);
	        }
	      });
	    };
	
	    _this.getRows = function (data) {
	      return data.map(function (rec) {
	        return _react2.default.createElement("tr", null, _this.getColumns(rec, _this.props.tableDef));
	      });
	    };
	
	    _this.getMobileDivs = function (data) {
	      return data.map(function (rec) {
	        return _react2.default.createElement("div", {
	          onClick: function onClick() {
	            return _this.props.handleEdit(rec.key, _this.props.tableName, rec);
	          },
	          style: {
	            borderColor: "darkgray",
	            borderWidth: "1px",
	            borderStyle: "solid",
	            borderRadius: "10px",
	            backgroundColor: "white",
	            margin: "5px",
	            padding: "5px",
	            marginBottom: "15px",
	            fontSize: "medium",
	            fontWeight: "bold",
	            boxShadow: "1px 2px #888888"
	          }
	        }, _this.getDivColumns(rec, _this.props.tableDef));
	      });
	    };
	
	    _this.state = {
	      data: {
	        path: _this.props.tableName,
	        payload: _this.props.data
	      }
	    };
	    return _this;
	  }
	
	  _createClass(ContentGridVanilla, [{
	    key: "render",
	    value: function render() {
	      if (this.props.data && this.props.data !== undefined && this.props.data.length > 0) {
	        if (_reactDeviceDetect.isMobile) {
	          // console.log("it is mobile");
	          return _react2.default.createElement("div", null, this.getMobileDivs(this.props.data));
	        } else {
	          //console.log("it is not mobile");
	          return _react2.default.createElement("div", {
	            style: {
	              scrollBehavior: "auto",
	              borderColor: "yellow",
	              borderWidth: "3px"
	            }
	          }, _react2.default.createElement("table", {
	            className: _reactDeviceDetect.isMobile ? "table table-striped table-sm" : "table table-striped table-bordered table-lg",
	            style: { tableLayout: "fixed" }
	          }, _react2.default.createElement("thead", null, _react2.default.createElement("tr", null, this.getHeaderRow(this.props.tableDef))), _react2.default.createElement("tbody", null, this.getRows(this.props.data))));
	        }
	
	        //return this.getRows(this.props.data);
	      } else {
	        //console.log("returning empty list");
	        return _react2.default.createElement("div", { style: {
	            textAlign: 'center'
	          } }, "No items to display");
	      }
	    }
	  }]);
	
	  return ContentGridVanilla;
	}(_react.Component);
	
	exports.default = ContentGridVanilla;

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(92);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _reactDeviceDetect = __webpack_require__(6);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var customStyles = {
	  control: function control(provided, state) {
	    return _extends({}, provided, {
	      width: "100%",
	      borderWidth: "0px",
	      borderBottomWidth: "0px",
	      borderRadius: "0px"
	    });
	  },
	  menu: function menu(base) {
	    return _extends({}, base, {
	      zIndex: 100
	    });
	  }
	};
	
	var SelectDropdownForGid = function (_Component) {
	  _inherits(SelectDropdownForGid, _Component);
	
	  function SelectDropdownForGid() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SelectDropdownForGid);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SelectDropdownForGid.__proto__ || Object.getPrototypeOf(SelectDropdownForGid)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      searchVal: ""
	    }, _this.handleChange = function (newValue, actionMeta) {
	      if (actionMeta.action === "clear") {
	        _this.props.stateHandler("", _this.props.stateFieldName, _this.props.isPayload, _this.props.arrayIndex);
	      } else {
	        if (newValue && newValue !== undefined) {
	          _this.props.stateHandler(newValue.value, _this.props.stateFieldName, _this.props.isPayload, _this.props.arrayIndex);
	          if (_this.props.otherFields && _this.props.otherFields.length > 0) {
	            _this.props.otherFields.map(function (item) {
	              //console.log("auto update: " + JSON.stringify(item));
	              var srcVal = newValue.fullRec[item.src];
	              if (srcVal === undefined) {
	                srcVal = "";
	              }
	              _this.props.stateHandler(srcVal, item.tgt, _this.props.isPayload, _this.props.arrayIndex);
	            });
	          }
	        }
	      }
	    }, _this.getOptions = function () {
	      var newArray = [];
	      if (!_this.props.data && _this.props.data === undefined) {
	        //console.log("Data is undefined for SelectDropdown");
	        return [];
	      }
	
	      //console.log("No of drop down records: " + this.props.data.length);
	      for (var i = 0; i < _this.props.data.length; i++) {
	        var item = _this.props.data[i];
	        //console.log(JSON.stringify(this.props.filter));
	        if (_this.props.filter && _this.props.filter !== undefined && _this.props.filter.fieldVal && _this.props.filter.fieldVal !== "") {
	          // console.log(
	          //   "fieldName: " +
	          //     this.props.filter.fieldName +
	          //     "rec value: " +
	          //     item[this.props.filter.fieldName] +
	          //     "filter fieldVal: " +
	          //     this.props.filter.fieldVal
	          // );
	          if (item[_this.props.filter.fieldName] === _this.props.filter.fieldVal) {
	            newArray.push({
	              value: item[_this.props.fieldName],
	              label: item[_this.props.fieldName],
	              fullRec: item
	            });
	          }
	        } else {
	          newArray.push({
	            value: item[_this.props.fieldName],
	            label: item[_this.props.fieldName],
	            fullRec: item
	          });
	        }
	      }
	
	      return newArray;
	    }, _this.getValue = function () {
	      return { value: _this.props.value, label: _this.props.value };
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SelectDropdownForGid, [{
	    key: "render",
	    value: function render() {
	      var _React$createElement;
	
	      return _react2.default.createElement(_reactSelect2.default, (_React$createElement = {
	        isClearable: true,
	        onChange: this.handleChange,
	        options: this.getOptions(),
	        label: this.props.label,
	        placeholder: this.props.placeholder,
	        value: this.getValue(),
	        styles: customStyles,
	        defaultValue: "",
	        theme: function theme(_theme) {
	          return _extends({}, _theme, {
	            borderRadius: 0,
	            colors: _extends({}, _theme.colors, {
	              primary: "blue"
	            }),
	            borderBottomWidth: "0px",
	            borderBottomColor: "blue"
	          });
	        }
	      }, _defineProperty(_React$createElement, "placeholder", this.props.title), _defineProperty(_React$createElement, "isDisabled", this.props.disabled), _React$createElement));
	    }
	
	    // handleInputChange = value => {
	    //   console.log("yummy" + value);
	    // };
	    // handleChange = (value, option, complete) => {
	    //   if (option || complete) return;
	    //   console.log("handleChange " + JSON.stringify(value));
	    //   this.props.stateHandler(value.value, "newVal", false);
	    // };
	
	  }]);
	
	  return SelectDropdownForGid;
	}(_react.Component);
	
	exports.default = SelectDropdownForGid;

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.localState = exports.autoSignIn = exports.useLocal = exports.tempTesting = undefined;
	
	var _localState = __webpack_require__(351);
	
	var tempTesting = exports.tempTesting = false;
	var useLocal = exports.useLocal = false;
	var autoSignIn = exports.autoSignIn = true;
	
	/*
	
	Dev:
	    SUPERADMIN
	        04065662
	        ahmed_fayyaz@outlook.com
	        devpass
	
	        94562455
	        kabir@bcs.com
	        devpass
	
	    DEVSTORE
	        00002450
	        supp1@bcs.com
	        devpass
	
	        0002451
	        supp2@bcs.com
	        devpass
	
	
	    WORKER
	        98761234
	
	Prod:
	    SUPERADMIN
	        04065662
	        ahmed_fayyaz@outlook.com
	        p123456
	
	        94562455
	        kabir@bcs.com
	        p123456
	
	    DEVSTORE
	        00002450
	        supp1@bcs.com
	        p123456
	
	        0002451
	        supp2@bcs.com
	        p123456
	
	
	    WORKER
	        98761234
	
	*/
	
	var targetTest = _localState.localState0.devWorker;
	var localState = exports.localState = targetTest;

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "between", {
	  enumerable: true,
	  get: function get() {
	    return _utils.between;
	  }
	});
	Object.defineProperty(exports, "callIfDefined", {
	  enumerable: true,
	  get: function get() {
	    return _utils.callIfDefined;
	  }
	});
	exports.max = exports.min = void 0;
	
	var _utils = __webpack_require__(119);
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	var isValidNumber = function isValidNumber(a) {
	  return typeof a === 'number' && !isNaN(a);
	};
	
	var min = function min() {
	  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  return Math.min.apply(Math, _toConsumableArray(args.filter(isValidNumber)));
	};
	
	exports.min = min;
	
	var max = function max() {
	  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    args[_key2] = arguments[_key2];
	  }
	
	  return Math.max.apply(Math, _toConsumableArray(args.filter(isValidNumber)));
	};
	
	exports.max = max;

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.routes = exports.route = exports.components = exports.component = exports.history = undefined;
	exports.falsy = falsy;
	
	var _propTypes = __webpack_require__(1);
	
	function falsy(props, propName, componentName) {
	  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
	}
	
	var history = exports.history = (0, _propTypes.shape)({
	  listen: _propTypes.func.isRequired,
	  push: _propTypes.func.isRequired,
	  replace: _propTypes.func.isRequired,
	  go: _propTypes.func.isRequired,
	  goBack: _propTypes.func.isRequired,
	  goForward: _propTypes.func.isRequired
	});
	
	var component = exports.component = _propTypes.elementType;
	var components = exports.components = (0, _propTypes.oneOfType)([component, _propTypes.object]);
	var route = exports.route = (0, _propTypes.oneOfType)([_propTypes.object, _propTypes.element]);
	var routes = exports.routes = (0, _propTypes.oneOfType)([route, (0, _propTypes.arrayOf)(route)]);

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.recalculateAllAutoPosition = exports.AutoPosition = undefined;
	
	var _AutoPosition = __webpack_require__(542);
	
	var _AutoPosition2 = _interopRequireDefault(_AutoPosition);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.AutoPosition = _AutoPosition2.default;
	exports.recalculateAllAutoPosition = _AutoPosition.recalculateAllAutoPosition;

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Tooltip = undefined;
	
	var _withTooltip = __webpack_require__(885);
	
	Object.keys(_withTooltip).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _withTooltip[key];
	    }
	  });
	});
	
	var _withContentTooltip = __webpack_require__(884);
	
	Object.keys(_withContentTooltip).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _withContentTooltip[key];
	    }
	  });
	});
	
	var _Tooltip = __webpack_require__(233);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Tooltip = _Tooltip2.default;

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(370);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(20)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../css-loader/index.js!./blur.css", function() {
				var newContent = require("!!../../../css-loader/index.js!./blur.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 68 */
/***/ (function(module, exports) {

	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	module.exports = _classCallCheck;

/***/ }),
/* 69 */
/***/ (function(module, exports) {

	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];
	    descriptor.enumerable = descriptor.enumerable || false;
	    descriptor.configurable = true;
	    if ("value" in descriptor) descriptor.writable = true;
	    Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	  if (staticProps) _defineProperties(Constructor, staticProps);
	  return Constructor;
	}
	
	module.exports = _createClass;

/***/ }),
/* 70 */
/***/ (function(module, exports) {

	function _getPrototypeOf(o) {
	  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };
	  return _getPrototypeOf(o);
	}
	
	module.exports = _getPrototypeOf;

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	var setPrototypeOf = __webpack_require__(256);
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) setPrototypeOf(subClass, superClass);
	}
	
	module.exports = _inherits;

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	var objectWithoutPropertiesLoose = __webpack_require__(138);
	
	function _objectWithoutProperties(source, excluded) {
	  if (source == null) return {};
	  var target = objectWithoutPropertiesLoose(source, excluded);
	  var key, i;
	
	  if (Object.getOwnPropertySymbols) {
	    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
	
	    for (i = 0; i < sourceSymbolKeys.length; i++) {
	      key = sourceSymbolKeys[i];
	      if (excluded.indexOf(key) >= 0) continue;
	      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
	      target[key] = source[key];
	    }
	  }
	
	  return target;
	}
	
	module.exports = _objectWithoutProperties;

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	var _typeof = __webpack_require__(74);
	
	var assertThisInitialized = __webpack_require__(55);
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }
	
	  return assertThisInitialized(self);
	}
	
	module.exports = _possibleConstructorReturn;

/***/ }),
/* 74 */
/***/ (function(module, exports) {

	function _typeof2(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }
	
	function _typeof(obj) {
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    module.exports = _typeof = function _typeof(obj) {
	      return _typeof2(obj);
	    };
	  } else {
	    module.exports = _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
	    };
	  }
	
	  return _typeof(obj);
	}
	
	module.exports = _typeof;

/***/ }),
/* 75 */
[937, 143],
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactackle = __webpack_require__(5);
	
	var _reactDeviceDetect = __webpack_require__(6);
	
	__webpack_require__(246);
	
	var _lodash = __webpack_require__(22);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _recompose = __webpack_require__(11);
	
	var _Firebase = __webpack_require__(10);
	
	var _reactRedux = __webpack_require__(9);
	
	var _uuid = __webpack_require__(249);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _toConsumableArray(arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
	      arr2[i] = arr[i];
	    }return arr2;
	  } else {
	    return Array.from(arr);
	  }
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var PhotoUploadPass = function (_Component) {
	  _inherits(PhotoUploadPass, _Component);
	
	  function PhotoUploadPass() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PhotoUploadPass);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PhotoUploadPass.__proto__ || Object.getPrototypeOf(PhotoUploadPass)).call.apply(_ref, [this].concat(args))), _this), _this.getImages = function () {
	      if (_this.props.images && _this.props.images.length > 0) {
	        // console.log(
	        //   "babu sending normal image: " + JSON.stringify(this.props.images)
	        // );
	        return _this.props.images.map(function (imgData, index) {
	          // console.log(
	          //   "babu chota image: " + imgData.url + " " + JSON.stringify(imgData)
	          // );
	          if (imgData.action !== "REMOVE" && imgData.b64 !== "" && imgData.b64.length > 0) {
	            return _react2.default.createElement("div", {
	              className: "img",
	              style: {
	                backgroundImage: imgData.b64 !== "" ? "url(" + imgData.b64 + ")" : "",
	                backgroundSize: "contain",
	                backgroundRepeat: "no-repeat",
	                maxWidth: "150px",
	                border: "1px solid gainsboro"
	              },
	              onClick: function onClick() {
	                _this.props.stateChangeHandler([], _this.props.fieldName, false);
	              }
	            }, _react2.default.createElement("span", {
	              style: {
	                position: "absolute",
	                top: 0,
	                right: 0,
	                color: "red"
	              }
	            }, _react2.default.createElement("i", {
	              className: "fa fa-times-circle fa-lg",
	              style: { backgroundColor: "white" }
	            })));
	          } else {
	            console.log("babu didnt send back anything");
	          }
	        });
	      }
	    }, _this.uploadImage = function (evtFiles) {
	      try {
	        //console.log("triggering inside uploadImage function");
	        var imageName = (0, _uuid.v1)() + ".jpg";
	        var Compress = __webpack_require__(81);
	        var compress = new Compress();
	        var files = [].concat(_toConsumableArray(evtFiles));
	        compress.compress(files, {
	          size: 1, // the max size in MB, defaults to 2MB
	          quality: 1, // the quality of the image, max is 1,
	          maxWidth: 800, // the max width of the output image, defaults to 1920px
	          maxHeight: 800, // the max height of the output image, defaults to 1920px
	          resize: true // defaults to true, set false if you do not want to resize the image width and height
	        }).then(function (data) {
	          //console.log("after conversion: " + JSON.stringify(data));
	          var imgArray = [];
	          var stateImgArray = [];
	
	          stateImgArray.push({
	            status: "UPLOADING...",
	            imageName: imageName,
	            url: "",
	            b64: "data:image/png;base64," + data[0].data
	          });
	
	          _this.props.stateChangeHandler(stateImgArray, _this.props.fieldName, false);
	          if (stateImgArray !== undefined && stateImgArray !== "") {
	            if (_this.props.nextStage && _this.props.nextStage !== "") {
	              _this.props.stateChangeHandler(_this.props.nextStage, "stage", false);
	              _this.props.setScroll(true);
	            }
	          }
	        });
	      } catch (err) {
	        alert(err);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(PhotoUploadPass, [{
	    key: "render",
	    value: function render() {
	      var _ref2,
	          _this2 = this;
	
	      return _react2.default.createElement("div", {
	        style: {
	          margin: "5px",
	          marginBottom: "15px",
	          borderRadius: "5px",
	          backgroundColor: "white"
	        }
	      }, _react2.default.createElement("table", {
	        className: "table",
	        style: {
	          marginBottom: "-10px"
	        }
	      }, _react2.default.createElement("tbody", null, _react2.default.createElement("tr", null, _react2.default.createElement("td", { style: { width: "100px" } }, !this.props.disabled && _react2.default.createElement("label", {
	        "for": "uploader" + this.props.fieldName,
	        style: (_ref2 = {
	          padding: "1px",
	          textAlign: "center",
	          border: "1px solid gainsboro",
	          borderRadius: _reactDeviceDetect.isMobile ? "5px" : "0px",
	          backgroundColor: "rgb(30, 101, 144)",
	          margin: "5px"
	        }, _defineProperty(_ref2, "padding", "6px"), _defineProperty(_ref2, "fontWeight", "bold"), _defineProperty(_ref2, "color", "white"), _defineProperty(_ref2, "fontSize", "12px"), _ref2)
	      }, _react2.default.createElement("div", null, _react2.default.createElement("i", { className: "fa fa-plus" }), " UPLOAD"))), _react2.default.createElement("td", { style: { textAlign: "center" } }, !this.props.disabled && this.props.images && this.props.images.length > 0 && _react2.default.createElement("div", { className: "images" }, this.getImages()), !this.props.disabled && (!this.props.images || !this.props.images.length > 0) && _react2.default.createElement("div", null, _react2.default.createElement("div", null, this.props.title1), _react2.default.createElement("div", {
	        style: {
	          textAlign: "center"
	        }
	      }, this.props.title2)))))), _react2.default.createElement("input", {
	        type: "file",
	        accept: "image/*",
	        id: "uploader" + this.props.fieldName,
	        onChange: function onChange(evt) {
	          console.log("clicked");
	          //console.log("triggering main function");
	          event.preventDefault();
	
	          if (evt.target.files[0]) {
	            _this2.uploadImage(evt.target.files);
	          } else {
	            console.log("gotcha");
	          }
	        },
	        style: {
	          visibility: "hidden"
	        }
	      }));
	    }
	  }]);
	
	  return PhotoUploadPass;
	}(_react.Component);
	
	exports.default = (0, _recompose.compose)((0, _reactRedux.connect)(null, null), _Firebase.withFirebase)(PhotoUploadPass);

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _recompose = __webpack_require__(11);
	
	var _Firebase = __webpack_require__(10);
	
	var _addAudits = __webpack_require__(25);
	
	var _reactackle = __webpack_require__(5);
	
	var _actions = __webpack_require__(13);
	
	var _getMenuList = __webpack_require__(34);
	
	var _reactDeviceDetect = __webpack_require__(6);
	
	var _checkBeforeSave = __webpack_require__(78);
	
	var _checkBeforeSave2 = _interopRequireDefault(_checkBeforeSave);
	
	var _getInputField = __webpack_require__(18);
	
	var _getInputField2 = _interopRequireDefault(_getInputField);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var SingleRecord = function (_Component) {
	  _inherits(SingleRecord, _Component);
	
	  function SingleRecord() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SingleRecord);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SingleRecord.__proto__ || Object.getPrototypeOf(SingleRecord)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      data: {
	        path: _this.props.path,
	        payload: _extends({}, _this.props.selectedRecord),
	        userEmail: _this.props.userProfile.userEmail
	      },
	      showForm: true
	    }, _this.stateChangeHandler = function (val, id, isPayload) {
	      //console.log("val: " + val + " id: " + id + " isPayload: " + isPayload);
	      var tmpState = {};
	      tmpState[id] = val;
	
	      if (isPayload) {
	        _this.setState(function (prevState) {
	          if (prevState && prevState.data.payload !== null) {
	            return _extends({}, prevState, {
	              data: _extends({}, prevState.data, {
	                payload: _extends({}, prevState.data.payload, tmpState)
	              })
	            });
	          } else {
	            return _extends({}, prevState, {
	              data: {
	                path: prevState.data.path,
	                payload: _extends({}, tmpState)
	              }
	            });
	          }
	        }, function () {
	          _this.procCalcFields(id);
	        });
	      } else {
	        _this.setState(function (prevState) {
	          return _extends({}, prevState, tmpState);
	        }, function () {
	          _this.procCalcFields(id);
	        });
	      }
	    }, _this.procCalcFields = function (id) {
	      //console.log("Checking ID: " + id);
	      var allFields = _this.props.ogTableDef[_this.props.path];
	      for (var key in allFields) {
	        var fldDef = allFields[key];
	        if (fldDef.type === "calculation" && id === fldDef.triggerField) {
	          //console.log("id matched: " + id + " " + JSON.stringify(fldDef));
	          if (fldDef.calcType === "subFieldsSum") {
	            if (fldDef.subFieldOperation === "SUM") {
	              _this.getSubGridSum(fldDef.name, fldDef.subGridName, fldDef.subGridField);
	            } else {}
	          } else if (fldDef.calcType === "mainFieldCalc") {
	            _this.getCalcdField(fldDef.name, fldDef.formula);
	          }
	        }
	      }
	    }, _this.getValue = function (stateVal, operand) {
	      var res = 0.0;
	      if (stateVal !== undefined) {
	        if (!isNaN(stateVal)) {
	          res = parseFloat(stateVal);
	        }
	      } else {
	        if (!isNaN(operand)) {
	          res = parseFloat(operand);
	        }
	      }
	      return res;
	    }, _this.getCalcdField = function (calcFieldName, calcRules) {
	      //console.log(calcFieldName + " " + JSON.stringify(calcRules));
	      var result = 0.0;
	
	      //currently only one rule will work
	      var currRule = calcRules[0];
	      if (currRule && currRule !== undefined) {
	        var val1 = _this.getValue(_this.state.data.payload[currRule.operand1], currRule.operand1);
	        var val2 = _this.getValue(_this.state.data.payload[currRule.operand2], currRule.operand2);
	        var op = currRule.operation;
	        if (op && !isNaN(val1) && !isNaN(val2)) {
	          if (op === "+") {
	            result = val1 + val2;
	          } else if (op === "-") {
	            result = val1 - val2;
	          } else if (op === "*") {
	            result = val1 * val2;
	          } else if (op === "/") {
	            result = val1 / val2;
	          }
	        }
	        // console.log(
	        //   "val1:" + val1 + " val2:" + val2 + " op:" + op + " result:" + result
	        // );
	        if (result !== undefined && !isNaN(result)) {
	          _this.stateChangeHandler(result.toFixed(2), calcFieldName, true);
	        }
	      }
	    }, _this.getSubGridSum = function (calcFieldName, subGridName, subFieldToProcess) {
	      var items = _this.state.data.payload[subGridName];
	
	      if (items && items !== undefined && items.length > 0) {
	        var invSum = items.reduce(function (sum, obj) {
	          //console.log(obj[subFieldToProcess]);
	          if (obj[subFieldToProcess] && !isNaN(obj[subFieldToProcess])) {
	            return sum + parseFloat(obj[subFieldToProcess]);
	          } else {
	            return sum;
	          }
	        }, 0);
	        invSum = invSum.toFixed(2);
	        _this.stateChangeHandler(invSum, calcFieldName, true);
	      }
	    }, _this.getField = function (fieldName, disabled) {
	      return (0, _getInputField2.default)(fieldName, _this.props.path, _this.state.data, _this.stateChangeHandler, disabled, _this.props.ogTableDef, _this.props.db, _reactDeviceDetect.isMobile);
	    }, _this.getFields = function () {
	      // console.log(
	      //   this.props.path +
	      //     " = " +
	      //     JSON.stringify(this.props.ogTableDef[this.props.path])
	      // );
	      return Object.keys(_this.props.ogTableDef[_this.props.path]).map(function (fldKey) {
	        return _this.getField(fldKey);
	      });
	    }, _this.uploadPhotos = function (dbKey) {
	      var tableDef = _this.props.ogTableDef[_this.props.path];
	      var tgtArray = [];
	      Object.keys(tableDef).map(function (fldKey) {
	        var fldDef = tableDef[fldKey];
	        if (fldDef.type == "photoUpload") {
	          var srcArray = _this.state[fldKey];
	          if (srcArray && srcArray.length > 0) {
	            for (var i = 0; i < srcArray.length; i++) {
	              var photoSource = srcArray[i];
	              if (photoSource.action === "") {} else if (photoSource.action === "ADD") {
	                //some action to add photo
	
	                _this.props.onUploadPhoto(_this.props.firebase, photoSource.imageName, "images", photoSource.blob, dbKey, _this.props.path);
	              } else if (photoSource.action === "REMOVE") {
	                //console.log(JSON.stringify(photoSource));
	                _this.props.onDeletePhoto(_this.props.firebase, photoSource.imageName, "images", dbKey, _this.props.path);
	                //some action delete photo
	              }
	            }
	          }
	        }
	      });
	    }, _this.saveHandler = function () {
	      console.log("before");
	      //console.log(JSON.stringify(this.props.ogTableDef[this.props.path]));
	
	      console.log("after");
	      _this.stateChangeHandler(_this.props.userEmail, "author", true);
	      _this.stateChangeHandler(false, "showForm", false);
	
	      var cloudPath = "";
	      if (_this.state.data.payload && _this.state.data.payload.key && _this.state.data.payload.key !== "") {
	        cloudPath = _this.props.path + "/" + _this.state.data.payload.key;
	        Promise.all([(0, _addAudits.addAudit)(_this.stateChangeHandler, _this.props.firebase.auth.currentUser.phoneNumber)]).then(function (res) {
	          _this.props.firebase.db.ref("/" + cloudPath).once("value").then(function (snap) {
	            return snap.ref.set(_this.state.data.payload);
	          }).catch(function (err) {
	            console.log(err);
	            return console.log("some error: " + err);
	          }).then(function (err) {
	            _this.uploadPhotos(_this.state.data.payload.key);
	            _this.props.genNotification(_this.state.data.payload, "update");
	            _this.props.handleEditCancel();
	          });
	        });
	      } else {
	        cloudPath = _this.props.path;
	        Promise.all([(0, _addAudits.addAudit)(_this.stateChangeHandler, _this.props.firebase.auth.currentUser.phoneNumber)
	        //get new ID
	        ]).then(function (res) {
	          var newInv = _this.props.firebase.db.ref("/" + cloudPath).push();
	          newInv.set(_this.state.data.payload).catch(function (err) {
	            console.log(err);
	            return console.log("some error: " + err);
	          }).then(function (err) {
	            //console.log(newInv.key);
	            _this.uploadPhotos(newInv.key);
	            _this.props.genNotification(_this.state.data.payload, "create");
	            _this.props.handleEditCancel();
	          });
	        });
	
	        //this.props.handleEditCancel();
	      }
	    }, _this.getLoader = function () {
	      return _react2.default.createElement(_reactackle.CardContent, null, _react2.default.createElement(_reactackle.CircleProgress, { indeterminate: true, subtitle: "Saving..." }));
	    }, _this.getTopHeader = function () {
	      return _react2.default.createElement("div", null, _react2.default.createElement(_reactackle.Card, null, _react2.default.createElement(_reactackle.CardAreaMain, null, !_reactDeviceDetect.isMobile && _react2.default.createElement(_reactackle.CardContent, null, _react2.default.createElement("div", null, _react2.default.createElement("h1", null, (0, _getMenuList.getCaption)(_this.props.path, _this.props.db["listOfTables"])))), _react2.default.createElement(_reactackle.CardActions, null, _react2.default.createElement(_reactackle.CardActionsSupplemental, null, _this.props.operationType !== "add" && _react2.default.createElement(_reactackle.Button, {
	        text: "DELETE",
	        onPress: function onPress(e) {
	          if (_this.state.data.payload.key && _this.state.data.payload.key !== "") {
	            window.confirm("Are you sure you wish to delete this item?") && _this.props.handleDelete(_this.state.data.payload.key, _this.props.path, _this.state.data.payload);
	          }
	        },
	        colorScheme: "warning",
	        disabled: !_this.state.showForm
	      }), _react2.default.createElement(_reactackle.Button, {
	        text: "SAVE",
	        onPress: function onPress() {
	          return _this.saveHandler();
	        },
	        colorScheme: "primary",
	        disabled: !_this.state.showForm || (0, _checkBeforeSave2.default)(_this.props.path, _this.state.data.payload, _this.props.ogTableDef)
	      }), _react2.default.createElement(_reactackle.Button, {
	        text: "CANCEL",
	        onPress: function onPress() {
	          return _this.props.handleEditCancel();
	        },
	        colorScheme: "primary",
	        disabled: !_this.state.showForm
	      }))))));
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  //single method that work for all fields
	  //takes incoming id of the field and then adds field data to state
	
	
	  _createClass(SingleRecord, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement("div", {
	        style: {
	          minHeight: 800,
	          marginTop: "60px"
	        }
	      }, _react2.default.createElement("div", null, this.getTopHeader()), _reactDeviceDetect.isMobile && _react2.default.createElement("div", null, this.state.showForm && this.getFields(), !this.state.showForm && this.getLoader()), !_reactDeviceDetect.isMobile && _react2.default.createElement(_reactackle.Card, null, _react2.default.createElement(_reactackle.CardAreaMain, { style: { padding: "0px" } }, _react2.default.createElement(_reactackle.CardContent, { style: { pading: "0px" } }, this.state.showForm && this.getFields(), !this.state.showForm && this.getLoader()))));
	    }
	  }]);
	
	  return SingleRecord;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    userEmail: state.db.currentUser && state.db.currentUser.userEmail ? state.db.currentUser.userEmail : "",
	    currUser: state.db.currentUser,
	    isSuperAdmin: state.ui.isThisSuperAdmin,
	    isAdmin: state.ui.isThisAdmin,
	    userProfile: state.db.userProfile,
	    selectedRecord: state.db["selected" + state.ui.tableName],
	    db: state.db,
	    createNewRec: state.ui.operationType === "add",
	    operationType: state.ui.operationType
	  };
	}
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    onAddRecord: function onAddRecord(data) {
	      return dispatch((0, _actions.actionAddArray2Redux)(data));
	    },
	    onSelectRecord: function onSelectRecord(params) {
	      return dispatch((0, _actions.selectARecord)(params));
	    },
	    onUploadPhoto: function onUploadPhoto(firebase, photoName, photoPath, blob, dbKey, cloudPath) {
	      return dispatch((0, _actions.uploadPhoto)(firebase, photoName, photoPath, blob, dbKey, cloudPath));
	    },
	    onDeletePhoto: function onDeletePhoto(firebase, photoName, photoPath, dbKey, cloudPath) {
	      return dispatch((0, _actions.deletePhoto)(firebase, photoName, photoPath, dbKey, cloudPath));
	    }
	  };
	};
	
	exports.default = (0, _recompose.compose)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _Firebase.withFirebase)(SingleRecord);

/***/ }),
/* 78 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var checkBeforeSave = function checkBeforeSave(tableName, payload, ogTableDef) {
	  var tempFlag = false;
	  var tFields = ogTableDef[tableName];
	  //console.log("checking enablement: " + JSON.stringify(tFields));
	  for (var tFkey in tFields) {
	    // console.log(
	    //   "tFkey: " + tFkey + " isMust flag is: " + tFields[tFkey].isMust
	    // );
	    if (tFields[tFkey].isMust && tFields[tFkey].isMust === "true" && (!payload[tFkey] || payload[tFkey] === "")) {
	      tempFlag = true;
	    }
	  }
	
	  //console.log("returning: " + tempFlag);
	
	  return tempFlag;
	};
	
	exports.default = checkBeforeSave;

/***/ }),
/* 79 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	exports.logger = logger;
	var getProjID = exports.getProjID = function getProjID() {
	  var unique_ID = getMsSinceMidnight(new Date());
	  var dtStamp = new Date().toISOString().split("T")[0];
	  return dtStamp + "-" + unique_ID;
	};
	
	function getMsSinceMidnight(d) {
	  var e = new Date(d);
	  return d - e.setHours(0, 0, 0, 0);
	}
	
	//this function gets a standard json bundle with key inside and then
	//changes that to firebase type json, where key becomes an object Id.
	//This function takes in a JSON object, but returns stringified version of correct json
	//that can be used to do a PATCH in firebase
	var convert2FirebaseJson = exports.convert2FirebaseJson = function convert2FirebaseJson(projectBundle) {
	  var fbJSON = {};
	  var key = projectBundle.key;
	  delete projectBundle[key];
	  fbJSON[key] = _extends({}, projectBundle);
	  return JSON.stringify(fbJSON);
	};
	
	//this function does logging.
	//Three levels of loggin
	//FULL: If set to full, all types of logs will be generated, this
	//      include state info, such as JSON objects
	//DEBUG:If set to DEBUG, all info will logged except state info
	//BASIC:If set to BASIC, only caugh exception will be logged
	//this function probably later on can be switched to
	
	function logger(strLevel, methodName, logMessage) {
	  //TODO
	  //This const here to be take out or made dynamic
	  //to check if running in dev then do logging else do not
	  //do logging
	
	  var DEBUG = "DEBUG";
	  var FULL = "FULL";
	  var BASIC = "BASIC";
	  var settingLogLevel = "DEBUG";
	
	  switch (settingLogLevel) {
	    case FULL:
	      {
	        console.log(strLevel + " " + methodName + " " + logMessage);
	      }
	      return;
	    case DEBUG:
	      {
	        if (strLevel === "DEBUG" || strLevel === "BASIC") {
	          console.log(strLevel + " " + methodName + " " + logMessage);
	        }
	      }
	      return;
	    case BASIC:
	      {
	        if (strLevel === "BASIC") {
	          console.log("!!EXCEPTION!! " + strLevel + " " + methodName + " " + logMessage);
	        }
	      }
	      return;
	    default:
	      if (strLevel === "BASIC") {
	        console.log("!!EXCEPTION!! " + strLevel + " " + methodName + " " + logMessage);
	      }
	  }
	}

/***/ }),
/* 80 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var ADD_PROJECT = exports.ADD_PROJECT = "ADD_PROJECT";
	var SELECT_PROJECT = exports.SELECT_PROJECT = "SELECT_PROJECT";
	var UPDATE_PROJECT = exports.UPDATE_PROJECT = "UPDATE_PROJECT";
	var CLEAR_ALL_PROJECTS = exports.CLEAR_ALL_PROJECTS = "CLEAR_ALL_PROJECTS";
	
	var UI_START_LOADING = exports.UI_START_LOADING = "UI_START_LOADING";
	var UI_STOP_LOADING = exports.UI_STOP_LOADING = "UI_STOP_LOADING";
	
	var ADD_PHOTO = exports.ADD_PHOTO = "ADD_PHOTO";
	var UPLOAD_PHOTO = exports.UPLOAD_PHOTO = "UPLOAD_PHOTO";
	var CLEAR_PHOTOS = exports.CLEAR_PHOTOS = "CLEAR_PHOTOS";
	
	var SHOW_BAR = exports.SHOW_BAR = "SHOW_BAR";
	var HIDE_BAR = exports.HIDE_BAR = "HIDE_BAR";
	
	var EDIT_MODE_ON = exports.EDIT_MODE_ON = "EDIT_MODE_ON";
	var EDIT_MODE_OFF = exports.EDIT_MODE_OFF = "EDIT_MODE_OFF";
	
	var SET_UI_FLAG = exports.SET_UI_FLAG = "SET_UI_FLAG";
	
	var LIST_PULL_REFRESHING_ON = exports.LIST_PULL_REFRESHING_ON = "LIST_PULL_REFRESHING_ON";
	var LIST_PULL_REFRESHING_OFF = exports.LIST_PULL_REFRESHING_OFF = "LIST_PULL_REFRESHING_OFF";
	
	var SELECT_ID_TO_VIEW_PHOTOS = exports.SELECT_ID_TO_VIEW_PHOTOS = "SELECT_ID_TO_VIEW_PHOTOS";
	
	var ADD_RECORD = exports.ADD_RECORD = "ADD_RECORD";
	var ADD_ARRAY = exports.ADD_ARRAY = "ADD_ARRAY";
	var ADD_SINGLE_RECORD = exports.ADD_SINGLE_RECORD = "ADD_SINGLE_RECORD";
	var DELETE_RECORD = exports.DELETE_RECORD = "DELETE_RECORD";
	var SELECT_RECORD = exports.SELECT_RECORD = "SELECT_RECORD";
	var INIT_SELECT_RECORD = exports.INIT_SELECT_RECORD = "INIT_SELECT_RECORD";
	var UPDATE_RECORD = exports.UPDATE_RECORD = "UPDATE_RECORD";
	var CLEAR_ALL_RECORDS = exports.CLEAR_ALL_RECORDS = "CLEAR_ALL_RECORDS";
	
	var TRY_AUTH = exports.TRY_AUTH = "TRY_AUTH";
	var AUTH_SET_TOKEN = exports.AUTH_SET_TOKEN = "AUTH_SET_TOKEN";
	var AUTH_REMOVE_TOKEN = exports.AUTH_REMOVE_TOKEN = "AUTH_REMOVE_TOKEN";
	
	var RESET_STORE = exports.RESET_STORE = "RESET_STORE";
	
	// / FIREBASE AUTH ACTIONS
	var LOGIN_WITH_PROVIDER_FIREBASE = exports.LOGIN_WITH_PROVIDER_FIREBASE = "LOGIN_WITH_PROVIDER_FIREBASE";
	var REGISTER_FIREBASE_USER = exports.REGISTER_FIREBASE_USER = "REGISTER_FIREBASE_USER";
	var LOGIN_FIREBASE_USER = exports.LOGIN_FIREBASE_USER = "LOGIN_FIREBASE_USER";
	var FETCH_FIREBASE_USER = exports.FETCH_FIREBASE_USER = "FETCH_FIREBASE_USER";
	var UPDATE_FIREBASE_USER = exports.UPDATE_FIREBASE_USER = "UPDATE_FIREBASE_USER";
	var CHANGE_FIREBASE_USER_PASSWORD = exports.CHANGE_FIREBASE_USER_PASSWORD = "CHANGE_FIREBASE_USER_PASSWORD";
	var FIREBASE_PASSWORD_RESET_EMAIL = exports.FIREBASE_PASSWORD_RESET_EMAIL = "FIREBASE_PASSWORD_RESET_EMAIL";
	var LOGOUT_FIREBASE_USER = exports.LOGOUT_FIREBASE_USER = "LOGOUT_FIREBASE_USER";

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define([],e):"object"==typeof exports?exports.Compress=e():t.Compress=e()}(this,function(){return function(t){function e(i){if(n[i])return n[i].exports;var a=n[i]={exports:{},id:i,loaded:!1};return t[i].call(a.exports,a,a.exports,e),a.loaded=!0,a.exports}var n={};return e.m=t,e.c=n,e.p="",e(0)}([function(t,e,n){var i,a,r;!function(o,u){a=[t,n(1),n(2),n(3),n(4),n(5),n(6)],i=u,r="function"==typeof i?i.apply(e,a):i,!(void 0!==r&&(t.exports=r))}(this,function(t,e,n,i,a,r,o){"use strict";function u(t){return t&&t.__esModule?t:{default:t}}function s(t){if(Array.isArray(t)){for(var e=0,n=Array(t.length);e<t.length;e++)n[e]=t[e];return n}return Array.from(t)}function f(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}var d=u(e),l=u(n),c=u(i),h=u(a),v=u(r),p=u(o),g=function(){function t(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}return function(e,n,i){return n&&t(e.prototype,n),i&&t(e,i),e}}(),w=function(){function t(){f(this,t)}return g(t,[{key:"attach",value:function(t,e){var n=this;return new Promise(function(i,a){var r=document.querySelector(t);r.setAttribute("accept","image/*"),r.addEventListener("change",function(t){var a=n.compress([].concat(s(t.target.files)),e);i(a)},!1)})}},{key:"compress",value:function(t,e){function n(t,e){var n=new v.default(e);return n.start=window.performance.now(),n.alt=t.name,n.ext=t.type,n.startSize=t.size,p.default.orientation(t).then(function(e){return n.orientation=e,c.default.load(t)}).then(i(n))}function i(t){return function(e){return h.default.load(e).then(function(e){if(t.startWidth=e.naturalWidth,t.startHeight=e.naturalHeight,t.resize){var n=h.default.resize(t.maxWidth,t.maxHeight)(e.naturalWidth,e.naturalHeight),i=n.width,a=n.height;t.endWidth=i,t.endHeight=a}else t.endWidth=e.naturalWidth,t.endHeight=e.naturalHeight;return l.default.imageToCanvas(t.endWidth,t.endHeight,t.orientation)(e)}).then(function(e){return t.iterations=1,t.base64prefix=d.default.prefix(t.ext),a(e,t.startSize,t.quality,t.size,t.minQuality,t.iterations)}).then(function(e){return t.finalSize=d.default.size(e),d.default.data(e)}).then(function(e){t.end=window.performance.now();var n=t.end-t.start;return{data:e,prefix:t.base64prefix,elapsedTimeInSeconds:n/1e3,alt:t.alt,initialSizeInMb:l.default.size(t.startSize).MB,endSizeInMb:l.default.size(t.finalSize).MB,ext:t.ext,quality:t.quality,endWidthInPx:t.endWidth,endHeightInPx:t.endHeight,initialWidthInPx:t.startWidth,initialHeightInPx:t.startHeight,sizeReducedInPercent:(t.startSize-t.finalSize)/t.startSize*100,iterations:t.iterations}})}}function a(t,e){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:1,i=arguments[3],r=arguments.length>4&&void 0!==arguments[4]?arguments[4]:1,o=arguments[5],u=l.default.canvasToBase64(t,n),s=d.default.size(u);return o+=1,s>i?a(t,s,n-.1,i,r,o):n>r?a(t,s,n-.1,i,r,o):n<.5?u:u}return Promise.all(t.map(function(t){return n(t,e)}))}}],[{key:"convertBase64ToFile",value:function(t,e){return l.default.base64ToFile(t,e)}}]),t}();t.exports=w})},function(t,e,n){var i,a,r;!function(n,o){a=[e],i=o,r="function"==typeof i?i.apply(e,a):i,!(void 0!==r&&(t.exports=r))}(this,function(t){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var e=function(t){var e=t.replace(/^data:image\/\w+;base64,/,"").length;return(e-814)/1.37},n=function(t){return t.split(";")[0].match(/jpeg|png|gif/)[0]},i=function(t){return t.replace(/^data:image\/\w+;base64,/,"")},a=function(t){return"data:"+t+";base64,"};t.default={size:e,mime:n,data:i,prefix:a}})},function(t,e,n){var i,a,r;!function(n,o){a=[e],i=o,r="function"==typeof i?i.apply(e,a):i,!(void 0!==r&&(t.exports=r))}(this,function(t){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var e=function(t){for(var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"image/jpeg",n=window.atob(t),i=[],a=0;a<n.length;a++)i[a]=n.charCodeAt(a);return new window.Blob([new Uint8Array(i)],{type:e})},n=function(t,e,n){var i=document.createElement("canvas"),a=i.getContext("2d");return i.width=t,i.height=e,function(r){if(!n||n>8)return a.drawImage(r,0,0,i.width,i.height),i;switch(n>4&&(i.width=e,i.height=t),n){case 2:a.translate(t,0),a.scale(-1,1);break;case 3:a.translate(t,e),a.rotate(Math.PI);break;case 4:a.translate(0,e),a.scale(1,-1);break;case 5:a.rotate(.5*Math.PI),a.scale(1,-1);break;case 6:a.rotate(.5*Math.PI),a.translate(0,-e);break;case 7:a.rotate(.5*Math.PI),a.translate(t,-e),a.scale(-1,1);break;case 8:a.rotate(-.5*Math.PI),a.translate(-t,0)}return n>4?a.drawImage(r,0,0,i.height,i.width):a.drawImage(r,0,0,i.width,i.height),i}},i=function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:.75,n=t.toDataURL("image/jpeg",e);return n},a=function(t){return{KB:t/1e3,MB:t/1e6}};t.default={base64ToFile:e,imageToCanvas:n,canvasToBase64:i,size:a}})},function(t,e,n){var i,a,r;!function(n,o){a=[e],i=o,r="function"==typeof i?i.apply(e,a):i,!(void 0!==r&&(t.exports=r))}(this,function(t){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var e=function(t){return new Promise(function(e,n){var i=new window.FileReader;i.addEventListener("load",function(t){e(t.target.result)},!1),i.addEventListener("error",function(t){n(t)},!1),i.readAsDataURL(t)})};t.default={load:e}})},function(t,e,n){var i,a,r;!function(n,o){a=[e],i=o,r="function"==typeof i?i.apply(e,a):i,!(void 0!==r&&(t.exports=r))}(this,function(t){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var e=function(t){return new Promise(function(e,n){var i=new window.Image;i.addEventListener("load",function(){e(i)},!1),i.addEventListener("error",function(t){n(t)},!1),i.src=t})},n=function(t,e){return function(n,i){if(!t&&!e)return{width:n,height:i};var a=n/i,r=t/e,o=void 0,u=void 0;return a>r?(o=Math.min(n,t),u=o/a):(u=Math.min(i,e),o=u*a),{width:o,height:u}}};t.default={load:e,resize:n}})},function(t,e,n){var i,a,r;!function(n,o){a=[e],i=o,r="function"==typeof i?i.apply(e,a):i,!(void 0!==r&&(t.exports=r))}(this,function(t){"use strict";function e(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var n=function t(n){var i=n.quality,a=void 0===i?.75:i,r=n.size,o=void 0===r?2:r,u=n.maxWidth,s=void 0===u?1920:u,f=n.maxHeight,d=void 0===f?1920:f,l=n.resize,c=void 0===l||l;e(this,t),this.start=window.performance.now(),this.end=null,this.alt=null,this.ext=null,this.startSize=null,this.startWidth=null,this.startHeight=null,this.size=1e3*o*1e3,this.endSize=null,this.endWidth=null,this.endHeight=null,this.iterations=0,this.base64prefix=null,this.quality=a,this.resize=c,this.maxWidth=s,this.maxHeight=d,this.orientation=1};t.default=n})},function(t,e,n){var i,a,r;!function(n,o){a=[e],i=o,r="function"==typeof i?i.apply(e,a):i,!(void 0!==r&&(t.exports=r))}(this,function(t){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var e=function(t){return new Promise(function(e,n){var i=new window.FileReader;i.onload=function(t){var n=new DataView(t.target.result);65496!==n.getUint16(0,!1)&&e(-2);for(var i=n.byteLength,a=2;a<i;){var r=n.getUint16(a,!1);if(a+=2,65505===r){1165519206!==n.getUint32(a+=2,!1)&&e(-1);var o=18761===n.getUint16(a+=6,!1);a+=n.getUint32(a+4,o);var u=n.getUint16(a,o);a+=2;for(var s=0;s<u;s++)274===n.getUint16(a+12*s,o)&&e(n.getUint16(a+12*s+8,o))}else{if(65280!==(65280&r))break;a+=n.getUint16(a,!1)}}e(-1)},i.readAsArrayBuffer(t.slice(0,65536))})};t.default={orientation:e}})}])});
	//# sourceMappingURL=index.js.map

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.getUserLocale = exports.getUserLocales = void 0;
	
	var _lodash = _interopRequireDefault(__webpack_require__(402));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function filterDuplicates(arr) {
	  return arr.filter(function (el, index, self) {
	    return self.indexOf(el) === index;
	  });
	}
	
	function fixLowercaseProperties(arr) {
	  return arr.map(function (el) {
	    if (!el || el.indexOf('-') === -1 || el.toLowerCase() !== el) {
	      return el;
	    }
	
	    var splitEl = el.split('-');
	    return "".concat(splitEl[0], "-").concat(splitEl[1].toUpperCase());
	  });
	}
	
	var getUserLocales = (0, _lodash["default"])(function () {
	  var languageList = [];
	
	  if (typeof window !== 'undefined') {
	    if (window.navigator.languages) {
	      languageList = languageList.concat(window.navigator.languages);
	    }
	
	    if (window.navigator.language) {
	      languageList.push(window.navigator.language);
	    }
	
	    if (window.navigator.userLanguage) {
	      languageList.push(window.navigator.userLanguage);
	    }
	
	    if (window.navigator.browserLanguage) {
	      languageList.push(window.navigator.browserLanguage);
	    }
	
	    if (window.navigator.systemLanguage) {
	      languageList.push(window.navigator.systemLanguage);
	    }
	  }
	
	  languageList.push('en-US'); // Fallback
	
	  return fixLowercaseProperties(filterDuplicates(languageList));
	});
	exports.getUserLocales = getUserLocales;
	var getUserLocale = (0, _lodash["default"])(function () {
	  return getUserLocales()[0];
	});
	exports.getUserLocale = getUserLocale;
	var _default = getUserLocale;
	exports["default"] = _default;

/***/ }),
/* 83 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Indicates that navigation was caused by a call to history.push.
	 */
	var PUSH = exports.PUSH = 'PUSH';
	
	/**
	 * Indicates that navigation was caused by a call to history.replace.
	 */
	var REPLACE = exports.REPLACE = 'REPLACE';
	
	/**
	 * Indicates that navigation was caused by some other action such
	 * as using a browser's back/forward buttons and/or manually manipulating
	 * the URL in a browser's location bar. This is the default.
	 *
	 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
	 * for more information.
	 */
	var POP = exports.POP = 'POP';

/***/ }),
/* 84 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
	  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
	};
	
	var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
	  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
	};
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
	 */
	var supportsHistory = exports.supportsHistory = function supportsHistory() {
	  var ua = window.navigator.userAgent;
	
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
	
	  return window.history && 'pushState' in window.history;
	};
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
	  return window.navigator.userAgent.indexOf('Firefox') === -1;
	};
	
	/**
	 * Returns true if browser fires popstate on hash change.
	 * IE10 and IE11 do not.
	 */
	var supportsPopstateOnHashchange = exports.supportsPopstateOnHashchange = function supportsPopstateOnHashchange() {
	  return window.navigator.userAgent.indexOf('Trident') === -1;
	};
	
	/**
	 * Returns true if a given popstate event is an extraneous WebKit event.
	 * Accounts for the fact that Chrome on iOS fires real popstate events
	 * containing undefined state when pressing the back button.
	 */
	var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
	  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
	};

/***/ }),
/* 85 */
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(1));
	
	var _mergeClassNames = _interopRequireDefault(__webpack_require__(29));
	
	var _propTypes2 = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var Tile =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(Tile, _Component);
	
	  function Tile() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Tile);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Tile)).call.apply(_getPrototypeOf2, [this].concat(args)));
	
	    _defineProperty(_assertThisInitialized(_this), "state", {});
	
	    return _this;
	  }
	
	  _createClass(Tile, [{
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          activeStartDate = _this$props.activeStartDate,
	          children = _this$props.children,
	          classes = _this$props.classes,
	          date = _this$props.date,
	          formatAbbr = _this$props.formatAbbr,
	          locale = _this$props.locale,
	          maxDate = _this$props.maxDate,
	          maxDateTransform = _this$props.maxDateTransform,
	          minDate = _this$props.minDate,
	          minDateTransform = _this$props.minDateTransform,
	          onClick = _this$props.onClick,
	          onMouseOver = _this$props.onMouseOver,
	          style = _this$props.style,
	          tileDisabled = _this$props.tileDisabled,
	          view = _this$props.view;
	      var _this$state = this.state,
	          tileClassName = _this$state.tileClassName,
	          tileContent = _this$state.tileContent;
	      return _react["default"].createElement("button", {
	        className: (0, _mergeClassNames["default"])(classes, tileClassName),
	        disabled: minDate && minDateTransform(minDate) > date || maxDate && maxDateTransform(maxDate) < date || tileDisabled && tileDisabled({
	          activeStartDate: activeStartDate,
	          date: date,
	          view: view
	        }),
	        onClick: onClick && function () {
	          return onClick(date);
	        },
	        onFocus: onMouseOver && function () {
	          return onMouseOver(date);
	        },
	        onMouseOver: onMouseOver && function () {
	          return onMouseOver(date);
	        },
	        style: style,
	        type: "button"
	      }, formatAbbr ? _react["default"].createElement("abbr", {
	        "aria-label": formatAbbr(locale, date)
	      }, children) : children, tileContent);
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps, prevState) {
	      var date = nextProps.date,
	          tileClassName = nextProps.tileClassName,
	          tileContent = nextProps.tileContent,
	          view = nextProps.view;
	      var nextState = {};
	
	      if (tileClassName !== prevState.tileClassNameProps) {
	        nextState.tileClassName = typeof tileClassName === 'function' ? tileClassName({
	          date: date,
	          view: view
	        }) : tileClassName;
	        nextState.tileClassNameProps = tileClassName;
	      }
	
	      if (tileContent !== prevState.tileContentProps) {
	        nextState.tileContent = typeof tileContent === 'function' ? tileContent({
	          date: date,
	          view: view
	        }) : tileContent;
	        nextState.tileContentProps = tileContent;
	      }
	
	      return nextState;
	    }
	  }]);
	
	  return Tile;
	}(_react.Component);
	
	exports["default"] = Tile;
	Tile.propTypes = _objectSpread({}, _propTypes2.tileProps, {
	  children: _propTypes["default"].node.isRequired,
	  formatAbbr: _propTypes["default"].func,
	  maxDateTransform: _propTypes["default"].func.isRequired,
	  minDateTransform: _propTypes["default"].func.isRequired
	});

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = TileGroup;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(1));
	
	var _Flex = _interopRequireDefault(__webpack_require__(118));
	
	var _utils = __webpack_require__(119);
	
	var _propTypes2 = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function TileGroup(_ref) {
	  var className = _ref.className,
	      count = _ref.count,
	      dateTransform = _ref.dateTransform,
	      dateType = _ref.dateType,
	      end = _ref.end,
	      hover = _ref.hover,
	      offset = _ref.offset,
	      start = _ref.start,
	      step = _ref.step,
	      Tile = _ref.tile,
	      value = _ref.value,
	      valueType = _ref.valueType,
	      tileProps = _objectWithoutProperties(_ref, ["className", "count", "dateTransform", "dateType", "end", "hover", "offset", "start", "step", "tile", "value", "valueType"]);
	
	  var tiles = [];
	
	  for (var point = start; point <= end; point += step) {
	    var date = dateTransform(point);
	    tiles.push(_react["default"].createElement(Tile, _extends({
	      key: date.getTime(),
	      classes: (0, _utils.getTileClasses)({
	        value: value,
	        valueType: valueType,
	        date: date,
	        dateType: dateType,
	        hover: hover
	      }),
	      date: date,
	      point: point
	    }, tileProps)));
	  }
	
	  return _react["default"].createElement(_Flex["default"], {
	    className: className,
	    count: count,
	    offset: offset,
	    wrap: true
	  }, tiles);
	}
	
	TileGroup.propTypes = _objectSpread({}, _propTypes2.tileGroupProps, {
	  activeStartDate: _propTypes["default"].instanceOf(Date),
	  count: _propTypes["default"].number,
	  dateTransform: _propTypes["default"].func.isRequired,
	  offset: _propTypes["default"].number,
	  step: _propTypes["default"].number,
	  tile: _propTypes["default"].func.isRequired
	});
	TileGroup.defaultProps = {
	  count: 3,
	  step: 1
	};

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.formatShortWeekday = exports.formatWeekday = exports.formatMonth = exports.formatMonthYear = exports.formatLongDate = exports.formatDate = void 0;
	
	var _getUserLocale = _interopRequireDefault(__webpack_require__(82));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function getFormatter(options) {
	  return function (locale, date) {
	    return date.toLocaleString(locale || (0, _getUserLocale["default"])(), options);
	  };
	}
	/**
	 * Changes the hour in a Date to ensure right date formatting even if DST is messed up.
	 * Workaround for bug in WebKit and Firefox with historical dates.
	 * For more details, see:
	 * https://bugs.chromium.org/p/chromium/issues/detail?id=750465
	 * https://bugzilla.mozilla.org/show_bug.cgi?id=1385643
	 *
	 * @param {Date} date Date.
	 */
	
	
	function toSafeHour(date) {
	  var safeDate = new Date(date);
	  return new Date(safeDate.setHours(12));
	}
	
	function getSafeFormatter(options) {
	  return function (locale, date) {
	    return getFormatter(options)(locale, toSafeHour(date));
	  };
	}
	
	var formatDateOptions = {
	  day: 'numeric',
	  month: 'numeric',
	  year: 'numeric'
	};
	var formatLongDateOptions = {
	  day: 'numeric',
	  month: 'long',
	  year: 'numeric'
	};
	var formatMonthYearOptions = {
	  month: 'long',
	  year: 'numeric'
	};
	var formatMonthOptions = {
	  month: 'long'
	};
	var formatWeekdayOptions = {
	  weekday: 'long'
	};
	var formatShortWeekdayOptions = {
	  weekday: 'short'
	};
	var formatDate = getSafeFormatter(formatDateOptions);
	exports.formatDate = formatDate;
	var formatLongDate = getSafeFormatter(formatLongDateOptions);
	exports.formatLongDate = formatLongDate;
	var formatMonthYear = getSafeFormatter(formatMonthYearOptions);
	exports.formatMonthYear = formatMonthYear;
	var formatMonth = getSafeFormatter(formatMonthOptions);
	exports.formatMonth = formatMonth;
	var formatWeekday = getSafeFormatter(formatWeekdayOptions);
	exports.formatWeekday = formatWeekday;
	var formatShortWeekday = getSafeFormatter(formatShortWeekdayOptions);
	exports.formatShortWeekday = formatShortWeekday;

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "getYear", {
	  enumerable: true,
	  get: function get() {
	    return _dates.getYear;
	  }
	});
	Object.defineProperty(exports, "getMonth", {
	  enumerable: true,
	  get: function get() {
	    return _dates.getMonth;
	  }
	});
	Object.defineProperty(exports, "getMonthIndex", {
	  enumerable: true,
	  get: function get() {
	    return _dates.getMonthIndex;
	  }
	});
	Object.defineProperty(exports, "getDay", {
	  enumerable: true,
	  get: function get() {
	    return _dates.getDay;
	  }
	});
	Object.defineProperty(exports, "getDaysInMonth", {
	  enumerable: true,
	  get: function get() {
	    return _dates.getDaysInMonth;
	  }
	});
	Object.defineProperty(exports, "getBegin", {
	  enumerable: true,
	  get: function get() {
	    return _dates.getBegin;
	  }
	});
	Object.defineProperty(exports, "getEnd", {
	  enumerable: true,
	  get: function get() {
	    return _dates.getEnd;
	  }
	});
	Object.defineProperty(exports, "getISOLocalMonth", {
	  enumerable: true,
	  get: function get() {
	    return _dates.getISOLocalMonth;
	  }
	});
	Object.defineProperty(exports, "getISOLocalDate", {
	  enumerable: true,
	  get: function get() {
	    return _dates.getISOLocalDate;
	  }
	});
	
	var _dates = __webpack_require__(15);

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "isMaxDate", {
	  enumerable: true,
	  get: function get() {
	    return _propTypes2.isMaxDate;
	  }
	});
	Object.defineProperty(exports, "isMinDate", {
	  enumerable: true,
	  get: function get() {
	    return _propTypes2.isMinDate;
	  }
	});
	exports.isValueType = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes2 = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	var allViews = ['century', 'decade', 'year', 'month'];
	var allValueTypes = [].concat(_toConsumableArray(allViews.slice(1)), ['day']);
	
	var isValueType = _propTypes["default"].oneOf(allValueTypes);
	
	exports.isValueType = isValueType;

/***/ }),
/* 91 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	function componentWillMount() {
	  // Call this.constructor.gDSFP to support sub-classes.
	  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
	  if (state !== null && state !== undefined) {
	    this.setState(state);
	  }
	}
	
	function componentWillReceiveProps(nextProps) {
	  // Call this.constructor.gDSFP to support sub-classes.
	  // Use the setState() updater to ensure state isn't stale in certain edge cases.
	  function updater(prevState) {
	    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
	    return state !== null && state !== undefined ? state : null;
	  }
	  // Binding "this" is important for shallow renderer support.
	  this.setState(updater.bind(this));
	}
	
	function componentWillUpdate(nextProps, nextState) {
	  try {
	    var prevProps = this.props;
	    var prevState = this.state;
	    this.props = nextProps;
	    this.state = nextState;
	    this.__reactInternalSnapshotFlag = true;
	    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
	      prevProps,
	      prevState
	    );
	  } finally {
	    this.props = prevProps;
	    this.state = prevState;
	  }
	}
	
	// React may warn about cWM/cWRP/cWU methods being deprecated.
	// Add a flag to suppress these warnings for this special case.
	componentWillMount.__suppressDeprecationWarning = true;
	componentWillReceiveProps.__suppressDeprecationWarning = true;
	componentWillUpdate.__suppressDeprecationWarning = true;
	
	function polyfill(Component) {
	  var prototype = Component.prototype;
	
	  if (!prototype || !prototype.isReactComponent) {
	    throw new Error('Can only polyfill class components');
	  }
	
	  if (
	    typeof Component.getDerivedStateFromProps !== 'function' &&
	    typeof prototype.getSnapshotBeforeUpdate !== 'function'
	  ) {
	    return Component;
	  }
	
	  // If new component APIs are defined, "unsafe" lifecycles won't be called.
	  // Error if any of these lifecycles are present,
	  // Because they would work differently between older and newer (16.3+) versions of React.
	  var foundWillMountName = null;
	  var foundWillReceivePropsName = null;
	  var foundWillUpdateName = null;
	  if (typeof prototype.componentWillMount === 'function') {
	    foundWillMountName = 'componentWillMount';
	  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
	    foundWillMountName = 'UNSAFE_componentWillMount';
	  }
	  if (typeof prototype.componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'componentWillReceiveProps';
	  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
	  }
	  if (typeof prototype.componentWillUpdate === 'function') {
	    foundWillUpdateName = 'componentWillUpdate';
	  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
	    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
	  }
	  if (
	    foundWillMountName !== null ||
	    foundWillReceivePropsName !== null ||
	    foundWillUpdateName !== null
	  ) {
	    var componentName = Component.displayName || Component.name;
	    var newApiName =
	      typeof Component.getDerivedStateFromProps === 'function'
	        ? 'getDerivedStateFromProps()'
	        : 'getSnapshotBeforeUpdate()';
	
	    throw Error(
	      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
	        componentName +
	        ' uses ' +
	        newApiName +
	        ' but also contains the following legacy lifecycles:' +
	        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
	        (foundWillReceivePropsName !== null
	          ? '\n  ' + foundWillReceivePropsName
	          : '') +
	        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
	        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
	        'https://fb.me/react-async-component-lifecycle-hooks'
	    );
	  }
	
	  // React <= 16.2 does not support static getDerivedStateFromProps.
	  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
	  // Newer versions of React will ignore these lifecycles if gDSFP exists.
	  if (typeof Component.getDerivedStateFromProps === 'function') {
	    prototype.componentWillMount = componentWillMount;
	    prototype.componentWillReceiveProps = componentWillReceiveProps;
	  }
	
	  // React <= 16.2 does not support getSnapshotBeforeUpdate.
	  // As a workaround, use cWU to invoke the new lifecycle.
	  // Newer versions of React will ignore that lifecycle if gSBU exists.
	  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
	    if (typeof prototype.componentDidUpdate !== 'function') {
	      throw new Error(
	        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
	      );
	    }
	
	    prototype.componentWillUpdate = componentWillUpdate;
	
	    var componentDidUpdate = prototype.componentDidUpdate;
	
	    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
	      prevProps,
	      prevState,
	      maybeSnapshot
	    ) {
	      // 16.3+ will not execute our will-update method;
	      // It will pass a snapshot value to did-update though.
	      // Older versions will require our polyfilled will-update value.
	      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
	      // Because for <= 15.x versions this might be a "prevContext" object.
	      // We also can't just check "__reactInternalSnapshot",
	      // Because get-snapshot might return a falsy value.
	      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
	      var snapshot = this.__reactInternalSnapshotFlag
	        ? this.__reactInternalSnapshot
	        : maybeSnapshot;
	
	      componentDidUpdate.call(this, prevProps, prevState, snapshot);
	    };
	  }
	
	  return Component;
	}
	
	exports.polyfill = polyfill;


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopDefault(ex) {
	  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
	}
	
	__webpack_require__(72);
	
	__webpack_require__(57);
	
	__webpack_require__(140);
	
	__webpack_require__(100);
	
	var _classCallCheck = _interopDefault(__webpack_require__(68));
	
	var _createClass = _interopDefault(__webpack_require__(69));
	
	var _possibleConstructorReturn = _interopDefault(__webpack_require__(73));
	
	var _getPrototypeOf = _interopDefault(__webpack_require__(70));
	
	var _inherits = _interopDefault(__webpack_require__(71));
	
	var _assertThisInitialized = _interopDefault(__webpack_require__(55));
	
	var _defineProperty = _interopDefault(__webpack_require__(56));
	
	var React = __webpack_require__(2);
	
	var React__default = _interopDefault(React);
	
	var memoizeOne = _interopDefault(__webpack_require__(117));
	
	var core = __webpack_require__(101);
	
	__webpack_require__(17);
	
	__webpack_require__(1);
	
	__webpack_require__(74);
	
	__webpack_require__(129);
	
	var __chunk_2 = __webpack_require__(202);
	
	var reactSelect = __webpack_require__(490);
	
	__webpack_require__(75);
	
	__webpack_require__(139);
	
	__webpack_require__(184);
	
	var __chunk_3 = __webpack_require__(491);
	
	var createCache = _interopDefault(__webpack_require__(141));
	
	var NonceProvider =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(NonceProvider, _Component);
	
	  function NonceProvider(props) {
	    var _this;
	
	    _classCallCheck(this, NonceProvider);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(NonceProvider).call(this, props));
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "createEmotionCache", function (nonce) {
	      return createCache({
	        nonce: nonce
	      });
	    });
	
	    _this.createEmotionCache = memoizeOne(_this.createEmotionCache);
	    return _this;
	  }
	
	  _createClass(NonceProvider, [{
	    key: "render",
	    value: function render() {
	      var emotionCache = this.createEmotionCache(this.props.nonce);
	      return React__default.createElement(core.CacheProvider, {
	        value: emotionCache
	      }, this.props.children);
	    }
	  }]);
	
	  return NonceProvider;
	}(React.Component);
	
	var index = __chunk_3.manageState(reactSelect.Select);
	
	exports.components = __chunk_2.components;
	exports.createFilter = reactSelect.createFilter;
	exports.defaultTheme = reactSelect.defaultTheme;
	exports.mergeStyles = reactSelect.mergeStyles;
	exports.NonceProvider = NonceProvider;
	exports.default = index;


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = Input;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(1));
	
	var _mergeClassNames = _interopRequireDefault(__webpack_require__(29));
	
	var _updateInputWidth = _interopRequireWildcard(__webpack_require__(248));
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function select(element) {
	  if (!element) {
	    return;
	  }
	
	  requestAnimationFrame(function () {
	    return element.select();
	  });
	}
	
	function updateInputWidthOnFontLoad(element) {
	  if (!document.fonts) {
	    return;
	  }
	
	  var font = (0, _updateInputWidth.getFontShorthand)(element);
	
	  if (!font) {
	    return;
	  }
	
	  var isFontLoaded = document.fonts.check(font);
	
	  if (isFontLoaded) {
	    return;
	  }
	
	  function onLoadingDone() {
	    (0, _updateInputWidth["default"])(element);
	  }
	
	  document.fonts.addEventListener('loadingdone', onLoadingDone);
	}
	
	function Input(_ref) {
	  var ariaLabel = _ref.ariaLabel,
	      className = _ref.className,
	      disabled = _ref.disabled,
	      itemRef = _ref.itemRef,
	      max = _ref.max,
	      min = _ref.min,
	      name = _ref.name,
	      nameForClass = _ref.nameForClass,
	      onChange = _ref.onChange,
	      onKeyDown = _ref.onKeyDown,
	      _onKeyUp = _ref.onKeyUp,
	      placeholder = _ref.placeholder,
	      required = _ref.required,
	      showLeadingZeros = _ref.showLeadingZeros,
	      step = _ref.step,
	      value = _ref.value;
	  var hasLeadingZero = showLeadingZeros && value !== null && value < 10;
	  return [hasLeadingZero && _react["default"].createElement("span", {
	    key: "leadingZero",
	    className: "".concat(className, "__leadingZero")
	  }, "0"), _react["default"].createElement("input", {
	    key: "input",
	    "aria-label": ariaLabel,
	    autoComplete: "off",
	    className: (0, _mergeClassNames["default"])("".concat(className, "__input"), "".concat(className, "__").concat(nameForClass || name), hasLeadingZero && "".concat(className, "__input--hasLeadingZero")),
	    disabled: disabled,
	    max: max,
	    min: min,
	    name: name,
	    onChange: onChange,
	    onFocus: function onFocus(event) {
	      return select(event.target);
	    },
	    onKeyDown: onKeyDown,
	    onKeyUp: function onKeyUp(event) {
	      (0, _updateInputWidth["default"])(event.target);
	
	      if (_onKeyUp) {
	        _onKeyUp(event);
	      }
	    },
	    placeholder: placeholder,
	    ref: function ref(_ref2) {
	      if (_ref2) {
	        (0, _updateInputWidth["default"])(_ref2);
	        updateInputWidthOnFontLoad(_ref2);
	      }
	
	      if (itemRef) {
	        itemRef(_ref2, name);
	      }
	    },
	    required: required,
	    step: step,
	    type: "number",
	    value: value !== null ? value : ''
	  })];
	}
	
	Input.propTypes = {
	  ariaLabel: _propTypes["default"].string,
	  className: _propTypes["default"].string.isRequired,
	  disabled: _propTypes["default"].bool,
	  itemRef: _propTypes["default"].func,
	  max: _propTypes["default"].number,
	  min: _propTypes["default"].number,
	  onChange: _propTypes["default"].func,
	  onKeyDown: _propTypes["default"].func,
	  required: _propTypes["default"].bool,
	  showLeadingZeros: _propTypes["default"].bool,
	  step: _propTypes["default"].number,
	  value: _propTypes["default"].number
	};
	Input.defaultProps = {
	  placeholder: '--'
	};

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Button = undefined;
	
	var _Button = __webpack_require__(562);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Button = _Button2.default;

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CardAreaSideStyled = undefined;
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {};
	var defaultProps = {};
	
	var CardAreaSideStyled = exports.CardAreaSideStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'CardAreaSideStyled'
	})(['display:flex;align-items:stretch;']);
	
	CardAreaSideStyled.propTypes = propTypes;
	CardAreaSideStyled.defaultProps = defaultProps;
	CardAreaSideStyled.displayName = 'CardAreaSideStyled';

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CardMediaStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  theme: _propTypes2.default.object
	};
	
	/** Styles */
	var CardMediaStyled = exports.CardMediaStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'CardMediaStyled'
	})(['display:flex;flex-direction:column;justify-content:flex-end;background-position:center center;background-repeat:no-repeat;background-size:cover;position:relative;']);
	
	CardMediaStyled.propTypes = propTypes;
	CardMediaStyled.displayName = 'CardMediaStyled';

/***/ }),
/* 97 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var noop = exports.noop = function noop() {};
	
	var returnNull = exports.returnNull = function returnNull() {
	  return null;
	};
	
	var returnTrue = exports.returnTrue = function returnTrue() {
	  return true;
	};
	
	var getKey = exports.getKey = function getKey(item, index) {
	  return item && typeof item.id !== 'undefined' ? item.id : index;
	};
	
	var isUndef = exports.isUndef = function isUndef(value) {
	  return typeof value === 'undefined';
	};
	
	var isFunction = exports.isFunction = function isFunction(value) {
	  return typeof value === 'function';
	};
	
	var isObject = exports.isObject = function isObject(value) {
	  return (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value !== null && !Array.isArray(value);
	};
	
	var isValidPositiveNumberOrZero = exports.isValidPositiveNumberOrZero = function isValidPositiveNumberOrZero(num) {
	  return Number.isFinite(num) && num >= 0;
	};
	
	var minMax = exports.minMax = function minMax(value, min, max) {
	  if (value < min) return min;
	  if (value > max) return max;
	  return value;
	};

/***/ }),
/* 98 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var MENU_BROADCAST = exports.MENU_BROADCAST = 'MENU_BROADCAST';
	var MENU_GROUP_BROADCAST = exports.MENU_GROUP_BROADCAST = 'MENU_GROUP_BROADCAST';

/***/ }),
/* 99 */
/***/ (function(module, exports) {

	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}
	
	module.exports = _inheritsLoose;

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(56);
	
	function _objectSpread(target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i] != null ? arguments[i] : {};
	    var ownKeys = Object.keys(source);
	
	    if (typeof Object.getOwnPropertySymbols === 'function') {
	      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
	        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
	      }));
	    }
	
	    ownKeys.forEach(function (key) {
	      defineProperty(target, key, source[key]);
	    });
	  }
	
	  return target;
	}
	
	module.exports = _objectSpread;

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var _inheritsLoose = _interopDefault(__webpack_require__(99));
	var React = __webpack_require__(2);
	var createCache = _interopDefault(__webpack_require__(141));
	var utils = __webpack_require__(260);
	var serialize = __webpack_require__(143);
	var sheet = __webpack_require__(144);
	var css = _interopDefault(__webpack_require__(75));
	
	var EmotionCacheContext = React.createContext( // we're doing this to avoid preconstruct's dead code elimination in this one case
	// because this module is primarily intended for the browser and node
	// but it's also required in react native and similar environments sometimes
	// and we could have a special build just for that
	// but this is much easier and the native packages
	// might use a different theme context in the future anyway
	typeof HTMLElement !== 'undefined' ? createCache() : null);
	var ThemeContext = React.createContext({});
	var CacheProvider = EmotionCacheContext.Provider;
	
	exports.withEmotionCache = function withEmotionCache(func) {
	  var render = function render(props, ref) {
	    return React.createElement(EmotionCacheContext.Consumer, null, function (cache) {
	      return func(props, cache, ref);
	    });
	  }; // $FlowFixMe
	
	
	  return React.forwardRef(render);
	};
	
	// thus we only need to replace what is a valid character for JS, but not for CSS
	
	var sanitizeIdentifier = function sanitizeIdentifier(identifier) {
	  return identifier.replace(/\$/g, '-');
	};
	
	var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
	var labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var render = function render(cache, props, theme, ref) {
	  var cssProp = theme === null ? props.css : props.css(theme); // so that using `css` from `emotion` and passing the result to the css prop works
	  // not passing the registered cache to serializeStyles because it would
	  // make certain babel optimisations not possible
	
	  if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
	    cssProp = cache.registered[cssProp];
	  }
	
	  var type = props[typePropName];
	  var registeredStyles = [cssProp];
	  var className = '';
	
	  if (props.className !== undefined) {
	    className = utils.getRegisteredStyles(cache.registered, registeredStyles, props.className);
	  }
	
	  var serialized = serialize.serializeStyles(registeredStyles);
	
	  if (false) {
	    var labelFromStack = props[labelPropName];
	
	    if (labelFromStack) {
	      serialized = serialize.serializeStyles([serialized, 'label:' + labelFromStack + ';']);
	    }
	  }
	
	  var rules = utils.insertStyles(cache, serialized, typeof type === 'string');
	  className += cache.key + "-" + serialized.name;
	  var newProps = {};
	
	  for (var key in props) {
	    if (hasOwnProperty.call(props, key) && key !== 'css' && key !== typePropName && (("production") === 'production' || key !== labelPropName)) {
	      newProps[key] = props[key];
	    }
	  }
	
	  newProps.ref = ref;
	  newProps.className = className;
	  var ele = React.createElement(type, newProps);
	
	  return ele;
	};
	
	var Emotion =
	/* #__PURE__ */
	exports.withEmotionCache(function (props, cache, ref) {
	  // use Context.read for the theme when it's stable
	  if (typeof props.css === 'function') {
	    return React.createElement(ThemeContext.Consumer, null, function (theme) {
	      return render(cache, props, theme, ref);
	    });
	  }
	
	  return render(cache, props, null, ref);
	});
	
	if (false) {
	  Emotion.displayName = 'EmotionCssPropInternal';
	} // $FlowFixMe
	
	
	var jsx = function jsx(type, props) {
	  var args = arguments;
	
	  if (props == null || !hasOwnProperty.call(props, 'css')) {
	    // $FlowFixMe
	    return React.createElement.apply(undefined, args);
	  }
	
	  if (false) {
	    throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/css' like this: css`" + props.css + "`");
	  }
	
	  var argsLength = args.length;
	  var createElementArgArray = new Array(argsLength);
	  createElementArgArray[0] = Emotion;
	  var newProps = {};
	
	  for (var key in props) {
	    if (hasOwnProperty.call(props, key)) {
	      newProps[key] = props[key];
	    }
	  }
	
	  newProps[typePropName] = type;
	
	  if (false) {
	    var error = new Error();
	
	    if (error.stack) {
	      // chrome
	      var match = error.stack.match(/at (?:Object\.|)jsx.*\n\s+at ([A-Z][A-Za-z$]+) /);
	
	      if (!match) {
	        // safari and firefox
	        match = error.stack.match(/^.*\n([A-Z][A-Za-z$]+)@/);
	      }
	
	      if (match) {
	        newProps[labelPropName] = sanitizeIdentifier(match[1]);
	      }
	    }
	  }
	
	  createElementArgArray[1] = newProps;
	
	  for (var i = 2; i < argsLength; i++) {
	    createElementArgArray[i] = args[i];
	  } // $FlowFixMe
	
	
	  return React.createElement.apply(null, createElementArgArray);
	};
	
	var warnedAboutCssPropForGlobal = false;
	var Global =
	/* #__PURE__ */
	exports.withEmotionCache(function (props, cache) {
	  if (false) {
	    console.error("It looks like you're using the css prop on Global, did you mean to use the styles prop instead?");
	    warnedAboutCssPropForGlobal = true;
	  }
	
	  var styles = props.styles;
	
	  if (typeof styles === 'function') {
	    return React.createElement(ThemeContext.Consumer, null, function (theme) {
	      var serialized = serialize.serializeStyles([styles(theme)]);
	      return React.createElement(InnerGlobal, {
	        serialized: serialized,
	        cache: cache
	      });
	    });
	  }
	
	  var serialized = serialize.serializeStyles([styles]);
	  return React.createElement(InnerGlobal, {
	    serialized: serialized,
	    cache: cache
	  });
	});
	
	// maintain place over rerenders.
	// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
	// initial client-side render from SSR, use place of hydrating tag
	var InnerGlobal =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(InnerGlobal, _React$Component);
	
	  function InnerGlobal(props, context, updater) {
	    return _React$Component.call(this, props, context, updater) || this;
	  }
	
	  var _proto = InnerGlobal.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.sheet = new sheet.StyleSheet({
	      key: this.props.cache.key + "-global",
	      nonce: this.props.cache.sheet.nonce,
	      container: this.props.cache.sheet.container
	    }); // $FlowFixMe
	
	    var node = document.querySelector("style[data-emotion-" + this.props.cache.key + "=\"" + this.props.serialized.name + "\"]");
	
	    if (node !== null) {
	      this.sheet.tags.push(node);
	    }
	
	    if (this.props.cache.sheet.tags.length) {
	      this.sheet.before = this.props.cache.sheet.tags[0];
	    }
	
	    this.insertStyles();
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
	    if (prevProps.serialized.name !== this.props.serialized.name) {
	      this.insertStyles();
	    }
	  };
	
	  _proto.insertStyles = function insertStyles() {
	    if (this.props.serialized.next !== undefined) {
	      // insert keyframes
	      utils.insertStyles(this.props.cache, this.props.serialized.next, true);
	    }
	
	    if (this.sheet.tags.length) {
	      // if this doesn't exist then it will be null so the style element will be appended
	      var element = this.sheet.tags[this.sheet.tags.length - 1].nextElementSibling;
	      this.sheet.before = element;
	      this.sheet.flush();
	    }
	
	    this.props.cache.insert("", this.props.serialized, this.sheet, false);
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.sheet.flush();
	  };
	
	  _proto.render = function render() {
	
	    return null;
	  };
	
	  return InnerGlobal;
	}(React.Component);
	
	var keyframes = function keyframes() {
	  var insertable = css.apply(void 0, arguments);
	  var name = "animation-" + insertable.name; // $FlowFixMe
	
	  return {
	    name: name,
	    styles: "@keyframes " + name + "{" + insertable.styles + "}",
	    anim: 1,
	    toString: function toString() {
	      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
	    }
	  };
	};
	
	var classnames = function classnames(args) {
	  var len = args.length;
	  var i = 0;
	  var cls = '';
	
	  for (; i < len; i++) {
	    var arg = args[i];
	    if (arg == null) continue;
	    var toAdd = void 0;
	
	    switch (typeof arg) {
	      case 'boolean':
	        break;
	
	      case 'object':
	        {
	          if (Array.isArray(arg)) {
	            toAdd = classnames(arg);
	          } else {
	            toAdd = '';
	
	            for (var k in arg) {
	              if (arg[k] && k) {
	                toAdd && (toAdd += ' ');
	                toAdd += k;
	              }
	            }
	          }
	
	          break;
	        }
	
	      default:
	        {
	          toAdd = arg;
	        }
	    }
	
	    if (toAdd) {
	      cls && (cls += ' ');
	      cls += toAdd;
	    }
	  }
	
	  return cls;
	};
	
	function merge(registered, css, className) {
	  var registeredStyles = [];
	  var rawClassName = utils.getRegisteredStyles(registered, registeredStyles, className);
	
	  if (registeredStyles.length < 2) {
	    return className;
	  }
	
	  return rawClassName + css(registeredStyles);
	}
	
	var ClassNames = exports.withEmotionCache(function (props, context) {
	  return React.createElement(ThemeContext.Consumer, null, function (theme) {
	    var hasRendered = false;
	
	    var css = function css() {
	      if (hasRendered && ("production") !== 'production') {
	        throw new Error('css can only be used during render');
	      }
	
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      var serialized = serialize.serializeStyles(args, context.registered);
	
	      {
	        utils.insertStyles(context, serialized, false);
	      }
	
	      return context.key + "-" + serialized.name;
	    };
	
	    var cx = function cx() {
	      if (hasRendered && ("production") !== 'production') {
	        throw new Error('cx can only be used during render');
	      }
	
	      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      return merge(context.registered, css, classnames(args));
	    };
	
	    var content = {
	      css: css,
	      cx: cx,
	      theme: theme
	    };
	    var ele = props.children(content);
	    hasRendered = true;
	
	    return ele;
	  });
	});
	
	exports.css = css;
	exports.CacheProvider = CacheProvider;
	exports.ClassNames = ClassNames;
	exports.Global = Global;
	exports.ThemeContext = ThemeContext;
	exports.jsx = jsx;
	exports.keyframes = keyframes;


/***/ }),
/* 102 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0
	
	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.
	
	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */
	
	function __spreadArrays() {
	    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
	    for (var r = Array(s), k = 0, i = 0; i < il; i++)
	        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	            r[k] = a[j];
	    return r;
	}
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var _a;
	/**
	 * A container for all of the Logger instances
	 */
	var instances = [];
	(function (LogLevel) {
	    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
	    LogLevel[LogLevel["VERBOSE"] = 1] = "VERBOSE";
	    LogLevel[LogLevel["INFO"] = 2] = "INFO";
	    LogLevel[LogLevel["WARN"] = 3] = "WARN";
	    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
	    LogLevel[LogLevel["SILENT"] = 5] = "SILENT";
	})(exports.LogLevel || (exports.LogLevel = {}));
	var levelStringToEnum = {
	    'debug': exports.LogLevel.DEBUG,
	    'verbose': exports.LogLevel.VERBOSE,
	    'info': exports.LogLevel.INFO,
	    'warn': exports.LogLevel.WARN,
	    'error': exports.LogLevel.ERROR,
	    'silent': exports.LogLevel.SILENT
	};
	/**
	 * The default log level
	 */
	var defaultLogLevel = exports.LogLevel.INFO;
	/**
	 * By default, `console.debug` is not displayed in the developer console (in
	 * chrome). To avoid forcing users to have to opt-in to these logs twice
	 * (i.e. once for firebase, and once in the console), we are sending `DEBUG`
	 * logs to the `console.log` function.
	 */
	var ConsoleMethod = (_a = {},
	    _a[exports.LogLevel.DEBUG] = 'log',
	    _a[exports.LogLevel.VERBOSE] = 'log',
	    _a[exports.LogLevel.INFO] = 'info',
	    _a[exports.LogLevel.WARN] = 'warn',
	    _a[exports.LogLevel.ERROR] = 'error',
	    _a);
	/**
	 * The default log handler will forward DEBUG, VERBOSE, INFO, WARN, and ERROR
	 * messages on to their corresponding console counterparts (if the log method
	 * is supported by the current log level)
	 */
	var defaultLogHandler = function (instance, logType) {
	    var args = [];
	    for (var _i = 2; _i < arguments.length; _i++) {
	        args[_i - 2] = arguments[_i];
	    }
	    if (logType < instance.logLevel) {
	        return;
	    }
	    var now = new Date().toISOString();
	    var method = ConsoleMethod[logType];
	    if (method) {
	        console[method].apply(console, __spreadArrays(["[" + now + "]  " + instance.name + ":"], args));
	    }
	    else {
	        throw new Error("Attempted to log a message with an invalid logType (value: " + logType + ")");
	    }
	};
	var Logger = /** @class */ (function () {
	    /**
	     * Gives you an instance of a Logger to capture messages according to
	     * Firebase's logging scheme.
	     *
	     * @param name The name that the logs will be associated with
	     */
	    function Logger(name) {
	        this.name = name;
	        /**
	         * The log level of the given Logger instance.
	         */
	        this._logLevel = defaultLogLevel;
	        /**
	         * The main (internal) log handler for the Logger instance.
	         * Can be set to a new function in internal package code but not by user.
	         */
	        this._logHandler = defaultLogHandler;
	        /**
	         * The optional, additional, user-defined log handler for the Logger instance.
	         */
	        this._userLogHandler = null;
	        /**
	         * Capture the current instance for later use
	         */
	        instances.push(this);
	    }
	    Object.defineProperty(Logger.prototype, "logLevel", {
	        get: function () {
	            return this._logLevel;
	        },
	        set: function (val) {
	            if (!(val in exports.LogLevel)) {
	                throw new TypeError('Invalid value assigned to `logLevel`');
	            }
	            this._logLevel = val;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Logger.prototype, "logHandler", {
	        get: function () {
	            return this._logHandler;
	        },
	        set: function (val) {
	            if (typeof val !== 'function') {
	                throw new TypeError('Value assigned to `logHandler` must be a function');
	            }
	            this._logHandler = val;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Logger.prototype, "userLogHandler", {
	        get: function () {
	            return this._userLogHandler;
	        },
	        set: function (val) {
	            this._userLogHandler = val;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * The functions below are all based on the `console` interface
	     */
	    Logger.prototype.debug = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        this._userLogHandler && this._userLogHandler.apply(this, __spreadArrays([this, exports.LogLevel.DEBUG], args));
	        this._logHandler.apply(this, __spreadArrays([this, exports.LogLevel.DEBUG], args));
	    };
	    Logger.prototype.log = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        this._userLogHandler && this._userLogHandler.apply(this, __spreadArrays([this, exports.LogLevel.VERBOSE], args));
	        this._logHandler.apply(this, __spreadArrays([this, exports.LogLevel.VERBOSE], args));
	    };
	    Logger.prototype.info = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        this._userLogHandler && this._userLogHandler.apply(this, __spreadArrays([this, exports.LogLevel.INFO], args));
	        this._logHandler.apply(this, __spreadArrays([this, exports.LogLevel.INFO], args));
	    };
	    Logger.prototype.warn = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        this._userLogHandler && this._userLogHandler.apply(this, __spreadArrays([this, exports.LogLevel.WARN], args));
	        this._logHandler.apply(this, __spreadArrays([this, exports.LogLevel.WARN], args));
	    };
	    Logger.prototype.error = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        this._userLogHandler && this._userLogHandler.apply(this, __spreadArrays([this, exports.LogLevel.ERROR], args));
	        this._logHandler.apply(this, __spreadArrays([this, exports.LogLevel.ERROR], args));
	    };
	    return Logger;
	}());
	function setLogLevel(level) {
	    var newLevel = typeof level === 'string' ? levelStringToEnum[level] : level;
	    instances.forEach(function (inst) {
	        inst.logLevel = newLevel;
	    });
	}
	function setUserLogHandler(logCallback, options) {
	    var _loop_1 = function (instance) {
	        var customLogLevel = null;
	        if (options && options.level) {
	            customLogLevel = levelStringToEnum[options.level];
	        }
	        if (logCallback === null) {
	            instance.userLogHandler = null;
	        }
	        else {
	            instance.userLogHandler = function (instance, level) {
	                var args = [];
	                for (var _i = 2; _i < arguments.length; _i++) {
	                    args[_i - 2] = arguments[_i];
	                }
	                var message = args
	                    .map(function (arg) {
	                    if (arg == null) {
	                        return null;
	                    }
	                    else if (typeof arg === 'string') {
	                        return arg;
	                    }
	                    else if (typeof arg === 'number' || typeof arg === 'boolean') {
	                        return arg.toString();
	                    }
	                    else if (arg instanceof Error) {
	                        return arg.message;
	                    }
	                    else {
	                        try {
	                            return JSON.stringify(arg);
	                        }
	                        catch (ignored) {
	                            return null;
	                        }
	                    }
	                })
	                    .filter(function (arg) { return arg; })
	                    .join(' ');
	                if (level >= (customLogLevel !== null && customLogLevel !== void 0 ? customLogLevel : instance.logLevel)) {
	                    logCallback({
	                        level: exports.LogLevel[level].toLowerCase(),
	                        message: message,
	                        args: args,
	                        type: instance.name
	                    });
	                }
	            };
	        }
	    };
	    for (var _i = 0, instances_1 = instances; _i < instances_1.length; _i++) {
	        var instance = instances_1[_i];
	        _loop_1(instance);
	    }
	}
	
	exports.Logger = Logger;
	exports.setLogLevel = setLogLevel;
	exports.setUserLogHandler = setUserLogHandler;
	//# sourceMappingURL=index.cjs.js.map


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BazarCard = __webpack_require__(285);
	
	var _BazarCard2 = _interopRequireDefault(_BazarCard);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var OpenBazarGrid = function (_Component) {
	  _inherits(OpenBazarGrid, _Component);
	
	  function OpenBazarGrid() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, OpenBazarGrid);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = OpenBazarGrid.__proto__ || Object.getPrototypeOf(OpenBazarGrid)).call.apply(_ref, [this].concat(args))), _this), _this.getMobileDivs = function (data) {
	      return data.map(function (rec, index) {
	        //console.log(JSON.stringify(rec));
	        return _react2.default.createElement("div", {
	          style: {
	            marginLeft: "5px",
	            marginRight: "5px"
	          }
	        }, _react2.default.createElement(_BazarCard2.default, {
	          key: rec.key,
	          data: rec,
	          index: index,
	          phoneNumber: _this.props.phoneNumber,
	          handleEdit: _this.props.handleEdit,
	          tableName: _this.props.tableName,
	          firebase: _this.props.firebase,
	          updateRecord: _this.props.updateRecord,
	          onNotifyUsers: _this.props.onNotifyUsers,
	          allSuppliers: _this.props.allSuppliers,
	          path: _this.props.tableName
	        }));
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(OpenBazarGrid, [{
	    key: "render",
	    value: function render() {
	      if (this.props.data && this.props.data !== undefined && this.props.data.length > 0) {
	        return _react2.default.createElement("div", null, this.getMobileDivs(this.props.data), _react2.default.createElement("div", { style: { height: "400px" } }));
	
	        //return this.getRows(this.props.data);
	      } else {
	        if (this.props.dataIsLoaded) {
	          return _react2.default.createElement("div", null, _react2.default.createElement("div", {
	            style: {
	              textAlign: "center"
	            }
	          }, "No posts currently availably in Open Bazar, tap Add Posts to create one."));
	        } else {
	          return _react2.default.createElement("div", {
	            style: {
	              margin: "15px"
	            }
	          }, _react2.default.createElement("div", {
	            style: {
	              textAlign: "center"
	            }
	          }, "Seems like you are on a slow network, we are loading data please wait a moment..."), _react2.default.createElement("div", {
	            style: {
	              backgroundColor: "whtie",
	              height: "200px"
	            }
	          }));
	        }
	      }
	    }
	  }]);
	
	  return OpenBazarGrid;
	}(_react.Component);
	
	exports.default = OpenBazarGrid;

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactLazyLoadImageComponent = __webpack_require__(30);
	
	__webpack_require__(67);
	
	var _reactLoadingSkeleton = __webpack_require__(124);
	
	var _reactLoadingSkeleton2 = _interopRequireDefault(_reactLoadingSkeleton);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var PhotoCard = function (_Component) {
	  _inherits(PhotoCard, _Component);
	
	  function PhotoCard() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PhotoCard);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PhotoCard.__proto__ || Object.getPrototypeOf(PhotoCard)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      0: false,
	      1: false
	    }, _this.getPhotos = function (photos) {
	      if (photos && photos.length > 0) {
	        return photos.map(function (photo, index) {
	          if (photo.status === "DONE") {
	            var _ref2;
	
	            return _react2.default.createElement("div", {
	              style: (_ref2 = {
	                margin: "auto",
	                position: "relative",
	                minHeight: "210px",
	                minWidth: "210px"
	              }, _defineProperty(_ref2, "margin", "auto"), _defineProperty(_ref2, "border", "0px solid black"), _defineProperty(_ref2, "padding", "5px"), _defineProperty(_ref2, "display", "flex"), _defineProperty(_ref2, "justifyContent", "center"), _defineProperty(_ref2, "alignItems", "center"), _ref2)
	            }, _react2.default.createElement("div", {
	              style: {
	                textAlign: "center"
	              }
	            }, _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, {
	              src: "https://storage.googleapis.com/bcsfbtest/images/" + photo.imageName,
	              style: {
	                maxHeight: "200px",
	                maxWidth: "200px",
	                height: _this.state[index] ? "200px" : null,
	                width: _this.state[index] ? "200px" : null,
	                borderRadius: "10px",
	                border: "0px solid gainsboro",
	                objectFit: "contain",
	                position: "abosolute",
	                top: "0",
	                left: "0",
	                zIndex: "2"
	              },
	              effect: "blur",
	              afterLoad: function afterLoad() {
	                //console.log("setting to true");
	                _this.setState(function (prevState) {
	                  return _extends({}, prevState, _defineProperty({}, index, true));
	                });
	              },
	              visibleByDefault: false
	            }), !_this.state[index] && _react2.default.createElement(_reactLoadingSkeleton2.default, {
	              style: {
	                height: "200px",
	                width: "200px",
	                borderRadius: "10px",
	                border: "0px solid gainsboro",
	                objectFill: "cover",
	                position: "absolute",
	                top: "0",
	                left: "0",
	                zIndex: "3"
	              },
	              duration: 1
	            })));
	          } else {
	            return _react2.default.createElement("div", {
	              style: {
	                margin: "auto"
	              }
	            }, _react2.default.createElement(_reactLoadingSkeleton2.default, {
	              style: {
	                minHeight: "200px",
	                maxHeight: "200px",
	                minWidth: "200px",
	                borderRadius: "10px",
	                border: "0px solid gainsboro",
	                objectFill: "cover",
	                margin: "5px"
	              }
	            }));
	          }
	        });
	      }
	    }, _this.getPhotosFast = function (photos) {
	      if (photos && photos.length > 0) {
	        return photos.map(function (photo, index) {
	          if (photo.status === "DONE") {
	            var _ref3;
	
	            return _react2.default.createElement("div", {
	              style: (_ref3 = {
	                margin: "auto",
	                position: "relative",
	                minHeight: "210px",
	                minWidth: "210px"
	              }, _defineProperty(_ref3, "margin", "auto"), _defineProperty(_ref3, "border", "0px solid black"), _defineProperty(_ref3, "padding", "5px"), _defineProperty(_ref3, "display", "flex"), _defineProperty(_ref3, "justifyContent", "center"), _defineProperty(_ref3, "alignItems", "center"), _ref3)
	            }, _react2.default.createElement("div", {
	              style: {
	                textAlign: "center"
	              }
	            }, _react2.default.createElement("img", {
	              src: "https://storage.googleapis.com/bcsfbtest/images/" + photo.imageName,
	              style: {
	                maxHeight: "200px",
	                maxWidth: "200px",
	                height: "200px",
	                width: "200px",
	                borderRadius: "10px",
	                border: "0px solid gainsboro",
	                objectFit: "contain",
	                position: "abosolute",
	                top: "0",
	                left: "0",
	                zIndex: "2"
	              }
	            })));
	          } else {
	            return _react2.default.createElement("div", {
	              style: {
	                margin: "auto"
	              }
	            }, _react2.default.createElement(_reactLoadingSkeleton2.default, {
	              style: {
	                minHeight: "200px",
	                maxHeight: "200px",
	                minWidth: "200px",
	                borderRadius: "10px",
	                border: "0px solid gainsboro",
	                objectFill: "cover",
	                margin: "5px"
	              }
	            }));
	          }
	        });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(PhotoCard, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement("div", {
	        style: {
	          display: "flex",
	          overflow: "scroll"
	        }
	      }, this.getPhotosFast(this.props.photos));
	    }
	  }]);
	
	  return PhotoCard;
	}(_react.Component);
	
	exports.default = PhotoCard;

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _entry = __webpack_require__(335);
	
	var _entry2 = _interopRequireDefault(_entry);
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactDeviceDetect = __webpack_require__(6);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var DateDropdown = function (_Component) {
	  _inherits(DateDropdown, _Component);
	
	  function DateDropdown() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, DateDropdown);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DateDropdown.__proto__ || Object.getPrototypeOf(DateDropdown)).call.apply(_ref, [this].concat(args))), _this), _this.getDateValue = function () {
	      // let momDate = moment()
	      //   .utc()
	      //   .format();
	      // console.log("=====================" + momDate);
	      // if (this.props.value !== "") {
	      //   momDate = moment(this.props.value)
	      //     .utc()
	      //     .format();
	      // }
	
	      // return momDate;
	      var newDataObj = new Date();
	      if (_this.props.value && _this.props.value !== undefined && _this.props.value !== "") {
	        var strDate = (0, _moment2.default)(_this.props.value, _this.props.formatOut);
	        //console.log("updating date value: " + strDate);
	        newDataObj = new Date(strDate);
	      }
	      //console.log("~!~!~!~!~!~!: newDateObj: " + newDataObj);
	      return newDataObj;
	    }, _this.setDateValue = function (newDateValue) {
	      //console.log("Something happening here...");
	      if (newDateValue !== "") {
	        var momDateValue = (0, _moment2.default)(newDateValue).format(_this.props.formatOut);
	        //console.log(momDateValue);
	        _this.props.onChange(momDateValue, _this.props.fieldName, true);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(DateDropdown, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement("div", {
	        className: "row",
	        style: {
	          marginLeft: "1px",
	          marginRight: "1px",
	          alignItems: "center",
	          padding: "2px",
	          border: "0px",
	          borderBottom: "0px",
	          borderBottomColor: "#cccccc",
	          borderStyle: "solid"
	        }
	      }, _react2.default.createElement("div", {
	        className: "col-sm-4 align-self-center\u201D",
	        style: {
	          margin: "0px",
	          verticalAlign: "middle",
	          height: "auto",
	          padding: "0px"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          marginTop: _reactDeviceDetect.isMobile ? "13px" : "0px",
	          verticalAlign: "middle",
	          lineHeight: _reactDeviceDetect.isMobile ? "20px" : "37px",
	          padding: "0px",
	          color: _reactDeviceDetect.isMobile ? "grey" : "black",
	          marginBottom: _reactDeviceDetect.isMobile ? "-1px" : "0px"
	        }
	      }, this.props.title)), _react2.default.createElement("div", {
	        className: "col-sm-8",
	        style: {
	          display: "block",
	          padding: "6px",
	          textAlign: "left",
	          border: "1px solid gainsboro",
	          borderRadius: "5px",
	          backgroundColor: "white"
	        }
	      }, _react2.default.createElement(_entry2.default, {
	        maxDetail: this.props.maxDetail,
	        format: this.props.format,
	        onChange: function onChange(value) {
	          return _this2.setDateValue(value);
	        },
	        value: this.getDateValue(),
	        calendarClassName: "container",
	        clearIcon: null,
	        disableClock: true,
	        disabled: this.props.disabled
	      })));
	    }
	  }]);
	
	  return DateDropdown;
	}(_react.Component);
	
	exports.default = DateDropdown;

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(92);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _reactDeviceDetect = __webpack_require__(6);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var customStyles = {
	  control: function control(provided, state) {
	    return _extends({}, provided, {
	      width: "100%",
	      borderWidth: "0px",
	      borderBottomWidth: "0px",
	      borderRadius: "0px"
	    });
	  },
	  menu: function menu(base) {
	    return _extends({}, base, {
	      zIndex: 100
	    });
	  }
	};
	
	var SelectDropdown = function (_Component) {
	  _inherits(SelectDropdown, _Component);
	
	  function SelectDropdown() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SelectDropdown);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SelectDropdown.__proto__ || Object.getPrototypeOf(SelectDropdown)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      searchVal: ""
	    }, _this.handleChange = function (newValue, actionMeta) {
	      if (actionMeta.action === "clear") {
	        _this.props.stateHandler("", _this.props.stateFieldName, _this.props.isPayload);
	      } else {
	        if (newValue && newValue !== undefined) {
	          _this.props.stateHandler(newValue.value, _this.props.stateFieldName, _this.props.isPayload);
	          if (_this.props.otherFields && _this.props.otherFields.length > 0) {
	            _this.props.otherFields.map(function (item) {
	              //console.log("auto update: " + JSON.stringify(item));
	              var srcVal = newValue.fullRec[item.src];
	              if (srcVal === undefined) {
	                srcVal = "";
	              }
	              _this.props.stateHandler(srcVal, item.tgt, _this.props.isPayload);
	            });
	          }
	        }
	      }
	    }, _this.getOptions = function () {
	      var newArray = [];
	      if (!_this.props.data && _this.props.data === undefined) {
	        //console.log("Data is undefined for SelectDropdown");
	        return [];
	      }
	
	      //console.log("No of drop down records: " + this.props.data.length);
	      for (var i = 0; i < _this.props.data.length; i++) {
	        var item = _this.props.data[i];
	        var filter = {};
	        if (_this.props.filter && _this.props.filter !== undefined && _this.props.filter.length > 0) {
	          filter = _this.props.filter[0];
	        }
	        if (filter.src && _this.props.stateRcvd && _this.props.stateRcvd.payload) {
	          if (item[filter.src] === _this.props.stateRcvd.payload[filter.tgt]) {
	            newArray.push({
	              value: item[_this.props.fieldName],
	              label: item[_this.props.fieldName],
	              fullRec: item
	            });
	          }
	        } else {
	          newArray.push({
	            value: item[_this.props.fieldName],
	            label: item[_this.props.fieldName],
	            fullRec: item
	          });
	        }
	      }
	
	      return newArray;
	    }, _this.getValue = function () {
	      return { value: _this.props.value, label: _this.props.value };
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SelectDropdown, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement("div", {
	        className: "row",
	        style: {
	          marginLeft: "1px",
	          marginRight: "1px",
	          alignItems: "center",
	          padding: "2px",
	          border: "0px",
	          borderBottom: "0px",
	          borderBottomColor: "#cccccc",
	          borderStyle: "solid",
	          paddingBottom: _reactDeviceDetect.isMobile ? "0px" : "2px"
	        }
	      }, _react2.default.createElement("div", {
	        className: "col-sm-4 align-self-center\u201D",
	        style: {
	          margin: "0px",
	          verticalAlign: "middle",
	          height: "auto",
	          padding: "0px"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          marginTop: _reactDeviceDetect.isMobile ? "13px" : "0px",
	          verticalAlign: "middle",
	          lineHeight: _reactDeviceDetect.isMobile ? "20px" : "37px",
	          padding: "0px",
	          color: _reactDeviceDetect.isMobile ? "grey" : "black",
	          marginBottom: _reactDeviceDetect.isMobile ? "-1px" : "0px"
	        }
	      }, this.props.title)), _react2.default.createElement("div", {
	        className: "col-sm-8",
	        style: {
	          display: "block",
	          padding: "1px",
	          textAlign: "left",
	          border: "1px solid gainsboro",
	          borderRadius: "5px",
	          backgroundColor: "white"
	        }
	      }, _react2.default.createElement(_reactSelect2.default, {
	        isClearable: true,
	        onChange: this.handleChange,
	        options: this.getOptions(),
	        label: this.props.label,
	        placeholder: this.props.placeholder,
	        value: this.getValue(),
	        styles: customStyles,
	        defaultValue: "",
	        theme: function theme(_theme) {
	          return _extends({}, _theme, {
	            borderRadius: 0,
	            colors: _extends({}, _theme.colors, {
	              primary: "blue"
	            }),
	            borderBottomWidth: "0px",
	            borderBottomColor: "blue"
	          });
	        },
	        isDisabled: this.props.disabled
	      })));
	    }
	  }]);
	
	  return SelectDropdown;
	}(_react.Component);
	
	exports.default = SelectDropdown;

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDeviceDetect = __webpack_require__(6);
	
	var _recompose = __webpack_require__(11);
	
	var _Firebase = __webpack_require__(10);
	
	var _reactRedux = __webpack_require__(9);
	
	__webpack_require__(910);
	
	var _reactSignatureCanvas = __webpack_require__(492);
	
	var _reactSignatureCanvas2 = _interopRequireDefault(_reactSignatureCanvas);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var PhotoUploadPass = function (_Component) {
	  _inherits(PhotoUploadPass, _Component);
	
	  function PhotoUploadPass() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PhotoUploadPass);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PhotoUploadPass.__proto__ || Object.getPrototypeOf(PhotoUploadPass)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      uploading: false,
	      progress: "0"
	    }, _this.b64toBlob = function (b64Data) {
	      var contentType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
	      var sliceSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 512;
	
	      var byteCharacters = atob(b64Data);
	      var byteArrays = [];
	
	      for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
	        var slice = byteCharacters.slice(offset, offset + sliceSize);
	
	        var byteNumbers = new Array(slice.length);
	        for (var i = 0; i < slice.length; i++) {
	          byteNumbers[i] = slice.charCodeAt(i);
	        }
	
	        var byteArray = new Uint8Array(byteNumbers);
	        byteArrays.push(byteArray);
	      }
	
	      var blob = new Blob(byteArrays, { type: contentType });
	      return blob;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(PhotoUploadPass, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.sigCanvas.fromDataURL(this.props.sigB64);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _ref2,
	          _this2 = this;
	
	      return _react2.default.createElement("div", {
	        className: "row",
	        style: {
	          marginLeft: "1px",
	          marginRight: "1px",
	          alignItems: "center",
	          padding: "2px",
	          border: "0px",
	          borderBottom: "0px",
	          borderBottomColor: "#cccccc",
	          borderStyle: "solid",
	          paddingBottom: _reactDeviceDetect.isMobile ? "0px" : "2px"
	        }
	      }, _react2.default.createElement("div", {
	        className: "col-sm-8",
	        style: {
	          padding: "1px",
	          border: "1px solid gainsboro",
	          borderRadius: _reactDeviceDetect.isMobile ? "5px" : "0px",
	          backgroundColor: "white",
	          minHeight: "100px",
	          textAlign: "center"
	        }
	      }, _react2.default.createElement("div", { style: { display: "flex", flexDirection: "row" } }, _react2.default.createElement("div", {
	        style: (_ref2 = {
	          padding: "1px",
	          border: "1px solid gainsboro",
	          borderRadius: _reactDeviceDetect.isMobile ? "5px" : "0px",
	          backgroundColor: "rgb(30, 101, 144)",
	          margin: "5px"
	        }, _defineProperty(_ref2, "padding", "6px"), _defineProperty(_ref2, "fontWeight", "bold"), _defineProperty(_ref2, "color", "white"), _defineProperty(_ref2, "width", "100px"), _defineProperty(_ref2, "fontSize", "12px"), _ref2),
	        onClick: function onClick() {
	          _this2.sigCanvas.clear();
	          _this2.props.stateChangeHandler("", _this2.props.fieldName, false);
	        }
	      }, _react2.default.createElement("div", null, _react2.default.createElement("i", { className: "fa fa-trash" }), " ", "CLEAR"), _react2.default.createElement("div", null, "মুছে ফেলুন")), _react2.default.createElement("div", { style: { margin: "auto", fontSize: "12px" } }, _react2.default.createElement("div", null, "SIGNATURE BELOW"), _react2.default.createElement("div", null, "এইখানে সাইন করুন"))), _react2.default.createElement(_reactSignatureCanvas2.default, {
	        penColor: "blue",
	        canvasProps: {
	          className: "sigPad"
	        },
	        ref: function ref(_ref3) {
	          _this2.sigCanvas = _ref3;
	        },
	        onEnd: function onEnd() {
	          //console.log(this.sigCanvas.toDataURL());
	          _this2.props.stateChangeHandler(_this2.sigCanvas.toDataURL(), _this2.props.fieldName, false);
	        }
	      })), _react2.default.createElement("input", {
	        type: "file",
	        accept: "image/*",
	        id: "uploader" + this.props.fieldName,
	        onChange: function onChange(evt) {
	          console.log("clicked");
	          //console.log("triggering main function");
	          event.preventDefault();
	
	          if (evt.target.files[0]) {
	            _this2.uploadImage(evt.target.files);
	          } else {
	            console.log("gotcha");
	          }
	        },
	        style: {
	          visibility: "hidden"
	        }
	      }));
	    }
	  }]);
	
	  return PhotoUploadPass;
	}(_react.Component);
	
	exports.default = (0, _recompose.compose)((0, _reactRedux.connect)(null, null), _Firebase.withFirebase)(PhotoUploadPass);

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SingleRecord = __webpack_require__(77);
	
	var _SingleRecord2 = _interopRequireDefault(_SingleRecord);
	
	var _User = __webpack_require__(304);
	
	var _User2 = _interopRequireDefault(_User);
	
	var _CreateTable = __webpack_require__(291);
	
	var _CreateTable2 = _interopRequireDefault(_CreateTable);
	
	var _CreateMenu = __webpack_require__(290);
	
	var _CreateMenu2 = _interopRequireDefault(_CreateMenu);
	
	var _extendedOgDef = __webpack_require__(26);
	
	var _extendedOgDef2 = _interopRequireDefault(_extendedOgDef);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var getEditView = function getEditView(tableName, cancelHandler, deleteHandler, createTableList, genNotification) {
	  var ogTableDef = (0, _extendedOgDef2.default)(createTableList);
	  //console.log("opening edit view");
	  if (tableName === "attendance") {
	    return _react2.default.createElement("div", null, _react2.default.createElement(Attendance, {
	      path: tableName,
	      handleEditCancel: cancelHandler,
	      handleDelete: deleteHandler,
	      ogTableDef: ogTableDef,
	      genNotification: genNotification
	    }));
	  } else if (tableName === "projectInvoices") {
	    return _react2.default.createElement("div", null, _react2.default.createElement(Invoices, {
	      path: tableName,
	      handleEditCancel: cancelHandler,
	      handleDelete: deleteHandler,
	      ogTableDef: ogTableDef,
	      genNotification: genNotification
	    }));
	  } else if (tableName === "projectQuotes") {} else if (tableName === "accountEnquiry") {
	    return _react2.default.createElement("div", null, _react2.default.createElement(AccountEnquiry, {
	      path: tableName,
	      handleEditCancel: cancelHandler,
	      handleDelete: deleteHandler,
	      ogTableDef: ogTableDef,
	      genNotification: genNotification
	    }));
	  } else if (tableName === "projectQuotes") {
	    return _react2.default.createElement("div", null, _react2.default.createElement(Quotations, {
	      path: tableName,
	      handleEditCancel: cancelHandler,
	      handleDelete: deleteHandler,
	      ogTableDef: ogTableDef,
	      genNotification: genNotification
	    }));
	  } else if (tableName === "projectPos") {
	    return _react2.default.createElement("div", null, _react2.default.createElement(PurchaseOrders, {
	      path: tableName,
	      handleEditCancel: cancelHandler,
	      handleDelete: deleteHandler,
	      ogTableDef: ogTableDef,
	      genNotification: genNotification
	    }));
	  } else if (tableName === "projectDos") {
	    return _react2.default.createElement("div", null, _react2.default.createElement(DeliveryOrders, {
	      path: tableName,
	      handleEditCancel: cancelHandler,
	      handleDelete: deleteHandler,
	      ogTableDef: ogTableDef,
	      genNotification: genNotification
	    }));
	  } else if (tableName === "users") {
	    return _react2.default.createElement("div", null, _react2.default.createElement(_User2.default, {
	      path: tableName,
	      handleEditCancel: cancelHandler,
	      handleDelete: deleteHandler,
	      ogTableDef: ogTableDef,
	      genNotification: genNotification
	    }));
	  } else if (tableName === "projectQuotes") {
	    return _react2.default.createElement("div", null, _react2.default.createElement(Quotations, {
	      path: tableName,
	      handleEditCancel: cancelHandler,
	      handleDelete: deleteHandler,
	      ogTableDef: ogTableDef,
	      genNotification: genNotification
	    }));
	  } else if (tableName === "reports") {
	    return _react2.default.createElement("div", null, _react2.default.createElement(ReportBuilder, {
	      path: tableName,
	      handleEditCancel: cancelHandler,
	      handleDelete: deleteHandler,
	      ogTableDef: ogTableDef
	    }));
	  } else if (tableName === "createTable") {
	    return _react2.default.createElement("div", null, _react2.default.createElement(_CreateTable2.default, {
	      path: tableName,
	      handleEditCancel: cancelHandler,
	      handleDelete: deleteHandler,
	      ogTableDef: ogTableDef
	    }));
	  } else if (tableName === "menuDesigner") {
	    return _react2.default.createElement("div", null, _react2.default.createElement(_CreateMenu2.default, {
	      path: tableName,
	      handleEditCancel: cancelHandler,
	      handleDelete: deleteHandler,
	      ogTableDef: ogTableDef
	    }));
	  } else {
	    return _react2.default.createElement("div", null, _react2.default.createElement(_SingleRecord2.default, {
	      path: tableName,
	      handleEditCancel: cancelHandler,
	      handleDelete: deleteHandler,
	      ogTableDef: ogTableDef,
	      genNotification: genNotification
	    }));
	  }
	};
	
	exports.default = getEditView;

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(12);
	
	Object.defineProperty(exports, 'isMaxDate', {
	  enumerable: true,
	  get: function get() {
	    return _propTypes.isMaxDate;
	  }
	});
	Object.defineProperty(exports, 'isMinDate', {
	  enumerable: true,
	  get: function get() {
	    return _propTypes.isMinDate;
	  }
	});
	
	var _propTypes2 = __webpack_require__(49);
	
	Object.defineProperty(exports, 'isValueType', {
	  enumerable: true,
	  get: function get() {
	    return _propTypes2.isValueType;
	  }
	});

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var colorString = __webpack_require__(362);
	var convert = __webpack_require__(35);
	
	var _slice = [].slice;
	
	var skippedModels = [
		// to be honest, I don't really feel like keyword belongs in color convert, but eh.
		'keyword',
	
		// gray conflicts with some method names, and has its own method defined.
		'gray',
	
		// shouldn't really be in color-convert either...
		'hex'
	];
	
	var hashedModelKeys = {};
	Object.keys(convert).forEach(function (model) {
		hashedModelKeys[_slice.call(convert[model].labels).sort().join('')] = model;
	});
	
	var limiters = {};
	
	function Color(obj, model) {
		if (!(this instanceof Color)) {
			return new Color(obj, model);
		}
	
		if (model && model in skippedModels) {
			model = null;
		}
	
		if (model && !(model in convert)) {
			throw new Error('Unknown model: ' + model);
		}
	
		var i;
		var channels;
	
		if (obj == null) { // eslint-disable-line no-eq-null,eqeqeq
			this.model = 'rgb';
			this.color = [0, 0, 0];
			this.valpha = 1;
		} else if (obj instanceof Color) {
			this.model = obj.model;
			this.color = obj.color.slice();
			this.valpha = obj.valpha;
		} else if (typeof obj === 'string') {
			var result = colorString.get(obj);
			if (result === null) {
				throw new Error('Unable to parse color from string: ' + obj);
			}
	
			this.model = result.model;
			channels = convert[this.model].channels;
			this.color = result.value.slice(0, channels);
			this.valpha = typeof result.value[channels] === 'number' ? result.value[channels] : 1;
		} else if (obj.length) {
			this.model = model || 'rgb';
			channels = convert[this.model].channels;
			var newArr = _slice.call(obj, 0, channels);
			this.color = zeroArray(newArr, channels);
			this.valpha = typeof obj[channels] === 'number' ? obj[channels] : 1;
		} else if (typeof obj === 'number') {
			// this is always RGB - can be converted later on.
			obj &= 0xFFFFFF;
			this.model = 'rgb';
			this.color = [
				(obj >> 16) & 0xFF,
				(obj >> 8) & 0xFF,
				obj & 0xFF
			];
			this.valpha = 1;
		} else {
			this.valpha = 1;
	
			var keys = Object.keys(obj);
			if ('alpha' in obj) {
				keys.splice(keys.indexOf('alpha'), 1);
				this.valpha = typeof obj.alpha === 'number' ? obj.alpha : 0;
			}
	
			var hashedKeys = keys.sort().join('');
			if (!(hashedKeys in hashedModelKeys)) {
				throw new Error('Unable to parse color from object: ' + JSON.stringify(obj));
			}
	
			this.model = hashedModelKeys[hashedKeys];
	
			var labels = convert[this.model].labels;
			var color = [];
			for (i = 0; i < labels.length; i++) {
				color.push(obj[labels[i]]);
			}
	
			this.color = zeroArray(color);
		}
	
		// perform limitations (clamping, etc.)
		if (limiters[this.model]) {
			channels = convert[this.model].channels;
			for (i = 0; i < channels; i++) {
				var limit = limiters[this.model][i];
				if (limit) {
					this.color[i] = limit(this.color[i]);
				}
			}
		}
	
		this.valpha = Math.max(0, Math.min(1, this.valpha));
	
		if (Object.freeze) {
			Object.freeze(this);
		}
	}
	
	Color.prototype = {
		toString: function () {
			return this.string();
		},
	
		toJSON: function () {
			return this[this.model]();
		},
	
		string: function (places) {
			var self = this.model in colorString.to ? this : this.rgb();
			self = self.round(typeof places === 'number' ? places : 1);
			var args = self.valpha === 1 ? self.color : self.color.concat(this.valpha);
			return colorString.to[self.model](args);
		},
	
		percentString: function (places) {
			var self = this.rgb().round(typeof places === 'number' ? places : 1);
			var args = self.valpha === 1 ? self.color : self.color.concat(this.valpha);
			return colorString.to.rgb.percent(args);
		},
	
		array: function () {
			return this.valpha === 1 ? this.color.slice() : this.color.concat(this.valpha);
		},
	
		object: function () {
			var result = {};
			var channels = convert[this.model].channels;
			var labels = convert[this.model].labels;
	
			for (var i = 0; i < channels; i++) {
				result[labels[i]] = this.color[i];
			}
	
			if (this.valpha !== 1) {
				result.alpha = this.valpha;
			}
	
			return result;
		},
	
		unitArray: function () {
			var rgb = this.rgb().color;
			rgb[0] /= 255;
			rgb[1] /= 255;
			rgb[2] /= 255;
	
			if (this.valpha !== 1) {
				rgb.push(this.valpha);
			}
	
			return rgb;
		},
	
		unitObject: function () {
			var rgb = this.rgb().object();
			rgb.r /= 255;
			rgb.g /= 255;
			rgb.b /= 255;
	
			if (this.valpha !== 1) {
				rgb.alpha = this.valpha;
			}
	
			return rgb;
		},
	
		round: function (places) {
			places = Math.max(places || 0, 0);
			return new Color(this.color.map(roundToPlace(places)).concat(this.valpha), this.model);
		},
	
		alpha: function (val) {
			if (arguments.length) {
				return new Color(this.color.concat(Math.max(0, Math.min(1, val))), this.model);
			}
	
			return this.valpha;
		},
	
		// rgb
		red: getset('rgb', 0, maxfn(255)),
		green: getset('rgb', 1, maxfn(255)),
		blue: getset('rgb', 2, maxfn(255)),
	
		hue: getset(['hsl', 'hsv', 'hsl', 'hwb', 'hcg'], 0, function (val) { return ((val % 360) + 360) % 360; }), // eslint-disable-line brace-style
	
		saturationl: getset('hsl', 1, maxfn(100)),
		lightness: getset('hsl', 2, maxfn(100)),
	
		saturationv: getset('hsv', 1, maxfn(100)),
		value: getset('hsv', 2, maxfn(100)),
	
		chroma: getset('hcg', 1, maxfn(100)),
		gray: getset('hcg', 2, maxfn(100)),
	
		white: getset('hwb', 1, maxfn(100)),
		wblack: getset('hwb', 2, maxfn(100)),
	
		cyan: getset('cmyk', 0, maxfn(100)),
		magenta: getset('cmyk', 1, maxfn(100)),
		yellow: getset('cmyk', 2, maxfn(100)),
		black: getset('cmyk', 3, maxfn(100)),
	
		x: getset('xyz', 0, maxfn(100)),
		y: getset('xyz', 1, maxfn(100)),
		z: getset('xyz', 2, maxfn(100)),
	
		l: getset('lab', 0, maxfn(100)),
		a: getset('lab', 1),
		b: getset('lab', 2),
	
		keyword: function (val) {
			if (arguments.length) {
				return new Color(val);
			}
	
			return convert[this.model].keyword(this.color);
		},
	
		hex: function (val) {
			if (arguments.length) {
				return new Color(val);
			}
	
			return colorString.to.hex(this.rgb().round().color);
		},
	
		rgbNumber: function () {
			var rgb = this.rgb().color;
			return ((rgb[0] & 0xFF) << 16) | ((rgb[1] & 0xFF) << 8) | (rgb[2] & 0xFF);
		},
	
		luminosity: function () {
			// http://www.w3.org/TR/WCAG20/#relativeluminancedef
			var rgb = this.rgb().color;
	
			var lum = [];
			for (var i = 0; i < rgb.length; i++) {
				var chan = rgb[i] / 255;
				lum[i] = (chan <= 0.03928) ? chan / 12.92 : Math.pow(((chan + 0.055) / 1.055), 2.4);
			}
	
			return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
		},
	
		contrast: function (color2) {
			// http://www.w3.org/TR/WCAG20/#contrast-ratiodef
			var lum1 = this.luminosity();
			var lum2 = color2.luminosity();
	
			if (lum1 > lum2) {
				return (lum1 + 0.05) / (lum2 + 0.05);
			}
	
			return (lum2 + 0.05) / (lum1 + 0.05);
		},
	
		level: function (color2) {
			var contrastRatio = this.contrast(color2);
			if (contrastRatio >= 7.1) {
				return 'AAA';
			}
	
			return (contrastRatio >= 4.5) ? 'AA' : '';
		},
	
		isDark: function () {
			// YIQ equation from http://24ways.org/2010/calculating-color-contrast
			var rgb = this.rgb().color;
			var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
			return yiq < 128;
		},
	
		isLight: function () {
			return !this.isDark();
		},
	
		negate: function () {
			var rgb = this.rgb();
			for (var i = 0; i < 3; i++) {
				rgb.color[i] = 255 - rgb.color[i];
			}
			return rgb;
		},
	
		lighten: function (ratio) {
			var hsl = this.hsl();
			hsl.color[2] += hsl.color[2] * ratio;
			return hsl;
		},
	
		darken: function (ratio) {
			var hsl = this.hsl();
			hsl.color[2] -= hsl.color[2] * ratio;
			return hsl;
		},
	
		saturate: function (ratio) {
			var hsl = this.hsl();
			hsl.color[1] += hsl.color[1] * ratio;
			return hsl;
		},
	
		desaturate: function (ratio) {
			var hsl = this.hsl();
			hsl.color[1] -= hsl.color[1] * ratio;
			return hsl;
		},
	
		whiten: function (ratio) {
			var hwb = this.hwb();
			hwb.color[1] += hwb.color[1] * ratio;
			return hwb;
		},
	
		blacken: function (ratio) {
			var hwb = this.hwb();
			hwb.color[2] += hwb.color[2] * ratio;
			return hwb;
		},
	
		grayscale: function () {
			// http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
			var rgb = this.rgb().color;
			var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
			return Color.rgb(val, val, val);
		},
	
		fade: function (ratio) {
			return this.alpha(this.valpha - (this.valpha * ratio));
		},
	
		opaquer: function (ratio) {
			return this.alpha(this.valpha + (this.valpha * ratio));
		},
	
		rotate: function (degrees) {
			var hsl = this.hsl();
			var hue = hsl.color[0];
			hue = (hue + degrees) % 360;
			hue = hue < 0 ? 360 + hue : hue;
			hsl.color[0] = hue;
			return hsl;
		},
	
		mix: function (mixinColor, weight) {
			// ported from sass implementation in C
			// https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
			if (!mixinColor || !mixinColor.rgb) {
				throw new Error('Argument to "mix" was not a Color instance, but rather an instance of ' + typeof mixinColor);
			}
			var color1 = mixinColor.rgb();
			var color2 = this.rgb();
			var p = weight === undefined ? 0.5 : weight;
	
			var w = 2 * p - 1;
			var a = color1.alpha() - color2.alpha();
	
			var w1 = (((w * a === -1) ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
			var w2 = 1 - w1;
	
			return Color.rgb(
					w1 * color1.red() + w2 * color2.red(),
					w1 * color1.green() + w2 * color2.green(),
					w1 * color1.blue() + w2 * color2.blue(),
					color1.alpha() * p + color2.alpha() * (1 - p));
		}
	};
	
	// model conversion methods and static constructors
	Object.keys(convert).forEach(function (model) {
		if (skippedModels.indexOf(model) !== -1) {
			return;
		}
	
		var channels = convert[model].channels;
	
		// conversion methods
		Color.prototype[model] = function () {
			if (this.model === model) {
				return new Color(this);
			}
	
			if (arguments.length) {
				return new Color(arguments, model);
			}
	
			var newAlpha = typeof arguments[channels] === 'number' ? channels : this.valpha;
			return new Color(assertArray(convert[this.model][model].raw(this.color)).concat(newAlpha), model);
		};
	
		// 'static' construction methods
		Color[model] = function (color) {
			if (typeof color === 'number') {
				color = zeroArray(_slice.call(arguments), channels);
			}
			return new Color(color, model);
		};
	});
	
	function roundTo(num, places) {
		return Number(num.toFixed(places));
	}
	
	function roundToPlace(places) {
		return function (num) {
			return roundTo(num, places);
		};
	}
	
	function getset(model, channel, modifier) {
		model = Array.isArray(model) ? model : [model];
	
		model.forEach(function (m) {
			(limiters[m] || (limiters[m] = []))[channel] = modifier;
		});
	
		model = model[0];
	
		return function (val) {
			var result;
	
			if (arguments.length) {
				if (modifier) {
					val = modifier(val);
				}
	
				result = this[model]();
				result.color[channel] = val;
				return result;
			}
	
			result = this[model]().color[channel];
			if (modifier) {
				result = modifier(result);
			}
	
			return result;
		};
	}
	
	function maxfn(max) {
		return function (v) {
			return Math.max(0, Math.min(max, v));
		};
	}
	
	function assertArray(val) {
		return Array.isArray(val) ? val : [val];
	}
	
	function zeroArray(arr, length) {
		for (var i = 0; i < length; i++) {
			if (typeof arr[i] !== 'number') {
				arr[i] = 0;
			}
		}
	
		return arr;
	}
	
	module.exports = Color;


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.go = exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getUserConfirmation = exports.getCurrentLocation = undefined;
	
	var _LocationUtils = __webpack_require__(44);
	
	var _DOMUtils = __webpack_require__(84);
	
	var _DOMStateStorage = __webpack_require__(166);
	
	var _PathUtils = __webpack_require__(28);
	
	var _ExecutionEnvironment = __webpack_require__(112);
	
	var PopStateEvent = 'popstate';
	var HashChangeEvent = 'hashchange';
	
	var needsHashchangeListener = _ExecutionEnvironment.canUseDOM && !(0, _DOMUtils.supportsPopstateOnHashchange)();
	
	var _createLocation = function _createLocation(historyState) {
	  var key = historyState && historyState.key;
	
	  return (0, _LocationUtils.createLocation)({
	    pathname: window.location.pathname,
	    search: window.location.search,
	    hash: window.location.hash,
	    state: key ? (0, _DOMStateStorage.readState)(key) : undefined
	  }, undefined, key);
	};
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
	  var historyState = void 0;
	  try {
	    historyState = window.history.state || {};
	  } catch (error) {
	    // IE 11 sometimes throws when accessing window.history.state
	    // See https://github.com/ReactTraining/history/pull/289
	    historyState = {};
	  }
	
	  return _createLocation(historyState);
	};
	
	var getUserConfirmation = exports.getUserConfirmation = function getUserConfirmation(message, callback) {
	  return callback(window.confirm(message));
	}; // eslint-disable-line no-alert
	
	var startListener = exports.startListener = function startListener(listener) {
	  var handlePopState = function handlePopState(event) {
	    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) // Ignore extraneous popstate events in WebKit
	      return;
	    listener(_createLocation(event.state));
	  };
	
	  (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);
	
	  var handleUnpoppedHashChange = function handleUnpoppedHashChange() {
	    return listener(getCurrentLocation());
	  };
	
	  if (needsHashchangeListener) {
	    (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
	  }
	
	  return function () {
	    (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);
	
	    if (needsHashchangeListener) {
	      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
	    }
	  };
	};
	
	var updateLocation = function updateLocation(location, updateState) {
	  var state = location.state,
	      key = location.key;
	
	
	  if (state !== undefined) (0, _DOMStateStorage.saveState)(key, state);
	
	  updateState({ key: key }, (0, _PathUtils.createPath)(location));
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location) {
	  return updateLocation(location, function (state, path) {
	    return window.history.pushState(state, null, path);
	  });
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
	  return updateLocation(location, function (state, path) {
	    return window.history.replaceState(state, null, path);
	  });
	};
	
	var go = exports.go = function go(n) {
	  if (n) window.history.go(n);
	};

/***/ }),
/* 112 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(389);
	
	var _PathUtils = __webpack_require__(28);
	
	var _runTransitionHook = __webpack_require__(114);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _Actions = __webpack_require__(83);
	
	var _LocationUtils = __webpack_require__(44);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createHistory = function createHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var getCurrentLocation = options.getCurrentLocation,
	      getUserConfirmation = options.getUserConfirmation,
	      pushLocation = options.pushLocation,
	      replaceLocation = options.replaceLocation,
	      go = options.go,
	      keyLength = options.keyLength;
	
	
	  var currentLocation = void 0;
	  var pendingLocation = void 0;
	  var beforeListeners = [];
	  var listeners = [];
	  var allKeys = [];
	
	  var getCurrentIndex = function getCurrentIndex() {
	    if (pendingLocation && pendingLocation.action === _Actions.POP) return allKeys.indexOf(pendingLocation.key);
	
	    if (currentLocation) return allKeys.indexOf(currentLocation.key);
	
	    return -1;
	  };
	
	  var updateLocation = function updateLocation(nextLocation) {
	    var currentIndex = getCurrentIndex();
	
	    currentLocation = nextLocation;
	
	    if (currentLocation.action === _Actions.PUSH) {
	      allKeys = [].concat(allKeys.slice(0, currentIndex + 1), [currentLocation.key]);
	    } else if (currentLocation.action === _Actions.REPLACE) {
	      allKeys[currentIndex] = currentLocation.key;
	    }
	
	    listeners.forEach(function (listener) {
	      return listener(currentLocation);
	    });
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    beforeListeners.push(listener);
	
	    return function () {
	      return beforeListeners = beforeListeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var listen = function listen(listener) {
	    listeners.push(listener);
	
	    return function () {
	      return listeners = listeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var confirmTransitionTo = function confirmTransitionTo(location, callback) {
	    (0, _AsyncUtils.loopAsync)(beforeListeners.length, function (index, next, done) {
	      (0, _runTransitionHook2.default)(beforeListeners[index], location, function (result) {
	        return result != null ? done(result) : next();
	      });
	    }, function (message) {
	      if (getUserConfirmation && typeof message === 'string') {
	        getUserConfirmation(message, function (ok) {
	          return callback(ok !== false);
	        });
	      } else {
	        callback(message !== false);
	      }
	    });
	  };
	
	  var transitionTo = function transitionTo(nextLocation) {
	    if (currentLocation && (0, _LocationUtils.locationsAreEqual)(currentLocation, nextLocation) || pendingLocation && (0, _LocationUtils.locationsAreEqual)(pendingLocation, nextLocation)) return; // Nothing to do
	
	    pendingLocation = nextLocation;
	
	    confirmTransitionTo(nextLocation, function (ok) {
	      if (pendingLocation !== nextLocation) return; // Transition was interrupted during confirmation
	
	      pendingLocation = null;
	
	      if (ok) {
	        // Treat PUSH to same path like REPLACE to be consistent with browsers
	        if (nextLocation.action === _Actions.PUSH) {
	          var prevPath = (0, _PathUtils.createPath)(currentLocation);
	          var nextPath = (0, _PathUtils.createPath)(nextLocation);
	
	          if (nextPath === prevPath && (0, _LocationUtils.statesAreEqual)(currentLocation.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
	        }
	
	        if (nextLocation.action === _Actions.POP) {
	          updateLocation(nextLocation);
	        } else if (nextLocation.action === _Actions.PUSH) {
	          if (pushLocation(nextLocation) !== false) updateLocation(nextLocation);
	        } else if (nextLocation.action === _Actions.REPLACE) {
	          if (replaceLocation(nextLocation) !== false) updateLocation(nextLocation);
	        }
	      } else if (currentLocation && nextLocation.action === _Actions.POP) {
	        var prevIndex = allKeys.indexOf(currentLocation.key);
	        var nextIndex = allKeys.indexOf(nextLocation.key);
	
	        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL
	      }
	    });
	  };
	
	  var push = function push(input) {
	    return transitionTo(createLocation(input, _Actions.PUSH));
	  };
	
	  var replace = function replace(input) {
	    return transitionTo(createLocation(input, _Actions.REPLACE));
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var createKey = function createKey() {
	    return Math.random().toString(36).substr(2, keyLength || 6);
	  };
	
	  var createHref = function createHref(location) {
	    return (0, _PathUtils.createPath)(location);
	  };
	
	  var createLocation = function createLocation(location, action) {
	    var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : createKey();
	    return (0, _LocationUtils.createLocation)(location, action, key);
	  };
	
	  return {
	    getCurrentLocation: getCurrentLocation,
	    listenBefore: listenBefore,
	    listen: listen,
	    transitionTo: transitionTo,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    createKey: createKey,
	    createPath: _PathUtils.createPath,
	    createHref: createHref,
	    createLocation: createLocation
	  };
	};
	
	exports.default = createHistory;

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(32);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var runTransitionHook = function runTransitionHook(hook, location, callback) {
	  var result = hook(location, callback);
	
	  if (hook.length < 2) {
	    // Assume the hook runs synchronously and automatically
	    // call the callback with the return value.
	    callback(result);
	  } else {
	     false ? (0, _warning2.default)(result === undefined, 'You should not "return" in a transition hook with a callback argument; ' + 'call the callback instead') : void 0;
	  }
	};
	
	exports.default = runTransitionHook;

/***/ }),
/* 115 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    symbolTag = '[object Symbol]';
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	/**
	 * A specialized version of `_.includes` for arrays without support for
	 * specifying an index to search from.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludes(array, value) {
	  var length = array ? array.length : 0;
	  return !!length && baseIndexOf(array, value, 0) > -1;
	}
	
	/**
	 * This function is like `arrayIncludes` except that it accepts a comparator.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @param {Function} comparator The comparator invoked per element.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludesWith(array, value, comparator) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  while (++index < length) {
	    if (comparator(value, array[index])) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array ? array.length : 0,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  if (value !== value) {
	    return baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.isNaN` without support for number objects.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 */
	function baseIsNaN(value) {
	  return value !== value;
	}
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	/**
	 * Checks if a cache value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var Symbol = root.Symbol,
	    getPrototype = overArg(Object.getPrototypeOf, Object),
	    propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    splice = arrayProto.splice,
	    spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols,
	    nativeMax = Math.max;
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map'),
	    nativeCreate = getNative(Object, 'create');
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	}
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  return this.has(key) && delete this.__data__[key];
	}
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	}
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	}
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  return true;
	}
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  return getMapData(this, key)['delete'](key);
	}
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  getMapData(this, key).set(key, value);
	  return this;
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values ? values.length : 0;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  // Safari 9 makes `arguments.length` enumerable in strict mode.
	  var result = (isArray(value) || isArguments(value))
	    ? baseTimes(value.length, String)
	    : [];
	
	  var length = result.length,
	      skipIndexes = !!length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of methods like `_.difference` without support
	 * for excluding multiple arrays or iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Array} values The values to exclude.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new array of filtered values.
	 */
	function baseDifference(array, values, iteratee, comparator) {
	  var index = -1,
	      includes = arrayIncludes,
	      isCommon = true,
	      length = array.length,
	      result = [],
	      valuesLength = values.length;
	
	  if (!length) {
	    return result;
	  }
	  if (iteratee) {
	    values = arrayMap(values, baseUnary(iteratee));
	  }
	  if (comparator) {
	    includes = arrayIncludesWith;
	    isCommon = false;
	  }
	  else if (values.length >= LARGE_ARRAY_SIZE) {
	    includes = cacheHas;
	    isCommon = false;
	    values = new SetCache(values);
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value) : value;
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (isCommon && computed === computed) {
	      var valuesIndex = valuesLength;
	      while (valuesIndex--) {
	        if (values[valuesIndex] === computed) {
	          continue outer;
	        }
	      }
	      result.push(value);
	    }
	    else if (!includes(values, computed, comparator)) {
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.pick` without support for individual
	 * property identifiers.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {string[]} props The property identifiers to pick.
	 * @returns {Object} Returns the new object.
	 */
	function basePick(object, props) {
	  object = Object(object);
	  return basePickBy(object, props, function(value, key) {
	    return key in object;
	  });
	}
	
	/**
	 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {string[]} props The property identifiers to pick from.
	 * @param {Function} predicate The function invoked per property.
	 * @returns {Object} Returns the new object.
	 */
	function basePickBy(object, props, predicate) {
	  var index = -1,
	      length = props.length,
	      result = {};
	
	  while (++index < length) {
	    var key = props[index],
	        value = object[key];
	
	    if (predicate(value, key)) {
	      result[key] = value;
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = array;
	    return apply(func, this, otherArgs);
	  };
	}
	
	/**
	 * Creates an array of own and inherited enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeysIn(object) {
	  return baseGetAllKeys(object, keysIn, getSymbolsIn);
	}
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * Creates an array of the own enumerable symbol properties of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;
	
	/**
	 * Creates an array of the own and inherited enumerable symbol properties
	 * of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	  var result = [];
	  while (object) {
	    arrayPush(result, getSymbols(object));
	    object = getPrototype(object);
	  }
	  return result;
	};
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	/**
	 * The opposite of `_.pick`; this method creates an object composed of the
	 * own and inherited enumerable string keyed properties of `object` that are
	 * not omitted.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {...(string|string[])} [props] The property identifiers to omit.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.omit(object, ['a', 'c']);
	 * // => { 'b': '2' }
	 */
	var omit = baseRest(function(object, props) {
	  if (object == null) {
	    return {};
	  }
	  props = arrayMap(baseFlatten(props, 1), toKey);
	  return basePick(object, baseDifference(getAllKeysIn(object), props));
	});
	
	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = omit;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 116 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    symbolTag = '[object Symbol]';
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array ? array.length : 0,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var Symbol = root.Symbol,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.pick` without support for individual
	 * property identifiers.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {string[]} props The property identifiers to pick.
	 * @returns {Object} Returns the new object.
	 */
	function basePick(object, props) {
	  object = Object(object);
	  return basePickBy(object, props, function(value, key) {
	    return key in object;
	  });
	}
	
	/**
	 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {string[]} props The property identifiers to pick from.
	 * @param {Function} predicate The function invoked per property.
	 * @returns {Object} Returns the new object.
	 */
	function basePickBy(object, props, predicate) {
	  var index = -1,
	      length = props.length,
	      result = {};
	
	  while (++index < length) {
	    var key = props[index],
	        value = object[key];
	
	    if (predicate(value, key)) {
	      result[key] = value;
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = array;
	    return apply(func, this, otherArgs);
	  };
	}
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Creates an object composed of the picked `object` properties.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {...(string|string[])} [props] The property identifiers to pick.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.pick(object, ['a', 'c']);
	 * // => { 'a': 1, 'c': 3 }
	 */
	var pick = baseRest(function(object, props) {
	  return object == null ? {} : basePick(object, arrayMap(baseFlatten(props, 1), toKey));
	});
	
	module.exports = pick;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 117 */
/***/ (function(module, exports) {

	'use strict';
	
	function areInputsEqual(newInputs, lastInputs) {
	    if (newInputs.length !== lastInputs.length) {
	        return false;
	    }
	    for (var i = 0; i < newInputs.length; i++) {
	        if (newInputs[i] !== lastInputs[i]) {
	            return false;
	        }
	    }
	    return true;
	}
	
	function memoizeOne(resultFn, isEqual) {
	    if (isEqual === void 0) { isEqual = areInputsEqual; }
	    var lastThis;
	    var lastArgs = [];
	    var lastResult;
	    var calledOnce = false;
	    function memoized() {
	        var newArgs = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            newArgs[_i] = arguments[_i];
	        }
	        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) {
	            return lastResult;
	        }
	        lastResult = resultFn.apply(this, newArgs);
	        calledOnce = true;
	        lastThis = this;
	        lastArgs = newArgs;
	        return lastResult;
	    }
	    return memoized;
	}
	
	module.exports = memoizeOne;


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = Flex;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function toPercent(num) {
	  return "".concat(num, "%");
	}
	
	function Flex(_ref) {
	  var children = _ref.children,
	      className = _ref.className,
	      direction = _ref.direction,
	      count = _ref.count,
	      offset = _ref.offset,
	      style = _ref.style,
	      wrap = _ref.wrap,
	      otherProps = _objectWithoutProperties(_ref, ["children", "className", "direction", "count", "offset", "style", "wrap"]);
	
	  return _react["default"].createElement("div", _extends({
	    className: className,
	    style: _objectSpread({
	      display: 'flex',
	      flexDirection: direction,
	      flexWrap: wrap ? 'wrap' : 'no-wrap'
	    }, style)
	  }, otherProps), _react["default"].Children.map(children, function (child, index) {
	    return _react["default"].cloneElement(child, _objectSpread({}, child.props, {
	      style: {
	        flexBasis: toPercent(100 / count),
	        maxWidth: toPercent(100 / count),
	        overflow: 'hidden',
	        marginLeft: offset && index === 0 ? toPercent(100 * offset / count) : null
	      }
	    }));
	  }));
	}
	
	Flex.propTypes = {
	  children: _propTypes["default"].node,
	  className: _propTypes["default"].string,
	  count: _propTypes["default"].number.isRequired,
	  direction: _propTypes["default"].string,
	  offset: _propTypes["default"].number,
	  style: _propTypes["default"].objectOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])),
	  wrap: _propTypes["default"].bool
	};

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getTileClasses = exports.between = exports.doRangesOverlap = exports.isRangeWithinRange = exports.isValueWithinRange = exports.callIfDefined = exports.mergeFunctions = void 0;
	
	var _dates = __webpack_require__(15);
	
	/**
	 * Returns a function that, when called, calls all the functions
	 * passed to it, applying its arguments to them.
	 *
	 * @param {Function[]} functions
	 */
	var mergeFunctions = function mergeFunctions() {
	  for (var _len = arguments.length, functions = new Array(_len), _key = 0; _key < _len; _key++) {
	    functions[_key] = arguments[_key];
	  }
	
	  return function () {
	    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    return functions.filter(Boolean).forEach(function (f) {
	      return f.apply(void 0, args);
	    });
	  };
	};
	/**
	 * Calls a function, if it's defined, with specified arguments
	 * @param {Function} fn
	 * @param {Object} args
	 */
	
	
	exports.mergeFunctions = mergeFunctions;
	
	var callIfDefined = function callIfDefined(fn) {
	  if (fn && typeof fn === 'function') {
	    for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
	      args[_key3 - 1] = arguments[_key3];
	    }
	
	    fn.apply(void 0, args);
	  }
	};
	
	exports.callIfDefined = callIfDefined;
	
	var isValueWithinRange = function isValueWithinRange(value, range) {
	  return range[0] <= value && range[1] >= value;
	};
	
	exports.isValueWithinRange = isValueWithinRange;
	
	var isRangeWithinRange = function isRangeWithinRange(greaterRange, smallerRange) {
	  return greaterRange[0] <= smallerRange[0] && greaterRange[1] >= smallerRange[1];
	};
	
	exports.isRangeWithinRange = isRangeWithinRange;
	
	var doRangesOverlap = function doRangesOverlap(range1, range2) {
	  return isValueWithinRange(range1[0], range2) || isValueWithinRange(range1[1], range2);
	};
	/**
	 * Returns a value no smaller than min and no larger than max.
	 *
	 * @param {*} value Value to return.
	 * @param {*} min Minimum return value.
	 * @param {*} max Maximum return value.
	 */
	
	
	exports.doRangesOverlap = doRangesOverlap;
	
	var between = function between(value, min, max) {
	  if (min && min > value) {
	    return min;
	  }
	
	  if (max && max < value) {
	    return max;
	  }
	
	  return value;
	};
	
	exports.between = between;
	
	var getTileClasses = function getTileClasses() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      value = _ref.value,
	      valueType = _ref.valueType,
	      date = _ref.date,
	      dateType = _ref.dateType,
	      hover = _ref.hover;
	
	  var className = 'react-calendar__tile';
	  var classes = [className];
	
	  if (!date) {
	    return classes;
	  }
	
	  if (!(date instanceof Array) && !dateType) {
	    throw new Error('getTileClasses(): Unable to get tile activity classes because one or more required arguments were not passed.');
	  }
	
	  var now = new Date();
	  var dateRange = date instanceof Array ? date : (0, _dates.getRange)(dateType, date);
	
	  if (isValueWithinRange(now, dateRange)) {
	    classes.push("".concat(className, "--now"));
	  }
	
	  if (!value) {
	    return classes;
	  }
	
	  if (!(value instanceof Array) && !valueType) {
	    throw new Error('getTileClasses(): Unable to get tile activity classes because one or more required arguments were not passed.');
	  }
	
	  var valueRange = value instanceof Array ? value : (0, _dates.getRange)(valueType, value);
	
	  if (isRangeWithinRange(valueRange, dateRange)) {
	    classes.push("".concat(className, "--active"));
	  } else if (doRangesOverlap(valueRange, dateRange)) {
	    classes.push("".concat(className, "--hasActive"));
	  } else if (hover && ( // Date before value
	  dateRange[1] < valueRange[0] && doRangesOverlap(dateRange, [hover, valueRange[0]]) || // Date after value
	  dateRange[0] > valueRange[1] && doRangesOverlap(dateRange, [valueRange[1], hover]))) {
	    classes.push("".concat(className, "--hover"));
	  }
	
	  var isRangeStart = isValueWithinRange(valueRange[0], dateRange);
	  var isRangeEnd = isValueWithinRange(valueRange[1], dateRange);
	
	  if (isRangeStart) {
	    classes.push("".concat(className, "--rangeStart"));
	  }
	
	  if (isRangeEnd) {
	    classes.push("".concat(className, "--rangeEnd"));
	  }
	
	  if (isRangeStart && isRangeEnd) {
	    classes.push("".concat(className, "--rangeBothEnds"));
	  }
	
	  return classes;
	};
	
	exports.getTileClasses = getTileClasses;

/***/ }),
/* 120 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getHours = getHours;
	exports.getMinutes = getMinutes;
	exports.getSeconds = getSeconds;
	var hourOptionalSecondsRegExp = /^(([0-1])?[0-9]|2[0-3]):[0-5][0-9](:([0-5][0-9]))?$/;
	var hourRegExp = /^(([0-1])?[0-9]|2[0-3]):[0-5][0-9]:([0-5][0-9])$/;
	
	function getHours(date) {
	  if (date instanceof Date) {
	    return date.getHours();
	  }
	
	  if (typeof date === 'string' && hourOptionalSecondsRegExp.test(date)) {
	    var hourString = date.split(':')[0];
	    return parseInt(hourString, 10);
	  }
	
	  throw new Error("Failed to get hours from date: ".concat(date, "."));
	}
	
	function getMinutes(date) {
	  if (date instanceof Date) {
	    return date.getMinutes();
	  }
	
	  if (typeof date === 'string' && hourOptionalSecondsRegExp.test(date)) {
	    var minuteString = date.split(':')[1];
	    return parseInt(minuteString, 10);
	  }
	
	  throw new Error("Failed to get minutes from date: ".concat(date, "."));
	}
	
	function getSeconds(date) {
	  if (date instanceof Date) {
	    return date.getSeconds();
	  }
	
	  if (typeof date === 'string') {
	    if (hourRegExp.test(date)) {
	      var secondString = date.split(':')[2];
	      return parseInt(secondString, 10);
	    }
	
	    if (hourOptionalSecondsRegExp.test(date)) {
	      return 0;
	    }
	  }
	
	  throw new Error("Failed to get seconds from date: ".concat(date, "."));
	}

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isMarkWidth = exports.isMarkLength = exports.isHandWidth = exports.isOppositeHandLength = exports.isHandLength = void 0;
	
	var _utils = __webpack_require__(430);
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	var isNumberBetween = function isNumberBetween(min, max) {
	  return function (props, propName, componentName) {
	    var value = props[propName];
	
	    if ((0, _utils.isDefined)(value)) {
	      if (typeof value !== 'number') {
	        return new Error("Invalid prop `".concat(propName, "` of type `").concat(_typeof(value), "` supplied to `").concat(componentName, "`, expected `number`."));
	      }
	
	      if (value < min || value > max) {
	        return new Error("Invalid prop `".concat(propName, "` of type `").concat(_typeof(value), "` supplied to `").concat(componentName, "`, length must be between ").concat(min, " and ").concat(max, "."));
	      }
	    } // Everything is fine
	
	
	    return null;
	  };
	};
	
	var isHandLength = isNumberBetween(0, 100);
	exports.isHandLength = isHandLength;
	var isOppositeHandLength = isNumberBetween(-100, 100);
	exports.isOppositeHandLength = isOppositeHandLength;
	
	var isHandWidth = function isHandWidth(props, propName, componentName) {
	  var width = props[propName];
	
	  if ((0, _utils.isDefined)(width)) {
	    if (typeof width !== 'number') {
	      return new Error("Invalid prop `".concat(propName, "` of type `").concat(_typeof(width), "` supplied to `").concat(componentName, "`, expected `number`."));
	    }
	
	    if (width < 0) {
	      return new Error("Invalid prop `".concat(propName, "` of type `").concat(_typeof(width), "` supplied to `").concat(componentName, "`, width must be greater or equal to 0."));
	    }
	  } // Everything is fine
	
	
	  return null;
	};
	
	exports.isHandWidth = isHandWidth;
	var isMarkLength = isHandLength;
	exports.isMarkLength = isMarkLength;
	var isMarkWidth = isHandWidth;
	exports.isMarkWidth = isMarkWidth;

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = Input;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(1));
	
	var _mergeClassNames = _interopRequireDefault(__webpack_require__(29));
	
	var _updateInputWidth = _interopRequireWildcard(__webpack_require__(248));
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function select(element) {
	  if (!element) {
	    return;
	  }
	
	  requestAnimationFrame(function () {
	    return element.select();
	  });
	}
	
	function updateInputWidthOnFontLoad(element) {
	  if (!document.fonts) {
	    return;
	  }
	
	  var font = (0, _updateInputWidth.getFontShorthand)(element);
	
	  if (!font) {
	    return;
	  }
	
	  var isFontLoaded = document.fonts.check(font);
	
	  if (isFontLoaded) {
	    return;
	  }
	
	  function onLoadingDone() {
	    (0, _updateInputWidth["default"])(element);
	  }
	
	  document.fonts.addEventListener('loadingdone', onLoadingDone);
	}
	
	function Input(_ref) {
	  var ariaLabel = _ref.ariaLabel,
	      className = _ref.className,
	      disabled = _ref.disabled,
	      itemRef = _ref.itemRef,
	      max = _ref.max,
	      min = _ref.min,
	      name = _ref.name,
	      nameForClass = _ref.nameForClass,
	      onChange = _ref.onChange,
	      onKeyDown = _ref.onKeyDown,
	      _onKeyUp = _ref.onKeyUp,
	      placeholder = _ref.placeholder,
	      required = _ref.required,
	      showLeadingZeros = _ref.showLeadingZeros,
	      step = _ref.step,
	      value = _ref.value;
	  var hasLeadingZero = showLeadingZeros && value !== null && value < 10;
	  return [hasLeadingZero && _react["default"].createElement("span", {
	    key: "leadingZero",
	    className: "".concat(className, "__leadingZero")
	  }, "0"), _react["default"].createElement("input", {
	    key: "input",
	    "aria-label": ariaLabel,
	    autoComplete: "off",
	    className: (0, _mergeClassNames["default"])("".concat(className, "__input"), "".concat(className, "__").concat(nameForClass || name), hasLeadingZero && "".concat(className, "__input--hasLeadingZero")),
	    disabled: disabled,
	    max: max,
	    min: min,
	    name: name,
	    onChange: onChange,
	    onFocus: function onFocus(event) {
	      return select(event.target);
	    },
	    onKeyDown: onKeyDown,
	    onKeyUp: function onKeyUp(event) {
	      (0, _updateInputWidth["default"])(event.target);
	
	      if (_onKeyUp) {
	        _onKeyUp(event);
	      }
	    },
	    placeholder: placeholder,
	    ref: function ref(_ref2) {
	      if (_ref2) {
	        (0, _updateInputWidth["default"])(_ref2);
	        updateInputWidthOnFontLoad(_ref2);
	      }
	
	      if (itemRef) {
	        itemRef(_ref2, name);
	      }
	    },
	    required: required,
	    step: step,
	    type: "number",
	    value: value !== null ? value : ''
	  })];
	}
	
	Input.propTypes = {
	  className: _propTypes["default"].string.isRequired,
	  disabled: _propTypes["default"].bool,
	  itemRef: _propTypes["default"].func,
	  max: _propTypes["default"].number,
	  min: _propTypes["default"].number,
	  onChange: _propTypes["default"].func,
	  onKeyDown: _propTypes["default"].func,
	  onKeyUp: _propTypes["default"].func,
	  required: _propTypes["default"].bool,
	  showLeadingZeros: _propTypes["default"].bool,
	  step: _propTypes["default"].number,
	  value: _propTypes["default"].number
	};
	Input.defaultProps = {
	  placeholder: '--'
	};

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(442);
	} else {
	  module.exports = require('./cjs/react-is.development.js');
	}


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _skeleton.default;
	  }
	});
	Object.defineProperty(exports, "SkeletonTheme", {
	  enumerable: true,
	  get: function get() {
	    return _skeletonTheme.default;
	  }
	});
	
	var _skeleton = _interopRequireDefault(__webpack_require__(185));
	
	var _skeletonTheme = _interopRequireDefault(__webpack_require__(443));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 125 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.loopAsync = loopAsync;
	exports.mapAsync = mapAsync;
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var sync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  function done() {
	    isDone = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = [].concat(Array.prototype.slice.call(arguments));
	      return;
	    }
	
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) {
	      return;
	    }
	
	    hasNext = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      return;
	    }
	
	    sync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work.call(this, currentTurn++, next, done);
	    }
	
	    sync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(this, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  }
	
	  next();
	}
	
	function mapAsync(array, work, callback) {
	  var length = array.length;
	  var values = [];
	
	  if (length === 0) return callback(null, values);
	
	  var isDone = false,
	      doneCount = 0;
	
	  function done(index, error, value) {
	    if (isDone) return;
	
	    if (error) {
	      isDone = true;
	      callback(error);
	    } else {
	      values[index] = value;
	
	      isDone = ++doneCount === length;
	
	      if (isDone) callback(null, values);
	    }
	  }
	
	  array.forEach(function (item, index) {
	    work(item, index, function (error, value) {
	      done(index, error, value);
	    });
	  });
	}

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ContextProvider = ContextProvider;
	exports.ContextSubscriber = ContextSubscriber;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Works around issues with context updates failing to propagate.
	// Caveat: the context value is expected to never change its identity.
	// https://github.com/facebook/react/issues/2517
	// https://github.com/reactjs/react-router/issues/470
	
	var contextProviderShape = _propTypes2.default.shape({
	  subscribe: _propTypes2.default.func.isRequired,
	  eventIndex: _propTypes2.default.number.isRequired
	});
	
	function makeContextName(name) {
	  return '@@contextSubscriber/' + name;
	}
	
	var prefixUnsafeLifecycleMethods = parseFloat(_react2.default.version) >= 16.3;
	
	function ContextProvider(name) {
	  var _childContextTypes, _config;
	
	  var contextName = makeContextName(name);
	  var listenersKey = contextName + '/listeners';
	  var eventIndexKey = contextName + '/eventIndex';
	  var subscribeKey = contextName + '/subscribe';
	
	  var config = (_config = {
	    childContextTypes: (_childContextTypes = {}, _childContextTypes[contextName] = contextProviderShape.isRequired, _childContextTypes),
	
	    getChildContext: function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[contextName] = {
	        eventIndex: this[eventIndexKey],
	        subscribe: this[subscribeKey]
	      }, _ref;
	    },
	
	
	    // this method will be updated to UNSAFE_componentWillMount below for React versions >= 16.3
	    componentWillMount: function componentWillMount() {
	      this[listenersKey] = [];
	      this[eventIndexKey] = 0;
	    },
	
	
	    // this method will be updated to UNSAFE_componentWillReceiveProps below for React versions >= 16.3
	    componentWillReceiveProps: function componentWillReceiveProps() {
	      this[eventIndexKey]++;
	    },
	    componentDidUpdate: function componentDidUpdate() {
	      var _this = this;
	
	      this[listenersKey].forEach(function (listener) {
	        return listener(_this[eventIndexKey]);
	      });
	    }
	  }, _config[subscribeKey] = function (listener) {
	    var _this2 = this;
	
	    // No need to immediately call listener here.
	    this[listenersKey].push(listener);
	
	    return function () {
	      _this2[listenersKey] = _this2[listenersKey].filter(function (item) {
	        return item !== listener;
	      });
	    };
	  }, _config);
	
	  if (prefixUnsafeLifecycleMethods) {
	    config.UNSAFE_componentWillMount = config.componentWillMount;
	    config.UNSAFE_componentWillReceiveProps = config.componentWillReceiveProps;
	    delete config.componentWillMount;
	    delete config.componentWillReceiveProps;
	  }
	  return config;
	}
	
	function ContextSubscriber(name) {
	  var _contextTypes, _config2;
	
	  var contextName = makeContextName(name);
	  var lastRenderedEventIndexKey = contextName + '/lastRenderedEventIndex';
	  var handleContextUpdateKey = contextName + '/handleContextUpdate';
	  var unsubscribeKey = contextName + '/unsubscribe';
	
	  var config = (_config2 = {
	    contextTypes: (_contextTypes = {}, _contextTypes[contextName] = contextProviderShape, _contextTypes),
	
	    getInitialState: function getInitialState() {
	      var _ref2;
	
	      if (!this.context[contextName]) {
	        return {};
	      }
	
	      return _ref2 = {}, _ref2[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _ref2;
	    },
	    componentDidMount: function componentDidMount() {
	      if (!this.context[contextName]) {
	        return;
	      }
	
	      this[unsubscribeKey] = this.context[contextName].subscribe(this[handleContextUpdateKey]);
	    },
	
	
	    // this method will be updated to UNSAFE_componentWillReceiveProps below for React versions >= 16.3
	    componentWillReceiveProps: function componentWillReceiveProps() {
	      var _setState;
	
	      if (!this.context[contextName]) {
	        return;
	      }
	
	      this.setState((_setState = {}, _setState[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _setState));
	    },
	    componentWillUnmount: function componentWillUnmount() {
	      if (!this[unsubscribeKey]) {
	        return;
	      }
	
	      this[unsubscribeKey]();
	      this[unsubscribeKey] = null;
	    }
	  }, _config2[handleContextUpdateKey] = function (eventIndex) {
	    if (eventIndex !== this.state[lastRenderedEventIndexKey]) {
	      var _setState2;
	
	      this.setState((_setState2 = {}, _setState2[lastRenderedEventIndexKey] = eventIndex, _setState2));
	    }
	  }, _config2);
	
	  if (prefixUnsafeLifecycleMethods) {
	    config.UNSAFE_componentWillReceiveProps = config.componentWillReceiveProps;
	    delete config.componentWillReceiveProps;
	  }
	  return config;
	}

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationShape = exports.routerShape = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var routerShape = exports.routerShape = (0, _propTypes.shape)({
	  push: _propTypes.func.isRequired,
	  replace: _propTypes.func.isRequired,
	  go: _propTypes.func.isRequired,
	  goBack: _propTypes.func.isRequired,
	  goForward: _propTypes.func.isRequired,
	  setRouteLeaveHook: _propTypes.func.isRequired,
	  isActive: _propTypes.func.isRequired
	});
	
	var locationShape = exports.locationShape = (0, _propTypes.shape)({
	  pathname: _propTypes.string.isRequired,
	  search: _propTypes.string.isRequired,
	  state: _propTypes.object,
	  action: _propTypes.string.isRequired,
	  key: _propTypes.string
	});

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _invariant = __webpack_require__(14);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIs = __webpack_require__(123);
	
	var _createReactClass = __webpack_require__(24);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(1);
	
	var _getRouteParams = __webpack_require__(483);
	
	var _getRouteParams2 = _interopRequireDefault(_getRouteParams);
	
	var _ContextUtils = __webpack_require__(126);
	
	var _RouteUtils = __webpack_require__(31);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A <RouterContext> renders the component tree for a given router state
	 * and sets the history object and the current location in context.
	 */
	var RouterContext = (0, _createReactClass2.default)({
	  displayName: 'RouterContext',
	
	  mixins: [(0, _ContextUtils.ContextProvider)('router')],
	
	  propTypes: {
	    router: _propTypes.object.isRequired,
	    location: _propTypes.object.isRequired,
	    routes: _propTypes.array.isRequired,
	    params: _propTypes.object.isRequired,
	    components: _propTypes.array.isRequired,
	    createElement: _propTypes.func.isRequired
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      createElement: _react2.default.createElement
	    };
	  },
	
	
	  childContextTypes: {
	    router: _propTypes.object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    return {
	      router: this.props.router
	    };
	  },
	  createElement: function createElement(component, props) {
	    return component == null ? null : this.props.createElement(component, props);
	  },
	  render: function render() {
	    var _this = this;
	
	    var _props = this.props,
	        location = _props.location,
	        routes = _props.routes,
	        params = _props.params,
	        components = _props.components,
	        router = _props.router;
	
	    var element = null;
	
	    if (components) {
	      element = components.reduceRight(function (element, components, index) {
	        if (components == null) return element; // Don't create new children; use the grandchildren.
	
	        var route = routes[index];
	        var routeParams = (0, _getRouteParams2.default)(route, params);
	        var props = {
	          location: location,
	          params: params,
	          route: route,
	          router: router,
	          routeParams: routeParams,
	          routes: routes
	        };
	
	        if ((0, _RouteUtils.isReactChildren)(element)) {
	          props.children = element;
	        } else if (element) {
	          for (var prop in element) {
	            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
	          }
	        }
	
	        // Handle components is object for { [name]: component } but not valid element
	        // type of react, such as React.memo, React.lazy and so on.
	        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object' && !(0, _reactIs.isValidElementType)(components)) {
	          var elements = {};
	
	          for (var key in components) {
	            if (Object.prototype.hasOwnProperty.call(components, key)) {
	              // Pass through the key as a prop to createElement to allow
	              // custom createElement functions to know which named component
	              // they're rendering, for e.g. matching up to fetched data.
	              elements[key] = _this.createElement(components[key], _extends({
	                key: key }, props));
	            }
	          }
	
	          return elements;
	        }
	
	        return _this.createElement(components, props);
	      }, element);
	    }
	
	    !(element === null || element === false || _react2.default.isValidElement(element)) ?  false ? (0, _invariant2.default)(false, 'The root route must render a single element') : (0, _invariant2.default)(false) : void 0;
	
	    return element;
	  }
	});
	
	exports.default = RouterContext;
	module.exports = exports['default'];

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault(ex) {
	  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
	}
	
	var _typeof = _interopDefault(__webpack_require__(74)); // ==============================
	// NO OP
	// ==============================
	
	
	var noop = function noop() {}; // Class Name Prefixer
	// ==============================
	
	/**
	 String representation of component state for styling with class names.
	
	 Expects an array of strings OR a string/object pair:
	 - className(['comp', 'comp-arg', 'comp-arg-2'])
	   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
	 - className('comp', { some: true, state: false })
	   @returns 'react-select__comp react-select__comp--some'
	*/
	
	
	function applyPrefixToName(prefix, name) {
	  if (!name) {
	    return prefix;
	  } else if (name[0] === '-') {
	    return prefix + name;
	  } else {
	    return prefix + '__' + name;
	  }
	}
	
	function classNames(prefix, state, className) {
	  var arr = [className];
	
	  if (state && prefix) {
	    for (var key in state) {
	      if (state.hasOwnProperty(key) && state[key]) {
	        arr.push("".concat(applyPrefixToName(prefix, key)));
	      }
	    }
	  }
	
	  return arr.filter(function (i) {
	    return i;
	  }).map(function (i) {
	    return String(i).trim();
	  }).join(' ');
	} // ==============================
	// Clean Value
	// ==============================
	
	
	var cleanValue = function cleanValue(value) {
	  if (Array.isArray(value)) return value.filter(Boolean);
	  if (_typeof(value) === 'object' && value !== null) return [value];
	  return [];
	}; // ==============================
	// Handle Input Change
	// ==============================
	
	
	function handleInputChange(inputValue, actionMeta, onInputChange) {
	  if (onInputChange) {
	    var newValue = onInputChange(inputValue, actionMeta);
	    if (typeof newValue === 'string') return newValue;
	  }
	
	  return inputValue;
	} // ==============================
	// Scroll Helpers
	// ==============================
	
	
	function isDocumentElement(el) {
	  return [document.documentElement, document.body, window].indexOf(el) > -1;
	} // Normalized Scroll Top
	// ------------------------------
	
	
	function getScrollTop(el) {
	  if (isDocumentElement(el)) {
	    return window.pageYOffset;
	  }
	
	  return el.scrollTop;
	}
	
	function scrollTo(el, top) {
	  // with a scroll distance, we perform scroll on the element
	  if (isDocumentElement(el)) {
	    window.scrollTo(0, top);
	    return;
	  }
	
	  el.scrollTop = top;
	} // Get Scroll Parent
	// ------------------------------
	
	
	function getScrollParent(element) {
	  var style = getComputedStyle(element);
	  var excludeStaticParent = style.position === 'absolute';
	  var overflowRx = /(auto|scroll)/;
	  var docEl = document.documentElement; // suck it, flow...
	
	  if (style.position === 'fixed') return docEl;
	
	  for (var parent = element; parent = parent.parentElement;) {
	    style = getComputedStyle(parent);
	
	    if (excludeStaticParent && style.position === 'static') {
	      continue;
	    }
	
	    if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) {
	      return parent;
	    }
	  }
	
	  return docEl;
	} // Animated Scroll To
	// ------------------------------
	
	/**
	  @param t: time (elapsed)
	  @param b: initial value
	  @param c: amount of change
	  @param d: duration
	*/
	
	
	function easeOutCubic(t, b, c, d) {
	  return c * ((t = t / d - 1) * t * t + 1) + b;
	}
	
	function animatedScrollTo(element, to) {
	  var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
	  var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : noop;
	  var start = getScrollTop(element);
	  var change = to - start;
	  var increment = 10;
	  var currentTime = 0;
	
	  function animateScroll() {
	    currentTime += increment;
	    var val = easeOutCubic(currentTime, start, change, duration);
	    scrollTo(element, val);
	
	    if (currentTime < duration) {
	      window.requestAnimationFrame(animateScroll);
	    } else {
	      callback(element);
	    }
	  }
	
	  animateScroll();
	} // Scroll Into View
	// ------------------------------
	
	
	function scrollIntoView(menuEl, focusedEl) {
	  var menuRect = menuEl.getBoundingClientRect();
	  var focusedRect = focusedEl.getBoundingClientRect();
	  var overScroll = focusedEl.offsetHeight / 3;
	
	  if (focusedRect.bottom + overScroll > menuRect.bottom) {
	    scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
	  } else if (focusedRect.top - overScroll < menuRect.top) {
	    scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
	  }
	} // ==============================
	// Get bounding client object
	// ==============================
	// cannot get keys using array notation with DOMRect
	
	
	function getBoundingClientObj(element) {
	  var rect = element.getBoundingClientRect();
	  return {
	    bottom: rect.bottom,
	    height: rect.height,
	    left: rect.left,
	    right: rect.right,
	    top: rect.top,
	    width: rect.width
	  };
	} // Touch Capability Detector
	// ==============================
	
	
	function isTouchCapable() {
	  try {
	    document.createEvent('TouchEvent');
	    return true;
	  } catch (e) {
	    return false;
	  }
	} // ==============================
	// Mobile Device Detector
	// ==============================
	
	
	function isMobileDevice() {
	  try {
	    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
	  } catch (e) {
	    return false;
	  }
	}
	
	exports.animatedScrollTo = animatedScrollTo;
	exports.classNames = classNames;
	exports.cleanValue = cleanValue;
	exports.getBoundingClientObj = getBoundingClientObj;
	exports.getScrollParent = getScrollParent;
	exports.getScrollTop = getScrollTop;
	exports.handleInputChange = handleInputChange;
	exports.isDocumentElement = isDocumentElement;
	exports.isMobileDevice = isMobileDevice;
	exports.isTouchCapable = isTouchCapable;
	exports.noop = noop;
	exports.scrollIntoView = scrollIntoView;
	exports.scrollTo = scrollTo;


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _constants = __webpack_require__(131);
	
	exports.default = {
	  baseModule: 8,
	  contentWidth: 1360,
	  totalColumns: _constants.grid.totalColumns,
	
	  radiusDefault: 2,
	  radiusRounded: 1000,
	
	  /**
	   * breakpoints contain lower bounds of screen sizes
	   * ex. if you want some div to be 100% width for small screen (<60em) and
	   * take 50% width on medium up screens
	   * @example const boxStyled = styled.div css`
	   *  width: 100%;
	   *  ${media(medium)`width: 50%;`}
	   * `
	   */
	  breakpoints: {
	    xsmall: '0',
	    small: '30em',
	    medium: '60em',
	    large: '80em',
	    xlarge: '90em',
	    xxlarge: '120em'
	  },
	
	  breakpointsEmBase: 16,
	
	  color: {
	    white: _constants.basicColors.white,
	    black: _constants.basicColors.black,
	    transparent: _constants.basicColors.transparent,
	
	    main: _constants.themeColors.main,
	    mainFgTextColor: _constants.colorsFgCalculated.main,
	    secondary: _constants.themeColors.secondary,
	    secondaryFgTextColor: _constants.colorsFgCalculated.secondary,
	
	    alert: _constants.themeColors.alert,
	    alertFgTextColor: _constants.colorsFgCalculated.alert,
	    warning: _constants.themeColors.warning,
	    warningFgTextColor: _constants.colorsFgCalculated.warning,
	    error: _constants.themeColors.alert,
	    errorFgTextColor: _constants.colorsFgCalculated.alert,
	    success: _constants.themeColors.success,
	    successFgTextColor: _constants.colorsFgCalculated.success,
	    info: _constants.themeColors.info,
	    infoFgTextColor: _constants.colorsFgCalculated.info
	  },
	
	  colorPaletteGrey: _extends({}, _constants.greyPalette),
	
	  colorBorder: _constants.greyPalette[300],
	  colorAnchor: _constants.basicColors.darkblue,
	
	  colorBrand: {
	    facebook: '#3b5998',
	    vkontakte: '#45668e',
	    googlePlus: '#dd4b39'
	  },
	
	  fontFamily: _extends({}, _constants.fontFamily),
	
	  fontWeight: _extends({}, _constants.fontWeight),
	
	  fontSize: _extends({}, _constants.fontSize),
	
	  fontColor: {
	    light: _constants.greyPalette[300],
	    medium: _constants.greyPalette[500]
	  },
	
	  direction: {
	    text: 'ltr',
	    float: 'left'
	  },
	
	  zIndex: {
	    moon: 9999,
	    tooltip: 9990,
	    alertDesktop: 9000,
	    popup: 8700,
	    modal: 8500,
	    overlay: 8000,
	    dropdown: 7000,
	    alertMobile: 5000,
	    nav: 500,
	    base: 1
	  },
	
	  body: {
	    backgroundColor: _constants.body.backgroundColor,
	    fontColor: _constants.body.fontColor,
	    fontColorAlt: _constants.body.fontColorAlt,
	    fontFamily: 'sansSerif', // place here a key of fontFamily collection
	    fontWeight: _constants.fontWeight.normal,
	    lineHeight: 1.5
	  }
	};

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.keyboardCodes = exports.colorsFgCalculated = exports.foreground = exports.body = exports.fontWeight = exports.fontFamily = exports.fontSize = exports.greyPalette = exports.themeColors = exports.basicColors = exports.grid = undefined;
	
	var _color = __webpack_require__(639);
	
	var _color2 = _interopRequireDefault(_color);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var grid = exports.grid = {
	  totalColumns: 12
	};
	
	var basicColors = exports.basicColors = {
	  white: '#ffffff',
	  black: '#000000',
	  red: '#f04124',
	  yellow: '#f0b900',
	  green: '#43AC6A',
	  lightblue: '#d9edf7',
	  darkblue: '#208dcc',
	  transparent: 'hsla(0, 0%, 100%, 0)'
	};
	
	var themeColors = exports.themeColors = {
	  main: '#2196F3',
	  secondary: '#673AB7',
	  alert: basicColors.red,
	  warning: basicColors.yellow,
	  success: basicColors.green,
	  info: basicColors.lightblue
	};
	
	var greyPalette = exports.greyPalette = {
	  50: '#fafafa',
	  75: '#f7f7f7',
	  100: '#f5f5f5',
	  200: '#eeeeee',
	  300: '#e0e0e0',
	  400: '#bdbdbd',
	  500: '#9e9e9e',
	  600: '#757575',
	  700: '#616161',
	  800: '#424242',
	  900: '#212121'
	};
	
	var fontSize = exports.fontSize = {
	  '-2': 10,
	  '-1': 12,
	  0: 13,
	  1: 15,
	  2: 18,
	  3: 24,
	  4: 34,
	  5: 45,
	  6: 56,
	  7: 112
	};
	
	var fontFamily = exports.fontFamily = {
	  sansSerif: 'Open Sans, Helvetica Neue, Helvetica, Roboto, Arial, sans-serif',
	  serif: 'Georgia, Cambria, Times New Roman, Times, serif',
	  monospace: 'Consolas, Liberation Mono, Courier, monospace'
	};
	
	var fontWeight = exports.fontWeight = {
	  light: '400',
	  normal: '400',
	  semibold: '600',
	  bold: '700'
	};
	
	var body = exports.body = {
	  backgroundColor: basicColors.white,
	  fontColor: greyPalette[900],
	  fontColorAlt: basicColors.white
	};
	
	/**
	 * Checks the lightness of `bgColor`, and if it passes the `threshold` of
	 * lightness, it returns the `dark` color. Otherwise, it returns
	 * the `light` color. Use this function to dynamically output a foreground color
	 * based on a given background color.
	 *
	 * @param {string} bgColor - Color to check the lightness of.
	 * @param {string} dark - Color to return if `bgColor` is light.
	 * @param {string} light - Color to return if `bgColor` is dark.
	 * @param {number} threshold - Threshold of lightness to check against.
	 * @return {string} The dark color or light color.
	 */
	var foreground = exports.foreground = function foreground(bgColor) {
	  var dark = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : body.fontColor;
	  var light = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : body.fontColorAlt;
	  var threshold = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0.5;
	  return (0, _color2.default)(bgColor).luminosity() > threshold ? dark : light;
	};
	
	var colorsFgCalculated = exports.colorsFgCalculated = {
	  main: foreground(basicColors.main),
	  secondary: foreground(basicColors.secondary),
	  alert: foreground(basicColors.red),
	  success: foreground(basicColors.green),
	  warning: foreground(basicColors.yellow),
	  info: foreground(basicColors.lightblue)
	};
	
	var keyboardCodes = exports.keyboardCodes = {
	  ENTER: 13,
	  ESC: 27,
	  DOWN: 40,
	  UP: 38,
	  SPACE: 32
	};

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.registerDefaultComponentTheme = exports.defaultThemeBlueprintBroadcast = exports.extractThemeOrDefault = exports.composeReactackleTheme = exports.defaultTheme = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _lodash = __webpack_require__(401);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _lodash3 = __webpack_require__(116);
	
	var _lodash4 = _interopRequireDefault(_lodash3);
	
	var _lodash5 = __webpack_require__(169);
	
	var _lodash6 = _interopRequireDefault(_lodash5);
	
	var _misc = __webpack_require__(97);
	
	var _base = __webpack_require__(130);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _createBroadcast = __webpack_require__(133);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var baseKeys = Object.keys(_base2.default);
	
	var buildByBlueprint = function buildByBlueprint(blueprint, base) {
	  var mixin = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  return (0, _lodash2.default)(blueprint, function (value, key) {
	    if ((0, _react.isValidElement)(value)) return value;
	
	    if ((0, _misc.isObject)(value)) return buildByBlueprint(value, base, mixin[key]);
	
	    var current = (0, _misc.isUndef)(mixin[key]) ? value : mixin[key];
	
	    if ((0, _misc.isFunction)(current)) return current(base);
	
	    if (Array.isArray(current)) return current.map(function (item) {
	      return buildByBlueprint(item, base);
	    });
	
	    return current;
	  });
	};
	
	var defaultThemeBlueprint = _extends({}, _base2.default, {
	  components: {}
	});
	
	var defaultTheme = exports.defaultTheme = {
	  reactackle: _extends({}, _base2.default, {
	    components: {}
	  })
	};
	
	var composeReactackleTheme = exports.composeReactackleTheme = function composeReactackleTheme() {
	  var mixin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	  if (!mixin) return defaultTheme;
	
	  var newBase = (0, _lodash6.default)({}, _base2.default, (0, _lodash4.default)(mixin, baseKeys));
	  var components = (0, _misc.isObject)(mixin.components) ? (0, _lodash2.default)(defaultThemeBlueprint.components, function (defaultComponentThemeBlueprint, key) {
	    return buildByBlueprint(defaultComponentThemeBlueprint, newBase, mixin.components[key] || {});
	  }) : defaultTheme.reactackle.components;
	
	  return {
	    reactackle: _extends({}, newBase, { components: components })
	  };
	};
	
	var extractThemeOrDefault = exports.extractThemeOrDefault = function extractThemeOrDefault(theme) {
	  if (!theme) return defaultTheme;
	  if (!theme.reactackle) return _extends({}, theme, defaultTheme);
	  return theme;
	};
	
	var defaultThemeBlueprintBroadcast = exports.defaultThemeBlueprintBroadcast = (0, _createBroadcast.createBroadcast)(defaultThemeBlueprint);
	
	var registerDefaultComponentTheme = exports.registerDefaultComponentTheme = function registerDefaultComponentTheme(key, defaultComponentThemeBlueprint) {
	  if (!defaultTheme.reactackle.components[key]) {
	    defaultThemeBlueprint.components[key] = defaultComponentThemeBlueprint;
	
	    defaultTheme.reactackle.components[key] = buildByBlueprint(defaultComponentThemeBlueprint, _base2.default);
	
	    defaultThemeBlueprintBroadcast.publish(defaultThemeBlueprint);
	  }
	};

/***/ }),
/* 133 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createBroadcast = exports.createBroadcast = function createBroadcast(initialValue) {
	  var listeners = [];
	  var currentValue = initialValue;
	
	  return {
	    publish: function publish(value) {
	      currentValue = value;
	      listeners.forEach(function (listener) {
	        return listener(currentValue);
	      });
	    },
	    subscribe: function subscribe(listener) {
	      listeners.push(listener);
	
	      listener(currentValue);
	
	      return function () {
	        listeners = listeners.filter(function (item) {
	          return item !== listener;
	        });
	      };
	    }
	  };
	};

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.iconsPropType = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var iconsPropType = exports.iconsPropType = {
	  /** Turns on/off icon's border */
	  border: _propTypes2.default.bool,
	  /** Set icon's border width */
	  borderWidth: _propTypes2.default.number,
	  /** Make icon rounded */
	  rounded: _propTypes2.default.bool,
	  /** Set icon size */
	  size: _propTypes2.default.oneOf(['custom', 'small', 'normal', 'large', 'xlarge']),
	  /** Set icon's color scheme */
	  colorScheme: _propTypes2.default.oneOf(['light', 'dark', 'default']),
	  /** Set exact icon's border color */
	  color: _propTypes2.default.string,
	  /** Set icon's background color */
	  backgroundColor: _propTypes2.default.string,
	  /** Set icon's flipping plane */
	  flip: _propTypes2.default.oneOf(['none', 'horizontal', 'vertical']),
	  /** Rotate icon by some degree */
	  rotate: _propTypes2.default.number
	};

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DefaultLinkComponent = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  href: _propTypes2.default.string,
	  title: _propTypes2.default.string,
	  onClick: _propTypes2.default.func
	};
	
	var defaultProps = {
	  href: '',
	  title: 'defaultLink',
	  onClick: _reactackleCore.noop
	};
	
	var DefaultLinkComponent = exports.DefaultLinkComponent = function DefaultLinkComponent(props) {
	  var content = props.children || props.title;
	
	  return _react2.default.createElement(
	    'a',
	    { href: props.href, onClick: props.onClick },
	    content
	  );
	};
	
	DefaultLinkComponent.propTypes = propTypes;
	DefaultLinkComponent.defaultProps = defaultProps;
	DefaultLinkComponent.displayName = 'DefaultLinkComponent';

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = undefined;
	
	var _createStore = __webpack_require__(240);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _combineReducers = __webpack_require__(891);
	
	var _combineReducers2 = _interopRequireDefault(_combineReducers);
	
	var _bindActionCreators = __webpack_require__(890);
	
	var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);
	
	var _applyMiddleware = __webpack_require__(889);
	
	var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);
	
	var _compose = __webpack_require__(239);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _warning = __webpack_require__(241);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*
	* This is a dummy function to check if the function name has been altered by minification.
	* If the function has been minified and NODE_ENV !== 'production', warn the user.
	*/
	function isCrushed() {}
	
	if (false) {
	  (0, _warning2['default'])('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.createStore = _createStore2['default'];
	exports.combineReducers = _combineReducers2['default'];
	exports.bindActionCreators = _bindActionCreators2['default'];
	exports.applyMiddleware = _applyMiddleware2['default'];
	exports.compose = _compose2['default'];

/***/ }),
/* 137 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	/**
	 * Convert array of 16 byte values to UUID string format of the form:
	 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
	 */
	var byteToHex = [];
	
	for (var i = 0; i < 256; ++i) {
	  byteToHex[i] = (i + 0x100).toString(16).substr(1);
	}
	
	function bytesToUuid(buf, offset) {
	  var i = offset || 0;
	  var bth = byteToHex; // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
	
	  return [bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]]].join('');
	}
	
	var _default = bytesToUuid;
	exports.default = _default;

/***/ }),
/* 138 */
/***/ (function(module, exports) {

	function _objectWithoutPropertiesLoose(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;
	
	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }
	
	  return target;
	}
	
	module.exports = _objectWithoutPropertiesLoose;

/***/ }),
/* 139 */
/***/ (function(module, exports) {

	function _taggedTemplateLiteral(strings, raw) {
	  if (!raw) {
	    raw = strings.slice(0);
	  }
	
	  return Object.freeze(Object.defineProperties(strings, {
	    raw: {
	      value: Object.freeze(raw)
	    }
	  }));
	}
	
	module.exports = _taggedTemplateLiteral;

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayWithoutHoles = __webpack_require__(253);
	
	var iterableToArray = __webpack_require__(254);
	
	var nonIterableSpread = __webpack_require__(255);
	
	function _toConsumableArray(arr) {
	  return arrayWithoutHoles(arr) || iterableToArray(arr) || nonIterableSpread();
	}
	
	module.exports = _toConsumableArray;

/***/ }),
/* 141 */
[936, 144, 259, 261],
/* 142 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function memoize(fn) {
	  var cache = {};
	  return function (arg) {
	    if (cache[arg] === undefined) cache[arg] = fn(arg);
	    return cache[arg];
	  };
	}
	
	exports.default = memoize;


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var hashString = _interopDefault(__webpack_require__(257));
	var unitless = _interopDefault(__webpack_require__(145));
	var memoize = _interopDefault(__webpack_require__(142));
	
	var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
	var hyphenateRegex = /[A-Z]|^ms/g;
	var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
	
	var isCustomProperty = function isCustomProperty(property) {
	  return property.charCodeAt(1) === 45;
	};
	
	var processStyleName = memoize(function (styleName) {
	  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
	});
	
	var processStyleValue = function processStyleValue(key, value) {
	  if (value == null || typeof value === 'boolean') {
	    return '';
	  }
	
	  switch (key) {
	    case 'animation':
	    case 'animationName':
	      {
	        if (typeof value === 'string') {
	          return value.replace(animationRegex, function (match, p1, p2) {
	            cursor = {
	              name: p1,
	              styles: p2,
	              next: cursor
	            };
	            return p1;
	          });
	        }
	      }
	  }
	
	  if (unitless[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
	    return value + 'px';
	  }
	
	  return value;
	};
	
	if (false) {
	  var contentValuePattern = /(attr|calc|counters?|url)\(/;
	  var contentValues = ['normal', 'none', 'counter', 'open-quote', 'close-quote', 'no-open-quote', 'no-close-quote', 'initial', 'inherit', 'unset'];
	  var oldProcessStyleValue = processStyleValue;
	  var msPattern = /^-ms-/;
	  var hyphenPattern = /-(.)/g;
	  var hyphenatedCache = {};
	
	  processStyleValue = function processStyleValue(key, value) {
	    if (key === 'content') {
	      if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
	        console.error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
	      }
	    }
	
	    var processed = oldProcessStyleValue(key, value);
	
	    if (processed !== '' && !isCustomProperty(key) && key.indexOf('-') !== -1 && hyphenatedCache[key] === undefined) {
	      hyphenatedCache[key] = true;
	      console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + key.replace(msPattern, 'ms-').replace(hyphenPattern, function (str, _char) {
	        return _char.toUpperCase();
	      }) + "?");
	    }
	
	    return processed;
	  };
	}
	
	var shouldWarnAboutInterpolatingClassNameFromCss = true;
	
	function handleInterpolation(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
	  if (interpolation == null) {
	    return '';
	  }
	
	  if (interpolation.__emotion_styles !== undefined) {
	    if (false) {
	      throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
	    }
	
	    return interpolation;
	  }
	
	  switch (typeof interpolation) {
	    case 'boolean':
	      {
	        return '';
	      }
	
	    case 'object':
	      {
	        if (interpolation.anim === 1) {
	          cursor = {
	            name: interpolation.name,
	            styles: interpolation.styles,
	            next: cursor
	          };
	          return interpolation.name;
	        }
	
	        if (interpolation.styles !== undefined) {
	          var next = interpolation.next;
	
	          if (next !== undefined) {
	            // not the most efficient thing ever but this is a pretty rare case
	            // and there will be very few iterations of this generally
	            while (next !== undefined) {
	              cursor = {
	                name: next.name,
	                styles: next.styles,
	                next: cursor
	              };
	              next = next.next;
	            }
	          }
	
	          var styles = interpolation.styles;
	
	          if (false) {
	            styles += interpolation.map;
	          }
	
	          return styles;
	        }
	
	        return createStringFromObject(mergedProps, registered, interpolation);
	      }
	
	    case 'function':
	      {
	        if (mergedProps !== undefined) {
	          var previousCursor = cursor;
	          var result = interpolation(mergedProps);
	          cursor = previousCursor;
	          return handleInterpolation(mergedProps, registered, result, couldBeSelectorInterpolation);
	        } else if (false) {
	          console.error('Functions that are interpolated in css calls will be stringified.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
	        }
	      }
	    // eslint-disable-next-line no-fallthrough
	
	    default:
	      {
	        if (registered == null) {
	          return interpolation;
	        }
	
	        var cached = registered[interpolation];
	
	        if (false) {
	          console.error('Interpolating a className from css`` is not recommended and will cause problems with composition.\n' + 'Interpolating a className from css`` will be completely unsupported in a future major version of Emotion');
	          shouldWarnAboutInterpolatingClassNameFromCss = false;
	        }
	
	        return cached !== undefined && !couldBeSelectorInterpolation ? cached : interpolation;
	      }
	  }
	}
	
	function createStringFromObject(mergedProps, registered, obj) {
	  var string = '';
	
	  if (Array.isArray(obj)) {
	    for (var i = 0; i < obj.length; i++) {
	      string += handleInterpolation(mergedProps, registered, obj[i], false);
	    }
	  } else {
	    for (var _key in obj) {
	      var value = obj[_key];
	
	      if (typeof value !== 'object') {
	        if (registered != null && registered[value] !== undefined) {
	          string += _key + "{" + registered[value] + "}";
	        } else {
	          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
	        }
	      } else {
	        if (_key === 'NO_COMPONENT_SELECTOR' && ("production") !== 'production') {
	          throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
	        }
	
	        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
	          for (var _i = 0; _i < value.length; _i++) {
	            string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
	          }
	        } else {
	          var interpolated = handleInterpolation(mergedProps, registered, value, false);
	
	          switch (_key) {
	            case 'animation':
	            case 'animationName':
	              {
	                string += processStyleName(_key) + ":" + interpolated + ";";
	                break;
	              }
	
	            default:
	              {
	                string += _key + "{" + interpolated + "}";
	              }
	          }
	        }
	      }
	    }
	  }
	
	  return string;
	}
	
	var labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
	var sourceMapPattern;
	
	if (false) {
	  sourceMapPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//;
	} // this is the cursor for keyframes
	// keyframes are stored on the SerializedStyles object as a linked list
	
	
	var cursor;
	var serializeStyles = function serializeStyles(args, registered, mergedProps) {
	  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
	    return args[0];
	  }
	
	  var stringMode = true;
	  var styles = '';
	  cursor = undefined;
	  var strings = args[0];
	
	  if (strings == null || strings.raw === undefined) {
	    stringMode = false;
	    styles += handleInterpolation(mergedProps, registered, strings, false);
	  } else {
	    if (false) {
	      console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
	    }
	
	    styles += strings[0];
	  } // we start at 1 since we've already handled the first arg
	
	
	  for (var i = 1; i < args.length; i++) {
	    styles += handleInterpolation(mergedProps, registered, args[i], styles.charCodeAt(styles.length - 1) === 46);
	
	    if (stringMode) {
	      if (false) {
	        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
	      }
	
	      styles += strings[i];
	    }
	  }
	
	  var sourceMap;
	
	  if (false) {
	    styles = styles.replace(sourceMapPattern, function (match) {
	      sourceMap = match;
	      return '';
	    });
	  } // using a global regex with .exec is stateful so lastIndex has to be reset each time
	
	
	  labelPattern.lastIndex = 0;
	  var identifierName = '';
	  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
	
	  while ((match = labelPattern.exec(styles)) !== null) {
	    identifierName += '-' + // $FlowFixMe we know it's not null
	    match[1];
	  }
	
	  var name = hashString(styles) + identifierName;
	
	  if (false) {
	    return {
	      name: name,
	      styles: styles,
	      map: sourceMap,
	      next: cursor
	    };
	  }
	
	  return {
	    name: name,
	    styles: styles,
	    next: cursor
	  };
	};
	
	exports.serializeStyles = serializeStyles;


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/*
	
	Based off glamor's StyleSheet, thanks Sunil ❤️
	
	high performance StyleSheet for css-in-js systems
	
	- uses multiple style tags behind the scenes for millions of rules
	- uses `insertRule` for appending in production for *much* faster performance
	
	// usage
	
	import { StyleSheet } from '@emotion/sheet'
	
	let styleSheet = new StyleSheet({ key: '', container: document.head })
	
	styleSheet.insert('#box { border: 1px solid red; }')
	- appends a css rule into the stylesheet
	
	styleSheet.flush()
	- empties the stylesheet of all its contents
	
	*/
	// $FlowFixMe
	function sheetForTag(tag) {
	  if (tag.sheet) {
	    // $FlowFixMe
	    return tag.sheet;
	  } // this weirdness brought to you by firefox
	
	  /* istanbul ignore next */
	
	
	  for (var i = 0; i < document.styleSheets.length; i++) {
	    if (document.styleSheets[i].ownerNode === tag) {
	      // $FlowFixMe
	      return document.styleSheets[i];
	    }
	  }
	}
	
	function createStyleElement(options) {
	  var tag = document.createElement('style');
	  tag.setAttribute('data-emotion', options.key);
	
	  if (options.nonce !== undefined) {
	    tag.setAttribute('nonce', options.nonce);
	  }
	
	  tag.appendChild(document.createTextNode(''));
	  return tag;
	}
	
	var StyleSheet =
	/*#__PURE__*/
	function () {
	  function StyleSheet(options) {
	    this.isSpeedy = options.speedy === undefined ? ("production") === 'production' : options.speedy;
	    this.tags = [];
	    this.ctr = 0;
	    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
	
	    this.key = options.key;
	    this.container = options.container;
	    this.before = null;
	  }
	
	  var _proto = StyleSheet.prototype;
	
	  _proto.insert = function insert(rule) {
	    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
	    // it's 1 in dev because we insert source maps that map a single rule to a location
	    // and you can only have one source map per style tag
	    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
	      var _tag = createStyleElement(this);
	
	      var before;
	
	      if (this.tags.length === 0) {
	        before = this.before;
	      } else {
	        before = this.tags[this.tags.length - 1].nextSibling;
	      }
	
	      this.container.insertBefore(_tag, before);
	      this.tags.push(_tag);
	    }
	
	    var tag = this.tags[this.tags.length - 1];
	
	    if (this.isSpeedy) {
	      var sheet = sheetForTag(tag);
	
	      try {
	        // this is a really hot path
	        // we check the second character first because having "i"
	        // as the second character will happen less often than
	        // having "@" as the first character
	        var isImportRule = rule.charCodeAt(1) === 105 && rule.charCodeAt(0) === 64; // this is the ultrafast version, works across browsers
	        // the big drawback is that the css won't be editable in devtools
	
	        sheet.insertRule(rule, // we need to insert @import rules before anything else
	        // otherwise there will be an error
	        // technically this means that the @import rules will
	        // _usually_(not always since there could be multiple style tags)
	        // be the first ones in prod and generally later in dev
	        // this shouldn't really matter in the real world though
	        // @import is generally only used for font faces from google fonts and etc.
	        // so while this could be technically correct then it would be slower and larger
	        // for a tiny bit of correctness that won't matter in the real world
	        isImportRule ? 0 : sheet.cssRules.length);
	      } catch (e) {
	        if (false) {
	          console.warn("There was a problem inserting the following rule: \"" + rule + "\"", e);
	        }
	      }
	    } else {
	      tag.appendChild(document.createTextNode(rule));
	    }
	
	    this.ctr++;
	  };
	
	  _proto.flush = function flush() {
	    // $FlowFixMe
	    this.tags.forEach(function (tag) {
	      return tag.parentNode.removeChild(tag);
	    });
	    this.tags = [];
	    this.ctr = 0;
	  };
	
	  return StyleSheet;
	}();
	
	exports.StyleSheet = StyleSheet;


/***/ }),
/* 145 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var unitlessKeys = {
	  animationIterationCount: 1,
	  borderImageOutset: 1,
	  borderImageSlice: 1,
	  borderImageWidth: 1,
	  boxFlex: 1,
	  boxFlexGroup: 1,
	  boxOrdinalGroup: 1,
	  columnCount: 1,
	  columns: 1,
	  flex: 1,
	  flexGrow: 1,
	  flexPositive: 1,
	  flexShrink: 1,
	  flexNegative: 1,
	  flexOrder: 1,
	  gridRow: 1,
	  gridRowEnd: 1,
	  gridRowSpan: 1,
	  gridRowStart: 1,
	  gridColumn: 1,
	  gridColumnEnd: 1,
	  gridColumnSpan: 1,
	  gridColumnStart: 1,
	  msGridRow: 1,
	  msGridRowSpan: 1,
	  msGridColumn: 1,
	  msGridColumnSpan: 1,
	  fontWeight: 1,
	  lineHeight: 1,
	  opacity: 1,
	  order: 1,
	  orphans: 1,
	  tabSize: 1,
	  widows: 1,
	  zIndex: 1,
	  zoom: 1,
	  WebkitLineClamp: 1,
	  // SVG-related properties
	  fillOpacity: 1,
	  floodOpacity: 1,
	  stopOpacity: 1,
	  strokeDasharray: 1,
	  strokeDashoffset: 1,
	  strokeMiterlimit: 1,
	  strokeOpacity: 1,
	  strokeWidth: 1
	};
	
	exports.default = unitlessKeys;


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AdminSummaryList = __webpack_require__(284);
	
	var _AdminSummaryList2 = _interopRequireDefault(_AdminSummaryList);
	
	var _AdminOrderList = __webpack_require__(283);
	
	var _AdminOrderList2 = _interopRequireDefault(_AdminOrderList);
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__(67);
	
	var _reactToPrint = __webpack_require__(203);
	
	var _reactToPrint2 = _interopRequireDefault(_reactToPrint);
	
	__webpack_require__(245);
	
	var _numeral = __webpack_require__(16);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var AdminGrid = function (_Component) {
	  _inherits(AdminGrid, _Component);
	
	  function AdminGrid() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, AdminGrid);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AdminGrid.__proto__ || Object.getPrototypeOf(AdminGrid)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      selectedOrders: true,
	      allOrders: false,
	      messageFocus: false,
	      compactOrderView: false,
	      viewOpenOrders: true,
	      print1OrderView: true,
	      showFilters: true,
	      data: {
	        path: "adminSummary",
	        payload: {
	          targetDeliveryDate: (0, _moment2.default)().format("ddd DD-MM-YYYY").toString(),
	          deliveryDate: (0, _moment2.default)().subtract(1, "day").format("DD-MM-YYYY").toString(),
	          open: true,
	          delivered: false,
	          sTgtdFlagDate: true,
	          orderDateFlag: false,
	          allItems: true,
	          foodItems: false,
	          vfruitItems: false,
	          meatItems: false,
	          ingredients: false,
	          mealLunch: true,
	          mealDinner: true,
	          mealAll: true,
	          image: true
	        }
	      }
	    }, _this.getOrdCount = function (data) {
	      var procInfo = _.chain(data).groupBy("mobile").map(function (value, key) {
	        if (value.length > 0) {
	          return {
	            mobile: key,
	            dates: _.pluck(value, "deliveryDate"),
	            createDates: _.pluck(value, "createDateTime"),
	            count: value.length
	          };
	        }
	      }).compact().value();
	      var finalInfo = {};
	      for (var i = 0; i < procInfo.length; i++) {
	        finalInfo[procInfo[i]["mobile"]] = procInfo[i];
	      }
	      _this.stateChangeHandler(finalInfo, "finalInfo", false, true);
	    }, _this.getProcInfo = function (recs) {
	      var data = _.cloneDeep(recs);
	      //console.log(moment().format("x") + " starting chaining");
	      var procInfo = _.chain(recs).filter(function (item) {
	        var sdDate = (0, _moment2.default)(_this.state.data.payload.deliveryDate, "DD-MM-YYYY");
	        var dDate = (0, _moment2.default)(item.deliveryDate, "DD-MM-YYYY");
	        if (item.createDateTime && item.createDateTime !== "") {
	          if (item.createDateTime.includes("/")) {
	            dDate = (0, _moment2.default)(item.createDateTime, "DD/MM/YYYY hh:mm:ss");
	          } else {
	            dDate = (0, _moment2.default)(item.createDateTime, "ddd DD-MM-YY h:mm a");
	          }
	        }
	
	        var tgtdDate = (0, _moment2.default)(item.targetDeliveryDate, "ddd DD-MM-YYYY");
	        var sTgtdDate = (0, _moment2.default)(_this.state.data.payload.targetDeliveryDate, "ddd DD-MM-YYYY");
	
	        var res = false;
	        // sTgtdFlagDate: false,
	        //   orderDateFlag: true
	        if (_this.state.data.payload.orderDateFlag && dDate.isSame(sdDate, "day") || _this.state.data.payload.sTgtdFlagDate && tgtdDate.isSame(sTgtdDate, "day")) {
	          if (_this.state.data.payload.open && !_this.state.data.payload.delivered) {
	            if (item.status !== "CANCELLED" && item.status !== "DELIVERED") {
	              res = true;
	            }
	          } else if (!_this.state.data.payload.open && _this.state.data.payload.delivered) {
	            if (item.status === "DELIVERED") {
	              res = true;
	            }
	          } else if (_this.state.data.payload.open && _this.state.data.payload.delivered) {
	            if (item.status !== "CANCELLED") {
	              res = true;
	            }
	          }
	        }
	        //if (item.targetDeliveryDate.includes("17-01-2021")) {
	        // console.log(
	        //   "Result: " +
	        //     res +
	        //     " order: " +
	        //     item.targetDeliveryDate +
	        //     " vs stateTgt: " +
	        //     this.state.data.payload.targetDeliveryDate +
	        //     " & stateODate: " +
	        //     this.state.data.payload.deliveryDate +
	        //     " byOrderDate: " +
	        //     this.state.data.payload.orderDateFlag +
	        //     " byDeliveryDate: " +
	        //     this.state.data.payload.sTgtdFlagDate
	        // );
	        // console.log(
	        //   tgtdDate + "|" + sTgtdDate + "|" + tgtdDate.isSame(sTgtdDate, "day")
	        // );
	        //}
	        return res;
	      }).filter(function (item) {
	        var res = false;
	        if (_this.state.data.payload.mealLunch) {
	          if (item.mealType && item.mealType === "LUNCH") {
	            res = true;
	          }
	        }
	        if (_this.state.data.payload.mealDinner) {
	          if (item.mealType && item.mealType === "DINNER") {
	            res = true;
	          }
	        }
	        if (_this.state.data.payload.mealAll) {
	          res = true;
	        }
	        return res;
	      }).filter(function (itemOrd) {
	        //console.log("finding categ orders");
	        if (_this.state.data.payload.allItems) {
	          //console.log("all items");
	          return true;
	        } else if (_this.state.data.payload.foodItems) {
	          //console.log("food only " + itemOrd.requestedItems.length);
	          for (var k = 0; k < itemOrd.requestedItems.length; k++) {
	            var item = itemOrd.requestedItems[k];
	            //console.log("item cag: " + item.category);
	            if (item.category && item.category.includes("রান্না করা খাবার")) {
	              k = itemOrd.requestedItems.length + 1;
	              return true;
	            }
	          }
	        } else if (_this.state.data.payload.vfruitItems) {
	          //console.log("veg only");
	          for (var _k = 0; _k < itemOrd.requestedItems.length; _k++) {
	            var _item = itemOrd.requestedItems[_k];
	
	            if (_item.category && _item.category.includes("FRUITS VEGET")) {
	              _k = itemOrd.requestedItems.length + 1;
	              return true;
	            }
	          }
	        } else if (_this.state.data.payload.meatItems) {
	          //console.log("meat only");
	          for (var _k2 = 0; _k2 < itemOrd.requestedItems.length; _k2++) {
	            var _item2 = itemOrd.requestedItems[_k2];
	
	            if (_item2.category && _item2.category.includes("MEAT FISH")) {
	              _k2 = itemOrd.requestedItems.length + 1;
	              return true;
	            }
	          }
	        } else if (_this.state.data.payload.ingredients) {
	          //console.log("in gredients");
	          for (var _k3 = 0; _k3 < itemOrd.requestedItems.length; _k3++) {
	            var _item3 = itemOrd.requestedItems[_k3];
	
	            if (_item3.category && !_item3.category.includes("রান্না করা খাবার") && !_item3.category.includes("FRUITS VEGETA") && !_item3.category.includes("MEAT FISH")) {
	              _k3 = itemOrd.requestedItems.length + 1;
	              return true;
	            }
	          }
	        }
	      }).value();
	      return procInfo;
	    }, _this.getSummedData = function (recs) {
	      //console.log(recs.length);
	
	      //let procInfo = _.groupBy(data, "mobile");
	      // console.log(JSON.stringify(Object.keys(procInfo)));
	      // console.log("rara ==> started");
	      function sum(numbers) {
	        //console.log(JSON.stringify(numbers));
	        var numSum = _.reduce(numbers, function (result, current) {
	          //console.log("current: " + current + "  result: " + result);
	          if (current === "" || current === null || current === undefined || current === "NaN") {
	            console.log("Found an NaN===" + current);
	            current = 0;
	          }
	          return result + parseFloat(current);
	        }, 0);
	        //console.log(numSum);
	        return numSum;
	      }
	      if (_this.state.data.payload.targetDeliveryDate && _this.state.data.payload.targetDeliveryDate !== undefined) {
	        var procInfo = _.cloneDeep(_this.getProcInfo(recs));
	        _this.stateChangeHandler(procInfo, "procInfo", false, true);
	        var sumArray = [];
	        for (var i = 0; i < procInfo.length; i++) {
	          var currOrd = procInfo[i];
	          var currProds = currOrd.requestedItems;
	          if (currProds && currProds.length > 0) {
	            for (var j = 0; j < currProds.length; j++) {
	              currProds[j]["ordererName"] = currOrd.name;
	              currProds[j]["ordererMobile"] = currOrd.mobile;
	              sumArray.push(currProds[j]);
	            }
	          }
	        }
	        //console.log(JSON.stringify(sumArray));
	        var summedProds = _.chain(sumArray).groupBy("productNameEnglish").map(function (value, key) {
	          return {
	            productName: key,
	            totalQuantity: sum(_.pluck(value, "quantity")),
	            qtyGroups: _.chain(_.pluck(value, "quantity")).countBy().map(function (val, k) {
	              return { bucketSize: k, bucketFrequency: val };
	            }).value(),
	            unit: _.pluck(value, "unit"),
	            price: parseFloat((parseFloat(_.pluck(value, "productPrice")[0]) * 0.9).toFixed(2)),
	            totAmount: sum(_.pluck(value, "quantity")) * parseFloat(_.pluck(value, "productPrice")[0]) * 0.9,
	            name: _.pluck(value, "ordererName"),
	            mobile: _.pluck(value, "ordererMobile"),
	            subQuantities: _.pluck(value, "quantity"),
	            photos: value[0].photos,
	            category: value[0].category
	          };
	        }, 0).filter(function (item) {
	          var res2 = false;
	          if (_this.state.data.payload.allItems) {
	            res2 = true;
	          }
	          if (_this.state.data.payload.foodItems && item.category && item.category.includes("রান্না করা খাবার")) {
	            res2 = true;
	          }
	          if (_this.state.data.payload.vfruitItems && item.category && item.category.includes("FRUITS VEGET")) {
	            res2 = true;
	          }
	          if (_this.state.data.payload.meatItems && item.category && item.category.includes("MEAT FISH")) {
	            res2 = true;
	          }
	          if (_this.state.data.payload.ingredients && item.category && !item.category.includes("রান্না করা খাবার") && !item.category.includes("FRUITS VEGETA") && !item.category.includes("MEAT FISH")) {
	            res2 = true;
	          }
	          return res2;
	        }).sortBy("totalQuantity").reverse().value();
	        //console.log(JSON.stringify(summedProds));
	        //return { products: summedProds, ordCount: procInfo.length };
	        var ordTotal = 0;
	        for (var _i = 0; _i < procInfo.length; _i++) {
	          ordTotal = ordTotal + sum(_.chain(procInfo[_i].requestedItems).filter(function (item) {
	            var res2 = false;
	            if (_this.state.data.payload.allItems) {
	              res2 = true;
	            }
	            if (_this.state.data.payload.foodItems && item.category && item.category.includes("রান্না করা খাবার")) {
	              res2 = true;
	            }
	            if (_this.state.data.payload.vfruitItems && item.category && item.category.includes("FRUITS VEGET")) {
	              res2 = true;
	            }
	            if (_this.state.data.payload.meatItems && item.category && item.category.includes("MEAT FISH")) {
	              res2 = true;
	            }
	            if (_this.state.data.payload.ingredients && item.category && !item.category.includes("রান্না করা খাবার") && !item.category.includes("FRUITS VEGETA") && !item.category.includes("MEAT FISH")) {
	              res2 = true;
	            }
	            return res2;
	          }).pluck("amount").value());
	        }
	        //console.log(ordTotal);
	        ordTotal = (0, _numeral2.default)(ordTotal).format("0,0.00");
	
	        var locArray = _.chain(procInfo).groupBy("address").map(function (val, key) {
	          return key;
	        }).value();
	
	        _this.stateChangeHandler({
	          products: summedProds,
	          ordCount: procInfo.length,
	          ordTotal: ordTotal,
	          locations: locArray.length
	        }, "summedData", false, true);
	      } else {
	        _this.stateChangeHandler({ products: [], ordCount: 0 }, "summedData", false, true);
	      }
	      //console.log("ended ==> started");
	    }, _this.stateChangeHandler = function (val, id, isPayload, counterUpdate) {
	      //console.log("val: " + val + " id: " + id + " isPayload: " + isPayload);
	      var tmpState = {};
	      tmpState[id] = val;
	      var calcFields = ["targetDeliveryDate", "deliveryDate", "allItems", "mealAll", "delivered"];
	      if (isPayload) {
	        _this.setState(function (prevState) {
	          if (prevState && prevState.data.payload !== null) {
	            return _extends({}, prevState, {
	              data: _extends({}, prevState.data, {
	                payload: _extends({}, prevState.data.payload, tmpState)
	              })
	            });
	          } else {
	            return _extends({}, prevState, {
	              data: {
	                path: prevState.data.path,
	                payload: _extends({}, tmpState)
	              }
	            });
	          }
	        }, function () {
	          if (!counterUpdate) {
	            if (calcFields.includes(id)) {
	              //console.log("the id is: " + id);
	              _this.getSummedData(_this.props.data);
	            }
	          }
	        });
	      } else {
	        _this.setState(function (prevState) {
	          return _extends({}, prevState, tmpState);
	        }, function () {
	          if (!counterUpdate) {
	            if (calcFields.includes(id)) {
	              //console.log("the id is: " + id);
	              _this.getSummedData(_this.props.data);
	            }
	          }
	        });
	      }
	    }, _this.getControlPanel = function () {
	      return _react2.default.createElement("div", {
	        style: {
	          borderRadius: "10px",
	          backgroundColor: "white",
	          margin: "5px",
	          padding: "10px",
	          marginBottom: "15px",
	          fontSize: "12px",
	          fontWeight: "bold",
	          border: "1.5px solid #ccc",
	          boxSizing: "border-box",
	          boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          backgroundColor: "gainsboro"
	        }
	      }, _react2.default.createElement("hr", {
	        style: {
	          margin: "2px"
	        }
	      }), _this.getDateFilter(), _this.getTargetDateFilter(), _react2.default.createElement("hr", {
	        style: {
	          margin: "2px"
	        }
	      }), _react2.default.createElement("div", {
	        style: {
	          fontSize: "12px",
	          display: "flex",
	          flexDirection: "row",
	          padding: "5px"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          width: "33%",
	          textAlign: "center",
	          lineHeight: "20px",
	          fontSize: _this.state.data.payload.open ? "14px" : "10px"
	        },
	        onClick: function onClick() {
	          _this.stateChangeHandler(true, "open", true);
	          _this.stateChangeHandler(false, "delivered", true);
	          _this.stateChangeHandler(false, "all", true);
	        }
	      }, _react2.default.createElement("span", {
	        style: {
	          marginRight: "3px"
	        }
	      }, _react2.default.createElement("icon", {
	        className: _this.state.data.payload.open ? "fa fa-eye" : "fa fa-eye-slash",
	        style: { color: "rgb(30, 101, 144)" }
	      }), " ", "OPEN")), _react2.default.createElement("div", {
	        style: {
	          width: "34%",
	          textAlign: "center",
	          lineHeight: "20px",
	          fontSize: _this.state.data.payload.delivered ? "14px" : "10px"
	        },
	        onClick: function onClick() {
	          _this.stateChangeHandler(false, "open", true);
	          _this.stateChangeHandler(true, "delivered", true);
	          _this.stateChangeHandler(false, "all", true);
	        }
	      }, _react2.default.createElement("span", {
	        style: {
	          marginRight: "3px"
	        }
	      }, _react2.default.createElement("icon", {
	        className: _this.state.data.payload.delivered ? "fa fa-eye" : "fa fa-eye-slash",
	        style: { color: "rgb(30, 101, 144)" }
	      }), " ", "DELIVERED")), _react2.default.createElement("div", {
	        style: {
	          width: "33%",
	          textAlign: "center",
	          lineHeight: "20px",
	          fontSize: _this.state.data.payload.all ? "14px" : "10px"
	        },
	        onClick: function onClick() {
	          _this.stateChangeHandler(true, "open", true);
	          _this.stateChangeHandler(true, "delivered", true);
	          _this.stateChangeHandler(true, "all", true);
	        }
	      }, _react2.default.createElement("span", {
	        style: {
	          marginRight: "3px"
	        }
	      }, _react2.default.createElement("icon", {
	        className: _this.state.data.payload.all ? "fa fa-eye" : "fa fa-eye-slash",
	        style: { color: "rgb(30, 101, 144)" }
	      }), " ", "ALL"))), _react2.default.createElement("hr", {
	        style: {
	          margin: "2px"
	        }
	      }), _react2.default.createElement("div", {
	        style: {
	          fontSize: "12px",
	          display: "flex",
	          flexDirection: "row",
	          padding: "5px"
	        }
	      }, _this.getCategCell("allItems", "ALL", true, false, false, false, false), _this.getCategCell("foodItems", "FOOD", false, true, false, false, false), _this.getCategCell("vfruitItems", "VEG", false, false, true, false, false), _this.getCategCell("meatItems", "MEATS", false, false, false, true, false), _this.getCategCell("ingredients", "DRY", false, false, false, false, true)), _react2.default.createElement("hr", {
	        style: {
	          margin: "2px"
	        }
	      }), _react2.default.createElement("div", {
	        style: {
	          fontSize: "12px",
	          display: "flex",
	          flexDirection: "row",
	          padding: "5px"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          width: "50%",
	          textAlign: "center",
	          lineHeight: "20px",
	          fontSize: _this.state.data.payload.breakup ? "14px" : "10px"
	        },
	        onClick: function onClick() {
	          _this.stateChangeHandler(true, "breakup", true);
	        }
	      }, _react2.default.createElement("span", {
	        style: {
	          marginRight: "3px"
	        }
	      }, _react2.default.createElement("icon", {
	        className: _this.state.data.payload.breakup ? "fa fa-eye" : "fa fa-eye-slash",
	        style: { color: "rgb(30, 101, 144)" }
	      }), " ", "SHOW BREAKUP")), _react2.default.createElement("div", {
	        style: {
	          width: "50%",
	          textAlign: "center",
	          lineHeight: "20px",
	          fontSize: !_this.state.data.payload.breakup ? "14px" : "10px"
	        },
	        onClick: function onClick() {
	          _this.stateChangeHandler(false, "breakup", true);
	        }
	      }, _react2.default.createElement("span", {
	        style: {
	          marginRight: "3px"
	        }
	      }, _react2.default.createElement("icon", {
	        className: !_this.state.data.payload.breakup ? "fa fa-eye" : "fa fa-eye-slash",
	        style: { color: "rgb(30, 101, 144)" }
	      }), " ", "HIDE BREAKUP"))), _react2.default.createElement("hr", {
	        style: {
	          margin: "2px"
	        }
	      }), _react2.default.createElement("div", {
	        style: {
	          fontSize: "12px",
	          display: "flex",
	          flexDirection: "row",
	          padding: "5px"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          width: "33%",
	          textAlign: "center",
	          lineHeight: "20px",
	          fontSize: _this.state.data.payload.mealLunch ? "14px" : "10px"
	        },
	        onClick: function onClick() {
	          _this.stateChangeHandler(true, "mealLunch", true);
	          _this.stateChangeHandler(false, "mealDinner", true);
	          _this.stateChangeHandler(false, "mealAll", true);
	        }
	      }, _react2.default.createElement("span", {
	        style: {
	          marginRight: "3px"
	        }
	      }, _react2.default.createElement("icon", {
	        className: _this.state.data.payload.mealLunch ? "fa fa-eye" : "fa fa-eye-slash",
	        style: { color: "rgb(30, 101, 144)" }
	      }), " ", "LUNCH")), _react2.default.createElement("div", {
	        style: {
	          width: "34%",
	          textAlign: "center",
	          lineHeight: "20px",
	          fontSize: _this.state.data.payload.mealDinner ? "14px" : "10px"
	        },
	        onClick: function onClick() {
	          _this.stateChangeHandler(false, "mealLunch", true);
	          _this.stateChangeHandler(true, "mealDinner", true);
	          _this.stateChangeHandler(false, "mealAll", true);
	        }
	      }, _react2.default.createElement("span", {
	        style: {
	          marginRight: "3px"
	        }
	      }, _react2.default.createElement("icon", {
	        className: _this.state.data.payload.mealDinner ? "fa fa-eye" : "fa fa-eye-slash",
	        style: { color: "rgb(30, 101, 144)" }
	      }), " ", "DINNER")), _react2.default.createElement("div", {
	        style: {
	          width: "33%",
	          textAlign: "center",
	          lineHeight: "20px",
	          fontSize: _this.state.data.payload.mealAll ? "14px" : "10px"
	        },
	        onClick: function onClick() {
	          _this.stateChangeHandler(true, "mealLunch", true);
	          _this.stateChangeHandler(true, "mealDinner", true);
	          _this.stateChangeHandler(true, "mealAll", true);
	        }
	      }, _react2.default.createElement("span", {
	        style: {
	          marginRight: "3px"
	        }
	      }, _react2.default.createElement("icon", {
	        className: _this.state.data.payload.mealAll ? "fa fa-eye" : "fa fa-eye-slash",
	        style: { color: "rgb(30, 101, 144)" }
	      }), " ", "ALL"))), _react2.default.createElement("hr", {
	        style: {
	          margin: "2px"
	        }
	      }), _react2.default.createElement("div", {
	        style: {
	          fontSize: "12px",
	          display: "flex",
	          flexDirection: "row",
	          padding: "5px"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          width: "50%",
	          textAlign: "center",
	          lineHeight: "20px",
	          fontSize: _this.state.data.payload.image ? "14px" : "10px"
	        },
	        onClick: function onClick() {
	          _this.stateChangeHandler(true, "image", true);
	        }
	      }, _react2.default.createElement("span", {
	        style: {
	          marginRight: "3px"
	        }
	      }, _react2.default.createElement("icon", {
	        className: _this.state.data.payload.image ? "fa fa-eye" : "fa fa-eye-slash",
	        style: { color: "rgb(30, 101, 144)" }
	      }), " ", "SHOW IMAGE")), _react2.default.createElement("div", {
	        style: {
	          width: "50%",
	          textAlign: "center",
	          lineHeight: "20px",
	          fontSize: !_this.state.data.payload.image ? "14px" : "10px"
	        },
	        onClick: function onClick() {
	          _this.stateChangeHandler(false, "image", true);
	        }
	      }, _react2.default.createElement("span", {
	        style: {
	          marginRight: "3px"
	        }
	      }, _react2.default.createElement("icon", {
	        className: !_this.state.data.payload.image ? "fa fa-eye" : "fa fa-eye-slash",
	        style: { color: "rgb(30, 101, 144)" }
	      }), " ", "HIDE IMAGE"))), _react2.default.createElement("hr", {
	        style: {
	          margin: "2px"
	        }
	      }), _react2.default.createElement("div", {
	        style: {
	          fontSize: "12px",
	          display: "flex",
	          flexDirection: "row",
	          padding: "5px"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          width: "50%",
	          textAlign: "center",
	          lineHeight: "20px",
	          fontSize: _this.state.data.payload.poMode ? "14px" : "10px"
	        },
	        onClick: function onClick() {
	          _this.stateChangeHandler(true, "poMode", true);
	        }
	      }, _react2.default.createElement("span", {
	        style: {
	          marginRight: "3px"
	        }
	      }, _react2.default.createElement("icon", {
	        className: _this.state.data.payload.poMode ? "fa fa-eye" : "fa fa-eye-slash",
	        style: { color: "rgb(30, 101, 144)" }
	      }), " ", "PO View")), _react2.default.createElement("div", {
	        style: {
	          width: "50%",
	          textAlign: "center",
	          lineHeight: "20px",
	          fontSize: !_this.state.data.payload.poMode ? "14px" : "10px"
	        },
	        onClick: function onClick() {
	          _this.stateChangeHandler(false, "poMode", true);
	        }
	      }, _react2.default.createElement("span", {
	        style: {
	          marginRight: "3px"
	        }
	      }, _react2.default.createElement("icon", {
	        className: !_this.state.data.payload.poMode ? "fa fa-eye" : "fa fa-eye-slash",
	        style: { color: "rgb(30, 101, 144)" }
	      }), " ", "BCS View"))), _react2.default.createElement("hr", {
	        style: {
	          margin: "2px"
	        }
	      })));
	    }, _this.getDateFilter = function () {
	      return _react2.default.createElement("div", {
	        style: {
	          display: "flex",
	          direction: "row",
	          alignItems: "center"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          fontSize: "14px",
	          border: "0px solid black",
	          cursor: "pointer",
	          width: "250px",
	          height: "30px",
	          lineHeight: "30px",
	          textAlign: "left",
	          margin: "5px",
	          marginLeft: "15px",
	          marginRight: "15px"
	        },
	        onClick: function onClick() {
	          _this.stateChangeHandler(!_this.state.data.payload.orderDateFlag, "orderDateFlag", true);
	          _this.stateChangeHandler(!_this.state.data.payload.sTgtdFlagDate, "sTgtdFlagDate", true);
	        }
	      }, _react2.default.createElement("span", {
	        style: {
	          marginRight: "3px"
	        }
	      }, _react2.default.createElement("icon", {
	        className: _this.state.data.payload.orderDateFlag ? "fa fa-eye" : "fa fa-eye-slash",
	        style: { color: "rgb(30, 101, 144)" }
	      }), " ", "Order Date")), _react2.default.createElement("div", {
	        style: {
	          borderRadius: "5px",
	          color: "#fff",
	          backgroundColor: "rgb(30, 101, 144)",
	          fontSize: "1.5em",
	          border: "0px solid black",
	          cursor: "pointer",
	          fontWeight: "bold",
	          width: "60px",
	          height: "30px",
	          lineHeight: "30px",
	          textAlign: "center",
	          margin: "5px",
	          marginLeft: "15px"
	        },
	        onClick: function onClick() {
	          var currStateDate = _this.state.data.payload.deliveryDate;
	          if (!currStateDate || currStateDate === undefined) {
	            currStateDate = (0, _moment2.default)().format("DD-MM-YYYY");
	          }
	          var currTgtDate = (0, _moment2.default)(currStateDate, "DD-MM-YYYY");
	          var newDate = currTgtDate.subtract(1, "day");
	
	          _this.stateChangeHandler(newDate.format("DD-MM-YYYY").toString(), "deliveryDate", true);
	          _this.stateChangeHandler(true, "orderDateFlag", true);
	          _this.stateChangeHandler(false, "sTgtdFlagDate", true);
	        }
	      }, "<"), _react2.default.createElement("div", {
	        style: {
	          width: "100%",
	          lineHeight: "45px",
	          textAlign: "center"
	        }
	      }, (0, _moment2.default)(_this.state.data.payload["deliveryDate"], "DD-MM-YYYY").format("ddd DD-MM-YYYY").toString()), _react2.default.createElement("div", {
	        style: {
	          borderRadius: "5px",
	          color: "#fff",
	          backgroundColor: "rgb(30, 101, 144)",
	          fontSize: "1.5em",
	          border: "0px solid black",
	          cursor: "pointer",
	          fontWeight: "bold",
	          width: "60px",
	          height: "30px",
	          lineHeight: "30px",
	          textAlign: "center",
	          margin: "5px",
	          marginRight: "15px"
	        },
	        onClick: function onClick() {
	          var currTgtDate = (0, _moment2.default)(_this.state.data.payload.deliveryDate, "DD-MM-YYYY");
	          var newDate = currTgtDate.add(1, "day");
	
	          if (_this.state.data.payload.deliveryDate) {
	            _this.stateChangeHandler(newDate.format("DD-MM-YYYY").toString(), "deliveryDate", true);
	          } else {
	            _this.stateChangeHandler((0, _moment2.default)().add(1, "day").format("DD-MM-YYYY").toString(), "deliveryDate", true);
	          }
	          _this.stateChangeHandler(true, "orderDateFlag", true);
	          _this.stateChangeHandler(false, "sTgtdFlagDate", true);
	        }
	      }, ">"));
	    }, _this.getTargetDateFilter = function () {
	      return _react2.default.createElement("div", {
	        style: {
	          display: "flex",
	          direction: "row",
	          alignItems: "center"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          fontSize: "14px",
	          border: "0px solid black",
	          cursor: "pointer",
	          width: "250px",
	          height: "30px",
	          lineHeight: "30px",
	          textAlign: "left",
	          margin: "5px",
	          marginLeft: "15px",
	          marginRight: "15px"
	        },
	        onClick: function onClick() {
	          _this.stateChangeHandler(!_this.state.data.payload.sTgtdFlagDate, "sTgtdFlagDate", true);
	          _this.stateChangeHandler(!_this.state.data.payload.orderDateFlag, "orderDateFlag", true);
	        }
	      }, _react2.default.createElement("span", {
	        style: {
	          marginRight: "3px"
	        }
	      }, _react2.default.createElement("icon", {
	        className: _this.state.data.payload.sTgtdFlagDate ? "fa fa-eye" : "fa fa-eye-slash",
	        style: { color: "rgb(30, 101, 144)" }
	      })), " ", "Tgt Dlvry Dt"), _react2.default.createElement("div", {
	        style: {
	          borderRadius: "5px",
	          color: "#fff",
	          backgroundColor: "rgb(30, 101, 144)",
	          fontSize: "1.5em",
	          border: "0px solid black",
	          cursor: "pointer",
	          fontWeight: "bold",
	          width: "60px",
	          height: "30px",
	          lineHeight: "30px",
	          textAlign: "center",
	          margin: "5px",
	          marginLeft: "15px"
	        },
	        onClick: function onClick() {
	          var currStateDate = _this.state.data.payload.targetDeliveryDate;
	          if (!currStateDate || currStateDate === undefined) {
	            currStateDate = (0, _moment2.default)().format("ddd DD-MM-YYYY");
	          }
	          var currTgtDate = (0, _moment2.default)(currStateDate, "ddd DD-MM-YYYY");
	          var newDate = currTgtDate.subtract(1, "day");
	
	          _this.stateChangeHandler(newDate.format("ddd DD-MM-YYYY").toString(), "targetDeliveryDate", true);
	          _this.stateChangeHandler(true, "sTgtdFlagDate", true);
	          _this.stateChangeHandler(false, "orderDateFlag", true);
	        }
	      }, "<"), _react2.default.createElement("div", {
	        style: {
	          width: "100%",
	          lineHeight: "45px",
	          textAlign: "center"
	        }
	      }, _this.state.data.payload["targetDeliveryDate"]), _react2.default.createElement("div", {
	        style: {
	          borderRadius: "5px",
	          color: "#fff",
	          backgroundColor: "rgb(30, 101, 144)",
	          fontSize: "1.5em",
	          border: "0px solid black",
	          cursor: "pointer",
	          fontWeight: "bold",
	          width: "60px",
	          height: "30px",
	          lineHeight: "30px",
	          textAlign: "center",
	          margin: "5px",
	          marginRight: "15px"
	        },
	        onClick: function onClick() {
	          var currTgtDate = (0, _moment2.default)(_this.state.data.payload.targetDeliveryDate, "ddd DD-MM-YYYY");
	          var newDate = currTgtDate.add(1, "day");
	
	          if (_this.state.data.payload.targetDeliveryDate) {
	            _this.stateChangeHandler(newDate.format("ddd DD-MM-YYYY").toString(), "targetDeliveryDate", true);
	          } else {
	            _this.stateChangeHandler((0, _moment2.default)().add(1, "day").format("ddd DD-MM-YYYY").toString(), "targetDeliveryDate", true);
	          }
	          _this.stateChangeHandler(true, "sTgtdFlagDate", true);
	          _this.stateChangeHandler(false, "orderDateFlag", true);
	        }
	      }, ">"));
	    }, _this.getCategCell = function (name, caption, allItems, foodItems, vfruitItems, meatItems, ingredients) {
	      return _react2.default.createElement("div", {
	        style: {
	          width: "20%",
	          textAlign: "center",
	          lineHeight: "20px",
	          fontSize: _this.state.data.payload[name] ? "14px" : "10px"
	        },
	        onClick: function onClick() {
	          _this.stateChangeHandler(allItems, "allItems", true);
	          _this.stateChangeHandler(foodItems, "foodItems", true);
	          _this.stateChangeHandler(vfruitItems, "vfruitItems", true);
	          _this.stateChangeHandler(meatItems, "meatItems", true);
	          _this.stateChangeHandler(ingredients, "ingredients", true);
	        }
	      }, _react2.default.createElement("span", {
	        style: {
	          marginRight: "3px"
	        }
	      }, _react2.default.createElement("icon", {
	        className: _this.state.data.payload[name] ? "fa fa-eye" : "fa fa-eye-slash",
	        style: { color: "rgb(30, 101, 144)" }
	      }), " ", caption));
	    }, _this.getCounters = function () {
	      return _react2.default.createElement("div", {
	        style: {
	          height: "45px",
	          lineHeight: "45px",
	          textAlign: "center"
	        }
	      }, _this.state.allOrders && _react2.default.createElement("div", null, "Total Orders: ", _this.props.data.length), _this.state.selectedOrders && _react2.default.createElement("div", null, "Ords:", " ", _this.state.summedData && _this.state.summedData.ordCount ? _this.state.summedData.ordCount : "0", " ", "| Prods:", " ", _this.state.summedData && _this.state.summedData.products ? _this.state.summedData.products.length : "0", " ", "| Locs:", " ", _this.state.summedData && _this.state.summedData.locations ? _this.state.summedData.locations : " ", _this.props.cellPhone === "+6594562455" && _react2.default.createElement("span", null, "| Amt:", " ", _this.state.summedData && _this.state.summedData.ordTotal ? _this.state.summedData.ordTotal : " ")));
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(AdminGrid, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.setState(function (prevState) {
	        return _extends({}, prevState, {
	          compactOrderView: false,
	          data: {
	            path: "adminSummary",
	            payload: {
	              targetDeliveryDate: (0, _moment2.default)().format("ddd DD-MM-YYYY").toString(),
	              deliveryDate: (0, _moment2.default)().subtract(1, "day").format("DD-MM-YYYY").toString(),
	              open: true,
	              delivered: false,
	              sTgtdFlagDate: true,
	              orderDateFlag: false,
	              allItems: true,
	              foodItems: false,
	              vfruitItems: false,
	              meatItems: false,
	              ingredients: false,
	              mealLunch: true,
	              mealDinner: true,
	              mealAll: true,
	              breakup: true,
	              image: true
	            }
	          }
	        });
	      });
	      this.getSummedData(this.props.data);
	      this.getOrdCount(this.props.data);
	    }
	
	    /*
	    summedData: this.getSummedData(this.props.data),
	          procInfo: this.getProcInfo(this.props.data)
	    */
	
	    //single method that work for all fields
	    //takes incoming id of the field and then adds field data to state
	
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement("div", {
	        style: {
	          marginBottom: "15px"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          display: "flex",
	          direction: "row"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          margin: "2px",
	          padding: "2px",
	          background: this.state.showSummary ? "rgb(30, 101, 144)" : "white",
	          color: this.state.showSummary ? "white" : "black",
	          textAlign: "center",
	          width: "20%"
	        },
	        onClick: function onClick() {
	          _this2.stateChangeHandler(!_this2.state.showSummary, "showSummary", false);
	        }
	      }, "Smry"), _react2.default.createElement("div", {
	        style: {
	          margin: "2px",
	          padding: "2px",
	          background: this.state.showFilters ? "rgb(30, 101, 144)" : "white",
	          color: this.state.showFilters ? "white" : "black",
	          textAlign: "center",
	          width: "20%"
	        },
	        onClick: function onClick() {
	          _this2.stateChangeHandler(!_this2.state.showFilters, "showFilters", false);
	        }
	      }, "Fltrs"), _react2.default.createElement("div", {
	        style: {
	          margin: "2px",
	          padding: "2px",
	          background: this.state.selectedOrders ? "rgb(30, 101, 144)" : "white",
	          color: this.state.selectedOrders ? "white" : "black",
	          textAlign: "center",
	          width: "20%"
	        },
	        onClick: function onClick() {
	          _this2.stateChangeHandler(!_this2.state.selectedOrders, "selectedOrders", false);
	          _this2.stateChangeHandler(false, "allOrders", false);
	        }
	      }, "Slctd Ord"), _react2.default.createElement("div", {
	        style: {
	          margin: "2px",
	          padding: "2px",
	          background: this.state.allOrders ? "rgb(30, 101, 144)" : "white",
	          color: this.state.allOrders ? "white" : "black",
	          textAlign: "center",
	          width: "20%"
	        },
	        onClick: function onClick() {
	          _this2.stateChangeHandler(!_this2.state.allOrders, "allOrders", false);
	          _this2.stateChangeHandler(false, "selectedOrders", false);
	        }
	      }, "All Ord"), _react2.default.createElement("div", {
	        style: {
	          margin: "2px",
	          padding: "2px",
	          background: this.state.messageFocus ? "rgb(30, 101, 144)" : "white",
	          color: this.state.messageFocus ? "white" : "black",
	          textAlign: "center",
	          width: "20%"
	        },
	        onClick: function onClick() {
	          _this2.stateChangeHandler(!_this2.state.messageFocus, "messageFocus", false);
	          _this2.stateChangeHandler(false, "compactOrderView", false);
	          _this2.stateChangeHandler(false, "regularOrderView", false);
	          _this2.stateChangeHandler(false, "print1OrderView", false);
	        }
	      }, "Msg Fcs")), _react2.default.createElement("div", {
	        style: {
	          display: "flex",
	          direction: "row"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          margin: "2px",
	          padding: "2px",
	          minWidth: "100px",
	          background: this.state.regularOrderView ? "rgb(30, 101, 144)" : "white",
	          color: this.state.regularOrderView ? "white" : "black",
	          textAlign: "center",
	          width: "20%"
	        },
	        onClick: function onClick() {
	          _this2.stateChangeHandler(!_this2.state.regularOrderView, "regularOrderView", false);
	          _this2.stateChangeHandler(false, "compactOrderView", false);
	          _this2.stateChangeHandler(false, "messageFocus", false);
	          _this2.stateChangeHandler(false, "print1OrderView", false);
	        }
	      }, "Rglr"), _react2.default.createElement("div", {
	        style: {
	          margin: "2px",
	          padding: "2px",
	          background: this.state.compactOrderView ? "rgb(30, 101, 144)" : "white",
	          color: this.state.compactOrderView ? "white" : "black",
	          textAlign: "center",
	          width: "20%"
	        },
	        onClick: function onClick() {
	          _this2.stateChangeHandler(!_this2.state.compactOrderView, "compactOrderView", false);
	          _this2.stateChangeHandler(false, "regularOrderView", false);
	          _this2.stateChangeHandler(false, "messageFocus", false);
	          _this2.stateChangeHandler(false, "print1OrderView", false);
	        }
	      }, "Cmpct"), _react2.default.createElement("div", {
	        style: {
	          margin: "2px",
	          padding: "2px",
	          background: this.state.print1OrderView ? "rgb(30, 101, 144)" : "white",
	          color: this.state.print1OrderView ? "white" : "black",
	          textAlign: "center",
	          width: "20%"
	        },
	        onClick: function onClick() {
	          _this2.stateChangeHandler(!_this2.state.print1OrderView, "print1OrderView", false);
	          _this2.stateChangeHandler(false, "compactOrderView", false);
	          _this2.stateChangeHandler(false, "regularOrderView", false);
	          _this2.stateChangeHandler(false, "messageFocus", false);
	        }
	      }, "Prnt 1"), _react2.default.createElement("div", {
	        style: {
	          margin: "2px",
	          padding: "2px",
	          background: this.state.viewOpenOrders ? "rgb(30, 101, 144)" : "white",
	          color: this.state.viewOpenOrders ? "white" : "black",
	          textAlign: "center",
	          width: "20%"
	        },
	        onClick: function onClick() {
	          _this2.stateChangeHandler(!_this2.state.viewOpenOrders, "viewOpenOrders", false);
	          _this2.stateChangeHandler(false, "viewAllOrders", false);
	        }
	      }, "Open"), _react2.default.createElement("div", {
	        style: {
	          margin: "2px",
	          padding: "2px",
	          background: this.state.viewAllOrders ? "rgb(30, 101, 144)" : "white",
	          color: this.state.viewAllOrders ? "white" : "black",
	          textAlign: "center",
	          width: "20%"
	        },
	        onClick: function onClick() {
	          _this2.stateChangeHandler(!_this2.state.viewAllOrders, "viewAllOrders", false);
	          _this2.stateChangeHandler(false, "viewOpenOrders", false);
	        }
	      }, "All")), this.state.showFilters && this.getControlPanel(), this.state.showSummary && _react2.default.createElement("div", null, _react2.default.createElement("div", {
	        style: {
	          margin: "5px",
	          marginTop: "30px",
	          textAlign: "center"
	        }
	      }, _react2.default.createElement(_reactToPrint2.default, {
	        trigger: function trigger() {
	          // NOTE: could just as easily return <SomeComponent />. Do NOT pass an `onClick` prop
	          // to the root node of the returned component as it will be overwritten.
	          return _react2.default.createElement("a", { href: "#" }, "Print this out!");
	        },
	        content: function content() {
	          return _this2.summRef;
	        }
	      })), _react2.default.createElement("div", { ref: function ref(el) {
	          return _this2.summRef = el;
	        } }, this.getCounters(), _react2.default.createElement(_AdminSummaryList2.default, _extends({}, this.props, {
	        summedData: this.state.summedData
	        //summedData={this.getSummedData(this.props.data)}
	        , image: this.state.data.payload.image,
	        poMode: this.state.data.payload.poMode,
	        breakup: this.state.data.payload.breakup,
	        showImage: this.state.data.payload.image
	      })))), this.state.allOrders && _react2.default.createElement("div", null, _react2.default.createElement("div", {
	        style: {
	          margin: "5px",
	          marginTop: "30px",
	          textAlign: "center"
	        }
	      }, _react2.default.createElement(_reactToPrint2.default, {
	        trigger: function trigger() {
	          // NOTE: could just as easily return <SomeComponent />. Do NOT pass an `onClick` prop
	          // to the root node of the returned component as it will be overwritten.
	          return _react2.default.createElement("a", { href: "#" }, "Print this out!");
	        },
	        content: function content() {
	          return _this2.allOrdRef;
	        }
	      })), _react2.default.createElement("div", { ref: function ref(el) {
	          return _this2.allOrdRef = el;
	        } }, _react2.default.createElement("div", { style: { overflowX: "auto" } }, this.getCounters(), _react2.default.createElement(_AdminOrderList2.default, _extends({}, this.props, {
	        compact: this.state.compactOrderView,
	        regular: this.state.regularOrderView,
	        messageFocus: this.state.messageFocus,
	        printFocus: this.state.print1OrderView,
	        showDets: this.state.data.payload.breakup,
	        showImage: this.state.data.payload.image,
	        finalInfo: this.state.finalInfo
	      }))))), this.state.selectedOrders && _react2.default.createElement("div", null, _react2.default.createElement("div", {
	        style: {
	          margin: "5px",
	          marginTop: "30px",
	          textAlign: "center"
	        }
	      }, _react2.default.createElement(_reactToPrint2.default, {
	        trigger: function trigger() {
	          // NOTE: could just as easily return <SomeComponent />. Do NOT pass an `onClick` prop
	          // to the root node of the returned component as it will be overwritten.
	          return _react2.default.createElement("a", { href: "#" }, "Print this out!");
	        },
	        content: function content() {
	          return _this2.selOrdRef;
	        }
	      })), _react2.default.createElement("div", { ref: function ref(el) {
	          return _this2.selOrdRef = el;
	        } }, _react2.default.createElement("div", null, this.getCounters(), _react2.default.createElement(_AdminOrderList2.default, _extends({}, this.props, {
	        data: this.getProcInfo(this.props.data)
	        //data={this.getProcInfo(this.props.data)}
	        , compact: this.state.compactOrderView,
	        regular: this.state.regularOrderView,
	        messageFocus: this.state.messageFocus,
	        printFocus: this.state.print1OrderView,
	        showDets: this.state.data.payload.breakup,
	        showImage: this.state.data.payload.image,
	        finalInfo: this.state.finalInfo
	      }))))));
	    }
	  }]);
	
	  return AdminGrid;
	}(_react.Component);
	
	exports.default = AdminGrid;

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MyShopCard = __webpack_require__(288);
	
	var _MyShopCard2 = _interopRequireDefault(_MyShopCard);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var MyShopGrid = function (_Component) {
	  _inherits(MyShopGrid, _Component);
	
	  function MyShopGrid(props) {
	    _classCallCheck(this, MyShopGrid);
	
	    var _this = _possibleConstructorReturn(this, (MyShopGrid.__proto__ || Object.getPrototypeOf(MyShopGrid)).call(this, props));
	
	    _this.getMobileDivs = function (data) {
	      return data.map(function (rec) {
	        //console.log(JSON.stringify(rec));
	        return _react2.default.createElement(_MyShopCard2.default, {
	          key: rec.key,
	          tableName: _this.props.tableName,
	          handleDelete: _this.props.handleDelete,
	          ogTableDef: _this.props.ogTableDef,
	          genNotification: _this.props.genNotification,
	          cellPhone: _this.props.refPhoneNumber,
	          handleEdit: _this.props.handleEdit,
	          data: rec
	        });
	      });
	    };
	
	    return _this;
	  }
	
	  _createClass(MyShopGrid, [{
	    key: "render",
	    value: function render() {
	      if (this.props.data && this.props.data !== undefined && this.props.data.length > 0) {
	        return _react2.default.createElement("div", null, this.getMobileDivs(this.props.data));
	
	        //return this.getRows(this.props.data);
	      } else {
	        return _react2.default.createElement("div", {
	          style: {
	            marginTop: "30px"
	          }
	        }, "No Items listed in your shop");
	      }
	    }
	  }]);
	
	  return MyShopGrid;
	}(_react.Component);
	
	exports.default = MyShopGrid;

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _WorkerCard = __webpack_require__(289);
	
	var _WorkerCard2 = _interopRequireDefault(_WorkerCard);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var WorkerGrid = function (_Component) {
	  _inherits(WorkerGrid, _Component);
	
	  function WorkerGrid(props) {
	    _classCallCheck(this, WorkerGrid);
	
	    var _this = _possibleConstructorReturn(this, (WorkerGrid.__proto__ || Object.getPrototypeOf(WorkerGrid)).call(this, props));
	
	    _this.getMobileDivs = function (data) {
	      //console.log(JSON.stringify(data));
	      return data.map(function (rec) {
	        if (rec.requestedItems && rec.requestedItems.length > 0 && rec.requestedItems[0].key !== undefined) {
	          return _react2.default.createElement(_WorkerCard2.default, {
	            key: rec.key,
	            rec: rec,
	            handleEdit: _this.props.handleEdit,
	            phoneNumber: _this.props.phoneNumber,
	            path: _this.props.tableName,
	            tableName: _this.props.tableName,
	            firebase: _this.props.firebase,
	            updateRecord: _this.props.updateRecord,
	            onNotifyUsers: _this.props.onNotifyUsers,
	            allSuppliers: _this.props.allSuppliers,
	            stage: _this.props.stage,
	            repeatOrder: _this.props.repeatOrder
	          });
	        }
	      });
	    };
	
	    _this.state = {
	      data: {
	        path: _this.props.tableName,
	        payload: _this.props.data
	      },
	      fieldList: {
	        worker: ["mobile", "name", "address", "requestedItems", "supplier"],
	        grocer: ["mobile", "name", "requestedItems"],
	        all: ["deliveryDate", "mobile", "name", "address", "requestedItems", "status", "supplier", "supplierPrice", "supplierNotes", "supplierPrices"]
	      }
	    };
	    return _this;
	  }
	
	  _createClass(WorkerGrid, [{
	    key: "render",
	    value: function render() {
	      if (this.props.data && this.props.data !== undefined && this.props.data.length > 0) {
	        return _react2.default.createElement("div", null, this.getMobileDivs(this.props.data));
	
	        //return this.getRows(this.props.data);
	      } else {
	        if (this.props.dataIsLoaded) {
	          return _react2.default.createElement("div", null, _react2.default.createElement("div", {
	            style: {
	              textAlign: "center",
	              padding: "10px"
	            }
	          }, "You do not have any orders."));
	        } else {
	          return _react2.default.createElement("div", {
	            style: {
	              margin: "15px"
	            }
	          }, _react2.default.createElement("div", {
	            style: {
	              textAlign: "center"
	            }
	          }, "Seems like you are on a slow network, we are loading data please wait a moment..."));
	        }
	      }
	    }
	  }]);
	
	  return WorkerGrid;
	}(_react.Component);
	
	exports.default = WorkerGrid;

/***/ }),
/* 149 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var backupImage = exports.backupImage = "data:image/jpeg;base64,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";

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactackle = __webpack_require__(5);
	
	var _reactDeviceDetect = __webpack_require__(6);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var TextInputField = function (_Component) {
	  _inherits(TextInputField, _Component);
	
	  function TextInputField() {
	    _classCallCheck(this, TextInputField);
	
	    return _possibleConstructorReturn(this, (TextInputField.__proto__ || Object.getPrototypeOf(TextInputField)).apply(this, arguments));
	  }
	
	  _createClass(TextInputField, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement("div", {
	        className: "row",
	        style: {
	          marginLeft: "1px",
	          marginRight: "1px",
	          alignItems: "center",
	          padding: "2px",
	          border: "0px",
	          borderBottom: "0px",
	          borderBottomColor: "#cccccc",
	          borderStyle: "solid",
	          paddingBottom: _reactDeviceDetect.isMobile ? "0px" : "2px"
	        }
	      }, _react2.default.createElement("div", {
	        className: "col-sm-4 align-self-center\xE2\u20AC\x9D",
	        style: {
	          margin: "0px",
	          verticalAlign: "middle",
	          height: "auto",
	          padding: "0px"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          marginTop: _reactDeviceDetect.isMobile ? "13px" : "0px",
	          verticalAlign: "middle",
	          lineHeight: _reactDeviceDetect.isMobile ? "20px" : "37px",
	          padding: "0px",
	          color: _reactDeviceDetect.isMobile ? "black" : "black",
	          marginBottom: _reactDeviceDetect.isMobile ? "-1px" : "0px"
	        }
	      }, this.props.title)), _react2.default.createElement("div", {
	        className: "col-sm-8",
	        style: {
	          padding: "1px",
	          textAlign: "right",
	          border: "1px solid gainsboro",
	          borderRadius: _reactDeviceDetect.isMobile ? "5px" : "0px",
	          backgroundColor: "white"
	        }
	      }, _react2.default.createElement(_reactackle.TextField, _extends({
	        value: this.props.value,
	        onChange: function onChange(e) {
	          _this2.props.stateChangeHandler(e.value, _this2.props.fieldName, true);
	        }
	      }, this.props, {
	        fullWidth: true
	      }))));
	    }
	  }]);
	
	  return TextInputField;
	}(_react.Component);
	
	exports.default = TextInputField;

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(36);
	
	var _reactRedux = __webpack_require__(9);
	
	var _actions = __webpack_require__(13);
	
	var _recompose = __webpack_require__(11);
	
	var _Firebase = __webpack_require__(10);
	
	var _reactackle = __webpack_require__(5);
	
	__webpack_require__(911);
	
	var _rawState = __webpack_require__(62);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _toConsumableArray(arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
	      arr2[i] = arr[i];
	    }return arr2;
	  } else {
	    return Array.from(arr);
	  }
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var UserLogin = function (_Component) {
	  _inherits(UserLogin, _Component);
	
	  function UserLogin(props) {
	    _classCallCheck(this, UserLogin);
	
	    var _this = _possibleConstructorReturn(this, (UserLogin.__proto__ || Object.getPrototypeOf(UserLogin)).call(this, props));
	
	    _this.stateChangeHandler = function (val, id, isPayload) {
	      ////console.log("val: " + val + " id: " + id + " isPayload: " + isPayload);
	      var tmpState = {};
	      tmpState[id] = val;
	
	      if (isPayload) {
	        _this.setState(function (prevState) {
	          if (prevState && prevState.data.payload !== null) {
	            return _extends({}, prevState, {
	              data: _extends({}, prevState.data, {
	                payload: _extends({}, prevState.data.payload, tmpState)
	              })
	            });
	          } else {
	            return _extends({}, prevState, {
	              data: {
	                path: prevState.data.path,
	                payload: _extends({}, tmpState)
	              }
	            });
	          }
	        });
	      } else {
	        _this.setState(function (prevState) {
	          return _extends({}, prevState, tmpState);
	        });
	      }
	    };
	
	    _this.loginHandler = function (event) {
	      console.log("doing login...");
	      event.preventDefault();
	      if (_this.state.notInitialized && !_this.props.firebase.auth && _this.props.firebase.auth === undefined) {
	        _this.setState(function (prevState) {
	          return _extends({}, prevState, {
	            logview: [].concat(_toConsumableArray(prevState.logview), ["BROOKLYNZ"])
	          });
	        });
	        _this.props.firebase.doInitiate("BROOKLYNZ");
	        console.log("init done");
	        _this.setState(function (prevState) {
	          return _extends({}, prevState, {
	            notInitialized: false
	          });
	        });
	      }
	
	      var fbCloudUrl = "https://us-central1-brooklynztest.cloudfunctions.net";
	      var fbDbUrl = "https://brooklynztest.firebaseio.com";
	
	      _this.setState(function (prevState) {
	        return _extends({}, prevState, {
	          loginProgress: true
	        });
	      });
	      _this.props.firebase.auth.signInWithEmailAndPassword(_this.refs.email.value, _this.refs.password.value).then(function (userRes) {
	        //console.log("stringify and parse done/skipped");
	        console.log("auth done");
	        var res = userRes.user;
	        _this.props.loadFbData("createTable", _this.props.firebase).then(function (crTableRes) {
	          console.log("create table done");
	          _this.props.loadFbData("listOfTables", _this.props.firebase).then(function (listRes) {
	            console.log("listOtTables done");
	            _this.props.loadFbData("menuDesigner", _this.props.firebase).then(function (desRes) {
	              console.log("menus done");
	              _this.stateChangeHandler("login done", "logview", false);
	              _this.props.onSetUiFlag("showSpinner", false);
	              //console.log("ui flag switched off");
	
	              _this.props.onSetUiFlag("userUid", res.uid);
	
	              _this.props.onSetUiFlag("userEmail", res.email);
	              //console.log("email updated");
	
	              //console.log("inside load data: " + this.refs.email.value);
	              var currEmail = _this.refs.email.value;
	              _this.props.firebase.db.ref("/users").on("value", function (snapshot) {
	                ////console.log("Linking " + tableName);
	                var tmpArray = [];
	                var fbOject = [];
	                Promise.all([snapshot.val()]).then(function (res) {
	                  fbOject = res[0];
	                  //console.log("now recieved the response for teams loading");
	                  tmpArray = Object.keys(fbOject).map(function (key) {
	                    return _extends({}, fbOject[key], {
	                      key: key
	                    });
	                  });
	                  tmpArray.reverse();
	                  //console.log("array reversed");
	                  ////console.log("Total Records: " + tmpArray.length);
	                  _this.props.onAddArray({
	                    path: "users",
	                    payload: tmpArray
	                  });
	
	                  var currentUser = {};
	
	                  //
	
	                  currentUser = tmpArray.find(function (userObj) {
	                    if (userObj.userEmail === currEmail) {
	                      return userObj;
	                    }
	                  });
	
	                  //console.log("admin status: " + JSON.stringify(currentUser));
	
	                  _this.props.addRecord({
	                    path: "userProfile",
	                    payload: currentUser
	                  });
	
	                  if (currentUser !== undefined) {
	                    ////console.log("~!@~!@ " + JSON.stringify(currentUser));
	                    var isThisAdmin = currentUser.roleName === "ADMIN" || currentUser.roleName === "SUPERADMIN";
	                    var isThisSuperAdmin = currentUser.roleName === "SUPERADMIN";
	                    _this.props.onSetUiFlag("currUserRole", currentUser.roleName);
	                    _this.props.onSetUiFlag("isThisAdmin", isThisAdmin);
	                    _this.props.onSetUiFlag("isThisSuperAdmin", isThisSuperAdmin);
	
	                    var allMenus = {};
	                    var allMenusFromDb = _this.props.menuDesigner;
	                    if (allMenusFromDb && allMenusFromDb.length > 0) {
	                      var userMenu = allMenusFromDb.find(function (singMenu) {
	                        return singMenu.name === currentUser.roleName;
	                      });
	                      if (userMenu) {
	                        allMenus = userMenu.menuItems.map(function (singleMenu) {
	                          var srcTable = _this.props.listOfTables.find(function (item) {
	                            return item.name === singleMenu.tableName;
	                          });
	                          if (srcTable && srcTable !== undefined && srcTable.name) {
	                            return _extends({}, singleMenu, {
	                              menuCaption: srcTable.menu
	                            });
	                          }
	                        });
	                        _this.props.onSetUiFlag("userMenus", allMenus);
	                      }
	                    }
	
	                    _this.props.addRecord({
	                      path: "currentUser",
	                      payload: currentUser
	                    });
	
	                    _this.props.addRecord({
	                      path: "team",
	                      payload: {
	                        name: "BROOKLYNZ",
	                        fbCloudUrl: fbCloudUrl,
	                        fbDbUrl: fbDbUrl
	                      }
	                    });
	                    console.log("all done");
	                    _reactRouter.browserHistory.push("landingPage");
	                  }
	                });
	              });
	            });
	          });
	        });
	      }).catch(function (error) {
	        console.log("some error");
	        console.log(error);
	        _this.setState(function (prevState) {
	          return _extends({}, prevState, {
	            message: error.message,
	            loginProgress: false,
	            logview: [].concat(_toConsumableArray(prevState.logview), [error])
	          });
	        });
	      });
	    };
	
	    _this.loadData = function (tableName) {};
	
	    _this.getError = function () {
	      if (_this.state.message !== "" && _this.state.message !== undefined) {
	        return _react2.default.createElement("div", null, _this.state.message);
	      }
	    };
	
	    _this.getLoader = function () {
	      if (_this.state.loginProgress) {
	        return _react2.default.createElement("div", {
	          style: {
	            textAlign: "center"
	          }
	        }, _react2.default.createElement(_reactackle.CircleProgress, {
	          indeterminate: true,
	          subtitle: "Connecting...",
	          circleSize: 40,
	          strokeSize: 5,
	          labelPositionY: "bottom",
	          labelPositionX: "center"
	        }));
	      } else {
	        return _react2.default.createElement("button", {
	          type: "submit",
	          className: "btn btn-block btn-primary",
	          disabled: _this.state.loginProgress
	        }, "Submit");
	      }
	    };
	
	    _this.loginHandler = _this.loginHandler.bind(_this);
	    _this.handleEmailChange = _this.handleEmailChange.bind(_this);
	    _this.handlePassChange = _this.handlePassChange.bind(_this);
	    _this.state = {
	      message: "",
	      email: "ahmed_fayyaz@outlook.com",
	      password: "password1",
	      isAuthorized: false,
	      notInitialized: true,
	      loginProgress: false,
	      logview: [],
	      localhost: _rawState.localState.hostname
	    };
	    return _this;
	  }
	
	  _createClass(UserLogin, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {}
	
	    //single method that work for all fields
	    //takes incoming id of the field and then adds field data to state
	
	  }, {
	    key: "handleEmailChange",
	    value: function handleEmailChange(evt) {
	      this.setState({
	        email: evt.target.value
	      });
	    }
	  }, {
	    key: "handlePassChange",
	    value: function handlePassChange(evt) {
	      this.setState({
	        password: evt.target.value
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement("div", { className: "wrap" }, _react2.default.createElement("center", null, _react2.default.createElement("h1", { style: { marginBottom: "-20px" } }, "BCS"), _react2.default.createElement("h2", null, "Welcome to BCS"), _react2.default.createElement("div", {
	        style: {
	          minHeight: "30px"
	        }
	      }), _react2.default.createElement("div", {
	        style: {
	          minHeight: "30px"
	        }
	      })), _react2.default.createElement("div", null, _react2.default.createElement("form", { onSubmit: this.loginHandler }, window.location.hostname === this.state.localhost && _react2.default.createElement("div", { className: "form-group" }, _react2.default.createElement("label", null, "Email address:"), _react2.default.createElement("input", {
	        type: "email",
	        className: "form-control",
	        id: "email",
	        ref: "email",
	        value: _rawState.localState.login
	        //value="test@test.com"
	        , disabled: this.state.loginProgress
	      })), window.location.hostname !== this.state.localhost && _react2.default.createElement("div", { className: "form-group" }, _react2.default.createElement("label", null, "Email address:"), _react2.default.createElement("input", {
	        type: "email",
	        className: "form-control",
	        id: "email",
	        ref: "email"
	        //value="test@test.com"
	        , disabled: this.state.loginProgress
	      })), window.location.hostname === this.state.localhost && _react2.default.createElement("div", { className: "form-group" }, _react2.default.createElement("label", null, "Password:"), _react2.default.createElement("input", {
	        type: "password",
	        className: "form-control",
	        id: "password",
	        secure: true,
	        ref: "password",
	        value: _rawState.localState.password,
	        disabled: this.state.loginProgress
	      })), window.location.hostname !== this.state.localhost && _react2.default.createElement("div", { className: "form-group" }, _react2.default.createElement("label", null, "Password:"), _react2.default.createElement("input", {
	        type: "password",
	        className: "form-control",
	        id: "password",
	        secure: true,
	        ref: "password",
	        disabled: this.state.loginProgress
	      })), this.getError(), this.getLoader())));
	    }
	  }]);
	
	  return UserLogin;
	}(_react.Component);
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    addRecord: function addRecord(data) {
	      return dispatch((0, _actions.actionAddSingleRecord)(data));
	    },
	    onSetUiFlag: function onSetUiFlag(flagName, flagValue) {
	      return dispatch((0, _actions.setUiFlag)(flagName, flagValue));
	    },
	    onAddArray: function onAddArray(data) {
	      return dispatch((0, _actions.actionAddArray2Redux)(data));
	    },
	    setupUsers: function setupUsers(email, firebase, teamValue, fbCloudUrl, fbDbUrl) {
	      return dispatch((0, _actions.setupUsers)(email, firebase, teamValue, fbCloudUrl, fbDbUrl));
	    },
	    loadFbData: function loadFbData(tableName, firebase) {
	      return dispatch((0, _actions.loadFbData)(tableName, firebase));
	    },
	    onSignOut: function onSignOut() {
	      return dispatch((0, _actions.resetRedux)());
	    }
	  };
	};
	
	function mapStateToProps(state) {
	  return {
	    currentUser: state.db.currentUser,
	    menuDesigner: state.db.menuDesigner,
	    listOfTables: state.db.listOfTables
	  };
	}
	
	exports.default = (0, _recompose.compose)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _Firebase.withFirebase)(UserLogin);

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _recompose = __webpack_require__(11);
	
	var _Firebase = __webpack_require__(10);
	
	var _actions = __webpack_require__(13);
	
	var _reactackle = __webpack_require__(5);
	
	var _getDefs = __webpack_require__(43);
	
	var _getDefs2 = _interopRequireDefault(_getDefs);
	
	var _searchRecords = __webpack_require__(42);
	
	var _getEditView = __webpack_require__(108);
	
	var _getEditView2 = _interopRequireDefault(_getEditView);
	
	var _getMenuList = __webpack_require__(34);
	
	__webpack_require__(53);
	
	var _throttleDebounce = __webpack_require__(54);
	
	var _GridFilters = __webpack_require__(41);
	
	var _GridFilters2 = _interopRequireDefault(_GridFilters);
	
	var _GridDateFilters = __webpack_require__(40);
	
	var _GridDateFilters2 = _interopRequireDefault(_GridDateFilters);
	
	var _ContentGridVanilla = __webpack_require__(60);
	
	var _ContentGridVanilla2 = _interopRequireDefault(_ContentGridVanilla);
	
	var _OpenBazarGrid = __webpack_require__(103);
	
	var _OpenBazarGrid2 = _interopRequireDefault(_OpenBazarGrid);
	
	var _reactDeviceDetect = __webpack_require__(6);
	
	var _numeral = __webpack_require__(16);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var _extendedOgDef = __webpack_require__(26);
	
	var _extendedOgDef2 = _interopRequireDefault(_extendedOgDef);
	
	var _getInputField = __webpack_require__(18);
	
	var _getInputField2 = _interopRequireDefault(_getInputField);
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _AdminGrid = __webpack_require__(146);
	
	var _AdminGrid2 = _interopRequireDefault(_AdminGrid);
	
	var _MyShopGrid = __webpack_require__(147);
	
	var _MyShopGrid2 = _interopRequireDefault(_MyShopGrid);
	
	var _rawState = __webpack_require__(62);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _asyncToGenerator(fn) {
	  return function () {
	    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
	      function step(key, arg) {
	        try {
	          var info = gen[key](arg);var value = info.value;
	        } catch (error) {
	          reject(error);return;
	        }if (info.done) {
	          resolve(value);
	        } else {
	          return Promise.resolve(value).then(function (value) {
	            step("next", value);
	          }, function (err) {
	            step("throw", err);
	          });
	        }
	      }return step("next");
	    });
	  };
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var DirectAdmin = function (_Component) {
	  _inherits(DirectAdmin, _Component);
	
	  function DirectAdmin(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, DirectAdmin);
	
	    ////console.log("...test... " + JSON.stringify(tableDefs));
	    var _this = _possibleConstructorReturn(this, (DirectAdmin.__proto__ || Object.getPrototypeOf(DirectAdmin)).call(this, props));
	
	    _this.handleScroll = function (event) {
	      // console.log(
	      //   "scrolling... " + window.document.querySelector(".content").scrollTop
	      // );
	
	      var last_known_scroll_position = 0;
	      var ticking = false;
	
	      if (_this.state.showGrid) {
	        last_known_scroll_position = window.document.querySelector(".content").scrollTop;
	
	        if (!ticking) {
	          window.requestAnimationFrame(function () {
	            _this.props.onSetUiFlag("listYPos", window.document.querySelector(".content").scrollTop);
	            ticking = false;
	          });
	
	          ticking = true;
	        }
	      }
	    };
	
	    _this.applyDataCondition = function (singleRecord, dataCondition) {
	      //console.log("~~||~~ " + JSON.stringify(singleRecord));
	      //console.log("~~ in the loop" + JSON.stringify(dataCondition));
	      var tmpRes = false;
	
	      for (var p = 0; p < dataCondition.length; p++) {
	        // console.log(
	        //   "~~~ signRec: " +
	        //     singleRecord[dataCondition[p]["colKey"]] +
	        //     " cond: " +
	        //     dataCondition[p]["colKey"] +
	        //     "=" +
	        //     dataCondition[p]["fieldVal"] +
	        //     " OR " +
	        //     this.props.userProfile[dataCondition[p]["fieldVal"]]
	        // );
	        if (singleRecord[dataCondition[p]["colKey"]] === dataCondition[p]["fieldVal"]) {
	          tmpRes = true;
	        }
	
	        if (singleRecord[dataCondition[p]["colKey"]] === _this.props.userProfile[dataCondition[p]["fieldVal"]]) {
	          tmpRes = true;
	        }
	      }
	      //console.log("~~ returning: " + tmpRes);
	      return tmpRes;
	    };
	
	    _this.loadDataEx = function (allTableDets) {
	      //if (allTableDets.tableName === "visitors") {
	      var recsLimit = 0;
	
	      if (!allTableDets || allTableDets === undefined) {
	        return [];
	      }
	
	      if (_reactDeviceDetect.isMobile) {
	        if (allTableDets.recMobileLimit) {
	          recsLimit = parseInt(allTableDets.recMobileLimit);
	        }
	      } else {
	        if (allTableDets.recMobileLimit) {
	          recsLimit = parseInt(allTableDets.recLimit);
	        }
	      }
	
	      var basePath = "/";
	      var tableName = allTableDets.tableName;
	      if (recsLimit > 0) {
	        _this.props.firebase.db.ref(basePath + tableName).limitToLast(recsLimit).on("value", function (snapshot) {
	          var tmpArray = [];
	          var fbOject = [];
	          Promise.all([snapshot.val()]).then(function (res) {
	            fbOject = res[0];
	            if (fbOject && fbOject !== null && fbOject !== undefined) {
	              Object.keys(fbOject).map(function (key) {
	                var item = _extends({}, fbOject[key], {
	                  key: key
	                });
	                //console.log("~~ Linking " + JSON.stringify(allTableDets));
	                if (allTableDets.dataConditions && allTableDets.dataConditions !== undefined && allTableDets.dataConditions.length > 0) {
	                  //console.log(JSON.stringify(allTableDets.dataConditions));
	                  if (_this.applyDataCondition(item, allTableDets.dataConditions)) {
	                    tmpArray.push(item);
	                  }
	                } else {
	                  tmpArray.push(item);
	                }
	              });
	            }
	            //reverse to have latest at the top
	            //tmpArray.reverse();
	            _this.props.onAddRecord({
	              path: tableName,
	              payload: tmpArray
	            });
	          });
	        });
	      } else {
	        _this.props.firebase.db.ref(basePath + tableName).on("value", function (snapshot) {
	          var tmpArray = [];
	          var fbOject = [];
	          Promise.all([snapshot.val()]).then(function (res) {
	            fbOject = res[0];
	            if (fbOject && fbOject !== null && fbOject !== undefined) {
	              Object.keys(fbOject).map(function (key) {
	                var item = _extends({}, fbOject[key], {
	                  key: key
	                });
	
	                if (allTableDets.dataConditions && allTableDets.dataConditions !== undefined && allTableDets.dataConditions.length > 0) {
	                  //console.log(JSON.stringify(allTableDets.dataConditions));
	                  if (_this.applyDataCondition(item, allTableDets.dataConditions)) {
	                    tmpArray.push(item);
	                  }
	                } else {
	                  tmpArray.push(item);
	                }
	              });
	            }
	            //reverse to have latest at the top
	            //tmpArray.reverse();
	            _this.props.onAddRecord({
	              path: tableName,
	              payload: tmpArray
	            });
	          });
	        });
	      }
	      //}
	    };
	
	    _this.loadData = function (tableName, isDeleted) {
	      //console.log(tableName);
	      var recsLimit = 3000;
	      if (_reactDeviceDetect.isMobile) {
	        recsLimit = 2000;
	      }
	      if (tableName === "attendance") {
	        if (_reactDeviceDetect.isMobile) {
	          recsLimit === 2000;
	        } else {
	          recsLimit === 3000;
	        }
	      }
	      var basePath = "/";
	      if (isDeleted) {
	        basePath = "/deletedRecs/";
	      }
	      _this.props.firebase.db.ref(basePath + tableName).limitToLast(recsLimit).on("value", function (snapshot) {
	        ////console.log("Linking " + tableName);
	        var tmpArray = [];
	        var fbOject = [];
	        var projTempArray = [];
	        Promise.all([snapshot.val()]).then(function (res) {
	          //basic updating keys into objects
	          fbOject = res[0];
	          if (fbOject && fbOject !== null && fbOject !== undefined) {
	            tmpArray = Object.keys(fbOject).map(function (key) {
	              return _extends({}, fbOject[key], {
	                key: key
	              });
	            });
	          }
	          //reverse to have latest at the top
	          //tmpArray.reverse();
	
	          //filter project table for engineer and contributor
	          if (tableName === "projects" && (_this.props.currUserRole === "ENGINEER" || _this.props.currUserRole === "CONTRIBUTOR")) {
	            projTempArray = tmpArray.filter(function (item) {
	              return item.projectPhase === "IN FLIGHT";
	            });
	
	            //handle delete
	            if (isDeleted) {
	              _this.props.onAddRecord({
	                path: "deleted" + tableName,
	                payload: projTempArray
	              });
	            } else {
	              _this.props.onAddRecord({
	                path: tableName,
	                payload: projTempArray
	              });
	            }
	          } else {
	            //handle delete
	            if (isDeleted) {
	              _this.props.onAddRecord({
	                path: "deleted" + tableName,
	                payload: tmpArray
	              });
	            } else {
	              _this.props.onAddRecord({ path: tableName, payload: tmpArray });
	            }
	          }
	        });
	      });
	    };
	
	    _this.getTopSearchHeader = function () {
	      return _react2.default.createElement("div", {
	        style: {
	          position: "fixed",
	          zIndex: 9999999,
	          top: "60px",
	          width: "95%",
	          alignSelf: "center"
	        }
	      }, _react2.default.createElement("div", { className: "wrapzz" }, _react2.default.createElement("div", { className: "searchzz" }, _react2.default.createElement("input", {
	        type: "text",
	        className: "searchTermzz",
	        placeholder: "Search...",
	        ref: "searchText",
	        onKeyUp: function onKeyUp() {
	          window.document.querySelector(".content").scroll(0, 0);
	          _this.doDelaySearch();
	        }
	      }), _react2.default.createElement("button", {
	        type: "submit",
	        className: "searchButtonzz",
	        onClick: function onClick() {
	          _this.setState(function (prevState) {
	            return _extends({}, prevState, {
	              searchVal: _this.refs.searchText.value
	            });
	          });
	          ////console.log("searchText " + this.refs.searchText.value);
	          ////console.log(JSON.stringify(this.state.searchVal));
	        }
	      }, _react2.default.createElement("i", { className: "fa fa-search" })))));
	    };
	
	    _this.stateChangeHandler = function (val, id, isPayload) {
	      //console.log("val: " + val + " id: " + id + " isPayload: " + isPayload);
	      var tmpState = {};
	      tmpState[id] = val;
	
	      if (isPayload) {
	        _this.setState(function (prevState) {
	          if (prevState && prevState.data.payload !== null) {
	            return _extends({}, prevState, {
	              data: _extends({}, prevState.data, {
	                payload: _extends({}, prevState.data.payload, tmpState)
	              })
	            });
	          } else {
	            return _extends({}, prevState, {
	              data: {
	                path: prevState.data.path,
	                payload: _extends({}, tmpState)
	              }
	            });
	          }
	        });
	      } else {
	        _this.setState(function (prevState) {
	          return _extends({}, prevState, tmpState);
	        });
	      }
	    };
	
	    _this.logoutApp = function () {
	      var msgToApp = {
	        actionType: "logOut",
	        payload: {}
	      };
	
	      if (window && window.ReactNativeWebView) {
	        //console.log("posing logout message to app");
	        window.ReactNativeWebView.postMessage(JSON.stringify(msgToApp));
	      }
	    };
	
	    _this.setScroll = function (setToTop) {
	      //console.log("attempting scroll");
	      var element = window.document.querySelector(".content");
	      if (element && element !== "") {
	        //console.log("setting scroll");
	        if (setToTop) {
	          //console.log("setting to 0");
	          element.scroll(0, 0);
	        } else {
	          //console.log("setting to " + this.props.listYPos);
	          element.scroll(0, parseInt(_this.props.listYPos));
	        }
	      } else {
	        //console.log("element not found");
	      }
	    };
	
	    _this.switchMenu = function (menuName) {
	      if (_this.refs && _this.refs.searchText) {
	        _this.refs.searchText.value = "";
	        _this.doDelaySearch();
	      }
	      _this.stateChangeHandler({}, "searchFilters", false);
	      _this.stateChangeHandler({}, "searchDateFilters", false);
	      _this.stateChangeHandler(false, "showPivot", false);
	      if (menuName === "dashboard") {
	        _this.setScroll(true);
	        _this.stateChangeHandler(true, "showDash", false);
	        _this.stateChangeHandler(false, "showGrid", false);
	        _this.stateChangeHandler(menuName, "tableName", false);
	      } else if (menuName === "signout") {
	        _this.stateChangeHandler("startButtonText", "LOADING ...", false);
	        _this.props.onSignOut();
	        _this.logoutApp();
	        _this.props.stateChangeHandler("login", "stage", false);
	        _this.props.stateChangeHandler(false, "loginProgress", false);
	      } else if (menuName === "bcsHome") {
	        _this.setScroll(true);
	        _this.props.switchMenu("bcsHome");
	      } else {
	        _this.setScroll(true);
	        _this.stateChangeHandler(true, "showGrid", false);
	        _this.stateChangeHandler(false, "showDash", false);
	        _this.stateChangeHandler(menuName, "tableName", false);
	      }
	    };
	
	    _this.isAdmin = function () {
	      return _this.props.isAdmin || _this.props.isSuperAdmin;
	    };
	
	    _this.deletePhotos = function (payload) {
	      var ogTableDef = (0, _extendedOgDef2.default)(_this.props.create);
	      var tableDef = ogTableDef[_this.state.tableName];
	
	      Object.keys(tableDef).map(function (fldKey) {
	        var fldDef = tableDef[fldKey];
	        if (fldDef.type == "photoUpload") {
	          var srcArray = payload[fldKey];
	          if (srcArray && srcArray.length > 0) {
	            for (var i = 0; i < srcArray.length; i++) {
	              var photoSource = srcArray[i];
	
	              //console.log(JSON.stringify(photoSource));
	              _this.props.onDeletePhoto(_this.props.firebase, photoSource.imageName, "images", undefined, _this.state.tableName);
	              //some action delete photo
	            }
	          }
	        }
	      });
	    };
	
	    _this.handleDelete = function (key, path, searchObj) {
	      _this.props.firebase.db.ref("/" + path + "/" + key).remove().then(function (res) {
	        _this.deletePhotos(searchObj);
	      });
	
	      _this.genNotification(searchObj, "delete");
	      _this.stateChangeHandler(true, "showGrid", false);
	    };
	
	    _this.handleEdit = function (key, path, fullPayload) {
	      var uRole = "";
	      if (_this.props.userProfile && _this.props.userProfile["roleName"] && _this.props.userProfile["roleName"] !== "") {
	        uRole = _this.props.userProfile["roleName"];
	      }
	      if (uRole === "ORDERADMIN" || uRole === "SUPERADMIN" || _this.state.tableName === "supplierShopItems") {
	        //alert("Here is the key: " + key + " here is the path: " + path);
	        window.document.querySelector(".content").scroll(0, 0);
	
	        _this.stateChangeHandler(false, "showGrid", false);
	        _this.props.onSelectRecord({ path: path, key: key });
	        _this.props.onSetUiFlag("operationType", "update");
	      }
	    };
	
	    _this.pickOrderByStoreAdmin = function (key, fullPayload) {
	      // console.log(
	      //   "pick by store admin: " +
	      //     key +
	      //     " " +
	      //     JSON.stringify(this.props.userProfile)
	      // );
	
	      var rec = _.cloneDeep(fullPayload);
	      var suppName = _this.props.userProfile["userCompany"];
	      var supplierContactName = _this.props.userProfile["userName"];
	      var supplierCellPhone = _this.props.userProfile["userMobile"];
	
	      var cloudPath = "deliveryRequest";
	      console.log("cloudPath: " + cloudPath);
	      if (rec && rec.key && rec.key !== "" && suppName && suppName !== "") {
	        rec.supplier = suppName;
	        rec.status = "PICKED BY SUPPLIER";
	        rec.supplierContactName = supplierContactName;
	        rec.supplierCellPhone = supplierCellPhone;
	        cloudPath = cloudPath + "/" + rec.key;
	
	        _this.props.firebase.db.ref("/" + cloudPath).once("value").then(function (snap) {
	          return snap.ref.set(rec);
	        }).catch(function (err) {
	          console.log(err);
	          return console.log("some error: " + err);
	        }).then(function (err) {
	          alert("This order has been successfully assigned to you. Other supplier will not be able to pick this order. ");
	          var phArray = [];
	          phArray.push(rec.mobile);
	          _this.props.onNotifyUsers(suppName + " is working to get your order ready.", phArray);
	          _this.props.onNotifyUsers("An order was picked up by other supplier", _this.getOtherSuppliers());
	        });
	      } else {
	        console.log("did not save");
	      }
	    };
	
	    _this.getOtherSuppliers = function () {
	      var allSup = _.chain(_this.props.users).filter(function (item) {
	        return item.roleName === "STOREADMIN";
	      }).pluck("userMobile").filter(function (item) {
	        return item !== "" && item !== null && typeof item === "string" && item !== _this.props.userProfile["userMobile"];
	      }).value();
	      return allSup;
	    };
	
	    _this.deliverOrderByStoreAdmin = function (key, fullPayload) {
	      // console.log(
	      //   "marking as delivered " +
	      //     key +
	      //     " " +
	      //     JSON.stringify(this.props.userProfile)
	      // );
	
	      // console.log(
	      //   "pick by store admin: " +
	      //     key +
	      //     " " +
	      //     JSON.stringify(this.props.userProfile)
	      // );
	
	      var rec = _.cloneDeep(fullPayload);
	
	      var cloudPath = "deliveryRequest";
	
	      if (rec && rec.key && rec.key !== "") {
	        rec.status = "DELIVERED";
	        cloudPath = cloudPath + "/" + rec.key;
	
	        _this.props.firebase.db.ref("/" + cloudPath).once("value").then(function (snap) {
	          return snap.ref.set(rec);
	        }).catch(function (err) {
	          console.log(err);
	          return console.log("some error: " + err);
	        }).then(function (err) {
	          alert("Order successfully updated as DELIVERED.");
	          var phArray = [];
	          phArray.push(rec.mobile);
	          _this.props.onNotifyUsers("Your order was marked as delivered. If you have not received your items, please wait for a while. If you have already received your items, you can help us by rating the service.", phArray);
	          _this.props.onNotifyUsers("An order was marked as Delivered by other supplier.", _this.getOtherSuppliers());
	        });
	      } else {
	        console.log("did not save");
	      }
	    };
	
	    _this.releaseOrderByStoreAdmin = function (key, fullPayload) {
	      // console.log(
	      //   "marking as delivered " +
	      //     key +
	      //     " " +
	      //     JSON.stringify(this.props.userProfile)
	      // );
	
	      // console.log(
	      //   "pick by store admin: " +
	      //     key +
	      //     " " +
	      //     JSON.stringify(this.props.userProfile)
	      // );
	
	      var rec = _.cloneDeep(fullPayload);
	
	      var cloudPath = "deliveryRequest";
	
	      if (rec && rec.key && rec.key !== "") {
	        rec.status = "WITH GROCER FOR PRICE";
	        rec.supplier = "ALL";
	
	        rec.supplierContactName = "";
	        rec.supplierCellPhone = "";
	        cloudPath = cloudPath + "/" + rec.key;
	
	        _this.props.firebase.db.ref("/" + cloudPath).once("value").then(function (snap) {
	          return snap.ref.set(rec);
	        }).catch(function (err) {
	          console.log(err);
	          return console.log("some error: " + err);
	        }).then(function (err) {
	          alert("Order successfully released back to market. Other suppliers can pick this order now.");
	        });
	      } else {
	        console.log("did not save");
	      }
	    };
	
	    _this.handleAddNew = function () {
	      ////console.log("generating new");
	      var initData = (0, _getMenuList.getInitData)(_this.state.tableName, _this.props.createTable, _this.props.userProfile);
	      if (initData && initData !== undefined) {
	        _this.stateChangeHandler(false, "showGrid", false);
	        _this.props.onSetUiFlag("operationType", "add");
	        _this.props.onSetUiFlag("tableName", _this.state.tableName);
	        _this.props.onAddNew({
	          path: _this.state.tableName,
	          data: _extends({}, initData)
	        });
	      }
	    };
	
	    _this.storeAutoLoginToApp = function () {
	      var tmpEmail = "";
	      var tempPass = "";
	
	      if (_this.refs.email && _this.refs.email.value) {
	        tmpEmail = _this.refs.email.value;
	      }
	
	      if (_this.refs.password && _this.refs.password.value) {
	        tempPass = _this.refs.password.value;
	      }
	
	      var msgToApp = {
	        actionType: "storeAutoLogin",
	        payload: {
	          email: tmpEmail,
	          password: tempPass,
	          company: _this.props.company
	        }
	      };
	
	      if (window && window.ReactNativeWebView) {
	        //console.log("posing autologin message to app");
	        window.ReactNativeWebView.postMessage(JSON.stringify(msgToApp));
	      }
	    };
	
	    _this.handleEditCancel = function () {
	      _this.stateChangeHandler(true, "showGrid", false);
	      window.document.querySelector(".content").scroll(0, parseInt(_this.props.listYPos));
	    };
	
	    _this.getDashView = function () {
	      //return <div></div>;
	      if (_this.props.userProfile && _this.props.userProfile["roleName"] && _this.props.userProfile["roleName"] === "SUPERADMIN") {
	        return _react2.default.createElement("div", {
	          style: {
	            backgroundColor: "white",
	            margint: "5px",
	            border: "1px solid grey",
	            borderRadius: "5px",
	            textAlign: "center"
	          }
	        }, _react2.default.createElement("div", {
	          style: {
	            padding: "2px",
	            border: "1px solid gainsboro"
	          }
	        }, "Total : ", _this.getTotCount(), " | Outstanding: ", _this.getTotOutCount()), _this.getCountByMobile(), _react2.default.createElement("div", null, _this.getCountByStatus()), _react2.default.createElement("div", {
	          style: {
	            marginBottom: "5px"
	          }
	        }, _this.getCountByOrdDate()));
	      }
	    };
	
	    _this.getFields = function () {
	      ////console.log("test");
	      alert("test");
	    };
	
	    _this.getAdminData = function () {
	      //console.log("looking for data: " + this.state.tableName);
	      //console.log(JSON.stringify(this.state.searchFilters));
	      var dTableName = _this.state.tableName;
	      if (_this.state.tableName === "viewReports") {
	        dTableName = "reports";
	      }
	      if (dTableName !== "dashboard") {
	        //console.log("not dash");
	        if (_this.state.searchVal === "" && Object(_this.state.searchFilters).keys && Object(_this.state.searchFilters).keys.length === 0) {
	          //console.log("time to return all data");
	          var allData = _this.props.db[dTableName];
	          if (allData && allData.length > 0) {
	            if (_this.state.sortByLatest) {
	              console.log("returning sortByLatest data");
	              return allData.reverse();
	            } else {
	              console.log("returning saada data");
	              return allData;
	            }
	          }
	        } else {
	          //console.log("its with some filters");
	          if (_this.state.tableDefs[dTableName] && _this.state.tableDefs[dTableName] !== undefined) {
	            //console.log("it has some tableDefs");
	            var allFullData = (0, _searchRecords.searchRecords)(_this.props.db[dTableName], _this.state.searchVal, _this.state.tableDefs[dTableName].searches, _this.state.searchFilters, _this.state.searchDateFilters);
	            var _allData = [];
	            if (_this.state.tableName === "deliveryRequest") {
	              _allData = allFullData.filter(function (item) {
	                return item.status !== "DELIVERED" && item.status !== "CANCELLED";
	              });
	            } else {
	              _allData = allFullData;
	            }
	            if (_allData && _allData.length > 0) {
	              if (_this.state.sortByLatest && _this.state.tableName === "deliveryRequest") {
	                //console.log("returning sortByLatest data");
	                return _allData.reverse();
	              } else {
	                //console.log("returning saada data");
	                return _allData;
	              }
	            } else {
	              //console.log("kuch mila he nahi");
	            }
	          } else {
	              //console.log("didnt search");
	            }
	        }
	      } else {
	          //console.log("its dash");
	        }
	    };
	
	    _this.doStateUpdateForSearch = function () {
	      _this.setState(function (prevState) {
	        return _extends({}, prevState, {
	          searchVal: _this.refs.searchText.value
	        });
	      });
	    };
	
	    _this.doDelaySearch = function () {
	      ////console.log("doning search...");
	      var q = _this.refs.searchText.value;
	      //this.stateChangeHandler("searchVal", q, false);
	      if (q.length < 5) {
	        _this.getDataThrottled();
	      } else {
	        _this.getDataDebounced();
	      }
	    };
	
	    _this.getSearchBar = function () {
	      return _react2.default.createElement("div", { className: "wrapzz" }, _react2.default.createElement("div", { className: "searchzz" }, _react2.default.createElement("input", {
	        type: "text",
	        className: "searchTermzz",
	        placeholder: "Search...",
	        ref: "searchText",
	        onKeyUp: function onKeyUp() {
	          window.document.querySelector(".content").scroll(0, 0);
	          _this.doDelaySearch();
	        }
	      }), _react2.default.createElement("button", {
	        type: "submit",
	        className: "searchButtonzz",
	        onClick: function onClick() {
	          _this.setState(function (prevState) {
	            return _extends({}, prevState, {
	              searchVal: _this.refs.searchText.value
	            });
	          });
	          ////console.log("searchText " + this.refs.searchText.value);
	          ////console.log(JSON.stringify(this.state.searchVal));
	        }
	      }, _react2.default.createElement("i", { className: "fa fa-search" }))));
	    };
	
	    _this.getNewButton = function () {
	      if (_this.state.showGrid) {
	        return _react2.default.createElement(_reactackle.Button, {
	          colorScheme: "primary",
	          onPress: function onPress() {
	            return _this.handleAddNew();
	          },
	          text: "Add New"
	        });
	      }
	    };
	
	    _this.recordPoPaymentHandler = function () {};
	
	    _this.getPoPaymentButton = function () {
	      if (_this.state.showGrid && _this.state.tableName === "projectPos") {
	        return _react2.default.createElement("div", {
	          style: {
	            justifyContent: "center",
	            verticalAlign: "middle",
	            padding: "6px",
	            paddingTop: "12px",
	            borderWidth: "0.5px",
	            borderColor: "blue",
	            borderRadius: "2px",
	            backgroundColor: "#2196F3"
	          }
	        }, _react2.default.createElement("a", {
	          href: "javascript:void(0)",
	          "data-toggle": "modal",
	          "data-target": "#myModal",
	          style: {
	            font: "inherit",
	            cursor: "pointer",
	            userSelect: "none",
	            fontFamily: "Open Sans,Helvetica Neue,Helvetica,Roboto,Arial,sans-serif",
	            boxSizing: "border-box",
	            color: "white",
	            textAlign: "inherit",
	            fontSize: "inherit",
	            lineHeight: "1.25",
	            fontWeight: "600",
	            textTransform: "uppercase",
	            paddingTop: "12px"
	          }
	        }, "Add Payment Details"));
	      }
	    };
	
	    _this.getPivotButton = function () {
	      if (_this.state.showGrid && _this.state.tableName !== "reports" && !_reactDeviceDetect.isMobile) {
	        return _react2.default.createElement(_reactackle.Button, {
	          colorScheme: "primary",
	          onPress: function onPress() {
	            return _this.stateChangeHandler(!_this.state.showPivot, "showPivot", false);
	          },
	          text: _this.state.showPivot ? "Show Grid" : "Show Pivot"
	        });
	      }
	    };
	
	    _this.getFiltersList = function () {
	      var filtersList = [];
	      if (_this.props.createTable && _this.props.createTable.length > 0) {
	        var tableObj = _this.props.createTable.find(function (item) {
	          return item.name === _this.state.tableName;
	        });
	
	        if (tableObj && tableObj !== undefined) {
	          if (tableObj.filters && tableObj.filters !== undefined) {
	            filtersList = tableObj.filters;
	          }
	        }
	
	        return filtersList;
	      } else {
	        console.log("createtable is empty");
	        return [];
	      }
	    };
	
	    _this.getFilterDropDowns = function () {
	      if (_this.state.showGrid) {
	        return _react2.default.createElement("div", null, _react2.default.createElement(_GridFilters2.default, {
	          path: _this.state.tableName,
	          stateHandler: _this.stateChangeHandler,
	          value: _this.state.searchFilters,
	          ogTableDef: _this.state.formDefs,
	          filtersList: _this.getFiltersList()
	        }), _react2.default.createElement(_GridDateFilters2.default, {
	          path: _this.state.tableName,
	          stateHandler: _this.stateChangeHandler,
	          value: _this.state.searchDateFilters,
	          ogTableDef: _this.state.formDefs,
	          filtersList: _this.getFiltersList()
	        }));
	      }
	    };
	
	    _this.getTotals = function () {
	      var totTables = ["projectInvoices", "projectPos"];
	
	      if (totTables.includes(_this.state.tableName)) {
	        var sumField = "";
	        if (_this.state.tableName === "projectInvoices") {
	          sumField = "totalInvoice";
	        } else if (_this.state.tableName === "projectPos") {
	          sumField = "poAmount";
	        }
	        if (sumField !== "") {
	          var filteredRecs = _this.getData();
	          var sum = filteredRecs.reduce(function (totValue, curr) {
	            return totValue + parseFloat(curr[sumField]);
	          }, 0);
	          var gstSum = sum * 1.07;
	          if (_reactDeviceDetect.isMobile) {
	            return _react2.default.createElement("table", { className: "table table-sm", style: { marginBottom: "0px" } }, _react2.default.createElement("tr", null, _react2.default.createElement("td", { style: { width: "50%", textAlign: "left" } }, "TOTAL:", " ", " " + (0, _numeral2.default)(sum.toFixed(2)).format("0,0.00") + "   "), _react2.default.createElement("td", { style: { width: "50%", textAlign: "right" } }, "TOTAL(W GST):", " ", " " + (0, _numeral2.default)(gstSum.toFixed(2)).format("0,0.00"))));
	          } else {
	            return _react2.default.createElement(_reactackle.CardActionsMain, null, _react2.default.createElement("div", {
	              className: "row",
	              style: {
	                marginLeft: "1px",
	                marginRight: "1px",
	                alignItems: "center",
	                padding: "2px",
	                border: "0px",
	                borderBottom: "0px",
	                borderBottomColor: "#cccccc",
	                borderStyle: "solid",
	                paddingBottom: _reactDeviceDetect.isMobile ? "0px" : "2px"
	              }
	            }, _react2.default.createElement("div", {
	              className: "col-sm-2",
	              style: {
	                textAlign: "right",
	                verticalAlign: "center",
	                border: "0px solid gainsboro",
	                width: "80px"
	              }
	            }, _react2.default.createElement("h5", null, "TOTAL")), _react2.default.createElement("div", {
	              className: "col-sm-2",
	              style: {
	                textAlign: "right",
	                verticalAlign: "center",
	                border: "1px solid gainsboro",
	                width: "120px"
	              }
	            }, _react2.default.createElement("h5", null, (0, _numeral2.default)(sum.toFixed(2)).format("0,0.00"))), _react2.default.createElement("div", {
	              className: "col-sm-2",
	              style: {
	                textAlign: "right",
	                verticalAlign: "center",
	                border: "0px solid gainsboro",
	                width: "140px"
	              }
	            }, _react2.default.createElement("h5", null, "TOTAL(W GST)")), _react2.default.createElement("div", {
	              className: "col-sm-2",
	              style: {
	                textAlign: "right",
	                verticalAlign: "center",
	                border: "1px solid gainsboro",
	                width: "120px"
	              }
	            }, _react2.default.createElement("h5", null, (0, _numeral2.default)(gstSum.toFixed(2)).format("0,0.00")))));
	          }
	        }
	      }
	    };
	
	    _this.getTopHeader = function () {
	      if (_reactDeviceDetect.isMobile) {} else {}
	    };
	
	    _this.getNicerData = function () {
	      var baseData = _this.getData();
	      var tableDefHere = _this.state.tableDefs[_this.state.tableName];
	      var nicerData = baseData.map(function (item) {
	        var tmpObj = {};
	        for (var key in item) {
	          if (tableDefHere && tableDefHere[key] && tableDefHere[key].caption && item[key]) {
	            tmpObj[tableDefHere[key].caption] = item[key];
	          }
	        }
	        return tmpObj;
	      });
	
	      return nicerData;
	    };
	
	    _this.getGrid = function () {
	      if (_this.state.showGrid) {
	        if (_this.state.tableName !== "reports") {
	          if (_this.state.tableName === "deliveryRequest") {
	            //console.log("sending AdminGrid back");
	            return _react2.default.createElement(_AdminGrid2.default, {
	              data: _this.getData(),
	              tableName: _this.state.tableName,
	              tableDef: _this.state.tableDefs[_this.state.tableName],
	              handleEdit: _this.handleEdit,
	              handleDelete: _this.handleDelete,
	              pickOrderByStoreAdmin: _this.pickOrderByStoreAdmin,
	              deliverOrderByStoreAdmin: _this.deliverOrderByStoreAdmin,
	              releaseOrderByStoreAdmin: _this.releaseOrderByStoreAdmin,
	              supplierName: _this.props.userProfile && _this.props.userProfile["userCompany"] ? _this.props.userProfile["userCompany"] : "",
	              supplierRole: _this.props.userProfile && _this.props.userProfile["roleName"] ? _this.props.userProfile["roleName"] : "",
	              role: "grocer"
	            });
	          } else if (_this.state.tableName === "supplierShopItems") {
	            //console.log("sending MyShopGrid back");
	            return _react2.default.createElement(_MyShopGrid2.default, {
	              data: _this.getData(),
	              tableName: _this.state.tableName,
	              tableDef: _this.state.tableDefs[_this.state.tableName],
	              handleEdit: _this.handleEdit,
	              handleDelete: _this.handleDelete,
	              pickOrderByStoreAdmin: _this.pickOrderByStoreAdmin,
	              deliverOrderByStoreAdmin: _this.deliverOrderByStoreAdmin,
	              releaseOrderByStoreAdmin: _this.releaseOrderByStoreAdmin,
	              supplierName: _this.props.userProfile && _this.props.userProfile["userCompany"] ? _this.props.userProfile["userCompany"] : "",
	              supplierRole: _this.props.userProfile && _this.props.userProfile["roleName"] ? _this.props.userProfile["roleName"] : "",
	              role: "all"
	            });
	          } else if (_this.state.tableName === "openBazar") {
	            //console.log("sending MyShopGrid back");
	            return _react2.default.createElement(_OpenBazarGrid2.default, {
	              data: _this.getData(),
	              tableName: _this.state.tableName,
	              tableDef: _this.state.tableDefs[_this.state.tableName],
	              handleEdit: _this.handleBazarEdit,
	              handleDelete: _this.handleDelete,
	              role: "worker",
	              phoneNumber: _this.props.firebase.auth.currentUser.phoneNumber
	            });
	          } else {
	            return _react2.default.createElement(_ContentGridVanilla2.default, {
	              data: _this.getData(),
	              tableName: _this.state.tableName,
	              tableDef: _this.state.tableDefs[_this.state.tableName],
	              handleEdit: _this.handleEdit,
	              handleDelete: _this.handleDelete
	            });
	          }
	        } else {
	          return _react2.default.createElement(AdvDashboard, {
	            data: _this.getData(),
	            reportData: {
	              attendance: _this.props.db["attendance"],
	              projectPos: _this.props.db["projectPos"],
	              projectInvoices: _this.props.db["projectInvoices"]
	            },
	            tableName: "reports",
	            tableDef: _this.state.tableDefs["reports"],
	            handleEdit: _this.handleEdit,
	            handleDelete: _this.handleDelete
	          });
	        }
	      }
	    };
	
	    _this.getEnrichedString = function (ogString, searchObj) {
	      //console.log(ogString + JSON.stringify(searchObj));
	      var strArray = ogString.split(" ").map(function (word) {
	        //console.log(word + " = " + searchObj[word]);
	        if (searchObj[word] && searchObj[word] !== undefined) {
	          return searchObj[word];
	        } else {
	          return word;
	        }
	      });
	
	      return strArray.join(" ");
	    };
	
	    _this.genNotification = function (recPayload, opType) {
	      var usersList = [];
	      var updateText = undefined;
	      var createText = undefined;
	      var deleteText = undefined;
	      var tableObj = _this.props.createTable.find(function (item) {
	        return item.name === _this.state.tableName;
	      });
	
	      if (tableObj && tableObj !== undefined) {
	        usersList = tableObj.notifyUsers;
	        createText = tableObj.createNotifyText;
	        updateText = tableObj.updateNotifyText;
	        deleteText = tableObj.deleteNotifyText;
	
	        if (opType === "update" && updateText && updateText !== "" && updateText !== null) {
	          //console.log(" updateText: " + updateText + " opType: " + opType);
	          _this.props.onNotifyUsers(_this.getEnrichedString(updateText, recPayload), usersList);
	        } else if (opType === "delete" && deleteText && deleteText !== "" && deleteText !== null) {
	          //console.log(" deleteText: " + deleteText + " opType: " + opType);
	          _this.props.onNotifyUsers(_this.getEnrichedString(deleteText, recPayload), usersList);
	        } else if (opType === "create" && createText && createText !== "" && createText !== null) {
	          //console.log("createText: " + createText + " opType: " + opType);
	          _this.props.onNotifyUsers(_this.getEnrichedString(createText, recPayload), usersList);
	        }
	      }
	    };
	
	    _this.getSelectedPoCount = function () {
	      var poRecs = _this.getData();
	      if (poRecs && poRecs.length && poRecs.length > 0) {
	        return poRecs.length;
	      } else {
	        return 0;
	      }
	    };
	
	    _this.getInputField = function (fieldName, poDefs) {
	      return (0, _getInputField2.default)(fieldName, "projectPos", _this.state.data, _this.stateChangeHandler, false, poDefs, _this.props.db, _reactDeviceDetect.isMobile);
	    };
	
	    _this.getPOPaymentFields = function () {
	      var poDefs = (0, _extendedOgDef2.default)(_this.props.createTable);
	      if (poDefs && poDefs !== undefined && poDefs.projectPos) {
	        //console.log("~~~");
	        //console.log(JSON.stringify(poDefs.projectPos.paymentType));
	        //console.log("~~~: " + JSON.stringify(poDefs.projectPos.paymentType));
	        return _react2.default.createElement("div", null, _this.getInputField("paymentType", poDefs), _this.getInputField("supplierInvoice", poDefs), _this.getInputField("referenceNumber", poDefs), _this.getInputField("paymentDate", poDefs));
	      }
	    };
	
	    _this.getPoPaymentModal = function () {
	      return (
	        //<!-- Modal -->
	        _react2.default.createElement("div", { className: "modal fade", id: "myModal", role: "dialog" }, _react2.default.createElement("div", { className: "modal-dialog" }, _react2.default.createElement("div", { className: "modal-content" }, _react2.default.createElement("div", { className: "modal-header" }, _react2.default.createElement("button", { type: "button", "class": "close", "data-dismiss": "modal" }, "\xD7"), _react2.default.createElement("h4", { className: "modal-title" }, "BULK UPDATE FOR PURCHASE ORDERS")), _react2.default.createElement("div", { className: "modal-body" }, _react2.default.createElement("div", {
	          style: {
	            padding: "20px",
	            backgroundColor: "red",
	            color: "white",
	            fontWeight: "600",
	            marginBottom: "15px"
	          }
	        }, "Please perform this action with utmost care. Once in progress, the upload process cannot be stopped midway.", _react2.default.createElement("p", {
	          style: {
	            fontWeight: "bolder"
	          }
	        }, _this.getSelectedPoCount(), " POs selected for update")), _react2.default.createElement("p", null, "Please fill in following fields and click update"), _react2.default.createElement("div", null, _this.state.tableName === "projectPos" && _this.getPOPaymentFields())), _react2.default.createElement("div", { className: "modal-footer" }, _react2.default.createElement("button", {
	          type: "button",
	          "class": "btn btn-default",
	          onClick: function onClick() {
	            _this.runUpload();
	          }
	        }, "Update"), _react2.default.createElement("button", {
	          type: "button",
	          "class": "btn btn-default",
	          "data-dismiss": "modal"
	        }, "Cancel")))))
	      );
	    };
	
	    _this.runUpload = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	      var allPosFull, allPos, i, currPo;
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              if (!(Object.keys(_this.state.searchFilters).length === 0 && Object.keys(_this.state.searchDateFilters).length === 0 && _this.state.searchVal === "")) {
	                _context.next = 4;
	                break;
	              }
	
	              alert("Please apply some filter criteria before running payment updates");
	              _context.next = 28;
	              break;
	
	            case 4:
	              allPosFull = _this.getData();
	              allPos = _.cloneDeep(allPosFull);
	              i = 0;
	
	            case 7:
	              if (!(i < allPos.length)) {
	                _context.next = 27;
	                break;
	              }
	
	              _context.prev = 8;
	              currPo = allPos[i];
	
	              currPo["paymentType"] = _this.state.data.payload.paymentType;
	              currPo["supplierInvoice"] = _this.state.data.payload.supplierInvoice;
	              currPo["referenceNumber"] = _this.state.data.payload.referenceNumber;
	              currPo["paymentDate"] = _this.state.data.payload.paymentDate;
	              if (currPo.paymentDate === "") {
	                currPo.paymentDate = (0, _moment2.default)().format("DD-MM-YYYY").toString();
	              }
	
	              _context.next = 17;
	              return _this.dataUpdateHandler(currPo, "projectPos/" + currPo.key + "/", "poId");
	
	            case 17:
	              _context.next = 19;
	              return _this.sleep(1000);
	
	            case 19:
	              _context.next = 24;
	              break;
	
	            case 21:
	              _context.prev = 21;
	              _context.t0 = _context["catch"](8);
	
	              console.log("some error: " + _context.t0);
	
	            case 24:
	              i++;
	              _context.next = 7;
	              break;
	
	            case 27:
	              alert("Upload completed");
	
	            case 28:
	            case "end":
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2, [[8, 21]]);
	    }));
	
	    _this.getTotCount = function () {
	      var totOrders = 0;
	
	      if (_this.props.db && _this.props.db["deliveryRequest"]) {
	        totOrders = _this.props.db["deliveryRequest"].length;
	      }
	
	      return totOrders;
	    };
	
	    _this.getTotOutCount = function () {
	      var totOrders = [];
	
	      if (_this.props.db && _this.props.db["deliveryRequest"]) {
	        totOrders = _this.props.db["deliveryRequest"].filter(function (item) {
	          return item.status !== "DELIVERED";
	        });
	      }
	
	      return totOrders.length;
	    };
	
	    _this.getCountByStatus = function () {
	      var procOrders = _.chain(_this.props.db["deliveryRequest"]).groupBy("status").value();
	      return Object.keys(procOrders).map(function (key) {
	        return _react2.default.createElement("div", {
	          style: {
	            padding: "2px",
	            border: "1px solid gainsboro"
	          }
	        }, key !== "undefined" ? key : "Blank Status", ": ", procOrders[key].length);
	      });
	    };
	
	    _this.getCountByStatus = function () {
	      var procOrders = _.chain(_this.props.db["deliveryRequest"]).groupBy("status").value();
	      return Object.keys(procOrders).map(function (key) {
	        return _react2.default.createElement("div", {
	          style: {
	            padding: "2px",
	            border: "1px solid gainsboro"
	          }
	        }, key !== "undefined" ? key : "Blank Status", ": ", procOrders[key].length);
	      });
	    };
	
	    _this.getCountByOrdDate = function () {
	      var procOrders = _.chain(_this.props.db["deliveryRequest"]).filter(function (item) {
	        return item.status !== "DELIVERED";
	      }).map(function (item) {
	        return _extends({}, item, {
	          momDate: (0, _moment2.default)(item.deliveryDate, "DD-MM-YYYY")
	        });
	      }).sortBy("momDate").reverse().groupBy("deliveryDate").value();
	      return Object.keys(procOrders).map(function (key) {
	        return _react2.default.createElement("div", {
	          style: {
	            padding: "2px",
	            border: "1px solid gainsboro"
	          }
	        }, "Order Date ", key, ": ", procOrders[key].length);
	      });
	    };
	
	    _this.getCountByMobile = function () {
	      var procOrders = _.chain(_this.props.db["deliveryRequest"]).map(function (item) {
	        return _extends({}, item, {
	          momDate: (0, _moment2.default)(item.deliveryDate, "DD-MM-YYYY")
	        });
	      }).sortBy("momDate").groupBy("mobile").map(function (item) {
	        return item;
	      }).reduce(function (sum, curr, index) {
	        sum = sum + 1;
	        return sum;
	      }, 0).value();
	
	      return _react2.default.createElement("div", {
	        style: {
	          padding: "2px",
	          border: "1px solid gainsboro"
	        }
	      }, "Total Unique Clients: ", procOrders);
	    };
	
	    _this.getSortingButton = function () {
	      return _react2.default.createElement("div", {
	        style: {
	          textAlign: "center",
	          paddingTop: "-30px",
	          paddingBottom: "10px"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          margin: "10px",
	          marginTop: "0px"
	        }
	      }, _react2.default.createElement(_reactackle.Button, {
	        colorScheme: "flat",
	        onPress: function onPress() {
	          //this.props.onSetUiFlag("dataUploadButton", true);
	          //this.perfDelayUpdates();
	          _this.stateChangeHandler(!_this.state.sortByLatest, "sortByLatest", false);
	        },
	        text: _this.state.sortByLatest ? "Sort by Oldest" : "Sort by Latest",
	        disabled: false
	      }), _react2.default.createElement(_reactackle.Button, {
	        colorScheme: "flat",
	        onPress: function onPress() {
	          //this.props.onSetUiFlag("dataUploadButton", true);
	          //this.perfDelayUpdates();
	
	          _this.setState(function (prevState) {
	            return _extends({}, prevState, {
	              formDefs: (0, _extendedOgDef2.default)(_this.props.createTable),
	              tableDefs: (0, _getDefs2.default)(_this.props.createTable)
	            });
	          });
	
	          var allMenus = {};
	          var allMenusFromDb = _this.props.menuDesigner;
	          if (allMenusFromDb && allMenusFromDb.length > 0) {
	            var userMenu = allMenusFromDb.find(function (singMenu) {
	              return singMenu.name === "SUPERADMIN";
	            });
	            if (userMenu) {
	              allMenus = userMenu.menuItems.map(function (singleMenu) {
	                var srcTable = _this.props.listOfTables.find(function (item) {
	                  return item.name === singleMenu.tableName;
	                });
	                if (srcTable && srcTable !== undefined && srcTable.name) {
	                  return _extends({}, singleMenu, {
	                    menuCaption: srcTable.menu
	                  });
	                }
	              });
	              _this.props.onSetUiFlag("userMenus", allMenus);
	            }
	          } else {
	            console.log("menus not received in time");
	          }
	          var allTableDets = allMenus;
	          if (allTableDets && allTableDets.length > 0) {
	            for (var k = 0; k < allTableDets.length; k++) {
	              _this.loadDataEx(allTableDets[k]);
	            }
	          } else {
	            console.log("tables not linked");
	          }
	        },
	        text: "Reload Data",
	        disabled: false,
	        style: {
	          margin: "10px"
	        }
	      })));
	    };
	
	    _this.getLogin = function () {
	      return _react2.default.createElement("div", { className: "wrap" }, _react2.default.createElement("center", null, _react2.default.createElement("h1", { style: { marginBottom: "-20px" } }, "BCS"), _react2.default.createElement("h2", null, "Welcome to BCS"), _react2.default.createElement("div", {
	        style: {
	          minHeight: "30px"
	        }
	      }), _react2.default.createElement("div", {
	        style: {
	          minHeight: "30px"
	        }
	      })), _react2.default.createElement("div", null, _react2.default.createElement("form", { onSubmit: _this.loginHandler }, window.location.hostname === _this.state.localhost && _react2.default.createElement("div", { className: "form-group" }, _react2.default.createElement("label", null, "Email address:"), _react2.default.createElement("input", {
	        type: "email",
	        className: "form-control",
	        id: "email",
	        ref: "email",
	        value: _rawState.localState.login
	        //value="test@test.com"
	        , disabled: _this.state.loginProgress
	      })), window.location.hostname !== _this.state.localhost && _react2.default.createElement("div", { className: "form-group" }, _react2.default.createElement("label", null, "Email address:"), _react2.default.createElement("input", {
	        type: "email",
	        className: "form-control",
	        id: "email",
	        ref: "email",
	        disabled: _this.state.loginProgress
	        //value={this.state.email}
	      })), window.location.hostname === _this.state.localhost && _react2.default.createElement("div", { className: "form-group" }, _react2.default.createElement("label", null, "Password:"), _react2.default.createElement("input", {
	        type: "password",
	        className: "form-control",
	        id: "password",
	        secure: true,
	        ref: "password",
	        value: _rawState.localState.password,
	        disabled: _this.state.loginProgress
	      })), window.location.hostname !== _this.state.localhost && _react2.default.createElement("div", { className: "form-group" }, _react2.default.createElement("label", null, "Password:"), _react2.default.createElement("input", {
	        type: "password",
	        className: "form-control",
	        id: "password",
	        secure: true,
	        ref: "password",
	        disabled: _this.state.loginProgress
	        //value={this.state.password}
	      })), _this.getError(), _this.getLoader())));
	    };
	
	    _this.loginHandler = function (event) {
	      console.log("doing login..." + _this.refs.email.value + "..." + _this.refs.password.value);
	      event.preventDefault();
	
	      _this.setState(function (prevState) {
	        return _extends({}, prevState, {
	          loginProgress: true
	        });
	      });
	
	      _this.setState(function (prevState) {
	        return _extends({}, prevState, {
	          formDefs: (0, _extendedOgDef2.default)(_this.props.createTable),
	          tableDefs: (0, _getDefs2.default)(_this.props.createTable)
	        });
	      });
	
	      var allMenus = {};
	      var allMenusFromDb = _this.props.menuDesigner;
	      if (allMenusFromDb && allMenusFromDb.length > 0) {
	        var userMenu = allMenusFromDb.find(function (singMenu) {
	          return singMenu.name === "SUPERADMIN";
	        });
	        if (userMenu) {
	          allMenus = userMenu.menuItems.map(function (singleMenu) {
	            var srcTable = _this.props.listOfTables.find(function (item) {
	              return item.name === singleMenu.tableName;
	            });
	            if (srcTable && srcTable !== undefined && srcTable.name) {
	              return _extends({}, singleMenu, {
	                menuCaption: srcTable.menu
	              });
	            }
	          });
	          _this.props.onSetUiFlag("userMenus", allMenus);
	        }
	      } else {
	        console.log("menus not received in time");
	      }
	      var allTableDets = allMenus;
	      if (allTableDets && allTableDets.length > 0) {
	        for (var k = 0; k < allTableDets.length; k++) {
	          _this.loadDataEx(allTableDets[k]);
	        }
	      } else {
	        console.log("tables not linked");
	      }
	
	      _this.props.firebase.auth.signInWithEmailAndPassword(_this.refs.email.value, _this.refs.password.value).then(function (userRes) {
	        _this.storeAutoLoginToApp();
	        //console.log("stringify and parse done/skipped");
	        console.log("auth done");
	        var res = userRes;
	
	        _this.props.onSetUiFlag("showSpinner", false);
	        //console.log("ui flag switched off");
	
	        _this.props.onSetUiFlag("userUid", res.uid);
	        //console.log("set ui flag user id");
	        _this.props.onSetUiFlag("userEmail", res.email);
	        //console.log("email updated");
	
	        //console.log("inside load data: " + this.refs.email.value);
	        var currEmail = _this.refs.email.value;
	        _this.props.firebase.db.ref("/users").on("value", function (snapshot) {
	          ////console.log("Linking " + tableName);
	          var tmpArray = [];
	          var fbOject = [];
	          Promise.all([snapshot.val()]).then(function (res) {
	            fbOject = res[0];
	            //console.log("now recieved the response for teams loading");
	            tmpArray = Object.keys(fbOject).map(function (key) {
	              return _extends({}, fbOject[key], {
	                key: key
	              });
	            });
	            tmpArray.reverse();
	            //console.log("array reversed");
	            ////console.log("Total Records: " + tmpArray.length);
	            _this.props.onAddArray({
	              path: "users",
	              payload: tmpArray
	            });
	
	            var currentUser = {};
	
	            //
	
	            currentUser = tmpArray.find(function (userObj) {
	              if (userObj.userEmail === currEmail) {
	                return userObj;
	              }
	            });
	
	            //console.log("admin status: " + JSON.stringify(currentUser));
	
	            _this.props.addRecord({
	              path: "userProfile",
	              payload: currentUser
	            });
	
	            if (currentUser !== undefined) {
	              ////console.log("~!@~!@ " + JSON.stringify(currentUser));
	              var isThisAdmin = currentUser.roleName === "ADMIN" || currentUser.roleName === "SUPERADMIN";
	              var isThisSuperAdmin = currentUser.roleName === "SUPERADMIN";
	              _this.props.onSetUiFlag("currUserRole", currentUser.roleName);
	              _this.props.onSetUiFlag("isThisAdmin", isThisAdmin);
	              _this.props.onSetUiFlag("isThisSuperAdmin", isThisSuperAdmin);
	
	              var _allMenus = {};
	              var _allMenusFromDb = _this.props.menuDesigner;
	              if (_allMenusFromDb && _allMenusFromDb.length > 0) {
	                var _userMenu = _allMenusFromDb.find(function (singMenu) {
	                  return singMenu.name === currentUser.roleName;
	                });
	                if (_userMenu) {
	                  _allMenus = _userMenu.menuItems.map(function (singleMenu) {
	                    var srcTable = _this.props.listOfTables.find(function (item) {
	                      return item.name === singleMenu.tableName;
	                    });
	                    if (srcTable && srcTable !== undefined && srcTable.name) {
	                      return _extends({}, singleMenu, {
	                        menuCaption: srcTable.menu
	                      });
	                    }
	                  });
	                  _this.props.onSetUiFlag("userMenus", _allMenus);
	                }
	              }
	
	              _this.props.addRecord({
	                path: "currentUser",
	                payload: currentUser
	              });
	
	              _this.props.addRecord({
	                path: "team",
	                payload: {
	                  name: "BROOKLYNZ",
	                  fbCloudUrl: "",
	                  fbDbUrl: ""
	                }
	              });
	              _this.stateChangeHandler("landingpage", "stage", false);
	              console.log("all done");
	              console.log("adding scroll listner");
	              window.document.querySelector(".content").addEventListener("scroll", _this.handleScroll, false);
	            }
	          });
	        });
	      }).catch(function (error) {
	        _this.setState(function (prevState) {
	          return _extends({}, prevState, {
	            message: error.message,
	            loginProgress: false
	          });
	        });
	        console.log("some error");
	        console.log(error);
	      });
	    };
	
	    _this.getMainContent = function () {
	      return _react2.default.createElement(_reactackle.MainRegion, null, _react2.default.createElement(_reactackle.Content, null, _react2.default.createElement(_reactackle.Container, null, _this.state.showGrid && _this.state.showFilters && _this.getTopHeader(), _react2.default.createElement("div", {
	        style: {
	          overflow: "auto",
	          WebkitOverflowScrolling: "touch",
	          scrollBehavior: "smooth",
	          marginTop: "40px"
	        }
	      }, _this.state.showGrid && _this.state.tableName === "deliveryRequest" && _this.getSortingButton(), _this.getGrid(), _this.state.showDash && _this.getDashView()), !_this.state.showGrid && !_this.state.showDash && _react2.default.createElement("div", {
	        style: {
	          marginTop: _reactDeviceDetect.isMobile ? "20px" : "0px"
	        }
	      }, (0, _getEditView2.default)(_this.state.tableName, _this.handleEditCancel, _this.handleDelete, _this.props.create, _this.genNotification))), _react2.default.createElement("div", {
	        style: {
	          minHeight: "500px"
	        }
	      })));
	    };
	
	    _this.sleep = function () {
	      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(milliseconds) {
	        var date, currentDate;
	        return regeneratorRuntime.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                date = Date.now();
	                currentDate = null;
	
	                do {
	                  currentDate = Date.now();
	                } while (currentDate - date < milliseconds);
	
	              case 3:
	              case "end":
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }));
	
	      return function (_x) {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	
	    _this.dataUpdateHandler = function () {
	      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(databucket, cloudPath, idField) {
	        return regeneratorRuntime.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                if (databucket && databucket.key && databucket.key !== "") {
	                  _this.props.firebase.db.ref("/" + cloudPath + "/" + databucket.key + "/").once("value").then(function (snap) {
	                    return snap.ref.set(databucket);
	                  }).catch(function (err) {
	                    console.log("some error: " + err);
	                  }).then(function (err) {
	                    //console.log("Updated Rec: " + databucket[idField]);
	                  });
	                }
	
	              //this.props.handleEditCancel();
	
	              case 1:
	              case "end":
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this2);
	      }));
	
	      return function (_x2, _x3, _x4) {
	        return _ref3.apply(this, arguments);
	      };
	    }();
	
	    _this.dataAddHandler = function () {
	      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(databucket, cloudPath, idField) {
	        var newInv, dbKey;
	        return regeneratorRuntime.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                if (databucket && databucket !== undefined) {
	                  newInv = _this.props.firebase.db.ref("/" + cloudPath).push();
	                  dbKey = newInv.key;
	
	                  newInv.set(databucket).catch(function (err) {
	                    console.log("some error: " + err);
	                  }).then(function (err) {});
	                }
	
	              //this.props.handleEditCancel();
	
	              case 1:
	              case "end":
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this2);
	      }));
	
	      return function (_x5, _x6, _x7) {
	        return _ref4.apply(this, arguments);
	      };
	    }();
	
	    _this.perfDelayUpdates = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
	      return regeneratorRuntime.wrap(function _callee5$(_context5) {
	        while (1) {
	          switch (_context5.prev = _context5.next) {
	            case 0:
	            case "end":
	              return _context5.stop();
	          }
	        }
	      }, _callee5, _this2);
	    }));
	
	    _this.getDataUpdating = function () {
	      //console.log("returing somethiung");
	      return _react2.default.createElement("div", {
	        style: {
	          backgroundColor: "black",
	          height: "400px"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          color: "white"
	        }
	      }, "Please do not click on this button", _react2.default.createElement("div", null, _react2.default.createElement(_reactackle.Button, {
	        colorScheme: "primary",
	        onPress: function onPress() {
	          //this.props.onSetUiFlag("dataUploadButton", true);
	          //this.perfDelayUpdates();
	          _this.props.onGetAcctBalance({
	            accIdArray: [{ accName: "COMPANY CASH ACCOUNT" }],
	            fromDate: "01-01-2020",
	            endDate: "31-03-2020"
	          }).then(function (resp) {
	            console.log(JSON.stringify(resp));
	          });
	        },
	        text: "Update Action",
	        disabled: _this.props.uploadButton
	      }))));
	    };
	
	    _this.getError = function () {
	      if (_this.state.message !== "" && _this.state.message !== undefined) {
	        return _react2.default.createElement("div", null, _this.state.message);
	      }
	    };
	
	    _this.getLoader = function () {
	      if (_this.state.loginProgress) {
	        return _react2.default.createElement("div", {
	          style: {
	            textAlign: "center"
	          }
	        }, _react2.default.createElement(_reactackle.CircleProgress, {
	          indeterminate: true,
	          subtitle: "Connecting...",
	          circleSize: 40,
	          strokeSize: 5,
	          labelPositionY: "bottom",
	          labelPositionX: "center"
	        }));
	      } else {
	        return _react2.default.createElement("button", {
	          type: "submit",
	          className: "btn btn-block btn-primary",
	          disabled: _this.state.loginProgress
	        }, "Submit");
	      }
	    };
	
	    _this.getLandingPage = function () {
	      return _react2.default.createElement("div", {
	        style: {
	          minHeight: "50000px",
	          marginTop: _reactDeviceDetect.isMobile ? "-20px" : "120px"
	        }
	      }, _react2.default.createElement("div", { id: "cntntDiv" }, _this.getMainContent()));
	    };
	
	    _this.state = {
	      data: {
	        path: "",
	        payload: {
	          paymentType: "",
	          supplierInvoice: "",
	          referenceNumber: "",
	          paymentDate: ""
	        }
	      },
	      message: "",
	      hasLoaded: false,
	      tableName: "deliveryRequest",
	      tableDefs: (0, _getDefs2.default)(_this.props.createTable),
	      searchVal: "",
	      showGrid: true,
	      showDash: false,
	      searchFilters: {},
	      searchDateFilters: {},
	      showFilters: true,
	      showPivot: false,
	      reRenderFlag: false,
	      formDefs: (0, _extendedOgDef2.default)(_this.props.createTable),
	      sortByLatest: true,
	      stage: "landingpage",
	      notInitialized: true,
	      localhost: _rawState.localState.hostname
	    };
	    _this.getDataDebounced = (0, _throttleDebounce.debounce)(1000, _this.doStateUpdateForSearch);
	    _this.getDataThrottled = (0, _throttleDebounce.throttle)(1000, _this.doStateUpdateForSearch);
	    return _this;
	  }
	
	  _createClass(DirectAdmin, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this3 = this;
	
	      //cntnDiv
	      if (this.props.email && this.props.email !== "") {
	        document.getElementById("email").value = this.props.email;
	      }
	
	      if (this.props.password && this.props.password !== "") {
	        document.getElementById("password").value = this.props.password;
	      }
	      this.setState(function (prevState) {
	        return _extends({}, prevState, {
	          showFilters: !_reactDeviceDetect.isMobile,
	          sortByLatest: true,
	          email: _this3.props.email && _this3.props.email !== "" ? _this3.props.email : "",
	          password: _this3.props.password && _this3.props.password !== undefined ? _this3.props.password : ""
	        });
	      });
	      window.document.querySelector(".content").addEventListener("scroll", this.handleScroll, false);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      console.log("detaching scroll listner");
	      window.removeEventListener("scroll", this.handleScroll);
	    }
	
	    //single method that work for all fields
	    //takes incoming id of the field and then adds field data to state
	
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement("div", null, this.getLandingPage());
	    }
	  }]);
	
	  return DirectAdmin;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    userProfile: state.db.userProfile,
	    userMenus: state.ui.userMenus,
	    users: state.db.users,
	    projects: state.db.projects,
	    attendance: state.db.attendance,
	    contacts: state.db.contacts,
	    logistics: state.db.logistics,
	    notices: state.db.notices,
	    projectInvoices: state.db.projectInvoices,
	    deletedprojectInvoices: state.db.deletedprojectInvoices,
	    projectClaims: state.db.projectClaims,
	    projectDos: state.db.projectDos,
	    projectPos: state.db.projectPos,
	    projectQuotes: state.db.projectQuotes,
	    reports: state.db.reports,
	    suppliers: state.db.suppliers,
	    tasks: state.db.tasks,
	    currentUser: state.db.userProfile,
	    isAdmin: state.ui.isThisAdmin,
	    isSuperAdmin: state.ui.isThisSuperAdmin,
	    userUid: state.ui.userUid,
	    currUserRole: state.ui.currUserRole,
	    createFields: state.db.createFields,
	    createTable: state.db.createTable,
	    testTable: state.db.testTable,
	    listOfTables: state.db.listOfTables,
	    menuDesigner: state.db.menuDesigner,
	    uploadButton: state.ui.dataUploadButton && state.ui.dataUploadButton !== undefined ? state.ui.dataUploadButton : false,
	    db: state.db,
	    listYPos: state.ui.listYPos
	  };
	}
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    onAddRecord: function onAddRecord(data) {
	      return dispatch((0, _actions.actionAddArray2Redux)(data));
	    },
	    addRecord: function addRecord(data) {
	      return dispatch((0, _actions.actionAddSingleRecord)(data));
	    },
	    onAddArray: function onAddArray(data) {
	      return dispatch((0, _actions.actionAddArray2Redux)(data));
	    },
	    onSelectRecord: function onSelectRecord(params) {
	      dispatch((0, _actions.selectARecord)(params));
	      dispatch((0, _actions.setUiFlag)("tableName", params.path));
	    },
	    onAddNew: function onAddNew(data) {
	      return dispatch((0, _actions.initSelectedRecord)(data));
	    },
	    loadStats: function loadStats(parsedRes) {
	      return dispatch((0, _actions.loadAllStats)(parsedRes));
	    },
	    onSetUiFlag: function onSetUiFlag(flagName, flagVal) {
	      return dispatch((0, _actions.setUiFlag)(flagName, flagVal));
	    },
	    onSignOut: function onSignOut() {
	      dispatch((0, _actions.resetRedux)());
	      dispatch((0, _actions.setUiFlag)("userMenus", []));
	    },
	    loadFbData: function loadFbData(tableName, firebase) {
	      return dispatch((0, _actions.loadFbData)(tableName, firebase));
	    },
	    onNotifyUsers: function onNotifyUsers(msgBody, arrayOfUsers) {
	      return dispatch((0, _actions.notifyUsers)(msgBody, arrayOfUsers));
	    },
	    onGetId: function onGetId(data) {
	      return dispatch((0, _actions.getId)(data));
	    },
	    onGetAcctStatement: function onGetAcctStatement(data) {
	      return dispatch((0, _actions.getAcctStatement)(data));
	    },
	    onGetAcctBalance: function onGetAcctBalance(data) {
	      return dispatch((0, _actions.getAcctBalance)(data));
	    },
	    onDeletePhoto: function onDeletePhoto(firebase, photoName, photoPath, dbKey, cloudPath) {
	      return dispatch((0, _actions.deletePhoto)(firebase, photoName, photoPath, dbKey, cloudPath));
	    }
	  };
	};
	
	exports.default = (0, _recompose.compose)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _Firebase.withFirebase)(DirectAdmin);

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var terms = function terms() {
	  return _react2.default.createElement("div", null, _react2.default.createElement("div", {
	    style: {
	      marginTop: "25px"
	    }
	  }, _react2.default.createElement("div", {
	    style: {
	      fontSize: "15px",
	      color: "grey",
	      marginTop: "15px"
	    }
	  }), _react2.default.createElement("div", { style: { margin: "5px" } }, _react2.default.createElement("lu", null, _react2.default.createElement("li", {
	    style: {
	      display: "block",
	      backgroundColor: "white",
	      margin: "2px",
	      padding: "5px"
	    }
	  }, "This is an online delivery service."), _react2.default.createElement("li", {
	    style: {
	      display: "block",
	      backgroundColor: "white",
	      margin: "2px",
	      padding: "5px"
	    }
	  }, "We strive our best to deliver as soon as possible, within next day. However we are getting overwhelmed by volume of orders received and our suppliers also require time for packaging."), _react2.default.createElement("li", {
	    style: {
	      display: "block",
	      backgroundColor: "white",
	      margin: "2px",
	      padding: "5px"
	    }
	  }, "For same day delivery (with nominal additional charge) please contact us at +65 94562455")))));
	};
	
	exports.default = terms;

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var getLi = function getLi() {
	  return termsArray.map(function (text) {
	    return _react2.default.createElement("li", {
	      style: {
	        display: "block",
	        backgroundColor: "white",
	        margin: "0px",
	        marginBottom: "10px",
	        padding: "10px"
	      }
	    }, text);
	  });
	};
	
	var termsArray = ["This is an online delivery service", "We are not charging any commission and the price you pay goes direct to supplier", "We strive our best to deliver as soon as possible, within 2/3 days, however we are getting overwhelmed by orders and our suppliers also require time for packaging", "For any urgent requests or follow-up please contact Kabir Hossain(Cell: 94562455)", "Please ensure to comply with all prevailing laws and safety precautions requirements that are relevant for circuit breaker.", "Please refer to https://www.moh.gov.sg/covid-19 for updates on current situation as well as latest updates.", "In these times, it is the responsibility of every individual to comply with social distancing, quarantine or circuit breaker rules. Though we strive our best to provide enough understanding of required rules/laws to our suppliers/drivers, it is as such, an individual's own responsibility to ensure compliance at all times.", "Please use the special instructions box provided in the order to inform upfront if you are currently in quarantine or if you tested positive or if you were in close contact with any one who tested positive. Please also inform the supplier of this when you are contacted back so that a contact less delivery is arranged while complying with any other required rules.", "This service is currently actively available in Singapore"];
	
	var termsMainPage = function termsMainPage() {
	  return _react2.default.createElement("div", null, _react2.default.createElement("div", null, _react2.default.createElement("h2", {
	    style: {
	      marginTop: "5px",
	      fontSize: "22px",
	      fontWeight: "bold",
	      textTransform: "uppercase",
	      textAlign: "center"
	    }
	  }, "TERMS AND CONDITIONS"), _react2.default.createElement("div", {
	    style: {
	      fontSize: "15px",
	      color: "grey",
	      marginTop: "15px"
	    }
	  }), _react2.default.createElement("div", { style: { margin: "5px" } }, _react2.default.createElement("lu", null, getLi()))));
	};
	
	exports.default = termsMainPage;

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extendedOgDef = __webpack_require__(26);
	
	var _extendedOgDef2 = _interopRequireDefault(_extendedOgDef);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var getTableFields = function getTableFields(createTableList, tableName) {
	  // console.log("~ recvd: tableList: " + JSON.stringify(tableList));
	  //console.log("~~ " + JSON.stringify(ogTableDef));
	
	  var ogTableDef = (0, _extendedOgDef2.default)(createTableList);
	  var tgtTable = ogTableDef[tableName];
	  if (tgtTable && tgtTable !== undefined && tgtTable !== null) {
	    var finalArray = Object.keys(tgtTable).map(function (key) {
	      return {
	        name: tgtTable[key].caption,
	        fieldName: key
	      };
	    });
	
	    //console.log(JSON.stringify(finalArray));
	    return finalArray;
	  } else {
	    return [];
	  }
	};
	
	exports.default = getTableFields;

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _redux = __webpack_require__(136);
	
	var _actions = __webpack_require__(13);
	
	var _Firebase = __webpack_require__(10);
	
	var _recompose = __webpack_require__(11);
	
	var _reactackle = __webpack_require__(5);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var App2 = function (_Component) {
	  _inherits(App2, _Component);
	
	  function App2(props) {
	    _classCallCheck(this, App2);
	
	    var _this = _possibleConstructorReturn(this, (App2.__proto__ || Object.getPrototypeOf(App2)).call(this, props));
	
	    console.log("running app jsx constructor");
	    //this.props.fetchUser();
	    return _this;
	  }
	
	  _createClass(App2, [{
	    key: "_logOut",
	    value: function _logOut() {
	      var _this2 = this;
	
	      this.props.logoutUser().then(function (data) {
	        // reload props from reducer
	        _this2.props.fetchUser();
	      });
	    }
	  }, {
	    key: "onComponentDidMount",
	    value: function onComponentDidMount() {
	      (0, _reactackle.injectGlobalStyle)();
	      (0, _reactackle.injectResetStyle)();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(_reactackle.App, { fixed: true }, this.props.children);
	    }
	  }]);
	
	  return App2;
	}(_react.Component);
	
	function mapDispatchToProps(dispatch) {
	  return (0, _redux.bindActionCreators)({ fetchUser: _actions.fetchUser, logoutUser: _actions.logoutUser }, dispatch);
	}
	
	function mapStateToProps(state) {
	  return { currentUser: state.db.userProfile };
	}
	
	exports.default = (0, _recompose.compose)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _Firebase.withFirebase)(App2);

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getISOLocalDateTime = exports.getHoursMinutesSeconds = exports.getISOLocalDate = exports.convert24to12 = exports.convert12to24 = exports.getHoursMinutes = exports.getSeconds = exports.getMinutes = exports.getHours = exports.getDay = exports.getMonth = exports.getYear = undefined;
	
	var _dates = __webpack_require__(15);
	
	Object.defineProperty(exports, 'getYear', {
	  enumerable: true,
	  get: function get() {
	    return _dates.getYear;
	  }
	});
	Object.defineProperty(exports, 'getMonth', {
	  enumerable: true,
	  get: function get() {
	    return _dates.getMonth;
	  }
	});
	Object.defineProperty(exports, 'getDay', {
	  enumerable: true,
	  get: function get() {
	    return _dates.getDay;
	  }
	});
	
	var _dates2 = __webpack_require__(120);
	
	Object.defineProperty(exports, 'getHours', {
	  enumerable: true,
	  get: function get() {
	    return _dates2.getHours;
	  }
	});
	Object.defineProperty(exports, 'getMinutes', {
	  enumerable: true,
	  get: function get() {
	    return _dates2.getMinutes;
	  }
	});
	Object.defineProperty(exports, 'getSeconds', {
	  enumerable: true,
	  get: function get() {
	    return _dates2.getSeconds;
	  }
	});
	
	var _dates3 = __webpack_require__(48);
	
	Object.defineProperty(exports, 'getHoursMinutes', {
	  enumerable: true,
	  get: function get() {
	    return _dates3.getHoursMinutes;
	  }
	});
	Object.defineProperty(exports, 'convert12to24', {
	  enumerable: true,
	  get: function get() {
	    return _dates3.convert12to24;
	  }
	});
	Object.defineProperty(exports, 'convert24to12', {
	  enumerable: true,
	  get: function get() {
	    return _dates3.convert24to12;
	  }
	});
	exports.getISOLocalDate = _dates.getISOLocalDate;
	exports.getHoursMinutesSeconds = _dates3.getHoursMinutesSeconds;
	
	// eslint-disable-next-line import/prefer-default-export
	
	var getISOLocalDateTime = exports.getISOLocalDateTime = function getISOLocalDateTime(value) {
	  if (!value) {
	    return value;
	  }
	
	  var date = new Date(value);
	
	  if (isNaN(date.getTime())) {
	    throw new Error('Invalid date: ' + value);
	  }
	
	  return (0, _dates.getISOLocalDate)(date) + 'T' + (0, _dates3.getHoursMinutesSeconds)(date);
	};

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(63);
	
	Object.defineProperty(exports, 'between', {
	  enumerable: true,
	  get: function get() {
	    return _utils.between;
	  }
	});
	Object.defineProperty(exports, 'callIfDefined', {
	  enumerable: true,
	  get: function get() {
	    return _utils.callIfDefined;
	  }
	});
	Object.defineProperty(exports, 'min', {
	  enumerable: true,
	  get: function get() {
	    return _utils.min;
	  }
	});
	Object.defineProperty(exports, 'max', {
	  enumerable: true,
	  get: function get() {
	    return _utils.max;
	  }
	});
	Object.defineProperty(exports, 'updateInputWidth', {
	  enumerable: true,
	  get: function get() {
	    return _utils.updateInputWidth;
	  }
	});
	
	var _utils2 = __webpack_require__(50);
	
	Object.defineProperty(exports, 'getAmPmLabels', {
	  enumerable: true,
	  get: function get() {
	    return _utils2.getAmPmLabels;
	  }
	});

/***/ }),
/* 159 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var tSupplierShopItems = exports.tSupplierShopItems = [{
	  availability: "AVAILABLE",
	  category: "DRINKS DESSERT",
	  photos: [{
	    imageName: "9d552330-2a43-11eb-97e8-9befc076c3e3.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F9d552330-2a43-11eb-97e8-9befc076c3e3.jpg?alt=media&token=73082170-4d97-4773-b699-97a11f23f03c"
	  }],
	  productDescription: "Milk Tea Sticks",
	  productNameEnglish: "Milk Tea Sticks",
	  productPrice: "4.95",
	  productSupplier: "BCS SHOP",
	  searchText: "milk tea",
	  sortOrder: "G",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "Bag(25 Sticks)",
	  updateDateTime: "Thu 19-11-20 7:46 pm",
	  key: "-MMUfeXIb0tl1MtLtJGE"
	}, {
	  availability: "AVAILABLE",
	  category: "SNACKS DRY FOOD",
	  key: "-MMUcA_ECvMzzCGqXyd6",
	  photos: [{
	    imageName: "8068ba40-2a41-11eb-bc77-4b3aa6852856.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F8068ba40-2a41-11eb-bc77-4b3aa6852856.jpg?alt=media&token=e0c10147-5cad-43d6-a818-0fe5a78abc05"
	  }],
	  productDescription: "Peanut Biscuit",
	  productNameEnglish: "Pran Cookies Peanut Biscuit",
	  productPrice: "3.5",
	  productSupplier: "BCS SHOP",
	  searchText: "cookies peanut biscuit",
	  sortOrder: "G",
	  supplierContactName: "Kabir",
	  supplierContactPhone: "94562455",
	  unit: "Bottle",
	  updateDateTime: "Fri 27-11-20 11:30 am"
	}, {
	  availability: "AVAILABLE",
	  category: "OTHERS",
	  photos: [{
	    imageName: "7171a1a0-0200-11eb-a8a9-31b609c2f968.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F7171a1a0-0200-11eb-a8a9-31b609c2f968.jpg?alt=media&token=ca50bf2e-b0f7-4dca-a51a-54b63e0437c8"
	  }],
	  productNameEnglish: "Socks",
	  productPrice: "2",
	  productSupplier: "BCS SHOP",
	  searchText: "মুজা",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "3 pcs",
	  updateDateTime: "Tue 29-09-20 11:04 am",
	  key: "-MIMoLyFOfruboBr4c6b"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  photos: [{
	    imageName: "2a89fc70-01fa-11eb-b3c7-236ec5a8a539.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F2a89fc70-01fa-11eb-b3c7-236ec5a8a539.jpg?alt=media&token=7c5f9ad7-c20f-4e07-bbda-15170cc0a6a7"
	  }],
	  productNameEnglish: "Kasundi ",
	  productPrice: "2",
	  productSupplier: "BCS SHOP",
	  searchText: "Kasundi ",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "300g",
	  updateDateTime: "Tue 29-09-20 10:19 am",
	  key: "-MIMe1KwabBD0YmmG3qm"
	}, {
	  availability: "AVAILABLE",
	  category: "রান্না করা খাবার",
	  photos: [{
	    imageName: "8d5bb440-f987-11ea-98b2-bdfbde6255e9.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F8d5bb440-f987-11ea-98b2-bdfbde6255e9.jpg?alt=media&token=f3dad4d2-92af-4b70-b443-2779ae1cb9ff"
	  }],
	  productNameEnglish: "মাছের ডিম ভাজি।",
	  productPrice: "2",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "1 serving",
	  updateDateTime: "Fri 18-09-20 4:18 pm",
	  key: "-MHVHnnh2iPjqWz6WrV5"
	}, {
	  availability: "AVAILABLE",
	  category: "রান্না করা খাবার",
	  key: "-MHVHKvftDDCPt3j1R-8",
	  photos: [{
	    imageName: "3ae48f20-f987-11ea-98b2-bdfbde6255e9.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F3ae48f20-f987-11ea-98b2-bdfbde6255e9.jpg?alt=media&token=9c03f659-6de2-4ae8-a483-39de6b2cae1b"
	  }],
	  productNameEnglish: "হাঁস এর মাংস রান্না।",
	  productPrice: "6",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "1 serving .",
	  updateDateTime: "Fri 18-09-20 4:18 pm"
	}, {
	  availability: "AVAILABLE",
	  category: "রান্না করা খাবার",
	  photos: [{
	    imageName: "dd057e00-f986-11ea-98b2-bdfbde6255e9.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2Fdd057e00-f986-11ea-98b2-bdfbde6255e9.jpg?alt=media&token=3a7a79ed-35e7-4cfa-bd33-2f2c88eb7355"
	  }],
	  productNameEnglish: "ভুড়ি রান্না।",
	  productPrice: "5",
	  productSupplier: "BCS SHOP",
	  searchText: "vure ranna.",
	  sortOrder: "1",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "1 serving",
	  updateDateTime: "Fri 18-09-20 4:13 pm",
	  key: "-MHVGfdf1MsX6RnFMzmV"
	}, {
	  availability: "AVAILABLE",
	  category: "রান্না করা খাবার",
	  key: "-MHVG19Kcy11GUx62ZHn",
	  photos: [{
	    imageName: "83a71300-f986-11ea-98b2-bdfbde6255e9.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F83a71300-f986-11ea-98b2-bdfbde6255e9.jpg?alt=media&token=da735328-9af7-411e-ab71-4e72c5633557"
	  }],
	  productNameEnglish: "শরিষা  ভর্তা  ।",
	  productPrice: "1",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "1 serving",
	  updateDateTime: "Fri 18-09-20 4:21 pm"
	}, {
	  availability: "AVAILABLE",
	  category: "রান্না করা খাবার",
	  key: "-MHVDYR3ye_hNAYgtCWm",
	  photos: [{
	    imageName: "f24ea0e0-f984-11ea-98b2-bdfbde6255e9.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2Ff24ea0e0-f984-11ea-98b2-bdfbde6255e9.jpg?alt=media&token=bbba37df-1b44-485f-8597-953919ce52ba"
	  }],
	  productNameEnglish: "কালো  জিরা ভর্তা ।",
	  productPrice: "1",
	  productSupplier: "BCS SHOP",
	  searchText: "kalo jera vorta.",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "1 serving.",
	  updateDateTime: "Fri 18-09-20 4:21 pm"
	}, {
	  availability: "AVAILABLE",
	  category: "DRINKS DESSERT",
	  photos: [{
	    imageName: "b936ee50-f7ce-11ea-9ca4-275d4c37dc1b.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2Fb936ee50-f7ce-11ea-9ca4-275d4c37dc1b.jpg?alt=media&token=c1f3cd55-0ebd-423e-9f7b-26c46189b56f"
	  }],
	  productNameEnglish: "Pran lachcha shemi",
	  productPrice: "1.70",
	  productSupplier: "BCS SHOP",
	  searchText: " lachcha shemi",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "200g",
	  updateDateTime: "Wed 16-09-20 11:43 am",
	  key: "-MHK-YgxQtovzCL12aCX"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  photos: [{
	    imageName: "08d9b330-f7ce-11ea-9ca4-275d4c37dc1b.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F08d9b330-f7ce-11ea-9ca4-275d4c37dc1b.jpg?alt=media&token=0ab0d7ab-a6f5-4784-988c-7fb85cbd6ea5"
	  }],
	  productNameEnglish: "Saffy sunflower",
	  productPrice: "14",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "5 L",
	  updateDateTime: "Wed 16-09-20 11:38 am",
	  key: "-MHJzQbjEXxFWdlUEMSV"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  key: "-MHJyDwP5va8JVS55gum",
	  photos: [{
	    imageName: "25921b30-f7cd-11ea-9ca4-275d4c37dc1b.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F25921b30-f7cd-11ea-9ca4-275d4c37dc1b.jpg?alt=media&token=2f5a818f-93d0-412b-b5ff-6b5ffae9d1cb"
	  }],
	  productNameEnglish: "Pran Fish masala",
	  productPrice: "3",
	  productSupplier: "BCS SHOP",
	  searchText: "Fish masala",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "100g",
	  updateDateTime: "Wed 16-09-20 11:34 am"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-MHJwuApldBM-FqskEBo",
	  photos: [{
	    imageName: "a10a7e70-f7cc-11ea-9ca4-275d4c37dc1b.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2Fa10a7e70-f7cc-11ea-9ca4-275d4c37dc1b.jpg?alt=media&token=2f1cd8b1-8072-43f0-bb05-11c203012f00"
	  }],
	  productNameEnglish: "pran chilli powder",
	  productPrice: "3.50",
	  productSupplier: "BCS SHOP",
	  searchText: "chilli powder",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "250g",
	  updateDateTime: "Wed 16-09-20 5:33 pm"
	}, {
	  availability: "AVAILABLE",
	  category: "SNACKS DRY FOOD",
	  isPopular: "",
	  key: "-MHFul2QZyxooWaFH1y6",
	  photos: [{
	    imageName: "2d8bc640-f72f-11ea-885a-2b4d96b2f26b.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F2d8bc640-f72f-11ea-885a-2b4d96b2f26b.jpg?alt=media&token=f4f0d783-4812-45c4-b3e5-20b781d6caaf"
	  }],
	  productNameEnglish: "Muri moa 1 jar",
	  productPrice: "3",
	  productSupplier: "BCS SHOP",
	  searchText: "Moa",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "400g",
	  updateDateTime: "Tue 15-09-20 4:50 pm"
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  key: "-MGajFuMfZ35eVylCMyq",
	  photos: [{
	    imageName: "40f06ea0-f0bf-11ea-ba7d-67bd2d78e913.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F40f06ea0-f0bf-11ea-ba7d-67bd2d78e913.jpg?alt=media&token=82428541-1ba2-4944-87ee-192f3a6c0338"
	  }],
	  productNameEnglish: "Garlic 1 bag",
	  productPrice: "9",
	  productSupplier: "BCS SHOP",
	  searchText: "Garlic",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "1 bag",
	  updateDateTime: "Mon 07-09-20 12:45 pm"
	}, {
	  availability: "AVAILABLE",
	  category: "MEAT FISH",
	  key: "-MGaNOtrs0L79H33eYUy",
	  photos: [{
	    imageName: "a6c3d130-f0b1-11ea-ba7d-67bd2d78e913.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2Fa6c3d130-f0b1-11ea-ba7d-67bd2d78e913.jpg?alt=media&token=7709abad-f84a-4486-a87b-be3911a8159d"
	  }],
	  productNameEnglish: "  Fish sea bass",
	  productPrice: "13",
	  productSupplier: "BCS SHOP",
	  searchText: "sea bass",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "1 kg",
	  updateDateTime: "Mon 07-09-20 12:41 pm"
	}, {
	  availability: "AVAILABLE",
	  category: "RICE DAAL NOODLES",
	  key: "-MFsRVzvqlSw2jAmJbf5",
	  photos: [{
	    imageName: "f979c5b0-e9ae-11ea-88e9-2b8db057b537.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2Ff979c5b0-e9ae-11ea-88e9-2b8db057b537.jpg?alt=media&token=596bc825-14ea-4551-a3e8-0cc03582f03e"
	  }],
	  productNameEnglish: "Jaguar rice",
	  productPrice: "35",
	  productSupplier: "BCS SHOP",
	  searchText: "rice",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "25kg",
	  updateDateTime: "Wed 02-12-20 10:20 am"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  photos: [{
	    imageName: "8dae0b00-e915-11ea-8fce-359ac42234fb.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F8dae0b00-e915-11ea-8fce-359ac42234fb.jpg?alt=media&token=917db79d-6fbc-48ff-b498-7dcb8604425c"
	  }],
	  productNameEnglish: "Shan haleem mix",
	  productPrice: "2.60",
	  productSupplier: "BCS SHOP",
	  searchText: "haleem mix",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "50g",
	  updateDateTime: "Fri 28-08-20 6:02 pm",
	  key: "-MFoW8q8-6QTyvl88vZg"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  key: "-MFoUZc12Nwex7SCUlaW",
	  photos: [{
	    imageName: "90a6ce10-e914-11ea-8fce-359ac42234fb.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F90a6ce10-e914-11ea-8fce-359ac42234fb.jpg?alt=media&token=00299e97-b1f4-44ad-b1df-09ddd50899c9"
	  }],
	  productNameEnglish: "Shan daal masala ",
	  productPrice: "2.60",
	  productSupplier: "BCS SHOP",
	  searchText: "daal masala",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "100g",
	  updateDateTime: "Fri 28-08-20 6:04 pm"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  key: "-MFioAQ7xOZQHrrb3yKh",
	  photos: [{
	    imageName: "ca46d860-e836-11ea-a70c-3f9f15f1ac0f.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2Fca46d860-e836-11ea-a70c-3f9f15f1ac0f.jpg?alt=media&token=714895a8-c4de-4943-994a-bc1068986a7b"
	  }],
	  productNameEnglish: "Malka coriander powder",
	  productPrice: ".90",
	  productSupplier: "BCS SHOP",
	  searchText: "coriander powder",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "50g",
	  updateDateTime: "Tue 15-09-20 1:26 pm"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  photos: [{
	    imageName: "26349da0-e833-11ea-a70c-3f9f15f1ac0f.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F26349da0-e833-11ea-a70c-3f9f15f1ac0f.jpg?alt=media&token=47418b1c-51e8-453c-a50b-da162f423e1d"
	  }],
	  productNameEnglish: "Malka turmeric powder",
	  productPrice: "1.30",
	  productSupplier: "BCS SHOP",
	  searchText: " turmeric powder",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "100g",
	  updateDateTime: "Thu 27-08-20 3:01 pm",
	  key: "-MFiiCMnPa_ZArGp15n9"
	}, {
	  availability: "AVAILABLE",
	  category: "DRINKS DESSERT",
	  key: "-MFig1_KHQrnrzAhMAW4",
	  photos: [{
	    imageName: "aa5bcae0-e833-11ea-a70c-3f9f15f1ac0f.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2Faa5bcae0-e833-11ea-a70c-3f9f15f1ac0f.jpg?alt=media&token=91503ec6-fa21-4a60-b9f0-ae754c7fd9d2"
	  }],
	  productNameEnglish: "Shan sheer khurma",
	  productPrice: "1.70",
	  productSupplier: "BCS SHOP",
	  searchText: " khurma",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "100g",
	  updateDateTime: "Thu 27-08-20 3:05 pm"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  key: "-MFibGQ-UkRLc5KS5egA",
	  photos: [{
	    imageName: "78902f00-e834-11ea-a70c-3f9f15f1ac0f.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F78902f00-e834-11ea-a70c-3f9f15f1ac0f.jpg?alt=media&token=8d492700-63b7-4f9c-b6c3-0cc418dd1bba"
	  }],
	  productNameEnglish: "Shan curry powdser",
	  productPrice: "1.30",
	  productSupplier: "BCS SHOP",
	  searchText: "curry powdser",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "1009",
	  updateDateTime: "Thu 27-08-20 3:11 pm"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  key: "-MFi_zHSYUHnI90Nb3yz",
	  photos: [{
	    imageName: "cd525590-e834-11ea-a70c-3f9f15f1ac0f.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2Fcd525590-e834-11ea-a70c-3f9f15f1ac0f.jpg?alt=media&token=71568e12-2d19-4d55-afea-c44e5a6979c3"
	  }],
	  productNameEnglish: "Shan mutton biryani",
	  productPrice: "1.50",
	  productSupplier: "BCS SHOP",
	  searchText: "mutton masala",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "60g",
	  updateDateTime: "Thu 27-08-20 3:14 pm"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  photos: [{
	    imageName: "942904f0-e82d-11ea-b1ae-e3e3c2d1f850.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F942904f0-e82d-11ea-b1ae-e3e3c2d1f850.jpg?alt=media&token=dd912b75-2c48-4ec3-bfc9-6e1f86eb0456"
	  }],
	  productNameEnglish: "Shan pilau biryani",
	  productPrice: "1.50",
	  productSupplier: "BCS SHOP",
	  searchText: "pilau biryani",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "50g",
	  updateDateTime: "Thu 27-08-20 2:21 pm",
	  key: "-MFi_4OhcsjfFDkLX32J"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  photos: [{
	    imageName: "4f6a2470-e82d-11ea-b1ae-e3e3c2d1f850.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F4f6a2470-e82d-11ea-b1ae-e3e3c2d1f850.jpg?alt=media&token=17839d92-e51c-4a4e-b642-32590bc45d90"
	  }],
	  productNameEnglish: "Shan kabsa  rice",
	  productPrice: "1.50",
	  productSupplier: "BCS SHOP",
	  searchText: "kabsa  rice",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "60g",
	  updateDateTime: "Thu 27-08-20 2:19 pm",
	  key: "-MFiZcx5Dx_mRAHfHJWG"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  photos: [{
	    imageName: "e6067790-e82c-11ea-b1ae-e3e3c2d1f850.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2Fe6067790-e82c-11ea-b1ae-e3e3c2d1f850.jpg?alt=media&token=79917cba-8080-423b-8b87-b8bd4685ff1e"
	  }],
	  productNameEnglish: "Shan haleem mix",
	  productPrice: "2.60",
	  productSupplier: "BCS SHOP",
	  searchText: "haleem mix",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "300g",
	  updateDateTime: "Thu 27-08-20 2:16 pm",
	  key: "-MFiYxfbB1MBnMi7xRA0"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  key: "-MFiXzlMuhflgMjcX9yc",
	  photos: [{
	    imageName: "23f32730-e835-11ea-a70c-3f9f15f1ac0f.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F23f32730-e835-11ea-a70c-3f9f15f1ac0f.jpg?alt=media&token=f1722292-dc96-4148-a777-cbb0dc5e424f"
	  }],
	  productNameEnglish: "Shan fish biryani",
	  productPrice: "1.50",
	  productSupplier: "BCS SHOP",
	  searchText: "fish biryani",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "50g",
	  updateDateTime: "Thu 27-08-20 3:15 pm"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  photos: [{
	    imageName: "18b54780-e82c-11ea-b1ae-e3e3c2d1f850.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F18b54780-e82c-11ea-b1ae-e3e3c2d1f850.jpg?alt=media&token=bf58c58e-92c1-486b-9dcb-ba6d328154e6"
	  }],
	  productNameEnglish: "Shan bombay biryani",
	  productPrice: "1.50",
	  productSupplier: "BCS SHOP",
	  searchText: " bombay biryani",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "60g",
	  updateDateTime: "Thu 27-08-20 2:11 pm",
	  key: "-MFiXeZ-jb04oeSw6EvZ"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  photos: [{
	    imageName: "a3a10ce0-e82b-11ea-b1ae-e3e3c2d1f850.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2Fa3a10ce0-e82b-11ea-b1ae-e3e3c2d1f850.jpg?alt=media&token=d9d05700-be53-4905-90c5-62bf14b9dc4b"
	  }],
	  productNameEnglish: "Shan korma masala",
	  productPrice: "1.50",
	  productSupplier: "BCS SHOP",
	  searchText: "korma masala",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "50g",
	  updateDateTime: "Thu 27-08-20 2:07 pm",
	  key: "-MFiWtwcMOdMMta92jro"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  photos: [{
	    imageName: "6f730c70-e82b-11ea-b1ae-e3e3c2d1f850.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F6f730c70-e82b-11ea-b1ae-e3e3c2d1f850.jpg?alt=media&token=b3487bd3-825b-479b-a4cb-2292451b64b0"
	  }],
	  productNameEnglish: "Shan keema masala",
	  productPrice: "1.50",
	  productSupplier: "BCS SHOP",
	  searchText: " keema masala",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "50g",
	  updateDateTime: "Thu 27-08-20 2:06 pm",
	  key: "-MFiWZaroF2Vy19-hXT8"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  photos: [{
	    imageName: "0bb9dfb0-e82b-11ea-b1ae-e3e3c2d1f850.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F0bb9dfb0-e82b-11ea-b1ae-e3e3c2d1f850.jpg?alt=media&token=834195b8-ff43-42cc-bfa4-d9e07d8338e5"
	  }],
	  productNameEnglish: "Shan meat & vegetable",
	  productPrice: "1.50",
	  productSupplier: "BCS SHOP",
	  searchText: "meat & vegetable",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "100g",
	  updateDateTime: "Thu 27-08-20 2:03 pm",
	  key: "-MFiVw3lxw-UcCHdRiPk"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  photos: [{
	    imageName: "c421a070-e82a-11ea-b1ae-e3e3c2d1f850.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2Fc421a070-e82a-11ea-b1ae-e3e3c2d1f850.jpg?alt=media&token=07f14e77-8d80-45e6-883c-21c101e6d174"
	  }],
	  productNameEnglish: "Shan  meat masala ",
	  productPrice: "1.50",
	  productSupplier: "BCS SHOP",
	  searchText: "beef masala",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "100g",
	  updateDateTime: "Thu 27-08-20 2:01 pm",
	  key: "-MFiVVjX_u5zP1rN9Ry4"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  photos: [{
	    imageName: "26bafac0-e82a-11ea-b1ae-e3e3c2d1f850.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F26bafac0-e82a-11ea-b1ae-e3e3c2d1f850.jpg?alt=media&token=01625141-9535-44e6-8898-83aff0fac72c"
	  }],
	  productNameEnglish: "Shan fried chops steaks",
	  productPrice: "1.50",
	  productSupplier: "BCS SHOP",
	  searchText: "fried chops steaks",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "50g",
	  updateDateTime: "Thu 27-08-20 1:57 pm",
	  key: "-MFiUSjN6SNe_Lei8zs8"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  photos: [{
	    imageName: "e5a06a20-e829-11ea-b1ae-e3e3c2d1f850.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2Fe5a06a20-e829-11ea-b1ae-e3e3c2d1f850.jpg?alt=media&token=b9b75cff-21df-4703-9759-ac1d7d68ccde"
	  }],
	  productNameEnglish: "Shan chicken masala",
	  productPrice: "1.50",
	  productSupplier: "BCS SHOP",
	  searchText: "chicken masala",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "50g",
	  updateDateTime: "Thu 27-08-20 1:55 pm",
	  key: "-MFiU3F-ld83EV43ezY8"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  photos: [{
	    imageName: "a2d5f180-e827-11ea-b1ae-e3e3c2d1f850.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2Fa2d5f180-e827-11ea-b1ae-e3e3c2d1f850.jpg?alt=media&token=efa96250-dbe9-4a16-90ee-874b56f2effd"
	  }],
	  productNameEnglish: "Shan chicken white korma",
	  productPrice: "1.50",
	  productSupplier: "BCS SHOP",
	  searchText: "chicken white korma",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "40g",
	  updateDateTime: "Thu 27-08-20 1:39 pm",
	  key: "-MFiQN2znzNKlt0Kig1w"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  key: "-MFiP7cGpuOE-RlkWBhE",
	  photos: [{
	    imageName: "5efd7100-e835-11ea-a70c-3f9f15f1ac0f.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F5efd7100-e835-11ea-a70c-3f9f15f1ac0f.jpg?alt=media&token=ffbf70f5-4ad6-49fb-aafb-d6268a42a07d"
	  }],
	  productNameEnglish: "Shan chana masala",
	  productPrice: "1.50",
	  productSupplier: "BCS SHOP",
	  searchText: "chana masala",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "100g",
	  updateDateTime: "Thu 27-08-20 3:17 pm"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  key: "-MFiOjwnmtk5jqUGPWqn",
	  photos: [{
	    imageName: "2ed54bf0-e836-11ea-a70c-3f9f15f1ac0f.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F2ed54bf0-e836-11ea-a70c-3f9f15f1ac0f.jpg?alt=media&token=42b03d2e-7dc6-4964-86bf-da5ef4a22557"
	  }],
	  productNameEnglish: "Shan stew / dopiaza masala",
	  productPrice: "1.50",
	  productSupplier: "BCS SHOP",
	  searchText: " dopiaza masala",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "50g",
	  updateDateTime: "Thu 27-08-20 3:23 pm"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  key: "-MFiJoCrO1unF5bCn1do",
	  photos: [{
	    imageName: "d5f6eb90-e823-11ea-b1ae-e3e3c2d1f850.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2Fd5f6eb90-e823-11ea-b1ae-e3e3c2d1f850.jpg?alt=media&token=e06a301c-4231-4876-bfb0-cb48a8889c73"
	  }],
	  productNameEnglish: "Shan bihari kabab",
	  productPrice: "1.50",
	  productSupplier: "BCS SHOP",
	  searchText: " bihari kabab",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "50g",
	  updateDateTime: "Thu 27-08-20 1:12 pm"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  photos: [{
	    imageName: "06bf2ff0-e81d-11ea-b1ae-e3e3c2d1f850.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F06bf2ff0-e81d-11ea-b1ae-e3e3c2d1f850.jpg?alt=media&token=1ed00fea-c10f-442e-822d-c34ca83dc316"
	  }],
	  productNameEnglish: "Shan chapli kabab",
	  productPrice: "1.50",
	  productSupplier: "BCS SHOP",
	  searchText: "chapli kabab",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "100g",
	  updateDateTime: "Thu 27-08-20 12:23 pm",
	  key: "-MFi8xY4_rUfIzh2LtYC"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  photos: [{
	    imageName: "7e731120-e81c-11ea-b1ae-e3e3c2d1f850.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F7e731120-e81c-11ea-b1ae-e3e3c2d1f850.jpg?alt=media&token=9f6aa663-b083-4a98-a759-f034ba6ee7cc"
	  }],
	  productNameEnglish: "Shan fenugreek leaves",
	  productPrice: "1.50",
	  productSupplier: "BCS SHOP",
	  searchText: "fenugreek leaves",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "50g",
	  updateDateTime: "Thu 27-08-20 12:19 pm",
	  key: "-MFi855Nl5zEHaWo1qSO"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  photos: [{
	    imageName: "1c08ab80-e81c-11ea-b1ae-e3e3c2d1f850.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F1c08ab80-e81c-11ea-b1ae-e3e3c2d1f850.jpg?alt=media&token=46849882-ebb9-494c-ad90-cad43e536f1d"
	  }],
	  productNameEnglish: "Shan turmeric powder",
	  productPrice: "1.80",
	  productSupplier: "BCS SHOP",
	  searchText: "turmeric powder",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "200g",
	  updateDateTime: "Thu 27-08-20 12:16 pm",
	  key: "-MFi7SivFrmiI3eW1WxW"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  photos: [{
	    imageName: "b6c18bc0-e81b-11ea-b1ae-e3e3c2d1f850.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2Fb6c18bc0-e81b-11ea-b1ae-e3e3c2d1f850.jpg?alt=media&token=e7a67767-5a2f-42fa-b984-46fdd4f202e3"
	  }],
	  productNameEnglish: "Shan dried mango powder",
	  productPrice: "1.70",
	  productSupplier: "BCS SHOP",
	  searchText: "dried mango powder",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "150g",
	  updateDateTime: "Thu 27-08-20 12:14 pm",
	  key: "-MFi6qfm0jQThRQ7QVpm"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  key: "-MFi4VtLQhsiCgJTHMAp",
	  photos: [{
	    imageName: "338ffe90-e81a-11ea-b1ae-e3e3c2d1f850.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F338ffe90-e81a-11ea-b1ae-e3e3c2d1f850.jpg?alt=media&token=cdd93cdd-734c-4f8b-a9a0-15f3292205ae"
	  }],
	  productNameEnglish: "Shan garam masala powder",
	  productPrice: "2.20",
	  productSupplier: "BCS SHOP",
	  searchText: "garam masala",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "50g",
	  updateDateTime: "Thu 27-08-20 1:14 pm"
	}, {
	  availability: "AVAILABLE",
	  category: "OTHERS",
	  photos: [{
	    imageName: "13a4cb20-e684-11ea-9786-7f7137f3f585.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F13a4cb20-e684-11ea-9786-7f7137f3f585.jpg?alt=media&token=c8135dfc-00cc-4bb0-a557-ddfd23c852c9"
	  }],
	  productNameEnglish: "BD Gamsa",
	  productPrice: "4.5",
	  productSupplier: "BCS SHOP",
	  searchText: "Gamsa",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "1 pc",
	  updateDateTime: "Tue 25-08-20 11:36 am",
	  key: "-MFYfxsA5OQoH8IP5nlX"
	}, {
	  availability: "AVAILABLE",
	  category: "OTHERS",
	  key: "-MFYfAtBRvgQShD8sJic",
	  photos: [{
	    imageName: "9d69ead0-e683-11ea-9786-7f7137f3f585.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F9d69ead0-e683-11ea-9786-7f7137f3f585.jpg?alt=media&token=e81bf61a-6b93-4c43-849e-9bc8ac156da7"
	  }],
	  productNameEnglish: "BD Lungi",
	  productPrice: "8",
	  productSupplier: "BCS SHOP",
	  searchText: "Lungi",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "1 pc",
	  updateDateTime: "Tue 29-09-20 10:26 am"
	}, {
	  availability: "AVAILABLE",
	  category: "TOILETRIES",
	  photos: [{
	    imageName: "1df0eb10-e67d-11ea-9786-7f7137f3f585.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F1df0eb10-e67d-11ea-9786-7f7137f3f585.jpg?alt=media&token=16b83173-3df0-4d56-a3b8-9911c72dd3e8"
	  }],
	  productNameEnglish: "Mama detergent powder",
	  productPrice: "2.50",
	  productSupplier: "BCS SHOP",
	  searchText: "Detergrnt powder",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "1kg",
	  updateDateTime: "Tue 25-08-20 10:46 am",
	  key: "-MFYVeAeF1eu5WHENFbn"
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  key: "-MFLZTbxvM6MFf8kb2ym",
	  photos: [{
	    imageName: "ac2a8d60-e483-11ea-8a88-a93d6c394935.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2Fac2a8d60-e483-11ea-8a88-a93d6c394935.jpg?alt=media&token=6a9d6725-42f2-4ccc-bc4f-d6db00e37be1"
	  }],
	  productNameEnglish: "Red chilli ",
	  productPrice: "1.5",
	  productSupplier: "BCS SHOP",
	  searchText: "লাল কাঁচা মরিচ",
	  sortOrder: "a",
	  supplierContactName: "Kabir",
	  supplierContactPhone: "94562455",
	  unit: "200g",
	  updateDateTime: "Wed 02-12-20 10:21 am"
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  photos: [{
	    imageName: "4fbdfc10-e122-11ea-8469-c1686cba6d19.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F4fbdfc10-e122-11ea-8469-c1686cba6d19.jpg?alt=media&token=e50af00e-c1d9-4625-b94a-9f7832addccf"
	  }],
	  productNameEnglish: "Arum lobe",
	  productPrice: "6.00",
	  productSupplier: "BCS SHOP",
	  searchText: "Kachur lati",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "1 kg",
	  updateDateTime: "Tue 18-08-20 3:22 pm",
	  key: "-MF-RiWAtk49xfQvcQ0k"
	}, {
	  availability: "AVAILABLE",
	  category: "PICKLES",
	  photos: [{
	    imageName: "78e64740-de0d-11ea-9698-4d47c48636b6.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F78e64740-de0d-11ea-9698-4d47c48636b6.jpg?alt=media&token=748ec572-b5c5-4569-91b4-b56dffd8c98e"
	  }],
	  productNameEnglish: "pran garlic pickle",
	  productPrice: "3.20",
	  productSupplier: "BCS SHOP",
	  searchText: "rosun acher",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "1 jar",
	  updateDateTime: "Fri 14-08-20 5:07 pm",
	  key: "-MEgDFKInKeMU-2jR-B9"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  key: "-MEg0nusCP-6UF_64iQi",
	  photos: [{
	    imageName: "32a793a0-de04-11ea-a50a-71ea37251d72.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F32a793a0-de04-11ea-a50a-71ea37251d72.jpg?alt=media&token=bab13879-c2b9-44db-81c6-f210583f03d9"
	  }],
	  productNameEnglish: "coriander powder pran",
	  productPrice: "2.5",
	  productSupplier: "BCS SHOP",
	  searchText: "coriander",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "1 jar 200g",
	  updateDateTime: "Fri 14-08-20 4:43 pm"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  key: "-MEfybskqSgPAmRbKKRe",
	  photos: [{
	    imageName: "55e9df40-de03-11ea-a50a-71ea37251d72.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F55e9df40-de03-11ea-a50a-71ea37251d72.jpg?alt=media&token=afed655d-6893-410d-8ca2-55fe79475e68"
	  }],
	  productNameEnglish: "turmeric powder pran",
	  productPrice: "3.80",
	  productSupplier: "BCS SHOP",
	  searchText: "holud",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "1 jar 250g",
	  updateDateTime: "Fri 14-08-20 4:17 pm"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  photos: [{
	    imageName: "9d1d1090-de02-11ea-a50a-71ea37251d72.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F9d1d1090-de02-11ea-a50a-71ea37251d72.jpg?alt=media&token=5dd026a3-1a37-46aa-a0ad-ff14f41e2e6f"
	  }],
	  productNameEnglish: "chicken  roast masala",
	  productPrice: "2.50",
	  productSupplier: "BCS SHOP",
	  searchText: "chicken roast masala",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "1 pkt 100g",
	  updateDateTime: "Fri 14-08-20 3:50 pm",
	  key: "-MEfwg03GN7OLr-wBBZh"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  key: "-MEfpcbKWce6xFoMeF0M",
	  photos: [{
	    imageName: "6967e670-ddfe-11ea-a50a-71ea37251d72.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F6967e670-ddfe-11ea-a50a-71ea37251d72.jpg?alt=media&token=869b475b-d16c-4506-adbe-c3a36a93074f"
	  }],
	  productNameEnglish: "beef masala pran",
	  productPrice: "2.50",
	  productSupplier: "BCS SHOP",
	  searchText: "beef masala",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "1 pkt 100g",
	  updateDateTime: "Fri 14-08-20 4:16 pm"
	}, {
	  availability: "AVAILABLE",
	  category: "SNACKS DRY FOOD",
	  key: "-MEfnE2YRECG5CSHrUtD",
	  photos: [{
	    imageName: "f611cc00-ddfc-11ea-a50a-71ea37251d72.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2Ff611cc00-ddfc-11ea-a50a-71ea37251d72.jpg?alt=media&token=f83a126e-c360-4e31-9b8f-53537c243e7c"
	  }],
	  productNameEnglish: "chanachur hot 300g",
	  productPrice: "1.80",
	  productSupplier: "BCS SHOP",
	  searchText: "chanachur",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "1 pkt 300g",
	  updateDateTime: "Fri 14-08-20 4:16 pm"
	}, {
	  availability: "AVAILABLE",
	  category: "SNACKS DRY FOOD",
	  key: "-MEfmmg-H4wL9EEg2t16",
	  photos: [{
	    imageName: "68c74100-ddfb-11ea-a50a-71ea37251d72.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F68c74100-ddfb-11ea-a50a-71ea37251d72.jpg?alt=media&token=1da3667b-b911-4aba-a5a9-be787b749aa7"
	  }],
	  productNameEnglish: "chanachur hot 150g pran",
	  productPrice: "0.90",
	  productSupplier: "BCS SHOP",
	  searchText: "chanachur ",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "1 pkt 150g",
	  updateDateTime: "Fri 14-08-20 4:16 pm"
	}, {
	  availability: "AVAILABLE",
	  category: "SNACKS DRY FOOD",
	  key: "-MEfelSS4pQkEVJ_ds8w",
	  photos: [{
	    imageName: "e38b6c40-ddf6-11ea-a50a-71ea37251d72.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2Fe38b6c40-ddf6-11ea-a50a-71ea37251d72.jpg?alt=media&token=f8ddf301-b918-4469-adbb-c692e52ea8ac"
	  }],
	  productNameEnglish: "sweet toast pran",
	  productPrice: "2.00",
	  productSupplier: "BCS SHOP",
	  searchText: "toast ",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "1 pkt 350g",
	  updateDateTime: "Fri 14-08-20 4:15 pm"
	}, {
	  availability: "AVAILABLE",
	  category: "DRINKS DESSERT",
	  key: "-MEfZDL2i8fOR8Yu5BpS",
	  photos: [{
	    imageName: "1be55ff0-ddf3-11ea-a50a-71ea37251d72.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F1be55ff0-ddf3-11ea-a50a-71ea37251d72.jpg?alt=media&token=c985fea1-dc8b-419a-92b6-e8f822a0a70d"
	  }],
	  productNameEnglish: "sat isabgol pran",
	  productPrice: "3.00",
	  productSupplier: "BCS SHOP",
	  searchText: "isabgol esobgul isopgol",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "1 pkt 100g",
	  updateDateTime: "Fri 14-08-20 4:16 pm"
	}, {
	  availability: "AVAILABLE",
	  category: "DRINKS DESSERT",
	  key: "-MEfRF_oewwv035TCXPk",
	  photos: [{
	    imageName: "9201ae00-ddee-11ea-a50a-71ea37251d72.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F9201ae00-ddee-11ea-a50a-71ea37251d72.jpg?alt=media&token=483d8be6-e128-48ee-aa65-270258f8b6f8"
	  }],
	  productNameEnglish: "basil seeds tukma Pran",
	  productPrice: "1.8",
	  productSupplier: "BCS SHOP",
	  searchText: "tukma dana ",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "1 pkt 100g",
	  updateDateTime: "Fri 14-08-20 4:13 pm"
	}, {
	  availability: "AVAILABLE",
	  category: "RICE DAAL NOODLES",
	  isPopular: "",
	  key: "-ME2kI4Y8ht02vbEv9uV",
	  photos: [{
	    imageName: "c2f04820-d7de-11ea-942d-b9f1e760c600.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fc2f04820-d7de-11ea-942d-b9f1e760c600.jpg?alt=media&token=3c4cd649-eeea-4e59-ba14-27e37a6cd9e9"
	  }],
	  productNameEnglish: "Rice - house brand 25kg",
	  productPrice: "34",
	  productSupplier: "BCS SHOP",
	  searchText: "rice",
	  sortOrder: "a",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "25kg",
	  updateDateTime: "Wed 02-12-20 10:20 am"
	}, {
	  availability: "OUT OF STOCK, TOPPING UP IN PROGRESS",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-MDxtMUlxU5qBOzL7Irf",
	  photos: [{
	    imageName: "e47946b0-d6fb-11ea-82eb-219eb13e1aa0.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fe47946b0-d6fb-11ea-82eb-219eb13e1aa0.jpg?alt=media&token=c332da8e-6d70-4b27-8bc2-3906dab13ee0"
	  }],
	  productNameEnglish: "Sunflower oil ",
	  productPrice: "13.50",
	  productSupplier: "BCS SHOP",
	  searchText: "G",
	  sortOrder: "G",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "5L",
	  updateDateTime: "Wed 16-09-20 11:35 am"
	}, {
	  availability: "AVAILABLE",
	  category: "RICE DAAL NOODLES",
	  key: "-MDeJ5jT1rQq8hlzdcn4",
	  photos: [{
	    imageName: "f1a90000-d3fe-11ea-a0e0-7d366b7a98ae.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Ff1a90000-d3fe-11ea-a0e0-7d366b7a98ae.jpg?alt=media&token=08e2aa38-1766-4926-8fdb-3f8c0b40293d"
	  }],
	  productNameEnglish: "Green Moong Dal",
	  productPrice: "4.50",
	  productSupplier: "BCS SHOP",
	  searchText: "ডাল",
	  sortOrder: "a",
	  supplierContactName: "Kabir",
	  supplierContactPhone: "94562455",
	  unit: "1kg ",
	  updateDateTime: "03/08/2020 03:04:50"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-MDSxVCslP0DQpLhyEuA",
	  photos: [{
	    imageName: "546a95d0-d21c-11ea-aa6f-8f310b43ab36.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F546a95d0-d21c-11ea-aa6f-8f310b43ab36.jpg?alt=media&token=a10fac92-656a-41b2-8c4e-665864e878ed"
	  }],
	  productNameEnglish: "S&W Organic Apple Cider Vinegar",
	  productPrice: "7.90",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "Kabir",
	  supplierContactPhone: "94562455",
	  unit: "473ml ",
	  updateDateTime: "03/08/2020 03:18:41"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-MDS5ujR6BVHM84V5qY5",
	  photos: [{
	    imageName: "0e7cae30-d1fb-11ea-af02-8f9212f09cdc.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F0e7cae30-d1fb-11ea-af02-8f9212f09cdc.jpg?alt=media&token=4cf63167-8847-46fc-ac5e-a00d53c19f93"
	  }],
	  productNameEnglish: "Bragg Organic Apple Cider Vinegar ",
	  productPrice: "13",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "Kabir",
	  supplierContactPhone: "94562455",
	  unit: "946ml",
	  updateDateTime: "03/08/2020 03:18:29"
	}, {
	  author: "+6594562455",
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-MDNgqX2N9uYblwrgjBF",
	  photos: [{
	    imageName: "33f95940-d928-11ea-b868-6be4132c903f.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F33f95940-d928-11ea-b868-6be4132c903f.jpg?alt=media&token=73f1c40f-992b-4680-8550-d3b417923214"
	  }],
	  productNameEnglish: "Lime",
	  productPrice: "1.50",
	  productSupplier: "BCS SHOP",
	  searchText: "lemon lime lamon লেবু লেভূ লেবো ",
	  sortOrder: "a",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "250gm",
	  updateDateTime: "Sat 08-08-20 11:43 am"
	}, {
	  availability: "AVAILABLE",
	  category: "রান্না করা খাবার",
	  key: "-MDKs4BC155HT4MpXh_N",
	  photos: [{
	    imageName: "96689730-d0e0-11ea-aade-65854897e2af.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F96689730-d0e0-11ea-aade-65854897e2af.jpg?alt=media&token=afeec514-ce2b-4005-8752-fde751847904"
	  }],
	  productNameEnglish: "চিকেন বিরানি  Chicken Briyani (not everyday available) - Delivery by taxi, pay as meter-fare. ",
	  productPrice: "6",
	  productSupplier: "BCS SHOP",
	  searchText: "চিকেন বিরানি ",
	  sortOrder: "a",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "1 serving ",
	  updateDateTime: "Tue 11-08-20 6:44 pm"
	}, {
	  availability: "AVAILABLE",
	  category: "রান্না করা খাবার",
	  key: "-MD4cxuovAy6ZGT2kouJ",
	  photos: [{
	    imageName: "db3035d0-ce65-11ea-ad6f-2324c1fe3ac0.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fdb3035d0-ce65-11ea-ad6f-2324c1fe3ac0.jpg?alt=media&token=53937bc0-3ecc-465e-a5be-8da7dcb7a4d3"
	  }],
	  productNameEnglish: "Lao chingri curry - Delivery by taxi, pay as meter-fare. ",
	  productPrice: "4",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "Kabir",
	  supplierContactPhone: "94562455",
	  unit: "1 serving ",
	  updateDateTime: "Tue 11-08-20 6:44 pm"
	}, {
	  availability: "AVAILABLE",
	  category: "রান্না করা খাবার",
	  key: "-MCyaRbCwGD5sQknunF3",
	  photos: [{
	    imageName: "6cd1f460-cd53-11ea-9688-f37030ef31de.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F6cd1f460-cd53-11ea-9688-f37030ef31de.jpg?alt=media&token=b0631769-f9ff-4fef-989f-41b57c970c2f"
	  }],
	  productNameEnglish: "করলা ভাজী - Delivery by taxi, pay as meter-fare. ",
	  productPrice: "1",
	  productSupplier: "BCS SHOP",
	  sortOrder: "g",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "1 serving",
	  updateDateTime: "Tue 11-08-20 6:44 pm"
	}, {
	  availability: "AVAILABLE",
	  category: "রান্না করা খাবার",
	  key: "-MCXB9pCvM1-zyyx3mEz",
	  photos: [{
	    imageName: "9fb805e0-c8fd-11ea-91d6-d9d33e68425f.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F9fb805e0-c8fd-11ea-91d6-d9d33e68425f.jpg?alt=media&token=d934f38a-071b-4e1e-b3c2-49a8a227fa38"
	  }],
	  productNameEnglish: "ভাত white rice - Delivery by taxi, pay as meter-fare. ",
	  productPrice: "1",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "Kabir",
	  supplierContactPhone: "94562455",
	  unit: "1 Serving",
	  updateDateTime: "Tue 11-08-20 6:44 pm"
	}, {
	  availability: "AVAILABLE",
	  category: "রান্না করা খাবার",
	  key: "-MCWkR6NjvZA27TfckdU",
	  photos: [{
	    imageName: "a9bc04d0-c8ec-11ea-91d6-d9d33e68425f.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fa9bc04d0-c8ec-11ea-91d6-d9d33e68425f.jpg?alt=media&token=29e2b7b3-d972-4465-add1-89c066ce3cd9"
	  }],
	  productNameEnglish: "ইলিশ মাছ ilish fish curry - Delivery by taxi, pay as meter-fare. ",
	  productPrice: "5",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "Kabir",
	  supplierContactPhone: "94562455",
	  unit: "1 serving ",
	  updateDateTime: "Tue 11-08-20 6:45 pm"
	}, {
	  availability: "AVAILABLE",
	  category: "রান্না করা খাবার",
	  key: "-MCRDjCeuWwGy19C9iJN",
	  photos: [{
	    imageName: "71693af0-c81d-11ea-99a6-3f4f89ed7cd9.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F71693af0-c81d-11ea-99a6-3f4f89ed7cd9.jpg?alt=media&token=4b572523-e57a-4634-8474-893337f38f05"
	  }],
	  productNameEnglish: "মুরগির মাংস  chicken curry - Delivery by taxi, pay as meter-fare. ",
	  productPrice: "4 ",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "1 serving ",
	  updateDateTime: "Tue 11-08-20 6:45 pm"
	}, {
	  availability: "AVAILABLE",
	  category: "রান্না করা খাবার",
	  key: "-MCRBqPtysKzn9y35Vp3",
	  photos: [{
	    imageName: "2c161540-c813-11ea-99a6-3f4f89ed7cd9.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F2c161540-c813-11ea-99a6-3f4f89ed7cd9.jpg?alt=media&token=c9861ad2-9fd6-4d4d-b17c-a0ca1d52012d"
	  }],
	  productNameEnglish: "কাতলা মাছ catla fish curry - Delivery by taxi, pay as meter-fare. ",
	  productPrice: "4",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "1 serving ",
	  updateDateTime: "Tue 11-08-20 6:45 pm"
	}, {
	  availability: "AVAILABLE",
	  category: "রান্না করা খাবার",
	  key: "-MCRAxQoO6xt9ez_xpWK",
	  photos: [{
	    imageName: "d4c358c0-c812-11ea-99a6-3f4f89ed7cd9.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fd4c358c0-c812-11ea-99a6-3f4f89ed7cd9.jpg?alt=media&token=b868a8b5-6897-4cd9-9b7f-ab3521db00fa"
	  }],
	  productNameEnglish: "কৈ মাছ  Koi fish curry - Delivery by taxi, pay as meter-fare. ",
	  productPrice: "4",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "1 serving ",
	  updateDateTime: "Tue 11-08-20 6:45 pm"
	}, {
	  availability: "AVAILABLE",
	  category: "রান্না করা খাবার",
	  key: "-MCRAQqB_mm1I7ffCCQg",
	  photos: [{
	    imageName: "9b0f9e40-c812-11ea-99a6-3f4f89ed7cd9.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F9b0f9e40-c812-11ea-99a6-3f4f89ed7cd9.jpg?alt=media&token=b8d00adb-4a78-4692-a08b-d9742444d78c"
	  }],
	  productNameEnglish: "মাছের মাথা fish head curry Small - Delivery by taxi, pay as meter-fare. ",
	  productPrice: "4",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "1 serving ",
	  updateDateTime: "Tue 11-08-20 6:46 pm"
	}, {
	  availability: "AVAILABLE",
	  category: "রান্না করা খাবার",
	  key: "-MCRA-WbZ8wZGd0NCVYC",
	  photos: [{
	    imageName: "6d422780-c812-11ea-99a6-3f4f89ed7cd9.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F6d422780-c812-11ea-99a6-3f4f89ed7cd9.jpg?alt=media&token=245e524c-7edc-46d9-b689-500b37ea48ea"
	  }],
	  productNameEnglish: "আলুর ভর্তা spicy mashed potato - Delivery by taxi, pay as meter-fare. ",
	  productPrice: "1",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "1 serving ",
	  updateDateTime: "Tue 11-08-20 6:46 pm"
	}, {
	  availability: "AVAILABLE",
	  category: "রান্না করা খাবার",
	  key: "-MCR9THHUwxHT0yCpCK6",
	  photos: [{
	    imageName: "23c71e80-c812-11ea-99a6-3f4f89ed7cd9.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F23c71e80-c812-11ea-99a6-3f4f89ed7cd9.jpg?alt=media&token=7a711649-1626-455d-8215-e3a9860aa7f1"
	  }],
	  productNameEnglish: "বাধাঁকপি cabbage - Delivery by taxi, pay as meter-fare. ",
	  productPrice: "1",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "1 serving ",
	  updateDateTime: "Tue 11-08-20 6:46 pm"
	}, {
	  availability: "AVAILABLE",
	  category: "রান্না করা খাবার",
	  key: "-MCR9GdJufTtT8m56H-1",
	  photos: [{
	    imageName: "f3b228c0-c811-11ea-99a6-3f4f89ed7cd9.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Ff3b228c0-c811-11ea-99a6-3f4f89ed7cd9.jpg?alt=media&token=1389e0eb-e748-4908-8f6a-76710cdba94f"
	  }],
	  productNameEnglish: "ডাল ভর্তা  Mashed lentil - Delivery by taxi, pay as meter-fare.  ",
	  productPrice: "1",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "1 serving ",
	  updateDateTime: "Tue 11-08-20 6:46 pm"
	}, {
	  availability: "AVAILABLE",
	  category: "রান্না করা খাবার",
	  key: "-MCR8w6gC2C8s2l4M1hd",
	  photos: [{
	    imageName: "c551e7e0-c811-11ea-99a6-3f4f89ed7cd9.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fc551e7e0-c811-11ea-99a6-3f4f89ed7cd9.jpg?alt=media&token=aa22d044-dabd-49c5-bbe6-35ac8325053f"
	  }],
	  productNameEnglish: "ছুট মাছ  small fish curry - Delivery by taxi, pay as meter-fare. ",
	  productPrice: "4",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "1 serving ",
	  updateDateTime: "Tue 11-08-20 6:46 pm"
	}, {
	  availability: "AVAILABLE",
	  category: "রান্না করা খাবার",
	  key: "-MCR8fQQxxiYmMT6iqAp",
	  photos: [{
	    imageName: "91ea92d0-c811-11ea-99a6-3f4f89ed7cd9.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F91ea92d0-c811-11ea-99a6-3f4f89ed7cd9.jpg?alt=media&token=b933cde8-e062-4c09-b5df-24a8f3aa6838"
	  }],
	  productNameEnglish: "কচু ভর্তা mashed taro - Delivery by taxi, pay as meter-fare. ",
	  productPrice: "1",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "1 serving ",
	  updateDateTime: "Tue 11-08-20 6:47 pm"
	}, {
	  availability: "AVAILABLE",
	  category: "রান্না করা খাবার",
	  key: "-MCR8Fw96_IPSx7ezDb2",
	  photos: [{
	    imageName: "5cde4050-c811-11ea-99a6-3f4f89ed7cd9.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F5cde4050-c811-11ea-99a6-3f4f89ed7cd9.jpg?alt=media&token=9fbae84a-126c-4869-97cd-e5655b73ad45"
	  }],
	  productNameEnglish: "মিষ্টি কুমড়া pumkin vege - Delivery by taxi, pay as meter-fare. ",
	  productPrice: "1",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "1 serving ",
	  updateDateTime: "Tue 11-08-20 6:47 pm"
	}, {
	  availability: "AVAILABLE",
	  category: "রান্না করা খাবার",
	  key: "-MCR7zvnQzc1AeZpRsk0",
	  photos: [{
	    imageName: "3a79ee10-c811-11ea-99a6-3f4f89ed7cd9.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F3a79ee10-c811-11ea-99a6-3f4f89ed7cd9.jpg?alt=media&token=a26699e9-de8d-4e6a-86bf-04274fbcd3d8"
	  }],
	  productNameEnglish: "মিক্স সব্জি mixed vege - Delivery by taxi, pay as meter-fare. ",
	  productPrice: "1",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "1 serving ",
	  updateDateTime: "Tue 11-08-20 6:47 pm"
	}, {
	  availability: "AVAILABLE",
	  category: "রান্না করা খাবার",
	  key: "-MCR0bUOwveXN1jXgscq",
	  photos: [{
	    imageName: "a4472470-c80c-11ea-99a6-3f4f89ed7cd9.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fa4472470-c80c-11ea-99a6-3f4f89ed7cd9.jpg?alt=media&token=75f78750-428d-49c2-8bd8-1c13989818a1"
	  }],
	  productNameEnglish: "শাক spinach - Delivery by taxi, pay as meter-fare. ",
	  productPrice: "1",
	  productSupplier: "BCS SHOP",
	  searchText: "",
	  sortOrder: "a",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "1 serving ",
	  updateDateTime: "Tue 11-08-20 6:48 pm"
	}, {
	  availability: "AVAILABLE",
	  category: "রান্না করা খাবার",
	  key: "-MCQyJtJM1kmln_OE3uJ",
	  photos: [{
	    imageName: "9f409760-c80a-11ea-99a6-3f4f89ed7cd9.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F9f409760-c80a-11ea-99a6-3f4f89ed7cd9.jpg?alt=media&token=4f4eccb4-d964-40bf-a792-e19c40a1c92a"
	  }],
	  productNameEnglish: "পেঁপে ভর্তা  mashed papaya - Delivery by taxi, pay as meter-fare. ",
	  productPrice: "1",
	  productSupplier: "BCS SHOP",
	  searchText: "",
	  sortOrder: "a",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "1 serving ",
	  updateDateTime: "Tue 11-08-20 6:48 pm"
	}, {
	  availability: "AVAILABLE",
	  category: "রান্না করা খাবার",
	  key: "-MCQxtNNMYXBX8xmTm7x",
	  photos: [{
	    imageName: "8346f870-d6e6-11ea-8976-95d75731af67.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F8346f870-d6e6-11ea-8976-95d75731af67.jpg?alt=media&token=157e0fa3-00d5-4548-af23-9575bbac25a6"
	  }],
	  productNameEnglish: "খাসির খিচুরি স্পেশাল  mutton khichuri - Delivery by taxi, pay as meter-fare. ",
	  productPrice: "7",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "1 serving ",
	  updateDateTime: "Tue 11-08-20 6:42 pm"
	}, {
	  availability: "AVAILABLE",
	  category: "রান্না করা খাবার",
	  key: "-MCQxdBRu9m2vsPCNd7-",
	  photos: [{
	    imageName: "f99a1bb0-d6e6-11ea-8976-95d75731af67.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Ff99a1bb0-d6e6-11ea-8976-95d75731af67.jpg?alt=media&token=2b4864ff-386d-4517-b542-dc96ab9531ef"
	  }],
	  productNameEnglish: "খাসির বিরানী স্পেশাল Mutton Briyani - Delivery by taxi, pay as meter-fare. ",
	  productPrice: "7",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "1 serving ",
	  updateDateTime: "Tue 11-08-20 6:43 pm"
	}, {
	  availability: "AVAILABLE",
	  category: "রান্না করা খাবার",
	  key: "-MCQu3407vHD39i2hP0P",
	  photos: [{
	    imageName: "2debe7b0-c808-11ea-99a6-3f4f89ed7cd9.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F2debe7b0-c808-11ea-99a6-3f4f89ed7cd9.jpg?alt=media&token=94f03c54-1eaa-4189-b193-07e206a6ef52"
	  }],
	  productNameEnglish: "খাসির মাংস Mutton curry - Delivery by taxi, pay as meter-fare. ",
	  productPrice: "5",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "1 serving",
	  updateDateTime: "Tue 11-08-20 6:43 pm"
	}, {
	  availability: "AVAILABLE",
	  category: "রান্না করা খাবার",
	  key: "-MCQrmhygF7gQa3IavNv",
	  photos: [{
	    imageName: "c7335310-c806-11ea-99a6-3f4f89ed7cd9.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fc7335310-c806-11ea-99a6-3f4f89ed7cd9.jpg?alt=media&token=74f1c1e7-50d6-404a-b62f-f781706b6a25"
	  }],
	  productNameEnglish: "গরুর মাংস  Beef Curry - Delivery by taxi, pay as meter-fare. ",
	  productPrice: "5",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "1 serving ",
	  updateDateTime: "Tue 11-08-20 6:48 pm"
	}, {
	  availability: "AVAILABLE",
	  category: "DRINKS DESSERT",
	  key: "-MCFqELs7pn6hJ5HC77t",
	  photos: [{
	    imageName: "07c78780-c658-11ea-8937-41f6a00ee84d.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F07c78780-c658-11ea-8937-41f6a00ee84d.jpg?alt=media&token=2640edda-a253-4dc8-92b4-00b85773333a"
	  }],
	  productNameEnglish: "Red Bull Energy Drink",
	  productPrice: "6.70",
	  productSupplier: "BCS SHOP",
	  searchText: "রেডবুল ",
	  sortOrder: "g",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "6 pcs x 250ml",
	  updateDateTime: "03/08/2020 03:26:32"
	}, {
	  availability: "AVAILABLE",
	  category: "TOILETRIES",
	  key: "-MBZWpNvXzV571CAQ62z",
	  photos: [{
	    imageName: "f54164b0-bf94-11ea-85e3-735b22b1a0db.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Ff54164b0-bf94-11ea-85e3-735b22b1a0db.jpg?alt=media&token=19ad6bd8-8ddd-4fdb-ad7f-08086827c923"
	  }],
	  productNameEnglish: "Neutrogena Deep Clean Blackhead eliminating daily scrub",
	  productPrice: "13.60",
	  productSupplier: "BCS SHOP",
	  searchText: "ফেইস ওয়াশ ",
	  sortOrder: "g",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "100gm",
	  updateDateTime: "03/08/2020 03:27:39"
	}, {
	  availability: "AVAILABLE",
	  category: "RICE DAAL NOODLES",
	  isPopular: "YES",
	  key: "-MBZW8vSHpbvJHgwGif3",
	  photos: [{
	    imageName: "7807e5f0-bf94-11ea-85e3-735b22b1a0db.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F7807e5f0-bf94-11ea-85e3-735b22b1a0db.jpg?alt=media&token=f17c7097-80ff-4b86-857c-8b9b2c041e35"
	  }],
	  productNameEnglish: "India Gate Premium Basmati Rice",
	  productPrice: "20.50",
	  productSupplier: "BCS SHOP",
	  searchText: "বাসমতি চাউল ",
	  sortOrder: "a",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "5kg",
	  updateDateTime: "03/08/2020 03:28:48"
	}, {
	  availability: "AVAILABLE",
	  category: "TOILETRIES",
	  key: "-MBZVee48Q_dgFNvFRDp",
	  photos: [{
	    imageName: "41a8d4b0-bf94-11ea-85e3-735b22b1a0db.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F41a8d4b0-bf94-11ea-85e3-735b22b1a0db.jpg?alt=media&token=27ac8c4c-13f3-47cb-9533-c4477ac2050e"
	  }],
	  productNameEnglish: "Ginvera Natural Bath Shower Gel  ",
	  productPrice: "4.95",
	  productSupplier: "BCS SHOP",
	  searchText: "শাওয়ার ফোম ",
	  sortOrder: "g",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "1L",
	  updateDateTime: "03/08/2020 03:29:54"
	}, {
	  availability: "AVAILABLE",
	  category: "EGGS DAIRY",
	  isPopular: "NO",
	  key: "-MBZUisJUWEgSH-uDmYN",
	  photos: [{
	    imageName: "b7abd190-bf93-11ea-85e3-735b22b1a0db.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fb7abd190-bf93-11ea-85e3-735b22b1a0db.jpg?alt=media&token=4b714d25-1da0-4055-88cc-df0192a8b02e"
	  }],
	  productNameEnglish: "Ayam Brand Tuna Mayonnaise - Hot",
	  productPrice: "2.65",
	  productSupplier: "BCS SHOP",
	  searchText: "টুনা মায়োনিস্ ",
	  sortOrder: "g",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "100gm containter",
	  updateDateTime: "03/08/2020 03:32:08"
	}, {
	  availability: "AVAILABLE",
	  category: "TOILETRIES",
	  key: "-MBZTrIFVTqwGck8rn8m",
	  photos: [{
	    imageName: "f1102900-bf92-11ea-85e3-735b22b1a0db.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Ff1102900-bf92-11ea-85e3-735b22b1a0db.jpg?alt=media&token=50b005e2-febd-48d7-8794-60c091da833b"
	  }],
	  productNameEnglish: "JOHNSON'S Baby Cotton Touch Bath Hair & Body ",
	  productPrice: "10.90",
	  productSupplier: "BCS SHOP",
	  searchText: "বেবি শাওয়ার জেল বাচ্চাদের সেম্পো ",
	  sortOrder: "g",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "500ml",
	  updateDateTime: "03/08/2020 03:32:25"
	}, {
	  availability: "AVAILABLE",
	  category: "EGGS DAIRY",
	  isPopular: "NO",
	  key: "-MBZSgMuAhBkuSScVIda",
	  photos: [{
	    imageName: "6b7bfe40-bf92-11ea-85e3-735b22b1a0db.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F6b7bfe40-bf92-11ea-85e3-735b22b1a0db.jpg?alt=media&token=0bc32690-6e45-4876-8478-ce39d63fc9aa"
	  }],
	  productNameEnglish: "Greenfields Fresh Milk - Chocolate Malt",
	  productPrice: "3.30",
	  productSupplier: "BCS SHOP",
	  searchText: "গ্রীনফিল্ড চকলেট মাল্ট",
	  sortOrder: "G",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "1L",
	  updateDateTime: "03/08/2020 03:33:35"
	}, {
	  availability: "AVAILABLE",
	  category: "LAUNDRY CLEANING",
	  isPopular: "NO",
	  key: "-MBZQu1RsS-9QxxS5if2",
	  photos: [{
	    imageName: "4b99b870-bf91-11ea-85e3-735b22b1a0db.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F4b99b870-bf91-11ea-85e3-735b22b1a0db.jpg?alt=media&token=6ce26509-6fce-4a04-b439-571b4e5c5b06"
	  }],
	  productNameEnglish: "Comfort Fabric Conditioner ",
	  productPrice: "8.50",
	  productSupplier: "BCS SHOP",
	  searchText: "কাপড়ের কন্ডিশনার ",
	  sortOrder: "G",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "5L",
	  updateDateTime: "03/08/2020 03:34:23"
	}, {
	  author: "+6589050302",
	  availability: "AVAILABLE",
	  category: "LAUNDRY CLEANING",
	  isPopular: "YES",
	  key: "-MBZOXMuKXHpRPhG7DoH",
	  photos: [{
	    imageName: "e14e8730-bf8f-11ea-85e3-735b22b1a0db.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fe14e8730-bf8f-11ea-85e3-735b22b1a0db.jpg?alt=media&token=7394dbcb-27e6-4c79-a3d3-250cef082cd9"
	  }],
	  productNameEnglish: "FAB Detergent Powder - Downy",
	  productPrice: "11.50",
	  productSupplier: "BCS SHOP",
	  searchText: "ওয়াশিং পাউডার কাপড় ধুয়ার পাউডার",
	  sortOrder: "g",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "4.7kg",
	  updateDateTime: "Thu 06-08-20 12:46 pm"
	}, {
	  availability: "AVAILABLE",
	  category: "EGGS DAIRY",
	  key: "-MBZN9kTGTqkO56A11u1",
	  photos: [{
	    imageName: "0d6df540-bf8f-11ea-85e3-735b22b1a0db.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F0d6df540-bf8f-11ea-85e3-735b22b1a0db.jpg?alt=media&token=8961a300-1fe0-4fa1-bf4d-709c0211f5c9"
	  }],
	  productNameEnglish: "Skippy Peanut Butter Spread - Grape Stripe",
	  productPrice: "7",
	  productSupplier: "BCS SHOP",
	  searchText: "পিনাট বাটার ",
	  sortOrder: "G",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "530gm",
	  updateDateTime: "03/08/2020 03:36:01"
	}, {
	  availability: "AVAILABLE",
	  category: "KITCHEN DINING",
	  isPopular: "NO",
	  key: "-MBZMcaPJsYk9yNqB2rR",
	  photos: [{
	    imageName: "8234a190-bf8e-11ea-85e3-735b22b1a0db.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F8234a190-bf8e-11ea-85e3-735b22b1a0db.jpg?alt=media&token=9fc38ddf-89a0-4a9d-96b8-11c71de2c0ae"
	  }],
	  productNameEnglish: "Kitchen Towel Rolls ",
	  productPrice: "4.50",
	  productSupplier: "BCS SHOP",
	  searchText: "কিচেন তোয়ালে ",
	  sortOrder: "G",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "6 roll pack",
	  updateDateTime: "03/08/2020 03:37:10"
	}, {
	  availability: "AVAILABLE",
	  category: "EGGS DAIRY",
	  isPopular: "YES",
	  key: "-MBZLVLQXyTSh5pehqLR",
	  photos: [{
	    imageName: "0b0d3e60-bf8e-11ea-85e3-735b22b1a0db.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F0b0d3e60-bf8e-11ea-85e3-735b22b1a0db.jpg?alt=media&token=98d5462b-d434-4893-a76e-e90c91f9bca5"
	  }],
	  productNameEnglish: "Gardenia Super Soft Wholemeal Bread",
	  productPrice: "3.5",
	  productSupplier: "BCS SHOP",
	  searchText: "পাউরুটি পাওরোটি ",
	  sortOrder: "g",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "600gm pkt",
	  updateDateTime: "03/08/2020 03:40:48"
	}, {
	  availability: "AVAILABLE",
	  category: "DRINKS DESSERT",
	  isPopular: "YES",
	  key: "-MBZKEFOmp9p-uw3Bn5n",
	  photos: [{
	    imageName: "30743ec0-bf8d-11ea-85e3-735b22b1a0db.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F30743ec0-bf8d-11ea-85e3-735b22b1a0db.jpg?alt=media&token=e2b19a51-7dc8-4665-982a-e0c6fba31e4f"
	  }],
	  productNameEnglish: "SIS Refined White Sugar",
	  productPrice: "1.90",
	  productSupplier: "BCS SHOP",
	  searchText: "চিনি ",
	  sortOrder: "a",
	  sourceSupplier: "Sheng siong ",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "1kg",
	  updateDateTime: "17/07/2020 07:32:58"
	}, {
	  availability: "AVAILABLE",
	  category: "EGGS DAIRY",
	  isPopular: "YES",
	  key: "-MBIm9l66dbWcOIQ7hNU",
	  photos: [{
	    imageName: "ddad7f90-bd06-11ea-83e5-cbed5ea0d8b3.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fddad7f90-bd06-11ea-83e5-cbed5ea0d8b3.jpg?alt=media&token=c286cf2e-8b36-4a7a-a45b-11bd6579576c"
	  }],
	  productNameEnglish: "Nespray Everyday Instant Milk Powder",
	  productPrice: "9.95",
	  productSupplier: "BCS SHOP",
	  searchText: "milk naspry nespry nestly powder ধুদ ",
	  sortOrder: "g",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "550g",
	  updateDateTime: "03/08/2020 03:41:59"
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-MBEKS4n6InBM-7Pyuqh",
	  photos: [{
	    imageName: "1192dc50-bc59-11ea-b7df-33e703b87300.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F1192dc50-bc59-11ea-b7df-33e703b87300.jpg?alt=media&token=3559c821-d04d-4d69-b4a0-7887d7e74fe6"
	  }],
	  productNameEnglish: "Green Grapes ",
	  productPrice: "4.50",
	  productSupplier: "BCS SHOP",
	  searchText: "আঙ্গুর আঙুর ",
	  sortOrder: "a",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "500gm",
	  updateDateTime: "Mon 21-09-20 3:37 pm"
	}, {
	  availability: "AVAILABLE",
	  category: "DRINKS DESSERT",
	  isPopular: "YES",
	  key: "-MB8XrLyYdlYzf0Rutzt",
	  photos: [{
	    imageName: "8e563c60-bb77-11ea-9bec-f98d55a4d196.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F8e563c60-bb77-11ea-9bec-f98d55a4d196.jpg?alt=media&token=bcb1f0ad-b14d-4db9-a63c-e615ef251469"
	  }],
	  productNameEnglish: "PRAN Frooto Mango Juice",
	  productPrice: "2.50",
	  productSupplier: "BCS SHOP",
	  searchText: "amer juice mango mengo আমের রস জুস ",
	  sortOrder: "g",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "1000ml",
	  updateDateTime: "03/08/2020 03:43:36"
	}, {
	  availability: "AVAILABLE",
	  category: "DRINKS DESSERT",
	  isPopular: "YES",
	  key: "-MB8X5eB7StmB_sv4Fli",
	  photos: [{
	    imageName: "437a1230-bb76-11ea-9bec-f98d55a4d196.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F437a1230-bb76-11ea-9bec-f98d55a4d196.jpg?alt=media&token=b6760277-0838-48c4-a15c-87a32db02106"
	  }],
	  productNameEnglish: "PRAN Orange Powder ",
	  productPrice: "4.50",
	  productSupplier: "BCS SHOP",
	  searchText: "orange juice powder অরেঞ্জ জুস",
	  sortOrder: "g",
	  sourceSupplier: "GLOBAL PIONEEER PTE LTD",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "500ml",
	  updateDateTime: "03/08/2020 03:44:33"
	}, {
	  availability: "AVAILABLE",
	  category: "OTHERS",
	  key: "-MAywiPOYxcEO50-mrk9",
	  photos: [{
	    imageName: "5131adb0-e8e0-11ea-b634-e7e7c4cb042d.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F5131adb0-e8e0-11ea-b634-e7e7c4cb042d.jpg?alt=media&token=46317372-b7a9-44ec-b42e-d9d4640e5c52"
	  }],
	  productNameEnglish: "Surgical Face mask",
	  productPrice: "18.90",
	  productSupplier: "BCS SHOP",
	  searchText: "মাস্ক ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "50pcs of 1packet.",
	  updateDateTime: "Fri 28-08-20 1:45 pm"
	}, {
	  availability: "OUT OF STOCK, TOPPING UP IN PROGRESS",
	  category: "OTHERS",
	  isPopular: "YES",
	  key: "-MAuWje35ZQxDS99_aGV",
	  photos: [{
	    imageName: "48809f70-b92c-11ea-bcad-f16312f4aa54.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F48809f70-b92c-11ea-bcad-f16312f4aa54.jpg?alt=media&token=815ade9d-1279-4404-9cc5-ad1762f68393"
	  }],
	  productNameEnglish: "Lungi - Malaysian & Indonesian ",
	  productPrice: "8",
	  productSupplier: "BCS SHOP",
	  searchText: "lungi loongi sarong লুঙ্গি লুঙ্গী ",
	  sortOrder: "m",
	  sourceSupplier: "TANMOY ENTERPRISE PTE LTD",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "1 pc",
	  updateDateTime: "Tue 29-09-20 10:56 am"
	}, {
	  availability: "OUT OF STOCK, TOPPING UP IN PROGRESS",
	  category: "OTHERS",
	  isPopular: "YES",
	  key: "-MAuV2lPINSwTniomMlp",
	  photos: [{
	    imageName: "3e521340-b92b-11ea-bcad-f16312f4aa54.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F3e521340-b92b-11ea-bcad-f16312f4aa54.jpg?alt=media&token=6bc2029c-be52-4eec-8cfa-5cd4e63354ae"
	  }],
	  productNameEnglish: "Gamsa - Bangladeshi Gamsa",
	  productPrice: "5",
	  productSupplier: "BCS SHOP",
	  searchText: "gamsa gamca gamcha গামছা ",
	  sortOrder: "m",
	  sourceSupplier: "TANMOY ENTERPRISE PTE LTD",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "1 pc",
	  updateDateTime: "Tue 25-08-20 11:45 am"
	}, {
	  availability: "AVAILABLE",
	  category: "OTHERS",
	  isPopular: "YES",
	  key: "-MAuUm3Qs70W-bsoD_Ci",
	  photos: [{
	    imageName: "8ae9f9d0-01ff-11eb-b3c7-236ec5a8a539.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F8ae9f9d0-01ff-11eb-b3c7-236ec5a8a539.jpg?alt=media&token=d22c1735-ae5c-424a-a3b6-ba84cb76dcb4"
	  }],
	  productNameEnglish: "Lungi - Bangladeshi & large size",
	  productPrice: "10",
	  productSupplier: "BCS SHOP",
	  searchText: "longi loongi lunge লুঙ্গি লুঙ্গী ",
	  sortOrder: "m",
	  sourceSupplier: "TANMOY ENTERPRISE PTE LTD",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "1 pc",
	  updateDateTime: "Tue 29-09-20 10:57 am"
	}, {
	  availability: "AVAILABLE",
	  category: "DRINKS DESSERT",
	  isPopular: "YES",
	  key: "-MAZejYrhHO1ZLsEJ3AF",
	  photos: [{
	    imageName: "496b2ba0-bc4f-11ea-b7df-33e703b87300.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F496b2ba0-bc4f-11ea-b7df-33e703b87300.jpg?alt=media&token=684a42d8-1e00-4d42-9f9a-ad6f514604f9"
	  }],
	  productNameEnglish: "Rock Sugar",
	  productPrice: "2.20",
	  productSupplier: "BCS SHOP",
	  searchText: "mirchi মির্চি মির্ছি ",
	  sortOrder: "g",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "350g",
	  updateDateTime: "03/08/2020 03:46:25"
	}, {
	  availability: "OUT OF STOCK, TOPPING UP IN PROGRESS",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-MAZe6naCD3X8bi9CORd",
	  photos: [{
	    imageName: "26a8dae0-bc4f-11ea-b7df-33e703b87300.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F26a8dae0-bc4f-11ea-b7df-33e703b87300.jpg?alt=media&token=4ec20587-3bbf-4fe4-a841-948d61bb46d9"
	  }],
	  productNameEnglish: "Himalay Cumin Powder",
	  productPrice: "3.50",
	  productSupplier: "BCS SHOP",
	  searchText: "zira jeera jira জিরা ",
	  sortOrder: "g",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "125g",
	  updateDateTime: "Fri 14-08-20 4:18 pm"
	}, {
	  availability: "OUT OF STOCK, TOPPING UP IN PROGRESS",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-MAZdpGYWmipvq1nf4Ja",
	  photos: [{
	    imageName: "f27709e0-bc4e-11ea-b7df-33e703b87300.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Ff27709e0-bc4e-11ea-b7df-33e703b87300.jpg?alt=media&token=249abff1-d69c-46c5-a563-12c2ce077a2f"
	  }],
	  productNameEnglish: "Himalay Coriander Powder",
	  productPrice: "2.50",
	  productSupplier: "BCS SHOP",
	  searchText: "ধনিয়ার গুঁড়া ",
	  sortOrder: "g",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "125g",
	  updateDateTime: "Fri 14-08-20 4:18 pm"
	}, {
	  availability: "OUT OF STOCK, TOPPING UP IN PROGRESS",
	  category: "COOKING INGREDIENTS",
	  isPopular: "YES",
	  key: "-MAZdA2vloIV39grJ-lO",
	  photos: [{
	    imageName: "bb849240-bc4e-11ea-b7df-33e703b87300.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fbb849240-bc4e-11ea-b7df-33e703b87300.jpg?alt=media&token=0864398c-055b-493e-a542-3af485529ec0"
	  }],
	  productNameEnglish: "Himalay Turmeric Powder",
	  productPrice: "2.50",
	  productSupplier: "BCS SHOP",
	  searchText: "holud holdi turmeric turmaric হলুদের গুঁড়া হলুদ ",
	  sortOrder: "g",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1.25G",
	  updateDateTime: "Fri 14-08-20 4:17 pm"
	}, {
	  availability: "OUT OF STOCK, TOPPING UP IN PROGRESS",
	  category: "COSMETICS",
	  key: "-MAL3wkgCT5J3xLA080v",
	  photos: [{
	    imageName: "52283be0-b39c-11ea-8405-4bfbff23e084.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F52283be0-b39c-11ea-8405-4bfbff23e084.jpg?alt=media&token=62a1bffc-3662-4fb4-b564-bc35cbf91ac6"
	  }],
	  productNameEnglish: "Nivea Deo Roll-On Dry Comfort",
	  productPrice: "3.95",
	  productSupplier: "BCS SHOP",
	  searchText: "deodorant বগলের পারফিউম ",
	  sortOrder: "n",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "50ML of 1pc",
	  updateDateTime: "17/07/2020 01:50:23"
	}, {
	  availability: "OUT OF STOCK, TOPPING UP IN PROGRESS",
	  category: "MEAT FISH",
	  isPopular: "YES",
	  key: "-MAFC3DkU-kjYPA_Sj6f",
	  photos: [{
	    imageName: "ed478220-b2b6-11ea-85ed-ad9467055d6e.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fed478220-b2b6-11ea-85ed-ad9467055d6e.jpg?alt=media&token=972c8971-cbad-4918-bd25-141bdf1f978c"
	  }],
	  productNameEnglish: "Lamb Rack Chop",
	  productPrice: "3.80",
	  productSupplier: "BCS SHOP",
	  searchText: "lamb chop খাশির চপ ",
	  sortOrder: "n",
	  sourceSupplier: "",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "100G",
	  updateDateTime: "03/08/2020 03:48:14"
	}, {
	  author: "+6589050302",
	  availability: "AVAILABLE",
	  category: "EGGS DAIRY",
	  isPopular: "YES",
	  key: "-MABkwxm7pStALGAF3ev",
	  photos: [{
	    imageName: "4ba4f990-bc50-11ea-b7df-33e703b87300.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F4ba4f990-bc50-11ea-b7df-33e703b87300.jpg?alt=media&token=f55e6d5a-4cc4-4653-8c6f-62ec45f5b57c"
	  }],
	  productNameEnglish: "Nestle Everyday Instant Milk Powder ",
	  productPrice: "20.90",
	  productSupplier: "BCS SHOP",
	  searchText: "milk ধুদ ",
	  sortOrder: "c",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "1kg Packet",
	  updateDateTime: "Thu 13-08-20 10:50 pm"
	}, {
	  availability: "AVAILABLE",
	  category: "EGGS DAIRY",
	  isPopular: "YES",
	  key: "-MABkOB9PgFDrB6Dv8D_",
	  photos: [{
	    imageName: "de9c87a0-bc4f-11ea-b7df-33e703b87300.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fde9c87a0-bc4f-11ea-b7df-33e703b87300.jpg?alt=media&token=8606e8f7-8b04-43b7-b055-09d58a6c0147"
	  }],
	  productNameEnglish: "Nestle Everyday Intant Milk Powder",
	  productPrice: "11",
	  productSupplier: "BCS SHOP",
	  searchText: "milk dudh dod ধুদ ",
	  sortOrder: "c",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "600gm",
	  updateDateTime: "Tue 18-08-20 9:35 am"
	}, {
	  availability: "AVAILABLE",
	  category: "EGGS DAIRY",
	  isPopular: "YES",
	  key: "-MABjiEtSQvbCSB-t1ux",
	  photos: [{
	    imageName: "ae547e80-bc50-11ea-b7df-33e703b87300.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fae547e80-bc50-11ea-b7df-33e703b87300.jpg?alt=media&token=e5e3a84e-1a4e-44e5-bea6-9e551bb27f0c"
	  }],
	  productNameEnglish: "Nestle Everyday Intant Milk Powder",
	  productPrice: "6",
	  productSupplier: "BCS SHOP",
	  searchText: "milk dudh dod powder ধুদ ",
	  sortOrder: "c",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "300gm",
	  updateDateTime: "03/08/2020 04:11:05"
	}, {
	  availability: "AVAILABLE",
	  category: "EGGS DAIRY",
	  isPopular: "YES",
	  key: "-MABjJi6SUbQ8eTcAd04",
	  photos: [{
	    imageName: "197d5b00-bc51-11ea-b7df-33e703b87300.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F197d5b00-bc51-11ea-b7df-33e703b87300.jpg?alt=media&token=062360d1-e98d-411a-af84-081a86567545"
	  }],
	  productNameEnglish: "Enricos Instant Milk Powder",
	  productPrice: "10",
	  productSupplier: "BCS SHOP",
	  searchText: "milk dud dood powder ধুদ ",
	  sortOrder: "c",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "635gm",
	  updateDateTime: "03/08/2020 03:55:05"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-MABh5F4COBtDnGWP0a5",
	  photos: [{
	    imageName: "58c0c6d0-b22e-11ea-b6a3-23fbd917d0cb.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F58c0c6d0-b22e-11ea-b6a3-23fbd917d0cb.jpg?alt=media&token=735b5ca8-1c8a-4ba7-af19-27cb07214585"
	  }],
	  productNameEnglish: "Cinnamon Powder ",
	  productPrice: "1.50",
	  productSupplier: "BCS SHOP",
	  searchText: "thenga masala দারচিনি দারুচিনি ",
	  sortOrder: "a",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "50gm",
	  updateDateTime: "03/08/2020 03:55:24"
	}, {
	  availability: "OUT OF STOCK, TOPPING UP IN PROGRESS",
	  category: "ELECTRONICS ACCESSORIES",
	  key: "-MABfPBzkJUhQJ0yHm67",
	  photos: [{
	    imageName: "86835d90-b22d-11ea-b6a3-23fbd917d0cb.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F86835d90-b22d-11ea-b6a3-23fbd917d0cb.jpg?alt=media&token=c1aaead1-6677-4b46-8aed-5bfd66c51923"
	  }],
	  productNameEnglish: "IPhone 6s Plus Screen Protector",
	  productPrice: "8",
	  productSupplier: "BCS SHOP",
	  searchText: "স্ক্রিন প্রটেক্টর ",
	  sortOrder: "m",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "per pc",
	  updateDateTime: "03/08/2020 03:55:38"
	}, {
	  availability: "OUT OF STOCK, TOPPING UP IN PROGRESS",
	  category: "ELECTRONICS ACCESSORIES",
	  isPopular: "NO",
	  key: "-MABfG00SBUIj5hmgsXS",
	  photos: [{
	    imageName: "34572420-b22d-11ea-b6a3-23fbd917d0cb.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F34572420-b22d-11ea-b6a3-23fbd917d0cb.jpg?alt=media&token=6c013e5f-cf9b-42cf-8f77-526ece4dd9d4"
	  }],
	  productNameEnglish: "IPhone 6s Plus Cover",
	  productPrice: "9",
	  productSupplier: "BCS SHOP",
	  searchText: "ফোন কভার ",
	  sortOrder: "m",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "1 pc",
	  updateDateTime: "03/08/2020 03:55:50"
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-MAB_ZvZGKR0d9NJnjha",
	  photos: [{
	    imageName: "cdaf1c30-b229-11ea-9201-9d4c56efae0c.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fcdaf1c30-b229-11ea-9201-9d4c56efae0c.jpg?alt=media&token=89515213-7acd-4581-badb-c1e2514e16c8"
	  }],
	  productNameEnglish: "Banana",
	  productPrice: "2.50",
	  productSupplier: "BCS SHOP",
	  searchText: "kola kala kela benana কলা কেলা ",
	  sortOrder: "a",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "5 to 6 pcs",
	  updateDateTime: "03/08/2020 03:55:59"
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-MABXAIcpABQfGW7lI7F",
	  photos: [{
	    imageName: "b64648c0-bf80-11ea-85e3-735b22b1a0db.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fb64648c0-bf80-11ea-85e3-735b22b1a0db.jpg?alt=media&token=f787ebe8-3b5d-45b6-b77a-338e1b461c99"
	  }],
	  productNameEnglish: "Orange (Malta)",
	  productPrice: "6",
	  productSupplier: "BCS SHOP",
	  searchText: "komola malta কমলা মালটা ",
	  sortOrder: "a",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "5 pcs",
	  updateDateTime: "03/08/2020 03:56:14"
	}, {
	  availability: "AVAILABLE",
	  category: "SNACKS DRY FOOD",
	  isPopular: "YES",
	  key: "-MAB9V1JLwAGA1zCB0hy",
	  photos: [{
	    imageName: "af7cc410-b5bc-11ea-8808-e1e7c83edfc8.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Faf7cc410-b5bc-11ea-8808-e1e7c83edfc8.jpg?alt=media&token=1fe738cc-b954-4daf-bd5c-018587483d3a"
	  }],
	  productNameEnglish: "PRAN Chanachur - Hot 1kg Pack ",
	  productPrice: "6",
	  productSupplier: "BCS SHOP",
	  searchText: "channachur chanacor ",
	  sortOrder: "a",
	  sourceSupplier: "GLOBAL PIONEEER PTE LTD",
	  supplierContactName: "Kabir",
	  supplierContactPhone: "94562455",
	  unit: "1kg",
	  updateDateTime: "03/08/2020 03:58:41"
	}, {
	  availability: "AVAILABLE",
	  category: "BABY TOYS",
	  isPopular: "NO",
	  key: "-MA9T5thc4lszCcVxGcX",
	  photos: [{
	    imageName: "04d87100-b1d7-11ea-be46-b92ce24bdd59.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F04d87100-b1d7-11ea-be46-b92ce24bdd59.jpg?alt=media&token=9b5bd640-f7bc-467a-a4f1-fa58261cd9f4"
	  }],
	  productNameEnglish: "Friso Gold 3 - Formula Milk Powder",
	  productPrice: "65",
	  productSupplier: "BCS SHOP",
	  searchText: "baby milk powder বাচ্চাদের ধুদ ",
	  sortOrder: "m",
	  sourceSupplier: "Sheng siong ",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "1.8kg",
	  updateDateTime: "03/08/2020 03:59:44"
	}, {
	  availability: "AVAILABLE",
	  category: "BABY TOYS",
	  isPopular: "NO",
	  key: "-MA9RxG3ChfDvvOfRGgE",
	  photos: [{
	    imageName: "614f5c10-b1d6-11ea-be46-b92ce24bdd59.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F614f5c10-b1d6-11ea-be46-b92ce24bdd59.jpg?alt=media&token=a02ee7a6-0c9b-400c-a58b-fb616375d260"
	  }],
	  productNameEnglish: "Frisolac Gold 1 - Formula Milk Powder",
	  productPrice: "59",
	  productSupplier: "BCS SHOP",
	  searchText: "বাচ্চাদের ধুদ ",
	  sortOrder: "m",
	  sourceSupplier: "Sheng siong ",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "900g",
	  updateDateTime: "03/08/2020 04:00:18"
	}, {
	  availability: "AVAILABLE",
	  category: "BABY TOYS",
	  isPopular: "NO",
	  key: "-MA9QikkTSfZ1oibC53c",
	  photos: [{
	    imageName: "cb05f900-b1d8-11ea-a6de-b7197ac269a2.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fcb05f900-b1d8-11ea-a6de-b7197ac269a2.jpg?alt=media&token=e98efdab-6923-42c0-aed9-f0edcf906f7e"
	  }],
	  productNameEnglish: "Friso Gold 4 - Formula Milk Powder",
	  productPrice: "55",
	  productSupplier: "BCS SHOP",
	  searchText: "বাচ্চাদের ধুদ ",
	  sortOrder: "m",
	  sourceSupplier: "Sheng siong ",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "1.8kg",
	  updateDateTime: "03/08/2020 04:00:46"
	}, {
	  availability: "OUT OF STOCK, TOPPING UP IN PROGRESS",
	  category: "STATIONARY",
	  isPopular: "NO",
	  key: "-MA9JrS5LCYBPILkmB0o",
	  photos: [{
	    imageName: "34cc58f0-b1d1-11ea-92aa-1786097b86e8.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F34cc58f0-b1d1-11ea-92aa-1786097b86e8.jpg?alt=media&token=6843521f-0ad4-4ef8-8680-3797cd3464f6"
	  }],
	  productNameEnglish: "Staples No.10-1M  ",
	  productPrice: "0.80",
	  productSupplier: "BCS SHOP",
	  searchText: "স্টেপলার স্টেপ্লার ",
	  sortOrder: "t",
	  sourceSupplier: "MUSTAFA CENTRE",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1Box (1000PC) ",
	  updateDateTime: "03/08/2020 04:01:47"
	}, {
	  availability: "AVAILABLE",
	  category: "BABY, CHILD & TOYS",
	  isPopular: "NO",
	  key: "-MA9IoMHiI07gZtjhS-S",
	  photos: [{
	    imageName: "bb02fab0-b1d0-11ea-b8f5-21ee7a5f677f.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fbb02fab0-b1d0-11ea-b8f5-21ee7a5f677f.jpg?alt=media&token=80361df1-66f1-4c5f-aa11-8a643c304fd2"
	  }],
	  productNameEnglish: "Frisolac Gold 2 - Formula Milk Powder",
	  productPrice: "99",
	  productSupplier: "BCS SHOP",
	  searchText: "বাচ্চাদের ধুদ",
	  sortOrder: "m",
	  sourceSupplier: "Sheng siong ",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "1.8kg",
	  updateDateTime: "03/08/2020 04:02:19"
	}, {
	  availability: "OUT OF STOCK, TOPPING UP IN PROGRESS",
	  category: "STATIONARY",
	  isPopular: "NO",
	  key: "-MA9I0eV2bYEy82pQdMX",
	  photos: [{
	    imageName: "1fc37ac0-b1d0-11ea-92aa-1786097b86e8.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F1fc37ac0-b1d0-11ea-92aa-1786097b86e8.jpg?alt=media&token=127b49d3-468a-48f4-9d05-3cf77d1f06f2"
	  }],
	  productNameEnglish: "A3/A4 Long Arm Stapler Metal Home Office Capacity 25 Sheets Paper Stapling",
	  productPrice: "21.80",
	  productSupplier: "BCS SHOP",
	  searchText: "পেপার ক্লিপ ",
	  sortOrder: "t",
	  sourceSupplier: "MUSTAFA CENTRE",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1PC",
	  updateDateTime: "17/07/2020 02:05:42"
	}, {
	  availability: "OUT OF STOCK, TOPPING UP IN PROGRESS",
	  category: "STATIONARY",
	  isPopular: "NO",
	  key: "-MA9GhowJQ3B-WKIxTLs",
	  photos: [{
	    imageName: "592b7bb0-b1cf-11ea-92aa-1786097b86e8.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F592b7bb0-b1cf-11ea-92aa-1786097b86e8.jpg?alt=media&token=42cd93de-683c-4e6a-b563-28f2e871a2ab"
	  }],
	  productNameEnglish: "Professional Magnetic Staple Remover Tool ",
	  productPrice: "3.20",
	  productSupplier: "BCS SHOP",
	  sortOrder: "t",
	  sourceSupplier: "Hao mart ",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1 Pc",
	  updateDateTime: "03/08/2020 04:03:22"
	}, {
	  availability: "OUT OF STOCK, TOPPING UP IN PROGRESS",
	  category: "STATIONARY",
	  isPopular: "NO",
	  key: "-MA9GHS91lg2eK20opya",
	  photos: [{
	    imageName: "3de403d0-b207-11ea-921f-9db4b33fb426.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F3de403d0-b207-11ea-921f-9db4b33fb426.jpg?alt=media&token=7bab2527-a74d-40a8-b203-878022c75b60"
	  }],
	  productNameEnglish: "Claw Staple Remover E0231",
	  productPrice: "3.50",
	  productSupplier: "BCS SHOP",
	  sortOrder: "t",
	  sourceSupplier: "Hao mart ",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1 Pc",
	  updateDateTime: "03/08/2020 04:04:07"
	}, {
	  availability: "OUT OF STOCK, TOPPING UP IN PROGRESS",
	  category: "STATIONARY",
	  isPopular: "NO",
	  key: "-MA9DML6m5Nmi78ZwMfC",
	  photos: [{
	    imageName: "31ba33c0-b1cd-11ea-825a-3b8acfde6ce7.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F31ba33c0-b1cd-11ea-825a-3b8acfde6ce7.jpg?alt=media&token=0141e0a1-fa40-4ab7-8e25-82d84e8a70e4"
	  }],
	  productDescription: "Leg length 6.3M",
	  productNameEnglish: "Max Staples 2115 1/4-5M",
	  productPrice: "0.80",
	  productSupplier: "BCS SHOP",
	  searchText: "স্টেপ্লার স্টেপলার ",
	  sortOrder: "o",
	  sourceSupplier: "Hao mart ",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1 Box (5000 Staples)",
	  updateDateTime: "17/07/2020 02:06:22"
	}, {
	  availability: "OUT OF STOCK, TOPPING UP IN PROGRESS",
	  category: "STATIONARY",
	  isPopular: "NO",
	  key: "-MA9CXJwA9-YTDqvaefl",
	  photos: [{
	    imageName: "05270ff0-b208-11ea-921f-9db4b33fb426.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F05270ff0-b208-11ea-921f-9db4b33fb426.jpg?alt=media&token=201f0b87-af24-43d9-be32-948c77ae023d"
	  }],
	  productNameEnglish: "Max Stapler Tokyo Design ",
	  productPrice: "3.20",
	  productSupplier: "BCS SHOP",
	  searchText: "স্টেপ্লার স্টেপলার ",
	  sortOrder: "o",
	  sourceSupplier: "Hao mart ",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1 Pc",
	  updateDateTime: "03/08/2020 04:04:26"
	}, {
	  availability: "OUT OF STOCK, TOPPING UP IN PROGRESS",
	  category: "STATIONARY",
	  isPopular: "NO",
	  key: "-MA9A8QyRZo2OyU2Cadj",
	  photos: [{
	    imageName: "68f956b0-b1cb-11ea-825a-3b8acfde6ce7.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F68f956b0-b1cb-11ea-825a-3b8acfde6ce7.jpg?alt=media&token=1c61cda2-d895-4572-9641-c6f33c5a80f4"
	  }],
	  productNameEnglish: "Deli 2 Hole Metal Punch Puncher",
	  productPrice: "3.80",
	  productSupplier: "BCS SHOP",
	  sortOrder: "o",
	  sourceSupplier: "Hao mart ",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1pc",
	  updateDateTime: "04/07/2020 07:42:57"
	}, {
	  category: "STATIONARY",
	  isPopular: "NO",
	  key: "-MA97iEs6t-46LTZdr79",
	  photos: [{
	    imageName: "f3f5da60-b1c9-11ea-825a-3b8acfde6ce7.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Ff3f5da60-b1c9-11ea-825a-3b8acfde6ce7.jpg?alt=media&token=2126a9bb-b23a-4e19-b90a-dad4ee598980"
	  }],
	  productNameEnglish: "Zebra Gel Ink Pen 0.5m (Blue, Black, Red)",
	  productPrice: "1.70",
	  productSupplier: "BCS SHOP",
	  searchText: "কলম ",
	  sortOrder: "n",
	  sourceSupplier: "MUSTAFA CENTRE",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1 Pc",
	  updateDateTime: "03/08/2020 04:05:06"
	}, {
	  availability: "OUT OF STOCK, TOPPING UP IN PROGRESS",
	  category: "STATIONARY",
	  isPopular: "NO",
	  key: "-MA97QTqMdZ0GWquWrjb",
	  photos: [{
	    imageName: "013f6390-b20a-11ea-921f-9db4b33fb426.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F013f6390-b20a-11ea-921f-9db4b33fb426.jpg?alt=media&token=0abe6310-7ef4-4721-87f4-f366f8b70cf2"
	  }],
	  productNameEnglish: "Pilot BL Pen G2 0.5 (Black, Blue, Red)",
	  productPrice: "2.50",
	  productSupplier: "BCS SHOP",
	  searchText: "কলম ",
	  sortOrder: "n",
	  sourceSupplier: "MUSTAFA CENTRE",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1PC",
	  updateDateTime: "03/08/2020 04:05:29"
	}, {
	  availability: "OUT OF STOCK, TOPPING UP IN PROGRESS",
	  category: "STATIONARY",
	  isPopular: "NO",
	  key: "-MA977JaYBip7q2dJGmX",
	  photos: [{
	    imageName: "8c003c70-b1c9-11ea-825a-3b8acfde6ce7.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F8c003c70-b1c9-11ea-825a-3b8acfde6ce7.jpg?alt=media&token=1bb49ae5-6e3c-4d5d-8e07-5cda6ae87280"
	  }],
	  productNameEnglish: "Pilot Pen G2 Gel ink 0.7m (black and blue)",
	  productPrice: "2.50",
	  productSupplier: "BCS SHOP",
	  searchText: "কলম ",
	  sortOrder: "n",
	  sourceSupplier: "MUSTAFA CENTRE",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1pc",
	  updateDateTime: "03/08/2020 04:05:51"
	}, {
	  category: "STATIONARY",
	  isPopular: "NO",
	  key: "-MA96t77dYxrab4sHe9s",
	  photos: [{
	    imageName: "52060310-b1c9-11ea-825a-3b8acfde6ce7.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F52060310-b1c9-11ea-825a-3b8acfde6ce7.jpg?alt=media&token=5f9b1a9f-4385-43aa-9212-d95c5895a9b9"
	  }],
	  productNameEnglish: "Pilot Pen G2 0.5m extra fine (Blue. Black, Red)",
	  productPrice: "2.50",
	  productSupplier: "BCS SHOP",
	  searchText: "কলম ",
	  sortOrder: "n",
	  sourceSupplier: "MUSTAFA CENTRE",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1pc",
	  updateDateTime: "03/08/2020 04:06:29"
	}, {
	  category: "STATIONARY",
	  isPopular: "NO",
	  key: "-MA96ThUvng4JLtbcjqV",
	  photos: [{
	    imageName: "173bf690-b1c9-11ea-825a-3b8acfde6ce7.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F173bf690-b1c9-11ea-825a-3b8acfde6ce7.jpg?alt=media&token=b5014879-f5ae-4b31-afab-d3883bfed06e"
	  }],
	  productNameEnglish: "Pen Pilot G2 0.5M gel ink rollerball pen",
	  productPrice: "2.50",
	  productSupplier: "BCS SHOP",
	  searchText: "কলম ",
	  sortOrder: "n",
	  sourceSupplier: "MUSTAFA CENTRE",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1pc",
	  updateDateTime: "17/07/2020 02:07:26"
	}, {
	  availability: "AVAILABLE",
	  category: "DRINKS DESSERT",
	  isPopular: "NO",
	  key: "-MA916B8NAJzyeMs1Zke",
	  photos: [{
	    imageName: "e5c26f20-b1c5-11ea-825a-3b8acfde6ce7.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fe5c26f20-b1c5-11ea-825a-3b8acfde6ce7.jpg?alt=media&token=5ecfdd83-beb4-4893-a59c-bdf95216aafa"
	  }],
	  productNameEnglish: "Vitamilk Soymilk",
	  productPrice: "1.50",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  sourceSupplier: "Hao mart ",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "300ML",
	  updateDateTime: "03/08/2020 04:06:48"
	}, {
	  availability: "AVAILABLE",
	  category: "DRINKS DESSERT",
	  key: "-MA90u7jyPGQfytLyUum",
	  photos: [{
	    imageName: "c903e210-b1c5-11ea-825a-3b8acfde6ce7.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fc903e210-b1c5-11ea-825a-3b8acfde6ce7.jpg?alt=media&token=734564ae-0144-4025-a942-c6ca90f8d07a"
	  }],
	  productNameEnglish: "Vitamilk Soymilk - Choco Shake",
	  productPrice: "1.50",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  sourceSupplier: "Hao mart ",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "300ML",
	  updateDateTime: "03/08/2020 04:07:17"
	}, {
	  availability: "AVAILABLE",
	  category: "DRINKS DESSERT",
	  key: "-MA90ibHFKxniQ4MjrIP",
	  photos: [{
	    imageName: "9d193cd0-b20c-11ea-921f-9db4b33fb426.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F9d193cd0-b20c-11ea-921f-9db4b33fb426.jpg?alt=media&token=a8329f47-0251-4624-afe9-8fec0503a540"
	  }],
	  productNameEnglish: "Vitamilk Soymilk - Double Choco Shake",
	  productPrice: "1.50",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  sourceSupplier: "Hao mart ",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "300ML",
	  updateDateTime: "03/08/2020 04:07:38"
	}, {
	  availability: "AVAILABLE",
	  category: "DRINKS DESSERT",
	  key: "-MA8xRV3tr9yy1qx8HlP",
	  photos: [{
	    imageName: "2d2d1670-b20d-11ea-921f-9db4b33fb426.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F2d2d1670-b20d-11ea-921f-9db4b33fb426.jpg?alt=media&token=c03b1667-cb4b-477e-966f-cb393fc8bdf1"
	  }],
	  productNameEnglish: "Vitamilk Soymilk - Energy",
	  productPrice: "1.50",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  sourceSupplier: "Hao mart ",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "300ML",
	  updateDateTime: "03/08/2020 04:08:45"
	}, {
	  availability: "AVAILABLE",
	  category: "DRINKS DESSERT",
	  key: "-MA5T2F7NqLuWoZUL093",
	  photos: [{
	    imageName: "b5a54c30-b13a-11ea-b71d-553b8acbaa9c.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fb5a54c30-b13a-11ea-b71d-553b8acbaa9c.jpg?alt=media&token=07967a87-f521-491a-b503-5da3702db993"
	  }],
	  productNameEnglish: "Riva Basil Seed Drink - Apple",
	  productPrice: "1.90",
	  productSupplier: "BCS SHOP",
	  searchText: "জুস তুকমার ",
	  sortOrder: "a",
	  sourceSupplier: "Hao mart ",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "290ML",
	  updateDateTime: "03/08/2020 04:11:54"
	}, {
	  availability: "AVAILABLE",
	  category: "DRINKS DESSERT",
	  key: "-MA5SrkI_1rItsZHrUZl",
	  photos: [{
	    imageName: "8ce09750-b13a-11ea-b71d-553b8acbaa9c.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F8ce09750-b13a-11ea-b71d-553b8acbaa9c.jpg?alt=media&token=8521c6b8-141f-4852-9c7d-67e772118d7d"
	  }],
	  productNameEnglish: "Basil Seed Drink - Pomegranate",
	  productPrice: "1.90",
	  productSupplier: "BCS SHOP",
	  searchText: "জুস তুকমার ",
	  sortOrder: "a",
	  sourceSupplier: "Hao mart ",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "290ML",
	  updateDateTime: "03/08/2020 04:12:28"
	}, {
	  availability: "AVAILABLE",
	  category: "DRINKS DESSERT",
	  key: "-MA5SbixrBai_JA2WGfm",
	  photos: [{
	    imageName: "65621e10-b13a-11ea-b71d-553b8acbaa9c.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F65621e10-b13a-11ea-b71d-553b8acbaa9c.jpg?alt=media&token=03c6e367-c39b-4833-b176-43e8462666f8"
	  }],
	  productNameEnglish: "Basil Seed Drink - Watermelon",
	  productPrice: "1.90",
	  productSupplier: "BCS SHOP",
	  searchText: "জুস তুকমার ",
	  sortOrder: "a",
	  sourceSupplier: "Hao mart ",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "290ML",
	  updateDateTime: "03/08/2020 04:12:51"
	}, {
	  availability: "AVAILABLE",
	  category: "DRINKS DESSERT",
	  key: "-MA5SM51GLNNlUQspnn8",
	  photos: [{
	    imageName: "39b898c0-b13a-11ea-b71d-553b8acbaa9c.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F39b898c0-b13a-11ea-b71d-553b8acbaa9c.jpg?alt=media&token=85c7ab21-7611-409c-8470-f6e5d7608270"
	  }],
	  productNameEnglish: "Basil Seed Drink - Grape ",
	  productPrice: "1.90",
	  productSupplier: "BCS SHOP",
	  searchText: "জুস তুকমার ",
	  sortOrder: "a",
	  sourceSupplier: "Hao mart ",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "290ML",
	  updateDateTime: "03/08/2020 04:13:06"
	}, {
	  availability: "AVAILABLE",
	  category: "DRINKS DESSERT",
	  key: "-MA5S4AHG6axvya61kAH",
	  photos: [{
	    imageName: "1702a410-b13a-11ea-b71d-553b8acbaa9c.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F1702a410-b13a-11ea-b71d-553b8acbaa9c.jpg?alt=media&token=f8893814-afab-4e4b-a3fc-6f5cbe73a819"
	  }],
	  productNameEnglish: "Basil Seed Drink - Coconut",
	  productPrice: "1.90",
	  productSupplier: "BCS SHOP",
	  searchText: "জুস তুকমার ",
	  sortOrder: "a",
	  sourceSupplier: "Hao mart ",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "290ML",
	  updateDateTime: "03/08/2020 04:13:24"
	}, {
	  availability: "AVAILABLE",
	  category: "DRINKS DESSERT",
	  key: "-MA5RreB5kj6Uxoi0V-x",
	  photos: [{
	    imageName: "e39e5c40-b139-11ea-b71d-553b8acbaa9c.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fe39e5c40-b139-11ea-b71d-553b8acbaa9c.jpg?alt=media&token=e1186223-2eba-40c9-bc5f-70977971e025"
	  }],
	  productNameEnglish: "Basil Seed Drink - Blueberry",
	  productPrice: "1.90",
	  productSupplier: "BCS SHOP",
	  searchText: "জুস তুকমার ",
	  sortOrder: "a",
	  sourceSupplier: "Hao mart ",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "290ML",
	  updateDateTime: "03/08/2020 04:13:40"
	}, {
	  availability: "AVAILABLE",
	  category: "DRINKS DESSERT",
	  key: "-MA5RWzbnJW145qbj_Ro",
	  photos: [{
	    imageName: "c22f3f70-b139-11ea-b71d-553b8acbaa9c.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fc22f3f70-b139-11ea-b71d-553b8acbaa9c.jpg?alt=media&token=820fb7a7-2319-45f7-8643-b2dc2a95b4c2"
	  }],
	  productNameEnglish: "Basil Seed Drink - Orange",
	  productPrice: "1.90",
	  productSupplier: "BCS SHOP",
	  searchText: "জুস তুকমার ",
	  sortOrder: "a",
	  sourceSupplier: "Hao mart ",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "290ML",
	  updateDateTime: "03/08/2020 04:13:51"
	}, {
	  availability: "AVAILABLE",
	  category: "DRINKS DESSERT",
	  key: "-MA5OjHo5DXbyE1jVbEG",
	  photos: [{
	    imageName: "10d52330-b138-11ea-b71d-553b8acbaa9c.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F10d52330-b138-11ea-b71d-553b8acbaa9c.jpg?alt=media&token=88d61e5e-991a-499d-8a0b-f3fafec4aa71"
	  }],
	  productNameEnglish: "Basil Seed Drink - Apricot",
	  productPrice: "1.90",
	  productSupplier: "BCS SHOP",
	  searchText: "জুস তুকমার ",
	  sortOrder: "a",
	  sourceSupplier: "Hao mart ",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "290ML",
	  updateDateTime: "03/08/2020 04:14:08"
	}, {
	  availability: "AVAILABLE",
	  category: "DRINKS DESSERT",
	  key: "-MA5OTVs18S76WSUoXoo",
	  photos: [{
	    imageName: "e9a28000-b137-11ea-b71d-553b8acbaa9c.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fe9a28000-b137-11ea-b71d-553b8acbaa9c.jpg?alt=media&token=5f9f3ef9-4d56-4800-a90d-deec98b6ee7e"
	  }],
	  productNameEnglish: "Basil Seed Drink - Mango",
	  productPrice: "1.90",
	  productSupplier: "BCS SHOP",
	  searchText: "জুস তুকমার ",
	  sortOrder: "a",
	  sourceSupplier: "Hao mart ",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "290ML",
	  updateDateTime: "03/08/2020 04:14:24"
	}, {
	  availability: "AVAILABLE",
	  category: "DRINKS DESSERT",
	  key: "-MA5OByVC8-e_zLf38FA",
	  photos: [{
	    imageName: "b9fdb130-b137-11ea-b71d-553b8acbaa9c.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fb9fdb130-b137-11ea-b71d-553b8acbaa9c.jpg?alt=media&token=8e981f05-e643-4e38-98a3-88829632653a"
	  }],
	  productNameEnglish: "Basil Seed Drink - Honey",
	  productPrice: "1.90",
	  productSupplier: "BCS SHOP",
	  searchText: "জুস তুকমার ",
	  sortOrder: "a",
	  sourceSupplier: "Hao mart ",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "290ML",
	  updateDateTime: "03/08/2020 04:14:41"
	}, {
	  availability: "AVAILABLE",
	  category: "DRINKS DESSERT",
	  key: "-MA5NwKyqKA9eFI0wbuP",
	  photos: [{
	    imageName: "871ca320-b137-11ea-b71d-553b8acbaa9c.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F871ca320-b137-11ea-b71d-553b8acbaa9c.jpg?alt=media&token=bc7e80ca-9767-4d15-8574-d0e5221168cf"
	  }],
	  productNameEnglish: "Basil Seed Drink - Strawberry",
	  productPrice: "1.90",
	  productSupplier: "BCS SHOP",
	  searchText: "জুস তুকমার ",
	  sortOrder: "a",
	  sourceSupplier: "Hao mart ",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "290ML",
	  updateDateTime: "03/08/2020 04:14:55"
	}, {
	  availability: "AVAILABLE",
	  category: "TOILETRIES",
	  key: "-MA5NsRQlWOon6tjRSpt",
	  photos: [{
	    imageName: "9eec5ef0-b137-11ea-8003-07538fa61857.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F9eec5ef0-b137-11ea-8003-07538fa61857.jpg?alt=media&token=85b8aaf4-5c1b-49f5-a904-5b58c3da2253"
	  }],
	  productNameEnglish: "Baby Wipes",
	  productPrice: "9.95",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  sourceSupplier: "builders mart.com",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "3 PACK 80 PCS",
	  updateDateTime: "03/08/2020 04:15:16"
	}, {
	  availability: "AVAILABLE",
	  category: "DRINKS DESSERT",
	  key: "-MA5Nc75EOVZ7Szr3R_g",
	  photos: [{
	    imageName: "4e84b8e0-b137-11ea-b71d-553b8acbaa9c.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F4e84b8e0-b137-11ea-b71d-553b8acbaa9c.jpg?alt=media&token=daff9114-e201-42d6-9e5d-213af23afd38"
	  }],
	  productNameEnglish: "Basil Seed Drink - Peach",
	  productPrice: "1.90",
	  productSupplier: "BCS SHOP",
	  searchText: "জুস তুকমার ",
	  sortOrder: "a",
	  sourceSupplier: "Hao mart ",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "290ML",
	  updateDateTime: "03/08/2020 04:15:30"
	}, {
	  availability: "AVAILABLE",
	  category: "DRINKS DESSERT",
	  key: "-MA5NFZO56AK1RTbBn9N",
	  photos: [{
	    imageName: "00319af0-b137-11ea-b71d-553b8acbaa9c.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F00319af0-b137-11ea-b71d-553b8acbaa9c.jpg?alt=media&token=19943485-2deb-4ef0-af27-9c31e48cd1d4"
	  }],
	  productNameEnglish: "Basil Seed Drink - Lychee",
	  productPrice: "1.90",
	  productSupplier: "BCS SHOP",
	  searchText: "জুস তুকমার ",
	  sortOrder: "a",
	  sourceSupplier: "Hao mart ",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "290ML",
	  updateDateTime: "03/08/2020 04:15:55"
	}, {
	  availability: "AVAILABLE",
	  category: "DRINKS DESSERT",
	  key: "-MA5MlnegEm2Fgu-EmvK",
	  photos: [{
	    imageName: "c1600ff0-b136-11ea-b71d-553b8acbaa9c.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fc1600ff0-b136-11ea-b71d-553b8acbaa9c.jpg?alt=media&token=fba5c776-2625-4d5c-be98-f637e28ffdd7"
	  }],
	  productNameEnglish: "U globe basil seed cocktail drink ",
	  productPrice: "1.90",
	  productSupplier: "BCS SHOP",
	  searchText: "জুস তুকমার ",
	  sortOrder: "a",
	  sourceSupplier: "Hao mart ",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "290ML",
	  updateDateTime: "17/07/2020 02:09:59"
	}, {
	  availability: "AVAILABLE",
	  category: "DRINKS DESSERT",
	  isPopular: "NO",
	  key: "-MA5MOErfMfePgvMO3Ho",
	  photos: [{
	    imageName: "92815040-b136-11ea-b71d-553b8acbaa9c.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F92815040-b136-11ea-b71d-553b8acbaa9c.jpg?alt=media&token=0656767b-2817-4b97-9d38-09f9c80c5a2e"
	  }],
	  productNameEnglish: "Basil Seed Drink - Cocktail",
	  productPrice: "1.90",
	  productSupplier: "BCS SHOP",
	  searchText: "জুস তুকমার ",
	  sortOrder: "a",
	  sourceSupplier: "Hao mart ",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "290ML",
	  updateDateTime: "03/08/2020 04:16:24"
	}, {
	  category: "TOILETRIES",
	  key: "-MA5EhhsJmF5tRLbgCrR",
	  photos: [{
	    imageName: "bee935d0-b131-11ea-ad89-0df8c42046ae.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fbee935d0-b131-11ea-ad89-0df8c42046ae.jpg?alt=media&token=1032bf4c-4fec-48e0-aa1e-cc249e9ed1b8"
	  }],
	  productNameEnglish: "WD-40 Multi USE PR ",
	  productPrice: "6.90",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  sourceSupplier: "Hao mart ",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "100ML",
	  updateDateTime: "04/07/2020 11:29:12"
	}, {
	  category: "KITCHEN DINING",
	  key: "-MA4sgeQJgpkoZouqO1P",
	  photos: [{
	    imageName: "d17d1a30-b123-11ea-b0bf-cbb30a1eed12.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fd17d1a30-b123-11ea-b0bf-cbb30a1eed12.jpg?alt=media&token=3d227a15-d5ed-4952-8bb1-24e812cf1847"
	  }],
	  productNameEnglish: "Wooden Angular Spoon (30cm)",
	  productPrice: "6.50",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  sourceSupplier: "Sheng siong ",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "PER PC",
	  updateDateTime: "03/08/2020 04:16:51"
	}, {
	  category: "KITCHEN DINING",
	  key: "-MA4rOVSvX0GBrGNproW",
	  photos: [{
	    imageName: "09a5bd50-b123-11ea-b0bf-cbb30a1eed12.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F09a5bd50-b123-11ea-b0bf-cbb30a1eed12.jpg?alt=media&token=ed46a91d-d6eb-44cf-a313-aedf2c472bd4"
	  }],
	  productNameEnglish: "Bamboo wooden Round Spatula (30cm)",
	  productPrice: "3.50",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  sourceSupplier: "Sheng siong ",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "PER PC",
	  updateDateTime: "03/08/2020 04:17:53"
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-MA4p5aqO6oRSOzE2akk",
	  photos: [{
	    imageName: "b8777d30-bdaa-11ea-8ba8-ddb60ef370d4.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fb8777d30-bdaa-11ea-8ba8-ddb60ef370d4.jpg?alt=media&token=7a2ebcdb-2a16-4e7d-a5b5-a51bb6d7a2b2"
	  }],
	  productNameEnglish: "Asparagus",
	  productPrice: "1.30",
	  productSupplier: "BCS SHOP",
	  searchText: "শতমূলী ",
	  sortOrder: "a",
	  sourceSupplier: "Sheng siong ",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "100G",
	  updateDateTime: "03/08/2020 04:18:07"
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "NO",
	  key: "-MA4cWSW0HAda4zBywEU",
	  photos: [{
	    imageName: "ff26c0d0-b119-11ea-810a-c5e0250e7646.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fff26c0d0-b119-11ea-810a-c5e0250e7646.jpg?alt=media&token=c10f409e-fbee-4c33-99d1-8f1533db8b86"
	  }],
	  productNameEnglish: "Coconut",
	  productPrice: "2.50",
	  productSupplier: "BCS SHOP",
	  searchText: "নারিকেল ",
	  sortOrder: "a",
	  sourceSupplier: "Minaka trading ",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1PC",
	  updateDateTime: "17/07/2020 02:11:44"
	}, {
	  availability: "AVAILABLE",
	  category: "DRINKS DESSERT",
	  key: "-MA4cGShaIl7o-YkQkFm",
	  photos: [{
	    imageName: "659d4fd0-bc52-11ea-b7df-33e703b87300.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F659d4fd0-bc52-11ea-b7df-33e703b87300.jpg?alt=media&token=53698db7-deb9-4657-9712-87bcbe08649d"
	  }],
	  productNameEnglish: "Young Coconut",
	  productPrice: "2.50",
	  productSupplier: "BCS SHOP",
	  searchText: "ডাবের পানি নারিকেল পানি ",
	  sortOrder: "a",
	  sourceSupplier: "B&S minimart ",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1PC",
	  updateDateTime: "17/07/2020 02:12:13"
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-MA4b6SEakaGudeVUHPy",
	  photos: [{
	    imageName: "28ec8770-b119-11ea-810a-c5e0250e7646.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F28ec8770-b119-11ea-810a-c5e0250e7646.jpg?alt=media&token=2b2007cc-f32f-435b-a46a-4ff6c42a7443"
	  }],
	  productNameEnglish: "Radicchio",
	  productPrice: "6",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  sourceSupplier: "Sheng siong ",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1KG",
	  updateDateTime: "03/08/2020 04:19:09"
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-MA4aIACmAC5fCV5M-7F",
	  photos: [{
	    imageName: "ff0095b0-bc52-11ea-b7df-33e703b87300.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fff0095b0-bc52-11ea-b7df-33e703b87300.jpg?alt=media&token=024e42da-b7bf-47c2-b344-8c14a05f6b5c"
	  }],
	  productNameEnglish: "Peas",
	  productPrice: "6.5",
	  productSupplier: "BCS SHOP",
	  searchText: "মটর ",
	  sortOrder: "a",
	  sourceSupplier: "Minaka trading ",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1KG",
	  updateDateTime: "03/08/2020 04:19:24"
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-MA4YlCmN4oegMgqBchv",
	  photos: [{
	    imageName: "18831770-b117-11ea-810a-c5e0250e7646.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F18831770-b117-11ea-810a-c5e0250e7646.jpg?alt=media&token=306c4a1c-00c9-4de9-b081-8a36cc3198ca"
	  }],
	  productNameEnglish: "Green Spinach",
	  productPrice: "5",
	  productSupplier: "BCS SHOP",
	  searchText: "ডাটা শাক ",
	  sortOrder: "a",
	  sourceSupplier: "B&S minimart ",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1KG",
	  updateDateTime: "03/08/2020 04:19:36"
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-MA4XjnSy0_iJBg1YE3w",
	  photos: [{
	    imageName: "e95f8440-bc53-11ea-b7df-33e703b87300.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fe95f8440-bc53-11ea-b7df-33e703b87300.jpg?alt=media&token=b2d5737c-b2c2-4a88-9a39-a80f2ffd9ad8"
	  }],
	  productNameEnglish: " Malabar Spinach",
	  productPrice: "5",
	  productSupplier: "BCS SHOP",
	  searchText: "poishak puishak shak পুঁইশাক পুইশাক ",
	  sortOrder: "a",
	  sourceSupplier: "B&S minimart ",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1kg",
	  updateDateTime: "03/08/2020 04:19:53"
	}, {
	  author: "+6589050302",
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-MA4XcGeK3fGezqp242G",
	  photos: [{
	    imageName: "9635a610-bdb5-11ea-8ba8-ddb60ef370d4.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F9635a610-bdb5-11ea-8ba8-ddb60ef370d4.jpg?alt=media&token=f349ff7f-4bf3-4fff-bd73-0269501e0056"
	  }],
	  productNameEnglish: "Green Papaya",
	  productPrice: "3.50",
	  productSupplier: "BCS SHOP",
	  searchText: "kacha pepe কাচা পেঁপে পেপে ",
	  sortOrder: "a",
	  sourceSupplier: "Veg mart ",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1kg",
	  updateDateTime: "Fri 21-08-20 4:31 pm"
	}, {
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-MA4X1ylVhS1ea28CGLI",
	  photos: [{
	    imageName: "ab534fa0-bc54-11ea-b7df-33e703b87300.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fab534fa0-bc54-11ea-b7df-33e703b87300.jpg?alt=media&token=9062ee47-ae37-49a1-8749-4b3fd2f81fb5"
	  }],
	  productNameEnglish: "Raddish ",
	  productPrice: "4.50",
	  productSupplier: "BCS SHOP",
	  searchText: "শাক সবজি সব্জি ",
	  sortOrder: "a",
	  sourceSupplier: "Giant supermarket ",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1KG",
	  updateDateTime: "03/08/2020 04:20:59"
	}, {
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-MA4WSi3YxwmKiQR-BNs",
	  photos: [{
	    imageName: "ecbaa0b0-bc54-11ea-b7df-33e703b87300.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fecbaa0b0-bc54-11ea-b7df-33e703b87300.jpg?alt=media&token=2f85db9e-f690-4bf9-9357-cccf6c5747b8"
	  }],
	  productNameEnglish: "Chow Chow",
	  productPrice: "0.60",
	  productSupplier: "BCS SHOP",
	  searchText: "শাক সবজি সব্জি ",
	  sortOrder: "a",
	  sourceSupplier: "Amman trading ",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "100Gm",
	  updateDateTime: "03/08/2020 04:21:11"
	}, {
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-MA4Vt8UuRY3ZbTkrlKM",
	  photos: [{
	    imageName: "2abbbc50-bc55-11ea-b7df-33e703b87300.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F2abbbc50-bc55-11ea-b7df-33e703b87300.jpg?alt=media&token=e55ce384-e792-4d17-8245-6c216c702e44"
	  }],
	  productNameEnglish: "Arugula",
	  productPrice: "2.6",
	  productSupplier: "BCS SHOP",
	  searchText: "শাক সবজি সব্জি ",
	  sortOrder: "a",
	  sourceSupplier: "Sheng siong ",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "500gm",
	  updateDateTime: "17/07/2020 02:14:45"
	}, {
	  author: "+6589050302",
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-MA4VexMK1sATknlT1Hj",
	  photos: [{
	    imageName: "736eba60-bc55-11ea-b7df-33e703b87300.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F736eba60-bc55-11ea-b7df-33e703b87300.jpg?alt=media&token=c5088de9-6c92-4b31-bc7c-9191b79f2bac"
	  }],
	  productNameEnglish: "Red Spinach",
	  productPrice: "3.20",
	  productSupplier: "BCS SHOP",
	  searchText: "lal shak sak লাল শাক সবজি সব্জি ",
	  sortOrder: "a",
	  sourceSupplier: "Veg mart ",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1kg",
	  updateDateTime: "Tue 18-08-20 10:52 am"
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-MA4UgzmLJisWqpgWd3O",
	  photos: [{
	    imageName: "4df926a0-bdac-11ea-8ba8-ddb60ef370d4.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F4df926a0-bdac-11ea-8ba8-ddb60ef370d4.jpg?alt=media&token=2a248587-1839-4b03-8bef-5a2d1ef69bd3"
	  }],
	  productNameEnglish: "Curry Leaves",
	  productPrice: "1.60",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  sourceSupplier: "Veg mart ",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "100G",
	  updateDateTime: "03/08/2020 04:21:36"
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-MA4UQ6KFh5415O1ZtaT",
	  photos: [{
	    imageName: "c17e83e0-bdac-11ea-8ba8-ddb60ef370d4.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fc17e83e0-bdac-11ea-8ba8-ddb60ef370d4.jpg?alt=media&token=8a79f382-93c1-4836-8ae4-a80f4acdba89"
	  }],
	  productNameEnglish: "Cucumber",
	  productPrice: "1.30",
	  productSupplier: "BCS SHOP",
	  searchText: "shosha sosa shoshi salad",
	  sortOrder: "a",
	  sourceSupplier: "Sheng siong ",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "500gm",
	  updateDateTime: "03/08/2020 04:21:46"
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "NO",
	  key: "-MA4UApEFXLtsvdbcyOr",
	  photos: [{
	    imageName: "5e8cd390-bdb1-11ea-8ba8-ddb60ef370d4.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F5e8cd390-bdb1-11ea-8ba8-ddb60ef370d4.jpg?alt=media&token=157d5690-c281-4d1d-aefc-d2bc0d65228f"
	  }],
	  productNameEnglish: "Celery",
	  productPrice: "6.80",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  sourceSupplier: "Sheng siong ",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1KG",
	  updateDateTime: "03/08/2020 04:21:56"
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-MA4TilEJRaCRQM41ncD",
	  photos: [{
	    imageName: "c6816010-bdb1-11ea-8ba8-ddb60ef370d4.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fc6816010-bdb1-11ea-8ba8-ddb60ef370d4.jpg?alt=media&token=9c581097-b9fe-413f-a9b3-444bc49ef3b8"
	  }],
	  productNameEnglish: "Ash Gourd / Winter Melon",
	  productPrice: "6.50",
	  productSupplier: "BCS SHOP",
	  searchText: "chal kumra komra",
	  sortOrder: "a",
	  sourceSupplier: "Veg mart ",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1KG",
	  updateDateTime: "03/08/2020 04:22:20"
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-MA4TQwXG21X3pVZSRMM",
	  photos: [{
	    imageName: "e3a49310-b113-11ea-b27a-f3d6ccb7047e.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fe3a49310-b113-11ea-b27a-f3d6ccb7047e.jpg?alt=media&token=fff3a411-c711-4382-9a7f-442c90359ba1"
	  }],
	  productNameEnglish: "Lettuce",
	  productPrice: "6",
	  productSupplier: "BCS SHOP",
	  searchText: "শাক সবজি সব্জি ",
	  sortOrder: "a",
	  sourceSupplier: "Sheng siong ",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1kg",
	  updateDateTime: "17/07/2020 02:15:32"
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-MA4TIuNH4iVUoOtOw9y",
	  photos: [{
	    imageName: "354dc920-bdb2-11ea-8ba8-ddb60ef370d4.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F354dc920-bdb2-11ea-8ba8-ddb60ef370d4.jpg?alt=media&token=eb5c5fad-95a9-4526-a381-ec948a1f1588"
	  }],
	  productNameEnglish: "Corn",
	  productPrice: "6",
	  productSupplier: "BCS SHOP",
	  searchText: "butta bhotta botta",
	  sortOrder: "a",
	  sourceSupplier: "Sai shanmuga",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1KG",
	  updateDateTime: "03/08/2020 04:22:32"
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-MA4Sr5vL2D5WLOZOmOg",
	  photos: [{
	    imageName: "9a953700-bdb2-11ea-8ba8-ddb60ef370d4.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F9a953700-bdb2-11ea-8ba8-ddb60ef370d4.jpg?alt=media&token=1c8727fb-8e93-4f75-92f6-77d32bbcc8cf"
	  }],
	  productNameEnglish: "Snake Gourd",
	  productPrice: "6",
	  productSupplier: "BCS SHOP",
	  searchText: "kioda",
	  sortOrder: "a",
	  sourceSupplier: "Veg mart ",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1KG",
	  updateDateTime: "03/08/2020 04:22:47"
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-MA4S3yetf2_0OsXdh_r",
	  photos: [{
	    imageName: "f001f570-bdb2-11ea-8ba8-ddb60ef370d4.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Ff001f570-bdb2-11ea-8ba8-ddb60ef370d4.jpg?alt=media&token=898fb46b-1f78-45f0-ab01-9c639e3ce5d3"
	  }],
	  productNameEnglish: "Chinese Spinach",
	  productPrice: "6",
	  productSupplier: "BCS SHOP",
	  searchText: "শাক সবজি সব্জি ",
	  sortOrder: "a",
	  sourceSupplier: "Sheng siong ",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1kg",
	  updateDateTime: "03/08/2020 04:23:19"
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-MA4Ro3P0gWz-3jP48Hf",
	  photos: [{
	    imageName: "8716b770-bdb3-11ea-8ba8-ddb60ef370d4.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F8716b770-bdb3-11ea-8ba8-ddb60ef370d4.jpg?alt=media&token=a0ca6b1d-bd33-4760-a2c5-d8fda67aea78"
	  }],
	  productNameEnglish: "Beetroot",
	  productPrice: "6.30",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  sourceSupplier: "Amman trading ",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1kg",
	  updateDateTime: "03/08/2020 04:23:27"
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-MA4RT70EXT1R-MsMAVd",
	  photos: [{
	    imageName: "0046bbe0-bdb4-11ea-8ba8-ddb60ef370d4.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F0046bbe0-bdb4-11ea-8ba8-ddb60ef370d4.jpg?alt=media&token=3b0fb145-bf3f-429f-b4fe-bd7a7ca49ca7"
	  }],
	  productNameEnglish: "Ridge Gourd",
	  productPrice: "6.20",
	  productSupplier: "BCS SHOP",
	  searchText: "jinga zinga jingha ",
	  sortOrder: "a",
	  sourceSupplier: "Veg mart ",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1kg",
	  updateDateTime: "03/08/2020 04:24:11"
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-MA4QI8ipDkr4X8KBkor",
	  photos: [{
	    imageName: "c52412a0-bdb4-11ea-8ba8-ddb60ef370d4.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fc52412a0-bdb4-11ea-8ba8-ddb60ef370d4.jpg?alt=media&token=b5d18bfe-7750-4a31-9b59-84a9e88a4192"
	  }],
	  productNameEnglish: "Water Spinach",
	  productPrice: "4.50",
	  productSupplier: "BCS SHOP",
	  searchText: "shak sak kolmi shak শাক সবজি সব্জি ",
	  sortOrder: "a",
	  sourceSupplier: "Veg mart ",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1KG",
	  updateDateTime: "03/08/2020 04:24:21"
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-MA4Q4kMB-2H30JLy_Tc",
	  photos: [{
	    imageName: "1013ba40-bdb5-11ea-8ba8-ddb60ef370d4.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F1013ba40-bdb5-11ea-8ba8-ddb60ef370d4.jpg?alt=media&token=ca1800da-00c4-4a5d-8e27-541faa9ef57b"
	  }],
	  productNameEnglish: "Mustard Spinach",
	  productPrice: " 4.50",
	  productSupplier: "BCS SHOP",
	  searchText: "শাক সবজি সব্জি ",
	  sortOrder: "a",
	  sourceSupplier: "Sai shanmuga",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1KG",
	  updateDateTime: "03/08/2020 04:24:56"
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-MA4Nz1M4RpvVw3tSrQR",
	  photos: [{
	    imageName: "61b7ff00-bdb5-11ea-8ba8-ddb60ef370d4.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F61b7ff00-bdb5-11ea-8ba8-ddb60ef370d4.jpg?alt=media&token=a5464231-fb92-483c-b9f6-c46abc99578d"
	  }],
	  productNameEnglish: "Pointed Gourd",
	  productPrice: "6",
	  productSupplier: "BCS SHOP",
	  searchText: "potol ",
	  sortOrder: "a",
	  sourceSupplier: "Amman trading ",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1kg",
	  updateDateTime: "03/08/2020 04:25:09"
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-MA4Na2HCRG67mD6NL0z",
	  photos: [{
	    imageName: "80ddab90-bdb6-11ea-8ba8-ddb60ef370d4.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F80ddab90-bdb6-11ea-8ba8-ddb60ef370d4.jpg?alt=media&token=148e4f5f-0c4f-45f9-97a9-eb6a2c3a470d"
	  }],
	  productNameEnglish: "Sponge Gourd",
	  productPrice: "6",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  sourceSupplier: "Amman trading ",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1kg",
	  updateDateTime: "03/08/2020 04:25:41"
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-MA4NEU0HJzS_aQbZzqz",
	  photos: [{
	    imageName: "cd3e4650-bdcc-11ea-8ba8-ddb60ef370d4.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fcd3e4650-bdcc-11ea-8ba8-ddb60ef370d4.jpg?alt=media&token=8fd5ea8b-c4d3-4f7f-b6c3-cdedea675cb1"
	  }],
	  productNameEnglish: "Turnip",
	  productPrice: "6",
	  productSupplier: "BCS SHOP",
	  searchText: " শালগম ",
	  sortOrder: "a",
	  sourceSupplier: "Veg mart ",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1kg",
	  updateDateTime: "03/08/2020 04:25:49"
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-MA4MzYjKNqu56ROR_7d",
	  photos: [{
	    imageName: "962ee5f0-bdce-11ea-8ba8-ddb60ef370d4.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F962ee5f0-bdce-11ea-8ba8-ddb60ef370d4.jpg?alt=media&token=718ad6e5-d580-4ee0-9965-7aaee126ac23"
	  }],
	  productNameEnglish: "Taro Root ",
	  productPrice: "6",
	  productSupplier: "BCS SHOP",
	  searchText: "kochu kacha kacho কচু কচুর ছরা ",
	  sortOrder: "a",
	  sourceSupplier: "Veg mart ",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1kg",
	  updateDateTime: "03/08/2020 04:25:58"
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-MA4Mhz5_iloZFQAnB3V",
	  photos: [{
	    imageName: "a123f670-bdcf-11ea-8ba8-ddb60ef370d4.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fa123f670-bdcf-11ea-8ba8-ddb60ef370d4.jpg?alt=media&token=3406769c-8a30-4422-a360-1d21150f6c17"
	  }],
	  productNameEnglish: "Amla",
	  productPrice: "6.70",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  sourceSupplier: "Veg mart ",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1kg",
	  updateDateTime: "03/08/2020 04:26:08"
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-MA4MUO3ordS6KdiUfku",
	  photos: [{
	    imageName: "47866d60-bf81-11ea-85e3-735b22b1a0db.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F47866d60-bf81-11ea-85e3-735b22b1a0db.jpg?alt=media&token=bf2dc684-71aa-4ea2-8d3f-af91965453b6"
	  }],
	  productNameEnglish: "Shim Bean",
	  productPrice: "6.50",
	  productSupplier: "BCS SHOP",
	  searchText: "শিম ছিম  sim shim seem ",
	  sortOrder: "a",
	  sourceSupplier: "Amman trading ",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1KG",
	  updateDateTime: "03/08/2020 04:26:35"
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-MA4Da4f67pdMPLcn-m-",
	  photos: [{
	    imageName: "b373dcf0-bf82-11ea-85e3-735b22b1a0db.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fb373dcf0-bf82-11ea-85e3-735b22b1a0db.jpg?alt=media&token=63926f40-da9c-467b-b58b-0a8bffae0475"
	  }],
	  productNameEnglish: "Drumstick",
	  productPrice: "6.50",
	  productSupplier: "BCS SHOP",
	  searchText: "সইজনা সাজনা ",
	  sortOrder: "a",
	  sourceSupplier: "MADURAI MEENAKSHI MINIMART",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1kg",
	  updateDateTime: "03/08/2020 04:26:43"
	}, {
	  category: "COSMETICS",
	  key: "-MA3zhczyKdhiqCr32ZG",
	  photos: [{
	    imageName: "052bb4c0-b211-11ea-921f-9db4b33fb426.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F052bb4c0-b211-11ea-921f-9db4b33fb426.jpg?alt=media&token=e7f225f8-f2ae-4237-9713-ab74cb16d6d8"
	  }],
	  productNameEnglish: "Himalaya Purifying Neem Facial Wash",
	  productPrice: "8.50",
	  productSupplier: "BCS SHOP",
	  searchText: "ফেইস ওয়াশ ",
	  sortOrder: "x",
	  sourceSupplier: "MUSTAFA CENTRE",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "100ml",
	  updateDateTime: "03/08/2020 04:27:34"
	}, {
	  category: "COSMETICS",
	  key: "-MA3zG1eWkBbKPxN7U2B",
	  photos: [{
	    imageName: "528111c0-b211-11ea-921f-9db4b33fb426.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F528111c0-b211-11ea-921f-9db4b33fb426.jpg?alt=media&token=d655ecbd-cf81-4bf6-86e4-c07f1465b077"
	  }],
	  productNameEnglish: "Himalaya Oil Control Facial Wash",
	  productPrice: "6.95",
	  productSupplier: "BCS SHOP",
	  searchText: "ফেইস ওয়াশ ",
	  sortOrder: "x",
	  sourceSupplier: "MUSTAFA CENTRE",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "100ML",
	  updateDateTime: "03/08/2020 04:27:51"
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-MA0MsR80E1n5sC5-OGS",
	  photos: [{
	    imageName: "23246470-bf83-11ea-85e3-735b22b1a0db.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F23246470-bf83-11ea-85e3-735b22b1a0db.jpg?alt=media&token=638f8e2e-413c-4906-82cb-2102fe5d5e3d"
	  }],
	  productNameEnglish: "Lemon Grass",
	  productPrice: "1",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  sourceSupplier: "Sheng siong ",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "100G",
	  updateDateTime: "03/08/2020 04:28:01"
	}, {
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-MA0M1ZNeHSwSvsOVwJt",
	  photos: [{
	    imageName: "2054fdf0-b073-11ea-9c7f-87aca56d8623.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F2054fdf0-b073-11ea-9c7f-87aca56d8623.jpg?alt=media&token=860fad18-fcfd-4275-9939-4203727eea0e"
	  }],
	  productNameEnglish: "Rock Melon",
	  productPrice: "7.90",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  sourceSupplier: "Sheng siong ",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1 pc",
	  updateDateTime: "03/08/2020 04:28:16"
	}, {
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-MA0JocbXImUuWFjH6Ch",
	  photos: [{
	    imageName: "b27d3680-b211-11ea-921f-9db4b33fb426.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fb27d3680-b211-11ea-921f-9db4b33fb426.jpg?alt=media&token=13981dc9-eabd-4cd2-a395-3bb289017930"
	  }],
	  productNameEnglish: "Bottle Gourd",
	  productPrice: "3",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  sourceSupplier: "S.K.K minimart ",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1Kg",
	  updateDateTime: "03/08/2020 04:29:22"
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-MA0HZHWnF1HIYhUqzL8",
	  photos: [{
	    imageName: "4b63d840-bc58-11ea-b7df-33e703b87300.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F4b63d840-bc58-11ea-b7df-33e703b87300.jpg?alt=media&token=a8a0acab-0394-4137-b528-fcb07dfc9e02"
	  }],
	  productNameEnglish: "Red Grapes",
	  productPrice: "4.50",
	  productSupplier: "BCS SHOP",
	  searchText: "লাল আঙ্গুর ",
	  sortOrder: "a",
	  sourceSupplier: "Sheng siong ",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "500gm",
	  updateDateTime: "Mon 21-09-20 3:38 pm"
	}, {
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-MA0Gzo9OmETYuiqg36L",
	  photos: [{
	    imageName: "c0663890-bc58-11ea-b7df-33e703b87300.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fc0663890-bc58-11ea-b7df-33e703b87300.jpg?alt=media&token=39849a01-d994-4832-ac04-15fca8882d58"
	  }],
	  productNameEnglish: "Strawberries",
	  productPrice: "4.50",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  sourceSupplier: "Sheng siong ",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "250g",
	  updateDateTime: "Mon 21-09-20 3:39 pm"
	}, {
	  author: "+6594562455",
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-MA0G8ynMhI4HuYx49i8",
	  photos: [{
	    imageName: "590236d0-bc59-11ea-b7df-33e703b87300.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F590236d0-bc59-11ea-b7df-33e703b87300.jpg?alt=media&token=5d090713-f8a2-4eab-b103-a5fb23518b29"
	  }],
	  productNameEnglish: "Coriander",
	  productPrice: "2",
	  productSupplier: "BCS SHOP",
	  searchText: "ধনিয়া পাতা ",
	  sortOrder: "a",
	  sourceSupplier: "FAHIM ENTERPRISE PTE LTD",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "100gm",
	  updateDateTime: "Sat 08-08-20 11:48 am"
	}, {
	  availability: "AVAILABLE",
	  category: "COSMETICS",
	  isPopular: "YES",
	  key: "-MA-vTilQKSysy5VlORf",
	  photos: [{
	    imageName: "905237c0-bc59-11ea-b7df-33e703b87300.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F905237c0-bc59-11ea-b7df-33e703b87300.jpg?alt=media&token=b5a6f868-7444-4f54-bd7e-e85fd004c443"
	  }],
	  productNameEnglish: "Fair & Lovely Daily Whitening Cream",
	  productPrice: "5.20",
	  productSupplier: "BCS SHOP",
	  searchText: "ফেইস ক্রিম",
	  sortOrder: "x",
	  sourceSupplier: "MUSTAFA CENTRE",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "25G",
	  updateDateTime: "17/07/2020 06:31:59"
	}, {
	  category: "COSMETICS",
	  isPopular: "YES",
	  key: "-MA-tazsHlmvFvZ0mjFU",
	  photos: [{
	    imageName: "4c030310-b213-11ea-921f-9db4b33fb426.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F4c030310-b213-11ea-921f-9db4b33fb426.jpg?alt=media&token=1558cce1-de64-4608-8ba1-14666e3d733c"
	  }],
	  productNameEnglish: "Fair & Handsome Advanced Whitening Cream",
	  productPrice: "5.20",
	  productSupplier: "BCS SHOP",
	  searchText: "fair & handsome ফেইস ক্রিম",
	  sortOrder: "x",
	  sourceSupplier: "MUSTAFA CENTRE",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "50G",
	  updateDateTime: "03/08/2020 04:33:26"
	}, {
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-MA-tUS7aOooCDdRb5ll",
	  photos: [{
	    imageName: "1c5525c0-b061-11ea-8357-d5a4954c59fc.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F1c5525c0-b061-11ea-8357-d5a4954c59fc.jpg?alt=media&token=dc0bb154-2c99-49b0-aff7-3c9cce03764c"
	  }],
	  productNameEnglish: "PRAN Curry Powder",
	  productPrice: "4.50",
	  productSupplier: "BCS SHOP",
	  searchText: "মসলা ",
	  sortOrder: "a",
	  sourceSupplier: "GAZIPUR TRADING PTE LTD ",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "200G",
	  updateDateTime: "03/08/2020 04:33:47"
	}, {
	  category: "COSMETICS",
	  isPopular: "YES",
	  key: "-MA-t186nywzez5LkCVy",
	  photos: [{
	    imageName: "a2ae5c00-b213-11ea-921f-9db4b33fb426.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fa2ae5c00-b213-11ea-921f-9db4b33fb426.jpg?alt=media&token=0f958146-9d0d-43e9-a07a-d5d2437402f6"
	  }],
	  productNameEnglish: "Fair & Handsome Advanced Whitening Cream - Oil Control",
	  productPrice: "4.20",
	  productSupplier: "BCS SHOP",
	  searchText: "ফেইস ক্রিম",
	  sortOrder: "x",
	  sourceSupplier: "MUSTAFA CENTRE",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "50G",
	  updateDateTime: "03/08/2020 04:34:26"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-MA-stIMYdnOFUC6-HLs",
	  photos: [{
	    imageName: "aa6a0610-c0ff-11ea-8470-83fbeadd4a74.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Faa6a0610-c0ff-11ea-8470-83fbeadd4a74.jpg?alt=media&token=034120b7-cba3-4703-a626-c8c8c4ec2234"
	  }],
	  productNameEnglish: "RADHUNI GARAM MASALA POWDER ",
	  productPrice: "2.20",
	  productSupplier: "BCS SHOP",
	  searchText: "গরম মশলা ",
	  sortOrder: "a",
	  sourceSupplier: "RAJDHANI ENTERPRISE PTE LTD",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "80g",
	  updateDateTime: "Tue 18-08-20 8:37 am"
	}, {
	  category: "COSMETICS",
	  isPopular: "YES",
	  key: "-MA-sRL3qefgUMb_UOtv",
	  photos: [{
	    imageName: "1a2d7c20-b214-11ea-921f-9db4b33fb426.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F1a2d7c20-b214-11ea-921f-9db4b33fb426.jpg?alt=media&token=4e348ad6-5cfa-47ed-82bb-f1c7a4ef338c"
	  }],
	  productNameEnglish: "Fair and Handsome Advanced Whitening Cream",
	  productPrice: "4.20",
	  productSupplier: "BCS SHOP",
	  searchText: "fair & handsome ফেইস ক্রিম",
	  sortOrder: "x",
	  sourceSupplier: "MUSTAFA CENTRE",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "50G",
	  updateDateTime: "17/07/2020 06:32:49"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-MA-s21eYOIHIgZgZ47u",
	  photos: [{
	    imageName: "01912890-f7d0-11ea-9ca4-275d4c37dc1b.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F01912890-f7d0-11ea-9ca4-275d4c37dc1b.jpg?alt=media&token=f0c6568d-56df-442a-b030-aca55b7ae8e9"
	  }],
	  productNameEnglish: "PRAN Garam Masala",
	  productPrice: "3.50",
	  productSupplier: "BCS SHOP",
	  searchText: "গরম মসলা ",
	  sortOrder: "a",
	  sourceSupplier: "KHAN PRODUCTS PTE LTD.",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "130g",
	  updateDateTime: "Wed 16-09-20 11:54 am"
	}, {
	  category: "SNACKS DRY FOOD",
	  key: "-MA-rg5hNW3ZbRV3v9Jv",
	  photos: [{
	    imageName: "800199a0-b214-11ea-921f-9db4b33fb426.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F800199a0-b214-11ea-921f-9db4b33fb426.jpg?alt=media&token=45477024-02fe-4447-878c-a490d9940512"
	  }],
	  productNameEnglish: "Calbee Prawn Crackers ",
	  productPrice: "2.70",
	  productSupplier: "BCS SHOP",
	  sortOrder: "h",
	  sourceSupplier: "Sheng siong ",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "150G",
	  updateDateTime: "17/07/2020 06:33:45"
	}, {
	  category: "SNACKS DRY FOOD",
	  key: "-MA-qrE1HieKjeQuTrEM",
	  photos: [{
	    imageName: "d4390c60-b214-11ea-921f-9db4b33fb426.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fd4390c60-b214-11ea-921f-9db4b33fb426.jpg?alt=media&token=4f51f18a-ead2-4643-8f80-e28608e94849"
	  }],
	  productNameEnglish: "Roller Coaster Potato Rings Cheese",
	  productPrice: "2.20",
	  productSupplier: "BCS SHOP",
	  sortOrder: "h",
	  sourceSupplier: "Sheng siong ",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "100g",
	  updateDateTime: "04/07/2020 08:18:51"
	}, {
	  category: "RICE DAAL NOODLES",
	  isPopular: "YES",
	  key: "-MA-qjY8tZLSruvj_oBv",
	  photos: [{
	    imageName: "6201d390-b05f-11ea-8357-d5a4954c59fc.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F6201d390-b05f-11ea-8357-d5a4954c59fc.jpg?alt=media&token=75707566-396b-4928-bd91-e700686d6a6f"
	  }],
	  productNameEnglish: "PRAN Chinigura Aromatic Rice",
	  productPrice: "4.50",
	  productSupplier: "BCS SHOP",
	  searchText: "পুলাওর চাউল ",
	  sortOrder: "a",
	  sourceSupplier: "AYSHA SUPERMARKET PTE LTD",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1Kg",
	  updateDateTime: "03/08/2020 04:35:31"
	}, {
	  category: "SNACKS DRY FOOD",
	  key: "-MA-qJBBcd7sXZTc9zt_",
	  photos: [{
	    imageName: "e9800500-b215-11ea-921f-9db4b33fb426.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fe9800500-b215-11ea-921f-9db4b33fb426.jpg?alt=media&token=36ba7acc-839f-40ff-b993-be707f5ea6fb"
	  }],
	  productNameEnglish: "Pringles Sour Cream & Onion Potato Chips ",
	  productPrice: "2.70",
	  productSupplier: "BCS SHOP",
	  sortOrder: "h",
	  sourceSupplier: "Sheng siong ",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "147G",
	  updateDateTime: "03/08/2020 04:36:37"
	}, {
	  category: "SNACKS DRY FOOD",
	  key: "-MA-ozuXRBn4GTx3Mhpe",
	  photos: [{
	    imageName: "2dac4270-b216-11ea-921f-9db4b33fb426.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F2dac4270-b216-11ea-921f-9db4b33fb426.jpg?alt=media&token=e0e21e43-159a-49b0-a77b-9312df500800"
	  }],
	  productNameEnglish: "Pringles Original Potato Chips",
	  productPrice: "2.70",
	  productSupplier: "BCS SHOP",
	  sortOrder: "h",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "147G",
	  updateDateTime: "03/08/2020 04:37:00"
	}, {
	  availability: "AVAILABLE",
	  category: "SNACKS DRY FOOD",
	  isPopular: "YES",
	  key: "-MA-oxGQ_WnEFDAPleoG",
	  photos: [{
	    imageName: "5e3f1ac0-b216-11ea-921f-9db4b33fb426.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F5e3f1ac0-b216-11ea-921f-9db4b33fb426.jpg?alt=media&token=c75ffd76-551e-448c-b3bd-a8bab4d76e16"
	  }],
	  productNameEnglish: "PRAN Special Toast Biscuit ",
	  productPrice: "2",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  sourceSupplier: "TERRY TRADING CO PTE LTD",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "350g",
	  updateDateTime: "03/08/2020 04:38:34"
	}, {
	  availability: "OUT OF STOCK, TOPPING UP IN PROGRESS",
	  category: "DRINKS DESSERT",
	  isPopular: "YES",
	  key: "-MA-oFKOeZeM-mQuLaZ3",
	  photos: [{
	    imageName: "518409f0-c100-11ea-8470-83fbeadd4a74.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F518409f0-c100-11ea-8470-83fbeadd4a74.jpg?alt=media&token=fd0b2094-6d22-4412-b912-9bbf77e8da93"
	  }],
	  productNameEnglish: "Lachcha Shemai",
	  productPrice: "1.50",
	  productSupplier: "BCS SHOP",
	  searchText: "লাচ্ছা সেমাই ",
	  sortOrder: "a",
	  sourceSupplier: "TRISHA EXPORT & IMPORT PTE LTD MINIMART",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "125g Packet",
	  updateDateTime: "Wed 16-09-20 11:38 am"
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-MA-nsPshOgTcNls80ZJ",
	  photos: [{
	    imageName: "825e7b50-bc5a-11ea-b7df-33e703b87300.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F825e7b50-bc5a-11ea-b7df-33e703b87300.jpg?alt=media&token=3fc67247-a966-491d-8450-8be463c7ca4b"
	  }],
	  productNameEnglish: "Pears",
	  productPrice: "3.95",
	  productSupplier: "BCS SHOP",
	  searchText: "ফল ",
	  sortOrder: "a",
	  sourceSupplier: "Sheng siong ",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "4pcs",
	  updateDateTime: "03/08/2020 04:39:26"
	}, {
	  availability: "AVAILABLE",
	  category: "EGGS DAIRY",
	  isPopular: "YES",
	  key: "-MA-ktuqryWbJ1oNe27B",
	  photos: [{
	    imageName: "cab1b550-b216-11ea-921f-9db4b33fb426.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fcab1b550-b216-11ea-921f-9db4b33fb426.jpg?alt=media&token=82c4d1d3-fc45-4b34-8ba7-2f3986be66e8"
	  }],
	  productNameEnglish: "Meiji Fresh Milk - Fullcream",
	  productPrice: "3.8",
	  productSupplier: "BCS SHOP",
	  searchText: "fresh milk দুধ গরুর দুধ",
	  sortOrder: "a",
	  sourceSupplier: "Sheng siong ",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "830ml",
	  updateDateTime: "03/08/2020 04:40:15"
	}, {
	  availability: "AVAILABLE",
	  category: "SNACKS DRY FOOD",
	  isPopular: "YES",
	  key: "-MA-kPUXlw_fuYi26H_Z",
	  photos: [{
	    imageName: "7ae9a1b0-bb79-11ea-9bec-f98d55a4d196.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F7ae9a1b0-bb79-11ea-9bec-f98d55a4d196.jpg?alt=media&token=07e55a5f-06fe-4b12-8cf2-52100c798bac"
	  }],
	  productNameEnglish: "PRAN Hot Chanachur - Bombay Mix",
	  productPrice: "2",
	  productSupplier: "BCS SHOP",
	  searchText: "চানাচুর ",
	  sortOrder: "a",
	  sourceSupplier: "RAJDHANI ENTERPRISE PTE LTD",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "300gm",
	  updateDateTime: "03/08/2020 04:40:42"
	}, {
	  availability: "AVAILABLE",
	  category: "EGGS DAIRY",
	  isPopular: "YES",
	  key: "-MA-kMYufmGnT6XGDUuI",
	  photos: [{
	    imageName: "bdea5130-bc5a-11ea-b7df-33e703b87300.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fbdea5130-bc5a-11ea-b7df-33e703b87300.jpg?alt=media&token=f0c580f0-f44b-4340-8622-95a8c448576d"
	  }],
	  productNameEnglish: "Meiji Chocolate Fresh Milk - Fullcream",
	  productPrice: "6.50",
	  productSupplier: "BCS SHOP",
	  searchText: "চকলেট দুধ ",
	  sortOrder: "a",
	  sourceSupplier: "Sheng siong ",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "2L",
	  updateDateTime: "03/08/2020 04:41:31"
	}, {
	  availability: "AVAILABLE",
	  category: "SNACKS DRY FOOD",
	  isPopular: "YES",
	  key: "-MA-jxAY58AOBdeov11V",
	  photos: [{
	    imageName: "49158100-b05b-11ea-8357-d5a4954c59fc.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F49158100-b05b-11ea-8357-d5a4954c59fc.jpg?alt=media&token=e3a9b308-dd01-4615-88c2-df10f1c61547"
	  }],
	  productNameEnglish: "PRAN Hot Chanachur ",
	  productPrice: "0.90",
	  productSupplier: "BCS SHOP",
	  searchText: "চানাচুর ",
	  sortOrder: "a",
	  sourceSupplier: "KHAN PRODUCTS PTE LTD.",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "150G",
	  updateDateTime: "03/08/2020 04:42:40"
	}, {
	  availability: "AVAILABLE",
	  category: "SANITARY",
	  isPopular: "NO",
	  key: "-MA-j9aKGGE3T3ChzTIC",
	  photos: [{
	    imageName: "0fedf400-bc5b-11ea-b7df-33e703b87300.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F0fedf400-bc5b-11ea-b7df-33e703b87300.jpg?alt=media&token=e830a52d-703a-48fa-b45a-5375a2757a05"
	  }],
	  productNameEnglish: "Shieldtox All Insect Killer Spray - Powergard",
	  productPrice: "4.20",
	  productSupplier: "BCS SHOP",
	  sortOrder: "o",
	  sourceSupplier: "MUSTAFA CENTRE",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "270ml",
	  updateDateTime: "03/08/2020 04:44:15"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-MA-h-OaWhiWRfI_qBp3",
	  photos: [{
	    imageName: "7ff8ef60-b059-11ea-8357-d5a4954c59fc.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F7ff8ef60-b059-11ea-8357-d5a4954c59fc.jpg?alt=media&token=e7a607ef-2500-4107-95d0-2dd6284fd2f9"
	  }],
	  productNameEnglish: "PRAN Chicken Masala Powder",
	  productPrice: "3.50",
	  productSupplier: "BCS SHOP",
	  searchText: "চিকেন কারি মসলা ",
	  sortOrder: "c",
	  sourceSupplier: "GAZIPUR TRADING PTE LTD ",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "100G",
	  updateDateTime: "03/08/2020 04:45:00"
	}, {
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-MA-gbxP3URtD4qfXJQ3",
	  photos: [{
	    imageName: "3d7f9210-b059-11ea-8357-d5a4954c59fc.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F3d7f9210-b059-11ea-8357-d5a4954c59fc.jpg?alt=media&token=99eaa607-195e-4d6c-a4d5-6db3773047b7"
	  }],
	  productNameEnglish: "PRAN Chicken Roast Masala Powder",
	  productPrice: "2.90",
	  productSupplier: "BCS SHOP",
	  searchText: "চিকেন রোস্ট মসলা",
	  sortOrder: "c",
	  sourceSupplier: "TERRY TRADING CO PTE LTD",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "35G",
	  updateDateTime: "03/08/2020 04:45:29"
	}, {
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-MA-g4mB6i2gHoEZaH7m",
	  photos: [{
	    imageName: "e756d6a0-b058-11ea-8357-d5a4954c59fc.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fe756d6a0-b058-11ea-8357-d5a4954c59fc.jpg?alt=media&token=5344fca6-91cb-4a2d-bea4-0016d2e08a3e"
	  }],
	  productNameEnglish: "PRAN Kacchi Biryani Masala",
	  productPrice: "3.80",
	  productSupplier: "BCS SHOP",
	  searchText: "বিরানি মসলা",
	  sortOrder: "c",
	  sourceSupplier: "RAJDHANI ENTERPRISE PTE LTD",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "45G",
	  updateDateTime: "03/08/2020 04:46:37"
	}, {
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-MA-faWokfFjVRxskzQs",
	  photos: [{
	    imageName: "a4296b90-b058-11ea-8357-d5a4954c59fc.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fa4296b90-b058-11ea-8357-d5a4954c59fc.jpg?alt=media&token=493121d9-37b6-4122-97cc-0e1d7270aa20"
	  }],
	  productNameEnglish: "PRAN Tehari Masala",
	  productPrice: "3.90",
	  productSupplier: "BCS SHOP",
	  searchText: "তেহারি মসলা",
	  sortOrder: "c",
	  sourceSupplier: "RAJDHANI ENTERPRISE PTE LTD",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "50G",
	  updateDateTime: "03/08/2020 04:47:09"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-MA-ezon2ica-wzQF-W3",
	  photos: [{
	    imageName: "3f8605e0-b058-11ea-8357-d5a4954c59fc.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F3f8605e0-b058-11ea-8357-d5a4954c59fc.jpg?alt=media&token=b4dce7b3-dde8-4b0a-b68b-6b9972aae93d"
	  }],
	  productNameEnglish: "PRAN Achari Meat Masala",
	  productPrice: "3.80",
	  productSupplier: "BCS SHOP",
	  searchText: "মাংস মসলা",
	  sortOrder: "c",
	  sourceSupplier: "KHAN PRODUCTS PTE LTD.",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "50G",
	  updateDateTime: "03/08/2020 04:47:44"
	}, {
	  category: "SANITARY",
	  isPopular: "NO",
	  key: "-MA-M8grf86PwIyJuEwn",
	  photos: [{
	    imageName: "aeedbf70-b217-11ea-921f-9db4b33fb426.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Faeedbf70-b217-11ea-921f-9db4b33fb426.jpg?alt=media&token=5fb50fd0-38ab-4b10-a503-69f2f7dbdf61"
	  }],
	  productNameEnglish: "Baygon Anti Dengue Mosquito Killer ",
	  productPrice: "6.20",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  sourceSupplier: "MUSTAFA CENTRE",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "600ML",
	  updateDateTime: "03/08/2020 04:48:52"
	}, {
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-MA-JybhhoZnd2xV63lY",
	  photos: [{
	    imageName: "cea1f350-b04a-11ea-9737-25db4b55bc7b.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fcea1f350-b04a-11ea-9737-25db4b55bc7b.jpg?alt=media&token=681ee9ef-0064-4948-9650-ab9f11d7211c"
	  }],
	  productNameEnglish: "PRAN Haleem Masala Mix",
	  productPrice: "3.90",
	  productSupplier: "BCS SHOP",
	  searchText: "হালীম মিক্স ",
	  sortOrder: "a",
	  sourceSupplier: "RAJDHANI ENTERPRISE PTE LTD",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "200G",
	  updateDateTime: "03/08/2020 04:49:29"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-MA-It9HDOROv_SNe7k_",
	  photos: [{
	    imageName: "1d4d86f0-b04a-11ea-9737-25db4b55bc7b.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F1d4d86f0-b04a-11ea-9737-25db4b55bc7b.jpg?alt=media&token=de924614-3b30-47ca-a9d8-ea68d9a22572"
	  }],
	  productNameEnglish: "PRAN Chicken Tikka Masala",
	  productPrice: "3.70",
	  productSupplier: "BCS SHOP",
	  searchText: "চিকেন টিক্কা মসলা ",
	  sortOrder: "a",
	  sourceSupplier: "TERRY TRADING CO PTE LTD",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "50G",
	  updateDateTime: "03/08/2020 04:49:56"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-MA-INBhfRZ_Ufq7sGye",
	  photos: [{
	    imageName: "d91ba430-b049-11ea-9737-25db4b55bc7b.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fd91ba430-b049-11ea-9737-25db4b55bc7b.jpg?alt=media&token=f58486ae-0eb0-4b0a-8280-3013d3695dbf"
	  }],
	  productNameEnglish: "PRAN Bbq Masala",
	  productPrice: "3.60",
	  productSupplier: "BCS SHOP",
	  searchText: "BBQ মসলা ",
	  sortOrder: "a",
	  sourceSupplier: "KHAN PRODUCTS PTE LTD.",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "50G",
	  updateDateTime: "03/08/2020 04:50:20"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-MA-HwsBZXu5J459CxaK",
	  photos: [{
	    imageName: "978bbc80-b049-11ea-9737-25db4b55bc7b.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F978bbc80-b049-11ea-9737-25db4b55bc7b.jpg?alt=media&token=c15d7f86-7648-49ac-a6f4-677cb741606f"
	  }],
	  productNameEnglish: "PRAN Duck Masala",
	  productPrice: "3.50",
	  productSupplier: "BCS SHOP",
	  searchText: "হাঁসের মসলা ",
	  sortOrder: "a",
	  sourceSupplier: "RAJDHANI ENTERPRISE PTE LTD",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "60gm",
	  updateDateTime: "03/08/2020 04:50:39"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-MA-HPrZgnI3W4ygoyv-",
	  photos: [{
	    imageName: "422b3310-b049-11ea-9737-25db4b55bc7b.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F422b3310-b049-11ea-9737-25db4b55bc7b.jpg?alt=media&token=db1d4ae7-2a5e-4164-beb4-1151e24ac62e"
	  }],
	  productNameEnglish: "RADHUNI Kacchi Biryani Masala",
	  productPrice: "3.50",
	  productSupplier: "BCS SHOP",
	  searchText: "খিচুড়ি মসলা",
	  sortOrder: "a",
	  sourceSupplier: "KHAN PRODUCTS PTE LTD.",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "40g",
	  updateDateTime: "03/08/2020 04:51:31"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-MA-Gj6E5dx9nQhb3Ce_",
	  photos: [{
	    imageName: "f56d3bb0-b217-11ea-921f-9db4b33fb426.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Ff56d3bb0-b217-11ea-921f-9db4b33fb426.jpg?alt=media&token=29bc3bcc-2d37-4edd-8a7c-cc4c78f8e1d8"
	  }],
	  productNameEnglish: "RADHUNI Kala Vuna Masala",
	  productPrice: "3.50",
	  productSupplier: "BCS SHOP",
	  searchText: "কালা ভুনা মসলা ",
	  sortOrder: "a",
	  sourceSupplier: "RAJDHANI ENTERPRISE PTE LTD",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "80g",
	  updateDateTime: "03/08/2020 04:52:05"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-MA-GH3pI33QqQoQ86-Q",
	  photos: [{
	    imageName: "8866e500-b048-11ea-9737-25db4b55bc7b.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F8866e500-b048-11ea-9737-25db4b55bc7b.jpg?alt=media&token=e6160326-73a3-43f1-948b-70143fcb7c14"
	  }],
	  productNameEnglish: "RADHUNI Hyderabadi Biryani Masala ",
	  productPrice: "3.50",
	  productSupplier: "BCS SHOP",
	  searchText: "হায়দরাবাদি বিরানী মসলা",
	  sortOrder: "a",
	  sourceSupplier: "KHAN PRODUCTS PTE LTD.",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "40g",
	  updateDateTime: "03/08/2020 04:53:13"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-MA-FDxT3W7EN2Xf9xNn",
	  photos: [{
	    imageName: "dfc09bd0-b047-11ea-9737-25db4b55bc7b.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fdfc09bd0-b047-11ea-9737-25db4b55bc7b.jpg?alt=media&token=7d962d31-6b99-4c5b-8f25-b0b8edd83e2f"
	  }],
	  productNameEnglish: "RADHUNI Fish Curry Masala",
	  productPrice: "3.50",
	  productSupplier: "BCS SHOP",
	  searchText: "মাছের মসলা",
	  sortOrder: "a",
	  sourceSupplier: "FAHIM ENTERPRISE PTE LTD",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "100G",
	  updateDateTime: "03/08/2020 04:53:41"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-MA-EUUCDoHoerBWyGXD",
	  photos: [{
	    imageName: "575b0190-b047-11ea-9737-25db4b55bc7b.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F575b0190-b047-11ea-9737-25db4b55bc7b.jpg?alt=media&token=f5e170aa-ba5d-4d33-aa9a-70c6627dff4e"
	  }],
	  productNameEnglish: "RADHUNI Beef Masala",
	  productPrice: "3.50",
	  productSupplier: "BCS SHOP",
	  searchText: "গরুর মাংস মসলা",
	  sortOrder: "a",
	  sourceSupplier: "KHAN PRODUCTS PTE LTD.",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "68G",
	  updateDateTime: "03/08/2020 04:54:49"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-MA-Dnh-n931gdIbkaF9",
	  photos: [{
	    imageName: "01e6f020-b047-11ea-9737-25db4b55bc7b.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F01e6f020-b047-11ea-9737-25db4b55bc7b.jpg?alt=media&token=8e0626a6-ffbf-4565-b402-ecc9a5403ead"
	  }],
	  productNameEnglish: "RADHUNI Meat Masala",
	  productPrice: "3.50",
	  productSupplier: "BCS SHOP",
	  searchText: "খাসির মাংস মসলা ",
	  sortOrder: "a",
	  sourceSupplier: "KHAN PRODUCTS PTE LTD.",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "20G",
	  updateDateTime: "03/08/2020 04:57:52"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-MA-DAJ7J3Q4gm8p6wKi",
	  photos: [{
	    imageName: "9c1606f0-b046-11ea-9737-25db4b55bc7b.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F9c1606f0-b046-11ea-9737-25db4b55bc7b.jpg?alt=media&token=a1c6f9d6-7e57-4f6a-92d2-541d9b842aed"
	  }],
	  productNameEnglish: "RADHUNI Chicken Roast Masala",
	  productPrice: "3",
	  productSupplier: "BCS SHOP",
	  searchText: "রোস্ট মসলা",
	  sortOrder: "a",
	  sourceSupplier: "FAHIM ENTERPRISE PTE LTD",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "35G",
	  updateDateTime: "03/08/2020 04:55:51"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-MA-CZjNP6303XAWLm3m",
	  photos: [{
	    imageName: "48f81a80-b046-11ea-9737-25db4b55bc7b.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F48f81a80-b046-11ea-9737-25db4b55bc7b.jpg?alt=media&token=8c0b64c1-d561-41b4-8682-1c1d3e49861b"
	  }],
	  productNameEnglish: "RADHUNI Chicken Masala",
	  productPrice: "2.90",
	  productSupplier: "BCS SHOP",
	  searchText: "চিকেন কারি মসলা ",
	  sortOrder: "a",
	  sourceSupplier: "RAJDHANI ENTERPRISE PTE LTD",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "20G",
	  updateDateTime: "03/08/2020 04:56:19"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-MA-C1A-sCAahqoQPvZV",
	  photos: [{
	    imageName: "f1445240-b045-11ea-9737-25db4b55bc7b.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Ff1445240-b045-11ea-9737-25db4b55bc7b.jpg?alt=media&token=b82d5e26-9d1e-4b5d-acdf-6892445078c1"
	  }],
	  productNameEnglish: "RADHUNI Meat Masala",
	  productPrice: "3.50",
	  productSupplier: "BCS SHOP",
	  searchText: "গরুর মাংস মসলা",
	  sortOrder: "a",
	  sourceSupplier: "KHAN PRODUCTS PTE LTD.",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "100G",
	  updateDateTime: "03/08/2020 04:58:05"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-MA-9IAFBBje9z79nxB8",
	  photos: [{
	    imageName: "353127a0-b044-11ea-9737-25db4b55bc7b.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F353127a0-b044-11ea-9737-25db4b55bc7b.jpg?alt=media&token=2e1ad4c8-b1d9-49af-8a3f-39eecb2c5a8a"
	  }],
	  productNameEnglish: "PRAN Chatpati Spice Mix Masala ",
	  productPrice: "3.50",
	  productSupplier: "BCS SHOP",
	  searchText: "চাপাতি মিক্স মসলা ",
	  sortOrder: "a",
	  sourceSupplier: "N K AMMAN PTE LTD",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "100G",
	  updateDateTime: "03/08/2020 04:58:41"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-MA-7PuCo27M4_HwIP5M",
	  photos: [{
	    imageName: "2424f280-b043-11ea-9737-25db4b55bc7b.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F2424f280-b043-11ea-9737-25db4b55bc7b.jpg?alt=media&token=f288d76c-3662-4c3b-a543-9c60a51ff848"
	  }],
	  productNameEnglish: "PRAN Biryani Masala",
	  productPrice: "3.50",
	  productSupplier: "BCS SHOP",
	  searchText: "বিরানী মসলা",
	  sortOrder: "a",
	  sourceSupplier: "TERRY TRADING CO PTE LTD",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "40G",
	  updateDateTime: "03/08/2020 04:59:03"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-MA-4o4Bq8366luSWQfN",
	  photos: [{
	    imageName: "48ce3da0-b041-11ea-9737-25db4b55bc7b.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F48ce3da0-b041-11ea-9737-25db4b55bc7b.jpg?alt=media&token=c34dcb2b-a64d-44ee-b72f-471880e904e4"
	  }],
	  productNameEnglish: "PRAN Meat Masala ",
	  productPrice: "3.50",
	  productSupplier: "BCS SHOP",
	  searchText: "মাংস মসলা",
	  sortOrder: "a",
	  sourceSupplier: "MUSTAFA CENTRE",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "100g",
	  updateDateTime: "03/08/2020 04:59:21"
	}, {
	  category: "MEAT FISH",
	  isPopular: "YES",
	  key: "-MA-081YlnomuMShqhCU",
	  photos: [{
	    imageName: "b2e7ad50-b03e-11ea-9737-25db4b55bc7b.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fb2e7ad50-b03e-11ea-9737-25db4b55bc7b.jpg?alt=media&token=a3257c88-e921-4c8d-8c84-7b8ba4eb1f30"
	  }],
	  productNameEnglish: "Tilapia ",
	  productPrice: "6",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  sourceSupplier: "AYSHA SUPERMARKET PTE LTD",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1KG",
	  updateDateTime: "03/08/2020 05:00:12"
	}, {
	  category: "MEAT FISH",
	  isPopular: "YES",
	  key: "-MA--py-a2EMdns3ljY1",
	  photos: [{
	    imageName: "7ed87f80-b03e-11ea-9737-25db4b55bc7b.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F7ed87f80-b03e-11ea-9737-25db4b55bc7b.jpg?alt=media&token=9dbd3be0-3355-4d02-83eb-1b29764ce67b"
	  }],
	  productNameEnglish: "Anabas Testudineus",
	  productPrice: "12",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  sourceSupplier: "KHAN PRODUCTS PTE LTD.",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1KG",
	  updateDateTime: "03/08/2020 05:20:31"
	}, {
	  category: "MEAT FISH",
	  isPopular: "YES",
	  key: "-MA--EcLlJD8siFnyC5a",
	  photos: [{
	    imageName: "1a588050-b03e-11ea-9737-25db4b55bc7b.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F1a588050-b03e-11ea-9737-25db4b55bc7b.jpg?alt=media&token=35e46cda-8e33-4ea6-ba14-621032a29a0e"
	  }],
	  productNameEnglish: "Silver Carp",
	  productPrice: "6",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  sourceSupplier: "TERRY TRADING CO PTE LTD",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1KG",
	  updateDateTime: "03/08/2020 05:20:09"
	}, {
	  category: "MEAT FISH",
	  isPopular: "YES",
	  key: "-M9zzmXCYPD7EUwz7pRI",
	  photos: [{
	    imageName: "8f6a0e30-c5bb-11ea-8edb-cd6b1542138d.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F8f6a0e30-c5bb-11ea-8edb-cd6b1542138d.jpg?alt=media&token=48e71bcf-2931-464f-b488-ba579dba1e9a"
	  }],
	  productDescription: "Price not stable  $13~$23.",
	  productNameEnglish: "Silver Pomfret",
	  productPrice: "15",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  sourceSupplier: "RAJDHANI ENTERPRISE PTE LTD",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1KG",
	  updateDateTime: "03/08/2020 05:19:59"
	}, {
	  category: "MEAT FISH",
	  isPopular: "YES",
	  key: "-M9zz8Y5c7-PpsTsEobK",
	  photos: [{
	    imageName: "0d5bd5e0-c5bb-11ea-8edb-cd6b1542138d.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F0d5bd5e0-c5bb-11ea-8edb-cd6b1542138d.jpg?alt=media&token=36469c2b-0749-41a0-ae7a-26f5fca51c98"
	  }],
	  productNameEnglish: "Catfish",
	  productPrice: "7",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  sourceSupplier: "AYSHA SUPERMARKET PTE LTD",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1KG",
	  updateDateTime: "03/08/2020 05:19:27"
	}, {
	  category: "MEAT FISH",
	  isPopular: "YES",
	  key: "-M9zyaGEkwWHN4gqOv1u",
	  photos: [{
	    imageName: "375432e0-b03d-11ea-9737-25db4b55bc7b.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F375432e0-b03d-11ea-9737-25db4b55bc7b.jpg?alt=media&token=4411a332-092b-42e5-ac8f-e1d8eba8890e"
	  }],
	  productNameEnglish: "Mrigal Carp",
	  productPrice: "6",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  sourceSupplier: "RAJDHANI ENTERPRISE PTE LTD",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1KG",
	  updateDateTime: "03/08/2020 05:19:16"
	}, {
	  category: "MEAT FISH",
	  isPopular: "YES",
	  key: "-M9zxx8mwFMeson_IRkz",
	  photos: [{
	    imageName: "d1e6c670-b03c-11ea-9737-25db4b55bc7b.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fd1e6c670-b03c-11ea-9737-25db4b55bc7b.jpg?alt=media&token=9c8f5020-1867-4b38-8fa7-597e616207f2"
	  }],
	  productNameEnglish: "Catla Fish",
	  productPrice: "5.50",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  sourceSupplier: "AYSHA SUPERMARKET PTE LTD",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1KG",
	  updateDateTime: "03/08/2020 05:23:26"
	}, {
	  availability: "AVAILABLE",
	  category: "MEAT FISH",
	  isPopular: "YES",
	  key: "-M9zxNO5xPdfu9fs1xXG",
	  photos: [{
	    imageName: "28148060-b03c-11ea-9737-25db4b55bc7b.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F28148060-b03c-11ea-9737-25db4b55bc7b.jpg?alt=media&token=b78474e7-b834-42be-8761-59103a522186"
	  }],
	  productNameEnglish: "Rohu Fish",
	  productPrice: "5.50",
	  productSupplier: "BCS SHOP",
	  searchText: "রুই মাছ ",
	  sortOrder: "a",
	  sourceSupplier: "AYSHA SUPERMARKET PTE LTD",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1KG",
	  updateDateTime: "03/08/2020 05:19:02"
	}, {
	  category: "OTHERS",
	  isPopular: "NO",
	  key: "-M9zwAVIufjGNJ2m7IUt",
	  photos: [{
	    imageName: "82bd6170-b218-11ea-921f-9db4b33fb426.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F82bd6170-b218-11ea-921f-9db4b33fb426.jpg?alt=media&token=20e6374b-f03c-4e20-96d8-1f026d7ef3f5"
	  }],
	  productNameEnglish: "Baygon Cockroach Killer",
	  productPrice: "7.8",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  sourceSupplier: "U STARS SUPERMARKET  ",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "500ml",
	  updateDateTime: "04/07/2020 08:54:11"
	}, {
	  availability: "AVAILABLE",
	  category: "MEAT FISH",
	  isPopular: "YES",
	  key: "-M9zpdyjH06nAqwc_-f7",
	  photos: [{
	    imageName: "be0749e0-b037-11ea-9e6b-fd3fc5d44f8f.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fbe0749e0-b037-11ea-9e6b-fd3fc5d44f8f.jpg?alt=media&token=33798c90-e1ae-418d-a0e5-22033d0d0584"
	  }],
	  productDescription: "3 pcs is 1kg",
	  productNameEnglish: "Ilish Fish - Small ",
	  productPrice: "4",
	  productSupplier: "BCS SHOP",
	  searchText: "ilish elish elis ilis ইলিশ ",
	  sortOrder: "a",
	  sourceSupplier: "TERRY TRADING CO PTE LTD",
	  supplierContactName: "arif",
	  supplierContactPhone: "84124637",
	  unit: "1 PC",
	  updateDateTime: "03/08/2020 05:23:58"
	}, {
	  category: "MEAT FISH",
	  isPopular: "YES",
	  key: "-M9zp2dHatratHCAkQ7R",
	  photos: [{
	    imageName: "6448bd80-b037-11ea-9e6b-fd3fc5d44f8f.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F6448bd80-b037-11ea-9e6b-fd3fc5d44f8f.jpg?alt=media&token=5c22ec8a-4c8c-4e1f-be8f-b627ac0b6929"
	  }],
	  productDescription: "1pic 600G to 900G.",
	  productNameEnglish: "Ilish Fish - Medium",
	  productPrice: "25",
	  productSupplier: "BCS SHOP",
	  searchText: "ilish elis elish hisla ইলিশ ",
	  sortOrder: "a",
	  sourceSupplier: "TERRY TRADING CO PTE LTD",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1kg",
	  updateDateTime: "03/08/2020 05:24:13"
	}, {
	  category: "MEAT FISH",
	  isPopular: "YES",
	  key: "-M9znavrxvUDOHWhLi0C",
	  photos: [{
	    imageName: "80f4a260-b036-11ea-9e6b-fd3fc5d44f8f.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F80f4a260-b036-11ea-9e6b-fd3fc5d44f8f.jpg?alt=media&token=fe5cdec9-0d8a-47a6-851c-1a6933987683"
	  }],
	  productDescription: "1pcs is 900gm to 1.5kg",
	  productNameEnglish: "Ilish Fish - Large",
	  productPrice: "30",
	  productSupplier: "BCS SHOP",
	  searchText: "elish ilis elis isish fish ইলিশ ",
	  sortOrder: "a",
	  sourceSupplier: "TERRY TRADING CO PTE LTD",
	  supplierContactName: "arif",
	  supplierContactPhone: "84124637",
	  unit: "1KG ",
	  updateDateTime: "03/08/2020 05:24:38"
	}, {
	  availability: "AVAILABLE",
	  category: "STATIONARY",
	  key: "-M9r0vyZWYjgx51_jeZB",
	  photos: [{
	    imageName: "82f26a70-c5bc-11ea-8edb-cd6b1542138d.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F82f26a70-c5bc-11ea-8edb-cd6b1542138d.jpg?alt=media&token=054dbe95-0350-49ec-9574-1731bec98186"
	  }],
	  productNameEnglish: "Paint Marker Pen - Oil Based ",
	  productPrice: "4.20",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  sourceSupplier: "MUSTAFA CENTRE",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1 Pen",
	  updateDateTime: "03/08/2020 05:32:03"
	}, {
	  category: "TOILETRIES",
	  key: "-M9r-cDBn4vIQlIH5Wh_",
	  photos: [{
	    imageName: "e08affc0-aede-11ea-9cc0-814fbb741388.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fe08affc0-aede-11ea-9cc0-814fbb741388.jpg?alt=media&token=e019ddee-9a47-4bcf-8cf1-e01dd2371534"
	  }],
	  productNameEnglish: "Dettol Antiseptic Germicide",
	  productPrice: "12.55",
	  productSupplier: "BCS SHOP",
	  sortOrder: "k",
	  sourceSupplier: "MUSTAFA CENTRE",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1L",
	  updateDateTime: "03/08/2020 05:32:51"
	}, {
	  category: "LAUNDRY CLEANING",
	  key: "-M9qyfPncL2HNkF4VWWI",
	  photos: [{
	    imageName: "afbee470-aedd-11ea-9cc0-814fbb741388.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fafbee470-aedd-11ea-9cc0-814fbb741388.jpg?alt=media&token=9c7e862f-ced5-4b11-8347-8cf3207602fd"
	  }],
	  productNameEnglish: "Comfort Fabric Conditioner",
	  productPrice: "8.85",
	  productSupplier: "BCS SHOP",
	  sortOrder: "k",
	  sourceSupplier: "MUSTAFA CENTRE",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "5L",
	  updateDateTime: "03/08/2020 05:33:27"
	}, {
	  category: "STATIONARY",
	  isPopular: "NO",
	  key: "-M9qxlJlSduEAkgi-FoD",
	  photos: [{
	    imageName: "194fd850-aedd-11ea-9b4b-4bd8d539c6a6.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F194fd850-aedd-11ea-9b4b-4bd8d539c6a6.jpg?alt=media&token=6322dafb-96e7-4815-b563-68c5b2bbc548"
	  }],
	  productNameEnglish: "Marker pen ",
	  productPrice: "1.5",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  sourceSupplier: "MUSTAFA CENTRE",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1 Pen",
	  updateDateTime: "04/07/2020 08:56:19"
	}, {
	  category: "LAUNDRY CLEANING",
	  key: "-M9qxg-sJGT7FAOFX_OD",
	  photos: [{
	    imageName: "162e25f0-aedd-11ea-9cc0-814fbb741388.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F162e25f0-aedd-11ea-9cc0-814fbb741388.jpg?alt=media&token=9bf5666e-2468-4992-9438-fe1f658c2508"
	  }],
	  productNameEnglish: "Comfort Fabric Conditioner - Pure",
	  productPrice: "8.90",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  sourceSupplier: "MUSTAFA CENTRE",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "5L",
	  updateDateTime: "03/08/2020 05:33:51"
	}, {
	  author: "+6589050302",
	  category: "COSMETICS",
	  isPopular: "NO",
	  key: "-M9qx3DztDO4jxgP57j_",
	  photos: [{
	    imageName: "a7b53410-aedc-11ea-9b4b-4bd8d539c6a6.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fa7b53410-aedc-11ea-9b4b-4bd8d539c6a6.jpg?alt=media&token=8e4acb94-2c64-4ae6-9551-d48f8f537fa9"
	  }],
	  productNameEnglish: "Parachute Coconut Hair Oil",
	  productPrice: "3.50",
	  productSupplier: "BCS SHOP",
	  sortOrder: "k",
	  sourceSupplier: "MUSTAFA CENTRE",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "200ML",
	  updateDateTime: "Tue 25-08-20 10:01 am"
	}, {
	  author: "+6589050302",
	  category: "COSMETICS",
	  isPopular: "NO",
	  key: "-M9qwX0kiI-lR8hHtXgf",
	  photos: [{
	    imageName: "43ca48f0-aedc-11ea-9b4b-4bd8d539c6a6.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F43ca48f0-aedc-11ea-9b4b-4bd8d539c6a6.jpg?alt=media&token=62dffcf9-d577-426e-8455-1d872a352955"
	  }],
	  productNameEnglish: "Parachute Coconut Hair Oil",
	  productPrice: "5.50",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  sourceSupplier: "MUSTAFA CENTRE",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "300ML",
	  updateDateTime: "Tue 25-08-20 10:02 am"
	}, {
	  category: "LAUNDRY CLEANING",
	  key: "-M9qu4ZeksjfvsV26w-H",
	  photos: [{
	    imageName: "e3ab2850-aeda-11ea-9cc0-814fbb741388.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fe3ab2850-aeda-11ea-9cc0-814fbb741388.jpg?alt=media&token=a346739a-63c4-4945-b2d4-f96a4d0bebe8"
	  }],
	  productNameEnglish: "Jackie Drain Easy",
	  productPrice: "13.30",
	  productSupplier: "BCS SHOP",
	  sortOrder: "k",
	  sourceSupplier: "MUSTAFA CENTRE",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1L",
	  updateDateTime: "03/08/2020 05:36:06"
	}, {
	  category: "COSMETICS",
	  key: "-M9qpajgHcqBBlFCHWUH",
	  photos: [{
	    imageName: "af5757c0-aed7-11ea-9b4b-4bd8d539c6a6.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Faf5757c0-aed7-11ea-9b4b-4bd8d539c6a6.jpg?alt=media&token=4a6994d4-afbc-447c-b438-47b7f23a5f37"
	  }],
	  productNameEnglish: "Navratna Ayurvedic Oil ",
	  productPrice: "9",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  sourceSupplier: "MUSTAFA CENTRE",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "200ML",
	  updateDateTime: "03/08/2020 05:39:32"
	}, {
	  category: "COSMETICS",
	  key: "-M9qmo8m2Y8rF36Tbf4W",
	  photos: [{
	    imageName: "41bad8a0-aed6-11ea-a496-7103817df0c1.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F41bad8a0-aed6-11ea-a496-7103817df0c1.jpg?alt=media&token=6b66c4d5-23da-47ca-a35a-781a8d967487"
	  }],
	  productNameEnglish: "Himani Navratna Revita Hair Oil",
	  productPrice: "9",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  sourceSupplier: "MUSTAFA CENTRE",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "200ML",
	  updateDateTime: "03/08/2020 05:40:44"
	}, {
	  category: "COSMETICS",
	  key: "-M9qlkNCRJaP7yOpg0ck",
	  photos: [{
	    imageName: "c2bfd3c0-aed5-11ea-8a8d-4f5b661598fc.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fc2bfd3c0-aed5-11ea-8a8d-4f5b661598fc.jpg?alt=media&token=ff7a4e6f-0eb0-47ca-9d1e-d44f45837a8d"
	  }],
	  productNameEnglish: "Himalaya Gentle Exfoliating Daily Face Wash",
	  productPrice: "11.5",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  sourceSupplier: "MUSTAFA CENTRE",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "150ML",
	  updateDateTime: "03/08/2020 05:41:57"
	}, {
	  availability: "AVAILABLE",
	  category: "COSMETICS",
	  key: "-M9ql62AvOC-_TkeZPGZ",
	  photos: [{
	    imageName: "48b0e100-aed5-11ea-8a8d-4f5b661598fc.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F48b0e100-aed5-11ea-8a8d-4f5b661598fc.jpg?alt=media&token=762b21a3-6998-4591-bfa3-a67a33b1806b"
	  }],
	  productNameEnglish: "Himalaya Men Intense Oil Clear Lemon Face Wash",
	  productPrice: "9.2",
	  productSupplier: "BCS SHOP",
	  searchText: "ফেইস ওয়াশ ",
	  sortOrder: "x",
	  sourceSupplier: "MUSTAFA CENTRE",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "100ML",
	  updateDateTime: "03/08/2020 05:42:58"
	}, {
	  availability: "AVAILABLE",
	  category: "COSMETICS",
	  key: "-M9qkW5FbzfMwsH1NsOs",
	  photos: [{
	    imageName: "cf6f2950-aed4-11ea-8a8d-4f5b661598fc.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fcf6f2950-aed4-11ea-8a8d-4f5b661598fc.jpg?alt=media&token=21252db9-ae32-4f42-af7c-3b353c66fccd"
	  }],
	  productNameEnglish: "Himalaya Men Power Glow Licorice Face Wash",
	  productPrice: "9.5",
	  productSupplier: "BCS SHOP",
	  searchText: "ফেইস ওয়াশ ",
	  sortOrder: "x",
	  sourceSupplier: "MUSTAFA CENTRE",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "100ML",
	  updateDateTime: "03/08/2020 05:43:44"
	}, {
	  category: "LAUNDRY CLEANING",
	  key: "-M9qjy5Ml2b2hqpcwHOZ",
	  photos: [{
	    imageName: "b5e7d270-aed4-11ea-9cc0-814fbb741388.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fb5e7d270-aed4-11ea-9cc0-814fbb741388.jpg?alt=media&token=6d8465db-45dc-4bd3-982f-d4ab46135e4a"
	  }],
	  productNameEnglish: "Clorox Pro-Strength Liquid-Plumr Urgent Clear Clog Remover",
	  productPrice: "7.95",
	  productSupplier: "BCS SHOP",
	  sortOrder: "k",
	  sourceSupplier: "MUSTAFA CENTRE",
	  supplierContactName: "ARIG",
	  supplierContactPhone: "84124637",
	  unit: "500ML",
	  updateDateTime: "03/08/2020 05:45:14"
	}, {
	  availability: "AVAILABLE",
	  category: "COSMETICS",
	  key: "-M9qjQc6sQmiIIgkR9b1",
	  photos: [{
	    imageName: "17a96a60-aed4-11ea-8a8d-4f5b661598fc.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F17a96a60-aed4-11ea-8a8d-4f5b661598fc.jpg?alt=media&token=d9c31e7d-444f-499f-b3c4-327b24329b29"
	  }],
	  productNameEnglish: "L`OREAL Men Expert Pure & Matte Charcoal Black Icy Foam",
	  productPrice: "11.10",
	  productSupplier: "BCS SHOP",
	  searchText: "ফেইস ওয়াশ ",
	  sortOrder: "d",
	  sourceSupplier: "MUSTAFA CENTRE",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "100ML ",
	  updateDateTime: "03/08/2020 05:46:24"
	}, {
	  category: "LAUNDRY CLEANING",
	  key: "-M9qioJ47KN21duRXAgJ",
	  photos: [{
	    imageName: "022aca80-aed4-11ea-9cc0-814fbb741388.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F022aca80-aed4-11ea-9cc0-814fbb741388.jpg?alt=media&token=1581825b-5855-4d76-afe4-53d9dda39e19"
	  }],
	  productNameEnglish: "Buster Plughole Unblocker - Bathroom",
	  productPrice: "9.20",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  sourceSupplier: "MUSTAFA CENTRE",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "300ML",
	  updateDateTime: "03/08/2020 05:47:36"
	}, {
	  availability: "AVAILABLE",
	  category: "COSMETICS",
	  isPopular: "NO",
	  key: "-M9qi8NirqjB3PjCGJ1X",
	  photos: [{
	    imageName: "888520e0-aed3-11ea-8a8d-4f5b661598fc.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F888520e0-aed3-11ea-8a8d-4f5b661598fc.jpg?alt=media&token=330079ea-2946-4a4c-b20a-1d1809979bb0"
	  }],
	  productNameEnglish: "Nivea Multi-Effect 8 Oil Control Face Wash",
	  productPrice: "9.9",
	  productSupplier: "BCS SHOP",
	  searchText: "ফেইস ওয়াশ ",
	  sortOrder: "x",
	  sourceSupplier: "MUSTAFA CENTRE",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "100ML",
	  updateDateTime: "03/08/2020 05:48:30"
	}, {
	  availability: "AVAILABLE",
	  category: "COSMETICS",
	  key: "-M9qhy-cLtcoJBhXeJtE",
	  photos: [{
	    imageName: "5c6692a0-aed3-11ea-8a8d-4f5b661598fc.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F5c6692a0-aed3-11ea-8a8d-4f5b661598fc.jpg?alt=media&token=e4c1bfcf-2cc8-4898-8221-388a449348dc"
	  }],
	  productNameEnglish: "Nivea Whitening Acne Oil Control + Pore Minimiser Cleanser & Scrub",
	  productPrice: "9.9",
	  productSupplier: "BCS SHOP",
	  searchText: "ফেইস ওয়াশ ",
	  sortOrder: "x",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "100ML",
	  updateDateTime: "03/08/2020 05:49:48"
	}, {
	  category: "LAUNDRY CLEANING",
	  key: "-M9qhvLJVgmSdm_Y-5rP",
	  photos: [{
	    imageName: "735f7670-aed3-11ea-9cc0-814fbb741388.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F735f7670-aed3-11ea-9cc0-814fbb741388.jpg?alt=media&token=214a61f3-8eb2-496f-ba1e-622ccf681e04"
	  }],
	  productNameEnglish: "Max Strength Drain Unblocker",
	  productPrice: "7.10",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  sourceSupplier: "MUSTAFA CENTRE",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "500ML",
	  updateDateTime: "03/08/2020 05:51:11"
	}, {
	  category: "KITCHEN DINING",
	  isPopular: "NO",
	  key: "-M9qfo7RSObSm8Oraur9",
	  photos: [{
	    imageName: "08b7cd50-aed2-11ea-8a8d-4f5b661598fc.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F08b7cd50-aed2-11ea-8a8d-4f5b661598fc.jpg?alt=media&token=e73a451b-6a67-4b34-a4ca-f884bb65b1af"
	  }],
	  productNameEnglish: "Vegetable / Fruit Peeler",
	  productPrice: "4.5",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  sourceSupplier: "MUSTAFA CENTRE",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1PC",
	  updateDateTime: "03/08/2020 05:51:41"
	}, {
	  category: "TOILETRIES",
	  key: "-M9qfP5U0uGQlwpUEyVN",
	  photos: [{
	    imageName: "ecfe2d20-aed1-11ea-9cc0-814fbb741388.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fecfe2d20-aed1-11ea-9cc0-814fbb741388.jpg?alt=media&token=35b807c7-f086-4f8a-87c0-7e122773f025"
	  }],
	  productNameEnglish: "Mr Muscle Toiler Cleaner - Lavender (Triple Pack)",
	  productPrice: "7.95",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  sourceSupplier: "MUSTAFA CENTRE",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "3 pcs of 500 ML",
	  updateDateTime: "03/08/2020 05:53:14"
	}, {
	  category: "TOILETRIES",
	  key: "-M9qf1UxVbQed3GYVmKW",
	  photos: [{
	    imageName: "84476210-aed1-11ea-8a8d-4f5b661598fc.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F84476210-aed1-11ea-8a8d-4f5b661598fc.jpg?alt=media&token=e05d02ac-d02c-4757-a096-f5e3cd59c29a"
	  }],
	  productNameEnglish: "Colgate Plax Ice Mouthwash",
	  productPrice: "6.3",
	  productSupplier: "BCS SHOP",
	  sortOrder: "k",
	  sourceSupplier: "Sheng siong ",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "250ML",
	  updateDateTime: "03/08/2020 05:54:06"
	}, {
	  category: "TOILETRIES",
	  key: "-M9qeRZgN6vy0H2MGIHE",
	  photos: [{
	    imageName: "5645bbf0-aed1-11ea-9cc0-814fbb741388.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F5645bbf0-aed1-11ea-9cc0-814fbb741388.jpg?alt=media&token=9bf9417b-87d9-494a-bdb2-b6f36ba6dcd2"
	  }],
	  productNameEnglish: "Mr Muscle 4 in 1 Active Clean In-Cistern Block-Fresh Scent",
	  productPrice: "6.95",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  sourceSupplier: "MUSTAFA CENTRE",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "6PCS 40G",
	  updateDateTime: "03/08/2020 05:55:39"
	}, {
	  category: "LAUNDRY CLEANING",
	  isPopular: "NO",
	  key: "-M9qcstKKSzKgQ2W8Bup",
	  photos: [{
	    imageName: "64199450-aed0-11ea-9cc0-814fbb741388.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F64199450-aed0-11ea-9cc0-814fbb741388.jpg?alt=media&token=1f9802e1-9582-4cfd-8c7d-1728e0481e5a"
	  }],
	  productNameEnglish: "TOP Concentrated Liquid Detergent",
	  productPrice: "4.95",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  sourceSupplier: "Sheng siong ",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1.5KG",
	  updateDateTime: "03/08/2020 05:57:11"
	}, {
	  category: "LAUNDRY CLEANING",
	  key: "-M9qatEWvUQ-j6-KzuDc",
	  photos: [{
	    imageName: "2c283fc0-aecf-11ea-9cc0-814fbb741388.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F2c283fc0-aecf-11ea-9cc0-814fbb741388.jpg?alt=media&token=adef0917-ab93-47c1-880f-d7038c9ea271"
	  }],
	  productNameEnglish: "Mr Muscle Sink and Drain Declogger",
	  productPrice: "8.45",
	  productSupplier: "BCS SHOP",
	  sortOrder: "g",
	  sourceSupplier: "Sheng siong ",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "500ML",
	  updateDateTime: "03/08/2020 05:57:59"
	}, {
	  category: "COSMETICS",
	  key: "-M9qaqmVr_mHgIgl7fx3",
	  photos: [{
	    imageName: "f30c0a50-aece-11ea-b774-7962c3b67908.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Ff30c0a50-aece-11ea-b774-7962c3b67908.jpg?alt=media&token=80d84dcd-058e-4859-8063-1702d32c2812"
	  }],
	  productNameEnglish: "Colgate Plax Fresh Tea Mouthwash",
	  productPrice: "10.90",
	  productSupplier: "BCS SHOP",
	  sortOrder: "g",
	  sourceSupplier: "MUSTAFA CENTRE",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1L",
	  updateDateTime: "03/08/2020 05:58:35"
	}, {
	  category: "LAUNDRY CLEANING",
	  key: "-M9qa698_7rl1kDHp9Hm",
	  photos: [{
	    imageName: "b10bad90-aece-11ea-9cc0-814fbb741388.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fb10bad90-aece-11ea-9cc0-814fbb741388.jpg?alt=media&token=17275188-ad93-451b-b809-581382a38e7f"
	  }],
	  productNameEnglish: "UIC Natural Plus Kitchen Cleaner",
	  productPrice: "6.50",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  sourceSupplier: "MUSTAFA CENTRE",
	  supplierContactName: "arif",
	  supplierContactPhone: "84124637",
	  unit: "1 pc of  500ML",
	  updateDateTime: "03/08/2020 05:59:18"
	}, {
	  availability: "AVAILABLE",
	  category: "COSMETICS",
	  key: "-M9qa24w0jVeMHfHk1AX",
	  photos: [{
	    imageName: "6a8fb3c0-aece-11ea-b774-7962c3b67908.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F6a8fb3c0-aece-11ea-b774-7962c3b67908.jpg?alt=media&token=2afb5185-b527-40a9-ad71-6e043bc75fd6"
	  }],
	  productNameEnglish: "Oil Control Facial Cleanser Moisturizing Skin Care Deep Cleansing",
	  productPrice: "9",
	  productSupplier: "BCS SHOP",
	  searchText: "ফেইস ওয়াশ ",
	  sortOrder: "k",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1 pc of 100ML",
	  updateDateTime: "03/08/2020 06:00:28"
	}, {
	  availability: "AVAILABLE",
	  category: "LAUNDRY CLEANING",
	  key: "-M9q_VuoNmofmTu6LIW3",
	  photos: [{
	    imageName: "405d6520-aece-11ea-9cc0-814fbb741388.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F405d6520-aece-11ea-9cc0-814fbb741388.jpg?alt=media&token=f17c8109-8c6b-4cde-bdf3-b424fcffd55d"
	  }],
	  productNameEnglish: "Mama Lemon Dishwashing Liquid",
	  productPrice: "2.80",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  sourceSupplier: "Sheng siong ",
	  supplierContactName: "arif",
	  supplierContactPhone: "84124637",
	  unit: "600ML",
	  updateDateTime: "03/08/2020 06:01:18"
	}, {
	  availability: "AVAILABLE",
	  category: "COSMETICS",
	  key: "-M9qZ5EiIDdsa9Zg3LpE",
	  photos: [{
	    imageName: "5bcb99e0-aecd-11ea-b774-7962c3b67908.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F5bcb99e0-aecd-11ea-b774-7962c3b67908.jpg?alt=media&token=851cd3dd-5f35-4a51-a06d-e274dd956981"
	  }],
	  productNameEnglish: "Garnier Light Foam Facial Wash",
	  productPrice: "6.8",
	  productSupplier: "BCS SHOP",
	  searchText: "ফেইস ওয়াশ ",
	  sortOrder: "d",
	  sourceSupplier: "MUSTAFA CENTRE",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1pc of 100ML",
	  updateDateTime: "03/08/2020 06:01:46"
	}, {
	  category: "TOILETRIES",
	  isPopular: "NO",
	  key: "-M9qZ4eweURh0156FPwh",
	  photos: [{
	    imageName: "799de0e0-aecd-11ea-9cc0-814fbb741388.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F799de0e0-aecd-11ea-9cc0-814fbb741388.jpg?alt=media&token=9f4d3099-d075-4d13-b04a-edba711d5cbd"
	  }],
	  productNameEnglish: "Pursoft Kitchen Towel Roll",
	  productPrice: "6.20",
	  productSupplier: "BCS SHOP",
	  sortOrder: "k",
	  sourceSupplier: "MUSTAFA CENTRE",
	  supplierContactName: "arif",
	  supplierContactPhone: "84124637",
	  unit: "6pcs of 1packet ",
	  updateDateTime: "03/08/2020 06:02:22"
	}, {
	  availability: "AVAILABLE",
	  category: "COSMETICS",
	  key: "-M9qYZuBZRkcKkf5szod",
	  photos: [{
	    imageName: "fdb83250-aecc-11ea-b774-7962c3b67908.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Ffdb83250-aecc-11ea-b774-7962c3b67908.jpg?alt=media&token=7cb74fa2-2c06-4445-af61-3f0249c6b035"
	  }],
	  productNameEnglish: "Garnier Pure Active Matcha Detox Foam",
	  productPrice: "6.8",
	  productSupplier: "BCS SHOP",
	  searchText: "ফেইস ওয়াশ ",
	  sortOrder: "x",
	  sourceSupplier: "MUSTAFA CENTRE",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "100ML",
	  updateDateTime: "03/08/2020 06:03:08"
	}, {
	  category: "TOILETRIES",
	  key: "-M9qYI1DC5DjkLn0Bs38",
	  photos: [{
	    imageName: "c88cbf10-aecc-11ea-9cc0-814fbb741388.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fc88cbf10-aecc-11ea-9cc0-814fbb741388.jpg?alt=media&token=d62e26c4-b6ff-4dbe-80cc-77dc252ceb46"
	  }],
	  productDescription: "(20 x185 per pack)",
	  productNameEnglish: "Scott Extra Regular 2-ply Toilet Tissue Roll ",
	  productPrice: "6.95",
	  productSupplier: "BCS SHOP",
	  sortOrder: "k",
	  sourceSupplier: "Sheng siong ",
	  supplierContactName: "arif",
	  supplierContactPhone: "84124637",
	  unit: "20rolls of 1packet",
	  updateDateTime: "03/08/2020 06:03:42"
	}, {
	  category: "TOILETRIES",
	  key: "-M9qWsLTgXB1IY3_vt4A",
	  photos: [{
	    imageName: "1e1c6440-aecc-11ea-9cc0-814fbb741388.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F1e1c6440-aecc-11ea-9cc0-814fbb741388.jpg?alt=media&token=9f6dc4dd-715c-4252-8f6a-cfedfa92971a"
	  }],
	  productDescription: " (20x200 per pack)",
	  productNameEnglish: "Kleenex Ultra Soft 3-ply Toilet Tissue Roll",
	  productPrice: "15",
	  productSupplier: "BCS SHOP",
	  sortOrder: "k",
	  sourceSupplier: "Sheng siong ",
	  supplierContactName: "arif",
	  supplierContactPhone: "84124637",
	  unit: "20 Rolls of 1packet",
	  updateDateTime: "03/08/2020 06:04:17"
	}, {
	  category: "TOILETRIES",
	  key: "-M9qW3hb6pRhivor4ItI",
	  photos: [{
	    imageName: "a205baa0-aecb-11ea-9cc0-814fbb741388.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fa205baa0-aecb-11ea-9cc0-814fbb741388.jpg?alt=media&token=a4a75886-cde8-4914-9068-bcb4393bb9ee"
	  }],
	  productNameEnglish: "Onwards Kitchen Towel Roll ",
	  productPrice: "6.50",
	  productSupplier: "BCS SHOP",
	  sortOrder: "k",
	  sourceSupplier: "Sheng siong ",
	  supplierContactName: "arif",
	  supplierContactPhone: "84124637",
	  unit: "8 rolls of 1 packet",
	  updateDateTime: "03/08/2020 06:04:40"
	}, {
	  category: "TOILETRIES",
	  key: "-M9qVRIsxpw0TyoXencw",
	  photos: [{
	    imageName: "3f903170-aecb-11ea-9cc0-814fbb741388.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F3f903170-aecb-11ea-9cc0-814fbb741388.jpg?alt=media&token=6b3379fb-ff23-4f9f-8040-c2f76db7d1d8"
	  }],
	  productDescription: " (8x55 per pack)",
	  productNameEnglish: "Scott Kitchen Towel Roll",
	  productPrice: "6.10",
	  productSupplier: "BCS SHOP",
	  sortOrder: "k",
	  sourceSupplier: "Sheng siong ",
	  supplierContactName: "arif",
	  supplierContactPhone: "84124637",
	  unit: "8 dools of 1 packet",
	  updateDateTime: "03/08/2020 06:05:02"
	}, {
	  category: "TOILETRIES",
	  key: "-M9qUoKPglLjSU6mkOlJ",
	  photos: [{
	    imageName: "da5e9580-aeca-11ea-9cc0-814fbb741388.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fda5e9580-aeca-11ea-9cc0-814fbb741388.jpg?alt=media&token=71e145eb-7628-449b-ba7a-7fb143f431b9"
	  }],
	  productDescription: "(10x220 per pack)",
	  productNameEnglish: "PurSoft 3-ply Unscented Toilet Tissue Roll",
	  productPrice: "7.55",
	  productSupplier: "BCS SHOP",
	  sortOrder: "k",
	  sourceSupplier: "Sheng siong ",
	  supplierContactName: "arif",
	  supplierContactPhone: "84124637",
	  unit: "10 ROLLS",
	  updateDateTime: "03/08/2020 06:10:53"
	}, {
	  category: "TOILETRIES",
	  key: "-M9qQN2dHSWptq7fJzue",
	  photos: [{
	    imageName: "2394d4b0-aec8-11ea-9cc0-814fbb741388.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F2394d4b0-aec8-11ea-9cc0-814fbb741388.jpg?alt=media&token=e0893cba-c5bf-451d-b2b6-02913362973d"
	  }],
	  productDescription: " (10x200 per pack)",
	  productNameEnglish: "PurSoft 4-ply Unscented Toilet Tissue Roll",
	  productPrice: "7.95",
	  productSupplier: "BCS SHOP",
	  sortOrder: "k",
	  sourceSupplier: "Sheng siong ",
	  supplierContactName: "arif",
	  supplierContactPhone: "84124637",
	  unit: "10 ROLLS",
	  updateDateTime: "03/08/2020 06:10:46"
	}, {
	  category: "TOILETRIES",
	  key: "-M9qPNpzb4wLoZtVc5DQ",
	  photos: [{
	    imageName: "8dd80190-aec7-11ea-9cc0-814fbb741388.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F8dd80190-aec7-11ea-9cc0-814fbb741388.jpg?alt=media&token=5ef71a70-b0fa-4347-a4c3-4cd5d500d571"
	  }],
	  productDescription: " (3x180 per pack)",
	  productNameEnglish: "PurSoft Toilet Tissue Roll - Lavender Vanilla",
	  productPrice: "19.10",
	  productSupplier: "BCS SHOP",
	  sortOrder: "k",
	  sourceSupplier: "Sheng siong ",
	  supplierContactName: "arif",
	  supplierContactPhone: "84124637",
	  unit: "30 ROLLS",
	  updateDateTime: "03/08/2020 06:10:38"
	}, {
	  category: "TOILETRIES",
	  isPopular: "NO",
	  key: "-M9qO3oaxhX1ph61tfLh",
	  photos: [{
	    imageName: "c0564ba0-aec6-11ea-9cc0-814fbb741388.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fc0564ba0-aec6-11ea-9cc0-814fbb741388.jpg?alt=media&token=78d54927-1e9a-40c2-99a5-5a3f63af7690"
	  }],
	  productDescription: " (20x200per pack)",
	  productNameEnglish: "Kleenex Ultra Soft Toilet Tissue Rolls - Cottony Clean",
	  productPrice: "15.30",
	  productSupplier: "BCS SHOP",
	  searchText: "",
	  sortOrder: "k",
	  sourceSupplier: "Sheng siong ",
	  supplierContactName: "arif",
	  supplierContactPhone: "84124637",
	  unit: "20 ROLLS",
	  updateDateTime: "03/08/2020 06:12:41"
	}, {
	  category: "TUPPERWARE CONTAINER",
	  key: "-M9q5QC6nrc4MfVdUoN0",
	  photos: [{
	    imageName: "5b02a9c0-aebb-11ea-9600-53e79e8cda87.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F5b02a9c0-aebb-11ea-9600-53e79e8cda87.jpg?alt=media&token=809b5b04-7592-4e2f-a094-2d248028db9a"
	  }],
	  productDescription: " 5PCS OF 1 PACK",
	  productNameEnglish: "Glad Soup & Salad Containers",
	  productPrice: "5.90",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  sourceSupplier: "MUSTAFA CENTRE",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "5PCS",
	  updateDateTime: "03/08/2020 06:14:27"
	}, {
	  category: "TOILETRIES",
	  key: "-M9q2aFwRHY16Xm425og",
	  photos: [{
	    imageName: "a0de7de0-aeb9-11ea-9600-53e79e8cda87.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fa0de7de0-aeb9-11ea-9600-53e79e8cda87.jpg?alt=media&token=fd7a2a2e-77a6-4206-99ca-651fad7c7268"
	  }],
	  productDescription: " (200g)",
	  productNameEnglish: "Glade Scented Gel - Lavender",
	  productPrice: "3.70",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  sourceSupplier: "MUSTAFA CENTRE",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1PCS",
	  updateDateTime: "03/08/2020 06:14:58"
	}, {
	  category: "TOILETRIES",
	  key: "-M9q1SEuEPgWUjBDuBf-",
	  photos: [{
	    imageName: "e66781a0-aeb8-11ea-9600-53e79e8cda87.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fe66781a0-aeb8-11ea-9600-53e79e8cda87.jpg?alt=media&token=743c9918-6d3c-423d-9ec4-f4623f68660f"
	  }],
	  productNameEnglish: "Dettol Anti-Bacterial Personal Wet Wipes",
	  productPrice: "2.35",
	  productSupplier: "BCS SHOP",
	  sortOrder: "k",
	  sourceSupplier: "MUSTAFA CENTRE",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1 PACKET",
	  updateDateTime: "03/08/2020 06:15:40"
	}, {
	  category: "TOILETRIES",
	  key: "-M9q0cbJZ174TJ0K9LQd",
	  photos: [{
	    imageName: "6cd58710-aeb8-11ea-9600-53e79e8cda87.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F6cd58710-aeb8-11ea-9600-53e79e8cda87.jpg?alt=media&token=aaf2729a-7bcd-4371-9776-debf7e4bc3cf"
	  }],
	  productNameEnglish: "Magiclean Wiper Handy Duster",
	  productPrice: "4.80",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  sourceSupplier: "MUSTAFA CENTRE",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1 PACKET",
	  updateDateTime: "03/08/2020 06:18:12"
	}, {
	  category: "TOILETRIES",
	  key: "-M9q-RMLIgkX7KhpOjRg",
	  photos: [{
	    imageName: "b6407ff0-aeb7-11ea-9600-53e79e8cda87.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fb6407ff0-aeb7-11ea-9600-53e79e8cda87.jpg?alt=media&token=a9b658ff-171a-492e-8e12-c090ca7f63cb"
	  }],
	  productNameEnglish: "Vanish Powder Fabric Stain Remover",
	  productPrice: "15.95",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  sourceSupplier: "Sheng siong ",
	  supplierContactName: "arif",
	  supplierContactPhone: "84124637",
	  unit: "900G",
	  updateDateTime: "03/08/2020 06:18:46"
	}, {
	  category: "LAUNDRY CLEANING",
	  key: "-M9pvuaZ-N-RjlDiLxVM",
	  photos: [{
	    imageName: "f0b261b0-aeb4-11ea-9600-53e79e8cda87.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Ff0b261b0-aeb4-11ea-9600-53e79e8cda87.jpg?alt=media&token=f605f675-33f0-4b24-812f-942f7f88b37c"
	  }],
	  productDescription: "1 bottol of 3 litter",
	  productNameEnglish: "Dynamo Power Gel Laundry Detergent",
	  productPrice: "13.95",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  sourceSupplier: "Sheng siong ",
	  supplierContactName: "arif",
	  supplierContactPhone: "84124637",
	  unit: "3L",
	  updateDateTime: "03/08/2020 06:20:26"
	}, {
	  availability: "AVAILABLE",
	  category: "DRINKS DESSERT",
	  isPopular: "YES",
	  key: "-M9pvV6nBjpjHiV6X0CV",
	  photos: [{
	    imageName: "94c360c0-aeb4-11ea-a578-077a102352bb.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F94c360c0-aeb4-11ea-a578-077a102352bb.jpg?alt=media&token=72ca56df-f33d-4162-b57c-e093b5130775"
	  }],
	  productNameEnglish: "Jaggery / Gour / Gur",
	  productPrice: "3.5",
	  productSupplier: "BCS SHOP",
	  searchText: "gur sugare cane মিঠাই ",
	  sortOrder: "a",
	  sourceSupplier: "TERRY TRADING CO PTE LTD",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: " 500gm",
	  updateDateTime: "03/08/2020 06:21:02"
	}, {
	  category: "TOILETRIES",
	  key: "-M9pvAmbmU0NICtafHuL",
	  photos: [{
	    imageName: "821fcd50-aeb4-11ea-9600-53e79e8cda87.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F821fcd50-aeb4-11ea-9600-53e79e8cda87.jpg?alt=media&token=2dcbb363-b6f1-445d-914b-8d8ddcbebcfd"
	  }],
	  productDescription: "(8x55 per pack)",
	  productNameEnglish: "Scott Kitchen Towel Rolls",
	  productPrice: "6.20",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  sourceSupplier: "Sheng siong ",
	  supplierContactName: "arif",
	  supplierContactPhone: "84121637",
	  unit: "1packet",
	  updateDateTime: "03/08/2020 06:23:03"
	}, {
	  category: "TOILETRIES",
	  key: "-M9puZTivnTeQamZ9h6T",
	  photos: [{
	    imageName: "21140d50-aeb4-11ea-9600-53e79e8cda87.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F21140d50-aeb4-11ea-9600-53e79e8cda87.jpg?alt=media&token=81b19c6e-5506-4e8d-9fac-a5c6a206ff24"
	  }],
	  productDescription: "(4x 130 per pack)",
	  productNameEnglish: "PurSoft 3-ply Tissue Soft Pack - Sakura",
	  productPrice: "5.85",
	  productSupplier: "BCS SHOP",
	  sortOrder: "k",
	  sourceSupplier: "Giant supermarket ",
	  supplierContactName: "arif",
	  supplierContactPhone: "84124637",
	  unit: "4 box of 1 pack",
	  updateDateTime: "03/08/2020 06:24:16"
	}, {
	  category: "LAUNDRY CLEANING",
	  key: "-M9ptWvipAKeUz6cyi8x",
	  photos: [{
	    imageName: "7c0569d0-aeb3-11ea-9600-53e79e8cda87.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F7c0569d0-aeb3-11ea-9600-53e79e8cda87.jpg?alt=media&token=5fe7277d-299f-4112-ae10-6c1563b191a9"
	  }],
	  productNameEnglish: "Dynamo Power Gel Laundry Detergent - Anti Bacterial",
	  productPrice: "13.60",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  sourceSupplier: "Sheng siong ",
	  supplierContactName: "arif",
	  supplierContactPhone: "84124637",
	  unit: "1 bottol of 2.7L",
	  updateDateTime: "03/08/2020 06:25:27"
	}, {
	  category: "TOILETRIES",
	  key: "-M9psXalirrHRL8c0oFq",
	  photos: [{
	    imageName: "e1fcbc30-aeb2-11ea-9600-53e79e8cda87.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fe1fcbc30-aeb2-11ea-9600-53e79e8cda87.jpg?alt=media&token=db669081-4281-43f7-866e-509e8325994a"
	  }],
	  productNameEnglish: "Magiclean Bathroom Stain & Mold Remover",
	  productPrice: "4.80",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  sourceSupplier: "Sheng siong ",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "400ML ",
	  updateDateTime: "03/08/2020 06:26:22"
	}, {
	  category: "LAUNDRY CLEANING",
	  key: "-M9prW9i4PUI9Qh_AYuY",
	  photos: [{
	    imageName: "42494050-aeb2-11ea-9600-53e79e8cda87.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F42494050-aeb2-11ea-9600-53e79e8cda87.jpg?alt=media&token=ab56ccef-6a9b-4934-9d41-eb334d1df53f"
	  }],
	  productNameEnglish: "Comfort Concentrated Fabric Conditioner - Refill ",
	  productPrice: "8.50",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  sourceSupplier: "Sheng siong ",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1 packet of 1.6L",
	  updateDateTime: "03/08/2020 06:27:13"
	}, {
	  category: "LAUNDRY CLEANING",
	  key: "-M9pq_7yFWPqW9dbIYUb",
	  photos: [{
	    imageName: "ae6b1840-aeb1-11ea-9600-53e79e8cda87.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fae6b1840-aeb1-11ea-9600-53e79e8cda87.jpg?alt=media&token=9de32055-cc30-41ff-9bdb-563d0fc9a662"
	  }],
	  productDescription: " (1.5kg)",
	  productNameEnglish: "TOP Super Low Studs Concentrated Liquid Detergent - Refill",
	  productPrice: "5.50",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  sourceSupplier: "Sheng siong ",
	  supplierContactName: "arif",
	  supplierContactPhone: "84124637",
	  unit: "1 packet of 1.5L",
	  updateDateTime: "03/08/2020 06:28:02"
	}, {
	  category: "TOILETRIES",
	  key: "-M9ppYCJ6-LIXVaNia1I",
	  photos: [{
	    imageName: "0ca64890-aeb1-11ea-9600-53e79e8cda87.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F0ca64890-aeb1-11ea-9600-53e79e8cda87.jpg?alt=media&token=fe16a2ed-c650-4121-b32d-5c9b66d58baa"
	  }],
	  productDescription: " (3x500ml)",
	  productNameEnglish: "Magiclean Toilet Cleaner",
	  productPrice: "8.95",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "3 bottol of 1 pack",
	  updateDateTime: "03/08/2020 06:28:26"
	}, {
	  category: "KITCHEN DINING",
	  key: "-M9po6TUpI01bzNV0pbR",
	  photos: [{
	    imageName: "2e88b610-aeb0-11ea-9600-53e79e8cda87.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F2e88b610-aeb0-11ea-9600-53e79e8cda87.jpg?alt=media&token=1e157c4b-141d-45fa-a064-4dcad4405183"
	  }],
	  productDescription: "(4x1pre pack)",
	  productNameEnglish: "3M Scotch Brite Scrub Sponges - Heavy Duty",
	  productPrice: "4.90",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  sourceSupplier: "MUSTAFA CENTRE",
	  supplierContactName: "arif",
	  supplierContactPhone: "84124637",
	  unit: "1 packet",
	  updateDateTime: "03/08/2020 06:29:20"
	}, {
	  category: "LAUNDRY CLEANING",
	  key: "-M9pn1aO6pTE9gK2xD7F",
	  photos: [{
	    imageName: "889b2440-aeaf-11ea-9600-53e79e8cda87.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F889b2440-aeaf-11ea-9600-53e79e8cda87.jpg?alt=media&token=0aadf8a8-aed4-4ec0-9dbb-569ec5a20027"
	  }],
	  productDescription: " (5kg",
	  productNameEnglish: "Persil Powder Detergent",
	  productPrice: "15.25",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  sourceSupplier: "MUSTAFA CENTRE",
	  supplierContactName: "arif",
	  supplierContactPhone: "84124637",
	  unit: "1 packet of 5kG",
	  updateDateTime: "03/08/2020 06:29:57"
	}, {
	  category: "TOILETRIES",
	  key: "-M9pm8LxmtnECfUleknC",
	  photos: [{
	    imageName: "fd512ec0-aeae-11ea-9600-53e79e8cda87.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Ffd512ec0-aeae-11ea-9600-53e79e8cda87.jpg?alt=media&token=00502454-adbf-4bda-ac9f-d53f789227e2"
	  }],
	  productDescription: "(6x50 per pack)",
	  productNameEnglish: "Scott Pick-a-size Kitchen Towel Rolls",
	  productPrice: "5.30",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "6 rools of 1 pack",
	  updateDateTime: "03/08/2020 06:30:43"
	}, {
	  category: "LAUNDRY CLEANING",
	  key: "-M9plDFNnX5i4BDGvIG7",
	  photos: [{
	    imageName: "6c1e77a0-aeae-11ea-9600-53e79e8cda87.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F6c1e77a0-aeae-11ea-9600-53e79e8cda87.jpg?alt=media&token=9a927ad4-8ecf-4547-98fd-19c87846e81b"
	  }],
	  productDescription: "(1.6l) REFILL",
	  productNameEnglish: "Softlan Anti-Wrinkles Fabric Conditioner",
	  productPrice: "3.90",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  sourceSupplier: "Sheng siong ",
	  supplierContactName: "arif",
	  supplierContactPhone: "84124637",
	  unit: "1 packet of 1.6L",
	  updateDateTime: "03/08/2020 06:31:40"
	}, {
	  category: "LAUNDRY CLEANING",
	  key: "-M9pkCPsEjim801GgbYA",
	  photos: [{
	    imageName: "cf181a60-aead-11ea-9600-53e79e8cda87.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fcf181a60-aead-11ea-9600-53e79e8cda87.jpg?alt=media&token=5dd4cc7b-69be-404e-b49e-5cb63f5663d8"
	  }],
	  productDescription: "1pc of 1 litter",
	  productNameEnglish: "Mr Muscle Glass Cleaner",
	  productPrice: "5.10",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  sourceSupplier: "Sheng siong ",
	  supplierContactName: "arif",
	  supplierContactPhone: "84124637",
	  unit: "1PC",
	  updateDateTime: "03/08/2020 06:32:15"
	}, {
	  category: "LAUNDRY CLEANING",
	  key: "-M9pjIH3o06dR4JA449a",
	  photos: [{
	    imageName: "3ee34b40-aead-11ea-9600-53e79e8cda87.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F3ee34b40-aead-11ea-9600-53e79e8cda87.jpg?alt=media&token=97a3e1af-e40f-4a57-8987-768c2f412e18"
	  }],
	  productDescription: "(500ml)",
	  productNameEnglish: "Magiclean Glass Cleaner",
	  productPrice: "3.10",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  sourceSupplier: "Sheng siong ",
	  supplierContactName: "arif",
	  supplierContactPhone: "84124637",
	  unit: "1PC",
	  updateDateTime: "03/08/2020 06:32:30"
	}, {
	  category: "LAUNDRY CLEANING",
	  key: "-M9pioyDlebH0j4ygK5d",
	  photos: [{
	    imageName: "f538f4e0-aeac-11ea-9600-53e79e8cda87.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Ff538f4e0-aeac-11ea-9600-53e79e8cda87.jpg?alt=media&token=386f00a5-9172-4686-bf45-a00e65d9bd4f"
	  }],
	  productDescription: "REFILL (1.5l)",
	  productNameEnglish: "Downy Fabric Conditioner",
	  productPrice: "8.10",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  sourceSupplier: "MUSTAFA CENTRE",
	  supplierContactName: "arif",
	  supplierContactPhone: "84124637",
	  unit: "1 packet",
	  updateDateTime: "03/08/2020 06:33:25"
	}, {
	  category: "LAUNDRY CLEANING",
	  key: "-M9phgy8yq-NdbnqoXB-",
	  photos: [{
	    imageName: "478a10e0-aeac-11ea-9600-53e79e8cda87.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F478a10e0-aeac-11ea-9600-53e79e8cda87.jpg?alt=media&token=274dbd2c-af42-4d32-afe0-a3896c543da4"
	  }],
	  productDescription: "(10 per pack)",
	  productNameEnglish: "Combat Killing Bait Strips",
	  productPrice: "8.95",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  sourceSupplier: "MUSTAFA CENTRE",
	  supplierContactName: "arif",
	  supplierContactPhone: "84124637",
	  unit: "1packet",
	  updateDateTime: "03/08/2020 06:34:00"
	}, {
	  category: "COSMETICS",
	  key: "-M9pgPAo0dMJ1L3Pb5xh",
	  photos: [{
	    imageName: "7d1c2aa0-aeab-11ea-9600-53e79e8cda87.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F7d1c2aa0-aeab-11ea-9600-53e79e8cda87.jpg?alt=media&token=b0b296c8-0e64-4f51-8c0c-07456e39d6a3"
	  }],
	  productDescription: "(5x100per box)",
	  productNameEnglish: "Kleenex 3-ply Facial Tissue Box - Lifestyle",
	  productPrice: "6.90",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  sourceSupplier: "MUSTAFA CENTRE",
	  supplierContactName: "arif",
	  supplierContactPhone: "84124637",
	  unit: "3pc of 1 packet",
	  updateDateTime: "03/08/2020 06:34:41"
	}, {
	  category: "LAUNDRY CLEANING",
	  key: "-M9pey7tzdbXg8Inf-vr",
	  photos: [{
	    imageName: "9c2ed650-aeaa-11ea-9600-53e79e8cda87.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F9c2ed650-aeaa-11ea-9600-53e79e8cda87.jpg?alt=media&token=e4d07e9e-a13a-4fba-a704-3ca1fefb360b"
	  }],
	  productNameEnglish: "Magiclean Floor Cleaner - Lavender",
	  productPrice: "7.10",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  sourceSupplier: "Sheng siong ",
	  supplierContactName: "arif",
	  supplierContactPhone: "84124637",
	  unit: "1pc of 3L",
	  updateDateTime: "03/08/2020 06:35:12"
	}, {
	  category: "LAUNDRY CLEANING",
	  key: "-M9pZCSJ2NuX6A0Mt_FQ",
	  photos: [{
	    imageName: "77fa06a0-aea6-11ea-9600-53e79e8cda87.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F77fa06a0-aea6-11ea-9600-53e79e8cda87.jpg?alt=media&token=df32520f-dae4-4c97-89d9-e2a5d9575565"
	  }],
	  productDescription: "(24per pack)",
	  productNameEnglish: "Finish All in 1 Max Dishwasher Tablets",
	  productPrice: "19.90",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  sourceSupplier: "MUSTAFA CENTRE",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1 Pkt",
	  updateDateTime: "03/08/2020 06:36:11"
	}, {
	  category: "LAUNDRY CLEANING",
	  key: "-M9pXG6GmKhzZ5upS7CK",
	  photos: [{
	    imageName: "4cf653b0-aea5-11ea-9600-53e79e8cda87.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F4cf653b0-aea5-11ea-9600-53e79e8cda87.jpg?alt=media&token=2faef842-57d9-47ce-84e0-70e669614c9e"
	  }],
	  productNameEnglish: "Ajax Fabuloso Multi Purpose Cleaner - Lavender Fresh",
	  productPrice: "7.05",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  sourceSupplier: "MUSTAFA CENTRE",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1 bottol of 3L",
	  updateDateTime: "03/08/2020 06:36:51"
	}, {
	  category: "TOILETRIES",
	  key: "-M9pW26zKd8OJAV85scH",
	  photos: [{
	    imageName: "8e1371d0-aea4-11ea-9600-53e79e8cda87.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F8e1371d0-aea4-11ea-9600-53e79e8cda87.jpg?alt=media&token=b29bedc7-ddd6-4455-954e-4f6255a510c3"
	  }],
	  productDescription: "(40per pack)",
	  productNameEnglish: "Magiclean Wiper Dry Sheet",
	  productPrice: "10.35",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  sourceSupplier: "MUSTAFA CENTRE",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1packet",
	  updateDateTime: "03/08/2020 06:37:22"
	}, {
	  category: "KITCHEN DINING",
	  key: "-M9pUsm9QFJ9rxqTYLX-",
	  photos: [{
	    imageName: "d91d2690-aea3-11ea-9600-53e79e8cda87.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fd91d2690-aea3-11ea-9600-53e79e8cda87.jpg?alt=media&token=704a029b-32da-4493-8eb6-4939638acd18"
	  }],
	  productDescription: " (340g)",
	  productNameEnglish: "Lysol Disinfectant Spray",
	  productPrice: "7.95",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  sourceSupplier: "MUSTAFA CENTRE",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1pcs",
	  updateDateTime: "03/08/2020 06:37:50"
	}, {
	  category: "LAUNDRY CLEANING",
	  key: "-M9pTmf7KDQW8D6SmK15",
	  photos: [{
	    imageName: "2d5ca510-aea3-11ea-9600-53e79e8cda87.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F2d5ca510-aea3-11ea-9600-53e79e8cda87.jpg?alt=media&token=951a1dc6-b945-4779-b530-c8c902cdba69"
	  }],
	  productDescription: "REFILL (1.6l)",
	  productNameEnglish: "Downy Fabric Conditioner - Sunrise Fresh",
	  productPrice: "8",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  sourceSupplier: "Sheng siong ",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1packet",
	  updateDateTime: "03/08/2020 06:38:20"
	}, {
	  category: "TOILETRIES",
	  isPopular: "NO",
	  key: "-M9pSVz724fKYscsYo5M",
	  photos: [{
	    imageName: "658d1060-aea2-11ea-9600-53e79e8cda87.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F658d1060-aea2-11ea-9600-53e79e8cda87.jpg?alt=media&token=13c54b10-010c-4ed1-b731-50814fea17d8"
	  }],
	  productNameEnglish: "Harpic Toilet Cleaner Gel - Lavender Gel (Triple Pack)",
	  productPrice: "7.90",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  sourceSupplier: "MUSTAFA CENTRE",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "3 x 500ml",
	  updateDateTime: "03/08/2020 06:39:04"
	}, {
	  category: "LAUNDRY CLEANING",
	  key: "-M9pRT884THdx39dv7Hq",
	  photos: [{
	    imageName: "c314f640-aea1-11ea-9600-53e79e8cda87.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fc314f640-aea1-11ea-9600-53e79e8cda87.jpg?alt=media&token=6594d607-be83-478d-ba8c-7b01d1cc860f"
	  }],
	  productDescription: " (1.6kg)",
	  productNameEnglish: "TOP Concentrated Liquid Detergent Refill - Super Colour",
	  productPrice: "5.10",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  sourceSupplier: "Sheng siong ",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1packet",
	  updateDateTime: "03/08/2020 06:39:53"
	}, {
	  category: "LAUNDRY CLEANING",
	  key: "-M9pPi0tJQKl2u5Vdx7C",
	  photos: [{
	    imageName: "b17de640-aea0-11ea-9600-53e79e8cda87.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fb17de640-aea0-11ea-9600-53e79e8cda87.jpg?alt=media&token=1a66f530-f021-4e12-ac80-9068681a5164"
	  }],
	  productNameEnglish: "3M Scotch Brite Scrub Sponges - Non Scratch",
	  productPrice: "5.95",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "3pc",
	  updateDateTime: "03/08/2020 06:42:06"
	}, {
	  category: "LAUNDRY CLEANING",
	  key: "-M9pNpff9SWiowz5uO0H",
	  photos: [{
	    imageName: "8b742820-ae9f-11ea-9600-53e79e8cda87.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F8b742820-ae9f-11ea-9600-53e79e8cda87.jpg?alt=media&token=41fa6fac-d443-4ba8-80a8-5e5aede36c4d"
	  }],
	  productNameEnglish: "TOP Concentrated Liquid Detergent Refill - Anti Bacterial",
	  productPrice: "4.95",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1.6Kg",
	  updateDateTime: "03/08/2020 06:43:03"
	}, {
	  category: "LAUNDRY CLEANING",
	  key: "-M9pMWG6JGhZZPVqjqtT",
	  photos: [{
	    imageName: "bcfd8ae0-ae9e-11ea-9600-53e79e8cda87.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fbcfd8ae0-ae9e-11ea-9600-53e79e8cda87.jpg?alt=media&token=f1dfa292-4a55-4d6e-a6ad-4b9878660b80"
	  }],
	  productNameEnglish: "Softlan Anti Wrinkles Fabric Conditioner - Lavender Fresh",
	  productPrice: "3.70",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1.6L Refill",
	  updateDateTime: "03/08/2020 06:44:09"
	}, {
	  availability: "AVAILABLE",
	  category: "LAUNDRY CLEANING",
	  key: "-M9pKnaBOD1D8sHjw_gB",
	  photos: [{
	    imageName: "b025d7b0-ae9d-11ea-9600-53e79e8cda87.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fb025d7b0-ae9d-11ea-9600-53e79e8cda87.jpg?alt=media&token=c863610e-5db1-45af-9b1c-2fd066334842"
	  }],
	  productNameEnglish: "CIF Cream Surface Cleanser - Lemon",
	  productPrice: "2.30",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "500ml",
	  updateDateTime: "03/08/2020 06:44:45"
	}, {
	  availability: "AVAILABLE",
	  category: "COSMETICS",
	  key: "-M9mc8ytLAQtxJEccOPX",
	  photos: [{
	    imageName: "8e20f0b0-ae33-11ea-8070-f3cc7bbcb5d1.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F8e20f0b0-ae33-11ea-8070-f3cc7bbcb5d1.jpg?alt=media&token=17739c96-f6a4-4311-bad4-36c5a380d5ca"
	  }],
	  productNameEnglish: "Garnier Men Turbo Light Cooling Foam ",
	  productPrice: "10.50",
	  productSupplier: "BCS SHOP",
	  searchText: "ফেইস ওয়াশ ",
	  sortOrder: "x",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "100ml",
	  updateDateTime: "03/08/2020 06:45:38"
	}, {
	  availability: "AVAILABLE",
	  category: "COSMETICS",
	  key: "-M9mbdvWAv7s67wfSQf_",
	  photos: [{
	    imageName: "26116220-ae33-11ea-8070-f3cc7bbcb5d1.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F26116220-ae33-11ea-8070-f3cc7bbcb5d1.jpg?alt=media&token=47fff116-b52f-4324-b9b4-80bce6117874"
	  }],
	  productNameEnglish: "Garnier Men Turbo Light White+Oil Control Icy Duo Foam",
	  productPrice: "10.50",
	  productSupplier: "BCS SHOP",
	  searchText: "ফেইস ওয়াশ ",
	  sortOrder: "x",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "100ml",
	  updateDateTime: "03/08/2020 06:46:54"
	}, {
	  category: "RICE DAAL NOODLES",
	  key: "-M9maT0lAzHbQKcGlLMR",
	  photos: [{
	    imageName: "a14a4b60-ae32-11ea-8070-f3cc7bbcb5d1.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fa14a4b60-ae32-11ea-8070-f3cc7bbcb5d1.jpg?alt=media&token=7b230263-aba4-444d-a265-51b6a6df402a"
	  }],
	  productNameEnglish: "Ooty Pooni Rice - By Sri Ambikas",
	  productPrice: "9",
	  productSupplier: "BCS SHOP",
	  sortOrder: "b",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "5Kg",
	  updateDateTime: "03/08/2020 06:48:19"
	}, {
	  availability: "AVAILABLE",
	  category: "RICE DAAL NOODLES",
	  key: "-M9ma8CcI51a_N56Srhs",
	  photos: [{
	    imageName: "61e7cb00-ae32-11ea-8070-f3cc7bbcb5d1.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F61e7cb00-ae32-11ea-8070-f3cc7bbcb5d1.jpg?alt=media&token=56868607-b2b0-401a-8d39-7586d85c1ed7"
	  }],
	  productNameEnglish: "Paddy Land Jasmine Fragrant Rice",
	  productPrice: "8.6",
	  productSupplier: "BCS SHOP",
	  searchText: "চাউল rice",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "5Kg",
	  updateDateTime: "03/08/2020 06:49:22"
	}, {
	  availability: "AVAILABLE",
	  category: "RICE DAAL NOODLES",
	  key: "-M9m_b44ut235CDhnAM2",
	  photos: [{
	    imageName: "052e9c40-ae32-11ea-8070-f3cc7bbcb5d1.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F052e9c40-ae32-11ea-8070-f3cc7bbcb5d1.jpg?alt=media&token=eb07da47-4065-43f6-bc5b-2fae72aa0a3e"
	  }],
	  productNameEnglish: "Royal Umbrella Jasmine Fragrant Rice",
	  productPrice: "10.90",
	  productSupplier: "BCS SHOP",
	  searchText: "চাউল rice",
	  sortOrder: "b",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "2.5kg",
	  updateDateTime: "03/08/2020 06:50:08"
	}, {
	  availability: "AVAILABLE",
	  category: "RICE DAAL NOODLES",
	  key: "-M9m_CxjtnUINLfRzie8",
	  photos: [{
	    imageName: "d15c2950-ae31-11ea-8070-f3cc7bbcb5d1.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fd15c2950-ae31-11ea-8070-f3cc7bbcb5d1.jpg?alt=media&token=2869470d-d387-4b94-b012-8fe360fba59c"
	  }],
	  productNameEnglish: "Golden Pineapple AAA Thai Premium Fragrant Rice",
	  productPrice: "25",
	  productSupplier: "BCS SHOP",
	  searchText: "চাউল rice",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "10Kg",
	  updateDateTime: "Fri 27-11-20 11:30 am"
	}, {
	  availability: "AVAILABLE",
	  category: "RICE DAAL NOODLES",
	  key: "-M9hkaEMkQ8ozocccNLY",
	  photos: [{
	    imageName: "6b90c4d0-ad75-11ea-8617-6988f4fcb266.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F6b90c4d0-ad75-11ea-8617-6988f4fcb266.jpg?alt=media&token=ec4a1442-e561-4df4-ac3f-54d6f4aebf45"
	  }],
	  productNameEnglish: "Royal India Basmati Rice ",
	  productPrice: "19.90",
	  productSupplier: "BCS SHOP",
	  searchText: "চাউল rice",
	  sortOrder: "b",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "5Kg",
	  updateDateTime: "03/08/2020 06:51:12"
	}, {
	  availability: "AVAILABLE",
	  category: "RICE DAAL NOODLES",
	  key: "-M9hjms-69uHkY6aPAh0",
	  photos: [{
	    imageName: "00b8a060-ad75-11ea-8617-6988f4fcb266.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F00b8a060-ad75-11ea-8617-6988f4fcb266.jpg?alt=media&token=c61cbe55-8a1b-4bd0-8d7d-49a4346f852b"
	  }],
	  productNameEnglish: "Housebrand Ponni Rice",
	  productPrice: "8.5",
	  productSupplier: "BCS SHOP",
	  searchText: "চাউল rice",
	  sortOrder: "b",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "5Kg",
	  updateDateTime: "03/08/2020 06:51:41"
	}, {
	  category: "RICE DAAL NOODLES",
	  key: "-M9hjeXdH6PLlcrwMShr",
	  photos: [{
	    imageName: "c9023c80-ad74-11ea-8617-6988f4fcb266.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fc9023c80-ad74-11ea-8617-6988f4fcb266.jpg?alt=media&token=0eab69cb-5644-4eea-82b5-df16dc3ad2e3"
	  }],
	  productNameEnglish: "Royal Umbrella Jasmine Fragrant Rice ",
	  productPrice: "18.3",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "5kg",
	  updateDateTime: "03/08/2020 06:52:09"
	}, {
	  availability: "AVAILABLE",
	  category: "COSMETICS",
	  isPopular: "YES",
	  key: "-M9hI30fYjFeEKpztA36",
	  photos: [{
	    imageName: "7e4b19c0-ad63-11ea-a545-3fca42f11c6b.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F7e4b19c0-ad63-11ea-a545-3fca42f11c6b.jpg?alt=media&token=f89a5dfc-e44a-4e86-a476-6a4592e4a004"
	  }],
	  productNameEnglish: "Shaving Blade",
	  productPrice: "1",
	  productSupplier: "BCS SHOP",
	  searchText: "shave shaving saving ব্লেড ",
	  sortOrder: "x",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1 Pkt",
	  updateDateTime: "03/08/2020 06:55:41"
	}, {
	  category: "LAUNDRY CLEANING",
	  key: "-M9gn8rLrPSZfJIsoCSC",
	  photos: [{
	    imageName: "0b27d450-ad50-11ea-9a01-db9ea96fa329.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F0b27d450-ad50-11ea-9a01-db9ea96fa329.jpg?alt=media&token=ecaefb03-ba5a-41b0-81a7-446ca7a59703"
	  }],
	  productNameEnglish: "Lysol Disinfectant Spray",
	  productPrice: "10.30",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "510g",
	  updateDateTime: "03/08/2020 06:58:00"
	}, {
	  category: "LAUNDRY CLEANING",
	  key: "-M9gm8uyQ37ejT8vSkMY",
	  photos: [{
	    imageName: "6f1992b0-ad4f-11ea-9a01-db9ea96fa329.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F6f1992b0-ad4f-11ea-9a01-db9ea96fa329.jpg?alt=media&token=d3292a00-080b-4792-9c55-c2e84d1fccb1"
	  }],
	  productNameEnglish: "MAMA LEMON NATURAL LEMON FRAGRANCE DISHWASHING LIQUID REFILL PACK",
	  productPrice: "2.3",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "600ml Refill",
	  updateDateTime: "04/07/2020 10:14:40"
	}, {
	  availability: "AVAILABLE",
	  category: "RICE DAAL NOODLES",
	  isPopular: "YES",
	  key: "-M9glXjaEe-mKWvEMYkB",
	  photos: [{
	    imageName: "047157e0-ad4f-11ea-9947-39ad013963aa.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F047157e0-ad4f-11ea-9947-39ad013963aa.jpg?alt=media&token=41b67f4a-8e77-4c84-b40c-e0d7a10cd76d"
	  }],
	  productNameEnglish: "Uncle Cook's Ponni Rice",
	  productPrice: "7.8",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "5Kg",
	  updateDateTime: "03/08/2020 06:59:38"
	}, {
	  category: "DRINKS DESSERT",
	  isPopular: "YES",
	  key: "-M9gdKMWElwiXoeMBUTl",
	  photos: [{
	    imageName: "0c3c6050-ad4a-11ea-9a01-db9ea96fa329.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F0c3c6050-ad4a-11ea-9a01-db9ea96fa329.jpg?alt=media&token=da35e7b2-d853-4a7f-b7c9-59179208129b"
	  }],
	  productNameEnglish: "Nescafe Instant Soluble Coffee Jar - Deluxe",
	  productPrice: "7.50",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "200gm Bottle",
	  updateDateTime: "Tue 18-08-20 9:46 am"
	}, {
	  availability: "AVAILABLE",
	  category: "EGGS DAIRY",
	  key: "-M9gcUuyQ9PdIQpp_HRY",
	  photos: [{
	    imageName: "89f0a9d0-ad49-11ea-9a01-db9ea96fa329.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F89f0a9d0-ad49-11ea-9a01-db9ea96fa329.jpg?alt=media&token=8ddc2c83-3a91-4db2-9a8b-dfbaac4cc8f2"
	  }],
	  productNameEnglish: "Nespray Everyday Full Cream Instant Milk Powder",
	  productPrice: "9",
	  productSupplier: "BCS SHOP",
	  sortOrder: "k",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "500g",
	  updateDateTime: "03/08/2020 07:02:12"
	}, {
	  category: "EGGS DAIRY",
	  key: "-M9gboJ-Kb2YSSVTcp0e",
	  photos: [{
	    imageName: "1fbadfe0-ad49-11ea-9a01-db9ea96fa329.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F1fbadfe0-ad49-11ea-9a01-db9ea96fa329.jpg?alt=media&token=09645012-9ea6-454b-8c2d-b5ef0279514a"
	  }],
	  productNameEnglish: "Nespray Fortified Full Cream Instant Milk Powder",
	  productPrice: "12.50",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "600g",
	  updateDateTime: "03/08/2020 07:03:20"
	}, {
	  category: "COSMETICS",
	  key: "-M9gY6ErV_g_Qj3_Keuw",
	  photos: [{
	    imageName: "1f7f16c0-ad46-11ea-93aa-6d00775cfd30.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F1f7f16c0-ad46-11ea-93aa-6d00775cfd30.jpg?alt=media&token=59053b15-dc2f-46c9-9582-aa081c9e2961"
	  }],
	  productNameEnglish: "Shaving rezor gillette vector ",
	  productPrice: "5",
	  productSupplier: "BCS SHOP",
	  sortOrder: "k",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  updateDateTime: "04/07/2020 09:42:12"
	}, {
	  category: "COSMETICS",
	  key: "-M9gRgxHShbWEYSu17Cn",
	  photos: [{
	    imageName: "33d1b690-ad42-11ea-93aa-6d00775cfd30.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F33d1b690-ad42-11ea-93aa-6d00775cfd30.jpg?alt=media&token=875b5b96-20bd-4317-a434-3d372ee73b39"
	  }],
	  productNameEnglish: "Shaving Razor gillette mach3 ",
	  productPrice: "10.60",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  updateDateTime: "04/07/2020 10:15:35"
	}, {
	  category: "COSMETICS",
	  key: "-M9gPGIcBzoPH_xk4Hz7",
	  photos: [{
	    imageName: "9f9ab590-ad40-11ea-93aa-6d00775cfd30.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F9f9ab590-ad40-11ea-93aa-6d00775cfd30.jpg?alt=media&token=68fa78d7-9e96-4868-95e6-4412c436c044"
	  }],
	  productNameEnglish: "Shaving  razor gillette blue ll disposable",
	  productPrice: "6.2",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "5pcs 1 Pkt",
	  updateDateTime: "04/07/2020 10:16:13"
	}, {
	  category: "COSMETICS",
	  key: "-M9gOUNg5ksrhHVA8-P4",
	  photos: [{
	    imageName: "2e812830-ad40-11ea-b044-d71d8f034373.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F2e812830-ad40-11ea-b044-d71d8f034373.jpg?alt=media&token=ef88be7c-b3f5-46e6-a5d6-d1d3234c9bc9"
	  }],
	  productNameEnglish: "Shaving razor kai fixed type",
	  productPrice: "3.5",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "5pcs 1packet",
	  updateDateTime: "04/07/2020 10:16:29"
	}, {
	  category: "COSMETICS",
	  key: "-M9gN5Ldhfx7tnCST-p7",
	  photos: [{
	    imageName: "724c0130-ad3f-11ea-b044-d71d8f034373.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F724c0130-ad3f-11ea-b044-d71d8f034373.jpg?alt=media&token=1774d9e1-0442-4b0a-bd3e-9bb6a16caef7"
	  }],
	  productNameEnglish: "Shaving foam denim foam black 300ml",
	  productPrice: "5.5",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  updateDateTime: "04/07/2020 10:17:17"
	}, {
	  category: "DRINKS DESSERT",
	  key: "-M9gMuB7C1BkKbWAAipX",
	  photos: [{
	    imageName: "165e11b0-ad3f-11ea-9a01-db9ea96fa329.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F165e11b0-ad3f-11ea-9a01-db9ea96fa329.jpg?alt=media&token=8278450d-d3e6-46e8-bbe2-b7ba4fe2e886"
	  }],
	  productNameEnglish: "MARIGOLD CHRYSANTHEMUM TEA PACKET DRINK CASE",
	  productPrice: "13",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: " 24x250ml",
	  updateDateTime: "04/07/2020 10:17:40"
	}, {
	  category: "COSMETICS",
	  key: "-M9gMP2U0vR6-qghNwpL",
	  photos: [{
	    imageName: "f81a6b40-ad3e-11ea-b044-d71d8f034373.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Ff81a6b40-ad3e-11ea-b044-d71d8f034373.jpg?alt=media&token=af781e30-fe2c-4937-af98-7de3c76559ab"
	  }],
	  productNameEnglish: "Shaving foar nivea foam smooth shave",
	  productPrice: "11",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "200mg",
	  updateDateTime: "04/07/2020 10:17:58"
	}, {
	  category: "COSMETICS",
	  key: "-M9gLx7ZYv2lDqyp_aFX",
	  photos: [{
	    imageName: "a55e4de0-ad3e-11ea-b044-d71d8f034373.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fa55e4de0-ad3e-11ea-b044-d71d8f034373.jpg?alt=media&token=02727822-b003-40ba-80d9-0f881370de31"
	  }],
	  productNameEnglish: "Shaving gel nivea men cool kick",
	  productPrice: "11",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "200ml",
	  updateDateTime: "04/07/2020 10:18:28"
	}, {
	  category: "DRINKS DESSERT",
	  key: "-M9gLUwl-HObFcAym0JH",
	  photos: [{
	    imageName: "8db86130-ad3e-11ea-9a01-db9ea96fa329.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F8db86130-ad3e-11ea-9a01-db9ea96fa329.jpg?alt=media&token=26fa96a3-e7d3-4955-b809-9df8617bd048"
	  }],
	  productNameEnglish: "MARIGOLD APPLE JUICE PACKET DRINK- CASE",
	  productPrice: "13",
	  productSupplier: "BCS SHOP",
	  sortOrder: "b",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "24x250ml",
	  updateDateTime: "04/07/2020 10:18:54"
	}, {
	  category: "DRINKS DESSERT",
	  key: "-M9gKh_rsgtAZRXpsFdD",
	  photos: [{
	    imageName: "1310d7f0-ad3e-11ea-9a01-db9ea96fa329.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F1310d7f0-ad3e-11ea-9a01-db9ea96fa329.jpg?alt=media&token=04e75b99-b651-45c8-8ca5-670c25cb2c8a"
	  }],
	  productNameEnglish: "MARIGOLD LESS SWEET LEMON BARLEY PACKET DRINK- CASE",
	  productPrice: "13",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "24x250ml",
	  updateDateTime: "04/07/2020 10:19:18"
	}, {
	  category: "COSMETICS",
	  key: "-M9gKgvBNYEfi7GuI0gp",
	  photos: [{
	    imageName: "ea7248b0-ad3d-11ea-b044-d71d8f034373.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fea7248b0-ad3d-11ea-b044-d71d8f034373.jpg?alt=media&token=23e8e3f7-ba07-4ee2-a375-4d193ab8a223"
	  }],
	  productNameEnglish: "Shaving foam sensitive",
	  productPrice: "5",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "200ml",
	  updateDateTime: "04/07/2020 10:19:58"
	}, {
	  category: "COSMETICS",
	  key: "-M9gKOicoJLEhs3LeP7H",
	  photos: [{
	    imageName: "70a89c50-ad3d-11ea-b044-d71d8f034373.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F70a89c50-ad3d-11ea-b044-d71d8f034373.jpg?alt=media&token=c4a59294-5ba1-4a78-8794-0c400f5270df"
	  }, {
	    imageName: "7485d680-ad3d-11ea-b044-d71d8f034373.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F7485d680-ad3d-11ea-b044-d71d8f034373.jpg?alt=media&token=3f02f0f4-aa9d-4165-9cbd-320544ceb0c7"
	  }],
	  productNameEnglish: "Shaving foam gillette foamy lemon lime",
	  productPrice: "7",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "175ml",
	  updateDateTime: "04/07/2020 10:20:11"
	}, {
	  category: "DRINKS DESSERT",
	  key: "-M9gJtbCb0YkR0UOC832",
	  photos: [{
	    imageName: "93e32a50-ad3d-11ea-9a01-db9ea96fa329.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F93e32a50-ad3d-11ea-9a01-db9ea96fa329.jpg?alt=media&token=d465428e-eb58-4e56-a18a-4730941b0d60"
	  }],
	  productNameEnglish: "NESCAFE WHITE COFFEE GAO SIEW DAI",
	  productPrice: "7.30",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "620g",
	  updateDateTime: "04/07/2020 10:20:27"
	}, {
	  category: "DRINKS DESSERT",
	  key: "-M9gJ0JxmR7x3MhyVPyr",
	  photos: [{
	    imageName: "0a8bdd10-ad3d-11ea-9a01-db9ea96fa329.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F0a8bdd10-ad3d-11ea-9a01-db9ea96fa329.jpg?alt=media&token=55ab4992-0f4d-4005-ba32-a3f2956c512b"
	  }],
	  productNameEnglish: "HEAVEN AND EARTH MANGO TEA WITH CHAMOMILE",
	  productPrice: "2.50",
	  productSupplier: "BCS SHOP",
	  sortOrder: "b",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1.5L",
	  updateDateTime: "04/07/2020 10:20:49"
	}, {
	  category: "SANITARY",
	  key: "-M9gIt0XRkIKwvG7mT3P",
	  photos: [{
	    imageName: "ce7664d0-ad3c-11ea-b044-d71d8f034373.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fce7664d0-ad3c-11ea-b044-d71d8f034373.jpg?alt=media&token=aab092f8-636b-46c0-b6df-f231cb4a47c8"
	  }],
	  productNameEnglish: "Toothbrush darlie charcoal clean    ",
	  productPrice: "5",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1pc",
	  updateDateTime: "04/07/2020 10:21:04"
	}, {
	  author: "+6589050302",
	  category: "DRINKS DESSERT",
	  isPopular: "YES",
	  key: "-M9gIBXZJGdkFxuAn3mh",
	  photos: [{
	    imageName: "886561d0-ad3c-11ea-9a01-db9ea96fa329.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F886561d0-ad3c-11ea-9a01-db9ea96fa329.jpg?alt=media&token=3ab8b277-a7bf-41c9-960f-4cb0f1cb7394"
	  }],
	  productNameEnglish: "SPRITE",
	  productPrice: "2.50",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1.5L",
	  updateDateTime: "11/07/2020 07:19:01"
	}, {
	  category: "SANITARY",
	  key: "-M9gI6whxYdQ3Cg9isJW",
	  photos: [{
	    imageName: "57aefbf0-ad3c-11ea-b044-d71d8f034373.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F57aefbf0-ad3c-11ea-b044-d71d8f034373.jpg?alt=media&token=a8122ab9-72fa-4cc8-a436-6f4d8e1449e0"
	  }],
	  productNameEnglish: "Toothbrush oral-B pulsar power soft  ",
	  productPrice: "15",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1pc",
	  updateDateTime: "04/07/2020 10:21:34"
	}, {
	  category: "DRINKS DESSERT",
	  key: "-M9gHdslTGbvMaokHlSy",
	  photos: [{
	    imageName: "34a36d30-ad3c-11ea-9a01-db9ea96fa329.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F34a36d30-ad3c-11ea-9a01-db9ea96fa329.jpg?alt=media&token=3d5c1a5c-0ab6-4b95-a38c-d3bab259cf03"
	  }],
	  productNameEnglish: "CERES WHISPERS OF SUMMER 100% JUICE",
	  productPrice: "2.70",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1L",
	  updateDateTime: "04/07/2020 10:22:07"
	}, {
	  category: "DRINKS DESSERT",
	  key: "-M9gGl_ykmk2MFL967d-",
	  photos: [{
	    imageName: "ab7f64f0-ad3b-11ea-9a01-db9ea96fa329.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fab7f64f0-ad3b-11ea-9a01-db9ea96fa329.jpg?alt=media&token=28b32328-b7e6-4533-89a6-2a7720829dab"
	  }],
	  productNameEnglish: "OLD TOWN 3 IN 1 CLASSIC WHITE COFFEE MIX",
	  productPrice: "7.50",
	  productSupplier: "BCS SHOP",
	  sortOrder: "g",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "15x38g",
	  updateDateTime: "04/07/2020 10:53:14"
	}, {
	  category: "TOILETRIES",
	  key: "-M9gGFKEWkHfoqW5in6t",
	  photos: [{
	    imageName: "2a2ab8a0-ad3b-11ea-b044-d71d8f034373.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F2a2ab8a0-ad3b-11ea-b044-d71d8f034373.jpg?alt=media&token=f35abdf8-f1c8-4c68-b7d0-81829f447870"
	  }],
	  productNameEnglish: "Toothpaste with toothbrush darlie double action travel kit     ",
	  productPrice: "5",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  updateDateTime: "04/07/2020 10:54:32"
	}, {
	  availability: "OUT OF STOCK, TOPPING UP IN PROGRESS",
	  category: "DRINKS DESSERT",
	  key: "-M9gG6hwg008BK17W3ne",
	  photos: [{
	    imageName: "44954390-ad3b-11ea-9a01-db9ea96fa329.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F44954390-ad3b-11ea-9a01-db9ea96fa329.jpg?alt=media&token=e2352caa-43cf-4159-9d42-345223b9098a"
	  }],
	  productNameEnglish: "LIPTON 3 IN 1 EARL GREY MILK TEA LATTE",
	  productPrice: "6",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "12x21g Sachet",
	  updateDateTime: "04/07/2020 10:54:46"
	}, {
	  category: "DRINKS DESSERT",
	  key: "-M9gFHdy1G5u9THo76iL",
	  photos: [{
	    imageName: "c1336220-ad3a-11ea-9a01-db9ea96fa329.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fc1336220-ad3a-11ea-9a01-db9ea96fa329.jpg?alt=media&token=9cca8dfe-0976-4833-b003-22f4ff21bc36"
	  }],
	  productNameEnglish: "OLD TOWN 3 IN 1 HAZELNUT WHITE COFFEE MIX",
	  productPrice: "7.50",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "15 x 40g",
	  updateDateTime: "04/07/2020 10:56:59"
	}, {
	  availability: "AVAILABLE",
	  category: "DRINKS DESSERT",
	  key: "-M9gEU9ioX8yOm2Yyle8",
	  photos: [{
	    imageName: "462f8810-ad3a-11ea-9a01-db9ea96fa329.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F462f8810-ad3a-11ea-9a01-db9ea96fa329.jpg?alt=media&token=e2518ae1-0f3e-42d6-970a-ae2b3ca8b55b"
	  }],
	  productNameEnglish: "MILO ACTIV-GO LOWER IN SUGER",
	  productPrice: "7",
	  productSupplier: "BCS SHOP",
	  searchText: "মিলো",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "15 x 33g",
	  updateDateTime: "17/07/2020 08:47:34"
	}, {
	  category: "LAUNDRY CLEANING",
	  key: "-M9gDRt4weDBMYJSfY8O",
	  photos: [{
	    imageName: "a40d5620-ad39-11ea-9a01-db9ea96fa329.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fa40d5620-ad39-11ea-9a01-db9ea96fa329.jpg?alt=media&token=35637b16-0b6b-47cc-ac69-75272a0e4df0"
	  }],
	  productNameEnglish: "RIBENA BLACKCURRANT LESS SWEET FRUIT DRINK",
	  productPrice: "3.80",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "6x200ml",
	  updateDateTime: "04/07/2020 11:06:59"
	}, {
	  category: "EGGS DAIRY",
	  isPopular: "YES",
	  key: "-M9gCSog7V0Vdy8tUqRW",
	  photos: [{
	    imageName: "09d1d8b0-ad39-11ea-9a01-db9ea96fa329.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F09d1d8b0-ad39-11ea-9a01-db9ea96fa329.jpg?alt=media&token=0e6309ca-1e09-4b48-9349-d330afa8a9eb"
	  }],
	  productNameEnglish: "MILKMAID FULL CREAM SWEETENED CONDENSED MILK",
	  productPrice: "1.80",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "392g",
	  updateDateTime: "04/07/2020 11:07:20"
	}, {
	  category: "TOILETRIES",
	  key: "-M9gCMyomakJx06w1EuF",
	  photos: [{
	    imageName: "db223f50-ad38-11ea-b044-d71d8f034373.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fdb223f50-ad38-11ea-b044-d71d8f034373.jpg?alt=media&token=af6a4cc1-2e16-4caa-b67b-62e6262c1697"
	  }],
	  productNameEnglish: "Toothpaste darlie shiny whiteenamel care",
	  productPrice: "4.5",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "140gm",
	  updateDateTime: "04/07/2020 11:09:32"
	}, {
	  category: "DRINKS DESSERT",
	  key: "-M9gBSfrNX8yNfsJsVd9",
	  photos: [{
	    imageName: "6b0d9ed0-ad38-11ea-9a01-db9ea96fa329.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F6b0d9ed0-ad38-11ea-9a01-db9ea96fa329.jpg?alt=media&token=7cfc70f4-0f8e-48d4-b457-320395c81dbc"
	  }],
	  productNameEnglish: "HEAVEN AND EARTH JASMINE GREEN TEA",
	  productPrice: "2.20",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1.5L",
	  updateDateTime: "04/07/2020 11:10:07"
	}, {
	  category: "DRINKS DESSERT",
	  key: "-M9gAmjVmP2ozJ5t6z3s",
	  photos: [{
	    imageName: "044d73a0-ad38-11ea-9a01-db9ea96fa329.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F044d73a0-ad38-11ea-9a01-db9ea96fa329.jpg?alt=media&token=0b38f9fa-338f-46b9-8112-5212ecc38a16"
	  }],
	  productNameEnglish: "POKKA ICE LEMON TEA (1.5l)",
	  productPrice: "2.30",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  updateDateTime: "04/07/2020 11:23:01"
	}, {
	  category: "DRINKS DESSERT",
	  key: "-M9gAIZl89X4bVR6jHlt",
	  photos: [{
	    imageName: "b884f830-ad37-11ea-9a01-db9ea96fa329.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fb884f830-ad37-11ea-9a01-db9ea96fa329.jpg?alt=media&token=6236bbc9-1d91-465a-80b2-b668972d6651"
	  }],
	  productNameEnglish: "POKKA NATSBEE HONEY YUZU TEA (6x250ml)",
	  productPrice: "3.30",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  updateDateTime: "04/07/2020 11:23:09"
	}, {
	  category: "DRINKS DESSERT",
	  key: "-M9g9_hjSZxXAgwz6z9i",
	  photos: [{
	    imageName: "48efe7f0-ad37-11ea-9a01-db9ea96fa329.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F48efe7f0-ad37-11ea-9a01-db9ea96fa329.jpg?alt=media&token=35fca560-62a9-43de-9afa-da7aa8fa06db"
	  }],
	  productNameEnglish: "ICE MOUNTAIN PURE DRINKING WATER - CASE (24x600ml)",
	  productPrice: "9",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  updateDateTime: "04/07/2020 11:23:23"
	}, {
	  category: "DRINKS DESSERT",
	  key: "-M9g64A28yZ3G0rpr37k",
	  photos: [{
	    imageName: "24dd8270-ad35-11ea-9a01-db9ea96fa329.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F24dd8270-ad35-11ea-9a01-db9ea96fa329.jpg?alt=media&token=1720c027-4045-4562-ba65-acd92e81b7f3"
	  }],
	  productNameEnglish: "JEJU SAMDASOO NATURAL KOREAN MINERAL WATER - CASE",
	  productPrice: "11.50",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "6 x 2L",
	  updateDateTime: "04/07/2020 11:23:55"
	}, {
	  category: "DRINKS DESSERT",
	  key: "-M9g56tFxoB1fRkZZD9F",
	  photos: [{
	    imageName: "8f622520-ad34-11ea-9a01-db9ea96fa329.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F8f622520-ad34-11ea-9a01-db9ea96fa329.jpg?alt=media&token=1fc71b99-2a2c-426f-bdb0-2b359fdcbf25"
	  }],
	  productNameEnglish: "NESCAFE ORIGINAL 3 IN 1 INSTANT COFFEE",
	  productPrice: "7.50",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "35 per pack",
	  updateDateTime: "04/07/2020 11:24:20"
	}, {
	  category: "DRINKS DESSERT",
	  key: "-M9fkswjeL4wt6eRouVn",
	  photos: [{
	    imageName: "985ca680-ad27-11ea-9a01-db9ea96fa329.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F985ca680-ad27-11ea-9a01-db9ea96fa329.jpg?alt=media&token=97a8a80b-b5f2-4bf8-9348-13092ef6f040"
	  }],
	  productNameEnglish: "UFC REFRESH 100% NATURAL COCONUT WATER",
	  productPrice: "3.80",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1L",
	  updateDateTime: "04/07/2020 11:24:44"
	}, {
	  category: "DRINKS DESSERT",
	  key: "-M9fkE_F7sw40RiQnwnz",
	  photos: [{
	    imageName: "34867be0-ad27-11ea-9a01-db9ea96fa329.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F34867be0-ad27-11ea-9a01-db9ea96fa329.jpg?alt=media&token=edcb9fa4-f5cf-47a1-9cdf-42a48d6c66d2"
	  }],
	  productNameEnglish: "VITASOY ORIGINAL SOYA BEAN DRINK",
	  productPrice: "3.20",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "6 x 250ml",
	  updateDateTime: "04/07/2020 11:25:05"
	}, {
	  availability: "OUT OF STOCK, TOPPING UP IN PROGRESS",
	  category: "DRINKS DESSERT",
	  key: "-M9fjUUrEMphycJgyMj7",
	  photos: [{
	    imageName: "bee40b00-ad26-11ea-9a01-db9ea96fa329.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fbee40b00-ad26-11ea-9a01-db9ea96fa329.jpg?alt=media&token=8c751b55-900e-489b-a00d-9a24187ee685"
	  }],
	  productNameEnglish: "POKKA HOUJICHA TEA NO SUGAR",
	  productPrice: "2.70",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1.5L",
	  updateDateTime: "04/07/2020 11:25:14"
	}, {
	  author: "+6589050302",
	  category: "DRINKS DESSERT",
	  key: "-M9fioFzWCqGG8o7tc88",
	  photos: [{
	    imageName: "55884d60-ad26-11ea-9a01-db9ea96fa329.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F55884d60-ad26-11ea-9a01-db9ea96fa329.jpg?alt=media&token=f9fdd525-8908-49e8-bc7a-0253dc6b4adb"
	  }],
	  productNameEnglish: "OSK 100% JAPANESE GREEN TEA",
	  productPrice: "7.95",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "50 per pack",
	  updateDateTime: "17/07/2020 08:54:46"
	}, {
	  category: "DRINKS DESSERT",
	  key: "-M9fi9A55AA8Ab9YUuvA",
	  photos: [{
	    imageName: "ee6fa1f0-ad25-11ea-9a01-db9ea96fa329.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fee6fa1f0-ad25-11ea-9a01-db9ea96fa329.jpg?alt=media&token=21edf8dd-358a-42df-b5e7-528ff8c88614"
	  }],
	  productNameEnglish: "F&N ROSE SYRUP CORDIAL",
	  productPrice: "4.50",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "2L",
	  updateDateTime: "04/07/2020 11:25:53"
	}, {
	  category: "TOILETRIES",
	  key: "-M9fhaow2dFpVyUAre4G",
	  photos: [{
	    imageName: "726617b0-ad25-11ea-b044-d71d8f034373.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F726617b0-ad25-11ea-b044-d71d8f034373.jpg?alt=media&token=f9156b26-6dc4-406e-a45a-751652817148"
	  }],
	  productNameEnglish: "Tootthpast colgate sensitive pro relief whitening",
	  productPrice: "9",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "110gm",
	  updateDateTime: "04/07/2020 11:26:16"
	}, {
	  category: "DRINKS DESSERT",
	  key: "-M9fhS6QGXX68eQ9dmb3",
	  photos: [{
	    imageName: "802adf70-ad25-11ea-9a01-db9ea96fa329.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F802adf70-ad25-11ea-9a01-db9ea96fa329.jpg?alt=media&token=7621a176-01e6-40cd-b809-31d3b39e5a1c"
	  }],
	  productNameEnglish: "POKKA JASMINE GREEN TEA",
	  productPrice: "2.30",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1.5L",
	  updateDateTime: "04/07/2020 11:26:34"
	}, {
	  category: "DRINKS DESSERT",
	  key: "-M9fgZ4S4Tq9T__XGHiN",
	  photos: [{
	    imageName: "25e548c0-ad25-11ea-9a01-db9ea96fa329.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F25e548c0-ad25-11ea-9a01-db9ea96fa329.jpg?alt=media&token=fb3b1f7a-ebc9-4e70-a82c-8a58d72197d3"
	  }],
	  productNameEnglish: "SAN BENEDETTO SPARKLING MINERAL WATER - CASE",
	  productPrice: "12.20",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "6 x 1.5L",
	  updateDateTime: "04/07/2020 11:26:58"
	}, {
	  category: "DRINKS DESSERT",
	  key: "-M9ffhpl0STp-dpqg1Ji",
	  photos: [{
	    imageName: "70ca1060-ad24-11ea-9a01-db9ea96fa329.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F70ca1060-ad24-11ea-9a01-db9ea96fa329.jpg?alt=media&token=f1aea3e2-1205-4c4e-a682-9262748d2d5b"
	  }],
	  productNameEnglish: "ICE MOUNTAIN PURE DRINKING WATER- CASE",
	  productPrice: "10",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "12 x 1.5L",
	  updateDateTime: "04/07/2020 11:27:22"
	}, {
	  category: "DRINKS DESSERT",
	  key: "-M9fdkLQJ3_O_3qHgsbi",
	  photos: [{
	    imageName: "3e94c820-ad23-11ea-9a01-db9ea96fa329.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F3e94c820-ad23-11ea-9a01-db9ea96fa329.jpg?alt=media&token=03f37920-52bd-4c2d-854c-ea7c3420f5ec"
	  }],
	  productNameEnglish: "DASANI DRINKING WATER- CASE",
	  productPrice: "9",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "12 x 1.5L",
	  updateDateTime: "04/07/2020 11:27:53"
	}, {
	  category: "TOILETRIES",
	  key: "-M9fdjCqSSk0r_sBqHgH",
	  photos: [{
	    imageName: "21e926d0-ad23-11ea-bbe8-977967140bbe.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F21e926d0-ad23-11ea-bbe8-977967140bbe.jpg?alt=media&token=3575636d-028e-43f7-b4e4-3ebdeae6832b"
	  }],
	  productNameEnglish: "Mouthwash cool mint",
	  productPrice: "12.5",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1L",
	  updateDateTime: "04/07/2020 11:28:24"
	}, {
	  category: "TOILETRIES",
	  key: "-M9fcF5ZkBOD12P39W6C",
	  photos: [{
	    imageName: "2742e450-ad22-11ea-bbe8-977967140bbe.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F2742e450-ad22-11ea-bbe8-977967140bbe.jpg?alt=media&token=20a426d3-5a61-41c0-bf5d-cac18dc2f593"
	  }],
	  productNameEnglish: "Toothpost colgate advanced white valuepack",
	  productPrice: "6.5",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "160gm×2pc",
	  updateDateTime: "04/07/2020 11:21:01"
	}, {
	  category: "DRINKS DESSERT",
	  key: "-M9fcC0Jn-Cd6p09bqaZ",
	  photos: [{
	    imageName: "4c129140-ad22-11ea-9a01-db9ea96fa329.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F4c129140-ad22-11ea-9a01-db9ea96fa329.jpg?alt=media&token=aed48a53-242a-4ede-a4c1-22c0ab0dedca"
	  }],
	  productNameEnglish: "DASANI MINERAL WATER - CASE",
	  productPrice: "11.5",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "12 x 1.5L",
	  updateDateTime: "04/07/2020 11:42:16"
	}, {
	  availability: "OUT OF STOCK, TOPPING UP IN PROGRESS",
	  category: "DRINKS DESSERT",
	  key: "-M9fbbIcnGhCU3f_okTc",
	  photos: [{
	    imageName: "ddec02a0-bf8c-11ea-85e3-735b22b1a0db.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fddec02a0-bf8c-11ea-85e3-735b22b1a0db.jpg?alt=media&token=f8e07c33-bd1b-43fe-ad81-67b626938634"
	  }],
	  productNameEnglish: "POKKA NO SUGAR OOLONG TEA",
	  productPrice: "2.30",
	  productSupplier: "BCS SHOP",
	  searchText: "পকা শুগার ওলং চা ",
	  sortOrder: "x",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1.5L",
	  updateDateTime: "06/07/2020 09:31:29"
	}, {
	  availability: "AVAILABLE",
	  category: "RICE DAAL NOODLES",
	  isPopular: "YES",
	  key: "-M9faHN_6liw96XMkKvd",
	  photos: [{
	    imageName: "1f949a60-ad21-11ea-9a01-db9ea96fa329.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F1f949a60-ad21-11ea-9a01-db9ea96fa329.jpg?alt=media&token=cc2aeda7-af86-483b-a3e1-2cd897649ea3"
	  }],
	  productNameEnglish: "MAGGI 2-MIN CURRY NOODLES",
	  productPrice: "2.90",
	  productSupplier: "BCS SHOP",
	  searchText: "mi goreng",
	  sortOrder: "a",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "5x79g Packets",
	  updateDateTime: "17/07/2020 06:54:18"
	}, {
	  availability: "AVAILABLE",
	  category: "RICE DAAL NOODLES",
	  isPopular: "YES",
	  key: "-M9fZqq9ZQaum3QmTD2W",
	  photos: [{
	    imageName: "407ffdb0-ad20-11ea-9a01-db9ea96fa329.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F407ffdb0-ad20-11ea-9a01-db9ea96fa329.jpg?alt=media&token=234d5097-afd8-47b9-be11-31dbce5f6f5d"
	  }],
	  productNameEnglish: "MYOJO CHICKEN ABALONE FLAVOURED INSTANT NOODLES ",
	  productPrice: "2.5",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "5 pack 79gm",
	  updateDateTime: "17/07/2020 06:53:25"
	}, {
	  availability: "AVAILABLE",
	  category: "RICE DAAL NOODLES",
	  key: "-M9fYouusyu6N1mtP-ee",
	  photos: [{
	    imageName: "a0082060-ad1f-11ea-9a01-db9ea96fa329.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fa0082060-ad1f-11ea-9a01-db9ea96fa329.jpg?alt=media&token=5f36bec9-4091-42b6-b726-42e0e716409e"
	  }],
	  productNameEnglish: "NISSIN SEAFOOD FLAVOUR CUP NOODLES",
	  productPrice: "2",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "Cup 75g",
	  updateDateTime: "17/07/2020 06:53:40"
	}, {
	  category: "COOKING OIL INGREDIENTS",
	  key: "-M9fY8PRxRRgFSg4VoDC",
	  photos: [{
	    imageName: "355bc6e0-ad1f-11ea-9a01-db9ea96fa329.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F355bc6e0-ad1f-11ea-9a01-db9ea96fa329.jpg?alt=media&token=867996e2-0035-4b7e-b3f9-314b813338ec"
	  }],
	  productNameEnglish: "GOLDEN CIRCLE SUNFLOWER OIL",
	  productPrice: "15",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "5L",
	  updateDateTime: "04/07/2020 11:50:50"
	}, {
	  category: "COOKING OIL INGREDIENTS",
	  key: "-M9fX8o43RsfQQVRYJay",
	  photos: [{
	    imageName: "9a69f1c0-ad1e-11ea-9a01-db9ea96fa329.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F9a69f1c0-ad1e-11ea-9a01-db9ea96fa329.jpg?alt=media&token=eff85424-43fc-4615-a3bb-6f69ffe926ac"
	  }],
	  productNameEnglish: "BORGES OLIVE OIL",
	  productPrice: "8.50",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "500ml",
	  updateDateTime: "04/07/2020 11:51:13"
	}, {
	  category: "COOKING OIL INGREDIENTS",
	  key: "-M9fWgVH0Saajjgwca01",
	  photos: [{
	    imageName: "4f592d90-ad1e-11ea-9a01-db9ea96fa329.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F4f592d90-ad1e-11ea-9a01-db9ea96fa329.jpg?alt=media&token=25af8b2c-bd2d-4313-bc12-165cd8b23390"
	  }],
	  productNameEnglish: "OKI PREMIUM SUNFLOWER OIL",
	  productPrice: "7.90",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "2L",
	  updateDateTime: "Tue 18-08-20 9:07 am"
	}, {
	  category: "COOKING OIL INGREDIENTS",
	  key: "-M9fWDRRy5rGN0ssRTbd",
	  photos: [{
	    imageName: "09735940-ad1e-11ea-9a01-db9ea96fa329.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F09735940-ad1e-11ea-9a01-db9ea96fa329.jpg?alt=media&token=28d27ee0-f020-4787-9258-5f72de09ff3b"
	  }],
	  productNameEnglish: "MAGGI CHILLI SAUCE",
	  productPrice: "2.70",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "500g",
	  updateDateTime: "04/07/2020 11:56:56"
	}, {
	  category: "RICE DAAL NOODLES",
	  key: "-M9fViWxjrPp1dB01tGR",
	  photos: [{
	    imageName: "bc02fa30-ad1d-11ea-9a01-db9ea96fa329.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fbc02fa30-ad1d-11ea-9a01-db9ea96fa329.jpg?alt=media&token=bcd0b863-4411-4a10-86c3-263d8e475175"
	  }],
	  productNameEnglish: "NATUREL ORGANIC MACARONI",
	  productPrice: "3.80",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "500g",
	  updateDateTime: "05/07/2020 12:00:21"
	}, {
	  category: "COOKING OIL INGREDIENTS",
	  key: "-M9fUyvL2TFHVdiq4r-Y",
	  photos: [{
	    imageName: "47b061e0-ad1d-11ea-9a01-db9ea96fa329.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F47b061e0-ad1d-11ea-9a01-db9ea96fa329.jpg?alt=media&token=e3e14745-32f5-4c48-84fa-302273e30645"
	  }],
	  productNameEnglish: "NATUREL SUNFLOWER OIL",
	  productPrice: "5.80",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1L",
	  updateDateTime: "04/07/2020 11:51:43"
	}, {
	  category: "COOKING OIL INGREDIENTS",
	  key: "-M9fUL-PSLdd30YrWxBO",
	  photos: [{
	    imageName: "e2c5e110-ad1c-11ea-9a01-db9ea96fa329.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fe2c5e110-ad1c-11ea-9a01-db9ea96fa329.jpg?alt=media&token=63201167-0871-45b0-9cff-b678fbc51ee9"
	  }],
	  productNameEnglish: "OKI PREMIUM SOYA BEAN OIL",
	  productPrice: "7.40",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "2L",
	  updateDateTime: "04/07/2020 11:51:54"
	}, {
	  category: "COOKING OIL INGREDIENTS",
	  key: "-M9fS0nIqI8eUKzfLF7t",
	  photos: [{
	    imageName: "7a48e020-ad1b-11ea-8bc0-03f48af12a9c.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F7a48e020-ad1b-11ea-8bc0-03f48af12a9c.jpg?alt=media&token=eaf48a60-1e24-47dd-992f-a5b47261b712"
	  }],
	  productNameEnglish: "NATUREL CANOLA OIL",
	  productPrice: "9.80",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "2L",
	  updateDateTime: "04/07/2020 11:53:52"
	}, {
	  category: "RICE DAAL NOODLES",
	  key: "-M9fRZ2AHbpan9u1pLF0",
	  photos: [{
	    imageName: "31b6fea0-ad1b-11ea-8bc0-03f48af12a9c.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F31b6fea0-ad1b-11ea-8bc0-03f48af12a9c.jpg?alt=media&token=02686466-3d0c-4706-8fd3-8420ef6d7640"
	  }],
	  productNameEnglish: "SONGHE WHOLE KERNEL THAI HOM MAIL RICE",
	  productPrice: "33",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "10 Kg",
	  updateDateTime: "05/07/2020 12:00:43"
	}, {
	  category: "COOKING OIL INGREDIENTS",
	  key: "-M9fQhmeLH__-yY3QLsP",
	  photos: [{
	    imageName: "acaee740-ad1a-11ea-8bc0-03f48af12a9c.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Facaee740-ad1a-11ea-8bc0-03f48af12a9c.jpg?alt=media&token=0fc3a22f-d19c-4c2c-a6ba-f351d97db93d"
	  }],
	  productNameEnglish: "NARCISSUS RICE VINEGAR",
	  productPrice: "1.50",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "600g",
	  updateDateTime: "05/07/2020 12:01:03"
	}, {
	  category: "COOKING OIL INGREDIENTS",
	  key: "-M9fPzIDhh8bCX8S4Cvm",
	  photos: [{
	    imageName: "3b930ff0-ad1a-11ea-8bc0-03f48af12a9c.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F3b930ff0-ad1a-11ea-8bc0-03f48af12a9c.jpg?alt=media&token=48d43754-9e46-4874-b128-4cc73093ea02"
	  }],
	  productNameEnglish: "TIGER BRAND WHITE ARTIFICIAL VINEGAR",
	  productPrice: "4.10",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "2L",
	  updateDateTime: "05/07/2020 12:01:27"
	}, {
	  category: "COOKING OIL INGREDIENTS",
	  key: "-M9fPBcONK70vV-e3ZX2",
	  photos: [{
	    imageName: "bfc11070-ad19-11ea-8bc0-03f48af12a9c.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fbfc11070-ad19-11ea-8bc0-03f48af12a9c.jpg?alt=media&token=91fd21e5-795b-46cf-8193-4d20818acf35"
	  }],
	  productNameEnglish: "HOSEN PINEAPPLE SLICE",
	  productPrice: "2",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "565g",
	  updateDateTime: "05/07/2020 12:02:12"
	}, {
	  category: "COOKING OIL INGREDIENTS",
	  key: "-M9fOV-yMxcL9A6pqBzA",
	  photos: [{
	    imageName: "5312cc70-ad19-11ea-8bc0-03f48af12a9c.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F5312cc70-ad19-11ea-8bc0-03f48af12a9c.jpg?alt=media&token=7a7ec498-d269-4746-8efe-5de37bf4e9ed"
	  }],
	  productNameEnglish: "BORGES OLIVE OIL EXTRA LIGHT",
	  productPrice: "29",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "2L",
	  updateDateTime: "04/07/2020 11:54:04"
	}, {
	  category: "COOKING OIL INGREDIENTS",
	  key: "-M9fNmYQMpqHtcYCzeN5",
	  photos: [{
	    imageName: "e3964d40-ad18-11ea-8bc0-03f48af12a9c.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fe3964d40-ad18-11ea-8bc0-03f48af12a9c.jpg?alt=media&token=5c975983-93cc-4903-81c2-69a5eaed9835"
	  }],
	  productNameEnglish: "EXTRA VIRGIN OLIVE OIL",
	  productPrice: "14",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1L",
	  updateDateTime: "04/07/2020 11:54:15"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  key: "-M9fMr2qCr1ml6DTdCaT",
	  photos: [{
	    imageName: "52a9c6e0-ad18-11ea-8bc0-03f48af12a9c.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F52a9c6e0-ad18-11ea-8bc0-03f48af12a9c.jpg?alt=media&token=02bc8234-8baf-4684-87ec-49f11199e839"
	  }],
	  productNameEnglish: "MAGGI TOMATO KETCHUP (HEALTHIER CHOICE)",
	  productPrice: "2",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "475g",
	  updateDateTime: "17/07/2020 08:30:55"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  key: "-M9fLfe0t6KCs7xmFC-a",
	  photos: [{
	    imageName: "9a6932a0-ad17-11ea-8bc0-03f48af12a9c.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F9a6932a0-ad17-11ea-8bc0-03f48af12a9c.jpg?alt=media&token=6adebbe5-a6d7-44b8-9449-853d515a60bf"
	  }],
	  productNameEnglish: "NATUREL EXTRA VIRGIN OLIVE OIL",
	  productPrice: "9",
	  productSupplier: "BCS SHOP",
	  searchText: "অলিভ অয়েল",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "500ml",
	  updateDateTime: "17/07/2020 07:35:16"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  key: "-M9fKkWFv5n6-RqH2DpL",
	  photos: [{
	    imageName: "07832630-ad17-11ea-8bc0-03f48af12a9c.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F07832630-ad17-11ea-8bc0-03f48af12a9c.jpg?alt=media&token=13bbb1f5-cd46-42c8-82d7-ff23b01d0a55"
	  }],
	  productNameEnglish: "PAGODA SEA SALT",
	  productPrice: "0.90",
	  productSupplier: "BCS SHOP",
	  searchText: "লবণ লবন",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "500g",
	  updateDateTime: "17/07/2020 08:50:15"
	}, {
	  category: "EGGS DAIRY",
	  key: "-M9fJG42PU0cJpHalor2",
	  photos: [{
	    imageName: "20dde440-ad16-11ea-8bc0-03f48af12a9c.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F20dde440-ad16-11ea-8bc0-03f48af12a9c.jpg?alt=media&token=d3d56b08-6320-4678-8f69-edfcce6be78b"
	  }],
	  productNameEnglish: "AYAM BRAND COCONUT MILK",
	  productPrice: "1.50",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "200ml",
	  updateDateTime: "05/07/2020 12:03:09"
	}, {
	  availability: "AVAILABLE",
	  category: "POPULAR",
	  isPopular: "YES",
	  key: "-M9fIeLqNa6uImfqltyH",
	  photos: [{
	    imageName: "9354b8a0-f97e-11ea-8999-bfa3df93f633.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F9354b8a0-f97e-11ea-8999-bfa3df93f633.jpg?alt=media&token=3718d897-6ec4-4b58-992b-e029e262f565"
	  }],
	  productNameEnglish: "Carrot 1kg ",
	  productPrice: "3.5",
	  productSupplier: "BCS SHOP",
	  searchText: "শাক সবজি সব্জি গাঁজর গাজর ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1kg",
	  updateDateTime: "Fri 18-09-20 3:14 pm"
	}, {
	  category: "EGGS DAIRY",
	  key: "-M9fIcMquTFfIRhPW08R",
	  photos: [{
	    imageName: "bbcd8bf0-ad15-11ea-8bc0-03f48af12a9c.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fbbcd8bf0-ad15-11ea-8bc0-03f48af12a9c.jpg?alt=media&token=a8eb7c43-0dba-4a1d-a3d3-637dbff8213a"
	  }],
	  productNameEnglish: "SAN REMO PASTA PENNE",
	  productPrice: "2.60",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "500g",
	  updateDateTime: "05/07/2020 12:03:22"
	}, {
	  category: "FRUITS VEGETABLES ",
	  key: "-M9fIYlyi8xetbpfusCw",
	  photos: [{
	    imageName: "892f5340-ad15-11ea-abb1-91c43b08e32b.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F892f5340-ad15-11ea-abb1-91c43b08e32b.jpg?alt=media&token=4bb9b087-f6d1-4d94-9fe4-1d9e1c8f954b"
	  }],
	  productNameEnglish: "Starfruit",
	  productPrice: "3.7",
	  productSupplier: "BCS SHOP",
	  searchText: "কামরাঙ্গা কামরাঙা ",
	  sortOrder: "d",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1 Pkt",
	  updateDateTime: "17/07/2020 02:18:09"
	}, {
	  category: "RICE DAAL NOODLES",
	  key: "-M9fHyrwa8H7s_aiAHMD",
	  photos: [{
	    imageName: "58671310-ad15-11ea-8bc0-03f48af12a9c.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F58671310-ad15-11ea-8bc0-03f48af12a9c.jpg?alt=media&token=66052056-5e57-467d-9541-be60d991ffef"
	  }],
	  productNameEnglish: "SAN REMO PASTA ELBOWS",
	  productPrice: "2.60",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "500g",
	  updateDateTime: "05/07/2020 12:05:27"
	}, {
	  category: "COOKING OIL INGREDIENTS",
	  key: "-M9fHP84oZPiAZSRRsOP",
	  photos: [{
	    imageName: "bbcff260-ad14-11ea-9aab-f922f3904dfb.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fbbcff260-ad14-11ea-9aab-f922f3904dfb.jpg?alt=media&token=934ff842-6292-41be-a5f6-9974a4382200"
	  }],
	  productNameEnglish: "Tamarind",
	  productPrice: "8",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1 box",
	  updateDateTime: "05/07/2020 12:07:26"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  key: "-M9fHMrVBEGYkGPsl98Q",
	  photos: [{
	    imageName: "f954d920-ad14-11ea-8bc0-03f48af12a9c.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Ff954d920-ad14-11ea-8bc0-03f48af12a9c.jpg?alt=media&token=50a9ce25-4ef7-4149-97b4-413063b91f9f"
	  }],
	  productNameEnglish: "PAGODA FINE SALT",
	  productPrice: "0.90",
	  productSupplier: "BCS SHOP",
	  searchText: "লবণ লবন ",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "500g",
	  updateDateTime: "17/07/2020 08:50:31"
	}, {
	  category: "COOKING OIL INGREDIENTS",
	  key: "-M9fGR1cZRc2bfPjl_2a",
	  photos: [{
	    imageName: "66a45ba0-ad14-11ea-8bc0-03f48af12a9c.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F66a45ba0-ad14-11ea-8bc0-03f48af12a9c.jpg?alt=media&token=87707f0b-cecb-4e74-8305-c787f1c76b29"
	  }],
	  productNameEnglish: "BORGEST EXTRA VIRGIN OLIVE OIL",
	  productPrice: "18",
	  productSupplier: "BCS SHOP",
	  searchText: "অলিভ অয়েল ",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1L",
	  updateDateTime: "17/07/2020 02:20:16"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  key: "-M9fFTX-LeUHsdP4_K_4",
	  photos: [{
	    imageName: "d12750a0-ad13-11ea-8bc0-03f48af12a9c.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fd12750a0-ad13-11ea-8bc0-03f48af12a9c.jpg?alt=media&token=6a12f0a6-ea0e-4eb5-b309-d170d9416dd7"
	  }],
	  productNameEnglish: "NATUREL PURE OLIVE OIL",
	  productPrice: "28",
	  productSupplier: "BCS SHOP",
	  searchText: "অলিভ অয়েল ",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "2L",
	  updateDateTime: "17/07/2020 02:20:53"
	}, {
	  category: "COOKING OIL INGREDIENTS",
	  key: "-M9fEv9wilhI77kVkDgi",
	  photos: [{
	    imageName: "79b1c9e0-ad13-11ea-8bc0-03f48af12a9c.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F79b1c9e0-ad13-11ea-8bc0-03f48af12a9c.jpg?alt=media&token=2ffbae79-99c5-4212-b576-e0e505d8c906"
	  }],
	  productNameEnglish: "KARA UHT NATURAL COCONUT CREAM",
	  productPrice: "1",
	  productSupplier: "BCS SHOP",
	  searchText: "নারিকেল ক্রিম ",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "200ml",
	  updateDateTime: "17/07/2020 02:32:43"
	}, {
	  category: "TOILETRIES",
	  key: "-M9fEMX1hiDu41exdO7F",
	  photos: [{
	    imageName: "fc01e2a0-ad12-11ea-9aab-f922f3904dfb.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Ffc01e2a0-ad12-11ea-9aab-f922f3904dfb.jpg?alt=media&token=23df00af-8d10-4b86-9846-1dc7d207f6c6"
	  }],
	  productNameEnglish: "Cottony pursoft 3ply B/T",
	  productPrice: "8.5",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "10 roll x 1pkt",
	  updateDateTime: "05/07/2020 12:29:11"
	}, {
	  category: "COOKING OIL INGREDIENTS",
	  key: "-M9fEJ2SMkO5D8A_eiQ7",
	  photos: [{
	    imageName: "1ad63050-ad13-11ea-8bc0-03f48af12a9c.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F1ad63050-ad13-11ea-8bc0-03f48af12a9c.jpg?alt=media&token=b4790a09-ae84-4756-87df-3a03864bf3b6"
	  }],
	  productNameEnglish: "LEE KUM KEE PANDA OYSTER SAUCE",
	  productPrice: "3.80",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "510g",
	  updateDateTime: "05/07/2020 12:29:30"
	}, {
	  category: "TOILETRIES",
	  key: "-M9fDzi6Dop6f0UEozcs",
	  photos: [{
	    imageName: "aac5d590-ad12-11ea-9aab-f922f3904dfb.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Faac5d590-ad12-11ea-9aab-f922f3904dfb.jpg?alt=media&token=7b3936ca-bf59-4ffd-bdcd-d12fa3308775"
	  }],
	  productNameEnglish: "Cottony Kleenex 3ply B/T",
	  productPrice: "17",
	  productSupplier: "BCS SHOP",
	  searchText: "টিস্যু পেপার ",
	  sortOrder: "d",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "20roll x 1packet ",
	  updateDateTime: "17/07/2020 02:37:11"
	}, {
	  category: "RICE DAAL NOODLES",
	  key: "-M9fDXrY0QwDR0Fy97Zl",
	  photos: [{
	    imageName: "9e29fd70-ad12-11ea-8bc0-03f48af12a9c.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F9e29fd70-ad12-11ea-8bc0-03f48af12a9c.jpg?alt=media&token=cad40c24-43a0-4722-8d7e-46309f977a36"
	  }],
	  productNameEnglish: "SAN REMO PASTA LINGUINE",
	  productPrice: "2.60",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "500g",
	  updateDateTime: "05/07/2020 12:30:29"
	}, {
	  category: "KITCHEN DINING",
	  key: "-M9fBN8ThHVka9M64fw_",
	  photos: [{
	    imageName: "2111b7c0-ad11-11ea-9aab-f922f3904dfb.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F2111b7c0-ad11-11ea-9aab-f922f3904dfb.jpg?alt=media&token=03cc8cbf-b3ac-4a18-9e9e-ec8e37f819b8"
	  }],
	  productNameEnglish: "Spoon",
	  productPrice: "5",
	  productSupplier: "BCS SHOP",
	  searchText: "চামচ ",
	  sortOrder: "x",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1 pc",
	  updateDateTime: "17/07/2020 02:37:47"
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  key: "-M9f8BRtoL4FZNlxklmG",
	  photos: [{
	    imageName: "3d7676f0-ad0f-11ea-873f-e1ac34f7defb.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F3d7676f0-ad0f-11ea-873f-e1ac34f7defb.jpg?alt=media&token=b0dda013-3aa5-4134-86a9-baf88f84a0f0"
	  }],
	  productNameEnglish: "Capsicum msia 3pic one set",
	  productPrice: "5",
	  productSupplier: "BCS SHOP",
	  sortOrder: "g",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "3 pcs",
	  updateDateTime: "15/07/2020 12:21:53"
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  key: "-M9f6r8w7-gwzLv4HabH",
	  photos: [{
	    imageName: "654c5f00-ad0f-11ea-873f-e1ac34f7defb.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F654c5f00-ad0f-11ea-873f-e1ac34f7defb.jpg?alt=media&token=de0ae61f-ede5-4c03-8069-b05f75bb4df8"
	  }],
	  productNameEnglish: "Capsicum yellow msia 1kg",
	  productPrice: "7",
	  productSupplier: "BCS SHOP",
	  sortOrder: "g",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1kg",
	  updateDateTime: "15/07/2020 12:22:36"
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  key: "-M9f6fP0n9ImeGTLSHMu",
	  photos: [{
	    imageName: "716153e0-ad0f-11ea-873f-e1ac34f7defb.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F716153e0-ad0f-11ea-873f-e1ac34f7defb.jpg?alt=media&token=774146ef-f66c-4166-ba98-ba31d85640b2"
	  }],
	  productNameEnglish: "Capsicum red msia 1kg",
	  productPrice: "6.8",
	  productSupplier: "BCS SHOP",
	  sortOrder: "g",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1 kg",
	  updateDateTime: "15/07/2020 12:23:01"
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  key: "-M9f6NsuqgGRpQGN_8t1",
	  photos: [{
	    imageName: "169a2f10-c653-11ea-8937-41f6a00ee84d.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F169a2f10-c653-11ea-8937-41f6a00ee84d.jpg?alt=media&token=e2a6c182-c7e7-4795-8fc8-8c003bd260fa"
	  }],
	  productNameEnglish: "Capsicum green msia 1kg",
	  productPrice: "4.5",
	  productSupplier: "BCS SHOP",
	  sortOrder: "g",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1 kg",
	  updateDateTime: "15/07/2020 12:24:50"
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  key: "-M9f6-hjDca9ThhkT2Hd",
	  photos: [{
	    imageName: "bc718dc0-ad0d-11ea-873f-e1ac34f7defb.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fbc718dc0-ad0d-11ea-873f-e1ac34f7defb.jpg?alt=media&token=37b690be-6f9d-4570-a5fc-9c51cfa9cfaf"
	  }],
	  productNameEnglish: "Red dragonfruits 1pcs",
	  productPrice: "3",
	  productSupplier: "BCS SHOP",
	  searchText: "ফল ",
	  sortOrder: "g",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  updateDateTime: "17/07/2020 02:38:26"
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  key: "-M9f5MRLGTyvg4nAONHR",
	  photos: [{
	    imageName: "ac00d520-f896-11ea-aaa8-a9cfb87a7f3a.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2Fac00d520-f896-11ea-aaa8-a9cfb87a7f3a.jpg?alt=media&token=fc3dcaf3-9569-432a-90d7-4eb1f19a07bc"
	  }],
	  productNameEnglish: "Lychee",
	  productPrice: "3.5",
	  productSupplier: "BCS SHOP",
	  searchText: "লিচু লীচু ফল ",
	  sortOrder: "g",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "500gm",
	  updateDateTime: "Thu 17-09-20 11:34 am"
	}, {
	  availability: "AVAILABLE",
	  category: "EGGS DAIRY",
	  isPopular: "YES",
	  key: "-M9ccYf_UiWa3q-Eyubz",
	  photos: [{
	    imageName: "5399f5e0-acad-11ea-ab51-0f18e1d42bbd.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F5399f5e0-acad-11ea-ab51-0f18e1d42bbd.jpg?alt=media&token=21615a34-8ecf-4244-8310-23c58e04ed51"
	  }],
	  productNameEnglish: "FARMHOUSE FRESH UHT MILK",
	  productPrice: "3.50",
	  productSupplier: "BCS SHOP",
	  searchText: "fresh milk ধুদ ",
	  sortOrder: "a",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1L",
	  updateDateTime: "23/07/2020 12:28:18"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  key: "-M9cbpzMQJkUss1XwPA6",
	  photos: [{
	    imageName: "e4216e50-acac-11ea-ab51-0f18e1d42bbd.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fe4216e50-acac-11ea-ab51-0f18e1d42bbd.jpg?alt=media&token=6d68c048-b683-4eda-b4f8-565211205fee"
	  }],
	  productNameEnglish: "CANOLA OIL",
	  productPrice: "9.5",
	  productSupplier: "BCS SHOP",
	  searchText: "তেল তৈল ",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "2L",
	  updateDateTime: "17/07/2020 02:40:43"
	}, {
	  availability: "AVAILABLE",
	  category: "EGGS DAIRY",
	  key: "-M9caCqf-VaAjPhBphyU",
	  photos: [{
	    imageName: "e5314d20-acab-11ea-ab51-0f18e1d42bbd.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fe5314d20-acab-11ea-ab51-0f18e1d42bbd.jpg?alt=media&token=41fd73ff-ed1e-4ae6-996b-d29d3478cc95"
	  }],
	  productNameEnglish: "YOGHURT (1kg)",
	  productPrice: "6.7",
	  productSupplier: "BCS SHOP",
	  searchText: "দই মাঠা ",
	  sortOrder: "g",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  updateDateTime: "17/07/2020 02:41:20"
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  key: "-M9cYvMUq77vUI_OoT1F",
	  photos: [{
	    imageName: "7f025ae0-acaa-11ea-ab51-0f18e1d42bbd.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F7f025ae0-acaa-11ea-ab51-0f18e1d42bbd.jpg?alt=media&token=86f6c9d0-27ce-4dcc-9319-d9bf2021235b"
	  }],
	  productNameEnglish: "CHERRIES ",
	  productPrice: "5",
	  productSupplier: "BCS SHOP",
	  searchText: " চেরি ",
	  sortOrder: "g",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "250gm",
	  updateDateTime: "17/07/2020 02:42:16"
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  key: "-M9cYGhK2EUcpGwMdTBz",
	  photos: [{
	    imageName: "1a317c90-acaa-11ea-ab51-0f18e1d42bbd.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F1a317c90-acaa-11ea-ab51-0f18e1d42bbd.jpg?alt=media&token=63c6c4c7-00e2-4f0d-bfde-00a4e9080c96"
	  }],
	  productNameEnglish: "PUMPKIN (1kg)",
	  productPrice: "4",
	  productSupplier: "BCS SHOP",
	  searchText: "মিষ্টি কুমড়া মিস্টি ",
	  sortOrder: "g",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1kg",
	  updateDateTime: "17/07/2020 02:43:00"
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  key: "-M9cXeynbwtq5zd_TsHl",
	  photos: [{
	    imageName: "b6486630-aca9-11ea-ab51-0f18e1d42bbd.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fb6486630-aca9-11ea-ab51-0f18e1d42bbd.jpg?alt=media&token=d03056ac-cd88-4d96-b004-7ed1029391fd"
	  }],
	  productNameEnglish: "YELLOW WATERMELON",
	  productPrice: "2.2",
	  productSupplier: "BCS SHOP",
	  searchText: "ফল ",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1 Kg",
	  updateDateTime: "Mon 21-09-20 3:37 pm"
	}, {
	  author: "+6594562455",
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-M9cNYNyXrvqE6nUaFKc",
	  photos: [{
	    imageName: "8eb5b060-aca3-11ea-b1f6-655d279c50ce.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F8eb5b060-aca3-11ea-b1f6-655d279c50ce.jpg?alt=media&token=b4c0576c-a46a-44ea-a20d-11cf008e982a"
	  }],
	  productNameEnglish: "LIMES lemon",
	  productPrice: "1.50",
	  productSupplier: "BCS SHOP",
	  searchText: "লেবু  কাগুজী ",
	  sortOrder: "a",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "250gm",
	  updateDateTime: "Sat 08-08-20 11:44 am"
	}, {
	  author: "+6594562455",
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-M9cN73SCaTMPoEWcX6s",
	  photos: [{
	    imageName: "47401e70-c7f9-11ea-9d1d-d9f4bc315562.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F47401e70-c7f9-11ea-9d1d-d9f4bc315562.jpg?alt=media&token=74597a21-45ff-4906-ab66-9ae3d1f5e84a"
	  }],
	  productNameEnglish: "GINGER",
	  productPrice: "1.40",
	  productSupplier: "BCS SHOP",
	  searchText: "আদা",
	  sortOrder: "a",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "200gm",
	  updateDateTime: "30/07/2020 12:11:30"
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-M9cMHEZQIK86s60YiGI",
	  photos: [{
	    imageName: "178554e0-bdac-11ea-8ba8-ddb60ef370d4.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F178554e0-bdac-11ea-8ba8-ddb60ef370d4.jpg?alt=media&token=1430bbd5-0925-4ce0-850c-99f5ed839fce"
	  }],
	  productNameEnglish: "PAPAYA (1kg)",
	  productPrice: "5",
	  productSupplier: "BCS SHOP",
	  searchText: "paka pepe পাকা পেঁপে ",
	  sortOrder: "a",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1kg",
	  updateDateTime: "23/07/2020 11:38:24"
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-M9cLdWJVsksCUdGRgRj",
	  photos: [{
	    imageName: "644cdde0-aca2-11ea-b1f6-655d279c50ce.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F644cdde0-aca2-11ea-b1f6-655d279c50ce.jpg?alt=media&token=8d7f8193-7f41-41f3-a64e-429368edbbdd"
	  }],
	  productNameEnglish: "BRINJAL ",
	  productPrice: "5",
	  productSupplier: "BCS SHOP",
	  searchText: "বেগুন বেগূন",
	  sortOrder: "a",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1kg",
	  updateDateTime: "17/07/2020 02:52:35"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  key: "-M9bY_Q2RTlndObGkIIm",
	  photos: [{
	    imageName: "333c3b20-ac83-11ea-add8-bd9e7e764e64.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F333c3b20-ac83-11ea-add8-bd9e7e764e64.jpg?alt=media&token=5d71581c-65e6-417f-b22c-ef6c3b2a70ff"
	  }],
	  productNameEnglish: "Fennel flower 100gm",
	  productPrice: "2.2",
	  productSupplier: "BCS SHOP",
	  searchText: " মৌরি",
	  sortOrder: "c",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "100gm",
	  updateDateTime: "17/07/2020 03:07:41"
	}, {
	  availability: "AVAILABLE",
	  category: "COSMETICS",
	  isPopular: "YES",
	  key: "-M9bU3WAyP6vNO30iLZ4",
	  photos: [{
	    imageName: "636ef970-ac80-11ea-9b70-29a530f3e931.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F636ef970-ac80-11ea-9b70-29a530f3e931.jpg?alt=media&token=c6cc4818-e3dd-490b-b005-01bff27b3f65"
	  }],
	  productNameEnglish: "Gilette blade",
	  productPrice: "1.20",
	  productSupplier: "BCS SHOP",
	  searchText: "ব্লেড",
	  sortOrder: "x",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1 Pkt",
	  updateDateTime: "17/07/2020 03:08:41"
	}, {
	  author: "+6589050302",
	  availability: "AVAILABLE",
	  category: "SNACKS DRY FOOD",
	  key: "-M9bShlvpc1WRxgKblin",
	  photos: [{
	    imageName: "c9d077b0-c7fc-11ea-9d1d-d9f4bc315562.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fc9d077b0-c7fc-11ea-9d1d-d9f4bc315562.jpg?alt=media&token=afd126af-c8e3-4bcc-b3f9-a79c3b21654f"
	  }],
	  productNameEnglish: "Pran puffed rice 1packet",
	  productPrice: "0.90",
	  productSupplier: "BCS SHOP",
	  searchText: "মুড়ি মুরি ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1",
	  updateDateTime: "23/07/2020 07:29:23"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-M9bJC6AZeWff8sR21LX",
	  photos: [{
	    imageName: "514a0f10-ac84-11ea-905e-b59fb9963ca1.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F514a0f10-ac84-11ea-905e-b59fb9963ca1.jpg?alt=media&token=186d6c18-e5e4-424b-a294-eab6f8e85802"
	  }],
	  productNameEnglish: "Vegetable oil",
	  productPrice: "5.80",
	  productSupplier: "BCS SHOP",
	  searchText: "তেল তৈল ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "2L Bottle",
	  updateDateTime: "Fri 28-08-20 11:57 am"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-M9bJ5RXMyXyUlmbf8WR",
	  photos: [{
	    imageName: "bdc954d0-ac79-11ea-90b2-195942e61adb.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fbdc954d0-ac79-11ea-90b2-195942e61adb.jpg?alt=media&token=02b0bb15-a44b-4c94-816e-2f64d4f63033"
	  }],
	  productNameEnglish: "Vegetable oil",
	  productPrice: "2.8",
	  productSupplier: "BCS SHOP",
	  searchText: "তেল তৈল",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1L Bottle",
	  updateDateTime: "17/07/2020 03:13:04"
	}, {
	  availability: "AVAILABLE",
	  category: "MEAT FISH",
	  key: "-M9bIu5zRY9p3Btp4DAn",
	  photos: [{
	    imageName: "980b7750-ac79-11ea-90b2-195942e61adb.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F980b7750-ac79-11ea-90b2-195942e61adb.jpg?alt=media&token=027ff7b0-fa85-49af-9498-9ec8277bee00"
	  }],
	  productNameEnglish: "Chicken nuggets 900gm 1packet ",
	  productPrice: "9",
	  productSupplier: "BCS SHOP",
	  searchText: "চিকেন নাগেট ",
	  sortOrder: "d",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "900gm",
	  updateDateTime: "17/07/2020 03:14:07"
	}, {
	  availability: "AVAILABLE",
	  category: "MEAT FISH",
	  key: "-M9bIi4Mz6EVLbB-Siwn",
	  photos: [{
	    imageName: "63e31c30-ac79-11ea-90b2-195942e61adb.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F63e31c30-ac79-11ea-90b2-195942e61adb.jpg?alt=media&token=f6d56ac6-b732-480b-8d7a-1786c05708d8"
	  }],
	  productNameEnglish: "Spicy chicken nuggets 900gm 1packet ",
	  productPrice: "9",
	  productSupplier: "BCS SHOP",
	  searchText: "চিকেন নাগেট ",
	  sortOrder: "d",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "900gm",
	  updateDateTime: "17/07/2020 03:14:23"
	}, {
	  category: "MEAT FISH",
	  key: "-M9bIKTKfx_V-xsmTadz",
	  photos: [{
	    imageName: "362583f0-ac79-11ea-90b2-195942e61adb.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F362583f0-ac79-11ea-90b2-195942e61adb.jpg?alt=media&token=29be69b2-e8da-4466-9eb7-55fa3c76e3b5"
	  }],
	  productNameEnglish: "Chicken Crispy popcorn 450gm 1packet",
	  productPrice: "8",
	  productSupplier: "BCS SHOP",
	  searchText: "চিকেন পপকর্ন ",
	  sortOrder: "d",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "450gm",
	  updateDateTime: "17/07/2020 03:14:54"
	}, {
	  availability: "AVAILABLE",
	  category: "EGGS DAIRY",
	  key: "-M9bI18w7Wmbkz8-XqOF",
	  photos: [{
	    imageName: "13596f30-ac79-11ea-90b2-195942e61adb.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F13596f30-ac79-11ea-90b2-195942e61adb.jpg?alt=media&token=5a83fa03-8879-4014-a03b-91e506fb90de"
	  }],
	  productNameEnglish: "Bread",
	  productPrice: "1.2",
	  productSupplier: "BCS SHOP",
	  searchText: "পাউরুটি পাওরোটি",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1 pc",
	  updateDateTime: "06/07/2020 09:40:00"
	}, {
	  availability: "AVAILABLE",
	  category: "EGGS DAIRY",
	  key: "-M9bHoKF-2K9TkktZI1L",
	  photos: [{
	    imageName: "eda24870-ac78-11ea-90b2-195942e61adb.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Feda24870-ac78-11ea-90b2-195942e61adb.jpg?alt=media&token=10aa5058-9dc1-4df5-9b5d-ba4eb5adab9c"
	  }],
	  productNameEnglish: "Cake traditional 1packet",
	  productPrice: "2.5",
	  productSupplier: "BCS SHOP",
	  searchText: "কেক ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1 pkt",
	  updateDateTime: "17/07/2020 03:16:29"
	}, {
	  category: "RICE DAAL NOODLES",
	  isPopular: "YES",
	  key: "-M9bH7pWwS_Hs2PnjPxw",
	  photos: [{
	    imageName: "78b62f40-ac78-11ea-891a-2516dcf49b13.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F78b62f40-ac78-11ea-891a-2516dcf49b13.jpg?alt=media&token=288e7221-e028-41a5-bbb2-f548e74e5773"
	  }],
	  productNameEnglish: "BASIL SEEDS",
	  productPrice: "3 ",
	  productSupplier: "BCS SHOP",
	  searchText: "tokma tukma tukh malanga",
	  sortOrder: "c",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "100g",
	  updateDateTime: "04/07/2020 08:27:20"
	}, {
	  availability: "OUT OF STOCK, TOPPING UP IN PROGRESS",
	  category: "EGGS DAIRY",
	  key: "-M9bGmiz04uGC8KpucgL",
	  photos: [{
	    imageName: "3bf36000-ac78-11ea-8ded-437354ec7423.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F3bf36000-ac78-11ea-8ded-437354ec7423.jpg?alt=media&token=b498638c-c982-40c3-93e4-6bc4bfb3f9f8"
	  }],
	  productNameEnglish: "quail egg",
	  productPrice: "3",
	  productSupplier: "BCS SHOP",
	  searchText: "কোয়েল ডিম ",
	  sortOrder: "g",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "15pcs 1box",
	  updateDateTime: "17/07/2020 04:06:24"
	}, {
	  availability: "AVAILABLE",
	  category: "RICE DAAL NOODLES",
	  key: "-M9bGWyqukG80g5HB4oH",
	  photos: [{
	    imageName: "f8f08760-ac77-11ea-891a-2516dcf49b13.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Ff8f08760-ac77-11ea-891a-2516dcf49b13.jpg?alt=media&token=1d56eb65-3f41-4e68-a9d6-21f0b4a1dc90"
	  }],
	  productNameEnglish: "PAO FLOUR (600g)",
	  productPrice: "2.80 ",
	  productSupplier: "BCS SHOP",
	  sortOrder: "f",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "600gm",
	  updateDateTime: "17/07/2020 04:06:44"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  key: "-M9bGSR_j7gaxUZ9Kc0f",
	  photos: [{
	    imageName: "1232e600-ac78-11ea-8ded-437354ec7423.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F1232e600-ac78-11ea-8ded-437354ec7423.jpg?alt=media&token=f067dcfa-91c9-450a-bae5-db864f4e022e"
	  }],
	  productNameEnglish: "Gold oil sunflower ",
	  productPrice: "16.2",
	  productSupplier: "BCS SHOP",
	  searchText: "তেল তৈল ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  updateDateTime: "17/07/2020 04:08:18"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-M9bGBYZ5VvgyNm1gak2",
	  photos: [{
	    imageName: "e0b871f0-c804-11ea-9d1d-d9f4bc315562.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fe0b871f0-c804-11ea-9d1d-d9f4bc315562.jpg?alt=media&token=32776a49-4223-4e2c-9b57-805ce21daad6"
	  }],
	  productNameEnglish: "Duck oil 2L",
	  productPrice: "6",
	  productSupplier: "BCS SHOP",
	  searchText: "তেল তৈল ",
	  sortOrder: "d",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "2L",
	  updateDateTime: "17/07/2020 04:09:55"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  key: "-M9bG1j4cuWPwuqeWkuI",
	  photos: [{
	    imageName: "dfdb2c30-ac77-11ea-8ded-437354ec7423.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fdfdb2c30-ac77-11ea-8ded-437354ec7423.jpg?alt=media&token=8f88031d-2ff0-402b-8bdf-079d45a83130"
	  }],
	  productNameEnglish: "Soya bean oil ",
	  productPrice: "12.5",
	  productSupplier: "BCS SHOP",
	  searchText: "তেল তৈল ",
	  sortOrder: "d",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "5L",
	  updateDateTime: "17/07/2020 04:10:11"
	}, {
	  availability: "AVAILABLE",
	  category: "RICE DAAL NOODLES",
	  isPopular: "YES",
	  key: "-M9bG0Ew_O0J9zgK08Ft",
	  photos: [{
	    imageName: "bd161c50-ac77-11ea-891a-2516dcf49b13.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fbd161c50-ac77-11ea-891a-2516dcf49b13.jpg?alt=media&token=121ac522-9835-41e2-bc69-159b7b01944f"
	  }],
	  productNameEnglish: "SELF RAISING FLOUR",
	  productPrice: "2.80 ",
	  productSupplier: "BCS SHOP",
	  searchText: "maida mayda fine ata atta আটা ময়দা",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1Kg Packet",
	  updateDateTime: "17/07/2020 04:13:25"
	}, {
	  author: "+6589050302",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-M9bFo5eMFcy5tHOyT4I",
	  photos: [{
	    imageName: "bab43780-ac77-11ea-8ded-437354ec7423.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fbab43780-ac77-11ea-8ded-437354ec7423.jpg?alt=media&token=963e0410-83b1-42fc-8b27-114977dd6974"
	  }],
	  productNameEnglish: "Vegetable oil",
	  productPrice: "6.20",
	  productSupplier: "BCS SHOP",
	  searchText: "তেল তৈল",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "3L Bottle",
	  updateDateTime: "29/07/2020 02:40:52"
	}, {
	  availability: "AVAILABLE",
	  category: "RICE DAAL NOODLES",
	  key: "-M9bFbu8vwHane1xIr1u",
	  photos: [{
	    imageName: "567cf3a0-e8dc-11ea-b634-e7e7c4cb042d.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F567cf3a0-e8dc-11ea-b634-e7e7c4cb042d.jpg?alt=media&token=19a68641-bb80-493c-b780-710c4536c9b1"
	  }],
	  productNameEnglish: "PLAIN FLOUR (1kg)",
	  productPrice: "2 ",
	  productSupplier: "BCS SHOP",
	  searchText: "এটা ময়দা ",
	  sortOrder: "a",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1kg",
	  updateDateTime: "Fri 28-08-20 11:12 am"
	}, {
	  author: "+6589050302",
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-M9bFJPUfqMNttFWJLgM",
	  photos: [{
	    imageName: "63ca27e0-ac77-11ea-8ded-437354ec7423.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F63ca27e0-ac77-11ea-8ded-437354ec7423.jpg?alt=media&token=f6e057d7-8089-4ce0-9410-6a43081ccbe4"
	  }],
	  productNameEnglish: "Vegetable oil",
	  productPrice: "9.50",
	  productSupplier: "BCS SHOP",
	  searchText: "তেল তৈল ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "5L Bottle",
	  updateDateTime: "29/07/2020 02:40:39"
	}, {
	  availability: "AVAILABLE",
	  category: "RICE DAAL NOODLES",
	  key: "-M9bFHt2KBV_U_2AlTyE",
	  photos: [{
	    imageName: "c7527db0-e8dd-11ea-b634-e7e7c4cb042d.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2Fc7527db0-e8dd-11ea-b634-e7e7c4cb042d.jpg?alt=media&token=dce8fe2a-07fd-44be-86f3-d60ee842ceee"
	  }],
	  productNameEnglish: "BAKERS WHEAT FLOUR",
	  productPrice: "2",
	  productSupplier: "BCS SHOP",
	  searchText: "আটা ময়দা",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1Kg",
	  updateDateTime: "Fri 28-08-20 11:23 am"
	}, {
	  availability: "AVAILABLE",
	  category: "RICE DAAL NOODLES",
	  isPopular: "YES",
	  key: "-M9bErwUjb0ZFLlRHkYo",
	  photos: [{
	    imageName: "2adcfe70-bd9e-11ea-9c87-8df410c3c074.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F2adcfe70-bd9e-11ea-9c87-8df410c3c074.jpg?alt=media&token=46f3c241-9144-437b-866d-44ee601590f8"
	  }],
	  productNameEnglish: "Masoor dhal lentils spit 500gm",
	  productPrice: "2.5",
	  productSupplier: "BCS SHOP",
	  searchText: "মশুর মসুর মুশুরি ডাল dhal dal",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "500gm",
	  updateDateTime: "17/07/2020 08:56:23"
	}, {
	  category: "COOKING OIL INGREDIENTS",
	  key: "-M9bEk5L7Pds_UwPPSlm",
	  photos: [{
	    imageName: "f7f728b0-ac76-11ea-891a-2516dcf49b13.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Ff7f728b0-ac76-11ea-891a-2516dcf49b13.jpg?alt=media&token=b318aeea-093e-4ecc-b6f4-2390b9bc9b9d"
	  }],
	  productNameEnglish: "POTATO STARCH",
	  productPrice: "2 ",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "350g",
	  updateDateTime: "04/07/2020 08:32:12"
	}, {
	  availability: "AVAILABLE",
	  category: "RICE DAAL NOODLES",
	  isPopular: "YES",
	  key: "-M9bEiKuAy12yg2CASFh",
	  photos: [{
	    imageName: "fe2216d0-b231-11ea-b6a3-23fbd917d0cb.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Ffe2216d0-b231-11ea-b6a3-23fbd917d0cb.jpg?alt=media&token=6f51e17b-1284-472c-90f3-49df7ecd0d3f"
	  }],
	  productNameEnglish: "Moong dhal lentils ",
	  productPrice: "2.5",
	  productSupplier: "BCS SHOP",
	  searchText: "mug dal mog mong mag dhal ডাল",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "409gm",
	  updateDateTime: "17/07/2020 08:55:42"
	}, {
	  availability: "AVAILABLE",
	  category: "RICE DAAL NOODLES",
	  isPopular: "YES",
	  key: "-M9bESNPxTDsCiuOhYQe",
	  photos: [{
	    imageName: "222cc2f0-bd9f-11ea-9c87-8df410c3c074.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F222cc2f0-bd9f-11ea-9c87-8df410c3c074.jpg?alt=media&token=274dc654-a767-4c6c-906f-f62cc865739b"
	  }],
	  productNameEnglish: "Channa dhal lentils 500gm",
	  productPrice: "2.5",
	  productSupplier: "BCS SHOP",
	  searchText: "chana dal dhal ডাল",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "500gm",
	  updateDateTime: "17/07/2020 08:55:55"
	}, {
	  category: "RICE DAAL NOODLES",
	  key: "-M9bEIvlWNBonUmZ9tjK",
	  photos: [{
	    imageName: "d8406a40-ac76-11ea-8ded-437354ec7423.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fd8406a40-ac76-11ea-8ded-437354ec7423.jpg?alt=media&token=e36c2ce6-7cbb-4953-a788-e97be6dd7d76"
	  }],
	  productNameEnglish: "House yellow gran",
	  productPrice: "2.5",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "500g",
	  updateDateTime: "04/07/2020 08:37:06"
	}, {
	  category: "FRUITS VEGETABLES ",
	  key: "-M9bE9qlAKL7zmPvEStf",
	  photos: [{
	    imageName: "c4aaaea0-ac76-11ea-8ded-437354ec7423.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fc4aaaea0-ac76-11ea-8ded-437354ec7423.jpg?alt=media&token=c974a64a-f7b5-4fa1-9db5-9b788a8aebd2"
	  }],
	  productNameEnglish: "House green peas",
	  productPrice: "2.5",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "500gm",
	  updateDateTime: "04/07/2020 08:41:26"
	}, {
	  category: "FRUITS VEGETABLES ",
	  key: "-M9bDznTAaqp0-l8dulV",
	  photos: [{
	    imageName: "854f8140-ac76-11ea-891a-2516dcf49b13.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F854f8140-ac76-11ea-891a-2516dcf49b13.jpg?alt=media&token=efea63b7-cf62-4b92-8933-d6691f45576f"
	  }],
	  productNameEnglish: "GREEN BEANS",
	  productPrice: "5",
	  productSupplier: "BCS SHOP",
	  sortOrder: "c",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1Kg",
	  updateDateTime: "04/07/2020 08:42:01"
	}, {
	  availability: "AVAILABLE",
	  category: "RICE DAAL NOODLES",
	  isPopular: "YES",
	  key: "-M9bDpZaI9gh2TyitTkr",
	  photos: [{
	    imageName: "1c7a7dd0-bda3-11ea-9c87-8df410c3c074.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F1c7a7dd0-bda3-11ea-9c87-8df410c3c074.jpg?alt=media&token=74930c83-7dfe-4bc6-a58d-ae2ed4f8e2d0"
	  }],
	  productNameEnglish: "Toor Dhal lenthils",
	  productPrice: "3.5",
	  productSupplier: "BCS SHOP",
	  searchText: "tood turd dal dhal ডাল",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "500gm",
	  updateDateTime: "17/07/2020 08:55:32"
	}, {
	  category: "COOKING OIL INGREDIENTS",
	  key: "-M9bDQeX1rsB1FUZXvdV",
	  photos: [{
	    imageName: "434d28b0-ac76-11ea-8ded-437354ec7423.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F434d28b0-ac76-11ea-8ded-437354ec7423.jpg?alt=media&token=b188c03d-e738-460a-890f-ee19ddc91a89"
	  }],
	  productNameEnglish: "Fish seasoning",
	  productPrice: "2",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "100g",
	  updateDateTime: "04/07/2020 08:42:48"
	}, {
	  category: "DRINKS DESSERT",
	  key: "-M9bCf_WwXB4rAW5mkgT",
	  photos: [{
	    imageName: "d1ef1840-ac75-11ea-8ded-437354ec7423.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fd1ef1840-ac75-11ea-8ded-437354ec7423.jpg?alt=media&token=f5efc351-df92-4c74-944a-afc119a630ff"
	  }],
	  productNameEnglish: "Coca cola",
	  productPrice: "2.5",
	  productSupplier: "BCS SHOP",
	  sortOrder: "f",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1L Bottle",
	  updateDateTime: "04/07/2020 08:43:06"
	}, {
	  availability: "AVAILABLE",
	  category: "LAUNDRY CLEANING",
	  key: "-M9bBs4PdfnxhlDzHxTx",
	  photos: [{
	    imageName: "28eaf7a0-ac75-11ea-8ded-437354ec7423.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F28eaf7a0-ac75-11ea-8ded-437354ec7423.jpg?alt=media&token=dded438e-c6a6-42e7-83a1-a1e3e8232eee"
	  }],
	  productNameEnglish: "Fab perfect washing powder ",
	  productPrice: "6.8",
	  productSupplier: "BCS SHOP",
	  searchText: "ওয়াশিং পাউডার ",
	  sortOrder: "f",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "2.1Kg",
	  updateDateTime: "17/07/2020 07:56:39"
	}, {
	  category: "COSMETICS",
	  isPopular: "YES",
	  key: "-M9bBN6Cns4Ya5sBUZvD",
	  photos: [{
	    imageName: "f96bfd60-e8da-11ea-b634-e7e7c4cb042d.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2Ff96bfd60-e8da-11ea-b634-e7e7c4cb042d.jpg?alt=media&token=89db75f0-26ba-4dd0-a1d1-8a1edafaa6fb"
	  }],
	  productNameEnglish: "Dettol soap",
	  productPrice: "4",
	  productSupplier: "BCS SHOP",
	  searchText: "detol sop sabun",
	  sortOrder: "75g",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "pack of 4 pcs",
	  updateDateTime: "Fri 28-08-20 11:03 am"
	}, {
	  category: "TOILETRIES",
	  key: "-M9bB5dnsCXDomgJ_OBA",
	  photos: [{
	    imageName: "563bf250-f89b-11ea-aaa8-a9cfb87a7f3a.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F563bf250-f89b-11ea-aaa8-a9cfb87a7f3a.jpg?alt=media&token=bc346ebc-e30f-4488-bded-668fc3aae7a8"
	  }],
	  productNameEnglish: "Hand wash",
	  productPrice: "3.2",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "200ml",
	  updateDateTime: "Thu 17-09-20 12:07 pm"
	}, {
	  category: "TOILETRIES",
	  key: "-M9bAvuFocwVT1Lt_S9j",
	  photos: [{
	    imageName: "b7134a60-ac74-11ea-8ded-437354ec7423.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fb7134a60-ac74-11ea-8ded-437354ec7423.jpg?alt=media&token=43bf3fb2-c434-44fd-8a0f-0a75e5c7c0a8"
	  }, {
	    imageName: "c05f3430-ac74-11ea-8ded-437354ec7423.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fc05f3430-ac74-11ea-8ded-437354ec7423.jpg?alt=media&token=49833320-a797-4748-a3a4-8f4c4659512b"
	  }],
	  productNameEnglish: "Hand wash",
	  productPrice: "4.2",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "500ml",
	  updateDateTime: "04/07/2020 08:45:02"
	}, {
	  availability: "AVAILABLE",
	  category: "LAUNDRY CLEANING",
	  key: "-M9bAZLU-a_Q-V-WlbbY",
	  photos: [{
	    imageName: "7884e2e0-ac74-11ea-8ded-437354ec7423.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F7884e2e0-ac74-11ea-8ded-437354ec7423.jpg?alt=media&token=640f2b31-ab60-48c9-bc9a-fac131af8e2a"
	  }],
	  productNameEnglish: "Detergent powder home niks",
	  productPrice: "8.5",
	  productSupplier: "BCS SHOP",
	  searchText: "ওয়াশিং পাউডার ",
	  sortOrder: "f",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "5Kg",
	  updateDateTime: "17/07/2020 07:56:35"
	}, {
	  category: "TOILETRIES",
	  key: "-M9bAExUU-7ZQvZRzxWU",
	  photos: [{
	    imageName: "6072c6e0-ac74-11ea-83ef-037972cabc05.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F6072c6e0-ac74-11ea-83ef-037972cabc05.jpg?alt=media&token=4a6a3588-660d-452c-864c-852cb9d9e3b5"
	  }],
	  productNameEnglish: "BIORE FACE CLEAN",
	  productPrice: "7",
	  productSupplier: "BCS SHOP",
	  sortOrder: "k",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "125ml",
	  updateDateTime: "04/07/2020 08:46:12"
	}, {
	  category: "SNACKS DRY FOOD",
	  isPopular: "YES",
	  key: "-M9b9n5oKPtCjUoynwer",
	  photos: [{
	    imageName: "f00ecde0-ac73-11ea-8ded-437354ec7423.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Ff00ecde0-ac73-11ea-8ded-437354ec7423.jpg?alt=media&token=54d0d0a4-6b52-442c-946e-541d50fa28b9"
	  }],
	  productNameEnglish: "Biscuits",
	  productPrice: "4",
	  productSupplier: "BCS SHOP",
	  searchText: "sweet biscuit buiskit",
	  sortOrder: "d",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1 packet",
	  updateDateTime: "04/07/2020 08:46:22"
	}, {
	  category: "OTHERS",
	  key: "-M9b9agn72hYXIcQaoOw",
	  photos: [{
	    imageName: "fb0c5f50-ac73-11ea-83ef-037972cabc05.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Ffb0c5f50-ac73-11ea-83ef-037972cabc05.jpg?alt=media&token=2c0d8ed0-f9cb-4166-9ac0-0c588d9c8e63"
	  }],
	  productNameEnglish: "MOSQUITO KILLER ",
	  productPrice: "7.20",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1 Spray Bottle",
	  updateDateTime: "04/07/2020 08:46:53"
	}, {
	  category: "SNACKS DRY FOOD",
	  key: "-M9b9Op5cDWf7IC8FFcy",
	  photos: [{
	    imageName: "bf2745e0-ac73-11ea-8ded-437354ec7423.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fbf2745e0-ac73-11ea-8ded-437354ec7423.jpg?alt=media&token=520e2bfc-0d06-498c-a981-3242f6248a5f"
	  }],
	  productNameEnglish: "Swiss roll cake",
	  productPrice: "4",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "24 pcs1 Pkt",
	  updateDateTime: "04/07/2020 08:48:37"
	}, {
	  category: "OTHERS",
	  key: "-M9b9AigsGTmxiI5tUhI",
	  photos: [{
	    imageName: "b9b2c9e0-ac73-11ea-83ef-037972cabc05.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fb9b2c9e0-ac73-11ea-83ef-037972cabc05.jpg?alt=media&token=f5572ef3-9668-4beb-9c70-7bdd88a1a83a"
	  }],
	  productNameEnglish: "MULTI INSECT KILLER",
	  productPrice: "7.50 ",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "600 ml",
	  updateDateTime: "04/07/2020 08:48:04"
	}, {
	  category: "RICE DAAL NOODLES",
	  key: "-M9b8iXcL7dhjtXM7st6",
	  photos: [{
	    imageName: "49a41cd0-ac73-11ea-8ded-437354ec7423.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F49a41cd0-ac73-11ea-8ded-437354ec7423.jpg?alt=media&token=27c4bcd5-378a-415e-8b95-5102e1e649a3"
	  }],
	  productNameEnglish: "Noodles tom yam/asam laksa/kari letup",
	  productPrice: "2.5",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1 Pkt",
	  updateDateTime: "04/07/2020 08:48:26"
	}, {
	  category: "KITCHEN DINING",
	  key: "-M9b8c4xiaoUzpBsxhG0",
	  photos: [{
	    imageName: "6253d860-ac73-11ea-83ef-037972cabc05.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F6253d860-ac73-11ea-83ef-037972cabc05.jpg?alt=media&token=af1e5d07-f220-4cb4-9a04-4e604cec50d8"
	  }],
	  productNameEnglish: "CUTTING BOARD ",
	  productPrice: "10 ",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1 pc",
	  updateDateTime: "04/07/2020 08:49:03"
	}, {
	  category: "RICE DAAL NOODLES",
	  key: "-M9b8JWwYFz517RGfvJ_",
	  photos: [{
	    imageName: "1759f790-ac73-11ea-8ded-437354ec7423.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F1759f790-ac73-11ea-8ded-437354ec7423.jpg?alt=media&token=87c9c6c7-6838-45e5-a421-679aa0408600"
	  }, {
	    imageName: "21c9c7f0-ac73-11ea-8ded-437354ec7423.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F21c9c7f0-ac73-11ea-8ded-437354ec7423.jpg?alt=media&token=033a0dad-aa01-4f30-9273-cba66ffad7db"
	  }],
	  productNameEnglish: "Big curry noodels",
	  productPrice: "3.1",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1 Pkt",
	  updateDateTime: "04/07/2020 08:49:23"
	}, {
	  category: "RICE DAAL NOODLES",
	  key: "-M9b7apudcJmYv59Ojtf",
	  photos: [{
	    imageName: "a4d8c3e0-ac72-11ea-8ded-437354ec7423.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fa4d8c3e0-ac72-11ea-8ded-437354ec7423.jpg?alt=media&token=3fdfb1e2-e845-4f55-afa8-65dabfb98b1b"
	  }],
	  productNameEnglish: "Cup noodles chicken",
	  productPrice: "2",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1 Pkt",
	  updateDateTime: "04/07/2020 11:30:17"
	}, {
	  availability: "AVAILABLE",
	  category: "TOILETRIES",
	  key: "-M9b7HZfPuATJUBkTdCs",
	  photos: [{
	    imageName: "91e2cab0-ac72-11ea-83ef-037972cabc05.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F91e2cab0-ac72-11ea-83ef-037972cabc05.jpg?alt=media&token=755f870a-7fbe-4703-bc41-4a71cf5cfed5"
	  }],
	  productNameEnglish: "DOVE BODY WASH",
	  productPrice: "7.5",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "Btl ",
	  updateDateTime: "Wed 02-12-20 10:22 am"
	}, {
	  category: "COOKING OIL INGREDIENTS",
	  key: "-M9b6_DddVN9pGnpsYVW",
	  photos: [{
	    imageName: "31cae090-ac72-11ea-83ef-037972cabc05.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F31cae090-ac72-11ea-83ef-037972cabc05.jpg?alt=media&token=2d6cb112-48ac-4e20-ba63-3a08a2820ccd"
	  }],
	  productNameEnglish: "KARACHI PARATHA",
	  productPrice: "3 ",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "400g",
	  updateDateTime: "04/07/2020 11:31:38"
	}, {
	  category: "MEAT FISH",
	  key: "-M9b6XWMW4dWuzwjBQDW",
	  photos: [{
	    imageName: "0e1f8f60-ac72-11ea-8ded-437354ec7423.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F0e1f8f60-ac72-11ea-8ded-437354ec7423.jpg?alt=media&token=9d5f7d1b-3bcc-467b-b82a-76ad2703a339"
	  }],
	  productNameEnglish: "Chicken",
	  productPrice: "3.5",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1pc 800gm",
	  updateDateTime: "04/07/2020 11:32:06"
	}, {
	  category: "RICE DAAL NOODLES",
	  key: "-M9b6LuJF4v10S5epeVw",
	  photos: [{
	    imageName: "dd707c80-ac71-11ea-8ded-437354ec7423.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fdd707c80-ac71-11ea-8ded-437354ec7423.jpg?alt=media&token=1f3a11e0-40f5-4c9a-8ecc-1162674a012c"
	  }],
	  productNameEnglish: "Noodles",
	  productPrice: "3.8",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1 Pkt",
	  updateDateTime: "04/07/2020 11:32:29"
	}, {
	  category: "COOKING OIL INGREDIENTS",
	  key: "-M9b6D6itMcUK3KyLdFp",
	  photos: [{
	    imageName: "e9e45a40-ac71-11ea-83ef-037972cabc05.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fe9e45a40-ac71-11ea-83ef-037972cabc05.jpg?alt=media&token=3a8ce57a-ae06-43e5-93d6-8eafb97be97d"
	  }],
	  productNameEnglish: "PLAIN PARATHA",
	  productPrice: "7.70",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "2 Kg",
	  updateDateTime: "04/07/2020 11:32:50"
	}, {
	  availability: "AVAILABLE",
	  category: "EGGS DAIRY",
	  key: "-M9b6-8mJq4PnN0R5X6L",
	  photos: [{
	    imageName: "bba5f940-ac71-11ea-8ded-437354ec7423.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fbba5f940-ac71-11ea-8ded-437354ec7423.jpg?alt=media&token=cb0a2a4e-70fb-468c-9348-6340c159e0f6"
	  }],
	  productNameEnglish: "Bread",
	  productPrice: "3.8",
	  productSupplier: "BCS SHOP",
	  searchText: "পাউরুটি পাওরোটি",
	  sortOrder: "d",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1 Pkt",
	  updateDateTime: "06/07/2020 09:40:11"
	}, {
	  availability: "AVAILABLE",
	  category: "EGGS DAIRY",
	  key: "-M9b5gixFFWFZu_8K2gD",
	  photos: [{
	    imageName: "78b34d40-ac71-11ea-8ded-437354ec7423.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F78b34d40-ac71-11ea-8ded-437354ec7423.jpg?alt=media&token=5313c355-f51e-4170-8e2b-3fd689895acf"
	  }],
	  productNameEnglish: "Bread",
	  productPrice: "2.9",
	  productSupplier: "BCS SHOP",
	  searchText: "পাউরুটি পাওরোটি",
	  sortOrder: "d",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1 Pkt",
	  updateDateTime: "06/07/2020 09:40:20"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  key: "-M9b5ar5vEu4FvrUc5PY",
	  photos: [{
	    imageName: "8aedbea0-ac71-11ea-83ef-037972cabc05.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F8aedbea0-ac71-11ea-83ef-037972cabc05.jpg?alt=media&token=83c21cb4-13c3-4fba-a834-0765f3336e9b"
	  }],
	  productNameEnglish: "EX VIRGIN OLIVE OIL (1l)",
	  productPrice: "16",
	  productSupplier: "BCS SHOP",
	  searchText: "অলিভ অয়েল",
	  sortOrder: "a",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1l",
	  updateDateTime: "17/07/2020 07:35:39"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  key: "-M9b5Bp3rmdHU8muuty_",
	  photos: [{
	    imageName: "4b76a4d0-ac71-11ea-83ef-037972cabc05.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F4b76a4d0-ac71-11ea-83ef-037972cabc05.jpg?alt=media&token=a11dd7c0-eddb-4e21-8a2a-d75748c554d6"
	  }],
	  productNameEnglish: "EX VIRGIN OLIVE OIL (500g)",
	  productPrice: "9",
	  productSupplier: "BCS SHOP",
	  searchText: "অলিভ অয়েল",
	  sortOrder: "g",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "500g",
	  updateDateTime: "17/07/2020 07:35:50"
	}, {
	  availability: "AVAILABLE",
	  category: "EGGS DAIRY",
	  isPopular: "YES",
	  key: "-M9b53-gYj3fNL3pj_SH",
	  photos: [{
	    imageName: "1b77f630-ac71-11ea-8ded-437354ec7423.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F1b77f630-ac71-11ea-8ded-437354ec7423.jpg?alt=media&token=965addb9-5921-433a-9f34-f72bf36b9e9d"
	  }],
	  productNameEnglish: "HL banana/strawberry milk",
	  productPrice: "3.5",
	  productSupplier: "BCS SHOP",
	  searchText: "fresh milk",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1L",
	  updateDateTime: "23/07/2020 12:30:15"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  key: "-M9b4vSa-PhukassruCo",
	  photos: [{
	    imageName: "20d2f6c0-ac71-11ea-83ef-037972cabc05.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F20d2f6c0-ac71-11ea-83ef-037972cabc05.jpg?alt=media&token=ff856e15-d9cc-4c1f-85c8-cac13e95f741"
	  }],
	  productNameEnglish: "OLIVE OIL (500g)",
	  productPrice: "8.90",
	  productSupplier: "BCS SHOP",
	  searchText: "অলিভ অয়েল",
	  sortOrder: "g",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "500g",
	  updateDateTime: "17/07/2020 07:36:02"
	}, {
	  category: "DRINKS DESSERT",
	  key: "-M9b4a-Ps5Kg4_LkPQHF",
	  photos: [{
	    imageName: "d270bda0-ac70-11ea-9366-875156fdc5b0.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fd270bda0-ac70-11ea-9366-875156fdc5b0.jpg?alt=media&token=ed85b657-4e29-405e-86db-3711b7371997"
	  }],
	  productNameEnglish: "Peel Fresh Oranje juice",
	  productPrice: "5",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "2 x 1L ",
	  updateDateTime: "05/07/2020 12:09:16"
	}, {
	  category: "FRUITS VEGETABLES ",
	  key: "-M9b4ZZZ7PcOh0dRuFGt",
	  photos: [{
	    imageName: "e95d4560-ac70-11ea-83ef-037972cabc05.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fe95d4560-ac70-11ea-83ef-037972cabc05.jpg?alt=media&token=f36c38b9-4c29-4d2e-839e-1e5c8c5d5f0d"
	  }],
	  productNameEnglish: "LYCHEE ",
	  productPrice: "2.50",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1 tin",
	  updateDateTime: "05/07/2020 12:09:39"
	}, {
	  category: "FRUITS VEGETABLES ",
	  key: "-M9b4LZs7VKuhHdtk47B",
	  photos: [{
	    imageName: "c71bbd60-ac70-11ea-83ef-037972cabc05.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fc71bbd60-ac70-11ea-83ef-037972cabc05.jpg?alt=media&token=519a77a1-35dc-43bd-8959-9129a6d6492c"
	  }],
	  productNameEnglish: "LONGAN",
	  productPrice: "3",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1 tin",
	  updateDateTime: "05/07/2020 12:09:56"
	}, {
	  category: "EGGS DAIRY",
	  isPopular: "YES",
	  key: "-M9b4GhsoKiSOk7LB9RD",
	  photos: [{
	    imageName: "8231fc50-ac70-11ea-9366-875156fdc5b0.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F8231fc50-ac70-11ea-9366-875156fdc5b0.jpg?alt=media&token=63f79f59-7260-4728-aac4-89908bf5dab5"
	  }],
	  productNameEnglish: "HL banana/strawberry milk",
	  productPrice: "6",
	  productSupplier: "BCS SHOP",
	  searchText: "fresh milk",
	  sortOrder: "d",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "2 x 1L",
	  updateDateTime: "05/07/2020 12:10:24"
	}, {
	  category: "DRINKS DESSERT",
	  key: "-M9b3lrh63IHxC_1Mssm",
	  photos: [{
	    imageName: "4db120f0-ac70-11ea-9366-875156fdc5b0.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F4db120f0-ac70-11ea-9366-875156fdc5b0.jpg?alt=media&token=89f1f325-5fca-465b-88ba-d8436e533a81"
	  }],
	  productNameEnglish: "Orange juice drink",
	  productPrice: "4.5",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "2L",
	  updateDateTime: "05/07/2020 12:14:31"
	}, {
	  category: "SNACKS DRY FOOD",
	  key: "-M9b3Wacdl9NUC-zrGlP",
	  photos: [{
	    imageName: "4561bf90-ac70-11ea-83ef-037972cabc05.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F4561bf90-ac70-11ea-83ef-037972cabc05.jpg?alt=media&token=ac1c7516-6790-4bcd-a6f1-3bfd5e34ca86"
	  }],
	  productNameEnglish: "Walnut",
	  productPrice: "5.50 ",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "200g Pkt",
	  updateDateTime: "05/07/2020 12:15:28"
	}, {
	  category: "DRINKS DESSERT",
	  key: "-M9b3SnWKBFpNCAcrE7G",
	  photos: [{
	    imageName: "1d14abb0-ac70-11ea-9366-875156fdc5b0.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F1d14abb0-ac70-11ea-9366-875156fdc5b0.jpg?alt=media&token=2c3a8293-dd81-4091-ad6a-d17764a3f6a3"
	  }],
	  productNameEnglish: " Orange juice drink  2litres ",
	  productPrice: "4.8",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "2L",
	  updateDateTime: "05/07/2020 12:15:42"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-M9b3EfDyq60NlPy0uO8",
	  photos: [{
	    imageName: "d6304170-e8db-11ea-b634-e7e7c4cb042d.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2Fd6304170-e8db-11ea-b634-e7e7c4cb042d.jpg?alt=media&token=a556f9c9-2e21-463f-8d57-9cb517b61bd6"
	  }],
	  productNameEnglish: "ATTA Flour",
	  productPrice: "1.80",
	  productSupplier: "BCS SHOP",
	  searchText: "atta",
	  sortOrder: "a",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1Kg Packet",
	  updateDateTime: "Fri 28-08-20 11:09 am"
	}, {
	  category: "COOKING OIL INGREDIENTS",
	  key: "-M9b2rYajYMImsSvokyT",
	  photos: [{
	    imageName: "deacb7f0-ac6f-11ea-83ef-037972cabc05.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fdeacb7f0-ac6f-11ea-83ef-037972cabc05.jpg?alt=media&token=f4d091e6-6f8e-4939-8176-eda885e02668"
	  }],
	  productNameEnglish: "SWEETENED CREAMER ",
	  productPrice: "1.20",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1 tin",
	  updateDateTime: "05/07/2020 12:17:32"
	}, {
	  author: "+6594562455",
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  key: "-M9b11V3Y0kE8aCjjY_1",
	  photos: [{
	    imageName: "c0e255a0-ac6e-11ea-83ef-037972cabc05.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fc0e255a0-ac6e-11ea-83ef-037972cabc05.jpg?alt=media&token=7117ff9a-187c-4536-8bca-e43bb6ad46fb"
	  }],
	  productNameEnglish: "YELLOW LEMON lime",
	  productPrice: "1.80",
	  productSupplier: "BCS SHOP",
	  searchText: "লেবু ",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "2 pcs ",
	  updateDateTime: "Sat 08-08-20 11:47 am"
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  key: "-M9b0j9_hMaT1Csp0yn-",
	  photos: [{
	    imageName: "097e8f90-f89b-11ea-aaa8-a9cfb87a7f3a.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F097e8f90-f89b-11ea-aaa8-a9cfb87a7f3a.jpg?alt=media&token=376cd4db-cf71-4542-b4d0-5bcd941bce01"
	  }],
	  productNameEnglish: "ROYAL APPLE",
	  productPrice: "3 ",
	  productSupplier: "BCS SHOP",
	  searchText: "আপেল ",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "5pcs",
	  updateDateTime: "Thu 17-09-20 12:05 pm"
	}, {
	  category: "COOKING OIL INGREDIENTS",
	  key: "-M9b0ejJGRBY6RONeqRc",
	  photos: [{
	    imageName: "868032b0-ac6e-11ea-9366-875156fdc5b0.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F868032b0-ac6e-11ea-9366-875156fdc5b0.jpg?alt=media&token=e61ff6ad-7089-497b-a2e7-364fb32cf506"
	  }],
	  productNameEnglish: "Oil rice bran",
	  productPrice: "18.50",
	  productSupplier: "BCS SHOP",
	  sortOrder: "e",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "5Kg",
	  updateDateTime: "04/07/2020 11:52:24"
	}, {
	  category: "LAUNDRY CLEANING",
	  key: "-M9b-r085kyDgg2qGPU4",
	  photos: [{
	    imageName: "620e8960-ad20-11ea-b3c2-65ebaaf8f481.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F620e8960-ad20-11ea-b3c2-65ebaaf8f481.jpg?alt=media&token=130ea1b3-8172-4819-93e9-f27697dffdbe"
	  }],
	  productNameEnglish: "Softlan anti wrinkles levender fresh fabric softener",
	  productPrice: "5",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1.6L refill",
	  updateDateTime: "05/07/2020 12:39:34"
	}, {
	  category: "FRUITS VEGETABLES ",
	  key: "-M9b-MLpqXrFjouqCo9g",
	  photos: [{
	    imageName: "e3403770-f89a-11ea-aaa8-a9cfb87a7f3a.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2Fe3403770-f89a-11ea-aaa8-a9cfb87a7f3a.jpg?alt=media&token=b68ac054-e6a1-4338-a8cd-35365f3e48e5"
	  }],
	  productNameEnglish: "POMEGRANATE ",
	  productPrice: "3",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1 pc",
	  updateDateTime: "Thu 17-09-20 12:04 pm"
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  key: "-M9b-7mBkiQTOHJc8uAO",
	  photos: [{
	    imageName: "a3e41fb0-f89a-11ea-aaa8-a9cfb87a7f3a.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2Fa3e41fb0-f89a-11ea-aaa8-a9cfb87a7f3a.jpg?alt=media&token=87a4a44c-3b0a-42cf-b613-d3a7b86c04f8"
	  }],
	  productNameEnglish: "MANGO ",
	  productPrice: "8",
	  productSupplier: "BCS SHOP",
	  searchText: "আম ",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1 kg",
	  updateDateTime: "Mon 21-09-20 3:34 pm"
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  key: "-M9azxw85yqueK8BLY-D",
	  photos: [{
	    imageName: "83655650-f89a-11ea-aaa8-a9cfb87a7f3a.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F83655650-f89a-11ea-aaa8-a9cfb87a7f3a.jpg?alt=media&token=003237b8-013d-48f9-a76a-a63fd9e36fd1"
	  }],
	  productNameEnglish: "MANGO ",
	  productPrice: "3.50",
	  productSupplier: "BCS SHOP",
	  searchText: "আম ",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1 pc",
	  updateDateTime: "Mon 21-09-20 3:34 pm"
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  key: "-M9azGy9V0WyqpXj0Fnx",
	  photos: [{
	    imageName: "598c4b40-f89a-11ea-aaa8-a9cfb87a7f3a.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F598c4b40-f89a-11ea-aaa8-a9cfb87a7f3a.jpg?alt=media&token=24f5c465-1f6c-436a-8cb0-abe73572625b"
	  }],
	  productNameEnglish: "PINEAPPLE ",
	  productPrice: "2",
	  productSupplier: "BCS SHOP",
	  searchText: "আনারস ",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1 pc",
	  updateDateTime: "Thu 17-09-20 12:00 pm"
	}, {
	  category: "EGGS DAIRY",
	  key: "-M9azBD00jOMIsIDMIsE",
	  photos: [{
	    imageName: "ecd726b0-ac6c-11ea-b746-074fa252a561.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fecd726b0-ac6c-11ea-b746-074fa252a561.jpg?alt=media&token=f5800a3d-394b-48ba-b84d-889cb3c02ac2"
	  }],
	  productNameEnglish: "HL Milk",
	  productPrice: "6",
	  productSupplier: "BCS SHOP",
	  searchText: "fresh milk",
	  sortOrder: "d",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "2 x 1L",
	  updateDateTime: "05/07/2020 12:51:04"
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  key: "-M9az5-Me-d8aZxa8GQ6",
	  photos: [{
	    imageName: "ef2c6410-f899-11ea-aaa8-a9cfb87a7f3a.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2Fef2c6410-f899-11ea-aaa8-a9cfb87a7f3a.jpg?alt=media&token=cf50a739-762a-4e82-a0c5-c51e14099503"
	  }],
	  productNameEnglish: "SWEET POTATOES ",
	  productPrice: "5",
	  productSupplier: "BCS SHOP",
	  searchText: "মিষ্টি আলু ",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1Kg",
	  updateDateTime: "Fri 02-10-20 11:09 am"
	}, {
	  availability: "AVAILABLE",
	  category: "EGGS DAIRY",
	  isPopular: "YES",
	  key: "-M9ayXnPTIZLPeIsVKIy",
	  photos: [{
	    imageName: "859f9950-bf8b-11ea-85e3-735b22b1a0db.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F859f9950-bf8b-11ea-85e3-735b22b1a0db.jpg?alt=media&token=feeb6233-fae4-4319-b830-d02a86d405de"
	  }],
	  productNameEnglish: "Meiji milk ",
	  productPrice: "6",
	  productSupplier: "BCS SHOP",
	  searchText: "fresh milk দুধ গরুর দুধ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "2L",
	  updateDateTime: "06/07/2020 09:24:42"
	}, {
	  author: "+6589050302",
	  availability: "AVAILABLE",
	  category: "EGGS DAIRY",
	  isPopular: "YES",
	  key: "-M9ay5D0iIseTdskzY0e",
	  photos: [{
	    imageName: "20cb1dc0-afc2-11ea-a37e-bd24eb8f726f.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F20cb1dc0-afc2-11ea-a37e-bd24eb8f726f.jpg?alt=media&token=c06cd2ef-a9e3-4e75-9225-398ef140c872"
	  }],
	  productNameEnglish: "Egg ",
	  productPrice: "5.90",
	  productSupplier: "BCS SHOP",
	  searchText: "ডিম ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "30pcs",
	  updateDateTime: "Wed 05-08-20 5:07 pm"
	}, {
	  category: "KITCHEN DINING",
	  isPopular: "YES",
	  key: "-M9agD1h6myA-aTwEf9n",
	  photos: [{
	    imageName: "4e8585c0-ac61-11ea-bbe4-ef7bbce60778.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F4e8585c0-ac61-11ea-bbe4-ef7bbce60778.jpg?alt=media&token=1aac9faa-a6d2-4d17-8f9d-69f4b8cd7d6a"
	  }],
	  productNameEnglish: "Dish plate washing sumu ",
	  productPrice: "2.5",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1 container",
	  updateDateTime: "05/07/2020 12:52:00"
	}, {
	  availability: "AVAILABLE",
	  category: "DRINKS DESSERT",
	  isPopular: "YES",
	  key: "-M9afcR3fAF6iuy36Ovu",
	  photos: [{
	    imageName: "0d7136b0-ac61-11ea-bbe4-ef7bbce60778.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F0d7136b0-ac61-11ea-bbe4-ef7bbce60778.jpg?alt=media&token=a377c659-95bc-41e7-86eb-c1a85c6d4774"
	  }],
	  productNameEnglish: "Coffee ye ye ",
	  productPrice: "13.50",
	  productSupplier: "BCS SHOP",
	  searchText: "কফি ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "100pcs",
	  updateDateTime: "17/07/2020 08:12:24"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-M9af2C6QcBOgCNLYrUY",
	  photos: [{
	    imageName: "9d3f4a30-ac60-11ea-bbe4-ef7bbce60778.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F9d3f4a30-ac60-11ea-bbe4-ef7bbce60778.jpg?alt=media&token=80081c6c-38c4-4a13-8fce-16deb8c7238c"
	  }],
	  productNameEnglish: "Apple cider vinegar ",
	  productPrice: "3.5",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "473ml",
	  updateDateTime: "17/07/2020 08:35:47"
	}, {
	  availability: "AVAILABLE",
	  category: "DRINKS DESSERT",
	  isPopular: "YES",
	  key: "-M9adMyGbl5sEoSO32-G",
	  photos: [{
	    imageName: "fa049c20-c826-11ea-99a6-3f4f89ed7cd9.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Ffa049c20-c826-11ea-99a6-3f4f89ed7cd9.jpg?alt=media&token=422a5305-33a0-4c49-b19b-91e1e0c87417"
	  }],
	  productNameEnglish: "SHEMAI",
	  productPrice: "1",
	  productSupplier: "BCS SHOP",
	  searchText: "সেমাই ",
	  sortOrder: "a",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1 pkt",
	  updateDateTime: "17/07/2020 08:13:56"
	}, {
	  availability: "AVAILABLE",
	  category: "DRINKS DESSERT",
	  isPopular: "YES",
	  key: "-M9acdO504KEU3NWLjzn",
	  photos: [{
	    imageName: "098170d0-ac5f-11ea-bbe4-619ccaa778ae.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F098170d0-ac5f-11ea-bbe4-619ccaa778ae.jpg?alt=media&token=898f30fa-1c3b-4c88-9319-cc14e2c84f7d"
	  }],
	  productNameEnglish: "SUGAR",
	  productPrice: "1.50",
	  productSupplier: "BCS SHOP",
	  searchText: "চিনি  ",
	  sortOrder: "a",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1Kg Packet",
	  updateDateTime: "17/07/2020 07:32:49"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-M9acBvzo_FyEcT4Sy6f",
	  photos: [{
	    imageName: "ca7b4140-ac5e-11ea-bbe4-619ccaa778ae.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fca7b4140-ac5e-11ea-bbe4-619ccaa778ae.jpg?alt=media&token=4e0e8eed-939d-434c-8934-3e09de7f84a0"
	  }],
	  productNameEnglish: "GHEE",
	  productPrice: "3.80 ",
	  productSupplier: "BCS SHOP",
	  searchText: "ঘি ",
	  sortOrder: "a",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "100gms",
	  updateDateTime: "17/07/2020 07:11:57"
	}, {
	  availability: "AVAILABLE",
	  category: "RICE DAAL NOODLES",
	  isPopular: "YES",
	  key: "-M9abk1BKoOu9ucf_i0P",
	  photos: [{
	    imageName: "9cd4b370-ac5e-11ea-bbe4-619ccaa778ae.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F9cd4b370-ac5e-11ea-bbe4-619ccaa778ae.jpg?alt=media&token=11a6a33d-b137-45d3-9d2b-ad3afd188bed"
	  }],
	  productNameEnglish: "BASIL SEEDS ",
	  productPrice: "2.50 ",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "80gm",
	  updateDateTime: "23/07/2020 12:30:54"
	}, {
	  availability: "AVAILABLE",
	  category: "DRINKS DESSERT",
	  isPopular: "YES",
	  key: "-M9abIGxJKlE1oLFhixj",
	  photos: [{
	    imageName: "4e108430-ac5e-11ea-bbe4-619ccaa778ae.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F4e108430-ac5e-11ea-bbe4-619ccaa778ae.jpg?alt=media&token=5153f384-472c-4c7e-8d5d-65c8f3afa2ca"
	  }],
	  productNameEnglish: "ISABGOL",
	  productPrice: "2.80 ",
	  productSupplier: "BCS SHOP",
	  searchText: "ইছবগুল",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1 pkt small",
	  updateDateTime: "17/07/2020 08:49:03"
	}, {
	  category: "SNACKS DRY FOOD",
	  isPopular: "YES",
	  key: "-M9aaXMmcESUiLyIFlYy",
	  photos: [{
	    imageName: "5abc8280-ddee-11ea-a50a-71ea37251d72.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F5abc8280-ddee-11ea-a50a-71ea37251d72.jpg?alt=media&token=6b453a6d-88da-433e-b338-508941e8076a"
	  }],
	  productNameEnglish: "DRY CAKE pran",
	  productPrice: "2.80",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1 pkt 350g",
	  updateDateTime: "Fri 14-08-20 1:24 pm"
	}, {
	  availability: "AVAILABLE",
	  category: "SNACKS DRY FOOD",
	  isPopular: "NO",
	  key: "-M9aaC7nHYMy5XdSKVR6",
	  photos: [{
	    imageName: "bcdbf850-ac5d-11ea-bbe4-619ccaa778ae.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fbcdbf850-ac5d-11ea-bbe4-619ccaa778ae.jpg?alt=media&token=af322bc6-c4d3-4053-a024-e9a32cee307d"
	  }],
	  productNameEnglish: "TOAST ",
	  productPrice: "2",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1 pkt",
	  updateDateTime: "23/07/2020 12:32:33"
	}, {
	  availability: "AVAILABLE",
	  category: "MEAT FISH",
	  isPopular: "YES",
	  key: "-M9aa9kk1vImV8YpWvXX",
	  photos: [{
	    imageName: "575f2290-ac5d-11ea-a00d-954b17f61eb9.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F575f2290-ac5d-11ea-a00d-954b17f61eb9.jpg?alt=media&token=48cef136-ff9c-468a-945c-3a86b315c180"
	  }],
	  productNameEnglish: "Olive bard ",
	  productPrice: "5.5",
	  productSupplier: "BCS SHOP",
	  searchText: "মাছ ",
	  sortOrder: "d",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1kg",
	  updateDateTime: "17/07/2020 07:36:39"
	}, {
	  availability: "AVAILABLE",
	  category: "SNACKS DRY FOOD",
	  isPopular: "NO",
	  key: "-M9a_YqhjXIpKB7_yC_b",
	  photos: [{
	    imageName: "3a2c76f0-ac5d-11ea-bbe4-619ccaa778ae.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F3a2c76f0-ac5d-11ea-bbe4-619ccaa778ae.jpg?alt=media&token=10e0d0a5-0aa5-48a0-b5c8-bf72ce4be9e0"
	  }],
	  productNameEnglish: "TOAST ",
	  productPrice: "2",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1 pkt",
	  updateDateTime: "23/07/2020 12:33:28"
	}, {
	  availability: "AVAILABLE",
	  category: "SNACKS DRY FOOD",
	  isPopular: "NO",
	  key: "-M9a_DoeaS6RlzomcExY",
	  photos: [{
	    imageName: "23c3c530-ac5d-11ea-bbe4-619ccaa778ae.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F23c3c530-ac5d-11ea-bbe4-619ccaa778ae.jpg?alt=media&token=e15f3569-efc2-473e-932f-af0cc080335f"
	  }],
	  productNameEnglish: "TOAST ",
	  productPrice: "2",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1 pkt",
	  updateDateTime: "23/07/2020 12:33:50"
	}, {
	  availability: "AVAILABLE",
	  category: "SNACKS DRY FOOD",
	  isPopular: "NO",
	  key: "-M9a_1bytLy0Nu3atm0R",
	  photos: [{
	    imageName: "f81b9f70-ac5c-11ea-bbe4-619ccaa778ae.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Ff81b9f70-ac5c-11ea-bbe4-619ccaa778ae.jpg?alt=media&token=141646ea-3a5b-4fe8-b0fd-9308269e54ec"
	  }],
	  productNameEnglish: "TOAST",
	  productPrice: "2",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1 pkt",
	  updateDateTime: "23/07/2020 12:34:05"
	}, {
	  availability: "AVAILABLE",
	  category: "MEAT FISH",
	  isPopular: "YES",
	  key: "-M9a_0-2n-GYPYpy2QX6",
	  photos: [{
	    imageName: "e04f6610-ac5c-11ea-a00d-954b17f61eb9.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fe04f6610-ac5c-11ea-a00d-954b17f61eb9.jpg?alt=media&token=d08dcef5-139c-492a-92aa-18b9655b6dc6"
	  }],
	  productNameEnglish: "prawns $16 to $30/1kg",
	  productPrice: "18",
	  productSupplier: "BCS SHOP",
	  searchText: "চিংড়ি মাছ ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1 kg",
	  updateDateTime: "23/07/2020 12:43:05"
	}, {
	  availability: "AVAILABLE",
	  category: "LAUNDRY CLEANING",
	  isPopular: "YES",
	  key: "-M9aYpdhtL6j7unq8TjC",
	  photos: [{
	    imageName: "fb7e9600-ac5b-11ea-bbe4-619ccaa778ae.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Ffb7e9600-ac5b-11ea-bbe4-619ccaa778ae.jpg?alt=media&token=d7e5631e-2a6c-45be-a79e-ece66f028b16"
	  }],
	  productNameEnglish: "DISHWASHING ",
	  productPrice: "11",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1 container",
	  updateDateTime: "23/07/2020 12:43:21"
	}, {
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-M9aX0eXXs2r-3O7c1OV",
	  photos: [{
	    imageName: "0a4ef8a0-f7cf-11ea-9ca4-275d4c37dc1b.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F0a4ef8a0-f7cf-11ea-9ca4-275d4c37dc1b.jpg?alt=media&token=a0cd1cab-f6c4-43c4-85eb-64e1773c957a"
	  }],
	  productNameEnglish: "PRAN MUSTARD SEEDS OIL ",
	  productPrice: "2.60 ",
	  productSupplier: "BCS SHOP",
	  searchText: "সরিষার তেল ",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "250ml",
	  updateDateTime: "Wed 16-09-20 11:45 am"
	}, {
	  availability: "AVAILABLE",
	  category: "PICKLES",
	  isPopular: "YES",
	  key: "-M9aWOR41HDGXQM1UaW-",
	  photos: [{
	    imageName: "ea186f50-ac81-11ea-b4b2-63d9e39acaf7.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fea186f50-ac81-11ea-b4b2-63d9e39acaf7.jpg?alt=media&token=a589dc38-cee4-4faf-9603-1d54438c10b9"
	  }],
	  productNameEnglish: "PRAN MANGO PICKLE",
	  productPrice: " 3.2",
	  productSupplier: "BCS SHOP",
	  searchText: "আমের আচার",
	  sortOrder: "a",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1 btl",
	  updateDateTime: "17/07/2020 07:38:49"
	}, {
	  author: "+6589050302",
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  key: "-M9aW8grXeHaS2bkydWz",
	  photos: [{
	    imageName: "a2db8130-ac5a-11ea-943a-e361d08112a3.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fa2db8130-ac5a-11ea-943a-e361d08112a3.jpg?alt=media&token=7b6e03c4-43f6-4548-aeb3-0d72cf3688cc"
	  }],
	  productNameEnglish: "Gold oil 2kg",
	  productPrice: "9.80",
	  productSupplier: "BCS SHOP",
	  searchText: "তেল ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "2L",
	  updateDateTime: "Mon 10-08-20 12:01 pm"
	}, {
	  availability: "AVAILABLE",
	  category: "PICKLES",
	  isPopular: "YES",
	  key: "-M9aW7edgmjmeVJGuQDg",
	  photos: [{
	    imageName: "906b0bb0-ac5a-11ea-bbe4-619ccaa778ae.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F906b0bb0-ac5a-11ea-bbe4-619ccaa778ae.jpg?alt=media&token=0d5ccf96-888e-4839-9527-6ee38c6b6752"
	  }],
	  productNameEnglish: "PRAN OLIVE PICKLE",
	  productPrice: "3.20",
	  productSupplier: "BCS SHOP",
	  searchText: "জলপাইর আচার",
	  sortOrder: "a",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1 btl",
	  updateDateTime: "17/07/2020 07:38:26"
	}, {
	  availability: "AVAILABLE",
	  category: "PICKLES",
	  isPopular: "YES",
	  key: "-M9aVn49Kj6Vx8QpDqtJ",
	  photos: [{
	    imageName: "566ba230-ac5a-11ea-bbe4-619ccaa778ae.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F566ba230-ac5a-11ea-bbe4-619ccaa778ae.jpg?alt=media&token=ac9d7b01-1703-49c2-b16a-523110e1c10c"
	  }],
	  productNameEnglish: "PRAN CHILLI PICKLE",
	  productPrice: "3.2",
	  productSupplier: "BCS SHOP",
	  searchText: "মরিচের আচার ",
	  sortOrder: "a",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1 btl",
	  updateDateTime: "17/07/2020 07:38:21"
	}, {
	  availability: "AVAILABLE",
	  category: "RICE DAAL NOODLES",
	  isPopular: "YES",
	  key: "-M9aVSMCT5Ptf6z4V_RH",
	  photos: [{
	    imageName: "39359b30-ac5a-11ea-abb9-bdb7271566ee.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F39359b30-ac5a-11ea-abb9-bdb7271566ee.jpg?alt=media&token=bc3b3ed4-680c-4e06-89a9-78472234b2f4"
	  }],
	  productNameEnglish: "Rice ",
	  productPrice: "14.9",
	  productSupplier: "BCS SHOP",
	  searchText: "চাউল ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "10kg",
	  updateDateTime: "23/07/2020 12:45:01"
	}, {
	  availability: "AVAILABLE",
	  category: "RICE DAAL NOODLES",
	  isPopular: "YES",
	  key: "-M9aVKAJjayljKS9Th5s",
	  photos: [{
	    imageName: "2b985630-f899-11ea-aaa8-a9cfb87a7f3a.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F2b985630-f899-11ea-aaa8-a9cfb87a7f3a.jpg?alt=media&token=1e4a7b65-b3c4-453c-a5c3-5d45e4d79ba4"
	  }],
	  productNameEnglish: "Rice ",
	  productPrice: "7.8",
	  productSupplier: "BCS SHOP",
	  searchText: "চাউল",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "5kg",
	  updateDateTime: "Thu 17-09-20 11:52 am"
	}, {
	  availability: "AVAILABLE",
	  category: "SNACKS DRY FOOD",
	  isPopular: "YES",
	  key: "-M9aVAEroX6hfNMnZlj6",
	  photos: [{
	    imageName: "f60ff850-ac59-11ea-bbe4-619ccaa778ae.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Ff60ff850-ac59-11ea-bbe4-619ccaa778ae.jpg?alt=media&token=6c8fb7e5-3e4f-4055-a03f-840ad423c18b"
	  }],
	  productNameEnglish: "RAISINS ",
	  productPrice: "2 ",
	  productSupplier: "BCS SHOP",
	  searchText: "maiwa কিচমিচ ",
	  sortOrder: "a",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "150gms",
	  updateDateTime: "23/07/2020 12:45:56"
	}, {
	  availability: "AVAILABLE",
	  category: "SNACKS DRY FOOD",
	  isPopular: "YES",
	  key: "-M9aUta2ZW3uTbaB-UsJ",
	  photos: [{
	    imageName: "d7e77b00-ac59-11ea-bbe4-619ccaa778ae.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fd7e77b00-ac59-11ea-bbe4-619ccaa778ae.jpg?alt=media&token=e82f3068-a359-4d59-ad04-7a1317b3da4c"
	  }],
	  productNameEnglish: "ALMOND ",
	  productPrice: "2",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1 pkt",
	  updateDateTime: "23/07/2020 12:46:52"
	}, {
	  availability: "AVAILABLE",
	  category: "SNACKS DRY FOOD",
	  isPopular: "YES",
	  key: "-M9aUeq2jeBQO3RmM6qP",
	  photos: [{
	    imageName: "b42e2010-ac59-11ea-bbe4-619ccaa778ae.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fb42e2010-ac59-11ea-bbe4-619ccaa778ae.jpg?alt=media&token=1388583b-af31-4f72-9810-0a5c20199038"
	  }],
	  productNameEnglish: "PEANUT ",
	  productPrice: "0.80",
	  productSupplier: "BCS SHOP",
	  searchText: "বাদাম ",
	  sortOrder: "a",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "100G",
	  updateDateTime: "23/07/2020 12:46:44"
	}, {
	  availability: "AVAILABLE",
	  category: "SNACKS DRY FOOD",
	  isPopular: "YES",
	  key: "-M9aUTJYmnr3ay_dMfFU",
	  photos: [{
	    imageName: "88b87c00-ac59-11ea-bbe4-619ccaa778ae.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F88b87c00-ac59-11ea-bbe4-619ccaa778ae.jpg?alt=media&token=806628c8-d92a-4854-998b-769cf8e22f6b"
	  }],
	  productNameEnglish: "CASHEW ",
	  productPrice: "2.50",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1 pkt",
	  updateDateTime: "23/07/2020 12:47:08"
	}, {
	  availability: "AVAILABLE",
	  category: "DRINKS DESSERT",
	  isPopular: "NO",
	  key: "-M9aUEBtt43r8qUiG-Jk",
	  photos: [{
	    imageName: "74a5c830-ac59-11ea-abb9-bdb7271566ee.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F74a5c830-ac59-11ea-abb9-bdb7271566ee.jpg?alt=media&token=b1d26395-81c3-4f04-859f-5e1a62451811"
	  }],
	  productNameEnglish: "Super coffee",
	  productPrice: "6",
	  productSupplier: "BCS SHOP",
	  searchText: "কফি ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: " 40 pkts",
	  updateDateTime: "23/07/2020 12:47:40"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-M9aUAXelq_RZ3rWlftI",
	  photos: [{
	    imageName: "537ba3a0-ac59-11ea-bbe4-619ccaa778ae.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F537ba3a0-ac59-11ea-bbe4-619ccaa778ae.jpg?alt=media&token=1555adaf-446a-4c95-93c1-57199b0e6efd"
	  }],
	  productNameEnglish: "STAR ANISE ",
	  productPrice: "2.70",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1 pkt",
	  updateDateTime: "23/07/2020 12:47:57"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-M9aTqdEuYIFo6kUyqf-",
	  photos: [{
	    imageName: "1cb17480-ac59-11ea-bbe4-619ccaa778ae.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F1cb17480-ac59-11ea-bbe4-619ccaa778ae.jpg?alt=media&token=7d33c4d9-a403-449c-a06b-9a44907e7357"
	  }],
	  productNameEnglish: "NUTMEG ",
	  productPrice: "1.50",
	  productSupplier: "BCS SHOP",
	  searchText: "জায়ফল",
	  sortOrder: "x",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1 pkt",
	  updateDateTime: "23/07/2020 12:49:03"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-M9aTVD1cwIwhtaqReNX",
	  photos: [{
	    imageName: "f04821a0-ac58-11ea-bbe4-619ccaa778ae.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Ff04821a0-ac58-11ea-bbe4-619ccaa778ae.jpg?alt=media&token=b3c70bc6-b839-4717-8275-0a13fd2d023e"
	  }],
	  productNameEnglish: "NIGELLA SEEDS ",
	  productPrice: "2.50",
	  productSupplier: "BCS SHOP",
	  searchText: "কালোজিরা",
	  sortOrder: "a",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1 pkt ",
	  updateDateTime: "23/07/2020 12:50:01"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-M9aTBq-BrOibWA7X8Y-",
	  photos: [{
	    imageName: "ce7ab830-ac58-11ea-bbe4-619ccaa778ae.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fce7ab830-ac58-11ea-bbe4-619ccaa778ae.jpg?alt=media&token=0348fe5e-a6e4-4e9a-9cef-f0f783d50486"
	  }],
	  productNameEnglish: "FENUGREEK ",
	  productPrice: "2.5",
	  productSupplier: "BCS SHOP",
	  searchText: "মেথি",
	  sortOrder: "a",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1 pkt",
	  updateDateTime: "23/07/2020 12:50:35"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-M9aSvkrW8JCLm9Dvxhy",
	  photos: [{
	    imageName: "7d11cec0-ac58-11ea-bbe4-619ccaa778ae.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F7d11cec0-ac58-11ea-bbe4-619ccaa778ae.jpg?alt=media&token=3b63f196-00de-4f2d-a8f3-55fdca947c35"
	  }],
	  productNameEnglish: "MUSTARD SEEDS ",
	  productPrice: "1.50",
	  productSupplier: "BCS SHOP",
	  searchText: " সরিষা",
	  sortOrder: "a",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1 pkt",
	  updateDateTime: "23/07/2020 12:51:08"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-M9aSP39jNTjGW4ykAwz",
	  photos: [{
	    imageName: "4b14b810-ac58-11ea-bbe4-619ccaa778ae.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F4b14b810-ac58-11ea-bbe4-619ccaa778ae.jpg?alt=media&token=6247c545-4ff3-4cc8-8671-6d198ed11612"
	  }],
	  productNameEnglish: "BLACK PEPPER ",
	  productPrice: "3.20",
	  productSupplier: "BCS SHOP",
	  searchText: "গোল মরিচ",
	  sortOrder: "a",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1pkt",
	  updateDateTime: "23/07/2020 12:51:48"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-M9aS4IY6quwHYKAvjXX",
	  photos: [{
	    imageName: "03b4edf0-ac58-11ea-bbe4-619ccaa778ae.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F03b4edf0-ac58-11ea-bbe4-619ccaa778ae.jpg?alt=media&token=0859059e-6ed2-4914-b8ea-9d5354cb1a40"
	  }],
	  productNameEnglish: "GARAM MASALA",
	  productPrice: "3.70",
	  productSupplier: "BCS SHOP",
	  searchText: "গরম মসলা ",
	  sortOrder: "a",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1pkt",
	  updateDateTime: "17/07/2020 07:51:43"
	}, {
	  availability: "AVAILABLE",
	  category: "DRINKS DESSERT",
	  isPopular: "YES",
	  key: "-M9aRmMLeT1fzaHZUOLK",
	  photos: [{
	    imageName: "eb144d90-ac57-11ea-985e-71484f367323.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Feb144d90-ac57-11ea-985e-71484f367323.jpg?alt=media&token=3d7a2556-c483-41e1-9b7f-2cb2304f1474"
	  }],
	  productNameEnglish: "Horlicks refill ",
	  productPrice: "7.90",
	  productSupplier: "BCS SHOP",
	  searchText: "হরলিক্স ",
	  sortOrder: "g",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "400g",
	  updateDateTime: "17/07/2020 07:41:20"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-M9aRdZyiIAso0X611a2",
	  photos: [{
	    imageName: "b8db3f50-ac57-11ea-bbe4-619ccaa778ae.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fb8db3f50-ac57-11ea-bbe4-619ccaa778ae.jpg?alt=media&token=f869a70e-0bf3-4b27-80d6-cf9145ff45c1"
	  }],
	  productNameEnglish: "CINNAMON ",
	  productPrice: "2",
	  productSupplier: "BCS SHOP",
	  searchText: "দারুচিনি",
	  sortOrder: "q",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1 pkt",
	  updateDateTime: "23/07/2020 12:52:38"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-M9aRBklNAIDF9JOcKsC",
	  photos: [{
	    imageName: "55b9f160-f738-11ea-885a-2b4d96b2f26b.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F55b9f160-f738-11ea-885a-2b4d96b2f26b.jpg?alt=media&token=16644f6d-4e4a-4cca-a4a7-9502e87dca56"
	  }],
	  productNameEnglish: "BAY LEAF",
	  productPrice: "1.40",
	  productSupplier: "BCS SHOP",
	  searchText: "তেজ পাতা",
	  sortOrder: "a",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1 pkt",
	  updateDateTime: "Tue 15-09-20 5:47 pm"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-M9aQxDONOGmx6jfGsIZ",
	  photos: [{
	    imageName: "62e5aa00-f7d3-11ea-9ca4-275d4c37dc1b.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F62e5aa00-f7d3-11ea-9ca4-275d4c37dc1b.jpg?alt=media&token=f59c35ed-827b-4519-8f99-9a89a34bbb90"
	  }],
	  productNameEnglish: "DRY CHILLI ",
	  productPrice: "1.50",
	  productSupplier: "BCS SHOP",
	  searchText: "শুকনা মরিচ লাল মরিচ ",
	  sortOrder: "a",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1 pkt",
	  updateDateTime: "Wed 16-09-20 12:16 pm"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-M9aQc7YsWNmDmoolF11",
	  photos: [{
	    imageName: "0b0b8ce0-ac57-11ea-bbe4-619ccaa778ae.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F0b0b8ce0-ac57-11ea-bbe4-619ccaa778ae.jpg?alt=media&token=2a3877ce-a6ee-49ba-b688-70de2d971d96"
	  }],
	  productNameEnglish: "DC DRY CHILLI POWDER ",
	  productPrice: "3.50",
	  productSupplier: "BCS SHOP",
	  searchText: "মরিচের গুঁড়া ",
	  sortOrder: "a",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1 btl",
	  updateDateTime: "17/07/2020 07:57:15"
	}, {
	  availability: "AVAILABLE",
	  category: "DRINKS DESSERT",
	  isPopular: "NO",
	  key: "-M9aQByOxtIHQ-5lwDs9",
	  photos: [{
	    imageName: "fc4310c0-ac56-11ea-985e-71484f367323.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Ffc4310c0-ac56-11ea-985e-71484f367323.jpg?alt=media&token=3bd0a4ca-eee5-4113-a4b7-df8a68f2a7c7"
	  }],
	  productNameEnglish: "Milo ",
	  productPrice: "9",
	  productSupplier: "BCS SHOP",
	  searchText: "মিলো ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "900gms",
	  updateDateTime: "17/07/2020 08:47:16"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-M9aQ4t5M-cz1xzBmOfI",
	  photos: [{
	    imageName: "dcc3dd10-ac56-11ea-bbe4-619ccaa778ae.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fdcc3dd10-ac56-11ea-bbe4-619ccaa778ae.jpg?alt=media&token=91619b71-70f4-4a45-96b4-043c11dd2dfe"
	  }],
	  productNameEnglish: "DC TURMERIC POWDER ",
	  productPrice: "3.70",
	  productSupplier: "BCS SHOP",
	  searchText: "হলুদের গুঁড়া হলুদ ",
	  sortOrder: "a",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1 btl",
	  updateDateTime: "23/07/2020 12:54:39"
	}, {
	  availability: "AVAILABLE",
	  category: "DRINKS DESSERT",
	  isPopular: "NO",
	  key: "-M9aQ1d0r501lRFYnTqB",
	  photos: [{
	    imageName: "c72fe070-ac56-11ea-985e-71484f367323.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fc72fe070-ac56-11ea-985e-71484f367323.jpg?alt=media&token=b86a93a7-7fb4-4016-bf3c-504ca3051629"
	  }],
	  productNameEnglish: "Milo",
	  productPrice: "15",
	  productSupplier: "BCS SHOP",
	  searchText: "মিলো",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "24pcs x 200ml ",
	  updateDateTime: "17/07/2020 08:47:42"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-M9aPVOkQxrHnTECKuuC",
	  photos: [{
	    imageName: "da671460-de06-11ea-a50a-71ea37251d72.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2Fda671460-de06-11ea-a50a-71ea37251d72.jpg?alt=media&token=f5a3c8c0-fcc1-4da3-a7ee-be044efff30e"
	  }],
	  productNameEnglish: "DC CUMIN POWDER ",
	  productPrice: "3.80",
	  productSupplier: "BCS SHOP",
	  searchText: "জিরার গুঁড়া পাউডার ",
	  sortOrder: "a",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1 btl 200g",
	  updateDateTime: "Fri 14-08-20 4:20 pm"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-M9aOOa2t7sa0B0gRCVr",
	  productNameEnglish: "TURMERIC POWDER",
	  productPrice: "3.80",
	  productSupplier: "BCS SHOP",
	  searchText: "হলুদের গুঁড়া",
	  sortOrder: "a",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1 pkt",
	  updateDateTime: "Fri 14-08-20 4:52 pm"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-M9aEGTP2736X6CBBnXa",
	  photos: [{
	    imageName: "87a98890-ac4f-11ea-95e2-e74f5187871b.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F87a98890-ac4f-11ea-95e2-e74f5187871b.jpg?alt=media&token=49f5c0fe-472b-4833-bd94-5e60cc5c65fd"
	  }],
	  productNameEnglish: "CORIANDER POWDER",
	  productPrice: "2.50",
	  productSupplier: "BCS SHOP",
	  searchText: "ধনিয়ার গুঁড়া ",
	  sortOrder: "a",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1 pkt",
	  updateDateTime: "17/07/2020 08:01:23"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-M9aDmJfZ26UqwhujLhA",
	  photos: [{
	    imageName: "2903cc10-ac4f-11ea-95e2-e74f5187871b.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F2903cc10-ac4f-11ea-95e2-e74f5187871b.jpg?alt=media&token=5157bf34-ad86-474d-bf50-f6401dca9beb"
	  }],
	  productNameEnglish: "CUMIN POWDER",
	  productPrice: "3.50",
	  productSupplier: "BCS SHOP",
	  searchText: "জিরার গুঁড়া ",
	  sortOrder: "a",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1 packet",
	  updateDateTime: "17/07/2020 07:58:13"
	}, {
	  availability: "AVAILABLE",
	  category: "RICE DAAL NOODLES",
	  isPopular: "YES",
	  key: "-M9a57Nre5UDcjazBxYD",
	  photos: [{
	    imageName: "18c5b8a0-e8e4-11ea-b634-e7e7c4cb042d.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F18c5b8a0-e8e4-11ea-b634-e7e7c4cb042d.jpg?alt=media&token=7058c195-98e7-4b91-a358-48ce46e0e590"
	  }],
	  productNameEnglish: "Rice Cinigora ",
	  productPrice: "5",
	  productSupplier: "BCS SHOP",
	  searchText: "চিনিগুঁড়া ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1kg",
	  updateDateTime: "Fri 28-08-20 12:08 pm"
	}, {
	  category: "FROZEN",
	  isPopular: "YES",
	  key: "-M9a4CZ78AOClgPOpNxT",
	  photos: [{
	    imageName: "6bbed500-ac49-11ea-ba1a-4bcfa8bf5006.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F6bbed500-ac49-11ea-ba1a-4bcfa8bf5006.jpg?alt=media&token=d5cff067-856b-447e-9a85-edd0d3a73555"
	  }],
	  productNameEnglish: "chicken drumstick   ",
	  productPrice: "4",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1kg",
	  updateDateTime: "04/07/2020 09:30:07"
	}, {
	  category: "MEAT FISH",
	  isPopular: "YES",
	  key: "-M9a3auhPEiHX8_zYJ8T",
	  photos: [{
	    imageName: "c22b5180-afbd-11ea-a37e-bd24eb8f726f.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fc22b5180-afbd-11ea-a37e-bd24eb8f726f.jpg?alt=media&token=e57daca0-c1dd-4eff-acfa-416ea81009ce"
	  }],
	  productNameEnglish: "Chicken wings ",
	  productPrice: "5",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1kg ",
	  updateDateTime: "04/07/2020 09:29:39"
	}, {
	  availability: "AVAILABLE",
	  category: "MEAT FISH",
	  isPopular: "YES",
	  key: "-M9a2iFZWTS972ahdFLF",
	  photos: [{
	    imageName: "b046e380-ac48-11ea-ba1a-4bcfa8bf5006.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fb046e380-ac48-11ea-ba1a-4bcfa8bf5006.jpg?alt=media&token=22920773-af55-4253-b1d8-dc02ba62bde0"
	  }],
	  productNameEnglish: "Fish small ",
	  productPrice: "5.5",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1 packet",
	  updateDateTime: "06/07/2020 07:12:48"
	}, {
	  availability: "AVAILABLE",
	  category: "MEAT FISH",
	  isPopular: "YES",
	  key: "-M9a2_CWuCbIou2qTCuq",
	  photos: [{
	    imageName: "9e45aa90-ac48-11ea-ba1a-4bcfa8bf5006.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F9e45aa90-ac48-11ea-ba1a-4bcfa8bf5006.jpg?alt=media&token=8bca4183-b6de-42fa-b59f-fe1b125e7b31"
	  }],
	  productNameEnglish: "Fish small ",
	  productPrice: "5.5",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1 packet",
	  updateDateTime: "06/07/2020 07:13:04"
	}, {
	  category: "MEAT FISH",
	  isPopular: "YES",
	  key: "-M9a2QTdetZeIHqGAUar",
	  photos: [{
	    imageName: "790847b0-ac48-11ea-ba1a-4bcfa8bf5006.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F790847b0-ac48-11ea-ba1a-4bcfa8bf5006.jpg?alt=media&token=049c102a-db22-4066-bbd6-5906774e76bb"
	  }],
	  productNameEnglish: "Fish small fish ",
	  productPrice: "5.5",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1 packet",
	  updateDateTime: "04/07/2020 09:28:25"
	}, {
	  availability: "AVAILABLE",
	  category: "TUPPERWARE CONTAINER",
	  isPopular: "YES",
	  key: "-M9a2COGsCqlkCzrn6zP",
	  photos: [{
	    imageName: "5c267b30-ac48-11ea-ba1a-4bcfa8bf5006.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F5c267b30-ac48-11ea-ba1a-4bcfa8bf5006.jpg?alt=media&token=b7299a94-a39a-4d4b-afba-fff28c83d61a"
	  }],
	  productNameEnglish: "Plastic bag ",
	  productPrice: "0.70",
	  productSupplier: "BCS SHOP",
	  searchText: "প্লাষ্টিক প্যাকেট ",
	  sortOrder: "x",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1 packet",
	  updateDateTime: "23/07/2020 12:55:53"
	}, {
	  availability: "AVAILABLE",
	  category: "TUPPERWARE CONTAINER",
	  isPopular: "YES",
	  key: "-M9a0sA0Y0KbX1e3hP5d",
	  photos: [{
	    imageName: "70c59220-e8f1-11ea-b634-e7e7c4cb042d.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F70c59220-e8f1-11ea-b634-e7e7c4cb042d.jpg?alt=media&token=abcd4376-9b86-4528-91b2-fec809d6969d"
	  }],
	  productNameEnglish: "Curry Plastic String Bag",
	  productPrice: "0.70",
	  productSupplier: "BCS SHOP",
	  searchText: "কারী পেপার কারি ব্যাগ ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1 roll ",
	  updateDateTime: "Fri 28-08-20 1:43 pm"
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-M9a0bvd5rTsA52SgzV4",
	  photos: [{
	    imageName: "e3140940-f898-11ea-aaa8-a9cfb87a7f3a.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2Fe3140940-f898-11ea-aaa8-a9cfb87a7f3a.jpg?alt=media&token=dd62c212-4dd4-4927-9f9b-6fe69504e258"
	  }],
	  productNameEnglish: "Dates ",
	  productPrice: "5",
	  productSupplier: "BCS SHOP",
	  searchText: "খেজুর ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "500gm",
	  updateDateTime: "Thu 17-09-20 11:50 am"
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-M9a0LDvo6faRtgYPazt",
	  photos: [{
	    imageName: "7327d800-e8e4-11ea-b634-e7e7c4cb042d.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F7327d800-e8e4-11ea-b634-e7e7c4cb042d.jpg?alt=media&token=01659db6-d97f-4b29-877b-f2dc6a154c60"
	  }],
	  productNameEnglish: "Salt ",
	  productPrice: "1.40",
	  productSupplier: "BCS SHOP",
	  searchText: "লবণ লবন",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1kg",
	  updateDateTime: "Fri 28-08-20 12:10 pm"
	}, {
	  availability: "AVAILABLE",
	  category: "MEAT FISH",
	  isPopular: "YES",
	  key: "-M9a01C0di5V5yqY-TI8",
	  photos: [{
	    imageName: "f7b6c520-ac46-11ea-ba1a-4bcfa8bf5006.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Ff7b6c520-ac46-11ea-ba1a-4bcfa8bf5006.jpg?alt=media&token=979f21dc-bcfe-45bb-9a80-9574a3b8c01d"
	  }],
	  productNameEnglish: "Beef liver ",
	  productPrice: "5.5",
	  productSupplier: "BCS SHOP",
	  searchText: "গরুর কলিজা ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1kg",
	  updateDateTime: "23/07/2020 12:57:35"
	}, {
	  availability: "AVAILABLE",
	  category: "RICE DAAL NOODLES",
	  isPopular: "YES",
	  key: "-M9_z0n6fZMwZEkO3MGg",
	  photos: [{
	    imageName: "aedfe0d0-ac45-11ea-ba1a-4bcfa8bf5006.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Faedfe0d0-ac45-11ea-ba1a-4bcfa8bf5006.jpg?alt=media&token=06c9af4c-2dc9-4c0f-a22f-eff214fdf9aa"
	  }],
	  productNameEnglish: "Rice Kali jera  ",
	  productPrice: "5",
	  productSupplier: "BCS SHOP",
	  searchText: "Kalojeera Rice zira কালো জিরা চাউল ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1kg",
	  updateDateTime: "23/07/2020 12:58:15"
	}, {
	  availability: "AVAILABLE",
	  category: "MEAT FISH",
	  isPopular: "YES",
	  key: "-M9Y_GalhAf1EZpTmHm_",
	  photos: [{
	    imageName: "4cd98e20-afbc-11ea-a37e-bd24eb8f726f.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F4cd98e20-afbc-11ea-a37e-bd24eb8f726f.jpg?alt=media&token=5d46c383-874d-448b-9321-1d4cb2e4bd48"
	  }],
	  productNameEnglish: "Rui fish ",
	  productPrice: "6.50",
	  productSupplier: "BCS SHOP",
	  searchText: "রুই মাছ ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1kg",
	  updateDateTime: "Tue 29-09-20 4:41 pm"
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "NO",
	  key: "-M9YZA49hWE54KVe0tCV",
	  photos: [{
	    imageName: "6bdc1a00-bdad-11ea-8ba8-ddb60ef370d4.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F6bdc1a00-bdad-11ea-8ba8-ddb60ef370d4.jpg?alt=media&token=d2412a77-2d03-45c8-9cc1-1610484cc04b"
	  }],
	  productNameEnglish: "Baby Cucumber ",
	  productPrice: "2",
	  productSupplier: "BCS SHOP",
	  searchText: "shosha  ছোট  শশা শসা ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "500gm",
	  updateDateTime: "28/07/2020 06:04:42"
	}, {
	  availability: "AVAILABLE",
	  category: "MEAT FISH",
	  isPopular: "YES",
	  key: "-M9YYpBjUhHmun6KH3hq",
	  photos: [{
	    imageName: "33253800-c81f-11ea-99a6-3f4f89ed7cd9.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F33253800-c81f-11ea-99a6-3f4f89ed7cd9.jpg?alt=media&token=56442d8a-c2c3-4408-81d8-991dff35744f"
	  }],
	  productNameEnglish: "Duck frozen",
	  productPrice: "11",
	  productSupplier: "BCS SHOP",
	  searchText: "হাঁস ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1 packet",
	  updateDateTime: "17/07/2020 07:18:46"
	}, {
	  author: "+6594562455",
	  availability: "AVAILABLE",
	  category: "MEAT FISH",
	  isPopular: "YES",
	  key: "-M9YYZThoI3vTcDmU6d5",
	  photos: [{
	    imageName: "efae5970-abe6-11ea-99a0-ada8a2be9f1b.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fefae5970-abe6-11ea-99a0-ada8a2be9f1b.jpg?alt=media&token=e19b59dd-8ca4-4349-9716-82d1369e98c7"
	  }, {
	    imageName: "68b0df30-d3fd-11ea-a0e0-7d366b7a98ae.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F68b0df30-d3fd-11ea-a0e0-7d366b7a98ae.jpg?alt=media&token=4e1c3011-50be-46f0-ab15-5d380e0cb817"
	  }],
	  productNameEnglish: "Chicken",
	  productPrice: "6",
	  productSupplier: "BCS SHOP",
	  searchText: "মুরগি মুরগী ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1.5kg ",
	  updateDateTime: "01/08/2020 09:48:25"
	}, {
	  author: "+6589050302",
	  availability: "AVAILABLE",
	  category: "MEAT FISH",
	  isPopular: "YES",
	  key: "-M9YYE7XExSI-8nZhIvy",
	  photos: [{
	    imageName: "63d1a8e0-d3fe-11ea-a0e0-7d366b7a98ae.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F63d1a8e0-d3fe-11ea-a0e0-7d366b7a98ae.jpg?alt=media&token=d7fa02b4-e3af-46cf-b6d4-75212ec12a19"
	  }],
	  productNameEnglish: "Mutton  (price vary depending on quality)",
	  productPrice: "11.50",
	  productSupplier: "BCS SHOP",
	  searchText: "খাসির মাংস ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1kg",
	  updateDateTime: "Mon 10-08-20 2:37 pm"
	}, {
	  availability: "AVAILABLE",
	  category: "MEAT FISH",
	  isPopular: "YES",
	  key: "-M9YY1Vs-DmZEPBdZ7Py",
	  photos: [{
	    imageName: "de857390-bf78-11ea-aa1e-9169bb2ab543.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fde857390-bf78-11ea-aa1e-9169bb2ab543.jpg?alt=media&token=4e793d06-81c3-4017-859b-7dc6d76e3ebe"
	  }],
	  productNameEnglish: "Beef ",
	  productPrice: "9.50",
	  productSupplier: "BCS SHOP",
	  searchText: "গরুর মাংস",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1kg",
	  updateDateTime: "23/07/2020 01:00:56"
	}, {
	  availability: "AVAILABLE",
	  category: "MEAT FISH",
	  isPopular: "YES",
	  key: "-M9YXmiqrCkl2UACh3XY",
	  photos: [{
	    imageName: "0db6e000-b2a8-11ea-a456-b52272a954da.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F0db6e000-b2a8-11ea-a456-b52272a954da.jpg?alt=media&token=22522c58-0786-4c5c-8673-9ec22520f0bf"
	  }],
	  productNameEnglish: "Mutton Marrow ",
	  productPrice: "6.50",
	  productSupplier: "BCS SHOP",
	  searchText: "খাসির পায়া ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1kg",
	  updateDateTime: "23/07/2020 01:01:18"
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-M9YXM8PU-56kPNuswb1",
	  photos: [{
	    imageName: "2d402df0-abe6-11ea-99a0-ada8a2be9f1b.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F2d402df0-abe6-11ea-99a0-ada8a2be9f1b.jpg?alt=media&token=cf7ca708-43d5-43a4-8d59-f2d6ccc47bfe"
	  }],
	  productNameEnglish: "Spiny gourd ",
	  productPrice: " 5.5",
	  productSupplier: "BCS SHOP",
	  searchText: "কারকল ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1kg",
	  updateDateTime: "17/07/2020 07:23:30"
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-M9YXC8HFxzWybtMNJwR",
	  photos: [{
	    imageName: "0bad0e60-abe6-11ea-99a0-ada8a2be9f1b.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F0bad0e60-abe6-11ea-99a0-ada8a2be9f1b.jpg?alt=media&token=31a8943b-38a7-4aac-9cc1-b10e7eddbba0"
	  }],
	  productNameEnglish: "yardlong long bean",
	  productPrice: "4.5",
	  productSupplier: "BCS SHOP",
	  searchText: "বরবটি ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1kg",
	  updateDateTime: "17/07/2020 08:33:48"
	}, {
	  availability: "AVAILABLE",
	  category: "TUPPERWARE CONTAINER",
	  isPopular: "YES",
	  key: "-M9YWPKH6wupC6XKrA8-",
	  photos: [{
	    imageName: "97fbbf20-abe5-11ea-99a0-ada8a2be9f1b.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F97fbbf20-abe5-11ea-99a0-ada8a2be9f1b.jpg?alt=media&token=26ed90f0-9141-4123-ba6c-745d89b1bf9b"
	  }],
	  productNameEnglish: "Makan paper ",
	  productPrice: "3.90",
	  productSupplier: "BCS SHOP",
	  searchText: "মাকান পেপার ভাতের প্যাকেট ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1 packet ",
	  updateDateTime: "17/07/2020 08:42:43"
	}, {
	  author: "+6594562455",
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-M9YWCesWwfEYegG51K-",
	  photos: [{
	    imageName: "a5b99b00-c81e-11ea-99a6-3f4f89ed7cd9.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fa5b99b00-c81e-11ea-99a6-3f4f89ed7cd9.jpg?alt=media&token=fe01e8d1-51c3-4c4a-a8d1-18b0009544b7"
	  }],
	  productNameEnglish: "Garlic ",
	  productPrice: "1.40",
	  productSupplier: "BCS SHOP",
	  searchText: "রসুন রসূন রশুন ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "200gms",
	  updateDateTime: "30/07/2020 12:13:08"
	}, {
	  author: "+6594562455",
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-M9YW2R7LfkaxZEJ6Ev5",
	  photos: [{
	    imageName: "115db770-c81e-11ea-99a6-3f4f89ed7cd9.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F115db770-c81e-11ea-99a6-3f4f89ed7cd9.jpg?alt=media&token=4fa3df14-1c00-44e4-bd8e-31b4340d72e4"
	  }],
	  productNameEnglish: "Onion ",
	  productPrice: "2.00",
	  productSupplier: "BCS SHOP",
	  searchText: "onion piaz piaj পেঁয়াজ পেয়াজ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1kg ",
	  updateDateTime: "Fri 07-08-20 8:27 pm"
	}, {
	  availability: "AVAILABLE",
	  category: "MEAT FISH",
	  isPopular: "YES",
	  key: "-M9YVFGS1aZS8hhaFMb-",
	  photos: [{
	    imageName: "e35086a0-abe4-11ea-99a0-ada8a2be9f1b.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fe35086a0-abe4-11ea-99a0-ada8a2be9f1b.jpg?alt=media&token=e2323664-15e7-4ee9-920c-b765fbb86483"
	  }],
	  productNameEnglish: "Fish baby fish",
	  productPrice: "4",
	  productSupplier: "BCS SHOP",
	  searchText: "ছোট মাছ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: " 1 packet",
	  updateDateTime: "Sun 20-12-20 11:28 pm"
	}, {
	  availability: "AVAILABLE",
	  category: "EGGS DAIRY",
	  isPopular: "YES",
	  key: "-M9YV1R47lPAdYHNFpMi",
	  photos: [{
	    imageName: "ceed5840-f898-11ea-aaa8-a9cfb87a7f3a.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2Fceed5840-f898-11ea-aaa8-a9cfb87a7f3a.jpg?alt=media&token=e54b879e-b9c1-451e-9290-c805bc6c07a5"
	  }],
	  productNameEnglish: "Egg ",
	  productPrice: "2.80",
	  productSupplier: "BCS SHOP",
	  searchText: "ডিম ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "10pcs",
	  updateDateTime: "Thu 17-09-20 11:49 am"
	}, {
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-M9YUfCHK8nxBXdjiJRN",
	  photos: [{
	    imageName: "630beac0-abe4-11ea-99a0-ada8a2be9f1b.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F630beac0-abe4-11ea-99a0-ada8a2be9f1b.jpg?alt=media&token=983ece57-623a-4c70-9ba4-de656b02edde"
	  }],
	  productNameEnglish: "Sponge ",
	  productPrice: "1.5",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1kg",
	  updateDateTime: "04/07/2020 09:21:27"
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-M9YSL-0prcztEj2MH5X",
	  photos: [{
	    imageName: "ff7c0d60-abe2-11ea-99a0-ada8a2be9f1b.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fff7c0d60-abe2-11ea-99a0-ada8a2be9f1b.jpg?alt=media&token=a59b7fe6-4135-4487-b3b1-a1ad75bf4d6d"
	  }],
	  productNameEnglish: "Broccoli ",
	  productPrice: "5.5",
	  productSupplier: "BCS SHOP",
	  searchText: "ব্রকোলি ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1kg",
	  updateDateTime: "Wed 02-12-20 10:21 am"
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-M9YGnHxxGqnARPsRDxa",
	  photos: [{
	    imageName: "b8ea5860-f733-11ea-885a-2b4d96b2f26b.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2Fb8ea5860-f733-11ea-885a-2b4d96b2f26b.jpg?alt=media&token=4a9b442e-13e4-426c-8f7d-b075c2d45a3e"
	  }],
	  productNameEnglish: "bitter melon ",
	  productPrice: "5",
	  productSupplier: "BCS SHOP",
	  searchText: "করল্লা ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1kg",
	  updateDateTime: "Fri 18-09-20 6:22 pm"
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-M9YEMBOnzZygQ5XCB9U",
	  photos: [{
	    imageName: "a7a8cfe0-abda-11ea-8036-6322e2b6fd90.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fa7a8cfe0-abda-11ea-8036-6322e2b6fd90.jpg?alt=media&token=ea2fe2d9-04bd-45fd-99b1-9933f95d19de"
	  }],
	  productNameEnglish: "calabash ",
	  productPrice: "2",
	  productSupplier: "BCS SHOP",
	  searchText: "লাউ ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1kg",
	  updateDateTime: "17/07/2020 08:32:47"
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-M9YBFF3IOwSaJ5jdXxt",
	  photos: [{
	    imageName: "86af5890-f897-11ea-aaa8-a9cfb87a7f3a.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F86af5890-f897-11ea-aaa8-a9cfb87a7f3a.jpg?alt=media&token=e3172c68-6f4a-4e1e-b1d5-def8c76d97e3"
	  }],
	  productNameEnglish: " wax gourd ",
	  productPrice: "3.5",
	  productSupplier: "BCS SHOP",
	  searchText: "চালকোমড়া",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1kg",
	  updateDateTime: "Thu 17-09-20 11:40 am"
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-M9YANJFg1D08vwrvhm1",
	  photos: [{
	    imageName: "24b72040-f898-11ea-aaa8-a9cfb87a7f3a.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F24b72040-f898-11ea-aaa8-a9cfb87a7f3a.jpg?alt=media&token=7a26b0b8-9da8-4697-a324-15de9739248f"
	  }],
	  productNameEnglish: "Green Plantains banana ",
	  productPrice: "6.00",
	  productSupplier: "BCS SHOP",
	  searchText: "কাঁচা কলা ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1kg",
	  updateDateTime: "Thu 17-09-20 11:44 am"
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-M9Y9D065-hddXvOvSpc",
	  photos: [{
	    imageName: "168de720-f734-11ea-885a-2b4d96b2f26b.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F168de720-f734-11ea-885a-2b4d96b2f26b.jpg?alt=media&token=2e5d791c-cfe6-4d98-828e-a8d9ec8210a9"
	  }],
	  productNameEnglish: "Radish ",
	  productPrice: "4",
	  productSupplier: "BCS SHOP",
	  searchText: "মুলা ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1kg",
	  updateDateTime: "Tue 15-09-20 5:16 pm"
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-M9Y5jNlVNJ0uW1ec5mh",
	  photos: [{
	    imageName: "379757a0-b204-11ea-aac4-61b5279351b7.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F379757a0-b204-11ea-aac4-61b5279351b7.jpg?alt=media&token=35add90b-6fbe-4299-883c-394530faf678"
	  }],
	  productNameEnglish: "Tomatoes ",
	  productPrice: "3.50",
	  productSupplier: "BCS SHOP",
	  searchText: "টমেটো ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1KG",
	  updateDateTime: "17/07/2020 08:30:35"
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  key: "-M9Y4AEtGCuFmPazEOcn",
	  photos: [{
	    imageName: "428601a0-f734-11ea-885a-2b4d96b2f26b.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F428601a0-f734-11ea-885a-2b4d96b2f26b.jpg?alt=media&token=3437c6f2-a9e1-4f33-b7e9-482a9694df90"
	  }],
	  productNameEnglish: "Eggplant ",
	  productPrice: "5",
	  productSupplier: "BCS SHOP",
	  searchText: "গোল বেগুন ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1KG",
	  updateDateTime: "Tue 15-09-20 5:17 pm"
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-M9Y1WO275HFH9pHbU8S",
	  photos: [{
	    imageName: "9c4fbc90-c105-11ea-8470-83fbeadd4a74.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F9c4fbc90-c105-11ea-8470-83fbeadd4a74.jpg?alt=media&token=652de7ef-294d-4561-b258-c1e2405bdd78"
	  }],
	  productNameEnglish: "Green chilli ",
	  productPrice: "2.00",
	  productSupplier: "BCS SHOP",
	  searchText: "কাঁচা মরিচ ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "200gm",
	  updateDateTime: "Sun 20-12-20 11:30 pm"
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-M9Y1KPJE0XuOLGxP41o",
	  photos: [{
	    imageName: "ea6810e0-c104-11ea-8470-83fbeadd4a74.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fea6810e0-c104-11ea-8470-83fbeadd4a74.jpg?alt=media&token=393c1c30-82f6-40e0-a6d2-e52d0ca425ad"
	  }],
	  productNameEnglish: "Ladyfinger  ",
	  productPrice: "5",
	  productSupplier: "BCS SHOP",
	  searchText: "ঢেঁড়শ ঢেঁড়স ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1kg",
	  updateDateTime: "08/07/2020 06:22:27"
	}, {
	  category: "EGGS DAIRY",
	  isPopular: "YES",
	  key: "-M9Y0vKi7518NwH69ezs",
	  photos: [{
	    imageName: "86d52960-abd2-11ea-8036-6322e2b6fd90.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F86d52960-abd2-11ea-8036-6322e2b6fd90.jpg?alt=media&token=2d3b7e72-63a9-443d-a1b2-2ba5ba38dd63"
	  }],
	  productNameEnglish: "Honey ",
	  productPrice: "11",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1L",
	  updateDateTime: "04/07/2020 09:16:35"
	}, {
	  category: "EGGS DAIRY",
	  isPopular: "YES",
	  key: "-M9Y0ixv1jxpZF_BdfTy",
	  photos: [{
	    imageName: "1cf52090-abd2-11ea-b76c-0b360dd92c32.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F1cf52090-abd2-11ea-b76c-0b360dd92c32.jpg?alt=media&token=3177d850-f72d-4b52-add8-1c73565f5f68"
	  }],
	  productNameEnglish: "Honey  ",
	  productPrice: "6.5",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "500ml",
	  updateDateTime: "04/07/2020 09:14:33"
	}, {
	  availability: "AVAILABLE",
	  category: "KITCHEN DINING",
	  isPopular: "NO",
	  key: "-M9Y0JRabxNgOzFRkwKB",
	  photos: [{
	    imageName: "789397f0-c104-11ea-8470-83fbeadd4a74.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F789397f0-c104-11ea-8470-83fbeadd4a74.jpg?alt=media&token=c6042177-aa13-4df6-9285-dc86d85b4507"
	  }],
	  productNameEnglish: "Rice cooker  big/small (price vary depending on size)",
	  productPrice: "32",
	  productSupplier: "BCS SHOP",
	  searchText: "রাইস কুকার ",
	  sortOrder: "x",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "Small",
	  updateDateTime: "08/07/2020 06:19:47"
	}, {
	  author: "+6589050302",
	  availability: "AVAILABLE",
	  category: "EGGS DAIRY",
	  isPopular: "NO",
	  key: "-M9Y03q7FRuMQjK5r4uT",
	  photos: [{
	    imageName: "2e329130-c103-11ea-8470-83fbeadd4a74.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F2e329130-c103-11ea-8470-83fbeadd4a74.jpg?alt=media&token=4beb50e2-d473-4791-b9ba-e679e035548d"
	  }],
	  productNameEnglish: "Yogurt ",
	  productPrice: "1.10",
	  productSupplier: "BCS SHOP",
	  searchText: "দই দধি ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1pc",
	  updateDateTime: "Wed 16-09-20 8:08 am"
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-M9Y-cMWFKAa3SBkMufK",
	  photos: [{
	    imageName: "cce05570-abd1-11ea-b76c-0b360dd92c32.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fcce05570-abd1-11ea-b76c-0b360dd92c32.jpg?alt=media&token=cde2016d-51b6-4050-bff9-067a501c3d7e"
	  }],
	  productNameEnglish: "Cabbage ",
	  productPrice: "3.5",
	  productSupplier: "BCS SHOP",
	  searchText: "বাধাকপি পাতাকপি ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1kg",
	  updateDateTime: "08/07/2020 06:08:21"
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-M9Y-M8Psr7VBfwBi9uI",
	  photos: [{
	    imageName: "b7c3abb0-abd1-11ea-b76c-0b360dd92c32.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fb7c3abb0-abd1-11ea-b76c-0b360dd92c32.jpg?alt=media&token=3243ad4c-9c84-4933-affc-1397c26316c9"
	  }],
	  productNameEnglish: "Cauliflower ",
	  productPrice: "5",
	  productSupplier: "BCS SHOP",
	  searchText: "ফুলকপি ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1kg ",
	  updateDateTime: "08/07/2020 06:07:38"
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-M9XzYPESx_Db7uv0jTY",
	  photos: [{
	    imageName: "253a8c50-abd1-11ea-b76c-0b360dd92c32.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F253a8c50-abd1-11ea-b76c-0b360dd92c32.jpg?alt=media&token=9e5d3417-818c-4a1e-ad72-bc1a2cd428db"
	  }],
	  productNameEnglish: "Onion bag",
	  productPrice: "6",
	  productSupplier: "BCS SHOP",
	  searchText: "পেঁয়াজ পেয়াজ onion piaz piaj",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1 bag (3 kg)",
	  updateDateTime: "Sun 20-12-20 11:29 pm"
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-M9XzO90h7UOuD09Pl9g",
	  photos: [{
	    imageName: "e2db46b0-abd0-11ea-b76c-0b360dd92c32.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fe2db46b0-abd0-11ea-b76c-0b360dd92c32.jpg?alt=media&token=45d6c7fe-894e-4782-ad44-5339cac68c34"
	  }],
	  productNameEnglish: "Potato ",
	  productPrice: "2",
	  productSupplier: "BCS SHOP",
	  searchText: "আলু ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1kg",
	  updateDateTime: "08/07/2020 06:05:20"
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-M9Xz1UTYCxt-drlSFrg",
	  photos: [{
	    imageName: "94fa4b80-abd0-11ea-b76c-0b360dd92c32.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F94fa4b80-abd0-11ea-b76c-0b360dd92c32.jpg?alt=media&token=2a1daa66-e53c-440b-82a3-47cd3dd2e2cf"
	  }],
	  productNameEnglish: "Potato bag ",
	  productPrice: "5.5",
	  productSupplier: "BCS SHOP",
	  searchText: "আলু ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "4kg",
	  updateDateTime: "08/07/2020 06:05:43"
	}, {
	  availability: "AVAILABLE",
	  category: "KITCHEN DINING",
	  key: "-M9XOy8oD7hBLxHrPrJX",
	  photos: [{
	    imageName: "5a2486a0-c102-11ea-8470-83fbeadd4a74.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F5a2486a0-c102-11ea-8470-83fbeadd4a74.jpg?alt=media&token=76f61b35-0100-44eb-9d57-c4bac42986dd"
	  }],
	  productNameEnglish: "Cutting board",
	  productPrice: "  5",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1 pc",
	  updateDateTime: "08/07/2020 06:04:18"
	}, {
	  availability: "AVAILABLE",
	  category: "OTHERS",
	  key: "-M9WI5Z7ReOVVwpd4iHp",
	  photos: [{
	    imageName: "e1741270-c101-11ea-8470-83fbeadd4a74.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fe1741270-c101-11ea-8470-83fbeadd4a74.jpg?alt=media&token=8729e58c-8c84-4392-b9d3-5c7c7cb97ce3"
	  }],
	  productNameEnglish: "Masks ",
	  productPrice: "20",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "50pcs box",
	  updateDateTime: "08/07/2020 06:01:11"
	}, {
	  author: "+6589050302",
	  availability: "AVAILABLE",
	  category: "RICE DAAL NOODLES",
	  isPopular: "YES",
	  key: "-M98XebbkWBaYir3DchI",
	  photos: [{
	    imageName: "c72d6f00-a7ee-11ea-9efa-45bf0dbedfb0.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fc72d6f00-a7ee-11ea-9efa-45bf0dbedfb0.jpg?alt=media&token=fe2bf965-c7d3-44e6-bf61-c6080eedf639"
	  }],
	  productDescription: "Best rice ",
	  productNameEnglish: "Rice ponni ",
	  productPrice: "$8",
	  productSupplier: "TANMOY",
	  searchText: "চাউল ",
	  sortOrder: "a",
	  supplierContactName: "Moni",
	  supplierContactPhone: "96220740",
	  unit: "5kg",
	  updateDateTime: "Sun 30-08-20 8:46 am"
	}, {
	  author: "+6597861234",
	  productDescription: "Coming soo",
	  productNameEnglish: "50+ Live TV Channels",
	  productSupplier: "Live TV (Coming Soon)",
	  supplierContactName: "Ahmed",
	  supplierContactPhone: "97861234",
	  updateDateTime: "06/06/2020 09:52:50",
	  key: "-M95tgO_ksM18SdAvT_c"
	}, {
	  author: "+6584124637",
	  isPopular: "YES",
	  key: "-M94SdSeP41Szh-wrWfT",
	  photos: [{
	    imageName: "6412cc70-a74f-11ea-a14e-4374971e8751.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F6412cc70-a74f-11ea-a14e-4374971e8751.jpg?alt=media&token=a0cc3232-a09a-4453-bf63-1dcaeea80e83"
	  }, {
	    imageName: "7af12360-a74f-11ea-a14e-4374971e8751.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F7af12360-a74f-11ea-a14e-4374971e8751.jpg?alt=media&token=f25c18cd-576f-4418-b0b8-b1fa02598ee9"
	  }],
	  productDescription: "Free prayer mats for migrant brothers who does not have prayer mat. ",
	  productNameEnglish: "Prayer mats ",
	  productPrice: "Free ",
	  productSupplier: "FREE PRAYER MAT",
	  supplierContactName: "Kabir",
	  supplierContactPhone: "94562455",
	  updateDateTime: "17/06/2020 10:35:38"
	}];

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setUiFlag = exports.pullRefreshOff = exports.pullRefreshOn = exports.editModeOff = exports.editModeOn = exports.uiHideBar = exports.uiShowBar = exports.uiStopLoading = exports.uiStartLoading = undefined;
	
	var _actionTypes = __webpack_require__(80);
	
	var uiStartLoading = exports.uiStartLoading = function uiStartLoading() {
	  //console.log("Switching on spinner");
	  return {
	    type: _actionTypes.UI_START_LOADING
	  };
	};
	
	var uiStopLoading = exports.uiStopLoading = function uiStopLoading() {
	  //console.log("switching OFF spinner");
	  return {
	    type: _actionTypes.UI_STOP_LOADING
	  };
	};
	
	var uiShowBar = exports.uiShowBar = function uiShowBar() {
	  //logger("BASIC","ACTION uiShowBar", "Show icons bar");
	  return {
	    type: _actionTypes.SHOW_BAR
	  };
	};
	
	var uiHideBar = exports.uiHideBar = function uiHideBar() {
	  //logger("BASIC","uiHideBar", "Hide icons bar");
	  return {
	    type: _actionTypes.HIDE_BAR
	  };
	};
	
	var editModeOn = exports.editModeOn = function editModeOn() {
	  //logger("BASIC","editModeOn", "Enabling edit");
	  return {
	    type: _actionTypes.EDIT_MODE_ON
	  };
	};
	
	var editModeOff = exports.editModeOff = function editModeOff() {
	  //logger("BASIC","editModeOff", "Switching off edit mode");
	  return {
	    type: _actionTypes.EDIT_MODE_OFF
	  };
	};
	
	var pullRefreshOn = exports.pullRefreshOn = function pullRefreshOn() {
	  //logger("DEBUG","pullRefreshOn", "On pull refresh flag");
	  return {
	    type: _actionTypes.LIST_PULL_REFRESHING_ON
	  };
	};
	
	var pullRefreshOff = exports.pullRefreshOff = function pullRefreshOff() {
	  //logger("DEBUG","pullRefreshOff","Off pull refresh flag");
	  return {
	    type: _actionTypes.LIST_PULL_REFRESHING_OFF
	  };
	};
	
	var setUiFlag = exports.setUiFlag = function setUiFlag(flagName, status) {
	  return {
	    type: _actionTypes.SET_UI_FLAG,
	    flagName: flagName,
	    status: status
	  };
	};

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.bodyLineHeight = exports.bodyFontWeight = exports.bodyFontFamily = exports.bodyFontColorAlt = exports.bodyFontColor = exports.bodyBackgroundColor = exports.zIndexMoon = exports.zIndexTooltip = exports.zIndexAlertDesktop = exports.zIndexPopup = exports.zIndexModal = exports.zIndexOverlay = exports.zIndexDropdown = exports.zIndexAlertMobile = exports.zIndexNav = exports.zIndexBase = exports.directionFloat = exports.directionText = exports.fontColorMedium = exports.fontColorLight = exports.fontSizeDisplay4 = exports.fontSizeDisplay3 = exports.fontSizeDisplay2 = exports.fontSizeDisplay1 = exports.fontSizeHeadline = exports.fontSizeTitle = exports.fontSizeBody2 = exports.fontSizeBody = exports.fontSizeSmall = exports.fontSizeXsmall = exports.fontWeightBold = exports.fontWeightSemibold = exports.fontWeightNormal = exports.fontWeightLight = exports.fontFamilyMonospace = exports.fontFamilySerif = exports.fontFamilySansSerif = exports.colorBrandGooglePlus = exports.colorBrandVkontakte = exports.colorBrandFacebook = exports.colorAnchor = exports.colorBorder = exports.paletteBlueGrey900 = exports.paletteBlueGrey800 = exports.paletteBlueGrey700 = exports.paletteBlueGrey600 = exports.paletteBlueGrey500 = exports.paletteBlueGrey400 = exports.paletteBlueGrey300 = exports.paletteBlueGrey200 = exports.paletteBlueGrey100 = exports.paletteBlueGrey75 = exports.paletteBlueGrey50 = exports.paletteBlueGrey25 = exports.colorPaletteGrey900 = exports.colorPaletteGrey800 = exports.colorPaletteGrey700 = exports.colorPaletteGrey600 = exports.colorPaletteGrey500 = exports.colorPaletteGrey400 = exports.colorPaletteGrey300 = exports.colorPaletteGrey200 = exports.colorPaletteGrey100 = exports.colorPaletteGrey75 = exports.colorPaletteGrey50 = exports.colorInfoForeground = exports.colorInfo = exports.colorSuccessForeground = exports.colorSuccess = exports.colorErrorForeground = exports.colorError = exports.colorWarningForeground = exports.colorWarning = exports.colorAlertForeground = exports.colorAlert = exports.colorSecondaryForeground = exports.colorSecondary = exports.colorMainForeground = exports.colorMain = exports.colorTransparent = exports.colorBlack = exports.colorWhite = exports.radiusRounded = exports.radiusDefault = exports.totalColumns = exports.contentWidth = exports.baseModule = undefined;
	
	var _reactackle = __webpack_require__(5);
	
	var multiplierFunctions = Object.create(null);
	
	var baseModule = exports.baseModule = function baseModule(multiplier) {
	  if (!multiplierFunctions[multiplier]) {
	    multiplierFunctions[multiplier] = function (_ref) {
	      var theme = _ref.theme;
	      return (0, _reactackle.extractThemeOrDefault)(theme).reactackle.baseModule * multiplier;
	    };
	  }
	
	  return multiplierFunctions[multiplier];
	};
	
	/** Size parameters */
	var contentWidth = exports.contentWidth = function contentWidth(_ref2) {
	  var theme = _ref2.theme;
	  return (0, _reactackle.extractThemeOrDefault)(theme).reactackle.contentWidth;
	};
	var totalColumns = exports.totalColumns = function totalColumns(_ref3) {
	  var theme = _ref3.theme;
	  return (0, _reactackle.extractThemeOrDefault)(theme).reactackle.totalColumns;
	};
	
	var radiusDefault = exports.radiusDefault = function radiusDefault(_ref4) {
	  var theme = _ref4.theme;
	  return (0, _reactackle.extractThemeOrDefault)(theme).reactackle.radiusDefault;
	};
	var radiusRounded = exports.radiusRounded = function radiusRounded(_ref5) {
	  var theme = _ref5.theme;
	  return (0, _reactackle.extractThemeOrDefault)(theme).reactackle.radiusRounded;
	};
	
	/** Colors */
	var colorWhite = exports.colorWhite = function colorWhite(_ref6) {
	  var theme = _ref6.theme;
	  return (0, _reactackle.extractThemeOrDefault)(theme).reactackle.color.white;
	};
	var colorBlack = exports.colorBlack = function colorBlack(_ref7) {
	  var theme = _ref7.theme;
	  return (0, _reactackle.extractThemeOrDefault)(theme).reactackle.color.black;
	};
	var colorTransparent = exports.colorTransparent = function colorTransparent(_ref8) {
	  var theme = _ref8.theme;
	  return (0, _reactackle.extractThemeOrDefault)(theme).reactackle.color.transparent;
	};
	
	var colorMain = exports.colorMain = function colorMain(_ref9) {
	  var theme = _ref9.theme;
	  return (0, _reactackle.extractThemeOrDefault)(theme).reactackle.color.main;
	};
	var colorMainForeground = exports.colorMainForeground = function colorMainForeground(_ref10) {
	  var theme = _ref10.theme;
	  return (0, _reactackle.extractThemeOrDefault)(theme).reactackle.color.mainFgTextColor;
	};
	var colorSecondary = exports.colorSecondary = function colorSecondary(_ref11) {
	  var theme = _ref11.theme;
	  return (0, _reactackle.extractThemeOrDefault)(theme).reactackle.color.secondary;
	};
	var colorSecondaryForeground = exports.colorSecondaryForeground = function colorSecondaryForeground(_ref12) {
	  var theme = _ref12.theme;
	  return (0, _reactackle.extractThemeOrDefault)(theme).reactackle.color.secondaryFgTextColor;
	};
	var colorAlert = exports.colorAlert = function colorAlert(_ref13) {
	  var theme = _ref13.theme;
	  return (0, _reactackle.extractThemeOrDefault)(theme).reactackle.color.alert;
	};
	var colorAlertForeground = exports.colorAlertForeground = function colorAlertForeground(_ref14) {
	  var theme = _ref14.theme;
	  return (0, _reactackle.extractThemeOrDefault)(theme).reactackle.color.alertFgTextColor;
	};
	var colorWarning = exports.colorWarning = function colorWarning(_ref15) {
	  var theme = _ref15.theme;
	  return (0, _reactackle.extractThemeOrDefault)(theme).reactackle.color.warning;
	};
	var colorWarningForeground = exports.colorWarningForeground = function colorWarningForeground(_ref16) {
	  var theme = _ref16.theme;
	  return (0, _reactackle.extractThemeOrDefault)(theme).reactackle.color.warningFgTextColor;
	};
	var colorError = exports.colorError = function colorError(_ref17) {
	  var theme = _ref17.theme;
	  return (0, _reactackle.extractThemeOrDefault)(theme).reactackle.color.alert;
	};
	var colorErrorForeground = exports.colorErrorForeground = function colorErrorForeground(_ref18) {
	  var theme = _ref18.theme;
	  return (0, _reactackle.extractThemeOrDefault)(theme).reactackle.color.alertFgTextColor;
	};
	var colorSuccess = exports.colorSuccess = function colorSuccess(_ref19) {
	  var theme = _ref19.theme;
	  return (0, _reactackle.extractThemeOrDefault)(theme).reactackle.color.success;
	};
	var colorSuccessForeground = exports.colorSuccessForeground = function colorSuccessForeground(_ref20) {
	  var theme = _ref20.theme;
	  return (0, _reactackle.extractThemeOrDefault)(theme).reactackle.color.successFgTextColor;
	};
	var colorInfo = exports.colorInfo = function colorInfo(_ref21) {
	  var theme = _ref21.theme;
	  return (0, _reactackle.extractThemeOrDefault)(theme).reactackle.color.info;
	};
	var colorInfoForeground = exports.colorInfoForeground = function colorInfoForeground(_ref22) {
	  var theme = _ref22.theme;
	  return (0, _reactackle.extractThemeOrDefault)(theme).reactackle.color.infoFgTextColor;
	};
	
	var colorPaletteGrey50 = exports.colorPaletteGrey50 = function colorPaletteGrey50(_ref23) {
	  var theme = _ref23.theme;
	  return (0, _reactackle.extractThemeOrDefault)(theme).reactackle.colorPaletteGrey[50];
	};
	var colorPaletteGrey75 = exports.colorPaletteGrey75 = function colorPaletteGrey75(_ref24) {
	  var theme = _ref24.theme;
	  return (0, _reactackle.extractThemeOrDefault)(theme).reactackle.colorPaletteGrey[75];
	};
	var colorPaletteGrey100 = exports.colorPaletteGrey100 = function colorPaletteGrey100(_ref25) {
	  var theme = _ref25.theme;
	  return (0, _reactackle.extractThemeOrDefault)(theme).reactackle.colorPaletteGrey[100];
	};
	var colorPaletteGrey200 = exports.colorPaletteGrey200 = function colorPaletteGrey200(_ref26) {
	  var theme = _ref26.theme;
	  return (0, _reactackle.extractThemeOrDefault)(theme).reactackle.colorPaletteGrey[200];
	};
	var colorPaletteGrey300 = exports.colorPaletteGrey300 = function colorPaletteGrey300(_ref27) {
	  var theme = _ref27.theme;
	  return (0, _reactackle.extractThemeOrDefault)(theme).reactackle.colorPaletteGrey[300];
	};
	var colorPaletteGrey400 = exports.colorPaletteGrey400 = function colorPaletteGrey400(_ref28) {
	  var theme = _ref28.theme;
	  return (0, _reactackle.extractThemeOrDefault)(theme).reactackle.colorPaletteGrey[400];
	};
	var colorPaletteGrey500 = exports.colorPaletteGrey500 = function colorPaletteGrey500(_ref29) {
	  var theme = _ref29.theme;
	  return (0, _reactackle.extractThemeOrDefault)(theme).reactackle.colorPaletteGrey[500];
	};
	var colorPaletteGrey600 = exports.colorPaletteGrey600 = function colorPaletteGrey600(_ref30) {
	  var theme = _ref30.theme;
	  return (0, _reactackle.extractThemeOrDefault)(theme).reactackle.colorPaletteGrey[600];
	};
	var colorPaletteGrey700 = exports.colorPaletteGrey700 = function colorPaletteGrey700(_ref31) {
	  var theme = _ref31.theme;
	  return (0, _reactackle.extractThemeOrDefault)(theme).reactackle.colorPaletteGrey[700];
	};
	var colorPaletteGrey800 = exports.colorPaletteGrey800 = function colorPaletteGrey800(_ref32) {
	  var theme = _ref32.theme;
	  return (0, _reactackle.extractThemeOrDefault)(theme).reactackle.colorPaletteGrey[800];
	};
	var colorPaletteGrey900 = exports.colorPaletteGrey900 = function colorPaletteGrey900(_ref33) {
	  var theme = _ref33.theme;
	  return (0, _reactackle.extractThemeOrDefault)(theme).reactackle.colorPaletteGrey[900];
	};
	
	var paletteBlueGrey25 = exports.paletteBlueGrey25 = function paletteBlueGrey25(_ref34) {
	  var theme = _ref34.theme;
	  return theme.reactackleDemo.paletteBlueGrey[25];
	};
	var paletteBlueGrey50 = exports.paletteBlueGrey50 = function paletteBlueGrey50(_ref35) {
	  var theme = _ref35.theme;
	  return theme.reactackleDemo.paletteBlueGrey[50];
	};
	var paletteBlueGrey75 = exports.paletteBlueGrey75 = function paletteBlueGrey75(_ref36) {
	  var theme = _ref36.theme;
	  return theme.reactackleDemo.paletteBlueGrey[75];
	};
	var paletteBlueGrey100 = exports.paletteBlueGrey100 = function paletteBlueGrey100(_ref37) {
	  var theme = _ref37.theme;
	  return theme.reactackleDemo.paletteBlueGrey[100];
	};
	var paletteBlueGrey200 = exports.paletteBlueGrey200 = function paletteBlueGrey200(_ref38) {
	  var theme = _ref38.theme;
	  return theme.reactackleDemo.paletteBlueGrey[200];
	};
	var paletteBlueGrey300 = exports.paletteBlueGrey300 = function paletteBlueGrey300(_ref39) {
	  var theme = _ref39.theme;
	  return theme.reactackleDemo.paletteBlueGrey[300];
	};
	var paletteBlueGrey400 = exports.paletteBlueGrey400 = function paletteBlueGrey400(_ref40) {
	  var theme = _ref40.theme;
	  return theme.reactackleDemo.paletteBlueGrey[400];
	};
	var paletteBlueGrey500 = exports.paletteBlueGrey500 = function paletteBlueGrey500(_ref41) {
	  var theme = _ref41.theme;
	  return theme.reactackleDemo.paletteBlueGrey[500];
	};
	var paletteBlueGrey600 = exports.paletteBlueGrey600 = function paletteBlueGrey600(_ref42) {
	  var theme = _ref42.theme;
	  return theme.reactackleDemo.paletteBlueGrey[600];
	};
	var paletteBlueGrey700 = exports.paletteBlueGrey700 = function paletteBlueGrey700(_ref43) {
	  var theme = _ref43.theme;
	  return theme.reactackleDemo.paletteBlueGrey[700];
	};
	var paletteBlueGrey800 = exports.paletteBlueGrey800 = function paletteBlueGrey800(_ref44) {
	  var theme = _ref44.theme;
	  return theme.reactackleDemo.paletteBlueGrey[800];
	};
	var paletteBlueGrey900 = exports.paletteBlueGrey900 = function paletteBlueGrey900(_ref45) {
	  var theme = _ref45.theme;
	  return theme.reactackleDemo.paletteBlueGrey[900];
	};
	
	var colorBorder = exports.colorBorder = function colorBorder(_ref46) {
	  var theme = _ref46.theme;
	  return (0, _reactackle.extractThemeOrDefault)(theme).reactackle.colorBorder;
	};
	var colorAnchor = exports.colorAnchor = function colorAnchor(_ref47) {
	  var theme = _ref47.theme;
	  return (0, _reactackle.extractThemeOrDefault)(theme).reactackle.colorAnchor;
	};
	
	var colorBrandFacebook = exports.colorBrandFacebook = function colorBrandFacebook(_ref48) {
	  var theme = _ref48.theme;
	  return (0, _reactackle.extractThemeOrDefault)(theme).reactackle.colorBrand.facebook;
	};
	var colorBrandVkontakte = exports.colorBrandVkontakte = function colorBrandVkontakte(_ref49) {
	  var theme = _ref49.theme;
	  return (0, _reactackle.extractThemeOrDefault)(theme).reactackle.colorBrand.vkontakte;
	};
	var colorBrandGooglePlus = exports.colorBrandGooglePlus = function colorBrandGooglePlus(_ref50) {
	  var theme = _ref50.theme;
	  return (0, _reactackle.extractThemeOrDefault)(theme).reactackle.colorBrand.googlePlus;
	};
	
	/** Font */
	var fontFamilySansSerif = exports.fontFamilySansSerif = function fontFamilySansSerif(_ref51) {
	  var theme = _ref51.theme;
	  return (0, _reactackle.extractThemeOrDefault)(theme).reactackle.fontFamily.sansSerif;
	};
	var fontFamilySerif = exports.fontFamilySerif = function fontFamilySerif(_ref52) {
	  var theme = _ref52.theme;
	  return (0, _reactackle.extractThemeOrDefault)(theme).reactackle.fontFamily.serif;
	};
	var fontFamilyMonospace = exports.fontFamilyMonospace = function fontFamilyMonospace(_ref53) {
	  var theme = _ref53.theme;
	  return (0, _reactackle.extractThemeOrDefault)(theme).reactackle.fontFamily.monospace;
	};
	
	var fontWeightLight = exports.fontWeightLight = function fontWeightLight(_ref54) {
	  var theme = _ref54.theme;
	  return (0, _reactackle.extractThemeOrDefault)(theme).reactackle.fontWeight.light;
	};
	var fontWeightNormal = exports.fontWeightNormal = function fontWeightNormal(_ref55) {
	  var theme = _ref55.theme;
	  return (0, _reactackle.extractThemeOrDefault)(theme).reactackle.fontWeight.normal;
	};
	var fontWeightSemibold = exports.fontWeightSemibold = function fontWeightSemibold(_ref56) {
	  var theme = _ref56.theme;
	  return (0, _reactackle.extractThemeOrDefault)(theme).reactackle.fontWeight.semibold;
	};
	var fontWeightBold = exports.fontWeightBold = function fontWeightBold(_ref57) {
	  var theme = _ref57.theme;
	  return (0, _reactackle.extractThemeOrDefault)(theme).reactackle.fontWeight.bold;
	};
	
	var fontSizeXsmall = exports.fontSizeXsmall = function fontSizeXsmall(_ref58) {
	  var theme = _ref58.theme;
	  return (0, _reactackle.extractThemeOrDefault)(theme).reactackle.fontSize[-2];
	};
	var fontSizeSmall = exports.fontSizeSmall = function fontSizeSmall(_ref59) {
	  var theme = _ref59.theme;
	  return (0, _reactackle.extractThemeOrDefault)(theme).reactackle.fontSize[-1];
	};
	var fontSizeBody = exports.fontSizeBody = function fontSizeBody(_ref60) {
	  var theme = _ref60.theme;
	  return (0, _reactackle.extractThemeOrDefault)(theme).reactackle.fontSize[0];
	};
	var fontSizeBody2 = exports.fontSizeBody2 = function fontSizeBody2(_ref61) {
	  var theme = _ref61.theme;
	  return (0, _reactackle.extractThemeOrDefault)(theme).reactackle.fontSize[1];
	};
	var fontSizeTitle = exports.fontSizeTitle = function fontSizeTitle(_ref62) {
	  var theme = _ref62.theme;
	  return (0, _reactackle.extractThemeOrDefault)(theme).reactackle.fontSize[2];
	};
	var fontSizeHeadline = exports.fontSizeHeadline = function fontSizeHeadline(_ref63) {
	  var theme = _ref63.theme;
	  return (0, _reactackle.extractThemeOrDefault)(theme).reactackle.fontSize[3];
	};
	var fontSizeDisplay1 = exports.fontSizeDisplay1 = function fontSizeDisplay1(_ref64) {
	  var theme = _ref64.theme;
	  return (0, _reactackle.extractThemeOrDefault)(theme).reactackle.fontSize[4];
	};
	var fontSizeDisplay2 = exports.fontSizeDisplay2 = function fontSizeDisplay2(_ref65) {
	  var theme = _ref65.theme;
	  return (0, _reactackle.extractThemeOrDefault)(theme).reactackle.fontSize[5];
	};
	var fontSizeDisplay3 = exports.fontSizeDisplay3 = function fontSizeDisplay3(_ref66) {
	  var theme = _ref66.theme;
	  return (0, _reactackle.extractThemeOrDefault)(theme).reactackle.fontSize[6];
	};
	var fontSizeDisplay4 = exports.fontSizeDisplay4 = function fontSizeDisplay4(_ref67) {
	  var theme = _ref67.theme;
	  return (0, _reactackle.extractThemeOrDefault)(theme).reactackle.fontSize[7];
	};
	
	var fontColorLight = exports.fontColorLight = function fontColorLight(_ref68) {
	  var theme = _ref68.theme;
	  return (0, _reactackle.extractThemeOrDefault)(theme).reactackle.fontColor.light;
	};
	var fontColorMedium = exports.fontColorMedium = function fontColorMedium(_ref69) {
	  var theme = _ref69.theme;
	  return (0, _reactackle.extractThemeOrDefault)(theme).reactackle.fontColor.medium;
	};
	
	/** Other */
	var directionText = exports.directionText = function directionText(_ref70) {
	  var theme = _ref70.theme;
	  return (0, _reactackle.extractThemeOrDefault)(theme).reactackle.direction.text;
	};
	var directionFloat = exports.directionFloat = function directionFloat(_ref71) {
	  var theme = _ref71.theme;
	  return (0, _reactackle.extractThemeOrDefault)(theme).reactackle.direction.float;
	};
	
	var zIndexBase = exports.zIndexBase = function zIndexBase(_ref72) {
	  var theme = _ref72.theme;
	  return (0, _reactackle.extractThemeOrDefault)(theme).reactackle.zIndex.base;
	};
	var zIndexNav = exports.zIndexNav = function zIndexNav(_ref73) {
	  var theme = _ref73.theme;
	  return (0, _reactackle.extractThemeOrDefault)(theme).reactackle.zIndex.nav;
	};
	var zIndexAlertMobile = exports.zIndexAlertMobile = function zIndexAlertMobile(_ref74) {
	  var theme = _ref74.theme;
	  return (0, _reactackle.extractThemeOrDefault)(theme).reactackle.zIndex.alertMobile;
	};
	var zIndexDropdown = exports.zIndexDropdown = function zIndexDropdown(_ref75) {
	  var theme = _ref75.theme;
	  return (0, _reactackle.extractThemeOrDefault)(theme).reactackle.zIndex.dropdown;
	};
	var zIndexOverlay = exports.zIndexOverlay = function zIndexOverlay(_ref76) {
	  var theme = _ref76.theme;
	  return (0, _reactackle.extractThemeOrDefault)(theme).reactackle.zIndex.overlay;
	};
	var zIndexModal = exports.zIndexModal = function zIndexModal(_ref77) {
	  var theme = _ref77.theme;
	  return (0, _reactackle.extractThemeOrDefault)(theme).reactackle.zIndex.modal;
	};
	var zIndexPopup = exports.zIndexPopup = function zIndexPopup(_ref78) {
	  var theme = _ref78.theme;
	  return (0, _reactackle.extractThemeOrDefault)(theme).reactackle.zIndex.popup;
	};
	var zIndexAlertDesktop = exports.zIndexAlertDesktop = function zIndexAlertDesktop(_ref79) {
	  var theme = _ref79.theme;
	  return (0, _reactackle.extractThemeOrDefault)(theme).reactackle.zIndex.alertDesktop;
	};
	var zIndexTooltip = exports.zIndexTooltip = function zIndexTooltip(_ref80) {
	  var theme = _ref80.theme;
	  return (0, _reactackle.extractThemeOrDefault)(theme).reactackle.zIndex.tooltip;
	};
	var zIndexMoon = exports.zIndexMoon = function zIndexMoon(_ref81) {
	  var theme = _ref81.theme;
	  return (0, _reactackle.extractThemeOrDefault)(theme).reactackle.zIndex.moon;
	};
	
	/** Body Settings */
	var bodyBackgroundColor = exports.bodyBackgroundColor = function bodyBackgroundColor(_ref82) {
	  var theme = _ref82.theme;
	  return (0, _reactackle.extractThemeOrDefault)(theme).reactackle.body.bgColor;
	};
	var bodyFontColor = exports.bodyFontColor = function bodyFontColor(_ref83) {
	  var theme = _ref83.theme;
	  return (0, _reactackle.extractThemeOrDefault)(theme).reactackle.body.fontColor;
	};
	var bodyFontColorAlt = exports.bodyFontColorAlt = function bodyFontColorAlt(_ref84) {
	  var theme = _ref84.theme;
	  return (0, _reactackle.extractThemeOrDefault)(theme).reactackle.body.fontColorAlt;
	};
	var bodyFontFamily = exports.bodyFontFamily = function bodyFontFamily(_ref85) {
	  var theme = _ref85.theme;
	  return (0, _reactackle.extractThemeOrDefault)(theme).reactackle.body.fontFamily;
	};
	var bodyFontWeight = exports.bodyFontWeight = function bodyFontWeight(_ref86) {
	  var theme = _ref86.theme;
	  return (0, _reactackle.extractThemeOrDefault)(theme).reactackle.body.fontWeight;
	};
	var bodyLineHeight = exports.bodyLineHeight = function bodyLineHeight(_ref87) {
	  var theme = _ref87.theme;
	  return (0, _reactackle.extractThemeOrDefault)(theme).reactackle.body.lineHeight;
	};

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	/* MIT license */
	var cssKeywords = __webpack_require__(27);
	
	// NOTE: conversions should only return primitive values (i.e. arrays, or
	//       values that give correct `typeof` results).
	//       do not use box values types (i.e. Number(), String(), etc.)
	
	var reverseKeywords = {};
	for (var key in cssKeywords) {
		if (cssKeywords.hasOwnProperty(key)) {
			reverseKeywords[cssKeywords[key]] = key;
		}
	}
	
	var convert = module.exports = {
		rgb: {channels: 3, labels: 'rgb'},
		hsl: {channels: 3, labels: 'hsl'},
		hsv: {channels: 3, labels: 'hsv'},
		hwb: {channels: 3, labels: 'hwb'},
		cmyk: {channels: 4, labels: 'cmyk'},
		xyz: {channels: 3, labels: 'xyz'},
		lab: {channels: 3, labels: 'lab'},
		lch: {channels: 3, labels: 'lch'},
		hex: {channels: 1, labels: ['hex']},
		keyword: {channels: 1, labels: ['keyword']},
		ansi16: {channels: 1, labels: ['ansi16']},
		ansi256: {channels: 1, labels: ['ansi256']},
		hcg: {channels: 3, labels: ['h', 'c', 'g']},
		apple: {channels: 3, labels: ['r16', 'g16', 'b16']},
		gray: {channels: 1, labels: ['gray']}
	};
	
	// hide .channels and .labels properties
	for (var model in convert) {
		if (convert.hasOwnProperty(model)) {
			if (!('channels' in convert[model])) {
				throw new Error('missing channels property: ' + model);
			}
	
			if (!('labels' in convert[model])) {
				throw new Error('missing channel labels property: ' + model);
			}
	
			if (convert[model].labels.length !== convert[model].channels) {
				throw new Error('channel and label counts mismatch: ' + model);
			}
	
			var channels = convert[model].channels;
			var labels = convert[model].labels;
			delete convert[model].channels;
			delete convert[model].labels;
			Object.defineProperty(convert[model], 'channels', {value: channels});
			Object.defineProperty(convert[model], 'labels', {value: labels});
		}
	}
	
	convert.rgb.hsl = function (rgb) {
		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;
		var min = Math.min(r, g, b);
		var max = Math.max(r, g, b);
		var delta = max - min;
		var h;
		var s;
		var l;
	
		if (max === min) {
			h = 0;
		} else if (r === max) {
			h = (g - b) / delta;
		} else if (g === max) {
			h = 2 + (b - r) / delta;
		} else if (b === max) {
			h = 4 + (r - g) / delta;
		}
	
		h = Math.min(h * 60, 360);
	
		if (h < 0) {
			h += 360;
		}
	
		l = (min + max) / 2;
	
		if (max === min) {
			s = 0;
		} else if (l <= 0.5) {
			s = delta / (max + min);
		} else {
			s = delta / (2 - max - min);
		}
	
		return [h, s * 100, l * 100];
	};
	
	convert.rgb.hsv = function (rgb) {
		var rdif;
		var gdif;
		var bdif;
		var h;
		var s;
	
		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;
		var v = Math.max(r, g, b);
		var diff = v - Math.min(r, g, b);
		var diffc = function (c) {
			return (v - c) / 6 / diff + 1 / 2;
		};
	
		if (diff === 0) {
			h = s = 0;
		} else {
			s = diff / v;
			rdif = diffc(r);
			gdif = diffc(g);
			bdif = diffc(b);
	
			if (r === v) {
				h = bdif - gdif;
			} else if (g === v) {
				h = (1 / 3) + rdif - bdif;
			} else if (b === v) {
				h = (2 / 3) + gdif - rdif;
			}
			if (h < 0) {
				h += 1;
			} else if (h > 1) {
				h -= 1;
			}
		}
	
		return [
			h * 360,
			s * 100,
			v * 100
		];
	};
	
	convert.rgb.hwb = function (rgb) {
		var r = rgb[0];
		var g = rgb[1];
		var b = rgb[2];
		var h = convert.rgb.hsl(rgb)[0];
		var w = 1 / 255 * Math.min(r, Math.min(g, b));
	
		b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));
	
		return [h, w * 100, b * 100];
	};
	
	convert.rgb.cmyk = function (rgb) {
		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;
		var c;
		var m;
		var y;
		var k;
	
		k = Math.min(1 - r, 1 - g, 1 - b);
		c = (1 - r - k) / (1 - k) || 0;
		m = (1 - g - k) / (1 - k) || 0;
		y = (1 - b - k) / (1 - k) || 0;
	
		return [c * 100, m * 100, y * 100, k * 100];
	};
	
	/**
	 * See https://en.m.wikipedia.org/wiki/Euclidean_distance#Squared_Euclidean_distance
	 * */
	function comparativeDistance(x, y) {
		return (
			Math.pow(x[0] - y[0], 2) +
			Math.pow(x[1] - y[1], 2) +
			Math.pow(x[2] - y[2], 2)
		);
	}
	
	convert.rgb.keyword = function (rgb) {
		var reversed = reverseKeywords[rgb];
		if (reversed) {
			return reversed;
		}
	
		var currentClosestDistance = Infinity;
		var currentClosestKeyword;
	
		for (var keyword in cssKeywords) {
			if (cssKeywords.hasOwnProperty(keyword)) {
				var value = cssKeywords[keyword];
	
				// Compute comparative distance
				var distance = comparativeDistance(rgb, value);
	
				// Check if its less, if so set as closest
				if (distance < currentClosestDistance) {
					currentClosestDistance = distance;
					currentClosestKeyword = keyword;
				}
			}
		}
	
		return currentClosestKeyword;
	};
	
	convert.keyword.rgb = function (keyword) {
		return cssKeywords[keyword];
	};
	
	convert.rgb.xyz = function (rgb) {
		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;
	
		// assume sRGB
		r = r > 0.04045 ? Math.pow(((r + 0.055) / 1.055), 2.4) : (r / 12.92);
		g = g > 0.04045 ? Math.pow(((g + 0.055) / 1.055), 2.4) : (g / 12.92);
		b = b > 0.04045 ? Math.pow(((b + 0.055) / 1.055), 2.4) : (b / 12.92);
	
		var x = (r * 0.4124) + (g * 0.3576) + (b * 0.1805);
		var y = (r * 0.2126) + (g * 0.7152) + (b * 0.0722);
		var z = (r * 0.0193) + (g * 0.1192) + (b * 0.9505);
	
		return [x * 100, y * 100, z * 100];
	};
	
	convert.rgb.lab = function (rgb) {
		var xyz = convert.rgb.xyz(rgb);
		var x = xyz[0];
		var y = xyz[1];
		var z = xyz[2];
		var l;
		var a;
		var b;
	
		x /= 95.047;
		y /= 100;
		z /= 108.883;
	
		x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (16 / 116);
		y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (16 / 116);
		z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (16 / 116);
	
		l = (116 * y) - 16;
		a = 500 * (x - y);
		b = 200 * (y - z);
	
		return [l, a, b];
	};
	
	convert.hsl.rgb = function (hsl) {
		var h = hsl[0] / 360;
		var s = hsl[1] / 100;
		var l = hsl[2] / 100;
		var t1;
		var t2;
		var t3;
		var rgb;
		var val;
	
		if (s === 0) {
			val = l * 255;
			return [val, val, val];
		}
	
		if (l < 0.5) {
			t2 = l * (1 + s);
		} else {
			t2 = l + s - l * s;
		}
	
		t1 = 2 * l - t2;
	
		rgb = [0, 0, 0];
		for (var i = 0; i < 3; i++) {
			t3 = h + 1 / 3 * -(i - 1);
			if (t3 < 0) {
				t3++;
			}
			if (t3 > 1) {
				t3--;
			}
	
			if (6 * t3 < 1) {
				val = t1 + (t2 - t1) * 6 * t3;
			} else if (2 * t3 < 1) {
				val = t2;
			} else if (3 * t3 < 2) {
				val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
			} else {
				val = t1;
			}
	
			rgb[i] = val * 255;
		}
	
		return rgb;
	};
	
	convert.hsl.hsv = function (hsl) {
		var h = hsl[0];
		var s = hsl[1] / 100;
		var l = hsl[2] / 100;
		var smin = s;
		var lmin = Math.max(l, 0.01);
		var sv;
		var v;
	
		l *= 2;
		s *= (l <= 1) ? l : 2 - l;
		smin *= lmin <= 1 ? lmin : 2 - lmin;
		v = (l + s) / 2;
		sv = l === 0 ? (2 * smin) / (lmin + smin) : (2 * s) / (l + s);
	
		return [h, sv * 100, v * 100];
	};
	
	convert.hsv.rgb = function (hsv) {
		var h = hsv[0] / 60;
		var s = hsv[1] / 100;
		var v = hsv[2] / 100;
		var hi = Math.floor(h) % 6;
	
		var f = h - Math.floor(h);
		var p = 255 * v * (1 - s);
		var q = 255 * v * (1 - (s * f));
		var t = 255 * v * (1 - (s * (1 - f)));
		v *= 255;
	
		switch (hi) {
			case 0:
				return [v, t, p];
			case 1:
				return [q, v, p];
			case 2:
				return [p, v, t];
			case 3:
				return [p, q, v];
			case 4:
				return [t, p, v];
			case 5:
				return [v, p, q];
		}
	};
	
	convert.hsv.hsl = function (hsv) {
		var h = hsv[0];
		var s = hsv[1] / 100;
		var v = hsv[2] / 100;
		var vmin = Math.max(v, 0.01);
		var lmin;
		var sl;
		var l;
	
		l = (2 - s) * v;
		lmin = (2 - s) * vmin;
		sl = s * vmin;
		sl /= (lmin <= 1) ? lmin : 2 - lmin;
		sl = sl || 0;
		l /= 2;
	
		return [h, sl * 100, l * 100];
	};
	
	// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
	convert.hwb.rgb = function (hwb) {
		var h = hwb[0] / 360;
		var wh = hwb[1] / 100;
		var bl = hwb[2] / 100;
		var ratio = wh + bl;
		var i;
		var v;
		var f;
		var n;
	
		// wh + bl cant be > 1
		if (ratio > 1) {
			wh /= ratio;
			bl /= ratio;
		}
	
		i = Math.floor(6 * h);
		v = 1 - bl;
		f = 6 * h - i;
	
		if ((i & 0x01) !== 0) {
			f = 1 - f;
		}
	
		n = wh + f * (v - wh); // linear interpolation
	
		var r;
		var g;
		var b;
		switch (i) {
			default:
			case 6:
			case 0: r = v; g = n; b = wh; break;
			case 1: r = n; g = v; b = wh; break;
			case 2: r = wh; g = v; b = n; break;
			case 3: r = wh; g = n; b = v; break;
			case 4: r = n; g = wh; b = v; break;
			case 5: r = v; g = wh; b = n; break;
		}
	
		return [r * 255, g * 255, b * 255];
	};
	
	convert.cmyk.rgb = function (cmyk) {
		var c = cmyk[0] / 100;
		var m = cmyk[1] / 100;
		var y = cmyk[2] / 100;
		var k = cmyk[3] / 100;
		var r;
		var g;
		var b;
	
		r = 1 - Math.min(1, c * (1 - k) + k);
		g = 1 - Math.min(1, m * (1 - k) + k);
		b = 1 - Math.min(1, y * (1 - k) + k);
	
		return [r * 255, g * 255, b * 255];
	};
	
	convert.xyz.rgb = function (xyz) {
		var x = xyz[0] / 100;
		var y = xyz[1] / 100;
		var z = xyz[2] / 100;
		var r;
		var g;
		var b;
	
		r = (x * 3.2406) + (y * -1.5372) + (z * -0.4986);
		g = (x * -0.9689) + (y * 1.8758) + (z * 0.0415);
		b = (x * 0.0557) + (y * -0.2040) + (z * 1.0570);
	
		// assume sRGB
		r = r > 0.0031308
			? ((1.055 * Math.pow(r, 1.0 / 2.4)) - 0.055)
			: r * 12.92;
	
		g = g > 0.0031308
			? ((1.055 * Math.pow(g, 1.0 / 2.4)) - 0.055)
			: g * 12.92;
	
		b = b > 0.0031308
			? ((1.055 * Math.pow(b, 1.0 / 2.4)) - 0.055)
			: b * 12.92;
	
		r = Math.min(Math.max(0, r), 1);
		g = Math.min(Math.max(0, g), 1);
		b = Math.min(Math.max(0, b), 1);
	
		return [r * 255, g * 255, b * 255];
	};
	
	convert.xyz.lab = function (xyz) {
		var x = xyz[0];
		var y = xyz[1];
		var z = xyz[2];
		var l;
		var a;
		var b;
	
		x /= 95.047;
		y /= 100;
		z /= 108.883;
	
		x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (16 / 116);
		y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (16 / 116);
		z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (16 / 116);
	
		l = (116 * y) - 16;
		a = 500 * (x - y);
		b = 200 * (y - z);
	
		return [l, a, b];
	};
	
	convert.lab.xyz = function (lab) {
		var l = lab[0];
		var a = lab[1];
		var b = lab[2];
		var x;
		var y;
		var z;
	
		y = (l + 16) / 116;
		x = a / 500 + y;
		z = y - b / 200;
	
		var y2 = Math.pow(y, 3);
		var x2 = Math.pow(x, 3);
		var z2 = Math.pow(z, 3);
		y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
		x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
		z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;
	
		x *= 95.047;
		y *= 100;
		z *= 108.883;
	
		return [x, y, z];
	};
	
	convert.lab.lch = function (lab) {
		var l = lab[0];
		var a = lab[1];
		var b = lab[2];
		var hr;
		var h;
		var c;
	
		hr = Math.atan2(b, a);
		h = hr * 360 / 2 / Math.PI;
	
		if (h < 0) {
			h += 360;
		}
	
		c = Math.sqrt(a * a + b * b);
	
		return [l, c, h];
	};
	
	convert.lch.lab = function (lch) {
		var l = lch[0];
		var c = lch[1];
		var h = lch[2];
		var a;
		var b;
		var hr;
	
		hr = h / 360 * 2 * Math.PI;
		a = c * Math.cos(hr);
		b = c * Math.sin(hr);
	
		return [l, a, b];
	};
	
	convert.rgb.ansi16 = function (args) {
		var r = args[0];
		var g = args[1];
		var b = args[2];
		var value = 1 in arguments ? arguments[1] : convert.rgb.hsv(args)[2]; // hsv -> ansi16 optimization
	
		value = Math.round(value / 50);
	
		if (value === 0) {
			return 30;
		}
	
		var ansi = 30
			+ ((Math.round(b / 255) << 2)
			| (Math.round(g / 255) << 1)
			| Math.round(r / 255));
	
		if (value === 2) {
			ansi += 60;
		}
	
		return ansi;
	};
	
	convert.hsv.ansi16 = function (args) {
		// optimization here; we already know the value and don't need to get
		// it converted for us.
		return convert.rgb.ansi16(convert.hsv.rgb(args), args[2]);
	};
	
	convert.rgb.ansi256 = function (args) {
		var r = args[0];
		var g = args[1];
		var b = args[2];
	
		// we use the extended greyscale palette here, with the exception of
		// black and white. normal palette only has 4 greyscale shades.
		if (r === g && g === b) {
			if (r < 8) {
				return 16;
			}
	
			if (r > 248) {
				return 231;
			}
	
			return Math.round(((r - 8) / 247) * 24) + 232;
		}
	
		var ansi = 16
			+ (36 * Math.round(r / 255 * 5))
			+ (6 * Math.round(g / 255 * 5))
			+ Math.round(b / 255 * 5);
	
		return ansi;
	};
	
	convert.ansi16.rgb = function (args) {
		var color = args % 10;
	
		// handle greyscale
		if (color === 0 || color === 7) {
			if (args > 50) {
				color += 3.5;
			}
	
			color = color / 10.5 * 255;
	
			return [color, color, color];
		}
	
		var mult = (~~(args > 50) + 1) * 0.5;
		var r = ((color & 1) * mult) * 255;
		var g = (((color >> 1) & 1) * mult) * 255;
		var b = (((color >> 2) & 1) * mult) * 255;
	
		return [r, g, b];
	};
	
	convert.ansi256.rgb = function (args) {
		// handle greyscale
		if (args >= 232) {
			var c = (args - 232) * 10 + 8;
			return [c, c, c];
		}
	
		args -= 16;
	
		var rem;
		var r = Math.floor(args / 36) / 5 * 255;
		var g = Math.floor((rem = args % 36) / 6) / 5 * 255;
		var b = (rem % 6) / 5 * 255;
	
		return [r, g, b];
	};
	
	convert.rgb.hex = function (args) {
		var integer = ((Math.round(args[0]) & 0xFF) << 16)
			+ ((Math.round(args[1]) & 0xFF) << 8)
			+ (Math.round(args[2]) & 0xFF);
	
		var string = integer.toString(16).toUpperCase();
		return '000000'.substring(string.length) + string;
	};
	
	convert.hex.rgb = function (args) {
		var match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
		if (!match) {
			return [0, 0, 0];
		}
	
		var colorString = match[0];
	
		if (match[0].length === 3) {
			colorString = colorString.split('').map(function (char) {
				return char + char;
			}).join('');
		}
	
		var integer = parseInt(colorString, 16);
		var r = (integer >> 16) & 0xFF;
		var g = (integer >> 8) & 0xFF;
		var b = integer & 0xFF;
	
		return [r, g, b];
	};
	
	convert.rgb.hcg = function (rgb) {
		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;
		var max = Math.max(Math.max(r, g), b);
		var min = Math.min(Math.min(r, g), b);
		var chroma = (max - min);
		var grayscale;
		var hue;
	
		if (chroma < 1) {
			grayscale = min / (1 - chroma);
		} else {
			grayscale = 0;
		}
	
		if (chroma <= 0) {
			hue = 0;
		} else
		if (max === r) {
			hue = ((g - b) / chroma) % 6;
		} else
		if (max === g) {
			hue = 2 + (b - r) / chroma;
		} else {
			hue = 4 + (r - g) / chroma + 4;
		}
	
		hue /= 6;
		hue %= 1;
	
		return [hue * 360, chroma * 100, grayscale * 100];
	};
	
	convert.hsl.hcg = function (hsl) {
		var s = hsl[1] / 100;
		var l = hsl[2] / 100;
		var c = 1;
		var f = 0;
	
		if (l < 0.5) {
			c = 2.0 * s * l;
		} else {
			c = 2.0 * s * (1.0 - l);
		}
	
		if (c < 1.0) {
			f = (l - 0.5 * c) / (1.0 - c);
		}
	
		return [hsl[0], c * 100, f * 100];
	};
	
	convert.hsv.hcg = function (hsv) {
		var s = hsv[1] / 100;
		var v = hsv[2] / 100;
	
		var c = s * v;
		var f = 0;
	
		if (c < 1.0) {
			f = (v - c) / (1 - c);
		}
	
		return [hsv[0], c * 100, f * 100];
	};
	
	convert.hcg.rgb = function (hcg) {
		var h = hcg[0] / 360;
		var c = hcg[1] / 100;
		var g = hcg[2] / 100;
	
		if (c === 0.0) {
			return [g * 255, g * 255, g * 255];
		}
	
		var pure = [0, 0, 0];
		var hi = (h % 1) * 6;
		var v = hi % 1;
		var w = 1 - v;
		var mg = 0;
	
		switch (Math.floor(hi)) {
			case 0:
				pure[0] = 1; pure[1] = v; pure[2] = 0; break;
			case 1:
				pure[0] = w; pure[1] = 1; pure[2] = 0; break;
			case 2:
				pure[0] = 0; pure[1] = 1; pure[2] = v; break;
			case 3:
				pure[0] = 0; pure[1] = w; pure[2] = 1; break;
			case 4:
				pure[0] = v; pure[1] = 0; pure[2] = 1; break;
			default:
				pure[0] = 1; pure[1] = 0; pure[2] = w;
		}
	
		mg = (1.0 - c) * g;
	
		return [
			(c * pure[0] + mg) * 255,
			(c * pure[1] + mg) * 255,
			(c * pure[2] + mg) * 255
		];
	};
	
	convert.hcg.hsv = function (hcg) {
		var c = hcg[1] / 100;
		var g = hcg[2] / 100;
	
		var v = c + g * (1.0 - c);
		var f = 0;
	
		if (v > 0.0) {
			f = c / v;
		}
	
		return [hcg[0], f * 100, v * 100];
	};
	
	convert.hcg.hsl = function (hcg) {
		var c = hcg[1] / 100;
		var g = hcg[2] / 100;
	
		var l = g * (1.0 - c) + 0.5 * c;
		var s = 0;
	
		if (l > 0.0 && l < 0.5) {
			s = c / (2 * l);
		} else
		if (l >= 0.5 && l < 1.0) {
			s = c / (2 * (1 - l));
		}
	
		return [hcg[0], s * 100, l * 100];
	};
	
	convert.hcg.hwb = function (hcg) {
		var c = hcg[1] / 100;
		var g = hcg[2] / 100;
		var v = c + g * (1.0 - c);
		return [hcg[0], (v - c) * 100, (1 - v) * 100];
	};
	
	convert.hwb.hcg = function (hwb) {
		var w = hwb[1] / 100;
		var b = hwb[2] / 100;
		var v = 1 - b;
		var c = v - w;
		var g = 0;
	
		if (c < 1) {
			g = (v - c) / (1 - c);
		}
	
		return [hwb[0], c * 100, g * 100];
	};
	
	convert.apple.rgb = function (apple) {
		return [(apple[0] / 65535) * 255, (apple[1] / 65535) * 255, (apple[2] / 65535) * 255];
	};
	
	convert.rgb.apple = function (rgb) {
		return [(rgb[0] / 255) * 65535, (rgb[1] / 255) * 65535, (rgb[2] / 255) * 65535];
	};
	
	convert.gray.rgb = function (args) {
		return [args[0] / 100 * 255, args[0] / 100 * 255, args[0] / 100 * 255];
	};
	
	convert.gray.hsl = convert.gray.hsv = function (args) {
		return [0, 0, args[0]];
	};
	
	convert.gray.hwb = function (gray) {
		return [0, 100, gray[0]];
	};
	
	convert.gray.cmyk = function (gray) {
		return [0, 0, 0, gray[0]];
	};
	
	convert.gray.lab = function (gray) {
		return [gray[0], 0, 0];
	};
	
	convert.gray.hex = function (gray) {
		var val = Math.round(gray[0] / 100 * 255) & 0xFF;
		var integer = (val << 16) + (val << 8) + val;
	
		var string = integer.toString(16).toUpperCase();
		return '000000'.substring(string.length) + string;
	};
	
	convert.rgb.gray = function (rgb) {
		var val = (rgb[0] + rgb[1] + rgb[2]) / 3;
		return [val / 255 * 100];
	};


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var firebase = _interopDefault(__webpack_require__(39));
	
	var name = "firebase";
	var version = "7.14.5";
	
	/**
	 * @license
	 * Copyright 2018 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	firebase.registerVersion(name, version, 'app');
	
	module.exports = firebase;
	//# sourceMappingURL=index.cjs.js.map


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(263);
	
	//# sourceMappingURL=index.cjs.js.map


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {(function() { var firebase=__webpack_require__(163);__webpack_require__(164);if(typeof firebase.default!=='undefined'){firebase=firebase.default;}(function(){var supportCustomEvent=window.CustomEvent;if(!supportCustomEvent||typeof supportCustomEvent==="object"){supportCustomEvent=function CustomEvent(event,x){x=x||{};var ev=document.createEvent("CustomEvent");ev.initCustomEvent(event,!!x.bubbles,!!x.cancelable,x.detail||null);return ev};supportCustomEvent.prototype=window.Event.prototype}function createsStackingContext(el){while(el&&el!==document.body){var s=window.getComputedStyle(el);var invalid=function(k,ok){return!(s[k]===undefined||s[k]===
	ok)};if(s.opacity<1||invalid("zIndex","auto")||invalid("transform","none")||invalid("mixBlendMode","normal")||invalid("filter","none")||invalid("perspective","none")||s["isolation"]==="isolate"||s.position==="fixed"||s.webkitOverflowScrolling==="touch")return true;el=el.parentElement}return false}function findNearestDialog(el){while(el){if(el.localName==="dialog")return el;el=el.parentElement}return null}function safeBlur(el){if(el&&el.blur&&el!==document.body)el.blur()}function inNodeList(nodeList,
	node){for(var i=0;i<nodeList.length;++i)if(nodeList[i]===node)return true;return false}function isFormMethodDialog(el){if(!el||!el.hasAttribute("method"))return false;return el.getAttribute("method").toLowerCase()==="dialog"}function dialogPolyfillInfo(dialog){this.dialog_=dialog;this.replacedStyleTop_=false;this.openAsModal_=false;if(!dialog.hasAttribute("role"))dialog.setAttribute("role","dialog");dialog.show=this.show.bind(this);dialog.showModal=this.showModal.bind(this);dialog.close=this.close.bind(this);
	if(!("returnValue"in dialog))dialog.returnValue="";if("MutationObserver"in window){var mo=new MutationObserver(this.maybeHideModal.bind(this));mo.observe(dialog,{attributes:true,attributeFilter:["open"]})}else{var removed=false;var cb=function(){removed?this.downgradeModal():this.maybeHideModal();removed=false}.bind(this);var timeout;var delayModel=function(ev){if(ev.target!==dialog)return;var cand="DOMNodeRemoved";removed|=ev.type.substr(0,cand.length)===cand;window.clearTimeout(timeout);timeout=
	window.setTimeout(cb,0)};["DOMAttrModified","DOMNodeRemoved","DOMNodeRemovedFromDocument"].forEach(function(name){dialog.addEventListener(name,delayModel)})}Object.defineProperty(dialog,"open",{set:this.setOpen.bind(this),get:dialog.hasAttribute.bind(dialog,"open")});this.backdrop_=document.createElement("div");this.backdrop_.className="backdrop";this.backdrop_.addEventListener("click",this.backdropClick_.bind(this))}dialogPolyfillInfo.prototype={get dialog(){return this.dialog_},maybeHideModal:function(){if(this.dialog_.hasAttribute("open")&&
	document.body.contains(this.dialog_))return;this.downgradeModal()},downgradeModal:function(){if(!this.openAsModal_)return;this.openAsModal_=false;this.dialog_.style.zIndex="";if(this.replacedStyleTop_){this.dialog_.style.top="";this.replacedStyleTop_=false}this.backdrop_.parentNode&&this.backdrop_.parentNode.removeChild(this.backdrop_);dialogPolyfill.dm.removeDialog(this)},setOpen:function(value){if(value)this.dialog_.hasAttribute("open")||this.dialog_.setAttribute("open","");else{this.dialog_.removeAttribute("open");
	this.maybeHideModal()}},backdropClick_:function(e){if(!this.dialog_.hasAttribute("tabindex")){var fake=document.createElement("div");this.dialog_.insertBefore(fake,this.dialog_.firstChild);fake.tabIndex=-1;fake.focus();this.dialog_.removeChild(fake)}else this.dialog_.focus();var redirectedEvent=document.createEvent("MouseEvents");redirectedEvent.initMouseEvent(e.type,e.bubbles,e.cancelable,window,e.detail,e.screenX,e.screenY,e.clientX,e.clientY,e.ctrlKey,e.altKey,e.shiftKey,e.metaKey,e.button,e.relatedTarget);
	this.dialog_.dispatchEvent(redirectedEvent);e.stopPropagation()},focus_:function(){var target=this.dialog_.querySelector("[autofocus]:not([disabled])");if(!target&&this.dialog_.tabIndex>=0)target=this.dialog_;if(!target){var opts=["button","input","keygen","select","textarea"];var query=opts.map(function(el){return el+":not([disabled])"});query.push('[tabindex]:not([disabled]):not([tabindex=""])');target=this.dialog_.querySelector(query.join(", "))}safeBlur(document.activeElement);target&&target.focus()},
	updateZIndex:function(dialogZ,backdropZ){if(dialogZ<backdropZ)throw new Error("dialogZ should never be < backdropZ");this.dialog_.style.zIndex=dialogZ;this.backdrop_.style.zIndex=backdropZ},show:function(){if(!this.dialog_.open){this.setOpen(true);this.focus_()}},showModal:function(){if(this.dialog_.hasAttribute("open"))throw new Error("Failed to execute 'showModal' on dialog: The element is already open, and therefore cannot be opened modally.");if(!document.body.contains(this.dialog_))throw new Error("Failed to execute 'showModal' on dialog: The element is not in a Document.");
	if(!dialogPolyfill.dm.pushDialog(this))throw new Error("Failed to execute 'showModal' on dialog: There are too many open modal dialogs.");if(createsStackingContext(this.dialog_.parentElement))console.warn("A dialog is being shown inside a stacking context. "+"This may cause it to be unusable. For more information, see this link: "+"https://github.com/GoogleChrome/dialog-polyfill/#stacking-context");this.setOpen(true);this.openAsModal_=true;if(dialogPolyfill.needsCentering(this.dialog_)){dialogPolyfill.reposition(this.dialog_);
	this.replacedStyleTop_=true}else this.replacedStyleTop_=false;this.dialog_.parentNode.insertBefore(this.backdrop_,this.dialog_.nextSibling);this.focus_()},close:function(opt_returnValue){if(!this.dialog_.hasAttribute("open"))throw new Error("Failed to execute 'close' on dialog: The element does not have an 'open' attribute, and therefore cannot be closed.");this.setOpen(false);if(opt_returnValue!==undefined)this.dialog_.returnValue=opt_returnValue;var closeEvent=new supportCustomEvent("close",{bubbles:false,
	cancelable:false});this.dialog_.dispatchEvent(closeEvent)}};var dialogPolyfill={};dialogPolyfill.reposition=function(element){var scrollTop=document.body.scrollTop||document.documentElement.scrollTop;var topValue=scrollTop+(window.innerHeight-element.offsetHeight)/2;element.style.top=Math.max(scrollTop,topValue)+"px"};dialogPolyfill.isInlinePositionSetByStylesheet=function(element){for(var i=0;i<document.styleSheets.length;++i){var styleSheet=document.styleSheets[i];var cssRules=null;try{cssRules=
	styleSheet.cssRules}catch(e){}if(!cssRules)continue;for(var j=0;j<cssRules.length;++j){var rule=cssRules[j];var selectedNodes=null;try{selectedNodes=document.querySelectorAll(rule.selectorText)}catch(e$0){}if(!selectedNodes||!inNodeList(selectedNodes,element))continue;var cssTop=rule.style.getPropertyValue("top");var cssBottom=rule.style.getPropertyValue("bottom");if(cssTop&&cssTop!=="auto"||cssBottom&&cssBottom!=="auto")return true}}return false};dialogPolyfill.needsCentering=function(dialog){var computedStyle=
	window.getComputedStyle(dialog);if(computedStyle.position!=="absolute")return false;if(dialog.style.top!=="auto"&&dialog.style.top!==""||dialog.style.bottom!=="auto"&&dialog.style.bottom!=="")return false;return!dialogPolyfill.isInlinePositionSetByStylesheet(dialog)};dialogPolyfill.forceRegisterDialog=function(element){if(window.HTMLDialogElement||element.showModal)console.warn("This browser already supports <dialog>, the polyfill "+"may not work correctly",element);if(element.localName!=="dialog")throw new Error("Failed to register dialog: The element is not a dialog.");
	new dialogPolyfillInfo(element)};dialogPolyfill.registerDialog=function(element){if(!element.showModal)dialogPolyfill.forceRegisterDialog(element)};dialogPolyfill.DialogManager=function(){this.pendingDialogStack=[];var checkDOM=this.checkDOM_.bind(this);this.overlay=document.createElement("div");this.overlay.className="_dialog_overlay";this.overlay.addEventListener("click",function(e){this.forwardTab_=undefined;e.stopPropagation();checkDOM([])}.bind(this));this.handleKey_=this.handleKey_.bind(this);
	this.handleFocus_=this.handleFocus_.bind(this);this.zIndexLow_=1E5;this.zIndexHigh_=1E5+150;this.forwardTab_=undefined;if("MutationObserver"in window)this.mo_=new MutationObserver(function(records){var removed=[];records.forEach(function(rec){for(var i=0,c;c=rec.removedNodes[i];++i){if(!(c instanceof Element))continue;else if(c.localName==="dialog")removed.push(c);removed=removed.concat(c.querySelectorAll("dialog"))}});removed.length&&checkDOM(removed)})};dialogPolyfill.DialogManager.prototype.blockDocument=
	function(){document.documentElement.addEventListener("focus",this.handleFocus_,true);document.addEventListener("keydown",this.handleKey_);this.mo_&&this.mo_.observe(document,{childList:true,subtree:true})};dialogPolyfill.DialogManager.prototype.unblockDocument=function(){document.documentElement.removeEventListener("focus",this.handleFocus_,true);document.removeEventListener("keydown",this.handleKey_);this.mo_&&this.mo_.disconnect()};dialogPolyfill.DialogManager.prototype.updateStacking=function(){var zIndex=
	this.zIndexHigh_;for(var i=0,dpi;dpi=this.pendingDialogStack[i];++i){dpi.updateZIndex(--zIndex,--zIndex);if(i===0)this.overlay.style.zIndex=--zIndex}var last=this.pendingDialogStack[0];if(last){var p=last.dialog.parentNode||document.body;p.appendChild(this.overlay)}else if(this.overlay.parentNode)this.overlay.parentNode.removeChild(this.overlay)};dialogPolyfill.DialogManager.prototype.containedByTopDialog_=function(candidate){while(candidate=findNearestDialog(candidate)){for(var i=0,dpi;dpi=this.pendingDialogStack[i];++i)if(dpi.dialog===
	candidate)return i===0;candidate=candidate.parentElement}return false};dialogPolyfill.DialogManager.prototype.handleFocus_=function(event){if(this.containedByTopDialog_(event.target))return;event.preventDefault();event.stopPropagation();safeBlur(event.target);if(this.forwardTab_===undefined)return;var dpi=this.pendingDialogStack[0];var dialog=dpi.dialog;var position=dialog.compareDocumentPosition(event.target);if(position&Node.DOCUMENT_POSITION_PRECEDING)if(this.forwardTab_)dpi.focus_();else document.documentElement.focus();
	else;return false};dialogPolyfill.DialogManager.prototype.handleKey_=function(event){this.forwardTab_=undefined;if(event.keyCode===27){event.preventDefault();event.stopPropagation();var cancelEvent=new supportCustomEvent("cancel",{bubbles:false,cancelable:true});var dpi=this.pendingDialogStack[0];if(dpi&&dpi.dialog.dispatchEvent(cancelEvent))dpi.dialog.close()}else if(event.keyCode===9)this.forwardTab_=!event.shiftKey};dialogPolyfill.DialogManager.prototype.checkDOM_=function(removed){var clone=this.pendingDialogStack.slice();
	clone.forEach(function(dpi){if(removed.indexOf(dpi.dialog)!==-1)dpi.downgradeModal();else dpi.maybeHideModal()})};dialogPolyfill.DialogManager.prototype.pushDialog=function(dpi){var allowed=(this.zIndexHigh_-this.zIndexLow_)/2-1;if(this.pendingDialogStack.length>=allowed)return false;if(this.pendingDialogStack.unshift(dpi)===1)this.blockDocument();this.updateStacking();return true};dialogPolyfill.DialogManager.prototype.removeDialog=function(dpi){var index=this.pendingDialogStack.indexOf(dpi);if(index===
	-1)return;this.pendingDialogStack.splice(index,1);if(this.pendingDialogStack.length===0)this.unblockDocument();this.updateStacking()};dialogPolyfill.dm=new dialogPolyfill.DialogManager;dialogPolyfill.formSubmitter=null;dialogPolyfill.useValue=null;if(window.HTMLDialogElement===undefined){var testForm=document.createElement("form");testForm.setAttribute("method","dialog");if(testForm.method!=="dialog"){var methodDescriptor=Object.getOwnPropertyDescriptor(HTMLFormElement.prototype,"method");if(methodDescriptor){var realGet=
	methodDescriptor.get;methodDescriptor.get=function(){if(isFormMethodDialog(this))return"dialog";return realGet.call(this)};var realSet=methodDescriptor.set;methodDescriptor.set=function(v){if(typeof v==="string"&&v.toLowerCase()==="dialog")return this.setAttribute("method",v);return realSet.call(this,v)};Object.defineProperty(HTMLFormElement.prototype,"method",methodDescriptor)}}document.addEventListener("click",function(ev){dialogPolyfill.formSubmitter=null;dialogPolyfill.useValue=null;if(ev.defaultPrevented)return;
	var target=ev.target;if(!target||!isFormMethodDialog(target.form))return;var valid=target.type==="submit"&&["button","input"].indexOf(target.localName)>-1;if(!valid){if(!(target.localName==="input"&&target.type==="image"))return;dialogPolyfill.useValue=ev.offsetX+","+ev.offsetY}var dialog=findNearestDialog(target);if(!dialog)return;dialogPolyfill.formSubmitter=target},false);var nativeFormSubmit=HTMLFormElement.prototype.submit;var replacementFormSubmit=function(){if(!isFormMethodDialog(this))return nativeFormSubmit.call(this);
	var dialog=findNearestDialog(this);dialog&&dialog.close()};HTMLFormElement.prototype.submit=replacementFormSubmit;document.addEventListener("submit",function(ev){var form=ev.target;if(!isFormMethodDialog(form))return;ev.preventDefault();var dialog=findNearestDialog(form);if(!dialog)return;var s=dialogPolyfill.formSubmitter;if(s&&s.form===form)dialog.close(dialogPolyfill.useValue||s.value);else dialog.close();dialogPolyfill.formSubmitter=null},true)}dialogPolyfill["forceRegisterDialog"]=dialogPolyfill.forceRegisterDialog;
	dialogPolyfill["registerDialog"]=dialogPolyfill.registerDialog;if("function"==="function"&&"amd"in __webpack_require__(252))!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return dialogPolyfill}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else if(typeof module==="object"&&typeof module["exports"]==="object")module["exports"]=dialogPolyfill;else window["dialogPolyfill"]=dialogPolyfill})();/*
	
	 Copyright 2015 Google Inc. All Rights Reserved.
	
	 Licensed under the Apache License, Version 2.0 (the "License");
	 you may not use this file except in compliance with the License.
	 You may obtain a copy of the License at
	
	      http://www.apache.org/licenses/LICENSE-2.0
	
	 Unless required by applicable law or agreed to in writing, software
	 distributed under the License is distributed on an "AS IS" BASIS,
	 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 See the License for the specific language governing permissions and
	 limitations under the License.
	*/
	var componentHandler={upgradeDom:function(optJsClass,optCssClass){},upgradeElement:function(element,optJsClass){},upgradeElements:function(elements){},upgradeAllRegistered:function(){},registerUpgradedCallback:function(jsClass,callback){},register:function(config){},downgradeElements:function(nodes){}};
	componentHandler=function(){var registeredComponents_=[];var createdComponents_=[];var componentConfigProperty_="mdlComponentConfigInternal_";function findRegisteredClass_(name,optReplace){for(var i=0;i<registeredComponents_.length;i++)if(registeredComponents_[i].className===name){if(typeof optReplace!=="undefined")registeredComponents_[i]=optReplace;return registeredComponents_[i]}return false}function getUpgradedListOfElement_(element){var dataUpgraded=element.getAttribute("data-upgraded");return dataUpgraded===
	null?[""]:dataUpgraded.split(",")}function isElementUpgraded_(element,jsClass){var upgradedList=getUpgradedListOfElement_(element);return upgradedList.indexOf(jsClass)!==-1}function createEvent_(eventType,bubbles,cancelable){if("CustomEvent"in window&&typeof window.CustomEvent==="function")return new CustomEvent(eventType,{bubbles:bubbles,cancelable:cancelable});else{var ev=document.createEvent("Events");ev.initEvent(eventType,bubbles,cancelable);return ev}}function upgradeDomInternal(optJsClass,
	optCssClass){if(typeof optJsClass==="undefined"&&typeof optCssClass==="undefined")for(var i=0;i<registeredComponents_.length;i++)upgradeDomInternal(registeredComponents_[i].className,registeredComponents_[i].cssClass);else{var jsClass=optJsClass;if(typeof optCssClass==="undefined"){var registeredClass=findRegisteredClass_(jsClass);if(registeredClass)optCssClass=registeredClass.cssClass}var elements=document.querySelectorAll("."+optCssClass);for(var n=0;n<elements.length;n++)upgradeElementInternal(elements[n],
	jsClass)}}function upgradeElementInternal(element,optJsClass){if(!(typeof element==="object"&&element instanceof Element))throw new Error("Invalid argument provided to upgrade MDL element.");var upgradingEv=createEvent_("mdl-componentupgrading",true,true);element.dispatchEvent(upgradingEv);if(upgradingEv.defaultPrevented)return;var upgradedList=getUpgradedListOfElement_(element);var classesToUpgrade=[];if(!optJsClass){var classList=element.classList;registeredComponents_.forEach(function(component){if(classList.contains(component.cssClass)&&
	classesToUpgrade.indexOf(component)===-1&&!isElementUpgraded_(element,component.className))classesToUpgrade.push(component)})}else if(!isElementUpgraded_(element,optJsClass))classesToUpgrade.push(findRegisteredClass_(optJsClass));for(var i=0,n=classesToUpgrade.length,registeredClass;i<n;i++){registeredClass=classesToUpgrade[i];if(registeredClass){upgradedList.push(registeredClass.className);element.setAttribute("data-upgraded",upgradedList.join(","));var instance=new registeredClass.classConstructor(element);
	instance[componentConfigProperty_]=registeredClass;createdComponents_.push(instance);for(var j=0,m=registeredClass.callbacks.length;j<m;j++)registeredClass.callbacks[j](element);if(registeredClass.widget)element[registeredClass.className]=instance}else throw new Error("Unable to find a registered component for the given class.");var upgradedEv=createEvent_("mdl-componentupgraded",true,false);element.dispatchEvent(upgradedEv)}}function upgradeElementsInternal(elements){if(!Array.isArray(elements))if(elements instanceof
	Element)elements=[elements];else elements=Array.prototype.slice.call(elements);for(var i=0,n=elements.length,element;i<n;i++){element=elements[i];if(element instanceof HTMLElement){upgradeElementInternal(element);if(element.children.length>0)upgradeElementsInternal(element.children)}}}function registerInternal(config){var widgetMissing=typeof config.widget==="undefined"&&typeof config["widget"]==="undefined";var widget=true;if(!widgetMissing)widget=config.widget||config["widget"];var newConfig={classConstructor:config.constructor||
	config["constructor"],className:config.classAsString||config["classAsString"],cssClass:config.cssClass||config["cssClass"],widget:widget,callbacks:[]};registeredComponents_.forEach(function(item){if(item.cssClass===newConfig.cssClass)throw new Error("The provided cssClass has already been registered: "+item.cssClass);if(item.className===newConfig.className)throw new Error("The provided className has already been registered");});if(config.constructor.prototype.hasOwnProperty(componentConfigProperty_))throw new Error("MDL component classes must not have "+
	componentConfigProperty_+" defined as a property.");var found=findRegisteredClass_(config.classAsString,newConfig);if(!found)registeredComponents_.push(newConfig)}function registerUpgradedCallbackInternal(jsClass,callback){var regClass=findRegisteredClass_(jsClass);if(regClass)regClass.callbacks.push(callback)}function upgradeAllRegisteredInternal(){for(var n=0;n<registeredComponents_.length;n++)upgradeDomInternal(registeredComponents_[n].className)}function deconstructComponentInternal(component){if(component){var componentIndex=
	createdComponents_.indexOf(component);createdComponents_.splice(componentIndex,1);var upgrades=component.element_.getAttribute("data-upgraded").split(",");var componentPlace=upgrades.indexOf(component[componentConfigProperty_].classAsString);upgrades.splice(componentPlace,1);component.element_.setAttribute("data-upgraded",upgrades.join(","));var ev=createEvent_("mdl-componentdowngraded",true,false);component.element_.dispatchEvent(ev)}}function downgradeNodesInternal(nodes){var downgradeNode=function(node){createdComponents_.filter(function(item){return item.element_===
	node}).forEach(deconstructComponentInternal)};if(nodes instanceof Array||nodes instanceof NodeList)for(var n=0;n<nodes.length;n++)downgradeNode(nodes[n]);else if(nodes instanceof Node)downgradeNode(nodes);else throw new Error("Invalid argument provided to downgrade MDL nodes.");}return{upgradeDom:upgradeDomInternal,upgradeElement:upgradeElementInternal,upgradeElements:upgradeElementsInternal,upgradeAllRegistered:upgradeAllRegisteredInternal,registerUpgradedCallback:registerUpgradedCallbackInternal,
	register:registerInternal,downgradeElements:downgradeNodesInternal}}();componentHandler.ComponentConfigPublic;componentHandler.ComponentConfig;componentHandler.Component;componentHandler["upgradeDom"]=componentHandler.upgradeDom;componentHandler["upgradeElement"]=componentHandler.upgradeElement;componentHandler["upgradeElements"]=componentHandler.upgradeElements;componentHandler["upgradeAllRegistered"]=componentHandler.upgradeAllRegistered;componentHandler["registerUpgradedCallback"]=componentHandler.registerUpgradedCallback;
	componentHandler["register"]=componentHandler.register;componentHandler["downgradeElements"]=componentHandler.downgradeElements;window.componentHandler=componentHandler;window["componentHandler"]=componentHandler;
	window.addEventListener("load",function(){if("classList"in document.createElement("div")&&"querySelector"in document&&"addEventListener"in window&&Array.prototype.forEach){document.documentElement.classList.add("mdl-js");componentHandler.upgradeAllRegistered()}else{componentHandler.upgradeElement=function(){};componentHandler.register=function(){}}});(function(){var MaterialButton=function MaterialButton(element){this.element_=element;this.init()};window["MaterialButton"]=MaterialButton;MaterialButton.prototype.Constant_={};MaterialButton.prototype.CssClasses_={RIPPLE_EFFECT:"mdl-js-ripple-effect",RIPPLE_CONTAINER:"mdl-button__ripple-container",RIPPLE:"mdl-ripple"};MaterialButton.prototype.blurHandler_=function(event){if(event)this.element_.blur()};MaterialButton.prototype.disable=function(){this.element_.disabled=true};MaterialButton.prototype["disable"]=
	MaterialButton.prototype.disable;MaterialButton.prototype.enable=function(){this.element_.disabled=false};MaterialButton.prototype["enable"]=MaterialButton.prototype.enable;MaterialButton.prototype.init=function(){if(this.element_){if(this.element_.classList.contains(this.CssClasses_.RIPPLE_EFFECT)){var rippleContainer=document.createElement("span");rippleContainer.classList.add(this.CssClasses_.RIPPLE_CONTAINER);this.rippleElement_=document.createElement("span");this.rippleElement_.classList.add(this.CssClasses_.RIPPLE);
	rippleContainer.appendChild(this.rippleElement_);this.boundRippleBlurHandler=this.blurHandler_.bind(this);this.rippleElement_.addEventListener("mouseup",this.boundRippleBlurHandler);this.element_.appendChild(rippleContainer)}this.boundButtonBlurHandler=this.blurHandler_.bind(this);this.element_.addEventListener("mouseup",this.boundButtonBlurHandler);this.element_.addEventListener("mouseleave",this.boundButtonBlurHandler)}};componentHandler.register({constructor:MaterialButton,classAsString:"MaterialButton",
	cssClass:"mdl-js-button",widget:true})})();(function(){var MaterialProgress=function MaterialProgress(element){this.element_=element;this.init()};window["MaterialProgress"]=MaterialProgress;MaterialProgress.prototype.Constant_={};MaterialProgress.prototype.CssClasses_={INDETERMINATE_CLASS:"mdl-progress__indeterminate"};MaterialProgress.prototype.setProgress=function(p){if(this.element_.classList.contains(this.CssClasses_.INDETERMINATE_CLASS))return;this.progressbar_.style.width=p+"%"};MaterialProgress.prototype["setProgress"]=MaterialProgress.prototype.setProgress;
	MaterialProgress.prototype.setBuffer=function(p){this.bufferbar_.style.width=p+"%";this.auxbar_.style.width=100-p+"%"};MaterialProgress.prototype["setBuffer"]=MaterialProgress.prototype.setBuffer;MaterialProgress.prototype.init=function(){if(this.element_){var el=document.createElement("div");el.className="progressbar bar bar1";this.element_.appendChild(el);this.progressbar_=el;el=document.createElement("div");el.className="bufferbar bar bar2";this.element_.appendChild(el);this.bufferbar_=el;el=document.createElement("div");
	el.className="auxbar bar bar3";this.element_.appendChild(el);this.auxbar_=el;this.progressbar_.style.width="0%";this.bufferbar_.style.width="100%";this.auxbar_.style.width="0%";this.element_.classList.add("is-upgraded")}};componentHandler.register({constructor:MaterialProgress,classAsString:"MaterialProgress",cssClass:"mdl-js-progress",widget:true})})();(function(){var MaterialSpinner=function MaterialSpinner(element){this.element_=element;this.init()};window["MaterialSpinner"]=MaterialSpinner;MaterialSpinner.prototype.Constant_={MDL_SPINNER_LAYER_COUNT:4};MaterialSpinner.prototype.CssClasses_={MDL_SPINNER_LAYER:"mdl-spinner__layer",MDL_SPINNER_CIRCLE_CLIPPER:"mdl-spinner__circle-clipper",MDL_SPINNER_CIRCLE:"mdl-spinner__circle",MDL_SPINNER_GAP_PATCH:"mdl-spinner__gap-patch",MDL_SPINNER_LEFT:"mdl-spinner__left",MDL_SPINNER_RIGHT:"mdl-spinner__right"};
	MaterialSpinner.prototype.createLayer=function(index){var layer=document.createElement("div");layer.classList.add(this.CssClasses_.MDL_SPINNER_LAYER);layer.classList.add(this.CssClasses_.MDL_SPINNER_LAYER+"-"+index);var leftClipper=document.createElement("div");leftClipper.classList.add(this.CssClasses_.MDL_SPINNER_CIRCLE_CLIPPER);leftClipper.classList.add(this.CssClasses_.MDL_SPINNER_LEFT);var gapPatch=document.createElement("div");gapPatch.classList.add(this.CssClasses_.MDL_SPINNER_GAP_PATCH);var rightClipper=
	document.createElement("div");rightClipper.classList.add(this.CssClasses_.MDL_SPINNER_CIRCLE_CLIPPER);rightClipper.classList.add(this.CssClasses_.MDL_SPINNER_RIGHT);var circleOwners=[leftClipper,gapPatch,rightClipper];for(var i=0;i<circleOwners.length;i++){var circle=document.createElement("div");circle.classList.add(this.CssClasses_.MDL_SPINNER_CIRCLE);circleOwners[i].appendChild(circle)}layer.appendChild(leftClipper);layer.appendChild(gapPatch);layer.appendChild(rightClipper);this.element_.appendChild(layer)};
	MaterialSpinner.prototype["createLayer"]=MaterialSpinner.prototype.createLayer;MaterialSpinner.prototype.stop=function(){this.element_.classList.remove("is-active")};MaterialSpinner.prototype["stop"]=MaterialSpinner.prototype.stop;MaterialSpinner.prototype.start=function(){this.element_.classList.add("is-active")};MaterialSpinner.prototype["start"]=MaterialSpinner.prototype.start;MaterialSpinner.prototype.init=function(){if(this.element_){for(var i=1;i<=this.Constant_.MDL_SPINNER_LAYER_COUNT;i++)this.createLayer(i);
	this.element_.classList.add("is-upgraded")}};componentHandler.register({constructor:MaterialSpinner,classAsString:"MaterialSpinner",cssClass:"mdl-js-spinner",widget:true})})();(function(){var MaterialTextfield=function MaterialTextfield(element){this.element_=element;this.maxRows=this.Constant_.NO_MAX_ROWS;this.init()};window["MaterialTextfield"]=MaterialTextfield;MaterialTextfield.prototype.Constant_={NO_MAX_ROWS:-1,MAX_ROWS_ATTRIBUTE:"maxrows"};MaterialTextfield.prototype.CssClasses_={LABEL:"mdl-textfield__label",INPUT:"mdl-textfield__input",IS_DIRTY:"is-dirty",IS_FOCUSED:"is-focused",IS_DISABLED:"is-disabled",IS_INVALID:"is-invalid",IS_UPGRADED:"is-upgraded",HAS_PLACEHOLDER:"has-placeholder"};
	MaterialTextfield.prototype.onKeyDown_=function(event){var currentRowCount=event.target.value.split("\n").length;if(event.keyCode===13)if(currentRowCount>=this.maxRows)event.preventDefault()};MaterialTextfield.prototype.onFocus_=function(event){this.element_.classList.add(this.CssClasses_.IS_FOCUSED)};MaterialTextfield.prototype.onBlur_=function(event){this.element_.classList.remove(this.CssClasses_.IS_FOCUSED)};MaterialTextfield.prototype.onReset_=function(event){this.updateClasses_()};MaterialTextfield.prototype.updateClasses_=
	function(){this.checkDisabled();this.checkValidity();this.checkDirty();this.checkFocus()};MaterialTextfield.prototype.checkDisabled=function(){if(this.input_.disabled)this.element_.classList.add(this.CssClasses_.IS_DISABLED);else this.element_.classList.remove(this.CssClasses_.IS_DISABLED)};MaterialTextfield.prototype["checkDisabled"]=MaterialTextfield.prototype.checkDisabled;MaterialTextfield.prototype.checkFocus=function(){if(Boolean(this.element_.querySelector(":focus")))this.element_.classList.add(this.CssClasses_.IS_FOCUSED);
	else this.element_.classList.remove(this.CssClasses_.IS_FOCUSED)};MaterialTextfield.prototype["checkFocus"]=MaterialTextfield.prototype.checkFocus;MaterialTextfield.prototype.checkValidity=function(){if(this.input_.validity)if(this.input_.validity.valid)this.element_.classList.remove(this.CssClasses_.IS_INVALID);else this.element_.classList.add(this.CssClasses_.IS_INVALID)};MaterialTextfield.prototype["checkValidity"]=MaterialTextfield.prototype.checkValidity;MaterialTextfield.prototype.checkDirty=
	function(){if(this.input_.value&&this.input_.value.length>0)this.element_.classList.add(this.CssClasses_.IS_DIRTY);else this.element_.classList.remove(this.CssClasses_.IS_DIRTY)};MaterialTextfield.prototype["checkDirty"]=MaterialTextfield.prototype.checkDirty;MaterialTextfield.prototype.disable=function(){this.input_.disabled=true;this.updateClasses_()};MaterialTextfield.prototype["disable"]=MaterialTextfield.prototype.disable;MaterialTextfield.prototype.enable=function(){this.input_.disabled=false;
	this.updateClasses_()};MaterialTextfield.prototype["enable"]=MaterialTextfield.prototype.enable;MaterialTextfield.prototype.change=function(value){this.input_.value=value||"";this.updateClasses_()};MaterialTextfield.prototype["change"]=MaterialTextfield.prototype.change;MaterialTextfield.prototype.init=function(){if(this.element_){this.label_=this.element_.querySelector("."+this.CssClasses_.LABEL);this.input_=this.element_.querySelector("."+this.CssClasses_.INPUT);if(this.input_){if(this.input_.hasAttribute(this.Constant_.MAX_ROWS_ATTRIBUTE)){this.maxRows=
	parseInt(this.input_.getAttribute(this.Constant_.MAX_ROWS_ATTRIBUTE),10);if(isNaN(this.maxRows))this.maxRows=this.Constant_.NO_MAX_ROWS}if(this.input_.hasAttribute("placeholder"))this.element_.classList.add(this.CssClasses_.HAS_PLACEHOLDER);this.boundUpdateClassesHandler=this.updateClasses_.bind(this);this.boundFocusHandler=this.onFocus_.bind(this);this.boundBlurHandler=this.onBlur_.bind(this);this.boundResetHandler=this.onReset_.bind(this);this.input_.addEventListener("input",this.boundUpdateClassesHandler);
	this.input_.addEventListener("focus",this.boundFocusHandler);this.input_.addEventListener("blur",this.boundBlurHandler);this.input_.addEventListener("reset",this.boundResetHandler);if(this.maxRows!==this.Constant_.NO_MAX_ROWS){this.boundKeyDownHandler=this.onKeyDown_.bind(this);this.input_.addEventListener("keydown",this.boundKeyDownHandler)}var invalid=this.element_.classList.contains(this.CssClasses_.IS_INVALID);this.updateClasses_();this.element_.classList.add(this.CssClasses_.IS_UPGRADED);if(invalid)this.element_.classList.add(this.CssClasses_.IS_INVALID);
	if(this.input_.hasAttribute("autofocus")){this.element_.focus();this.checkFocus()}}}};componentHandler.register({constructor:MaterialTextfield,classAsString:"MaterialTextfield",cssClass:"mdl-js-textfield",widget:true})})();(function(){var l,aa="function"==typeof Object.create?Object.create:function(a){function b(){}b.prototype=a;return new b},ba;if("function"==typeof Object.setPrototypeOf)ba=Object.setPrototypeOf;else{var ca;a:{var da={zb:!0},ea={};try{ea.__proto__=da;ca=ea.zb;break a}catch(a){}ca=!1}ba=ca?function(a,b){a.__proto__=b;if(a.__proto__!==b)throw new TypeError(a+" is not extensible");return a}:null}var fa=ba;function n(a,b){a.prototype=aa(b.prototype);a.prototype.constructor=a;if(fa)fa(a,b);else for(var c in b)if("prototype"!=
	c)if(Object.defineProperties){var d=Object.getOwnPropertyDescriptor(b,c);d&&Object.defineProperty(a,c,d)}else a[c]=b[c];a.M=b.prototype}var ha="function"==typeof Object.defineProperties?Object.defineProperty:function(a,b,c){a!=Array.prototype&&a!=Object.prototype&&(a[b]=c.value)},ia="undefined"!=typeof window&&window===this?this:"undefined"!=typeof global&&null!=global?global:this;function ka(a,b){if(b){var c=ia;a=a.split(".");for(var d=0;d<a.length-1;d++){var e=a[d];e in c||(c[e]={});c=c[e]}a=a[a.length-
	1];d=c[a];b=b(d);b!=d&&null!=b&&ha(c,a,{configurable:!0,writable:!0,value:b})}}function la(a){var b=0;return function(){return b<a.length?{done:!1,value:a[b++]}:{done:!0}}}ka("Object.is",function(a){return a?a:function(b,c){return b===c?0!==b||1/b===1/c:b!==b&&c!==c}});ka("Array.prototype.includes",function(a){return a?a:function(b,c){var d=this;d instanceof String&&(d=String(d));var e=d.length;c=c||0;for(0>c&&(c=Math.max(c+e,0));c<e;c++){var f=d[c];if(f===b||Object.is(f,b))return!0}return!1}});function ma(a){var b=
	"undefined"!=typeof Symbol&&Symbol.iterator&&a[Symbol.iterator];return b?b.call(a):{next:la(a)}}ka("Promise",function(a){function b(g){this.f=0;this.h=void 0;this.a=[];var h=this.j();try{g(h.resolve,h.reject)}catch(k){h.reject(k)}}function c(){this.a=null}function d(g){return g instanceof b?g:new b(function(h){h(g)})}if(a)return a;c.prototype.f=function(g){if(null==this.a){this.a=[];var h=this;this.h(function(){h.s()})}this.a.push(g)};var e=ia.setTimeout;c.prototype.h=function(g){e(g,0)};c.prototype.s=
	function(){for(;this.a&&this.a.length;){var g=this.a;this.a=[];for(var h=0;h<g.length;++h){var k=g[h];g[h]=null;try{k()}catch(m){this.j(m)}}}this.a=null};c.prototype.j=function(g){this.h(function(){throw g;})};b.prototype.j=function(){function g(m){return function(q){k||(k=!0,m.call(h,q))}}var h=this,k=!1;return{resolve:g(this.L),reject:g(this.s)}};b.prototype.L=function(g){if(g===this)this.s(new TypeError("A Promise cannot resolve to itself"));else if(g instanceof b)this.N(g);else{a:switch(typeof g){case "object":var h=
	null!=g;break a;case "function":h=!0;break a;default:h=!1}h?this.I(g):this.i(g)}};b.prototype.I=function(g){var h=void 0;try{h=g.then}catch(k){this.s(k);return}"function"==typeof h?this.O(h,g):this.i(g)};b.prototype.s=function(g){this.w(2,g)};b.prototype.i=function(g){this.w(1,g)};b.prototype.w=function(g,h){if(0!=this.f)throw Error("Cannot settle("+g+", "+h+"): Promise already settled in state"+this.f);this.f=g;this.h=h;this.C()};b.prototype.C=function(){if(null!=this.a){for(var g=0;g<this.a.length;++g)f.f(this.a[g]);
	this.a=null}};var f=new c;b.prototype.N=function(g){var h=this.j();g.Ia(h.resolve,h.reject)};b.prototype.O=function(g,h){var k=this.j();try{g.call(h,k.resolve,k.reject)}catch(m){k.reject(m)}};b.prototype.then=function(g,h){function k(S,Ha){return"function"==typeof S?function(Pa){try{m(S(Pa))}catch(ja){q(ja)}}:Ha}var m,q,E=new b(function(S,Ha){m=S;q=Ha});this.Ia(k(g,m),k(h,q));return E};b.prototype.catch=function(g){return this.then(void 0,g)};b.prototype.Ia=function(g,h){function k(){switch(m.f){case 1:g(m.h);
	break;case 2:h(m.h);break;default:throw Error("Unexpected state: "+m.f);}}var m=this;null==this.a?f.f(k):this.a.push(k)};b.resolve=d;b.reject=function(g){return new b(function(h,k){k(g)})};b.race=function(g){return new b(function(h,k){for(var m=ma(g),q=m.next();!q.done;q=m.next())d(q.value).Ia(h,k)})};b.all=function(g){var h=ma(g),k=h.next();return k.done?d([]):new b(function(m,q){function E(Pa){return function(ja){S[Pa]=ja;Ha--;0==Ha&&m(S)}}var S=[],Ha=0;do S.push(void 0),Ha++,d(k.value).Ia(E(S.length-
	1),q),k=h.next();while(!k.done)})};return b});var p=this;function na(a){return void 0!==a}function r(a){return"string"==typeof a}var oa=/^[\w+/_-]+[=]{0,2}$/,pa=null;function qa(){}function ra(a){a.V=void 0;a.Ya=function(){return a.V?a.V:a.V=new a}}function sa(a){var b=typeof a;if("object"==b)if(a){if(a instanceof Array)return"array";if(a instanceof Object)return b;var c=Object.prototype.toString.call(a);if("[object Window]"==c)return"object";if("[object Array]"==c||"number"==typeof a.length&&"undefined"!=
	typeof a.splice&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("splice"))return"array";if("[object Function]"==c||"undefined"!=typeof a.call&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("call"))return"function"}else return"null";else if("function"==b&&"undefined"==typeof a.call)return"object";return b}function ta(a){return"array"==sa(a)}function ua(a){var b=sa(a);return"array"==b||"object"==b&&"number"==typeof a.length}function va(a){return"function"==
	sa(a)}function wa(a){var b=typeof a;return"object"==b&&null!=a||"function"==b}var xa="closure_uid_"+(1E9*Math.random()>>>0),ya=0;function za(a,b,c){return a.call.apply(a.bind,arguments)}function Aa(a,b,c){if(!a)throw Error();if(2<arguments.length){var d=Array.prototype.slice.call(arguments,2);return function(){var e=Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(e,d);return a.apply(b,e)}}return function(){return a.apply(b,arguments)}}function t(a,b,c){Function.prototype.bind&&
	-1!=Function.prototype.bind.toString().indexOf("native code")?t=za:t=Aa;return t.apply(null,arguments)}function Ba(a,b){var c=Array.prototype.slice.call(arguments,1);return function(){var d=c.slice();d.push.apply(d,arguments);return a.apply(this,d)}}function u(a,b){for(var c in b)a[c]=b[c]}var Ca=Date.now||function(){return+new Date};function v(a,b){a=a.split(".");var c=p;a[0]in c||"undefined"==typeof c.execScript||c.execScript("var "+a[0]);for(var d;a.length&&(d=a.shift());)!a.length&&na(b)?c[d]=
	b:c[d]&&c[d]!==Object.prototype[d]?c=c[d]:c=c[d]={}}function w(a,b){function c(){}c.prototype=b.prototype;a.M=b.prototype;a.prototype=new c;a.prototype.constructor=a;a.uc=function(d,e,f){for(var g=Array(arguments.length-2),h=2;h<arguments.length;h++)g[h-2]=arguments[h];return b.prototype[e].apply(d,g)}}function Da(a){if(Error.captureStackTrace)Error.captureStackTrace(this,Da);else{var b=Error().stack;b&&(this.stack=b)}a&&(this.message=String(a))}w(Da,Error);Da.prototype.name="CustomError";var Ea;
	function Fa(a,b){a=a.split("%s");for(var c="",d=a.length-1,e=0;e<d;e++)c+=a[e]+(e<b.length?b[e]:"%s");Da.call(this,c+a[d])}w(Fa,Da);Fa.prototype.name="AssertionError";function Ga(a,b){throw new Fa("Failure"+(a?": "+a:""),Array.prototype.slice.call(arguments,1));}var Ia=Array.prototype.indexOf?function(a,b){return Array.prototype.indexOf.call(a,b,void 0)}:function(a,b){if(r(a))return r(b)&&1==b.length?a.indexOf(b,0):-1;for(var c=0;c<a.length;c++)if(c in a&&a[c]===b)return c;return-1},Ja=Array.prototype.forEach?
	function(a,b,c){Array.prototype.forEach.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=r(a)?a.split(""):a,f=0;f<d;f++)f in e&&b.call(c,e[f],f,a)};function Ka(a,b){for(var c=r(a)?a.split(""):a,d=a.length-1;0<=d;--d)d in c&&b.call(void 0,c[d],d,a)}var La=Array.prototype.filter?function(a,b){return Array.prototype.filter.call(a,b,void 0)}:function(a,b){for(var c=a.length,d=[],e=0,f=r(a)?a.split(""):a,g=0;g<c;g++)if(g in f){var h=f[g];b.call(void 0,h,g,a)&&(d[e++]=h)}return d},Ma=Array.prototype.map?
	function(a,b){return Array.prototype.map.call(a,b,void 0)}:function(a,b){for(var c=a.length,d=Array(c),e=r(a)?a.split(""):a,f=0;f<c;f++)f in e&&(d[f]=b.call(void 0,e[f],f,a));return d},Na=Array.prototype.some?function(a,b){return Array.prototype.some.call(a,b,void 0)}:function(a,b){for(var c=a.length,d=r(a)?a.split(""):a,e=0;e<c;e++)if(e in d&&b.call(void 0,d[e],e,a))return!0;return!1};function Oa(a,b,c){for(var d=a.length,e=r(a)?a.split(""):a,f=0;f<d;f++)if(f in e&&b.call(c,e[f],f,a))return f;return-1}
	function Qa(a,b){return 0<=Ia(a,b)}function Ra(a,b){b=Ia(a,b);var c;(c=0<=b)&&Sa(a,b);return c}function Sa(a,b){return 1==Array.prototype.splice.call(a,b,1).length}function Ta(a,b){b=Oa(a,b,void 0);0<=b&&Sa(a,b)}function Ua(a,b){var c=0;Ka(a,function(d,e){b.call(void 0,d,e,a)&&Sa(a,e)&&c++})}function Va(a){return Array.prototype.concat.apply([],arguments)}function Wa(a){var b=a.length;if(0<b){for(var c=Array(b),d=0;d<b;d++)c[d]=a[d];return c}return[]}function Xa(a,b,c,d){return Array.prototype.splice.apply(a,
	Ya(arguments,1))}function Ya(a,b,c){return 2>=arguments.length?Array.prototype.slice.call(a,b):Array.prototype.slice.call(a,b,c)}var Za=String.prototype.trim?function(a){return a.trim()}:function(a){return/^[\s\xa0]*([\s\S]*?)[\s\xa0]*$/.exec(a)[1]},$a=/&/g,ab=/</g,bb=/>/g,cb=/"/g,db=/'/g,eb=/\x00/g,fb=/[\x00&<>"']/;function gb(a,b){return a<b?-1:a>b?1:0}function hb(a){fb.test(a)&&(-1!=a.indexOf("&")&&(a=a.replace($a,"&amp;")),-1!=a.indexOf("<")&&(a=a.replace(ab,"&lt;")),-1!=a.indexOf(">")&&(a=a.replace(bb,
	"&gt;")),-1!=a.indexOf('"')&&(a=a.replace(cb,"&quot;")),-1!=a.indexOf("'")&&(a=a.replace(db,"&#39;")),-1!=a.indexOf("\x00")&&(a=a.replace(eb,"&#0;")));return a}function ib(a,b,c){for(var d in a)b.call(c,a[d],d,a)}function jb(a){var b={},c;for(c in a)b[c]=a[c];return b}var kb="constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");function lb(a,b){for(var c,d,e=1;e<arguments.length;e++){d=arguments[e];for(c in d)a[c]=d[c];for(var f=0;f<kb.length;f++)c=
	kb[f],Object.prototype.hasOwnProperty.call(d,c)&&(a[c]=d[c])}}var mb="StopIteration"in p?p.StopIteration:{message:"StopIteration",stack:""};function nb(){}nb.prototype.next=function(){throw mb;};nb.prototype.ha=function(){return this};function ob(a){if(a instanceof nb)return a;if("function"==typeof a.ha)return a.ha(!1);if(ua(a)){var b=0,c=new nb;c.next=function(){for(;;){if(b>=a.length)throw mb;if(b in a)return a[b++];b++}};return c}throw Error("Not implemented");}function pb(a,b){if(ua(a))try{Ja(a,
	b,void 0)}catch(c){if(c!==mb)throw c;}else{a=ob(a);try{for(;;)b.call(void 0,a.next(),void 0,a)}catch(c$1){if(c$1!==mb)throw c$1;}}}function qb(a){if(ua(a))return Wa(a);a=ob(a);var b=[];pb(a,function(c){b.push(c)});return b}function rb(a,b){this.f={};this.a=[];this.j=this.h=0;var c=arguments.length;if(1<c){if(c%2)throw Error("Uneven number of arguments");for(var d=0;d<c;d+=2)this.set(arguments[d],arguments[d+1])}else if(a)if(a instanceof rb)for(c=a.ja(),d=0;d<c.length;d++)this.set(c[d],a.get(c[d]));
	else for(d in a)this.set(d,a[d])}l=rb.prototype;l.la=function(){sb(this);for(var a=[],b=0;b<this.a.length;b++)a.push(this.f[this.a[b]]);return a};l.ja=function(){sb(this);return this.a.concat()};l.clear=function(){this.f={};this.j=this.h=this.a.length=0};function sb(a){if(a.h!=a.a.length){for(var b=0,c=0;b<a.a.length;){var d=a.a[b];tb(a.f,d)&&(a.a[c++]=d);b++}a.a.length=c}if(a.h!=a.a.length){var e={};for(c=b=0;b<a.a.length;)d=a.a[b],tb(e,d)||(a.a[c++]=d,e[d]=1),b++;a.a.length=c}}l.get=function(a,
	b){return tb(this.f,a)?this.f[a]:b};l.set=function(a,b){tb(this.f,a)||(this.h++,this.a.push(a),this.j++);this.f[a]=b};l.forEach=function(a,b){for(var c=this.ja(),d=0;d<c.length;d++){var e=c[d],f=this.get(e);a.call(b,f,e,this)}};l.ha=function(a){sb(this);var b=0,c=this.j,d=this,e=new nb;e.next=function(){if(c!=d.j)throw Error("The map has changed since the iterator was created");if(b>=d.a.length)throw mb;var f=d.a[b++];return a?f:d.f[f]};return e};function tb(a,b){return Object.prototype.hasOwnProperty.call(a,
	b)}var ub=/^(?:([^:/?#.]+):)?(?:\/\/(?:([^/?#]*)@)?([^/#?]*?)(?::([0-9]+))?(?=[/#?]|$))?([^?#]+)?(?:\?([^#]*))?(?:#([\s\S]*))?$/;function vb(a,b){if(a){a=a.split("&");for(var c=0;c<a.length;c++){var d=a[c].indexOf("="),e=null;if(0<=d){var f=a[c].substring(0,d);e=a[c].substring(d+1)}else f=a[c];b(f,e?decodeURIComponent(e.replace(/\+/g," ")):"")}}}function wb(a,b,c,d){for(var e=c.length;0<=(b=a.indexOf(c,b))&&b<d;){var f=a.charCodeAt(b-1);if(38==f||63==f)if(f=a.charCodeAt(b+e),!f||61==f||38==f||35==
	f)return b;b+=e+1}return-1}var xb=/#|$/;function yb(a,b){var c=a.search(xb),d=wb(a,0,b,c);if(0>d)return null;var e=a.indexOf("&",d);if(0>e||e>c)e=c;d+=b.length+1;return decodeURIComponent(a.substr(d,e-d).replace(/\+/g," "))}var zb=/[?&]($|#)/;function Ab(a,b){this.h=this.w=this.j="";this.C=null;this.s=this.f="";this.i=!1;var c;a instanceof Ab?(this.i=na(b)?b:a.i,Bb(this,a.j),this.w=a.w,this.h=a.h,Cb(this,a.C),this.f=a.f,Db(this,Eb(a.a)),this.s=a.s):a&&(c=String(a).match(ub))?(this.i=!!b,Bb(this,c[1]||
	"",!0),this.w=Fb(c[2]||""),this.h=Fb(c[3]||"",!0),Cb(this,c[4]),this.f=Fb(c[5]||"",!0),Db(this,c[6]||"",!0),this.s=Fb(c[7]||"")):(this.i=!!b,this.a=new Gb(null,this.i))}Ab.prototype.toString=function(){var a=[],b=this.j;b&&a.push(Hb(b,Ib,!0),":");var c=this.h;if(c||"file"==b)a.push("//"),(b=this.w)&&a.push(Hb(b,Ib,!0),"@"),a.push(encodeURIComponent(String(c)).replace(/%25([0-9a-fA-F]{2})/g,"%$1")),c=this.C,null!=c&&a.push(":",String(c));if(c=this.f)this.h&&"/"!=c.charAt(0)&&a.push("/"),a.push(Hb(c,
	"/"==c.charAt(0)?Jb:Kb,!0));(c=this.a.toString())&&a.push("?",c);(c=this.s)&&a.push("#",Hb(c,Lb));return a.join("")};Ab.prototype.resolve=function(a){var b=new Ab(this),c=!!a.j;c?Bb(b,a.j):c=!!a.w;c?b.w=a.w:c=!!a.h;c?b.h=a.h:c=null!=a.C;var d=a.f;if(c)Cb(b,a.C);else if(c=!!a.f){if("/"!=d.charAt(0))if(this.h&&!this.f)d="/"+d;else{var e=b.f.lastIndexOf("/");-1!=e&&(d=b.f.substr(0,e+1)+d)}e=d;if(".."==e||"."==e)d="";else if(-1!=e.indexOf("./")||-1!=e.indexOf("/.")){d=0==e.lastIndexOf("/",0);e=e.split("/");
	for(var f=[],g=0;g<e.length;){var h=e[g++];"."==h?d&&g==e.length&&f.push(""):".."==h?((1<f.length||1==f.length&&""!=f[0])&&f.pop(),d&&g==e.length&&f.push("")):(f.push(h),d=!0)}d=f.join("/")}else d=e}c?b.f=d:c=""!==a.a.toString();c?Db(b,Eb(a.a)):c=!!a.s;c&&(b.s=a.s);return b};function Bb(a,b,c){a.j=c?Fb(b,!0):b;a.j&&(a.j=a.j.replace(/:$/,""))}function Cb(a,b){if(b){b=Number(b);if(isNaN(b)||0>b)throw Error("Bad port number "+b);a.C=b}else a.C=null}function Db(a,b,c){b instanceof Gb?(a.a=b,Mb(a.a,a.i)):
	(c||(b=Hb(b,Nb)),a.a=new Gb(b,a.i))}function Ob(a){return a instanceof Ab?new Ab(a):new Ab(a,void 0)}function Pb(a,b){a instanceof Ab||(a=Ob(a));b instanceof Ab||(b=Ob(b));return a.resolve(b)}function Fb(a,b){return a?b?decodeURI(a.replace(/%25/g,"%2525")):decodeURIComponent(a):""}function Hb(a,b,c){return r(a)?(a=encodeURI(a).replace(b,Qb),c&&(a=a.replace(/%25([0-9a-fA-F]{2})/g,"%$1")),a):null}function Qb(a){a=a.charCodeAt(0);return"%"+(a>>4&15).toString(16)+(a&15).toString(16)}var Ib=/[#\/\?@]/g,
	Kb=/[#\?:]/g,Jb=/[#\?]/g,Nb=/[#\?@]/g,Lb=/#/g;function Gb(a,b){this.f=this.a=null;this.h=a||null;this.j=!!b}function Rb(a){a.a||(a.a=new rb,a.f=0,a.h&&vb(a.h,function(b,c){a.add(decodeURIComponent(b.replace(/\+/g," ")),c)}))}l=Gb.prototype;l.add=function(a,b){Rb(this);this.h=null;a=Sb(this,a);var c=this.a.get(a);c||this.a.set(a,c=[]);c.push(b);this.f+=1;return this};function Tb(a,b){Rb(a);b=Sb(a,b);tb(a.a.f,b)&&(a.h=null,a.f-=a.a.get(b).length,a=a.a,tb(a.f,b)&&(delete a.f[b],a.h--,a.j++,a.a.length>
	2*a.h&&sb(a)))}l.clear=function(){this.a=this.h=null;this.f=0};function Ub(a,b){Rb(a);b=Sb(a,b);return tb(a.a.f,b)}l.forEach=function(a,b){Rb(this);this.a.forEach(function(c,d){Ja(c,function(e){a.call(b,e,d,this)},this)},this)};l.ja=function(){Rb(this);for(var a=this.a.la(),b=this.a.ja(),c=[],d=0;d<b.length;d++)for(var e=a[d],f=0;f<e.length;f++)c.push(b[d]);return c};l.la=function(a){Rb(this);var b=[];if(r(a))Ub(this,a)&&(b=Va(b,this.a.get(Sb(this,a))));else{a=this.a.la();for(var c=0;c<a.length;c++)b=
	Va(b,a[c])}return b};l.set=function(a,b){Rb(this);this.h=null;a=Sb(this,a);Ub(this,a)&&(this.f-=this.a.get(a).length);this.a.set(a,[b]);this.f+=1;return this};l.get=function(a,b){if(!a)return b;a=this.la(a);return 0<a.length?String(a[0]):b};l.toString=function(){if(this.h)return this.h;if(!this.a)return"";for(var a=[],b=this.a.ja(),c=0;c<b.length;c++){var d=b[c],e=encodeURIComponent(String(d));d=this.la(d);for(var f=0;f<d.length;f++){var g=e;""!==d[f]&&(g+="="+encodeURIComponent(String(d[f])));a.push(g)}}return this.h=
	a.join("&")};function Eb(a){var b=new Gb;b.h=a.h;a.a&&(b.a=new rb(a.a),b.f=a.f);return b}function Sb(a,b){b=String(b);a.j&&(b=b.toLowerCase());return b}function Mb(a,b){b&&!a.j&&(Rb(a),a.h=null,a.a.forEach(function(c,d){var e=d.toLowerCase();d!=e&&(Tb(this,d),Tb(this,e),0<c.length&&(this.h=null,this.a.set(Sb(this,e),Wa(c)),this.f+=c.length))},a));a.j=b}function Vb(a){this.a=Ob(a)}function Wb(a,b){b?a.a.a.set(x.Ta,b):Tb(a.a.a,x.Ta)}function Xb(a,b){null!==b?a.a.a.set(x.Ra,b?"1":"0"):Tb(a.a.a,x.Ra)}
	function Yb(a){return a.a.a.get(x.Qa)||null}function Zb(a,b){b?a.a.a.set(x.PROVIDER_ID,b):Tb(a.a.a,x.PROVIDER_ID)}Vb.prototype.toString=function(){return this.a.toString()};var x={Qa:"ui_auid",kc:"apiKey",Ra:"ui_sd",wb:"mode",ab:"oobCode",PROVIDER_ID:"ui_pid",Ta:"ui_sid",xb:"tenantId"};var $b;a:{var ac=p.navigator;if(ac){var bc=ac.userAgent;if(bc){$b=bc;break a}}$b=""}function y(a){return-1!=$b.indexOf(a)}function cc(){return(y("Chrome")||y("CriOS"))&&!y("Edge")}function dc(a){dc[" "](a);return a}
	dc[" "]=qa;function ec(a,b){var c=fc;return Object.prototype.hasOwnProperty.call(c,a)?c[a]:c[a]=b(a)}var gc=y("Opera"),z=y("Trident")||y("MSIE"),hc=y("Edge"),ic=hc||z,jc=y("Gecko")&&!(-1!=$b.toLowerCase().indexOf("webkit")&&!y("Edge"))&&!(y("Trident")||y("MSIE"))&&!y("Edge"),kc=-1!=$b.toLowerCase().indexOf("webkit")&&!y("Edge"),lc=kc&&y("Mobile"),mc=y("Macintosh");function nc(){var a=p.document;return a?a.documentMode:void 0}var oc;a:{var pc="",qc=function(){var a=$b;if(jc)return/rv:([^\);]+)(\)|;)/.exec(a);
	if(hc)return/Edge\/([\d\.]+)/.exec(a);if(z)return/\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(a);if(kc)return/WebKit\/(\S+)/.exec(a);if(gc)return/(?:Version)[ \/]?(\S+)/.exec(a)}();qc&&(pc=qc?qc[1]:"");if(z){var rc=nc();if(null!=rc&&rc>parseFloat(pc)){oc=String(rc);break a}}oc=pc}var fc={};function sc(a){return ec(a,function(){for(var b=0,c=Za(String(oc)).split("."),d=Za(String(a)).split("."),e=Math.max(c.length,d.length),f=0;0==b&&f<e;f++){var g=c[f]||"",h=d[f]||"";do{g=/(\d*)(\D*)(.*)/.exec(g)||["",
	"","",""];h=/(\d*)(\D*)(.*)/.exec(h)||["","","",""];if(0==g[0].length&&0==h[0].length)break;b=gb(0==g[1].length?0:parseInt(g[1],10),0==h[1].length?0:parseInt(h[1],10))||gb(0==g[2].length,0==h[2].length)||gb(g[2],h[2]);g=g[3];h=h[3]}while(0==b)}return 0<=b})}var tc;var uc=p.document;tc=uc&&z?nc()||("CSS1Compat"==uc.compatMode?parseInt(oc,10):5):void 0;function vc(a,b){this.a=a===wc&&b||"";this.f=xc}vc.prototype.ma=!0;vc.prototype.ka=function(){return this.a};vc.prototype.toString=function(){return"Const{"+
	this.a+"}"};function yc(a){if(a instanceof vc&&a.constructor===vc&&a.f===xc)return a.a;Ga("expected object of type Const, got '"+a+"'");return"type_error:Const"}var xc={},wc={};function zc(){this.a="";this.h=Ac}zc.prototype.ma=!0;zc.prototype.ka=function(){return this.a.toString()};zc.prototype.f=function(){return 1};zc.prototype.toString=function(){return"TrustedResourceUrl{"+this.a+"}"};function Bc(a){if(a instanceof zc&&a.constructor===zc&&a.h===Ac)return a.a;Ga("expected object of type TrustedResourceUrl, got '"+
	a+"' of type "+sa(a));return"type_error:TrustedResourceUrl"}var Ac={};function Cc(a){var b=new zc;b.a=a;return b}function Dc(){this.a="";this.h=Ec}Dc.prototype.ma=!0;Dc.prototype.ka=function(){return this.a.toString()};Dc.prototype.f=function(){return 1};Dc.prototype.toString=function(){return"SafeUrl{"+this.a+"}"};function Fc(a){return Gc(a).toString()}function Gc(a){if(a instanceof Dc&&a.constructor===Dc&&a.h===Ec)return a.a;Ga("expected object of type SafeUrl, got '"+a+"' of type "+sa(a));return"type_error:SafeUrl"}
	var Hc=/^(?:(?:https?|mailto|ftp):|[^:/?#]*(?:[/?#]|$))/i;function Ic(a){if(a instanceof Dc)return a;a="object"==typeof a&&a.ma?a.ka():String(a);Hc.test(a)||(a="about:invalid#zClosurez");return Jc(a)}var Ec={};function Jc(a){var b=new Dc;b.a=a;return b}Jc("about:blank");function Kc(){this.a="";this.f=Lc}Kc.prototype.ma=!0;var Lc={};Kc.prototype.ka=function(){return this.a};Kc.prototype.toString=function(){return"SafeStyle{"+this.a+"}"};function Mc(){this.a="";this.j=Nc;this.h=null}Mc.prototype.f=
	function(){return this.h};Mc.prototype.ma=!0;Mc.prototype.ka=function(){return this.a.toString()};Mc.prototype.toString=function(){return"SafeHtml{"+this.a+"}"};function Oc(a){if(a instanceof Mc&&a.constructor===Mc&&a.j===Nc)return a.a;Ga("expected object of type SafeHtml, got '"+a+"' of type "+sa(a));return"type_error:SafeHtml"}var Nc={};function Pc(a,b){var c=new Mc;c.a=a;c.h=b;return c}Pc("<!DOCTYPE html>",0);var Qc=Pc("",0);Pc("<br>",0);var Rc=function(a){var b=!1,c;return function(){b||(c=a(),
	b=!0);return c}}(function(){if("undefined"===typeof document)return!1;var a=document.createElement("div"),b=document.createElement("div");b.appendChild(document.createElement("div"));a.appendChild(b);if(!a.firstChild)return!1;b=a.firstChild.firstChild;a.innerHTML=Oc(Qc);return!b.parentElement});function Sc(a,b){a.src=Bc(b);if(null===pa)b:{b=p.document;if((b=b.querySelector&&b.querySelector("script[nonce]"))&&(b=b.nonce||b.getAttribute("nonce"))&&oa.test(b)){pa=b;break b}pa=""}b=pa;b&&a.setAttribute("nonce",
	b)}function Tc(a,b){this.a=na(a)?a:0;this.f=na(b)?b:0}Tc.prototype.toString=function(){return"("+this.a+", "+this.f+")"};Tc.prototype.ceil=function(){this.a=Math.ceil(this.a);this.f=Math.ceil(this.f);return this};Tc.prototype.floor=function(){this.a=Math.floor(this.a);this.f=Math.floor(this.f);return this};Tc.prototype.round=function(){this.a=Math.round(this.a);this.f=Math.round(this.f);return this};function Uc(a,b){this.width=a;this.height=b}l=Uc.prototype;l.toString=function(){return"("+this.width+
	" x "+this.height+")"};l.aspectRatio=function(){return this.width/this.height};l.ceil=function(){this.width=Math.ceil(this.width);this.height=Math.ceil(this.height);return this};l.floor=function(){this.width=Math.floor(this.width);this.height=Math.floor(this.height);return this};l.round=function(){this.width=Math.round(this.width);this.height=Math.round(this.height);return this};function Vc(a){return a?new Wc(Xc(a)):Ea||(Ea=new Wc)}function Yc(a,b){var c=b||document;return c.querySelectorAll&&c.querySelector?
	c.querySelectorAll("."+a):Zc(document,a,b)}function $c(a,b){var c=b||document;if(c.getElementsByClassName)a=c.getElementsByClassName(a)[0];else{c=document;var d=b||c;a=d.querySelectorAll&&d.querySelector&&a?d.querySelector(a?"."+a:""):Zc(c,a,b)[0]||null}return a||null}function Zc(a,b,c){var d;a=c||a;if(a.querySelectorAll&&a.querySelector&&b)return a.querySelectorAll(b?"."+b:"");if(b&&a.getElementsByClassName){var e=a.getElementsByClassName(b);return e}e=a.getElementsByTagName("*");if(b){var f={};
	for(c=d=0;a=e[c];c++){var g=a.className;"function"==typeof g.split&&Qa(g.split(/\s+/),b)&&(f[d++]=a)}f.length=d;return f}return e}function ad(a,b){ib(b,function(c,d){c&&"object"==typeof c&&c.ma&&(c=c.ka());"style"==d?a.style.cssText=c:"class"==d?a.className=c:"for"==d?a.htmlFor=c:bd.hasOwnProperty(d)?a.setAttribute(bd[d],c):0==d.lastIndexOf("aria-",0)||0==d.lastIndexOf("data-",0)?a.setAttribute(d,c):a[d]=c})}var bd={cellpadding:"cellPadding",cellspacing:"cellSpacing",colspan:"colSpan",frameborder:"frameBorder",
	height:"height",maxlength:"maxLength",nonce:"nonce",role:"role",rowspan:"rowSpan",type:"type",usemap:"useMap",valign:"vAlign",width:"width"};function cd(a){return a.scrollingElement?a.scrollingElement:kc||"CSS1Compat"!=a.compatMode?a.body||a.documentElement:a.documentElement}function dd(a){a&&a.parentNode&&a.parentNode.removeChild(a)}function Xc(a){return 9==a.nodeType?a:a.ownerDocument||a.document}function ed(a,b){if("textContent"in a)a.textContent=b;else if(3==a.nodeType)a.data=String(b);else if(a.firstChild&&
	3==a.firstChild.nodeType){for(;a.lastChild!=a.firstChild;)a.removeChild(a.lastChild);a.firstChild.data=String(b)}else{for(var c;c=a.firstChild;)a.removeChild(c);a.appendChild(Xc(a).createTextNode(String(b)))}}function fd(a,b){return b?gd(a,function(c){return!b||r(c.className)&&Qa(c.className.split(/\s+/),b)}):null}function gd(a,b){for(var c=0;a;){if(b(a))return a;a=a.parentNode;c++}return null}function Wc(a){this.a=a||p.document||document}Wc.prototype.R=function(){return r(void 0)?this.a.getElementById(void 0):
	void 0};var hd={Ec:!0},id={Gc:!0},jd={Dc:!0},kd={Fc:!0};function ld(){throw Error("Do not instantiate directly");}ld.prototype.va=null;ld.prototype.toString=function(){return this.content};function md(a,b,c,d){a=a(b||nd,void 0,c);d=(d||Vc()).a.createElement("DIV");a=od(a);a.match(pd);a=Pc(a,null);if(Rc())for(;d.lastChild;)d.removeChild(d.lastChild);d.innerHTML=Oc(a);1==d.childNodes.length&&(a=d.firstChild,1==a.nodeType&&(d=a));return d}function od(a){if(!wa(a))return hb(String(a));if(a instanceof
	ld){if(a.fa===hd)return a.content;if(a.fa===kd)return hb(a.content)}Ga("Soy template output is unsafe for use as HTML: "+a);return"zSoyz"}var pd=/^<(body|caption|col|colgroup|head|html|tr|td|th|tbody|thead|tfoot)>/i,nd={};function qd(a){if(null!=a)switch(a.va){case 1:return 1;case -1:return-1;case 0:return 0}return null}function rd(){ld.call(this)}w(rd,ld);rd.prototype.fa=hd;function A(a){return null!=a&&a.fa===hd?a:a instanceof Mc?B(Oc(a).toString(),a.f()):B(hb(String(String(a))),qd(a))}function sd(){ld.call(this)}
	w(sd,ld);sd.prototype.fa=id;sd.prototype.va=1;function ud(a,b){this.content=String(a);this.va=null!=b?b:null}w(ud,ld);ud.prototype.fa=kd;function C(a){return new ud(a,void 0)}var B=function(a){function b(c){this.content=c}b.prototype=a.prototype;return function(c,d){c=new b(String(c));void 0!==d&&(c.va=d);return c}}(rd),vd=function(a){function b(c){this.content=c}b.prototype=a.prototype;return function(c){return new b(String(c))}}(sd);function wd(a){function b(){}var c={label:D("New password")};b.prototype=
	a;a=new b;for(var d in c)a[d]=c[d];return a}function D(a){return(a=String(a))?new ud(a,void 0):""}var xd=function(a){function b(c){this.content=c}b.prototype=a.prototype;return function(c,d){c=String(c);if(!c)return"";c=new b(c);void 0!==d&&(c.va=d);return c}}(rd);function yd(a){return null!=a&&a.fa===hd?String(String(a.content).replace(zd,"").replace(Ad,"&lt;")).replace(Bd,Cd):hb(String(a))}function Dd(a){null!=a&&a.fa===id?a=String(a).replace(Ed,Fd):a instanceof Dc?a=String(Fc(a)).replace(Ed,Fd):
	(a=String(a),Gd.test(a)?a=a.replace(Ed,Fd):(Ga("Bad value `%s` for |filterNormalizeUri",[a]),a="#zSoyz"));return a}function Hd(a){null!=a&&a.fa===jd?a=a.content:null==a?a="":a instanceof Kc?a instanceof Kc&&a.constructor===Kc&&a.f===Lc?a=a.a:(Ga("expected object of type SafeStyle, got '"+a+"' of type "+sa(a)),a="type_error:SafeStyle"):(a=String(a),Id.test(a)||(Ga("Bad value `%s` for |filterCssValue",[a]),a="zSoyz"));return a}var Jd={"\x00":"&#0;","\t":"&#9;","\n":"&#10;","\x0B":"&#11;","\f":"&#12;",
	"\r":"&#13;"," ":"&#32;",'"':"&quot;","&":"&amp;","'":"&#39;","-":"&#45;","/":"&#47;","<":"&lt;","=":"&#61;",">":"&gt;","`":"&#96;","\u0085":"&#133;","\u00a0":"&#160;","\u2028":"&#8232;","\u2029":"&#8233;"};function Cd(a){return Jd[a]}var Kd={"\x00":"%00","\u0001":"%01","\u0002":"%02","\u0003":"%03","\u0004":"%04","\u0005":"%05","\u0006":"%06","\u0007":"%07","\b":"%08","\t":"%09","\n":"%0A","\x0B":"%0B","\f":"%0C","\r":"%0D","\u000e":"%0E","\u000f":"%0F","\u0010":"%10","\u0011":"%11","\u0012":"%12",
	"\u0013":"%13","\u0014":"%14","\u0015":"%15","\u0016":"%16","\u0017":"%17","\u0018":"%18","\u0019":"%19","\u001a":"%1A","\u001b":"%1B","\u001c":"%1C","\u001d":"%1D","\u001e":"%1E","\u001f":"%1F"," ":"%20",'"':"%22","'":"%27","(":"%28",")":"%29","<":"%3C",">":"%3E","\\":"%5C","{":"%7B","}":"%7D","\u007f":"%7F","\u0085":"%C2%85","\u00a0":"%C2%A0","\u2028":"%E2%80%A8","\u2029":"%E2%80%A9","\uff01":"%EF%BC%81","\uff03":"%EF%BC%83","\uff04":"%EF%BC%84","\uff06":"%EF%BC%86","\uff07":"%EF%BC%87","\uff08":"%EF%BC%88",
	"\uff09":"%EF%BC%89","\uff0a":"%EF%BC%8A","\uff0b":"%EF%BC%8B","\uff0c":"%EF%BC%8C","\uff0f":"%EF%BC%8F","\uff1a":"%EF%BC%9A","\uff1b":"%EF%BC%9B","\uff1d":"%EF%BC%9D","\uff1f":"%EF%BC%9F","\uff20":"%EF%BC%A0","\uff3b":"%EF%BC%BB","\uff3d":"%EF%BC%BD"};function Fd(a){return Kd[a]}var Bd=/[\x00\x22\x27\x3c\x3e]/g,Ed=/[\x00- \x22\x27-\x29\x3c\x3e\\\x7b\x7d\x7f\x85\xa0\u2028\u2029\uff01\uff03\uff04\uff06-\uff0c\uff0f\uff1a\uff1b\uff1d\uff1f\uff20\uff3b\uff3d]/g,Id=/^(?!-*(?:expression|(?:moz-)?binding))(?:[.#]?-?(?:[_a-z0-9-]+)(?:-[_a-z0-9-]+)*-?|-?(?:[0-9]+(?:\.[0-9]*)?|\.[0-9]+)(?:[a-z]{1,2}|%)?|!important|)$/i,
	Gd=/^(?![^#?]*\/(?:\.|%2E){2}(?:[\/?#]|$))(?:(?:https?|mailto):|[^&:\/?#]*(?:[\/?#]|$))/i,zd=/<(?:!|\/?([a-zA-Z][a-zA-Z0-9:\-]*))(?:[^>'"]|"[^"]*"|'[^']*')*>/g,Ad=/</g;function Ld(){return C("Enter a valid phone number")}function Md(){return C("Unable to send password reset code to specified email")}function Nd(){return C("Something went wrong. Please try again.")}function Od(){return C("This email already exists without any means of sign-in. Please reset the password to recover.")}function Pd(a){a=
	a||{};var b="";switch(a.code){case "invalid-argument":b+="Client specified an invalid argument.";break;case "invalid-configuration":b+="Client specified an invalid project configuration.";break;case "failed-precondition":b+="Request can not be executed in the current system state.";break;case "out-of-range":b+="Client specified an invalid range.";break;case "unauthenticated":b+="Request not authenticated due to missing, invalid, or expired OAuth token.";break;case "permission-denied":b+="Client does not have sufficient permission.";
	break;case "not-found":b+="Specified resource is not found.";break;case "aborted":b+="Concurrency conflict, such as read-modify-write conflict.";break;case "already-exists":b+="The resource that a client tried to create already exists.";break;case "resource-exhausted":b+="Either out of resource quota or reaching rate limiting.";break;case "cancelled":b+="Request cancelled by the client.";break;case "data-loss":b+="Unrecoverable data loss or data corruption.";break;case "unknown":b+="Unknown server error.";
	break;case "internal":b+="Internal server error.";break;case "not-implemented":b+="API method not implemented by the server.";break;case "unavailable":b+="Service unavailable.";break;case "deadline-exceeded":b+="Request deadline exceeded.";break;case "auth/user-disabled":b+="The user account has been disabled by an administrator.";break;case "auth/timeout":b+="The operation has timed out.";break;case "auth/too-many-requests":b+="We have blocked all requests from this device due to unusual activity. Try again later.";
	break;case "auth/quota-exceeded":b+="The quota for this operation has been exceeded. Try again later.";break;case "auth/network-request-failed":b+="A network error has occurred. Try again later.";break;case "restart-process":b+="An issue was encountered when authenticating your request. Please visit the URL that redirected you to this page again to restart the authentication process.";break;case "no-matching-tenant-for-email":b+="No sign-in provider is available for the given email, please try with a different email."}return C(b)}
	function Qd(){return C("Please login again to perform this operation")}function Rd(a,b,c){var d=Error.call(this);this.message=d.message;"stack"in d&&(this.stack=d.stack);this.code=Sd+a;if(!(a=b)){a="";switch(this.code){case "firebaseui/merge-conflict":a+="The current anonymous user failed to upgrade. The non-anonymous credential is already associated with a different user account.";break;default:a+=Nd()}a=C(a).toString()}this.message=a||"";this.credential=c||null}n(Rd,Error);Rd.prototype.aa=function(){return{code:this.code,
	message:this.message}};Rd.prototype.toJSON=function(){return this.aa()};var Sd="firebaseui/";function Td(){0!=Ud&&(Vd[this[xa]||(this[xa]=++ya)]=this);this.O=this.O;this.C=this.C}var Ud=0,Vd={};Td.prototype.O=!1;Td.prototype.o=function(){if(!this.O&&(this.O=!0,this.m(),0!=Ud)){var a=this[xa]||(this[xa]=++ya);if(0!=Ud&&this.C&&0<this.C.length)throw Error(this+" did not empty its onDisposeCallbacks queue. This probably means it overrode dispose() or disposeInternal() without calling the superclass' method.");
	delete Vd[a]}};function Wd(a,b){a.O?na(void 0)?b.call(void 0):b():(a.C||(a.C=[]),a.C.push(na(void 0)?t(b,void 0):b))}Td.prototype.m=function(){if(this.C)for(;this.C.length;)this.C.shift()()};function Xd(a){a&&"function"==typeof a.o&&a.o()}var Yd=Object.freeze||function(a){return a};var Zd=!z||9<=Number(tc),$d=z&&!sc("9"),ae=function(){if(!p.addEventListener||!Object.defineProperty)return!1;var a=!1,b=Object.defineProperty({},"passive",{get:function(){a=!0}});try{p.addEventListener("test",qa,b),p.removeEventListener("test",
	qa,b)}catch(c){}return a}();function be(a,b){this.type=a;this.f=this.target=b;this.h=!1;this.sb=!0}be.prototype.stopPropagation=function(){this.h=!0};be.prototype.preventDefault=function(){this.sb=!1};function ce(a,b){be.call(this,a?a.type:"");this.relatedTarget=this.f=this.target=null;this.button=this.screenY=this.screenX=this.clientY=this.clientX=0;this.key="";this.j=this.keyCode=0;this.metaKey=this.shiftKey=this.altKey=this.ctrlKey=!1;this.pointerId=0;this.pointerType="";this.a=null;if(a){var c=
	this.type=a.type,d=a.changedTouches&&a.changedTouches.length?a.changedTouches[0]:null;this.target=a.target||a.srcElement;this.f=b;if(b=a.relatedTarget){if(jc){a:{try{dc(b.nodeName);var e=!0;break a}catch(f){}e=!1}e||(b=null)}}else"mouseover"==c?b=a.fromElement:"mouseout"==c&&(b=a.toElement);this.relatedTarget=b;d?(this.clientX=void 0!==d.clientX?d.clientX:d.pageX,this.clientY=void 0!==d.clientY?d.clientY:d.pageY,this.screenX=d.screenX||0,this.screenY=d.screenY||0):(this.clientX=void 0!==a.clientX?
	a.clientX:a.pageX,this.clientY=void 0!==a.clientY?a.clientY:a.pageY,this.screenX=a.screenX||0,this.screenY=a.screenY||0);this.button=a.button;this.keyCode=a.keyCode||0;this.key=a.key||"";this.j=a.charCode||("keypress"==c?a.keyCode:0);this.ctrlKey=a.ctrlKey;this.altKey=a.altKey;this.shiftKey=a.shiftKey;this.metaKey=a.metaKey;this.pointerId=a.pointerId||0;this.pointerType=r(a.pointerType)?a.pointerType:de[a.pointerType]||"";this.a=a;a.defaultPrevented&&this.preventDefault()}}w(ce,be);var de=Yd({2:"touch",
	3:"pen",4:"mouse"});ce.prototype.stopPropagation=function(){ce.M.stopPropagation.call(this);this.a.stopPropagation?this.a.stopPropagation():this.a.cancelBubble=!0};ce.prototype.preventDefault=function(){ce.M.preventDefault.call(this);var a=this.a;if(a.preventDefault)a.preventDefault();else if(a.returnValue=!1,$d)try{if(a.ctrlKey||112<=a.keyCode&&123>=a.keyCode)a.keyCode=-1}catch(b){}};var ee="closure_listenable_"+(1E6*Math.random()|0),fe=0;function ge(a,b,c,d,e){this.listener=a;this.proxy=null;this.src=
	b;this.type=c;this.capture=!!d;this.La=e;this.key=++fe;this.sa=this.Ha=!1}function he(a){a.sa=!0;a.listener=null;a.proxy=null;a.src=null;a.La=null}function ie(a){this.src=a;this.a={};this.f=0}ie.prototype.add=function(a,b,c,d,e){var f=a.toString();a=this.a[f];a||(a=this.a[f]=[],this.f++);var g=je(a,b,d,e);-1<g?(b=a[g],c||(b.Ha=!1)):(b=new ge(b,this.src,f,!!d,e),b.Ha=c,a.push(b));return b};function ke(a,b){var c=b.type;c in a.a&&Ra(a.a[c],b)&&(he(b),0==a.a[c].length&&(delete a.a[c],a.f--))}function je(a,
	b,c,d){for(var e=0;e<a.length;++e){var f=a[e];if(!f.sa&&f.listener==b&&f.capture==!!c&&f.La==d)return e}return-1}var le="closure_lm_"+(1E6*Math.random()|0),me={},ne=0;function oe(a,b,c,d,e){if(d&&d.once)return pe(a,b,c,d,e);if(ta(b)){for(var f=0;f<b.length;f++)oe(a,b[f],c,d,e);return null}c=qe(c);return a&&a[ee]?a.I.add(String(b),c,!1,wa(d)?!!d.capture:!!d,e):re(a,b,c,!1,d,e)}function re(a,b,c,d,e,f){if(!b)throw Error("Invalid event type");var g=wa(e)?!!e.capture:!!e,h=se(a);h||(a[le]=h=new ie(a));
	c=h.add(b,c,d,g,f);if(c.proxy)return c;d=te();c.proxy=d;d.src=a;d.listener=c;if(a.addEventListener)ae||(e=g),void 0===e&&(e=!1),a.addEventListener(b.toString(),d,e);else if(a.attachEvent)a.attachEvent(ue(b.toString()),d);else if(a.addListener&&a.removeListener)a.addListener(d);else throw Error("addEventListener and attachEvent are unavailable.");ne++;return c}function te(){var a=ve,b=Zd?function(c){return a.call(b.src,b.listener,c)}:function(c){c=a.call(b.src,b.listener,c);if(!c)return c};return b}
	function pe(a,b,c,d,e){if(ta(b)){for(var f=0;f<b.length;f++)pe(a,b[f],c,d,e);return null}c=qe(c);return a&&a[ee]?a.I.add(String(b),c,!0,wa(d)?!!d.capture:!!d,e):re(a,b,c,!0,d,e)}function we(a,b,c,d,e){if(ta(b))for(var f=0;f<b.length;f++)we(a,b[f],c,d,e);else(d=wa(d)?!!d.capture:!!d,c=qe(c),a&&a[ee])?(a=a.I,b=String(b).toString(),b in a.a&&(f=a.a[b],c=je(f,c,d,e),-1<c&&(he(f[c]),Sa(f,c),0==f.length&&(delete a.a[b],a.f--)))):a&&(a=se(a))&&(b=a.a[b.toString()],a=-1,b&&(a=je(b,c,d,e)),(c=-1<a?b[a]:null)&&
	xe(c))}function xe(a){if("number"!=typeof a&&a&&!a.sa){var b=a.src;if(b&&b[ee])ke(b.I,a);else{var c=a.type,d=a.proxy;b.removeEventListener?b.removeEventListener(c,d,a.capture):b.detachEvent?b.detachEvent(ue(c),d):b.addListener&&b.removeListener&&b.removeListener(d);ne--;(c=se(b))?(ke(c,a),0==c.f&&(c.src=null,b[le]=null)):he(a)}}}function ue(a){return a in me?me[a]:me[a]="on"+a}function ye(a,b,c,d){var e=!0;if(a=se(a))if(b=a.a[b.toString()])for(b=b.concat(),a=0;a<b.length;a++){var f=b[a];f&&f.capture==
	c&&!f.sa&&(f=ze(f,d),e=e&&!1!==f)}return e}function ze(a,b){var c=a.listener,d=a.La||a.src;a.Ha&&xe(a);return c.call(d,b)}function ve(a,b){if(a.sa)return!0;if(!Zd){if(!b)a:{b=["window","event"];for(var c=p,d=0;d<b.length;d++)if(c=c[b[d]],null==c){b=null;break a}b=c}d=b;b=new ce(d,this);c=!0;if(!(0>d.keyCode||void 0!=d.returnValue)){a:{var e=!1;if(0==d.keyCode)try{d.keyCode=-1;break a}catch(g){e=!0}if(e||void 0==d.returnValue)d.returnValue=!0}d=[];for(e=b.f;e;e=e.parentNode)d.push(e);a=a.type;for(e=
	d.length-1;!b.h&&0<=e;e--){b.f=d[e];var f=ye(d[e],a,!0,b);c=c&&f}for(e=0;!b.h&&e<d.length;e++)b.f=d[e],f=ye(d[e],a,!1,b),c=c&&f}return c}return ze(a,new ce(b,this))}function se(a){a=a[le];return a instanceof ie?a:null}var Ae="__closure_events_fn_"+(1E9*Math.random()>>>0);function qe(a){if(va(a))return a;a[Ae]||(a[Ae]=function(b){return a.handleEvent(b)});return a[Ae]}function F(){Td.call(this);this.I=new ie(this);this.yb=this;this.Fa=null}w(F,Td);F.prototype[ee]=!0;F.prototype.$a=function(a){this.Fa=
	a};F.prototype.removeEventListener=function(a,b,c,d){we(this,a,b,c,d)};function Be(a,b){var c,d=a.Fa;if(d)for(c=[];d;d=d.Fa)c.push(d);a=a.yb;d=b.type||b;if(r(b))b=new be(b,a);else if(b instanceof be)b.target=b.target||a;else{var e=b;b=new be(d,a);lb(b,e)}e=!0;if(c)for(var f=c.length-1;!b.h&&0<=f;f--){var g=b.f=c[f];e=Ce(g,d,!0,b)&&e}b.h||(g=b.f=a,e=Ce(g,d,!0,b)&&e,b.h||(e=Ce(g,d,!1,b)&&e));if(c)for(f=0;!b.h&&f<c.length;f++)g=b.f=c[f],e=Ce(g,d,!1,b)&&e;return e}F.prototype.m=function(){F.M.m.call(this);
	if(this.I){var a=this.I,b=0,c;for(c in a.a){for(var d=a.a[c],e=0;e<d.length;e++)++b,he(d[e]);delete a.a[c];a.f--}}this.Fa=null};function Ce(a,b,c,d){b=a.I.a[String(b)];if(!b)return!0;b=b.concat();for(var e=!0,f=0;f<b.length;++f){var g=b[f];if(g&&!g.sa&&g.capture==c){var h=g.listener,k=g.La||g.src;g.Ha&&ke(a.I,g);e=!1!==h.call(k,d)&&e}}return e&&0!=d.sb}var De={},Ee=0;function Fe(a,b){if(!a)throw Error("Event target element must be provided!");a=Ge(a);if(De[a]&&De[a].length)for(var c=0;c<De[a].length;c++)Be(De[a][c],
	b)}function He(a){var b=Ge(a.R());De[b]&&De[b].length&&(Ta(De[b],function(c){return c==a}),De[b].length||delete De[b])}function Ge(a){"undefined"===typeof a.a&&(a.a=Ee,Ee++);return a.a}function Ie(a){if(!a)throw Error("Event target element must be provided!");F.call(this);this.a=a}n(Ie,F);Ie.prototype.R=function(){return this.a};Ie.prototype.register=function(){var a=Ge(this.R());De[a]?Qa(De[a],this)||De[a].push(this):De[a]=[this]};function Je(a){if(!a)return!1;try{return!!a.$goog_Thenable}catch(b){return!1}}
	function Ke(a,b){this.h=a;this.j=b;this.f=0;this.a=null}Ke.prototype.get=function(){if(0<this.f){this.f--;var a=this.a;this.a=a.next;a.next=null}else a=this.h();return a};function Le(a,b){a.j(b);100>a.f&&(a.f++,b.next=a.a,a.a=b)}function Me(){this.f=this.a=null}var Oe=new Ke(function(){return new Ne},function(a){a.reset()});Me.prototype.add=function(a,b){var c=Oe.get();c.set(a,b);this.f?this.f.next=c:this.a=c;this.f=c};function Pe(){var a=Qe,b=null;a.a&&(b=a.a,a.a=a.a.next,a.a||(a.f=null),b.next=
	null);return b}function Ne(){this.next=this.f=this.a=null}Ne.prototype.set=function(a,b){this.a=a;this.f=b;this.next=null};Ne.prototype.reset=function(){this.next=this.f=this.a=null};function Re(a){p.setTimeout(function(){throw a;},0)}var Se;function Te(){var a=p.MessageChannel;"undefined"===typeof a&&"undefined"!==typeof window&&window.postMessage&&window.addEventListener&&!y("Presto")&&(a=function(){var e=document.createElement("IFRAME");e.style.display="none";e.src="";document.documentElement.appendChild(e);
	var f=e.contentWindow;e=f.document;e.open();e.write("");e.close();var g="callImmediate"+Math.random(),h="file:"==f.location.protocol?"*":f.location.protocol+"//"+f.location.host;e=t(function(k){if(("*"==h||k.origin==h)&&k.data==g)this.port1.onmessage()},this);f.addEventListener("message",e,!1);this.port1={};this.port2={postMessage:function(){f.postMessage(g,h)}}});if("undefined"!==typeof a&&!y("Trident")&&!y("MSIE")){var b=new a,c={},d=c;b.port1.onmessage=function(){if(na(c.next)){c=c.next;var e=
	c.hb;c.hb=null;e()}};return function(e){d.next={hb:e};d=d.next;b.port2.postMessage(0)}}return"undefined"!==typeof document&&"onreadystatechange"in document.createElement("SCRIPT")?function(e){var f=document.createElement("SCRIPT");f.onreadystatechange=function(){f.onreadystatechange=null;f.parentNode.removeChild(f);f=null;e();e=null};document.documentElement.appendChild(f)}:function(e){p.setTimeout(e,0)}}function Ue(a,b){Ve||We();Xe||(Ve(),Xe=!0);Qe.add(a,b)}var Ve;function We(){if(p.Promise&&p.Promise.resolve){var a=
	p.Promise.resolve(void 0);Ve=function(){a.then(Ye)}}else Ve=function(){var b=Ye;!va(p.setImmediate)||p.Window&&p.Window.prototype&&!y("Edge")&&p.Window.prototype.setImmediate==p.setImmediate?(Se||(Se=Te()),Se(b)):p.setImmediate(b)}}var Xe=!1,Qe=new Me;function Ye(){for(var a;a=Pe();){try{a.a.call(a.f)}catch(b){Re(b)}Le(Oe,a)}Xe=!1}function Ze(a){this.a=$e;this.w=void 0;this.j=this.f=this.h=null;this.s=this.i=!1;if(a!=qa)try{var b=this;a.call(void 0,function(c){af(b,bf,c)},function(c){if(!(c instanceof
	cf))try{if(c instanceof Error)throw c;throw Error("Promise rejected.");}catch(d){}af(b,df,c)})}catch(c){af(this,df,c)}}var $e=0,bf=2,df=3;function ef(){this.next=this.context=this.f=this.j=this.a=null;this.h=!1}ef.prototype.reset=function(){this.context=this.f=this.j=this.a=null;this.h=!1};var ff=new Ke(function(){return new ef},function(a){a.reset()});function gf(a,b,c){var d=ff.get();d.j=a;d.f=b;d.context=c;return d}function G(a){if(a instanceof Ze)return a;var b=new Ze(qa);af(b,bf,a);return b}
	function hf(a){return new Ze(function(b,c){c(a)})}Ze.prototype.then=function(a,b,c){return jf(this,va(a)?a:null,va(b)?b:null,c)};Ze.prototype.$goog_Thenable=!0;l=Ze.prototype;l.ec=function(a,b){a=gf(a,a,b);a.h=!0;kf(this,a);return this};l.ta=function(a,b){return jf(this,null,a,b)};l.cancel=function(a){this.a==$e&&Ue(function(){var b=new cf(a);lf(this,b)},this)};function lf(a,b){if(a.a==$e)if(a.h){var c=a.h;if(c.f){for(var d=0,e=null,f=null,g=c.f;g&&(g.h||(d++,g.a==a&&(e=g),!(e&&1<d)));g=g.next)e||
	(f=g);e&&(c.a==$e&&1==d?lf(c,b):(f?(d=f,d.next==c.j&&(c.j=d),d.next=d.next.next):mf(c),nf(c,e,df,b)))}a.h=null}else af(a,df,b)}function kf(a,b){a.f||a.a!=bf&&a.a!=df||of(a);a.j?a.j.next=b:a.f=b;a.j=b}function jf(a,b,c,d){var e=gf(null,null,null);e.a=new Ze(function(f,g){e.j=b?function(h){try{var k=b.call(d,h);f(k)}catch(m){g(m)}}:f;e.f=c?function(h){try{var k=c.call(d,h);!na(k)&&h instanceof cf?g(h):f(k)}catch(m){g(m)}}:g});e.a.h=a;kf(a,e);return e.a}l.gc=function(a){this.a=$e;af(this,bf,a)};l.hc=
	function(a){this.a=$e;af(this,df,a)};function af(a,b,c){if(a.a==$e){a===c&&(b=df,c=new TypeError("Promise cannot resolve to itself"));a.a=1;a:{var d=c,e=a.gc,f=a.hc;if(d instanceof Ze){kf(d,gf(e||qa,f||null,a));var g=!0}else if(Je(d))d.then(e,f,a),g=!0;else{if(wa(d))try{var h=d.then;if(va(h)){pf(d,h,e,f,a);g=!0;break a}}catch(k){f.call(a,k);g=!0;break a}g=!1}}g||(a.w=c,a.a=b,a.h=null,of(a),b!=df||c instanceof cf||qf(a,c))}}function pf(a,b,c,d,e){function f(k){h||(h=!0,d.call(e,k))}function g(k){h||
	(h=!0,c.call(e,k))}var h=!1;try{b.call(a,g,f)}catch(k){f(k)}}function of(a){a.i||(a.i=!0,Ue(a.Gb,a))}function mf(a){var b=null;a.f&&(b=a.f,a.f=b.next,b.next=null);a.f||(a.j=null);return b}l.Gb=function(){for(var a;a=mf(this);)nf(this,a,this.a,this.w);this.i=!1};function nf(a,b,c,d){if(c==df&&b.f&&!b.h)for(;a&&a.s;a=a.h)a.s=!1;if(b.a)b.a.h=null,rf(b,c,d);else try{b.h?b.j.call(b.context):rf(b,c,d)}catch(e){sf.call(null,e)}Le(ff,b)}function rf(a,b,c){b==bf?a.j.call(a.context,c):a.f&&a.f.call(a.context,
	c)}function qf(a,b){a.s=!0;Ue(function(){a.s&&sf.call(null,b)})}var sf=Re;function cf(a){Da.call(this,a)}w(cf,Da);cf.prototype.name="cancel";function tf(a,b,c){b||(b={});c=c||window;var d=a instanceof Dc?a:Ic("undefined"!=typeof a.href?a.href:String(a));a=b.target||a.target;var e=[];for(f in b)switch(f){case "width":case "height":case "top":case "left":e.push(f+"="+b[f]);break;case "target":case "noopener":case "noreferrer":break;default:e.push(f+"="+(b[f]?1:0))}var f=e.join(",");(y("iPhone")&&!y("iPod")&&
	!y("iPad")||y("iPad")||y("iPod"))&&c.navigator&&c.navigator.standalone&&a&&"_self"!=a?(f=c.document.createElement("A"),d instanceof Dc||d instanceof Dc||(d="object"==typeof d&&d.ma?d.ka():String(d),Hc.test(d)||(d="about:invalid#zClosurez"),d=Jc(d)),f.href=Gc(d),f.setAttribute("target",a),b.noreferrer&&f.setAttribute("rel","noreferrer"),b=document.createEvent("MouseEvent"),b.initMouseEvent("click",!0,!0,c,1),f.dispatchEvent(b),c={}):b.noreferrer?(c=c.open("",a,f),b=Fc(d),c&&(ic&&-1!=b.indexOf(";")&&
	(b="'"+b.replace(/'/g,"%27")+"'"),c.opener=null,b=Pc('<meta name="referrer" content="no-referrer"><meta http-equiv="refresh" content="0; url='+hb(b)+'">',null),c.document.write(Oc(b)),c.document.close())):(c=c.open(Fc(d),a,f))&&b.noopener&&(c.opener=null);return c}function uf(a){window.location.assign(Fc(Ic(a)))}function vf(){try{return!!(window.opener&&window.opener.location&&window.opener.location.assign&&window.opener.location.hostname===window.location.hostname&&window.opener.location.protocol===
	window.location.protocol)}catch(a$2){}return!1}function wf(a){tf(a,{target:window.cordova&&window.cordova.InAppBrowser?"_system":"_blank"},void 0)}function xf(a,b){a=wa(a)&&1==a.nodeType?a:document.querySelector(String(a));if(null==a)throw Error(b||"Cannot find element.");return a}function yf(){return window.location.href}function zf(){var a=null;return(new Ze(function(b){"complete"==p.document.readyState?b():(a=function(){b()},pe(window,"load",a))})).ta(function(b){we(window,"load",a);throw b;})}
	function Af(){for(var a=32,b=[];0<a;)b.push("1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ".charAt(Math.floor(62*Math.random()))),a--;return b.join("")}function Bf(a,b,c){c=void 0===c?{}:c;return Object.keys(a).filter(function(d){return b.includes(d)}).reduce(function(d,e){d[e]=a[e];return d},c)}function Cf(a){var b=Df;this.s=[];this.O=b;this.N=a||null;this.j=this.a=!1;this.h=void 0;this.I=this.l=this.w=!1;this.i=0;this.f=null;this.C=0}Cf.prototype.cancel=function(a){if(this.a)this.h instanceof
	Cf&&this.h.cancel();else{if(this.f){var b=this.f;delete this.f;a?b.cancel(a):(b.C--,0>=b.C&&b.cancel())}this.O?this.O.call(this.N,this):this.I=!0;this.a||(a=new Ef(this),Ff(this),Gf(this,!1,a))}};Cf.prototype.L=function(a,b){this.w=!1;Gf(this,a,b)};function Gf(a,b,c){a.a=!0;a.h=c;a.j=!b;Hf(a)}function Ff(a){if(a.a){if(!a.I)throw new If(a);a.I=!1}}function Jf(a,b,c){a.s.push([b,c,void 0]);a.a&&Hf(a)}Cf.prototype.then=function(a,b,c){var d,e,f=new Ze(function(g,h){d=g;e=h});Jf(this,d,function(g){g instanceof
	Ef?f.cancel():e(g)});return f.then(a,b,c)};Cf.prototype.$goog_Thenable=!0;function Kf(a){return Na(a.s,function(b){return va(b[1])})}function Hf(a){if(a.i&&a.a&&Kf(a)){var b=a.i,c=Lf[b];c&&(p.clearTimeout(c.a),delete Lf[b]);a.i=0}a.f&&(a.f.C--,delete a.f);b=a.h;for(var d=c=!1;a.s.length&&!a.w;){var e=a.s.shift(),f=e[0],g=e[1];e=e[2];if(f=a.j?g:f)try{var h=f.call(e||a.N,b);na(h)&&(a.j=a.j&&(h==b||h instanceof Error),a.h=b=h);if(Je(b)||"function"===typeof p.Promise&&b instanceof p.Promise)d=!0,a.w=
	!0}catch(k){b=k,a.j=!0,Kf(a)||(c=!0)}}a.h=b;d&&(h=t(a.L,a,!0),d=t(a.L,a,!1),b instanceof Cf?(Jf(b,h,d),b.l=!0):b.then(h,d));c&&(b=new Mf(b),Lf[b.a]=b,a.i=b.a)}function If(){Da.call(this)}w(If,Da);If.prototype.message="Deferred has already fired";If.prototype.name="AlreadyCalledError";function Ef(){Da.call(this)}w(Ef,Da);Ef.prototype.message="Deferred was canceled";Ef.prototype.name="CanceledError";function Mf(a){this.a=p.setTimeout(t(this.h,this),0);this.f=a}Mf.prototype.h=function(){delete Lf[this.a];
	throw this.f;};var Lf={};function Nf(a){var b={},c=b.document||document,d=Bc(a).toString(),e=document.createElement("SCRIPT"),f={tb:e,ub:void 0},g=new Cf(f),h=null,k=null!=b.timeout?b.timeout:5E3;0<k&&(h=window.setTimeout(function(){Of(e,!0);var m=new Pf(Qf,"Timeout reached for loading script "+d);Ff(g);Gf(g,!1,m)},k),f.ub=h);e.onload=e.onreadystatechange=function(){e.readyState&&"loaded"!=e.readyState&&"complete"!=e.readyState||(Of(e,b.wc||!1,h),Ff(g),Gf(g,!0,null))};e.onerror=function(){Of(e,!0,
	h);var m=new Pf(Rf,"Error while loading script "+d);Ff(g);Gf(g,!1,m)};f=b.attributes||{};lb(f,{type:"text/javascript",charset:"UTF-8"});ad(e,f);Sc(e,a);Sf(c).appendChild(e);return g}function Sf(a){var b=(a||document).getElementsByTagName("HEAD");return b&&0!=b.length?b[0]:a.documentElement}function Df(){if(this&&this.tb){var a=this.tb;a&&"SCRIPT"==a.tagName&&Of(a,!0,this.ub)}}function Of(a,b,c){null!=c&&p.clearTimeout(c);a.onload=qa;a.onerror=qa;a.onreadystatechange=qa;b&&window.setTimeout(function(){dd(a)},
	0)}var Rf=0,Qf=1;function Pf(a,b){var c="Jsloader error (code #"+a+")";b&&(c+=": "+b);Da.call(this,c);this.code=a}w(Pf,Da);function Tf(a){this.a=a||p.googleyolo;this.f=null;this.h=!1}Tf.prototype.cancel=function(){this.a&&this.h&&(this.f=this.a.cancelLastOperation().catch(function(){}))};function Uf(a,b,c){if(a.a&&b){var d=function(){a.h=!0;var e=Promise.resolve(null);c||(e=a.a.retrieve(b).catch(function(f){if(f.type===Vf||f.type===Wf)throw f;return null}));return e.then(function(f){return f?f:a.a.hint(b)}).catch(function(f){if(f.type===
	Vf)a.f=Promise.resolve();else if(f.type===Wf)return a.cancel(),Uf(a,b,c);return null})};return a.f?a.f.then(d):d()}if(b)return d=Xf.Ya().load().then(function(){a.a=p.googleyolo;return Uf(a,b,c)}).ta(function(){return null}),Promise.resolve(d);if("undefined"!==typeof Promise)return Promise.resolve(null);throw Error("One-Tap sign in not supported in the current browser!");}ra(Tf);var Yf=new vc(wc,"https://smartlock.google.com/client"),Wf="illegalConcurrentRequest",Vf="userCanceled";function Xf(){this.a=
	null}Xf.prototype.load=function(){var a=this;if(this.a)return this.a;var b=Cc(yc(Yf));return p.googleyolo?G():this.a=zf().then(function(){if(!p.googleyolo)return new Ze(function(c,d){var e=setTimeout(function(){a.a=null;d(Error("Network error!"))},1E4);p.onGoogleYoloLoad=function(){clearTimeout(e);c()};G(Nf(b)).ta(function(f){clearTimeout(e);a.a=null;d(f)})})})};ra(Xf);function Zf(a,b){this.a=a;this.f=b||function(c){throw c;}}Zf.prototype.confirm=function(a){return G(this.a.confirm(a)).ta(this.f)};
	function $f(a,b,c){this.reset(a,b,c,void 0,void 0)}$f.prototype.a=null;var ag=0;$f.prototype.reset=function(a,b,c,d,e){"number"==typeof e||ag++;this.h=d||Ca();this.j=a;this.s=b;this.f=c;delete this.a};function bg(a){this.s=a;this.a=this.h=this.j=this.f=null}function cg(a,b){this.name=a;this.value=b}cg.prototype.toString=function(){return this.name};var dg=new cg("SEVERE",1E3),eg=new cg("WARNING",900),fg=new cg("CONFIG",700);function gg(a){if(a.j)return a.j;if(a.f)return gg(a.f);Ga("Root logger has no level set.");
	return null}bg.prototype.log=function(a,b,c){if(a.value>=gg(this).value)for(va(b)&&(b=b()),a=new $f(a,String(b),this.s),c&&(a.a=c),c=this;c;){var d=c,e=a;if(d.a)for(var f=0;b=d.a[f];f++)b(e);c=c.f}};var hg={},ig=null;function jg(){ig||(ig=new bg(""),hg[""]=ig,ig.j=fg)}function kg(a){jg();var b;if(!(b=hg[a])){b=new bg(a);var c=a.lastIndexOf("."),d=a.substr(c+1);c=kg(a.substr(0,c));c.h||(c.h={});c.h[d]=b;b.f=c;hg[a]=b}return b}function lg(){this.a=Ca()}var mg=null;lg.prototype.set=function(a){this.a=
	a};lg.prototype.reset=function(){this.set(Ca())};lg.prototype.get=function(){return this.a};function ng(a){this.j=a||"";mg||(mg=new lg);this.s=mg}ng.prototype.a=!0;ng.prototype.f=!0;ng.prototype.h=!1;function og(a){return 10>a?"0"+a:String(a)}function pg(a,b){a=(a.h-b)/1E3;b=a.toFixed(3);var c=0;if(1>a)c=2;else for(;100>a;)c++,a*=10;for(;0<c--;)b=" "+b;return b}function qg(a){ng.call(this,a)}w(qg,ng);function rg(a,b){var c=[];c.push(a.j," ");if(a.f){var d=new Date(b.h);c.push("[",og(d.getFullYear()-
	2E3)+og(d.getMonth()+1)+og(d.getDate())+" "+og(d.getHours())+":"+og(d.getMinutes())+":"+og(d.getSeconds())+"."+og(Math.floor(d.getMilliseconds()/10)),"] ")}c.push("[",pg(b,a.s.get()),"s] ");c.push("[",b.f,"] ");c.push(b.s);a.h&&(b=b.a)&&c.push("\n",b instanceof Error?b.message:b.toString());a.a&&c.push("\n");return c.join("")}function sg(){this.s=t(this.h,this);this.a=new qg;this.a.f=!1;this.a.h=!1;this.f=this.a.a=!1;this.j={}}sg.prototype.h=function(a){function b(f){if(f){if(f.value>=dg.value)return"error";
	if(f.value>=eg.value)return"warn";if(f.value>=fg.value)return"log"}return"debug"}if(!this.j[a.f]){var c=rg(this.a,a),d=tg;if(d){var e=b(a.j);ug(d,e,c,a.a)}}};var tg=p.console;function ug(a,b,c,d){if(a[b])a[b](c,d||"");else a.log(c,d||"")}function vg(a,b){var c=wg;c&&c.log(dg,a,b)}var wg;wg=kg("firebaseui");var xg=new sg;if(1!=xg.f){var yg;jg();yg=ig;var zg=xg.s;yg.a||(yg.a=[]);yg.a.push(zg);xg.f=!0}function Ag(a){var b=wg;b&&b.log(eg,a,void 0)}function Bg(a,b,c,d){this.a=a;this.h=b||null;this.j=c||
	null;this.f=d||null}Bg.prototype.aa=function(){return{email:this.a,displayName:this.h,photoUrl:this.j,providerId:this.f}};function Cg(a){return a.email?new Bg(a.email,a.displayName,a.photoUrl,a.providerId):null}function Dg(){this.a=("undefined"==typeof document?null:document)||{cookie:""}}l=Dg.prototype;l.set=function(a,b,c,d,e,f){if(/[;=\s]/.test(a))throw Error('Invalid cookie name "'+a+'"');if(/[;\r\n]/.test(b))throw Error('Invalid cookie value "'+b+'"');na(c)||(c=-1);e=e?";domain="+e:"";d=d?";path="+
	d:"";f=f?";secure":"";c=0>c?"":0==c?";expires="+(new Date(1970,1,1)).toUTCString():";expires="+(new Date(Ca()+1E3*c)).toUTCString();this.a.cookie=a+"="+b+e+d+c+f};l.get=function(a,b){for(var c=a+"=",d=(this.a.cookie||"").split(";"),e=0,f;e<d.length;e++){f=Za(d[e]);if(0==f.lastIndexOf(c,0))return f.substr(c.length);if(f==a)return""}return b};l.ja=function(){return Eg(this).keys};l.la=function(){return Eg(this).values};l.clear=function(){for(var a=Eg(this).keys,b=a.length-1;0<=b;b--){var c=a[b];this.get(c);
	this.set(c,"",0,void 0,void 0)}};function Eg(a){a=(a.a.cookie||"").split(";");for(var b=[],c=[],d,e,f=0;f<a.length;f++)e=Za(a[f]),d=e.indexOf("="),-1==d?(b.push(""),c.push(e)):(b.push(e.substring(0,d)),c.push(e.substring(d+1)));return{keys:b,values:c}}var Fg=new Dg;function Gg(){}function Hg(a,b,c,d){this.h="undefined"!==typeof a&&null!==a?a:-1;this.f=b||null;this.a=c||null;this.j=!!d}n(Hg,Gg);Hg.prototype.set=function(a,b){Fg.set(a,b,this.h,this.f,this.a,this.j)};Hg.prototype.get=function(a){return Fg.get(a)||
	null};Hg.prototype.ra=function(a){var b=this.f,c=this.a;Fg.get(a);Fg.set(a,"",0,b,c)};function Ig(a,b){this.f=a;this.a=b||null}Ig.prototype.aa=function(){return{email:this.f,credential:this.a&&this.a.toJSON()}};function Jg(a){if(a&&a.email){var b=a.credential&&firebase.auth.AuthCredential.fromJSON(a.credential);return new Ig(a.email,b)}return null}function Kg(a){this.a=a||null}Kg.prototype.aa=function(){return{tenantId:this.a}};function Lg(a){for(var b=[],c=0,d=0;d<a.length;d++){var e=a.charCodeAt(d);
	255<e&&(b[c++]=e&255,e>>=8);b[c++]=e}return b}function Ng(a){return Ma(a,function(b){b=b.toString(16);return 1<b.length?b:"0"+b}).join("")}function Og(a){this.i=a;this.f=this.i.length/4;this.j=this.f+6;this.h=[[],[],[],[]];this.s=[[],[],[],[]];this.a=Array(Pg*(this.j+1));for(a=0;a<this.f;a++)this.a[a]=[this.i[4*a],this.i[4*a+1],this.i[4*a+2],this.i[4*a+3]];var b=Array(4);for(a=this.f;a<Pg*(this.j+1);a++){b[0]=this.a[a-1][0];b[1]=this.a[a-1][1];b[2]=this.a[a-1][2];b[3]=this.a[a-1][3];if(0==a%this.f){var c=
	b,d=c[0];c[0]=c[1];c[1]=c[2];c[2]=c[3];c[3]=d;Qg(b);b[0]^=Rg[a/this.f][0];b[1]^=Rg[a/this.f][1];b[2]^=Rg[a/this.f][2];b[3]^=Rg[a/this.f][3]}else 6<this.f&&4==a%this.f&&Qg(b);this.a[a]=Array(4);this.a[a][0]=this.a[a-this.f][0]^b[0];this.a[a][1]=this.a[a-this.f][1]^b[1];this.a[a][2]=this.a[a-this.f][2]^b[2];this.a[a][3]=this.a[a-this.f][3]^b[3]}}Og.prototype.w=16;var Pg=Og.prototype.w/4;function Sg(a,b){for(var c,d=0;d<Pg;d++)for(var e=0;4>e;e++)c=4*e+d,c=b[c],a.h[d][e]=c}function Tg(a){for(var b=[],
	c=0;c<Pg;c++)for(var d=0;4>d;d++)b[4*d+c]=a.h[c][d];return b}function Ug(a,b){for(var c=0;4>c;c++)for(var d=0;4>d;d++)a.h[c][d]^=a.a[4*b+d][c]}function Vg(a,b){for(var c=0;4>c;c++)for(var d=0;4>d;d++)a.h[c][d]=b[a.h[c][d]]}function Wg(a){for(var b=1;4>b;b++)for(var c=0;4>c;c++)a.s[b][c]=a.h[b][c];for(b=1;4>b;b++)for(c=0;4>c;c++)a.h[b][c]=a.s[b][(c+b)%Pg]}function Xg(a){for(var b=1;4>b;b++)for(var c=0;4>c;c++)a.s[b][(c+b)%Pg]=a.h[b][c];for(b=1;4>b;b++)for(c=0;4>c;c++)a.h[b][c]=a.s[b][c]}function Qg(a){a[0]=
	Yg[a[0]];a[1]=Yg[a[1]];a[2]=Yg[a[2]];a[3]=Yg[a[3]]}var Yg=[99,124,119,123,242,107,111,197,48,1,103,43,254,215,171,118,202,130,201,125,250,89,71,240,173,212,162,175,156,164,114,192,183,253,147,38,54,63,247,204,52,165,229,241,113,216,49,21,4,199,35,195,24,150,5,154,7,18,128,226,235,39,178,117,9,131,44,26,27,110,90,160,82,59,214,179,41,227,47,132,83,209,0,237,32,252,177,91,106,203,190,57,74,76,88,207,208,239,170,251,67,77,51,133,69,249,2,127,80,60,159,168,81,163,64,143,146,157,56,245,188,182,218,33,
	16,255,243,210,205,12,19,236,95,151,68,23,196,167,126,61,100,93,25,115,96,129,79,220,34,42,144,136,70,238,184,20,222,94,11,219,224,50,58,10,73,6,36,92,194,211,172,98,145,149,228,121,231,200,55,109,141,213,78,169,108,86,244,234,101,122,174,8,186,120,37,46,28,166,180,198,232,221,116,31,75,189,139,138,112,62,181,102,72,3,246,14,97,53,87,185,134,193,29,158,225,248,152,17,105,217,142,148,155,30,135,233,206,85,40,223,140,161,137,13,191,230,66,104,65,153,45,15,176,84,187,22],Zg=[82,9,106,213,48,54,165,56,
	191,64,163,158,129,243,215,251,124,227,57,130,155,47,255,135,52,142,67,68,196,222,233,203,84,123,148,50,166,194,35,61,238,76,149,11,66,250,195,78,8,46,161,102,40,217,36,178,118,91,162,73,109,139,209,37,114,248,246,100,134,104,152,22,212,164,92,204,93,101,182,146,108,112,72,80,253,237,185,218,94,21,70,87,167,141,157,132,144,216,171,0,140,188,211,10,247,228,88,5,184,179,69,6,208,44,30,143,202,63,15,2,193,175,189,3,1,19,138,107,58,145,17,65,79,103,220,234,151,242,207,206,240,180,230,115,150,172,116,
	34,231,173,53,133,226,249,55,232,28,117,223,110,71,241,26,113,29,41,197,137,111,183,98,14,170,24,190,27,252,86,62,75,198,210,121,32,154,219,192,254,120,205,90,244,31,221,168,51,136,7,199,49,177,18,16,89,39,128,236,95,96,81,127,169,25,181,74,13,45,229,122,159,147,201,156,239,160,224,59,77,174,42,245,176,200,235,187,60,131,83,153,97,23,43,4,126,186,119,214,38,225,105,20,99,85,33,12,125],Rg=[[0,0,0,0],[1,0,0,0],[2,0,0,0],[4,0,0,0],[8,0,0,0],[16,0,0,0],[32,0,0,0],[64,0,0,0],[128,0,0,0],[27,0,0,0],[54,
	0,0,0]],$g=[0,2,4,6,8,10,12,14,16,18,20,22,24,26,28,30,32,34,36,38,40,42,44,46,48,50,52,54,56,58,60,62,64,66,68,70,72,74,76,78,80,82,84,86,88,90,92,94,96,98,100,102,104,106,108,110,112,114,116,118,120,122,124,126,128,130,132,134,136,138,140,142,144,146,148,150,152,154,156,158,160,162,164,166,168,170,172,174,176,178,180,182,184,186,188,190,192,194,196,198,200,202,204,206,208,210,212,214,216,218,220,222,224,226,228,230,232,234,236,238,240,242,244,246,248,250,252,254,27,25,31,29,19,17,23,21,11,9,15,
	13,3,1,7,5,59,57,63,61,51,49,55,53,43,41,47,45,35,33,39,37,91,89,95,93,83,81,87,85,75,73,79,77,67,65,71,69,123,121,127,125,115,113,119,117,107,105,111,109,99,97,103,101,155,153,159,157,147,145,151,149,139,137,143,141,131,129,135,133,187,185,191,189,179,177,183,181,171,169,175,173,163,161,167,165,219,217,223,221,211,209,215,213,203,201,207,205,195,193,199,197,251,249,255,253,243,241,247,245,235,233,239,237,227,225,231,229],ah=[0,3,6,5,12,15,10,9,24,27,30,29,20,23,18,17,48,51,54,53,60,63,58,57,40,43,
	46,45,36,39,34,33,96,99,102,101,108,111,106,105,120,123,126,125,116,119,114,113,80,83,86,85,92,95,90,89,72,75,78,77,68,71,66,65,192,195,198,197,204,207,202,201,216,219,222,221,212,215,210,209,240,243,246,245,252,255,250,249,232,235,238,237,228,231,226,225,160,163,166,165,172,175,170,169,184,187,190,189,180,183,178,177,144,147,150,149,156,159,154,153,136,139,142,141,132,135,130,129,155,152,157,158,151,148,145,146,131,128,133,134,143,140,137,138,171,168,173,174,167,164,161,162,179,176,181,182,191,188,
	185,186,251,248,253,254,247,244,241,242,227,224,229,230,239,236,233,234,203,200,205,206,199,196,193,194,211,208,213,214,223,220,217,218,91,88,93,94,87,84,81,82,67,64,69,70,79,76,73,74,107,104,109,110,103,100,97,98,115,112,117,118,127,124,121,122,59,56,61,62,55,52,49,50,35,32,37,38,47,44,41,42,11,8,13,14,7,4,1,2,19,16,21,22,31,28,25,26],bh=[0,9,18,27,36,45,54,63,72,65,90,83,108,101,126,119,144,153,130,139,180,189,166,175,216,209,202,195,252,245,238,231,59,50,41,32,31,22,13,4,115,122,97,104,87,94,69,
	76,171,162,185,176,143,134,157,148,227,234,241,248,199,206,213,220,118,127,100,109,82,91,64,73,62,55,44,37,26,19,8,1,230,239,244,253,194,203,208,217,174,167,188,181,138,131,152,145,77,68,95,86,105,96,123,114,5,12,23,30,33,40,51,58,221,212,207,198,249,240,235,226,149,156,135,142,177,184,163,170,236,229,254,247,200,193,218,211,164,173,182,191,128,137,146,155,124,117,110,103,88,81,74,67,52,61,38,47,16,25,2,11,215,222,197,204,243,250,225,232,159,150,141,132,187,178,169,160,71,78,85,92,99,106,113,120,
	15,6,29,20,43,34,57,48,154,147,136,129,190,183,172,165,210,219,192,201,246,255,228,237,10,3,24,17,46,39,60,53,66,75,80,89,102,111,116,125,161,168,179,186,133,140,151,158,233,224,251,242,205,196,223,214,49,56,35,42,21,28,7,14,121,112,107,98,93,84,79,70],ch=[0,11,22,29,44,39,58,49,88,83,78,69,116,127,98,105,176,187,166,173,156,151,138,129,232,227,254,245,196,207,210,217,123,112,109,102,87,92,65,74,35,40,53,62,15,4,25,18,203,192,221,214,231,236,241,250,147,152,133,142,191,180,169,162,246,253,224,235,
	218,209,204,199,174,165,184,179,130,137,148,159,70,77,80,91,106,97,124,119,30,21,8,3,50,57,36,47,141,134,155,144,161,170,183,188,213,222,195,200,249,242,239,228,61,54,43,32,17,26,7,12,101,110,115,120,73,66,95,84,247,252,225,234,219,208,205,198,175,164,185,178,131,136,149,158,71,76,81,90,107,96,125,118,31,20,9,2,51,56,37,46,140,135,154,145,160,171,182,189,212,223,194,201,248,243,238,229,60,55,42,33,16,27,6,13,100,111,114,121,72,67,94,85,1,10,23,28,45,38,59,48,89,82,79,68,117,126,99,104,177,186,167,
	172,157,150,139,128,233,226,255,244,197,206,211,216,122,113,108,103,86,93,64,75,34,41,52,63,14,5,24,19,202,193,220,215,230,237,240,251,146,153,132,143,190,181,168,163],dh=[0,13,26,23,52,57,46,35,104,101,114,127,92,81,70,75,208,221,202,199,228,233,254,243,184,181,162,175,140,129,150,155,187,182,161,172,143,130,149,152,211,222,201,196,231,234,253,240,107,102,113,124,95,82,69,72,3,14,25,20,55,58,45,32,109,96,119,122,89,84,67,78,5,8,31,18,49,60,43,38,189,176,167,170,137,132,147,158,213,216,207,194,225,
	236,251,246,214,219,204,193,226,239,248,245,190,179,164,169,138,135,144,157,6,11,28,17,50,63,40,37,110,99,116,121,90,87,64,77,218,215,192,205,238,227,244,249,178,191,168,165,134,139,156,145,10,7,16,29,62,51,36,41,98,111,120,117,86,91,76,65,97,108,123,118,85,88,79,66,9,4,19,30,61,48,39,42,177,188,171,166,133,136,159,146,217,212,195,206,237,224,247,250,183,186,173,160,131,142,153,148,223,210,197,200,235,230,241,252,103,106,125,112,83,94,73,68,15,2,21,24,59,54,33,44,12,1,22,27,56,53,34,47,100,105,126,
	115,80,93,74,71,220,209,198,203,232,229,242,255,180,185,174,163,128,141,154,151],eh=[0,14,28,18,56,54,36,42,112,126,108,98,72,70,84,90,224,238,252,242,216,214,196,202,144,158,140,130,168,166,180,186,219,213,199,201,227,237,255,241,171,165,183,185,147,157,143,129,59,53,39,41,3,13,31,17,75,69,87,89,115,125,111,97,173,163,177,191,149,155,137,135,221,211,193,207,229,235,249,247,77,67,81,95,117,123,105,103,61,51,33,47,5,11,25,23,118,120,106,100,78,64,82,92,6,8,26,20,62,48,34,44,150,152,138,132,174,160,
	178,188,230,232,250,244,222,208,194,204,65,79,93,83,121,119,101,107,49,63,45,35,9,7,21,27,161,175,189,179,153,151,133,139,209,223,205,195,233,231,245,251,154,148,134,136,162,172,190,176,234,228,246,248,210,220,206,192,122,116,102,104,66,76,94,80,10,4,22,24,50,60,46,32,236,226,240,254,212,218,200,198,156,146,128,142,164,170,184,182,12,2,16,30,52,58,40,38,124,114,96,110,68,74,88,86,55,57,43,37,15,1,19,29,71,73,91,85,127,113,99,109,215,217,203,197,239,225,243,253,167,169,187,181,159,145,131,141];function fh(a,
	b){a=new Og(gh(a));b=Lg(b);for(var c=Xa(b,0,16),d="",e;c.length;){e=16-c.length;for(var f=0;f<e;f++)c.push(0);e=a;Sg(e,c);Ug(e,0);for(c=1;c<e.j;++c){Vg(e,Yg);Wg(e);f=e.h;for(var g=e.s[0],h=0;4>h;h++)g[0]=f[0][h],g[1]=f[1][h],g[2]=f[2][h],g[3]=f[3][h],f[0][h]=$g[g[0]]^ah[g[1]]^g[2]^g[3],f[1][h]=g[0]^$g[g[1]]^ah[g[2]]^g[3],f[2][h]=g[0]^g[1]^$g[g[2]]^ah[g[3]],f[3][h]=ah[g[0]]^g[1]^g[2]^$g[g[3]];Ug(e,c)}Vg(e,Yg);Wg(e);Ug(e,e.j);d+=Ng(Tg(e));c=Xa(b,0,16)}return d}function hh(a,b){a=new Og(gh(a));for(var c=
	[],d=0;d<b.length;d+=2)c.push(parseInt(b.substring(d,d+2),16));var e=Xa(c,0,16);for(b="";e.length;){d=a;Sg(d,e);Ug(d,d.j);for(e=1;e<d.j;++e){Xg(d);Vg(d,Zg);Ug(d,d.j-e);for(var f=d.h,g=d.s[0],h=0;4>h;h++)g[0]=f[0][h],g[1]=f[1][h],g[2]=f[2][h],g[3]=f[3][h],f[0][h]=eh[g[0]]^ch[g[1]]^dh[g[2]]^bh[g[3]],f[1][h]=bh[g[0]]^eh[g[1]]^ch[g[2]]^dh[g[3]],f[2][h]=dh[g[0]]^bh[g[1]]^eh[g[2]]^ch[g[3]],f[3][h]=ch[g[0]]^dh[g[1]]^bh[g[2]]^eh[g[3]]}Xg(d);Vg(d,Zg);Ug(d,0);d=Tg(d);if(8192>=d.length)d=String.fromCharCode.apply(null,
	d);else{e="";for(f=0;f<d.length;f+=8192)e+=String.fromCharCode.apply(null,Ya(d,f,f+8192));d=e}b+=d;e=Xa(c,0,16)}return b.replace(/(\x00)+$/,"")}function gh(a){a=Lg(a.substring(0,32));for(var b=32-a.length,c=0;c<b;c++)a.push(0);return a}function ih(a){var b=[];jh(new kh,a,b);return b.join("")}function kh(){}function jh(a,b,c){if(null==b)c.push("null");else{if("object"==typeof b){if(ta(b)){var d=b;b=d.length;c.push("[");for(var e="",f=0;f<b;f++)c.push(e),jh(a,d[f],c),e=",";c.push("]");return}if(b instanceof
	String||b instanceof Number||b instanceof Boolean)b=b.valueOf();else{c.push("{");e="";for(d in b)Object.prototype.hasOwnProperty.call(b,d)&&(f=b[d],"function"!=typeof f&&(c.push(e),lh(d,c),c.push(":"),jh(a,f,c),e=","));c.push("}");return}}switch(typeof b){case "string":lh(b,c);break;case "number":c.push(isFinite(b)&&!isNaN(b)?String(b):"null");break;case "boolean":c.push(String(b));break;case "function":c.push("null");break;default:throw Error("Unknown type: "+typeof b);}}}var mh={'"':'\\"',"\\":"\\\\",
	"/":"\\/","\b":"\\b","\f":"\\f","\n":"\\n","\r":"\\r","\t":"\\t","\x0B":"\\u000b"},nh=/\uffff/.test("\uffff")?/[\\"\x00-\x1f\x7f-\uffff]/g:/[\\"\x00-\x1f\x7f-\xff]/g;function lh(a,b){b.push('"',a.replace(nh,function(c){var d=mh[c];d||(d="\\u"+(c.charCodeAt(0)|65536).toString(16).substr(1),mh[c]=d);return d}),'"')}function oh(a){this.a=a}oh.prototype.set=function(a,b){na(b)?this.a.set(a,ih(b)):this.a.ra(a)};oh.prototype.get=function(a){try{var b=this.a.get(a)}catch(c){return}if(null!==b)try{return JSON.parse(b)}catch(c$3){throw"Storage: Invalid value was encountered";
	}};function ph(){}w(ph,Gg);ph.prototype.clear=function(){var a=qb(this.ha(!0)),b=this;Ja(a,function(c){b.ra(c)})};function qh(a){this.a=a}w(qh,ph);function rh(a){if(!a.a)return!1;try{return a.a.setItem("__sak","1"),a.a.removeItem("__sak"),!0}catch(b){return!1}}l=qh.prototype;l.set=function(a,b){try{this.a.setItem(a,b)}catch(c){if(0==this.a.length)throw"Storage mechanism: Storage disabled";throw"Storage mechanism: Quota exceeded";}};l.get=function(a){a=this.a.getItem(a);if(!r(a)&&null!==a)throw"Storage mechanism: Invalid value was encountered";
	return a};l.ra=function(a){this.a.removeItem(a)};l.ha=function(a){var b=0,c=this.a,d=new nb;d.next=function(){if(b>=c.length)throw mb;var e=c.key(b++);if(a)return e;e=c.getItem(e);if(!r(e))throw"Storage mechanism: Invalid value was encountered";return e};return d};l.clear=function(){this.a.clear()};l.key=function(a){return this.a.key(a)};function sh(){var a=null;try{a=window.localStorage||null}catch(b){}this.a=a}w(sh,qh);function th(){var a=null;try{a=window.sessionStorage||null}catch(b){}this.a=
	a}w(th,qh);function uh(a,b){this.f=a;this.a=b+"::"}w(uh,ph);uh.prototype.set=function(a,b){this.f.set(this.a+a,b)};uh.prototype.get=function(a){return this.f.get(this.a+a)};uh.prototype.ra=function(a){this.f.ra(this.a+a)};uh.prototype.ha=function(a){var b=this.f.ha(!0),c=this,d=new nb;d.next=function(){for(var e=b.next();e.substr(0,c.a.length)!=c.a;)e=b.next();return a?e.substr(c.a.length):c.f.get(e)};return d};var vh,wh=new sh;vh=rh(wh)?new uh(wh,"firebaseui"):null;var xh=new oh(vh),yh,zh=new th;
	yh=rh(zh)?new uh(zh,"firebaseui"):null;var Ah=new oh(yh),Bh={name:"pendingEmailCredential",storage:Ah},Ch={name:"redirectStatus",storage:Ah},Dh={name:"redirectUrl",storage:Ah},Eh={name:"rememberAccount",storage:Ah},Fh={name:"rememberedAccounts",storage:xh},Gh={name:"emailForSignIn",storage:new oh(new Hg(3600,"/"))},Hh={name:"pendingEncryptedCredential",storage:new oh(new Hg(3600,"/"))};function Ih(a,b){return a.storage.get(b?a.name+":"+b:a.name)}function Jh(a,b){a.storage.a.ra(b?a.name+":"+b:a.name)}
	function Kh(a,b,c){a.storage.set(c?a.name+":"+c:a.name,b)}function Lh(a){return Ih(Dh,a)||null}function Mh(a,b){Kh(Dh,a,b)}function Nh(a,b){Kh(Eh,a,b)}function Oh(a){a=Ih(Fh,a)||[];a=Ma(a,function(b){return Cg(b)});return La(a,function(b){return null!=b})}function Ph(a,b){var c=Oh(b),d=Oa(c,function(e){return e.a==a.a&&(e.f||null)==(a.f||null)});-1<d&&Sa(c,d);c.unshift(a);Kh(Fh,Ma(c,function(e){return e.aa()}),b)}function Qh(a){a=Ih(Bh,a)||null;return Jg(a)}function Rh(a){Jh(Bh,a)}function Sh(a,b){Kh(Bh,
	a.aa(),b)}function Th(a){return(a=Ih(Ch,a)||null)&&"undefined"!==typeof a.tenantId?new Kg(a.tenantId):null}function Uh(a,b){Kh(Ch,a.aa(),b)}function Vh(a,b){b=Ih(Gh,b);var c=null;if(b)try{var d=hh(a,b),e=JSON.parse(d);c=e&&e.email||null}catch(f){}return c}function Wh(a,b){b=Ih(Hh,b);var c=null;if(b)try{var d=hh(a,b);c=JSON.parse(d)}catch(e){}return Jg(c||null)}function Xh(a,b,c){Kh(Hh,fh(a,JSON.stringify(b.aa())),c)}function Yh(){this.V={}}function H(a,b,c){if(b.toLowerCase()in a.V)throw Error("Configuration "+
	b+" has already been defined.");a.V[b.toLowerCase()]=c}function Zh(a,b,c){if(!(b.toLowerCase()in a.V))throw Error("Configuration "+b+" is not defined.");a.V[b.toLowerCase()]=c}Yh.prototype.get=function(a){if(!(a.toLowerCase()in this.V))throw Error("Configuration "+a+" is not defined.");return this.V[a.toLowerCase()]};function $h(a,b){a=a.get(b);if(!a)throw Error("Configuration "+b+" is required.");return a}function ai(){this.f=void 0;this.a={}}l=ai.prototype;l.set=function(a,b){bi(this,a,b,!1)};l.add=
	function(a,b){bi(this,a,b,!0)};function bi(a,b,c,d){for(var e=0;e<b.length;e++){var f=b.charAt(e);a.a[f]||(a.a[f]=new ai);a=a.a[f]}if(d&&void 0!==a.f)throw Error('The collection already contains the key "'+b+'"');a.f=c}l.get=function(a){a:{for(var b=this,c=0;c<a.length;c++)if(b=b.a[a.charAt(c)],!b){a=void 0;break a}a=b}return a?a.f:void 0};l.la=function(){var a=[];ci(this,a);return a};function ci(a,b){void 0!==a.f&&b.push(a.f);for(var c in a.a)ci(a.a[c],b)}l.ja=function(){var a=[];di(this,"",a);return a};
	function di(a,b,c){void 0!==a.f&&c.push(b);for(var d in a.a)di(a.a[d],b+d,c)}l.clear=function(){this.a={};this.f=void 0};function ei(a){this.a=a;this.f=new ai;for(a=0;a<this.a.length;a++){var b=this.f.get("+"+this.a[a].b);b?b.push(this.a[a]):this.f.add("+"+this.a[a].b,[this.a[a]])}}function fi(a,b){a=a.f;var c={},d=0;void 0!==a.f&&(c[d]=a.f);for(;d<b.length;d++){var e=b.charAt(d);if(!(e in a.a))break;a=a.a[e];void 0!==a.f&&(c[d]=a.f)}for(var f in c)if(c.hasOwnProperty(f))return c[f];return[]}function gi(a){for(var b=
	0;b<hi.length;b++)if(hi[b].c===a)return hi[b];return null}function ii(a){a=a.toUpperCase();for(var b=[],c=0;c<hi.length;c++)hi[c].g===a&&b.push(hi[c]);return b}function ji(a){if(0<a.length&&"+"==a.charAt(0)){a=a.substring(1);for(var b=[],c=0;c<hi.length;c++)hi[c].b==a&&b.push(hi[c]);a=b}else a=ii(a);return a}function ki(a){a.sort(function(b,c){return b.name.localeCompare(c.name,"en")})}var hi=[{name:"Afghanistan",c:"93-AF-0",b:"93",g:"AF"},{name:"\u00c5land Islands",c:"358-AX-0",b:"358",g:"AX"},{name:"Albania",
	c:"355-AL-0",b:"355",g:"AL"},{name:"Algeria",c:"213-DZ-0",b:"213",g:"DZ"},{name:"American Samoa",c:"1-AS-0",b:"1",g:"AS"},{name:"Andorra",c:"376-AD-0",b:"376",g:"AD"},{name:"Angola",c:"244-AO-0",b:"244",g:"AO"},{name:"Anguilla",c:"1-AI-0",b:"1",g:"AI"},{name:"Antigua and Barbuda",c:"1-AG-0",b:"1",g:"AG"},{name:"Argentina",c:"54-AR-0",b:"54",g:"AR"},{name:"Armenia",c:"374-AM-0",b:"374",g:"AM"},{name:"Aruba",c:"297-AW-0",b:"297",g:"AW"},{name:"Ascension Island",c:"247-AC-0",b:"247",g:"AC"},{name:"Australia",
	c:"61-AU-0",b:"61",g:"AU"},{name:"Austria",c:"43-AT-0",b:"43",g:"AT"},{name:"Azerbaijan",c:"994-AZ-0",b:"994",g:"AZ"},{name:"Bahamas",c:"1-BS-0",b:"1",g:"BS"},{name:"Bahrain",c:"973-BH-0",b:"973",g:"BH"},{name:"Bangladesh",c:"880-BD-0",b:"880",g:"BD"},{name:"Barbados",c:"1-BB-0",b:"1",g:"BB"},{name:"Belarus",c:"375-BY-0",b:"375",g:"BY"},{name:"Belgium",c:"32-BE-0",b:"32",g:"BE"},{name:"Belize",c:"501-BZ-0",b:"501",g:"BZ"},{name:"Benin",c:"229-BJ-0",b:"229",g:"BJ"},{name:"Bermuda",c:"1-BM-0",b:"1",
	g:"BM"},{name:"Bhutan",c:"975-BT-0",b:"975",g:"BT"},{name:"Bolivia",c:"591-BO-0",b:"591",g:"BO"},{name:"Bosnia and Herzegovina",c:"387-BA-0",b:"387",g:"BA"},{name:"Botswana",c:"267-BW-0",b:"267",g:"BW"},{name:"Brazil",c:"55-BR-0",b:"55",g:"BR"},{name:"British Indian Ocean Territory",c:"246-IO-0",b:"246",g:"IO"},{name:"British Virgin Islands",c:"1-VG-0",b:"1",g:"VG"},{name:"Brunei",c:"673-BN-0",b:"673",g:"BN"},{name:"Bulgaria",c:"359-BG-0",b:"359",g:"BG"},{name:"Burkina Faso",c:"226-BF-0",b:"226",
	g:"BF"},{name:"Burundi",c:"257-BI-0",b:"257",g:"BI"},{name:"Cambodia",c:"855-KH-0",b:"855",g:"KH"},{name:"Cameroon",c:"237-CM-0",b:"237",g:"CM"},{name:"Canada",c:"1-CA-0",b:"1",g:"CA"},{name:"Cape Verde",c:"238-CV-0",b:"238",g:"CV"},{name:"Caribbean Netherlands",c:"599-BQ-0",b:"599",g:"BQ"},{name:"Cayman Islands",c:"1-KY-0",b:"1",g:"KY"},{name:"Central African Republic",c:"236-CF-0",b:"236",g:"CF"},{name:"Chad",c:"235-TD-0",b:"235",g:"TD"},{name:"Chile",c:"56-CL-0",b:"56",g:"CL"},{name:"China",c:"86-CN-0",
	b:"86",g:"CN"},{name:"Christmas Island",c:"61-CX-0",b:"61",g:"CX"},{name:"Cocos [Keeling] Islands",c:"61-CC-0",b:"61",g:"CC"},{name:"Colombia",c:"57-CO-0",b:"57",g:"CO"},{name:"Comoros",c:"269-KM-0",b:"269",g:"KM"},{name:"Democratic Republic Congo",c:"243-CD-0",b:"243",g:"CD"},{name:"Republic of Congo",c:"242-CG-0",b:"242",g:"CG"},{name:"Cook Islands",c:"682-CK-0",b:"682",g:"CK"},{name:"Costa Rica",c:"506-CR-0",b:"506",g:"CR"},{name:"C\u00f4te d'Ivoire",c:"225-CI-0",b:"225",g:"CI"},{name:"Croatia",
	c:"385-HR-0",b:"385",g:"HR"},{name:"Cuba",c:"53-CU-0",b:"53",g:"CU"},{name:"Cura\u00e7ao",c:"599-CW-0",b:"599",g:"CW"},{name:"Cyprus",c:"357-CY-0",b:"357",g:"CY"},{name:"Czech Republic",c:"420-CZ-0",b:"420",g:"CZ"},{name:"Denmark",c:"45-DK-0",b:"45",g:"DK"},{name:"Djibouti",c:"253-DJ-0",b:"253",g:"DJ"},{name:"Dominica",c:"1-DM-0",b:"1",g:"DM"},{name:"Dominican Republic",c:"1-DO-0",b:"1",g:"DO"},{name:"East Timor",c:"670-TL-0",b:"670",g:"TL"},{name:"Ecuador",c:"593-EC-0",b:"593",g:"EC"},{name:"Egypt",
	c:"20-EG-0",b:"20",g:"EG"},{name:"El Salvador",c:"503-SV-0",b:"503",g:"SV"},{name:"Equatorial Guinea",c:"240-GQ-0",b:"240",g:"GQ"},{name:"Eritrea",c:"291-ER-0",b:"291",g:"ER"},{name:"Estonia",c:"372-EE-0",b:"372",g:"EE"},{name:"Ethiopia",c:"251-ET-0",b:"251",g:"ET"},{name:"Falkland Islands [Islas Malvinas]",c:"500-FK-0",b:"500",g:"FK"},{name:"Faroe Islands",c:"298-FO-0",b:"298",g:"FO"},{name:"Fiji",c:"679-FJ-0",b:"679",g:"FJ"},{name:"Finland",c:"358-FI-0",b:"358",g:"FI"},{name:"France",c:"33-FR-0",
	b:"33",g:"FR"},{name:"French Guiana",c:"594-GF-0",b:"594",g:"GF"},{name:"French Polynesia",c:"689-PF-0",b:"689",g:"PF"},{name:"Gabon",c:"241-GA-0",b:"241",g:"GA"},{name:"Gambia",c:"220-GM-0",b:"220",g:"GM"},{name:"Georgia",c:"995-GE-0",b:"995",g:"GE"},{name:"Germany",c:"49-DE-0",b:"49",g:"DE"},{name:"Ghana",c:"233-GH-0",b:"233",g:"GH"},{name:"Gibraltar",c:"350-GI-0",b:"350",g:"GI"},{name:"Greece",c:"30-GR-0",b:"30",g:"GR"},{name:"Greenland",c:"299-GL-0",b:"299",g:"GL"},{name:"Grenada",c:"1-GD-0",
	b:"1",g:"GD"},{name:"Guadeloupe",c:"590-GP-0",b:"590",g:"GP"},{name:"Guam",c:"1-GU-0",b:"1",g:"GU"},{name:"Guatemala",c:"502-GT-0",b:"502",g:"GT"},{name:"Guernsey",c:"44-GG-0",b:"44",g:"GG"},{name:"Guinea Conakry",c:"224-GN-0",b:"224",g:"GN"},{name:"Guinea-Bissau",c:"245-GW-0",b:"245",g:"GW"},{name:"Guyana",c:"592-GY-0",b:"592",g:"GY"},{name:"Haiti",c:"509-HT-0",b:"509",g:"HT"},{name:"Heard Island and McDonald Islands",c:"672-HM-0",b:"672",g:"HM"},{name:"Honduras",c:"504-HN-0",b:"504",g:"HN"},{name:"Hong Kong",
	c:"852-HK-0",b:"852",g:"HK"},{name:"Hungary",c:"36-HU-0",b:"36",g:"HU"},{name:"Iceland",c:"354-IS-0",b:"354",g:"IS"},{name:"India",c:"91-IN-0",b:"91",g:"IN"},{name:"Indonesia",c:"62-ID-0",b:"62",g:"ID"},{name:"Iran",c:"98-IR-0",b:"98",g:"IR"},{name:"Iraq",c:"964-IQ-0",b:"964",g:"IQ"},{name:"Ireland",c:"353-IE-0",b:"353",g:"IE"},{name:"Isle of Man",c:"44-IM-0",b:"44",g:"IM"},{name:"Israel",c:"972-IL-0",b:"972",g:"IL"},{name:"Italy",c:"39-IT-0",b:"39",g:"IT"},{name:"Jamaica",c:"1-JM-0",b:"1",g:"JM"},
	{name:"Japan",c:"81-JP-0",b:"81",g:"JP"},{name:"Jersey",c:"44-JE-0",b:"44",g:"JE"},{name:"Jordan",c:"962-JO-0",b:"962",g:"JO"},{name:"Kazakhstan",c:"7-KZ-0",b:"7",g:"KZ"},{name:"Kenya",c:"254-KE-0",b:"254",g:"KE"},{name:"Kiribati",c:"686-KI-0",b:"686",g:"KI"},{name:"Kosovo",c:"377-XK-0",b:"377",g:"XK"},{name:"Kosovo",c:"381-XK-0",b:"381",g:"XK"},{name:"Kosovo",c:"386-XK-0",b:"386",g:"XK"},{name:"Kuwait",c:"965-KW-0",b:"965",g:"KW"},{name:"Kyrgyzstan",c:"996-KG-0",b:"996",g:"KG"},{name:"Laos",c:"856-LA-0",
	b:"856",g:"LA"},{name:"Latvia",c:"371-LV-0",b:"371",g:"LV"},{name:"Lebanon",c:"961-LB-0",b:"961",g:"LB"},{name:"Lesotho",c:"266-LS-0",b:"266",g:"LS"},{name:"Liberia",c:"231-LR-0",b:"231",g:"LR"},{name:"Libya",c:"218-LY-0",b:"218",g:"LY"},{name:"Liechtenstein",c:"423-LI-0",b:"423",g:"LI"},{name:"Lithuania",c:"370-LT-0",b:"370",g:"LT"},{name:"Luxembourg",c:"352-LU-0",b:"352",g:"LU"},{name:"Macau",c:"853-MO-0",b:"853",g:"MO"},{name:"Macedonia",c:"389-MK-0",b:"389",g:"MK"},{name:"Madagascar",c:"261-MG-0",
	b:"261",g:"MG"},{name:"Malawi",c:"265-MW-0",b:"265",g:"MW"},{name:"Malaysia",c:"60-MY-0",b:"60",g:"MY"},{name:"Maldives",c:"960-MV-0",b:"960",g:"MV"},{name:"Mali",c:"223-ML-0",b:"223",g:"ML"},{name:"Malta",c:"356-MT-0",b:"356",g:"MT"},{name:"Marshall Islands",c:"692-MH-0",b:"692",g:"MH"},{name:"Martinique",c:"596-MQ-0",b:"596",g:"MQ"},{name:"Mauritania",c:"222-MR-0",b:"222",g:"MR"},{name:"Mauritius",c:"230-MU-0",b:"230",g:"MU"},{name:"Mayotte",c:"262-YT-0",b:"262",g:"YT"},{name:"Mexico",c:"52-MX-0",
	b:"52",g:"MX"},{name:"Micronesia",c:"691-FM-0",b:"691",g:"FM"},{name:"Moldova",c:"373-MD-0",b:"373",g:"MD"},{name:"Monaco",c:"377-MC-0",b:"377",g:"MC"},{name:"Mongolia",c:"976-MN-0",b:"976",g:"MN"},{name:"Montenegro",c:"382-ME-0",b:"382",g:"ME"},{name:"Montserrat",c:"1-MS-0",b:"1",g:"MS"},{name:"Morocco",c:"212-MA-0",b:"212",g:"MA"},{name:"Mozambique",c:"258-MZ-0",b:"258",g:"MZ"},{name:"Myanmar [Burma]",c:"95-MM-0",b:"95",g:"MM"},{name:"Namibia",c:"264-NA-0",b:"264",g:"NA"},{name:"Nauru",c:"674-NR-0",
	b:"674",g:"NR"},{name:"Nepal",c:"977-NP-0",b:"977",g:"NP"},{name:"Netherlands",c:"31-NL-0",b:"31",g:"NL"},{name:"New Caledonia",c:"687-NC-0",b:"687",g:"NC"},{name:"New Zealand",c:"64-NZ-0",b:"64",g:"NZ"},{name:"Nicaragua",c:"505-NI-0",b:"505",g:"NI"},{name:"Niger",c:"227-NE-0",b:"227",g:"NE"},{name:"Nigeria",c:"234-NG-0",b:"234",g:"NG"},{name:"Niue",c:"683-NU-0",b:"683",g:"NU"},{name:"Norfolk Island",c:"672-NF-0",b:"672",g:"NF"},{name:"North Korea",c:"850-KP-0",b:"850",g:"KP"},{name:"Northern Mariana Islands",
	c:"1-MP-0",b:"1",g:"MP"},{name:"Norway",c:"47-NO-0",b:"47",g:"NO"},{name:"Oman",c:"968-OM-0",b:"968",g:"OM"},{name:"Pakistan",c:"92-PK-0",b:"92",g:"PK"},{name:"Palau",c:"680-PW-0",b:"680",g:"PW"},{name:"Palestinian Territories",c:"970-PS-0",b:"970",g:"PS"},{name:"Panama",c:"507-PA-0",b:"507",g:"PA"},{name:"Papua New Guinea",c:"675-PG-0",b:"675",g:"PG"},{name:"Paraguay",c:"595-PY-0",b:"595",g:"PY"},{name:"Peru",c:"51-PE-0",b:"51",g:"PE"},{name:"Philippines",c:"63-PH-0",b:"63",g:"PH"},{name:"Poland",
	c:"48-PL-0",b:"48",g:"PL"},{name:"Portugal",c:"351-PT-0",b:"351",g:"PT"},{name:"Puerto Rico",c:"1-PR-0",b:"1",g:"PR"},{name:"Qatar",c:"974-QA-0",b:"974",g:"QA"},{name:"R\u00e9union",c:"262-RE-0",b:"262",g:"RE"},{name:"Romania",c:"40-RO-0",b:"40",g:"RO"},{name:"Russia",c:"7-RU-0",b:"7",g:"RU"},{name:"Rwanda",c:"250-RW-0",b:"250",g:"RW"},{name:"Saint Barth\u00e9lemy",c:"590-BL-0",b:"590",g:"BL"},{name:"Saint Helena",c:"290-SH-0",b:"290",g:"SH"},{name:"St. Kitts",c:"1-KN-0",b:"1",g:"KN"},{name:"St. Lucia",
	c:"1-LC-0",b:"1",g:"LC"},{name:"Saint Martin",c:"590-MF-0",b:"590",g:"MF"},{name:"Saint Pierre and Miquelon",c:"508-PM-0",b:"508",g:"PM"},{name:"St. Vincent",c:"1-VC-0",b:"1",g:"VC"},{name:"Samoa",c:"685-WS-0",b:"685",g:"WS"},{name:"San Marino",c:"378-SM-0",b:"378",g:"SM"},{name:"S\u00e3o Tom\u00e9 and Pr\u00edncipe",c:"239-ST-0",b:"239",g:"ST"},{name:"Saudi Arabia",c:"966-SA-0",b:"966",g:"SA"},{name:"Senegal",c:"221-SN-0",b:"221",g:"SN"},{name:"Serbia",c:"381-RS-0",b:"381",g:"RS"},{name:"Seychelles",
	c:"248-SC-0",b:"248",g:"SC"},{name:"Sierra Leone",c:"232-SL-0",b:"232",g:"SL"},{name:"Singapore",c:"65-SG-0",b:"65",g:"SG"},{name:"Sint Maarten",c:"1-SX-0",b:"1",g:"SX"},{name:"Slovakia",c:"421-SK-0",b:"421",g:"SK"},{name:"Slovenia",c:"386-SI-0",b:"386",g:"SI"},{name:"Solomon Islands",c:"677-SB-0",b:"677",g:"SB"},{name:"Somalia",c:"252-SO-0",b:"252",g:"SO"},{name:"South Africa",c:"27-ZA-0",b:"27",g:"ZA"},{name:"South Georgia and the South Sandwich Islands",c:"500-GS-0",b:"500",g:"GS"},{name:"South Korea",
	c:"82-KR-0",b:"82",g:"KR"},{name:"South Sudan",c:"211-SS-0",b:"211",g:"SS"},{name:"Spain",c:"34-ES-0",b:"34",g:"ES"},{name:"Sri Lanka",c:"94-LK-0",b:"94",g:"LK"},{name:"Sudan",c:"249-SD-0",b:"249",g:"SD"},{name:"Suriname",c:"597-SR-0",b:"597",g:"SR"},{name:"Svalbard and Jan Mayen",c:"47-SJ-0",b:"47",g:"SJ"},{name:"Swaziland",c:"268-SZ-0",b:"268",g:"SZ"},{name:"Sweden",c:"46-SE-0",b:"46",g:"SE"},{name:"Switzerland",c:"41-CH-0",b:"41",g:"CH"},{name:"Syria",c:"963-SY-0",b:"963",g:"SY"},{name:"Taiwan",
	c:"886-TW-0",b:"886",g:"TW"},{name:"Tajikistan",c:"992-TJ-0",b:"992",g:"TJ"},{name:"Tanzania",c:"255-TZ-0",b:"255",g:"TZ"},{name:"Thailand",c:"66-TH-0",b:"66",g:"TH"},{name:"Togo",c:"228-TG-0",b:"228",g:"TG"},{name:"Tokelau",c:"690-TK-0",b:"690",g:"TK"},{name:"Tonga",c:"676-TO-0",b:"676",g:"TO"},{name:"Trinidad/Tobago",c:"1-TT-0",b:"1",g:"TT"},{name:"Tunisia",c:"216-TN-0",b:"216",g:"TN"},{name:"Turkey",c:"90-TR-0",b:"90",g:"TR"},{name:"Turkmenistan",c:"993-TM-0",b:"993",g:"TM"},{name:"Turks and Caicos Islands",
	c:"1-TC-0",b:"1",g:"TC"},{name:"Tuvalu",c:"688-TV-0",b:"688",g:"TV"},{name:"U.S. Virgin Islands",c:"1-VI-0",b:"1",g:"VI"},{name:"Uganda",c:"256-UG-0",b:"256",g:"UG"},{name:"Ukraine",c:"380-UA-0",b:"380",g:"UA"},{name:"United Arab Emirates",c:"971-AE-0",b:"971",g:"AE"},{name:"United Kingdom",c:"44-GB-0",b:"44",g:"GB"},{name:"United States",c:"1-US-0",b:"1",g:"US"},{name:"Uruguay",c:"598-UY-0",b:"598",g:"UY"},{name:"Uzbekistan",c:"998-UZ-0",b:"998",g:"UZ"},{name:"Vanuatu",c:"678-VU-0",b:"678",g:"VU"},
	{name:"Vatican City",c:"379-VA-0",b:"379",g:"VA"},{name:"Venezuela",c:"58-VE-0",b:"58",g:"VE"},{name:"Vietnam",c:"84-VN-0",b:"84",g:"VN"},{name:"Wallis and Futuna",c:"681-WF-0",b:"681",g:"WF"},{name:"Western Sahara",c:"212-EH-0",b:"212",g:"EH"},{name:"Yemen",c:"967-YE-0",b:"967",g:"YE"},{name:"Zambia",c:"260-ZM-0",b:"260",g:"ZM"},{name:"Zimbabwe",c:"263-ZW-0",b:"263",g:"ZW"}];ki(hi);var li=new ei(hi);function mi(a,b){this.a=a;this.za=b}function ni(a){a=Za(a);var b=fi(li,a);return 0<b.length?new mi("1"==
	b[0].b?"1-US-0":b[0].c,Za(a.substr(b[0].b.length+1))):null}function oi(a){var b=gi(a.a);if(!b)throw Error("Country ID "+a.a+" not found.");return"+"+b.b+a.za}function pi(a,b){for(var c=0;c<a.length;c++)if(!Qa(qi,a[c])&&(null!==ri&&a[c]in ri||Qa(b,a[c])))return a[c];return null}var qi=["emailLink","password","phone"],ri={"facebook.com":"FacebookAuthProvider","github.com":"GithubAuthProvider","google.com":"GoogleAuthProvider",password:"EmailAuthProvider","twitter.com":"TwitterAuthProvider",phone:"PhoneAuthProvider"};
	function si(){this.a=new Yh;H(this.a,"acUiConfig");H(this.a,"autoUpgradeAnonymousUsers");H(this.a,"callbacks");H(this.a,"credentialHelper",ti);H(this.a,"immediateFederatedRedirect",!1);H(this.a,"popupMode",!1);H(this.a,"privacyPolicyUrl");H(this.a,"queryParameterForSignInSuccessUrl","signInSuccessUrl");H(this.a,"queryParameterForWidgetMode","mode");H(this.a,"signInFlow");H(this.a,"signInOptions");H(this.a,"signInSuccessUrl");H(this.a,"siteName");H(this.a,"tosUrl");H(this.a,"widgetUrl")}function ui(a){return a.a.get("acUiConfig")||
	null}function vi(a){var b=a.a.get("widgetUrl")||yf();return wi(a,b)}function wi(a,b){a=xi(a);for(var c=b.search(xb),d=0,e,f=[];0<=(e=wb(b,d,a,c));)f.push(b.substring(d,e)),d=Math.min(b.indexOf("&",e)+1||c,c);f.push(b.substr(d));b=f.join("").replace(zb,"$1");c="="+encodeURIComponent("select");(a+=c)?(c=b.indexOf("#"),0>c&&(c=b.length),d=b.indexOf("?"),0>d||d>c?(d=c,e=""):e=b.substring(d+1,c),b=[b.substr(0,d),e,b.substr(c)],c=b[1],b[1]=a?c?c+"&"+a:a:c,a=b[0]+(b[1]?"?"+b[1]:"")+b[2]):a=b;return a}function yi(a){var b=
	!!a.a.get("autoUpgradeAnonymousUsers");b&&!zi(a)&&vg('Missing "signInFailure" callback: "signInFailure" callback needs to be provided when "autoUpgradeAnonymousUsers" is set to true.',void 0);return b}function Ai(a){a=a.a.get("signInOptions")||[];for(var b=[],c=0;c<a.length;c++){var d=a[c];d=wa(d)?d:{provider:d};d.provider&&b.push(d)}return b}function Bi(a,b){a=Ai(a);for(var c=0;c<a.length;c++)if(a[c].provider===b)return a[c];return null}function Ci(a){return Ma(Ai(a),function(b){return b.provider})}
	function Di(a,b){a=Ei(a);for(var c=0;c<a.length;c++)if(a[c].providerId===b)return a[c];return null}function Ei(a){return Ma(Ai(a),function(b){return ri[b.provider]||Qa(Fi,b.provider)?{providerId:b.provider}:{providerId:b.provider,rb:b.providerName||null,Ga:b.buttonColor||null,Na:b.iconUrl?Fc(Ic(b.iconUrl)):null,Nb:b.loginHintKey||null}})}function Gi(a){var b=[],c=[];Ja(Ai(a),function(e){e.authMethod&&(b.push(e.authMethod),e.clientId&&c.push({uri:e.authMethod,clientId:e.clientId}))});var d=null;Hi(a)===
	Ii&&b.length&&(d={supportedIdTokenProviders:c,supportedAuthMethods:b});return d}function Ji(a,b){var c=null;Ja(Ai(a),function(d){d.authMethod===b&&(c=d.provider)});return c}function Ki(a){var b=null;Ja(Ai(a),function(d){d.provider==firebase.auth.PhoneAuthProvider.PROVIDER_ID&&wa(d.recaptchaParameters)&&!ta(d.recaptchaParameters)&&(b=jb(d.recaptchaParameters))});if(b){var c=[];Ja(Li,function(d){"undefined"!==typeof b[d]&&(c.push(d),delete b[d])});c.length&&Ag('The following provided "recaptchaParameters" keys are not allowed: '+
	c.join(", "))}return b}function Mi(a,b){a=(a=Bi(a,b))&&a.scopes;return ta(a)?a:[]}function Ni(a,b){a=(a=Bi(a,b))&&a.customParameters;return wa(a)?(a=jb(a),b===firebase.auth.GoogleAuthProvider.PROVIDER_ID&&delete a.login_hint,b===firebase.auth.GithubAuthProvider.PROVIDER_ID&&delete a.login,a):null}function Oi(a){a=Bi(a,firebase.auth.PhoneAuthProvider.PROVIDER_ID);var b=null;a&&"string"===typeof a.loginHint&&(b=ni(a.loginHint));return a&&a.defaultNationalNumber||b&&b.za||null}function Pi(a){var b=(a=
	Bi(a,firebase.auth.PhoneAuthProvider.PROVIDER_ID))&&a.defaultCountry||null;b=b&&ii(b);var c=null;a&&"string"===typeof a.loginHint&&(c=ni(a.loginHint));return b&&b[0]||c&&gi(c.a)||null}function Qi(a){a=Bi(a,firebase.auth.PhoneAuthProvider.PROVIDER_ID);if(!a)return null;var b=a.whitelistedCountries,c=a.blacklistedCountries;if("undefined"!==typeof b&&(!ta(b)||0==b.length))throw Error("WhitelistedCountries must be a non-empty array.");if("undefined"!==typeof c&&!ta(c))throw Error("BlacklistedCountries must be an array.");
	if(b&&c)throw Error("Both whitelistedCountries and blacklistedCountries are provided.");if(!b&&!c)return hi;a=[];if(b){c={};for(var d=0;d<b.length;d++){var e=ji(b[d]);for(var f=0;f<e.length;f++)c[e[f].c]=e[f]}for(var g in c)c.hasOwnProperty(g)&&a.push(c[g])}else{g={};for(b=0;b<c.length;b++)for(e=ji(c[b]),d=0;d<e.length;d++)g[e[d].c]=e[d];for(e=0;e<hi.length;e++)null!==g&&hi[e].c in g||a.push(hi[e])}return a}function xi(a){return $h(a.a,"queryParameterForWidgetMode")}function I(a){var b=a.a.get("tosUrl")||
	null;a=a.a.get("privacyPolicyUrl")||null;b&&!a&&Ag("Privacy Policy URL is missing, the link will not be displayed.");if(b&&a){if(va(b))return b;if("string"===typeof b)return function(){wf(b)}}return null}function Ri(a){var b=a.a.get("tosUrl")||null,c=a.a.get("privacyPolicyUrl")||null;c&&!b&&Ag("Term of Service URL is missing, the link will not be displayed.");if(b&&c){if(va(c))return c;if("string"===typeof c)return function(){wf(c)}}return null}function Si(a){return(a=Bi(a,firebase.auth.EmailAuthProvider.PROVIDER_ID))&&
	"undefined"!==typeof a.requireDisplayName?!!a.requireDisplayName:!0}function Ti(a){a=Bi(a,firebase.auth.EmailAuthProvider.PROVIDER_ID);return!(!a||a.signInMethod!==firebase.auth.EmailAuthProvider.EMAIL_LINK_SIGN_IN_METHOD)}function Ui(a){a=Bi(a,firebase.auth.EmailAuthProvider.PROVIDER_ID);return!(!a||!a.forceSameDevice)}function Vi(a){if(Ti(a)){var b={url:yf(),handleCodeInApp:!0};(a=Bi(a,firebase.auth.EmailAuthProvider.PROVIDER_ID))&&"function"===typeof a.emailLinkSignIn&&lb(b,a.emailLinkSignIn());
	b.url=Pb(yf(),b.url).toString();return b}return null}function Wi(a){var b=!!a.a.get("immediateFederatedRedirect"),c=Ci(a);a=Xi(a);return b&&1==c.length&&!Qa(qi,c[0])&&a==Yi}function Xi(a){a=a.a.get("signInFlow");for(var b in Zi)if(Zi[b]==a)return Zi[b];return Yi}function $i(a){return aj(a).uiShown||null}function bj(a){return aj(a).signInSuccess||null}function cj(a){return aj(a).signInSuccessWithAuthResult||null}function zi(a){return aj(a).signInFailure||null}function aj(a){return a.a.get("callbacks")||
	{}}function Hi(a){if("http:"!==(window.location&&window.location.protocol)&&"https:"!==(window.location&&window.location.protocol))return dj;a=a.a.get("credentialHelper");for(var b in ej)if(ej[b]==a)return ej[b];return ti}var ti="accountchooser.com",Ii="googleyolo",dj="none",ej={jc:ti,mc:Ii,NONE:dj},Yi="redirect",Zi={pc:"popup",qc:Yi},fj={lc:"callback",RECOVER_EMAIL:"recoverEmail",rc:"resetPassword",REVERT_SECOND_FACTOR_ADDITION:"revertSecondFactorAddition",sc:"select",tc:"signIn",VERIFY_AND_CHANGE_EMAIL:"verifyAndChangeEmail",
	VERIFY_EMAIL:"verifyEmail"},Fi=["anonymous"],Li=["sitekey","tabindex","callback","expired-callback"];var gj,hj,ij,jj,J={};function K(a,b,c,d){J[a].apply(null,Array.prototype.slice.call(arguments,1))}var kj=null;function lj(a){return!(!a||-32E3!=a.code||"Service unavailable"!=a.message)}function mj(a,b,c,d){kj||(a={callbacks:{empty:a,select:function(e,f){e&&e.account&&b?b(Cg(e.account)):c&&c(!lj(f))},store:a,update:a},language:"en",providers:void 0,ui:d},"undefined"!=typeof accountchooser&&accountchooser.Api&&
	accountchooser.Api.init?kj=accountchooser.Api.init(a):(kj=new nj(a),oj()))}function pj(a,b,c){function d(){var e=Pb(window.location.href,c).toString();kj.select(Ma(b||[],function(f){return f.aa()}),{clientCallbackUrl:e})}b&&b.length?d():kj.checkEmpty(function(e,f){e||f?a(!lj(f)):d()})}function nj(a){this.a=a;this.a.callbacks=this.a.callbacks||{}}function oj(){var a=kj;va(a.a.callbacks.empty)&&a.a.callbacks.empty()}l=nj.prototype;l.store=function(){va(this.a.callbacks.store)&&this.a.callbacks.store(void 0,
	qj)};l.select=function(){va(this.a.callbacks.select)&&this.a.callbacks.select(void 0,qj)};l.update=function(){va(this.a.callbacks.update)&&this.a.callbacks.update(void 0,qj)};l.checkDisabled=function(a){a(!0)};l.checkEmpty=function(a){a(void 0,qj)};l.checkAccountExist=function(a,b){b(void 0,qj)};l.checkShouldUpdate=function(a,b){b(void 0,qj)};var qj={code:-32E3,message:"Service unavailable",data:"Service is unavailable."};var rj=/MSIE ([\d.]+).*Windows NT ([\d.]+)/,sj=/Firefox\/([\d.]+)/,tj=/Opera[ \/]([\d.]+)(.*Version\/([\d.]+))?/,
	uj=/Chrome\/([\d.]+)/,vj=/((Windows NT ([\d.]+))|(Mac OS X ([\d_]+))).*Version\/([\d.]+).*Safari/,wj=/Mac OS X;.*(?!(Version)).*Safari/,xj=/Android ([\d.]+).*Safari/,yj=/OS ([\d_]+) like Mac OS X.*Mobile.*Safari/,zj=/Konqueror\/([\d.]+)/,Aj=/MSIE ([\d.]+).*Windows Phone OS ([\d.]+)/;function Bj(a,b){a=a.split(b||".");this.a=[];for(b=0;b<a.length;b++)this.a.push(parseInt(a[b],10))}function Cj(a,b){b instanceof Bj||(b=new Bj(String(b)));for(var c=Math.max(a.a.length,b.a.length),d=0;d<c;d++){var e=a.a[d],
	f=b.a[d];if(void 0!==e&&void 0!==f&&e!==f)return e-f;if(void 0===e)return-1;if(void 0===f)return 1}return 0}function Dj(a,b){return 0<=Cj(a,b)}function Ej(){var a=window.navigator&&window.navigator.userAgent;if(a){var b;if(b=a.match(tj)){var c=new Bj(b[3]||b[1]);return 0<=a.indexOf("Opera Mini")?!1:0<=a.indexOf("Opera Mobi")?0<=a.indexOf("Android")&&Dj(c,"10.1"):Dj(c,"8.0")}if(b=a.match(sj))return Dj(new Bj(b[1]),"2.0");if(b=a.match(uj))return Dj(new Bj(b[1]),"6.0");if(b=a.match(vj))return c=new Bj(b[6]),
	a=b[3]&&new Bj(b[3]),b=b[5]&&new Bj(b[5],"_"),(!(!a||!Dj(a,"6.0"))||!(!b||!Dj(b,"10.5.6")))&&Dj(c,"3.0");if(b=a.match(xj))return Dj(new Bj(b[1]),"3.0");if(b=a.match(yj))return Dj(new Bj(b[1],"_"),"4.0");if(b=a.match(zj))return Dj(new Bj(b[1]),"4.7");if(b=a.match(Aj))return c=new Bj(b[1]),a=new Bj(b[2]),Dj(c,"7.0")&&Dj(a,"7.0");if(b=a.match(rj))return c=new Bj(b[1]),a=new Bj(b[2]),Dj(c,"7.0")&&Dj(a,"6.0");if(a.match(wj))return!1}return!0}function Fj(a){if(a.classList)return a.classList;a=a.className;
	return r(a)&&a.match(/\S+/g)||[]}function Gj(a,b){return a.classList?a.classList.contains(b):Qa(Fj(a),b)}function Hj(a,b){a.classList?a.classList.add(b):Gj(a,b)||(a.className+=0<a.className.length?" "+b:b)}function Ij(a,b){a.classList?a.classList.remove(b):Gj(a,b)&&(a.className=La(Fj(a),function(c){return c!=b}).join(" "))}function Jj(a){var b=a.type;switch(r(b)&&b.toLowerCase()){case "checkbox":case "radio":return a.checked?a.value:null;case "select-one":return b=a.selectedIndex,0<=b?a.options[b].value:
	null;case "select-multiple":b=[];for(var c,d=0;c=a.options[d];d++)c.selected&&b.push(c.value);return b.length?b:null;default:return null!=a.value?a.value:null}}function Kj(a,b){var c=a.type;switch(r(c)&&c.toLowerCase()){case "checkbox":case "radio":a.checked=b;break;case "select-one":a.selectedIndex=-1;if(r(b))for(var d=0;c=a.options[d];d++)if(c.value==b){c.selected=!0;break}break;case "select-multiple":r(b)&&(b=[b]);for(d=0;c=a.options[d];d++)if(c.selected=!1,b)for(var e,f=0;e=b[f];f++)c.value==
	e&&(c.selected=!0);break;default:a.value=null!=b?b:""}}function Lj(a){if(a.altKey&&!a.ctrlKey||a.metaKey||112<=a.keyCode&&123>=a.keyCode)return!1;if(Mj(a.keyCode))return!0;switch(a.keyCode){case 18:case 20:case 93:case 17:case 40:case 35:case 27:case 36:case 45:case 37:case 224:case 91:case 144:case 12:case 34:case 33:case 19:case 255:case 44:case 39:case 145:case 16:case 38:case 252:case 224:case 92:return!1;case 0:return!jc;default:return 166>a.keyCode||183<a.keyCode}}function Nj(a,b,c,d,e,f){if(kc&&
	!sc("525"))return!0;if(mc&&e)return Mj(a);if(e&&!d)return!1;if(!jc){"number"==typeof b&&(b=Oj(b));var g=17==b||18==b||mc&&91==b;if((!c||mc)&&g||mc&&16==b&&(d||f))return!1}if((kc||hc)&&d&&c)switch(a){case 220:case 219:case 221:case 192:case 186:case 189:case 187:case 188:case 190:case 191:case 192:case 222:return!1}if(z&&d&&b==a)return!1;switch(a){case 13:return jc?f||e?!1:!(c&&d):!0;case 27:return!(kc||hc||jc)}return jc&&(d||e||f)?!1:Mj(a)}function Mj(a){if(48<=a&&57>=a||96<=a&&106>=a||65<=a&&90>=
	a||(kc||hc)&&0==a)return!0;switch(a){case 32:case 43:case 63:case 64:case 107:case 109:case 110:case 111:case 186:case 59:case 189:case 187:case 61:case 188:case 190:case 191:case 192:case 222:case 219:case 220:case 221:case 163:return!0;case 173:return jc;default:return!1}}function Oj(a){if(jc)a=Pj(a);else if(mc&&kc)switch(a){case 93:a=91}return a}function Pj(a){switch(a){case 61:return 187;case 59:return 186;case 173:return 189;case 224:return 91;case 0:return 224;default:return a}}function Qj(a){F.call(this);
	this.a=a;oe(a,"keydown",this.f,!1,this);oe(a,"click",this.h,!1,this)}w(Qj,F);Qj.prototype.f=function(a){(13==a.keyCode||kc&&3==a.keyCode)&&Rj(this,a)};Qj.prototype.h=function(a){Rj(this,a)};function Rj(a,b){var c=new Sj(b);if(Be(a,c)){c=new Tj(b);try{Be(a,c)}finally{b.stopPropagation()}}}Qj.prototype.m=function(){Qj.M.m.call(this);we(this.a,"keydown",this.f,!1,this);we(this.a,"click",this.h,!1,this);delete this.a};function Tj(a){ce.call(this,a.a);this.type="action"}w(Tj,ce);function Sj(a){ce.call(this,
	a.a);this.type="beforeaction"}w(Sj,ce);function Uj(a){F.call(this);this.a=a;a=z?"focusout":"blur";this.f=oe(this.a,z?"focusin":"focus",this,!z);this.h=oe(this.a,a,this,!z)}w(Uj,F);Uj.prototype.handleEvent=function(a){var b=new ce(a.a);b.type="focusin"==a.type||"focus"==a.type?"focusin":"focusout";Be(this,b)};Uj.prototype.m=function(){Uj.M.m.call(this);xe(this.f);xe(this.h);delete this.a};function Vj(a,b){F.call(this);this.f=a||1;this.a=b||p;this.h=t(this.fc,this);this.j=Ca()}w(Vj,F);l=Vj.prototype;
	l.Ka=!1;l.$=null;l.fc=function(){if(this.Ka){var a=Ca()-this.j;0<a&&a<.8*this.f?this.$=this.a.setTimeout(this.h,this.f-a):(this.$&&(this.a.clearTimeout(this.$),this.$=null),Be(this,"tick"),this.Ka&&(Wj(this),this.start()))}};l.start=function(){this.Ka=!0;this.$||(this.$=this.a.setTimeout(this.h,this.f),this.j=Ca())};function Wj(a){a.Ka=!1;a.$&&(a.a.clearTimeout(a.$),a.$=null)}l.m=function(){Vj.M.m.call(this);Wj(this);delete this.a};function Xj(a,b){if(va(a))b&&(a=t(a,b));else if(a&&"function"==typeof a.handleEvent)a=
	t(a.handleEvent,a);else throw Error("Invalid listener argument");return 2147483647<Number(0)?-1:p.setTimeout(a,0)}function Yj(a){Td.call(this);this.f=a;this.a={}}w(Yj,Td);var Zj=[];function ak(a,b,c,d){ta(c)||(c&&(Zj[0]=c.toString()),c=Zj);for(var e=0;e<c.length;e++){var f=oe(b,c[e],d||a.handleEvent,!1,a.f||a);if(!f)break;a.a[f.key]=f}}function bk(a){ib(a.a,function(b,c){this.a.hasOwnProperty(c)&&xe(b)},a);a.a={}}Yj.prototype.m=function(){Yj.M.m.call(this);bk(this)};Yj.prototype.handleEvent=function(){throw Error("EventHandler.handleEvent not implemented");
	};function ck(a){F.call(this);this.a=null;this.f=a;a=z||hc||kc&&!sc("531")&&"TEXTAREA"==a.tagName;this.h=new Yj(this);ak(this.h,this.f,a?["keydown","paste","cut","drop","input"]:"input",this)}w(ck,F);ck.prototype.handleEvent=function(a){if("input"==a.type)z&&sc(10)&&0==a.keyCode&&0==a.j||(dk(this),Be(this,ek(a)));else if("keydown"!=a.type||Lj(a)){var b="keydown"==a.type?this.f.value:null;z&&229==a.keyCode&&(b=null);var c=ek(a);dk(this);this.a=Xj(function(){this.a=null;this.f.value!=b&&Be(this,c)},
	this)}};function dk(a){null!=a.a&&(p.clearTimeout(a.a),a.a=null)}function ek(a){a=new ce(a.a);a.type="input";return a}ck.prototype.m=function(){ck.M.m.call(this);this.h.o();dk(this);delete this.f};function fk(a,b){F.call(this);a&&(this.Pa&&gk(this),this.qa=a,this.Oa=oe(this.qa,"keypress",this,b),this.Za=oe(this.qa,"keydown",this.Ib,b,this),this.Pa=oe(this.qa,"keyup",this.Jb,b,this))}w(fk,F);l=fk.prototype;l.qa=null;l.Oa=null;l.Za=null;l.Pa=null;l.T=-1;l.W=-1;l.Va=!1;var hk={3:13,12:144,63232:38,63233:40,
	63234:37,63235:39,63236:112,63237:113,63238:114,63239:115,63240:116,63241:117,63242:118,63243:119,63244:120,63245:121,63246:122,63247:123,63248:44,63272:46,63273:36,63275:35,63276:33,63277:34,63289:144,63302:45},ik={Up:38,Down:40,Left:37,Right:39,Enter:13,F1:112,F2:113,F3:114,F4:115,F5:116,F6:117,F7:118,F8:119,F9:120,F10:121,F11:122,F12:123,"U+007F":46,Home:36,End:35,PageUp:33,PageDown:34,Insert:45},jk=!kc||sc("525"),kk=mc&&jc;l=fk.prototype;l.Ib=function(a){if(kc||hc)if(17==this.T&&!a.ctrlKey||18==
	this.T&&!a.altKey||mc&&91==this.T&&!a.metaKey)this.W=this.T=-1;-1==this.T&&(a.ctrlKey&&17!=a.keyCode?this.T=17:a.altKey&&18!=a.keyCode?this.T=18:a.metaKey&&91!=a.keyCode&&(this.T=91));jk&&!Nj(a.keyCode,this.T,a.shiftKey,a.ctrlKey,a.altKey,a.metaKey)?this.handleEvent(a):(this.W=Oj(a.keyCode),kk&&(this.Va=a.altKey))};l.Jb=function(a){this.W=this.T=-1;this.Va=a.altKey};l.handleEvent=function(a){var b=a.a,c=b.altKey;if(z&&"keypress"==a.type){var d=this.W;var e=13!=d&&27!=d?b.keyCode:0}else(kc||hc)&&"keypress"==
	a.type?(d=this.W,e=0<=b.charCode&&63232>b.charCode&&Mj(d)?b.charCode:0):gc&&!kc?(d=this.W,e=Mj(d)?b.keyCode:0):("keypress"==a.type?(kk&&(c=this.Va),b.keyCode==b.charCode?32>b.keyCode?(d=b.keyCode,e=0):(d=this.W,e=b.charCode):(d=b.keyCode||this.W,e=b.charCode||0)):(d=b.keyCode||this.W,e=b.charCode||0),mc&&63==e&&224==d&&(d=191));var f=d=Oj(d);d?63232<=d&&d in hk?f=hk[d]:25==d&&a.shiftKey&&(f=9):b.keyIdentifier&&b.keyIdentifier in ik&&(f=ik[b.keyIdentifier]);jc&&jk&&"keypress"==a.type&&!Nj(f,this.T,
	a.shiftKey,a.ctrlKey,c,a.metaKey)||(a=f==this.T,this.T=f,b=new lk(f,e,a,b),b.altKey=c,Be(this,b))};l.R=function(){return this.qa};function gk(a){a.Oa&&(xe(a.Oa),xe(a.Za),xe(a.Pa),a.Oa=null,a.Za=null,a.Pa=null);a.qa=null;a.T=-1;a.W=-1}l.m=function(){fk.M.m.call(this);gk(this)};function lk(a,b,c,d){ce.call(this,d);this.type="key";this.keyCode=a;this.j=b;this.repeat=c}w(lk,ce);function mk(a,b,c,d){this.top=a;this.right=b;this.bottom=c;this.left=d}mk.prototype.toString=function(){return"("+this.top+"t, "+
	this.right+"r, "+this.bottom+"b, "+this.left+"l)"};mk.prototype.ceil=function(){this.top=Math.ceil(this.top);this.right=Math.ceil(this.right);this.bottom=Math.ceil(this.bottom);this.left=Math.ceil(this.left);return this};mk.prototype.floor=function(){this.top=Math.floor(this.top);this.right=Math.floor(this.right);this.bottom=Math.floor(this.bottom);this.left=Math.floor(this.left);return this};mk.prototype.round=function(){this.top=Math.round(this.top);this.right=Math.round(this.right);this.bottom=
	Math.round(this.bottom);this.left=Math.round(this.left);return this};function nk(a,b){var c=Xc(a);return c.defaultView&&c.defaultView.getComputedStyle&&(a=c.defaultView.getComputedStyle(a,null))?a[b]||a.getPropertyValue(b)||"":""}function ok(a){try{var b=a.getBoundingClientRect()}catch(c){return{left:0,top:0,right:0,bottom:0}}z&&a.ownerDocument.body&&(a=a.ownerDocument,b.left-=a.documentElement.clientLeft+a.body.clientLeft,b.top-=a.documentElement.clientTop+a.body.clientTop);return b}function pk(a,
	b){b=b||cd(document);var c=b||cd(document);var d=qk(a),e=qk(c);if(!z||9<=Number(tc)){g=nk(c,"borderLeftWidth");var f=nk(c,"borderRightWidth");h=nk(c,"borderTopWidth");k=nk(c,"borderBottomWidth");f=new mk(parseFloat(h),parseFloat(f),parseFloat(k),parseFloat(g))}else{var g=rk(c,"borderLeft");f=rk(c,"borderRight");var h=rk(c,"borderTop"),k=rk(c,"borderBottom");f=new mk(h,f,k,g)}c==cd(document)?(g=d.a-c.scrollLeft,d=d.f-c.scrollTop,!z||10<=Number(tc)||(g+=f.left,d+=f.top)):(g=d.a-e.a-f.left,d=d.f-e.f-
	f.top);e=a.offsetWidth;f=a.offsetHeight;h=kc&&!e&&!f;na(e)&&!h||!a.getBoundingClientRect?a=new Uc(e,f):(a=ok(a),a=new Uc(a.right-a.left,a.bottom-a.top));e=c.clientHeight-a.height;f=c.scrollLeft;h=c.scrollTop;f+=Math.min(g,Math.max(g-(c.clientWidth-a.width),0));h+=Math.min(d,Math.max(d-e,0));c=new Tc(f,h);b.scrollLeft=c.a;b.scrollTop=c.f}function qk(a){var b=Xc(a),c=new Tc(0,0);var d=b?Xc(b):document;d=!z||9<=Number(tc)||"CSS1Compat"==Vc(d).a.compatMode?d.documentElement:d.body;if(a==d)return c;a=
	ok(a);d=Vc(b).a;b=cd(d);d=d.parentWindow||d.defaultView;b=z&&sc("10")&&d.pageYOffset!=b.scrollTop?new Tc(b.scrollLeft,b.scrollTop):new Tc(d.pageXOffset||b.scrollLeft,d.pageYOffset||b.scrollTop);c.a=a.left+b.a;c.f=a.top+b.f;return c}var sk={thin:2,medium:4,thick:6};function rk(a,b){if("none"==(a.currentStyle?a.currentStyle[b+"Style"]:null))return 0;var c=a.currentStyle?a.currentStyle[b+"Width"]:null;if(c in sk)a=sk[c];else if(/^\d+px?$/.test(c))a=parseInt(c,10);else{b=a.style.left;var d=a.runtimeStyle.left;
	a.runtimeStyle.left=a.currentStyle.left;a.style.left=c;c=a.style.pixelLeft;a.style.left=b;a.runtimeStyle.left=d;a=+c}return a}function tk(){}ra(tk);tk.prototype.a=0;function uk(a){F.call(this);this.s=a||Vc();this.eb=null;this.na=!1;this.f=null;this.L=void 0;this.oa=this.Ca=this.X=null}w(uk,F);l=uk.prototype;l.Kb=tk.Ya();l.R=function(){return this.f};function L(a,b){return a.f?$c(b,a.f||a.s.a):null}function vk(a){a.L||(a.L=new Yj(a));return a.L}l.$a=function(a){if(this.X&&this.X!=a)throw Error("Method not supported");
	uk.M.$a.call(this,a)};l.lb=function(){this.f=this.s.a.createElement("DIV")};l.render=function(a){if(this.na)throw Error("Component already rendered");this.f||this.lb();a?a.insertBefore(this.f,null):this.s.a.body.appendChild(this.f);this.X&&!this.X.na||this.v()};l.v=function(){this.na=!0;wk(this,function(a){!a.na&&a.R()&&a.v()})};l.ya=function(){wk(this,function(a){a.na&&a.ya()});this.L&&bk(this.L);this.na=!1};l.m=function(){this.na&&this.ya();this.L&&(this.L.o(),delete this.L);wk(this,function(a){a.o()});
	this.f&&dd(this.f);this.X=this.f=this.oa=this.Ca=null;uk.M.m.call(this)};function wk(a,b){a.Ca&&Ja(a.Ca,b,void 0)}l.removeChild=function(a,b){if(a){var c=r(a)?a:a.eb||(a.eb=":"+(a.Kb.a++).toString(36));this.oa&&c?(a=this.oa,a=(null!==a&&c in a?a[c]:void 0)||null):a=null;if(c&&a){var d=this.oa;c in d&&delete d[c];Ra(this.Ca,a);b&&(a.ya(),a.f&&dd(a.f));b=a;if(null==b)throw Error("Unable to set parent component");b.X=null;uk.M.$a.call(b,null)}}if(!a)throw Error("Child is not in parent component");return a};
	function M(a,b){var c=fd(a,"firebaseui-textfield");b?(Ij(a,"firebaseui-input-invalid"),Hj(a,"firebaseui-input"),c&&Ij(c,"firebaseui-textfield-invalid")):(Ij(a,"firebaseui-input"),Hj(a,"firebaseui-input-invalid"),c&&Hj(c,"firebaseui-textfield-invalid"))}function xk(a,b,c){b=new ck(b);Wd(a,Ba(Xd,b));ak(vk(a),b,"input",c)}function yk(a,b,c){b=new fk(b);Wd(a,Ba(Xd,b));ak(vk(a),b,"key",function(d){13==d.keyCode&&(d.stopPropagation(),d.preventDefault(),c(d))})}function zk(a,b,c){b=new Uj(b);Wd(a,Ba(Xd,
	b));ak(vk(a),b,"focusin",c)}function Ak(a,b,c){b=new Uj(b);Wd(a,Ba(Xd,b));ak(vk(a),b,"focusout",c)}function N(a,b,c){b=new Qj(b);Wd(a,Ba(Xd,b));ak(vk(a),b,"action",function(d){d.stopPropagation();d.preventDefault();c(d)})}function Bk(a){Hj(a,"firebaseui-hidden")}function Ck(a,b){b&&ed(a,b);Ij(a,"firebaseui-hidden")}function Dk(a){return!Gj(a,"firebaseui-hidden")&&"none"!=a.style.display}function Ek(a){a=a||{};var b=a.email,c=a.disabled,d='<div class="firebaseui-textfield mdl-textfield mdl-js-textfield mdl-textfield--floating-label"><label class="mdl-textfield__label firebaseui-label" for="ui-sign-in-email-input">';
	d=a.vc?d+"Enter new email address":d+"Email";d+='</label><input type="email" name="email" id="ui-sign-in-email-input" autocomplete="username" class="mdl-textfield__input firebaseui-input firebaseui-id-email" value="'+yd(null!=b?b:"")+'"'+(c?"disabled":"")+'></div><div class="firebaseui-error-wrapper"><p class="firebaseui-error firebaseui-text-input-error firebaseui-hidden firebaseui-id-email-error"></p></div>';return B(d)}function Fk(a){a=a||{};a=a.label;var b='<button type="submit" class="firebaseui-id-submit firebaseui-button mdl-button mdl-js-button mdl-button--raised mdl-button--colored">';
	b=a?b+A(a):b+"Next";return B(b+"</button>")}function Gk(){var a=""+Fk({label:D("Sign In")});return B(a)}function Hk(){var a=""+Fk({label:D("Save")});return B(a)}function Ik(){var a=""+Fk({label:D("Continue")});return B(a)}function Jk(a){a=a||{};a=a.label;var b='<div class="firebaseui-new-password-component"><div class="firebaseui-textfield mdl-textfield mdl-js-textfield mdl-textfield--floating-label"><label class="mdl-textfield__label firebaseui-label" for="ui-sign-in-new-password-input">';b=a?b+
	A(a):b+"Choose password";return B(b+'</label><input type="password" name="newPassword" id="ui-sign-in-new-password-input" autocomplete="new-password" class="mdl-textfield__input firebaseui-input firebaseui-id-new-password"></div><a href="javascript:void(0)" class="firebaseui-input-floating-button firebaseui-id-password-toggle firebaseui-input-toggle-on firebaseui-input-toggle-blur"></a><div class="firebaseui-error-wrapper"><p class="firebaseui-error firebaseui-text-input-error firebaseui-hidden firebaseui-id-new-password-error"></p></div></div>')}
	function Kk(){var a={};var b='<div class="firebaseui-textfield mdl-textfield mdl-js-textfield mdl-textfield--floating-label"><label class="mdl-textfield__label firebaseui-label" for="ui-sign-in-password-input">';b=a.current?b+"Current password":b+"Password";return B(b+'</label><input type="password" name="password" id="ui-sign-in-password-input" autocomplete="current-password" class="mdl-textfield__input firebaseui-input firebaseui-id-password"></div><div class="firebaseui-error-wrapper"><p class="firebaseui-error firebaseui-text-input-error firebaseui-hidden firebaseui-id-password-error"></p></div>')}
	function Lk(){return B('<a class="firebaseui-link firebaseui-id-secondary-link" href="javascript:void(0)">Trouble signing in?</a>')}function Mk(a){a=a||{};a=a.label;var b='<button class="firebaseui-id-secondary-link firebaseui-button mdl-button mdl-js-button mdl-button--primary">';b=a?b+A(a):b+"Cancel";return B(b+"</button>")}function Nk(a){var b="";a.G&&a.F&&(b+='<ul class="firebaseui-tos-list firebaseui-tos"><li class="firebaseui-inline-list-item"><a href="javascript:void(0)" class="firebaseui-link firebaseui-tos-link" target="_blank">Terms of Service</a></li><li class="firebaseui-inline-list-item"><a href="javascript:void(0)" class="firebaseui-link firebaseui-pp-link" target="_blank">Privacy Policy</a></li></ul>');
	return B(b)}function Ok(a){var b="";a.G&&a.F&&(b+='<p class="firebaseui-tos firebaseui-tospp-full-message">By continuing, you are indicating that you accept our <a href="javascript:void(0)" class="firebaseui-link firebaseui-tos-link" target="_blank">Terms of Service</a> and <a href="javascript:void(0)" class="firebaseui-link firebaseui-pp-link" target="_blank">Privacy Policy</a>.</p>');return B(b)}function Pk(a){a='<div class="firebaseui-info-bar firebaseui-id-info-bar"><p class="firebaseui-info-bar-message">'+
	A(a.message)+'&nbsp;&nbsp;<a href="javascript:void(0)" class="firebaseui-link firebaseui-id-dismiss-info-bar">Dismiss</a></p></div>';return B(a)}Pk.A="firebaseui.auth.soy2.element.infoBar";function Qk(a){var b=a.content;a=a.Bb;return B('<dialog class="mdl-dialog firebaseui-dialog firebaseui-id-dialog'+(a?" "+yd(a):"")+'">'+A(b)+"</dialog>")}function Rk(a){var b=a.message;return B(Qk({content:xd('<div class="firebaseui-dialog-icon-wrapper"><div class="'+yd(a.Ma)+' firebaseui-dialog-icon"></div></div><div class="firebaseui-progress-dialog-message">'+
	A(b)+"</div>")}))}Rk.A="firebaseui.auth.soy2.element.progressDialog";function Sk(a){var b='<div class="firebaseui-list-box-actions">';a=a.items;for(var c=a.length,d=0;d<c;d++){var e=a[d];b+='<button type="button" data-listboxid="'+yd(e.id)+'" class="mdl-button firebaseui-id-list-box-dialog-button firebaseui-list-box-dialog-button">'+(e.Ma?'<div class="firebaseui-list-box-icon-wrapper"><div class="firebaseui-list-box-icon '+yd(e.Ma)+'"></div></div>':"")+'<div class="firebaseui-list-box-label-wrapper">'+
	A(e.label)+"</div></button>"}b=""+Qk({Bb:D("firebaseui-list-box-dialog"),content:xd(b+"</div>")});return B(b)}Sk.A="firebaseui.auth.soy2.element.listBoxDialog";function Tk(a){a=a||{};return B(a.vb?'<div class="mdl-spinner mdl-spinner--single-color mdl-js-spinner is-active firebaseui-busy-indicator firebaseui-id-busy-indicator"></div>':'<div class="mdl-progress mdl-js-progress mdl-progress__indeterminate firebaseui-busy-indicator firebaseui-id-busy-indicator"></div>')}Tk.A="firebaseui.auth.soy2.element.busyIndicator";
	function Uk(a,b){a=a||{};a=a.ga;return C(a.rb?a.rb:b.ib[a.providerId]?""+b.ib[a.providerId]:0==(""+a.providerId).indexOf("saml.")?(""+a.providerId).substring(5):0==(""+a.providerId).indexOf("oidc.")?(""+a.providerId).substring(5):""+a.providerId)}function Vk(a){Wk(a,"upgradeElement")}function Xk(a){Wk(a,"downgradeElements")}var Yk=["mdl-js-textfield","mdl-js-progress","mdl-js-spinner","mdl-js-button"];function Wk(a,b){a&&window.componentHandler&&window.componentHandler[b]&&Ja(Yk,function(c){if(Gj(a,
	c))window.componentHandler[b](a);Ja(Yc(c,a),function(d){window.componentHandler[b](d)})})}function Zk(a,b,c){$k.call(this);document.body.appendChild(a);a.showModal||window.dialogPolyfill.registerDialog(a);a.showModal();Vk(a);b&&N(this,a,function(f){var g=a.getBoundingClientRect();(f.clientX<g.left||g.left+g.width<f.clientX||f.clientY<g.top||g.top+g.height<f.clientY)&&$k.call(this)});if(!c){var d=this.R().parentElement||this.R().parentNode;if(d){var e=this;this.da=function(){if(a.open){var f=a.getBoundingClientRect().height,
	g=d.getBoundingClientRect().height,h=d.getBoundingClientRect().top-document.body.getBoundingClientRect().top,k=d.getBoundingClientRect().left-document.body.getBoundingClientRect().left,m=a.getBoundingClientRect().width,q=d.getBoundingClientRect().width;a.style.top=(h+(g-f)/2).toString()+"px";f=k+(q-m)/2;a.style.left=f.toString()+"px";a.style.right=(document.body.getBoundingClientRect().width-f-m).toString()+"px"}else window.removeEventListener("resize",e.da)};this.da();window.addEventListener("resize",
	this.da,!1)}}}function $k(){var a=al.call(this);a&&(Xk(a),a.open&&a.close(),dd(a),this.da&&window.removeEventListener("resize",this.da))}function al(){return $c("firebaseui-id-dialog")}function bl(){dd(cl.call(this))}function cl(){return L(this,"firebaseui-id-info-bar")}function dl(){return L(this,"firebaseui-id-dismiss-info-bar")}var el={xa:{"google.com":"https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg","github.com":"https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/github.svg",
	"facebook.com":"https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/facebook.svg","twitter.com":"https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/twitter.svg",password:"https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/mail.svg",phone:"https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/phone.svg",anonymous:"https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/anonymous.png","microsoft.com":"https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/microsoft.svg","yahoo.com":"https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/yahoo.svg",
	"apple.com":"https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/apple.png",saml:"https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/saml.svg",oidc:"https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/oidc.svg"},wa:{"google.com":"#ffffff","github.com":"#333333","facebook.com":"#3b5998","twitter.com":"#55acee",password:"#db4437",phone:"#02bd7e",anonymous:"#f4b400","microsoft.com":"#2F2F2F","yahoo.com":"#720E9E","apple.com":"#000000",saml:"#007bff",oidc:"#007bff"},ib:{"google.com":"Google",
	"github.com":"GitHub","facebook.com":"Facebook","twitter.com":"Twitter",password:"Password",phone:"Phone",anonymous:"Guest","microsoft.com":"Microsoft","yahoo.com":"Yahoo","apple.com":"Apple"}};function fl(a,b,c){be.call(this,a,b);for(var d in c)this[d]=c[d]}w(fl,be);function O(a,b,c,d,e){uk.call(this,c);this.gb=a;this.fb=b;this.Da=!1;this.Ea=d||null;this.w=this.ca=null;this.Y=jb(el);lb(this.Y,e||{})}w(O,uk);l=O.prototype;l.lb=function(){var a=md(this.gb,this.fb,this.Y,this.s);Vk(a);this.f=a};l.v=
	function(){O.M.v.call(this);Fe(P(this),new fl("pageEnter",P(this),{pageId:this.Ea}));if(this.cb()&&this.Y.G){var a=this.Y.G;N(this,this.cb(),function(){a()})}if(this.bb()&&this.Y.F){var b=this.Y.F;N(this,this.bb(),function(){b()})}};l.ya=function(){Fe(P(this),new fl("pageExit",P(this),{pageId:this.Ea}));O.M.ya.call(this)};l.m=function(){window.clearTimeout(this.ca);this.fb=this.gb=this.ca=null;this.Da=!1;this.w=null;Xk(this.R());O.M.m.call(this)};function gl(a){a.Da=!0;var b=Gj(a.R(),"firebaseui-use-spinner");
	a.ca=window.setTimeout(function(){a.R()&&null===a.w&&(a.w=md(Tk,{vb:b},null,a.s),a.R().appendChild(a.w),Vk(a.w))},500)}l.K=function(a,b,c,d){function e(){if(f.O)return null;f.Da=!1;window.clearTimeout(f.ca);f.ca=null;f.w&&(Xk(f.w),dd(f.w),f.w=null)}var f=this;if(f.Da)return null;gl(f);return a.apply(null,b).then(c,d).then(e,e)};function P(a){return a.R().parentElement||a.R().parentNode}function hl(a,b,c){yk(a,b,function(){c.focus()})}function il(a,b,c){yk(a,b,function(){c()})}u(O.prototype,{a:function(a){bl.call(this);
	var b=md(Pk,{message:a},null,this.s);this.R().appendChild(b);N(this,dl.call(this),function(){dd(b)})},xc:bl,zc:cl,yc:dl,Z:function(a,b){a=md(Rk,{Ma:a,message:b},null,this.s);Zk.call(this,a)},h:$k,Db:al,Bc:function(){return L(this,"firebaseui-tos")},cb:function(){return L(this,"firebaseui-tos-link")},bb:function(){return L(this,"firebaseui-pp-link")},Cc:function(){return L(this,"firebaseui-tos-list")}});function jl(a,b,c){a=a||{};b=a.Wa;var d=a.ia;a='<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-sign-in"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Sign in with email</h1></div><div class="firebaseui-card-content"><div class="firebaseui-relative-wrapper">'+
	Ek(a)+'</div></div><div class="firebaseui-card-actions"><div class="firebaseui-form-actions">'+(b?Mk(null):"")+Fk(null)+'</div></div><div class="firebaseui-card-footer">'+(d?Ok(c):Nk(c))+"</div></form></div>";return B(a)}jl.A="firebaseui.auth.soy2.page.signIn";function kl(a,b,c){a=a||{};b=a.ia;a='<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-password-sign-in"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Sign in</h1></div><div class="firebaseui-card-content">'+
	Ek(a)+Kk()+'</div><div class="firebaseui-card-actions"><div class="firebaseui-form-links">'+Lk()+'</div><div class="firebaseui-form-actions">'+Gk()+'</div></div><div class="firebaseui-card-footer">'+(b?Ok(c):Nk(c))+"</div></form></div>";return B(a)}kl.A="firebaseui.auth.soy2.page.passwordSignIn";function ll(a,b,c){a=a||{};var d=a.Sb;b=a.Ua;var e=a.ia,f='<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-password-sign-up"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Create account</h1></div><div class="firebaseui-card-content">'+
	Ek(a);d?(a=a||{},a=a.name,a='<div class="firebaseui-textfield mdl-textfield mdl-js-textfield mdl-textfield--floating-label"><label class="mdl-textfield__label firebaseui-label" for="ui-sign-in-name-input">First &amp; last name</label><input type="text" name="name" id="ui-sign-in-name-input" autocomplete="name" class="mdl-textfield__input firebaseui-input firebaseui-id-name" value="'+yd(null!=a?a:"")+'"></div><div class="firebaseui-error-wrapper"><p class="firebaseui-error firebaseui-text-input-error firebaseui-hidden firebaseui-id-name-error"></p></div>',
	a=B(a)):a="";c=f+a+Jk(null)+'</div><div class="firebaseui-card-actions"><div class="firebaseui-form-actions">'+(b?Mk(null):"")+Hk()+'</div></div><div class="firebaseui-card-footer">'+(e?Ok(c):Nk(c))+"</div></form></div>";return B(c)}ll.A="firebaseui.auth.soy2.page.passwordSignUp";function ml(a,b,c){a=a||{};b=a.Ua;a='<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-password-recovery"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Recover password</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">Get instructions sent to this email that explain how to reset your password</p>'+
	Ek(a)+'</div><div class="firebaseui-card-actions"><div class="firebaseui-form-actions">'+(b?Mk(null):"")+Fk({label:D("Send")})+'</div></div><div class="firebaseui-card-footer">'+Nk(c)+"</div></form></div>";return B(a)}ml.A="firebaseui.auth.soy2.page.passwordRecovery";function nl(a,b,c){b=a.H;var d="";a="Follow the instructions sent to <strong>"+(A(a.email)+"</strong> to recover your password");d+='<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-password-recovery-email-sent"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Check your email</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">'+
	a+'</p></div><div class="firebaseui-card-actions">';b&&(d+='<div class="firebaseui-form-actions">'+Fk({label:D("Done")})+"</div>");d+='</div><div class="firebaseui-card-footer">'+Nk(c)+"</div></div>";return B(d)}nl.A="firebaseui.auth.soy2.page.passwordRecoveryEmailSent";function ol(a,b,c){return B('<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-callback"><div class="firebaseui-callback-indicator-container">'+Tk(null,null,c)+"</div></div>")}ol.A="firebaseui.auth.soy2.page.callback";
	function pl(a,b,c){return B('<div class="firebaseui-container firebaseui-id-page-spinner">'+Tk({vb:!0},null,c)+"</div>")}pl.A="firebaseui.auth.soy2.page.spinner";function ql(){return B('<div class="firebaseui-container firebaseui-id-page-blank firebaseui-use-spinner"></div>')}ql.A="firebaseui.auth.soy2.page.blank";function rl(a,b,c){b="";a="A sign-in email with additional instructions was sent to <strong>"+(A(a.email)+"</strong>. Check your email to complete sign-in.");var d=B('<a class="firebaseui-link firebaseui-id-trouble-getting-email-link" href="javascript:void(0)">Trouble getting email?</a>');
	b+='<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-email-link-sign-in-sent"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Sign-in email sent</h1></div><div class="firebaseui-card-content"><div class="firebaseui-email-sent"></div><p class="firebaseui-text">'+a+'</p></div><div class="firebaseui-card-actions"><div class="firebaseui-form-links">'+d+'</div><div class="firebaseui-form-actions">'+Mk({label:D("Back")})+'</div></div><div class="firebaseui-card-footer">'+
	Nk(c)+"</div></form></div>";return B(b)}rl.A="firebaseui.auth.soy2.page.emailLinkSignInSent";function sl(a,b,c){a='<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-email-not-received"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Trouble getting email?</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">Try these common fixes:<ul><li>Check if the email was marked as spam or filtered.</li><li>Check your internet connection.</li><li>Check that you did not misspell your email.</li><li>Check that your inbox space is not running out or other inbox settings related issues.</li></ul></p><p class="firebaseui-text">If the steps above didn\'t work, you can resend the email. Note that this will deactivate the link in the older email.</p></div><div class="firebaseui-card-actions"><div class="firebaseui-form-links">'+
	B('<a class="firebaseui-link firebaseui-id-resend-email-link" href="javascript:void(0)">Resend</a>')+'</div><div class="firebaseui-form-actions">'+Mk({label:D("Back")})+'</div></div><div class="firebaseui-card-footer">'+Nk(c)+"</div></form></div>";return B(a)}sl.A="firebaseui.auth.soy2.page.emailNotReceived";function tl(a,b,c){a='<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-email-link-sign-in-confirmation"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Confirm email</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">Confirm your email to complete sign in</p><div class="firebaseui-relative-wrapper">'+
	Ek(a)+'</div></div><div class="firebaseui-card-actions"><div class="firebaseui-form-actions">'+Mk(null)+Fk(null)+'</div></div><div class="firebaseui-card-footer">'+Nk(c)+"</div></form></div>";return B(a)}tl.A="firebaseui.auth.soy2.page.emailLinkSignInConfirmation";function ul(){var a='<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-different-device-error"><div class="firebaseui-card-header"><h1 class="firebaseui-title">New device or browser detected</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">Try opening the link using the same device or browser where you started the sign-in process.</p></div><div class="firebaseui-card-actions"><div class="firebaseui-form-actions">'+
	Mk({label:D("Dismiss")})+"</div></div></div>";return B(a)}ul.A="firebaseui.auth.soy2.page.differentDeviceError";function vl(){var a='<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-anonymous-user-mismatch"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Session ended</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">The session associated with this sign-in request has either expired or was cleared.</p></div><div class="firebaseui-card-actions"><div class="firebaseui-form-actions">'+
	Mk({label:D("Dismiss")})+"</div></div></div>";return B(a)}vl.A="firebaseui.auth.soy2.page.anonymousUserMismatch";function wl(a,b,c){b="";a="You\u2019ve already used <strong>"+(A(a.email)+"</strong> to sign in. Enter your password for that account.");b+='<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-password-linking"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Sign in</h1></div><div class="firebaseui-card-content"><h2 class="firebaseui-subtitle">You already have an account</h2><p class="firebaseui-text">'+
	a+"</p>"+Kk()+'</div><div class="firebaseui-card-actions"><div class="firebaseui-form-links">'+Lk()+'</div><div class="firebaseui-form-actions">'+Gk()+'</div></div><div class="firebaseui-card-footer">'+Nk(c)+"</div></form></div>";return B(b)}wl.A="firebaseui.auth.soy2.page.passwordLinking";function xl(a,b,c){var d=a.email;b="";a=""+Uk(a,c);a=D(a);d="You\u2019ve already used <strong>"+(A(d)+("</strong>. You can connect your <strong>"+(A(a)+("</strong> account with <strong>"+(A(d)+"</strong> by signing in with email link below.")))));
	a="For this flow to successfully connect your "+(A(a)+" account with this email, you have to open the link on the same device or browser.");b+='<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-email-link-sign-in-linking"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Sign in</h1></div><div class="firebaseui-card-content"><h2 class="firebaseui-subtitle">You already have an account</h2><p class="firebaseui-text firebaseui-text-justify">'+
	d+'<p class="firebaseui-text firebaseui-text-justify">'+a+'</p></div><div class="firebaseui-card-actions"><div class="firebaseui-form-actions">'+Gk()+'</div></div><div class="firebaseui-card-footer">'+Nk(c)+"</div></form></div>";return B(b)}xl.A="firebaseui.auth.soy2.page.emailLinkSignInLinking";function yl(a,b,c){b="";var d=""+Uk(a,c);d=D(d);a="You originally intended to connect <strong>"+(A(d)+"</strong> to your email account but have opened the link on a different device where you are not signed in.");
	d="If you still want to connect your <strong>"+(A(d)+"</strong> account, open the link on the same device where you started sign-in. Otherwise, tap Continue to sign-in on this device.");b+='<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-email-link-sign-in-linking-different-device"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Sign in</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text firebaseui-text-justify">'+
	a+'</p><p class="firebaseui-text firebaseui-text-justify">'+d+'</p></div><div class="firebaseui-card-actions"><div class="firebaseui-form-actions">'+Ik()+'</div></div><div class="firebaseui-card-footer">'+Nk(c)+"</div></form></div>";return B(b)}yl.A="firebaseui.auth.soy2.page.emailLinkSignInLinkingDifferentDevice";function zl(a,b,c){var d=a.email;b="";a=""+Uk(a,c);a=D(a);d="You\u2019ve already used <strong>"+(A(d)+("</strong>. Sign in with "+(A(a)+" to continue.")));b+='<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-federated-linking"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Sign in</h1></div><div class="firebaseui-card-content"><h2 class="firebaseui-subtitle">You already have an account</h2><p class="firebaseui-text">'+
	d+'</p></div><div class="firebaseui-card-actions"><div class="firebaseui-form-actions">'+Fk({label:D("Sign in with "+a)})+'</div></div><div class="firebaseui-card-footer">'+Nk(c)+"</div></form></div>";return B(b)}zl.A="firebaseui.auth.soy2.page.federatedLinking";function Al(a,b,c){b="";a="To continue sign in with <strong>"+(A(a.email)+"</strong> on this device, you have to recover the password.");b+='<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-unsupported-provider"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Sign in</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">'+
	a+'</p></div><div class="firebaseui-card-actions"><div class="firebaseui-form-actions">'+Mk(null)+Fk({label:D("Recover password")})+'</div></div><div class="firebaseui-card-footer">'+Nk(c)+"</div></form></div>";return B(b)}Al.A="firebaseui.auth.soy2.page.unsupportedProvider";function Bl(a){var b="",c='<p class="firebaseui-text">for <strong>'+(A(a.email)+"</strong></p>");b+='<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-password-reset"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Reset your password</h1></div><div class="firebaseui-card-content">'+
	c+Jk(wd(a))+'</div><div class="firebaseui-card-actions"><div class="firebaseui-form-actions">'+Hk()+"</div></div></form></div>";return B(b)}Bl.A="firebaseui.auth.soy2.page.passwordReset";function Cl(a){a=a||{};a='<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-password-reset-success"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Password changed</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">You can now sign in with your new password</p></div><div class="firebaseui-card-actions">'+
	(a.H?'<div class="firebaseui-form-actions">'+Ik()+"</div>":"")+"</div></div>";return B(a)}Cl.A="firebaseui.auth.soy2.page.passwordResetSuccess";function Dl(a){a=a||{};a='<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-password-reset-failure"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Try resetting your password again</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">Your request to reset your password has expired or the link has already been used</p></div><div class="firebaseui-card-actions">'+
	(a.H?'<div class="firebaseui-form-actions">'+Ik()+"</div>":"")+"</div></div>";return B(a)}Dl.A="firebaseui.auth.soy2.page.passwordResetFailure";function El(a){var b=a.H,c="";a="Your sign-in email address has been changed back to <strong>"+(A(a.email)+"</strong>.");c+='<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-email-change-revoke-success"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Updated email address</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">'+
	a+'</p><p class="firebaseui-text">If you didn\u2019t ask to change your sign-in email, it\u2019s possible someone is trying to access your account and you should <a class="firebaseui-link firebaseui-id-reset-password-link" href="javascript:void(0)">change your password right away</a>.</p></div><div class="firebaseui-card-actions">'+(b?'<div class="firebaseui-form-actions">'+Ik()+"</div>":"")+"</div></form></div>";return B(c)}El.A="firebaseui.auth.soy2.page.emailChangeRevokeSuccess";function Fl(a){a=
	a||{};a='<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-email-change-revoke-failure"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Unable to update your email address</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">There was a problem changing your sign-in email back.</p><p class="firebaseui-text">If you try again and still can\u2019t reset your email, try asking your administrator for help.</p></div><div class="firebaseui-card-actions">'+
	(a.H?'<div class="firebaseui-form-actions">'+Ik()+"</div>":"")+"</div></div>";return B(a)}Fl.A="firebaseui.auth.soy2.page.emailChangeRevokeFailure";function Gl(a){a=a||{};a='<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-email-verification-success"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Your email has been verified</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">You can now sign in with your new account</p></div><div class="firebaseui-card-actions">'+
	(a.H?'<div class="firebaseui-form-actions">'+Ik()+"</div>":"")+"</div></div>";return B(a)}Gl.A="firebaseui.auth.soy2.page.emailVerificationSuccess";function Hl(a){a=a||{};a='<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-email-verification-failure"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Try verifying your email again</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">Your request to verify your email has expired or the link has already been used</p></div><div class="firebaseui-card-actions">'+
	(a.H?'<div class="firebaseui-form-actions">'+Ik()+"</div>":"")+"</div></div>";return B(a)}Hl.A="firebaseui.auth.soy2.page.emailVerificationFailure";function Il(a){var b=a.H,c="";a="You can now sign in with your new email <strong>"+(A(a.email)+"</strong>.");c+='<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-verify-and-change-email-success"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Your email has been verified and changed</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">'+
	a+'</p></div><div class="firebaseui-card-actions">'+(b?'<div class="firebaseui-form-actions">'+Ik()+"</div>":"")+"</div></div>";return B(c)}Il.A="firebaseui.auth.soy2.page.verifyAndChangeEmailSuccess";function Jl(a){a=a||{};a='<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-verify-and-change-email-failure"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Try updating your email again</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">Your request to verify and update your email has expired or the link has already been used.</p></div><div class="firebaseui-card-actions">'+
	(a.H?'<div class="firebaseui-form-actions">'+Ik()+"</div>":"")+"</div></div>";return B(a)}Jl.A="firebaseui.auth.soy2.page.verifyAndChangeEmailFailure";function Kl(a){var b=a.factorId,c=a.phoneNumber;a=a.H;var d='<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-revert-second-factor-addition-success"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Removed second factor</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">';
	switch(b){case "phone":b="The <strong>"+(A(b)+(" "+(A(c)+"</strong> was removed as a second authentication step.")));d+=b;break;default:d+="The device or app was removed as a second authentication step."}d+='</p><p class="firebaseui-text">If you don\'t recognize this device, someone might be trying to access your account. Consider <a class="firebaseui-link firebaseui-id-reset-password-link" href="javascript:void(0)">changing your password right away</a>.</p></div><div class="firebaseui-card-actions">'+
	(a?'<div class="firebaseui-form-actions">'+Ik()+"</div>":"")+"</div></form></div>";return B(d)}Kl.A="firebaseui.auth.soy2.page.revertSecondFactorAdditionSuccess";function Ll(a){a=a||{};a='<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-revert-second-factor-addition-failure"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Couldn\'t remove your second factor</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">Something went wrong removing your second factor.</p><p class="firebaseui-text">Try removing it again. If that doesn\'t work, contact support for assistance.</p></div><div class="firebaseui-card-actions">'+
	(a.H?'<div class="firebaseui-form-actions">'+Ik()+"</div>":"")+"</div></div>";return B(a)}Ll.A="firebaseui.auth.soy2.page.revertSecondFactorAdditionFailure";function Ml(a){var b=a.Ab;a='<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-recoverable-error"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Error encountered</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">'+A(a.errorMessage)+'</p></div><div class="firebaseui-card-actions"><div class="firebaseui-form-actions">';
	b&&(a+=Fk({label:D("Retry")}));return B(a+"</div></div></div>")}Ml.A="firebaseui.auth.soy2.page.recoverableError";function Nl(a){a='<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-unrecoverable-error"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Error encountered</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">'+A(a.errorMessage)+"</p></div></div>";return B(a)}Nl.A="firebaseui.auth.soy2.page.unrecoverableError";function Ol(a,
	b,c){var d=a.Pb;b="";a="Continue with "+(A(a.ic)+"?");d="You originally wanted to sign in with "+A(d);b+='<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-email-mismatch"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Sign in</h1></div><div class="firebaseui-card-content"><h2 class="firebaseui-subtitle">'+a+'</h2><p class="firebaseui-text">'+d+'</p></div><div class="firebaseui-card-actions"><div class="firebaseui-form-actions">'+
	Mk(null)+Fk({label:D("Continue")})+'</div></div><div class="firebaseui-card-footer">'+Nk(c)+"</div></form></div>";return B(b)}Ol.A="firebaseui.auth.soy2.page.emailMismatch";function Pl(a,b,c){var d='<div class="firebaseui-container firebaseui-page-provider-sign-in firebaseui-id-page-provider-sign-in firebaseui-use-spinner"><div class="firebaseui-card-content"><form onsubmit="return false;"><ul class="firebaseui-idp-list">';a=a.Rb;b=a.length;for(var e=0;e<b;e++){var f={ga:a[e]};var g=c;f=f||{};var h=
	f.ga,k=f;k=k||{};var m="";switch(k.ga.providerId){case "google.com":m+="firebaseui-idp-google";break;case "github.com":m+="firebaseui-idp-github";break;case "facebook.com":m+="firebaseui-idp-facebook";break;case "twitter.com":m+="firebaseui-idp-twitter";break;case "phone":m+="firebaseui-idp-phone";break;case "anonymous":m+="firebaseui-idp-anonymous";break;case "password":m+="firebaseui-idp-password";break;default:m+="firebaseui-idp-generic"}k='<button class="firebaseui-idp-button mdl-button mdl-js-button mdl-button--raised '+
	yd(C(m))+' firebaseui-id-idp-button" data-provider-id="'+yd(h.providerId)+'" style="background-color:';m=(m=f)||{};m=m.ga;k=k+yd(Hd(C(m.Ga?m.Ga:g.wa[m.providerId]?""+g.wa[m.providerId]:0==m.providerId.indexOf("saml.")?""+g.wa.saml:0==m.providerId.indexOf("oidc.")?""+g.wa.oidc:""+g.wa.password)))+'"><span class="firebaseui-idp-icon-wrapper"><img class="firebaseui-idp-icon" alt="" src="';var q=f;m=g;q=q||{};q=q.ga;m=vd(q.Na?Dd(q.Na):m.xa[q.providerId]?Dd(m.xa[q.providerId]):0==q.providerId.indexOf("saml.")?
	Dd(m.xa.saml):0==q.providerId.indexOf("oidc.")?Dd(m.xa.oidc):Dd(m.xa.password));k=k+yd(Dd(m))+'"></span>';"password"==h.providerId?k+='<span class="firebaseui-idp-text firebaseui-idp-text-long">Sign in with email</span><span class="firebaseui-idp-text firebaseui-idp-text-short">Email</span>':"phone"==h.providerId?k+='<span class="firebaseui-idp-text firebaseui-idp-text-long">Sign in with phone</span><span class="firebaseui-idp-text firebaseui-idp-text-short">Phone</span>':"anonymous"==h.providerId?
	k+='<span class="firebaseui-idp-text firebaseui-idp-text-long">Continue as guest</span><span class="firebaseui-idp-text firebaseui-idp-text-short">Guest</span>':(h="Sign in with "+A(Uk(f,g)),k+='<span class="firebaseui-idp-text firebaseui-idp-text-long">'+h+'</span><span class="firebaseui-idp-text firebaseui-idp-text-short">'+A(Uk(f,g))+"</span>");f=B(k+"</button>");d+='<li class="firebaseui-list-item">'+f+"</li>"}d+='</ul></form></div><div class="firebaseui-card-footer firebaseui-provider-sign-in-footer">'+
	Ok(c)+"</div></div>";return B(d)}Pl.A="firebaseui.auth.soy2.page.providerSignIn";function Ql(a,b,c){a=a||{};var d=a.Fb,e=a.Wa;b=a.ia;a=a||{};a=a.za;a='<div class="firebaseui-phone-number"><button class="firebaseui-id-country-selector firebaseui-country-selector mdl-button mdl-js-button"><span class="firebaseui-flag firebaseui-country-selector-flag firebaseui-id-country-selector-flag"></span><span class="firebaseui-id-country-selector-code"></span></button><div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label firebaseui-textfield firebaseui-phone-input-wrapper"><label class="mdl-textfield__label firebaseui-label" for="ui-sign-in-phone-number-input">Phone number</label><input type="tel" name="phoneNumber" id="ui-sign-in-phone-number-input" class="mdl-textfield__input firebaseui-input firebaseui-id-phone-number" value="'+
	yd(null!=a?a:"")+'"></div></div><div class="firebaseui-error-wrapper"><p class="firebaseui-error firebaseui-text-input-error firebaseui-hidden firebaseui-phone-number-error firebaseui-id-phone-number-error"></p></div>';a='<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-phone-sign-in-start"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Enter your phone number</h1></div><div class="firebaseui-card-content"><div class="firebaseui-relative-wrapper">'+
	B(a);var f;d?f=B('<div class="firebaseui-recaptcha-wrapper"><div class="firebaseui-recaptcha-container"></div><div class="firebaseui-error-wrapper firebaseui-recaptcha-error-wrapper"><p class="firebaseui-error firebaseui-hidden firebaseui-id-recaptcha-error"></p></div></div>'):f="";f=a+f+'</div></div><div class="firebaseui-card-actions"><div class="firebaseui-form-actions">'+(e?Mk(null):"")+Fk({label:D("Verify")})+'</div></div><div class="firebaseui-card-footer">';b?(b='<p class="firebaseui-tos firebaseui-phone-tos">',
	b=c.G&&c.F?b+'By tapping Verify, you are indicating that you accept our <a href="javascript:void(0)" class="firebaseui-link firebaseui-tos-link" target="_blank">Terms of Service</a> and <a href="javascript:void(0)" class="firebaseui-link firebaseui-pp-link" target="_blank">Privacy Policy</a>. An SMS may be sent. Message &amp; data rates may apply.':b+"By tapping Verify, an SMS may be sent. Message &amp; data rates may apply.",c=B(b+"</p>")):c=B('<p class="firebaseui-tos firebaseui-phone-sms-notice">By tapping Verify, an SMS may be sent. Message &amp; data rates may apply.</p>')+
	Nk(c);return B(f+c+"</div></form></div>")}Ql.A="firebaseui.auth.soy2.page.phoneSignInStart";function Rl(a,b,c){a=a||{};b=a.phoneNumber;var d="";a='Enter the 6-digit code we sent to <a class="firebaseui-link firebaseui-change-phone-number-link firebaseui-id-change-phone-number-link" href="javascript:void(0)">&lrm;'+(A(b)+"</a>");A(b);b=d;d=B('<div class="firebaseui-textfield mdl-textfield mdl-js-textfield mdl-textfield--floating-label"><label class="mdl-textfield__label firebaseui-label" for="ui-sign-in-phone-confirmation-code-input">6-digit code</label><input type="number" name="phoneConfirmationCode" id="ui-sign-in-phone-confirmation-code-input" class="mdl-textfield__input firebaseui-input firebaseui-id-phone-confirmation-code"></div><div class="firebaseui-error-wrapper"><p class="firebaseui-error firebaseui-text-input-error firebaseui-hidden firebaseui-id-phone-confirmation-code-error"></p></div>');
	c='<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-phone-sign-in-finish"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Verify your phone number</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">'+a+"</p>"+d+'</div><div class="firebaseui-card-actions"><div class="firebaseui-form-actions">'+Mk(null)+Fk({label:D("Continue")})+'</div></div><div class="firebaseui-card-footer">'+Nk(c)+"</div></form>";
	a=B('<div class="firebaseui-resend-container"><span class="firebaseui-id-resend-countdown"></span><a href="javascript:void(0)" class="firebaseui-id-resend-link firebaseui-hidden firebaseui-link">Resend</a></div>');return B(b+(c+a+"</div>"))}Rl.A="firebaseui.auth.soy2.page.phoneSignInFinish";function Sl(){return B('<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-sign-out"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Sign Out</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">You are now successfully signed out.</p></div></div>')}
	Sl.A="firebaseui.auth.soy2.page.signOut";function Tl(a,b,c){var d='<div class="firebaseui-container firebaseui-page-select-tenant firebaseui-id-page-select-tenant"><div class="firebaseui-card-content"><form onsubmit="return false;"><ul class="firebaseui-tenant-list">';a=a.dc;b=a.length;for(var e=0;e<b;e++){var f=a[e];var g="",h="Sign in to "+A(f.displayName),k=A(f.displayName),m=f.tenantId?f.tenantId:"top-level-project";m=D(m);g+='<button class="firebaseui-tenant-button mdl-button mdl-js-button mdl-button--raised firebaseui-tenant-selection-'+
	yd(m)+' firebaseui-id-tenant-selection-button"'+(f.tenantId?'data-tenant-id="'+yd(f.tenantId)+'"':"")+'style="background-color:'+yd(Hd(f.Ga))+'"><span class="firebaseui-idp-icon-wrapper"><img class="firebaseui-idp-icon" alt="" src="'+yd(Dd(f.Na))+'"></span><span class="firebaseui-idp-text firebaseui-idp-text-long">'+h+'</span><span class="firebaseui-idp-text firebaseui-idp-text-short">'+k+"</span></button>";f=B(g);d+='<li class="firebaseui-list-item">'+f+"</li>"}d+='</ul></form></div><div class="firebaseui-card-footer firebaseui-provider-sign-in-footer">'+
	Ok(c)+"</div></div>";return B(d)}Tl.A="firebaseui.auth.soy2.page.selectTenant";function Ul(a,b,c){a='<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-provider-match-by-email"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Sign in</h1></div><div class="firebaseui-card-content"><div class="firebaseui-relative-wrapper">'+Ek(null)+'</div></div><div class="firebaseui-card-actions"><div class="firebaseui-form-actions">'+Fk(null)+
	'</div></div><div class="firebaseui-card-footer">'+Ok(c)+"</div></form></div>";return B(a)}Ul.A="firebaseui.auth.soy2.page.providerMatchByEmail";function Vl(){return L(this,"firebaseui-id-submit")}function Wl(){return L(this,"firebaseui-id-secondary-link")}function Xl(a,b){N(this,Vl.call(this),function(d){a(d)});var c=Wl.call(this);c&&b&&N(this,c,function(d){b(d)})}function Yl(){return L(this,"firebaseui-id-password")}function Zl(){return L(this,"firebaseui-id-password-error")}function $l(){var a=
	Yl.call(this),b=Zl.call(this);xk(this,a,function(){Dk(b)&&(M(a,!0),Bk(b))})}function am(){var a=Yl.call(this);var b=Zl.call(this);Jj(a)?(M(a,!0),Bk(b),b=!0):(M(a,!1),Ck(b,C("Enter your password").toString()),b=!1);return b?Jj(a):null}function bm(a,b,c,d,e,f){O.call(this,wl,{email:a},f,"passwordLinking",{G:d,F:e});this.B=b;this.J=c}n(bm,O);bm.prototype.v=function(){this.S();this.P(this.B,this.J);il(this,this.i(),this.B);this.i().focus();O.prototype.v.call(this)};bm.prototype.m=function(){this.B=null;
	O.prototype.m.call(this)};bm.prototype.j=function(){return Jj(L(this,"firebaseui-id-email"))};u(bm.prototype,{i:Yl,D:Zl,S:$l,u:am,ea:Vl,ba:Wl,P:Xl});var cm=/^[+a-zA-Z0-9_.!#$%&'*\/=?^`{|}~-]+@([a-zA-Z0-9-]+\.)+[a-zA-Z0-9]{2,63}$/;function dm(){return L(this,"firebaseui-id-email")}function em(){return L(this,"firebaseui-id-email-error")}function fm(a){var b=dm.call(this),c=em.call(this);xk(this,b,function(){Dk(c)&&(M(b,!0),Bk(c))});a&&yk(this,b,function(){a()})}function gm(){return Za(Jj(dm.call(this))||
	"")}function hm(){var a=dm.call(this);var b=em.call(this);var c=Jj(a)||"";c?cm.test(c)?(M(a,!0),Bk(b),b=!0):(M(a,!1),Ck(b,C("That email address isn't correct").toString()),b=!1):(M(a,!1),Ck(b,C("Enter your email address to continue").toString()),b=!1);return b?Za(Jj(a)):null}function im(a,b,c,d,e,f,g){O.call(this,kl,{email:c,ia:!!f},g,"passwordSignIn",{G:d,F:e});this.B=a;this.J=b}n(im,O);im.prototype.v=function(){this.S();this.ea();this.ba(this.B,this.J);hl(this,this.l(),this.i());il(this,this.i(),
	this.B);Jj(this.l())?this.i().focus():this.l().focus();O.prototype.v.call(this)};im.prototype.m=function(){this.J=this.B=null;O.prototype.m.call(this)};u(im.prototype,{l:dm,U:em,S:fm,P:gm,j:hm,i:Yl,D:Zl,ea:$l,u:am,ua:Vl,pa:Wl,ba:Xl});function Q(a,b,c,d,e,f){O.call(this,a,b,d,e||"notice",f);this.i=c||null}w(Q,O);Q.prototype.v=function(){this.i&&(this.u(this.i),this.l().focus());Q.M.v.call(this)};Q.prototype.m=function(){this.i=null;Q.M.m.call(this)};u(Q.prototype,{l:Vl,B:Wl,u:Xl});function jm(a,b,
	c,d,e){Q.call(this,nl,{email:a,H:!!b},b,e,"passwordRecoveryEmailSent",{G:c,F:d})}w(jm,Q);function km(a,b){Q.call(this,Gl,{H:!!a},a,b,"emailVerificationSuccess")}w(km,Q);function lm(a,b){Q.call(this,Hl,{H:!!a},a,b,"emailVerificationFailure")}w(lm,Q);function mm(a,b,c){Q.call(this,Il,{email:a,H:!!b},b,c,"verifyAndChangeEmailSuccess")}w(mm,Q);function nm(a,b){Q.call(this,Jl,{H:!!a},a,b,"verifyAndChangeEmailFailure")}w(nm,Q);function om(a,b){Q.call(this,Ll,{H:!!a},a,b,"revertSecondFactorAdditionFailure")}
	w(om,Q);function pm(a){Q.call(this,Sl,void 0,void 0,a,"signOut")}w(pm,Q);function qm(a,b){Q.call(this,Cl,{H:!!a},a,b,"passwordResetSuccess")}w(qm,Q);function rm(a,b){Q.call(this,Dl,{H:!!a},a,b,"passwordResetFailure")}w(rm,Q);function sm(a,b){Q.call(this,Fl,{H:!!a},a,b,"emailChangeRevokeFailure")}w(sm,Q);function tm(a,b,c){Q.call(this,Ml,{errorMessage:a,Ab:!!b},b,c,"recoverableError")}w(tm,Q);function um(a,b){Q.call(this,Nl,{errorMessage:a},void 0,b,"unrecoverableError")}w(um,Q);var vm=!1,wm=null;
	function xm(a,b){vm=!!b;wm||("undefined"==typeof accountchooser&&Ej()?(b=Cc(yc(new vc(wc,"//www.gstatic.com/accountchooser/client.js"))),wm=G(Nf(b)).ta(function(){})):wm=G());wm.then(a,a)}function ym(a,b){a=R(a);(a=aj(a).accountChooserInvoked||null)?a(b):b()}function zm(a,b,c){a=R(a);(a=aj(a).accountChooserResult||null)?a(b,c):c()}function Am(a,b,c,d,e){d?(K("callback",a,b),vm&&c()):ym(a,function(){Uh(new Kg(a.a.tenantId||null),T(a));pj(function(f){Jh(Ch,T(a));zm(a,f?"empty":"unavailable",function(){K("signIn",
	a,b);(f||vm)&&c()})},Oh(T(a)),e)})}function Bm(a,b,c,d){function e(f){f=U(f);V(b,c,void 0,f);d()}zm(b,"accountSelected",function(){Nh(!1,T(b));var f=Cm(b);W(b,X(b).fetchSignInMethodsForEmail(a.a).then(function(g){Dm(b,c,g,a.a,a.h||void 0,void 0,f);d()},e))})}function Em(a,b,c,d){zm(b,a?"addAccount":"unavailable",function(){K("signIn",b,c);(a||vm)&&d()})}function Fm(a,b,c,d){function e(){var f=a();f&&(f=$i(R(f)))&&f()}mj(function(){var f=a();f&&Am(f,b,e,c,d)},function(f){var g=a();g&&Bm(f,g,b,e)},
	function(f){var g=a();g&&Em(f,g,b,e)},a()&&ui(R(a())))}function Gm(a,b,c,d){function e(g){if(!g.name||"cancel"!=g.name){a:{var h=g.message;try{var k=((JSON.parse(h).error||{}).message||"").toLowerCase().match(/invalid.+(access|id)_token/);if(k&&k.length){var m=!0;break a}}catch(q){}m=!1}if(m)g=P(b),b.o(),V(a,g,void 0,C("Your sign-in session has expired. Please try again.").toString());else{m=g&&g.message||"";if(g.code){if("auth/email-already-in-use"==g.code||"auth/credential-already-in-use"==g.code)return;
	m=U(g)}b.a(m)}}}Hm(a);if(d)return Im(a,c),G();if(!c.credential)throw Error("No credential found!");d=X(a).currentUser||c.user;if(!d)throw Error("User not logged in.");d=new Bg(d.email,d.displayName,d.photoURL,"password"==c.credential.providerId?null:c.credential.providerId);null!=Ih(Eh,T(a))&&!Ih(Eh,T(a))||Ph(d,T(a));Jh(Eh,T(a));try{var f=Jm(a,c)}catch(g){return vg(g.code||g.message,g),b.a(g.code||g.message),G()}c=f.then(function(g){Im(a,g)},e).then(void 0,e);W(a,f);return G(c)}function Im(a,b){if(!b.user)throw Error("No user found");
	var c=cj(R(a));bj(R(a))&&c&&Ag("Both signInSuccess and signInSuccessWithAuthResult callbacks are provided. Only signInSuccessWithAuthResult callback will be invoked.");if(c){c=cj(R(a));var d=Lh(T(a))||void 0;Jh(Dh,T(a));var e=!1;if(vf()){if(!c||c(b,d))e=!0,window.opener.location.assign(Fc(Ic(Km(a,d))));c||window.close()}else if(!c||c(b,d))e=!0,uf(Km(a,d));e||a.reset()}else{c=b.user;b=b.credential;d=bj(R(a));e=Lh(T(a))||void 0;Jh(Dh,T(a));var f=!1;if(vf()){if(!d||d(c,b,e))f=!0,window.opener.location.assign(Fc(Ic(Km(a,
	e))));d||window.close()}else if(!d||d(c,b,e))f=!0,uf(Km(a,e));f||a.reset()}}function Km(a,b){a=b||R(a).a.get("signInSuccessUrl");if(!a)throw Error("No redirect URL has been found. You must either specify a signInSuccessUrl in the configuration, pass in a redirect URL to the widget URL, or return false from the callback.");return a}function U(a){var b={code:a.code};b=b||{};var c="";switch(b.code){case "auth/email-already-in-use":c+="The email address is already used by another account";break;case "auth/requires-recent-login":c+=
	Qd();break;case "auth/too-many-requests":c+="You have entered an incorrect password too many times. Please try again in a few minutes.";break;case "auth/user-cancelled":c+="Please authorize the required permissions to sign in to the application";break;case "auth/user-not-found":c+="That email address doesn't match an existing account";break;case "auth/user-token-expired":c+=Qd();break;case "auth/weak-password":c+="Strong passwords have at least 6 characters and a mix of letters and numbers";break;
	case "auth/wrong-password":c+="The email and password you entered don't match";break;case "auth/network-request-failed":c+="A network error has occurred";break;case "auth/invalid-phone-number":c+=Ld();break;case "auth/invalid-verification-code":c+=C("Wrong code. Try again.");break;case "auth/code-expired":c+="This code is no longer valid";break;case "auth/expired-action-code":c+="This code has expired.";break;case "auth/invalid-action-code":c+="The action code is invalid. This can happen if the code is malformed, expired, or has already been used."}if(b=
	C(c).toString())return b;try{return JSON.parse(a.message),vg("Internal error: "+a.message,void 0),Nd().toString()}catch(d){return a.message}}function Lm(a,b,c){var d=ri[b]&&firebase.auth[ri[b]]?new firebase.auth[ri[b]]:0==b.indexOf("saml.")?new firebase.auth.SAMLAuthProvider(b):new firebase.auth.OAuthProvider(b);if(!d)throw Error("Invalid Firebase Auth provider!");var e=Mi(R(a),b);if(d.addScope)for(var f=0;f<e.length;f++)d.addScope(e[f]);e=Ni(R(a),b)||{};c&&(b==firebase.auth.GoogleAuthProvider.PROVIDER_ID?
	a="login_hint":b==firebase.auth.GithubAuthProvider.PROVIDER_ID?a="login":a=(a=Di(R(a),b))&&a.Nb,a&&(e[a]=c));d.setCustomParameters&&d.setCustomParameters(e);return d}function Mm(a,b,c,d){function e(){Uh(new Kg(a.a.tenantId||null),T(a));W(a,b.K(t(a.cc,a),[k],function(){if("file:"===(window.location&&window.location.protocol))return W(a,Nm(a).then(function(m){b.o();Jh(Ch,T(a));K("callback",a,h,G(m))},f))},g))}function f(m){Jh(Ch,T(a));if(!m.name||"cancel"!=m.name)switch(m.code){case "auth/popup-blocked":e();
	break;case "auth/popup-closed-by-user":case "auth/cancelled-popup-request":break;case "auth/credential-already-in-use":break;case "auth/network-request-failed":case "auth/too-many-requests":case "auth/user-cancelled":b.a(U(m));break;default:b.o(),K("callback",a,h,hf(m))}}function g(m){Jh(Ch,T(a));m.name&&"cancel"==m.name||(vg("signInWithRedirect: "+m.code,void 0),m=U(m),"blank"==b.Ea&&Wi(R(a))?(b.o(),K("providerSignIn",a,h,m)):b.a(m))}var h=P(b),k=Lm(a,c,d);Xi(R(a))==Yi?e():W(a,Om(a,k).then(function(m){b.o();
	K("callback",a,h,G(m))},f))}function Pm(a,b){W(a,b.K(t(a.Zb,a),[],function(c){b.o();return Gm(a,b,c,!0)},function(c){c.name&&"cancel"==c.name||(vg("ContinueAsGuest: "+c.code,void 0),c=U(c),b.a(c))}))}function Qm(a,b,c){function d(f){var g=!1;f=b.K(t(a.$b,a),[f],function(h){var k=P(b);b.o();K("callback",a,k,G(h));g=!0},function(h){if(!h.name||"cancel"!=h.name)if(!h||"auth/credential-already-in-use"!=h.code)if(h&&"auth/email-already-in-use"==h.code&&h.email&&h.credential){var k=P(b);b.o();K("callback",
	a,k,hf(h))}else h=U(h),b.a(h)});W(a,f);return f.then(function(){return g},function(){return!1})}var e=Ji(R(a),c&&c.authMethod||null);if(c&&c.idToken&&e===firebase.auth.GoogleAuthProvider.PROVIDER_ID)return Mi(R(a),firebase.auth.GoogleAuthProvider.PROVIDER_ID).length?(Mm(a,b,e,c.id),c=G(!0)):c=d(firebase.auth.GoogleAuthProvider.credential(c.idToken)),c;c&&b.a(C("The selected credential for the authentication provider is not supported!").toString());return G(!1)}function Rm(a,b){var c=b.j(),d=b.u();
	if(c)if(d){var e=firebase.auth.EmailAuthProvider.credential(c,d);W(a,b.K(t(a.ac,a),[c,d],function(f){return Gm(a,b,{user:f.user,credential:e,operationType:f.operationType,additionalUserInfo:f.additionalUserInfo})},function(f){if(!f.name||"cancel"!=f.name)switch(f.code){case "auth/email-already-in-use":break;case "auth/email-exists":M(b.l(),!1);Ck(b.U(),U(f));break;case "auth/too-many-requests":case "auth/wrong-password":M(b.i(),!1);Ck(b.D(),U(f));break;default:vg("verifyPassword: "+f.message,void 0),
	b.a(U(f))}}))}else b.i().focus();else b.l().focus()}function Cm(a){a=Ci(R(a));return 1==a.length&&a[0]==firebase.auth.EmailAuthProvider.PROVIDER_ID}function Sm(a){a=Ci(R(a));return 1==a.length&&a[0]==firebase.auth.PhoneAuthProvider.PROVIDER_ID}function V(a,b,c,d){Cm(a)?d?K("signIn",a,b,c,d):Tm(a,b,c):a&&Sm(a)&&!d?K("phoneSignInStart",a,b):a&&Wi(R(a))&&!d?K("federatedRedirect",a,b,c):K("providerSignIn",a,b,d,c)}function Um(a,b,c,d){var e=P(b);W(a,b.K(t(X(a).fetchSignInMethodsForEmail,X(a)),[c],function(f){Nh(Hi(R(a))==
	ti,T(a));b.o();Dm(a,e,f,c,void 0,d)},function(f){f=U(f);b.a(f)}))}function Dm(a,b,c,d,e,f,g){c.length||Ti(R(a))?!c.length&&Ti(R(a))?K("sendEmailLinkForSignIn",a,b,d,function(){K("signIn",a,b)}):Qa(c,firebase.auth.EmailAuthProvider.EMAIL_PASSWORD_SIGN_IN_METHOD)?K("passwordSignIn",a,b,d,g):1==c.length&&c[0]===firebase.auth.EmailAuthProvider.EMAIL_LINK_SIGN_IN_METHOD?K("sendEmailLinkForSignIn",a,b,d,function(){K("signIn",a,b)}):(c=pi(c,Ci(R(a))))?(Sh(new Ig(d),T(a)),K("federatedSignIn",a,b,d,c,f)):
	K("unsupportedProvider",a,b,d):K("passwordSignUp",a,b,d,e,void 0,g)}function Vm(a,b,c,d,e,f){var g=P(b);W(a,b.K(t(a.Hb,a),[c,f],function(){b.o();K("emailLinkSignInSent",a,g,c,d,f)},e))}function Tm(a,b,c){Hi(R(a))==ti?xm(function(){kj?ym(a,function(){Uh(new Kg(a.a.tenantId||null),T(a));pj(function(d){Jh(Ch,T(a));zm(a,d?"empty":"unavailable",function(){c?K("prefilledEmailSignIn",a,b,c):K("signIn",a,b)})},Oh(T(a)),vi(R(a)))}):(Y(a),Fm(Wm,b,!1,vi(R(a))))},!1):(vm=!1,ym(a,function(){zm(a,"unavailable",
	function(){c?K("prefilledEmailSignIn",a,b,c):K("signIn",a,b)})}))}function Xm(a){var b=yf();a=xi(R(a));b=yb(b,a)||"";for(var c in fj)if(fj[c].toLowerCase()==b.toLowerCase())return fj[c];return"callback"}function Ym(a){var b=yf();a=$h(R(a).a,"queryParameterForSignInSuccessUrl");return(b=yb(b,a))?Fc(Ic(b)):null}function Zm(){return yb(yf(),"oobCode")}function $m(){var a=yb(yf(),"continueUrl");return a?function(){uf(a)}:null}function an(a,b){var c=xf(b,"Could not find the FirebaseUI widget element on the page.");
	b=Ym(a);switch(Xm(a)){case "callback":b&&Mh(b,T(a));a.ob()?K("callback",a,c):V(a,c,bn(a));break;case "resetPassword":K("passwordReset",a,c,Zm(),$m());break;case "recoverEmail":K("emailChangeRevocation",a,c,Zm());break;case "revertSecondFactorAddition":K("revertSecondFactorAddition",a,c,Zm());break;case "verifyEmail":K("emailVerification",a,c,Zm(),$m());break;case "verifyAndChangeEmail":K("verifyAndChangeEmail",a,c,Zm(),$m());break;case "signIn":K("emailLinkSignInCallback",a,c,yf());cn();break;case "select":if(b&&
	Mh(b,T(a)),kj){V(a,c);break}else{xm(function(){Y(a);Fm(Wm,c,!0)},!0);return}default:throw Error("Unhandled widget operation.");}(b=$i(R(a)))&&b()}function dn(a,b){O.call(this,vl,void 0,b,"anonymousUserMismatch");this.i=a}n(dn,O);dn.prototype.v=function(){var a=this;N(this,this.l(),function(){a.i()});this.l().focus();O.prototype.v.call(this)};dn.prototype.m=function(){this.i=null;O.prototype.m.call(this)};u(dn.prototype,{l:Wl});J.anonymousUserMismatch=function(a,b){var c=new dn(function(){c.o();V(a,
	b)});c.render(b);Z(a,c)};function en(a){O.call(this,ol,void 0,a,"callback")}n(en,O);en.prototype.K=function(a,b,c,d){return a.apply(null,b).then(c,d)};function fn(a,b,c){if(c.user){var d={user:c.user,credential:c.credential,operationType:c.operationType,additionalUserInfo:c.additionalUserInfo},e=Qh(T(a)),f=e&&e.f;if(f&&!gn(c.user,f))hn(a,b,d);else{var g=e&&e.a;g?W(a,c.user.linkWithCredential(g).then(function(h){d={user:h.user,credential:g,operationType:h.operationType,additionalUserInfo:h.additionalUserInfo};
	jn(a,b,d)},function(h){kn(a,b,h)})):jn(a,b,d)}}else c=P(b),b.o(),Rh(T(a)),V(a,c)}function jn(a,b,c){Rh(T(a));Gm(a,b,c)}function kn(a,b,c){var d=P(b);Rh(T(a));c=U(c);b.o();V(a,d,void 0,c)}function ln(a,b,c,d){var e=P(b);W(a,X(a).fetchSignInMethodsForEmail(c).then(function(f){b.o();f.length?Qa(f,firebase.auth.EmailAuthProvider.EMAIL_PASSWORD_SIGN_IN_METHOD)?K("passwordLinking",a,e,c):1==f.length&&f[0]===firebase.auth.EmailAuthProvider.EMAIL_LINK_SIGN_IN_METHOD?K("emailLinkSignInLinking",a,e,c):(f=pi(f,
	Ci(R(a))))?K("federatedLinking",a,e,c,f,d):(Rh(T(a)),K("unsupportedProvider",a,e,c)):(Rh(T(a)),K("passwordRecovery",a,e,c,!1,Od().toString()))},function(f){kn(a,b,f)}))}function hn(a,b,c){var d=P(b);W(a,mn(a).then(function(){b.o();K("emailMismatch",a,d,c)},function(e){e.name&&"cancel"==e.name||(e=U(e.code),b.a(e))}))}function gn(a,b){if(b==a.email)return!0;if(a.providerData)for(var c=0;c<a.providerData.length;c++)if(b==a.providerData[c].email)return!0;return!1}J.callback=function(a,b,c){var d=new en;
	d.render(b);Z(a,d);b=c||Nm(a);W(a,b.then(function(e){fn(a,d,e)},function(e){if(e&&("auth/account-exists-with-different-credential"==e.code||"auth/email-already-in-use"==e.code)&&e.email&&e.credential)Sh(new Ig(e.email,e.credential),T(a)),ln(a,d,e.email);else if(e&&"auth/user-cancelled"==e.code){var f=Qh(T(a)),g=U(e);f&&f.a?ln(a,d,f.f,g):f?Um(a,d,f.f,g):kn(a,d,e)}else e&&"auth/credential-already-in-use"==e.code||(e&&"auth/operation-not-supported-in-this-environment"==e.code&&Cm(a)?fn(a,d,{user:null,
	credential:null}):kn(a,d,e))}))};function nn(a,b){O.call(this,ul,void 0,b,"differentDeviceError");this.i=a}n(nn,O);nn.prototype.v=function(){var a=this;N(this,this.l(),function(){a.i()});this.l().focus();O.prototype.v.call(this)};nn.prototype.m=function(){this.i=null;O.prototype.m.call(this)};u(nn.prototype,{l:Wl});J.differentDeviceError=function(a,b){var c=new nn(function(){c.o();V(a,b)});c.render(b);Z(a,c)};function on(a,b,c,d){O.call(this,El,{email:a,H:!!c},d,"emailChangeRevoke");this.l=b;this.i=
	c||null}n(on,O);on.prototype.v=function(){var a=this;N(this,L(this,"firebaseui-id-reset-password-link"),function(){a.l()});this.i&&(this.B(this.i),this.u().focus());O.prototype.v.call(this)};on.prototype.m=function(){this.l=this.i=null;O.prototype.m.call(this)};u(on.prototype,{u:Vl,D:Wl,B:Xl});function pn(){return L(this,"firebaseui-id-new-password")}function qn(){return L(this,"firebaseui-id-password-toggle")}function rn(){this.Sa=!this.Sa;var a=qn.call(this),b=pn.call(this);this.Sa?(b.type="text",
	Hj(a,"firebaseui-input-toggle-off"),Ij(a,"firebaseui-input-toggle-on")):(b.type="password",Hj(a,"firebaseui-input-toggle-on"),Ij(a,"firebaseui-input-toggle-off"));b.focus()}function sn(){return L(this,"firebaseui-id-new-password-error")}function tn(){this.Sa=!1;var a=pn.call(this);a.type="password";var b=sn.call(this);xk(this,a,function(){Dk(b)&&(M(a,!0),Bk(b))});var c=qn.call(this);Hj(c,"firebaseui-input-toggle-on");Ij(c,"firebaseui-input-toggle-off");zk(this,a,function(){Hj(c,"firebaseui-input-toggle-focus");
	Ij(c,"firebaseui-input-toggle-blur")});Ak(this,a,function(){Hj(c,"firebaseui-input-toggle-blur");Ij(c,"firebaseui-input-toggle-focus")});N(this,c,t(rn,this))}function un(){var a=pn.call(this);var b=sn.call(this);Jj(a)?(M(a,!0),Bk(b),b=!0):(M(a,!1),Ck(b,C("Enter your password").toString()),b=!1);return b?Jj(a):null}function vn(a,b,c){O.call(this,Bl,{email:a},c,"passwordReset");this.l=b}n(vn,O);vn.prototype.v=function(){this.J();this.D(this.l);il(this,this.i(),this.l);this.i().focus();O.prototype.v.call(this)};
	vn.prototype.m=function(){this.l=null;O.prototype.m.call(this)};u(vn.prototype,{i:pn,B:sn,P:qn,J:tn,u:un,U:Vl,S:Wl,D:Xl});function wn(a,b,c,d,e){O.call(this,Kl,{factorId:a,phoneNumber:c||null,H:!!d},e,"revertSecondFactorAdditionSuccess");this.l=b;this.i=d||null}n(wn,O);wn.prototype.v=function(){var a=this;N(this,L(this,"firebaseui-id-reset-password-link"),function(){a.l()});this.i&&(this.B(this.i),this.u().focus());O.prototype.v.call(this)};wn.prototype.m=function(){this.l=this.i=null;O.prototype.m.call(this)};
	u(wn.prototype,{u:Vl,D:Wl,B:Xl});function xn(a,b,c,d,e){var f=c.u();f&&W(a,c.K(t(X(a).confirmPasswordReset,X(a)),[d,f],function(){c.o();var g=new qm(e);g.render(b);Z(a,g)},function(g){yn(a,b,c,g)}))}function yn(a,b,c,d){"auth/weak-password"==(d&&d.code)?(a=U(d),M(c.i(),!1),Ck(c.B(),a),c.i().focus()):(c&&c.o(),c=new rm,c.render(b),Z(a,c))}function zn(a,b,c){var d=new on(c,function(){W(a,d.K(t(X(a).sendPasswordResetEmail,X(a)),[c],function(){d.o();d=new jm(c,void 0,I(R(a)),Ri(R(a)));d.render(b);Z(a,
	d)},function(){d.a(Md().toString())}))});d.render(b);Z(a,d)}function An(a,b,c,d){var e=new wn(d.factorId,function(){e.K(t(X(a).sendPasswordResetEmail,X(a)),[c],function(){e.o();e=new jm(c,void 0,I(R(a)),Ri(R(a)));e.render(b);Z(a,e)},function(){e.a(Md().toString())})},d.phoneNumber);e.render(b);Z(a,e)}J.passwordReset=function(a,b,c,d){W(a,X(a).verifyPasswordResetCode(c).then(function(e){var f=new vn(e,function(){xn(a,b,f,c,d)});f.render(b);Z(a,f)},function(){yn(a,b)}))};J.emailChangeRevocation=function(a,
	b,c){var d=null;W(a,X(a).checkActionCode(c).then(function(e){d=e.data.email;return X(a).applyActionCode(c)}).then(function(){zn(a,b,d)},function(){var e=new sm;e.render(b);Z(a,e)}))};J.emailVerification=function(a,b,c,d){W(a,X(a).applyActionCode(c).then(function(){var e=new km(d);e.render(b);Z(a,e)},function(){var e=new lm;e.render(b);Z(a,e)}))};J.revertSecondFactorAddition=function(a,b,c){var d=null,e=null;W(a,X(a).checkActionCode(c).then(function(f){d=f.data.email;e=f.data.multiFactorInfo;return X(a).applyActionCode(c)}).then(function(){An(a,
	b,d,e)},function(){var f=new om;f.render(b);Z(a,f)}))};J.verifyAndChangeEmail=function(a,b,c,d){var e=null;W(a,X(a).checkActionCode(c).then(function(f){e=f.data.email;return X(a).applyActionCode(c)}).then(function(){var f=new mm(e,d);f.render(b);Z(a,f)},function(){var f=new nm;f.render(b);Z(a,f)}))};function Bn(a,b){try{var c="number"==typeof a.selectionStart}catch(d){c=!1}c?(a.selectionStart=b,a.selectionEnd=b):z&&!sc("9")&&("textarea"==a.type&&(b=a.value.substring(0,b).replace(/(\r\n|\r|\n)/g,"\n").length),
	a=a.createTextRange(),a.collapse(!0),a.move("character",b),a.select())}function Cn(a,b,c,d,e,f){O.call(this,tl,{email:c},f,"emailLinkSignInConfirmation",{G:d,F:e});this.l=a;this.u=b}n(Cn,O);Cn.prototype.v=function(){this.B(this.l);this.D(this.l,this.u);this.i().focus();Bn(this.i(),(this.i().value||"").length);O.prototype.v.call(this)};Cn.prototype.m=function(){this.u=this.l=null;O.prototype.m.call(this)};u(Cn.prototype,{i:dm,P:em,B:fm,J:gm,j:hm,U:Vl,S:Wl,D:Xl});J.emailLinkConfirmation=function(a,
	b,c,d,e,f){var g=new Cn(function(){var h=g.j();h?(g.o(),d(a,b,h,c)):g.i().focus()},function(){g.o();V(a,b,e||void 0)},e||void 0,I(R(a)),Ri(R(a)));g.render(b);Z(a,g);f&&g.a(f)};function Dn(a,b,c,d,e){O.call(this,yl,{ga:a},e,"emailLinkSignInLinkingDifferentDevice",{G:c,F:d});this.i=b}n(Dn,O);Dn.prototype.v=function(){this.u(this.i);this.l().focus();O.prototype.v.call(this)};Dn.prototype.m=function(){this.i=null;O.prototype.m.call(this)};u(Dn.prototype,{l:Vl,u:Xl});J.emailLinkNewDeviceLinking=function(a,
	b,c,d){var e=new Vb(c);c=e.a.a.get(x.PROVIDER_ID)||null;Zb(e,null);if(c){var f=new Dn(Di(R(a),c),function(){f.o();d(a,b,e.toString())},I(R(a)),Ri(R(a)));f.render(b);Z(a,f)}else V(a,b)};function En(a){O.call(this,ql,void 0,a,"blank")}n(En,O);function Fn(a,b,c,d,e){var f=new En,g=new Vb(c),h=g.a.a.get(x.ab)||"",k=g.a.a.get(x.Ta)||"",m="1"===g.a.a.get(x.Ra),q=Yb(g),E=g.a.a.get(x.PROVIDER_ID)||null;g=g.a.a.get(x.xb)||null;Gn(a,g);var S=!Ih(Gh,T(a)),Ha=d||Vh(k,T(a)),Pa=(d=Wh(k,T(a)))&&d.a;E&&Pa&&Pa.providerId!==
	E&&(Pa=null);f.render(b);Z(a,f);W(a,f.K(function(){var ja=G(null);ja=q&&S||S&&m?hf(Error("anonymous-user-not-found")):Hn(a,c).then(function(Mg){if(E&&!Pa)throw Error("pending-credential-not-found");return Mg});var td=null;return ja.then(function(Mg){td=Mg;return e?null:X(a).checkActionCode(h)}).then(function(){return td})},[],function(ja){Ha?In(a,f,Ha,c,Pa,ja):m?(f.o(),K("differentDeviceError",a,b)):(f.o(),K("emailLinkConfirmation",a,b,c,Jn))},function(ja){var td=void 0;if(!ja||!ja.name||"cancel"!=
	ja.name)switch(f.o(),ja&&ja.message){case "anonymous-user-not-found":K("differentDeviceError",a,b);break;case "anonymous-user-mismatch":K("anonymousUserMismatch",a,b);break;case "pending-credential-not-found":K("emailLinkNewDeviceLinking",a,b,c,Kn);break;default:ja&&(td=U(ja)),V(a,b,void 0,td)}}))}function Jn(a,b,c,d){Fn(a,b,d,c,!0)}function Kn(a,b,c){Fn(a,b,c)}function In(a,b,c,d,e,f){var g=P(b);b.Z("mdl-spinner mdl-spinner--single-color mdl-js-spinner is-active firebaseui-progress-dialog-loading-icon",
	C("Signing in...").toString());var h=null;e=(f?Ln(a,f,c,d,e):Mn(a,c,d,e)).then(function(k){Jh(Hh,T(a));Jh(Gh,T(a));b.h();b.Z("firebaseui-icon-done",C("Signed in!").toString());h=setTimeout(function(){b.h();Gm(a,b,k,!0)},1E3);W(a,function(){b&&(b.h(),b.o());clearTimeout(h)})},function(k){b.h();b.o();if(!k.name||"cancel"!=k.name){var m=U(k);"auth/email-already-in-use"==k.code||"auth/credential-already-in-use"==k.code?(Jh(Hh,T(a)),Jh(Gh,T(a))):"auth/invalid-email"==k.code?(m=C("The email provided does not match the current sign-in session.").toString(),
	K("emailLinkConfirmation",a,g,d,Jn,null,m)):V(a,g,c,m)}});W(a,e)}J.emailLinkSignInCallback=Fn;function Nn(a,b,c,d,e,f){O.call(this,xl,{email:a,ga:b},f,"emailLinkSignInLinking",{G:d,F:e});this.i=c}n(Nn,O);Nn.prototype.v=function(){this.u(this.i);this.l().focus();O.prototype.v.call(this)};Nn.prototype.m=function(){this.i=null;O.prototype.m.call(this)};u(Nn.prototype,{l:Vl,u:Xl});function On(a,b,c,d){var e=P(b);Vm(a,b,c,function(){V(a,e,c)},function(f){if(!f.name||"cancel"!=f.name){var g=U(f);f&&"auth/network-request-failed"==
	f.code?b.a(g):(b.o(),V(a,e,c,g))}},d)}J.emailLinkSignInLinking=function(a,b,c){var d=Qh(T(a));Rh(T(a));if(d){var e=d.a.providerId,f=new Nn(c,Di(R(a),e),function(){On(a,f,c,d)},I(R(a)),Ri(R(a)));f.render(b);Z(a,f)}else V(a,b)};function Pn(a,b,c,d,e,f){O.call(this,rl,{email:a},f,"emailLinkSignInSent",{G:d,F:e});this.u=b;this.i=c}n(Pn,O);Pn.prototype.v=function(){var a=this;N(this,this.l(),function(){a.i()});N(this,L(this,"firebaseui-id-trouble-getting-email-link"),function(){a.u()});this.l().focus();
	O.prototype.v.call(this)};Pn.prototype.m=function(){this.i=this.u=null;O.prototype.m.call(this)};u(Pn.prototype,{l:Wl});J.emailLinkSignInSent=function(a,b,c,d,e){var f=new Pn(c,function(){f.o();K("emailNotReceived",a,b,c,d,e)},function(){f.o();d()},I(R(a)),Ri(R(a)));f.render(b);Z(a,f)};function Qn(a,b,c,d,e,f,g){O.call(this,Ol,{ic:a,Pb:b},g,"emailMismatch",{G:e,F:f});this.l=c;this.i=d}n(Qn,O);Qn.prototype.v=function(){this.B(this.l,this.i);this.u().focus();O.prototype.v.call(this)};Qn.prototype.m=
	function(){this.i=null;O.prototype.m.call(this)};u(Qn.prototype,{u:Vl,D:Wl,B:Xl});J.emailMismatch=function(a,b,c){var d=Qh(T(a));if(d){var e=new Qn(c.user.email,d.f,function(){var f=e;Rh(T(a));Gm(a,f,c)},function(){var f=c.credential.providerId,g=P(e);e.o();d.a?K("federatedLinking",a,g,d.f,f):K("federatedSignIn",a,g,d.f,f)},I(R(a)),Ri(R(a)));e.render(b);Z(a,e)}else V(a,b)};function Rn(a,b,c,d,e){O.call(this,sl,void 0,e,"emailNotReceived",{G:c,F:d});this.l=a;this.i=b}n(Rn,O);Rn.prototype.v=function(){var a=
	this;N(this,this.u(),function(){a.i()});N(this,this.Ba(),function(){a.l()});this.u().focus();O.prototype.v.call(this)};Rn.prototype.Ba=function(){return L(this,"firebaseui-id-resend-email-link")};Rn.prototype.m=function(){this.i=this.l=null;O.prototype.m.call(this)};u(Rn.prototype,{u:Wl});J.emailNotReceived=function(a,b,c,d,e){var f=new Rn(function(){Vm(a,f,c,d,function(g){g=U(g);f.a(g)},e)},function(){f.o();V(a,b,c)},I(R(a)),Ri(R(a)));f.render(b);Z(a,f)};function Sn(a,b,c,d,e,f){O.call(this,zl,{email:a,
	ga:b},f,"federatedLinking",{G:d,F:e});this.i=c}n(Sn,O);Sn.prototype.v=function(){this.u(this.i);this.l().focus();O.prototype.v.call(this)};Sn.prototype.m=function(){this.i=null;O.prototype.m.call(this)};u(Sn.prototype,{l:Vl,u:Xl});J.federatedLinking=function(a,b,c,d,e){var f=Qh(T(a));if(f&&f.a){var g=new Sn(c,Di(R(a),d),function(){Mm(a,g,d,c)},I(R(a)),Ri(R(a)));g.render(b);Z(a,g);e&&g.a(e)}else V(a,b)};J.federatedRedirect=function(a,b,c){var d=new En;d.render(b);Z(a,d);b=Ci(R(a))[0];Mm(a,d,b,c)};
	J.federatedSignIn=function(a,b,c,d,e){var f=new Sn(c,Di(R(a),d),function(){Mm(a,f,d,c)},I(R(a)),Ri(R(a)));f.render(b);Z(a,f);e&&f.a(e)};function Tn(a,b,c,d){var e=b.u();e?W(a,b.K(t(a.Wb,a),[c,e],function(f){f=f.user.linkWithCredential(d).then(function(g){return Gm(a,b,{user:g.user,credential:d,operationType:g.operationType,additionalUserInfo:g.additionalUserInfo})});W(a,f);return f},function(f){if(!f.name||"cancel"!=f.name)switch(f.code){case "auth/wrong-password":M(b.i(),!1);Ck(b.D(),U(f));break;
	case "auth/too-many-requests":b.a(U(f));break;default:vg("signInWithEmailAndPassword: "+f.message,void 0),b.a(U(f))}})):b.i().focus()}J.passwordLinking=function(a,b,c){var d=Qh(T(a));Rh(T(a));var e=d&&d.a;if(e){var f=new bm(c,function(){Tn(a,f,c,e)},function(){f.o();K("passwordRecovery",a,b,c)},I(R(a)),Ri(R(a)));f.render(b);Z(a,f)}else V(a,b)};function Un(a,b,c,d,e,f){O.call(this,ml,{email:c,Ua:!!b},f,"passwordRecovery",{G:d,F:e});this.l=a;this.u=b}n(Un,O);Un.prototype.v=function(){this.D();this.J(this.l,
	this.u);Jj(this.i())||this.i().focus();il(this,this.i(),this.l);O.prototype.v.call(this)};Un.prototype.m=function(){this.u=this.l=null;O.prototype.m.call(this)};u(Un.prototype,{i:dm,B:em,D:fm,P:gm,j:hm,U:Vl,S:Wl,J:Xl});function Vn(a,b){var c=b.j();if(c){var d=P(b);W(a,b.K(t(X(a).sendPasswordResetEmail,X(a)),[c],function(){b.o();var e=new jm(c,function(){e.o();V(a,d)},I(R(a)),Ri(R(a)));e.render(d);Z(a,e)},function(e){M(b.i(),!1);Ck(b.B(),U(e))}))}else b.i().focus()}J.passwordRecovery=function(a,b,
	c,d,e){var f=new Un(function(){Vn(a,f)},d?void 0:function(){f.o();V(a,b)},c,I(R(a)),Ri(R(a)));f.render(b);Z(a,f);e&&f.a(e)};J.passwordSignIn=function(a,b,c,d){var e=new im(function(){Rm(a,e)},function(){var f=e.P();e.o();K("passwordRecovery",a,b,f)},c,I(R(a)),Ri(R(a)),d);e.render(b);Z(a,e)};function Wn(){return L(this,"firebaseui-id-name")}function Xn(){return L(this,"firebaseui-id-name-error")}function Yn(a,b,c,d,e,f,g,h,k){O.call(this,ll,{email:d,Sb:a,name:e,Ua:!!c,ia:!!h},k,"passwordSignUp",{G:f,
	F:g});this.B=b;this.J=c;this.D=a}n(Yn,O);Yn.prototype.v=function(){this.ea();this.D&&this.Ja();this.ua();this.pa(this.B,this.J);this.D?(hl(this,this.i(),this.u()),hl(this,this.u(),this.l())):hl(this,this.i(),this.l());this.B&&il(this,this.l(),this.B);Jj(this.i())?this.D&&!Jj(this.u())?this.u().focus():this.l().focus():this.i().focus();O.prototype.v.call(this)};Yn.prototype.m=function(){this.J=this.B=null;O.prototype.m.call(this)};u(Yn.prototype,{i:dm,U:em,ea:fm,kb:gm,j:hm,u:Wn,Ac:Xn,Ja:function(){var a=
	Wn.call(this),b=Xn.call(this);xk(this,a,function(){Dk(b)&&(M(a,!0),Bk(b))})},P:function(){var a=Wn.call(this);var b=Xn.call(this);var c=Jj(a);c=!/^[\s\xa0]*$/.test(null==c?"":String(c));M(a,c);c?(Bk(b),b=!0):(Ck(b,C("Enter your account name").toString()),b=!1);return b?Za(Jj(a)):null},l:pn,ba:sn,mb:qn,ua:tn,S:un,Mb:Vl,Lb:Wl,pa:Xl});function Zn(a,b){var c=Si(R(a)),d=b.j(),e=null;c&&(e=b.P());var f=b.S();if(d){if(c)if(e)e=hb(e);else{b.u().focus();return}if(f){var g=firebase.auth.EmailAuthProvider.credential(d,
	f);W(a,b.K(t(a.Xb,a),[d,f],function(h){var k={user:h.user,credential:g,operationType:h.operationType,additionalUserInfo:h.additionalUserInfo};return c?(h=h.user.updateProfile({displayName:e}).then(function(){return Gm(a,b,k)}),W(a,h),h):Gm(a,b,k)},function(h){if(!h.name||"cancel"!=h.name){var k=U(h);switch(h.code){case "auth/email-already-in-use":return $n(a,b,d,h);case "auth/too-many-requests":k=C("Too many account requests are coming from your IP address. Try again in a few minutes.").toString();
	case "auth/operation-not-allowed":case "auth/weak-password":M(b.l(),!1);Ck(b.ba(),k);break;default:h="setAccountInfo: "+ih(h),vg(h,void 0),b.a(k)}}}))}else b.l().focus()}else b.i().focus()}function $n(a,b,c,d){function e(){var g=U(d);M(b.i(),!1);Ck(b.U(),g);b.i().focus()}var f=X(a).fetchSignInMethodsForEmail(c).then(function(g){g.length?e():(g=P(b),b.o(),K("passwordRecovery",a,g,c,!1,Od().toString()))},function(){e()});W(a,f);return f}J.passwordSignUp=function(a,b,c,d,e,f){function g(){h.o();V(a,
	b)}var h=new Yn(Si(R(a)),function(){Zn(a,h)},e?void 0:g,c,d,I(R(a)),Ri(R(a)),f);h.render(b);Z(a,h)};function ao(){return L(this,"firebaseui-id-phone-confirmation-code")}function bo(){return L(this,"firebaseui-id-phone-confirmation-code-error")}function co(){return L(this,"firebaseui-id-resend-countdown")}function eo(a,b,c,d,e,f,g,h,k){O.call(this,Rl,{phoneNumber:e},k,"phoneSignInFinish",{G:g,F:h});this.kb=f;this.i=new Vj(1E3);this.D=f;this.S=a;this.l=b;this.J=c;this.P=d}n(eo,O);eo.prototype.v=function(){var a=
	this;this.U(this.kb);oe(this.i,"tick",this.B,!1,this);this.i.start();N(this,L(this,"firebaseui-id-change-phone-number-link"),function(){a.S()});N(this,this.Ba(),function(){a.P()});this.Ja(this.l);this.ea(this.l,this.J);this.u().focus();O.prototype.v.call(this)};eo.prototype.m=function(){this.P=this.J=this.l=this.S=null;Wj(this.i);we(this.i,"tick",this.B);this.i=null;O.prototype.m.call(this)};eo.prototype.B=function(){--this.D;0<this.D?this.U(this.D):(Wj(this.i),we(this.i,"tick",this.B),this.ua(),
	this.mb())};u(eo.prototype,{u:ao,pa:bo,Ja:function(a){var b=ao.call(this),c=bo.call(this);xk(this,b,function(){Dk(c)&&(M(b,!0),Bk(c))});a&&yk(this,b,function(){a()})},ba:function(){var a=Za(Jj(ao.call(this))||"");return/^\d{6}$/.test(a)?a:null},Eb:co,U:function(a){ed(co.call(this),C("Resend code in "+((9<a?"0:":"0:0")+a)).toString())},ua:function(){Bk(this.Eb())},Ba:function(){return L(this,"firebaseui-id-resend-link")},mb:function(){Ck(this.Ba())},Mb:Vl,Lb:Wl,ea:Xl});function fo(a,b,c,d){function e(g){b.u().focus();
	M(b.u(),!1);Ck(b.pa(),g)}var f=b.ba();f?(b.Z("mdl-spinner mdl-spinner--single-color mdl-js-spinner is-active firebaseui-progress-dialog-loading-icon",C("Verifying...").toString()),W(a,b.K(t(d.confirm,d),[f],function(g){b.h();b.Z("firebaseui-icon-done",C("Verified!").toString());var h=setTimeout(function(){b.h();b.o();var k={user:go(a).currentUser,credential:null,operationType:g.operationType,additionalUserInfo:g.additionalUserInfo};Gm(a,b,k,!0)},1E3);W(a,function(){b&&b.h();clearTimeout(h)})},function(g){if(g.name&&
	"cancel"==g.name)b.h();else{var h=U(g);switch(g.code){case "auth/credential-already-in-use":b.h();break;case "auth/code-expired":g=P(b);b.h();b.o();K("phoneSignInStart",a,g,c,h);break;case "auth/missing-verification-code":case "auth/invalid-verification-code":b.h();e(h);break;default:b.h(),b.a(h)}}}))):e(C("Wrong code. Try again.").toString())}J.phoneSignInFinish=function(a,b,c,d,e,f){var g=new eo(function(){g.o();K("phoneSignInStart",a,b,c)},function(){fo(a,g,c,e)},function(){g.o();V(a,b)},function(){g.o();
	K("phoneSignInStart",a,b,c)},oi(c),d,I(R(a)),Ri(R(a)));g.render(b);Z(a,g);f&&g.a(f)};var ho=!z&&!(y("Safari")&&!(cc()||y("Coast")||y("Opera")||y("Edge")||y("Firefox")||y("FxiOS")||y("Silk")||y("Android")));function io(a,b){if(/-[a-z]/.test(b))return null;if(ho&&a.dataset){if(!(!y("Android")||cc()||y("Firefox")||y("FxiOS")||y("Opera")||y("Silk")||b in a.dataset))return null;a=a.dataset[b];return void 0===a?null:a}return a.getAttribute("data-"+String(b).replace(/([A-Z])/g,"-$1").toLowerCase())}function jo(a,
	b,c){var d=this;a=md(Sk,{items:a},null,this.s);Zk.call(this,a,!0,!0);c&&(c=ko(a,c))&&(c.focus(),pk(c,a));N(this,a,function(e){if(e=(e=fd(e.target,"firebaseui-id-list-box-dialog-button"))&&io(e,"listboxid"))$k.call(d),b(e)})}function ko(a,b){a=(a||document).getElementsByTagName("BUTTON");for(var c=0;c<a.length;c++)if(io(a[c],"listboxid")===b)return a[c];return null}function lo(){return L(this,"firebaseui-id-phone-number")}function mo(){return L(this,"firebaseui-id-country-selector")}function no(){return L(this,
	"firebaseui-id-phone-number-error")}function oo(a,b){var c=a.a,d=po("1-US-0",c),e=null;b&&po(b,c)?e=b:d?e="1-US-0":e=0<c.length?c[0].c:null;if(!e)throw Error("No available default country");qo.call(this,e,a)}function po(a,b){a=gi(a);return!(!a||!Qa(b,a))}function ro(a){return Ma(a,function(b){return{id:b.c,Ma:"firebaseui-flag "+so(b),label:b.name+" "+("\u200e+"+b.b)}})}function so(a){return"firebaseui-flag-"+a.g}function to(a){var b=this;jo.call(this,ro(a.a),function(c){qo.call(b,c,a,!0);b.N().focus()},
	this.Aa)}function qo(a,b,c){var d=gi(a);d&&(c&&(c=Za(Jj(lo.call(this))||""),b=fi(b,c),b.length&&b[0].b!=d.b&&(c="+"+d.b+c.substr(b[0].b.length+1),Kj(lo.call(this),c))),b=gi(this.Aa),this.Aa=a,a=L(this,"firebaseui-id-country-selector-flag"),b&&Ij(a,so(b)),Hj(a,so(d)),ed(L(this,"firebaseui-id-country-selector-code"),"\u200e+"+d.b))}function uo(a,b,c,d,e,f,g,h,k,m){O.call(this,Ql,{Fb:b,za:k||null,Wa:!!c,ia:!!f},m,"phoneSignInStart",{G:d,F:e});this.J=h||null;this.P=b;this.l=a;this.B=c||null;this.pa=g||
	null}n(uo,O);uo.prototype.v=function(){this.ea(this.pa,this.J);this.S(this.l,this.B||void 0);this.P||hl(this,this.N(),this.i());il(this,this.i(),this.l);this.N().focus();Bn(this.N(),(this.N().value||"").length);O.prototype.v.call(this)};uo.prototype.m=function(){this.B=this.l=null;O.prototype.m.call(this)};u(uo.prototype,{Db:al,N:lo,D:no,ea:function(a,b,c){var d=this,e=lo.call(this),f=mo.call(this),g=no.call(this),h=a||li,k=h.a;if(0==k.length)throw Error("No available countries provided.");oo.call(d,
	h,b);N(this,f,function(){to.call(d,h)});xk(this,e,function(){Dk(g)&&(M(e,!0),Bk(g));var m=Za(Jj(e)||""),q=gi(this.Aa),E=fi(h,m);m=po("1-US-0",k);E.length&&E[0].b!=q.b&&(q=E[0],qo.call(d,"1"==q.b&&m?"1-US-0":q.c,h))});c&&yk(this,e,function(){c()})},U:function(a){var b=Za(Jj(lo.call(this))||"");a=a||li;var c=a.a,d=fi(li,b);if(d.length&&!Qa(c,d[0]))throw Kj(lo.call(this)),lo.call(this).focus(),Ck(no.call(this),C("The country code provided is not supported.").toString()),Error("The country code provided is not supported.");
	c=gi(this.Aa);d.length&&d[0].b!=c.b&&qo.call(this,d[0].c,a);d.length&&(b=b.substr(d[0].b.length+1));return b?new mi(this.Aa,b):null},Ja:mo,ba:function(){return L(this,"firebaseui-recaptcha-container")},u:function(){return L(this,"firebaseui-id-recaptcha-error")},i:Vl,ua:Wl,S:Xl});function vo(a,b,c,d){try{var e=b.U(ij)}catch(f){return}e?gj?(b.Z("mdl-spinner mdl-spinner--single-color mdl-js-spinner is-active firebaseui-progress-dialog-loading-icon",C("Verifying...").toString()),W(a,b.K(t(a.bc,a),[oi(e),
	c],function(f){var g=P(b);b.Z("firebaseui-icon-done",C("Code sent!").toString());var h=setTimeout(function(){b.h();b.o();K("phoneSignInFinish",a,g,e,15,f)},1E3);W(a,function(){b&&b.h();clearTimeout(h)})},function(f){b.h();if(!f.name||"cancel"!=f.name){grecaptcha.reset(jj);gj=null;var g=f&&f.message||"";if(f.code)switch(f.code){case "auth/too-many-requests":g=C("This phone number has been used too many times").toString();break;case "auth/invalid-phone-number":case "auth/missing-phone-number":b.N().focus();
	Ck(b.D(),Ld().toString());return;default:g=U(f)}b.a(g)}}))):hj?Ck(b.u(),C("Solve the reCAPTCHA").toString()):!hj&&d&&b.i().click():(b.N().focus(),Ck(b.D(),Ld().toString()))}J.phoneSignInStart=function(a,b,c,d){var e=Ki(R(a))||{};gj=null;hj=!(e&&"invisible"===e.size);var f=Sm(a),g=Pi(R(a)),h=f?Oi(R(a)):null;g=c&&c.a||g&&g.c||null;c=c&&c.za||h;(h=Qi(R(a)))&&ki(h);ij=h?new ei(Qi(R(a))):li;var k=new uo(function(q){vo(a,k,m,!(!q||!q.keyCode))},hj,f?null:function(){m.clear();k.o();V(a,b)},I(R(a)),Ri(R(a)),
	f,ij,g,c);k.render(b);Z(a,k);d&&k.a(d);e.callback=function(q){k.u()&&Bk(k.u());gj=q;hj||vo(a,k,m)};e["expired-callback"]=function(){gj=null};var m=new firebase.auth.RecaptchaVerifier(hj?k.ba():k.i(),e,go(a).app);W(a,k.K(t(m.render,m),[],function(q){jj=q},function(q){q.name&&"cancel"==q.name||(q=U(q),k.o(),V(a,b,void 0,q))}))};J.prefilledEmailSignIn=function(a,b,c){var d=new En;d.render(b);Z(a,d);W(a,d.K(t(X(a).fetchSignInMethodsForEmail,X(a)),[c],function(e){d.o();var f=!(!Cm(a)||!bn(a));Dm(a,b,e,
	c,void 0,void 0,f)},function(e){e=U(e);d.o();K("signIn",a,b,c,e)}))};function wo(a,b,c,d,e){O.call(this,Pl,{Rb:b},e,"providerSignIn",{G:c,F:d});this.i=a}n(wo,O);wo.prototype.v=function(){this.l(this.i);O.prototype.v.call(this)};wo.prototype.m=function(){this.i=null;O.prototype.m.call(this)};u(wo.prototype,{l:function(a){function b(g){a(g)}for(var c=this.f?Yc("firebaseui-id-idp-button",this.f||this.s.a):[],d=0;d<c.length;d++){var e=c[d],f=io(e,"providerId");N(this,e,Ba(b,f))}}});J.providerSignIn=function(a,
	b,c,d){var e=new wo(function(f){f==firebase.auth.EmailAuthProvider.PROVIDER_ID?(e.o(),Tm(a,b,d)):f==firebase.auth.PhoneAuthProvider.PROVIDER_ID?(e.o(),K("phoneSignInStart",a,b)):"anonymous"==f?Pm(a,e):Mm(a,e,f,d);Y(a);a.l.cancel()},Ei(R(a)),I(R(a)),Ri(R(a)));e.render(b);Z(a,e);c&&e.a(c);xo(a)};J.sendEmailLinkForSignIn=function(a,b,c,d){var e=new en;e.render(b);Z(a,e);Vm(a,e,c,d,function(f){e.o();f=U(f);K("signIn",a,b,c,f)})};function yo(a,b,c,d,e,f,g){O.call(this,jl,{email:c,Wa:!!b,ia:!!f},g,"signIn",
	{G:d,F:e});this.i=a;this.u=b}n(yo,O);yo.prototype.v=function(){this.B(this.i);this.D(this.i,this.u||void 0);this.l().focus();Bn(this.l(),(this.l().value||"").length);O.prototype.v.call(this)};yo.prototype.m=function(){this.u=this.i=null;O.prototype.m.call(this)};u(yo.prototype,{l:dm,P:em,B:fm,J:gm,j:hm,U:Vl,S:Wl,D:Xl});J.signIn=function(a,b,c,d){var e=Cm(a),f=e&&Hi(R(a))!=ti,g=new yo(function(){var h=g,k=h.j()||"";k&&Um(a,h,k)},f?null:function(){g.o();V(a,b,c)},c,I(R(a)),Ri(R(a)),e);g.render(b);Z(a,
	g);d&&g.a(d)};function zo(a,b,c,d,e,f){O.call(this,Al,{email:a},f,"unsupportedProvider",{G:d,F:e});this.l=b;this.i=c}n(zo,O);zo.prototype.v=function(){this.B(this.l,this.i);this.u().focus();O.prototype.v.call(this)};zo.prototype.m=function(){this.i=this.l=null;O.prototype.m.call(this)};u(zo.prototype,{u:Vl,D:Wl,B:Xl});J.unsupportedProvider=function(a,b,c){var d=new zo(c,function(){d.o();K("passwordRecovery",a,b,c)},function(){d.o();V(a,b,c)},I(R(a)),Ri(R(a)));d.render(b);Z(a,d)};function Ao(a,b){this.Z=
	!1;var c=Bo(b);if(Co[c])throw Error('An AuthUI instance already exists for the key "'+c+'"');Co[c]=this;this.f=a;this.u=null;this.X=!1;Do(this.f);this.a=firebase.initializeApp({apiKey:a.app.options.apiKey,authDomain:a.app.options.authDomain},a.app.name+"-firebaseui-temp").auth();Do(this.a);this.a.setPersistence&&this.a.setPersistence(firebase.auth.Auth.Persistence.SESSION);this.oa=b;this.ca=new si;this.h=this.O=this.i=this.I=this.N=null;this.s=[];this.Y=!1;this.l=Tf.Ya();this.j=this.C=null;this.da=
	this.w=!1}function Do(a){a&&a.INTERNAL&&a.INTERNAL.logFramework&&a.INTERNAL.logFramework("FirebaseUI-web")}var Co={};function Bo(a){return a||"[DEFAULT]"}function Nm(a){Y(a);a.i||(a.i=Eo(a,function(b){return b&&!Qh(T(a))?G(go(a).getRedirectResult().then(function(c){return c},function(c){if(c&&"auth/email-already-in-use"==c.code&&c.email&&c.credential)throw c;return Fo(a,c)})):G(X(a).getRedirectResult().then(function(c){return yi(R(a))&&!c.user&&a.j&&!a.j.isAnonymous?go(a).getRedirectResult():c}))}));
	return a.i}function Z(a,b){Y(a);a.h=b}var Go=null;function Wm(){return Go}function X(a){Y(a);return a.a}function go(a){Y(a);return a.f}function T(a){Y(a);return a.oa}function bn(a){Y(a);return a.N?a.N.emailHint:void 0}l=Ao.prototype;l.ob=function(){Y(this);return!!Th(T(this))||Ho(yf())};function Ho(a){a=new Vb(a);return"signIn"===(a.a.a.get(x.wb)||null)&&!!a.a.a.get(x.ab)}l.start=function(a,b){Io(this,a,b)};function Io(a,b,c,d){Y(a);"undefined"!==typeof a.f.languageCode&&(a.u=a.f.languageCode);var e=
	"en".replace(/_/g,"-");a.f.languageCode=e;a.a.languageCode=e;a.X=!0;"undefined"!==typeof a.f.tenantId&&(a.a.tenantId=a.f.tenantId);a.jb(c);a.N=d||null;var f=p.document;a.C?a.C.then(function(){"complete"==f.readyState?Jo(a,b):pe(window,"load",function(){Jo(a,b)})}):"complete"==f.readyState?Jo(a,b):pe(window,"load",function(){Jo(a,b)})}function Jo(a,b){var c=xf(b,"Could not find the FirebaseUI widget element on the page.");c.setAttribute("lang","en".replace(/_/g,"-"));if(Go){var d=Go;Y(d);Qh(T(d))&&
	Ag("UI Widget is already rendered on the page and is pending some user interaction. Only one widget instance can be rendered per page. The previous instance has been automatically reset.");Go.reset()}Go=a;a.O=c;Ko(a,c);rh(new sh)&&rh(new th)?an(a,b):(b=xf(b,"Could not find the FirebaseUI widget element on the page."),c=new um(C("The browser you are using does not support Web Storage. Please try again in a different browser.").toString()),c.render(b),Z(a,c));b=a.h&&"blank"==a.h.Ea&&Wi(R(a));Th(T(a))&&
	!b&&(b=Th(T(a)),Gn(a,b.a),Jh(Ch,T(a)))}function Eo(a,b){if(a.w)return b(Lo(a));W(a,function(){a.w=!1});if(yi(R(a))){var c=new Ze(function(d){W(a,a.f.onAuthStateChanged(function(e){a.j=e;a.w||(a.w=!0,d(b(Lo(a))))}))});W(a,c);return c}a.w=!0;return b(null)}function Lo(a){Y(a);return yi(R(a))&&a.j&&a.j.isAnonymous?a.j:null}function W(a,b){Y(a);if(b){a.s.push(b);var c=function(){Ua(a.s,function(d){return d==b})};"function"!=typeof b&&b.then(c,c)}}l.disableAutoSignIn=function(){Y(this);this.Y=!0};function Mo(a){Y(a);
	var b;(b=a.Y)||(a=R(a),a=Ni(a,firebase.auth.GoogleAuthProvider.PROVIDER_ID),b=!(!a||"select_account"!==a.prompt));return b}function Hm(a){"undefined"!==typeof a.f.languageCode&&a.X&&(a.X=!1,a.f.languageCode=a.u)}function Gn(a,b){a.f.tenantId=b;a.a.tenantId=b}l.reset=function(){Y(this);var a=this;this.O&&this.O.removeAttribute("lang");this.I&&He(this.I);Hm(this);this.N=null;cn();Jh(Ch,T(this));Y(this);this.l.cancel();this.i=G({user:null,credential:null});Go==this&&(Go=null);this.O=null;for(var b=0;b<
	this.s.length;b++)if("function"==typeof this.s[b])this.s[b]();else this.s[b].cancel&&this.s[b].cancel();this.s=[];Rh(T(this));this.h&&(this.h.o(),this.h=null);this.L=null;this.a&&(this.C=mn(this).then(function(){a.C=null},function(){a.C=null}))};function Ko(a,b){a.L=null;a.I=new Ie(b);a.I.register();oe(a.I,"pageEnter",function(c){c=c&&c.pageId;if(a.L!=c){var d=R(a);(d=aj(d).uiChanged||null)&&d(a.L,c);a.L=c}})}l.jb=function(a){Y(this);var b=this.ca,c;for(c in a)try{Zh(b.a,c,a[c])}catch(d){vg('Invalid config: "'+
	c+'"',void 0)}lc&&Zh(b.a,"popupMode",!1);Qi(b);!this.da&&bj(R(this))&&(Ag("signInSuccess callback is deprecated. Please use signInSuccessWithAuthResult callback instead."),this.da=!0)};function R(a){Y(a);return a.ca}l.Vb=function(){Y(this);var a=R(this),b=$h(a.a,"widgetUrl");var c=wi(a,b);R(this).a.get("popupMode")?(a=(window.screen.availHeight-600)/2,b=(window.screen.availWidth-500)/2,c=c||"about:blank",a={width:500,height:600,top:0<a?a:0,left:0<b?b:0,location:!0,resizable:!0,statusbar:!0,toolbar:!1},
	a.target=a.target||c.target||"google_popup",a.width=a.width||690,a.height=a.height||500,(a=tf(c,a))&&a.focus()):uf(c)};function Y(a){if(a.Z)throw Error("AuthUI instance is deleted!");}l.Xa=function(){var a=this;Y(this);return this.a.app.delete().then(function(){var b=Bo(T(a));delete Co[b];a.reset();a.Z=!0})};function xo(a){Y(a);try{Uf(a.l,Gi(R(a)),Mo(a)).then(function(b){return a.h?Qm(a,a.h,b):!1})}catch(b){}}l.Hb=function(a,b){Y(this);var c=this,d=Af();if(!Ti(R(this)))return hf(Error("Email link sign-in should be enabled to trigger email sending."));
	var e=Vi(R(this)),f=new Vb(e.url);Wb(f,d);b&&b.a&&(Xh(d,b,T(this)),Zb(f,b.a.providerId));Xb(f,Ui(R(this)));return Eo(this,function(g){g&&((g=g.uid)?f.a.a.set(x.Qa,g):Tb(f.a.a,x.Qa));e.url=f.toString();return X(c).sendSignInLinkToEmail(a,e)}).then(function(){var g=T(c),h={};h.email=a;Kh(Gh,fh(d,JSON.stringify(h)),g)},function(g){Jh(Hh,T(c));Jh(Gh,T(c));throw g;})};function Hn(a,b){var c=Yb(new Vb(b));if(!c)return G(null);b=new Ze(function(d,e){var f=go(a).onAuthStateChanged(function(g){f();g&&g.isAnonymous&&
	g.uid===c?d(g):g&&g.isAnonymous&&g.uid!==c?e(Error("anonymous-user-mismatch")):e(Error("anonymous-user-not-found"))});W(a,f)});W(a,b);return b}function Ln(a,b,c,d,e){Y(a);var f=e||null,g=firebase.auth.EmailAuthProvider.credentialWithLink(c,d);c=f?X(a).signInWithEmailLink(c,d).then(function(h){return h.user.linkWithCredential(f)}).then(function(){return mn(a)}).then(function(){return Fo(a,{code:"auth/email-already-in-use"},f)}):X(a).fetchSignInMethodsForEmail(c).then(function(h){return h.length?Fo(a,
	{code:"auth/email-already-in-use"},g):b.linkWithCredential(g)});W(a,c);return c}function Mn(a,b,c,d){Y(a);var e=d||null,f;b=X(a).signInWithEmailLink(b,c).then(function(g){f={user:g.user,credential:null,operationType:g.operationType,additionalUserInfo:g.additionalUserInfo};if(e)return g.user.linkWithCredential(e).then(function(h){f={user:h.user,credential:e,operationType:f.operationType,additionalUserInfo:h.additionalUserInfo}})}).then(function(){mn(a)}).then(function(){return go(a).updateCurrentUser(f.user)}).then(function(){f.user=
	go(a).currentUser;return f});W(a,b);return b}function cn(){var a=yf();if(Ho(a)){a=new Vb(a);for(var b in x)x.hasOwnProperty(b)&&Tb(a.a.a,x[b]);b={state:"signIn",mode:"emailLink",operation:"clear"};var c=p.document.title;p.history&&p.history.replaceState&&p.history.replaceState(b,c,a.toString())}}l.ac=function(a,b){Y(this);var c=this;return X(this).signInWithEmailAndPassword(a,b).then(function(d){return Eo(c,function(e){return e?mn(c).then(function(){return Fo(c,{code:"auth/email-already-in-use"},
	firebase.auth.EmailAuthProvider.credential(a,b))}):d})})};l.Xb=function(a,b){Y(this);var c=this;return Eo(this,function(d){if(d){var e=firebase.auth.EmailAuthProvider.credential(a,b);return d.linkWithCredential(e)}return X(c).createUserWithEmailAndPassword(a,b)})};l.$b=function(a){Y(this);var b=this;return Eo(this,function(c){return c?c.linkWithCredential(a).then(function(d){return d},function(d){if(d&&"auth/email-already-in-use"==d.code&&d.email&&d.credential)throw d;return Fo(b,d,a)}):X(b).signInWithCredential(a)})};
	function Om(a,b){Y(a);return Eo(a,function(c){return c&&!Qh(T(a))?c.linkWithPopup(b).then(function(d){return d},function(d){if(d&&"auth/email-already-in-use"==d.code&&d.email&&d.credential)throw d;return Fo(a,d)}):X(a).signInWithPopup(b)})}l.cc=function(a){Y(this);var b=this,c=this.i;this.i=null;return Eo(this,function(d){return d&&!Qh(T(b))?d.linkWithRedirect(a):X(b).signInWithRedirect(a)}).then(function(){},function(d){b.i=c;throw d;})};l.bc=function(a,b){Y(this);var c=this;return Eo(this,function(d){return d?
	d.linkWithPhoneNumber(a,b).then(function(e){return new Zf(e,function(f){if("auth/credential-already-in-use"==f.code)return Fo(c,f);throw f;})}):go(c).signInWithPhoneNumber(a,b).then(function(e){return new Zf(e)})})};l.Zb=function(){Y(this);return go(this).signInAnonymously()};function Jm(a,b){Y(a);return Eo(a,function(c){if(a.j&&!a.j.isAnonymous&&yi(R(a))&&!X(a).currentUser)return mn(a).then(function(){"password"==b.credential.providerId&&(b.credential=null);return b});if(c)return mn(a).then(function(){return c.linkWithCredential(b.credential)}).then(function(d){b.user=
	d.user;b.credential=d.credential;b.operationType=d.operationType;b.additionalUserInfo=d.additionalUserInfo;return b},function(d){if(d&&"auth/email-already-in-use"==d.code&&d.email&&d.credential)throw d;return Fo(a,d,b.credential)});if(!b.user)throw Error('Internal error: An incompatible or outdated version of "firebase.js" may be used.');return mn(a).then(function(){return go(a).updateCurrentUser(b.user)}).then(function(){b.user=go(a).currentUser;b.operationType="signIn";b.credential&&b.credential.providerId&&
	"password"==b.credential.providerId&&(b.credential=null);return b})})}l.Wb=function(a,b){Y(this);return X(this).signInWithEmailAndPassword(a,b)};function mn(a){Y(a);return X(a).signOut()}function Fo(a,b,c){Y(a);if(b&&b.code&&("auth/email-already-in-use"==b.code||"auth/credential-already-in-use"==b.code)){var d=zi(R(a));return G().then(function(){return d(new Rd("anonymous-upgrade-merge-conflict",null,c||b.credential))}).then(function(){a.h&&(a.h.o(),a.h=null);throw b;})}return hf(b)}function No(a,
	b,c,d){O.call(this,Ul,void 0,d,"providerMatchByEmail",{G:b,F:c});this.i=a}n(No,O);No.prototype.v=function(){this.u(this.i);this.B(this.i);this.l().focus();Bn(this.l(),(this.l().value||"").length);O.prototype.v.call(this)};No.prototype.m=function(){this.i=null;O.prototype.m.call(this)};u(No.prototype,{l:dm,J:em,u:fm,D:gm,j:hm,P:Vl,B:Xl});function Oo(a,b,c,d,e){O.call(this,Tl,{dc:b},e,"selectTenant",{G:c,F:d});this.i=a}n(Oo,O);Oo.prototype.v=function(){Po(this,this.i);O.prototype.v.call(this)};Oo.prototype.m=
	function(){this.i=null;O.prototype.m.call(this)};function Po(a,b){function c(h){b(h)}for(var d=a.f?Yc("firebaseui-id-tenant-selection-button",a.f||a.s.a):[],e=0;e<d.length;e++){var f=d[e],g=io(f,"tenantId");N(a,f,Ba(c,g))}}function Qo(a){O.call(this,pl,void 0,a,"spinner")}n(Qo,O);function Ro(a){this.a=new Yh;H(this.a,"authDomain");H(this.a,"displayMode",So);H(this.a,"tenants");H(this.a,"callbacks");H(this.a,"tosUrl");H(this.a,"privacyPolicyUrl");for(var b in a)if(a.hasOwnProperty(b))try{Zh(this.a,
	b,a[b])}catch(c){vg('Invalid config: "'+b+'"',void 0)}}function To(a){a=a.a.get("displayMode");for(var b in Uo)if(Uo[b]===a)return Uo[b];return So}function Vo(a){return a.a.get("callbacks")||{}}function Wo(a){var b=a.a.get("tosUrl")||null;a=a.a.get("privacyPolicyUrl")||null;b&&!a&&Ag("Privacy Policy URL is missing, the link will not be displayed.");if(b&&a){if("function"===typeof b)return b;if("string"===typeof b)return function(){wf(b)}}return null}function Xo(a){var b=a.a.get("tosUrl")||null,c=
	a.a.get("privacyPolicyUrl")||null;c&&!b&&Ag("Terms of Service URL is missing, the link will not be displayed.");if(b&&c){if("function"===typeof c)return c;if("string"===typeof c)return function(){wf(c)}}return null}function Yo(a,b){a=a.a.get("tenants");if(!a||!a.hasOwnProperty(b)&&!a.hasOwnProperty(Zo))throw Error("Invalid tenant configuration!");}function $o(a,b,c){a=a.a.get("tenants");if(!a)throw Error("Invalid tenant configuration!");var d=[];a=a[b]||a[Zo];if(!a)return vg("Invalid tenant configuration: "+
	(b+" is not configured!"),void 0),d;b=a.signInOptions;if(!b)throw Error("Invalid tenant configuration: signInOptions are invalid!");b.forEach(function(e){if("string"===typeof e)d.push(e);else if("string"===typeof e.provider){var f=e.hd;f&&c?(f instanceof RegExp?f:new RegExp("@"+f.replace(".","\\.")+"$")).test(c)&&d.push(e.provider):d.push(e.provider)}else e="Invalid tenant configuration: signInOption "+(JSON.stringify(e)+" is invalid!"),vg(e,void 0)});return d}function ap(a,b,c){a=bp(a,b);(b=a.signInOptions)&&
	c&&(b=b.filter(function(d){return"string"===typeof d?c.includes(d):c.includes(d.provider)}),a.signInOptions=b);return a}function bp(a,b){var c=cp;var d=void 0===d?{}:d;Yo(a,b);a=a.a.get("tenants");return Bf(a[b]||a[Zo],c,d)}var cp=["immediateFederatedRedirect","privacyPolicyUrl","signInFlow","signInOptions","tosUrl"],So="optionFirst",Uo={oc:So,nc:"identifierFirst"},Zo="*";function dp(a,b){var c=this;this.s=xf(a);this.a={};Object.keys(b).forEach(function(d){c.a[d]=new Ro(b[d])});this.pb=this.f=this.w=
	this.h=this.i=this.j=null;Object.defineProperty(this,"languageCode",{get:function(){return this.pb},set:function(d){this.pb=d||null},enumerable:!1})}l=dp.prototype;l.Tb=function(a,b){var c=this;ep(this);var d=a.apiKey;return new Ze(function(e,f){if(c.a.hasOwnProperty(d)){var g=Vo(c.a[d]).selectTenantUiHidden||null;if(To(c.a[d])===So){var h=[];b.forEach(function(q){q=q||"_";var E=c.a[d].a.get("tenants");if(!E)throw Error("Invalid tenant configuration!");(E=E[q]||E[Zo])?q={tenantId:"_"!==q?q:null,displayName:E.displayName,
	Na:E.iconUrl,Ga:E.buttonColor}:(vg("Invalid tenant configuration: "+(q+" is not configured!"),void 0),q=null);q&&h.push(q)});var k=function(q){q={tenantId:q,providerIds:$o(c.a[d],q||"_")};e(q)};if(1===h.length){k(h[0].tenantId);return}c.f=new Oo(function(q){ep(c);g&&g();k(q)},h,Wo(c.a[d]),Xo(c.a[d]))}else c.f=new No(function(){var q=c.f.j();if(q){for(var E=0;E<b.length;E++){var S=$o(c.a[d],b[E]||"_",q);if(0!==S.length){q={tenantId:b[E],providerIds:S,email:q};ep(c);g&&g();e(q);return}}c.f.a(Pd({code:"no-matching-tenant-for-email"}).toString())}},
	Wo(c.a[d]),Xo(c.a[d]));c.f.render(c.s);(f=Vo(c.a[d]).selectTenantUiShown||null)&&f()}else{var m=Error("Invalid project configuration: API key is invalid!");m.code="invalid-configuration";c.qb(m);f(m)}})};l.Ob=function(a,b){if(!this.a.hasOwnProperty(a))throw Error("Invalid project configuration: API key is invalid!");var c=b||void 0;Yo(this.a[a],b||"_");try{this.i=firebase.app(c).auth()}catch(e){var d=this.a[a].a.get("authDomain");if(!d)throw Error("Invalid project configuration: authDomain is required!");
	a=firebase.initializeApp({apiKey:a,authDomain:d},c);a.auth().tenantId=b;this.i=a.auth()}return this.i};l.Yb=function(a,b){var c=this;return new Ze(function(d,e){function f(E,S){c.j=new Ao(a);Io(c.j,c.s,E,S)}var g=a.app.options.apiKey;c.a.hasOwnProperty(g)||e(Error("Invalid project configuration: API key is invalid!"));var h=ap(c.a[g],a.tenantId||"_",b&&b.providerIds);ep(c);e={signInSuccessWithAuthResult:function(E){d(E);return!1}};var k=Vo(c.a[g]).signInUiShown||null,m=!1;e.uiChanged=function(E,S){null===
	E&&"callback"===S?((E=$c("firebaseui-id-page-callback",c.s))&&Bk(E),c.h=new Qo,c.h.render(c.s)):m||null===E&&"spinner"===S||"blank"===S||(c.h&&(c.h.o(),c.h=null),m=!0,k&&k(a.tenantId))};h.callbacks=e;h.credentialHelper="none";var q;b&&b.email&&(q={emailHint:b.email});c.j?c.j.Xa().then(function(){f(h,q)}):f(h,q)})};l.reset=function(){var a=this;return G().then(function(){a.j&&a.j.Xa()}).then(function(){a.j=null;ep(a)})};l.Ub=function(){var a=this;this.h||this.w||(this.w=window.setTimeout(function(){ep(a);
	a.h=new Qo;a.f=a.h;a.h.render(a.s);a.w=null},500))};l.nb=function(){window.clearTimeout(this.w);this.w=null;this.h&&(this.h.o(),this.h=null)};l.Cb=function(){ep(this);this.f=new pm;this.f.render(this.s);return G()};function ep(a){a.j&&a.j.reset();a.nb();a.f&&a.f.o()}l.qb=function(a){var b=this,c=Pd({code:a.code}).toString()||a.message;ep(this);var d;a.retry&&va(a.retry)&&(d=function(){b.reset();a.retry()});this.f=new tm(c,d);this.f.render(this.s)};l.Qb=function(a){var b=this;return G().then(function(){var c=
	b.i&&b.i.app.options.apiKey;if(!b.a.hasOwnProperty(c))throw Error("Invalid project configuration: API key is invalid!");Yo(b.a[c],a.tenantId||"_");if(!b.i.currentUser||b.i.currentUser.uid!==a.uid)throw Error("The user being processed does not match the signed in user!");return(c=Vo(b.a[c]).beforeSignInSuccess||null)?c(a):a}).then(function(c){if(c.uid!==a.uid)throw Error("User with mismatching UID returned.");return c})};v("firebaseui.auth.FirebaseUiHandler",dp);v("firebaseui.auth.FirebaseUiHandler.prototype.selectTenant",
	dp.prototype.Tb);v("firebaseui.auth.FirebaseUiHandler.prototype.getAuth",dp.prototype.Ob);v("firebaseui.auth.FirebaseUiHandler.prototype.startSignIn",dp.prototype.Yb);v("firebaseui.auth.FirebaseUiHandler.prototype.reset",dp.prototype.reset);v("firebaseui.auth.FirebaseUiHandler.prototype.showProgressBar",dp.prototype.Ub);v("firebaseui.auth.FirebaseUiHandler.prototype.hideProgressBar",dp.prototype.nb);v("firebaseui.auth.FirebaseUiHandler.prototype.completeSignOut",dp.prototype.Cb);v("firebaseui.auth.FirebaseUiHandler.prototype.handleError",
	dp.prototype.qb);v("firebaseui.auth.FirebaseUiHandler.prototype.processUser",dp.prototype.Qb);v("firebaseui.auth.AuthUI",Ao);v("firebaseui.auth.AuthUI.getInstance",function(a){a=Bo(a);return Co[a]?Co[a]:null});v("firebaseui.auth.AuthUI.prototype.disableAutoSignIn",Ao.prototype.disableAutoSignIn);v("firebaseui.auth.AuthUI.prototype.start",Ao.prototype.start);v("firebaseui.auth.AuthUI.prototype.setConfig",Ao.prototype.jb);v("firebaseui.auth.AuthUI.prototype.signIn",Ao.prototype.Vb);v("firebaseui.auth.AuthUI.prototype.reset",
	Ao.prototype.reset);v("firebaseui.auth.AuthUI.prototype.delete",Ao.prototype.Xa);v("firebaseui.auth.AuthUI.prototype.isPendingRedirect",Ao.prototype.ob);v("firebaseui.auth.AuthUIError",Rd);v("firebaseui.auth.AuthUIError.prototype.toJSON",Rd.prototype.toJSON);v("firebaseui.auth.CredentialHelper.ACCOUNT_CHOOSER_COM",ti);v("firebaseui.auth.CredentialHelper.GOOGLE_YOLO",Ii);v("firebaseui.auth.CredentialHelper.NONE",dj);v("firebaseui.auth.AnonymousAuthProvider.PROVIDER_ID","anonymous");Ze.prototype["catch"]=
	Ze.prototype.ta;Ze.prototype["finally"]=Ze.prototype.ec}).apply(typeof global!=="undefined"?global:typeof self!=="undefined"?self:window); if(typeof window!=='undefined'){window.dialogPolyfill=__webpack_require__(383);}})();module.exports=firebaseui;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(33)(module), (function() { return this; }())))

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.readState = exports.saveState = undefined;
	
	var _warning = __webpack_require__(32);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var QuotaExceededErrors = {
	  QuotaExceededError: true,
	  QUOTA_EXCEEDED_ERR: true
	};
	
	var SecurityErrors = {
	  SecurityError: true
	};
	
	var KeyPrefix = '@@History/';
	
	var createKey = function createKey(key) {
	  return KeyPrefix + key;
	};
	
	var saveState = exports.saveState = function saveState(key, state) {
	  if (!window.sessionStorage) {
	    // Session storage is not available or hidden.
	    // sessionStorage is undefined in Internet Explorer when served via file protocol.
	     false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available') : void 0;
	
	    return;
	  }
	
	  try {
	    if (state == null) {
	      window.sessionStorage.removeItem(createKey(key));
	    } else {
	      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
	    }
	  } catch (error) {
	    if (SecurityErrors[error.name]) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available due to security settings') : void 0;
	
	      return;
	    }
	
	    if (QuotaExceededErrors[error.name] && window.sessionStorage.length === 0) {
	      // Safari "private mode" throws QuotaExceededError.
	       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : void 0;
	
	      return;
	    }
	
	    throw error;
	  }
	};
	
	var readState = exports.readState = function readState(key) {
	  var json = void 0;
	  try {
	    json = window.sessionStorage.getItem(createKey(key));
	  } catch (error) {
	    if (SecurityErrors[error.name]) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? (0, _warning2.default)(false, '[history] Unable to read state; sessionStorage is not available due to security settings') : void 0;
	
	      return undefined;
	    }
	  }
	
	  if (json) {
	    try {
	      return JSON.parse(json);
	    } catch (error) {
	      // Ignore invalid JSON.
	    }
	  }
	
	  return undefined;
	};

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _runTransitionHook = __webpack_require__(114);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _PathUtils = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var useBasename = function useBasename(createHistory) {
	  return function () {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var history = createHistory(options);
	    var basename = options.basename;
	
	
	    var addBasename = function addBasename(location) {
	      if (!location) return location;
	
	      if (basename && location.basename == null) {
	        if (location.pathname.toLowerCase().indexOf(basename.toLowerCase()) === 0) {
	          location.pathname = location.pathname.substring(basename.length);
	          location.basename = basename;
	
	          if (location.pathname === '') location.pathname = '/';
	        } else {
	          location.basename = '';
	        }
	      }
	
	      return location;
	    };
	
	    var prependBasename = function prependBasename(location) {
	      if (!basename) return location;
	
	      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
	      var pname = object.pathname;
	      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
	      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
	      var pathname = normalizedBasename + normalizedPathname;
	
	      return _extends({}, object, {
	        pathname: pathname
	      });
	    };
	
	    // Override all read methods with basename-aware versions.
	    var getCurrentLocation = function getCurrentLocation() {
	      return addBasename(history.getCurrentLocation());
	    };
	
	    var listenBefore = function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        return (0, _runTransitionHook2.default)(hook, addBasename(location), callback);
	      });
	    };
	
	    var listen = function listen(listener) {
	      return history.listen(function (location) {
	        return listener(addBasename(location));
	      });
	    };
	
	    // Override all write methods with basename-aware versions.
	    var push = function push(location) {
	      return history.push(prependBasename(location));
	    };
	
	    var replace = function replace(location) {
	      return history.replace(prependBasename(location));
	    };
	
	    var createPath = function createPath(location) {
	      return history.createPath(prependBasename(location));
	    };
	
	    var createHref = function createHref(location) {
	      return history.createHref(prependBasename(location));
	    };
	
	    var createLocation = function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
	    };
	
	    return _extends({}, history, {
	      getCurrentLocation: getCurrentLocation,
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation
	    });
	  };
	};
	
	exports.default = useBasename;

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _queryString = __webpack_require__(410);
	
	var _runTransitionHook = __webpack_require__(114);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _LocationUtils = __webpack_require__(44);
	
	var _PathUtils = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultStringifyQuery = function defaultStringifyQuery(query) {
	  return (0, _queryString.stringify)(query).replace(/%20/g, '+');
	};
	
	var defaultParseQueryString = _queryString.parse;
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know how to handle URL queries.
	 */
	var useQueries = function useQueries(createHistory) {
	  return function () {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var history = createHistory(options);
	    var stringifyQuery = options.stringifyQuery,
	        parseQueryString = options.parseQueryString;
	
	
	    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;
	
	    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;
	
	    var decodeQuery = function decodeQuery(location) {
	      if (!location) return location;
	
	      if (location.query == null) location.query = parseQueryString(location.search.substring(1));
	
	      return location;
	    };
	
	    var encodeQuery = function encodeQuery(location, query) {
	      if (query == null) return location;
	
	      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
	      var queryString = stringifyQuery(query);
	      var search = queryString ? '?' + queryString : '';
	
	      return _extends({}, object, {
	        search: search
	      });
	    };
	
	    // Override all read methods with query-aware versions.
	    var getCurrentLocation = function getCurrentLocation() {
	      return decodeQuery(history.getCurrentLocation());
	    };
	
	    var listenBefore = function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        return (0, _runTransitionHook2.default)(hook, decodeQuery(location), callback);
	      });
	    };
	
	    var listen = function listen(listener) {
	      return history.listen(function (location) {
	        return listener(decodeQuery(location));
	      });
	    };
	
	    // Override all write methods with query-aware versions.
	    var push = function push(location) {
	      return history.push(encodeQuery(location, location.query));
	    };
	
	    var replace = function replace(location) {
	      return history.replace(encodeQuery(location, location.query));
	    };
	
	    var createPath = function createPath(location) {
	      return history.createPath(encodeQuery(location, location.query));
	    };
	
	    var createHref = function createHref(location) {
	      return history.createHref(encodeQuery(location, location.query));
	    };
	
	    var createLocation = function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var newLocation = history.createLocation.apply(history, [encodeQuery(location, location.query)].concat(args));
	
	      if (location.query) newLocation.query = (0, _LocationUtils.createQuery)(location.query);
	
	      return decodeQuery(newLocation);
	    };
	
	    return _extends({}, history, {
	      getCurrentLocation: getCurrentLocation,
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation
	    });
	  };
	};
	
	exports.default = useQueries;

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * Lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    asyncTag = '[object AsyncFunction]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    nullTag = '[object Null]',
	    objectTag = '[object Object]',
	    proxyTag = '[object Proxy]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    undefinedTag = '[object Undefined]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    // Use `util.types` for Node.js 10+.
	    var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	    if (types) {
	      return types;
	    }
	
	    // Legacy `process.binding('util')` for Node.js < 10.
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    Symbol = root.Symbol,
	    Uint8Array = root.Uint8Array,
	    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	    getPrototype = overArg(Object.getPrototypeOf, Object),
	    objectCreate = Object.create,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    splice = arrayProto.splice,
	    symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	    nativeMax = Math.max,
	    nativeNow = Date.now;
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map'),
	    nativeCreate = getNative(Object, 'create');
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} proto The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	var baseCreate = (function() {
	  function object() {}
	  return function(proto) {
	    if (!isObject(proto)) {
	      return {};
	    }
	    if (objectCreate) {
	      return objectCreate(proto);
	    }
	    object.prototype = proto;
	    var result = new object;
	    object.prototype = undefined;
	    return result;
	  };
	}());
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * This function is like `assignValue` except that it doesn't assign
	 * `undefined` values.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignMergeValue(object, key, value) {
	  if ((value !== undefined && !eq(object[key], value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.merge` without support for multiple sources.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} [customizer] The function to customize merged values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMerge(object, source, srcIndex, customizer, stack) {
	  if (object === source) {
	    return;
	  }
	  baseFor(source, function(srcValue, key) {
	    stack || (stack = new Stack);
	    if (isObject(srcValue)) {
	      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	    }
	    else {
	      var newValue = customizer
	        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      if (newValue === undefined) {
	        newValue = srcValue;
	      }
	      assignMergeValue(object, key, newValue);
	    }
	  }, keysIn);
	}
	
	/**
	 * A specialized version of `baseMerge` for arrays and objects which performs
	 * deep merges and tracks traversed objects enabling objects with circular
	 * references to be merged.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {string} key The key of the value to merge.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} mergeFunc The function to merge values.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	  var objValue = safeGet(object, key),
	      srcValue = safeGet(source, key),
	      stacked = stack.get(srcValue);
	
	  if (stacked) {
	    assignMergeValue(object, key, stacked);
	    return;
	  }
	  var newValue = customizer
	    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	    : undefined;
	
	  var isCommon = newValue === undefined;
	
	  if (isCommon) {
	    var isArr = isArray(srcValue),
	        isBuff = !isArr && isBuffer(srcValue),
	        isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	    newValue = srcValue;
	    if (isArr || isBuff || isTyped) {
	      if (isArray(objValue)) {
	        newValue = objValue;
	      }
	      else if (isArrayLikeObject(objValue)) {
	        newValue = copyArray(objValue);
	      }
	      else if (isBuff) {
	        isCommon = false;
	        newValue = cloneBuffer(srcValue, true);
	      }
	      else if (isTyped) {
	        isCommon = false;
	        newValue = cloneTypedArray(srcValue, true);
	      }
	      else {
	        newValue = [];
	      }
	    }
	    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	      newValue = objValue;
	      if (isArguments(objValue)) {
	        newValue = toPlainObject(objValue);
	      }
	      else if (!isObject(objValue) || isFunction(objValue)) {
	        newValue = initCloneObject(srcValue);
	      }
	    }
	    else {
	      isCommon = false;
	    }
	  }
	  if (isCommon) {
	    // Recursively merge objects and arrays (susceptible to call stack limits).
	    stack.set(srcValue, newValue);
	    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	    stack['delete'](srcValue);
	  }
	  assignMergeValue(object, key, newValue);
	}
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  return setToString(overRest(func, start, identity), func + '');
	}
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var length = buffer.length,
	      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	  buffer.copy(result);
	  return result;
	}
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  var isNew = !object;
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    if (newValue === undefined) {
	      newValue = source[key];
	    }
	    if (isNew) {
	      baseAssignValue(object, key, newValue);
	    } else {
	      assignValue(object, key, newValue);
	    }
	  }
	  return object;
	}
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return baseRest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	
	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	/**
	 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function safeGet(object, key) {
	  if (key === 'constructor' && typeof object[key] === 'function') {
	    return;
	  }
	
	  if (key == '__proto__') {
	    return;
	  }
	
	  return object[key];
	}
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	/**
	 * Converts `value` to a plain object flattening inherited enumerable string
	 * keyed properties of `value` to own properties of the plain object.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {Object} Returns the converted plain object.
	 * @example
	 *
	 * function Foo() {
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.assign({ 'a': 1 }, new Foo);
	 * // => { 'a': 1, 'b': 2 }
	 *
	 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	 * // => { 'a': 1, 'b': 2, 'c': 3 }
	 */
	function toPlainObject(value) {
	  return copyObject(value, keysIn(value));
	}
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	/**
	 * This method is like `_.assign` except that it recursively merges own and
	 * inherited enumerable string keyed properties of source objects into the
	 * destination object. Source properties that resolve to `undefined` are
	 * skipped if a destination value exists. Array and plain object properties
	 * are merged recursively. Other objects and value types are overridden by
	 * assignment. Source objects are applied from left to right. Subsequent
	 * sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.5.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var object = {
	 *   'a': [{ 'b': 2 }, { 'd': 4 }]
	 * };
	 *
	 * var other = {
	 *   'a': [{ 'c': 3 }, { 'e': 5 }]
	 * };
	 *
	 * _.merge(object, other);
	 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	 */
	var merge = createAssigner(function(object, source, srcIndex) {
	  baseMerge(object, source, srcIndex);
	});
	
	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = merge;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(33)(module)))

/***/ }),
/* 170 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	/**
	 * Creates a throttled function that only invokes `func` at most once per
	 * every `wait` milliseconds. The throttled function comes with a `cancel`
	 * method to cancel delayed `func` invocations and a `flush` method to
	 * immediately invoke them. Provide `options` to indicate whether `func`
	 * should be invoked on the leading and/or trailing edge of the `wait`
	 * timeout. The `func` is invoked with the last arguments provided to the
	 * throttled function. Subsequent calls to the throttled function return the
	 * result of the last `func` invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the throttled function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.throttle` and `_.debounce`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to throttle.
	 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=true]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new throttled function.
	 * @example
	 *
	 * // Avoid excessively updating the position while scrolling.
	 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	 *
	 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	 * jQuery(element).on('click', throttled);
	 *
	 * // Cancel the trailing throttled invocation.
	 * jQuery(window).on('popstate', throttled.cancel);
	 */
	function throttle(func, wait, options) {
	  var leading = true,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  if (isObject(options)) {
	    leading = 'leading' in options ? !!options.leading : leading;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	  return debounce(func, wait, {
	    'leading': leading,
	    'maxWait': wait,
	    'trailing': trailing
	  });
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = throttle;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enSG = moment.defineLocale('en-SG', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enSG;
	
	})));


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enAu = moment.defineLocale('en-au', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enAu;
	
	})));


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enCa = moment.defineLocale('en-ca', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'YYYY-MM-DD',
	            LL : 'MMMM D, YYYY',
	            LLL : 'MMMM D, YYYY h:mm A',
	            LLLL : 'dddd, MMMM D, YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    return enCa;
	
	})));


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enGb = moment.defineLocale('en-gb', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enGb;
	
	})));


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enIe = moment.defineLocale('en-ie', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enIe;
	
	})));


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enIl = moment.defineLocale('en-il', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    return enIl;
	
	})));


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enNz = moment.defineLocale('en-nz', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enNz;
	
	})));


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// resolves . and .. elements in a path array with directory names there
	// must be no slashes, empty elements, or device names (c:\) in the array
	// (so also no leading and trailing slashes - it does not distinguish
	// relative and absolute paths)
	function normalizeArray(parts, allowAboveRoot) {
	  // if the path tries to go above the root, `up` ends up > 0
	  var up = 0;
	  for (var i = parts.length - 1; i >= 0; i--) {
	    var last = parts[i];
	    if (last === '.') {
	      parts.splice(i, 1);
	    } else if (last === '..') {
	      parts.splice(i, 1);
	      up++;
	    } else if (up) {
	      parts.splice(i, 1);
	      up--;
	    }
	  }
	
	  // if the path is allowed to go above the root, restore leading ..s
	  if (allowAboveRoot) {
	    for (; up--; up) {
	      parts.unshift('..');
	    }
	  }
	
	  return parts;
	}
	
	// Split a filename into [root, dir, basename, ext], unix version
	// 'root' is just a slash, or nothing.
	var splitPathRe =
	    /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
	var splitPath = function(filename) {
	  return splitPathRe.exec(filename).slice(1);
	};
	
	// path.resolve([from ...], to)
	// posix version
	exports.resolve = function() {
	  var resolvedPath = '',
	      resolvedAbsolute = false;
	
	  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
	    var path = (i >= 0) ? arguments[i] : process.cwd();
	
	    // Skip empty and invalid entries
	    if (typeof path !== 'string') {
	      throw new TypeError('Arguments to path.resolve must be strings');
	    } else if (!path) {
	      continue;
	    }
	
	    resolvedPath = path + '/' + resolvedPath;
	    resolvedAbsolute = path.charAt(0) === '/';
	  }
	
	  // At this point the path should be resolved to a full absolute path, but
	  // handle relative paths to be safe (might happen when process.cwd() fails)
	
	  // Normalize the path
	  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
	    return !!p;
	  }), !resolvedAbsolute).join('/');
	
	  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
	};
	
	// path.normalize(path)
	// posix version
	exports.normalize = function(path) {
	  var isAbsolute = exports.isAbsolute(path),
	      trailingSlash = substr(path, -1) === '/';
	
	  // Normalize the path
	  path = normalizeArray(filter(path.split('/'), function(p) {
	    return !!p;
	  }), !isAbsolute).join('/');
	
	  if (!path && !isAbsolute) {
	    path = '.';
	  }
	  if (path && trailingSlash) {
	    path += '/';
	  }
	
	  return (isAbsolute ? '/' : '') + path;
	};
	
	// posix version
	exports.isAbsolute = function(path) {
	  return path.charAt(0) === '/';
	};
	
	// posix version
	exports.join = function() {
	  var paths = Array.prototype.slice.call(arguments, 0);
	  return exports.normalize(filter(paths, function(p, index) {
	    if (typeof p !== 'string') {
	      throw new TypeError('Arguments to path.join must be strings');
	    }
	    return p;
	  }).join('/'));
	};
	
	
	// path.relative(from, to)
	// posix version
	exports.relative = function(from, to) {
	  from = exports.resolve(from).substr(1);
	  to = exports.resolve(to).substr(1);
	
	  function trim(arr) {
	    var start = 0;
	    for (; start < arr.length; start++) {
	      if (arr[start] !== '') break;
	    }
	
	    var end = arr.length - 1;
	    for (; end >= 0; end--) {
	      if (arr[end] !== '') break;
	    }
	
	    if (start > end) return [];
	    return arr.slice(start, end - start + 1);
	  }
	
	  var fromParts = trim(from.split('/'));
	  var toParts = trim(to.split('/'));
	
	  var length = Math.min(fromParts.length, toParts.length);
	  var samePartsLength = length;
	  for (var i = 0; i < length; i++) {
	    if (fromParts[i] !== toParts[i]) {
	      samePartsLength = i;
	      break;
	    }
	  }
	
	  var outputParts = [];
	  for (var i = samePartsLength; i < fromParts.length; i++) {
	    outputParts.push('..');
	  }
	
	  outputParts = outputParts.concat(toParts.slice(samePartsLength));
	
	  return outputParts.join('/');
	};
	
	exports.sep = '/';
	exports.delimiter = ':';
	
	exports.dirname = function(path) {
	  var result = splitPath(path),
	      root = result[0],
	      dir = result[1];
	
	  if (!root && !dir) {
	    // No dirname whatsoever
	    return '.';
	  }
	
	  if (dir) {
	    // It has a dirname, strip trailing slash
	    dir = dir.substr(0, dir.length - 1);
	  }
	
	  return root + dir;
	};
	
	
	exports.basename = function(path, ext) {
	  var f = splitPath(path)[2];
	  // TODO: make this comparison case-insensitive on windows?
	  if (ext && f.substr(-1 * ext.length) === ext) {
	    f = f.substr(0, f.length - ext.length);
	  }
	  return f;
	};
	
	
	exports.extname = function(path) {
	  return splitPath(path)[3];
	};
	
	function filter (xs, f) {
	    if (xs.filter) return xs.filter(f);
	    var res = [];
	    for (var i = 0; i < xs.length; i++) {
	        if (f(xs[i], i, xs)) res.push(xs[i]);
	    }
	    return res;
	}
	
	// String.prototype.substr - negative index don't work in IE8
	var substr = 'ab'.substr(-1) === 'b'
	    ? function (str, start, len) { return str.substr(start, len) }
	    : function (str, start, len) {
	        if (start < 0) start = str.length + start;
	        return str.substr(start, len);
	    }
	;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(45)))

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = CenturyView;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _Decades = _interopRequireDefault(__webpack_require__(415));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function CenturyView(props) {
	  function renderDecades() {
	    return _react["default"].createElement(_Decades["default"], props);
	  }
	
	  return _react["default"].createElement("div", {
	    className: "react-calendar__century-view"
	  }, renderDecades());
	}

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = DecadeView;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _Years = _interopRequireDefault(__webpack_require__(417));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function DecadeView(props) {
	  function renderYears() {
	    return _react["default"].createElement(_Years["default"], props);
	  }
	
	  return _react["default"].createElement("div", {
	    className: "react-calendar__decade-view"
	  }, renderYears());
	}

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = MonthView;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(1));
	
	var _Days = _interopRequireDefault(__webpack_require__(419));
	
	var _Weekdays = _interopRequireDefault(__webpack_require__(422));
	
	var _WeekNumbers = _interopRequireDefault(__webpack_require__(421));
	
	var _propTypes2 = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function MonthView(props) {
	  var activeStartDate = props.activeStartDate,
	      locale = props.locale,
	      onMouseLeave = props.onMouseLeave,
	      showFixedNumberOfWeeks = props.showFixedNumberOfWeeks;
	
	  var calendarTypeProps = props.calendarType,
	      formatShortWeekday = props.formatShortWeekday,
	      onClickWeekNumber = props.onClickWeekNumber,
	      showWeekNumbers = props.showWeekNumbers,
	      childProps = _objectWithoutProperties(props, ["calendarType", "formatShortWeekday", "onClickWeekNumber", "showWeekNumbers"]);
	
	  var calendarType = function () {
	    if (calendarTypeProps) {
	      return calendarTypeProps;
	    }
	
	    switch (locale) {
	      case 'en-CA':
	      case 'en-US':
	      case 'es-AR':
	      case 'es-BO':
	      case 'es-CL':
	      case 'es-CO':
	      case 'es-CR':
	      case 'es-DO':
	      case 'es-EC':
	      case 'es-GT':
	      case 'es-HN':
	      case 'es-MX':
	      case 'es-NI':
	      case 'es-PA':
	      case 'es-PE':
	      case 'es-PR':
	      case 'es-SV':
	      case 'es-VE':
	      case 'pt-BR':
	        return 'US';
	      // ar-LB, ar-MA intentionally missing
	
	      case 'ar':
	      case 'ar-AE':
	      case 'ar-BH':
	      case 'ar-DZ':
	      case 'ar-EG':
	      case 'ar-IQ':
	      case 'ar-JO':
	      case 'ar-KW':
	      case 'ar-LY':
	      case 'ar-OM':
	      case 'ar-QA':
	      case 'ar-SA':
	      case 'ar-SD':
	      case 'ar-SY':
	      case 'ar-YE':
	      case 'dv':
	      case 'dv-MV':
	      case 'ps':
	      case 'ps-AR':
	        return 'Arabic';
	
	      case 'he':
	      case 'he-IL':
	        return 'Hebrew';
	
	      default:
	        return 'ISO 8601';
	    }
	  }();
	
	  function renderWeekdays() {
	    return _react["default"].createElement(_Weekdays["default"], {
	      calendarType: calendarType,
	      formatShortWeekday: formatShortWeekday,
	      locale: locale,
	      onMouseLeave: onMouseLeave
	    });
	  }
	
	  function renderWeekNumbers() {
	    if (!showWeekNumbers) {
	      return null;
	    }
	
	    return _react["default"].createElement(_WeekNumbers["default"], {
	      activeStartDate: activeStartDate,
	      calendarType: calendarType,
	      onClickWeekNumber: onClickWeekNumber,
	      onMouseLeave: onMouseLeave,
	      showFixedNumberOfWeeks: showFixedNumberOfWeeks
	    });
	  }
	
	  function renderDays() {
	    return _react["default"].createElement(_Days["default"], _extends({
	      calendarType: calendarType
	    }, childProps));
	  }
	
	  var className = 'react-calendar__month-view';
	  return _react["default"].createElement("div", {
	    className: [className, showWeekNumbers ? "".concat(className, "--weekNumbers") : ''].join(' ')
	  }, _react["default"].createElement("div", {
	    style: {
	      display: 'flex',
	      alignItems: 'flex-end'
	    }
	  }, renderWeekNumbers(), _react["default"].createElement("div", {
	    style: {
	      flexGrow: 1,
	      width: '100%'
	    }
	  }, renderWeekdays(), renderDays())));
	}
	
	MonthView.propTypes = {
	  activeStartDate: _propTypes["default"].instanceOf(Date).isRequired,
	  calendarType: _propTypes2.isCalendarType,
	  formatShortWeekday: _propTypes["default"].func,
	  locale: _propTypes["default"].string,
	  maxDate: _propTypes2.isMaxDate,
	  minDate: _propTypes2.isMinDate,
	  onChange: _propTypes["default"].func,
	  onClickWeekNumber: _propTypes["default"].func,
	  onMouseLeave: _propTypes["default"].func,
	  setActiveRange: _propTypes["default"].func,
	  showFixedNumberOfWeeks: _propTypes["default"].bool,
	  showNeighboringMonth: _propTypes["default"].bool,
	  showWeekNumbers: _propTypes["default"].bool,
	  value: _propTypes2.isValue,
	  valueType: _propTypes["default"].string
	};

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = YearView;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _Months = _interopRequireDefault(__webpack_require__(424));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function YearView(props) {
	  function renderMonths() {
	    return _react["default"].createElement(_Months["default"], props);
	  }
	
	  return _react["default"].createElement("div", {
	    className: "react-calendar__year-view"
	  }, renderMonths());
	}

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports=function(i){var e={};function o(t){if(e[t])return e[t].exports;var a=e[t]={i:t,l:!1,exports:{}};return i[t].call(a.exports,a,a.exports,o),a.l=!0,a.exports}return o.m=i,o.c=e,o.d=function(i,e,t){o.o(i,e)||Object.defineProperty(i,e,{enumerable:!0,get:t})},o.r=function(i){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(i,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(i,"__esModule",{value:!0})},o.t=function(i,e){if(1&e&&(i=o(i)),8&e)return i;if(4&e&&"object"==typeof i&&i&&i.__esModule)return i;var t=Object.create(null);if(o.r(t),Object.defineProperty(t,"default",{enumerable:!0,value:i}),2&e&&"string"!=typeof i)for(var a in i)o.d(t,a,function(e){return i[e]}.bind(null,a));return t},o.n=function(i){var e=i&&i.__esModule?function(){return i.default}:function(){return i};return o.d(e,"a",e),e},o.o=function(i,e){return Object.prototype.hasOwnProperty.call(i,e)},o.p="",o(o.s=0)}([function(i,e,o){"use strict";e.__esModule=!0;var t=function(i){return i&&i.__esModule?i:{default:i}}(o(1));var a=Promise.resolve(),r=function(i){function e(o){!function(i,e){if(!(i instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e);var t=function(i,e){if(!i)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?i:e}(this,i.call(this,o));return t.uiConfig=o.uiConfig,t.firebaseAuth=o.firebaseAuth,t.className=o.className,t.uiCallback=o.uiCallback,t.unregisterAuthObserver=function(){},t}return function(i,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);i.prototype=Object.create(e&&e.prototype,{constructor:{value:i,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(i,e):i.__proto__=e)}(e,i),e.prototype.componentDidMount=function(){var i=this;o(2);var e=o(7);return a.then(function(){i.firebaseUiWidget=e.auth.AuthUI.getInstance()||new e.auth.AuthUI(i.firebaseAuth),"popup"===i.uiConfig.signInFlow&&i.firebaseUiWidget.reset(),i.userSignedIn=!1,i.unregisterAuthObserver=i.firebaseAuth.onAuthStateChanged(function(e){!e&&i.userSignedIn&&i.firebaseUiWidget.reset(),i.userSignedIn=!!e}),i.uiCallback&&i.uiCallback(i.firebaseUiWidget),i.firebaseUiWidget.start("#firebaseui_container",i.uiConfig)})},e.prototype.componentWillUnmount=function(){var i=this;return a=a.then(function(){return i.unregisterAuthObserver(),i.firebaseUiWidget.delete()})},e.prototype.render=function(){return t.default.createElement("div",{className:this.className,id:"firebaseui_container"})},e}(t.default.Component);e.default=r},function(i,e){i.exports=__webpack_require__(2)},function(i,e,o){var t=o(3);"string"==typeof t&&(t=[[i.i,t,""]]);var a={hmr:!0,transform:void 0,insertInto:void 0};o(5)(t,a);t.locals&&(i.exports=t.locals)},function(i,e,o){(e=i.exports=o(4)(!1)).push([i.i,"@import url(https://fonts.googleapis.com/css?family=Roboto:400,500,700);",""]),e.push([i.i,'.mdl-button{background:0 0;border:none;border-radius:2px;color:#000;position:relative;height:36px;margin:0;min-width:64px;padding:0 16px;display:inline-block;font-family:Roboto,Helvetica,Arial,sans-serif;font-size:14px;font-weight:500;text-transform:uppercase;line-height:1;letter-spacing:0;overflow:hidden;will-change:box-shadow;transition:box-shadow .2s cubic-bezier(.4,0,1,1),background-color .2s cubic-bezier(.4,0,.2,1),color .2s cubic-bezier(.4,0,.2,1);outline:0;cursor:pointer;text-decoration:none;text-align:center;line-height:36px;vertical-align:middle}.mdl-button::-moz-focus-inner{border:0}.mdl-button:hover{background-color:hsla(0,0%,62%,.2)}.mdl-button:focus:not(:active){background-color:rgba(0,0,0,.12)}.mdl-button:active{background-color:hsla(0,0%,62%,.4)}.mdl-button.mdl-button--colored{color:#3f51b5}.mdl-button.mdl-button--colored:focus:not(:active){background-color:rgba(0,0,0,.12)}input.mdl-button[type=submit]{-webkit-appearance:none}.mdl-button--raised{background:hsla(0,0%,62%,.2);box-shadow:0 2px 2px 0 rgba(0,0,0,.14),0 3px 1px -2px rgba(0,0,0,.2),0 1px 5px 0 rgba(0,0,0,.12)}.mdl-button--raised:active{box-shadow:0 4px 5px 0 rgba(0,0,0,.14),0 1px 10px 0 rgba(0,0,0,.12),0 2px 4px -1px rgba(0,0,0,.2);background-color:hsla(0,0%,62%,.4)}.mdl-button--raised:focus:not(:active){box-shadow:0 0 8px rgba(0,0,0,.18),0 8px 16px rgba(0,0,0,.36);background-color:hsla(0,0%,62%,.4)}.mdl-button--raised.mdl-button--colored{background:#3f51b5;color:#fff}.mdl-button--raised.mdl-button--colored:active,.mdl-button--raised.mdl-button--colored:focus:not(:active),.mdl-button--raised.mdl-button--colored:hover{background-color:#3f51b5}.mdl-button--raised.mdl-button--colored .mdl-ripple{background:#fff}.mdl-button--fab{border-radius:50%;font-size:24px;height:56px;margin:auto;min-width:56px;width:56px;padding:0;overflow:hidden;background:hsla(0,0%,62%,.2);box-shadow:0 1px 1.5px 0 rgba(0,0,0,.12),0 1px 1px 0 rgba(0,0,0,.24);position:relative;line-height:normal}.mdl-button--fab .material-icons{position:absolute;top:50%;left:50%;transform:translate(-12px,-12px);line-height:24px;width:24px}.mdl-button--fab.mdl-button--mini-fab{height:40px;min-width:40px;width:40px}.mdl-button--fab .mdl-button__ripple-container{border-radius:50%;-webkit-mask-image:-webkit-radial-gradient(circle,#fff,#000)}.mdl-button--fab:active{box-shadow:0 4px 5px 0 rgba(0,0,0,.14),0 1px 10px 0 rgba(0,0,0,.12),0 2px 4px -1px rgba(0,0,0,.2);background-color:hsla(0,0%,62%,.4)}.mdl-button--fab:focus:not(:active){box-shadow:0 0 8px rgba(0,0,0,.18),0 8px 16px rgba(0,0,0,.36);background-color:hsla(0,0%,62%,.4)}.mdl-button--fab.mdl-button--colored{background:#ff4081;color:#fff}.mdl-button--fab.mdl-button--colored:active,.mdl-button--fab.mdl-button--colored:focus:not(:active),.mdl-button--fab.mdl-button--colored:hover{background-color:#ff4081}.mdl-button--fab.mdl-button--colored .mdl-ripple{background:#fff}.mdl-button--icon{border-radius:50%;font-size:24px;height:32px;margin-left:0;margin-right:0;min-width:32px;width:32px;padding:0;overflow:hidden;color:inherit;line-height:normal}.mdl-button--icon .material-icons{position:absolute;top:50%;left:50%;transform:translate(-12px,-12px);line-height:24px;width:24px}.mdl-button--icon.mdl-button--mini-icon{height:24px;min-width:24px;width:24px}.mdl-button--icon.mdl-button--mini-icon .material-icons{top:0;left:0}.mdl-button--icon .mdl-button__ripple-container{border-radius:50%;-webkit-mask-image:-webkit-radial-gradient(circle,#fff,#000)}.mdl-button__ripple-container{display:block;height:100%;left:0;position:absolute;top:0;width:100%;z-index:0;overflow:hidden}.mdl-button.mdl-button--disabled .mdl-button__ripple-container .mdl-ripple,.mdl-button[disabled] .mdl-button__ripple-container .mdl-ripple{background-color:transparent}.mdl-button--primary.mdl-button--primary{color:#3f51b5}.mdl-button--primary.mdl-button--primary .mdl-ripple{background:#fff}.mdl-button--primary.mdl-button--primary.mdl-button--fab,.mdl-button--primary.mdl-button--primary.mdl-button--raised{color:#fff;background-color:#3f51b5}.mdl-button--accent.mdl-button--accent{color:#ff4081}.mdl-button--accent.mdl-button--accent .mdl-ripple{background:#fff}.mdl-button--accent.mdl-button--accent.mdl-button--fab,.mdl-button--accent.mdl-button--accent.mdl-button--raised{color:#fff;background-color:#ff4081}.mdl-button.mdl-button--disabled.mdl-button--disabled,.mdl-button[disabled][disabled]{color:rgba(0,0,0,.26);cursor:default;background-color:transparent}.mdl-button--fab.mdl-button--disabled.mdl-button--disabled,.mdl-button--fab[disabled][disabled]{background-color:rgba(0,0,0,.12);color:rgba(0,0,0,.26)}.mdl-button--raised.mdl-button--disabled.mdl-button--disabled,.mdl-button--raised[disabled][disabled]{background-color:rgba(0,0,0,.12);color:rgba(0,0,0,.26);box-shadow:none}.mdl-button--colored.mdl-button--disabled.mdl-button--disabled,.mdl-button--colored[disabled][disabled]{color:rgba(0,0,0,.26)}.mdl-button .material-icons{vertical-align:middle}.mdl-card{display:flex;flex-direction:column;font-size:16px;font-weight:400;min-height:200px;overflow:hidden;width:330px;z-index:1;position:relative;background:#fff;border-radius:2px;box-sizing:border-box}.mdl-card__media{background-color:#ff4081;background-repeat:repeat;background-position:50% 50%;background-size:cover;background-origin:padding-box;background-attachment:scroll;box-sizing:border-box}.mdl-card__title{align-items:center;color:#000;display:block;display:flex;justify-content:stretch;line-height:normal;padding:16px;perspective-origin:165px 56px;transform-origin:165px 56px;box-sizing:border-box}.mdl-card__title.mdl-card--border{border-bottom:1px solid rgba(0,0,0,.1)}.mdl-card__title-text{align-self:flex-end;color:inherit;display:block;display:flex;font-size:24px;font-weight:300;line-height:normal;overflow:hidden;transform-origin:149px 48px;margin:0}.mdl-card__subtitle-text{font-size:14px;color:rgba(0,0,0,.54);margin:0}.mdl-card__supporting-text{color:rgba(0,0,0,.54);font-size:1rem;line-height:18px;overflow:hidden;padding:16px;width:90%}.mdl-card__supporting-text.mdl-card--border{border-bottom:1px solid rgba(0,0,0,.1)}.mdl-card__actions{font-size:16px;line-height:normal;width:100%;background-color:transparent;padding:8px;box-sizing:border-box}.mdl-card__actions.mdl-card--border{border-top:1px solid rgba(0,0,0,.1)}.mdl-card--expand{flex-grow:1}.mdl-card__menu{position:absolute;right:16px;top:16px}.mdl-dialog{border:none;box-shadow:0 9px 46px 8px rgba(0,0,0,.14),0 11px 15px -7px rgba(0,0,0,.12),0 24px 38px 3px rgba(0,0,0,.2);width:280px}.mdl-dialog__title{padding:24px 24px 0;margin:0;font-size:2.5rem}.mdl-dialog__actions{padding:8px 8px 8px 24px;display:flex;flex-direction:row-reverse;flex-wrap:wrap}.mdl-dialog__actions>*{margin-right:8px;height:36px}.mdl-dialog__actions>:first-child{margin-right:0}.mdl-dialog__actions--full-width{padding:0 0 8px}.mdl-dialog__actions--full-width>*{height:48px;flex:0 0 100%;padding-right:16px;margin-right:0;text-align:right}.mdl-dialog__content{padding:20px 24px 24px;color:rgba(0,0,0,.54)}.mdl-progress{display:block;position:relative;height:4px;width:500px;max-width:100%}.mdl-progress>.bar{display:block;position:absolute;top:0;bottom:0;width:0;transition:width .2s cubic-bezier(.4,0,.2,1)}.mdl-progress>.progressbar{background-color:#3f51b5;z-index:1;left:0}.mdl-progress>.bufferbar{background-image:linear-gradient(90deg,hsla(0,0%,100%,.7),hsla(0,0%,100%,.7)),linear-gradient(90deg,#3f51b5,#3f51b5);z-index:0;left:0}.mdl-progress>.auxbar{right:0}@supports (-webkit-appearance:none){.mdl-progress:not(.mdl-progress--indeterminate):not(.mdl-progress--indeterminate)>.auxbar,.mdl-progress:not(.mdl-progress__indeterminate):not(.mdl-progress__indeterminate)>.auxbar{background-image:linear-gradient(90deg,hsla(0,0%,100%,.7),hsla(0,0%,100%,.7)),linear-gradient(90deg,#3f51b5,#3f51b5);mask:url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIj8+Cjxzdmcgd2lkdGg9IjEyIiBoZWlnaHQ9IjQiIHZpZXdQb3J0PSIwIDAgMTIgNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogIDxlbGxpcHNlIGN4PSIyIiBjeT0iMiIgcng9IjIiIHJ5PSIyIj4KICAgIDxhbmltYXRlIGF0dHJpYnV0ZU5hbWU9ImN4IiBmcm9tPSIyIiB0bz0iLTEwIiBkdXI9IjAuNnMiIHJlcGVhdENvdW50PSJpbmRlZmluaXRlIiAvPgogIDwvZWxsaXBzZT4KICA8ZWxsaXBzZSBjeD0iMTQiIGN5PSIyIiByeD0iMiIgcnk9IjIiIGNsYXNzPSJsb2FkZXIiPgogICAgPGFuaW1hdGUgYXR0cmlidXRlTmFtZT0iY3giIGZyb209IjE0IiB0bz0iMiIgZHVyPSIwLjZzIiByZXBlYXRDb3VudD0iaW5kZWZpbml0ZSIgLz4KICA8L2VsbGlwc2U+Cjwvc3ZnPgo=)}}.mdl-progress:not(.mdl-progress--indeterminate)>.auxbar,.mdl-progress:not(.mdl-progress__indeterminate)>.auxbar{background-image:linear-gradient(90deg,hsla(0,0%,100%,.9),hsla(0,0%,100%,.9)),linear-gradient(90deg,#3f51b5,#3f51b5)}.mdl-progress.mdl-progress--indeterminate>.bar1,.mdl-progress.mdl-progress__indeterminate>.bar1{background-color:#3f51b5;animation-name:indeterminate1;animation-duration:2s;animation-iteration-count:infinite;animation-timing-function:linear}.mdl-progress.mdl-progress--indeterminate>.bar3,.mdl-progress.mdl-progress__indeterminate>.bar3{background-image:none;background-color:#3f51b5;animation-name:indeterminate2;animation-duration:2s;animation-iteration-count:infinite;animation-timing-function:linear}@keyframes indeterminate1{0%{left:0;width:0}50%{left:25%;width:75%}75%{left:100%;width:0}}@keyframes indeterminate2{0%{left:0;width:0}50%{left:0;width:0}75%{left:0;width:25%}to{left:100%;width:0}}.mdl-shadow--2dp{box-shadow:0 2px 2px 0 rgba(0,0,0,.14),0 3px 1px -2px rgba(0,0,0,.2),0 1px 5px 0 rgba(0,0,0,.12)}.mdl-shadow--3dp{box-shadow:0 3px 4px 0 rgba(0,0,0,.14),0 3px 3px -2px rgba(0,0,0,.2),0 1px 8px 0 rgba(0,0,0,.12)}.mdl-shadow--4dp{box-shadow:0 4px 5px 0 rgba(0,0,0,.14),0 1px 10px 0 rgba(0,0,0,.12),0 2px 4px -1px rgba(0,0,0,.2)}.mdl-shadow--6dp{box-shadow:0 6px 10px 0 rgba(0,0,0,.14),0 1px 18px 0 rgba(0,0,0,.12),0 3px 5px -1px rgba(0,0,0,.2)}.mdl-shadow--8dp{box-shadow:0 8px 10px 1px rgba(0,0,0,.14),0 3px 14px 2px rgba(0,0,0,.12),0 5px 5px -3px rgba(0,0,0,.2)}.mdl-shadow--16dp{box-shadow:0 16px 24px 2px rgba(0,0,0,.14),0 6px 30px 5px rgba(0,0,0,.12),0 8px 10px -5px rgba(0,0,0,.2)}.mdl-shadow--24dp{box-shadow:0 9px 46px 8px rgba(0,0,0,.14),0 11px 15px -7px rgba(0,0,0,.12),0 24px 38px 3px rgba(0,0,0,.2)}.mdl-spinner{display:inline-block;position:relative;width:28px;height:28px}.mdl-spinner:not(.is-upgraded).is-active:after{content:"Loading..."}.mdl-spinner.is-upgraded.is-active{animation:mdl-spinner__container-rotate 1.568s linear infinite}@keyframes mdl-spinner__container-rotate{to{transform:rotate(1turn)}}.mdl-spinner__layer{position:absolute;width:100%;height:100%;opacity:0}.mdl-spinner__layer-1{border-color:#42a5f5}.mdl-spinner--single-color .mdl-spinner__layer-1{border-color:#3f51b5}.mdl-spinner.is-active .mdl-spinner__layer-1{animation:mdl-spinner__fill-unfill-rotate 5332ms cubic-bezier(.4,0,.2,1) infinite both,mdl-spinner__layer-1-fade-in-out 5332ms cubic-bezier(.4,0,.2,1) infinite both}.mdl-spinner__layer-2{border-color:#f44336}.mdl-spinner--single-color .mdl-spinner__layer-2{border-color:#3f51b5}.mdl-spinner.is-active .mdl-spinner__layer-2{animation:mdl-spinner__fill-unfill-rotate 5332ms cubic-bezier(.4,0,.2,1) infinite both,mdl-spinner__layer-2-fade-in-out 5332ms cubic-bezier(.4,0,.2,1) infinite both}.mdl-spinner__layer-3{border-color:#fdd835}.mdl-spinner--single-color .mdl-spinner__layer-3{border-color:#3f51b5}.mdl-spinner.is-active .mdl-spinner__layer-3{animation:mdl-spinner__fill-unfill-rotate 5332ms cubic-bezier(.4,0,.2,1) infinite both,mdl-spinner__layer-3-fade-in-out 5332ms cubic-bezier(.4,0,.2,1) infinite both}.mdl-spinner__layer-4{border-color:#4caf50}.mdl-spinner--single-color .mdl-spinner__layer-4{border-color:#3f51b5}.mdl-spinner.is-active .mdl-spinner__layer-4{animation:mdl-spinner__fill-unfill-rotate 5332ms cubic-bezier(.4,0,.2,1) infinite both,mdl-spinner__layer-4-fade-in-out 5332ms cubic-bezier(.4,0,.2,1) infinite both}@keyframes mdl-spinner__fill-unfill-rotate{12.5%{transform:rotate(135deg)}25%{transform:rotate(270deg)}37.5%{transform:rotate(405deg)}50%{transform:rotate(540deg)}62.5%{transform:rotate(675deg)}75%{transform:rotate(810deg)}87.5%{transform:rotate(945deg)}to{transform:rotate(3turn)}}@keyframes mdl-spinner__layer-1-fade-in-out{0%{opacity:.99}25%{opacity:.99}26%{opacity:0}89%{opacity:0}90%{opacity:.99}to{opacity:.99}}@keyframes mdl-spinner__layer-2-fade-in-out{0%{opacity:0}15%{opacity:0}25%{opacity:.99}50%{opacity:.99}51%{opacity:0}}@keyframes mdl-spinner__layer-3-fade-in-out{0%{opacity:0}40%{opacity:0}50%{opacity:.99}75%{opacity:.99}76%{opacity:0}}@keyframes mdl-spinner__layer-4-fade-in-out{0%{opacity:0}65%{opacity:0}75%{opacity:.99}90%{opacity:.99}to{opacity:0}}.mdl-spinner__gap-patch{position:absolute;box-sizing:border-box;top:0;left:45%;width:10%;height:100%;overflow:hidden;border-color:inherit}.mdl-spinner__gap-patch .mdl-spinner__circle{width:1000%;left:-450%}.mdl-spinner__circle-clipper{display:inline-block;position:relative;width:50%;height:100%;overflow:hidden;border-color:inherit}.mdl-spinner__circle-clipper.mdl-spinner__left{float:left}.mdl-spinner__circle-clipper.mdl-spinner__right{float:right}.mdl-spinner__circle-clipper .mdl-spinner__circle{width:200%}.mdl-spinner__circle{box-sizing:border-box;height:100%;border-width:3px;border-style:solid;border-color:inherit;border-bottom-color:transparent!important;border-radius:50%;animation:none;position:absolute;top:0;right:0;bottom:0;left:0}.mdl-spinner__left .mdl-spinner__circle{border-right-color:transparent!important;transform:rotate(129deg)}.mdl-spinner.is-active .mdl-spinner__left .mdl-spinner__circle{animation:mdl-spinner__left-spin 1333ms cubic-bezier(.4,0,.2,1) infinite both}.mdl-spinner__right .mdl-spinner__circle{left:-100%;border-left-color:transparent!important;transform:rotate(-129deg)}.mdl-spinner.is-active .mdl-spinner__right .mdl-spinner__circle{animation:mdl-spinner__right-spin 1333ms cubic-bezier(.4,0,.2,1) infinite both}@keyframes mdl-spinner__left-spin{0%{transform:rotate(130deg)}50%{transform:rotate(-5deg)}to{transform:rotate(130deg)}}@keyframes mdl-spinner__right-spin{0%{transform:rotate(-130deg)}50%{transform:rotate(5deg)}to{transform:rotate(-130deg)}}.mdl-textfield{position:relative;font-size:16px;display:inline-block;box-sizing:border-box;width:300px;max-width:100%;margin:0;padding:20px 0}.mdl-textfield .mdl-button{position:absolute;bottom:20px}.mdl-textfield--align-right{text-align:right}.mdl-textfield--full-width{width:100%}.mdl-textfield--expandable{min-width:32px;width:auto;min-height:32px}.mdl-textfield--expandable .mdl-button--icon{top:16px}.mdl-textfield__input{border:none;border-bottom:1px solid rgba(0,0,0,.12);display:block;font-size:16px;font-family:Helvetica,Arial,sans-serif;margin:0;padding:4px 0;width:100%;background:0 0;text-align:left;color:inherit}.mdl-textfield__input[type=number]{-moz-appearance:textfield}.mdl-textfield__input[type=number]::-webkit-inner-spin-button,.mdl-textfield__input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.mdl-textfield.is-focused .mdl-textfield__input{outline:0}.mdl-textfield.is-invalid .mdl-textfield__input{border-color:#d50000;box-shadow:none}.mdl-textfield.is-disabled .mdl-textfield__input,fieldset[disabled] .mdl-textfield .mdl-textfield__input{background-color:transparent;border-bottom:1px dotted rgba(0,0,0,.12);color:rgba(0,0,0,.26)}.mdl-textfield textarea.mdl-textfield__input{display:block}.mdl-textfield__label{bottom:0;color:rgba(0,0,0,.26);font-size:16px;left:0;right:0;pointer-events:none;position:absolute;display:block;top:24px;width:100%;overflow:hidden;white-space:nowrap;text-align:left}.mdl-textfield.has-placeholder .mdl-textfield__label,.mdl-textfield.is-dirty .mdl-textfield__label{visibility:hidden}.mdl-textfield--floating-label .mdl-textfield__label{transition-duration:.2s;transition-timing-function:cubic-bezier(.4,0,.2,1)}.mdl-textfield--floating-label.has-placeholder .mdl-textfield__label{transition:none}.mdl-textfield.is-disabled.is-disabled .mdl-textfield__label,fieldset[disabled] .mdl-textfield .mdl-textfield__label{color:rgba(0,0,0,.26)}.mdl-textfield--floating-label.has-placeholder .mdl-textfield__label,.mdl-textfield--floating-label.is-dirty .mdl-textfield__label,.mdl-textfield--floating-label.is-focused .mdl-textfield__label{color:#3f51b5;font-size:12px;top:4px;visibility:visible}.mdl-textfield--floating-label.has-placeholder .mdl-textfield__expandable-holder .mdl-textfield__label,.mdl-textfield--floating-label.is-dirty .mdl-textfield__expandable-holder .mdl-textfield__label,.mdl-textfield--floating-label.is-focused .mdl-textfield__expandable-holder .mdl-textfield__label{top:-16px}.mdl-textfield--floating-label.is-invalid .mdl-textfield__label{color:#d50000;font-size:12px}.mdl-textfield__label:after{background-color:#3f51b5;bottom:20px;content:"";height:2px;left:45%;position:absolute;transition-duration:.2s;transition-timing-function:cubic-bezier(.4,0,.2,1);visibility:hidden;width:10px}.mdl-textfield.is-focused .mdl-textfield__label:after{left:0;visibility:visible;width:100%}.mdl-textfield.is-invalid .mdl-textfield__label:after{background-color:#d50000}.mdl-textfield__error{color:#d50000;position:absolute;font-size:12px;margin-top:3px;visibility:hidden;display:block}.mdl-textfield.is-invalid .mdl-textfield__error{visibility:visible}.mdl-textfield__expandable-holder{position:relative;margin-left:32px;transition-duration:.2s;transition-timing-function:cubic-bezier(.4,0,.2,1);display:inline-block;max-width:.1px}.mdl-textfield.is-dirty .mdl-textfield__expandable-holder,.mdl-textfield.is-focused .mdl-textfield__expandable-holder{max-width:600px}.mdl-textfield__expandable-holder .mdl-textfield__label:after{bottom:0}dialog{position:absolute;left:0;right:0;width:-moz-fit-content;width:-webkit-fit-content;width:fit-content;height:-moz-fit-content;height:-webkit-fit-content;height:fit-content;margin:auto;border:solid;padding:1em;background:#fff;color:#000;display:block}dialog:not([open]){display:none}dialog+.backdrop{background:rgba(0,0,0,.1)}._dialog_overlay,dialog+.backdrop{position:fixed;top:0;right:0;bottom:0;left:0}dialog.fixed{position:fixed;top:50%;transform:translateY(-50%)}.firebaseui-container{background-color:#fff;box-sizing:border-box;-moz-box-sizing:border-box;-webkit-box-sizing:border-box;color:rgba(0,0,0,.87);direction:ltr;font:16px Roboto,arial,sans-serif;margin:0 auto;max-width:360px;overflow:visible;position:relative;text-align:left;width:100%}.firebaseui-container.mdl-card{overflow:visible}.firebaseui-card-header{padding:24px 24px 0}.firebaseui-card-content,.firebaseui-card-footer{padding:0 24px}.firebaseui-card-actions{box-sizing:border-box;display:table;font-size:14px;padding:8px 24px 24px;text-align:left;width:100%}.firebaseui-form-links{display:table-cell;vertical-align:middle;width:100%}.firebaseui-form-actions{display:table-cell;text-align:right;white-space:nowrap;width:100%}.firebaseui-subtitle,.firebaseui-title{color:rgba(0,0,0,.87);direction:ltr;font-size:20px;font-weight:500;line-height:24px;margin:0;padding:0;text-align:left}.firebaseui-title{padding-bottom:16px}.firebaseui-subtitle{margin:16px 0}.firebaseui-text{color:rgba(0,0,0,.87);direction:ltr;font-size:16px;line-height:24px;text-align:left}.firebaseui-id-page-password-recovery-email-sent p.firebaseui-text{margin:16px 0}.firebaseui-text-emphasis{font-weight:700}.firebaseui-error{color:#dd2c00;direction:ltr;font-size:12px;line-height:16px;margin:0;text-align:left}.firebaseui-text-input-error{margin:-16px 0 16px}.firebaseui-error-wrapper{min-height:16px}.firebaseui-list-item{direction:ltr;margin:0;padding:0;text-align:left}.firebaseui-hidden{display:none}.firebaseui-relative-wrapper{position:relative}.firebaseui-label{color:rgba(0,0,0,.54);direction:ltr;font-size:16px;text-align:left}.mdl-textfield--floating-label.is-dirty .mdl-textfield__label,.mdl-textfield--floating-label.is-focused .mdl-textfield__label{color:#757575}.firebaseui-input,.firebaseui-input-invalid{border-radius:0;color:rgba(0,0,0,.87);direction:ltr;font-size:16px;width:100%}input.firebaseui-input,input.firebaseui-input-invalid{direction:ltr;text-align:left}.firebaseui-input-invalid{border-color:#dd2c00}.firebaseui-textfield{width:100%}.firebaseui-textfield.mdl-textfield .firebaseui-input{border-color:rgba(0,0,0,.12)}.firebaseui-textfield.mdl-textfield .firebaseui-label:after{background-color:#3f51b5}.firebaseui-textfield-invalid.mdl-textfield .firebaseui-input{border-color:#dd2c00}.firebaseui-textfield-invalid.mdl-textfield .firebaseui-label:after{background-color:#dd2c00}.firebaseui-button{display:inline-block;height:36px;margin-left:8px;min-width:88px}.firebaseui-link{color:#4285f4;font-variant:normal;font-weight:400;text-decoration:none}.firebaseui-link:hover{text-decoration:underline}.firebaseui-indent{margin-left:1em}.firebaseui-tos{color:#757575;direction:ltr;font-size:12px;line-height:16px;margin-bottom:24px;margin-top:0;text-align:left}.firebaseui-provider-sign-in-footer>.firebaseui-tos{text-align:center}.firebaseui-tos-list{list-style:none;text-align:right}.firebaseui-inline-list-item{display:inline-block;margin-left:5px;margin-right:5px}.firebaseui-page-provider-sign-in{background:inherit}.firebaseui-idp-list{list-style:none;margin:1em 0;padding:0}.firebaseui-idp-button{direction:ltr;font-weight:500;height:auto;line-height:normal;max-width:220px;min-height:40px;padding:8px 16px;text-align:left;width:100%}.firebaseui-idp-list>.firebaseui-list-item{margin-bottom:15px;text-align:center}.firebaseui-idp-icon-wrapper{display:table-cell;vertical-align:middle}.firebaseui-idp-icon{height:18px;width:18px}.firebaseui-idp-favicon,.firebaseui-idp-icon{border:none;display:inline-block;vertical-align:middle}.firebaseui-idp-favicon{height:14px;margin-right:5px;width:14px}.firebaseui-idp-text{color:#fff;display:table-cell;font-size:14px;padding-left:16px;text-transform:none;vertical-align:middle}.firebaseui-idp-text.firebaseui-idp-text-long{display:table-cell}.firebaseui-idp-text.firebaseui-idp-text-short{display:none}@media (max-width:268px){.firebaseui-idp-text.firebaseui-idp-text-long{display:none}.firebaseui-idp-text.firebaseui-idp-text-short{display:table-cell}}@media (max-width:320px){.firebaseui-recaptcha-container>div>div{transform:scale(.9);-webkit-transform:scale(.9);transform-origin:0 0;-webkit-transform-origin:0 0}}.firebaseui-idp-password,.firebaseui-idp-password:hover,.mdl-button.firebaseui-idp-password:active,.mdl-button.firebaseui-idp-password:focus{background-color:#db4437}.firebaseui-idp-phone,.firebaseui-idp-phone:hover,.mdl-button.firebaseui-idp-phone:active,.mdl-button.firebaseui-idp-phone:focus{background-color:#02bd7e}.firebaseui-idp-google,.firebaseui-idp-google:hover,.mdl-button.firebaseui-idp-google:active,.mdl-button.firebaseui-idp-google:focus{background-color:#fff}.firebaseui-idp-google>.firebaseui-idp-text{color:#757575}.firebaseui-idp-github,.firebaseui-idp-github:hover,.mdl-button.firebaseui-idp-github:active,.mdl-button.firebaseui-idp-github:focus{background-color:#333}.firebaseui-idp-facebook,.firebaseui-idp-facebook:hover,.mdl-button.firebaseui-idp-facebook:active,.mdl-button.firebaseui-idp-facebook:focus{background-color:#3b5998}.firebaseui-idp-twitter,.firebaseui-idp-twitter:hover,.mdl-button.firebaseui-idp-twitter:active,.mdl-button.firebaseui-idp-twitter:focus{background-color:#55acee}.firebaseui-idp-anonymous,.firebaseui-idp-anonymous:hover,.mdl-button.firebaseui-idp-anonymous:active,.mdl-button.firebaseui-idp-anonymous:focus{background-color:#f4b400}.firebaseui-info-bar{background-color:#f9edbe;border:1px solid #f0c36d;box-shadow:0 2px 4px rgba(0,0,0,.2);-webkit-box-shadow:0 2px 4px rgba(0,0,0,.2);-moz-box-shadow:0 2px 4px rgba(0,0,0,.2);left:10%;padding:8px 16px;position:absolute;right:10%;text-align:center;top:0}.firebaseui-info-bar-message{font-size:12px;margin:0}.firebaseui-dialog{box-sizing:border-box;color:rgba(0,0,0,.87);font:16px Roboto,arial,sans-serif;height:auto;padding:24px;text-align:left}.firebaseui-dialog-icon-wrapper{display:table-cell;vertical-align:middle}.firebaseui-dialog-icon{float:left;height:40px;margin-right:24px;width:40px}.firebaseui-progress-dialog-message{display:table-cell;font-size:16px;font-weight:400;min-height:40px;vertical-align:middle}.firebaseui-progress-dialog-loading-icon{height:28px;margin:6px 30px 6px 6px;width:28px}.firebaseui-icon-done{background-image:url(https://www.gstatic.com/images/icons/material/system/2x/done_googgreen_36dp.png);background-position:50%;background-repeat:no-repeat;background-size:36px 36px}.firebaseui-phone-number{display:flex}.firebaseui-country-selector{background-image:url(https://www.gstatic.com/images/icons/material/system/1x/arrow_drop_down_grey600_18dp.png);background-position:100%;background-repeat:no-repeat;background-size:18px auto;border-radius:0;border-bottom:1px solid rgba(0,0,0,.12);color:rgba(0,0,0,.87);flex-shrink:0;font-size:16px;font-weight:400;height:auto;line-height:normal;margin:20px 24px 20px 0;padding:4px 20px 4px 0;width:90px}.firebaseui-country-selector-flag{display:inline-block;margin-right:1ex}.firebaseui-flag{background-image:url(https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/flags_sprite_2x.png);background-size:100% auto;filter:drop-shadow(1px 1px 1px rgba(0,0,0,.54));height:14px;width:24px}.firebaseui-list-box-dialog{max-height:90%;overflow:auto;padding:8px 0 0}.firebaseui-list-box-actions{padding-bottom:8px}.firebaseui-list-box-icon-wrapper{padding-right:24px}.firebaseui-list-box-icon-wrapper,.firebaseui-list-box-label-wrapper{display:table-cell;vertical-align:top}.firebaseui-list-box-dialog-button{color:rgba(0,0,0,.87);direction:ltr;font-size:16px;font-weight:400;height:auto;line-height:normal;min-height:48px;padding:14px 24px;text-align:left;text-transform:none;width:100%}.firebaseui-phone-number-error{margin-left:114px}.mdl-progress.firebaseui-busy-indicator{height:2px;left:0;position:absolute;top:55px;width:100%}.mdl-spinner.firebaseui-busy-indicator{height:56px;left:0;margin:auto;position:absolute;right:0;top:30%;width:56px}.firebaseui-callback-indicator-container .firebaseui-busy-indicator{top:0}.firebaseui-callback-indicator-container{height:120px}.firebaseui-new-password-component{display:inline-block;position:relative;width:100%}.firebaseui-input-floating-button{background-position:50%;background-repeat:no-repeat;display:block;height:24px;position:absolute;right:0;top:20px;width:24px}.firebaseui-input-toggle-on{background-image:url(https://www.gstatic.com/images/icons/material/system/1x/visibility_black_24dp.png)}.firebaseui-input-toggle-off{background-image:url(https://www.gstatic.com/images/icons/material/system/1x/visibility_off_black_24dp.png)}.firebaseui-input-toggle-focus{opacity:.87}.firebaseui-input-toggle-blur{opacity:.38}.firebaseui-recaptcha-wrapper{display:table;margin:0 auto;padding-bottom:8px}.firebaseui-recaptcha-container{display:table-cell}.firebaseui-recaptcha-error-wrapper{caption-side:bottom;display:table-caption}.firebaseui-change-phone-number-link{display:block}.firebaseui-resend-container{direction:ltr;margin:20px 0;text-align:center}.firebaseui-id-resend-countdown{color:rgba(0,0,0,.38)}.firebaseui-id-page-phone-sign-in-start .firebaseui-form-actions div{float:left}@media (max-width:480px){.firebaseui-container{box-shadow:none;max-width:none;width:100%}.firebaseui-card-header{border-bottom:1px solid #e0e0e0;margin-bottom:16px;padding:16px 24px 0}.firebaseui-title{padding-bottom:16px}.firebaseui-card-actions{padding-right:24px}.firebaseui-busy-indicator{top:0}}.mdl-textfield__label{font-weight:400;margin-bottom:0}.firebaseui-id-page-blank{background:inherit;height:64px}.firebaseui-email-sent{background-image:url(https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/success_status.png);background-position:50%;background-repeat:no-repeat;background-size:64px 64px;height:64px;margin-top:16px;text-align:center}.firebaseui-text-justify{text-align:justify}.firebaseui-flag-KY{background-position:0 0}.firebaseui-flag-AC{background-position:0 -14px}.firebaseui-flag-AE{background-position:0 -28px}.firebaseui-flag-AF{background-position:0 -42px}.firebaseui-flag-AG{background-position:0 -56px}.firebaseui-flag-AI{background-position:0 -70px}.firebaseui-flag-AL{background-position:0 -84px}.firebaseui-flag-AM{background-position:0 -98px}.firebaseui-flag-AO{background-position:0 -112px}.firebaseui-flag-AQ{background-position:0 -126px}.firebaseui-flag-AR{background-position:0 -140px}.firebaseui-flag-AS{background-position:0 -154px}.firebaseui-flag-AT{background-position:0 -168px}.firebaseui-flag-AU{background-position:0 -182px}.firebaseui-flag-AW{background-position:0 -196px}.firebaseui-flag-AX{background-position:0 -210px}.firebaseui-flag-AZ{background-position:0 -224px}.firebaseui-flag-BA{background-position:0 -238px}.firebaseui-flag-BB{background-position:0 -252px}.firebaseui-flag-BD{background-position:0 -266px}.firebaseui-flag-BE{background-position:0 -280px}.firebaseui-flag-BF{background-position:0 -294px}.firebaseui-flag-BG{background-position:0 -308px}.firebaseui-flag-BH{background-position:0 -322px}.firebaseui-flag-BI{background-position:0 -336px}.firebaseui-flag-BJ{background-position:0 -350px}.firebaseui-flag-BL{background-position:0 -364px}.firebaseui-flag-BM{background-position:0 -378px}.firebaseui-flag-BN{background-position:0 -392px}.firebaseui-flag-BO{background-position:0 -406px}.firebaseui-flag-BQ{background-position:0 -420px}.firebaseui-flag-BR{background-position:0 -434px}.firebaseui-flag-BS{background-position:0 -448px}.firebaseui-flag-BT{background-position:0 -462px}.firebaseui-flag-BV{background-position:0 -476px}.firebaseui-flag-BW{background-position:0 -490px}.firebaseui-flag-BY{background-position:0 -504px}.firebaseui-flag-BZ{background-position:0 -518px}.firebaseui-flag-CA{background-position:0 -532px}.firebaseui-flag-CC{background-position:0 -546px}.firebaseui-flag-CD{background-position:0 -560px}.firebaseui-flag-CF{background-position:0 -574px}.firebaseui-flag-CG{background-position:0 -588px}.firebaseui-flag-CH{background-position:0 -602px}.firebaseui-flag-CI{background-position:0 -616px}.firebaseui-flag-CK{background-position:0 -630px}.firebaseui-flag-CL{background-position:0 -644px}.firebaseui-flag-CM{background-position:0 -658px}.firebaseui-flag-CN{background-position:0 -672px}.firebaseui-flag-CO{background-position:0 -686px}.firebaseui-flag-CP{background-position:0 -700px}.firebaseui-flag-CR{background-position:0 -714px}.firebaseui-flag-CU{background-position:0 -728px}.firebaseui-flag-CV{background-position:0 -742px}.firebaseui-flag-CW{background-position:0 -756px}.firebaseui-flag-CX{background-position:0 -770px}.firebaseui-flag-CY{background-position:0 -784px}.firebaseui-flag-CZ{background-position:0 -798px}.firebaseui-flag-DE{background-position:0 -812px}.firebaseui-flag-DG{background-position:0 -826px}.firebaseui-flag-DJ{background-position:0 -840px}.firebaseui-flag-DK{background-position:0 -854px}.firebaseui-flag-DM{background-position:0 -868px}.firebaseui-flag-DO{background-position:0 -882px}.firebaseui-flag-DZ{background-position:0 -896px}.firebaseui-flag-EA{background-position:0 -910px}.firebaseui-flag-EC{background-position:0 -924px}.firebaseui-flag-EE{background-position:0 -938px}.firebaseui-flag-EG{background-position:0 -952px}.firebaseui-flag-EH{background-position:0 -966px}.firebaseui-flag-ER{background-position:0 -980px}.firebaseui-flag-ES{background-position:0 -994px}.firebaseui-flag-ET{background-position:0 -1008px}.firebaseui-flag-EU{background-position:0 -1022px}.firebaseui-flag-FI{background-position:0 -1036px}.firebaseui-flag-FJ{background-position:0 -1050px}.firebaseui-flag-FK{background-position:0 -1064px}.firebaseui-flag-FM{background-position:0 -1078px}.firebaseui-flag-FO{background-position:0 -1092px}.firebaseui-flag-FR{background-position:0 -1106px}.firebaseui-flag-GA{background-position:0 -1120px}.firebaseui-flag-GB{background-position:0 -1134px}.firebaseui-flag-GD{background-position:0 -1148px}.firebaseui-flag-GE{background-position:0 -1162px}.firebaseui-flag-GF{background-position:0 -1176px}.firebaseui-flag-GG{background-position:0 -1190px}.firebaseui-flag-GH{background-position:0 -1204px}.firebaseui-flag-GI{background-position:0 -1218px}.firebaseui-flag-GL{background-position:0 -1232px}.firebaseui-flag-GM{background-position:0 -1246px}.firebaseui-flag-GN{background-position:0 -1260px}.firebaseui-flag-GP{background-position:0 -1274px}.firebaseui-flag-GQ{background-position:0 -1288px}.firebaseui-flag-GR{background-position:0 -1302px}.firebaseui-flag-GS{background-position:0 -1316px}.firebaseui-flag-GT{background-position:0 -1330px}.firebaseui-flag-GU{background-position:0 -1344px}.firebaseui-flag-GW{background-position:0 -1358px}.firebaseui-flag-GY{background-position:0 -1372px}.firebaseui-flag-HK{background-position:0 -1386px}.firebaseui-flag-HM{background-position:0 -1400px}.firebaseui-flag-HN{background-position:0 -1414px}.firebaseui-flag-HR{background-position:0 -1428px}.firebaseui-flag-HT{background-position:0 -1442px}.firebaseui-flag-HU{background-position:0 -1456px}.firebaseui-flag-IC{background-position:0 -1470px}.firebaseui-flag-ID{background-position:0 -1484px}.firebaseui-flag-IE{background-position:0 -1498px}.firebaseui-flag-IL{background-position:0 -1512px}.firebaseui-flag-IM{background-position:0 -1526px}.firebaseui-flag-IN{background-position:0 -1540px}.firebaseui-flag-IO{background-position:0 -1554px}.firebaseui-flag-IQ{background-position:0 -1568px}.firebaseui-flag-IR{background-position:0 -1582px}.firebaseui-flag-IS{background-position:0 -1596px}.firebaseui-flag-IT{background-position:0 -1610px}.firebaseui-flag-JE{background-position:0 -1624px}.firebaseui-flag-JM{background-position:0 -1638px}.firebaseui-flag-JO{background-position:0 -1652px}.firebaseui-flag-JP{background-position:0 -1666px}.firebaseui-flag-KE{background-position:0 -1680px}.firebaseui-flag-KG{background-position:0 -1694px}.firebaseui-flag-KH{background-position:0 -1708px}.firebaseui-flag-KI{background-position:0 -1722px}.firebaseui-flag-KM{background-position:0 -1736px}.firebaseui-flag-KN{background-position:0 -1750px}.firebaseui-flag-KP{background-position:0 -1764px}.firebaseui-flag-KR{background-position:0 -1778px}.firebaseui-flag-KW{background-position:0 -1792px}.firebaseui-flag-AD{background-position:0 -1806px}.firebaseui-flag-KZ{background-position:0 -1820px}.firebaseui-flag-LA{background-position:0 -1834px}.firebaseui-flag-LB{background-position:0 -1848px}.firebaseui-flag-LC{background-position:0 -1862px}.firebaseui-flag-LI{background-position:0 -1876px}.firebaseui-flag-LK{background-position:0 -1890px}.firebaseui-flag-LR{background-position:0 -1904px}.firebaseui-flag-LS{background-position:0 -1918px}.firebaseui-flag-LT{background-position:0 -1932px}.firebaseui-flag-LU{background-position:0 -1946px}.firebaseui-flag-LV{background-position:0 -1960px}.firebaseui-flag-LY{background-position:0 -1974px}.firebaseui-flag-MA{background-position:0 -1988px}.firebaseui-flag-MC{background-position:0 -2002px}.firebaseui-flag-MD{background-position:0 -2016px}.firebaseui-flag-ME{background-position:0 -2030px}.firebaseui-flag-MF{background-position:0 -2044px}.firebaseui-flag-MG{background-position:0 -2058px}.firebaseui-flag-MH{background-position:0 -2072px}.firebaseui-flag-MK{background-position:0 -2086px}.firebaseui-flag-ML{background-position:0 -2100px}.firebaseui-flag-MM{background-position:0 -2114px}.firebaseui-flag-MN{background-position:0 -2128px}.firebaseui-flag-MO{background-position:0 -2142px}.firebaseui-flag-MP{background-position:0 -2156px}.firebaseui-flag-MQ{background-position:0 -2170px}.firebaseui-flag-MR{background-position:0 -2184px}.firebaseui-flag-MS{background-position:0 -2198px}.firebaseui-flag-MT{background-position:0 -2212px}.firebaseui-flag-MU{background-position:0 -2226px}.firebaseui-flag-MV{background-position:0 -2240px}.firebaseui-flag-MW{background-position:0 -2254px}.firebaseui-flag-MX{background-position:0 -2268px}.firebaseui-flag-MY{background-position:0 -2282px}.firebaseui-flag-MZ{background-position:0 -2296px}.firebaseui-flag-NA{background-position:0 -2310px}.firebaseui-flag-NC{background-position:0 -2324px}.firebaseui-flag-NE{background-position:0 -2338px}.firebaseui-flag-NF{background-position:0 -2352px}.firebaseui-flag-NG{background-position:0 -2366px}.firebaseui-flag-NI{background-position:0 -2380px}.firebaseui-flag-NL{background-position:0 -2394px}.firebaseui-flag-NO{background-position:0 -2408px}.firebaseui-flag-NP{background-position:0 -2422px}.firebaseui-flag-NR{background-position:0 -2436px}.firebaseui-flag-NU{background-position:0 -2450px}.firebaseui-flag-NZ{background-position:0 -2464px}.firebaseui-flag-OM{background-position:0 -2478px}.firebaseui-flag-PA{background-position:0 -2492px}.firebaseui-flag-PE{background-position:0 -2506px}.firebaseui-flag-PF{background-position:0 -2520px}.firebaseui-flag-PG{background-position:0 -2534px}.firebaseui-flag-PH{background-position:0 -2548px}.firebaseui-flag-PK{background-position:0 -2562px}.firebaseui-flag-PL{background-position:0 -2576px}.firebaseui-flag-PM{background-position:0 -2590px}.firebaseui-flag-PN{background-position:0 -2604px}.firebaseui-flag-PR{background-position:0 -2618px}.firebaseui-flag-PS{background-position:0 -2632px}.firebaseui-flag-PT{background-position:0 -2646px}.firebaseui-flag-PW{background-position:0 -2660px}.firebaseui-flag-PY{background-position:0 -2674px}.firebaseui-flag-QA{background-position:0 -2688px}.firebaseui-flag-RE{background-position:0 -2702px}.firebaseui-flag-RO{background-position:0 -2716px}.firebaseui-flag-RS{background-position:0 -2730px}.firebaseui-flag-RU{background-position:0 -2744px}.firebaseui-flag-RW{background-position:0 -2758px}.firebaseui-flag-SA{background-position:0 -2772px}.firebaseui-flag-SB{background-position:0 -2786px}.firebaseui-flag-SC{background-position:0 -2800px}.firebaseui-flag-SD{background-position:0 -2814px}.firebaseui-flag-SE{background-position:0 -2828px}.firebaseui-flag-SG{background-position:0 -2842px}.firebaseui-flag-SH{background-position:0 -2856px}.firebaseui-flag-SI{background-position:0 -2870px}.firebaseui-flag-SJ{background-position:0 -2884px}.firebaseui-flag-SK{background-position:0 -2898px}.firebaseui-flag-SL{background-position:0 -2912px}.firebaseui-flag-SM{background-position:0 -2926px}.firebaseui-flag-SN{background-position:0 -2940px}.firebaseui-flag-SO{background-position:0 -2954px}.firebaseui-flag-SR{background-position:0 -2968px}.firebaseui-flag-SS{background-position:0 -2982px}.firebaseui-flag-ST{background-position:0 -2996px}.firebaseui-flag-SV{background-position:0 -3010px}.firebaseui-flag-SX{background-position:0 -3024px}.firebaseui-flag-SY{background-position:0 -3038px}.firebaseui-flag-SZ{background-position:0 -3052px}.firebaseui-flag-TA{background-position:0 -3066px}.firebaseui-flag-TC{background-position:0 -3080px}.firebaseui-flag-TD{background-position:0 -3094px}.firebaseui-flag-TF{background-position:0 -3108px}.firebaseui-flag-TG{background-position:0 -3122px}.firebaseui-flag-TH{background-position:0 -3136px}.firebaseui-flag-TJ{background-position:0 -3150px}.firebaseui-flag-TK{background-position:0 -3164px}.firebaseui-flag-TL{background-position:0 -3178px}.firebaseui-flag-TM{background-position:0 -3192px}.firebaseui-flag-TN{background-position:0 -3206px}.firebaseui-flag-TO{background-position:0 -3220px}.firebaseui-flag-TR{background-position:0 -3234px}.firebaseui-flag-TT{background-position:0 -3248px}.firebaseui-flag-TV{background-position:0 -3262px}.firebaseui-flag-TW{background-position:0 -3276px}.firebaseui-flag-TZ{background-position:0 -3290px}.firebaseui-flag-UA{background-position:0 -3304px}.firebaseui-flag-UG{background-position:0 -3318px}.firebaseui-flag-UM{background-position:0 -3332px}.firebaseui-flag-UN{background-position:0 -3346px}.firebaseui-flag-US{background-position:0 -3360px}.firebaseui-flag-UY{background-position:0 -3374px}.firebaseui-flag-UZ{background-position:0 -3388px}.firebaseui-flag-VA{background-position:0 -3402px}.firebaseui-flag-VC{background-position:0 -3416px}.firebaseui-flag-VE{background-position:0 -3430px}.firebaseui-flag-VG{background-position:0 -3444px}.firebaseui-flag-VI{background-position:0 -3458px}.firebaseui-flag-VN{background-position:0 -3472px}.firebaseui-flag-VU{background-position:0 -3486px}.firebaseui-flag-WF{background-position:0 -3500px}.firebaseui-flag-WS{background-position:0 -3514px}.firebaseui-flag-XK{background-position:0 -3528px}.firebaseui-flag-YE{background-position:0 -3542px}.firebaseui-flag-YT{background-position:0 -3556px}.firebaseui-flag-ZA{background-position:0 -3570px}.firebaseui-flag-ZM{background-position:0 -3584px}.firebaseui-flag-ZW{background-position:0 -3598px}',""])},function(i,e){i.exports=function(i){var e=[];return e.toString=function(){return this.map(function(e){var o=function(i,e){var o=i[1]||"",t=i[3];if(!t)return o;if(e&&"function"==typeof btoa){var a=function(i){return"/*# sourceMappingURL=data:application/json;charset=utf-8;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(i))))+" */"}(t),r=t.sources.map(function(i){return"/*# sourceURL="+t.sourceRoot+i+" */"});return[o].concat(r).concat([a]).join("\n")}return[o].join("\n")}(e,i);return e[2]?"@media "+e[2]+"{"+o+"}":o}).join("")},e.i=function(i,o){"string"==typeof i&&(i=[[null,i,""]]);for(var t={},a=0;a<this.length;a++){var r=this[a][0];"number"==typeof r&&(t[r]=!0)}for(a=0;a<i.length;a++){var n=i[a];"number"==typeof n[0]&&t[n[0]]||(o&&!n[2]?n[2]=o:o&&(n[2]="("+n[2]+") and ("+o+")"),e.push(n))}},e}},function(i,e,o){var t={},a=function(i){var e;return function(){return void 0===e&&(e=i.apply(this,arguments)),e}}(function(){return window&&document&&document.all&&!window.atob}),r=function(i){var e={};return function(i){if("function"==typeof i)return i();if(void 0===e[i]){var o=function(i){return document.querySelector(i)}.call(this,i);if(window.HTMLIFrameElement&&o instanceof window.HTMLIFrameElement)try{o=o.contentDocument.head}catch(i){o=null}e[i]=o}return e[i]}}(),n=null,l=0,s=[],d=o(6);function p(i,e){for(var o=0;o<i.length;o++){var a=i[o],r=t[a.id];if(r){r.refs++;for(var n=0;n<r.parts.length;n++)r.parts[n](a.parts[n]);for(;n<a.parts.length;n++)r.parts.push(x(a.parts[n],e))}else{var l=[];for(n=0;n<a.parts.length;n++)l.push(x(a.parts[n],e));t[a.id]={id:a.id,refs:1,parts:l}}}}function b(i,e){for(var o=[],t={},a=0;a<i.length;a++){var r=i[a],n=e.base?r[0]+e.base:r[0],l={css:r[1],media:r[2],sourceMap:r[3]};t[n]?t[n].parts.push(l):o.push(t[n]={id:n,parts:[l]})}return o}function f(i,e){var o=r(i.insertInto);if(!o)throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");var t=s[s.length-1];if("top"===i.insertAt)t?t.nextSibling?o.insertBefore(e,t.nextSibling):o.appendChild(e):o.insertBefore(e,o.firstChild),s.push(e);else if("bottom"===i.insertAt)o.appendChild(e);else{if("object"!=typeof i.insertAt||!i.insertAt.before)throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");var a=r(i.insertInto+" "+i.insertAt.before);o.insertBefore(e,a)}}function u(i){if(null===i.parentNode)return!1;i.parentNode.removeChild(i);var e=s.indexOf(i);e>=0&&s.splice(e,1)}function g(i){var e=document.createElement("style");return void 0===i.attrs.type&&(i.attrs.type="text/css"),c(e,i.attrs),f(i,e),e}function c(i,e){Object.keys(e).forEach(function(o){i.setAttribute(o,e[o])})}function x(i,e){var o,t,a,r;if(e.transform&&i.css){if(!(r=e.transform(i.css)))return function(){};i.css=r}if(e.singleton){var s=l++;o=n||(n=g(e)),t=h.bind(null,o,s,!1),a=h.bind(null,o,s,!0)}else i.sourceMap&&"function"==typeof URL&&"function"==typeof URL.createObjectURL&&"function"==typeof URL.revokeObjectURL&&"function"==typeof Blob&&"function"==typeof btoa?(o=function(i){var e=document.createElement("link");return void 0===i.attrs.type&&(i.attrs.type="text/css"),i.attrs.rel="stylesheet",c(e,i.attrs),f(i,e),e}(e),t=function(i,e,o){var t=o.css,a=o.sourceMap,r=void 0===e.convertToAbsoluteUrls&&a;(e.convertToAbsoluteUrls||r)&&(t=d(t));a&&(t+="\n/*# sourceMappingURL=data:application/json;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(a))))+" */");var n=new Blob([t],{type:"text/css"}),l=i.href;i.href=URL.createObjectURL(n),l&&URL.revokeObjectURL(l)}.bind(null,o,e),a=function(){u(o),o.href&&URL.revokeObjectURL(o.href)}):(o=g(e),t=function(i,e){var o=e.css,t=e.media;t&&i.setAttribute("media",t);if(i.styleSheet)i.styleSheet.cssText=o;else{for(;i.firstChild;)i.removeChild(i.firstChild);i.appendChild(document.createTextNode(o))}}.bind(null,o),a=function(){u(o)});return t(i),function(e){if(e){if(e.css===i.css&&e.media===i.media&&e.sourceMap===i.sourceMap)return;t(i=e)}else a()}}i.exports=function(i,e){if(false)throw new Error("The style-loader cannot be used in a non-browser environment");(e=e||{}).attrs="object"==typeof e.attrs?e.attrs:{},e.singleton||"boolean"==typeof e.singleton||(e.singleton=a()),e.insertInto||(e.insertInto="head"),e.insertAt||(e.insertAt="bottom");var o=b(i,e);return p(o,e),function(i){for(var a=[],r=0;r<o.length;r++){var n=o[r];(l=t[n.id]).refs--,a.push(l)}i&&p(b(i,e),e);for(r=0;r<a.length;r++){var l;if(0===(l=a[r]).refs){for(var s=0;s<l.parts.length;s++)l.parts[s]();delete t[l.id]}}}};var m=function(){var i=[];return function(e,o){return i[e]=o,i.filter(Boolean).join("\n")}}();function h(i,e,o,t){var a=o?"":t.css;if(i.styleSheet)i.styleSheet.cssText=m(e,a);else{var r=document.createTextNode(a),n=i.childNodes;n[e]&&i.removeChild(n[e]),n.length?i.insertBefore(r,n[e]):i.appendChild(r)}}},function(i,e){i.exports=function(i){var e="undefined"!=typeof window&&window.location;if(!e)throw new Error("fixUrls requires window.location");if(!i||"string"!=typeof i)return i;var o=e.protocol+"//"+e.host,t=o+e.pathname.replace(/\/[^\/]*$/,"/");return i.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi,function(i,e){var a,r=e.trim().replace(/^"(.*)"$/,function(i,e){return e}).replace(/^'(.*)'$/,function(i,e){return e});return/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(r)?i:(a=0===r.indexOf("//")?r:0===r.indexOf("/")?o+r:t+r.replace(/^\.\//,""),"url("+JSON.stringify(a)+")")})}},function(i,e){i.exports=__webpack_require__(165)}]);
	//# sourceMappingURL=StyledFirebaseAuth.js.map

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var sizerStyle = {
		position: 'absolute',
		top: 0,
		left: 0,
		visibility: 'hidden',
		height: 0,
		overflow: 'scroll',
		whiteSpace: 'pre'
	};
	
	var INPUT_PROPS_BLACKLIST = ['extraWidth', 'injectStyles', 'inputClassName', 'inputRef', 'inputStyle', 'minWidth', 'onAutosize', 'placeholderIsMinWidth'];
	
	var cleanInputProps = function cleanInputProps(inputProps) {
		INPUT_PROPS_BLACKLIST.forEach(function (field) {
			return delete inputProps[field];
		});
		return inputProps;
	};
	
	var copyStyles = function copyStyles(styles, node) {
		node.style.fontSize = styles.fontSize;
		node.style.fontFamily = styles.fontFamily;
		node.style.fontWeight = styles.fontWeight;
		node.style.fontStyle = styles.fontStyle;
		node.style.letterSpacing = styles.letterSpacing;
		node.style.textTransform = styles.textTransform;
	};
	
	var isIE = typeof window !== 'undefined' && window.navigator ? /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent) : false;
	
	var generateId = function generateId() {
		// we only need an auto-generated ID for stylesheet injection, which is only
		// used for IE. so if the browser is not IE, this should return undefined.
		return isIE ? '_' + Math.random().toString(36).substr(2, 12) : undefined;
	};
	
	var AutosizeInput = function (_Component) {
		_inherits(AutosizeInput, _Component);
	
		function AutosizeInput(props) {
			_classCallCheck(this, AutosizeInput);
	
			var _this = _possibleConstructorReturn(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, props));
	
			_this.inputRef = function (el) {
				_this.input = el;
				if (typeof _this.props.inputRef === 'function') {
					_this.props.inputRef(el);
				}
			};
	
			_this.placeHolderSizerRef = function (el) {
				_this.placeHolderSizer = el;
			};
	
			_this.sizerRef = function (el) {
				_this.sizer = el;
			};
	
			_this.state = {
				inputWidth: props.minWidth,
				inputId: props.id || generateId()
			};
			return _this;
		}
	
		_createClass(AutosizeInput, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.mounted = true;
				this.copyInputStyles();
				this.updateInputWidth();
			}
		}, {
			key: 'UNSAFE_componentWillReceiveProps',
			value: function UNSAFE_componentWillReceiveProps(nextProps) {
				var id = nextProps.id;
	
				if (id !== this.props.id) {
					this.setState({ inputId: id || generateId() });
				}
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps, prevState) {
				if (prevState.inputWidth !== this.state.inputWidth) {
					if (typeof this.props.onAutosize === 'function') {
						this.props.onAutosize(this.state.inputWidth);
					}
				}
				this.updateInputWidth();
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.mounted = false;
			}
		}, {
			key: 'copyInputStyles',
			value: function copyInputStyles() {
				if (!this.mounted || !window.getComputedStyle) {
					return;
				}
				var inputStyles = this.input && window.getComputedStyle(this.input);
				if (!inputStyles) {
					return;
				}
				copyStyles(inputStyles, this.sizer);
				if (this.placeHolderSizer) {
					copyStyles(inputStyles, this.placeHolderSizer);
				}
			}
		}, {
			key: 'updateInputWidth',
			value: function updateInputWidth() {
				if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
					return;
				}
				var newInputWidth = void 0;
				if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
					newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
				} else {
					newInputWidth = this.sizer.scrollWidth + 2;
				}
				// add extraWidth to the detected width. for number types, this defaults to 16 to allow for the stepper UI
				var extraWidth = this.props.type === 'number' && this.props.extraWidth === undefined ? 16 : parseInt(this.props.extraWidth) || 0;
				newInputWidth += extraWidth;
				if (newInputWidth < this.props.minWidth) {
					newInputWidth = this.props.minWidth;
				}
				if (newInputWidth !== this.state.inputWidth) {
					this.setState({
						inputWidth: newInputWidth
					});
				}
			}
		}, {
			key: 'getInput',
			value: function getInput() {
				return this.input;
			}
		}, {
			key: 'focus',
			value: function focus() {
				this.input.focus();
			}
		}, {
			key: 'blur',
			value: function blur() {
				this.input.blur();
			}
		}, {
			key: 'select',
			value: function select() {
				this.input.select();
			}
		}, {
			key: 'renderStyles',
			value: function renderStyles() {
				// this method injects styles to hide IE's clear indicator, which messes
				// with input size detection. the stylesheet is only injected when the
				// browser is IE, and can also be disabled by the `injectStyles` prop.
				var injectStyles = this.props.injectStyles;
	
				return isIE && injectStyles ? _react2.default.createElement('style', { dangerouslySetInnerHTML: {
						__html: 'input#' + this.state.inputId + '::-ms-clear {display: none;}'
					} }) : null;
			}
		}, {
			key: 'render',
			value: function render() {
				var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
					if (previousValue !== null && previousValue !== undefined) {
						return previousValue;
					}
					return currentValue;
				});
	
				var wrapperStyle = _extends({}, this.props.style);
				if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';
	
				var inputStyle = _extends({
					boxSizing: 'content-box',
					width: this.state.inputWidth + 'px'
				}, this.props.inputStyle);
	
				var inputProps = _objectWithoutProperties(this.props, []);
	
				cleanInputProps(inputProps);
				inputProps.className = this.props.inputClassName;
				inputProps.id = this.state.inputId;
				inputProps.style = inputStyle;
	
				return _react2.default.createElement(
					'div',
					{ className: this.props.className, style: wrapperStyle },
					this.renderStyles(),
					_react2.default.createElement('input', _extends({}, inputProps, { ref: this.inputRef })),
					_react2.default.createElement(
						'div',
						{ ref: this.sizerRef, style: sizerStyle },
						sizerValue
					),
					this.props.placeholder ? _react2.default.createElement(
						'div',
						{ ref: this.placeHolderSizerRef, style: sizerStyle },
						this.props.placeholder
					) : null
				);
			}
		}]);
	
		return AutosizeInput;
	}(_react.Component);
	
	AutosizeInput.propTypes = {
		className: _propTypes2.default.string, // className for the outer element
		defaultValue: _propTypes2.default.any, // default field value
		extraWidth: _propTypes2.default.oneOfType([// additional width for input element
		_propTypes2.default.number, _propTypes2.default.string]),
		id: _propTypes2.default.string, // id to use for the input, can be set for consistent snapshots
		injectStyles: _propTypes2.default.bool, // inject the custom stylesheet to hide clear UI, defaults to true
		inputClassName: _propTypes2.default.string, // className for the input element
		inputRef: _propTypes2.default.func, // ref callback for the input element
		inputStyle: _propTypes2.default.object, // css styles for the input element
		minWidth: _propTypes2.default.oneOfType([// minimum width for input element
		_propTypes2.default.number, _propTypes2.default.string]),
		onAutosize: _propTypes2.default.func, // onAutosize handler: function(newWidth) {}
		onChange: _propTypes2.default.func, // onChange handler: function(event) {}
		placeholder: _propTypes2.default.string, // placeholder text
		placeholderIsMinWidth: _propTypes2.default.bool, // don't collapse size to less than the placeholder
		style: _propTypes2.default.object, // css styles for the outer element
		value: _propTypes2.default.any // field value
	};
	AutosizeInput.defaultProps = {
		minWidth: 1,
		injectStyles: true
	};
	
	exports.default = AutosizeInput;

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Skeleton;
	exports.skeletonStyles = exports.skeletonKeyframes = exports.defaultHighlightColor = exports.defaultBaseColor = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _core = __webpack_require__(186);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _templateObject() {
	  var data = _taggedTemplateLiteral(["\n  0% {\n    background-position: -200px 0;\n  }\n  100% {\n    background-position: calc(200px + 100%) 0;\n  }\n"]);
	
	  _templateObject = function _templateObject() {
	    return data;
	  };
	
	  return data;
	}
	
	function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var defaultBaseColor = "#eee";
	exports.defaultBaseColor = defaultBaseColor;
	var defaultHighlightColor = "#f5f5f5";
	exports.defaultHighlightColor = defaultHighlightColor;
	var skeletonKeyframes = (0, _core.keyframes)(_templateObject());
	exports.skeletonKeyframes = skeletonKeyframes;
	var skeletonStyles =
	/*#__PURE__*/
	(0, _core.css)("background-color:", defaultBaseColor, ";background-image:linear-gradient( 90deg,", defaultBaseColor, ",", defaultHighlightColor, ",", defaultBaseColor, " );background-size:200px 100%;background-repeat:no-repeat;border-radius:4px;display:inline-block;line-height:1;width:100%;;label:skeletonStyles;" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
	exports.skeletonStyles = skeletonStyles;
	
	function Skeleton(_ref) {
	  var count = _ref.count,
	      duration = _ref.duration,
	      width = _ref.width,
	      Wrapper = _ref.wrapper,
	      height = _ref.height,
	      circle = _ref.circle,
	      customStyle = _ref.style,
	      customClassName = _ref.className;
	  var elements = [];
	
	  for (var i = 0; i < count; i++) {
	    var style = {};
	
	    if (width !== null) {
	      style.width = width;
	    }
	
	    if (height !== null) {
	      style.height = height;
	    }
	
	    if (width !== null && height !== null && circle) {
	      style.borderRadius = "50%";
	    }
	
	    var className = "react-loading-skeleton";
	
	    if (customClassName) {
	      className += " " + customClassName;
	    }
	
	    elements.push((0, _core.jsx)("span", {
	      key: i,
	      className: className,
	      css:
	      /*#__PURE__*/
	      (0, _core.css)(skeletonStyles, " animation:", skeletonKeyframes, " ", duration, "s ease-in-out infinite;label:Skeleton;" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")),
	      style: _objectSpread({}, customStyle, {}, style)
	    }, "\u200C"));
	  }
	
	  return (0, _core.jsx)("span", null, Wrapper ? elements.map(function (element, i) {
	    return (0, _core.jsx)(Wrapper, {
	      key: i
	    }, element, "\u200C");
	  }) : elements);
	}
	
	Skeleton.defaultProps = {
	  count: 1,
	  duration: 1.2,
	  width: null,
	  wrapper: null,
	  height: null,
	  circle: false
	};

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var _inheritsLoose = _interopDefault(__webpack_require__(99));
	var React = __webpack_require__(2);
	var createCache = _interopDefault(__webpack_require__(444));
	var utils = __webpack_require__(450);
	var serialize = __webpack_require__(187);
	var sheet = __webpack_require__(188);
	var css = _interopDefault(__webpack_require__(445));
	
	var EmotionCacheContext = React.createContext( // we're doing this to avoid preconstruct's dead code elimination in this one case
	// because this module is primarily intended for the browser and node
	// but it's also required in react native and similar environments sometimes
	// and we could have a special build just for that
	// but this is much easier and the native packages
	// might use a different theme context in the future anyway
	typeof HTMLElement !== 'undefined' ? createCache() : null);
	var ThemeContext = React.createContext({});
	var CacheProvider = EmotionCacheContext.Provider;
	
	exports.withEmotionCache = function withEmotionCache(func) {
	  var render = function render(props, ref) {
	    return React.createElement(EmotionCacheContext.Consumer, null, function (cache) {
	      return func(props, cache, ref);
	    });
	  }; // $FlowFixMe
	
	
	  return React.forwardRef(render);
	};
	
	// thus we only need to replace what is a valid character for JS, but not for CSS
	
	var sanitizeIdentifier = function sanitizeIdentifier(identifier) {
	  return identifier.replace(/\$/g, '-');
	};
	
	var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
	var labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var render = function render(cache, props, theme, ref) {
	  var cssProp = theme === null ? props.css : props.css(theme); // so that using `css` from `emotion` and passing the result to the css prop works
	  // not passing the registered cache to serializeStyles because it would
	  // make certain babel optimisations not possible
	
	  if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
	    cssProp = cache.registered[cssProp];
	  }
	
	  var type = props[typePropName];
	  var registeredStyles = [cssProp];
	  var className = '';
	
	  if (typeof props.className === 'string') {
	    className = utils.getRegisteredStyles(cache.registered, registeredStyles, props.className);
	  } else if (props.className != null) {
	    className = props.className + " ";
	  }
	
	  var serialized = serialize.serializeStyles(registeredStyles);
	
	  if (false) {
	    var labelFromStack = props[labelPropName];
	
	    if (labelFromStack) {
	      serialized = serialize.serializeStyles([serialized, 'label:' + labelFromStack + ';']);
	    }
	  }
	
	  var rules = utils.insertStyles(cache, serialized, typeof type === 'string');
	  className += cache.key + "-" + serialized.name;
	  var newProps = {};
	
	  for (var key in props) {
	    if (hasOwnProperty.call(props, key) && key !== 'css' && key !== typePropName && (("production") === 'production' || key !== labelPropName)) {
	      newProps[key] = props[key];
	    }
	  }
	
	  newProps.ref = ref;
	  newProps.className = className;
	  var ele = React.createElement(type, newProps);
	
	  return ele;
	};
	
	var Emotion =
	/* #__PURE__ */
	exports.withEmotionCache(function (props, cache, ref) {
	  // use Context.read for the theme when it's stable
	  if (typeof props.css === 'function') {
	    return React.createElement(ThemeContext.Consumer, null, function (theme) {
	      return render(cache, props, theme, ref);
	    });
	  }
	
	  return render(cache, props, null, ref);
	});
	
	if (false) {
	  Emotion.displayName = 'EmotionCssPropInternal';
	} // $FlowFixMe
	
	
	var jsx = function jsx(type, props) {
	  var args = arguments;
	
	  if (props == null || !hasOwnProperty.call(props, 'css')) {
	    // $FlowFixMe
	    return React.createElement.apply(undefined, args);
	  }
	
	  if (false) {
	    throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/css' like this: css`" + props.css + "`");
	  }
	
	  var argsLength = args.length;
	  var createElementArgArray = new Array(argsLength);
	  createElementArgArray[0] = Emotion;
	  var newProps = {};
	
	  for (var key in props) {
	    if (hasOwnProperty.call(props, key)) {
	      newProps[key] = props[key];
	    }
	  }
	
	  newProps[typePropName] = type;
	
	  if (false) {
	    var error = new Error();
	
	    if (error.stack) {
	      // chrome
	      var match = error.stack.match(/at (?:Object\.|)jsx.*\n\s+at ([A-Z][A-Za-z$]+) /);
	
	      if (!match) {
	        // safari and firefox
	        match = error.stack.match(/.*\n([A-Z][A-Za-z$]+)@/);
	      }
	
	      if (match) {
	        newProps[labelPropName] = sanitizeIdentifier(match[1]);
	      }
	    }
	  }
	
	  createElementArgArray[1] = newProps;
	
	  for (var i = 2; i < argsLength; i++) {
	    createElementArgArray[i] = args[i];
	  } // $FlowFixMe
	
	
	  return React.createElement.apply(null, createElementArgArray);
	};
	
	var warnedAboutCssPropForGlobal = false;
	var Global =
	/* #__PURE__ */
	exports.withEmotionCache(function (props, cache) {
	  if (false) {
	    console.error("It looks like you're using the css prop on Global, did you mean to use the styles prop instead?");
	    warnedAboutCssPropForGlobal = true;
	  }
	
	  var styles = props.styles;
	
	  if (typeof styles === 'function') {
	    return React.createElement(ThemeContext.Consumer, null, function (theme) {
	      var serialized = serialize.serializeStyles([styles(theme)]);
	      return React.createElement(InnerGlobal, {
	        serialized: serialized,
	        cache: cache
	      });
	    });
	  }
	
	  var serialized = serialize.serializeStyles([styles]);
	  return React.createElement(InnerGlobal, {
	    serialized: serialized,
	    cache: cache
	  });
	});
	
	// maintain place over rerenders.
	// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
	// initial client-side render from SSR, use place of hydrating tag
	var InnerGlobal =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(InnerGlobal, _React$Component);
	
	  function InnerGlobal(props, context, updater) {
	    return _React$Component.call(this, props, context, updater) || this;
	  }
	
	  var _proto = InnerGlobal.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.sheet = new sheet.StyleSheet({
	      key: this.props.cache.key + "-global",
	      nonce: this.props.cache.sheet.nonce,
	      container: this.props.cache.sheet.container
	    }); // $FlowFixMe
	
	    var node = document.querySelector("style[data-emotion-" + this.props.cache.key + "=\"" + this.props.serialized.name + "\"]");
	
	    if (node !== null) {
	      this.sheet.tags.push(node);
	    }
	
	    if (this.props.cache.sheet.tags.length) {
	      this.sheet.before = this.props.cache.sheet.tags[0];
	    }
	
	    this.insertStyles();
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
	    if (prevProps.serialized.name !== this.props.serialized.name) {
	      this.insertStyles();
	    }
	  };
	
	  _proto.insertStyles = function insertStyles() {
	    if (this.props.serialized.next !== undefined) {
	      // insert keyframes
	      utils.insertStyles(this.props.cache, this.props.serialized.next, true);
	    }
	
	    if (this.sheet.tags.length) {
	      // if this doesn't exist then it will be null so the style element will be appended
	      var element = this.sheet.tags[this.sheet.tags.length - 1].nextElementSibling;
	      this.sheet.before = element;
	      this.sheet.flush();
	    }
	
	    this.props.cache.insert("", this.props.serialized, this.sheet, false);
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.sheet.flush();
	  };
	
	  _proto.render = function render() {
	
	    return null;
	  };
	
	  return InnerGlobal;
	}(React.Component);
	
	var keyframes = function keyframes() {
	  var insertable = css.apply(void 0, arguments);
	  var name = "animation-" + insertable.name; // $FlowFixMe
	
	  return {
	    name: name,
	    styles: "@keyframes " + name + "{" + insertable.styles + "}",
	    anim: 1,
	    toString: function toString() {
	      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
	    }
	  };
	};
	
	var classnames = function classnames(args) {
	  var len = args.length;
	  var i = 0;
	  var cls = '';
	
	  for (; i < len; i++) {
	    var arg = args[i];
	    if (arg == null) continue;
	    var toAdd = void 0;
	
	    switch (typeof arg) {
	      case 'boolean':
	        break;
	
	      case 'object':
	        {
	          if (Array.isArray(arg)) {
	            toAdd = classnames(arg);
	          } else {
	            toAdd = '';
	
	            for (var k in arg) {
	              if (arg[k] && k) {
	                toAdd && (toAdd += ' ');
	                toAdd += k;
	              }
	            }
	          }
	
	          break;
	        }
	
	      default:
	        {
	          toAdd = arg;
	        }
	    }
	
	    if (toAdd) {
	      cls && (cls += ' ');
	      cls += toAdd;
	    }
	  }
	
	  return cls;
	};
	
	function merge(registered, css, className) {
	  var registeredStyles = [];
	  var rawClassName = utils.getRegisteredStyles(registered, registeredStyles, className);
	
	  if (registeredStyles.length < 2) {
	    return className;
	  }
	
	  return rawClassName + css(registeredStyles);
	}
	
	var ClassNames = exports.withEmotionCache(function (props, context) {
	  return React.createElement(ThemeContext.Consumer, null, function (theme) {
	    var hasRendered = false;
	
	    var css = function css() {
	      if (hasRendered && ("production") !== 'production') {
	        throw new Error('css can only be used during render');
	      }
	
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      var serialized = serialize.serializeStyles(args, context.registered);
	
	      {
	        utils.insertStyles(context, serialized, false);
	      }
	
	      return context.key + "-" + serialized.name;
	    };
	
	    var cx = function cx() {
	      if (hasRendered && ("production") !== 'production') {
	        throw new Error('cx can only be used during render');
	      }
	
	      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      return merge(context.registered, css, classnames(args));
	    };
	
	    var content = {
	      css: css,
	      cx: cx,
	      theme: theme
	    };
	    var ele = props.children(content);
	    hasRendered = true;
	
	    return ele;
	  });
	});
	
	exports.css = css;
	exports.CacheProvider = CacheProvider;
	exports.ClassNames = ClassNames;
	exports.Global = Global;
	exports.ThemeContext = ThemeContext;
	exports.jsx = jsx;
	exports.keyframes = keyframes;


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var hashString = _interopDefault(__webpack_require__(446));
	var unitless = _interopDefault(__webpack_require__(449));
	var memoize = _interopDefault(__webpack_require__(447));
	
	var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
	var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
	var hyphenateRegex = /[A-Z]|^ms/g;
	var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
	
	var isCustomProperty = function isCustomProperty(property) {
	  return property.charCodeAt(1) === 45;
	};
	
	var isProcessableValue = function isProcessableValue(value) {
	  return value != null && typeof value !== 'boolean';
	};
	
	var processStyleName = memoize(function (styleName) {
	  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
	});
	
	var processStyleValue = function processStyleValue(key, value) {
	  switch (key) {
	    case 'animation':
	    case 'animationName':
	      {
	        if (typeof value === 'string') {
	          return value.replace(animationRegex, function (match, p1, p2) {
	            cursor = {
	              name: p1,
	              styles: p2,
	              next: cursor
	            };
	            return p1;
	          });
	        }
	      }
	  }
	
	  if (unitless[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
	    return value + 'px';
	  }
	
	  return value;
	};
	
	if (false) {
	  var contentValuePattern = /(attr|calc|counters?|url)\(/;
	  var contentValues = ['normal', 'none', 'counter', 'open-quote', 'close-quote', 'no-open-quote', 'no-close-quote', 'initial', 'inherit', 'unset'];
	  var oldProcessStyleValue = processStyleValue;
	  var msPattern = /^-ms-/;
	  var hyphenPattern = /-(.)/g;
	  var hyphenatedCache = {};
	
	  processStyleValue = function processStyleValue(key, value) {
	    if (key === 'content') {
	      if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
	        console.error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
	      }
	    }
	
	    var processed = oldProcessStyleValue(key, value);
	
	    if (processed !== '' && !isCustomProperty(key) && key.indexOf('-') !== -1 && hyphenatedCache[key] === undefined) {
	      hyphenatedCache[key] = true;
	      console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + key.replace(msPattern, 'ms-').replace(hyphenPattern, function (str, _char) {
	        return _char.toUpperCase();
	      }) + "?");
	    }
	
	    return processed;
	  };
	}
	
	var shouldWarnAboutInterpolatingClassNameFromCss = true;
	
	function handleInterpolation(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
	  if (interpolation == null) {
	    return '';
	  }
	
	  if (interpolation.__emotion_styles !== undefined) {
	    if (false) {
	      throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
	    }
	
	    return interpolation;
	  }
	
	  switch (typeof interpolation) {
	    case 'boolean':
	      {
	        return '';
	      }
	
	    case 'object':
	      {
	        if (interpolation.anim === 1) {
	          cursor = {
	            name: interpolation.name,
	            styles: interpolation.styles,
	            next: cursor
	          };
	          return interpolation.name;
	        }
	
	        if (interpolation.styles !== undefined) {
	          var next = interpolation.next;
	
	          if (next !== undefined) {
	            // not the most efficient thing ever but this is a pretty rare case
	            // and there will be very few iterations of this generally
	            while (next !== undefined) {
	              cursor = {
	                name: next.name,
	                styles: next.styles,
	                next: cursor
	              };
	              next = next.next;
	            }
	          }
	
	          var styles = interpolation.styles + ";";
	
	          if (false) {
	            styles += interpolation.map;
	          }
	
	          return styles;
	        }
	
	        return createStringFromObject(mergedProps, registered, interpolation);
	      }
	
	    case 'function':
	      {
	        if (mergedProps !== undefined) {
	          var previousCursor = cursor;
	          var result = interpolation(mergedProps);
	          cursor = previousCursor;
	          return handleInterpolation(mergedProps, registered, result, couldBeSelectorInterpolation);
	        } else if (false) {
	          console.error('Functions that are interpolated in css calls will be stringified.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
	        }
	
	        break;
	      }
	
	    case 'string':
	      if (false) {
	        var matched = [];
	        var replaced = interpolation.replace(animationRegex, function (match, p1, p2) {
	          var fakeVarName = "animation" + matched.length;
	          matched.push("const " + fakeVarName + " = keyframes`" + p2.replace(/^@keyframes animation-\w+/, '') + "`");
	          return "${" + fakeVarName + "}";
	        });
	
	        if (matched.length) {
	          console.error('`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\n' + 'Instead of doing this:\n\n' + [].concat(matched, ["`" + replaced + "`"]).join('\n') + '\n\nYou should wrap it with `css` like this:\n\n' + ("css`" + replaced + "`"));
	        }
	      }
	
	      break;
	  } // finalize string values (regular strings and functions interpolated into css calls)
	
	
	  if (registered == null) {
	    return interpolation;
	  }
	
	  var cached = registered[interpolation];
	
	  if (false) {
	    console.error('Interpolating a className from css`` is not recommended and will cause problems with composition.\n' + 'Interpolating a className from css`` will be completely unsupported in a future major version of Emotion');
	    shouldWarnAboutInterpolatingClassNameFromCss = false;
	  }
	
	  return cached !== undefined && !couldBeSelectorInterpolation ? cached : interpolation;
	}
	
	function createStringFromObject(mergedProps, registered, obj) {
	  var string = '';
	
	  if (Array.isArray(obj)) {
	    for (var i = 0; i < obj.length; i++) {
	      string += handleInterpolation(mergedProps, registered, obj[i], false);
	    }
	  } else {
	    for (var _key in obj) {
	      var value = obj[_key];
	
	      if (typeof value !== 'object') {
	        if (registered != null && registered[value] !== undefined) {
	          string += _key + "{" + registered[value] + "}";
	        } else if (isProcessableValue(value)) {
	          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
	        }
	      } else {
	        if (_key === 'NO_COMPONENT_SELECTOR' && ("production") !== 'production') {
	          throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
	        }
	
	        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
	          for (var _i = 0; _i < value.length; _i++) {
	            if (isProcessableValue(value[_i])) {
	              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
	            }
	          }
	        } else {
	          var interpolated = handleInterpolation(mergedProps, registered, value, false);
	
	          switch (_key) {
	            case 'animation':
	            case 'animationName':
	              {
	                string += processStyleName(_key) + ":" + interpolated + ";";
	                break;
	              }
	
	            default:
	              {
	                if (false) {
	                  console.error(UNDEFINED_AS_OBJECT_KEY_ERROR);
	                }
	
	                string += _key + "{" + interpolated + "}";
	              }
	          }
	        }
	      }
	    }
	  }
	
	  return string;
	}
	
	var labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
	var sourceMapPattern;
	
	if (false) {
	  sourceMapPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//;
	} // this is the cursor for keyframes
	// keyframes are stored on the SerializedStyles object as a linked list
	
	
	var cursor;
	var serializeStyles = function serializeStyles(args, registered, mergedProps) {
	  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
	    return args[0];
	  }
	
	  var stringMode = true;
	  var styles = '';
	  cursor = undefined;
	  var strings = args[0];
	
	  if (strings == null || strings.raw === undefined) {
	    stringMode = false;
	    styles += handleInterpolation(mergedProps, registered, strings, false);
	  } else {
	    if (false) {
	      console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
	    }
	
	    styles += strings[0];
	  } // we start at 1 since we've already handled the first arg
	
	
	  for (var i = 1; i < args.length; i++) {
	    styles += handleInterpolation(mergedProps, registered, args[i], styles.charCodeAt(styles.length - 1) === 46);
	
	    if (stringMode) {
	      if (false) {
	        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
	      }
	
	      styles += strings[i];
	    }
	  }
	
	  var sourceMap;
	
	  if (false) {
	    styles = styles.replace(sourceMapPattern, function (match) {
	      sourceMap = match;
	      return '';
	    });
	  } // using a global regex with .exec is stateful so lastIndex has to be reset each time
	
	
	  labelPattern.lastIndex = 0;
	  var identifierName = '';
	  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
	
	  while ((match = labelPattern.exec(styles)) !== null) {
	    identifierName += '-' + // $FlowFixMe we know it's not null
	    match[1];
	  }
	
	  var name = hashString(styles) + identifierName;
	
	  if (false) {
	    // $FlowFixMe SerializedStyles type doesn't have toString property (and we don't want to add it)
	    return {
	      name: name,
	      styles: styles,
	      map: sourceMap,
	      next: cursor,
	      toString: function toString() {
	        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
	      }
	    };
	  }
	
	  return {
	    name: name,
	    styles: styles,
	    next: cursor
	  };
	};
	
	exports.serializeStyles = serializeStyles;


/***/ }),
/* 188 */
144,
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactDom = __webpack_require__(17);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Portal = __webpack_require__(453);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _LegacyPortal = __webpack_require__(452);
	
	var _LegacyPortal2 = _interopRequireDefault(_LegacyPortal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Portal = void 0;
	
	if (_reactDom2.default.createPortal) {
	  Portal = _Portal2.default;
	} else {
	  Portal = _LegacyPortal2.default;
	}
	
	exports.default = Portal;

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PortalWithState = exports.Portal = undefined;
	
	var _PortalCompat = __webpack_require__(189);
	
	var _PortalCompat2 = _interopRequireDefault(_PortalCompat);
	
	var _PortalWithState = __webpack_require__(454);
	
	var _PortalWithState2 = _interopRequireDefault(_PortalWithState);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Portal = _PortalCompat2.default;
	exports.PortalWithState = _PortalWithState2.default;

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	exports["default"] = _propTypes2["default"].shape({
	  subscribe: _propTypes2["default"].func.isRequired,
	  dispatch: _propTypes2["default"].func.isRequired,
	  getState: _propTypes2["default"].func.isRequired
	});

/***/ }),
/* 192 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ }),
/* 193 */
[938, 466],
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(24);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(1);
	
	var _invariant = __webpack_require__(14);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _PropTypes = __webpack_require__(127);
	
	var _ContextUtils = __webpack_require__(126);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
	function isEmptyObject(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
	  }return true;
	}
	
	function resolveToLocation(to, router) {
	  return typeof to === 'function' ? to(router.location) : to;
	}
	
	/**
	 * A <Link> is used to create an <a> element that links to a route.
	 * When that route is active, the link gets the value of its
	 * activeClassName prop.
	 *
	 * For example, assuming you have the following route:
	 *
	 *   <Route path="/posts/:postID" component={Post} />
	 *
	 * You could use the following component to link to that route:
	 *
	 *   <Link to={`/posts/${post.id}`} />
	 */
	var Link = (0, _createReactClass2.default)({
	  displayName: 'Link',
	
	  mixins: [(0, _ContextUtils.ContextSubscriber)('router')],
	
	  contextTypes: {
	    router: _PropTypes.routerShape
	  },
	
	  propTypes: {
	    to: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.object, _propTypes.func]),
	    activeStyle: _propTypes.object,
	    activeClassName: _propTypes.string,
	    onlyActiveOnIndex: _propTypes.bool.isRequired,
	    onClick: _propTypes.func,
	    target: _propTypes.string,
	    innerRef: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.func])
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onlyActiveOnIndex: false,
	      style: {}
	    };
	  },
	  handleClick: function handleClick(event) {
	    if (this.props.onClick) this.props.onClick(event);
	
	    if (event.defaultPrevented) return;
	
	    var router = this.context.router;
	
	    !router ?  false ? (0, _invariant2.default)(false, '<Link>s rendered outside of a router context cannot navigate.') : (0, _invariant2.default)(false) : void 0;
	
	    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;
	
	    // If target prop is set (e.g. to "_blank"), let browser handle link.
	    /* istanbul ignore if: untestable with Karma */
	    if (this.props.target) return;
	
	    event.preventDefault();
	
	    router.push(resolveToLocation(this.props.to, router));
	  },
	  render: function render() {
	    var _props = this.props,
	        to = _props.to,
	        activeClassName = _props.activeClassName,
	        activeStyle = _props.activeStyle,
	        onlyActiveOnIndex = _props.onlyActiveOnIndex,
	        innerRef = _props.innerRef,
	        props = _objectWithoutProperties(_props, ['to', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex', 'innerRef']);
	
	    // Ignore if rendered outside the context of router to simplify unit testing.
	
	
	    var router = this.context.router;
	
	
	    if (router) {
	      // If user does not specify a `to` prop, return an empty anchor tag.
	      if (!to) {
	        return _react2.default.createElement('a', _extends({}, props, { ref: innerRef }));
	      }
	
	      var toLocation = resolveToLocation(to, router);
	      props.href = router.createHref(toLocation);
	
	      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
	        if (router.isActive(toLocation, onlyActiveOnIndex)) {
	          if (activeClassName) {
	            if (props.className) {
	              props.className += ' ' + activeClassName;
	            } else {
	              props.className = activeClassName;
	            }
	          }
	
	          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
	        }
	      }
	    }
	
	    return _react2.default.createElement('a', _extends({}, props, { onClick: this.handleClick, ref: innerRef }));
	  }
	});
	
	exports.default = Link;
	module.exports = exports['default'];

/***/ }),
/* 195 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.isPromise = isPromise;
	function isPromise(obj) {
	  return obj && typeof obj.then === 'function';
	}

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(24);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(1);
	
	var _invariant = __webpack_require__(14);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(31);
	
	var _PatternUtils = __webpack_require__(46);
	
	var _InternalPropTypes = __webpack_require__(64);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A <Redirect> is used to declare another URL path a client should
	 * be sent to when they request a given URL.
	 *
	 * Redirects are placed alongside routes in the route configuration
	 * and are traversed in the same manner.
	 */
	/* eslint-disable react/require-render-return */
	var Redirect = (0, _createReactClass2.default)({
	  displayName: 'Redirect',
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element) {
	      var route = (0, _RouteUtils.createRouteFromReactElement)(element);
	
	      if (route.from) route.path = route.from;
	
	      route.onEnter = function (nextState, replace) {
	        var location = nextState.location,
	            params = nextState.params;
	
	
	        var pathname = void 0;
	        if (route.to.charAt(0) === '/') {
	          pathname = (0, _PatternUtils.formatPattern)(route.to, params);
	        } else if (!route.to) {
	          pathname = location.pathname;
	        } else {
	          var routeIndex = nextState.routes.indexOf(route);
	          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
	          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
	          pathname = (0, _PatternUtils.formatPattern)(pattern, params);
	        }
	
	        replace({
	          pathname: pathname,
	          query: route.query || location.query,
	          state: route.state || location.state
	        });
	      };
	
	      return route;
	    },
	    getRoutePattern: function getRoutePattern(routes, routeIndex) {
	      var parentPattern = '';
	
	      for (var i = routeIndex; i >= 0; i--) {
	        var route = routes[i];
	        var pattern = route.path || '';
	
	        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;
	
	        if (pattern.indexOf('/') === 0) break;
	      }
	
	      return '/' + parentPattern;
	    }
	  },
	
	  propTypes: {
	    path: _propTypes.string,
	    from: _propTypes.string, // Alias for path
	    to: _propTypes.string.isRequired,
	    query: _propTypes.object,
	    state: _propTypes.object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Redirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Redirect;
	module.exports = exports['default'];

/***/ }),
/* 197 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createRouterObject = createRouterObject;
	exports.assignRouterState = assignRouterState;
	function createRouterObject(history, transitionManager, state) {
	  var router = _extends({}, history, {
	    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
	    isActive: transitionManager.isActive
	  });
	
	  return assignRouterState(router, state);
	}
	
	function assignRouterState(router, _ref) {
	  var location = _ref.location,
	      params = _ref.params,
	      routes = _ref.routes;
	
	  router.location = location;
	  router.params = params;
	  router.routes = routes;
	
	  return router;
	}

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createMemoryHistory;
	
	var _useQueries = __webpack_require__(168);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(167);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	var _createMemoryHistory = __webpack_require__(394);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createMemoryHistory(options) {
	  // signatures and type checking differ between `useQueries` and
	  // `createMemoryHistory`, have to create `memoryHistory` first because
	  // `useQueries` doesn't understand the signature
	  var memoryHistory = (0, _createMemoryHistory2.default)(options);
	  var createHistory = function createHistory() {
	    return memoryHistory;
	  };
	  var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	  return history;
	}
	module.exports = exports['default'];

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createRouterHistory;
	
	var _useRouterHistory = __webpack_require__(201);
	
	var _useRouterHistory2 = _interopRequireDefault(_useRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	function createRouterHistory(createHistory) {
	  var history = void 0;
	  if (canUseDOM) history = (0, _useRouterHistory2.default)(createHistory)();
	  return history;
	}
	module.exports = exports['default'];

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createTransitionManager;
	
	var _routerWarning = __webpack_require__(47);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _computeChangedRoutes2 = __webpack_require__(481);
	
	var _computeChangedRoutes3 = _interopRequireDefault(_computeChangedRoutes2);
	
	var _TransitionUtils = __webpack_require__(478);
	
	var _TransitionUtils2 = _interopRequireDefault(_TransitionUtils);
	
	var _isActive2 = __webpack_require__(485);
	
	var _isActive3 = _interopRequireDefault(_isActive2);
	
	var _getComponents = __webpack_require__(482);
	
	var _getComponents2 = _interopRequireDefault(_getComponents);
	
	var _matchRoutes = __webpack_require__(487);
	
	var _matchRoutes2 = _interopRequireDefault(_matchRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hasAnyProperties(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
	  }return false;
	}
	
	function createTransitionManager(history, routes) {
	  var state = {};
	
	  var _getTransitionUtils = (0, _TransitionUtils2.default)(),
	      runEnterHooks = _getTransitionUtils.runEnterHooks,
	      runChangeHooks = _getTransitionUtils.runChangeHooks,
	      runLeaveHooks = _getTransitionUtils.runLeaveHooks;
	
	  // Signature should be (location, indexOnly), but needs to support (path,
	  // query, indexOnly)
	
	
	  function isActive(location, indexOnly) {
	    location = history.createLocation(location);
	
	    return (0, _isActive3.default)(location, indexOnly, state.location, state.routes, state.params);
	  }
	
	  var partialNextState = void 0;
	
	  function match(location, callback) {
	    if (partialNextState && partialNextState.location === location) {
	      // Continue from where we left off.
	      finishMatch(partialNextState, callback);
	    } else {
	      (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	        if (error) {
	          callback(error);
	        } else if (nextState) {
	          finishMatch(_extends({}, nextState, { location: location }), callback);
	        } else {
	          callback();
	        }
	      });
	    }
	  }
	
	  function finishMatch(nextState, callback) {
	    var _computeChangedRoutes = (0, _computeChangedRoutes3.default)(state, nextState),
	        leaveRoutes = _computeChangedRoutes.leaveRoutes,
	        changeRoutes = _computeChangedRoutes.changeRoutes,
	        enterRoutes = _computeChangedRoutes.enterRoutes;
	
	    runLeaveHooks(leaveRoutes, state);
	
	    // Tear down confirmation hooks for left routes
	    leaveRoutes.filter(function (route) {
	      return enterRoutes.indexOf(route) === -1;
	    }).forEach(removeListenBeforeHooksForRoute);
	
	    // change and enter hooks are run in series
	    runChangeHooks(changeRoutes, state, nextState, function (error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      runEnterHooks(enterRoutes, nextState, finishEnterHooks);
	    });
	
	    function finishEnterHooks(error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      // TODO: Fetch components after state is updated.
	      (0, _getComponents2.default)(nextState, function (error, components) {
	        if (error) {
	          callback(error);
	        } else {
	          // TODO: Make match a pure function and have some other API
	          // for "match and update state".
	          callback(null, null, state = _extends({}, nextState, { components: components }));
	        }
	      });
	    }
	
	    function handleErrorOrRedirect(error, redirectInfo) {
	      if (error) callback(error);else callback(null, redirectInfo);
	    }
	  }
	
	  var RouteGuid = 1;
	
	  function getRouteID(route) {
	    var create = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    return route.__id__ || create && (route.__id__ = RouteGuid++);
	  }
	
	  var RouteHooks = Object.create(null);
	
	  function getRouteHooksForRoutes(routes) {
	    return routes.map(function (route) {
	      return RouteHooks[getRouteID(route)];
	    }).filter(function (hook) {
	      return hook;
	    });
	  }
	
	  function transitionHook(location, callback) {
	    (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	      if (nextState == null) {
	        // TODO: We didn't actually match anything, but hang
	        // onto error/nextState so we don't have to matchRoutes
	        // again in the listen callback.
	        callback();
	        return;
	      }
	
	      // Cache some state here so we don't have to
	      // matchRoutes() again in the listen callback.
	      partialNextState = _extends({}, nextState, { location: location });
	
	      var hooks = getRouteHooksForRoutes((0, _computeChangedRoutes3.default)(state, partialNextState).leaveRoutes);
	
	      var result = void 0;
	      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
	        // Passing the location arg here indicates to
	        // the user that this is a transition hook.
	        result = hooks[i](location);
	      }
	
	      callback(result);
	    });
	  }
	
	  /* istanbul ignore next: untestable with Karma */
	  function beforeUnloadHook() {
	    // Synchronously check to see if any route hooks want
	    // to prevent the current window/tab from closing.
	    if (state.routes) {
	      var hooks = getRouteHooksForRoutes(state.routes);
	
	      var message = void 0;
	      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
	        // Passing no args indicates to the user that this is a
	        // beforeunload hook. We don't know the next location.
	        message = hooks[i]();
	      }
	
	      return message;
	    }
	  }
	
	  var unlistenBefore = void 0,
	      unlistenBeforeUnload = void 0;
	
	  function removeListenBeforeHooksForRoute(route) {
	    var routeID = getRouteID(route);
	    if (!routeID) {
	      return;
	    }
	
	    delete RouteHooks[routeID];
	
	    if (!hasAnyProperties(RouteHooks)) {
	      // teardown transition & beforeunload hooks
	      if (unlistenBefore) {
	        unlistenBefore();
	        unlistenBefore = null;
	      }
	
	      if (unlistenBeforeUnload) {
	        unlistenBeforeUnload();
	        unlistenBeforeUnload = null;
	      }
	    }
	  }
	
	  /**
	   * Registers the given hook function to run before leaving the given route.
	   *
	   * During a normal transition, the hook function receives the next location
	   * as its only argument and can return either a prompt message (string) to show the user,
	   * to make sure they want to leave the page; or `false`, to prevent the transition.
	   * Any other return value will have no effect.
	   *
	   * During the beforeunload event (in browsers) the hook receives no arguments.
	   * In this case it must return a prompt message to prevent the transition.
	   *
	   * Returns a function that may be used to unbind the listener.
	   */
	  function listenBeforeLeavingRoute(route, hook) {
	    var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);
	    var routeID = getRouteID(route, true);
	
	    RouteHooks[routeID] = hook;
	
	    if (thereWereNoRouteHooks) {
	      // setup transition & beforeunload hooks
	      unlistenBefore = history.listenBefore(transitionHook);
	
	      if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
	    }
	
	    return function () {
	      removeListenBeforeHooksForRoute(route);
	    };
	  }
	
	  /**
	   * This is the API for stateful environments. As the location
	   * changes, we update state and call the listener. We can also
	   * gracefully handle errors and redirects.
	   */
	  function listen(listener) {
	    function historyListener(location) {
	      if (state.location === location) {
	        listener(null, state);
	      } else {
	        match(location, function (error, redirectLocation, nextState) {
	          if (error) {
	            listener(error);
	          } else if (redirectLocation) {
	            history.replace(redirectLocation);
	          } else if (nextState) {
	            listener(null, nextState);
	          } else {
	             false ? (0, _routerWarning2.default)(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
	          }
	        });
	      }
	    }
	
	    // TODO: Only use a single history listener. Otherwise we'll end up with
	    // multiple concurrent calls to match.
	
	    // Set up the history listener first in case the initial match redirects.
	    var unsubscribe = history.listen(historyListener);
	
	    if (state.location) {
	      // Picking up on a matchContext.
	      listener(null, state);
	    } else {
	      historyListener(history.getCurrentLocation());
	    }
	
	    return unsubscribe;
	  }
	
	  return {
	    isActive: isActive,
	    match: match,
	    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
	    listen: listen
	  };
	}
	module.exports = exports['default'];

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = useRouterHistory;
	
	var _useQueries = __webpack_require__(168);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(167);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useRouterHistory(createHistory) {
	  return function (options) {
	    var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	    return history;
	  };
	}
	module.exports = exports['default'];

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault(ex) {
	  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
	}
	
	var _objectWithoutProperties = _interopDefault(__webpack_require__(72));
	
	var _extends = _interopDefault(__webpack_require__(57));
	
	var _objectSpread = _interopDefault(__webpack_require__(100));
	
	var _classCallCheck = _interopDefault(__webpack_require__(68));
	
	var _createClass = _interopDefault(__webpack_require__(69));
	
	var _possibleConstructorReturn = _interopDefault(__webpack_require__(73));
	
	var _getPrototypeOf = _interopDefault(__webpack_require__(70));
	
	var _inherits = _interopDefault(__webpack_require__(71));
	
	var _assertThisInitialized = _interopDefault(__webpack_require__(55));
	
	var _defineProperty = _interopDefault(__webpack_require__(56));
	
	var React = __webpack_require__(2);
	
	var React__default = _interopDefault(React);
	
	var core = __webpack_require__(101);
	
	var reactDom = __webpack_require__(17);
	
	var PropTypes = _interopDefault(__webpack_require__(1));
	
	var _typeof = _interopDefault(__webpack_require__(74));
	
	var __chunk_1 = __webpack_require__(129);
	
	var _css = _interopDefault(__webpack_require__(75));
	
	var _taggedTemplateLiteral = _interopDefault(__webpack_require__(139));
	
	var AutosizeInput = _interopDefault(__webpack_require__(184));
	
	function getMenuPlacement(_ref) {
	  var maxHeight = _ref.maxHeight,
	      menuEl = _ref.menuEl,
	      minHeight = _ref.minHeight,
	      placement = _ref.placement,
	      shouldScroll = _ref.shouldScroll,
	      isFixedPosition = _ref.isFixedPosition,
	      theme = _ref.theme;
	  var spacing = theme.spacing;
	
	  var scrollParent = __chunk_1.getScrollParent(menuEl);
	
	  var defaultState = {
	    placement: 'bottom',
	    maxHeight: maxHeight
	  }; // something went wrong, return default state
	
	  if (!menuEl || !menuEl.offsetParent) return defaultState; // we can't trust `scrollParent.scrollHeight` --> it may increase when
	  // the menu is rendered
	
	  var _scrollParent$getBoun = scrollParent.getBoundingClientRect(),
	      scrollHeight = _scrollParent$getBoun.height;
	
	  var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(),
	      menuBottom = _menuEl$getBoundingCl.bottom,
	      menuHeight = _menuEl$getBoundingCl.height,
	      menuTop = _menuEl$getBoundingCl.top;
	
	  var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(),
	      containerTop = _menuEl$offsetParent$.top;
	
	  var viewHeight = window.innerHeight;
	
	  var scrollTop = __chunk_1.getScrollTop(scrollParent);
	
	  var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
	  var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
	  var viewSpaceAbove = containerTop - marginTop;
	  var viewSpaceBelow = viewHeight - menuTop;
	  var scrollSpaceAbove = viewSpaceAbove + scrollTop;
	  var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
	  var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
	  var scrollUp = scrollTop + menuTop - marginTop;
	  var scrollDuration = 160;
	
	  switch (placement) {
	    case 'auto':
	    case 'bottom':
	      // 1: the menu will fit, do nothing
	      if (viewSpaceBelow >= menuHeight) {
	        return {
	          placement: 'bottom',
	          maxHeight: maxHeight
	        };
	      } // 2: the menu will fit, if scrolled
	
	
	      if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
	        if (shouldScroll) {
	          __chunk_1.animatedScrollTo(scrollParent, scrollDown, scrollDuration);
	        }
	
	        return {
	          placement: 'bottom',
	          maxHeight: maxHeight
	        };
	      } // 3: the menu will fit, if constrained
	
	
	      if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
	        if (shouldScroll) {
	          __chunk_1.animatedScrollTo(scrollParent, scrollDown, scrollDuration);
	        } // we want to provide as much of the menu as possible to the user,
	        // so give them whatever is available below rather than the minHeight.
	
	
	        var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
	        return {
	          placement: 'bottom',
	          maxHeight: constrainedHeight
	        };
	      } // 4. Forked beviour when there isn't enough space below
	      // AUTO: flip the menu, render above
	
	
	      if (placement === 'auto' || isFixedPosition) {
	        // may need to be constrained after flipping
	        var _constrainedHeight = maxHeight;
	        var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
	
	        if (spaceAbove >= minHeight) {
	          _constrainedHeight = Math.min(spaceAbove - marginBottom - spacing.controlHeight, maxHeight);
	        }
	
	        return {
	          placement: 'top',
	          maxHeight: _constrainedHeight
	        };
	      } // BOTTOM: allow browser to increase scrollable area and immediately set scroll
	
	
	      if (placement === 'bottom') {
	        __chunk_1.scrollTo(scrollParent, scrollDown);
	
	        return {
	          placement: 'bottom',
	          maxHeight: maxHeight
	        };
	      }
	
	      break;
	
	    case 'top':
	      // 1: the menu will fit, do nothing
	      if (viewSpaceAbove >= menuHeight) {
	        return {
	          placement: 'top',
	          maxHeight: maxHeight
	        };
	      } // 2: the menu will fit, if scrolled
	
	
	      if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
	        if (shouldScroll) {
	          __chunk_1.animatedScrollTo(scrollParent, scrollUp, scrollDuration);
	        }
	
	        return {
	          placement: 'top',
	          maxHeight: maxHeight
	        };
	      } // 3: the menu will fit, if constrained
	
	
	      if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
	        var _constrainedHeight2 = maxHeight; // we want to provide as much of the menu as possible to the user,
	        // so give them whatever is available below rather than the minHeight.
	
	        if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
	          _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
	        }
	
	        if (shouldScroll) {
	          __chunk_1.animatedScrollTo(scrollParent, scrollUp, scrollDuration);
	        }
	
	        return {
	          placement: 'top',
	          maxHeight: _constrainedHeight2
	        };
	      } // 4. not enough space, the browser WILL NOT increase scrollable area when
	      // absolutely positioned element rendered above the viewport (only below).
	      // Flip the menu, render below
	
	
	      return {
	        placement: 'bottom',
	        maxHeight: maxHeight
	      };
	
	    default:
	      throw new Error("Invalid placement provided \"".concat(placement, "\"."));
	  } // fulfil contract with flow: implicit return value of undefined
	
	
	  return defaultState;
	} // Menu Component
	// ------------------------------
	
	
	function alignToControl(placement) {
	  var placementToCSSProp = {
	    bottom: 'top',
	    top: 'bottom'
	  };
	  return placement ? placementToCSSProp[placement] : 'bottom';
	}
	
	var coercePlacement = function coercePlacement(p) {
	  return p === 'auto' ? 'bottom' : p;
	};
	
	var menuCSS = function menuCSS(_ref2) {
	  var _ref3;
	
	  var placement = _ref2.placement,
	      _ref2$theme = _ref2.theme,
	      borderRadius = _ref2$theme.borderRadius,
	      spacing = _ref2$theme.spacing,
	      colors = _ref2$theme.colors;
	  return _ref3 = {
	    label: 'menu'
	  }, _defineProperty(_ref3, alignToControl(placement), '100%'), _defineProperty(_ref3, "backgroundColor", colors.neutral0), _defineProperty(_ref3, "borderRadius", borderRadius), _defineProperty(_ref3, "boxShadow", '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)'), _defineProperty(_ref3, "marginBottom", spacing.menuGutter), _defineProperty(_ref3, "marginTop", spacing.menuGutter), _defineProperty(_ref3, "position", 'absolute'), _defineProperty(_ref3, "width", '100%'), _defineProperty(_ref3, "zIndex", 1), _ref3;
	}; // NOTE: internal only
	
	
	var MenuPlacer =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(MenuPlacer, _Component);
	
	  function MenuPlacer() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, MenuPlacer);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(MenuPlacer)).call.apply(_getPrototypeOf2, [this].concat(args)));
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
	      maxHeight: _this.props.maxMenuHeight,
	      placement: null
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getPlacement", function (ref) {
	      var _this$props = _this.props,
	          minMenuHeight = _this$props.minMenuHeight,
	          maxMenuHeight = _this$props.maxMenuHeight,
	          menuPlacement = _this$props.menuPlacement,
	          menuPosition = _this$props.menuPosition,
	          menuShouldScrollIntoView = _this$props.menuShouldScrollIntoView,
	          theme = _this$props.theme;
	      var getPortalPlacement = _this.context.getPortalPlacement;
	      if (!ref) return; // DO NOT scroll if position is fixed
	
	      var isFixedPosition = menuPosition === 'fixed';
	      var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
	      var state = getMenuPlacement({
	        maxHeight: maxMenuHeight,
	        menuEl: ref,
	        minHeight: minMenuHeight,
	        placement: menuPlacement,
	        shouldScroll: shouldScroll,
	        isFixedPosition: isFixedPosition,
	        theme: theme
	      });
	      if (getPortalPlacement) getPortalPlacement(state);
	
	      _this.setState(state);
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getUpdatedProps", function () {
	      var menuPlacement = _this.props.menuPlacement;
	      var placement = _this.state.placement || coercePlacement(menuPlacement);
	      return _objectSpread({}, _this.props, {
	        placement: placement,
	        maxHeight: _this.state.maxHeight
	      });
	    });
	
	    return _this;
	  }
	
	  _createClass(MenuPlacer, [{
	    key: "render",
	    value: function render() {
	      var children = this.props.children;
	      return children({
	        ref: this.getPlacement,
	        placerProps: this.getUpdatedProps()
	      });
	    }
	  }]);
	
	  return MenuPlacer;
	}(React.Component);
	
	_defineProperty(MenuPlacer, "contextTypes", {
	  getPortalPlacement: PropTypes.func
	});
	
	var Menu = function Menu(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      innerRef = props.innerRef,
	      innerProps = props.innerProps;
	  return core.jsx("div", _extends({
	    css: getStyles('menu', props),
	    className: cx({
	      menu: true
	    }, className)
	  }, innerProps, {
	    ref: innerRef
	  }), children);
	}; // Menu List
	// ==============================
	
	
	var menuListCSS = function menuListCSS(_ref4) {
	  var maxHeight = _ref4.maxHeight,
	      baseUnit = _ref4.theme.spacing.baseUnit;
	  return {
	    maxHeight: maxHeight,
	    overflowY: 'auto',
	    paddingBottom: baseUnit,
	    paddingTop: baseUnit,
	    position: 'relative',
	    // required for offset[Height, Top] > keyboard scroll
	    WebkitOverflowScrolling: 'touch'
	  };
	};
	
	var MenuList = function MenuList(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      isMulti = props.isMulti,
	      innerRef = props.innerRef;
	  return core.jsx("div", {
	    css: getStyles('menuList', props),
	    className: cx({
	      'menu-list': true,
	      'menu-list--is-multi': isMulti
	    }, className),
	    ref: innerRef
	  }, children);
	}; // ==============================
	// Menu Notices
	// ==============================
	
	
	var noticeCSS = function noticeCSS(_ref5) {
	  var _ref5$theme = _ref5.theme,
	      baseUnit = _ref5$theme.spacing.baseUnit,
	      colors = _ref5$theme.colors;
	  return {
	    color: colors.neutral40,
	    padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px"),
	    textAlign: 'center'
	  };
	};
	
	var noOptionsMessageCSS = noticeCSS;
	var loadingMessageCSS = noticeCSS;
	
	var NoOptionsMessage = function NoOptionsMessage(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      innerProps = props.innerProps;
	  return core.jsx("div", _extends({
	    css: getStyles('noOptionsMessage', props),
	    className: cx({
	      'menu-notice': true,
	      'menu-notice--no-options': true
	    }, className)
	  }, innerProps), children);
	};
	
	NoOptionsMessage.defaultProps = {
	  children: 'No options'
	};
	
	var LoadingMessage = function LoadingMessage(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      innerProps = props.innerProps;
	  return core.jsx("div", _extends({
	    css: getStyles('loadingMessage', props),
	    className: cx({
	      'menu-notice': true,
	      'menu-notice--loading': true
	    }, className)
	  }, innerProps), children);
	};
	
	LoadingMessage.defaultProps = {
	  children: 'Loading...'
	}; // ==============================
	// Menu Portal
	// ==============================
	
	var menuPortalCSS = function menuPortalCSS(_ref6) {
	  var rect = _ref6.rect,
	      offset = _ref6.offset,
	      position = _ref6.position;
	  return {
	    left: rect.left,
	    position: position,
	    top: offset,
	    width: rect.width,
	    zIndex: 1
	  };
	};
	
	var MenuPortal =
	/*#__PURE__*/
	function (_Component2) {
	  _inherits(MenuPortal, _Component2);
	
	  function MenuPortal() {
	    var _getPrototypeOf3;
	
	    var _this2;
	
	    _classCallCheck(this, MenuPortal);
	
	    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    _this2 = _possibleConstructorReturn(this, (_getPrototypeOf3 = _getPrototypeOf(MenuPortal)).call.apply(_getPrototypeOf3, [this].concat(args)));
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this2)), "state", {
	      placement: null
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this2)), "getPortalPlacement", function (_ref7) {
	      var placement = _ref7.placement;
	      var initialPlacement = coercePlacement(_this2.props.menuPlacement); // avoid re-renders if the placement has not changed
	
	      if (placement !== initialPlacement) {
	        _this2.setState({
	          placement: placement
	        });
	      }
	    });
	
	    return _this2;
	  }
	
	  _createClass(MenuPortal, [{
	    key: "getChildContext",
	    value: function getChildContext() {
	      return {
	        getPortalPlacement: this.getPortalPlacement
	      };
	    } // callback for occassions where the menu must "flip"
	
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          appendTo = _this$props2.appendTo,
	          children = _this$props2.children,
	          controlElement = _this$props2.controlElement,
	          menuPlacement = _this$props2.menuPlacement,
	          position = _this$props2.menuPosition,
	          getStyles = _this$props2.getStyles;
	      var isFixed = position === 'fixed'; // bail early if required elements aren't present
	
	      if (!appendTo && !isFixed || !controlElement) {
	        return null;
	      }
	
	      var placement = this.state.placement || coercePlacement(menuPlacement);
	
	      var rect = __chunk_1.getBoundingClientObj(controlElement);
	
	      var scrollDistance = isFixed ? 0 : window.pageYOffset;
	      var offset = rect[placement] + scrollDistance;
	      var state = {
	        offset: offset,
	        position: position,
	        rect: rect
	      }; // same wrapper element whether fixed or portalled
	
	      var menuWrapper = core.jsx("div", {
	        css: getStyles('menuPortal', state)
	      }, children);
	      return appendTo ? reactDom.createPortal(menuWrapper, appendTo) : menuWrapper;
	    }
	  }]);
	
	  return MenuPortal;
	}(React.Component);
	
	_defineProperty(MenuPortal, "childContextTypes", {
	  getPortalPlacement: PropTypes.func
	});
	
	var isArray = Array.isArray;
	var keyList = Object.keys;
	var hasProp = Object.prototype.hasOwnProperty;
	
	function equal(a, b) {
	  // fast-deep-equal index.js 2.0.1
	  if (a === b) return true;
	
	  if (a && b && _typeof(a) == 'object' && _typeof(b) == 'object') {
	    var arrA = isArray(a),
	        arrB = isArray(b),
	        i,
	        length,
	        key;
	
	    if (arrA && arrB) {
	      length = a.length;
	      if (length != b.length) return false;
	
	      for (i = length; i-- !== 0;) {
	        if (!equal(a[i], b[i])) return false;
	      }
	
	      return true;
	    }
	
	    if (arrA != arrB) return false;
	    var dateA = a instanceof Date,
	        dateB = b instanceof Date;
	    if (dateA != dateB) return false;
	    if (dateA && dateB) return a.getTime() == b.getTime();
	    var regexpA = a instanceof RegExp,
	        regexpB = b instanceof RegExp;
	    if (regexpA != regexpB) return false;
	    if (regexpA && regexpB) return a.toString() == b.toString();
	    var keys = keyList(a);
	    length = keys.length;
	
	    if (length !== keyList(b).length) {
	      return false;
	    }
	
	    for (i = length; i-- !== 0;) {
	      if (!hasProp.call(b, keys[i])) return false;
	    } // end fast-deep-equal
	    // Custom handling for React
	
	
	    for (i = length; i-- !== 0;) {
	      key = keys[i];
	
	      if (key === '_owner' && a.$$typeof) {
	        // React-specific: avoid traversing React elements' _owner.
	        //  _owner contains circular references
	        // and is not needed when comparing the actual elements (and not their owners)
	        // .$$typeof and ._store on just reasonable markers of a react element
	        continue;
	      } else {
	        // all other properties should be traversed as usual
	        if (!equal(a[key], b[key])) return false;
	      }
	    } // fast-deep-equal index.js 2.0.1
	
	
	    return true;
	  }
	
	  return a !== a && b !== b;
	} // end fast-deep-equal
	
	
	function exportedEqual(a, b) {
	  try {
	    return equal(a, b);
	  } catch (error) {
	    if (error.message && error.message.match(/stack|recursion/i)) {
	      // warn on circular references, don't crash
	      // browsers give this different errors name and messages:
	      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
	      // firefox: "InternalError", too much recursion"
	      // edge: "Error", "Out of stack space"
	      console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
	      return false;
	    } // some other error. we should definitely know about these
	
	
	    throw error;
	  }
	}
	
	var containerCSS = function containerCSS(_ref) {
	  var isDisabled = _ref.isDisabled,
	      isRtl = _ref.isRtl;
	  return {
	    label: 'container',
	    direction: isRtl ? 'rtl' : null,
	    pointerEvents: isDisabled ? 'none' : null,
	    // cancel mouse events when disabled
	    position: 'relative'
	  };
	};
	
	var SelectContainer = function SelectContainer(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      innerProps = props.innerProps,
	      isDisabled = props.isDisabled,
	      isRtl = props.isRtl;
	  return core.jsx("div", _extends({
	    css: getStyles('container', props),
	    className: cx({
	      '--is-disabled': isDisabled,
	      '--is-rtl': isRtl
	    }, className)
	  }, innerProps), children);
	}; // ==============================
	// Value Container
	// ==============================
	
	
	var valueContainerCSS = function valueContainerCSS(_ref2) {
	  var spacing = _ref2.theme.spacing;
	  return {
	    alignItems: 'center',
	    display: 'flex',
	    flex: 1,
	    flexWrap: 'wrap',
	    padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px"),
	    WebkitOverflowScrolling: 'touch',
	    position: 'relative',
	    overflow: 'hidden'
	  };
	};
	
	var ValueContainer =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(ValueContainer, _Component);
	
	  function ValueContainer() {
	    _classCallCheck(this, ValueContainer);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(ValueContainer).apply(this, arguments));
	  }
	
	  _createClass(ValueContainer, [{
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          children = _this$props.children,
	          className = _this$props.className,
	          cx = _this$props.cx,
	          isMulti = _this$props.isMulti,
	          getStyles = _this$props.getStyles,
	          hasValue = _this$props.hasValue;
	      return core.jsx("div", {
	        css: getStyles('valueContainer', this.props),
	        className: cx({
	          'value-container': true,
	          'value-container--is-multi': isMulti,
	          'value-container--has-value': hasValue
	        }, className)
	      }, children);
	    }
	  }]);
	
	  return ValueContainer;
	}(React.Component); // ==============================
	// Indicator Container
	// ==============================
	
	
	var indicatorsContainerCSS = function indicatorsContainerCSS() {
	  return {
	    alignItems: 'center',
	    alignSelf: 'stretch',
	    display: 'flex',
	    flexShrink: 0
	  };
	};
	
	var IndicatorsContainer = function IndicatorsContainer(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles;
	  return core.jsx("div", {
	    css: getStyles('indicatorsContainer', props),
	    className: cx({
	      indicators: true
	    }, className)
	  }, children);
	};
	
	function _templateObject() {
	  var data = _taggedTemplateLiteral(["\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"]);
	
	  _templateObject = function _templateObject() {
	    return data;
	  };
	
	  return data;
	}
	
	var _ref2 =  true ? {
	  name: "19bqh2r",
	  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0;"
	} : {
	  name: "19bqh2r",
	  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0;",
	  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"
	}; // ==============================
	// Dropdown & Clear Icons
	// ==============================
	
	
	var Svg = function Svg(_ref) {
	  var size = _ref.size,
	      props = _objectWithoutProperties(_ref, ["size"]);
	
	  return core.jsx("svg", _extends({
	    height: size,
	    width: size,
	    viewBox: "0 0 20 20",
	    "aria-hidden": "true",
	    focusable: "false",
	    css: _ref2
	  }, props));
	};
	
	var CrossIcon = function CrossIcon(props) {
	  return core.jsx(Svg, _extends({
	    size: 20
	  }, props), core.jsx("path", {
	    d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
	  }));
	};
	
	var DownChevron = function DownChevron(props) {
	  return core.jsx(Svg, _extends({
	    size: 20
	  }, props), core.jsx("path", {
	    d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
	  }));
	}; // ==============================
	// Dropdown & Clear Buttons
	// ==============================
	
	
	var baseCSS = function baseCSS(_ref3) {
	  var isFocused = _ref3.isFocused,
	      _ref3$theme = _ref3.theme,
	      baseUnit = _ref3$theme.spacing.baseUnit,
	      colors = _ref3$theme.colors;
	  return {
	    label: 'indicatorContainer',
	    color: isFocused ? colors.neutral60 : colors.neutral20,
	    display: 'flex',
	    padding: baseUnit * 2,
	    transition: 'color 150ms',
	    ':hover': {
	      color: isFocused ? colors.neutral80 : colors.neutral40
	    }
	  };
	};
	
	var dropdownIndicatorCSS = baseCSS;
	
	var DropdownIndicator = function DropdownIndicator(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      innerProps = props.innerProps;
	  return core.jsx("div", _extends({}, innerProps, {
	    css: getStyles('dropdownIndicator', props),
	    className: cx({
	      indicator: true,
	      'dropdown-indicator': true
	    }, className)
	  }), children || core.jsx(DownChevron, null));
	};
	
	var clearIndicatorCSS = baseCSS;
	
	var ClearIndicator = function ClearIndicator(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      innerProps = props.innerProps;
	  return core.jsx("div", _extends({}, innerProps, {
	    css: getStyles('clearIndicator', props),
	    className: cx({
	      indicator: true,
	      'clear-indicator': true
	    }, className)
	  }), children || core.jsx(CrossIcon, null));
	}; // ==============================
	// Separator
	// ==============================
	
	
	var indicatorSeparatorCSS = function indicatorSeparatorCSS(_ref4) {
	  var isDisabled = _ref4.isDisabled,
	      _ref4$theme = _ref4.theme,
	      baseUnit = _ref4$theme.spacing.baseUnit,
	      colors = _ref4$theme.colors;
	  return {
	    label: 'indicatorSeparator',
	    alignSelf: 'stretch',
	    backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
	    marginBottom: baseUnit * 2,
	    marginTop: baseUnit * 2,
	    width: 1
	  };
	};
	
	var IndicatorSeparator = function IndicatorSeparator(props) {
	  var className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      innerProps = props.innerProps;
	  return core.jsx("span", _extends({}, innerProps, {
	    css: getStyles('indicatorSeparator', props),
	    className: cx({
	      'indicator-separator': true
	    }, className)
	  }));
	}; // ==============================
	// Loading
	// ==============================
	
	
	var loadingDotAnimations = core.keyframes(_templateObject());
	
	var loadingIndicatorCSS = function loadingIndicatorCSS(_ref5) {
	  var isFocused = _ref5.isFocused,
	      size = _ref5.size,
	      _ref5$theme = _ref5.theme,
	      colors = _ref5$theme.colors,
	      baseUnit = _ref5$theme.spacing.baseUnit;
	  return {
	    label: 'loadingIndicator',
	    color: isFocused ? colors.neutral60 : colors.neutral20,
	    display: 'flex',
	    padding: baseUnit * 2,
	    transition: 'color 150ms',
	    alignSelf: 'center',
	    fontSize: size,
	    lineHeight: 1,
	    marginRight: size,
	    textAlign: 'center',
	    verticalAlign: 'middle'
	  };
	};
	
	var LoadingDot = function LoadingDot(_ref6) {
	  var delay = _ref6.delay,
	      offset = _ref6.offset;
	  return core.jsx("span", {
	    css:
	    /*#__PURE__*/
	    _css({
	      animation: "".concat(loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
	      backgroundColor: 'currentColor',
	      borderRadius: '1em',
	      display: 'inline-block',
	      marginLeft: offset ? '1em' : null,
	      height: '1em',
	      verticalAlign: 'top',
	      width: '1em'
	    },  true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
	  });
	};
	
	var LoadingIndicator = function LoadingIndicator(props) {
	  var className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      innerProps = props.innerProps,
	      isRtl = props.isRtl;
	  return core.jsx("div", _extends({}, innerProps, {
	    css: getStyles('loadingIndicator', props),
	    className: cx({
	      indicator: true,
	      'loading-indicator': true
	    }, className)
	  }), core.jsx(LoadingDot, {
	    delay: 0,
	    offset: isRtl
	  }), core.jsx(LoadingDot, {
	    delay: 160,
	    offset: true
	  }), core.jsx(LoadingDot, {
	    delay: 320,
	    offset: !isRtl
	  }));
	};
	
	LoadingIndicator.defaultProps = {
	  size: 4
	};
	
	var css = function css(_ref) {
	  var isDisabled = _ref.isDisabled,
	      isFocused = _ref.isFocused,
	      _ref$theme = _ref.theme,
	      colors = _ref$theme.colors,
	      borderRadius = _ref$theme.borderRadius,
	      spacing = _ref$theme.spacing;
	  return {
	    label: 'control',
	    alignItems: 'center',
	    backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
	    borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
	    borderRadius: borderRadius,
	    borderStyle: 'solid',
	    borderWidth: 1,
	    boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : null,
	    cursor: 'default',
	    display: 'flex',
	    flexWrap: 'wrap',
	    justifyContent: 'space-between',
	    minHeight: spacing.controlHeight,
	    outline: '0 !important',
	    position: 'relative',
	    transition: 'all 100ms',
	    '&:hover': {
	      borderColor: isFocused ? colors.primary : colors.neutral30
	    }
	  };
	};
	
	var Control = function Control(props) {
	  var children = props.children,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      className = props.className,
	      isDisabled = props.isDisabled,
	      isFocused = props.isFocused,
	      innerRef = props.innerRef,
	      innerProps = props.innerProps,
	      menuIsOpen = props.menuIsOpen;
	  return core.jsx("div", _extends({
	    ref: innerRef,
	    css: getStyles('control', props),
	    className: cx({
	      control: true,
	      'control--is-disabled': isDisabled,
	      'control--is-focused': isFocused,
	      'control--menu-is-open': menuIsOpen
	    }, className)
	  }, innerProps), children);
	};
	
	var groupCSS = function groupCSS(_ref) {
	  var spacing = _ref.theme.spacing;
	  return {
	    paddingBottom: spacing.baseUnit * 2,
	    paddingTop: spacing.baseUnit * 2
	  };
	};
	
	var Group = function Group(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      Heading = props.Heading,
	      headingProps = props.headingProps,
	      label = props.label,
	      theme = props.theme,
	      selectProps = props.selectProps;
	  return core.jsx("div", {
	    css: getStyles('group', props),
	    className: cx({
	      group: true
	    }, className)
	  }, core.jsx(Heading, _extends({}, headingProps, {
	    selectProps: selectProps,
	    theme: theme,
	    getStyles: getStyles,
	    cx: cx
	  }), label), core.jsx("div", null, children));
	};
	
	var groupHeadingCSS = function groupHeadingCSS(_ref2) {
	  var spacing = _ref2.theme.spacing;
	  return {
	    label: 'group',
	    color: '#999',
	    cursor: 'default',
	    display: 'block',
	    fontSize: '75%',
	    fontWeight: '500',
	    marginBottom: '0.25em',
	    paddingLeft: spacing.baseUnit * 3,
	    paddingRight: spacing.baseUnit * 3,
	    textTransform: 'uppercase'
	  };
	};
	
	var GroupHeading = function GroupHeading(props) {
	  var className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      theme = props.theme,
	      selectProps = props.selectProps,
	      cleanProps = _objectWithoutProperties(props, ["className", "cx", "getStyles", "theme", "selectProps"]);
	
	  return core.jsx("div", _extends({
	    css: getStyles('groupHeading', _objectSpread({
	      theme: theme
	    }, cleanProps)),
	    className: cx({
	      'group-heading': true
	    }, className)
	  }, cleanProps));
	};
	
	var inputCSS = function inputCSS(_ref) {
	  var isDisabled = _ref.isDisabled,
	      _ref$theme = _ref.theme,
	      spacing = _ref$theme.spacing,
	      colors = _ref$theme.colors;
	  return {
	    margin: spacing.baseUnit / 2,
	    paddingBottom: spacing.baseUnit / 2,
	    paddingTop: spacing.baseUnit / 2,
	    visibility: isDisabled ? 'hidden' : 'visible',
	    color: colors.neutral80
	  };
	};
	
	var inputStyle = function inputStyle(isHidden) {
	  return {
	    label: 'input',
	    background: 0,
	    border: 0,
	    fontSize: 'inherit',
	    opacity: isHidden ? 0 : 1,
	    outline: 0,
	    padding: 0,
	    color: 'inherit'
	  };
	};
	
	var Input = function Input(_ref2) {
	  var className = _ref2.className,
	      cx = _ref2.cx,
	      getStyles = _ref2.getStyles,
	      innerRef = _ref2.innerRef,
	      isHidden = _ref2.isHidden,
	      isDisabled = _ref2.isDisabled,
	      theme = _ref2.theme,
	      selectProps = _ref2.selectProps,
	      props = _objectWithoutProperties(_ref2, ["className", "cx", "getStyles", "innerRef", "isHidden", "isDisabled", "theme", "selectProps"]);
	
	  return core.jsx("div", {
	    css: getStyles('input', _objectSpread({
	      theme: theme
	    }, props))
	  }, core.jsx(AutosizeInput, _extends({
	    className: cx({
	      input: true
	    }, className),
	    inputRef: innerRef,
	    inputStyle: inputStyle(isHidden),
	    disabled: isDisabled
	  }, props)));
	};
	
	var multiValueCSS = function multiValueCSS(_ref) {
	  var _ref$theme = _ref.theme,
	      spacing = _ref$theme.spacing,
	      borderRadius = _ref$theme.borderRadius,
	      colors = _ref$theme.colors;
	  return {
	    label: 'multiValue',
	    backgroundColor: colors.neutral10,
	    borderRadius: borderRadius / 2,
	    display: 'flex',
	    margin: spacing.baseUnit / 2,
	    minWidth: 0 // resolves flex/text-overflow bug
	
	  };
	};
	
	var multiValueLabelCSS = function multiValueLabelCSS(_ref2) {
	  var _ref2$theme = _ref2.theme,
	      borderRadius = _ref2$theme.borderRadius,
	      colors = _ref2$theme.colors,
	      cropWithEllipsis = _ref2.cropWithEllipsis;
	  return {
	    borderRadius: borderRadius / 2,
	    color: colors.neutral80,
	    fontSize: '85%',
	    overflow: 'hidden',
	    padding: 3,
	    paddingLeft: 6,
	    textOverflow: cropWithEllipsis ? 'ellipsis' : null,
	    whiteSpace: 'nowrap'
	  };
	};
	
	var multiValueRemoveCSS = function multiValueRemoveCSS(_ref3) {
	  var _ref3$theme = _ref3.theme,
	      spacing = _ref3$theme.spacing,
	      borderRadius = _ref3$theme.borderRadius,
	      colors = _ref3$theme.colors,
	      isFocused = _ref3.isFocused;
	  return {
	    alignItems: 'center',
	    borderRadius: borderRadius / 2,
	    backgroundColor: isFocused && colors.dangerLight,
	    display: 'flex',
	    paddingLeft: spacing.baseUnit,
	    paddingRight: spacing.baseUnit,
	    ':hover': {
	      backgroundColor: colors.dangerLight,
	      color: colors.danger
	    }
	  };
	};
	
	var MultiValueGeneric = function MultiValueGeneric(_ref4) {
	  var children = _ref4.children,
	      innerProps = _ref4.innerProps;
	  return core.jsx("div", innerProps, children);
	};
	
	var MultiValueContainer = MultiValueGeneric;
	var MultiValueLabel = MultiValueGeneric;
	
	var MultiValueRemove =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(MultiValueRemove, _Component);
	
	  function MultiValueRemove() {
	    _classCallCheck(this, MultiValueRemove);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(MultiValueRemove).apply(this, arguments));
	  }
	
	  _createClass(MultiValueRemove, [{
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          children = _this$props.children,
	          innerProps = _this$props.innerProps;
	      return core.jsx("div", innerProps, children || core.jsx(CrossIcon, {
	        size: 14
	      }));
	    }
	  }]);
	
	  return MultiValueRemove;
	}(React.Component);
	
	var MultiValue =
	/*#__PURE__*/
	function (_Component2) {
	  _inherits(MultiValue, _Component2);
	
	  function MultiValue() {
	    _classCallCheck(this, MultiValue);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(MultiValue).apply(this, arguments));
	  }
	
	  _createClass(MultiValue, [{
	    key: "render",
	    value: function render() {
	      var _this = this;
	
	      var _this$props2 = this.props,
	          children = _this$props2.children,
	          className = _this$props2.className,
	          components = _this$props2.components,
	          cx = _this$props2.cx,
	          data = _this$props2.data,
	          getStyles = _this$props2.getStyles,
	          innerProps = _this$props2.innerProps,
	          isDisabled = _this$props2.isDisabled,
	          removeProps = _this$props2.removeProps,
	          selectProps = _this$props2.selectProps;
	      var Container = components.Container,
	          Label = components.Label,
	          Remove = components.Remove;
	      return core.jsx(core.ClassNames, null, function (_ref5) {
	        var css = _ref5.css,
	            emotionCx = _ref5.cx;
	        return core.jsx(Container, {
	          data: data,
	          innerProps: _objectSpread({}, innerProps, {
	            className: emotionCx(css(getStyles('multiValue', _this.props)), cx({
	              'multi-value': true,
	              'multi-value--is-disabled': isDisabled
	            }, className))
	          }),
	          selectProps: selectProps
	        }, core.jsx(Label, {
	          data: data,
	          innerProps: {
	            className: emotionCx(css(getStyles('multiValueLabel', _this.props)), cx({
	              'multi-value__label': true
	            }, className))
	          },
	          selectProps: selectProps
	        }, children), core.jsx(Remove, {
	          data: data,
	          innerProps: _objectSpread({
	            className: emotionCx(css(getStyles('multiValueRemove', _this.props)), cx({
	              'multi-value__remove': true
	            }, className))
	          }, removeProps),
	          selectProps: selectProps
	        }));
	      });
	    }
	  }]);
	
	  return MultiValue;
	}(React.Component);
	
	_defineProperty(MultiValue, "defaultProps", {
	  cropWithEllipsis: true
	});
	
	var optionCSS = function optionCSS(_ref) {
	  var isDisabled = _ref.isDisabled,
	      isFocused = _ref.isFocused,
	      isSelected = _ref.isSelected,
	      _ref$theme = _ref.theme,
	      spacing = _ref$theme.spacing,
	      colors = _ref$theme.colors;
	  return {
	    label: 'option',
	    backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
	    color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
	    cursor: 'default',
	    display: 'block',
	    fontSize: 'inherit',
	    padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
	    width: '100%',
	    userSelect: 'none',
	    WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
	    // provide some affordance on touch devices
	    ':active': {
	      backgroundColor: !isDisabled && (isSelected ? colors.primary : colors.primary50)
	    }
	  };
	};
	
	var Option = function Option(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      isDisabled = props.isDisabled,
	      isFocused = props.isFocused,
	      isSelected = props.isSelected,
	      innerRef = props.innerRef,
	      innerProps = props.innerProps;
	  return core.jsx("div", _extends({
	    css: getStyles('option', props),
	    className: cx({
	      option: true,
	      'option--is-disabled': isDisabled,
	      'option--is-focused': isFocused,
	      'option--is-selected': isSelected
	    }, className),
	    ref: innerRef
	  }, innerProps), children);
	};
	
	var placeholderCSS = function placeholderCSS(_ref) {
	  var _ref$theme = _ref.theme,
	      spacing = _ref$theme.spacing,
	      colors = _ref$theme.colors;
	  return {
	    label: 'placeholder',
	    color: colors.neutral50,
	    marginLeft: spacing.baseUnit / 2,
	    marginRight: spacing.baseUnit / 2,
	    position: 'absolute',
	    top: '50%',
	    transform: 'translateY(-50%)'
	  };
	};
	
	var Placeholder = function Placeholder(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      innerProps = props.innerProps;
	  return core.jsx("div", _extends({
	    css: getStyles('placeholder', props),
	    className: cx({
	      placeholder: true
	    }, className)
	  }, innerProps), children);
	};
	
	var css$1 = function css(_ref) {
	  var isDisabled = _ref.isDisabled,
	      _ref$theme = _ref.theme,
	      spacing = _ref$theme.spacing,
	      colors = _ref$theme.colors;
	  return {
	    label: 'singleValue',
	    color: isDisabled ? colors.neutral40 : colors.neutral80,
	    marginLeft: spacing.baseUnit / 2,
	    marginRight: spacing.baseUnit / 2,
	    maxWidth: "calc(100% - ".concat(spacing.baseUnit * 2, "px)"),
	    overflow: 'hidden',
	    position: 'absolute',
	    textOverflow: 'ellipsis',
	    whiteSpace: 'nowrap',
	    top: '50%',
	    transform: 'translateY(-50%)'
	  };
	};
	
	var SingleValue = function SingleValue(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      isDisabled = props.isDisabled,
	      innerProps = props.innerProps;
	  return core.jsx("div", _extends({
	    css: getStyles('singleValue', props),
	    className: cx({
	      'single-value': true,
	      'single-value--is-disabled': isDisabled
	    }, className)
	  }, innerProps), children);
	};
	
	var components = {
	  ClearIndicator: ClearIndicator,
	  Control: Control,
	  DropdownIndicator: DropdownIndicator,
	  DownChevron: DownChevron,
	  CrossIcon: CrossIcon,
	  Group: Group,
	  GroupHeading: GroupHeading,
	  IndicatorsContainer: IndicatorsContainer,
	  IndicatorSeparator: IndicatorSeparator,
	  Input: Input,
	  LoadingIndicator: LoadingIndicator,
	  Menu: Menu,
	  MenuList: MenuList,
	  MenuPortal: MenuPortal,
	  LoadingMessage: LoadingMessage,
	  NoOptionsMessage: NoOptionsMessage,
	  MultiValue: MultiValue,
	  MultiValueContainer: MultiValueContainer,
	  MultiValueLabel: MultiValueLabel,
	  MultiValueRemove: MultiValueRemove,
	  Option: Option,
	  Placeholder: Placeholder,
	  SelectContainer: SelectContainer,
	  SingleValue: SingleValue,
	  ValueContainer: ValueContainer
	};
	
	var defaultComponents = function defaultComponents(props) {
	  return _objectSpread({}, components, props.components);
	};
	
	exports.MenuPlacer = MenuPlacer;
	exports.clearIndicatorCSS = clearIndicatorCSS;
	exports.components = components;
	exports.containerCSS = containerCSS;
	exports.css = css;
	exports.css$1 = css$1;
	exports.defaultComponents = defaultComponents;
	exports.dropdownIndicatorCSS = dropdownIndicatorCSS;
	exports.exportedEqual = exportedEqual;
	exports.groupCSS = groupCSS;
	exports.groupHeadingCSS = groupHeadingCSS;
	exports.indicatorSeparatorCSS = indicatorSeparatorCSS;
	exports.indicatorsContainerCSS = indicatorsContainerCSS;
	exports.inputCSS = inputCSS;
	exports.loadingIndicatorCSS = loadingIndicatorCSS;
	exports.loadingMessageCSS = loadingMessageCSS;
	exports.menuCSS = menuCSS;
	exports.menuListCSS = menuListCSS;
	exports.menuPortalCSS = menuPortalCSS;
	exports.multiValueCSS = multiValueCSS;
	exports.multiValueLabelCSS = multiValueLabelCSS;
	exports.multiValueRemoveCSS = multiValueRemoveCSS;
	exports.noOptionsMessageCSS = noOptionsMessageCSS;
	exports.optionCSS = optionCSS;
	exports.placeholderCSS = placeholderCSS;
	exports.valueContainerCSS = valueContainerCSS;


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	!function(e,t){ true?module.exports=t(__webpack_require__(2),__webpack_require__(17)):"function"==typeof define&&define.amd?define("lib",["react","react-dom"],t):"object"==typeof exports?exports.lib=t(require("react"),require("react-dom")):e.lib=t(e.react,e["react-dom"])}("undefined"!=typeof self?self:this,function(n,r){return a={},o.m=i=[function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.useReactToPrint=t.PrintContextConsumer=void 0;var r=n(1),i=n(2),a=n(3),o=i.hasOwnProperty("createContext"),u=i.hasOwnProperty("useMemo")&&i.hasOwnProperty("useCallback"),l=o?i.createContext({}):null;t.PrintContextConsumer=l?l.Consumer:function(){return null};var c,s={copyStyles:!0,pageStyle:"@page { size: auto;  margin: 0mm; } @media print { body { -webkit-print-color-adjust: exact; } }",removeAfterPrint:!1,suppressErrors:!1},f=(c=i.Component,r.__extends(d,c),d.prototype.render=function(){var e=this.props,t=e.children,n=e.suppressErrors,r=e.trigger;if(r)return i.cloneElement(r(),{onClick:this.handleClick});var o={handlePrint:this.handleClick};return l?l?i.createElement(l.Provider,{value:o},t):i.createElement("h2",null,"lorem"):(n||console.error('"react-to-print" requires React ^16.3.0 to be able to use "PrintContext"'),null)},d.defaultProps=s,d);function d(){var E=null!==c&&c.apply(this,arguments)||this;return E.startPrint=function(n){var e=E.props,r=e.onAfterPrint,o=e.removeAfterPrint,i=e.suppressErrors,a=e.documentTitle;setTimeout(function(){if(n.contentWindow){if(n.contentWindow.focus(),n.contentWindow.print){var e=document.title;a&&(document.title=a),n.contentWindow.print(),a&&(document.title=e),r&&r()}else i||console.error("Printing for this browser is not currently possible: the browser does not have a `print` method available for iframes.");if(o){var t=document.getElementById("printWindow");t&&document.body.removeChild(t)}}else i||console.error("Printing failed because the `contentWindow` of the print iframe did not load. This is possibly an error with `react-to-print`. Please file an issue: https://github.com/gregnb/react-to-print/issues/")},500)},E.triggerPrint=function(e){var t=E.props,n=t.onBeforePrint,r=t.onPrintError;if(n){var o=n();o&&"function"==typeof o.then?o.then(function(){E.startPrint(e)}).catch(function(e){r&&r("onBeforePrint",e)}):E.startPrint(e)}else E.startPrint(e)},E.handleClick=function(){var e=E.props,t=e.onBeforeGetContent,n=e.onPrintError;if(t){var r=t();r&&"function"==typeof r.then?r.then(E.handlePrint).catch(function(e){n&&n("onBeforeGetContent",e)}):E.handlePrint()}else E.handlePrint()},E.handlePrint=function(){var e=E.props,P=e.bodyClass,t=e.content,x=e.copyStyles,O=e.pageStyle,S=e.suppressErrors,n=t();if(void 0!==n)if(null!==n){var k=document.createElement("iframe");k.style.position="absolute",k.style.top="-1000px",k.style.left="-1000px",k.id="printWindow",k.title="Print Window";var j=a.findDOMNode(n);if(j){var r=document.querySelectorAll("link[rel='stylesheet']"),C=j.querySelectorAll("img");E.linkTotal=r.length+C.length,E.linksLoaded=[],E.linksErrored=[];var T=function(e,t){t?E.linksLoaded.push(e):(S||console.error('"react-to-print" was unable to load a linked node. It may be invalid. "react-to-print" will continue attempting to print the page. The linked node that errored was:',e),E.linksErrored.push(e)),E.linksLoaded.length+E.linksErrored.length===E.linkTotal&&E.triggerPrint(k)};k.onload=function(){var e;k.onload=null;var t=k.contentDocument||(null===(e=k.contentWindow)||void 0===e?void 0:e.document),n=j.querySelectorAll("canvas");if(t){t.open(),t.write(j.outerHTML),t.close();var r="function"==typeof O?O():O,o=t.createElement("style");o.appendChild(t.createTextNode(r)),t.head.appendChild(o),P&&t.body.classList.add(P);for(var i=t.querySelectorAll("canvas"),a=0,u=i.length;a<u;++a){var l=(y=i[a]).getContext("2d");l&&l.drawImage(n[a],0,0)}for(a=0;a<C.length;a++){var c=C[a],s=c.getAttribute("src");if(s){var f=new Image;f.onload=T.bind(null,c,!0),f.onerror=T.bind(null,c,!1),f.src=s}else S||console.warn('"react-to-print" encountered an <img> tag with an empty "src" attribute. It will not attempt to pre-load it. The <img> is:',c)}if(x)for(var d=document.querySelectorAll("style, link[rel='stylesheet']"),p=(a=0,d.length);a<p;++a){var y;if("STYLE"===(y=d[a]).tagName){var h=t.createElement(y.tagName),b=y.sheet;if(b){for(var v="",m=0,g=b.cssRules.length;m<g;++m)"string"==typeof b.cssRules[m].cssText&&(v+=b.cssRules[m].cssText+"\r\n");h.setAttribute("id","react-to-print-"+a),h.appendChild(t.createTextNode(v)),t.head.appendChild(h)}}else if(y.getAttribute("href")){h=t.createElement(y.tagName),m=0;for(var w=y.attributes.length;m<w;++m){var _=y.attributes[m];_&&h.setAttribute(_.nodeName,_.nodeValue||"")}h.onload=T.bind(null,h,!0),h.onerror=T.bind(null,h,!1),t.head.appendChild(h)}else S||console.warn('"react-to-print" encountered a <link> tag with an empty "href" attribute. In addition to being invalid HTML, this can cause problems in many browsers, and so the <link> was not loaded. The <link> is:',y),T(y,!0)}}0!==E.linkTotal&&x||E.triggerPrint(k)};var o=document.getElementById("printWindow");o&&document.body.removeChild(o),document.body.appendChild(k)}else S||console.error('"react-to-print" could not locate the DOM node corresponding with the `content` prop')}else S||console.error('There is nothing to print because the "content" prop returned "null". Please ensure "content" is renderable before allowing "react-to-print" to be called.');else S||console.error('For "react-to-print" to work only Class based components can be printed.')},E}t.default=f,t.useReactToPrint=u?function(e){var t=i.useMemo(function(){return new f(r.__assign(r.__assign({},s),e))},[e]);return i.useCallback(function(){return t.handleClick()},[t])}:function(e){e.suppressErrors||console.warn('"react-to-print" requires React ^16.8.0 to be able to use "useReactToPrint"')}},function(e,t,n){"use strict";n.r(t),n.d(t,"__extends",function(){return o}),n.d(t,"__assign",function(){return i}),n.d(t,"__rest",function(){return a}),n.d(t,"__decorate",function(){return u}),n.d(t,"__param",function(){return l}),n.d(t,"__metadata",function(){return c}),n.d(t,"__awaiter",function(){return s}),n.d(t,"__generator",function(){return f}),n.d(t,"__exportStar",function(){return d}),n.d(t,"__values",function(){return p}),n.d(t,"__read",function(){return y}),n.d(t,"__spread",function(){return h}),n.d(t,"__spreadArrays",function(){return b}),n.d(t,"__await",function(){return v}),n.d(t,"__asyncGenerator",function(){return m}),n.d(t,"__asyncDelegator",function(){return g}),n.d(t,"__asyncValues",function(){return w}),n.d(t,"__makeTemplateObject",function(){return _}),n.d(t,"__importStar",function(){return P}),n.d(t,"__importDefault",function(){return x}),n.d(t,"__classPrivateFieldGet",function(){return O}),n.d(t,"__classPrivateFieldSet",function(){return S});var r=function(e,t){return(r=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)t.hasOwnProperty(n)&&(e[n]=t[n])})(e,t)};function o(e,t){function n(){this.constructor=e}r(e,t),e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)}var i=function(){return(i=Object.assign||function(e){for(var t,n=1,r=arguments.length;n<r;n++)for(var o in t=arguments[n])Object.prototype.hasOwnProperty.call(t,o)&&(e[o]=t[o]);return e}).apply(this,arguments)};function a(e,t){var n={};for(var r in e)Object.prototype.hasOwnProperty.call(e,r)&&t.indexOf(r)<0&&(n[r]=e[r]);if(null!=e&&"function"==typeof Object.getOwnPropertySymbols){var o=0;for(r=Object.getOwnPropertySymbols(e);o<r.length;o++)t.indexOf(r[o])<0&&Object.prototype.propertyIsEnumerable.call(e,r[o])&&(n[r[o]]=e[r[o]])}return n}function u(e,t,n,r){var o,i=arguments.length,a=i<3?t:null===r?r=Object.getOwnPropertyDescriptor(t,n):r;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)a=Reflect.decorate(e,t,n,r);else for(var u=e.length-1;0<=u;u--)(o=e[u])&&(a=(i<3?o(a):3<i?o(t,n,a):o(t,n))||a);return 3<i&&a&&Object.defineProperty(t,n,a),a}function l(n,r){return function(e,t){r(e,t,n)}}function c(e,t){if("object"==typeof Reflect&&"function"==typeof Reflect.metadata)return Reflect.metadata(e,t)}function s(e,a,u,l){return new(u=u||Promise)(function(n,t){function r(e){try{i(l.next(e))}catch(e){t(e)}}function o(e){try{i(l.throw(e))}catch(e){t(e)}}function i(e){var t;e.done?n(e.value):((t=e.value)instanceof u?t:new u(function(e){e(t)})).then(r,o)}i((l=l.apply(e,a||[])).next())})}function f(n,r){var o,i,a,e,u={label:0,sent:function(){if(1&a[0])throw a[1];return a[1]},trys:[],ops:[]};return e={next:t(0),throw:t(1),return:t(2)},"function"==typeof Symbol&&(e[Symbol.iterator]=function(){return this}),e;function t(t){return function(e){return function(t){if(o)throw new TypeError("Generator is already executing.");for(;u;)try{if(o=1,i&&(a=2&t[0]?i.return:t[0]?i.throw||((a=i.return)&&a.call(i),0):i.next)&&!(a=a.call(i,t[1])).done)return a;switch(i=0,a&&(t=[2&t[0],a.value]),t[0]){case 0:case 1:a=t;break;case 4:return u.label++,{value:t[1],done:!1};case 5:u.label++,i=t[1],t=[0];continue;case 7:t=u.ops.pop(),u.trys.pop();continue;default:if(!(a=0<(a=u.trys).length&&a[a.length-1])&&(6===t[0]||2===t[0])){u=0;continue}if(3===t[0]&&(!a||t[1]>a[0]&&t[1]<a[3])){u.label=t[1];break}if(6===t[0]&&u.label<a[1]){u.label=a[1],a=t;break}if(a&&u.label<a[2]){u.label=a[2],u.ops.push(t);break}a[2]&&u.ops.pop(),u.trys.pop();continue}t=r.call(n,u)}catch(e){t=[6,e],i=0}finally{o=a=0}if(5&t[0])throw t[1];return{value:t[0]?t[1]:void 0,done:!0}}([t,e])}}}function d(e,t){for(var n in e)t.hasOwnProperty(n)||(t[n]=e[n])}function p(e){var t="function"==typeof Symbol&&Symbol.iterator,n=t&&e[t],r=0;if(n)return n.call(e);if(e&&"number"==typeof e.length)return{next:function(){return e&&r>=e.length&&(e=void 0),{value:e&&e[r++],done:!e}}};throw new TypeError(t?"Object is not iterable.":"Symbol.iterator is not defined.")}function y(e,t){var n="function"==typeof Symbol&&e[Symbol.iterator];if(!n)return e;var r,o,i=n.call(e),a=[];try{for(;(void 0===t||0<t--)&&!(r=i.next()).done;)a.push(r.value)}catch(e){o={error:e}}finally{try{r&&!r.done&&(n=i.return)&&n.call(i)}finally{if(o)throw o.error}}return a}function h(){for(var e=[],t=0;t<arguments.length;t++)e=e.concat(y(arguments[t]));return e}function b(){for(var e=0,t=0,n=arguments.length;t<n;t++)e+=arguments[t].length;var r=Array(e),o=0;for(t=0;t<n;t++)for(var i=arguments[t],a=0,u=i.length;a<u;a++,o++)r[o]=i[a];return r}function v(e){return this instanceof v?(this.v=e,this):new v(e)}function m(e,t,n){if(!Symbol.asyncIterator)throw new TypeError("Symbol.asyncIterator is not defined.");var o,i=n.apply(e,t||[]),a=[];return o={},r("next"),r("throw"),r("return"),o[Symbol.asyncIterator]=function(){return this},o;function r(r){i[r]&&(o[r]=function(n){return new Promise(function(e,t){1<a.push([r,n,e,t])||u(r,n)})})}function u(e,t){try{(n=i[e](t)).value instanceof v?Promise.resolve(n.value.v).then(l,c):s(a[0][2],n)}catch(e){s(a[0][3],e)}var n}function l(e){u("next",e)}function c(e){u("throw",e)}function s(e,t){e(t),a.shift(),a.length&&u(a[0][0],a[0][1])}}function g(r){var e,o;return e={},t("next"),t("throw",function(e){throw e}),t("return"),e[Symbol.iterator]=function(){return this},e;function t(t,n){e[t]=r[t]?function(e){return(o=!o)?{value:v(r[t](e)),done:"return"===t}:n?n(e):e}:n}}function w(l){if(!Symbol.asyncIterator)throw new TypeError("Symbol.asyncIterator is not defined.");var e,t=l[Symbol.asyncIterator];return t?t.call(l):(l=p(l),e={},n("next"),n("throw"),n("return"),e[Symbol.asyncIterator]=function(){return this},e);function n(u){e[u]=l[u]&&function(a){return new Promise(function(e,t){var n,r,o,i;a=l[u](a),n=e,r=t,o=a.done,i=a.value,Promise.resolve(i).then(function(e){n({value:e,done:o})},r)})}}}function _(e,t){return Object.defineProperty?Object.defineProperty(e,"raw",{value:t}):e.raw=t,e}function P(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var n in e)Object.hasOwnProperty.call(e,n)&&(t[n]=e[n]);return t.default=e,t}function x(e){return e&&e.__esModule?e:{default:e}}function O(e,t){if(!t.has(e))throw new TypeError("attempted to get private field on non-instance");return t.get(e)}function S(e,t,n){if(!t.has(e))throw new TypeError("attempted to set private field on non-instance");return t.set(e,n),n}},function(e,t){e.exports=n},function(e,t){e.exports=r}],o.c=a,o.d=function(e,t,n){o.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:n})},o.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},o.t=function(t,e){if(1&e&&(t=o(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var n=Object.create(null);if(o.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var r in t)o.d(n,r,function(e){return t[e]}.bind(null,r));return n},o.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return o.d(t,"a",t),t},o.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},o.p="",o(o.s=0);function o(e){if(a[e])return a[e].exports;var t=a[e]={i:e,l:!1,exports:{}};return i[e].call(t.exports,t,t.exports,o),t.l=!0,t.exports}var i,a});

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(1));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _fastDeepEqual = _interopRequireDefault(__webpack_require__(500));
	
	var _youtubePlayer = _interopRequireDefault(__webpack_require__(934));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/**
	 * Check whether a `props` change should result in the video being updated.
	 *
	 * @param {Object} prevProps
	 * @param {Object} props
	 */
	function shouldUpdateVideo(prevProps, props) {
	  // A changing video should always trigger an update
	  if (prevProps.videoId !== props.videoId) {
	    return true;
	  } // Otherwise, a change in the start/end time playerVars also requires a player
	  // update.
	
	
	  var prevVars = prevProps.opts.playerVars || {};
	  var vars = props.opts.playerVars || {};
	  return prevVars.start !== vars.start || prevVars.end !== vars.end;
	}
	/**
	 * Neutralize API options that only require a video update, leaving only options
	 * that require a player reset. The results can then be compared to see if a
	 * player reset is necessary.
	 *
	 * @param {Object} opts
	 */
	
	
	function filterResetOptions(opts) {
	  return _objectSpread({}, opts, {
	    playerVars: _objectSpread({}, opts.playerVars, {
	      autoplay: 0,
	      start: 0,
	      end: 0
	    })
	  });
	}
	/**
	 * Check whether a `props` change should result in the player being reset.
	 * The player is reset when the `props.opts` change, except if the only change
	 * is in the `start` and `end` playerVars, because a video update can deal with
	 * those.
	 *
	 * @param {Object} prevProps
	 * @param {Object} props
	 */
	
	
	function shouldResetPlayer(prevProps, props) {
	  return !(0, _fastDeepEqual.default)(filterResetOptions(prevProps.opts), filterResetOptions(props.opts));
	}
	/**
	 * Check whether a props change should result in an id or className update.
	 *
	 * @param {Object} prevProps
	 * @param {Object} props
	 */
	
	
	function shouldUpdatePlayer(prevProps, props) {
	  return prevProps.id !== props.id || prevProps.className !== props.className;
	}
	
	var YouTube = /*#__PURE__*/function (_React$Component) {
	  _inherits(YouTube, _React$Component);
	
	  var _super = _createSuper(YouTube);
	
	  /**
	   * Expose PlayerState constants for convenience. These constants can also be
	   * accessed through the global YT object after the YouTube IFrame API is instantiated.
	   * https://developers.google.com/youtube/iframe_api_reference#onStateChange
	   */
	  function YouTube(props) {
	    var _this;
	
	    _classCallCheck(this, YouTube);
	
	    _this = _super.call(this, props);
	
	    _defineProperty(_assertThisInitialized(_this), "onPlayerReady", function (event) {
	      return _this.props.onReady(event);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onPlayerError", function (event) {
	      return _this.props.onError(event);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onPlayerStateChange", function (event) {
	      _this.props.onStateChange(event);
	
	      switch (event.data) {
	        case YouTube.PlayerState.ENDED:
	          _this.props.onEnd(event);
	
	          break;
	
	        case YouTube.PlayerState.PLAYING:
	          _this.props.onPlay(event);
	
	          break;
	
	        case YouTube.PlayerState.PAUSED:
	          _this.props.onPause(event);
	
	          break;
	
	        default:
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onPlayerPlaybackRateChange", function (event) {
	      return _this.props.onPlaybackRateChange(event);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onPlayerPlaybackQualityChange", function (event) {
	      return _this.props.onPlaybackQualityChange(event);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "createPlayer", function () {
	      // do not attempt to create a player server-side, it won't work
	      if (typeof document === 'undefined') return; // create player
	
	      var playerOpts = _objectSpread({}, _this.props.opts, {
	        // preload the `videoId` video if one is already given
	        videoId: _this.props.videoId
	      });
	
	      _this.internalPlayer = (0, _youtubePlayer.default)(_this.container, playerOpts); // attach event handlers
	
	      _this.internalPlayer.on('ready', _this.onPlayerReady);
	
	      _this.internalPlayer.on('error', _this.onPlayerError);
	
	      _this.internalPlayer.on('stateChange', _this.onPlayerStateChange);
	
	      _this.internalPlayer.on('playbackRateChange', _this.onPlayerPlaybackRateChange);
	
	      _this.internalPlayer.on('playbackQualityChange', _this.onPlayerPlaybackQualityChange);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "resetPlayer", function () {
	      return _this.internalPlayer.destroy().then(_this.createPlayer);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "updatePlayer", function () {
	      _this.internalPlayer.getIframe().then(function (iframe) {
	        if (_this.props.id) iframe.setAttribute('id', _this.props.id);else iframe.removeAttribute('id');
	        if (_this.props.className) iframe.setAttribute('class', _this.props.className);else iframe.removeAttribute('class');
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "updateVideo", function () {
	      if (typeof _this.props.videoId === 'undefined' || _this.props.videoId === null) {
	        _this.internalPlayer.stopVideo();
	
	        return;
	      } // set queueing options
	
	
	      var autoplay = false;
	      var opts = {
	        videoId: _this.props.videoId
	      };
	
	      if ('playerVars' in _this.props.opts) {
	        autoplay = _this.props.opts.playerVars.autoplay === 1;
	
	        if ('start' in _this.props.opts.playerVars) {
	          opts.startSeconds = _this.props.opts.playerVars.start;
	        }
	
	        if ('end' in _this.props.opts.playerVars) {
	          opts.endSeconds = _this.props.opts.playerVars.end;
	        }
	      } // if autoplay is enabled loadVideoById
	
	
	      if (autoplay) {
	        _this.internalPlayer.loadVideoById(opts);
	
	        return;
	      } // default behaviour just cues the video
	
	
	      _this.internalPlayer.cueVideoById(opts);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "refContainer", function (container) {
	      _this.container = container;
	    });
	
	    _this.container = null;
	    _this.internalPlayer = null;
	    return _this;
	  }
	
	  _createClass(YouTube, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.createPlayer();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      if (shouldUpdatePlayer(prevProps, this.props)) {
	        this.updatePlayer();
	      }
	
	      if (shouldResetPlayer(prevProps, this.props)) {
	        this.resetPlayer();
	      }
	
	      if (shouldUpdateVideo(prevProps, this.props)) {
	        this.updateVideo();
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      /**
	       * Note: The `youtube-player` package that is used promisifies all YouTube
	       * Player API calls, which introduces a delay of a tick before it actually
	       * gets destroyed. Since React attempts to remove the element instantly
	       * this method isn't quick enough to reset the container element.
	       */
	      this.internalPlayer.destroy();
	    }
	    /**
	     * https://developers.google.com/youtube/iframe_api_reference#onReady
	     *
	     * @param {Object} event
	     *   @param {Object} target - player object
	     */
	
	  }, {
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/_react.default.createElement("div", {
	        className: this.props.containerClassName
	      }, /*#__PURE__*/_react.default.createElement("div", {
	        id: this.props.id,
	        className: this.props.className,
	        ref: this.refContainer
	      }));
	    }
	  }]);
	
	  return YouTube;
	}(_react.default.Component);
	
	_defineProperty(YouTube, "PlayerState", {
	  UNSTARTED: -1,
	  ENDED: 0,
	  PLAYING: 1,
	  PAUSED: 2,
	  BUFFERING: 3,
	  CUED: 5
	});
	
	YouTube.propTypes = {
	  videoId: _propTypes.default.string,
	  // custom ID for player element
	  id: _propTypes.default.string,
	  // custom class name for player element
	  className: _propTypes.default.string,
	  // custom class name for player container element
	  containerClassName: _propTypes.default.string,
	  // https://developers.google.com/youtube/iframe_api_reference#Loading_a_Video_Player
	  opts: _propTypes.default.objectOf(_propTypes.default.any),
	  // event subscriptions
	  onReady: _propTypes.default.func,
	  onError: _propTypes.default.func,
	  onPlay: _propTypes.default.func,
	  onPause: _propTypes.default.func,
	  onEnd: _propTypes.default.func,
	  onStateChange: _propTypes.default.func,
	  onPlaybackRateChange: _propTypes.default.func,
	  onPlaybackQualityChange: _propTypes.default.func
	};
	YouTube.defaultProps = {
	  videoId: null,
	  id: null,
	  className: null,
	  opts: {},
	  containerClassName: '',
	  onReady: function onReady() {},
	  onError: function onError() {},
	  onPlay: function onPlay() {},
	  onPause: function onPause() {},
	  onEnd: function onEnd() {},
	  onStateChange: function onStateChange() {},
	  onPlaybackRateChange: function onPlaybackRateChange() {},
	  onPlaybackQualityChange: function onPlaybackQualityChange() {}
	};
	var _default = YouTube;
	exports.default = _default;


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactackleCore = __webpack_require__(3);
	
	var _styles = __webpack_require__(510);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  /**
	   * Item id
	   */
	  id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  /**
	   * Item title
	   */
	  title: _propTypes2.default.string,
	  /**
	   * Show/hide item's content
	   */
	  expanded: _propTypes2.default.bool,
	  /**
	   * Removes content paddings
	   */
	  contentBlank: _propTypes2.default.bool,
	  /**
	   * Adds additional content slot to the item's header
	   */
	  headerSlot: _propTypes2.default.node,
	  /**
	   * Function to be called on title click
	   */
	  onToggleExpanded: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  // eslint-disable-next-line react/require-default-props
	  theme: _propTypes2.default.object
	};
	
	var defaultProps = {
	  id: null,
	  title: '',
	  expanded: false,
	  contentBlank: false,
	  onToggleExpanded: _reactackleCore.noop,
	  headerSlot: null
	};
	
	var AccordionItem = function (_Component) {
	  _inherits(AccordionItem, _Component);
	
	  function AccordionItem(props) {
	    _classCallCheck(this, AccordionItem);
	
	    var _this = _possibleConstructorReturn(this, (AccordionItem.__proto__ || Object.getPrototypeOf(AccordionItem)).call(this, props));
	
	    _this._handleClick = _this._handleClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(AccordionItem, [{
	    key: '_handleClick',
	    value: function _handleClick() {
	      this.props.onToggleExpanded({ id: this.props.id });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          expanded = _props.expanded,
	          contentBlank = _props.contentBlank;
	
	
	      var title = this.props.title && _react2.default.createElement(
	        _styles.TitleStyled,
	        { expanded: expanded },
	        this.props.title
	      );
	
	      var styleKey = expanded ? 'expanded' : 'collapsed';
	
	      return [_react2.default.createElement(
	        _styles.HeadingStyled,
	        { key: 'heading', role: 'heading' },
	        _react2.default.createElement(
	          _styles.TitleBoxStyled,
	          {
	            expanded: expanded,
	            onClick: this._handleClick,
	            role: 'button',
	            'aria-expanded': expanded,
	            'aria-controls': this.props.id,
	            id: 'labelfor' + this.props.id
	          },
	          _react2.default.createElement(
	            _styles.TitleContentStyled,
	            null,
	            title,
	            this.props.headerSlot
	          ),
	          _react2.default.createElement(
	            _styles.IconExpandWrapperStyled,
	            null,
	            _react2.default.createElement(
	              _styles.IconWrapperStyled,
	              { expanded: expanded },
	              this.props.theme.reactackle.components.accordion.item.expandIcon[styleKey].iconElement
	            )
	          )
	        )
	      ), _react2.default.createElement(
	        _styles.ContentStyled,
	        {
	          key: 'content',
	          expanded: expanded,
	          contentBlank: contentBlank,
	          id: this.props.id,
	          role: 'region',
	          'aria-labelledby': 'labelfor' + this.props.id
	        },
	        this.props.children
	      )];
	    }
	  }]);
	
	  return AccordionItem;
	}(_react.Component);
	
	AccordionItem.propTypes = propTypes;
	AccordionItem.defaultProps = defaultProps;
	AccordionItem.displayName = 'AccordionItem';
	
	exports.default = (0, _reactackleCore.withTheme)(AccordionItem);

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactackleCore = __webpack_require__(3);
	
	exports.default = (0, _reactackleCore.withExternalProps)(_reactackleCore.APP_CHANNEL);

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BreadcrumbsItem = undefined;
	
	var _BreadcrumbsItem = __webpack_require__(544);
	
	var _BreadcrumbsItem2 = _interopRequireDefault(_BreadcrumbsItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.BreadcrumbsItem = _BreadcrumbsItem2.default;

/***/ }),
/* 208 */
[944, 570],
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CardHeaderPrimaryStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  first: _propTypes2.default.bool,
	  last: _propTypes2.default.bool,
	  size: _propTypes2.default.oneOf(['default', 'medium', 'large', 'xlarge']),
	  theme: _propTypes2.default.object
	};
	
	var defaultProps = {
	  first: false,
	  last: false,
	  size: 'default'
	};
	
	/** Prop Receivers */
	var sizeProps = function sizeProps(_ref) {
	  var themeFromProvider = _ref.theme,
	      first = _ref.first,
	      last = _ref.last,
	      size = _ref.size;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var _theme$reactackle$com = theme.reactackle.components.card.headerPrimary.size[size],
	      paddingX = _theme$reactackle$com.paddingX,
	      paddingY = _theme$reactackle$com.paddingY,
	      paddingYLarge = _theme$reactackle$com.paddingYLarge,
	      similarElementsSpacing = _theme$reactackle$com.similarElementsSpacing;
	
	
	  return '\n    padding: ' + (0, _reactackleCore.getValueString)(paddingY) + ' ' + (0, _reactackleCore.getValueString)(paddingX) + ';\n    \n    ' + (first && 'padding-top: ' + (0, _reactackleCore.getValueString)(paddingYLarge) + ';') + '\n    ' + (last && 'padding-bottom: ' + (0, _reactackleCore.getValueString)(paddingYLarge) + ';') + '\n    \n    & + & {\n      padding-top: ' + (0, _reactackleCore.getValueString)(similarElementsSpacing) + ';\n    }\n  ';
	};
	
	/** Styles */
	var CardHeaderPrimaryStyled = exports.CardHeaderPrimaryStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'CardHeaderPrimaryStyled'
	})(['display:flex;', ';'], sizeProps);
	
	CardHeaderPrimaryStyled.propTypes = propTypes;
	CardHeaderPrimaryStyled.defaultProps = defaultProps;
	CardHeaderPrimaryStyled.displayName = 'CardHeaderPrimaryStyled';

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CheckboxLabelStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  disabled: _propTypes2.default.bool,
	  checked: _propTypes2.default.bool,
	  textFree: _propTypes2.default.bool,
	  theme: _propTypes2.default.object
	};
	
	var defaultProps = {
	  disabled: false,
	  checked: false,
	  textFree: false
	};
	
	var labelSize = function labelSize(_ref) {
	  var themeFromProvider = _ref.theme,
	      textFree = _ref.textFree;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var size = theme.reactackle.components.checkbox.input.size;
	  var checkboxTextSpacing = theme.reactackle.components.checkbox.label.checkboxTextSpacing;
	
	
	  var paddingLeft = textFree ? (0, _reactackleCore.getValueString)(size) : 'calc(' + (0, _reactackleCore.getValueString)(size) + ' + ' + (0, _reactackleCore.getValueString)(checkboxTextSpacing) + ')';
	
	  return (0, _styledComponents.css)(['min-width:', ';max-width:', ';min-height:', ';padding-left:', ';&:empty{padding-left:', ';}'], (0, _reactackleCore.getValueString)(size), textFree ? (0, _reactackleCore.getValueString)(size) : '100%', (0, _reactackleCore.getValueString)(size), paddingLeft, (0, _reactackleCore.getValueString)(size));
	};
	
	var labelText = function labelText(_ref2) {
	  var themeFromProvider = _ref2.theme,
	      disabled = _ref2.disabled;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var labelSource = theme.reactackle.components.checkbox.label;
	
	  var fontSize = labelSource.fontSize,
	      fontColor = labelSource.fontColor,
	      lineHeight = labelSource.lineHeight;
	  var disabledColor = labelSource.disabled.color;
	
	
	  return '  \n    line-height: ' + lineHeight + ';\n    font-size: ' + (0, _reactackleCore.getValueString)(fontSize) + ';\n    \n    ' + (disabled ? '\n        cursor: default;\n        color: ' + disabledColor + ';\n      ' : '\n        cursor: pointer;\n        color: ' + fontColor + ';\n      ') + '\n  ';
	};
	
	var checkboxSize = function checkboxSize(_ref3) {
	  var themeFromProvider = _ref3.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var size = theme.reactackle.components.checkbox.input.size;
	
	
	  return '  \n    width: ' + (0, _reactackleCore.getValueString)(size) + ';\n    height: ' + (0, _reactackleCore.getValueString)(size) + ';\n  ';
	};
	
	var checkboxStyle = function checkboxStyle(_ref4) {
	  var themeFromProvider = _ref4.theme,
	      checked = _ref4.checked,
	      disabled = _ref4.disabled;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var path = theme.reactackle.components.checkbox.input;
	
	  var size = path.size,
	      borderWidth = path.borderWidth,
	      borderRadius = path.borderRadius;
	
	
	  var source = checked ? path.checked : path;
	
	  return '\n    &::before {\n      line-height: calc(' + (0, _reactackleCore.getValueString)(size) + ' - ' + borderWidth * 2 + 'px);\n      border: ' + borderWidth + 'px solid transparent;\n      border-radius: ' + (0, _reactackleCore.getValueString)(borderRadius) + ';\n    }\n    \n    ' + (!disabled ? '\n        &::before {\n          background-color: ' + source.backgroundColor + ';\n          border-color: ' + source.borderColor + ';\n        }\n        \n        &:hover::before {\n          background-color: ' + source.hover.backgroundColor + ';\n          border-color: ' + source.hover.borderColor + ';\n        }\n        \n        &:focus::before {\n          background-color: ' + source.focus.backgroundColor + ';\n          border-color: ' + source.focus.borderColor + ';\n        }\n      ' : '\n        &::before,\n        &:hover::before,\n        &:focus::before {\n          background-color: ' + source.disabled.backgroundColor + ';\n          border-color: ' + source.disabled.borderColor + ';\n        }\n      ') + '\n  ';
	};
	
	var CheckboxLabelStyled = exports.CheckboxLabelStyled = _styledComponents2.default.label.withConfig({
	  displayName: 'CheckboxLabelStyled'
	})(['position:relative;cursor:pointer;display:inline-block;width:100%;', ';', ';&:focus{box-shadow:none;outline:none;}&::before{content:\'\';display:block;text-align:center;position:absolute;top:0;left:0;', ';', ';}', ';'], labelSize, labelText, checkboxSize, (0, _reactackleCore.transition)('color, background-color, border'), checkboxStyle);
	
	CheckboxLabelStyled.propTypes = propTypes;
	CheckboxLabelStyled.defaultProps = defaultProps;
	CheckboxLabelStyled.displayName = 'CheckboxLabelStyled';

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getValueString = exports.column = exports.legacyDirection = exports.oppositeDirection = exports.getValueUnit = exports.stripUnit = undefined;
	
	var _constants = __webpack_require__(131);
	
	var stripUnit = exports.stripUnit = function stripUnit(value) {
	  if (!value) throw new TypeError('Value is not defined');
	
	  if (typeof value === 'string' && value !== 'inherit') return value.match(/^\d+/)[0];else if (isFinite(value) || value === 'inherit') return value;
	
	  throw new TypeError('Wrong value type');
	};
	
	var getValueUnit = exports.getValueUnit = function getValueUnit(value) {
	  if (!value) throw new TypeError('Value is not defined');
	
	  if (typeof value === 'string') return value.match(/\D+/);else if (typeof value === 'number') return '';
	
	  throw new TypeError('Wrong value type');
	};
	
	var oppositeDirection = exports.oppositeDirection = function oppositeDirection(direction) {
	  var directionMap = {
	    top: 'bottom',
	    right: 'left',
	    bottom: 'top',
	    left: 'right',
	    center: 'center',
	    ltr: 'rtl',
	    rtl: 'ltr'
	  };
	
	  return directionMap[direction];
	};
	
	var legacyDirection = exports.legacyDirection = function legacyDirection(direction) {
	  var directionMap = {
	    'to top': 'bottom',
	    'to top right': 'bottom left',
	    'to right top': 'left bottom',
	    'to right': 'left',
	    'to bottom right': 'top left',
	    'to right bottom': 'left top',
	    'to bottom': 'top',
	    'to bottom left': 'top right',
	    'to left bottom': 'right top',
	    'to left': 'right',
	    'to left top': 'right bottom',
	    'to top left': 'bottom right'
	  };
	
	  if (!directionMap[direction.toLowerCase()]) throw new TypeError('Wrong direction value: \'' + direction + '\'');
	
	  return directionMap[direction.toLowerCase()];
	};
	
	/**
	 * Generate columns
	 */
	var column = exports.column = function column(amount) {
	  var totalColumns = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _constants.grid.totalColumns;
	
	  if (!isFinite(amount) || !isFinite(totalColumns)) throw new TypeError('Wrong value type. Number expected.');
	
	  var result = amount * 100 / totalColumns;
	
	  return result ? result + '%' : result;
	};
	
	var getValueString = exports.getValueString = function getValueString(value) {
	  return typeof value === 'number' ? value + 'px' : value;
	};

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DialogActions = undefined;
	
	var _DialogActionsRegion = __webpack_require__(643);
	
	Object.keys(_DialogActionsRegion).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _DialogActionsRegion[key];
	    }
	  });
	});
	
	var _DialogActions = __webpack_require__(641);
	
	var _DialogActions2 = _interopRequireDefault(_DialogActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.DialogActions = _DialogActions2.default;

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DialogContent = undefined;
	
	var _DialogContentText = __webpack_require__(654);
	
	Object.keys(_DialogContentText).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _DialogContentText[key];
	    }
	  });
	});
	
	var _DialogContent = __webpack_require__(652);
	
	var _DialogContent2 = _interopRequireDefault(_DialogContent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.DialogContent = _DialogContent2.default;

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DialogTitle = undefined;
	
	var _DialogTitle = __webpack_require__(658);
	
	var _DialogTitle2 = _interopRequireDefault(_DialogTitle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.DialogTitle = _DialogTitle2.default;

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DialogHeading = undefined;
	
	var _DialogTitle = __webpack_require__(214);
	
	Object.keys(_DialogTitle).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _DialogTitle[key];
	    }
	  });
	});
	
	var _DialogHeading = __webpack_require__(657);
	
	var _DialogHeading2 = _interopRequireDefault(_DialogHeading);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.DialogHeading = _DialogHeading2.default;

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactackleCore = __webpack_require__(3);
	
	exports.default = {
	  themeColor: _reactackleCore.colorSecondary,
	  gutter: _reactackleCore.tripleBaseModule,
	
	  message: {
	    fontSize: function fontSize(_ref) {
	      var _fontSize = _ref.fontSize;
	      return _fontSize[-1];
	    },
	    lineHeight: 1.5,
	    marginBottom: function marginBottom(_ref2) {
	      var baseModule = _ref2.baseModule;
	      return baseModule * 4.5;
	    },
	    color: function color(_ref3) {
	      var fontColor = _ref3.fontColor;
	      return fontColor.medium;
	    },
	    backgroundColor: _reactackleCore.colorTransparent,
	    paddingY: 0,
	    paddingX: 0,
	
	    error: {
	      color: function color(_ref4) {
	        var _color = _ref4.color;
	        return _color.alert;
	      },
	      backgroundColor: _reactackleCore.colorTransparent,
	      paddingY: 0,
	      paddingX: 0
	    }
	  }
	};

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.transform = exports.backgroundProps = exports.sizeProps = exports.borderRadius = exports.border = undefined;
	
	var _styledComponents = __webpack_require__(4);
	
	var _reactackleCore = __webpack_require__(3);
	
	var border = exports.border = function border(_ref) {
	  var border = _ref.border,
	      borderWidth = _ref.borderWidth,
	      colorScheme = _ref.colorScheme,
	      customColor = _ref.customColor,
	      sizeKey = _ref.sizeKey,
	      themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var path = theme.reactackle.components.icon;
	  var customWidth = borderWidth > 0 && borderWidth;
	  var themeWidth = sizeKey !== 'custom' ? path.size[sizeKey].borderWidth : 1;
	  var bWidth = customWidth || themeWidth;
	
	  var color = path.color[colorScheme];
	
	  return border && (0, _styledComponents.css)(['border:solid ', 'px ', ';'], bWidth, customColor || color);
	};
	
	var borderRadius = exports.borderRadius = function borderRadius(_ref2) {
	  var rounded = _ref2.rounded,
	      themeFromProvider = _ref2.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var borderRadius = rounded ? '50%' : (0, _reactackleCore.getValueString)(theme.reactackle.components.icon.borderRadius);
	
	  return '\n    border-radius: ' + borderRadius + ';\n  ';
	};
	
	var sizeProps = exports.sizeProps = function sizeProps(_ref3) {
	  var themeFromProvider = _ref3.theme,
	      sizeKey = _ref3.sizeKey,
	      border = _ref3.border,
	      rounded = _ref3.rounded;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var path = theme.reactackle.components.icon;
	
	  var width = sizeKey !== 'custom' ? path.size[sizeKey].width || path.size[sizeKey].height : 'inherit';
	
	  var height = sizeKey !== 'custom' ? path.size[sizeKey].height || path.size[sizeKey].width : 'inherit';
	
	  var imgSize = null;
	  if (sizeKey !== 'custom') {
	    if (border) {
	      if (rounded) imgSize = path.size[sizeKey].roundedImgSize || path.size[sizeKey].borderedImgSize || path.size[sizeKey].imgSize || height;else imgSize = path.size[sizeKey].borderedImgSize || path.size[sizeKey].imgSize || height;
	    } else imgSize = path.size[sizeKey].imgSize || height;
	  }
	
	  return (0, _styledComponents.css)(['', ''], (0, _reactackleCore.iconSizeMixin)((0, _reactackleCore.getValueString)(height), (0, _reactackleCore.getValueString)(imgSize), (0, _reactackleCore.getValueString)(width)));
	};
	
	var backgroundProps = exports.backgroundProps = function backgroundProps(_ref4) {
	  var backgroundColor = _ref4.backgroundColor;
	  return backgroundColor && '\n  background-color: ' + backgroundColor + ';\n';
	};
	
	var transform = exports.transform = function transform(_ref5) {
	  var flip = _ref5.flip,
	      rotate = _ref5.rotate;
	
	  var iconFlip = '',
	      iconRotate = '';
	
	  if (flip === 'horizontal') iconFlip = 'scale(-1, 1);';else if (flip === 'vertical') iconFlip = 'scale(1, -1);';
	
	  if (rotate) iconRotate = 'rotate(' + rotate + 'deg)';
	
	  return iconFlip || iconRotate ? 'transform: ' + iconFlip + ' ' + iconRotate + ';' : '';
	};

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CircleProgress = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactackleCore = __webpack_require__(3);
	
	var _ProgressBase2 = __webpack_require__(220);
	
	var _ProgressBoxStyled = __webpack_require__(221);
	
	var _SecondaryLineStyled = __webpack_require__(762);
	
	var _ContentWrapperStyled = __webpack_require__(760);
	
	var _CircleWrapperStyled = __webpack_require__(759);
	
	var _CircleBoxStyled = __webpack_require__(758);
	
	var _BgLineStyled = __webpack_require__(757);
	
	var _PrimaryLineStyled = __webpack_require__(761);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = _extends({}, _ProgressBase2.ProgressBase.propTypes, {
	  /**
	   * Set circle diameter
	   */
	  circleSize: _propTypes2.default.number,
	  /**
	   * Set progress line thickness
	   */
	  strokeSize: _propTypes2.default.number
	});
	
	var defaultProps = _extends({}, _ProgressBase2.ProgressBase.defaultProps, {
	  circleSize: 0,
	  strokeSize: 0
	});
	
	var _CircleProgress = function (_ProgressBase) {
	  _inherits(_CircleProgress, _ProgressBase);
	
	  function _CircleProgress() {
	    _classCallCheck(this, _CircleProgress);
	
	    return _possibleConstructorReturn(this, (_CircleProgress.__proto__ || Object.getPrototypeOf(_CircleProgress)).apply(this, arguments));
	  }
	
	  _createClass(_CircleProgress, [{
	    key: '_renderSecondaryProgressCircle',
	    value: function _renderSecondaryProgressCircle() {
	      var _props = this.props,
	          indeterminate = _props.indeterminate,
	          withSecondaryProgress = _props.withSecondaryProgress;
	
	
	      if (indeterminate || !withSecondaryProgress) return null;
	
	      var normalizedSecondaryProgress = this._getNormalizedSecondaryProgress();
	      var circleLength = this.circleLength;
	      var circleRadius = this.circleRadius;
	      var circleCenter = this.circleCenter;
	      var secondaryProgressLength = normalizedSecondaryProgress * circleLength;
	
	      var progressSecondaryStyle = {
	        stroke: this._getSecondaryProgressColor('circle').string(),
	        strokeDasharray: secondaryProgressLength + ' ' + circleLength
	      };
	
	      return _react2.default.createElement(_SecondaryLineStyled.SecondaryLineStyled, {
	        r: circleRadius,
	        cx: circleCenter,
	        cy: circleCenter,
	        customThickness: this.strokeSize,
	        style: progressSecondaryStyle
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var indeterminate = this.props.indeterminate;
	
	
	      var normalizedProgress = this._getNormalizedProgress();
	      var viewBox = '0 0 ' + this.circleSize + ' ' + this.circleSize;
	      var circleRadius = this.circleRadius;
	      var circleCenter = this.circleCenter;
	      var circleLength = this.circleLength;
	      var progressLength = normalizedProgress * circleLength;
	      var bgStyle = {
	        strokeDasharray: circleLength + ' ' + circleLength
	      };
	
	      var progressAdditionalStyle = void 0;
	      if (indeterminate) {
	        progressAdditionalStyle = {
	          strokeLinecap: 'round',
	          strokeLinejoin: 'round'
	        };
	      } else {
	        progressAdditionalStyle = {
	          strokeDasharray: progressLength + ' ' + circleLength
	        };
	      }
	
	      var progressPrimaryStyle = _extends({
	        stroke: this._getProgressColor('circle').string()
	      }, progressAdditionalStyle);
	
	      var strokeSize = this.strokeSize;
	
	      return _react2.default.createElement(
	        _ProgressBoxStyled.ProgressBoxStyled,
	        this._getAriaAttributes(),
	        this._renderLabel('circle'),
	        _react2.default.createElement(
	          _ContentWrapperStyled.ContentWrapperStyled,
	          { customDiameter: this.circleSize },
	          _react2.default.createElement(
	            _CircleWrapperStyled.CircleWrapperStyled,
	            null,
	            _react2.default.createElement(
	              _CircleBoxStyled.CircleBoxStyled,
	              {
	                viewBox: viewBox,
	                customDiameter: this.circleSize,
	                shapeRendering: 'geometricPrecision',
	                indeterminate: this.props.indeterminate
	              },
	              _react2.default.createElement(_BgLineStyled.BgLineStyled, {
	                r: circleRadius,
	                cx: circleCenter,
	                cy: circleCenter,
	                style: bgStyle,
	                customThickness: strokeSize
	              }),
	              this._renderSecondaryProgressCircle(),
	              _react2.default.createElement(_PrimaryLineStyled.PrimaryLineStyled, {
	                r: circleRadius,
	                cx: circleCenter,
	                cy: circleCenter,
	                customThickness: strokeSize,
	                style: progressPrimaryStyle,
	                circleLength: this.circleLength,
	                indeterminate: this.props.indeterminate
	              })
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'theme',
	    get: function get() {
	      return this.props.theme.reactackle.components.progress.circle;
	    }
	  }, {
	    key: 'circleSize',
	    get: function get() {
	      return this.props.circleSize || this.theme.circleSize;
	    }
	  }, {
	    key: 'strokeSize',
	    get: function get() {
	      return this.props.strokeSize || this.theme.strokeSize;
	    }
	  }, {
	    key: 'circleRadius',
	    get: function get() {
	      return this.circleSize / 2 - this.strokeSize / 2;
	    }
	  }, {
	    key: 'circleLength',
	    get: function get() {
	      return 2 * this.circleRadius * Math.PI;
	    }
	  }, {
	    key: 'circleCenter',
	    get: function get() {
	      return this.circleSize / 2;
	    }
	  }]);
	
	  return _CircleProgress;
	}(_ProgressBase2.ProgressBase);
	
	_CircleProgress.propTypes = propTypes;
	_CircleProgress.defaultProps = defaultProps;
	_CircleProgress.displayName = 'CircleProgress';
	
	var CircleProgress = exports.CircleProgress = (0, _reactackleCore.withTheme)(_CircleProgress);

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LinearProgress = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactackleCore = __webpack_require__(3);
	
	var _ProgressBase2 = __webpack_require__(220);
	
	var _ProgressBoxStyled = __webpack_require__(221);
	
	var _ContentWrapperStyled = __webpack_require__(763);
	
	var _PrimaryLineStyled = __webpack_require__(765);
	
	var _SecondaryLineStyled = __webpack_require__(766);
	
	var _SplitterStyled = __webpack_require__(767);
	
	var _LinearProgressStyled = __webpack_require__(764);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = _extends({}, _ProgressBase2.ProgressBase.propTypes);
	
	var defaultProps = _extends({}, _ProgressBase2.ProgressBase.defaultProps);
	
	var _LinearProgress = function (_ProgressBase) {
	  _inherits(_LinearProgress, _ProgressBase);
	
	  function _LinearProgress() {
	    _classCallCheck(this, _LinearProgress);
	
	    return _possibleConstructorReturn(this, (_LinearProgress.__proto__ || Object.getPrototypeOf(_LinearProgress)).apply(this, arguments));
	  }
	
	  _createClass(_LinearProgress, [{
	    key: '_renderSecondaryProgress',
	    value: function _renderSecondaryProgress() {
	      var _props = this.props,
	          withSecondaryProgress = _props.withSecondaryProgress,
	          indeterminate = _props.indeterminate;
	
	
	      if (indeterminate || !withSecondaryProgress) return null;
	
	      var normalizedSecondaryProgress = this._getNormalizedSecondaryProgress();
	
	      return _react2.default.createElement(_SecondaryLineStyled.SecondaryLineStyled, {
	        style: {
	          backgroundColor: this._getSecondaryProgressColor('linear').string(),
	          transform: 'scaleX(' + normalizedSecondaryProgress + ')'
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var indeterminate = this.props.indeterminate;
	
	
	      var normalizedProgress = this._getNormalizedProgress();
	      var progressStyle = {
	        backgroundColor: this._getProgressColor('linear').string()
	      };
	
	      if (!indeterminate) progressStyle.transform = 'scaleX(' + normalizedProgress + ')';
	
	      var progressSplitter = indeterminate ? _react2.default.createElement(_SplitterStyled.SplitterStyled, null) : null;
	
	      return _react2.default.createElement(
	        _ProgressBoxStyled.ProgressBoxStyled,
	        this._getAriaAttributes(),
	        _react2.default.createElement(
	          _LinearProgressStyled.LinearProgressStyled,
	          null,
	          this._renderLabel('linear'),
	          _react2.default.createElement(
	            _ContentWrapperStyled.ContentWrapperStyled,
	            null,
	            this._renderSecondaryProgress(),
	            _react2.default.createElement(
	              _PrimaryLineStyled.PrimaryLineStyled,
	              {
	                indeterminate: indeterminate,
	                style: progressStyle
	              },
	              progressSplitter
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return _LinearProgress;
	}(_ProgressBase2.ProgressBase);
	
	_LinearProgress.propTypes = propTypes;
	_LinearProgress.defaultProps = defaultProps;
	_LinearProgress.displayName = 'LinearProgress';
	
	var LinearProgress = exports.LinearProgress = (0, _reactackleCore.withTheme)(_LinearProgress);

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ProgressBase = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactackleCore = __webpack_require__(3);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _color = __webpack_require__(110);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _LabelWrapperStyled = __webpack_require__(770);
	
	var _SupplementTextStyled = __webpack_require__(771);
	
	var _ValueLabelStyled = __webpack_require__(772);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  /**
	   * Progress line will change its colour accordingly to progress
	   */
	  dynamicColor: _propTypes2.default.bool,
	  /**
	   * Specifies progress mode. Indeterminate one doesn't have value.
	   */
	  indeterminate: _propTypes2.default.bool,
	  /**
	   * Specifies max value to calculate progress from
	   */
	  max: _propTypes2.default.number,
	  /**
	   * Specifies min value to calculate progress from
	   */
	  min: _propTypes2.default.number,
	  /**
	   * Specifies current value to calculate progress from
	   */
	  value: _propTypes2.default.number,
	  /**
	   * Shows a progress label with the exact value (=shows this.props.value)
	   * Has priority over progressLabel
	   */
	  exactProgressLabel: _propTypes2.default.bool,
	  /**
	   * Show postfix after exact progress label
	   */
	  labelPostfix: _propTypes2.default.string,
	  /**
	   * Shows a progress label with the percentage value
	   */
	  progressLabel: _propTypes2.default.bool,
	  /**
	   * Set text align for progress label
	   */
	  labelPositionX: _propTypes2.default.oneOf(['left', 'center', 'right']),
	  /**
	   * Set label position. "Center" is valid for circle progress only.
	   */
	  labelPositionY: _propTypes2.default.oneOf(['top', 'center', 'bottom']),
	  /**
	   * Set subtitle for progress label
	   */
	  subtitle: _propTypes2.default.string,
	  /**
	   * Add secondary progress line
	   */
	  withSecondaryProgress: _propTypes2.default.bool, // eslint-disable-line react/no-unused-prop-types
	  /**
	   * Value for secondary progress
	   */
	  secondaryProgressValue: _propTypes2.default.number,
	  /**
	   * Value for aria-valuetext attr
	   */
	  ariaValueText: _propTypes2.default.string,
	  /**
	   * Theme provided by withTheme HOC
	   */
	  theme: _propTypes2.default.object.isRequired
	};
	
	var defaultProps = {
	  dynamicColor: false,
	  indeterminate: false,
	  max: 100,
	  min: 0,
	  value: 0,
	  exactProgressLabel: false,
	  labelPostfix: '',
	  progressLabel: false,
	  labelPositionX: 'left',
	  labelPositionY: 'top',
	  subtitle: '',
	  withSecondaryProgress: false,
	  secondaryProgressValue: 0,
	  ariaValueText: ''
	};
	
	var normalizeValue = function normalizeValue(value, min, max) {
	  return ((0, _reactackleCore.minMax)(value, min, max) - min) / (max - min);
	};
	
	var ProgressBase = exports.ProgressBase = function (_Component) {
	  _inherits(ProgressBase, _Component);
	
	  function ProgressBase() {
	    _classCallCheck(this, ProgressBase);
	
	    return _possibleConstructorReturn(this, (ProgressBase.__proto__ || Object.getPrototypeOf(ProgressBase)).apply(this, arguments));
	  }
	
	  _createClass(ProgressBase, [{
	    key: '_getNormalizedProgress',
	    value: function _getNormalizedProgress() {
	      var _props = this.props,
	          value = _props.value,
	          min = _props.min,
	          max = _props.max;
	
	
	      return normalizeValue(value, min, max);
	    }
	  }, {
	    key: '_getNormalizedSecondaryProgress',
	    value: function _getNormalizedSecondaryProgress() {
	      var _props2 = this.props,
	          secondaryProgressValue = _props2.secondaryProgressValue,
	          min = _props2.min,
	          max = _props2.max;
	
	
	      var value = normalizeValue(secondaryProgressValue, min, max);
	      var progress = this._getNormalizedProgress();
	
	      return value < progress ? progress : value;
	    }
	  }, {
	    key: '_getProgressColor',
	    value: function _getProgressColor(progressType) {
	      var _props3 = this.props,
	          dynamicColor = _props3.dynamicColor,
	          theme = _props3.theme;
	
	
	      var componentTheme = theme.reactackle.components.progress;
	      var colors = componentTheme[progressType].mainLine;
	      var startColor = colors.startColor,
	          endColor = colors.endColor,
	          color = colors.color;
	
	
	      if (dynamicColor) {
	        var start = (0, _color2.default)(startColor);
	        var end = (0, _color2.default)(endColor);
	        var progress = this._getNormalizedProgress();
	
	        return start.mix(end, progress);
	      } else {
	        return (0, _color2.default)(color);
	      }
	    }
	  }, {
	    key: '_getSecondaryProgressColor',
	    value: function _getSecondaryProgressColor(progressType) {
	      var theme = this.props.theme;
	
	
	      var componentTheme = theme.reactackle.components.progress;
	      var _componentTheme$progr = componentTheme[progressType].secondaryLine,
	          color = _componentTheme$progr.color,
	          opacity = _componentTheme$progr.opacity;
	
	
	      return color ? (0, _color2.default)(color) : this._getProgressColor(progressType).fade(1 - opacity);
	    }
	  }, {
	    key: '_getAriaAttributes',
	    value: function _getAriaAttributes() {
	      var _props4 = this.props,
	          indeterminate = _props4.indeterminate,
	          min = _props4.min,
	          max = _props4.max,
	          value = _props4.value,
	          subtitle = _props4.subtitle,
	          ariaValueText = _props4.ariaValueText;
	
	
	      var ret = {
	        role: 'progressbar'
	      };
	
	      var valueText = ariaValueText || subtitle;
	      if (valueText) ret['aria-valuetext'] = valueText;
	
	      if (!indeterminate) {
	        ret['aria-valuenow'] = String(value);
	        ret['aria-valuemin'] = String(min);
	        ret['aria-valuemax'] = String(max);
	      }
	
	      return ret;
	    }
	  }, {
	    key: '_renderPrimaryText',
	    value: function _renderPrimaryText(progressType) {
	      var _props5 = this.props,
	          progressLabel = _props5.progressLabel,
	          exactProgressLabel = _props5.exactProgressLabel,
	          value = _props5.value,
	          labelPostfix = _props5.labelPostfix;
	
	      var text = void 0;
	
	      if (!progressLabel && !exactProgressLabel) return null;
	
	      if (exactProgressLabel) {
	        text = '' + value + labelPostfix;
	      } else {
	        var progressPercent = Math.round(this._getNormalizedProgress() * 100);
	        text = progressPercent + '%';
	      }
	
	      return _react2.default.createElement(
	        _ValueLabelStyled.ValueLabelStyled,
	        { progressType: progressType },
	        text
	      );
	    }
	  }, {
	    key: '_renderSubtitle',
	    value: function _renderSubtitle(progressType) {
	      var _props6 = this.props,
	          subtitle = _props6.subtitle,
	          children = _props6.children;
	
	
	      if (!children && !subtitle) return null;
	
	      return _react2.default.createElement(
	        _SupplementTextStyled.SupplementTextStyled,
	        { progressType: progressType },
	        children && subtitle ? _react2.default.createElement(
	          'div',
	          null,
	          subtitle
	        ) : subtitle,
	        children
	      );
	    }
	  }, {
	    key: '_renderLabel',
	    value: function _renderLabel(progressType) {
	      var _props7 = this.props,
	          progressLabel = _props7.progressLabel,
	          exactProgressLabel = _props7.exactProgressLabel,
	          subtitle = _props7.subtitle,
	          labelPositionX = _props7.labelPositionX,
	          labelPositionY = _props7.labelPositionY;
	
	
	      if (!progressLabel && !exactProgressLabel && !subtitle) return null;
	
	      return _react2.default.createElement(
	        _LabelWrapperStyled.LabelWrapperStyled,
	        {
	          labelAlign: labelPositionX,
	          labelPositionY: labelPositionY,
	          progressType: progressType
	        },
	        this._renderPrimaryText(progressType),
	        this._renderSubtitle(progressType)
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return ProgressBase;
	}(_react.Component);
	
	ProgressBase.propTypes = propTypes;
	ProgressBase.defaultProps = defaultProps;
	ProgressBase.displayName = 'ProgressBase';

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ProgressBoxStyled = undefined;
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProgressBoxStyled = exports.ProgressBoxStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'ProgressBoxStyled'
	})(['display:flex;flex-direction:column;position:relative;']);
	
	ProgressBoxStyled.displayName = 'ProgressBoxStyled';

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.OptionPropTypeCustom = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OptionPropTypeCustom = exports.OptionPropTypeCustom = _propTypes2.default.shape({
	  value: _propTypes2.default.any,
	  text: _propTypes2.default.string,
	  disabled: _propTypes2.default.bool
	});

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.OptionPropTypeNative = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OptionPropTypeNative = exports.OptionPropTypeNative = _propTypes2.default.shape({
	  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  text: _propTypes2.default.string,
	  disabled: _propTypes2.default.bool
	});

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ContentBoxStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  labelPosition: _propTypes2.default.oneOf(['top', 'side'])
	};
	
	var defaultProps = {
	  labelPosition: 'top'
	};
	
	/** Prop Receivers */
	var contentFlow = function contentFlow(_ref) {
	  var labelPosition = _ref.labelPosition;
	  return labelPosition === 'side' && '\n    display: flex;\n    flex-direction: row;\n    align-items: flex-end;\n  ';
	};
	
	/** Styles */
	var ContentBoxStyled = exports.ContentBoxStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'ContentBoxStyled'
	})(['flex-grow:1;max-width:100%;', ';'], contentFlow);
	
	ContentBoxStyled.propTypes = propTypes;
	ContentBoxStyled.defaultProps = defaultProps;
	ContentBoxStyled.displayName = 'ContentBoxStyled';

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MessageStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  dense: _propTypes2.default.bool,
	  /**
	   * Define theme
	   * See https://github.com/styled-components/styled-components/blob/master/docs/theming.md
	   * for more information
	   */
	  theme: _propTypes2.default.object
	};
	
	var defaultProps = {
	  dense: false
	};
	
	/** Prop Receivers */
	var styleProps = function styleProps(_ref) {
	  var themeFromProvider = _ref.theme,
	      colorScheme = _ref.colorScheme,
	      focus = _ref.focus,
	      disabled = _ref.disabled;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var path = theme.reactackle.components.selectBox.message.style;
	
	  var source = null;
	
	  if (!disabled) {
	    if (colorScheme !== 'neutral') source = path[colorScheme];else if (focus) source = path.focus;else source = path;
	  } else {
	    source = path.disabled;
	  }
	
	  var _source = source,
	      fontColor = _source.fontColor;
	
	
	  return 'color: ' + fontColor + ';';
	};
	
	var baseProps = function baseProps(_ref2) {
	  var themeFromProvider = _ref2.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var _theme$reactackle$com = theme.reactackle.components.selectBox.message,
	      messageSelectSpacing = _theme$reactackle$com.messageSelectSpacing,
	      fontSize = _theme$reactackle$com.fontSize,
	      lineHeight = _theme$reactackle$com.lineHeight;
	
	
	  return '\n    margin-top: ' + (0, _reactackleCore.getValueString)(messageSelectSpacing) + ';\n    font-size: ' + (0, _reactackleCore.getValueString)(fontSize) + ';\n    line-height: ' + lineHeight + ';\n  ';
	};
	
	/** STYLES */
	var MessageStyled = exports.MessageStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'MessageStyled'
	})(['flex-grow:1;', ';', ';', ';'], baseProps, styleProps, (0, _reactackleCore.transition)('color'));
	
	MessageStyled.propTypes = propTypes;
	MessageStyled.defaultProps = defaultProps;
	MessageStyled.displayName = 'MessageStyled';

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SelectBoxInfoBoxStyled = undefined;
	
	var _templateObject = _taggedTemplateLiteral(['\n        padding-left: ', ';\n      '], ['\n        padding-left: ', ';\n      ']);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var propTypes = {
	  dense: _propTypes2.default.bool,
	  /**
	   * Define theme
	   * See https://github.com/styled-components/styled-components/blob/master/docs/theming.md
	   * for more information
	   */
	  theme: _propTypes2.default.object
	};
	
	var defaultProps = {
	  dense: false
	};
	
	/** Prop Receivers */
	var offset = function offset(_ref) {
	  var themeFromProvider = _ref.theme,
	      labelPosition = _ref.labelPosition,
	      dense = _ref.dense,
	      fullWidth = _ref.fullWidth,
	      bordered = _ref.bordered;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var labelPositionSide = theme.reactackle.components.selectBox.label.positionSide,
	      styleKey = bordered ? 'bordered' : 'underlined',
	      labelPositionSideSize = labelPositionSide.size[styleKey];
	
	  var labelSizeSource = labelPositionSideSize;
	
	  if (dense && !fullWidth) labelSizeSource = labelPositionSideSize.dense;else if (dense && fullWidth) labelSizeSource = labelPositionSideSize.denseFullWidth;else if (!dense && fullWidth) labelSizeSource = labelPositionSideSize.fullWidth;
	
	  var labelSelectSpacing = (0, _reactackleCore.getValueString)(labelSizeSource.labelSelectSpacing);
	
	  var breakpoints = labelPositionSide.breakpoints.map(function (item) {
	    var offset = 'calc(' + (0, _reactackleCore.getValueString)(item.width) + ' + ' + labelSelectSpacing + ')';
	
	    return (0, _styledComponents.css)(['', ''], (0, _reactackleCore.media)(item.breakpoint)(_templateObject, offset));
	  });
	
	  var defaultOffset = 'calc(' + (0, _reactackleCore.getValueString)(labelPositionSide.width) + ' + ' + labelSelectSpacing + ')';
	
	  return labelPosition === 'side' && (0, _styledComponents.css)(['padding-left:', 'px;', ';'], defaultOffset, breakpoints);
	};
	
	/** STYLES */
	var SelectBoxInfoBoxStyled = exports.SelectBoxInfoBoxStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'SelectBoxInfoBoxStyled'
	})(['display:flex;', ';'], offset);
	
	SelectBoxInfoBoxStyled.propTypes = propTypes;
	SelectBoxInfoBoxStyled.defaultProps = defaultProps;
	SelectBoxInfoBoxStyled.displayName = 'SelectBoxInfoBoxStyled';

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SelectBoxLabelStyled = undefined;
	
	var _templateObject = _taggedTemplateLiteral(['\n        width: ', ';\n      '], ['\n        width: ', ';\n      ']);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var propTypes = {
	  labelPosition: _propTypes2.default.oneOf(['top', 'side']),
	  /**
	   * Define theme
	   * See https://github.com/styled-components/styled-components/blob/master/docs/theming.md
	   * for more information
	   */
	  theme: _propTypes2.default.object
	};
	
	var defaultProps = {
	  labelPosition: 'top'
	};
	
	/** Prop Receivers */
	var labelBase = function labelBase(_ref) {
	  var labelPosition = _ref.labelPosition,
	      themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var path = theme.reactackle.components.selectBox.label,
	      source = labelPosition === 'top' ? path.positionTop : path.positionSide;
	
	  var fontSize = source.fontSize,
	      lineHeight = source.lineHeight,
	      textTransform = source.textTransform,
	      fontWeight = source.fontWeight;
	
	
	  return (0, _styledComponents.css)(['font-size:', ';line-height:', ';text-transform:', ';font-weight:', ';', ''], (0, _reactackleCore.getValueString)(fontSize), lineHeight, textTransform, fontWeight, labelPosition === 'side' ? '\n        flex-direction: column;\n        justify-content: center;\n      ' : 'align-items: center;');
	};
	
	var labelSelectSpacing = function labelSelectSpacing(_ref2) {
	  var labelPosition = _ref2.labelPosition,
	      dense = _ref2.dense,
	      fullWidth = _ref2.fullWidth,
	      themeFromProvider = _ref2.theme,
	      bordered = _ref2.bordered;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var key = labelPosition === 'top' ? 'positionTop' : 'positionSide',
	      styleKey = bordered ? 'bordered' : 'underlined',
	      path = theme.reactackle.components.selectBox.label[key].size[styleKey];
	
	  var source = path;
	
	  if (dense && !fullWidth) source = path.dense;else if (dense && fullWidth) source = path.denseFullWidth;else if (!dense && fullWidth) source = path.fullWidth;
	
	  var labelSelectSpacing = (0, _reactackleCore.getValueString)(source.labelSelectSpacing);
	
	  return labelPosition === 'top' ? 'margin-bottom: ' + labelSelectSpacing + ';' : 'margin-right: ' + labelSelectSpacing + ';';
	};
	
	var sizeProps = function sizeProps(_ref3) {
	  var labelPosition = _ref3.labelPosition,
	      dense = _ref3.dense,
	      fullWidth = _ref3.fullWidth,
	      themeFromProvider = _ref3.theme,
	      bordered = _ref3.bordered;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var styleKey = bordered ? 'bordered' : 'underlined',
	      path = theme.reactackle.components.selectBox.selectBox[styleKey].size;
	  var source = path;
	
	  if (dense && !fullWidth) source = path.dense;else if (dense && fullWidth) source = path.denseFullWidth;else if (!dense && fullWidth) source = path.fullWidth;
	
	  var _source = source,
	      paddingY = _source.paddingY;
	
	
	  return labelPosition === 'side' && '\n    padding-bottom: ' + (0, _reactackleCore.getValueString)(paddingY) + ';\n  ';
	};
	
	var labelStyle = function labelStyle(_ref4) {
	  var themeFromProvider = _ref4.theme,
	      disabled = _ref4.disabled,
	      colorScheme = _ref4.colorScheme,
	      labelPosition = _ref4.labelPosition,
	      focus = _ref4.focus;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var key = labelPosition === 'top' ? 'positionTop' : 'positionSide',
	      path = theme.reactackle.components.selectBox.label[key].style;
	  var source = null;
	
	  if (!disabled) {
	    if (colorScheme !== 'neutral') source = path[colorScheme];else if (focus) source = path.focus;else source = path;
	  } else {
	    source = path.disabled;
	  }
	  var _source2 = source,
	      fontColor = _source2.fontColor;
	
	
	  return 'color: ' + fontColor + ';';
	};
	
	var labelSideWidth = function labelSideWidth(_ref5) {
	  var labelPosition = _ref5.labelPosition,
	      themeFromProvider = _ref5.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var source = theme.reactackle.components.selectBox.label.positionSide;
	
	  var breakpoints = source.breakpoints.map(function (item) {
	    return (0, _styledComponents.css)(['', ''], (0, _reactackleCore.media)(item.breakpoint)(_templateObject, (0, _reactackleCore.getValueString)(item.width)));
	  });
	
	  return labelPosition === 'side' && (0, _styledComponents.css)(['width:', ';', ';'], (0, _reactackleCore.getValueString)(source.width), breakpoints);
	};
	
	/** STYLES */
	var SelectBoxLabelStyled = exports.SelectBoxLabelStyled = _styledComponents2.default.label.withConfig({
	  displayName: 'SelectBoxLabelStyled'
	})(['display:flex;user-select:none;', ';', ';', ';', ';', ';', ';'], labelBase, labelStyle, sizeProps, labelSelectSpacing, labelSideWidth, (0, _reactackleCore.transition)('color, font-size'));
	
	SelectBoxLabelStyled.propTypes = propTypes;
	SelectBoxLabelStyled.defaultProps = defaultProps;
	SelectBoxLabelStyled.displayName = 'SelectBoxLabelStyled';

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SelectBoxLabelTextStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * Define theme
	   * See https://github.com/styled-components/styled-components/blob/master/docs/theming.md
	   * for more information
	   */
	  theme: _propTypes2.default.object
	};
	
	/** Prop Receivers */
	var spacingProps = function spacingProps(_ref) {
	  var themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var marginRight = (0, _reactackleCore.getValueString)(theme.reactackle.components.selectBox.label.labelTooltipSpacing);
	
	  return '\n    margin-right: ' + marginRight + ';\n  ';
	};
	
	/** STYLES */
	var SelectBoxLabelTextStyled = exports.SelectBoxLabelTextStyled = _styledComponents2.default.span.withConfig({
	  displayName: 'SelectBoxLabelTextStyled'
	})(['', ';', ';'], /* Prettier workarount until issue is not fixed: https://github.com/prettier/prettier/issues/2291 */'', spacingProps);
	
	SelectBoxLabelTextStyled.propTypes = propTypes;
	SelectBoxLabelTextStyled.displayName = 'SelectBoxLabelTextStyled';

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SelectBoxStyled = undefined;
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var base = function base(_ref) {
	  var themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var fontFamily = theme.reactackle.fontFamily[theme.reactackle.body.fontFamily];
	
	  return '\n    &,\n    & *,\n    *::after,\n    *::before {\n      font-family: ' + fontFamily + ';\n      box-sizing: border-box;\n    }\n  ';
	};
	
	/** STYLES */
	var SelectBoxStyled = exports.SelectBoxStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'SelectBoxStyled'
	})(['display:flex;width:100%;max-width:100%;', ';'], base);
	
	SelectBoxStyled.displayName = 'SelectBoxStyled';

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.WrapperStyled = undefined;
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** Styles */
	var WrapperStyled = exports.WrapperStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'WrapperStyled'
	})(['position:relative;flex-grow:1;']);
	
	WrapperStyled.displayName = 'WrapperStyled';

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SidebarToggle = undefined;
	
	var _SidebarToggle = __webpack_require__(802);
	
	var _SidebarToggle2 = _interopRequireDefault(_SidebarToggle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.SidebarToggle = _SidebarToggle2.default;

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TextField = undefined;
	
	var _TextField = __webpack_require__(836);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.TextField = _TextField2.default;

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactPortal = __webpack_require__(238);
	
	var _reactackleCore = __webpack_require__(3);
	
	var _TooltipStyled = __webpack_require__(236);
	
	var _TooltipWrapperStyled = __webpack_require__(237);
	
	var _TooltipContentStyled = __webpack_require__(235);
	
	var _theme = __webpack_require__(883);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	(0, _reactackleCore.registerDefaultComponentTheme)('tooltip', _theme2.default);
	
	var propTypes = {
	  /**
	   * Text of the Tooltip
	   */
	  text: _propTypes2.default.string,
	  /**
	   * Determines x axis Tooltip position
	   */
	  positionX: _propTypes2.default.oneOf(['right', 'left']),
	  /**
	   * Determines y axis Tooltip position
	   */
	  positionY: _propTypes2.default.oneOf(['top', 'bottom']),
	  /**
	   * Determines whether Tooltip is visible
	   */
	  isVisible: _propTypes2.default.bool
	};
	
	var defaultProps = {
	  text: '',
	  positionX: 'right',
	  positionY: 'bottom',
	  isVisible: false
	};
	
	var Tooltip = function (_Component) {
	  _inherits(Tooltip, _Component);
	
	  function Tooltip(props) {
	    _classCallCheck(this, Tooltip);
	
	    var _this = _possibleConstructorReturn(this, (Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call(this, props));
	
	    _this.state = {
	      positionX: void 0,
	      positionY: void 0,
	      top: 0,
	      left: 0
	    };
	
	    _this._element = null;
	    _this._createElementRef = _this._createElementRef.bind(_this);
	    _this._setPosition = _this._setPosition.bind(_this);
	    return _this;
	  }
	
	  _createClass(Tooltip, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.addEventListener('resize', this._setPosition);
	      document.addEventListener('mousemove', this._setPosition);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this._setPosition);
	      document.removeEventListener('mousemove', this._setPosition);
	    }
	  }, {
	    key: '_setPosition',
	    value: function _setPosition(_ref) {
	      var _ref$clientX = _ref.clientX,
	          left = _ref$clientX === undefined ? 0 : _ref$clientX,
	          _ref$clientY = _ref.clientY,
	          top = _ref$clientY === undefined ? 0 : _ref$clientY;
	
	      if (!this._element || !this.props.isVisible) return;
	
	      var _element$getBoundingC = this._element.getBoundingClientRect(),
	          width = _element$getBoundingC.width,
	          height = _element$getBoundingC.height;
	
	      var positionX = void 0,
	          positionY = void 0;
	
	      if (left + width > document.body.clientWidth) positionX = 'left';else if (left < 0) positionX = 'right';
	
	      if (top + height > document.body.clientHeight) positionY = 'top';else if (top < 0) positionY = 'bottom';
	
	      this.setState({
	        left: left,
	        top: top,
	        positionX: positionX,
	        positionY: positionY
	      });
	    }
	  }, {
	    key: '_createElementRef',
	    value: function _createElementRef(ref) {
	      this._element = ref;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          left = _state.left,
	          top = _state.top;
	
	
	      return !this.props.isVisible ? null : _react2.default.createElement(
	        _reactPortal.Portal,
	        null,
	        _react2.default.createElement(
	          _TooltipWrapperStyled.TooltipWrapperStyled,
	          { style: { left: left, top: top } },
	          _react2.default.createElement(
	            _TooltipStyled.TooltipStyled,
	            {
	              innerRef: this._createElementRef,
	              visible: this.props.isVisible,
	              positionX: this.state.positionX || this.props.positionX,
	              positionY: this.state.positionY || this.props.positionY
	            },
	            _react2.default.createElement(
	              _TooltipContentStyled.TooltipContentStyled,
	              null,
	              this.props.text
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Tooltip;
	}(_react.Component);
	
	exports.default = Tooltip;
	
	
	Tooltip.propTypes = propTypes;
	Tooltip.defaultProps = defaultProps;
	Tooltip.displayName = 'Tooltip';

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.withEventListeners = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// event names coercion
	var withEventListeners = function withEventListeners(WrappedComponent) {
	  var WithEventListeners = function (_Component) {
	    _inherits(WithEventListeners, _Component);
	
	    function WithEventListeners(props) {
	      _classCallCheck(this, WithEventListeners);
	
	      var _this = _possibleConstructorReturn(this, (WithEventListeners.__proto__ || Object.getPrototypeOf(WithEventListeners)).call(this, props));
	
	      _this.state = {
	        eventListeners: {}
	      };
	
	      _this._toggleEventListener = _this._toggleEventListener.bind(_this);
	      _this._cleanEventListeners = _this._cleanEventListeners.bind(_this);
	      return _this;
	    }
	
	    _createClass(WithEventListeners, [{
	      key: '_toggleEventListener',
	      value: function _toggleEventListener(newListener) {
	        var _state$eventListeners = this.state.eventListeners,
	            existedListener = _state$eventListeners[newListener.event],
	            eventListeners = _objectWithoutProperties(_state$eventListeners, [newListener.event]);
	
	        if (existedListener) {
	          existedListener.target.removeEventListener(existedListener.event, existedListener.cb);
	          this.setState({ eventListeners: eventListeners });
	        } else {
	          var _target = newListener.target,
	              event = newListener.event,
	              cb = newListener.cb;
	
	          _target.addEventListener(event, cb);
	          this.setState(function (_ref) {
	            var eventListeners = _ref.eventListeners;
	            return {
	              eventListeners: _extends({}, eventListeners, _defineProperty({}, event, newListener))
	            };
	          });
	        }
	      }
	    }, {
	      key: '_cleanEventListeners',
	      value: function _cleanEventListeners() {
	        var _this2 = this;
	
	        var listeners = this.state.eventListeners;
	        Object.values(listeners).forEach(function (listener) {
	          _this2._toggleEventListener(listener);
	        });
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        return _react2.default.createElement(WrappedComponent, _extends({}, this.props, {
	          toggleEventListener: this._toggleEventListener,
	          cleanEventListeners: this._cleanEventListeners
	        }));
	      }
	    }]);
	
	    return WithEventListeners;
	  }(_react.Component);
	
	  return WithEventListeners;
	};
	exports.withEventListeners = withEventListeners;

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TooltipContentStyled = undefined;
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {};
	var defaultProps = {};
	
	var TooltipContentStyled = exports.TooltipContentStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'TooltipContentStyled'
	})(['color:inherit;font-size:inherit;line-height:inherit;']);
	
	TooltipContentStyled.propTypes = propTypes;
	TooltipContentStyled.defaultProps = defaultProps;
	TooltipContentStyled.displayName = 'TooltipContentStyled';

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TooltipStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  positionX: _propTypes2.default.string,
	  positionY: _propTypes2.default.string,
	  visible: _propTypes2.default.bool,
	  theme: _propTypes2.default.object
	};
	
	var defaultProps = {
	  positionX: 'right',
	  positionY: 'bottom',
	  visible: true
	};
	
	/** Prop Receivers */
	var baseProps = function baseProps(_ref) {
	  var themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var _theme$reactackle$com = theme.reactackle.components.tooltip,
	      backgroundColor = _theme$reactackle$com.backgroundColor,
	      borderRadius = _theme$reactackle$com.borderRadius,
	      paddingY = _theme$reactackle$com.paddingY,
	      paddingX = _theme$reactackle$com.paddingX,
	      fontSize = _theme$reactackle$com.fontSize,
	      fontColor = _theme$reactackle$com.fontColor,
	      lineHeight = _theme$reactackle$com.lineHeight,
	      minWidth = _theme$reactackle$com.minWidth,
	      maxWidth = _theme$reactackle$com.maxWidth;
	
	
	  var fontFamily = theme.reactackle.fontFamily[theme.reactackle.body.fontFamily];
	
	  return (0, _styledComponents.css)(['background-color:', ';border-radius:', ';padding:', ' ', ';font-size:', ';color:', ';line-height:', ';min-width:', ';max-width:', ';&,& *,*::after,*::before{font-family:', ';box-sizing:border-box;}'], backgroundColor, (0, _reactackleCore.getValueString)(borderRadius), (0, _reactackleCore.getValueString)(paddingY), (0, _reactackleCore.getValueString)(paddingX), (0, _reactackleCore.getValueString)(fontSize), fontColor, lineHeight, (0, _reactackleCore.getValueString)(minWidth), (0, _reactackleCore.getValueString)(maxWidth), fontFamily);
	};
	
	var visibility = function visibility(_ref2) {
	  var visible = _ref2.visible;
	  return 'opacity: ' + (visible ? '1' : '0') + ';';
	};
	
	var position = function position(_ref3) {
	  var positionY = _ref3.positionY,
	      positionX = _ref3.positionX,
	      themeFromProvider = _ref3.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var tooltipRefererSpacing = theme.reactackle.components.tooltip.tooltipRefererSpacing;
	
	  var spacing = (0, _reactackleCore.getValueString)(tooltipRefererSpacing);
	
	  var alignX = positionX === 'left' ? 'right: ' + spacing + ';' : '\n        left: ' + spacing + ';\n        transform: translateX(-100%);\n      ';
	
	  var alignY = positionY === 'top' ? '\n        top: -' + spacing + ';\n        transform: translateY(-100%);\n      ' : '\n        bottom: -' + spacing + ';\n        transform: translateY(100%);\n      ';
	
	  return (0, _styledComponents.css)(['', ';', ';'], alignX, alignY);
	};
	
	/** Styles */
	var TooltipStyled = exports.TooltipStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'TooltipStyled'
	})(['position:absolute;text-align:left;pointer-events:none;opacity:0;width:100%;user-select:none;', ';', ';', ';', ';'], (0, _reactackleCore.transition)('top, bottom, left, right, opacity'), baseProps, visibility, position);
	
	TooltipStyled.propTypes = propTypes;
	TooltipStyled.defaultProps = defaultProps;
	TooltipStyled.displayName = 'TooltipStyled';

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TooltipWrapperStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  theme: _propTypes2.default.object
	};
	
	var baseProps = function baseProps(_ref) {
	  var themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var zIndex = theme.reactackle.components.tooltip.zIndex;
	
	
	  return '\n    z-index: ' + zIndex + ';\n  ';
	};
	
	var TooltipWrapperStyled = exports.TooltipWrapperStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'TooltipWrapperStyled'
	})(['position:fixed;', ';'], baseProps);
	
	TooltipWrapperStyled.propTypes = propTypes;
	TooltipWrapperStyled.displayName = 'TooltipWrapperStyled';

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(17);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var KEYCODES = {
	  ESCAPE: 27
	};
	
	var Portal = function (_React$Component) {
	  _inherits(Portal, _React$Component);
	
	  function Portal() {
	    _classCallCheck(this, Portal);
	
	    var _this = _possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).call(this));
	
	    _this.state = { active: false };
	    _this.handleWrapperClick = _this.handleWrapperClick.bind(_this);
	    _this.closePortal = _this.closePortal.bind(_this);
	    _this.handleOutsideMouseClick = _this.handleOutsideMouseClick.bind(_this);
	    _this.handleKeydown = _this.handleKeydown.bind(_this);
	    _this.portal = null;
	    _this.node = null;
	    return _this;
	  }
	
	  _createClass(Portal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.closeOnEsc) {
	        document.addEventListener('keydown', this.handleKeydown);
	      }
	
	      if (this.props.closeOnOutsideClick) {
	        document.addEventListener('mouseup', this.handleOutsideMouseClick);
	        document.addEventListener('touchstart', this.handleOutsideMouseClick);
	      }
	
	      if (this.props.isOpened) {
	        this.openPortal();
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(newProps) {
	      // portal's 'is open' state is handled through the prop isOpened
	      if (typeof newProps.isOpened !== 'undefined') {
	        if (newProps.isOpened) {
	          if (this.state.active) {
	            this.renderPortal(newProps);
	          } else {
	            this.openPortal(newProps);
	          }
	        }
	        if (!newProps.isOpened && this.state.active) {
	          this.closePortal();
	        }
	      }
	
	      // portal handles its own 'is open' state
	      if (typeof newProps.isOpened === 'undefined' && this.state.active) {
	        this.renderPortal(newProps);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.props.closeOnEsc) {
	        document.removeEventListener('keydown', this.handleKeydown);
	      }
	
	      if (this.props.closeOnOutsideClick) {
	        document.removeEventListener('mouseup', this.handleOutsideMouseClick);
	        document.removeEventListener('touchstart', this.handleOutsideMouseClick);
	      }
	
	      this.closePortal(true);
	    }
	  }, {
	    key: 'handleWrapperClick',
	    value: function handleWrapperClick(e) {
	      e.preventDefault();
	      e.stopPropagation();
	      if (this.state.active) {
	        return;
	      }
	      this.openPortal();
	    }
	  }, {
	    key: 'openPortal',
	    value: function openPortal() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	
	      this.setState({ active: true });
	      this.renderPortal(props);
	      this.props.onOpen(this.node);
	    }
	  }, {
	    key: 'closePortal',
	    value: function closePortal() {
	      var _this2 = this;
	
	      var isUnmounted = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      var resetPortalState = function resetPortalState(overrideIsUnmounted) {
	        if (_this2.node) {
	          _reactDom2.default.unmountComponentAtNode(_this2.node);
	          document.body.removeChild(_this2.node);
	        }
	        _this2.portal = null;
	        _this2.node = null;
	
	        var finalIsUnmounted = overrideIsUnmounted === undefined ? isUnmounted : overrideIsUnmounted;
	
	        if (finalIsUnmounted !== true) {
	          _this2.setState({ active: false });
	        }
	      };
	
	      if (this.state.active) {
	        if (this.props.beforeClose) {
	          this.props.beforeClose(this.node, resetPortalState);
	        } else {
	          resetPortalState();
	        }
	
	        this.props.onClose();
	      }
	    }
	  }, {
	    key: 'handleOutsideMouseClick',
	    value: function handleOutsideMouseClick(e) {
	      if (!this.state.active) {
	        return;
	      }
	
	      var root = (0, _reactDom.findDOMNode)(this.portal);
	      if (root.contains(e.target) || e.button && e.button !== 0) {
	        return;
	      }
	
	      e.stopPropagation();
	      this.closePortal();
	    }
	  }, {
	    key: 'handleKeydown',
	    value: function handleKeydown(e) {
	      if (e.keyCode === KEYCODES.ESCAPE && this.state.active) {
	        this.closePortal();
	      }
	    }
	  }, {
	    key: 'renderPortal',
	    value: function renderPortal(props) {
	      if (!this.node) {
	        this.node = document.createElement('div');
	        document.body.appendChild(this.node);
	      }
	
	      var children = props.children;
	      // https://gist.github.com/jimfb/d99e0678e9da715ccf6454961ef04d1b
	      if (typeof props.children.type === 'function') {
	        children = _react2.default.cloneElement(props.children, { closePortal: this.closePortal });
	      }
	
	      this.portal = _reactDom2.default.unstable_renderSubtreeIntoContainer(this, children, this.node, this.props.onUpdate);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.props.openByClickOn) {
	        return _react2.default.cloneElement(this.props.openByClickOn, { onClick: this.handleWrapperClick });
	      }
	      return null;
	    }
	  }]);
	
	  return Portal;
	}(_react2.default.Component);
	
	exports.default = Portal;
	
	
	Portal.propTypes = {
	  children: _propTypes2.default.element.isRequired,
	  openByClickOn: _propTypes2.default.element,
	  closeOnEsc: _propTypes2.default.bool,
	  closeOnOutsideClick: _propTypes2.default.bool,
	  isOpened: _propTypes2.default.bool,
	  onOpen: _propTypes2.default.func,
	  onClose: _propTypes2.default.func,
	  beforeClose: _propTypes2.default.func,
	  onUpdate: _propTypes2.default.func
	};
	
	Portal.defaultProps = {
	  onOpen: function onOpen() {},
	  onClose: function onClose() {},
	  onUpdate: function onUpdate() {}
	};
	module.exports = exports['default'];


/***/ }),
/* 239 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = compose;
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(undefined, arguments));
	    };
	  });
	}

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ActionTypes = undefined;
	exports['default'] = createStore;
	
	var _isPlainObject = __webpack_require__(243);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _symbolObservable = __webpack_require__(247);
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = exports.ActionTypes = {
	  INIT: '@@redux/INIT'
	
	  /**
	   * Creates a Redux store that holds the state tree.
	   * The only way to change the data in the store is to call `dispatch()` on it.
	   *
	   * There should only be a single store in your app. To specify how different
	   * parts of the state tree respond to actions, you may combine several reducers
	   * into a single reducer function by using `combineReducers`.
	   *
	   * @param {Function} reducer A function that returns the next state tree, given
	   * the current state tree and the action to handle.
	   *
	   * @param {any} [preloadedState] The initial state. You may optionally specify it
	   * to hydrate the state from the server in universal apps, or to restore a
	   * previously serialized user session.
	   * If you use `combineReducers` to produce the root reducer function, this must be
	   * an object with the same shape as `combineReducers` keys.
	   *
	   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
	   * to enhance the store with third-party capabilities such as middleware,
	   * time travel, persistence, etc. The only store enhancer that ships with Redux
	   * is `applyMiddleware()`.
	   *
	   * @returns {Store} A Redux store that lets you read the state, dispatch actions
	   * and subscribe to changes.
	   */
	};function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!(0, _isPlainObject2['default'])(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      var listener = listeners[i];
	      listener();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.INIT });
	  }
	
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/tc39/proposal-observable
	   */
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object') {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return { unsubscribe: unsubscribe };
	      }
	    }, _ref[_symbolObservable2['default']] = function () {
	      return this;
	    }, _ref;
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[_symbolObservable2['default']] = observable, _ref2;
	}

/***/ }),
/* 241 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ }),
/* 242 */
[938, 898],
/* 243 */
[943, 892, 894, 899],
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(371);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(20)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!./chatclasses.css", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!./chatclasses.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(372);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(20)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!./poPrint.css", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!./poPrint.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(373);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(20)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!./photo.css", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!./photo.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ponyfill = __webpack_require__(916);
	
	var _ponyfill2 = _interopRequireDefault(_ponyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var root; /* global window */
	
	
	if (typeof self !== 'undefined') {
	  root = self;
	} else if (typeof window !== 'undefined') {
	  root = window;
	} else if (typeof global !== 'undefined') {
	  root = global;
	} else if (true) {
	  root = module;
	} else {
	  root = Function('return this')();
	}
	
	var result = (0, _ponyfill2['default'])(root);
	exports['default'] = result;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(33)(module)))

/***/ }),
/* 248 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getFontShorthand = getFontShorthand;
	exports.measureText = measureText;
	exports.updateInputWidth = updateInputWidth;
	exports["default"] = void 0;
	
	/**
	 * Gets font CSS shorthand property given element.
	 *
	 * @param {HTMLElement} element Element to get font CSS shorthand property from
	 */
	function getFontShorthand(element) {
	  var style = window.getComputedStyle(element);
	
	  if (style.font) {
	    return style.font;
	  }
	
	  var isFontDefined = style['font-family'] !== '';
	
	  if (!isFontDefined) {
	    return '';
	  }
	
	  return "".concat(style['font-style'], " ").concat(style['font-variant'], " ").concat(style['font-weight'], " ").concat(style['font-size'], " / ").concat(style['line-height'], " ").concat(style['font-family']);
	}
	/**
	 * Measures text width given text and font CSS shorthand.
	 *
	 * @param {String} text Text to measure
	 * @param {String} font Font to use when measuring the text
	 */
	
	
	function measureText(text, font) {
	  var canvas = measureText.canvas || (measureText.canvas = document.createElement('canvas'));
	  var context = canvas.getContext('2d');
	  context.font = font;
	
	  var _context$measureText = context.measureText(text),
	      width = _context$measureText.width;
	
	  return Math.ceil(width);
	}
	/**
	 * Updates input element width to fit its content given input element
	 * @param {HTMLInputElement} element
	 */
	
	
	function updateInputWidth(element) {
	  if (typeof window === 'undefined') {
	    return null;
	  }
	
	  var font = getFontShorthand(element);
	  var text = element.value || element.placeholder;
	  var width = measureText(text, font);
	  element.style.width = "".concat(width, "px");
	  return width;
	}
	
	var _default = updateInputWidth;
	exports["default"] = _default;

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "v1", {
	  enumerable: true,
	  get: function () {
	    return _v.default;
	  }
	});
	Object.defineProperty(exports, "v3", {
	  enumerable: true,
	  get: function () {
	    return _v2.default;
	  }
	});
	Object.defineProperty(exports, "v4", {
	  enumerable: true,
	  get: function () {
	    return _v3.default;
	  }
	});
	Object.defineProperty(exports, "v5", {
	  enumerable: true,
	  get: function () {
	    return _v4.default;
	  }
	});
	
	var _v = _interopRequireDefault(__webpack_require__(925));
	
	var _v2 = _interopRequireDefault(__webpack_require__(926));
	
	var _v3 = _interopRequireDefault(__webpack_require__(927));
	
	var _v4 = _interopRequireDefault(__webpack_require__(928));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 250 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = rng;
	// Unique ID creation requires a high quality random # generator. In the browser we therefore
	// require the crypto API and do not support built-in fallback to lower quality random number
	// generators (like Math.random()).
	// getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
	// find the complete implementation of crypto (msCrypto) on IE11.
	var getRandomValues = typeof crypto != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != 'undefined' && typeof msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto);
	var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
	
	function rng() {
	  if (!getRandomValues) {
	    throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
	  }
	
	  return getRandomValues(rnds8);
	}

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = _default;
	exports.URL = exports.DNS = void 0;
	
	var _bytesToUuid = _interopRequireDefault(__webpack_require__(137));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function uuidToBytes(uuid) {
	  // Note: We assume we're being passed a valid uuid string
	  var bytes = [];
	  uuid.replace(/[a-fA-F0-9]{2}/g, function (hex) {
	    bytes.push(parseInt(hex, 16));
	  });
	  return bytes;
	}
	
	function stringToBytes(str) {
	  str = unescape(encodeURIComponent(str)); // UTF8 escape
	
	  var bytes = new Array(str.length);
	
	  for (var i = 0; i < str.length; i++) {
	    bytes[i] = str.charCodeAt(i);
	  }
	
	  return bytes;
	}
	
	const DNS = '6ba7b810-9dad-11d1-80b4-00c04fd430c8';
	exports.DNS = DNS;
	const URL = '6ba7b811-9dad-11d1-80b4-00c04fd430c8';
	exports.URL = URL;
	
	function _default(name, version, hashfunc) {
	  var generateUUID = function (value, namespace, buf, offset) {
	    var off = buf && offset || 0;
	    if (typeof value == 'string') value = stringToBytes(value);
	    if (typeof namespace == 'string') namespace = uuidToBytes(namespace);
	    if (!Array.isArray(value)) throw TypeError('value must be an array of bytes');
	    if (!Array.isArray(namespace) || namespace.length !== 16) throw TypeError('namespace must be uuid string or an Array of 16 byte values'); // Per 4.3
	
	    var bytes = hashfunc(namespace.concat(value));
	    bytes[6] = bytes[6] & 0x0f | version;
	    bytes[8] = bytes[8] & 0x3f | 0x80;
	
	    if (buf) {
	      for (var idx = 0; idx < 16; ++idx) {
	        buf[off + idx] = bytes[idx];
	      }
	    }
	
	    return buf || (0, _bytesToUuid.default)(bytes);
	  }; // Function#name is not settable on some platforms (#270)
	
	
	  try {
	    generateUUID.name = name;
	  } catch (err) {} // For CommonJS default export support
	
	
	  generateUUID.DNS = DNS;
	  generateUUID.URL = URL;
	  return generateUUID;
	}

/***/ }),
/* 252 */
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),
/* 253 */
/***/ (function(module, exports) {

	function _arrayWithoutHoles(arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
	      arr2[i] = arr[i];
	    }
	
	    return arr2;
	  }
	}
	
	module.exports = _arrayWithoutHoles;

/***/ }),
/* 254 */
/***/ (function(module, exports) {

	function _iterableToArray(iter) {
	  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
	}
	
	module.exports = _iterableToArray;

/***/ }),
/* 255 */
/***/ (function(module, exports) {

	function _nonIterableSpread() {
	  throw new TypeError("Invalid attempt to spread non-iterable instance");
	}
	
	module.exports = _nonIterableSpread;

/***/ }),
/* 256 */
/***/ (function(module, exports) {

	function _setPrototypeOf(o, p) {
	  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;
	    return o;
	  };
	
	  return _setPrototypeOf(o, p);
	}
	
	module.exports = _setPrototypeOf;

/***/ }),
/* 257 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/* eslint-disable */
	// murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
	function murmurhash2_32_gc(str) {
	  var l = str.length,
	      h = l ^ l,
	      i = 0,
	      k;
	
	  while (l >= 4) {
	    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
	    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	    k ^= k >>> 24;
	    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
	    l -= 4;
	    ++i;
	  }
	
	  switch (l) {
	    case 3:
	      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
	
	    case 2:
	      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
	
	    case 1:
	      h ^= str.charCodeAt(i) & 0xff;
	      h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	  }
	
	  h ^= h >>> 13;
	  h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	  h ^= h >>> 15;
	  return (h >>> 0).toString(36);
	}
	
	exports.default = murmurhash2_32_gc;


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var memoize = _interopDefault(__webpack_require__(142));
	
	var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|itemProp|itemScope|itemType|itemID|itemRef|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
	
	var index = memoize(function (prop) {
	  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
	  /* o */
	  && prop.charCodeAt(1) === 110
	  /* n */
	  && prop.charCodeAt(2) < 91;
	}
	/* Z+1 */
	);
	
	exports.default = index;


/***/ }),
/* 259 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function stylis_min (W) {
	  function M(d, c, e, h, a) {
	    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
	      g = e.charCodeAt(l);
	      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);
	
	      if (0 === b + n + v + m) {
	        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
	          switch (g) {
	            case 32:
	            case 9:
	            case 59:
	            case 13:
	            case 10:
	              break;
	
	            default:
	              f += e.charAt(l);
	          }
	
	          g = 59;
	        }
	
	        switch (g) {
	          case 123:
	            f = f.trim();
	            q = f.charCodeAt(0);
	            k = 1;
	
	            for (t = ++l; l < B;) {
	              switch (g = e.charCodeAt(l)) {
	                case 123:
	                  k++;
	                  break;
	
	                case 125:
	                  k--;
	                  break;
	
	                case 47:
	                  switch (g = e.charCodeAt(l + 1)) {
	                    case 42:
	                    case 47:
	                      a: {
	                        for (u = l + 1; u < J; ++u) {
	                          switch (e.charCodeAt(u)) {
	                            case 47:
	                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
	                                l = u + 1;
	                                break a;
	                              }
	
	                              break;
	
	                            case 10:
	                              if (47 === g) {
	                                l = u + 1;
	                                break a;
	                              }
	
	                          }
	                        }
	
	                        l = u;
	                      }
	
	                  }
	
	                  break;
	
	                case 91:
	                  g++;
	
	                case 40:
	                  g++;
	
	                case 34:
	                case 39:
	                  for (; l++ < J && e.charCodeAt(l) !== g;) {
	                  }
	
	              }
	
	              if (0 === k) break;
	              l++;
	            }
	
	            k = e.substring(t, l);
	            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));
	
	            switch (q) {
	              case 64:
	                0 < r && (f = f.replace(N, ''));
	                g = f.charCodeAt(1);
	
	                switch (g) {
	                  case 100:
	                  case 109:
	                  case 115:
	                  case 45:
	                    r = c;
	                    break;
	
	                  default:
	                    r = O;
	                }
	
	                k = M(c, r, k, g, a + 1);
	                t = k.length;
	                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
	                if (0 < t) switch (g) {
	                  case 115:
	                    f = f.replace(da, ea);
	
	                  case 100:
	                  case 109:
	                  case 45:
	                    k = f + '{' + k + '}';
	                    break;
	
	                  case 107:
	                    f = f.replace(fa, '$1 $2');
	                    k = f + '{' + k + '}';
	                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
	                    break;
	
	                  default:
	                    k = f + k, 112 === h && (k = (p += k, ''));
	                } else k = '';
	                break;
	
	              default:
	                k = M(c, X(c, f, I), k, h, a + 1);
	            }
	
	            F += k;
	            k = I = r = u = q = 0;
	            f = '';
	            g = e.charCodeAt(++l);
	            break;
	
	          case 125:
	          case 59:
	            f = (0 < r ? f.replace(N, '') : f).trim();
	            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
	              case 0:
	                break;
	
	              case 64:
	                if (105 === g || 99 === g) {
	                  G += f + e.charAt(l);
	                  break;
	                }
	
	              default:
	                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
	            }
	            I = r = u = q = 0;
	            f = '';
	            g = e.charCodeAt(++l);
	        }
	      }
	
	      switch (g) {
	        case 13:
	        case 10:
	          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
	          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
	          z = 1;
	          D++;
	          break;
	
	        case 59:
	        case 125:
	          if (0 === b + n + v + m) {
	            z++;
	            break;
	          }
	
	        default:
	          z++;
	          y = e.charAt(l);
	
	          switch (g) {
	            case 9:
	            case 32:
	              if (0 === n + m + b) switch (x) {
	                case 44:
	                case 58:
	                case 9:
	                case 32:
	                  y = '';
	                  break;
	
	                default:
	                  32 !== g && (y = ' ');
	              }
	              break;
	
	            case 0:
	              y = '\\0';
	              break;
	
	            case 12:
	              y = '\\f';
	              break;
	
	            case 11:
	              y = '\\v';
	              break;
	
	            case 38:
	              0 === n + b + m && (r = I = 1, y = '\f' + y);
	              break;
	
	            case 108:
	              if (0 === n + b + m + E && 0 < u) switch (l - u) {
	                case 2:
	                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);
	
	                case 8:
	                  111 === K && (E = K);
	              }
	              break;
	
	            case 58:
	              0 === n + b + m && (u = l);
	              break;
	
	            case 44:
	              0 === b + v + n + m && (r = 1, y += '\r');
	              break;
	
	            case 34:
	            case 39:
	              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
	              break;
	
	            case 91:
	              0 === n + b + v && m++;
	              break;
	
	            case 93:
	              0 === n + b + v && m--;
	              break;
	
	            case 41:
	              0 === n + b + m && v--;
	              break;
	
	            case 40:
	              if (0 === n + b + m) {
	                if (0 === q) switch (2 * x + 3 * K) {
	                  case 533:
	                    break;
	
	                  default:
	                    q = 1;
	                }
	                v++;
	              }
	
	              break;
	
	            case 64:
	              0 === b + v + n + m + u + k && (k = 1);
	              break;
	
	            case 42:
	            case 47:
	              if (!(0 < n + m + v)) switch (b) {
	                case 0:
	                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
	                    case 235:
	                      b = 47;
	                      break;
	
	                    case 220:
	                      t = l, b = 42;
	                  }
	
	                  break;
	
	                case 42:
	                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
	              }
	          }
	
	          0 === b && (f += y);
	      }
	
	      K = x;
	      x = g;
	      l++;
	    }
	
	    t = p.length;
	
	    if (0 < t) {
	      r = c;
	      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
	      p = r.join(',') + '{' + p + '}';
	
	      if (0 !== w * E) {
	        2 !== w || L(p, 2) || (E = 0);
	
	        switch (E) {
	          case 111:
	            p = p.replace(ha, ':-moz-$1') + p;
	            break;
	
	          case 112:
	            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
	        }
	
	        E = 0;
	      }
	    }
	
	    return G + p + F;
	  }
	
	  function X(d, c, e) {
	    var h = c.trim().split(ia);
	    c = h;
	    var a = h.length,
	        m = d.length;
	
	    switch (m) {
	      case 0:
	      case 1:
	        var b = 0;
	
	        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
	          c[b] = Z(d, c[b], e).trim();
	        }
	
	        break;
	
	      default:
	        var v = b = 0;
	
	        for (c = []; b < a; ++b) {
	          for (var n = 0; n < m; ++n) {
	            c[v++] = Z(d[n] + ' ', h[b], e).trim();
	          }
	        }
	
	    }
	
	    return c;
	  }
	
	  function Z(d, c, e) {
	    var h = c.charCodeAt(0);
	    33 > h && (h = (c = c.trim()).charCodeAt(0));
	
	    switch (h) {
	      case 38:
	        return c.replace(F, '$1' + d.trim());
	
	      case 58:
	        return d.trim() + c.replace(F, '$1' + d.trim());
	
	      default:
	        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
	    }
	
	    return d + c;
	  }
	
	  function P(d, c, e, h) {
	    var a = d + ';',
	        m = 2 * c + 3 * e + 4 * h;
	
	    if (944 === m) {
	      d = a.indexOf(':', 9) + 1;
	      var b = a.substring(d, a.length - 1).trim();
	      b = a.substring(0, d).trim() + b + ';';
	      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
	    }
	
	    if (0 === w || 2 === w && !L(a, 1)) return a;
	
	    switch (m) {
	      case 1015:
	        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;
	
	      case 951:
	        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;
	
	      case 963:
	        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;
	
	      case 1009:
	        if (100 !== a.charCodeAt(4)) break;
	
	      case 969:
	      case 942:
	        return '-webkit-' + a + a;
	
	      case 978:
	        return '-webkit-' + a + '-moz-' + a + a;
	
	      case 1019:
	      case 983:
	        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;
	
	      case 883:
	        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
	        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
	        break;
	
	      case 932:
	        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
	          case 103:
	            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;
	
	          case 115:
	            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;
	
	          case 98:
	            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
	        }
	        return '-webkit-' + a + '-ms-' + a + a;
	
	      case 964:
	        return '-webkit-' + a + '-ms-flex-' + a + a;
	
	      case 1023:
	        if (99 !== a.charCodeAt(8)) break;
	        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
	        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;
	
	      case 1005:
	        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;
	
	      case 1e3:
	        b = a.substring(13).trim();
	        c = b.indexOf('-') + 1;
	
	        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
	          case 226:
	            b = a.replace(G, 'tb');
	            break;
	
	          case 232:
	            b = a.replace(G, 'tb-rl');
	            break;
	
	          case 220:
	            b = a.replace(G, 'lr');
	            break;
	
	          default:
	            return a;
	        }
	
	        return '-webkit-' + a + '-ms-' + b + a;
	
	      case 1017:
	        if (-1 === a.indexOf('sticky', 9)) break;
	
	      case 975:
	        c = (a = d).length - 10;
	        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();
	
	        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
	          case 203:
	            if (111 > b.charCodeAt(8)) break;
	
	          case 115:
	            a = a.replace(b, '-webkit-' + b) + ';' + a;
	            break;
	
	          case 207:
	          case 102:
	            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
	        }
	
	        return a + ';';
	
	      case 938:
	        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
	          case 105:
	            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;
	
	          case 115:
	            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;
	
	          default:
	            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
	        }
	        break;
	
	      case 973:
	      case 989:
	        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
	
	      case 931:
	      case 953:
	        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
	        break;
	
	      case 962:
	        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
	    }
	
	    return a;
	  }
	
	  function L(d, c) {
	    var e = d.indexOf(1 === c ? ':' : '{'),
	        h = d.substring(0, 3 !== c ? e : 10);
	    e = d.substring(e + 1, d.length - 1);
	    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
	  }
	
	  function ea(d, c) {
	    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
	    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
	  }
	
	  function H(d, c, e, h, a, m, b, v, n, q) {
	    for (var g = 0, x = c, w; g < A; ++g) {
	      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
	        case void 0:
	        case !1:
	        case !0:
	        case null:
	          break;
	
	        default:
	          x = w;
	      }
	    }
	
	    if (x !== c) return x;
	  }
	
	  function T(d) {
	    switch (d) {
	      case void 0:
	      case null:
	        A = S.length = 0;
	        break;
	
	      default:
	        if ('function' === typeof d) S[A++] = d;else if ('object' === typeof d) for (var c = 0, e = d.length; c < e; ++c) {
	          T(d[c]);
	        } else Y = !!d | 0;
	    }
	
	    return T;
	  }
	
	  function U(d) {
	    d = d.prefix;
	    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
	    return U;
	  }
	
	  function B(d, c) {
	    var e = d;
	    33 > e.charCodeAt(0) && (e = e.trim());
	    V = e;
	    e = [V];
	
	    if (0 < A) {
	      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
	      void 0 !== h && 'string' === typeof h && (c = h);
	    }
	
	    var a = M(O, e, c, 0, 0);
	    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
	    V = '';
	    E = 0;
	    z = D = 1;
	    return a;
	  }
	
	  var ca = /^\0+/g,
	      N = /[\0\r\f]/g,
	      aa = /: */g,
	      ka = /zoo|gra/,
	      ma = /([,: ])(transform)/g,
	      ia = /,\r+?/g,
	      F = /([\t\r\n ])*\f?&/g,
	      fa = /@(k\w+)\s*(\S*)\s*/,
	      Q = /::(place)/g,
	      ha = /:(read-only)/g,
	      G = /[svh]\w+-[tblr]{2}/,
	      da = /\(\s*(.*)\s*\)/g,
	      oa = /([\s\S]*?);/g,
	      ba = /-self|flex-/g,
	      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
	      la = /stretch|:\s*\w+\-(?:conte|avail)/,
	      ja = /([^-])(image-set\()/,
	      z = 1,
	      D = 1,
	      E = 0,
	      w = 1,
	      O = [],
	      S = [],
	      A = 0,
	      R = null,
	      Y = 0,
	      V = '';
	  B.use = T;
	  B.set = U;
	  void 0 !== W && U(W);
	  return B;
	}
	
	exports.default = stylis_min;


/***/ }),
/* 260 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var isBrowser = "object" !== 'undefined';
	function getRegisteredStyles(registered, registeredStyles, classNames) {
	  var rawClassName = '';
	  classNames.split(' ').forEach(function (className) {
	    if (registered[className] !== undefined) {
	      registeredStyles.push(registered[className]);
	    } else {
	      rawClassName += className + " ";
	    }
	  });
	  return rawClassName;
	}
	var insertStyles = function insertStyles(cache, serialized, isStringTag) {
	  var className = cache.key + "-" + serialized.name;
	
	  if ( // we only need to add the styles to the registered cache if the
	  // class name could be used further down
	  // the tree but if it's a string tag, we know it won't
	  // so we don't have to add it to registered cache.
	  // this improves memory usage since we can avoid storing the whole style string
	  (isStringTag === false || // we need to always store it if we're in compat mode and
	  // in node since emotion-server relies on whether a style is in
	  // the registered cache to know whether a style is global or not
	  // also, note that this check will be dead code eliminated in the browser
	  isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) {
	    cache.registered[className] = serialized.styles;
	  }
	
	  if (cache.inserted[serialized.name] === undefined) {
	    var current = serialized;
	
	    do {
	      var maybeStyles = cache.insert("." + className, current, cache.sheet, true);
	
	      current = current.next;
	    } while (current !== undefined);
	  }
	};
	
	exports.getRegisteredStyles = getRegisteredStyles;
	exports.insertStyles = insertStyles;


/***/ }),
/* 261 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var weakMemoize = function weakMemoize(func) {
	  // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
	  var cache = new WeakMap();
	  return function (arg) {
	    if (cache.has(arg)) {
	      // $FlowFixMe
	      return cache.get(arg);
	    }
	
	    var ret = func(arg);
	    cache.set(arg, ret);
	    return ret;
	  };
	};
	
	exports.default = weakMemoize;


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0
	
	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.
	
	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */
	/* global global, define, System, Reflect, Promise */
	var __extends;
	var __assign;
	var __rest;
	var __decorate;
	var __param;
	var __metadata;
	var __awaiter;
	var __generator;
	var __exportStar;
	var __values;
	var __read;
	var __spread;
	var __spreadArrays;
	var __await;
	var __asyncGenerator;
	var __asyncDelegator;
	var __asyncValues;
	var __makeTemplateObject;
	var __importStar;
	var __importDefault;
	var __classPrivateFieldGet;
	var __classPrivateFieldSet;
	(function (factory) {
	    var root = typeof global === "object" ? global : typeof self === "object" ? self : typeof this === "object" ? this : {};
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_RESULT__ = function (exports) { factory(createExporter(root, createExporter(exports))); }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }
	    else if (typeof module === "object" && typeof module.exports === "object") {
	        factory(createExporter(root, createExporter(module.exports)));
	    }
	    else {
	        factory(createExporter(root));
	    }
	    function createExporter(exports, previous) {
	        if (exports !== root) {
	            if (typeof Object.create === "function") {
	                Object.defineProperty(exports, "__esModule", { value: true });
	            }
	            else {
	                exports.__esModule = true;
	            }
	        }
	        return function (id, v) { return exports[id] = previous ? previous(id, v) : v; };
	    }
	})
	(function (exporter) {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	
	    __extends = function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	        }
	        return t;
	    };
	
	    __rest = function (s, e) {
	        var t = {};
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	            t[p] = s[p];
	        if (s != null && typeof Object.getOwnPropertySymbols === "function")
	            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	                if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
	                    t[p[i]] = s[p[i]];
	            }
	        return t;
	    };
	
	    __decorate = function (decorators, target, key, desc) {
	        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	        else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	        return c > 3 && r && Object.defineProperty(target, key, r), r;
	    };
	
	    __param = function (paramIndex, decorator) {
	        return function (target, key) { decorator(target, key, paramIndex); }
	    };
	
	    __metadata = function (metadataKey, metadataValue) {
	        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
	    };
	
	    __awaiter = function (thisArg, _arguments, P, generator) {
	        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	        return new (P || (P = Promise))(function (resolve, reject) {
	            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	            step((generator = generator.apply(thisArg, _arguments || [])).next());
	        });
	    };
	
	    __generator = function (thisArg, body) {
	        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	        function verb(n) { return function (v) { return step([n, v]); }; }
	        function step(op) {
	            if (f) throw new TypeError("Generator is already executing.");
	            while (_) try {
	                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	                if (y = 0, t) op = [op[0] & 2, t.value];
	                switch (op[0]) {
	                    case 0: case 1: t = op; break;
	                    case 4: _.label++; return { value: op[1], done: false };
	                    case 5: _.label++; y = op[1]; op = [0]; continue;
	                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                    default:
	                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                        if (t[2]) _.ops.pop();
	                        _.trys.pop(); continue;
	                }
	                op = body.call(thisArg, _);
	            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	        }
	    };
	
	    __exportStar = function (m, exports) {
	        for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	    };
	
	    __values = function (o) {
	        var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
	        if (m) return m.call(o);
	        if (o && typeof o.length === "number") return {
	            next: function () {
	                if (o && i >= o.length) o = void 0;
	                return { value: o && o[i++], done: !o };
	            }
	        };
	        throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
	    };
	
	    __read = function (o, n) {
	        var m = typeof Symbol === "function" && o[Symbol.iterator];
	        if (!m) return o;
	        var i = m.call(o), r, ar = [], e;
	        try {
	            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	        }
	        catch (error) { e = { error: error }; }
	        finally {
	            try {
	                if (r && !r.done && (m = i["return"])) m.call(i);
	            }
	            finally { if (e) throw e.error; }
	        }
	        return ar;
	    };
	
	    __spread = function () {
	        for (var ar = [], i = 0; i < arguments.length; i++)
	            ar = ar.concat(__read(arguments[i]));
	        return ar;
	    };
	
	    __spreadArrays = function () {
	        for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
	        for (var r = Array(s), k = 0, i = 0; i < il; i++)
	            for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	                r[k] = a[j];
	        return r;
	    };
	
	    __await = function (v) {
	        return this instanceof __await ? (this.v = v, this) : new __await(v);
	    };
	
	    __asyncGenerator = function (thisArg, _arguments, generator) {
	        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	        var g = generator.apply(thisArg, _arguments || []), i, q = [];
	        return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
	        function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
	        function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
	        function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);  }
	        function fulfill(value) { resume("next", value); }
	        function reject(value) { resume("throw", value); }
	        function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
	    };
	
	    __asyncDelegator = function (o) {
	        var i, p;
	        return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
	        function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
	    };
	
	    __asyncValues = function (o) {
	        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	        var m = o[Symbol.asyncIterator], i;
	        return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
	        function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
	        function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
	    };
	
	    __makeTemplateObject = function (cooked, raw) {
	        if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
	        return cooked;
	    };
	
	    __importStar = function (mod) {
	        if (mod && mod.__esModule) return mod;
	        var result = {};
	        if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
	        result["default"] = mod;
	        return result;
	    };
	
	    __importDefault = function (mod) {
	        return (mod && mod.__esModule) ? mod : { "default": mod };
	    };
	
	    __classPrivateFieldGet = function (receiver, privateMap) {
	        if (!privateMap.has(receiver)) {
	            throw new TypeError("attempted to get private field on non-instance");
	        }
	        return privateMap.get(receiver);
	    };
	
	    __classPrivateFieldSet = function (receiver, privateMap, value) {
	        if (!privateMap.has(receiver)) {
	            throw new TypeError("attempted to set private field on non-instance");
	        }
	        privateMap.set(receiver, value);
	        return value;
	    }
	
	    exporter("__extends", __extends);
	    exporter("__assign", __assign);
	    exporter("__rest", __rest);
	    exporter("__decorate", __decorate);
	    exporter("__param", __param);
	    exporter("__metadata", __metadata);
	    exporter("__awaiter", __awaiter);
	    exporter("__generator", __generator);
	    exporter("__exportStar", __exportStar);
	    exporter("__values", __values);
	    exporter("__read", __read);
	    exporter("__spread", __spread);
	    exporter("__spreadArrays", __spreadArrays);
	    exporter("__await", __await);
	    exporter("__asyncGenerator", __asyncGenerator);
	    exporter("__asyncDelegator", __asyncDelegator);
	    exporter("__asyncValues", __asyncValues);
	    exporter("__makeTemplateObject", __makeTemplateObject);
	    exporter("__importStar", __importStar);
	    exporter("__importDefault", __importDefault);
	    exporter("__classPrivateFieldGet", __classPrivateFieldGet);
	    exporter("__classPrivateFieldSet", __classPrivateFieldSet);
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function() {var firebase = __webpack_require__(39).default;/*
	
	 Copyright The Closure Library Authors.
	 SPDX-License-Identifier: Apache-2.0
	*/
	var k,aa="function"==typeof Object.defineProperties?Object.defineProperty:function(a,b,c){a!=Array.prototype&&a!=Object.prototype&&(a[b]=c.value)};function ba(a){a=["object"==typeof window&&window,"object"==typeof self&&self,"object"==typeof global&&global,a];for(var b=0;b<a.length;++b){var c=a[b];if(c&&c.Math==Math)return c}return globalThis}var ca=ba(this);
	function da(a,b){if(b){var c=ca;a=a.split(".");for(var d=0;d<a.length-1;d++){var e=a[d];e in c||(c[e]={});c=c[e]}a=a[a.length-1];d=c[a];b=b(d);b!=d&&null!=b&&aa(c,a,{configurable:!0,writable:!0,value:b})}}function ea(a){var b=0;return function(){return b<a.length?{done:!1,value:a[b++]}:{done:!0}}}function fa(a){var b="undefined"!=typeof Symbol&&Symbol.iterator&&a[Symbol.iterator];return b?b.call(a):{next:ea(a)}}
	da("Promise",function(a){function b(g){this.b=0;this.c=void 0;this.a=[];var h=this.f();try{g(h.resolve,h.reject)}catch(m){h.reject(m)}}function c(){this.a=null}function d(g){return g instanceof b?g:new b(function(h){h(g)})}if(a)return a;c.prototype.b=function(g){if(null==this.a){this.a=[];var h=this;this.c(function(){h.g()})}this.a.push(g)};var e=ca.setTimeout;c.prototype.c=function(g){e(g,0)};c.prototype.g=function(){for(;this.a&&this.a.length;){var g=this.a;this.a=[];for(var h=0;h<g.length;++h){var m=
	g[h];g[h]=null;try{m()}catch(p){this.f(p)}}}this.a=null};c.prototype.f=function(g){this.c(function(){throw g;})};b.prototype.f=function(){function g(p){return function(v){m||(m=!0,p.call(h,v))}}var h=this,m=!1;return{resolve:g(this.m),reject:g(this.g)}};b.prototype.m=function(g){if(g===this)this.g(new TypeError("A Promise cannot resolve to itself"));else if(g instanceof b)this.s(g);else{a:switch(typeof g){case "object":var h=null!=g;break a;case "function":h=!0;break a;default:h=!1}h?this.u(g):this.h(g)}};
	b.prototype.u=function(g){var h=void 0;try{h=g.then}catch(m){this.g(m);return}"function"==typeof h?this.w(h,g):this.h(g)};b.prototype.g=function(g){this.i(2,g)};b.prototype.h=function(g){this.i(1,g)};b.prototype.i=function(g,h){if(0!=this.b)throw Error("Cannot settle("+g+", "+h+"): Promise already settled in state"+this.b);this.b=g;this.c=h;this.l()};b.prototype.l=function(){if(null!=this.a){for(var g=0;g<this.a.length;++g)f.b(this.a[g]);this.a=null}};var f=new c;b.prototype.s=function(g){var h=this.f();
	g.Oa(h.resolve,h.reject)};b.prototype.w=function(g,h){var m=this.f();try{g.call(h,m.resolve,m.reject)}catch(p){m.reject(p)}};b.prototype.then=function(g,h){function m(A,Q){return"function"==typeof A?function(xa){try{p(A(xa))}catch(ud){v(ud)}}:Q}var p,v,C=new b(function(A,Q){p=A;v=Q});this.Oa(m(g,p),m(h,v));return C};b.prototype.catch=function(g){return this.then(void 0,g)};b.prototype.Oa=function(g,h){function m(){switch(p.b){case 1:g(p.c);break;case 2:h(p.c);break;default:throw Error("Unexpected state: "+
	p.b);}}var p=this;null==this.a?f.b(m):this.a.push(m)};b.resolve=d;b.reject=function(g){return new b(function(h,m){m(g)})};b.race=function(g){return new b(function(h,m){for(var p=fa(g),v=p.next();!v.done;v=p.next())d(v.value).Oa(h,m)})};b.all=function(g){var h=fa(g),m=h.next();return m.done?d([]):new b(function(p,v){function C(xa){return function(ud){A[xa]=ud;Q--;0==Q&&p(A)}}var A=[],Q=0;do A.push(void 0),Q++,d(m.value).Oa(C(A.length-1),v),m=h.next();while(!m.done)})};return b});
	var ha=ha||{},l=this||self,ia=/^[\w+/_-]+[=]{0,2}$/,ja=null;function ka(){}
	function la(a){var b=typeof a;if("object"==b)if(a){if(a instanceof Array)return"array";if(a instanceof Object)return b;var c=Object.prototype.toString.call(a);if("[object Window]"==c)return"object";if("[object Array]"==c||"number"==typeof a.length&&"undefined"!=typeof a.splice&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("splice"))return"array";if("[object Function]"==c||"undefined"!=typeof a.call&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("call"))return"function"}else return"null";
	else if("function"==b&&"undefined"==typeof a.call)return"object";return b}function ma(a){var b=la(a);return"array"==b||"object"==b&&"number"==typeof a.length}function n(a){return"function"==la(a)}function q(a){var b=typeof a;return"object"==b&&null!=a||"function"==b}function na(a){return Object.prototype.hasOwnProperty.call(a,oa)&&a[oa]||(a[oa]=++pa)}var oa="closure_uid_"+(1E9*Math.random()>>>0),pa=0;function qa(a,b,c){return a.call.apply(a.bind,arguments)}
	function ra(a,b,c){if(!a)throw Error();if(2<arguments.length){var d=Array.prototype.slice.call(arguments,2);return function(){var e=Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(e,d);return a.apply(b,e)}}return function(){return a.apply(b,arguments)}}function r(a,b,c){Function.prototype.bind&&-1!=Function.prototype.bind.toString().indexOf("native code")?r=qa:r=ra;return r.apply(null,arguments)}
	function sa(a,b){var c=Array.prototype.slice.call(arguments,1);return function(){var d=c.slice();d.push.apply(d,arguments);return a.apply(this,d)}}var ta=Date.now||function(){return+new Date};function t(a,b){function c(){}c.prototype=b.prototype;a.Za=b.prototype;a.prototype=new c;a.prototype.constructor=a};/*
	
	 Copyright 2017 Google Inc.
	
	 Licensed under the Apache License, Version 2.0 (the "License");
	 you may not use this file except in compliance with the License.
	 You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	 Unless required by applicable law or agreed to in writing, software
	 distributed under the License is distributed on an "AS IS" BASIS,
	 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 See the License for the specific language governing permissions and
	 limitations under the License.
	*/
	function u(a,b,c){this.code=ua+a;this.message=b||va[a]||"";this.a=c||null}t(u,Error);u.prototype.v=function(){var a={code:this.code,message:this.message};this.a&&(a.serverResponse=this.a);return a};u.prototype.toJSON=function(){return this.v()};function wa(a){var b=a&&a.code;return b?new u(b.substring(ua.length),a.message,a.serverResponse):null}
	var ua="auth/",va={"admin-restricted-operation":"This operation is restricted to administrators only.","argument-error":"","app-not-authorized":"This app, identified by the domain where it's hosted, is not authorized to use Firebase Authentication with the provided API key. Review your key configuration in the Google API console.","app-not-installed":"The requested mobile application corresponding to the identifier (Android package name or iOS bundle ID) provided is not installed on this device.",
	"captcha-check-failed":"The reCAPTCHA response token provided is either invalid, expired, already used or the domain associated with it does not match the list of whitelisted domains.","code-expired":"The SMS code has expired. Please re-send the verification code to try again.","cordova-not-ready":"Cordova framework is not ready.","cors-unsupported":"This browser is not supported.","credential-already-in-use":"This credential is already associated with a different user account.","custom-token-mismatch":"The custom token corresponds to a different audience.",
	"requires-recent-login":"This operation is sensitive and requires recent authentication. Log in again before retrying this request.","dynamic-link-not-activated":"Please activate Dynamic Links in the Firebase Console and agree to the terms and conditions.","email-change-needs-verification":"Multi-factor users must always have a verified email.","email-already-in-use":"The email address is already in use by another account.","expired-action-code":"The action code has expired. ","cancelled-popup-request":"This operation has been cancelled due to another conflicting popup being opened.",
	"internal-error":"An internal error has occurred.","invalid-app-credential":"The phone verification request contains an invalid application verifier. The reCAPTCHA token response is either invalid or expired.","invalid-app-id":"The mobile app identifier is not registed for the current project.","invalid-user-token":"This user's credential isn't valid for this project. This can happen if the user's token has been tampered with, or if the user isn't for the project associated with this API key.","invalid-auth-event":"An internal error has occurred.",
	"invalid-verification-code":"The SMS verification code used to create the phone auth credential is invalid. Please resend the verification code sms and be sure use the verification code provided by the user.","invalid-continue-uri":"The continue URL provided in the request is invalid.","invalid-cordova-configuration":"The following Cordova plugins must be installed to enable OAuth sign-in: cordova-plugin-buildinfo, cordova-universal-links-plugin, cordova-plugin-browsertab, cordova-plugin-inappbrowser and cordova-plugin-customurlscheme.",
	"invalid-custom-token":"The custom token format is incorrect. Please check the documentation.","invalid-dynamic-link-domain":"The provided dynamic link domain is not configured or authorized for the current project.","invalid-email":"The email address is badly formatted.","invalid-api-key":"Your API key is invalid, please check you have copied it correctly.","invalid-cert-hash":"The SHA-1 certificate hash provided is invalid.","invalid-credential":"The supplied auth credential is malformed or has expired.",
	"invalid-message-payload":"The email template corresponding to this action contains invalid characters in its message. Please fix by going to the Auth email templates section in the Firebase Console.","invalid-multi-factor-session":"The request does not contain a valid proof of first factor successful sign-in.","invalid-oauth-provider":"EmailAuthProvider is not supported for this operation. This operation only supports OAuth providers.","invalid-oauth-client-id":"The OAuth client ID provided is either invalid or does not match the specified API key.",
	"unauthorized-domain":"This domain is not authorized for OAuth operations for your Firebase project. Edit the list of authorized domains from the Firebase console.","invalid-action-code":"The action code is invalid. This can happen if the code is malformed, expired, or has already been used.","wrong-password":"The password is invalid or the user does not have a password.","invalid-persistence-type":"The specified persistence type is invalid. It can only be local, session or none.","invalid-phone-number":"The format of the phone number provided is incorrect. Please enter the phone number in a format that can be parsed into E.164 format. E.164 phone numbers are written in the format [+][country code][subscriber number including area code].",
	"invalid-provider-id":"The specified provider ID is invalid.","invalid-recipient-email":"The email corresponding to this action failed to send as the provided recipient email address is invalid.","invalid-sender":"The email template corresponding to this action contains an invalid sender email or name. Please fix by going to the Auth email templates section in the Firebase Console.","invalid-verification-id":"The verification ID used to create the phone auth credential is invalid.","invalid-tenant-id":"The Auth instance's tenant ID is invalid.",
	"multi-factor-info-not-found":"The user does not have a second factor matching the identifier provided.","multi-factor-auth-required":"Proof of ownership of a second factor is required to complete sign-in.","missing-android-pkg-name":"An Android Package Name must be provided if the Android App is required to be installed.","auth-domain-config-required":"Be sure to include authDomain when calling firebase.initializeApp(), by following the instructions in the Firebase console.","missing-app-credential":"The phone verification request is missing an application verifier assertion. A reCAPTCHA response token needs to be provided.",
	"missing-verification-code":"The phone auth credential was created with an empty SMS verification code.","missing-continue-uri":"A continue URL must be provided in the request.","missing-iframe-start":"An internal error has occurred.","missing-ios-bundle-id":"An iOS Bundle ID must be provided if an App Store ID is provided.","missing-multi-factor-info":"No second factor identifier is provided.","missing-multi-factor-session":"The request is missing proof of first factor successful sign-in.","missing-or-invalid-nonce":"The request does not contain a valid nonce. This can occur if the SHA-256 hash of the provided raw nonce does not match the hashed nonce in the ID token payload.",
	"missing-phone-number":"To send verification codes, provide a phone number for the recipient.","missing-verification-id":"The phone auth credential was created with an empty verification ID.","app-deleted":"This instance of FirebaseApp has been deleted.","account-exists-with-different-credential":"An account already exists with the same email address but different sign-in credentials. Sign in using a provider associated with this email address.","network-request-failed":"A network error (such as timeout, interrupted connection or unreachable host) has occurred.",
	"no-auth-event":"An internal error has occurred.","no-such-provider":"User was not linked to an account with the given provider.","null-user":"A null user object was provided as the argument for an operation which requires a non-null user object.","operation-not-allowed":"The given sign-in provider is disabled for this Firebase project. Enable it in the Firebase console, under the sign-in method tab of the Auth section.","operation-not-supported-in-this-environment":'This operation is not supported in the environment this application is running on. "location.protocol" must be http, https or chrome-extension and web storage must be enabled.',
	"popup-blocked":"Unable to establish a connection with the popup. It may have been blocked by the browser.","popup-closed-by-user":"The popup has been closed by the user before finalizing the operation.","provider-already-linked":"User can only be linked to one identity for the given provider.","quota-exceeded":"The project's quota for this operation has been exceeded.","redirect-cancelled-by-user":"The redirect operation has been cancelled by the user before finalizing.","redirect-operation-pending":"A redirect sign-in operation is already pending.",
	"rejected-credential":"The request contains malformed or mismatching credentials.","second-factor-already-in-use":"The second factor is already enrolled on this account.","maximum-second-factor-count-exceeded":"The maximum allowed number of second factors on a user has been exceeded.","tenant-id-mismatch":"The provided tenant ID does not match the Auth instance's tenant ID",timeout:"The operation has timed out.","user-token-expired":"The user's credential is no longer valid. The user must sign in again.",
	"too-many-requests":"We have blocked all requests from this device due to unusual activity. Try again later.","unauthorized-continue-uri":"The domain of the continue URL is not whitelisted.  Please whitelist the domain in the Firebase console.","unsupported-first-factor":"Enrolling a second factor or signing in with a multi-factor account requires sign-in with a supported first factor.","unsupported-persistence-type":"The current environment does not support the specified persistence type.","unsupported-tenant-operation":"This operation is not supported in a multi-tenant context.",
	"unverified-email":"The operation requires a verified email.","user-cancelled":"The user did not grant your application the permissions it requested.","user-not-found":"There is no user record corresponding to this identifier. The user may have been deleted.","user-disabled":"The user account has been disabled by an administrator.","user-mismatch":"The supplied credentials do not correspond to the previously signed in user.","user-signed-out":"","weak-password":"The password must be 6 characters long or more.",
	"web-storage-unsupported":"This browser is not supported or 3rd party cookies and data may be disabled."};var ya={hd:{Ra:"https://staging-identitytoolkit.sandbox.googleapis.com/identitytoolkit/v3/relyingparty/",Xa:"https://staging-securetoken.sandbox.googleapis.com/v1/token",Ua:"https://staging-identitytoolkit.sandbox.googleapis.com/v2/",id:"b"},pd:{Ra:"https://www.googleapis.com/identitytoolkit/v3/relyingparty/",Xa:"https://securetoken.googleapis.com/v1/token",Ua:"https://identitytoolkit.googleapis.com/v2/",id:"p"},rd:{Ra:"https://staging-www.sandbox.googleapis.com/identitytoolkit/v3/relyingparty/",
	Xa:"https://staging-securetoken.sandbox.googleapis.com/v1/token",Ua:"https://staging-identitytoolkit.sandbox.googleapis.com/v2/",id:"s"},sd:{Ra:"https://www-googleapis-test.sandbox.google.com/identitytoolkit/v3/relyingparty/",Xa:"https://test-securetoken.sandbox.googleapis.com/v1/token",Ua:"https://test-identitytoolkit.sandbox.googleapis.com/v2/",id:"t"}};
	function za(a){for(var b in ya)if(ya[b].id===a)return a=ya[b],{firebaseEndpoint:a.Ra,secureTokenEndpoint:a.Xa,identityPlatformEndpoint:a.Ua};return null}var Aa;Aa=za("__EID__")?"__EID__":void 0;function Ba(a){if(!a)return!1;try{return!!a.$goog_Thenable}catch(b){return!1}};function w(a){if(Error.captureStackTrace)Error.captureStackTrace(this,w);else{var b=Error().stack;b&&(this.stack=b)}a&&(this.message=String(a))}t(w,Error);w.prototype.name="CustomError";function Ca(a,b){a=a.split("%s");for(var c="",d=a.length-1,e=0;e<d;e++)c+=a[e]+(e<b.length?b[e]:"%s");w.call(this,c+a[d])}t(Ca,w);Ca.prototype.name="AssertionError";function Da(a,b){throw new Ca("Failure"+(a?": "+a:""),Array.prototype.slice.call(arguments,1));};function Ea(a,b){this.c=a;this.f=b;this.b=0;this.a=null}Ea.prototype.get=function(){if(0<this.b){this.b--;var a=this.a;this.a=a.next;a.next=null}else a=this.c();return a};function Fa(a,b){a.f(b);100>a.b&&(a.b++,b.next=a.a,a.a=b)};function Ga(){this.b=this.a=null}var Ia=new Ea(function(){return new Ha},function(a){a.reset()});Ga.prototype.add=function(a,b){var c=Ia.get();c.set(a,b);this.b?this.b.next=c:this.a=c;this.b=c};function Ja(){var a=Ka,b=null;a.a&&(b=a.a,a.a=a.a.next,a.a||(a.b=null),b.next=null);return b}function Ha(){this.next=this.b=this.a=null}Ha.prototype.set=function(a,b){this.a=a;this.b=b;this.next=null};Ha.prototype.reset=function(){this.next=this.b=this.a=null};var La=Array.prototype.indexOf?function(a,b){return Array.prototype.indexOf.call(a,b,void 0)}:function(a,b){if("string"===typeof a)return"string"!==typeof b||1!=b.length?-1:a.indexOf(b,0);for(var c=0;c<a.length;c++)if(c in a&&a[c]===b)return c;return-1},x=Array.prototype.forEach?function(a,b,c){Array.prototype.forEach.call(a,b,c)}:function(a,b,c){for(var d=a.length,e="string"===typeof a?a.split(""):a,f=0;f<d;f++)f in e&&b.call(c,e[f],f,a)};
	function Ma(a,b){for(var c="string"===typeof a?a.split(""):a,d=a.length-1;0<=d;--d)d in c&&b.call(void 0,c[d],d,a)}
	var Na=Array.prototype.filter?function(a,b){return Array.prototype.filter.call(a,b,void 0)}:function(a,b){for(var c=a.length,d=[],e=0,f="string"===typeof a?a.split(""):a,g=0;g<c;g++)if(g in f){var h=f[g];b.call(void 0,h,g,a)&&(d[e++]=h)}return d},Oa=Array.prototype.map?function(a,b){return Array.prototype.map.call(a,b,void 0)}:function(a,b){for(var c=a.length,d=Array(c),e="string"===typeof a?a.split(""):a,f=0;f<c;f++)f in e&&(d[f]=b.call(void 0,e[f],f,a));return d},Pa=Array.prototype.some?function(a,
	b){return Array.prototype.some.call(a,b,void 0)}:function(a,b){for(var c=a.length,d="string"===typeof a?a.split(""):a,e=0;e<c;e++)if(e in d&&b.call(void 0,d[e],e,a))return!0;return!1};function Qa(a){a:{var b=Ra;for(var c=a.length,d="string"===typeof a?a.split(""):a,e=0;e<c;e++)if(e in d&&b.call(void 0,d[e],e,a)){b=e;break a}b=-1}return 0>b?null:"string"===typeof a?a.charAt(b):a[b]}function Sa(a,b){return 0<=La(a,b)}
	function Ta(a,b){b=La(a,b);var c;(c=0<=b)&&Array.prototype.splice.call(a,b,1);return c}function Ua(a,b){var c=0;Ma(a,function(d,e){b.call(void 0,d,e,a)&&1==Array.prototype.splice.call(a,e,1).length&&c++})}function Va(a){return Array.prototype.concat.apply([],arguments)}function Wa(a){var b=a.length;if(0<b){for(var c=Array(b),d=0;d<b;d++)c[d]=a[d];return c}return[]};var Xa=String.prototype.trim?function(a){return a.trim()}:function(a){return/^[\s\xa0]*([\s\S]*?)[\s\xa0]*$/.exec(a)[1]},Ya=/&/g,Za=/</g,$a=/>/g,ab=/"/g,bb=/'/g,cb=/\x00/g,db=/[\x00&<>"']/;function y(a,b){return-1!=a.indexOf(b)}function eb(a,b){return a<b?-1:a>b?1:0};var fb;a:{var gb=l.navigator;if(gb){var hb=gb.userAgent;if(hb){fb=hb;break a}}fb=""}function z(a){return y(fb,a)};function ib(a,b){for(var c in a)b.call(void 0,a[c],c,a)}function jb(a){for(var b in a)return!1;return!0}function kb(a){var b={},c;for(c in a)b[c]=a[c];return b}var lb="constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");function B(a,b){for(var c,d,e=1;e<arguments.length;e++){d=arguments[e];for(c in d)a[c]=d[c];for(var f=0;f<lb.length;f++)c=lb[f],Object.prototype.hasOwnProperty.call(d,c)&&(a[c]=d[c])}};function mb(a,b){a:{try{var c=a&&a.ownerDocument,d=c&&(c.defaultView||c.parentWindow);d=d||l;if(d.Element&&d.Location){var e=d;break a}}catch(g){}e=null}if(e&&"undefined"!=typeof e[b]&&(!a||!(a instanceof e[b])&&(a instanceof e.Location||a instanceof e.Element))){if(q(a))try{var f=a.constructor.displayName||a.constructor.name||Object.prototype.toString.call(a)}catch(g){f="<object could not be stringified>"}else f=void 0===a?"undefined":null===a?"null":typeof a;Da("Argument is not a %s (or a non-Element, non-Location mock); got: %s",
	b,f)}};function nb(a,b){this.a=a===ob&&b||"";this.b=pb}nb.prototype.ra=!0;nb.prototype.qa=function(){return this.a};nb.prototype.toString=function(){return"Const{"+this.a+"}"};function qb(a){if(a instanceof nb&&a.constructor===nb&&a.b===pb)return a.a;Da("expected object of type Const, got '"+a+"'");return"type_error:Const"}var pb={},ob={},rb=new nb(ob,"");function sb(a,b){this.a=a===tb&&b||"";this.b=ub}sb.prototype.ra=!0;sb.prototype.qa=function(){return this.a.toString()};sb.prototype.toString=function(){return"TrustedResourceUrl{"+this.a+"}"};function vb(a){if(a instanceof sb&&a.constructor===sb&&a.b===ub)return a.a;Da("expected object of type TrustedResourceUrl, got '"+a+"' of type "+la(a));return"type_error:TrustedResourceUrl"}
	function wb(a,b){var c=qb(a);if(!xb.test(c))throw Error("Invalid TrustedResourceUrl format: "+c);a=c.replace(yb,function(d,e){if(!Object.prototype.hasOwnProperty.call(b,e))throw Error('Found marker, "'+e+'", in format string, "'+c+'", but no valid label mapping found in args: '+JSON.stringify(b));d=b[e];return d instanceof nb?qb(d):encodeURIComponent(String(d))});return new sb(tb,a)}
	var yb=/%{(\w+)}/g,xb=/^((https:)?\/\/[0-9a-z.:[\]-]+\/|\/[^/\\]|[^:/\\%]+\/|[^:/\\%]*[?#]|about:blank#)/i,ub={},tb={};function zb(a,b){this.a=a===Ab&&b||"";this.b=Bb}zb.prototype.ra=!0;zb.prototype.qa=function(){return this.a.toString()};zb.prototype.toString=function(){return"SafeUrl{"+this.a+"}"};function Cb(a){if(a instanceof zb&&a.constructor===zb&&a.b===Bb)return a.a;Da("expected object of type SafeUrl, got '"+a+"' of type "+la(a));return"type_error:SafeUrl"}var Db=/^(?:(?:https?|mailto|ftp):|[^:/?#]*(?:[/?#]|$))/i;
	function Eb(a){if(a instanceof zb)return a;a="object"==typeof a&&a.ra?a.qa():String(a);Db.test(a)||(a="about:invalid#zClosurez");return new zb(Ab,a)}var Bb={},Ab={};function Fb(){this.a="";this.b=Gb}Fb.prototype.ra=!0;Fb.prototype.qa=function(){return this.a.toString()};Fb.prototype.toString=function(){return"SafeHtml{"+this.a+"}"};function Hb(a){if(a instanceof Fb&&a.constructor===Fb&&a.b===Gb)return a.a;Da("expected object of type SafeHtml, got '"+a+"' of type "+la(a));return"type_error:SafeHtml"}var Gb={};function Ib(a){var b=new Fb;b.a=a;return b}Ib("<!DOCTYPE html>");var Jb=Ib("");Ib("<br>");function Kb(a){var b=new sb(tb,qb(rb));mb(a,"HTMLIFrameElement");a.src=vb(b).toString()}function Lb(a,b){mb(a,"HTMLScriptElement");a.src=vb(b);if(null===ja)b:{b=l.document;if((b=b.querySelector&&b.querySelector("script[nonce]"))&&(b=b.nonce||b.getAttribute("nonce"))&&ia.test(b)){ja=b;break b}ja=""}b=ja;b&&a.setAttribute("nonce",b)};function Mb(a,b){for(var c=a.split("%s"),d="",e=Array.prototype.slice.call(arguments,1);e.length&&1<c.length;)d+=c.shift()+e.shift();return d+c.join("%s")}function Nb(a){db.test(a)&&(-1!=a.indexOf("&")&&(a=a.replace(Ya,"&amp;")),-1!=a.indexOf("<")&&(a=a.replace(Za,"&lt;")),-1!=a.indexOf(">")&&(a=a.replace($a,"&gt;")),-1!=a.indexOf('"')&&(a=a.replace(ab,"&quot;")),-1!=a.indexOf("'")&&(a=a.replace(bb,"&#39;")),-1!=a.indexOf("\x00")&&(a=a.replace(cb,"&#0;")));return a};function Ob(a){Ob[" "](a);return a}Ob[" "]=ka;function Pb(a,b){var c=Qb;return Object.prototype.hasOwnProperty.call(c,a)?c[a]:c[a]=b(a)};var Rb=z("Opera"),Sb=z("Trident")||z("MSIE"),Tb=z("Edge"),Ub=Tb||Sb,Vb=z("Gecko")&&!(y(fb.toLowerCase(),"webkit")&&!z("Edge"))&&!(z("Trident")||z("MSIE"))&&!z("Edge"),Wb=y(fb.toLowerCase(),"webkit")&&!z("Edge");function Xb(){var a=l.document;return a?a.documentMode:void 0}var Yb;
	a:{var Zb="",$b=function(){var a=fb;if(Vb)return/rv:([^\);]+)(\)|;)/.exec(a);if(Tb)return/Edge\/([\d\.]+)/.exec(a);if(Sb)return/\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(a);if(Wb)return/WebKit\/(\S+)/.exec(a);if(Rb)return/(?:Version)[ \/]?(\S+)/.exec(a)}();$b&&(Zb=$b?$b[1]:"");if(Sb){var ac=Xb();if(null!=ac&&ac>parseFloat(Zb)){Yb=String(ac);break a}}Yb=Zb}var Qb={};
	function bc(a){return Pb(a,function(){for(var b=0,c=Xa(String(Yb)).split("."),d=Xa(String(a)).split("."),e=Math.max(c.length,d.length),f=0;0==b&&f<e;f++){var g=c[f]||"",h=d[f]||"";do{g=/(\d*)(\D*)(.*)/.exec(g)||["","","",""];h=/(\d*)(\D*)(.*)/.exec(h)||["","","",""];if(0==g[0].length&&0==h[0].length)break;b=eb(0==g[1].length?0:parseInt(g[1],10),0==h[1].length?0:parseInt(h[1],10))||eb(0==g[2].length,0==h[2].length)||eb(g[2],h[2]);g=g[3];h=h[3]}while(0==b)}return 0<=b})}var cc;
	cc=l.document&&Sb?Xb():void 0;try{(new self.OffscreenCanvas(0,0)).getContext("2d")}catch(a){}var dc=!Sb||9<=Number(cc);function ec(a){var b=document;return"string"===typeof a?b.getElementById(a):a}function fc(a,b){ib(b,function(c,d){c&&"object"==typeof c&&c.ra&&(c=c.qa());"style"==d?a.style.cssText=c:"class"==d?a.className=c:"for"==d?a.htmlFor=c:gc.hasOwnProperty(d)?a.setAttribute(gc[d],c):0==d.lastIndexOf("aria-",0)||0==d.lastIndexOf("data-",0)?a.setAttribute(d,c):a[d]=c})}
	var gc={cellpadding:"cellPadding",cellspacing:"cellSpacing",colspan:"colSpan",frameborder:"frameBorder",height:"height",maxlength:"maxLength",nonce:"nonce",role:"role",rowspan:"rowSpan",type:"type",usemap:"useMap",valign:"vAlign",width:"width"};
	function hc(a,b,c){var d=arguments,e=document,f=String(d[0]),g=d[1];if(!dc&&g&&(g.name||g.type)){f=["<",f];g.name&&f.push(' name="',Nb(g.name),'"');if(g.type){f.push(' type="',Nb(g.type),'"');var h={};B(h,g);delete h.type;g=h}f.push(">");f=f.join("")}f=ic(e,f);g&&("string"===typeof g?f.className=g:Array.isArray(g)?f.className=g.join(" "):fc(f,g));2<d.length&&jc(e,f,d);return f}
	function jc(a,b,c){function d(g){g&&b.appendChild("string"===typeof g?a.createTextNode(g):g)}for(var e=2;e<c.length;e++){var f=c[e];!ma(f)||q(f)&&0<f.nodeType?d(f):x(kc(f)?Wa(f):f,d)}}function ic(a,b){b=String(b);"application/xhtml+xml"===a.contentType&&(b=b.toLowerCase());return a.createElement(b)}function kc(a){if(a&&"number"==typeof a.length){if(q(a))return"function"==typeof a.item||"string"==typeof a.item;if(n(a))return"function"==typeof a.item}return!1};function lc(a){l.setTimeout(function(){throw a;},0)}var mc;
	function nc(){var a=l.MessageChannel;"undefined"===typeof a&&"undefined"!==typeof window&&window.postMessage&&window.addEventListener&&!z("Presto")&&(a=function(){var e=ic(document,"IFRAME");e.style.display="none";Kb(e);document.documentElement.appendChild(e);var f=e.contentWindow;e=f.document;e.open();e.write(Hb(Jb));e.close();var g="callImmediate"+Math.random(),h="file:"==f.location.protocol?"*":f.location.protocol+"//"+f.location.host;e=r(function(m){if(("*"==h||m.origin==h)&&m.data==g)this.port1.onmessage()},
	this);f.addEventListener("message",e,!1);this.port1={};this.port2={postMessage:function(){f.postMessage(g,h)}}});if("undefined"!==typeof a&&!z("Trident")&&!z("MSIE")){var b=new a,c={},d=c;b.port1.onmessage=function(){if(void 0!==c.next){c=c.next;var e=c.Db;c.Db=null;e()}};return function(e){d.next={Db:e};d=d.next;b.port2.postMessage(0)}}return function(e){l.setTimeout(e,0)}};function oc(a,b){pc||qc();rc||(pc(),rc=!0);Ka.add(a,b)}var pc;function qc(){if(l.Promise&&l.Promise.resolve){var a=l.Promise.resolve(void 0);pc=function(){a.then(sc)}}else pc=function(){var b=sc;!n(l.setImmediate)||l.Window&&l.Window.prototype&&!z("Edge")&&l.Window.prototype.setImmediate==l.setImmediate?(mc||(mc=nc()),mc(b)):l.setImmediate(b)}}var rc=!1,Ka=new Ga;function sc(){for(var a;a=Ja();){try{a.a.call(a.b)}catch(b){lc(b)}Fa(Ia,a)}rc=!1};function D(a,b){this.a=tc;this.i=void 0;this.f=this.b=this.c=null;this.g=this.h=!1;if(a!=ka)try{var c=this;a.call(b,function(d){uc(c,vc,d)},function(d){if(!(d instanceof wc))try{if(d instanceof Error)throw d;throw Error("Promise rejected.");}catch(e){}uc(c,xc,d)})}catch(d){uc(this,xc,d)}}var tc=0,vc=2,xc=3;function yc(){this.next=this.f=this.b=this.g=this.a=null;this.c=!1}yc.prototype.reset=function(){this.f=this.b=this.g=this.a=null;this.c=!1};var zc=new Ea(function(){return new yc},function(a){a.reset()});
	function Ac(a,b,c){var d=zc.get();d.g=a;d.b=b;d.f=c;return d}function E(a){if(a instanceof D)return a;var b=new D(ka);uc(b,vc,a);return b}function F(a){return new D(function(b,c){c(a)})}function Bc(a,b,c){Cc(a,b,c,null)||oc(sa(b,a))}function Dc(a){return new D(function(b,c){var d=a.length,e=[];if(d)for(var f=function(p,v){d--;e[p]=v;0==d&&b(e)},g=function(p){c(p)},h=0,m;h<a.length;h++)m=a[h],Bc(m,sa(f,h),g);else b(e)})}
	function Ec(a){return new D(function(b){var c=a.length,d=[];if(c)for(var e=function(h,m,p){c--;d[h]=m?{Mb:!0,value:p}:{Mb:!1,reason:p};0==c&&b(d)},f=0,g;f<a.length;f++)g=a[f],Bc(g,sa(e,f,!0),sa(e,f,!1));else b(d)})}D.prototype.then=function(a,b,c){return Fc(this,n(a)?a:null,n(b)?b:null,c)};D.prototype.$goog_Thenable=!0;k=D.prototype;k.ma=function(a,b){a=Ac(a,a,b);a.c=!0;Gc(this,a);return this};k.o=function(a,b){return Fc(this,null,a,b)};
	k.cancel=function(a){if(this.a==tc){var b=new wc(a);oc(function(){Hc(this,b)},this)}};function Hc(a,b){if(a.a==tc)if(a.c){var c=a.c;if(c.b){for(var d=0,e=null,f=null,g=c.b;g&&(g.c||(d++,g.a==a&&(e=g),!(e&&1<d)));g=g.next)e||(f=g);e&&(c.a==tc&&1==d?Hc(c,b):(f?(d=f,d.next==c.f&&(c.f=d),d.next=d.next.next):Ic(c),Jc(c,e,xc,b)))}a.c=null}else uc(a,xc,b)}function Gc(a,b){a.b||a.a!=vc&&a.a!=xc||Kc(a);a.f?a.f.next=b:a.b=b;a.f=b}
	function Fc(a,b,c,d){var e=Ac(null,null,null);e.a=new D(function(f,g){e.g=b?function(h){try{var m=b.call(d,h);f(m)}catch(p){g(p)}}:f;e.b=c?function(h){try{var m=c.call(d,h);void 0===m&&h instanceof wc?g(h):f(m)}catch(p){g(p)}}:g});e.a.c=a;Gc(a,e);return e.a}k.Yc=function(a){this.a=tc;uc(this,vc,a)};k.Zc=function(a){this.a=tc;uc(this,xc,a)};
	function uc(a,b,c){a.a==tc&&(a===c&&(b=xc,c=new TypeError("Promise cannot resolve to itself")),a.a=1,Cc(c,a.Yc,a.Zc,a)||(a.i=c,a.a=b,a.c=null,Kc(a),b!=xc||c instanceof wc||Lc(a,c)))}function Cc(a,b,c,d){if(a instanceof D)return Gc(a,Ac(b||ka,c||null,d)),!0;if(Ba(a))return a.then(b,c,d),!0;if(q(a))try{var e=a.then;if(n(e))return Mc(a,e,b,c,d),!0}catch(f){return c.call(d,f),!0}return!1}
	function Mc(a,b,c,d,e){function f(m){h||(h=!0,d.call(e,m))}function g(m){h||(h=!0,c.call(e,m))}var h=!1;try{b.call(a,g,f)}catch(m){f(m)}}function Kc(a){a.h||(a.h=!0,oc(a.ec,a))}function Ic(a){var b=null;a.b&&(b=a.b,a.b=b.next,b.next=null);a.b||(a.f=null);return b}k.ec=function(){for(var a;a=Ic(this);)Jc(this,a,this.a,this.i);this.h=!1};
	function Jc(a,b,c,d){if(c==xc&&b.b&&!b.c)for(;a&&a.g;a=a.c)a.g=!1;if(b.a)b.a.c=null,Nc(b,c,d);else try{b.c?b.g.call(b.f):Nc(b,c,d)}catch(e){Oc.call(null,e)}Fa(zc,b)}function Nc(a,b,c){b==vc?a.g.call(a.f,c):a.b&&a.b.call(a.f,c)}function Lc(a,b){a.g=!0;oc(function(){a.g&&Oc.call(null,b)})}var Oc=lc;function wc(a){w.call(this,a)}t(wc,w);wc.prototype.name="cancel";function Pc(){0!=Qc&&(Rc[na(this)]=this);this.wa=this.wa;this.na=this.na}var Qc=0,Rc={};Pc.prototype.wa=!1;function Sc(a){if(!a.wa&&(a.wa=!0,a.Ba(),0!=Qc)){var b=na(a);if(0!=Qc&&a.na&&0<a.na.length)throw Error(a+" did not empty its onDisposeCallbacks queue. This probably means it overrode dispose() or disposeInternal() without calling the superclass' method.");delete Rc[b]}}Pc.prototype.Ba=function(){if(this.na)for(;this.na.length;)this.na.shift()()};var Tc=Object.freeze||function(a){return a};var Uc=!Sb||9<=Number(cc),Vc=Sb&&!bc("9"),Wc=function(){if(!l.addEventListener||!Object.defineProperty)return!1;var a=!1,b=Object.defineProperty({},"passive",{get:function(){a=!0}});try{l.addEventListener("test",ka,b),l.removeEventListener("test",ka,b)}catch(c){}return a}();function Xc(a,b){this.type=a;this.b=this.target=b;this.defaultPrevented=!1}Xc.prototype.preventDefault=function(){this.defaultPrevented=!0};function Yc(a,b){Xc.call(this,a?a.type:"");this.relatedTarget=this.b=this.target=null;this.button=this.screenY=this.screenX=this.clientY=this.clientX=0;this.key="";this.metaKey=this.shiftKey=this.altKey=this.ctrlKey=!1;this.pointerId=0;this.pointerType="";this.a=null;if(a){var c=this.type=a.type,d=a.changedTouches&&a.changedTouches.length?a.changedTouches[0]:null;this.target=a.target||a.srcElement;this.b=b;if(b=a.relatedTarget){if(Vb){a:{try{Ob(b.nodeName);var e=!0;break a}catch(f){}e=!1}e||(b=null)}}else"mouseover"==
	c?b=a.fromElement:"mouseout"==c&&(b=a.toElement);this.relatedTarget=b;d?(this.clientX=void 0!==d.clientX?d.clientX:d.pageX,this.clientY=void 0!==d.clientY?d.clientY:d.pageY,this.screenX=d.screenX||0,this.screenY=d.screenY||0):(this.clientX=void 0!==a.clientX?a.clientX:a.pageX,this.clientY=void 0!==a.clientY?a.clientY:a.pageY,this.screenX=a.screenX||0,this.screenY=a.screenY||0);this.button=a.button;this.key=a.key||"";this.ctrlKey=a.ctrlKey;this.altKey=a.altKey;this.shiftKey=a.shiftKey;this.metaKey=
	a.metaKey;this.pointerId=a.pointerId||0;this.pointerType="string"===typeof a.pointerType?a.pointerType:Zc[a.pointerType]||"";this.a=a;a.defaultPrevented&&this.preventDefault()}}t(Yc,Xc);var Zc=Tc({2:"touch",3:"pen",4:"mouse"});Yc.prototype.preventDefault=function(){Yc.Za.preventDefault.call(this);var a=this.a;if(a.preventDefault)a.preventDefault();else if(a.returnValue=!1,Vc)try{if(a.ctrlKey||112<=a.keyCode&&123>=a.keyCode)a.keyCode=-1}catch(b){}};Yc.prototype.f=function(){return this.a};var $c="closure_listenable_"+(1E6*Math.random()|0),ad=0;function bd(a,b,c,d,e){this.listener=a;this.proxy=null;this.src=b;this.type=c;this.capture=!!d;this.Ta=e;this.key=++ad;this.ua=this.Na=!1}function cd(a){a.ua=!0;a.listener=null;a.proxy=null;a.src=null;a.Ta=null};function dd(a){this.src=a;this.a={};this.b=0}dd.prototype.add=function(a,b,c,d,e){var f=a.toString();a=this.a[f];a||(a=this.a[f]=[],this.b++);var g=ed(a,b,d,e);-1<g?(b=a[g],c||(b.Na=!1)):(b=new bd(b,this.src,f,!!d,e),b.Na=c,a.push(b));return b};function fd(a,b){var c=b.type;c in a.a&&Ta(a.a[c],b)&&(cd(b),0==a.a[c].length&&(delete a.a[c],a.b--))}function ed(a,b,c,d){for(var e=0;e<a.length;++e){var f=a[e];if(!f.ua&&f.listener==b&&f.capture==!!c&&f.Ta==d)return e}return-1};var gd="closure_lm_"+(1E6*Math.random()|0),hd={},id=0;function jd(a,b,c,d,e){if(d&&d.once)kd(a,b,c,d,e);else if(Array.isArray(b))for(var f=0;f<b.length;f++)jd(a,b[f],c,d,e);else c=ld(c),a&&a[$c]?md(a,b,c,q(d)?!!d.capture:!!d,e):nd(a,b,c,!1,d,e)}
	function nd(a,b,c,d,e,f){if(!b)throw Error("Invalid event type");var g=q(e)?!!e.capture:!!e,h=od(a);h||(a[gd]=h=new dd(a));c=h.add(b,c,d,g,f);if(!c.proxy){d=pd();c.proxy=d;d.src=a;d.listener=c;if(a.addEventListener)Wc||(e=g),void 0===e&&(e=!1),a.addEventListener(b.toString(),d,e);else if(a.attachEvent)a.attachEvent(qd(b.toString()),d);else if(a.addListener&&a.removeListener)a.addListener(d);else throw Error("addEventListener and attachEvent are unavailable.");id++}}
	function pd(){var a=rd,b=Uc?function(c){return a.call(b.src,b.listener,c)}:function(c){c=a.call(b.src,b.listener,c);if(!c)return c};return b}function kd(a,b,c,d,e){if(Array.isArray(b))for(var f=0;f<b.length;f++)kd(a,b[f],c,d,e);else c=ld(c),a&&a[$c]?sd(a,b,c,q(d)?!!d.capture:!!d,e):nd(a,b,c,!0,d,e)}
	function td(a,b,c,d,e){if(Array.isArray(b))for(var f=0;f<b.length;f++)td(a,b[f],c,d,e);else(d=q(d)?!!d.capture:!!d,c=ld(c),a&&a[$c])?(a=a.u,b=String(b).toString(),b in a.a&&(f=a.a[b],c=ed(f,c,d,e),-1<c&&(cd(f[c]),Array.prototype.splice.call(f,c,1),0==f.length&&(delete a.a[b],a.b--)))):a&&(a=od(a))&&(b=a.a[b.toString()],a=-1,b&&(a=ed(b,c,d,e)),(c=-1<a?b[a]:null)&&vd(c))}
	function vd(a){if("number"!==typeof a&&a&&!a.ua){var b=a.src;if(b&&b[$c])fd(b.u,a);else{var c=a.type,d=a.proxy;b.removeEventListener?b.removeEventListener(c,d,a.capture):b.detachEvent?b.detachEvent(qd(c),d):b.addListener&&b.removeListener&&b.removeListener(d);id--;(c=od(b))?(fd(c,a),0==c.b&&(c.src=null,b[gd]=null)):cd(a)}}}function qd(a){return a in hd?hd[a]:hd[a]="on"+a}
	function wd(a,b,c,d){var e=!0;if(a=od(a))if(b=a.a[b.toString()])for(b=b.concat(),a=0;a<b.length;a++){var f=b[a];f&&f.capture==c&&!f.ua&&(f=xd(f,d),e=e&&!1!==f)}return e}function xd(a,b){var c=a.listener,d=a.Ta||a.src;a.Na&&vd(a);return c.call(d,b)}
	function rd(a,b){if(a.ua)return!0;if(!Uc){if(!b)a:{b=["window","event"];for(var c=l,d=0;d<b.length;d++)if(c=c[b[d]],null==c){b=null;break a}b=c}d=b;b=new Yc(d,this);c=!0;if(!(0>d.keyCode||void 0!=d.returnValue)){a:{var e=!1;if(0==d.keyCode)try{d.keyCode=-1;break a}catch(g){e=!0}if(e||void 0==d.returnValue)d.returnValue=!0}d=[];for(e=b.b;e;e=e.parentNode)d.push(e);a=a.type;for(e=d.length-1;0<=e;e--){b.b=d[e];var f=wd(d[e],a,!0,b);c=c&&f}for(e=0;e<d.length;e++)b.b=d[e],f=wd(d[e],a,!1,b),c=c&&f}return c}return xd(a,
	new Yc(b,this))}function od(a){a=a[gd];return a instanceof dd?a:null}var yd="__closure_events_fn_"+(1E9*Math.random()>>>0);function ld(a){if(n(a))return a;a[yd]||(a[yd]=function(b){return a.handleEvent(b)});return a[yd]};function G(){Pc.call(this);this.u=new dd(this);this.Yb=this;this.eb=null}t(G,Pc);G.prototype[$c]=!0;G.prototype.addEventListener=function(a,b,c,d){jd(this,a,b,c,d)};G.prototype.removeEventListener=function(a,b,c,d){td(this,a,b,c,d)};
	G.prototype.dispatchEvent=function(a){var b,c=this.eb;if(c)for(b=[];c;c=c.eb)b.push(c);c=this.Yb;var d=a.type||a;if("string"===typeof a)a=new Xc(a,c);else if(a instanceof Xc)a.target=a.target||c;else{var e=a;a=new Xc(d,c);B(a,e)}e=!0;if(b)for(var f=b.length-1;0<=f;f--){var g=a.b=b[f];e=zd(g,d,!0,a)&&e}g=a.b=c;e=zd(g,d,!0,a)&&e;e=zd(g,d,!1,a)&&e;if(b)for(f=0;f<b.length;f++)g=a.b=b[f],e=zd(g,d,!1,a)&&e;return e};
	G.prototype.Ba=function(){G.Za.Ba.call(this);if(this.u){var a=this.u,b=0,c;for(c in a.a){for(var d=a.a[c],e=0;e<d.length;e++)++b,cd(d[e]);delete a.a[c];a.b--}}this.eb=null};function md(a,b,c,d,e){a.u.add(String(b),c,!1,d,e)}function sd(a,b,c,d,e){a.u.add(String(b),c,!0,d,e)}
	function zd(a,b,c,d){b=a.u.a[String(b)];if(!b)return!0;b=b.concat();for(var e=!0,f=0;f<b.length;++f){var g=b[f];if(g&&!g.ua&&g.capture==c){var h=g.listener,m=g.Ta||g.src;g.Na&&fd(a.u,g);e=!1!==h.call(m,d)&&e}}return e&&!d.defaultPrevented};function Ad(a,b,c){if(n(a))c&&(a=r(a,c));else if(a&&"function"==typeof a.handleEvent)a=r(a.handleEvent,a);else throw Error("Invalid listener argument");return 2147483647<Number(b)?-1:l.setTimeout(a,b||0)}function Bd(a){var b=null;return(new D(function(c,d){b=Ad(function(){c(void 0)},a);-1==b&&d(Error("Failed to schedule timer."))})).o(function(c){l.clearTimeout(b);throw c;})};function Cd(a){if(a.V&&"function"==typeof a.V)return a.V();if("string"===typeof a)return a.split("");if(ma(a)){for(var b=[],c=a.length,d=0;d<c;d++)b.push(a[d]);return b}b=[];c=0;for(d in a)b[c++]=a[d];return b}function Dd(a){if(a.X&&"function"==typeof a.X)return a.X();if(!a.V||"function"!=typeof a.V){if(ma(a)||"string"===typeof a){var b=[];a=a.length;for(var c=0;c<a;c++)b.push(c);return b}b=[];c=0;for(var d in a)b[c++]=d;return b}}
	function Ed(a,b){if(a.forEach&&"function"==typeof a.forEach)a.forEach(b,void 0);else if(ma(a)||"string"===typeof a)x(a,b,void 0);else for(var c=Dd(a),d=Cd(a),e=d.length,f=0;f<e;f++)b.call(void 0,d[f],c&&c[f],a)};function Fd(a,b){this.b={};this.a=[];this.c=0;var c=arguments.length;if(1<c){if(c%2)throw Error("Uneven number of arguments");for(var d=0;d<c;d+=2)this.set(arguments[d],arguments[d+1])}else if(a)if(a instanceof Fd)for(c=a.X(),d=0;d<c.length;d++)this.set(c[d],a.get(c[d]));else for(d in a)this.set(d,a[d])}k=Fd.prototype;k.V=function(){Gd(this);for(var a=[],b=0;b<this.a.length;b++)a.push(this.b[this.a[b]]);return a};k.X=function(){Gd(this);return this.a.concat()};
	k.clear=function(){this.b={};this.c=this.a.length=0};function Gd(a){if(a.c!=a.a.length){for(var b=0,c=0;b<a.a.length;){var d=a.a[b];Hd(a.b,d)&&(a.a[c++]=d);b++}a.a.length=c}if(a.c!=a.a.length){var e={};for(c=b=0;b<a.a.length;)d=a.a[b],Hd(e,d)||(a.a[c++]=d,e[d]=1),b++;a.a.length=c}}k.get=function(a,b){return Hd(this.b,a)?this.b[a]:b};k.set=function(a,b){Hd(this.b,a)||(this.c++,this.a.push(a));this.b[a]=b};
	k.forEach=function(a,b){for(var c=this.X(),d=0;d<c.length;d++){var e=c[d],f=this.get(e);a.call(b,f,e,this)}};function Hd(a,b){return Object.prototype.hasOwnProperty.call(a,b)};var Id=/^(?:([^:/?#.]+):)?(?:\/\/(?:([^/?#]*)@)?([^/#?]*?)(?::([0-9]+))?(?=[/\\#?]|$))?([^?#]+)?(?:\?([^#]*))?(?:#([\s\S]*))?$/;function Jd(a,b){if(a){a=a.split("&");for(var c=0;c<a.length;c++){var d=a[c].indexOf("="),e=null;if(0<=d){var f=a[c].substring(0,d);e=a[c].substring(d+1)}else f=a[c];b(f,e?decodeURIComponent(e.replace(/\+/g," ")):"")}}};function Kd(a,b){this.b=this.i=this.f="";this.l=null;this.g=this.c="";this.h=!1;var c;a instanceof Kd?(this.h=void 0!==b?b:a.h,Ld(this,a.f),this.i=a.i,this.b=a.b,Md(this,a.l),this.c=a.c,Nd(this,Od(a.a)),this.g=a.g):a&&(c=String(a).match(Id))?(this.h=!!b,Ld(this,c[1]||"",!0),this.i=Pd(c[2]||""),this.b=Pd(c[3]||"",!0),Md(this,c[4]),this.c=Pd(c[5]||"",!0),Nd(this,c[6]||"",!0),this.g=Pd(c[7]||"")):(this.h=!!b,this.a=new Qd(null,this.h))}
	Kd.prototype.toString=function(){var a=[],b=this.f;b&&a.push(Rd(b,Sd,!0),":");var c=this.b;if(c||"file"==b)a.push("//"),(b=this.i)&&a.push(Rd(b,Sd,!0),"@"),a.push(encodeURIComponent(String(c)).replace(/%25([0-9a-fA-F]{2})/g,"%$1")),c=this.l,null!=c&&a.push(":",String(c));if(c=this.c)this.b&&"/"!=c.charAt(0)&&a.push("/"),a.push(Rd(c,"/"==c.charAt(0)?Td:Ud,!0));(c=this.a.toString())&&a.push("?",c);(c=this.g)&&a.push("#",Rd(c,Vd));return a.join("")};
	Kd.prototype.resolve=function(a){var b=new Kd(this),c=!!a.f;c?Ld(b,a.f):c=!!a.i;c?b.i=a.i:c=!!a.b;c?b.b=a.b:c=null!=a.l;var d=a.c;if(c)Md(b,a.l);else if(c=!!a.c){if("/"!=d.charAt(0))if(this.b&&!this.c)d="/"+d;else{var e=b.c.lastIndexOf("/");-1!=e&&(d=b.c.substr(0,e+1)+d)}e=d;if(".."==e||"."==e)d="";else if(y(e,"./")||y(e,"/.")){d=0==e.lastIndexOf("/",0);e=e.split("/");for(var f=[],g=0;g<e.length;){var h=e[g++];"."==h?d&&g==e.length&&f.push(""):".."==h?((1<f.length||1==f.length&&""!=f[0])&&f.pop(),
	d&&g==e.length&&f.push("")):(f.push(h),d=!0)}d=f.join("/")}else d=e}c?b.c=d:c=""!==a.a.toString();c?Nd(b,Od(a.a)):c=!!a.g;c&&(b.g=a.g);return b};function Ld(a,b,c){a.f=c?Pd(b,!0):b;a.f&&(a.f=a.f.replace(/:$/,""))}function Md(a,b){if(b){b=Number(b);if(isNaN(b)||0>b)throw Error("Bad port number "+b);a.l=b}else a.l=null}function Nd(a,b,c){b instanceof Qd?(a.a=b,Wd(a.a,a.h)):(c||(b=Rd(b,Xd)),a.a=new Qd(b,a.h))}function H(a,b,c){a.a.set(b,c)}function Yd(a,b){return a.a.get(b)}
	function Zd(a){return a instanceof Kd?new Kd(a):new Kd(a,void 0)}function $d(a,b){var c=new Kd(null,void 0);Ld(c,"https");a&&(c.b=a);b&&(c.c=b);return c}function Pd(a,b){return a?b?decodeURI(a.replace(/%25/g,"%2525")):decodeURIComponent(a):""}function Rd(a,b,c){return"string"===typeof a?(a=encodeURI(a).replace(b,ae),c&&(a=a.replace(/%25([0-9a-fA-F]{2})/g,"%$1")),a):null}function ae(a){a=a.charCodeAt(0);return"%"+(a>>4&15).toString(16)+(a&15).toString(16)}
	var Sd=/[#\/\?@]/g,Ud=/[#\?:]/g,Td=/[#\?]/g,Xd=/[#\?@]/g,Vd=/#/g;function Qd(a,b){this.b=this.a=null;this.c=a||null;this.f=!!b}function be(a){a.a||(a.a=new Fd,a.b=0,a.c&&Jd(a.c,function(b,c){a.add(decodeURIComponent(b.replace(/\+/g," ")),c)}))}function ce(a){var b=Dd(a);if("undefined"==typeof b)throw Error("Keys are undefined");var c=new Qd(null,void 0);a=Cd(a);for(var d=0;d<b.length;d++){var e=b[d],f=a[d];Array.isArray(f)?de(c,e,f):c.add(e,f)}return c}k=Qd.prototype;
	k.add=function(a,b){be(this);this.c=null;a=ee(this,a);var c=this.a.get(a);c||this.a.set(a,c=[]);c.push(b);this.b+=1;return this};function fe(a,b){be(a);b=ee(a,b);Hd(a.a.b,b)&&(a.c=null,a.b-=a.a.get(b).length,a=a.a,Hd(a.b,b)&&(delete a.b[b],a.c--,a.a.length>2*a.c&&Gd(a)))}k.clear=function(){this.a=this.c=null;this.b=0};function ge(a,b){be(a);b=ee(a,b);return Hd(a.a.b,b)}k.forEach=function(a,b){be(this);this.a.forEach(function(c,d){x(c,function(e){a.call(b,e,d,this)},this)},this)};
	k.X=function(){be(this);for(var a=this.a.V(),b=this.a.X(),c=[],d=0;d<b.length;d++)for(var e=a[d],f=0;f<e.length;f++)c.push(b[d]);return c};k.V=function(a){be(this);var b=[];if("string"===typeof a)ge(this,a)&&(b=Va(b,this.a.get(ee(this,a))));else{a=this.a.V();for(var c=0;c<a.length;c++)b=Va(b,a[c])}return b};k.set=function(a,b){be(this);this.c=null;a=ee(this,a);ge(this,a)&&(this.b-=this.a.get(a).length);this.a.set(a,[b]);this.b+=1;return this};
	k.get=function(a,b){if(!a)return b;a=this.V(a);return 0<a.length?String(a[0]):b};function de(a,b,c){fe(a,b);0<c.length&&(a.c=null,a.a.set(ee(a,b),Wa(c)),a.b+=c.length)}k.toString=function(){if(this.c)return this.c;if(!this.a)return"";for(var a=[],b=this.a.X(),c=0;c<b.length;c++){var d=b[c],e=encodeURIComponent(String(d));d=this.V(d);for(var f=0;f<d.length;f++){var g=e;""!==d[f]&&(g+="="+encodeURIComponent(String(d[f])));a.push(g)}}return this.c=a.join("&")};
	function Od(a){var b=new Qd;b.c=a.c;a.a&&(b.a=new Fd(a.a),b.b=a.b);return b}function ee(a,b){b=String(b);a.f&&(b=b.toLowerCase());return b}function Wd(a,b){b&&!a.f&&(be(a),a.c=null,a.a.forEach(function(c,d){var e=d.toLowerCase();d!=e&&(fe(this,d),de(this,e,c))},a));a.f=b};function he(a){var b=[];ie(new je,a,b);return b.join("")}function je(){}
	function ie(a,b,c){if(null==b)c.push("null");else{if("object"==typeof b){if(Array.isArray(b)){var d=b;b=d.length;c.push("[");for(var e="",f=0;f<b;f++)c.push(e),ie(a,d[f],c),e=",";c.push("]");return}if(b instanceof String||b instanceof Number||b instanceof Boolean)b=b.valueOf();else{c.push("{");e="";for(d in b)Object.prototype.hasOwnProperty.call(b,d)&&(f=b[d],"function"!=typeof f&&(c.push(e),ke(d,c),c.push(":"),ie(a,f,c),e=","));c.push("}");return}}switch(typeof b){case "string":ke(b,c);break;case "number":c.push(isFinite(b)&&
	!isNaN(b)?String(b):"null");break;case "boolean":c.push(String(b));break;case "function":c.push("null");break;default:throw Error("Unknown type: "+typeof b);}}}var le={'"':'\\"',"\\":"\\\\","/":"\\/","\b":"\\b","\f":"\\f","\n":"\\n","\r":"\\r","\t":"\\t","\x0B":"\\u000b"},me=/\uffff/.test("\uffff")?/[\\"\x00-\x1f\x7f-\uffff]/g:/[\\"\x00-\x1f\x7f-\xff]/g;
	function ke(a,b){b.push('"',a.replace(me,function(c){var d=le[c];d||(d="\\u"+(c.charCodeAt(0)|65536).toString(16).substr(1),le[c]=d);return d}),'"')};function ne(){var a=I();return Sb&&!!cc&&11==cc||/Edge\/\d+/.test(a)}function oe(){return l.window&&l.window.location.href||self&&self.location&&self.location.href||""}function pe(a,b){b=b||l.window;var c="about:blank";a&&(c=Cb(Eb(a)));b.location.href=c}function qe(a,b){var c=[],d;for(d in a)d in b?typeof a[d]!=typeof b[d]?c.push(d):"object"==typeof a[d]&&null!=a[d]&&null!=b[d]?0<qe(a[d],b[d]).length&&c.push(d):a[d]!==b[d]&&c.push(d):c.push(d);for(d in b)d in a||c.push(d);return c}
	function re(){var a=I();a=se(a)!=te?null:(a=a.match(/\sChrome\/(\d+)/i))&&2==a.length?parseInt(a[1],10):null;return a&&30>a?!1:!Sb||!cc||9<cc}function ue(a){a=(a||I()).toLowerCase();return a.match(/android/)||a.match(/webos/)||a.match(/iphone|ipad|ipod/)||a.match(/blackberry/)||a.match(/windows phone/)||a.match(/iemobile/)?!0:!1}function ve(a){a=a||l.window;try{a.close()}catch(b){}}
	function we(a,b,c){var d=Math.floor(1E9*Math.random()).toString();b=b||500;c=c||600;var e=(window.screen.availHeight-c)/2,f=(window.screen.availWidth-b)/2;b={width:b,height:c,top:0<e?e:0,left:0<f?f:0,location:!0,resizable:!0,statusbar:!0,toolbar:!1};c=I().toLowerCase();d&&(b.target=d,y(c,"crios/")&&(b.target="_blank"));se(I())==xe&&(a=a||"http://localhost",b.scrollbars=!0);c=a||"";(a=b)||(a={});d=window;b=c instanceof zb?c:Eb("undefined"!=typeof c.href?c.href:String(c));c=a.target||c.target;e=[];
	for(g in a)switch(g){case "width":case "height":case "top":case "left":e.push(g+"="+a[g]);break;case "target":case "noopener":case "noreferrer":break;default:e.push(g+"="+(a[g]?1:0))}var g=e.join(",");if((z("iPhone")&&!z("iPod")&&!z("iPad")||z("iPad")||z("iPod"))&&d.navigator&&d.navigator.standalone&&c&&"_self"!=c)g=ic(document,"A"),mb(g,"HTMLAnchorElement"),b instanceof zb||b instanceof zb||(b="object"==typeof b&&b.ra?b.qa():String(b),Db.test(b)||(b="about:invalid#zClosurez"),b=new zb(Ab,b)),g.href=
	Cb(b),g.setAttribute("target",c),a.noreferrer&&g.setAttribute("rel","noreferrer"),a=document.createEvent("MouseEvent"),a.initMouseEvent("click",!0,!0,d,1),g.dispatchEvent(a),g={};else if(a.noreferrer){if(g=d.open("",c,g),a=Cb(b),g&&(Ub&&y(a,";")&&(a="'"+a.replace(/'/g,"%27")+"'"),g.opener=null,a=Ib('<meta name="referrer" content="no-referrer"><meta http-equiv="refresh" content="0; url='+Nb(a)+'">'),d=g.document))d.write(Hb(a)),d.close()}else(g=d.open(Cb(b),c,g))&&a.noopener&&(g.opener=null);if(g)try{g.focus()}catch(h){}return g}
	function ye(a){return new D(function(b){function c(){Bd(2E3).then(function(){if(!a||a.closed)b();else return c()})}return c()})}var ze=/^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/,Ae=/^[^@]+@[^@]+$/;function Be(){var a=null;return(new D(function(b){"complete"==l.document.readyState?b():(a=function(){b()},kd(window,"load",a))})).o(function(b){td(window,"load",a);throw b;})}
	function Ce(){return De(void 0)?Be().then(function(){return new D(function(a,b){var c=l.document,d=setTimeout(function(){b(Error("Cordova framework is not ready."))},1E3);c.addEventListener("deviceready",function(){clearTimeout(d);a()},!1)})}):F(Error("Cordova must run in an Android or iOS file scheme."))}function De(a){a=a||I();return!("file:"!==Ee()&&"ionic:"!==Ee()||!a.toLowerCase().match(/iphone|ipad|ipod|android/))}function Fe(){var a=l.window;try{return!(!a||a==a.top)}catch(b){return!1}}
	function Ge(){return"undefined"!==typeof l.WorkerGlobalScope&&"function"===typeof l.importScripts}function He(){return firebase.INTERNAL.hasOwnProperty("reactNative")?"ReactNative":firebase.INTERNAL.hasOwnProperty("node")?"Node":Ge()?"Worker":"Browser"}function Ie(){var a=He();return"ReactNative"===a||"Node"===a}function Je(){for(var a=50,b=[];0<a;)b.push("1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ".charAt(Math.floor(62*Math.random()))),a--;return b.join("")}
	var xe="Firefox",te="Chrome";
	function se(a){var b=a.toLowerCase();if(y(b,"opera/")||y(b,"opr/")||y(b,"opios/"))return"Opera";if(y(b,"iemobile"))return"IEMobile";if(y(b,"msie")||y(b,"trident/"))return"IE";if(y(b,"edge/"))return"Edge";if(y(b,"firefox/"))return xe;if(y(b,"silk/"))return"Silk";if(y(b,"blackberry"))return"Blackberry";if(y(b,"webos"))return"Webos";if(!y(b,"safari/")||y(b,"chrome/")||y(b,"crios/")||y(b,"android"))if(!y(b,"chrome/")&&!y(b,"crios/")||y(b,"edge/")){if(y(b,"android"))return"Android";if((a=a.match(/([a-zA-Z\d\.]+)\/[a-zA-Z\d\.]*$/))&&
	2==a.length)return a[1]}else return te;else return"Safari";return"Other"}var Ke={jd:"FirebaseCore-web",ld:"FirebaseUI-web"};function Le(a,b){b=b||[];var c=[],d={},e;for(e in Ke)d[Ke[e]]=!0;for(e=0;e<b.length;e++)"undefined"!==typeof d[b[e]]&&(delete d[b[e]],c.push(b[e]));c.sort();b=c;b.length||(b=["FirebaseCore-web"]);c=He();"Browser"===c?(d=I(),c=se(d)):"Worker"===c&&(d=I(),c=se(d)+"-"+c);return c+"/JsCore/"+a+"/"+b.join(",")}function I(){return l.navigator&&l.navigator.userAgent||""}
	function J(a,b){a=a.split(".");b=b||l;for(var c=0;c<a.length&&"object"==typeof b&&null!=b;c++)b=b[a[c]];c!=a.length&&(b=void 0);return b}function Me(){try{var a=l.localStorage,b=Ne();if(a)return a.setItem(b,"1"),a.removeItem(b),ne()?!!l.indexedDB:!0}catch(c){return Ge()&&!!l.indexedDB}return!1}function Oe(){return(Pe()||"chrome-extension:"===Ee()||De())&&!Ie()&&Me()&&!Ge()}function Pe(){return"http:"===Ee()||"https:"===Ee()}function Ee(){return l.location&&l.location.protocol||null}
	function Qe(a){a=a||I();return ue(a)||se(a)==xe?!1:!0}function Re(a){return"undefined"===typeof a?null:he(a)}function Se(a){var b={},c;for(c in a)a.hasOwnProperty(c)&&null!==a[c]&&void 0!==a[c]&&(b[c]=a[c]);return b}function Te(a){if(null!==a)return JSON.parse(a)}function Ne(a){return a?a:Math.floor(1E9*Math.random()).toString()}function Ue(a){a=a||I();return"Safari"==se(a)||a.toLowerCase().match(/iphone|ipad|ipod/)?!1:!0}
	function Ve(){var a=l.___jsl;if(a&&a.H)for(var b in a.H)if(a.H[b].r=a.H[b].r||[],a.H[b].L=a.H[b].L||[],a.H[b].r=a.H[b].L.concat(),a.CP)for(var c=0;c<a.CP.length;c++)a.CP[c]=null}function We(a,b){if(a>b)throw Error("Short delay should be less than long delay!");this.a=a;this.c=b;a=I();b=He();this.b=ue(a)||"ReactNative"===b}
	We.prototype.get=function(){var a=l.navigator;return(a&&"boolean"===typeof a.onLine&&(Pe()||"chrome-extension:"===Ee()||"undefined"!==typeof a.connection)?a.onLine:1)?this.b?this.c:this.a:Math.min(5E3,this.a)};function Xe(){var a=l.document;return a&&"undefined"!==typeof a.visibilityState?"visible"==a.visibilityState:!0}
	function Ye(){var a=l.document,b=null;return Xe()||!a?E():(new D(function(c){b=function(){Xe()&&(a.removeEventListener("visibilitychange",b,!1),c())};a.addEventListener("visibilitychange",b,!1)})).o(function(c){a.removeEventListener("visibilitychange",b,!1);throw c;})}function Ze(a){try{var b=new Date(parseInt(a,10));if(!isNaN(b.getTime())&&!/[^0-9]/.test(a))return b.toUTCString()}catch(c){}return null}function $e(){return!(!J("fireauth.oauthhelper",l)&&!J("fireauth.iframe",l))}
	function af(){var a=l.navigator;return a&&a.serviceWorker&&a.serviceWorker.controller||null}function bf(){var a=l.navigator;return a&&a.serviceWorker?E().then(function(){return a.serviceWorker.ready}).then(function(b){return b.active||null}).o(function(){return null}):E(null)};var cf={};function df(a){cf[a]||(cf[a]=!0,"undefined"!==typeof console&&"function"===typeof console.warn&&console.warn(a))};var ef;try{var ff={};Object.defineProperty(ff,"abcd",{configurable:!0,enumerable:!0,value:1});Object.defineProperty(ff,"abcd",{configurable:!0,enumerable:!0,value:2});ef=2==ff.abcd}catch(a){ef=!1}function K(a,b,c){ef?Object.defineProperty(a,b,{configurable:!0,enumerable:!0,value:c}):a[b]=c}function L(a,b){if(b)for(var c in b)b.hasOwnProperty(c)&&K(a,c,b[c])}function gf(a){var b={};L(b,a);return b}function hf(a){var b={},c;for(c in a)a.hasOwnProperty(c)&&(b[c]=a[c]);return b}
	function jf(a,b){if(!b||!b.length)return!0;if(!a)return!1;for(var c=0;c<b.length;c++){var d=a[b[c]];if(void 0===d||null===d||""===d)return!1}return!0}function kf(a){var b=a;if("object"==typeof a&&null!=a){b="length"in a?[]:{};for(var c in a)K(b,c,kf(a[c]))}return b};/*
	
	 Copyright 2019 Google Inc.
	
	 Licensed under the Apache License, Version 2.0 (the "License");
	 you may not use this file except in compliance with the License.
	 You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	 Unless required by applicable law or agreed to in writing, software
	 distributed under the License is distributed on an "AS IS" BASIS,
	 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 See the License for the specific language governing permissions and
	 limitations under the License.
	*/
	function lf(a){var b=a&&(a[mf]?"phone":null);if(b&&a&&a[nf]){K(this,"uid",a[nf]);K(this,"displayName",a[of]||null);var c=null;a[pf]&&(c=(new Date(a[pf])).toUTCString());K(this,"enrollmentTime",c);K(this,"factorId",b)}else throw new u("internal-error","Internal assert: invalid MultiFactorInfo object");}lf.prototype.v=function(){return{uid:this.uid,displayName:this.displayName,factorId:this.factorId,enrollmentTime:this.enrollmentTime}};function qf(a){try{var b=new rf(a)}catch(c){b=null}return b}
	var of="displayName",pf="enrolledAt",nf="mfaEnrollmentId",mf="phoneInfo";function rf(a){lf.call(this,a);K(this,"phoneNumber",a[mf])}t(rf,lf);rf.prototype.v=function(){var a=rf.Za.v.call(this);a.phoneNumber=this.phoneNumber;return a};function sf(a){var b={},c=a[tf],d=a[uf],e=a[vf];a=qf(a[wf]);if(!e||e!=xf&&e!=yf&&!c||e==yf&&!d||e==zf&&!a)throw Error("Invalid checkActionCode response!");e==yf?(b[Af]=c||null,b[Bf]=c||null,b[Cf]=d):(b[Af]=d||null,b[Bf]=d||null,b[Cf]=c||null);b[Df]=a||null;K(this,Ef,e);K(this,Ff,kf(b))}
	var zf="REVERT_SECOND_FACTOR_ADDITION",xf="EMAIL_SIGNIN",yf="VERIFY_AND_CHANGE_EMAIL",tf="email",wf="mfaInfo",uf="newEmail",vf="requestType",Cf="email",Af="fromEmail",Df="multiFactorInfo",Bf="previousEmail",Ff="data",Ef="operation";function Gf(a){a=Zd(a);var b=Yd(a,Hf)||null,c=Yd(a,If)||null,d=Yd(a,Jf)||null;d=d?Kf[d]||null:null;if(!b||!c||!d)throw new u("argument-error",Hf+", "+If+"and "+Jf+" are required in a valid action code URL.");L(this,{apiKey:b,operation:d,code:c,continueUrl:Yd(a,Lf)||null,languageCode:Yd(a,Mf)||null,tenantId:Yd(a,Nf)||null})}
	var Hf="apiKey",If="oobCode",Lf="continueUrl",Mf="languageCode",Jf="mode",Nf="tenantId",Kf={recoverEmail:"RECOVER_EMAIL",resetPassword:"PASSWORD_RESET",revertSecondFactorAddition:zf,signIn:xf,verifyAndChangeEmail:yf,verifyEmail:"VERIFY_EMAIL"};function Of(a){try{return new Gf(a)}catch(b){return null}};function Pf(a){var b=a[Qf];if("undefined"===typeof b)throw new u("missing-continue-uri");if("string"!==typeof b||"string"===typeof b&&!b.length)throw new u("invalid-continue-uri");this.h=b;this.b=this.a=null;this.g=!1;var c=a[Rf];if(c&&"object"===typeof c){b=c[Sf];var d=c[Tf];c=c[Uf];if("string"===typeof b&&b.length){this.a=b;if("undefined"!==typeof d&&"boolean"!==typeof d)throw new u("argument-error",Tf+" property must be a boolean when specified.");this.g=!!d;if("undefined"!==typeof c&&("string"!==
	typeof c||"string"===typeof c&&!c.length))throw new u("argument-error",Uf+" property must be a non empty string when specified.");this.b=c||null}else{if("undefined"!==typeof b)throw new u("argument-error",Sf+" property must be a non empty string when specified.");if("undefined"!==typeof d||"undefined"!==typeof c)throw new u("missing-android-pkg-name");}}else if("undefined"!==typeof c)throw new u("argument-error",Rf+" property must be a non null object when specified.");this.f=null;if((b=a[Vf])&&"object"===
	typeof b)if(b=b[Wf],"string"===typeof b&&b.length)this.f=b;else{if("undefined"!==typeof b)throw new u("argument-error",Wf+" property must be a non empty string when specified.");}else if("undefined"!==typeof b)throw new u("argument-error",Vf+" property must be a non null object when specified.");b=a[Xf];if("undefined"!==typeof b&&"boolean"!==typeof b)throw new u("argument-error",Xf+" property must be a boolean when specified.");this.c=!!b;a=a[Yf];if("undefined"!==typeof a&&("string"!==typeof a||"string"===
	typeof a&&!a.length))throw new u("argument-error",Yf+" property must be a non empty string when specified.");this.i=a||null}var Rf="android",Yf="dynamicLinkDomain",Xf="handleCodeInApp",Vf="iOS",Qf="url",Tf="installApp",Uf="minimumVersion",Sf="packageName",Wf="bundleId";
	function Zf(a){var b={};b.continueUrl=a.h;b.canHandleCodeInApp=a.c;if(b.androidPackageName=a.a)b.androidMinimumVersion=a.b,b.androidInstallApp=a.g;b.iOSBundleId=a.f;b.dynamicLinkDomain=a.i;for(var c in b)null===b[c]&&delete b[c];return b};function $f(a){return Oa(a,function(b){b=b.toString(16);return 1<b.length?b:"0"+b}).join("")};var ag=null;function bg(a){var b="";cg(a,function(c){b+=String.fromCharCode(c)});return b}function cg(a,b){function c(m){for(;d<a.length;){var p=a.charAt(d++),v=ag[p];if(null!=v)return v;if(!/^[\s\xa0]*$/.test(p))throw Error("Unknown base64 encoding at char: "+p);}return m}dg();for(var d=0;;){var e=c(-1),f=c(0),g=c(64),h=c(64);if(64===h&&-1===e)break;b(e<<2|f>>4);64!=g&&(b(f<<4&240|g>>2),64!=h&&b(g<<6&192|h))}}
	function dg(){if(!ag){ag={};for(var a="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".split(""),b=["+/=","+/","-_=","-_.","-_"],c=0;5>c;c++)for(var d=a.concat(b[c].split("")),e=0;e<d.length;e++){var f=d[e];void 0===ag[f]&&(ag[f]=e)}}};function eg(a){var b=fg(a);if(!(b&&b.sub&&b.iss&&b.aud&&b.exp))throw Error("Invalid JWT");this.g=a;this.c=b.exp;this.h=b.sub;ta();this.a=b.provider_id||b.firebase&&b.firebase.sign_in_provider||null;this.f=b.firebase&&b.firebase.tenant||null;this.b=!!b.is_anonymous||"anonymous"==this.a}eg.prototype.S=function(){return this.f};eg.prototype.i=function(){return this.b};eg.prototype.toString=function(){return this.g};function gg(a){try{return new eg(a)}catch(b){return null}}
	function fg(a){if(!a)return null;a=a.split(".");if(3!=a.length)return null;a=a[1];for(var b=(4-a.length%4)%4,c=0;c<b;c++)a+=".";try{return JSON.parse(bg(a))}catch(d){}return null};var hg="oauth_consumer_key oauth_nonce oauth_signature oauth_signature_method oauth_timestamp oauth_token oauth_version".split(" "),ig=["client_id","response_type","scope","redirect_uri","state"],jg={kd:{Ha:"locale",ta:700,sa:600,ea:"facebook.com",Va:ig},md:{Ha:null,ta:500,sa:750,ea:"github.com",Va:ig},nd:{Ha:"hl",ta:515,sa:680,ea:"google.com",Va:ig},td:{Ha:"lang",ta:485,sa:705,ea:"twitter.com",Va:hg},gd:{Ha:"locale",ta:640,sa:600,ea:"apple.com",Va:[]}};
	function kg(a){for(var b in jg)if(jg[b].ea==a)return jg[b];return null};function lg(a){var b={};b["facebook.com"]=mg;b["google.com"]=ng;b["github.com"]=og;b["twitter.com"]=pg;var c=a&&a[qg];try{if(c)return b[c]?new b[c](a):new rg(a);if("undefined"!==typeof a[sg])return new tg(a)}catch(d){}return null}var sg="idToken",qg="providerId";
	function tg(a){var b=a[qg];if(!b&&a[sg]){var c=gg(a[sg]);c&&c.a&&(b=c.a)}if(!b)throw Error("Invalid additional user info!");if("anonymous"==b||"custom"==b)b=null;c=!1;"undefined"!==typeof a.isNewUser?c=!!a.isNewUser:"identitytoolkit#SignupNewUserResponse"===a.kind&&(c=!0);K(this,"providerId",b);K(this,"isNewUser",c)}function rg(a){tg.call(this,a);a=Te(a.rawUserInfo||"{}");K(this,"profile",kf(a||{}))}t(rg,tg);
	function mg(a){rg.call(this,a);if("facebook.com"!=this.providerId)throw Error("Invalid provider ID!");}t(mg,rg);function og(a){rg.call(this,a);if("github.com"!=this.providerId)throw Error("Invalid provider ID!");K(this,"username",this.profile&&this.profile.login||null)}t(og,rg);function ng(a){rg.call(this,a);if("google.com"!=this.providerId)throw Error("Invalid provider ID!");}t(ng,rg);
	function pg(a){rg.call(this,a);if("twitter.com"!=this.providerId)throw Error("Invalid provider ID!");K(this,"username",a.screenName||null)}t(pg,rg);function ug(a){var b=Zd(a),c=Yd(b,"link"),d=Yd(Zd(c),"link");b=Yd(b,"deep_link_id");return Yd(Zd(b),"link")||b||d||c||a};function vg(a,b){if(!a&&!b)throw new u("internal-error","Internal assert: no raw session string available");if(a&&b)throw new u("internal-error","Internal assert: unable to determine the session type");this.a=a||null;this.b=b||null;this.type=this.a?wg:xg}var wg="enroll",xg="signin";vg.prototype.Fa=function(){return this.a?E(this.a):E(this.b)};vg.prototype.v=function(){return this.type==wg?{multiFactorSession:{idToken:this.a}}:{multiFactorSession:{pendingCredential:this.b}}};function yg(){}yg.prototype.ia=function(){};yg.prototype.b=function(){};yg.prototype.c=function(){};yg.prototype.v=function(){};function zg(a,b){return a.then(function(c){if(c[Ag]){var d=gg(c[Ag]);if(!d||b!=d.h)throw new u("user-mismatch");return c}throw new u("user-mismatch");}).o(function(c){throw c&&c.code&&c.code==ua+"user-not-found"?new u("user-mismatch"):c;})}
	function Bg(a,b){if(b)this.a=b;else throw new u("internal-error","failed to construct a credential");K(this,"providerId",a);K(this,"signInMethod",a)}Bg.prototype.ia=function(a){return Cg(a,Dg(this))};Bg.prototype.b=function(a,b){var c=Dg(this);c.idToken=b;return Eg(a,c)};Bg.prototype.c=function(a,b){return zg(Fg(a,Dg(this)),b)};function Dg(a){return{pendingToken:a.a,requestUri:"http://localhost"}}Bg.prototype.v=function(){return{providerId:this.providerId,signInMethod:this.signInMethod,pendingToken:this.a}};
	function Gg(a){if(a&&a.providerId&&a.signInMethod&&0==a.providerId.indexOf("saml.")&&a.pendingToken)try{return new Bg(a.providerId,a.pendingToken)}catch(b){}return null}
	function Hg(a,b,c){this.a=null;if(b.idToken||b.accessToken)b.idToken&&K(this,"idToken",b.idToken),b.accessToken&&K(this,"accessToken",b.accessToken),b.nonce&&!b.pendingToken&&K(this,"nonce",b.nonce),b.pendingToken&&(this.a=b.pendingToken);else if(b.oauthToken&&b.oauthTokenSecret)K(this,"accessToken",b.oauthToken),K(this,"secret",b.oauthTokenSecret);else throw new u("internal-error","failed to construct a credential");K(this,"providerId",a);K(this,"signInMethod",c)}
	Hg.prototype.ia=function(a){return Cg(a,Ig(this))};Hg.prototype.b=function(a,b){var c=Ig(this);c.idToken=b;return Eg(a,c)};Hg.prototype.c=function(a,b){var c=Ig(this);return zg(Fg(a,c),b)};
	function Ig(a){var b={};a.idToken&&(b.id_token=a.idToken);a.accessToken&&(b.access_token=a.accessToken);a.secret&&(b.oauth_token_secret=a.secret);b.providerId=a.providerId;a.nonce&&!a.a&&(b.nonce=a.nonce);b={postBody:ce(b).toString(),requestUri:"http://localhost"};a.a&&(delete b.postBody,b.pendingToken=a.a);return b}
	Hg.prototype.v=function(){var a={providerId:this.providerId,signInMethod:this.signInMethod};this.idToken&&(a.oauthIdToken=this.idToken);this.accessToken&&(a.oauthAccessToken=this.accessToken);this.secret&&(a.oauthTokenSecret=this.secret);this.nonce&&(a.nonce=this.nonce);this.a&&(a.pendingToken=this.a);return a};
	function Jg(a){if(a&&a.providerId&&a.signInMethod){var b={idToken:a.oauthIdToken,accessToken:a.oauthTokenSecret?null:a.oauthAccessToken,oauthTokenSecret:a.oauthTokenSecret,oauthToken:a.oauthTokenSecret&&a.oauthAccessToken,nonce:a.nonce,pendingToken:a.pendingToken};try{return new Hg(a.providerId,b,a.signInMethod)}catch(c){}}return null}function Kg(a,b){this.Oc=b||[];L(this,{providerId:a,isOAuthProvider:!0});this.Fb={};this.lb=(kg(a)||{}).Ha||null;this.kb=null}
	Kg.prototype.Ia=function(a){this.Fb=kb(a);return this};function Lg(a){if("string"!==typeof a||0!=a.indexOf("saml."))throw new u("argument-error",'SAML provider IDs must be prefixed with "saml."');Kg.call(this,a,[])}t(Lg,Kg);function M(a){Kg.call(this,a,ig);this.a=[]}t(M,Kg);M.prototype.Aa=function(a){Sa(this.a,a)||this.a.push(a);return this};M.prototype.Nb=function(){return Wa(this.a)};
	M.prototype.credential=function(a,b){var c;q(a)?c={idToken:a.idToken||null,accessToken:a.accessToken||null,nonce:a.rawNonce||null}:c={idToken:a||null,accessToken:b||null};if(!c.idToken&&!c.accessToken)throw new u("argument-error","credential failed: must provide the ID token and/or the access token.");return new Hg(this.providerId,c,this.providerId)};function Mg(){M.call(this,"facebook.com")}t(Mg,M);K(Mg,"PROVIDER_ID","facebook.com");K(Mg,"FACEBOOK_SIGN_IN_METHOD","facebook.com");
	function Ng(a){if(!a)throw new u("argument-error","credential failed: expected 1 argument (the OAuth access token).");var b=a;q(a)&&(b=a.accessToken);return(new Mg).credential({accessToken:b})}function Og(){M.call(this,"github.com")}t(Og,M);K(Og,"PROVIDER_ID","github.com");K(Og,"GITHUB_SIGN_IN_METHOD","github.com");
	function Pg(a){if(!a)throw new u("argument-error","credential failed: expected 1 argument (the OAuth access token).");var b=a;q(a)&&(b=a.accessToken);return(new Og).credential({accessToken:b})}function Qg(){M.call(this,"google.com");this.Aa("profile")}t(Qg,M);K(Qg,"PROVIDER_ID","google.com");K(Qg,"GOOGLE_SIGN_IN_METHOD","google.com");function Rg(a,b){var c=a;q(a)&&(c=a.idToken,b=a.accessToken);return(new Qg).credential({idToken:c,accessToken:b})}function Sg(){Kg.call(this,"twitter.com",hg)}t(Sg,Kg);
	K(Sg,"PROVIDER_ID","twitter.com");K(Sg,"TWITTER_SIGN_IN_METHOD","twitter.com");function Tg(a,b){var c=a;q(c)||(c={oauthToken:a,oauthTokenSecret:b});if(!c.oauthToken||!c.oauthTokenSecret)throw new u("argument-error","credential failed: expected 2 arguments (the OAuth access token and secret).");return new Hg("twitter.com",c,"twitter.com")}
	function Ug(a,b,c){this.a=a;this.f=b;K(this,"providerId","password");K(this,"signInMethod",c===Vg.EMAIL_LINK_SIGN_IN_METHOD?Vg.EMAIL_LINK_SIGN_IN_METHOD:Vg.EMAIL_PASSWORD_SIGN_IN_METHOD)}Ug.prototype.ia=function(a){return this.signInMethod==Vg.EMAIL_LINK_SIGN_IN_METHOD?N(a,Wg,{email:this.a,oobCode:this.f}):N(a,Xg,{email:this.a,password:this.f})};
	Ug.prototype.b=function(a,b){return this.signInMethod==Vg.EMAIL_LINK_SIGN_IN_METHOD?N(a,Yg,{idToken:b,email:this.a,oobCode:this.f}):N(a,Zg,{idToken:b,email:this.a,password:this.f})};Ug.prototype.c=function(a,b){return zg(this.ia(a),b)};Ug.prototype.v=function(){return{email:this.a,password:this.f,signInMethod:this.signInMethod}};function $g(a){return a&&a.email&&a.password?new Ug(a.email,a.password,a.signInMethod):null}function Vg(){L(this,{providerId:"password",isOAuthProvider:!1})}
	function ah(a,b){b=bh(b);if(!b)throw new u("argument-error","Invalid email link!");return new Ug(a,b.code,Vg.EMAIL_LINK_SIGN_IN_METHOD)}function bh(a){a=ug(a);return(a=Of(a))&&a.operation===xf?a:null}L(Vg,{PROVIDER_ID:"password"});L(Vg,{EMAIL_LINK_SIGN_IN_METHOD:"emailLink"});L(Vg,{EMAIL_PASSWORD_SIGN_IN_METHOD:"password"});function ch(a){if(!(a.bb&&a.ab||a.Ja&&a.da))throw new u("internal-error");this.a=a;K(this,"providerId","phone");this.ea="phone";K(this,"signInMethod","phone")}
	ch.prototype.ia=function(a){return a.cb(dh(this))};ch.prototype.b=function(a,b){var c=dh(this);c.idToken=b;return N(a,eh,c)};ch.prototype.c=function(a,b){var c=dh(this);c.operation="REAUTH";a=N(a,fh,c);return zg(a,b)};ch.prototype.v=function(){var a={providerId:"phone"};this.a.bb&&(a.verificationId=this.a.bb);this.a.ab&&(a.verificationCode=this.a.ab);this.a.Ja&&(a.temporaryProof=this.a.Ja);this.a.da&&(a.phoneNumber=this.a.da);return a};
	function gh(a){if(a&&"phone"===a.providerId&&(a.verificationId&&a.verificationCode||a.temporaryProof&&a.phoneNumber)){var b={};x(["verificationId","verificationCode","temporaryProof","phoneNumber"],function(c){a[c]&&(b[c]=a[c])});return new ch(b)}return null}function dh(a){return a.a.Ja&&a.a.da?{temporaryProof:a.a.Ja,phoneNumber:a.a.da}:{sessionInfo:a.a.bb,code:a.a.ab}}
	function hh(a){try{this.a=a||firebase.auth()}catch(b){throw new u("argument-error","Either an instance of firebase.auth.Auth must be passed as an argument to the firebase.auth.PhoneAuthProvider constructor, or the default firebase App instance must be initialized via firebase.initializeApp().");}L(this,{providerId:"phone",isOAuthProvider:!1})}
	hh.prototype.cb=function(a,b){var c=this.a.b;return E(b.verify()).then(function(d){if("string"!==typeof d)throw new u("argument-error","An implementation of firebase.auth.ApplicationVerifier.prototype.verify() must return a firebase.Promise that resolves with a string.");switch(b.type){case "recaptcha":var e=q(a)?a.session:null,f=q(a)?a.phoneNumber:a,g;e&&e.type==wg?g=e.Fa().then(function(h){return ih(c,{idToken:h,phoneEnrollmentInfo:{phoneNumber:f,recaptchaToken:d}})}):e&&e.type==xg?g=e.Fa().then(function(h){return jh(c,
	{mfaPendingCredential:h,mfaEnrollmentId:a.multiFactorHint&&a.multiFactorHint.uid||a.multiFactorUid,phoneSignInInfo:{recaptchaToken:d}})}):g=kh(c,{phoneNumber:f,recaptchaToken:d});return g.then(function(h){"function"===typeof b.reset&&b.reset();return h},function(h){"function"===typeof b.reset&&b.reset();throw h;});default:throw new u("argument-error",'Only firebase.auth.ApplicationVerifiers with type="recaptcha" are currently supported.');}})};
	function lh(a,b){if(!a)throw new u("missing-verification-id");if(!b)throw new u("missing-verification-code");return new ch({bb:a,ab:b})}L(hh,{PROVIDER_ID:"phone"});L(hh,{PHONE_SIGN_IN_METHOD:"phone"});
	function mh(a){if(a.temporaryProof&&a.phoneNumber)return new ch({Ja:a.temporaryProof,da:a.phoneNumber});var b=a&&a.providerId;if(!b||"password"===b)return null;var c=a&&a.oauthAccessToken,d=a&&a.oauthTokenSecret,e=a&&a.nonce,f=a&&a.oauthIdToken,g=a&&a.pendingToken;try{switch(b){case "google.com":return Rg(f,c);case "facebook.com":return Ng(c);case "github.com":return Pg(c);case "twitter.com":return Tg(c,d);default:return c||d||f||g?g?0==b.indexOf("saml.")?new Bg(b,g):new Hg(b,{pendingToken:g,idToken:a.oauthIdToken,
	accessToken:a.oauthAccessToken},b):(new M(b)).credential({idToken:f,accessToken:c,rawNonce:e}):null}}catch(h){return null}}function nh(a){if(!a.isOAuthProvider)throw new u("invalid-oauth-provider");};function oh(a,b,c,d,e,f,g){this.c=a;this.b=b||null;this.g=c||null;this.f=d||null;this.i=f||null;this.h=g||null;this.a=e||null;if(this.g||this.a){if(this.g&&this.a)throw new u("invalid-auth-event");if(this.g&&!this.f)throw new u("invalid-auth-event");}else throw new u("invalid-auth-event");}oh.prototype.getUid=function(){var a=[];a.push(this.c);this.b&&a.push(this.b);this.f&&a.push(this.f);this.h&&a.push(this.h);return a.join("-")};oh.prototype.S=function(){return this.h};
	oh.prototype.v=function(){return{type:this.c,eventId:this.b,urlResponse:this.g,sessionId:this.f,postBody:this.i,tenantId:this.h,error:this.a&&this.a.v()}};function ph(a){a=a||{};return a.type?new oh(a.type,a.eventId,a.urlResponse,a.sessionId,a.error&&wa(a.error),a.postBody,a.tenantId):null};/*
	
	 Copyright 2018 Google Inc.
	
	 Licensed under the Apache License, Version 2.0 (the "License");
	 you may not use this file except in compliance with the License.
	 You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	 Unless required by applicable law or agreed to in writing, software
	 distributed under the License is distributed on an "AS IS" BASIS,
	 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 See the License for the specific language governing permissions and
	 limitations under the License.
	*/
	function qh(){this.b=null;this.a=[]}var rh=null;function sh(a){var b=rh;b.a.push(a);b.b||(b.b=function(c){for(var d=0;d<b.a.length;d++)b.a[d](c)},a=J("universalLinks.subscribe",l),"function"===typeof a&&a(null,b.b))};function th(a){var b="unauthorized-domain",c=void 0,d=Zd(a);a=d.b;d=d.f;"chrome-extension"==d?c=Mb("This chrome extension ID (chrome-extension://%s) is not authorized to run this operation. Add it to the OAuth redirect domains list in the Firebase console -> Auth section -> Sign in method tab.",a):"http"==d||"https"==d?c=Mb("This domain (%s) is not authorized to run this operation. Add it to the OAuth redirect domains list in the Firebase console -> Auth section -> Sign in method tab.",a):b="operation-not-supported-in-this-environment";
	u.call(this,b,c)}t(th,u);function uh(a,b,c){u.call(this,a,c);a=b||{};a.Gb&&K(this,"email",a.Gb);a.da&&K(this,"phoneNumber",a.da);a.credential&&K(this,"credential",a.credential);a.Wb&&K(this,"tenantId",a.Wb)}t(uh,u);uh.prototype.v=function(){var a={code:this.code,message:this.message};this.email&&(a.email=this.email);this.phoneNumber&&(a.phoneNumber=this.phoneNumber);this.tenantId&&(a.tenantId=this.tenantId);var b=this.credential&&this.credential.v();b&&B(a,b);return a};uh.prototype.toJSON=function(){return this.v()};
	function vh(a){if(a.code){var b=a.code||"";0==b.indexOf(ua)&&(b=b.substring(ua.length));var c={credential:mh(a),Wb:a.tenantId};if(a.email)c.Gb=a.email;else if(a.phoneNumber)c.da=a.phoneNumber;else if(!c.credential)return new u(b,a.message||void 0);return new uh(b,c,a.message)}return null};function wh(){}wh.prototype.c=null;function xh(a){return a.c||(a.c=a.b())};var yh;function zh(){}t(zh,wh);zh.prototype.a=function(){var a=Ah(this);return a?new ActiveXObject(a):new XMLHttpRequest};zh.prototype.b=function(){var a={};Ah(this)&&(a[0]=!0,a[1]=!0);return a};
	function Ah(a){if(!a.f&&"undefined"==typeof XMLHttpRequest&&"undefined"!=typeof ActiveXObject){for(var b=["MSXML2.XMLHTTP.6.0","MSXML2.XMLHTTP.3.0","MSXML2.XMLHTTP","Microsoft.XMLHTTP"],c=0;c<b.length;c++){var d=b[c];try{return new ActiveXObject(d),a.f=d}catch(e){}}throw Error("Could not create ActiveXObject. ActiveX might be disabled, or MSXML might not be installed");}return a.f}yh=new zh;function Bh(){}t(Bh,wh);Bh.prototype.a=function(){var a=new XMLHttpRequest;if("withCredentials"in a)return a;if("undefined"!=typeof XDomainRequest)return new Ch;throw Error("Unsupported browser");};Bh.prototype.b=function(){return{}};
	function Ch(){this.a=new XDomainRequest;this.readyState=0;this.onreadystatechange=null;this.responseType=this.responseText=this.response="";this.status=-1;this.statusText="";this.a.onload=r(this.oc,this);this.a.onerror=r(this.Pb,this);this.a.onprogress=r(this.pc,this);this.a.ontimeout=r(this.tc,this)}k=Ch.prototype;k.open=function(a,b,c){if(null!=c&&!c)throw Error("Only async requests are supported.");this.a.open(a,b)};
	k.send=function(a){if(a)if("string"==typeof a)this.a.send(a);else throw Error("Only string data is supported");else this.a.send()};k.abort=function(){this.a.abort()};k.setRequestHeader=function(){};k.getResponseHeader=function(a){return"content-type"==a.toLowerCase()?this.a.contentType:""};k.oc=function(){this.status=200;this.response=this.responseText=this.a.responseText;Dh(this,4)};k.Pb=function(){this.status=500;this.response=this.responseText="";Dh(this,4)};k.tc=function(){this.Pb()};
	k.pc=function(){this.status=200;Dh(this,1)};function Dh(a,b){a.readyState=b;if(a.onreadystatechange)a.onreadystatechange()}k.getAllResponseHeaders=function(){return"content-type: "+this.a.contentType};function Eh(a,b,c){this.reset(a,b,c,void 0,void 0)}Eh.prototype.a=null;var Fh=0;Eh.prototype.reset=function(a,b,c,d,e){"number"==typeof e||Fh++;d||ta();delete this.a};function Gh(a){this.f=a;this.b=this.c=this.a=null}function Hh(a,b){this.name=a;this.value=b}Hh.prototype.toString=function(){return this.name};var Ih=new Hh("SEVERE",1E3),Jh=new Hh("WARNING",900),Kh=new Hh("CONFIG",700),Lh=new Hh("FINE",500);function Mh(a){if(a.c)return a.c;if(a.a)return Mh(a.a);Da("Root logger has no level set.");return null}Gh.prototype.log=function(a,b,c){if(a.value>=Mh(this).value)for(n(b)&&(b=b()),a=new Eh(a,String(b),this.f),c&&(a.a=c),c=this;c;)c=c.a};var Nh={},Oh=null;
	function Ph(a){Oh||(Oh=new Gh(""),Nh[""]=Oh,Oh.c=Kh);var b;if(!(b=Nh[a])){b=new Gh(a);var c=a.lastIndexOf("."),d=a.substr(c+1);c=Ph(a.substr(0,c));c.b||(c.b={});c.b[d]=b;b.a=c;Nh[a]=b}return b};function Qh(a,b){a&&a.log(Lh,b,void 0)};function Rh(a){this.f=a}t(Rh,wh);Rh.prototype.a=function(){return new Sh(this.f)};Rh.prototype.b=function(a){return function(){return a}}({});function Sh(a){G.call(this);this.s=a;this.readyState=Th;this.status=0;this.responseType=this.responseText=this.response=this.statusText="";this.onreadystatechange=null;this.i=new Headers;this.b=null;this.m="GET";this.g="";this.a=!1;this.h=Ph("goog.net.FetchXmlHttp");this.l=this.c=this.f=null}t(Sh,G);var Th=0;k=Sh.prototype;
	k.open=function(a,b){if(this.readyState!=Th)throw this.abort(),Error("Error reopening a connection");this.m=a;this.g=b;this.readyState=1;Uh(this)};k.send=function(a){if(1!=this.readyState)throw this.abort(),Error("need to call open() first. ");this.a=!0;var b={headers:this.i,method:this.m,credentials:void 0,cache:void 0};a&&(b.body=a);this.s.fetch(new Request(this.g,b)).then(this.sc.bind(this),this.Sa.bind(this))};
	k.abort=function(){this.response=this.responseText="";this.i=new Headers;this.status=0;this.c&&this.c.cancel("Request was aborted.");1<=this.readyState&&this.a&&4!=this.readyState&&(this.a=!1,Vh(this,!1));this.readyState=Th};
	k.sc=function(a){this.a&&(this.f=a,this.b||(this.b=a.headers,this.readyState=2,Uh(this)),this.a&&(this.readyState=3,Uh(this),this.a&&("arraybuffer"===this.responseType?a.arrayBuffer().then(this.qc.bind(this),this.Sa.bind(this)):"undefined"!==typeof l.ReadableStream&&"body"in a?(this.response=this.responseText="",this.c=a.body.getReader(),this.l=new TextDecoder,Wh(this)):a.text().then(this.rc.bind(this),this.Sa.bind(this)))))};function Wh(a){a.c.read().then(a.nc.bind(a)).catch(a.Sa.bind(a))}
	k.nc=function(a){if(this.a){var b=this.l.decode(a.value?a.value:new Uint8Array(0),{stream:!a.done});b&&(this.response=this.responseText+=b);a.done?Vh(this,!0):Uh(this);3==this.readyState&&Wh(this)}};k.rc=function(a){this.a&&(this.response=this.responseText=a,Vh(this,!0))};k.qc=function(a){this.a&&(this.response=a,Vh(this,!0))};k.Sa=function(a){var b=this.h;b&&b.log(Jh,"Failed to fetch url "+this.g,a instanceof Error?a:Error(a));this.a&&Vh(this,!0)};
	function Vh(a,b){b&&a.f&&(a.status=a.f.status,a.statusText=a.f.statusText);a.readyState=4;a.f=null;a.c=null;a.l=null;Uh(a)}k.setRequestHeader=function(a,b){this.i.append(a,b)};k.getResponseHeader=function(a){return this.b?this.b.get(a.toLowerCase())||"":((a=this.h)&&a.log(Jh,"Attempting to get response header but no headers have been received for url: "+this.g,void 0),"")};
	k.getAllResponseHeaders=function(){if(!this.b){var a=this.h;a&&a.log(Jh,"Attempting to get all response headers but no headers have been received for url: "+this.g,void 0);return""}a=[];for(var b=this.b.entries(),c=b.next();!c.done;)c=c.value,a.push(c[0]+": "+c[1]),c=b.next();return a.join("\r\n")};function Uh(a){a.onreadystatechange&&a.onreadystatechange.call(a)};function Xh(a){G.call(this);this.headers=new Fd;this.D=a||null;this.c=!1;this.B=this.a=null;this.h=this.P=this.l="";this.f=this.O=this.i=this.N=!1;this.g=0;this.s=null;this.m=Yh;this.w=this.R=!1}t(Xh,G);var Yh="";Xh.prototype.b=Ph("goog.net.XhrIo");var Zh=/^https?$/i,$h=["POST","PUT"];
	function ai(a,b,c,d,e){if(a.a)throw Error("[goog.net.XhrIo] Object is active with another request="+a.l+"; newUri="+b);c=c?c.toUpperCase():"GET";a.l=b;a.h="";a.P=c;a.N=!1;a.c=!0;a.a=a.D?a.D.a():yh.a();a.B=a.D?xh(a.D):xh(yh);a.a.onreadystatechange=r(a.Sb,a);try{Qh(a.b,bi(a,"Opening Xhr")),a.O=!0,a.a.open(c,String(b),!0),a.O=!1}catch(g){Qh(a.b,bi(a,"Error opening Xhr: "+g.message));ci(a,g);return}b=d||"";var f=new Fd(a.headers);e&&Ed(e,function(g,h){f.set(h,g)});e=Qa(f.X());d=l.FormData&&b instanceof
	l.FormData;!Sa($h,c)||e||d||f.set("Content-Type","application/x-www-form-urlencoded;charset=utf-8");f.forEach(function(g,h){this.a.setRequestHeader(h,g)},a);a.m&&(a.a.responseType=a.m);"withCredentials"in a.a&&a.a.withCredentials!==a.R&&(a.a.withCredentials=a.R);try{di(a),0<a.g&&(a.w=ei(a.a),Qh(a.b,bi(a,"Will abort after "+a.g+"ms if incomplete, xhr2 "+a.w)),a.w?(a.a.timeout=a.g,a.a.ontimeout=r(a.Ka,a)):a.s=Ad(a.Ka,a.g,a)),Qh(a.b,bi(a,"Sending request")),a.i=!0,a.a.send(b),a.i=!1}catch(g){Qh(a.b,
	bi(a,"Send error: "+g.message)),ci(a,g)}}function ei(a){return Sb&&bc(9)&&"number"===typeof a.timeout&&void 0!==a.ontimeout}function Ra(a){return"content-type"==a.toLowerCase()}k=Xh.prototype;k.Ka=function(){"undefined"!=typeof ha&&this.a&&(this.h="Timed out after "+this.g+"ms, aborting",Qh(this.b,bi(this,this.h)),this.dispatchEvent("timeout"),this.abort(8))};function ci(a,b){a.c=!1;a.a&&(a.f=!0,a.a.abort(),a.f=!1);a.h=b;fi(a);gi(a)}
	function fi(a){a.N||(a.N=!0,a.dispatchEvent("complete"),a.dispatchEvent("error"))}k.abort=function(){this.a&&this.c&&(Qh(this.b,bi(this,"Aborting")),this.c=!1,this.f=!0,this.a.abort(),this.f=!1,this.dispatchEvent("complete"),this.dispatchEvent("abort"),gi(this))};k.Ba=function(){this.a&&(this.c&&(this.c=!1,this.f=!0,this.a.abort(),this.f=!1),gi(this,!0));Xh.Za.Ba.call(this)};k.Sb=function(){this.wa||(this.O||this.i||this.f?hi(this):this.Hc())};k.Hc=function(){hi(this)};
	function hi(a){if(a.c&&"undefined"!=typeof ha)if(a.B[1]&&4==ii(a)&&2==ji(a))Qh(a.b,bi(a,"Local request error detected and ignored"));else if(a.i&&4==ii(a))Ad(a.Sb,0,a);else if(a.dispatchEvent("readystatechange"),4==ii(a)){Qh(a.b,bi(a,"Request complete"));a.c=!1;try{var b=ji(a);a:switch(b){case 200:case 201:case 202:case 204:case 206:case 304:case 1223:var c=!0;break a;default:c=!1}var d;if(!(d=c)){var e;if(e=0===b){var f=String(a.l).match(Id)[1]||null;if(!f&&l.self&&l.self.location){var g=l.self.location.protocol;
	f=g.substr(0,g.length-1)}e=!Zh.test(f?f.toLowerCase():"")}d=e}if(d)a.dispatchEvent("complete"),a.dispatchEvent("success");else{try{var h=2<ii(a)?a.a.statusText:""}catch(m){Qh(a.b,"Can not get status: "+m.message),h=""}a.h=h+" ["+ji(a)+"]";fi(a)}}finally{gi(a)}}}function gi(a,b){if(a.a){di(a);var c=a.a,d=a.B[0]?ka:null;a.a=null;a.B=null;b||a.dispatchEvent("ready");try{c.onreadystatechange=d}catch(e){(a=a.b)&&a.log(Ih,"Problem encountered resetting onreadystatechange: "+e.message,void 0)}}}
	function di(a){a.a&&a.w&&(a.a.ontimeout=null);a.s&&(l.clearTimeout(a.s),a.s=null)}function ii(a){return a.a?a.a.readyState:0}function ji(a){try{return 2<ii(a)?a.a.status:-1}catch(b){return-1}}function ki(a){try{return a.a?a.a.responseText:""}catch(b){return Qh(a.b,"Can not get responseText: "+b.message),""}}
	k.getResponse=function(){try{if(!this.a)return null;if("response"in this.a)return this.a.response;switch(this.m){case Yh:case "text":return this.a.responseText;case "arraybuffer":if("mozResponseArrayBuffer"in this.a)return this.a.mozResponseArrayBuffer}var a=this.b;a&&a.log(Ih,"Response type "+this.m+" is not supported on this browser",void 0);return null}catch(b){return Qh(this.b,"Can not get response: "+b.message),null}};function bi(a,b){return b+" ["+a.P+" "+a.l+" "+ji(a)+"]"};/*
	 Portions of this code are from MochiKit, received by
	 The Closure Authors under the MIT license. All other code is Copyright
	 2005-2009 The Closure Authors. All Rights Reserved.
	*/
	function li(a){var b=mi;this.g=[];this.w=b;this.s=a||null;this.f=this.a=!1;this.c=void 0;this.u=this.B=this.i=!1;this.h=0;this.b=null;this.l=0}li.prototype.cancel=function(a){if(this.a)this.c instanceof li&&this.c.cancel();else{if(this.b){var b=this.b;delete this.b;a?b.cancel(a):(b.l--,0>=b.l&&b.cancel())}this.w?this.w.call(this.s,this):this.u=!0;this.a||(a=new ni(this),oi(this),pi(this,!1,a))}};li.prototype.m=function(a,b){this.i=!1;pi(this,a,b)};function pi(a,b,c){a.a=!0;a.c=c;a.f=!b;qi(a)}
	function oi(a){if(a.a){if(!a.u)throw new ri(a);a.u=!1}}function si(a,b){ti(a,null,b,void 0)}function ti(a,b,c,d){a.g.push([b,c,d]);a.a&&qi(a)}li.prototype.then=function(a,b,c){var d,e,f=new D(function(g,h){d=g;e=h});ti(this,d,function(g){g instanceof ni?f.cancel():e(g)});return f.then(a,b,c)};li.prototype.$goog_Thenable=!0;function ui(a){return Pa(a.g,function(b){return n(b[1])})}
	function qi(a){if(a.h&&a.a&&ui(a)){var b=a.h,c=vi[b];c&&(l.clearTimeout(c.a),delete vi[b]);a.h=0}a.b&&(a.b.l--,delete a.b);b=a.c;for(var d=c=!1;a.g.length&&!a.i;){var e=a.g.shift(),f=e[0],g=e[1];e=e[2];if(f=a.f?g:f)try{var h=f.call(e||a.s,b);void 0!==h&&(a.f=a.f&&(h==b||h instanceof Error),a.c=b=h);if(Ba(b)||"function"===typeof l.Promise&&b instanceof l.Promise)d=!0,a.i=!0}catch(m){b=m,a.f=!0,ui(a)||(c=!0)}}a.c=b;d&&(h=r(a.m,a,!0),d=r(a.m,a,!1),b instanceof li?(ti(b,h,d),b.B=!0):b.then(h,d));c&&(b=
	new wi(b),vi[b.a]=b,a.h=b.a)}function ri(){w.call(this)}t(ri,w);ri.prototype.message="Deferred has already fired";ri.prototype.name="AlreadyCalledError";function ni(){w.call(this)}t(ni,w);ni.prototype.message="Deferred was canceled";ni.prototype.name="CanceledError";function wi(a){this.a=l.setTimeout(r(this.c,this),0);this.b=a}wi.prototype.c=function(){delete vi[this.a];throw this.b;};var vi={};function xi(a){var b={},c=b.document||document,d=vb(a).toString(),e=ic(document,"SCRIPT"),f={Tb:e,Ka:void 0},g=new li(f),h=null,m=null!=b.timeout?b.timeout:5E3;0<m&&(h=window.setTimeout(function(){yi(e,!0);var p=new zi(Ai,"Timeout reached for loading script "+d);oi(g);pi(g,!1,p)},m),f.Ka=h);e.onload=e.onreadystatechange=function(){e.readyState&&"loaded"!=e.readyState&&"complete"!=e.readyState||(yi(e,b.ud||!1,h),oi(g),pi(g,!0,null))};e.onerror=function(){yi(e,!0,h);var p=new zi(Bi,"Error while loading script "+
	d);oi(g);pi(g,!1,p)};f=b.attributes||{};B(f,{type:"text/javascript",charset:"UTF-8"});fc(e,f);Lb(e,a);Ci(c).appendChild(e);return g}function Ci(a){var b;return(b=(a||document).getElementsByTagName("HEAD"))&&0!=b.length?b[0]:a.documentElement}function mi(){if(this&&this.Tb){var a=this.Tb;a&&"SCRIPT"==a.tagName&&yi(a,!0,this.Ka)}}
	function yi(a,b,c){null!=c&&l.clearTimeout(c);a.onload=ka;a.onerror=ka;a.onreadystatechange=ka;b&&window.setTimeout(function(){a&&a.parentNode&&a.parentNode.removeChild(a)},0)}var Bi=0,Ai=1;function zi(a,b){var c="Jsloader error (code #"+a+")";b&&(c+=": "+b);w.call(this,c);this.code=a}t(zi,w);function Di(a){this.f=a}t(Di,wh);Di.prototype.a=function(){return new this.f};Di.prototype.b=function(){return{}};
	function Ei(a,b,c){this.c=a;a=b||{};this.u=a.secureTokenEndpoint||"https://securetoken.googleapis.com/v1/token";this.m=a.secureTokenTimeout||Fi;this.g=kb(a.secureTokenHeaders||Gi);this.h=a.firebaseEndpoint||"https://www.googleapis.com/identitytoolkit/v3/relyingparty/";this.l=a.identityPlatformEndpoint||"https://identitytoolkit.googleapis.com/v2/";this.i=a.firebaseTimeout||Hi;this.a=kb(a.firebaseHeaders||Ii);c&&(this.a["X-Client-Version"]=c,this.g["X-Client-Version"]=c);c="Node"==He();c=l.XMLHttpRequest||
	c&&firebase.INTERNAL.node&&firebase.INTERNAL.node.XMLHttpRequest;if(!c&&!Ge())throw new u("internal-error","The XMLHttpRequest compatibility library was not found.");this.f=void 0;Ge()?this.f=new Rh(self):Ie()?this.f=new Di(c):this.f=new Bh;this.b=null}var Ji,Ag="idToken",Fi=new We(3E4,6E4),Gi={"Content-Type":"application/x-www-form-urlencoded"},Hi=new We(3E4,6E4),Ii={"Content-Type":"application/json"};function Ki(a,b){b?a.a["X-Firebase-Locale"]=b:delete a.a["X-Firebase-Locale"]}
	function Li(a,b){b?(a.a["X-Client-Version"]=b,a.g["X-Client-Version"]=b):(delete a.a["X-Client-Version"],delete a.g["X-Client-Version"])}Ei.prototype.S=function(){return this.b};function Mi(a,b,c,d,e,f,g){re()||Ge()?a=r(a.w,a):(Ji||(Ji=new D(function(h,m){Ni(h,m)})),a=r(a.s,a));a(b,c,d,e,f,g)}
	Ei.prototype.w=function(a,b,c,d,e,f){if(Ge()&&("undefined"===typeof l.fetch||"undefined"===typeof l.Headers||"undefined"===typeof l.Request))throw new u("operation-not-supported-in-this-environment","fetch, Headers and Request native APIs or equivalent Polyfills must be available to support HTTP requests from a Worker environment.");var g=new Xh(this.f);if(f){g.g=Math.max(0,f);var h=setTimeout(function(){g.dispatchEvent("timeout")},f)}md(g,"complete",function(){h&&clearTimeout(h);var m=null;try{m=
	JSON.parse(ki(this))||null}catch(p){m=null}b&&b(m)});sd(g,"ready",function(){h&&clearTimeout(h);Sc(this)});sd(g,"timeout",function(){h&&clearTimeout(h);Sc(this);b&&b(null)});ai(g,a,c,d,e)};var Oi=new nb(ob,"https://apis.google.com/js/client.js?onload=%{onload}"),Pi="__fcb"+Math.floor(1E6*Math.random()).toString();
	function Ni(a,b){if(((window.gapi||{}).client||{}).request)a();else{l[Pi]=function(){((window.gapi||{}).client||{}).request?a():b(Error("CORS_UNSUPPORTED"))};var c=wb(Oi,{onload:Pi});si(xi(c),function(){b(Error("CORS_UNSUPPORTED"))})}}
	Ei.prototype.s=function(a,b,c,d,e){var f=this;Ji.then(function(){window.gapi.client.setApiKey(f.c);var g=window.gapi.auth.getToken();window.gapi.auth.setToken(null);window.gapi.client.request({path:a,method:c,body:d,headers:e,authType:"none",callback:function(h){window.gapi.auth.setToken(g);b&&b(h)}})}).o(function(g){b&&b({error:{message:g&&g.message||"CORS_UNSUPPORTED"}})})};
	function Qi(a,b){return new D(function(c,d){"refresh_token"==b.grant_type&&b.refresh_token||"authorization_code"==b.grant_type&&b.code?Mi(a,a.u+"?key="+encodeURIComponent(a.c),function(e){e?e.error?d(Ri(e)):e.access_token&&e.refresh_token?c(e):d(new u("internal-error")):d(new u("network-request-failed"))},"POST",ce(b).toString(),a.g,a.m.get()):d(new u("internal-error"))})}
	function Si(a,b,c,d,e,f,g){var h=Zd(b+c);H(h,"key",a.c);g&&H(h,"cb",ta().toString());var m="GET"==d;if(m)for(var p in e)e.hasOwnProperty(p)&&H(h,p,e[p]);return new D(function(v,C){Mi(a,h.toString(),function(A){A?A.error?C(Ri(A,f||{})):v(A):C(new u("network-request-failed"))},d,m?void 0:he(Se(e)),a.a,a.i.get())})}function Ti(a){a=a.email;if("string"!==typeof a||!Ae.test(a))throw new u("invalid-email");}function Ui(a){"email"in a&&Ti(a)}
	function Vi(a,b){return N(a,Wi,{identifier:b,continueUri:Pe()?oe():"http://localhost"}).then(function(c){return c.signinMethods||[]})}function Xi(a){return N(a,Yi,{}).then(function(b){return b.authorizedDomains||[]})}function O(a){if(!a[Ag]){if(a.mfaPendingCredential)throw new u("multi-factor-auth-required",null,kb(a));throw new u("internal-error");}}
	function Zi(a){if(a.phoneNumber||a.temporaryProof){if(!a.phoneNumber||!a.temporaryProof)throw new u("internal-error");}else{if(!a.sessionInfo)throw new u("missing-verification-id");if(!a.code)throw new u("missing-verification-code");}}Ei.prototype.vb=function(){return N(this,$i,{})};Ei.prototype.xb=function(a,b){return N(this,aj,{idToken:a,email:b})};Ei.prototype.yb=function(a,b){return N(this,Zg,{idToken:a,password:b})};var bj={displayName:"DISPLAY_NAME",photoUrl:"PHOTO_URL"};k=Ei.prototype;
	k.zb=function(a,b){var c={idToken:a},d=[];ib(bj,function(e,f){var g=b[f];null===g?d.push(e):f in b&&(c[f]=g)});d.length&&(c.deleteAttribute=d);return N(this,aj,c)};k.rb=function(a,b){a={requestType:"PASSWORD_RESET",email:a};B(a,b);return N(this,cj,a)};k.sb=function(a,b){a={requestType:"EMAIL_SIGNIN",email:a};B(a,b);return N(this,dj,a)};k.qb=function(a,b){a={requestType:"VERIFY_EMAIL",idToken:a};B(a,b);return N(this,ej,a)};
	k.Ab=function(a,b,c){a={requestType:"VERIFY_AND_CHANGE_EMAIL",idToken:a,newEmail:b};B(a,c);return N(this,fj,a)};function kh(a,b){return N(a,gj,b)}k.cb=function(a){return N(this,hj,a)};function ih(a,b){return N(a,ij,b).then(function(c){return c.phoneSessionInfo.sessionInfo})}
	function jj(a){if(!a.phoneVerificationInfo)throw new u("internal-error");if(!a.phoneVerificationInfo.sessionInfo)throw new u("missing-verification-id");if(!a.phoneVerificationInfo.code)throw new u("missing-verification-code");}function jh(a,b){return N(a,kj,b).then(function(c){return c.phoneResponseInfo.sessionInfo})}function lj(a,b,c){return N(a,mj,{idToken:b,deleteProvider:c})}function nj(a){if(!a.requestUri||!a.sessionId&&!a.postBody&&!a.pendingToken)throw new u("internal-error");}
	function oj(a,b){b.oauthIdToken&&b.providerId&&0==b.providerId.indexOf("oidc.")&&!b.pendingToken&&(a.sessionId?b.nonce=a.sessionId:a.postBody&&(a=new Qd(a.postBody),ge(a,"nonce")&&(b.nonce=a.get("nonce"))));return b}
	function pj(a){var b=null;a.needConfirmation?(a.code="account-exists-with-different-credential",b=vh(a)):"FEDERATED_USER_ID_ALREADY_LINKED"==a.errorMessage?(a.code="credential-already-in-use",b=vh(a)):"EMAIL_EXISTS"==a.errorMessage?(a.code="email-already-in-use",b=vh(a)):a.errorMessage&&(b=qj(a.errorMessage));if(b)throw b;O(a)}function Cg(a,b){b.returnIdpCredential=!0;return N(a,rj,b)}function Eg(a,b){b.returnIdpCredential=!0;return N(a,sj,b)}
	function Fg(a,b){b.returnIdpCredential=!0;b.autoCreate=!1;return N(a,tj,b)}function uj(a){if(!a.oobCode)throw new u("invalid-action-code");}k.jb=function(a,b){return N(this,vj,{oobCode:a,newPassword:b})};k.Pa=function(a){return N(this,wj,{oobCode:a})};k.fb=function(a){return N(this,xj,{oobCode:a})};
	var xj={endpoint:"setAccountInfo",A:uj,Y:"email",C:!0},wj={endpoint:"resetPassword",A:uj,G:function(a){var b=a.requestType;if(!b||!a.email&&"EMAIL_SIGNIN"!=b&&"VERIFY_AND_CHANGE_EMAIL"!=b)throw new u("internal-error");},C:!0},yj={endpoint:"signupNewUser",A:function(a){Ti(a);if(!a.password)throw new u("weak-password");},G:O,U:!0,C:!0},Wi={endpoint:"createAuthUri",C:!0},zj={endpoint:"deleteAccount",M:["idToken"]},mj={endpoint:"setAccountInfo",M:["idToken","deleteProvider"],A:function(a){if("array"!=
	la(a.deleteProvider))throw new u("internal-error");}},Wg={endpoint:"emailLinkSignin",M:["email","oobCode"],A:Ti,G:O,U:!0,C:!0},Yg={endpoint:"emailLinkSignin",M:["idToken","email","oobCode"],A:Ti,G:O,U:!0},Aj={endpoint:"accounts/mfaEnrollment:finalize",M:["idToken","phoneVerificationInfo"],A:jj,G:O,C:!0,La:!0},Bj={endpoint:"accounts/mfaSignIn:finalize",M:["mfaPendingCredential","phoneVerificationInfo"],A:jj,G:O,C:!0,La:!0},Cj={endpoint:"getAccountInfo"},dj={endpoint:"getOobConfirmationCode",M:["requestType"],
	A:function(a){if("EMAIL_SIGNIN"!=a.requestType)throw new u("internal-error");Ti(a)},Y:"email",C:!0},ej={endpoint:"getOobConfirmationCode",M:["idToken","requestType"],A:function(a){if("VERIFY_EMAIL"!=a.requestType)throw new u("internal-error");},Y:"email",C:!0},fj={endpoint:"getOobConfirmationCode",M:["idToken","newEmail","requestType"],A:function(a){if("VERIFY_AND_CHANGE_EMAIL"!=a.requestType)throw new u("internal-error");},Y:"email",C:!0},cj={endpoint:"getOobConfirmationCode",M:["requestType"],A:function(a){if("PASSWORD_RESET"!=
	a.requestType)throw new u("internal-error");Ti(a)},Y:"email",C:!0},Yi={hb:!0,endpoint:"getProjectConfig",Rb:"GET"},Dj={hb:!0,endpoint:"getRecaptchaParam",Rb:"GET",G:function(a){if(!a.recaptchaSiteKey)throw new u("internal-error");}},vj={endpoint:"resetPassword",A:uj,Y:"email",C:!0},gj={endpoint:"sendVerificationCode",M:["phoneNumber","recaptchaToken"],Y:"sessionInfo",C:!0},aj={endpoint:"setAccountInfo",M:["idToken"],A:Ui,U:!0},Zg={endpoint:"setAccountInfo",M:["idToken"],A:function(a){Ui(a);if(!a.password)throw new u("weak-password");
	},G:O,U:!0},$i={endpoint:"signupNewUser",G:O,U:!0,C:!0},ij={endpoint:"accounts/mfaEnrollment:start",M:["idToken","phoneEnrollmentInfo"],A:function(a){if(!a.phoneEnrollmentInfo)throw new u("internal-error");if(!a.phoneEnrollmentInfo.phoneNumber)throw new u("missing-phone-number");if(!a.phoneEnrollmentInfo.recaptchaToken)throw new u("missing-app-credential");},G:function(a){if(!a.phoneSessionInfo||!a.phoneSessionInfo.sessionInfo)throw new u("internal-error");},C:!0,La:!0},kj={endpoint:"accounts/mfaSignIn:start",
	M:["mfaPendingCredential","mfaEnrollmentId","phoneSignInInfo"],A:function(a){if(!a.phoneSignInInfo||!a.phoneSignInInfo.recaptchaToken)throw new u("missing-app-credential");},G:function(a){if(!a.phoneResponseInfo||!a.phoneResponseInfo.sessionInfo)throw new u("internal-error");},C:!0,La:!0},rj={endpoint:"verifyAssertion",A:nj,Wa:oj,G:pj,U:!0,C:!0},tj={endpoint:"verifyAssertion",A:nj,Wa:oj,G:function(a){if(a.errorMessage&&"USER_NOT_FOUND"==a.errorMessage)throw new u("user-not-found");if(a.errorMessage)throw qj(a.errorMessage);
	O(a)},U:!0,C:!0},sj={endpoint:"verifyAssertion",A:function(a){nj(a);if(!a.idToken)throw new u("internal-error");},Wa:oj,G:pj,U:!0},Ej={endpoint:"verifyCustomToken",A:function(a){if(!a.token)throw new u("invalid-custom-token");},G:O,U:!0,C:!0},Xg={endpoint:"verifyPassword",A:function(a){Ti(a);if(!a.password)throw new u("wrong-password");},G:O,U:!0,C:!0},hj={endpoint:"verifyPhoneNumber",A:Zi,G:O,C:!0},eh={endpoint:"verifyPhoneNumber",A:function(a){if(!a.idToken)throw new u("internal-error");Zi(a)},
	G:function(a){if(a.temporaryProof)throw a.code="credential-already-in-use",vh(a);O(a)}},fh={Eb:{USER_NOT_FOUND:"user-not-found"},endpoint:"verifyPhoneNumber",A:Zi,G:O,C:!0},Fj={endpoint:"accounts/mfaEnrollment:withdraw",M:["idToken","mfaEnrollmentId"],G:function(a){if(!!a[Ag]^!!a.refreshToken)throw new u("internal-error");},C:!0,La:!0};
	function N(a,b,c){if(!jf(c,b.M))return F(new u("internal-error"));var d=!!b.La,e=b.Rb||"POST",f;return E(c).then(b.A).then(function(){b.U&&(c.returnSecureToken=!0);b.C&&a.b&&"undefined"===typeof c.tenantId&&(c.tenantId=a.b);return d?Si(a,a.l,b.endpoint,e,c,b.Eb,b.hb||!1):Si(a,a.h,b.endpoint,e,c,b.Eb,b.hb||!1)}).then(function(g){f=g;return b.Wa?b.Wa(c,f):f}).then(b.G).then(function(){if(!b.Y)return f;if(!(b.Y in f))throw new u("internal-error");return f[b.Y]})}
	function qj(a){return Ri({error:{errors:[{message:a}],code:400,message:a}})}
	function Ri(a,b){var c=(a.error&&a.error.errors&&a.error.errors[0]||{}).reason||"";var d={keyInvalid:"invalid-api-key",ipRefererBlocked:"app-not-authorized"};if(c=d[c]?new u(d[c]):null)return c;c=a.error&&a.error.message||"";d={INVALID_CUSTOM_TOKEN:"invalid-custom-token",CREDENTIAL_MISMATCH:"custom-token-mismatch",MISSING_CUSTOM_TOKEN:"internal-error",INVALID_IDENTIFIER:"invalid-email",MISSING_CONTINUE_URI:"internal-error",INVALID_EMAIL:"invalid-email",INVALID_PASSWORD:"wrong-password",USER_DISABLED:"user-disabled",
	MISSING_PASSWORD:"internal-error",EMAIL_EXISTS:"email-already-in-use",PASSWORD_LOGIN_DISABLED:"operation-not-allowed",INVALID_IDP_RESPONSE:"invalid-credential",INVALID_PENDING_TOKEN:"invalid-credential",FEDERATED_USER_ID_ALREADY_LINKED:"credential-already-in-use",MISSING_OR_INVALID_NONCE:"missing-or-invalid-nonce",INVALID_MESSAGE_PAYLOAD:"invalid-message-payload",INVALID_RECIPIENT_EMAIL:"invalid-recipient-email",INVALID_SENDER:"invalid-sender",EMAIL_NOT_FOUND:"user-not-found",RESET_PASSWORD_EXCEED_LIMIT:"too-many-requests",
	EXPIRED_OOB_CODE:"expired-action-code",INVALID_OOB_CODE:"invalid-action-code",MISSING_OOB_CODE:"internal-error",INVALID_PROVIDER_ID:"invalid-provider-id",CREDENTIAL_TOO_OLD_LOGIN_AGAIN:"requires-recent-login",INVALID_ID_TOKEN:"invalid-user-token",TOKEN_EXPIRED:"user-token-expired",USER_NOT_FOUND:"user-token-expired",CORS_UNSUPPORTED:"cors-unsupported",DYNAMIC_LINK_NOT_ACTIVATED:"dynamic-link-not-activated",INVALID_APP_ID:"invalid-app-id",TOO_MANY_ATTEMPTS_TRY_LATER:"too-many-requests",WEAK_PASSWORD:"weak-password",
	OPERATION_NOT_ALLOWED:"operation-not-allowed",USER_CANCELLED:"user-cancelled",CAPTCHA_CHECK_FAILED:"captcha-check-failed",INVALID_APP_CREDENTIAL:"invalid-app-credential",INVALID_CODE:"invalid-verification-code",INVALID_PHONE_NUMBER:"invalid-phone-number",INVALID_SESSION_INFO:"invalid-verification-id",INVALID_TEMPORARY_PROOF:"invalid-credential",MISSING_APP_CREDENTIAL:"missing-app-credential",MISSING_CODE:"missing-verification-code",MISSING_PHONE_NUMBER:"missing-phone-number",MISSING_SESSION_INFO:"missing-verification-id",
	QUOTA_EXCEEDED:"quota-exceeded",SESSION_EXPIRED:"code-expired",REJECTED_CREDENTIAL:"rejected-credential",INVALID_CONTINUE_URI:"invalid-continue-uri",MISSING_ANDROID_PACKAGE_NAME:"missing-android-pkg-name",MISSING_IOS_BUNDLE_ID:"missing-ios-bundle-id",UNAUTHORIZED_DOMAIN:"unauthorized-continue-uri",INVALID_DYNAMIC_LINK_DOMAIN:"invalid-dynamic-link-domain",INVALID_OAUTH_CLIENT_ID:"invalid-oauth-client-id",INVALID_CERT_HASH:"invalid-cert-hash",UNSUPPORTED_TENANT_OPERATION:"unsupported-tenant-operation",
	INVALID_TENANT_ID:"invalid-tenant-id",TENANT_ID_MISMATCH:"tenant-id-mismatch",ADMIN_ONLY_OPERATION:"admin-restricted-operation",INVALID_MFA_PENDING_CREDENTIAL:"invalid-multi-factor-session",MFA_ENROLLMENT_NOT_FOUND:"multi-factor-info-not-found",MISSING_MFA_PENDING_CREDENTIAL:"missing-multi-factor-session",MISSING_MFA_ENROLLMENT_ID:"missing-multi-factor-info",EMAIL_CHANGE_NEEDS_VERIFICATION:"email-change-needs-verification",SECOND_FACTOR_EXISTS:"second-factor-already-in-use",SECOND_FACTOR_LIMIT_EXCEEDED:"maximum-second-factor-count-exceeded",
	UNSUPPORTED_FIRST_FACTOR:"unsupported-first-factor",UNVERIFIED_EMAIL:"unverified-email"};B(d,b||{});b=(b=c.match(/^[^\s]+\s*:\s*([\s\S]*)$/))&&1<b.length?b[1]:void 0;for(var e in d)if(0===c.indexOf(e))return new u(d[e],b);!b&&a&&(b=Re(a));return new u("internal-error",b)};function Gj(a){this.b=a;this.a=null;this.nb=Hj(this)}
	function Hj(a){return Ij().then(function(){return new D(function(b,c){J("gapi.iframes.getContext")().open({where:document.body,url:a.b,messageHandlersFilter:J("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"),attributes:{style:{position:"absolute",top:"-100px",width:"1px",height:"1px"}},dontclear:!0},function(d){function e(){clearTimeout(f);b()}a.a=d;a.a.restyle({setHideOnLeave:!1});var f=setTimeout(function(){c(Error("Network Error"))},Jj.get());d.ping(e).then(e,function(){c(Error("Network Error"))})})})})}
	function Kj(a,b){return a.nb.then(function(){return new D(function(c){a.a.send(b.type,b,c,J("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"))})})}function Lj(a,b){a.nb.then(function(){a.a.register("authEvent",b,J("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"))})}var Mj=new nb(ob,"https://apis.google.com/js/api.js?onload=%{onload}"),Nj=new We(3E4,6E4),Jj=new We(5E3,15E3),Oj=null;
	function Ij(){return Oj?Oj:Oj=(new D(function(a,b){function c(){Ve();J("gapi.load")("gapi.iframes",{callback:a,ontimeout:function(){Ve();b(Error("Network Error"))},timeout:Nj.get()})}if(J("gapi.iframes.Iframe"))a();else if(J("gapi.load"))c();else{var d="__iframefcb"+Math.floor(1E6*Math.random()).toString();l[d]=function(){J("gapi.load")?c():b(Error("Network Error"))};d=wb(Mj,{onload:d});E(xi(d)).o(function(){b(Error("Network Error"))})}})).o(function(a){Oj=null;throw a;})};function Pj(a,b,c){this.i=a;this.g=b;this.h=c;this.f=null;this.a=$d(this.i,"/__/auth/iframe");H(this.a,"apiKey",this.g);H(this.a,"appName",this.h);this.b=null;this.c=[]}Pj.prototype.toString=function(){this.f?H(this.a,"v",this.f):fe(this.a.a,"v");this.b?H(this.a,"eid",this.b):fe(this.a.a,"eid");this.c.length?H(this.a,"fw",this.c.join(",")):fe(this.a.a,"fw");return this.a.toString()};function Qj(a,b,c,d,e){this.s=a;this.m=b;this.c=c;this.u=d;this.i=this.g=this.l=null;this.a=e;this.h=this.f=null}
	Qj.prototype.ub=function(a){this.h=a;return this};
	Qj.prototype.toString=function(){var a=$d(this.s,"/__/auth/handler");H(a,"apiKey",this.m);H(a,"appName",this.c);H(a,"authType",this.u);if(this.a.isOAuthProvider){var b=this.a;try{var c=firebase.app(this.c).auth().ja()}catch(h){c=null}b.kb=c;H(a,"providerId",this.a.providerId);b=this.a;c=Se(b.Fb);for(var d in c)c[d]=c[d].toString();d=b.Oc;c=kb(c);for(var e=0;e<d.length;e++){var f=d[e];f in c&&delete c[f]}b.lb&&b.kb&&!c[b.lb]&&(c[b.lb]=b.kb);jb(c)||H(a,"customParameters",Re(c))}"function"===typeof this.a.Nb&&
	(b=this.a.Nb(),b.length&&H(a,"scopes",b.join(",")));this.l?H(a,"redirectUrl",this.l):fe(a.a,"redirectUrl");this.g?H(a,"eventId",this.g):fe(a.a,"eventId");this.i?H(a,"v",this.i):fe(a.a,"v");if(this.b)for(var g in this.b)this.b.hasOwnProperty(g)&&!Yd(a,g)&&H(a,g,this.b[g]);this.h?H(a,"tid",this.h):fe(a.a,"tid");this.f?H(a,"eid",this.f):fe(a.a,"eid");g=Rj(this.c);g.length&&H(a,"fw",g.join(","));return a.toString()};function Rj(a){try{return firebase.app(a).auth().Ea()}catch(b){return[]}}
	function Sj(a,b,c,d,e){this.u=a;this.f=b;this.b=c;this.c=d||null;this.h=e||null;this.m=this.s=this.w=null;this.g=[];this.l=this.a=null}
	function Tj(a){var b=oe();return Xi(a).then(function(c){a:{var d=Zd(b),e=d.f;d=d.b;for(var f=0;f<c.length;f++){var g=c[f];var h=d;var m=e;0==g.indexOf("chrome-extension://")?h=Zd(g).b==h&&"chrome-extension"==m:"http"!=m&&"https"!=m?h=!1:ze.test(g)?h=h==g:(g=g.split(".").join("\\."),h=(new RegExp("^(.+\\."+g+"|"+g+")$","i")).test(h));if(h){c=!0;break a}}c=!1}if(!c)throw new th(oe());})}
	function Uj(a){if(a.l)return a.l;a.l=Be().then(function(){if(!a.s){var b=a.c,c=a.h,d=Rj(a.b),e=new Pj(a.u,a.f,a.b);e.f=b;e.b=c;e.c=Wa(d||[]);a.s=e.toString()}a.i=new Gj(a.s);Vj(a)});return a.l}k=Sj.prototype;k.Lb=function(a,b,c){var d=new u("popup-closed-by-user"),e=new u("web-storage-unsupported"),f=this,g=!1;return this.ka().then(function(){Wj(f).then(function(h){h||(a&&ve(a),b(e),g=!0)})}).o(function(){}).then(function(){if(!g)return ye(a)}).then(function(){if(!g)return Bd(c).then(function(){b(d)})})};
	k.Ub=function(){var a=I();return!Qe(a)&&!Ue(a)};k.Qb=function(){return!1};
	k.Jb=function(a,b,c,d,e,f,g,h){if(!a)return F(new u("popup-blocked"));if(g&&!Qe())return this.ka().o(function(p){ve(a);e(p)}),d(),E();this.a||(this.a=Tj(Xj(this)));var m=this;return this.a.then(function(){var p=m.ka().o(function(v){ve(a);e(v);throw v;});d();return p}).then(function(){nh(c);if(!g){var p=Yj(m.u,m.f,m.b,b,c,null,f,m.c,void 0,m.h,h);pe(p,a)}}).o(function(p){"auth/network-request-failed"==p.code&&(m.a=null);throw p;})};
	function Xj(a){a.m||(a.w=a.c?Le(a.c,Rj(a.b)):null,a.m=new Ei(a.f,za(a.h),a.w));return a.m}k.Kb=function(a,b,c,d){this.a||(this.a=Tj(Xj(this)));var e=this;return this.a.then(function(){nh(b);var f=Yj(e.u,e.f,e.b,a,b,oe(),c,e.c,void 0,e.h,d);pe(f)}).o(function(f){"auth/network-request-failed"==f.code&&(e.a=null);throw f;})};k.ka=function(){var a=this;return Uj(this).then(function(){return a.i.nb}).o(function(){a.a=null;throw new u("network-request-failed");})};k.Xb=function(){return!0};
	function Yj(a,b,c,d,e,f,g,h,m,p,v){a=new Qj(a,b,c,d,e);a.l=f;a.g=g;a.i=h;a.b=kb(m||null);a.f=p;return a.ub(v).toString()}function Vj(a){if(!a.i)throw Error("IfcHandler must be initialized!");Lj(a.i,function(b){var c={};if(b&&b.authEvent){var d=!1;b=ph(b.authEvent);for(c=0;c<a.g.length;c++)d=a.g[c](b)||d;c={};c.status=d?"ACK":"ERROR";return E(c)}c.status="ERROR";return E(c)})}
	function Wj(a){var b={type:"webStorageSupport"};return Uj(a).then(function(){return Kj(a.i,b)}).then(function(c){if(c&&c.length&&"undefined"!==typeof c[0].webStorageSupport)return c[0].webStorageSupport;throw Error();})}k.Ca=function(a){this.g.push(a)};k.Qa=function(a){Ua(this.g,function(b){return b==a})};function Zj(a){this.a=a||firebase.INTERNAL.reactNative&&firebase.INTERNAL.reactNative.AsyncStorage;if(!this.a)throw new u("internal-error","The React Native compatibility library was not found.");this.type="asyncStorage"}k=Zj.prototype;k.get=function(a){return E(this.a.getItem(a)).then(function(b){return b&&Te(b)})};k.set=function(a,b){return E(this.a.setItem(a,Re(b)))};k.T=function(a){return E(this.a.removeItem(a))};k.ba=function(){};k.ha=function(){};function ak(a){this.b=a;this.a={};this.f=r(this.c,this)}var bk=[];function ck(){var a=Ge()?self:null;x(bk,function(c){c.b==a&&(b=c)});if(!b){var b=new ak(a);bk.push(b)}return b}
	ak.prototype.c=function(a){var b=a.data.eventType,c=a.data.eventId,d=this.a[b];if(d&&0<d.length){a.ports[0].postMessage({status:"ack",eventId:c,eventType:b,response:null});var e=[];x(d,function(f){e.push(E().then(function(){return f(a.origin,a.data.data)}))});Ec(e).then(function(f){var g=[];x(f,function(h){g.push({fulfilled:h.Mb,value:h.value,reason:h.reason?h.reason.message:void 0})});x(g,function(h){for(var m in h)"undefined"===typeof h[m]&&delete h[m]});a.ports[0].postMessage({status:"done",eventId:c,
	eventType:b,response:g})})}};function dk(a,b,c){jb(a.a)&&a.b.addEventListener("message",a.f);"undefined"===typeof a.a[b]&&(a.a[b]=[]);a.a[b].push(c)};function ek(a){this.a=a}ek.prototype.postMessage=function(a,b){this.a.postMessage(a,b)};function fk(a){this.c=a;this.b=!1;this.a=[]}
	function gk(a,b,c,d){var e,f=c||{},g,h,m,p=null;if(a.b)return F(Error("connection_unavailable"));var v=d?800:50,C="undefined"!==typeof MessageChannel?new MessageChannel:null;return(new D(function(A,Q){C?(e=Math.floor(Math.random()*Math.pow(10,20)).toString(),C.port1.start(),h=setTimeout(function(){Q(Error("unsupported_event"))},v),g=function(xa){xa.data.eventId===e&&("ack"===xa.data.status?(clearTimeout(h),m=setTimeout(function(){Q(Error("timeout"))},3E3)):"done"===xa.data.status?(clearTimeout(m),
	"undefined"!==typeof xa.data.response?A(xa.data.response):Q(Error("unknown_error"))):(clearTimeout(h),clearTimeout(m),Q(Error("invalid_response"))))},p={messageChannel:C,onMessage:g},a.a.push(p),C.port1.addEventListener("message",g),a.c.postMessage({eventType:b,eventId:e,data:f},[C.port2])):Q(Error("connection_unavailable"))})).then(function(A){hk(a,p);return A}).o(function(A){hk(a,p);throw A;})}
	function hk(a,b){if(b){var c=b.messageChannel,d=b.onMessage;c&&(c.port1.removeEventListener("message",d),c.port1.close());Ua(a.a,function(e){return e==b})}}fk.prototype.close=function(){for(;0<this.a.length;)hk(this,this.a[0]);this.b=!0};function ik(){if(!jk())throw new u("web-storage-unsupported");this.c={};this.a=[];this.b=0;this.u=l.indexedDB;this.type="indexedDB";this.g=this.l=this.f=this.i=null;this.s=!1;this.h=null;var a=this;Ge()&&self?(this.l=ck(),dk(this.l,"keyChanged",function(b,c){return kk(a).then(function(d){0<d.length&&x(a.a,function(e){e(d)});return{keyProcessed:Sa(d,c.key)}})}),dk(this.l,"ping",function(){return E(["keyChanged"])})):bf().then(function(b){if(a.h=b)a.g=new fk(new ek(b)),gk(a.g,"ping",null,!0).then(function(c){c[0].fulfilled&&
	Sa(c[0].value,"keyChanged")&&(a.s=!0)}).o(function(){})})}var lk;function mk(a){return new D(function(b,c){var d=a.u.deleteDatabase("firebaseLocalStorageDb");d.onsuccess=function(){b()};d.onerror=function(e){c(Error(e.target.error))}})}
	function nk(a){return new D(function(b,c){var d=a.u.open("firebaseLocalStorageDb",1);d.onerror=function(e){try{e.preventDefault()}catch(f){}c(Error(e.target.error))};d.onupgradeneeded=function(e){e=e.target.result;try{e.createObjectStore("firebaseLocalStorage",{keyPath:"fbase_key"})}catch(f){c(f)}};d.onsuccess=function(e){e=e.target.result;e.objectStoreNames.contains("firebaseLocalStorage")?b(e):mk(a).then(function(){return nk(a)}).then(function(f){b(f)}).o(function(f){c(f)})}})}
	function ok(a){a.m||(a.m=nk(a));return a.m}function jk(){try{return!!l.indexedDB}catch(a){return!1}}function pk(a){return a.objectStore("firebaseLocalStorage")}function qk(a,b){return a.transaction(["firebaseLocalStorage"],b?"readwrite":"readonly")}function rk(a){return new D(function(b,c){a.onsuccess=function(d){d&&d.target?b(d.target.result):b()};a.onerror=function(d){c(d.target.error)}})}k=ik.prototype;
	k.set=function(a,b){var c=!1,d,e=this;return ok(this).then(function(f){d=f;f=pk(qk(d,!0));return rk(f.get(a))}).then(function(f){var g=pk(qk(d,!0));if(f)return f.value=b,rk(g.put(f));e.b++;c=!0;f={};f.fbase_key=a;f.value=b;return rk(g.add(f))}).then(function(){e.c[a]=b;return sk(e,a)}).ma(function(){c&&e.b--})};function sk(a,b){return a.g&&a.h&&af()===a.h?gk(a.g,"keyChanged",{key:b},a.s).then(function(){}).o(function(){}):E()}
	k.get=function(a){return ok(this).then(function(b){return rk(pk(qk(b,!1)).get(a))}).then(function(b){return b&&b.value})};k.T=function(a){var b=!1,c=this;return ok(this).then(function(d){b=!0;c.b++;return rk(pk(qk(d,!0))["delete"](a))}).then(function(){delete c.c[a];return sk(c,a)}).ma(function(){b&&c.b--})};
	function kk(a){return ok(a).then(function(b){var c=pk(qk(b,!1));return c.getAll?rk(c.getAll()):new D(function(d,e){var f=[],g=c.openCursor();g.onsuccess=function(h){(h=h.target.result)?(f.push(h.value),h["continue"]()):d(f)};g.onerror=function(h){e(h.target.error)}})}).then(function(b){var c={},d=[];if(0==a.b){for(d=0;d<b.length;d++)c[b[d].fbase_key]=b[d].value;d=qe(a.c,c);a.c=c}return d})}k.ba=function(a){0==this.a.length&&tk(this);this.a.push(a)};
	k.ha=function(a){Ua(this.a,function(b){return b==a});0==this.a.length&&uk(this)};function tk(a){function b(){a.f=setTimeout(function(){a.i=kk(a).then(function(c){0<c.length&&x(a.a,function(d){d(c)})}).then(function(){b()}).o(function(c){"STOP_EVENT"!=c.message&&b()})},800)}uk(a);b()}function uk(a){a.i&&a.i.cancel("STOP_EVENT");a.f&&(clearTimeout(a.f),a.f=null)};function vk(a){var b=this,c=null;this.a=[];this.type="indexedDB";this.c=a;this.b=E().then(function(){if(jk()){var d=Ne(),e="__sak"+d;lk||(lk=new ik);c=lk;return c.set(e,d).then(function(){return c.get(e)}).then(function(f){if(f!==d)throw Error("indexedDB not supported!");return c.T(e)}).then(function(){return c}).o(function(){return b.c})}return b.c}).then(function(d){b.type=d.type;d.ba(function(e){x(b.a,function(f){f(e)})});return d})}k=vk.prototype;k.get=function(a){return this.b.then(function(b){return b.get(a)})};
	k.set=function(a,b){return this.b.then(function(c){return c.set(a,b)})};k.T=function(a){return this.b.then(function(b){return b.T(a)})};k.ba=function(a){this.a.push(a)};k.ha=function(a){Ua(this.a,function(b){return b==a})};function wk(){this.a={};this.type="inMemory"}k=wk.prototype;k.get=function(a){return E(this.a[a])};k.set=function(a,b){this.a[a]=b;return E()};k.T=function(a){delete this.a[a];return E()};k.ba=function(){};k.ha=function(){};function xk(){if(!yk()){if("Node"==He())throw new u("internal-error","The LocalStorage compatibility library was not found.");throw new u("web-storage-unsupported");}this.a=zk()||firebase.INTERNAL.node.localStorage;this.type="localStorage"}function zk(){try{var a=l.localStorage,b=Ne();a&&(a.setItem(b,"1"),a.removeItem(b));return a}catch(c){return null}}
	function yk(){var a="Node"==He();a=zk()||a&&firebase.INTERNAL.node&&firebase.INTERNAL.node.localStorage;if(!a)return!1;try{return a.setItem("__sak","1"),a.removeItem("__sak"),!0}catch(b){return!1}}k=xk.prototype;k.get=function(a){var b=this;return E().then(function(){var c=b.a.getItem(a);return Te(c)})};k.set=function(a,b){var c=this;return E().then(function(){var d=Re(b);null===d?c.T(a):c.a.setItem(a,d)})};k.T=function(a){var b=this;return E().then(function(){b.a.removeItem(a)})};
	k.ba=function(a){l.window&&jd(l.window,"storage",a)};k.ha=function(a){l.window&&td(l.window,"storage",a)};function Ak(){this.type="nullStorage"}k=Ak.prototype;k.get=function(){return E(null)};k.set=function(){return E()};k.T=function(){return E()};k.ba=function(){};k.ha=function(){};function Bk(){if(!Ck()){if("Node"==He())throw new u("internal-error","The SessionStorage compatibility library was not found.");throw new u("web-storage-unsupported");}this.a=Dk()||firebase.INTERNAL.node.sessionStorage;this.type="sessionStorage"}function Dk(){try{var a=l.sessionStorage,b=Ne();a&&(a.setItem(b,"1"),a.removeItem(b));return a}catch(c){return null}}
	function Ck(){var a="Node"==He();a=Dk()||a&&firebase.INTERNAL.node&&firebase.INTERNAL.node.sessionStorage;if(!a)return!1;try{return a.setItem("__sak","1"),a.removeItem("__sak"),!0}catch(b){return!1}}k=Bk.prototype;k.get=function(a){var b=this;return E().then(function(){var c=b.a.getItem(a);return Te(c)})};k.set=function(a,b){var c=this;return E().then(function(){var d=Re(b);null===d?c.T(a):c.a.setItem(a,d)})};k.T=function(a){var b=this;return E().then(function(){b.a.removeItem(a)})};k.ba=function(){};
	k.ha=function(){};function Ek(){var a={};a.Browser=Fk;a.Node=Gk;a.ReactNative=Hk;a.Worker=Ik;this.a=a[He()]}var Jk,Fk={F:xk,$a:Bk},Gk={F:xk,$a:Bk},Hk={F:Zj,$a:Ak},Ik={F:xk,$a:Ak};/*
	
	 Copyright 2017 Google LLC
	
	 Licensed under the Apache License, Version 2.0 (the "License");
	 you may not use this file except in compliance with the License.
	 You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	 Unless required by applicable law or agreed to in writing, software
	 distributed under the License is distributed on an "AS IS" BASIS,
	 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 See the License for the specific language governing permissions and
	 limitations under the License.
	*/
	var Kk={od:"local",NONE:"none",qd:"session"};function Lk(a){var b=new u("invalid-persistence-type"),c=new u("unsupported-persistence-type");a:{for(d in Kk)if(Kk[d]==a){var d=!0;break a}d=!1}if(!d||"string"!==typeof a)throw b;switch(He()){case "ReactNative":if("session"===a)throw c;break;case "Node":if("none"!==a)throw c;break;case "Worker":if("session"===a||!jk()&&"none"!==a)throw c;break;default:if(!Me()&&"none"!==a)throw c;}}
	function Mk(){var a=!Ue(I())&&Fe()?!0:!1,b=Qe(),c=Me();this.m=a;this.h=b;this.l=c;this.a={};Jk||(Jk=new Ek);a=Jk;try{this.g=!ne()&&$e()||!l.indexedDB?new a.a.F:new vk(Ge()?new wk:new a.a.F)}catch(d){this.g=new wk,this.h=!0}try{this.i=new a.a.$a}catch(d){this.i=new wk}this.u=new wk;this.f=r(this.Vb,this);this.b={}}var Nk;function Ok(){Nk||(Nk=new Mk);return Nk}function Pk(a,b){switch(b){case "session":return a.i;case "none":return a.u;default:return a.g}}
	function Qk(a,b){return"firebase:"+a.name+(b?":"+b:"")}function Rk(a,b,c){var d=Qk(b,c),e=Pk(a,b.F);return a.get(b,c).then(function(f){var g=null;try{g=Te(l.localStorage.getItem(d))}catch(h){}if(g&&!f)return l.localStorage.removeItem(d),a.set(b,g,c);g&&f&&"localStorage"!=e.type&&l.localStorage.removeItem(d)})}k=Mk.prototype;k.get=function(a,b){return Pk(this,a.F).get(Qk(a,b))};function Sk(a,b,c){c=Qk(b,c);"local"==b.F&&(a.b[c]=null);return Pk(a,b.F).T(c)}
	k.set=function(a,b,c){var d=Qk(a,c),e=this,f=Pk(this,a.F);return f.set(d,b).then(function(){return f.get(d)}).then(function(g){"local"==a.F&&(e.b[d]=g)})};k.addListener=function(a,b,c){a=Qk(a,b);this.l&&(this.b[a]=l.localStorage.getItem(a));jb(this.a)&&(Pk(this,"local").ba(this.f),this.h||(ne()||!$e())&&l.indexedDB||!this.l||Tk(this));this.a[a]||(this.a[a]=[]);this.a[a].push(c)};
	k.removeListener=function(a,b,c){a=Qk(a,b);this.a[a]&&(Ua(this.a[a],function(d){return d==c}),0==this.a[a].length&&delete this.a[a]);jb(this.a)&&(Pk(this,"local").ha(this.f),Uk(this))};function Tk(a){Uk(a);a.c=setInterval(function(){for(var b in a.a){var c=l.localStorage.getItem(b),d=a.b[b];c!=d&&(a.b[b]=c,c=new Yc({type:"storage",key:b,target:window,oldValue:d,newValue:c,a:!0}),a.Vb(c))}},1E3)}function Uk(a){a.c&&(clearInterval(a.c),a.c=null)}
	k.Vb=function(a){if(a&&a.f){var b=a.a.key;if(null==b)for(var c in this.a){var d=this.b[c];"undefined"===typeof d&&(d=null);var e=l.localStorage.getItem(c);e!==d&&(this.b[c]=e,this.ib(c))}else if(0==b.indexOf("firebase:")&&this.a[b]){"undefined"!==typeof a.a.a?Pk(this,"local").ha(this.f):Uk(this);if(this.m)if(c=l.localStorage.getItem(b),d=a.a.newValue,d!==c)null!==d?l.localStorage.setItem(b,d):l.localStorage.removeItem(b);else if(this.b[b]===d&&"undefined"===typeof a.a.a)return;var f=this;c=function(){if("undefined"!==
	typeof a.a.a||f.b[b]!==l.localStorage.getItem(b))f.b[b]=l.localStorage.getItem(b),f.ib(b)};Sb&&cc&&10==cc&&l.localStorage.getItem(b)!==a.a.newValue&&a.a.newValue!==a.a.oldValue?setTimeout(c,10):c()}}else x(a,r(this.ib,this))};k.ib=function(a){this.a[a]&&x(this.a[a],function(b){b()})};function Vk(a){this.a=a;this.b=Ok()}var Wk={name:"authEvent",F:"local"};function Xk(a){return a.b.get(Wk,a.a).then(function(b){return ph(b)})};function Yk(){this.a=Ok()};function Zk(){this.b=-1};function $k(a,b){this.b=al;this.f=l.Uint8Array?new Uint8Array(this.b):Array(this.b);this.g=this.c=0;this.a=[];this.i=a;this.h=b;this.l=l.Int32Array?new Int32Array(64):Array(64);void 0===bl&&(l.Int32Array?bl=new Int32Array(cl):bl=cl);this.reset()}var bl;t($k,Zk);for(var al=64,dl=al-1,el=[],fl=0;fl<dl;fl++)el[fl]=0;var gl=Va(128,el);$k.prototype.reset=function(){this.g=this.c=0;this.a=l.Int32Array?new Int32Array(this.h):Wa(this.h)};
	function hl(a){for(var b=a.f,c=a.l,d=0,e=0;e<b.length;)c[d++]=b[e]<<24|b[e+1]<<16|b[e+2]<<8|b[e+3],e=4*d;for(b=16;64>b;b++){e=c[b-15]|0;d=c[b-2]|0;var f=(c[b-16]|0)+((e>>>7|e<<25)^(e>>>18|e<<14)^e>>>3)|0,g=(c[b-7]|0)+((d>>>17|d<<15)^(d>>>19|d<<13)^d>>>10)|0;c[b]=f+g|0}d=a.a[0]|0;e=a.a[1]|0;var h=a.a[2]|0,m=a.a[3]|0,p=a.a[4]|0,v=a.a[5]|0,C=a.a[6]|0;f=a.a[7]|0;for(b=0;64>b;b++){var A=((d>>>2|d<<30)^(d>>>13|d<<19)^(d>>>22|d<<10))+(d&e^d&h^e&h)|0;g=p&v^~p&C;f=f+((p>>>6|p<<26)^(p>>>11|p<<21)^(p>>>25|p<<
	7))|0;g=g+(bl[b]|0)|0;g=f+(g+(c[b]|0)|0)|0;f=C;C=v;v=p;p=m+g|0;m=h;h=e;e=d;d=g+A|0}a.a[0]=a.a[0]+d|0;a.a[1]=a.a[1]+e|0;a.a[2]=a.a[2]+h|0;a.a[3]=a.a[3]+m|0;a.a[4]=a.a[4]+p|0;a.a[5]=a.a[5]+v|0;a.a[6]=a.a[6]+C|0;a.a[7]=a.a[7]+f|0}
	function il(a,b,c){void 0===c&&(c=b.length);var d=0,e=a.c;if("string"===typeof b)for(;d<c;)a.f[e++]=b.charCodeAt(d++),e==a.b&&(hl(a),e=0);else if(ma(b))for(;d<c;){var f=b[d++];if(!("number"==typeof f&&0<=f&&255>=f&&f==(f|0)))throw Error("message must be a byte array");a.f[e++]=f;e==a.b&&(hl(a),e=0)}else throw Error("message must be string or array");a.c=e;a.g+=c}
	var cl=[1116352408,1899447441,3049323471,3921009573,961987163,1508970993,2453635748,2870763221,3624381080,310598401,607225278,1426881987,1925078388,2162078206,2614888103,3248222580,3835390401,4022224774,264347078,604807628,770255983,1249150122,1555081692,1996064986,2554220882,2821834349,2952996808,3210313671,3336571891,3584528711,113926993,338241895,666307205,773529912,1294757372,1396182291,1695183700,1986661051,2177026350,2456956037,2730485921,2820302411,3259730800,3345764771,3516065817,3600352804,
	4094571909,275423344,430227734,506948616,659060556,883997877,958139571,1322822218,1537002063,1747873779,1955562222,2024104815,2227730452,2361852424,2428436474,2756734187,3204031479,3329325298];function jl(){$k.call(this,8,kl)}t(jl,$k);var kl=[1779033703,3144134277,1013904242,2773480762,1359893119,2600822924,528734635,1541459225];function ll(a,b,c,d,e){this.u=a;this.i=b;this.l=c;this.m=d||null;this.s=e||null;this.h=b+":"+c;this.w=new Yk;this.g=new Vk(this.h);this.f=null;this.b=[];this.a=this.c=null}function ml(a){return new u("invalid-cordova-configuration",a)}k=ll.prototype;
	k.ka=function(){return this.Ga?this.Ga:this.Ga=Ce().then(function(){if("function"!==typeof J("universalLinks.subscribe",l))throw ml("cordova-universal-links-plugin-fix is not installed");if("undefined"===typeof J("BuildInfo.packageName",l))throw ml("cordova-plugin-buildinfo is not installed");if("function"!==typeof J("cordova.plugins.browsertab.openUrl",l))throw ml("cordova-plugin-browsertab is not installed");if("function"!==typeof J("cordova.InAppBrowser.open",l))throw ml("cordova-plugin-inappbrowser is not installed");
	},function(){throw new u("cordova-not-ready");})};function nl(){for(var a=20,b=[];0<a;)b.push("1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ".charAt(Math.floor(62*Math.random()))),a--;return b.join("")}function ol(a){var b=new jl;il(b,a);a=[];var c=8*b.g;56>b.c?il(b,gl,56-b.c):il(b,gl,b.b-(b.c-56));for(var d=63;56<=d;d--)b.f[d]=c&255,c/=256;hl(b);for(d=c=0;d<b.i;d++)for(var e=24;0<=e;e-=8)a[c++]=b.a[d]>>e&255;return $f(a)}
	k.Lb=function(a,b){b(new u("operation-not-supported-in-this-environment"));return E()};k.Jb=function(){return F(new u("operation-not-supported-in-this-environment"))};k.Xb=function(){return!1};k.Ub=function(){return!0};k.Qb=function(){return!0};
	k.Kb=function(a,b,c,d){if(this.c)return F(new u("redirect-operation-pending"));var e=this,f=l.document,g=null,h=null,m=null,p=null;return this.c=E().then(function(){nh(b);return pl(e)}).then(function(){return ql(e,a,b,c,d)}).then(function(){return(new D(function(v,C){h=function(){var A=J("cordova.plugins.browsertab.close",l);v();"function"===typeof A&&A();e.a&&"function"===typeof e.a.close&&(e.a.close(),e.a=null);return!1};e.Ca(h);m=function(){g||(g=Bd(2E3).then(function(){C(new u("redirect-cancelled-by-user"))}))};
	p=function(){Xe()&&m()};f.addEventListener("resume",m,!1);I().toLowerCase().match(/android/)||f.addEventListener("visibilitychange",p,!1)})).o(function(v){return rl(e).then(function(){throw v;})})}).ma(function(){m&&f.removeEventListener("resume",m,!1);p&&f.removeEventListener("visibilitychange",p,!1);g&&g.cancel();h&&e.Qa(h);e.c=null})};
	function ql(a,b,c,d,e){var f=nl(),g=new oh(b,d,null,f,new u("no-auth-event"),null,e),h=J("BuildInfo.packageName",l);if("string"!==typeof h)throw new u("invalid-cordova-configuration");var m=J("BuildInfo.displayName",l),p={};if(I().toLowerCase().match(/iphone|ipad|ipod/))p.ibi=h;else if(I().toLowerCase().match(/android/))p.apn=h;else return F(new u("operation-not-supported-in-this-environment"));m&&(p.appDisplayName=m);f=ol(f);p.sessionId=f;var v=Yj(a.u,a.i,a.l,b,c,null,d,a.m,p,a.s,e);return a.ka().then(function(){var C=
	a.h;return a.w.a.set(Wk,g.v(),C)}).then(function(){var C=J("cordova.plugins.browsertab.isAvailable",l);if("function"!==typeof C)throw new u("invalid-cordova-configuration");var A=null;C(function(Q){if(Q){A=J("cordova.plugins.browsertab.openUrl",l);if("function"!==typeof A)throw new u("invalid-cordova-configuration");A(v)}else{A=J("cordova.InAppBrowser.open",l);if("function"!==typeof A)throw new u("invalid-cordova-configuration");Q=I();a.a=A(v,Q.match(/(iPad|iPhone|iPod).*OS 7_\d/i)||Q.match(/(iPad|iPhone|iPod).*OS 8_\d/i)?
	"_blank":"_system","location=yes")}})})}function sl(a,b){for(var c=0;c<a.b.length;c++)try{a.b[c](b)}catch(d){}}function pl(a){a.f||(a.f=a.ka().then(function(){return new D(function(b){function c(d){b(d);a.Qa(c);return!1}a.Ca(c);tl(a)})}));return a.f}function rl(a){var b=null;return Xk(a.g).then(function(c){b=c;c=a.g;return Sk(c.b,Wk,c.a)}).then(function(){return b})}
	function tl(a){function b(g){d=!0;e&&e.cancel();rl(a).then(function(h){var m=c;if(h&&g&&g.url){var p=null;m=ug(g.url);-1!=m.indexOf("/__/auth/callback")&&(p=Zd(m),p=Te(Yd(p,"firebaseError")||null),p=(p="object"===typeof p?wa(p):null)?new oh(h.c,h.b,null,null,p,null,h.S()):new oh(h.c,h.b,m,h.f,null,null,h.S()));m=p||c}sl(a,m)})}var c=new oh("unknown",null,null,null,new u("no-auth-event")),d=!1,e=Bd(500).then(function(){return rl(a).then(function(){d||sl(a,c)})}),f=l.handleOpenURL;l.handleOpenURL=function(g){0==
	g.toLowerCase().indexOf(J("BuildInfo.packageName",l).toLowerCase()+"://")&&b({url:g});if("function"===typeof f)try{f(g)}catch(h){console.error(h)}};rh||(rh=new qh);sh(b)}k.Ca=function(a){this.b.push(a);pl(this).o(function(b){"auth/invalid-cordova-configuration"===b.code&&(b=new oh("unknown",null,null,null,new u("no-auth-event")),a(b))})};k.Qa=function(a){Ua(this.b,function(b){return b==a})};function ul(a){this.a=a;this.b=Ok()}var vl={name:"pendingRedirect",F:"session"};function wl(a){return a.b.set(vl,"pending",a.a)}function xl(a){return Sk(a.b,vl,a.a)}function yl(a){return a.b.get(vl,a.a).then(function(b){return"pending"==b})};function zl(a,b,c){this.i={};this.w=0;this.D=a;this.u=b;this.m=c;this.h=[];this.f=!1;this.l=r(this.s,this);this.b=new Al;this.B=new Bl;this.g=new ul(this.u+":"+this.m);this.c={};this.c.unknown=this.b;this.c.signInViaRedirect=this.b;this.c.linkViaRedirect=this.b;this.c.reauthViaRedirect=this.b;this.c.signInViaPopup=this.B;this.c.linkViaPopup=this.B;this.c.reauthViaPopup=this.B;this.a=Cl(this.D,this.u,this.m,Aa)}
	function Cl(a,b,c,d){var e=firebase.SDK_VERSION||null;return De()?new ll(a,b,c,e,d):new Sj(a,b,c,e,d)}zl.prototype.reset=function(){this.f=!1;this.a.Qa(this.l);this.a=Cl(this.D,this.u,this.m);this.i={}};function Dl(a){a.f||(a.f=!0,a.a.Ca(a.l));var b=a.a;return a.a.ka().o(function(c){a.a==b&&a.reset();throw c;})}function El(a){a.a.Ub()&&Dl(a).o(function(b){var c=new oh("unknown",null,null,null,new u("operation-not-supported-in-this-environment"));Fl(b)&&a.s(c)});a.a.Qb()||Gl(a.b)}
	function Hl(a,b){Sa(a.h,b)||a.h.push(b);a.f||yl(a.g).then(function(c){c?xl(a.g).then(function(){Dl(a).o(function(d){var e=new oh("unknown",null,null,null,new u("operation-not-supported-in-this-environment"));Fl(d)&&a.s(e)})}):El(a)}).o(function(){El(a)})}function Il(a,b){Ua(a.h,function(c){return c==b})}
	zl.prototype.s=function(a){if(!a)throw new u("invalid-auth-event");6E5<=ta()-this.w&&(this.i={},this.w=0);if(a&&a.getUid()&&this.i.hasOwnProperty(a.getUid()))return!1;for(var b=!1,c=0;c<this.h.length;c++){var d=this.h[c];if(d.Cb(a.c,a.b)){if(b=this.c[a.c])b.h(a,d),a&&(a.f||a.b)&&(this.i[a.getUid()]=!0,this.w=ta());b=!0;break}}Gl(this.b);return b};var Jl=new We(2E3,1E4),Kl=new We(3E4,6E4);zl.prototype.pa=function(){return this.b.pa()};
	function Ll(a,b,c,d,e,f,g){return a.a.Jb(b,c,d,function(){a.f||(a.f=!0,a.a.Ca(a.l))},function(){a.reset()},e,f,g)}function Fl(a){return a&&"auth/cordova-not-ready"==a.code?!0:!1}
	function Ml(a,b,c,d,e){var f;return wl(a.g).then(function(){return a.a.Kb(b,c,d,e).o(function(g){if(Fl(g))throw new u("operation-not-supported-in-this-environment");f=g;return xl(a.g).then(function(){throw f;})}).then(function(){return a.a.Xb()?new D(function(){}):xl(a.g).then(function(){return a.pa()}).then(function(){}).o(function(){})})})}function Nl(a,b,c,d,e){return a.a.Lb(d,function(f){b.la(c,null,f,e)},Jl.get())}var Ol={};
	function Pl(a,b,c){var d=b+":"+c;Ol[d]||(Ol[d]=new zl(a,b,c));return Ol[d]}function Al(){this.b=null;this.f=[];this.c=[];this.a=null;this.i=this.g=!1}Al.prototype.reset=function(){this.b=null;this.a&&(this.a.cancel(),this.a=null)};
	Al.prototype.h=function(a,b){if(a){this.reset();this.g=!0;var c=a.c,d=a.b,e=a.a&&"auth/web-storage-unsupported"==a.a.code,f=a.a&&"auth/operation-not-supported-in-this-environment"==a.a.code;this.i=!(!e&&!f);"unknown"!=c||e||f?a.a?(Ql(this,!0,null,a.a),E()):b.Da(c,d)?Rl(this,a,b):F(new u("invalid-auth-event")):(Ql(this,!1,null,null),E())}else F(new u("invalid-auth-event"))};function Gl(a){a.g||(a.g=!0,Ql(a,!1,null,null))}function Sl(a){a.g&&!a.i&&Ql(a,!1,null,null)}
	function Rl(a,b,c){c=c.Da(b.c,b.b);var d=b.g,e=b.f,f=b.i,g=b.S(),h=!!b.c.match(/Redirect$/);c(d,e,g,f).then(function(m){Ql(a,h,m,null)}).o(function(m){Ql(a,h,null,m)})}function Tl(a,b){a.b=function(){return F(b)};if(a.c.length)for(var c=0;c<a.c.length;c++)a.c[c](b)}function Ul(a,b){a.b=function(){return E(b)};if(a.f.length)for(var c=0;c<a.f.length;c++)a.f[c](b)}function Ql(a,b,c,d){b?d?Tl(a,d):Ul(a,c):Ul(a,{user:null});a.f=[];a.c=[]}
	Al.prototype.pa=function(){var a=this;return new D(function(b,c){a.b?a.b().then(b,c):(a.f.push(b),a.c.push(c),Vl(a))})};function Vl(a){var b=new u("timeout");a.a&&a.a.cancel();a.a=Bd(Kl.get()).then(function(){a.b||(a.g=!0,Ql(a,!0,null,b))})}function Bl(){}Bl.prototype.h=function(a,b){if(a){var c=a.c,d=a.b;a.a?(b.la(a.c,null,a.a,a.b),E()):b.Da(c,d)?Wl(a,b):F(new u("invalid-auth-event"))}else F(new u("invalid-auth-event"))};
	function Wl(a,b){var c=a.b,d=a.c;b.Da(d,c)(a.g,a.f,a.S(),a.i).then(function(e){b.la(d,e,null,c)}).o(function(e){b.la(d,null,e,c)})};function Xl(){this.Bb=!1;Object.defineProperty(this,"appVerificationDisabled",{get:function(){return this.Bb},set:function(a){this.Bb=a},enumerable:!1})};function Yl(a,b){this.a=b;K(this,"verificationId",a)}Yl.prototype.confirm=function(a){a=lh(this.verificationId,a);return this.a(a)};function Zl(a,b,c,d){return(new hh(a)).cb(b,c).then(function(e){return new Yl(e,d)})};function $l(a){var b=fg(a);if(!(b&&b.exp&&b.auth_time&&b.iat))throw new u("internal-error","An internal error occurred. The token obtained by Firebase appears to be malformed. Please retry the operation.");L(this,{token:a,expirationTime:Ze(1E3*b.exp),authTime:Ze(1E3*b.auth_time),issuedAtTime:Ze(1E3*b.iat),signInProvider:b.firebase&&b.firebase.sign_in_provider?b.firebase.sign_in_provider:null,signInSecondFactor:b.firebase&&b.firebase.sign_in_second_factor?b.firebase.sign_in_second_factor:null,claims:b})}
	;function am(a,b,c){var d=b&&b[bm];if(!d)throw new u("argument-error","Internal assert: Invalid MultiFactorResolver");this.a=a;this.f=kb(b);this.g=c;this.c=new vg(null,d);this.b=[];var e=this;x(b[cm]||[],function(f){(f=qf(f))&&e.b.push(f)});K(this,"auth",this.a);K(this,"session",this.c);K(this,"hints",this.b)}var cm="mfaInfo",bm="mfaPendingCredential";am.prototype.Pc=function(a){var b=this;return a.ob(this.a.b,this.c).then(function(c){var d=kb(b.f);delete d[cm];delete d[bm];B(d,c);return b.g(d)})};function dm(a,b,c,d){u.call(this,"multi-factor-auth-required",d,b);this.b=new am(a,b,c);K(this,"resolver",this.b)}t(dm,u);function em(a,b,c){if(a&&q(a.serverResponse)&&"auth/multi-factor-auth-required"===a.code)try{return new dm(b,a.serverResponse,c,a.message)}catch(d){}return null};function fm(){}fm.prototype.ob=function(a,b,c){return b.type==wg?gm(this,a,b,c):hm(this,a,b)};function gm(a,b,c,d){return c.Fa().then(function(e){e={idToken:e};"undefined"!==typeof d&&(e.displayName=d);B(e,{phoneVerificationInfo:dh(a.a)});return N(b,Aj,e)})}function hm(a,b,c){return c.Fa().then(function(d){d={mfaPendingCredential:d};B(d,{phoneVerificationInfo:dh(a.a)});return N(b,Bj,d)})}function im(a){K(this,"factorId",a.ea);this.a=a}t(im,fm);
	function jm(a){im.call(this,a);if(this.a.ea!=hh.PROVIDER_ID)throw new u("argument-error","firebase.auth.PhoneMultiFactorAssertion requires a valid firebase.auth.PhoneAuthCredential");}t(jm,im);function km(a,b){Xc.call(this,a);for(var c in b)this[c]=b[c]}t(km,Xc);function lm(a,b){this.a=a;this.b=[];this.c=r(this.wc,this);jd(this.a,"userReloaded",this.c);var c=[];b&&b.multiFactor&&b.multiFactor.enrolledFactors&&x(b.multiFactor.enrolledFactors,function(d){var e=null,f={};if(d){d.uid&&(f[nf]=d.uid);d.displayName&&(f[of]=d.displayName);d.enrollmentTime&&(f[pf]=(new Date(d.enrollmentTime)).toISOString());d.phoneNumber&&(f[mf]=d.phoneNumber);try{e=new rf(f)}catch(g){}d=e}else d=null;d&&c.push(d)});mm(this,c)}
	function nm(a){var b=[];x(a.mfaInfo||[],function(c){(c=qf(c))&&b.push(c)});return b}k=lm.prototype;k.wc=function(a){mm(this,nm(a.ed))};function mm(a,b){a.b=b;K(a,"enrolledFactors",b)}k.Ob=function(){return this.a.I().then(function(a){return new vg(a,null)})};k.dc=function(a,b){var c=this,d=this.a.a;return this.Ob().then(function(e){return a.ob(d,e,b)}).then(function(e){om(c.a,e);return c.a.reload()})};
	k.$c=function(a){var b=this,c="string"===typeof a?a:a.uid,d=this.a.a;return this.a.I().then(function(e){return N(d,Fj,{idToken:e,mfaEnrollmentId:c})}).then(function(e){var f=Na(b.b,function(g){return g.uid!=c});mm(b,f);om(b.a,e);return b.a.reload().o(function(g){if("auth/user-token-expired"!=g.code)throw g;})})};k.v=function(){return{multiFactor:{enrolledFactors:Oa(this.b,function(a){return a.v()})}}};function pm(a,b,c){this.h=a;this.i=b;this.g=c;this.c=3E4;this.f=96E4;this.b=null;this.a=this.c;if(this.f<this.c)throw Error("Proactive refresh lower bound greater than upper bound!");}pm.prototype.start=function(){this.a=this.c;qm(this,!0)};function rm(a,b){if(b)return a.a=a.c,a.g();b=a.a;a.a*=2;a.a>a.f&&(a.a=a.f);return b}function qm(a,b){a.stop();a.b=Bd(rm(a,b)).then(function(){return Ye()}).then(function(){return a.h()}).then(function(){qm(a,!0)}).o(function(c){a.i(c)&&qm(a,!1)})}
	pm.prototype.stop=function(){this.b&&(this.b.cancel(),this.b=null)};function sm(a){this.c=a;this.b=this.a=null}sm.prototype.v=function(){return{apiKey:this.c.c,refreshToken:this.a,accessToken:this.b&&this.b.toString(),expirationTime:tm(this)}};function tm(a){return a.b&&1E3*a.b.c||0}function um(a,b){var c=b.refreshToken;a.b=gg(b[Ag]||"");a.a=c}function vm(a,b){a.b=b.b;a.a=b.a}
	function wm(a,b){return Qi(a.c,b).then(function(c){a.b=gg(c.access_token);a.a=c.refresh_token;return{accessToken:a.b.toString(),refreshToken:a.a}}).o(function(c){"auth/user-token-expired"==c.code&&(a.a=null);throw c;})}sm.prototype.getToken=function(a){a=!!a;return this.b&&!this.a?F(new u("user-token-expired")):a||!this.b||ta()>tm(this)-3E4?this.a?wm(this,{grant_type:"refresh_token",refresh_token:this.a}):E(null):E({accessToken:this.b.toString(),refreshToken:this.a})};function xm(a,b){this.a=a||null;this.b=b||null;L(this,{lastSignInTime:Ze(b||null),creationTime:Ze(a||null)})}function ym(a){return new xm(a.a,a.b)}xm.prototype.v=function(){return{lastLoginAt:this.b,createdAt:this.a}};function zm(a,b,c,d,e,f){L(this,{uid:a,displayName:d||null,photoURL:e||null,email:c||null,phoneNumber:f||null,providerId:b})}
	function P(a,b,c){this.N=[];this.l=a.apiKey;this.m=a.appName;this.s=a.authDomain||null;a=firebase.SDK_VERSION?Le(firebase.SDK_VERSION):null;this.a=new Ei(this.l,za(Aa),a);this.b=new sm(this.a);Am(this,b[Ag]);um(this.b,b);K(this,"refreshToken",this.b.a);Bm(this,c||{});G.call(this);this.P=!1;this.s&&Oe()&&(this.i=Pl(this.s,this.l,this.m));this.R=[];this.h=null;this.B=Cm(this);this.Z=r(this.Ma,this);var d=this;this.oa=null;this.za=function(e){d.va(e.g)};this.aa=null;this.W=[];this.ya=function(e){Dm(d,
	e.c)};this.$=null;this.O=new lm(this,c);K(this,"multiFactor",this.O)}t(P,G);P.prototype.va=function(a){this.oa=a;Ki(this.a,a)};P.prototype.ja=function(){return this.oa};function Em(a,b){a.aa&&td(a.aa,"languageCodeChanged",a.za);(a.aa=b)&&jd(b,"languageCodeChanged",a.za)}function Dm(a,b){a.W=b;Li(a.a,firebase.SDK_VERSION?Le(firebase.SDK_VERSION,a.W):null)}P.prototype.Ea=function(){return Wa(this.W)};function Fm(a,b){a.$&&td(a.$,"frameworkChanged",a.ya);(a.$=b)&&jd(b,"frameworkChanged",a.ya)}
	P.prototype.Ma=function(){this.B.b&&(this.B.stop(),this.B.start())};function Gm(a){try{return firebase.app(a.m).auth()}catch(b){throw new u("internal-error","No firebase.auth.Auth instance is available for the Firebase App '"+a.m+"'!");}}function Cm(a){return new pm(function(){return a.I(!0)},function(b){return b&&"auth/network-request-failed"==b.code?!0:!1},function(){var b=tm(a.b)-ta()-3E5;return 0<b?b:0})}
	function Hm(a){a.D||a.B.b||(a.B.start(),td(a,"tokenChanged",a.Z),jd(a,"tokenChanged",a.Z))}function Im(a){td(a,"tokenChanged",a.Z);a.B.stop()}function Am(a,b){a.xa=b;K(a,"_lat",b)}function Jm(a,b){Ua(a.R,function(c){return c==b})}function Km(a){for(var b=[],c=0;c<a.R.length;c++)b.push(a.R[c](a));return Ec(b).then(function(){return a})}function Lm(a){a.i&&!a.P&&(a.P=!0,Hl(a.i,a))}
	function Bm(a,b){L(a,{uid:b.uid,displayName:b.displayName||null,photoURL:b.photoURL||null,email:b.email||null,emailVerified:b.emailVerified||!1,phoneNumber:b.phoneNumber||null,isAnonymous:b.isAnonymous||!1,tenantId:b.tenantId||null,metadata:new xm(b.createdAt,b.lastLoginAt),providerData:[]});a.a.b=a.tenantId}K(P.prototype,"providerId","firebase");function Mm(){}function Nm(a){return E().then(function(){if(a.D)throw new u("app-deleted");})}
	function Om(a){return Oa(a.providerData,function(b){return b.providerId})}function Pm(a,b){b&&(Qm(a,b.providerId),a.providerData.push(b))}function Qm(a,b){Ua(a.providerData,function(c){return c.providerId==b})}function Rm(a,b,c){("uid"!=b||c)&&a.hasOwnProperty(b)&&K(a,b,c)}
	function Sm(a,b){a!=b&&(L(a,{uid:b.uid,displayName:b.displayName,photoURL:b.photoURL,email:b.email,emailVerified:b.emailVerified,phoneNumber:b.phoneNumber,isAnonymous:b.isAnonymous,tenantId:b.tenantId,providerData:[]}),b.metadata?K(a,"metadata",ym(b.metadata)):K(a,"metadata",new xm),x(b.providerData,function(c){Pm(a,c)}),vm(a.b,b.b),K(a,"refreshToken",a.b.a),mm(a.O,b.O.b))}k=P.prototype;k.reload=function(){var a=this;return R(this,Nm(this).then(function(){return Tm(a).then(function(){return Km(a)}).then(Mm)}))};
	function Tm(a){return a.I().then(function(b){var c=a.isAnonymous;return Um(a,b).then(function(){c||Rm(a,"isAnonymous",!1);return b})})}k.mc=function(a){return this.I(a).then(function(b){return new $l(b)})};k.I=function(a){var b=this;return R(this,Nm(this).then(function(){return b.b.getToken(a)}).then(function(c){if(!c)throw new u("internal-error");c.accessToken!=b.xa&&(Am(b,c.accessToken),b.dispatchEvent(new km("tokenChanged")));Rm(b,"refreshToken",c.refreshToken);return c.accessToken}))};
	function om(a,b){b[Ag]&&a.xa!=b[Ag]&&(um(a.b,b),a.dispatchEvent(new km("tokenChanged")),Am(a,b[Ag]),Rm(a,"refreshToken",a.b.a))}function Um(a,b){return N(a.a,Cj,{idToken:b}).then(r(a.Ic,a))}
	k.Ic=function(a){a=a.users;if(!a||!a.length)throw new u("internal-error");a=a[0];Bm(this,{uid:a.localId,displayName:a.displayName,photoURL:a.photoUrl,email:a.email,emailVerified:!!a.emailVerified,phoneNumber:a.phoneNumber,lastLoginAt:a.lastLoginAt,createdAt:a.createdAt,tenantId:a.tenantId});for(var b=Vm(a),c=0;c<b.length;c++)Pm(this,b[c]);Rm(this,"isAnonymous",!(this.email&&a.passwordHash)&&!(this.providerData&&this.providerData.length));this.dispatchEvent(new km("userReloaded",{ed:a}))};
	function Vm(a){return(a=a.providerUserInfo)&&a.length?Oa(a,function(b){return new zm(b.rawId,b.providerId,b.email,b.displayName,b.photoUrl,b.phoneNumber)}):[]}k.Jc=function(a){df("firebase.User.prototype.reauthenticateAndRetrieveDataWithCredential is deprecated. Please use firebase.User.prototype.reauthenticateWithCredential instead.");return this.pb(a)};
	k.pb=function(a){var b=this,c=null;return R(this,a.c(this.a,this.uid).then(function(d){om(b,d);c=Wm(b,d,"reauthenticate");b.h=null;return b.reload()}).then(function(){return c}),!0)};function Xm(a,b){return Tm(a).then(function(){if(Sa(Om(a),b))return Km(a).then(function(){throw new u("provider-already-linked");})})}k.Ac=function(a){df("firebase.User.prototype.linkAndRetrieveDataWithCredential is deprecated. Please use firebase.User.prototype.linkWithCredential instead.");return this.mb(a)};
	k.mb=function(a){var b=this,c=null;return R(this,Xm(this,a.providerId).then(function(){return b.I()}).then(function(d){return a.b(b.a,d)}).then(function(d){c=Wm(b,d,"link");return Ym(b,d)}).then(function(){return c}))};k.Bc=function(a,b){var c=this;return R(this,Xm(this,"phone").then(function(){return Zl(Gm(c),a,b,r(c.mb,c))}))};k.Kc=function(a,b){var c=this;return R(this,E().then(function(){return Zl(Gm(c),a,b,r(c.pb,c))}),!0)};
	function Wm(a,b,c){var d=mh(b);b=lg(b);return gf({user:a,credential:d,additionalUserInfo:b,operationType:c})}function Ym(a,b){om(a,b);return a.reload().then(function(){return a})}k.xb=function(a){var b=this;return R(this,this.I().then(function(c){return b.a.xb(c,a)}).then(function(c){om(b,c);return b.reload()}))};k.cd=function(a){var b=this;return R(this,this.I().then(function(c){return a.b(b.a,c)}).then(function(c){om(b,c);return b.reload()}))};
	k.yb=function(a){var b=this;return R(this,this.I().then(function(c){return b.a.yb(c,a)}).then(function(c){om(b,c);return b.reload()}))};
	k.zb=function(a){if(void 0===a.displayName&&void 0===a.photoURL)return Nm(this);var b=this;return R(this,this.I().then(function(c){return b.a.zb(c,{displayName:a.displayName,photoUrl:a.photoURL})}).then(function(c){om(b,c);Rm(b,"displayName",c.displayName||null);Rm(b,"photoURL",c.photoUrl||null);x(b.providerData,function(d){"password"===d.providerId&&(K(d,"displayName",b.displayName),K(d,"photoURL",b.photoURL))});return Km(b)}).then(Mm))};
	k.ad=function(a){var b=this;return R(this,Tm(this).then(function(c){return Sa(Om(b),a)?lj(b.a,c,[a]).then(function(d){var e={};x(d.providerUserInfo||[],function(f){e[f.providerId]=!0});x(Om(b),function(f){e[f]||Qm(b,f)});e[hh.PROVIDER_ID]||K(b,"phoneNumber",null);return Km(b)}):Km(b).then(function(){throw new u("no-such-provider");})}))};
	k.delete=function(){var a=this;return R(this,this.I().then(function(b){return N(a.a,zj,{idToken:b})}).then(function(){a.dispatchEvent(new km("userDeleted"))})).then(function(){for(var b=0;b<a.N.length;b++)a.N[b].cancel("app-deleted");Em(a,null);Fm(a,null);a.N=[];a.D=!0;Im(a);K(a,"refreshToken",null);a.i&&Il(a.i,a)})};
	k.Cb=function(a,b){return"linkViaPopup"==a&&(this.g||null)==b&&this.f||"reauthViaPopup"==a&&(this.g||null)==b&&this.f||"linkViaRedirect"==a&&(this.fa||null)==b||"reauthViaRedirect"==a&&(this.fa||null)==b?!0:!1};k.la=function(a,b,c,d){"linkViaPopup"!=a&&"reauthViaPopup"!=a||d!=(this.g||null)||(c&&this.w?this.w(c):b&&!c&&this.f&&this.f(b),this.c&&(this.c.cancel(),this.c=null),delete this.f,delete this.w)};
	k.Da=function(a,b){return"linkViaPopup"==a&&b==(this.g||null)?r(this.Hb,this):"reauthViaPopup"==a&&b==(this.g||null)?r(this.Ib,this):"linkViaRedirect"==a&&(this.fa||null)==b?r(this.Hb,this):"reauthViaRedirect"==a&&(this.fa||null)==b?r(this.Ib,this):null};k.Cc=function(a){var b=this;return Zm(this,"linkViaPopup",a,function(){return Xm(b,a.providerId).then(function(){return Km(b)})},!1)};k.Lc=function(a){return Zm(this,"reauthViaPopup",a,function(){return E()},!0)};
	function Zm(a,b,c,d,e){if(!Oe())return F(new u("operation-not-supported-in-this-environment"));if(a.h&&!e)return F(a.h);var f=kg(c.providerId),g=Ne(a.uid+":::"),h=null;(!Qe()||Fe())&&a.s&&c.isOAuthProvider&&(h=Yj(a.s,a.l,a.m,b,c,null,g,firebase.SDK_VERSION||null,null,null,a.tenantId));var m=we(h,f&&f.ta,f&&f.sa);d=d().then(function(){$m(a);if(!e)return a.I().then(function(){})}).then(function(){return Ll(a.i,m,b,c,g,!!h,a.tenantId)}).then(function(){return new D(function(p,v){a.la(b,null,new u("cancelled-popup-request"),
	a.g||null);a.f=p;a.w=v;a.g=g;a.c=Nl(a.i,a,b,m,g)})}).then(function(p){m&&ve(m);return p?gf(p):null}).o(function(p){m&&ve(m);throw p;});return R(a,d,e)}k.Dc=function(a){var b=this;return an(this,"linkViaRedirect",a,function(){return Xm(b,a.providerId)},!1)};k.Mc=function(a){return an(this,"reauthViaRedirect",a,function(){return E()},!0)};
	function an(a,b,c,d,e){if(!Oe())return F(new u("operation-not-supported-in-this-environment"));if(a.h&&!e)return F(a.h);var f=null,g=Ne(a.uid+":::");d=d().then(function(){$m(a);if(!e)return a.I().then(function(){})}).then(function(){a.fa=g;return Km(a)}).then(function(h){a.ga&&(h=a.ga,h=h.b.set(bn,a.v(),h.a));return h}).then(function(){return Ml(a.i,b,c,g,a.tenantId)}).o(function(h){f=h;if(a.ga)return cn(a.ga);throw f;}).then(function(){if(f)throw f;});return R(a,d,e)}
	function $m(a){if(!a.i||!a.P){if(a.i&&!a.P)throw new u("internal-error");throw new u("auth-domain-config-required");}}k.Hb=function(a,b,c,d){var e=this;this.c&&(this.c.cancel(),this.c=null);var f=null;c=this.I().then(function(g){return Eg(e.a,{requestUri:a,postBody:d,sessionId:b,idToken:g})}).then(function(g){f=Wm(e,g,"link");return Ym(e,g)}).then(function(){return f});return R(this,c)};
	k.Ib=function(a,b,c,d){var e=this;this.c&&(this.c.cancel(),this.c=null);var f=null,g=E().then(function(){return zg(Fg(e.a,{requestUri:a,sessionId:b,postBody:d,tenantId:c}),e.uid)}).then(function(h){f=Wm(e,h,"reauthenticate");om(e,h);e.h=null;return e.reload()}).then(function(){return f});return R(this,g,!0)};
	k.qb=function(a){var b=this,c=null;return R(this,this.I().then(function(d){c=d;return"undefined"===typeof a||jb(a)?{}:Zf(new Pf(a))}).then(function(d){return b.a.qb(c,d)}).then(function(d){if(b.email!=d)return b.reload()}).then(function(){}))};k.Ab=function(a,b){var c=this,d=null;return R(this,this.I().then(function(e){d=e;return"undefined"===typeof b||jb(b)?{}:Zf(new Pf(b))}).then(function(e){return c.a.Ab(d,a,e)}).then(function(e){if(c.email!=e)return c.reload()}).then(function(){}))};
	function R(a,b,c){var d=dn(a,b,c);a.N.push(d);d.ma(function(){Ta(a.N,d)});return d.o(function(e){var f=null;e&&"auth/multi-factor-auth-required"===e.code&&(f=em(e.v(),Gm(a),r(a.hc,a)));throw f||e;})}k.hc=function(a){var b=null,c=this;a=zg(E(a),c.uid).then(function(d){b=Wm(c,d,"reauthenticate");om(c,d);c.h=null;return c.reload()}).then(function(){return b});return R(this,a,!0)};
	function dn(a,b,c){return a.h&&!c?(b.cancel(),F(a.h)):b.o(function(d){!d||"auth/user-disabled"!=d.code&&"auth/user-token-expired"!=d.code||(a.h||a.dispatchEvent(new km("userInvalidated")),a.h=d);throw d;})}k.toJSON=function(){return this.v()};
	k.v=function(){var a={uid:this.uid,displayName:this.displayName,photoURL:this.photoURL,email:this.email,emailVerified:this.emailVerified,phoneNumber:this.phoneNumber,isAnonymous:this.isAnonymous,tenantId:this.tenantId,providerData:[],apiKey:this.l,appName:this.m,authDomain:this.s,stsTokenManager:this.b.v(),redirectEventId:this.fa||null};this.metadata&&B(a,this.metadata.v());x(this.providerData,function(b){a.providerData.push(hf(b))});B(a,this.O.v());return a};
	function en(a){if(!a.apiKey)return null;var b={apiKey:a.apiKey,authDomain:a.authDomain,appName:a.appName},c={};if(a.stsTokenManager&&a.stsTokenManager.accessToken)c[Ag]=a.stsTokenManager.accessToken,c.refreshToken=a.stsTokenManager.refreshToken||null;else return null;var d=new P(b,c,a);a.providerData&&x(a.providerData,function(e){e&&Pm(d,gf(e))});a.redirectEventId&&(d.fa=a.redirectEventId);return d}
	function fn(a,b,c,d){var e=new P(a,b);c&&(e.ga=c);d&&Dm(e,d);return e.reload().then(function(){return e})}function gn(a,b,c,d){var e=a.b,f={};f[Ag]=e.b&&e.b.toString();f.refreshToken=e.a;b=new P(b||{apiKey:a.l,authDomain:a.s,appName:a.m},f);c&&(b.ga=c);d&&Dm(b,d);Sm(b,a);return b};function hn(a){this.a=a;this.b=Ok()}var bn={name:"redirectUser",F:"session"};function cn(a){return Sk(a.b,bn,a.a)}function jn(a,b){return a.b.get(bn,a.a).then(function(c){c&&b&&(c.authDomain=b);return en(c||{})})};function kn(a){this.a=a;this.b=Ok();this.c=null;this.f=ln(this);this.b.addListener(mn("local"),this.a,r(this.g,this))}kn.prototype.g=function(){var a=this,b=mn("local");nn(this,function(){return E().then(function(){return a.c&&"local"!=a.c.F?a.b.get(b,a.a):null}).then(function(c){if(c)return on(a,"local").then(function(){a.c=b})})})};function on(a,b){var c=[],d;for(d in Kk)Kk[d]!==b&&c.push(Sk(a.b,mn(Kk[d]),a.a));c.push(Sk(a.b,pn,a.a));return Dc(c)}
	function ln(a){var b=mn("local"),c=mn("session"),d=mn("none");return Rk(a.b,b,a.a).then(function(){return a.b.get(c,a.a)}).then(function(e){return e?c:a.b.get(d,a.a).then(function(f){return f?d:a.b.get(b,a.a).then(function(g){return g?b:a.b.get(pn,a.a).then(function(h){return h?mn(h):b})})})}).then(function(e){a.c=e;return on(a,e.F)}).o(function(){a.c||(a.c=b)})}var pn={name:"persistence",F:"session"};function mn(a){return{name:"authUser",F:a}}
	kn.prototype.tb=function(a){var b=null,c=this;Lk(a);return nn(this,function(){return a!=c.c.F?c.b.get(c.c,c.a).then(function(d){b=d;return on(c,a)}).then(function(){c.c=mn(a);if(b)return c.b.set(c.c,b,c.a)}):E()})};function qn(a){return nn(a,function(){return a.b.set(pn,a.c.F,a.a)})}function rn(a,b){return nn(a,function(){return a.b.set(a.c,b.v(),a.a)})}function sn(a){return nn(a,function(){return Sk(a.b,a.c,a.a)})}
	function tn(a,b){return nn(a,function(){return a.b.get(a.c,a.a).then(function(c){c&&b&&(c.authDomain=b);return en(c||{})})})}function nn(a,b){a.f=a.f.then(b,b);return a.f};function un(a){this.l=!1;K(this,"settings",new Xl);K(this,"app",a);if(S(this).options&&S(this).options.apiKey)a=firebase.SDK_VERSION?Le(firebase.SDK_VERSION):null,this.b=new Ei(S(this).options&&S(this).options.apiKey,za(Aa),a);else throw new u("invalid-api-key");this.P=[];this.m=[];this.O=[];this.$b=firebase.INTERNAL.createSubscribe(r(this.xc,this));this.W=void 0;this.ac=firebase.INTERNAL.createSubscribe(r(this.yc,this));vn(this,null);this.i=new kn(S(this).options.apiKey+":"+S(this).name);this.B=
	new hn(S(this).options.apiKey+":"+S(this).name);this.Z=T(this,wn(this));this.h=T(this,xn(this));this.aa=!1;this.oa=r(this.Xc,this);this.Ma=r(this.ca,this);this.xa=r(this.jc,this);this.ya=r(this.uc,this);this.za=r(this.vc,this);this.a=null;yn(this);this.INTERNAL={};this.INTERNAL["delete"]=r(this.delete,this);this.INTERNAL.logFramework=r(this.Ec,this);this.s=0;G.call(this);zn(this);this.N=[]}t(un,G);function An(a){Xc.call(this,"languageCodeChanged");this.g=a}t(An,Xc);
	function Bn(a){Xc.call(this,"frameworkChanged");this.c=a}t(Bn,Xc);k=un.prototype;k.tb=function(a){a=this.i.tb(a);return T(this,a)};k.va=function(a){this.$===a||this.l||(this.$=a,Ki(this.b,this.$),this.dispatchEvent(new An(this.ja())))};k.ja=function(){return this.$};k.dd=function(){var a=l.navigator;this.va(a?a.languages&&a.languages[0]||a.language||a.userLanguage||null:null)};k.Ec=function(a){this.N.push(a);Li(this.b,firebase.SDK_VERSION?Le(firebase.SDK_VERSION,this.N):null);this.dispatchEvent(new Bn(this.N))};
	k.Ea=function(){return Wa(this.N)};k.ub=function(a){this.R===a||this.l||(this.R=a,this.b.b=this.R)};k.S=function(){return this.R};function zn(a){Object.defineProperty(a,"lc",{get:function(){return this.ja()},set:function(b){this.va(b)},enumerable:!1});a.$=null;Object.defineProperty(a,"ti",{get:function(){return this.S()},set:function(b){this.ub(b)},enumerable:!1});a.R=null}
	k.toJSON=function(){return{apiKey:S(this).options.apiKey,authDomain:S(this).options.authDomain,appName:S(this).name,currentUser:U(this)&&U(this).v()}};function Cn(a){return a.Zb||F(new u("auth-domain-config-required"))}function yn(a){var b=S(a).options.authDomain,c=S(a).options.apiKey;b&&Oe()&&(a.Zb=a.Z.then(function(){if(!a.l){a.a=Pl(b,c,S(a).name);Hl(a.a,a);U(a)&&Lm(U(a));if(a.D){Lm(a.D);var d=a.D;d.va(a.ja());Em(d,a);d=a.D;Dm(d,a.N);Fm(d,a);a.D=null}return a.a}}))}
	k.Cb=function(a,b){switch(a){case "unknown":case "signInViaRedirect":return!0;case "signInViaPopup":return this.g==b&&!!this.f;default:return!1}};k.la=function(a,b,c,d){"signInViaPopup"==a&&this.g==d&&(c&&this.w?this.w(c):b&&!c&&this.f&&this.f(b),this.c&&(this.c.cancel(),this.c=null),delete this.f,delete this.w)};k.Da=function(a,b){return"signInViaRedirect"==a||"signInViaPopup"==a&&this.g==b&&this.f?r(this.gc,this):null};
	k.gc=function(a,b,c,d){var e=this,f={requestUri:a,postBody:d,sessionId:b,tenantId:c};this.c&&(this.c.cancel(),this.c=null);return e.Z.then(function(){return Dn(e,Cg(e.b,f))})};
	k.Vc=function(a){if(!Oe())return F(new u("operation-not-supported-in-this-environment"));var b=this,c=kg(a.providerId),d=Ne(),e=null;(!Qe()||Fe())&&S(this).options.authDomain&&a.isOAuthProvider&&(e=Yj(S(this).options.authDomain,S(this).options.apiKey,S(this).name,"signInViaPopup",a,null,d,firebase.SDK_VERSION||null,null,null,this.S()));var f=we(e,c&&c.ta,c&&c.sa);c=Cn(this).then(function(g){return Ll(g,f,"signInViaPopup",a,d,!!e,b.S())}).then(function(){return new D(function(g,h){b.la("signInViaPopup",
	null,new u("cancelled-popup-request"),b.g);b.f=g;b.w=h;b.g=d;b.c=Nl(b.a,b,"signInViaPopup",f,d)})}).then(function(g){f&&ve(f);return g?gf(g):null}).o(function(g){f&&ve(f);throw g;});return T(this,c)};k.Wc=function(a){if(!Oe())return F(new u("operation-not-supported-in-this-environment"));var b=this,c=Cn(this).then(function(){return qn(b.i)}).then(function(){return Ml(b.a,"signInViaRedirect",a,void 0,b.S())});return T(this,c)};
	function En(a){if(!Oe())return F(new u("operation-not-supported-in-this-environment"));var b=Cn(a).then(function(){return a.a.pa()}).then(function(c){return c?gf(c):null});return T(a,b)}k.pa=function(){var a=this;return En(this).then(function(b){a.a&&Sl(a.a.b);return b}).o(function(b){a.a&&Sl(a.a.b);throw b;})};
	k.bd=function(a){if(!a)return F(new u("null-user"));if(this.R!=a.tenantId)return F(new u("tenant-id-mismatch"));var b=this,c={};c.apiKey=S(this).options.apiKey;c.authDomain=S(this).options.authDomain;c.appName=S(this).name;var d=gn(a,c,b.B,b.Ea());return T(this,this.h.then(function(){if(S(b).options.apiKey!=a.l)return d.reload()}).then(function(){if(U(b)&&a.uid==U(b).uid)return Sm(U(b),a),b.ca(a);vn(b,d);Lm(d);return b.ca(d)}).then(function(){Fn(b)}))};
	function Gn(a,b){var c={};c.apiKey=S(a).options.apiKey;c.authDomain=S(a).options.authDomain;c.appName=S(a).name;return a.Z.then(function(){return fn(c,b,a.B,a.Ea())}).then(function(d){if(U(a)&&d.uid==U(a).uid)return Sm(U(a),d),a.ca(d);vn(a,d);Lm(d);return a.ca(d)}).then(function(){Fn(a)})}
	function vn(a,b){U(a)&&(Jm(U(a),a.Ma),td(U(a),"tokenChanged",a.xa),td(U(a),"userDeleted",a.ya),td(U(a),"userInvalidated",a.za),Im(U(a)));b&&(b.R.push(a.Ma),jd(b,"tokenChanged",a.xa),jd(b,"userDeleted",a.ya),jd(b,"userInvalidated",a.za),0<a.s&&Hm(b));K(a,"currentUser",b);b&&(b.va(a.ja()),Em(b,a),Dm(b,a.N),Fm(b,a))}k.wb=function(){var a=this,b=this.h.then(function(){a.a&&Sl(a.a.b);if(!U(a))return E();vn(a,null);return sn(a.i).then(function(){Fn(a)})});return T(this,b)};
	function Hn(a){var b=jn(a.B,S(a).options.authDomain).then(function(c){if(a.D=c)c.ga=a.B;return cn(a.B)});return T(a,b)}function wn(a){var b=S(a).options.authDomain,c=Hn(a).then(function(){return tn(a.i,b)}).then(function(d){return d?(d.ga=a.B,a.D&&(a.D.fa||null)==(d.fa||null)?d:d.reload().then(function(){return rn(a.i,d).then(function(){return d})}).o(function(e){return"auth/network-request-failed"==e.code?d:sn(a.i)})):null}).then(function(d){vn(a,d||null)});return T(a,c)}
	function xn(a){return a.Z.then(function(){return En(a)}).o(function(){}).then(function(){if(!a.l)return a.oa()}).o(function(){}).then(function(){if(!a.l){a.aa=!0;var b=a.i;b.b.addListener(mn("local"),b.a,a.oa)}})}
	k.Xc=function(){var a=this;return tn(this.i,S(this).options.authDomain).then(function(b){if(!a.l){var c;if(c=U(a)&&b){c=U(a).uid;var d=b.uid;c=void 0===c||null===c||""===c||void 0===d||null===d||""===d?!1:c==d}if(c)return Sm(U(a),b),U(a).I();if(U(a)||b)vn(a,b),b&&(Lm(b),b.ga=a.B),a.a&&Hl(a.a,a),Fn(a)}})};k.ca=function(a){return rn(this.i,a)};k.jc=function(){Fn(this);this.ca(U(this))};k.uc=function(){this.wb()};k.vc=function(){this.wb()};
	function Dn(a,b){var c=null,d=null;return T(a,b.then(function(e){c=mh(e);d=lg(e);return Gn(a,e)},function(e){var f=null;e&&"auth/multi-factor-auth-required"===e.code&&(f=em(e.v(),a,r(a.ic,a)));throw f||e;}).then(function(){return gf({user:U(a),credential:c,additionalUserInfo:d,operationType:"signIn"})}))}k.ic=function(a){var b=this;return this.h.then(function(){return Dn(b,E(a))})};k.xc=function(a){var b=this;this.addAuthTokenListener(function(){a.next(U(b))})};
	k.yc=function(a){var b=this;In(this,function(){a.next(U(b))})};k.Gc=function(a,b,c){var d=this;this.aa&&Promise.resolve().then(function(){n(a)?a(U(d)):n(a.next)&&a.next(U(d))});return this.$b(a,b,c)};k.Fc=function(a,b,c){var d=this;this.aa&&Promise.resolve().then(function(){d.W=d.getUid();n(a)?a(U(d)):n(a.next)&&a.next(U(d))});return this.ac(a,b,c)};k.kc=function(a){var b=this,c=this.h.then(function(){return U(b)?U(b).I(a).then(function(d){return{accessToken:d}}):null});return T(this,c)};
	k.Rc=function(a){var b=this;return this.h.then(function(){return Dn(b,N(b.b,Ej,{token:a}))}).then(function(c){var d=c.user;Rm(d,"isAnonymous",!1);b.ca(d);return c})};k.Sc=function(a,b){var c=this;return this.h.then(function(){return Dn(c,N(c.b,Xg,{email:a,password:b}))})};k.cc=function(a,b){var c=this;return this.h.then(function(){return Dn(c,N(c.b,yj,{email:a,password:b}))})};k.Ya=function(a){var b=this;return this.h.then(function(){return Dn(b,a.ia(b.b))})};
	k.Qc=function(a){df("firebase.auth.Auth.prototype.signInAndRetrieveDataWithCredential is deprecated. Please use firebase.auth.Auth.prototype.signInWithCredential instead.");return this.Ya(a)};k.vb=function(){var a=this;return this.h.then(function(){var b=U(a);if(b&&b.isAnonymous){var c=gf({providerId:null,isNewUser:!1});return gf({user:b,credential:null,additionalUserInfo:c,operationType:"signIn"})}return Dn(a,a.b.vb()).then(function(d){var e=d.user;Rm(e,"isAnonymous",!0);a.ca(e);return d})})};
	function S(a){return a.app}function U(a){return a.currentUser}k.getUid=function(){return U(this)&&U(this).uid||null};function Jn(a){return U(a)&&U(a)._lat||null}function Fn(a){if(a.aa){for(var b=0;b<a.m.length;b++)if(a.m[b])a.m[b](Jn(a));if(a.W!==a.getUid()&&a.O.length)for(a.W=a.getUid(),b=0;b<a.O.length;b++)if(a.O[b])a.O[b](Jn(a))}}k.bc=function(a){this.addAuthTokenListener(a);this.s++;0<this.s&&U(this)&&Hm(U(this))};
	k.Nc=function(a){var b=this;x(this.m,function(c){c==a&&b.s--});0>this.s&&(this.s=0);0==this.s&&U(this)&&Im(U(this));this.removeAuthTokenListener(a)};k.addAuthTokenListener=function(a){var b=this;this.m.push(a);T(this,this.h.then(function(){b.l||Sa(b.m,a)&&a(Jn(b))}))};k.removeAuthTokenListener=function(a){Ua(this.m,function(b){return b==a})};function In(a,b){a.O.push(b);T(a,a.h.then(function(){!a.l&&Sa(a.O,b)&&a.W!==a.getUid()&&(a.W=a.getUid(),b(Jn(a)))}))}
	k.delete=function(){this.l=!0;for(var a=0;a<this.P.length;a++)this.P[a].cancel("app-deleted");this.P=[];this.i&&(a=this.i,a.b.removeListener(mn("local"),a.a,this.oa));this.a&&(Il(this.a,this),Sl(this.a.b));return Promise.resolve()};function T(a,b){a.P.push(b);b.ma(function(){Ta(a.P,b)});return b}k.fc=function(a){return T(this,Vi(this.b,a))};k.zc=function(a){return!!bh(a)};
	k.sb=function(a,b){var c=this;return T(this,E().then(function(){var d=new Pf(b);if(!d.c)throw new u("argument-error",Xf+" must be true when sending sign in link to email");return Zf(d)}).then(function(d){return c.b.sb(a,d)}).then(function(){}))};k.fd=function(a){return this.Pa(a).then(function(b){return b.data.email})};k.jb=function(a,b){return T(this,this.b.jb(a,b).then(function(){}))};k.Pa=function(a){return T(this,this.b.Pa(a).then(function(b){return new sf(b)}))};
	k.fb=function(a){return T(this,this.b.fb(a).then(function(){}))};k.rb=function(a,b){var c=this;return T(this,E().then(function(){return"undefined"===typeof b||jb(b)?{}:Zf(new Pf(b))}).then(function(d){return c.b.rb(a,d)}).then(function(){}))};k.Uc=function(a,b){return T(this,Zl(this,a,b,r(this.Ya,this)))};
	k.Tc=function(a,b){var c=this;return T(this,E().then(function(){var d=b||oe(),e=ah(a,d);d=bh(d);if(!d)throw new u("argument-error","Invalid email link!");if(d.tenantId!==c.S())throw new u("tenant-id-mismatch");return c.Ya(e)}))};function Kn(){}Kn.prototype.render=function(){};Kn.prototype.reset=function(){};Kn.prototype.getResponse=function(){};Kn.prototype.execute=function(){};function Ln(){this.a={};this.b=1E12}var Mn=null;Ln.prototype.render=function(a,b){this.a[this.b.toString()]=new Nn(a,b);return this.b++};Ln.prototype.reset=function(a){var b=On(this,a);a=Pn(a);b&&a&&(b.delete(),delete this.a[a])};Ln.prototype.getResponse=function(a){return(a=On(this,a))?a.getResponse():null};Ln.prototype.execute=function(a){(a=On(this,a))&&a.execute()};function On(a,b){return(b=Pn(b))?a.a[b]||null:null}function Pn(a){return(a="undefined"===typeof a?1E12:a)?a.toString():null}
	function Nn(a,b){this.g=!1;this.c=b;this.a=this.b=null;this.h="invisible"!==this.c.size;this.f=ec(a);var c=this;this.i=function(){c.execute()};this.h?this.execute():jd(this.f,"click",this.i)}Nn.prototype.getResponse=function(){Qn(this);return this.b};
	Nn.prototype.execute=function(){Qn(this);var a=this;this.a||(this.a=setTimeout(function(){a.b=Je();var b=a.c.callback,c=a.c["expired-callback"];if(b)try{b(a.b)}catch(d){}a.a=setTimeout(function(){a.a=null;a.b=null;if(c)try{c()}catch(d){}a.h&&a.execute()},6E4)},500))};Nn.prototype.delete=function(){Qn(this);this.g=!0;clearTimeout(this.a);this.a=null;td(this.f,"click",this.i)};function Qn(a){if(a.g)throw Error("reCAPTCHA mock was already deleted!");};function Rn(){}K(Rn,"FACTOR_ID","phone");function Sn(){}Sn.prototype.g=function(){Mn||(Mn=new Ln);return E(Mn)};Sn.prototype.c=function(){};var Tn=null;function Un(){this.b=l.grecaptcha?Infinity:0;this.f=null;this.a="__rcb"+Math.floor(1E6*Math.random()).toString()}var Vn=new nb(ob,"https://www.google.com/recaptcha/api.js?onload=%{onload}&render=explicit&hl=%{hl}"),Wn=new We(3E4,6E4);
	Un.prototype.g=function(a){var b=this;return new D(function(c,d){var e=setTimeout(function(){d(new u("network-request-failed"))},Wn.get());if(!l.grecaptcha||a!==b.f&&!b.b){l[b.a]=function(){if(l.grecaptcha){b.f=a;var g=l.grecaptcha.render;l.grecaptcha.render=function(h,m){h=g(h,m);b.b++;return h};clearTimeout(e);c(l.grecaptcha)}else clearTimeout(e),d(new u("internal-error"));delete l[b.a]};var f=wb(Vn,{onload:b.a,hl:a||""});E(xi(f)).o(function(){clearTimeout(e);d(new u("internal-error","Unable to load external reCAPTCHA dependencies!"))})}else clearTimeout(e),
	c(l.grecaptcha)})};Un.prototype.c=function(){this.b--};var Xn=null;function Yn(a,b,c,d,e,f,g){K(this,"type","recaptcha");this.c=this.f=null;this.D=!1;this.u=b;this.g=null;g?(Tn||(Tn=new Sn),g=Tn):(Xn||(Xn=new Un),g=Xn);this.m=g;this.a=c||{theme:"light",type:"image"};this.h=[];if(this.a[Zn])throw new u("argument-error","sitekey should not be provided for reCAPTCHA as one is automatically provisioned for the current project.");this.i="invisible"===this.a[$n];if(!l.document)throw new u("operation-not-supported-in-this-environment","RecaptchaVerifier is only supported in a browser HTTP/HTTPS environment with DOM support.");
	if(!ec(b)||!this.i&&ec(b).hasChildNodes())throw new u("argument-error","reCAPTCHA container is either not found or already contains inner elements!");this.s=new Ei(a,f||null,e||null);this.w=d||function(){return null};var h=this;this.l=[];var m=this.a[ao];this.a[ao]=function(v){bo(h,v);if("function"===typeof m)m(v);else if("string"===typeof m){var C=J(m,l);"function"===typeof C&&C(v)}};var p=this.a[co];this.a[co]=function(){bo(h,null);if("function"===typeof p)p();else if("string"===typeof p){var v=
	J(p,l);"function"===typeof v&&v()}}}var ao="callback",co="expired-callback",Zn="sitekey",$n="size";function bo(a,b){for(var c=0;c<a.l.length;c++)try{a.l[c](b)}catch(d){}}function eo(a,b){Ua(a.l,function(c){return c==b})}function fo(a,b){a.h.push(b);b.ma(function(){Ta(a.h,b)});return b}k=Yn.prototype;
	k.Ga=function(){var a=this;return this.f?this.f:this.f=fo(this,E().then(function(){if(Pe()&&!Ge())return Be();throw new u("operation-not-supported-in-this-environment","RecaptchaVerifier is only supported in a browser HTTP/HTTPS environment.");}).then(function(){return a.m.g(a.w())}).then(function(b){a.g=b;return N(a.s,Dj,{})}).then(function(b){a.a[Zn]=b.recaptchaSiteKey}).o(function(b){a.f=null;throw b;}))};
	k.render=function(){go(this);var a=this;return fo(this,this.Ga().then(function(){if(null===a.c){var b=a.u;if(!a.i){var c=ec(b);b=hc("DIV");c.appendChild(b)}a.c=a.g.render(b,a.a)}return a.c}))};k.verify=function(){go(this);var a=this;return fo(this,this.render().then(function(b){return new D(function(c){var d=a.g.getResponse(b);if(d)c(d);else{var e=function(f){f&&(eo(a,e),c(f))};a.l.push(e);a.i&&a.g.execute(a.c)}})}))};k.reset=function(){go(this);null!==this.c&&this.g.reset(this.c)};
	function go(a){if(a.D)throw new u("internal-error","RecaptchaVerifier instance has been destroyed.");}k.clear=function(){go(this);this.D=!0;this.m.c();for(var a=0;a<this.h.length;a++)this.h[a].cancel("RecaptchaVerifier instance has been destroyed.");if(!this.i){a=ec(this.u);for(var b;b=a.firstChild;)a.removeChild(b)}};
	function ho(a,b,c){var d=!1;try{this.b=c||firebase.app()}catch(g){throw new u("argument-error","No firebase.app.App instance is currently initialized.");}if(this.b.options&&this.b.options.apiKey)c=this.b.options.apiKey;else throw new u("invalid-api-key");var e=this,f=null;try{f=this.b.auth().Ea()}catch(g){}try{d=this.b.auth().settings.appVerificationDisabledForTesting}catch(g){}f=firebase.SDK_VERSION?Le(firebase.SDK_VERSION,f):null;Yn.call(this,c,a,b,function(){try{var g=e.b.auth().ja()}catch(h){g=
	null}return g},f,za(Aa),d)}t(ho,Yn);function io(a,b,c,d){a:{c=Array.prototype.slice.call(c);var e=0;for(var f=!1,g=0;g<b.length;g++)if(b[g].optional)f=!0;else{if(f)throw new u("internal-error","Argument validator encountered a required argument after an optional argument.");e++}f=b.length;if(c.length<e||f<c.length)d="Expected "+(e==f?1==e?"1 argument":e+" arguments":e+"-"+f+" arguments")+" but got "+c.length+".";else{for(e=0;e<c.length;e++)if(f=b[e].optional&&void 0===c[e],!b[e].K(c[e])&&!f){b=b[e];if(0>e||e>=jo.length)throw new u("internal-error",
	"Argument validator received an unsupported number of arguments.");c=jo[e];d=(d?"":c+" argument ")+(b.name?'"'+b.name+'" ':"")+"must be "+b.J+".";break a}d=null}}if(d)throw new u("argument-error",a+" failed: "+d);}var jo="First Second Third Fourth Fifth Sixth Seventh Eighth Ninth".split(" ");function V(a,b){return{name:a||"",J:"a valid string",optional:!!b,K:function(c){return"string"===typeof c}}}
	function ko(a,b){return{name:a||"",J:"a boolean",optional:!!b,K:function(c){return"boolean"===typeof c}}}function W(a,b){return{name:a||"",J:"a valid object",optional:!!b,K:q}}function lo(a,b){return{name:a||"",J:"a function",optional:!!b,K:n}}function mo(a,b){return{name:a||"",J:"null",optional:!!b,K:function(c){return null===c}}}function no(){return{name:"",J:"an HTML element",optional:!1,K:function(a){return!!(a&&a instanceof Element)}}}
	function oo(){return{name:"auth",J:"an instance of Firebase Auth",optional:!0,K:function(a){return!!(a&&a instanceof un)}}}function po(){return{name:"app",J:"an instance of Firebase App",optional:!0,K:function(a){return!!(a&&a instanceof firebase.app.App)}}}function qo(a){return{name:a?a+"Credential":"credential",J:a?"a valid "+a+" credential":"a valid credential",optional:!1,K:function(b){if(!b)return!1;var c=!a||b.providerId===a;return!(!b.ia||!c)}}}
	function ro(){return{name:"multiFactorAssertion",J:"a valid multiFactorAssertion",optional:!1,K:function(a){return a?!!a.ob:!1}}}function so(){return{name:"authProvider",J:"a valid Auth provider",optional:!1,K:function(a){return!!(a&&a.providerId&&a.hasOwnProperty&&a.hasOwnProperty("isOAuthProvider"))}}}function to(a,b){return q(a)&&"string"===typeof a.type&&a.type===b&&n(a.Fa)}function uo(a){return q(a)&&"string"===typeof a.uid}
	function vo(){return{name:"applicationVerifier",J:"an implementation of firebase.auth.ApplicationVerifier",optional:!1,K:function(a){return!(!a||"string"!==typeof a.type||!n(a.verify))}}}function X(a,b,c,d){return{name:c||"",J:a.J+" or "+b.J,optional:!!d,K:function(e){return a.K(e)||b.K(e)}}};function Y(a,b){for(var c in b){var d=b[c].name;a[d]=wo(d,a[c],b[c].j)}}function xo(a,b){for(var c in b){var d=b[c].name;d!==c&&Object.defineProperty(a,d,{get:sa(function(e){return this[e]},c),set:sa(function(e,f,g,h){io(e,[g],[h],!0);this[f]=h},d,c,b[c].gb),enumerable:!0})}}function Z(a,b,c,d){a[b]=wo(b,c,d)}
	function wo(a,b,c){function d(){var g=Array.prototype.slice.call(arguments);io(e,c,g);return b.apply(this,g)}if(!c)return b;var e=yo(a),f;for(f in b)d[f]=b[f];for(f in b.prototype)d.prototype[f]=b.prototype[f];return d}function yo(a){a=a.split(".");return a[a.length-1]};Y(un.prototype,{fb:{name:"applyActionCode",j:[V("code")]},Pa:{name:"checkActionCode",j:[V("code")]},jb:{name:"confirmPasswordReset",j:[V("code"),V("newPassword")]},cc:{name:"createUserWithEmailAndPassword",j:[V("email"),V("password")]},fc:{name:"fetchSignInMethodsForEmail",j:[V("email")]},pa:{name:"getRedirectResult",j:[]},zc:{name:"isSignInWithEmailLink",j:[V("emailLink")]},Fc:{name:"onAuthStateChanged",j:[X(W(),lo(),"nextOrObserver"),lo("opt_error",!0),lo("opt_completed",!0)]},Gc:{name:"onIdTokenChanged",
	j:[X(W(),lo(),"nextOrObserver"),lo("opt_error",!0),lo("opt_completed",!0)]},rb:{name:"sendPasswordResetEmail",j:[V("email"),X(W("opt_actionCodeSettings",!0),mo(null,!0),"opt_actionCodeSettings",!0)]},sb:{name:"sendSignInLinkToEmail",j:[V("email"),W("actionCodeSettings")]},tb:{name:"setPersistence",j:[V("persistence")]},Qc:{name:"signInAndRetrieveDataWithCredential",j:[qo()]},vb:{name:"signInAnonymously",j:[]},Ya:{name:"signInWithCredential",j:[qo()]},Rc:{name:"signInWithCustomToken",j:[V("token")]},
	Sc:{name:"signInWithEmailAndPassword",j:[V("email"),V("password")]},Tc:{name:"signInWithEmailLink",j:[V("email"),V("emailLink",!0)]},Uc:{name:"signInWithPhoneNumber",j:[V("phoneNumber"),vo()]},Vc:{name:"signInWithPopup",j:[so()]},Wc:{name:"signInWithRedirect",j:[so()]},bd:{name:"updateCurrentUser",j:[X(function(a){return{name:"user",J:"an instance of Firebase User",optional:!!a,K:function(b){return!!(b&&b instanceof P)}}}(),mo(),"user")]},wb:{name:"signOut",j:[]},toJSON:{name:"toJSON",j:[V(null,!0)]},
	dd:{name:"useDeviceLanguage",j:[]},fd:{name:"verifyPasswordResetCode",j:[V("code")]}});xo(un.prototype,{lc:{name:"languageCode",gb:X(V(),mo(),"languageCode")},ti:{name:"tenantId",gb:X(V(),mo(),"tenantId")}});un.Persistence=Kk;un.Persistence.LOCAL="local";un.Persistence.SESSION="session";un.Persistence.NONE="none";
	Y(P.prototype,{"delete":{name:"delete",j:[]},mc:{name:"getIdTokenResult",j:[ko("opt_forceRefresh",!0)]},I:{name:"getIdToken",j:[ko("opt_forceRefresh",!0)]},Ac:{name:"linkAndRetrieveDataWithCredential",j:[qo()]},mb:{name:"linkWithCredential",j:[qo()]},Bc:{name:"linkWithPhoneNumber",j:[V("phoneNumber"),vo()]},Cc:{name:"linkWithPopup",j:[so()]},Dc:{name:"linkWithRedirect",j:[so()]},Jc:{name:"reauthenticateAndRetrieveDataWithCredential",j:[qo()]},pb:{name:"reauthenticateWithCredential",j:[qo()]},Kc:{name:"reauthenticateWithPhoneNumber",
	j:[V("phoneNumber"),vo()]},Lc:{name:"reauthenticateWithPopup",j:[so()]},Mc:{name:"reauthenticateWithRedirect",j:[so()]},reload:{name:"reload",j:[]},qb:{name:"sendEmailVerification",j:[X(W("opt_actionCodeSettings",!0),mo(null,!0),"opt_actionCodeSettings",!0)]},toJSON:{name:"toJSON",j:[V(null,!0)]},ad:{name:"unlink",j:[V("provider")]},xb:{name:"updateEmail",j:[V("email")]},yb:{name:"updatePassword",j:[V("password")]},cd:{name:"updatePhoneNumber",j:[qo("phone")]},zb:{name:"updateProfile",j:[W("profile")]},
	Ab:{name:"verifyBeforeUpdateEmail",j:[V("email"),X(W("opt_actionCodeSettings",!0),mo(null,!0),"opt_actionCodeSettings",!0)]}});Y(Ln.prototype,{execute:{name:"execute"},render:{name:"render"},reset:{name:"reset"},getResponse:{name:"getResponse"}});Y(Kn.prototype,{execute:{name:"execute"},render:{name:"render"},reset:{name:"reset"},getResponse:{name:"getResponse"}});Y(D.prototype,{ma:{name:"finally"},o:{name:"catch"},then:{name:"then"}});
	xo(Xl.prototype,{appVerificationDisabled:{name:"appVerificationDisabledForTesting",gb:ko("appVerificationDisabledForTesting")}});Y(Yl.prototype,{confirm:{name:"confirm",j:[V("verificationCode")]}});Z(yg,"fromJSON",function(a){a="string"===typeof a?JSON.parse(a):a;for(var b,c=[Jg,$g,gh,Gg],d=0;d<c.length;d++)if(b=c[d](a))return b;return null},[X(V(),W(),"json")]);Z(Vg,"credential",function(a,b){return new Ug(a,b)},[V("email"),V("password")]);Y(Ug.prototype,{v:{name:"toJSON",j:[V(null,!0)]}});
	Y(Mg.prototype,{Aa:{name:"addScope",j:[V("scope")]},Ia:{name:"setCustomParameters",j:[W("customOAuthParameters")]}});Z(Mg,"credential",Ng,[X(V(),W(),"token")]);Z(Vg,"credentialWithLink",ah,[V("email"),V("emailLink")]);Y(Og.prototype,{Aa:{name:"addScope",j:[V("scope")]},Ia:{name:"setCustomParameters",j:[W("customOAuthParameters")]}});Z(Og,"credential",Pg,[X(V(),W(),"token")]);Y(Qg.prototype,{Aa:{name:"addScope",j:[V("scope")]},Ia:{name:"setCustomParameters",j:[W("customOAuthParameters")]}});
	Z(Qg,"credential",Rg,[X(V(),X(W(),mo()),"idToken"),X(V(),mo(),"accessToken",!0)]);Y(Sg.prototype,{Ia:{name:"setCustomParameters",j:[W("customOAuthParameters")]}});Z(Sg,"credential",Tg,[X(V(),W(),"token"),V("secret",!0)]);Y(M.prototype,{Aa:{name:"addScope",j:[V("scope")]},credential:{name:"credential",j:[X(V(),X(W(),mo()),"optionsOrIdToken"),X(V(),mo(),"accessToken",!0)]},Ia:{name:"setCustomParameters",j:[W("customOAuthParameters")]}});Y(Hg.prototype,{v:{name:"toJSON",j:[V(null,!0)]}});
	Y(Bg.prototype,{v:{name:"toJSON",j:[V(null,!0)]}});Z(hh,"credential",lh,[V("verificationId"),V("verificationCode")]);
	Y(hh.prototype,{cb:{name:"verifyPhoneNumber",j:[X(V(),function(a,b){return{name:a||"phoneInfoOptions",J:"valid phone info options",optional:!!b,K:function(c){return c?c.session&&c.phoneNumber?to(c.session,wg)&&"string"===typeof c.phoneNumber:c.session&&c.multiFactorHint?to(c.session,xg)&&uo(c.multiFactorHint):c.session&&c.multiFactorUid?to(c.session,xg)&&"string"===typeof c.multiFactorUid:c.phoneNumber?"string"===typeof c.phoneNumber:!1:!1}}}(),"phoneInfoOptions"),vo()]}});
	Y(ch.prototype,{v:{name:"toJSON",j:[V(null,!0)]}});Y(u.prototype,{toJSON:{name:"toJSON",j:[V(null,!0)]}});Y(uh.prototype,{toJSON:{name:"toJSON",j:[V(null,!0)]}});Y(th.prototype,{toJSON:{name:"toJSON",j:[V(null,!0)]}});Y(dm.prototype,{toJSON:{name:"toJSON",j:[V(null,!0)]}});Y(am.prototype,{Pc:{name:"resolveSignIn",j:[ro()]}});
	Y(lm.prototype,{Ob:{name:"getSession",j:[]},dc:{name:"enroll",j:[ro(),V("displayName",!0)]},$c:{name:"unenroll",j:[X({name:"multiFactorInfo",J:"a valid multiFactorInfo",optional:!1,K:uo},V(),"multiFactorInfoIdentifier")]}});Y(ho.prototype,{clear:{name:"clear",j:[]},render:{name:"render",j:[]},verify:{name:"verify",j:[]}});Z(Gf,"parseLink",Of,[V("link")]);Z(Rn,"assertion",function(a){return new jm(a)},[qo("phone")]);
	(function(){if("undefined"!==typeof firebase&&firebase.INTERNAL&&firebase.INTERNAL.registerComponent){var a={ActionCodeInfo:{Operation:{EMAIL_SIGNIN:xf,PASSWORD_RESET:"PASSWORD_RESET",RECOVER_EMAIL:"RECOVER_EMAIL",REVERT_SECOND_FACTOR_ADDITION:zf,VERIFY_AND_CHANGE_EMAIL:yf,VERIFY_EMAIL:"VERIFY_EMAIL"}},Auth:un,AuthCredential:yg,Error:u};Z(a,"EmailAuthProvider",Vg,[]);Z(a,"FacebookAuthProvider",Mg,[]);Z(a,"GithubAuthProvider",Og,[]);Z(a,"GoogleAuthProvider",Qg,[]);Z(a,"TwitterAuthProvider",Sg,[]);
	Z(a,"OAuthProvider",M,[V("providerId")]);Z(a,"SAMLAuthProvider",Lg,[V("providerId")]);Z(a,"PhoneAuthProvider",hh,[oo()]);Z(a,"RecaptchaVerifier",ho,[X(V(),no(),"recaptchaContainer"),W("recaptchaParameters",!0),po()]);Z(a,"ActionCodeURL",Gf,[]);Z(a,"PhoneMultiFactorGenerator",Rn,[]);firebase.INTERNAL.registerComponent({name:"auth",instanceFactory:function(b){b=b.getProvider("app").getImmediate();return new un(b)},multipleInstances:!1,serviceProps:a,instantiationMode:"LAZY",type:"PUBLIC"});firebase.INTERNAL.registerComponent({name:"auth-internal",
	instanceFactory:function(b){b=b.getProvider("auth").getImmediate();return{getUid:r(b.getUid,b),getToken:r(b.kc,b),addAuthTokenListener:r(b.bc,b),removeAuthTokenListener:r(b.Nc,b)}},multipleInstances:!1,instantiationMode:"LAZY",type:"PRIVATE"});firebase.registerVersion("@firebase/auth","0.14.6");firebase.INTERNAL.extendNamespace({User:P})}else throw Error("Cannot find the firebase namespace; be sure to include firebase-app.js before this library.");})();}).apply(typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : {});
	
	//# sourceMappingURL=auth.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 264 */
262,
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var firebase = _interopDefault(__webpack_require__(39));
	var tslib = __webpack_require__(266);
	var util = __webpack_require__(59);
	var logger$1 = __webpack_require__(102);
	var component = __webpack_require__(58);
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Wraps a DOM Storage object and:
	 * - automatically encode objects as JSON strings before storing them to allow us to store arbitrary types.
	 * - prefixes names with "firebase:" to avoid collisions with app data.
	 *
	 * We automatically (see storage.js) create two such wrappers, one for sessionStorage,
	 * and one for localStorage.
	 *
	 * @constructor
	 */
	var DOMStorageWrapper = /** @class */ (function () {
	    /**
	     * @param {Storage} domStorage_ The underlying storage object (e.g. localStorage or sessionStorage)
	     */
	    function DOMStorageWrapper(domStorage_) {
	        this.domStorage_ = domStorage_;
	        // Use a prefix to avoid collisions with other stuff saved by the app.
	        this.prefix_ = 'firebase:';
	    }
	    /**
	     * @param {string} key The key to save the value under
	     * @param {?Object} value The value being stored, or null to remove the key.
	     */
	    DOMStorageWrapper.prototype.set = function (key, value) {
	        if (value == null) {
	            this.domStorage_.removeItem(this.prefixedName_(key));
	        }
	        else {
	            this.domStorage_.setItem(this.prefixedName_(key), util.stringify(value));
	        }
	    };
	    /**
	     * @param {string} key
	     * @return {*} The value that was stored under this key, or null
	     */
	    DOMStorageWrapper.prototype.get = function (key) {
	        var storedVal = this.domStorage_.getItem(this.prefixedName_(key));
	        if (storedVal == null) {
	            return null;
	        }
	        else {
	            return util.jsonEval(storedVal);
	        }
	    };
	    /**
	     * @param {string} key
	     */
	    DOMStorageWrapper.prototype.remove = function (key) {
	        this.domStorage_.removeItem(this.prefixedName_(key));
	    };
	    /**
	     * @param {string} name
	     * @return {string}
	     */
	    DOMStorageWrapper.prototype.prefixedName_ = function (name) {
	        return this.prefix_ + name;
	    };
	    DOMStorageWrapper.prototype.toString = function () {
	        return this.domStorage_.toString();
	    };
	    return DOMStorageWrapper;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * An in-memory storage implementation that matches the API of DOMStorageWrapper
	 * (TODO: create interface for both to implement).
	 *
	 * @constructor
	 */
	var MemoryStorage = /** @class */ (function () {
	    function MemoryStorage() {
	        this.cache_ = {};
	        this.isInMemoryStorage = true;
	    }
	    MemoryStorage.prototype.set = function (key, value) {
	        if (value == null) {
	            delete this.cache_[key];
	        }
	        else {
	            this.cache_[key] = value;
	        }
	    };
	    MemoryStorage.prototype.get = function (key) {
	        if (util.contains(this.cache_, key)) {
	            return this.cache_[key];
	        }
	        return null;
	    };
	    MemoryStorage.prototype.remove = function (key) {
	        delete this.cache_[key];
	    };
	    return MemoryStorage;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Helper to create a DOMStorageWrapper or else fall back to MemoryStorage.
	 * TODO: Once MemoryStorage and DOMStorageWrapper have a shared interface this method annotation should change
	 * to reflect this type
	 *
	 * @param {string} domStorageName Name of the underlying storage object
	 *   (e.g. 'localStorage' or 'sessionStorage').
	 * @return {?} Turning off type information until a common interface is defined.
	 */
	var createStoragefor = function (domStorageName) {
	    try {
	        // NOTE: just accessing "localStorage" or "window['localStorage']" may throw a security exception,
	        // so it must be inside the try/catch.
	        if (typeof window !== 'undefined' &&
	            typeof window[domStorageName] !== 'undefined') {
	            // Need to test cache. Just because it's here doesn't mean it works
	            var domStorage = window[domStorageName];
	            domStorage.setItem('firebase:sentinel', 'cache');
	            domStorage.removeItem('firebase:sentinel');
	            return new DOMStorageWrapper(domStorage);
	        }
	    }
	    catch (e) { }
	    // Failed to create wrapper.  Just return in-memory storage.
	    // TODO: log?
	    return new MemoryStorage();
	};
	/** A storage object that lasts across sessions */
	var PersistentStorage = createStoragefor('localStorage');
	/** A storage object that only lasts one session */
	var SessionStorage = createStoragefor('sessionStorage');
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var logClient = new logger$1.Logger('@firebase/database');
	/**
	 * Returns a locally-unique ID (generated by just incrementing up from 0 each time its called).
	 * @type {function(): number} Generated ID.
	 */
	var LUIDGenerator = (function () {
	    var id = 1;
	    return function () {
	        return id++;
	    };
	})();
	/**
	 * Sha1 hash of the input string
	 * @param {!string} str The string to hash
	 * @return {!string} The resulting hash
	 */
	var sha1 = function (str) {
	    var utf8Bytes = util.stringToByteArray(str);
	    var sha1 = new util.Sha1();
	    sha1.update(utf8Bytes);
	    var sha1Bytes = sha1.digest();
	    return util.base64.encodeByteArray(sha1Bytes);
	};
	/**
	 * @param {...*} varArgs
	 * @return {string}
	 * @private
	 */
	var buildLogMessage_ = function () {
	    var varArgs = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        varArgs[_i] = arguments[_i];
	    }
	    var message = '';
	    for (var i = 0; i < varArgs.length; i++) {
	        var arg = varArgs[i];
	        if (Array.isArray(arg) ||
	            (arg &&
	                typeof arg === 'object' &&
	                // eslint-disable-next-line @typescript-eslint/no-explicit-any
	                typeof arg.length === 'number')) {
	            message += buildLogMessage_.apply(null, arg);
	        }
	        else if (typeof arg === 'object') {
	            message += util.stringify(arg);
	        }
	        else {
	            message += arg;
	        }
	        message += ' ';
	    }
	    return message;
	};
	/**
	 * Use this for all debug messages in Firebase.
	 * @type {?function(string)}
	 */
	var logger = null;
	/**
	 * Flag to check for log availability on first log message
	 * @type {boolean}
	 * @private
	 */
	var firstLog_ = true;
	/**
	 * The implementation of Firebase.enableLogging (defined here to break dependencies)
	 * @param {boolean|?function(string)} logger_ A flag to turn on logging, or a custom logger
	 * @param {boolean=} persistent Whether or not to persist logging settings across refreshes
	 */
	var enableLogging = function (logger_, persistent) {
	    util.assert(!persistent || logger_ === true || logger_ === false, "Can't turn on custom loggers persistently.");
	    if (logger_ === true) {
	        logClient.logLevel = logger$1.LogLevel.VERBOSE;
	        logger = logClient.log.bind(logClient);
	        if (persistent) {
	            SessionStorage.set('logging_enabled', true);
	        }
	    }
	    else if (typeof logger_ === 'function') {
	        logger = logger_;
	    }
	    else {
	        logger = null;
	        SessionStorage.remove('logging_enabled');
	    }
	};
	/**
	 *
	 * @param {...(string|Arguments)} varArgs
	 */
	var log = function () {
	    var varArgs = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        varArgs[_i] = arguments[_i];
	    }
	    if (firstLog_ === true) {
	        firstLog_ = false;
	        if (logger === null && SessionStorage.get('logging_enabled') === true) {
	            enableLogging(true);
	        }
	    }
	    if (logger) {
	        var message = buildLogMessage_.apply(null, varArgs);
	        logger(message);
	    }
	};
	/**
	 * @param {!string} prefix
	 * @return {function(...[*])}
	 */
	var logWrapper = function (prefix) {
	    return function () {
	        var varArgs = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            varArgs[_i] = arguments[_i];
	        }
	        log.apply(void 0, tslib.__spread([prefix], varArgs));
	    };
	};
	/**
	 * @param {...string} varArgs
	 */
	var error = function () {
	    var varArgs = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        varArgs[_i] = arguments[_i];
	    }
	    var message = 'FIREBASE INTERNAL ERROR: ' + buildLogMessage_.apply(void 0, tslib.__spread(varArgs));
	    logClient.error(message);
	};
	/**
	 * @param {...string} varArgs
	 */
	var fatal = function () {
	    var varArgs = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        varArgs[_i] = arguments[_i];
	    }
	    var message = "FIREBASE FATAL ERROR: " + buildLogMessage_.apply(void 0, tslib.__spread(varArgs));
	    logClient.error(message);
	    throw new Error(message);
	};
	/**
	 * @param {...*} varArgs
	 */
	var warn = function () {
	    var varArgs = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        varArgs[_i] = arguments[_i];
	    }
	    var message = 'FIREBASE WARNING: ' + buildLogMessage_.apply(void 0, tslib.__spread(varArgs));
	    logClient.warn(message);
	};
	/**
	 * Logs a warning if the containing page uses https. Called when a call to new Firebase
	 * does not use https.
	 */
	var warnIfPageIsSecure = function () {
	    // Be very careful accessing browser globals. Who knows what may or may not exist.
	    if (typeof window !== 'undefined' &&
	        window.location &&
	        window.location.protocol &&
	        window.location.protocol.indexOf('https:') !== -1) {
	        warn('Insecure Firebase access from a secure page. ' +
	            'Please use https in calls to new Firebase().');
	    }
	};
	/**
	 * Returns true if data is NaN, or +/- Infinity.
	 * @param {*} data
	 * @return {boolean}
	 */
	var isInvalidJSONNumber = function (data) {
	    return (typeof data === 'number' &&
	        (data !== data || // NaN
	            data === Number.POSITIVE_INFINITY ||
	            data === Number.NEGATIVE_INFINITY));
	};
	/**
	 * @param {function()} fn
	 */
	var executeWhenDOMReady = function (fn) {
	    if (util.isNodeSdk() || document.readyState === 'complete') {
	        fn();
	    }
	    else {
	        // Modeled after jQuery. Try DOMContentLoaded and onreadystatechange (which
	        // fire before onload), but fall back to onload.
	        var called_1 = false;
	        var wrappedFn_1 = function () {
	            if (!document.body) {
	                setTimeout(wrappedFn_1, Math.floor(10));
	                return;
	            }
	            if (!called_1) {
	                called_1 = true;
	                fn();
	            }
	        };
	        if (document.addEventListener) {
	            document.addEventListener('DOMContentLoaded', wrappedFn_1, false);
	            // fallback to onload.
	            window.addEventListener('load', wrappedFn_1, false);
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        }
	        else if (document.attachEvent) {
	            // IE.
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	            document.attachEvent('onreadystatechange', function () {
	                if (document.readyState === 'complete') {
	                    wrappedFn_1();
	                }
	            });
	            // fallback to onload.
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	            window.attachEvent('onload', wrappedFn_1);
	            // jQuery has an extra hack for IE that we could employ (based on
	            // http://javascript.nwbox.com/IEContentLoaded/) But it looks really old.
	            // I'm hoping we don't need it.
	        }
	    }
	};
	/**
	 * Minimum key name. Invalid for actual data, used as a marker to sort before any valid names
	 * @type {!string}
	 */
	var MIN_NAME = '[MIN_NAME]';
	/**
	 * Maximum key name. Invalid for actual data, used as a marker to sort above any valid names
	 * @type {!string}
	 */
	var MAX_NAME = '[MAX_NAME]';
	/**
	 * Compares valid Firebase key names, plus min and max name
	 * @param {!string} a
	 * @param {!string} b
	 * @return {!number}
	 */
	var nameCompare = function (a, b) {
	    if (a === b) {
	        return 0;
	    }
	    else if (a === MIN_NAME || b === MAX_NAME) {
	        return -1;
	    }
	    else if (b === MIN_NAME || a === MAX_NAME) {
	        return 1;
	    }
	    else {
	        var aAsInt = tryParseInt(a), bAsInt = tryParseInt(b);
	        if (aAsInt !== null) {
	            if (bAsInt !== null) {
	                return aAsInt - bAsInt === 0 ? a.length - b.length : aAsInt - bAsInt;
	            }
	            else {
	                return -1;
	            }
	        }
	        else if (bAsInt !== null) {
	            return 1;
	        }
	        else {
	            return a < b ? -1 : 1;
	        }
	    }
	};
	/**
	 * @param {!string} a
	 * @param {!string} b
	 * @return {!number} comparison result.
	 */
	var stringCompare = function (a, b) {
	    if (a === b) {
	        return 0;
	    }
	    else if (a < b) {
	        return -1;
	    }
	    else {
	        return 1;
	    }
	};
	/**
	 * @param {string} key
	 * @param {Object} obj
	 * @return {*}
	 */
	var requireKey = function (key, obj) {
	    if (obj && key in obj) {
	        return obj[key];
	    }
	    else {
	        throw new Error('Missing required key (' + key + ') in object: ' + util.stringify(obj));
	    }
	};
	/**
	 * @param {*} obj
	 * @return {string}
	 */
	var ObjectToUniqueKey = function (obj) {
	    if (typeof obj !== 'object' || obj === null) {
	        return util.stringify(obj);
	    }
	    var keys = [];
	    // eslint-disable-next-line guard-for-in
	    for (var k in obj) {
	        keys.push(k);
	    }
	    // Export as json, but with the keys sorted.
	    keys.sort();
	    var key = '{';
	    for (var i = 0; i < keys.length; i++) {
	        if (i !== 0) {
	            key += ',';
	        }
	        key += util.stringify(keys[i]);
	        key += ':';
	        key += ObjectToUniqueKey(obj[keys[i]]);
	    }
	    key += '}';
	    return key;
	};
	/**
	 * Splits a string into a number of smaller segments of maximum size
	 * @param {!string} str The string
	 * @param {!number} segsize The maximum number of chars in the string.
	 * @return {Array.<string>} The string, split into appropriately-sized chunks
	 */
	var splitStringBySize = function (str, segsize) {
	    var len = str.length;
	    if (len <= segsize) {
	        return [str];
	    }
	    var dataSegs = [];
	    for (var c = 0; c < len; c += segsize) {
	        if (c + segsize > len) {
	            dataSegs.push(str.substring(c, len));
	        }
	        else {
	            dataSegs.push(str.substring(c, c + segsize));
	        }
	    }
	    return dataSegs;
	};
	/**
	 * Apply a function to each (key, value) pair in an object or
	 * apply a function to each (index, value) pair in an array
	 * @param obj The object or array to iterate over
	 * @param fn The function to apply
	 */
	function each(obj, fn) {
	    for (var key in obj) {
	        if (obj.hasOwnProperty(key)) {
	            fn(key, obj[key]);
	        }
	    }
	}
	/**
	 * Borrowed from http://hg.secondlife.com/llsd/src/tip/js/typedarray.js (MIT License)
	 * I made one modification at the end and removed the NaN / Infinity
	 * handling (since it seemed broken [caused an overflow] and we don't need it).  See MJL comments.
	 * @param {!number} v A double
	 * @return {string}
	 */
	var doubleToIEEE754String = function (v) {
	    util.assert(!isInvalidJSONNumber(v), 'Invalid JSON number'); // MJL
	    var ebits = 11, fbits = 52;
	    var bias = (1 << (ebits - 1)) - 1;
	    var s, e, f, ln, i;
	    // Compute sign, exponent, fraction
	    // Skip NaN / Infinity handling --MJL.
	    if (v === 0) {
	        e = 0;
	        f = 0;
	        s = 1 / v === -Infinity ? 1 : 0;
	    }
	    else {
	        s = v < 0;
	        v = Math.abs(v);
	        if (v >= Math.pow(2, 1 - bias)) {
	            // Normalized
	            ln = Math.min(Math.floor(Math.log(v) / Math.LN2), bias);
	            e = ln + bias;
	            f = Math.round(v * Math.pow(2, fbits - ln) - Math.pow(2, fbits));
	        }
	        else {
	            // Denormalized
	            e = 0;
	            f = Math.round(v / Math.pow(2, 1 - bias - fbits));
	        }
	    }
	    // Pack sign, exponent, fraction
	    var bits = [];
	    for (i = fbits; i; i -= 1) {
	        bits.push(f % 2 ? 1 : 0);
	        f = Math.floor(f / 2);
	    }
	    for (i = ebits; i; i -= 1) {
	        bits.push(e % 2 ? 1 : 0);
	        e = Math.floor(e / 2);
	    }
	    bits.push(s ? 1 : 0);
	    bits.reverse();
	    var str = bits.join('');
	    // Return the data as a hex string. --MJL
	    var hexByteString = '';
	    for (i = 0; i < 64; i += 8) {
	        var hexByte = parseInt(str.substr(i, 8), 2).toString(16);
	        if (hexByte.length === 1) {
	            hexByte = '0' + hexByte;
	        }
	        hexByteString = hexByteString + hexByte;
	    }
	    return hexByteString.toLowerCase();
	};
	/**
	 * Used to detect if we're in a Chrome content script (which executes in an
	 * isolated environment where long-polling doesn't work).
	 * @return {boolean}
	 */
	var isChromeExtensionContentScript = function () {
	    return !!(typeof window === 'object' &&
	        window['chrome'] &&
	        window['chrome']['extension'] &&
	        !/^chrome/.test(window.location.href));
	};
	/**
	 * Used to detect if we're in a Windows 8 Store app.
	 * @return {boolean}
	 */
	var isWindowsStoreApp = function () {
	    // Check for the presence of a couple WinRT globals
	    return typeof Windows === 'object' && typeof Windows.UI === 'object';
	};
	/**
	 * Converts a server error code to a Javascript Error
	 * @param {!string} code
	 * @param {!Query} query
	 * @return {Error}
	 */
	var errorForServerCode = function (code, query) {
	    var reason = 'Unknown Error';
	    if (code === 'too_big') {
	        reason =
	            'The data requested exceeds the maximum size ' +
	                'that can be accessed with a single request.';
	    }
	    else if (code === 'permission_denied') {
	        reason = "Client doesn't have permission to access the desired data.";
	    }
	    else if (code === 'unavailable') {
	        reason = 'The service is unavailable';
	    }
	    var error = new Error(code + ' at ' + query.path.toString() + ': ' + reason);
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    error.code = code.toUpperCase();
	    return error;
	};
	/**
	 * Used to test for integer-looking strings
	 * @type {RegExp}
	 * @private
	 */
	var INTEGER_REGEXP_ = new RegExp('^-?(0*)\\d{1,10}$');
	/**
	 * If the string contains a 32-bit integer, return it.  Else return null.
	 * @param {!string} str
	 * @return {?number}
	 */
	var tryParseInt = function (str) {
	    if (INTEGER_REGEXP_.test(str)) {
	        var intVal = Number(str);
	        if (intVal >= -2147483648 && intVal <= 2147483647) {
	            return intVal;
	        }
	    }
	    return null;
	};
	/**
	 * Helper to run some code but catch any exceptions and re-throw them later.
	 * Useful for preventing user callbacks from breaking internal code.
	 *
	 * Re-throwing the exception from a setTimeout is a little evil, but it's very
	 * convenient (we don't have to try to figure out when is a safe point to
	 * re-throw it), and the behavior seems reasonable:
	 *
	 * * If you aren't pausing on exceptions, you get an error in the console with
	 *   the correct stack trace.
	 * * If you're pausing on all exceptions, the debugger will pause on your
	 *   exception and then again when we rethrow it.
	 * * If you're only pausing on uncaught exceptions, the debugger will only pause
	 *   on us re-throwing it.
	 *
	 * @param {!function()} fn The code to guard.
	 */
	var exceptionGuard = function (fn) {
	    try {
	        fn();
	    }
	    catch (e) {
	        // Re-throw exception when it's safe.
	        setTimeout(function () {
	            // It used to be that "throw e" would result in a good console error with
	            // relevant context, but as of Chrome 39, you just get the firebase.js
	            // file/line number where we re-throw it, which is useless. So we log
	            // e.stack explicitly.
	            var stack = e.stack || '';
	            warn('Exception was thrown by user callback.', stack);
	            throw e;
	        }, Math.floor(0));
	    }
	};
	/**
	 * @return {boolean} true if we think we're currently being crawled.
	 */
	var beingCrawled = function () {
	    var userAgent = (typeof window === 'object' &&
	        window['navigator'] &&
	        window['navigator']['userAgent']) ||
	        '';
	    // For now we whitelist the most popular crawlers.  We should refine this to be the set of crawlers we
	    // believe to support JavaScript/AJAX rendering.
	    // NOTE: Google Webmaster Tools doesn't really belong, but their "This is how a visitor to your website
	    // would have seen the page" is flaky if we don't treat it as a crawler.
	    return (userAgent.search(/googlebot|google webmaster tools|bingbot|yahoo! slurp|baiduspider|yandexbot|duckduckbot/i) >= 0);
	};
	/**
	 * Same as setTimeout() except on Node.JS it will /not/ prevent the process from exiting.
	 *
	 * It is removed with clearTimeout() as normal.
	 *
	 * @param {Function} fn Function to run.
	 * @param {number} time Milliseconds to wait before running.
	 * @return {number|Object} The setTimeout() return value.
	 */
	var setTimeoutNonBlocking = function (fn, time) {
	    var timeout = setTimeout(fn, time);
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    if (typeof timeout === 'object' && timeout['unref']) {
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        timeout['unref']();
	    }
	    return timeout;
	};
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * An immutable object representing a parsed path.  It's immutable so that you
	 * can pass them around to other functions without worrying about them changing
	 * it.
	 */
	var Path = /** @class */ (function () {
	    /**
	     * @param {string|Array.<string>} pathOrString Path string to parse,
	     *      or another path, or the raw tokens array
	     * @param {number=} pieceNum
	     */
	    function Path(pathOrString, pieceNum) {
	        if (pieceNum === void 0) {
	            this.pieces_ = pathOrString.split('/');
	            // Remove empty pieces.
	            var copyTo = 0;
	            for (var i = 0; i < this.pieces_.length; i++) {
	                if (this.pieces_[i].length > 0) {
	                    this.pieces_[copyTo] = this.pieces_[i];
	                    copyTo++;
	                }
	            }
	            this.pieces_.length = copyTo;
	            this.pieceNum_ = 0;
	        }
	        else {
	            this.pieces_ = pathOrString;
	            this.pieceNum_ = pieceNum;
	        }
	    }
	    Object.defineProperty(Path, "Empty", {
	        /**
	         * Singleton to represent an empty path
	         *
	         * @const
	         */
	        get: function () {
	            return new Path('');
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Path.prototype.getFront = function () {
	        if (this.pieceNum_ >= this.pieces_.length) {
	            return null;
	        }
	        return this.pieces_[this.pieceNum_];
	    };
	    /**
	     * @return {number} The number of segments in this path
	     */
	    Path.prototype.getLength = function () {
	        return this.pieces_.length - this.pieceNum_;
	    };
	    /**
	     * @return {!Path}
	     */
	    Path.prototype.popFront = function () {
	        var pieceNum = this.pieceNum_;
	        if (pieceNum < this.pieces_.length) {
	            pieceNum++;
	        }
	        return new Path(this.pieces_, pieceNum);
	    };
	    /**
	     * @return {?string}
	     */
	    Path.prototype.getBack = function () {
	        if (this.pieceNum_ < this.pieces_.length) {
	            return this.pieces_[this.pieces_.length - 1];
	        }
	        return null;
	    };
	    Path.prototype.toString = function () {
	        var pathString = '';
	        for (var i = this.pieceNum_; i < this.pieces_.length; i++) {
	            if (this.pieces_[i] !== '') {
	                pathString += '/' + this.pieces_[i];
	            }
	        }
	        return pathString || '/';
	    };
	    Path.prototype.toUrlEncodedString = function () {
	        var pathString = '';
	        for (var i = this.pieceNum_; i < this.pieces_.length; i++) {
	            if (this.pieces_[i] !== '') {
	                pathString += '/' + encodeURIComponent(String(this.pieces_[i]));
	            }
	        }
	        return pathString || '/';
	    };
	    /**
	     * Shallow copy of the parts of the path.
	     *
	     * @param {number=} begin
	     * @return {!Array<string>}
	     */
	    Path.prototype.slice = function (begin) {
	        if (begin === void 0) { begin = 0; }
	        return this.pieces_.slice(this.pieceNum_ + begin);
	    };
	    /**
	     * @return {?Path}
	     */
	    Path.prototype.parent = function () {
	        if (this.pieceNum_ >= this.pieces_.length) {
	            return null;
	        }
	        var pieces = [];
	        for (var i = this.pieceNum_; i < this.pieces_.length - 1; i++) {
	            pieces.push(this.pieces_[i]);
	        }
	        return new Path(pieces, 0);
	    };
	    /**
	     * @param {string|!Path} childPathObj
	     * @return {!Path}
	     */
	    Path.prototype.child = function (childPathObj) {
	        var pieces = [];
	        for (var i = this.pieceNum_; i < this.pieces_.length; i++) {
	            pieces.push(this.pieces_[i]);
	        }
	        if (childPathObj instanceof Path) {
	            for (var i = childPathObj.pieceNum_; i < childPathObj.pieces_.length; i++) {
	                pieces.push(childPathObj.pieces_[i]);
	            }
	        }
	        else {
	            var childPieces = childPathObj.split('/');
	            for (var i = 0; i < childPieces.length; i++) {
	                if (childPieces[i].length > 0) {
	                    pieces.push(childPieces[i]);
	                }
	            }
	        }
	        return new Path(pieces, 0);
	    };
	    /**
	     * @return {boolean} True if there are no segments in this path
	     */
	    Path.prototype.isEmpty = function () {
	        return this.pieceNum_ >= this.pieces_.length;
	    };
	    /**
	     * @param {!Path} outerPath
	     * @param {!Path} innerPath
	     * @return {!Path} The path from outerPath to innerPath
	     */
	    Path.relativePath = function (outerPath, innerPath) {
	        var outer = outerPath.getFront(), inner = innerPath.getFront();
	        if (outer === null) {
	            return innerPath;
	        }
	        else if (outer === inner) {
	            return Path.relativePath(outerPath.popFront(), innerPath.popFront());
	        }
	        else {
	            throw new Error('INTERNAL ERROR: innerPath (' +
	                innerPath +
	                ') is not within ' +
	                'outerPath (' +
	                outerPath +
	                ')');
	        }
	    };
	    /**
	     * @param {!Path} left
	     * @param {!Path} right
	     * @return {number} -1, 0, 1 if left is less, equal, or greater than the right.
	     */
	    Path.comparePaths = function (left, right) {
	        var leftKeys = left.slice();
	        var rightKeys = right.slice();
	        for (var i = 0; i < leftKeys.length && i < rightKeys.length; i++) {
	            var cmp = nameCompare(leftKeys[i], rightKeys[i]);
	            if (cmp !== 0) {
	                return cmp;
	            }
	        }
	        if (leftKeys.length === rightKeys.length) {
	            return 0;
	        }
	        return leftKeys.length < rightKeys.length ? -1 : 1;
	    };
	    /**
	     *
	     * @param {Path} other
	     * @return {boolean} true if paths are the same.
	     */
	    Path.prototype.equals = function (other) {
	        if (this.getLength() !== other.getLength()) {
	            return false;
	        }
	        for (var i = this.pieceNum_, j = other.pieceNum_; i <= this.pieces_.length; i++, j++) {
	            if (this.pieces_[i] !== other.pieces_[j]) {
	                return false;
	            }
	        }
	        return true;
	    };
	    /**
	     *
	     * @param {!Path} other
	     * @return {boolean} True if this path is a parent (or the same as) other
	     */
	    Path.prototype.contains = function (other) {
	        var i = this.pieceNum_;
	        var j = other.pieceNum_;
	        if (this.getLength() > other.getLength()) {
	            return false;
	        }
	        while (i < this.pieces_.length) {
	            if (this.pieces_[i] !== other.pieces_[j]) {
	                return false;
	            }
	            ++i;
	            ++j;
	        }
	        return true;
	    };
	    return Path;
	}()); // end Path
	/**
	 * Dynamic (mutable) path used to count path lengths.
	 *
	 * This class is used to efficiently check paths for valid
	 * length (in UTF8 bytes) and depth (used in path validation).
	 *
	 * Throws Error exception if path is ever invalid.
	 *
	 * The definition of a path always begins with '/'.
	 */
	var ValidationPath = /** @class */ (function () {
	    /**
	     * @param {!Path} path Initial Path.
	     * @param {string} errorPrefix_ Prefix for any error messages.
	     */
	    function ValidationPath(path, errorPrefix_) {
	        this.errorPrefix_ = errorPrefix_;
	        /** @type {!Array<string>} */
	        this.parts_ = path.slice();
	        /** @type {number} Initialize to number of '/' chars needed in path. */
	        this.byteLength_ = Math.max(1, this.parts_.length);
	        for (var i = 0; i < this.parts_.length; i++) {
	            this.byteLength_ += util.stringLength(this.parts_[i]);
	        }
	        this.checkValid_();
	    }
	    Object.defineProperty(ValidationPath, "MAX_PATH_DEPTH", {
	        /** @const {number} Maximum key depth. */
	        get: function () {
	            return 32;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ValidationPath, "MAX_PATH_LENGTH_BYTES", {
	        /** @const {number} Maximum number of (UTF8) bytes in a Firebase path. */
	        get: function () {
	            return 768;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /** @param {string} child */
	    ValidationPath.prototype.push = function (child) {
	        // Count the needed '/'
	        if (this.parts_.length > 0) {
	            this.byteLength_ += 1;
	        }
	        this.parts_.push(child);
	        this.byteLength_ += util.stringLength(child);
	        this.checkValid_();
	    };
	    ValidationPath.prototype.pop = function () {
	        var last = this.parts_.pop();
	        this.byteLength_ -= util.stringLength(last);
	        // Un-count the previous '/'
	        if (this.parts_.length > 0) {
	            this.byteLength_ -= 1;
	        }
	    };
	    ValidationPath.prototype.checkValid_ = function () {
	        if (this.byteLength_ > ValidationPath.MAX_PATH_LENGTH_BYTES) {
	            throw new Error(this.errorPrefix_ +
	                'has a key path longer than ' +
	                ValidationPath.MAX_PATH_LENGTH_BYTES +
	                ' bytes (' +
	                this.byteLength_ +
	                ').');
	        }
	        if (this.parts_.length > ValidationPath.MAX_PATH_DEPTH) {
	            throw new Error(this.errorPrefix_ +
	                'path specified exceeds the maximum depth that can be written (' +
	                ValidationPath.MAX_PATH_DEPTH +
	                ') or object contains a cycle ' +
	                this.toErrorString());
	        }
	    };
	    /**
	     * String for use in error messages - uses '.' notation for path.
	     *
	     * @return {string}
	     */
	    ValidationPath.prototype.toErrorString = function () {
	        if (this.parts_.length === 0) {
	            return '';
	        }
	        return "in property '" + this.parts_.join('.') + "'";
	    };
	    return ValidationPath;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var PROTOCOL_VERSION = '5';
	var VERSION_PARAM = 'v';
	var TRANSPORT_SESSION_PARAM = 's';
	var REFERER_PARAM = 'r';
	var FORGE_REF = 'f';
	var FORGE_DOMAIN = 'firebaseio.com';
	var LAST_SESSION_PARAM = 'ls';
	var WEBSOCKET = 'websocket';
	var LONG_POLLING = 'long_polling';
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * A class that holds metadata about a Repo object
	 *
	 * @constructor
	 */
	var RepoInfo = /** @class */ (function () {
	    /**
	     * @param {string} host Hostname portion of the url for the repo
	     * @param {boolean} secure Whether or not this repo is accessed over ssl
	     * @param {string} namespace The namespace represented by the repo
	     * @param {boolean} webSocketOnly Whether to prefer websockets over all other transports (used by Nest).
	     * @param {string=} persistenceKey Override the default session persistence storage key
	     */
	    function RepoInfo(host, secure, namespace, webSocketOnly, persistenceKey, includeNamespaceInQueryParams) {
	        if (persistenceKey === void 0) { persistenceKey = ''; }
	        if (includeNamespaceInQueryParams === void 0) { includeNamespaceInQueryParams = false; }
	        this.secure = secure;
	        this.namespace = namespace;
	        this.webSocketOnly = webSocketOnly;
	        this.persistenceKey = persistenceKey;
	        this.includeNamespaceInQueryParams = includeNamespaceInQueryParams;
	        this.host = host.toLowerCase();
	        this.domain = this.host.substr(this.host.indexOf('.') + 1);
	        this.internalHost =
	            PersistentStorage.get('host:' + host) || this.host;
	    }
	    RepoInfo.prototype.needsQueryParam = function () {
	        return (this.host !== this.internalHost ||
	            this.isCustomHost() ||
	            this.includeNamespaceInQueryParams);
	    };
	    RepoInfo.prototype.isCacheableHost = function () {
	        return this.internalHost.substr(0, 2) === 's-';
	    };
	    RepoInfo.prototype.isDemoHost = function () {
	        return this.domain === 'firebaseio-demo.com';
	    };
	    RepoInfo.prototype.isCustomHost = function () {
	        return (this.domain !== 'firebaseio.com' && this.domain !== 'firebaseio-demo.com');
	    };
	    RepoInfo.prototype.updateHost = function (newHost) {
	        if (newHost !== this.internalHost) {
	            this.internalHost = newHost;
	            if (this.isCacheableHost()) {
	                PersistentStorage.set('host:' + this.host, this.internalHost);
	            }
	        }
	    };
	    /**
	     * Returns the websocket URL for this repo
	     * @param {string} type of connection
	     * @param {Object} params list
	     * @return {string} The URL for this repo
	     */
	    RepoInfo.prototype.connectionURL = function (type, params) {
	        util.assert(typeof type === 'string', 'typeof type must == string');
	        util.assert(typeof params === 'object', 'typeof params must == object');
	        var connURL;
	        if (type === WEBSOCKET) {
	            connURL =
	                (this.secure ? 'wss://' : 'ws://') + this.internalHost + '/.ws?';
	        }
	        else if (type === LONG_POLLING) {
	            connURL =
	                (this.secure ? 'https://' : 'http://') + this.internalHost + '/.lp?';
	        }
	        else {
	            throw new Error('Unknown connection type: ' + type);
	        }
	        if (this.needsQueryParam()) {
	            params['ns'] = this.namespace;
	        }
	        var pairs = [];
	        each(params, function (key, value) {
	            pairs.push(key + '=' + value);
	        });
	        return connURL + pairs.join('&');
	    };
	    /** @return {string} */
	    RepoInfo.prototype.toString = function () {
	        var str = this.toURLString();
	        if (this.persistenceKey) {
	            str += '<' + this.persistenceKey + '>';
	        }
	        return str;
	    };
	    /** @return {string} */
	    RepoInfo.prototype.toURLString = function () {
	        return (this.secure ? 'https://' : 'http://') + this.host;
	    };
	    return RepoInfo;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @param {!string} pathString
	 * @return {string}
	 */
	function decodePath(pathString) {
	    var pathStringDecoded = '';
	    var pieces = pathString.split('/');
	    for (var i = 0; i < pieces.length; i++) {
	        if (pieces[i].length > 0) {
	            var piece = pieces[i];
	            try {
	                piece = decodeURIComponent(piece.replace(/\+/g, ' '));
	            }
	            catch (e) { }
	            pathStringDecoded += '/' + piece;
	        }
	    }
	    return pathStringDecoded;
	}
	/**
	 * @param {!string} queryString
	 * @return {!{[key:string]:string}} key value hash
	 */
	function decodeQuery(queryString) {
	    var e_1, _a;
	    var results = {};
	    if (queryString.charAt(0) === '?') {
	        queryString = queryString.substring(1);
	    }
	    try {
	        for (var _b = tslib.__values(queryString.split('&')), _c = _b.next(); !_c.done; _c = _b.next()) {
	            var segment = _c.value;
	            if (segment.length === 0) {
	                continue;
	            }
	            var kv = segment.split('=');
	            if (kv.length === 2) {
	                results[decodeURIComponent(kv[0])] = decodeURIComponent(kv[1]);
	            }
	            else {
	                warn("Invalid query segment '" + segment + "' in query '" + queryString + "'");
	            }
	        }
	    }
	    catch (e_1_1) { e_1 = { error: e_1_1 }; }
	    finally {
	        try {
	            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	        }
	        finally { if (e_1) throw e_1.error; }
	    }
	    return results;
	}
	/**
	 *
	 * @param {!string} dataURL
	 * @return {{repoInfo: !RepoInfo, path: !Path}}
	 */
	var parseRepoInfo = function (dataURL) {
	    var parsedUrl = parseDatabaseURL(dataURL), namespace = parsedUrl.namespace;
	    if (parsedUrl.domain === 'firebase.com') {
	        fatal(parsedUrl.host +
	            ' is no longer supported. ' +
	            'Please use <YOUR FIREBASE>.firebaseio.com instead');
	    }
	    // Catch common error of uninitialized namespace value.
	    if ((!namespace || namespace === 'undefined') &&
	        parsedUrl.domain !== 'localhost') {
	        fatal('Cannot parse Firebase url. Please use https://<YOUR FIREBASE>.firebaseio.com');
	    }
	    if (!parsedUrl.secure) {
	        warnIfPageIsSecure();
	    }
	    var webSocketOnly = parsedUrl.scheme === 'ws' || parsedUrl.scheme === 'wss';
	    return {
	        repoInfo: new RepoInfo(parsedUrl.host, parsedUrl.secure, namespace, webSocketOnly, 
	        /*persistenceKey=*/ '', 
	        /*includeNamespaceInQueryParams=*/ namespace !== parsedUrl.subdomain),
	        path: new Path(parsedUrl.pathString)
	    };
	};
	/**
	 *
	 * @param {!string} dataURL
	 * @return {{host: string, port: number, domain: string, subdomain: string, secure: boolean, scheme: string, pathString: string, namespace: string}}
	 */
	var parseDatabaseURL = function (dataURL) {
	    // Default to empty strings in the event of a malformed string.
	    var host = '', domain = '', subdomain = '', pathString = '', namespace = '';
	    // Always default to SSL, unless otherwise specified.
	    var secure = true, scheme = 'https', port = 443;
	    // Don't do any validation here. The caller is responsible for validating the result of parsing.
	    if (typeof dataURL === 'string') {
	        // Parse scheme.
	        var colonInd = dataURL.indexOf('//');
	        if (colonInd >= 0) {
	            scheme = dataURL.substring(0, colonInd - 1);
	            dataURL = dataURL.substring(colonInd + 2);
	        }
	        // Parse host, path, and query string.
	        var slashInd = dataURL.indexOf('/');
	        if (slashInd === -1) {
	            slashInd = dataURL.length;
	        }
	        var questionMarkInd = dataURL.indexOf('?');
	        if (questionMarkInd === -1) {
	            questionMarkInd = dataURL.length;
	        }
	        host = dataURL.substring(0, Math.min(slashInd, questionMarkInd));
	        if (slashInd < questionMarkInd) {
	            // For pathString, questionMarkInd will always come after slashInd
	            pathString = decodePath(dataURL.substring(slashInd, questionMarkInd));
	        }
	        var queryParams = decodeQuery(dataURL.substring(Math.min(dataURL.length, questionMarkInd)));
	        // If we have a port, use scheme for determining if it's secure.
	        colonInd = host.indexOf(':');
	        if (colonInd >= 0) {
	            secure = scheme === 'https' || scheme === 'wss';
	            port = parseInt(host.substring(colonInd + 1), 10);
	        }
	        else {
	            colonInd = host.length;
	        }
	        var hostWithoutPort = host.slice(0, colonInd);
	        if (hostWithoutPort.toLowerCase() === 'localhost') {
	            domain = 'localhost';
	        }
	        else if (hostWithoutPort.split('.').length <= 2) {
	            domain = hostWithoutPort;
	        }
	        else {
	            // Interpret the subdomain of a 3 or more component URL as the namespace name.
	            var dotInd = host.indexOf('.');
	            subdomain = host.substring(0, dotInd).toLowerCase();
	            domain = host.substring(dotInd + 1);
	            // Normalize namespaces to lowercase to share storage / connection.
	            namespace = subdomain;
	        }
	        // Always treat the value of the `ns` as the namespace name if it is present.
	        if ('ns' in queryParams) {
	            namespace = queryParams['ns'];
	        }
	    }
	    return {
	        host: host,
	        port: port,
	        domain: domain,
	        subdomain: subdomain,
	        secure: secure,
	        scheme: scheme,
	        pathString: pathString,
	        namespace: namespace
	    };
	};
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * True for invalid Firebase keys
	 * @type {RegExp}
	 * @private
	 */
	var INVALID_KEY_REGEX_ = /[\[\].#$\/\u0000-\u001F\u007F]/;
	/**
	 * True for invalid Firebase paths.
	 * Allows '/' in paths.
	 * @type {RegExp}
	 * @private
	 */
	var INVALID_PATH_REGEX_ = /[\[\].#$\u0000-\u001F\u007F]/;
	/**
	 * Maximum number of characters to allow in leaf value
	 * @type {number}
	 * @private
	 */
	var MAX_LEAF_SIZE_ = 10 * 1024 * 1024;
	/**
	 * @param {*} key
	 * @return {boolean}
	 */
	var isValidKey = function (key) {
	    return (typeof key === 'string' && key.length !== 0 && !INVALID_KEY_REGEX_.test(key));
	};
	/**
	 * @param {string} pathString
	 * @return {boolean}
	 */
	var isValidPathString = function (pathString) {
	    return (typeof pathString === 'string' &&
	        pathString.length !== 0 &&
	        !INVALID_PATH_REGEX_.test(pathString));
	};
	/**
	 * @param {string} pathString
	 * @return {boolean}
	 */
	var isValidRootPathString = function (pathString) {
	    if (pathString) {
	        // Allow '/.info/' at the beginning.
	        pathString = pathString.replace(/^\/*\.info(\/|$)/, '/');
	    }
	    return isValidPathString(pathString);
	};
	/**
	 * @param {*} priority
	 * @return {boolean}
	 */
	var isValidPriority = function (priority) {
	    return (priority === null ||
	        typeof priority === 'string' ||
	        (typeof priority === 'number' && !isInvalidJSONNumber(priority)) ||
	        (priority &&
	            typeof priority === 'object' &&
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	            util.contains(priority, '.sv')));
	};
	/**
	 * Pre-validate a datum passed as an argument to Firebase function.
	 *
	 * @param {string} fnName
	 * @param {number} argumentNumber
	 * @param {*} data
	 * @param {!Path} path
	 * @param {boolean} optional
	 */
	var validateFirebaseDataArg = function (fnName, argumentNumber, data, path, optional) {
	    if (optional && data === undefined) {
	        return;
	    }
	    validateFirebaseData(util.errorPrefix(fnName, argumentNumber, optional), data, path);
	};
	/**
	 * Validate a data object client-side before sending to server.
	 *
	 * @param {string} errorPrefix
	 * @param {*} data
	 * @param {!Path|!ValidationPath} path_
	 */
	var validateFirebaseData = function (errorPrefix, data, path_) {
	    var path = path_ instanceof Path ? new ValidationPath(path_, errorPrefix) : path_;
	    if (data === undefined) {
	        throw new Error(errorPrefix + 'contains undefined ' + path.toErrorString());
	    }
	    if (typeof data === 'function') {
	        throw new Error(errorPrefix +
	            'contains a function ' +
	            path.toErrorString() +
	            ' with contents = ' +
	            data.toString());
	    }
	    if (isInvalidJSONNumber(data)) {
	        throw new Error(errorPrefix + 'contains ' + data.toString() + ' ' + path.toErrorString());
	    }
	    // Check max leaf size, but try to avoid the utf8 conversion if we can.
	    if (typeof data === 'string' &&
	        data.length > MAX_LEAF_SIZE_ / 3 &&
	        util.stringLength(data) > MAX_LEAF_SIZE_) {
	        throw new Error(errorPrefix +
	            'contains a string greater than ' +
	            MAX_LEAF_SIZE_ +
	            ' utf8 bytes ' +
	            path.toErrorString() +
	            " ('" +
	            data.substring(0, 50) +
	            "...')");
	    }
	    // TODO = Perf = Consider combining the recursive validation of keys into NodeFromJSON
	    // to save extra walking of large objects.
	    if (data && typeof data === 'object') {
	        var hasDotValue_1 = false;
	        var hasActualChild_1 = false;
	        each(data, function (key, value) {
	            if (key === '.value') {
	                hasDotValue_1 = true;
	            }
	            else if (key !== '.priority' && key !== '.sv') {
	                hasActualChild_1 = true;
	                if (!isValidKey(key)) {
	                    throw new Error(errorPrefix +
	                        ' contains an invalid key (' +
	                        key +
	                        ') ' +
	                        path.toErrorString() +
	                        '.  Keys must be non-empty strings ' +
	                        'and can\'t contain ".", "#", "$", "/", "[", or "]"');
	                }
	            }
	            path.push(key);
	            validateFirebaseData(errorPrefix, value, path);
	            path.pop();
	        });
	        if (hasDotValue_1 && hasActualChild_1) {
	            throw new Error(errorPrefix +
	                ' contains ".value" child ' +
	                path.toErrorString() +
	                ' in addition to actual children.');
	        }
	    }
	};
	/**
	 * Pre-validate paths passed in the firebase function.
	 *
	 * @param {string} errorPrefix
	 * @param {Array<!Path>} mergePaths
	 */
	var validateFirebaseMergePaths = function (errorPrefix, mergePaths) {
	    var i, curPath;
	    for (i = 0; i < mergePaths.length; i++) {
	        curPath = mergePaths[i];
	        var keys = curPath.slice();
	        for (var j = 0; j < keys.length; j++) {
	            if (keys[j] === '.priority' && j === keys.length - 1) ;
	            else if (!isValidKey(keys[j])) {
	                throw new Error(errorPrefix +
	                    'contains an invalid key (' +
	                    keys[j] +
	                    ') in path ' +
	                    curPath.toString() +
	                    '. Keys must be non-empty strings ' +
	                    'and can\'t contain ".", "#", "$", "/", "[", or "]"');
	            }
	        }
	    }
	    // Check that update keys are not descendants of each other.
	    // We rely on the property that sorting guarantees that ancestors come
	    // right before descendants.
	    mergePaths.sort(Path.comparePaths);
	    var prevPath = null;
	    for (i = 0; i < mergePaths.length; i++) {
	        curPath = mergePaths[i];
	        if (prevPath !== null && prevPath.contains(curPath)) {
	            throw new Error(errorPrefix +
	                'contains a path ' +
	                prevPath.toString() +
	                ' that is ancestor of another path ' +
	                curPath.toString());
	        }
	        prevPath = curPath;
	    }
	};
	/**
	 * pre-validate an object passed as an argument to firebase function (
	 * must be an object - e.g. for firebase.update()).
	 *
	 * @param {string} fnName
	 * @param {number} argumentNumber
	 * @param {*} data
	 * @param {!Path} path
	 * @param {boolean} optional
	 */
	var validateFirebaseMergeDataArg = function (fnName, argumentNumber, data, path, optional) {
	    if (optional && data === undefined) {
	        return;
	    }
	    var errorPrefix = util.errorPrefix(fnName, argumentNumber, optional);
	    if (!(data && typeof data === 'object') || Array.isArray(data)) {
	        throw new Error(errorPrefix + ' must be an object containing the children to replace.');
	    }
	    var mergePaths = [];
	    each(data, function (key, value) {
	        var curPath = new Path(key);
	        validateFirebaseData(errorPrefix, value, path.child(curPath));
	        if (curPath.getBack() === '.priority') {
	            if (!isValidPriority(value)) {
	                throw new Error(errorPrefix +
	                    "contains an invalid value for '" +
	                    curPath.toString() +
	                    "', which must be a valid " +
	                    'Firebase priority (a string, finite number, server value, or null).');
	            }
	        }
	        mergePaths.push(curPath);
	    });
	    validateFirebaseMergePaths(errorPrefix, mergePaths);
	};
	var validatePriority = function (fnName, argumentNumber, priority, optional) {
	    if (optional && priority === undefined) {
	        return;
	    }
	    if (isInvalidJSONNumber(priority)) {
	        throw new Error(util.errorPrefix(fnName, argumentNumber, optional) +
	            'is ' +
	            priority.toString() +
	            ', but must be a valid Firebase priority (a string, finite number, ' +
	            'server value, or null).');
	    }
	    // Special case to allow importing data with a .sv.
	    if (!isValidPriority(priority)) {
	        throw new Error(util.errorPrefix(fnName, argumentNumber, optional) +
	            'must be a valid Firebase priority ' +
	            '(a string, finite number, server value, or null).');
	    }
	};
	var validateEventType = function (fnName, argumentNumber, eventType, optional) {
	    if (optional && eventType === undefined) {
	        return;
	    }
	    switch (eventType) {
	        case 'value':
	        case 'child_added':
	        case 'child_removed':
	        case 'child_changed':
	        case 'child_moved':
	            break;
	        default:
	            throw new Error(util.errorPrefix(fnName, argumentNumber, optional) +
	                'must be a valid event type = "value", "child_added", "child_removed", ' +
	                '"child_changed", or "child_moved".');
	    }
	};
	var validateKey = function (fnName, argumentNumber, key, optional) {
	    if (optional && key === undefined) {
	        return;
	    }
	    if (!isValidKey(key)) {
	        throw new Error(util.errorPrefix(fnName, argumentNumber, optional) +
	            'was an invalid key = "' +
	            key +
	            '".  Firebase keys must be non-empty strings and ' +
	            'can\'t contain ".", "#", "$", "/", "[", or "]").');
	    }
	};
	var validatePathString = function (fnName, argumentNumber, pathString, optional) {
	    if (optional && pathString === undefined) {
	        return;
	    }
	    if (!isValidPathString(pathString)) {
	        throw new Error(util.errorPrefix(fnName, argumentNumber, optional) +
	            'was an invalid path = "' +
	            pathString +
	            '". Paths must be non-empty strings and ' +
	            'can\'t contain ".", "#", "$", "[", or "]"');
	    }
	};
	var validateRootPathString = function (fnName, argumentNumber, pathString, optional) {
	    if (pathString) {
	        // Allow '/.info/' at the beginning.
	        pathString = pathString.replace(/^\/*\.info(\/|$)/, '/');
	    }
	    validatePathString(fnName, argumentNumber, pathString, optional);
	};
	var validateWritablePath = function (fnName, path) {
	    if (path.getFront() === '.info') {
	        throw new Error(fnName + " failed = Can't modify data under /.info/");
	    }
	};
	var validateUrl = function (fnName, argumentNumber, parsedUrl) {
	    // TODO = Validate server better.
	    var pathString = parsedUrl.path.toString();
	    if (!(typeof parsedUrl.repoInfo.host === 'string') ||
	        parsedUrl.repoInfo.host.length === 0 ||
	        (!isValidKey(parsedUrl.repoInfo.namespace) &&
	            parsedUrl.repoInfo.host.split(':')[0] !== 'localhost') ||
	        (pathString.length !== 0 && !isValidRootPathString(pathString))) {
	        throw new Error(util.errorPrefix(fnName, argumentNumber, false) +
	            'must be a valid firebase URL and ' +
	            'the path can\'t contain ".", "#", "$", "[", or "]".');
	    }
	};
	var validateBoolean = function (fnName, argumentNumber, bool, optional) {
	    if (optional && bool === undefined) {
	        return;
	    }
	    if (typeof bool !== 'boolean') {
	        throw new Error(util.errorPrefix(fnName, argumentNumber, optional) + 'must be a boolean.');
	    }
	};
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @constructor
	 */
	var OnDisconnect = /** @class */ (function () {
	    /**
	     * @param {!Repo} repo_
	     * @param {!Path} path_
	     */
	    function OnDisconnect(repo_, path_) {
	        this.repo_ = repo_;
	        this.path_ = path_;
	    }
	    /**
	     * @param {function(?Error)=} onComplete
	     * @return {!firebase.Promise}
	     */
	    OnDisconnect.prototype.cancel = function (onComplete) {
	        util.validateArgCount('OnDisconnect.cancel', 0, 1, arguments.length);
	        util.validateCallback('OnDisconnect.cancel', 1, onComplete, true);
	        var deferred = new util.Deferred();
	        this.repo_.onDisconnectCancel(this.path_, deferred.wrapCallback(onComplete));
	        return deferred.promise;
	    };
	    /**
	     * @param {function(?Error)=} onComplete
	     * @return {!firebase.Promise}
	     */
	    OnDisconnect.prototype.remove = function (onComplete) {
	        util.validateArgCount('OnDisconnect.remove', 0, 1, arguments.length);
	        validateWritablePath('OnDisconnect.remove', this.path_);
	        util.validateCallback('OnDisconnect.remove', 1, onComplete, true);
	        var deferred = new util.Deferred();
	        this.repo_.onDisconnectSet(this.path_, null, deferred.wrapCallback(onComplete));
	        return deferred.promise;
	    };
	    /**
	     * @param {*} value
	     * @param {function(?Error)=} onComplete
	     * @return {!firebase.Promise}
	     */
	    OnDisconnect.prototype.set = function (value, onComplete) {
	        util.validateArgCount('OnDisconnect.set', 1, 2, arguments.length);
	        validateWritablePath('OnDisconnect.set', this.path_);
	        validateFirebaseDataArg('OnDisconnect.set', 1, value, this.path_, false);
	        util.validateCallback('OnDisconnect.set', 2, onComplete, true);
	        var deferred = new util.Deferred();
	        this.repo_.onDisconnectSet(this.path_, value, deferred.wrapCallback(onComplete));
	        return deferred.promise;
	    };
	    /**
	     * @param {*} value
	     * @param {number|string|null} priority
	     * @param {function(?Error)=} onComplete
	     * @return {!firebase.Promise}
	     */
	    OnDisconnect.prototype.setWithPriority = function (value, priority, onComplete) {
	        util.validateArgCount('OnDisconnect.setWithPriority', 2, 3, arguments.length);
	        validateWritablePath('OnDisconnect.setWithPriority', this.path_);
	        validateFirebaseDataArg('OnDisconnect.setWithPriority', 1, value, this.path_, false);
	        validatePriority('OnDisconnect.setWithPriority', 2, priority, false);
	        util.validateCallback('OnDisconnect.setWithPriority', 3, onComplete, true);
	        var deferred = new util.Deferred();
	        this.repo_.onDisconnectSetWithPriority(this.path_, value, priority, deferred.wrapCallback(onComplete));
	        return deferred.promise;
	    };
	    /**
	     * @param {!Object} objectToMerge
	     * @param {function(?Error)=} onComplete
	     * @return {!firebase.Promise}
	     */
	    OnDisconnect.prototype.update = function (objectToMerge, onComplete) {
	        util.validateArgCount('OnDisconnect.update', 1, 2, arguments.length);
	        validateWritablePath('OnDisconnect.update', this.path_);
	        if (Array.isArray(objectToMerge)) {
	            var newObjectToMerge = {};
	            for (var i = 0; i < objectToMerge.length; ++i) {
	                newObjectToMerge['' + i] = objectToMerge[i];
	            }
	            objectToMerge = newObjectToMerge;
	            warn('Passing an Array to firebase.database.onDisconnect().update() is deprecated. Use set() if you want to overwrite the ' +
	                'existing data, or an Object with integer keys if you really do want to only update some of the children.');
	        }
	        validateFirebaseMergeDataArg('OnDisconnect.update', 1, objectToMerge, this.path_, false);
	        util.validateCallback('OnDisconnect.update', 2, onComplete, true);
	        var deferred = new util.Deferred();
	        this.repo_.onDisconnectUpdate(this.path_, objectToMerge, deferred.wrapCallback(onComplete));
	        return deferred.promise;
	    };
	    return OnDisconnect;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var TransactionResult = /** @class */ (function () {
	    /**
	     * A type for the resolve value of Firebase.transaction.
	     * @constructor
	     * @dict
	     * @param {boolean} committed
	     * @param {DataSnapshot} snapshot
	     */
	    function TransactionResult(committed, snapshot) {
	        this.committed = committed;
	        this.snapshot = snapshot;
	    }
	    // Do not create public documentation. This is intended to make JSON serialization work but is otherwise unnecessary
	    // for end-users
	    TransactionResult.prototype.toJSON = function () {
	        util.validateArgCount('TransactionResult.toJSON', 0, 1, arguments.length);
	        return { committed: this.committed, snapshot: this.snapshot.toJSON() };
	    };
	    return TransactionResult;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Fancy ID generator that creates 20-character string identifiers with the
	 * following properties:
	 *
	 * 1. They're based on timestamp so that they sort *after* any existing ids.
	 * 2. They contain 72-bits of random data after the timestamp so that IDs won't
	 *    collide with other clients' IDs.
	 * 3. They sort *lexicographically* (so the timestamp is converted to characters
	 *    that will sort properly).
	 * 4. They're monotonically increasing. Even if you generate more than one in
	 *    the same timestamp, the latter ones will sort after the former ones. We do
	 *    this by using the previous random bits but "incrementing" them by 1 (only
	 *    in the case of a timestamp collision).
	 */
	var nextPushId = (function () {
	    // Modeled after base64 web-safe chars, but ordered by ASCII.
	    var PUSH_CHARS = '-0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ_abcdefghijklmnopqrstuvwxyz';
	    // Timestamp of last push, used to prevent local collisions if you push twice
	    // in one ms.
	    var lastPushTime = 0;
	    // We generate 72-bits of randomness which get turned into 12 characters and
	    // appended to the timestamp to prevent collisions with other clients. We
	    // store the last characters we generated because in the event of a collision,
	    // we'll use those same characters except "incremented" by one.
	    var lastRandChars = [];
	    return function (now) {
	        var duplicateTime = now === lastPushTime;
	        lastPushTime = now;
	        var i;
	        var timeStampChars = new Array(8);
	        for (i = 7; i >= 0; i--) {
	            timeStampChars[i] = PUSH_CHARS.charAt(now % 64);
	            // NOTE: Can't use << here because javascript will convert to int and lose
	            // the upper bits.
	            now = Math.floor(now / 64);
	        }
	        util.assert(now === 0, 'Cannot push at time == 0');
	        var id = timeStampChars.join('');
	        if (!duplicateTime) {
	            for (i = 0; i < 12; i++) {
	                lastRandChars[i] = Math.floor(Math.random() * 64);
	            }
	        }
	        else {
	            // If the timestamp hasn't changed since last push, use the same random
	            // number, except incremented by 1.
	            for (i = 11; i >= 0 && lastRandChars[i] === 63; i--) {
	                lastRandChars[i] = 0;
	            }
	            lastRandChars[i]++;
	        }
	        for (i = 0; i < 12; i++) {
	            id += PUSH_CHARS.charAt(lastRandChars[i]);
	        }
	        util.assert(id.length === 20, 'nextPushId: Length should be 20.');
	        return id;
	    };
	})();
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 *
	 * @param {!string} name
	 * @param {!Node} node
	 * @constructor
	 * @struct
	 */
	var NamedNode = /** @class */ (function () {
	    function NamedNode(name, node) {
	        this.name = name;
	        this.node = node;
	    }
	    /**
	     *
	     * @param {!string} name
	     * @param {!Node} node
	     * @return {NamedNode}
	     */
	    NamedNode.Wrap = function (name, node) {
	        return new NamedNode(name, node);
	    };
	    return NamedNode;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 *
	 * @constructor
	 */
	var Index = /** @class */ (function () {
	    function Index() {
	    }
	    /**
	     * @return {function(!NamedNode, !NamedNode):number} A standalone comparison function for
	     * this index
	     */
	    Index.prototype.getCompare = function () {
	        return this.compare.bind(this);
	    };
	    /**
	     * Given a before and after value for a node, determine if the indexed value has changed. Even if they are different,
	     * it's possible that the changes are isolated to parts of the snapshot that are not indexed.
	     *
	     * @param {!Node} oldNode
	     * @param {!Node} newNode
	     * @return {boolean} True if the portion of the snapshot being indexed changed between oldNode and newNode
	     */
	    Index.prototype.indexedValueChanged = function (oldNode, newNode) {
	        var oldWrapped = new NamedNode(MIN_NAME, oldNode);
	        var newWrapped = new NamedNode(MIN_NAME, newNode);
	        return this.compare(oldWrapped, newWrapped) !== 0;
	    };
	    /**
	     * @return {!NamedNode} a node wrapper that will sort equal to or less than
	     * any other node wrapper, using this index
	     */
	    Index.prototype.minPost = function () {
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        return NamedNode.MIN;
	    };
	    return Index;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var __EMPTY_NODE;
	var KeyIndex = /** @class */ (function (_super) {
	    tslib.__extends(KeyIndex, _super);
	    function KeyIndex() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    Object.defineProperty(KeyIndex, "__EMPTY_NODE", {
	        get: function () {
	            return __EMPTY_NODE;
	        },
	        set: function (val) {
	            __EMPTY_NODE = val;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @inheritDoc
	     */
	    KeyIndex.prototype.compare = function (a, b) {
	        return nameCompare(a.name, b.name);
	    };
	    /**
	     * @inheritDoc
	     */
	    KeyIndex.prototype.isDefinedOn = function (node) {
	        // We could probably return true here (since every node has a key), but it's never called
	        // so just leaving unimplemented for now.
	        throw util.assertionError('KeyIndex.isDefinedOn not expected to be called.');
	    };
	    /**
	     * @inheritDoc
	     */
	    KeyIndex.prototype.indexedValueChanged = function (oldNode, newNode) {
	        return false; // The key for a node never changes.
	    };
	    /**
	     * @inheritDoc
	     */
	    KeyIndex.prototype.minPost = function () {
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        return NamedNode.MIN;
	    };
	    /**
	     * @inheritDoc
	     */
	    KeyIndex.prototype.maxPost = function () {
	        // TODO: This should really be created once and cached in a static property, but
	        // NamedNode isn't defined yet, so I can't use it in a static.  Bleh.
	        return new NamedNode(MAX_NAME, __EMPTY_NODE);
	    };
	    /**
	     * @param {*} indexValue
	     * @param {string} name
	     * @return {!NamedNode}
	     */
	    KeyIndex.prototype.makePost = function (indexValue, name) {
	        util.assert(typeof indexValue === 'string', 'KeyIndex indexValue must always be a string.');
	        // We just use empty node, but it'll never be compared, since our comparator only looks at name.
	        return new NamedNode(indexValue, __EMPTY_NODE);
	    };
	    /**
	     * @return {!string} String representation for inclusion in a query spec
	     */
	    KeyIndex.prototype.toString = function () {
	        return '.key';
	    };
	    return KeyIndex;
	}(Index));
	var KEY_INDEX = new KeyIndex();
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var MAX_NODE;
	function setMaxNode(val) {
	    MAX_NODE = val;
	}
	/**
	 * @param {(!string|!number)} priority
	 * @return {!string}
	 */
	var priorityHashText = function (priority) {
	    if (typeof priority === 'number') {
	        return 'number:' + doubleToIEEE754String(priority);
	    }
	    else {
	        return 'string:' + priority;
	    }
	};
	/**
	 * Validates that a priority snapshot Node is valid.
	 *
	 * @param {!Node} priorityNode
	 */
	var validatePriorityNode = function (priorityNode) {
	    if (priorityNode.isLeafNode()) {
	        var val = priorityNode.val();
	        util.assert(typeof val === 'string' ||
	            typeof val === 'number' ||
	            (typeof val === 'object' && util.contains(val, '.sv')), 'Priority must be a string or number.');
	    }
	    else {
	        util.assert(priorityNode === MAX_NODE || priorityNode.isEmpty(), 'priority of unexpected type.');
	    }
	    // Don't call getPriority() on MAX_NODE to avoid hitting assertion.
	    util.assert(priorityNode === MAX_NODE || priorityNode.getPriority().isEmpty(), "Priority nodes can't have a priority of their own.");
	};
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var __childrenNodeConstructor;
	/**
	 * LeafNode is a class for storing leaf nodes in a DataSnapshot.  It
	 * implements Node and stores the value of the node (a string,
	 * number, or boolean) accessible via getValue().
	 */
	var LeafNode = /** @class */ (function () {
	    /**
	     * @implements {Node}
	     * @param {!(string|number|boolean|Object)} value_ The value to store in this leaf node.
	     *                                         The object type is possible in the event of a deferred value
	     * @param {!Node=} priorityNode_ The priority of this node.
	     */
	    function LeafNode(value_, priorityNode_) {
	        if (priorityNode_ === void 0) { priorityNode_ = LeafNode.__childrenNodeConstructor.EMPTY_NODE; }
	        this.value_ = value_;
	        this.priorityNode_ = priorityNode_;
	        this.lazyHash_ = null;
	        util.assert(this.value_ !== undefined && this.value_ !== null, "LeafNode shouldn't be created with null/undefined value.");
	        validatePriorityNode(this.priorityNode_);
	    }
	    Object.defineProperty(LeafNode, "__childrenNodeConstructor", {
	        get: function () {
	            return __childrenNodeConstructor;
	        },
	        set: function (val) {
	            __childrenNodeConstructor = val;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /** @inheritDoc */
	    LeafNode.prototype.isLeafNode = function () {
	        return true;
	    };
	    /** @inheritDoc */
	    LeafNode.prototype.getPriority = function () {
	        return this.priorityNode_;
	    };
	    /** @inheritDoc */
	    LeafNode.prototype.updatePriority = function (newPriorityNode) {
	        return new LeafNode(this.value_, newPriorityNode);
	    };
	    /** @inheritDoc */
	    LeafNode.prototype.getImmediateChild = function (childName) {
	        // Hack to treat priority as a regular child
	        if (childName === '.priority') {
	            return this.priorityNode_;
	        }
	        else {
	            return LeafNode.__childrenNodeConstructor.EMPTY_NODE;
	        }
	    };
	    /** @inheritDoc */
	    LeafNode.prototype.getChild = function (path) {
	        if (path.isEmpty()) {
	            return this;
	        }
	        else if (path.getFront() === '.priority') {
	            return this.priorityNode_;
	        }
	        else {
	            return LeafNode.__childrenNodeConstructor.EMPTY_NODE;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    LeafNode.prototype.hasChild = function () {
	        return false;
	    };
	    /** @inheritDoc */
	    LeafNode.prototype.getPredecessorChildName = function (childName, childNode) {
	        return null;
	    };
	    /** @inheritDoc */
	    LeafNode.prototype.updateImmediateChild = function (childName, newChildNode) {
	        if (childName === '.priority') {
	            return this.updatePriority(newChildNode);
	        }
	        else if (newChildNode.isEmpty() && childName !== '.priority') {
	            return this;
	        }
	        else {
	            return LeafNode.__childrenNodeConstructor.EMPTY_NODE.updateImmediateChild(childName, newChildNode).updatePriority(this.priorityNode_);
	        }
	    };
	    /** @inheritDoc */
	    LeafNode.prototype.updateChild = function (path, newChildNode) {
	        var front = path.getFront();
	        if (front === null) {
	            return newChildNode;
	        }
	        else if (newChildNode.isEmpty() && front !== '.priority') {
	            return this;
	        }
	        else {
	            util.assert(front !== '.priority' || path.getLength() === 1, '.priority must be the last token in a path');
	            return this.updateImmediateChild(front, LeafNode.__childrenNodeConstructor.EMPTY_NODE.updateChild(path.popFront(), newChildNode));
	        }
	    };
	    /** @inheritDoc */
	    LeafNode.prototype.isEmpty = function () {
	        return false;
	    };
	    /** @inheritDoc */
	    LeafNode.prototype.numChildren = function () {
	        return 0;
	    };
	    /** @inheritDoc */
	    LeafNode.prototype.forEachChild = function (index, action) {
	        return false;
	    };
	    /**
	     * @inheritDoc
	     */
	    LeafNode.prototype.val = function (exportFormat) {
	        if (exportFormat && !this.getPriority().isEmpty()) {
	            return {
	                '.value': this.getValue(),
	                '.priority': this.getPriority().val()
	            };
	        }
	        else {
	            return this.getValue();
	        }
	    };
	    /** @inheritDoc */
	    LeafNode.prototype.hash = function () {
	        if (this.lazyHash_ === null) {
	            var toHash = '';
	            if (!this.priorityNode_.isEmpty()) {
	                toHash +=
	                    'priority:' +
	                        priorityHashText(this.priorityNode_.val()) +
	                        ':';
	            }
	            var type = typeof this.value_;
	            toHash += type + ':';
	            if (type === 'number') {
	                toHash += doubleToIEEE754String(this.value_);
	            }
	            else {
	                toHash += this.value_;
	            }
	            this.lazyHash_ = sha1(toHash);
	        }
	        return this.lazyHash_;
	    };
	    /**
	     * Returns the value of the leaf node.
	     * @return {Object|string|number|boolean} The value of the node.
	     */
	    LeafNode.prototype.getValue = function () {
	        return this.value_;
	    };
	    /**
	     * @inheritDoc
	     */
	    LeafNode.prototype.compareTo = function (other) {
	        if (other === LeafNode.__childrenNodeConstructor.EMPTY_NODE) {
	            return 1;
	        }
	        else if (other instanceof LeafNode.__childrenNodeConstructor) {
	            return -1;
	        }
	        else {
	            util.assert(other.isLeafNode(), 'Unknown node type');
	            return this.compareToLeafNode_(other);
	        }
	    };
	    /**
	     * Comparison specifically for two leaf nodes
	     * @param {!LeafNode} otherLeaf
	     * @return {!number}
	     * @private
	     */
	    LeafNode.prototype.compareToLeafNode_ = function (otherLeaf) {
	        var otherLeafType = typeof otherLeaf.value_;
	        var thisLeafType = typeof this.value_;
	        var otherIndex = LeafNode.VALUE_TYPE_ORDER.indexOf(otherLeafType);
	        var thisIndex = LeafNode.VALUE_TYPE_ORDER.indexOf(thisLeafType);
	        util.assert(otherIndex >= 0, 'Unknown leaf type: ' + otherLeafType);
	        util.assert(thisIndex >= 0, 'Unknown leaf type: ' + thisLeafType);
	        if (otherIndex === thisIndex) {
	            // Same type, compare values
	            if (thisLeafType === 'object') {
	                // Deferred value nodes are all equal, but we should also never get to this point...
	                return 0;
	            }
	            else {
	                // Note that this works because true > false, all others are number or string comparisons
	                if (this.value_ < otherLeaf.value_) {
	                    return -1;
	                }
	                else if (this.value_ === otherLeaf.value_) {
	                    return 0;
	                }
	                else {
	                    return 1;
	                }
	            }
	        }
	        else {
	            return thisIndex - otherIndex;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    LeafNode.prototype.withIndex = function () {
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    LeafNode.prototype.isIndexed = function () {
	        return true;
	    };
	    /**
	     * @inheritDoc
	     */
	    LeafNode.prototype.equals = function (other) {
	        /**
	         * @inheritDoc
	         */
	        if (other === this) {
	            return true;
	        }
	        else if (other.isLeafNode()) {
	            var otherLeaf = other;
	            return (this.value_ === otherLeaf.value_ &&
	                this.priorityNode_.equals(otherLeaf.priorityNode_));
	        }
	        else {
	            return false;
	        }
	    };
	    /**
	     * The sort order for comparing leaf nodes of different types. If two leaf nodes have
	     * the same type, the comparison falls back to their value
	     * @type {Array.<!string>}
	     * @const
	     */
	    LeafNode.VALUE_TYPE_ORDER = ['object', 'boolean', 'number', 'string'];
	    return LeafNode;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var nodeFromJSON;
	var MAX_NODE$1;
	function setNodeFromJSON(val) {
	    nodeFromJSON = val;
	}
	function setMaxNode$1(val) {
	    MAX_NODE$1 = val;
	}
	/**
	 * @constructor
	 * @extends {Index}
	 * @private
	 */
	var PriorityIndex = /** @class */ (function (_super) {
	    tslib.__extends(PriorityIndex, _super);
	    function PriorityIndex() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * @inheritDoc
	     */
	    PriorityIndex.prototype.compare = function (a, b) {
	        var aPriority = a.node.getPriority();
	        var bPriority = b.node.getPriority();
	        var indexCmp = aPriority.compareTo(bPriority);
	        if (indexCmp === 0) {
	            return nameCompare(a.name, b.name);
	        }
	        else {
	            return indexCmp;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    PriorityIndex.prototype.isDefinedOn = function (node) {
	        return !node.getPriority().isEmpty();
	    };
	    /**
	     * @inheritDoc
	     */
	    PriorityIndex.prototype.indexedValueChanged = function (oldNode, newNode) {
	        return !oldNode.getPriority().equals(newNode.getPriority());
	    };
	    /**
	     * @inheritDoc
	     */
	    PriorityIndex.prototype.minPost = function () {
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        return NamedNode.MIN;
	    };
	    /**
	     * @inheritDoc
	     */
	    PriorityIndex.prototype.maxPost = function () {
	        return new NamedNode(MAX_NAME, new LeafNode('[PRIORITY-POST]', MAX_NODE$1));
	    };
	    /**
	     * @param {*} indexValue
	     * @param {string} name
	     * @return {!NamedNode}
	     */
	    PriorityIndex.prototype.makePost = function (indexValue, name) {
	        var priorityNode = nodeFromJSON(indexValue);
	        return new NamedNode(name, new LeafNode('[PRIORITY-POST]', priorityNode));
	    };
	    /**
	     * @return {!string} String representation for inclusion in a query spec
	     */
	    PriorityIndex.prototype.toString = function () {
	        return '.priority';
	    };
	    return PriorityIndex;
	}(Index));
	var PRIORITY_INDEX = new PriorityIndex();
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * An iterator over an LLRBNode.
	 */
	var SortedMapIterator = /** @class */ (function () {
	    /**
	     * @template K, V, T
	     * @param {LLRBNode|LLRBEmptyNode} node Node to iterate.
	     * @param {?K} startKey
	     * @param {function(K, K): number} comparator
	     * @param {boolean} isReverse_ Whether or not to iterate in reverse
	     * @param {(function(K, V):T)=} resultGenerator_
	     */
	    function SortedMapIterator(node, startKey, comparator, isReverse_, resultGenerator_) {
	        if (resultGenerator_ === void 0) { resultGenerator_ = null; }
	        this.isReverse_ = isReverse_;
	        this.resultGenerator_ = resultGenerator_;
	        /** @private
	         * @type {Array.<!LLRBNode>}
	         */
	        this.nodeStack_ = [];
	        var cmp = 1;
	        while (!node.isEmpty()) {
	            node = node;
	            cmp = startKey ? comparator(node.key, startKey) : 1;
	            // flip the comparison if we're going in reverse
	            if (isReverse_) {
	                cmp *= -1;
	            }
	            if (cmp < 0) {
	                // This node is less than our start key. ignore it
	                if (this.isReverse_) {
	                    node = node.left;
	                }
	                else {
	                    node = node.right;
	                }
	            }
	            else if (cmp === 0) {
	                // This node is exactly equal to our start key. Push it on the stack, but stop iterating;
	                this.nodeStack_.push(node);
	                break;
	            }
	            else {
	                // This node is greater than our start key, add it to the stack and move to the next one
	                this.nodeStack_.push(node);
	                if (this.isReverse_) {
	                    node = node.right;
	                }
	                else {
	                    node = node.left;
	                }
	            }
	        }
	    }
	    SortedMapIterator.prototype.getNext = function () {
	        if (this.nodeStack_.length === 0) {
	            return null;
	        }
	        var node = this.nodeStack_.pop();
	        var result;
	        if (this.resultGenerator_) {
	            result = this.resultGenerator_(node.key, node.value);
	        }
	        else {
	            result = { key: node.key, value: node.value };
	        }
	        if (this.isReverse_) {
	            node = node.left;
	            while (!node.isEmpty()) {
	                this.nodeStack_.push(node);
	                node = node.right;
	            }
	        }
	        else {
	            node = node.right;
	            while (!node.isEmpty()) {
	                this.nodeStack_.push(node);
	                node = node.left;
	            }
	        }
	        return result;
	    };
	    SortedMapIterator.prototype.hasNext = function () {
	        return this.nodeStack_.length > 0;
	    };
	    SortedMapIterator.prototype.peek = function () {
	        if (this.nodeStack_.length === 0) {
	            return null;
	        }
	        var node = this.nodeStack_[this.nodeStack_.length - 1];
	        if (this.resultGenerator_) {
	            return this.resultGenerator_(node.key, node.value);
	        }
	        else {
	            return { key: node.key, value: node.value };
	        }
	    };
	    return SortedMapIterator;
	}());
	/**
	 * Represents a node in a Left-leaning Red-Black tree.
	 */
	var LLRBNode = /** @class */ (function () {
	    /**
	     * @template K, V
	     * @param {!K} key Key associated with this node.
	     * @param {!V} value Value associated with this node.
	     * @param {?boolean} color Whether this node is red.
	     * @param {?(LLRBNode|LLRBEmptyNode)=} left Left child.
	     * @param {?(LLRBNode|LLRBEmptyNode)=} right Right child.
	     */
	    function LLRBNode(key, value, color, left, right) {
	        this.key = key;
	        this.value = value;
	        this.color = color != null ? color : LLRBNode.RED;
	        this.left =
	            left != null ? left : SortedMap.EMPTY_NODE;
	        this.right =
	            right != null ? right : SortedMap.EMPTY_NODE;
	    }
	    /**
	     * Returns a copy of the current node, optionally replacing pieces of it.
	     *
	     * @param {?K} key New key for the node, or null.
	     * @param {?V} value New value for the node, or null.
	     * @param {?boolean} color New color for the node, or null.
	     * @param {?LLRBNode|LLRBEmptyNode} left New left child for the node, or null.
	     * @param {?LLRBNode|LLRBEmptyNode} right New right child for the node, or null.
	     * @return {!LLRBNode} The node copy.
	     */
	    LLRBNode.prototype.copy = function (key, value, color, left, right) {
	        return new LLRBNode(key != null ? key : this.key, value != null ? value : this.value, color != null ? color : this.color, left != null ? left : this.left, right != null ? right : this.right);
	    };
	    /**
	     * @return {number} The total number of nodes in the tree.
	     */
	    LLRBNode.prototype.count = function () {
	        return this.left.count() + 1 + this.right.count();
	    };
	    /**
	     * @return {boolean} True if the tree is empty.
	     */
	    LLRBNode.prototype.isEmpty = function () {
	        return false;
	    };
	    /**
	     * Traverses the tree in key order and calls the specified action function
	     * for each node.
	     *
	     * @param {function(!K, !V):*} action Callback function to be called for each
	     *   node.  If it returns true, traversal is aborted.
	     * @return {*} The first truthy value returned by action, or the last falsey
	     *   value returned by action
	     */
	    LLRBNode.prototype.inorderTraversal = function (action) {
	        return (this.left.inorderTraversal(action) ||
	            !!action(this.key, this.value) ||
	            this.right.inorderTraversal(action));
	    };
	    /**
	     * Traverses the tree in reverse key order and calls the specified action function
	     * for each node.
	     *
	     * @param {function(!Object, !Object)} action Callback function to be called for each
	     * node.  If it returns true, traversal is aborted.
	     * @return {*} True if traversal was aborted.
	     */
	    LLRBNode.prototype.reverseTraversal = function (action) {
	        return (this.right.reverseTraversal(action) ||
	            action(this.key, this.value) ||
	            this.left.reverseTraversal(action));
	    };
	    /**
	     * @return {!Object} The minimum node in the tree.
	     * @private
	     */
	    LLRBNode.prototype.min_ = function () {
	        if (this.left.isEmpty()) {
	            return this;
	        }
	        else {
	            return this.left.min_();
	        }
	    };
	    /**
	     * @return {!K} The maximum key in the tree.
	     */
	    LLRBNode.prototype.minKey = function () {
	        return this.min_().key;
	    };
	    /**
	     * @return {!K} The maximum key in the tree.
	     */
	    LLRBNode.prototype.maxKey = function () {
	        if (this.right.isEmpty()) {
	            return this.key;
	        }
	        else {
	            return this.right.maxKey();
	        }
	    };
	    /**
	     *
	     * @param {!Object} key Key to insert.
	     * @param {!Object} value Value to insert.
	     * @param {Comparator} comparator Comparator.
	     * @return {!LLRBNode} New tree, with the key/value added.
	     */
	    LLRBNode.prototype.insert = function (key, value, comparator) {
	        var n = this;
	        var cmp = comparator(key, n.key);
	        if (cmp < 0) {
	            n = n.copy(null, null, null, n.left.insert(key, value, comparator), null);
	        }
	        else if (cmp === 0) {
	            n = n.copy(null, value, null, null, null);
	        }
	        else {
	            n = n.copy(null, null, null, null, n.right.insert(key, value, comparator));
	        }
	        return n.fixUp_();
	    };
	    /**
	     * @private
	     * @return {!LLRBNode|LLRBEmptyNode} New tree, with the minimum key removed.
	     */
	    LLRBNode.prototype.removeMin_ = function () {
	        if (this.left.isEmpty()) {
	            return SortedMap.EMPTY_NODE;
	        }
	        var n = this;
	        if (!n.left.isRed_() && !n.left.left.isRed_()) {
	            n = n.moveRedLeft_();
	        }
	        n = n.copy(null, null, null, n.left.removeMin_(), null);
	        return n.fixUp_();
	    };
	    /**
	     * @param {!Object} key The key of the item to remove.
	     * @param {Comparator} comparator Comparator.
	     * @return {!LLRBNode|LLRBEmptyNode} New tree, with the specified item removed.
	     */
	    LLRBNode.prototype.remove = function (key, comparator) {
	        var n, smallest;
	        n = this;
	        if (comparator(key, n.key) < 0) {
	            if (!n.left.isEmpty() && !n.left.isRed_() && !n.left.left.isRed_()) {
	                n = n.moveRedLeft_();
	            }
	            n = n.copy(null, null, null, n.left.remove(key, comparator), null);
	        }
	        else {
	            if (n.left.isRed_()) {
	                n = n.rotateRight_();
	            }
	            if (!n.right.isEmpty() && !n.right.isRed_() && !n.right.left.isRed_()) {
	                n = n.moveRedRight_();
	            }
	            if (comparator(key, n.key) === 0) {
	                if (n.right.isEmpty()) {
	                    return SortedMap.EMPTY_NODE;
	                }
	                else {
	                    smallest = n.right.min_();
	                    n = n.copy(smallest.key, smallest.value, null, null, n.right.removeMin_());
	                }
	            }
	            n = n.copy(null, null, null, null, n.right.remove(key, comparator));
	        }
	        return n.fixUp_();
	    };
	    /**
	     * @private
	     * @return {boolean} Whether this is a RED node.
	     */
	    LLRBNode.prototype.isRed_ = function () {
	        return this.color;
	    };
	    /**
	     * @private
	     * @return {!LLRBNode} New tree after performing any needed rotations.
	     */
	    LLRBNode.prototype.fixUp_ = function () {
	        var n = this;
	        if (n.right.isRed_() && !n.left.isRed_()) {
	            n = n.rotateLeft_();
	        }
	        if (n.left.isRed_() && n.left.left.isRed_()) {
	            n = n.rotateRight_();
	        }
	        if (n.left.isRed_() && n.right.isRed_()) {
	            n = n.colorFlip_();
	        }
	        return n;
	    };
	    /**
	     * @private
	     * @return {!LLRBNode} New tree, after moveRedLeft.
	     */
	    LLRBNode.prototype.moveRedLeft_ = function () {
	        var n = this.colorFlip_();
	        if (n.right.left.isRed_()) {
	            n = n.copy(null, null, null, null, n.right.rotateRight_());
	            n = n.rotateLeft_();
	            n = n.colorFlip_();
	        }
	        return n;
	    };
	    /**
	     * @private
	     * @return {!LLRBNode} New tree, after moveRedRight.
	     */
	    LLRBNode.prototype.moveRedRight_ = function () {
	        var n = this.colorFlip_();
	        if (n.left.left.isRed_()) {
	            n = n.rotateRight_();
	            n = n.colorFlip_();
	        }
	        return n;
	    };
	    /**
	     * @private
	     * @return {!LLRBNode} New tree, after rotateLeft.
	     */
	    LLRBNode.prototype.rotateLeft_ = function () {
	        var nl = this.copy(null, null, LLRBNode.RED, null, this.right.left);
	        return this.right.copy(null, null, this.color, nl, null);
	    };
	    /**
	     * @private
	     * @return {!LLRBNode} New tree, after rotateRight.
	     */
	    LLRBNode.prototype.rotateRight_ = function () {
	        var nr = this.copy(null, null, LLRBNode.RED, this.left.right, null);
	        return this.left.copy(null, null, this.color, null, nr);
	    };
	    /**
	     * @private
	     * @return {!LLRBNode} New tree, after colorFlip.
	     */
	    LLRBNode.prototype.colorFlip_ = function () {
	        var left = this.left.copy(null, null, !this.left.color, null, null);
	        var right = this.right.copy(null, null, !this.right.color, null, null);
	        return this.copy(null, null, !this.color, left, right);
	    };
	    /**
	     * For testing.
	     *
	     * @private
	     * @return {boolean} True if all is well.
	     */
	    LLRBNode.prototype.checkMaxDepth_ = function () {
	        var blackDepth = this.check_();
	        return Math.pow(2.0, blackDepth) <= this.count() + 1;
	    };
	    /**
	     * @private
	     * @return {number} Not sure what this returns exactly. :-).
	     */
	    LLRBNode.prototype.check_ = function () {
	        if (this.isRed_() && this.left.isRed_()) {
	            throw new Error('Red node has red child(' + this.key + ',' + this.value + ')');
	        }
	        if (this.right.isRed_()) {
	            throw new Error('Right child of (' + this.key + ',' + this.value + ') is red');
	        }
	        var blackDepth = this.left.check_();
	        if (blackDepth !== this.right.check_()) {
	            throw new Error('Black depths differ');
	        }
	        else {
	            return blackDepth + (this.isRed_() ? 0 : 1);
	        }
	    };
	    LLRBNode.RED = true;
	    LLRBNode.BLACK = false;
	    return LLRBNode;
	}());
	/**
	 * Represents an empty node (a leaf node in the Red-Black Tree).
	 */
	var LLRBEmptyNode = /** @class */ (function () {
	    function LLRBEmptyNode() {
	    }
	    /**
	     * Returns a copy of the current node.
	     *
	     * @return {!LLRBEmptyNode} The node copy.
	     */
	    LLRBEmptyNode.prototype.copy = function (key, value, color, left, right) {
	        return this;
	    };
	    /**
	     * Returns a copy of the tree, with the specified key/value added.
	     *
	     * @param {!K} key Key to be added.
	     * @param {!V} value Value to be added.
	     * @param {Comparator} comparator Comparator.
	     * @return {!LLRBNode} New tree, with item added.
	     */
	    LLRBEmptyNode.prototype.insert = function (key, value, comparator) {
	        return new LLRBNode(key, value, null);
	    };
	    /**
	     * Returns a copy of the tree, with the specified key removed.
	     *
	     * @param {!K} key The key to remove.
	     * @param {Comparator} comparator Comparator.
	     * @return {!LLRBEmptyNode} New tree, with item removed.
	     */
	    LLRBEmptyNode.prototype.remove = function (key, comparator) {
	        return this;
	    };
	    /**
	     * @return {number} The total number of nodes in the tree.
	     */
	    LLRBEmptyNode.prototype.count = function () {
	        return 0;
	    };
	    /**
	     * @return {boolean} True if the tree is empty.
	     */
	    LLRBEmptyNode.prototype.isEmpty = function () {
	        return true;
	    };
	    /**
	     * Traverses the tree in key order and calls the specified action function
	     * for each node.
	     *
	     * @param {function(!K, !V):*} action Callback function to be called for each
	     * node.  If it returns true, traversal is aborted.
	     * @return {boolean} True if traversal was aborted.
	     */
	    LLRBEmptyNode.prototype.inorderTraversal = function (action) {
	        return false;
	    };
	    /**
	     * Traverses the tree in reverse key order and calls the specified action function
	     * for each node.
	     *
	     * @param {function(!K, !V)} action Callback function to be called for each
	     * node.  If it returns true, traversal is aborted.
	     * @return {boolean} True if traversal was aborted.
	     */
	    LLRBEmptyNode.prototype.reverseTraversal = function (action) {
	        return false;
	    };
	    /**
	     * @return {null}
	     */
	    LLRBEmptyNode.prototype.minKey = function () {
	        return null;
	    };
	    /**
	     * @return {null}
	     */
	    LLRBEmptyNode.prototype.maxKey = function () {
	        return null;
	    };
	    /**
	     * @private
	     * @return {number} Not sure what this returns exactly. :-).
	     */
	    LLRBEmptyNode.prototype.check_ = function () {
	        return 0;
	    };
	    /**
	     * @private
	     * @return {boolean} Whether this node is red.
	     */
	    LLRBEmptyNode.prototype.isRed_ = function () {
	        return false;
	    };
	    return LLRBEmptyNode;
	}());
	/**
	 * An immutable sorted map implementation, based on a Left-leaning Red-Black
	 * tree.
	 */
	var SortedMap = /** @class */ (function () {
	    /**
	     * @template K, V
	     * @param {function(K, K):number} comparator_ Key comparator.
	     * @param {LLRBNode=} root_ (Optional) Root node for the map.
	     */
	    function SortedMap(comparator_, root_) {
	        if (root_ === void 0) { root_ = SortedMap.EMPTY_NODE; }
	        this.comparator_ = comparator_;
	        this.root_ = root_;
	    }
	    /**
	     * Returns a copy of the map, with the specified key/value added or replaced.
	     * (TODO: We should perhaps rename this method to 'put')
	     *
	     * @param {!K} key Key to be added.
	     * @param {!V} value Value to be added.
	     * @return {!SortedMap.<K, V>} New map, with item added.
	     */
	    SortedMap.prototype.insert = function (key, value) {
	        return new SortedMap(this.comparator_, this.root_
	            .insert(key, value, this.comparator_)
	            .copy(null, null, LLRBNode.BLACK, null, null));
	    };
	    /**
	     * Returns a copy of the map, with the specified key removed.
	     *
	     * @param {!K} key The key to remove.
	     * @return {!SortedMap.<K, V>} New map, with item removed.
	     */
	    SortedMap.prototype.remove = function (key) {
	        return new SortedMap(this.comparator_, this.root_
	            .remove(key, this.comparator_)
	            .copy(null, null, LLRBNode.BLACK, null, null));
	    };
	    /**
	     * Returns the value of the node with the given key, or null.
	     *
	     * @param {!K} key The key to look up.
	     * @return {?V} The value of the node with the given key, or null if the
	     * key doesn't exist.
	     */
	    SortedMap.prototype.get = function (key) {
	        var cmp;
	        var node = this.root_;
	        while (!node.isEmpty()) {
	            cmp = this.comparator_(key, node.key);
	            if (cmp === 0) {
	                return node.value;
	            }
	            else if (cmp < 0) {
	                node = node.left;
	            }
	            else if (cmp > 0) {
	                node = node.right;
	            }
	        }
	        return null;
	    };
	    /**
	     * Returns the key of the item *before* the specified key, or null if key is the first item.
	     * @param {K} key The key to find the predecessor of
	     * @return {?K} The predecessor key.
	     */
	    SortedMap.prototype.getPredecessorKey = function (key) {
	        var cmp, node = this.root_, rightParent = null;
	        while (!node.isEmpty()) {
	            cmp = this.comparator_(key, node.key);
	            if (cmp === 0) {
	                if (!node.left.isEmpty()) {
	                    node = node.left;
	                    while (!node.right.isEmpty()) {
	                        node = node.right;
	                    }
	                    return node.key;
	                }
	                else if (rightParent) {
	                    return rightParent.key;
	                }
	                else {
	                    return null; // first item.
	                }
	            }
	            else if (cmp < 0) {
	                node = node.left;
	            }
	            else if (cmp > 0) {
	                rightParent = node;
	                node = node.right;
	            }
	        }
	        throw new Error('Attempted to find predecessor key for a nonexistent key.  What gives?');
	    };
	    /**
	     * @return {boolean} True if the map is empty.
	     */
	    SortedMap.prototype.isEmpty = function () {
	        return this.root_.isEmpty();
	    };
	    /**
	     * @return {number} The total number of nodes in the map.
	     */
	    SortedMap.prototype.count = function () {
	        return this.root_.count();
	    };
	    /**
	     * @return {?K} The minimum key in the map.
	     */
	    SortedMap.prototype.minKey = function () {
	        return this.root_.minKey();
	    };
	    /**
	     * @return {?K} The maximum key in the map.
	     */
	    SortedMap.prototype.maxKey = function () {
	        return this.root_.maxKey();
	    };
	    /**
	     * Traverses the map in key order and calls the specified action function
	     * for each key/value pair.
	     *
	     * @param {function(!K, !V):*} action Callback function to be called
	     * for each key/value pair.  If action returns true, traversal is aborted.
	     * @return {*} The first truthy value returned by action, or the last falsey
	     *   value returned by action
	     */
	    SortedMap.prototype.inorderTraversal = function (action) {
	        return this.root_.inorderTraversal(action);
	    };
	    /**
	     * Traverses the map in reverse key order and calls the specified action function
	     * for each key/value pair.
	     *
	     * @param {function(!Object, !Object)} action Callback function to be called
	     * for each key/value pair.  If action returns true, traversal is aborted.
	     * @return {*} True if the traversal was aborted.
	     */
	    SortedMap.prototype.reverseTraversal = function (action) {
	        return this.root_.reverseTraversal(action);
	    };
	    /**
	     * Returns an iterator over the SortedMap.
	     * @template T
	     * @param {(function(K, V):T)=} resultGenerator
	     * @return {SortedMapIterator.<K, V, T>} The iterator.
	     */
	    SortedMap.prototype.getIterator = function (resultGenerator) {
	        return new SortedMapIterator(this.root_, null, this.comparator_, false, resultGenerator);
	    };
	    SortedMap.prototype.getIteratorFrom = function (key, resultGenerator) {
	        return new SortedMapIterator(this.root_, key, this.comparator_, false, resultGenerator);
	    };
	    SortedMap.prototype.getReverseIteratorFrom = function (key, resultGenerator) {
	        return new SortedMapIterator(this.root_, key, this.comparator_, true, resultGenerator);
	    };
	    SortedMap.prototype.getReverseIterator = function (resultGenerator) {
	        return new SortedMapIterator(this.root_, null, this.comparator_, true, resultGenerator);
	    };
	    /**
	     * Always use the same empty node, to reduce memory.
	     * @const
	     */
	    SortedMap.EMPTY_NODE = new LLRBEmptyNode();
	    return SortedMap;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var LOG_2 = Math.log(2);
	/**
	 * @constructor
	 */
	var Base12Num = /** @class */ (function () {
	    /**
	     * @param {number} length
	     */
	    function Base12Num(length) {
	        var logBase2 = function (num) {
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	            return parseInt((Math.log(num) / LOG_2), 10);
	        };
	        var bitMask = function (bits) { return parseInt(Array(bits + 1).join('1'), 2); };
	        this.count = logBase2(length + 1);
	        this.current_ = this.count - 1;
	        var mask = bitMask(this.count);
	        this.bits_ = (length + 1) & mask;
	    }
	    /**
	     * @return {boolean}
	     */
	    Base12Num.prototype.nextBitIsOne = function () {
	        //noinspection JSBitwiseOperatorUsage
	        var result = !(this.bits_ & (0x1 << this.current_));
	        this.current_--;
	        return result;
	    };
	    return Base12Num;
	}());
	/**
	 * Takes a list of child nodes and constructs a SortedSet using the given comparison
	 * function
	 *
	 * Uses the algorithm described in the paper linked here:
	 * http://citeseerx.ist.psu.edu/viewdoc/summary?doi=10.1.1.46.1458
	 *
	 * @template K, V
	 * @param {Array.<!NamedNode>} childList Unsorted list of children
	 * @param {function(!NamedNode, !NamedNode):number} cmp The comparison method to be used
	 * @param {(function(NamedNode):K)=} keyFn An optional function to extract K from a node wrapper, if K's
	 *                                                        type is not NamedNode
	 * @param {(function(K, K):number)=} mapSortFn An optional override for comparator used by the generated sorted map
	 * @return {SortedMap.<K, V>}
	 */
	var buildChildSet = function (childList, cmp, keyFn, mapSortFn) {
	    childList.sort(cmp);
	    var buildBalancedTree = function (low, high) {
	        var length = high - low;
	        var namedNode;
	        var key;
	        if (length === 0) {
	            return null;
	        }
	        else if (length === 1) {
	            namedNode = childList[low];
	            key = keyFn ? keyFn(namedNode) : namedNode;
	            return new LLRBNode(key, namedNode.node, LLRBNode.BLACK, null, null);
	        }
	        else {
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	            var middle = parseInt((length / 2), 10) + low;
	            var left = buildBalancedTree(low, middle);
	            var right = buildBalancedTree(middle + 1, high);
	            namedNode = childList[middle];
	            key = keyFn ? keyFn(namedNode) : namedNode;
	            return new LLRBNode(key, namedNode.node, LLRBNode.BLACK, left, right);
	        }
	    };
	    var buildFrom12Array = function (base12) {
	        var node = null;
	        var root = null;
	        var index = childList.length;
	        var buildPennant = function (chunkSize, color) {
	            var low = index - chunkSize;
	            var high = index;
	            index -= chunkSize;
	            var childTree = buildBalancedTree(low + 1, high);
	            var namedNode = childList[low];
	            var key = keyFn ? keyFn(namedNode) : namedNode;
	            attachPennant(new LLRBNode(key, namedNode.node, color, null, childTree));
	        };
	        var attachPennant = function (pennant) {
	            if (node) {
	                node.left = pennant;
	                node = pennant;
	            }
	            else {
	                root = pennant;
	                node = pennant;
	            }
	        };
	        for (var i = 0; i < base12.count; ++i) {
	            var isOne = base12.nextBitIsOne();
	            // The number of nodes taken in each slice is 2^(arr.length - (i + 1))
	            var chunkSize = Math.pow(2, base12.count - (i + 1));
	            if (isOne) {
	                buildPennant(chunkSize, LLRBNode.BLACK);
	            }
	            else {
	                // current == 2
	                buildPennant(chunkSize, LLRBNode.BLACK);
	                buildPennant(chunkSize, LLRBNode.RED);
	            }
	        }
	        return root;
	    };
	    var base12 = new Base12Num(childList.length);
	    var root = buildFrom12Array(base12);
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    return new SortedMap(mapSortFn || cmp, root);
	};
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var _defaultIndexMap;
	var fallbackObject = {};
	var IndexMap = /** @class */ (function () {
	    function IndexMap(indexes_, indexSet_) {
	        this.indexes_ = indexes_;
	        this.indexSet_ = indexSet_;
	    }
	    Object.defineProperty(IndexMap, "Default", {
	        /**
	         * The default IndexMap for nodes without a priority
	         */
	        get: function () {
	            util.assert(fallbackObject && PRIORITY_INDEX, 'ChildrenNode.ts has not been loaded');
	            _defaultIndexMap =
	                _defaultIndexMap ||
	                    new IndexMap({ '.priority': fallbackObject }, { '.priority': PRIORITY_INDEX });
	            return _defaultIndexMap;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    IndexMap.prototype.get = function (indexKey) {
	        var sortedMap = util.safeGet(this.indexes_, indexKey);
	        if (!sortedMap) {
	            throw new Error('No index defined for ' + indexKey);
	        }
	        if (sortedMap instanceof SortedMap) {
	            return sortedMap;
	        }
	        else {
	            // The index exists, but it falls back to just name comparison. Return null so that the calling code uses the
	            // regular child map
	            return null;
	        }
	    };
	    IndexMap.prototype.hasIndex = function (indexDefinition) {
	        return util.contains(this.indexSet_, indexDefinition.toString());
	    };
	    IndexMap.prototype.addIndex = function (indexDefinition, existingChildren) {
	        util.assert(indexDefinition !== KEY_INDEX, "KeyIndex always exists and isn't meant to be added to the IndexMap.");
	        var childList = [];
	        var sawIndexedValue = false;
	        var iter = existingChildren.getIterator(NamedNode.Wrap);
	        var next = iter.getNext();
	        while (next) {
	            sawIndexedValue =
	                sawIndexedValue || indexDefinition.isDefinedOn(next.node);
	            childList.push(next);
	            next = iter.getNext();
	        }
	        var newIndex;
	        if (sawIndexedValue) {
	            newIndex = buildChildSet(childList, indexDefinition.getCompare());
	        }
	        else {
	            newIndex = fallbackObject;
	        }
	        var indexName = indexDefinition.toString();
	        var newIndexSet = tslib.__assign({}, this.indexSet_);
	        newIndexSet[indexName] = indexDefinition;
	        var newIndexes = tslib.__assign({}, this.indexes_);
	        newIndexes[indexName] = newIndex;
	        return new IndexMap(newIndexes, newIndexSet);
	    };
	    /**
	     * Ensure that this node is properly tracked in any indexes that we're maintaining
	     */
	    IndexMap.prototype.addToIndexes = function (namedNode, existingChildren) {
	        var _this = this;
	        var newIndexes = util.map(this.indexes_, function (indexedChildren, indexName) {
	            var index = util.safeGet(_this.indexSet_, indexName);
	            util.assert(index, 'Missing index implementation for ' + indexName);
	            if (indexedChildren === fallbackObject) {
	                // Check to see if we need to index everything
	                if (index.isDefinedOn(namedNode.node)) {
	                    // We need to build this index
	                    var childList = [];
	                    var iter = existingChildren.getIterator(NamedNode.Wrap);
	                    var next = iter.getNext();
	                    while (next) {
	                        if (next.name !== namedNode.name) {
	                            childList.push(next);
	                        }
	                        next = iter.getNext();
	                    }
	                    childList.push(namedNode);
	                    return buildChildSet(childList, index.getCompare());
	                }
	                else {
	                    // No change, this remains a fallback
	                    return fallbackObject;
	                }
	            }
	            else {
	                var existingSnap = existingChildren.get(namedNode.name);
	                var newChildren = indexedChildren;
	                if (existingSnap) {
	                    newChildren = newChildren.remove(new NamedNode(namedNode.name, existingSnap));
	                }
	                return newChildren.insert(namedNode, namedNode.node);
	            }
	        });
	        return new IndexMap(newIndexes, this.indexSet_);
	    };
	    /**
	     * Create a new IndexMap instance with the given value removed
	     */
	    IndexMap.prototype.removeFromIndexes = function (namedNode, existingChildren) {
	        var newIndexes = util.map(this.indexes_, function (indexedChildren) {
	            if (indexedChildren === fallbackObject) {
	                // This is the fallback. Just return it, nothing to do in this case
	                return indexedChildren;
	            }
	            else {
	                var existingSnap = existingChildren.get(namedNode.name);
	                if (existingSnap) {
	                    return indexedChildren.remove(new NamedNode(namedNode.name, existingSnap));
	                }
	                else {
	                    // No record of this child
	                    return indexedChildren;
	                }
	            }
	        });
	        return new IndexMap(newIndexes, this.indexSet_);
	    };
	    return IndexMap;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function NAME_ONLY_COMPARATOR(left, right) {
	    return nameCompare(left.name, right.name);
	}
	function NAME_COMPARATOR(left, right) {
	    return nameCompare(left, right);
	}
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	// TODO: For memory savings, don't store priorityNode_ if it's empty.
	var EMPTY_NODE;
	/**
	 * ChildrenNode is a class for storing internal nodes in a DataSnapshot
	 * (i.e. nodes with children).  It implements Node and stores the
	 * list of children in the children property, sorted by child name.
	 *
	 * @constructor
	 * @implements {Node}
	 */
	var ChildrenNode = /** @class */ (function () {
	    /**
	     *
	     * @param {!SortedMap.<string, !Node>} children_ List of children
	     * of this node..
	     * @param {?Node} priorityNode_ The priority of this node (as a snapshot node).
	     * @param {!IndexMap} indexMap_
	     */
	    function ChildrenNode(children_, priorityNode_, indexMap_) {
	        this.children_ = children_;
	        this.priorityNode_ = priorityNode_;
	        this.indexMap_ = indexMap_;
	        this.lazyHash_ = null;
	        /**
	         * Note: The only reason we allow null priority is for EMPTY_NODE, since we can't use
	         * EMPTY_NODE as the priority of EMPTY_NODE.  We might want to consider making EMPTY_NODE its own
	         * class instead of an empty ChildrenNode.
	         */
	        if (this.priorityNode_) {
	            validatePriorityNode(this.priorityNode_);
	        }
	        if (this.children_.isEmpty()) {
	            util.assert(!this.priorityNode_ || this.priorityNode_.isEmpty(), 'An empty node cannot have a priority');
	        }
	    }
	    Object.defineProperty(ChildrenNode, "EMPTY_NODE", {
	        get: function () {
	            return (EMPTY_NODE ||
	                (EMPTY_NODE = new ChildrenNode(new SortedMap(NAME_COMPARATOR), null, IndexMap.Default)));
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /** @inheritDoc */
	    ChildrenNode.prototype.isLeafNode = function () {
	        return false;
	    };
	    /** @inheritDoc */
	    ChildrenNode.prototype.getPriority = function () {
	        return this.priorityNode_ || EMPTY_NODE;
	    };
	    /** @inheritDoc */
	    ChildrenNode.prototype.updatePriority = function (newPriorityNode) {
	        if (this.children_.isEmpty()) {
	            // Don't allow priorities on empty nodes
	            return this;
	        }
	        else {
	            return new ChildrenNode(this.children_, newPriorityNode, this.indexMap_);
	        }
	    };
	    /** @inheritDoc */
	    ChildrenNode.prototype.getImmediateChild = function (childName) {
	        // Hack to treat priority as a regular child
	        if (childName === '.priority') {
	            return this.getPriority();
	        }
	        else {
	            var child = this.children_.get(childName);
	            return child === null ? EMPTY_NODE : child;
	        }
	    };
	    /** @inheritDoc */
	    ChildrenNode.prototype.getChild = function (path) {
	        var front = path.getFront();
	        if (front === null) {
	            return this;
	        }
	        return this.getImmediateChild(front).getChild(path.popFront());
	    };
	    /** @inheritDoc */
	    ChildrenNode.prototype.hasChild = function (childName) {
	        return this.children_.get(childName) !== null;
	    };
	    /** @inheritDoc */
	    ChildrenNode.prototype.updateImmediateChild = function (childName, newChildNode) {
	        util.assert(newChildNode, 'We should always be passing snapshot nodes');
	        if (childName === '.priority') {
	            return this.updatePriority(newChildNode);
	        }
	        else {
	            var namedNode = new NamedNode(childName, newChildNode);
	            var newChildren = void 0, newIndexMap = void 0;
	            if (newChildNode.isEmpty()) {
	                newChildren = this.children_.remove(childName);
	                newIndexMap = this.indexMap_.removeFromIndexes(namedNode, this.children_);
	            }
	            else {
	                newChildren = this.children_.insert(childName, newChildNode);
	                newIndexMap = this.indexMap_.addToIndexes(namedNode, this.children_);
	            }
	            var newPriority = newChildren.isEmpty()
	                ? EMPTY_NODE
	                : this.priorityNode_;
	            return new ChildrenNode(newChildren, newPriority, newIndexMap);
	        }
	    };
	    /** @inheritDoc */
	    ChildrenNode.prototype.updateChild = function (path, newChildNode) {
	        var front = path.getFront();
	        if (front === null) {
	            return newChildNode;
	        }
	        else {
	            util.assert(path.getFront() !== '.priority' || path.getLength() === 1, '.priority must be the last token in a path');
	            var newImmediateChild = this.getImmediateChild(front).updateChild(path.popFront(), newChildNode);
	            return this.updateImmediateChild(front, newImmediateChild);
	        }
	    };
	    /** @inheritDoc */
	    ChildrenNode.prototype.isEmpty = function () {
	        return this.children_.isEmpty();
	    };
	    /** @inheritDoc */
	    ChildrenNode.prototype.numChildren = function () {
	        return this.children_.count();
	    };
	    /** @inheritDoc */
	    ChildrenNode.prototype.val = function (exportFormat) {
	        if (this.isEmpty()) {
	            return null;
	        }
	        var obj = {};
	        var numKeys = 0, maxKey = 0, allIntegerKeys = true;
	        this.forEachChild(PRIORITY_INDEX, function (key, childNode) {
	            obj[key] = childNode.val(exportFormat);
	            numKeys++;
	            if (allIntegerKeys && ChildrenNode.INTEGER_REGEXP_.test(key)) {
	                maxKey = Math.max(maxKey, Number(key));
	            }
	            else {
	                allIntegerKeys = false;
	            }
	        });
	        if (!exportFormat && allIntegerKeys && maxKey < 2 * numKeys) {
	            // convert to array.
	            var array = [];
	            // eslint-disable-next-line guard-for-in
	            for (var key in obj) {
	                array[key] = obj[key];
	            }
	            return array;
	        }
	        else {
	            if (exportFormat && !this.getPriority().isEmpty()) {
	                obj['.priority'] = this.getPriority().val();
	            }
	            return obj;
	        }
	    };
	    /** @inheritDoc */
	    ChildrenNode.prototype.hash = function () {
	        if (this.lazyHash_ === null) {
	            var toHash_1 = '';
	            if (!this.getPriority().isEmpty()) {
	                toHash_1 +=
	                    'priority:' +
	                        priorityHashText(this.getPriority().val()) +
	                        ':';
	            }
	            this.forEachChild(PRIORITY_INDEX, function (key, childNode) {
	                var childHash = childNode.hash();
	                if (childHash !== '') {
	                    toHash_1 += ':' + key + ':' + childHash;
	                }
	            });
	            this.lazyHash_ = toHash_1 === '' ? '' : sha1(toHash_1);
	        }
	        return this.lazyHash_;
	    };
	    /** @inheritDoc */
	    ChildrenNode.prototype.getPredecessorChildName = function (childName, childNode, index) {
	        var idx = this.resolveIndex_(index);
	        if (idx) {
	            var predecessor = idx.getPredecessorKey(new NamedNode(childName, childNode));
	            return predecessor ? predecessor.name : null;
	        }
	        else {
	            return this.children_.getPredecessorKey(childName);
	        }
	    };
	    /**
	     * @param {!Index} indexDefinition
	     * @return {?string}
	     */
	    ChildrenNode.prototype.getFirstChildName = function (indexDefinition) {
	        var idx = this.resolveIndex_(indexDefinition);
	        if (idx) {
	            var minKey = idx.minKey();
	            return minKey && minKey.name;
	        }
	        else {
	            return this.children_.minKey();
	        }
	    };
	    /**
	     * @param {!Index} indexDefinition
	     * @return {?NamedNode}
	     */
	    ChildrenNode.prototype.getFirstChild = function (indexDefinition) {
	        var minKey = this.getFirstChildName(indexDefinition);
	        if (minKey) {
	            return new NamedNode(minKey, this.children_.get(minKey));
	        }
	        else {
	            return null;
	        }
	    };
	    /**
	     * Given an index, return the key name of the largest value we have, according to that index
	     * @param {!Index} indexDefinition
	     * @return {?string}
	     */
	    ChildrenNode.prototype.getLastChildName = function (indexDefinition) {
	        var idx = this.resolveIndex_(indexDefinition);
	        if (idx) {
	            var maxKey = idx.maxKey();
	            return maxKey && maxKey.name;
	        }
	        else {
	            return this.children_.maxKey();
	        }
	    };
	    /**
	     * @param {!Index} indexDefinition
	     * @return {?NamedNode}
	     */
	    ChildrenNode.prototype.getLastChild = function (indexDefinition) {
	        var maxKey = this.getLastChildName(indexDefinition);
	        if (maxKey) {
	            return new NamedNode(maxKey, this.children_.get(maxKey));
	        }
	        else {
	            return null;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    ChildrenNode.prototype.forEachChild = function (index, action) {
	        var idx = this.resolveIndex_(index);
	        if (idx) {
	            return idx.inorderTraversal(function (wrappedNode) {
	                return action(wrappedNode.name, wrappedNode.node);
	            });
	        }
	        else {
	            return this.children_.inorderTraversal(action);
	        }
	    };
	    /**
	     * @param {!Index} indexDefinition
	     * @return {SortedMapIterator}
	     */
	    ChildrenNode.prototype.getIterator = function (indexDefinition) {
	        return this.getIteratorFrom(indexDefinition.minPost(), indexDefinition);
	    };
	    /**
	     *
	     * @param {!NamedNode} startPost
	     * @param {!Index} indexDefinition
	     * @return {!SortedMapIterator}
	     */
	    ChildrenNode.prototype.getIteratorFrom = function (startPost, indexDefinition) {
	        var idx = this.resolveIndex_(indexDefinition);
	        if (idx) {
	            return idx.getIteratorFrom(startPost, function (key) { return key; });
	        }
	        else {
	            var iterator = this.children_.getIteratorFrom(startPost.name, NamedNode.Wrap);
	            var next = iterator.peek();
	            while (next != null && indexDefinition.compare(next, startPost) < 0) {
	                iterator.getNext();
	                next = iterator.peek();
	            }
	            return iterator;
	        }
	    };
	    /**
	     * @param {!Index} indexDefinition
	     * @return {!SortedMapIterator}
	     */
	    ChildrenNode.prototype.getReverseIterator = function (indexDefinition) {
	        return this.getReverseIteratorFrom(indexDefinition.maxPost(), indexDefinition);
	    };
	    /**
	     * @param {!NamedNode} endPost
	     * @param {!Index} indexDefinition
	     * @return {!SortedMapIterator}
	     */
	    ChildrenNode.prototype.getReverseIteratorFrom = function (endPost, indexDefinition) {
	        var idx = this.resolveIndex_(indexDefinition);
	        if (idx) {
	            return idx.getReverseIteratorFrom(endPost, function (key) {
	                return key;
	            });
	        }
	        else {
	            var iterator = this.children_.getReverseIteratorFrom(endPost.name, NamedNode.Wrap);
	            var next = iterator.peek();
	            while (next != null && indexDefinition.compare(next, endPost) > 0) {
	                iterator.getNext();
	                next = iterator.peek();
	            }
	            return iterator;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    ChildrenNode.prototype.compareTo = function (other) {
	        if (this.isEmpty()) {
	            if (other.isEmpty()) {
	                return 0;
	            }
	            else {
	                return -1;
	            }
	        }
	        else if (other.isLeafNode() || other.isEmpty()) {
	            return 1;
	        }
	        else if (other === MAX_NODE$2) {
	            return -1;
	        }
	        else {
	            // Must be another node with children.
	            return 0;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    ChildrenNode.prototype.withIndex = function (indexDefinition) {
	        if (indexDefinition === KEY_INDEX ||
	            this.indexMap_.hasIndex(indexDefinition)) {
	            return this;
	        }
	        else {
	            var newIndexMap = this.indexMap_.addIndex(indexDefinition, this.children_);
	            return new ChildrenNode(this.children_, this.priorityNode_, newIndexMap);
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    ChildrenNode.prototype.isIndexed = function (index) {
	        return index === KEY_INDEX || this.indexMap_.hasIndex(index);
	    };
	    /**
	     * @inheritDoc
	     */
	    ChildrenNode.prototype.equals = function (other) {
	        if (other === this) {
	            return true;
	        }
	        else if (other.isLeafNode()) {
	            return false;
	        }
	        else {
	            var otherChildrenNode = other;
	            if (!this.getPriority().equals(otherChildrenNode.getPriority())) {
	                return false;
	            }
	            else if (this.children_.count() === otherChildrenNode.children_.count()) {
	                var thisIter = this.getIterator(PRIORITY_INDEX);
	                var otherIter = otherChildrenNode.getIterator(PRIORITY_INDEX);
	                var thisCurrent = thisIter.getNext();
	                var otherCurrent = otherIter.getNext();
	                while (thisCurrent && otherCurrent) {
	                    if (thisCurrent.name !== otherCurrent.name ||
	                        !thisCurrent.node.equals(otherCurrent.node)) {
	                        return false;
	                    }
	                    thisCurrent = thisIter.getNext();
	                    otherCurrent = otherIter.getNext();
	                }
	                return thisCurrent === null && otherCurrent === null;
	            }
	            else {
	                return false;
	            }
	        }
	    };
	    /**
	     * Returns a SortedMap ordered by index, or null if the default (by-key) ordering can be used
	     * instead.
	     *
	     * @private
	     * @param {!Index} indexDefinition
	     * @return {?SortedMap.<NamedNode, Node>}
	     */
	    ChildrenNode.prototype.resolveIndex_ = function (indexDefinition) {
	        if (indexDefinition === KEY_INDEX) {
	            return null;
	        }
	        else {
	            return this.indexMap_.get(indexDefinition.toString());
	        }
	    };
	    /**
	     * @private
	     * @type {RegExp}
	     */
	    ChildrenNode.INTEGER_REGEXP_ = /^(0|[1-9]\d*)$/;
	    return ChildrenNode;
	}());
	/**
	 * @constructor
	 * @extends {ChildrenNode}
	 * @private
	 */
	var MaxNode = /** @class */ (function (_super) {
	    tslib.__extends(MaxNode, _super);
	    function MaxNode() {
	        return _super.call(this, new SortedMap(NAME_COMPARATOR), ChildrenNode.EMPTY_NODE, IndexMap.Default) || this;
	    }
	    MaxNode.prototype.compareTo = function (other) {
	        if (other === this) {
	            return 0;
	        }
	        else {
	            return 1;
	        }
	    };
	    MaxNode.prototype.equals = function (other) {
	        // Not that we every compare it, but MAX_NODE is only ever equal to itself
	        return other === this;
	    };
	    MaxNode.prototype.getPriority = function () {
	        return this;
	    };
	    MaxNode.prototype.getImmediateChild = function (childName) {
	        return ChildrenNode.EMPTY_NODE;
	    };
	    MaxNode.prototype.isEmpty = function () {
	        return false;
	    };
	    return MaxNode;
	}(ChildrenNode));
	/**
	 * Marker that will sort higher than any other snapshot.
	 * @type {!MAX_NODE}
	 * @const
	 */
	var MAX_NODE$2 = new MaxNode();
	Object.defineProperties(NamedNode, {
	    MIN: {
	        value: new NamedNode(MIN_NAME, ChildrenNode.EMPTY_NODE)
	    },
	    MAX: {
	        value: new NamedNode(MAX_NAME, MAX_NODE$2)
	    }
	});
	/**
	 * Reference Extensions
	 */
	KeyIndex.__EMPTY_NODE = ChildrenNode.EMPTY_NODE;
	LeafNode.__childrenNodeConstructor = ChildrenNode;
	setMaxNode(MAX_NODE$2);
	setMaxNode$1(MAX_NODE$2);
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var USE_HINZE = true;
	/**
	 * Constructs a snapshot node representing the passed JSON and returns it.
	 * @param {*} json JSON to create a node for.
	 * @param {?string|?number=} priority Optional priority to use.  This will be ignored if the
	 * passed JSON contains a .priority property.
	 * @return {!Node}
	 */
	function nodeFromJSON$1(json, priority) {
	    if (priority === void 0) { priority = null; }
	    if (json === null) {
	        return ChildrenNode.EMPTY_NODE;
	    }
	    if (typeof json === 'object' && '.priority' in json) {
	        priority = json['.priority'];
	    }
	    util.assert(priority === null ||
	        typeof priority === 'string' ||
	        typeof priority === 'number' ||
	        (typeof priority === 'object' && '.sv' in priority), 'Invalid priority type found: ' + typeof priority);
	    if (typeof json === 'object' && '.value' in json && json['.value'] !== null) {
	        json = json['.value'];
	    }
	    // Valid leaf nodes include non-objects or server-value wrapper objects
	    if (typeof json !== 'object' || '.sv' in json) {
	        var jsonLeaf = json;
	        return new LeafNode(jsonLeaf, nodeFromJSON$1(priority));
	    }
	    if (!(json instanceof Array) && USE_HINZE) {
	        var children_1 = [];
	        var childrenHavePriority_1 = false;
	        var hinzeJsonObj = json;
	        each(hinzeJsonObj, function (key, child) {
	            if (key.substring(0, 1) !== '.') {
	                // Ignore metadata nodes
	                var childNode = nodeFromJSON$1(child);
	                if (!childNode.isEmpty()) {
	                    childrenHavePriority_1 =
	                        childrenHavePriority_1 || !childNode.getPriority().isEmpty();
	                    children_1.push(new NamedNode(key, childNode));
	                }
	            }
	        });
	        if (children_1.length === 0) {
	            return ChildrenNode.EMPTY_NODE;
	        }
	        var childSet = buildChildSet(children_1, NAME_ONLY_COMPARATOR, function (namedNode) { return namedNode.name; }, NAME_COMPARATOR);
	        if (childrenHavePriority_1) {
	            var sortedChildSet = buildChildSet(children_1, PRIORITY_INDEX.getCompare());
	            return new ChildrenNode(childSet, nodeFromJSON$1(priority), new IndexMap({ '.priority': sortedChildSet }, { '.priority': PRIORITY_INDEX }));
	        }
	        else {
	            return new ChildrenNode(childSet, nodeFromJSON$1(priority), IndexMap.Default);
	        }
	    }
	    else {
	        var node_1 = ChildrenNode.EMPTY_NODE;
	        each(json, function (key, childData) {
	            if (util.contains(json, key)) {
	                if (key.substring(0, 1) !== '.') {
	                    // ignore metadata nodes.
	                    var childNode = nodeFromJSON$1(childData);
	                    if (childNode.isLeafNode() || !childNode.isEmpty()) {
	                        node_1 = node_1.updateImmediateChild(key, childNode);
	                    }
	                }
	            }
	        });
	        return node_1.updatePriority(nodeFromJSON$1(priority));
	    }
	}
	setNodeFromJSON(nodeFromJSON$1);
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @constructor
	 * @extends {Index}
	 * @private
	 */
	var ValueIndex = /** @class */ (function (_super) {
	    tslib.__extends(ValueIndex, _super);
	    function ValueIndex() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * @inheritDoc
	     */
	    ValueIndex.prototype.compare = function (a, b) {
	        var indexCmp = a.node.compareTo(b.node);
	        if (indexCmp === 0) {
	            return nameCompare(a.name, b.name);
	        }
	        else {
	            return indexCmp;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    ValueIndex.prototype.isDefinedOn = function (node) {
	        return true;
	    };
	    /**
	     * @inheritDoc
	     */
	    ValueIndex.prototype.indexedValueChanged = function (oldNode, newNode) {
	        return !oldNode.equals(newNode);
	    };
	    /**
	     * @inheritDoc
	     */
	    ValueIndex.prototype.minPost = function () {
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        return NamedNode.MIN;
	    };
	    /**
	     * @inheritDoc
	     */
	    ValueIndex.prototype.maxPost = function () {
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        return NamedNode.MAX;
	    };
	    /**
	     * @param {*} indexValue
	     * @param {string} name
	     * @return {!NamedNode}
	     */
	    ValueIndex.prototype.makePost = function (indexValue, name) {
	        var valueNode = nodeFromJSON$1(indexValue);
	        return new NamedNode(name, valueNode);
	    };
	    /**
	     * @return {!string} String representation for inclusion in a query spec
	     */
	    ValueIndex.prototype.toString = function () {
	        return '.value';
	    };
	    return ValueIndex;
	}(Index));
	var VALUE_INDEX = new ValueIndex();
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @param {!Path} indexPath
	 * @constructor
	 * @extends {Index}
	 */
	var PathIndex = /** @class */ (function (_super) {
	    tslib.__extends(PathIndex, _super);
	    function PathIndex(indexPath_) {
	        var _this = _super.call(this) || this;
	        _this.indexPath_ = indexPath_;
	        util.assert(!indexPath_.isEmpty() && indexPath_.getFront() !== '.priority', "Can't create PathIndex with empty path or .priority key");
	        return _this;
	    }
	    /**
	     * @param {!Node} snap
	     * @return {!Node}
	     * @protected
	     */
	    PathIndex.prototype.extractChild = function (snap) {
	        return snap.getChild(this.indexPath_);
	    };
	    /**
	     * @inheritDoc
	     */
	    PathIndex.prototype.isDefinedOn = function (node) {
	        return !node.getChild(this.indexPath_).isEmpty();
	    };
	    /**
	     * @inheritDoc
	     */
	    PathIndex.prototype.compare = function (a, b) {
	        var aChild = this.extractChild(a.node);
	        var bChild = this.extractChild(b.node);
	        var indexCmp = aChild.compareTo(bChild);
	        if (indexCmp === 0) {
	            return nameCompare(a.name, b.name);
	        }
	        else {
	            return indexCmp;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    PathIndex.prototype.makePost = function (indexValue, name) {
	        var valueNode = nodeFromJSON$1(indexValue);
	        var node = ChildrenNode.EMPTY_NODE.updateChild(this.indexPath_, valueNode);
	        return new NamedNode(name, node);
	    };
	    /**
	     * @inheritDoc
	     */
	    PathIndex.prototype.maxPost = function () {
	        var node = ChildrenNode.EMPTY_NODE.updateChild(this.indexPath_, MAX_NODE$2);
	        return new NamedNode(MAX_NAME, node);
	    };
	    /**
	     * @inheritDoc
	     */
	    PathIndex.prototype.toString = function () {
	        return this.indexPath_.slice().join('/');
	    };
	    return PathIndex;
	}(Index));
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Class representing a firebase data snapshot.  It wraps a SnapshotNode and
	 * surfaces the public methods (val, forEach, etc.) we want to expose.
	 */
	var DataSnapshot = /** @class */ (function () {
	    /**
	     * @param {!Node} node_ A SnapshotNode to wrap.
	     * @param {!Reference} ref_ The ref of the location this snapshot came from.
	     * @param {!Index} index_ The iteration order for this snapshot
	     */
	    function DataSnapshot(node_, ref_, index_) {
	        this.node_ = node_;
	        this.ref_ = ref_;
	        this.index_ = index_;
	    }
	    /**
	     * Retrieves the snapshot contents as JSON.  Returns null if the snapshot is
	     * empty.
	     *
	     * @return {*} JSON representation of the DataSnapshot contents, or null if empty.
	     */
	    DataSnapshot.prototype.val = function () {
	        util.validateArgCount('DataSnapshot.val', 0, 0, arguments.length);
	        return this.node_.val();
	    };
	    /**
	     * Returns the snapshot contents as JSON, including priorities of node.  Suitable for exporting
	     * the entire node contents.
	     * @return {*} JSON representation of the DataSnapshot contents, or null if empty.
	     */
	    DataSnapshot.prototype.exportVal = function () {
	        util.validateArgCount('DataSnapshot.exportVal', 0, 0, arguments.length);
	        return this.node_.val(true);
	    };
	    // Do not create public documentation. This is intended to make JSON serialization work but is otherwise unnecessary
	    // for end-users
	    DataSnapshot.prototype.toJSON = function () {
	        // Optional spacer argument is unnecessary because we're depending on recursion rather than stringifying the content
	        util.validateArgCount('DataSnapshot.toJSON', 0, 1, arguments.length);
	        return this.exportVal();
	    };
	    /**
	     * Returns whether the snapshot contains a non-null value.
	     *
	     * @return {boolean} Whether the snapshot contains a non-null value, or is empty.
	     */
	    DataSnapshot.prototype.exists = function () {
	        util.validateArgCount('DataSnapshot.exists', 0, 0, arguments.length);
	        return !this.node_.isEmpty();
	    };
	    /**
	     * Returns a DataSnapshot of the specified child node's contents.
	     *
	     * @param {!string} childPathString Path to a child.
	     * @return {!DataSnapshot} DataSnapshot for child node.
	     */
	    DataSnapshot.prototype.child = function (childPathString) {
	        util.validateArgCount('DataSnapshot.child', 0, 1, arguments.length);
	        // Ensure the childPath is a string (can be a number)
	        childPathString = String(childPathString);
	        validatePathString('DataSnapshot.child', 1, childPathString, false);
	        var childPath = new Path(childPathString);
	        var childRef = this.ref_.child(childPath);
	        return new DataSnapshot(this.node_.getChild(childPath), childRef, PRIORITY_INDEX);
	    };
	    /**
	     * Returns whether the snapshot contains a child at the specified path.
	     *
	     * @param {!string} childPathString Path to a child.
	     * @return {boolean} Whether the child exists.
	     */
	    DataSnapshot.prototype.hasChild = function (childPathString) {
	        util.validateArgCount('DataSnapshot.hasChild', 1, 1, arguments.length);
	        validatePathString('DataSnapshot.hasChild', 1, childPathString, false);
	        var childPath = new Path(childPathString);
	        return !this.node_.getChild(childPath).isEmpty();
	    };
	    /**
	     * Returns the priority of the object, or null if no priority was set.
	     *
	     * @return {string|number|null} The priority.
	     */
	    DataSnapshot.prototype.getPriority = function () {
	        util.validateArgCount('DataSnapshot.getPriority', 0, 0, arguments.length);
	        // typecast here because we never return deferred values or internal priorities (MAX_PRIORITY)
	        return this.node_.getPriority().val();
	    };
	    /**
	     * Iterates through child nodes and calls the specified action for each one.
	     *
	     * @param {function(!DataSnapshot)} action Callback function to be called
	     * for each child.
	     * @return {boolean} True if forEach was canceled by action returning true for
	     * one of the child nodes.
	     */
	    DataSnapshot.prototype.forEach = function (action) {
	        var _this = this;
	        util.validateArgCount('DataSnapshot.forEach', 1, 1, arguments.length);
	        util.validateCallback('DataSnapshot.forEach', 1, action, false);
	        if (this.node_.isLeafNode()) {
	            return false;
	        }
	        var childrenNode = this.node_;
	        // Sanitize the return value to a boolean. ChildrenNode.forEachChild has a weird return type...
	        return !!childrenNode.forEachChild(this.index_, function (key, node) {
	            return action(new DataSnapshot(node, _this.ref_.child(key), PRIORITY_INDEX));
	        });
	    };
	    /**
	     * Returns whether this DataSnapshot has children.
	     * @return {boolean} True if the DataSnapshot contains 1 or more child nodes.
	     */
	    DataSnapshot.prototype.hasChildren = function () {
	        util.validateArgCount('DataSnapshot.hasChildren', 0, 0, arguments.length);
	        if (this.node_.isLeafNode()) {
	            return false;
	        }
	        else {
	            return !this.node_.isEmpty();
	        }
	    };
	    Object.defineProperty(DataSnapshot.prototype, "key", {
	        get: function () {
	            return this.ref_.getKey();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Returns the number of children for this DataSnapshot.
	     * @return {number} The number of children that this DataSnapshot contains.
	     */
	    DataSnapshot.prototype.numChildren = function () {
	        util.validateArgCount('DataSnapshot.numChildren', 0, 0, arguments.length);
	        return this.node_.numChildren();
	    };
	    /**
	     * @return {Reference} The Firebase reference for the location this snapshot's data came from.
	     */
	    DataSnapshot.prototype.getRef = function () {
	        util.validateArgCount('DataSnapshot.ref', 0, 0, arguments.length);
	        return this.ref_;
	    };
	    Object.defineProperty(DataSnapshot.prototype, "ref", {
	        get: function () {
	            return this.getRef();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return DataSnapshot;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Encapsulates the data needed to raise an event
	 * @implements {Event}
	 */
	var DataEvent = /** @class */ (function () {
	    /**
	     * @param {!string} eventType One of: value, child_added, child_changed, child_moved, child_removed
	     * @param {!EventRegistration} eventRegistration The function to call to with the event data. User provided
	     * @param {!DataSnapshot} snapshot The data backing the event
	     * @param {?string=} prevName Optional, the name of the previous child for child_* events.
	     */
	    function DataEvent(eventType, eventRegistration, snapshot, prevName) {
	        this.eventType = eventType;
	        this.eventRegistration = eventRegistration;
	        this.snapshot = snapshot;
	        this.prevName = prevName;
	    }
	    /**
	     * @inheritDoc
	     */
	    DataEvent.prototype.getPath = function () {
	        var ref = this.snapshot.getRef();
	        if (this.eventType === 'value') {
	            return ref.path;
	        }
	        else {
	            return ref.getParent().path;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    DataEvent.prototype.getEventType = function () {
	        return this.eventType;
	    };
	    /**
	     * @inheritDoc
	     */
	    DataEvent.prototype.getEventRunner = function () {
	        return this.eventRegistration.getEventRunner(this);
	    };
	    /**
	     * @inheritDoc
	     */
	    DataEvent.prototype.toString = function () {
	        return (this.getPath().toString() +
	            ':' +
	            this.eventType +
	            ':' +
	            util.stringify(this.snapshot.exportVal()));
	    };
	    return DataEvent;
	}());
	var CancelEvent = /** @class */ (function () {
	    /**
	     * @param {EventRegistration} eventRegistration
	     * @param {Error} error
	     * @param {!Path} path
	     */
	    function CancelEvent(eventRegistration, error, path) {
	        this.eventRegistration = eventRegistration;
	        this.error = error;
	        this.path = path;
	    }
	    /**
	     * @inheritDoc
	     */
	    CancelEvent.prototype.getPath = function () {
	        return this.path;
	    };
	    /**
	     * @inheritDoc
	     */
	    CancelEvent.prototype.getEventType = function () {
	        return 'cancel';
	    };
	    /**
	     * @inheritDoc
	     */
	    CancelEvent.prototype.getEventRunner = function () {
	        return this.eventRegistration.getEventRunner(this);
	    };
	    /**
	     * @inheritDoc
	     */
	    CancelEvent.prototype.toString = function () {
	        return this.path.toString() + ':cancel';
	    };
	    return CancelEvent;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Represents registration for 'value' events.
	 */
	var ValueEventRegistration = /** @class */ (function () {
	    /**
	     * @param {?function(!DataSnapshot)} callback_
	     * @param {?function(Error)} cancelCallback_
	     * @param {?Object} context_
	     */
	    function ValueEventRegistration(callback_, cancelCallback_, context_) {
	        this.callback_ = callback_;
	        this.cancelCallback_ = cancelCallback_;
	        this.context_ = context_;
	    }
	    /**
	     * @inheritDoc
	     */
	    ValueEventRegistration.prototype.respondsTo = function (eventType) {
	        return eventType === 'value';
	    };
	    /**
	     * @inheritDoc
	     */
	    ValueEventRegistration.prototype.createEvent = function (change, query) {
	        var index = query.getQueryParams().getIndex();
	        return new DataEvent('value', this, new DataSnapshot(change.snapshotNode, query.getRef(), index));
	    };
	    /**
	     * @inheritDoc
	     */
	    ValueEventRegistration.prototype.getEventRunner = function (eventData) {
	        var ctx = this.context_;
	        if (eventData.getEventType() === 'cancel') {
	            util.assert(this.cancelCallback_, 'Raising a cancel event on a listener with no cancel callback');
	            var cancelCB_1 = this.cancelCallback_;
	            return function () {
	                // We know that error exists, we checked above that this is a cancel event
	                cancelCB_1.call(ctx, eventData.error);
	            };
	        }
	        else {
	            var cb_1 = this.callback_;
	            return function () {
	                cb_1.call(ctx, eventData.snapshot);
	            };
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    ValueEventRegistration.prototype.createCancelEvent = function (error, path) {
	        if (this.cancelCallback_) {
	            return new CancelEvent(this, error, path);
	        }
	        else {
	            return null;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    ValueEventRegistration.prototype.matches = function (other) {
	        if (!(other instanceof ValueEventRegistration)) {
	            return false;
	        }
	        else if (!other.callback_ || !this.callback_) {
	            // If no callback specified, we consider it to match any callback.
	            return true;
	        }
	        else {
	            return (other.callback_ === this.callback_ && other.context_ === this.context_);
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    ValueEventRegistration.prototype.hasAnyCallback = function () {
	        return this.callback_ !== null;
	    };
	    return ValueEventRegistration;
	}());
	/**
	 * Represents the registration of 1 or more child_xxx events.
	 *
	 * Currently, it is always exactly 1 child_xxx event, but the idea is we might let you
	 * register a group of callbacks together in the future.
	 *
	 * @constructor
	 * @implements {EventRegistration}
	 */
	var ChildEventRegistration = /** @class */ (function () {
	    /**
	     * @param {?Object.<string, function(!DataSnapshot, ?string=)>} callbacks_
	     * @param {?function(Error)} cancelCallback_
	     * @param {Object=} context_
	     */
	    function ChildEventRegistration(callbacks_, cancelCallback_, context_) {
	        this.callbacks_ = callbacks_;
	        this.cancelCallback_ = cancelCallback_;
	        this.context_ = context_;
	    }
	    /**
	     * @inheritDoc
	     */
	    ChildEventRegistration.prototype.respondsTo = function (eventType) {
	        var eventToCheck = eventType === 'children_added' ? 'child_added' : eventType;
	        eventToCheck =
	            eventToCheck === 'children_removed' ? 'child_removed' : eventToCheck;
	        return util.contains(this.callbacks_, eventToCheck);
	    };
	    /**
	     * @inheritDoc
	     */
	    ChildEventRegistration.prototype.createCancelEvent = function (error, path) {
	        if (this.cancelCallback_) {
	            return new CancelEvent(this, error, path);
	        }
	        else {
	            return null;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    ChildEventRegistration.prototype.createEvent = function (change, query) {
	        util.assert(change.childName != null, 'Child events should have a childName.');
	        var ref = query.getRef().child(/** @type {!string} */ change.childName);
	        var index = query.getQueryParams().getIndex();
	        return new DataEvent(change.type, this, new DataSnapshot(change.snapshotNode, ref, index), change.prevName);
	    };
	    /**
	     * @inheritDoc
	     */
	    ChildEventRegistration.prototype.getEventRunner = function (eventData) {
	        var ctx = this.context_;
	        if (eventData.getEventType() === 'cancel') {
	            util.assert(this.cancelCallback_, 'Raising a cancel event on a listener with no cancel callback');
	            var cancelCB_2 = this.cancelCallback_;
	            return function () {
	                // We know that error exists, we checked above that this is a cancel event
	                cancelCB_2.call(ctx, eventData.error);
	            };
	        }
	        else {
	            var cb_2 = this.callbacks_[eventData.eventType];
	            return function () {
	                cb_2.call(ctx, eventData.snapshot, eventData.prevName);
	            };
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    ChildEventRegistration.prototype.matches = function (other) {
	        var _this = this;
	        if (other instanceof ChildEventRegistration) {
	            if (!this.callbacks_ || !other.callbacks_) {
	                return true;
	            }
	            else if (this.context_ === other.context_) {
	                var otherKeys = Object.keys(other.callbacks_);
	                var thisKeys = Object.keys(this.callbacks_);
	                var otherCount = otherKeys.length;
	                var thisCount = thisKeys.length;
	                if (otherCount === thisCount) {
	                    // If count is 1, do an exact match on eventType, if either is defined but null, it's a match.
	                    // If event types don't match, not a match
	                    // If count is not 1, exact match across all
	                    if (otherCount === 1) {
	                        var otherKey = otherKeys[0];
	                        var thisKey = thisKeys[0];
	                        return (thisKey === otherKey &&
	                            (!other.callbacks_[otherKey] ||
	                                !this.callbacks_[thisKey] ||
	                                other.callbacks_[otherKey] === this.callbacks_[thisKey]));
	                    }
	                    else {
	                        // Exact match on each key.
	                        return thisKeys.every(function (eventType) {
	                            return other.callbacks_[eventType] === _this.callbacks_[eventType];
	                        });
	                    }
	                }
	            }
	        }
	        return false;
	    };
	    /**
	     * @inheritDoc
	     */
	    ChildEventRegistration.prototype.hasAnyCallback = function () {
	        return this.callbacks_ !== null;
	    };
	    return ChildEventRegistration;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var __referenceConstructor;
	/**
	 * A Query represents a filter to be applied to a firebase location.  This object purely represents the
	 * query expression (and exposes our public API to build the query).  The actual query logic is in ViewBase.js.
	 *
	 * Since every Firebase reference is a query, Firebase inherits from this object.
	 */
	var Query = /** @class */ (function () {
	    function Query(repo, path, queryParams_, orderByCalled_) {
	        this.repo = repo;
	        this.path = path;
	        this.queryParams_ = queryParams_;
	        this.orderByCalled_ = orderByCalled_;
	    }
	    Object.defineProperty(Query, "__referenceConstructor", {
	        get: function () {
	            util.assert(__referenceConstructor, 'Reference.ts has not been loaded');
	            return __referenceConstructor;
	        },
	        set: function (val) {
	            __referenceConstructor = val;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Validates start/end values for queries.
	     * @param {!QueryParams} params
	     * @private
	     */
	    Query.validateQueryEndpoints_ = function (params) {
	        var startNode = null;
	        var endNode = null;
	        if (params.hasStart()) {
	            startNode = params.getIndexStartValue();
	        }
	        if (params.hasEnd()) {
	            endNode = params.getIndexEndValue();
	        }
	        if (params.getIndex() === KEY_INDEX) {
	            var tooManyArgsError = 'Query: When ordering by key, you may only pass one argument to ' +
	                'startAt(), endAt(), or equalTo().';
	            var wrongArgTypeError = 'Query: When ordering by key, the argument passed to startAt(), endAt(),' +
	                'or equalTo() must be a string.';
	            if (params.hasStart()) {
	                var startName = params.getIndexStartName();
	                if (startName !== MIN_NAME) {
	                    throw new Error(tooManyArgsError);
	                }
	                else if (typeof startNode !== 'string') {
	                    throw new Error(wrongArgTypeError);
	                }
	            }
	            if (params.hasEnd()) {
	                var endName = params.getIndexEndName();
	                if (endName !== MAX_NAME) {
	                    throw new Error(tooManyArgsError);
	                }
	                else if (typeof endNode !== 'string') {
	                    throw new Error(wrongArgTypeError);
	                }
	            }
	        }
	        else if (params.getIndex() === PRIORITY_INDEX) {
	            if ((startNode != null && !isValidPriority(startNode)) ||
	                (endNode != null && !isValidPriority(endNode))) {
	                throw new Error('Query: When ordering by priority, the first argument passed to startAt(), ' +
	                    'endAt(), or equalTo() must be a valid priority value (null, a number, or a string).');
	            }
	        }
	        else {
	            util.assert(params.getIndex() instanceof PathIndex ||
	                params.getIndex() === VALUE_INDEX, 'unknown index type.');
	            if ((startNode != null && typeof startNode === 'object') ||
	                (endNode != null && typeof endNode === 'object')) {
	                throw new Error('Query: First argument passed to startAt(), endAt(), or equalTo() cannot be ' +
	                    'an object.');
	            }
	        }
	    };
	    /**
	     * Validates that limit* has been called with the correct combination of parameters
	     * @param {!QueryParams} params
	     * @private
	     */
	    Query.validateLimit_ = function (params) {
	        if (params.hasStart() &&
	            params.hasEnd() &&
	            params.hasLimit() &&
	            !params.hasAnchoredLimit()) {
	            throw new Error("Query: Can't combine startAt(), endAt(), and limit(). Use limitToFirst() or limitToLast() instead.");
	        }
	    };
	    /**
	     * Validates that no other order by call has been made
	     * @param {!string} fnName
	     * @private
	     */
	    Query.prototype.validateNoPreviousOrderByCall_ = function (fnName) {
	        if (this.orderByCalled_ === true) {
	            throw new Error(fnName + ": You can't combine multiple orderBy calls.");
	        }
	    };
	    /**
	     * @return {!QueryParams}
	     */
	    Query.prototype.getQueryParams = function () {
	        return this.queryParams_;
	    };
	    /**
	     * @return {!Reference}
	     */
	    Query.prototype.getRef = function () {
	        util.validateArgCount('Query.ref', 0, 0, arguments.length);
	        // This is a slight hack. We cannot goog.require('fb.api.Firebase'), since Firebase requires fb.api.Query.
	        // However, we will always export 'Firebase' to the global namespace, so it's guaranteed to exist by the time this
	        // method gets called.
	        return new Query.__referenceConstructor(this.repo, this.path);
	    };
	    /**
	     * @param {!string} eventType
	     * @param {!function(DataSnapshot, string=)} callback
	     * @param {(function(Error)|Object)=} cancelCallbackOrContext
	     * @param {Object=} context
	     * @return {!function(DataSnapshot, string=)}
	     */
	    Query.prototype.on = function (eventType, callback, cancelCallbackOrContext, context) {
	        util.validateArgCount('Query.on', 2, 4, arguments.length);
	        validateEventType('Query.on', 1, eventType, false);
	        util.validateCallback('Query.on', 2, callback, false);
	        var ret = Query.getCancelAndContextArgs_('Query.on', cancelCallbackOrContext, context);
	        if (eventType === 'value') {
	            this.onValueEvent(callback, ret.cancel, ret.context);
	        }
	        else {
	            var callbacks = {};
	            callbacks[eventType] = callback;
	            this.onChildEvent(callbacks, ret.cancel, ret.context);
	        }
	        return callback;
	    };
	    /**
	     * @param {!function(!DataSnapshot)} callback
	     * @param {?function(Error)} cancelCallback
	     * @param {?Object} context
	     * @protected
	     */
	    Query.prototype.onValueEvent = function (callback, cancelCallback, context) {
	        var container = new ValueEventRegistration(callback, cancelCallback || null, context || null);
	        this.repo.addEventCallbackForQuery(this, container);
	    };
	    /**
	     * @param {!Object.<string, !function(!DataSnapshot, ?string)>} callbacks
	     * @param {?function(Error)} cancelCallback
	     * @param {?Object} context
	     * @protected
	     */
	    Query.prototype.onChildEvent = function (callbacks, cancelCallback, context) {
	        var container = new ChildEventRegistration(callbacks, cancelCallback, context);
	        this.repo.addEventCallbackForQuery(this, container);
	    };
	    /**
	     * @param {string=} eventType
	     * @param {(function(!DataSnapshot, ?string=))=} callback
	     * @param {Object=} context
	     */
	    Query.prototype.off = function (eventType, callback, context) {
	        util.validateArgCount('Query.off', 0, 3, arguments.length);
	        validateEventType('Query.off', 1, eventType, true);
	        util.validateCallback('Query.off', 2, callback, true);
	        util.validateContextObject('Query.off', 3, context, true);
	        var container = null;
	        var callbacks = null;
	        if (eventType === 'value') {
	            var valueCallback = callback || null;
	            container = new ValueEventRegistration(valueCallback, null, context || null);
	        }
	        else if (eventType) {
	            if (callback) {
	                callbacks = {};
	                callbacks[eventType] = callback;
	            }
	            container = new ChildEventRegistration(callbacks, null, context || null);
	        }
	        this.repo.removeEventCallbackForQuery(this, container);
	    };
	    /**
	     * Attaches a listener, waits for the first event, and then removes the listener
	     * @param {!string} eventType
	     * @param {!function(!DataSnapshot, string=)} userCallback
	     * @param failureCallbackOrContext
	     * @param context
	     * @return {!firebase.Promise}
	     */
	    Query.prototype.once = function (eventType, userCallback, failureCallbackOrContext, context) {
	        var _this = this;
	        util.validateArgCount('Query.once', 1, 4, arguments.length);
	        validateEventType('Query.once', 1, eventType, false);
	        util.validateCallback('Query.once', 2, userCallback, true);
	        var ret = Query.getCancelAndContextArgs_('Query.once', failureCallbackOrContext, context);
	        // TODO: Implement this more efficiently (in particular, use 'get' wire protocol for 'value' event)
	        // TODO: consider actually wiring the callbacks into the promise. We cannot do this without a breaking change
	        // because the API currently expects callbacks will be called synchronously if the data is cached, but this is
	        // against the Promise specification.
	        var firstCall = true;
	        var deferred = new util.Deferred();
	        // A dummy error handler in case a user wasn't expecting promises
	        deferred.promise.catch(function () { });
	        var onceCallback = function (snapshot) {
	            // NOTE: Even though we unsubscribe, we may get called multiple times if a single action (e.g. set() with JSON)
	            // triggers multiple events (e.g. child_added or child_changed).
	            if (firstCall) {
	                firstCall = false;
	                _this.off(eventType, onceCallback);
	                if (userCallback) {
	                    userCallback.bind(ret.context)(snapshot);
	                }
	                deferred.resolve(snapshot);
	            }
	        };
	        this.on(eventType, onceCallback, 
	        /*cancel=*/ function (err) {
	            _this.off(eventType, onceCallback);
	            if (ret.cancel) {
	                ret.cancel.bind(ret.context)(err);
	            }
	            deferred.reject(err);
	        });
	        return deferred.promise;
	    };
	    /**
	     * Set a limit and anchor it to the start of the window.
	     * @param {!number} limit
	     * @return {!Query}
	     */
	    Query.prototype.limitToFirst = function (limit) {
	        util.validateArgCount('Query.limitToFirst', 1, 1, arguments.length);
	        if (typeof limit !== 'number' ||
	            Math.floor(limit) !== limit ||
	            limit <= 0) {
	            throw new Error('Query.limitToFirst: First argument must be a positive integer.');
	        }
	        if (this.queryParams_.hasLimit()) {
	            throw new Error('Query.limitToFirst: Limit was already set (by another call to limit, ' +
	                'limitToFirst, or limitToLast).');
	        }
	        return new Query(this.repo, this.path, this.queryParams_.limitToFirst(limit), this.orderByCalled_);
	    };
	    /**
	     * Set a limit and anchor it to the end of the window.
	     * @param {!number} limit
	     * @return {!Query}
	     */
	    Query.prototype.limitToLast = function (limit) {
	        util.validateArgCount('Query.limitToLast', 1, 1, arguments.length);
	        if (typeof limit !== 'number' ||
	            Math.floor(limit) !== limit ||
	            limit <= 0) {
	            throw new Error('Query.limitToLast: First argument must be a positive integer.');
	        }
	        if (this.queryParams_.hasLimit()) {
	            throw new Error('Query.limitToLast: Limit was already set (by another call to limit, ' +
	                'limitToFirst, or limitToLast).');
	        }
	        return new Query(this.repo, this.path, this.queryParams_.limitToLast(limit), this.orderByCalled_);
	    };
	    /**
	     * Given a child path, return a new query ordered by the specified grandchild path.
	     * @param {!string} path
	     * @return {!Query}
	     */
	    Query.prototype.orderByChild = function (path) {
	        util.validateArgCount('Query.orderByChild', 1, 1, arguments.length);
	        if (path === '$key') {
	            throw new Error('Query.orderByChild: "$key" is invalid.  Use Query.orderByKey() instead.');
	        }
	        else if (path === '$priority') {
	            throw new Error('Query.orderByChild: "$priority" is invalid.  Use Query.orderByPriority() instead.');
	        }
	        else if (path === '$value') {
	            throw new Error('Query.orderByChild: "$value" is invalid.  Use Query.orderByValue() instead.');
	        }
	        validatePathString('Query.orderByChild', 1, path, false);
	        this.validateNoPreviousOrderByCall_('Query.orderByChild');
	        var parsedPath = new Path(path);
	        if (parsedPath.isEmpty()) {
	            throw new Error('Query.orderByChild: cannot pass in empty path.  Use Query.orderByValue() instead.');
	        }
	        var index = new PathIndex(parsedPath);
	        var newParams = this.queryParams_.orderBy(index);
	        Query.validateQueryEndpoints_(newParams);
	        return new Query(this.repo, this.path, newParams, /*orderByCalled=*/ true);
	    };
	    /**
	     * Return a new query ordered by the KeyIndex
	     * @return {!Query}
	     */
	    Query.prototype.orderByKey = function () {
	        util.validateArgCount('Query.orderByKey', 0, 0, arguments.length);
	        this.validateNoPreviousOrderByCall_('Query.orderByKey');
	        var newParams = this.queryParams_.orderBy(KEY_INDEX);
	        Query.validateQueryEndpoints_(newParams);
	        return new Query(this.repo, this.path, newParams, /*orderByCalled=*/ true);
	    };
	    /**
	     * Return a new query ordered by the PriorityIndex
	     * @return {!Query}
	     */
	    Query.prototype.orderByPriority = function () {
	        util.validateArgCount('Query.orderByPriority', 0, 0, arguments.length);
	        this.validateNoPreviousOrderByCall_('Query.orderByPriority');
	        var newParams = this.queryParams_.orderBy(PRIORITY_INDEX);
	        Query.validateQueryEndpoints_(newParams);
	        return new Query(this.repo, this.path, newParams, /*orderByCalled=*/ true);
	    };
	    /**
	     * Return a new query ordered by the ValueIndex
	     * @return {!Query}
	     */
	    Query.prototype.orderByValue = function () {
	        util.validateArgCount('Query.orderByValue', 0, 0, arguments.length);
	        this.validateNoPreviousOrderByCall_('Query.orderByValue');
	        var newParams = this.queryParams_.orderBy(VALUE_INDEX);
	        Query.validateQueryEndpoints_(newParams);
	        return new Query(this.repo, this.path, newParams, /*orderByCalled=*/ true);
	    };
	    /**
	     * @param {number|string|boolean|null} value
	     * @param {?string=} name
	     * @return {!Query}
	     */
	    Query.prototype.startAt = function (value, name) {
	        if (value === void 0) { value = null; }
	        util.validateArgCount('Query.startAt', 0, 2, arguments.length);
	        validateFirebaseDataArg('Query.startAt', 1, value, this.path, true);
	        validateKey('Query.startAt', 2, name, true);
	        var newParams = this.queryParams_.startAt(value, name);
	        Query.validateLimit_(newParams);
	        Query.validateQueryEndpoints_(newParams);
	        if (this.queryParams_.hasStart()) {
	            throw new Error('Query.startAt: Starting point was already set (by another call to startAt ' +
	                'or equalTo).');
	        }
	        // Calling with no params tells us to start at the beginning.
	        if (value === undefined) {
	            value = null;
	            name = null;
	        }
	        return new Query(this.repo, this.path, newParams, this.orderByCalled_);
	    };
	    /**
	     * @param {number|string|boolean|null} value
	     * @param {?string=} name
	     * @return {!Query}
	     */
	    Query.prototype.endAt = function (value, name) {
	        if (value === void 0) { value = null; }
	        util.validateArgCount('Query.endAt', 0, 2, arguments.length);
	        validateFirebaseDataArg('Query.endAt', 1, value, this.path, true);
	        validateKey('Query.endAt', 2, name, true);
	        var newParams = this.queryParams_.endAt(value, name);
	        Query.validateLimit_(newParams);
	        Query.validateQueryEndpoints_(newParams);
	        if (this.queryParams_.hasEnd()) {
	            throw new Error('Query.endAt: Ending point was already set (by another call to endAt or ' +
	                'equalTo).');
	        }
	        return new Query(this.repo, this.path, newParams, this.orderByCalled_);
	    };
	    /**
	     * Load the selection of children with exactly the specified value, and, optionally,
	     * the specified name.
	     * @param {number|string|boolean|null} value
	     * @param {string=} name
	     * @return {!Query}
	     */
	    Query.prototype.equalTo = function (value, name) {
	        util.validateArgCount('Query.equalTo', 1, 2, arguments.length);
	        validateFirebaseDataArg('Query.equalTo', 1, value, this.path, false);
	        validateKey('Query.equalTo', 2, name, true);
	        if (this.queryParams_.hasStart()) {
	            throw new Error('Query.equalTo: Starting point was already set (by another call to startAt or ' +
	                'equalTo).');
	        }
	        if (this.queryParams_.hasEnd()) {
	            throw new Error('Query.equalTo: Ending point was already set (by another call to endAt or ' +
	                'equalTo).');
	        }
	        return this.startAt(value, name).endAt(value, name);
	    };
	    /**
	     * @return {!string} URL for this location.
	     */
	    Query.prototype.toString = function () {
	        util.validateArgCount('Query.toString', 0, 0, arguments.length);
	        return this.repo.toString() + this.path.toUrlEncodedString();
	    };
	    // Do not create public documentation. This is intended to make JSON serialization work but is otherwise unnecessary
	    // for end-users.
	    Query.prototype.toJSON = function () {
	        // An optional spacer argument is unnecessary for a string.
	        util.validateArgCount('Query.toJSON', 0, 1, arguments.length);
	        return this.toString();
	    };
	    /**
	     * An object representation of the query parameters used by this Query.
	     * @return {!Object}
	     */
	    Query.prototype.queryObject = function () {
	        return this.queryParams_.getQueryObject();
	    };
	    /**
	     * @return {!string}
	     */
	    Query.prototype.queryIdentifier = function () {
	        var obj = this.queryObject();
	        var id = ObjectToUniqueKey(obj);
	        return id === '{}' ? 'default' : id;
	    };
	    /**
	     * Return true if this query and the provided query are equivalent; otherwise, return false.
	     * @param {Query} other
	     * @return {boolean}
	     */
	    Query.prototype.isEqual = function (other) {
	        util.validateArgCount('Query.isEqual', 1, 1, arguments.length);
	        if (!(other instanceof Query)) {
	            var error = 'Query.isEqual failed: First argument must be an instance of firebase.database.Query.';
	            throw new Error(error);
	        }
	        var sameRepo = this.repo === other.repo;
	        var samePath = this.path.equals(other.path);
	        var sameQueryIdentifier = this.queryIdentifier() === other.queryIdentifier();
	        return sameRepo && samePath && sameQueryIdentifier;
	    };
	    /**
	     * Helper used by .on and .once to extract the context and or cancel arguments.
	     * @param {!string} fnName The function name (on or once)
	     * @param {(function(Error)|Object)=} cancelOrContext
	     * @param {Object=} context
	     * @return {{cancel: ?function(Error), context: ?Object}}
	     * @private
	     */
	    Query.getCancelAndContextArgs_ = function (fnName, cancelOrContext, context) {
	        var ret = { cancel: null, context: null };
	        if (cancelOrContext && context) {
	            ret.cancel = cancelOrContext;
	            util.validateCallback(fnName, 3, ret.cancel, true);
	            ret.context = context;
	            util.validateContextObject(fnName, 4, ret.context, true);
	        }
	        else if (cancelOrContext) {
	            // we have either a cancel callback or a context.
	            if (typeof cancelOrContext === 'object' && cancelOrContext !== null) {
	                // it's a context!
	                ret.context = cancelOrContext;
	            }
	            else if (typeof cancelOrContext === 'function') {
	                ret.cancel = cancelOrContext;
	            }
	            else {
	                throw new Error(util.errorPrefix(fnName, 3, true) +
	                    ' must either be a cancel callback or a context object.');
	            }
	        }
	        return ret;
	    };
	    Object.defineProperty(Query.prototype, "ref", {
	        get: function () {
	            return this.getRef();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return Query;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var ExistingValueProvider = /** @class */ (function () {
	    function ExistingValueProvider(node_) {
	        this.node_ = node_;
	    }
	    ExistingValueProvider.prototype.getImmediateChild = function (childName) {
	        var child = this.node_.getImmediateChild(childName);
	        return new ExistingValueProvider(child);
	    };
	    ExistingValueProvider.prototype.node = function () {
	        return this.node_;
	    };
	    return ExistingValueProvider;
	}());
	var DeferredValueProvider = /** @class */ (function () {
	    function DeferredValueProvider(syncTree, path) {
	        this.syncTree_ = syncTree;
	        this.path_ = path;
	    }
	    DeferredValueProvider.prototype.getImmediateChild = function (childName) {
	        var childPath = this.path_.child(childName);
	        return new DeferredValueProvider(this.syncTree_, childPath);
	    };
	    DeferredValueProvider.prototype.node = function () {
	        return this.syncTree_.calcCompleteEventCache(this.path_);
	    };
	    return DeferredValueProvider;
	}());
	/**
	 * Generate placeholders for deferred values.
	 * @param {?Object} values
	 * @return {!Object}
	 */
	var generateWithValues = function (values) {
	    values = values || {};
	    values['timestamp'] = values['timestamp'] || new Date().getTime();
	    return values;
	};
	/**
	 * Value to use when firing local events. When writing server values, fire
	 * local events with an approximate value, otherwise return value as-is.
	 * @param {(Object|string|number|boolean)} value
	 * @param {!Object} serverValues
	 * @return {!(string|number|boolean)}
	 */
	var resolveDeferredLeafValue = function (value, existingVal, serverValues) {
	    if (!value || typeof value !== 'object') {
	        return value;
	    }
	    util.assert('.sv' in value, 'Unexpected leaf node or priority contents');
	    if (typeof value['.sv'] === 'string') {
	        return resolveScalarDeferredValue(value['.sv'], existingVal, serverValues);
	    }
	    else if (typeof value['.sv'] === 'object') {
	        return resolveComplexDeferredValue(value['.sv'], existingVal);
	    }
	    else {
	        util.assert(false, 'Unexpected server value: ' + JSON.stringify(value, null, 2));
	    }
	};
	var resolveScalarDeferredValue = function (op, existing, serverValues) {
	    switch (op) {
	        case 'timestamp':
	            return serverValues['timestamp'];
	        default:
	            util.assert(false, 'Unexpected server value: ' + op);
	    }
	};
	var resolveComplexDeferredValue = function (op, existing, unused) {
	    if (!op.hasOwnProperty('increment')) {
	        util.assert(false, 'Unexpected server value: ' + JSON.stringify(op, null, 2));
	    }
	    var delta = op['increment'];
	    if (typeof delta !== 'number') {
	        util.assert(false, 'Unexpected increment value: ' + delta);
	    }
	    var existingNode = existing.node();
	    util.assert(existingNode !== null && typeof existingNode !== 'undefined', 'Expected ChildrenNode.EMPTY_NODE for nulls');
	    // Incrementing a non-number sets the value to the incremented amount
	    if (!existingNode.isLeafNode()) {
	        return delta;
	    }
	    var leaf = existingNode;
	    var existingVal = leaf.getValue();
	    if (typeof existingVal !== 'number') {
	        return delta;
	    }
	    // No need to do over/underflow arithmetic here because JS only handles floats under the covers
	    return existingVal + delta;
	};
	/**
	 * Recursively replace all deferred values and priorities in the tree with the
	 * specified generated replacement values.
	 * @param {!Path} path path to which write is relative
	 * @param {!Node} node new data written at path
	 * @param {!SyncTree} syncTree current data
	 * @param {!Object} serverValues
	 * @return {!SparseSnapshotTree}
	 */
	var resolveDeferredValueTree = function (path, node, syncTree, serverValues) {
	    return resolveDeferredValue(node, new DeferredValueProvider(syncTree, path), serverValues);
	};
	/**
	 * Recursively replace all deferred values and priorities in the node with the
	 * specified generated replacement values.  If there are no server values in the node,
	 * it'll be returned as-is.
	 * @param {!Node} node
	 * @param {!Object} serverValues
	 * @return {!Node}
	 */
	var resolveDeferredValueSnapshot = function (node, existing, serverValues) {
	    return resolveDeferredValue(node, new ExistingValueProvider(existing), serverValues);
	};
	function resolveDeferredValue(node, existingVal, serverValues) {
	    var rawPri = node.getPriority().val();
	    var priority = resolveDeferredLeafValue(rawPri, existingVal.getImmediateChild('.priority'), serverValues);
	    var newNode;
	    if (node.isLeafNode()) {
	        var leafNode = node;
	        var value = resolveDeferredLeafValue(leafNode.getValue(), existingVal, serverValues);
	        if (value !== leafNode.getValue() ||
	            priority !== leafNode.getPriority().val()) {
	            return new LeafNode(value, nodeFromJSON$1(priority));
	        }
	        else {
	            return node;
	        }
	    }
	    else {
	        var childrenNode = node;
	        newNode = childrenNode;
	        if (priority !== childrenNode.getPriority().val()) {
	            newNode = newNode.updatePriority(new LeafNode(priority));
	        }
	        childrenNode.forEachChild(PRIORITY_INDEX, function (childName, childNode) {
	            var newChildNode = resolveDeferredValue(childNode, existingVal.getImmediateChild(childName), serverValues);
	            if (newChildNode !== childNode) {
	                newNode = newNode.updateImmediateChild(childName, newChildNode);
	            }
	        });
	        return newNode;
	    }
	}
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Helper class to store a sparse set of snapshots.
	 */
	var SparseSnapshotTree = /** @class */ (function () {
	    function SparseSnapshotTree() {
	        this.value = null;
	        this.children = new Map();
	    }
	    /**
	     * Gets the node stored at the given path if one exists.
	     *
	     * @param path Path to look up snapshot for.
	     * @return The retrieved node, or null.
	     */
	    SparseSnapshotTree.prototype.find = function (path) {
	        if (this.value != null) {
	            return this.value.getChild(path);
	        }
	        else if (!path.isEmpty() && this.children.size > 0) {
	            var childKey = path.getFront();
	            path = path.popFront();
	            if (this.children.has(childKey)) {
	                var childTree = this.children.get(childKey);
	                return childTree.find(path);
	            }
	            else {
	                return null;
	            }
	        }
	        else {
	            return null;
	        }
	    };
	    /**
	     * Stores the given node at the specified path. If there is already a node
	     * at a shallower path, it merges the new data into that snapshot node.
	     *
	     * @param path Path to look up snapshot for.
	     * @param data The new data, or null.
	     */
	    SparseSnapshotTree.prototype.remember = function (path, data) {
	        if (path.isEmpty()) {
	            this.value = data;
	            this.children.clear();
	        }
	        else if (this.value !== null) {
	            this.value = this.value.updateChild(path, data);
	        }
	        else {
	            var childKey = path.getFront();
	            if (!this.children.has(childKey)) {
	                this.children.set(childKey, new SparseSnapshotTree());
	            }
	            var child = this.children.get(childKey);
	            path = path.popFront();
	            child.remember(path, data);
	        }
	    };
	    /**
	     * Purge the data at path from the cache.
	     *
	     * @param path Path to look up snapshot for.
	     * @return True if this node should now be removed.
	     */
	    SparseSnapshotTree.prototype.forget = function (path) {
	        if (path.isEmpty()) {
	            this.value = null;
	            this.children.clear();
	            return true;
	        }
	        else {
	            if (this.value !== null) {
	                if (this.value.isLeafNode()) {
	                    // We're trying to forget a node that doesn't exist
	                    return false;
	                }
	                else {
	                    var value = this.value;
	                    this.value = null;
	                    var self_1 = this;
	                    value.forEachChild(PRIORITY_INDEX, function (key, tree) {
	                        self_1.remember(new Path(key), tree);
	                    });
	                    return this.forget(path);
	                }
	            }
	            else if (this.children.size > 0) {
	                var childKey = path.getFront();
	                path = path.popFront();
	                if (this.children.has(childKey)) {
	                    var safeToRemove = this.children.get(childKey).forget(path);
	                    if (safeToRemove) {
	                        this.children.delete(childKey);
	                    }
	                }
	                return this.children.size === 0;
	            }
	            else {
	                return true;
	            }
	        }
	    };
	    /**
	     * Recursively iterates through all of the stored tree and calls the
	     * callback on each one.
	     *
	     * @param prefixPath Path to look up node for.
	     * @param func The function to invoke for each tree.
	     */
	    SparseSnapshotTree.prototype.forEachTree = function (prefixPath, func) {
	        if (this.value !== null) {
	            func(prefixPath, this.value);
	        }
	        else {
	            this.forEachChild(function (key, tree) {
	                var path = new Path(prefixPath.toString() + '/' + key);
	                tree.forEachTree(path, func);
	            });
	        }
	    };
	    /**
	     * Iterates through each immediate child and triggers the callback.
	     *
	     * @param func The function to invoke for each child.
	     */
	    SparseSnapshotTree.prototype.forEachChild = function (func) {
	        this.children.forEach(function (tree, key) {
	            func(key, tree);
	        });
	    };
	    return SparseSnapshotTree;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 *
	 * @enum
	 */
	var OperationType;
	(function (OperationType) {
	    OperationType[OperationType["OVERWRITE"] = 0] = "OVERWRITE";
	    OperationType[OperationType["MERGE"] = 1] = "MERGE";
	    OperationType[OperationType["ACK_USER_WRITE"] = 2] = "ACK_USER_WRITE";
	    OperationType[OperationType["LISTEN_COMPLETE"] = 3] = "LISTEN_COMPLETE";
	})(OperationType || (OperationType = {}));
	/**
	 * @param {boolean} fromUser
	 * @param {boolean} fromServer
	 * @param {?string} queryId
	 * @param {boolean} tagged
	 * @constructor
	 */
	var OperationSource = /** @class */ (function () {
	    function OperationSource(fromUser, fromServer, queryId, tagged) {
	        this.fromUser = fromUser;
	        this.fromServer = fromServer;
	        this.queryId = queryId;
	        this.tagged = tagged;
	        util.assert(!tagged || fromServer, 'Tagged queries must be from server.');
	    }
	    /**
	     * @const
	     * @type {!OperationSource}
	     */
	    OperationSource.User = new OperationSource(
	    /*fromUser=*/ true, false, null, 
	    /*tagged=*/ false);
	    /**
	     * @const
	     * @type {!OperationSource}
	     */
	    OperationSource.Server = new OperationSource(false, 
	    /*fromServer=*/ true, null, 
	    /*tagged=*/ false);
	    /**
	     * @param {string} queryId
	     * @return {!OperationSource}
	     */
	    OperationSource.forServerTaggedQuery = function (queryId) {
	        return new OperationSource(false, 
	        /*fromServer=*/ true, queryId, 
	        /*tagged=*/ true);
	    };
	    return OperationSource;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var AckUserWrite = /** @class */ (function () {
	    /**
	     *
	     * @param {!Path} path
	     * @param {!ImmutableTree<!boolean>} affectedTree A tree containing true for each affected path. Affected paths can't overlap.
	     * @param {!boolean} revert
	     */
	    function AckUserWrite(
	    /** @inheritDoc */ path, 
	    /** @inheritDoc */ affectedTree, 
	    /** @inheritDoc */ revert) {
	        this.path = path;
	        this.affectedTree = affectedTree;
	        this.revert = revert;
	        /** @inheritDoc */
	        this.type = OperationType.ACK_USER_WRITE;
	        /** @inheritDoc */
	        this.source = OperationSource.User;
	    }
	    /**
	     * @inheritDoc
	     */
	    AckUserWrite.prototype.operationForChild = function (childName) {
	        if (!this.path.isEmpty()) {
	            util.assert(this.path.getFront() === childName, 'operationForChild called for unrelated child.');
	            return new AckUserWrite(this.path.popFront(), this.affectedTree, this.revert);
	        }
	        else if (this.affectedTree.value != null) {
	            util.assert(this.affectedTree.children.isEmpty(), 'affectedTree should not have overlapping affected paths.');
	            // All child locations are affected as well; just return same operation.
	            return this;
	        }
	        else {
	            var childTree = this.affectedTree.subtree(new Path(childName));
	            return new AckUserWrite(Path.Empty, childTree, this.revert);
	        }
	    };
	    return AckUserWrite;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var emptyChildrenSingleton;
	/**
	 * Singleton empty children collection.
	 *
	 * @const
	 * @type {!SortedMap.<string, !ImmutableTree.<?>>}
	 */
	var EmptyChildren = function () {
	    if (!emptyChildrenSingleton) {
	        emptyChildrenSingleton = new SortedMap(stringCompare);
	    }
	    return emptyChildrenSingleton;
	};
	/**
	 * A tree with immutable elements.
	 */
	var ImmutableTree = /** @class */ (function () {
	    /**
	     * @template T
	     * @param {?T} value
	     * @param {SortedMap.<string, !ImmutableTree.<T>>=} children
	     */
	    function ImmutableTree(value, children) {
	        if (children === void 0) { children = EmptyChildren(); }
	        this.value = value;
	        this.children = children;
	    }
	    /**
	     * @template T
	     * @param {!Object.<string, !T>} obj
	     * @return {!ImmutableTree.<!T>}
	     */
	    ImmutableTree.fromObject = function (obj) {
	        var tree = ImmutableTree.Empty;
	        each(obj, function (childPath, childSnap) {
	            tree = tree.set(new Path(childPath), childSnap);
	        });
	        return tree;
	    };
	    /**
	     * True if the value is empty and there are no children
	     * @return {boolean}
	     */
	    ImmutableTree.prototype.isEmpty = function () {
	        return this.value === null && this.children.isEmpty();
	    };
	    /**
	     * Given a path and predicate, return the first node and the path to that node
	     * where the predicate returns true.
	     *
	     * TODO Do a perf test -- If we're creating a bunch of {path: value:} objects
	     * on the way back out, it may be better to pass down a pathSoFar obj.
	     *
	     * @param {!Path} relativePath The remainder of the path
	     * @param {function(T):boolean} predicate The predicate to satisfy to return a
	     *   node
	     * @return {?{path:!Path, value:!T}}
	     */
	    ImmutableTree.prototype.findRootMostMatchingPathAndValue = function (relativePath, predicate) {
	        if (this.value != null && predicate(this.value)) {
	            return { path: Path.Empty, value: this.value };
	        }
	        else {
	            if (relativePath.isEmpty()) {
	                return null;
	            }
	            else {
	                var front = relativePath.getFront();
	                var child = this.children.get(front);
	                if (child !== null) {
	                    var childExistingPathAndValue = child.findRootMostMatchingPathAndValue(relativePath.popFront(), predicate);
	                    if (childExistingPathAndValue != null) {
	                        var fullPath = new Path(front).child(childExistingPathAndValue.path);
	                        return { path: fullPath, value: childExistingPathAndValue.value };
	                    }
	                    else {
	                        return null;
	                    }
	                }
	                else {
	                    return null;
	                }
	            }
	        }
	    };
	    /**
	     * Find, if it exists, the shortest subpath of the given path that points a defined
	     * value in the tree
	     * @param {!Path} relativePath
	     * @return {?{path: !Path, value: !T}}
	     */
	    ImmutableTree.prototype.findRootMostValueAndPath = function (relativePath) {
	        return this.findRootMostMatchingPathAndValue(relativePath, function () { return true; });
	    };
	    /**
	     * @param {!Path} relativePath
	     * @return {!ImmutableTree.<T>} The subtree at the given path
	     */
	    ImmutableTree.prototype.subtree = function (relativePath) {
	        if (relativePath.isEmpty()) {
	            return this;
	        }
	        else {
	            var front = relativePath.getFront();
	            var childTree = this.children.get(front);
	            if (childTree !== null) {
	                return childTree.subtree(relativePath.popFront());
	            }
	            else {
	                return ImmutableTree.Empty;
	            }
	        }
	    };
	    /**
	     * Sets a value at the specified path.
	     *
	     * @param {!Path} relativePath Path to set value at.
	     * @param {?T} toSet Value to set.
	     * @return {!ImmutableTree.<T>} Resulting tree.
	     */
	    ImmutableTree.prototype.set = function (relativePath, toSet) {
	        if (relativePath.isEmpty()) {
	            return new ImmutableTree(toSet, this.children);
	        }
	        else {
	            var front = relativePath.getFront();
	            var child = this.children.get(front) || ImmutableTree.Empty;
	            var newChild = child.set(relativePath.popFront(), toSet);
	            var newChildren = this.children.insert(front, newChild);
	            return new ImmutableTree(this.value, newChildren);
	        }
	    };
	    /**
	     * Removes the value at the specified path.
	     *
	     * @param {!Path} relativePath Path to value to remove.
	     * @return {!ImmutableTree.<T>} Resulting tree.
	     */
	    ImmutableTree.prototype.remove = function (relativePath) {
	        if (relativePath.isEmpty()) {
	            if (this.children.isEmpty()) {
	                return ImmutableTree.Empty;
	            }
	            else {
	                return new ImmutableTree(null, this.children);
	            }
	        }
	        else {
	            var front = relativePath.getFront();
	            var child = this.children.get(front);
	            if (child) {
	                var newChild = child.remove(relativePath.popFront());
	                var newChildren = void 0;
	                if (newChild.isEmpty()) {
	                    newChildren = this.children.remove(front);
	                }
	                else {
	                    newChildren = this.children.insert(front, newChild);
	                }
	                if (this.value === null && newChildren.isEmpty()) {
	                    return ImmutableTree.Empty;
	                }
	                else {
	                    return new ImmutableTree(this.value, newChildren);
	                }
	            }
	            else {
	                return this;
	            }
	        }
	    };
	    /**
	     * Gets a value from the tree.
	     *
	     * @param {!Path} relativePath Path to get value for.
	     * @return {?T} Value at path, or null.
	     */
	    ImmutableTree.prototype.get = function (relativePath) {
	        if (relativePath.isEmpty()) {
	            return this.value;
	        }
	        else {
	            var front = relativePath.getFront();
	            var child = this.children.get(front);
	            if (child) {
	                return child.get(relativePath.popFront());
	            }
	            else {
	                return null;
	            }
	        }
	    };
	    /**
	     * Replace the subtree at the specified path with the given new tree.
	     *
	     * @param {!Path} relativePath Path to replace subtree for.
	     * @param {!ImmutableTree} newTree New tree.
	     * @return {!ImmutableTree} Resulting tree.
	     */
	    ImmutableTree.prototype.setTree = function (relativePath, newTree) {
	        if (relativePath.isEmpty()) {
	            return newTree;
	        }
	        else {
	            var front = relativePath.getFront();
	            var child = this.children.get(front) || ImmutableTree.Empty;
	            var newChild = child.setTree(relativePath.popFront(), newTree);
	            var newChildren = void 0;
	            if (newChild.isEmpty()) {
	                newChildren = this.children.remove(front);
	            }
	            else {
	                newChildren = this.children.insert(front, newChild);
	            }
	            return new ImmutableTree(this.value, newChildren);
	        }
	    };
	    /**
	     * Performs a depth first fold on this tree. Transforms a tree into a single
	     * value, given a function that operates on the path to a node, an optional
	     * current value, and a map of child names to folded subtrees
	     * @template V
	     * @param {function(Path, ?T, Object.<string, V>):V} fn
	     * @return {V}
	     */
	    ImmutableTree.prototype.fold = function (fn) {
	        return this.fold_(Path.Empty, fn);
	    };
	    /**
	     * Recursive helper for public-facing fold() method
	     * @template V
	     * @param {!Path} pathSoFar
	     * @param {function(Path, ?T, Object.<string, V>):V} fn
	     * @return {V}
	     * @private
	     */
	    ImmutableTree.prototype.fold_ = function (pathSoFar, fn) {
	        var accum = {};
	        this.children.inorderTraversal(function (childKey, childTree) {
	            accum[childKey] = childTree.fold_(pathSoFar.child(childKey), fn);
	        });
	        return fn(pathSoFar, this.value, accum);
	    };
	    /**
	     * Find the first matching value on the given path. Return the result of applying f to it.
	     * @template V
	     * @param {!Path} path
	     * @param {!function(!Path, !T):?V} f
	     * @return {?V}
	     */
	    ImmutableTree.prototype.findOnPath = function (path, f) {
	        return this.findOnPath_(path, Path.Empty, f);
	    };
	    ImmutableTree.prototype.findOnPath_ = function (pathToFollow, pathSoFar, f) {
	        var result = this.value ? f(pathSoFar, this.value) : false;
	        if (result) {
	            return result;
	        }
	        else {
	            if (pathToFollow.isEmpty()) {
	                return null;
	            }
	            else {
	                var front = pathToFollow.getFront();
	                var nextChild = this.children.get(front);
	                if (nextChild) {
	                    return nextChild.findOnPath_(pathToFollow.popFront(), pathSoFar.child(front), f);
	                }
	                else {
	                    return null;
	                }
	            }
	        }
	    };
	    /**
	     *
	     * @param {!Path} path
	     * @param {!function(!Path, !T)} f
	     * @returns {!ImmutableTree.<T>}
	     */
	    ImmutableTree.prototype.foreachOnPath = function (path, f) {
	        return this.foreachOnPath_(path, Path.Empty, f);
	    };
	    ImmutableTree.prototype.foreachOnPath_ = function (pathToFollow, currentRelativePath, f) {
	        if (pathToFollow.isEmpty()) {
	            return this;
	        }
	        else {
	            if (this.value) {
	                f(currentRelativePath, this.value);
	            }
	            var front = pathToFollow.getFront();
	            var nextChild = this.children.get(front);
	            if (nextChild) {
	                return nextChild.foreachOnPath_(pathToFollow.popFront(), currentRelativePath.child(front), f);
	            }
	            else {
	                return ImmutableTree.Empty;
	            }
	        }
	    };
	    /**
	     * Calls the given function for each node in the tree that has a value.
	     *
	     * @param {function(!Path, !T)} f A function to be called with
	     *   the path from the root of the tree to a node, and the value at that node.
	     *   Called in depth-first order.
	     */
	    ImmutableTree.prototype.foreach = function (f) {
	        this.foreach_(Path.Empty, f);
	    };
	    ImmutableTree.prototype.foreach_ = function (currentRelativePath, f) {
	        this.children.inorderTraversal(function (childName, childTree) {
	            childTree.foreach_(currentRelativePath.child(childName), f);
	        });
	        if (this.value) {
	            f(currentRelativePath, this.value);
	        }
	    };
	    /**
	     *
	     * @param {function(string, !T)} f
	     */
	    ImmutableTree.prototype.foreachChild = function (f) {
	        this.children.inorderTraversal(function (childName, childTree) {
	            if (childTree.value) {
	                f(childName, childTree.value);
	            }
	        });
	    };
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    ImmutableTree.Empty = new ImmutableTree(null);
	    return ImmutableTree;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @param {!OperationSource} source
	 * @param {!Path} path
	 * @constructor
	 * @implements {Operation}
	 */
	var ListenComplete = /** @class */ (function () {
	    function ListenComplete(source, path) {
	        this.source = source;
	        this.path = path;
	        /** @inheritDoc */
	        this.type = OperationType.LISTEN_COMPLETE;
	    }
	    ListenComplete.prototype.operationForChild = function (childName) {
	        if (this.path.isEmpty()) {
	            return new ListenComplete(this.source, Path.Empty);
	        }
	        else {
	            return new ListenComplete(this.source, this.path.popFront());
	        }
	    };
	    return ListenComplete;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @param {!OperationSource} source
	 * @param {!Path} path
	 * @param {!Node} snap
	 * @constructor
	 * @implements {Operation}
	 */
	var Overwrite = /** @class */ (function () {
	    function Overwrite(source, path, snap) {
	        this.source = source;
	        this.path = path;
	        this.snap = snap;
	        /** @inheritDoc */
	        this.type = OperationType.OVERWRITE;
	    }
	    Overwrite.prototype.operationForChild = function (childName) {
	        if (this.path.isEmpty()) {
	            return new Overwrite(this.source, Path.Empty, this.snap.getImmediateChild(childName));
	        }
	        else {
	            return new Overwrite(this.source, this.path.popFront(), this.snap);
	        }
	    };
	    return Overwrite;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @param {!OperationSource} source
	 * @param {!Path} path
	 * @param {!ImmutableTree.<!Node>} children
	 * @constructor
	 * @implements {Operation}
	 */
	var Merge = /** @class */ (function () {
	    function Merge(
	    /** @inheritDoc */ source, 
	    /** @inheritDoc */ path, 
	    /** @inheritDoc */ children) {
	        this.source = source;
	        this.path = path;
	        this.children = children;
	        /** @inheritDoc */
	        this.type = OperationType.MERGE;
	    }
	    /**
	     * @inheritDoc
	     */
	    Merge.prototype.operationForChild = function (childName) {
	        if (this.path.isEmpty()) {
	            var childTree = this.children.subtree(new Path(childName));
	            if (childTree.isEmpty()) {
	                // This child is unaffected
	                return null;
	            }
	            else if (childTree.value) {
	                // We have a snapshot for the child in question.  This becomes an overwrite of the child.
	                return new Overwrite(this.source, Path.Empty, childTree.value);
	            }
	            else {
	                // This is a merge at a deeper level
	                return new Merge(this.source, Path.Empty, childTree);
	            }
	        }
	        else {
	            util.assert(this.path.getFront() === childName, "Can't get a merge for a child not on the path of the operation");
	            return new Merge(this.source, this.path.popFront(), this.children);
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    Merge.prototype.toString = function () {
	        return ('Operation(' +
	            this.path +
	            ': ' +
	            this.source.toString() +
	            ' merge: ' +
	            this.children.toString() +
	            ')');
	    };
	    return Merge;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * A cache node only stores complete children. Additionally it holds a flag whether the node can be considered fully
	 * initialized in the sense that we know at one point in time this represented a valid state of the world, e.g.
	 * initialized with data from the server, or a complete overwrite by the client. The filtered flag also tracks
	 * whether a node potentially had children removed due to a filter.
	 */
	var CacheNode = /** @class */ (function () {
	    /**
	     * @param {!Node} node_
	     * @param {boolean} fullyInitialized_
	     * @param {boolean} filtered_
	     */
	    function CacheNode(node_, fullyInitialized_, filtered_) {
	        this.node_ = node_;
	        this.fullyInitialized_ = fullyInitialized_;
	        this.filtered_ = filtered_;
	    }
	    /**
	     * Returns whether this node was fully initialized with either server data or a complete overwrite by the client
	     * @return {boolean}
	     */
	    CacheNode.prototype.isFullyInitialized = function () {
	        return this.fullyInitialized_;
	    };
	    /**
	     * Returns whether this node is potentially missing children due to a filter applied to the node
	     * @return {boolean}
	     */
	    CacheNode.prototype.isFiltered = function () {
	        return this.filtered_;
	    };
	    /**
	     * @param {!Path} path
	     * @return {boolean}
	     */
	    CacheNode.prototype.isCompleteForPath = function (path) {
	        if (path.isEmpty()) {
	            return this.isFullyInitialized() && !this.filtered_;
	        }
	        var childKey = path.getFront();
	        return this.isCompleteForChild(childKey);
	    };
	    /**
	     * @param {!string} key
	     * @return {boolean}
	     */
	    CacheNode.prototype.isCompleteForChild = function (key) {
	        return ((this.isFullyInitialized() && !this.filtered_) || this.node_.hasChild(key));
	    };
	    /**
	     * @return {!Node}
	     */
	    CacheNode.prototype.getNode = function () {
	        return this.node_;
	    };
	    return CacheNode;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Stores the data we have cached for a view.
	 *
	 * serverSnap is the cached server data, eventSnap is the cached event data (server data plus any local writes).
	 *
	 * @constructor
	 */
	var ViewCache = /** @class */ (function () {
	    /**
	     *
	     * @param {!CacheNode} eventCache_
	     * @param {!CacheNode} serverCache_
	     */
	    function ViewCache(eventCache_, serverCache_) {
	        this.eventCache_ = eventCache_;
	        this.serverCache_ = serverCache_;
	    }
	    /**
	     * @param {!Node} eventSnap
	     * @param {boolean} complete
	     * @param {boolean} filtered
	     * @return {!ViewCache}
	     */
	    ViewCache.prototype.updateEventSnap = function (eventSnap, complete, filtered) {
	        return new ViewCache(new CacheNode(eventSnap, complete, filtered), this.serverCache_);
	    };
	    /**
	     * @param {!Node} serverSnap
	     * @param {boolean} complete
	     * @param {boolean} filtered
	     * @return {!ViewCache}
	     */
	    ViewCache.prototype.updateServerSnap = function (serverSnap, complete, filtered) {
	        return new ViewCache(this.eventCache_, new CacheNode(serverSnap, complete, filtered));
	    };
	    /**
	     * @return {!CacheNode}
	     */
	    ViewCache.prototype.getEventCache = function () {
	        return this.eventCache_;
	    };
	    /**
	     * @return {?Node}
	     */
	    ViewCache.prototype.getCompleteEventSnap = function () {
	        return this.eventCache_.isFullyInitialized()
	            ? this.eventCache_.getNode()
	            : null;
	    };
	    /**
	     * @return {!CacheNode}
	     */
	    ViewCache.prototype.getServerCache = function () {
	        return this.serverCache_;
	    };
	    /**
	     * @return {?Node}
	     */
	    ViewCache.prototype.getCompleteServerSnap = function () {
	        return this.serverCache_.isFullyInitialized()
	            ? this.serverCache_.getNode()
	            : null;
	    };
	    /**
	     * @const
	     * @type {ViewCache}
	     */
	    ViewCache.Empty = new ViewCache(new CacheNode(ChildrenNode.EMPTY_NODE, 
	    /*fullyInitialized=*/ false, 
	    /*filtered=*/ false), new CacheNode(ChildrenNode.EMPTY_NODE, 
	    /*fullyInitialized=*/ false, 
	    /*filtered=*/ false));
	    return ViewCache;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @constructor
	 * @struct
	 * @param {!string} type The event type
	 * @param {!Node} snapshotNode The data
	 * @param {string=} childName The name for this child, if it's a child event
	 * @param {Node=} oldSnap Used for intermediate processing of child changed events
	 * @param {string=} prevName The name for the previous child, if applicable
	 */
	var Change = /** @class */ (function () {
	    function Change(type, snapshotNode, childName, oldSnap, prevName) {
	        this.type = type;
	        this.snapshotNode = snapshotNode;
	        this.childName = childName;
	        this.oldSnap = oldSnap;
	        this.prevName = prevName;
	    }
	    /**
	     * @param {!Node} snapshot
	     * @return {!Change}
	     */
	    Change.valueChange = function (snapshot) {
	        return new Change(Change.VALUE, snapshot);
	    };
	    /**
	     * @param {string} childKey
	     * @param {!Node} snapshot
	     * @return {!Change}
	     */
	    Change.childAddedChange = function (childKey, snapshot) {
	        return new Change(Change.CHILD_ADDED, snapshot, childKey);
	    };
	    /**
	     * @param {string} childKey
	     * @param {!Node} snapshot
	     * @return {!Change}
	     */
	    Change.childRemovedChange = function (childKey, snapshot) {
	        return new Change(Change.CHILD_REMOVED, snapshot, childKey);
	    };
	    /**
	     * @param {string} childKey
	     * @param {!Node} newSnapshot
	     * @param {!Node} oldSnapshot
	     * @return {!Change}
	     */
	    Change.childChangedChange = function (childKey, newSnapshot, oldSnapshot) {
	        return new Change(Change.CHILD_CHANGED, newSnapshot, childKey, oldSnapshot);
	    };
	    /**
	     * @param {string} childKey
	     * @param {!Node} snapshot
	     * @return {!Change}
	     */
	    Change.childMovedChange = function (childKey, snapshot) {
	        return new Change(Change.CHILD_MOVED, snapshot, childKey);
	    };
	    //event types
	    /** Event type for a child added */
	    Change.CHILD_ADDED = 'child_added';
	    /** Event type for a child removed */
	    Change.CHILD_REMOVED = 'child_removed';
	    /** Event type for a child changed */
	    Change.CHILD_CHANGED = 'child_changed';
	    /** Event type for a child moved */
	    Change.CHILD_MOVED = 'child_moved';
	    /** Event type for a value change */
	    Change.VALUE = 'value';
	    return Change;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Doesn't really filter nodes but applies an index to the node and keeps track of any changes
	 *
	 * @constructor
	 * @implements {NodeFilter}
	 * @param {!Index} index
	 */
	var IndexedFilter = /** @class */ (function () {
	    function IndexedFilter(index_) {
	        this.index_ = index_;
	    }
	    IndexedFilter.prototype.updateChild = function (snap, key, newChild, affectedPath, source, optChangeAccumulator) {
	        util.assert(snap.isIndexed(this.index_), 'A node must be indexed if only a child is updated');
	        var oldChild = snap.getImmediateChild(key);
	        // Check if anything actually changed.
	        if (oldChild.getChild(affectedPath).equals(newChild.getChild(affectedPath))) {
	            // There's an edge case where a child can enter or leave the view because affectedPath was set to null.
	            // In this case, affectedPath will appear null in both the old and new snapshots.  So we need
	            // to avoid treating these cases as "nothing changed."
	            if (oldChild.isEmpty() === newChild.isEmpty()) {
	                // Nothing changed.
	                // This assert should be valid, but it's expensive (can dominate perf testing) so don't actually do it.
	                //assert(oldChild.equals(newChild), 'Old and new snapshots should be equal.');
	                return snap;
	            }
	        }
	        if (optChangeAccumulator != null) {
	            if (newChild.isEmpty()) {
	                if (snap.hasChild(key)) {
	                    optChangeAccumulator.trackChildChange(Change.childRemovedChange(key, oldChild));
	                }
	                else {
	                    util.assert(snap.isLeafNode(), 'A child remove without an old child only makes sense on a leaf node');
	                }
	            }
	            else if (oldChild.isEmpty()) {
	                optChangeAccumulator.trackChildChange(Change.childAddedChange(key, newChild));
	            }
	            else {
	                optChangeAccumulator.trackChildChange(Change.childChangedChange(key, newChild, oldChild));
	            }
	        }
	        if (snap.isLeafNode() && newChild.isEmpty()) {
	            return snap;
	        }
	        else {
	            // Make sure the node is indexed
	            return snap.updateImmediateChild(key, newChild).withIndex(this.index_);
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    IndexedFilter.prototype.updateFullNode = function (oldSnap, newSnap, optChangeAccumulator) {
	        if (optChangeAccumulator != null) {
	            if (!oldSnap.isLeafNode()) {
	                oldSnap.forEachChild(PRIORITY_INDEX, function (key, childNode) {
	                    if (!newSnap.hasChild(key)) {
	                        optChangeAccumulator.trackChildChange(Change.childRemovedChange(key, childNode));
	                    }
	                });
	            }
	            if (!newSnap.isLeafNode()) {
	                newSnap.forEachChild(PRIORITY_INDEX, function (key, childNode) {
	                    if (oldSnap.hasChild(key)) {
	                        var oldChild = oldSnap.getImmediateChild(key);
	                        if (!oldChild.equals(childNode)) {
	                            optChangeAccumulator.trackChildChange(Change.childChangedChange(key, childNode, oldChild));
	                        }
	                    }
	                    else {
	                        optChangeAccumulator.trackChildChange(Change.childAddedChange(key, childNode));
	                    }
	                });
	            }
	        }
	        return newSnap.withIndex(this.index_);
	    };
	    /**
	     * @inheritDoc
	     */
	    IndexedFilter.prototype.updatePriority = function (oldSnap, newPriority) {
	        if (oldSnap.isEmpty()) {
	            return ChildrenNode.EMPTY_NODE;
	        }
	        else {
	            return oldSnap.updatePriority(newPriority);
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    IndexedFilter.prototype.filtersNodes = function () {
	        return false;
	    };
	    /**
	     * @inheritDoc
	     */
	    IndexedFilter.prototype.getIndexedFilter = function () {
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    IndexedFilter.prototype.getIndex = function () {
	        return this.index_;
	    };
	    return IndexedFilter;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var ChildChangeAccumulator = /** @class */ (function () {
	    function ChildChangeAccumulator() {
	        this.changeMap = new Map();
	    }
	    ChildChangeAccumulator.prototype.trackChildChange = function (change) {
	        var type = change.type;
	        var childKey = change.childName;
	        util.assert(type === Change.CHILD_ADDED ||
	            type === Change.CHILD_CHANGED ||
	            type === Change.CHILD_REMOVED, 'Only child changes supported for tracking');
	        util.assert(childKey !== '.priority', 'Only non-priority child changes can be tracked.');
	        var oldChange = this.changeMap.get(childKey);
	        if (oldChange) {
	            var oldType = oldChange.type;
	            if (type === Change.CHILD_ADDED && oldType === Change.CHILD_REMOVED) {
	                this.changeMap.set(childKey, Change.childChangedChange(childKey, change.snapshotNode, oldChange.snapshotNode));
	            }
	            else if (type === Change.CHILD_REMOVED &&
	                oldType === Change.CHILD_ADDED) {
	                this.changeMap.delete(childKey);
	            }
	            else if (type === Change.CHILD_REMOVED &&
	                oldType === Change.CHILD_CHANGED) {
	                this.changeMap.set(childKey, Change.childRemovedChange(childKey, oldChange.oldSnap));
	            }
	            else if (type === Change.CHILD_CHANGED &&
	                oldType === Change.CHILD_ADDED) {
	                this.changeMap.set(childKey, Change.childAddedChange(childKey, change.snapshotNode));
	            }
	            else if (type === Change.CHILD_CHANGED &&
	                oldType === Change.CHILD_CHANGED) {
	                this.changeMap.set(childKey, Change.childChangedChange(childKey, change.snapshotNode, oldChange.oldSnap));
	            }
	            else {
	                throw util.assertionError('Illegal combination of changes: ' +
	                    change +
	                    ' occurred after ' +
	                    oldChange);
	            }
	        }
	        else {
	            this.changeMap.set(childKey, change);
	        }
	    };
	    ChildChangeAccumulator.prototype.getChanges = function () {
	        return Array.from(this.changeMap.values());
	    };
	    return ChildChangeAccumulator;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * An implementation of CompleteChildSource that never returns any additional children
	 *
	 * @private
	 * @constructor
	 * @implements CompleteChildSource
	 */
	// eslint-disable-next-line @typescript-eslint/class-name-casing
	var NoCompleteChildSource_ = /** @class */ (function () {
	    function NoCompleteChildSource_() {
	    }
	    /**
	     * @inheritDoc
	     */
	    NoCompleteChildSource_.prototype.getCompleteChild = function (childKey) {
	        return null;
	    };
	    /**
	     * @inheritDoc
	     */
	    NoCompleteChildSource_.prototype.getChildAfterChild = function (index, child, reverse) {
	        return null;
	    };
	    return NoCompleteChildSource_;
	}());
	/**
	 * Singleton instance.
	 * @const
	 * @type {!CompleteChildSource}
	 */
	var NO_COMPLETE_CHILD_SOURCE = new NoCompleteChildSource_();
	/**
	 * An implementation of CompleteChildSource that uses a WriteTree in addition to any other server data or
	 * old event caches available to calculate complete children.
	 *
	 *
	 * @implements CompleteChildSource
	 */
	var WriteTreeCompleteChildSource = /** @class */ (function () {
	    /**
	     * @param {!WriteTreeRef} writes_
	     * @param {!ViewCache} viewCache_
	     * @param {?Node} optCompleteServerCache_
	     */
	    function WriteTreeCompleteChildSource(writes_, viewCache_, optCompleteServerCache_) {
	        if (optCompleteServerCache_ === void 0) { optCompleteServerCache_ = null; }
	        this.writes_ = writes_;
	        this.viewCache_ = viewCache_;
	        this.optCompleteServerCache_ = optCompleteServerCache_;
	    }
	    /**
	     * @inheritDoc
	     */
	    WriteTreeCompleteChildSource.prototype.getCompleteChild = function (childKey) {
	        var node = this.viewCache_.getEventCache();
	        if (node.isCompleteForChild(childKey)) {
	            return node.getNode().getImmediateChild(childKey);
	        }
	        else {
	            var serverNode = this.optCompleteServerCache_ != null
	                ? new CacheNode(this.optCompleteServerCache_, true, false)
	                : this.viewCache_.getServerCache();
	            return this.writes_.calcCompleteChild(childKey, serverNode);
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    WriteTreeCompleteChildSource.prototype.getChildAfterChild = function (index, child, reverse) {
	        var completeServerData = this.optCompleteServerCache_ != null
	            ? this.optCompleteServerCache_
	            : this.viewCache_.getCompleteServerSnap();
	        var nodes = this.writes_.calcIndexedSlice(completeServerData, child, 1, reverse, index);
	        if (nodes.length === 0) {
	            return null;
	        }
	        else {
	            return nodes[0];
	        }
	    };
	    return WriteTreeCompleteChildSource;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @constructor
	 * @struct
	 */
	var ProcessorResult = /** @class */ (function () {
	    /**
	     * @param {!ViewCache} viewCache
	     * @param {!Array.<!Change>} changes
	     */
	    function ProcessorResult(viewCache, changes) {
	        this.viewCache = viewCache;
	        this.changes = changes;
	    }
	    return ProcessorResult;
	}());
	/**
	 * @constructor
	 */
	var ViewProcessor = /** @class */ (function () {
	    /**
	     * @param {!NodeFilter} filter_
	     */
	    function ViewProcessor(filter_) {
	        this.filter_ = filter_;
	    }
	    /**
	     * @param {!ViewCache} viewCache
	     */
	    ViewProcessor.prototype.assertIndexed = function (viewCache) {
	        util.assert(viewCache
	            .getEventCache()
	            .getNode()
	            .isIndexed(this.filter_.getIndex()), 'Event snap not indexed');
	        util.assert(viewCache
	            .getServerCache()
	            .getNode()
	            .isIndexed(this.filter_.getIndex()), 'Server snap not indexed');
	    };
	    /**
	     * @param {!ViewCache} oldViewCache
	     * @param {!Operation} operation
	     * @param {!WriteTreeRef} writesCache
	     * @param {?Node} completeCache
	     * @return {!ProcessorResult}
	     */
	    ViewProcessor.prototype.applyOperation = function (oldViewCache, operation, writesCache, completeCache) {
	        var accumulator = new ChildChangeAccumulator();
	        var newViewCache, filterServerNode;
	        if (operation.type === OperationType.OVERWRITE) {
	            var overwrite = operation;
	            if (overwrite.source.fromUser) {
	                newViewCache = this.applyUserOverwrite_(oldViewCache, overwrite.path, overwrite.snap, writesCache, completeCache, accumulator);
	            }
	            else {
	                util.assert(overwrite.source.fromServer, 'Unknown source.');
	                // We filter the node if it's a tagged update or the node has been previously filtered  and the
	                // update is not at the root in which case it is ok (and necessary) to mark the node unfiltered
	                // again
	                filterServerNode =
	                    overwrite.source.tagged ||
	                        (oldViewCache.getServerCache().isFiltered() &&
	                            !overwrite.path.isEmpty());
	                newViewCache = this.applyServerOverwrite_(oldViewCache, overwrite.path, overwrite.snap, writesCache, completeCache, filterServerNode, accumulator);
	            }
	        }
	        else if (operation.type === OperationType.MERGE) {
	            var merge = operation;
	            if (merge.source.fromUser) {
	                newViewCache = this.applyUserMerge_(oldViewCache, merge.path, merge.children, writesCache, completeCache, accumulator);
	            }
	            else {
	                util.assert(merge.source.fromServer, 'Unknown source.');
	                // We filter the node if it's a tagged update or the node has been previously filtered
	                filterServerNode =
	                    merge.source.tagged || oldViewCache.getServerCache().isFiltered();
	                newViewCache = this.applyServerMerge_(oldViewCache, merge.path, merge.children, writesCache, completeCache, filterServerNode, accumulator);
	            }
	        }
	        else if (operation.type === OperationType.ACK_USER_WRITE) {
	            var ackUserWrite = operation;
	            if (!ackUserWrite.revert) {
	                newViewCache = this.ackUserWrite_(oldViewCache, ackUserWrite.path, ackUserWrite.affectedTree, writesCache, completeCache, accumulator);
	            }
	            else {
	                newViewCache = this.revertUserWrite_(oldViewCache, ackUserWrite.path, writesCache, completeCache, accumulator);
	            }
	        }
	        else if (operation.type === OperationType.LISTEN_COMPLETE) {
	            newViewCache = this.listenComplete_(oldViewCache, operation.path, writesCache, accumulator);
	        }
	        else {
	            throw util.assertionError('Unknown operation type: ' + operation.type);
	        }
	        var changes = accumulator.getChanges();
	        ViewProcessor.maybeAddValueEvent_(oldViewCache, newViewCache, changes);
	        return new ProcessorResult(newViewCache, changes);
	    };
	    /**
	     * @param {!ViewCache} oldViewCache
	     * @param {!ViewCache} newViewCache
	     * @param {!Array.<!Change>} accumulator
	     * @private
	     */
	    ViewProcessor.maybeAddValueEvent_ = function (oldViewCache, newViewCache, accumulator) {
	        var eventSnap = newViewCache.getEventCache();
	        if (eventSnap.isFullyInitialized()) {
	            var isLeafOrEmpty = eventSnap.getNode().isLeafNode() || eventSnap.getNode().isEmpty();
	            var oldCompleteSnap = oldViewCache.getCompleteEventSnap();
	            if (accumulator.length > 0 ||
	                !oldViewCache.getEventCache().isFullyInitialized() ||
	                (isLeafOrEmpty &&
	                    !eventSnap.getNode().equals(/** @type {!Node} */ oldCompleteSnap)) ||
	                !eventSnap
	                    .getNode()
	                    .getPriority()
	                    .equals(oldCompleteSnap.getPriority())) {
	                accumulator.push(Change.valueChange(
	                /** @type {!Node} */ newViewCache.getCompleteEventSnap()));
	            }
	        }
	    };
	    /**
	     * @param {!ViewCache} viewCache
	     * @param {!Path} changePath
	     * @param {!WriteTreeRef} writesCache
	     * @param {!CompleteChildSource} source
	     * @param {!ChildChangeAccumulator} accumulator
	     * @return {!ViewCache}
	     * @private
	     */
	    ViewProcessor.prototype.generateEventCacheAfterServerEvent_ = function (viewCache, changePath, writesCache, source, accumulator) {
	        var oldEventSnap = viewCache.getEventCache();
	        if (writesCache.shadowingWrite(changePath) != null) {
	            // we have a shadowing write, ignore changes
	            return viewCache;
	        }
	        else {
	            var newEventCache = void 0, serverNode = void 0;
	            if (changePath.isEmpty()) {
	                // TODO: figure out how this plays with "sliding ack windows"
	                util.assert(viewCache.getServerCache().isFullyInitialized(), 'If change path is empty, we must have complete server data');
	                if (viewCache.getServerCache().isFiltered()) {
	                    // We need to special case this, because we need to only apply writes to complete children, or
	                    // we might end up raising events for incomplete children. If the server data is filtered deep
	                    // writes cannot be guaranteed to be complete
	                    var serverCache = viewCache.getCompleteServerSnap();
	                    var completeChildren = serverCache instanceof ChildrenNode
	                        ? serverCache
	                        : ChildrenNode.EMPTY_NODE;
	                    var completeEventChildren = writesCache.calcCompleteEventChildren(completeChildren);
	                    newEventCache = this.filter_.updateFullNode(viewCache.getEventCache().getNode(), completeEventChildren, accumulator);
	                }
	                else {
	                    var completeNode = writesCache.calcCompleteEventCache(viewCache.getCompleteServerSnap());
	                    newEventCache = this.filter_.updateFullNode(viewCache.getEventCache().getNode(), completeNode, accumulator);
	                }
	            }
	            else {
	                var childKey = changePath.getFront();
	                if (childKey === '.priority') {
	                    util.assert(changePath.getLength() === 1, "Can't have a priority with additional path components");
	                    var oldEventNode = oldEventSnap.getNode();
	                    serverNode = viewCache.getServerCache().getNode();
	                    // we might have overwrites for this priority
	                    var updatedPriority = writesCache.calcEventCacheAfterServerOverwrite(changePath, oldEventNode, serverNode);
	                    if (updatedPriority != null) {
	                        newEventCache = this.filter_.updatePriority(oldEventNode, updatedPriority);
	                    }
	                    else {
	                        // priority didn't change, keep old node
	                        newEventCache = oldEventSnap.getNode();
	                    }
	                }
	                else {
	                    var childChangePath = changePath.popFront();
	                    // update child
	                    var newEventChild = void 0;
	                    if (oldEventSnap.isCompleteForChild(childKey)) {
	                        serverNode = viewCache.getServerCache().getNode();
	                        var eventChildUpdate = writesCache.calcEventCacheAfterServerOverwrite(changePath, oldEventSnap.getNode(), serverNode);
	                        if (eventChildUpdate != null) {
	                            newEventChild = oldEventSnap
	                                .getNode()
	                                .getImmediateChild(childKey)
	                                .updateChild(childChangePath, eventChildUpdate);
	                        }
	                        else {
	                            // Nothing changed, just keep the old child
	                            newEventChild = oldEventSnap
	                                .getNode()
	                                .getImmediateChild(childKey);
	                        }
	                    }
	                    else {
	                        newEventChild = writesCache.calcCompleteChild(childKey, viewCache.getServerCache());
	                    }
	                    if (newEventChild != null) {
	                        newEventCache = this.filter_.updateChild(oldEventSnap.getNode(), childKey, newEventChild, childChangePath, source, accumulator);
	                    }
	                    else {
	                        // no complete child available or no change
	                        newEventCache = oldEventSnap.getNode();
	                    }
	                }
	            }
	            return viewCache.updateEventSnap(newEventCache, oldEventSnap.isFullyInitialized() || changePath.isEmpty(), this.filter_.filtersNodes());
	        }
	    };
	    /**
	     * @param {!ViewCache} oldViewCache
	     * @param {!Path} changePath
	     * @param {!Node} changedSnap
	     * @param {!WriteTreeRef} writesCache
	     * @param {?Node} completeCache
	     * @param {boolean} filterServerNode
	     * @param {!ChildChangeAccumulator} accumulator
	     * @return {!ViewCache}
	     * @private
	     */
	    ViewProcessor.prototype.applyServerOverwrite_ = function (oldViewCache, changePath, changedSnap, writesCache, completeCache, filterServerNode, accumulator) {
	        var oldServerSnap = oldViewCache.getServerCache();
	        var newServerCache;
	        var serverFilter = filterServerNode
	            ? this.filter_
	            : this.filter_.getIndexedFilter();
	        if (changePath.isEmpty()) {
	            newServerCache = serverFilter.updateFullNode(oldServerSnap.getNode(), changedSnap, null);
	        }
	        else if (serverFilter.filtersNodes() && !oldServerSnap.isFiltered()) {
	            // we want to filter the server node, but we didn't filter the server node yet, so simulate a full update
	            var newServerNode = oldServerSnap
	                .getNode()
	                .updateChild(changePath, changedSnap);
	            newServerCache = serverFilter.updateFullNode(oldServerSnap.getNode(), newServerNode, null);
	        }
	        else {
	            var childKey = changePath.getFront();
	            if (!oldServerSnap.isCompleteForPath(changePath) &&
	                changePath.getLength() > 1) {
	                // We don't update incomplete nodes with updates intended for other listeners
	                return oldViewCache;
	            }
	            var childChangePath = changePath.popFront();
	            var childNode = oldServerSnap.getNode().getImmediateChild(childKey);
	            var newChildNode = childNode.updateChild(childChangePath, changedSnap);
	            if (childKey === '.priority') {
	                newServerCache = serverFilter.updatePriority(oldServerSnap.getNode(), newChildNode);
	            }
	            else {
	                newServerCache = serverFilter.updateChild(oldServerSnap.getNode(), childKey, newChildNode, childChangePath, NO_COMPLETE_CHILD_SOURCE, null);
	            }
	        }
	        var newViewCache = oldViewCache.updateServerSnap(newServerCache, oldServerSnap.isFullyInitialized() || changePath.isEmpty(), serverFilter.filtersNodes());
	        var source = new WriteTreeCompleteChildSource(writesCache, newViewCache, completeCache);
	        return this.generateEventCacheAfterServerEvent_(newViewCache, changePath, writesCache, source, accumulator);
	    };
	    /**
	     * @param {!ViewCache} oldViewCache
	     * @param {!Path} changePath
	     * @param {!Node} changedSnap
	     * @param {!WriteTreeRef} writesCache
	     * @param {?Node} completeCache
	     * @param {!ChildChangeAccumulator} accumulator
	     * @return {!ViewCache}
	     * @private
	     */
	    ViewProcessor.prototype.applyUserOverwrite_ = function (oldViewCache, changePath, changedSnap, writesCache, completeCache, accumulator) {
	        var oldEventSnap = oldViewCache.getEventCache();
	        var newViewCache, newEventCache;
	        var source = new WriteTreeCompleteChildSource(writesCache, oldViewCache, completeCache);
	        if (changePath.isEmpty()) {
	            newEventCache = this.filter_.updateFullNode(oldViewCache.getEventCache().getNode(), changedSnap, accumulator);
	            newViewCache = oldViewCache.updateEventSnap(newEventCache, true, this.filter_.filtersNodes());
	        }
	        else {
	            var childKey = changePath.getFront();
	            if (childKey === '.priority') {
	                newEventCache = this.filter_.updatePriority(oldViewCache.getEventCache().getNode(), changedSnap);
	                newViewCache = oldViewCache.updateEventSnap(newEventCache, oldEventSnap.isFullyInitialized(), oldEventSnap.isFiltered());
	            }
	            else {
	                var childChangePath = changePath.popFront();
	                var oldChild = oldEventSnap.getNode().getImmediateChild(childKey);
	                var newChild = void 0;
	                if (childChangePath.isEmpty()) {
	                    // Child overwrite, we can replace the child
	                    newChild = changedSnap;
	                }
	                else {
	                    var childNode = source.getCompleteChild(childKey);
	                    if (childNode != null) {
	                        if (childChangePath.getBack() === '.priority' &&
	                            childNode.getChild(childChangePath.parent()).isEmpty()) {
	                            // This is a priority update on an empty node. If this node exists on the server, the
	                            // server will send down the priority in the update, so ignore for now
	                            newChild = childNode;
	                        }
	                        else {
	                            newChild = childNode.updateChild(childChangePath, changedSnap);
	                        }
	                    }
	                    else {
	                        // There is no complete child node available
	                        newChild = ChildrenNode.EMPTY_NODE;
	                    }
	                }
	                if (!oldChild.equals(newChild)) {
	                    var newEventSnap = this.filter_.updateChild(oldEventSnap.getNode(), childKey, newChild, childChangePath, source, accumulator);
	                    newViewCache = oldViewCache.updateEventSnap(newEventSnap, oldEventSnap.isFullyInitialized(), this.filter_.filtersNodes());
	                }
	                else {
	                    newViewCache = oldViewCache;
	                }
	            }
	        }
	        return newViewCache;
	    };
	    /**
	     * @param {!ViewCache} viewCache
	     * @param {string} childKey
	     * @return {boolean}
	     * @private
	     */
	    ViewProcessor.cacheHasChild_ = function (viewCache, childKey) {
	        return viewCache.getEventCache().isCompleteForChild(childKey);
	    };
	    /**
	     * @param {!ViewCache} viewCache
	     * @param {!Path} path
	     * @param {ImmutableTree.<!Node>} changedChildren
	     * @param {!WriteTreeRef} writesCache
	     * @param {?Node} serverCache
	     * @param {!ChildChangeAccumulator} accumulator
	     * @return {!ViewCache}
	     * @private
	     */
	    ViewProcessor.prototype.applyUserMerge_ = function (viewCache, path, changedChildren, writesCache, serverCache, accumulator) {
	        var _this = this;
	        // HACK: In the case of a limit query, there may be some changes that bump things out of the
	        // window leaving room for new items.  It's important we process these changes first, so we
	        // iterate the changes twice, first processing any that affect items currently in view.
	        // TODO: I consider an item "in view" if cacheHasChild is true, which checks both the server
	        // and event snap.  I'm not sure if this will result in edge cases when a child is in one but
	        // not the other.
	        var curViewCache = viewCache;
	        changedChildren.foreach(function (relativePath, childNode) {
	            var writePath = path.child(relativePath);
	            if (ViewProcessor.cacheHasChild_(viewCache, writePath.getFront())) {
	                curViewCache = _this.applyUserOverwrite_(curViewCache, writePath, childNode, writesCache, serverCache, accumulator);
	            }
	        });
	        changedChildren.foreach(function (relativePath, childNode) {
	            var writePath = path.child(relativePath);
	            if (!ViewProcessor.cacheHasChild_(viewCache, writePath.getFront())) {
	                curViewCache = _this.applyUserOverwrite_(curViewCache, writePath, childNode, writesCache, serverCache, accumulator);
	            }
	        });
	        return curViewCache;
	    };
	    /**
	     * @param {!Node} node
	     * @param {ImmutableTree.<!Node>} merge
	     * @return {!Node}
	     * @private
	     */
	    ViewProcessor.prototype.applyMerge_ = function (node, merge) {
	        merge.foreach(function (relativePath, childNode) {
	            node = node.updateChild(relativePath, childNode);
	        });
	        return node;
	    };
	    /**
	     * @param {!ViewCache} viewCache
	     * @param {!Path} path
	     * @param {!ImmutableTree.<!Node>} changedChildren
	     * @param {!WriteTreeRef} writesCache
	     * @param {?Node} serverCache
	     * @param {boolean} filterServerNode
	     * @param {!ChildChangeAccumulator} accumulator
	     * @return {!ViewCache}
	     * @private
	     */
	    ViewProcessor.prototype.applyServerMerge_ = function (viewCache, path, changedChildren, writesCache, serverCache, filterServerNode, accumulator) {
	        var _this = this;
	        // If we don't have a cache yet, this merge was intended for a previously listen in the same location. Ignore it and
	        // wait for the complete data update coming soon.
	        if (viewCache
	            .getServerCache()
	            .getNode()
	            .isEmpty() &&
	            !viewCache.getServerCache().isFullyInitialized()) {
	            return viewCache;
	        }
	        // HACK: In the case of a limit query, there may be some changes that bump things out of the
	        // window leaving room for new items.  It's important we process these changes first, so we
	        // iterate the changes twice, first processing any that affect items currently in view.
	        // TODO: I consider an item "in view" if cacheHasChild is true, which checks both the server
	        // and event snap.  I'm not sure if this will result in edge cases when a child is in one but
	        // not the other.
	        var curViewCache = viewCache;
	        var viewMergeTree;
	        if (path.isEmpty()) {
	            viewMergeTree = changedChildren;
	        }
	        else {
	            viewMergeTree = ImmutableTree.Empty.setTree(path, changedChildren);
	        }
	        var serverNode = viewCache.getServerCache().getNode();
	        viewMergeTree.children.inorderTraversal(function (childKey, childTree) {
	            if (serverNode.hasChild(childKey)) {
	                var serverChild = viewCache
	                    .getServerCache()
	                    .getNode()
	                    .getImmediateChild(childKey);
	                var newChild = _this.applyMerge_(serverChild, childTree);
	                curViewCache = _this.applyServerOverwrite_(curViewCache, new Path(childKey), newChild, writesCache, serverCache, filterServerNode, accumulator);
	            }
	        });
	        viewMergeTree.children.inorderTraversal(function (childKey, childMergeTree) {
	            var isUnknownDeepMerge = !viewCache.getServerCache().isCompleteForChild(childKey) &&
	                childMergeTree.value == null;
	            if (!serverNode.hasChild(childKey) && !isUnknownDeepMerge) {
	                var serverChild = viewCache
	                    .getServerCache()
	                    .getNode()
	                    .getImmediateChild(childKey);
	                var newChild = _this.applyMerge_(serverChild, childMergeTree);
	                curViewCache = _this.applyServerOverwrite_(curViewCache, new Path(childKey), newChild, writesCache, serverCache, filterServerNode, accumulator);
	            }
	        });
	        return curViewCache;
	    };
	    /**
	     * @param {!ViewCache} viewCache
	     * @param {!Path} ackPath
	     * @param {!ImmutableTree<!boolean>} affectedTree
	     * @param {!WriteTreeRef} writesCache
	     * @param {?Node} completeCache
	     * @param {!ChildChangeAccumulator} accumulator
	     * @return {!ViewCache}
	     * @private
	     */
	    ViewProcessor.prototype.ackUserWrite_ = function (viewCache, ackPath, affectedTree, writesCache, completeCache, accumulator) {
	        if (writesCache.shadowingWrite(ackPath) != null) {
	            return viewCache;
	        }
	        // Only filter server node if it is currently filtered
	        var filterServerNode = viewCache.getServerCache().isFiltered();
	        // Essentially we'll just get our existing server cache for the affected paths and re-apply it as a server update
	        // now that it won't be shadowed.
	        var serverCache = viewCache.getServerCache();
	        if (affectedTree.value != null) {
	            // This is an overwrite.
	            if ((ackPath.isEmpty() && serverCache.isFullyInitialized()) ||
	                serverCache.isCompleteForPath(ackPath)) {
	                return this.applyServerOverwrite_(viewCache, ackPath, serverCache.getNode().getChild(ackPath), writesCache, completeCache, filterServerNode, accumulator);
	            }
	            else if (ackPath.isEmpty()) {
	                // This is a goofy edge case where we are acking data at this location but don't have full data.  We
	                // should just re-apply whatever we have in our cache as a merge.
	                var changedChildren_1 = ImmutableTree.Empty;
	                serverCache.getNode().forEachChild(KEY_INDEX, function (name, node) {
	                    changedChildren_1 = changedChildren_1.set(new Path(name), node);
	                });
	                return this.applyServerMerge_(viewCache, ackPath, changedChildren_1, writesCache, completeCache, filterServerNode, accumulator);
	            }
	            else {
	                return viewCache;
	            }
	        }
	        else {
	            // This is a merge.
	            var changedChildren_2 = ImmutableTree.Empty;
	            affectedTree.foreach(function (mergePath, value) {
	                var serverCachePath = ackPath.child(mergePath);
	                if (serverCache.isCompleteForPath(serverCachePath)) {
	                    changedChildren_2 = changedChildren_2.set(mergePath, serverCache.getNode().getChild(serverCachePath));
	                }
	            });
	            return this.applyServerMerge_(viewCache, ackPath, changedChildren_2, writesCache, completeCache, filterServerNode, accumulator);
	        }
	    };
	    /**
	     * @param {!ViewCache} viewCache
	     * @param {!Path} path
	     * @param {!WriteTreeRef} writesCache
	     * @param {!ChildChangeAccumulator} accumulator
	     * @return {!ViewCache}
	     * @private
	     */
	    ViewProcessor.prototype.listenComplete_ = function (viewCache, path, writesCache, accumulator) {
	        var oldServerNode = viewCache.getServerCache();
	        var newViewCache = viewCache.updateServerSnap(oldServerNode.getNode(), oldServerNode.isFullyInitialized() || path.isEmpty(), oldServerNode.isFiltered());
	        return this.generateEventCacheAfterServerEvent_(newViewCache, path, writesCache, NO_COMPLETE_CHILD_SOURCE, accumulator);
	    };
	    /**
	     * @param {!ViewCache} viewCache
	     * @param {!Path} path
	     * @param {!WriteTreeRef} writesCache
	     * @param {?Node} completeServerCache
	     * @param {!ChildChangeAccumulator} accumulator
	     * @return {!ViewCache}
	     * @private
	     */
	    ViewProcessor.prototype.revertUserWrite_ = function (viewCache, path, writesCache, completeServerCache, accumulator) {
	        var complete;
	        if (writesCache.shadowingWrite(path) != null) {
	            return viewCache;
	        }
	        else {
	            var source = new WriteTreeCompleteChildSource(writesCache, viewCache, completeServerCache);
	            var oldEventCache = viewCache.getEventCache().getNode();
	            var newEventCache = void 0;
	            if (path.isEmpty() || path.getFront() === '.priority') {
	                var newNode = void 0;
	                if (viewCache.getServerCache().isFullyInitialized()) {
	                    newNode = writesCache.calcCompleteEventCache(viewCache.getCompleteServerSnap());
	                }
	                else {
	                    var serverChildren = viewCache.getServerCache().getNode();
	                    util.assert(serverChildren instanceof ChildrenNode, 'serverChildren would be complete if leaf node');
	                    newNode = writesCache.calcCompleteEventChildren(serverChildren);
	                }
	                newNode = newNode;
	                newEventCache = this.filter_.updateFullNode(oldEventCache, newNode, accumulator);
	            }
	            else {
	                var childKey = path.getFront();
	                var newChild = writesCache.calcCompleteChild(childKey, viewCache.getServerCache());
	                if (newChild == null &&
	                    viewCache.getServerCache().isCompleteForChild(childKey)) {
	                    newChild = oldEventCache.getImmediateChild(childKey);
	                }
	                if (newChild != null) {
	                    newEventCache = this.filter_.updateChild(oldEventCache, childKey, newChild, path.popFront(), source, accumulator);
	                }
	                else if (viewCache
	                    .getEventCache()
	                    .getNode()
	                    .hasChild(childKey)) {
	                    // No complete child available, delete the existing one, if any
	                    newEventCache = this.filter_.updateChild(oldEventCache, childKey, ChildrenNode.EMPTY_NODE, path.popFront(), source, accumulator);
	                }
	                else {
	                    newEventCache = oldEventCache;
	                }
	                if (newEventCache.isEmpty() &&
	                    viewCache.getServerCache().isFullyInitialized()) {
	                    // We might have reverted all child writes. Maybe the old event was a leaf node
	                    complete = writesCache.calcCompleteEventCache(viewCache.getCompleteServerSnap());
	                    if (complete.isLeafNode()) {
	                        newEventCache = this.filter_.updateFullNode(newEventCache, complete, accumulator);
	                    }
	                }
	            }
	            complete =
	                viewCache.getServerCache().isFullyInitialized() ||
	                    writesCache.shadowingWrite(Path.Empty) != null;
	            return viewCache.updateEventSnap(newEventCache, complete, this.filter_.filtersNodes());
	        }
	    };
	    return ViewProcessor;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * An EventGenerator is used to convert "raw" changes (Change) as computed by the
	 * CacheDiffer into actual events (Event) that can be raised.  See generateEventsForChanges()
	 * for details.
	 *
	 * @constructor
	 */
	var EventGenerator = /** @class */ (function () {
	    /**
	     *
	     * @param {!Query} query_
	     */
	    function EventGenerator(query_) {
	        this.query_ = query_;
	        /**
	         * @private
	         * @type {!Index}
	         */
	        this.index_ = this.query_.getQueryParams().getIndex();
	    }
	    /**
	     * Given a set of raw changes (no moved events and prevName not specified yet), and a set of
	     * EventRegistrations that should be notified of these changes, generate the actual events to be raised.
	     *
	     * Notes:
	     *  - child_moved events will be synthesized at this time for any child_changed events that affect
	     *    our index.
	     *  - prevName will be calculated based on the index ordering.
	     *
	     * @param {!Array.<!Change>} changes
	     * @param {!Node} eventCache
	     * @param {!Array.<!EventRegistration>} eventRegistrations
	     * @return {!Array.<!Event>}
	     */
	    EventGenerator.prototype.generateEventsForChanges = function (changes, eventCache, eventRegistrations) {
	        var _this = this;
	        var events = [];
	        var moves = [];
	        changes.forEach(function (change) {
	            if (change.type === Change.CHILD_CHANGED &&
	                _this.index_.indexedValueChanged(change.oldSnap, change.snapshotNode)) {
	                moves.push(Change.childMovedChange(change.childName, change.snapshotNode));
	            }
	        });
	        this.generateEventsForType_(events, Change.CHILD_REMOVED, changes, eventRegistrations, eventCache);
	        this.generateEventsForType_(events, Change.CHILD_ADDED, changes, eventRegistrations, eventCache);
	        this.generateEventsForType_(events, Change.CHILD_MOVED, moves, eventRegistrations, eventCache);
	        this.generateEventsForType_(events, Change.CHILD_CHANGED, changes, eventRegistrations, eventCache);
	        this.generateEventsForType_(events, Change.VALUE, changes, eventRegistrations, eventCache);
	        return events;
	    };
	    /**
	     * Given changes of a single change type, generate the corresponding events.
	     *
	     * @param {!Array.<!Event>} events
	     * @param {!string} eventType
	     * @param {!Array.<!Change>} changes
	     * @param {!Array.<!EventRegistration>} registrations
	     * @param {!Node} eventCache
	     * @private
	     */
	    EventGenerator.prototype.generateEventsForType_ = function (events, eventType, changes, registrations, eventCache) {
	        var _this = this;
	        var filteredChanges = changes.filter(function (change) { return change.type === eventType; });
	        filteredChanges.sort(this.compareChanges_.bind(this));
	        filteredChanges.forEach(function (change) {
	            var materializedChange = _this.materializeSingleChange_(change, eventCache);
	            registrations.forEach(function (registration) {
	                if (registration.respondsTo(change.type)) {
	                    events.push(registration.createEvent(materializedChange, _this.query_));
	                }
	            });
	        });
	    };
	    /**
	     * @param {!Change} change
	     * @param {!Node} eventCache
	     * @return {!Change}
	     * @private
	     */
	    EventGenerator.prototype.materializeSingleChange_ = function (change, eventCache) {
	        if (change.type === 'value' || change.type === 'child_removed') {
	            return change;
	        }
	        else {
	            change.prevName = eventCache.getPredecessorChildName(
	            /** @type {!string} */
	            change.childName, change.snapshotNode, this.index_);
	            return change;
	        }
	    };
	    /**
	     * @param {!Change} a
	     * @param {!Change} b
	     * @return {number}
	     * @private
	     */
	    EventGenerator.prototype.compareChanges_ = function (a, b) {
	        if (a.childName == null || b.childName == null) {
	            throw util.assertionError('Should only compare child_ events.');
	        }
	        var aWrapped = new NamedNode(a.childName, a.snapshotNode);
	        var bWrapped = new NamedNode(b.childName, b.snapshotNode);
	        return this.index_.compare(aWrapped, bWrapped);
	    };
	    return EventGenerator;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * A view represents a specific location and query that has 1 or more event registrations.
	 *
	 * It does several things:
	 *  - Maintains the list of event registrations for this location/query.
	 *  - Maintains a cache of the data visible for this location/query.
	 *  - Applies new operations (via applyOperation), updates the cache, and based on the event
	 *    registrations returns the set of events to be raised.
	 * @constructor
	 */
	var View = /** @class */ (function () {
	    /**
	     *
	     * @param {!Query} query_
	     * @param {!ViewCache} initialViewCache
	     */
	    function View(query_, initialViewCache) {
	        this.query_ = query_;
	        this.eventRegistrations_ = [];
	        var params = this.query_.getQueryParams();
	        var indexFilter = new IndexedFilter(params.getIndex());
	        var filter = params.getNodeFilter();
	        /**
	         * @type {ViewProcessor}
	         * @private
	         */
	        this.processor_ = new ViewProcessor(filter);
	        var initialServerCache = initialViewCache.getServerCache();
	        var initialEventCache = initialViewCache.getEventCache();
	        // Don't filter server node with other filter than index, wait for tagged listen
	        var serverSnap = indexFilter.updateFullNode(ChildrenNode.EMPTY_NODE, initialServerCache.getNode(), null);
	        var eventSnap = filter.updateFullNode(ChildrenNode.EMPTY_NODE, initialEventCache.getNode(), null);
	        var newServerCache = new CacheNode(serverSnap, initialServerCache.isFullyInitialized(), indexFilter.filtersNodes());
	        var newEventCache = new CacheNode(eventSnap, initialEventCache.isFullyInitialized(), filter.filtersNodes());
	        /**
	         * @type {!ViewCache}
	         * @private
	         */
	        this.viewCache_ = new ViewCache(newEventCache, newServerCache);
	        /**
	         * @type {!EventGenerator}
	         * @private
	         */
	        this.eventGenerator_ = new EventGenerator(this.query_);
	    }
	    /**
	     * @return {!Query}
	     */
	    View.prototype.getQuery = function () {
	        return this.query_;
	    };
	    /**
	     * @return {?Node}
	     */
	    View.prototype.getServerCache = function () {
	        return this.viewCache_.getServerCache().getNode();
	    };
	    /**
	     * @param {!Path} path
	     * @return {?Node}
	     */
	    View.prototype.getCompleteServerCache = function (path) {
	        var cache = this.viewCache_.getCompleteServerSnap();
	        if (cache) {
	            // If this isn't a "loadsAllData" view, then cache isn't actually a complete cache and
	            // we need to see if it contains the child we're interested in.
	            if (this.query_.getQueryParams().loadsAllData() ||
	                (!path.isEmpty() && !cache.getImmediateChild(path.getFront()).isEmpty())) {
	                return cache.getChild(path);
	            }
	        }
	        return null;
	    };
	    /**
	     * @return {boolean}
	     */
	    View.prototype.isEmpty = function () {
	        return this.eventRegistrations_.length === 0;
	    };
	    /**
	     * @param {!EventRegistration} eventRegistration
	     */
	    View.prototype.addEventRegistration = function (eventRegistration) {
	        this.eventRegistrations_.push(eventRegistration);
	    };
	    /**
	     * @param {?EventRegistration} eventRegistration If null, remove all callbacks.
	     * @param {Error=} cancelError If a cancelError is provided, appropriate cancel events will be returned.
	     * @return {!Array.<!Event>} Cancel events, if cancelError was provided.
	     */
	    View.prototype.removeEventRegistration = function (eventRegistration, cancelError) {
	        var cancelEvents = [];
	        if (cancelError) {
	            util.assert(eventRegistration == null, 'A cancel should cancel all event registrations.');
	            var path_1 = this.query_.path;
	            this.eventRegistrations_.forEach(function (registration) {
	                cancelError /** @type {!Error} */ = cancelError;
	                var maybeEvent = registration.createCancelEvent(cancelError, path_1);
	                if (maybeEvent) {
	                    cancelEvents.push(maybeEvent);
	                }
	            });
	        }
	        if (eventRegistration) {
	            var remaining = [];
	            for (var i = 0; i < this.eventRegistrations_.length; ++i) {
	                var existing = this.eventRegistrations_[i];
	                if (!existing.matches(eventRegistration)) {
	                    remaining.push(existing);
	                }
	                else if (eventRegistration.hasAnyCallback()) {
	                    // We're removing just this one
	                    remaining = remaining.concat(this.eventRegistrations_.slice(i + 1));
	                    break;
	                }
	            }
	            this.eventRegistrations_ = remaining;
	        }
	        else {
	            this.eventRegistrations_ = [];
	        }
	        return cancelEvents;
	    };
	    /**
	     * Applies the given Operation, updates our cache, and returns the appropriate events.
	     *
	     * @param {!Operation} operation
	     * @param {!WriteTreeRef} writesCache
	     * @param {?Node} completeServerCache
	     * @return {!Array.<!Event>}
	     */
	    View.prototype.applyOperation = function (operation, writesCache, completeServerCache) {
	        if (operation.type === OperationType.MERGE &&
	            operation.source.queryId !== null) {
	            util.assert(this.viewCache_.getCompleteServerSnap(), 'We should always have a full cache before handling merges');
	            util.assert(this.viewCache_.getCompleteEventSnap(), 'Missing event cache, even though we have a server cache');
	        }
	        var oldViewCache = this.viewCache_;
	        var result = this.processor_.applyOperation(oldViewCache, operation, writesCache, completeServerCache);
	        this.processor_.assertIndexed(result.viewCache);
	        util.assert(result.viewCache.getServerCache().isFullyInitialized() ||
	            !oldViewCache.getServerCache().isFullyInitialized(), 'Once a server snap is complete, it should never go back');
	        this.viewCache_ = result.viewCache;
	        return this.generateEventsForChanges_(result.changes, result.viewCache.getEventCache().getNode(), null);
	    };
	    /**
	     * @param {!EventRegistration} registration
	     * @return {!Array.<!Event>}
	     */
	    View.prototype.getInitialEvents = function (registration) {
	        var eventSnap = this.viewCache_.getEventCache();
	        var initialChanges = [];
	        if (!eventSnap.getNode().isLeafNode()) {
	            var eventNode = eventSnap.getNode();
	            eventNode.forEachChild(PRIORITY_INDEX, function (key, childNode) {
	                initialChanges.push(Change.childAddedChange(key, childNode));
	            });
	        }
	        if (eventSnap.isFullyInitialized()) {
	            initialChanges.push(Change.valueChange(eventSnap.getNode()));
	        }
	        return this.generateEventsForChanges_(initialChanges, eventSnap.getNode(), registration);
	    };
	    /**
	     * @private
	     * @param {!Array.<!Change>} changes
	     * @param {!Node} eventCache
	     * @param {EventRegistration=} eventRegistration
	     * @return {!Array.<!Event>}
	     */
	    View.prototype.generateEventsForChanges_ = function (changes, eventCache, eventRegistration) {
	        var registrations = eventRegistration
	            ? [eventRegistration]
	            : this.eventRegistrations_;
	        return this.eventGenerator_.generateEventsForChanges(changes, eventCache, registrations);
	    };
	    return View;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var __referenceConstructor$1;
	/**
	 * SyncPoint represents a single location in a SyncTree with 1 or more event registrations, meaning we need to
	 * maintain 1 or more Views at this location to cache server data and raise appropriate events for server changes
	 * and user writes (set, transaction, update).
	 *
	 * It's responsible for:
	 *  - Maintaining the set of 1 or more views necessary at this location (a SyncPoint with 0 views should be removed).
	 *  - Proxying user / server operations to the views as appropriate (i.e. applyServerOverwrite,
	 *    applyUserOverwrite, etc.)
	 */
	var SyncPoint = /** @class */ (function () {
	    function SyncPoint() {
	        /**
	         * The Views being tracked at this location in the tree, stored as a map where the key is a
	         * queryId and the value is the View for that query.
	         *
	         * NOTE: This list will be quite small (usually 1, but perhaps 2 or 3; any more is an odd use case).
	         */
	        this.views = new Map();
	    }
	    Object.defineProperty(SyncPoint, "__referenceConstructor", {
	        get: function () {
	            util.assert(__referenceConstructor$1, 'Reference.ts has not been loaded');
	            return __referenceConstructor$1;
	        },
	        set: function (val) {
	            util.assert(!__referenceConstructor$1, '__referenceConstructor has already been defined');
	            __referenceConstructor$1 = val;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    SyncPoint.prototype.isEmpty = function () {
	        return this.views.size === 0;
	    };
	    SyncPoint.prototype.applyOperation = function (operation, writesCache, optCompleteServerCache) {
	        var e_1, _a;
	        var queryId = operation.source.queryId;
	        if (queryId !== null) {
	            var view = this.views.get(queryId);
	            util.assert(view != null, 'SyncTree gave us an op for an invalid query.');
	            return view.applyOperation(operation, writesCache, optCompleteServerCache);
	        }
	        else {
	            var events = [];
	            try {
	                for (var _b = tslib.__values(this.views.values()), _c = _b.next(); !_c.done; _c = _b.next()) {
	                    var view = _c.value;
	                    events = events.concat(view.applyOperation(operation, writesCache, optCompleteServerCache));
	                }
	            }
	            catch (e_1_1) { e_1 = { error: e_1_1 }; }
	            finally {
	                try {
	                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	                }
	                finally { if (e_1) throw e_1.error; }
	            }
	            return events;
	        }
	    };
	    /**
	     * Add an event callback for the specified query.
	     *
	     * @param {!Query} query
	     * @param {!EventRegistration} eventRegistration
	     * @param {!WriteTreeRef} writesCache
	     * @param {?Node} serverCache Complete server cache, if we have it.
	     * @param {boolean} serverCacheComplete
	     * @return {!Array.<!Event>} Events to raise.
	     */
	    SyncPoint.prototype.addEventRegistration = function (query, eventRegistration, writesCache, serverCache, serverCacheComplete) {
	        var queryId = query.queryIdentifier();
	        var view = this.views.get(queryId);
	        if (!view) {
	            // TODO: make writesCache take flag for complete server node
	            var eventCache = writesCache.calcCompleteEventCache(serverCacheComplete ? serverCache : null);
	            var eventCacheComplete = false;
	            if (eventCache) {
	                eventCacheComplete = true;
	            }
	            else if (serverCache instanceof ChildrenNode) {
	                eventCache = writesCache.calcCompleteEventChildren(serverCache);
	                eventCacheComplete = false;
	            }
	            else {
	                eventCache = ChildrenNode.EMPTY_NODE;
	                eventCacheComplete = false;
	            }
	            var viewCache = new ViewCache(new CacheNode(
	            /** @type {!Node} */ eventCache, eventCacheComplete, false), new CacheNode(
	            /** @type {!Node} */ serverCache, serverCacheComplete, false));
	            view = new View(query, viewCache);
	            this.views.set(queryId, view);
	        }
	        // This is guaranteed to exist now, we just created anything that was missing
	        view.addEventRegistration(eventRegistration);
	        return view.getInitialEvents(eventRegistration);
	    };
	    /**
	     * Remove event callback(s).  Return cancelEvents if a cancelError is specified.
	     *
	     * If query is the default query, we'll check all views for the specified eventRegistration.
	     * If eventRegistration is null, we'll remove all callbacks for the specified view(s).
	     *
	     * @param {!Query} query
	     * @param {?EventRegistration} eventRegistration If null, remove all callbacks.
	     * @param {Error=} cancelError If a cancelError is provided, appropriate cancel events will be returned.
	     * @return {{removed:!Array.<!Query>, events:!Array.<!Event>}} removed queries and any cancel events
	     */
	    SyncPoint.prototype.removeEventRegistration = function (query, eventRegistration, cancelError) {
	        var e_2, _a;
	        var queryId = query.queryIdentifier();
	        var removed = [];
	        var cancelEvents = [];
	        var hadCompleteView = this.hasCompleteView();
	        if (queryId === 'default') {
	            try {
	                // When you do ref.off(...), we search all views for the registration to remove.
	                for (var _b = tslib.__values(this.views.entries()), _c = _b.next(); !_c.done; _c = _b.next()) {
	                    var _d = tslib.__read(_c.value, 2), viewQueryId = _d[0], view = _d[1];
	                    cancelEvents = cancelEvents.concat(view.removeEventRegistration(eventRegistration, cancelError));
	                    if (view.isEmpty()) {
	                        this.views.delete(viewQueryId);
	                        // We'll deal with complete views later.
	                        if (!view
	                            .getQuery()
	                            .getQueryParams()
	                            .loadsAllData()) {
	                            removed.push(view.getQuery());
	                        }
	                    }
	                }
	            }
	            catch (e_2_1) { e_2 = { error: e_2_1 }; }
	            finally {
	                try {
	                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	                }
	                finally { if (e_2) throw e_2.error; }
	            }
	        }
	        else {
	            // remove the callback from the specific view.
	            var view = this.views.get(queryId);
	            if (view) {
	                cancelEvents = cancelEvents.concat(view.removeEventRegistration(eventRegistration, cancelError));
	                if (view.isEmpty()) {
	                    this.views.delete(queryId);
	                    // We'll deal with complete views later.
	                    if (!view
	                        .getQuery()
	                        .getQueryParams()
	                        .loadsAllData()) {
	                        removed.push(view.getQuery());
	                    }
	                }
	            }
	        }
	        if (hadCompleteView && !this.hasCompleteView()) {
	            // We removed our last complete view.
	            removed.push(new SyncPoint.__referenceConstructor(query.repo, query.path));
	        }
	        return { removed: removed, events: cancelEvents };
	    };
	    SyncPoint.prototype.getQueryViews = function () {
	        var e_3, _a;
	        var result = [];
	        try {
	            for (var _b = tslib.__values(this.views.values()), _c = _b.next(); !_c.done; _c = _b.next()) {
	                var view = _c.value;
	                if (!view
	                    .getQuery()
	                    .getQueryParams()
	                    .loadsAllData()) {
	                    result.push(view);
	                }
	            }
	        }
	        catch (e_3_1) { e_3 = { error: e_3_1 }; }
	        finally {
	            try {
	                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	            }
	            finally { if (e_3) throw e_3.error; }
	        }
	        return result;
	    };
	    /**
	     * @param path The path to the desired complete snapshot
	     * @return A complete cache, if it exists
	     */
	    SyncPoint.prototype.getCompleteServerCache = function (path) {
	        var e_4, _a;
	        var serverCache = null;
	        try {
	            for (var _b = tslib.__values(this.views.values()), _c = _b.next(); !_c.done; _c = _b.next()) {
	                var view = _c.value;
	                serverCache = serverCache || view.getCompleteServerCache(path);
	            }
	        }
	        catch (e_4_1) { e_4 = { error: e_4_1 }; }
	        finally {
	            try {
	                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	            }
	            finally { if (e_4) throw e_4.error; }
	        }
	        return serverCache;
	    };
	    SyncPoint.prototype.viewForQuery = function (query) {
	        var params = query.getQueryParams();
	        if (params.loadsAllData()) {
	            return this.getCompleteView();
	        }
	        else {
	            var queryId = query.queryIdentifier();
	            return this.views.get(queryId);
	        }
	    };
	    SyncPoint.prototype.viewExistsForQuery = function (query) {
	        return this.viewForQuery(query) != null;
	    };
	    SyncPoint.prototype.hasCompleteView = function () {
	        return this.getCompleteView() != null;
	    };
	    SyncPoint.prototype.getCompleteView = function () {
	        var e_5, _a;
	        try {
	            for (var _b = tslib.__values(this.views.values()), _c = _b.next(); !_c.done; _c = _b.next()) {
	                var view = _c.value;
	                if (view
	                    .getQuery()
	                    .getQueryParams()
	                    .loadsAllData()) {
	                    return view;
	                }
	            }
	        }
	        catch (e_5_1) { e_5 = { error: e_5_1 }; }
	        finally {
	            try {
	                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	            }
	            finally { if (e_5) throw e_5.error; }
	        }
	        return null;
	    };
	    return SyncPoint;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * This class holds a collection of writes that can be applied to nodes in unison. It abstracts away the logic with
	 * dealing with priority writes and multiple nested writes. At any given path there is only allowed to be one write
	 * modifying that path. Any write to an existing path or shadowing an existing path will modify that existing write
	 * to reflect the write added.
	 */
	var CompoundWrite = /** @class */ (function () {
	    function CompoundWrite(writeTree_) {
	        this.writeTree_ = writeTree_;
	    }
	    CompoundWrite.prototype.addWrite = function (path, node) {
	        if (path.isEmpty()) {
	            return new CompoundWrite(new ImmutableTree(node));
	        }
	        else {
	            var rootmost = this.writeTree_.findRootMostValueAndPath(path);
	            if (rootmost != null) {
	                var rootMostPath = rootmost.path;
	                var value = rootmost.value;
	                var relativePath = Path.relativePath(rootMostPath, path);
	                value = value.updateChild(relativePath, node);
	                return new CompoundWrite(this.writeTree_.set(rootMostPath, value));
	            }
	            else {
	                var subtree = new ImmutableTree(node);
	                var newWriteTree = this.writeTree_.setTree(path, subtree);
	                return new CompoundWrite(newWriteTree);
	            }
	        }
	    };
	    CompoundWrite.prototype.addWrites = function (path, updates) {
	        var newWrite = this;
	        each(updates, function (childKey, node) {
	            newWrite = newWrite.addWrite(path.child(childKey), node);
	        });
	        return newWrite;
	    };
	    /**
	     * Will remove a write at the given path and deeper paths. This will <em>not</em> modify a write at a higher
	     * location, which must be removed by calling this method with that path.
	     *
	     * @param path The path at which a write and all deeper writes should be removed
	     * @return {!CompoundWrite} The new CompoundWrite with the removed path
	     */
	    CompoundWrite.prototype.removeWrite = function (path) {
	        if (path.isEmpty()) {
	            return CompoundWrite.Empty;
	        }
	        else {
	            var newWriteTree = this.writeTree_.setTree(path, ImmutableTree.Empty);
	            return new CompoundWrite(newWriteTree);
	        }
	    };
	    /**
	     * Returns whether this CompoundWrite will fully overwrite a node at a given location and can therefore be
	     * considered "complete".
	     *
	     * @param path The path to check for
	     * @return Whether there is a complete write at that path
	     */
	    CompoundWrite.prototype.hasCompleteWrite = function (path) {
	        return this.getCompleteNode(path) != null;
	    };
	    /**
	     * Returns a node for a path if and only if the node is a "complete" overwrite at that path. This will not aggregate
	     * writes from deeper paths, but will return child nodes from a more shallow path.
	     *
	     * @param path The path to get a complete write
	     * @return The node if complete at that path, or null otherwise.
	     */
	    CompoundWrite.prototype.getCompleteNode = function (path) {
	        var rootmost = this.writeTree_.findRootMostValueAndPath(path);
	        if (rootmost != null) {
	            return this.writeTree_
	                .get(rootmost.path)
	                .getChild(Path.relativePath(rootmost.path, path));
	        }
	        else {
	            return null;
	        }
	    };
	    /**
	     * Returns all children that are guaranteed to be a complete overwrite.
	     *
	     * @return A list of all complete children.
	     */
	    CompoundWrite.prototype.getCompleteChildren = function () {
	        var children = [];
	        var node = this.writeTree_.value;
	        if (node != null) {
	            // If it's a leaf node, it has no children; so nothing to do.
	            if (!node.isLeafNode()) {
	                node.forEachChild(PRIORITY_INDEX, function (childName, childNode) {
	                    children.push(new NamedNode(childName, childNode));
	                });
	            }
	        }
	        else {
	            this.writeTree_.children.inorderTraversal(function (childName, childTree) {
	                if (childTree.value != null) {
	                    children.push(new NamedNode(childName, childTree.value));
	                }
	            });
	        }
	        return children;
	    };
	    CompoundWrite.prototype.childCompoundWrite = function (path) {
	        if (path.isEmpty()) {
	            return this;
	        }
	        else {
	            var shadowingNode = this.getCompleteNode(path);
	            if (shadowingNode != null) {
	                return new CompoundWrite(new ImmutableTree(shadowingNode));
	            }
	            else {
	                return new CompoundWrite(this.writeTree_.subtree(path));
	            }
	        }
	    };
	    /**
	     * Returns true if this CompoundWrite is empty and therefore does not modify any nodes.
	     * @return Whether this CompoundWrite is empty
	     */
	    CompoundWrite.prototype.isEmpty = function () {
	        return this.writeTree_.isEmpty();
	    };
	    /**
	     * Applies this CompoundWrite to a node. The node is returned with all writes from this CompoundWrite applied to the
	     * node
	     * @param node The node to apply this CompoundWrite to
	     * @return The node with all writes applied
	     */
	    CompoundWrite.prototype.apply = function (node) {
	        return applySubtreeWrite(Path.Empty, this.writeTree_, node);
	    };
	    CompoundWrite.Empty = new CompoundWrite(new ImmutableTree(null));
	    return CompoundWrite;
	}());
	function applySubtreeWrite(relativePath, writeTree, node) {
	    if (writeTree.value != null) {
	        // Since there a write is always a leaf, we're done here
	        return node.updateChild(relativePath, writeTree.value);
	    }
	    else {
	        var priorityWrite_1 = null;
	        writeTree.children.inorderTraversal(function (childKey, childTree) {
	            if (childKey === '.priority') {
	                // Apply priorities at the end so we don't update priorities for either empty nodes or forget
	                // to apply priorities to empty nodes that are later filled
	                util.assert(childTree.value !== null, 'Priority writes must always be leaf nodes');
	                priorityWrite_1 = childTree.value;
	            }
	            else {
	                node = applySubtreeWrite(relativePath.child(childKey), childTree, node);
	            }
	        });
	        // If there was a priority write, we only apply it if the node is not empty
	        if (!node.getChild(relativePath).isEmpty() && priorityWrite_1 !== null) {
	            node = node.updateChild(relativePath.child('.priority'), priorityWrite_1);
	        }
	        return node;
	    }
	}
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * WriteTree tracks all pending user-initiated writes and has methods to calculate the result of merging them
	 * with underlying server data (to create "event cache" data).  Pending writes are added with addOverwrite()
	 * and addMerge(), and removed with removeWrite().
	 *
	 * @constructor
	 */
	var WriteTree = /** @class */ (function () {
	    function WriteTree() {
	        /**
	         * A tree tracking the result of applying all visible writes.  This does not include transactions with
	         * applyLocally=false or writes that are completely shadowed by other writes.
	         *
	         * @type {!CompoundWrite}
	         * @private
	         */
	        this.visibleWrites_ = CompoundWrite.Empty;
	        /**
	         * A list of all pending writes, regardless of visibility and shadowed-ness.  Used to calculate arbitrary
	         * sets of the changed data, such as hidden writes (from transactions) or changes with certain writes excluded (also
	         * used by transactions).
	         *
	         * @type {!Array.<!WriteRecord>}
	         * @private
	         */
	        this.allWrites_ = [];
	        this.lastWriteId_ = -1;
	    }
	    /**
	     * Create a new WriteTreeRef for the given path. For use with a new sync point at the given path.
	     *
	     * @param {!Path} path
	     * @return {!WriteTreeRef}
	     */
	    WriteTree.prototype.childWrites = function (path) {
	        return new WriteTreeRef(path, this);
	    };
	    /**
	     * Record a new overwrite from user code.
	     *
	     * @param {!Path} path
	     * @param {!Node} snap
	     * @param {!number} writeId
	     * @param {boolean=} visible This is set to false by some transactions. It should be excluded from event caches
	     */
	    WriteTree.prototype.addOverwrite = function (path, snap, writeId, visible) {
	        util.assert(writeId > this.lastWriteId_, 'Stacking an older write on top of newer ones');
	        if (visible === undefined) {
	            visible = true;
	        }
	        this.allWrites_.push({
	            path: path,
	            snap: snap,
	            writeId: writeId,
	            visible: visible
	        });
	        if (visible) {
	            this.visibleWrites_ = this.visibleWrites_.addWrite(path, snap);
	        }
	        this.lastWriteId_ = writeId;
	    };
	    /**
	     * Record a new merge from user code.
	     *
	     * @param {!Path} path
	     * @param {!Object.<string, !Node>} changedChildren
	     * @param {!number} writeId
	     */
	    WriteTree.prototype.addMerge = function (path, changedChildren, writeId) {
	        util.assert(writeId > this.lastWriteId_, 'Stacking an older merge on top of newer ones');
	        this.allWrites_.push({
	            path: path,
	            children: changedChildren,
	            writeId: writeId,
	            visible: true
	        });
	        this.visibleWrites_ = this.visibleWrites_.addWrites(path, changedChildren);
	        this.lastWriteId_ = writeId;
	    };
	    /**
	     * @param {!number} writeId
	     * @return {?WriteRecord}
	     */
	    WriteTree.prototype.getWrite = function (writeId) {
	        for (var i = 0; i < this.allWrites_.length; i++) {
	            var record = this.allWrites_[i];
	            if (record.writeId === writeId) {
	                return record;
	            }
	        }
	        return null;
	    };
	    /**
	     * Remove a write (either an overwrite or merge) that has been successfully acknowledge by the server. Recalculates
	     * the tree if necessary.  We return true if it may have been visible, meaning views need to reevaluate.
	     *
	     * @param {!number} writeId
	     * @return {boolean} true if the write may have been visible (meaning we'll need to reevaluate / raise
	     * events as a result).
	     */
	    WriteTree.prototype.removeWrite = function (writeId) {
	        // Note: disabling this check. It could be a transaction that preempted another transaction, and thus was applied
	        // out of order.
	        //const validClear = revert || this.allWrites_.length === 0 || writeId <= this.allWrites_[0].writeId;
	        //assert(validClear, "Either we don't have this write, or it's the first one in the queue");
	        var _this = this;
	        var idx = this.allWrites_.findIndex(function (s) {
	            return s.writeId === writeId;
	        });
	        util.assert(idx >= 0, 'removeWrite called with nonexistent writeId.');
	        var writeToRemove = this.allWrites_[idx];
	        this.allWrites_.splice(idx, 1);
	        var removedWriteWasVisible = writeToRemove.visible;
	        var removedWriteOverlapsWithOtherWrites = false;
	        var i = this.allWrites_.length - 1;
	        while (removedWriteWasVisible && i >= 0) {
	            var currentWrite = this.allWrites_[i];
	            if (currentWrite.visible) {
	                if (i >= idx &&
	                    this.recordContainsPath_(currentWrite, writeToRemove.path)) {
	                    // The removed write was completely shadowed by a subsequent write.
	                    removedWriteWasVisible = false;
	                }
	                else if (writeToRemove.path.contains(currentWrite.path)) {
	                    // Either we're covering some writes or they're covering part of us (depending on which came first).
	                    removedWriteOverlapsWithOtherWrites = true;
	                }
	            }
	            i--;
	        }
	        if (!removedWriteWasVisible) {
	            return false;
	        }
	        else if (removedWriteOverlapsWithOtherWrites) {
	            // There's some shadowing going on. Just rebuild the visible writes from scratch.
	            this.resetTree_();
	            return true;
	        }
	        else {
	            // There's no shadowing.  We can safely just remove the write(s) from visibleWrites.
	            if (writeToRemove.snap) {
	                this.visibleWrites_ = this.visibleWrites_.removeWrite(writeToRemove.path);
	            }
	            else {
	                var children = writeToRemove.children;
	                each(children, function (childName) {
	                    _this.visibleWrites_ = _this.visibleWrites_.removeWrite(writeToRemove.path.child(childName));
	                });
	            }
	            return true;
	        }
	    };
	    /**
	     * Return a complete snapshot for the given path if there's visible write data at that path, else null.
	     * No server data is considered.
	     *
	     * @param {!Path} path
	     * @return {?Node}
	     */
	    WriteTree.prototype.getCompleteWriteData = function (path) {
	        return this.visibleWrites_.getCompleteNode(path);
	    };
	    /**
	     * Given optional, underlying server data, and an optional set of constraints (exclude some sets, include hidden
	     * writes), attempt to calculate a complete snapshot for the given path
	     *
	     * @param {!Path} treePath
	     * @param {?Node} completeServerCache
	     * @param {Array.<number>=} writeIdsToExclude An optional set to be excluded
	     * @param {boolean=} includeHiddenWrites Defaults to false, whether or not to layer on writes with visible set to false
	     * @return {?Node}
	     */
	    WriteTree.prototype.calcCompleteEventCache = function (treePath, completeServerCache, writeIdsToExclude, includeHiddenWrites) {
	        if (!writeIdsToExclude && !includeHiddenWrites) {
	            var shadowingNode = this.visibleWrites_.getCompleteNode(treePath);
	            if (shadowingNode != null) {
	                return shadowingNode;
	            }
	            else {
	                var subMerge = this.visibleWrites_.childCompoundWrite(treePath);
	                if (subMerge.isEmpty()) {
	                    return completeServerCache;
	                }
	                else if (completeServerCache == null &&
	                    !subMerge.hasCompleteWrite(Path.Empty)) {
	                    // We wouldn't have a complete snapshot, since there's no underlying data and no complete shadow
	                    return null;
	                }
	                else {
	                    var layeredCache = completeServerCache || ChildrenNode.EMPTY_NODE;
	                    return subMerge.apply(layeredCache);
	                }
	            }
	        }
	        else {
	            var merge = this.visibleWrites_.childCompoundWrite(treePath);
	            if (!includeHiddenWrites && merge.isEmpty()) {
	                return completeServerCache;
	            }
	            else {
	                // If the server cache is null, and we don't have a complete cache, we need to return null
	                if (!includeHiddenWrites &&
	                    completeServerCache == null &&
	                    !merge.hasCompleteWrite(Path.Empty)) {
	                    return null;
	                }
	                else {
	                    var filter = function (write) {
	                        return ((write.visible || includeHiddenWrites) &&
	                            (!writeIdsToExclude ||
	                                !~writeIdsToExclude.indexOf(write.writeId)) &&
	                            (write.path.contains(treePath) || treePath.contains(write.path)));
	                    };
	                    var mergeAtPath = WriteTree.layerTree_(this.allWrites_, filter, treePath);
	                    var layeredCache = completeServerCache || ChildrenNode.EMPTY_NODE;
	                    return mergeAtPath.apply(layeredCache);
	                }
	            }
	        }
	    };
	    /**
	     * With optional, underlying server data, attempt to return a children node of children that we have complete data for.
	     * Used when creating new views, to pre-fill their complete event children snapshot.
	     *
	     * @param {!Path} treePath
	     * @param {?ChildrenNode} completeServerChildren
	     * @return {!ChildrenNode}
	     */
	    WriteTree.prototype.calcCompleteEventChildren = function (treePath, completeServerChildren) {
	        var completeChildren = ChildrenNode.EMPTY_NODE;
	        var topLevelSet = this.visibleWrites_.getCompleteNode(treePath);
	        if (topLevelSet) {
	            if (!topLevelSet.isLeafNode()) {
	                // we're shadowing everything. Return the children.
	                topLevelSet.forEachChild(PRIORITY_INDEX, function (childName, childSnap) {
	                    completeChildren = completeChildren.updateImmediateChild(childName, childSnap);
	                });
	            }
	            return completeChildren;
	        }
	        else if (completeServerChildren) {
	            // Layer any children we have on top of this
	            // We know we don't have a top-level set, so just enumerate existing children
	            var merge_1 = this.visibleWrites_.childCompoundWrite(treePath);
	            completeServerChildren.forEachChild(PRIORITY_INDEX, function (childName, childNode) {
	                var node = merge_1
	                    .childCompoundWrite(new Path(childName))
	                    .apply(childNode);
	                completeChildren = completeChildren.updateImmediateChild(childName, node);
	            });
	            // Add any complete children we have from the set
	            merge_1.getCompleteChildren().forEach(function (namedNode) {
	                completeChildren = completeChildren.updateImmediateChild(namedNode.name, namedNode.node);
	            });
	            return completeChildren;
	        }
	        else {
	            // We don't have anything to layer on top of. Layer on any children we have
	            // Note that we can return an empty snap if we have a defined delete
	            var merge = this.visibleWrites_.childCompoundWrite(treePath);
	            merge.getCompleteChildren().forEach(function (namedNode) {
	                completeChildren = completeChildren.updateImmediateChild(namedNode.name, namedNode.node);
	            });
	            return completeChildren;
	        }
	    };
	    /**
	     * Given that the underlying server data has updated, determine what, if anything, needs to be
	     * applied to the event cache.
	     *
	     * Possibilities:
	     *
	     * 1. No writes are shadowing. Events should be raised, the snap to be applied comes from the server data
	     *
	     * 2. Some write is completely shadowing. No events to be raised
	     *
	     * 3. Is partially shadowed. Events
	     *
	     * Either existingEventSnap or existingServerSnap must exist
	     *
	     * @param {!Path} treePath
	     * @param {!Path} childPath
	     * @param {?Node} existingEventSnap
	     * @param {?Node} existingServerSnap
	     * @return {?Node}
	     */
	    WriteTree.prototype.calcEventCacheAfterServerOverwrite = function (treePath, childPath, existingEventSnap, existingServerSnap) {
	        util.assert(existingEventSnap || existingServerSnap, 'Either existingEventSnap or existingServerSnap must exist');
	        var path = treePath.child(childPath);
	        if (this.visibleWrites_.hasCompleteWrite(path)) {
	            // At this point we can probably guarantee that we're in case 2, meaning no events
	            // May need to check visibility while doing the findRootMostValueAndPath call
	            return null;
	        }
	        else {
	            // No complete shadowing. We're either partially shadowing or not shadowing at all.
	            var childMerge = this.visibleWrites_.childCompoundWrite(path);
	            if (childMerge.isEmpty()) {
	                // We're not shadowing at all. Case 1
	                return existingServerSnap.getChild(childPath);
	            }
	            else {
	                // This could be more efficient if the serverNode + updates doesn't change the eventSnap
	                // However this is tricky to find out, since user updates don't necessary change the server
	                // snap, e.g. priority updates on empty nodes, or deep deletes. Another special case is if the server
	                // adds nodes, but doesn't change any existing writes. It is therefore not enough to
	                // only check if the updates change the serverNode.
	                // Maybe check if the merge tree contains these special cases and only do a full overwrite in that case?
	                return childMerge.apply(existingServerSnap.getChild(childPath));
	            }
	        }
	    };
	    /**
	     * Returns a complete child for a given server snap after applying all user writes or null if there is no
	     * complete child for this ChildKey.
	     *
	     * @param {!Path} treePath
	     * @param {!string} childKey
	     * @param {!CacheNode} existingServerSnap
	     * @return {?Node}
	     */
	    WriteTree.prototype.calcCompleteChild = function (treePath, childKey, existingServerSnap) {
	        var path = treePath.child(childKey);
	        var shadowingNode = this.visibleWrites_.getCompleteNode(path);
	        if (shadowingNode != null) {
	            return shadowingNode;
	        }
	        else {
	            if (existingServerSnap.isCompleteForChild(childKey)) {
	                var childMerge = this.visibleWrites_.childCompoundWrite(path);
	                return childMerge.apply(existingServerSnap.getNode().getImmediateChild(childKey));
	            }
	            else {
	                return null;
	            }
	        }
	    };
	    /**
	     * Returns a node if there is a complete overwrite for this path. More specifically, if there is a write at
	     * a higher path, this will return the child of that write relative to the write and this path.
	     * Returns null if there is no write at this path.
	     */
	    WriteTree.prototype.shadowingWrite = function (path) {
	        return this.visibleWrites_.getCompleteNode(path);
	    };
	    /**
	     * This method is used when processing child remove events on a query. If we can, we pull in children that were outside
	     * the window, but may now be in the window.
	     */
	    WriteTree.prototype.calcIndexedSlice = function (treePath, completeServerData, startPost, count, reverse, index) {
	        var toIterate;
	        var merge = this.visibleWrites_.childCompoundWrite(treePath);
	        var shadowingNode = merge.getCompleteNode(Path.Empty);
	        if (shadowingNode != null) {
	            toIterate = shadowingNode;
	        }
	        else if (completeServerData != null) {
	            toIterate = merge.apply(completeServerData);
	        }
	        else {
	            // no children to iterate on
	            return [];
	        }
	        toIterate = toIterate.withIndex(index);
	        if (!toIterate.isEmpty() && !toIterate.isLeafNode()) {
	            var nodes = [];
	            var cmp = index.getCompare();
	            var iter = reverse
	                ? toIterate.getReverseIteratorFrom(startPost, index)
	                : toIterate.getIteratorFrom(startPost, index);
	            var next = iter.getNext();
	            while (next && nodes.length < count) {
	                if (cmp(next, startPost) !== 0) {
	                    nodes.push(next);
	                }
	                next = iter.getNext();
	            }
	            return nodes;
	        }
	        else {
	            return [];
	        }
	    };
	    WriteTree.prototype.recordContainsPath_ = function (writeRecord, path) {
	        if (writeRecord.snap) {
	            return writeRecord.path.contains(path);
	        }
	        else {
	            for (var childName in writeRecord.children) {
	                if (writeRecord.children.hasOwnProperty(childName) &&
	                    writeRecord.path.child(childName).contains(path)) {
	                    return true;
	                }
	            }
	            return false;
	        }
	    };
	    /**
	     * Re-layer the writes and merges into a tree so we can efficiently calculate event snapshots
	     */
	    WriteTree.prototype.resetTree_ = function () {
	        this.visibleWrites_ = WriteTree.layerTree_(this.allWrites_, WriteTree.DefaultFilter_, Path.Empty);
	        if (this.allWrites_.length > 0) {
	            this.lastWriteId_ = this.allWrites_[this.allWrites_.length - 1].writeId;
	        }
	        else {
	            this.lastWriteId_ = -1;
	        }
	    };
	    /**
	     * The default filter used when constructing the tree. Keep everything that's visible.
	     */
	    WriteTree.DefaultFilter_ = function (write) {
	        return write.visible;
	    };
	    /**
	     * Static method. Given an array of WriteRecords, a filter for which ones to include, and a path, construct the tree of
	     * event data at that path.
	     */
	    WriteTree.layerTree_ = function (writes, filter, treeRoot) {
	        var compoundWrite = CompoundWrite.Empty;
	        for (var i = 0; i < writes.length; ++i) {
	            var write = writes[i];
	            // Theory, a later set will either:
	            // a) abort a relevant transaction, so no need to worry about excluding it from calculating that transaction
	            // b) not be relevant to a transaction (separate branch), so again will not affect the data for that transaction
	            if (filter(write)) {
	                var writePath = write.path;
	                var relativePath = void 0;
	                if (write.snap) {
	                    if (treeRoot.contains(writePath)) {
	                        relativePath = Path.relativePath(treeRoot, writePath);
	                        compoundWrite = compoundWrite.addWrite(relativePath, write.snap);
	                    }
	                    else if (writePath.contains(treeRoot)) {
	                        relativePath = Path.relativePath(writePath, treeRoot);
	                        compoundWrite = compoundWrite.addWrite(Path.Empty, write.snap.getChild(relativePath));
	                    }
	                }
	                else if (write.children) {
	                    if (treeRoot.contains(writePath)) {
	                        relativePath = Path.relativePath(treeRoot, writePath);
	                        compoundWrite = compoundWrite.addWrites(relativePath, write.children);
	                    }
	                    else if (writePath.contains(treeRoot)) {
	                        relativePath = Path.relativePath(writePath, treeRoot);
	                        if (relativePath.isEmpty()) {
	                            compoundWrite = compoundWrite.addWrites(Path.Empty, write.children);
	                        }
	                        else {
	                            var child = util.safeGet(write.children, relativePath.getFront());
	                            if (child) {
	                                // There exists a child in this node that matches the root path
	                                var deepNode = child.getChild(relativePath.popFront());
	                                compoundWrite = compoundWrite.addWrite(Path.Empty, deepNode);
	                            }
	                        }
	                    }
	                }
	                else {
	                    throw util.assertionError('WriteRecord should have .snap or .children');
	                }
	            }
	        }
	        return compoundWrite;
	    };
	    return WriteTree;
	}());
	/**
	 * A WriteTreeRef wraps a WriteTree and a path, for convenient access to a particular subtree.  All of the methods
	 * just proxy to the underlying WriteTree.
	 *
	 * @constructor
	 */
	var WriteTreeRef = /** @class */ (function () {
	    /**
	     * @param {!Path} path
	     * @param {!WriteTree} writeTree
	     */
	    function WriteTreeRef(path, writeTree) {
	        this.treePath_ = path;
	        this.writeTree_ = writeTree;
	    }
	    /**
	     * If possible, returns a complete event cache, using the underlying server data if possible. In addition, can be used
	     * to get a cache that includes hidden writes, and excludes arbitrary writes. Note that customizing the returned node
	     * can lead to a more expensive calculation.
	     *
	     * @param {?Node} completeServerCache
	     * @param {Array.<number>=} writeIdsToExclude Optional writes to exclude.
	     * @param {boolean=} includeHiddenWrites Defaults to false, whether or not to layer on writes with visible set to false
	     * @return {?Node}
	     */
	    WriteTreeRef.prototype.calcCompleteEventCache = function (completeServerCache, writeIdsToExclude, includeHiddenWrites) {
	        return this.writeTree_.calcCompleteEventCache(this.treePath_, completeServerCache, writeIdsToExclude, includeHiddenWrites);
	    };
	    /**
	     * If possible, returns a children node containing all of the complete children we have data for. The returned data is a
	     * mix of the given server data and write data.
	     *
	     * @param {?ChildrenNode} completeServerChildren
	     * @return {!ChildrenNode}
	     */
	    WriteTreeRef.prototype.calcCompleteEventChildren = function (completeServerChildren) {
	        return this.writeTree_.calcCompleteEventChildren(this.treePath_, completeServerChildren);
	    };
	    /**
	     * Given that either the underlying server data has updated or the outstanding writes have updated, determine what,
	     * if anything, needs to be applied to the event cache.
	     *
	     * Possibilities:
	     *
	     * 1. No writes are shadowing. Events should be raised, the snap to be applied comes from the server data
	     *
	     * 2. Some write is completely shadowing. No events to be raised
	     *
	     * 3. Is partially shadowed. Events should be raised
	     *
	     * Either existingEventSnap or existingServerSnap must exist, this is validated via an assert
	     *
	     * @param {!Path} path
	     * @param {?Node} existingEventSnap
	     * @param {?Node} existingServerSnap
	     * @return {?Node}
	     */
	    WriteTreeRef.prototype.calcEventCacheAfterServerOverwrite = function (path, existingEventSnap, existingServerSnap) {
	        return this.writeTree_.calcEventCacheAfterServerOverwrite(this.treePath_, path, existingEventSnap, existingServerSnap);
	    };
	    /**
	     * Returns a node if there is a complete overwrite for this path. More specifically, if there is a write at
	     * a higher path, this will return the child of that write relative to the write and this path.
	     * Returns null if there is no write at this path.
	     *
	     * @param {!Path} path
	     * @return {?Node}
	     */
	    WriteTreeRef.prototype.shadowingWrite = function (path) {
	        return this.writeTree_.shadowingWrite(this.treePath_.child(path));
	    };
	    /**
	     * This method is used when processing child remove events on a query. If we can, we pull in children that were outside
	     * the window, but may now be in the window
	     *
	     * @param {?Node} completeServerData
	     * @param {!NamedNode} startPost
	     * @param {!number} count
	     * @param {boolean} reverse
	     * @param {!Index} index
	     * @return {!Array.<!NamedNode>}
	     */
	    WriteTreeRef.prototype.calcIndexedSlice = function (completeServerData, startPost, count, reverse, index) {
	        return this.writeTree_.calcIndexedSlice(this.treePath_, completeServerData, startPost, count, reverse, index);
	    };
	    /**
	     * Returns a complete child for a given server snap after applying all user writes or null if there is no
	     * complete child for this ChildKey.
	     *
	     * @param {!string} childKey
	     * @param {!CacheNode} existingServerCache
	     * @return {?Node}
	     */
	    WriteTreeRef.prototype.calcCompleteChild = function (childKey, existingServerCache) {
	        return this.writeTree_.calcCompleteChild(this.treePath_, childKey, existingServerCache);
	    };
	    /**
	     * Return a WriteTreeRef for a child.
	     *
	     * @param {string} childName
	     * @return {!WriteTreeRef}
	     */
	    WriteTreeRef.prototype.child = function (childName) {
	        return new WriteTreeRef(this.treePath_.child(childName), this.writeTree_);
	    };
	    return WriteTreeRef;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * SyncTree is the central class for managing event callback registration, data caching, views
	 * (query processing), and event generation.  There are typically two SyncTree instances for
	 * each Repo, one for the normal Firebase data, and one for the .info data.
	 *
	 * It has a number of responsibilities, including:
	 *  - Tracking all user event callbacks (registered via addEventRegistration() and removeEventRegistration()).
	 *  - Applying and caching data changes for user set(), transaction(), and update() calls
	 *    (applyUserOverwrite(), applyUserMerge()).
	 *  - Applying and caching data changes for server data changes (applyServerOverwrite(),
	 *    applyServerMerge()).
	 *  - Generating user-facing events for server and user changes (all of the apply* methods
	 *    return the set of events that need to be raised as a result).
	 *  - Maintaining the appropriate set of server listens to ensure we are always subscribed
	 *    to the correct set of paths and queries to satisfy the current set of user event
	 *    callbacks (listens are started/stopped using the provided listenProvider).
	 *
	 * NOTE: Although SyncTree tracks event callbacks and calculates events to raise, the actual
	 * events are returned to the caller rather than raised synchronously.
	 *
	 * @constructor
	 */
	var SyncTree = /** @class */ (function () {
	    /**
	     * @param {!ListenProvider} listenProvider_ Used by SyncTree to start / stop listening
	     *   to server data.
	     */
	    function SyncTree(listenProvider_) {
	        this.listenProvider_ = listenProvider_;
	        /**
	         * Tree of SyncPoints.  There's a SyncPoint at any location that has 1 or more views.
	         */
	        this.syncPointTree_ = ImmutableTree.Empty;
	        /**
	         * A tree of all pending user writes (user-initiated set()'s, transaction()'s, update()'s, etc.).
	         */
	        this.pendingWriteTree_ = new WriteTree();
	        this.tagToQueryMap = new Map();
	        this.queryToTagMap = new Map();
	    }
	    /**
	     * Apply the data changes for a user-generated set() or transaction() call.
	     *
	     * @return Events to raise.
	     */
	    SyncTree.prototype.applyUserOverwrite = function (path, newData, writeId, visible) {
	        // Record pending write.
	        this.pendingWriteTree_.addOverwrite(path, newData, writeId, visible);
	        if (!visible) {
	            return [];
	        }
	        else {
	            return this.applyOperationToSyncPoints_(new Overwrite(OperationSource.User, path, newData));
	        }
	    };
	    /**
	     * Apply the data from a user-generated update() call
	     *
	     * @return Events to raise.
	     */
	    SyncTree.prototype.applyUserMerge = function (path, changedChildren, writeId) {
	        // Record pending merge.
	        this.pendingWriteTree_.addMerge(path, changedChildren, writeId);
	        var changeTree = ImmutableTree.fromObject(changedChildren);
	        return this.applyOperationToSyncPoints_(new Merge(OperationSource.User, path, changeTree));
	    };
	    /**
	     * Acknowledge a pending user write that was previously registered with applyUserOverwrite() or applyUserMerge().
	     *
	     * @param revert True if the given write failed and needs to be reverted
	     * @return Events to raise.
	     */
	    SyncTree.prototype.ackUserWrite = function (writeId, revert) {
	        if (revert === void 0) { revert = false; }
	        var write = this.pendingWriteTree_.getWrite(writeId);
	        var needToReevaluate = this.pendingWriteTree_.removeWrite(writeId);
	        if (!needToReevaluate) {
	            return [];
	        }
	        else {
	            var affectedTree_1 = ImmutableTree.Empty;
	            if (write.snap != null) {
	                // overwrite
	                affectedTree_1 = affectedTree_1.set(Path.Empty, true);
	            }
	            else {
	                each(write.children, function (pathString, node) {
	                    affectedTree_1 = affectedTree_1.set(new Path(pathString), node);
	                });
	            }
	            return this.applyOperationToSyncPoints_(new AckUserWrite(write.path, affectedTree_1, revert));
	        }
	    };
	    /**
	     * Apply new server data for the specified path..
	     *
	     * @return Events to raise.
	     */
	    SyncTree.prototype.applyServerOverwrite = function (path, newData) {
	        return this.applyOperationToSyncPoints_(new Overwrite(OperationSource.Server, path, newData));
	    };
	    /**
	     * Apply new server data to be merged in at the specified path.
	     *
	     * @return Events to raise.
	     */
	    SyncTree.prototype.applyServerMerge = function (path, changedChildren) {
	        var changeTree = ImmutableTree.fromObject(changedChildren);
	        return this.applyOperationToSyncPoints_(new Merge(OperationSource.Server, path, changeTree));
	    };
	    /**
	     * Apply a listen complete for a query
	     *
	     * @return Events to raise.
	     */
	    SyncTree.prototype.applyListenComplete = function (path) {
	        return this.applyOperationToSyncPoints_(new ListenComplete(OperationSource.Server, path));
	    };
	    /**
	     * Apply new server data for the specified tagged query.
	     *
	     * @return Events to raise.
	     */
	    SyncTree.prototype.applyTaggedQueryOverwrite = function (path, snap, tag) {
	        var queryKey = this.queryKeyForTag_(tag);
	        if (queryKey != null) {
	            var r = SyncTree.parseQueryKey_(queryKey);
	            var queryPath = r.path, queryId = r.queryId;
	            var relativePath = Path.relativePath(queryPath, path);
	            var op = new Overwrite(OperationSource.forServerTaggedQuery(queryId), relativePath, snap);
	            return this.applyTaggedOperation_(queryPath, op);
	        }
	        else {
	            // Query must have been removed already
	            return [];
	        }
	    };
	    /**
	     * Apply server data to be merged in for the specified tagged query.
	     *
	     * @return Events to raise.
	     */
	    SyncTree.prototype.applyTaggedQueryMerge = function (path, changedChildren, tag) {
	        var queryKey = this.queryKeyForTag_(tag);
	        if (queryKey) {
	            var r = SyncTree.parseQueryKey_(queryKey);
	            var queryPath = r.path, queryId = r.queryId;
	            var relativePath = Path.relativePath(queryPath, path);
	            var changeTree = ImmutableTree.fromObject(changedChildren);
	            var op = new Merge(OperationSource.forServerTaggedQuery(queryId), relativePath, changeTree);
	            return this.applyTaggedOperation_(queryPath, op);
	        }
	        else {
	            // We've already removed the query. No big deal, ignore the update
	            return [];
	        }
	    };
	    /**
	     * Apply a listen complete for a tagged query
	     *
	     * @return Events to raise.
	     */
	    SyncTree.prototype.applyTaggedListenComplete = function (path, tag) {
	        var queryKey = this.queryKeyForTag_(tag);
	        if (queryKey) {
	            var r = SyncTree.parseQueryKey_(queryKey);
	            var queryPath = r.path, queryId = r.queryId;
	            var relativePath = Path.relativePath(queryPath, path);
	            var op = new ListenComplete(OperationSource.forServerTaggedQuery(queryId), relativePath);
	            return this.applyTaggedOperation_(queryPath, op);
	        }
	        else {
	            // We've already removed the query. No big deal, ignore the update
	            return [];
	        }
	    };
	    /**
	     * Add an event callback for the specified query.
	     *
	     * @return Events to raise.
	     */
	    SyncTree.prototype.addEventRegistration = function (query, eventRegistration) {
	        var path = query.path;
	        var serverCache = null;
	        var foundAncestorDefaultView = false;
	        // Any covering writes will necessarily be at the root, so really all we need to find is the server cache.
	        // Consider optimizing this once there's a better understanding of what actual behavior will be.
	        this.syncPointTree_.foreachOnPath(path, function (pathToSyncPoint, sp) {
	            var relativePath = Path.relativePath(pathToSyncPoint, path);
	            serverCache = serverCache || sp.getCompleteServerCache(relativePath);
	            foundAncestorDefaultView =
	                foundAncestorDefaultView || sp.hasCompleteView();
	        });
	        var syncPoint = this.syncPointTree_.get(path);
	        if (!syncPoint) {
	            syncPoint = new SyncPoint();
	            this.syncPointTree_ = this.syncPointTree_.set(path, syncPoint);
	        }
	        else {
	            foundAncestorDefaultView =
	                foundAncestorDefaultView || syncPoint.hasCompleteView();
	            serverCache = serverCache || syncPoint.getCompleteServerCache(Path.Empty);
	        }
	        var serverCacheComplete;
	        if (serverCache != null) {
	            serverCacheComplete = true;
	        }
	        else {
	            serverCacheComplete = false;
	            serverCache = ChildrenNode.EMPTY_NODE;
	            var subtree = this.syncPointTree_.subtree(path);
	            subtree.foreachChild(function (childName, childSyncPoint) {
	                var completeCache = childSyncPoint.getCompleteServerCache(Path.Empty);
	                if (completeCache) {
	                    serverCache = serverCache.updateImmediateChild(childName, completeCache);
	                }
	            });
	        }
	        var viewAlreadyExists = syncPoint.viewExistsForQuery(query);
	        if (!viewAlreadyExists && !query.getQueryParams().loadsAllData()) {
	            // We need to track a tag for this query
	            var queryKey = SyncTree.makeQueryKey_(query);
	            util.assert(!this.queryToTagMap.has(queryKey), 'View does not exist, but we have a tag');
	            var tag = SyncTree.getNextQueryTag_();
	            this.queryToTagMap.set(queryKey, tag);
	            this.tagToQueryMap.set(tag, queryKey);
	        }
	        var writesCache = this.pendingWriteTree_.childWrites(path);
	        var events = syncPoint.addEventRegistration(query, eventRegistration, writesCache, serverCache, serverCacheComplete);
	        if (!viewAlreadyExists && !foundAncestorDefaultView) {
	            var view /** @type !View */ = syncPoint.viewForQuery(query);
	            events = events.concat(this.setupListener_(query, view));
	        }
	        return events;
	    };
	    /**
	     * Remove event callback(s).
	     *
	     * If query is the default query, we'll check all queries for the specified eventRegistration.
	     * If eventRegistration is null, we'll remove all callbacks for the specified query/queries.
	     *
	     * @param eventRegistration If null, all callbacks are removed.
	     * @param cancelError If a cancelError is provided, appropriate cancel events will be returned.
	     * @return Cancel events, if cancelError was provided.
	     */
	    SyncTree.prototype.removeEventRegistration = function (query, eventRegistration, cancelError) {
	        var _this = this;
	        // Find the syncPoint first. Then deal with whether or not it has matching listeners
	        var path = query.path;
	        var maybeSyncPoint = this.syncPointTree_.get(path);
	        var cancelEvents = [];
	        // A removal on a default query affects all queries at that location. A removal on an indexed query, even one without
	        // other query constraints, does *not* affect all queries at that location. So this check must be for 'default', and
	        // not loadsAllData().
	        if (maybeSyncPoint &&
	            (query.queryIdentifier() === 'default' ||
	                maybeSyncPoint.viewExistsForQuery(query))) {
	            /**
	             * @type {{removed: !Array.<!Query>, events: !Array.<!Event>}}
	             */
	            var removedAndEvents = maybeSyncPoint.removeEventRegistration(query, eventRegistration, cancelError);
	            if (maybeSyncPoint.isEmpty()) {
	                this.syncPointTree_ = this.syncPointTree_.remove(path);
	            }
	            var removed = removedAndEvents.removed;
	            cancelEvents = removedAndEvents.events;
	            // We may have just removed one of many listeners and can short-circuit this whole process
	            // We may also not have removed a default listener, in which case all of the descendant listeners should already be
	            // properly set up.
	            //
	            // Since indexed queries can shadow if they don't have other query constraints, check for loadsAllData(), instead of
	            // queryId === 'default'
	            var removingDefault = -1 !==
	                removed.findIndex(function (query) {
	                    return query.getQueryParams().loadsAllData();
	                });
	            var covered = this.syncPointTree_.findOnPath(path, function (relativePath, parentSyncPoint) {
	                return parentSyncPoint.hasCompleteView();
	            });
	            if (removingDefault && !covered) {
	                var subtree = this.syncPointTree_.subtree(path);
	                // There are potentially child listeners. Determine what if any listens we need to send before executing the
	                // removal
	                if (!subtree.isEmpty()) {
	                    // We need to fold over our subtree and collect the listeners to send
	                    var newViews = this.collectDistinctViewsForSubTree_(subtree);
	                    // Ok, we've collected all the listens we need. Set them up.
	                    for (var i = 0; i < newViews.length; ++i) {
	                        var view = newViews[i], newQuery = view.getQuery();
	                        var listener = this.createListenerForView_(view);
	                        this.listenProvider_.startListening(SyncTree.queryForListening_(newQuery), this.tagForQuery_(newQuery), listener.hashFn, listener.onComplete);
	                    }
	                }
	            }
	            // If we removed anything and we're not covered by a higher up listen, we need to stop listening on this query
	            // The above block has us covered in terms of making sure we're set up on listens lower in the tree.
	            // Also, note that if we have a cancelError, it's already been removed at the provider level.
	            if (!covered && removed.length > 0 && !cancelError) {
	                // If we removed a default, then we weren't listening on any of the other queries here. Just cancel the one
	                // default. Otherwise, we need to iterate through and cancel each individual query
	                if (removingDefault) {
	                    // We don't tag default listeners
	                    var defaultTag = null;
	                    this.listenProvider_.stopListening(SyncTree.queryForListening_(query), defaultTag);
	                }
	                else {
	                    removed.forEach(function (queryToRemove) {
	                        var tagToRemove = _this.queryToTagMap.get(SyncTree.makeQueryKey_(queryToRemove));
	                        _this.listenProvider_.stopListening(SyncTree.queryForListening_(queryToRemove), tagToRemove);
	                    });
	                }
	            }
	            // Now, clear all of the tags we're tracking for the removed listens
	            this.removeTags_(removed);
	        }
	        return cancelEvents;
	    };
	    /**
	     * Returns a complete cache, if we have one, of the data at a particular path. If the location does not have a
	     * listener above it, we will get a false "null". This shouldn't be a problem because transactions will always
	     * have a listener above, and atomic operations would correctly show a jitter of <increment value> ->
	     *     <incremented total> as the write is applied locally and then acknowledged at the server.
	     *
	     * Note: this method will *include* hidden writes from transaction with applyLocally set to false.
	     *
	     * @param path The path to the data we want
	     * @param writeIdsToExclude A specific set to be excluded
	     */
	    SyncTree.prototype.calcCompleteEventCache = function (path, writeIdsToExclude) {
	        var includeHiddenSets = true;
	        var writeTree = this.pendingWriteTree_;
	        var serverCache = this.syncPointTree_.findOnPath(path, function (pathSoFar, syncPoint) {
	            var relativePath = Path.relativePath(pathSoFar, path);
	            var serverCache = syncPoint.getCompleteServerCache(relativePath);
	            if (serverCache) {
	                return serverCache;
	            }
	        });
	        return writeTree.calcCompleteEventCache(path, serverCache, writeIdsToExclude, includeHiddenSets);
	    };
	    /**
	     * This collapses multiple unfiltered views into a single view, since we only need a single
	     * listener for them.
	     */
	    SyncTree.prototype.collectDistinctViewsForSubTree_ = function (subtree) {
	        return subtree.fold(function (relativePath, maybeChildSyncPoint, childMap) {
	            if (maybeChildSyncPoint && maybeChildSyncPoint.hasCompleteView()) {
	                var completeView = maybeChildSyncPoint.getCompleteView();
	                return [completeView];
	            }
	            else {
	                // No complete view here, flatten any deeper listens into an array
	                var views_1 = [];
	                if (maybeChildSyncPoint) {
	                    views_1 = maybeChildSyncPoint.getQueryViews();
	                }
	                each(childMap, function (_key, childViews) {
	                    views_1 = views_1.concat(childViews);
	                });
	                return views_1;
	            }
	        });
	    };
	    SyncTree.prototype.removeTags_ = function (queries) {
	        for (var j = 0; j < queries.length; ++j) {
	            var removedQuery = queries[j];
	            if (!removedQuery.getQueryParams().loadsAllData()) {
	                // We should have a tag for this
	                var removedQueryKey = SyncTree.makeQueryKey_(removedQuery);
	                var removedQueryTag = this.queryToTagMap.get(removedQueryKey);
	                this.queryToTagMap.delete(removedQueryKey);
	                this.tagToQueryMap.delete(removedQueryTag);
	            }
	        }
	    };
	    /**
	     * Normalizes a query to a query we send the server for listening
	     *
	     * @return The normalized query
	     */
	    SyncTree.queryForListening_ = function (query) {
	        if (query.getQueryParams().loadsAllData() &&
	            !query.getQueryParams().isDefault()) {
	            // We treat queries that load all data as default queries
	            // Cast is necessary because ref() technically returns Firebase which is actually fb.api.Firebase which inherits
	            // from Query
	            return query.getRef();
	        }
	        else {
	            return query;
	        }
	    };
	    /**
	     * For a given new listen, manage the de-duplication of outstanding subscriptions.
	     *
	     * @return This method can return events to support synchronous data sources
	     */
	    SyncTree.prototype.setupListener_ = function (query, view) {
	        var path = query.path;
	        var tag = this.tagForQuery_(query);
	        var listener = this.createListenerForView_(view);
	        var events = this.listenProvider_.startListening(SyncTree.queryForListening_(query), tag, listener.hashFn, listener.onComplete);
	        var subtree = this.syncPointTree_.subtree(path);
	        // The root of this subtree has our query. We're here because we definitely need to send a listen for that, but we
	        // may need to shadow other listens as well.
	        if (tag) {
	            util.assert(!subtree.value.hasCompleteView(), "If we're adding a query, it shouldn't be shadowed");
	        }
	        else {
	            // Shadow everything at or below this location, this is a default listener.
	            var queriesToStop = subtree.fold(function (relativePath, maybeChildSyncPoint, childMap) {
	                if (!relativePath.isEmpty() &&
	                    maybeChildSyncPoint &&
	                    maybeChildSyncPoint.hasCompleteView()) {
	                    return [maybeChildSyncPoint.getCompleteView().getQuery()];
	                }
	                else {
	                    // No default listener here, flatten any deeper queries into an array
	                    var queries_1 = [];
	                    if (maybeChildSyncPoint) {
	                        queries_1 = queries_1.concat(maybeChildSyncPoint.getQueryViews().map(function (view) { return view.getQuery(); }));
	                    }
	                    each(childMap, function (_key, childQueries) {
	                        queries_1 = queries_1.concat(childQueries);
	                    });
	                    return queries_1;
	                }
	            });
	            for (var i = 0; i < queriesToStop.length; ++i) {
	                var queryToStop = queriesToStop[i];
	                this.listenProvider_.stopListening(SyncTree.queryForListening_(queryToStop), this.tagForQuery_(queryToStop));
	            }
	        }
	        return events;
	    };
	    SyncTree.prototype.createListenerForView_ = function (view) {
	        var _this = this;
	        var query = view.getQuery();
	        var tag = this.tagForQuery_(query);
	        return {
	            hashFn: function () {
	                var cache = view.getServerCache() || ChildrenNode.EMPTY_NODE;
	                return cache.hash();
	            },
	            onComplete: function (status) {
	                if (status === 'ok') {
	                    if (tag) {
	                        return _this.applyTaggedListenComplete(query.path, tag);
	                    }
	                    else {
	                        return _this.applyListenComplete(query.path);
	                    }
	                }
	                else {
	                    // If a listen failed, kill all of the listeners here, not just the one that triggered the error.
	                    // Note that this may need to be scoped to just this listener if we change permissions on filtered children
	                    var error = errorForServerCode(status, query);
	                    return _this.removeEventRegistration(query, 
	                    /*eventRegistration*/ null, error);
	                }
	            }
	        };
	    };
	    /**
	     * Given a query, computes a "queryKey" suitable for use in our queryToTagMap_.
	     */
	    SyncTree.makeQueryKey_ = function (query) {
	        return query.path.toString() + '$' + query.queryIdentifier();
	    };
	    /**
	     * Given a queryKey (created by makeQueryKey), parse it back into a path and queryId.
	     */
	    SyncTree.parseQueryKey_ = function (queryKey) {
	        var splitIndex = queryKey.indexOf('$');
	        util.assert(splitIndex !== -1 && splitIndex < queryKey.length - 1, 'Bad queryKey.');
	        return {
	            queryId: queryKey.substr(splitIndex + 1),
	            path: new Path(queryKey.substr(0, splitIndex))
	        };
	    };
	    /**
	     * Return the query associated with the given tag, if we have one
	     */
	    SyncTree.prototype.queryKeyForTag_ = function (tag) {
	        return this.tagToQueryMap.get(tag);
	    };
	    /**
	     * Return the tag associated with the given query.
	     */
	    SyncTree.prototype.tagForQuery_ = function (query) {
	        var queryKey = SyncTree.makeQueryKey_(query);
	        return this.queryToTagMap.get(queryKey);
	    };
	    /**
	     * Static accessor for query tags.
	     */
	    SyncTree.getNextQueryTag_ = function () {
	        return SyncTree.nextQueryTag_++;
	    };
	    /**
	     * A helper method to apply tagged operations
	     */
	    SyncTree.prototype.applyTaggedOperation_ = function (queryPath, operation) {
	        var syncPoint = this.syncPointTree_.get(queryPath);
	        util.assert(syncPoint, "Missing sync point for query tag that we're tracking");
	        var writesCache = this.pendingWriteTree_.childWrites(queryPath);
	        return syncPoint.applyOperation(operation, writesCache, 
	        /*serverCache=*/ null);
	    };
	    /**
	     * A helper method that visits all descendant and ancestor SyncPoints, applying the operation.
	     *
	     * NOTES:
	     * - Descendant SyncPoints will be visited first (since we raise events depth-first).
	     *
	     * - We call applyOperation() on each SyncPoint passing three things:
	     *   1. A version of the Operation that has been made relative to the SyncPoint location.
	     *   2. A WriteTreeRef of any writes we have cached at the SyncPoint location.
	     *   3. A snapshot Node with cached server data, if we have it.
	     *
	     * - We concatenate all of the events returned by each SyncPoint and return the result.
	     */
	    SyncTree.prototype.applyOperationToSyncPoints_ = function (operation) {
	        return this.applyOperationHelper_(operation, this.syncPointTree_, 
	        /*serverCache=*/ null, this.pendingWriteTree_.childWrites(Path.Empty));
	    };
	    /**
	     * Recursive helper for applyOperationToSyncPoints_
	     */
	    SyncTree.prototype.applyOperationHelper_ = function (operation, syncPointTree, serverCache, writesCache) {
	        if (operation.path.isEmpty()) {
	            return this.applyOperationDescendantsHelper_(operation, syncPointTree, serverCache, writesCache);
	        }
	        else {
	            var syncPoint = syncPointTree.get(Path.Empty);
	            // If we don't have cached server data, see if we can get it from this SyncPoint.
	            if (serverCache == null && syncPoint != null) {
	                serverCache = syncPoint.getCompleteServerCache(Path.Empty);
	            }
	            var events = [];
	            var childName = operation.path.getFront();
	            var childOperation = operation.operationForChild(childName);
	            var childTree = syncPointTree.children.get(childName);
	            if (childTree && childOperation) {
	                var childServerCache = serverCache
	                    ? serverCache.getImmediateChild(childName)
	                    : null;
	                var childWritesCache = writesCache.child(childName);
	                events = events.concat(this.applyOperationHelper_(childOperation, childTree, childServerCache, childWritesCache));
	            }
	            if (syncPoint) {
	                events = events.concat(syncPoint.applyOperation(operation, writesCache, serverCache));
	            }
	            return events;
	        }
	    };
	    /**
	     * Recursive helper for applyOperationToSyncPoints_
	     */
	    SyncTree.prototype.applyOperationDescendantsHelper_ = function (operation, syncPointTree, serverCache, writesCache) {
	        var _this = this;
	        var syncPoint = syncPointTree.get(Path.Empty);
	        // If we don't have cached server data, see if we can get it from this SyncPoint.
	        if (serverCache == null && syncPoint != null) {
	            serverCache = syncPoint.getCompleteServerCache(Path.Empty);
	        }
	        var events = [];
	        syncPointTree.children.inorderTraversal(function (childName, childTree) {
	            var childServerCache = serverCache
	                ? serverCache.getImmediateChild(childName)
	                : null;
	            var childWritesCache = writesCache.child(childName);
	            var childOperation = operation.operationForChild(childName);
	            if (childOperation) {
	                events = events.concat(_this.applyOperationDescendantsHelper_(childOperation, childTree, childServerCache, childWritesCache));
	            }
	        });
	        if (syncPoint) {
	            events = events.concat(syncPoint.applyOperation(operation, writesCache, serverCache));
	        }
	        return events;
	    };
	    /**
	     * Static tracker for next query tag.
	     */
	    SyncTree.nextQueryTag_ = 1;
	    return SyncTree;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Mutable object which basically just stores a reference to the "latest" immutable snapshot.
	 *
	 * @constructor
	 */
	var SnapshotHolder = /** @class */ (function () {
	    function SnapshotHolder() {
	        this.rootNode_ = ChildrenNode.EMPTY_NODE;
	    }
	    SnapshotHolder.prototype.getNode = function (path) {
	        return this.rootNode_.getChild(path);
	    };
	    SnapshotHolder.prototype.updateSnapshot = function (path, newSnapshotNode) {
	        this.rootNode_ = this.rootNode_.updateChild(path, newSnapshotNode);
	    };
	    return SnapshotHolder;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Abstraction around FirebaseApp's token fetching capabilities.
	 */
	var AuthTokenProvider = /** @class */ (function () {
	    function AuthTokenProvider(app_, authProvider_) {
	        var _this = this;
	        this.app_ = app_;
	        this.authProvider_ = authProvider_;
	        this.auth_ = null;
	        this.auth_ = authProvider_.getImmediate({ optional: true });
	        if (!this.auth_) {
	            authProvider_.get().then(function (auth) { return (_this.auth_ = auth); });
	        }
	    }
	    /**
	     * @param {boolean} forceRefresh
	     * @return {!Promise<FirebaseAuthTokenData>}
	     */
	    AuthTokenProvider.prototype.getToken = function (forceRefresh) {
	        if (!this.auth_) {
	            return Promise.resolve(null);
	        }
	        return this.auth_.getToken(forceRefresh).catch(function (error) {
	            // TODO: Need to figure out all the cases this is raised and whether
	            // this makes sense.
	            if (error && error.code === 'auth/token-not-initialized') {
	                log('Got auth/token-not-initialized error.  Treating as null token.');
	                return null;
	            }
	            else {
	                return Promise.reject(error);
	            }
	        });
	    };
	    AuthTokenProvider.prototype.addTokenChangeListener = function (listener) {
	        // TODO: We might want to wrap the listener and call it with no args to
	        // avoid a leaky abstraction, but that makes removing the listener harder.
	        if (this.auth_) {
	            this.auth_.addAuthTokenListener(listener);
	        }
	        else {
	            setTimeout(function () { return listener(null); }, 0);
	            this.authProvider_
	                .get()
	                .then(function (auth) { return auth.addAuthTokenListener(listener); });
	        }
	    };
	    AuthTokenProvider.prototype.removeTokenChangeListener = function (listener) {
	        this.authProvider_
	            .get()
	            .then(function (auth) { return auth.removeAuthTokenListener(listener); });
	    };
	    AuthTokenProvider.prototype.notifyForInvalidToken = function () {
	        var errorMessage = 'Provided authentication credentials for the app named "' +
	            this.app_.name +
	            '" are invalid. This usually indicates your app was not ' +
	            'initialized correctly. ';
	        if ('credential' in this.app_.options) {
	            errorMessage +=
	                'Make sure the "credential" property provided to initializeApp() ' +
	                    'is authorized to access the specified "databaseURL" and is from the correct ' +
	                    'project.';
	        }
	        else if ('serviceAccount' in this.app_.options) {
	            errorMessage +=
	                'Make sure the "serviceAccount" property provided to initializeApp() ' +
	                    'is authorized to access the specified "databaseURL" and is from the correct ' +
	                    'project.';
	        }
	        else {
	            errorMessage +=
	                'Make sure the "apiKey" and "databaseURL" properties provided to ' +
	                    'initializeApp() match the values provided for your app at ' +
	                    'https://console.firebase.google.com/.';
	        }
	        warn(errorMessage);
	    };
	    return AuthTokenProvider;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Tracks a collection of stats.
	 *
	 * @constructor
	 */
	var StatsCollection = /** @class */ (function () {
	    function StatsCollection() {
	        this.counters_ = {};
	    }
	    StatsCollection.prototype.incrementCounter = function (name, amount) {
	        if (amount === void 0) { amount = 1; }
	        if (!util.contains(this.counters_, name)) {
	            this.counters_[name] = 0;
	        }
	        this.counters_[name] += amount;
	    };
	    StatsCollection.prototype.get = function () {
	        return util.deepCopy(this.counters_);
	    };
	    return StatsCollection;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var StatsManager = /** @class */ (function () {
	    function StatsManager() {
	    }
	    StatsManager.getCollection = function (repoInfo) {
	        var hashString = repoInfo.toString();
	        if (!this.collections_[hashString]) {
	            this.collections_[hashString] = new StatsCollection();
	        }
	        return this.collections_[hashString];
	    };
	    StatsManager.getOrCreateReporter = function (repoInfo, creatorFunction) {
	        var hashString = repoInfo.toString();
	        if (!this.reporters_[hashString]) {
	            this.reporters_[hashString] = creatorFunction();
	        }
	        return this.reporters_[hashString];
	    };
	    StatsManager.collections_ = {};
	    StatsManager.reporters_ = {};
	    return StatsManager;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Returns the delta from the previous call to get stats.
	 *
	 * @param collection_ The collection to "listen" to.
	 * @constructor
	 */
	var StatsListener = /** @class */ (function () {
	    function StatsListener(collection_) {
	        this.collection_ = collection_;
	        this.last_ = null;
	    }
	    StatsListener.prototype.get = function () {
	        var newStats = this.collection_.get();
	        var delta = tslib.__assign({}, newStats);
	        if (this.last_) {
	            each(this.last_, function (stat, value) {
	                delta[stat] = delta[stat] - value;
	            });
	        }
	        this.last_ = newStats;
	        return delta;
	    };
	    return StatsListener;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	// Assuming some apps may have a short amount of time on page, and a bulk of firebase operations probably
	// happen on page load, we try to report our first set of stats pretty quickly, but we wait at least 10
	// seconds to try to ensure the Firebase connection is established / settled.
	var FIRST_STATS_MIN_TIME = 10 * 1000;
	var FIRST_STATS_MAX_TIME = 30 * 1000;
	// We'll continue to report stats on average every 5 minutes.
	var REPORT_STATS_INTERVAL = 5 * 60 * 1000;
	/**
	 * @constructor
	 */
	var StatsReporter = /** @class */ (function () {
	    /**
	     * @param collection
	     * @param server_
	     */
	    function StatsReporter(collection, server_) {
	        this.server_ = server_;
	        this.statsToReport_ = {};
	        this.statsListener_ = new StatsListener(collection);
	        var timeout = FIRST_STATS_MIN_TIME +
	            (FIRST_STATS_MAX_TIME - FIRST_STATS_MIN_TIME) * Math.random();
	        setTimeoutNonBlocking(this.reportStats_.bind(this), Math.floor(timeout));
	    }
	    StatsReporter.prototype.includeStat = function (stat) {
	        this.statsToReport_[stat] = true;
	    };
	    StatsReporter.prototype.reportStats_ = function () {
	        var _this = this;
	        var stats = this.statsListener_.get();
	        var reportedStats = {};
	        var haveStatsToReport = false;
	        each(stats, function (stat, value) {
	            if (value > 0 && util.contains(_this.statsToReport_, stat)) {
	                reportedStats[stat] = value;
	                haveStatsToReport = true;
	            }
	        });
	        if (haveStatsToReport) {
	            this.server_.reportStats(reportedStats);
	        }
	        // queue our next run.
	        setTimeoutNonBlocking(this.reportStats_.bind(this), Math.floor(Math.random() * 2 * REPORT_STATS_INTERVAL));
	    };
	    return StatsReporter;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * The event queue serves a few purposes:
	 * 1. It ensures we maintain event order in the face of event callbacks doing operations that result in more
	 *    events being queued.
	 * 2. raiseQueuedEvents() handles being called reentrantly nicely.  That is, if in the course of raising events,
	 *    raiseQueuedEvents() is called again, the "inner" call will pick up raising events where the "outer" call
	 *    left off, ensuring that the events are still raised synchronously and in order.
	 * 3. You can use raiseEventsAtPath and raiseEventsForChangedPath to ensure only relevant previously-queued
	 *    events are raised synchronously.
	 *
	 * NOTE: This can all go away if/when we move to async events.
	 *
	 * @constructor
	 */
	var EventQueue = /** @class */ (function () {
	    function EventQueue() {
	        /**
	         * @private
	         * @type {!Array.<EventList>}
	         */
	        this.eventLists_ = [];
	        /**
	         * Tracks recursion depth of raiseQueuedEvents_, for debugging purposes.
	         * @private
	         * @type {!number}
	         */
	        this.recursionDepth_ = 0;
	    }
	    /**
	     * @param {!Array.<Event>} eventDataList The new events to queue.
	     */
	    EventQueue.prototype.queueEvents = function (eventDataList) {
	        // We group events by path, storing them in a single EventList, to make it easier to skip over them quickly.
	        var currList = null;
	        for (var i = 0; i < eventDataList.length; i++) {
	            var eventData = eventDataList[i];
	            var eventPath = eventData.getPath();
	            if (currList !== null && !eventPath.equals(currList.getPath())) {
	                this.eventLists_.push(currList);
	                currList = null;
	            }
	            if (currList === null) {
	                currList = new EventList(eventPath);
	            }
	            currList.add(eventData);
	        }
	        if (currList) {
	            this.eventLists_.push(currList);
	        }
	    };
	    /**
	     * Queues the specified events and synchronously raises all events (including previously queued ones)
	     * for the specified path.
	     *
	     * It is assumed that the new events are all for the specified path.
	     *
	     * @param {!Path} path The path to raise events for.
	     * @param {!Array.<Event>} eventDataList The new events to raise.
	     */
	    EventQueue.prototype.raiseEventsAtPath = function (path, eventDataList) {
	        this.queueEvents(eventDataList);
	        this.raiseQueuedEventsMatchingPredicate_(function (eventPath) {
	            return eventPath.equals(path);
	        });
	    };
	    /**
	     * Queues the specified events and synchronously raises all events (including previously queued ones) for
	     * locations related to the specified change path (i.e. all ancestors and descendants).
	     *
	     * It is assumed that the new events are all related (ancestor or descendant) to the specified path.
	     *
	     * @param {!Path} changedPath The path to raise events for.
	     * @param {!Array.<!Event>} eventDataList The events to raise
	     */
	    EventQueue.prototype.raiseEventsForChangedPath = function (changedPath, eventDataList) {
	        this.queueEvents(eventDataList);
	        this.raiseQueuedEventsMatchingPredicate_(function (eventPath) {
	            return eventPath.contains(changedPath) || changedPath.contains(eventPath);
	        });
	    };
	    /**
	     * @param {!function(!Path):boolean} predicate
	     * @private
	     */
	    EventQueue.prototype.raiseQueuedEventsMatchingPredicate_ = function (predicate) {
	        this.recursionDepth_++;
	        var sentAll = true;
	        for (var i = 0; i < this.eventLists_.length; i++) {
	            var eventList = this.eventLists_[i];
	            if (eventList) {
	                var eventPath = eventList.getPath();
	                if (predicate(eventPath)) {
	                    this.eventLists_[i].raise();
	                    this.eventLists_[i] = null;
	                }
	                else {
	                    sentAll = false;
	                }
	            }
	        }
	        if (sentAll) {
	            this.eventLists_ = [];
	        }
	        this.recursionDepth_--;
	    };
	    return EventQueue;
	}());
	/**
	 * @param {!Path} path
	 * @constructor
	 */
	var EventList = /** @class */ (function () {
	    function EventList(path_) {
	        this.path_ = path_;
	        /**
	         * @type {!Array.<Event>}
	         * @private
	         */
	        this.events_ = [];
	    }
	    /**
	     * @param {!Event} eventData
	     */
	    EventList.prototype.add = function (eventData) {
	        this.events_.push(eventData);
	    };
	    /**
	     * Iterates through the list and raises each event
	     */
	    EventList.prototype.raise = function () {
	        for (var i = 0; i < this.events_.length; i++) {
	            var eventData = this.events_[i];
	            if (eventData !== null) {
	                this.events_[i] = null;
	                var eventFn = eventData.getEventRunner();
	                if (logger) {
	                    log('event: ' + eventData.toString());
	                }
	                exceptionGuard(eventFn);
	            }
	        }
	    };
	    /**
	     * @return {!Path}
	     */
	    EventList.prototype.getPath = function () {
	        return this.path_;
	    };
	    return EventList;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Base class to be used if you want to emit events. Call the constructor with
	 * the set of allowed event names.
	 */
	var EventEmitter = /** @class */ (function () {
	    /**
	     * @param {!Array.<string>} allowedEvents_
	     */
	    function EventEmitter(allowedEvents_) {
	        this.allowedEvents_ = allowedEvents_;
	        this.listeners_ = {};
	        util.assert(Array.isArray(allowedEvents_) && allowedEvents_.length > 0, 'Requires a non-empty array');
	    }
	    /**
	     * To be called by derived classes to trigger events.
	     * @param {!string} eventType
	     * @param {...*} varArgs
	     */
	    EventEmitter.prototype.trigger = function (eventType) {
	        var varArgs = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            varArgs[_i - 1] = arguments[_i];
	        }
	        if (Array.isArray(this.listeners_[eventType])) {
	            // Clone the list, since callbacks could add/remove listeners.
	            var listeners = tslib.__spread(this.listeners_[eventType]);
	            for (var i = 0; i < listeners.length; i++) {
	                listeners[i].callback.apply(listeners[i].context, varArgs);
	            }
	        }
	    };
	    EventEmitter.prototype.on = function (eventType, callback, context) {
	        this.validateEventType_(eventType);
	        this.listeners_[eventType] = this.listeners_[eventType] || [];
	        this.listeners_[eventType].push({ callback: callback, context: context });
	        var eventData = this.getInitialEvent(eventType);
	        if (eventData) {
	            callback.apply(context, eventData);
	        }
	    };
	    EventEmitter.prototype.off = function (eventType, callback, context) {
	        this.validateEventType_(eventType);
	        var listeners = this.listeners_[eventType] || [];
	        for (var i = 0; i < listeners.length; i++) {
	            if (listeners[i].callback === callback &&
	                (!context || context === listeners[i].context)) {
	                listeners.splice(i, 1);
	                return;
	            }
	        }
	    };
	    EventEmitter.prototype.validateEventType_ = function (eventType) {
	        util.assert(this.allowedEvents_.find(function (et) {
	            return et === eventType;
	        }), 'Unknown event: ' + eventType);
	    };
	    return EventEmitter;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @extends {EventEmitter}
	 */
	var VisibilityMonitor = /** @class */ (function (_super) {
	    tslib.__extends(VisibilityMonitor, _super);
	    function VisibilityMonitor() {
	        var _this = _super.call(this, ['visible']) || this;
	        var hidden;
	        var visibilityChange;
	        if (typeof document !== 'undefined' &&
	            typeof document.addEventListener !== 'undefined') {
	            if (typeof document['hidden'] !== 'undefined') {
	                // Opera 12.10 and Firefox 18 and later support
	                visibilityChange = 'visibilitychange';
	                hidden = 'hidden';
	            }
	            else if (typeof document['mozHidden'] !== 'undefined') {
	                visibilityChange = 'mozvisibilitychange';
	                hidden = 'mozHidden';
	            }
	            else if (typeof document['msHidden'] !== 'undefined') {
	                visibilityChange = 'msvisibilitychange';
	                hidden = 'msHidden';
	            }
	            else if (typeof document['webkitHidden'] !== 'undefined') {
	                visibilityChange = 'webkitvisibilitychange';
	                hidden = 'webkitHidden';
	            }
	        }
	        // Initially, we always assume we are visible. This ensures that in browsers
	        // without page visibility support or in cases where we are never visible
	        // (e.g. chrome extension), we act as if we are visible, i.e. don't delay
	        // reconnects
	        _this.visible_ = true;
	        if (visibilityChange) {
	            document.addEventListener(visibilityChange, function () {
	                var visible = !document[hidden];
	                if (visible !== _this.visible_) {
	                    _this.visible_ = visible;
	                    _this.trigger('visible', visible);
	                }
	            }, false);
	        }
	        return _this;
	    }
	    VisibilityMonitor.getInstance = function () {
	        return new VisibilityMonitor();
	    };
	    /**
	     * @param {!string} eventType
	     * @return {Array.<boolean>}
	     */
	    VisibilityMonitor.prototype.getInitialEvent = function (eventType) {
	        util.assert(eventType === 'visible', 'Unknown event type: ' + eventType);
	        return [this.visible_];
	    };
	    return VisibilityMonitor;
	}(EventEmitter));
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Monitors online state (as reported by window.online/offline events).
	 *
	 * The expectation is that this could have many false positives (thinks we are online
	 * when we're not), but no false negatives.  So we can safely use it to determine when
	 * we definitely cannot reach the internet.
	 *
	 * @extends {EventEmitter}
	 */
	var OnlineMonitor = /** @class */ (function (_super) {
	    tslib.__extends(OnlineMonitor, _super);
	    function OnlineMonitor() {
	        var _this = _super.call(this, ['online']) || this;
	        _this.online_ = true;
	        // We've had repeated complaints that Cordova apps can get stuck "offline", e.g.
	        // https://forum.ionicframework.com/t/firebase-connection-is-lost-and-never-come-back/43810
	        // It would seem that the 'online' event does not always fire consistently. So we disable it
	        // for Cordova.
	        if (typeof window !== 'undefined' &&
	            typeof window.addEventListener !== 'undefined' &&
	            !util.isMobileCordova()) {
	            window.addEventListener('online', function () {
	                if (!_this.online_) {
	                    _this.online_ = true;
	                    _this.trigger('online', true);
	                }
	            }, false);
	            window.addEventListener('offline', function () {
	                if (_this.online_) {
	                    _this.online_ = false;
	                    _this.trigger('online', false);
	                }
	            }, false);
	        }
	        return _this;
	    }
	    OnlineMonitor.getInstance = function () {
	        return new OnlineMonitor();
	    };
	    /**
	     * @param {!string} eventType
	     * @return {Array.<boolean>}
	     */
	    OnlineMonitor.prototype.getInitialEvent = function (eventType) {
	        util.assert(eventType === 'online', 'Unknown event type: ' + eventType);
	        return [this.online_];
	    };
	    /**
	     * @return {boolean}
	     */
	    OnlineMonitor.prototype.currentlyOnline = function () {
	        return this.online_;
	    };
	    return OnlineMonitor;
	}(EventEmitter));
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * This class ensures the packets from the server arrive in order
	 * This class takes data from the server and ensures it gets passed into the callbacks in order.
	 * @constructor
	 */
	var PacketReceiver = /** @class */ (function () {
	    /**
	     * @param onMessage_
	     */
	    function PacketReceiver(onMessage_) {
	        this.onMessage_ = onMessage_;
	        this.pendingResponses = [];
	        this.currentResponseNum = 0;
	        this.closeAfterResponse = -1;
	        this.onClose = null;
	    }
	    PacketReceiver.prototype.closeAfter = function (responseNum, callback) {
	        this.closeAfterResponse = responseNum;
	        this.onClose = callback;
	        if (this.closeAfterResponse < this.currentResponseNum) {
	            this.onClose();
	            this.onClose = null;
	        }
	    };
	    /**
	     * Each message from the server comes with a response number, and an array of data. The responseNumber
	     * allows us to ensure that we process them in the right order, since we can't be guaranteed that all
	     * browsers will respond in the same order as the requests we sent
	     * @param {number} requestNum
	     * @param {Array} data
	     */
	    PacketReceiver.prototype.handleResponse = function (requestNum, data) {
	        var _this = this;
	        this.pendingResponses[requestNum] = data;
	        var _loop_1 = function () {
	            var toProcess = this_1.pendingResponses[this_1.currentResponseNum];
	            delete this_1.pendingResponses[this_1.currentResponseNum];
	            var _loop_2 = function (i) {
	                if (toProcess[i]) {
	                    exceptionGuard(function () {
	                        _this.onMessage_(toProcess[i]);
	                    });
	                }
	            };
	            for (var i = 0; i < toProcess.length; ++i) {
	                _loop_2(i);
	            }
	            if (this_1.currentResponseNum === this_1.closeAfterResponse) {
	                if (this_1.onClose) {
	                    this_1.onClose();
	                    this_1.onClose = null;
	                }
	                return "break";
	            }
	            this_1.currentResponseNum++;
	        };
	        var this_1 = this;
	        while (this.pendingResponses[this.currentResponseNum]) {
	            var state_1 = _loop_1();
	            if (state_1 === "break")
	                break;
	        }
	    };
	    return PacketReceiver;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	// URL query parameters associated with longpolling
	var FIREBASE_LONGPOLL_START_PARAM = 'start';
	var FIREBASE_LONGPOLL_CLOSE_COMMAND = 'close';
	var FIREBASE_LONGPOLL_COMMAND_CB_NAME = 'pLPCommand';
	var FIREBASE_LONGPOLL_DATA_CB_NAME = 'pRTLPCB';
	var FIREBASE_LONGPOLL_ID_PARAM = 'id';
	var FIREBASE_LONGPOLL_PW_PARAM = 'pw';
	var FIREBASE_LONGPOLL_SERIAL_PARAM = 'ser';
	var FIREBASE_LONGPOLL_CALLBACK_ID_PARAM = 'cb';
	var FIREBASE_LONGPOLL_SEGMENT_NUM_PARAM = 'seg';
	var FIREBASE_LONGPOLL_SEGMENTS_IN_PACKET = 'ts';
	var FIREBASE_LONGPOLL_DATA_PARAM = 'd';
	var FIREBASE_LONGPOLL_DISCONN_FRAME_REQUEST_PARAM = 'dframe';
	//Data size constants.
	//TODO: Perf: the maximum length actually differs from browser to browser.
	// We should check what browser we're on and set accordingly.
	var MAX_URL_DATA_SIZE = 1870;
	var SEG_HEADER_SIZE = 30; //ie: &seg=8299234&ts=982389123&d=
	var MAX_PAYLOAD_SIZE = MAX_URL_DATA_SIZE - SEG_HEADER_SIZE;
	/**
	 * Keepalive period
	 * send a fresh request at minimum every 25 seconds. Opera has a maximum request
	 * length of 30 seconds that we can't exceed.
	 * @const
	 * @type {number}
	 */
	var KEEPALIVE_REQUEST_INTERVAL = 25000;
	/**
	 * How long to wait before aborting a long-polling connection attempt.
	 * @const
	 * @type {number}
	 */
	var LP_CONNECT_TIMEOUT = 30000;
	/**
	 * This class manages a single long-polling connection.
	 *
	 * @constructor
	 * @implements {Transport}
	 */
	var BrowserPollConnection = /** @class */ (function () {
	    /**
	     * @param {string} connId An identifier for this connection, used for logging
	     * @param {RepoInfo} repoInfo The info for the endpoint to send data to.
	     * @param {string=} transportSessionId Optional transportSessionid if we are reconnecting for an existing
	     *                                         transport session
	     * @param {string=}  lastSessionId Optional lastSessionId if the PersistentConnection has already created a
	     *                                     connection previously
	     */
	    function BrowserPollConnection(connId, repoInfo, transportSessionId, lastSessionId) {
	        this.connId = connId;
	        this.repoInfo = repoInfo;
	        this.transportSessionId = transportSessionId;
	        this.lastSessionId = lastSessionId;
	        this.bytesSent = 0;
	        this.bytesReceived = 0;
	        this.everConnected_ = false;
	        this.log_ = logWrapper(connId);
	        this.stats_ = StatsManager.getCollection(repoInfo);
	        this.urlFn = function (params) {
	            return repoInfo.connectionURL(LONG_POLLING, params);
	        };
	    }
	    /**
	     *
	     * @param {function(Object)} onMessage Callback when messages arrive
	     * @param {function()} onDisconnect Callback with connection lost.
	     */
	    BrowserPollConnection.prototype.open = function (onMessage, onDisconnect) {
	        var _this = this;
	        this.curSegmentNum = 0;
	        this.onDisconnect_ = onDisconnect;
	        this.myPacketOrderer = new PacketReceiver(onMessage);
	        this.isClosed_ = false;
	        this.connectTimeoutTimer_ = setTimeout(function () {
	            _this.log_('Timed out trying to connect.');
	            // Make sure we clear the host cache
	            _this.onClosed_();
	            _this.connectTimeoutTimer_ = null;
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        }, Math.floor(LP_CONNECT_TIMEOUT));
	        // Ensure we delay the creation of the iframe until the DOM is loaded.
	        executeWhenDOMReady(function () {
	            if (_this.isClosed_) {
	                return;
	            }
	            //Set up a callback that gets triggered once a connection is set up.
	            _this.scriptTagHolder = new FirebaseIFrameScriptHolder(function () {
	                var args = [];
	                for (var _i = 0; _i < arguments.length; _i++) {
	                    args[_i] = arguments[_i];
	                }
	                var _a = tslib.__read(args, 5), command = _a[0], arg1 = _a[1], arg2 = _a[2], arg3 = _a[3], arg4 = _a[4];
	                _this.incrementIncomingBytes_(args);
	                if (!_this.scriptTagHolder) {
	                    return; // we closed the connection.
	                }
	                if (_this.connectTimeoutTimer_) {
	                    clearTimeout(_this.connectTimeoutTimer_);
	                    _this.connectTimeoutTimer_ = null;
	                }
	                _this.everConnected_ = true;
	                if (command === FIREBASE_LONGPOLL_START_PARAM) {
	                    _this.id = arg1;
	                    _this.password = arg2;
	                }
	                else if (command === FIREBASE_LONGPOLL_CLOSE_COMMAND) {
	                    // Don't clear the host cache. We got a response from the server, so we know it's reachable
	                    if (arg1) {
	                        // We aren't expecting any more data (other than what the server's already in the process of sending us
	                        // through our already open polls), so don't send any more.
	                        _this.scriptTagHolder.sendNewPolls = false;
	                        // arg1 in this case is the last response number sent by the server. We should try to receive
	                        // all of the responses up to this one before closing
	                        _this.myPacketOrderer.closeAfter(arg1, function () {
	                            _this.onClosed_();
	                        });
	                    }
	                    else {
	                        _this.onClosed_();
	                    }
	                }
	                else {
	                    throw new Error('Unrecognized command received: ' + command);
	                }
	            }, function () {
	                var args = [];
	                for (var _i = 0; _i < arguments.length; _i++) {
	                    args[_i] = arguments[_i];
	                }
	                var _a = tslib.__read(args, 2), pN = _a[0], data = _a[1];
	                _this.incrementIncomingBytes_(args);
	                _this.myPacketOrderer.handleResponse(pN, data);
	            }, function () {
	                _this.onClosed_();
	            }, _this.urlFn);
	            //Send the initial request to connect. The serial number is simply to keep the browser from pulling previous results
	            //from cache.
	            var urlParams = {};
	            urlParams[FIREBASE_LONGPOLL_START_PARAM] = 't';
	            urlParams[FIREBASE_LONGPOLL_SERIAL_PARAM] = Math.floor(Math.random() * 100000000);
	            if (_this.scriptTagHolder.uniqueCallbackIdentifier) {
	                urlParams[FIREBASE_LONGPOLL_CALLBACK_ID_PARAM] = _this.scriptTagHolder.uniqueCallbackIdentifier;
	            }
	            urlParams[VERSION_PARAM] = PROTOCOL_VERSION;
	            if (_this.transportSessionId) {
	                urlParams[TRANSPORT_SESSION_PARAM] = _this.transportSessionId;
	            }
	            if (_this.lastSessionId) {
	                urlParams[LAST_SESSION_PARAM] = _this.lastSessionId;
	            }
	            if (typeof location !== 'undefined' &&
	                location.href &&
	                location.href.indexOf(FORGE_DOMAIN) !== -1) {
	                urlParams[REFERER_PARAM] = FORGE_REF;
	            }
	            var connectURL = _this.urlFn(urlParams);
	            _this.log_('Connecting via long-poll to ' + connectURL);
	            _this.scriptTagHolder.addTag(connectURL, function () {
	                /* do nothing */
	            });
	        });
	    };
	    /**
	     * Call this when a handshake has completed successfully and we want to consider the connection established
	     */
	    BrowserPollConnection.prototype.start = function () {
	        this.scriptTagHolder.startLongPoll(this.id, this.password);
	        this.addDisconnectPingFrame(this.id, this.password);
	    };
	    /**
	     * Forces long polling to be considered as a potential transport
	     */
	    BrowserPollConnection.forceAllow = function () {
	        BrowserPollConnection.forceAllow_ = true;
	    };
	    /**
	     * Forces longpolling to not be considered as a potential transport
	     */
	    BrowserPollConnection.forceDisallow = function () {
	        BrowserPollConnection.forceDisallow_ = true;
	    };
	    // Static method, use string literal so it can be accessed in a generic way
	    BrowserPollConnection.isAvailable = function () {
	        if (util.isNodeSdk()) {
	            return false;
	        }
	        else if (BrowserPollConnection.forceAllow_) {
	            return true;
	        }
	        else {
	            // NOTE: In React-Native there's normally no 'document', but if you debug a React-Native app in
	            // the Chrome debugger, 'document' is defined, but document.createElement is null (2015/06/08).
	            return (!BrowserPollConnection.forceDisallow_ &&
	                typeof document !== 'undefined' &&
	                document.createElement != null &&
	                !isChromeExtensionContentScript() &&
	                !isWindowsStoreApp());
	        }
	    };
	    /**
	     * No-op for polling
	     */
	    BrowserPollConnection.prototype.markConnectionHealthy = function () { };
	    /**
	     * Stops polling and cleans up the iframe
	     * @private
	     */
	    BrowserPollConnection.prototype.shutdown_ = function () {
	        this.isClosed_ = true;
	        if (this.scriptTagHolder) {
	            this.scriptTagHolder.close();
	            this.scriptTagHolder = null;
	        }
	        //remove the disconnect frame, which will trigger an XHR call to the server to tell it we're leaving.
	        if (this.myDisconnFrame) {
	            document.body.removeChild(this.myDisconnFrame);
	            this.myDisconnFrame = null;
	        }
	        if (this.connectTimeoutTimer_) {
	            clearTimeout(this.connectTimeoutTimer_);
	            this.connectTimeoutTimer_ = null;
	        }
	    };
	    /**
	     * Triggered when this transport is closed
	     * @private
	     */
	    BrowserPollConnection.prototype.onClosed_ = function () {
	        if (!this.isClosed_) {
	            this.log_('Longpoll is closing itself');
	            this.shutdown_();
	            if (this.onDisconnect_) {
	                this.onDisconnect_(this.everConnected_);
	                this.onDisconnect_ = null;
	            }
	        }
	    };
	    /**
	     * External-facing close handler. RealTime has requested we shut down. Kill our connection and tell the server
	     * that we've left.
	     */
	    BrowserPollConnection.prototype.close = function () {
	        if (!this.isClosed_) {
	            this.log_('Longpoll is being closed.');
	            this.shutdown_();
	        }
	    };
	    /**
	     * Send the JSON object down to the server. It will need to be stringified, base64 encoded, and then
	     * broken into chunks (since URLs have a small maximum length).
	     * @param {!Object} data The JSON data to transmit.
	     */
	    BrowserPollConnection.prototype.send = function (data) {
	        var dataStr = util.stringify(data);
	        this.bytesSent += dataStr.length;
	        this.stats_.incrementCounter('bytes_sent', dataStr.length);
	        //first, lets get the base64-encoded data
	        var base64data = util.base64Encode(dataStr);
	        //We can only fit a certain amount in each URL, so we need to split this request
	        //up into multiple pieces if it doesn't fit in one request.
	        var dataSegs = splitStringBySize(base64data, MAX_PAYLOAD_SIZE);
	        //Enqueue each segment for transmission. We assign each chunk a sequential ID and a total number
	        //of segments so that we can reassemble the packet on the server.
	        for (var i = 0; i < dataSegs.length; i++) {
	            this.scriptTagHolder.enqueueSegment(this.curSegmentNum, dataSegs.length, dataSegs[i]);
	            this.curSegmentNum++;
	        }
	    };
	    /**
	     * This is how we notify the server that we're leaving.
	     * We aren't able to send requests with DHTML on a window close event, but we can
	     * trigger XHR requests in some browsers (everything but Opera basically).
	     * @param {!string} id
	     * @param {!string} pw
	     */
	    BrowserPollConnection.prototype.addDisconnectPingFrame = function (id, pw) {
	        if (util.isNodeSdk()) {
	            return;
	        }
	        this.myDisconnFrame = document.createElement('iframe');
	        var urlParams = {};
	        urlParams[FIREBASE_LONGPOLL_DISCONN_FRAME_REQUEST_PARAM] = 't';
	        urlParams[FIREBASE_LONGPOLL_ID_PARAM] = id;
	        urlParams[FIREBASE_LONGPOLL_PW_PARAM] = pw;
	        this.myDisconnFrame.src = this.urlFn(urlParams);
	        this.myDisconnFrame.style.display = 'none';
	        document.body.appendChild(this.myDisconnFrame);
	    };
	    /**
	     * Used to track the bytes received by this client
	     * @param {*} args
	     * @private
	     */
	    BrowserPollConnection.prototype.incrementIncomingBytes_ = function (args) {
	        // TODO: This is an annoying perf hit just to track the number of incoming bytes.  Maybe it should be opt-in.
	        var bytesReceived = util.stringify(args).length;
	        this.bytesReceived += bytesReceived;
	        this.stats_.incrementCounter('bytes_received', bytesReceived);
	    };
	    return BrowserPollConnection;
	}());
	/*********************************************************************************************
	 * A wrapper around an iframe that is used as a long-polling script holder.
	 * @constructor
	 *********************************************************************************************/
	var FirebaseIFrameScriptHolder = /** @class */ (function () {
	    /**
	     * @param commandCB - The callback to be called when control commands are recevied from the server.
	     * @param onMessageCB - The callback to be triggered when responses arrive from the server.
	     * @param onDisconnect - The callback to be triggered when this tag holder is closed
	     * @param urlFn - A function that provides the URL of the endpoint to send data to.
	     */
	    function FirebaseIFrameScriptHolder(commandCB, onMessageCB, onDisconnect, urlFn) {
	        this.onDisconnect = onDisconnect;
	        this.urlFn = urlFn;
	        //We maintain a count of all of the outstanding requests, because if we have too many active at once it can cause
	        //problems in some browsers.
	        this.outstandingRequests = new Set();
	        //A queue of the pending segments waiting for transmission to the server.
	        this.pendingSegs = [];
	        //A serial number. We use this for two things:
	        // 1) A way to ensure the browser doesn't cache responses to polls
	        // 2) A way to make the server aware when long-polls arrive in a different order than we started them. The
	        //    server needs to release both polls in this case or it will cause problems in Opera since Opera can only execute
	        //    JSONP code in the order it was added to the iframe.
	        this.currentSerial = Math.floor(Math.random() * 100000000);
	        // This gets set to false when we're "closing down" the connection (e.g. we're switching transports but there's still
	        // incoming data from the server that we're waiting for).
	        this.sendNewPolls = true;
	        if (!util.isNodeSdk()) {
	            //Each script holder registers a couple of uniquely named callbacks with the window. These are called from the
	            //iframes where we put the long-polling script tags. We have two callbacks:
	            //   1) Command Callback - Triggered for control issues, like starting a connection.
	            //   2) Message Callback - Triggered when new data arrives.
	            this.uniqueCallbackIdentifier = LUIDGenerator();
	            window[FIREBASE_LONGPOLL_COMMAND_CB_NAME + this.uniqueCallbackIdentifier] = commandCB;
	            window[FIREBASE_LONGPOLL_DATA_CB_NAME + this.uniqueCallbackIdentifier] = onMessageCB;
	            //Create an iframe for us to add script tags to.
	            this.myIFrame = FirebaseIFrameScriptHolder.createIFrame_();
	            // Set the iframe's contents.
	            var script = '';
	            // if we set a javascript url, it's IE and we need to set the document domain. The javascript url is sufficient
	            // for ie9, but ie8 needs to do it again in the document itself.
	            if (this.myIFrame.src &&
	                this.myIFrame.src.substr(0, 'javascript:'.length) === 'javascript:') {
	                var currentDomain = document.domain;
	                script = '<script>document.domain="' + currentDomain + '";</script>';
	            }
	            var iframeContents = '<html><body>' + script + '</body></html>';
	            try {
	                this.myIFrame.doc.open();
	                this.myIFrame.doc.write(iframeContents);
	                this.myIFrame.doc.close();
	            }
	            catch (e) {
	                log('frame writing exception');
	                if (e.stack) {
	                    log(e.stack);
	                }
	                log(e);
	            }
	        }
	        else {
	            this.commandCB = commandCB;
	            this.onMessageCB = onMessageCB;
	        }
	    }
	    /**
	     * Each browser has its own funny way to handle iframes. Here we mush them all together into one object that I can
	     * actually use.
	     * @private
	     * @return {Element}
	     */
	    FirebaseIFrameScriptHolder.createIFrame_ = function () {
	        var iframe = document.createElement('iframe');
	        iframe.style.display = 'none';
	        // This is necessary in order to initialize the document inside the iframe
	        if (document.body) {
	            document.body.appendChild(iframe);
	            try {
	                // If document.domain has been modified in IE, this will throw an error, and we need to set the
	                // domain of the iframe's document manually. We can do this via a javascript: url as the src attribute
	                // Also note that we must do this *after* the iframe has been appended to the page. Otherwise it doesn't work.
	                var a = iframe.contentWindow.document;
	                if (!a) {
	                    // Apologies for the log-spam, I need to do something to keep closure from optimizing out the assignment above.
	                    log('No IE domain setting required');
	                }
	            }
	            catch (e) {
	                var domain = document.domain;
	                iframe.src =
	                    "javascript:void((function(){document.open();document.domain='" +
	                        domain +
	                        "';document.close();})())";
	            }
	        }
	        else {
	            // LongPollConnection attempts to delay initialization until the document is ready, so hopefully this
	            // never gets hit.
	            throw 'Document body has not initialized. Wait to initialize Firebase until after the document is ready.';
	        }
	        // Get the document of the iframe in a browser-specific way.
	        if (iframe.contentDocument) {
	            iframe.doc = iframe.contentDocument; // Firefox, Opera, Safari
	        }
	        else if (iframe.contentWindow) {
	            iframe.doc = iframe.contentWindow.document; // Internet Explorer
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        }
	        else if (iframe.document) {
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	            iframe.doc = iframe.document; //others?
	        }
	        return iframe;
	    };
	    /**
	     * Cancel all outstanding queries and remove the frame.
	     */
	    FirebaseIFrameScriptHolder.prototype.close = function () {
	        var _this = this;
	        //Mark this iframe as dead, so no new requests are sent.
	        this.alive = false;
	        if (this.myIFrame) {
	            //We have to actually remove all of the html inside this iframe before removing it from the
	            //window, or IE will continue loading and executing the script tags we've already added, which
	            //can lead to some errors being thrown. Setting innerHTML seems to be the easiest way to do this.
	            this.myIFrame.doc.body.innerHTML = '';
	            setTimeout(function () {
	                if (_this.myIFrame !== null) {
	                    document.body.removeChild(_this.myIFrame);
	                    _this.myIFrame = null;
	                }
	            }, Math.floor(0));
	        }
	        // Protect from being called recursively.
	        var onDisconnect = this.onDisconnect;
	        if (onDisconnect) {
	            this.onDisconnect = null;
	            onDisconnect();
	        }
	    };
	    /**
	     * Actually start the long-polling session by adding the first script tag(s) to the iframe.
	     * @param {!string} id - The ID of this connection
	     * @param {!string} pw - The password for this connection
	     */
	    FirebaseIFrameScriptHolder.prototype.startLongPoll = function (id, pw) {
	        this.myID = id;
	        this.myPW = pw;
	        this.alive = true;
	        //send the initial request. If there are requests queued, make sure that we transmit as many as we are currently able to.
	        while (this.newRequest_()) { }
	    };
	    /**
	     * This is called any time someone might want a script tag to be added. It adds a script tag when there aren't
	     * too many outstanding requests and we are still alive.
	     *
	     * If there are outstanding packet segments to send, it sends one. If there aren't, it sends a long-poll anyways if
	     * needed.
	     */
	    FirebaseIFrameScriptHolder.prototype.newRequest_ = function () {
	        // We keep one outstanding request open all the time to receive data, but if we need to send data
	        // (pendingSegs.length > 0) then we create a new request to send the data.  The server will automatically
	        // close the old request.
	        if (this.alive &&
	            this.sendNewPolls &&
	            this.outstandingRequests.size < (this.pendingSegs.length > 0 ? 2 : 1)) {
	            //construct our url
	            this.currentSerial++;
	            var urlParams = {};
	            urlParams[FIREBASE_LONGPOLL_ID_PARAM] = this.myID;
	            urlParams[FIREBASE_LONGPOLL_PW_PARAM] = this.myPW;
	            urlParams[FIREBASE_LONGPOLL_SERIAL_PARAM] = this.currentSerial;
	            var theURL = this.urlFn(urlParams);
	            //Now add as much data as we can.
	            var curDataString = '';
	            var i = 0;
	            while (this.pendingSegs.length > 0) {
	                //first, lets see if the next segment will fit.
	                var nextSeg = this.pendingSegs[0];
	                if (nextSeg.d.length +
	                    SEG_HEADER_SIZE +
	                    curDataString.length <=
	                    MAX_URL_DATA_SIZE) {
	                    //great, the segment will fit. Lets append it.
	                    var theSeg = this.pendingSegs.shift();
	                    curDataString =
	                        curDataString +
	                            '&' +
	                            FIREBASE_LONGPOLL_SEGMENT_NUM_PARAM +
	                            i +
	                            '=' +
	                            theSeg.seg +
	                            '&' +
	                            FIREBASE_LONGPOLL_SEGMENTS_IN_PACKET +
	                            i +
	                            '=' +
	                            theSeg.ts +
	                            '&' +
	                            FIREBASE_LONGPOLL_DATA_PARAM +
	                            i +
	                            '=' +
	                            theSeg.d;
	                    i++;
	                }
	                else {
	                    break;
	                }
	            }
	            theURL = theURL + curDataString;
	            this.addLongPollTag_(theURL, this.currentSerial);
	            return true;
	        }
	        else {
	            return false;
	        }
	    };
	    /**
	     * Queue a packet for transmission to the server.
	     * @param segnum - A sequential id for this packet segment used for reassembly
	     * @param totalsegs - The total number of segments in this packet
	     * @param data - The data for this segment.
	     */
	    FirebaseIFrameScriptHolder.prototype.enqueueSegment = function (segnum, totalsegs, data) {
	        //add this to the queue of segments to send.
	        this.pendingSegs.push({ seg: segnum, ts: totalsegs, d: data });
	        //send the data immediately if there isn't already data being transmitted, unless
	        //startLongPoll hasn't been called yet.
	        if (this.alive) {
	            this.newRequest_();
	        }
	    };
	    /**
	     * Add a script tag for a regular long-poll request.
	     * @param {!string} url - The URL of the script tag.
	     * @param {!number} serial - The serial number of the request.
	     * @private
	     */
	    FirebaseIFrameScriptHolder.prototype.addLongPollTag_ = function (url, serial) {
	        var _this = this;
	        //remember that we sent this request.
	        this.outstandingRequests.add(serial);
	        var doNewRequest = function () {
	            _this.outstandingRequests.delete(serial);
	            _this.newRequest_();
	        };
	        // If this request doesn't return on its own accord (by the server sending us some data), we'll
	        // create a new one after the KEEPALIVE interval to make sure we always keep a fresh request open.
	        var keepaliveTimeout = setTimeout(doNewRequest, Math.floor(KEEPALIVE_REQUEST_INTERVAL));
	        var readyStateCB = function () {
	            // Request completed.  Cancel the keepalive.
	            clearTimeout(keepaliveTimeout);
	            // Trigger a new request so we can continue receiving data.
	            doNewRequest();
	        };
	        this.addTag(url, readyStateCB);
	    };
	    /**
	     * Add an arbitrary script tag to the iframe.
	     * @param {!string} url - The URL for the script tag source.
	     * @param {!function()} loadCB - A callback to be triggered once the script has loaded.
	     */
	    FirebaseIFrameScriptHolder.prototype.addTag = function (url, loadCB) {
	        var _this = this;
	        if (util.isNodeSdk()) {
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	            this.doNodeLongPoll(url, loadCB);
	        }
	        else {
	            setTimeout(function () {
	                try {
	                    // if we're already closed, don't add this poll
	                    if (!_this.sendNewPolls) {
	                        return;
	                    }
	                    var newScript_1 = _this.myIFrame.doc.createElement('script');
	                    newScript_1.type = 'text/javascript';
	                    newScript_1.async = true;
	                    newScript_1.src = url;
	                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	                    newScript_1.onload = newScript_1.onreadystatechange = function () {
	                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	                        var rstate = newScript_1.readyState;
	                        if (!rstate || rstate === 'loaded' || rstate === 'complete') {
	                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	                            newScript_1.onload = newScript_1.onreadystatechange = null;
	                            if (newScript_1.parentNode) {
	                                newScript_1.parentNode.removeChild(newScript_1);
	                            }
	                            loadCB();
	                        }
	                    };
	                    newScript_1.onerror = function () {
	                        log('Long-poll script failed to load: ' + url);
	                        _this.sendNewPolls = false;
	                        _this.close();
	                    };
	                    _this.myIFrame.doc.body.appendChild(newScript_1);
	                }
	                catch (e) {
	                    // TODO: we should make this error visible somehow
	                }
	            }, Math.floor(1));
	        }
	    };
	    return FirebaseIFrameScriptHolder;
	}());
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/** The semver (www.semver.org) version of the SDK. */
	var SDK_VERSION = '';
	// SDK_VERSION should be set before any database instance is created
	function setSDKVersion(version) {
	    SDK_VERSION = version;
	}
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var WEBSOCKET_MAX_FRAME_SIZE = 16384;
	var WEBSOCKET_KEEPALIVE_INTERVAL = 45000;
	var WebSocketImpl = null;
	if (typeof MozWebSocket !== 'undefined') {
	    WebSocketImpl = MozWebSocket;
	}
	else if (typeof WebSocket !== 'undefined') {
	    WebSocketImpl = WebSocket;
	}
	/**
	 * Create a new websocket connection with the given callbacks.
	 * @constructor
	 * @implements {Transport}
	 */
	var WebSocketConnection = /** @class */ (function () {
	    /**
	     * @param {string} connId identifier for this transport
	     * @param {RepoInfo} repoInfo The info for the websocket endpoint.
	     * @param {string=} transportSessionId Optional transportSessionId if this is connecting to an existing transport
	     *                                         session
	     * @param {string=} lastSessionId Optional lastSessionId if there was a previous connection
	     */
	    function WebSocketConnection(connId, repoInfo, transportSessionId, lastSessionId) {
	        this.connId = connId;
	        this.keepaliveTimer = null;
	        this.frames = null;
	        this.totalFrames = 0;
	        this.bytesSent = 0;
	        this.bytesReceived = 0;
	        this.log_ = logWrapper(this.connId);
	        this.stats_ = StatsManager.getCollection(repoInfo);
	        this.connURL = WebSocketConnection.connectionURL_(repoInfo, transportSessionId, lastSessionId);
	    }
	    /**
	     * @param {RepoInfo} repoInfo The info for the websocket endpoint.
	     * @param {string=} transportSessionId Optional transportSessionId if this is connecting to an existing transport
	     *                                         session
	     * @param {string=} lastSessionId Optional lastSessionId if there was a previous connection
	     * @return {string} connection url
	     * @private
	     */
	    WebSocketConnection.connectionURL_ = function (repoInfo, transportSessionId, lastSessionId) {
	        var urlParams = {};
	        urlParams[VERSION_PARAM] = PROTOCOL_VERSION;
	        if (!util.isNodeSdk() &&
	            typeof location !== 'undefined' &&
	            location.href &&
	            location.href.indexOf(FORGE_DOMAIN) !== -1) {
	            urlParams[REFERER_PARAM] = FORGE_REF;
	        }
	        if (transportSessionId) {
	            urlParams[TRANSPORT_SESSION_PARAM] = transportSessionId;
	        }
	        if (lastSessionId) {
	            urlParams[LAST_SESSION_PARAM] = lastSessionId;
	        }
	        return repoInfo.connectionURL(WEBSOCKET, urlParams);
	    };
	    /**
	     *
	     * @param onMessage Callback when messages arrive
	     * @param onDisconnect Callback with connection lost.
	     */
	    WebSocketConnection.prototype.open = function (onMessage, onDisconnect) {
	        var _this = this;
	        this.onDisconnect = onDisconnect;
	        this.onMessage = onMessage;
	        this.log_('Websocket connecting to ' + this.connURL);
	        this.everConnected_ = false;
	        // Assume failure until proven otherwise.
	        PersistentStorage.set('previous_websocket_failure', true);
	        try {
	            if (util.isNodeSdk()) {
	                var device = util.CONSTANTS.NODE_ADMIN ? 'AdminNode' : 'Node';
	                // UA Format: Firebase/<wire_protocol>/<sdk_version>/<platform>/<device>
	                var options = {
	                    headers: {
	                        'User-Agent': "Firebase/" + PROTOCOL_VERSION + "/" + SDK_VERSION + "/" + process.platform + "/" + device
	                    }
	                };
	                // Plumb appropriate http_proxy environment variable into faye-websocket if it exists.
	                var env = process['env'];
	                var proxy = this.connURL.indexOf('wss://') === 0
	                    ? env['HTTPS_PROXY'] || env['https_proxy']
	                    : env['HTTP_PROXY'] || env['http_proxy'];
	                if (proxy) {
	                    options['proxy'] = { origin: proxy };
	                }
	                this.mySock = new WebSocketImpl(this.connURL, [], options);
	            }
	            else {
	                this.mySock = new WebSocketImpl(this.connURL);
	            }
	        }
	        catch (e) {
	            this.log_('Error instantiating WebSocket.');
	            var error = e.message || e.data;
	            if (error) {
	                this.log_(error);
	            }
	            this.onClosed_();
	            return;
	        }
	        this.mySock.onopen = function () {
	            _this.log_('Websocket connected.');
	            _this.everConnected_ = true;
	        };
	        this.mySock.onclose = function () {
	            _this.log_('Websocket connection was disconnected.');
	            _this.mySock = null;
	            _this.onClosed_();
	        };
	        this.mySock.onmessage = function (m) {
	            _this.handleIncomingFrame(m);
	        };
	        this.mySock.onerror = function (e) {
	            _this.log_('WebSocket error.  Closing connection.');
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	            var error = e.message || e.data;
	            if (error) {
	                _this.log_(error);
	            }
	            _this.onClosed_();
	        };
	    };
	    /**
	     * No-op for websockets, we don't need to do anything once the connection is confirmed as open
	     */
	    WebSocketConnection.prototype.start = function () { };
	    WebSocketConnection.forceDisallow = function () {
	        WebSocketConnection.forceDisallow_ = true;
	    };
	    WebSocketConnection.isAvailable = function () {
	        var isOldAndroid = false;
	        if (typeof navigator !== 'undefined' && navigator.userAgent) {
	            var oldAndroidRegex = /Android ([0-9]{0,}\.[0-9]{0,})/;
	            var oldAndroidMatch = navigator.userAgent.match(oldAndroidRegex);
	            if (oldAndroidMatch && oldAndroidMatch.length > 1) {
	                if (parseFloat(oldAndroidMatch[1]) < 4.4) {
	                    isOldAndroid = true;
	                }
	            }
	        }
	        return (!isOldAndroid &&
	            WebSocketImpl !== null &&
	            !WebSocketConnection.forceDisallow_);
	    };
	    /**
	     * Returns true if we previously failed to connect with this transport.
	     * @return {boolean}
	     */
	    WebSocketConnection.previouslyFailed = function () {
	        // If our persistent storage is actually only in-memory storage,
	        // we default to assuming that it previously failed to be safe.
	        return (PersistentStorage.isInMemoryStorage ||
	            PersistentStorage.get('previous_websocket_failure') === true);
	    };
	    WebSocketConnection.prototype.markConnectionHealthy = function () {
	        PersistentStorage.remove('previous_websocket_failure');
	    };
	    WebSocketConnection.prototype.appendFrame_ = function (data) {
	        this.frames.push(data);
	        if (this.frames.length === this.totalFrames) {
	            var fullMess = this.frames.join('');
	            this.frames = null;
	            var jsonMess = util.jsonEval(fullMess);
	            //handle the message
	            this.onMessage(jsonMess);
	        }
	    };
	    /**
	     * @param {number} frameCount The number of frames we are expecting from the server
	     * @private
	     */
	    WebSocketConnection.prototype.handleNewFrameCount_ = function (frameCount) {
	        this.totalFrames = frameCount;
	        this.frames = [];
	    };
	    /**
	     * Attempts to parse a frame count out of some text. If it can't, assumes a value of 1
	     * @param {!String} data
	     * @return {?String} Any remaining data to be process, or null if there is none
	     * @private
	     */
	    WebSocketConnection.prototype.extractFrameCount_ = function (data) {
	        util.assert(this.frames === null, 'We already have a frame buffer');
	        // TODO: The server is only supposed to send up to 9999 frames (i.e. length <= 4), but that isn't being enforced
	        // currently.  So allowing larger frame counts (length <= 6).  See https://app.asana.com/0/search/8688598998380/8237608042508
	        if (data.length <= 6) {
	            var frameCount = Number(data);
	            if (!isNaN(frameCount)) {
	                this.handleNewFrameCount_(frameCount);
	                return null;
	            }
	        }
	        this.handleNewFrameCount_(1);
	        return data;
	    };
	    /**
	     * Process a websocket frame that has arrived from the server.
	     * @param mess The frame data
	     */
	    WebSocketConnection.prototype.handleIncomingFrame = function (mess) {
	        if (this.mySock === null) {
	            return; // Chrome apparently delivers incoming packets even after we .close() the connection sometimes.
	        }
	        var data = mess['data'];
	        this.bytesReceived += data.length;
	        this.stats_.incrementCounter('bytes_received', data.length);
	        this.resetKeepAlive();
	        if (this.frames !== null) {
	            // we're buffering
	            this.appendFrame_(data);
	        }
	        else {
	            // try to parse out a frame count, otherwise, assume 1 and process it
	            var remainingData = this.extractFrameCount_(data);
	            if (remainingData !== null) {
	                this.appendFrame_(remainingData);
	            }
	        }
	    };
	    /**
	     * Send a message to the server
	     * @param {Object} data The JSON object to transmit
	     */
	    WebSocketConnection.prototype.send = function (data) {
	        this.resetKeepAlive();
	        var dataStr = util.stringify(data);
	        this.bytesSent += dataStr.length;
	        this.stats_.incrementCounter('bytes_sent', dataStr.length);
	        //We can only fit a certain amount in each websocket frame, so we need to split this request
	        //up into multiple pieces if it doesn't fit in one request.
	        var dataSegs = splitStringBySize(dataStr, WEBSOCKET_MAX_FRAME_SIZE);
	        //Send the length header
	        if (dataSegs.length > 1) {
	            this.sendString_(String(dataSegs.length));
	        }
	        //Send the actual data in segments.
	        for (var i = 0; i < dataSegs.length; i++) {
	            this.sendString_(dataSegs[i]);
	        }
	    };
	    WebSocketConnection.prototype.shutdown_ = function () {
	        this.isClosed_ = true;
	        if (this.keepaliveTimer) {
	            clearInterval(this.keepaliveTimer);
	            this.keepaliveTimer = null;
	        }
	        if (this.mySock) {
	            this.mySock.close();
	            this.mySock = null;
	        }
	    };
	    WebSocketConnection.prototype.onClosed_ = function () {
	        if (!this.isClosed_) {
	            this.log_('WebSocket is closing itself');
	            this.shutdown_();
	            // since this is an internal close, trigger the close listener
	            if (this.onDisconnect) {
	                this.onDisconnect(this.everConnected_);
	                this.onDisconnect = null;
	            }
	        }
	    };
	    /**
	     * External-facing close handler.
	     * Close the websocket and kill the connection.
	     */
	    WebSocketConnection.prototype.close = function () {
	        if (!this.isClosed_) {
	            this.log_('WebSocket is being closed');
	            this.shutdown_();
	        }
	    };
	    /**
	     * Kill the current keepalive timer and start a new one, to ensure that it always fires N seconds after
	     * the last activity.
	     */
	    WebSocketConnection.prototype.resetKeepAlive = function () {
	        var _this = this;
	        clearInterval(this.keepaliveTimer);
	        this.keepaliveTimer = setInterval(function () {
	            //If there has been no websocket activity for a while, send a no-op
	            if (_this.mySock) {
	                _this.sendString_('0');
	            }
	            _this.resetKeepAlive();
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        }, Math.floor(WEBSOCKET_KEEPALIVE_INTERVAL));
	    };
	    /**
	     * Send a string over the websocket.
	     *
	     * @param {string} str String to send.
	     * @private
	     */
	    WebSocketConnection.prototype.sendString_ = function (str) {
	        // Firefox seems to sometimes throw exceptions (NS_ERROR_UNEXPECTED) from websocket .send()
	        // calls for some unknown reason.  We treat these as an error and disconnect.
	        // See https://app.asana.com/0/58926111402292/68021340250410
	        try {
	            this.mySock.send(str);
	        }
	        catch (e) {
	            this.log_('Exception thrown from WebSocket.send():', e.message || e.data, 'Closing connection.');
	            setTimeout(this.onClosed_.bind(this), 0);
	        }
	    };
	    /**
	     * Number of response before we consider the connection "healthy."
	     * @type {number}
	     */
	    WebSocketConnection.responsesRequiredToBeHealthy = 2;
	    /**
	     * Time to wait for the connection te become healthy before giving up.
	     * @type {number}
	     */
	    WebSocketConnection.healthyTimeout = 30000;
	    return WebSocketConnection;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Currently simplistic, this class manages what transport a Connection should use at various stages of its
	 * lifecycle.
	 *
	 * It starts with longpolling in a browser, and httppolling on node. It then upgrades to websockets if
	 * they are available.
	 * @constructor
	 */
	var TransportManager = /** @class */ (function () {
	    /**
	     * @param {!RepoInfo} repoInfo Metadata around the namespace we're connecting to
	     */
	    function TransportManager(repoInfo) {
	        this.initTransports_(repoInfo);
	    }
	    Object.defineProperty(TransportManager, "ALL_TRANSPORTS", {
	        /**
	         * @const
	         * @type {!Array.<function(new:Transport, string, RepoInfo, string=)>}
	         */
	        get: function () {
	            return [BrowserPollConnection, WebSocketConnection];
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @param {!RepoInfo} repoInfo
	     * @private
	     */
	    TransportManager.prototype.initTransports_ = function (repoInfo) {
	        var e_1, _a;
	        var isWebSocketsAvailable = WebSocketConnection && WebSocketConnection['isAvailable']();
	        var isSkipPollConnection = isWebSocketsAvailable && !WebSocketConnection.previouslyFailed();
	        if (repoInfo.webSocketOnly) {
	            if (!isWebSocketsAvailable) {
	                warn("wss:// URL used, but browser isn't known to support websockets.  Trying anyway.");
	            }
	            isSkipPollConnection = true;
	        }
	        if (isSkipPollConnection) {
	            this.transports_ = [WebSocketConnection];
	        }
	        else {
	            var transports = (this.transports_ = []);
	            try {
	                for (var _b = tslib.__values(TransportManager.ALL_TRANSPORTS), _c = _b.next(); !_c.done; _c = _b.next()) {
	                    var transport = _c.value;
	                    if (transport && transport['isAvailable']()) {
	                        transports.push(transport);
	                    }
	                }
	            }
	            catch (e_1_1) { e_1 = { error: e_1_1 }; }
	            finally {
	                try {
	                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	                }
	                finally { if (e_1) throw e_1.error; }
	            }
	        }
	    };
	    /**
	     * @return {function(new:Transport, !string, !RepoInfo, string=, string=)} The constructor for the
	     * initial transport to use
	     */
	    TransportManager.prototype.initialTransport = function () {
	        if (this.transports_.length > 0) {
	            return this.transports_[0];
	        }
	        else {
	            throw new Error('No transports available');
	        }
	    };
	    /**
	     * @return {?function(new:Transport, function(),function(), string=)} The constructor for the next
	     * transport, or null
	     */
	    TransportManager.prototype.upgradeTransport = function () {
	        if (this.transports_.length > 1) {
	            return this.transports_[1];
	        }
	        else {
	            return null;
	        }
	    };
	    return TransportManager;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	// Abort upgrade attempt if it takes longer than 60s.
	var UPGRADE_TIMEOUT = 60000;
	// For some transports (WebSockets), we need to "validate" the transport by exchanging a few requests and responses.
	// If we haven't sent enough requests within 5s, we'll start sending noop ping requests.
	var DELAY_BEFORE_SENDING_EXTRA_REQUESTS = 5000;
	// If the initial data sent triggers a lot of bandwidth (i.e. it's a large put or a listen for a large amount of data)
	// then we may not be able to exchange our ping/pong requests within the healthy timeout.  So if we reach the timeout
	// but we've sent/received enough bytes, we don't cancel the connection.
	var BYTES_SENT_HEALTHY_OVERRIDE = 10 * 1024;
	var BYTES_RECEIVED_HEALTHY_OVERRIDE = 100 * 1024;
	var MESSAGE_TYPE = 't';
	var MESSAGE_DATA = 'd';
	var CONTROL_SHUTDOWN = 's';
	var CONTROL_RESET = 'r';
	var CONTROL_ERROR = 'e';
	var CONTROL_PONG = 'o';
	var SWITCH_ACK = 'a';
	var END_TRANSMISSION = 'n';
	var PING = 'p';
	var SERVER_HELLO = 'h';
	/**
	 * Creates a new real-time connection to the server using whichever method works
	 * best in the current browser.
	 *
	 * @constructor
	 */
	var Connection = /** @class */ (function () {
	    /**
	     * @param {!string} id - an id for this connection
	     * @param {!RepoInfo} repoInfo_ - the info for the endpoint to connect to
	     * @param {function(Object)} onMessage_ - the callback to be triggered when a server-push message arrives
	     * @param {function(number, string)} onReady_ - the callback to be triggered when this connection is ready to send messages.
	     * @param {function()} onDisconnect_ - the callback to be triggered when a connection was lost
	     * @param {function(string)} onKill_ - the callback to be triggered when this connection has permanently shut down.
	     * @param {string=} lastSessionId - last session id in persistent connection. is used to clean up old session in real-time server
	     */
	    function Connection(id, repoInfo_, onMessage_, onReady_, onDisconnect_, onKill_, lastSessionId) {
	        this.id = id;
	        this.repoInfo_ = repoInfo_;
	        this.onMessage_ = onMessage_;
	        this.onReady_ = onReady_;
	        this.onDisconnect_ = onDisconnect_;
	        this.onKill_ = onKill_;
	        this.lastSessionId = lastSessionId;
	        this.connectionCount = 0;
	        this.pendingDataMessages = [];
	        this.state_ = 0 /* CONNECTING */;
	        this.log_ = logWrapper('c:' + this.id + ':');
	        this.transportManager_ = new TransportManager(repoInfo_);
	        this.log_('Connection created');
	        this.start_();
	    }
	    /**
	     * Starts a connection attempt
	     * @private
	     */
	    Connection.prototype.start_ = function () {
	        var _this = this;
	        var conn = this.transportManager_.initialTransport();
	        this.conn_ = new conn(this.nextTransportId_(), this.repoInfo_, undefined, this.lastSessionId);
	        // For certain transports (WebSockets), we need to send and receive several messages back and forth before we
	        // can consider the transport healthy.
	        this.primaryResponsesRequired_ = conn['responsesRequiredToBeHealthy'] || 0;
	        var onMessageReceived = this.connReceiver_(this.conn_);
	        var onConnectionLost = this.disconnReceiver_(this.conn_);
	        this.tx_ = this.conn_;
	        this.rx_ = this.conn_;
	        this.secondaryConn_ = null;
	        this.isHealthy_ = false;
	        /*
	         * Firefox doesn't like when code from one iframe tries to create another iframe by way of the parent frame.
	         * This can occur in the case of a redirect, i.e. we guessed wrong on what server to connect to and received a reset.
	         * Somehow, setTimeout seems to make this ok. That doesn't make sense from a security perspective, since you should
	         * still have the context of your originating frame.
	         */
	        setTimeout(function () {
	            // this.conn_ gets set to null in some of the tests. Check to make sure it still exists before using it
	            _this.conn_ && _this.conn_.open(onMessageReceived, onConnectionLost);
	        }, Math.floor(0));
	        var healthyTimeoutMS = conn['healthyTimeout'] || 0;
	        if (healthyTimeoutMS > 0) {
	            this.healthyTimeout_ = setTimeoutNonBlocking(function () {
	                _this.healthyTimeout_ = null;
	                if (!_this.isHealthy_) {
	                    if (_this.conn_ &&
	                        _this.conn_.bytesReceived > BYTES_RECEIVED_HEALTHY_OVERRIDE) {
	                        _this.log_('Connection exceeded healthy timeout but has received ' +
	                            _this.conn_.bytesReceived +
	                            ' bytes.  Marking connection healthy.');
	                        _this.isHealthy_ = true;
	                        _this.conn_.markConnectionHealthy();
	                    }
	                    else if (_this.conn_ &&
	                        _this.conn_.bytesSent > BYTES_SENT_HEALTHY_OVERRIDE) {
	                        _this.log_('Connection exceeded healthy timeout but has sent ' +
	                            _this.conn_.bytesSent +
	                            ' bytes.  Leaving connection alive.');
	                        // NOTE: We don't want to mark it healthy, since we have no guarantee that the bytes have made it to
	                        // the server.
	                    }
	                    else {
	                        _this.log_('Closing unhealthy connection after timeout.');
	                        _this.close();
	                    }
	                }
	                // eslint-disable-next-line @typescript-eslint/no-explicit-any
	            }, Math.floor(healthyTimeoutMS));
	        }
	    };
	    /**
	     * @return {!string}
	     * @private
	     */
	    Connection.prototype.nextTransportId_ = function () {
	        return 'c:' + this.id + ':' + this.connectionCount++;
	    };
	    Connection.prototype.disconnReceiver_ = function (conn) {
	        var _this = this;
	        return function (everConnected) {
	            if (conn === _this.conn_) {
	                _this.onConnectionLost_(everConnected);
	            }
	            else if (conn === _this.secondaryConn_) {
	                _this.log_('Secondary connection lost.');
	                _this.onSecondaryConnectionLost_();
	            }
	            else {
	                _this.log_('closing an old connection');
	            }
	        };
	    };
	    Connection.prototype.connReceiver_ = function (conn) {
	        var _this = this;
	        return function (message) {
	            if (_this.state_ !== 2 /* DISCONNECTED */) {
	                if (conn === _this.rx_) {
	                    _this.onPrimaryMessageReceived_(message);
	                }
	                else if (conn === _this.secondaryConn_) {
	                    _this.onSecondaryMessageReceived_(message);
	                }
	                else {
	                    _this.log_('message on old connection');
	                }
	            }
	        };
	    };
	    /**
	     *
	     * @param {Object} dataMsg An arbitrary data message to be sent to the server
	     */
	    Connection.prototype.sendRequest = function (dataMsg) {
	        // wrap in a data message envelope and send it on
	        var msg = { t: 'd', d: dataMsg };
	        this.sendData_(msg);
	    };
	    Connection.prototype.tryCleanupConnection = function () {
	        if (this.tx_ === this.secondaryConn_ && this.rx_ === this.secondaryConn_) {
	            this.log_('cleaning up and promoting a connection: ' + this.secondaryConn_.connId);
	            this.conn_ = this.secondaryConn_;
	            this.secondaryConn_ = null;
	            // the server will shutdown the old connection
	        }
	    };
	    Connection.prototype.onSecondaryControl_ = function (controlData) {
	        if (MESSAGE_TYPE in controlData) {
	            var cmd = controlData[MESSAGE_TYPE];
	            if (cmd === SWITCH_ACK) {
	                this.upgradeIfSecondaryHealthy_();
	            }
	            else if (cmd === CONTROL_RESET) {
	                // Most likely the session wasn't valid. Abandon the switch attempt
	                this.log_('Got a reset on secondary, closing it');
	                this.secondaryConn_.close();
	                // If we were already using this connection for something, than we need to fully close
	                if (this.tx_ === this.secondaryConn_ ||
	                    this.rx_ === this.secondaryConn_) {
	                    this.close();
	                }
	            }
	            else if (cmd === CONTROL_PONG) {
	                this.log_('got pong on secondary.');
	                this.secondaryResponsesRequired_--;
	                this.upgradeIfSecondaryHealthy_();
	            }
	        }
	    };
	    Connection.prototype.onSecondaryMessageReceived_ = function (parsedData) {
	        var layer = requireKey('t', parsedData);
	        var data = requireKey('d', parsedData);
	        if (layer === 'c') {
	            this.onSecondaryControl_(data);
	        }
	        else if (layer === 'd') {
	            // got a data message, but we're still second connection. Need to buffer it up
	            this.pendingDataMessages.push(data);
	        }
	        else {
	            throw new Error('Unknown protocol layer: ' + layer);
	        }
	    };
	    Connection.prototype.upgradeIfSecondaryHealthy_ = function () {
	        if (this.secondaryResponsesRequired_ <= 0) {
	            this.log_('Secondary connection is healthy.');
	            this.isHealthy_ = true;
	            this.secondaryConn_.markConnectionHealthy();
	            this.proceedWithUpgrade_();
	        }
	        else {
	            // Send a ping to make sure the connection is healthy.
	            this.log_('sending ping on secondary.');
	            this.secondaryConn_.send({ t: 'c', d: { t: PING, d: {} } });
	        }
	    };
	    Connection.prototype.proceedWithUpgrade_ = function () {
	        // tell this connection to consider itself open
	        this.secondaryConn_.start();
	        // send ack
	        this.log_('sending client ack on secondary');
	        this.secondaryConn_.send({ t: 'c', d: { t: SWITCH_ACK, d: {} } });
	        // send end packet on primary transport, switch to sending on this one
	        // can receive on this one, buffer responses until end received on primary transport
	        this.log_('Ending transmission on primary');
	        this.conn_.send({ t: 'c', d: { t: END_TRANSMISSION, d: {} } });
	        this.tx_ = this.secondaryConn_;
	        this.tryCleanupConnection();
	    };
	    Connection.prototype.onPrimaryMessageReceived_ = function (parsedData) {
	        // Must refer to parsedData properties in quotes, so closure doesn't touch them.
	        var layer = requireKey('t', parsedData);
	        var data = requireKey('d', parsedData);
	        if (layer === 'c') {
	            this.onControl_(data);
	        }
	        else if (layer === 'd') {
	            this.onDataMessage_(data);
	        }
	    };
	    Connection.prototype.onDataMessage_ = function (message) {
	        this.onPrimaryResponse_();
	        // We don't do anything with data messages, just kick them up a level
	        this.onMessage_(message);
	    };
	    Connection.prototype.onPrimaryResponse_ = function () {
	        if (!this.isHealthy_) {
	            this.primaryResponsesRequired_--;
	            if (this.primaryResponsesRequired_ <= 0) {
	                this.log_('Primary connection is healthy.');
	                this.isHealthy_ = true;
	                this.conn_.markConnectionHealthy();
	            }
	        }
	    };
	    Connection.prototype.onControl_ = function (controlData) {
	        var cmd = requireKey(MESSAGE_TYPE, controlData);
	        if (MESSAGE_DATA in controlData) {
	            var payload = controlData[MESSAGE_DATA];
	            if (cmd === SERVER_HELLO) {
	                this.onHandshake_(payload);
	            }
	            else if (cmd === END_TRANSMISSION) {
	                this.log_('recvd end transmission on primary');
	                this.rx_ = this.secondaryConn_;
	                for (var i = 0; i < this.pendingDataMessages.length; ++i) {
	                    this.onDataMessage_(this.pendingDataMessages[i]);
	                }
	                this.pendingDataMessages = [];
	                this.tryCleanupConnection();
	            }
	            else if (cmd === CONTROL_SHUTDOWN) {
	                // This was previously the 'onKill' callback passed to the lower-level connection
	                // payload in this case is the reason for the shutdown. Generally a human-readable error
	                this.onConnectionShutdown_(payload);
	            }
	            else if (cmd === CONTROL_RESET) {
	                // payload in this case is the host we should contact
	                this.onReset_(payload);
	            }
	            else if (cmd === CONTROL_ERROR) {
	                error('Server Error: ' + payload);
	            }
	            else if (cmd === CONTROL_PONG) {
	                this.log_('got pong on primary.');
	                this.onPrimaryResponse_();
	                this.sendPingOnPrimaryIfNecessary_();
	            }
	            else {
	                error('Unknown control packet command: ' + cmd);
	            }
	        }
	    };
	    /**
	     *
	     * @param {Object} handshake The handshake data returned from the server
	     * @private
	     */
	    Connection.prototype.onHandshake_ = function (handshake) {
	        var timestamp = handshake.ts;
	        var version = handshake.v;
	        var host = handshake.h;
	        this.sessionId = handshake.s;
	        this.repoInfo_.updateHost(host);
	        // if we've already closed the connection, then don't bother trying to progress further
	        if (this.state_ === 0 /* CONNECTING */) {
	            this.conn_.start();
	            this.onConnectionEstablished_(this.conn_, timestamp);
	            if (PROTOCOL_VERSION !== version) {
	                warn('Protocol version mismatch detected');
	            }
	            // TODO: do we want to upgrade? when? maybe a delay?
	            this.tryStartUpgrade_();
	        }
	    };
	    Connection.prototype.tryStartUpgrade_ = function () {
	        var conn = this.transportManager_.upgradeTransport();
	        if (conn) {
	            this.startUpgrade_(conn);
	        }
	    };
	    Connection.prototype.startUpgrade_ = function (conn) {
	        var _this = this;
	        this.secondaryConn_ = new conn(this.nextTransportId_(), this.repoInfo_, this.sessionId);
	        // For certain transports (WebSockets), we need to send and receive several messages back and forth before we
	        // can consider the transport healthy.
	        this.secondaryResponsesRequired_ =
	            conn['responsesRequiredToBeHealthy'] || 0;
	        var onMessage = this.connReceiver_(this.secondaryConn_);
	        var onDisconnect = this.disconnReceiver_(this.secondaryConn_);
	        this.secondaryConn_.open(onMessage, onDisconnect);
	        // If we haven't successfully upgraded after UPGRADE_TIMEOUT, give up and kill the secondary.
	        setTimeoutNonBlocking(function () {
	            if (_this.secondaryConn_) {
	                _this.log_('Timed out trying to upgrade.');
	                _this.secondaryConn_.close();
	            }
	        }, Math.floor(UPGRADE_TIMEOUT));
	    };
	    Connection.prototype.onReset_ = function (host) {
	        this.log_('Reset packet received.  New host: ' + host);
	        this.repoInfo_.updateHost(host);
	        // TODO: if we're already "connected", we need to trigger a disconnect at the next layer up.
	        // We don't currently support resets after the connection has already been established
	        if (this.state_ === 1 /* CONNECTED */) {
	            this.close();
	        }
	        else {
	            // Close whatever connections we have open and start again.
	            this.closeConnections_();
	            this.start_();
	        }
	    };
	    Connection.prototype.onConnectionEstablished_ = function (conn, timestamp) {
	        var _this = this;
	        this.log_('Realtime connection established.');
	        this.conn_ = conn;
	        this.state_ = 1 /* CONNECTED */;
	        if (this.onReady_) {
	            this.onReady_(timestamp, this.sessionId);
	            this.onReady_ = null;
	        }
	        // If after 5 seconds we haven't sent enough requests to the server to get the connection healthy,
	        // send some pings.
	        if (this.primaryResponsesRequired_ === 0) {
	            this.log_('Primary connection is healthy.');
	            this.isHealthy_ = true;
	        }
	        else {
	            setTimeoutNonBlocking(function () {
	                _this.sendPingOnPrimaryIfNecessary_();
	            }, Math.floor(DELAY_BEFORE_SENDING_EXTRA_REQUESTS));
	        }
	    };
	    Connection.prototype.sendPingOnPrimaryIfNecessary_ = function () {
	        // If the connection isn't considered healthy yet, we'll send a noop ping packet request.
	        if (!this.isHealthy_ && this.state_ === 1 /* CONNECTED */) {
	            this.log_('sending ping on primary.');
	            this.sendData_({ t: 'c', d: { t: PING, d: {} } });
	        }
	    };
	    Connection.prototype.onSecondaryConnectionLost_ = function () {
	        var conn = this.secondaryConn_;
	        this.secondaryConn_ = null;
	        if (this.tx_ === conn || this.rx_ === conn) {
	            // we are relying on this connection already in some capacity. Therefore, a failure is real
	            this.close();
	        }
	    };
	    /**
	     *
	     * @param {boolean} everConnected Whether or not the connection ever reached a server. Used to determine if
	     * we should flush the host cache
	     * @private
	     */
	    Connection.prototype.onConnectionLost_ = function (everConnected) {
	        this.conn_ = null;
	        // NOTE: IF you're seeing a Firefox error for this line, I think it might be because it's getting
	        // called on window close and RealtimeState.CONNECTING is no longer defined.  Just a guess.
	        if (!everConnected && this.state_ === 0 /* CONNECTING */) {
	            this.log_('Realtime connection failed.');
	            // Since we failed to connect at all, clear any cached entry for this namespace in case the machine went away
	            if (this.repoInfo_.isCacheableHost()) {
	                PersistentStorage.remove('host:' + this.repoInfo_.host);
	                // reset the internal host to what we would show the user, i.e. <ns>.firebaseio.com
	                this.repoInfo_.internalHost = this.repoInfo_.host;
	            }
	        }
	        else if (this.state_ === 1 /* CONNECTED */) {
	            this.log_('Realtime connection lost.');
	        }
	        this.close();
	    };
	    /**
	     *
	     * @param {string} reason
	     * @private
	     */
	    Connection.prototype.onConnectionShutdown_ = function (reason) {
	        this.log_('Connection shutdown command received. Shutting down...');
	        if (this.onKill_) {
	            this.onKill_(reason);
	            this.onKill_ = null;
	        }
	        // We intentionally don't want to fire onDisconnect (kill is a different case),
	        // so clear the callback.
	        this.onDisconnect_ = null;
	        this.close();
	    };
	    Connection.prototype.sendData_ = function (data) {
	        if (this.state_ !== 1 /* CONNECTED */) {
	            throw 'Connection is not connected';
	        }
	        else {
	            this.tx_.send(data);
	        }
	    };
	    /**
	     * Cleans up this connection, calling the appropriate callbacks
	     */
	    Connection.prototype.close = function () {
	        if (this.state_ !== 2 /* DISCONNECTED */) {
	            this.log_('Closing realtime connection.');
	            this.state_ = 2 /* DISCONNECTED */;
	            this.closeConnections_();
	            if (this.onDisconnect_) {
	                this.onDisconnect_();
	                this.onDisconnect_ = null;
	            }
	        }
	    };
	    /**
	     *
	     * @private
	     */
	    Connection.prototype.closeConnections_ = function () {
	        this.log_('Shutting down all connections');
	        if (this.conn_) {
	            this.conn_.close();
	            this.conn_ = null;
	        }
	        if (this.secondaryConn_) {
	            this.secondaryConn_.close();
	            this.secondaryConn_ = null;
	        }
	        if (this.healthyTimeout_) {
	            clearTimeout(this.healthyTimeout_);
	            this.healthyTimeout_ = null;
	        }
	    };
	    return Connection;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Interface defining the set of actions that can be performed against the Firebase server
	 * (basically corresponds to our wire protocol).
	 *
	 * @interface
	 */
	var ServerActions = /** @class */ (function () {
	    function ServerActions() {
	    }
	    /**
	     * @param {string} pathString
	     * @param {*} data
	     * @param {function(string, string)=} onComplete
	     * @param {string=} hash
	     */
	    ServerActions.prototype.put = function (pathString, data, onComplete, hash) { };
	    /**
	     * @param {string} pathString
	     * @param {*} data
	     * @param {function(string, ?string)} onComplete
	     * @param {string=} hash
	     */
	    ServerActions.prototype.merge = function (pathString, data, onComplete, hash) { };
	    /**
	     * Refreshes the auth token for the current connection.
	     * @param {string} token The authentication token
	     */
	    ServerActions.prototype.refreshAuthToken = function (token) { };
	    /**
	     * @param {string} pathString
	     * @param {*} data
	     * @param {function(string, string)=} onComplete
	     */
	    ServerActions.prototype.onDisconnectPut = function (pathString, data, onComplete) { };
	    /**
	     * @param {string} pathString
	     * @param {*} data
	     * @param {function(string, string)=} onComplete
	     */
	    ServerActions.prototype.onDisconnectMerge = function (pathString, data, onComplete) { };
	    /**
	     * @param {string} pathString
	     * @param {function(string, string)=} onComplete
	     */
	    ServerActions.prototype.onDisconnectCancel = function (pathString, onComplete) { };
	    /**
	     * @param {Object.<string, *>} stats
	     */
	    ServerActions.prototype.reportStats = function (stats) { };
	    return ServerActions;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var RECONNECT_MIN_DELAY = 1000;
	var RECONNECT_MAX_DELAY_DEFAULT = 60 * 5 * 1000; // 5 minutes in milliseconds (Case: 1858)
	var RECONNECT_MAX_DELAY_FOR_ADMINS = 30 * 1000; // 30 seconds for admin clients (likely to be a backend server)
	var RECONNECT_DELAY_MULTIPLIER = 1.3;
	var RECONNECT_DELAY_RESET_TIMEOUT = 30000; // Reset delay back to MIN_DELAY after being connected for 30sec.
	var SERVER_KILL_INTERRUPT_REASON = 'server_kill';
	// If auth fails repeatedly, we'll assume something is wrong and log a warning / back off.
	var INVALID_AUTH_TOKEN_THRESHOLD = 3;
	/**
	 * Firebase connection.  Abstracts wire protocol and handles reconnecting.
	 *
	 * NOTE: All JSON objects sent to the realtime connection must have property names enclosed
	 * in quotes to make sure the closure compiler does not minify them.
	 */
	var PersistentConnection = /** @class */ (function (_super) {
	    tslib.__extends(PersistentConnection, _super);
	    /**
	     * @implements {ServerActions}
	     * @param repoInfo_ Data about the namespace we are connecting to
	     * @param onDataUpdate_ A callback for new data from the server
	     */
	    function PersistentConnection(repoInfo_, onDataUpdate_, onConnectStatus_, onServerInfoUpdate_, authTokenProvider_, authOverride_) {
	        var _this = _super.call(this) || this;
	        _this.repoInfo_ = repoInfo_;
	        _this.onDataUpdate_ = onDataUpdate_;
	        _this.onConnectStatus_ = onConnectStatus_;
	        _this.onServerInfoUpdate_ = onServerInfoUpdate_;
	        _this.authTokenProvider_ = authTokenProvider_;
	        _this.authOverride_ = authOverride_;
	        // Used for diagnostic logging.
	        _this.id = PersistentConnection.nextPersistentConnectionId_++;
	        _this.log_ = logWrapper('p:' + _this.id + ':');
	        _this.interruptReasons_ = {};
	        /** Map<path, Map<queryId, ListenSpec>> */
	        _this.listens = new Map();
	        _this.outstandingPuts_ = [];
	        _this.outstandingPutCount_ = 0;
	        _this.onDisconnectRequestQueue_ = [];
	        _this.connected_ = false;
	        _this.reconnectDelay_ = RECONNECT_MIN_DELAY;
	        _this.maxReconnectDelay_ = RECONNECT_MAX_DELAY_DEFAULT;
	        _this.securityDebugCallback_ = null;
	        _this.lastSessionId = null;
	        _this.establishConnectionTimer_ = null;
	        _this.visible_ = false;
	        // Before we get connected, we keep a queue of pending messages to send.
	        _this.requestCBHash_ = {};
	        _this.requestNumber_ = 0;
	        _this.realtime_ = null;
	        _this.authToken_ = null;
	        _this.forceTokenRefresh_ = false;
	        _this.invalidAuthTokenCount_ = 0;
	        _this.firstConnection_ = true;
	        _this.lastConnectionAttemptTime_ = null;
	        _this.lastConnectionEstablishedTime_ = null;
	        if (authOverride_ && !util.isNodeSdk()) {
	            throw new Error('Auth override specified in options, but not supported on non Node.js platforms');
	        }
	        _this.scheduleConnect_(0);
	        VisibilityMonitor.getInstance().on('visible', _this.onVisible_, _this);
	        if (repoInfo_.host.indexOf('fblocal') === -1) {
	            OnlineMonitor.getInstance().on('online', _this.onOnline_, _this);
	        }
	        return _this;
	    }
	    PersistentConnection.prototype.sendRequest = function (action, body, onResponse) {
	        var curReqNum = ++this.requestNumber_;
	        var msg = { r: curReqNum, a: action, b: body };
	        this.log_(util.stringify(msg));
	        util.assert(this.connected_, "sendRequest call when we're not connected not allowed.");
	        this.realtime_.sendRequest(msg);
	        if (onResponse) {
	            this.requestCBHash_[curReqNum] = onResponse;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    PersistentConnection.prototype.listen = function (query, currentHashFn, tag, onComplete) {
	        var queryId = query.queryIdentifier();
	        var pathString = query.path.toString();
	        this.log_('Listen called for ' + pathString + ' ' + queryId);
	        if (!this.listens.has(pathString)) {
	            this.listens.set(pathString, new Map());
	        }
	        util.assert(query.getQueryParams().isDefault() ||
	            !query.getQueryParams().loadsAllData(), 'listen() called for non-default but complete query');
	        util.assert(!this.listens.get(pathString).has(queryId), 'listen() called twice for same path/queryId.');
	        var listenSpec = {
	            onComplete: onComplete,
	            hashFn: currentHashFn,
	            query: query,
	            tag: tag
	        };
	        this.listens.get(pathString).set(queryId, listenSpec);
	        if (this.connected_) {
	            this.sendListen_(listenSpec);
	        }
	    };
	    PersistentConnection.prototype.sendListen_ = function (listenSpec) {
	        var _this = this;
	        var query = listenSpec.query;
	        var pathString = query.path.toString();
	        var queryId = query.queryIdentifier();
	        this.log_('Listen on ' + pathString + ' for ' + queryId);
	        var req = { /*path*/ p: pathString };
	        var action = 'q';
	        // Only bother to send query if it's non-default.
	        if (listenSpec.tag) {
	            req['q'] = query.queryObject();
	            req['t'] = listenSpec.tag;
	        }
	        req[ /*hash*/'h'] = listenSpec.hashFn();
	        this.sendRequest(action, req, function (message) {
	            var payload = message[ /*data*/'d'];
	            var status = message[ /*status*/'s'];
	            // print warnings in any case...
	            PersistentConnection.warnOnListenWarnings_(payload, query);
	            var currentListenSpec = _this.listens.get(pathString) &&
	                _this.listens.get(pathString).get(queryId);
	            // only trigger actions if the listen hasn't been removed and readded
	            if (currentListenSpec === listenSpec) {
	                _this.log_('listen response', message);
	                if (status !== 'ok') {
	                    _this.removeListen_(pathString, queryId);
	                }
	                if (listenSpec.onComplete) {
	                    listenSpec.onComplete(status, payload);
	                }
	            }
	        });
	    };
	    PersistentConnection.warnOnListenWarnings_ = function (payload, query) {
	        if (payload && typeof payload === 'object' && util.contains(payload, 'w')) {
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	            var warnings = util.safeGet(payload, 'w');
	            if (Array.isArray(warnings) && ~warnings.indexOf('no_index')) {
	                var indexSpec = '".indexOn": "' +
	                    query
	                        .getQueryParams()
	                        .getIndex()
	                        .toString() +
	                    '"';
	                var indexPath = query.path.toString();
	                warn("Using an unspecified index. Your data will be downloaded and " +
	                    ("filtered on the client. Consider adding " + indexSpec + " at ") +
	                    (indexPath + " to your security rules for better performance."));
	            }
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    PersistentConnection.prototype.refreshAuthToken = function (token) {
	        this.authToken_ = token;
	        this.log_('Auth token refreshed');
	        if (this.authToken_) {
	            this.tryAuth();
	        }
	        else {
	            //If we're connected we want to let the server know to unauthenticate us. If we're not connected, simply delete
	            //the credential so we dont become authenticated next time we connect.
	            if (this.connected_) {
	                this.sendRequest('unauth', {}, function () { });
	            }
	        }
	        this.reduceReconnectDelayIfAdminCredential_(token);
	    };
	    PersistentConnection.prototype.reduceReconnectDelayIfAdminCredential_ = function (credential) {
	        // NOTE: This isn't intended to be bulletproof (a malicious developer can always just modify the client).
	        // Additionally, we don't bother resetting the max delay back to the default if auth fails / expires.
	        var isFirebaseSecret = credential && credential.length === 40;
	        if (isFirebaseSecret || util.isAdmin(credential)) {
	            this.log_('Admin auth credential detected.  Reducing max reconnect time.');
	            this.maxReconnectDelay_ = RECONNECT_MAX_DELAY_FOR_ADMINS;
	        }
	    };
	    /**
	     * Attempts to authenticate with the given credentials. If the authentication attempt fails, it's triggered like
	     * a auth revoked (the connection is closed).
	     */
	    PersistentConnection.prototype.tryAuth = function () {
	        var _this = this;
	        if (this.connected_ && this.authToken_) {
	            var token_1 = this.authToken_;
	            var authMethod = util.isValidFormat(token_1) ? 'auth' : 'gauth';
	            var requestData = { cred: token_1 };
	            if (this.authOverride_ === null) {
	                requestData['noauth'] = true;
	            }
	            else if (typeof this.authOverride_ === 'object') {
	                requestData['authvar'] = this.authOverride_;
	            }
	            this.sendRequest(authMethod, requestData, function (res) {
	                var status = res[ /*status*/'s'];
	                var data = res[ /*data*/'d'] || 'error';
	                if (_this.authToken_ === token_1) {
	                    if (status === 'ok') {
	                        _this.invalidAuthTokenCount_ = 0;
	                    }
	                    else {
	                        // Triggers reconnect and force refresh for auth token
	                        _this.onAuthRevoked_(status, data);
	                    }
	                }
	            });
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    PersistentConnection.prototype.unlisten = function (query, tag) {
	        var pathString = query.path.toString();
	        var queryId = query.queryIdentifier();
	        this.log_('Unlisten called for ' + pathString + ' ' + queryId);
	        util.assert(query.getQueryParams().isDefault() ||
	            !query.getQueryParams().loadsAllData(), 'unlisten() called for non-default but complete query');
	        var listen = this.removeListen_(pathString, queryId);
	        if (listen && this.connected_) {
	            this.sendUnlisten_(pathString, queryId, query.queryObject(), tag);
	        }
	    };
	    PersistentConnection.prototype.sendUnlisten_ = function (pathString, queryId, queryObj, tag) {
	        this.log_('Unlisten on ' + pathString + ' for ' + queryId);
	        var req = { /*path*/ p: pathString };
	        var action = 'n';
	        // Only bother sending queryId if it's non-default.
	        if (tag) {
	            req['q'] = queryObj;
	            req['t'] = tag;
	        }
	        this.sendRequest(action, req);
	    };
	    /**
	     * @inheritDoc
	     */
	    PersistentConnection.prototype.onDisconnectPut = function (pathString, data, onComplete) {
	        if (this.connected_) {
	            this.sendOnDisconnect_('o', pathString, data, onComplete);
	        }
	        else {
	            this.onDisconnectRequestQueue_.push({
	                pathString: pathString,
	                action: 'o',
	                data: data,
	                onComplete: onComplete
	            });
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    PersistentConnection.prototype.onDisconnectMerge = function (pathString, data, onComplete) {
	        if (this.connected_) {
	            this.sendOnDisconnect_('om', pathString, data, onComplete);
	        }
	        else {
	            this.onDisconnectRequestQueue_.push({
	                pathString: pathString,
	                action: 'om',
	                data: data,
	                onComplete: onComplete
	            });
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    PersistentConnection.prototype.onDisconnectCancel = function (pathString, onComplete) {
	        if (this.connected_) {
	            this.sendOnDisconnect_('oc', pathString, null, onComplete);
	        }
	        else {
	            this.onDisconnectRequestQueue_.push({
	                pathString: pathString,
	                action: 'oc',
	                data: null,
	                onComplete: onComplete
	            });
	        }
	    };
	    PersistentConnection.prototype.sendOnDisconnect_ = function (action, pathString, data, onComplete) {
	        var request = { /*path*/ p: pathString, /*data*/ d: data };
	        this.log_('onDisconnect ' + action, request);
	        this.sendRequest(action, request, function (response) {
	            if (onComplete) {
	                setTimeout(function () {
	                    onComplete(response[ /*status*/'s'], response[ /* data */'d']);
	                }, Math.floor(0));
	            }
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    PersistentConnection.prototype.put = function (pathString, data, onComplete, hash) {
	        this.putInternal('p', pathString, data, onComplete, hash);
	    };
	    /**
	     * @inheritDoc
	     */
	    PersistentConnection.prototype.merge = function (pathString, data, onComplete, hash) {
	        this.putInternal('m', pathString, data, onComplete, hash);
	    };
	    PersistentConnection.prototype.putInternal = function (action, pathString, data, onComplete, hash) {
	        var request = {
	            /*path*/ p: pathString,
	            /*data*/ d: data
	        };
	        if (hash !== undefined) {
	            request[ /*hash*/'h'] = hash;
	        }
	        // TODO: Only keep track of the most recent put for a given path?
	        this.outstandingPuts_.push({
	            action: action,
	            request: request,
	            onComplete: onComplete
	        });
	        this.outstandingPutCount_++;
	        var index = this.outstandingPuts_.length - 1;
	        if (this.connected_) {
	            this.sendPut_(index);
	        }
	        else {
	            this.log_('Buffering put: ' + pathString);
	        }
	    };
	    PersistentConnection.prototype.sendPut_ = function (index) {
	        var _this = this;
	        var action = this.outstandingPuts_[index].action;
	        var request = this.outstandingPuts_[index].request;
	        var onComplete = this.outstandingPuts_[index].onComplete;
	        this.outstandingPuts_[index].queued = this.connected_;
	        this.sendRequest(action, request, function (message) {
	            _this.log_(action + ' response', message);
	            delete _this.outstandingPuts_[index];
	            _this.outstandingPutCount_--;
	            // Clean up array occasionally.
	            if (_this.outstandingPutCount_ === 0) {
	                _this.outstandingPuts_ = [];
	            }
	            if (onComplete) {
	                onComplete(message[ /*status*/'s'], message[ /* data */'d']);
	            }
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    PersistentConnection.prototype.reportStats = function (stats) {
	        var _this = this;
	        // If we're not connected, we just drop the stats.
	        if (this.connected_) {
	            var request = { /*counters*/ c: stats };
	            this.log_('reportStats', request);
	            this.sendRequest(/*stats*/ 's', request, function (result) {
	                var status = result[ /*status*/'s'];
	                if (status !== 'ok') {
	                    var errorReason = result[ /* data */'d'];
	                    _this.log_('reportStats', 'Error sending stats: ' + errorReason);
	                }
	            });
	        }
	    };
	    PersistentConnection.prototype.onDataMessage_ = function (message) {
	        if ('r' in message) {
	            // this is a response
	            this.log_('from server: ' + util.stringify(message));
	            var reqNum = message['r'];
	            var onResponse = this.requestCBHash_[reqNum];
	            if (onResponse) {
	                delete this.requestCBHash_[reqNum];
	                onResponse(message[ /*body*/'b']);
	            }
	        }
	        else if ('error' in message) {
	            throw 'A server-side error has occurred: ' + message['error'];
	        }
	        else if ('a' in message) {
	            // a and b are action and body, respectively
	            this.onDataPush_(message['a'], message['b']);
	        }
	    };
	    PersistentConnection.prototype.onDataPush_ = function (action, body) {
	        this.log_('handleServerMessage', action, body);
	        if (action === 'd') {
	            this.onDataUpdate_(body[ /*path*/'p'], body[ /*data*/'d'], 
	            /*isMerge*/ false, body['t']);
	        }
	        else if (action === 'm') {
	            this.onDataUpdate_(body[ /*path*/'p'], body[ /*data*/'d'], 
	            /*isMerge=*/ true, body['t']);
	        }
	        else if (action === 'c') {
	            this.onListenRevoked_(body[ /*path*/'p'], body[ /*query*/'q']);
	        }
	        else if (action === 'ac') {
	            this.onAuthRevoked_(body[ /*status code*/'s'], body[ /* explanation */'d']);
	        }
	        else if (action === 'sd') {
	            this.onSecurityDebugPacket_(body);
	        }
	        else {
	            error('Unrecognized action received from server: ' +
	                util.stringify(action) +
	                '\nAre you using the latest client?');
	        }
	    };
	    PersistentConnection.prototype.onReady_ = function (timestamp, sessionId) {
	        this.log_('connection ready');
	        this.connected_ = true;
	        this.lastConnectionEstablishedTime_ = new Date().getTime();
	        this.handleTimestamp_(timestamp);
	        this.lastSessionId = sessionId;
	        if (this.firstConnection_) {
	            this.sendConnectStats_();
	        }
	        this.restoreState_();
	        this.firstConnection_ = false;
	        this.onConnectStatus_(true);
	    };
	    PersistentConnection.prototype.scheduleConnect_ = function (timeout) {
	        var _this = this;
	        util.assert(!this.realtime_, "Scheduling a connect when we're already connected/ing?");
	        if (this.establishConnectionTimer_) {
	            clearTimeout(this.establishConnectionTimer_);
	        }
	        // NOTE: Even when timeout is 0, it's important to do a setTimeout to work around an infuriating "Security Error" in
	        // Firefox when trying to write to our long-polling iframe in some scenarios (e.g. Forge or our unit tests).
	        this.establishConnectionTimer_ = setTimeout(function () {
	            _this.establishConnectionTimer_ = null;
	            _this.establishConnection_();
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        }, Math.floor(timeout));
	    };
	    PersistentConnection.prototype.onVisible_ = function (visible) {
	        // NOTE: Tabbing away and back to a window will defeat our reconnect backoff, but I think that's fine.
	        if (visible &&
	            !this.visible_ &&
	            this.reconnectDelay_ === this.maxReconnectDelay_) {
	            this.log_('Window became visible.  Reducing delay.');
	            this.reconnectDelay_ = RECONNECT_MIN_DELAY;
	            if (!this.realtime_) {
	                this.scheduleConnect_(0);
	            }
	        }
	        this.visible_ = visible;
	    };
	    PersistentConnection.prototype.onOnline_ = function (online) {
	        if (online) {
	            this.log_('Browser went online.');
	            this.reconnectDelay_ = RECONNECT_MIN_DELAY;
	            if (!this.realtime_) {
	                this.scheduleConnect_(0);
	            }
	        }
	        else {
	            this.log_('Browser went offline.  Killing connection.');
	            if (this.realtime_) {
	                this.realtime_.close();
	            }
	        }
	    };
	    PersistentConnection.prototype.onRealtimeDisconnect_ = function () {
	        this.log_('data client disconnected');
	        this.connected_ = false;
	        this.realtime_ = null;
	        // Since we don't know if our sent transactions succeeded or not, we need to cancel them.
	        this.cancelSentTransactions_();
	        // Clear out the pending requests.
	        this.requestCBHash_ = {};
	        if (this.shouldReconnect_()) {
	            if (!this.visible_) {
	                this.log_("Window isn't visible.  Delaying reconnect.");
	                this.reconnectDelay_ = this.maxReconnectDelay_;
	                this.lastConnectionAttemptTime_ = new Date().getTime();
	            }
	            else if (this.lastConnectionEstablishedTime_) {
	                // If we've been connected long enough, reset reconnect delay to minimum.
	                var timeSinceLastConnectSucceeded = new Date().getTime() - this.lastConnectionEstablishedTime_;
	                if (timeSinceLastConnectSucceeded > RECONNECT_DELAY_RESET_TIMEOUT) {
	                    this.reconnectDelay_ = RECONNECT_MIN_DELAY;
	                }
	                this.lastConnectionEstablishedTime_ = null;
	            }
	            var timeSinceLastConnectAttempt = new Date().getTime() - this.lastConnectionAttemptTime_;
	            var reconnectDelay = Math.max(0, this.reconnectDelay_ - timeSinceLastConnectAttempt);
	            reconnectDelay = Math.random() * reconnectDelay;
	            this.log_('Trying to reconnect in ' + reconnectDelay + 'ms');
	            this.scheduleConnect_(reconnectDelay);
	            // Adjust reconnect delay for next time.
	            this.reconnectDelay_ = Math.min(this.maxReconnectDelay_, this.reconnectDelay_ * RECONNECT_DELAY_MULTIPLIER);
	        }
	        this.onConnectStatus_(false);
	    };
	    PersistentConnection.prototype.establishConnection_ = function () {
	        if (this.shouldReconnect_()) {
	            this.log_('Making a connection attempt');
	            this.lastConnectionAttemptTime_ = new Date().getTime();
	            this.lastConnectionEstablishedTime_ = null;
	            var onDataMessage_1 = this.onDataMessage_.bind(this);
	            var onReady_1 = this.onReady_.bind(this);
	            var onDisconnect_1 = this.onRealtimeDisconnect_.bind(this);
	            var connId_1 = this.id + ':' + PersistentConnection.nextConnectionId_++;
	            var self_1 = this;
	            var lastSessionId_1 = this.lastSessionId;
	            var canceled_1 = false;
	            var connection_1 = null;
	            var closeFn_1 = function () {
	                if (connection_1) {
	                    connection_1.close();
	                }
	                else {
	                    canceled_1 = true;
	                    onDisconnect_1();
	                }
	            };
	            var sendRequestFn = function (msg) {
	                util.assert(connection_1, "sendRequest call when we're not connected not allowed.");
	                connection_1.sendRequest(msg);
	            };
	            this.realtime_ = {
	                close: closeFn_1,
	                sendRequest: sendRequestFn
	            };
	            var forceRefresh = this.forceTokenRefresh_;
	            this.forceTokenRefresh_ = false;
	            // First fetch auth token, and establish connection after fetching the token was successful
	            this.authTokenProvider_
	                .getToken(forceRefresh)
	                .then(function (result) {
	                if (!canceled_1) {
	                    log('getToken() completed. Creating connection.');
	                    self_1.authToken_ = result && result.accessToken;
	                    connection_1 = new Connection(connId_1, self_1.repoInfo_, onDataMessage_1, onReady_1, onDisconnect_1, 
	                    /* onKill= */ function (reason) {
	                        warn(reason + ' (' + self_1.repoInfo_.toString() + ')');
	                        self_1.interrupt(SERVER_KILL_INTERRUPT_REASON);
	                    }, lastSessionId_1);
	                }
	                else {
	                    log('getToken() completed but was canceled');
	                }
	            })
	                .then(null, function (error) {
	                self_1.log_('Failed to get token: ' + error);
	                if (!canceled_1) {
	                    if (util.CONSTANTS.NODE_ADMIN) {
	                        // This may be a critical error for the Admin Node.js SDK, so log a warning.
	                        // But getToken() may also just have temporarily failed, so we still want to
	                        // continue retrying.
	                        warn(error);
	                    }
	                    closeFn_1();
	                }
	            });
	        }
	    };
	    PersistentConnection.prototype.interrupt = function (reason) {
	        log('Interrupting connection for reason: ' + reason);
	        this.interruptReasons_[reason] = true;
	        if (this.realtime_) {
	            this.realtime_.close();
	        }
	        else {
	            if (this.establishConnectionTimer_) {
	                clearTimeout(this.establishConnectionTimer_);
	                this.establishConnectionTimer_ = null;
	            }
	            if (this.connected_) {
	                this.onRealtimeDisconnect_();
	            }
	        }
	    };
	    PersistentConnection.prototype.resume = function (reason) {
	        log('Resuming connection for reason: ' + reason);
	        delete this.interruptReasons_[reason];
	        if (util.isEmpty(this.interruptReasons_)) {
	            this.reconnectDelay_ = RECONNECT_MIN_DELAY;
	            if (!this.realtime_) {
	                this.scheduleConnect_(0);
	            }
	        }
	    };
	    PersistentConnection.prototype.handleTimestamp_ = function (timestamp) {
	        var delta = timestamp - new Date().getTime();
	        this.onServerInfoUpdate_({ serverTimeOffset: delta });
	    };
	    PersistentConnection.prototype.cancelSentTransactions_ = function () {
	        for (var i = 0; i < this.outstandingPuts_.length; i++) {
	            var put = this.outstandingPuts_[i];
	            if (put && /*hash*/ 'h' in put.request && put.queued) {
	                if (put.onComplete) {
	                    put.onComplete('disconnect');
	                }
	                delete this.outstandingPuts_[i];
	                this.outstandingPutCount_--;
	            }
	        }
	        // Clean up array occasionally.
	        if (this.outstandingPutCount_ === 0) {
	            this.outstandingPuts_ = [];
	        }
	    };
	    PersistentConnection.prototype.onListenRevoked_ = function (pathString, query) {
	        // Remove the listen and manufacture a "permission_denied" error for the failed listen.
	        var queryId;
	        if (!query) {
	            queryId = 'default';
	        }
	        else {
	            queryId = query.map(function (q) { return ObjectToUniqueKey(q); }).join('$');
	        }
	        var listen = this.removeListen_(pathString, queryId);
	        if (listen && listen.onComplete) {
	            listen.onComplete('permission_denied');
	        }
	    };
	    PersistentConnection.prototype.removeListen_ = function (pathString, queryId) {
	        var normalizedPathString = new Path(pathString).toString(); // normalize path.
	        var listen;
	        if (this.listens.has(normalizedPathString)) {
	            var map = this.listens.get(normalizedPathString);
	            listen = map.get(queryId);
	            map.delete(queryId);
	            if (map.size === 0) {
	                this.listens.delete(normalizedPathString);
	            }
	        }
	        else {
	            // all listens for this path has already been removed
	            listen = undefined;
	        }
	        return listen;
	    };
	    PersistentConnection.prototype.onAuthRevoked_ = function (statusCode, explanation) {
	        log('Auth token revoked: ' + statusCode + '/' + explanation);
	        this.authToken_ = null;
	        this.forceTokenRefresh_ = true;
	        this.realtime_.close();
	        if (statusCode === 'invalid_token' || statusCode === 'permission_denied') {
	            // We'll wait a couple times before logging the warning / increasing the
	            // retry period since oauth tokens will report as "invalid" if they're
	            // just expired. Plus there may be transient issues that resolve themselves.
	            this.invalidAuthTokenCount_++;
	            if (this.invalidAuthTokenCount_ >= INVALID_AUTH_TOKEN_THRESHOLD) {
	                // Set a long reconnect delay because recovery is unlikely
	                this.reconnectDelay_ = RECONNECT_MAX_DELAY_FOR_ADMINS;
	                // Notify the auth token provider that the token is invalid, which will log
	                // a warning
	                this.authTokenProvider_.notifyForInvalidToken();
	            }
	        }
	    };
	    PersistentConnection.prototype.onSecurityDebugPacket_ = function (body) {
	        if (this.securityDebugCallback_) {
	            this.securityDebugCallback_(body);
	        }
	        else {
	            if ('msg' in body) {
	                console.log('FIREBASE: ' + body['msg'].replace('\n', '\nFIREBASE: '));
	            }
	        }
	    };
	    PersistentConnection.prototype.restoreState_ = function () {
	        var e_1, _a, e_2, _b;
	        //Re-authenticate ourselves if we have a credential stored.
	        this.tryAuth();
	        try {
	            // Puts depend on having received the corresponding data update from the server before they complete, so we must
	            // make sure to send listens before puts.
	            for (var _c = tslib.__values(this.listens.values()), _d = _c.next(); !_d.done; _d = _c.next()) {
	                var queries = _d.value;
	                try {
	                    for (var _e = (e_2 = void 0, tslib.__values(queries.values())), _f = _e.next(); !_f.done; _f = _e.next()) {
	                        var listenSpec = _f.value;
	                        this.sendListen_(listenSpec);
	                    }
	                }
	                catch (e_2_1) { e_2 = { error: e_2_1 }; }
	                finally {
	                    try {
	                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
	                    }
	                    finally { if (e_2) throw e_2.error; }
	                }
	            }
	        }
	        catch (e_1_1) { e_1 = { error: e_1_1 }; }
	        finally {
	            try {
	                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
	            }
	            finally { if (e_1) throw e_1.error; }
	        }
	        for (var i = 0; i < this.outstandingPuts_.length; i++) {
	            if (this.outstandingPuts_[i]) {
	                this.sendPut_(i);
	            }
	        }
	        while (this.onDisconnectRequestQueue_.length) {
	            var request = this.onDisconnectRequestQueue_.shift();
	            this.sendOnDisconnect_(request.action, request.pathString, request.data, request.onComplete);
	        }
	    };
	    /**
	     * Sends client stats for first connection
	     */
	    PersistentConnection.prototype.sendConnectStats_ = function () {
	        var stats = {};
	        var clientName = 'js';
	        if (util.CONSTANTS.NODE_ADMIN) {
	            clientName = 'admin_node';
	        }
	        else if (util.CONSTANTS.NODE_CLIENT) {
	            clientName = 'node';
	        }
	        stats['sdk.' + clientName + '.' + SDK_VERSION.replace(/\./g, '-')] = 1;
	        if (util.isMobileCordova()) {
	            stats['framework.cordova'] = 1;
	        }
	        else if (util.isReactNative()) {
	            stats['framework.reactnative'] = 1;
	        }
	        this.reportStats(stats);
	    };
	    PersistentConnection.prototype.shouldReconnect_ = function () {
	        var online = OnlineMonitor.getInstance().currentlyOnline();
	        return util.isEmpty(this.interruptReasons_) && online;
	    };
	    PersistentConnection.nextPersistentConnectionId_ = 0;
	    /**
	     * Counter for number of connections created. Mainly used for tagging in the logs
	     */
	    PersistentConnection.nextConnectionId_ = 0;
	    return PersistentConnection;
	}(ServerActions));
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * An implementation of ServerActions that communicates with the server via REST requests.
	 * This is mostly useful for compatibility with crawlers, where we don't want to spin up a full
	 * persistent connection (using WebSockets or long-polling)
	 */
	var ReadonlyRestClient = /** @class */ (function (_super) {
	    tslib.__extends(ReadonlyRestClient, _super);
	    /**
	     * @param {!RepoInfo} repoInfo_ Data about the namespace we are connecting to
	     * @param {function(string, *, boolean, ?number)} onDataUpdate_ A callback for new data from the server
	     * @param {AuthTokenProvider} authTokenProvider_
	     * @implements {ServerActions}
	     */
	    function ReadonlyRestClient(repoInfo_, onDataUpdate_, authTokenProvider_) {
	        var _this = _super.call(this) || this;
	        _this.repoInfo_ = repoInfo_;
	        _this.onDataUpdate_ = onDataUpdate_;
	        _this.authTokenProvider_ = authTokenProvider_;
	        /** @private {function(...[*])} */
	        _this.log_ = logWrapper('p:rest:');
	        /**
	         * We don't actually need to track listens, except to prevent us calling an onComplete for a listen
	         * that's been removed. :-/
	         *
	         * @private {!Object.<string, !Object>}
	         */
	        _this.listens_ = {};
	        return _this;
	    }
	    ReadonlyRestClient.prototype.reportStats = function (stats) {
	        throw new Error('Method not implemented.');
	    };
	    /**
	     * @param {!Query} query
	     * @param {?number=} tag
	     * @return {string}
	     * @private
	     */
	    ReadonlyRestClient.getListenId_ = function (query, tag) {
	        if (tag !== undefined) {
	            return 'tag$' + tag;
	        }
	        else {
	            util.assert(query.getQueryParams().isDefault(), "should have a tag if it's not a default query.");
	            return query.path.toString();
	        }
	    };
	    /** @inheritDoc */
	    ReadonlyRestClient.prototype.listen = function (query, currentHashFn, tag, onComplete) {
	        var _this = this;
	        var pathString = query.path.toString();
	        this.log_('Listen called for ' + pathString + ' ' + query.queryIdentifier());
	        // Mark this listener so we can tell if it's removed.
	        var listenId = ReadonlyRestClient.getListenId_(query, tag);
	        var thisListen = {};
	        this.listens_[listenId] = thisListen;
	        var queryStringParameters = query
	            .getQueryParams()
	            .toRestQueryStringParameters();
	        this.restRequest_(pathString + '.json', queryStringParameters, function (error, result) {
	            var data = result;
	            if (error === 404) {
	                data = null;
	                error = null;
	            }
	            if (error === null) {
	                _this.onDataUpdate_(pathString, data, /*isMerge=*/ false, tag);
	            }
	            if (util.safeGet(_this.listens_, listenId) === thisListen) {
	                var status_1;
	                if (!error) {
	                    status_1 = 'ok';
	                }
	                else if (error === 401) {
	                    status_1 = 'permission_denied';
	                }
	                else {
	                    status_1 = 'rest_error:' + error;
	                }
	                onComplete(status_1, null);
	            }
	        });
	    };
	    /** @inheritDoc */
	    ReadonlyRestClient.prototype.unlisten = function (query, tag) {
	        var listenId = ReadonlyRestClient.getListenId_(query, tag);
	        delete this.listens_[listenId];
	    };
	    /** @inheritDoc */
	    ReadonlyRestClient.prototype.refreshAuthToken = function (token) {
	        // no-op since we just always call getToken.
	    };
	    /**
	     * Performs a REST request to the given path, with the provided query string parameters,
	     * and any auth credentials we have.
	     *
	     * @param {!string} pathString
	     * @param {!Object.<string, *>} queryStringParameters
	     * @param {?function(?number, *=)} callback
	     * @private
	     */
	    ReadonlyRestClient.prototype.restRequest_ = function (pathString, queryStringParameters, callback) {
	        var _this = this;
	        if (queryStringParameters === void 0) { queryStringParameters = {}; }
	        queryStringParameters['format'] = 'export';
	        this.authTokenProvider_
	            .getToken(/*forceRefresh=*/ false)
	            .then(function (authTokenData) {
	            var authToken = authTokenData && authTokenData.accessToken;
	            if (authToken) {
	                queryStringParameters['auth'] = authToken;
	            }
	            var url = (_this.repoInfo_.secure ? 'https://' : 'http://') +
	                _this.repoInfo_.host +
	                pathString +
	                '?' +
	                'ns=' +
	                _this.repoInfo_.namespace +
	                util.querystring(queryStringParameters);
	            _this.log_('Sending REST request for ' + url);
	            var xhr = new XMLHttpRequest();
	            xhr.onreadystatechange = function () {
	                if (callback && xhr.readyState === 4) {
	                    _this.log_('REST Response for ' + url + ' received. status:', xhr.status, 'response:', xhr.responseText);
	                    var res = null;
	                    if (xhr.status >= 200 && xhr.status < 300) {
	                        try {
	                            res = util.jsonEval(xhr.responseText);
	                        }
	                        catch (e) {
	                            warn('Failed to parse JSON response for ' +
	                                url +
	                                ': ' +
	                                xhr.responseText);
	                        }
	                        callback(null, res);
	                    }
	                    else {
	                        // 401 and 404 are expected.
	                        if (xhr.status !== 401 && xhr.status !== 404) {
	                            warn('Got unsuccessful REST response for ' +
	                                url +
	                                ' Status: ' +
	                                xhr.status);
	                        }
	                        callback(xhr.status);
	                    }
	                    callback = null;
	                }
	            };
	            xhr.open('GET', url, /*asynchronous=*/ true);
	            xhr.send();
	        });
	    };
	    return ReadonlyRestClient;
	}(ServerActions));
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var INTERRUPT_REASON = 'repo_interrupt';
	/**
	 * A connection to a single data repository.
	 */
	var Repo = /** @class */ (function () {
	    function Repo(repoInfo_, forceRestClient, app, authProvider) {
	        var _this = this;
	        this.repoInfo_ = repoInfo_;
	        this.app = app;
	        this.dataUpdateCount = 0;
	        this.statsListener_ = null;
	        this.eventQueue_ = new EventQueue();
	        this.nextWriteId_ = 1;
	        this.interceptServerDataCallback_ = null;
	        /** A list of data pieces and paths to be set when this client disconnects. */
	        this.onDisconnect_ = new SparseSnapshotTree();
	        // TODO: This should be @private but it's used by test_access.js and internal.js
	        this.persistentConnection_ = null;
	        var authTokenProvider = new AuthTokenProvider(app, authProvider);
	        this.stats_ = StatsManager.getCollection(repoInfo_);
	        if (forceRestClient || beingCrawled()) {
	            this.server_ = new ReadonlyRestClient(this.repoInfo_, this.onDataUpdate_.bind(this), authTokenProvider);
	            // Minor hack: Fire onConnect immediately, since there's no actual connection.
	            setTimeout(this.onConnectStatus_.bind(this, true), 0);
	        }
	        else {
	            var authOverride = app.options['databaseAuthVariableOverride'];
	            // Validate authOverride
	            if (typeof authOverride !== 'undefined' && authOverride !== null) {
	                if (typeof authOverride !== 'object') {
	                    throw new Error('Only objects are supported for option databaseAuthVariableOverride');
	                }
	                try {
	                    util.stringify(authOverride);
	                }
	                catch (e) {
	                    throw new Error('Invalid authOverride provided: ' + e);
	                }
	            }
	            this.persistentConnection_ = new PersistentConnection(this.repoInfo_, this.onDataUpdate_.bind(this), this.onConnectStatus_.bind(this), this.onServerInfoUpdate_.bind(this), authTokenProvider, authOverride);
	            this.server_ = this.persistentConnection_;
	        }
	        authTokenProvider.addTokenChangeListener(function (token) {
	            _this.server_.refreshAuthToken(token);
	        });
	        // In the case of multiple Repos for the same repoInfo (i.e. there are multiple Firebase.Contexts being used),
	        // we only want to create one StatsReporter.  As such, we'll report stats over the first Repo created.
	        this.statsReporter_ = StatsManager.getOrCreateReporter(repoInfo_, function () { return new StatsReporter(_this.stats_, _this.server_); });
	        this.transactionsInit_();
	        // Used for .info.
	        this.infoData_ = new SnapshotHolder();
	        this.infoSyncTree_ = new SyncTree({
	            startListening: function (query, tag, currentHashFn, onComplete) {
	                var infoEvents = [];
	                var node = _this.infoData_.getNode(query.path);
	                // This is possibly a hack, but we have different semantics for .info endpoints. We don't raise null events
	                // on initial data...
	                if (!node.isEmpty()) {
	                    infoEvents = _this.infoSyncTree_.applyServerOverwrite(query.path, node);
	                    setTimeout(function () {
	                        onComplete('ok');
	                    }, 0);
	                }
	                return infoEvents;
	            },
	            stopListening: function () { }
	        });
	        this.updateInfo_('connected', false);
	        this.serverSyncTree_ = new SyncTree({
	            startListening: function (query, tag, currentHashFn, onComplete) {
	                _this.server_.listen(query, currentHashFn, tag, function (status, data) {
	                    var events = onComplete(status, data);
	                    _this.eventQueue_.raiseEventsForChangedPath(query.path, events);
	                });
	                // No synchronous events for network-backed sync trees
	                return [];
	            },
	            stopListening: function (query, tag) {
	                _this.server_.unlisten(query, tag);
	            }
	        });
	    }
	    /**
	     * @return The URL corresponding to the root of this Firebase.
	     */
	    Repo.prototype.toString = function () {
	        return ((this.repoInfo_.secure ? 'https://' : 'http://') + this.repoInfo_.host);
	    };
	    /**
	     * @return The namespace represented by the repo.
	     */
	    Repo.prototype.name = function () {
	        return this.repoInfo_.namespace;
	    };
	    /**
	     * @return The time in milliseconds, taking the server offset into account if we have one.
	     */
	    Repo.prototype.serverTime = function () {
	        var offsetNode = this.infoData_.getNode(new Path('.info/serverTimeOffset'));
	        var offset = offsetNode.val() || 0;
	        return new Date().getTime() + offset;
	    };
	    /**
	     * Generate ServerValues using some variables from the repo object.
	     */
	    Repo.prototype.generateServerValues = function () {
	        return generateWithValues({
	            timestamp: this.serverTime()
	        });
	    };
	    /**
	     * Called by realtime when we get new messages from the server.
	     */
	    Repo.prototype.onDataUpdate_ = function (pathString, data, isMerge, tag) {
	        // For testing.
	        this.dataUpdateCount++;
	        var path = new Path(pathString);
	        data = this.interceptServerDataCallback_
	            ? this.interceptServerDataCallback_(pathString, data)
	            : data;
	        var events = [];
	        if (tag) {
	            if (isMerge) {
	                var taggedChildren = util.map(data, function (raw) { return nodeFromJSON$1(raw); });
	                events = this.serverSyncTree_.applyTaggedQueryMerge(path, taggedChildren, tag);
	            }
	            else {
	                var taggedSnap = nodeFromJSON$1(data);
	                events = this.serverSyncTree_.applyTaggedQueryOverwrite(path, taggedSnap, tag);
	            }
	        }
	        else if (isMerge) {
	            var changedChildren = util.map(data, function (raw) { return nodeFromJSON$1(raw); });
	            events = this.serverSyncTree_.applyServerMerge(path, changedChildren);
	        }
	        else {
	            var snap = nodeFromJSON$1(data);
	            events = this.serverSyncTree_.applyServerOverwrite(path, snap);
	        }
	        var affectedPath = path;
	        if (events.length > 0) {
	            // Since we have a listener outstanding for each transaction, receiving any events
	            // is a proxy for some change having occurred.
	            affectedPath = this.rerunTransactions_(path);
	        }
	        this.eventQueue_.raiseEventsForChangedPath(affectedPath, events);
	    };
	    // TODO: This should be @private but it's used by test_access.js and internal.js
	    Repo.prototype.interceptServerData_ = function (callback) {
	        this.interceptServerDataCallback_ = callback;
	    };
	    Repo.prototype.onConnectStatus_ = function (connectStatus) {
	        this.updateInfo_('connected', connectStatus);
	        if (connectStatus === false) {
	            this.runOnDisconnectEvents_();
	        }
	    };
	    Repo.prototype.onServerInfoUpdate_ = function (updates) {
	        var _this = this;
	        each(updates, function (key, value) {
	            _this.updateInfo_(key, value);
	        });
	    };
	    Repo.prototype.updateInfo_ = function (pathString, value) {
	        var path = new Path('/.info/' + pathString);
	        var newNode = nodeFromJSON$1(value);
	        this.infoData_.updateSnapshot(path, newNode);
	        var events = this.infoSyncTree_.applyServerOverwrite(path, newNode);
	        this.eventQueue_.raiseEventsForChangedPath(path, events);
	    };
	    Repo.prototype.getNextWriteId_ = function () {
	        return this.nextWriteId_++;
	    };
	    Repo.prototype.setWithPriority = function (path, newVal, newPriority, onComplete) {
	        var _this = this;
	        this.log_('set', {
	            path: path.toString(),
	            value: newVal,
	            priority: newPriority
	        });
	        // TODO: Optimize this behavior to either (a) store flag to skip resolving where possible and / or
	        // (b) store unresolved paths on JSON parse
	        var serverValues = this.generateServerValues();
	        var newNodeUnresolved = nodeFromJSON$1(newVal, newPriority);
	        var existing = this.serverSyncTree_.calcCompleteEventCache(path);
	        var newNode = resolveDeferredValueSnapshot(newNodeUnresolved, existing, serverValues);
	        var writeId = this.getNextWriteId_();
	        var events = this.serverSyncTree_.applyUserOverwrite(path, newNode, writeId, true);
	        this.eventQueue_.queueEvents(events);
	        this.server_.put(path.toString(), newNodeUnresolved.val(/*export=*/ true), function (status, errorReason) {
	            var success = status === 'ok';
	            if (!success) {
	                warn('set at ' + path + ' failed: ' + status);
	            }
	            var clearEvents = _this.serverSyncTree_.ackUserWrite(writeId, !success);
	            _this.eventQueue_.raiseEventsForChangedPath(path, clearEvents);
	            _this.callOnCompleteCallback(onComplete, status, errorReason);
	        });
	        var affectedPath = this.abortTransactions_(path);
	        this.rerunTransactions_(affectedPath);
	        // We queued the events above, so just flush the queue here
	        this.eventQueue_.raiseEventsForChangedPath(affectedPath, []);
	    };
	    Repo.prototype.update = function (path, childrenToMerge, onComplete) {
	        var _this = this;
	        this.log_('update', { path: path.toString(), value: childrenToMerge });
	        // Start with our existing data and merge each child into it.
	        var empty = true;
	        var serverValues = this.generateServerValues();
	        var changedChildren = {};
	        each(childrenToMerge, function (changedKey, changedValue) {
	            empty = false;
	            changedChildren[changedKey] = resolveDeferredValueTree(path.child(changedKey), nodeFromJSON$1(changedValue), _this.serverSyncTree_, serverValues);
	        });
	        if (!empty) {
	            var writeId_1 = this.getNextWriteId_();
	            var events = this.serverSyncTree_.applyUserMerge(path, changedChildren, writeId_1);
	            this.eventQueue_.queueEvents(events);
	            this.server_.merge(path.toString(), childrenToMerge, function (status, errorReason) {
	                var success = status === 'ok';
	                if (!success) {
	                    warn('update at ' + path + ' failed: ' + status);
	                }
	                var clearEvents = _this.serverSyncTree_.ackUserWrite(writeId_1, !success);
	                var affectedPath = clearEvents.length > 0 ? _this.rerunTransactions_(path) : path;
	                _this.eventQueue_.raiseEventsForChangedPath(affectedPath, clearEvents);
	                _this.callOnCompleteCallback(onComplete, status, errorReason);
	            });
	            each(childrenToMerge, function (changedPath) {
	                var affectedPath = _this.abortTransactions_(path.child(changedPath));
	                _this.rerunTransactions_(affectedPath);
	            });
	            // We queued the events above, so just flush the queue here
	            this.eventQueue_.raiseEventsForChangedPath(path, []);
	        }
	        else {
	            log("update() called with empty data.  Don't do anything.");
	            this.callOnCompleteCallback(onComplete, 'ok');
	        }
	    };
	    /**
	     * Applies all of the changes stored up in the onDisconnect_ tree.
	     */
	    Repo.prototype.runOnDisconnectEvents_ = function () {
	        var _this = this;
	        this.log_('onDisconnectEvents');
	        var serverValues = this.generateServerValues();
	        var resolvedOnDisconnectTree = new SparseSnapshotTree();
	        this.onDisconnect_.forEachTree(Path.Empty, function (path, node) {
	            var resolved = resolveDeferredValueTree(path, node, _this.serverSyncTree_, serverValues);
	            resolvedOnDisconnectTree.remember(path, resolved);
	        });
	        var events = [];
	        resolvedOnDisconnectTree.forEachTree(Path.Empty, function (path, snap) {
	            events = events.concat(_this.serverSyncTree_.applyServerOverwrite(path, snap));
	            var affectedPath = _this.abortTransactions_(path);
	            _this.rerunTransactions_(affectedPath);
	        });
	        this.onDisconnect_ = new SparseSnapshotTree();
	        this.eventQueue_.raiseEventsForChangedPath(Path.Empty, events);
	    };
	    Repo.prototype.onDisconnectCancel = function (path, onComplete) {
	        var _this = this;
	        this.server_.onDisconnectCancel(path.toString(), function (status, errorReason) {
	            if (status === 'ok') {
	                _this.onDisconnect_.forget(path);
	            }
	            _this.callOnCompleteCallback(onComplete, status, errorReason);
	        });
	    };
	    Repo.prototype.onDisconnectSet = function (path, value, onComplete) {
	        var _this = this;
	        var newNode = nodeFromJSON$1(value);
	        this.server_.onDisconnectPut(path.toString(), newNode.val(/*export=*/ true), function (status, errorReason) {
	            if (status === 'ok') {
	                _this.onDisconnect_.remember(path, newNode);
	            }
	            _this.callOnCompleteCallback(onComplete, status, errorReason);
	        });
	    };
	    Repo.prototype.onDisconnectSetWithPriority = function (path, value, priority, onComplete) {
	        var _this = this;
	        var newNode = nodeFromJSON$1(value, priority);
	        this.server_.onDisconnectPut(path.toString(), newNode.val(/*export=*/ true), function (status, errorReason) {
	            if (status === 'ok') {
	                _this.onDisconnect_.remember(path, newNode);
	            }
	            _this.callOnCompleteCallback(onComplete, status, errorReason);
	        });
	    };
	    Repo.prototype.onDisconnectUpdate = function (path, childrenToMerge, onComplete) {
	        var _this = this;
	        if (util.isEmpty(childrenToMerge)) {
	            log("onDisconnect().update() called with empty data.  Don't do anything.");
	            this.callOnCompleteCallback(onComplete, 'ok');
	            return;
	        }
	        this.server_.onDisconnectMerge(path.toString(), childrenToMerge, function (status, errorReason) {
	            if (status === 'ok') {
	                each(childrenToMerge, function (childName, childNode) {
	                    var newChildNode = nodeFromJSON$1(childNode);
	                    _this.onDisconnect_.remember(path.child(childName), newChildNode);
	                });
	            }
	            _this.callOnCompleteCallback(onComplete, status, errorReason);
	        });
	    };
	    Repo.prototype.addEventCallbackForQuery = function (query, eventRegistration) {
	        var events;
	        if (query.path.getFront() === '.info') {
	            events = this.infoSyncTree_.addEventRegistration(query, eventRegistration);
	        }
	        else {
	            events = this.serverSyncTree_.addEventRegistration(query, eventRegistration);
	        }
	        this.eventQueue_.raiseEventsAtPath(query.path, events);
	    };
	    Repo.prototype.removeEventCallbackForQuery = function (query, eventRegistration) {
	        // These are guaranteed not to raise events, since we're not passing in a cancelError. However, we can future-proof
	        // a little bit by handling the return values anyways.
	        var events;
	        if (query.path.getFront() === '.info') {
	            events = this.infoSyncTree_.removeEventRegistration(query, eventRegistration);
	        }
	        else {
	            events = this.serverSyncTree_.removeEventRegistration(query, eventRegistration);
	        }
	        this.eventQueue_.raiseEventsAtPath(query.path, events);
	    };
	    Repo.prototype.interrupt = function () {
	        if (this.persistentConnection_) {
	            this.persistentConnection_.interrupt(INTERRUPT_REASON);
	        }
	    };
	    Repo.prototype.resume = function () {
	        if (this.persistentConnection_) {
	            this.persistentConnection_.resume(INTERRUPT_REASON);
	        }
	    };
	    Repo.prototype.stats = function (showDelta) {
	        if (showDelta === void 0) { showDelta = false; }
	        if (typeof console === 'undefined') {
	            return;
	        }
	        var stats;
	        if (showDelta) {
	            if (!this.statsListener_) {
	                this.statsListener_ = new StatsListener(this.stats_);
	            }
	            stats = this.statsListener_.get();
	        }
	        else {
	            stats = this.stats_.get();
	        }
	        var longestName = Object.keys(stats).reduce(function (previousValue, currentValue) {
	            return Math.max(currentValue.length, previousValue);
	        }, 0);
	        each(stats, function (stat, value) {
	            var paddedStat = stat;
	            // pad stat names to be the same length (plus 2 extra spaces).
	            for (var i = stat.length; i < longestName + 2; i++) {
	                paddedStat += ' ';
	            }
	            console.log(paddedStat + value);
	        });
	    };
	    Repo.prototype.statsIncrementCounter = function (metric) {
	        this.stats_.incrementCounter(metric);
	        this.statsReporter_.includeStat(metric);
	    };
	    Repo.prototype.log_ = function () {
	        var varArgs = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            varArgs[_i] = arguments[_i];
	        }
	        var prefix = '';
	        if (this.persistentConnection_) {
	            prefix = this.persistentConnection_.id + ':';
	        }
	        log.apply(void 0, tslib.__spread([prefix], varArgs));
	    };
	    Repo.prototype.callOnCompleteCallback = function (callback, status, errorReason) {
	        if (callback) {
	            exceptionGuard(function () {
	                if (status === 'ok') {
	                    callback(null);
	                }
	                else {
	                    var code = (status || 'error').toUpperCase();
	                    var message = code;
	                    if (errorReason) {
	                        message += ': ' + errorReason;
	                    }
	                    var error = new Error(message);
	                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	                    error.code = code;
	                    callback(error);
	                }
	            });
	        }
	    };
	    Object.defineProperty(Repo.prototype, "database", {
	        get: function () {
	            return this.__database || (this.__database = new Database(this));
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return Repo;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Filters nodes by range and uses an IndexFilter to track any changes after filtering the node
	 *
	 * @constructor
	 * @implements {NodeFilter}
	 */
	var RangedFilter = /** @class */ (function () {
	    /**
	     * @param {!QueryParams} params
	     */
	    function RangedFilter(params) {
	        this.indexedFilter_ = new IndexedFilter(params.getIndex());
	        this.index_ = params.getIndex();
	        this.startPost_ = RangedFilter.getStartPost_(params);
	        this.endPost_ = RangedFilter.getEndPost_(params);
	    }
	    /**
	     * @return {!NamedNode}
	     */
	    RangedFilter.prototype.getStartPost = function () {
	        return this.startPost_;
	    };
	    /**
	     * @return {!NamedNode}
	     */
	    RangedFilter.prototype.getEndPost = function () {
	        return this.endPost_;
	    };
	    /**
	     * @param {!NamedNode} node
	     * @return {boolean}
	     */
	    RangedFilter.prototype.matches = function (node) {
	        return (this.index_.compare(this.getStartPost(), node) <= 0 &&
	            this.index_.compare(node, this.getEndPost()) <= 0);
	    };
	    /**
	     * @inheritDoc
	     */
	    RangedFilter.prototype.updateChild = function (snap, key, newChild, affectedPath, source, optChangeAccumulator) {
	        if (!this.matches(new NamedNode(key, newChild))) {
	            newChild = ChildrenNode.EMPTY_NODE;
	        }
	        return this.indexedFilter_.updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator);
	    };
	    /**
	     * @inheritDoc
	     */
	    RangedFilter.prototype.updateFullNode = function (oldSnap, newSnap, optChangeAccumulator) {
	        if (newSnap.isLeafNode()) {
	            // Make sure we have a children node with the correct index, not a leaf node;
	            newSnap = ChildrenNode.EMPTY_NODE;
	        }
	        var filtered = newSnap.withIndex(this.index_);
	        // Don't support priorities on queries
	        filtered = filtered.updatePriority(ChildrenNode.EMPTY_NODE);
	        var self = this;
	        newSnap.forEachChild(PRIORITY_INDEX, function (key, childNode) {
	            if (!self.matches(new NamedNode(key, childNode))) {
	                filtered = filtered.updateImmediateChild(key, ChildrenNode.EMPTY_NODE);
	            }
	        });
	        return this.indexedFilter_.updateFullNode(oldSnap, filtered, optChangeAccumulator);
	    };
	    /**
	     * @inheritDoc
	     */
	    RangedFilter.prototype.updatePriority = function (oldSnap, newPriority) {
	        // Don't support priorities on queries
	        return oldSnap;
	    };
	    /**
	     * @inheritDoc
	     */
	    RangedFilter.prototype.filtersNodes = function () {
	        return true;
	    };
	    /**
	     * @inheritDoc
	     */
	    RangedFilter.prototype.getIndexedFilter = function () {
	        return this.indexedFilter_;
	    };
	    /**
	     * @inheritDoc
	     */
	    RangedFilter.prototype.getIndex = function () {
	        return this.index_;
	    };
	    /**
	     * @param {!QueryParams} params
	     * @return {!NamedNode}
	     * @private
	     */
	    RangedFilter.getStartPost_ = function (params) {
	        if (params.hasStart()) {
	            var startName = params.getIndexStartName();
	            return params.getIndex().makePost(params.getIndexStartValue(), startName);
	        }
	        else {
	            return params.getIndex().minPost();
	        }
	    };
	    /**
	     * @param {!QueryParams} params
	     * @return {!NamedNode}
	     * @private
	     */
	    RangedFilter.getEndPost_ = function (params) {
	        if (params.hasEnd()) {
	            var endName = params.getIndexEndName();
	            return params.getIndex().makePost(params.getIndexEndValue(), endName);
	        }
	        else {
	            return params.getIndex().maxPost();
	        }
	    };
	    return RangedFilter;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Applies a limit and a range to a node and uses RangedFilter to do the heavy lifting where possible
	 *
	 * @constructor
	 * @implements {NodeFilter}
	 */
	var LimitedFilter = /** @class */ (function () {
	    /**
	     * @param {!QueryParams} params
	     */
	    function LimitedFilter(params) {
	        this.rangedFilter_ = new RangedFilter(params);
	        this.index_ = params.getIndex();
	        this.limit_ = params.getLimit();
	        this.reverse_ = !params.isViewFromLeft();
	    }
	    /**
	     * @inheritDoc
	     */
	    LimitedFilter.prototype.updateChild = function (snap, key, newChild, affectedPath, source, optChangeAccumulator) {
	        if (!this.rangedFilter_.matches(new NamedNode(key, newChild))) {
	            newChild = ChildrenNode.EMPTY_NODE;
	        }
	        if (snap.getImmediateChild(key).equals(newChild)) {
	            // No change
	            return snap;
	        }
	        else if (snap.numChildren() < this.limit_) {
	            return this.rangedFilter_
	                .getIndexedFilter()
	                .updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator);
	        }
	        else {
	            return this.fullLimitUpdateChild_(snap, key, newChild, source, optChangeAccumulator);
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    LimitedFilter.prototype.updateFullNode = function (oldSnap, newSnap, optChangeAccumulator) {
	        var filtered;
	        if (newSnap.isLeafNode() || newSnap.isEmpty()) {
	            // Make sure we have a children node with the correct index, not a leaf node;
	            filtered = ChildrenNode.EMPTY_NODE.withIndex(this.index_);
	        }
	        else {
	            if (this.limit_ * 2 < newSnap.numChildren() &&
	                newSnap.isIndexed(this.index_)) {
	                // Easier to build up a snapshot, since what we're given has more than twice the elements we want
	                filtered = ChildrenNode.EMPTY_NODE.withIndex(this.index_);
	                // anchor to the startPost, endPost, or last element as appropriate
	                var iterator = void 0;
	                if (this.reverse_) {
	                    iterator = newSnap.getReverseIteratorFrom(this.rangedFilter_.getEndPost(), this.index_);
	                }
	                else {
	                    iterator = newSnap.getIteratorFrom(this.rangedFilter_.getStartPost(), this.index_);
	                }
	                var count = 0;
	                while (iterator.hasNext() && count < this.limit_) {
	                    var next = iterator.getNext();
	                    var inRange = void 0;
	                    if (this.reverse_) {
	                        inRange =
	                            this.index_.compare(this.rangedFilter_.getStartPost(), next) <= 0;
	                    }
	                    else {
	                        inRange =
	                            this.index_.compare(next, this.rangedFilter_.getEndPost()) <= 0;
	                    }
	                    if (inRange) {
	                        filtered = filtered.updateImmediateChild(next.name, next.node);
	                        count++;
	                    }
	                    else {
	                        // if we have reached the end post, we cannot keep adding elemments
	                        break;
	                    }
	                }
	            }
	            else {
	                // The snap contains less than twice the limit. Faster to delete from the snap than build up a new one
	                filtered = newSnap.withIndex(this.index_);
	                // Don't support priorities on queries
	                filtered = filtered.updatePriority(ChildrenNode.EMPTY_NODE);
	                var startPost = void 0;
	                var endPost = void 0;
	                var cmp = void 0;
	                var iterator = void 0;
	                if (this.reverse_) {
	                    iterator = filtered.getReverseIterator(this.index_);
	                    startPost = this.rangedFilter_.getEndPost();
	                    endPost = this.rangedFilter_.getStartPost();
	                    var indexCompare_1 = this.index_.getCompare();
	                    cmp = function (a, b) { return indexCompare_1(b, a); };
	                }
	                else {
	                    iterator = filtered.getIterator(this.index_);
	                    startPost = this.rangedFilter_.getStartPost();
	                    endPost = this.rangedFilter_.getEndPost();
	                    cmp = this.index_.getCompare();
	                }
	                var count = 0;
	                var foundStartPost = false;
	                while (iterator.hasNext()) {
	                    var next = iterator.getNext();
	                    if (!foundStartPost && cmp(startPost, next) <= 0) {
	                        // start adding
	                        foundStartPost = true;
	                    }
	                    var inRange = foundStartPost && count < this.limit_ && cmp(next, endPost) <= 0;
	                    if (inRange) {
	                        count++;
	                    }
	                    else {
	                        filtered = filtered.updateImmediateChild(next.name, ChildrenNode.EMPTY_NODE);
	                    }
	                }
	            }
	        }
	        return this.rangedFilter_
	            .getIndexedFilter()
	            .updateFullNode(oldSnap, filtered, optChangeAccumulator);
	    };
	    /**
	     * @inheritDoc
	     */
	    LimitedFilter.prototype.updatePriority = function (oldSnap, newPriority) {
	        // Don't support priorities on queries
	        return oldSnap;
	    };
	    /**
	     * @inheritDoc
	     */
	    LimitedFilter.prototype.filtersNodes = function () {
	        return true;
	    };
	    /**
	     * @inheritDoc
	     */
	    LimitedFilter.prototype.getIndexedFilter = function () {
	        return this.rangedFilter_.getIndexedFilter();
	    };
	    /**
	     * @inheritDoc
	     */
	    LimitedFilter.prototype.getIndex = function () {
	        return this.index_;
	    };
	    /**
	     * @param {!Node} snap
	     * @param {string} childKey
	     * @param {!Node} childSnap
	     * @param {!CompleteChildSource} source
	     * @param {?ChildChangeAccumulator} changeAccumulator
	     * @return {!Node}
	     * @private
	     */
	    LimitedFilter.prototype.fullLimitUpdateChild_ = function (snap, childKey, childSnap, source, changeAccumulator) {
	        // TODO: rename all cache stuff etc to general snap terminology
	        var cmp;
	        if (this.reverse_) {
	            var indexCmp_1 = this.index_.getCompare();
	            cmp = function (a, b) { return indexCmp_1(b, a); };
	        }
	        else {
	            cmp = this.index_.getCompare();
	        }
	        var oldEventCache = snap;
	        util.assert(oldEventCache.numChildren() === this.limit_, '');
	        var newChildNamedNode = new NamedNode(childKey, childSnap);
	        var windowBoundary = this.reverse_
	            ? oldEventCache.getFirstChild(this.index_)
	            : oldEventCache.getLastChild(this.index_);
	        var inRange = this.rangedFilter_.matches(newChildNamedNode);
	        if (oldEventCache.hasChild(childKey)) {
	            var oldChildSnap = oldEventCache.getImmediateChild(childKey);
	            var nextChild = source.getChildAfterChild(this.index_, windowBoundary, this.reverse_);
	            while (nextChild != null &&
	                (nextChild.name === childKey || oldEventCache.hasChild(nextChild.name))) {
	                // There is a weird edge case where a node is updated as part of a merge in the write tree, but hasn't
	                // been applied to the limited filter yet. Ignore this next child which will be updated later in
	                // the limited filter...
	                nextChild = source.getChildAfterChild(this.index_, nextChild, this.reverse_);
	            }
	            var compareNext = nextChild == null ? 1 : cmp(nextChild, newChildNamedNode);
	            var remainsInWindow = inRange && !childSnap.isEmpty() && compareNext >= 0;
	            if (remainsInWindow) {
	                if (changeAccumulator != null) {
	                    changeAccumulator.trackChildChange(Change.childChangedChange(childKey, childSnap, oldChildSnap));
	                }
	                return oldEventCache.updateImmediateChild(childKey, childSnap);
	            }
	            else {
	                if (changeAccumulator != null) {
	                    changeAccumulator.trackChildChange(Change.childRemovedChange(childKey, oldChildSnap));
	                }
	                var newEventCache = oldEventCache.updateImmediateChild(childKey, ChildrenNode.EMPTY_NODE);
	                var nextChildInRange = nextChild != null && this.rangedFilter_.matches(nextChild);
	                if (nextChildInRange) {
	                    if (changeAccumulator != null) {
	                        changeAccumulator.trackChildChange(Change.childAddedChange(nextChild.name, nextChild.node));
	                    }
	                    return newEventCache.updateImmediateChild(nextChild.name, nextChild.node);
	                }
	                else {
	                    return newEventCache;
	                }
	            }
	        }
	        else if (childSnap.isEmpty()) {
	            // we're deleting a node, but it was not in the window, so ignore it
	            return snap;
	        }
	        else if (inRange) {
	            if (cmp(windowBoundary, newChildNamedNode) >= 0) {
	                if (changeAccumulator != null) {
	                    changeAccumulator.trackChildChange(Change.childRemovedChange(windowBoundary.name, windowBoundary.node));
	                    changeAccumulator.trackChildChange(Change.childAddedChange(childKey, childSnap));
	                }
	                return oldEventCache
	                    .updateImmediateChild(childKey, childSnap)
	                    .updateImmediateChild(windowBoundary.name, ChildrenNode.EMPTY_NODE);
	            }
	            else {
	                return snap;
	            }
	        }
	        else {
	            return snap;
	        }
	    };
	    return LimitedFilter;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * This class is an immutable-from-the-public-api struct containing a set of query parameters defining a
	 * range to be returned for a particular location. It is assumed that validation of parameters is done at the
	 * user-facing API level, so it is not done here.
	 * @constructor
	 */
	var QueryParams = /** @class */ (function () {
	    function QueryParams() {
	        this.limitSet_ = false;
	        this.startSet_ = false;
	        this.startNameSet_ = false;
	        this.endSet_ = false;
	        this.endNameSet_ = false;
	        this.limit_ = 0;
	        this.viewFrom_ = '';
	        this.indexStartValue_ = null;
	        this.indexStartName_ = '';
	        this.indexEndValue_ = null;
	        this.indexEndName_ = '';
	        this.index_ = PRIORITY_INDEX;
	    }
	    /**
	     * @return {boolean}
	     */
	    QueryParams.prototype.hasStart = function () {
	        return this.startSet_;
	    };
	    /**
	     * @return {boolean} True if it would return from left.
	     */
	    QueryParams.prototype.isViewFromLeft = function () {
	        if (this.viewFrom_ === '') {
	            // limit(), rather than limitToFirst or limitToLast was called.
	            // This means that only one of startSet_ and endSet_ is true. Use them
	            // to calculate which side of the view to anchor to. If neither is set,
	            // anchor to the end.
	            return this.startSet_;
	        }
	        else {
	            return (this.viewFrom_ === QueryParams.WIRE_PROTOCOL_CONSTANTS_.VIEW_FROM_LEFT);
	        }
	    };
	    /**
	     * Only valid to call if hasStart() returns true
	     * @return {*}
	     */
	    QueryParams.prototype.getIndexStartValue = function () {
	        util.assert(this.startSet_, 'Only valid if start has been set');
	        return this.indexStartValue_;
	    };
	    /**
	     * Only valid to call if hasStart() returns true.
	     * Returns the starting key name for the range defined by these query parameters
	     * @return {!string}
	     */
	    QueryParams.prototype.getIndexStartName = function () {
	        util.assert(this.startSet_, 'Only valid if start has been set');
	        if (this.startNameSet_) {
	            return this.indexStartName_;
	        }
	        else {
	            return MIN_NAME;
	        }
	    };
	    /**
	     * @return {boolean}
	     */
	    QueryParams.prototype.hasEnd = function () {
	        return this.endSet_;
	    };
	    /**
	     * Only valid to call if hasEnd() returns true.
	     * @return {*}
	     */
	    QueryParams.prototype.getIndexEndValue = function () {
	        util.assert(this.endSet_, 'Only valid if end has been set');
	        return this.indexEndValue_;
	    };
	    /**
	     * Only valid to call if hasEnd() returns true.
	     * Returns the end key name for the range defined by these query parameters
	     * @return {!string}
	     */
	    QueryParams.prototype.getIndexEndName = function () {
	        util.assert(this.endSet_, 'Only valid if end has been set');
	        if (this.endNameSet_) {
	            return this.indexEndName_;
	        }
	        else {
	            return MAX_NAME;
	        }
	    };
	    /**
	     * @return {boolean}
	     */
	    QueryParams.prototype.hasLimit = function () {
	        return this.limitSet_;
	    };
	    /**
	     * @return {boolean} True if a limit has been set and it has been explicitly anchored
	     */
	    QueryParams.prototype.hasAnchoredLimit = function () {
	        return this.limitSet_ && this.viewFrom_ !== '';
	    };
	    /**
	     * Only valid to call if hasLimit() returns true
	     * @return {!number}
	     */
	    QueryParams.prototype.getLimit = function () {
	        util.assert(this.limitSet_, 'Only valid if limit has been set');
	        return this.limit_;
	    };
	    /**
	     * @return {!Index}
	     */
	    QueryParams.prototype.getIndex = function () {
	        return this.index_;
	    };
	    /**
	     * @return {!QueryParams}
	     * @private
	     */
	    QueryParams.prototype.copy_ = function () {
	        var copy = new QueryParams();
	        copy.limitSet_ = this.limitSet_;
	        copy.limit_ = this.limit_;
	        copy.startSet_ = this.startSet_;
	        copy.indexStartValue_ = this.indexStartValue_;
	        copy.startNameSet_ = this.startNameSet_;
	        copy.indexStartName_ = this.indexStartName_;
	        copy.endSet_ = this.endSet_;
	        copy.indexEndValue_ = this.indexEndValue_;
	        copy.endNameSet_ = this.endNameSet_;
	        copy.indexEndName_ = this.indexEndName_;
	        copy.index_ = this.index_;
	        copy.viewFrom_ = this.viewFrom_;
	        return copy;
	    };
	    /**
	     * @param {!number} newLimit
	     * @return {!QueryParams}
	     */
	    QueryParams.prototype.limit = function (newLimit) {
	        var newParams = this.copy_();
	        newParams.limitSet_ = true;
	        newParams.limit_ = newLimit;
	        newParams.viewFrom_ = '';
	        return newParams;
	    };
	    /**
	     * @param {!number} newLimit
	     * @return {!QueryParams}
	     */
	    QueryParams.prototype.limitToFirst = function (newLimit) {
	        var newParams = this.copy_();
	        newParams.limitSet_ = true;
	        newParams.limit_ = newLimit;
	        newParams.viewFrom_ = QueryParams.WIRE_PROTOCOL_CONSTANTS_.VIEW_FROM_LEFT;
	        return newParams;
	    };
	    /**
	     * @param {!number} newLimit
	     * @return {!QueryParams}
	     */
	    QueryParams.prototype.limitToLast = function (newLimit) {
	        var newParams = this.copy_();
	        newParams.limitSet_ = true;
	        newParams.limit_ = newLimit;
	        newParams.viewFrom_ = QueryParams.WIRE_PROTOCOL_CONSTANTS_.VIEW_FROM_RIGHT;
	        return newParams;
	    };
	    /**
	     * @param {*} indexValue
	     * @param {?string=} key
	     * @return {!QueryParams}
	     */
	    QueryParams.prototype.startAt = function (indexValue, key) {
	        var newParams = this.copy_();
	        newParams.startSet_ = true;
	        if (indexValue === undefined) {
	            indexValue = null;
	        }
	        newParams.indexStartValue_ = indexValue;
	        if (key != null) {
	            newParams.startNameSet_ = true;
	            newParams.indexStartName_ = key;
	        }
	        else {
	            newParams.startNameSet_ = false;
	            newParams.indexStartName_ = '';
	        }
	        return newParams;
	    };
	    /**
	     * @param {*} indexValue
	     * @param {?string=} key
	     * @return {!QueryParams}
	     */
	    QueryParams.prototype.endAt = function (indexValue, key) {
	        var newParams = this.copy_();
	        newParams.endSet_ = true;
	        if (indexValue === undefined) {
	            indexValue = null;
	        }
	        newParams.indexEndValue_ = indexValue;
	        if (key !== undefined) {
	            newParams.endNameSet_ = true;
	            newParams.indexEndName_ = key;
	        }
	        else {
	            newParams.endNameSet_ = false;
	            newParams.indexEndName_ = '';
	        }
	        return newParams;
	    };
	    /**
	     * @param {!Index} index
	     * @return {!QueryParams}
	     */
	    QueryParams.prototype.orderBy = function (index) {
	        var newParams = this.copy_();
	        newParams.index_ = index;
	        return newParams;
	    };
	    /**
	     * @return {!Object}
	     */
	    QueryParams.prototype.getQueryObject = function () {
	        var WIRE_PROTOCOL_CONSTANTS = QueryParams.WIRE_PROTOCOL_CONSTANTS_;
	        var obj = {};
	        if (this.startSet_) {
	            obj[WIRE_PROTOCOL_CONSTANTS.INDEX_START_VALUE] = this.indexStartValue_;
	            if (this.startNameSet_) {
	                obj[WIRE_PROTOCOL_CONSTANTS.INDEX_START_NAME] = this.indexStartName_;
	            }
	        }
	        if (this.endSet_) {
	            obj[WIRE_PROTOCOL_CONSTANTS.INDEX_END_VALUE] = this.indexEndValue_;
	            if (this.endNameSet_) {
	                obj[WIRE_PROTOCOL_CONSTANTS.INDEX_END_NAME] = this.indexEndName_;
	            }
	        }
	        if (this.limitSet_) {
	            obj[WIRE_PROTOCOL_CONSTANTS.LIMIT] = this.limit_;
	            var viewFrom = this.viewFrom_;
	            if (viewFrom === '') {
	                if (this.isViewFromLeft()) {
	                    viewFrom = WIRE_PROTOCOL_CONSTANTS.VIEW_FROM_LEFT;
	                }
	                else {
	                    viewFrom = WIRE_PROTOCOL_CONSTANTS.VIEW_FROM_RIGHT;
	                }
	            }
	            obj[WIRE_PROTOCOL_CONSTANTS.VIEW_FROM] = viewFrom;
	        }
	        // For now, priority index is the default, so we only specify if it's some other index
	        if (this.index_ !== PRIORITY_INDEX) {
	            obj[WIRE_PROTOCOL_CONSTANTS.INDEX] = this.index_.toString();
	        }
	        return obj;
	    };
	    /**
	     * @return {boolean}
	     */
	    QueryParams.prototype.loadsAllData = function () {
	        return !(this.startSet_ || this.endSet_ || this.limitSet_);
	    };
	    /**
	     * @return {boolean}
	     */
	    QueryParams.prototype.isDefault = function () {
	        return this.loadsAllData() && this.index_ === PRIORITY_INDEX;
	    };
	    /**
	     * @return {!NodeFilter}
	     */
	    QueryParams.prototype.getNodeFilter = function () {
	        if (this.loadsAllData()) {
	            return new IndexedFilter(this.getIndex());
	        }
	        else if (this.hasLimit()) {
	            return new LimitedFilter(this);
	        }
	        else {
	            return new RangedFilter(this);
	        }
	    };
	    /**
	     * Returns a set of REST query string parameters representing this query.
	     *
	     * @return {!Object.<string,*>} query string parameters
	     */
	    QueryParams.prototype.toRestQueryStringParameters = function () {
	        var REST_CONSTANTS = QueryParams.REST_QUERY_CONSTANTS_;
	        var qs = {};
	        if (this.isDefault()) {
	            return qs;
	        }
	        var orderBy;
	        if (this.index_ === PRIORITY_INDEX) {
	            orderBy = REST_CONSTANTS.PRIORITY_INDEX;
	        }
	        else if (this.index_ === VALUE_INDEX) {
	            orderBy = REST_CONSTANTS.VALUE_INDEX;
	        }
	        else if (this.index_ === KEY_INDEX) {
	            orderBy = REST_CONSTANTS.KEY_INDEX;
	        }
	        else {
	            util.assert(this.index_ instanceof PathIndex, 'Unrecognized index type!');
	            orderBy = this.index_.toString();
	        }
	        qs[REST_CONSTANTS.ORDER_BY] = util.stringify(orderBy);
	        if (this.startSet_) {
	            qs[REST_CONSTANTS.START_AT] = util.stringify(this.indexStartValue_);
	            if (this.startNameSet_) {
	                qs[REST_CONSTANTS.START_AT] += ',' + util.stringify(this.indexStartName_);
	            }
	        }
	        if (this.endSet_) {
	            qs[REST_CONSTANTS.END_AT] = util.stringify(this.indexEndValue_);
	            if (this.endNameSet_) {
	                qs[REST_CONSTANTS.END_AT] += ',' + util.stringify(this.indexEndName_);
	            }
	        }
	        if (this.limitSet_) {
	            if (this.isViewFromLeft()) {
	                qs[REST_CONSTANTS.LIMIT_TO_FIRST] = this.limit_;
	            }
	            else {
	                qs[REST_CONSTANTS.LIMIT_TO_LAST] = this.limit_;
	            }
	        }
	        return qs;
	    };
	    /**
	     * Wire Protocol Constants
	     * @const
	     * @enum {string}
	     * @private
	     */
	    QueryParams.WIRE_PROTOCOL_CONSTANTS_ = {
	        INDEX_START_VALUE: 'sp',
	        INDEX_START_NAME: 'sn',
	        INDEX_END_VALUE: 'ep',
	        INDEX_END_NAME: 'en',
	        LIMIT: 'l',
	        VIEW_FROM: 'vf',
	        VIEW_FROM_LEFT: 'l',
	        VIEW_FROM_RIGHT: 'r',
	        INDEX: 'i'
	    };
	    /**
	     * REST Query Constants
	     * @const
	     * @enum {string}
	     * @private
	     */
	    QueryParams.REST_QUERY_CONSTANTS_ = {
	        ORDER_BY: 'orderBy',
	        PRIORITY_INDEX: '$priority',
	        VALUE_INDEX: '$value',
	        KEY_INDEX: '$key',
	        START_AT: 'startAt',
	        END_AT: 'endAt',
	        LIMIT_TO_FIRST: 'limitToFirst',
	        LIMIT_TO_LAST: 'limitToLast'
	    };
	    /**
	     * Default, empty query parameters
	     * @type {!QueryParams}
	     * @const
	     */
	    QueryParams.DEFAULT = new QueryParams();
	    return QueryParams;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var Reference = /** @class */ (function (_super) {
	    tslib.__extends(Reference, _super);
	    /**
	     * Call options:
	     *   new Reference(Repo, Path) or
	     *   new Reference(url: string, string|RepoManager)
	     *
	     * Externally - this is the firebase.database.Reference type.
	     *
	     * @param {!Repo} repo
	     * @param {(!Path)} path
	     * @extends {Query}
	     */
	    function Reference(repo, path) {
	        var _this = this;
	        if (!(repo instanceof Repo)) {
	            throw new Error('new Reference() no longer supported - use app.database().');
	        }
	        // call Query's constructor, passing in the repo and path.
	        _this = _super.call(this, repo, path, QueryParams.DEFAULT, false) || this;
	        return _this;
	    }
	    /** @return {?string} */
	    Reference.prototype.getKey = function () {
	        util.validateArgCount('Reference.key', 0, 0, arguments.length);
	        if (this.path.isEmpty()) {
	            return null;
	        }
	        else {
	            return this.path.getBack();
	        }
	    };
	    /**
	     * @param {!(string|Path)} pathString
	     * @return {!Reference}
	     */
	    Reference.prototype.child = function (pathString) {
	        util.validateArgCount('Reference.child', 1, 1, arguments.length);
	        if (typeof pathString === 'number') {
	            pathString = String(pathString);
	        }
	        else if (!(pathString instanceof Path)) {
	            if (this.path.getFront() === null) {
	                validateRootPathString('Reference.child', 1, pathString, false);
	            }
	            else {
	                validatePathString('Reference.child', 1, pathString, false);
	            }
	        }
	        return new Reference(this.repo, this.path.child(pathString));
	    };
	    /** @return {?Reference} */
	    Reference.prototype.getParent = function () {
	        util.validateArgCount('Reference.parent', 0, 0, arguments.length);
	        var parentPath = this.path.parent();
	        return parentPath === null ? null : new Reference(this.repo, parentPath);
	    };
	    /** @return {!Reference} */
	    Reference.prototype.getRoot = function () {
	        util.validateArgCount('Reference.root', 0, 0, arguments.length);
	        var ref = this;
	        while (ref.getParent() !== null) {
	            ref = ref.getParent();
	        }
	        return ref;
	    };
	    /** @return {!Database} */
	    Reference.prototype.databaseProp = function () {
	        return this.repo.database;
	    };
	    /**
	     * @param {*} newVal
	     * @param {function(?Error)=} onComplete
	     * @return {!Promise}
	     */
	    Reference.prototype.set = function (newVal, onComplete) {
	        util.validateArgCount('Reference.set', 1, 2, arguments.length);
	        validateWritablePath('Reference.set', this.path);
	        validateFirebaseDataArg('Reference.set', 1, newVal, this.path, false);
	        util.validateCallback('Reference.set', 2, onComplete, true);
	        var deferred = new util.Deferred();
	        this.repo.setWithPriority(this.path, newVal, 
	        /*priority=*/ null, deferred.wrapCallback(onComplete));
	        return deferred.promise;
	    };
	    /**
	     * @param {!Object} objectToMerge
	     * @param {function(?Error)=} onComplete
	     * @return {!Promise}
	     */
	    Reference.prototype.update = function (objectToMerge, onComplete) {
	        util.validateArgCount('Reference.update', 1, 2, arguments.length);
	        validateWritablePath('Reference.update', this.path);
	        if (Array.isArray(objectToMerge)) {
	            var newObjectToMerge = {};
	            for (var i = 0; i < objectToMerge.length; ++i) {
	                newObjectToMerge['' + i] = objectToMerge[i];
	            }
	            objectToMerge = newObjectToMerge;
	            warn('Passing an Array to Firebase.update() is deprecated. ' +
	                'Use set() if you want to overwrite the existing data, or ' +
	                'an Object with integer keys if you really do want to ' +
	                'only update some of the children.');
	        }
	        validateFirebaseMergeDataArg('Reference.update', 1, objectToMerge, this.path, false);
	        util.validateCallback('Reference.update', 2, onComplete, true);
	        var deferred = new util.Deferred();
	        this.repo.update(this.path, objectToMerge, deferred.wrapCallback(onComplete));
	        return deferred.promise;
	    };
	    /**
	     * @param {*} newVal
	     * @param {string|number|null} newPriority
	     * @param {function(?Error)=} onComplete
	     * @return {!Promise}
	     */
	    Reference.prototype.setWithPriority = function (newVal, newPriority, onComplete) {
	        util.validateArgCount('Reference.setWithPriority', 2, 3, arguments.length);
	        validateWritablePath('Reference.setWithPriority', this.path);
	        validateFirebaseDataArg('Reference.setWithPriority', 1, newVal, this.path, false);
	        validatePriority('Reference.setWithPriority', 2, newPriority, false);
	        util.validateCallback('Reference.setWithPriority', 3, onComplete, true);
	        if (this.getKey() === '.length' || this.getKey() === '.keys') {
	            throw 'Reference.setWithPriority failed: ' +
	                this.getKey() +
	                ' is a read-only object.';
	        }
	        var deferred = new util.Deferred();
	        this.repo.setWithPriority(this.path, newVal, newPriority, deferred.wrapCallback(onComplete));
	        return deferred.promise;
	    };
	    /**
	     * @param {function(?Error)=} onComplete
	     * @return {!Promise}
	     */
	    Reference.prototype.remove = function (onComplete) {
	        util.validateArgCount('Reference.remove', 0, 1, arguments.length);
	        validateWritablePath('Reference.remove', this.path);
	        util.validateCallback('Reference.remove', 1, onComplete, true);
	        return this.set(null, onComplete);
	    };
	    /**
	     * @param {function(*):*} transactionUpdate
	     * @param {(function(?Error, boolean, ?DataSnapshot))=} onComplete
	     * @param {boolean=} applyLocally
	     * @return {!Promise}
	     */
	    Reference.prototype.transaction = function (transactionUpdate, onComplete, applyLocally) {
	        util.validateArgCount('Reference.transaction', 1, 3, arguments.length);
	        validateWritablePath('Reference.transaction', this.path);
	        util.validateCallback('Reference.transaction', 1, transactionUpdate, false);
	        util.validateCallback('Reference.transaction', 2, onComplete, true);
	        // NOTE: applyLocally is an internal-only option for now.  We need to decide if we want to keep it and how
	        // to expose it.
	        validateBoolean('Reference.transaction', 3, applyLocally, true);
	        if (this.getKey() === '.length' || this.getKey() === '.keys') {
	            throw 'Reference.transaction failed: ' +
	                this.getKey() +
	                ' is a read-only object.';
	        }
	        if (applyLocally === undefined) {
	            applyLocally = true;
	        }
	        var deferred = new util.Deferred();
	        if (typeof onComplete === 'function') {
	            deferred.promise.catch(function () { });
	        }
	        var promiseComplete = function (error, committed, snapshot) {
	            if (error) {
	                deferred.reject(error);
	            }
	            else {
	                deferred.resolve(new TransactionResult(committed, snapshot));
	            }
	            if (typeof onComplete === 'function') {
	                onComplete(error, committed, snapshot);
	            }
	        };
	        this.repo.startTransaction(this.path, transactionUpdate, promiseComplete, applyLocally);
	        return deferred.promise;
	    };
	    /**
	     * @param {string|number|null} priority
	     * @param {function(?Error)=} onComplete
	     * @return {!Promise}
	     */
	    Reference.prototype.setPriority = function (priority, onComplete) {
	        util.validateArgCount('Reference.setPriority', 1, 2, arguments.length);
	        validateWritablePath('Reference.setPriority', this.path);
	        validatePriority('Reference.setPriority', 1, priority, false);
	        util.validateCallback('Reference.setPriority', 2, onComplete, true);
	        var deferred = new util.Deferred();
	        this.repo.setWithPriority(this.path.child('.priority'), priority, null, deferred.wrapCallback(onComplete));
	        return deferred.promise;
	    };
	    /**
	     * @param {*=} value
	     * @param {function(?Error)=} onComplete
	     * @return {!Reference}
	     */
	    Reference.prototype.push = function (value, onComplete) {
	        util.validateArgCount('Reference.push', 0, 2, arguments.length);
	        validateWritablePath('Reference.push', this.path);
	        validateFirebaseDataArg('Reference.push', 1, value, this.path, true);
	        util.validateCallback('Reference.push', 2, onComplete, true);
	        var now = this.repo.serverTime();
	        var name = nextPushId(now);
	        // push() returns a ThennableReference whose promise is fulfilled with a regular Reference.
	        // We use child() to create handles to two different references. The first is turned into a
	        // ThennableReference below by adding then() and catch() methods and is used as the
	        // return value of push(). The second remains a regular Reference and is used as the fulfilled
	        // value of the first ThennableReference.
	        var thennablePushRef = this.child(name);
	        var pushRef = this.child(name);
	        var promise;
	        if (value != null) {
	            promise = thennablePushRef.set(value, onComplete).then(function () { return pushRef; });
	        }
	        else {
	            promise = Promise.resolve(pushRef);
	        }
	        thennablePushRef.then = promise.then.bind(promise);
	        thennablePushRef.catch = promise.then.bind(promise, undefined);
	        if (typeof onComplete === 'function') {
	            promise.catch(function () { });
	        }
	        return thennablePushRef;
	    };
	    /**
	     * @return {!OnDisconnect}
	     */
	    Reference.prototype.onDisconnect = function () {
	        validateWritablePath('Reference.onDisconnect', this.path);
	        return new OnDisconnect(this.repo, this.path);
	    };
	    Object.defineProperty(Reference.prototype, "database", {
	        get: function () {
	            return this.databaseProp();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Reference.prototype, "key", {
	        get: function () {
	            return this.getKey();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Reference.prototype, "parent", {
	        get: function () {
	            return this.getParent();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Reference.prototype, "root", {
	        get: function () {
	            return this.getRoot();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return Reference;
	}(Query));
	/**
	 * Define reference constructor in various modules
	 *
	 * We are doing this here to avoid several circular
	 * dependency issues
	 */
	Query.__referenceConstructor = Reference;
	SyncPoint.__referenceConstructor = Reference;
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Node in a Tree.
	 */
	var TreeNode = /** @class */ (function () {
	    function TreeNode() {
	        // TODO: Consider making accessors that create children and value lazily or
	        // separate Internal / Leaf 'types'.
	        this.children = {};
	        this.childCount = 0;
	        this.value = null;
	    }
	    return TreeNode;
	}());
	/**
	 * A light-weight tree, traversable by path.  Nodes can have both values and children.
	 * Nodes are not enumerated (by forEachChild) unless they have a value or non-empty
	 * children.
	 */
	var Tree = /** @class */ (function () {
	    /**
	     * @template T
	     * @param {string=} name_ Optional name of the node.
	     * @param {Tree=} parent_ Optional parent node.
	     * @param {TreeNode=} node_ Optional node to wrap.
	     */
	    function Tree(name_, parent_, node_) {
	        if (name_ === void 0) { name_ = ''; }
	        if (parent_ === void 0) { parent_ = null; }
	        if (node_ === void 0) { node_ = new TreeNode(); }
	        this.name_ = name_;
	        this.parent_ = parent_;
	        this.node_ = node_;
	    }
	    /**
	     * Returns a sub-Tree for the given path.
	     *
	     * @param {!(string|Path)} pathObj Path to look up.
	     * @return {!Tree.<T>} Tree for path.
	     */
	    Tree.prototype.subTree = function (pathObj) {
	        // TODO: Require pathObj to be Path?
	        var path = pathObj instanceof Path ? pathObj : new Path(pathObj);
	        var child = this, next = path.getFront();
	        while (next !== null) {
	            var childNode = util.safeGet(child.node_.children, next) || new TreeNode();
	            child = new Tree(next, child, childNode);
	            path = path.popFront();
	            next = path.getFront();
	        }
	        return child;
	    };
	    /**
	     * Returns the data associated with this tree node.
	     *
	     * @return {?T} The data or null if no data exists.
	     */
	    Tree.prototype.getValue = function () {
	        return this.node_.value;
	    };
	    /**
	     * Sets data to this tree node.
	     *
	     * @param {!T} value Value to set.
	     */
	    Tree.prototype.setValue = function (value) {
	        util.assert(typeof value !== 'undefined', 'Cannot set value to undefined');
	        this.node_.value = value;
	        this.updateParents_();
	    };
	    /**
	     * Clears the contents of the tree node (its value and all children).
	     */
	    Tree.prototype.clear = function () {
	        this.node_.value = null;
	        this.node_.children = {};
	        this.node_.childCount = 0;
	        this.updateParents_();
	    };
	    /**
	     * @return {boolean} Whether the tree has any children.
	     */
	    Tree.prototype.hasChildren = function () {
	        return this.node_.childCount > 0;
	    };
	    /**
	     * @return {boolean} Whether the tree is empty (no value or children).
	     */
	    Tree.prototype.isEmpty = function () {
	        return this.getValue() === null && !this.hasChildren();
	    };
	    /**
	     * Calls action for each child of this tree node.
	     *
	     * @param {function(!Tree.<T>)} action Action to be called for each child.
	     */
	    Tree.prototype.forEachChild = function (action) {
	        var _this = this;
	        each(this.node_.children, function (child, childTree) {
	            action(new Tree(child, _this, childTree));
	        });
	    };
	    /**
	     * Does a depth-first traversal of this node's descendants, calling action for each one.
	     *
	     * @param {function(!Tree.<T>)} action Action to be called for each child.
	     * @param {boolean=} includeSelf Whether to call action on this node as well. Defaults to
	     *   false.
	     * @param {boolean=} childrenFirst Whether to call action on children before calling it on
	     *   parent.
	     */
	    Tree.prototype.forEachDescendant = function (action, includeSelf, childrenFirst) {
	        if (includeSelf && !childrenFirst) {
	            action(this);
	        }
	        this.forEachChild(function (child) {
	            child.forEachDescendant(action, /*includeSelf=*/ true, childrenFirst);
	        });
	        if (includeSelf && childrenFirst) {
	            action(this);
	        }
	    };
	    /**
	     * Calls action on each ancestor node.
	     *
	     * @param {function(!Tree.<T>)} action Action to be called on each parent; return
	     *   true to abort.
	     * @param {boolean=} includeSelf Whether to call action on this node as well.
	     * @return {boolean} true if the action callback returned true.
	     */
	    Tree.prototype.forEachAncestor = function (action, includeSelf) {
	        var node = includeSelf ? this : this.parent();
	        while (node !== null) {
	            if (action(node)) {
	                return true;
	            }
	            node = node.parent();
	        }
	        return false;
	    };
	    /**
	     * Does a depth-first traversal of this node's descendants.  When a descendant with a value
	     * is found, action is called on it and traversal does not continue inside the node.
	     * Action is *not* called on this node.
	     *
	     * @param {function(!Tree.<T>)} action Action to be called for each child.
	     */
	    Tree.prototype.forEachImmediateDescendantWithValue = function (action) {
	        this.forEachChild(function (child) {
	            if (child.getValue() !== null) {
	                action(child);
	            }
	            else {
	                child.forEachImmediateDescendantWithValue(action);
	            }
	        });
	    };
	    /**
	     * @return {!Path} The path of this tree node, as a Path.
	     */
	    Tree.prototype.path = function () {
	        return new Path(this.parent_ === null
	            ? this.name_
	            : this.parent_.path() + '/' + this.name_);
	    };
	    /**
	     * @return {string} The name of the tree node.
	     */
	    Tree.prototype.name = function () {
	        return this.name_;
	    };
	    /**
	     * @return {?Tree} The parent tree node, or null if this is the root of the tree.
	     */
	    Tree.prototype.parent = function () {
	        return this.parent_;
	    };
	    /**
	     * Adds or removes this child from its parent based on whether it's empty or not.
	     *
	     * @private
	     */
	    Tree.prototype.updateParents_ = function () {
	        if (this.parent_ !== null) {
	            this.parent_.updateChild_(this.name_, this);
	        }
	    };
	    /**
	     * Adds or removes the passed child to this tree node, depending on whether it's empty.
	     *
	     * @param {string} childName The name of the child to update.
	     * @param {!Tree.<T>} child The child to update.
	     * @private
	     */
	    Tree.prototype.updateChild_ = function (childName, child) {
	        var childEmpty = child.isEmpty();
	        var childExists = util.contains(this.node_.children, childName);
	        if (childEmpty && childExists) {
	            delete this.node_.children[childName];
	            this.node_.childCount--;
	            this.updateParents_();
	        }
	        else if (!childEmpty && !childExists) {
	            this.node_.children[childName] = child.node_;
	            this.node_.childCount++;
	            this.updateParents_();
	        }
	    };
	    return Tree;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	// TODO: This is pretty messy.  Ideally, a lot of this would move into FirebaseData, or a transaction-specific
	// component used by FirebaseData, but it has ties to user callbacks (transaction update and onComplete) as well
	// as the realtime connection (to send transactions to the server).  So that all needs to be decoupled first.
	// For now it's part of Repo, but in its own file.
	/**
	 * @enum {number}
	 */
	var TransactionStatus;
	(function (TransactionStatus) {
	    // We've run the transaction and updated transactionResultData_ with the result, but it isn't currently sent to the
	    // server. A transaction will go from RUN -> SENT -> RUN if it comes back from the server as rejected due to
	    // mismatched hash.
	    TransactionStatus[TransactionStatus["RUN"] = 0] = "RUN";
	    // We've run the transaction and sent it to the server and it's currently outstanding (hasn't come back as accepted
	    // or rejected yet).
	    TransactionStatus[TransactionStatus["SENT"] = 1] = "SENT";
	    // Temporary state used to mark completed transactions (whether successful or aborted).  The transaction will be
	    // removed when we get a chance to prune completed ones.
	    TransactionStatus[TransactionStatus["COMPLETED"] = 2] = "COMPLETED";
	    // Used when an already-sent transaction needs to be aborted (e.g. due to a conflicting set() call that was made).
	    // If it comes back as unsuccessful, we'll abort it.
	    TransactionStatus[TransactionStatus["SENT_NEEDS_ABORT"] = 3] = "SENT_NEEDS_ABORT";
	    // Temporary state used to mark transactions that need to be aborted.
	    TransactionStatus[TransactionStatus["NEEDS_ABORT"] = 4] = "NEEDS_ABORT";
	})(TransactionStatus || (TransactionStatus = {}));
	/**
	 * If a transaction does not succeed after 25 retries, we abort it.  Among other things this ensure that if there's
	 * ever a bug causing a mismatch between client / server hashes for some data, we won't retry indefinitely.
	 * @type {number}
	 * @const
	 * @private
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	Repo.MAX_TRANSACTION_RETRIES_ = 25;
	/**
	 * Setup the transaction data structures
	 * @private
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	Repo.prototype.transactionsInit_ = function () {
	    /**
	     * Stores queues of outstanding transactions for Firebase locations.
	     *
	     * @type {!Tree.<Array.<!Transaction>>}
	     * @private
	     */
	    this.transactionQueueTree_ = new Tree();
	};
	/**
	 * Creates a new transaction, adds it to the transactions we're tracking, and sends it to the server if possible.
	 *
	 * @param {!Path} path Path at which to do transaction.
	 * @param {function(*):*} transactionUpdate Update callback.
	 * @param {?function(?Error, boolean, ?DataSnapshot)} onComplete Completion callback.
	 * @param {boolean} applyLocally Whether or not to make intermediate results visible
	 */
	Repo.prototype.startTransaction = function (path, transactionUpdate, onComplete, applyLocally) {
	    this.log_('transaction on ' + path);
	    // Add a watch to make sure we get server updates.
	    var valueCallback = function () { };
	    var watchRef = new Reference(this, path);
	    watchRef.on('value', valueCallback);
	    var unwatcher = function () {
	        watchRef.off('value', valueCallback);
	    };
	    // Initialize transaction.
	    var transaction = {
	        path: path,
	        update: transactionUpdate,
	        onComplete: onComplete,
	        // One of TransactionStatus enums.
	        status: null,
	        // Used when combining transactions at different locations to figure out which one goes first.
	        order: LUIDGenerator(),
	        // Whether to raise local events for this transaction.
	        applyLocally: applyLocally,
	        // Count of how many times we've retried the transaction.
	        retryCount: 0,
	        // Function to call to clean up our .on() listener.
	        unwatcher: unwatcher,
	        // Stores why a transaction was aborted.
	        abortReason: null,
	        currentWriteId: null,
	        currentInputSnapshot: null,
	        currentOutputSnapshotRaw: null,
	        currentOutputSnapshotResolved: null
	    };
	    // Run transaction initially.
	    var currentState = this.getLatestState_(path);
	    transaction.currentInputSnapshot = currentState;
	    var newVal = transaction.update(currentState.val());
	    if (newVal === undefined) {
	        // Abort transaction.
	        transaction.unwatcher();
	        transaction.currentOutputSnapshotRaw = null;
	        transaction.currentOutputSnapshotResolved = null;
	        if (transaction.onComplete) {
	            // We just set the input snapshot, so this cast should be safe
	            var snapshot = new DataSnapshot(transaction.currentInputSnapshot, new Reference(this, transaction.path), PRIORITY_INDEX);
	            transaction.onComplete(null, false, snapshot);
	        }
	    }
	    else {
	        validateFirebaseData('transaction failed: Data returned ', newVal, transaction.path);
	        // Mark as run and add to our queue.
	        transaction.status = TransactionStatus.RUN;
	        var queueNode = this.transactionQueueTree_.subTree(path);
	        var nodeQueue = queueNode.getValue() || [];
	        nodeQueue.push(transaction);
	        queueNode.setValue(nodeQueue);
	        // Update visibleData and raise events
	        // Note: We intentionally raise events after updating all of our transaction state, since the user could
	        // start new transactions from the event callbacks.
	        var priorityForNode = void 0;
	        if (typeof newVal === 'object' &&
	            newVal !== null &&
	            util.contains(newVal, '.priority')) {
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	            priorityForNode = util.safeGet(newVal, '.priority');
	            util.assert(isValidPriority(priorityForNode), 'Invalid priority returned by transaction. ' +
	                'Priority must be a valid string, finite number, server value, or null.');
	        }
	        else {
	            var currentNode = this.serverSyncTree_.calcCompleteEventCache(path) ||
	                ChildrenNode.EMPTY_NODE;
	            priorityForNode = currentNode.getPriority().val();
	        }
	        priorityForNode /** @type {null|number|string} */ = priorityForNode;
	        var serverValues = this.generateServerValues();
	        var newNodeUnresolved = nodeFromJSON$1(newVal, priorityForNode);
	        var newNode = resolveDeferredValueSnapshot(newNodeUnresolved, currentState, serverValues);
	        transaction.currentOutputSnapshotRaw = newNodeUnresolved;
	        transaction.currentOutputSnapshotResolved = newNode;
	        transaction.currentWriteId = this.getNextWriteId_();
	        var events = this.serverSyncTree_.applyUserOverwrite(path, newNode, transaction.currentWriteId, transaction.applyLocally);
	        this.eventQueue_.raiseEventsForChangedPath(path, events);
	        this.sendReadyTransactions_();
	    }
	};
	/**
	 * @param {!Path} path
	 * @param {Array.<number>=} excludeSets A specific set to exclude
	 * @return {Node}
	 * @private
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	Repo.prototype.getLatestState_ = function (path, excludeSets) {
	    return (this.serverSyncTree_.calcCompleteEventCache(path, excludeSets) ||
	        ChildrenNode.EMPTY_NODE);
	};
	/**
	 * Sends any already-run transactions that aren't waiting for outstanding transactions to
	 * complete.
	 *
	 * Externally it's called with no arguments, but it calls itself recursively with a particular
	 * transactionQueueTree node to recurse through the tree.
	 *
	 * @param {Tree.<Array.<Transaction>>=} node  transactionQueueTree node to start at.
	 * @private
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	Repo.prototype.sendReadyTransactions_ = function (node) {
	    var _this = this;
	    if (node === void 0) { node = this.transactionQueueTree_; }
	    // Before recursing, make sure any completed transactions are removed.
	    if (!node) {
	        this.pruneCompletedTransactionsBelowNode_(node);
	    }
	    if (node.getValue() !== null) {
	        var queue = this.buildTransactionQueue_(node);
	        util.assert(queue.length > 0, 'Sending zero length transaction queue');
	        var allRun = queue.every(function (transaction) { return transaction.status === TransactionStatus.RUN; });
	        // If they're all run (and not sent), we can send them.  Else, we must wait.
	        if (allRun) {
	            this.sendTransactionQueue_(node.path(), queue);
	        }
	    }
	    else if (node.hasChildren()) {
	        node.forEachChild(function (childNode) {
	            _this.sendReadyTransactions_(childNode);
	        });
	    }
	};
	/**
	 * Given a list of run transactions, send them to the server and then handle the result (success or failure).
	 *
	 * @param {!Path} path The location of the queue.
	 * @param {!Array.<Transaction>} queue Queue of transactions under the specified location.
	 * @private
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	Repo.prototype.sendTransactionQueue_ = function (path, queue) {
	    var _this = this;
	    // Mark transactions as sent and increment retry count!
	    var setsToIgnore = queue.map(function (txn) {
	        return txn.currentWriteId;
	    });
	    var latestState = this.getLatestState_(path, setsToIgnore);
	    var snapToSend = latestState;
	    var latestHash = latestState.hash();
	    for (var i = 0; i < queue.length; i++) {
	        var txn = queue[i];
	        util.assert(txn.status === TransactionStatus.RUN, 'tryToSendTransactionQueue_: items in queue should all be run.');
	        txn.status = TransactionStatus.SENT;
	        txn.retryCount++;
	        var relativePath = Path.relativePath(path, txn.path);
	        // If we've gotten to this point, the output snapshot must be defined.
	        snapToSend = snapToSend.updateChild(relativePath /** @type {!Node} */, txn.currentOutputSnapshotRaw);
	    }
	    var dataToSend = snapToSend.val(true);
	    var pathToSend = path;
	    // Send the put.
	    this.server_.put(pathToSend.toString(), dataToSend, function (status) {
	        _this.log_('transaction put response', {
	            path: pathToSend.toString(),
	            status: status
	        });
	        var events = [];
	        if (status === 'ok') {
	            // Queue up the callbacks and fire them after cleaning up all of our transaction state, since
	            // the callback could trigger more transactions or sets.
	            var callbacks = [];
	            for (var i = 0; i < queue.length; i++) {
	                queue[i].status = TransactionStatus.COMPLETED;
	                events = events.concat(_this.serverSyncTree_.ackUserWrite(queue[i].currentWriteId));
	                if (queue[i].onComplete) {
	                    // We never unset the output snapshot, and given that this transaction is complete, it should be set
	                    var node = queue[i].currentOutputSnapshotResolved;
	                    var ref = new Reference(_this, queue[i].path);
	                    var snapshot = new DataSnapshot(node, ref, PRIORITY_INDEX);
	                    callbacks.push(queue[i].onComplete.bind(null, null, true, snapshot));
	                }
	                queue[i].unwatcher();
	            }
	            // Now remove the completed transactions.
	            _this.pruneCompletedTransactionsBelowNode_(_this.transactionQueueTree_.subTree(path));
	            // There may be pending transactions that we can now send.
	            _this.sendReadyTransactions_();
	            _this.eventQueue_.raiseEventsForChangedPath(path, events);
	            // Finally, trigger onComplete callbacks.
	            for (var i = 0; i < callbacks.length; i++) {
	                exceptionGuard(callbacks[i]);
	            }
	        }
	        else {
	            // transactions are no longer sent.  Update their status appropriately.
	            if (status === 'datastale') {
	                for (var i = 0; i < queue.length; i++) {
	                    if (queue[i].status === TransactionStatus.SENT_NEEDS_ABORT) {
	                        queue[i].status = TransactionStatus.NEEDS_ABORT;
	                    }
	                    else {
	                        queue[i].status = TransactionStatus.RUN;
	                    }
	                }
	            }
	            else {
	                warn('transaction at ' + pathToSend.toString() + ' failed: ' + status);
	                for (var i = 0; i < queue.length; i++) {
	                    queue[i].status = TransactionStatus.NEEDS_ABORT;
	                    queue[i].abortReason = status;
	                }
	            }
	            _this.rerunTransactions_(path);
	        }
	    }, latestHash);
	};
	/**
	 * Finds all transactions dependent on the data at changedPath and reruns them.
	 *
	 * Should be called any time cached data changes.
	 *
	 * Return the highest path that was affected by rerunning transactions.  This is the path at which events need to
	 * be raised for.
	 *
	 * @param {!Path} changedPath The path in mergedData that changed.
	 * @return {!Path} The rootmost path that was affected by rerunning transactions.
	 * @private
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	Repo.prototype.rerunTransactions_ = function (changedPath) {
	    var rootMostTransactionNode = this.getAncestorTransactionNode_(changedPath);
	    var path = rootMostTransactionNode.path();
	    var queue = this.buildTransactionQueue_(rootMostTransactionNode);
	    this.rerunTransactionQueue_(queue, path);
	    return path;
	};
	/**
	 * Does all the work of rerunning transactions (as well as cleans up aborted transactions and whatnot).
	 *
	 * @param {Array.<Transaction>} queue The queue of transactions to run.
	 * @param {!Path} path The path the queue is for.
	 * @private
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	Repo.prototype.rerunTransactionQueue_ = function (queue, path) {
	    if (queue.length === 0) {
	        return; // Nothing to do!
	    }
	    // Queue up the callbacks and fire them after cleaning up all of our transaction state, since
	    // the callback could trigger more transactions or sets.
	    var callbacks = [];
	    var events = [];
	    // Ignore all of the sets we're going to re-run.
	    var txnsToRerun = queue.filter(function (q) {
	        return q.status === TransactionStatus.RUN;
	    });
	    var setsToIgnore = txnsToRerun.map(function (q) {
	        return q.currentWriteId;
	    });
	    for (var i = 0; i < queue.length; i++) {
	        var transaction = queue[i];
	        var relativePath = Path.relativePath(path, transaction.path);
	        var abortTransaction = false, abortReason = void 0;
	        util.assert(relativePath !== null, 'rerunTransactionsUnderNode_: relativePath should not be null.');
	        if (transaction.status === TransactionStatus.NEEDS_ABORT) {
	            abortTransaction = true;
	            abortReason = transaction.abortReason;
	            events = events.concat(this.serverSyncTree_.ackUserWrite(transaction.currentWriteId, true));
	        }
	        else if (transaction.status === TransactionStatus.RUN) {
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	            if (transaction.retryCount >= Repo.MAX_TRANSACTION_RETRIES_) {
	                abortTransaction = true;
	                abortReason = 'maxretry';
	                events = events.concat(this.serverSyncTree_.ackUserWrite(transaction.currentWriteId, true));
	            }
	            else {
	                // This code reruns a transaction
	                var currentNode = this.getLatestState_(transaction.path, setsToIgnore);
	                transaction.currentInputSnapshot = currentNode;
	                var newData = queue[i].update(currentNode.val());
	                if (newData !== undefined) {
	                    validateFirebaseData('transaction failed: Data returned ', newData, transaction.path);
	                    var newDataNode = nodeFromJSON$1(newData);
	                    var hasExplicitPriority = typeof newData === 'object' &&
	                        newData != null &&
	                        util.contains(newData, '.priority');
	                    if (!hasExplicitPriority) {
	                        // Keep the old priority if there wasn't a priority explicitly specified.
	                        newDataNode = newDataNode.updatePriority(currentNode.getPriority());
	                    }
	                    var oldWriteId = transaction.currentWriteId;
	                    var serverValues = this.generateServerValues();
	                    var newNodeResolved = resolveDeferredValueSnapshot(newDataNode, currentNode, serverValues);
	                    transaction.currentOutputSnapshotRaw = newDataNode;
	                    transaction.currentOutputSnapshotResolved = newNodeResolved;
	                    transaction.currentWriteId = this.getNextWriteId_();
	                    // Mutates setsToIgnore in place
	                    setsToIgnore.splice(setsToIgnore.indexOf(oldWriteId), 1);
	                    events = events.concat(this.serverSyncTree_.applyUserOverwrite(transaction.path, newNodeResolved, transaction.currentWriteId, transaction.applyLocally));
	                    events = events.concat(this.serverSyncTree_.ackUserWrite(oldWriteId, true));
	                }
	                else {
	                    abortTransaction = true;
	                    abortReason = 'nodata';
	                    events = events.concat(this.serverSyncTree_.ackUserWrite(transaction.currentWriteId, true));
	                }
	            }
	        }
	        this.eventQueue_.raiseEventsForChangedPath(path, events);
	        events = [];
	        if (abortTransaction) {
	            // Abort.
	            queue[i].status = TransactionStatus.COMPLETED;
	            // Removing a listener can trigger pruning which can muck with mergedData/visibleData (as it prunes data).
	            // So defer the unwatcher until we're done.
	            (function (unwatcher) {
	                setTimeout(unwatcher, Math.floor(0));
	            })(queue[i].unwatcher);
	            if (queue[i].onComplete) {
	                if (abortReason === 'nodata') {
	                    var ref = new Reference(this, queue[i].path);
	                    // We set this field immediately, so it's safe to cast to an actual snapshot
	                    var lastInput /** @type {!Node} */ = queue[i].currentInputSnapshot;
	                    var snapshot = new DataSnapshot(lastInput, ref, PRIORITY_INDEX);
	                    callbacks.push(queue[i].onComplete.bind(null, null, false, snapshot));
	                }
	                else {
	                    callbacks.push(queue[i].onComplete.bind(null, new Error(abortReason), false, null));
	                }
	            }
	        }
	    }
	    // Clean up completed transactions.
	    this.pruneCompletedTransactionsBelowNode_(this.transactionQueueTree_);
	    // Now fire callbacks, now that we're in a good, known state.
	    for (var i = 0; i < callbacks.length; i++) {
	        exceptionGuard(callbacks[i]);
	    }
	    // Try to send the transaction result to the server.
	    this.sendReadyTransactions_();
	};
	/**
	 * Returns the rootmost ancestor node of the specified path that has a pending transaction on it, or just returns
	 * the node for the given path if there are no pending transactions on any ancestor.
	 *
	 * @param {!Path} path The location to start at.
	 * @return {!Tree.<Array.<!Transaction>>} The rootmost node with a transaction.
	 * @private
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	Repo.prototype.getAncestorTransactionNode_ = function (path) {
	    var front;
	    // Start at the root and walk deeper into the tree towards path until we find a node with pending transactions.
	    var transactionNode = this.transactionQueueTree_;
	    front = path.getFront();
	    while (front !== null && transactionNode.getValue() === null) {
	        transactionNode = transactionNode.subTree(front);
	        path = path.popFront();
	        front = path.getFront();
	    }
	    return transactionNode;
	};
	/**
	 * Builds the queue of all transactions at or below the specified transactionNode.
	 *
	 * @param {!Tree.<Array.<Transaction>>} transactionNode
	 * @return {Array.<Transaction>} The generated queue.
	 * @private
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	Repo.prototype.buildTransactionQueue_ = function (transactionNode) {
	    // Walk any child transaction queues and aggregate them into a single queue.
	    var transactionQueue = [];
	    this.aggregateTransactionQueuesForNode_(transactionNode, transactionQueue);
	    // Sort them by the order the transactions were created.
	    transactionQueue.sort(function (a, b) {
	        return a.order - b.order;
	    });
	    return transactionQueue;
	};
	/**
	 * @param {!Tree.<Array.<Transaction>>} node
	 * @param {Array.<Transaction>} queue
	 * @private
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	Repo.prototype.aggregateTransactionQueuesForNode_ = function (node, queue) {
	    var _this = this;
	    var nodeQueue = node.getValue();
	    if (nodeQueue !== null) {
	        for (var i = 0; i < nodeQueue.length; i++) {
	            queue.push(nodeQueue[i]);
	        }
	    }
	    node.forEachChild(function (child) {
	        _this.aggregateTransactionQueuesForNode_(child, queue);
	    });
	};
	/**
	 * Remove COMPLETED transactions at or below this node in the transactionQueueTree_.
	 *
	 * @param {!Tree.<Array.<!Transaction>>} node
	 * @private
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	Repo.prototype.pruneCompletedTransactionsBelowNode_ = function (node) {
	    var _this = this;
	    var queue = node.getValue();
	    if (queue) {
	        var to = 0;
	        for (var from = 0; from < queue.length; from++) {
	            if (queue[from].status !== TransactionStatus.COMPLETED) {
	                queue[to] = queue[from];
	                to++;
	            }
	        }
	        queue.length = to;
	        node.setValue(queue.length > 0 ? queue : null);
	    }
	    node.forEachChild(function (childNode) {
	        _this.pruneCompletedTransactionsBelowNode_(childNode);
	    });
	};
	/**
	 * Aborts all transactions on ancestors or descendants of the specified path.  Called when doing a set() or update()
	 * since we consider them incompatible with transactions.
	 *
	 * @param {!Path} path Path for which we want to abort related transactions.
	 * @return {!Path}
	 * @private
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	Repo.prototype.abortTransactions_ = function (path) {
	    var _this = this;
	    var affectedPath = this.getAncestorTransactionNode_(path).path();
	    var transactionNode = this.transactionQueueTree_.subTree(path);
	    transactionNode.forEachAncestor(function (node) {
	        _this.abortTransactionsOnNode_(node);
	    });
	    this.abortTransactionsOnNode_(transactionNode);
	    transactionNode.forEachDescendant(function (node) {
	        _this.abortTransactionsOnNode_(node);
	    });
	    return affectedPath;
	};
	/**
	 * Abort transactions stored in this transaction queue node.
	 *
	 * @param {!Tree.<Array.<Transaction>>} node Node to abort transactions for.
	 * @private
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	Repo.prototype.abortTransactionsOnNode_ = function (node) {
	    var queue = node.getValue();
	    if (queue !== null) {
	        // Queue up the callbacks and fire them after cleaning up all of our transaction state, since
	        // the callback could trigger more transactions or sets.
	        var callbacks = [];
	        // Go through queue.  Any already-sent transactions must be marked for abort, while the unsent ones
	        // can be immediately aborted and removed.
	        var events = [];
	        var lastSent = -1;
	        for (var i = 0; i < queue.length; i++) {
	            if (queue[i].status === TransactionStatus.SENT_NEEDS_ABORT) ;
	            else if (queue[i].status === TransactionStatus.SENT) {
	                util.assert(lastSent === i - 1, 'All SENT items should be at beginning of queue.');
	                lastSent = i;
	                // Mark transaction for abort when it comes back.
	                queue[i].status = TransactionStatus.SENT_NEEDS_ABORT;
	                queue[i].abortReason = 'set';
	            }
	            else {
	                util.assert(queue[i].status === TransactionStatus.RUN, 'Unexpected transaction status in abort');
	                // We can abort it immediately.
	                queue[i].unwatcher();
	                events = events.concat(this.serverSyncTree_.ackUserWrite(queue[i].currentWriteId, true));
	                if (queue[i].onComplete) {
	                    var snapshot = null;
	                    callbacks.push(queue[i].onComplete.bind(null, new Error('set'), false, snapshot));
	                }
	            }
	        }
	        if (lastSent === -1) {
	            // We're not waiting for any sent transactions.  We can clear the queue.
	            node.setValue(null);
	        }
	        else {
	            // Remove the transactions we aborted.
	            queue.length = lastSent + 1;
	        }
	        // Now fire the callbacks.
	        this.eventQueue_.raiseEventsForChangedPath(node.path(), events);
	        for (var i = 0; i < callbacks.length; i++) {
	            exceptionGuard(callbacks[i]);
	        }
	    }
	};
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/** @const {string} */
	var DATABASE_URL_OPTION = 'databaseURL';
	/**
	 * This variable is also defined in the firebase node.js admin SDK. Before
	 * modifying this definition, consult the definition in:
	 *
	 * https://github.com/firebase/firebase-admin-node
	 *
	 * and make sure the two are consistent.
	 */
	var FIREBASE_DATABASE_EMULATOR_HOST_VAR = 'FIREBASE_DATABASE_EMULATOR_HOST';
	var _staticInstance;
	/**
	 * Creates and caches Repo instances.
	 */
	var RepoManager = /** @class */ (function () {
	    function RepoManager() {
	        /**
	         * @private {!Object.<string, Object<string, !fb.core.Repo>>}
	         */
	        this.repos_ = {};
	        /**
	         * If true, new Repos will be created to use ReadonlyRestClient (for testing purposes).
	         * @private {boolean}
	         */
	        this.useRestClient_ = false;
	    }
	    RepoManager.getInstance = function () {
	        if (!_staticInstance) {
	            _staticInstance = new RepoManager();
	        }
	        return _staticInstance;
	    };
	    // TODO(koss): Remove these functions unless used in tests?
	    RepoManager.prototype.interrupt = function () {
	        var e_1, _a, e_2, _b;
	        try {
	            for (var _c = tslib.__values(Object.keys(this.repos_)), _d = _c.next(); !_d.done; _d = _c.next()) {
	                var appName = _d.value;
	                try {
	                    for (var _e = (e_2 = void 0, tslib.__values(Object.keys(this.repos_[appName]))), _f = _e.next(); !_f.done; _f = _e.next()) {
	                        var dbUrl = _f.value;
	                        this.repos_[appName][dbUrl].interrupt();
	                    }
	                }
	                catch (e_2_1) { e_2 = { error: e_2_1 }; }
	                finally {
	                    try {
	                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
	                    }
	                    finally { if (e_2) throw e_2.error; }
	                }
	            }
	        }
	        catch (e_1_1) { e_1 = { error: e_1_1 }; }
	        finally {
	            try {
	                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
	            }
	            finally { if (e_1) throw e_1.error; }
	        }
	    };
	    RepoManager.prototype.resume = function () {
	        var e_3, _a, e_4, _b;
	        try {
	            for (var _c = tslib.__values(Object.keys(this.repos_)), _d = _c.next(); !_d.done; _d = _c.next()) {
	                var appName = _d.value;
	                try {
	                    for (var _e = (e_4 = void 0, tslib.__values(Object.keys(this.repos_[appName]))), _f = _e.next(); !_f.done; _f = _e.next()) {
	                        var dbUrl = _f.value;
	                        this.repos_[appName][dbUrl].resume();
	                    }
	                }
	                catch (e_4_1) { e_4 = { error: e_4_1 }; }
	                finally {
	                    try {
	                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
	                    }
	                    finally { if (e_4) throw e_4.error; }
	                }
	            }
	        }
	        catch (e_3_1) { e_3 = { error: e_3_1 }; }
	        finally {
	            try {
	                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
	            }
	            finally { if (e_3) throw e_3.error; }
	        }
	    };
	    /**
	     * This function should only ever be called to CREATE a new database instance.
	     *
	     * @param {!FirebaseApp} app
	     * @return {!Database}
	     */
	    RepoManager.prototype.databaseFromApp = function (app, authProvider, url) {
	        var dbUrl = url || app.options[DATABASE_URL_OPTION];
	        if (dbUrl === undefined) {
	            fatal("Can't determine Firebase Database URL.  Be sure to include " +
	                DATABASE_URL_OPTION +
	                ' option when calling firebase.initializeApp().');
	        }
	        var parsedUrl = parseRepoInfo(dbUrl);
	        var repoInfo = parsedUrl.repoInfo;
	        var dbEmulatorHost = undefined;
	        if (typeof process !== 'undefined') {
	            dbEmulatorHost = ({"NODE_ENV":"production"})[FIREBASE_DATABASE_EMULATOR_HOST_VAR];
	        }
	        if (dbEmulatorHost) {
	            dbUrl = "http://" + dbEmulatorHost + "?ns=" + repoInfo.namespace;
	            parsedUrl = parseRepoInfo(dbUrl);
	            repoInfo = parsedUrl.repoInfo;
	        }
	        validateUrl('Invalid Firebase Database URL', 1, parsedUrl);
	        if (!parsedUrl.path.isEmpty()) {
	            fatal('Database URL must point to the root of a Firebase Database ' +
	                '(not including a child path).');
	        }
	        var repo = this.createRepo(repoInfo, app, authProvider);
	        return repo.database;
	    };
	    /**
	     * Remove the repo and make sure it is disconnected.
	     *
	     * @param {!Repo} repo
	     */
	    RepoManager.prototype.deleteRepo = function (repo) {
	        var appRepos = util.safeGet(this.repos_, repo.app.name);
	        // This should never happen...
	        if (!appRepos || util.safeGet(appRepos, repo.repoInfo_.toURLString()) !== repo) {
	            fatal("Database " + repo.app.name + "(" + repo.repoInfo_ + ") has already been deleted.");
	        }
	        repo.interrupt();
	        delete appRepos[repo.repoInfo_.toURLString()];
	    };
	    /**
	     * Ensures a repo doesn't already exist and then creates one using the
	     * provided app.
	     *
	     * @param {!RepoInfo} repoInfo The metadata about the Repo
	     * @param {!FirebaseApp} app
	     * @return {!Repo} The Repo object for the specified server / repoName.
	     */
	    RepoManager.prototype.createRepo = function (repoInfo, app, authProvider) {
	        var appRepos = util.safeGet(this.repos_, app.name);
	        if (!appRepos) {
	            appRepos = {};
	            this.repos_[app.name] = appRepos;
	        }
	        var repo = util.safeGet(appRepos, repoInfo.toURLString());
	        if (repo) {
	            fatal('Database initialized multiple times. Please make sure the format of the database URL matches with each database() call.');
	        }
	        repo = new Repo(repoInfo, this.useRestClient_, app, authProvider);
	        appRepos[repoInfo.toURLString()] = repo;
	        return repo;
	    };
	    /**
	     * Forces us to use ReadonlyRestClient instead of PersistentConnection for new Repos.
	     * @param {boolean} forceRestClient
	     */
	    RepoManager.prototype.forceRestClient = function (forceRestClient) {
	        this.useRestClient_ = forceRestClient;
	    };
	    return RepoManager;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Class representing a firebase database.
	 * @implements {FirebaseService}
	 */
	var Database = /** @class */ (function () {
	    /**
	     * The constructor should not be called by users of our public API.
	     * @param {!Repo} repo_
	     */
	    function Database(repo_) {
	        this.repo_ = repo_;
	        if (!(repo_ instanceof Repo)) {
	            fatal("Don't call new Database() directly - please use firebase.database().");
	        }
	        /** @type {Reference} */
	        this.root_ = new Reference(repo_, Path.Empty);
	        this.INTERNAL = new DatabaseInternals(this);
	    }
	    Object.defineProperty(Database.prototype, "app", {
	        get: function () {
	            return this.repo_.app;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Database.prototype.ref = function (path) {
	        this.checkDeleted_('ref');
	        util.validateArgCount('database.ref', 0, 1, arguments.length);
	        if (path instanceof Reference) {
	            return this.refFromURL(path.toString());
	        }
	        return path !== undefined ? this.root_.child(path) : this.root_;
	    };
	    /**
	     * Returns a reference to the root or the path specified in url.
	     * We throw a exception if the url is not in the same domain as the
	     * current repo.
	     * @param {string} url
	     * @return {!Reference} Firebase reference.
	     */
	    Database.prototype.refFromURL = function (url) {
	        /** @const {string} */
	        var apiName = 'database.refFromURL';
	        this.checkDeleted_(apiName);
	        util.validateArgCount(apiName, 1, 1, arguments.length);
	        var parsedURL = parseRepoInfo(url);
	        validateUrl(apiName, 1, parsedURL);
	        var repoInfo = parsedURL.repoInfo;
	        if (repoInfo.host !== this.repo_.repoInfo_.host) {
	            fatal(apiName +
	                ': Host name does not match the current database: ' +
	                '(found ' +
	                repoInfo.host +
	                ' but expected ' +
	                this.repo_.repoInfo_.host +
	                ')');
	        }
	        return this.ref(parsedURL.path.toString());
	    };
	    /**
	     * @param {string} apiName
	     */
	    Database.prototype.checkDeleted_ = function (apiName) {
	        if (this.repo_ === null) {
	            fatal('Cannot call ' + apiName + ' on a deleted database.');
	        }
	    };
	    // Make individual repo go offline.
	    Database.prototype.goOffline = function () {
	        util.validateArgCount('database.goOffline', 0, 0, arguments.length);
	        this.checkDeleted_('goOffline');
	        this.repo_.interrupt();
	    };
	    Database.prototype.goOnline = function () {
	        util.validateArgCount('database.goOnline', 0, 0, arguments.length);
	        this.checkDeleted_('goOnline');
	        this.repo_.resume();
	    };
	    Database.ServerValue = {
	        TIMESTAMP: {
	            '.sv': 'timestamp'
	        },
	        increment: function (delta) {
	            return {
	                '.sv': {
	                    'increment': delta
	                }
	            };
	        }
	    };
	    return Database;
	}());
	var DatabaseInternals = /** @class */ (function () {
	    /** @param {!Database} database */
	    function DatabaseInternals(database) {
	        this.database = database;
	    }
	    /** @return {Promise<void>} */
	    DatabaseInternals.prototype.delete = function () {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            return tslib.__generator(this, function (_a) {
	                // eslint-disable-next-line @typescript-eslint/no-explicit-any
	                this.database.checkDeleted_('delete');
	                // eslint-disable-next-line @typescript-eslint/no-explicit-any
	                RepoManager.getInstance().deleteRepo(this.database.repo_);
	                // eslint-disable-next-line @typescript-eslint/no-explicit-any
	                this.database.repo_ = null;
	                // eslint-disable-next-line @typescript-eslint/no-explicit-any
	                this.database.root_ = null;
	                this.database.INTERNAL = null;
	                this.database = null;
	                return [2 /*return*/];
	            });
	        });
	    };
	    return DatabaseInternals;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * INTERNAL methods for internal-use only (tests, etc.).
	 *
	 * Customers shouldn't use these or else should be aware that they could break at any time.
	 *
	 * @const
	 */
	var forceLongPolling = function () {
	    WebSocketConnection.forceDisallow();
	    BrowserPollConnection.forceAllow();
	};
	var forceWebSockets = function () {
	    BrowserPollConnection.forceDisallow();
	};
	/* Used by App Manager */
	var isWebSocketsAvailable = function () {
	    return WebSocketConnection['isAvailable']();
	};
	var setSecurityDebugCallback = function (ref, callback) {
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    ref.repo.persistentConnection_.securityDebugCallback_ = callback;
	};
	var stats = function (ref, showDelta) {
	    ref.repo.stats(showDelta);
	};
	var statsIncrementCounter = function (ref, metric) {
	    ref.repo.statsIncrementCounter(metric);
	};
	var dataUpdateCount = function (ref) {
	    return ref.repo.dataUpdateCount;
	};
	var interceptServerData = function (ref, callback) {
	    return ref.repo.interceptServerData_(callback);
	};
	
	var INTERNAL = /*#__PURE__*/Object.freeze({
	  __proto__: null,
	  forceLongPolling: forceLongPolling,
	  forceWebSockets: forceWebSockets,
	  isWebSocketsAvailable: isWebSocketsAvailable,
	  setSecurityDebugCallback: setSecurityDebugCallback,
	  stats: stats,
	  statsIncrementCounter: statsIncrementCounter,
	  dataUpdateCount: dataUpdateCount,
	  interceptServerData: interceptServerData
	});
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var DataConnection = PersistentConnection;
	/**
	 * @param {!string} pathString
	 * @param {function(*)} onComplete
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	PersistentConnection.prototype.simpleListen = function (pathString, onComplete) {
	    this.sendRequest('q', { p: pathString }, onComplete);
	};
	/**
	 * @param {*} data
	 * @param {function(*)} onEcho
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	PersistentConnection.prototype.echo = function (data, onEcho) {
	    this.sendRequest('echo', { d: data }, onEcho);
	};
	// RealTimeConnection properties that we use in tests.
	var RealTimeConnection = Connection;
	/**
	 * @param {function(): string} newHash
	 * @return {function()}
	 */
	var hijackHash = function (newHash) {
	    var oldPut = PersistentConnection.prototype.put;
	    PersistentConnection.prototype.put = function (pathString, data, onComplete, hash) {
	        if (hash !== undefined) {
	            hash = newHash();
	        }
	        oldPut.call(this, pathString, data, onComplete, hash);
	    };
	    return function () {
	        PersistentConnection.prototype.put = oldPut;
	    };
	};
	/**
	 * @type {function(new:RepoInfo, !string, boolean, !string, boolean): undefined}
	 */
	var ConnectionTarget = RepoInfo;
	/**
	 * @param {!Query} query
	 * @return {!string}
	 */
	var queryIdentifier = function (query) {
	    return query.queryIdentifier();
	};
	/**
	 * Forces the RepoManager to create Repos that use ReadonlyRestClient instead of PersistentConnection.
	 *
	 * @param {boolean} forceRestClient
	 */
	var forceRestClient = function (forceRestClient) {
	    RepoManager.getInstance().forceRestClient(forceRestClient);
	};
	
	var TEST_ACCESS = /*#__PURE__*/Object.freeze({
	  __proto__: null,
	  DataConnection: DataConnection,
	  RealTimeConnection: RealTimeConnection,
	  hijackHash: hijackHash,
	  ConnectionTarget: ConnectionTarget,
	  queryIdentifier: queryIdentifier,
	  forceRestClient: forceRestClient
	});
	
	var name = "@firebase/database";
	var version = "0.6.3";
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var ServerValue = Database.ServerValue;
	function registerDatabase(instance) {
	    // set SDK_VERSION
	    setSDKVersion(instance.SDK_VERSION);
	    // Register the Database Service with the 'firebase' namespace.
	    var namespace = instance.INTERNAL.registerComponent(new component.Component('database', function (container, url) {
	        /* Dependencies */
	        // getImmediate for FirebaseApp will always succeed
	        var app = container.getProvider('app').getImmediate();
	        var authProvider = container.getProvider('auth-internal');
	        return RepoManager.getInstance().databaseFromApp(app, authProvider, url);
	    }, "PUBLIC" /* PUBLIC */)
	        .setServiceProps(
	    // firebase.database namespace properties
	    {
	        Reference: Reference,
	        Query: Query,
	        Database: Database,
	        DataSnapshot: DataSnapshot,
	        enableLogging: enableLogging,
	        INTERNAL: INTERNAL,
	        ServerValue: ServerValue,
	        TEST_ACCESS: TEST_ACCESS
	    })
	        .setMultipleInstances(true));
	    instance.registerVersion(name, version);
	    if (util.isNodeSdk()) {
	        module.exports = namespace;
	    }
	}
	registerDatabase(firebase);
	
	exports.DataSnapshot = DataSnapshot;
	exports.Database = Database;
	exports.OnDisconnect = OnDisconnect;
	exports.Query = Query;
	exports.Reference = Reference;
	exports.ServerValue = ServerValue;
	exports.enableLogging = enableLogging;
	exports.registerDatabase = registerDatabase;
	//# sourceMappingURL=index.cjs.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(45)))

/***/ }),
/* 266 */
262,
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var firebase = _interopDefault(__webpack_require__(39));
	var component = __webpack_require__(58);
	var tslib = __webpack_require__(268);
	var util = __webpack_require__(59);
	var idb = __webpack_require__(397);
	
	var name = "@firebase/installations";
	var version = "0.4.10";
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var PENDING_TIMEOUT_MS = 10000;
	var PACKAGE_VERSION = "w:" + version;
	var INTERNAL_AUTH_VERSION = 'FIS_v2';
	var INSTALLATIONS_API_URL = 'https://firebaseinstallations.googleapis.com/v1';
	var TOKEN_EXPIRATION_BUFFER = 60 * 60 * 1000; // One hour
	var SERVICE = 'installations';
	var SERVICE_NAME = 'Installations';
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var _a;
	var ERROR_DESCRIPTION_MAP = (_a = {},
	    _a["missing-app-config-values" /* MISSING_APP_CONFIG_VALUES */] = 'Missing App configuration value: "{$valueName}"',
	    _a["not-registered" /* NOT_REGISTERED */] = 'Firebase Installation is not registered.',
	    _a["installation-not-found" /* INSTALLATION_NOT_FOUND */] = 'Firebase Installation not found.',
	    _a["request-failed" /* REQUEST_FAILED */] = '{$requestName} request failed with error "{$serverCode} {$serverStatus}: {$serverMessage}"',
	    _a["app-offline" /* APP_OFFLINE */] = 'Could not process request. Application offline.',
	    _a["delete-pending-registration" /* DELETE_PENDING_REGISTRATION */] = "Can't delete installation while there is a pending registration request.",
	    _a);
	var ERROR_FACTORY = new util.ErrorFactory(SERVICE, SERVICE_NAME, ERROR_DESCRIPTION_MAP);
	/** Returns true if error is a FirebaseError that is based on an error from the server. */
	function isServerError(error) {
	    return (error instanceof util.FirebaseError &&
	        error.code.includes("request-failed" /* REQUEST_FAILED */));
	}
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function getInstallationsEndpoint(_a) {
	    var projectId = _a.projectId;
	    return INSTALLATIONS_API_URL + "/projects/" + projectId + "/installations";
	}
	function extractAuthTokenInfoFromResponse(response) {
	    return {
	        token: response.token,
	        requestStatus: 2 /* COMPLETED */,
	        expiresIn: getExpiresInFromResponseExpiresIn(response.expiresIn),
	        creationTime: Date.now()
	    };
	}
	function getErrorFromResponse(requestName, response) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var responseJson, errorData;
	        return tslib.__generator(this, function (_a) {
	            switch (_a.label) {
	                case 0: return [4 /*yield*/, response.json()];
	                case 1:
	                    responseJson = _a.sent();
	                    errorData = responseJson.error;
	                    return [2 /*return*/, ERROR_FACTORY.create("request-failed" /* REQUEST_FAILED */, {
	                            requestName: requestName,
	                            serverCode: errorData.code,
	                            serverMessage: errorData.message,
	                            serverStatus: errorData.status
	                        })];
	            }
	        });
	    });
	}
	function getHeaders(_a) {
	    var apiKey = _a.apiKey;
	    return new Headers({
	        'Content-Type': 'application/json',
	        Accept: 'application/json',
	        'x-goog-api-key': apiKey
	    });
	}
	function getHeadersWithAuth(appConfig, _a) {
	    var refreshToken = _a.refreshToken;
	    var headers = getHeaders(appConfig);
	    headers.append('Authorization', getAuthorizationHeader(refreshToken));
	    return headers;
	}
	/**
	 * Calls the passed in fetch wrapper and returns the response.
	 * If the returned response has a status of 5xx, re-runs the function once and
	 * returns the response.
	 */
	function retryIfServerError(fn) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var result;
	        return tslib.__generator(this, function (_a) {
	            switch (_a.label) {
	                case 0: return [4 /*yield*/, fn()];
	                case 1:
	                    result = _a.sent();
	                    if (result.status >= 500 && result.status < 600) {
	                        // Internal Server Error. Retry request.
	                        return [2 /*return*/, fn()];
	                    }
	                    return [2 /*return*/, result];
	            }
	        });
	    });
	}
	function getExpiresInFromResponseExpiresIn(responseExpiresIn) {
	    // This works because the server will never respond with fractions of a second.
	    return Number(responseExpiresIn.replace('s', '000'));
	}
	function getAuthorizationHeader(refreshToken) {
	    return INTERNAL_AUTH_VERSION + " " + refreshToken;
	}
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function createInstallationRequest(appConfig, _a) {
	    var fid = _a.fid;
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var endpoint, headers, body, request, response, responseValue, registeredInstallationEntry;
	        return tslib.__generator(this, function (_b) {
	            switch (_b.label) {
	                case 0:
	                    endpoint = getInstallationsEndpoint(appConfig);
	                    headers = getHeaders(appConfig);
	                    body = {
	                        fid: fid,
	                        authVersion: INTERNAL_AUTH_VERSION,
	                        appId: appConfig.appId,
	                        sdkVersion: PACKAGE_VERSION
	                    };
	                    request = {
	                        method: 'POST',
	                        headers: headers,
	                        body: JSON.stringify(body)
	                    };
	                    return [4 /*yield*/, retryIfServerError(function () { return fetch(endpoint, request); })];
	                case 1:
	                    response = _b.sent();
	                    if (!response.ok) return [3 /*break*/, 3];
	                    return [4 /*yield*/, response.json()];
	                case 2:
	                    responseValue = _b.sent();
	                    registeredInstallationEntry = {
	                        fid: responseValue.fid || fid,
	                        registrationStatus: 2 /* COMPLETED */,
	                        refreshToken: responseValue.refreshToken,
	                        authToken: extractAuthTokenInfoFromResponse(responseValue.authToken)
	                    };
	                    return [2 /*return*/, registeredInstallationEntry];
	                case 3: return [4 /*yield*/, getErrorFromResponse('Create Installation', response)];
	                case 4: throw _b.sent();
	            }
	        });
	    });
	}
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/** Returns a promise that resolves after given time passes. */
	function sleep(ms) {
	    return new Promise(function (resolve) {
	        setTimeout(resolve, ms);
	    });
	}
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function bufferToBase64UrlSafe(array) {
	    var b64 = btoa(String.fromCharCode.apply(String, tslib.__spread(array)));
	    return b64.replace(/\+/g, '-').replace(/\//g, '_');
	}
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var VALID_FID_PATTERN = /^[cdef][\w-]{21}$/;
	var INVALID_FID = '';
	/**
	 * Generates a new FID using random values from Web Crypto API.
	 * Returns an empty string if FID generation fails for any reason.
	 */
	function generateFid() {
	    try {
	        // A valid FID has exactly 22 base64 characters, which is 132 bits, or 16.5
	        // bytes. our implementation generates a 17 byte array instead.
	        var fidByteArray = new Uint8Array(17);
	        var crypto_1 = self.crypto || self.msCrypto;
	        crypto_1.getRandomValues(fidByteArray);
	        // Replace the first 4 random bits with the constant FID header of 0b0111.
	        fidByteArray[0] = 112 + (fidByteArray[0] % 16);
	        var fid = encode(fidByteArray);
	        return VALID_FID_PATTERN.test(fid) ? fid : INVALID_FID;
	    }
	    catch (_a) {
	        // FID generation errored
	        return INVALID_FID;
	    }
	}
	/** Converts a FID Uint8Array to a base64 string representation. */
	function encode(fidByteArray) {
	    var b64String = bufferToBase64UrlSafe(fidByteArray);
	    // Remove the 23rd character that was added because of the extra 4 bits at the
	    // end of our 17 byte array, and the '=' padding.
	    return b64String.substr(0, 22);
	}
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/** Returns a string key that can be used to identify the app. */
	function getKey(appConfig) {
	    return appConfig.appName + "!" + appConfig.appId;
	}
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var fidChangeCallbacks = new Map();
	/**
	 * Calls the onIdChange callbacks with the new FID value, and broadcasts the
	 * change to other tabs.
	 */
	function fidChanged(appConfig, fid) {
	    var key = getKey(appConfig);
	    callFidChangeCallbacks(key, fid);
	    broadcastFidChange(key, fid);
	}
	function addCallback(appConfig, callback) {
	    // Open the broadcast channel if it's not already open,
	    // to be able to listen to change events from other tabs.
	    getBroadcastChannel();
	    var key = getKey(appConfig);
	    var callbackSet = fidChangeCallbacks.get(key);
	    if (!callbackSet) {
	        callbackSet = new Set();
	        fidChangeCallbacks.set(key, callbackSet);
	    }
	    callbackSet.add(callback);
	}
	function removeCallback(appConfig, callback) {
	    var key = getKey(appConfig);
	    var callbackSet = fidChangeCallbacks.get(key);
	    if (!callbackSet) {
	        return;
	    }
	    callbackSet.delete(callback);
	    if (callbackSet.size === 0) {
	        fidChangeCallbacks.delete(key);
	    }
	    // Close broadcast channel if there are no more callbacks.
	    closeBroadcastChannel();
	}
	function callFidChangeCallbacks(key, fid) {
	    var e_1, _a;
	    var callbacks = fidChangeCallbacks.get(key);
	    if (!callbacks) {
	        return;
	    }
	    try {
	        for (var callbacks_1 = tslib.__values(callbacks), callbacks_1_1 = callbacks_1.next(); !callbacks_1_1.done; callbacks_1_1 = callbacks_1.next()) {
	            var callback = callbacks_1_1.value;
	            callback(fid);
	        }
	    }
	    catch (e_1_1) { e_1 = { error: e_1_1 }; }
	    finally {
	        try {
	            if (callbacks_1_1 && !callbacks_1_1.done && (_a = callbacks_1.return)) _a.call(callbacks_1);
	        }
	        finally { if (e_1) throw e_1.error; }
	    }
	}
	function broadcastFidChange(key, fid) {
	    var channel = getBroadcastChannel();
	    if (channel) {
	        channel.postMessage({ key: key, fid: fid });
	    }
	    closeBroadcastChannel();
	}
	var broadcastChannel = null;
	/** Opens and returns a BroadcastChannel if it is supported by the browser. */
	function getBroadcastChannel() {
	    if (!broadcastChannel && 'BroadcastChannel' in self) {
	        broadcastChannel = new BroadcastChannel('[Firebase] FID Change');
	        broadcastChannel.onmessage = function (e) {
	            callFidChangeCallbacks(e.data.key, e.data.fid);
	        };
	    }
	    return broadcastChannel;
	}
	function closeBroadcastChannel() {
	    if (fidChangeCallbacks.size === 0 && broadcastChannel) {
	        broadcastChannel.close();
	        broadcastChannel = null;
	    }
	}
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var DATABASE_NAME = 'firebase-installations-database';
	var DATABASE_VERSION = 1;
	var OBJECT_STORE_NAME = 'firebase-installations-store';
	var dbPromise = null;
	function getDbPromise() {
	    if (!dbPromise) {
	        dbPromise = idb.openDb(DATABASE_NAME, DATABASE_VERSION, function (upgradeDB) {
	            // We don't use 'break' in this switch statement, the fall-through
	            // behavior is what we want, because if there are multiple versions between
	            // the old version and the current version, we want ALL the migrations
	            // that correspond to those versions to run, not only the last one.
	            // eslint-disable-next-line default-case
	            switch (upgradeDB.oldVersion) {
	                case 0:
	                    upgradeDB.createObjectStore(OBJECT_STORE_NAME);
	            }
	        });
	    }
	    return dbPromise;
	}
	/** Assigns or overwrites the record for the given key with the given value. */
	function set(appConfig, value) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var key, db, tx, objectStore, oldValue;
	        return tslib.__generator(this, function (_a) {
	            switch (_a.label) {
	                case 0:
	                    key = getKey(appConfig);
	                    return [4 /*yield*/, getDbPromise()];
	                case 1:
	                    db = _a.sent();
	                    tx = db.transaction(OBJECT_STORE_NAME, 'readwrite');
	                    objectStore = tx.objectStore(OBJECT_STORE_NAME);
	                    return [4 /*yield*/, objectStore.get(key)];
	                case 2:
	                    oldValue = _a.sent();
	                    return [4 /*yield*/, objectStore.put(value, key)];
	                case 3:
	                    _a.sent();
	                    return [4 /*yield*/, tx.complete];
	                case 4:
	                    _a.sent();
	                    if (!oldValue || oldValue.fid !== value.fid) {
	                        fidChanged(appConfig, value.fid);
	                    }
	                    return [2 /*return*/, value];
	            }
	        });
	    });
	}
	/** Removes record(s) from the objectStore that match the given key. */
	function remove(appConfig) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var key, db, tx;
	        return tslib.__generator(this, function (_a) {
	            switch (_a.label) {
	                case 0:
	                    key = getKey(appConfig);
	                    return [4 /*yield*/, getDbPromise()];
	                case 1:
	                    db = _a.sent();
	                    tx = db.transaction(OBJECT_STORE_NAME, 'readwrite');
	                    return [4 /*yield*/, tx.objectStore(OBJECT_STORE_NAME).delete(key)];
	                case 2:
	                    _a.sent();
	                    return [4 /*yield*/, tx.complete];
	                case 3:
	                    _a.sent();
	                    return [2 /*return*/];
	            }
	        });
	    });
	}
	/**
	 * Atomically updates a record with the result of updateFn, which gets
	 * called with the current value. If newValue is undefined, the record is
	 * deleted instead.
	 * @return Updated value
	 */
	function update(appConfig, updateFn) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var key, db, tx, store, oldValue, newValue;
	        return tslib.__generator(this, function (_a) {
	            switch (_a.label) {
	                case 0:
	                    key = getKey(appConfig);
	                    return [4 /*yield*/, getDbPromise()];
	                case 1:
	                    db = _a.sent();
	                    tx = db.transaction(OBJECT_STORE_NAME, 'readwrite');
	                    store = tx.objectStore(OBJECT_STORE_NAME);
	                    return [4 /*yield*/, store.get(key)];
	                case 2:
	                    oldValue = _a.sent();
	                    newValue = updateFn(oldValue);
	                    if (!(newValue === undefined)) return [3 /*break*/, 4];
	                    return [4 /*yield*/, store.delete(key)];
	                case 3:
	                    _a.sent();
	                    return [3 /*break*/, 6];
	                case 4: return [4 /*yield*/, store.put(newValue, key)];
	                case 5:
	                    _a.sent();
	                    _a.label = 6;
	                case 6: return [4 /*yield*/, tx.complete];
	                case 7:
	                    _a.sent();
	                    if (newValue && (!oldValue || oldValue.fid !== newValue.fid)) {
	                        fidChanged(appConfig, newValue.fid);
	                    }
	                    return [2 /*return*/, newValue];
	            }
	        });
	    });
	}
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Updates and returns the InstallationEntry from the database.
	 * Also triggers a registration request if it is necessary and possible.
	 */
	function getInstallationEntry(appConfig) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var registrationPromise, installationEntry, _a;
	        return tslib.__generator(this, function (_b) {
	            switch (_b.label) {
	                case 0: return [4 /*yield*/, update(appConfig, function (oldEntry) {
	                        var installationEntry = updateOrCreateInstallationEntry(oldEntry);
	                        var entryWithPromise = triggerRegistrationIfNecessary(appConfig, installationEntry);
	                        registrationPromise = entryWithPromise.registrationPromise;
	                        return entryWithPromise.installationEntry;
	                    })];
	                case 1:
	                    installationEntry = _b.sent();
	                    if (!(installationEntry.fid === INVALID_FID)) return [3 /*break*/, 3];
	                    _a = {};
	                    return [4 /*yield*/, registrationPromise];
	                case 2: 
	                // FID generation failed. Waiting for the FID from the server.
	                return [2 /*return*/, (_a.installationEntry = _b.sent(), _a)];
	                case 3: return [2 /*return*/, {
	                        installationEntry: installationEntry,
	                        registrationPromise: registrationPromise
	                    }];
	            }
	        });
	    });
	}
	/**
	 * Creates a new Installation Entry if one does not exist.
	 * Also clears timed out pending requests.
	 */
	function updateOrCreateInstallationEntry(oldEntry) {
	    var entry = oldEntry || {
	        fid: generateFid(),
	        registrationStatus: 0 /* NOT_STARTED */
	    };
	    return clearTimedOutRequest(entry);
	}
	/**
	 * If the Firebase Installation is not registered yet, this will trigger the
	 * registration and return an InProgressInstallationEntry.
	 *
	 * If registrationPromise does not exist, the installationEntry is guaranteed
	 * to be registered.
	 */
	function triggerRegistrationIfNecessary(appConfig, installationEntry) {
	    if (installationEntry.registrationStatus === 0 /* NOT_STARTED */) {
	        if (!navigator.onLine) {
	            // Registration required but app is offline.
	            var registrationPromiseWithError = Promise.reject(ERROR_FACTORY.create("app-offline" /* APP_OFFLINE */));
	            return {
	                installationEntry: installationEntry,
	                registrationPromise: registrationPromiseWithError
	            };
	        }
	        // Try registering. Change status to IN_PROGRESS.
	        var inProgressEntry = {
	            fid: installationEntry.fid,
	            registrationStatus: 1 /* IN_PROGRESS */,
	            registrationTime: Date.now()
	        };
	        var registrationPromise = registerInstallation(appConfig, inProgressEntry);
	        return { installationEntry: inProgressEntry, registrationPromise: registrationPromise };
	    }
	    else if (installationEntry.registrationStatus === 1 /* IN_PROGRESS */) {
	        return {
	            installationEntry: installationEntry,
	            registrationPromise: waitUntilFidRegistration(appConfig)
	        };
	    }
	    else {
	        return { installationEntry: installationEntry };
	    }
	}
	/** This will be executed only once for each new Firebase Installation. */
	function registerInstallation(appConfig, installationEntry) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var registeredInstallationEntry, e_1;
	        return tslib.__generator(this, function (_a) {
	            switch (_a.label) {
	                case 0:
	                    _a.trys.push([0, 2, , 7]);
	                    return [4 /*yield*/, createInstallationRequest(appConfig, installationEntry)];
	                case 1:
	                    registeredInstallationEntry = _a.sent();
	                    return [2 /*return*/, set(appConfig, registeredInstallationEntry)];
	                case 2:
	                    e_1 = _a.sent();
	                    if (!(isServerError(e_1) && e_1.serverCode === 409)) return [3 /*break*/, 4];
	                    // Server returned a "FID can not be used" error.
	                    // Generate a new ID next time.
	                    return [4 /*yield*/, remove(appConfig)];
	                case 3:
	                    // Server returned a "FID can not be used" error.
	                    // Generate a new ID next time.
	                    _a.sent();
	                    return [3 /*break*/, 6];
	                case 4: 
	                // Registration failed. Set FID as not registered.
	                return [4 /*yield*/, set(appConfig, {
	                        fid: installationEntry.fid,
	                        registrationStatus: 0 /* NOT_STARTED */
	                    })];
	                case 5:
	                    // Registration failed. Set FID as not registered.
	                    _a.sent();
	                    _a.label = 6;
	                case 6: throw e_1;
	                case 7: return [2 /*return*/];
	            }
	        });
	    });
	}
	/** Call if FID registration is pending in another request. */
	function waitUntilFidRegistration(appConfig) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var entry, _a, installationEntry, registrationPromise;
	        return tslib.__generator(this, function (_b) {
	            switch (_b.label) {
	                case 0: return [4 /*yield*/, updateInstallationRequest(appConfig)];
	                case 1:
	                    entry = _b.sent();
	                    _b.label = 2;
	                case 2:
	                    if (!(entry.registrationStatus === 1 /* IN_PROGRESS */)) return [3 /*break*/, 5];
	                    // createInstallation request still in progress.
	                    return [4 /*yield*/, sleep(100)];
	                case 3:
	                    // createInstallation request still in progress.
	                    _b.sent();
	                    return [4 /*yield*/, updateInstallationRequest(appConfig)];
	                case 4:
	                    entry = _b.sent();
	                    return [3 /*break*/, 2];
	                case 5:
	                    if (!(entry.registrationStatus === 0 /* NOT_STARTED */)) return [3 /*break*/, 7];
	                    return [4 /*yield*/, getInstallationEntry(appConfig)];
	                case 6:
	                    _a = _b.sent(), installationEntry = _a.installationEntry, registrationPromise = _a.registrationPromise;
	                    if (registrationPromise) {
	                        return [2 /*return*/, registrationPromise];
	                    }
	                    else {
	                        // if there is no registrationPromise, entry is registered.
	                        return [2 /*return*/, installationEntry];
	                    }
	                case 7: return [2 /*return*/, entry];
	            }
	        });
	    });
	}
	/**
	 * Called only if there is a CreateInstallation request in progress.
	 *
	 * Updates the InstallationEntry in the DB based on the status of the
	 * CreateInstallation request.
	 *
	 * Returns the updated InstallationEntry.
	 */
	function updateInstallationRequest(appConfig) {
	    return update(appConfig, function (oldEntry) {
	        if (!oldEntry) {
	            throw ERROR_FACTORY.create("installation-not-found" /* INSTALLATION_NOT_FOUND */);
	        }
	        return clearTimedOutRequest(oldEntry);
	    });
	}
	function clearTimedOutRequest(entry) {
	    if (hasInstallationRequestTimedOut(entry)) {
	        return {
	            fid: entry.fid,
	            registrationStatus: 0 /* NOT_STARTED */
	        };
	    }
	    return entry;
	}
	function hasInstallationRequestTimedOut(installationEntry) {
	    return (installationEntry.registrationStatus === 1 /* IN_PROGRESS */ &&
	        installationEntry.registrationTime + PENDING_TIMEOUT_MS < Date.now());
	}
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function generateAuthTokenRequest(_a, installationEntry) {
	    var appConfig = _a.appConfig, platformLoggerProvider = _a.platformLoggerProvider;
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var endpoint, headers, platformLogger, body, request, response, responseValue, completedAuthToken;
	        return tslib.__generator(this, function (_b) {
	            switch (_b.label) {
	                case 0:
	                    endpoint = getGenerateAuthTokenEndpoint(appConfig, installationEntry);
	                    headers = getHeadersWithAuth(appConfig, installationEntry);
	                    platformLogger = platformLoggerProvider.getImmediate({
	                        optional: true
	                    });
	                    if (platformLogger) {
	                        headers.append('x-firebase-client', platformLogger.getPlatformInfoString());
	                    }
	                    body = {
	                        installation: {
	                            sdkVersion: PACKAGE_VERSION
	                        }
	                    };
	                    request = {
	                        method: 'POST',
	                        headers: headers,
	                        body: JSON.stringify(body)
	                    };
	                    return [4 /*yield*/, retryIfServerError(function () { return fetch(endpoint, request); })];
	                case 1:
	                    response = _b.sent();
	                    if (!response.ok) return [3 /*break*/, 3];
	                    return [4 /*yield*/, response.json()];
	                case 2:
	                    responseValue = _b.sent();
	                    completedAuthToken = extractAuthTokenInfoFromResponse(responseValue);
	                    return [2 /*return*/, completedAuthToken];
	                case 3: return [4 /*yield*/, getErrorFromResponse('Generate Auth Token', response)];
	                case 4: throw _b.sent();
	            }
	        });
	    });
	}
	function getGenerateAuthTokenEndpoint(appConfig, _a) {
	    var fid = _a.fid;
	    return getInstallationsEndpoint(appConfig) + "/" + fid + "/authTokens:generate";
	}
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Returns a valid authentication token for the installation. Generates a new
	 * token if one doesn't exist, is expired or about to expire.
	 *
	 * Should only be called if the Firebase Installation is registered.
	 */
	function refreshAuthToken(dependencies, forceRefresh) {
	    if (forceRefresh === void 0) { forceRefresh = false; }
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var tokenPromise, entry, authToken, _a;
	        return tslib.__generator(this, function (_b) {
	            switch (_b.label) {
	                case 0: return [4 /*yield*/, update(dependencies.appConfig, function (oldEntry) {
	                        if (!isEntryRegistered(oldEntry)) {
	                            throw ERROR_FACTORY.create("not-registered" /* NOT_REGISTERED */);
	                        }
	                        var oldAuthToken = oldEntry.authToken;
	                        if (!forceRefresh && isAuthTokenValid(oldAuthToken)) {
	                            // There is a valid token in the DB.
	                            return oldEntry;
	                        }
	                        else if (oldAuthToken.requestStatus === 1 /* IN_PROGRESS */) {
	                            // There already is a token request in progress.
	                            tokenPromise = waitUntilAuthTokenRequest(dependencies, forceRefresh);
	                            return oldEntry;
	                        }
	                        else {
	                            // No token or token expired.
	                            if (!navigator.onLine) {
	                                throw ERROR_FACTORY.create("app-offline" /* APP_OFFLINE */);
	                            }
	                            var inProgressEntry = makeAuthTokenRequestInProgressEntry(oldEntry);
	                            tokenPromise = fetchAuthTokenFromServer(dependencies, inProgressEntry);
	                            return inProgressEntry;
	                        }
	                    })];
	                case 1:
	                    entry = _b.sent();
	                    if (!tokenPromise) return [3 /*break*/, 3];
	                    return [4 /*yield*/, tokenPromise];
	                case 2:
	                    _a = _b.sent();
	                    return [3 /*break*/, 4];
	                case 3:
	                    _a = entry.authToken;
	                    _b.label = 4;
	                case 4:
	                    authToken = _a;
	                    return [2 /*return*/, authToken];
	            }
	        });
	    });
	}
	/**
	 * Call only if FID is registered and Auth Token request is in progress.
	 *
	 * Waits until the current pending request finishes. If the request times out,
	 * tries once in this thread as well.
	 */
	function waitUntilAuthTokenRequest(dependencies, forceRefresh) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var entry, authToken;
	        return tslib.__generator(this, function (_a) {
	            switch (_a.label) {
	                case 0: return [4 /*yield*/, updateAuthTokenRequest(dependencies.appConfig)];
	                case 1:
	                    entry = _a.sent();
	                    _a.label = 2;
	                case 2:
	                    if (!(entry.authToken.requestStatus === 1 /* IN_PROGRESS */)) return [3 /*break*/, 5];
	                    // generateAuthToken still in progress.
	                    return [4 /*yield*/, sleep(100)];
	                case 3:
	                    // generateAuthToken still in progress.
	                    _a.sent();
	                    return [4 /*yield*/, updateAuthTokenRequest(dependencies.appConfig)];
	                case 4:
	                    entry = _a.sent();
	                    return [3 /*break*/, 2];
	                case 5:
	                    authToken = entry.authToken;
	                    if (authToken.requestStatus === 0 /* NOT_STARTED */) {
	                        // The request timed out or failed in a different call. Try again.
	                        return [2 /*return*/, refreshAuthToken(dependencies, forceRefresh)];
	                    }
	                    else {
	                        return [2 /*return*/, authToken];
	                    }
	            }
	        });
	    });
	}
	/**
	 * Called only if there is a GenerateAuthToken request in progress.
	 *
	 * Updates the InstallationEntry in the DB based on the status of the
	 * GenerateAuthToken request.
	 *
	 * Returns the updated InstallationEntry.
	 */
	function updateAuthTokenRequest(appConfig) {
	    return update(appConfig, function (oldEntry) {
	        if (!isEntryRegistered(oldEntry)) {
	            throw ERROR_FACTORY.create("not-registered" /* NOT_REGISTERED */);
	        }
	        var oldAuthToken = oldEntry.authToken;
	        if (hasAuthTokenRequestTimedOut(oldAuthToken)) {
	            return tslib.__assign(tslib.__assign({}, oldEntry), { authToken: { requestStatus: 0 /* NOT_STARTED */ } });
	        }
	        return oldEntry;
	    });
	}
	function fetchAuthTokenFromServer(dependencies, installationEntry) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var authToken, updatedInstallationEntry, e_1, updatedInstallationEntry;
	        return tslib.__generator(this, function (_a) {
	            switch (_a.label) {
	                case 0:
	                    _a.trys.push([0, 3, , 8]);
	                    return [4 /*yield*/, generateAuthTokenRequest(dependencies, installationEntry)];
	                case 1:
	                    authToken = _a.sent();
	                    updatedInstallationEntry = tslib.__assign(tslib.__assign({}, installationEntry), { authToken: authToken });
	                    return [4 /*yield*/, set(dependencies.appConfig, updatedInstallationEntry)];
	                case 2:
	                    _a.sent();
	                    return [2 /*return*/, authToken];
	                case 3:
	                    e_1 = _a.sent();
	                    if (!(isServerError(e_1) && (e_1.serverCode === 401 || e_1.serverCode === 404))) return [3 /*break*/, 5];
	                    // Server returned a "FID not found" or a "Invalid authentication" error.
	                    // Generate a new ID next time.
	                    return [4 /*yield*/, remove(dependencies.appConfig)];
	                case 4:
	                    // Server returned a "FID not found" or a "Invalid authentication" error.
	                    // Generate a new ID next time.
	                    _a.sent();
	                    return [3 /*break*/, 7];
	                case 5:
	                    updatedInstallationEntry = tslib.__assign(tslib.__assign({}, installationEntry), { authToken: { requestStatus: 0 /* NOT_STARTED */ } });
	                    return [4 /*yield*/, set(dependencies.appConfig, updatedInstallationEntry)];
	                case 6:
	                    _a.sent();
	                    _a.label = 7;
	                case 7: throw e_1;
	                case 8: return [2 /*return*/];
	            }
	        });
	    });
	}
	function isEntryRegistered(installationEntry) {
	    return (installationEntry !== undefined &&
	        installationEntry.registrationStatus === 2 /* COMPLETED */);
	}
	function isAuthTokenValid(authToken) {
	    return (authToken.requestStatus === 2 /* COMPLETED */ &&
	        !isAuthTokenExpired(authToken));
	}
	function isAuthTokenExpired(authToken) {
	    var now = Date.now();
	    return (now < authToken.creationTime ||
	        authToken.creationTime + authToken.expiresIn < now + TOKEN_EXPIRATION_BUFFER);
	}
	/** Returns an updated InstallationEntry with an InProgressAuthToken. */
	function makeAuthTokenRequestInProgressEntry(oldEntry) {
	    var inProgressAuthToken = {
	        requestStatus: 1 /* IN_PROGRESS */,
	        requestTime: Date.now()
	    };
	    return tslib.__assign(tslib.__assign({}, oldEntry), { authToken: inProgressAuthToken });
	}
	function hasAuthTokenRequestTimedOut(authToken) {
	    return (authToken.requestStatus === 1 /* IN_PROGRESS */ &&
	        authToken.requestTime + PENDING_TIMEOUT_MS < Date.now());
	}
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function getId(dependencies) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var _a, installationEntry, registrationPromise;
	        return tslib.__generator(this, function (_b) {
	            switch (_b.label) {
	                case 0: return [4 /*yield*/, getInstallationEntry(dependencies.appConfig)];
	                case 1:
	                    _a = _b.sent(), installationEntry = _a.installationEntry, registrationPromise = _a.registrationPromise;
	                    if (registrationPromise) {
	                        registrationPromise.catch(console.error);
	                    }
	                    else {
	                        // If the installation is already registered, update the authentication
	                        // token if needed.
	                        refreshAuthToken(dependencies).catch(console.error);
	                    }
	                    return [2 /*return*/, installationEntry.fid];
	            }
	        });
	    });
	}
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function getToken(dependencies, forceRefresh) {
	    if (forceRefresh === void 0) { forceRefresh = false; }
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var authToken;
	        return tslib.__generator(this, function (_a) {
	            switch (_a.label) {
	                case 0: return [4 /*yield*/, completeInstallationRegistration(dependencies.appConfig)];
	                case 1:
	                    _a.sent();
	                    return [4 /*yield*/, refreshAuthToken(dependencies, forceRefresh)];
	                case 2:
	                    authToken = _a.sent();
	                    return [2 /*return*/, authToken.token];
	            }
	        });
	    });
	}
	function completeInstallationRegistration(appConfig) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var registrationPromise;
	        return tslib.__generator(this, function (_a) {
	            switch (_a.label) {
	                case 0: return [4 /*yield*/, getInstallationEntry(appConfig)];
	                case 1:
	                    registrationPromise = (_a.sent()).registrationPromise;
	                    if (!registrationPromise) return [3 /*break*/, 3];
	                    // A createInstallation request is in progress. Wait until it finishes.
	                    return [4 /*yield*/, registrationPromise];
	                case 2:
	                    // A createInstallation request is in progress. Wait until it finishes.
	                    _a.sent();
	                    _a.label = 3;
	                case 3: return [2 /*return*/];
	            }
	        });
	    });
	}
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function deleteInstallationRequest(appConfig, installationEntry) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var endpoint, headers, request, response;
	        return tslib.__generator(this, function (_a) {
	            switch (_a.label) {
	                case 0:
	                    endpoint = getDeleteEndpoint(appConfig, installationEntry);
	                    headers = getHeadersWithAuth(appConfig, installationEntry);
	                    request = {
	                        method: 'DELETE',
	                        headers: headers
	                    };
	                    return [4 /*yield*/, retryIfServerError(function () { return fetch(endpoint, request); })];
	                case 1:
	                    response = _a.sent();
	                    if (!!response.ok) return [3 /*break*/, 3];
	                    return [4 /*yield*/, getErrorFromResponse('Delete Installation', response)];
	                case 2: throw _a.sent();
	                case 3: return [2 /*return*/];
	            }
	        });
	    });
	}
	function getDeleteEndpoint(appConfig, _a) {
	    var fid = _a.fid;
	    return getInstallationsEndpoint(appConfig) + "/" + fid;
	}
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function deleteInstallation(dependencies) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var appConfig, entry;
	        return tslib.__generator(this, function (_a) {
	            switch (_a.label) {
	                case 0:
	                    appConfig = dependencies.appConfig;
	                    return [4 /*yield*/, update(appConfig, function (oldEntry) {
	                            if (oldEntry && oldEntry.registrationStatus === 0 /* NOT_STARTED */) {
	                                // Delete the unregistered entry without sending a deleteInstallation request.
	                                return undefined;
	                            }
	                            return oldEntry;
	                        })];
	                case 1:
	                    entry = _a.sent();
	                    if (!entry) return [3 /*break*/, 6];
	                    if (!(entry.registrationStatus === 1 /* IN_PROGRESS */)) return [3 /*break*/, 2];
	                    // Can't delete while trying to register.
	                    throw ERROR_FACTORY.create("delete-pending-registration" /* DELETE_PENDING_REGISTRATION */);
	                case 2:
	                    if (!(entry.registrationStatus === 2 /* COMPLETED */)) return [3 /*break*/, 6];
	                    if (!!navigator.onLine) return [3 /*break*/, 3];
	                    throw ERROR_FACTORY.create("app-offline" /* APP_OFFLINE */);
	                case 3: return [4 /*yield*/, deleteInstallationRequest(appConfig, entry)];
	                case 4:
	                    _a.sent();
	                    return [4 /*yield*/, remove(appConfig)];
	                case 5:
	                    _a.sent();
	                    _a.label = 6;
	                case 6: return [2 /*return*/];
	            }
	        });
	    });
	}
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Sets a new callback that will get called when Installation ID changes.
	 * Returns an unsubscribe function that will remove the callback when called.
	 */
	function onIdChange(_a, callback) {
	    var appConfig = _a.appConfig;
	    addCallback(appConfig, callback);
	    return function () {
	        removeCallback(appConfig, callback);
	    };
	}
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function extractAppConfig(app) {
	    var e_1, _a;
	    if (!app || !app.options) {
	        throw getMissingValueError('App Configuration');
	    }
	    if (!app.name) {
	        throw getMissingValueError('App Name');
	    }
	    // Required app config keys
	    var configKeys = [
	        'projectId',
	        'apiKey',
	        'appId'
	    ];
	    try {
	        for (var configKeys_1 = tslib.__values(configKeys), configKeys_1_1 = configKeys_1.next(); !configKeys_1_1.done; configKeys_1_1 = configKeys_1.next()) {
	            var keyName = configKeys_1_1.value;
	            if (!app.options[keyName]) {
	                throw getMissingValueError(keyName);
	            }
	        }
	    }
	    catch (e_1_1) { e_1 = { error: e_1_1 }; }
	    finally {
	        try {
	            if (configKeys_1_1 && !configKeys_1_1.done && (_a = configKeys_1.return)) _a.call(configKeys_1);
	        }
	        finally { if (e_1) throw e_1.error; }
	    }
	    return {
	        appName: app.name,
	        projectId: app.options.projectId,
	        apiKey: app.options.apiKey,
	        appId: app.options.appId
	    };
	}
	function getMissingValueError(valueName) {
	    return ERROR_FACTORY.create("missing-app-config-values" /* MISSING_APP_CONFIG_VALUES */, {
	        valueName: valueName
	    });
	}
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function registerInstallations(instance) {
	    var installationsName = 'installations';
	    instance.INTERNAL.registerComponent(new component.Component(installationsName, function (container) {
	        var app = container.getProvider('app').getImmediate();
	        // Throws if app isn't configured properly.
	        var appConfig = extractAppConfig(app);
	        var platformLoggerProvider = container.getProvider('platform-logger');
	        var dependencies = {
	            appConfig: appConfig,
	            platformLoggerProvider: platformLoggerProvider
	        };
	        var installations = {
	            app: app,
	            getId: function () { return getId(dependencies); },
	            getToken: function (forceRefresh) {
	                return getToken(dependencies, forceRefresh);
	            },
	            delete: function () { return deleteInstallation(dependencies); },
	            onIdChange: function (callback) {
	                return onIdChange(dependencies, callback);
	            }
	        };
	        return installations;
	    }, "PUBLIC" /* PUBLIC */));
	    instance.registerVersion(name, version);
	}
	registerInstallations(firebase);
	
	exports.registerInstallations = registerInstallations;
	//# sourceMappingURL=index.cjs.js.map


/***/ }),
/* 268 */
262,
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var firebase = _interopDefault(__webpack_require__(39));
	__webpack_require__(267);
	var tslib = __webpack_require__(270);
	var util = __webpack_require__(59);
	var logger$1 = __webpack_require__(102);
	var component = __webpack_require__(58);
	
	var name = "@firebase/performance";
	var version = "0.3.4";
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var SDK_VERSION = version;
	/** The prefix for start User Timing marks used for creating Traces. */
	var TRACE_START_MARK_PREFIX = 'FB-PERF-TRACE-START';
	/** The prefix for stop User Timing marks used for creating Traces. */
	var TRACE_STOP_MARK_PREFIX = 'FB-PERF-TRACE-STOP';
	/** The prefix for User Timing measure used for creating Traces. */
	var TRACE_MEASURE_PREFIX = 'FB-PERF-TRACE-MEASURE';
	/** The prefix for out of the box page load Trace name. */
	var OOB_TRACE_PAGE_LOAD_PREFIX = '_wt_';
	var FIRST_PAINT_COUNTER_NAME = '_fp';
	var FIRST_CONTENTFUL_PAINT_COUNTER_NAME = '_fcp';
	var FIRST_INPUT_DELAY_COUNTER_NAME = '_fid';
	var CONFIG_LOCAL_STORAGE_KEY = '@firebase/performance/config';
	var CONFIG_EXPIRY_LOCAL_STORAGE_KEY = '@firebase/performance/configexpire';
	var SERVICE = 'performance';
	var SERVICE_NAME = 'Performance';
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var _a;
	var ERROR_DESCRIPTION_MAP = (_a = {},
	    _a["trace started" /* TRACE_STARTED_BEFORE */] = 'Trace {$traceName} was started before.',
	    _a["trace stopped" /* TRACE_STOPPED_BEFORE */] = 'Trace {$traceName} is not running.',
	    _a["no window" /* NO_WINDOW */] = 'Window is not available.',
	    _a["no app id" /* NO_APP_ID */] = 'App id is not available.',
	    _a["no project id" /* NO_PROJECT_ID */] = 'Project id is not available.',
	    _a["no api key" /* NO_API_KEY */] = 'Api key is not available.',
	    _a["invalid cc log" /* INVALID_CC_LOG */] = 'Attempted to queue invalid cc event',
	    _a["FB not default" /* FB_NOT_DEFAULT */] = 'Performance can only start when Firebase app instance is the default one.',
	    _a["RC response not ok" /* RC_NOT_OK */] = 'RC response is not ok',
	    _a["invalid attribute name" /* INVALID_ATTRIBUTE_NAME */] = 'Attribute name {$attributeName} is invalid.',
	    _a["invalid attribute value" /* INVALID_ATTRIBUTE_VALUE */] = 'Attribute value {$attributeValue} is invalid.',
	    _a["invalid custom metric name" /* INVALID_CUSTOM_METRIC_NAME */] = 'Custom metric name {$customMetricName} is invalid',
	    _a["invalid String merger input" /* INVALID_STRING_MERGER_PARAMETER */] = 'Input for String merger is invalid, contact support team to resolve.',
	    _a);
	var ERROR_FACTORY = new util.ErrorFactory(SERVICE, SERVICE_NAME, ERROR_DESCRIPTION_MAP);
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var apiInstance;
	var windowInstance;
	/**
	 * This class holds a reference to various browser related objects injected by
	 * set methods.
	 */
	var Api = /** @class */ (function () {
	    function Api(window) {
	        this.window = window;
	        if (!window) {
	            throw ERROR_FACTORY.create("no window" /* NO_WINDOW */);
	        }
	        this.performance = window.performance;
	        this.PerformanceObserver = window.PerformanceObserver;
	        this.windowLocation = window.location;
	        this.navigator = window.navigator;
	        this.document = window.document;
	        if (this.navigator && this.navigator.cookieEnabled) {
	            // If user blocks cookies on the browser, accessing localStorage will
	            // throw an exception.
	            this.localStorage = window.localStorage;
	        }
	        if (window.perfMetrics && window.perfMetrics.onFirstInputDelay) {
	            this.onFirstInputDelay = window.perfMetrics.onFirstInputDelay;
	        }
	    }
	    Api.prototype.getUrl = function () {
	        // Do not capture the string query part of url.
	        return this.windowLocation.href.split('?')[0];
	    };
	    Api.prototype.mark = function (name) {
	        if (!this.performance || !this.performance.mark) {
	            return;
	        }
	        this.performance.mark(name);
	    };
	    Api.prototype.measure = function (measureName, mark1, mark2) {
	        if (!this.performance || !this.performance.measure) {
	            return;
	        }
	        this.performance.measure(measureName, mark1, mark2);
	    };
	    Api.prototype.getEntriesByType = function (type) {
	        if (!this.performance || !this.performance.getEntriesByType) {
	            return [];
	        }
	        return this.performance.getEntriesByType(type);
	    };
	    Api.prototype.getEntriesByName = function (name) {
	        if (!this.performance || !this.performance.getEntriesByName) {
	            return [];
	        }
	        return this.performance.getEntriesByName(name);
	    };
	    Api.prototype.getTimeOrigin = function () {
	        // Polyfill the time origin with performance.timing.navigationStart.
	        return (this.performance &&
	            (this.performance.timeOrigin || this.performance.timing.navigationStart));
	    };
	    Api.prototype.requiredApisAvailable = function () {
	        if (fetch && Promise && this.navigator && this.navigator.cookieEnabled) {
	            return true;
	        }
	        return false;
	    };
	    Api.prototype.setupObserver = function (entryType, callback) {
	        if (!this.PerformanceObserver) {
	            return;
	        }
	        var observer = new this.PerformanceObserver(function (list) {
	            for (var _i = 0, _a = list.getEntries(); _i < _a.length; _i++) {
	                var entry = _a[_i];
	                // `entry` is a PerformanceEntry instance.
	                callback(entry);
	            }
	        });
	        // Start observing the entry types you care about.
	        observer.observe({ entryTypes: [entryType] });
	    };
	    Api.getInstance = function () {
	        if (apiInstance === undefined) {
	            apiInstance = new Api(windowInstance);
	        }
	        return apiInstance;
	    };
	    return Api;
	}());
	function setupApi(window) {
	    windowInstance = window;
	}
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function mergeStrings(part1, part2) {
	    var sizeDiff = part1.length - part2.length;
	    if (sizeDiff < 0 || sizeDiff > 1) {
	        throw ERROR_FACTORY.create("invalid String merger input" /* INVALID_STRING_MERGER_PARAMETER */);
	    }
	    var resultArray = [];
	    for (var i = 0; i < part1.length; i++) {
	        resultArray.push(part1.charAt(i));
	        if (part2.length > i) {
	            resultArray.push(part2.charAt(i));
	        }
	    }
	    return resultArray.join('');
	}
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var settingsServiceInstance;
	var SettingsService = /** @class */ (function () {
	    function SettingsService() {
	        // The variable which controls logging of automatic traces and HTTP/S network monitoring.
	        this.instrumentationEnabled = true;
	        // The variable which controls logging of custom traces.
	        this.dataCollectionEnabled = true;
	        // Configuration flags set through remote config.
	        this.loggingEnabled = false;
	        // Sampling rate between 0 and 1.
	        this.tracesSamplingRate = 1;
	        this.networkRequestsSamplingRate = 1;
	        // Address of logging service.
	        this.logEndPointUrl = 'https://firebaselogging.googleapis.com/v0cc/log?format=json_proto';
	        // Performance event transport endpoint URL which should be compatible with proto3.
	        // New Address for transport service, not configurable via Remote Config.
	        this.flTransportEndpointUrl = mergeStrings('hts/frbslgigp.ogepscmv/ieo/eaylg', 'tp:/ieaeogn-agolai.o/1frlglgc/o');
	        this.transportKey = mergeStrings('AzSC8r6ReiGqFMyfvgow', 'Iayx0u-XT3vksVM-pIV');
	        this.shouldSendToFl = false;
	        // Source type for performance event logs.
	        this.logSource = 462;
	        // Flags which control per session logging of traces and network requests.
	        this.logTraceAfterSampling = false;
	        this.logNetworkAfterSampling = false;
	        // TTL of config retrieved from remote config in hours.
	        this.configTimeToLive = 12;
	    }
	    SettingsService.prototype.getAppId = function () {
	        var appId = this.firebaseAppInstance &&
	            this.firebaseAppInstance.options &&
	            this.firebaseAppInstance.options.appId;
	        if (!appId) {
	            throw ERROR_FACTORY.create("no app id" /* NO_APP_ID */);
	        }
	        return appId;
	    };
	    SettingsService.prototype.getProjectId = function () {
	        var projectId = this.firebaseAppInstance &&
	            this.firebaseAppInstance.options &&
	            this.firebaseAppInstance.options.projectId;
	        if (!projectId) {
	            throw ERROR_FACTORY.create("no project id" /* NO_PROJECT_ID */);
	        }
	        return projectId;
	    };
	    SettingsService.prototype.getApiKey = function () {
	        var apiKey = this.firebaseAppInstance &&
	            this.firebaseAppInstance.options &&
	            this.firebaseAppInstance.options.apiKey;
	        if (!apiKey) {
	            throw ERROR_FACTORY.create("no api key" /* NO_API_KEY */);
	        }
	        return apiKey;
	    };
	    SettingsService.prototype.getFlTransportFullUrl = function () {
	        return this.flTransportEndpointUrl.concat('?key=', this.transportKey);
	    };
	    SettingsService.getInstance = function () {
	        if (settingsServiceInstance === undefined) {
	            settingsServiceInstance = new SettingsService();
	        }
	        return settingsServiceInstance;
	    };
	    return SettingsService;
	}());
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var iid;
	function getIidPromise() {
	    var iidPromise = SettingsService.getInstance().installationsService.getId();
	    // eslint-disable-next-line @typescript-eslint/no-floating-promises
	    iidPromise.then(function (iidVal) {
	        iid = iidVal;
	    });
	    return iidPromise;
	}
	// This method should be used after the iid is retrieved by getIidPromise method.
	function getIid() {
	    return iid;
	}
	function getAuthTokenPromise() {
	    var authTokenPromise = SettingsService.getInstance().installationsService.getToken();
	    // eslint-disable-next-line @typescript-eslint/no-floating-promises
	    authTokenPromise.then(function (authTokenVal) {
	    });
	    return authTokenPromise;
	}
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var VisibilityState;
	(function (VisibilityState) {
	    VisibilityState[VisibilityState["UNKNOWN"] = 0] = "UNKNOWN";
	    VisibilityState[VisibilityState["VISIBLE"] = 1] = "VISIBLE";
	    VisibilityState[VisibilityState["HIDDEN"] = 2] = "HIDDEN";
	})(VisibilityState || (VisibilityState = {}));
	var RESERVED_ATTRIBUTE_PREFIXES = ['firebase_', 'google_', 'ga_'];
	var ATTRIBUTE_FORMAT_REGEX = new RegExp('^[a-zA-Z]\\w*$');
	var MAX_ATTRIBUTE_NAME_LENGTH = 40;
	var MAX_ATTRIBUTE_VALUE_LENGTH = 100;
	function getServiceWorkerStatus() {
	    var navigator = Api.getInstance().navigator;
	    if ('serviceWorker' in navigator) {
	        if (navigator.serviceWorker.controller) {
	            return 2 /* CONTROLLED */;
	        }
	        else {
	            return 3 /* UNCONTROLLED */;
	        }
	    }
	    else {
	        return 1 /* UNSUPPORTED */;
	    }
	}
	function getVisibilityState() {
	    var document = Api.getInstance().document;
	    var visibilityState = document.visibilityState;
	    switch (visibilityState) {
	        case 'visible':
	            return VisibilityState.VISIBLE;
	        case 'hidden':
	            return VisibilityState.HIDDEN;
	        default:
	            return VisibilityState.UNKNOWN;
	    }
	}
	function getEffectiveConnectionType() {
	    var navigator = Api.getInstance().navigator;
	    var navigatorConnection = navigator.connection;
	    var effectiveType = navigatorConnection && navigatorConnection.effectiveType;
	    switch (effectiveType) {
	        case 'slow-2g':
	            return 1 /* CONNECTION_SLOW_2G */;
	        case '2g':
	            return 2 /* CONNECTION_2G */;
	        case '3g':
	            return 3 /* CONNECTION_3G */;
	        case '4g':
	            return 4 /* CONNECTION_4G */;
	        default:
	            return 0 /* UNKNOWN */;
	    }
	}
	function isValidCustomAttributeName(name) {
	    if (name.length === 0 || name.length > MAX_ATTRIBUTE_NAME_LENGTH) {
	        return false;
	    }
	    var matchesReservedPrefix = RESERVED_ATTRIBUTE_PREFIXES.some(function (prefix) {
	        return name.startsWith(prefix);
	    });
	    return !matchesReservedPrefix && !!name.match(ATTRIBUTE_FORMAT_REGEX);
	}
	function isValidCustomAttributeValue(value) {
	    return value.length !== 0 && value.length <= MAX_ATTRIBUTE_VALUE_LENGTH;
	}
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var consoleLogger = new logger$1.Logger(SERVICE_NAME);
	consoleLogger.logLevel = logger$1.LogLevel.INFO;
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var REMOTE_CONFIG_SDK_VERSION = '0.0.1';
	// These values will be used if the remote config object is successfully
	// retrieved, but the template does not have these fields.
	var DEFAULT_CONFIGS = {
	    loggingEnabled: true,
	    shouldSendToFl: true
	};
	// These values will be used if the remote config object is successfully
	// retrieved, but the config object state shows unspecified or no template.
	var NO_TEMPLATE_CONFIGS = {
	    shouldSendToFl: false
	};
	var FIS_AUTH_PREFIX = 'FIREBASE_INSTALLATIONS_AUTH';
	function getConfig(iid) {
	    var config = getStoredConfig();
	    if (config) {
	        processConfig(iid, config);
	        return Promise.resolve();
	    }
	    return getRemoteConfig(iid)
	        .then(function (config) { return processConfig(iid, config); })
	        .then(function (config) { return storeConfig(config); }, 
	    /** Do nothing for error, use defaults set in settings service. */
	    function () { });
	}
	function getStoredConfig() {
	    var localStorage = Api.getInstance().localStorage;
	    if (!localStorage) {
	        return;
	    }
	    var expiryString = localStorage.getItem(CONFIG_EXPIRY_LOCAL_STORAGE_KEY);
	    if (!expiryString || !configValid(expiryString)) {
	        return;
	    }
	    var configStringified = localStorage.getItem(CONFIG_LOCAL_STORAGE_KEY);
	    if (!configStringified) {
	        return;
	    }
	    try {
	        var configResponse = JSON.parse(configStringified);
	        return configResponse;
	    }
	    catch (_a) {
	        return;
	    }
	}
	function storeConfig(config) {
	    var localStorage = Api.getInstance().localStorage;
	    if (!config || !localStorage) {
	        return;
	    }
	    localStorage.setItem(CONFIG_LOCAL_STORAGE_KEY, JSON.stringify(config));
	    localStorage.setItem(CONFIG_EXPIRY_LOCAL_STORAGE_KEY, String(Date.now() +
	        SettingsService.getInstance().configTimeToLive * 60 * 60 * 1000));
	}
	var COULD_NOT_GET_CONFIG_MSG = 'Could not fetch config, will use default configs';
	function getRemoteConfig(iid) {
	    // Perf needs auth token only to retrieve remote config.
	    return getAuthTokenPromise()
	        .then(function (authToken) {
	        var projectId = SettingsService.getInstance().getProjectId();
	        var configEndPoint = "https://firebaseremoteconfig.googleapis.com/v1/projects/" + projectId + "/namespaces/fireperf:fetch?key=" + SettingsService.getInstance().getApiKey();
	        var request = new Request(configEndPoint, {
	            method: 'POST',
	            headers: { Authorization: FIS_AUTH_PREFIX + " " + authToken },
	            /* eslint-disable camelcase */
	            body: JSON.stringify({
	                app_instance_id: iid,
	                app_instance_id_token: authToken,
	                app_id: SettingsService.getInstance().getAppId(),
	                app_version: SDK_VERSION,
	                sdk_version: REMOTE_CONFIG_SDK_VERSION
	            })
	            /* eslint-enable camelcase */
	        });
	        return fetch(request).then(function (response) {
	            if (response.ok) {
	                return response.json();
	            }
	            // In case response is not ok. This will be caught by catch.
	            throw ERROR_FACTORY.create("RC response not ok" /* RC_NOT_OK */);
	        });
	    })
	        .catch(function () {
	        consoleLogger.info(COULD_NOT_GET_CONFIG_MSG);
	        return undefined;
	    });
	}
	/**
	 * Processes config coming either from calling RC or from local storage.
	 * This method only runs if call is successful or config in storage
	 * is valid.
	 */
	function processConfig(iid, config) {
	    if (!config) {
	        return config;
	    }
	    var settingsServiceInstance = SettingsService.getInstance();
	    var entries = config.entries || {};
	    var state = config.state;
	    if (entries.fpr_enabled !== undefined) {
	        // TODO: Change the assignment of loggingEnabled once the received type is
	        // known.
	        settingsServiceInstance.loggingEnabled =
	            String(entries.fpr_enabled) === 'true';
	    }
	    else {
	        // Config retrieved successfully, but there is no fpr_enabled in template.
	        // Use secondary configs value.
	        settingsServiceInstance.loggingEnabled = DEFAULT_CONFIGS.loggingEnabled;
	    }
	    if (entries.fpr_log_source) {
	        settingsServiceInstance.logSource = Number(entries.fpr_log_source);
	    }
	    if (entries.fpr_log_endpoint_url) {
	        settingsServiceInstance.logEndPointUrl = entries.fpr_log_endpoint_url;
	    }
	    // Key from Remote Config has to be non-empty string, otherwsie use local value.
	    if (entries.fpr_log_transport_key) {
	        settingsServiceInstance.transportKey = entries.fpr_log_transport_key;
	    }
	    // If config object state indicates that no template has been set, that means it is new user of
	    // Performance Monitoring and should use the old log endpoint, because it is guaranteed to work.
	    if (state === undefined ||
	        state === 'INSTANCE_STATE_UNSPECIFIED' ||
	        state === 'NO_TEMPLATE') {
	        {
	            settingsServiceInstance.shouldSendToFl =
	                NO_TEMPLATE_CONFIGS.shouldSendToFl;
	        }
	    }
	    else if (entries.fpr_log_transport_web_percent) {
	        // If config object state doesn't indicate no template, it can only be UPDATE for now.
	        // - Performance Monitoring doesn't set etag in request, therefore state cannot be NO_CHANGE.
	        // - Sampling rate flags and master flag are required, therefore state cannot be EMPTY_CONFIG.
	        // If config object state is UPDATE and rollout flag is present, determine endpoint by iid.
	        settingsServiceInstance.shouldSendToFl = isDestFl(iid, Number(entries.fpr_log_transport_web_percent));
	    }
	    else {
	        // If config object state is UPDATE and rollout flag is not present, that means rollout is
	        // complete and rollout flag is deprecated, therefore dispatch events to new transport endpoint.
	        settingsServiceInstance.shouldSendToFl = DEFAULT_CONFIGS.shouldSendToFl;
	    }
	    if (entries.fpr_vc_network_request_sampling_rate !== undefined) {
	        settingsServiceInstance.networkRequestsSamplingRate = Number(entries.fpr_vc_network_request_sampling_rate);
	    }
	    if (entries.fpr_vc_trace_sampling_rate !== undefined) {
	        settingsServiceInstance.tracesSamplingRate = Number(entries.fpr_vc_trace_sampling_rate);
	    }
	    // Set the per session trace and network logging flags.
	    settingsServiceInstance.logTraceAfterSampling = shouldLogAfterSampling(settingsServiceInstance.tracesSamplingRate);
	    settingsServiceInstance.logNetworkAfterSampling = shouldLogAfterSampling(settingsServiceInstance.networkRequestsSamplingRate);
	    return config;
	}
	function configValid(expiry) {
	    return Number(expiry) > Date.now();
	}
	function shouldLogAfterSampling(samplingRate) {
	    return Math.random() <= samplingRate;
	}
	/**
	 * True if event should be sent to Fl transport endpoint rather than CC transport endpoint.
	 * rolloutPercent is in range [0.0, 100.0].
	 * @param iid Installation ID which identifies a web app installed on client.
	 * @param rolloutPercent the possibility of this app sending events to Fl endpoint.
	 * @return true if this installation should send events to Fl endpoint.
	 */
	function isDestFl(iid, rolloutPercent) {
	    if (iid.length === 0) {
	        return false;
	    }
	    return getHashPercent(iid) < rolloutPercent;
	}
	/**
	 * Generate integer value range in [0, 99]. Implementation from String.hashCode() in Java.
	 * @param seed Same seed will generate consistent hash value using this algorithm.
	 * @return Hash value in range [0, 99], generated from seed and hash algorithm.
	 */
	function getHashPercent(seed) {
	    var hash = 0;
	    for (var i = 0; i < seed.length; i++) {
	        hash = (hash << 3) + hash - seed.charCodeAt(i);
	    }
	    hash = Math.abs(hash % 100);
	    return hash;
	}
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var initializationStatus = 1 /* notInitialized */;
	var initializationPromise;
	function getInitializationPromise() {
	    initializationStatus = 2 /* initializationPending */;
	    initializationPromise = initializationPromise || initializePerf();
	    return initializationPromise;
	}
	function isPerfInitialized() {
	    return initializationStatus === 3 /* initialized */;
	}
	function initializePerf() {
	    return getDocumentReadyComplete()
	        .then(function () { return getIidPromise(); })
	        .then(function (iid) { return getConfig(iid); })
	        .then(function () { return changeInitializationStatus(); }, function () { return changeInitializationStatus(); });
	}
	/**
	 * Returns a promise which resolves whenever the document readystate is complete or
	 * immediately if it is called after page load complete.
	 */
	function getDocumentReadyComplete() {
	    var document = Api.getInstance().document;
	    return new Promise(function (resolve) {
	        if (document && document.readyState !== 'complete') {
	            var handler_1 = function () {
	                if (document.readyState === 'complete') {
	                    document.removeEventListener('readystatechange', handler_1);
	                    resolve();
	                }
	            };
	            document.addEventListener('readystatechange', handler_1);
	        }
	        else {
	            resolve();
	        }
	    });
	}
	function changeInitializationStatus() {
	    initializationStatus = 3 /* initialized */;
	}
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var DEFAULT_SEND_INTERVAL_MS = 10 * 1000;
	var INITIAL_SEND_TIME_DELAY_MS = 5.5 * 1000;
	// If end point does not work, the call will be tried for these many times.
	var DEFAULT_REMAINING_TRIES = 3;
	var remainingTries = DEFAULT_REMAINING_TRIES;
	/* eslint-enable camelcase */
	var queue = [];
	var isTransportSetup = false;
	function setupTransportService() {
	    if (!isTransportSetup) {
	        processQueue(INITIAL_SEND_TIME_DELAY_MS);
	        isTransportSetup = true;
	    }
	}
	function processQueue(timeOffset) {
	    setTimeout(function () {
	        // If there is no remainingTries left, stop retrying.
	        if (remainingTries === 0) {
	            return;
	        }
	        // If there are no events to process, wait for DEFAULT_SEND_INTERVAL_MS and try again.
	        if (!queue.length) {
	            return processQueue(DEFAULT_SEND_INTERVAL_MS);
	        }
	        dispatchQueueEvents();
	    }, timeOffset);
	}
	function dispatchQueueEvents() {
	    // Capture a snapshot of the queue and empty the "official queue".
	    var staged = tslib.__spreadArrays(queue);
	    queue = [];
	    /* eslint-disable camelcase */
	    // We will pass the JSON serialized event to the backend.
	    var log_event = staged.map(function (evt) { return ({
	        source_extension_json_proto3: evt.message,
	        event_time_ms: String(evt.eventTime)
	    }); });
	    var data = {
	        request_time_ms: String(Date.now()),
	        client_info: {
	            client_type: 1,
	            js_client_info: {}
	        },
	        log_source: SettingsService.getInstance().logSource,
	        log_event: log_event
	    };
	    /* eslint-enable camelcase */
	    postToEndpoint(data, staged).catch(function () {
	        // If the request fails for some reason, add the events that were attempted
	        // back to the primary queue to retry later.
	        queue = tslib.__spreadArrays(staged, queue);
	        remainingTries--;
	        consoleLogger.info("Tries left: " + remainingTries + ".");
	        processQueue(DEFAULT_SEND_INTERVAL_MS);
	    });
	}
	function postToEndpoint(data, staged) {
	    // Gradually rollout traffic from cc to transport using remote config.
	    if (SettingsService.getInstance().shouldSendToFl) {
	        return sendEventsToFl(data, staged);
	    }
	    else {
	        return sendEventsToCc(data);
	    }
	}
	function sendEventsToFl(data, staged) {
	    return postToFlEndpoint(data)
	        .then(function (res) {
	        if (!res.ok) {
	            consoleLogger.info('Call to Firebase backend failed.');
	        }
	        return res.json();
	    })
	        .then(function (res) {
	        // Find the next call wait time from the response.
	        var transportWait = Number(res.nextRequestWaitMillis);
	        var requestOffset = DEFAULT_SEND_INTERVAL_MS;
	        if (!isNaN(transportWait)) {
	            requestOffset = Math.max(transportWait, requestOffset);
	        }
	        // Delete request if response include RESPONSE_ACTION_UNKNOWN or DELETE_REQUEST action.
	        // Otherwise, retry request using normal scheduling if response include RETRY_REQUEST_LATER.
	        var logResponseDetails = res.logResponseDetails;
	        if (Array.isArray(logResponseDetails) &&
	            logResponseDetails.length > 0 &&
	            logResponseDetails[0].responseAction === 'RETRY_REQUEST_LATER') {
	            queue = tslib.__spreadArrays(staged, queue);
	            consoleLogger.info("Retry transport request later.");
	        }
	        remainingTries = DEFAULT_REMAINING_TRIES;
	        // Schedule the next process.
	        processQueue(requestOffset);
	    });
	}
	function sendEventsToCc(data) {
	    return fetch(SettingsService.getInstance().logEndPointUrl, {
	        method: 'POST',
	        body: JSON.stringify(data)
	    })
	        .then(function (res) {
	        if (!res.ok) {
	            consoleLogger.info('Call to Firebase backend failed.');
	        }
	        return res.json();
	    })
	        .then(function (res) {
	        var wait = Number(res.next_request_wait_millis);
	        // Find the next call wait time from the response.
	        var requestOffset = isNaN(wait)
	            ? DEFAULT_SEND_INTERVAL_MS
	            : Math.max(DEFAULT_SEND_INTERVAL_MS, wait);
	        remainingTries = DEFAULT_REMAINING_TRIES;
	        // Schedule the next process.
	        processQueue(requestOffset);
	    });
	}
	function postToFlEndpoint(data) {
	    var flTransportFullUrl = SettingsService.getInstance().getFlTransportFullUrl();
	    return fetch(flTransportFullUrl, {
	        method: 'POST',
	        body: JSON.stringify(data)
	    });
	}
	function addToQueue(evt) {
	    if (!evt.eventTime || !evt.message) {
	        throw ERROR_FACTORY.create("invalid cc log" /* INVALID_CC_LOG */);
	    }
	    // Add the new event to the queue.
	    queue = tslib.__spreadArrays(queue, [evt]);
	}
	/** Log handler for cc service to send the performance logs to the server. */
	function transportHandler(
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	serializer) {
	    return function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        var message = serializer.apply(void 0, args);
	        addToQueue({
	            message: message,
	            eventTime: Date.now()
	        });
	    };
	}
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/* eslint-enble camelcase */
	var logger;
	// This method is not called before initialization.
	function sendLog(resource, resourceType) {
	    if (!logger) {
	        logger = transportHandler(serializer);
	    }
	    logger(resource, resourceType);
	}
	function logTrace(trace) {
	    var settingsService = SettingsService.getInstance();
	    // Do not log if trace is auto generated and instrumentation is disabled.
	    if (!settingsService.instrumentationEnabled && trace.isAuto) {
	        return;
	    }
	    // Do not log if trace is custom and data collection is disabled.
	    if (!settingsService.dataCollectionEnabled && !trace.isAuto) {
	        return;
	    }
	    // Do not log if required apis are not available.
	    if (!Api.getInstance().requiredApisAvailable()) {
	        return;
	    }
	    // Only log the page load auto traces if page is visible.
	    if (trace.isAuto && getVisibilityState() !== VisibilityState.VISIBLE) {
	        return;
	    }
	    if (!settingsService.loggingEnabled ||
	        !settingsService.logTraceAfterSampling) {
	        return;
	    }
	    if (isPerfInitialized()) {
	        sendTraceLog(trace);
	    }
	    else {
	        // Custom traces can be used before the initialization but logging
	        // should wait until after.
	        getInitializationPromise().then(function () { return sendTraceLog(trace); }, function () { return sendTraceLog(trace); });
	    }
	}
	function sendTraceLog(trace) {
	    if (getIid()) {
	        setTimeout(function () { return sendLog(trace, 1 /* Trace */); }, 0);
	    }
	}
	function logNetworkRequest(networkRequest) {
	    var settingsService = SettingsService.getInstance();
	    // Do not log network requests if instrumentation is disabled.
	    if (!settingsService.instrumentationEnabled) {
	        return;
	    }
	    // Do not log the js sdk's call to transport service domain to avoid unnecessary cycle.
	    // Need to blacklist both old and new endpoints to avoid migration gap.
	    var networkRequestUrl = networkRequest.url;
	    // Blacklist old log endpoint and new transport endpoint.
	    // Because Performance SDK doesn't instrument requests sent from SDK itself.
	    var logEndpointUrl = settingsService.logEndPointUrl.split('?')[0];
	    var flEndpointUrl = settingsService.flTransportEndpointUrl.split('?')[0];
	    if (networkRequestUrl === logEndpointUrl ||
	        networkRequestUrl === flEndpointUrl) {
	        return;
	    }
	    if (!settingsService.loggingEnabled ||
	        !settingsService.logNetworkAfterSampling) {
	        return;
	    }
	    setTimeout(function () { return sendLog(networkRequest, 0 /* NetworkRequest */); }, 0);
	}
	function serializer(resource, resourceType) {
	    if (resourceType === 0 /* NetworkRequest */) {
	        return serializeNetworkRequest(resource);
	    }
	    return serializeTrace(resource);
	}
	function serializeNetworkRequest(networkRequest) {
	    var networkRequestMetric = {
	        url: networkRequest.url,
	        http_method: networkRequest.httpMethod || 0,
	        http_response_code: 200,
	        response_payload_bytes: networkRequest.responsePayloadBytes,
	        client_start_time_us: networkRequest.startTimeUs,
	        time_to_response_initiated_us: networkRequest.timeToResponseInitiatedUs,
	        time_to_response_completed_us: networkRequest.timeToResponseCompletedUs
	    };
	    var perfMetric = {
	        application_info: getApplicationInfo(),
	        network_request_metric: networkRequestMetric
	    };
	    return JSON.stringify(perfMetric);
	}
	function serializeTrace(trace) {
	    var traceMetric = {
	        name: trace.name,
	        is_auto: trace.isAuto,
	        client_start_time_us: trace.startTimeUs,
	        duration_us: trace.durationUs
	    };
	    if (Object.keys(trace.counters).length !== 0) {
	        traceMetric.counters = trace.counters;
	    }
	    var customAttributes = trace.getAttributes();
	    if (Object.keys(customAttributes).length !== 0) {
	        traceMetric.custom_attributes = customAttributes;
	    }
	    var perfMetric = {
	        application_info: getApplicationInfo(),
	        trace_metric: traceMetric
	    };
	    return JSON.stringify(perfMetric);
	}
	function getApplicationInfo() {
	    return {
	        google_app_id: SettingsService.getInstance().getAppId(),
	        app_instance_id: getIid(),
	        web_app_info: {
	            sdk_version: SDK_VERSION,
	            page_url: Api.getInstance().getUrl(),
	            service_worker_status: getServiceWorkerStatus(),
	            visibility_state: getVisibilityState(),
	            effective_connection_type: getEffectiveConnectionType()
	        },
	        application_process_state: 0
	    };
	}
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var MAX_METRIC_NAME_LENGTH = 100;
	var RESERVED_AUTO_PREFIX = '_';
	var oobMetrics = [
	    FIRST_PAINT_COUNTER_NAME,
	    FIRST_CONTENTFUL_PAINT_COUNTER_NAME,
	    FIRST_INPUT_DELAY_COUNTER_NAME
	];
	/**
	 * Returns true if the metric is custom and does not start with reserved prefix, or if
	 * the metric is one of out of the box page load trace metrics.
	 */
	function isValidMetricName(name, traceName) {
	    if (name.length === 0 || name.length > MAX_METRIC_NAME_LENGTH) {
	        return false;
	    }
	    return ((traceName &&
	        traceName.startsWith(OOB_TRACE_PAGE_LOAD_PREFIX) &&
	        oobMetrics.indexOf(name) > -1) ||
	        !name.startsWith(RESERVED_AUTO_PREFIX));
	}
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var Trace = /** @class */ (function () {
	    /**
	     * @param name The name of the trace.
	     * @param isAuto If the trace is auto-instrumented.
	     * @param traceMeasureName The name of the measure marker in user timing specification. This field
	     * is only set when the trace is built for logging when the user directly uses the user timing
	     * api (performance.mark and performance.measure).
	     */
	    function Trace(name, isAuto, traceMeasureName) {
	        if (isAuto === void 0) { isAuto = false; }
	        this.name = name;
	        this.isAuto = isAuto;
	        this.state = 1 /* UNINITIALIZED */;
	        this.customAttributes = {};
	        this.counters = {};
	        this.api = Api.getInstance();
	        this.randomId = Math.floor(Math.random() * 1000000);
	        if (!this.isAuto) {
	            this.traceStartMark = TRACE_START_MARK_PREFIX + "-" + this.randomId + "-" + this.name;
	            this.traceStopMark = TRACE_STOP_MARK_PREFIX + "-" + this.randomId + "-" + this.name;
	            this.traceMeasure =
	                traceMeasureName ||
	                    TRACE_MEASURE_PREFIX + "-" + this.randomId + "-" + this.name;
	            if (traceMeasureName) {
	                // For the case of direct user timing traces, no start stop will happen. The measure object
	                // is already available.
	                this.calculateTraceMetrics();
	            }
	        }
	    }
	    /**
	     * Starts a trace. The measurement of the duration starts at this point.
	     */
	    Trace.prototype.start = function () {
	        if (this.state !== 1 /* UNINITIALIZED */) {
	            throw ERROR_FACTORY.create("trace started" /* TRACE_STARTED_BEFORE */, {
	                traceName: this.name
	            });
	        }
	        this.api.mark(this.traceStartMark);
	        this.state = 2 /* RUNNING */;
	    };
	    /**
	     * Stops the trace. The measurement of the duration of the trace stops at this point and trace
	     * is logged.
	     */
	    Trace.prototype.stop = function () {
	        if (this.state !== 2 /* RUNNING */) {
	            throw ERROR_FACTORY.create("trace stopped" /* TRACE_STOPPED_BEFORE */, {
	                traceName: this.name
	            });
	        }
	        this.state = 3 /* TERMINATED */;
	        this.api.mark(this.traceStopMark);
	        this.api.measure(this.traceMeasure, this.traceStartMark, this.traceStopMark);
	        this.calculateTraceMetrics();
	        logTrace(this);
	    };
	    /**
	     * Records a trace with predetermined values. If this method is used a trace is created and logged
	     * directly. No need to use start and stop methods.
	     * @param startTime Trace start time since epoch in millisec
	     * @param duration The duraction of the trace in millisec
	     * @param options An object which can optionally hold maps of custom metrics and custom attributes
	     */
	    Trace.prototype.record = function (startTime, duration, options) {
	        this.durationUs = Math.floor(duration * 1000);
	        this.startTimeUs = Math.floor(startTime * 1000);
	        if (options && options.attributes) {
	            this.customAttributes = tslib.__assign({}, options.attributes);
	        }
	        if (options && options.metrics) {
	            for (var _i = 0, _a = Object.keys(options.metrics); _i < _a.length; _i++) {
	                var metric = _a[_i];
	                if (!isNaN(Number(options.metrics[metric]))) {
	                    this.counters[metric] = Number(Math.floor(options.metrics[metric]));
	                }
	            }
	        }
	        logTrace(this);
	    };
	    /**
	     * Increments a custom metric by a certain number or 1 if number not specified. Will create a new
	     * custom metric if one with the given name does not exist.
	     * @param counter Name of the custom metric
	     * @param num Increment by value
	     */
	    Trace.prototype.incrementMetric = function (counter, num) {
	        if (num === void 0) { num = 1; }
	        if (this.counters[counter] === undefined) {
	            this.putMetric(counter, 0);
	        }
	        this.counters[counter] += num;
	    };
	    /**
	     * Sets a custom metric to a specified value. Will create a new custom metric if one with the
	     * given name does not exist.
	     * @param counter Name of the custom metric
	     * @param num Set custom metric to this value
	     */
	    Trace.prototype.putMetric = function (counter, num) {
	        if (isValidMetricName(counter, this.name)) {
	            this.counters[counter] = num;
	        }
	        else {
	            throw ERROR_FACTORY.create("invalid custom metric name" /* INVALID_CUSTOM_METRIC_NAME */, {
	                customMetricName: counter
	            });
	        }
	    };
	    /**
	     * Returns the value of the custom metric by that name. If a custom metric with that name does
	     * not exist will return zero.
	     * @param counter
	     */
	    Trace.prototype.getMetric = function (counter) {
	        return this.counters[counter] || 0;
	    };
	    /**
	     * Sets a custom attribute of a trace to a certain value.
	     * @param attr
	     * @param value
	     */
	    Trace.prototype.putAttribute = function (attr, value) {
	        var isValidName = isValidCustomAttributeName(attr);
	        var isValidValue = isValidCustomAttributeValue(value);
	        if (isValidName && isValidValue) {
	            this.customAttributes[attr] = value;
	            return;
	        }
	        // Throw appropriate error when the attribute name or value is invalid.
	        if (!isValidName) {
	            throw ERROR_FACTORY.create("invalid attribute name" /* INVALID_ATTRIBUTE_NAME */, {
	                attributeName: attr
	            });
	        }
	        if (!isValidValue) {
	            throw ERROR_FACTORY.create("invalid attribute value" /* INVALID_ATTRIBUTE_VALUE */, {
	                attributeValue: value
	            });
	        }
	    };
	    /**
	     * Retrieves the value a custom attribute of a trace is set to.
	     * @param attr
	     */
	    Trace.prototype.getAttribute = function (attr) {
	        return this.customAttributes[attr];
	    };
	    Trace.prototype.removeAttribute = function (attr) {
	        if (this.customAttributes[attr] === undefined) {
	            return;
	        }
	        delete this.customAttributes[attr];
	    };
	    Trace.prototype.getAttributes = function () {
	        return tslib.__assign({}, this.customAttributes);
	    };
	    Trace.prototype.setStartTime = function (startTime) {
	        this.startTimeUs = startTime;
	    };
	    Trace.prototype.setDuration = function (duration) {
	        this.durationUs = duration;
	    };
	    /**
	     * Calculates and assigns the duration and start time of the trace using the measure performance
	     * entry.
	     */
	    Trace.prototype.calculateTraceMetrics = function () {
	        var perfMeasureEntries = this.api.getEntriesByName(this.traceMeasure);
	        var perfMeasureEntry = perfMeasureEntries && perfMeasureEntries[0];
	        if (perfMeasureEntry) {
	            this.durationUs = Math.floor(perfMeasureEntry.duration * 1000);
	            this.startTimeUs = Math.floor((perfMeasureEntry.startTime + this.api.getTimeOrigin()) * 1000);
	        }
	    };
	    /**
	     * @param navigationTimings A single element array which contains the navigationTIming object of
	     * the page load
	     * @param paintTimings A array which contains paintTiming object of the page load
	     * @param firstInputDelay First input delay in millisec
	     */
	    Trace.createOobTrace = function (navigationTimings, paintTimings, firstInputDelay) {
	        var route = Api.getInstance().getUrl();
	        if (!route) {
	            return;
	        }
	        var trace = new Trace(OOB_TRACE_PAGE_LOAD_PREFIX + route, true);
	        var timeOriginUs = Math.floor(Api.getInstance().getTimeOrigin() * 1000);
	        trace.setStartTime(timeOriginUs);
	        // navigationTimings includes only one element.
	        if (navigationTimings && navigationTimings[0]) {
	            trace.setDuration(Math.floor(navigationTimings[0].duration * 1000));
	            trace.putMetric('domInteractive', Math.floor(navigationTimings[0].domInteractive * 1000));
	            trace.putMetric('domContentLoadedEventEnd', Math.floor(navigationTimings[0].domContentLoadedEventEnd * 1000));
	            trace.putMetric('loadEventEnd', Math.floor(navigationTimings[0].loadEventEnd * 1000));
	        }
	        var FIRST_PAINT = 'first-paint';
	        var FIRST_CONTENTFUL_PAINT = 'first-contentful-paint';
	        if (paintTimings) {
	            var firstPaint = paintTimings.find(function (paintObject) { return paintObject.name === FIRST_PAINT; });
	            if (firstPaint && firstPaint.startTime) {
	                trace.putMetric(FIRST_PAINT_COUNTER_NAME, Math.floor(firstPaint.startTime * 1000));
	            }
	            var firstContentfulPaint = paintTimings.find(function (paintObject) { return paintObject.name === FIRST_CONTENTFUL_PAINT; });
	            if (firstContentfulPaint && firstContentfulPaint.startTime) {
	                trace.putMetric(FIRST_CONTENTFUL_PAINT_COUNTER_NAME, Math.floor(firstContentfulPaint.startTime * 1000));
	            }
	            if (firstInputDelay) {
	                trace.putMetric(FIRST_INPUT_DELAY_COUNTER_NAME, Math.floor(firstInputDelay * 1000));
	            }
	        }
	        logTrace(trace);
	    };
	    Trace.createUserTimingTrace = function (measureName) {
	        var trace = new Trace(measureName, false, measureName);
	        logTrace(trace);
	    };
	    return Trace;
	}());
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function createNetworkRequestEntry(entry) {
	    var performanceEntry = entry;
	    if (!performanceEntry || performanceEntry.responseStart === undefined) {
	        return;
	    }
	    var timeOrigin = Api.getInstance().getTimeOrigin();
	    var startTimeUs = Math.floor((performanceEntry.startTime + timeOrigin) * 1000);
	    var timeToResponseInitiatedUs = performanceEntry.responseStart
	        ? Math.floor((performanceEntry.responseStart - performanceEntry.startTime) * 1000)
	        : undefined;
	    var timeToResponseCompletedUs = Math.floor((performanceEntry.responseEnd - performanceEntry.startTime) * 1000);
	    // Remove the query params from logged network request url.
	    var url = performanceEntry.name && performanceEntry.name.split('?')[0];
	    var networkRequest = {
	        url: url,
	        responsePayloadBytes: performanceEntry.transferSize,
	        startTimeUs: startTimeUs,
	        timeToResponseInitiatedUs: timeToResponseInitiatedUs,
	        timeToResponseCompletedUs: timeToResponseCompletedUs
	    };
	    logNetworkRequest(networkRequest);
	}
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var FID_WAIT_TIME_MS = 5000;
	function setupOobResources() {
	    // Do not initialize unless iid is available.
	    if (!getIid()) {
	        return;
	    }
	    // The load event might not have fired yet, and that means performance navigation timing
	    // object has a duration of 0. The setup should run after all current tasks in js queue.
	    setTimeout(function () { return setupOobTraces(); }, 0);
	    setTimeout(function () { return setupNetworkRequests(); }, 0);
	    setTimeout(function () { return setupUserTimingTraces(); }, 0);
	}
	function setupNetworkRequests() {
	    var api = Api.getInstance();
	    var resources = api.getEntriesByType('resource');
	    for (var _i = 0, resources_1 = resources; _i < resources_1.length; _i++) {
	        var resource = resources_1[_i];
	        createNetworkRequestEntry(resource);
	    }
	    api.setupObserver('resource', createNetworkRequestEntry);
	}
	function setupOobTraces() {
	    var api = Api.getInstance();
	    var navigationTimings = api.getEntriesByType('navigation');
	    var paintTimings = api.getEntriesByType('paint');
	    // If First Input Desly polyfill is added to the page, report the fid value.
	    // https://github.com/GoogleChromeLabs/first-input-delay
	    if (api.onFirstInputDelay) {
	        // If the fid call back is not called for certain time, continue without it.
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        var timeoutId_1 = setTimeout(function () {
	            Trace.createOobTrace(navigationTimings, paintTimings);
	            timeoutId_1 = undefined;
	        }, FID_WAIT_TIME_MS);
	        api.onFirstInputDelay(function (fid) {
	            if (timeoutId_1) {
	                clearTimeout(timeoutId_1);
	                Trace.createOobTrace(navigationTimings, paintTimings, fid);
	            }
	        });
	    }
	    else {
	        Trace.createOobTrace(navigationTimings, paintTimings);
	    }
	}
	function setupUserTimingTraces() {
	    var api = Api.getInstance();
	    // Run through the measure performance entries collected up to this point.
	    var measures = api.getEntriesByType('measure');
	    for (var _i = 0, measures_1 = measures; _i < measures_1.length; _i++) {
	        var measure = measures_1[_i];
	        createUserTimingTrace(measure);
	    }
	    // Setup an observer to capture the measures from this point on.
	    api.setupObserver('measure', createUserTimingTrace);
	}
	function createUserTimingTrace(measure) {
	    var measureName = measure.name;
	    // Do not create a trace, if the user timing marks and measures are created by the sdk itself.
	    if (measureName.substring(0, TRACE_MEASURE_PREFIX.length) ===
	        TRACE_MEASURE_PREFIX) {
	        return;
	    }
	    Trace.createUserTimingTrace(measureName);
	}
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var PerformanceController = /** @class */ (function () {
	    function PerformanceController(app) {
	        this.app = app;
	        if (Api.getInstance().requiredApisAvailable()) {
	            setupTransportService();
	            getInitializationPromise().then(setupOobResources, setupOobResources);
	        }
	        else {
	            consoleLogger.info('Firebase Performance cannot start if browser does not support fetch and Promise or cookie is disabled.');
	        }
	    }
	    PerformanceController.prototype.trace = function (name) {
	        return new Trace(name);
	    };
	    Object.defineProperty(PerformanceController.prototype, "instrumentationEnabled", {
	        get: function () {
	            return SettingsService.getInstance().instrumentationEnabled;
	        },
	        set: function (val) {
	            SettingsService.getInstance().instrumentationEnabled = val;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(PerformanceController.prototype, "dataCollectionEnabled", {
	        get: function () {
	            return SettingsService.getInstance().dataCollectionEnabled;
	        },
	        set: function (val) {
	            SettingsService.getInstance().dataCollectionEnabled = val;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return PerformanceController;
	}());
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var DEFAULT_ENTRY_NAME = '[DEFAULT]';
	function registerPerformance(instance) {
	    var factoryMethod = function (app, installations) {
	        if (app.name !== DEFAULT_ENTRY_NAME) {
	            throw ERROR_FACTORY.create("FB not default" /* FB_NOT_DEFAULT */);
	        }
	        if (typeof window === 'undefined') {
	            throw ERROR_FACTORY.create("no window" /* NO_WINDOW */);
	        }
	        setupApi(window);
	        SettingsService.getInstance().firebaseAppInstance = app;
	        SettingsService.getInstance().installationsService = installations;
	        return new PerformanceController(app);
	    };
	    // Register performance with firebase-app.
	    instance.INTERNAL.registerComponent(new component.Component('performance', function (container) {
	        /* Dependencies */
	        // getImmediate for FirebaseApp will always succeed
	        var app = container.getProvider('app').getImmediate();
	        // The following call will always succeed because perf has `import '@firebase/installations'`
	        var installations = container
	            .getProvider('installations')
	            .getImmediate();
	        return factoryMethod(app, installations);
	    }, "PUBLIC" /* PUBLIC */));
	    instance.registerVersion(name, version);
	}
	registerPerformance(firebase);
	
	exports.registerPerformance = registerPerformance;
	//# sourceMappingURL=index.cjs.js.map


/***/ }),
/* 270 */
262,
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var firebase = _interopDefault(__webpack_require__(39));
	var tslib = __webpack_require__(272);
	var component = __webpack_require__(58);
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @fileoverview Constants used in the Firebase Storage library.
	 */
	/**
	 * Domain name for firebase storage.
	 */
	var DEFAULT_HOST = 'firebasestorage.googleapis.com';
	/**
	 * The key in Firebase config json for the storage bucket.
	 */
	var CONFIG_STORAGE_BUCKET_KEY = 'storageBucket';
	/**
	 * 2 minutes
	 *
	 * The timeout for all operations except upload.
	 */
	var DEFAULT_MAX_OPERATION_RETRY_TIME = 2 * 60 * 1000;
	/**
	 * 10 minutes
	 *
	 * The timeout for upload.
	 */
	var DEFAULT_MAX_UPLOAD_RETRY_TIME = 10 * 60 * 1000;
	/**
	 * This is the value of Number.MIN_SAFE_INTEGER, which is not well supported
	 * enough for us to use it directly.
	 */
	var MIN_SAFE_INTEGER = -9007199254740991;
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var FirebaseStorageError = /** @class */ (function () {
	    function FirebaseStorageError(code, message) {
	        this.code_ = prependCode(code);
	        this.message_ = 'Firebase Storage: ' + message;
	        this.serverResponse_ = null;
	        this.name_ = 'FirebaseError';
	    }
	    FirebaseStorageError.prototype.codeProp = function () {
	        return this.code;
	    };
	    FirebaseStorageError.prototype.codeEquals = function (code) {
	        return prependCode(code) === this.codeProp();
	    };
	    FirebaseStorageError.prototype.serverResponseProp = function () {
	        return this.serverResponse_;
	    };
	    FirebaseStorageError.prototype.setServerResponseProp = function (serverResponse) {
	        this.serverResponse_ = serverResponse;
	    };
	    Object.defineProperty(FirebaseStorageError.prototype, "name", {
	        get: function () {
	            return this.name_;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FirebaseStorageError.prototype, "code", {
	        get: function () {
	            return this.code_;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FirebaseStorageError.prototype, "message", {
	        get: function () {
	            return this.message_;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FirebaseStorageError.prototype, "serverResponse", {
	        get: function () {
	            return this.serverResponse_;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return FirebaseStorageError;
	}());
	var Code = {
	    // Shared between all platforms
	    UNKNOWN: 'unknown',
	    OBJECT_NOT_FOUND: 'object-not-found',
	    BUCKET_NOT_FOUND: 'bucket-not-found',
	    PROJECT_NOT_FOUND: 'project-not-found',
	    QUOTA_EXCEEDED: 'quota-exceeded',
	    UNAUTHENTICATED: 'unauthenticated',
	    UNAUTHORIZED: 'unauthorized',
	    RETRY_LIMIT_EXCEEDED: 'retry-limit-exceeded',
	    INVALID_CHECKSUM: 'invalid-checksum',
	    CANCELED: 'canceled',
	    // JS specific
	    INVALID_EVENT_NAME: 'invalid-event-name',
	    INVALID_URL: 'invalid-url',
	    INVALID_DEFAULT_BUCKET: 'invalid-default-bucket',
	    NO_DEFAULT_BUCKET: 'no-default-bucket',
	    CANNOT_SLICE_BLOB: 'cannot-slice-blob',
	    SERVER_FILE_WRONG_SIZE: 'server-file-wrong-size',
	    NO_DOWNLOAD_URL: 'no-download-url',
	    INVALID_ARGUMENT: 'invalid-argument',
	    INVALID_ARGUMENT_COUNT: 'invalid-argument-count',
	    APP_DELETED: 'app-deleted',
	    INVALID_ROOT_OPERATION: 'invalid-root-operation',
	    INVALID_FORMAT: 'invalid-format',
	    INTERNAL_ERROR: 'internal-error'
	};
	function prependCode(code) {
	    return 'storage/' + code;
	}
	function unknown() {
	    var message = 'An unknown error occurred, please check the error payload for ' +
	        'server response.';
	    return new FirebaseStorageError(Code.UNKNOWN, message);
	}
	function objectNotFound(path) {
	    return new FirebaseStorageError(Code.OBJECT_NOT_FOUND, "Object '" + path + "' does not exist.");
	}
	function quotaExceeded(bucket) {
	    return new FirebaseStorageError(Code.QUOTA_EXCEEDED, "Quota for bucket '" +
	        bucket +
	        "' exceeded, please view quota on " +
	        'https://firebase.google.com/pricing/.');
	}
	function unauthenticated() {
	    var message = 'User is not authenticated, please authenticate using Firebase ' +
	        'Authentication and try again.';
	    return new FirebaseStorageError(Code.UNAUTHENTICATED, message);
	}
	function unauthorized(path) {
	    return new FirebaseStorageError(Code.UNAUTHORIZED, "User does not have permission to access '" + path + "'.");
	}
	function retryLimitExceeded() {
	    return new FirebaseStorageError(Code.RETRY_LIMIT_EXCEEDED, 'Max retry time for operation exceeded, please try again.');
	}
	function canceled() {
	    return new FirebaseStorageError(Code.CANCELED, 'User canceled the upload/download.');
	}
	function invalidUrl(url) {
	    return new FirebaseStorageError(Code.INVALID_URL, "Invalid URL '" + url + "'.");
	}
	function invalidDefaultBucket(bucket) {
	    return new FirebaseStorageError(Code.INVALID_DEFAULT_BUCKET, "Invalid default bucket '" + bucket + "'.");
	}
	function cannotSliceBlob() {
	    return new FirebaseStorageError(Code.CANNOT_SLICE_BLOB, 'Cannot slice blob for upload. Please retry the upload.');
	}
	function serverFileWrongSize() {
	    return new FirebaseStorageError(Code.SERVER_FILE_WRONG_SIZE, 'Server recorded incorrect upload file size, please retry the upload.');
	}
	function noDownloadURL() {
	    return new FirebaseStorageError(Code.NO_DOWNLOAD_URL, 'The given file does not have any download URLs.');
	}
	function invalidArgument(index, fnName, message) {
	    return new FirebaseStorageError(Code.INVALID_ARGUMENT, 'Invalid argument in `' + fnName + '` at index ' + index + ': ' + message);
	}
	function invalidArgumentCount(argMin, argMax, fnName, real) {
	    var countPart;
	    var plural;
	    if (argMin === argMax) {
	        countPart = argMin;
	        plural = argMin === 1 ? 'argument' : 'arguments';
	    }
	    else {
	        countPart = 'between ' + argMin + ' and ' + argMax;
	        plural = 'arguments';
	    }
	    return new FirebaseStorageError(Code.INVALID_ARGUMENT_COUNT, 'Invalid argument count in `' +
	        fnName +
	        '`: Expected ' +
	        countPart +
	        ' ' +
	        plural +
	        ', received ' +
	        real +
	        '.');
	}
	function appDeleted() {
	    return new FirebaseStorageError(Code.APP_DELETED, 'The Firebase app was deleted.');
	}
	/**
	 * @param name The name of the operation that was invalid.
	 */
	function invalidRootOperation(name) {
	    return new FirebaseStorageError(Code.INVALID_ROOT_OPERATION, "The operation '" +
	        name +
	        "' cannot be performed on a root reference, create a non-root " +
	        "reference using child, such as .child('file.png').");
	}
	/**
	 * @param format The format that was not valid.
	 * @param message A message describing the format violation.
	 */
	function invalidFormat(format, message) {
	    return new FirebaseStorageError(Code.INVALID_FORMAT, "String does not match format '" + format + "': " + message);
	}
	/**
	 * @param message A message describing the internal error.
	 */
	function internalError(message) {
	    throw new FirebaseStorageError(Code.INTERNAL_ERROR, 'Internal error: ' + message);
	}
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var StringFormat = {
	    RAW: 'raw',
	    BASE64: 'base64',
	    BASE64URL: 'base64url',
	    DATA_URL: 'data_url'
	};
	function formatValidator(stringFormat) {
	    switch (stringFormat) {
	        case StringFormat.RAW:
	        case StringFormat.BASE64:
	        case StringFormat.BASE64URL:
	        case StringFormat.DATA_URL:
	            return;
	        default:
	            throw 'Expected one of the event types: [' +
	                StringFormat.RAW +
	                ', ' +
	                StringFormat.BASE64 +
	                ', ' +
	                StringFormat.BASE64URL +
	                ', ' +
	                StringFormat.DATA_URL +
	                '].';
	    }
	}
	/**
	 * @struct
	 */
	var StringData = /** @class */ (function () {
	    function StringData(data, contentType) {
	        this.data = data;
	        this.contentType = contentType || null;
	    }
	    return StringData;
	}());
	function dataFromString(format, stringData) {
	    switch (format) {
	        case StringFormat.RAW:
	            return new StringData(utf8Bytes_(stringData));
	        case StringFormat.BASE64:
	        case StringFormat.BASE64URL:
	            return new StringData(base64Bytes_(format, stringData));
	        case StringFormat.DATA_URL:
	            return new StringData(dataURLBytes_(stringData), dataURLContentType_(stringData));
	        // do nothing
	    }
	    // assert(false);
	    throw unknown();
	}
	function utf8Bytes_(value) {
	    var b = [];
	    for (var i = 0; i < value.length; i++) {
	        var c = value.charCodeAt(i);
	        if (c <= 127) {
	            b.push(c);
	        }
	        else {
	            if (c <= 2047) {
	                b.push(192 | (c >> 6), 128 | (c & 63));
	            }
	            else {
	                if ((c & 64512) === 55296) {
	                    // The start of a surrogate pair.
	                    var valid = i < value.length - 1 && (value.charCodeAt(i + 1) & 64512) === 56320;
	                    if (!valid) {
	                        // The second surrogate wasn't there.
	                        b.push(239, 191, 189);
	                    }
	                    else {
	                        var hi = c;
	                        var lo = value.charCodeAt(++i);
	                        c = 65536 | ((hi & 1023) << 10) | (lo & 1023);
	                        b.push(240 | (c >> 18), 128 | ((c >> 12) & 63), 128 | ((c >> 6) & 63), 128 | (c & 63));
	                    }
	                }
	                else {
	                    if ((c & 64512) === 56320) {
	                        // Invalid low surrogate.
	                        b.push(239, 191, 189);
	                    }
	                    else {
	                        b.push(224 | (c >> 12), 128 | ((c >> 6) & 63), 128 | (c & 63));
	                    }
	                }
	            }
	        }
	    }
	    return new Uint8Array(b);
	}
	function percentEncodedBytes_(value) {
	    var decoded;
	    try {
	        decoded = decodeURIComponent(value);
	    }
	    catch (e) {
	        throw invalidFormat(StringFormat.DATA_URL, 'Malformed data URL.');
	    }
	    return utf8Bytes_(decoded);
	}
	function base64Bytes_(format, value) {
	    switch (format) {
	        case StringFormat.BASE64: {
	            var hasMinus = value.indexOf('-') !== -1;
	            var hasUnder = value.indexOf('_') !== -1;
	            if (hasMinus || hasUnder) {
	                var invalidChar = hasMinus ? '-' : '_';
	                throw invalidFormat(format, "Invalid character '" +
	                    invalidChar +
	                    "' found: is it base64url encoded?");
	            }
	            break;
	        }
	        case StringFormat.BASE64URL: {
	            var hasPlus = value.indexOf('+') !== -1;
	            var hasSlash = value.indexOf('/') !== -1;
	            if (hasPlus || hasSlash) {
	                var invalidChar = hasPlus ? '+' : '/';
	                throw invalidFormat(format, "Invalid character '" + invalidChar + "' found: is it base64 encoded?");
	            }
	            value = value.replace(/-/g, '+').replace(/_/g, '/');
	            break;
	        }
	        // do nothing
	    }
	    var bytes;
	    try {
	        bytes = atob(value);
	    }
	    catch (e) {
	        throw invalidFormat(format, 'Invalid character found');
	    }
	    var array = new Uint8Array(bytes.length);
	    for (var i = 0; i < bytes.length; i++) {
	        array[i] = bytes.charCodeAt(i);
	    }
	    return array;
	}
	/**
	 * @struct
	 */
	var DataURLParts = /** @class */ (function () {
	    function DataURLParts(dataURL) {
	        this.base64 = false;
	        this.contentType = null;
	        var matches = dataURL.match(/^data:([^,]+)?,/);
	        if (matches === null) {
	            throw invalidFormat(StringFormat.DATA_URL, "Must be formatted 'data:[<mediatype>][;base64],<data>");
	        }
	        var middle = matches[1] || null;
	        if (middle != null) {
	            this.base64 = endsWith(middle, ';base64');
	            this.contentType = this.base64
	                ? middle.substring(0, middle.length - ';base64'.length)
	                : middle;
	        }
	        this.rest = dataURL.substring(dataURL.indexOf(',') + 1);
	    }
	    return DataURLParts;
	}());
	function dataURLBytes_(dataUrl) {
	    var parts = new DataURLParts(dataUrl);
	    if (parts.base64) {
	        return base64Bytes_(StringFormat.BASE64, parts.rest);
	    }
	    else {
	        return percentEncodedBytes_(parts.rest);
	    }
	}
	function dataURLContentType_(dataUrl) {
	    var parts = new DataURLParts(dataUrl);
	    return parts.contentType;
	}
	function endsWith(s, end) {
	    var longEnough = s.length >= end.length;
	    if (!longEnough) {
	        return false;
	    }
	    return s.substring(s.length - end.length) === end;
	}
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var TaskEvent = {
	    /** Triggered whenever the task changes or progress is updated. */
	    STATE_CHANGED: 'state_changed'
	};
	var InternalTaskState = {
	    RUNNING: 'running',
	    PAUSING: 'pausing',
	    PAUSED: 'paused',
	    SUCCESS: 'success',
	    CANCELING: 'canceling',
	    CANCELED: 'canceled',
	    ERROR: 'error'
	};
	var TaskState = {
	    /** The task is currently transferring data. */
	    RUNNING: 'running',
	    /** The task was paused by the user. */
	    PAUSED: 'paused',
	    /** The task completed successfully. */
	    SUCCESS: 'success',
	    /** The task was canceled. */
	    CANCELED: 'canceled',
	    /** The task failed with an error. */
	    ERROR: 'error'
	};
	function taskStateFromInternalTaskState(state) {
	    switch (state) {
	        case InternalTaskState.RUNNING:
	        case InternalTaskState.PAUSING:
	        case InternalTaskState.CANCELING:
	            return TaskState.RUNNING;
	        case InternalTaskState.PAUSED:
	            return TaskState.PAUSED;
	        case InternalTaskState.SUCCESS:
	            return TaskState.SUCCESS;
	        case InternalTaskState.CANCELED:
	            return TaskState.CANCELED;
	        case InternalTaskState.ERROR:
	            return TaskState.ERROR;
	        default:
	            // TODO(andysoto): assert(false);
	            return TaskState.ERROR;
	    }
	}
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @return False if the object is undefined or null, true otherwise.
	 */
	function isDef(p) {
	    return p != null;
	}
	function isJustDef(p) {
	    return p !== void 0;
	}
	function isFunction(p) {
	    return typeof p === 'function';
	}
	function isObject(p) {
	    return typeof p === 'object';
	}
	function isNonNullObject(p) {
	    return isObject(p) && p !== null;
	}
	function isNonArrayObject(p) {
	    return isObject(p) && !Array.isArray(p);
	}
	function isString(p) {
	    return typeof p === 'string' || p instanceof String;
	}
	function isInteger(p) {
	    return isNumber(p) && Number.isInteger(p);
	}
	function isNumber(p) {
	    return typeof p === 'number' || p instanceof Number;
	}
	function isNativeBlob(p) {
	    return isNativeBlobDefined() && p instanceof Blob;
	}
	function isNativeBlobDefined() {
	    return typeof Blob !== 'undefined';
	}
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @enum{number}
	 */
	var ErrorCode;
	(function (ErrorCode) {
	    ErrorCode[ErrorCode["NO_ERROR"] = 0] = "NO_ERROR";
	    ErrorCode[ErrorCode["NETWORK_ERROR"] = 1] = "NETWORK_ERROR";
	    ErrorCode[ErrorCode["ABORT"] = 2] = "ABORT";
	})(ErrorCode || (ErrorCode = {}));
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * We use this instead of goog.net.XhrIo because goog.net.XhrIo is hyuuuuge and
	 * doesn't work in React Native on Android.
	 */
	var NetworkXhrIo = /** @class */ (function () {
	    function NetworkXhrIo() {
	        var _this = this;
	        this.sent_ = false;
	        this.xhr_ = new XMLHttpRequest();
	        this.errorCode_ = ErrorCode.NO_ERROR;
	        this.sendPromise_ = new Promise(function (resolve) {
	            _this.xhr_.addEventListener('abort', function () {
	                _this.errorCode_ = ErrorCode.ABORT;
	                resolve(_this);
	            });
	            _this.xhr_.addEventListener('error', function () {
	                _this.errorCode_ = ErrorCode.NETWORK_ERROR;
	                resolve(_this);
	            });
	            _this.xhr_.addEventListener('load', function () {
	                resolve(_this);
	            });
	        });
	    }
	    /**
	     * @override
	     */
	    NetworkXhrIo.prototype.send = function (url, method, body, headers) {
	        if (this.sent_) {
	            throw internalError('cannot .send() more than once');
	        }
	        this.sent_ = true;
	        this.xhr_.open(method, url, true);
	        if (isDef(headers)) {
	            for (var key in headers) {
	                if (headers.hasOwnProperty(key)) {
	                    this.xhr_.setRequestHeader(key, headers[key].toString());
	                }
	            }
	        }
	        if (isDef(body)) {
	            this.xhr_.send(body);
	        }
	        else {
	            this.xhr_.send();
	        }
	        return this.sendPromise_;
	    };
	    /**
	     * @override
	     */
	    NetworkXhrIo.prototype.getErrorCode = function () {
	        if (!this.sent_) {
	            throw internalError('cannot .getErrorCode() before sending');
	        }
	        return this.errorCode_;
	    };
	    /**
	     * @override
	     */
	    NetworkXhrIo.prototype.getStatus = function () {
	        if (!this.sent_) {
	            throw internalError('cannot .getStatus() before sending');
	        }
	        try {
	            return this.xhr_.status;
	        }
	        catch (e) {
	            return -1;
	        }
	    };
	    /**
	     * @override
	     */
	    NetworkXhrIo.prototype.getResponseText = function () {
	        if (!this.sent_) {
	            throw internalError('cannot .getResponseText() before sending');
	        }
	        return this.xhr_.responseText;
	    };
	    /**
	     * Aborts the request.
	     * @override
	     */
	    NetworkXhrIo.prototype.abort = function () {
	        this.xhr_.abort();
	    };
	    /**
	     * @override
	     */
	    NetworkXhrIo.prototype.getResponseHeader = function (header) {
	        return this.xhr_.getResponseHeader(header);
	    };
	    /**
	     * @override
	     */
	    NetworkXhrIo.prototype.addUploadProgressListener = function (listener) {
	        if (isDef(this.xhr_.upload)) {
	            this.xhr_.upload.addEventListener('progress', listener);
	        }
	    };
	    /**
	     * @override
	     */
	    NetworkXhrIo.prototype.removeUploadProgressListener = function (listener) {
	        if (isDef(this.xhr_.upload)) {
	            this.xhr_.upload.removeEventListener('progress', listener);
	        }
	    };
	    return NetworkXhrIo;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Factory-like class for creating XhrIo instances.
	 */
	var XhrIoPool = /** @class */ (function () {
	    function XhrIoPool() {
	    }
	    XhrIoPool.prototype.createXhrIo = function () {
	        return new NetworkXhrIo();
	    };
	    return XhrIoPool;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function getBlobBuilder() {
	    if (typeof BlobBuilder !== 'undefined') {
	        return BlobBuilder;
	    }
	    else if (typeof WebKitBlobBuilder !== 'undefined') {
	        return WebKitBlobBuilder;
	    }
	    else {
	        return undefined;
	    }
	}
	/**
	 * Concatenates one or more values together and converts them to a Blob.
	 *
	 * @param args The values that will make up the resulting blob.
	 * @return The blob.
	 */
	function getBlob() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    var BlobBuilder = getBlobBuilder();
	    if (BlobBuilder !== undefined) {
	        var bb = new BlobBuilder();
	        for (var i = 0; i < args.length; i++) {
	            bb.append(args[i]);
	        }
	        return bb.getBlob();
	    }
	    else {
	        if (isNativeBlobDefined()) {
	            return new Blob(args);
	        }
	        else {
	            throw Error("This browser doesn't seem to support creating Blobs");
	        }
	    }
	}
	/**
	 * Slices the blob. The returned blob contains data from the start byte
	 * (inclusive) till the end byte (exclusive). Negative indices cannot be used.
	 *
	 * @param blob The blob to be sliced.
	 * @param start Index of the starting byte.
	 * @param end Index of the ending byte.
	 * @return The blob slice or null if not supported.
	 */
	function sliceBlob(blob, start, end) {
	    if (blob.webkitSlice) {
	        return blob.webkitSlice(start, end);
	    }
	    else if (blob.mozSlice) {
	        return blob.mozSlice(start, end);
	    }
	    else if (blob.slice) {
	        return blob.slice(start, end);
	    }
	    return null;
	}
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @param opt_elideCopy If true, doesn't copy mutable input data
	 *     (e.g. Uint8Arrays). Pass true only if you know the objects will not be
	 *     modified after this blob's construction.
	 */
	var FbsBlob = /** @class */ (function () {
	    function FbsBlob(data, elideCopy) {
	        var size = 0;
	        var blobType = '';
	        if (isNativeBlob(data)) {
	            this.data_ = data;
	            size = data.size;
	            blobType = data.type;
	        }
	        else if (data instanceof ArrayBuffer) {
	            if (elideCopy) {
	                this.data_ = new Uint8Array(data);
	            }
	            else {
	                this.data_ = new Uint8Array(data.byteLength);
	                this.data_.set(new Uint8Array(data));
	            }
	            size = this.data_.length;
	        }
	        else if (data instanceof Uint8Array) {
	            if (elideCopy) {
	                this.data_ = data;
	            }
	            else {
	                this.data_ = new Uint8Array(data.length);
	                this.data_.set(data);
	            }
	            size = data.length;
	        }
	        this.size_ = size;
	        this.type_ = blobType;
	    }
	    FbsBlob.prototype.size = function () {
	        return this.size_;
	    };
	    FbsBlob.prototype.type = function () {
	        return this.type_;
	    };
	    FbsBlob.prototype.slice = function (startByte, endByte) {
	        if (isNativeBlob(this.data_)) {
	            var realBlob = this.data_;
	            var sliced = sliceBlob(realBlob, startByte, endByte);
	            if (sliced === null) {
	                return null;
	            }
	            return new FbsBlob(sliced);
	        }
	        else {
	            var slice = new Uint8Array(this.data_.buffer, startByte, endByte - startByte);
	            return new FbsBlob(slice, true);
	        }
	    };
	    FbsBlob.getBlob = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        if (isNativeBlobDefined()) {
	            var blobby = args.map(function (val) {
	                if (val instanceof FbsBlob) {
	                    return val.data_;
	                }
	                else {
	                    return val;
	                }
	            });
	            return new FbsBlob(getBlob.apply(null, blobby));
	        }
	        else {
	            var uint8Arrays = args.map(function (val) {
	                if (isString(val)) {
	                    return dataFromString(StringFormat.RAW, val).data;
	                }
	                else {
	                    // Blobs don't exist, so this has to be a Uint8Array.
	                    return val.data_;
	                }
	            });
	            var finalLength_1 = 0;
	            uint8Arrays.forEach(function (array) {
	                finalLength_1 += array.byteLength;
	            });
	            var merged_1 = new Uint8Array(finalLength_1);
	            var index_1 = 0;
	            uint8Arrays.forEach(function (array) {
	                for (var i = 0; i < array.length; i++) {
	                    merged_1[index_1++] = array[i];
	                }
	            });
	            return new FbsBlob(merged_1, true);
	        }
	    };
	    FbsBlob.prototype.uploadData = function () {
	        return this.data_;
	    };
	    return FbsBlob;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @struct
	 */
	var Location = /** @class */ (function () {
	    function Location(bucket, path) {
	        this.bucket = bucket;
	        this.path_ = path;
	    }
	    Object.defineProperty(Location.prototype, "path", {
	        get: function () {
	            return this.path_;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Location.prototype, "isRoot", {
	        get: function () {
	            return this.path.length === 0;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Location.prototype.fullServerUrl = function () {
	        var encode = encodeURIComponent;
	        return '/b/' + encode(this.bucket) + '/o/' + encode(this.path);
	    };
	    Location.prototype.bucketOnlyServerUrl = function () {
	        var encode = encodeURIComponent;
	        return '/b/' + encode(this.bucket) + '/o';
	    };
	    Location.makeFromBucketSpec = function (bucketString) {
	        var bucketLocation;
	        try {
	            bucketLocation = Location.makeFromUrl(bucketString);
	        }
	        catch (e) {
	            // Not valid URL, use as-is. This lets you put bare bucket names in
	            // config.
	            return new Location(bucketString, '');
	        }
	        if (bucketLocation.path === '') {
	            return bucketLocation;
	        }
	        else {
	            throw invalidDefaultBucket(bucketString);
	        }
	    };
	    Location.makeFromUrl = function (url) {
	        var location = null;
	        var bucketDomain = '([A-Za-z0-9.\\-_]+)';
	        function gsModify(loc) {
	            if (loc.path.charAt(loc.path.length - 1) === '/') {
	                loc.path_ = loc.path_.slice(0, -1);
	            }
	        }
	        var gsPath = '(/(.*))?$';
	        var gsRegex = new RegExp('^gs://' + bucketDomain + gsPath, 'i');
	        var gsIndices = { bucket: 1, path: 3 };
	        function httpModify(loc) {
	            loc.path_ = decodeURIComponent(loc.path);
	        }
	        var version = 'v[A-Za-z0-9_]+';
	        var firebaseStorageHost = DEFAULT_HOST.replace(/[.]/g, '\\.');
	        var firebaseStoragePath = '(/([^?#]*).*)?$';
	        var firebaseStorageRegExp = new RegExp("^https?://" + firebaseStorageHost + "/" + version + "/b/" + bucketDomain + "/o" + firebaseStoragePath, 'i');
	        var firebaseStorageIndices = { bucket: 1, path: 3 };
	        var cloudStorageHost = '(?:storage.googleapis.com|storage.cloud.google.com)';
	        var cloudStoragePath = '([^?#]*)';
	        var cloudStorageRegExp = new RegExp("^https?://" + cloudStorageHost + "/" + bucketDomain + "/" + cloudStoragePath, 'i');
	        var cloudStorageIndices = { bucket: 1, path: 2 };
	        var groups = [
	            { regex: gsRegex, indices: gsIndices, postModify: gsModify },
	            {
	                regex: firebaseStorageRegExp,
	                indices: firebaseStorageIndices,
	                postModify: httpModify
	            },
	            {
	                regex: cloudStorageRegExp,
	                indices: cloudStorageIndices,
	                postModify: httpModify
	            }
	        ];
	        for (var i = 0; i < groups.length; i++) {
	            var group = groups[i];
	            var captures = group.regex.exec(url);
	            if (captures) {
	                var bucketValue = captures[group.indices.bucket];
	                var pathValue = captures[group.indices.path];
	                if (!pathValue) {
	                    pathValue = '';
	                }
	                location = new Location(bucketValue, pathValue);
	                group.postModify(location);
	                break;
	            }
	        }
	        if (location == null) {
	            throw invalidUrl(url);
	        }
	        return location;
	    };
	    return Location;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Returns the Object resulting from parsing the given JSON, or null if the
	 * given string does not represent a JSON object.
	 */
	function jsonObjectOrNull(s) {
	    var obj;
	    try {
	        obj = JSON.parse(s);
	    }
	    catch (e) {
	        return null;
	    }
	    if (isNonArrayObject(obj)) {
	        return obj;
	    }
	    else {
	        return null;
	    }
	}
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @fileoverview Contains helper methods for manipulating paths.
	 */
	/**
	 * @return Null if the path is already at the root.
	 */
	function parent(path) {
	    if (path.length === 0) {
	        return null;
	    }
	    var index = path.lastIndexOf('/');
	    if (index === -1) {
	        return '';
	    }
	    var newPath = path.slice(0, index);
	    return newPath;
	}
	function child(path, childPath) {
	    var canonicalChildPath = childPath
	        .split('/')
	        .filter(function (component) { return component.length > 0; })
	        .join('/');
	    if (path.length === 0) {
	        return canonicalChildPath;
	    }
	    else {
	        return path + '/' + canonicalChildPath;
	    }
	}
	/**
	 * Returns the last component of a path.
	 * '/foo/bar' -> 'bar'
	 * '/foo/bar/baz/' -> 'baz/'
	 * '/a' -> 'a'
	 */
	function lastComponent(path) {
	    var index = path.lastIndexOf('/', path.length - 2);
	    if (index === -1) {
	        return path;
	    }
	    else {
	        return path.slice(index + 1);
	    }
	}
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function makeUrl(urlPart) {
	    return "https://" + DEFAULT_HOST + "/v0" + urlPart;
	}
	function makeQueryString(params) {
	    var encode = encodeURIComponent;
	    var queryPart = '?';
	    for (var key in params) {
	        if (params.hasOwnProperty(key)) {
	            // @ts-ignore TODO: remove once typescript is upgraded to 3.5.x
	            var nextPart = encode(key) + '=' + encode(params[key]);
	            queryPart = queryPart + nextPart + '&';
	        }
	    }
	    // Chop off the extra '&' or '?' on the end
	    queryPart = queryPart.slice(0, -1);
	    return queryPart;
	}
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function noXform_(metadata, value) {
	    return value;
	}
	/**
	 * @struct
	 */
	var Mapping = /** @class */ (function () {
	    function Mapping(server, local, writable, xform) {
	        this.server = server;
	        this.local = local || server;
	        this.writable = !!writable;
	        this.xform = xform || noXform_;
	    }
	    return Mapping;
	}());
	var mappings_ = null;
	function xformPath(fullPath) {
	    if (!isString(fullPath) || fullPath.length < 2) {
	        return fullPath;
	    }
	    else {
	        return lastComponent(fullPath);
	    }
	}
	function getMappings() {
	    if (mappings_) {
	        return mappings_;
	    }
	    var mappings = [];
	    mappings.push(new Mapping('bucket'));
	    mappings.push(new Mapping('generation'));
	    mappings.push(new Mapping('metageneration'));
	    mappings.push(new Mapping('name', 'fullPath', true));
	    function mappingsXformPath(_metadata, fullPath) {
	        return xformPath(fullPath);
	    }
	    var nameMapping = new Mapping('name');
	    nameMapping.xform = mappingsXformPath;
	    mappings.push(nameMapping);
	    /**
	     * Coerces the second param to a number, if it is defined.
	     */
	    function xformSize(_metadata, size) {
	        if (isDef(size)) {
	            return Number(size);
	        }
	        else {
	            return size;
	        }
	    }
	    var sizeMapping = new Mapping('size');
	    sizeMapping.xform = xformSize;
	    mappings.push(sizeMapping);
	    mappings.push(new Mapping('timeCreated'));
	    mappings.push(new Mapping('updated'));
	    mappings.push(new Mapping('md5Hash', null, true));
	    mappings.push(new Mapping('cacheControl', null, true));
	    mappings.push(new Mapping('contentDisposition', null, true));
	    mappings.push(new Mapping('contentEncoding', null, true));
	    mappings.push(new Mapping('contentLanguage', null, true));
	    mappings.push(new Mapping('contentType', null, true));
	    mappings.push(new Mapping('metadata', 'customMetadata', true));
	    mappings_ = mappings;
	    return mappings_;
	}
	function addRef(metadata, authWrapper) {
	    function generateRef() {
	        var bucket = metadata['bucket'];
	        var path = metadata['fullPath'];
	        var loc = new Location(bucket, path);
	        return authWrapper.makeStorageReference(loc);
	    }
	    Object.defineProperty(metadata, 'ref', { get: generateRef });
	}
	function fromResource(authWrapper, resource, mappings) {
	    var metadata = {};
	    metadata['type'] = 'file';
	    var len = mappings.length;
	    for (var i = 0; i < len; i++) {
	        var mapping = mappings[i];
	        metadata[mapping.local] = mapping.xform(metadata, resource[mapping.server]);
	    }
	    addRef(metadata, authWrapper);
	    return metadata;
	}
	function fromResourceString(authWrapper, resourceString, mappings) {
	    var obj = jsonObjectOrNull(resourceString);
	    if (obj === null) {
	        return null;
	    }
	    var resource = obj;
	    return fromResource(authWrapper, resource, mappings);
	}
	function downloadUrlFromResourceString(metadata, resourceString) {
	    var obj = jsonObjectOrNull(resourceString);
	    if (obj === null) {
	        return null;
	    }
	    if (!isString(obj['downloadTokens'])) {
	        // This can happen if objects are uploaded through GCS and retrieved
	        // through list, so we don't want to throw an Error.
	        return null;
	    }
	    var tokens = obj['downloadTokens'];
	    if (tokens.length === 0) {
	        return null;
	    }
	    var encode = encodeURIComponent;
	    var tokensList = tokens.split(',');
	    var urls = tokensList.map(function (token) {
	        var bucket = metadata['bucket'];
	        var path = metadata['fullPath'];
	        var urlPart = '/b/' + encode(bucket) + '/o/' + encode(path);
	        var base = makeUrl(urlPart);
	        var queryString = makeQueryString({
	            alt: 'media',
	            token: token
	        });
	        return base + queryString;
	    });
	    return urls[0];
	}
	function toResourceString(metadata, mappings) {
	    var resource = {};
	    var len = mappings.length;
	    for (var i = 0; i < len; i++) {
	        var mapping = mappings[i];
	        if (mapping.writable) {
	            resource[mapping.server] = metadata[mapping.local];
	        }
	    }
	    return JSON.stringify(resource);
	}
	function metadataValidator(p) {
	    if (!isObject(p) || !p) {
	        throw 'Expected Metadata object.';
	    }
	    for (var key in p) {
	        if (p.hasOwnProperty(key)) {
	            var val = p[key];
	            if (key === 'customMetadata') {
	                if (!isObject(val)) {
	                    throw 'Expected object for \'customMetadata\' mapping.';
	                }
	            }
	            else {
	                if (isNonNullObject(val)) {
	                    throw "Mapping for '" + key + "' cannot be an object.";
	                }
	            }
	        }
	    }
	}
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var MAX_RESULTS_KEY = 'maxResults';
	var MAX_MAX_RESULTS = 1000;
	var PAGE_TOKEN_KEY = 'pageToken';
	var PREFIXES_KEY = 'prefixes';
	var ITEMS_KEY = 'items';
	function fromBackendResponse(authWrapper, bucket, resource) {
	    var listResult = {
	        prefixes: [],
	        items: [],
	        nextPageToken: resource['nextPageToken']
	    };
	    if (resource[PREFIXES_KEY]) {
	        for (var _i = 0, _a = resource[PREFIXES_KEY]; _i < _a.length; _i++) {
	            var path = _a[_i];
	            var pathWithoutTrailingSlash = path.replace(/\/$/, '');
	            var reference = authWrapper.makeStorageReference(new Location(bucket, pathWithoutTrailingSlash));
	            listResult.prefixes.push(reference);
	        }
	    }
	    if (resource[ITEMS_KEY]) {
	        for (var _b = 0, _c = resource[ITEMS_KEY]; _b < _c.length; _b++) {
	            var item = _c[_b];
	            var reference = authWrapper.makeStorageReference(new Location(bucket, item['name']));
	            listResult.items.push(reference);
	        }
	    }
	    return listResult;
	}
	function fromResponseString(authWrapper, bucket, resourceString) {
	    var obj = jsonObjectOrNull(resourceString);
	    if (obj === null) {
	        return null;
	    }
	    var resource = obj;
	    return fromBackendResponse(authWrapper, bucket, resource);
	}
	function listOptionsValidator(p) {
	    if (!isObject(p) || !p) {
	        throw 'Expected ListOptions object.';
	    }
	    for (var key in p) {
	        if (key === MAX_RESULTS_KEY) {
	            if (!isInteger(p[MAX_RESULTS_KEY]) ||
	                p[MAX_RESULTS_KEY] <= 0) {
	                throw 'Expected maxResults to be a positive number.';
	            }
	            if (p[MAX_RESULTS_KEY] > 1000) {
	                throw "Expected maxResults to be less than or equal to " + MAX_MAX_RESULTS + ".";
	            }
	        }
	        else if (key === PAGE_TOKEN_KEY) {
	            if (p[PAGE_TOKEN_KEY] && !isString(p[PAGE_TOKEN_KEY])) {
	                throw 'Expected pageToken to be string.';
	            }
	        }
	        else {
	            throw 'Unknown option: ' + key;
	        }
	    }
	}
	
	var RequestInfo = /** @class */ (function () {
	    function RequestInfo(url, method, 
	    /**
	     * Returns the value with which to resolve the request's promise. Only called
	     * if the request is successful. Throw from this function to reject the
	     * returned Request's promise with the thrown error.
	     * Note: The XhrIo passed to this function may be reused after this callback
	     * returns. Do not keep a reference to it in any way.
	     */
	    handler, timeout) {
	        this.url = url;
	        this.method = method;
	        this.handler = handler;
	        this.timeout = timeout;
	        this.urlParams = {};
	        this.headers = {};
	        this.body = null;
	        this.errorHandler = null;
	        /**
	         * Called with the current number of bytes uploaded and total size (-1 if not
	         * computable) of the request body (i.e. used to report upload progress).
	         */
	        this.progressCallback = null;
	        this.successCodes = [200];
	        this.additionalRetryCodes = [];
	    }
	    return RequestInfo;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Throws the UNKNOWN FirebaseStorageError if cndn is false.
	 */
	function handlerCheck(cndn) {
	    if (!cndn) {
	        throw unknown();
	    }
	}
	function metadataHandler(authWrapper, mappings) {
	    function handler(xhr, text) {
	        var metadata = fromResourceString(authWrapper, text, mappings);
	        handlerCheck(metadata !== null);
	        return metadata;
	    }
	    return handler;
	}
	function listHandler(authWrapper, bucket) {
	    function handler(xhr, text) {
	        var listResult = fromResponseString(authWrapper, bucket, text);
	        handlerCheck(listResult !== null);
	        return listResult;
	    }
	    return handler;
	}
	function downloadUrlHandler(authWrapper, mappings) {
	    function handler(xhr, text) {
	        var metadata = fromResourceString(authWrapper, text, mappings);
	        handlerCheck(metadata !== null);
	        return downloadUrlFromResourceString(metadata, text);
	    }
	    return handler;
	}
	function sharedErrorHandler(location) {
	    function errorHandler(xhr, err) {
	        var newErr;
	        if (xhr.getStatus() === 401) {
	            newErr = unauthenticated();
	        }
	        else {
	            if (xhr.getStatus() === 402) {
	                newErr = quotaExceeded(location.bucket);
	            }
	            else {
	                if (xhr.getStatus() === 403) {
	                    newErr = unauthorized(location.path);
	                }
	                else {
	                    newErr = err;
	                }
	            }
	        }
	        newErr.setServerResponseProp(err.serverResponseProp());
	        return newErr;
	    }
	    return errorHandler;
	}
	function objectErrorHandler(location) {
	    var shared = sharedErrorHandler(location);
	    function errorHandler(xhr, err) {
	        var newErr = shared(xhr, err);
	        if (xhr.getStatus() === 404) {
	            newErr = objectNotFound(location.path);
	        }
	        newErr.setServerResponseProp(err.serverResponseProp());
	        return newErr;
	    }
	    return errorHandler;
	}
	function getMetadata(authWrapper, location, mappings) {
	    var urlPart = location.fullServerUrl();
	    var url = makeUrl(urlPart);
	    var method = 'GET';
	    var timeout = authWrapper.maxOperationRetryTime();
	    var requestInfo = new RequestInfo(url, method, metadataHandler(authWrapper, mappings), timeout);
	    requestInfo.errorHandler = objectErrorHandler(location);
	    return requestInfo;
	}
	function list(authWrapper, location, delimiter, pageToken, maxResults) {
	    var urlParams = {};
	    if (location.isRoot) {
	        urlParams['prefix'] = '';
	    }
	    else {
	        urlParams['prefix'] = location.path + '/';
	    }
	    if (delimiter && delimiter.length > 0) {
	        urlParams['delimiter'] = delimiter;
	    }
	    if (pageToken) {
	        urlParams['pageToken'] = pageToken;
	    }
	    if (maxResults) {
	        urlParams['maxResults'] = maxResults;
	    }
	    var urlPart = location.bucketOnlyServerUrl();
	    var url = makeUrl(urlPart);
	    var method = 'GET';
	    var timeout = authWrapper.maxOperationRetryTime();
	    var requestInfo = new RequestInfo(url, method, listHandler(authWrapper, location.bucket), timeout);
	    requestInfo.urlParams = urlParams;
	    requestInfo.errorHandler = sharedErrorHandler(location);
	    return requestInfo;
	}
	function getDownloadUrl(authWrapper, location, mappings) {
	    var urlPart = location.fullServerUrl();
	    var url = makeUrl(urlPart);
	    var method = 'GET';
	    var timeout = authWrapper.maxOperationRetryTime();
	    var requestInfo = new RequestInfo(url, method, downloadUrlHandler(authWrapper, mappings), timeout);
	    requestInfo.errorHandler = objectErrorHandler(location);
	    return requestInfo;
	}
	function updateMetadata(authWrapper, location, metadata, mappings) {
	    var urlPart = location.fullServerUrl();
	    var url = makeUrl(urlPart);
	    var method = 'PATCH';
	    var body = toResourceString(metadata, mappings);
	    var headers = { 'Content-Type': 'application/json; charset=utf-8' };
	    var timeout = authWrapper.maxOperationRetryTime();
	    var requestInfo = new RequestInfo(url, method, metadataHandler(authWrapper, mappings), timeout);
	    requestInfo.headers = headers;
	    requestInfo.body = body;
	    requestInfo.errorHandler = objectErrorHandler(location);
	    return requestInfo;
	}
	function deleteObject(authWrapper, location) {
	    var urlPart = location.fullServerUrl();
	    var url = makeUrl(urlPart);
	    var method = 'DELETE';
	    var timeout = authWrapper.maxOperationRetryTime();
	    function handler(_xhr, _text) { }
	    var requestInfo = new RequestInfo(url, method, handler, timeout);
	    requestInfo.successCodes = [200, 204];
	    requestInfo.errorHandler = objectErrorHandler(location);
	    return requestInfo;
	}
	function determineContentType_(metadata, blob) {
	    return ((metadata && metadata['contentType']) ||
	        (blob && blob.type()) ||
	        'application/octet-stream');
	}
	function metadataForUpload_(location, blob, metadata) {
	    var metadataClone = Object.assign({}, metadata);
	    metadataClone['fullPath'] = location.path;
	    metadataClone['size'] = blob.size();
	    if (!metadataClone['contentType']) {
	        metadataClone['contentType'] = determineContentType_(null, blob);
	    }
	    return metadataClone;
	}
	function multipartUpload(authWrapper, location, mappings, blob, metadata) {
	    var urlPart = location.bucketOnlyServerUrl();
	    var headers = {
	        'X-Goog-Upload-Protocol': 'multipart'
	    };
	    function genBoundary() {
	        var str = '';
	        for (var i = 0; i < 2; i++) {
	            str =
	                str +
	                    Math.random()
	                        .toString()
	                        .slice(2);
	        }
	        return str;
	    }
	    var boundary = genBoundary();
	    headers['Content-Type'] = 'multipart/related; boundary=' + boundary;
	    var metadata_ = metadataForUpload_(location, blob, metadata);
	    var metadataString = toResourceString(metadata_, mappings);
	    var preBlobPart = '--' +
	        boundary +
	        '\r\n' +
	        'Content-Type: application/json; charset=utf-8\r\n\r\n' +
	        metadataString +
	        '\r\n--' +
	        boundary +
	        '\r\n' +
	        'Content-Type: ' +
	        metadata_['contentType'] +
	        '\r\n\r\n';
	    var postBlobPart = '\r\n--' + boundary + '--';
	    var body = FbsBlob.getBlob(preBlobPart, blob, postBlobPart);
	    if (body === null) {
	        throw cannotSliceBlob();
	    }
	    var urlParams = { name: metadata_['fullPath'] };
	    var url = makeUrl(urlPart);
	    var method = 'POST';
	    var timeout = authWrapper.maxUploadRetryTime();
	    var requestInfo = new RequestInfo(url, method, metadataHandler(authWrapper, mappings), timeout);
	    requestInfo.urlParams = urlParams;
	    requestInfo.headers = headers;
	    requestInfo.body = body.uploadData();
	    requestInfo.errorHandler = sharedErrorHandler(location);
	    return requestInfo;
	}
	/**
	 * @param current The number of bytes that have been uploaded so far.
	 * @param total The total number of bytes in the upload.
	 * @param opt_finalized True if the server has finished the upload.
	 * @param opt_metadata The upload metadata, should
	 *     only be passed if opt_finalized is true.
	 * @struct
	 */
	var ResumableUploadStatus = /** @class */ (function () {
	    function ResumableUploadStatus(current, total, finalized, metadata) {
	        this.current = current;
	        this.total = total;
	        this.finalized = !!finalized;
	        this.metadata = metadata || null;
	    }
	    return ResumableUploadStatus;
	}());
	function checkResumeHeader_(xhr, allowed) {
	    var status = null;
	    try {
	        status = xhr.getResponseHeader('X-Goog-Upload-Status');
	    }
	    catch (e) {
	        handlerCheck(false);
	    }
	    var allowedStatus = allowed || ['active'];
	    handlerCheck(!!status && allowedStatus.indexOf(status) !== -1);
	    return status;
	}
	function createResumableUpload(authWrapper, location, mappings, blob, metadata) {
	    var urlPart = location.bucketOnlyServerUrl();
	    var metadataForUpload = metadataForUpload_(location, blob, metadata);
	    var urlParams = { name: metadataForUpload['fullPath'] };
	    var url = makeUrl(urlPart);
	    var method = 'POST';
	    var headers = {
	        'X-Goog-Upload-Protocol': 'resumable',
	        'X-Goog-Upload-Command': 'start',
	        'X-Goog-Upload-Header-Content-Length': blob.size(),
	        'X-Goog-Upload-Header-Content-Type': metadataForUpload['contentType'],
	        'Content-Type': 'application/json; charset=utf-8'
	    };
	    var body = toResourceString(metadataForUpload, mappings);
	    var timeout = authWrapper.maxUploadRetryTime();
	    function handler(xhr) {
	        checkResumeHeader_(xhr);
	        var url;
	        try {
	            url = xhr.getResponseHeader('X-Goog-Upload-URL');
	        }
	        catch (e) {
	            handlerCheck(false);
	        }
	        handlerCheck(isString(url));
	        return url;
	    }
	    var requestInfo = new RequestInfo(url, method, handler, timeout);
	    requestInfo.urlParams = urlParams;
	    requestInfo.headers = headers;
	    requestInfo.body = body;
	    requestInfo.errorHandler = sharedErrorHandler(location);
	    return requestInfo;
	}
	/**
	 * @param url From a call to fbs.requests.createResumableUpload.
	 */
	function getResumableUploadStatus(authWrapper, location, url, blob) {
	    var headers = { 'X-Goog-Upload-Command': 'query' };
	    function handler(xhr) {
	        var status = checkResumeHeader_(xhr, ['active', 'final']);
	        var sizeString = null;
	        try {
	            sizeString = xhr.getResponseHeader('X-Goog-Upload-Size-Received');
	        }
	        catch (e) {
	            handlerCheck(false);
	        }
	        if (!sizeString) {
	            // null or empty string
	            handlerCheck(false);
	        }
	        var size = Number(sizeString);
	        handlerCheck(!isNaN(size));
	        return new ResumableUploadStatus(size, blob.size(), status === 'final');
	    }
	    var method = 'POST';
	    var timeout = authWrapper.maxUploadRetryTime();
	    var requestInfo = new RequestInfo(url, method, handler, timeout);
	    requestInfo.headers = headers;
	    requestInfo.errorHandler = sharedErrorHandler(location);
	    return requestInfo;
	}
	/**
	 * Any uploads via the resumable upload API must transfer a number of bytes
	 * that is a multiple of this number.
	 */
	var resumableUploadChunkSize = 256 * 1024;
	/**
	 * @param url From a call to fbs.requests.createResumableUpload.
	 * @param chunkSize Number of bytes to upload.
	 * @param status The previous status.
	 *     If not passed or null, we start from the beginning.
	 * @throws fbs.Error If the upload is already complete, the passed in status
	 *     has a final size inconsistent with the blob, or the blob cannot be sliced
	 *     for upload.
	 */
	function continueResumableUpload(location, authWrapper, url, blob, chunkSize, mappings, status, progressCallback) {
	    // TODO(andysoto): standardize on internal asserts
	    // assert(!(opt_status && opt_status.finalized));
	    var status_ = new ResumableUploadStatus(0, 0);
	    if (status) {
	        status_.current = status.current;
	        status_.total = status.total;
	    }
	    else {
	        status_.current = 0;
	        status_.total = blob.size();
	    }
	    if (blob.size() !== status_.total) {
	        throw serverFileWrongSize();
	    }
	    var bytesLeft = status_.total - status_.current;
	    var bytesToUpload = bytesLeft;
	    if (chunkSize > 0) {
	        bytesToUpload = Math.min(bytesToUpload, chunkSize);
	    }
	    var startByte = status_.current;
	    var endByte = startByte + bytesToUpload;
	    var uploadCommand = bytesToUpload === bytesLeft ? 'upload, finalize' : 'upload';
	    var headers = {
	        'X-Goog-Upload-Command': uploadCommand,
	        'X-Goog-Upload-Offset': status_.current
	    };
	    var body = blob.slice(startByte, endByte);
	    if (body === null) {
	        throw cannotSliceBlob();
	    }
	    function handler(xhr, text) {
	        // TODO(andysoto): Verify the MD5 of each uploaded range:
	        // the 'x-range-md5' header comes back with status code 308 responses.
	        // We'll only be able to bail out though, because you can't re-upload a
	        // range that you previously uploaded.
	        var uploadStatus = checkResumeHeader_(xhr, ['active', 'final']);
	        var newCurrent = status_.current + bytesToUpload;
	        var size = blob.size();
	        var metadata;
	        if (uploadStatus === 'final') {
	            metadata = metadataHandler(authWrapper, mappings)(xhr, text);
	        }
	        else {
	            metadata = null;
	        }
	        return new ResumableUploadStatus(newCurrent, size, uploadStatus === 'final', metadata);
	    }
	    var method = 'POST';
	    var timeout = authWrapper.maxUploadRetryTime();
	    var requestInfo = new RequestInfo(url, method, handler, timeout);
	    requestInfo.headers = headers;
	    requestInfo.body = body.uploadData();
	    requestInfo.progressCallback = progressCallback || null;
	    requestInfo.errorHandler = sharedErrorHandler(location);
	    return requestInfo;
	}
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @struct
	 */
	var Observer = /** @class */ (function () {
	    function Observer(nextOrObserver, error, complete) {
	        var asFunctions = isFunction(nextOrObserver) ||
	            isDef(error) ||
	            isDef(complete);
	        if (asFunctions) {
	            this.next = nextOrObserver;
	            this.error = error || null;
	            this.complete = complete || null;
	        }
	        else {
	            var observer = nextOrObserver;
	            this.next = observer.next || null;
	            this.error = observer.error || null;
	            this.complete = observer.complete || null;
	        }
	    }
	    return Observer;
	}());
	
	var UploadTaskSnapshot = /** @class */ (function () {
	    function UploadTaskSnapshot(bytesTransferred, totalBytes, state, metadata, task, ref) {
	        this.bytesTransferred = bytesTransferred;
	        this.totalBytes = totalBytes;
	        this.state = state;
	        this.metadata = metadata;
	        this.task = task;
	        this.ref = ref;
	    }
	    return UploadTaskSnapshot;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @param name Name of the function.
	 * @param specs Argument specs.
	 * @param passed The actual arguments passed to the function.
	 * @throws {fbs.Error} If the arguments are invalid.
	 */
	function validate(name, specs, passed) {
	    var minArgs = specs.length;
	    var maxArgs = specs.length;
	    for (var i = 0; i < specs.length; i++) {
	        if (specs[i].optional) {
	            minArgs = i;
	            break;
	        }
	    }
	    var validLength = minArgs <= passed.length && passed.length <= maxArgs;
	    if (!validLength) {
	        throw invalidArgumentCount(minArgs, maxArgs, name, passed.length);
	    }
	    for (var i = 0; i < passed.length; i++) {
	        try {
	            specs[i].validator(passed[i]);
	        }
	        catch (e) {
	            if (e instanceof Error) {
	                throw invalidArgument(i, name, e.message);
	            }
	            else {
	                throw invalidArgument(i, name, e);
	            }
	        }
	    }
	}
	/**
	 * @struct
	 */
	var ArgSpec = /** @class */ (function () {
	    function ArgSpec(validator, optional) {
	        var self = this;
	        this.validator = function (p) {
	            if (self.optional && !isJustDef(p)) {
	                return;
	            }
	            validator(p);
	        };
	        this.optional = !!optional;
	    }
	    return ArgSpec;
	}());
	function and_(v1, v2) {
	    return function (p) {
	        v1(p);
	        v2(p);
	    };
	}
	function stringSpec(validator, optional) {
	    function stringValidator(p) {
	        if (!isString(p)) {
	            throw 'Expected string.';
	        }
	    }
	    var chainedValidator;
	    if (validator) {
	        chainedValidator = and_(stringValidator, validator);
	    }
	    else {
	        chainedValidator = stringValidator;
	    }
	    return new ArgSpec(chainedValidator, optional);
	}
	function uploadDataSpec() {
	    function validator(p) {
	        var valid = p instanceof Uint8Array ||
	            p instanceof ArrayBuffer ||
	            (isNativeBlobDefined() && p instanceof Blob);
	        if (!valid) {
	            throw 'Expected Blob or File.';
	        }
	    }
	    return new ArgSpec(validator);
	}
	function metadataSpec(optional) {
	    return new ArgSpec(metadataValidator, optional);
	}
	function listOptionSpec(optional) {
	    return new ArgSpec(listOptionsValidator, optional);
	}
	function nonNegativeNumberSpec() {
	    function validator(p) {
	        var valid = isNumber(p) && p >= 0;
	        if (!valid) {
	            throw 'Expected a number 0 or greater.';
	        }
	    }
	    return new ArgSpec(validator);
	}
	function looseObjectSpec(validator, optional) {
	    function isLooseObjectValidator(p) {
	        var isLooseObject = p === null || (isDef(p) && p instanceof Object);
	        if (!isLooseObject) {
	            throw 'Expected an Object.';
	        }
	        if (validator !== undefined && validator !== null) {
	            validator(p);
	        }
	    }
	    return new ArgSpec(isLooseObjectValidator, optional);
	}
	function nullFunctionSpec(optional) {
	    function validator(p) {
	        var valid = p === null || isFunction(p);
	        if (!valid) {
	            throw 'Expected a Function.';
	        }
	    }
	    return new ArgSpec(validator, optional);
	}
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Returns a function that invokes f with its arguments asynchronously as a
	 * microtask, i.e. as soon as possible after the current script returns back
	 * into browser code.
	 */
	function async(f) {
	    return function () {
	        var argsToForward = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            argsToForward[_i] = arguments[_i];
	        }
	        // eslint-disable-next-line @typescript-eslint/no-floating-promises
	        Promise.resolve().then(function () { return f.apply(void 0, argsToForward); });
	    };
	}
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Represents a blob being uploaded. Can be used to pause/resume/cancel the
	 * upload and manage callbacks for various events.
	 */
	var UploadTask = /** @class */ (function () {
	    /**
	     * @param ref The firebaseStorage.Reference object this task came
	     *     from, untyped to avoid cyclic dependencies.
	     * @param blob The blob to upload.
	     */
	    function UploadTask(ref, authWrapper, location, mappings, blob, metadata) {
	        var _this = this;
	        if (metadata === void 0) { metadata = null; }
	        this.transferred_ = 0;
	        this.needToFetchStatus_ = false;
	        this.needToFetchMetadata_ = false;
	        this.observers_ = [];
	        this.error_ = null;
	        this.uploadUrl_ = null;
	        this.request_ = null;
	        this.chunkMultiplier_ = 1;
	        this.resolve_ = null;
	        this.reject_ = null;
	        this.ref_ = ref;
	        this.authWrapper_ = authWrapper;
	        this.location_ = location;
	        this.blob_ = blob;
	        this.metadata_ = metadata;
	        this.mappings_ = mappings;
	        this.resumable_ = this.shouldDoResumable_(this.blob_);
	        this.state_ = InternalTaskState.RUNNING;
	        this.errorHandler_ = function (error) {
	            _this.request_ = null;
	            _this.chunkMultiplier_ = 1;
	            if (error.codeEquals(Code.CANCELED)) {
	                _this.needToFetchStatus_ = true;
	                _this.completeTransitions_();
	            }
	            else {
	                _this.error_ = error;
	                _this.transition_(InternalTaskState.ERROR);
	            }
	        };
	        this.metadataErrorHandler_ = function (error) {
	            _this.request_ = null;
	            if (error.codeEquals(Code.CANCELED)) {
	                _this.completeTransitions_();
	            }
	            else {
	                _this.error_ = error;
	                _this.transition_(InternalTaskState.ERROR);
	            }
	        };
	        this.promise_ = new Promise(function (resolve, reject) {
	            _this.resolve_ = resolve;
	            _this.reject_ = reject;
	            _this.start_();
	        });
	        // Prevent uncaught rejections on the internal promise from bubbling out
	        // to the top level with a dummy handler.
	        this.promise_.then(null, function () { });
	    }
	    UploadTask.prototype.makeProgressCallback_ = function () {
	        var _this = this;
	        var sizeBefore = this.transferred_;
	        return function (loaded) { return _this.updateProgress_(sizeBefore + loaded); };
	    };
	    UploadTask.prototype.shouldDoResumable_ = function (blob) {
	        return blob.size() > 256 * 1024;
	    };
	    UploadTask.prototype.start_ = function () {
	        if (this.state_ !== InternalTaskState.RUNNING) {
	            // This can happen if someone pauses us in a resume callback, for example.
	            return;
	        }
	        if (this.request_ !== null) {
	            return;
	        }
	        if (this.resumable_) {
	            if (this.uploadUrl_ === null) {
	                this.createResumable_();
	            }
	            else {
	                if (this.needToFetchStatus_) {
	                    this.fetchStatus_();
	                }
	                else {
	                    if (this.needToFetchMetadata_) {
	                        // Happens if we miss the metadata on upload completion.
	                        this.fetchMetadata_();
	                    }
	                    else {
	                        this.continueUpload_();
	                    }
	                }
	            }
	        }
	        else {
	            this.oneShotUpload_();
	        }
	    };
	    UploadTask.prototype.resolveToken_ = function (callback) {
	        var _this = this;
	        // eslint-disable-next-line @typescript-eslint/no-floating-promises
	        this.authWrapper_.getAuthToken().then(function (authToken) {
	            switch (_this.state_) {
	                case InternalTaskState.RUNNING:
	                    callback(authToken);
	                    break;
	                case InternalTaskState.CANCELING:
	                    _this.transition_(InternalTaskState.CANCELED);
	                    break;
	                case InternalTaskState.PAUSING:
	                    _this.transition_(InternalTaskState.PAUSED);
	                    break;
	            }
	        });
	    };
	    // TODO(andysoto): assert false
	    UploadTask.prototype.createResumable_ = function () {
	        var _this = this;
	        this.resolveToken_(function (authToken) {
	            var requestInfo = createResumableUpload(_this.authWrapper_, _this.location_, _this.mappings_, _this.blob_, _this.metadata_);
	            var createRequest = _this.authWrapper_.makeRequest(requestInfo, authToken);
	            _this.request_ = createRequest;
	            createRequest.getPromise().then(function (url) {
	                _this.request_ = null;
	                _this.uploadUrl_ = url;
	                _this.needToFetchStatus_ = false;
	                _this.completeTransitions_();
	            }, _this.errorHandler_);
	        });
	    };
	    UploadTask.prototype.fetchStatus_ = function () {
	        var _this = this;
	        // TODO(andysoto): assert(this.uploadUrl_ !== null);
	        var url = this.uploadUrl_;
	        this.resolveToken_(function (authToken) {
	            var requestInfo = getResumableUploadStatus(_this.authWrapper_, _this.location_, url, _this.blob_);
	            var statusRequest = _this.authWrapper_.makeRequest(requestInfo, authToken);
	            _this.request_ = statusRequest;
	            statusRequest.getPromise().then(function (status) {
	                status = status;
	                _this.request_ = null;
	                _this.updateProgress_(status.current);
	                _this.needToFetchStatus_ = false;
	                if (status.finalized) {
	                    _this.needToFetchMetadata_ = true;
	                }
	                _this.completeTransitions_();
	            }, _this.errorHandler_);
	        });
	    };
	    UploadTask.prototype.continueUpload_ = function () {
	        var _this = this;
	        var chunkSize = resumableUploadChunkSize * this.chunkMultiplier_;
	        var status = new ResumableUploadStatus(this.transferred_, this.blob_.size());
	        // TODO(andysoto): assert(this.uploadUrl_ !== null);
	        var url = this.uploadUrl_;
	        this.resolveToken_(function (authToken) {
	            var requestInfo;
	            try {
	                requestInfo = continueResumableUpload(_this.location_, _this.authWrapper_, url, _this.blob_, chunkSize, _this.mappings_, status, _this.makeProgressCallback_());
	            }
	            catch (e) {
	                _this.error_ = e;
	                _this.transition_(InternalTaskState.ERROR);
	                return;
	            }
	            var uploadRequest = _this.authWrapper_.makeRequest(requestInfo, authToken);
	            _this.request_ = uploadRequest;
	            uploadRequest
	                .getPromise()
	                .then(function (newStatus) {
	                _this.increaseMultiplier_();
	                _this.request_ = null;
	                _this.updateProgress_(newStatus.current);
	                if (newStatus.finalized) {
	                    _this.metadata_ = newStatus.metadata;
	                    _this.transition_(InternalTaskState.SUCCESS);
	                }
	                else {
	                    _this.completeTransitions_();
	                }
	            }, _this.errorHandler_);
	        });
	    };
	    UploadTask.prototype.increaseMultiplier_ = function () {
	        var currentSize = resumableUploadChunkSize * this.chunkMultiplier_;
	        // Max chunk size is 32M.
	        if (currentSize < 32 * 1024 * 1024) {
	            this.chunkMultiplier_ *= 2;
	        }
	    };
	    UploadTask.prototype.fetchMetadata_ = function () {
	        var _this = this;
	        this.resolveToken_(function (authToken) {
	            var requestInfo = getMetadata(_this.authWrapper_, _this.location_, _this.mappings_);
	            var metadataRequest = _this.authWrapper_.makeRequest(requestInfo, authToken);
	            _this.request_ = metadataRequest;
	            metadataRequest.getPromise().then(function (metadata) {
	                _this.request_ = null;
	                _this.metadata_ = metadata;
	                _this.transition_(InternalTaskState.SUCCESS);
	            }, _this.metadataErrorHandler_);
	        });
	    };
	    UploadTask.prototype.oneShotUpload_ = function () {
	        var _this = this;
	        this.resolveToken_(function (authToken) {
	            var requestInfo = multipartUpload(_this.authWrapper_, _this.location_, _this.mappings_, _this.blob_, _this.metadata_);
	            var multipartRequest = _this.authWrapper_.makeRequest(requestInfo, authToken);
	            _this.request_ = multipartRequest;
	            multipartRequest.getPromise().then(function (metadata) {
	                _this.request_ = null;
	                _this.metadata_ = metadata;
	                _this.updateProgress_(_this.blob_.size());
	                _this.transition_(InternalTaskState.SUCCESS);
	            }, _this.errorHandler_);
	        });
	    };
	    UploadTask.prototype.updateProgress_ = function (transferred) {
	        var old = this.transferred_;
	        this.transferred_ = transferred;
	        // A progress update can make the "transferred" value smaller (e.g. a
	        // partial upload not completed by server, after which the "transferred"
	        // value may reset to the value at the beginning of the request).
	        if (this.transferred_ !== old) {
	            this.notifyObservers_();
	        }
	    };
	    UploadTask.prototype.transition_ = function (state) {
	        if (this.state_ === state) {
	            return;
	        }
	        switch (state) {
	            case InternalTaskState.CANCELING:
	                // TODO(andysoto):
	                // assert(this.state_ === InternalTaskState.RUNNING ||
	                //        this.state_ === InternalTaskState.PAUSING);
	                this.state_ = state;
	                if (this.request_ !== null) {
	                    this.request_.cancel();
	                }
	                break;
	            case InternalTaskState.PAUSING:
	                // TODO(andysoto):
	                // assert(this.state_ === InternalTaskState.RUNNING);
	                this.state_ = state;
	                if (this.request_ !== null) {
	                    this.request_.cancel();
	                }
	                break;
	            case InternalTaskState.RUNNING:
	                // TODO(andysoto):
	                // assert(this.state_ === InternalTaskState.PAUSED ||
	                //        this.state_ === InternalTaskState.PAUSING);
	                var wasPaused = this.state_ === InternalTaskState.PAUSED;
	                this.state_ = state;
	                if (wasPaused) {
	                    this.notifyObservers_();
	                    this.start_();
	                }
	                break;
	            case InternalTaskState.PAUSED:
	                // TODO(andysoto):
	                // assert(this.state_ === InternalTaskState.PAUSING);
	                this.state_ = state;
	                this.notifyObservers_();
	                break;
	            case InternalTaskState.CANCELED:
	                // TODO(andysoto):
	                // assert(this.state_ === InternalTaskState.PAUSED ||
	                //        this.state_ === InternalTaskState.CANCELING);
	                this.error_ = canceled();
	                this.state_ = state;
	                this.notifyObservers_();
	                break;
	            case InternalTaskState.ERROR:
	                // TODO(andysoto):
	                // assert(this.state_ === InternalTaskState.RUNNING ||
	                //        this.state_ === InternalTaskState.PAUSING ||
	                //        this.state_ === InternalTaskState.CANCELING);
	                this.state_ = state;
	                this.notifyObservers_();
	                break;
	            case InternalTaskState.SUCCESS:
	                // TODO(andysoto):
	                // assert(this.state_ === InternalTaskState.RUNNING ||
	                //        this.state_ === InternalTaskState.PAUSING ||
	                //        this.state_ === InternalTaskState.CANCELING);
	                this.state_ = state;
	                this.notifyObservers_();
	                break;
	        }
	    };
	    UploadTask.prototype.completeTransitions_ = function () {
	        switch (this.state_) {
	            case InternalTaskState.PAUSING:
	                this.transition_(InternalTaskState.PAUSED);
	                break;
	            case InternalTaskState.CANCELING:
	                this.transition_(InternalTaskState.CANCELED);
	                break;
	            case InternalTaskState.RUNNING:
	                this.start_();
	                break;
	        }
	    };
	    Object.defineProperty(UploadTask.prototype, "snapshot", {
	        get: function () {
	            var externalState = taskStateFromInternalTaskState(this.state_);
	            return new UploadTaskSnapshot(this.transferred_, this.blob_.size(), externalState, this.metadata_, this, this.ref_);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Adds a callback for an event.
	     * @param type The type of event to listen for.
	     */
	    UploadTask.prototype.on = function (type, nextOrObserver, error, completed) {
	        function typeValidator() {
	            if (type !== TaskEvent.STATE_CHANGED) {
	                throw "Expected one of the event types: [" + TaskEvent.STATE_CHANGED + "].";
	            }
	        }
	        var nextOrObserverMessage = 'Expected a function or an Object with one of ' +
	            '`next`, `error`, `complete` properties.';
	        var nextValidator = nullFunctionSpec(true).validator;
	        var observerValidator = looseObjectSpec(null, true).validator;
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        function nextOrObserverValidator(p) {
	            try {
	                nextValidator(p);
	                return;
	            }
	            catch (e) { }
	            try {
	                observerValidator(p);
	                var anyDefined = isJustDef(p['next']) ||
	                    isJustDef(p['error']) ||
	                    isJustDef(p['complete']);
	                if (!anyDefined) {
	                    throw '';
	                }
	                return;
	            }
	            catch (e) {
	                throw nextOrObserverMessage;
	            }
	        }
	        var specs = [
	            stringSpec(typeValidator),
	            looseObjectSpec(nextOrObserverValidator, true),
	            nullFunctionSpec(true),
	            nullFunctionSpec(true)
	        ];
	        validate('on', specs, arguments);
	        var self = this;
	        function makeBinder(specs) {
	            function binder(nextOrObserver, error, complete) {
	                if (specs !== null) {
	                    validate('on', specs, arguments);
	                }
	                var observer = new Observer(nextOrObserver, error, completed);
	                self.addObserver_(observer);
	                return function () {
	                    self.removeObserver_(observer);
	                };
	            }
	            return binder;
	        }
	        function binderNextOrObserverValidator(p) {
	            if (p === null) {
	                throw nextOrObserverMessage;
	            }
	            nextOrObserverValidator(p);
	        }
	        var binderSpecs = [
	            looseObjectSpec(binderNextOrObserverValidator),
	            nullFunctionSpec(true),
	            nullFunctionSpec(true)
	        ];
	        var typeOnly = !(isJustDef(nextOrObserver) ||
	            isJustDef(error) ||
	            isJustDef(completed));
	        if (typeOnly) {
	            return makeBinder(binderSpecs);
	        }
	        else {
	            return makeBinder(null)(nextOrObserver, error, completed);
	        }
	    };
	    /**
	     * This object behaves like a Promise, and resolves with its snapshot data
	     * when the upload completes.
	     * @param onFulfilled The fulfillment callback. Promise chaining works as normal.
	     * @param onRejected The rejection callback.
	     */
	    UploadTask.prototype.then = function (onFulfilled, onRejected) {
	        // These casts are needed so that TypeScript can infer the types of the
	        // resulting Promise.
	        return this.promise_.then(onFulfilled, onRejected);
	    };
	    /**
	     * Equivalent to calling `then(null, onRejected)`.
	     */
	    UploadTask.prototype.catch = function (onRejected) {
	        return this.then(null, onRejected);
	    };
	    /**
	     * Adds the given observer.
	     */
	    UploadTask.prototype.addObserver_ = function (observer) {
	        this.observers_.push(observer);
	        this.notifyObserver_(observer);
	    };
	    /**
	     * Removes the given observer.
	     */
	    UploadTask.prototype.removeObserver_ = function (observer) {
	        var i = this.observers_.indexOf(observer);
	        if (i !== -1) {
	            this.observers_.splice(i, 1);
	        }
	    };
	    UploadTask.prototype.notifyObservers_ = function () {
	        var _this = this;
	        this.finishPromise_();
	        var observers = this.observers_.slice();
	        observers.forEach(function (observer) {
	            _this.notifyObserver_(observer);
	        });
	    };
	    UploadTask.prototype.finishPromise_ = function () {
	        if (this.resolve_ !== null) {
	            var triggered = true;
	            switch (taskStateFromInternalTaskState(this.state_)) {
	                case TaskState.SUCCESS:
	                    async(this.resolve_.bind(null, this.snapshot))();
	                    break;
	                case TaskState.CANCELED:
	                case TaskState.ERROR:
	                    var toCall = this.reject_;
	                    async(toCall.bind(null, this.error_))();
	                    break;
	                default:
	                    triggered = false;
	                    break;
	            }
	            if (triggered) {
	                this.resolve_ = null;
	                this.reject_ = null;
	            }
	        }
	    };
	    UploadTask.prototype.notifyObserver_ = function (observer) {
	        var externalState = taskStateFromInternalTaskState(this.state_);
	        switch (externalState) {
	            case TaskState.RUNNING:
	            case TaskState.PAUSED:
	                if (observer.next) {
	                    async(observer.next.bind(observer, this.snapshot))();
	                }
	                break;
	            case TaskState.SUCCESS:
	                if (observer.complete) {
	                    async(observer.complete.bind(observer))();
	                }
	                break;
	            case TaskState.CANCELED:
	            case TaskState.ERROR:
	                if (observer.error) {
	                    async(observer.error.bind(observer, this.error_))();
	                }
	                break;
	            default:
	                // TODO(andysoto): assert(false);
	                if (observer.error) {
	                    async(observer.error.bind(observer, this.error_))();
	                }
	        }
	    };
	    /**
	     * Resumes a paused task. Has no effect on a currently running or failed task.
	     * @return True if the operation took effect, false if ignored.
	     */
	    UploadTask.prototype.resume = function () {
	        validate('resume', [], arguments);
	        var valid = this.state_ === InternalTaskState.PAUSED ||
	            this.state_ === InternalTaskState.PAUSING;
	        if (valid) {
	            this.transition_(InternalTaskState.RUNNING);
	        }
	        return valid;
	    };
	    /**
	     * Pauses a currently running task. Has no effect on a paused or failed task.
	     * @return True if the operation took effect, false if ignored.
	     */
	    UploadTask.prototype.pause = function () {
	        validate('pause', [], arguments);
	        var valid = this.state_ === InternalTaskState.RUNNING;
	        if (valid) {
	            this.transition_(InternalTaskState.PAUSING);
	        }
	        return valid;
	    };
	    /**
	     * Cancels a currently running or paused task. Has no effect on a complete or
	     * failed task.
	     * @return True if the operation took effect, false if ignored.
	     */
	    UploadTask.prototype.cancel = function () {
	        validate('cancel', [], arguments);
	        var valid = this.state_ === InternalTaskState.RUNNING ||
	            this.state_ === InternalTaskState.PAUSING;
	        if (valid) {
	            this.transition_(InternalTaskState.CANCELING);
	        }
	        return valid;
	    };
	    return UploadTask;
	}());
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Provides methods to interact with a bucket in the Firebase Storage service.
	 * @param location An fbs.location, or the URL at
	 *     which to base this object, in one of the following forms:
	 *         gs://<bucket>/<object-path>
	 *         http[s]://firebasestorage.googleapis.com/
	 *                     <api-version>/b/<bucket>/o/<object-path>
	 *     Any query or fragment strings will be ignored in the http[s]
	 *     format. If no value is passed, the storage object will use a URL based on
	 *     the project ID of the base firebase.App instance.
	 */
	var Reference = /** @class */ (function () {
	    function Reference(authWrapper, location) {
	        this.authWrapper = authWrapper;
	        if (location instanceof Location) {
	            this.location = location;
	        }
	        else {
	            this.location = Location.makeFromUrl(location);
	        }
	    }
	    /**
	     * @return The URL for the bucket and path this object references,
	     *     in the form gs://<bucket>/<object-path>
	     * @override
	     */
	    Reference.prototype.toString = function () {
	        validate('toString', [], arguments);
	        return 'gs://' + this.location.bucket + '/' + this.location.path;
	    };
	    Reference.prototype.newRef = function (authWrapper, location) {
	        return new Reference(authWrapper, location);
	    };
	    Reference.prototype.mappings = function () {
	        return getMappings();
	    };
	    /**
	     * @return A reference to the object obtained by
	     *     appending childPath, removing any duplicate, beginning, or trailing
	     *     slashes.
	     */
	    Reference.prototype.child = function (childPath) {
	        validate('child', [stringSpec()], arguments);
	        var newPath = child(this.location.path, childPath);
	        var location = new Location(this.location.bucket, newPath);
	        return this.newRef(this.authWrapper, location);
	    };
	    Object.defineProperty(Reference.prototype, "parent", {
	        /**
	         * @return A reference to the parent of the
	         *     current object, or null if the current object is the root.
	         */
	        get: function () {
	            var newPath = parent(this.location.path);
	            if (newPath === null) {
	                return null;
	            }
	            var location = new Location(this.location.bucket, newPath);
	            return this.newRef(this.authWrapper, location);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Reference.prototype, "root", {
	        /**
	         * @return An reference to the root of this
	         *     object's bucket.
	         */
	        get: function () {
	            var location = new Location(this.location.bucket, '');
	            return this.newRef(this.authWrapper, location);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Reference.prototype, "bucket", {
	        get: function () {
	            return this.location.bucket;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Reference.prototype, "fullPath", {
	        get: function () {
	            return this.location.path;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Reference.prototype, "name", {
	        get: function () {
	            return lastComponent(this.location.path);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Reference.prototype, "storage", {
	        get: function () {
	            return this.authWrapper.service();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Uploads a blob to this object's location.
	     * @param data The blob to upload.
	     * @return An UploadTask that lets you control and
	     *     observe the upload.
	     */
	    Reference.prototype.put = function (data, metadata) {
	        if (metadata === void 0) { metadata = null; }
	        validate('put', [uploadDataSpec(), metadataSpec(true)], arguments);
	        this.throwIfRoot_('put');
	        return new UploadTask(this, this.authWrapper, this.location, this.mappings(), new FbsBlob(data), metadata);
	    };
	    /**
	     * Uploads a string to this object's location.
	     * @param value The string to upload.
	     * @param format The format of the string to upload.
	     * @return An UploadTask that lets you control and
	     *     observe the upload.
	     */
	    Reference.prototype.putString = function (value, format, metadata) {
	        if (format === void 0) { format = StringFormat.RAW; }
	        validate('putString', [stringSpec(), stringSpec(formatValidator, true), metadataSpec(true)], arguments);
	        this.throwIfRoot_('putString');
	        var data = dataFromString(format, value);
	        var metadataClone = Object.assign({}, metadata);
	        if (!isDef(metadataClone['contentType']) &&
	            isDef(data.contentType)) {
	            metadataClone['contentType'] = data.contentType;
	        }
	        return new UploadTask(this, this.authWrapper, this.location, this.mappings(), new FbsBlob(data.data, true), metadataClone);
	    };
	    /**
	     * Deletes the object at this location.
	     * @return A promise that resolves if the deletion succeeds.
	     */
	    Reference.prototype.delete = function () {
	        var _this = this;
	        validate('delete', [], arguments);
	        this.throwIfRoot_('delete');
	        return this.authWrapper.getAuthToken().then(function (authToken) {
	            var requestInfo = deleteObject(_this.authWrapper, _this.location);
	            return _this.authWrapper.makeRequest(requestInfo, authToken).getPromise();
	        });
	    };
	    /**
	     * List all items (files) and prefixes (folders) under this storage reference.
	     *
	     * This is a helper method for calling list() repeatedly until there are
	     * no more results. The default pagination size is 1000.
	     *
	     * Note: The results may not be consistent if objects are changed while this
	     * operation is running.
	     *
	     * Warning: listAll may potentially consume too many resources if there are
	     * too many results.
	     *
	     * @return A Promise that resolves with all the items and prefixes under
	     *      the current storage reference. `prefixes` contains references to
	     *      sub-directories and `items` contains references to objects in this
	     *      folder. `nextPageToken` is never returned.
	     */
	    Reference.prototype.listAll = function () {
	        validate('listAll', [], arguments);
	        var accumulator = {
	            prefixes: [],
	            items: []
	        };
	        return this.listAllHelper(accumulator).then(function () { return accumulator; });
	    };
	    Reference.prototype.listAllHelper = function (accumulator, pageToken) {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var opt, nextPage;
	            var _a, _b;
	            return tslib.__generator(this, function (_c) {
	                switch (_c.label) {
	                    case 0:
	                        opt = {
	                            // maxResults is 1000 by default.
	                            pageToken: pageToken
	                        };
	                        return [4 /*yield*/, this.list(opt)];
	                    case 1:
	                        nextPage = _c.sent();
	                        (_a = accumulator.prefixes).push.apply(_a, nextPage.prefixes);
	                        (_b = accumulator.items).push.apply(_b, nextPage.items);
	                        if (!(nextPage.nextPageToken != null)) return [3 /*break*/, 3];
	                        return [4 /*yield*/, this.listAllHelper(accumulator, nextPage.nextPageToken)];
	                    case 2:
	                        _c.sent();
	                        _c.label = 3;
	                    case 3: return [2 /*return*/];
	                }
	            });
	        });
	    };
	    /**
	     * List items (files) and prefixes (folders) under this storage reference.
	     *
	     * List API is only available for Firebase Rules Version 2.
	     *
	     * GCS is a key-blob store. Firebase Storage imposes the semantic of '/'
	     * delimited folder structure.
	     * Refer to GCS's List API if you want to learn more.
	     *
	     * To adhere to Firebase Rules's Semantics, Firebase Storage does not
	     * support objects whose paths end with "/" or contain two consecutive
	     * "/"s. Firebase Storage List API will filter these unsupported objects.
	     * list() may fail if there are too many unsupported objects in the bucket.
	     *
	     * @param options See ListOptions for details.
	     * @return A Promise that resolves with the items and prefixes.
	     *      `prefixes` contains references to sub-folders and `items`
	     *      contains references to objects in this folder. `nextPageToken`
	     *      can be used to get the rest of the results.
	     */
	    Reference.prototype.list = function (options) {
	        validate('list', [listOptionSpec(true)], arguments);
	        var self = this;
	        return this.authWrapper.getAuthToken().then(function (authToken) {
	            var op = options || {};
	            var requestInfo = list(self.authWrapper, self.location, 
	            /*delimiter= */ '/', op.pageToken, op.maxResults);
	            return self.authWrapper.makeRequest(requestInfo, authToken).getPromise();
	        });
	    };
	    /**
	     *     A promise that resolves with the metadata for this object. If this
	     *     object doesn't exist or metadata cannot be retreived, the promise is
	     *     rejected.
	     */
	    Reference.prototype.getMetadata = function () {
	        var _this = this;
	        validate('getMetadata', [], arguments);
	        this.throwIfRoot_('getMetadata');
	        return this.authWrapper.getAuthToken().then(function (authToken) {
	            var requestInfo = getMetadata(_this.authWrapper, _this.location, _this.mappings());
	            return _this.authWrapper.makeRequest(requestInfo, authToken).getPromise();
	        });
	    };
	    /**
	     * Updates the metadata for this object.
	     * @param metadata The new metadata for the object.
	     *     Only values that have been explicitly set will be changed. Explicitly
	     *     setting a value to null will remove the metadata.
	     * @return A promise that resolves
	     *     with the new metadata for this object.
	     *     @see firebaseStorage.Reference.prototype.getMetadata
	     */
	    Reference.prototype.updateMetadata = function (metadata) {
	        var _this = this;
	        validate('updateMetadata', [metadataSpec()], arguments);
	        this.throwIfRoot_('updateMetadata');
	        return this.authWrapper.getAuthToken().then(function (authToken) {
	            var requestInfo = updateMetadata(_this.authWrapper, _this.location, metadata, _this.mappings());
	            return _this.authWrapper.makeRequest(requestInfo, authToken).getPromise();
	        });
	    };
	    /**
	     * @return A promise that resolves with the download
	     *     URL for this object.
	     */
	    Reference.prototype.getDownloadURL = function () {
	        var _this = this;
	        validate('getDownloadURL', [], arguments);
	        this.throwIfRoot_('getDownloadURL');
	        return this.authWrapper.getAuthToken().then(function (authToken) {
	            var requestInfo = getDownloadUrl(_this.authWrapper, _this.location, _this.mappings());
	            return _this.authWrapper
	                .makeRequest(requestInfo, authToken)
	                .getPromise()
	                .then(function (url) {
	                if (url === null) {
	                    throw noDownloadURL();
	                }
	                return url;
	            });
	        });
	    };
	    Reference.prototype.throwIfRoot_ = function (name) {
	        if (this.location.path === '') {
	            throw invalidRootOperation(name);
	        }
	    };
	    return Reference;
	}());
	
	/**
	 * A request whose promise always fails.
	 * @struct
	 * @template T
	 */
	var FailRequest = /** @class */ (function () {
	    function FailRequest(error) {
	        this.promise_ = Promise.reject(error);
	    }
	    /** @inheritDoc */
	    FailRequest.prototype.getPromise = function () {
	        return this.promise_;
	    };
	    /** @inheritDoc */
	    FailRequest.prototype.cancel = function (_appDelete) {
	    };
	    return FailRequest;
	}());
	
	var RequestMap = /** @class */ (function () {
	    function RequestMap() {
	        this.map = new Map();
	        this.id = MIN_SAFE_INTEGER;
	    }
	    /**
	     * Registers the given request with this map.
	     * The request is unregistered when it completes.
	     *
	     * @param request The request to register.
	     */
	    RequestMap.prototype.addRequest = function (request) {
	        var _this = this;
	        var id = this.id;
	        this.id++;
	        this.map.set(id, request);
	        request.getPromise().then(function () { return _this.map.delete(id); }, function () { return _this.map.delete(id); });
	    };
	    /**
	     * Cancels all registered requests.
	     */
	    RequestMap.prototype.clear = function () {
	        this.map.forEach(function (v) {
	            v && v.cancel(true);
	        });
	        this.map.clear();
	    };
	    return RequestMap;
	}());
	
	/**
	 * @param app If null, getAuthToken always resolves with null.
	 * @param service The storage service associated with this auth wrapper.
	 *     Untyped to avoid circular type dependencies.
	 * @struct
	 */
	var AuthWrapper = /** @class */ (function () {
	    function AuthWrapper(app, authProvider, maker, requestMaker, service, pool) {
	        var _a;
	        this.bucket_ = null;
	        this.appId_ = null;
	        this.deleted_ = false;
	        this.app_ = app;
	        if (this.app_ !== null) {
	            var options = this.app_.options;
	            if (isDef(options)) {
	                this.bucket_ = AuthWrapper.extractBucket_(options);
	                this.appId_ = (_a = options.appId) !== null && _a !== void 0 ? _a : null;
	            }
	        }
	        this.authProvider_ = authProvider;
	        this.storageRefMaker_ = maker;
	        this.requestMaker_ = requestMaker;
	        this.pool_ = pool;
	        this.service_ = service;
	        this.maxOperationRetryTime_ = DEFAULT_MAX_OPERATION_RETRY_TIME;
	        this.maxUploadRetryTime_ = DEFAULT_MAX_UPLOAD_RETRY_TIME;
	        this.requestMap_ = new RequestMap();
	    }
	    AuthWrapper.extractBucket_ = function (config) {
	        var bucketString = config[CONFIG_STORAGE_BUCKET_KEY] || null;
	        if (bucketString == null) {
	            return null;
	        }
	        var loc = Location.makeFromBucketSpec(bucketString);
	        return loc.bucket;
	    };
	    AuthWrapper.prototype.getAuthToken = function () {
	        var auth = this.authProvider_.getImmediate({ optional: true });
	        if (auth) {
	            return auth.getToken().then(function (response) {
	                if (response !== null) {
	                    return response.accessToken;
	                }
	                else {
	                    return null;
	                }
	            }, function () { return null; });
	        }
	        else {
	            return Promise.resolve(null);
	        }
	    };
	    AuthWrapper.prototype.bucket = function () {
	        if (this.deleted_) {
	            throw appDeleted();
	        }
	        else {
	            return this.bucket_;
	        }
	    };
	    /**
	     * The service associated with this auth wrapper. Untyped to avoid circular
	     * type dependencies.
	     */
	    AuthWrapper.prototype.service = function () {
	        return this.service_;
	    };
	    /**
	     * Returns a new firebaseStorage.Reference object referencing this AuthWrapper
	     * at the given Location.
	     * @param loc The Location.
	     * @return Actually a firebaseStorage.Reference, typing not allowed
	     *     because of circular dependency problems.
	     */
	    AuthWrapper.prototype.makeStorageReference = function (loc) {
	        return this.storageRefMaker_(this, loc);
	    };
	    AuthWrapper.prototype.makeRequest = function (requestInfo, authToken) {
	        if (!this.deleted_) {
	            var request = this.requestMaker_(requestInfo, this.appId_, authToken, this.pool_);
	            this.requestMap_.addRequest(request);
	            return request;
	        }
	        else {
	            return new FailRequest(appDeleted());
	        }
	    };
	    /**
	     * Stop running requests and prevent more from being created.
	     */
	    AuthWrapper.prototype.deleteApp = function () {
	        this.deleted_ = true;
	        this.app_ = null;
	        this.requestMap_.clear();
	    };
	    AuthWrapper.prototype.maxUploadRetryTime = function () {
	        return this.maxUploadRetryTime_;
	    };
	    AuthWrapper.prototype.setMaxUploadRetryTime = function (time) {
	        this.maxUploadRetryTime_ = time;
	    };
	    AuthWrapper.prototype.maxOperationRetryTime = function () {
	        return this.maxOperationRetryTime_;
	    };
	    AuthWrapper.prototype.setMaxOperationRetryTime = function (time) {
	        this.maxOperationRetryTime_ = time;
	    };
	    return AuthWrapper;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @param f May be invoked
	 *     before the function returns.
	 * @param callback Get all the arguments passed to the function
	 *     passed to f, including the initial boolean.
	 */
	function start(f, callback, timeout) {
	    // TODO(andysoto): make this code cleaner (probably refactor into an actual
	    // type instead of a bunch of functions with state shared in the closure)
	    var waitSeconds = 1;
	    // Would type this as "number" but that doesn't work for Node so ¯\_(ツ)_/¯
	    // TODO: find a way to exclude Node type definition for storage because storage only works in browser
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    var timeoutId = null;
	    var hitTimeout = false;
	    var cancelState = 0;
	    function canceled() {
	        return cancelState === 2;
	    }
	    var triggeredCallback = false;
	    // TODO: This disable can be removed and the 'ignoreRestArgs' option added to
	    // the no-explicit-any rule when ESlint releases it.
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    function triggerCallback() {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        if (!triggeredCallback) {
	            triggeredCallback = true;
	            callback.apply(null, args);
	        }
	    }
	    function callWithDelay(millis) {
	        timeoutId = setTimeout(function () {
	            timeoutId = null;
	            f(handler, canceled());
	        }, millis);
	    }
	    // TODO: This disable can be removed and the 'ignoreRestArgs' option added to
	    // the no-explicit-any rule when ESlint releases it.
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    function handler(success) {
	        var args = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            args[_i - 1] = arguments[_i];
	        }
	        if (triggeredCallback) {
	            return;
	        }
	        if (success) {
	            triggerCallback.call.apply(triggerCallback, tslib.__spreadArrays([null, success], args));
	            return;
	        }
	        var mustStop = canceled() || hitTimeout;
	        if (mustStop) {
	            triggerCallback.call.apply(triggerCallback, tslib.__spreadArrays([null, success], args));
	            return;
	        }
	        if (waitSeconds < 64) {
	            /* TODO(andysoto): don't back off so quickly if we know we're offline. */
	            waitSeconds *= 2;
	        }
	        var waitMillis;
	        if (cancelState === 1) {
	            cancelState = 2;
	            waitMillis = 0;
	        }
	        else {
	            waitMillis = (waitSeconds + Math.random()) * 1000;
	        }
	        callWithDelay(waitMillis);
	    }
	    var stopped = false;
	    function stop(wasTimeout) {
	        if (stopped) {
	            return;
	        }
	        stopped = true;
	        if (triggeredCallback) {
	            return;
	        }
	        if (timeoutId !== null) {
	            if (!wasTimeout) {
	                cancelState = 2;
	            }
	            clearTimeout(timeoutId);
	            callWithDelay(0);
	        }
	        else {
	            if (!wasTimeout) {
	                cancelState = 1;
	            }
	        }
	    }
	    callWithDelay(0);
	    setTimeout(function () {
	        hitTimeout = true;
	        stop(true);
	    }, timeout);
	    return stop;
	}
	/**
	 * Stops the retry loop from repeating.
	 * If the function is currently "in between" retries, it is invoked immediately
	 * with the second parameter as "true". Otherwise, it will be invoked once more
	 * after the current invocation finishes iff the current invocation would have
	 * triggered another retry.
	 */
	function stop(id) {
	    id(false);
	}
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @struct
	 * @template T
	 */
	var NetworkRequest = /** @class */ (function () {
	    function NetworkRequest(url, method, headers, body, successCodes, additionalRetryCodes, callback, errorCallback, timeout, progressCallback, pool) {
	        var _this = this;
	        this.pendingXhr_ = null;
	        this.backoffId_ = null;
	        this.resolve_ = null;
	        this.reject_ = null;
	        this.canceled_ = false;
	        this.appDelete_ = false;
	        this.url_ = url;
	        this.method_ = method;
	        this.headers_ = headers;
	        this.body_ = body;
	        this.successCodes_ = successCodes.slice();
	        this.additionalRetryCodes_ = additionalRetryCodes.slice();
	        this.callback_ = callback;
	        this.errorCallback_ = errorCallback;
	        this.progressCallback_ = progressCallback;
	        this.timeout_ = timeout;
	        this.pool_ = pool;
	        this.promise_ = new Promise(function (resolve, reject) {
	            _this.resolve_ = resolve;
	            _this.reject_ = reject;
	            _this.start_();
	        });
	    }
	    /**
	     * Actually starts the retry loop.
	     */
	    NetworkRequest.prototype.start_ = function () {
	        var self = this;
	        function doTheRequest(backoffCallback, canceled) {
	            if (canceled) {
	                backoffCallback(false, new RequestEndStatus(false, null, true));
	                return;
	            }
	            var xhr = self.pool_.createXhrIo();
	            self.pendingXhr_ = xhr;
	            function progressListener(progressEvent) {
	                var loaded = progressEvent.loaded;
	                var total = progressEvent.lengthComputable ? progressEvent.total : -1;
	                if (self.progressCallback_ !== null) {
	                    self.progressCallback_(loaded, total);
	                }
	            }
	            if (self.progressCallback_ !== null) {
	                xhr.addUploadProgressListener(progressListener);
	            }
	            // eslint-disable-next-line @typescript-eslint/no-floating-promises
	            xhr
	                .send(self.url_, self.method_, self.body_, self.headers_)
	                .then(function (xhr) {
	                if (self.progressCallback_ !== null) {
	                    xhr.removeUploadProgressListener(progressListener);
	                }
	                self.pendingXhr_ = null;
	                xhr = xhr;
	                var hitServer = xhr.getErrorCode() === ErrorCode.NO_ERROR;
	                var status = xhr.getStatus();
	                if (!hitServer || self.isRetryStatusCode_(status)) {
	                    var wasCanceled = xhr.getErrorCode() === ErrorCode.ABORT;
	                    backoffCallback(false, new RequestEndStatus(false, null, wasCanceled));
	                    return;
	                }
	                var successCode = self.successCodes_.indexOf(status) !== -1;
	                backoffCallback(true, new RequestEndStatus(successCode, xhr));
	            });
	        }
	        /**
	         * @param requestWentThrough True if the request eventually went
	         *     through, false if it hit the retry limit or was canceled.
	         */
	        function backoffDone(requestWentThrough, status) {
	            var resolve = self.resolve_;
	            var reject = self.reject_;
	            var xhr = status.xhr;
	            if (status.wasSuccessCode) {
	                try {
	                    var result = self.callback_(xhr, xhr.getResponseText());
	                    if (isJustDef(result)) {
	                        resolve(result);
	                    }
	                    else {
	                        resolve();
	                    }
	                }
	                catch (e) {
	                    reject(e);
	                }
	            }
	            else {
	                if (xhr !== null) {
	                    var err = unknown();
	                    err.setServerResponseProp(xhr.getResponseText());
	                    if (self.errorCallback_) {
	                        reject(self.errorCallback_(xhr, err));
	                    }
	                    else {
	                        reject(err);
	                    }
	                }
	                else {
	                    if (status.canceled) {
	                        var err = self.appDelete_ ? appDeleted() : canceled();
	                        reject(err);
	                    }
	                    else {
	                        var err = retryLimitExceeded();
	                        reject(err);
	                    }
	                }
	            }
	        }
	        if (this.canceled_) {
	            backoffDone(false, new RequestEndStatus(false, null, true));
	        }
	        else {
	            this.backoffId_ = start(doTheRequest, backoffDone, this.timeout_);
	        }
	    };
	    /** @inheritDoc */
	    NetworkRequest.prototype.getPromise = function () {
	        return this.promise_;
	    };
	    /** @inheritDoc */
	    NetworkRequest.prototype.cancel = function (appDelete) {
	        this.canceled_ = true;
	        this.appDelete_ = appDelete || false;
	        if (this.backoffId_ !== null) {
	            stop(this.backoffId_);
	        }
	        if (this.pendingXhr_ !== null) {
	            this.pendingXhr_.abort();
	        }
	    };
	    NetworkRequest.prototype.isRetryStatusCode_ = function (status) {
	        // The codes for which to retry came from this page:
	        // https://cloud.google.com/storage/docs/exponential-backoff
	        var isFiveHundredCode = status >= 500 && status < 600;
	        var extraRetryCodes = [
	            // Request Timeout: web server didn't receive full request in time.
	            408,
	            // Too Many Requests: you're getting rate-limited, basically.
	            429
	        ];
	        var isExtraRetryCode = extraRetryCodes.indexOf(status) !== -1;
	        var isRequestSpecificRetryCode = this.additionalRetryCodes_.indexOf(status) !== -1;
	        return isFiveHundredCode || isExtraRetryCode || isRequestSpecificRetryCode;
	    };
	    return NetworkRequest;
	}());
	/**
	 * A collection of information about the result of a network request.
	 * @param opt_canceled Defaults to false.
	 * @struct
	 */
	var RequestEndStatus = /** @class */ (function () {
	    function RequestEndStatus(wasSuccessCode, xhr, canceled) {
	        this.wasSuccessCode = wasSuccessCode;
	        this.xhr = xhr;
	        this.canceled = !!canceled;
	    }
	    return RequestEndStatus;
	}());
	function addAuthHeader_(headers, authToken) {
	    if (authToken !== null && authToken.length > 0) {
	        headers['Authorization'] = 'Firebase ' + authToken;
	    }
	}
	function addVersionHeader_(headers) {
	    var version = typeof firebase !== 'undefined' ? firebase.SDK_VERSION : 'AppManager';
	    headers['X-Firebase-Storage-Version'] = 'webjs/' + version;
	}
	function addGmpidHeader_(headers, appId) {
	    if (appId) {
	        headers['X-Firebase-GMPID'] = appId;
	    }
	}
	/**
	 * @template T
	 */
	function makeRequest(requestInfo, appId, authToken, pool) {
	    var queryPart = makeQueryString(requestInfo.urlParams);
	    var url = requestInfo.url + queryPart;
	    var headers = Object.assign({}, requestInfo.headers);
	    addGmpidHeader_(headers, appId);
	    addAuthHeader_(headers, authToken);
	    addVersionHeader_(headers);
	    return new NetworkRequest(url, requestInfo.method, headers, requestInfo.body, requestInfo.successCodes, requestInfo.additionalRetryCodes, requestInfo.handler, requestInfo.errorHandler, requestInfo.timeout, requestInfo.progressCallback, pool);
	}
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * A service that provides firebaseStorage.Reference instances.
	 * @param opt_url gs:// url to a custom Storage Bucket
	 *
	 * @struct
	 */
	var Service = /** @class */ (function () {
	    function Service(app, authProvider, pool, url) {
	        this.bucket_ = null;
	        function maker(authWrapper, loc) {
	            return new Reference(authWrapper, loc);
	        }
	        this.authWrapper_ = new AuthWrapper(app, authProvider, maker, makeRequest, this, pool);
	        this.app_ = app;
	        if (url != null) {
	            this.bucket_ = Location.makeFromBucketSpec(url);
	        }
	        else {
	            var authWrapperBucket = this.authWrapper_.bucket();
	            if (authWrapperBucket != null) {
	                this.bucket_ = new Location(authWrapperBucket, '');
	            }
	        }
	        this.internals_ = new ServiceInternals(this);
	    }
	    /**
	     * Returns a firebaseStorage.Reference for the given path in the default
	     * bucket.
	     */
	    Service.prototype.ref = function (path) {
	        function validator(path) {
	            if (typeof path !== 'string') {
	                throw 'Path is not a string.';
	            }
	            if (/^[A-Za-z]+:\/\//.test(path)) {
	                throw 'Expected child path but got a URL, use refFromURL instead.';
	            }
	        }
	        validate('ref', [stringSpec(validator, true)], arguments);
	        if (this.bucket_ == null) {
	            throw new Error('No Storage Bucket defined in Firebase Options.');
	        }
	        var ref = new Reference(this.authWrapper_, this.bucket_);
	        if (path != null) {
	            return ref.child(path);
	        }
	        else {
	            return ref;
	        }
	    };
	    /**
	     * Returns a firebaseStorage.Reference object for the given absolute URL,
	     * which must be a gs:// or http[s]:// URL.
	     */
	    Service.prototype.refFromURL = function (url) {
	        function validator(p) {
	            if (typeof p !== 'string') {
	                throw 'Path is not a string.';
	            }
	            if (!/^[A-Za-z]+:\/\//.test(p)) {
	                throw 'Expected full URL but got a child path, use ref instead.';
	            }
	            try {
	                Location.makeFromUrl(p);
	            }
	            catch (e) {
	                throw 'Expected valid full URL but got an invalid one.';
	            }
	        }
	        validate('refFromURL', [stringSpec(validator, false)], arguments);
	        return new Reference(this.authWrapper_, url);
	    };
	    Object.defineProperty(Service.prototype, "maxUploadRetryTime", {
	        get: function () {
	            return this.authWrapper_.maxUploadRetryTime();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Service.prototype.setMaxUploadRetryTime = function (time) {
	        validate('setMaxUploadRetryTime', [nonNegativeNumberSpec()], arguments);
	        this.authWrapper_.setMaxUploadRetryTime(time);
	    };
	    Service.prototype.setMaxOperationRetryTime = function (time) {
	        validate('setMaxOperationRetryTime', [nonNegativeNumberSpec()], arguments);
	        this.authWrapper_.setMaxOperationRetryTime(time);
	    };
	    Object.defineProperty(Service.prototype, "app", {
	        get: function () {
	            return this.app_;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Service.prototype, "INTERNAL", {
	        get: function () {
	            return this.internals_;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return Service;
	}());
	/**
	 * @struct
	 */
	var ServiceInternals = /** @class */ (function () {
	    function ServiceInternals(service) {
	        this.service_ = service;
	    }
	    /**
	     * Called when the associated app is deleted.
	     * @see {!fbs.AuthWrapper.prototype.deleteApp}
	     */
	    ServiceInternals.prototype.delete = function () {
	        this.service_.authWrapper_.deleteApp();
	        return Promise.resolve();
	    };
	    return ServiceInternals;
	}());
	
	var name = "@firebase/storage";
	var version = "0.3.34";
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Type constant for Firebase Storage.
	 */
	var STORAGE_TYPE = 'storage';
	function factory(container, url) {
	    // Dependencies
	    var app = container.getProvider('app').getImmediate();
	    var authProvider = container.getProvider('auth-internal');
	    return new Service(app, authProvider, new XhrIoPool(), url);
	}
	function registerStorage(instance) {
	    var namespaceExports = {
	        // no-inline
	        TaskState: TaskState,
	        TaskEvent: TaskEvent,
	        StringFormat: StringFormat,
	        Storage: Service,
	        Reference: Reference
	    };
	    instance.INTERNAL.registerComponent(new component.Component(STORAGE_TYPE, factory, "PUBLIC" /* PUBLIC */)
	        .setServiceProps(namespaceExports)
	        .setMultipleInstances(true));
	    instance.registerVersion(name, version);
	}
	registerStorage(firebase);
	
	exports.registerStorage = registerStorage;
	//# sourceMappingURL=index.cjs.js.map


/***/ }),
/* 272 */
262,
/* 273 */
262,
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.withFirebase = undefined;
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var FirebaseContext = _react2.default.createContext(null);
	
	var withFirebase = exports.withFirebase = function withFirebase(Component) {
	  return function (props) {
	    return _react2.default.createElement(FirebaseContext.Consumer, null, function (firebase) {
	      return _react2.default.createElement(Component, _extends({}, props, { firebase: firebase }));
	    });
	  };
	};
	
	exports.default = FirebaseContext;

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _app = __webpack_require__(163);
	
	var _app2 = _interopRequireDefault(_app);
	
	__webpack_require__(386);
	
	__webpack_require__(388);
	
	__webpack_require__(387);
	
	__webpack_require__(164);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	var Firebase = function Firebase() {
	  var _this = this;
	
	  _classCallCheck(this, Firebase);
	
	  this.doInitiate = function (dbName) {
	    //console.log("Doing fb init");
	    var config = {};
	
	    //console.log("yes it is brooklynz");
	    //console.log(window.location.hostname);
	    if (window.location.hostname === "app.brooklynzcommunitysupport.com") {
	      console.log("rodp");
	      config = {
	        apiKey: "AIzaSyDy2xShHWWf7y_imfJp3JwwxO81SpI-MfY",
	        authDomain: "bcs-fb-database.firebaseapp.com",
	        databaseURL: "https://bcs-fb-database.firebaseio.com",
	        projectId: "bcs-fb-database",
	        storageBucket: "bcsfbtest",
	        messagingSenderId: "506308287965",
	        appId: "1:506308287965:web:c4757661f1911a16156a34"
	      };
	    } else {
	      console.log("vedp");
	      config = {
	        apiKey: "AIzaSyDy2xShHWWf7y_imfJp3JwwxO81SpI-MfY",
	        authDomain: "bcs-fb-database.firebaseapp.com",
	        databaseURL: "https://bcs-fb-database.firebaseio.com",
	        projectId: "bcs-fb-database",
	        storageBucket: "bcsfbtest",
	        messagingSenderId: "506308287965",
	        appId: "1:506308287965:web:c4757661f1911a16156a34"
	      };
	      // config = {
	      //   apiKey: "AIzaSyC8zPSIZ0D1hD4SCtkopZcfjKoSmH2d6oQ",
	      //   authDomain: "bcs-fb-dev.firebaseapp.com",
	      //   databaseURL: "https://bcs-fb-dev.firebaseio.com",
	      //   projectId: "bcs-fb-dev",
	      //   storageBucket: "bcsfbtest",
	      //   messagingSenderId: "548075302244",
	      //   appId: "1:548075302244:web:f3cbe772dd237dd9f21e71",
	      //   measurementId: "G-3324ZXRXMJ"
	      // };
	    }
	
	    //console.log("Initializing firebase");
	    _app2.default.initializeApp(config);
	    //console.log("Initialize completed");
	    /* Helper */
	
	    _this.serverValue = _app2.default.database.ServerValue;
	    _this.emailAuthProvider = _app2.default.auth.EmailAuthProvider;
	    _this.phoneAuthProvider = _app2.default.auth.PhoneAuthProvider;
	
	    //console.log("Session established: " + JSON.stringify(this.serverValue));
	    /* Firebase APIs */
	
	    _this.auth = _app2.default.auth();
	    _this.db = _app2.default.database();
	    _this.storage = _app2.default.storage();
	    _this.perf = _app2.default.performance();
	    _this.dbUrl = config.databaseURL;
	  };
	
	  this.doCreateUserWithEmailAndPassword = function (email, password) {
	    return _this.auth.createUserWithEmailAndPassword(email, password);
	  };
	
	  this.doSignInWithEmailAndPassword = function (email, password) {
	    return _this.auth.signInWithEmailAndPassword(email, password);
	  };
	
	  this.doSignInWithGoogle = function () {
	    return _this.auth.signInWithPopup(_this.googleProvider);
	  };
	
	  this.doSignInWithFacebook = function () {
	    return _this.auth.signInWithPopup(_this.facebookProvider);
	  };
	
	  this.doSignInWithTwitter = function () {
	    return _this.auth.signInWithPopup(_this.twitterProvider);
	  };
	
	  this.doSignOut = function () {
	    return _this.auth.signOut();
	  };
	
	  this.doPasswordReset = function (email) {
	    return _this.auth.sendPasswordResetEmail(email);
	  };
	
	  this.doSendEmailVerification = function () {
	    return _this.auth.currentUser.sendEmailVerification({
	      url: ({"NODE_ENV":"production"}).REACT_APP_CONFIRMATION_EMAIL_REDIRECT
	    });
	  };
	
	  this.doPasswordUpdate = function (password) {
	    return _this.auth.currentUser.updatePassword(password);
	  };
	
	  this.onAuthUserListener = function (next, fallback) {
	    return _this.auth.onAuthStateChanged(function (authUser) {
	      //console.log("Auth listening");
	      if (authUser) {
	        _this.user(authUser.uid).once("value").then(function (snapshot) {
	          var dbUser = snapshot.val();
	
	          // default empty roles
	
	          // dbUser.roles = {};
	
	          // // merge auth and db user
	          // authUser = {
	          //   uid: authUser.uid,
	          //   email: authUser.email,
	          //   emailVerified: authUser.emailVerified,
	          //   providerData: authUser.providerData,
	          //   ...dbUser,
	          // };
	
	          next(authUser);
	        });
	      } else {
	        fallback();
	      }
	    });
	  };
	
	  this.user = function (uid) {
	    return _this.db.ref("users/" + uid);
	  };
	
	  this.users = function () {
	    return _this.db.ref("users");
	  };
	
	  this.message = function (uid) {
	    return _this.db.ref("messages/" + uid);
	  };
	
	  this.messages = function () {
	    return _this.db.ref("messages");
	  };
	}
	
	// *** Auth API ***
	
	// *** Merge Auth and DB User API *** //
	
	// *** User API ***
	
	// *** Message API ***
	
	;
	
	exports.default = Firebase;

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Menu = undefined;
	
	var _MenuGroup = __webpack_require__(277);
	
	Object.keys(_MenuGroup).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _MenuGroup[key];
	    }
	  });
	});
	
	var _MenuGroupItem = __webpack_require__(280);
	
	Object.keys(_MenuGroupItem).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _MenuGroupItem[key];
	    }
	  });
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MenuStyled = __webpack_require__(281);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var propTypes = {};
	var defaultProps = {};
	
	var Menu = exports.Menu = function Menu(props) {
	  return _react2.default.createElement(_MenuStyled.MenuStyled, null, props.children);
	};
	
	Menu.propTypes = propTypes;
	Menu.defaultProps = defaultProps;
	Menu.displayName = 'Menu';

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MenuGroup = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TitleStyled = __webpack_require__(279);
	
	var _MenuGroupStyled = __webpack_require__(278);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var propTypes = {
	  title: _propTypes2.default.string
	};
	
	var defaultProps = {
	  title: ''
	};
	
	var MenuGroup = exports.MenuGroup = function MenuGroup(props) {
	  var groupTitle = props.title ? _react2.default.createElement(_TitleStyled.TitleStyled, null, props.title) : null;
	
	  return _react2.default.createElement(_MenuGroupStyled.MenuGroupStyled, { hasTitle: props.title }, groupTitle, props.children);
	};
	
	MenuGroup.propTypes = propTypes;
	MenuGroup.defaultProps = defaultProps;
	MenuGroup.displayName = 'MenuGroup';

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MenuGroupStyled = undefined;
	
	var _templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n  margin: 0;\n  list-style-type: none;\n  padding: ", "px 0;\n  ", "\n"], ["\n  width: 100%;\n  margin: 0;\n  list-style-type: none;\n  padding: ", "px 0;\n  ", "\n"]);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _styleHelpers = __webpack_require__(161);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _taggedTemplateLiteral(strings, raw) {
	  return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } }));
	}
	
	var hasTitle = function hasTitle(_ref) {
	  var hasTitle = _ref.hasTitle;
	  return hasTitle ? "padding-top: 0;" : "";
	};
	
	var MenuGroupStyled = exports.MenuGroupStyled = _styledComponents2.default.menu(_templateObject, (0, _styleHelpers.baseModule)(1), hasTitle);
	
	MenuGroupStyled.displayName = "MenuGroupStyled";

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TitleStyled = undefined;
	
	var _templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n  margin: 0;\n  list-style-type: none;\n  padding: ", "px ", "px;\n  margin-bottom: ", "px;\n  background-color: rgba(0, 0, 0, 0.07);\n  color: rgba(255, 255, 255, 0.6);\n  text-transform: uppercase;\n  font-weight: ", ";\n  font-size: ", "px;\n  letter-spacing: 0.5px;\n"], ["\n  width: 100%;\n  margin: 0;\n  list-style-type: none;\n  padding: ", "px ", "px;\n  margin-bottom: ", "px;\n  background-color: rgba(0, 0, 0, 0.07);\n  color: rgba(255, 255, 255, 0.6);\n  text-transform: uppercase;\n  font-weight: ", ";\n  font-size: ", "px;\n  letter-spacing: 0.5px;\n"]);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _styleHelpers = __webpack_require__(161);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _taggedTemplateLiteral(strings, raw) {
	  return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } }));
	}
	
	var TitleStyled = exports.TitleStyled = _styledComponents2.default.div(_templateObject, (0, _styleHelpers.baseModule)(1), (0, _styleHelpers.baseModule)(2), (0, _styleHelpers.baseModule)(0.5), _styleHelpers.fontWeightSemibold, _styleHelpers.fontSizeSmall);
	
	TitleStyled.displayName = "TitleStyled";

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MenuGroupItem = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactackle = __webpack_require__(5);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var MenuGroupItem = exports.MenuGroupItem = function MenuGroupItem(props) {
	  return _react2.default.createElement(_reactackle.Button, { text: props.text, onPress: props.onPress, colorScheme: "secondary" });
	};

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MenuStyled = undefined;
	
	var _templateObject = _taggedTemplateLiteral(['\n  width: 100%;\n  min-width: 0;\n  flex-shrink: 0;\n'], ['\n  width: 100%;\n  min-width: 0;\n  flex-shrink: 0;\n']);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _taggedTemplateLiteral(strings, raw) {
	  return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } }));
	}
	
	var MenuStyled = exports.MenuStyled = _styledComponents2.default.div(_templateObject);
	
	MenuStyled.displayName = 'MenuStyled';

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	};
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _numeral = __webpack_require__(16);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var _reactLazyLoadImageComponent = __webpack_require__(30);
	
	__webpack_require__(67);
	
	var _util = __webpack_require__(922);
	
	__webpack_require__(244);
	
	var _reactLoadingSkeleton = __webpack_require__(124);
	
	var _reactLoadingSkeleton2 = _interopRequireDefault(_reactLoadingSkeleton);
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof2(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var AdminCard = function (_Component) {
	  _inherits(AdminCard, _Component);
	
	  function AdminCard(props) {
	    _classCallCheck(this, AdminCard);
	
	    //console.log(JSON.stringify(this.props.data));
	    var _this = _possibleConstructorReturn(this, (AdminCard.__proto__ || Object.getPrototypeOf(AdminCard)).call(this, props));
	
	    _this.stateChangeHandler = function (val, id, isPayload) {
	      //console.log("val: " + val + " id: " + id + " isPayload: " + isPayload);
	      var tmpState = {};
	      tmpState[id] = val;
	
	      if (isPayload) {
	        _this.setState(function (prevState) {
	          if (prevState && prevState.data.payload !== null) {
	            return _extends({}, prevState, {
	              data: _extends({}, prevState.data, {
	                payload: _extends({}, prevState.data.payload, tmpState)
	              })
	            });
	          } else {
	            return _extends({}, prevState, {
	              data: {
	                path: prevState.data.path,
	                payload: _extends({}, tmpState)
	              }
	            });
	          }
	        });
	      } else {
	        _this.setState(function (prevState) {
	          return _extends({}, prevState, tmpState);
	        });
	      }
	    };
	
	    _this.itemUpdateHandler = function (rowNum, newVal, recKey) {
	      // console.log(
	      //   "rowNum: " + rowNum + " recKey: " + recKey + " newVal: " + newVal
	      // );
	
	      var tmpData = _.cloneDeep(_this.props.data);
	      //console.log("Before: " + JSON.stringify(tmpData[rowNum]));
	      if (rowNum !== undefined && (0, _util.isNumber)(rowNum)) {
	        tmpData["requestedItems"][rowNum][recKey] = newVal;
	        var newAmt = tmpData["requestedItems"][rowNum]["quantity"] * tmpData["requestedItems"][rowNum]["productPrice"];
	        //console.log(newAmt);
	        newAmt = newAmt.toFixed(2);
	        //console.log(newAmt);
	        tmpData["requestedItems"][rowNum]["amount"] = "" + newAmt + "";
	        //console.log("After: " + JSON.stringify(tmpData[rowNum]));
	      } else {
	        //console.log(recKey + " value to be set to " + newVal);
	        tmpData[recKey] = newVal;
	      }
	
	      _this.props.updateRecord({ path: _this.props.tableName, payload: tmpData });
	    };
	
	    _this.getEditRow = function (lable, value, fieldName, index) {
	      // console.log(
	      //   "getting edit row: " + lable + " " + value + " " + fieldName + " " + index
	      // );
	      var calcVal = 0;
	      if (fieldName === "amount") {
	        if (_this.props.data.requestedItems && _this.props.data.requestedItems[index]) {
	          var itemDets = _.cloneDeep(_this.props.data.requestedItems[index]);
	          var qty = itemDets.quantity;
	          var prc = itemDets.productPrice;
	          if (qty && qty > 0 && prc && prc > 0) {
	            calcVal = (qty * prc).toFixed(2);
	          }
	        }
	      }
	      return _react2.default.createElement("tr", null, _react2.default.createElement("td", null, lable), _react2.default.createElement("td", null, _react2.default.createElement("input", {
	        type: "text",
	        value: fieldName === "amount" ? calcVal : value,
	        onChange: function onChange(e) {
	          _this.itemUpdateHandler(index, e.target.value, fieldName);
	        },
	        style: {
	          width: "100%",
	          marginBottom: "2px"
	        }
	      })));
	    };
	
	    _this.getEditBucket = function (product, index) {
	      var _ref;
	
	      return _react2.default.createElement("div", {
	        style: {
	          display: "flex",
	          alignItems: "center",
	          paddingBottom: "5px"
	        }
	      }, _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, {
	        src: product.photos && product.photos.length > 0 ? product.photos[0].url : "",
	        style: {
	          maxWidth: "50px",
	          maxHeight: "50px",
	          height: _this.state[0] ? "50px" : "0px",
	          width: _this.state[0] ? "50px" : "0px",
	          borderRadius: "50px",
	          border: _this.state[0] ? "1px solid gainsboro" : "0px",
	          objectFit: "contain",
	          margin: _this.state[0] ? "5px" : "0px",
	          minWidth: _this.state[0] ? "50px" : null
	        },
	        afterLoad: function afterLoad() {
	          _this.setState(function (prevState) {
	            return _extends({}, prevState, _defineProperty({}, 0, true));
	          });
	        }
	      }), !_this.state[0] && _react2.default.createElement(_reactLoadingSkeleton2.default, {
	        style: (_ref = {
	          height: "50px",
	          width: "50px",
	          borderRadius: "50px",
	          border: "1px solid gainsboro"
	        }, _defineProperty(_ref, "border", "0px solid gainsboro"), _defineProperty(_ref, "margin", "5px"), _ref),
	        duration: 1
	      }), _react2.default.createElement("div", {
	        style: {
	          width: "100%",
	          display: "flex"
	        }
	      }, _react2.default.createElement("table", {
	        className: "table table-lg",
	        style: {
	          margin: "auto"
	        }
	      }, _this.getEditRow("Name", product.productNameEnglish, "productNameEnglish", index), _this.getEditRow("Unit", product.unit, "unit", index), _this.getEditRow("UnitPrice", product.productPrice, "productPrice", index), _this.getEditRow("Qty", product.quantity, "quantity", index), _this.getEditRow("Amt", product.amount, "amount", index))));
	    };
	
	    _this.getImageSize = function () {
	      if (_this.state.magnify) {
	        return {
	          maxWidth: "250px",
	          maxHeight: "250px",
	          height: _this.state[0] ? "200px" : "0px",
	          width: _this.state[0] ? "200px" : "0px",
	          borderRadius: "0px",
	          border: _this.state[0] ? "1px solid gainsboro" : "0px",
	          objectFit: "contain",
	          margin: _this.state[0] ? "5px" : "0px",
	          minWidth: _this.state[0] ? "250px" : null
	        };
	      } else {
	        return {
	          maxWidth: "50px",
	          maxHeight: "50px",
	          height: _this.state[0] ? "50px" : "0px",
	          width: _this.state[0] ? "50px" : "0px",
	          borderRadius: "50px",
	          border: _this.state[0] ? "1px solid gainsboro" : "0px",
	          objectFit: "contain",
	          margin: _this.state[0] ? "5px" : "0px",
	          minWidth: _this.state[0] ? "50px" : null
	        };
	      }
	    };
	
	    _this.getReadOnlyBucket = function (product) {
	      var _ref2;
	
	      return _react2.default.createElement("div", {
	        style: {
	          display: !_this.state.magnify ? "flex" : null,
	          alignItems: "center",
	          paddingBottom: "0px",
	          overflow: "scroll",
	          textAlign: !_this.state.magnify ? null : "center"
	        }
	      }, _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, {
	        src: product.photos && product.photos.length > 0 ? product.photos[0].url : "",
	        style: _this.getImageSize(),
	        afterLoad: function afterLoad() {
	          _this.setState(function (prevState) {
	            return _extends({}, prevState, _defineProperty({}, 0, true));
	          });
	        }
	      }), !_this.state[0] && _react2.default.createElement(_reactLoadingSkeleton2.default, {
	        style: (_ref2 = {
	          height: "50px",
	          width: "50px",
	          borderRadius: "50px",
	          border: "1px solid gainsboro"
	        }, _defineProperty(_ref2, "border", "0px solid gainsboro"), _defineProperty(_ref2, "margin", "5px"), _ref2),
	        duration: 1
	      }), _react2.default.createElement("div", {
	        style: {
	          width: !_this.state.magnify ? "100%" : "250px",
	          display: "flex",
	          textAlign: !_this.state.magnify ? null : "left",
	          margin: !_this.state.magnify ? null : "auto"
	        }
	      }, _react2.default.createElement("table", {
	        className: "table table-lg",
	        style: {
	          margin: "auto"
	        }
	      }, _react2.default.createElement("tr", {
	        style: {
	          backgroundColor: product.done ? "pink" : "transparent",
	          fontWeight: product.done ? "bold" : "normal",
	          fontSize: product.done ? "14px" : "6px"
	        }
	      }, _react2.default.createElement("td", {
	        style: {
	          paddingLeft: "5px"
	        }
	      }, product.done ? "PICK UP DONE" : "PENDING PICK UP"), _react2.default.createElement("td", {
	        style: {
	          textAlign: "right",
	          paddingRight: "5px"
	        }
	      }, product.done ? _react2.default.createElement("icon", {
	        className: "fa fa-check",
	        style: {
	          fontSize: "14px"
	        }
	      }) : null)), _react2.default.createElement("tr", {
	        style: {
	          fontSize: "14px"
	        }
	      }, _react2.default.createElement("td", null, product.productNameEnglish), _react2.default.createElement("td", null, _react2.default.createElement("div", {
	        style: {
	          textAlign: "right",
	          margin: "3px"
	        }
	      }, product.quantity + " x " + product.unit))), _react2.default.createElement("tr", null, _react2.default.createElement("td", null, "Customer Price"), _react2.default.createElement("td", null, _react2.default.createElement("div", {
	        style: {
	          fontSize: "12px",
	          textAlign: "right",
	          margin: "3px"
	        }
	      }, "$", product.amount))), _react2.default.createElement("tr", null, _react2.default.createElement("td", null), _react2.default.createElement("td", null)))));
	    };
	
	    _this.getItems = function (currOgBucket) {
	      //console.log("here is currBucket: " + JSON.stringify(currBucket));
	      var currBucket = _.cloneDeep(currOgBucket);
	      if (currBucket && currBucket.length > 0 && currBucket !== "" && (typeof currBucket === "undefined" ? "undefined" : _typeof(currBucket)) === "object") {
	        return currBucket.map(function (product, index) {
	          return _react2.default.createElement("div", {
	            style: {
	              border: "1px solid white",
	              margin: "0px",
	              fontSize: "10px"
	            },
	            onClick: function onClick() {
	              var data = _.cloneDeep(_this.props.data);
	              if (data.status !== "DELIVERED" && data.status !== "CANCELLED") {
	                data.requestedItems[index]["done"] = !data.requestedItems[index]["done"];
	
	                if (data && data.key && data.key !== "") {
	                  var cloudPath = _this.props.path + "/" + data.key;
	
	                  _this.props.firebase.db.ref("/" + cloudPath).once("value").then(function (snap) {
	                    return snap.ref.set(data);
	                  }).catch(function (err) {
	                    console.log(err);
	                    alert("Update could not be compeleted. " + err);
	                    return "";
	                  }).then(function (err) {});
	                }
	              }
	            }
	          }, !_this.state.editMode && _this.getReadOnlyBucket(product), _this.state.editMode && _this.getEditBucket(product, index), _react2.default.createElement("hr", { style: { margin: "5px" } }));
	        });
	      }
	    };
	
	    _this.getTotal = function (currBucket, ordTotal) {
	      //console.log("calcing total again: " + JSON.stringify(currBucket));
	      if (currBucket && currBucket.length > 0 && currBucket !== "" && (typeof currBucket === "undefined" ? "undefined" : _typeof(currBucket)) === "object") {
	        try {
	          if (_this.state.editMode) {
	            var totAmt = currBucket.reduce(function (sum, item) {
	              sum = sum + parseFloat(item.amount.replace(/,/g, ""));
	              return parseFloat(sum);
	            }, 0);
	
	            return (0, _numeral2.default)(totAmt).format("0,0.00");
	          } else {
	            if (ordTotal && ordTotal !== "") {
	              return ordTotal;
	            } else {
	              return "0.00";
	            }
	          }
	        } catch (err) {
	          return 0;
	        }
	      }
	    };
	
	    _this.getBasicRow = function (label, value, fieldName) {
	      if (_this.state.editMode) {
	        return _react2.default.createElement("div", null, _react2.default.createElement("div", {
	          style: {
	            display: "flex",
	            flexDirection: "row",
	            marginLeft: "5px",
	            marginRight: "5px",
	            padding: "5px",
	            fontSize: "12px"
	          }
	        }, _react2.default.createElement("div", {
	          style: {
	            width: "50%",
	            textAlign: "left"
	          }
	        }, label), _react2.default.createElement("div", {
	          style: {
	            width: "50%",
	            textAlign: "left"
	          }
	        }, _react2.default.createElement("input", {
	          type: "text",
	          value: value,
	          onChange: function onChange(e) {
	            _this.itemUpdateHandler(undefined, e.target.value, fieldName);
	          },
	          style: {
	            width: "100%",
	            marginBottom: "2px"
	          }
	        }))), _react2.default.createElement("hr", {
	          style: {
	            margin: "0px"
	          }
	        }));
	      } else {
	        return _react2.default.createElement("div", null, _react2.default.createElement("div", {
	          style: {
	            display: "flex",
	            flexDirection: "row",
	            marginLeft: "5px",
	            marginRight: "5px",
	            padding: "5px",
	            fontSize: "12px"
	          }
	        }, _react2.default.createElement("div", {
	          style: {
	            width: "50%",
	            textAlign: "left"
	          }
	        }, label), _react2.default.createElement("div", {
	          style: {
	            width: "50%",
	            textAlign: "left",
	            overflow: "scroll"
	          }
	        }, value)), _react2.default.createElement("hr", {
	          style: {
	            margin: "0px"
	          }
	        }));
	      }
	    };
	
	    _this.saveHandler = function (sentData) {
	      var data = _.cloneDeep(_this.props.data);
	      if (sentData && sentData !== undefined) {
	        data = sentData;
	      }
	      if (data && data.key && data.key !== "") {
	        var cloudPath = _this.props.path + "/" + data.key;
	        if (_this.props.firebase.auth && _this.props.firebase.auth.currentUser && _this.props.firebase.auth.currentUser.phoneNumber) {
	          data["author"] = _this.props.firebase.auth.currentUser.phoneNumber;
	        } else {
	          //to be covered later? do we need this for super admin?
	          data["author"] = "";
	        }
	
	        _this.props.firebase.db.ref("/" + cloudPath).once("value").then(function (snap) {
	          return snap.ref.set(data);
	        }).catch(function (err) {
	          console.log(err);
	          alert("Order could not be compeleted. " + err);
	          return "";
	        }).then(function (err) {
	          _this.stateChangeHandler(false, "editMode", false);
	        });
	
	        _this.props.firebase.db.ref("/myOrders" + "/" + data.mobile + "/" + data.key).once("value").then(function (snap) {
	          return snap.ref.set(data);
	        }).catch(function (err) {
	          console.log(err);
	          alert("Order could not be compeleted. " + err);
	          return "";
	        }).then(function (err) {
	          _this.stateChangeHandler(false, "editMode", false);
	        });
	      }
	    };
	
	    _this.saveMessageHandler = function () {
	      if (_this.state.message && _this.state.message.msgText && _this.state.message.msgText.length > 0) {
	        var data = _.cloneDeep(_this.props.data);
	        if (data.messages && data.messages.length > 0) {
	          data.messages.push(_this.state.message);
	        } else {
	          data["messages"] = [];
	          data.messages.push(_this.state.message);
	        }
	        if (data && data.key && data.key !== "") {
	          var cloudPath = _this.props.path + "/" + data.key;
	          if (_this.props.firebase.auth && _this.props.firebase.auth.currentUser && _this.props.firebase.auth.currentUser.phoneNumber) {
	            data["author"] = _this.props.firebase.auth.currentUser.phoneNumber;
	          } else {
	            //to be covered later? do we need this for super admin?
	            data["author"] = "";
	          }
	
	          _this.props.firebase.db.ref("/" + cloudPath).once("value").then(function (snap) {
	            _this.props.onNotifyUsers("BCS App says: " + _this.refs.searchText.value, [data.mobile], false);
	            _this.refs.searchText.value = "";
	
	            return snap.ref.set(data);
	          }).catch(function (err) {
	            console.log(err);
	            alert("Messages could not be saved. " + err);
	            return "";
	          }).then(function (err) {
	            _this.stateChangeHandler(false, "editMode", false);
	          });
	
	          _this.props.firebase.db.ref("/myOrders" + "/" + data.mobile + "/" + data.key).once("value").then(function (snap) {
	            return snap.ref.set(data);
	          }).catch(function (err) {
	            console.log(err);
	            alert("Order could not be compeleted. " + err);
	            return "";
	          }).then(function (err) {
	            _this.stateChangeHandler(false, "editMode", false);
	          });
	        }
	      }
	    };
	
	    _this.getMessages = function () {
	      var msgs = _this.props.data.messages;
	
	      if (msgs && msgs.length > 0) {
	        return msgs.map(function (msg) {
	          // //if (msg.author === "+6589050302") {
	          //   //console.log(JSON.stringify(this.props.allSuppliers));
	          //   console.log(msg.author.replace("+65", ""));
	          //   console.log(
	          //     this.props.allSuppliers.includes(msg.author.replace("+65", ""))
	          //   );
	          // //}
	          var fromMe = _this.props.allSuppliers.includes(msg.author.replace("+65", "")) ? "from-me" : "";
	
	          return _react2.default.createElement("div", { className: "message " + fromMe }, _react2.default.createElement("div", { className: "username" }, msg.msgTime + "  " + msg.author), _react2.default.createElement("div", { className: "message-body" }, msg.msgText));
	        });
	      }
	    };
	
	    _this.getCard = function () {
	      //console.log("getting card ");
	      var rec = _this.props.data;
	
	      if (rec && rec !== undefined) {
	        var _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref11, _ref12, _ref13;
	
	        return _react2.default.createElement("div", {
	          style: {
	            borderRadius: "10px",
	            backgroundColor: "white",
	            margin: "5px",
	            padding: "10px",
	            marginBottom: "15px",
	            fontSize: "12px",
	            fontWeight: "bold",
	            border: "1.5px solid #ccc",
	            boxSizing: "border-box",
	            boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)"
	          }
	        }, _this.props.regular && _react2.default.createElement("div", null, _react2.default.createElement("div", { style: { display: "flex", flexDirection: "row" } }, _react2.default.createElement("div", {
	          style: (_ref3 = {
	            color: "#333",
	            fontSize: "14px",
	            backgroundColor: "rgb(30, 101, 144)",
	            padding: "5px",
	            borderRadius: "5px"
	          }, _defineProperty(_ref3, "color", "white"), _defineProperty(_ref3, "width", "50%"), _defineProperty(_ref3, "margin", "5px"), _defineProperty(_ref3, "textAlign", "center"), _ref3)
	        }, _react2.default.createElement("div", {
	          onClick: function onClick() {
	            if (_this.state.editMode) {
	              var resConfirm = confirm("Please confirm if you would like to update & save this order?");
	
	              if (resConfirm) {
	                //send the save here
	                _this.saveHandler();
	              }
	            }
	          }
	        }, "SAVE")), _react2.default.createElement("div", {
	          style: (_ref4 = {
	            color: "#333",
	            fontSize: "14px",
	            backgroundColor: "rgb(30, 101, 144)",
	            padding: "5px",
	            borderRadius: "5px"
	          }, _defineProperty(_ref4, "color", "white"), _defineProperty(_ref4, "width", "50%"), _defineProperty(_ref4, "margin", "5px"), _defineProperty(_ref4, "textAlign", "center"), _ref4)
	        }, _react2.default.createElement("div", {
	          onClick: function onClick() {
	            _this.stateChangeHandler(!_this.state.editMode, "editMode", false);
	          }
	        }, !_this.state.editMode ? "EDIT" : "CLOSE"))), _react2.default.createElement("div", { style: { display: "flex", flexDirection: "row" } }, _react2.default.createElement("div", {
	          style: (_ref5 = {
	            color: "#333",
	            fontSize: "14px",
	            backgroundColor: _this.props.data.mealType === "LUNCH" ? "rgb(30, 101, 144)" : "rgb(186 217 243)",
	            padding: "5px",
	            borderRadius: "5px"
	          }, _defineProperty(_ref5, "color", "white"), _defineProperty(_ref5, "width", "50%"), _defineProperty(_ref5, "margin", "5px"), _defineProperty(_ref5, "textAlign", "center"), _ref5)
	        }, _react2.default.createElement("div", {
	          onClick: function onClick() {
	            var newRec = _.cloneDeep(_this.props.data);
	            newRec["mealType"] = "LUNCH";
	            _this.saveHandler(newRec);
	          }
	        }, "LUNCH")), _react2.default.createElement("div", {
	          style: (_ref6 = {
	            color: "#333",
	            fontSize: "14px",
	            backgroundColor: _this.props.data.mealType && _this.props.data.mealType === "DINNER" ? "rgb(30, 101, 144)" : "rgb(186 217 243)",
	            padding: "5px",
	            borderRadius: "5px"
	          }, _defineProperty(_ref6, "color", "white"), _defineProperty(_ref6, "width", "50%"), _defineProperty(_ref6, "margin", "5px"), _defineProperty(_ref6, "textAlign", "center"), _ref6)
	        }, _react2.default.createElement("div", {
	          onClick: function onClick() {
	            var newRec = _.cloneDeep(_this.props.data);
	            newRec["mealType"] = "DINNER";
	            _this.saveHandler(newRec);
	          }
	        }, "DINNER"))), !_this.state.editMode && _react2.default.createElement("div", { style: { display: "flex", flexDirection: "row" } }, _react2.default.createElement("div", {
	          style: (_ref7 = {
	            color: "#333",
	            fontSize: "14px",
	            backgroundColor: "red",
	            padding: "5px",
	            borderRadius: "5px"
	          }, _defineProperty(_ref7, "color", "white"), _defineProperty(_ref7, "width", "30%"), _defineProperty(_ref7, "margin", "5px"), _defineProperty(_ref7, "textAlign", "center"), _ref7)
	        }, _react2.default.createElement("div", {
	          onClick: function onClick() {
	            var resConfirm = confirm("Please confirm if you would like mark this order as CANCELLED?");
	
	            if (resConfirm) {
	              var tmpData = _.cloneDeep(_this.props.data);
	              //console.log("Before: " + JSON.stringify(tmpData[rowNum]));
	              tmpData["status"] = "CANCELLED";
	              _this.saveHandler(tmpData);
	            }
	          }
	        }, "CANCEL")), _react2.default.createElement("div", {
	          style: (_ref8 = {
	            color: "#333",
	            fontSize: "14px",
	            backgroundColor: "rgb(30, 101, 144)",
	            padding: "5px",
	            borderRadius: "5px"
	          }, _defineProperty(_ref8, "color", "white"), _defineProperty(_ref8, "width", "30%"), _defineProperty(_ref8, "margin", "5px"), _defineProperty(_ref8, "textAlign", "center"), _ref8)
	        }, _react2.default.createElement("div", {
	          onClick: function onClick() {
	            var tmpData = _.cloneDeep(_this.props.data);
	            //console.log("Before: " + JSON.stringify(tmpData[rowNum]));
	            tmpData["status"] = "IN PROGRESS";
	
	            _this.saveHandler(tmpData);
	          }
	        }, "WORKING")), _react2.default.createElement("div", {
	          style: (_ref9 = {
	            color: "#333",
	            fontSize: "14px",
	            backgroundColor: "rgb(30, 101, 144)",
	            padding: "5px",
	            borderRadius: "5px"
	          }, _defineProperty(_ref9, "color", "white"), _defineProperty(_ref9, "width", "30%"), _defineProperty(_ref9, "margin", "5px"), _defineProperty(_ref9, "textAlign", "center"), _ref9)
	        }, _react2.default.createElement("div", {
	          onClick: function onClick() {
	            var resConfirm = confirm("Please confirm if you would like mark this order as DELIVERED?");
	
	            if (resConfirm) {
	              var tmpData = _.cloneDeep(_this.props.data);
	              //console.log("Before: " + JSON.stringify(tmpData[rowNum]));
	              tmpData["status"] = "DELIVERED";
	              _this.saveHandler(tmpData);
	            }
	          }
	        }, "DONE"))), _react2.default.createElement("hr", {
	          style: {
	            margin: "0px"
	          }
	        }), _this.getBasicRow("Status", rec.status, "status"), _this.getBasicRow("Order Date", rec.createDateTime && rec.createDateTime !== undefined && rec.createDateTime !== "" ? rec.createDateTime : rec.deliveryDate + " " + (rec.orderTime && rec.orderTime !== "" ? rec.orderTime : ""), "deliveryDate"), _this.getBasicRow("Last Update", rec.updateDateTime && rec.updateDateTime !== undefined && rec.updateDateTime !== "" ? rec.updateDateTime : "", "updateDateTime"), _react2.default.createElement("div", {
	          style: {
	            padding: "1px",
	            textAlign: "right",
	            border: "1px solid gainsboro",
	            backgroundColor: "white",
	            zIndex: "-9"
	          }
	        }, _react2.default.createElement("div", {
	          style: {
	            display: "flex",
	            direction: "row",
	            alignItems: "center"
	          }
	        }, _react2.default.createElement("div", {
	          style: {
	            fontSize: "14px",
	            border: "0px solid black",
	            cursor: "pointer",
	            width: "200px",
	            height: "30px",
	            lineHeight: "30px",
	            textAlign: "left",
	            margin: "5px",
	            marginLeft: "15px",
	            marginRight: "15px"
	          },
	          onClick: function onClick() {}
	        }, "Del Dt"), _react2.default.createElement("div", {
	          style: {
	            borderRadius: "5px",
	            color: "#fff",
	            backgroundColor: "rgb(30, 101, 144)",
	            fontSize: "1.5em",
	            border: "0px solid black",
	            cursor: "pointer",
	            fontWeight: "bold",
	            width: "60px",
	            height: "30px",
	            lineHeight: "30px",
	            textAlign: "center",
	            margin: "5px",
	            marginLeft: "15px"
	          },
	          onClick: function onClick() {
	            var currTgtDate = (0, _moment2.default)(rec.targetDeliveryDate, "ddd DD-MM-YYYY");
	            var newDate = currTgtDate.subtract(1, "day");
	            var newRec = _.cloneDeep(_this.props.data);
	            newRec["targetDeliveryDate"] = newDate.format("ddd DD-MM-YYYY").toString();
	            _this.saveHandler(newRec);
	          }
	        }, "<"), _react2.default.createElement("div", {
	          style: {
	            width: "100%",
	            lineHeight: "45px",
	            textAlign: "center"
	          }
	        }, rec.targetDeliveryDate), _react2.default.createElement("div", {
	          style: {
	            borderRadius: "5px",
	            color: "#fff",
	            backgroundColor: "rgb(30, 101, 144)",
	            fontSize: "1.5em",
	            border: "0px solid black",
	            cursor: "pointer",
	            fontWeight: "bold",
	            width: "60px",
	            height: "30px",
	            lineHeight: "30px",
	            textAlign: "center",
	            margin: "5px",
	            marginRight: "15px"
	          },
	          onClick: function onClick() {
	            //console.log("trying delivery date move to next");
	            var currTgtDate = (0, _moment2.default)(rec.targetDeliveryDate, "ddd DD-MM-YYYY");
	            //console.log(currTgtDate);
	            var newDate = currTgtDate.add(1, "day");
	            //console.log(newDate.format("ddd DD-MM-YYYY").toString());
	            var newRec = _.cloneDeep(_this.props.data);
	            newRec["targetDeliveryDate"] = newDate.format("ddd DD-MM-YYYY").toString();
	
	            _this.saveHandler(newRec);
	          }
	        }, ">"))), _this.getBasicRow("Name", rec.name, "name"), _this.getBasicRow("Phone", rec.mobile, "mobile"), _this.getBasicRow("Order Count", _this.props.orderCount, "orderCount"), _this.getBasicRow("Address", rec.address, "address"), _this.getBasicRow("Other Items", rec.otherItems), _react2.default.createElement("div", {
	          style: {
	            borderRadius: "5px",
	            color: "black",
	            backgroundColor: "white",
	            fontSize: "18px",
	            border: "0px solid rgb(30, 101, 144)",
	            cursor: "pointer",
	            fontWeight: "bold",
	            height: "40px",
	            lineHeight: "40px",
	            textAlign: "center",
	            margin: "5px",
	            display: "flex"
	          }
	        }, _react2.default.createElement("div", {
	          style: {
	            width: "50%",
	            textAlign: "left"
	          }
	        }, _react2.default.createElement("span", { style: { fontSize: "10px" } }, "Items: "), " ", rec.requestedItems && rec.requestedItems.length > 0 ? rec.requestedItems.length : 0, " "), _react2.default.createElement("div", {
	          style: {
	            width: "50%",
	            textAlign: "right"
	          }
	        }, _react2.default.createElement("span", { style: { fontSize: "10px", marginLeft: "10px" } }, "SGD:", " "), " ", rec.requestedItems && rec.requestedItems.length > 0 ? _this.getTotal(rec.requestedItems, rec.orderTotal) : "")), _react2.default.createElement("hr", {
	          style: {
	            margin: "0px"
	          }
	        }), _react2.default.createElement("div", {
	          style: {
	            fontSize: "12px",
	            display: "flex",
	            justifyContent: "flex-end"
	          },
	          onClick: function onClick() {
	            _this.setState(function (prevState) {
	              return _extends({}, prevState, {
	                showMessages: !prevState.showMessages
	              });
	            });
	          }
	        }, !_this.state.showMessages && _react2.default.createElement("span", {
	          style: {
	            marginRight: "3px"
	          }
	        }, _react2.default.createElement("icon", {
	          className: "fa fa-eye",
	          style: { color: "rgb(30, 101, 144)" }
	        }), " ", "SHOW MESSAGES", " [", rec.messages && rec.messages.length > 0 ? rec.messages.length : "0", "]"), _this.state.showMessages && _react2.default.createElement("span", {
	          style: {
	            marginRight: "3px"
	          }
	        }, _react2.default.createElement("icon", {
	          className: "fa fa-eye-slash",
	          style: { color: "rgb(30, 101, 144)" }
	        }), " ", "HIDE MESSAGES")), _this.state.showMessages && _react2.default.createElement("div", {
	          style: {
	            minHeight: "40px",
	            padding: "5px"
	          }
	        }, _this.getMessages()), _react2.default.createElement("hr", {
	          style: {
	            margin: "0px"
	          }
	        }), _react2.default.createElement("div", {
	          style: {
	            display: "flex",
	            direction: "row"
	          }
	        }, _react2.default.createElement("div", {
	          style: {
	            width: "100%"
	          }
	        }, _react2.default.createElement("textarea", {
	          type: "text",
	          placeholder: "Enter your message",
	          ref: "searchText",
	          onKeyUp: function onKeyUp(e) {
	            var msgTime = (0, _moment2.default)().format("h:mma DD-MM").toLocaleString();
	            _this.setState({
	              message: {
	                msgTime: msgTime,
	                author: _this.props.firebase.auth.currentUser.phoneNumber,
	                msgText: e.target.value
	              }
	            });
	          },
	          style: _defineProperty({
	            height: "35px",
	            borderRadius: "5px",
	            width: "100%",
	            border: "0px",
	            padding: "5px",
	            margin: "5px"
	          }, "border", "1px solid gainsboro"),
	          rows: 3
	        })), _react2.default.createElement("div", {
	          onClick: _this.saveMessageHandler,
	          style: {
	            width: "60px",
	            margin: "2px",
	            textAlign: "center",
	            height: "35px",
	            /* background-color: blue; */
	            lineHeight: "35px",
	            border: "1px solid white",
	            marginTop: "5px",
	            marginBottom: "5px",
	            marginLeft: "10px",
	            backgroundColor: "rgb(30, 101, 144)",
	            color: "white"
	          }
	        }, "Send")), _react2.default.createElement("hr", {
	          style: {
	            margin: "0px"
	          }
	        }), _react2.default.createElement("hr", {
	          style: {
	            margin: "0px"
	          }
	        }), _react2.default.createElement("div", {
	          style: {
	            display: "flex",
	            flexDirection: "row",
	            height: "40px",
	            alignItems: "center",
	            justifyContent: "center"
	          }
	        }, _react2.default.createElement("div", {
	          style: {
	            fontSize: "12px",
	            width: "50%",
	            textAlign: "center"
	          },
	          onClick: function onClick() {
	            _this.setState(function (prevState) {
	              return _extends({}, prevState, {
	                magnify: !prevState.magnify
	              });
	            });
	          }
	        }, _react2.default.createElement("span", {
	          style: {
	            marginRight: "3px"
	          }
	        }, _react2.default.createElement("icon", {
	          className: !_this.state.magnify ? "fa fa-search-plus" : "fa fa-search-minus",
	          style: { color: "rgb(30, 101, 144)" }
	        }), " ", !_this.state.magnify ? "MAGNIFY" : "UN MAGNIFY")), _react2.default.createElement("div", {
	          style: {
	            fontSize: "12px",
	            width: "50%",
	            textAlign: "center"
	          },
	          onClick: function onClick() {
	            _this.setState(function (prevState) {
	              return _extends({}, prevState, {
	                showItems: !prevState.showItems
	              });
	            });
	          }
	        }, _react2.default.createElement("span", {
	          style: {
	            marginRight: "3px"
	          }
	        }, _react2.default.createElement("icon", {
	          className: !_this.state.showItems ? "fa fa-eye" : "fa fa-eye-slash",
	          style: { color: "rgb(30, 101, 144)" }
	        }), " ", !_this.state.showItems ? "SHOW ITEMS [" : "HIDE ITEMS [", rec.requestedItems ? rec.requestedItems.length : "", "]"))), _react2.default.createElement("hr", {
	          style: {
	            margin: "0px"
	          }
	        }), _react2.default.createElement("div", null, _this.state.showItems && _react2.default.createElement("div", null, rec.requestedItems && rec.requestedItems.length > 0 && _this.getItems(rec.requestedItems)))), _this.props.compact && _react2.default.createElement("div", null, _react2.default.createElement("hr", {
	          style: {
	            margin: "0px"
	          }
	        }), _react2.default.createElement("div", { style: { display: "flex", flexDirection: "row" } }, _react2.default.createElement("div", {
	          style: (_ref11 = {
	            color: "#333",
	            fontSize: "14px",
	            backgroundColor: "red",
	            padding: "5px",
	            borderRadius: "5px"
	          }, _defineProperty(_ref11, "color", "white"), _defineProperty(_ref11, "width", "30%"), _defineProperty(_ref11, "margin", "5px"), _defineProperty(_ref11, "textAlign", "center"), _ref11)
	        }, _react2.default.createElement("div", {
	          onClick: function onClick() {
	            var resConfirm = confirm("Please confirm if you would like mark this order as CANCELLED?");
	
	            if (resConfirm) {
	              var tmpData = _.cloneDeep(_this.props.data);
	              //console.log("Before: " + JSON.stringify(tmpData[rowNum]));
	              tmpData["status"] = "CANCELLED";
	              _this.saveHandler(tmpData);
	            }
	          }
	        }, "CANCEL")), _react2.default.createElement("div", {
	          style: (_ref12 = {
	            color: "#333",
	            fontSize: "14px",
	            backgroundColor: "rgb(30, 101, 144)",
	            padding: "5px",
	            borderRadius: "5px"
	          }, _defineProperty(_ref12, "color", "white"), _defineProperty(_ref12, "width", "30%"), _defineProperty(_ref12, "margin", "5px"), _defineProperty(_ref12, "textAlign", "center"), _ref12)
	        }, _react2.default.createElement("div", {
	          onClick: function onClick() {
	            var tmpData = _.cloneDeep(_this.props.data);
	            //console.log("Before: " + JSON.stringify(tmpData[rowNum]));
	            tmpData["status"] = "IN PROGRESS";
	
	            _this.saveHandler(tmpData);
	          }
	        }, "WORKING")), _react2.default.createElement("div", {
	          style: (_ref13 = {
	            color: "#333",
	            fontSize: "14px",
	            backgroundColor: "rgb(30, 101, 144)",
	            padding: "5px",
	            borderRadius: "5px"
	          }, _defineProperty(_ref13, "color", "white"), _defineProperty(_ref13, "width", "30%"), _defineProperty(_ref13, "margin", "5px"), _defineProperty(_ref13, "textAlign", "center"), _ref13)
	        }, _react2.default.createElement("div", {
	          onClick: function onClick() {
	            var resConfirm = confirm("Please confirm if you would like mark this order as DELIVERED?");
	
	            if (resConfirm) {
	              var tmpData = _.cloneDeep(_this.props.data);
	              //console.log("Before: " + JSON.stringify(tmpData[rowNum]));
	              tmpData["status"] = "DELIVERED";
	              _this.saveHandler(tmpData);
	            }
	          }
	        }, "DONE"))), _this.getBasicRow("Customer", rec.name, "name"), _this.getBasicRow("Phone", rec.mobile, "mobile"), _this.getBasicRow("Address", rec.address, "address"), _react2.default.createElement("div", {
	          style: {
	            borderRadius: "5px",
	            color: "black",
	            backgroundColor: "white",
	            fontSize: "18px",
	            border: "0px solid rgb(30, 101, 144)",
	            cursor: "pointer",
	            fontWeight: "bold",
	            height: "40px",
	            lineHeight: "40px",
	            textAlign: "center",
	            margin: "5px",
	            display: "flex"
	          }
	        }, _react2.default.createElement("div", {
	          style: {
	            width: "50%",
	            textAlign: "left"
	          }
	        }, _react2.default.createElement("span", { style: { fontSize: "10px" } }, "Items: "), " ", rec.requestedItems && rec.requestedItems.length > 0 ? rec.requestedItems.length : 0, " "), _react2.default.createElement("div", {
	          style: {
	            width: "50%",
	            textAlign: "right"
	          }
	        }, _react2.default.createElement("span", { style: { fontSize: "10px", marginLeft: "10px" } }, "SGD:", " "), " ", rec.requestedItems && rec.requestedItems.length > 0 ? _this.getTotal(rec.requestedItems, rec.orderTotal) : ""))), _this.props.messageFocus && _react2.default.createElement("div", null, _react2.default.createElement("hr", {
	          style: {
	            margin: "0px"
	          }
	        }), _this.getBasicRow("Customer", rec.name, "name"), _this.getBasicRow("Phone", rec.mobile, "mobile"), _this.getBasicRow("Address", rec.address, "address"), _react2.default.createElement("div", {
	          style: {
	            borderRadius: "5px",
	            color: "black",
	            backgroundColor: "white",
	            fontSize: "18px",
	            border: "0px solid rgb(30, 101, 144)",
	            cursor: "pointer",
	            fontWeight: "bold",
	            height: "40px",
	            lineHeight: "40px",
	            textAlign: "center",
	            margin: "5px",
	            display: "flex"
	          }
	        }, _react2.default.createElement("div", {
	          style: {
	            width: "50%",
	            textAlign: "left"
	          }
	        }, _react2.default.createElement("span", { style: { fontSize: "10px" } }, "Items: "), " ", rec.requestedItems && rec.requestedItems.length > 0 ? rec.requestedItems.length : 0, " "), _react2.default.createElement("div", {
	          style: {
	            width: "50%",
	            textAlign: "right"
	          }
	        }, _react2.default.createElement("span", { style: { fontSize: "10px", marginLeft: "10px" } }, "SGD:", " "), " ", rec.requestedItems && rec.requestedItems.length > 0 ? _this.getTotal(rec.requestedItems, rec.orderTime) : "")), _react2.default.createElement("div", {
	          style: {
	            minHeight: "40px",
	            padding: "5px"
	          }
	        }, _this.getMessages()), _react2.default.createElement("hr", {
	          style: {
	            margin: "0px"
	          }
	        }), _react2.default.createElement("div", {
	          style: {
	            display: "flex",
	            direction: "row"
	          }
	        }, _react2.default.createElement("div", {
	          style: {
	            width: "100%"
	          }
	        }, _react2.default.createElement("textarea", {
	          type: "text",
	          placeholder: "Enter your message",
	          ref: "searchText",
	          onKeyUp: function onKeyUp(e) {
	            var msgTime = (0, _moment2.default)().format("h:mm a DD-MM").toLocaleString();
	
	            _this.setState({
	              msgTime: msgTime,
	              message: {
	                author: _this.props.firebase.auth.currentUser.phoneNumber,
	                msgText: e.target.value
	              }
	            });
	          },
	          style: _defineProperty({
	            height: "35px",
	            borderRadius: "5px",
	            width: "100%",
	            border: "0px",
	            padding: "5px",
	            margin: "5px"
	          }, "border", "1px solid gainsboro"),
	          rows: 3
	        })), _react2.default.createElement("div", {
	          onClick: _this.saveMessageHandler,
	          style: {
	            width: "60px",
	            margin: "2px",
	            textAlign: "center",
	            height: "35px",
	            /* background-color: blue; */
	            lineHeight: "35px",
	            border: "1px solid white",
	            marginTop: "5px",
	            marginBottom: "5px",
	            marginLeft: "10px",
	            backgroundColor: "rgb(30, 101, 144)",
	            color: "white"
	          }
	        }, "Send")), _react2.default.createElement("hr", {
	          style: {
	            margin: "0px"
	          }
	        })));
	      } else {
	        return _react2.default.createElement("div", null);
	      }
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  //single method that work for all fields
	  //takes incoming id of the field and then adds field data to state
	
	
	  _createClass(AdminCard, [{
	    key: "render",
	    value: function render() {
	      if (this.props.data && this.props.data !== undefined) {
	        return this.getCard(this.props.data);
	
	        //return this.getRows(this.props.data);
	      } else {
	        return _react2.default.createElement("div", null);
	      }
	    }
	  }]);
	
	  return AdminCard;
	}(_react.Component);
	
	exports.default = AdminCard;

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	};
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AdminCard = __webpack_require__(282);
	
	var _AdminCard2 = _interopRequireDefault(_AdminCard);
	
	var _underscore = __webpack_require__(919);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _numeral = __webpack_require__(16);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var _reactToPrint = __webpack_require__(203);
	
	var _reactToPrint2 = _interopRequireDefault(_reactToPrint);
	
	__webpack_require__(245);
	
	var _reactLazyLoadImageComponent = __webpack_require__(30);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof2(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var AdminOrderList = function (_Component) {
	  _inherits(AdminOrderList, _Component);
	
	  function AdminOrderList() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, AdminOrderList);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AdminOrderList.__proto__ || Object.getPrototypeOf(AdminOrderList)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      cancelled: false,
	      delivered: false
	    }, _this.getMobileDivs = function (data) {
	      var finalInfo = _this.props.finalInfo;
	      //console.log(JSON.stringify(finalInfo));
	      if (!_this.props.printFocus) {
	        return data.map(function (rec) {
	          //console.log("sending cards name: " + rec.name);
	          var showRes = false;
	          if (_this.props.searchVal && _this.props.searchVal !== "" && _this.props.tableDef.searches && _this.props.tableDef.searches.length > 0) {
	            // console.log(
	            //   "checking results: " + JSON.stringify(this.props.tableDef.searches)
	            // );
	            var searchVal = _this.props.searchVal.toLowerCase();
	            for (var i = 0; i < _this.props.tableDef.searches.length; i++) {
	              // console.log(
	              //   this.props.tableDef.searches[i] +
	              //     "= " +
	              //     this.props.searchVal +
	              //     " v " +
	              //     recText
	              // );
	              var recText = rec[_this.props.tableDef.searches[i]];
	              if (recText && recText !== "") {
	                recText = recText.toLowerCase();
	                if (recText.includes(searchVal)) {
	                  showRes = true;
	                }
	              } else {}
	            }
	            if (rec.messages && rec.messages !== undefined && rec.messages.length > 0) {
	              for (var _i = 0; _i < rec.messages.length; _i++) {
	                var recVal = rec.messages[_i].msgText;
	                var msgRes = recVal.toLowerCase().includes(searchVal);
	                if (msgRes) {
	                  showRes = true;
	                }
	              }
	            }
	          } else {
	            showRes = true;
	          }
	          if (showRes) {
	            return _react2.default.createElement(_AdminCard2.default, {
	              data: rec,
	              key: rec.key,
	              tableName: _this.props.tableName,
	              path: _this.props.tableName,
	              firebase: _this.props.firebase,
	              updateRecord: _this.props.updateRecord,
	              onNotifyUsers: _this.props.onNotifyUsers,
	              searchVal: _this.props.searchVal,
	              tableDef: _this.props.tableDef,
	              viewOptions: _this.state,
	              allSuppliers: _this.props.allSuppliers,
	              fetchDistance: _this.props.fetchDistance,
	              orderCount: finalInfo && finalInfo[rec.mobile] && finalInfo[rec.mobile].count ? finalInfo[rec.mobile].count : 0,
	              compact: _this.props.compact,
	              regular: _this.props.regular,
	              messageFocus: _this.props.messageFocus
	            });
	          }
	        });
	      } else {
	        if (_this.props.showDets) {
	          return _this.getDetailedPrintRows(data);
	        } else {
	          return _react2.default.createElement("table", {
	            className: "table table-bordered table-lg",
	            style: { backgroundColor: "white", margin: "2px" }
	          }, _react2.default.createElement("thead", {
	            style: {
	              backgroundColor: "white"
	            }
	          }, _react2.default.createElement("tr", null, _react2.default.createElement("td", null, "#"), _react2.default.createElement("th", null, "Name"), _react2.default.createElement("th", null, "Address"), _react2.default.createElement("th", null, "Amount"))), _react2.default.createElement("tbody", {
	            style: {
	              backgroundColor: "white"
	            }
	          }, _this.getPrintRows(data)));
	        }
	      }
	    }, _this.getTotal = function (currBucket) {
	      //console.log("calcing total again: " + JSON.stringify(currBucket));
	      if (currBucket && currBucket.length > 0 && currBucket !== "" && (typeof currBucket === "undefined" ? "undefined" : _typeof(currBucket)) === "object") {
	        try {
	          var totAmt = currBucket.reduce(function (sum, item) {
	            sum = sum + parseFloat(item.amount.replace(/,/g, ""));
	            return parseFloat(sum);
	          }, 0);
	
	          return (0, _numeral2.default)(totAmt).format("0,0.00");
	        } catch (err) {
	          return 0;
	        }
	      }
	    }, _this.getDetailedPrintRows = function (data) {
	      return data.map(function (rec, index) {
	        var showRes = false;
	        if (_this.props.searchVal && _this.props.searchVal !== "" && _this.props.tableDef.searches && _this.props.tableDef.searches.length > 0) {
	          // console.log(
	          //   "checking results: " + JSON.stringify(this.props.tableDef.searches)
	          // );
	          var searchVal = _this.props.searchVal.toLowerCase();
	          for (var i = 0; i < _this.props.tableDef.searches.length; i++) {
	            // console.log(
	            //   this.props.tableDef.searches[i] +
	            //     "= " +
	            //     this.props.searchVal +
	            //     " v " +
	            //     recText
	            // );
	            var recText = rec[_this.props.tableDef.searches[i]];
	            if (recText && recText !== "") {
	              recText = recText.toLowerCase();
	              if (recText.includes(searchVal)) {
	                showRes = true;
	              }
	            } else {}
	          }
	          if (rec.messages && rec.messages !== undefined && rec.messages.length > 0) {
	            for (var _i2 = 0; _i2 < rec.messages.length; _i2++) {
	              var recVal = rec.messages[_i2].msgText;
	              var msgRes = recVal.toLowerCase().includes(searchVal);
	              if (msgRes) {
	                showRes = true;
	              }
	            }
	          }
	        } else {
	          showRes = true;
	        }
	        if (showRes) {
	          return _react2.default.createElement("div", {
	            style: {
	              marginBottom: "30px"
	            },
	            ref: function ref(el) {
	              return _this[rec.key] = el;
	            }
	          }, _react2.default.createElement("table", {
	            className: "table table-bordered table-sm",
	            style: {
	              backgroundColor: "white",
	              margin: "2px"
	            }
	          }, _react2.default.createElement("thead", {
	            style: {
	              backgroundColor: "white"
	            }
	          }, _react2.default.createElement("tr", null, _react2.default.createElement("td", null, _react2.default.createElement(_reactToPrint2.default, {
	            trigger: function trigger() {
	              // NOTE: could just as easily return <SomeComponent />. Do NOT pass an `onClick` prop
	              // to the root node of the returned component as it will be overwritten.
	              return _react2.default.createElement("a", { href: "#" }, "#");
	            },
	            content: function content() {
	              return _this[rec.key];
	            }
	          })), _react2.default.createElement("th", null, "Name"), _react2.default.createElement("th", null, "Address"), _react2.default.createElement("th", null, "Amount"))), _react2.default.createElement("tbody", {
	            style: {
	              backgroundColor: "white"
	            }
	          }, _react2.default.createElement("tr", null, _react2.default.createElement("td", null, index + 1), _react2.default.createElement("td", null, rec.name + "\n" + rec.mobile), _react2.default.createElement("td", null, rec.address), _react2.default.createElement("td", {
	            style: {
	              textAlign: "right"
	            }
	          }, _this.getTotal(rec.requestedItems))))), _react2.default.createElement("div", {
	            style: {
	              backgroundColor: "white",
	              display: "flex",
	              flexDirection: "row"
	            }
	          }, _react2.default.createElement("div", {
	            style: {
	              fontWeight: "bold",
	              margin: "5px",
	              border: "1px solid gainsboro",
	              width: "50%",
	              textAlign: "center"
	            }
	          }, "rec:", " ", rec.createDateTime && rec.createDateTime !== undefined && rec.createDateTime !== "" ? rec.createDateTime : rec.deliveryDate + " " + (rec.orderTime && rec.orderTime !== "" ? rec.orderTime : "")), _react2.default.createElement("div", {
	            style: {
	              fontWeight: "bold",
	              margin: "5px",
	              border: "1px solid gainsboro",
	              width: "50%",
	              textAlign: "center"
	            }
	          }, "dlv:", " ", rec.targetDeliveryDate && rec.targetDeliveryDate !== undefined ? rec.targetDeliveryDate : "")), _react2.default.createElement("div", { style: { backgroundColor: "white" } }, _react2.default.createElement("div", {
	            style: {
	              fontWeight: "bold",
	              margin: "5px",
	              borderBottom: "1px solid gainsboro",
	              textAlign: "center"
	            }
	          }, "Special Instructions"), rec.otherItems && rec.otherItems !== undefined ? rec.otherItems : ""), _react2.default.createElement("div", { style: { backgroundColor: "white" } }, _react2.default.createElement("div", {
	            style: {
	              fontWeight: "bold",
	              margin: "5px",
	              borderBottom: "1px solid gainsboro"
	            }
	          }, "Messages"), _this.getMessages(rec.messages)), _react2.default.createElement("div", {
	            style: {
	              fontSize: "10px"
	            }
	          }, _react2.default.createElement("table", {
	            className: "table table-bordered table-sm",
	            style: {
	              backgroundColor: "white",
	              margin: "2px"
	            }
	          }, _react2.default.createElement("thead", {
	            style: {
	              backgroundColor: "white"
	            }
	          }, _react2.default.createElement("tr", null, _react2.default.createElement("td", { style: { padding: "5px", textAlign: "center" } }, "#"), _react2.default.createElement("td", { style: { padding: "5px", textAlign: "center" } }, "Pic"), _react2.default.createElement("th", { style: { padding: "5px", textAlign: "center" } }, "Name"), _react2.default.createElement("th", { style: { padding: "5px", textAlign: "center" } }, "Qty"), _react2.default.createElement("th", { style: { padding: "5px", textAlign: "center" } }, "$"), _react2.default.createElement("th", { style: { padding: "5px", textAlign: "center" } }, "Tot"))), _react2.default.createElement("tbody", {
	            style: {
	              backgroundColor: "white"
	            }
	          }, _this.getItemRows(rec.requestedItems)))));
	        }
	      });
	    }, _this.getMessages = function (msgs) {
	      if (msgs && msgs.length > 0) {
	        return msgs.map(function (msg) {
	          var fromMe = _this.props.allSuppliers.includes(msg.author.replace("+65", ""));
	          if (fromMe) {
	            return _react2.default.createElement("div", {
	              style: {
	                textAlign: "right",
	                margin: "1px",
	                marginLeft: "40px",
	                backgroundColor: "white",
	                borderBottom: "0px solid gainsboro",
	                padding: "2px",
	                border: "1px solid gainsboro"
	              }
	            }, msg.msgText);
	          } else {
	            return _react2.default.createElement("div", {
	              style: {
	                textAlign: "left",
	                margin: "1px",
	                marginRight: "40px",
	                backgroundColor: "white",
	                borderBottom: "0px solid gainsboro",
	                padding: "2px",
	                border: "1px solid gainsboro"
	              }
	            }, msg.msgText);
	          }
	        });
	      }
	    }, _this.getItemRows = function (items) {
	      return items.map(function (rec, index) {
	        return _react2.default.createElement("tr", null, _react2.default.createElement("td", {
	          style: {
	            textAlign: "center",
	            padding: "5px"
	          }
	        }, index + 1), _react2.default.createElement("td", {
	          style: {
	            textAlign: "center",
	            padding: "5px"
	          }
	        }, _this.props.showImage && _react2.default.createElement("img", {
	          src: rec.photos && rec.photos.length > 0 ? "https://storage.googleapis.com/bcsfbtest/images/" + rec.photos[0].imageName : "",
	          style: {
	            maxWidth: "75px",
	            maxHeight: "75px",
	            height: "75px",
	            width: "75px",
	            borderRadius: "0px",
	            objectFit: "contain"
	          }
	        })), _react2.default.createElement("td", {
	          style: {
	            padding: "5px"
	          }
	        }, rec.productNameEnglish + "  (" + rec.unit + ")"), _react2.default.createElement("td", {
	          style: {
	            textAlign: "center",
	            padding: "5px"
	          }
	        }, rec.quantity), _react2.default.createElement("td", {
	          style: {
	            textAlign: "center",
	            padding: "5px"
	          }
	        }, rec.productPrice), _react2.default.createElement("td", {
	          style: {
	            textAlign: "right",
	            padding: "5px"
	          }
	        }, rec.amount));
	      });
	    }, _this.getPrintRows = function (data) {
	      return data.map(function (rec, index) {
	        var showRes = false;
	        if (_this.props.searchVal && _this.props.searchVal !== "" && _this.props.tableDef.searches && _this.props.tableDef.searches.length > 0) {
	          // console.log(
	          //   "checking results: " + JSON.stringify(this.props.tableDef.searches)
	          // );
	          var searchVal = _this.props.searchVal.toLowerCase();
	          for (var i = 0; i < _this.props.tableDef.searches.length; i++) {
	            // console.log(
	            //   this.props.tableDef.searches[i] +
	            //     "= " +
	            //     this.props.searchVal +
	            //     " v " +
	            //     recText
	            // );
	            var recText = rec[_this.props.tableDef.searches[i]];
	            if (recText && recText !== "") {
	              recText = recText.toLowerCase();
	              if (recText.includes(searchVal)) {
	                showRes = true;
	              }
	            } else {}
	          }
	          if (rec.messages && rec.messages !== undefined && rec.messages.length > 0) {
	            for (var _i3 = 0; _i3 < rec.messages.length; _i3++) {
	              var recVal = rec.messages[_i3].msgText;
	              var msgRes = recVal.toLowerCase().includes(searchVal);
	              if (msgRes) {
	                showRes = true;
	              }
	            }
	          }
	        } else {
	          showRes = true;
	        }
	        if (showRes) {
	          return _react2.default.createElement("tr", null, _react2.default.createElement("td", null, index + 1), _react2.default.createElement("td", null, rec.name + "\n" + rec.mobile), _react2.default.createElement("td", null, rec.address), _react2.default.createElement("td", {
	            style: {
	              textAlign: "right"
	            }
	          }, _this.getTotal(rec.requestedItems)));
	        }
	      });
	    }, _this.getFiltersRow = function () {
	      var _ref2, _ref3;
	
	      return _react2.default.createElement("div", {
	        style: { display: "flex", flexDirection: "row", marginTop: "-10px" }
	      }, _react2.default.createElement("div", {
	        style: (_ref2 = {
	          color: "#333",
	          fontSize: "14px",
	          padding: "5px",
	          borderRadius: "5px"
	        }, _defineProperty(_ref2, "color", "black"), _defineProperty(_ref2, "width", "50%"), _defineProperty(_ref2, "textAlign", "center"), _ref2)
	      }, _react2.default.createElement("div", {
	        onClick: function onClick() {
	          _this.setState(function (prevState) {
	            return _extends({}, prevState, {
	              delivered: !prevState.delivered
	            });
	          });
	        }
	      }, _this.state.delivered ? "HIDE DLVRD" : "SHOW DLVRD")), _react2.default.createElement("div", {
	        style: (_ref3 = {
	          color: "#333",
	          fontSize: "14px",
	          padding: "5px",
	          borderRadius: "5px"
	        }, _defineProperty(_ref3, "color", "black"), _defineProperty(_ref3, "width", "50%"), _defineProperty(_ref3, "textAlign", "center"), _ref3)
	      }, _react2.default.createElement("div", {
	        onClick: function onClick() {
	          _this.setState(function (prevState) {
	            return _extends({}, prevState, {
	              cancelled: !prevState.cancelled
	            });
	          });
	        }
	      }, _this.state.cancelled ? "HIDE CNCLD" : "SHOW CNCLD")));
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(AdminOrderList, [{
	    key: "render",
	    value: function render() {
	      if (this.props.data && this.props.data !== undefined && this.props.data.length > 0) {
	        return _react2.default.createElement("div", null, this.getMobileDivs(this.props.data), _react2.default.createElement("div", { style: { height: "400px" } }));
	
	        //return this.getRows(this.props.data);
	      } else {
	        console.log("AdminOrderList NO data");
	        if (this.props.dataIsLoaded) {
	          return _react2.default.createElement("div", {
	            style: {
	              textAlign: "center"
	            }
	          }, "No orders available to display.");
	        } else {
	          return _react2.default.createElement("div", {
	            style: {
	              margin: "15px"
	            }
	          }, _react2.default.createElement("div", {
	            style: {
	              textAlign: "center"
	            }
	          }, "Seems like you are on a slow network, we are loading data please wait a moment..."), _react2.default.createElement("div", {
	            style: {
	              backgroundColor: "whtie",
	              height: "200px"
	            }
	          }));
	        }
	      }
	    }
	  }]);
	
	  return AdminOrderList;
	}(_react.Component);
	
	exports.default = AdminOrderList;

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(22);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var AdminSummaryList = function (_Component) {
	  _inherits(AdminSummaryList, _Component);
	
	  function AdminSummaryList() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, AdminSummaryList);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AdminSummaryList.__proto__ || Object.getPrototypeOf(AdminSummaryList)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      cancelled: false,
	      delivered: false,
	      data: {
	        path: "adminSummary",
	        payload: {}
	      }
	    }, _this.getSubTableRows = function (names, mobiles, qtys) {
	      if (names && names.length > 0) {
	        return names.map(function (name, index) {
	          return _react2.default.createElement("tr", null, _react2.default.createElement("td", null, name), _react2.default.createElement("td", null, mobiles[index]), _react2.default.createElement("td", null, qtys[index]));
	        });
	      }
	    }, _this.getPoSubTableRows = function (qtyGroups, units) {
	      if (qtyGroups && qtyGroups !== undefined && qtyGroups.length > 0) {
	        return qtyGroups.map(function (qtg, index) {
	          return _react2.default.createElement("tr", null, _react2.default.createElement("td", null, qtg.bucketSize, " x ", units[0]), _react2.default.createElement("td", null, qtg.bucketFrequency));
	        });
	      }
	    }, _this.getBasicRow = function (label, value, orderNames, orderPhones, orderQtys, photos, totAmount, price, qtyGroups, unit) {
	      return _react2.default.createElement("div", null, _react2.default.createElement("div", {
	        style: {
	          display: "flex",
	          flexDirection: "row",
	          marginLeft: "5px",
	          marginRight: "5px",
	          padding: "5px",
	          fontSize: "14px",
	          fontWeight: "bold"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          width: "80%",
	          textAlign: "left"
	        }
	      }, label.toUpperCase()), _react2.default.createElement("div", {
	        style: {
	          width: "20%",
	          textAlign: "right",
	          overflow: "scroll"
	        }
	      }, value)), _this.props.image && _react2.default.createElement("div", null, _react2.default.createElement("img", {
	        src: photos && photos.length > 0 ? photos[0].url : "",
	        style: {
	          maxWidth: "250px",
	          maxHeight: "250px",
	          height: "200px",
	          width: "200px",
	          borderRadius: "0px",
	          border: _this.state[0] ? "1px solid gainsboro" : "0px",
	          objectFit: "contain",
	          margin: _this.state[0] ? "5px" : "0px",
	          minWidth: _this.state[0] ? "250px" : null
	        }
	      })), _react2.default.createElement("hr", {
	        style: {
	          margin: "0px"
	        }
	      }), _this.props.breakup && _react2.default.createElement("div", {
	        style: {
	          fontSize: "10px",
	          padding: "5px"
	        }
	      }, !_this.props.poMode && _react2.default.createElement("table", { className: "table table-striped tabled-bordered table-sm" }, _react2.default.createElement("thead", null, _react2.default.createElement("tr", null, _react2.default.createElement("td", null, "Name"), _react2.default.createElement("td", null, "Mobile"), _react2.default.createElement("td", null, "Quantity"))), _react2.default.createElement("tbody", null, _this.getSubTableRows(orderNames, orderPhones, orderQtys))), _this.props.poMode && _react2.default.createElement("table", { className: "table table-striped tabled-bordered table-sm" }, _react2.default.createElement("thead", null, _react2.default.createElement("tr", null, _react2.default.createElement("td", null, "Size"), _react2.default.createElement("td", null, "No. of packets"))), _react2.default.createElement("tbody", null, _this.getPoSubTableRows(qtyGroups, unit)))));
	    }, _this.getSummaryCard = function (rec, srNo) {
	      //console.log(JSON.stringify(rec.qtyGroups));
	      return _react2.default.createElement("div", null, _this.getBasicRow(srNo + ". " + rec.productName + " (" + rec.unit[0] + ")", rec.totalQuantity, rec.name, rec.mobile, rec.subQuantities, rec.photos, rec.totAmount, rec.price, rec.qtyGroups, rec.unit));
	    }, _this.getDetailList = function (processedArray) {
	      return processedArray.map(function (rec, index) {
	        return _this.getSummaryCard(rec, index + 1);
	      });
	    }, _this.getSummaryItems = function (data) {
	      var processedArray = data.products;
	
	      if (processedArray && processedArray.length > 0) {
	        return _react2.default.createElement("div", null, _react2.default.createElement("div", null, _this.getDetailList(processedArray)));
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(AdminSummaryList, [{
	    key: "render",
	    value: function render() {
	      if (this.props.data && this.props.data !== undefined && this.props.data.length > 0) {
	        return _react2.default.createElement("div", {
	          style: {
	            borderRadius: "10px",
	            backgroundColor: "white",
	            margin: "5px",
	            padding: "10px",
	            marginBottom: "15px",
	            fontSize: "12px",
	            fontWeight: "bold",
	            border: "1.5px solid #ccc",
	            boxSizing: "border-box",
	            boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)"
	          }
	        }, _react2.default.createElement("div", null, this.getSummaryItems(this.props.summedData)));
	
	        //return this.getRows(this.props.data);
	      } else {
	        if (this.props.dataIsLoaded) {
	          return _react2.default.createElement("div", {
	            style: {
	              borderRadius: "10px",
	              backgroundColor: "white",
	              margin: "5px",
	              padding: "10px",
	              marginBottom: "15px",
	              fontSize: "12px",
	              fontWeight: "bold",
	              border: "1.5px solid #ccc",
	              boxSizing: "border-box",
	              boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
	              textAlign: "center"
	            }
	          }, "No orders available to display.");
	        } else {
	          return _react2.default.createElement("div", {
	            style: {
	              borderRadius: "10px",
	              backgroundColor: "white",
	              margin: "5px",
	              padding: "10px",
	              marginBottom: "15px",
	              fontSize: "12px",
	              fontWeight: "bold",
	              border: "1.5px solid #ccc",
	              boxSizing: "border-box",
	              boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
	              textAlign: "center"
	            }
	          }, _react2.default.createElement("div", {
	            style: {
	              textAlign: "center"
	            }
	          }, "Seems like you are on a slow network, we are loading data please wait a moment..."));
	        }
	      }
	    }
	  }]);
	
	  return AdminSummaryList;
	}(_react.Component);
	
	exports.default = AdminSummaryList;

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactackle = __webpack_require__(5);
	
	var _PhotoCard = __webpack_require__(104);
	
	var _PhotoCard2 = _interopRequireDefault(_PhotoCard);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var BazarCard = function (_Component) {
	  _inherits(BazarCard, _Component);
	
	  function BazarCard(props) {
	    _classCallCheck(this, BazarCard);
	
	    var _this = _possibleConstructorReturn(this, (BazarCard.__proto__ || Object.getPrototypeOf(BazarCard)).call(this, props));
	
	    _this.likeHandler = function () {
	      var data = _.cloneDeep(_this.props.data);
	      if (data.likes && data.likes.length > 0) {
	        if (data.likes.includes(_this.props.firebase.auth.currentUser.phoneNumber)) {
	          data.likes = data.likes.filter(function (num) {
	            return num !== _this.props.firebase.auth.currentUser.phoneNumber;
	          });
	        } else {
	          data.likes.push(_this.props.firebase.auth.currentUser.phoneNumber);
	        }
	      } else {
	        data["likes"] = [];
	        data.likes.push(_this.props.firebase.auth.currentUser.phoneNumber);
	      }
	      if (data && data.key && data.key !== "") {
	        var cloudPath = _this.props.path + "/" + data.key;
	
	        _this.props.firebase.db.ref("/" + cloudPath).once("value").then(function (snap) {
	          // this.props.onNotifyUsers(
	          //   data.name + " says: " + this.refs.searchText.value,
	          //   this.props.allSuppliers,
	          //   false
	          // );
	
	          return snap.ref.set(data);
	        }).catch(function (err) {
	          console.log(err);
	          alert("Message could not be sent. " + err);
	          return "";
	        }).then(function (err) {});
	      }
	    };
	
	    _this.saveHandler = function () {
	      if (_this.state.message && _this.state.message.msgText && _this.state.message.msgText.length > 0) {
	        var data = _.cloneDeep(_this.props.data);
	        if (data.messages && data.messages.length > 0) {
	          data.messages.push(_this.state.message);
	        } else {
	          data["messages"] = [];
	          data.messages.push(_this.state.message);
	        }
	        var notifyTgt = [];
	        for (var i = 0; i < data.messages.length; i++) {
	          var numb = data.messages[i].author;
	          if (!notifyTgt.includes(numb.replace("+65", ""))) {
	            notifyTgt.push(numb.replace("+65", ""));
	          }
	        }
	        if (!notifyTgt.includes(data.author.replace("+65", ""))) {
	          notifyTgt.push(data.author.replace("+65", ""));
	        }
	
	        //console.log(JSON.stringify(notifyTgt));
	        if (data && data.key && data.key !== "") {
	          var cloudPath = _this.props.path + "/" + data.key;
	
	          _this.props.firebase.db.ref("/" + cloudPath).once("value").then(function (snap) {
	            _this.props.onNotifyUsers(_this.state.message.author + " commented on open bazar post: " + _this.state.message.msgText, notifyTgt, false);
	            _this.setState({
	              message: {
	                author: _this.props.phoneNumber,
	                msgText: ""
	              }
	            });
	            return snap.ref.set(data);
	          }).catch(function (err) {
	            console.log(err);
	            alert("Message could not be sent. " + err);
	            return "";
	          }).then(function (err) {});
	        }
	      }
	    };
	
	    _this.getMessages = function () {
	      var msgs = _this.props.data.messages;
	      if (msgs && msgs.length > 0) {
	        return msgs.map(function (msg) {
	          var fromMe = _this.props.phoneNumber === msg.author ? "from-me" : "";
	
	          return _react2.default.createElement("div", { className: "message " + fromMe }, _react2.default.createElement("div", { className: "username" }, msg.author.substring(0, 7) + "****"), _react2.default.createElement("div", { className: "message-body" }, msg.msgText));
	        });
	      }
	    };
	
	    _this.getMessageSection = function () {
	      return _react2.default.createElement("div", null, _react2.default.createElement("hr", {
	        style: {
	          margin: "0px"
	        }
	      }), _react2.default.createElement("div", {
	        style: {
	          minHeight: "40px",
	          padding: "5px"
	        }
	      }, _this.getMessages()));
	    };
	
	    _this.getBazarCard = function () {
	      var rec = _this.props.data;
	      var index = _this.props.index;
	
	      return _react2.default.createElement("div", {
	        style: {
	          background: "#FFFFFF",
	          border: "1.5px solid #ccc",
	          boxSizing: "border-box",
	          boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
	          borderRadius: "10px",
	          marginBottom: "10px"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          display: "flex",
	          direction: "row",
	          margin: "10px"
	        }
	      }, _react2.default.createElement("div", null, _react2.default.createElement("div", {
	        style: {
	          width: "35px",
	          height: "35px",
	          borderRadius: "35px",
	          backgroundColor: "gainsboro",
	          border: "0.5px solid gray"
	        }
	      })), _react2.default.createElement("div", {
	        style: {
	          lineHeight: "30px",
	          paddingLeft: "5px",
	          textTransform: "uppercase"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          lineHeight: "20px"
	        }
	      }, rec.name), _react2.default.createElement("div", {
	        style: {
	          lineHeight: "10px"
	        }
	      }, _react2.default.createElement("span", {
	        style: {
	          fontSize: "10px"
	        }
	      }, " ", rec.author.substring(0, 7) + "****")))), _react2.default.createElement("div", {
	        style: {
	          paddingLeft: "10px"
	        }
	      }, _react2.default.createElement("h2", {
	        style: {
	          marginTop: "5px",
	          fontSize: "18px",
	          fontWeight: "bold",
	          textTransform: "uppercase"
	        }
	      }, rec.title), (rec.messageType === "SELLING" || rec.messageType === "BUYING") && _react2.default.createElement("div", null, _react2.default.createElement("span", {
	        style: _defineProperty({
	          marginTop: "-10px",
	          marginBottom: "0px",
	          marginLeft: "0px",
	          fontSize: "14px",
	          textTransform: "uppercase",
	          backgroundColor: "black",
	          padding: "2px",
	          borderRadius: "10px",
	          color: "white",
	          paddingLeft: "10px",
	          paddingRight: "10px"
	        }, "textTransform", "uppercase")
	      }, "PRICE: ", rec.price))), _react2.default.createElement("div", {
	        style: {
	          marginLeft: "1px",
	          marginRight: "1px"
	        }
	      }, _react2.default.createElement(_PhotoCard2.default, { photos: rec.photos })), _react2.default.createElement("div", {
	        style: {
	          padding: "10px",
	          marginTop: rec.photos && rec.photos.length > 0 ? "10px" : "-10px"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          margin: "5px"
	        }
	      }), rec.message, _react2.default.createElement("div", {
	        style: {
	          margin: "5px",
	          marginBottom: "5px",
	          display: "flex",
	          flexDirection: "row",
	          justifyContent: "flex-end"
	        },
	        onClick: function onClick() {
	          _this.setState(function (prevState) {
	            return _extends({}, prevState, {
	              showComments: !prevState.showComments
	            });
	          });
	        }
	      }, !_this.state.showComments && _react2.default.createElement("span", {
	        style: {
	          marginRight: "3px"
	        }
	      }, _react2.default.createElement("icon", {
	        className: "fa fa-eye",
	        style: { color: "rgb(30, 101, 144)" }
	      })), _this.state.showComments && _react2.default.createElement("span", {
	        style: {
	          marginRight: "3px"
	        }
	      }, _react2.default.createElement("icon", {
	        className: "fa fa-eye-slash",
	        style: { color: "rgb(30, 101, 144)" }
	      })), _react2.default.createElement("span", null, _this.state.showComments ? "Hide Comments" : "View Comments")), _this.state.showComments && _this.getMessageSection(), _react2.default.createElement("hr", {
	        style: {
	          margin: "0px",
	          marginBottom: "5px"
	        }
	      }), _react2.default.createElement("div", {
	        style: {
	          display: "flex",
	          direction: "row"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          width: "100%",
	          border: "1px solid gainsboro"
	        }
	      }, _react2.default.createElement(_reactackle.TextField, {
	        bordered: true,
	        ref: "searchText",
	        value: _this.state.message && _this.state.message.msgText ? _this.state.message.msgText : "",
	        onChange: function onChange(e) {
	          //console.log("value changed" + JSON.stringify(e));
	          _this.setState({
	            message: {
	              author: _this.props.phoneNumber,
	              msgText: e.value
	            }
	          });
	        },
	        fullWidth: true,
	        multiline: true,
	        multilineRows: { min: 2 }
	      })), _react2.default.createElement("div", {
	        onClick: _this.saveHandler,
	        style: {
	          width: "60px",
	          margin: "2px",
	          textAlign: "center",
	          height: "35px",
	          /* background-color: blue; */
	          lineHeight: "35px",
	          border: "1px solid white",
	          marginTop: "5px",
	          marginBottom: "5px",
	          marginLeft: "10px",
	          backgroundColor: "rgb(30, 101, 144)",
	          color: "white"
	        }
	      }, "Send")), _react2.default.createElement("hr", {
	        style: {
	          margin: "5px",
	          marginTop: "5px"
	        }
	      }), _react2.default.createElement("div", {
	        style: {
	          display: "flex",
	          direction: "row"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          width: "30%"
	        }
	      }, rec.author === _this.props.phoneNumber && _react2.default.createElement("div", {
	        style: {
	          margin: "3px",
	          display: "flex",
	          direction: "row"
	        },
	        onClick: function onClick() {
	          _this.props.handleEdit(rec.key, _this.props.tableName, rec, "openBazar");
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          margin: "1px"
	        }
	      }, _react2.default.createElement("icon", { className: "fa fa-edit" })), _react2.default.createElement("div", {
	        style: {
	          minWidth: "5px",
	          textAlign: "center",
	          margin: "auto",
	          fontSize: "10px"
	        }
	      }, "TAP TO CHANGE"))), _react2.default.createElement("div", {
	        style: {
	          width: "70%",
	          textAlign: "right",
	          fontSize: "16px",
	          display: "flex",
	          direction: "row",
	          justifyContent: "flex-end"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          marginLeft: "10px",
	          display: "flex",
	          direction: "row"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          margin: "3px"
	        },
	        onClick: function onClick() {
	          _this.setState(function (prevState) {
	            return _extends({}, prevState, {
	              showComments: !prevState.showComments
	            });
	          });
	        }
	      }, _react2.default.createElement("icon", { className: "fa fa-comment-o" })), _react2.default.createElement("div", {
	        style: {
	          minWidth: "5px",
	          textAlign: "center",
	          margin: "auto"
	        }
	      }, rec.messages && rec.messages.length > 0 ? rec.messages.length : "")), _react2.default.createElement("div", {
	        style: {
	          marginLeft: "10px",
	          display: "flex",
	          direction: "row"
	        },
	        onClick: function onClick() {
	          _this.likeHandler();
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          margin: "3px"
	        }
	      }, rec.likes && rec.likes.length > 0 && rec.likes.includes(_this.props.firebase.auth.currentUser.phoneNumber) && _react2.default.createElement("icon", {
	        className: "fa fa-heart",
	        style: { color: "red" }
	      }), (!rec.likes || rec.likes && rec.likes.length > 0 && !rec.likes.includes(_this.props.firebase.auth.currentUser.phoneNumber)) && _react2.default.createElement("icon", { className: "fa fa-heart-o" })), _react2.default.createElement("div", {
	        style: {
	          minWidth: "5px",
	          textAlign: "center",
	          margin: "auto"
	        }
	      }, rec.likes && rec.likes.length > 0 ? rec.likes.length : ""))))));
	    };
	
	    _this.state = {
	      showContact: false,
	      fieldList: {
	        worker: ["mobile", "name", "address", "requestedItems"],
	        grocer: ["mobile", "name", "requestedItems"],
	        all: ["deliveryDate", "mobile", "name", "address", "requestedItems", "status", "supplier", "supplierPrice", "supplierNotes", "supplierPrices"]
	      }
	    };
	    return _this;
	  }
	
	  _createClass(BazarCard, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement("div", null, this.getBazarCard());
	    }
	  }]);
	
	  return BazarCard;
	}(_react.Component);
	
	exports.default = BazarCard;

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _numeral = __webpack_require__(16);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var _reactackle = __webpack_require__(5);
	
	var _reactLazyLoadImageComponent = __webpack_require__(30);
	
	var _PhotoCard = __webpack_require__(104);
	
	var _PhotoCard2 = _interopRequireDefault(_PhotoCard);
	
	var _lodash = __webpack_require__(22);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var BuyFromShopGrid = function (_Component) {
	  _inherits(BuyFromShopGrid, _Component);
	
	  function BuyFromShopGrid(props) {
	    _classCallCheck(this, BuyFromShopGrid);
	
	    var _this = _possibleConstructorReturn(this, (BuyFromShopGrid.__proto__ || Object.getPrototypeOf(BuyFromShopGrid)).call(this, props));
	
	    _this.getPhotos = function (photos) {
	      if (photos && photos.length > 0) {
	        return photos.map(function (photo, index) {
	          if (photo.status === "DONE") {
	            return _react2.default.createElement("div", { style: { backgroundColor: "white" } }, _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: photo.url, style: { minHeight: "200px" } }));
	          } else {
	            return _react2.default.createElement("div", { style: { padding: "40px", backgroundColor: "white" } }, _react2.default.createElement(_reactackle.CircleProgress, {
	              indeterminate: true,
	              subtitle: "Updating...",
	              labelPositionX: "center",
	              labelPositionY: "bottom"
	            }));
	          }
	        });
	      }
	    };
	
	    _this.getBucketView = function (rec) {
	      var bucketDets = _this.props.getBucketDetails(rec);
	      if (bucketDets) {
	        return _react2.default.createElement("div", {
	          style: {
	            borderRadius: "5px",
	            color: "black",
	            backgroundColor: "white",
	            fontSize: "18px",
	            border: "0px solid rgb(30, 101, 144)",
	            cursor: "pointer",
	            fontWeight: "bold",
	            width: "180px",
	            height: "40px",
	            lineHeight: "40px",
	            textAlign: "center",
	            margin: "5px"
	          }
	        }, _react2.default.createElement("span", { style: { fontSize: "10px" } }, "Units: "), " ", bucketDets.quantity, " ", _react2.default.createElement("span", { style: { fontSize: "10px", marginLeft: "10px" } }, "SGD: "), " ", bucketDets.amount);
	      }
	    };
	
	    _this.getCard = function (rec) {
	      return _react2.default.createElement("div", {
	        style: {
	          background: "#FFFFFF",
	          border: "1.5px solid #ccc",
	          boxSizing: "border-box",
	          boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
	          borderRadius: "10px",
	          marginBottom: "10px",
	          marginRight: "5px",
	          marginLeft: "5px",
	          padding: "2px"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          margin: "0px",
	          fontSize: "16px",
	          fontWeight: "bold",
	          textTransform: "uppercase",
	          width: "100%",
	          padding: "10px",
	          paddingBottom: "0px"
	        }
	      }, rec.productNameEnglish), _react2.default.createElement("div", {
	        style: {
	          marginTop: "1px"
	        }
	      }, _react2.default.createElement("span", {
	        style: {
	          marginTop: "1px",
	          marginBottom: "0px",
	          marginLeft: "10px",
	          fontSize: "16px",
	          fontWeight: "bolder",
	          borderRadius: "10px",
	          textTransform: "uppercase",
	          backgroundColor: "black",
	          padding: "2px",
	          color: "white",
	          paddingLeft: "10px",
	          paddingRight: "10px"
	        }
	      }, "$", (0, _numeral2.default)(rec.productPrice).format("0,0.00")), _react2.default.createElement("span", {
	        style: {
	          marginTop: "1px",
	          marginBottom: "0px",
	          marginLeft: "1px",
	          fontSize: "12px",
	          textTransform: "uppercase",
	          backgroundColor: "white",
	          padding: "2px",
	          borderRadius: "2px",
	          color: "black",
	          lineHeight: "16px"
	        }
	      }, rec.unit)), _react2.default.createElement("div", {
	        style: {
	          marginLeft: "1px",
	          marginRight: "1px"
	        }
	      }, _react2.default.createElement(_PhotoCard2.default, { photos: rec.photos })), rec.availability !== "OUT OF STOCK, TOPPING UP IN PROGRESS" && _react2.default.createElement("div", {
	        style: {
	          width: "100%",
	          display: "flex",
	          justifyContent: "center"
	        }
	      }, _react2.default.createElement("span", {
	        style: {
	          width: "10%",
	          minWidth: "20%"
	        }
	      }, _this.props.getBucketDetails(rec) && _react2.default.createElement("div", {
	        style: {
	          borderRadius: "40px",
	          color: "#fff",
	          backgroundColor: "red",
	          fontSize: "2em",
	          border: "0px solid black",
	          cursor: "pointer",
	          fontWeight: "bold",
	          width: "40px",
	          height: "40px",
	          lineHeight: "40px",
	          textAlign: "center",
	          margin: "5px"
	        },
	        onClick: function onClick() {
	          _this.props.removeFromBucket(rec);
	        }
	      }, "-")), _react2.default.createElement("span", {
	        style: {
	          width: "80%",
	          minWidth: "20%",
	          display: "flex",
	          justifyContent: "center"
	        }
	      }, _this.getBucketView(rec)), _react2.default.createElement("span", {
	        style: {
	          width: "10%",
	          minWidth: "20%"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          width: "100%",
	          textAlign: "right",
	          display: "flex",
	          justifyContent: "flex-end"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          borderRadius: "40px",
	          color: "#fff",
	          backgroundColor: "rgb(30, 101, 144)",
	          fontSize: "2em",
	          border: "0px solid black",
	          cursor: "pointer",
	          fontWeight: "bold",
	          width: "40px",
	          height: "40px",
	          lineHeight: "40px",
	          textAlign: "center",
	          margin: "5px"
	        },
	        onClick: function onClick() {
	          _this.props.addToBucket(rec);
	        }
	      }, _react2.default.createElement("span", { className: "blink" }, "+"))))), rec.availability === "OUT OF STOCK, TOPPING UP IN PROGRESS" && _react2.default.createElement("div", {
	        style: {
	          width: "100%",
	          display: "flex",
	          justifyContent: "center",
	          textAlign: "center"
	        }
	      }, "OUT OF STOCK, TOPPING UP IN PROGRESS"));
	    };
	
	    _this.getMobileDivs = function (data) {
	      //console.log(JSON.stringify(this.props.myProductsKeys));
	      return data.map(function (rec) {
	        //console.log(rec.sortOrder + " - " + rec.category);
	        if (rec && rec.productNameEnglish) {
	          return _this.getCard(rec);
	        }
	      });
	    };
	
	    _this.getFilteredData = function (data) {
	      //console.log(JSON.stringify(data));
	      var filtRes = [];
	      if (data && data.length > 0) {
	        if (_this.props.searchVal && _this.props.searchVal !== "") {
	          for (var i = 0; i < data.length; i++) {
	            var rec = data[i];
	
	            var recSearchVal = "";
	            if (rec.searchText && rec.searchText !== undefined && rec.searchText !== "") {
	              recSearchVal = rec.searchText;
	            }
	
	            var recVal = rec.productNameEnglish;
	            var filterVal = _this.props.searchVal.toLowerCase();
	
	            var searchResult = recVal.toLowerCase().includes(filterVal);
	            if (searchResult) {
	              filtRes.push(rec);
	            } else {
	              if (recSearchVal.toLowerCase().includes(filterVal)) {
	                filtRes.push(rec);
	              }
	            }
	          }
	        } else {
	          filtRes = data;
	        }
	      }
	      if (_this.props.searchFilters.category === "POPULAR") {
	        filtRes = _lodash2.default.sortBy(filtRes, "count");
	        filtRes = filtRes.reverse();
	        return filtRes;
	      } else {
	        return filtRes;
	      }
	    };
	
	    _this.getShoGrid = function () {
	      //console.log(this.props.searchFilters.category);
	      var filtData = [];
	      if (_this.props.searchFilters.category === "ALL" || _this.props.searchFilters.category === undefined) {
	        filtData = _this.getFilteredData(_this.props.db["supplierShopItems"]);
	      } else {
	        filtData = _this.getFilteredData(_this.props.db[_this.props.searchFilters.category]);
	      }
	
	      if (filtData && filtData.length > 0) {
	        // console.log(filtData.length);
	        // console.log("got some prods");
	        return _react2.default.createElement("div", null, _this.getMobileDivs(filtData));
	      } else {
	        console.log("time to ask for customer product");
	        return _react2.default.createElement("div", {
	          style: {
	            margin: "10px",
	            textAlign: "center"
	          }
	        }, _react2.default.createElement("div", null, "No products matched your search criteria"));
	      }
	
	      //return this.getRows(this.props.data);
	    };
	
	    _this.state = {
	      data: {
	        path: _this.props.tableName,
	        payload: _this.props.data
	      },
	      fieldList: {
	        worker: ["mobile", "name", "address", "requestedItems"],
	        grocer: ["mobile", "name", "requestedItems"],
	        all: ["deliveryDate", "mobile", "name", "address", "requestedItems", "status", "supplier", "supplierPrice", "supplierNotes", "supplierPrices"]
	      }
	    };
	    return _this;
	  }
	
	  _createClass(BuyFromShopGrid, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.props.loadPrevOrders();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement("div", { style: { marginTop: "30px" } }, this.getShoGrid());
	    }
	  }]);
	
	  return BuyFromShopGrid;
	}(_react.Component);
	
	exports.default = BuyFromShopGrid;

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	};
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _numeral = __webpack_require__(16);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var _reactDeviceDetect = __webpack_require__(6);
	
	var _reactRedux = __webpack_require__(9);
	
	var _reactackle = __webpack_require__(5);
	
	var _actions = __webpack_require__(13);
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _SelectDropdown = __webpack_require__(106);
	
	var _SelectDropdown2 = _interopRequireDefault(_SelectDropdown);
	
	var _DateDropdown = __webpack_require__(105);
	
	var _DateDropdown2 = _interopRequireDefault(_DateDropdown);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof2(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var InventoryGrid = function (_Component) {
	  _inherits(InventoryGrid, _Component);
	
	  function InventoryGrid(props) {
	    _classCallCheck(this, InventoryGrid);
	
	    var _this = _possibleConstructorReturn(this, (InventoryGrid.__proto__ || Object.getPrototypeOf(InventoryGrid)).call(this, props));
	
	    _this.getCellValue = function (strFormat, jsonValue, type) {
	      if ((typeof jsonValue === "undefined" ? "undefined" : _typeof(jsonValue)) !== "object") {
	        if (strFormat && strFormat === "numeral") {
	          return _react2.default.createElement("td", { align: "right" }, (0, _numeral2.default)(jsonValue).format("0,0.00"));
	        } else {
	          return jsonValue;
	        }
	      } else {
	        //console.log("this is an object " + JSON.stringify(jsonValue));
	        //let amt = "SGD " + numeral(props.quoteAmount).format("0,0.00");
	
	        return JSON.stringify(jsonValue);
	      }
	    };
	
	    _this.getDivCellValue = function (strFormat, jsonValue, type) {
	      if ((typeof jsonValue === "undefined" ? "undefined" : _typeof(jsonValue)) !== "object") {
	        if (strFormat && strFormat === "numeral") {
	          return (0, _numeral2.default)(jsonValue).format("0,0.00");
	        } else {
	          return jsonValue;
	        }
	      } else {
	        //console.log(type + " this is an object " + JSON.stringify(jsonValue));
	        //let amt = "SGD " + numeral(props.quoteAmount).format("0,0.00");
	        if (type === "photoUpload") {
	          return _react2.default.createElement("div", { className: "images" }, _this.getImages(jsonValue));
	        } else {
	          return JSON.stringify(jsonValue);
	        }
	      }
	    };
	
	    _this.getColumns = function (jObject, tableDef) {
	      //console.log(JSON.stringify(this.state))
	      //console.log(JSON.stringify(tableDef));
	
	      return Object.keys(tableDef).map(function (key, index) {
	        //console.log(key + "=" + tableDef[key]);
	        if (key !== "searches") {
	          if (index === 0) {
	            return _react2.default.createElement("td", {
	              "data-title": tableDef[key].caption,
	              style: {
	                wordBreak: "break-word",
	                wordWrap: "break-word",
	                overflowWrap: "break-word"
	              }
	            }, _react2.default.createElement("a", {
	              href: "#",
	              onClick: function onClick() {
	                return _this.props.handleEdit(jObject.key, _this.props.tableName, jObject);
	              }
	            }, _this.getCellValue(tableDef[key].format, jObject[key], tableDef[key].type)));
	          } else {
	            return _react2.default.createElement("td", {
	              "data-title": tableDef[key].caption,
	              style: {
	                wordBreak: "break-word",
	                wordWrap: "break-word",
	                overflowWrap: "break-word"
	              }
	            }, _this.getCellValue(tableDef[key].format, jObject[key], tableDef[key].type));
	          }
	        }
	      });
	    };
	
	    _this.getDivColumns = function (jObject, tableDef) {
	      //console.log("content grid issue: " + JSON.stringify(tableDef));
	      return Object.keys(tableDef).map(function (key, index) {
	        //console.log("here is the " + key);
	        if (key !== "searches") {
	          return _react2.default.createElement("div", null, _react2.default.createElement("span", {
	            style: {
	              marginLeft: "0px",
	              color: "grey",
	              fontSize: "12px",
	              fontWeight: "bold"
	            }
	          }, tableDef[key].caption, ":"), _react2.default.createElement("span", {
	            style: {
	              wordBreak: "break-word",
	              wordWrap: "break-word",
	              overflowWrap: "break-word",
	              fontSize: "15px",
	              paddingLeft: "15px"
	            }
	          }, _this.getDivCellValue(tableDef[key].format, jObject[key], tableDef[key].type)));
	        }
	      });
	    };
	
	    _this.getLoader = function () {
	      return _react2.default.createElement(_reactackle.CardContent, null, _react2.default.createElement(_reactackle.CircleProgress, { indeterminate: true, subtitle: "Saving..." }));
	    };
	
	    _this.getHeaderRow = function (tableDef) {
	      return Object.keys(tableDef).map(function (key) {
	        if (key !== "searches" && tableDef[key]) {
	          return _react2.default.createElement("th", null, tableDef[key].caption);
	        }
	      });
	    };
	
	    _this.getRows = function (data) {
	      return data.map(function (rec) {
	        return _react2.default.createElement("tr", null, _this.getColumns(rec, _this.props.tableDef));
	      });
	    };
	
	    _this.getMobileDivs = function (data) {
	      return data.map(function (rec) {
	        return _react2.default.createElement("div", {
	          onClick: function onClick() {
	            return _this.props.handleEdit(rec.key, _this.props.tableName, rec);
	          },
	          style: {
	            borderColor: "darkgray",
	            borderWidth: "1px",
	            borderStyle: "solid",
	            borderRadius: "10px",
	            backgroundColor: "white",
	            margin: "5px",
	            padding: "5px",
	            marginBottom: "15px",
	            fontSize: "medium",
	            fontWeight: "bold",
	            boxShadow: "1px 2px #888888"
	          }
	        }, _this.getDivColumns(rec, _this.props.tableDef));
	      });
	    };
	
	    _this.getTopHeader = function () {
	      return _react2.default.createElement("div", null, _react2.default.createElement(_reactackle.Card, null, _react2.default.createElement(_reactackle.CardAreaMain, null, _react2.default.createElement(_reactackle.CardContent, null, _react2.default.createElement("div", null, _react2.default.createElement("h1", null, "BCS HOME"))), _react2.default.createElement(_reactackle.CardActions, null))));
	    };
	
	    _this.getDailyInventory = function () {
	      function sum(numbers) {
	        //console.log(JSON.stringify(numbers));
	        var numSum = _.reduce(numbers, function (result, current) {
	          //console.log("current: " + current + "  result: " + result);
	          if (current === "" || current === null || current === undefined || current === "NaN") {
	            console.log("Found an NaN===" + current);
	            current = 0;
	          }
	          return result + parseFloat(current);
	        }, 0);
	        //console.log(numSum);
	        return numSum.toFixed(2);
	      }
	
	      function getDeliveryDate(item) {
	        var dDate = (0, _moment2.default)(item.deliveryDate, "DD-MM-YYYY");
	        if (item.createDateTime && item.createDateTime !== "") {
	          if (item.createDateTime.includes("/")) {
	            dDate = (0, _moment2.default)(item.createDateTime, "DD/MM/YYYY hh:mm:ss");
	          } else {
	            dDate = (0, _moment2.default)(item.createDateTime, "ddd DD-MM-YY h:mm a");
	          }
	        }
	
	        return dDate.format("DD-MM-YYYY").toString();
	      }
	
	      var allOrders = _this.props.db["deliveryRequest"];
	
	      var filteredOrders = _.chain(allOrders).filter(function (item) {
	        var createDateTime = getDeliveryDate(item);
	        var checkMomDate = (0, _moment2.default)(createDateTime, "DD-MM-YYYY");
	        var sDate = (0, _moment2.default)(_this.state.data.payload.invFromDate, "DD-MM-YYYY");
	        var eDate = (0, _moment2.default)(_this.state.data.payload.invToDate, "DD-MM-YYYY");
	
	        if (checkMomDate.isBetween(sDate, eDate, "day", "[]")) {
	          if (_this.state.data.payload.orderStatus === "ALL") {
	            return true;
	          } else if (_this.state.data.payload.orderStatus === "ALL EXCEPT CANCELLED") {
	            return item.status !== "CANCELLED";
	          } else {
	            return item.status === _this.state.data.payload.orderStatus;
	          }
	        } else {
	          return false;
	        }
	      }).map(function (item) {
	        return _extends({}, item, {
	          createDateTime: getDeliveryDate(item)
	        });
	      }).value();
	      var prodSales = [];
	      for (var i = 0; i < filteredOrders.length; i++) {
	        var currOrd = filteredOrders[i];
	        var currProds = currOrd.requestedItems;
	        for (var j = 0; j < currProds.length; j++) {
	          prodSales.push({
	            quantity: currProds[j].quantity,
	            productNameEnglish: currProds[j].productNameEnglish,
	            createDateTime: currOrd.createDateTime,
	            name: currOrd.name,
	            status: currOrd.status
	          });
	        }
	      }
	      var allProductsSalesArray = _.chain(prodSales).groupBy("productNameEnglish").map(function (value, key) {
	        return {
	          productNameEnglish: key,
	          totSold: sum(_.pluck(value, "quantity")),
	          indOrders: value
	        };
	      }).value();
	
	      var inventoryArray = _this.props.db["inventory"];
	      var allProductsBuysArray = _.chain(inventoryArray).groupBy("product").map(function (value, key) {
	        return {
	          productNameEnglish: key,
	          totPurchased: sum(_.pluck(value, "quantity")),
	          indPurchases: value,
	          saleInfo: allProductsSalesArray.find(function (item) {
	            return item.productNameEnglish === key;
	          })
	        };
	      }).value();
	      _this.props.onSetUiFlag("allProductsBuysArray", allProductsBuysArray);
	    };
	
	    _this.getOverallTotal = function (dailySaleArray) {
	      var totSaleAmt = 0;
	      var totPurAmt = 0;
	      var totAdminSaleAmt = 0;
	      for (var i = 0; i < dailySaleArray.length; i++) {
	        totSaleAmt = totSaleAmt + parseFloat(dailySaleArray[i].actualSales);
	        totPurAmt = totPurAmt + (dailySaleArray && dailySaleArray[i].purchaseInfo && dailySaleArray[i].purchaseInfo.retailPurchase ? parseFloat(dailySaleArray[i].purchaseInfo.retailPurchase) : 0);
	        totAdminSaleAmt = totAdminSaleAmt + (dailySaleArray && dailySaleArray[i].purchaseInfo && dailySaleArray[i].purchaseInfo.smitaSale ? parseFloat(dailySaleArray[i].purchaseInfo.smitaSale) : 0);
	      }
	      _this.props.onSetUiFlag("totActualSales", totSaleAmt.toFixed(2));
	      _this.props.onSetUiFlag("totPur", totPurAmt.toFixed(2));
	      _this.props.onSetUiFlag("totAdminSales", totAdminSaleAmt.toFixed(2));
	      _this.props.onSetUiFlag("dailySaleArray", dailySaleArray);
	      // console.log("total sales" + totSaleAmt.toFixed(2));
	      // console.log("total purchase" + totPurAmt.toFixed(2));
	      // console.log("total admin sale" + totAdminSaleAmt.toFixed(2));
	    };
	
	    _this.getDailySales = function () {
	      function sum(numbers) {
	        //console.log(JSON.stringify(numbers));
	        var numSum = _.reduce(numbers, function (result, current) {
	          //console.log("current: " + current + "  result: " + result);
	          if (current === "" || current === null || current === undefined || current === "NaN") {
	            //console.log("Found an NaN===" + current);
	            current = 0;
	          }
	
	          return result + parseFloat(current);
	        }, 0);
	        //console.log(numSum);
	        return numSum.toFixed(2);
	      }
	
	      function getDeliveryDate(item) {
	        var dDate = (0, _moment2.default)(item.targetDeliveryDate, "ddd DD-MM-YYYY");
	        if (item.targetDeliveryDate && item.targetDeliveryDate !== undefined && item.targetDeliveryDate !== "" && item.targetDeliveryDate.includes("-")) {
	          dDate = (0, _moment2.default)(item.targetDeliveryDate, "ddd DD-MM-YYYY");
	        } else {
	          dDate = (0, _moment2.default)(item.deliveryDate, "DD-MM-YYYY");
	        }
	        // let dDate = moment(item.deliveryDate, "DD-MM-YYYY");
	        // if (item.createDateTime && item.createDateTime !== "") {
	        //   if (item.createDateTime.includes("/")) {
	        //     dDate = moment(item.createDateTime, "DD/MM/YYYY hh:mm:ss");
	        //   } else {
	        //     dDate = moment(item.createDateTime, "ddd DD-MM-YY h:mm a");
	        //   }
	        // }
	
	        return dDate.format("DD-MM-YYYY").toString();
	      }
	
	      function getGroupBy(selection) {
	        if (selection === "DAILY") {
	          return "createDateTime";
	        } else if (selection === "WEEKLY") {
	          return "week";
	        } else if (selection === "MONTHLY") {
	          return "month";
	        } else {
	          return "quarter";
	        }
	      }
	
	      var allPurchases = _this.props.db["purchase"];
	      var dailyPurchaseArray = _.chain(allPurchases).filter(function (item) {
	        var createDateTime = item.date;
	        if (_this.state.data.payload.days !== "ALL" && _this.state.data.payload.groupBy === "DAILY") {
	          var dDay = (0, _moment2.default)(createDateTime, "DD-MM-YYYY").format("ddd").toString().toLowerCase();
	          // console.log(
	          //   dDay + " vs " + this.state.data.payload.days.toLowerCase()
	          // );
	          return dDay === _this.state.data.payload.days.toLowerCase();
	        }
	        var checkMomDate = (0, _moment2.default)(createDateTime, "DD-MM-YYYY");
	
	        var sDate = (0, _moment2.default)(_this.state.data.payload.fromDate, "DD-MM-YYYY");
	        //console.log(this.state.data.payload.fromDate + "=" + sDate);
	        var eDate = (0, _moment2.default)(_this.state.data.payload.toDate, "DD-MM-YYYY");
	
	        if (checkMomDate.isBetween(sDate, eDate, "day", "[]")) {
	          return true;
	        } else {
	          // console.log(
	          //   createDateTime +
	          //     "(" +
	          //     checkMomDate +
	          //     ") " +
	          //     this.state.data.payload.fromDate +
	          //     "(" +
	          //     sDate +
	          //     ") " +
	          //     this.state.data.payload.toDate +
	          //     "(" +
	          //     eDate +
	          //     ")"
	          // );
	          return false;
	        }
	      }).map(function (value) {
	        return _extends({}, value, {
	          retailPurchase: value.receiptAmount.replace(",", ""),
	          wholeSalePurcahse: value.supplierPurchase,
	          smitaSale: value.sellAmount,
	          createDateTime: value.date,
	          week: (0, _moment2.default)(value.date, "DD-MM-YYYY").week(),
	          month: (0, _moment2.default)(value.date, "DD-MM-YYYY").format("MMM").toString(),
	          quarter: (0, _moment2.default)(value.date, "DD-MM-YYYY").quarter()
	        });
	      }).groupBy(getGroupBy(_this.state.data.payload.groupBy)).map(function (value, key) {
	        var refDate = "";
	
	        if (_this.state.data.payload.groupBy === "DAILY") {
	          refDate = (0, _moment2.default)(key, "DD-MM-YYYY").format("ddd DD-MM-YYYY").toString();
	        } else {
	          refDate = key;
	        }
	        return {
	          oDate: refDate,
	          momODate: (0, _moment2.default)(key, "DD-MM-YYYY"),
	          retailPurchase: sum(_.pluck(value, "retailPurchase")),
	          wholeSalePurcahse: sum(_.pluck(value, "wholeSalePurcahse")),
	          smitaSale: sum(_.pluck(value, "smitaSale"))
	        };
	      }).sortBy("momODate").reverse().value();
	
	      var allOrders = _this.props.db["deliveryRequest"];
	      var dailySaleArray = _.chain(allOrders).filter(function (item) {
	        var createDateTime = getDeliveryDate(item);
	        if (_this.state.data.payload.days !== "ALL" && _this.state.data.payload.groupBy === "DAILY") {
	          var dDay = (0, _moment2.default)(createDateTime, "DD-MM-YYYY").format("ddd").toString().toLowerCase();
	          // console.log(
	          //   dDay + " vs " + this.state.data.payload.days.toLowerCase()
	          // );
	          return dDay === _this.state.data.payload.days.toLowerCase();
	        }
	        var checkMomDate = (0, _moment2.default)(createDateTime, "DD-MM-YYYY");
	
	        var sDate = (0, _moment2.default)(_this.state.data.payload.fromDate, "DD-MM-YYYY");
	        //console.log(this.state.data.payload.fromDate + "=" + sDate);
	        var eDate = (0, _moment2.default)(_this.state.data.payload.toDate, "DD-MM-YYYY");
	
	        if (checkMomDate.isBetween(sDate, eDate, "day", "[]")) {
	          if (_this.state.data.payload.orderStatus === "ALL") {
	            return true;
	          } else if (_this.state.data.payload.orderStatus === "ALL EXCEPT CANCELLED") {
	            return item.status !== "CANCELLED";
	          } else {
	            return item.status === _this.state.data.payload.orderStatus;
	          }
	        } else {
	          // console.log(
	          //   createDateTime +
	          //     "(" +
	          //     checkMomDate +
	          //     ") " +
	          //     this.state.data.payload.fromDate +
	          //     "(" +
	          //     sDate +
	          //     ") " +
	          //     this.state.data.payload.toDate +
	          //     "(" +
	          //     eDate +
	          //     ")"
	          // );
	          return false;
	        }
	      }).map(function (value) {
	        return _extends({}, value, {
	          salesTotal: value.salesTotal && value.salesTotal > 0 ? value.salesTotal : value.orderTotal,
	          createDateTime: getDeliveryDate(value),
	          week: (0, _moment2.default)(getDeliveryDate(value), "DD-MM-YYYY").week(),
	          month: (0, _moment2.default)(getDeliveryDate(value), "DD-MM-YYYY").format("MMM").toString(),
	          quarter: (0, _moment2.default)(getDeliveryDate(value), "DD-MM-YYYY").quarter()
	        });
	      }).groupBy(getGroupBy(_this.state.data.payload.groupBy)).map(function (value, key) {
	        var refDate = "";
	
	        if (_this.state.data.payload.groupBy === "DAILY") {
	          refDate = (0, _moment2.default)(key, "DD-MM-YYYY").format("ddd DD-MM-YYYY").toString();
	        } else {
	          refDate = key;
	          if (_this.state.data.payload.groupBy === "WEEKLY") {} else if (_this.state.data.payload.groupBy === "MONTHLY") {} else if (_this.state.data.payload.groupBy === "QUARTLY") {}
	        }
	        //console.log(refDate);
	        return {
	          oDate: refDate,
	          momODate: (0, _moment2.default)(key, "DD-MM-YYYY"),
	          orderTotal: sum(_.pluck(value, "orderTotal")),
	          actualSales: sum(_.pluck(value, "salesTotal")),
	          purchaseInfo: dailyPurchaseArray.find(function (item) {
	            return item.oDate === refDate;
	          }),
	          allRecs: value
	        };
	      }).sortBy("momODate").reverse().value();
	
	      if (_this.state.data.payload.groupBy === "MONTHLY") {
	        dailySaleArray = dailySaleArray.reverse();
	      }
	
	      _this.getOverallTotal(dailySaleArray);
	    };
	
	    _this.stateChangeHandler = function (val, id, isPayload) {
	      //console.log("val: " + val + " id: " + id + " isPayload: " + isPayload);
	      var tmpState = {};
	      tmpState[id] = val;
	
	      if (isPayload) {
	        _this.setState(function (prevState) {
	          if (prevState && prevState.data.payload !== null) {
	            return _extends({}, prevState, {
	              data: _extends({}, prevState.data, {
	                payload: _extends({}, prevState.data.payload, tmpState)
	              })
	            });
	          } else {
	            return _extends({}, prevState, {
	              data: {
	                path: prevState.data.path,
	                payload: _extends({}, tmpState)
	              }
	            });
	          }
	        });
	      } else {
	        _this.setState(function (prevState) {
	          return _extends({}, prevState, tmpState);
	        });
	      }
	    };
	
	    _this.getProfit = function (saleAmt, purchaseAmt) {
	      var sellNumber = parseFloat(saleAmt);
	      var purchaseNumber = parseFloat(purchaseAmt);
	      var profitNumber = sellNumber - purchaseNumber;
	      profitNumber = profitNumber.toFixed(2);
	      return profitNumber;
	    };
	
	    _this.getSalesReport = function () {
	      var dailySaleArray = _this.props.ui["dailySaleArray"];
	      var getIndOrders = function getIndOrders(indOrders) {
	        if (_this.state.data.payload.indOrders === "YES") {
	          return indOrders.map(function (item) {
	            return _react2.default.createElement("div", {
	              style: {
	                textAlign: "right",
	                fontFamily: "Courier",
	                fontSize: "8px",
	                display: "flex",
	                flexDirection: "row"
	              },
	              onClick: function onClick() {
	                var newObj = _extends({}, item, { requestedItems: [], messages: [] });
	
	                alert(JSON.stringify(newObj));
	              }
	            }, _react2.default.createElement("div", { style: { width: "20%" } }, item.name.substring(0, 7)), _react2.default.createElement("div", { style: { width: "20%" } }, item.createDateTime.substring(0, 5)), _react2.default.createElement("div", { style: { width: "20%" } }, item.status.substring(0, 7)), _react2.default.createElement("div", { style: { width: "20%" } }, item.salesTotal), _react2.default.createElement("div", { style: { width: "20%" } }, item.orderTotal));
	          });
	        } else {}
	      };
	
	      if (dailySaleArray && dailySaleArray.length > 0) {
	        if (_this.state.data.payload.indOrders) {
	          return dailySaleArray.map(function (item) {
	            return _react2.default.createElement("tr", null, _react2.default.createElement("td", {
	              style: {
	                textAlign: "center"
	              }
	            }, item.oDate), _react2.default.createElement("td", {
	              style: {
	                textAlign: "center"
	              }
	            }, item.purchaseInfo && item.purchaseInfo !== undefined && item.purchaseInfo.retailPurchase ? item.purchaseInfo.retailPurchase : ""), _react2.default.createElement("td", {
	              style: {
	                textAlign: "center"
	              }
	            }, item.actualSales), _react2.default.createElement("td", {
	              style: {
	                textAlign: "center"
	              }
	            }, item.purchaseInfo && item.purchaseInfo !== undefined && item.purchaseInfo.smitaSale ? item.purchaseInfo.smitaSale : ""), _react2.default.createElement("td", {
	              style: {
	                textAlign: "center"
	              }
	            }, _this.getProfit(item.purchaseInfo && item.purchaseInfo !== undefined && item.purchaseInfo.smitaSale ? item.purchaseInfo.smitaSale : "0", item.purchaseInfo && item.purchaseInfo !== undefined && item.purchaseInfo.retailPurchase ? item.purchaseInfo.retailPurchase : "0")), _this.state.data.payload.indOrders === "YES" ? _react2.default.createElement("td", null, getIndOrders(item.allRecs)) : null);
	          });
	        } else {
	          return dailySaleArray.map(function (item) {
	            return _react2.default.createElement("tr", null, _react2.default.createElement("td", {
	              style: {
	                textAlign: "center"
	              }
	            }, item.oDate), _react2.default.createElement("td", {
	              style: {
	                textAlign: "center"
	              }
	            }, item.purchaseInfo && item.purchaseInfo !== undefined && item.purchaseInfo.retailPurchase ? item.purchaseInfo.retailPurchase : ""), _react2.default.createElement("td", {
	              style: {
	                textAlign: "center"
	              }
	            }, item.actualSales), _react2.default.createElement("td", {
	              style: {
	                textAlign: "center"
	              }
	            }, item.purchaseInfo && item.purchaseInfo !== undefined && item.purchaseInfo.smitaSale ? item.purchaseInfo.smitaSale : ""), _react2.default.createElement("td", {
	              style: {
	                textAlign: "center"
	              }
	            }, _this.getProfit(item.purchaseInfo && item.purchaseInfo !== undefined && item.purchaseInfo.smitaSale ? item.purchaseInfo.smitaSale : "0", item.purchaseInfo && item.purchaseInfo !== undefined && item.purchaseInfo.retailPurchase ? item.purchaseInfo.retailPurchase : "0")));
	          });
	        }
	      } else {
	        return _react2.default.createElement("div", null);
	      }
	    };
	
	    _this.getInventoryReport = function () {
	      var allProductsBuysArray = _this.props.ui["allProductsBuysArray"];
	
	      function getRemainUnits(purUnits, saleInfo) {
	        if (saleInfo && saleInfo.totSold) {
	          var purQty = parseFloat(purUnits);
	          var sellQty = parseFloat(saleInfo.totSold);
	          var remUnits = purQty - sellQty;
	          return remUnits;
	        } else {
	          return purUnits;
	        }
	      }
	
	      var getIndOrders = function getIndOrders(indOrders) {
	        if (_this.state.data.payload.indOrders === "YES") {
	          return indOrders.map(function (item) {
	            return _react2.default.createElement("div", {
	              style: {
	                textAlign: "right",
	                fontFamily: "Courier",
	                fontSize: "8px",
	                display: "flex",
	                flexDirection: "row"
	              }
	            }, _react2.default.createElement("div", { style: { width: "20%" } }, item.name.substring(0, 7)), _react2.default.createElement("div", { style: { width: "20%" } }, item.createDateTime.substring(0, 5)), _react2.default.createElement("div", { style: { width: "20%" } }, item.status.substring(0, 7)), _react2.default.createElement("div", { style: { width: "20%" } }, item.quantity));
	          });
	        } else {}
	      };
	
	      if (allProductsBuysArray && allProductsBuysArray.length > 0) {
	        return allProductsBuysArray.map(function (item) {
	          return _react2.default.createElement("tr", null, _react2.default.createElement("td", {
	            style: {
	              textAlign: "center"
	            }
	          }, item.productNameEnglish), _react2.default.createElement("td", {
	            style: {
	              textAlign: "center"
	            }
	          }, item.totPurchased), _react2.default.createElement("td", {
	            style: {
	              textAlign: "center"
	            }
	          }, item.saleInfo && item.saleInfo.totSold ? item.saleInfo.totSold : ""), _react2.default.createElement("td", {
	            style: {
	              textAlign: "center"
	            }
	          }, getRemainUnits(item.totPurchased, item.saleInfo)), _this.state.data.payload.indOrders === "YES" ? _react2.default.createElement("td", null, getIndOrders(item.saleInfo && item.saleInfo.totSold ? item.saleInfo.indOrders : [])) : null);
	        });
	      } else {
	        return _react2.default.createElement("div", null);
	      }
	    };
	
	    _this.state = {
	      data: {
	        path: "",
	        payload: {
	          orderStatus: "ALL EXCEPT CANCELLED",
	          toDate: (0, _moment2.default)().format("DD-MM-YYYY").toString(),
	          fromDate: (0, _moment2.default)().subtract(365, "days").format("DD-MM-YYYY").toString(),
	          invToDate: (0, _moment2.default)().format("DD-MM-YYYY").toString(),
	          invFromDate: "13-08-2020",
	          indOrders: "NO",
	          groupBy: "MONTHLY",
	          days: "ALL"
	        }
	      }
	    };
	    return _this;
	  }
	
	  //single method that work for all fields
	  //takes incoming id of the field and then adds field data to state
	
	
	  _createClass(InventoryGrid, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement("div", {
	        style: {
	          minHeight: 800
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          margin: "5px",
	          border: "1px solid gainsboro",
	          padding: "2px"
	        }
	      }, _react2.default.createElement(_SelectDropdown2.default, {
	        title: "Order Status",
	        data: [{ name: "ALL" }, { name: "ALL EXCEPT CANCELLED" }, { name: "WITH GROCER FOR PRICE" }, { name: "DELIVERED" }, { name: "CANCELLED" }],
	        label: "ORDER STATUS",
	        placeholder: "",
	        value: this.state.data.payload.orderStatus,
	        stateFieldName: "orderStatus",
	        isPayload: true,
	        fieldName: "name",
	        stateHandler: this.stateChangeHandler,
	        disabled: false
	      }), _react2.default.createElement(_SelectDropdown2.default, {
	        title: "FREQUENCY",
	        data: [{ name: "DAILY" }, { name: "WEEKLY" }, { name: "MONTHLY" }, { name: "QUARTERLY" }],
	        label: "FREQUENCY",
	        placeholder: "",
	        value: this.state.data.payload.groupBy,
	        stateFieldName: "groupBy",
	        isPayload: true,
	        fieldName: "name",
	        stateHandler: this.stateChangeHandler,
	        disabled: false
	      }), _react2.default.createElement(_DateDropdown2.default, {
	        title: "To Date"
	        //maxDetail={fieldDef.dateMaxDetail === "minute" ? "minute" : ""}
	        , format: "dd-MM-yyyy",
	        formatOut: "DD-MM-YYYY",
	        onChange: this.stateChangeHandler,
	        fieldName: "toDate",
	        value: this.state.data.payload.toDate,
	        disabled: false
	      }), _react2.default.createElement(_DateDropdown2.default, {
	        title: "From Date"
	        //maxDetail={fieldDef.dateMaxDetail === "minute" ? "minute" : ""}
	        , format: "dd-MM-yyyy",
	        formatOut: "DD-MM-YYYY",
	        onChange: this.stateChangeHandler,
	        fieldName: "fromDate",
	        value: this.state.data.payload.fromDate,
	        disabled: false
	      }), _react2.default.createElement(_SelectDropdown2.default, {
	        title: "DAYS",
	        data: [{ name: "ALL" }, { name: "MON" }, { name: "TUE" }, { name: "WED" }, { name: "THU" }, { name: "FRI" }, { name: "SAT" }, { name: "SUN" }],
	        label: "DAYS",
	        placeholder: "",
	        value: this.state.data.payload.days,
	        stateFieldName: "days",
	        isPayload: true,
	        fieldName: "name",
	        stateHandler: this.stateChangeHandler,
	        disabled: false
	      }), _react2.default.createElement(_SelectDropdown2.default, {
	        title: "Show Order Breakdown",
	        data: [{ name: "YES" }, { name: "NO" }],
	        label: "VIEW INDIVIDUAL ORDERS",
	        placeholder: "",
	        value: this.state.data.payload.indOrders,
	        stateFieldName: "indOrders",
	        isPayload: true,
	        fieldName: "name",
	        stateHandler: this.stateChangeHandler,
	        disabled: false
	      }), _react2.default.createElement("div", {
	        style: {
	          textAlign: "center",
	          fontSize: "18px",
	          color: "blue",
	          margin: "5px",
	          border: "1px solid blue",
	          cursor: "pointer"
	        },
	        onClick: function onClick() {
	          _this2.getDailySales();
	        }
	      }, "Generate Report")), _react2.default.createElement("div", {
	        style: {
	          display: "flex"
	        }
	      }), _react2.default.createElement("table", {
	        className: _reactDeviceDetect.isMobile ? "table table-striped table-sm" : "table table-striped table-bordered table-lg",
	        style: { tableLayout: "fixed" }
	      }, _react2.default.createElement("thead", null, _react2.default.createElement("tr", null, _react2.default.createElement("th", {
	        style: {
	          textAlign: "center"
	        }
	      }, "DATE"), _react2.default.createElement("th", {
	        style: {
	          textAlign: "center"
	        }
	      }, "PURCHASES"), _react2.default.createElement("th", {
	        style: {
	          textAlign: "center"
	        }
	      }, "ACTUAL SALE"), _react2.default.createElement("th", {
	        style: {
	          textAlign: "center"
	        }
	      }, "ADMIN SALE"), _react2.default.createElement("th", {
	        style: {
	          textAlign: "center"
	        }
	      }, "PROFIT"), this.state.data.payload.indOrders === "YES" ? _react2.default.createElement("th", null, "IND ORDERS") : null)), _react2.default.createElement("tbody", null, this.getSalesReport(), _react2.default.createElement("tr", null, _react2.default.createElement("td", {
	        style: {
	          textAlign: "right",
	          fontWeight: "bold"
	        }
	      }, "TOTAL"), _react2.default.createElement("td", {
	        style: {
	          textAlign: "center",
	          fontWeight: "bold"
	        }
	      }, this.props.ui["totPur"] ? this.props.ui["totPur"] : ""), _react2.default.createElement("td", {
	        style: {
	          textAlign: "center",
	          fontWeight: "bold"
	        }
	      }, this.props.ui["totActualSales"] ? this.props.ui["totActualSales"] : ""), _react2.default.createElement("td", {
	        style: {
	          textAlign: "center",
	          fontWeight: "bold"
	        }
	      }, this.props.ui["totAdminSales"] ? this.props.ui["totAdminSales"] : ""), _react2.default.createElement("td", {
	        style: {
	          textAlign: "center",
	          fontWeight: "bold"
	        }
	      }, this.getProfit(this.props.ui["totAdminSales"] ? this.props.ui["totAdminSales"] : "0", this.props.ui["totPur"] ? this.props.ui["totPur"] : "0")), this.state.data.payload.indOrders === "YES" && _react2.default.createElement("td", null)))), _react2.default.createElement("div", {
	        style: {
	          minHeight: "50px"
	        }
	      }), _react2.default.createElement("div", {
	        style: {
	          margin: "5px",
	          border: "1px solid gainsboro",
	          padding: "2px"
	        }
	      }, _react2.default.createElement(_DateDropdown2.default, {
	        title: "To Date"
	        //maxDetail={fieldDef.dateMaxDetail === "minute" ? "minute" : ""}
	        , format: "dd-MM-yyyy",
	        formatOut: "DD-MM-YYYY",
	        onChange: this.stateChangeHandler,
	        fieldName: "invToDate",
	        value: this.state.data.payload.invToDate,
	        disabled: false
	      }), _react2.default.createElement(_DateDropdown2.default, {
	        title: "From Date"
	        //maxDetail={fieldDef.dateMaxDetail === "minute" ? "minute" : ""}
	        , format: "dd-MM-yyyy",
	        formatOut: "DD-MM-YYYY",
	        onChange: this.stateChangeHandler,
	        fieldName: "invFromDate",
	        value: this.state.data.payload.invFromDate,
	        disabled: false
	      }), _react2.default.createElement("div", {
	        style: {
	          textAlign: "center",
	          fontSize: "18px",
	          color: "blue",
	          margin: "5px",
	          border: "1px solid blue",
	          cursor: "pointer"
	        },
	        onClick: function onClick() {
	          _this2.getDailyInventory();
	        }
	      }, "Generate Report")), _react2.default.createElement("table", {
	        className: _reactDeviceDetect.isMobile ? "table table-striped table-sm" : "table table-striped table-bordered table-lg",
	        style: { tableLayout: "fixed" }
	      }, _react2.default.createElement("thead", null, _react2.default.createElement("tr", null, _react2.default.createElement("th", {
	        style: {
	          textAlign: "center"
	        }
	      }, "PRODUCT NAME"), _react2.default.createElement("th", {
	        style: {
	          textAlign: "center"
	        }
	      }, "PURCHASED"), _react2.default.createElement("th", {
	        style: {
	          textAlign: "center"
	        }
	      }, "SOLD"), _react2.default.createElement("th", {
	        style: {
	          textAlign: "center"
	        }
	      }, "REMAINING"), this.state.data.payload.indOrders === "YES" ? _react2.default.createElement("th", null, "IND ORDERS") : null)), _react2.default.createElement("tbody", null, this.getInventoryReport())));
	    }
	  }]);
	
	  return InventoryGrid;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    db: state.db,
	    ui: state.ui
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  return {
	    onSetUiFlag: function onSetUiFlag(flagName, flagVal) {
	      return dispatch((0, _actions.setUiFlag)(flagName, flagVal));
	    }
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(InventoryGrid);

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _numeral = __webpack_require__(16);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var _reactackle = __webpack_require__(5);
	
	var _reactLazyLoadImageComponent = __webpack_require__(30);
	
	var _PhotoCard = __webpack_require__(104);
	
	var _PhotoCard2 = _interopRequireDefault(_PhotoCard);
	
	var _SingleRecord = __webpack_require__(77);
	
	var _SingleRecord2 = _interopRequireDefault(_SingleRecord);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var MyShopCard = function (_Component) {
	  _inherits(MyShopCard, _Component);
	
	  function MyShopCard() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, MyShopCard);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MyShopCard.__proto__ || Object.getPrototypeOf(MyShopCard)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      editMode: false
	    }, _this.getPhotos = function (photos) {
	      if (photos && photos.length > 0) {
	        return photos.map(function (photo, index) {
	          if (photo.status === "DONE") {
	            return _react2.default.createElement("div", { style: { backgroundColor: "white" } }, _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: photo.url, style: { minHeight: "200px" } }));
	          } else {
	            return _react2.default.createElement("div", { style: { padding: "40px", backgroundColor: "white" } }, _react2.default.createElement(_reactackle.CircleProgress, {
	              indeterminate: true,
	              subtitle: "Updating...",
	              labelPositionX: "center",
	              labelPositionY: "bottom"
	            }));
	          }
	        });
	      }
	    }, _this.getMobileDiv = function (rec) {
	      var _ref2;
	
	      //console.log(JSON.stringify(rec));
	      return _react2.default.createElement("div", null, _react2.default.createElement("div", {
	        style: {
	          margin: "0px",
	          fontSize: "16px",
	          fontWeight: "bold",
	          textTransform: "uppercase",
	          width: "100%",
	          padding: "10px",
	          paddingBottom: "0px"
	        }
	      }, rec.productNameEnglish), _react2.default.createElement("div", {
	        style: {
	          marginTop: "1px"
	        }
	      }, _react2.default.createElement("span", {
	        style: {
	          marginTop: "1px",
	          marginBottom: "0px",
	          marginLeft: "10px",
	          fontSize: "14px",
	          textTransform: "uppercase",
	          backgroundColor: "black",
	          padding: "2px",
	          borderRadius: "2px",
	          color: "white",
	          paddingLeft: "10px",
	          paddingRight: "10px"
	        }
	      }, "$", (0, _numeral2.default)(rec.productPrice).format("0,0.00")), _react2.default.createElement("span", {
	        style: {
	          marginTop: "1px",
	          marginBottom: "0px",
	          marginLeft: "1px",
	          fontSize: "12px",
	          textTransform: "uppercase",
	          backgroundColor: "white",
	          padding: "2px",
	          borderRadius: "2px",
	          color: "black"
	        }
	      }, rec.unit)), _react2.default.createElement("div", {
	        style: {
	          marginLeft: "1px",
	          marginRight: "1px"
	        }
	      }, _react2.default.createElement(_PhotoCard2.default, { photos: rec.photos })), _react2.default.createElement("div", {
	        style: (_ref2 = {
	          color: "#333",
	          fontSize: "14px",
	          backgroundColor: "rgb(30, 101, 144)",
	          padding: "5px",
	          borderRadius: "5px"
	        }, _defineProperty(_ref2, "color", "white"), _defineProperty(_ref2, "margin", "5px"), _defineProperty(_ref2, "textAlign", "center"), _ref2)
	      }, _react2.default.createElement("div", {
	        onClick: function onClick() {
	          _this.props.handleEdit(rec.key, _this.props.tableName, rec);
	          _this.setState({ editMode: true });
	        }
	      }, "CHANGE")));
	    }, _this.getEditView = function () {
	      return _react2.default.createElement("div", {
	        style: {
	          marginTop: "-60px"
	        }
	      }, _react2.default.createElement(_SingleRecord2.default, {
	        path: _this.props.tableName,
	        handleEditCancel: function handleEditCancel() {
	          _this.setState({ editMode: false });
	        },
	        handleDelete: _this.props.handleDelete,
	        ogTableDef: _this.props.ogTableDef,
	        genNotification: _this.props.genNotification,
	        cellPhone: _this.props.refPhoneNumber
	      }));
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(MyShopCard, [{
	    key: "render",
	    value: function render() {
	      if (this.state.editMode) {
	        return _react2.default.createElement("div", {
	          style: {
	            background: "#FFFFFF",
	            border: "1.5px solid #ccc",
	            boxSizing: "border-box",
	            boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
	            borderRadius: "10px",
	            marginBottom: "10px",
	            marginRight: "5px",
	            marginLeft: "5px",
	            padding: "2px"
	          }
	        }, this.getEditView(), ";");
	      } else {
	        return _react2.default.createElement("div", {
	          style: {
	            background: "#FFFFFF",
	            border: "1.5px solid #ccc",
	            boxSizing: "border-box",
	            boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
	            borderRadius: "10px",
	            marginBottom: "10px",
	            marginRight: "5px",
	            marginLeft: "5px",
	            padding: "2px"
	          }
	        }, this.getMobileDiv(this.props.data), ";");
	      }
	    }
	  }]);
	
	  return MyShopCard;
	}(_react.Component);
	
	exports.default = MyShopCard;

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	};
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _numeral = __webpack_require__(16);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var _reactLazyLoadImageComponent = __webpack_require__(30);
	
	__webpack_require__(67);
	
	__webpack_require__(244);
	
	var _reactLoadingSkeleton = __webpack_require__(124);
	
	var _reactLoadingSkeleton2 = _interopRequireDefault(_reactLoadingSkeleton);
	
	var _backupImage = __webpack_require__(149);
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof2(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var WorkerCard = function (_Component) {
	  _inherits(WorkerCard, _Component);
	
	  function WorkerCard() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, WorkerCard);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = WorkerCard.__proto__ || Object.getPrototypeOf(WorkerCard)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      0: false,
	      1: false
	    }, _this.getItems = function (currBucket) {
	      //console.log("here is currBucket: " + JSON.stringify(currBucket));
	      if (currBucket && currBucket.length > 0 && currBucket !== "" && (typeof currBucket === "undefined" ? "undefined" : _typeof(currBucket)) === "object") {
	        return currBucket.map(function (product, index) {
	          var _ref2;
	
	          return _react2.default.createElement("div", {
	            style: {
	              border: "1px solid white",
	              margin: "0px",
	              fontSize: "10px"
	            }
	          }, _react2.default.createElement("div", {
	            style: {
	              display: "flex",
	              minHeight: "70px",
	              alignItems: "center"
	            }
	          }, _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, {
	            src: product.photos && product.photos.length > 0 ? product.photos[0].url : _backupImage.backupImage,
	            style: {
	              maxWidth: "50px",
	              maxHeight: "50px",
	              height: _this.state[0] ? "50px" : "0px",
	              width: _this.state[0] ? "50px" : "0px",
	              borderRadius: "50px",
	              border: _this.state[0] ? "1px solid gainsboro" : "0px",
	              objectFit: "contain",
	              margin: _this.state[0] ? "5px" : "0px",
	              minWidth: _this.state[0] ? "50px" : null
	            },
	            afterLoad: function afterLoad() {
	              _this.setState(function (prevState) {
	                return _extends({}, prevState, _defineProperty({}, 0, true));
	              });
	            },
	            onError: function onError() {
	              var probElem = document.getElementById("img" + _this.props.rec.key + index);
	              if (probElem && probElem !== undefined) {
	                probElem.src = _backupImage.backupImage;
	              }
	            },
	            id: "img" + _this.props.rec.key + index
	          }), !_this.state[0] && _react2.default.createElement(_reactLoadingSkeleton2.default, {
	            style: (_ref2 = {
	              height: "50px",
	              width: "50px",
	              borderRadius: "50px",
	              border: "1px solid gainsboro"
	            }, _defineProperty(_ref2, "border", "0px solid gainsboro"), _defineProperty(_ref2, "margin", "5px"), _ref2),
	            duration: 1
	          }), _react2.default.createElement("div", {
	            style: {
	              width: "100%",
	              display: "flex"
	            }
	          }, _react2.default.createElement("table", {
	            className: "table table-lg",
	            style: {
	              margin: "auto"
	            }
	          }, _react2.default.createElement("tr", null, _react2.default.createElement("td", null, product.productNameEnglish), _react2.default.createElement("td", null, _react2.default.createElement("div", {
	            style: {
	              fontSize: "12px",
	              textAlign: "right",
	              margin: "3px"
	            }
	          }, "$", product.amount))), _react2.default.createElement("tr", null, _react2.default.createElement("td", null, product.unit), _react2.default.createElement("td", null)), _react2.default.createElement("tr", null, _react2.default.createElement("td", null, product.quantity, " x ", product.productPrice), _react2.default.createElement("td", null))))), _react2.default.createElement("hr", { style: { margin: "0px" } }));
	        });
	      }
	    }, _this.itemUpdateHandler = function (rowNum, newVal, recKey) {
	      // console.log(
	      //   "rowNum: " + rowNum + " recKey: " + recKey + " newVal: " + newVal
	      // );
	
	      var tmpData = _.cloneDeep(_this.props.data);
	      //console.log("Before: " + JSON.stringify(tmpData[rowNum]));
	      if (rowNum !== undefined && isNumber(rowNum)) {
	        tmpData["requestedItems"][rowNum][recKey] = newVal;
	        var newAmt = tmpData["requestedItems"][rowNum]["quantity"] * tmpData["requestedItems"][rowNum]["productPrice"];
	        //console.log(newAmt);
	        newAmt = newAmt.toFixed(2);
	        //console.log(newAmt);
	        tmpData["requestedItems"][rowNum]["amount"] = "" + newAmt + "";
	        //console.log("After: " + JSON.stringify(tmpData[rowNum]));
	      } else {
	        tmpData[recKey] = newVal;
	      }
	
	      _this.props.updateRecord({ path: _this.props.tableName, payload: tmpData });
	    }, _this.saveHandler = function () {
	      if (_this.state.message && _this.state.message.msgText && _this.state.message.msgText.length > 0) {
	        var data = _.cloneDeep(_this.props.rec);
	        if (data.messages && data.messages.length > 0) {
	          data.messages.push(_this.state.message);
	        } else {
	          data["messages"] = [];
	          data.messages.push(_this.state.message);
	        }
	        if (data && data.key && data.key !== "") {
	          var cloudPath = _this.props.path + "/" + data.key;
	
	          _this.props.firebase.db.ref("/" + cloudPath).once("value").then(function (snap) {
	            snap.ref.set(data);
	            //send only to supplier
	            _this.props.onNotifyUsers(data.name + " says: " + _this.refs.searchText.value, _this.props.allSuppliers, false);
	
	            _this.refs.searchText.value = "";
	            return "";
	          }).catch(function (err) {
	            console.log(err);
	            alert("Message could not be sent. " + err);
	            return "";
	          }).then(function (err) {});
	
	          _this.props.firebase.db.ref("/myOrders" + "/" + data.mobile + "/" + data.key).once("value").then(function (snap) {
	            return snap.ref.set(data);
	          }).catch(function (err) {
	            console.log(err);
	            alert("Order could not be compeleted. " + err);
	            return "";
	          }).then(function (err) {
	            _this.stateChangeHandler(false, "editMode", false);
	          });
	        }
	      }
	    }, _this.getBasicRow = function (label, value) {
	      return _react2.default.createElement("div", null, _react2.default.createElement("div", {
	        style: {
	          display: "flex",
	          flexDirection: "row",
	          marginLeft: "5px",
	          marginRight: "5px",
	          padding: "5px",
	          fontSize: "14px"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          width: "50%",
	          textAlign: "left"
	        }
	      }, label), _react2.default.createElement("div", {
	        style: {
	          width: "50%",
	          textAlign: "right"
	        }
	      }, value)), _react2.default.createElement("hr", {
	        style: {
	          margin: "0px"
	        }
	      }));
	    }, _this.getMessages = function () {
	      var msgs = _this.props.rec.messages;
	      if (msgs && msgs.length > 0) {
	        return msgs.map(function (msg) {
	          var fromMe = _this.props.phoneNumber === msg.author ? "from-me" : "";
	
	          return _react2.default.createElement("div", { className: "message " + fromMe }, _react2.default.createElement("div", { className: "username" }, msg.author), _react2.default.createElement("div", { className: "message-body" }, msg.msgText));
	        });
	      }
	    }, _this.getCard = function (rec) {
	      var _ref3, _ref4;
	
	      //console.log("in worker card: " + JSON.stringify(rec));
	      return _react2.default.createElement("div", {
	        style: {
	          borderRadius: "10px",
	          backgroundColor: "white",
	          margin: "5px",
	          padding: "10px",
	          marginBottom: "15px",
	          fontSize: "12px",
	          fontWeight: "bold"
	        }
	      }, (rec.status === "DELIVERED" || rec.status === "CANCELLED") && _react2.default.createElement("div", {
	        style: (_ref3 = {
	          color: "#333",
	          fontSize: "14px",
	          backgroundColor: "rgb(30, 101, 144)",
	          padding: "5px",
	          borderRadius: "5px"
	        }, _defineProperty(_ref3, "fontSize", "18px"), _defineProperty(_ref3, "color", "white"), _ref3),
	        onClick: function onClick() {
	          if (rec.status === "DELIVERED" || rec.status !== "CANCELLED") {
	            _this.props.repeatOrder(rec);
	          }
	        }
	      }, _react2.default.createElement("div", { style: { textAlign: "center" } }, "ORDER SAME ITEMS AGAIN ")), rec.status !== "DELIVERED" && rec.status !== "" && rec.status !== "IN PROGRESS" && rec.status !== "CANCELLED" && _react2.default.createElement("div", {
	        style: (_ref4 = {
	          color: "#333",
	          fontSize: "14px",
	          backgroundColor: "rgb(30, 101, 144)",
	          padding: "5px",
	          borderRadius: "5px"
	        }, _defineProperty(_ref4, "fontSize", "18px"), _defineProperty(_ref4, "color", "white"), _ref4),
	        onClick: function onClick() {
	          if (rec.status !== "DELIVERED" && rec.status !== "" && rec.status !== "IN PROGRESS" && rec.status !== "CANCELLED") {
	            _this.props.handleEdit(rec.key, _this.props.tableName, rec);
	          }
	        }
	      }, rec.status !== "DELIVERED" && rec.status !== "" && rec.status !== "IN PROGRESS" && rec.status !== "CANCELLED" && _react2.default.createElement("div", { style: { textAlign: "center" } }, "EDIT ORDER")), _react2.default.createElement("div", {
	        style: {
	          paddingTop: "5px",
	          paddingBottom: "5px"
	        }
	      }, rec.status !== "DELIVERED" && rec.status !== "" && rec.status !== "CANCELLED" && _react2.default.createElement("div", null, "Your delivery is getting ready and we will be in contact with you shortly. Please contact us at 94562455 for any urgent requests."), rec.status && rec.status === "DELIVERED" && _react2.default.createElement("div", null, "This order has been marked as DELIVERED by ", rec.supplier, ". For any feedback or complaints please contact us at Cell# 94562455. We hope you liked this service."), rec.status && rec.status === "CANCELLED" && _react2.default.createElement("div", null, "You have cancelled this order. ")), _react2.default.createElement("hr", {
	        style: {
	          margin: "0px"
	        }
	      }), _react2.default.createElement("div", {
	        style: {
	          borderRadius: "5px",
	          color: "black",
	          backgroundColor: "white",
	          fontSize: "18px",
	          border: "0px solid rgb(30, 101, 144)",
	          cursor: "pointer",
	          fontWeight: "bold",
	          height: "40px",
	          lineHeight: "40px",
	          textAlign: "center",
	          margin: "5px",
	          display: "flex"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          width: "50%",
	          textAlign: "left"
	        }
	      }, _react2.default.createElement("span", { style: { fontSize: "10px" } }, "Items: "), " ", rec.requestedItems && rec.requestedItems.length > 0 ? rec.requestedItems.length : 0, " "), _react2.default.createElement("div", {
	        style: {
	          width: "50%",
	          textAlign: "right"
	        }
	      }, _react2.default.createElement("span", { style: { fontSize: "10px", marginLeft: "10px" } }, "SGD: "), " ", rec.orderTotal)), _react2.default.createElement("hr", {
	        style: {
	          margin: "0px"
	        }
	      }), rec.messages && rec.messages.length > 0 && _react2.default.createElement("div", {
	        style: {
	          minHeight: "40px",
	          padding: "5px"
	        }
	      }, _this.getMessages()), rec.messages && rec.messages.length > 0 && _react2.default.createElement("hr", {
	        style: {
	          margin: "0px"
	        }
	      }), _react2.default.createElement("div", {
	        style: {
	          display: "flex",
	          direction: "row"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          width: "100%"
	        }
	      }, _react2.default.createElement("textarea", {
	        type: "text",
	        placeholder: "Enter your message",
	        ref: "searchText",
	        onKeyUp: function onKeyUp(e) {
	          var msgTime = (0, _moment2.default)().format("h:mma DD-MM").toLocaleString();
	          _this.setState({
	            message: {
	              msgTime: msgTime,
	              author: _this.props.phoneNumber,
	              msgText: e.target.value
	            }
	          });
	        },
	        style: _defineProperty({
	          height: "35px",
	          borderRadius: "5px",
	          width: "100%",
	          border: "0px",
	          padding: "5px",
	          margin: "5px"
	        }, "border", "1px solid gainsboro"),
	        rows: 3
	      })), _react2.default.createElement("div", {
	        onClick: _this.saveHandler,
	        style: {
	          width: "60px",
	          margin: "2px",
	          textAlign: "center",
	          height: "35px",
	          /* background-color: blue; */
	          lineHeight: "35px",
	          border: "1px solid white",
	          marginTop: "5px",
	          marginBottom: "5px",
	          marginLeft: "10px",
	          backgroundColor: "rgb(30, 101, 144)",
	          color: "white"
	        }
	      }, "Send")), _react2.default.createElement("hr", {
	        style: {
	          margin: "0px"
	        }
	      }), _this.getBasicRow("Status", rec.status), _this.getBasicRow("Order Date", rec.deliveryDate + " " + (rec.orderTime && rec.orderTime !== "" ? rec.orderTime : ""), "deliveryDate"), _this.getBasicRow("Target Delivery Date", rec.targetDeliveryDate ? rec.targetDeliveryDate : "-", "targetDeliveryDate"), _this.getBasicRow("Name", rec.name), _this.getBasicRow("Phone", rec.mobile), _this.getBasicRow("Address", rec.address), _this.getBasicRow("Other Items", rec.otherItems), _react2.default.createElement("hr", {
	        style: {
	          margin: "0px"
	        }
	      }), _react2.default.createElement("div", null, rec.requestedItems && rec.requestedItems.length > 0 && _this.getItems(rec.requestedItems)));
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(WorkerCard, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement("div", null, this.getCard(this.props.rec));
	    }
	  }]);
	
	  return WorkerCard;
	}(_react.Component);
	
	exports.default = WorkerCard;

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _recompose = __webpack_require__(11);
	
	var _Firebase = __webpack_require__(10);
	
	var _reactDeviceDetect = __webpack_require__(6);
	
	var _getInputField = __webpack_require__(18);
	
	var _getInputField2 = _interopRequireDefault(_getInputField);
	
	var _lodash = __webpack_require__(22);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _addAudits = __webpack_require__(25);
	
	var _MenuColumns = __webpack_require__(297);
	
	var _MenuColumns2 = _interopRequireDefault(_MenuColumns);
	
	var _reactackle = __webpack_require__(5);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	// {
	//   name: "",
	//   fields: [],
	//   menuItems: [],
	//   searchColumns: [],
	//   ...this.props.selectedRecord
	// }
	
	// {
	//   name: "TEST MENU",
	//   fields: [],
	//   menuItems: [
	//     {
	//       menuCaption: "table1",
	//       tableCaption: "caption1",
	//       tableName: "testTable",
	//       recLimit: 3000,
	//       mobileRecLimit: 4000,
	//       dataConditions: [
	//         { fieldName: "Afld1", fieldVal: "Aval1" },
	//         { fieldName: "Afld2", fieldVal: "Aval2" }
	//       ]
	//     },
	//     {
	//       menuCaption: "table2",
	//       tableCaption: "caption2",
	//       tableName: "testTable2",
	//       recLimit: 2000,
	//       mobileRecLimit: 2000,
	//       dataConditions: [
	//         { fieldName: "Bfld1", fieldVal: "Bval1" },
	//         { fieldName: "Bfld2", fieldVal: "Bval2" }
	//       ]
	//     }
	//   ],
	//   searchColumns: []
	// }
	
	var CreateMenu = function (_Component) {
	  _inherits(CreateMenu, _Component);
	
	  function CreateMenu() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CreateMenu);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CreateMenu.__proto__ || Object.getPrototypeOf(CreateMenu)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      data: {
	        path: _this.props.path,
	        payload: _extends({
	          name: "",
	          fields: [],
	          menuItems: [],
	          searchColumns: []
	        }, _this.props.selectedRecord),
	        userEmail: _this.props.userProfile.userEmail
	      },
	      showForm: true,
	      generatingStatement: false,
	      statementLink: ""
	    }, _this.stateChangeHandler = function (val, id, isPayload) {
	      // console.log(
	      //   "val: " + JSON.stringify(val) + " id: " + id + " isPayload: " + isPayload
	      // );
	      var tmpState = {};
	      tmpState[id] = val;
	
	      if (isPayload) {
	        _this.setState(function (prevState) {
	          if (prevState && prevState.data.payload !== null) {
	            return _extends({}, prevState, {
	              data: _extends({}, prevState.data, {
	                payload: _extends({}, prevState.data.payload, tmpState)
	              })
	            });
	          } else {
	            return _extends({}, prevState, {
	              data: {
	                path: prevState.data.path,
	                payload: _extends({}, tmpState)
	              }
	            });
	          }
	        });
	      } else {
	        _this.setState(function (prevState) {
	          return _extends({}, prevState, tmpState);
	        });
	      }
	    }, _this.saveHandler = function (saveAs) {
	      _this.stateChangeHandler(_this.props.userEmail, "author", true);
	      _this.stateChangeHandler(false, "showForm", false);
	
	      var myDate = (0, _moment2.default)().format("DD-MM-YYYY");
	
	      var cloudPath = "";
	      if (_this.state.data.payload && _this.state.data.payload.key && _this.state.data.payload.key !== "" && !saveAs) {
	        cloudPath = _this.props.path + "/" + _this.state.data.payload.key;
	        Promise.all([(0, _addAudits.addAudit)(_this.stateChangeHandler, _this.props.userEmail), _this.stateChangeHandler(_this.getFormattedMenuRec(), "readyMenus", true)]).then(function (res) {
	          // console.log("UPDATE RECORD: " + cloudPath);
	          // console.log("Here is the path: " + cloudPath);
	          // console.log(
	          //   "Here is the payload: " + JSON.stringify(this.state.data.payload)
	          // );
	          _this.props.firebase.db.ref("/" + cloudPath).once("value").then(function (snap) {
	            // console.log(
	            //   "Before ret set payload: " +
	            //     JSON.stringify(this.state.data.payload)
	            // );
	            return snap.ref.set(_this.state.data.payload);
	          }).catch(function (err) {
	            console.log(err);
	            return "some error: " + err;
	          }).then(function (err) {
	            //console.log("rec pushed");
	            _this.props.handleEditCancel();
	          });
	        });
	      } else {
	        // console.log(
	        //   "Here is the payload: " + JSON.stringify(this.state.data.payload)
	        // );
	        cloudPath = _this.props.path;
	        Promise.all([(0, _addAudits.addAudit)(_this.stateChangeHandler, _this.props.userEmail), _this.stateChangeHandler(_this.getFormattedMenuRec(), "readyMenus", true)]).then(function (res) {
	          var newInv = _this.props.firebase.db.ref("/" + cloudPath).push();
	          // console.log(
	          //   "Before ret set payload: " + JSON.stringify(this.state.data.payload)
	          // );
	          newInv.set(_this.state.data.payload).catch(function (err) {
	            // console.log(err);
	            return "some error: " + err;
	          }).then(function (err) {
	            //console.log("rec pushed");
	            _this.props.handleEditCancel();
	          });
	        });
	      }
	
	      //this.props.handleEditCancel();
	    }, _this.getField = function (fieldName, disabled) {
	      return (0, _getInputField2.default)(fieldName, "menuDesigner", _this.state.data, _this.stateChangeHandler, disabled, _this.props.ogTableDef);
	    }, _this.itemHandler = function (fldName, val, rowNum) {
	      var newArray = _lodash2.default.cloneDeep(_this.state.data.payload.fields);
	      var currPayload = newArray[rowNum];
	      currPayload[fldName] = val;
	      _this.stateChangeHandler(newArray, "fields", true);
	    }, _this.itemAddHandler = function (rowNum) {
	      //console.log("fromRow: " + fromRow + " updated: " + JSON.stringify(updated));
	      var tmpData = _lodash2.default.cloneDeep(_this.state.data.payload.fields);
	      //console.log("Before: " + JSON.stringify(tmpData));
	      tmpData.splice(rowNum + 1, 0, {
	        type: "",
	        selectorType: "",
	        staticSource: [{ name: "" }],
	        colDefs: [{
	          name: "",
	          key: "",
	          editable: true,
	          resizable: true
	        }]
	      });
	
	      //console.log("After: " + JSON.stringify(tmpData));
	      _this.stateChangeHandler(tmpData, "fields", true);
	    }, _this.itemDeleteHandler = function (rowNum) {
	      //console.log("fromRow: " + fromRow + " updated: " + JSON.stringify(updated));
	      var tmpData = JSON.parse(JSON.stringify(_this.state.data.payload.fields));
	      //console.log("Before: " + JSON.stringify(tmpData));
	      delete tmpData[rowNum];
	
	      tmpData = tmpData.filter(function (item) {
	        return item !== null;
	      });
	      //console.log("at filter:" + JSON.stringify(currActionsList));
	
	      _this.stateChangeHandler(tmpData, "fields", true);
	    }, _this.getFullMenuItems = function (menuCaption) {
	      //console.log(menuCaption);
	      var tmpObj = _this.props.listOfTables.find(function (singleTable) {
	        //console.log(JSON.stringify(singleTable));
	        return singleTable.menu === menuCaption;
	      });
	      //console.log("returning: " + JSON.stringify(tmpObj));
	      return tmpObj;
	    }, _this.getFormattedMenuRec = function () {
	      var fmtMenu = {};
	      if (_this.state.data.payload.menuItems && _this.state.data.payload.menuItems.length > 0) {
	        for (var i = 0; i < _this.state.data.payload.menuItems.length; i++) {
	          var fullDets = _this.getFullMenuItems(_this.state.data.payload.menuItems[i]);
	          if (fullDets && fullDets !== undefined) {
	            fmtMenu[fullDets.name] = {
	              caption: fullDets.menu,
	              tableName: fullDets.tableName && fullDets.tableName !== undefined ? fullDets.tableName : ""
	            };
	          }
	        }
	      }
	      return fmtMenu;
	    }, _this.tableSelectionHandler = function (val, arrIndex) {
	      //console.log(arrIndex + ". val: " + JSON.stringify(val));
	      var currDashFields = _lodash2.default.cloneDeep(_this.state.data.payload.menuItems);
	      var fullTableObj = _this.getFullMenuItems(val);
	      currDashFields[arrIndex] = {
	        menuCaption: val,
	        tableName: fullTableObj["name"] && fullTableObj["name"] !== undefined ? fullTableObj["name"] : "",
	        tableCaption: fullTableObj["caption"] && fullTableObj["caption"] !== undefined ? fullTableObj["caption"] : "",
	        recLimit: "",
	        mobileRecLimit: "",
	        dataConditions: []
	      };
	      //console.log(JSON.stringify(currDashFields));
	
	      _this.stateChangeHandler(currDashFields, "menuItems", true);
	    }, _this.limitHandler = function (val, fldName, arrIndex) {
	      var currDashFields = _lodash2.default.cloneDeep(_this.state.data.payload.menuItems);
	      currDashFields[arrIndex] = _extends({}, currDashFields[arrIndex], _defineProperty({}, fldName, val));
	      _this.stateChangeHandler(currDashFields, "menuItems", true);
	    }, _this.searchColumnsAddHandler = function (val, id, isPayload) {
	      //console.log("val: " + val + " id:" + id + " isPayload: " + isPayload);
	
	      var currSearchFields = _lodash2.default.cloneDeep(_this.state.data.payload.searchColumns);
	      currSearchFields.push(val);
	      _this.stateChangeHandler(currSearchFields, "searchColumns", true);
	    }, _this.getCreateMenuForm = function () {
	      return _react2.default.createElement("div", null, _this.getField("name", false), _react2.default.createElement(_MenuColumns2.default, {
	        fieldsList: _this.props.listOfTables
	        // fieldsList={[
	        //   { name: "testTable", menu: "TEST TABLE", caption: "TEST TABLE" }
	        // ]}
	        , stateFieldName: "menuItems",
	        value: _this.state.data.payload.menuItems,
	        tableSelectionHandler: _this.tableSelectionHandler,
	        itemHandler: _this.dashColumnsAddHandler,
	        stateChangeHandler: _this.stateChangeHandler,
	        isPayload: true,
	        title: "MENU LIST",
	        limitHandler: _this.limitHandler,
	        tableList: _this.props.listOfTables,
	        createTableList: _this.props.createTable
	        // otherFields={[
	        //   { src: "name", tgt: "name" },
	        //   { src: "tableName", tgt: "tableName" }
	        // ]}
	      }));
	    }, _this.getLoader = function () {
	      return _react2.default.createElement(_reactackle.CardContent, null, _react2.default.createElement(_reactackle.CircleProgress, {
	        indeterminate: true,
	        subtitle: "Saving...",
	        labelPositionY: "bottom",
	        labelPositionX: "center"
	      }));
	    }, _this.getTopHeader = function () {
	      return _react2.default.createElement("div", null, _react2.default.createElement(_reactackle.Card, null, _react2.default.createElement(_reactackle.CardAreaMain, null, !_reactDeviceDetect.isMobile && _react2.default.createElement(_reactackle.CardContent, null, _react2.default.createElement("div", null, _react2.default.createElement("h1", null, "CREATE MENU"))), _react2.default.createElement(_reactackle.CardActions, null, _react2.default.createElement(_reactackle.CardActionsSupplemental, null, _this.props.operationType !== "add" && _react2.default.createElement(_reactackle.Button, {
	        text: "DELETE",
	        onPress: function onPress(e) {
	          if (_this.state.data.payload.key && _this.state.data.payload.key !== "") {
	            window.confirm("Are you sure you wish to delete this item?") && _this.props.handleDelete(_this.state.data.payload.key, _this.props.path);
	          }
	        },
	        colorScheme: "warning",
	        disabled: !_this.state.showForm
	      }), _react2.default.createElement(_reactackle.Button, {
	        text: "SAVE",
	        onPress: function onPress() {
	          return _this.saveHandler(false);
	        },
	        colorScheme: "primary",
	        disabled: !_this.state.showForm
	      }), _react2.default.createElement(_reactackle.Button, {
	        text: "SAVE AS NEW",
	        onPress: function onPress(e) {
	          if (_this.state.data.payload.key && _this.state.data.payload.key !== "") {
	            window.confirm("Are you sure you wish to creat a new copy of this item?") && _this.saveHandler(true);
	          }
	        },
	        colorScheme: "primary",
	        disabled: !_this.state.showForm
	      }), _react2.default.createElement(_reactackle.Button, {
	        text: "CANCEL",
	        onPress: function onPress() {
	          return _this.props.handleEditCancel();
	        },
	        colorScheme: "primary",
	        disabled: !_this.state.showForm
	      }))))));
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  //single method that work for all fields
	  //takes incoming id of the field and then adds field data to state
	
	
	  _createClass(CreateMenu, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement("div", null, _react2.default.createElement("div", null, this.getTopHeader()), _reactDeviceDetect.isMobile && _react2.default.createElement("div", null, this.state.showForm && this.getCreateMenuForm(), !this.state.showForm && this.getLoader()), !_reactDeviceDetect.isMobile && _react2.default.createElement(_reactackle.Card, null, _react2.default.createElement(_reactackle.CardAreaMain, { style: { padding: "0px" } }, _react2.default.createElement(_reactackle.CardContent, { style: { pading: "0px" } }, this.state.showForm && this.getCreateMenuForm(), !this.state.showForm && this.getLoader()))));
	    }
	  }]);
	
	  return CreateMenu;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    userEmail: state.db.currentUser.userEmail,
	    currUser: state.db.currentUser,
	    isSuperAdmin: state.ui.isThisSuperAdmin,
	    isAdmin: state.ui.isThisAdmin,
	    userProfile: state.db.userProfile,
	    selectedRecord: state.db["selected" + state.ui.tableName],
	    users: state.db.users,
	    projects: state.db.projects,
	    contacts: state.db.contacts,
	    suppliers: state.db.suppliers,
	    poId: state.db.poId,
	    operationType: state.ui.operationType,
	    tableList: state.db.tableList === undefined ? [] : state.db.tableList,
	    listOfTables: state.db.listOfTables,
	    createTable: state.db.createTable
	  };
	}
	
	exports.default = (0, _recompose.compose)((0, _reactRedux.connect)(mapStateToProps, null), _Firebase.withFirebase)(CreateMenu);

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _recompose = __webpack_require__(11);
	
	var _Firebase = __webpack_require__(10);
	
	var _reactDeviceDetect = __webpack_require__(6);
	
	var _getInputField = __webpack_require__(18);
	
	var _getInputField2 = _interopRequireDefault(_getInputField);
	
	var _lodash = __webpack_require__(22);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _Feild = __webpack_require__(292);
	
	var _Feild2 = _interopRequireDefault(_Feild);
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _addAudits = __webpack_require__(25);
	
	var _DashColumns = __webpack_require__(296);
	
	var _DashColumns2 = _interopRequireDefault(_DashColumns);
	
	var _reactackle = __webpack_require__(5);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var CreateTable = function (_Component) {
	  _inherits(CreateTable, _Component);
	
	  function CreateTable() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CreateTable);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CreateTable.__proto__ || Object.getPrototypeOf(CreateTable)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      data: {
	        path: _this.props.path,
	        payload: _extends({
	          name: "",
	          fields: [],
	          dashColumns: [],
	          searchColumns: [],
	          filters: [],
	          notifyUsers: [],
	          otherFieldsToUpdate: [],
	          updateNotifyText: "",
	          createNotifyText: "",
	          deleteNotifyText: ""
	        }, _this.props.selectedRecord),
	        userEmail: _this.props.userProfile.userEmail
	      },
	      showForm: true,
	      generatingStatement: false,
	      statementLink: ""
	    }, _this.stateChangeHandler = function (val, id, isPayload) {
	      // console.log(
	      //   "val: " + JSON.stringify(val) + " id: " + id + " isPayload: " + isPayload
	      // );
	      var tmpState = {};
	      tmpState[id] = val;
	
	      if (isPayload) {
	        _this.setState(function (prevState) {
	          if (prevState && prevState.data.payload !== null) {
	            return _extends({}, prevState, {
	              data: _extends({}, prevState.data, {
	                payload: _extends({}, prevState.data.payload, tmpState)
	              })
	            });
	          } else {
	            return _extends({}, prevState, {
	              data: {
	                path: prevState.data.path,
	                payload: _extends({}, tmpState)
	              }
	            });
	          }
	        });
	      } else {
	        _this.setState(function (prevState) {
	          return _extends({}, prevState, tmpState);
	        });
	      }
	    }, _this.saveHandler = function (newPayload) {
	      _this.stateChangeHandler(_this.props.userEmail, "author", true);
	      _this.stateChangeHandler(false, "showForm", false);
	
	      var myDate = (0, _moment2.default)().format("DD-MM-YYYY");
	
	      var cloudPath = "";
	      if (_this.state.data.payload && _this.state.data.payload.key && _this.state.data.payload.key !== "") {
	        cloudPath = _this.props.path + "/" + _this.state.data.payload.key;
	        Promise.all([(0, _addAudits.addAudit)(_this.stateChangeHandler, _this.props.userEmail)]).then(function (res) {
	          // console.log("UPDATE RECORD: " + cloudPath);
	          // console.log("Here is the path: " + cloudPath);
	          //console.log(JSON.stringify(this.state.data.payload));
	          _this.props.firebase.db.ref("/" + cloudPath).once("value").then(function (snap) {
	            return snap.ref.set(_this.state.data.payload);
	          }).catch(function (err) {
	            console.log(err);
	            return "some error: " + err;
	          }).then(function (err) {
	            return _this.props.handleEditCancel();
	          });
	        });
	      } else {
	        cloudPath = _this.props.path;
	        Promise.all([(0, _addAudits.addAudit)(_this.stateChangeHandler, _this.props.userEmail)
	        //get new ID
	        ]).then(function (res) {
	          var newInv = _this.props.firebase.db.ref("/" + cloudPath).push();
	          var tgtObj = {};
	          if (newPayload && newPayload !== undefined) {
	            tgtObj = newPayload;
	          }
	          //console.log(JSON.stringify(tgtObj));
	          newInv.set(tgtObj).catch(function (err) {
	            // console.log(err);
	            return "some error: " + err;
	          }).then(function (err) {
	            return _this.props.handleEditCancel();
	          });
	        });
	      }
	
	      //this.props.handleEditCancel();
	    }, _this.addToTablesList = function () {
	      //path tableList
	
	      var tableName = _this.state.data.payload.name;
	      var caption = _this.state.data.payload.caption;
	      var menu = _this.state.data.payload.menu;
	
	      var currTableList = _lodash2.default.cloneDeep(_this.props.tableList);
	      var found = false;
	      var foundKey = "";
	      var foundObj = {};
	      if (currTableList && currTableList.length > 0) {
	        for (var i = 0; i < currTableList.length; i++) {
	          if (currTableList[i]["name"] === tableName) {
	            found = true;
	            foundKey = currTableList[i].key;
	            foundObj = _extends({}, currTableList[i], {
	              name: tableName,
	              caption: caption,
	              menu: menu
	            });
	          }
	        }
	      }
	      var cloudPath = "listOfTables";
	      if (!found) {
	        var newInv = _this.props.firebase.db.ref("/" + cloudPath).push();
	        newInv.set({
	          name: tableName,
	          caption: caption,
	          menu: menu
	        }).catch(function (err) {
	          console.log(err);
	          return console.log("some error: " + err);
	        }).then(function (err) {});
	      } else {
	        _this.props.firebase.db.ref("/" + cloudPath + "/" + foundKey).once("value").then(function (snap) {
	          return snap.ref.set(foundObj);
	        }).catch(function (err) {
	          console.log(err);
	          return "some error: " + err;
	        }).then(function (err) {});
	      }
	    }, _this.publishHandler = function () {
	      //this should update
	      // A. List of tables? do i really need to update that? Yes ||DONE||
	      // C. Dashboard Fields ||ADDED TO FILE||
	      // D. Search Fields ||ADDED TO FILE||
	      // D. Menu List -> should be its own module
	      // E. Roles? No - this should me another module
	      //console.log(this.state.data.payload.fullText);
	      console.log("publishing now...");
	      var newPayload = undefined;
	      if (_this.state.data.payload.fullText && _this.state.data.payload.fullText !== "") {
	        newPayload = JSON.parse(_this.state.data.payload.fullText);
	      }
	      if (newPayload && newPayload.tableName && newPayload.tableName !== "") {
	        //console.log("going with fullText");
	        _this.saveHandler(newPayload);
	      } else {
	        //console.log("going with non fullText");
	        Promise.all([_this.saveHandler(_this.state.data.payload), _this.addToTablesList()]).then(function (res) {});
	      }
	      _this.props.handleEditCancel();
	    }, _this.getField = function (fieldName, disabled) {
	      return (0, _getInputField2.default)(fieldName, "createTable", _this.state.data, _this.stateChangeHandler, disabled, _this.props.ogTableDef);
	    }, _this.addField = function () {
	      var currFields = _lodash2.default.cloneDeep(_this.state.data.payload.fields);
	      currFields.push({
	        type: "",
	        selectorType: "",
	        staticSource: [{ name: "" }],
	        isMust: "true",
	        enabled: "true",
	        colDefs: [{
	          name: "",
	          key: "",
	          editable: true,
	          resizable: true
	        }],
	        otherFieldsToUpdate: [{ src: "", tgt: "" }]
	      });
	      _this.stateChangeHandler(currFields, "fields", true);
	    }, _this.itemHandler = function (fldName, val, rowNum) {
	      var newArray = _lodash2.default.cloneDeep(_this.state.data.payload.fields);
	      var currPayload = newArray[rowNum];
	      currPayload[fldName] = val;
	      _this.stateChangeHandler(newArray, "fields", true);
	    }, _this.getFieldsList = function () {
	      return _this.state.data.payload.fields.map(function (fieldData, rowNum) {
	        //console.log(JSON.stringify(fieldData));
	        return _react2.default.createElement("div", null, _react2.default.createElement(_Feild2.default, {
	          data: { payload: fieldData },
	          itemHandler: _this.itemHandler,
	          rowNum: rowNum,
	          itemAddHandler: _this.itemAddHandler,
	          itemDeleteHandler: _this.itemDeleteHandler,
	          move: _this.move,
	          ogTableDef: _this.props.ogTableDef,
	          tableList: _this.props.tableList,
	          createTableList: _this.props.createTable,
	          tgtFieldsList: _this.getCurrentTableFields,
	          selectedGridFields: _this.getGridFields
	        }));
	      });
	    }, _this.getCurrentTableFields = function (keyField) {
	      //console.log("~~~~" + keyField);
	      if (_this.state.data.payload.fields && _this.state.data.payload.fields.length > 0) {
	        if (keyField && keyField === "name") {
	          return _this.state.data.payload.fields.map(function (fld) {
	            return { name: fld.name, fieldName: fld.name, fldType: fld.type };
	          });
	        } else {
	          return _this.state.data.payload.fields.map(function (fld) {
	            return { name: fld.caption, fieldName: fld.name, fldType: fld.type };
	          });
	        }
	      } else {
	        return [];
	      }
	    }, _this.getGridFields = function (gridName) {
	      if (_this.state.data.payload.fields && _this.state.data.payload.fields.length > 0) {
	        var selectedGrid = _this.state.data.payload.fields.find(function (fld) {
	          return fld.name === gridName;
	        });
	        if (selectedGrid && selectedGrid !== undefined && selectedGrid.colDefs && selectedGrid.colDefs.length > 0) {
	          return selectedGrid.colDefs.map(function (item) {
	            return { name: item.key, fieldName: item.key };
	          });
	        } else {
	          return [];
	        }
	      } else {
	        return [];
	      }
	    }, _this.move = function (oldIndex, newIndex) {
	      var array = _lodash2.default.cloneDeep(_this.state.data.payload.fields);
	      //console.log("before: " + JSON.stringify(array));
	      if (newIndex >= array.length) {
	        newIndex = array.length - 1;
	      }
	      array.splice(newIndex, 0, array.splice(oldIndex, 1)[0]);
	      //console.log("after: " + JSON.stringify(array));
	      _this.stateChangeHandler(array, "fields", true);
	    }, _this.itemAddHandler = function (rowNum) {
	      //console.log("fromRow: " + fromRow + " updated: " + JSON.stringify(updated));
	      var tmpData = _lodash2.default.cloneDeep(_this.state.data.payload.fields);
	      //console.log("Before: " + JSON.stringify(tmpData));
	      tmpData.splice(rowNum + 1, 0, {
	        type: "",
	        selectorType: "",
	        staticSource: [{ name: "" }],
	        colDefs: [{
	          name: "",
	          key: "",
	          editable: true,
	          resizable: true
	        }]
	      });
	
	      //console.log("After: " + JSON.stringify(tmpData));
	      _this.stateChangeHandler(tmpData, "fields", true);
	    }, _this.itemDeleteHandler = function (rowNum) {
	      var tmpData = _lodash2.default.cloneDeep(_this.state.data.payload.fields);
	      delete tmpData[rowNum];
	      tmpData = tmpData.filter(function (item) {
	        return item !== null;
	      });
	      _this.stateChangeHandler(tmpData, "fields", true);
	    }, _this.columnsAddHandler = function (fieldName, val) {
	      var currDashFields = _lodash2.default.cloneDeep(_this.state.data.payload[fieldName]);
	      currDashFields.push(val);
	      _this.stateChangeHandler(currDashFields, fieldName, true);
	    }, _this.dashColumnsAddHandler = function (val, id, isPayload) {
	      var currDashFields = _lodash2.default.cloneDeep(_this.state.data.payload.dashColumns);
	      currDashFields.push(val);
	      _this.stateChangeHandler(currDashFields, "dashColumns", true);
	    }, _this.searchColumnsAddHandler = function (val, id, isPayload) {
	      var currSearchFields = _lodash2.default.cloneDeep(_this.state.data.payload.searchColumns);
	      currSearchFields.push(val);
	      _this.stateChangeHandler(currSearchFields, "searchColumns", true);
	    }, _this.getUsersList = function () {
	      var newArray = _this.props.users.map(function (item) {
	        return {
	          name: item.userEmail
	        };
	      });
	      //console.log("~~~~" + JSON.stringify(newArray));
	      return newArray;
	    }, _this.getCreateTableForm = function () {
	      return _react2.default.createElement("div", null, _this.getField("name", _this.props.operationType === "update"), _this.getField("caption", false), _this.getField("menu", false), _react2.default.createElement(_DashColumns2.default, {
	        fieldsList: _this.state.data.payload.fields,
	        stateFieldName: "dashColumns",
	        value: _this.state.data.payload.dashColumns,
	        itemHandler: function itemHandler(val, id, isPayload) {
	          return _this.columnsAddHandler("dashColumns", val);
	        },
	        stateChangeHandler: _this.stateChangeHandler,
	        isPayload: true,
	        title: "GRID FIELDS"
	      }), _react2.default.createElement(_DashColumns2.default, {
	        fieldsList: _this.state.data.payload.fields,
	        stateFieldName: "searchColumns",
	        value: _this.state.data.payload.searchColumns,
	        itemHandler: function itemHandler(val, id, isPayload) {
	          return _this.columnsAddHandler("searchColumns", val);
	        },
	        stateChangeHandler: _this.stateChangeHandler,
	        isPayload: true,
	        title: "SEARCH FIELDS"
	      }), _react2.default.createElement(_DashColumns2.default, {
	        fieldsList: _this.state.data.payload.fields,
	        stateFieldName: "filters",
	        value: _this.state.data.payload.filters,
	        itemHandler: function itemHandler(val, id, isPayload) {
	          return _this.columnsAddHandler("filters", val);
	        },
	        stateChangeHandler: _this.stateChangeHandler,
	        isPayload: true,
	        title: "FILTERS"
	      }), _react2.default.createElement(_DashColumns2.default, {
	        fieldsList: _this.getUsersList(),
	        stateFieldName: "notifyUsers",
	        value: _this.state.data.payload.notifyUsers,
	        itemHandler: function itemHandler(val, id, isPayload) {
	          return _this.columnsAddHandler("notifyUsers", val);
	        },
	        stateChangeHandler: _this.stateChangeHandler,
	        isPayload: true,
	        title: "NOTIFICATION RECIPIENTS"
	      }), _this.getField("createNotifyText", false), _this.getField("updateNotifyText", false), _this.getField("deleteNotifyText", false), _react2.default.createElement("hr", null), _react2.default.createElement("div", {
	        style: {
	          padding: "5px",
	          marginBottom: "10px",
	          marginTop: "-5px",
	          border: "0px solid blue"
	        }
	      }, _react2.default.createElement("table", null, _react2.default.createElement("tr", null, _react2.default.createElement("td", null, _react2.default.createElement(_reactackle.Button, {
	        text: "ADD FORM FIELD",
	        onPress: function onPress() {
	          return _this.addField();
	        },
	        colorScheme: "primary",
	        disabled: !_this.state.showForm
	      })), _react2.default.createElement("td", null, _react2.default.createElement(_reactackle.Button, {
	        text: "EXPAND ALL",
	        onPress: function onPress() {
	          var newFieldsArray = _this.state.data.payload.fields.map(function (fld) {
	            return _extends({}, fld, {
	              expanded: true
	            });
	          });
	
	          _this.stateChangeHandler(newFieldsArray, "fields", true);
	        },
	        colorScheme: "primary",
	        disabled: !_this.state.showForm
	      })), _react2.default.createElement("td", null, _react2.default.createElement(_reactackle.Button, {
	        text: "COLLAPSE ALL",
	        onPress: function onPress() {
	          var newFieldsArray = _this.state.data.payload.fields.map(function (fld) {
	            return _extends({}, fld, {
	              expanded: false
	            });
	          });
	
	          _this.stateChangeHandler(newFieldsArray, "fields", true);
	        },
	        colorScheme: "primary",
	        disabled: !_this.state.showForm
	      }))))), _this.getFieldsList(), _react2.default.createElement("hr", null), _react2.default.createElement("div", null, _react2.default.createElement("pre", null, _react2.default.createElement("code", null, JSON.stringify(_this.state.data.payload, undefined, 2)))), _react2.default.createElement("hr", null), _react2.default.createElement("hr", null), _this.getField("fullText", false));
	    }, _this.getLoader = function () {
	      return _react2.default.createElement(_reactackle.CardContent, null, _react2.default.createElement(_reactackle.CircleProgress, {
	        indeterminate: true,
	        subtitle: "Saving...",
	        labelPositionY: "bottom",
	        labelPositionX: "center"
	      }));
	    }, _this.getTopHeader = function () {
	      return _react2.default.createElement("div", null, _react2.default.createElement(_reactackle.Card, null, _react2.default.createElement(_reactackle.CardAreaMain, null, !_reactDeviceDetect.isMobile && _react2.default.createElement(_reactackle.CardContent, null, _react2.default.createElement("div", null, _react2.default.createElement("h1", null, "CREATE TABLE"))), _react2.default.createElement(_reactackle.CardActions, null, _react2.default.createElement(_reactackle.CardActionsSupplemental, null, _this.props.operationType !== "add" && _react2.default.createElement(_reactackle.Button, {
	        text: "DELETE",
	        onPress: function onPress(e) {
	          if (_this.state.data.payload.key && _this.state.data.payload.key !== "") {
	            window.confirm("Are you sure you wish to delete this item?") && _this.props.handleDelete(_this.state.data.payload.key, _this.props.path);
	          }
	        },
	        colorScheme: "warning",
	        disabled: !_this.state.showForm
	      }), _react2.default.createElement(_reactackle.Button, {
	        text: "PUBLISH",
	        onPress: function onPress(e) {
	          _this.publishHandler();
	        },
	        colorScheme: "primary",
	        disabled: !_this.state.showForm
	      }), _react2.default.createElement(_reactackle.Button, {
	        text: "CANCEL",
	        onPress: function onPress() {
	          return _this.props.handleEditCancel();
	        },
	        colorScheme: "primary",
	        disabled: !_this.state.showForm
	      }))))));
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  //single method that work for all fields
	  //takes incoming id of the field and then adds field data to state
	
	
	  _createClass(CreateTable, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement("div", null, _react2.default.createElement("div", null, this.getTopHeader()), _reactDeviceDetect.isMobile && _react2.default.createElement("div", null, this.state.showForm && this.getCreateTableForm(), !this.state.showForm && this.getLoader()), !_reactDeviceDetect.isMobile && _react2.default.createElement(_reactackle.Card, null, _react2.default.createElement(_reactackle.CardAreaMain, { style: { padding: "0px" } }, _react2.default.createElement(_reactackle.CardContent, { style: { pading: "0px" } }, this.state.showForm && this.getCreateTableForm(), !this.state.showForm && this.getLoader()))));
	    }
	  }]);
	
	  return CreateTable;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    userEmail: state.db.currentUser.userEmail,
	    currUser: state.db.currentUser,
	    isSuperAdmin: state.ui.isThisSuperAdmin,
	    isAdmin: state.ui.isThisAdmin,
	    userProfile: state.db.userProfile,
	    selectedRecord: state.db["selected" + state.ui.tableName],
	    users: state.db.users,
	    projects: state.db.projects,
	    contacts: state.db.contacts,
	    suppliers: state.db.suppliers,
	    poId: state.db.poId,
	    operationType: state.ui.operationType,
	    tableList: state.db.listOfTables === undefined ? [] : state.db.listOfTables,
	    createTable: state.db.createTable
	  };
	}
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    onGetId: function onGetId(data) {
	      return dispatch(getId(data));
	    },
	    onGetPoStatement: function onGetPoStatement(data) {
	      return dispatch(getStatement(62673, data));
	    }
	  };
	};
	
	exports.default = (0, _recompose.compose)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _Firebase.withFirebase)(CreateTable);

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _getInputField = __webpack_require__(18);
	
	var _getInputField2 = _interopRequireDefault(_getInputField);
	
	var _SelectDropdown = __webpack_require__(106);
	
	var _SelectDropdown2 = _interopRequireDefault(_SelectDropdown);
	
	var _reactDeviceDetect = __webpack_require__(6);
	
	var _SimpleUniList = __webpack_require__(300);
	
	var _SimpleUniList2 = _interopRequireDefault(_SimpleUniList);
	
	var _SimpleFormulaList = __webpack_require__(299);
	
	var _SimpleFormulaList2 = _interopRequireDefault(_SimpleFormulaList);
	
	var _CompositeList = __webpack_require__(295);
	
	var _CompositeList2 = _interopRequireDefault(_CompositeList);
	
	var _CompositeDropDownList = __webpack_require__(293);
	
	var _CompositeDropDownList2 = _interopRequireDefault(_CompositeDropDownList);
	
	var _CompositeFilterList = __webpack_require__(294);
	
	var _CompositeFilterList2 = _interopRequireDefault(_CompositeFilterList);
	
	var _reactackleIcons = __webpack_require__(7);
	
	var _getTableFields = __webpack_require__(155);
	
	var _getTableFields2 = _interopRequireDefault(_getTableFields);
	
	var _reactackle = __webpack_require__(5);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var Field = function (_Component) {
	  _inherits(Field, _Component);
	
	  function Field(props) {
	    _classCallCheck(this, Field);
	
	    var _this = _possibleConstructorReturn(this, (Field.__proto__ || Object.getPrototypeOf(Field)).call(this, props));
	
	    _this.itemHandler = function (val, id, isPayload) {
	      //console.log(" id: " + id + " val:" + JSON.stringify(val));
	      _this.props.itemHandler(id, val, _this.props.rowNum);
	    };
	
	    _this.getField = function (fieldName, disabled) {
	      return (0, _getInputField2.default)(fieldName, "createFields", _this.props.data, _this.itemHandler, disabled, _this.props.ogTableDef);
	    };
	
	    _this.getStaticList = function (fieldName, disabled) {
	      return _react2.default.createElement("div", null, _react2.default.createElement("hr", null), _react2.default.createElement(_SimpleUniList2.default, {
	        stateChangeHandler: _this.itemHandler,
	        data: _this.props.data.payload[fieldName],
	        title: "LIST OF VALUES",
	        stateFieldName: fieldName,
	        fieldNameInArray: "name",
	        isPayload: true,
	        emptyRow: {
	          name: ""
	        },
	        emptyTitle: "Add Value"
	      }), _react2.default.createElement("hr", null));
	    };
	
	    _this.getFormulaList = function (fieldName, disabled) {
	      return _react2.default.createElement("div", null, _react2.default.createElement("hr", null), _react2.default.createElement(_SimpleFormulaList2.default, {
	        stateChangeHandler: _this.itemHandler,
	        data: _this.props.data.payload[fieldName],
	        title: "RULES",
	        stateFieldName: fieldName,
	        fieldNameInArray: "name",
	        isPayload: true,
	        emptyRow: {
	          name: ""
	        },
	        emptyTitle: "Add Rule"
	      }), _react2.default.createElement("hr", null));
	    };
	
	    _this.getCompositeList = function (fieldName, disabled) {
	      return _react2.default.createElement(_CompositeList2.default, {
	        stateChangeHandler: _this.itemHandler,
	        data: _this.props.data.payload[fieldName],
	        title: "FIELDS IN GRID",
	        stateFieldName: fieldName,
	        isPayload: true,
	        emptyRow: {
	          name: "",
	          key: "",
	          editable: true,
	          resizable: true
	        }
	      });
	    };
	
	    _this.getCompositeDropDownList = function (fieldName, title, emptyTitle, disabled) {
	      return _react2.default.createElement(_CompositeDropDownList2.default, {
	        stateChangeHandler: _this.itemHandler,
	        data: _this.props.data.payload[fieldName],
	        title: title,
	        emptyTitle: emptyTitle,
	        stateFieldName: fieldName,
	        isPayload: true,
	        emptyRow: {
	          src: "",
	          tgt: ""
	        },
	        srcTableFields: function srcTableFields() {
	          return _this.getListOfFields(_this.props.data.payload.table);
	        },
	        tgtTableFields: _this.props.tgtFieldsList
	      });
	    };
	
	    _this.getCompositeFilterList = function (fieldName, title, emptyTitle, disabled) {
	      return _react2.default.createElement(_CompositeFilterList2.default, {
	        stateChangeHandler: _this.itemHandler,
	        data: _this.props.data.payload[fieldName],
	        title: title,
	        emptyTitle: emptyTitle,
	        stateFieldName: fieldName,
	        isPayload: true,
	        emptyRow: {
	          src: "",
	          tgt: ""
	        },
	        srcTableFields: function srcTableFields() {
	          return _this.getListOfFields(_this.props.data.payload.table);
	        },
	        tgtTableFields: _this.props.tgtFieldsList
	      });
	    };
	
	    _this.getTableList = function (fieldName, isDisabled) {
	      return _react2.default.createElement(_SelectDropdown2.default, {
	        title: "SOURCE TABLE",
	        data: _this.props.tableList,
	        label: "SOURCE TABLE",
	        placeholder: "SOURCE TABLE",
	        value: _this.props.data.payload[fieldName],
	        stateFieldName: fieldName,
	        isPayload: true,
	        fieldName: "name",
	        stateHandler: _this.itemHandler
	      });
	    };
	
	    _this.getListOfGrids = function () {
	      var listOfFields = _this.props.tgtFieldsList("name");
	      if (listOfFields && listOfFields.length > 0) {
	        return listOfFields.filter(function (item) {
	          return item.fldType === "array";
	        });
	      } else {
	        return [];
	      }
	    };
	
	    _this.getSubGridsList = function (fieldName, isDisabled) {
	      return _react2.default.createElement(_SelectDropdown2.default, {
	        title: "SUB GRID NAME",
	        data: _this.getListOfGrids(),
	        label: "SUB GRID NAME",
	        placeholder: "",
	        value: _this.props.data.payload[fieldName],
	        stateFieldName: fieldName,
	        isPayload: true,
	        fieldName: "name",
	        stateHandler: _this.itemHandler
	      });
	    };
	
	    _this.getSelectedSubGridsFields = function (fieldName, selectedGrid) {
	      return _react2.default.createElement(_SelectDropdown2.default, {
	        title: "SUB GRID FIELD",
	        data: _this.props.selectedGridFields(selectedGrid),
	        label: "SUB GRID FIELD",
	        placeholder: "",
	        value: _this.props.data.payload[fieldName],
	        stateFieldName: fieldName,
	        isPayload: true,
	        fieldName: "name",
	        stateHandler: _this.itemHandler
	      });
	    };
	
	    _this.getListOfFields = function (tgtTable) {
	      //console.log(JSON.stringify(this.props.data));
	      //console.log(JSON.stringify(this.state.data.payload));
	      if (tgtTable) {
	        //console.log("checking now...");
	        return (0, _getTableFields2.default)(_this.props.createTableList, tgtTable);
	      }
	    };
	
	    _this.getTableFieldsList = function (fieldName, isDisabled) {
	      return _react2.default.createElement(_SelectDropdown2.default, {
	        title: "SOURCE FIELD",
	        data: _this.getListOfFields(_this.props.data.payload.table),
	        label: "SOURCE FIELD",
	        placeholder: "SOURCE FIELD",
	        value: _this.props.data.payload[fieldName],
	        stateFieldName: fieldName,
	        isPayload: true,
	        fieldName: "fieldName",
	        stateHandler: _this.itemHandler
	      });
	    };
	
	    _this.getTriggerFieldList = function (fieldName, isDisabled) {
	      return _react2.default.createElement(_SelectDropdown2.default, {
	        title: "TRIGGER FIELD",
	        data: _this.props.tgtFieldsList("name"),
	        label: "TRIGGER FIELD",
	        placeholder: "TRIGGER FIELD",
	        value: _this.props.data.payload[fieldName],
	        stateFieldName: fieldName,
	        isPayload: true,
	        fieldName: "fieldName",
	        stateHandler: _this.itemHandler
	      });
	    };
	
	    _this.getDelIcon = function (rowNum) {
	      return _react2.default.createElement("div", {
	        style: {
	          padding: "10px",
	          textAlign: "center",
	          border: "1px solid gainsboro",
	          height: "45px",
	          width: "45px"
	        }
	      }, _react2.default.createElement("a", {
	        onClick: function onClick() {
	          _this.props.itemDeleteHandler(rowNum);
	        }
	      }, _react2.default.createElement(_reactackleIcons.IconSvg, null, _react2.default.createElement("svg", { style: { width: "24px", height: "24px" }, viewBox: "0 0 24 24" }, _react2.default.createElement("path", {
	        fill: "currentColor",
	        d: "M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19M8,9H16V19H8V9M15.5,4L14.5,3H9.5L8.5,4H5V6H19V4H15.5Z"
	      })))));
	    };
	
	    _this.getUpIcon = function (rowNum) {
	      return _react2.default.createElement("div", {
	        className: "col-sm-2",
	        style: {
	          padding: "10px",
	          textAlign: "center",
	          border: "1px solid gainsboro",
	          height: "45px",
	          width: "45px"
	        }
	      }, _react2.default.createElement("a", {
	        onClick: function onClick() {
	          _this.props.move(rowNum, rowNum - 1);
	        }
	      }, _react2.default.createElement(_reactackleIcons.IconSvg, null, _react2.default.createElement("svg", { style: { width: "24px", height: "24px" }, viewBox: "0 0 24 24" }, _react2.default.createElement("path", {
	        fill: "currentColor",
	        d: "M16,13V21H8V13H2L12,3L22,13H16M7,11H10V19H14V11H17L12,6L7,11Z"
	      })))));
	    };
	
	    _this.getDownIcon = function (rowNum) {
	      return _react2.default.createElement("div", {
	        className: "col-sm-2",
	        style: {
	          padding: "10px",
	          textAlign: "center",
	          border: "1px solid gainsboro",
	          height: "45px",
	          width: "45px"
	        }
	      }, _react2.default.createElement("a", {
	        onClick: function onClick() {
	          _this.props.move(rowNum, rowNum + 1);
	        }
	      }, _react2.default.createElement(_reactackleIcons.IconSvg, null, _react2.default.createElement("svg", { style: { width: "24px", height: "24px" }, viewBox: "0 0 24 24" }, _react2.default.createElement("path", {
	        fill: "currentColor",
	        d: "M22,11L12,21L2,11H8V3H16V11H22M12,18L17,13H14V5H10V13H7L12,18Z"
	      })))));
	    };
	
	    _this.getAddStaticField = function (rowNum) {
	      return _react2.default.createElement("div", {
	        className: "col-sm-2",
	        style: {
	          padding: "10px",
	          textAlign: "center",
	          border: "1px solid gainsboro",
	          height: "45px",
	          width: "45px"
	        }
	      }, _react2.default.createElement("a", {
	        onClick: function onClick() {
	          _this.props.move(rowNum, rowNum + 1);
	        }
	      }, _react2.default.createElement("div", null, "Add to List of Values")));
	    };
	
	    _this.getPlusIcon = function (rowNum) {
	      return _react2.default.createElement("div", {
	        style: {
	          padding: "10px",
	          textAlign: "center",
	          border: "1px solid gainsboro",
	          height: "45px",
	          width: "45px"
	        }
	      }, _react2.default.createElement("a", {
	        href: "_",
	        onClick: function onClick(event) {
	          event.preventDefault();
	          _this.props.itemAddHandler(rowNum);
	        }
	      }, _react2.default.createElement(_reactackleIcons.IconSvg, null, _react2.default.createElement("svg", { style: { width: "24px", height: "24px" }, viewBox: "0 0 24 24" }, _react2.default.createElement("path", {
	        fill: "currentColor",
	        d: "M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z"
	      })))));
	    };
	
	    _this.getExpandIcon = function (rowNum) {
	      return _react2.default.createElement(_reactackle.Button, {
	        text: "EXPAND",
	        onPress: function onPress() {
	          event.preventDefault();
	          _this.props.itemHandler("expanded", true, rowNum);
	        },
	        colorScheme: "primary",
	        outlined: true
	      });
	    };
	
	    _this.getCollapseIcon = function (rowNum) {
	      return _react2.default.createElement(_reactackle.Button, {
	        text: "COLLAPSE",
	        onPress: function onPress() {
	          event.preventDefault();
	          _this.props.itemHandler("expanded", false, rowNum);
	        },
	        colorScheme: "primary",
	        outlined: true
	      });
	    };
	
	    _this.getActionRow = function () {
	      return _react2.default.createElement("div", {
	        style: {
	          backgroundColor: "gainsboro",
	          borderBottom: "1px solid white"
	        }
	      }, _react2.default.createElement("table", null, _react2.default.createElement("tr", null, _react2.default.createElement("td", { style: { width: "45px" } }, _this.getDelIcon(_this.props.rowNum)), _react2.default.createElement("td", { style: { width: "45px" } }, _this.getUpIcon(_this.props.rowNum)), _react2.default.createElement("td", { style: { width: "45px" } }, _this.getDownIcon(_this.props.rowNum)), _react2.default.createElement("td", { style: { width: "45px" } }, _this.getPlusIcon(_this.props.rowNum)), !_this.props.data.payload.expanded && _react2.default.createElement("td", null, _this.getExpandIcon(_this.props.rowNum)), _this.props.data.payload.expanded && _react2.default.createElement("td", null, _this.getCollapseIcon(_this.props.rowNum)), _react2.default.createElement("td", null, _react2.default.createElement("div", {
	        style: {
	          lineHeight: "30px",
	          minWidth: "150px",
	          border: "1px solid white",
	          margin: "2px",
	          paddingLeft: "5px",
	          paddingRight: "5px"
	        }
	      }, _this.props.data.payload.caption)), _react2.default.createElement("td", null, _react2.default.createElement("div", {
	        style: {
	          lineHeight: "30px",
	          minWidth: "150px",
	          border: "1px solid white",
	          margin: "2px",
	          paddingLeft: "5px",
	          paddingRight: "5px"
	        }
	      }, _this.props.data.payload.name)), _react2.default.createElement("td", null, _react2.default.createElement("div", {
	        style: {
	          lineHeight: "30px",
	          minWidth: "150px",
	          border: "1px solid white",
	          margin: "2px",
	          paddingLeft: "5px",
	          paddingRight: "5px"
	        }
	      }, _this.props.data.payload.type)))));
	    };
	
	    _this.getCreateFieldForm = function () {
	      return _react2.default.createElement("div", null, _this.getActionRow(), _this.props.data.payload.expanded && _react2.default.createElement("div", null, _this.getField("type", false), _this.getField("name", false), _this.getField("caption", false), _this.props.data && _this.props.data.payload["type"] && _this.props.data.payload["type"] === "input" && _this.getField("placeholder", false), _this.props.data && _this.props.data.payload["type"] && _this.props.data.payload["type"] === "textarea" && _this.getField("placeholder", false), _this.getField("enabled", false), _this.getField("isMust", false), _this.getField("isHidden", false), _this.props.data && _this.props.data.payload["type"] && _this.props.data.payload["type"] === "input" && _this.getField("isSecure", false), _this.props.data && _this.props.data.payload["type"] && _this.props.data.payload["type"] === "input" && _this.getField("inputValidator", false), _this.props.data && _this.props.data.payload["type"] && _this.props.data.payload["type"] !== "calculation" && _this.getField("defaultValue", false), _this.props.data && _this.props.data.payload["type"] && _this.props.data.payload["type"] === "textarea" && _this.getField("numOfLines", false), _this.props.data && _this.props.data.payload["type"] && _this.props.data.payload["type"] === "calendar" && _this.getField("dateFormat", false), _this.props.data && _this.props.data.payload["type"] && _this.props.data.payload["type"] === "calendar" && _this.getField("dateFormatOut", false), _this.props.data && _this.props.data.payload["type"] && _this.props.data.payload["type"] === "calendar" && _this.getField("dateMaxDetail", false), _this.props.data && _this.props.data.payload["type"] && _this.props.data.payload["type"] === "search" && _this.getField("selectorType", false), _this.props.data && _this.props.data.payload["selectorType"] && _this.props.data.payload["selectorType"] === "static" && _this.props.data.payload["type"] === "search" && _this.getStaticList("staticSource", false), _this.props.data && _this.props.data.payload["selectorType"] && _this.props.data.payload["selectorType"] === "table" && _this.props.data.payload["type"] === "search" && _this.getTableList("table", false), _this.props.data && _this.props.data.payload["selectorType"] && _this.props.data.payload["selectorType"] === "table" && _this.props.data.payload["type"] === "search" && _this.getTableFieldsList("tableField", false), _this.props.data && _this.props.data.payload["selectorType"] && _this.props.data.payload["selectorType"] === "table" && _this.props.data.payload["type"] === "search" && _this.getCompositeDropDownList("otherFieldsToUpdate", "AUTO UPDATE FIELDS", "ADD AUTO UPDATE FIELDS", false), _this.props.data && _this.props.data.payload["selectorType"] && _this.props.data.payload["selectorType"] === "table" && _this.props.data.payload["type"] === "search" && _this.getCompositeFilterList("filters", "FILTER FIELDS", "ADD FILTER", false), _this.props.data && _this.props.data.payload["type"] && _this.props.data.payload["type"] === "array" && _this.getCompositeList("colDefs", false), _this.props.data && _this.props.data.payload["type"] && _this.props.data.payload["type"] === "calculation" && _this.getField("calcType", false), _this.props.data && _this.props.data.payload["type"] && _this.props.data.payload["type"] === "calculation" && _this.getTriggerFieldList("triggerField", false), _this.props.data && _this.props.data.payload["type"] && _this.props.data.payload["type"] === "calculation" && _this.props.data.payload["calcType"] === "subFieldsSum" && _this.getSubGridsList("subGridName", false), _this.props.data && _this.props.data.payload["type"] && _this.props.data.payload["type"] === "calculation" && _this.props.data.payload["calcType"] === "subFieldsSum" && _this.getSelectedSubGridsFields("subGridField", _this.props.data.payload.subGridName), _this.props.data && _this.props.data.payload["type"] && _this.props.data.payload["type"] === "calculation" && _this.props.data.payload["calcType"] === "subFieldsSum" && _this.getField("subFieldOperation", false), _this.props.data && _this.props.data.payload["type"] && _this.props.data.payload["type"] === "calculation" && _this.props.data.payload["calcType"] === "mainFieldCalc" && _this.getFormulaList("formula", false)));
	    };
	
	    _this.state = {
	      data: {
	        path: _this.props.path,
	        payload: _extends({}, _this.props.data),
	        showForm: true,
	        generatingStatement: false,
	        statementLink: ""
	      }
	    };
	    return _this;
	  }
	
	  _createClass(Field, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement("div", null, _reactDeviceDetect.isMobile && _react2.default.createElement("div", null, this.getCreateFieldForm()), _react2.default.createElement("div", {
	        style: {
	          border: "0px solid black"
	        }
	      }, !_reactDeviceDetect.isMobile && this.getCreateFieldForm()));
	    }
	  }]);
	
	  return Field;
	}(_react.Component);
	
	exports.default = Field;

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDeviceDetect = __webpack_require__(6);
	
	var _reactackleIcons = __webpack_require__(7);
	
	var _reactackle = __webpack_require__(5);
	
	var _SelectDropdownForGrid = __webpack_require__(61);
	
	var _SelectDropdownForGrid2 = _interopRequireDefault(_SelectDropdownForGrid);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var CompositeDropDownList = function (_Component) {
	  _inherits(CompositeDropDownList, _Component);
	
	  function CompositeDropDownList(props) {
	    _classCallCheck(this, CompositeDropDownList);
	
	    var _this = _possibleConstructorReturn(this, (CompositeDropDownList.__proto__ || Object.getPrototypeOf(CompositeDropDownList)).call(this, props));
	
	    _this.getCompositeInput = function (rec, arrIndex) {
	      return Object.keys(rec).map(function (recKey) {
	        return _react2.default.createElement("div", {
	          style: {
	            marginBottom: "2px",
	            border: "1px solid gainsboro",
	            margin: "0px"
	          },
	          className: "row"
	        }, _react2.default.createElement("div", {
	          className: "col-sm-4",
	          style: {
	            borderRight: "1px solid gainsboro",
	            textAlign: "left",
	            margin: "auto",
	            padding: "0px",
	            paddingLeft: "5px",
	            verticalAlign: "middle",
	            height: "42px",
	            lineHeight: "42px"
	          }
	        }, recKey === "src" ? "SOURCE FIELD" : "TARGET FIELD"), _react2.default.createElement("div", {
	          className: "col-sm-8",
	          style: { height: "42px", textAlign: "left" }
	        }, _react2.default.createElement(_SelectDropdownForGrid2.default, {
	          title: "SOURCE FIELD",
	          data: recKey === "src" ? _this.props.srcTableFields() : _this.props.tgtTableFields(),
	          label: "SOURCE FIELD",
	          placeholder: "SOURCE FIELD",
	          value: rec[recKey],
	          stateFieldName: recKey,
	          isPayload: true,
	          fieldName: "fieldName",
	          stateHandler: function stateHandler(val, id, isPayload, index) {
	            //console.log("val: " + val + " id: " + id);
	            _this.itemUpdateHandler(arrIndex, val, recKey);
	          }
	        })));
	      });
	    };
	
	    _this.getDelIcon = function (rowNum) {
	      return _react2.default.createElement("div", {
	        style: {
	          padding: "10px",
	          textAlign: "center",
	          border: "1px solid gainsboro",
	          height: "45px",
	          width: "45px"
	        }
	      }, _react2.default.createElement("a", {
	        onClick: function onClick() {
	          _this.itemDeleteHandler(rowNum);
	        }
	      }, _react2.default.createElement(_reactackleIcons.IconSvg, null, _react2.default.createElement("svg", { style: { width: "24px", height: "24px" }, viewBox: "0 0 24 24" }, _react2.default.createElement("path", {
	        fill: "currentColor",
	        d: "M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19M8,9H16V19H8V9M15.5,4L14.5,3H9.5L8.5,4H5V6H19V4H15.5Z"
	      })))));
	    };
	
	    _this.getUpIcon = function (rowNum) {
	      return _react2.default.createElement("div", {
	        className: "col-sm-2",
	        style: {
	          padding: "10px",
	          textAlign: "center",
	          border: "1px solid gainsboro",
	          height: "45px",
	          width: "45px"
	        }
	      }, _react2.default.createElement("a", {
	        onClick: function onClick() {
	          _this.move(rowNum, rowNum - 1);
	        }
	      }, _react2.default.createElement(_reactackleIcons.IconSvg, null, _react2.default.createElement("svg", { style: { width: "24px", height: "24px" }, viewBox: "0 0 24 24" }, _react2.default.createElement("path", {
	        fill: "currentColor",
	        d: "M16,13V21H8V13H2L12,3L22,13H16M7,11H10V19H14V11H17L12,6L7,11Z"
	      })))));
	    };
	
	    _this.getDownIcon = function (rowNum) {
	      return _react2.default.createElement("div", {
	        className: "col-sm-2",
	        style: {
	          padding: "10px",
	          textAlign: "center",
	          border: "1px solid gainsboro",
	          height: "45px",
	          width: "45px"
	        }
	      }, _react2.default.createElement("a", {
	        onClick: function onClick() {
	          _this.move(rowNum, rowNum + 1);
	        }
	      }, _react2.default.createElement(_reactackleIcons.IconSvg, null, _react2.default.createElement("svg", { style: { width: "24px", height: "24px" }, viewBox: "0 0 24 24" }, _react2.default.createElement("path", {
	        fill: "currentColor",
	        d: "M22,11L12,21L2,11H8V3H16V11H22M12,18L17,13H14V5H10V13H7L12,18Z"
	      })))));
	    };
	
	    _this.move = function (oldIndex, newIndex) {
	      var array = _.cloneDeep(_this.props.data);
	      //console.log("before: " + JSON.stringify(array));
	      if (newIndex >= array.length) {
	        newIndex = array.length - 1;
	      }
	      array.splice(newIndex, 0, array.splice(oldIndex, 1)[0]);
	      //console.log("after: " + JSON.stringify(array));
	      _this.props.stateChangeHandler(array, _this.props.stateFieldName, _this.props.isPayload);
	    };
	
	    _this.getPlusIcon = function (rowNum) {
	      return _react2.default.createElement("div", {
	        style: {
	          padding: "10px",
	          textAlign: "center",
	          border: "1px solid gainsboro",
	          height: "45px",
	          width: "45px"
	        }
	      }, _react2.default.createElement("a", {
	        href: "_",
	        onClick: function onClick(event) {
	          event.preventDefault();
	          _this.itemAddHandler(rowNum);
	        }
	      }, _react2.default.createElement(_reactackleIcons.IconSvg, null, _react2.default.createElement("svg", { style: { width: "24px", height: "24px" }, viewBox: "0 0 24 24" }, _react2.default.createElement("path", {
	        fill: "currentColor",
	        d: "M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z"
	      })))));
	    };
	
	    _this.itemUpdateHandler = function (rowNum, newVal, recKey) {
	      // console.log(
	      //   "rowNum: " +
	      //     rowNum +
	      //     " recKey: " +
	      //     recKey +
	      //     " newVal: " +
	      //     newVal +
	      //     " prop.data: " +
	      //     JSON.stringify(this.props.data)
	      // );
	
	      var tmpData = _.cloneDeep(_this.props.data);
	      //console.log("Before: " + JSON.stringify(tmpData[rowNum]));
	      tmpData[rowNum][recKey] = newVal;
	      //console.log("After: " + JSON.stringify(tmpData[rowNum]));
	
	      _this.props.stateChangeHandler(tmpData, _this.props.stateFieldName, _this.props.isPayload);
	    };
	
	    _this.itemAddHandler = function (rowNum) {
	      //console.log("fromRow: " + fromRow + " updated: " + JSON.stringify(updated));
	
	      var tmpData = _.cloneDeep(_this.props.data);
	      if (!tmpData || tmpData === undefined) {
	        tmpData = [];
	      }
	      //console.log("Before: " + JSON.stringify(tmpData));
	      tmpData.splice(rowNum + 1, 0, _this.props.emptyRow);
	
	      //console.log("After: " + JSON.stringify(tmpData));
	      _this.props.stateChangeHandler(tmpData, _this.props.stateFieldName, _this.props.isPayload);
	    };
	
	    _this.itemDeleteHandler = function (rowNum) {
	      //console.log("fromRow: " + fromRow + " updated: " + JSON.stringify(updated));
	
	      var tmpData = JSON.parse(JSON.stringify(_this.props.data));
	      //console.log("Before: " + JSON.stringify(tmpData));
	      delete tmpData[rowNum];
	
	      tmpData = tmpData.filter(function (item) {
	        return item !== null;
	      });
	      //console.log("at filter:" + JSON.stringify(currActionsList));
	
	      //console.log("After: " + JSON.stringify(tmpData));
	      _this.props.stateChangeHandler(tmpData, _this.props.stateFieldName, _this.props.isPayload);
	    };
	
	    _this.getInputRows = function () {
	      if (_this.props.data && _this.props.data.length > 0) {
	        return _this.props.data.map(function (rec, arrIndex) {
	          return _react2.default.createElement("tr", {
	            style: {
	              border: "0.5px solid gainsboro"
	            }
	          }, _react2.default.createElement("td", {
	            style: {
	              width: "45px",
	              verticalAlign: "top",
	              paddingBottom: "5px",
	              paddingLeft: "5px",
	              paddingTop: "5px"
	            }
	          }, _this.getDelIcon(arrIndex)), _react2.default.createElement("td", {
	            style: {
	              width: "45px",
	              verticalAlign: "top",
	              paddingBottom: "5px",
	              paddingTop: "5px"
	            }
	          }, _this.getPlusIcon(arrIndex)), _react2.default.createElement("td", {
	            style: {
	              paddingBottom: "5px",
	              paddingTop: "5px",
	              paddingRight: "5px"
	            }
	          }, _this.getCompositeInput(rec, arrIndex)));
	        });
	      } else {
	        return _react2.default.createElement("tr", {
	          style: {
	            border: "0px solid gainsboro"
	          }
	        }, _react2.default.createElement("td", {
	          style: {
	            width: "45px",
	            verticalAlign: "top",
	            paddingBottom: "5px",
	            paddingLeft: "5px",
	            paddingTop: "5px",
	            textAlign: "left"
	          },
	          colSpan: 3
	        }, _react2.default.createElement(_reactackle.Button, {
	          text: _this.props.emptyTitle,
	          onPress: function onPress() {
	            return _this.itemAddHandler(0);
	          },
	          colorScheme: "primary",
	          outlined: true
	        })));
	      }
	    };
	
	    _this.state = {
	      data: {
	        path: "",
	        payload: _this.props.data
	      }
	    };
	    return _this;
	  }
	
	  _createClass(CompositeDropDownList, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement("div", {
	        className: "row",
	        style: {
	          marginLeft: "1px",
	          marginRight: "1px",
	          alignItems: "center",
	          padding: "2px",
	          border: "0px",
	          borderBottom: "0px",
	          borderBottomColor: "#cccccc",
	          borderStyle: "solid",
	          paddingBottom: _reactDeviceDetect.isMobile ? "0px" : "2px"
	        }
	      }, _react2.default.createElement("div", {
	        className: "col-sm-4 align-self-center\u201D",
	        style: {
	          margin: "0px",
	          verticalAlign: "middle",
	          height: "auto",
	          padding: "0px"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          marginTop: _reactDeviceDetect.isMobile ? "13px" : "0px",
	          verticalAlign: "middle",
	          lineHeight: _reactDeviceDetect.isMobile ? "20px" : "37px",
	          padding: "0px",
	          color: _reactDeviceDetect.isMobile ? "grey" : "black",
	          marginBottom: _reactDeviceDetect.isMobile ? "-1px" : "0px"
	        }
	      }, this.props.title)), _react2.default.createElement("div", {
	        className: "col-sm-8",
	        style: {
	          padding: "0px",
	          textAlign: "right",
	          border: "0px solid gainsboro"
	        }
	      }, _react2.default.createElement("table", {
	        className: "table table-striped",
	        style: {
	          borderSpacing: "10px"
	        }
	      }, this.getInputRows())));
	    }
	  }]);
	
	  return CompositeDropDownList;
	}(_react.Component);
	
	exports.default = CompositeDropDownList;

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDeviceDetect = __webpack_require__(6);
	
	var _reactackleIcons = __webpack_require__(7);
	
	var _reactackle = __webpack_require__(5);
	
	var _SelectDropdownForGrid = __webpack_require__(61);
	
	var _SelectDropdownForGrid2 = _interopRequireDefault(_SelectDropdownForGrid);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var CompositeFilterList = function (_Component) {
	  _inherits(CompositeFilterList, _Component);
	
	  function CompositeFilterList(props) {
	    _classCallCheck(this, CompositeFilterList);
	
	    var _this = _possibleConstructorReturn(this, (CompositeFilterList.__proto__ || Object.getPrototypeOf(CompositeFilterList)).call(this, props));
	
	    _this.getCompositeInput = function (rec, arrIndex) {
	      return Object.keys(rec).map(function (recKey) {
	        return _react2.default.createElement("div", {
	          style: {
	            marginBottom: "2px",
	            border: "1px solid gainsboro",
	            margin: "0px"
	          },
	          className: "row"
	        }, _react2.default.createElement("div", {
	          className: "col-sm-4",
	          style: {
	            borderRight: "1px solid gainsboro",
	            textAlign: "left",
	            margin: "auto",
	            padding: "0px",
	            paddingLeft: "5px",
	            verticalAlign: "middle",
	            height: "42px",
	            lineHeight: "42px"
	          }
	        }, recKey === "src" ? "FIELD" : "EQUALS"), _react2.default.createElement("div", {
	          className: "col-sm-8",
	          style: { height: "42px", textAlign: "left" }
	        }, _react2.default.createElement(_SelectDropdownForGrid2.default, {
	          title: "SOURCE FIELD",
	          data: recKey === "src" ? _this.props.srcTableFields() : _this.props.tgtTableFields(),
	          label: "SOURCE FIELD",
	          placeholder: "SOURCE FIELD",
	          value: rec[recKey],
	          stateFieldName: recKey,
	          isPayload: true,
	          fieldName: "fieldName",
	          stateHandler: function stateHandler(val, id, isPayload, index) {
	            //console.log("val: " + val + " id: " + id);
	            _this.itemUpdateHandler(arrIndex, val, recKey);
	          }
	        })));
	      });
	    };
	
	    _this.getDelIcon = function (rowNum) {
	      return _react2.default.createElement("div", {
	        style: {
	          padding: "10px",
	          textAlign: "center",
	          border: "1px solid gainsboro",
	          height: "45px",
	          width: "45px"
	        }
	      }, _react2.default.createElement("a", {
	        onClick: function onClick() {
	          _this.itemDeleteHandler(rowNum);
	        }
	      }, _react2.default.createElement(_reactackleIcons.IconSvg, null, _react2.default.createElement("svg", { style: { width: "24px", height: "24px" }, viewBox: "0 0 24 24" }, _react2.default.createElement("path", {
	        fill: "currentColor",
	        d: "M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19M8,9H16V19H8V9M15.5,4L14.5,3H9.5L8.5,4H5V6H19V4H15.5Z"
	      })))));
	    };
	
	    _this.getUpIcon = function (rowNum) {
	      return _react2.default.createElement("div", {
	        className: "col-sm-2",
	        style: {
	          padding: "10px",
	          textAlign: "center",
	          border: "1px solid gainsboro",
	          height: "45px",
	          width: "45px"
	        }
	      }, _react2.default.createElement("a", {
	        onClick: function onClick() {
	          _this.move(rowNum, rowNum - 1);
	        }
	      }, _react2.default.createElement(_reactackleIcons.IconSvg, null, _react2.default.createElement("svg", { style: { width: "24px", height: "24px" }, viewBox: "0 0 24 24" }, _react2.default.createElement("path", {
	        fill: "currentColor",
	        d: "M16,13V21H8V13H2L12,3L22,13H16M7,11H10V19H14V11H17L12,6L7,11Z"
	      })))));
	    };
	
	    _this.getDownIcon = function (rowNum) {
	      return _react2.default.createElement("div", {
	        className: "col-sm-2",
	        style: {
	          padding: "10px",
	          textAlign: "center",
	          border: "1px solid gainsboro",
	          height: "45px",
	          width: "45px"
	        }
	      }, _react2.default.createElement("a", {
	        onClick: function onClick() {
	          _this.move(rowNum, rowNum + 1);
	        }
	      }, _react2.default.createElement(_reactackleIcons.IconSvg, null, _react2.default.createElement("svg", { style: { width: "24px", height: "24px" }, viewBox: "0 0 24 24" }, _react2.default.createElement("path", {
	        fill: "currentColor",
	        d: "M22,11L12,21L2,11H8V3H16V11H22M12,18L17,13H14V5H10V13H7L12,18Z"
	      })))));
	    };
	
	    _this.move = function (oldIndex, newIndex) {
	      var array = _.cloneDeep(_this.props.data);
	      //console.log("before: " + JSON.stringify(array));
	      if (newIndex >= array.length) {
	        newIndex = array.length - 1;
	      }
	      array.splice(newIndex, 0, array.splice(oldIndex, 1)[0]);
	      //console.log("after: " + JSON.stringify(array));
	      _this.props.stateChangeHandler(array, _this.props.stateFieldName, _this.props.isPayload);
	    };
	
	    _this.getPlusIcon = function (rowNum) {
	      return _react2.default.createElement("div", {
	        style: {
	          padding: "10px",
	          textAlign: "center",
	          border: "1px solid gainsboro",
	          height: "45px",
	          width: "45px"
	        }
	      }, _react2.default.createElement("a", {
	        href: "_",
	        onClick: function onClick(event) {
	          event.preventDefault();
	          _this.itemAddHandler(rowNum);
	        }
	      }, _react2.default.createElement(_reactackleIcons.IconSvg, null, _react2.default.createElement("svg", { style: { width: "24px", height: "24px" }, viewBox: "0 0 24 24" }, _react2.default.createElement("path", {
	        fill: "currentColor",
	        d: "M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z"
	      })))));
	    };
	
	    _this.itemUpdateHandler = function (rowNum, newVal, recKey) {
	      // console.log(
	      //   "rowNum: " +
	      //     rowNum +
	      //     " recKey: " +
	      //     recKey +
	      //     " newVal: " +
	      //     newVal +
	      //     " prop.data: " +
	      //     JSON.stringify(this.props.data)
	      // );
	
	      var tmpData = _.cloneDeep(_this.props.data);
	      //console.log("Before: " + JSON.stringify(tmpData[rowNum]));
	      tmpData[rowNum][recKey] = newVal;
	      //console.log("After: " + JSON.stringify(tmpData[rowNum]));
	
	      _this.props.stateChangeHandler(tmpData, _this.props.stateFieldName, _this.props.isPayload);
	    };
	
	    _this.itemAddHandler = function (rowNum) {
	      //console.log("fromRow: " + fromRow + " updated: " + JSON.stringify(updated));
	
	      var tmpData = _.cloneDeep(_this.props.data);
	      if (!tmpData || tmpData === undefined) {
	        tmpData = [];
	      }
	      //console.log("Before: " + JSON.stringify(tmpData));
	      tmpData.splice(rowNum + 1, 0, _this.props.emptyRow);
	
	      //console.log("After: " + JSON.stringify(tmpData));
	      _this.props.stateChangeHandler(tmpData, _this.props.stateFieldName, _this.props.isPayload);
	    };
	
	    _this.itemDeleteHandler = function (rowNum) {
	      //console.log("fromRow: " + fromRow + " updated: " + JSON.stringify(updated));
	
	      var tmpData = JSON.parse(JSON.stringify(_this.props.data));
	      //console.log("Before: " + JSON.stringify(tmpData));
	      delete tmpData[rowNum];
	
	      tmpData = tmpData.filter(function (item) {
	        return item !== null;
	      });
	      //console.log("at filter:" + JSON.stringify(currActionsList));
	
	      //console.log("After: " + JSON.stringify(tmpData));
	      _this.props.stateChangeHandler(tmpData, _this.props.stateFieldName, _this.props.isPayload);
	    };
	
	    _this.getInputRows = function () {
	      if (_this.props.data && _this.props.data.length > 0) {
	        return _this.props.data.map(function (rec, arrIndex) {
	          return _react2.default.createElement("tr", {
	            style: {
	              border: "0.5px solid gainsboro"
	            }
	          }, _react2.default.createElement("td", {
	            style: {
	              width: "45px",
	              verticalAlign: "top",
	              paddingBottom: "5px",
	              paddingLeft: "5px",
	              paddingTop: "5px"
	            }
	          }, _this.getDelIcon(arrIndex)), _react2.default.createElement("td", {
	            style: {
	              width: "45px",
	              verticalAlign: "top",
	              paddingBottom: "5px",
	              paddingTop: "5px"
	            }
	          }, _this.getPlusIcon(arrIndex)), _react2.default.createElement("td", {
	            style: {
	              paddingBottom: "5px",
	              paddingTop: "5px",
	              paddingRight: "5px"
	            }
	          }, _this.getCompositeInput(rec, arrIndex)));
	        });
	      } else {
	        return _react2.default.createElement("tr", {
	          style: {
	            border: "0px solid gainsboro"
	          }
	        }, _react2.default.createElement("td", {
	          style: {
	            width: "45px",
	            verticalAlign: "top",
	            paddingBottom: "5px",
	            paddingLeft: "5px",
	            paddingTop: "5px",
	            textAlign: "left"
	          },
	          colSpan: 3
	        }, _react2.default.createElement(_reactackle.Button, {
	          text: _this.props.emptyTitle,
	          onPress: function onPress() {
	            return _this.itemAddHandler(0);
	          },
	          colorScheme: "primary",
	          outlined: true
	        })));
	      }
	    };
	
	    _this.state = {
	      data: {
	        path: "",
	        payload: _this.props.data
	      }
	    };
	    return _this;
	  }
	
	  _createClass(CompositeFilterList, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement("div", {
	        className: "row",
	        style: {
	          marginLeft: "1px",
	          marginRight: "1px",
	          alignItems: "center",
	          padding: "2px",
	          border: "0px",
	          borderBottom: "0px",
	          borderBottomColor: "#cccccc",
	          borderStyle: "solid",
	          paddingBottom: _reactDeviceDetect.isMobile ? "0px" : "2px"
	        }
	      }, _react2.default.createElement("div", {
	        className: "col-sm-4 align-self-center\u201D",
	        style: {
	          margin: "0px",
	          verticalAlign: "middle",
	          height: "auto",
	          padding: "0px"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          marginTop: _reactDeviceDetect.isMobile ? "13px" : "0px",
	          verticalAlign: "middle",
	          lineHeight: _reactDeviceDetect.isMobile ? "20px" : "37px",
	          padding: "0px",
	          color: _reactDeviceDetect.isMobile ? "grey" : "black",
	          marginBottom: _reactDeviceDetect.isMobile ? "-1px" : "0px"
	        }
	      }, this.props.title)), _react2.default.createElement("div", {
	        className: "col-sm-8",
	        style: {
	          padding: "0px",
	          textAlign: "right",
	          border: "0px solid gainsboro"
	        }
	      }, _react2.default.createElement("table", {
	        className: "table table-striped",
	        style: {
	          borderSpacing: "10px"
	        }
	      }, this.getInputRows())));
	    }
	  }]);
	
	  return CompositeFilterList;
	}(_react.Component);
	
	exports.default = CompositeFilterList;

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactackle = __webpack_require__(5);
	
	var _reactDeviceDetect = __webpack_require__(6);
	
	var _reactackleIcons = __webpack_require__(7);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var CompositeList = function (_Component) {
	  _inherits(CompositeList, _Component);
	
	  function CompositeList(props) {
	    _classCallCheck(this, CompositeList);
	
	    var _this = _possibleConstructorReturn(this, (CompositeList.__proto__ || Object.getPrototypeOf(CompositeList)).call(this, props));
	
	    _this.getCompositeInput = function (rec, arrIndex) {
	      return Object.keys(rec).map(function (recKey) {
	        return _react2.default.createElement("div", { style: { marginBottom: "2px" } }, _react2.default.createElement("div", {
	          style: {
	            width: "100px",
	            float: "left",
	            lineHeight: "39px",
	            border: "1px solid gainsboro",
	            padding: "2px",
	            textAlign: "left",
	            backgroundColor: "gainsboro"
	          }
	        }, recKey.toUpperCase()), _react2.default.createElement("div", {
	          style: {
	            paddingLeft: "1px",
	
	            border: "1px solid gainsboro",
	            height: "45px"
	          }
	        }, _react2.default.createElement(_reactackle.TextField, {
	          value: rec[recKey],
	          onChange: function onChange(e) {
	            _this.itemUpdateHandler(arrIndex, e.value, recKey);
	          },
	          fullWidth: true
	        })));
	      });
	    };
	
	    _this.getDelIcon = function (rowNum) {
	      return _react2.default.createElement("div", {
	        style: {
	          padding: "10px",
	          textAlign: "center",
	          border: "1px solid gainsboro",
	          height: "45px",
	          width: "45px"
	        }
	      }, _react2.default.createElement("a", {
	        onClick: function onClick() {
	          _this.itemDeleteHandler(rowNum);
	        }
	      }, _react2.default.createElement(_reactackleIcons.IconSvg, null, _react2.default.createElement("svg", { style: { width: "24px", height: "24px" }, viewBox: "0 0 24 24" }, _react2.default.createElement("path", {
	        fill: "currentColor",
	        d: "M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19M8,9H16V19H8V9M15.5,4L14.5,3H9.5L8.5,4H5V6H19V4H15.5Z"
	      })))));
	    };
	
	    _this.getUpIcon = function (rowNum) {
	      return _react2.default.createElement("div", {
	        className: "col-sm-2",
	        style: {
	          padding: "10px",
	          textAlign: "center",
	          border: "1px solid gainsboro",
	          height: "45px",
	          width: "45px"
	        }
	      }, _react2.default.createElement("a", {
	        onClick: function onClick() {
	          _this.move(rowNum, rowNum - 1);
	        }
	      }, _react2.default.createElement(_reactackleIcons.IconSvg, null, _react2.default.createElement("svg", { style: { width: "24px", height: "24px" }, viewBox: "0 0 24 24" }, _react2.default.createElement("path", {
	        fill: "currentColor",
	        d: "M16,13V21H8V13H2L12,3L22,13H16M7,11H10V19H14V11H17L12,6L7,11Z"
	      })))));
	    };
	
	    _this.getDownIcon = function (rowNum) {
	      return _react2.default.createElement("div", {
	        className: "col-sm-2",
	        style: {
	          padding: "10px",
	          textAlign: "center",
	          border: "1px solid gainsboro",
	          height: "45px",
	          width: "45px"
	        }
	      }, _react2.default.createElement("a", {
	        onClick: function onClick() {
	          _this.move(rowNum, rowNum + 1);
	        }
	      }, _react2.default.createElement(_reactackleIcons.IconSvg, null, _react2.default.createElement("svg", { style: { width: "24px", height: "24px" }, viewBox: "0 0 24 24" }, _react2.default.createElement("path", {
	        fill: "currentColor",
	        d: "M22,11L12,21L2,11H8V3H16V11H22M12,18L17,13H14V5H10V13H7L12,18Z"
	      })))));
	    };
	
	    _this.move = function (oldIndex, newIndex) {
	      var array = _.cloneDeep(_this.props.data);
	      //console.log("before: " + JSON.stringify(array));
	      if (newIndex >= array.length) {
	        newIndex = array.length - 1;
	      }
	      array.splice(newIndex, 0, array.splice(oldIndex, 1)[0]);
	      //console.log("after: " + JSON.stringify(array));
	      _this.props.stateChangeHandler(array, _this.props.stateFieldName, _this.props.isPayload);
	    };
	
	    _this.getPlusIcon = function (rowNum) {
	      return _react2.default.createElement("div", {
	        style: {
	          padding: "10px",
	          textAlign: "center",
	          border: "1px solid gainsboro",
	          height: "45px",
	          width: "45px"
	        }
	      }, _react2.default.createElement("a", {
	        href: "_",
	        onClick: function onClick(event) {
	          event.preventDefault();
	          _this.itemAddHandler(rowNum);
	        }
	      }, _react2.default.createElement(_reactackleIcons.IconSvg, null, _react2.default.createElement("svg", { style: { width: "24px", height: "24px" }, viewBox: "0 0 24 24" }, _react2.default.createElement("path", {
	        fill: "currentColor",
	        d: "M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z"
	      })))));
	    };
	
	    _this.itemUpdateHandler = function (rowNum, newVal, recKey) {
	      // console.log(
	      //   "rowNum: " + rowNum + " recKey: " + recKey + " newVal: " + newVal
	      // );
	
	      var tmpData = _.cloneDeep(_this.props.data);
	      //console.log("Before: " + JSON.stringify(tmpData[rowNum]));
	      tmpData[rowNum][recKey] = newVal;
	      //console.log("After: " + JSON.stringify(tmpData[rowNum]));
	
	      _this.props.stateChangeHandler(tmpData, _this.props.stateFieldName, _this.props.isPayload);
	    };
	
	    _this.itemAddHandler = function (rowNum) {
	      //console.log("fromRow: " + fromRow + " updated: " + JSON.stringify(updated));
	
	      var tmpData = _.cloneDeep(_this.props.data);
	      //console.log("Before: " + JSON.stringify(tmpData));
	      tmpData.splice(rowNum + 1, 0, _this.props.emptyRow);
	
	      //console.log("After: " + JSON.stringify(tmpData));
	      _this.props.stateChangeHandler(tmpData, _this.props.stateFieldName, _this.props.isPayload);
	    };
	
	    _this.itemDeleteHandler = function (rowNum) {
	      //console.log("fromRow: " + fromRow + " updated: " + JSON.stringify(updated));
	
	      var tmpData = JSON.parse(JSON.stringify(_this.props.data));
	      //console.log("Before: " + JSON.stringify(tmpData));
	      delete tmpData[rowNum];
	
	      tmpData = tmpData.filter(function (item) {
	        return item !== null;
	      });
	      //console.log("at filter:" + JSON.stringify(currActionsList));
	
	      //console.log("After: " + JSON.stringify(tmpData));
	      _this.props.stateChangeHandler(tmpData, _this.props.stateFieldName, _this.props.isPayload);
	    };
	
	    _this.getInputRows = function () {
	      if (_this.props.data && _this.props.data.length > 0) {
	        return _this.props.data.map(function (rec, arrIndex) {
	          return _react2.default.createElement("tr", {
	            style: {
	              border: "0.5px solid gainsboro"
	            }
	          }, _react2.default.createElement("td", {
	            style: {
	              width: "45px",
	              verticalAlign: "top",
	              paddingBottom: "5px",
	              paddingLeft: "5px",
	              paddingTop: "5px"
	            }
	          }, _this.getDelIcon(arrIndex)), _react2.default.createElement("td", {
	            style: {
	              width: "45px",
	              verticalAlign: "top",
	              paddingBottom: "5px",
	              paddingTop: "5px"
	            }
	          }, _this.getUpIcon(arrIndex)), _react2.default.createElement("td", {
	            style: {
	              width: "45px",
	              verticalAlign: "top",
	              paddingBottom: "5px",
	              paddingTop: "5px"
	            }
	          }, _this.getDownIcon(arrIndex)), _react2.default.createElement("td", {
	            style: {
	              width: "45px",
	              verticalAlign: "top",
	              paddingBottom: "5px",
	              paddingTop: "5px"
	            }
	          }, _this.getPlusIcon(arrIndex)), _react2.default.createElement("td", {
	            style: {
	              paddingBottom: "5px",
	              paddingTop: "5px",
	              paddingRight: "5px"
	            }
	          }, _this.getCompositeInput(rec, arrIndex)));
	        });
	      }
	    };
	
	    _this.state = {
	      data: {
	        path: "",
	        payload: _this.props.data
	      }
	    };
	    return _this;
	  }
	
	  _createClass(CompositeList, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement("div", {
	        className: "row",
	        style: {
	          marginLeft: "1px",
	          marginRight: "1px",
	          alignItems: "center",
	          padding: "2px",
	          border: "0px",
	          borderBottom: "0px",
	          borderBottomColor: "#cccccc",
	          borderStyle: "solid",
	          paddingBottom: _reactDeviceDetect.isMobile ? "0px" : "2px"
	        }
	      }, _react2.default.createElement("div", {
	        className: "col-sm-4 align-self-center\u201D",
	        style: {
	          margin: "0px",
	          verticalAlign: "middle",
	          height: "auto",
	          padding: "0px"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          marginTop: _reactDeviceDetect.isMobile ? "13px" : "0px",
	          verticalAlign: "middle",
	          lineHeight: _reactDeviceDetect.isMobile ? "20px" : "37px",
	          padding: "0px",
	          color: _reactDeviceDetect.isMobile ? "grey" : "black",
	          marginBottom: _reactDeviceDetect.isMobile ? "-1px" : "0px"
	        }
	      }, this.props.title)), _react2.default.createElement("div", {
	        className: "col-sm-8",
	        style: {
	          padding: "0px",
	          textAlign: "right",
	          border: "0px solid gainsboro"
	        }
	      }, _react2.default.createElement("table", {
	        className: "table table-striped",
	        style: {
	          borderSpacing: "10px"
	        }
	      }, this.getInputRows())));
	    }
	  }]);
	
	  return CompositeList;
	}(_react.Component);
	
	exports.default = CompositeList;

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactackle = __webpack_require__(5);
	
	var _SelectDropdownForGrid = __webpack_require__(61);
	
	var _SelectDropdownForGrid2 = _interopRequireDefault(_SelectDropdownForGrid);
	
	var _reactDeviceDetect = __webpack_require__(6);
	
	var _reactackleIcons = __webpack_require__(7);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var DashColumns = function (_Component) {
	  _inherits(DashColumns, _Component);
	
	  function DashColumns(props) {
	    _classCallCheck(this, DashColumns);
	
	    var _this = _possibleConstructorReturn(this, (DashColumns.__proto__ || Object.getPrototypeOf(DashColumns)).call(this, props));
	
	    _this.getInput = function (fieldVal) {
	      return _react2.default.createElement("div", {
	        style: {
	          paddingLeft: "1px",
	          textAlign: "right",
	          border: "1px solid gainsboro",
	          height: "45px"
	        }
	      }, _react2.default.createElement(_reactackle.TextField, {
	        value: fieldVal,
	        onChange: function onChange(e) {
	          _this.itemUpdateHandler(arrIndex, e.value);
	        },
	        fullWidth: true,
	        disabled: true
	      }));
	    };
	
	    _this.move = function (oldIndex, newIndex) {
	      var array = _.cloneDeep(_this.props.value);
	      //console.log("before: " + JSON.stringify(array));
	      if (newIndex >= array.length) {
	        newIndex = array.length - 1;
	      }
	      array.splice(newIndex, 0, array.splice(oldIndex, 1)[0]);
	      //console.log("after: " + JSON.stringify(array));
	      _this.props.stateChangeHandler(array, _this.props.stateFieldName, _this.props.isPayload);
	    };
	
	    _this.getDelIcon = function (rowNum) {
	      return _react2.default.createElement("div", {
	        style: {
	          padding: "10px",
	          textAlign: "center",
	          border: "1px solid gainsboro",
	          height: "45px",
	          width: "45px"
	        }
	      }, _react2.default.createElement("a", {
	        onClick: function onClick() {
	          _this.itemDeleteHandler(rowNum);
	        }
	      }, _react2.default.createElement(_reactackleIcons.IconSvg, null, _react2.default.createElement("svg", { style: { width: "24px", height: "24px" }, viewBox: "0 0 24 24" }, _react2.default.createElement("path", {
	        fill: "currentColor",
	        d: "M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19M8,9H16V19H8V9M15.5,4L14.5,3H9.5L8.5,4H5V6H19V4H15.5Z"
	      })))));
	    };
	
	    _this.getUpIcon = function (rowNum) {
	      return _react2.default.createElement("div", {
	        className: "col-sm-2",
	        style: {
	          padding: "10px",
	          textAlign: "center",
	          border: "1px solid gainsboro",
	          height: "45px",
	          width: "45px"
	        }
	      }, _react2.default.createElement("a", {
	        onClick: function onClick() {
	          _this.move(rowNum, rowNum - 1);
	        }
	      }, _react2.default.createElement(_reactackleIcons.IconSvg, null, _react2.default.createElement("svg", { style: { width: "24px", height: "24px" }, viewBox: "0 0 24 24" }, _react2.default.createElement("path", {
	        fill: "currentColor",
	        d: "M16,13V21H8V13H2L12,3L22,13H16M7,11H10V19H14V11H17L12,6L7,11Z"
	      })))));
	    };
	
	    _this.getDownIcon = function (rowNum) {
	      return _react2.default.createElement("div", {
	        className: "col-sm-2",
	        style: {
	          padding: "10px",
	          textAlign: "center",
	          border: "1px solid gainsboro",
	          height: "45px",
	          width: "45px"
	        }
	      }, _react2.default.createElement("a", {
	        onClick: function onClick() {
	          _this.move(rowNum, rowNum + 1);
	        }
	      }, _react2.default.createElement(_reactackleIcons.IconSvg, null, _react2.default.createElement("svg", { style: { width: "24px", height: "24px" }, viewBox: "0 0 24 24" }, _react2.default.createElement("path", {
	        fill: "currentColor",
	        d: "M22,11L12,21L2,11H8V3H16V11H22M12,18L17,13H14V5H10V13H7L12,18Z"
	      })))));
	    };
	
	    _this.getPlusIcon = function (rowNum) {
	      return _react2.default.createElement("div", {
	        style: {
	          padding: "10px",
	          textAlign: "center",
	          border: "1px solid gainsboro",
	          height: "45px",
	          width: "45px"
	        }
	      }, _react2.default.createElement("a", {
	        href: "_",
	        onClick: function onClick(event) {
	          event.preventDefault();
	          _this.itemAddHandler(rowNum);
	        }
	      }, _react2.default.createElement(_reactackleIcons.IconSvg, null, _react2.default.createElement("svg", { style: { width: "24px", height: "24px" }, viewBox: "0 0 24 24" }, _react2.default.createElement("path", {
	        fill: "currentColor",
	        d: "M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z"
	      })))));
	    };
	
	    _this.itemUpdateHandler = function (rowNum, newVal) {
	      //console.log("rowNum: " + rowNum + " updated: " + newVal);
	
	      var tmpData = _.cloneDeep(_this.props.value);
	      //console.log("Before: " + JSON.stringify(tmpData[rowNum]));
	      tmpData[rowNum][_this.props.fieldNameInArray] = newVal;
	      //console.log("After: " + JSON.stringify(tmpData[rowNum]));
	
	      _this.props.stateChangeHandler(tmpData, _this.props.stateFieldName, _this.props.isPayload);
	    };
	
	    _this.itemAddHandler = function (rowNum) {
	      //console.log("fromRow: " + fromRow + " updated: " + JSON.stringify(updated));
	      var tmpData = _.cloneDeep(_this.props.value);
	      //console.log("Before: " + JSON.stringify(tmpData));
	      tmpData.splice(rowNum + 1, 0, _this.props.emptyRow);
	
	      //console.log("After: " + JSON.stringify(tmpData));
	      _this.props.stateChangeHandler(tmpData, _this.props.stateFieldName, _this.props.isPayload);
	    };
	
	    _this.itemDeleteHandler = function (rowNum) {
	      //console.log("fromRow: " + fromRow + " updated: " + JSON.stringify(updated));
	      var tmpData = _.cloneDeep(_this.props.value);
	      //console.log("Before: " + JSON.stringify(tmpData));
	      delete tmpData[rowNum];
	
	      tmpData = tmpData.filter(function (item) {
	        return item !== null;
	      });
	      //console.log("at filter:" + JSON.stringify(currActionsList));
	
	      _this.props.stateChangeHandler(tmpData, _this.props.stateFieldName, _this.props.isPayload);
	    };
	
	    _this.getInputRows = function () {
	      if (_this.props.value && _this.props.value.length > 0) {
	        return _this.props.value.map(function (val, arrIndex) {
	          return _react2.default.createElement("tr", null, _react2.default.createElement("td", { style: { width: "45px" } }, _this.getDelIcon(arrIndex)), _react2.default.createElement("td", { style: { width: "45px" } }, _this.getUpIcon(arrIndex)), _react2.default.createElement("td", { style: { width: "45px" } }, _this.getDownIcon(arrIndex)), _react2.default.createElement("td", null, _this.getInput(val, arrIndex)));
	        });
	      }
	    };
	
	    _this.getSelectionList = function () {
	      return _react2.default.createElement("div", {
	        className: "row",
	        style: {
	          marginLeft: "1px",
	          marginRight: "1px",
	          alignItems: "center",
	          padding: "2px",
	          border: "0px solid gainsboro",
	          borderStyle: "solid",
	          paddingBottom: _reactDeviceDetect.isMobile ? "0px" : "2px"
	        }
	      }, _react2.default.createElement("div", {
	        className: "col-sm-2 align-self-center\u201D",
	        style: {
	          margin: "0px",
	          verticalAlign: "middle",
	          height: "auto",
	          padding: "0px"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          marginTop: _reactDeviceDetect.isMobile ? "13px" : "0px",
	          verticalAlign: "middle",
	          lineHeight: _reactDeviceDetect.isMobile ? "20px" : "37px",
	          padding: "0px",
	          paddingRight: "2px",
	          color: "grey",
	          marginBottom: _reactDeviceDetect.isMobile ? "-1px" : "0px",
	          textAlign: "left",
	          fontSize: "10px"
	        }
	      }, "Select to Add")), _react2.default.createElement("div", {
	        className: "col-sm-10",
	        style: {
	          padding: "0px",
	          textAlign: "left",
	          border: "1px solid gainsboro"
	        }
	      }, _react2.default.createElement(_SelectDropdownForGrid2.default, {
	        title: "Title",
	        data: _this.getAvailableChoices(),
	        label: "label",
	        placeholder: "placeholder",
	        value: "",
	        stateFieldName: _this.props.stateFieldName,
	        isPayload: true,
	        fieldName: "name",
	        stateHandler: _this.props.itemHandler
	      })));
	    };
	
	    _this.getCurrentList = function () {
	      return _react2.default.createElement("div", {
	        className: "row",
	        style: {
	          marginLeft: "1px",
	          marginRight: "1px",
	          alignItems: "center",
	          padding: "2px",
	          border: "0px solid gainsboro",
	          borderStyle: "solid",
	          paddingBottom: _reactDeviceDetect.isMobile ? "0px" : "2px"
	        }
	      }, _react2.default.createElement("div", {
	        className: "col-sm-2 align-self-center\u201D",
	        style: {
	          margin: "0px",
	          verticalAlign: "middle",
	          height: "auto",
	          padding: "0px"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          marginTop: _reactDeviceDetect.isMobile ? "13px" : "0px",
	          verticalAlign: "middle",
	          lineHeight: _reactDeviceDetect.isMobile ? "20px" : "37px",
	          padding: "0px",
	          paddingRight: "2px",
	          color: "grey",
	          marginBottom: _reactDeviceDetect.isMobile ? "-1px" : "0px",
	          textAlign: "left"
	        }
	      })), _react2.default.createElement("div", {
	        className: "col-sm-10",
	        style: {
	          padding: "0px",
	          textAlign: "left",
	          border: "0px solid gainsboro"
	        }
	      }, _react2.default.createElement("table", { className: "table table-striped" }, _this.getInputRows())));
	    };
	
	    _this.getAvailableChoices = function () {
	      var availableChoices = [];
	
	      for (var i = 0; i < _this.props.fieldsList.length; i++) {
	        //console.log("~ " + this.props.fieldsList[i].name);
	        if (!_this.props.value.includes(_this.props.fieldsList[i].name)) {
	          //console.log("~ included - " + this.props.fieldsList[i].name);
	          availableChoices.push(_this.props.fieldsList[i]);
	        } else {
	          //console.log("~ excluded - " + this.props.fieldsList[i].name);
	        }
	      }
	      return availableChoices;
	    };
	
	    _this.state = {
	      data: {
	        path: "",
	        payload: _this.props.data
	      }
	    };
	    return _this;
	  }
	
	  _createClass(DashColumns, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement("div", {
	        className: "row",
	        style: {
	          marginLeft: "1px",
	          marginRight: "1px",
	          alignItems: "center",
	          padding: "2px",
	          border: "0px solid gainsboro",
	          paddingBottom: _reactDeviceDetect.isMobile ? "0px" : "2px"
	        }
	      }, _react2.default.createElement("div", {
	        className: "col-sm-4 align-self-center\u201D",
	        style: {
	          margin: "0px",
	          verticalAlign: "middle",
	          height: "auto",
	          padding: "0px"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          marginTop: _reactDeviceDetect.isMobile ? "13px" : "0px",
	          verticalAlign: "middle",
	          lineHeight: _reactDeviceDetect.isMobile ? "20px" : "37px",
	          padding: "0px",
	          color: _reactDeviceDetect.isMobile ? "grey" : "black",
	          marginBottom: _reactDeviceDetect.isMobile ? "-1px" : "0px"
	        }
	      }, this.props.title)), _react2.default.createElement("div", {
	        className: "col-sm-8",
	        style: {
	          padding: "0px",
	          textAlign: "right",
	          border: "1px solid gainsboro"
	        }
	      }, this.getSelectionList(), this.getCurrentList()));
	    }
	  }]);
	
	  return DashColumns;
	}(_react.Component);
	
	exports.default = DashColumns;

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactackle = __webpack_require__(5);
	
	var _SelectDropdownForGrid = __webpack_require__(61);
	
	var _SelectDropdownForGrid2 = _interopRequireDefault(_SelectDropdownForGrid);
	
	var _reactDeviceDetect = __webpack_require__(6);
	
	var _reactackleIcons = __webpack_require__(7);
	
	var _MenuColumnsDataGrid = __webpack_require__(298);
	
	var _MenuColumnsDataGrid2 = _interopRequireDefault(_MenuColumnsDataGrid);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var MenuColumns = function (_Component) {
	  _inherits(MenuColumns, _Component);
	
	  function MenuColumns(props) {
	    _classCallCheck(this, MenuColumns);
	
	    var _this = _possibleConstructorReturn(this, (MenuColumns.__proto__ || Object.getPrototypeOf(MenuColumns)).call(this, props));
	
	    _this.getTableDropDown = function (fieldVal, arrIndex) {
	      return _react2.default.createElement("div", {
	        style: {
	          paddingLeft: "1px",
	          textAlign: "left",
	          border: "1px solid gainsboro",
	          height: "45px"
	        }
	      }, _react2.default.createElement(_SelectDropdownForGrid2.default, {
	        title: "Title",
	        data: _this.getAvailableChoices(),
	        label: "label",
	        placeholder: "placeholder",
	        value: fieldVal && fieldVal && fieldVal.menuCaption ? fieldVal.menuCaption : "",
	        stateFieldName: _this.props.stateFieldName,
	        isPayload: true,
	        fieldName: "menu",
	        arrayIndex: arrIndex,
	        stateHandler: function stateHandler(val, id, isPayload) {
	          _this.props.tableSelectionHandler(val, arrIndex);
	        }
	      }));
	    };
	
	    _this.getInputRecLimit = function (fieldVal, arrIndex) {
	      return _react2.default.createElement("div", {
	        style: {
	          paddingLeft: "1px",
	          textAlign: "right",
	          border: "1px solid gainsboro",
	          height: "45px",
	          marginTop: "5px",
	          marginBottom: "5px"
	        }
	      }, _react2.default.createElement(_reactackle.TextField, {
	        value: fieldVal && fieldVal.recLimit && fieldVal.recLimit !== undefined ? fieldVal.recLimit : "",
	        onChange: function onChange(e) {
	          _this.props.limitHandler(e.value, "recLimit", arrIndex);
	        },
	        fullWidth: true,
	        disabled: false,
	        placeholder: " DESKTOP RECORDS LIMIT"
	      }));
	    };
	
	    _this.getInputMenuIcon = function (fieldVal, arrIndex) {
	      return _react2.default.createElement("div", {
	        style: {
	          paddingLeft: "1px",
	          textAlign: "right",
	          border: "1px solid gainsboro",
	          height: "45px",
	          marginTop: "5px",
	          marginBottom: "5px"
	        }
	      }, _react2.default.createElement(_reactackle.TextField, {
	        value: fieldVal && fieldVal.menuIcon && fieldVal.menuIcon !== undefined ? fieldVal.menuIcon : "",
	        onChange: function onChange(e) {
	          _this.props.limitHandler(e.value, "menuIcon", arrIndex);
	        },
	        fullWidth: true,
	        disabled: false,
	        placeholder: "fa fa-home"
	      }));
	    };
	
	    _this.getInputMobileRecLimit = function (fieldVal, arrIndex) {
	      return _react2.default.createElement("div", {
	        style: {
	          paddingLeft: "1px",
	          textAlign: "right",
	          border: "1px solid gainsboro",
	          height: "45px",
	          marginTop: "5px",
	          marginBottom: "5px"
	        }
	      }, _react2.default.createElement(_reactackle.TextField, {
	        value: fieldVal && fieldVal.recMobileLimit && fieldVal.recMobileLimit !== undefined ? fieldVal.recMobileLimit : "",
	        onChange: function onChange(e) {
	          _this.props.limitHandler(e.value, "recMobileLimit", arrIndex);
	        },
	        fullWidth: true,
	        disabled: false,
	        placeholder: "MOBILE RECORDS LIMIT"
	      }));
	    };
	
	    _this.getDisplayToggle = function (fieldVal, arrIndex) {
	      return _react2.default.createElement("div", {
	        style: {
	          paddingLeft: "1px",
	          textAlign: "left",
	          border: "1px solid gainsboro",
	          height: "45px",
	          marginTop: "5px",
	          marginBottom: "5px"
	        }
	      }, _react2.default.createElement(_SelectDropdownForGrid2.default, {
	        title: "Title",
	        data: [{ name: "YES", value: "YES" }, { name: "NO", value: "NO" }],
	        label: "label",
	        placeholder: "placeholder",
	        value: fieldVal && fieldVal.displayToggle ? fieldVal.displayToggle : "",
	        stateFieldName: "displayToggle",
	        isPayload: true,
	        fieldName: "name",
	        arrayIndex: arrIndex,
	        stateHandler: function stateHandler(val, id, isPayload) {
	          _this.props.limitHandler(val, "displayToggle", arrIndex);
	        }
	      }));
	    };
	
	    _this.getInputRows = function () {
	      if (_this.props.value && _this.props.value.length > 0) {
	        return _this.props.value.map(function (val, arrIndex) {
	          var _ref;
	
	          return _react2.default.createElement("div", {
	            style: (_ref = {
	              padding: "0px",
	              textAlign: "left",
	              border: "1px solid gainsboro"
	            }, _defineProperty(_ref, "padding", "20px"), _defineProperty(_ref, "paddingBottom", "0px"), _defineProperty(_ref, "marginTop", "5px"), _defineProperty(_ref, "marginBottom", "5px"), _ref)
	          }, _react2.default.createElement("table", { className: "table table-striped" }, _react2.default.createElement("tr", null, _react2.default.createElement("td", { style: { width: "45px" } }, _this.getDelIcon(arrIndex)), _react2.default.createElement("td", { style: { width: "45px" } }, _this.getUpIcon(arrIndex)), _react2.default.createElement("td", { style: { width: "45px" } }, _this.getDownIcon(arrIndex)), _react2.default.createElement("td", { style: { width: "45px" } }, _this.getPlusIcon(arrIndex)), _react2.default.createElement("td", null, _this.getTableDropDown(val, arrIndex))), _react2.default.createElement("tr", null, _react2.default.createElement("td", { colSpan: 5 }, _this.getDisplayToggle(val, arrIndex))), _react2.default.createElement("tr", null, _react2.default.createElement("td", { colSpan: 5 }, _this.getInputRecLimit(val, arrIndex))), _react2.default.createElement("tr", null, _react2.default.createElement("td", { colSpan: 5 }, _this.getInputMenuIcon(val, arrIndex))), _react2.default.createElement("tr", null, _react2.default.createElement("td", { colSpan: 5 }, _this.getInputMobileRecLimit(val, arrIndex))), _react2.default.createElement("tr", null, _react2.default.createElement("td", {
	            colSpan: 5,
	            style: {
	              maring: "10px"
	            }
	          }, _this.getDataRows(val, arrIndex)))));
	        });
	      }
	    };
	
	    _this.getDataRows = function (val, arrIndex) {
	      return _react2.default.createElement(_MenuColumnsDataGrid2.default, {
	        fieldsList: _this.props.listOfTables,
	        stateFieldName: "dataConditions",
	        value: val && val.dataConditions && val.dataConditions !== undefined ? val.dataConditions : [],
	        stateChangeHandler: _this.dataGridStateChangeHandler,
	        isPayload: true,
	        title: "MENU LIST",
	        arrIndex: arrIndex,
	        recLimitFieldVal: "fieldVal",
	        recLimitFieldName: "fieldName",
	        emptyRow: { fieldName: "", fieldVal: "" },
	        createTableList: _this.props.createTableList,
	        tableName: val && val.tableName && val.tableName !== undefined ? val.tableName : "",
	        fullFieldVal: val
	        // otherFields={[
	        //   { src: "name", tgt: "name" },
	        //   { src: "tableName", tgt: "tableName" }
	        // ]}
	      });
	    };
	
	    _this.dataGridStateChangeHandler = function (fullDataGridVal, arrIndex) {
	      //console.log("fullDataGridVal: " + JSON.stringify(fullDataGridVal));
	      var array = _.cloneDeep(_this.props.value);
	      array[arrIndex]["dataConditions"] = fullDataGridVal;
	
	      _this.props.stateChangeHandler(array, _this.props.stateFieldName, _this.props.isPayload);
	
	      _this.props.stateChangeHandler;
	    };
	
	    _this.move = function (oldIndex, newIndex) {
	      var array = _.cloneDeep(_this.props.value);
	      //console.log("before: " + JSON.stringify(array));
	      if (newIndex >= array.length) {
	        newIndex = array.length - 1;
	      }
	      array.splice(newIndex, 0, array.splice(oldIndex, 1)[0]);
	      //console.log("after: " + JSON.stringify(array));
	      _this.props.stateChangeHandler(array, _this.props.stateFieldName, _this.props.isPayload);
	    };
	
	    _this.getDelIcon = function (rowNum) {
	      return _react2.default.createElement("div", {
	        style: {
	          padding: "10px",
	          textAlign: "center",
	          border: "1px solid gainsboro",
	          height: "45px",
	          width: "45px"
	        }
	      }, _react2.default.createElement("a", {
	        onClick: function onClick() {
	          _this.itemDeleteHandler(rowNum);
	        }
	      }, _react2.default.createElement(_reactackleIcons.IconSvg, null, _react2.default.createElement("svg", { style: { width: "24px", height: "24px" }, viewBox: "0 0 24 24" }, _react2.default.createElement("path", {
	        fill: "currentColor",
	        d: "M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19M8,9H16V19H8V9M15.5,4L14.5,3H9.5L8.5,4H5V6H19V4H15.5Z"
	      })))));
	    };
	
	    _this.getUpIcon = function (rowNum) {
	      return _react2.default.createElement("div", {
	        className: "col-sm-2",
	        style: {
	          padding: "10px",
	          textAlign: "center",
	          border: "1px solid gainsboro",
	          height: "45px",
	          width: "45px"
	        }
	      }, _react2.default.createElement("a", {
	        onClick: function onClick() {
	          _this.move(rowNum, rowNum - 1);
	        }
	      }, _react2.default.createElement(_reactackleIcons.IconSvg, null, _react2.default.createElement("svg", { style: { width: "24px", height: "24px" }, viewBox: "0 0 24 24" }, _react2.default.createElement("path", {
	        fill: "currentColor",
	        d: "M16,13V21H8V13H2L12,3L22,13H16M7,11H10V19H14V11H17L12,6L7,11Z"
	      })))));
	    };
	
	    _this.getDownIcon = function (rowNum) {
	      return _react2.default.createElement("div", {
	        className: "col-sm-2",
	        style: {
	          padding: "10px",
	          textAlign: "center",
	          border: "1px solid gainsboro",
	          height: "45px",
	          width: "45px"
	        }
	      }, _react2.default.createElement("a", {
	        onClick: function onClick() {
	          _this.move(rowNum, rowNum + 1);
	        }
	      }, _react2.default.createElement(_reactackleIcons.IconSvg, null, _react2.default.createElement("svg", { style: { width: "24px", height: "24px" }, viewBox: "0 0 24 24" }, _react2.default.createElement("path", {
	        fill: "currentColor",
	        d: "M22,11L12,21L2,11H8V3H16V11H22M12,18L17,13H14V5H10V13H7L12,18Z"
	      })))));
	    };
	
	    _this.getPlusIcon = function (rowNum) {
	      return _react2.default.createElement("div", {
	        style: {
	          padding: "10px",
	          textAlign: "center",
	          border: "1px solid gainsboro",
	          height: "45px",
	          width: "45px"
	        }
	      }, _react2.default.createElement("a", {
	        href: "_",
	        onClick: function onClick(event) {
	          event.preventDefault();
	          _this.itemAddHandler(rowNum);
	        }
	      }, _react2.default.createElement(_reactackleIcons.IconSvg, null, _react2.default.createElement("svg", { style: { width: "24px", height: "24px" }, viewBox: "0 0 24 24" }, _react2.default.createElement("path", {
	        fill: "currentColor",
	        d: "M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z"
	      })))));
	    };
	
	    _this.itemUpdateHandler = function (rowNum, newVal) {
	      //console.log("rowNum: " + rowNum + " updated: " + newVal);
	
	      var tmpData = _.cloneDeep(_this.props.value);
	      //console.log("Before: " + JSON.stringify(tmpData[rowNum]));
	      tmpData[rowNum][_this.props.fieldNameInArray] = newVal;
	      //console.log("After: " + JSON.stringify(tmpData[rowNum]));
	
	      _this.props.stateChangeHandler(tmpData, _this.props.stateFieldName, _this.props.isPayload);
	    };
	
	    _this.itemAddHandler = function (rowNum) {
	      //console.log("fromRow: " + fromRow + " updated: " + JSON.stringify(updated));
	      var tmpData = _.cloneDeep(_this.props.value);
	      //console.log("Before: " + JSON.stringify(tmpData));
	      tmpData.splice(rowNum + 1, 0, _this.props.emptyRow);
	
	      //console.log("After: " + JSON.stringify(tmpData));
	      _this.props.stateChangeHandler(tmpData, _this.props.stateFieldName, _this.props.isPayload);
	    };
	
	    _this.itemDeleteHandler = function (rowNum) {
	      //console.log("fromRow: " + fromRow + " updated: " + JSON.stringify(updated));
	      var tmpData = _.cloneDeep(_this.props.value);
	      //console.log("Before: " + JSON.stringify(tmpData));
	      delete tmpData[rowNum];
	
	      tmpData = tmpData.filter(function (item) {
	        return item !== null;
	      });
	      //console.log("at filter:" + JSON.stringify(currActionsList));
	
	      _this.props.stateChangeHandler(tmpData, _this.props.stateFieldName, _this.props.isPayload);
	    };
	
	    _this.getSelectionList = function () {
	      return _react2.default.createElement("div", {
	        className: "row",
	        style: {
	          marginLeft: "1px",
	          marginRight: "1px",
	          alignItems: "center",
	          padding: "2px",
	          border: "0px solid gainsboro",
	          borderStyle: "solid",
	          paddingBottom: _reactDeviceDetect.isMobile ? "0px" : "2px"
	        }
	      }, _react2.default.createElement("div", {
	        className: "col-sm-2 align-self-center\u201D",
	        style: {
	          margin: "0px",
	          verticalAlign: "middle",
	          height: "auto",
	          padding: "0px"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          marginTop: _reactDeviceDetect.isMobile ? "13px" : "0px",
	          verticalAlign: "middle",
	          lineHeight: _reactDeviceDetect.isMobile ? "20px" : "37px",
	          padding: "0px",
	          paddingRight: "2px",
	          color: "grey",
	          marginBottom: _reactDeviceDetect.isMobile ? "-1px" : "0px",
	          textAlign: "left",
	          fontSize: "10px"
	        }
	      }, "Select to Add")), _react2.default.createElement("div", {
	        className: "col-sm-10",
	        style: {
	          padding: "0px",
	          textAlign: "left",
	          border: "1px solid gainsboro"
	        }
	      }));
	    };
	
	    _this.getAvailableChoices = function () {
	      var availableChoices = [];
	      if (_this.props.fieldsList && _this.props.fieldsList.length > 0) {
	        for (var i = 0; i < _this.props.fieldsList.length; i++) {
	          //console.log("~ " + this.props.fieldsList[i].name);
	          if (!_this.props.value.includes(_this.props.fieldsList[i].menu)) {
	            //console.log("~ included - " + this.props.fieldsList[i].name);
	            availableChoices.push(_this.props.fieldsList[i]);
	          } else {
	            //console.log("~ excluded - " + this.props.fieldsList[i].name);
	          }
	        }
	      }
	      return availableChoices;
	    };
	
	    _this.state = {
	      data: {
	        path: "",
	        payload: _this.props.data
	      }
	    };
	    return _this;
	  }
	
	  _createClass(MenuColumns, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement("div", {
	        className: "row",
	        style: {
	          marginLeft: "1px",
	          marginRight: "1px",
	          alignItems: "center",
	          padding: "2px",
	          border: "0px solid gainsboro",
	          paddingBottom: _reactDeviceDetect.isMobile ? "0px" : "2px"
	        }
	      }, _react2.default.createElement("div", {
	        className: "col-sm-4 align-self-center\u201D",
	        style: {
	          margin: "0px",
	          verticalAlign: "middle",
	          height: "auto",
	          padding: "0px"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          marginTop: _reactDeviceDetect.isMobile ? "13px" : "0px",
	          verticalAlign: "middle",
	          lineHeight: _reactDeviceDetect.isMobile ? "20px" : "37px",
	          padding: "0px",
	          color: _reactDeviceDetect.isMobile ? "grey" : "black",
	          marginBottom: _reactDeviceDetect.isMobile ? "-1px" : "0px"
	        }
	      }, this.props.title)), _react2.default.createElement("div", {
	        className: "col-sm-8",
	        style: _defineProperty({
	          padding: "0px",
	          textAlign: "left",
	          border: "0px solid gainsboro"
	        }, "padding", "0px")
	      }, this.getInputRows()));
	    }
	  }]);
	
	  return MenuColumns;
	}(_react.Component);
	
	exports.default = MenuColumns;

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactackle = __webpack_require__(5);
	
	var _SelectDropdownForGrid = __webpack_require__(61);
	
	var _SelectDropdownForGrid2 = _interopRequireDefault(_SelectDropdownForGrid);
	
	var _reactackleIcons = __webpack_require__(7);
	
	var _getTableFields = __webpack_require__(155);
	
	var _getTableFields2 = _interopRequireDefault(_getTableFields);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var MenuColumnsDataGrid = function (_Component) {
	  _inherits(MenuColumnsDataGrid, _Component);
	
	  function MenuColumnsDataGrid(props) {
	    _classCallCheck(this, MenuColumnsDataGrid);
	
	    var _this = _possibleConstructorReturn(this, (MenuColumnsDataGrid.__proto__ || Object.getPrototypeOf(MenuColumnsDataGrid)).call(this, props));
	
	    _this.getFieldNameInput = function (obj, arrIndex) {
	      //console.log("~~~" + JSON.stringify(this.props.fullFieldVal));
	      return _react2.default.createElement("div", {
	        style: {
	          paddingLeft: "1px",
	          textAlign: "left",
	          border: "1px solid gainsboro",
	          height: "45px"
	        }
	      }, _react2.default.createElement(_SelectDropdownForGrid2.default, {
	        title: "Title",
	        data: _this.props.tableName && _this.props.tableName !== undefined && (0, _getTableFields2.default)(_this.props.createTableList, _this.props.tableName),
	        label: "label",
	        placeholder: "placeholder",
	        value: obj && obj !== undefined ? obj[_this.props.recLimitFieldName] : "",
	        stateFieldName: _this.props.recLimitFieldName,
	        isPayload: true,
	        fieldName: "name",
	        arrayIndex: arrIndex,
	        stateHandler: function stateHandler(val, id, isPayload) {
	          console.log(val);
	          _this.itemHandler(id, val, arrIndex);
	          //this.props.limitHandler(val, "displayToggle", arrIndex);
	        }
	      }));
	    };
	
	    _this.getFieldValInput = function (obj, arrIndex) {
	      return _react2.default.createElement("div", {
	        style: {
	          paddingLeft: "1px",
	          textAlign: "right",
	          border: "1px solid gainsboro",
	          height: "45px"
	        }
	      }, _react2.default.createElement(_reactackle.TextField, {
	        value: obj && obj !== undefined ? obj[_this.props.recLimitFieldVal] : "",
	        onChange: function onChange(e) {
	          _this.itemHandler(_this.props.recLimitFieldVal, e.value, arrIndex);
	        },
	        fullWidth: true,
	        disabled: false
	      }));
	    };
	
	    _this.getColId = function (colCaption) {
	      //console.log("colCaption is: " + colCaption);
	      var allCols = _this.props.tableName && _this.props.tableName !== undefined && (0, _getTableFields2.default)(_this.props.createTableList, _this.props.tableName);
	      //console.log(JSON.stringify(allCols));
	      var tmpObj = allCols.filter(function (item) {
	        return item.name === colCaption;
	      });
	      var tgtObj = tmpObj[0];
	      //console.log("tmpObj: " + JSON.stringify(tmpObj));
	      //console.log("tgtObj: " + JSON.stringify(tgtObj));
	      return tgtObj && tgtObj.fieldName ? tgtObj.fieldName : "";
	    };
	
	    _this.itemHandler = function (fldName, val, rowNum) {
	      // console.log(
	      //   rowNum +
	      //     ":" +
	      //     fldName +
	      //     ":" +
	      //     JSON.stringify(val) +
	      //     " propName: " +
	      //     this.props.recLimitFieldName
	      // );
	      var newArray = _.cloneDeep(_this.props.value);
	      // console.log(
	      //   this.props.arrIndex +
	      //     ":" +
	      //     rowNum +
	      //     ":" +
	      //     JSON.stringify(newArray[rowNum])
	      // );
	      if (fldName === _this.props.recLimitFieldName) {
	        var _extends2;
	
	        //console.log("matches");
	        newArray[rowNum] = _extends({}, newArray[rowNum], (_extends2 = {}, _defineProperty(_extends2, fldName, val), _defineProperty(_extends2, "colKey", _this.getColId(val)), _extends2));
	      } else {
	        newArray[rowNum] = _extends({}, newArray[rowNum], _defineProperty({}, fldName, val));
	      }
	
	      // console.log(
	      //   this.props.arrIndex +
	      //     ":" +
	      //     rowNum +
	      //     ":" +
	      //     JSON.stringify(newArray[rowNum])
	      // );
	      _this.props.stateChangeHandler(newArray, _this.props.arrIndex);
	    };
	
	    _this.getInputRows = function () {
	      if (_this.props.value && _this.props.value.length > 0) {
	        return _this.props.value.map(function (val, arrIndex) {
	          return _react2.default.createElement("tr", null, _react2.default.createElement("td", { style: { width: "45px" } }, _this.getDelIcon(arrIndex)), _react2.default.createElement("td", { style: { width: "45px" } }, _this.getPlusIcon(arrIndex)), _react2.default.createElement("td", null, _this.getFieldNameInput(val, arrIndex)), _react2.default.createElement("td", null, _this.getFieldValInput(val, arrIndex)));
	        });
	      } else {
	        return _react2.default.createElement(_reactackle.Button, {
	          text: "Add Data Restrictions",
	          onPress: function onPress() {
	            var _ref;
	
	            _this.props.stateChangeHandler([(_ref = {}, _defineProperty(_ref, _this.props.recLimitFieldName, ""), _defineProperty(_ref, _this.props.recLimitFieldVal, ""), _ref)], _this.props.arrIndex);
	          },
	          colorScheme: "primary",
	          outlined: true
	        });
	      }
	    };
	
	    _this.move = function (oldIndex, newIndex) {
	      var array = _.cloneDeep(_this.props.value);
	      //console.log("before: " + JSON.stringify(array));
	      if (newIndex >= array.length) {
	        newIndex = array.length - 1;
	      }
	      array.splice(newIndex, 0, array.splice(oldIndex, 1)[0]);
	      //console.log("after: " + JSON.stringify(array));
	      _this.props.stateChangeHandler(array, _this.props.stateFieldName, _this.props.isPayload, _this.props.arrIndex);
	    };
	
	    _this.getDelIcon = function (rowNum) {
	      return _react2.default.createElement("div", {
	        style: {
	          padding: "10px",
	          textAlign: "center",
	          border: "1px solid gainsboro",
	          height: "45px",
	          width: "45px"
	        }
	      }, _react2.default.createElement("a", {
	        onClick: function onClick() {
	          _this.itemDeleteHandler(rowNum);
	        }
	      }, _react2.default.createElement(_reactackleIcons.IconSvg, null, _react2.default.createElement("svg", { style: { width: "24px", height: "24px" }, viewBox: "0 0 24 24" }, _react2.default.createElement("path", {
	        fill: "currentColor",
	        d: "M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19M8,9H16V19H8V9M15.5,4L14.5,3H9.5L8.5,4H5V6H19V4H15.5Z"
	      })))));
	    };
	
	    _this.getUpIcon = function (rowNum) {
	      return _react2.default.createElement("div", {
	        className: "col-sm-2",
	        style: {
	          padding: "10px",
	          textAlign: "center",
	          border: "1px solid gainsboro",
	          height: "45px",
	          width: "45px"
	        }
	      }, _react2.default.createElement("a", {
	        onClick: function onClick() {
	          _this.move(rowNum, rowNum - 1);
	        }
	      }, _react2.default.createElement(_reactackleIcons.IconSvg, null, _react2.default.createElement("svg", { style: { width: "24px", height: "24px" }, viewBox: "0 0 24 24" }, _react2.default.createElement("path", {
	        fill: "currentColor",
	        d: "M16,13V21H8V13H2L12,3L22,13H16M7,11H10V19H14V11H17L12,6L7,11Z"
	      })))));
	    };
	
	    _this.getDownIcon = function (rowNum) {
	      return _react2.default.createElement("div", {
	        className: "col-sm-2",
	        style: {
	          padding: "10px",
	          textAlign: "center",
	          border: "1px solid gainsboro",
	          height: "45px",
	          width: "45px"
	        }
	      }, _react2.default.createElement("a", {
	        onClick: function onClick() {
	          _this.move(rowNum, rowNum + 1);
	        }
	      }, _react2.default.createElement(_reactackleIcons.IconSvg, null, _react2.default.createElement("svg", { style: { width: "24px", height: "24px" }, viewBox: "0 0 24 24" }, _react2.default.createElement("path", {
	        fill: "currentColor",
	        d: "M22,11L12,21L2,11H8V3H16V11H22M12,18L17,13H14V5H10V13H7L12,18Z"
	      })))));
	    };
	
	    _this.getPlusIcon = function (rowNum) {
	      return _react2.default.createElement("div", {
	        style: {
	          padding: "10px",
	          textAlign: "center",
	          border: "1px solid gainsboro",
	          height: "45px",
	          width: "45px"
	        }
	      }, _react2.default.createElement("a", {
	        href: "_",
	        onClick: function onClick(event) {
	          event.preventDefault();
	          _this.itemAddHandler(rowNum);
	        }
	      }, _react2.default.createElement(_reactackleIcons.IconSvg, null, _react2.default.createElement("svg", { style: { width: "24px", height: "24px" }, viewBox: "0 0 24 24" }, _react2.default.createElement("path", {
	        fill: "currentColor",
	        d: "M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z"
	      })))));
	    };
	
	    _this.itemUpdateHandler = function (rowNum, newVal) {
	      //console.log("rowNum: " + rowNum + " updated: " + newVal);
	
	      var tmpData = _.cloneDeep(_this.props.value);
	      //console.log("Before: " + JSON.stringify(tmpData[rowNum]));
	      tmpData[rowNum][_this.props.fieldNameInArray] = newVal;
	      //console.log("After: " + JSON.stringify(tmpData[rowNum]));
	
	      _this.props.stateChangeHandler(tmpData, _this.props.stateFieldName, _this.props.isPayload);
	    };
	
	    _this.itemAddHandler = function (rowNum) {
	      //console.log("fromRow: " + fromRow + " updated: " + JSON.stringify(updated));
	      var tmpData = _.cloneDeep(_this.props.value);
	      //console.log("Before: " + JSON.stringify(tmpData));
	      tmpData.splice(rowNum + 1, 0, _this.props.emptyRow);
	
	      //console.log("After: " + JSON.stringify(tmpData));
	      _this.props.stateChangeHandler(tmpData, _this.props.arrIndex);
	    };
	
	    _this.itemDeleteHandler = function (rowNum) {
	      //console.log("fromRow: " + fromRow + " updated: " + JSON.stringify(updated));
	      var tmpData = _.cloneDeep(_this.props.value);
	      //console.log("Before: " + JSON.stringify(tmpData));
	      delete tmpData[rowNum];
	
	      tmpData = tmpData.filter(function (item) {
	        return item !== null;
	      });
	      //console.log("at filter:" + JSON.stringify(currActionsList));
	
	      _this.props.stateChangeHandler(tmpData, _this.props.arrIndex);
	    };
	
	    _this.getAvailableChoices = function () {
	      var availableChoices = [];
	
	      // for (let i = 0; i < this.props.fieldsList.length; i++) {
	      //   //console.log("~ " + this.props.fieldsList[i].name);
	      //   if (!this.props.value.includes(this.props.fieldsList[i].menu)) {
	      //     //console.log("~ included - " + this.props.fieldsList[i].name);
	      //     availableChoices.push(this.props.fieldsList[i]);
	      //   } else {
	      //     //console.log("~ excluded - " + this.props.fieldsList[i].name);
	      //   }
	      // }
	      return availableChoices;
	    };
	
	    _this.state = {
	      data: {
	        path: "",
	        payload: _this.props.data
	      }
	    };
	    return _this;
	  }
	
	  _createClass(MenuColumnsDataGrid, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement("table", { className: "table table-striped" }, this.getInputRows());
	    }
	  }]);
	
	  return MenuColumnsDataGrid;
	}(_react.Component);
	
	exports.default = MenuColumnsDataGrid;

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactackle = __webpack_require__(5);
	
	var _reactDeviceDetect = __webpack_require__(6);
	
	var _reactackleIcons = __webpack_require__(7);
	
	var _reactSelect = __webpack_require__(92);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var customStyles = {
	  control: function control(provided, state) {
	    return _extends({}, provided, {
	      width: "100%",
	      borderWidth: "0px",
	      borderBottomWidth: "0px",
	      borderRadius: "0px"
	    });
	  },
	  menu: function menu(base) {
	    return _extends({}, base, {
	      zIndex: 100
	    });
	  }
	};
	
	var SimpleFormulaList = function (_Component) {
	  _inherits(SimpleFormulaList, _Component);
	
	  function SimpleFormulaList(props) {
	    _classCallCheck(this, SimpleFormulaList);
	
	    var _this = _possibleConstructorReturn(this, (SimpleFormulaList.__proto__ || Object.getPrototypeOf(SimpleFormulaList)).call(this, props));
	
	    _this.getInput = function (rec, arrIndex, fieldName) {
	      return _react2.default.createElement("div", {
	        style: {
	          paddingLeft: "1px",
	          textAlign: "right",
	          border: "1px solid gainsboro",
	          height: "45px"
	        }
	      }, _react2.default.createElement(_reactackle.TextField, {
	        value: rec[fieldName],
	        onChange: function onChange(e) {
	          _this.itemUpdateHandler(arrIndex, e.value, fieldName);
	        },
	        fullWidth: true
	      }));
	    };
	
	    _this.getOperatorDropdown = function (rec, arrIndex, fieldName) {
	      return _react2.default.createElement("div", {
	        style: {
	          paddingLeft: "1px",
	          textAlign: "center",
	          border: "1px solid gainsboro",
	          height: "45px",
	          width: "75px"
	        }
	      }, _react2.default.createElement(_reactSelect2.default, {
	        onChange: function onChange(newValue, actionMeta) {
	          if (actionMeta.action === "clear") {} else {
	            if (newValue && newValue !== undefined) {
	              _this.itemUpdateHandler(arrIndex, newValue.value, fieldName);
	            }
	          }
	        },
	        options: [{ value: "+", label: "+" }, { value: "-", label: "-" }, { value: "*", label: "*" }, { value: "/", label: "/" }],
	        label: "",
	        placeholder: "",
	        value: { value: rec[fieldName], label: rec[fieldName] },
	        styles: customStyles,
	        defaultValue: "",
	        theme: function theme(_theme) {
	          return _extends({}, _theme, {
	            borderRadius: 0,
	            colors: _extends({}, _theme.colors, {
	              primary: "blue"
	            }),
	            borderBottomWidth: "0px",
	            borderBottomColor: "blue"
	          });
	        }
	      }));
	    };
	
	    _this.move = function (oldIndex, newIndex) {
	      var array = _.cloneDeep(_this.props.data);
	      //console.log("before: " + JSON.stringify(array));
	      if (newIndex >= array.length) {
	        newIndex = array.length - 1;
	      }
	      array.splice(newIndex, 0, array.splice(oldIndex, 1)[0]);
	      //console.log("after: " + JSON.stringify(array));
	      _this.props.stateChangeHandler(array, _this.props.stateFieldName, _this.props.isPayload);
	    };
	
	    _this.getDelIcon = function (rowNum) {
	      return _react2.default.createElement("div", {
	        style: {
	          padding: "10px",
	          textAlign: "center",
	          border: "1px solid gainsboro",
	          height: "45px",
	          width: "45px"
	        }
	      }, _react2.default.createElement("a", {
	        onClick: function onClick() {
	          _this.itemDeleteHandler(rowNum);
	        }
	      }, _react2.default.createElement(_reactackleIcons.IconSvg, null, _react2.default.createElement("svg", { style: { width: "24px", height: "24px" }, viewBox: "0 0 24 24" }, _react2.default.createElement("path", {
	        fill: "currentColor",
	        d: "M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19M8,9H16V19H8V9M15.5,4L14.5,3H9.5L8.5,4H5V6H19V4H15.5Z"
	      })))));
	    };
	
	    _this.getUpIcon = function (rowNum) {
	      return _react2.default.createElement("div", {
	        className: "col-sm-2",
	        style: {
	          padding: "10px",
	          textAlign: "center",
	          border: "1px solid gainsboro",
	          height: "45px",
	          width: "45px"
	        }
	      }, _react2.default.createElement("a", {
	        onClick: function onClick() {
	          _this.move(rowNum, rowNum - 1);
	        }
	      }, _react2.default.createElement(_reactackleIcons.IconSvg, null, _react2.default.createElement("svg", { style: { width: "24px", height: "24px" }, viewBox: "0 0 24 24" }, _react2.default.createElement("path", {
	        fill: "currentColor",
	        d: "M16,13V21H8V13H2L12,3L22,13H16M7,11H10V19H14V11H17L12,6L7,11Z"
	      })))));
	    };
	
	    _this.getDownIcon = function (rowNum) {
	      return _react2.default.createElement("div", {
	        className: "col-sm-2",
	        style: {
	          padding: "10px",
	          textAlign: "center",
	          border: "1px solid gainsboro",
	          height: "45px",
	          width: "45px"
	        }
	      }, _react2.default.createElement("a", {
	        onClick: function onClick() {
	          _this.move(rowNum, rowNum + 1);
	        }
	      }, _react2.default.createElement(_reactackleIcons.IconSvg, null, _react2.default.createElement("svg", { style: { width: "24px", height: "24px" }, viewBox: "0 0 24 24" }, _react2.default.createElement("path", {
	        fill: "currentColor",
	        d: "M22,11L12,21L2,11H8V3H16V11H22M12,18L17,13H14V5H10V13H7L12,18Z"
	      })))));
	    };
	
	    _this.getPlusIcon = function (rowNum) {
	      return _react2.default.createElement("div", {
	        style: {
	          padding: "10px",
	          textAlign: "center",
	          border: "1px solid gainsboro",
	          height: "45px",
	          width: "45px"
	        }
	      }, _react2.default.createElement("a", {
	        href: "_",
	        onClick: function onClick(event) {
	          event.preventDefault();
	          _this.itemAddHandler(rowNum);
	        }
	      }, _react2.default.createElement(_reactackleIcons.IconSvg, null, _react2.default.createElement("svg", { style: { width: "24px", height: "24px" }, viewBox: "0 0 24 24" }, _react2.default.createElement("path", {
	        fill: "currentColor",
	        d: "M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z"
	      })))));
	    };
	
	    _this.itemUpdateHandler = function (rowNum, newVal, fieldName) {
	      //console.log("rowNum: " + rowNum + " updated: " + newVal);
	
	      var tmpData = _.cloneDeep(_this.props.data);
	      //console.log("Before: " + JSON.stringify(tmpData[rowNum]));
	      tmpData[rowNum][fieldName] = newVal;
	      //console.log("After: " + JSON.stringify(tmpData[rowNum]));
	
	      _this.props.stateChangeHandler(tmpData, _this.props.stateFieldName, _this.props.isPayload);
	    };
	
	    _this.itemAddHandler = function (rowNum) {
	      //console.log("fromRow: " + fromRow + " updated: " + JSON.stringify(updated));
	      var tmpData = _.cloneDeep(_this.props.data);
	      if (tmpData && tmpData !== undefined) {
	        //console.log("Before: " + JSON.stringify(tmpData));
	        tmpData.splice(rowNum + 1, 0, _this.props.emptyRow);
	      } else {
	        tmpData = [];
	        tmpData.push(_this.props.emptyRow);
	      }
	
	      //console.log("After: " + JSON.stringify(tmpData));
	      _this.props.stateChangeHandler(tmpData, _this.props.stateFieldName, _this.props.isPayload);
	    };
	
	    _this.itemDeleteHandler = function (rowNum) {
	      //console.log("fromRow: " + fromRow + " updated: " + JSON.stringify(updated));
	      var tmpData = JSON.parse(JSON.stringify(_this.props.data));
	      //console.log("Before: " + JSON.stringify(tmpData));
	      delete tmpData[rowNum];
	
	      tmpData = tmpData.filter(function (item) {
	        return item !== null;
	      });
	      //console.log("at filter:" + JSON.stringify(currActionsList));
	
	      _this.props.stateChangeHandler(tmpData, _this.props.stateFieldName, _this.props.isPayload);
	    };
	
	    _this.getInputRows = function () {
	      if (_this.props.data && _this.props.data.length > 0) {
	        return _this.props.data.map(function (rec, arrIndex) {
	          return _react2.default.createElement("tr", null, _react2.default.createElement("td", { style: { width: "45px" } }, _this.getDelIcon(arrIndex)), _react2.default.createElement("td", { style: { width: "45px" } }, _this.getUpIcon(arrIndex)), _react2.default.createElement("td", { style: { width: "45px" } }, _this.getDownIcon(arrIndex)), _react2.default.createElement("td", { style: { width: "45px" } }, _this.getPlusIcon(arrIndex)), _react2.default.createElement("td", null, _this.getInput(rec, arrIndex, "operand1")), _react2.default.createElement("td", null, _this.getOperatorDropdown(rec, arrIndex, "operation")), _react2.default.createElement("td", null, _this.getInput(rec, arrIndex, "operand2")), _react2.default.createElement("td", null, _this.getOperatorDropdown(rec, arrIndex, "nextOperation")));
	        });
	      } else {
	        return _react2.default.createElement("tr", {
	          style: {
	            border: "0px solid gainsboro"
	          }
	        }, _react2.default.createElement("td", {
	          style: {
	            width: "45px",
	            verticalAlign: "top",
	            paddingBottom: "5px",
	            paddingLeft: "5px",
	            paddingTop: "5px",
	            textAlign: "left"
	          },
	          colSpan: 3
	        }, _react2.default.createElement(_reactackle.Button, {
	          text: _this.props.emptyTitle,
	          onPress: function onPress() {
	            return _this.itemAddHandler(0);
	          },
	          colorScheme: "primary",
	          outlined: true
	        })));
	      }
	    };
	
	    _this.state = {
	      data: {
	        path: "",
	        payload: _this.props.data
	      }
	    };
	    return _this;
	  }
	
	  _createClass(SimpleFormulaList, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement("div", {
	        className: "row",
	        style: {
	          marginLeft: "1px",
	          marginRight: "1px",
	          alignItems: "center",
	          padding: "2px",
	          border: "0px",
	          borderBottom: "0px",
	          borderBottomColor: "#cccccc",
	          borderStyle: "solid",
	          paddingBottom: _reactDeviceDetect.isMobile ? "0px" : "2px"
	        }
	      }, _react2.default.createElement("div", {
	        className: "col-sm-4 align-self-center\u201D",
	        style: {
	          margin: "0px",
	          verticalAlign: "middle",
	          height: "auto",
	          padding: "0px"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          marginTop: _reactDeviceDetect.isMobile ? "13px" : "0px",
	          verticalAlign: "middle",
	          lineHeight: _reactDeviceDetect.isMobile ? "20px" : "37px",
	          padding: "0px",
	          color: _reactDeviceDetect.isMobile ? "grey" : "black",
	          marginBottom: _reactDeviceDetect.isMobile ? "-1px" : "0px"
	        }
	      }, this.props.title)), _react2.default.createElement("div", {
	        className: "col-sm-8",
	        style: {
	          padding: "0px",
	          textAlign: "right",
	          border: "0px solid gainsboro"
	        }
	      }, _react2.default.createElement("table", { className: "table table-striped" }, this.getInputRows())));
	    }
	  }]);
	
	  return SimpleFormulaList;
	}(_react.Component);
	
	exports.default = SimpleFormulaList;

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactackle = __webpack_require__(5);
	
	var _reactDeviceDetect = __webpack_require__(6);
	
	var _reactackleIcons = __webpack_require__(7);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var SimpleUniList = function (_Component) {
	  _inherits(SimpleUniList, _Component);
	
	  function SimpleUniList(props) {
	    _classCallCheck(this, SimpleUniList);
	
	    var _this = _possibleConstructorReturn(this, (SimpleUniList.__proto__ || Object.getPrototypeOf(SimpleUniList)).call(this, props));
	
	    _this.stateChangeHandler = function (val, id, isPayload) {
	      //console.log("val: " + val + " id: " + id + " isPayload: " + isPayload);
	      var tmpState = {};
	      tmpState[id] = val;
	
	      if (isPayload) {
	        _this.setState(function (prevState) {
	          if (prevState && prevState.data.payload !== null) {
	            return _extends({}, prevState, {
	              data: _extends({}, prevState.data, {
	                payload: _extends({}, prevState.data.payload, tmpState)
	              })
	            });
	          } else {
	            return _extends({}, prevState, {
	              data: {
	                path: prevState.data.path,
	                payload: _extends({}, tmpState)
	              }
	            });
	          }
	        }, function () {
	          return _this.props.stateHandler(_this.state.data.payload, _this.props.arrayIndex);
	        });
	      } else {
	        _this.setState(function (prevState) {
	          return _extends({}, prevState, tmpState);
	        });
	      }
	    };
	
	    _this.getInput = function (rec, arrIndex) {
	      return _react2.default.createElement("div", {
	        style: {
	          paddingLeft: "1px",
	          textAlign: "right",
	          border: "1px solid gainsboro",
	          height: "45px"
	        }
	      }, _react2.default.createElement(_reactackle.TextField, {
	        value: rec[_this.props.fieldNameInArray],
	        onChange: function onChange(e) {
	          _this.itemUpdateHandler(arrIndex, e.value);
	        },
	        fullWidth: true
	      }));
	    };
	
	    _this.move = function (oldIndex, newIndex) {
	      var array = _.cloneDeep(_this.props.data);
	      //console.log("before: " + JSON.stringify(array));
	      if (newIndex >= array.length) {
	        newIndex = array.length - 1;
	      }
	      array.splice(newIndex, 0, array.splice(oldIndex, 1)[0]);
	      //console.log("after: " + JSON.stringify(array));
	      _this.props.stateChangeHandler(array, _this.props.stateFieldName, _this.props.isPayload);
	    };
	
	    _this.getDelIcon = function (rowNum) {
	      return _react2.default.createElement("div", {
	        style: {
	          padding: "10px",
	          textAlign: "center",
	          border: "1px solid gainsboro",
	          height: "45px",
	          width: "45px"
	        }
	      }, _react2.default.createElement("a", {
	        onClick: function onClick() {
	          _this.itemDeleteHandler(rowNum);
	        }
	      }, _react2.default.createElement(_reactackleIcons.IconSvg, null, _react2.default.createElement("svg", { style: { width: "24px", height: "24px" }, viewBox: "0 0 24 24" }, _react2.default.createElement("path", {
	        fill: "currentColor",
	        d: "M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19M8,9H16V19H8V9M15.5,4L14.5,3H9.5L8.5,4H5V6H19V4H15.5Z"
	      })))));
	    };
	
	    _this.getUpIcon = function (rowNum) {
	      return _react2.default.createElement("div", {
	        className: "col-sm-2",
	        style: {
	          padding: "10px",
	          textAlign: "center",
	          border: "1px solid gainsboro",
	          height: "45px",
	          width: "45px"
	        }
	      }, _react2.default.createElement("a", {
	        onClick: function onClick() {
	          _this.move(rowNum, rowNum - 1);
	        }
	      }, _react2.default.createElement(_reactackleIcons.IconSvg, null, _react2.default.createElement("svg", { style: { width: "24px", height: "24px" }, viewBox: "0 0 24 24" }, _react2.default.createElement("path", {
	        fill: "currentColor",
	        d: "M16,13V21H8V13H2L12,3L22,13H16M7,11H10V19H14V11H17L12,6L7,11Z"
	      })))));
	    };
	
	    _this.getDownIcon = function (rowNum) {
	      return _react2.default.createElement("div", {
	        className: "col-sm-2",
	        style: {
	          padding: "10px",
	          textAlign: "center",
	          border: "1px solid gainsboro",
	          height: "45px",
	          width: "45px"
	        }
	      }, _react2.default.createElement("a", {
	        onClick: function onClick() {
	          _this.move(rowNum, rowNum + 1);
	        }
	      }, _react2.default.createElement(_reactackleIcons.IconSvg, null, _react2.default.createElement("svg", { style: { width: "24px", height: "24px" }, viewBox: "0 0 24 24" }, _react2.default.createElement("path", {
	        fill: "currentColor",
	        d: "M22,11L12,21L2,11H8V3H16V11H22M12,18L17,13H14V5H10V13H7L12,18Z"
	      })))));
	    };
	
	    _this.getPlusIcon = function (rowNum) {
	      return _react2.default.createElement("div", {
	        style: {
	          padding: "10px",
	          textAlign: "center",
	          border: "1px solid gainsboro",
	          height: "45px",
	          width: "45px"
	        }
	      }, _react2.default.createElement("a", {
	        href: "_",
	        onClick: function onClick(event) {
	          event.preventDefault();
	          _this.itemAddHandler(rowNum);
	        }
	      }, _react2.default.createElement(_reactackleIcons.IconSvg, null, _react2.default.createElement("svg", { style: { width: "24px", height: "24px" }, viewBox: "0 0 24 24" }, _react2.default.createElement("path", {
	        fill: "currentColor",
	        d: "M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z"
	      })))));
	    };
	
	    _this.itemUpdateHandler = function (rowNum, newVal) {
	      //console.log("rowNum: " + rowNum + " updated: " + newVal);
	
	      var tmpData = _.cloneDeep(_this.props.data);
	      //console.log("Before: " + JSON.stringify(tmpData[rowNum]));
	      tmpData[rowNum][_this.props.fieldNameInArray] = newVal;
	      //console.log("After: " + JSON.stringify(tmpData[rowNum]));
	
	      _this.props.stateChangeHandler(tmpData, _this.props.stateFieldName, _this.props.isPayload);
	    };
	
	    _this.itemAddHandler = function (rowNum) {
	      //console.log("fromRow: " + fromRow + " updated: " + JSON.stringify(updated));
	      var tmpData = _.cloneDeep(_this.props.data);
	      //console.log("Before: " + JSON.stringify(tmpData));
	      tmpData.splice(rowNum + 1, 0, _this.props.emptyRow);
	
	      //console.log("After: " + JSON.stringify(tmpData));
	      _this.props.stateChangeHandler(tmpData, _this.props.stateFieldName, _this.props.isPayload);
	    };
	
	    _this.itemDeleteHandler = function (rowNum) {
	      //console.log("fromRow: " + fromRow + " updated: " + JSON.stringify(updated));
	      var tmpData = JSON.parse(JSON.stringify(_this.props.data));
	      //console.log("Before: " + JSON.stringify(tmpData));
	      delete tmpData[rowNum];
	
	      tmpData = tmpData.filter(function (item) {
	        return item !== null;
	      });
	      //console.log("at filter:" + JSON.stringify(currActionsList));
	
	      _this.props.stateChangeHandler(tmpData, _this.props.stateFieldName, _this.props.isPayload);
	    };
	
	    _this.getInputRows = function () {
	      if (_this.props.data && _this.props.data.length > 0) {
	        return _this.props.data.map(function (rec, arrIndex) {
	          return _react2.default.createElement("tr", null, _react2.default.createElement("td", { style: { width: "45px" } }, _this.getDelIcon(arrIndex)), _react2.default.createElement("td", { style: { width: "45px" } }, _this.getUpIcon(arrIndex)), _react2.default.createElement("td", { style: { width: "45px" } }, _this.getDownIcon(arrIndex)), _react2.default.createElement("td", { style: { width: "45px" } }, _this.getPlusIcon(arrIndex)), _react2.default.createElement("td", null, _this.getInput(rec, arrIndex)));
	        });
	      } else {
	        return _react2.default.createElement("tr", {
	          style: {
	            border: "0px solid gainsboro"
	          }
	        }, _react2.default.createElement("td", {
	          style: {
	            width: "45px",
	            verticalAlign: "top",
	            paddingBottom: "5px",
	            paddingLeft: "5px",
	            paddingTop: "5px",
	            textAlign: "left"
	          },
	          colSpan: 3
	        }, _react2.default.createElement(_reactackle.Button, {
	          text: _this.props.emptyTitle,
	          onPress: function onPress() {
	            return _this.itemAddHandler(0);
	          },
	          colorScheme: "primary",
	          outlined: true
	        })));
	      }
	    };
	
	    _this.state = {
	      data: {
	        path: "",
	        payload: _this.props.data
	      }
	    };
	    return _this;
	  }
	
	  //single method that work for all fields
	  //takes incoming id of the field and then adds field data to state
	
	
	  _createClass(SimpleUniList, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement("div", {
	        className: "row",
	        style: {
	          marginLeft: "1px",
	          marginRight: "1px",
	          alignItems: "center",
	          padding: "2px",
	          border: "0px",
	          borderBottom: "0px",
	          borderBottomColor: "#cccccc",
	          borderStyle: "solid",
	          paddingBottom: _reactDeviceDetect.isMobile ? "0px" : "2px"
	        }
	      }, _react2.default.createElement("div", {
	        className: "col-sm-4 align-self-center\u201D",
	        style: {
	          margin: "0px",
	          verticalAlign: "middle",
	          height: "auto",
	          padding: "0px"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          marginTop: _reactDeviceDetect.isMobile ? "13px" : "0px",
	          verticalAlign: "middle",
	          lineHeight: _reactDeviceDetect.isMobile ? "20px" : "37px",
	          padding: "0px",
	          color: _reactDeviceDetect.isMobile ? "grey" : "black",
	          marginBottom: _reactDeviceDetect.isMobile ? "-1px" : "0px"
	        }
	      }, this.props.title)), _react2.default.createElement("div", {
	        className: "col-sm-8",
	        style: {
	          padding: "0px",
	          textAlign: "right",
	          border: "0px solid gainsboro"
	        }
	      }, _react2.default.createElement("table", { className: "table table-striped" }, this.getInputRows())));
	    }
	  }]);
	
	  return SimpleUniList;
	}(_react.Component);
	
	exports.default = SimpleUniList;

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactackle = __webpack_require__(5);
	
	var _reactDeviceDetect = __webpack_require__(6);
	
	__webpack_require__(246);
	
	var _lodash = __webpack_require__(22);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _recompose = __webpack_require__(11);
	
	var _Firebase = __webpack_require__(10);
	
	var _reactRedux = __webpack_require__(9);
	
	var _uuid = __webpack_require__(249);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _toConsumableArray(arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
	      arr2[i] = arr[i];
	    }return arr2;
	  } else {
	    return Array.from(arr);
	  }
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var PhotoUpload = function (_Component) {
	  _inherits(PhotoUpload, _Component);
	
	  function PhotoUpload() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PhotoUpload);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PhotoUpload.__proto__ || Object.getPrototypeOf(PhotoUpload)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      uploading: false,
	      progress: "0"
	    }, _this.b64toBlob = function (b64Data) {
	      var contentType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
	      var sliceSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 512;
	
	      var byteCharacters = atob(b64Data);
	      var byteArrays = [];
	
	      for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
	        var slice = byteCharacters.slice(offset, offset + sliceSize);
	
	        var byteNumbers = new Array(slice.length);
	        for (var i = 0; i < slice.length; i++) {
	          byteNumbers[i] = slice.charCodeAt(i);
	        }
	
	        var byteArray = new Uint8Array(byteNumbers);
	        byteArrays.push(byteArray);
	      }
	
	      var blob = new Blob(byteArrays, { type: contentType });
	      return blob;
	    }, _this.getImages = function () {
	      if (_this.state.images && _this.state.images.length > 0) {
	        return _this.state.images.map(function (imgData, index) {
	          //console.log("chota image: " + imgData.url);
	          if (imgData.action !== "REMOVE") {
	            return _react2.default.createElement("div", {
	              className: "img",
	              style: {
	                backgroundImage: imgData.url !== "" ? "url('" + imgData.url + "')" : "url(data:image/png;base64," + imgData.b64 + ")",
	                backgroundSize: "contain",
	                backgroundRepeat: "no-repeat",
	                maxWidth: "150px",
	                border: "1px solid gainsboro"
	              },
	              onClick: function onClick() {
	                var imgArray = _lodash2.default.cloneDeep(_this.state.images);
	                imgArray[index].action = "REMOVE";
	                if (imgArray[index].url === "") {
	                  imgArray.splice(index, 1);
	                }
	
	                var stateImgArray = _lodash2.default.cloneDeep(_this.state.stateImages);
	                stateImgArray[index].status = "REMOVING...";
	                if (stateImgArray[index].url === "") {
	                  stateImgArray.splice(index, 1);
	                }
	
	                _this.setState(function (prevState) {
	                  return _extends({}, prevState, {
	                    images: imgArray,
	                    stateImages: stateImgArray
	                  });
	                });
	
	                _this.props.stateChangeHandler(imgArray, _this.props.fieldName, false);
	
	                _this.props.stateChangeHandler(stateImgArray, _this.props.fieldName, true);
	              }
	            }, _react2.default.createElement("span", {
	              style: {
	                position: "absolute",
	                top: 0,
	                right: 0,
	                color: "red"
	              }
	            }, _react2.default.createElement("i", {
	              className: "fa fa-times-circle fa-lg",
	              style: { backgroundColor: "white" }
	            })));
	          }
	        });
	      }
	    }, _this.uploadImage = function (evtFiles) {
	      try {
	        console.log("triggering inside uploadImage function");
	        var imageName = (0, _uuid.v1)() + ".jpg";
	        var Compress = __webpack_require__(81);
	        var compress = new Compress();
	        var files = [].concat(_toConsumableArray(evtFiles));
	        compress.compress(files, {
	          size: 2, // the max size in MB, defaults to 2MB
	          quality: 1, // the quality of the image, max is 1,
	          maxWidth: 300, // the max width of the output image, defaults to 1920px
	          maxHeight: 300, // the max height of the output image, defaults to 1920px
	          resize: true // defaults to true, set false if you do not want to resize the image width and height
	        }).then(function (data) {
	          //console.log("after conversion: " + JSON.stringify(data));
	          var imgArray = [];
	          var stateImgArray = [];
	          if (_this.state.images && _this.state.images.length > 0) {
	            imgArray = _lodash2.default.cloneDeep(_this.state.images);
	          }
	          if (_this.state.stateImages && _this.state.stateImages.length > 0) {
	            stateImgArray = _lodash2.default.cloneDeep(_this.state.stateImages);
	          }
	          imgArray.push({
	            action: "ADD",
	            imageName: imageName,
	            url: "",
	            b64: data[0].data,
	            blob: _this.b64toBlob(data[0].data)
	          });
	          stateImgArray.push({
	            status: "UPLOADING...",
	            imageName: imageName,
	            url: ""
	          });
	          _this.setState(function (prevState) {
	            return _extends({}, prevState, {
	              images: imgArray,
	              stateImages: stateImgArray
	            });
	          });
	          _this.props.stateChangeHandler(imgArray, _this.props.fieldName, false);
	          _this.props.stateChangeHandler(stateImgArray, _this.props.fieldName, true);
	        });
	      } catch (err) {
	        alert(err);
	      }
	    }, _this.getViewOnlyImages = function () {
	      if (_this.props.images && _this.props.images.length > 0) {
	        return _this.props.images.map(function (photo) {
	          return _react2.default.createElement("div", {
	            style: {
	              textAlign: "center"
	            }
	          }, _react2.default.createElement("img", {
	            src: "https://storage.googleapis.com/bcsfbtest/images/" + photo.imageName,
	            style: {
	              maxHeight: "200px",
	              maxWidth: "200px",
	              height: "200px",
	              width: "200px",
	              borderRadius: "10px",
	              border: "0px solid gainsboro",
	              objectFit: "contain",
	              position: "abosolute",
	              top: "0",
	              left: "0",
	              zIndex: "2"
	            }
	          }));
	        });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(PhotoUpload, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var newImages = [];
	      var stateImages = [];
	      if (this.props.images && this.props.images.length > 0) {
	        newImages = this.props.images.map(function (image) {
	          return {
	            action: "",
	            url: image.url,
	            imageName: image.imageName,
	            b64: "",
	            blob: ""
	          };
	        });
	        stateImages = this.props.images.map(function (image) {
	          return {
	            status: "DONE",
	            url: image.url,
	            imageName: image.imageName
	          };
	        });
	      }
	      this.setState(function (prevState) {
	        return _extends({}, prevState, {
	          images: newImages,
	          stateImages: stateImages
	        });
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _ref2,
	          _this2 = this;
	
	      return _react2.default.createElement("div", {
	        className: "row",
	        style: {
	          marginLeft: "1px",
	          marginRight: "1px",
	          alignItems: "center",
	          padding: "2px",
	          border: "0px",
	          borderBottom: "0px",
	          borderBottomColor: "#cccccc",
	          borderStyle: "solid",
	          paddingBottom: _reactDeviceDetect.isMobile ? "0px" : "2px"
	        }
	      }, _react2.default.createElement("div", {
	        className: "col-sm-4 align-self-center\u201D",
	        style: {
	          margin: "0px",
	          verticalAlign: "middle",
	          height: "auto",
	          padding: "0px"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          marginTop: _reactDeviceDetect.isMobile ? "13px" : "0px",
	          verticalAlign: "middle",
	          lineHeight: _reactDeviceDetect.isMobile ? "20px" : "37px",
	          padding: "0px",
	          color: _reactDeviceDetect.isMobile ? "black" : "black",
	          marginBottom: _reactDeviceDetect.isMobile ? "-1px" : "0px"
	        }
	      }, this.props.title)), _react2.default.createElement("div", {
	        className: "col-sm-8",
	        style: {
	          padding: "1px",
	          border: "1px solid gainsboro",
	          borderRadius: _reactDeviceDetect.isMobile ? "5px" : "0px",
	          backgroundColor: "white",
	          minHeight: "100px"
	        }
	      }, _react2.default.createElement("div", null, !this.props.disabled && _react2.default.createElement("div", { className: "images" }, this.getImages()), !this.props.disabled && _react2.default.createElement("div", null, _react2.default.createElement("label", {
	        "for": "uploader",
	        style: (_ref2 = {
	          padding: "1px",
	          textAlign: "right",
	          border: "1px solid gainsboro",
	          borderRadius: _reactDeviceDetect.isMobile ? "5px" : "0px",
	          backgroundColor: "#2196F3",
	          margin: "5px"
	        }, _defineProperty(_ref2, "padding", "6px"), _defineProperty(_ref2, "fontWeight", "bold"), _defineProperty(_ref2, "color", "white"), _ref2)
	      }, _react2.default.createElement("i", { className: "fa fa-plus" }), " TAP TO ADD PHOTO")), this.props.disabled && _react2.default.createElement("div", null, this.getViewOnlyImages()))), _react2.default.createElement("input", {
	        type: "file",
	        accept: "image/*",
	        id: "uploader",
	        onChange: function onChange(evt) {
	          console.log("clicked");
	          //console.log("triggering main function");
	          event.preventDefault();
	
	          if (evt.target.files[0]) {
	            _this2.uploadImage(evt.target.files);
	          } else {
	            console.log("gotcha");
	          }
	        },
	        style: {
	          visibility: "hidden"
	        }
	      }));
	    }
	  }]);
	
	  return PhotoUpload;
	}(_react.Component);
	
	exports.default = (0, _recompose.compose)((0, _reactRedux.connect)(null, null), _Firebase.withFirebase)(PhotoUpload);

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	};
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactackle = __webpack_require__(5);
	
	var _reactDeviceDetect = __webpack_require__(6);
	
	var _reactackleIcons = __webpack_require__(7);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof2(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var SubGridVanilla = function (_Component) {
	  _inherits(SubGridVanilla, _Component);
	
	  function SubGridVanilla() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SubGridVanilla);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SubGridVanilla.__proto__ || Object.getPrototypeOf(SubGridVanilla)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      selectedIndexes: []
	    }, _this.getRowCount = function () {
	      ////console.log("Data Length: " + this.props.data.length);
	      if (_this.props.data && _this.props.data.length > 0) {
	        return _this.props.data.length;
	      } else {
	        return 0;
	      }
	    }, _this.getDataWithEmptyRow = function (singleRow) {
	      var empRow = {};
	      for (var key in singleRow) {
	        empRow[key] = "";
	      }
	      _this.props.data.push(empRow);
	      return _this.props.data;
	    }, _this.rowGetter = function (i) {
	      ////console.log("Sending Row: " + JSON.stringify(this.props.data[i]));
	      if (_this.props.data && _this.props.data.length > 0) {
	        return _extends({}, _this.props.data[i]);
	      }
	    }, _this.onRowsSelected = function (rows) {
	      _this.setState({
	        selectedIndexes: _this.state.selectedIndexes.concat(rows.map(function (r) {
	          return r.rowIdx;
	        }))
	      });
	    }, _this.onRowsDeselected = function (rows) {
	      var rowIndexes = rows.map(function (r) {
	        return r.rowIdx;
	      });
	      _this.setState({
	        selectedIndexes: _this.state.selectedIndexes.filter(function (i) {
	          return rowIndexes.indexOf(i) === -1;
	        })
	      });
	    }, _this.deleteSelected = function () {
	      if (_this.props.data && _this.props.data.length < 2) {
	        alert("Not enough items to be deleted");
	      } else {
	        var oldArray = _this.props.data;
	        var newArray = [];
	        for (var i = 0; i < _this.props.data.length - 1; i++) {
	          if (!_this.state.selectedIndexes.includes(i)) {
	            newArray.push(oldArray[i]);
	          }
	        }
	
	        _this.props.stateChangeHandler(newArray, _this.props.fieldName, _this.props.isPayload);
	      }
	    }, _this.addRows = function () {
	      console.log("adding rows...");
	      var newArray = [];
	      if (_this.props.data && _this.props.data.length > 0) {
	        newArray = _this.props.data.map(function (item) {
	          return item;
	        });
	        newArray.push(_this.props.emptyRow);
	      } else {
	        newArray.push(_this.props.emptyRow);
	      }
	      console.log(JSON.stringify(newArray));
	      _this.props.stateChangeHandler(newArray, _this.props.fieldName, _this.props.isPayload);
	    }, _this.doCalc = function (val1, val2, strOperator) {
	      // console.log(
	      //   "in doCalc, recvd val1:" +
	      //     val1 +
	      //     " " +
	      //     " val2:" +
	      //     val2 +
	      //     " operator:" +
	      //     strOperator
	      // );
	      var result = "0";
	      if (val1 === "" || val2 === "" || val1 === undefined || val1 === null || val2 === undefined || val2 === null) {
	        return result;
	      }
	
	      var num1 = parseFloat(val1);
	      var num2 = parseFloat(val2);
	      if (!isNaN(num1) && !isNaN(num2)) {
	        // console.log(
	        //   "All good about to do calc " + num1 + "  " + strOperator + "  " + num2
	        // );
	        var calcRes = 0.0;
	        if (strOperator === "*") {
	          calcRes = num1 * num2;
	        } else if (strOperator === "+") {
	          calcRes = num1 + num2;
	        } else if (strOperator === "-") {
	          calcRes = num1 - num2;
	        } else if (strOperator === "/") {
	          calcRes = num1 / num2;
	        } else {
	          calcRes = result;
	        }
	        return calcRes.toFixed(2);
	      } else {
	        return result;
	      }
	    }, _this.executeCalc = function (calcRule, data, rowNum) {
	      calcRule = calcRule.replace(" ", "");
	      calcRule = calcRule.replace(/\*/g, " * ");
	      calcRule = calcRule.replace(/\+/g, " + ");
	      calcRule = calcRule.replace(/-/g, " - ");
	      calcRule = calcRule.replace(/\//g, " / ");
	      var calcRuleArray = calcRule.split(" ");
	      //console.log("calcRule array: " + JSON.stringify(calcRuleArray));
	      var res = _this.doCalc(data[calcRuleArray[0]], data[calcRuleArray[2]], calcRuleArray[1]);
	
	      //console.log("Here is the res: " + res);
	      return res;
	    }, _this.updateCalcValues = function (tmpData, fieldDefs, rowNum) {
	      // console.log(
	      //   "Updating calc values: " +
	      //     JSON.stringify(tmpData) +
	      //     " defs: " +
	      //     JSON.stringify(fieldDefs)
	      // );
	      for (var key in fieldDefs) {
	        var fieldDets = fieldDefs[key];
	        if (fieldDets.mode && fieldDets.mode === "calc") {
	          //console.log("Key is: " + fieldDets.key);
	          tmpData[rowNum][fieldDets.key] = _this.executeCalc(fieldDets.rule, tmpData[rowNum]);
	        }
	      }
	      //console.log("Updated tmpData is: " + JSON.stringify(tmpData));
	      return tmpData[rowNum];
	    }, _this.onGridRowsUpdated = function (fromRow, toRow, updated, tableDef) {
	      //console.log("fromRow: " + fromRow + " updated: " + JSON.stringify(updated));
	      if (updated && updated !== undefined) {
	        var key = Object.keys(updated);
	        var tmpData = JSON.parse(JSON.stringify(_this.props.data));
	        //console.log("Before: " + JSON.stringify(tmpData[fromRow]));
	        tmpData[fromRow][key] = updated[key];
	        tmpData[fromRow] = _this.updateCalcValues(tmpData, tableDef, fromRow);
	        //console.log("After: " + JSON.stringify(tmpData));
	        _this.props.stateChangeHandler(tmpData, _this.props.fieldName, _this.props.isPayload);
	      }
	    }, _this.onGridRowsAdded = function (rowNum) {
	      //console.log("fromRow: " + fromRow + " updated: " + JSON.stringify(updated));
	
	      var tmpData = JSON.parse(JSON.stringify(_this.props.data));
	      //console.log("Before: " + JSON.stringify(tmpData));
	      tmpData.splice(rowNum + 1, 0, _this.props.emptyRow);
	
	      //console.log("After: " + JSON.stringify(tmpData));
	      _this.props.stateChangeHandler(tmpData, _this.props.fieldName, _this.props.isPayload);
	    }, _this.onGridRowsDeleted = function (rowNum) {
	      //console.log("fromRow: " + fromRow + " updated: " + JSON.stringify(updated));
	
	      var tmpData = JSON.parse(JSON.stringify(_this.props.data));
	      //console.log("Before: " + JSON.stringify(tmpData));
	      delete tmpData[rowNum];
	
	      tmpData = tmpData.filter(function (item) {
	        return item !== null;
	      });
	      //console.log("at filter:" + JSON.stringify(currActionsList));
	
	      //console.log("After: " + JSON.stringify(tmpData));
	      _this.props.stateChangeHandler(tmpData, _this.props.fieldName, _this.props.isPayload);
	    }, _this.getCellValue = function (fldName, fldValue, rowNum, tableDef, rec) {
	      //console.log(
	      //   "getCellValue: fldname: " +
	      //     fldName +
	      //     "  fldValue: " +
	      //     fldValue +
	      //     " rowNum:" +
	      //     rowNum
	      // );
	      if ((typeof jsonValue === "undefined" ? "undefined" : _typeof(jsonValue)) !== "object") {
	        return _react2.default.createElement("td", { style: { padding: "0px", borderWidth: "0px" } }, _react2.default.createElement(_reactackle.TextField, {
	          bordered: true,
	          value: fldValue,
	          resize: "auto",
	          multiline: true,
	          multilineRows: { min: 4 },
	          disabled: rec.disabled,
	          onChange: function onChange(val) {
	            //console.log("Value from text field: " + JSON.stringify(val));
	            var updatedObj = {};
	            updatedObj[fldName] = val.value;
	            //console.log(
	            //   "updated value: " +
	            //     JSON.stringify(updatedObj) +
	            //     " rowNum: " +
	            //     rowNum
	            // );
	            _this.onGridRowsUpdated(rowNum, rowNum, updatedObj, tableDef);
	          },
	          style: { margin: "0px", padding: "0px" }
	        }));
	      }
	    }, _this.getColumns = function (rowNum, jObject, tableDef) {
	      //console.log("jObject: " + JSON.stringify(jObject));
	      //console.log("rowNum: " + rowNum);
	      //console.log("tableDef: " + JSON.stringify(tableDef));
	      return tableDef.map(function (rec, index) {
	        return _this.getCellValue(rec.key, jObject[rec.key], rowNum, tableDef, rec);
	      });
	    }, _this.getMobileStyle = function () {
	      if (_reactDeviceDetect.isMobile) {
	        return {
	          display: "block"
	        };
	      }
	    }, _this.getDelIcon = function (rowIndex) {
	      return _react2.default.createElement("div", {
	        className: "col-sm-2",
	        style: {
	          padding: "10px",
	          textAlign: "center",
	          border: "1px solid gainsboro",
	          height: "45px",
	          width: "45px"
	        }
	      }, _react2.default.createElement("a", {
	        onClick: function onClick() {
	          _this.onGridRowsDeleted(rowIndex);
	        }
	      }, _react2.default.createElement(_reactackleIcons.IconSvg, null, _react2.default.createElement("svg", { style: { width: "24px", height: "24px" }, viewBox: "0 0 24 24" }, _react2.default.createElement("path", {
	        fill: "currentColor",
	        d: "M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19M8,9H16V19H8V9M15.5,4L14.5,3H9.5L8.5,4H5V6H19V4H15.5Z"
	      })))));
	    }, _this.getUpIcon = function () {
	      return _react2.default.createElement("div", {
	        className: "col-sm-2",
	        style: {
	          padding: "10px",
	          textAlign: "center",
	          border: "1px solid gainsboro",
	          height: "45px",
	          width: "45px"
	        }
	      }, _react2.default.createElement(_reactackleIcons.IconSvg, null, _react2.default.createElement("svg", { style: { width: "24px", height: "24px" }, viewBox: "0 0 24 24" }, _react2.default.createElement("path", {
	        fill: "currentColor",
	        d: "M16,13V21H8V13H2L12,3L22,13H16M7,11H10V19H14V11H17L12,6L7,11Z"
	      }))));
	    }, _this.getDownIcon = function () {
	      return _react2.default.createElement("div", {
	        className: "col-sm-2",
	        style: {
	          padding: "10px",
	          textAlign: "center",
	          border: "1px solid gainsboro",
	          height: "45px",
	          width: "45px"
	        }
	      }, _react2.default.createElement(_reactackleIcons.IconSvg, null, _react2.default.createElement("svg", { style: { width: "24px", height: "24px" }, viewBox: "0 0 24 24" }, _react2.default.createElement("path", {
	        fill: "currentColor",
	        d: "M22,11L12,21L2,11H8V3H16V11H22M12,18L17,13H14V5H10V13H7L12,18Z"
	      }))));
	    }, _this.getPlusIcon = function (rowIndex) {
	      return _react2.default.createElement("div", {
	        className: "col-sm-2",
	        style: {
	          padding: "10px",
	          textAlign: "center",
	          border: "1px solid gainsboro",
	          height: "45px",
	          width: "45px"
	        }
	      }, _react2.default.createElement("a", {
	        href: "_",
	        onClick: function onClick(event) {
	          event.preventDefault();
	          _this.onGridRowsAdded(rowIndex);
	        }
	      }, _react2.default.createElement(_reactackleIcons.IconSvg, null, _react2.default.createElement("svg", { style: { width: "24px", height: "24px" }, viewBox: "0 0 24 24" }, _react2.default.createElement("path", {
	        fill: "currentColor",
	        d: "M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z"
	      })))));
	    }, _this.getRows = function (data) {
	      if (data && data !== undefined && data.length > 0) {
	        return data.map(function (rec, rowNum) {
	          return _react2.default.createElement("tr", { style: _this.getMobileStyle() }, _react2.default.createElement("td", { style: { width: "100px" } }, _react2.default.createElement("div", null, _this.getDelIcon(rowNum), _this.getPlusIcon(rowNum))), _this.getColumns(rowNum, rec, _this.props.colDefs));
	        });
	      }
	    }, _this.getHeaderRow = function (tableDef) {
	      return Object.keys(tableDef).map(function (key) {
	        if (key !== "searches") {
	          return _react2.default.createElement("th", { className: "col-sm-1" }, tableDef[key].name);
	        }
	      });
	    }, _this.getVanillaGrid = function () {
	      //console.log(JSON.stringify(this.props.data));
	      return _react2.default.createElement("div", { className: "table-responsive" }, _react2.default.createElement("hr", null), _react2.default.createElement("h3", { style: { textAlign: "left" } }, _this.props.caption), _react2.default.createElement("table", {
	        className: "table table-striped table-bordered table-sm",
	        cellSpacing: "0",
	        width: "100%",
	        style: {
	          marginBottom: "0px"
	        }
	      }, _react2.default.createElement("thead", null, _react2.default.createElement("tr", null, _react2.default.createElement("th", { className: "col-sm-1" }, "Actions"), _this.getHeaderRow(_this.props.colDefs))), _react2.default.createElement("tbody", null, _this.getRows(_this.props.data))), _react2.default.createElement("div", {
	        style: {
	          display: "flex",
	          flexDirection: "row-reverse",
	          padding: "0px"
	        }
	      }, _react2.default.createElement("div", { sytle: { float: "right" } }, _react2.default.createElement(_reactackle.Button, {
	        text: "Add",
	        className: "flat",
	        style: { padding: "0px", margin: "0px" },
	        onPress: function onPress() {
	          return _this.addRows();
	        }
	      }), _react2.default.createElement(_reactackle.Button, {
	        text: "Delete",
	        className: "flat",
	        style: { padding: "0px", margin: "0px" },
	        onPress: function onPress() {
	          return _this.deleteSelected();
	        }
	      }))));
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SubGridVanilla, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement("div", null, this.getVanillaGrid());
	    }
	  }]);
	
	  return SubGridVanilla;
	}(_react.Component);
	
	exports.default = SubGridVanilla;

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	};
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactackle = __webpack_require__(5);
	
	var _reactackleIcons = __webpack_require__(7);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof2(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var SubGridVanillaMobile = function (_Component) {
	  _inherits(SubGridVanillaMobile, _Component);
	
	  function SubGridVanillaMobile() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SubGridVanillaMobile);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SubGridVanillaMobile.__proto__ || Object.getPrototypeOf(SubGridVanillaMobile)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      selectedIndexes: []
	    }, _this.getRowCount = function () {
	      ////console.log("Data Length: " + this.props.data.length);
	      if (_this.props.data && _this.props.data.length > 0) {
	        return _this.props.data.length;
	      } else {
	        return 0;
	      }
	    }, _this.getDataWithEmptyRow = function (singleRow) {
	      var empRow = {};
	      for (var key in singleRow) {
	        empRow[key] = "";
	      }
	      _this.props.data.push(empRow);
	      return _this.props.data;
	    }, _this.rowGetter = function (i) {
	      ////console.log("Sending Row: " + JSON.stringify(this.props.data[i]));
	      if (_this.props.data && _this.props.data.length > 0) {
	        return _extends({}, _this.props.data[i]);
	      }
	    }, _this.onRowsSelected = function (rows) {
	      _this.setState({
	        selectedIndexes: _this.state.selectedIndexes.concat(rows.map(function (r) {
	          return r.rowIdx;
	        }))
	      });
	    }, _this.onRowsDeselected = function (rows) {
	      var rowIndexes = rows.map(function (r) {
	        return r.rowIdx;
	      });
	      _this.setState({
	        selectedIndexes: _this.state.selectedIndexes.filter(function (i) {
	          return rowIndexes.indexOf(i) === -1;
	        })
	      });
	    }, _this.deleteSelected = function () {
	      if (_this.props.data && _this.props.data.length < 2) {
	        alert("Not enough items to be deleted");
	      } else {
	        var oldArray = _this.props.data;
	        var newArray = [];
	        for (var i = 0; i < _this.props.data.length - 1; i++) {
	          if (!_this.state.selectedIndexes.includes(i)) {
	            newArray.push(oldArray[i]);
	          }
	        }
	
	        _this.props.stateChangeHandler(newArray, _this.props.fieldName, _this.props.isPayload);
	      }
	    }, _this.addRows = function () {
	      console.log("adding rows...");
	      var newArray = [];
	      if (_this.props.data && _this.props.data.length > 0) {
	        newArray = _this.props.data.map(function (item) {
	          return item;
	        });
	        newArray.push(_this.props.emptyRow);
	      } else {
	        newArray.push(_this.props.emptyRow);
	      }
	      //console.log(JSON.stringify(newArray));
	      _this.props.stateChangeHandler(newArray, _this.props.fieldName, _this.props.isPayload);
	    }, _this.doCalc = function (val1, val2, strOperator) {
	      // console.log(
	      //   "in doCalc, recvd val1:" +
	      //     val1 +
	      //     " " +
	      //     " val2:" +
	      //     val2 +
	      //     " operator:" +
	      //     strOperator
	      // );
	      var result = "0";
	      if (val1 === "" || val2 === "" || val1 === undefined || val1 === null || val2 === undefined || val2 === null) {
	        return result;
	      }
	
	      var num1 = parseFloat(val1);
	      var num2 = parseFloat(val2);
	      if (!isNaN(num1) && !isNaN(num2)) {
	        // console.log(
	        //   "All good about to do calc " + num1 + "  " + strOperator + "  " + num2
	        // );
	        if (strOperator === "*") {
	          return num1 * num2;
	        } else if (strOperator === "+") {
	          return num1 + num2;
	        } else if (strOperator === "-") {
	          return num1 - num2;
	        } else if (strOperator === "/") {
	          return num1 / num2;
	        } else {
	          return result;
	        }
	      } else {
	        return result;
	      }
	    }, _this.executeCalc = function (calcRule, data, rowNum) {
	      calcRule = calcRule.replace(" ", "");
	      calcRule = calcRule.replace(/\*/g, " * ");
	      calcRule = calcRule.replace(/\+/g, " + ");
	      calcRule = calcRule.replace(/-/g, " - ");
	      calcRule = calcRule.replace(/\//g, " / ");
	      var calcRuleArray = calcRule.split(" ");
	      //console.log("calcRule array: " + JSON.stringify(calcRuleArray));
	      var res = _this.doCalc(data[calcRuleArray[0]], data[calcRuleArray[2]], calcRuleArray[1]);
	
	      //console.log("Here is the res: " + res);
	      return res;
	    }, _this.updateCalcValues = function (tmpData, fieldDefs, rowNum) {
	      // console.log(
	      //   "Updating calc values: " +
	      //     JSON.stringify(tmpData) +
	      //     " defs: " +
	      //     JSON.stringify(fieldDefs)
	      // );
	      for (var key in fieldDefs) {
	        var fieldDets = fieldDefs[key];
	        if (fieldDets.mode && fieldDets.mode === "calc") {
	          //console.log("Key is: " + fieldDets.key);
	          tmpData[rowNum][fieldDets.key] = _this.executeCalc(fieldDets.rule, tmpData[rowNum]);
	        }
	      }
	      //console.log("Updated tmpData is: " + JSON.stringify(tmpData));
	      return tmpData[rowNum];
	    }, _this.onGridRowsUpdated = function (fromRow, toRow, updated, tableDef) {
	      //console.log("fromRow: " + fromRow + " updated: " + JSON.stringify(updated));
	      if (updated && updated !== undefined) {
	        var key = Object.keys(updated);
	        var tmpData = JSON.parse(JSON.stringify(_this.props.data));
	        //console.log("Before: " + JSON.stringify(tmpData[fromRow]));
	        tmpData[fromRow][key] = updated[key];
	        tmpData[fromRow] = _this.updateCalcValues(tmpData, tableDef, fromRow);
	        //console.log("After: " + JSON.stringify(tmpData));
	        _this.props.stateChangeHandler(tmpData, _this.props.fieldName, _this.props.isPayload);
	      }
	    }, _this.getCellValue = function (fldName, fldValue, rowNum, tableDef, rec) {
	      //console.log(
	      //   "getCellValue: fldname: " +
	      //     fldName +
	      //     "  fldValue: " +
	      //     fldValue +
	      //     " rowNum:" +
	      //     rowNum
	      // );
	      if ((typeof jsonValue === "undefined" ? "undefined" : _typeof(jsonValue)) !== "object") {
	        return _react2.default.createElement(_reactackle.TextField, {
	          bordered: true,
	          value: fldValue,
	          resize: "auto",
	          placeholder: fldName,
	          multiline: fldName === "description" ? true : false,
	          multilineRows: { min: fldName === "description" ? 6 : 1 },
	          disabled: rec.disabled,
	          onChange: function onChange(val) {
	            //console.log("Value from text field: " + JSON.stringify(val));
	            var updatedObj = {};
	            updatedObj[fldName] = val.value;
	            //console.log(
	            //   "updated value: " +
	            //     JSON.stringify(updatedObj) +
	            //     " rowNum: " +
	            //     rowNum
	            // );
	            _this.onGridRowsUpdated(rowNum, rowNum, updatedObj, tableDef);
	          },
	          style: { margin: "0px", padding: "0px" }
	        });
	      }
	    }, _this.getColumns = function (rowNum, jObject, tableDef) {
	      //console.log("jObject: " + JSON.stringify(jObject));
	      //console.log("rowNum: " + rowNum);
	      //console.log("tableDef: " + JSON.stringify(tableDef));
	      return tableDef.map(function (rec, index) {
	        return _this.getCellValue(rec.key, jObject[rec.key], rowNum, tableDef, rec);
	      });
	    }, _this.getDelIcon = function (rowIndex) {
	      return _react2.default.createElement("a", {
	        onClick: function onClick() {
	          _this.onGridRowsDeleted(rowIndex);
	        }
	      }, _react2.default.createElement(_reactackleIcons.IconSvg, null, _react2.default.createElement("svg", { style: { width: "24px", height: "24px" }, viewBox: "0 0 24 24" }, _react2.default.createElement("path", {
	        fill: "currentColor",
	        d: "M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19M8,9H16V19H8V9M15.5,4L14.5,3H9.5L8.5,4H5V6H19V4H15.5Z"
	      }))));
	    }, _this.getUpIcon = function () {
	      return _react2.default.createElement("div", {
	        className: "col-sm-2",
	        style: {
	          padding: "10px",
	          textAlign: "center",
	          border: "1px solid gainsboro",
	          height: "45px",
	          width: "45px"
	        }
	      }, _react2.default.createElement(_reactackleIcons.IconSvg, null, _react2.default.createElement("svg", { style: { width: "24px", height: "24px" }, viewBox: "0 0 24 24" }, _react2.default.createElement("path", {
	        fill: "currentColor",
	        d: "M16,13V21H8V13H2L12,3L22,13H16M7,11H10V19H14V11H17L12,6L7,11Z"
	      }))));
	    }, _this.getDownIcon = function () {
	      return _react2.default.createElement("div", {
	        className: "col-sm-2",
	        style: {
	          padding: "10px",
	          textAlign: "center",
	          border: "1px solid gainsboro",
	          height: "45px",
	          width: "45px"
	        }
	      }, _react2.default.createElement(_reactackleIcons.IconSvg, null, _react2.default.createElement("svg", { style: { width: "24px", height: "24px" }, viewBox: "0 0 24 24" }, _react2.default.createElement("path", {
	        fill: "currentColor",
	        d: "M22,11L12,21L2,11H8V3H16V11H22M12,18L17,13H14V5H10V13H7L12,18Z"
	      }))));
	    }, _this.getPlusIcon = function (rowIndex) {
	      return _react2.default.createElement("a", {
	        href: "_",
	        onClick: function onClick(event) {
	          event.preventDefault();
	          _this.onGridRowsAdded(rowIndex);
	        }
	      }, _react2.default.createElement(_reactackleIcons.IconSvg, null, _react2.default.createElement("svg", { style: { width: "24px", height: "24px" }, viewBox: "0 0 24 24" }, _react2.default.createElement("path", {
	        fill: "currentColor",
	        d: "M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z"
	      }))));
	    }, _this.onGridRowsAdded = function (rowNum) {
	      //console.log("fromRow: " + fromRow + " updated: " + JSON.stringify(updated));
	
	      var tmpData = JSON.parse(JSON.stringify(_this.props.data));
	      //console.log("Before: " + JSON.stringify(tmpData));
	      tmpData.splice(rowNum + 1, 0, _this.props.emptyRow);
	
	      //console.log("After: " + JSON.stringify(tmpData));
	      _this.props.stateChangeHandler(tmpData, _this.props.fieldName, _this.props.isPayload);
	    }, _this.onGridRowsDeleted = function (rowNum) {
	      //console.log("fromRow: " + fromRow + " updated: " + JSON.stringify(updated));
	
	      var tmpData = JSON.parse(JSON.stringify(_this.props.data));
	      //console.log("Before: " + JSON.stringify(tmpData));
	      delete tmpData[rowNum];
	
	      tmpData = tmpData.filter(function (item) {
	        return item !== null;
	      });
	      //console.log("at filter:" + JSON.stringify(currActionsList));
	
	      //console.log("After: " + JSON.stringify(tmpData));
	      _this.props.stateChangeHandler(tmpData, _this.props.fieldName, _this.props.isPayload);
	    }, _this.getRows = function (data) {
	      if (data && data !== undefined && data.length > 0) {
	        return data.map(function (rec, rowNum) {
	          return _react2.default.createElement("div", {
	            style: {
	              margin: "5px",
	              padding: "5px",
	              borderColor: "grey",
	              borderStyle: "solid",
	              borderWidth: "0.25px"
	            }
	          }, _this.getColumns(rowNum, rec, _this.props.colDefs), _react2.default.createElement("div", {
	            style: {
	              margin: "5px",
	              height: "45px"
	            }
	          }, _react2.default.createElement("div", {
	            className: "col-sm-2",
	            style: {
	              padding: "10px",
	              textAlign: "center",
	              border: "1px solid gainsboro",
	              height: "45px",
	              width: "45px",
	              marginRight: "5px",
	              float: "right"
	            }
	          }, _this.getPlusIcon(rowNum)), _react2.default.createElement("div", {
	            style: {
	              padding: "10px",
	              textAlign: "center",
	              border: "1px solid gainsboro",
	              height: "45px",
	              width: "45px",
	              float: "right",
	              marginLeft: "5px"
	            }
	          }, _this.getDelIcon(rowNum))));
	        });
	      }
	    }, _this.getVanillaGrid = function () {
	      console.log(JSON.stringify(_this.props.data));
	      return _react2.default.createElement("div", null, _react2.default.createElement("hr", null), _react2.default.createElement("h3", { style: { textAlign: "left" } }, _this.props.caption), _react2.default.createElement("div", null, _this.getRows(_this.props.data)), _react2.default.createElement("div", {
	        style: {
	          display: "flex",
	          flexDirection: "row-reverse",
	          padding: "0px"
	        }
	      }, _react2.default.createElement("div", { sytle: { float: "right" } }, _react2.default.createElement(_reactackle.Button, {
	        text: "Add",
	        className: "flat",
	        style: { padding: "0px", margin: "0px" },
	        onPress: function onPress() {
	          return _this.addRows();
	        }
	      }), _react2.default.createElement(_reactackle.Button, {
	        text: "Delete",
	        className: "flat",
	        style: { padding: "0px", margin: "0px" },
	        onPress: function onPress() {
	          return _this.deleteSelected();
	        }
	      }))));
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SubGridVanillaMobile, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement("div", null, this.getVanillaGrid());
	    }
	  }]);
	
	  return SubGridVanillaMobile;
	}(_react.Component);
	
	exports.default = SubGridVanillaMobile;

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _recompose = __webpack_require__(11);
	
	var _Firebase = __webpack_require__(10);
	
	var _checkBeforeSave = __webpack_require__(78);
	
	var _checkBeforeSave2 = _interopRequireDefault(_checkBeforeSave);
	
	var _reactackle = __webpack_require__(5);
	
	var _addAudits = __webpack_require__(25);
	
	var _getInputField = __webpack_require__(18);
	
	var _getInputField2 = _interopRequireDefault(_getInputField);
	
	var _reactDeviceDetect = __webpack_require__(6);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var User = function (_Component) {
	  _inherits(User, _Component);
	
	  function User() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, User);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = User.__proto__ || Object.getPrototypeOf(User)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      data: {
	        path: _this.props.path,
	        payload: _extends({}, _this.props.selectedusers, {
	          author: _this.props.userEmail && _this.props.userEmail !== undefined ? _this.props.userEmail : ""
	        })
	      },
	      showForm: true
	    }, _this.stateChangeHandler = function (val, id, isPayload) {
	      //console.log("val: " + val + " id: " + id + " isPayload: " + isPayload);
	      var tmpState = {};
	      tmpState[id] = val;
	
	      if (isPayload) {
	        _this.setState(function (prevState) {
	          if (prevState && prevState.data.payload !== null) {
	            return _extends({}, prevState, {
	              data: _extends({}, prevState.data, {
	                payload: _extends({}, prevState.data.payload, tmpState)
	              })
	            });
	          } else {
	            return _extends({}, prevState, {
	              data: {
	                path: prevState.data.path,
	                payload: _extends({}, tmpState)
	              }
	            });
	          }
	        });
	      } else {
	        _this.setState(function (prevState) {
	          return _extends({}, prevState, tmpState);
	        });
	      }
	    }, _this.getField = function (fieldName, disabled) {
	      return (0, _getInputField2.default)(fieldName, _this.props.path, _this.state.data, _this.stateChangeHandler, disabled, _this.props.ogTableDef, _this.props.db, _reactDeviceDetect.isMobile);
	    }, _this.getFields = function () {
	      return Object.keys(_this.props.ogTableDef[_this.props.path]).map(function (fldKey) {
	        return _this.getField(fldKey);
	      });
	    }, _this.updateUserTable = function () {
	      var cloudPath = "";
	      if (_this.state.data.payload && _this.state.data.payload.key && _this.state.data.payload.key !== "") {
	        cloudPath = _this.props.path + "/" + _this.state.data.payload.key;
	        Promise.all([(0, _addAudits.addAudit)(_this.stateChangeHandler, _this.props.firebase.auth.currentUser && _this.props.firebase.auth.currentUser.phoneNumber ? _this.props.firebase.auth.currentUser.phoneNumber : "")]).then(function (res) {
	          _this.props.firebase.db.ref("/" + cloudPath).once("value").then(function (snap) {
	            return snap.ref.set(_this.state.data.payload);
	          }).catch(function (err) {
	            console.log(err);
	            return console.log("some error: " + err);
	          }).then(function (err) {
	            return _this.props.handleEditCancel();
	          });
	        });
	      } else {
	        cloudPath = _this.props.path;
	        Promise.all([(0, _addAudits.addAudit)(_this.stateChangeHandler, _this.props.userEmail)]).then(function (res) {
	          var newInv = _this.props.firebase.db.ref("/" + cloudPath).push();
	          newInv.set(_this.state.data.payload).catch(function (err) {
	            alert("Please contact support. New user creation failed. Error: " + err);
	            console.log(err);
	            return console.log("some error: " + err);
	          }).then(function (err) {
	            return _this.props.handleEditCancel();
	          });
	        });
	      }
	    }, _this.saveHandler = function () {
	      //existing user
	      _this.updateUserTable();
	
	      //this.props.handleEditCancel();
	    }, _this.getLoader = function () {
	      return _react2.default.createElement(_reactackle.CardContent, null, _react2.default.createElement(_reactackle.CircleProgress, { indeterminate: true, subtitle: "Saving..." }));
	    }, _this.checkInputs = function () {
	      if (_this.state.password !== "" && _this.state.data.payload.userEmail !== "" && _this.state.data.payload.roleName !== "") {
	        console.log("disabled is false");
	        return false;
	      } else {
	        console.log("disabled is true");
	        return true;
	      }
	    }, _this.getTopHeader = function () {
	      return _react2.default.createElement("div", null, _react2.default.createElement(_reactackle.Card, null, _react2.default.createElement(_reactackle.CardAreaMain, null, !_reactDeviceDetect.isMobile && _react2.default.createElement(_reactackle.CardContent, null, _react2.default.createElement("div", null, _react2.default.createElement("h1", null, "USER"))), _react2.default.createElement(_reactackle.CardActions, null, _react2.default.createElement(_reactackle.CardActionsSupplemental, null, _this.props.operationType !== "add" && _react2.default.createElement(_reactackle.Button, {
	        text: "DELETE",
	        onPress: function onPress(e) {
	          if (_this.state.data.payload.key && _this.state.data.payload.key !== "") {
	            window.confirm("Are you sure you wish to delete this item?") && _this.props.handleDelete(_this.state.data.payload.key, _this.props.path);
	          }
	        },
	        colorScheme: "warning",
	        disabled: !_this.state.showForm
	      }), _react2.default.createElement(_reactackle.Button, {
	        text: "SAVE",
	        onPress: function onPress() {
	          return _this.saveHandler();
	        },
	        colorScheme: "primary",
	        disabled: !_this.state.showForm || (0, _checkBeforeSave2.default)(_this.props.path, _this.state.data.payload, _this.props.ogTableDef)
	      }), _react2.default.createElement(_reactackle.Button, {
	        text: "CANCEL",
	        onPress: function onPress() {
	          return _this.props.handleEditCancel();
	        },
	        colorScheme: "primary",
	        disabled: !_this.state.showForm
	      }))))));
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(User, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      //console.log("1212 attendance did mounting");
	      if (this.props.operationType === "add") {
	        var date = new Date();
	        var createDateTime = date.toLocaleString();
	        this.stateChangeHandler(createDateTime, "createDateTime", true);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement("div", null, _react2.default.createElement("div", null, this.getTopHeader()), _reactDeviceDetect.isMobile && _react2.default.createElement("div", null, this.state.showForm && this.getFields(), !this.state.showForm && this.getLoader()), !_reactDeviceDetect.isMobile && _react2.default.createElement(_reactackle.Card, null, _react2.default.createElement(_reactackle.CardAreaMain, { style: { padding: "0px" } }, _react2.default.createElement(_reactackle.CardContent, { style: { pading: "0px" } }, this.state.showForm && this.getFields(), !this.state.showForm && this.getLoader()))));
	    }
	  }]);
	
	  return User;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    userEmail: state.db.currentUser.userEmail,
	    currUser: state.db.currentUser,
	    isSuperAdmin: state.ui.isThisSuperAdmin,
	    isAdmin: state.ui.isThisAdmin,
	    userName: state.db.currentUser.userName,
	    attList: state.db.attendance,
	    userProfile: state.db.userProfile,
	    projects: state.db.projects,
	    users: state.db.users,
	    editMode: state.ui.editMode,
	    selectedusers: state.db.selectedusers,
	    operationType: state.ui.operationType,
	    showSpinner: state.ui.showSpinner,
	    createNewRec: state.ui.operationType === "add",
	    db: state.db
	  };
	}
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    onAddRecord: function onAddRecord(data) {
	      return dispatch(actionAddArray2Redux(data));
	    },
	    onSelectRecord: function onSelectRecord(params) {
	      return dispatch(selectARecord(params));
	    }
	  };
	};
	
	exports.default = (0, _recompose.compose)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _Firebase.withFirebase)(User);

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDeviceDetect = __webpack_require__(6);
	
	var _reactackle = __webpack_require__(5);
	
	var _lodash = __webpack_require__(22);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var AgraniRegCard = function (_Component) {
	  _inherits(AgraniRegCard, _Component);
	
	  function AgraniRegCard() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, AgraniRegCard);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AgraniRegCard.__proto__ || Object.getPrototypeOf(AgraniRegCard)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      data: {
	        path: "",
	        payload: ""
	      },
	      mode: "collapseView", //1. collapseView 2. expandView 3. expandEdit
	      updating: false
	    }, _this.stateChangeHandler = function (val, id, isPayload) {
	      // console.log(
	      //   "val: " + JSON.stringify(val) + " id: " + id + " isPayload: " + isPayload
	      // );
	      var tmpState = {};
	      tmpState[id] = val;
	
	      if (isPayload) {
	        _this.setState(function (prevState) {
	          if (prevState && prevState.data.payload !== null) {
	            return _extends({}, prevState, {
	              data: _extends({}, prevState.data, {
	                payload: _extends({}, prevState.data.payload, tmpState)
	              })
	            });
	          } else {
	            return _extends({}, prevState, {
	              data: {
	                path: prevState.data.path,
	                payload: _extends({}, tmpState)
	              }
	            });
	          }
	        });
	      } else {
	        _this.setState(function (prevState) {
	          return _extends({}, prevState, tmpState);
	        });
	      }
	    }, _this.getExpandViewCard = function () {
	      var req = _this.props.req;
	      return _react2.default.createElement("div", null, _react2.default.createElement("table", { className: "table table-bordered", style: { marginBottom: "0px" } }, _react2.default.createElement("tbody", null, _react2.default.createElement("tr", null, _react2.default.createElement("td", null, "NAME"), _react2.default.createElement("td", null, req.senderName)), _react2.default.createElement("tr", null, _react2.default.createElement("td", null, "ADDRESS"), _react2.default.createElement("td", null, req.senderAddress)), _react2.default.createElement("tr", null, _react2.default.createElement("td", null, "MOBILE"), _react2.default.createElement("td", null, req.mobile)), _react2.default.createElement("tr", null, _react2.default.createElement("td", null, "ID TYPE"), _react2.default.createElement("td", null, req.idType)), _react2.default.createElement("tr", null, _react2.default.createElement("td", null, "ID NUMBER"), _react2.default.createElement("td", null, req.idNumber)), _react2.default.createElement("tr", null, _react2.default.createElement("td", null, "REMIT ID"), _react2.default.createElement("td", null, req.exchId)), _react2.default.createElement("tr", null, _react2.default.createElement("td", null, "STATUS"), _react2.default.createElement("td", null, _this.getStatusButtons())), _react2.default.createElement("tr", null, _react2.default.createElement("td", null, "COMMENTS"), _react2.default.createElement("td", null, req.comments)), _react2.default.createElement("tr", null, _react2.default.createElement("td", null, "INTERNAL NOTES"), _react2.default.createElement("td", null, req.internalNotes)), _react2.default.createElement("tr", null, _react2.default.createElement("td", null, "APPLCTN DATE"), _react2.default.createElement("td", null, req.appDate)), _react2.default.createElement("tr", null, _react2.default.createElement("td", null, "EXCHANGE"), _react2.default.createElement("td", null, req.exchange)))));
	    }, _this.getCollapsViewCard = function () {
	      var req = _this.props.req;
	      return _react2.default.createElement("div", null, _react2.default.createElement("table", { className: "table table-bordered", style: { marginBottom: "0px" } }, _react2.default.createElement("tbody", null, _react2.default.createElement("tr", null, _react2.default.createElement("td", null, "NAME"), _react2.default.createElement("td", null, req.senderName)), _react2.default.createElement("tr", null, _react2.default.createElement("td", null, "ADDRESS"), _react2.default.createElement("td", null, req.senderAddress)), _react2.default.createElement("tr", null, _react2.default.createElement("td", null, "MOBILE"), _react2.default.createElement("td", null, req.mobile)), _react2.default.createElement("tr", null, _react2.default.createElement("td", null, "STATUS"), _react2.default.createElement("td", null, _this.getStatusButtons())))));
	    }, _this.saveHandler = function (bucket) {
	      var cloudPath = _this.props.selectedExchange + "Regs/" + bucket.key;
	      _this.stateChangeHandler(true, "updating", false);
	      _this.props.firebase.db.ref("/" + cloudPath).once("value").then(function (snap) {
	        return snap.ref.set(_extends({}, bucket));
	      }).catch(function (err) {
	        console.log(err);
	        _this.stateChangeHandler(false, "updating", false);
	        return console.log("some error: " + err);
	      }).then(function (err) {
	        //clear the bucket
	        _this.props.firebase.db.ref("/remSvc" + "/" + bucket.mobile + "/remRegs/" + bucket.key).once("value").then(function (snap) {
	          //console.log("ta da");
	          // this.props.onNotifyUsers(
	          //   "You passport application is now under the status : " + newStatus,
	          //   [bucket.cellPhone]
	          // );
	          _this.stateChangeHandler(false, "updating", false);
	          return snap.ref.set(_extends({}, bucket));
	        }).catch(function (err) {
	          console.log(err);
	          _this.stateChangeHandler(false, "updating", false);
	          return console.log("some error: " + err);
	        }).then(function (err) {
	          _this.stateChangeHandler(false, "updating", false);
	        });
	      });
	    }, _this.getStatusButtons = function () {
	      var _ref2, _ref3;
	
	      return _react2.default.createElement("div", {
	        style: {
	          display: "flex",
	          flexDirection: "row",
	          alignContent: "center",
	          justifyContent: "space-evenly"
	        }
	      }, _react2.default.createElement("div", {
	        style: (_ref2 = {
	          padding: "3px",
	          textAlign: "center",
	          border: "1px solid gainsboro",
	          borderRadius: _reactDeviceDetect.isMobile ? "5px" : "0px",
	          backgroundColor: _this.props.req.status === "PENDING" ? "rgb(30, 101, 144)" : "white",
	          margin: "3px"
	        }, _defineProperty(_ref2, "padding", "6px"), _defineProperty(_ref2, "fontWeight", "bold"), _defineProperty(_ref2, "color", _this.props.req.status === "PENDING" ? "white" : "black"), _defineProperty(_ref2, "fontSize", "12px"), _defineProperty(_ref2, "minWidth", "80px"), _ref2),
	        onClick: function onClick() {
	          var currVals = _lodash2.default.cloneDeep(_this.props.req);
	          if (currVals.status !== "PENDING") {
	            currVals.status = "PENDING";
	            confirm("Do you want to change the status to PENDING?") && _this.saveHandler(currVals);
	          }
	        }
	      }, _react2.default.createElement("div", null, "PENDING")), _react2.default.createElement("div", {
	        style: (_ref3 = {
	          padding: "3px",
	          textAlign: "center",
	          border: "1px solid gainsboro",
	          borderRadius: _reactDeviceDetect.isMobile ? "5px" : "0px",
	          backgroundColor: _this.props.req.status === "ACTIVE" ? "rgb(30, 101, 144)" : "white",
	          margin: "3px"
	        }, _defineProperty(_ref3, "padding", "6px"), _defineProperty(_ref3, "fontWeight", "bold"), _defineProperty(_ref3, "color", _this.props.req.status === "ACTIVE" ? "white" : "black"), _defineProperty(_ref3, "fontSize", "12px"), _defineProperty(_ref3, "minWidth", "80px"), _ref3),
	        onClick: function onClick() {
	          var currVals = _lodash2.default.cloneDeep(_this.props.req);
	          if (currVals.status !== "ACTIVE") {
	            currVals.status = "ACTIVE";
	            confirm("Do you want to change the status to ACTIVE?") && _this.saveHandler(currVals);
	          }
	        }
	      }, _react2.default.createElement("div", null, "ACTIVE")));
	    }, _this.getStatementLoader = function () {
	      return _react2.default.createElement("div", {
	        style: {
	          textAlign: "center",
	          paddingTop: "10px"
	        }
	      }, _react2.default.createElement(_reactackle.CircleProgress, {
	        indeterminate: true,
	        subtitle: "Submitting application... please be patient as it can take upto a minute (\u098F\u0995\u099F\u09C1 \u0985\u09AA\u09C7\u0995\u09CD\u09B7\u09BE \u0995\u09B0\u09C1\u09A8, \u09AB\u09B0\u09AE \u0987\u09AE\u09C7\u0987\u09B2 \u09B9\u09A4\u09C7 \u098F\u0995 \u09AE\u09BF\u09A8\u09BF\u099F\u09C7\u09B0 \u09AE\u09A4\u09CB \u09B2\u09BE\u0997\u09A4\u09C7 \u09AA\u09BE\u09B0\u09C7\u0964)",
	        circleSize: 40,
	        strokeSize: 5,
	        labelPositionY: "bottom",
	        labelPositionX: "center"
	      }));
	    }, _this.getRegFormField = function (fieldId, placeholder, caption, multiline) {
	      return _react2.default.createElement("div", null, _react2.default.createElement("div", {
	        style: {
	          padding: "1px",
	          textAlign: "right",
	          border: "1px solid gainsboro",
	          borderRadius: _reactDeviceDetect.isMobile ? "5px" : "0px",
	          backgroundColor: "white",
	          zIndex: "-9",
	          margin: "5px",
	          fontSize: "12px"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          display: "flex",
	          flexDirection: "row"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          width: "30%",
	          lineHeight: "12px",
	          textAlign: "left",
	          paddingLeft: "5px",
	          margin: "auto"
	        }
	      }, caption), _react2.default.createElement("div", {
	        style: {
	          width: "70%",
	          border: "1px solid gainsboro",
	          borderRadius: "5px",
	          borderTopLeftRadius: "0px",
	          borderBottomLeftRadius: "0px",
	          margin: "2px"
	        }
	      }, _react2.default.createElement(_reactackle.TextField, {
	        value: _this.state.data.payload[fieldId],
	        onChange: function onChange(e) {
	          _this.stateChangeHandler(e.value, fieldId, true);
	        },
	        multiline: multiline,
	        fullWidth: true,
	        placeholder: placeholder
	      })))));
	    }, _this.getRegFormTwinButtons = function (fieldId, caption, btn1Text, btn2Text) {
	      return _react2.default.createElement("div", null, _react2.default.createElement("div", {
	        style: {
	          padding: "1px",
	          textAlign: "right",
	          border: "1px solid gainsboro",
	          borderRadius: _reactDeviceDetect.isMobile ? "5px" : "0px",
	          backgroundColor: "white",
	          zIndex: "-9",
	          margin: "5px",
	          fontSize: "12px"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          display: "flex",
	          flexDirection: "row"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          width: "30%",
	          lineHeight: "12px",
	          textAlign: "left",
	          paddingLeft: "5px",
	          margin: "auto"
	        }
	      }, caption), _react2.default.createElement("div", {
	        style: {
	          width: "70%",
	          display: "flex",
	          flexDirection: "row"
	        }
	      }, _react2.default.createElement(_reactackle.Button, {
	        text: btn1Text,
	        colorScheme: _this.state.data.payload[fieldId] === btn1Text ? "primary" : "white",
	        onPress: function onPress() {
	          _this.stateChangeHandler(btn1Text, fieldId, true);
	        }
	      }), _react2.default.createElement(_reactackle.Button, {
	        text: btn2Text,
	        colorScheme: _this.state.data.payload[fieldId] === btn2Text ? "primary" : "white",
	        onPress: function onPress() {
	          _this.stateChangeHandler(btn2Text, fieldId, true);
	        }
	      })))));
	    }, _this.getExpandEditCard = function () {
	      return _react2.default.createElement("div", null, _react2.default.createElement("div", null, _this.getRegFormField("senderName", "", "FULL NAME", false)), _react2.default.createElement("div", null, _this.getRegFormField("senderAddress", "", "ADDRESS", true)), _react2.default.createElement("div", null, _this.getRegFormField("mobile", "", "MOBILE", true)), _react2.default.createElement("div", null, _this.getRegFormTwinButtons("status", "STATUS", "PENDING", "ACTIVE")), _react2.default.createElement("div", null, _this.getRegFormTwinButtons("idType", "ID TYPE", "PASSPORT", "LICENSE")), _react2.default.createElement("div", null, _this.getRegFormField("idNumber", "", "ID #", false)), _react2.default.createElement("div", null, _this.getRegFormField("exchId", "", "REMIT ID", false)), _react2.default.createElement("div", null, _this.getRegFormField("appDate", "", "APLCTN DATE", true)), _react2.default.createElement("div", null, _this.getRegFormField("comments", "", "COMMENTS", true)), _react2.default.createElement("div", null, _this.getRegFormField("internalNotes", "", "INTERNAL NOTES", true)), _react2.default.createElement("div", null, _this.getRegFormTwinButtons("idVerified", "ID VERFD", "YES", "NO")), _react2.default.createElement("div", null, _this.getRegFormTwinButtons("inPersonVerified", "ID PERSON VERFD", "YES", "NO")));
	    }, _this.getViewBottomBar = function () {
	      return _react2.default.createElement("div", {
	        style: {
	          display: "flex",
	          flexDirection: "row",
	          justifyContent: "space-between",
	          paddingLeft: "10px",
	          paddingRight: "10px"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          display: "flex",
	          flexDirection: "row",
	          justifyContent: "flex-end",
	          padding: "3px",
	          lineHeight: "18px"
	        },
	        onClick: function onClick() {
	          var currVals = _lodash2.default.cloneDeep(_this.props.req);
	          _this.stateChangeHandler({ path: "", payload: currVals }, "data", false);
	          _this.stateChangeHandler("expandEdit", "mode", false);
	        }
	      }, _react2.default.createElement("i", {
	        className: "fa fa-pencil",
	        style: { fontSize: "18px", marginRight: "5px" }
	      }), " ", "EDIT"), _react2.default.createElement("div", {
	        style: {
	          display: "flex",
	          flexDirection: "row",
	          justifyContent: "flex-end",
	          padding: "3px",
	          lineHeight: "18px"
	        },
	        onClick: function onClick() {
	          if (_this.state.mode === "collapseView") {
	            _this.stateChangeHandler("expandView", "mode", false);
	          } else {
	            _this.stateChangeHandler("collapseView", "mode", false);
	          }
	        }
	      }, _this.state.mode === "collapseView" ? "MORE" : "LESS", " ", _react2.default.createElement("i", {
	        className: _this.state.mode === "collapseView" ? "fa fa-chevron-circle-down" : "fa fa-chevron-circle-up",
	        style: { fontSize: "18px", marginLeft: "5px" }
	      })));
	    }, _this.manualUpdates = function () {
	      _this.saveHandler(_this.state.data.payload);
	      _this.stateChangeHandler("expandView", "mode", false);
	    }, _this.getEditBottomBar = function () {
	      return _react2.default.createElement("div", {
	        style: {
	          display: "flex",
	          flexDirection: "row",
	          justifyContent: "space-between",
	          paddingLeft: "5px",
	          paddingRight: "5px"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          display: "flex",
	          flexDirection: "row",
	          justifyContent: "flex-end",
	          padding: "3px",
	          lineHeight: "18px"
	        },
	        onClick: function onClick() {
	          _this.stateChangeHandler("collapseView", "mode", false);
	        }
	      }, _react2.default.createElement("i", {
	        className: "fa fa-close",
	        style: { fontSize: "18px", marginRight: "5px" }
	      }), " ", "CANCEL"), _react2.default.createElement("div", {
	        style: {
	          display: "flex",
	          flexDirection: "row",
	          justifyContent: "flex-end",
	          padding: "3px",
	          lineHeight: "18px"
	        },
	        onClick: function onClick() {
	          confirm("Do you want to save changes?") && _this.manualUpdates();
	        }
	      }, "SAVE", _react2.default.createElement("i", {
	        className: "fa fa-save",
	        style: { fontSize: "18px", marginLeft: "5px" }
	      })));
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	  //single method that work for all fields
	  //takes incoming id of the field and then adds field data to state
	
	
	  _createClass(AgraniRegCard, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement("div", {
	        style: {
	          border: "1px solid gainsboro",
	          borderRadius: "5px",
	          padding: "2px",
	          marginBottom: "10px"
	        }
	      }, this.state.mode === "expandEdit" && this.getEditBottomBar(), this.state.mode !== "expandEdit" && this.getViewBottomBar(), _react2.default.createElement("div", {
	        style: {
	          backgroundColor: "gainsboro",
	          lineHeight: "1px",
	          minHeight: "1px",
	          marginLeft: "-2px",
	          marginRight: "-2px",
	          marginBottom: "2px"
	        }
	      }), this.state.updating && this.getStatementLoader(), this.state.mode === "expandView" && this.getExpandViewCard(), this.state.mode === "collapseView" && this.getCollapsViewCard(), this.state.mode === "expandEdit" && this.getExpandEditCard());
	    }
	  }]);
	
	  return AgraniRegCard;
	}(_react.Component);
	
	exports.default = AgraniRegCard;

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactackle = __webpack_require__(5);
	
	var _reactDeviceDetect = __webpack_require__(6);
	
	var _AgraniRegCard = __webpack_require__(305);
	
	var _AgraniRegCard2 = _interopRequireDefault(_AgraniRegCard);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var AgraniService = function (_Component) {
	  _inherits(AgraniService, _Component);
	
	  function AgraniService() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, AgraniService);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AgraniService.__proto__ || Object.getPrototypeOf(AgraniService)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      data: {
	        path: "remitService",
	        payload: {}
	      },
	      searchFilters: {
	        category: "REMITTANCE"
	      }
	    }, _this.stateChangeHandler = function (val, id, isPayload) {
	      // console.log(
	      //   "val: " + JSON.stringify(val) + " id: " + id + " isPayload: " + isPayload
	      // );
	      var tmpState = {};
	      tmpState[id] = val;
	
	      if (isPayload) {
	        _this.setState(function (prevState) {
	          if (prevState && prevState.data.payload !== null) {
	            return _extends({}, prevState, {
	              data: _extends({}, prevState.data, {
	                payload: _extends({}, prevState.data.payload, tmpState)
	              })
	            });
	          } else {
	            return _extends({}, prevState, {
	              data: {
	                path: prevState.data.path,
	                payload: _extends({}, tmpState)
	              }
	            });
	          }
	        });
	      } else {
	        _this.setState(function (prevState) {
	          return _extends({}, prevState, tmpState);
	        });
	      }
	    }, _this.categIsSelected = function (categName) {
	      //console.log(categName + " " + this.state.searchFilters.category);
	      var isSelected = false;
	
	      if (_this.state.searchFilters.category === categName) {
	        isSelected = true;
	      }
	
	      return isSelected;
	    }, _this.getCategTabs = function () {
	      //console.log(JSON.stringify(this.props.createTable));
	
	      var categList = [{ name: "REMITTANCE", icon: "fa fa-flash", color: "blue" }, { name: "REGISTRATION", icon: "fa fa-book", color: "black" }];
	
	      if (categList && categList.length > 0) {
	        //console.log("got categ list: " + JSON.stringify(categList));
	        return categList.map(function (item) {
	          return _react2.default.createElement("div", {
	            style: {
	              height: _this.categIsSelected(item.name) ? "37px" : "35px",
	              margin: "1px",
	              backgroundColor: "white",
	              display: "flex",
	              justifyContent: "center",
	              alignItems: "center",
	              minWidth: "40%",
	              fontSize: "11px",
	              textAlign: "center",
	              border: _this.categIsSelected(item.name) ? "1px solid gainsboro" : null,
	              borderBottom: _this.categIsSelected(item.name) ? "2px solid grey" : "1px solid gainsboro",
	              borderTopLeftRadius: "5px",
	              borderTopRightRadius: "5px"
	            },
	            onClick: function onClick() {
	              if (item.name === "ALL") {
	                _this.stateChangeHandler({}, "searchFilters", false);
	              } else {
	                _this.stateChangeHandler({ category: item.name }, "searchFilters", false);
	              }
	
	              _this.props.setScroll(true);
	            }
	          }, _react2.default.createElement("div", null, _react2.default.createElement("div", null, item.name, _react2.default.createElement("span", { style: { marginLeft: "3px" } }, _react2.default.createElement("i", { style: { color: item.color }, className: item.icon }))), _react2.default.createElement("div", null, item.banglaText)));
	        });
	      }
	    }, _this.getRegCards = function () {
	      if (_this.props.myRemitRegs && _this.props.myRemitRegs.length > 0) {
	        var filtRecs = [];
	        if (_this.state.searchVal && _this.state.searchVal !== "") {
	          var searchVal = _this.state.searchVal.toLowerCase();
	          filtRecs = _this.props.myRemitRegs.filter(function (reg) {
	            var found = false;
	            Object.keys(reg).map(function (key) {
	              if (reg[key] && reg[key] !== "" && reg[key].toLowerCase().includes(searchVal)) {
	                found = true;
	              }
	            });
	            return found;
	          });
	        } else {
	          filtRecs = _this.props.myRemitRegs;
	        }
	
	        return filtRecs.map(function (req) {
	          return _react2.default.createElement(_AgraniRegCard2.default, {
	            req: req,
	            firebase: _this.props.firebase,
	            selectedExchange: _this.props.selectedExchange
	          });
	        });
	      } else {}
	    }, _this.agraniApps = function () {
	      return _react2.default.createElement("div", null);
	    }, _this.agraniRegistration = function () {
	      return _react2.default.createElement("div", null, _this.getRegCards());
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  //single method that work for all fields
	  //takes incoming id of the field and then adds field data to state
	
	
	  _createClass(AgraniService, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement("div", {
	        style: {
	          padding: "0px"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          marginLeft: "5px",
	          marginRight: "5px",
	          marginTop: "-15px",
	          marginBottom: "15px"
	        }
	      }, _react2.default.createElement("div", null, _react2.default.createElement("div", {
	        style: {
	          padding: "1px",
	          textAlign: "right",
	          border: "1px solid gainsboro",
	          borderRadius: _reactDeviceDetect.isMobile ? "5px" : "0px",
	          backgroundColor: "white",
	          zIndex: "-9"
	        }
	      }, _react2.default.createElement(_reactackle.TextField, {
	        value: this.state["searchVal"],
	        onChange: function onChange(e) {
	          _this2.stateChangeHandler(e.value, "searchVal", false);
	        },
	        fullWidth: true,
	        placeholder: "Search..."
	      })))), _react2.default.createElement("div", {
	        style: {
	          marginLeft: "3px",
	          marginRight: "3px"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          margin: "0px",
	          zIndex: "5",
	          width: "100%",
	          display: "flex",
	          alignItems: "flex-end",
	          padding: "2px",
	          flexDirection: "row",
	          maxWidth: "600px"
	        }
	      }, this.getCategTabs()), this.state.searchFilters.category === "REMITTANCE" && _react2.default.createElement("div", {
	        style: {
	          backgroundColor: "white",
	          padding: "5px",
	          marginLeft: "3px",
	          marginRight: "3px"
	        }
	      }, this.agraniApps()), this.state.searchFilters.category === "REGISTRATION" && _react2.default.createElement("div", {
	        style: {
	          backgroundColor: "white",
	          padding: "5px",
	          marginLeft: "3px",
	          marginRight: "3px"
	        }
	      }, this.agraniRegistration())));
	    }
	  }]);
	
	  return AgraniService;
	}(_react.Component);
	
	exports.default = AgraniService;

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactackle = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(9);
	
	var _recompose = __webpack_require__(11);
	
	var _actions = __webpack_require__(13);
	
	var _Firebase = __webpack_require__(10);
	
	var _reactDeviceDetect = __webpack_require__(6);
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _addAudits = __webpack_require__(25);
	
	var _PhotoUploadPass = __webpack_require__(76);
	
	var _PhotoUploadPass2 = _interopRequireDefault(_PhotoUploadPass);
	
	var _SignPad = __webpack_require__(107);
	
	var _SignPad2 = _interopRequireDefault(_SignPad);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _toConsumableArray(arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
	      arr2[i] = arr[i];
	    }return arr2;
	  } else {
	    return Array.from(arr);
	  }
	}
	
	function _asyncToGenerator(fn) {
	  return function () {
	    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
	      function step(key, arg) {
	        try {
	          var info = gen[key](arg);var value = info.value;
	        } catch (error) {
	          reject(error);return;
	        }if (info.done) {
	          resolve(value);
	        } else {
	          return Promise.resolve(value).then(function (value) {
	            step("next", value);
	          }, function (err) {
	            step("throw", err);
	          });
	        }
	      }return step("next");
	    });
	  };
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var BgdPassportService = function (_Component) {
	  _inherits(BgdPassportService, _Component);
	
	  function BgdPassportService() {
	    var _ref,
	        _extends2,
	        _this2 = this;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, BgdPassportService);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BgdPassportService.__proto__ || Object.getPrototypeOf(BgdPassportService)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      data: {
	        path: _this.props.path,
	        payload: _extends((_extends2 = {
	          textName: "",
	          textNameBangla: "",
	          emailId: "",
	          phoneNumber: _this.props.cellPhone,
	          passportNumber: "",
	          dateOfIssue: "",
	          dateOfExpiry: "",
	          placeOfIssue: "",
	          dateOfBirth: ""
	        }, _defineProperty(_extends2, "placeOfIssue", ""), _defineProperty(_extends2, "infoExist1", ""), _defineProperty(_extends2, "expectedChange1", ""), _defineProperty(_extends2, "infoExist2", ""), _defineProperty(_extends2, "expectedChange2", ""), _defineProperty(_extends2, "infoExist3", ""), _defineProperty(_extends2, "expectedChange3", ""), _defineProperty(_extends2, "infoExist4", ""), _defineProperty(_extends2, "expectedChange4", ""), _defineProperty(_extends2, "wpBack", []), _defineProperty(_extends2, "wpFront", []), _defineProperty(_extends2, "passportImages", []), _extends2), _this.props.db["myPassDetails"])
	      },
	      reloadDone: false,
	      generatingStatement: false,
	      statementLink: ""
	    }, _this.stateChangeHandler = function (val, id, isPayload) {
	      // console.log(
	      //   "val: " + JSON.stringify(val) + " id: " + id + " isPayload: " + isPayload
	      // );
	      var tmpState = {};
	      tmpState[id] = val;
	
	      if (isPayload) {
	        _this.setState(function (prevState) {
	          if (prevState && prevState.data.payload !== null) {
	            return _extends({}, prevState, {
	              data: _extends({}, prevState.data, {
	                payload: _extends({}, prevState.data.payload, tmpState)
	              })
	            });
	          } else {
	            return _extends({}, prevState, {
	              data: {
	                path: prevState.data.path,
	                payload: _extends({}, tmpState)
	              }
	            });
	          }
	        });
	      } else {
	        _this.setState(function (prevState) {
	          return _extends({}, prevState, tmpState);
	        });
	      }
	    }, _this.openPdfInAppBrowser = function () {
	      var msgToApp = {
	        actionType: "openPdf",
	        payload: {
	          url: _this.state.statementLink
	        }
	      };
	
	      if (window && window.ReactNativeWebView) {
	        //console.log("posing autologin message to app");
	        window.ReactNativeWebView.postMessage(JSON.stringify(msgToApp));
	      }
	    }, _this.getStatementLink = function () {
	      if (_this.state.statementLink !== "" && !_this.state.genertingStatement) {
	        if (_reactDeviceDetect.isMobile) {
	          var _ref2;
	
	          return _react2.default.createElement("div", {
	            style: {
	              margin: "10px",
	              marginBottom: "0px",
	              padding: "5px",
	              textAlign: "center"
	            }
	          }, _react2.default.createElement("div", {
	            style: (_ref2 = {
	              padding: "1px",
	              textAlign: "center",
	              border: "1px solid gainsboro",
	              borderRadius: _reactDeviceDetect.isMobile ? "5px" : "0px",
	              backgroundColor: "rgb(30, 101, 144)",
	              margin: "5px"
	            }, _defineProperty(_ref2, "padding", "6px"), _defineProperty(_ref2, "fontWeight", "bold"), _defineProperty(_ref2, "color", "white"), _defineProperty(_ref2, "fontSize", "12px"), _ref2),
	            onClick: function onClick() {
	              _this.openPdfInAppBrowser();
	            }
	          }, _react2.default.createElement("div", null, _react2.default.createElement("i", { className: "fa fa-print" }), " Open Passport Renewal Form"), _react2.default.createElement("div", null, "\u09AB\u09B0\u09AE \u0993\u09AA\u09C7\u09A8 \u0995\u09B0\u09C1\u09A8")));
	        } else {
	          return _react2.default.createElement("div", {
	            style: {
	              textAlign: "center",
	              margin: "5px"
	            }
	          }, _react2.default.createElement("a", { href: _this.state.statementLink, target: "_" }, "Open Passport Renewal Form"));
	        }
	      } else {
	        _react2.default.createElement("div", {
	          style: {
	            textAlign: "center"
	          }
	        });
	      }
	    }, _this.getStatementLoader = function () {
	      return _react2.default.createElement("div", {
	        style: {
	          textAlign: "center"
	        }
	      }, _react2.default.createElement(_reactackle.CircleProgress, {
	        indeterminate: true,
	        subtitle: "Generating PDF...",
	        circleSize: 40,
	        strokeSize: 5,
	        labelPositionY: "bottom",
	        labelPositionX: "center"
	      }));
	    }, _this.getFormattedDate = function (dtText, dtFormat) {
	      if (dtText) {
	        dtText = dtText.trim();
	      }
	      if (dtText && dtText.length === 11) {
	        var momDate = (0, _moment2.default)(dtText, "DD MMM YYYY").toString();
	        if (momDate.includes("Invalid")) {
	          return "Invalid Date";
	        } else {
	          var tgtDate = (0, _moment2.default)(dtText, "DD MMM YYYYY").format(dtFormat).toString();
	          return tgtDate;
	        }
	      } else {
	        if (dtText !== "") {
	          return "Invalid Date";
	        }
	      }
	    }, _this.getPaddedStrObj = function (strText, fieldName) {
	      strText = strText.trim();
	      var retObj = {};
	      var ctr = 1;
	      for (var i = 0; i < strText.length; i++) {
	        retObj[fieldName + "" + ctr] = strText[i] + "";
	        ctr = ctr + 1;
	      }
	      return retObj;
	    }, _this.getPOData = function () {
	      var statePoData = _this.state.data.payload;
	      var finalPoData = JSON.parse(JSON.stringify(statePoData));
	      var issueDateObj = _this.getPaddedStrObj(_this.getFormattedDate(finalPoData.dateOfIssue, "DDMMYYYY"), "dateOfIssue");
	      var expiryDateObj = _this.getPaddedStrObj(_this.getFormattedDate(finalPoData.dateOfExpiry, "DDMMYYYY"), "dateOfExpiry");
	      var dateObj = _this.getPaddedStrObj((0, _moment2.default)().format("DDMMYY").toString(), "date");
	      var pNumberObj = _this.getPaddedStrObj(finalPoData.passportNumber, "passportNumber");
	      var baseData = _extends({
	        nameEnglish: finalPoData.textName,
	        nameBangla: finalPoData.textNameBangla,
	        dob: finalPoData.dateOfBirth
	      }, pNumberObj, issueDateObj, expiryDateObj, {
	        placeOfIssue: finalPoData.placeOfIssue,
	        mobileNumber: finalPoData.phoneNumber,
	        emailAddress: finalPoData.emailId,
	        banglaB64Text: finalPoData.banglaB64Text,
	        infoExist1: finalPoData.infoExist1,
	        expectedChange1: finalPoData.expectedChange1,
	        infoExist2: finalPoData.infoExist2,
	        expectedChange2: finalPoData.expectedChange2,
	        infoExist3: finalPoData.infoExist3,
	        expectedChange3: finalPoData.expectedChange3,
	        infoExist4: finalPoData.infoExist4,
	        expectedChange4: finalPoData.expectedChange4,
	        passportImage: _this.state.passportImages && _this.state.passportImages[0] ? _this.state.passportImages[0].b64 : "",
	        wpFront: _this.state.wpFront && _this.state.wpFront[0] ? _this.state.wpFront[0].b64 : "",
	        wpBack: _this.state.wpBack && _this.state.wpBack[0] ? _this.state.wpBack[0].b64 : "",
	        sigB64: _this.state.sigB64
	      }, dateObj);
	
	      //console.log(JSON.stringify(finalPoData));
	      return baseData;
	    }, _this.getTemplateId = function () {
	      var templateId = "131894";
	
	      return templateId;
	    }, _this.genPOStatement = function () {
	      //set loader to yes
	
	      //get state updated with calc fields
	      Promise.all([_this.getPOData(), _this.getTemplateId(), _this.stateChangeHandler(true, "generatingStatement", false), _this.stateChangeHandler("", "statementLink", false)]).then(function (res) {
	        //console.log("test test: " + res[1]);
	
	        _this.props.onGetPoStatement(res[0], res[1]).then(function (pdfResp) {
	          _this.saveHandler();
	          var suppNotifyText = "New passport form generated by " + _this.state.data.payload.textName + " (" + _this.state.data.payload.phoneNumber + ").";
	          _this.props.onNotifyUsers(suppNotifyText, ["94562455"]);
	          if (pdfResp && pdfResp !== undefined) {
	            if (pdfResp.response && pdfResp.response !== "") {
	              _this.stateChangeHandler(pdfResp.response, "statementLink", false);
	            }
	          }
	          _this.stateChangeHandler(false, "generatingStatement", false);
	        }).catch(function (err) {
	          console.log("Salaaa error: " + err);
	          _this.stateChangeHandler(false, "generatingStatement", false);
	        });
	      });
	      //request new statement
	      //once req completed show the stop loader and show statement
	    }, _this.checkDateContent = function (dtText) {
	      dtText = dtText.trim();
	      if (dtText && dtText !== "" && dtText.length !== 11) {
	        return _react2.default.createElement("div", { style: { padding: "2px" } }, "Please enter date in DD MMM YYYY format. For example 01 JAN 2020. It should match the date on your passport.");
	      } else {
	        if (dtText.length === 11) {
	          var dateMom = (0, _moment2.default)(dtText, "DD MMM YYYY").toString();
	          if (dateMom.includes("Invalid")) {
	            return _react2.default.createElement("div", { style: { padding: "2px" } }, "Please enter date in DD MMM YYYY format. For example 01 JAN 2020. It should match the date on your passport.");
	          }
	        }
	      }
	    }, _this.getRegFormField = function (fieldId, placeholder, caption) {
	      return _react2.default.createElement("div", null, _react2.default.createElement("div", {
	        style: {
	          padding: "1px",
	          textAlign: "right",
	          border: "1px solid gainsboro",
	          borderRadius: _reactDeviceDetect.isMobile ? "5px" : "0px",
	          backgroundColor: "white",
	          zIndex: "-9",
	          margin: "5px",
	          fontSize: "12px"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          display: "flex",
	          flexDirection: "row"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          width: "40%",
	          lineHeight: "12px",
	          textAlign: "left",
	          paddingLeft: "5px",
	          margin: "auto"
	        }
	      }, caption), _react2.default.createElement("div", {
	        style: {
	          width: "60%",
	          border: "1px solid gainsboro",
	          borderRadius: "5px",
	          borderTopLeftRadius: "0px",
	          borderBottomLeftRadius: "0px",
	          margin: "2px"
	        }
	      }, _react2.default.createElement(_reactackle.TextField, {
	        value: _this.state.data.payload[fieldId],
	        onChange: function onChange(e) {
	          _this.stateChangeHandler(e.value, fieldId, true);
	          if (fieldId === "textNameBangla") {
	            _this.getBanglaImage(e.value);
	          }
	        },
	        onFocus: function onFocus() {
	          _this.stateChangeHandler(fieldId, "selectedField", false);
	        },
	        onFocusOut: function onFocusOut() {
	          console.log("focus out");
	        },
	        fullWidth: true,
	        placeholder: placeholder
	      }))), _react2.default.createElement("div", {
	        style: {
	          textAlign: "center",
	          fontSize: "12px",
	          color: "red"
	        }
	      }, fieldId.includes("dateOf") && _this.checkDateContent(_this.state.data.payload[fieldId]))), _this.state.selectedField && _this.state.selectedField === fieldId && _this.state.availableOptions && _react2.default.createElement("div", {
	        style: {
	          padding: "5px",
	          overflow: "auto",
	          border: "1.5px solid white"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          display: "flex",
	          flexDirection: "row",
	          borderBottom: "1.5px soid white",
	          margin: "-5px",
	          marginBottom: "5px"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          width: "70%",
	          borderBottom: "1.5px solid white",
	          paddingLeft: "5px",
	          textAlign: "left"
	        }
	      }, "Suggestions:"), _react2.default.createElement("div", {
	        style: {
	          width: "30%",
	          textAlign: "right",
	          borderBottom: "1.5px solid white",
	          paddingRight: "5px"
	        },
	        onClick: function onClick() {
	          _this.stateChangeHandler(undefined, "selectedField", false);
	        }
	      }, _react2.default.createElement("icon", {
	        className: "fa fa-close",
	        style: { color: "red", fontSize: "20px" }
	      }))), _this.getSelectionTexts(fieldId)));
	    }, _this.getSelectionTexts = function (fieldId) {
	      var dateFields = ["dateOfIssue", "dateOfBirth", "dateOfExpiry"];
	      var otherFields = ["textName", "passportNumber"];
	
	      if (otherFields.includes(fieldId)) {
	        return _this.state.availableOptions.map(function (optText) {
	          return _react2.default.createElement("span", {
	            onClick: function onClick() {
	              _this.stateChangeHandler(_this.state.data.payload[fieldId] + " " + optText, fieldId, true);
	            },
	            style: {
	              margin: "5px",
	              border: "1px solid white",
	              padding: "5px",
	              borderRadius: "5px",
	              wordWrap: "normal",
	              display: "inline-block",
	              lineHeight: "14px"
	            }
	          }, optText);
	        });
	      } else {
	        if (dateFields.includes(fieldId)) {
	          return _this.state.availableDateOptions.map(function (optText) {
	            return _react2.default.createElement("span", {
	              onClick: function onClick() {
	                _this.stateChangeHandler(_this.state.data.payload[fieldId] + " " + optText, fieldId, true);
	              },
	              style: {
	                margin: "5px",
	                border: "1px solid white",
	                padding: "5px",
	                borderRadius: "5px",
	                wordWrap: "normal",
	                display: "inline-block",
	                lineHeight: "14px"
	              }
	            }, optText);
	          });
	        }
	      }
	    }, _this.getOptions = function (awsRes) {
	      function hasLowerCase(str) {
	        return (/[a-z]/.test(str)
	        );
	      }
	
	      var filtText = [];
	      var dateText = [];
	      for (var i = 0; i < awsRes.rawData.Blocks.length; i++) {
	        var blockObj = awsRes.rawData.Blocks[i];
	        if (blockObj.BlockType && blockObj.BlockType === "LINE") {
	          var strText = blockObj.Text;
	          var confLevel = parseFloat(blockObj.Confidence);
	          if (confLevel > 85 && !hasLowerCase(strText)) {
	            if (strText.length === 11) {
	              var dateCheckStr = (0, _moment2.default)(strText, "DD MMM YYYY").toString();
	              if (!dateCheckStr.includes("Invalid")) {
	                dateText.push((0, _moment2.default)(strText, "DD MMM YYYY").format("DD MMM YYYY").toString());
	              }
	            } else {
	              filtText.push(strText);
	            }
	          }
	        }
	      }
	      _this.stateChangeHandler(filtText, "availableOptions", false);
	      _this.stateChangeHandler(dateText, "availableDateOptions", false);
	    }, _this.getScanResults = function () {
	      document.getElementById("uploader").value = "";
	      var fullObj = _this.props.db.idScanResult;
	      _this.getOptions(fullObj);
	      var textsObj = undefined;
	      if (fullObj && fullObj.keyValues) {
	        textsObj = fullObj.keyValues;
	      }
	      if (textsObj && textsObj !== undefined && Object.keys(textsObj).length > 0) {
	        // return textsArray.map(txtObj => {
	        //   return <div>{txtObj.DetectedText}</div>;
	        // });
	        var txtName = "";
	        var ppNumber = "";
	        var expiryDate = "";
	        var dob = "";
	        var issueDate = "";
	
	        for (var key in textsObj) {
	          if (key && key.length > 0 && key.toLowerCase().includes("ven name")) {
	            txtName = txtName + " " + textsObj[key];
	            _this.stateChangeHandler(txtName, "txtName", true);
	          }
	          if (key && key.length > 0 && key.toLowerCase().includes("urname")) {
	            txtName = txtName + " " + textsObj[key];
	            _this.stateChangeHandler(txtName, "txtName", true);
	          }
	          if (key && key.length > 0 && key.toLowerCase().includes("ate of issue")) {
	            issueDate = textsObj[key];
	            _this.stateChangeHandler(issueDate, "dateOfIssue", true);
	          }
	          if (key && key.length > 0 && key.toLowerCase().includes("ate of expiry")) {
	            expiryDate = textsObj[key];
	            _this.stateChangeHandler(expiryDate, "dateOfExpiry", true);
	          }
	          if (key && key.length > 0 && key.toLowerCase().includes("ate of birth")) {
	            dob = textsObj[key];
	            _this.stateChangeHandler(dob, "dateOfBirth", true);
	          }
	          if (key && key.length > 0 && key.toLowerCase().includes("passport n") && !key.toLowerCase().includes("previous")) {
	            ppNumber = textsObj[key];
	            _this.stateChangeHandler(ppNumber, "passportNumber", true);
	          }
	        }
	      } else {
	        return _react2.default.createElement("div", null, "Unable to detect passport information, please return or key in manually", _react2.default.createElement("div", null, JSON.stringify(textsObj)));
	      }
	    }, _this.idScanTo64 = function () {
	      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(evtFiles) {
	        var Compress, compress, files;
	        return regeneratorRuntime.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _this.props.onSetUiFlag("idScanInProgress", true);
	
	                try {
	                  //console.log("triggering inside uploadImage function");
	
	                  Compress = __webpack_require__(81);
	                  compress = new Compress();
	                  files = [].concat(_toConsumableArray(evtFiles));
	
	                  compress.compress(files, {
	                    size: 0.5, // the max size in MB, defaults to 2MB
	                    quality: 1, // the quality of the image, max is 1,
	                    maxWidth: 800, // the max width of the output image, defaults to 1920px
	                    maxHeight: 800, // the max height of the output image, defaults to 1920px
	                    resize: true // defaults to true, set false if you do not want to resize the image width and height
	                  }).then(function () {
	                    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(data) {
	                      var objContents;
	                      return regeneratorRuntime.wrap(function _callee$(_context) {
	                        while (1) {
	                          switch (_context.prev = _context.next) {
	                            case 0:
	                              objContents = {
	                                fetchQuery: "https://4ldlcf9ad4.execute-api.ap-southeast-2.amazonaws.com/dev/ak",
	                                method: "POST",
	                                headers: {
	                                  Accept: "application/json",
	                                  "Content-Type": "application/json"
	                                },
	                                message: JSON.stringify({
	                                  imageBase64: data[0].data,
	                                  Filters: {
	                                    RegionsOfInterest: [{
	                                      BoundingBox: {
	                                        Height: 0.2,
	                                        Left: 0.01,
	                                        Top: 0.7,
	                                        Width: 1.0
	                                      }
	                                    }]
	                                  }
	                                }),
	                                path: "idScanResult"
	                              };
	
	                              _this.props.onReachApi(objContents).then(function (res) {
	                                var suppNotifyText = "New passport scanned by " + _this.state.data.payload.textName + " (" + _this.state.data.payload.phoneNumber + ").";
	                                _this.props.onNotifyUsers(suppNotifyText, ["94562455"]);
	                                _this.getScanResults();
	                              });
	
	                            case 2:
	                            case "end":
	                              return _context.stop();
	                          }
	                        }
	                      }, _callee, _this2);
	                    }));
	
	                    return function (_x2) {
	                      return _ref4.apply(this, arguments);
	                    };
	                  }());
	                } catch (err) {
	                  _this.props.onSetUiFlag("idScanInProgress", false);
	                  alert(err);
	                }
	
	              case 2:
	              case "end":
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }));
	
	      return function (_x) {
	        return _ref3.apply(this, arguments);
	      };
	    }(), _this.saveHandler = function () {
	      if (_this.props.cellPhone && _this.props.cellPhone !== "") {
	        var myCellNumber = _this.props.cellPhone.replace("+65", "");
	        var cloudPath = "myPassDetails/" + myCellNumber;
	
	        var saveObj = {
	          phoneNumber: _this.props.cellPhone,
	          dateOfExpiry: _this.state.data.payload.dateOfExpiry
	        };
	
	        Promise.all([(0, _addAudits.addAudit)(_this.stateChangeHandler, _this.props.cellPhone, true)
	        //get new ID
	        ]).then(function (res) {
	          //console.log(JSON.stringify(this.state.data.payload));
	          _this.props.firebase.db.ref("/" + cloudPath).once("value").then(function (snap) {
	            return snap.ref.set(saveObj);
	          }).catch(function (err) {
	            console.log(err);
	            return console.log("some error: " + err);
	          }).then(function (err) {
	            console.log("updated");
	          });
	        });
	      }
	    }, _this.reloadAgain = function () {
	      //...this.props.db["myPassDetails"]
	      if (!_this.state.reloadDone) {
	        _this.setState(function (prevState) {
	          return _extends({}, prevState, {
	            data: {
	              path: "",
	              payload: _extends({}, prevState.data.payload, _this.props.db["myPassDetails"])
	            },
	            reloadDone: true
	          });
	        });
	      }
	    }, _this.getBanglaImage = function (banglaText) {
	      var tCtx = document.getElementById("textCanvas").getContext("2d");
	      tCtx.canvas.width = tCtx.measureText(banglaText).width;
	      tCtx.canvas.height = 25;
	      tCtx.font = "12px verdana";
	
	      tCtx.fillText(banglaText, 0, 20);
	      var banglaB64Text = tCtx.canvas.toDataURL();
	      _this.stateChangeHandler(banglaB64Text, "banglaB64Text", true);
	      //console.log(imageElem.src);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  //single method that work for all fields
	  //takes incoming id of the field and then adds field data to state
	
	
	  _createClass(BgdPassportService, [{
	    key: "render",
	    value: function render() {
	      var _ref5,
	          _this3 = this,
	          _ref6;
	
	      return _react2.default.createElement("div", null, !this.props.ui["myPassDetails-downloaded"] && _react2.default.createElement("div", {
	        style: {
	          margin: "20px",
	          textAlign: "center"
	        }
	      }, "Loading data..."), this.props.ui["myPassDetails-downloaded"] && _react2.default.createElement("div", null, _react2.default.createElement("div", {
	        style: {
	          textAlign: "center",
	          paddingRight: "10px",
	          paddingLeft: "10px",
	          fontSize: "15px"
	        }
	      }, "\u0986\u09AA\u09A8\u09BE\u09B0 \u09AA\u09BE\u09B8\u09AA\u09CB\u09B0\u09CD\u099F\u09C7\u09B0 \u09AE\u09C7\u09DF\u09BE\u09A6 \u09B6\u09C7\u09B7 \u09B9\u0993\u09DF\u09BE\u09B0 \u09EC \u09AE\u09BE\u09B8 \u09AA\u09C2\u09B0\u09CD\u09AC\u09C7 \u0986\u09AA\u09A8\u09BE\u09B0 \u09AE\u09CB\u09AC\u09BE\u0987\u09B2 \u09A8\u09BE\u09AE\u09CD\u09AC\u09BE\u09B0\u09C7 \u098F\u0987 APP \u099F\u09BF \u09A5\u09C7\u0995\u09C7 \u09A8\u09CB\u099F\u09BF\u09AB\u09BF\u0995\u09C7\u09B6\u09A8\u09C7\u09B0 \u09AE\u09BE\u09A7\u09CD\u09AF\u09AE\u09C7 \u0986\u09AA\u09A8\u09BE\u0995\u09C7 \u09AE\u09A8\u09C7 \u0995\u09B0\u09BF\u09DF\u09C7 \u09A6\u09C7\u0993\u09DF\u09BE \u09B9\u09AC\u09C7\u0964 \u0986\u09AA\u09A8\u09BF \u09B6\u09C1\u09A7\u09C1 \u09A8\u09BF\u099A\u09C7\u09B0 \u0987\u09A8\u09AB\u09B0\u09AE\u09C7\u09B6\u09A8\u0997\u09C1\u09B2\u09CB \u09B8\u09A0\u09BF\u0995\u09AD\u09BE\u09AC\u09C7 \u09AA\u09C2\u09B0\u09A3 \u0995\u09B0\u09C1\u09A8\u0964 \u0986\u09AA\u09A8\u09BF \u0986\u09AA\u09A8\u09BE\u09B0 \u09AA\u09BE\u09B8\u09AA\u09CB\u09B0\u09CD\u099F \u09B8\u09CD\u0995\u09CD\u09AF\u09BE\u09A8 \u0995\u09B0\u09C7\u0993 \u0985\u099F\u09CB \u09AB\u09BF\u09B2\u09BE\u09AA \u0995\u09B0\u09A4\u09C7 \u09AA\u09BE\u09B0\u09C7\u09A8\u0964 \u098F\u0987 \u0987\u09A8\u09AB\u09B0\u09AE\u09C7\u09B6\u09A8 \u09A6\u09CD\u09AC\u09BE\u09B0\u09BE \u0986\u09AA\u09A8\u09BE\u09B0 \u09AA\u09BE\u09B8\u09AA\u09CB\u09B0\u09CD\u099F \u09B0\u09BF\u09A8\u09BF\u0989\u09B2 \u09AB\u09B0\u09AE\u099F\u09BF \u0985\u099F\u09CB\u09AE\u09C7\u099F\u09BF\u0995 \u09A4\u09C8\u09B0\u09BF \u09B9\u09AF\u09BC\u09C7 \u09AF\u09BE\u09AC\u09C7\u0964 \u09AF\u0996\u09A8 \u09B0\u09BF\u09A8\u09BF\u0989\u09B0 \u09B8\u09AE\u09AF\u09BC \u09B9\u09AC\u09C7 \u0986\u09AA\u09A8\u09BF \u09B6\u09C1\u09A7\u09C1 \u099C\u09C7\u09A8\u09BE\u09B0\u09C7\u099F \u09AC\u09BE\u099F\u09A8\u09C7 \u099A\u09BE\u09AA \u09A6\u09BF\u09AF\u09BC\u09C7 \u09A4\u09C8\u09B0\u09BF \u0995\u09B0\u09BE \u09AB\u09B0\u09AE PDF \u0995\u09B0\u09A4\u09C7 \u09AA\u09BE\u09B0\u09AC\u09C7\u09A8 \u098F\u09AC\u0982 \u09B6\u09C7\u09DF\u09BE\u09B0 \u0995\u09B0\u09A4\u09C7 \u09AA\u09BE\u09B0\u09AC\u09C7\u09A8\u0964 \u0995\u09CB\u09A8 \u099F\u09C7\u0995\u09A8\u09BF\u0995\u09CD\u09AF\u09BE\u09B2 \u09B9\u09C7\u09B2\u09CD\u09AA \u09B2\u09BE\u0997\u09B2\u09C7 \u098F\u0987 94562455 \u09A8\u09BE\u09AE\u09CD\u09AC\u09BE\u09B0\u09C7 \u09AB\u09CB\u09A8 \u0995\u09B0\u09AC\u09C7\u09A8\u0964"), _react2.default.createElement("div", null, this.reloadAgain()), _react2.default.createElement("div", null, this.getStatementLink(), _react2.default.createElement("div", { style: { margin: "0px", textAlign: "center" } }, !this.props.ui["idScanInProgress"] && _react2.default.createElement("div", null, _react2.default.createElement("label", {
	        "for": "uploader",
	        style: (_ref5 = {
	          padding: "1px",
	          textAlign: "right",
	          border: "1px solid gainsboro",
	          borderRadius: _reactDeviceDetect.isMobile ? "5px" : "0px",
	          backgroundColor: "rgb(30, 101, 144)",
	          margin: "5px"
	        }, _defineProperty(_ref5, "padding", "6px"), _defineProperty(_ref5, "fontWeight", "bold"), _defineProperty(_ref5, "color", "white"), _defineProperty(_ref5, "fontSize", "12px"), _defineProperty(_ref5, "paddingLeft", "20px"), _defineProperty(_ref5, "paddingRight", "20px"), _ref5)
	      }, _react2.default.createElement("i", { className: "fa fa-camera" }), " SCAN PASSPORT \u09B8\u09CD\u0995\u09CD\u09AF\u09BE\u09A8 \u09AA\u09BE\u09B8\u09AA\u09CB\u09B0\u09CD\u099F")), this.props.ui["idScanInProgress"] && _react2.default.createElement("div", {
	        style: {
	          padding: "10px",
	          textAlign: "center"
	        }
	      }, _react2.default.createElement("div", null, _react2.default.createElement(_reactackle.LinearProgress, {
	        indeterminate: true,
	        subtitle: "Processing image, please wait as it may take upto a minute..."
	      }))), !this.props.ui["idScanInProgress"] && this.state.availableOptions && this.state.availableOptions.length > 0 && _react2.default.createElement("div", {
	        style: {
	          textAlign: "center",
	          margin: "10px"
	        }
	      }, this.state.availableOptions.length, "+ fields extracted from provided passport"), !this.state.generatingStatement && _react2.default.createElement("div", null, this.getRegFormField("textName", "আবেদনকারীর নাম (ইংরেজিতে)", "NAME"), this.getRegFormField("textNameBangla", "আবেদনকারীর নাম (বাংলায়)", "NAME (BANGLA)"), this.getRegFormField("emailId", "ইমেইল (যদি থাকে)", "EMAIL ID"), this.getRegFormField("phoneNumber", "ENTER PHONE NUMBER", "PHONE"), this.getRegFormField("passportNumber", "পাসপোর্ট নম্বর", "PASSPORT #"), this.getRegFormField("dateOfIssue", "ইস্যুর তারিখ", "ISSUE DATE"), this.getRegFormField("dateOfExpiry", "মেয়াদ উত্তীর্ণের তারিখ", "EXPIRY DATE"), this.getRegFormField("dateOfBirth", "জন্মতারিখ", "BIRTH DATE"), this.getRegFormField("placeOfIssue", "ইস্যুর স্থান", "PLACE OF ISSUE"), _react2.default.createElement("div", {
	        style: {
	          margin: "2px",
	          marginTop: "5px"
	        }
	      }, _react2.default.createElement("div", null, "EXPECTED CORRECTION"), _react2.default.createElement("div", null, "\u09AA\u09BE\u09B8\u09AA\u09CB\u09B0\u09CD\u099F\u09C7\u09B0 \u0995\u09CB\u09A8 \u09A4\u09A5\u09CD\u09AF \u09B8\u0982\u09B6\u09CB\u09A7\u09A8 \u0995\u09B0\u09A4\u09C7 \u099A\u09BE\u0987\u09B2\u09C7")), _react2.default.createElement("div", {
	        style: {
	          marginTop: "10px"
	        }
	      }, this.getRegFormField("infoExist1", "বর্তমানে প্রদর্শিত তথ্য", "1. EXISTING INFORMATION"), _react2.default.createElement("div", { style: { margin: "-5px" } }), this.getRegFormField("expectedChange1", "পরিবর্তন/সংশোধোন", "1. EXPECTED CHANGE")), _react2.default.createElement("div", {
	        style: {
	          marginTop: "10px"
	        }
	      }, this.getRegFormField("infoExist2", "বর্তমানে প্রদর্শিত তথ্য", "2. EXISTING INFORMATION"), _react2.default.createElement("div", { style: { margin: "-5px" } }), this.getRegFormField("expectedChange2", "পরিবর্তন/সংশোধোন", "2. EXPECTED CHANGE")), _react2.default.createElement("div", {
	        style: {
	          marginTop: "10px"
	        }
	      }, this.getRegFormField("infoExist3", "বর্তমানে প্রদর্শিত তথ্য", "3. EXISTING INFORMATION"), _react2.default.createElement("div", { style: { margin: "-5px" } }), this.getRegFormField("expectedChange3", "পরিবর্তন/সংশোধোন", "3. EXPECTED CHANGE")), _react2.default.createElement("div", {
	        style: {
	          marginTop: "10px"
	        }
	      }, this.getRegFormField("infoExist4", "বর্তমানে প্রদর্শিত তথ্য", "4. EXISTING INFORMATION"), _react2.default.createElement("div", { style: { margin: "-5px" } }), this.getRegFormField("expectedChange4", "পরিবর্তন/সংশোধোন", "4. EXPECTED CHANGE")), _react2.default.createElement(_SignPad2.default, {
	        title: "SIGN PAD",
	        sigB64: this.state.sigB64,
	        fieldName: "sigB64",
	        isPayload: true,
	        stateChangeHandler: this.stateChangeHandler,
	        disabled: false
	      }), _react2.default.createElement(_PhotoUploadPass2.default, {
	        title1: "PASSPORT PHOTO",
	        title2: "লোড পাসপোর্ট ফটো",
	        images: this.state.passportImages,
	        fieldName: "passportImages",
	        isPayload: false,
	        stateChangeHandler: this.stateChangeHandler,
	        disabled: false
	      }), _react2.default.createElement(_PhotoUploadPass2.default, {
	        title1: "WORK PERMIT PHOTO (FRONT)",
	        title2: "লোড পারমিটের সামনের ফটো",
	        images: this.state.wpFront,
	        fieldName: "wpFront",
	        isPayload: false,
	        stateChangeHandler: this.stateChangeHandler,
	        disabled: false
	      }), _react2.default.createElement(_PhotoUploadPass2.default, {
	        title1: "WORK PERMIT PHOTO (BACK)",
	        title2: "লোড পারমিটের পেছনের ফটো",
	        images: this.state.wpBack,
	        fieldName: "wpBack",
	        isPayload: false,
	        stateChangeHandler: this.stateChangeHandler,
	        disabled: false
	      })), _react2.default.createElement("input", {
	        type: "file",
	        accept: "image/*",
	        id: "uploader",
	        onChange: function onChange(evt) {
	          console.log("clicked");
	          //console.log("triggering main function");
	          event.preventDefault();
	          //console.log(evt.target.result);
	          if (evt.target.files[0]) {
	            _this3.idScanTo64(evt.target.files);
	          } else {
	            console.log("gotcha");
	          }
	        },
	        style: {
	          visibility: "hidden",
	          height: "0px"
	        }
	      }))), _react2.default.createElement("div", {
	        style: {
	          textAlign: "center",
	          width: "100%"
	        }
	      }, _react2.default.createElement("div", {
	        style: (_ref6 = {
	          width: "50%",
	          padding: "1px",
	          textAlign: "center",
	          border: "1px solid gainsboro",
	          borderRadius: _reactDeviceDetect.isMobile ? "5px" : "0px",
	          backgroundColor: "rgb(30, 101, 144)",
	          margin: "auto"
	        }, _defineProperty(_ref6, "padding", "6px"), _defineProperty(_ref6, "fontWeight", "bold"), _defineProperty(_ref6, "color", "white"), _defineProperty(_ref6, "fontSize", "12px"), _ref6),
	        onClick: function onClick() {
	          if (!_this3.state.generatingStatement) {
	            var allFieldsOK = true;
	            var reqFields = ["textName", "textNameBangla", "phoneNumber", "passportNumber", "dateOfIssue", "dateOfExpiry", "placeOfIssue"];
	            for (var i = 0; i < reqFields.length; i++) {
	              if (!_this3.state.data.payload[reqFields[i]] || _this3.state.data.payload[reqFields[i]] === "") {
	                console.log(reqFields[i]);
	                allFieldsOK = false;
	              }
	            }
	            if (allFieldsOK) {
	              _this3.genPOStatement();
	            } else {
	              alert("Please complete all fields before generating the PDF for passport renewal form.");
	            }
	          }
	        }
	      }, _react2.default.createElement("div", null, _react2.default.createElement("i", { className: "fa fa-print" }), " GENERATE FORM"), _react2.default.createElement("div", null, "\u09AB\u09B0\u09AE \u09A4\u09C8\u09B0\u09BF \u0995\u09B0\u09C1\u09A8")), this.getStatementLink(), this.state.generatingStatement && this.getStatementLoader()), _react2.default.createElement("canvas", {
	        id: "textCanvas",
	        style: { display: "none", border: "0px solid black" }
	      })));
	    }
	  }]);
	
	  return BgdPassportService;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    userProfile: state.db.userProfile,
	    db: state.db,
	    ui: state.ui
	  };
	}
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    onSetUiFlag: function onSetUiFlag(flagName, flagVal) {
	      return dispatch((0, _actions.setUiFlag)(flagName, flagVal));
	    },
	    onReachApi: function () {
	      var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(objContents) {
	        return regeneratorRuntime.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                return _context3.abrupt("return", dispatch((0, _actions.reachApi)(objContents)));
	
	              case 1:
	              case "end":
	                return _context3.stop();
	            }
	          }
	        }, _callee3, undefined);
	      }));
	
	      return function onReachApi(_x3) {
	        return _ref7.apply(this, arguments);
	      };
	    }(),
	    onGetPoStatement: function onGetPoStatement(data, templateId) {
	      return dispatch((0, _actions.getStatement)(templateId, data));
	    },
	    onNotifyUsers: function onNotifyUsers(msgBody, arrayOfUsers) {
	      return dispatch((0, _actions.notifyUsers)(msgBody, arrayOfUsers));
	    }
	  };
	};
	
	exports.default = (0, _recompose.compose)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _Firebase.withFirebase)(BgdPassportService);

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactackle = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(9);
	
	var _recompose = __webpack_require__(11);
	
	var _actions = __webpack_require__(13);
	
	var _Firebase = __webpack_require__(10);
	
	var _reactDeviceDetect = __webpack_require__(6);
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _addAudits = __webpack_require__(25);
	
	var _PhotoUploadPass = __webpack_require__(76);
	
	var _PhotoUploadPass2 = _interopRequireDefault(_PhotoUploadPass);
	
	var _SignPad = __webpack_require__(107);
	
	var _SignPad2 = _interopRequireDefault(_SignPad);
	
	var _mrpPmtImage = __webpack_require__(328);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _toConsumableArray(arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
	      arr2[i] = arr[i];
	    }return arr2;
	  } else {
	    return Array.from(arr);
	  }
	}
	
	function _asyncToGenerator(fn) {
	  return function () {
	    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
	      function step(key, arg) {
	        try {
	          var info = gen[key](arg);var value = info.value;
	        } catch (error) {
	          reject(error);return;
	        }if (info.done) {
	          resolve(value);
	        } else {
	          return Promise.resolve(value).then(function (value) {
	            step("next", value);
	          }, function (err) {
	            step("throw", err);
	          });
	        }
	      }return step("next");
	    });
	  };
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var BgdPassportServiceExt = function (_Component) {
	  _inherits(BgdPassportServiceExt, _Component);
	
	  function BgdPassportServiceExt() {
	    var _ref,
	        _this2 = this;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, BgdPassportServiceExt);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BgdPassportServiceExt.__proto__ || Object.getPrototypeOf(BgdPassportServiceExt)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      data: {
	        path: "myPassApplication",
	        payload: _extends({
	          textName: "",
	          textNameBangla: "",
	          emailId: "",
	          phoneNumber: _this.props.cellPhone,
	          passportNumber: "",
	          dateOfIssue: "",
	          dateOfExpiry: "",
	          placeOfIssue: "",
	          dateOfBirth: "",
	          infoExist1: "",
	          expectedChange1: "",
	          infoExist2: "",
	          expectedChange2: "",
	          infoExist3: "",
	          expectedChange3: "",
	          infoExist4: "",
	          expectedChange4: "",
	          wpBack: [],
	          wpFront: [],
	          passportImages: []
	        }, _this.props.db["myPassDetails"])
	      },
	
	      reloadDone: false,
	      generatingStatement: false,
	      statementLink: "",
	      b64Text: "",
	      stage: "home",
	      sgPresence: ""
	    }, _this.stateChangeHandler = function (val, id, isPayload) {
	      // console.log(
	      //   "val: " + JSON.stringify(val) + " id: " + id + " isPayload: " + isPayload
	      // );
	      var tmpState = {};
	      tmpState[id] = val;
	
	      if (isPayload) {
	        _this.setState(function (prevState) {
	          if (prevState && prevState.data.payload !== null) {
	            return _extends({}, prevState, {
	              data: _extends({}, prevState.data, {
	                payload: _extends({}, prevState.data.payload, tmpState)
	              })
	            });
	          } else {
	            return _extends({}, prevState, {
	              data: {
	                path: prevState.data.path,
	                payload: _extends({}, tmpState)
	              }
	            });
	          }
	        }, function () {
	          _this.props.onAddRecord({
	            path: "myPassApplication",
	            payload: _this.state
	          });
	        });
	      } else {
	        _this.setState(function (prevState) {
	          return _extends({}, prevState, tmpState);
	        }, function () {
	          _this.props.onAddRecord({
	            path: "myPassApplication",
	            payload: _this.state
	          });
	        });
	      }
	    }, _this.openPdfInAppBrowser = function () {
	      var msgToApp = {
	        actionType: "openPdf",
	        payload: {
	          url: _this.state.statementLink
	        }
	      };
	
	      if (window && window.ReactNativeWebView) {
	        //console.log("posing autologin message to app");
	        window.ReactNativeWebView.postMessage(JSON.stringify(msgToApp));
	      }
	    }, _this.getStatementLoader = function () {
	      return _react2.default.createElement("div", {
	        style: {
	          textAlign: "center",
	          padding: "30px"
	        }
	      }, _react2.default.createElement(_reactackle.CircleProgress, {
	        indeterminate: true,
	        circleSize: 80,
	        strokeSize: 10,
	        labelPositionY: "bottom",
	        labelPositionX: "center"
	      }), _react2.default.createElement("div", { style: { fontSize: "20px", marginTop: "10px" } }, "Submitting application... please be patient as it can take upto a minute ", _react2.default.createElement("br", null), "\u098F\u0995\u099F\u09C1 \u0985\u09AA\u09C7\u0995\u09CD\u09B7\u09BE \u0995\u09B0\u09C1\u09A8, \u09AB\u09B0\u09AE \u0987\u09AE\u09C7\u0987\u09B2 \u09B9\u09A4\u09C7 \u098F\u0995 \u09AE\u09BF\u09A8\u09BF\u099F\u09C7\u09B0 \u09AE\u09A4\u09CB \u09B2\u09BE\u0997\u09A4\u09C7 \u09AA\u09BE\u09B0\u09C7\u0964"));
	    }, _this.getManualPDFLoader = function () {
	      return _react2.default.createElement("div", {
	        style: {
	          textAlign: "center",
	          padding: "30px"
	        }
	      }, _react2.default.createElement(_reactackle.CircleProgress, {
	        indeterminate: true,
	        circleSize: 80,
	        strokeSize: 10,
	        labelPositionY: "bottom",
	        labelPositionX: "center"
	      }), _react2.default.createElement("div", { style: { fontSize: "20px", marginTop: "10px" } }, "Generating PDF... please be patient as it can take upto a minute", " ", _react2.default.createElement("br", null), "\u098F\u0995\u099F\u09C1 \u0985\u09AA\u09C7\u0995\u09CD\u09B7\u09BE \u0995\u09B0\u09C1\u09A8, \u09AB\u09B0\u09AE \u0987\u09AE\u09C7\u0987\u09B2 \u09B9\u09A4\u09C7 \u098F\u0995 \u09AE\u09BF\u09A8\u09BF\u099F\u09C7\u09B0 \u09AE\u09A4\u09CB \u09B2\u09BE\u0997\u09A4\u09C7 \u09AA\u09BE\u09B0\u09C7\u0964"));
	    }, _this.getFormattedDate = function (dtText, dtFormat) {
	      if (dtText) {
	        dtText = dtText.trim();
	      }
	      if (dtText && dtText.length === 11) {
	        var momDate = (0, _moment2.default)(dtText, "DD MMM YYYY").toString();
	        if (momDate.includes("Invalid")) {
	          return "Invalid Date";
	        } else {
	          var tgtDate = (0, _moment2.default)(dtText, "DD MMM YYYYY").format(dtFormat).toString();
	          return tgtDate;
	        }
	      } else {
	        if (dtText !== "") {
	          return "Invalid Date";
	        }
	      }
	    }, _this.getPaddedStrObj = function (strText, fieldName) {
	      strText = strText.trim();
	      var retObj = {};
	      var ctr = 1;
	      for (var i = 0; i < strText.length; i++) {
	        retObj[fieldName + "" + ctr] = strText[i] + "";
	        ctr = ctr + 1;
	      }
	      return retObj;
	    }, _this.getPOData = function () {
	      var statePoData = _this.state.data.payload;
	      var finalPoData = JSON.parse(JSON.stringify(statePoData));
	      var issueDateObj = _this.getPaddedStrObj(_this.getFormattedDate(finalPoData.dateOfIssue, "DDMMYYYY"), "dateOfIssue");
	      var expiryDateObj = _this.getPaddedStrObj(_this.getFormattedDate(finalPoData.dateOfExpiry, "DDMMYYYY"), "dateOfExpiry");
	      var dateObj = _this.getPaddedStrObj((0, _moment2.default)().format("DDMMYY").toString(), "date");
	      var pNumberObj = _this.getPaddedStrObj(finalPoData.passportNumber, "passportNumber");
	      var baseData = _extends({
	        nameEnglish: finalPoData.textName,
	        nameBangla: finalPoData.textNameBangla,
	        dob: finalPoData.dateOfBirth
	      }, pNumberObj, issueDateObj, expiryDateObj, {
	        placeOfIssue: finalPoData.placeOfIssue,
	        mobileNumber: finalPoData.phoneNumber,
	        emailAddress: finalPoData.emailId,
	        banglaB64Text: finalPoData.banglaB64Text,
	        infoExist1: finalPoData.infoExist1,
	        expectedChange1: finalPoData.expectedChange1,
	        infoExist2: finalPoData.infoExist2,
	        expectedChange2: finalPoData.expectedChange2,
	        infoExist3: finalPoData.infoExist3,
	        expectedChange3: finalPoData.expectedChange3,
	        infoExist4: finalPoData.infoExist4,
	        expectedChange4: finalPoData.expectedChange4,
	        passportImage: _this.state.passportImages && _this.state.passportImages[0] ? _this.state.passportImages[0].b64 : "",
	        wpFront: _this.state.wpFront && _this.state.wpFront[0] ? _this.state.wpFront[0].b64 : "",
	        wpBack: _this.state.wpBack && _this.state.wpBack[0] ? _this.state.wpBack[0].b64 : "",
	        payPhoto: _this.state.payPhoto && _this.state.payPhoto[0] ? _this.state.payPhoto[0].b64 : "",
	        sigB64: _this.state.sigB64
	      }, dateObj);
	
	      //console.log(JSON.stringify(finalPoData));
	      return baseData;
	    }, _this.getTemplateId = function () {
	      var templateId = "131894";
	
	      return templateId;
	    }, _this.getEmailText = function () {
	      var emTxt = "Dear Sir \n Please see attached my application";
	      emTxt = emTxt + " for passport renewal(or updates) as per the following details: \n";
	      emTxt = emTxt + "\n";
	      emTxt = emTxt + "\n";
	      emTxt = emTxt + "Applicant Name (English): " + _this.state.data.payload.textName + " \n";
	      emTxt = emTxt + "Applicant Name (Bangla): " + _this.state.data.payload.textNameBangla + " \n";
	      emTxt = emTxt + "Passport No.: " + _this.state.data.payload.passportNumber + " \n";
	      emTxt = emTxt + "Place of Issue: " + _this.state.data.payload.placeOfIssue + " \n";
	      emTxt = emTxt + "Date of Expiry: " + _this.state.data.payload.dateOfExpiry + " \n";
	      emTxt = emTxt + "Date of Issue: " + _this.state.data.payload.dateOfIssue + " \n";
	      emTxt = emTxt + "Date: " + (0, _moment2.default)().format("DDMMYYYY").toString() + " \n";
	      emTxt = emTxt + "Mobile No: " + _this.state.data.payload.phoneNumber + " \n";
	      emTxt = emTxt + "Email Address: " + _this.state.data.payload.emailId + " \n";
	      emTxt = emTxt + "\n";
	      emTxt = emTxt + "\n";
	      emTxt = emTxt + "Expected Corrections (if any)" + " \n";
	      emTxt = emTxt + _this.state.data.payload.infoExist1 + "  :   " + _this.state.data.payload.expectedChange1 + "   \n";
	      emTxt = emTxt + _this.state.data.payload.infoExist2 + "  :   " + _this.state.data.payload.expectedChange2 + "   \n";
	      emTxt = emTxt + _this.state.data.payload.infoExist3 + "  :   " + _this.state.data.payload.expectedChange3 + "   \n";
	      emTxt = emTxt + _this.state.data.payload.infoExist4 + "  :   " + _this.state.data.payload.expectedChange4 + "   \n";
	
	      emTxt = emTxt + "\n";
	      emTxt = emTxt + "I have attached with this email the duly completed application form along with photocopies of following documents: \n";
	      emTxt = emTxt + " - Passport \n - Work Permit (Front & Back) \n - Proof of payment \n";
	      emTxt = emTxt + "For any further information please rechout to me at my phone number or email provided above.\n";
	      emTxt = emTxt + "\n";
	      emTxt = emTxt + "\n Note: \n";
	      emTxt = emTxt + "";
	      emTxt = emTxt + "- This is a system generated email. \n";
	      emTxt = emTxt + " - Information provided above is as per the data provided by users, and it is the responsibility of users to ensure correct input of all information. \n";
	      emTxt = emTxt + "- For any further information please contact the applicant or Bangladesh High Commission directly \n";
	      emTxt = emTxt + " - BCS App only generates the application form and sends an email application to the High Commission to facilitate workers and make it easier to send passport renewal application. For any further enquires on the renewal process / acceptance of application, users are responsible to contact Bangladesh High Commission directly. \n";
	      emTxt = emTxt + " - Please note it is applicant's responsibility to contact the High Commission directly. This email is may not be enough for your applicaiton to be accepted as you might be required to visit High Commission in person. \n";
	
	      emTxt = emTxt + "\n ";
	      emTxt = emTxt + "\n";
	      emTxt = emTxt + "\n";
	      return emTxt;
	    }, _this.getHtmlRow = function (heading, value) {
	      return "<tr><td style='border: 1px solid black;padding: 5px'>" + heading + "</td><td style='border: 1px solid black;padding: 5px'>" + value + "</td></tr>";
	    }, _this.getRow = function (heading, value) {
	      return _react2.default.createElement("tr", null, _react2.default.createElement("td", null, heading), _react2.default.createElement("td", null, value));
	    }, _this.getEmailHtml = function () {
	      var emTxt = "<p>Dear Sir </p><p> Please see attached my application";
	      emTxt = emTxt + " for passport renewal as per the following details: </p>";
	      emTxt = emTxt + "<p></p>";
	      emTxt = emTxt + "<table style='border: 1px solid black;max-width: 450px;min-width:450px'><tbody>";
	      emTxt = emTxt + _this.getHtmlRow("Applicant Name (English)", _this.state.data.payload.textName);
	      emTxt = emTxt + _this.getHtmlRow("Applicant Name (Bangla)", _this.state.data.payload.textNameBangla);
	      emTxt = emTxt + _this.getHtmlRow("Passport No.", _this.state.data.payload.passportNumber);
	
	      emTxt = emTxt + _this.getHtmlRow("Place of Issue", _this.state.data.payload.placeOfIssue);
	      emTxt = emTxt + _this.getHtmlRow("Date of Expiry", _this.state.data.payload.dateOfExpiry);
	      emTxt = emTxt + _this.getHtmlRow("Date of Issue", _this.state.data.payload.dateOfIssue);
	      emTxt = emTxt + _this.getHtmlRow("Date", (0, _moment2.default)().format("DD MMM YYYY").toString());
	      emTxt = emTxt + _this.getHtmlRow("Mobile No", _this.state.data.payload.phoneNumber);
	
	      emTxt = emTxt + _this.getHtmlRow("Email Address", _this.state.data.payload.emailId);
	      emTxt = emTxt + "</tbody></table>";
	      emTxt = emTxt + "<p></p><p></p>";
	      emTxt = emTxt + "<p>Expected Corrections (if any)" + " </p>";
	      emTxt = emTxt + "<table style='border: 1px solid black; max-width: 450px;min-width:450px'><tbody>";
	      emTxt = emTxt + _this.getHtmlRow(_this.state.data.payload.infoExist1, _this.state.data.payload.expectedChange1);
	      emTxt = emTxt + _this.getHtmlRow(_this.state.data.payload.infoExist2, _this.state.data.payload.expectedChange2);
	      emTxt = emTxt + _this.getHtmlRow(_this.state.data.payload.infoExist3, _this.state.data.payload.expectedChange3);
	      emTxt = emTxt + _this.getHtmlRow(_this.state.data.payload.infoExist4, _this.state.data.payload.expectedChange4);
	      emTxt = emTxt + "</tbody></table>";
	      emTxt = emTxt + "<p>I have attached with this email the duly completed application form along with photocopies of following documents:</p>";
	      emTxt = emTxt + "<ul><li>Passport</li><li>Work Permit (Front & Back)</li><li>Proof of payment</li></ul>";
	      emTxt = emTxt + "<p>For any further information please rechout to me at my phone number or email provided above.</p>";
	      emTxt = emTxt + "<p></p>";
	      emTxt = emTxt + "<p><b>Note:</b></p>";
	      emTxt = emTxt + "<p></p>";
	      emTxt = emTxt + "<p><ul><li>This is a system generated email.</li>";
	      emTxt = emTxt + "<li>Information provided in this renewal application, is as per the data provided by users, and it is the responsibility of users to ensure correct input of all information.</li>";
	      emTxt = emTxt + "<li>For any further information please contact the applicant directly</li>";
	      emTxt = emTxt + "<li>BCS App only generates the application form and submits an email application to the High Commission to facilitate passport holders and make it very easy and simple to submit passport renewal applications. For any further enquires on the renewal process / acceptance of application, users are responsible to contact Bangladesh High Commission directly.</li><ul>";
	      emTxt = emTxt + "</p>";
	      emTxt = emTxt + "<p></p>";
	      return emTxt;
	    }, _this.genPOStatement = function () {
	      //set loader to yes
	
	      var emailParams = {
	        from: '"BCS Easy Passport Application" helper@brooklynzcommunitysupport.com', // sender address
	        to: _this.state.data.payload.emailId + ",mrp.bdhc.sg@gmail.com", // list of receivers
	        subject: "Passport Application [" + _this.state.data.payload.textName + " | " + _this.state.data.payload.passportNumber + " | " + _this.props.cellPhone + "]", // Subject line
	        text: _this.getEmailText(), // plain text body
	        html: _this.getEmailHtml() // html body
	      };
	
	      //get state updated with calc fields
	      Promise.all([_this.getPOData(), _this.getTemplateId(), _this.stateChangeHandler(true, "generatingStatement", false), _this.stateChangeHandler("", "statementLink", false)]).then(function (res) {
	        //console.log("test test: " + res[1]);
	
	        _this.props.onGetPoStatementB64(res[0], res[1], emailParams).then(function (pdfResp) {
	          _this.saveHandler();
	          _this.createPassRec();
	          var suppNotifyText = "New End to End passport form generated by " + _this.state.data.payload.textName + " (" + _this.state.data.payload.phoneNumber + ").";
	          _this.props.onNotifyUsers(suppNotifyText, ["94562455"]);
	          _this.stateChangeHandler(false, "generatingStatement", false);
	          _this.stateChangeHandler("submit", "stage", false);
	          _this.props.onAddRecord({
	            path: "myPassApplication",
	            payload: {}
	          });
	        }).catch(function (err) {
	          console.log("Salaaa error: " + err);
	          _this.stateChangeHandler(false, "generatingStatement", false);
	          _this.stateChangeHandler("", "b64Text", false);
	        });
	      });
	      //request new statement
	      //once req completed show the stop loader and show statement
	    }, _this.checkDateContent = function (dtText) {
	      dtText = dtText.trim();
	      if (dtText && dtText !== "" && dtText.length !== 11) {
	        return _react2.default.createElement("div", { style: { padding: "2px" } }, "Please enter date in DD MMM YYYY format. For example 01 JAN 2020. It should match the date on your passport.");
	      } else {
	        if (dtText.length === 11) {
	          var dateMom = (0, _moment2.default)(dtText, "DD MMM YYYY").toString();
	          if (dateMom.includes("Invalid")) {
	            return _react2.default.createElement("div", { style: { padding: "2px" } }, "Please enter date in DD MMM YYYY format. For example 01 JAN 2020. It should match the date on your passport.");
	          }
	        }
	      }
	    }, _this.getRegFormField = function (fieldId, placeholder, caption) {
	      return _react2.default.createElement("div", null, _react2.default.createElement("div", {
	        style: {
	          padding: "1px",
	          textAlign: "right",
	          border: "1px solid gainsboro",
	          borderRadius: _reactDeviceDetect.isMobile ? "5px" : "0px",
	          backgroundColor: "white",
	          zIndex: "-9",
	          margin: "5px",
	          fontSize: "12px"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          display: "flex",
	          flexDirection: "row"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          width: "40%",
	          lineHeight: "12px",
	          textAlign: "left",
	          paddingLeft: "5px",
	          margin: "auto"
	        }
	      }, caption), _react2.default.createElement("div", {
	        style: {
	          width: "60%",
	          border: "1px solid gainsboro",
	          borderRadius: "5px",
	          borderTopLeftRadius: "0px",
	          borderBottomLeftRadius: "0px",
	          margin: "2px"
	        }
	      }, _react2.default.createElement(_reactackle.TextField, {
	        value: _this.state.data.payload[fieldId],
	        onChange: function onChange(e) {
	          _this.stateChangeHandler(e.value, fieldId, true);
	          if (fieldId === "textNameBangla") {
	            _this.getBanglaImage(e.value);
	          }
	        },
	        onFocus: function onFocus() {
	          _this.stateChangeHandler(fieldId, "selectedField", false);
	        },
	        onFocusOut: function onFocusOut() {
	          console.log("focus out");
	        },
	        fullWidth: true,
	        placeholder: placeholder
	      }))), _react2.default.createElement("div", {
	        style: {
	          textAlign: "center",
	          fontSize: "12px",
	          color: "red"
	        }
	      }, fieldId.includes("dateOf") && _this.checkDateContent(_this.state.data.payload[fieldId]))), _this.state.selectedField && _this.state.selectedField === fieldId && _this.state.availableOptions && _react2.default.createElement("div", {
	        style: {
	          padding: "5px",
	          overflow: "auto",
	          border: "1.5px solid white"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          display: "flex",
	          flexDirection: "row",
	          borderBottom: "1.5px soid white",
	          margin: "-5px",
	          marginBottom: "5px"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          width: "70%",
	          borderBottom: "1.5px solid white",
	          paddingLeft: "5px",
	          textAlign: "left"
	        }
	      }, "Suggestions:"), _react2.default.createElement("div", {
	        style: {
	          width: "30%",
	          textAlign: "right",
	          borderBottom: "1.5px solid white",
	          paddingRight: "5px"
	        },
	        onClick: function onClick() {
	          _this.stateChangeHandler(undefined, "selectedField", false);
	        }
	      }, _react2.default.createElement("icon", {
	        className: "fa fa-close",
	        style: { color: "red", fontSize: "20px" }
	      }))), _this.getSelectionTexts(fieldId)));
	    }, _this.getSelectionTexts = function (fieldId) {
	      var dateFields = ["dateOfIssue", "dateOfBirth", "dateOfExpiry"];
	      var otherFields = ["textName", "passportNumber"];
	
	      if (otherFields.includes(fieldId)) {
	        return _this.state.availableOptions.map(function (optText) {
	          return _react2.default.createElement("span", {
	            onClick: function onClick() {
	              _this.stateChangeHandler(_this.state.data.payload[fieldId] + " " + optText, fieldId, true);
	            },
	            style: {
	              margin: "5px",
	              border: "1px solid white",
	              padding: "5px",
	              borderRadius: "5px",
	              wordWrap: "normal",
	              display: "inline-block",
	              lineHeight: "14px"
	            }
	          }, optText);
	        });
	      } else {
	        if (dateFields.includes(fieldId)) {
	          console.log("tada " + _this.state.availableDateOptions);
	          return _this.state.availableDateOptions.map(function (optText) {
	            return _react2.default.createElement("span", {
	              onClick: function onClick() {
	                _this.stateChangeHandler(_this.state.data.payload[fieldId] + " " + optText, fieldId, true);
	              },
	              style: {
	                margin: "5px",
	                border: "1px solid white",
	                padding: "5px",
	                borderRadius: "5px",
	                wordWrap: "normal",
	                display: "inline-block",
	                lineHeight: "14px"
	              }
	            }, optText);
	          });
	        }
	      }
	    }, _this.getOptions = function (awsRes) {
	      function hasLowerCase(str) {
	        return (/[a-z]/.test(str)
	        );
	      }
	
	      var filtText = [];
	      var dateText = [];
	      for (var i = 0; i < awsRes.rawData.Blocks.length; i++) {
	        var blockObj = awsRes.rawData.Blocks[i];
	        if (blockObj.BlockType && blockObj.BlockType === "LINE") {
	          var strText = blockObj.Text;
	          var confLevel = parseFloat(blockObj.Confidence);
	          if (confLevel > 85 && !hasLowerCase(strText)) {
	            if (strText.length === 11) {
	              var dateCheckStr = (0, _moment2.default)(strText, "DD MMM YYYY").toString();
	              if (!dateCheckStr.includes("Invalid")) {
	                dateText.push((0, _moment2.default)(strText, "DD MMM YYYY").format("DD MMM YYYY").toString());
	              }
	            } else {
	              filtText.push(strText);
	            }
	          }
	        }
	      }
	      _this.stateChangeHandler(filtText, "availableOptions", false);
	      _this.stateChangeHandler(dateText, "availableDateOptions", false);
	    }, _this.getScanResults = function () {
	      document.getElementById("uploader").value = "";
	      var fullObj = _this.props.db.idScanResult;
	      _this.getOptions(fullObj);
	      var textsObj = undefined;
	      if (fullObj && fullObj.keyValues) {
	        textsObj = fullObj.keyValues;
	      }
	      if (textsObj && textsObj !== undefined && Object.keys(textsObj).length > 0) {
	        // return textsArray.map(txtObj => {
	        //   return <div>{txtObj.DetectedText}</div>;
	        // });
	        var txtName = "";
	        var ppNumber = "";
	        var expiryDate = "";
	        var dob = "";
	        var issueDate = "";
	
	        for (var key in textsObj) {
	          if (key && key.length > 0 && key.toLowerCase().includes("ven name")) {
	            txtName = txtName + " " + textsObj[key];
	            _this.stateChangeHandler(txtName, "txtName", true);
	          }
	          if (key && key.length > 0 && key.toLowerCase().includes("urname")) {
	            txtName = txtName + " " + textsObj[key];
	            _this.stateChangeHandler(txtName, "txtName", true);
	          }
	          if (key && key.length > 0 && key.toLowerCase().includes("ate of issue")) {
	            issueDate = textsObj[key];
	            _this.stateChangeHandler(issueDate, "dateOfIssue", true);
	          }
	          if (key && key.length > 0 && key.toLowerCase().includes("ate of expiry")) {
	            expiryDate = textsObj[key];
	            _this.stateChangeHandler(expiryDate, "dateOfExpiry", true);
	          }
	          if (key && key.length > 0 && key.toLowerCase().includes("ate of birth")) {
	            dob = textsObj[key];
	            _this.stateChangeHandler(dob, "dateOfBirth", true);
	          }
	          if (key && key.length > 0 && key.toLowerCase().includes("passport n") && !key.toLowerCase().includes("previous")) {
	            ppNumber = textsObj[key];
	            _this.stateChangeHandler(ppNumber, "passportNumber", true);
	          }
	        }
	      } else {
	        return _react2.default.createElement("div", null, "Unable to detect passport information, please return or key in manually", _react2.default.createElement("div", null, JSON.stringify(textsObj)));
	      }
	    }, _this.idScanTo64 = function () {
	      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(evtFiles) {
	        var Compress, compress, files;
	        return regeneratorRuntime.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _this.props.onSetUiFlag("idScanInProgress", true);
	
	                try {
	                  //console.log("triggering inside uploadImage function");
	
	                  Compress = __webpack_require__(81);
	                  compress = new Compress();
	                  files = [].concat(_toConsumableArray(evtFiles));
	
	                  compress.compress(files, {
	                    size: 0.5, // the max size in MB, defaults to 2MB
	                    quality: 1, // the quality of the image, max is 1,
	                    maxWidth: 800, // the max width of the output image, defaults to 1920px
	                    maxHeight: 800, // the max height of the output image, defaults to 1920px
	                    resize: true // defaults to true, set false if you do not want to resize the image width and height
	                  }).then(function () {
	                    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(data) {
	                      var objContents;
	                      return regeneratorRuntime.wrap(function _callee$(_context) {
	                        while (1) {
	                          switch (_context.prev = _context.next) {
	                            case 0:
	                              objContents = {
	                                fetchQuery: "https://4ldlcf9ad4.execute-api.ap-southeast-2.amazonaws.com/dev/ak",
	                                method: "POST",
	                                headers: {
	                                  Accept: "application/json",
	                                  "Content-Type": "application/json"
	                                },
	                                message: JSON.stringify({
	                                  imageBase64: data[0].data,
	                                  Filters: {
	                                    RegionsOfInterest: [{
	                                      BoundingBox: {
	                                        Height: 0.2,
	                                        Left: 0.01,
	                                        Top: 0.7,
	                                        Width: 1.0
	                                      }
	                                    }]
	                                  }
	                                }),
	                                path: "idScanResult"
	                              };
	
	                              _this.props.onReachApi(objContents).then(function (res) {
	                                var suppNotifyText = "New passport scanned by " + _this.state.data.payload.textName + " (" + _this.state.data.payload.phoneNumber + ").";
	                                _this.props.onNotifyUsers(suppNotifyText, ["94562455"]);
	                                _this.getScanResults();
	                              });
	
	                            case 2:
	                            case "end":
	                              return _context.stop();
	                          }
	                        }
	                      }, _callee, _this2);
	                    }));
	
	                    return function (_x2) {
	                      return _ref3.apply(this, arguments);
	                    };
	                  }());
	                } catch (err) {
	                  _this.props.onSetUiFlag("idScanInProgress", false);
	                  alert(err);
	                }
	
	              case 2:
	              case "end":
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }));
	
	      return function (_x) {
	        return _ref2.apply(this, arguments);
	      };
	    }(), _this.saveHandler = function () {
	      if (_this.props.cellPhone && _this.props.cellPhone !== "") {
	        var myCellNumber = _this.props.cellPhone.replace("+65", "");
	        var cloudPath = "myPassDetails/" + myCellNumber;
	
	        var saveObj = {
	          phoneNumber: _this.props.cellPhone,
	          dateOfExpiry: _this.state.data.payload.dateOfExpiry
	        };
	
	        Promise.all([(0, _addAudits.addAudit)(_this.stateChangeHandler, _this.props.cellPhone, true)
	        //get new ID
	        ]).then(function (res) {
	          //console.log(JSON.stringify(this.state.data.payload));
	          _this.props.firebase.db.ref("/" + cloudPath).once("value").then(function (snap) {
	            return snap.ref.set(saveObj);
	          }).catch(function (err) {
	            console.log(err);
	            return console.log("some error: " + err);
	          }).then(function (err) {
	            console.log("updated");
	          });
	        });
	      }
	    }, _this.createPassRec = function () {
	      var cloudPath = "hCommApps/";
	      var passApp = _this.props.firebase.db.ref("/" + cloudPath).push();
	      passApp.set({
	        applicationDate: (0, _moment2.default)().format("DD MMM YYYY"),
	        passportNo: _this.state.data.payload.passportNumber,
	        status: "EMAIL GENERATED",
	        name: _this.state.data.payload.textName,
	        cellPhone: _this.props.cellPhone
	      }).catch(function (err) {
	        console.log(err);
	        return console.log("some error: " + err);
	      }).then(function (err) {
	        //clear the bucket
	        _this.props.firebase.db.ref("/myPassApps" + "/" + _this.props.cellPhone + "/" + passApp.key).once("value").then(function (snap) {
	          return snap.ref.set({
	            applicationDate: (0, _moment2.default)().format("DD MMM YYYY"),
	            passportNo: _this.state.data.payload.passportNumber,
	            status: "EMAIL GENERATED",
	            name: _this.state.data.payload.textName,
	            cellPhone: _this.props.cellPhone
	          });
	        }).catch(function (err) {
	          console.log(err);
	          return console.log("some error: " + err);
	        }).then(function (err) {
	          console.log("updated");
	        });
	      });
	    }, _this.reloadAgain = function () {
	      //...this.props.db["myPassDetails"]
	      if (!_this.state.reloadDone) {
	        _this.setState(function (prevState) {
	          return _extends({}, prevState, {
	            data: {
	              path: "",
	              payload: _extends({}, prevState.data.payload, _this.props.db["myPassDetails"])
	            },
	            reloadDone: true
	          });
	        });
	      }
	    }, _this.getBanglaImage = function (banglaText) {
	      var tCtx = document.getElementById("textCanvas").getContext("2d");
	      tCtx.canvas.width = tCtx.measureText(banglaText).width;
	      tCtx.canvas.height = 25;
	      tCtx.font = "12px verdana";
	
	      tCtx.fillText(banglaText, 0, 20);
	      var banglaB64Text = tCtx.canvas.toDataURL();
	      _this.stateChangeHandler(banglaB64Text, "banglaB64Text", true);
	      //console.log(imageElem.src);
	    }, _this.validatePayPhoto = function () {
	      var allFieldsOK = true;
	      if (!_this.state.payPhoto || _this.state.payPhoto.length === 0) {
	        allFieldsOK = false;
	      }
	      return allFieldsOK;
	    }, _this.validateGenPhotos = function () {
	      var allFieldsOK = true;
	      var wpFront = !_this.state.wpFront || _this.state.wpFront.length === 0;
	      var wpBack = !_this.state.wpBack || _this.state.wpBack.length === 0;
	      var pPhoto = !_this.state.passportImages || _this.state.passportImages.length === 0;
	      var signText = !_this.state.sigB64 || _this.state.sigB64 === "";
	      //console.log("returning: " + allFieldsOK);
	      if (wpFront || wpBack || pPhoto || signText) {
	        allFieldsOK = false;
	      }
	      return allFieldsOK;
	    }, _this.validateGeneralInputs = function () {
	      var allFieldsOK = true;
	      var reqFields = ["textName", "textNameBangla", "phoneNumber", "passportNumber", "dateOfIssue", "dateOfExpiry", "placeOfIssue"];
	      for (var i = 0; i < reqFields.length; i++) {
	        if (!_this.state.data.payload[reqFields[i]] || _this.state.data.payload[reqFields[i]] === "") {
	          //console.log(reqFields[i]);
	          allFieldsOK = false;
	        }
	      }
	      //console.log("returning: " + allFieldsOK);
	      return allFieldsOK;
	    }, _this.getFormInputStageGeneral = function () {
	      var _ref4;
	
	      return _react2.default.createElement("div", null, _react2.default.createElement("div", null, _this.getNextBack("applyHome", "inputCorrection"), _react2.default.createElement("div", { style: { margin: "0px", textAlign: "center" } }, !_this.props.ui["idScanInProgress"] && _react2.default.createElement("div", null, _react2.default.createElement("label", {
	        "for": "uploader",
	        style: (_ref4 = {
	          padding: "1px",
	          textAlign: "right",
	          border: "1px solid gainsboro",
	          borderRadius: _reactDeviceDetect.isMobile ? "5px" : "0px",
	          backgroundColor: "rgb(30, 101, 144)",
	          margin: "5px"
	        }, _defineProperty(_ref4, "padding", "6px"), _defineProperty(_ref4, "fontWeight", "bold"), _defineProperty(_ref4, "color", "white"), _defineProperty(_ref4, "fontSize", "12px"), _defineProperty(_ref4, "paddingLeft", "20px"), _defineProperty(_ref4, "paddingRight", "20px"), _ref4)
	      }, _react2.default.createElement("i", { className: "fa fa-camera" }), " SCAN PASSPORT \u09B8\u09CD\u0995\u09CD\u09AF\u09BE\u09A8 \u09AA\u09BE\u09B8\u09AA\u09CB\u09B0\u09CD\u099F")), _this.props.ui["idScanInProgress"] && _react2.default.createElement("div", {
	        style: {
	          padding: "10px",
	          textAlign: "center"
	        }
	      }, _react2.default.createElement("div", null, _react2.default.createElement(_reactackle.LinearProgress, {
	        indeterminate: true,
	        subtitle: "Processing image, please wait as it may take upto a minute..."
	      }))), !_this.props.ui["idScanInProgress"] && _this.state.availableOptions && _this.state.availableOptions.length > 0 && _react2.default.createElement("div", {
	        style: {
	          textAlign: "center",
	          margin: "10px"
	        }
	      }, _this.state.availableOptions.length, "+ fields extracted from provided passport"), !_this.state.generatingStatement && _react2.default.createElement("div", null, _this.getRegFormField("textName", "আবেদনকারীর নাম (ইংরেজিতে)", "NAME"), _this.getRegFormField("textNameBangla", "আবেদনকারীর নাম (বাংলায়)", "NAME (BANGLA)"), _this.getRegFormField("emailId", "ইমেইল (যদি থাকে)", "EMAIL ID"), _this.getRegFormField("phoneNumber", "ENTER PHONE NUMBER", "PHONE"), _this.getRegFormField("passportNumber", "পাসপোর্ট নম্বর", "PASSPORT #"), _this.getRegFormField("dateOfIssue", "ইস্যুর তারিখ", "ISSUE DATE"), _this.getRegFormField("dateOfExpiry", "মেয়াদ উত্তীর্ণের তারিখ", "EXPIRY DATE"), _this.getRegFormField("dateOfBirth", "জন্মতারিখ", "BIRTH DATE"), _this.getRegFormField("placeOfIssue", "ইস্যুর স্থান", "PLACE OF ISSUE"), _react2.default.createElement("input", {
	        type: "file",
	        accept: "image/*",
	        id: "uploader",
	        onChange: function onChange(evt) {
	          console.log("clicked");
	          //console.log("triggering main function");
	          event.preventDefault();
	          //console.log(evt.target.result);
	          if (evt.target.files[0]) {
	            _this.idScanTo64(evt.target.files);
	          } else {
	            console.log("gotcha");
	          }
	        },
	        style: {
	          visibility: "hidden",
	          height: "0px"
	        }
	      })))));
	    }, _this.getFormInputStageCorrections = function () {
	      return _react2.default.createElement("div", null, _react2.default.createElement("div", null, _this.getNextBack("inputGeneral", "inputPhotos"), _react2.default.createElement("div", { style: { margin: "0px", textAlign: "center" } }, _react2.default.createElement("div", {
	        style: {
	          margin: "2px",
	          marginTop: "5px"
	        }
	      }, _react2.default.createElement("div", null, "EXPECTED CORRECTION"), _react2.default.createElement("div", null, "\u09AA\u09BE\u09B8\u09AA\u09CB\u09B0\u09CD\u099F\u09C7\u09B0 \u0995\u09CB\u09A8 \u09A4\u09A5\u09CD\u09AF \u09B8\u0982\u09B6\u09CB\u09A7\u09A8 \u0995\u09B0\u09A4\u09C7 \u099A\u09BE\u0987\u09B2\u09C7"), _react2.default.createElement("div", null, "Leave empty if no changes required")), _react2.default.createElement("div", {
	        style: {
	          marginTop: "10px"
	        }
	      }, _this.getRegFormField("infoExist1", "বর্তমানে প্রদর্শিত তথ্য", "1. EXISTING INFORMATION"), _react2.default.createElement("div", { style: { margin: "-5px" } }), _this.getRegFormField("expectedChange1", "পরিবর্তন/সংশোধোন", "1. EXPECTED CHANGE")), _react2.default.createElement("div", {
	        style: {
	          marginTop: "10px"
	        }
	      }, _this.getRegFormField("infoExist2", "বর্তমানে প্রদর্শিত তথ্য", "2. EXISTING INFORMATION"), _react2.default.createElement("div", { style: { margin: "-5px" } }), _this.getRegFormField("expectedChange2", "পরিবর্তন/সংশোধোন", "2. EXPECTED CHANGE")), _react2.default.createElement("div", {
	        style: {
	          marginTop: "10px"
	        }
	      }, _this.getRegFormField("infoExist3", "বর্তমানে প্রদর্শিত তথ্য", "3. EXISTING INFORMATION"), _react2.default.createElement("div", { style: { margin: "-5px" } }), _this.getRegFormField("expectedChange3", "পরিবর্তন/সংশোধোন", "3. EXPECTED CHANGE")), _react2.default.createElement("div", {
	        style: {
	          marginTop: "10px"
	        }
	      }, _this.getRegFormField("infoExist4", "বর্তমানে প্রদর্শিত তথ্য", "4. EXISTING INFORMATION"), _react2.default.createElement("div", { style: { margin: "-5px" } }), _this.getRegFormField("expectedChange4", "পরিবর্তন/সংশোধোন", "4. EXPECTED CHANGE")))));
	    }, _this.getFormInputStageGenPhotos = function () {
	      return _react2.default.createElement("div", null, _this.getNextBack("inputCorrection", "inputPayment"), _react2.default.createElement("div", { style: { margin: "0px", textAlign: "center" } }, _react2.default.createElement(_SignPad2.default, {
	        title: "SIGN PAD",
	        sigB64: _this.state.sigB64,
	        fieldName: "sigB64",
	        isPayload: true,
	        stateChangeHandler: _this.stateChangeHandler,
	        disabled: false
	      }), _react2.default.createElement(_PhotoUploadPass2.default, {
	        title1: "PASSPORT PHOTO",
	        title2: "লোড পাসপোর্ট ফটো",
	        images: _this.state.passportImages,
	        fieldName: "passportImages",
	        isPayload: false,
	        stateChangeHandler: _this.stateChangeHandler,
	        disabled: false
	      }), _react2.default.createElement(_PhotoUploadPass2.default, {
	        title1: "WORK PERMIT PHOTO (FRONT)",
	        title2: "লোড পারমিটের সামনের ফটো",
	        images: _this.state.wpFront,
	        fieldName: "wpFront",
	        isPayload: false,
	        stateChangeHandler: _this.stateChangeHandler,
	        disabled: false
	      }), _react2.default.createElement(_PhotoUploadPass2.default, {
	        title1: "WORK PERMIT PHOTO (BACK)",
	        title2: "লোড পারমিটের পেছনের ফটো",
	        images: _this.state.wpBack,
	        fieldName: "wpBack",
	        isPayload: false,
	        stateChangeHandler: _this.stateChangeHandler,
	        disabled: false
	      })), _react2.default.createElement("input", {
	        type: "file",
	        accept: "image/*",
	        id: "uploader",
	        onChange: function onChange(evt) {
	          console.log("clicked");
	          //console.log("triggering main function");
	          event.preventDefault();
	          //console.log(evt.target.result);
	          if (evt.target.files[0]) {
	            _this.idScanTo64(evt.target.files);
	          } else {
	            console.log("gotcha");
	          }
	        },
	        style: {
	          visibility: "hidden",
	          height: "0px"
	        }
	      }));
	    }, _this.getFormInputStagePayment = function () {
	      return _react2.default.createElement("div", null, _this.getNextBack("inputPhotos", "review"), _this.getGenManualForm(), _react2.default.createElement("div", {
	        style: {
	          margin: "5px",
	          border: "2px solid gainsboro"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          backgroundColor: "orange",
	          padding: "5px",
	          fontWeight: "bold",
	          margin: "5px"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          fontWeight: "bold",
	          fontSize: "large"
	        }
	      }, "OPTION B: Upload the payment record & direct submit from the App", _react2.default.createElement("br", null), "\u0985\u09AA\u09B6\u09A8 B: \u0985\u09A8\u09B2\u09BE\u0987\u09A8\u09C7 \u099F\u09BE\u0995\u09BE \u09AA\u09BE\u09A0\u09BF\u09DF\u09C7 \u09B0\u09BF\u099B\u09BF\u099F \u0986\u09AA\u09B2\u09CB\u09A1 \u0995\u09B0\u09C1\u09A8 \u098F\u09AC\u0982 \u09AB\u09B0\u09AE \u0985\u09A8\u09B2\u09BE\u0987\u09A8\u09C7 \u099C\u09AE\u09BE \u09A6\u09BF\u09A8"), _react2.default.createElement("div", {
	        style: {
	          fontSize: "medium"
	        }
	      }, _react2.default.createElement("ul", null, _react2.default.createElement("li", null, "Please use internet banking to pay S$155 fee as per the details provided below", " ", _react2.default.createElement("span", {
	        style: {
	          color: "#a70101",
	          fontWeight: "bolder",
	          fontSize: "14px"
	        }
	      }, "(You must enter the text highlihted in red box below under the field \"Comments for Recipient\" on the internet banking screen. Please see the example screen shot at the bottom for details.):"), _react2.default.createElement("br", null), " Take screenshot of the payment record and upload using the upload button below. Tap Next button once upload is completed."), _react2.default.createElement("li", null, _react2.default.createElement("p", null, "\u09A6\u09DF\u09BE\u0995\u09B0\u09C7 \u0987\u09A8\u09CD\u099F\u09BE\u09B0\u09A8\u09C7\u099F \u09AC\u09CD\u09AF\u09BE\u0999\u09CD\u0995\u09BF\u0982 \u098F\u09B0 \u09AE\u09BE\u09A7\u09CD\u09AF\u09AE\u09C7 S$155 \u099F\u09CD\u09B0\u09BE\u09A8\u09CD\u09B8\u09AB\u09BE\u09B0 \u0995\u09B0\u09C1\u09A8.", " ", _react2.default.createElement("span", {
	        style: {
	          color: "#a70101",
	          fontWeight: "bolder",
	          fontSize: "14px"
	        }
	      }, "\u09AC\u09CD\u09AF\u09BE\u0982\u0995 \u099F\u09CD\u09B0\u09BE\u09A8\u09CD\u09B8\u09AB\u09BE\u09B0 \u0995\u09B0\u09BE\u09B0 \u09B8\u09AE\u09DF \u09A8\u09BF\u099A\u09C7\u09B0 \u09B2\u09BE\u09B2 \u09AC\u0995\u09CD\u09B8\u09C7\u09B0 \u09B2\u09BF\u0996\u09BE\u099F\u09BE \u099F\u09CD\u09B0\u09BE\u09A8\u09CD\u09B8\u09AB\u09BE\u09B0 \u0995\u09AE\u09C7\u09A8\u09CD\u099F\u09C7 \u09B2\u09BF\u0996\u09C1\u09A8, \u0985\u09A8\u09CD\u09AF\u09A5\u09BE\u09DF \u0986\u09AA\u09A8\u09BE\u09B0 \u09AA\u09C7\u09AE\u09C7\u09A8\u09CD\u099F \u0996\u09C1\u099C\u09C7 \u09AA\u09BE\u0993\u09DF\u09BE \u09AF\u09BE\u09AC\u09C7\u09A8\u09BEI \u09A8\u09BF\u099A\u09C7 \u0989\u09A6\u09BE\u09B9\u09B0\u09A3 \u09B8\u09CD\u0995\u09CD\u09B0\u09BF\u09A8\u09C7 \u09A6\u09C7\u0996\u09C7 \u09A8\u09BF\u09A8."), _react2.default.createElement("br", null), " \u09A6\u09DF\u09BE\u0995\u09B0\u09C7 \u09AA\u09C7\u09AE\u09C7\u09A8\u09CD\u099F\u09C7\u09B0 \u09B8\u09CD\u0995\u09CD\u09B0\u09BF\u09A8\u09B6\u099F \u09A8\u09BF\u09DF\u09C7 \u09A8\u09BF\u099A\u09C7\u09B0 + UPLOAD \u09AC\u09BE\u099F\u09A8\u09C7 \u0986\u09AA\u09B2\u09CB\u09A1 \u0995\u09B0\u09C1\u09A8"))))), _react2.default.createElement("div", { style: { margin: "5px" } }, _react2.default.createElement("table", { className: "table table-bordered" }, _react2.default.createElement("tbody", null, _react2.default.createElement("tr", null, _react2.default.createElement("td", { style: { backgroundColor: "white" } }, "Account Name"), _react2.default.createElement("td", { style: { backgroundColor: "white" } }, "High Commission of Bangladesh")), _react2.default.createElement("tr", null, _react2.default.createElement("td", { style: { backgroundColor: "white" } }, "Account Number"), _react2.default.createElement("td", { style: { backgroundColor: "white" } }, "451-301-564-4")), _react2.default.createElement("tr", null, _react2.default.createElement("td", { style: { backgroundColor: "white" } }, "Bank"), _react2.default.createElement("td", { style: { backgroundColor: "white" } }, "UOB Limited Singapore")), _react2.default.createElement("tr", null, _react2.default.createElement("td", { style: { backgroundColor: "white" } }, "Comments for Recipient / My Initials"), _react2.default.createElement("td", {
	        style: {
	          backgroundColor: "white",
	          border: "2px solid red"
	        }
	      }, _this.state.data.payload.passportNumber + "-" + _this.state.data.payload.textName.substring(0, 10))))), _react2.default.createElement("div", null, _react2.default.createElement("div", { style: { margin: "0px", textAlign: "center" } }, _react2.default.createElement(_PhotoUploadPass2.default, {
	        title1: "PAYMENT RECIEPT PHOTO",
	        title2: "ফিস ট্রান্সফার করে থাকলে তার রসিদ এখানে আপলোড করুন",
	        images: _this.state.payPhoto,
	        fieldName: "payPhoto",
	        isPayload: false,
	        stateChangeHandler: _this.stateChangeHandler,
	        disabled: false,
	        nextStage: "review",
	        setScroll: _this.props.setScroll
	      }))), _react2.default.createElement("p", null, _react2.default.createElement("div", null, "Example payment screen for POSB Bank"), _react2.default.createElement("div", {
	        style: {
	          textAlign: "center"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          margin: "auto"
	        }
	      }, _react2.default.createElement("img", {
	        src: _mrpPmtImage.mrpPmtImage,
	        style: {
	          objectFit: "contain",
	          width: "100%"
	        }
	      })))), _this.getBdgHighCommInfo())));
	    }, _this.getStatementLink = function () {
	      if (_this.state.statementLink !== "" && !_this.state.genertingStatement) {
	        if (_reactDeviceDetect.isMobile) {
	          var _ref5;
	
	          return _react2.default.createElement("div", {
	            style: {
	              marginBottom: "0px",
	              padding: "5px",
	              textAlign: "center"
	            }
	          }, _react2.default.createElement("div", {
	            style: (_ref5 = {
	              padding: "1px",
	              textAlign: "center",
	              border: "1px solid gainsboro",
	              borderRadius: _reactDeviceDetect.isMobile ? "5px" : "0px",
	              backgroundColor: "rgb(30, 101, 144)"
	            }, _defineProperty(_ref5, "padding", "6px"), _defineProperty(_ref5, "fontWeight", "bold"), _defineProperty(_ref5, "color", "white"), _defineProperty(_ref5, "fontSize", "12px"), _ref5),
	            onClick: function onClick() {
	              _this.openPdfInAppBrowser();
	            }
	          }, _react2.default.createElement("div", null, _react2.default.createElement("i", { className: "fa fa-print" }), " Open Passport Renewal Form"), _react2.default.createElement("div", null, "\u09AB\u09B0\u09AE \u0993\u09AA\u09C7\u09A8 \u0995\u09B0\u09C1\u09A8")));
	        } else {
	          return _react2.default.createElement("div", {
	            style: {
	              textAlign: "center",
	              margin: "5px"
	            }
	          }, _react2.default.createElement("a", { href: _this.state.statementLink, target: "_" }, "Open Passport Renewal Form"));
	        }
	      } else {
	        _react2.default.createElement("div", {
	          style: {
	            textAlign: "center"
	          }
	        });
	      }
	    }, _this.generateForm = function () {
	      //set loader to yes
	
	      //get state updated with calc fields
	      console.log("generating form");
	      Promise.all([_this.getPOData(), _this.getTemplateId(), _this.stateChangeHandler(true, "generatingManualPDF", false), _this.stateChangeHandler("", "statementLink", false)]).then(function (res) {
	        console.log("test test: " + res[1]);
	
	        _this.props.onGetPoStatement(res[0], res[1]).then(function (pdfResp) {
	          console.log("ok " + pdfResp);
	          //this.saveHandler();
	          // let suppNotifyText =
	          //   "New passport form generated by " +
	          //   this.state.data.payload.textName +
	          //   " (" +
	          //   this.state.data.payload.phoneNumber +
	          //   ").";
	          // this.props.onNotifyUsers(suppNotifyText, ["94562455"]);
	          if (pdfResp && pdfResp !== undefined) {
	            if (pdfResp.response && pdfResp.response !== "") {
	              _this.stateChangeHandler(pdfResp.response, "statementLink", false);
	            }
	          }
	          _this.stateChangeHandler(false, "generatingManualPDF", false);
	        }).catch(function (err) {
	          console.log("Salaaa error: " + err);
	          _this.stateChangeHandler(false, "generatingManualPDF", false);
	        });
	      });
	      //request new statement
	      //once req completed show the stop loader and show statement
	    }, _this.getGenManualForm = function () {
	      var _ref6;
	
	      return _react2.default.createElement("p", {
	        style: {
	          border: "2px solid gainsboro",
	          margin: "5px",
	          padding: "5px",
	          marginBottom: "10px"
	        }
	      }, _react2.default.createElement("p", null, _react2.default.createElement("div", {
	        style: {
	          backgroundColor: "orange",
	          padding: "2px",
	          fontWeight: "bold"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          fontWeight: "bold",
	          fontSize: "large"
	        }
	      }, "OPTION A: Download, Print & Apply in person ", _react2.default.createElement("br", null), "\u0985\u09AA\u09B6\u09A8 A: \u09AB\u09B0\u09AE \u09A1\u09BE\u0989\u09A8\u09B2\u09CB\u09A1 \u0995\u09B0\u09C7 \u09AA\u09CD\u09B0\u09BF\u09A8\u09CD\u099F \u0995\u09B0\u09C7 \u09B9\u09BE\u0987\u0995\u09AE\u09BF\u09B6\u09A8 \u0985\u09AB\u09BF\u09B8\u09C7 \u099C\u09AE\u09BE \u09A6\u09C7\u09DF\u09BE"), _react2.default.createElement("div", { style: { fontSize: "medium" } }, _react2.default.createElement("ul", null, _react2.default.createElement("li", null, "Tap the Generate Form button below to download the completed form \u09A8\u09BF\u099A\u09C7\u09B0 \u099C\u09C7\u09A8\u09BE\u09B0\u09C7\u099F \u09AC\u09BE\u099F\u09A8 \u099A\u09C7\u09AA\u09C7 \u09A4\u09C8\u09B0\u09C0 \u0995\u09B0\u09BE \u09AB\u09B0\u09AE \u09A1\u09BE\u0989\u09A8\u09B2\u09CB\u0995\u09A1\u09BF \u0995\u09B0\u09C1\u09A8."))))), _react2.default.createElement("div", {
	        style: {
	          background: "white",
	          margin: "5px",
	          borderRadius: "5px",
	          padding: "10px"
	        }
	      }, _react2.default.createElement("div", null, _react2.default.createElement("div", null, !_this.state.generatingManualPDF && !_this.state.generatingStatement && _this.getStatementLink()), (!_this.state.statementLink || _this.state.statementLink === "") && _react2.default.createElement("div", {
	        style: (_ref6 = {
	          width: "50%",
	          padding: "1px",
	          textAlign: "center",
	          border: "1px solid gainsboro",
	          borderRadius: _reactDeviceDetect.isMobile ? "5px" : "0px",
	          backgroundColor: "rgb(30, 101, 144)",
	          margin: "auto"
	        }, _defineProperty(_ref6, "padding", "6px"), _defineProperty(_ref6, "fontWeight", "bold"), _defineProperty(_ref6, "color", "white"), _defineProperty(_ref6, "fontSize", "12px"), _ref6),
	        onClick: function onClick() {
	          _this.generateForm();
	        }
	      }, _react2.default.createElement("div", null, _react2.default.createElement("i", { className: "fa fa-print" }), " GENERATE FORM"), _react2.default.createElement("div", null, "\u09AB\u09B0\u09AE \u09A4\u09C8\u09B0\u09BF \u0995\u09B0\u09C1\u09A8")))));
	    }, _this.getFormReviewStage = function () {
	      var _ref7, _ref8;
	
	      return _react2.default.createElement("div", {
	        style: {
	          padding: "5px",
	          margin: "5px",
	          backgroundColor: "white"
	        }
	      }, !_this.state.generatingStatement && _react2.default.createElement("p", {
	        style: {
	          backgroundColor: "orange",
	          padding: "5px",
	          fontWeight: "bold"
	        }
	      }, "Please carefully review the following information and press the confirm button (\u09A6\u09DF\u09BE\u0995\u09B0\u09C7 \u09A8\u09BF\u099A\u09C7\u09B0 \u09A4\u09A5\u09CD\u09AF\u0997\u09C1\u09B2\u09CB \u09AD\u09BE\u09B2\u0995\u09B0\u09C7 \u09A6\u09C7\u0996\u09C7 \u09A8\u09BF\u09A8, \u09B8\u09AC\u0995\u09BF\u099B\u09C1 \u09A0\u09BF\u0995 \u09A5\u09BE\u0995\u09B2\u09C7 \u09A8\u09BF\u099A\u09C7\u09B0 \"\u0995\u09A8\u09AB\u09BE\u09B0\u09CD\u09AE\" \u09AC\u09BE\u099F\u09A8\u09C7 \u099A\u09BE\u09AA\u09C1\u09A8\u0964):"), _react2.default.createElement("p", null, _react2.default.createElement("span", null, _react2.default.createElement("div", {
	        style: {
	          textAlign: "center",
	          width: "100%"
	        }
	      }, _react2.default.createElement("div", {
	        style: (_ref7 = {
	          width: "50%",
	          padding: "1px",
	          textAlign: "center",
	          border: "1px solid gainsboro",
	          borderRadius: _reactDeviceDetect.isMobile ? "5px" : "0px",
	          backgroundColor: "green",
	          margin: "auto"
	        }, _defineProperty(_ref7, "padding", "6px"), _defineProperty(_ref7, "fontWeight", "bold"), _defineProperty(_ref7, "color", "white"), _defineProperty(_ref7, "fontSize", "12px"), _ref7),
	        onClick: function onClick() {
	          if (!_this.state.generatingStatement) {
	            _this.genPOStatement();
	          }
	        }
	      }, _react2.default.createElement("div", null, _react2.default.createElement("i", { className: "fa fa-check" }), " CONFIRM"), _react2.default.createElement("div", null, "\u0995\u09A8\u09AB\u09BE\u09B0\u09CD\u09AE")), _this.state.generatingStatement && _this.getStatementLoader())), !_this.state.generatingStatement && _react2.default.createElement("span", null, _react2.default.createElement("div", {
	        style: {
	          textAlign: "center",
	          width: "100%"
	        }
	      }, _react2.default.createElement("div", {
	        style: (_ref8 = {
	          width: "50%",
	          padding: "1px",
	          textAlign: "center",
	          border: "1px solid gainsboro",
	          borderRadius: _reactDeviceDetect.isMobile ? "5px" : "0px",
	          backgroundColor: "red",
	          margin: "auto"
	        }, _defineProperty(_ref8, "padding", "6px"), _defineProperty(_ref8, "fontWeight", "bold"), _defineProperty(_ref8, "color", "white"), _defineProperty(_ref8, "fontSize", "12px"), _ref8),
	        onClick: function onClick() {
	          _this.stateChangeHandler("inputGeneral", "stage", false);
	        }
	      }, _react2.default.createElement("div", null, _react2.default.createElement("i", { className: "fa fa-arrow-circle-left" }), " CHANGE"), _react2.default.createElement("div", null, "\u09AA\u09B0\u09BF\u09AC\u09B0\u09CD\u09A4\u09A8 \u0995\u09B0\u09C1\u09A8"))))), !_this.state.generatingStatement && _react2.default.createElement("div", null, _react2.default.createElement("p", null, _react2.default.createElement("b", null, "Particulars")), _react2.default.createElement("table", { className: "table table-bordered table-striped" }, _react2.default.createElement("tbody", null, _this.getRow("Applicant Name (English)", _this.state.data.payload.textName), _this.getRow("Applicant Name (Bangla)", _this.state.data.payload.textNameBangla), _this.getRow("Passport No.", _this.state.data.payload.passportNumber), _this.getRow("Place of Issue", _this.state.data.payload.placeOfIssue), _this.getRow("Date of Expiry", _this.state.data.payload.dateOfExpiry), _this.getRow("Date of Issue", _this.state.data.payload.dateOfIssue), _this.getRow("Date", (0, _moment2.default)().format("DD MMM YYYY").toString()), _this.getRow("Mobile No", _this.state.data.payload.phoneNumber), _this.getRow("Email Address", _this.state.data.payload.emailId))), _react2.default.createElement("p", null), _react2.default.createElement("p", null, _react2.default.createElement("b", null, "Expected Corrections (if any)")), _react2.default.createElement("table", { className: "table table-bordered table-striped" }, _react2.default.createElement("thead", null, _react2.default.createElement("tr", null, _react2.default.createElement("th", null, "Current Value"), _react2.default.createElement("th", null, "New Value"))), _react2.default.createElement("tbody", null, _this.getRow(_this.state.data.payload.infoExist1, _this.state.data.payload.expectedChange1), _this.getRow(_this.state.data.payload.infoExist2, _this.state.data.payload.expectedChange2), _this.getRow(_this.state.data.payload.infoExist3, _this.state.data.payload.expectedChange3), _this.getRow(_this.state.data.payload.infoExist4, _this.state.data.payload.expectedChange4)))), _react2.default.createElement("p", null, _react2.default.createElement("b", null, "Note:")), _react2.default.createElement("p", null), _react2.default.createElement("ul", null, _react2.default.createElement("li", null, "BCS App only generates the application form and submits it online via email to the Bangladesh High Commission, to facilitate passport holders and make it very easy and simple to submit the passport renewal applications."), _react2.default.createElement("li", null, "For any further enquires on the renewal process / acceptance of application, users are responsible to contact the Bangladesh High Commission directly (Phone Number: 6255 0075 or email: mrp.bdhc.sg@gmail.com)."), _react2.default.createElement("li", null, "Copy of the application email is also sent to the user's email address. Please make sure you have entered a valid email address."), _react2.default.createElement("li", null, "Information included in the application form is as per the data provided by users, and it is the responsibility of users to ensure correct input of all information.")));
	    }, _this.getFormSubmitStage = function () {
	      var _ref9;
	
	      return _react2.default.createElement("div", null, _react2.default.createElement("div", {
	        style: {
	          fontSize: "12px",
	          fontWeight: "bold",
	          textAlign: "center",
	          marginTop: "10px"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          margin: "auto",
	          border: "5px solid green",
	          width: "100px",
	          height: "100px",
	          borderRadius: "100px",
	          lineHeight: "90px",
	          verticalAlign: "middle"
	        }
	      }, _react2.default.createElement("icon", {
	        className: "fa fa-check fa-3x",
	        style: {
	          color: "green",
	          verticalAlign: "middle"
	        }
	      })), _react2.default.createElement("div", { style: { marginTop: "10px" } }, _this.getMyPassportApplications(), _react2.default.createElement("div", {
	        style: {
	          marginTop: "10px"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          textAlign: "center",
	          width: "100%"
	        }
	      }, _react2.default.createElement("div", {
	        style: (_ref9 = {
	          width: "75%",
	          padding: "1px",
	          textAlign: "center",
	          border: "1px solid gainsboro",
	          borderRadius: _reactDeviceDetect.isMobile ? "5px" : "0px",
	          backgroundColor: "rgb(30, 101, 144)",
	          margin: "auto"
	        }, _defineProperty(_ref9, "padding", "6px"), _defineProperty(_ref9, "fontWeight", "bold"), _defineProperty(_ref9, "color", "white"), _defineProperty(_ref9, "fontSize", "12px"), _ref9),
	        onClick: function onClick() {
	          Promise.all([_this.stateChangeHandler("home", "stage", false)]).then(function (resp) {
	            _this.props.cancelHandler();
	            _this.props.setScroll(true);
	          });
	        }
	      }, _react2.default.createElement("div", null, _react2.default.createElement("i", { className: "fa fa-home" }), " RETURN TO BCS HOME"))))), _this.getBdgHighCommInfo(), _react2.default.createElement("div", {
	        style: {
	          marginTop: "12px",
	          marginBottom: "12px",
	          textAlign: "left",
	          fontSize: "14px"
	        }
	      }, _react2.default.createElement("ul", null, _react2.default.createElement("li", null, "Your application has been sent to the Bangladesh High Commission. BCS only submits online application to High Commission. It is responsibility of the applicant to do further follow-up with High Comm to ensure application is accepted for processing. Please note you might be required to visit the High Commission in-person in order for your appliccation to be accepted for processing."), _react2.default.createElement("li", null, "Please check your mail inbox for email id", " ", _this.state.data.payload.emailId, " to see copy of the application."), _react2.default.createElement("li", null, "Please also check spam or junk folder to view the copy of application email.")))));
	    }, _this.getPassAppRows = function (applications) {
	      return applications.map(function (passApp) {
	        return _react2.default.createElement("tr", null, _react2.default.createElement("td", null, passApp.passportNo), _react2.default.createElement("td", null, passApp.applicationDate), _react2.default.createElement("td", null, passApp.status));
	      });
	    }, _this.getMyPassportApplications = function () {
	      if (_this.props.db["myPassApps"] && _this.props.db["myPassApps"].length > 0) {
	        return _react2.default.createElement("div", {
	          style: {
	            margin: "auto",
	            fontSize: "11px"
	          }
	        }, _react2.default.createElement("div", {
	          style: {
	            margin: "5px",
	            padding: "5px"
	          }
	        }, "Your current passport applications:", _react2.default.createElement("div", {
	          style: {
	            border: "1px solid black",
	            marginTop: "5px"
	          }
	        }, _react2.default.createElement("table", { className: "table table-striped table-bordered" }, _react2.default.createElement("thead", null, _react2.default.createElement("tr", null, _react2.default.createElement("th", null, "Psprt No"), _react2.default.createElement("th", null, "Apply Date"), _react2.default.createElement("th", null, "Status"))), _react2.default.createElement("tbody", null, _this.getPassAppRows(_this.props.db["myPassApps"]))))));
	      } else {
	        return _react2.default.createElement("div", {
	          style: {
	            margin: "auto"
	          }
	        }, _react2.default.createElement("div", {
	          style: {
	            margin: "5px",
	            padding: "5px"
	          }
	        }, "Your current passport applications:", _react2.default.createElement("div", {
	          style: {
	            border: "1px solid black",
	            marginTop: "5px"
	          }
	        }, _react2.default.createElement("table", { className: "table table-striped table-bordered" }, _react2.default.createElement("thead", null, _react2.default.createElement("tr", null, _react2.default.createElement("th", null, "Psprt No"), _react2.default.createElement("th", null, "Apply Date"), _react2.default.createElement("th", null, "Status"))), _react2.default.createElement("tbody", null, _react2.default.createElement("tr", null, _react2.default.createElement("td", { colSpan: 3 }, "Currently you don't have any previous applications.")))))));
	      }
	    }, _this.getPportHomePage = function () {
	      var _ref10;
	
	      return _react2.default.createElement("div", null, _react2.default.createElement("div", null, _react2.default.createElement("div", null, _react2.default.createElement("div", {
	        style: {
	          marginTop: "10px"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          textAlign: "center",
	          width: "100%"
	        }
	      }, _react2.default.createElement("div", {
	        style: (_ref10 = {
	          width: "50%",
	          padding: "1px",
	          textAlign: "center",
	          border: "1px solid gainsboro",
	          borderRadius: _reactDeviceDetect.isMobile ? "5px" : "0px",
	          backgroundColor: "rgb(30, 101, 144)",
	          margin: "auto"
	        }, _defineProperty(_ref10, "padding", "6px"), _defineProperty(_ref10, "fontWeight", "bold"), _defineProperty(_ref10, "color", "white"), _defineProperty(_ref10, "fontSize", "12px"), _defineProperty(_ref10, "minWidth", "300px"), _defineProperty(_ref10, "maxWidth", "300px"), _ref10),
	        onClick: function onClick() {
	          _this.stateChangeHandler("applyHome", "stage", false);
	        }
	      }, _react2.default.createElement("div", null, _react2.default.createElement("i", { className: "fa fa-book" }), " NEW APPLICATION FORM"), _react2.default.createElement("div", null, "\u09A6\u09B0\u0996\u09BE\u09B8\u09CD\u09A4\u09C7\u09B0 \u09AB\u09B0\u09AE"))))), _react2.default.createElement("div", null), _react2.default.createElement("div", null, _this.getMyPassportApplications()), _react2.default.createElement("div", null, _this.getBdgHighCommInfo())));
	    }, _this.getBdgHighCommInfo = function () {
	      return _react2.default.createElement("div", {
	        style: {
	          margin: "10px"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          fontWeight: "bold"
	        }
	      }, "BDG HIGH COMM CONTACT:", " "), _react2.default.createElement("div", null, _react2.default.createElement("table", { className: "table table-striped table-bordered" }, _react2.default.createElement("tbody", null, _react2.default.createElement("tr", null, _react2.default.createElement("td", null, "Phone # "), _react2.default.createElement("td", null, "+65-66610295 / 66610290 / 66610280 ")), _react2.default.createElement("tr", null, _react2.default.createElement("td", null, "Address"), _react2.default.createElement("td", null, "Bangladesh High Commission, Singapore ", _react2.default.createElement("br", null), "19 Keppel Road, Jit Poh Building ", _react2.default.createElement("br", null), "Singapore 089058 # 04-00 ", _react2.default.createElement("br", null), "(Passport & Visa, Consular and Labour Wing)"))))), ":");
	    }, _this.getNextBack = function (stageBack, stageNext) {
	      var _ref11, _ref12;
	
	      return _react2.default.createElement("div", null, _react2.default.createElement("table", {
	        className: "table",
	        style: {
	          marginBottom: "0px"
	        }
	      }, _react2.default.createElement("tbody", null, _react2.default.createElement("tr", null, _react2.default.createElement("td", { style: { border: "0px" } }, _react2.default.createElement("div", {
	        style: {
	          textAlign: "center",
	          width: "100%"
	        }
	      }, _react2.default.createElement("div", {
	        style: (_ref11 = {
	          width: "50%",
	          padding: "1px",
	          textAlign: "center",
	          border: "1px solid gainsboro",
	          borderRadius: _reactDeviceDetect.isMobile ? "5px" : "0px",
	          backgroundColor: "rgb(30, 101, 144)",
	          margin: "auto"
	        }, _defineProperty(_ref11, "padding", "6px"), _defineProperty(_ref11, "fontWeight", "bold"), _defineProperty(_ref11, "color", "white"), _defineProperty(_ref11, "fontSize", "12px"), _defineProperty(_ref11, "minWidth", "140px"), _ref11),
	        onClick: function onClick() {
	          _this.stateChangeHandler(stageBack, "stage", false);
	        }
	      }, _react2.default.createElement("div", null, _react2.default.createElement("i", { className: "fa fa-arrow-left" }), " BACK")))), _react2.default.createElement("td", { style: { border: "0px" } }, _react2.default.createElement("div", {
	        style: {
	          textAlign: "center",
	          width: "100%"
	        }
	      }, _react2.default.createElement("div", {
	        style: (_ref12 = {
	          width: "50%",
	          padding: "1px",
	          textAlign: "center",
	          border: "1px solid gainsboro",
	          borderRadius: _reactDeviceDetect.isMobile ? "5px" : "0px",
	          backgroundColor: "rgb(30, 101, 144)",
	          margin: "auto"
	        }, _defineProperty(_ref12, "padding", "6px"), _defineProperty(_ref12, "fontWeight", "bold"), _defineProperty(_ref12, "color", "white"), _defineProperty(_ref12, "fontSize", "12px"), _defineProperty(_ref12, "minWidth", "140px"), _ref12),
	        onClick: function onClick() {
	          if (stageNext === "inputCorrection") {
	            if (_this.validateGeneralInputs()) {
	              _this.stateChangeHandler(stageNext, "stage", false);
	            } else {
	              alert("Please complete all fields");
	            }
	          } else if (stageNext === "inputGeneral") {
	            if (!_this.state.sgPresence || _this.state.sgPresence === "" || !_this.state.sgDocs || _this.state.sgDocs === "") {
	              alert("Before proceeding next, please answer the questions on screen Yes or No. \n" + ' নেক্সট চাপার পূর্বে স্ক্রিনের দুইটা প্রশ্নের "হা" অথবা "না" সিলেক্ট করুন');
	            } else if (_this.state.sgPresence === "NO" || _this.state.sgDocs === "NO") {
	              alert("To apply for passport renewal/update you must hold \n Passport \n Valid Singapore Visa \n and be present in Singapore.");
	            } else {
	              _this.stateChangeHandler(stageNext, "stage", false);
	            }
	          } else if (stageNext === "inputPayment") {
	            if (_this.validateGenPhotos()) {
	              _this.stateChangeHandler("", "statementLink", false);
	              _this.stateChangeHandler(stageNext, "stage", false);
	            } else {
	              alert("Please sign and upload all the photos \n দয়াকরে সাইন এবং সব ফটো আপলোড করুন");
	            }
	          } else if (stageNext === "review") {
	            if (_this.validatePayPhoto()) {
	              _this.stateChangeHandler(stageNext, "stage", false);
	            } else {
	              alert("Please upload photo of payment reciept");
	            }
	          } else {
	            _this.stateChangeHandler(stageNext, "stage", false);
	          }
	        }
	      }, _react2.default.createElement("div", null, "NEXT ", _react2.default.createElement("i", { className: "fa fa-arrow-right" })))))))));
	    }, _this.getChoiceButton = function (label, stateVal, stateFldId, iconClass, colorIt) {
	      var _ref13;
	
	      return _react2.default.createElement("div", {
	        style: (_ref13 = {
	          width: "50%",
	          padding: "1px",
	          textAlign: "center",
	          border: "1px solid gainsboro",
	          borderRadius: _reactDeviceDetect.isMobile ? "5px" : "0px",
	          backgroundColor: colorIt ? "rgb(30, 101, 144)" : "white",
	          margin: "auto"
	        }, _defineProperty(_ref13, "padding", "6px"), _defineProperty(_ref13, "fontWeight", "bold"), _defineProperty(_ref13, "color", colorIt ? "white" : "black"), _defineProperty(_ref13, "fontSize", "12px"), _defineProperty(_ref13, "minWidth", "80px"), _defineProperty(_ref13, "maxWidth", "80px"), _ref13),
	        onClick: function onClick() {
	          _this.stateChangeHandler(stateVal, stateFldId, false);
	        }
	      }, _react2.default.createElement("div", null, _react2.default.createElement("i", { className: iconClass }), " ", label));
	    }, _this.getApplyHomePage = function () {
	      return _react2.default.createElement("div", null, _this.getNextBack("home", "inputGeneral"), _react2.default.createElement("div", {
	        style: {
	          margin: "10px",
	          marginTop: "-10px"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          backgroundColor: "orange",
	          padding: "5px",
	          fontWeight: "bold",
	          marginTop: "5px",
	          marginBottom: "5px"
	        }
	      }, "Please review/answer following terms and tap on Next button:"), _react2.default.createElement("table", { className: "table table-bordered" }, _react2.default.createElement("tbody", null, _react2.default.createElement("tr", null, _react2.default.createElement("td", { style: { backgroundColor: "white" } }, "Completing passport application can take upto 5 minutes and requires a valid email address and following documents:", _react2.default.createElement("ul", null, _react2.default.createElement("li", null, "Passport"), _react2.default.createElement("li", null, "Valid Signapore Visa or Work Permit")), _react2.default.createElement("p", null, "\u09AA\u09BE\u09B8\u09AA\u09CB\u09B0\u09CD\u099F\u09C7\u09B0 \u0986\u09AC\u09C7\u09A6\u09A8 \u09B6\u09C7\u09B7 \u0995\u09B0\u09A4\u09C7 \u09AA\u09BE\u0981\u099A \u09AE\u09BF\u09A8\u09BF\u099F\u09C7\u09B0 \u09AE\u09A4\u09CB \u09B8\u09AE\u09DF, \u09A8\u09BF\u09A8\u09CD\u09AE\u09B2\u09BF\u0996\u09BF\u09A4 \u09A1\u0995\u09C1\u09AE\u09C7\u09A8\u09CD\u099F\u09B8 \u098F\u09AC\u0982 \u0986\u09AA\u09A8\u09BE\u09B0 \u09AD\u09C7\u09B2\u09BF\u09A1 \u0987\u09AE\u09C7\u0987\u09B2 \u098F\u09A1\u09CD\u09B0\u09C7\u09B8 \u09B2\u09BE\u0997\u09AC\u09C7: ", _react2.default.createElement("br", null), "1) \u09AC\u09B0\u09CD\u09A4\u09AE\u09BE\u09A8 \u09AA\u09BE\u09B8\u09AA\u09CB\u09B0\u09CD\u099F\u09C7\u09B0 (2 & 3 \u09AA\u09C3\u09B7\u09CD\u09A0\u09BE\u09B0) \u098F\u0995\u099F\u09BF \u0995\u09CD\u09B2\u09BF\u09DF\u09BE\u09B0 \u09AB\u099F\u09CB", " ", _react2.default.createElement("br", null), " 2) \u09AD\u09C7\u09B2\u09BF\u09A1 \u0993\u09DF\u09BE\u09B0\u09CD\u0995 \u09AA\u09BE\u09B0\u09CD\u09AE\u09BF\u099F / \u09B8\u09CD\u09AA\u09C7\u09B6\u09BE\u09B2 \u09AA\u09BE\u09B8 / \u098F\u09AE\u09AA\u09CD\u09B2\u09DF\u09AE\u09C7\u09A8\u09CD\u099F \u09AA\u09BE\u09B8 / \u0986\u0987 \u09B8\u09BF-\u098F\u09B0 (\u0989\u09AD\u09DF \u09AA\u09C3\u09B7\u09CD\u09A0\u09BE\u09B0) \u09AB\u099F\u09CB"), _react2.default.createElement("p", null, "Do you have these documents?"), _react2.default.createElement("p", null, "\u0986\u09AA\u09A8\u09BE\u09B0 \u0995\u09BE\u099B\u09C7 \u0995\u09BF \u0989\u09AA\u09B0\u09C7\u09B0 \u09A1\u0995\u09C1\u09AE\u09C7\u09A8\u09CD\u099F\u09B8 \u0986\u099B\u09C7?"), _react2.default.createElement("p", { style: { display: "flex", float: "right" } }, _react2.default.createElement("span", null, _this.getChoiceButton("NO", "NO", "sgDocs", "fa fa-cross", _this.state.sgDocs === "NO")), _react2.default.createElement("span", null, _this.getChoiceButton("YES", "YES", "sgDocs", "fa fa-tick", _this.state.sgDocs === "YES"))))), _react2.default.createElement("tr", null, _react2.default.createElement("td", { style: { backgroundColor: "white" } }, _react2.default.createElement("p", null, "Are you present in Singapore?"), _react2.default.createElement("p", null, "\u0986\u09AA\u09A8\u09BF \u0995\u09BF \u09AC\u09B0\u09CD\u09A4\u09AE\u09BE\u09A8\u09C7 \u09B8\u09BF\u0999\u09CD\u0997\u09BE\u09AA\u09C1\u09B0\u09C7 \u0986\u099B\u09C7\u09A8?"), _react2.default.createElement("p", { style: { display: "flex", float: "right" } }, _react2.default.createElement("span", null, _this.getChoiceButton("NO", "NO", "sgPresence", "fa fa-cross", _this.state.sgPresence === "NO")), _react2.default.createElement("span", null, _this.getChoiceButton("YES", "YES", "sgPresence", "fa fa-tick", _this.state.sgPresence === "YES"))))), _react2.default.createElement("tr", null, _react2.default.createElement("td", { style: { backgroundColor: "white" } }, "The information you provide in application must be correct and up to date; incorrect or false information can lead to delays.")), _react2.default.createElement("tr", null, _react2.default.createElement("td", { style: { backgroundColor: "white" } }, "Based on the current processing times, the passport renewal & updates can take upto 7 to 8 weeks.")), _react2.default.createElement("tr", null, _react2.default.createElement("td", { style: { backgroundColor: "white" } }, "For any other enquiries or information, please call the High Commission of Bangladesh at +65-66610295 / 66610290 / 66610280 or visit in person at following address:", " ", _react2.default.createElement("p", null, "Bangladesh High Commission, Singapore ", _react2.default.createElement("br", null), "19 Keppel Road, Jit Poh Building ", _react2.default.createElement("br", null), "Singapore 089058 # 04-00 ", _react2.default.createElement("br", null), "(Passport & Visa, Consular and Labour Wing)"))), _react2.default.createElement("tr", null, _react2.default.createElement("td", { style: { backgroundColor: "white" } }, "For any BCS App related information or questions please contact at +65 9456 2455."))))));
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(BgdPassportServiceExt, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (window.location.hostname === "localhost") {
	        this.setState({
	          data: {
	            path: "myPassApplication",
	            payload: {
	              textName: "name english",
	              textNameBangla: "name bangla",
	              emailId: "ahmed_fayyaz@outlook.com",
	              phoneNumber: this.props.cellPhone,
	              passportNumber: "p123456",
	              dateOfIssue: "10 JAN 1998",
	              dateOfExpiry: "10 DEC 2003",
	              placeOfIssue: "DHKA",
	              dateOfBirth: "10 FEB 1990",
	              infoExist1: "A",
	              expectedChange1: "AA",
	              infoExist2: "B",
	              expectedChange2: "BB",
	              infoExist3: "C",
	              expectedChange3: "CC",
	              infoExist4: "D",
	              expectedChange4: "DD",
	              wpBack: [],
	              wpFront: [],
	              passportImages: []
	            }
	          },
	          reloadDone: false,
	          generatingStatement: false,
	          statementLink: ""
	          // reloadDone: true,
	          // generatingStatement: false,
	          // statementLink:
	          //   "https://us1.pdfgeneratorapi.com/share/6667/7c075ba68344cee7a11cf6a33f2f811b",
	          // b64Text: "",
	          // stage: "inputPayment",
	          // sgPresence: "YES",
	          // sgDocs: "YES",
	          // sigB64:
	          //   "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAABLwAAAHCCAYAAADlz9AsAAAgAElEQVR4XuzdCbRmRXno/X/duz7jDCqOgKAoohCGgAOKgY6IQQFFQ9+ocUATMI6giCa5dwH3ZomKERHFQIwQBW9CB0VQnEMbJQiKDBEQB0AFHHBANBpjcutbz3veVsQ+766932kP/1qrVwOnqvZTv9rdh/c5NSQsCiiggAIKKKCAAgoooIACCiiggAIK9Egg9WgsDkUBBRRQQAEFFFBAAQUUUEABBRRQQAFMePkSKKCAAgoooIACCiiggAIKKKCAAgr0SsCEV6+m08EooIACCiiggAIKKKCAAgoooIACCpjw8h1QQAEFFFBAAQUUUEABBRRQQAEFFOiVgAmvXk2ng1FAAQUUUEABBRRQQAEFFFBAAQUUMOHlO6CAAgoooIACCiiggAIKKKCAAgoo0CsBE169mk4Ho4ACCiiggAIKKKCAAg...",
	          // passportImages: [
	          //   '{b64: "data:image/png;base64,/9j/4AAQSkZJRgABAQAAAQ…}'
	          // ],
	          // wpFront: ['{b64: "data:image/png;base64,/9j/4AAQSkZJRgABAQAAAQ…}'],
	          // wpBack: ['{b64: "data:image/png;base64,/9j/4AAQSkZJRgABAQAAAQ…}'],
	          // generatingManualPDF: false
	        });
	      }
	      if (this.props.db["myPassApplication"] && Object.keys(this.props.db["myPassApplication"]).length > 0) {
	        this.setState(this.props.db["myPassApplication"]);
	      }
	    }
	
	    //single method that work for all fields
	    //takes incoming id of the field and then adds field data to state
	
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement("div", null, _react2.default.createElement("canvas", {
	        id: "textCanvas",
	        style: { display: "none", border: "0px solid black" }
	      }), !this.props.ui["myPassDetails-downloaded"] && _react2.default.createElement("div", {
	        style: {
	          margin: "20px",
	          textAlign: "center"
	        }
	      }, "Loading data..."), !this.state.generatingStatement && this.state.generatingManualPDF && this.getManualPDFLoader(), !this.state.generatingManualPDF && this.state.generatingStatement && this.getStatementLoader(), !this.state.generatingStatement && !this.state.generatingManualPDF && this.props.ui["myPassDetails-downloaded"] && _react2.default.createElement("div", null, _react2.default.createElement("div", null, this.reloadAgain()), this.state.stage === "home" && this.getPportHomePage(), this.state.stage === "applyHome" && this.getApplyHomePage(), this.state.stage === "inputGeneral" && this.getFormInputStageGeneral(), this.state.stage === "inputCorrection" && this.getFormInputStageCorrections(), this.state.stage === "inputPhotos" && this.getFormInputStageGenPhotos(), this.state.stage === "inputPayment" && this.getFormInputStagePayment(), this.state.stage === "review" && this.getFormReviewStage(), this.state.stage === "submit" && this.getFormSubmitStage()));
	    }
	  }]);
	
	  return BgdPassportServiceExt;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    userProfile: state.db.userProfile,
	    db: state.db,
	    ui: state.ui
	  };
	}
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    onSetUiFlag: function onSetUiFlag(flagName, flagVal) {
	      return dispatch((0, _actions.setUiFlag)(flagName, flagVal));
	    },
	    onReachApi: function () {
	      var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(objContents) {
	        return regeneratorRuntime.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                return _context3.abrupt("return", dispatch((0, _actions.reachApi)(objContents)));
	
	              case 1:
	              case "end":
	                return _context3.stop();
	            }
	          }
	        }, _callee3, undefined);
	      }));
	
	      return function onReachApi(_x3) {
	        return _ref14.apply(this, arguments);
	      };
	    }(),
	    onGetPoStatement: function onGetPoStatement(data, templateId) {
	      return dispatch((0, _actions.getStatement)(templateId, data));
	    },
	    onGetPoStatementB64: function onGetPoStatementB64(data, templateId, mailParams) {
	      return dispatch((0, _actions.getStatementB64)(templateId, data, mailParams));
	    },
	    onNotifyUsers: function onNotifyUsers(msgBody, arrayOfUsers) {
	      return dispatch((0, _actions.notifyUsers)(msgBody, arrayOfUsers));
	    },
	    onAddRecord: function onAddRecord(data) {
	      return dispatch((0, _actions.actionAddArray2Redux)(data));
	    }
	  };
	};
	
	exports.default = (0, _recompose.compose)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _Firebase.withFirebase)(BgdPassportServiceExt);

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(36);
	
	var _reactRedux = __webpack_require__(9);
	
	var _recompose = __webpack_require__(11);
	
	var _Firebase = __webpack_require__(10);
	
	var _actions = __webpack_require__(13);
	
	var _ContentGridVanilla = __webpack_require__(60);
	
	var _ContentGridVanilla2 = _interopRequireDefault(_ContentGridVanilla);
	
	var _reactackle = __webpack_require__(5);
	
	var _getDefs = __webpack_require__(43);
	
	var _getDefs2 = _interopRequireDefault(_getDefs);
	
	var _searchRecords = __webpack_require__(42);
	
	var _getMenuList = __webpack_require__(34);
	
	__webpack_require__(53);
	
	var _throttleDebounce = __webpack_require__(54);
	
	var _GridFilters = __webpack_require__(41);
	
	var _GridFilters2 = _interopRequireDefault(_GridFilters);
	
	var _GridDateFilters = __webpack_require__(40);
	
	var _GridDateFilters2 = _interopRequireDefault(_GridDateFilters);
	
	var _reactDeviceDetect = __webpack_require__(6);
	
	var _extendedOgDef = __webpack_require__(26);
	
	var _extendedOgDef2 = _interopRequireDefault(_extendedOgDef);
	
	var _TextInputField = __webpack_require__(150);
	
	var _TextInputField2 = _interopRequireDefault(_TextInputField);
	
	var _ScrollPositionManager = __webpack_require__(317);
	
	var _ScrollPositionManager2 = _interopRequireDefault(_ScrollPositionManager);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _toConsumableArray(arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
	      arr2[i] = arr[i];
	    }return arr2;
	  } else {
	    return Array.from(arr);
	  }
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var Grocer = function (_Component) {
	  _inherits(Grocer, _Component);
	
	  function Grocer(props) {
	    _classCallCheck(this, Grocer);
	
	    ////console.log("...test... " + JSON.stringify(tableDefs));
	    var _this = _possibleConstructorReturn(this, (Grocer.__proto__ || Object.getPrototypeOf(Grocer)).call(this, props));
	
	    _this.handleScroll = function (event) {
	      if (_this.state.stage === "showGrid") {
	        _this.props.onSetUiFlag("listYPos", window.scrollY);
	      }
	    };
	
	    _this.applyDataCondition = function (singleRecord, dataCondition) {
	      //console.log("~~||~~ " + JSON.stringify(singleRecord));
	      //console.log("~~ in the loop" + JSON.stringify(dataCondition));
	      var tmpRes = false;
	
	      for (var p = 0; p < dataCondition.length; p++) {
	        // console.log(
	        //   "~~~ signRec: " +
	        //     singleRecord[dataCondition[p]["colKey"]] +
	        //     " cond: " +
	        //     dataCondition[p]["colKey"] +
	        //     "=" +
	        //     dataCondition[p]["fieldVal"] +
	        //     " OR " +
	        //     this.props.userProfile[dataCondition[p]["fieldVal"]]
	        // );
	        if (singleRecord[dataCondition[p]["colKey"]] === dataCondition[p]["fieldVal"]) {
	          tmpRes = true;
	        }
	
	        if (singleRecord[dataCondition[p]["colKey"]] === _this.props.userProfile[dataCondition[p]["fieldVal"]]) {
	          tmpRes = true;
	        }
	      }
	      //console.log("~~ returning: " + tmpRes);
	      return tmpRes;
	    };
	
	    _this.displayToGrocer = function (item, tableName) {
	      if (tableName === "deliveryRequest" && item && item !== undefined) {
	        var specificSupplierCheck = item.supplier && item.supplier.includes(_this.state.supplierName) || item.supplier && item.supplier.includes("ALL");
	        if (item.supplierPrices && item.supplierPrices.length > 0 && item.status.includes("FOR PRICE")) {
	          var priceQuoteObj = item.supplierPrices.find(function (pObj) {
	            return pObj.supplierName === _this.state.supplierName;
	          });
	
	          if (priceQuoteObj && priceQuoteObj !== undefined) {
	            specificSupplierCheck = false;
	          }
	        }
	
	        var itemStatusCheck = item.status && item.status.includes("WITH GROCER");
	        if (itemStatusCheck && specificSupplierCheck) {
	          return true;
	        } else {
	          return false;
	        }
	      } else {
	        return true;
	      }
	    };
	
	    _this.loadDataEx = function (allTableDets) {
	      //console.log(JSON.stringify(allTableDets));
	      var recsLimit = 0;
	
	      if (_reactDeviceDetect.isMobile) {
	        if (allTableDets.recMobileLimit) {
	          recsLimit = parseInt(allTableDets.recMobileLimit);
	        }
	      } else {
	        if (allTableDets.recMobileLimit) {
	          recsLimit = parseInt(allTableDets.recLimit);
	        }
	      }
	
	      var basePath = "/";
	      var tableName = allTableDets.tableName;
	      if (recsLimit > 0) {
	        _this.props.firebase.db.ref(basePath + tableName).limitToLast(recsLimit).on("value", function (snapshot) {
	          var tmpArray = [];
	          var fbOject = [];
	          Promise.all([snapshot.val()]).then(function (res) {
	            fbOject = res[0];
	            if (fbOject && fbOject !== null && fbOject !== undefined) {
	              Object.keys(fbOject).map(function (key) {
	                var item = _extends({}, fbOject[key], {
	                  key: key
	                });
	                console.log("~~ Linking " + JSON.stringify(allTableDets));
	                if (allTableDets.dataConditions && allTableDets.dataConditions !== undefined && allTableDets.dataConditions.length > 0) {
	                  //console.log(JSON.stringify(allTableDets.dataConditions));
	                  if (_this.applyDataCondition(item, allTableDets.dataConditions)) {
	                    if (_this.displayToGrocer(item, tableName)) {
	                      tmpArray.push(item);
	                    }
	                  }
	                } else {
	                  if (_this.displayToGrocer(item, tableName)) {
	                    tmpArray.push(item);
	                  }
	                }
	              });
	            }
	            //reverse to have latest at the top
	            //tmpArray.reverse();
	            _this.props.onAddRecord({
	              path: tableName,
	              payload: tmpArray
	            });
	          });
	        });
	      } else {
	        _this.props.firebase.db.ref(basePath + tableName).on("value", function (snapshot) {
	          var tmpArray = [];
	          var fbOject = [];
	          Promise.all([snapshot.val()]).then(function (res) {
	            fbOject = res[0];
	            if (fbOject && fbOject !== null && fbOject !== undefined) {
	              Object.keys(fbOject).map(function (key) {
	                var item = _extends({}, fbOject[key], {
	                  key: key
	                });
	                //console.log("~~ Linking " + JSON.stringify(allTableDets));
	                if (allTableDets.dataConditions && allTableDets.dataConditions !== undefined && allTableDets.dataConditions.length > 0) {
	                  //console.log(JSON.stringify(allTableDets.dataConditions));
	                  if (_this.applyDataCondition(item, allTableDets.dataConditions)) {
	                    if (_this.displayToGrocer(item, tableName)) {
	                      tmpArray.push(item);
	                    }
	                  }
	                } else {
	                  if (_this.displayToGrocer(item, tableName)) {
	                    tmpArray.push(item);
	                  }
	                }
	              });
	            }
	            //reverse to have latest at the top
	
	            _this.props.onAddRecord({
	              path: tableName,
	              payload: tmpArray
	            });
	            _this.setState(function (prevState) {
	              return _extends({}, prevState, {
	                formDefs: (0, _extendedOgDef2.default)(_this.props.createTable),
	                tableDefs: (0, _getDefs2.default)(_this.props.createTable)
	              });
	            });
	          });
	        });
	      }
	      //}
	    };
	
	    _this.loadData = function (tableName, isDeleted) {
	      //console.log(tableName);
	      var recsLimit = 3000;
	      if (_reactDeviceDetect.isMobile) {
	        recsLimit = 2000;
	      }
	      if (tableName === "attendance") {
	        if (_reactDeviceDetect.isMobile) {
	          recsLimit === 2000;
	        } else {
	          recsLimit === 3000;
	        }
	      }
	      var basePath = "/";
	      if (isDeleted) {
	        basePath = "/deletedRecs/";
	      }
	      _this.props.firebase.db.ref(basePath + tableName).limitToLast(recsLimit).on("value", function (snapshot) {
	        ////console.log("Linking " + tableName);
	        var tmpArray = [];
	        var fbOject = [];
	        var projTempArray = [];
	        Promise.all([snapshot.val()]).then(function (res) {
	          //basic updating keys into objects
	          fbOject = res[0];
	          if (fbOject && fbOject !== null && fbOject !== undefined) {
	            tmpArray = Object.keys(fbOject).map(function (key) {
	              return _extends({}, fbOject[key], {
	                key: key
	              });
	            });
	          }
	          //reverse to have latest at the top
	          //tmpArray.reverse();
	
	          //filter project table for engineer and contributor
	          if (tableName === "projects" && (_this.props.currUserRole === "ENGINEER" || _this.props.currUserRole === "CONTRIBUTOR")) {
	            projTempArray = tmpArray.filter(function (item) {
	              return item.projectPhase === "IN FLIGHT";
	            });
	
	            //handle delete
	            if (isDeleted) {
	              _this.props.onAddRecord({
	                path: "deleted" + tableName,
	                payload: projTempArray
	              });
	            } else {
	              _this.props.onAddRecord({
	                path: tableName,
	                payload: projTempArray
	              });
	            }
	          } else {
	            //handle delete
	            if (isDeleted) {
	              _this.props.onAddRecord({
	                path: "deleted" + tableName,
	                payload: tmpArray
	              });
	            } else {
	              _this.props.onAddRecord({ path: tableName, payload: tmpArray });
	            }
	          }
	        });
	      });
	    };
	
	    _this.getTopMenu = function () {
	      return _react2.default.createElement("nav", { className: "navbar navbar-default navbar-fixed-top" }, _react2.default.createElement("div", {
	        className: "container-fluid",
	        style: {
	          paddingTop: "0px"
	        }
	      }, _react2.default.createElement("div", { className: "navbar-header" }, _react2.default.createElement("a", {
	        className: "navbar-brand",
	        href: "#",
	        style: {
	          marginLeft: "10px",
	          marginRight: "-20px",
	          color: "black"
	        }
	      }, "BCS"))));
	    };
	
	    _this.fetchMenus = function () {
	      //console.log("Fetching...");
	      //console.log("Props userMenu: " + JSON.stringify(this.props.userMenus));
	      return (0, _getMenuList.getMenuList)(true, _this.isAdmin(), _this.switchMenu, _this.props.currUserRole, _this.props.userMenus);
	    };
	
	    _this.stateChangeHandler = function (val, id, isPayload) {
	      //console.log("val: " + val + " id: " + id + " isPayload: " + isPayload);
	      var tmpState = {};
	      tmpState[id] = val;
	
	      if (isPayload) {
	        _this.setState(function (prevState) {
	          if (prevState && prevState.data.payload !== null) {
	            return _extends({}, prevState, {
	              data: _extends({}, prevState.data, {
	                payload: _extends({}, prevState.data.payload, tmpState)
	              })
	            });
	          } else {
	            return _extends({}, prevState, {
	              data: {
	                path: prevState.data.path,
	                payload: _extends({}, tmpState)
	              }
	            });
	          }
	        });
	      } else {
	        _this.setState(function (prevState) {
	          return _extends({}, prevState, tmpState);
	        });
	      }
	    };
	
	    _this.logoutApp = function () {
	      var msgToApp = {
	        actionType: "logOut",
	        payload: {}
	      };
	
	      if (window && window.ReactNativeWebView) {
	        //console.log("posing logout message to app");
	        window.ReactNativeWebView.postMessage(JSON.stringify(msgToApp));
	      }
	    };
	
	    _this.switchMenu = function (menuName) {
	      var unhandledMenu = ["checkLists", "clientFeedback", "soa", "chequesPayments", "creditNotes"];
	      if (unhandledMenu.includes(menuName)) {
	        alert("Wheels are spinning.... \nThis feature is coming soon!!!");
	        return;
	      }
	      if (_this.refs && _this.refs.searchText) {
	        _this.refs.searchText.value = "";
	        _this.doDelaySearch();
	      }
	      _this.stateChangeHandler({}, "searchFilters", false);
	      _this.stateChangeHandler({}, "searchDateFilters", false);
	      _this.stateChangeHandler(false, "showPivot", false);
	      if (menuName === "dashboard") {
	        _this.stateChangeHandler(true, "showDash", false);
	        _this.stateChangeHandler(false, "showGrid", false);
	        _this.stateChangeHandler(menuName, "tableName", false);
	      } else if (menuName === "signout") {
	        _this.props.firebase.doSignOut();
	        _this.props.onSignOut();
	        _this.logoutApp();
	        _reactRouter.browserHistory.push("/login");
	      } else {
	        _this.stateChangeHandler(true, "showGrid", false);
	        _this.stateChangeHandler(false, "showDash", false);
	        _this.stateChangeHandler(menuName, "tableName", false);
	      }
	    };
	
	    _this.isAdmin = function () {
	      return _this.props.isAdmin || _this.props.isSuperAdmin;
	    };
	
	    _this.handleDelete = function (key, path, searchObj) {
	      _this.props.firebase.db.ref("/" + path + "/" + key).remove();
	      _this.genNotification(searchObj, "delete");
	      _this.stateChangeHandler(true, "showGrid", false);
	    };
	
	    _this.getFormattedCellValue = function (jsonValue) {
	      if (jsonValue && jsonValue !== "" && typeof jsonValue === "string") {
	        var valArray = jsonValue.split("\n");
	        if (valArray.length > 1) {
	          return valArray.map(function (item, index) {
	            return _react2.default.createElement("div", { style: { paddingLeft: "10px" } }, index + 1 + ". " + item);
	          });
	        } else {
	          return jsonValue;
	        }
	      } else {
	        return jsonValue;
	      }
	    };
	
	    _this.getPriceConfirmation = function () {
	      return _react2.default.createElement("div", null, _react2.default.createElement("div", {
	        style: {
	          fontSize: "medium",
	          fontWeight: "bold",
	          margin: "5px"
	        }
	      }, "What is total price of this order:"), _react2.default.createElement("div", {
	        style: {
	          border: "1px solid grey",
	          borderRadius: "5px",
	          padding: "5px"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          marginTop: "3px",
	          marginBottom: "3px"
	        }
	      }, _react2.default.createElement(_TextInputField2.default, {
	        title: "PRICE",
	        value: _this.state.data.payload.grocerPrice,
	        stateChangeHandler: _this.stateChangeHandler,
	        fieldName: "grocerPrice",
	        disabled: false,
	        type: null,
	        message: "",
	        placeholder: "100"
	      })), _react2.default.createElement("div", {
	        style: {
	          marginTop: "3px",
	          marginBottom: "3px"
	        }
	      }, _react2.default.createElement(_TextInputField2.default, {
	        title: "ANY COMMENTS",
	        value: _this.state.data.payload.grocerComments,
	        stateChangeHandler: _this.stateChangeHandler,
	        fieldName: "grocerComments",
	        disabled: false,
	        type: null,
	        message: "",
	        multiline: true,
	        placeholder: "Onion and Jeeri not available"
	      })), _react2.default.createElement("div", {
	        style: {
	          marginTop: "3px",
	          marginBottom: "3px"
	        }
	      }, _react2.default.createElement(_reactackle.CardActions, null, _react2.default.createElement(_reactackle.CardActionsSupplemental, null, _react2.default.createElement(_reactackle.Button, {
	        text: "SUBMIT PRICE",
	        onPress: function onPress() {
	          window.confirm("Proceed with total of price of : " + _this.state.data.payload.grocerPrice + "?") && _this.directSave(false, false);
	        },
	        colorScheme: "primary",
	        disabled: _this.state.data.payload.grocerPrice === undefined || _this.state.data.payload.grocerPrice === ""
	      }), _react2.default.createElement(_reactackle.Button, {
	        text: "CANCEL",
	        onPress: function onPress() {
	          _this.stateChangeHandler("showGrid", "stage", false);
	          //console.log("cancelling..." + this.props.listYPos);
	          window.scroll(0, parseInt(_this.props.listYPos));
	        },
	        colorScheme: "warning",
	        disabled: false
	      }), _react2.default.createElement(_reactackle.Button, {
	        text: "DIRECT DELIVER",
	        onPress: function onPress() {
	          window.confirm("Please use this option carefully." + " Did you arrange collection of cash and delivery of goods yourself?" + " Press Ok to confirm. ") && _this.directSave(false, true);
	        },
	        colorScheme: "warning",
	        disabled: false
	      }))))), _react2.default.createElement("div", {
	        style: {
	          color: "#333",
	          fontSize: "medium",
	          fontWeight: "bold",
	          fontFamily: "RobotMedium",
	          backgroundColor: "gainsboro",
	          padding: "5px",
	          marginTop: "10px"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          paddingTop: "10px",
	          paddingBottom: "6px"
	        }
	      }, _react2.default.createElement("div", null, "REQUESTED ITEMS"), _react2.default.createElement("div", null, _this.getFormattedCellValue(_this.state.fullPayload.requestedItems)))));
	    };
	
	    _this.getPackingDone = function () {
	      return _react2.default.createElement("div", null, _react2.default.createElement("div", {
	        style: {
	          fontSize: "medium",
	          fontWeight: "bold",
	          margin: "5px"
	        }
	      }, "Is the order packed and is ready for lorry pickup? Tap on Packing Completed button to complete this order's packing."), _react2.default.createElement("div", {
	        style: {
	          border: "1px solid grey",
	          borderRadius: "5px",
	          padding: "5px"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          marginTop: "3px",
	          marginBottom: "3px"
	        }
	      }, _react2.default.createElement(_reactackle.CardActions, null, _react2.default.createElement(_reactackle.CardActionsSupplemental, null, _react2.default.createElement(_reactackle.Button, {
	        text: "PACKING COMPLETED",
	        onPress: function onPress() {
	          window.confirm("Are the items in this order packed and readied for pickup? Have you also clearly written cell number on the packet? Tap OK to confirm.") && _this.directSave(true);
	        },
	        colorScheme: "primary",
	        disabled: false
	      }), _react2.default.createElement(_reactackle.Button, {
	        text: "CANCEL",
	        onPress: function onPress() {
	          _this.stateChangeHandler("showGrid", "stage", false);
	        },
	        colorScheme: "warning",
	        disabled: false
	      }))))), _react2.default.createElement("div", {
	        style: {
	          color: "#333",
	          fontSize: "medium",
	          fontWeight: "bold",
	          fontFamily: "RobotMedium",
	          backgroundColor: "gainsboro",
	          padding: "5px",
	          marginTop: "10px"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          paddingTop: "10px",
	          paddingBottom: "6px"
	        }
	      }, _react2.default.createElement("div", null, "REQUESTED ITEMS"), _react2.default.createElement("div", null, _this.getFormattedCellValue(_this.state.fullPayload.requestedItems)))));
	    };
	
	    _this.handleEdit = function (key, path, fullPayload) {
	      //console.log("doing...: " + JSON.stringify(fullPayload));
	      window.scroll(0, 0);
	      _this.stateChangeHandler(fullPayload, "fullPayload", false);
	      if (fullPayload && fullPayload.status && fullPayload.status === "WITH GROCER FOR PRICE") {
	        _this.stateChangeHandler("getPrice", "stage", false);
	      }
	      if (fullPayload && fullPayload.status && fullPayload.status === "WITH GROCER FOR PACKING") {
	        _this.stateChangeHandler("getPackingDone", "stage", false);
	      }
	    };
	
	    _this.directSave = function (packingDone, directDelivered) {
	      var cloudPath = "deliveryRequest";
	      var tgtPayload = _.cloneDeep(_this.state.fullPayload);
	
	      if (!packingDone && !directDelivered) {
	        if (!tgtPayload.supplierPrices && tgtPayload.supplierPrices === undefined) {
	          tgtPayload.supplierPrices = [];
	        }
	
	        tgtPayload.supplierPrices.push({
	          price: _this.state.data.payload.grocerPrice ? _this.state.data.payload.grocerPrice : "",
	          notes: _this.state.data.payload.notes ? _this.state.data.payload.notes : "",
	          supplierName: _this.state.supplierName
	        });
	      }
	      var key = tgtPayload.key;
	
	      if (packingDone && packingDone === true) {
	        tgtPayload["status"] = "WAITING FOR LORRY";
	      }
	      if (directDelivered && directDelivered === true) {
	        tgtPayload["status"] = "DELIVERED";
	      }
	
	      if (key && key !== "") {
	        cloudPath = cloudPath + "/" + key;
	
	        _this.props.firebase.db.ref("/" + cloudPath).once("value").then(function (snap) {
	          _this.stateChangeHandler("showGrid", "stage", false);
	          return snap.ref.set(tgtPayload);
	        }).catch(function (err) {
	          console.log(err);
	          _this.stateChangeHandler("showGrid", "stage", false);
	          return console.log("some error: " + err);
	        });
	      }
	    };
	
	    _this.handleAddNew = function () {
	      ////console.log("generating new");
	      var initData = (0, _getMenuList.getInitData)(_this.state.tableName, _this.props.createTable, _this.props.userProfile);
	      if (initData && initData !== undefined) {
	        _this.stateChangeHandler(false, "showGrid", false);
	        _this.props.onSetUiFlag("operationType", "add");
	        _this.props.onSetUiFlag("tableName", _this.state.tableName);
	        _this.props.onAddNew({
	          path: _this.state.tableName,
	          data: _extends({}, initData)
	        });
	      }
	    };
	
	    _this.handleEditCancel = function () {
	      _this.stateChangeHandler(true, "showGrid", false);
	    };
	
	    _this.getDashView = function () {
	      return _react2.default.createElement("div", null);
	    };
	
	    _this.getFields = function () {
	      ////console.log("test");
	      alert("test");
	    };
	
	    _this.getData = function () {
	      var dTableName = _this.state.tableName;
	
	      if (_this.state.tableName === "viewReports") {
	        dTableName = "reports";
	      }
	      if (dTableName !== "dashboard") {
	        if (_this.state.tableDefs[dTableName] && _this.state.tableDefs[dTableName] !== undefined) {
	          //console.log(JSON.stringify(this.props.db[dTableName]));
	          return (0, _searchRecords.searchRecords)(_this.props.db[dTableName], _this.state.searchVal, _this.state.tableDefs[dTableName].searches ? _this.state.tableDefs[dTableName].searches : [], _this.state.searchFilters, _this.state.searchDateFilters);
	        } else {
	          return [];
	        }
	      }
	    };
	
	    _this.doStateUpdateForSearch = function () {
	      _this.setState(function (prevState) {
	        return _extends({}, prevState, {
	          searchVal: _this.refs.searchText.value
	        });
	      });
	    };
	
	    _this.doDelaySearch = function () {
	      ////console.log("doning search...");
	      var q = _this.refs.searchText.value;
	      //this.stateChangeHandler("searchVal", q, false);
	      if (q.length < 5) {
	        _this.getDataThrottled();
	      } else {
	        _this.getDataDebounced();
	      }
	    };
	
	    _this.getNewButton = function () {
	      if (_this.state.showGrid) {
	        return _react2.default.createElement(_reactackle.Button, {
	          colorScheme: "primary",
	          onPress: function onPress() {
	            return _this.handleAddNew();
	          },
	          text: "Add New"
	        });
	      }
	    };
	
	    _this.getFiltersList = function () {
	      var filtersList = [];
	      if (_this.props.createTable && _this.props.createTable.length > 0) {
	        var tableObj = _this.props.createTable.find(function (item) {
	          return item.name === _this.state.tableName;
	        });
	
	        if (tableObj && tableObj !== undefined) {
	          if (tableObj.filters && tableObj.filters !== undefined) {
	            filtersList = tableObj.filters;
	          }
	        }
	
	        return filtersList;
	      } else {
	        return [];
	      }
	    };
	
	    _this.getFilterDropDowns = function () {
	      if (_this.state.showGrid) {
	        return _react2.default.createElement("div", null, _react2.default.createElement(_GridFilters2.default, {
	          path: _this.state.tableName,
	          stateHandler: _this.stateChangeHandler,
	          value: _this.state.searchFilters,
	          ogTableDef: _this.state.formDefs,
	          filtersList: _this.getFiltersList()
	        }), _react2.default.createElement(_GridDateFilters2.default, {
	          path: _this.state.tableName,
	          stateHandler: _this.stateChangeHandler,
	          value: _this.state.searchDateFilters,
	          ogTableDef: _this.state.formDefs,
	          filtersList: _this.getFiltersList()
	        }));
	      }
	    };
	
	    _this.getGrid = function () {
	      return _react2.default.createElement(_ContentGridVanilla2.default, {
	        data: _this.getData(),
	        tableName: _this.state.tableName,
	        tableDef: _this.state.tableDefs[_this.state.tableName],
	        handleEdit: _this.handleEdit,
	        handleDelete: _this.handleDelete,
	        role: "grocer"
	      });
	    };
	
	    _this.getEnrichedString = function (ogString, searchObj) {
	      //console.log(ogString + JSON.stringify(searchObj));
	      var strArray = ogString.split(" ").map(function (word) {
	        //console.log(word + " = " + searchObj[word]);
	        if (searchObj[word] && searchObj[word] !== undefined) {
	          return searchObj[word];
	        } else {
	          return word;
	        }
	      });
	
	      return strArray.join(" ");
	    };
	
	    _this.genNotification = function (recPayload, opType) {
	      var usersList = [];
	      var updateText = undefined;
	      var createText = undefined;
	      var deleteText = undefined;
	      var tableObj = _this.props.createTable.find(function (item) {
	        return item.name === _this.state.tableName;
	      });
	
	      if (tableObj && tableObj !== undefined) {
	        usersList = tableObj.notifyUsers;
	        createText = tableObj.createNotifyText;
	        updateText = tableObj.updateNotifyText;
	        deleteText = tableObj.deleteNotifyText;
	
	        if (opType === "update" && updateText && updateText !== "" && updateText !== null) {
	          //console.log(" updateText: " + updateText + " opType: " + opType);
	          _this.props.onNotifyUsers(_this.getEnrichedString(updateText, recPayload), usersList);
	        } else if (opType === "delete" && deleteText && deleteText !== "" && deleteText !== null) {
	          //console.log(" deleteText: " + deleteText + " opType: " + opType);
	          _this.props.onNotifyUsers(_this.getEnrichedString(deleteText, recPayload), usersList);
	        } else if (opType === "create" && createText && createText !== "" && createText !== null) {
	          //console.log("createText: " + createText + " opType: " + opType);
	          _this.props.onNotifyUsers(_this.getEnrichedString(createText, recPayload), usersList);
	        }
	      }
	    };
	
	    _this.getSelectedPoCount = function () {
	      var poRecs = _this.getData();
	      if (poRecs && poRecs.length && poRecs.length > 0) {
	        return poRecs.length;
	      } else {
	        return 0;
	      }
	    };
	
	    _this.getInputField = function (fieldName, poDefs) {
	      return getInputField(fieldName, "projectPos", _this.state.data, _this.stateChangeHandler, false, poDefs, _this.props.db, _reactDeviceDetect.isMobile);
	    };
	
	    _this.getTopHeader = function () {
	      return _react2.default.createElement("div", {
	        style: {
	          position: "fixed",
	          zIndex: 99999,
	          top: "60px",
	          width: "95%"
	        }
	      }, _react2.default.createElement("div", { className: "wrapzz" }, _react2.default.createElement("div", { className: "searchzz" }, _react2.default.createElement("input", {
	        type: "text",
	        className: "searchTermzz",
	        placeholder: "Search...",
	        ref: "searchText",
	        onKeyUp: function onKeyUp() {
	          window.scroll(0, 0);
	          _this.doDelaySearch();
	        }
	      }), _react2.default.createElement("button", {
	        type: "submit",
	        className: "searchButtonzz",
	        onClick: function onClick() {
	          _this.setState(function (prevState) {
	            return _extends({}, prevState, {
	              searchVal: _this.refs.searchText.value
	            });
	          });
	          ////console.log("searchText " + this.refs.searchText.value);
	          ////console.log(JSON.stringify(this.state.searchVal));
	        }
	      }, _react2.default.createElement("i", { className: "fa fa-search" })))));
	    };
	
	    _this.getMainContent = function () {
	      return _react2.default.createElement(_reactackle.MainRegion, null, _react2.default.createElement(_reactackle.Content, null, _react2.default.createElement(_reactackle.Container, null, _this.getTopHeader(), _react2.default.createElement("div", {
	        style: {
	          overflow: "auto",
	          WebkitOverflowScrolling: "touch",
	          scrollBehavior: "smooth",
	          marginTop: "60px"
	        }
	      }, _this.state.stage === "showGrid" && _this.getGrid(), _this.state.stage === "getPrice" && _this.getPriceConfirmation(), _this.state.stage === "getPackingDone" && _this.getPackingDone())), _react2.default.createElement("div", {
	        style: {
	          minHeight: "500px"
	        }
	      })));
	    };
	
	    _this.state = {
	      data: {
	        path: "",
	        payload: {
	          paymentType: "",
	          supplierInvoice: "",
	          referenceNumber: "",
	          paymentDate: ""
	        }
	      },
	      message: "",
	      hasLoaded: false,
	      tableName: "deliveryRequest",
	      tableDefs: (0, _getDefs2.default)(_this.props.createTable),
	      searchVal: "",
	      showGrid: true,
	      showDash: false,
	      searchFilters: {},
	      searchDateFilters: {},
	      showFilters: true,
	      showPivot: false,
	      reRenderFlag: false,
	      formDefs: (0, _extendedOgDef2.default)(_this.props.createTable),
	      notInitialized: true,
	      loginProgress: false,
	      logview: [],
	      showPackingConfirmation: false,
	      stage: "showGrid"
	    };
	    _this.getDataDebounced = (0, _throttleDebounce.debounce)(1000, _this.doStateUpdateForSearch);
	    _this.getDataThrottled = (0, _throttleDebounce.throttle)(1000, _this.doStateUpdateForSearch);
	    return _this;
	  }
	
	  _createClass(Grocer, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      if (this.state.notInitialized && !this.props.firebase.auth && this.props.firebase.auth === undefined) {
	        /*
	        searchDateFilters: {
	              FromDate: moment()
	                .format("DD-MM-YYYY")
	                .toString(),
	              tgtDateField: "deliveryDate",
	              tgtDateFormat: "DD-MM-YYYY",
	              ToDate: moment()
	                .format("DD-MM-YYYY")
	                .toString()
	            }
	        */
	        var supplierName = window.location.pathname.replace("/", "");
	        if (supplierName && supplierName !== "") {
	          supplierName = supplierName.toUpperCase();
	        }
	        this.setState(function (prevState) {
	          return _extends({}, prevState, {
	            logview: [].concat(_toConsumableArray(prevState.logview), ["BROOKLYNZ"]),
	            notInitialized: false,
	            supplierName: supplierName
	          });
	        });
	        this.props.firebase.doInitiate("BROOKLYNZ");
	      }
	
	      window.addEventListener("scroll", this.handleScroll);
	
	      this.setState(function (prevState) {
	        return _extends({}, prevState, {
	          showFilters: !_reactDeviceDetect.isMobile
	        });
	      });
	
	      this.props.firebase.auth.signInWithEmailAndPassword("grocer@grocer.com.sg", "p123456").then(function (userRes) {
	        //console.log("stringify and parse done/skipped");
	        var res = userRes;
	
	        _this2.props.loadFbData("createTable", _this2.props.firebase).then(function (crTableRes) {
	          //console.log("crTableRes: " + JSON.stringify(crTableRes));
	
	          _this2.props.loadFbData("listOfTables", _this2.props.firebase).then(function (listRes) {
	            _this2.props.loadFbData("menuDesigner", _this2.props.firebase).then(function (desRes) {
	              _this2.stateChangeHandler("login done", "logview", false);
	              _this2.props.onSetUiFlag("showSpinner", false);
	              //console.log("ui flag switched off");
	
	              _this2.props.onSetUiFlag("userUid", res.uid);
	              //console.log("set ui flag user id");
	              _this2.props.onSetUiFlag("userEmail", res.email);
	              //console.log("email updated");
	
	              //console.log("inside load data: " + this.refs.email.value);
	              var currEmail = "grocer@grocer.com.sg";
	              _this2.props.firebase.db.ref("/users").on("value", function (snapshot) {
	                ////console.log("Linking " + tableName);
	                var tmpArray = [];
	                var fbOject = [];
	                Promise.all([snapshot.val()]).then(function (res) {
	                  fbOject = res[0];
	                  //console.log("now recieved the response for teams loading");
	                  tmpArray = Object.keys(fbOject).map(function (key) {
	                    return _extends({}, fbOject[key], {
	                      key: key
	                    });
	                  });
	                  tmpArray.reverse();
	                  //console.log("array reversed");
	                  ////console.log("Total Records: " + tmpArray.length);
	                  _this2.props.onAddArray({
	                    path: "users",
	                    payload: tmpArray
	                  });
	
	                  var currentUser = {};
	
	                  //
	
	                  currentUser = tmpArray.find(function (userObj) {
	                    if (userObj.userEmail === currEmail) {
	                      return userObj;
	                    }
	                  });
	
	                  // console.log(
	                  //   "admin status: " + JSON.stringify(currentUser)
	                  // );
	
	                  _this2.props.onAddRecord({
	                    path: "userProfile",
	                    payload: currentUser
	                  });
	
	                  if (currentUser !== undefined) {
	                    ////console.log("~!@~!@ " + JSON.stringify(currentUser));
	                    var isThisAdmin = currentUser.roleName === "ADMIN" || currentUser.roleName === "SUPERADMIN";
	                    var isThisSuperAdmin = currentUser.roleName === "SUPERADMIN";
	                    _this2.props.onSetUiFlag("currUserRole", currentUser.roleName);
	                    _this2.props.onSetUiFlag("isThisAdmin", isThisAdmin);
	                    _this2.props.onSetUiFlag("isThisSuperAdmin", isThisSuperAdmin);
	
	                    var allMenus = {};
	                    var allMenusFromDb = _this2.props.menuDesigner;
	                    if (allMenusFromDb && allMenusFromDb.length > 0) {
	                      var userMenu = allMenusFromDb.find(function (singMenu) {
	                        return singMenu.name === currentUser.roleName;
	                      });
	                      if (userMenu) {
	                        allMenus = userMenu.menuItems.map(function (singleMenu) {
	                          var srcTable = _this2.props.listOfTables.find(function (item) {
	                            return item.name === singleMenu.tableName;
	                          });
	                          if (srcTable && srcTable !== undefined && srcTable.name) {
	                            return _extends({}, singleMenu, {
	                              menuCaption: srcTable.menu
	                            });
	                          }
	                        });
	                        _this2.props.onSetUiFlag("userMenus", allMenus);
	                      }
	                    }
	
	                    _this2.props.onAddRecord({
	                      path: "currentUser",
	                      payload: currentUser
	                    });
	
	                    _this2.props.onAddRecord({
	                      path: "team",
	                      payload: {
	                        name: "BROOKLYNZ",
	                        fbCloudUrl: "",
	                        fbDbUrl: ""
	                      }
	                    });
	
	                    var allTableDets = _this2.props.userMenus;
	                    if (allTableDets && allTableDets.length > 0) {
	                      for (var k = 0; k < allTableDets.length; k++) {
	                        _this2.loadDataEx(allTableDets[k]);
	                      }
	                    } else {
	                      console.log("tables not linked");
	                    }
	                  }
	                });
	              });
	            });
	          });
	        });
	      }).catch(function (error) {
	        _this2.setState(function (prevState) {
	          return _extends({}, prevState, {
	            message: error.message,
	            loginProgress: false,
	            logview: [].concat(_toConsumableArray(prevState.logview), [error])
	          });
	        });
	      });
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      window.removeEventListener("scroll", this.handleScroll);
	    }
	
	    //single method that work for all fields
	    //takes incoming id of the field and then adds field data to state
	
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement("div", { id: "mainContainer", style: { minHeight: "30000px" } }, _react2.default.createElement("div", null, this.getTopMenu()), _react2.default.createElement("div", {
	        style: {
	          marginTop: "40px"
	        }
	      }, _react2.default.createElement("div", null, this.getMainContent())));
	    }
	  }]);
	
	  return Grocer;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    userProfile: state.db.userProfile,
	    userMenus: state.ui.userMenus,
	    users: state.db.users,
	    projects: state.db.projects,
	    attendance: state.db.attendance,
	    contacts: state.db.contacts,
	    logistics: state.db.logistics,
	    notices: state.db.notices,
	    projectInvoices: state.db.projectInvoices,
	    deletedprojectInvoices: state.db.deletedprojectInvoices,
	    projectClaims: state.db.projectClaims,
	    projectDos: state.db.projectDos,
	    projectPos: state.db.projectPos,
	    projectQuotes: state.db.projectQuotes,
	    reports: state.db.reports,
	    suppliers: state.db.suppliers,
	    tasks: state.db.tasks,
	    currentUser: state.db.userProfile,
	    isAdmin: state.ui.isThisAdmin,
	    isSuperAdmin: state.ui.isThisSuperAdmin,
	    userUid: state.ui.userUid,
	    currUserRole: state.ui.currUserRole,
	    createFields: state.db.createFields,
	    createTable: state.db.createTable,
	    testTable: state.db.testTable,
	    listOfTables: state.db.listOfTables,
	    menuDesigner: state.db.menuDesigner,
	    uploadButton: state.ui.dataUploadButton && state.ui.dataUploadButton !== undefined ? state.ui.dataUploadButton : false,
	    db: state.db,
	    listYPos: state.ui.listYPos
	  };
	}
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    onAddRecord: function onAddRecord(data) {
	      return dispatch((0, _actions.actionAddArray2Redux)(data));
	    },
	    onSelectRecord: function onSelectRecord(params) {
	      dispatch((0, _actions.selectARecord)(params));
	      dispatch((0, _actions.setUiFlag)("tableName", params.path));
	    },
	    onAddNew: function onAddNew(data) {
	      return dispatch((0, _actions.initSelectedRecord)(data));
	    },
	    loadStats: function loadStats(parsedRes) {
	      return dispatch((0, _actions.loadAllStats)(parsedRes));
	    },
	    onSetUiFlag: function onSetUiFlag(flagName, flagVal) {
	      return dispatch((0, _actions.setUiFlag)(flagName, flagVal));
	    },
	    onSignOut: function onSignOut() {
	      dispatch((0, _actions.resetRedux)());
	      dispatch((0, _actions.setUiFlag)("userMenus", []));
	    },
	    loadFbData: function loadFbData(tableName, firebase) {
	      return dispatch((0, _actions.loadFbData)(tableName, firebase));
	    },
	    onNotifyUsers: function onNotifyUsers(msgBody, arrayOfUsers) {
	      return dispatch((0, _actions.notifyUsers)(msgBody, arrayOfUsers));
	    },
	    onGetId: function onGetId(data) {
	      return dispatch((0, _actions.getId)(data));
	    },
	    onGetAcctStatement: function onGetAcctStatement(data) {
	      return dispatch((0, _actions.getAcctStatement)(data));
	    },
	    onGetAcctBalance: function onGetAcctBalance(data) {
	      return dispatch((0, _actions.getAcctBalance)(data));
	    },
	    onAddArray: function onAddArray(data) {
	      return dispatch((0, _actions.actionAddArray2Redux)(data));
	    }
	  };
	};
	
	exports.default = (0, _recompose.compose)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _Firebase.withFirebase)(Grocer);

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactackle = __webpack_require__(5);
	
	var _reactDeviceDetect = __webpack_require__(6);
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var HighComm = function (_Component) {
	  _inherits(HighComm, _Component);
	
	  function HighComm() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, HighComm);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = HighComm.__proto__ || Object.getPrototypeOf(HighComm)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      searchVal: ""
	    }, _this.stateChangeHandler = function (val, id, isPayload) {
	      // console.log(
	      //   "val: " + JSON.stringify(val) + " id: " + id + " isPayload: " + isPayload
	      // );
	      var tmpState = {};
	      tmpState[id] = val;
	
	      if (isPayload) {
	        _this.setState(function (prevState) {
	          if (prevState && prevState.data.payload !== null) {
	            return _extends({}, prevState, {
	              data: _extends({}, prevState.data, {
	                payload: _extends({}, prevState.data.payload, tmpState)
	              })
	            });
	          } else {
	            return _extends({}, prevState, {
	              data: {
	                path: prevState.data.path,
	                payload: _extends({}, tmpState)
	              }
	            });
	          }
	        });
	      } else {
	        _this.setState(function (prevState) {
	          return _extends({}, prevState, tmpState);
	        });
	      }
	    }, _this.getActionButton = function (iconName, title, stateValue, bucket) {
	      var _ref2;
	
	      return _react2.default.createElement("div", {
	        style: {
	          textAlign: "center",
	          width: "100%"
	        }
	      }, _react2.default.createElement("div", {
	        style: (_ref2 = {
	          width: "50%",
	          padding: "1px",
	          textAlign: "center",
	          border: "1px solid gainsboro",
	          borderRadius: _reactDeviceDetect.isMobile ? "5px" : "0px",
	          backgroundColor: stateValue === title ? "rgb(30, 101, 144)" : "gainsboro",
	          margin: "auto"
	        }, _defineProperty(_ref2, "padding", "6px"), _defineProperty(_ref2, "fontWeight", "bold"), _defineProperty(_ref2, "color", stateValue === title ? "white" : "black"), _defineProperty(_ref2, "fontSize", "12px"), _ref2),
	        onClick: function onClick() {
	          if (title !== stateValue) {
	            if (window.confirm("Please confirm if you would like to change the status of this application to " + title + "?")) {
	              _this.updateStatus(bucket, title);
	            }
	          }
	        }
	      }, _react2.default.createElement("div", null, _react2.default.createElement("i", { className: iconName }), " ", title)));
	    }, _this.updateStatus = function (bucket, newStatus) {
	      var cloudPath = "hCommApps/" + bucket.key;
	      _this.props.firebase.db.ref("/" + cloudPath).once("value").then(function (snap) {
	        return snap.ref.set(_extends({}, bucket, {
	          status: newStatus
	        }));
	      }).catch(function (err) {
	        console.log(err);
	        return console.log("some error: " + err);
	      }).then(function (err) {
	        //clear the bucket
	        _this.props.firebase.db.ref("/myPassApps" + "/" + bucket.cellPhone + "/" + bucket.key).once("value").then(function (snap) {
	          //console.log("ta da");
	          _this.props.onNotifyUsers("You passport application is now under the status : " + newStatus, [bucket.cellPhone]);
	          return snap.ref.set(_extends({}, bucket, {
	            status: newStatus
	          }));
	        }).catch(function (err) {
	          console.log(err);
	          return console.log("some error: " + err);
	        }).then(function (err) {});
	      });
	    }, _this.getApplicationsList = function (listOfApplicationsAll) {
	      //console.log(JSON.stringify(listOfApplications));
	
	      var listOfApplications = [];
	
	      if (_this.state.searchVal === "") {
	        listOfApplications = listOfApplicationsAll;
	      } else {
	        var searchVal = _this.state.searchVal.toLowerCase();
	        listOfApplications = listOfApplicationsAll.filter(function (app) {
	          return app.passportNo.toLowerCase().includes(searchVal) || app.name.toLowerCase().includes(searchVal) || app.applicationDate.toLowerCase().includes(searchVal) || app.status.toLowerCase().includes(searchVal) || app.cellPhone.includes(searchVal);
	        });
	      }
	
	      if (listOfApplications && listOfApplications.length > 0) {
	        return listOfApplications.map(function (passApp) {
	          return _react2.default.createElement("div", {
	            style: {
	              margin: "10px",
	              padding: "5px",
	              backgroundColor: "white",
	              marginBottom: "15px",
	              borderRadius: "5px"
	            }
	          }, _react2.default.createElement("table", { className: "table table-striped table-bordered" }, _react2.default.createElement("tbody", null, _react2.default.createElement("tr", null, _react2.default.createElement("td", null, "Name"), _react2.default.createElement("td", null, passApp.name)), _react2.default.createElement("tr", null, _react2.default.createElement("td", null, "Cell No."), _react2.default.createElement("td", null, passApp.cellPhone)), _react2.default.createElement("tr", null, _react2.default.createElement("td", null, "Passport No."), _react2.default.createElement("td", null, passApp.passportNo)), _react2.default.createElement("tr", null, _react2.default.createElement("td", null, "Application Date"), _react2.default.createElement("td", null, passApp.applicationDate)), _react2.default.createElement("tr", null, _react2.default.createElement("td", null, "Status"), _react2.default.createElement("td", null, passApp.status)))), _react2.default.createElement("table", { className: "table table-bordered" }, _react2.default.createElement("tbody", null, _react2.default.createElement("tr", null, _react2.default.createElement("td", null, "Tap to update status")), _react2.default.createElement("tr", null, _react2.default.createElement("td", null, _this.getActionButton("fa fa-clock", "SUBMITTED", passApp.status, passApp))), _react2.default.createElement("tr", null, _react2.default.createElement("td", null, _this.getActionButton("fa fa-clock", "ACCEPTED", passApp.status, passApp))), _react2.default.createElement("tr", null, _react2.default.createElement("td", null, _this.getActionButton("fa fa-clock", "READY FOR COLLECTION", passApp.status, passApp))), _react2.default.createElement("tr", null, _react2.default.createElement("td", null, _this.getActionButton("fa fa-clock", "REJECTED", passApp.status, passApp))))));
	        });
	      } else {
	        return _react2.default.createElement("div", null, "No recs");
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  //single method that work for all fields
	  //takes incoming id of the field and then adds field data to state
	
	
	  _createClass(HighComm, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement("div", null, _react2.default.createElement("div", {
	        style: {
	          margin: "5px",
	          padding: "5px"
	        }
	      }, _react2.default.createElement("div", null, _react2.default.createElement("div", {
	        style: {
	          padding: "1px",
	          textAlign: "right",
	          border: "1px solid gainsboro",
	          borderRadius: _reactDeviceDetect.isMobile ? "5px" : "0px",
	          backgroundColor: "white",
	          zIndex: "-9"
	        }
	      }, _react2.default.createElement(_reactackle.TextField, {
	        value: this.state["searchVal"],
	        onChange: function onChange(e) {
	          _this2.stateChangeHandler(e.value, "searchVal", false);
	        },
	        fullWidth: true,
	        placeholder: "Search..."
	      })))), _react2.default.createElement("div", null, this.getApplicationsList(this.props.applications)));
	    }
	  }]);
	
	  return HighComm;
	}(_react.Component);
	
	exports.default = HighComm;

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(36);
	
	var _reactRedux = __webpack_require__(9);
	
	var _recompose = __webpack_require__(11);
	
	var _Firebase = __webpack_require__(10);
	
	var _actions = __webpack_require__(13);
	
	var _ContentGridVanilla = __webpack_require__(60);
	
	var _ContentGridVanilla2 = _interopRequireDefault(_ContentGridVanilla);
	
	var _reactackle = __webpack_require__(5);
	
	var _getDefs = __webpack_require__(43);
	
	var _getDefs2 = _interopRequireDefault(_getDefs);
	
	var _searchRecords = __webpack_require__(42);
	
	var _getEditView = __webpack_require__(108);
	
	var _getEditView2 = _interopRequireDefault(_getEditView);
	
	var _getMenuList = __webpack_require__(34);
	
	__webpack_require__(53);
	
	var _throttleDebounce = __webpack_require__(54);
	
	var _GridFilters = __webpack_require__(41);
	
	var _GridFilters2 = _interopRequireDefault(_GridFilters);
	
	var _GridDateFilters = __webpack_require__(40);
	
	var _GridDateFilters2 = _interopRequireDefault(_GridDateFilters);
	
	var _reactDeviceDetect = __webpack_require__(6);
	
	var _numeral = __webpack_require__(16);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var _extendedOgDef = __webpack_require__(26);
	
	var _extendedOgDef2 = _interopRequireDefault(_extendedOgDef);
	
	var _getInputField = __webpack_require__(18);
	
	var _getInputField2 = _interopRequireDefault(_getInputField);
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _InventoryGrid = __webpack_require__(287);
	
	var _InventoryGrid2 = _interopRequireDefault(_InventoryGrid);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _asyncToGenerator(fn) {
	  return function () {
	    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
	      function step(key, arg) {
	        try {
	          var info = gen[key](arg);var value = info.value;
	        } catch (error) {
	          reject(error);return;
	        }if (info.done) {
	          resolve(value);
	        } else {
	          return Promise.resolve(value).then(function (value) {
	            step("next", value);
	          }, function (err) {
	            step("throw", err);
	          });
	        }
	      }return step("next");
	    });
	  };
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var LandingPage = function (_Component) {
	  _inherits(LandingPage, _Component);
	
	  function LandingPage(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, LandingPage);
	
	    ////console.log("...test... " + JSON.stringify(tableDefs));
	    var _this = _possibleConstructorReturn(this, (LandingPage.__proto__ || Object.getPrototypeOf(LandingPage)).call(this, props));
	
	    _this.handleScroll = function (event) {
	      // console.log(
	      //   "scrolling... " + window.document.querySelector(".content").scrollTop
	      // );
	
	      var last_known_scroll_position = 0;
	      var ticking = false;
	
	      if (_this.state.showGrid) {
	        //console.log("setting scroll pos");
	        last_known_scroll_position = window.document.querySelector(".content").scrollTop;
	
	        if (!ticking) {
	          window.requestAnimationFrame(function () {
	            _this.props.onSetUiFlag("listYPos", window.document.querySelector(".content").scrollTop);
	            ticking = false;
	          });
	
	          ticking = true;
	        }
	      }
	    };
	
	    _this.setScroll = function (setToTop) {
	      //console.log("attempting scroll");
	      var element = window.document.querySelector(".content");
	      if (element && element !== "") {
	        //console.log("setting scroll");
	        if (setToTop) {
	          //console.log("setting to 0");
	          element.scroll(0, 0);
	        } else {
	          //console.log("setting to " + this.props.listYPos);
	          element.scroll(0, parseInt(_this.props.listYPos));
	        }
	      } else {
	        //console.log("element not found");
	      }
	    };
	
	    _this.applyDataCondition = function (singleRecord, dataCondition) {
	      //console.log("~~||~~ " + JSON.stringify(singleRecord));
	      //console.log("~~ in the loop" + JSON.stringify(dataCondition));
	      var tmpRes = false;
	
	      for (var p = 0; p < dataCondition.length; p++) {
	        // console.log(
	        //   "~~~ signRec: " +
	        //     singleRecord[dataCondition[p]["colKey"]] +
	        //     " cond: " +
	        //     dataCondition[p]["colKey"] +
	        //     "=" +
	        //     dataCondition[p]["fieldVal"] +
	        //     " OR " +
	        //     this.props.userProfile[dataCondition[p]["fieldVal"]]
	        // );
	        if (singleRecord[dataCondition[p]["colKey"]] === dataCondition[p]["fieldVal"]) {
	          tmpRes = true;
	        }
	
	        if (singleRecord[dataCondition[p]["colKey"]] === _this.props.userProfile[dataCondition[p]["fieldVal"]]) {
	          tmpRes = true;
	        }
	      }
	      //console.log("~~ returning: " + tmpRes);
	      return tmpRes;
	    };
	
	    _this.loadDataEx = function (allTableDets) {
	      //if (allTableDets.tableName === "visitors") {
	      var recsLimit = 0;
	
	      if (!allTableDets || allTableDets === undefined) {
	        return [];
	      }
	
	      if (_reactDeviceDetect.isMobile) {
	        if (allTableDets.recMobileLimit) {
	          recsLimit = parseInt(allTableDets.recMobileLimit);
	        }
	      } else {
	        if (allTableDets.recMobileLimit) {
	          recsLimit = parseInt(allTableDets.recLimit);
	        }
	      }
	
	      var basePath = "/";
	      var tableName = allTableDets.tableName;
	      if (recsLimit > 0) {
	        _this.props.firebase.db.ref(basePath + tableName).limitToLast(recsLimit).on("value", function (snapshot) {
	          var tmpArray = [];
	          var fbOject = [];
	          Promise.all([snapshot.val()]).then(function (res) {
	            fbOject = res[0];
	            if (fbOject && fbOject !== null && fbOject !== undefined) {
	              Object.keys(fbOject).map(function (key) {
	                var item = _extends({}, fbOject[key], {
	                  key: key
	                });
	                //console.log("~~ Linking " + JSON.stringify(allTableDets));
	                if (allTableDets.dataConditions && allTableDets.dataConditions !== undefined && allTableDets.dataConditions.length > 0) {
	                  //console.log(JSON.stringify(allTableDets.dataConditions));
	                  if (_this.applyDataCondition(item, allTableDets.dataConditions)) {
	                    tmpArray.push(item);
	                  }
	                } else {
	                  tmpArray.push(item);
	                }
	              });
	            }
	            //reverse to have latest at the top
	            tmpArray.reverse();
	            _this.props.onAddRecord({
	              path: tableName,
	              payload: tmpArray
	            });
	          });
	        });
	      } else {
	        _this.props.firebase.db.ref(basePath + tableName).on("value", function (snapshot) {
	          var tmpArray = [];
	          var fbOject = [];
	          Promise.all([snapshot.val()]).then(function (res) {
	            fbOject = res[0];
	            if (fbOject && fbOject !== null && fbOject !== undefined) {
	              Object.keys(fbOject).map(function (key) {
	                var item = _extends({}, fbOject[key], {
	                  key: key
	                });
	                //console.log("~~ Linking " + JSON.stringify(allTableDets));
	                if (allTableDets.dataConditions && allTableDets.dataConditions !== undefined && allTableDets.dataConditions.length > 0) {
	                  //console.log(JSON.stringify(allTableDets.dataConditions));
	                  if (_this.applyDataCondition(item, allTableDets.dataConditions)) {
	                    tmpArray.push(item);
	                  }
	                } else {
	                  tmpArray.push(item);
	                }
	              });
	            }
	            //reverse to have latest at the top
	            tmpArray.reverse();
	            _this.props.onAddRecord({
	              path: tableName,
	              payload: tmpArray
	            });
	          });
	        });
	      }
	      //}
	    };
	
	    _this.loadData = function (tableName, isDeleted) {
	      //console.log(tableName);
	      var recsLimit = 3000;
	      if (_reactDeviceDetect.isMobile) {
	        recsLimit = 2000;
	      }
	      if (tableName === "attendance") {
	        if (_reactDeviceDetect.isMobile) {
	          recsLimit === 2000;
	        } else {
	          recsLimit === 3000;
	        }
	      }
	      var basePath = "/";
	      if (isDeleted) {
	        basePath = "/deletedRecs/";
	      }
	      _this.props.firebase.db.ref(basePath + tableName).limitToLast(recsLimit).on("value", function (snapshot) {
	        ////console.log("Linking " + tableName);
	        var tmpArray = [];
	        var fbOject = [];
	        var projTempArray = [];
	        Promise.all([snapshot.val()]).then(function (res) {
	          //basic updating keys into objects
	          fbOject = res[0];
	          if (fbOject && fbOject !== null && fbOject !== undefined) {
	            tmpArray = Object.keys(fbOject).map(function (key) {
	              return _extends({}, fbOject[key], {
	                key: key
	              });
	            });
	          }
	          //reverse to have latest at the top
	          tmpArray.reverse();
	
	          //filter project table for engineer and contributor
	          if (tableName === "projects" && (_this.props.currUserRole === "ENGINEER" || _this.props.currUserRole === "CONTRIBUTOR")) {
	            projTempArray = tmpArray.filter(function (item) {
	              return item.projectPhase === "IN FLIGHT";
	            });
	
	            //handle delete
	            if (isDeleted) {
	              _this.props.onAddRecord({
	                path: "deleted" + tableName,
	                payload: projTempArray
	              });
	            } else {
	              _this.props.onAddRecord({
	                path: tableName,
	                payload: projTempArray
	              });
	            }
	          } else {
	            //handle delete
	            if (isDeleted) {
	              _this.props.onAddRecord({
	                path: "deleted" + tableName,
	                payload: tmpArray
	              });
	            } else {
	              _this.props.onAddRecord({ path: tableName, payload: tmpArray });
	            }
	          }
	        });
	      });
	    };
	
	    _this.getTopMenu = function () {
	      return _react2.default.createElement("nav", { className: "navbar navbar-default navbar-fixed-top" }, _react2.default.createElement("div", {
	        className: "container-fluid",
	        style: {
	          paddingTop: "25px"
	        }
	      }, _react2.default.createElement("div", { className: "navbar-header" }, _react2.default.createElement("button", {
	        type: "button",
	        className: "pull-left navbar-toggle collapsed",
	        "data-toggle": "collapse",
	        "data-target": "#navMenu",
	        "aria-expanded": "false",
	        style: {
	          marginLeft: "10px"
	        }
	      }, _react2.default.createElement("span", { className: "sr-only" }, "Toggle navigation"), _react2.default.createElement("span", { className: "icon-bar" }), _react2.default.createElement("span", { className: "icon-bar" }), _react2.default.createElement("span", { className: "icon-bar" })), _react2.default.createElement("a", {
	        className: "navbar-brand",
	        href: "#",
	        style: {
	          marginLeft: "-20px",
	          marginRight: "-20px",
	          color: "black"
	        }
	      }, (0, _getMenuList.getCaption)(_this.state.tableName, _this.props.listOfTables, _reactDeviceDetect.isMobile)), _this.state.showGrid && !_this.state.showDash && _react2.default.createElement("button", {
	        type: "button",
	        className: "pull-right navbar-toggle",
	        style: {
	          marginLeft: "10px",
	          marginRight: "10px",
	          marginTop: "10px",
	          paddingRight: "13px",
	          paddingLeft: "13px",
	          paddingTop: "5px",
	          paddingBottom: "5px"
	        }
	      }, _react2.default.createElement("span", {
	        "class": "fa fa-filter fa-lg",
	        "aria-hidden": "true",
	        onClick: function onClick() {
	          _this.setState(function (prevState) {
	            return _extends({}, prevState, {
	              showFilters: !prevState.showFilters
	            });
	          });
	        }
	      })), _this.state.showGrid && _react2.default.createElement("button", {
	        type: "button",
	        className: "pull-right navbar-toggle",
	        style: {
	          marginLeft: "10px",
	          marginRight: "0px",
	          marginTop: "10px",
	          paddingRight: "13px",
	          paddingLeft: "13px",
	          paddingTop: "5px",
	          paddingBottom: "5px"
	        }
	      }, _react2.default.createElement("span", {
	        "class": "fa fa-plus fa-lg",
	        "aria-hidden": "true",
	        onClick: function onClick() {
	          return _this.handleAddNew();
	        }
	      }))), !_this.state.showDash && _this.state.showFilters && _react2.default.createElement("div", {
	        style: {
	          marginTop: "15px",
	          marginBottom: "15px"
	        }
	      }, _this.state.showGrid && _this.state.showFilters && _this.getSearchBar(), _this.state.showGrid && _this.state.showFilters && _this.getFilterDropDowns()), _react2.default.createElement("div", null, _this.getTotals()), _react2.default.createElement("div", { className: "collapse navbar-collapse", id: "navMenu" }, _react2.default.createElement("ul", { className: "nav navbar-nav navbar-left" }, _this.fetchMenus()))));
	    };
	
	    _this.fetchMenus = function () {
	      //console.log("Fetching...");
	      //console.log("Props userMenu: " + JSON.stringify(this.props.userMenus));
	      return (0, _getMenuList.getMenuList)(true, _this.isAdmin(), _this.switchMenu, _this.props.currUserRole, _this.props.userMenus);
	    };
	
	    _this.stateChangeHandler = function (val, id, isPayload) {
	      //console.log("val: " + val + " id: " + id + " isPayload: " + isPayload);
	      var tmpState = {};
	      tmpState[id] = val;
	
	      if (isPayload) {
	        _this.setState(function (prevState) {
	          if (prevState && prevState.data.payload !== null) {
	            return _extends({}, prevState, {
	              data: _extends({}, prevState.data, {
	                payload: _extends({}, prevState.data.payload, tmpState)
	              })
	            });
	          } else {
	            return _extends({}, prevState, {
	              data: {
	                path: prevState.data.path,
	                payload: _extends({}, tmpState)
	              }
	            });
	          }
	        });
	      } else {
	        _this.setState(function (prevState) {
	          return _extends({}, prevState, tmpState);
	        });
	      }
	    };
	
	    _this.logoutApp = function () {
	      var msgToApp = {
	        actionType: "logOut",
	        payload: {}
	      };
	
	      if (window && window.ReactNativeWebView) {
	        //console.log("posing logout message to app");
	        window.ReactNativeWebView.postMessage(JSON.stringify(msgToApp));
	      }
	    };
	
	    _this.switchMenu = function (menuName) {
	      var unhandledMenu = ["checkLists", "clientFeedback", "soa", "chequesPayments", "creditNotes"];
	      if (unhandledMenu.includes(menuName)) {
	        alert("Wheels are spinning.... \nThis feature is coming soon!!!");
	        return;
	      }
	      if (_this.refs && _this.refs.searchText) {
	        _this.refs.searchText.value = "";
	        _this.doDelaySearch();
	      }
	      _this.stateChangeHandler({}, "searchFilters", false);
	      _this.stateChangeHandler({}, "searchDateFilters", false);
	      _this.stateChangeHandler(false, "showPivot", false);
	      if (menuName === "dashboard" || menuName === "bcsHome") {
	        _this.stateChangeHandler(true, "showDash", false);
	        _this.stateChangeHandler(false, "showGrid", false);
	        _this.stateChangeHandler(menuName, "tableName", false);
	      } else if (menuName === "signout") {
	        _this.props.firebase.doSignOut();
	        _this.props.onSignOut();
	        _this.logoutApp();
	        _reactRouter.browserHistory.push("/login");
	      } else {
	        _this.stateChangeHandler(true, "showGrid", false);
	        _this.stateChangeHandler(false, "showDash", false);
	        _this.stateChangeHandler(menuName, "tableName", false);
	        _this.setScroll(true);
	      }
	    };
	
	    _this.isAdmin = function () {
	      return _this.props.isAdmin || _this.props.isSuperAdmin;
	    };
	
	    _this.handleDelete = function (key, path, searchObj) {
	      _this.props.firebase.db.ref("/" + path + "/" + key).remove();
	      _this.genNotification(searchObj, "delete");
	      _this.stateChangeHandler(true, "showGrid", false);
	    };
	
	    _this.handleEdit = function (key, path, fullPayload) {
	      //alert("Here is the key: " + key + " here is the path: " + path);
	      _this.setScroll(true);
	      if (path === "deletedprojectInvoices") {
	        if (window.confirm("Do you wish to restore this item?")) {
	          var cloudPath = "projectInvoices/" + key + "/";
	          _this.props.firebase.db.ref("/" + cloudPath).once("value").then(function (snap) {
	            snap.ref.set(fullPayload);
	          }).catch(function (err) {
	            console.log(err);
	            return "some error: " + err;
	          }).then(function (err) {
	            return _this.handleDelete(key, "deletedRecs/projectInvoices");
	          });
	        }
	      } else {
	        _this.stateChangeHandler(false, "showGrid", false);
	        _this.props.onSelectRecord({ path: path, key: key });
	        _this.props.onSetUiFlag("operationType", "update");
	      }
	    };
	
	    _this.handleAddNew = function () {
	      ////console.log("generating new");
	      var initData = (0, _getMenuList.getInitData)(_this.state.tableName, _this.props.createTable, _this.props.userProfile);
	      if (initData && initData !== undefined) {
	        _this.stateChangeHandler(false, "showGrid", false);
	        _this.props.onSetUiFlag("operationType", "add");
	        _this.props.onSetUiFlag("tableName", _this.state.tableName);
	        _this.props.onAddNew({
	          path: _this.state.tableName,
	          data: _extends({}, initData)
	        });
	      }
	    };
	
	    _this.handleEditCancel = function () {
	      _this.stateChangeHandler(true, "showGrid", false);
	      _this.setScroll(false);
	    };
	
	    _this.getDashView = function () {
	      return _react2.default.createElement(_InventoryGrid2.default, null);
	    };
	
	    _this.getFields = function () {
	      ////console.log("test");
	      alert("test");
	    };
	
	    _this.getData = function () {
	      var dTableName = _this.state.tableName;
	      if (_this.state.tableName === "viewReports") {
	        dTableName = "reports";
	      }
	      if (dTableName !== "dashboard" && dTableName !== "bcsHome") {
	        if (_this.state.searchVal === "" && Object(_this.state.searchFilters).keys && Object(_this.state.searchFilters).keys.length === 0) {
	          ////console.log("get data returning all");
	          if (_this.props.db[dTableName] && _this.props.db[dTableName] !== undefined) {
	            return _this.props.db[dTableName].slice(0, 300);
	          } else {
	            return _this.props.db[dTableName];
	          }
	        } else {
	          return (0, _searchRecords.searchRecords)(_this.props.db[dTableName], _this.state.searchVal, _this.state.tableDefs[dTableName].searches, _this.state.searchFilters, _this.state.searchDateFilters);
	        }
	      }
	    };
	
	    _this.doStateUpdateForSearch = function () {
	      _this.setState(function (prevState) {
	        return _extends({}, prevState, {
	          searchVal: _this.refs.searchText.value
	        });
	      });
	    };
	
	    _this.doDelaySearch = function () {
	      ////console.log("doning search...");
	      var q = _this.refs.searchText.value;
	      //this.stateChangeHandler("searchVal", q, false);
	      if (q.length < 5) {
	        _this.getDataThrottled();
	      } else {
	        _this.getDataDebounced();
	      }
	    };
	
	    _this.getSearchBar = function () {
	      return _react2.default.createElement("div", { className: "wrapzz" }, _react2.default.createElement("div", { className: "searchzz" }, _react2.default.createElement("input", {
	        type: "text",
	        className: "searchTermzz",
	        placeholder: "Search...",
	        ref: "searchText",
	        onKeyUp: function onKeyUp() {
	          return _this.doDelaySearch();
	        }
	      }), _react2.default.createElement("button", {
	        type: "submit",
	        className: "searchButtonzz",
	        onClick: function onClick() {
	          _this.setState(function (prevState) {
	            return _extends({}, prevState, {
	              searchVal: _this.refs.searchText.value
	            });
	          });
	          ////console.log("searchText " + this.refs.searchText.value);
	          ////console.log(JSON.stringify(this.state.searchVal));
	        }
	      }, _react2.default.createElement("i", { className: "fa fa-search" }))));
	    };
	
	    _this.getNewButton = function () {
	      if (_this.state.showGrid) {
	        return _react2.default.createElement(_reactackle.Button, {
	          colorScheme: "primary",
	          onPress: function onPress() {
	            return _this.handleAddNew();
	          },
	          text: "Add New"
	        });
	      }
	    };
	
	    _this.recordPoPaymentHandler = function () {};
	
	    _this.getPoPaymentButton = function () {
	      if (_this.state.showGrid && _this.state.tableName === "projectPos") {
	        return _react2.default.createElement("div", {
	          style: {
	            justifyContent: "center",
	            verticalAlign: "middle",
	            padding: "6px",
	            paddingTop: "12px",
	            borderWidth: "0.5px",
	            borderColor: "blue",
	            borderRadius: "2px",
	            backgroundColor: "#2196F3"
	          }
	        }, _react2.default.createElement("a", {
	          href: "javascript:void(0)",
	          "data-toggle": "modal",
	          "data-target": "#myModal",
	          style: {
	            font: "inherit",
	            cursor: "pointer",
	            userSelect: "none",
	            fontFamily: "Open Sans,Helvetica Neue,Helvetica,Roboto,Arial,sans-serif",
	            boxSizing: "border-box",
	            color: "white",
	            textAlign: "inherit",
	            fontSize: "inherit",
	            lineHeight: "1.25",
	            fontWeight: "600",
	            textTransform: "uppercase",
	            paddingTop: "12px"
	          }
	        }, "Add Payment Details"));
	      }
	    };
	
	    _this.getPivotButton = function () {
	      if (_this.state.showGrid && _this.state.tableName !== "reports" && !_reactDeviceDetect.isMobile) {
	        return _react2.default.createElement(_reactackle.Button, {
	          colorScheme: "primary",
	          onPress: function onPress() {
	            return _this.stateChangeHandler(!_this.state.showPivot, "showPivot", false);
	          },
	          text: _this.state.showPivot ? "Show Grid" : "Show Pivot"
	        });
	      }
	    };
	
	    _this.getFiltersList = function () {
	      var filtersList = [];
	      var tableObj = _this.props.createTable.find(function (item) {
	        return item.name === _this.state.tableName;
	      });
	
	      if (tableObj && tableObj !== undefined) {
	        if (tableObj.filters && tableObj.filters !== undefined) {
	          filtersList = tableObj.filters;
	        }
	      }
	
	      return filtersList;
	    };
	
	    _this.getFilterDropDowns = function () {
	      if (_this.state.showGrid) {
	        return _react2.default.createElement("div", null, _react2.default.createElement(_GridFilters2.default, {
	          path: _this.state.tableName,
	          stateHandler: _this.stateChangeHandler,
	          value: _this.state.searchFilters,
	          ogTableDef: _this.state.formDefs,
	          filtersList: _this.getFiltersList()
	        }), _react2.default.createElement(_GridDateFilters2.default, {
	          path: _this.state.tableName,
	          stateHandler: _this.stateChangeHandler,
	          value: _this.state.searchDateFilters,
	          ogTableDef: _this.state.formDefs,
	          filtersList: _this.getFiltersList()
	        }));
	      }
	    };
	
	    _this.getTotals = function () {
	      var totTables = ["projectInvoices", "projectPos"];
	
	      if (totTables.includes(_this.state.tableName)) {
	        var sumField = "";
	        if (_this.state.tableName === "projectInvoices") {
	          sumField = "totalInvoice";
	        } else if (_this.state.tableName === "projectPos") {
	          sumField = "poAmount";
	        }
	        if (sumField !== "") {
	          var filteredRecs = _this.getData();
	          var sum = filteredRecs.reduce(function (totValue, curr) {
	            return totValue + parseFloat(curr[sumField]);
	          }, 0);
	          var gstSum = sum * 1.07;
	          if (_reactDeviceDetect.isMobile) {
	            return _react2.default.createElement("table", { className: "table table-sm", style: { marginBottom: "0px" } }, _react2.default.createElement("tr", null, _react2.default.createElement("td", { style: { width: "50%", textAlign: "left" } }, "TOTAL:", " ", " " + (0, _numeral2.default)(sum.toFixed(2)).format("0,0.00") + "   "), _react2.default.createElement("td", { style: { width: "50%", textAlign: "right" } }, "TOTAL(W GST):", " ", " " + (0, _numeral2.default)(gstSum.toFixed(2)).format("0,0.00"))));
	          } else {
	            return _react2.default.createElement(_reactackle.CardActionsMain, null, _react2.default.createElement("div", {
	              className: "row",
	              style: {
	                marginLeft: "1px",
	                marginRight: "1px",
	                alignItems: "center",
	                padding: "2px",
	                border: "0px",
	                borderBottom: "0px",
	                borderBottomColor: "#cccccc",
	                borderStyle: "solid",
	                paddingBottom: _reactDeviceDetect.isMobile ? "0px" : "2px"
	              }
	            }, _react2.default.createElement("div", {
	              className: "col-sm-2",
	              style: {
	                textAlign: "right",
	                verticalAlign: "center",
	                border: "0px solid gainsboro",
	                width: "80px"
	              }
	            }, _react2.default.createElement("h5", null, "TOTAL")), _react2.default.createElement("div", {
	              className: "col-sm-2",
	              style: {
	                textAlign: "right",
	                verticalAlign: "center",
	                border: "1px solid gainsboro",
	                width: "120px"
	              }
	            }, _react2.default.createElement("h5", null, (0, _numeral2.default)(sum.toFixed(2)).format("0,0.00"))), _react2.default.createElement("div", {
	              className: "col-sm-2",
	              style: {
	                textAlign: "right",
	                verticalAlign: "center",
	                border: "0px solid gainsboro",
	                width: "140px"
	              }
	            }, _react2.default.createElement("h5", null, "TOTAL(W GST)")), _react2.default.createElement("div", {
	              className: "col-sm-2",
	              style: {
	                textAlign: "right",
	                verticalAlign: "center",
	                border: "1px solid gainsboro",
	                width: "120px"
	              }
	            }, _react2.default.createElement("h5", null, (0, _numeral2.default)(gstSum.toFixed(2)).format("0,0.00")))));
	          }
	        }
	      }
	    };
	
	    _this.getTopHeader = function () {
	      if (_reactDeviceDetect.isMobile) {} else {
	        return _react2.default.createElement("div", null, _react2.default.createElement(_reactackle.Card, null, _react2.default.createElement(_reactackle.CardAreaMain, null, _react2.default.createElement(_reactackle.CardContent, null, _react2.default.createElement("div", null, _react2.default.createElement("h1", null, (0, _getMenuList.getCaption)(_this.state.tableName, _this.props.listOfTables, _reactDeviceDetect.isMobile))), _this.getSearchBar(), _this.getFilterDropDowns()), _react2.default.createElement(_reactackle.CardActions, null, _react2.default.createElement(_reactackle.CardActionsSupplemental, null, _this.getNewButton(), _this.getPivotButton(), _this.getPoPaymentButton()), _this.getTotals()))));
	      }
	    };
	
	    _this.getNicerData = function () {
	      var baseData = _this.getData();
	      var tableDefHere = _this.state.tableDefs[_this.state.tableName];
	      var nicerData = baseData.map(function (item) {
	        var tmpObj = {};
	        for (var key in item) {
	          if (tableDefHere && tableDefHere[key] && tableDefHere[key].caption && item[key]) {
	            tmpObj[tableDefHere[key].caption] = item[key];
	          }
	        }
	        return tmpObj;
	      });
	
	      return nicerData;
	    };
	
	    _this.getCsvHeaders = function () {
	      var headerArray = [];
	      var tableDefHere = _this.state.tableDefs[_this.state.tableName];
	      for (var key in tableDefHere) {
	        var tmpObj = {};
	        if (tableDefHere && tableDefHere[key]) {
	          tmpObj["label"] = tableDefHere[key].caption;
	          tmpObj["key"] = key;
	          headerArray.push(tmpObj);
	        }
	      }
	      return headerArray;
	    };
	
	    _this.getGrid = function () {
	      if (_this.state.showGrid) {
	        if (_this.state.tableName !== "reports") {
	          return _react2.default.createElement(_ContentGridVanilla2.default, {
	            data: _this.getData(),
	            tableName: _this.state.tableName,
	            tableDef: _this.state.tableDefs[_this.state.tableName],
	            handleEdit: _this.handleEdit,
	            handleDelete: _this.handleDelete
	          });
	        } else {
	          return _react2.default.createElement(AdvDashboard, {
	            data: _this.getData(),
	            reportData: {
	              attendance: _this.props.db["attendance"],
	              projectPos: _this.props.db["projectPos"],
	              projectInvoices: _this.props.db["projectInvoices"]
	            },
	            tableName: "reports",
	            tableDef: _this.state.tableDefs["reports"],
	            handleEdit: _this.handleEdit,
	            handleDelete: _this.handleDelete
	          });
	        }
	      }
	    };
	
	    _this.getEnrichedString = function (ogString, searchObj) {
	      //console.log(ogString + JSON.stringify(searchObj));
	      var strArray = ogString.split(" ").map(function (word) {
	        //console.log(word + " = " + searchObj[word]);
	        if (searchObj[word] && searchObj[word] !== undefined) {
	          return searchObj[word];
	        } else {
	          return word;
	        }
	      });
	
	      return strArray.join(" ");
	    };
	
	    _this.genNotification = function (recPayload, opType) {
	      var usersList = [];
	      var updateText = undefined;
	      var createText = undefined;
	      var deleteText = undefined;
	      var tableObj = _this.props.createTable.find(function (item) {
	        return item.name === _this.state.tableName;
	      });
	
	      if (tableObj && tableObj !== undefined) {
	        usersList = tableObj.notifyUsers;
	        createText = tableObj.createNotifyText;
	        updateText = tableObj.updateNotifyText;
	        deleteText = tableObj.deleteNotifyText;
	
	        if (opType === "update" && updateText && updateText !== "" && updateText !== null) {
	          //console.log(" updateText: " + updateText + " opType: " + opType);
	          _this.props.onNotifyUsers(_this.getEnrichedString(updateText, recPayload), usersList);
	        } else if (opType === "delete" && deleteText && deleteText !== "" && deleteText !== null) {
	          //console.log(" deleteText: " + deleteText + " opType: " + opType);
	          _this.props.onNotifyUsers(_this.getEnrichedString(deleteText, recPayload), usersList);
	        } else if (opType === "create" && createText && createText !== "" && createText !== null) {
	          //console.log("createText: " + createText + " opType: " + opType);
	          _this.props.onNotifyUsers(_this.getEnrichedString(createText, recPayload), usersList);
	        }
	      }
	    };
	
	    _this.getSelectedPoCount = function () {
	      var poRecs = _this.getData();
	      if (poRecs && poRecs.length && poRecs.length > 0) {
	        return poRecs.length;
	      } else {
	        return 0;
	      }
	    };
	
	    _this.getInputField = function (fieldName, poDefs) {
	      return (0, _getInputField2.default)(fieldName, "projectPos", _this.state.data, _this.stateChangeHandler, false, poDefs, _this.props.db, _reactDeviceDetect.isMobile);
	    };
	
	    _this.getPOPaymentFields = function () {
	      var poDefs = (0, _extendedOgDef2.default)(_this.props.createTable);
	      if (poDefs && poDefs !== undefined && poDefs.projectPos) {
	        //console.log("~~~");
	        //console.log(JSON.stringify(poDefs.projectPos.paymentType));
	        //console.log("~~~: " + JSON.stringify(poDefs.projectPos.paymentType));
	        return _react2.default.createElement("div", null, _this.getInputField("paymentType", poDefs), _this.getInputField("supplierInvoice", poDefs), _this.getInputField("referenceNumber", poDefs), _this.getInputField("paymentDate", poDefs));
	      }
	    };
	
	    _this.getPoPaymentModal = function () {
	      return (
	        //<!-- Modal -->
	        _react2.default.createElement("div", { className: "modal fade", id: "myModal", role: "dialog" }, _react2.default.createElement("div", { className: "modal-dialog" }, _react2.default.createElement("div", { className: "modal-content" }, _react2.default.createElement("div", { className: "modal-header" }, _react2.default.createElement("button", { type: "button", "class": "close", "data-dismiss": "modal" }, "\xD7"), _react2.default.createElement("h4", { className: "modal-title" }, "BULK UPDATE FOR PURCHASE ORDERS")), _react2.default.createElement("div", { className: "modal-body" }, _react2.default.createElement("div", {
	          style: {
	            padding: "20px",
	            backgroundColor: "red",
	            color: "white",
	            fontWeight: "600",
	            marginBottom: "15px"
	          }
	        }, "Please perform this action with utmost care. Once in progress, the upload process cannot be stopped midway.", _react2.default.createElement("p", {
	          style: {
	            fontWeight: "bolder"
	          }
	        }, _this.getSelectedPoCount(), " POs selected for update")), _react2.default.createElement("p", null, "Please fill in following fields and click update"), _react2.default.createElement("div", null, _this.state.tableName === "projectPos" && _this.getPOPaymentFields())), _react2.default.createElement("div", { className: "modal-footer" }, _react2.default.createElement("button", {
	          type: "button",
	          "class": "btn btn-default",
	          onClick: function onClick() {
	            _this.runUpload();
	          }
	        }, "Update"), _react2.default.createElement("button", {
	          type: "button",
	          "class": "btn btn-default",
	          "data-dismiss": "modal"
	        }, "Cancel")))))
	      );
	    };
	
	    _this.runUpload = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	      var allPosFull, allPos, i, currPo;
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              if (!(Object.keys(_this.state.searchFilters).length === 0 && Object.keys(_this.state.searchDateFilters).length === 0 && _this.state.searchVal === "")) {
	                _context.next = 4;
	                break;
	              }
	
	              alert("Please apply some filter criteria before running payment updates");
	              _context.next = 28;
	              break;
	
	            case 4:
	              allPosFull = _this.getData();
	              allPos = _.cloneDeep(allPosFull);
	              i = 0;
	
	            case 7:
	              if (!(i < allPos.length)) {
	                _context.next = 27;
	                break;
	              }
	
	              _context.prev = 8;
	              currPo = allPos[i];
	
	              currPo["paymentType"] = _this.state.data.payload.paymentType;
	              currPo["supplierInvoice"] = _this.state.data.payload.supplierInvoice;
	              currPo["referenceNumber"] = _this.state.data.payload.referenceNumber;
	              currPo["paymentDate"] = _this.state.data.payload.paymentDate;
	              if (currPo.paymentDate === "") {
	                currPo.paymentDate = (0, _moment2.default)().format("DD-MM-YYYY").toString();
	              }
	
	              _context.next = 17;
	              return _this.dataUpdateHandler(currPo, "projectPos/" + currPo.key + "/", "poId");
	
	            case 17:
	              _context.next = 19;
	              return _this.sleep(1000);
	
	            case 19:
	              _context.next = 24;
	              break;
	
	            case 21:
	              _context.prev = 21;
	              _context.t0 = _context["catch"](8);
	
	              console.log("some error: " + _context.t0);
	
	            case 24:
	              i++;
	              _context.next = 7;
	              break;
	
	            case 27:
	              alert("Upload completed");
	
	            case 28:
	            case "end":
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2, [[8, 21]]);
	    }));
	
	    _this.getMainContent = function () {
	      return _react2.default.createElement(_reactackle.MainRegion, null, _this.props.currentUser && _this.props.users && (0, _getMenuList.getSideBar)(false, _this.isAdmin(), _this.switchMenu, _this.props.currUserRole, _this.props.userMenus), _react2.default.createElement(_reactackle.Content, null, _react2.default.createElement(_reactackle.Container, null, _this.state.showGrid && _this.state.showFilters && _this.getTopHeader(), _react2.default.createElement("div", {
	        style: {
	          overflow: "auto",
	          WebkitOverflowScrolling: "touch",
	          scrollBehavior: "smooth",
	          marginTop: "60px"
	        }
	      }, _this.state.showDash && _this.props.userProfile && _this.props.userProfile.userEmail === "ahmed_fayyaz@outlook.com" && _this.getDataUpdating(), _this.getGrid(), _this.state.showDash && _this.getDashView()), !_this.state.showGrid && !_this.state.showDash && _react2.default.createElement("div", {
	        style: {
	          marginTop: _reactDeviceDetect.isMobile ? "-20px" : "-58px"
	        }
	      }, (0, _getEditView2.default)(_this.state.tableName, _this.handleEditCancel, _this.handleDelete, _this.props.create, _this.genNotification))), _react2.default.createElement("div", {
	        style: {
	          minHeight: "500px"
	        }
	      })));
	    };
	
	    _this.sleep = function () {
	      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(milliseconds) {
	        var date, currentDate;
	        return regeneratorRuntime.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                date = Date.now();
	                currentDate = null;
	
	                do {
	                  currentDate = Date.now();
	                } while (currentDate - date < milliseconds);
	
	              case 3:
	              case "end":
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }));
	
	      return function (_x) {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	
	    _this.dataUpdateHandler = function () {
	      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(databucket, cloudPath, idField) {
	        return regeneratorRuntime.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                if (databucket && databucket.key && databucket.key !== "") {
	                  _this.props.firebase.db.ref("/" + cloudPath + "/" + databucket.key + "/").once("value").then(function (snap) {
	                    return snap.ref.set(databucket);
	                  }).catch(function (err) {
	                    console.log("some error: " + err);
	                  }).then(function (err) {
	                    //console.log("Updated Rec: " + databucket[idField]);
	                  });
	                }
	
	              //this.props.handleEditCancel();
	
	              case 1:
	              case "end":
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this2);
	      }));
	
	      return function (_x2, _x3, _x4) {
	        return _ref3.apply(this, arguments);
	      };
	    }();
	
	    _this.dataAddHandler = function () {
	      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(databucket, cloudPath, idField) {
	        var newInv, dbKey;
	        return regeneratorRuntime.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                if (databucket && databucket !== undefined) {
	                  newInv = _this.props.firebase.db.ref("/" + cloudPath).push();
	                  dbKey = newInv.key;
	
	                  newInv.set(databucket).catch(function (err) {
	                    console.log("some error: " + err);
	                  }).then(function (err) {});
	                }
	
	              //this.props.handleEditCancel();
	
	              case 1:
	              case "end":
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this2);
	      }));
	
	      return function (_x5, _x6, _x7) {
	        return _ref4.apply(this, arguments);
	      };
	    }();
	
	    _this.perfDelayUpdates = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
	      return regeneratorRuntime.wrap(function _callee5$(_context5) {
	        while (1) {
	          switch (_context5.prev = _context5.next) {
	            case 0:
	            case "end":
	              return _context5.stop();
	          }
	        }
	      }, _callee5, _this2);
	    }));
	
	    _this.getDataUpdating = function () {
	      // return (
	      //   <div
	      //     style={{
	      //       backgroundColor: "black",
	      //       height: "400px"
	      //     }}
	      //   >
	      //     <div
	      //       style={{
	      //         color: "white"
	      //       }}
	      //     >
	      //       Please do not click on this button
	      //       <div>
	      //         <Button
	      //           colorScheme="primary"
	      //           onPress={() => {
	      //             //this.props.onSetUiFlag("dataUploadButton", true);
	      //             //this.perfDelayUpdates();
	      //             console.log(JSON.stringify(this.props.deliveryRequest));
	      //           }}
	      //           text="Update Action"
	      //         />
	      //       </div>
	      //     </div>
	      //   </div>
	      // );
	    };
	
	    _this.getClients = function () {
	      var allOrders = _this.props.deliveryRequest;
	      if (allOrders && allOrders.length > 0) {
	        return allOrders.map(function (singOrder) {
	          return _react2.default.createElement("tr", null, _react2.default.createElement("td", null, singOrder.name), _react2.default.createElement("td", null, singOrder.author), _react2.default.createElement("td", null, singOrder.mobile), _react2.default.createElement("td", null, singOrder.address));
	        });
	      }
	    };
	
	    _this.state = {
	      data: {
	        path: "",
	        payload: {
	          paymentType: "",
	          supplierInvoice: "",
	          referenceNumber: "",
	          paymentDate: ""
	        }
	      },
	      message: "",
	      hasLoaded: false,
	      tableName: "bcsHome",
	      tableDefs: (0, _getDefs2.default)(_this.props.createTable),
	      searchVal: "",
	      showGrid: false,
	      showDash: true,
	      searchFilters: {},
	      searchDateFilters: {},
	      showFilters: true,
	      showPivot: false,
	      reRenderFlag: false,
	      formDefs: (0, _extendedOgDef2.default)(_this.props.createTable)
	    };
	    _this.getDataDebounced = (0, _throttleDebounce.debounce)(1000, _this.doStateUpdateForSearch);
	    _this.getDataThrottled = (0, _throttleDebounce.throttle)(1000, _this.doStateUpdateForSearch);
	    return _this;
	  }
	
	  _createClass(LandingPage, [{
	    key: "componentDidCatch",
	    value: function componentDidCatch(error, info) {
	      //handle the sending message to backend? store back to db? send notification?
	      console.log("Uncaught : " + error + " | " + info);
	      this.switchMenu("signout");
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.setState(function (prevState) {
	        return _extends({}, prevState, {
	          showFilters: !_reactDeviceDetect.isMobile
	        });
	      });
	
	      //console.log("adding scroll listner");
	      var scrollElement = window.document.querySelector(".content");
	      if (scrollElement && scrollElement !== undefined) {
	        scrollElement.addEventListener("scroll", this.handleScroll, false);
	      }
	
	      if (!this.props.userUid || this.props.userUid === undefined) {
	        console.log("pushing back");
	        _reactRouter.browserHistory.push("/login");
	      } else {
	        //console.log("~ this is admin? " + this.props.isAdmin);
	        var allTableDets = this.props.userMenus;
	        if (allTableDets && allTableDets.length > 0) {
	          for (var k = 0; k < allTableDets.length; k++) {
	            this.loadDataEx(allTableDets[k]);
	          }
	        }
	
	        // this.loadData("projects");
	        // this.loadData("reports");
	        // this.loadData("contacts");
	        // this.loadData("logistics");
	        // this.loadData("notices");
	        // this.loadData("projectDos");
	        // this.loadData("projectPos");
	        // this.loadData("projectQuotes");
	        // this.loadData("suppliers");
	        // this.loadData("tasks");
	        // this.loadData("attendance");
	        // this.props.isAdmin && this.loadData("projectInvoices");
	        this.props.isAdmin && this.loadData("projectInvoices", true);
	        // this.props.isAdmin && this.loadData("projectClaims");
	        // this.props.isAdmin && this.loadData("reports");
	
	        this.props.isAdmin && this.loadData("createFields");
	        this.props.isAdmin && this.loadData("listOfTables");
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      console.log("detaching scroll listner");
	      window.removeEventListener("scroll", this.handleScroll);
	    }
	
	    //single method that work for all fields
	    //takes incoming id of the field and then adds field data to state
	
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement("div", null, this.state.tableName === "projectPos" && this.getPoPaymentModal(), _reactDeviceDetect.isMobile && this.getTopMenu(), _react2.default.createElement("div", {
	        className: "content",
	        style: {
	          marginTop: _reactDeviceDetect.isMobile ? "50px" : "0px"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          minHeight: "50000px"
	        }
	      }, this.getMainContent(), _react2.default.createElement("table", null, _react2.default.createElement("thead", null, _react2.default.createElement("td", null, "NAME"), _react2.default.createElement("td", null, "AUTHOR"), _react2.default.createElement("td", null, "MOBILE"), _react2.default.createElement("td", null, "ADDRESS")), _react2.default.createElement("tbody", null, this.getClients())))));
	    }
	  }]);
	
	  return LandingPage;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    userProfile: state.db.userProfile,
	    userMenus: state.ui.userMenus,
	    users: state.db.users,
	    projects: state.db.projects,
	    attendance: state.db.attendance,
	    contacts: state.db.contacts,
	    logistics: state.db.logistics,
	    notices: state.db.notices,
	    projectInvoices: state.db.projectInvoices,
	    deletedprojectInvoices: state.db.deletedprojectInvoices,
	    projectClaims: state.db.projectClaims,
	    projectDos: state.db.projectDos,
	    projectPos: state.db.projectPos,
	    projectQuotes: state.db.projectQuotes,
	    reports: state.db.reports,
	    suppliers: state.db.suppliers,
	    tasks: state.db.tasks,
	    currentUser: state.db.userProfile,
	    isAdmin: state.ui.isThisAdmin,
	    isSuperAdmin: state.ui.isThisSuperAdmin,
	    userUid: state.ui.userUid,
	    currUserRole: state.ui.currUserRole,
	    createFields: state.db.createFields,
	    createTable: state.db.createTable,
	    testTable: state.db.testTable,
	    listOfTables: state.db.listOfTables,
	    menuDesigner: state.db.menuDesigner,
	    uploadButton: state.ui.dataUploadButton && state.ui.dataUploadButton !== undefined ? state.ui.dataUploadButton : false,
	    db: state.db,
	    listYPos: state.ui.listYPos
	  };
	}
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    onAddRecord: function onAddRecord(data) {
	      return dispatch((0, _actions.actionAddArray2Redux)(data));
	    },
	    onSelectRecord: function onSelectRecord(params) {
	      dispatch((0, _actions.selectARecord)(params));
	      dispatch((0, _actions.setUiFlag)("tableName", params.path));
	    },
	    onAddNew: function onAddNew(data) {
	      return dispatch((0, _actions.initSelectedRecord)(data));
	    },
	    loadStats: function loadStats(parsedRes) {
	      return dispatch((0, _actions.loadAllStats)(parsedRes));
	    },
	    onSetUiFlag: function onSetUiFlag(flagName, flagVal) {
	      return dispatch((0, _actions.setUiFlag)(flagName, flagVal));
	    },
	    onSignOut: function onSignOut() {
	      dispatch((0, _actions.resetRedux)());
	      dispatch((0, _actions.setUiFlag)("userMenus", []));
	    },
	    loadFbData: function loadFbData(tableName, firebase) {
	      return dispatch((0, _actions.loadFbData)(tableName, firebase));
	    },
	    onNotifyUsers: function onNotifyUsers(msgBody, arrayOfUsers) {
	      return dispatch((0, _actions.notifyUsers)(msgBody, arrayOfUsers));
	    },
	    onGetId: function onGetId(data) {
	      return dispatch((0, _actions.getId)(data));
	    },
	    onGetAcctStatement: function onGetAcctStatement(data) {
	      return dispatch((0, _actions.getAcctStatement)(data));
	    },
	    onGetAcctBalance: function onGetAcctBalance(data) {
	      return dispatch((0, _actions.getAcctBalance)(data));
	    }
	  };
	};
	
	exports.default = (0, _recompose.compose)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _Firebase.withFirebase)(LandingPage);

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _recompose = __webpack_require__(11);
	
	var _Firebase = __webpack_require__(10);
	
	var _addAudits = __webpack_require__(25);
	
	var _reactackle = __webpack_require__(5);
	
	var _reactDeviceDetect = __webpack_require__(6);
	
	var _checkBeforeSave = __webpack_require__(78);
	
	var _checkBeforeSave2 = _interopRequireDefault(_checkBeforeSave);
	
	var _getInputField = __webpack_require__(18);
	
	var _getInputField2 = _interopRequireDefault(_getInputField);
	
	var _actions = __webpack_require__(13);
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _terms = __webpack_require__(153);
	
	var _terms2 = _interopRequireDefault(_terms);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var OrderPad = function (_Component) {
	  _inherits(OrderPad, _Component);
	
	  function OrderPad() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, OrderPad);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = OrderPad.__proto__ || Object.getPrototypeOf(OrderPad)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      data: {
	        path: _this.props.path,
	        payload: _extends({}, _this.props.selectedRecord),
	        userEmail: _this.props.userProfile.userEmail
	      },
	      showForm: true,
	      allowedFields: ["mobile", "name", "address", "specialInstructions", "requestedItems"],
	      stage: "orderForm"
	    }, _this.stateChangeHandler = function (val, id, isPayload) {
	      //console.log("val: " + val + " id: " + id + " isPayload: " + isPayload);
	      var tmpState = {};
	      tmpState[id] = val;
	
	      if (isPayload) {
	        _this.setState(function (prevState) {
	          if (prevState && prevState.data.payload !== null) {
	            return _extends({}, prevState, {
	              data: _extends({}, prevState.data, {
	                payload: _extends({}, prevState.data.payload, tmpState)
	              })
	            });
	          } else {
	            return _extends({}, prevState, {
	              data: {
	                path: prevState.data.path,
	                payload: _extends({}, tmpState)
	              }
	            });
	          }
	        }, function () {
	          _this.procCalcFields(id);
	        });
	      } else {
	        _this.setState(function (prevState) {
	          return _extends({}, prevState, tmpState);
	        }, function () {
	          _this.procCalcFields(id);
	        });
	      }
	    }, _this.procCalcFields = function (id) {
	      //console.log("Checking ID: " + id);
	      var allFields = _this.props.ogTableDef[_this.props.path];
	      for (var key in allFields) {
	        var fldDef = allFields[key];
	        if (fldDef.type === "calculation" && id === fldDef.triggerField) {
	          //console.log("id matched: " + id + " " + JSON.stringify(fldDef));
	          if (fldDef.calcType === "subFieldsSum") {
	            if (fldDef.subFieldOperation === "SUM") {
	              _this.getSubGridSum(fldDef.name, fldDef.subGridName, fldDef.subGridField);
	            } else {}
	          } else if (fldDef.calcType === "mainFieldCalc") {
	            _this.getCalcdField(fldDef.name, fldDef.formula);
	          }
	        }
	      }
	    }, _this.getValue = function (stateVal, operand) {
	      var res = 0.0;
	      if (stateVal !== undefined) {
	        if (!isNaN(stateVal)) {
	          res = parseFloat(stateVal);
	        }
	      } else {
	        if (!isNaN(operand)) {
	          res = parseFloat(operand);
	        }
	      }
	      return res;
	    }, _this.getCalcdField = function (calcFieldName, calcRules) {
	      //console.log(calcFieldName + " " + JSON.stringify(calcRules));
	      var result = 0.0;
	
	      //currently only one rule will work
	      var currRule = calcRules[0];
	      if (currRule && currRule !== undefined) {
	        var val1 = _this.getValue(_this.state.data.payload[currRule.operand1], currRule.operand1);
	        var val2 = _this.getValue(_this.state.data.payload[currRule.operand2], currRule.operand2);
	        var op = currRule.operation;
	        if (op && !isNaN(val1) && !isNaN(val2)) {
	          if (op === "+") {
	            result = val1 + val2;
	          } else if (op === "-") {
	            result = val1 - val2;
	          } else if (op === "*") {
	            result = val1 * val2;
	          } else if (op === "/") {
	            result = val1 / val2;
	          }
	        }
	        // console.log(
	        //   "val1:" + val1 + " val2:" + val2 + " op:" + op + " result:" + result
	        // );
	        if (result !== undefined && !isNaN(result)) {
	          _this.stateChangeHandler(result.toFixed(2), calcFieldName, true);
	        }
	      }
	    }, _this.getSubGridSum = function (calcFieldName, subGridName, subFieldToProcess) {
	      var items = _this.state.data.payload[subGridName];
	
	      if (items && items !== undefined && items.length > 0) {
	        var invSum = items.reduce(function (sum, obj) {
	          //console.log(obj[subFieldToProcess]);
	          if (obj[subFieldToProcess] && !isNaN(obj[subFieldToProcess])) {
	            return sum + parseFloat(obj[subFieldToProcess]);
	          } else {
	            return sum;
	          }
	        }, 0);
	        invSum = invSum.toFixed(2);
	        _this.stateChangeHandler(invSum, calcFieldName, true);
	      }
	    }, _this.getField = function (fieldName, disabled) {
	      return (0, _getInputField2.default)(fieldName, _this.props.path, _this.state.data, _this.stateChangeHandler, disabled, _this.props.ogTableDef, _this.props.db);
	    }, _this.getFields = function () {
	      if (_this.props.ogTableDef[_this.props.path]) {
	        return Object.keys(_this.props.ogTableDef[_this.props.path]).map(function (fldKey) {
	          if (_this.state.allowedFields.includes(fldKey)) {
	            return _this.getField(fldKey);
	          }
	        });
	      } else {
	        console.log("chacha some problems");
	      }
	    }, _this.saveHandler = function (isCancellation) {
	      _this.stateChangeHandler(_this.props.cellPhone, "author", true);
	      _this.stateChangeHandler([], "supplierPrices", true);
	      if (isCancellation) {
	        _this.stateChangeHandler("CANCELLED", "status", true);
	      } else {
	        _this.stateChangeHandler("WITH GROCER FOR PRICE", "status", true);
	      }
	      _this.stateChangeHandler("ALL", "supplier", true);
	
	      var cloudPath = _this.props.path;
	
	      if (_this.state.data.payload && _this.state.data.payload.key && _this.state.data.payload.key !== "") {
	        cloudPath = _this.props.path + "/" + _this.state.data.payload.key;
	        Promise.all([(0, _addAudits.addAudit)(_this.stateChangeHandler, _this.props.firebase.auth.currentUser.phoneNumber)]).then(function (res) {
	          _this.props.firebase.db.ref("/" + cloudPath).once("value").then(function (snap) {
	            return snap.ref.set(_this.state.data.payload);
	          }).catch(function (err) {
	            console.log(err);
	            return console.log("some error: " + err);
	          }).then(function (err) {
	            var phArray = [];
	            phArray.push(_this.state.data.payload.mobile);
	            if (isCancellation) {
	              _this.props.onNotifyUsers("Your order has been cancelled. We would love to see you again. Please Kabir Hossain at 94562455 if you cancelled order due to any problems.", phArray);
	            } else {
	              _this.stateChangeHandler("showUpdateConfirmation", "stage", false);
	              _this.props.onNotifyUsers("Your order has been received, we try our best to deliver orders the same day else we deliver next day. We will notify you again once your order gets picked up.", phArray);
	              _this.props.onNotifyUsers("New order received. " + _this.state.data.payload.requestedItems, _this.getAllSuppliers());
	            }
	          });
	        });
	      } else {
	        Promise.all([(0, _addAudits.addAudit)(_this.stateChangeHandler, _this.props.firebase.auth.currentUser.phoneNumber)
	        //get new ID
	        ]).then(function (res) {
	          var newInv = _this.props.firebase.db.ref("/" + cloudPath).push();
	          newInv.set(_this.state.data.payload).catch(function (err) {
	            console.log(err);
	            return console.log("some error: " + err);
	          }).then(function (err) {
	            console.log("added a new record");
	            _this.stateChangeHandler("showConfirmation", "stage", false);
	            var phArray = [];
	            phArray.push(_this.state.data.payload.mobile);
	            _this.props.onNotifyUsers("Your order has been received, we try our best to deliver orders the same day else we deliver next day. We will notify you again once your order gets picked up.", phArray);
	            _this.props.onNotifyUsers("New order received. " + _this.state.data.payload.requestedItems, _this.getAllSuppliers());
	          });
	        });
	      }
	    }, _this.getAllSuppliers = function () {
	      var allSup = _.chain(_this.props.users).filter(function (item) {
	        return item.roleName === "STOREADMIN" || item.roleName === "SUPERADMIN";
	      }).pluck("userMobile").filter(function (item) {
	        return item !== "" && item !== null && typeof item === "string";
	      }).value();
	      allSup.push("94562455");
	      allSup.push("97861234");
	      return allSup;
	    }, _this.getLoader = function () {
	      return _react2.default.createElement(_reactackle.CardContent, null, _react2.default.createElement(_reactackle.CircleProgress, { indeterminate: true, subtitle: "Saving..." }));
	    }, _this.getTopHeader = function () {
	      return _react2.default.createElement("table", {
	        className: _reactDeviceDetect.isMobile ? "table table-striped table-bordered table-sm" : "table table-striped table-bordered table-lg"
	      }, _react2.default.createElement("tbody", null, _react2.default.createElement("tr", null, _react2.default.createElement("td", {
	        style: {
	          textAlign: "center",
	          padding: "5px"
	        }
	      }, _react2.default.createElement(_reactackle.Button, {
	        text: "SUBMIT ORDER",
	        onPress: function onPress() {
	          return _this.saveHandler();
	        } //this.getAllSuppliers()}
	        , colorScheme: "primary",
	        disabled: !_this.state.showForm || (0, _checkBeforeSave2.default)(_this.props.path, _this.state.data.payload, _this.props.ogTableDef)
	      })), _react2.default.createElement("td", {
	        style: {
	          textAlign: "center",
	          padding: "5px"
	        }
	      }, _react2.default.createElement(_reactackle.Button, {
	        text: "BACK TO MY ORDER LIST",
	        onPress: function onPress() {
	          return _this.props.backToList("orderlist");
	        },
	        colorScheme: "primary",
	        disabled: !_this.state.showForm
	      }))), _react2.default.createElement("tr", null, _this.props.operationType !== "add" && _react2.default.createElement("td", {
	        style: {
	          textAlign: "center",
	          padding: "5px"
	        },
	        colSpan: 2
	      }, _react2.default.createElement(_reactackle.Button, {
	        text: "CANCEL THIS ORDER",
	        onPress: function onPress(e) {
	          if (_this.state.data.payload.key && _this.state.data.payload.key !== "") {
	            window.confirm("Are you sure you wish to cancel this order?") && _this.cancelOder();
	          }
	        },
	        colorScheme: "warning",
	        disabled: !_this.state.showForm
	      })))));
	    }, _this.cancelOder = function () {
	      _this.saveHandler(true);
	      _this.stateChangeHandler("showCancellation", "stage", false);
	    }, _this.getOrderForm = function () {
	      return _react2.default.createElement("div", {
	        style: {
	          WebkitOverflowScrolling: "auto",
	          height: "100%"
	        }
	      }, _reactDeviceDetect.isMobile && _react2.default.createElement("div", { style: { paddingTop: "5px", zIndex: -1 } }, _react2.default.createElement("lu", null, _react2.default.createElement("li", {
	        style: {
	          fontSize: "16px",
	          display: "block",
	          backgroundColor: "white",
	          margin: "2px",
	          padding: "5px"
	        }
	      }, _react2.default.createElement("div", null, "Carefully complete below fields."), _react2.default.createElement("div", null, "Fields marked with * are compulsory."), _react2.default.createElement("div", null, "Press Submit after filling form."))), _this.state.showForm && _this.state.proceedForward && _this.getField("mobile"), _this.state.showForm && _this.state.proceedForward && _this.getField("name"), _this.state.showForm && _this.state.proceedForward && _this.getField("address"), _this.state.showForm && _this.state.proceedForward && _this.getField("specialInstructions"), _this.state.showForm && _this.state.proceedForward && _react2.default.createElement("div", {
	        style: {
	          marginLeft: "0px",
	          textAlign: "center",
	          marginBottom: "-10px",
	          marginTop: "10px"
	        }
	      }, _react2.default.createElement(_reactackle.Button, {
	        colorScheme: "flat",
	        onPress: function onPress() {
	          //this.props.onSetUiFlag("dataUploadButton", true);
	          //this.perfDelayUpdates();
	          if (_this.state.tgtOrder && _this.state.tgtOrder !== undefined && _this.state.tgtOrder.requestedItems && _this.state.tgtOrder.requestedItems !== "") {
	            _this.setState(function (prevState) {
	              return _extends({}, prevState, {
	                data: _extends({}, prevState.data, {
	                  payload: _extends({}, prevState.data.payload, {
	                    requestedItems: prevState.tgtOrder.requestedItems
	                  })
	                })
	              });
	            });
	          }
	        },
	        text: "Copy from Previous Order",
	        disabled: false
	      })), _this.state.showForm && _this.state.proceedForward && _this.getField("requestedItems"), !_this.state.proceedForward && _react2.default.createElement("h1", null, "YOUR CELL NUMBER IS REQUIRED TO PROCEED"), !_this.state.showForm && _this.getLoader(), (0, _terms2.default)()), !_reactDeviceDetect.isMobile && _react2.default.createElement("div", null, _react2.default.createElement(_reactackle.Card, null, _react2.default.createElement(_reactackle.CardAreaMain, null, _react2.default.createElement(_reactackle.CardContent, { style: { pading: "0px" } }, _react2.default.createElement("div", { style: { fontSize: "15px", color: "grey" } }, "Carefully complete below fields and tap on SUBMIT button. Fields marked with * are compulsory."), _this.state.showForm && _this.state.proceedForward && _this.getFields(), !_this.state.showForm && _this.getLoader(), (0, _terms2.default)())))));
	    }, _this.getOrderConformation = function () {
	      window.scroll(0, 0);
	      return _react2.default.createElement("div", {
	        style: {
	          fontSize: "15px",
	          fontWeight: "bold",
	          textAlign: "center",
	          marginTop: "20px"
	        }
	      }, _react2.default.createElement("div", null, "You order is successfuly submitted"), _react2.default.createElement("div", {
	        style: {
	          marginTop: "10px"
	        }
	      }, _react2.default.createElement(_reactackle.Button, {
	        text: "VIEW YOUR ORDERS",
	        onPress: function onPress() {
	          return _this.props.backToList("orderlist");
	        },
	        colorScheme: "primary",
	        disabled: !_this.state.showForm
	      }), (0, _terms2.default)()));
	    }, _this.getOrderUpdateConfirmation = function () {
	      window.scroll(0, 0);
	      return _react2.default.createElement("div", {
	        style: {
	          fontSize: "20px",
	          fontWeight: "bold",
	          textAlign: "center",
	          marginTop: "20px"
	        }
	      }, _react2.default.createElement("div", null, "You order is successfuly updated and submitted"), _react2.default.createElement("div", {
	        style: {
	          marginTop: "10px"
	        }
	      }, _react2.default.createElement(_reactackle.Button, {
	        text: "VIEW YOUR ORDERS",
	        onPress: function onPress() {
	          return _this.props.backToList("orderlist");
	        },
	        colorScheme: "primary",
	        disabled: !_this.state.showForm
	      }), (0, _terms2.default)()));
	    }, _this.getOrderCancellation = function () {
	      window.scroll(0, 0);
	      return _react2.default.createElement("div", {
	        style: {
	          fontSize: "20px",
	          fontWeight: "bold",
	          textAlign: "center",
	          marginTop: "20px"
	        }
	      }, _react2.default.createElement("div", null, "You order has been CANCELLED"), _react2.default.createElement("div", {
	        style: {
	          marginTop: "10px"
	        }
	      }, _react2.default.createElement(_reactackle.Button, {
	        text: "VIEW YOUR ORDERS",
	        onPress: function onPress() {
	          return _this.props.backToList("orderlist");
	        },
	        colorScheme: "primary",
	        disabled: !_this.state.showForm
	      })));
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(OrderPad, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var todaysDate = (0, _moment2.default)().format("DD-MM-YYYY").toString();
	      var targetDate = todaysDate;
	
	      var tgtOrder = {
	        name: "",
	        address: ""
	      };
	      if (this.props.createNewRec) {
	        if (this.props.orders && this.props.orders.length > 0) {
	          var myOrders = this.props.orders.filter(function (singOrder) {
	            //console.log(singOrder.mobile + " vs " + this.props.cellPhone);
	            return singOrder.mobile === _this2.props.cellPhone;
	          });
	          if (myOrders && myOrders.length > 0) {
	            //console.log(JSON.stringify(myOrders));
	            tgtOrder = myOrders[myOrders.length - 1];
	
	            this.setState(function (prevState) {
	              return _extends({}, prevState, {
	                data: _extends({}, prevState.data, {
	                  payload: _extends({}, prevState.data.payload, {
	                    name: tgtOrder.name,
	                    address: tgtOrder.address,
	                    deliveryDate: targetDate
	                  })
	                }),
	                tgtOrder: tgtOrder
	              });
	            });
	          }
	        } else {
	          console.log("orders not found");
	        }
	      } else {
	        //console.log("its not even a new rec" + this.props.operationType);
	      }
	      if (!this.props.cellPhone || this.props.cellPhone === "") {
	        var cellPhone = prompt("Please enter your cell phone to continue");
	
	        if (cellPhone && cellPhone !== undefined && cellPhone !== "") {
	          this.props.onSetUiFlag("cellPhone", cellPhone);
	          //console.log("allOrders length: " + JSON.stringify(this.props.db));
	
	          this.setState(function (prevState) {
	            return _extends({}, prevState, {
	              data: _extends({}, prevState.data, {
	                payload: _extends({}, prevState.data.payload, {
	                  mobile: cellPhone,
	                  deliveryDate: targetDate
	                })
	              }),
	              proceedForward: true
	            });
	          });
	        } else {
	          this.setState(function (prevState) {
	            return _extends({}, prevState, {
	              cellPhone: cellPhone,
	              proceedForward: false
	            });
	          });
	        }
	      } else {
	        this.setState(function (prevState) {
	          return _extends({}, prevState, {
	            data: _extends({}, prevState.data, {
	              payload: _extends({}, prevState.data.payload, {
	                mobile: _this2.props.cellPhone,
	                deliveryDate: targetDate
	              })
	            }),
	            proceedForward: true
	          });
	        });
	      }
	    }
	
	    //single method that work for all fields
	    //takes incoming id of the field and then adds field data to state
	
	
	    /*
	    -webkit-tap-highlight-color: rgba(0,0,0,0);
	    font-size: 14px;
	    line-height: 1.42857143;
	    color: #333;
	    box-sizing: border-box;
	    font-family: "RobotMedium";
	    position: fixed;
	    top: 60px;
	    width: 95%;
	    align-self: center;
	    z-index: 99999;
	    -webkit-tap-highlight-color: rgba(0,0,0,0);
	    font-size: 14px;
	    line-height: 1.42857143;
	    color: #333;
	    box-sizing: border-box;
	    font-family: "RobotMedium";
	    z-index: -1;
	    margin-top: 60px;
	      */
	
	    //f2f4f6
	
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement("div", null, this.state.stage === "orderForm" && _react2.default.createElement("div", null, this.getTopHeader()), this.state.stage === "orderForm" && this.getOrderForm(), this.state.stage === "showConfirmation" && this.getOrderConformation(), this.state.stage === "showUpdateConfirmation" && this.getOrderUpdateConfirmation(), this.state.stage === "showCancellation" && this.getOrderCancellation());
	    }
	  }]);
	
	  return OrderPad;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    userEmail: state.db.currentUser.userEmail,
	    currUser: state.db.currentUser,
	    isSuperAdmin: state.ui.isThisSuperAdmin,
	    isAdmin: state.ui.isThisAdmin,
	    userProfile: state.db.userProfile,
	    selectedRecord: state.db["selected" + state.ui.tableName],
	    db: state.db,
	    createNewRec: state.ui.operationType === "add",
	    operationType: state.ui.operationType,
	    orders: state.db.deliveryRequest,
	    users: state.db.users
	  };
	}
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    onAddRecord: function onAddRecord(data) {
	      return dispatch((0, _actions.actionAddArray2Redux)(data));
	    },
	    onSelectRecord: function onSelectRecord(params) {
	      return dispatch((0, _actions.selectARecord)(params));
	    },
	    onSetUiFlag: function onSetUiFlag(flagName, flagVal) {
	      return dispatch((0, _actions.setUiFlag)(flagName, flagVal));
	    },
	    onNotifyUsers: function onNotifyUsers(msgBody, arrayOfUsers) {
	      return dispatch((0, _actions.notifyUsers)(msgBody, arrayOfUsers));
	    }
	  };
	};
	
	exports.default = (0, _recompose.compose)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _Firebase.withFirebase)(OrderPad);

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	};
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _recompose = __webpack_require__(11);
	
	var _Firebase = __webpack_require__(10);
	
	var _addAudits = __webpack_require__(25);
	
	var _reactackle = __webpack_require__(5);
	
	var _reactDeviceDetect = __webpack_require__(6);
	
	var _checkBeforeSave = __webpack_require__(78);
	
	var _checkBeforeSave2 = _interopRequireDefault(_checkBeforeSave);
	
	var _getInputField = __webpack_require__(18);
	
	var _getInputField2 = _interopRequireDefault(_getInputField);
	
	var _actions = __webpack_require__(13);
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _terms = __webpack_require__(153);
	
	var _terms2 = _interopRequireDefault(_terms);
	
	var _numeral = __webpack_require__(16);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var _reactLazyLoadImageComponent = __webpack_require__(30);
	
	__webpack_require__(67);
	
	var _backupImage = __webpack_require__(149);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof2(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var OrderPadDirectSupplier = function (_Component) {
	  _inherits(OrderPadDirectSupplier, _Component);
	
	  function OrderPadDirectSupplier() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, OrderPadDirectSupplier);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = OrderPadDirectSupplier.__proto__ || Object.getPrototypeOf(OrderPadDirectSupplier)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      data: {
	        path: _this.props.path,
	        payload: _extends({}, _this.props.selectedRecord),
	        userEmail: _this.props.userProfile && _this.props.userProfile.userEmail ? _this.props.userProfile.userEmail : ""
	      },
	      showForm: true,
	      allowedFields: ["mobile", "name", "address", "specialInstructions", "requestedItems"],
	      stage: "orderForm"
	    }, _this.stateChangeHandler = function (val, id, isPayload) {
	      //console.log("val: " + val + " id: " + id + " isPayload: " + isPayload);
	      var tmpState = {};
	      tmpState[id] = val;
	
	      if (isPayload) {
	        _this.setState(function (prevState) {
	          if (prevState && prevState.data.payload !== null) {
	            return _extends({}, prevState, {
	              data: _extends({}, prevState.data, {
	                payload: _extends({}, prevState.data.payload, tmpState)
	              })
	            });
	          } else {
	            return _extends({}, prevState, {
	              data: {
	                path: prevState.data.path,
	                payload: _extends({}, tmpState)
	              }
	            });
	          }
	        }, function () {
	          _this.procCalcFields(id);
	        });
	      } else {
	        _this.setState(function (prevState) {
	          return _extends({}, prevState, tmpState);
	        }, function () {
	          _this.procCalcFields(id);
	        });
	      }
	    }, _this.procCalcFields = function (id) {
	      //console.log("Checking ID: " + id);
	      var allFields = _this.props.ogTableDef[_this.props.path];
	      for (var key in allFields) {
	        var fldDef = allFields[key];
	        if (fldDef.type === "calculation" && id === fldDef.triggerField) {
	          //console.log("id matched: " + id + " " + JSON.stringify(fldDef));
	          if (fldDef.calcType === "subFieldsSum") {
	            if (fldDef.subFieldOperation === "SUM") {
	              _this.getSubGridSum(fldDef.name, fldDef.subGridName, fldDef.subGridField);
	            } else {}
	          } else if (fldDef.calcType === "mainFieldCalc") {
	            _this.getCalcdField(fldDef.name, fldDef.formula);
	          }
	        }
	      }
	    }, _this.getValue = function (stateVal, operand) {
	      var res = 0.0;
	      if (stateVal !== undefined) {
	        if (!isNaN(stateVal)) {
	          res = parseFloat(stateVal);
	        }
	      } else {
	        if (!isNaN(operand)) {
	          res = parseFloat(operand);
	        }
	      }
	      return res;
	    }, _this.getCalcdField = function (calcFieldName, calcRules) {
	      //console.log(calcFieldName + " " + JSON.stringify(calcRules));
	      var result = 0.0;
	
	      //currently only one rule will work
	      var currRule = calcRules[0];
	      if (currRule && currRule !== undefined) {
	        var val1 = _this.getValue(_this.state.data.payload[currRule.operand1], currRule.operand1);
	        var val2 = _this.getValue(_this.state.data.payload[currRule.operand2], currRule.operand2);
	        var op = currRule.operation;
	        if (op && !isNaN(val1) && !isNaN(val2)) {
	          if (op === "+") {
	            result = val1 + val2;
	          } else if (op === "-") {
	            result = val1 - val2;
	          } else if (op === "*") {
	            result = val1 * val2;
	          } else if (op === "/") {
	            result = val1 / val2;
	          }
	        }
	        // console.log(
	        //   "val1:" + val1 + " val2:" + val2 + " op:" + op + " result:" + result
	        // );
	        if (result !== undefined && !isNaN(result)) {
	          _this.stateChangeHandler(result.toFixed(2), calcFieldName, true);
	        }
	      }
	    }, _this.getSubGridSum = function (calcFieldName, subGridName, subFieldToProcess) {
	      var items = _this.state.data.payload[subGridName];
	
	      if (items && items !== undefined && items.length > 0) {
	        var invSum = items.reduce(function (sum, obj) {
	          //console.log(obj[subFieldToProcess]);
	          if (obj[subFieldToProcess] && !isNaN(obj[subFieldToProcess])) {
	            return sum + parseFloat(obj[subFieldToProcess]);
	          } else {
	            return sum;
	          }
	        }, 0);
	        invSum = invSum.toFixed(2);
	        _this.stateChangeHandler(invSum, calcFieldName, true);
	      }
	    }, _this.getField = function (fieldName, disabled) {
	      return (0, _getInputField2.default)(fieldName, _this.props.path, _this.state.data, _this.stateChangeHandler, disabled, _this.props.ogTableDef, _this.props.db);
	    }, _this.getFields = function () {
	      if (_this.props.ogTableDef[_this.props.path]) {
	        return Object.keys(_this.props.ogTableDef[_this.props.path]).map(function (fldKey) {
	          if (_this.state.allowedFields.includes(fldKey)) {
	            return _this.getField(fldKey);
	          }
	        });
	      } else {
	        console.log("chacha some problems");
	      }
	    }, _this.getTotal = function (currBucket) {
	      //console.log("calcing total again: " + JSON.stringify(currBucket));
	      if (currBucket && currBucket.length > 0 && currBucket !== "" && (typeof currBucket === "undefined" ? "undefined" : _typeof(currBucket)) === "object") {
	        try {
	          var totAmt = currBucket.reduce(function (sum, item) {
	            sum = sum + parseFloat(item.amount.replace(/,/g, ""));
	            return parseFloat(sum);
	          }, 0);
	
	          return totAmt.toFixed(2);
	        } catch (err) {
	          return 0;
	        }
	      }
	    }, _this.saveHandler = function (isCancellation) {
	      _this.stateChangeHandler(_this.getTotal(_this.state.data.payload.requestedItems, "orderTotal", true));
	      if (_this.state.data.payload.name === "" || _this.state.data.payload.name === undefined || _this.state.data.payload.address === undefined || _this.state.data.payload.address === "") {
	        alert("Please enter both Name and Address before placing the order.");
	        return "";
	      }
	      if (_this.props.db["bucket"] && _this.props.db["bucket"].length > 0) {
	        _this.stateChangeHandler(_this.props.cellPhone, "author", true);
	        _this.stateChangeHandler([], "supplierPrices", true);
	        if (isCancellation) {
	          _this.stateChangeHandler("CANCELLED", "status", true);
	        } else {
	          _this.stateChangeHandler("WITH GROCER FOR PRICE", "status", true);
	        }
	
	        var oItems = _.cloneDeep(_this.props.db["bucket"]);
	        _this.stateChangeHandler(oItems, "requestedItems", true);
	        var prod1 = _this.props.db["bucket"][0];
	
	        // rec.status = "PICKED BY SUPPLIER";
	        //   rec.supplierContactName = supplierContactName;
	        //   rec.supplierCellPhone = supplierCellPhone;
	
	        _this.stateChangeHandler(prod1.productSupplier, "supplier", true);
	        _this.stateChangeHandler(prod1.supplierContactName, "supplierContactName", true);
	        _this.stateChangeHandler(prod1.supplierContactPhone, "supplierCellPhone", true);
	
	        var todaysTime = (0, _moment2.default)().format("h:mm a").toString();
	
	        var todaysDate = (0, _moment2.default)().format("DD-MM-YYYY").toString();
	
	        var cloudPath = _this.props.path;
	
	        if (_this.state.data.payload && _this.state.data.payload.key && _this.state.data.payload.key !== "") {
	          cloudPath = _this.props.path + "/" + _this.state.data.payload.key;
	          Promise.all([(0, _addAudits.addAudit)(_this.stateChangeHandler, _this.props.firebase.auth.currentUser.phoneNumber, false)]).then(function (res) {
	            _this.props.firebase.db.ref("/" + cloudPath).once("value").then(function (snap) {
	              return snap.ref.set(_this.state.data.payload);
	            }).catch(function (err) {
	              console.log(err);
	              return console.log("some error: " + err);
	            }).then(function (err) {
	              //clear the bucket
	              _this.props.firebase.db.ref("/myOrders" + "/" + _this.props.cellPhone + "/" + _this.state.data.payload.key).once("value").then(function (snap) {
	                return snap.ref.set(_this.state.data.payload);
	              }).catch(function (err) {
	                console.log(err);
	                return console.log("some error: " + err);
	              }).then(function (err) {
	                console.log("Updated: " + err);
	              });
	              _this.props.onAddArray({
	                path: "bucket",
	                payload: []
	              });
	              //sending notifications
	              var phArray = [];
	              phArray.push(_this.state.data.payload.mobile);
	              if (isCancellation) {
	                _this.props.onNotifyUsers("Your order has been cancelled. We would love to see you again. Please Kabir Hossain at 94562455 if you cancelled order due to any problems.", phArray);
	              } else {
	                _this.stateChangeHandler("showUpdateConfirmation", "stage", false);
	                _this.props.onSetUiFlag("orderStage", "showUpdateConfirmation");
	
	                var userNotifyText = "Your order has been updated, we try our best to deliver orders the same day else we deliver next day. We will notify you again once your order gets picked up.";
	
	                _this.props.onNotifyUsers(userNotifyText, phArray);
	
	                var totAmt = _this.state.data.payload.requestedItems.reduce(function (sum, item) {
	                  sum = sum + parseFloat(item.amount.replace(/,/g, ""));
	                  return parseFloat(sum);
	                }, 0);
	
	                totAmt = totAmt.toFixed(2);
	
	                var suppNotifyText = _this.state.data.payload.name + " " + _this.state.data.payload.mobile + " updated $" + totAmt + " " + _this.state.data.payload.targetDeliveryDate;
	
	                _this.props.onNotifyUsers(suppNotifyText, _this.getAllSuppliers());
	              }
	            });
	          });
	        } else {
	          Promise.all([(0, _addAudits.addAudit)(_this.stateChangeHandler, _this.props.firebase.auth.currentUser.phoneNumber, true)
	          //get new ID
	          ]).then(function (res) {
	            _this.stateChangeHandler(todaysTime, "orderTime", true);
	            _this.stateChangeHandler(todaysDate, "deliveryDate", true);
	            var newInv = _this.props.firebase.db.ref("/" + cloudPath).push();
	            newInv.set(_this.state.data.payload).catch(function (err) {
	              console.log(err);
	              return console.log("some error: " + err);
	            }).then(function (err) {
	              //clear the bucket
	              _this.props.firebase.db.ref("/myOrders" + "/" + _this.props.cellPhone + "/" + newInv.key).once("value").then(function (snap) {
	                return snap.ref.set(_this.state.data.payload);
	              }).catch(function (err) {
	                console.log(err);
	                return console.log("some error: " + err);
	              }).then(function (err) {
	                console.log("updated");
	              });
	              _this.props.onAddArray({
	                path: "bucket",
	                payload: []
	              });
	              //sending notifications
	              _this.stateChangeHandler("showConfirmation", "stage", false);
	              _this.props.onSetUiFlag("orderStage", "showConfirmation");
	              var phArray = [];
	              phArray.push(_this.state.data.payload.mobile);
	              _this.props.onNotifyUsers("Your order has been received, we try our best to deliver orders the same day else we deliver next day. We will notify you again once your order gets picked up.", phArray);
	              var totAmt = _this.state.data.payload.requestedItems.reduce(function (sum, item) {
	                var thisAmt = parseFloat(item.amount.replace(/,/g, ""));
	                if (thisAmt === "NaN") {
	                  thisAmt = 0;
	                }
	                sum = sum + thisAmt;
	                return parseFloat(sum);
	              }, 0);
	              totAmt = totAmt.toFixed(2);
	              console.log("totAmt: " + totAmt);
	              _this.props.onNotifyUsers(_this.state.data.payload.name + " " + _this.state.data.payload.mobile + " $" + totAmt + " " + _this.state.data.payload.targetDeliveryDate, _this.getAllSuppliers());
	            });
	          });
	        }
	      } else {
	        console.log("no items");
	      }
	    }, _this.getAllSuppliers = function () {
	      var allSup = _.chain(_this.props.users).filter(function (item) {
	        return item.roleName === "STOREADMIN";
	      }).pluck("userMobile").filter(function (item) {
	        return item !== "" && item !== null && typeof item === "string";
	      }).value();
	      return allSup;
	    }, _this.getLoader = function () {
	      return _react2.default.createElement(_reactackle.CardContent, null, _react2.default.createElement(_reactackle.CircleProgress, { indeterminate: true, subtitle: "Saving..." }));
	    }, _this.getTopHeader = function () {
	      return _react2.default.createElement("table", {
	        className: _reactDeviceDetect.isMobile ? "table table-striped table-bordered table-sm" : "table table-striped table-bordered table-lg"
	      }, _react2.default.createElement("tbody", null, _react2.default.createElement("tr", null, _react2.default.createElement("td", {
	        style: {
	          textAlign: "center",
	          padding: "5px"
	        }
	      }, _react2.default.createElement(_reactackle.Button, {
	        text: "SUBMIT ORDER",
	        onPress: function onPress() {
	          return _this.saveHandler();
	        } //this.getAllSuppliers()}
	        , colorScheme: "primary",
	        disabled: !_this.state.showForm || (0, _checkBeforeSave2.default)(_this.props.path, _this.state.data.payload, _this.props.ogTableDef)
	      })), _react2.default.createElement("td", {
	        style: {
	          textAlign: "center",
	          padding: "5px"
	        }
	      }, _react2.default.createElement(_reactackle.Button, {
	        text: "BACK TO SHOP",
	        onPress: function onPress() {
	          return _this.props.backToList("shopFromASupplier", "supplierShopItems");
	        },
	        colorScheme: "primary",
	        disabled: !_this.state.showForm
	      }))), _react2.default.createElement("tr", null, _this.props.operationType !== "add" && _react2.default.createElement("td", {
	        style: {
	          textAlign: "center",
	          padding: "5px"
	        },
	        colSpan: 2
	      }, _react2.default.createElement(_reactackle.Button, {
	        text: "CANCEL THIS ORDER",
	        onPress: function onPress(e) {
	          if (_this.state.data.payload.key && _this.state.data.payload.key !== "") {
	            window.confirm("Are you sure you wish to cancel this order?") && _this.cancelOder();
	          }
	        },
	        colorScheme: "warning",
	        disabled: !_this.state.showForm
	      })))));
	    }, _this.cancelOder = function () {
	      _this.saveHandler(true);
	      _this.stateChangeHandler("showCancellation", "stage", false);
	      _this.props.onSetUiFlag("orderStage", "showCancellation");
	    }, _this.getOrderForm = function () {
	      return _react2.default.createElement("div", {
	        style: {
	          WebkitOverflowScrolling: "auto",
	          height: "100%"
	        }
	      }, _react2.default.createElement("div", { style: { paddingTop: "5px" } }, _react2.default.createElement("div", {
	        style: {
	          margin: "5px"
	        }
	      }, _this.state.showForm && _this.state.proceedForward && _react2.default.createElement("div", {
	        style: {
	          padding: "1px",
	          textAlign: "right",
	          border: "1px solid gainsboro",
	          borderRadius: _reactDeviceDetect.isMobile ? "5px" : "0px",
	          backgroundColor: "white",
	          zIndex: "-9"
	        }
	      }, _react2.default.createElement(_reactackle.TextField, {
	        value: _this.state.data.payload["name"],
	        onChange: function onChange(e) {
	          _this.stateChangeHandler(e.value, "name", true);
	        },
	        fullWidth: true,
	        placeholder: "ENTER YOUR NAME"
	      })), _this.state.showForm && _this.state.proceedForward && _react2.default.createElement("div", {
	        style: {
	          padding: "1px",
	          textAlign: "right",
	          border: "1px solid gainsboro",
	          borderRadius: _reactDeviceDetect.isMobile ? "5px" : "0px",
	          backgroundColor: "white",
	          zIndex: "-9"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          display: "flex",
	          direction: "row",
	          alignItems: "center"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          fontSize: "14px",
	          border: "0px solid black",
	          cursor: "pointer",
	          width: "200px",
	          height: "30px",
	          lineHeight: "30px",
	          textAlign: "left",
	          margin: "5px",
	          marginLeft: "15px",
	          marginRight: "15px"
	        },
	        onClick: function onClick() {}
	      }, "Delivery Date"), _react2.default.createElement("div", {
	        style: {
	          borderRadius: "5px",
	          color: "#fff",
	          backgroundColor: "rgb(30, 101, 144)",
	          fontSize: "1.5em",
	          border: "0px solid black",
	          cursor: "pointer",
	          fontWeight: "bold",
	          width: "60px",
	          height: "30px",
	          lineHeight: "30px",
	          textAlign: "center",
	          margin: "5px",
	          marginLeft: "15px"
	        },
	        onClick: function onClick() {
	          var currTgtDate = (0, _moment2.default)(_this.state.data.payload.targetDeliveryDate, "ddd DD-MM-YYYY");
	          var newDate = currTgtDate.subtract(1, "day");
	          var minDate = (0, _moment2.default)();
	          if (newDate.isAfter(minDate)) {
	            _this.stateChangeHandler(newDate.format("ddd DD-MM-YYYY").toString(), "targetDeliveryDate", true);
	          } else {
	            _this.stateChangeHandler(minDate.add(1, "day").format("ddd DD-MM-YYYY").toString(), "targetDeliveryDate", true);
	          }
	        }
	      }, "<"), _react2.default.createElement("div", {
	        style: {
	          width: "100%",
	          lineHeight: "45px",
	          textAlign: "center"
	        }
	      }, _this.state.data.payload["targetDeliveryDate"]), _react2.default.createElement("div", {
	        style: {
	          borderRadius: "5px",
	          color: "#fff",
	          backgroundColor: "rgb(30, 101, 144)",
	          fontSize: "1.5em",
	          border: "0px solid black",
	          cursor: "pointer",
	          fontWeight: "bold",
	          width: "60px",
	          height: "30px",
	          lineHeight: "30px",
	          textAlign: "center",
	          margin: "5px",
	          marginRight: "15px"
	        },
	        onClick: function onClick() {
	          var currTgtDate = (0, _moment2.default)(_this.state.data.payload.targetDeliveryDate, "ddd DD-MM-YYYY");
	          var newDate = currTgtDate.add(1, "day");
	          var minDate = (0, _moment2.default)();
	          if (newDate.isAfter(minDate)) {
	            _this.stateChangeHandler(newDate.format("ddd DD-MM-YYYY").toString(), "targetDeliveryDate", true);
	          } else {
	            _this.stateChangeHandler(minDate.add(1, "day").format("ddd DD-MM-YYYY").toString(), "targetDeliveryDate", true);
	          }
	        }
	      }, ">"))), _this.state.showForm && _this.state.proceedForward && _react2.default.createElement("div", {
	        style: {
	          padding: "1px",
	          textAlign: "right",
	          border: "1px solid gainsboro",
	          borderRadius: _reactDeviceDetect.isMobile ? "5px" : "0px",
	          backgroundColor: "white",
	          zIndex: "-9"
	        }
	      }, _react2.default.createElement(_reactackle.TextField, {
	        value: _this.state.data.payload["otherItems"],
	        onChange: function onChange(e) {
	          _this.stateChangeHandler(e.value, "otherItems", true);
	        },
	        fullWidth: true,
	        placeholder: "Special Insructions or any items not found you can add here. \nএপ্সের বাইরে কোন অর্ডার থাকলে এই বক্সে লিখুনI আইটেম, ওজন এবং পরিমান লিখতে ভুলবেন না",
	        multiline: true,
	        multilineRows: { min: 3 }
	      })), _this.state.showForm && _this.state.proceedForward && _react2.default.createElement("div", {
	        style: {
	          padding: "1px",
	          textAlign: "right",
	          border: "1px solid gainsboro",
	          borderRadius: _reactDeviceDetect.isMobile ? "5px" : "0px",
	          backgroundColor: "white",
	          zIndex: "-9"
	        }
	      }, _react2.default.createElement(_reactackle.TextField, {
	        value: _this.state.data.payload["address"],
	        onChange: function onChange(e) {
	          _this.stateChangeHandler(e.value, "address", true);
	        },
	        fullWidth: true,
	        placeholder: "ENTER YOUR ADDRESS",
	        multiline: true,
	        multilineRows: { min: 3 }
	      })), _react2.default.createElement("div", {
	        style: {
	          height: "45px",
	          margin: "5px",
	          display: "flex",
	          flexDirection: "row",
	          alignItems: "center"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          padding: "0.5em 0.5em",
	          borderRadius: "8px",
	          color: "#fff",
	          backgroundColor: "rgb(30, 101, 144)",
	          border: "0px",
	          cursor: "pointer",
	          marginLef: "5px",
	          fontWeight: "bold",
	          maxWidth: "200px",
	          marginLeft: "10px",
	          marginTop: "5px"
	        },
	        onClick: _this.props.addMoreItems
	      }, _react2.default.createElement("span", null, _react2.default.createElement("icon", {
	        className: "fa fa-shopping-bag",
	        style: {
	          color: "white",
	          marginRight: "15px",
	          fontSize: "18px"
	        }
	      })), "ADD MORE ITEMS"), _react2.default.createElement("div", {
	        style: {
	          padding: "0.5em 0.5em",
	          borderRadius: "8px",
	          color: "#fff",
	          backgroundColor: "red",
	          border: "0px",
	          cursor: "pointer",
	          marginLef: "5px",
	          fontWeight: "bold",
	          maxWidth: "200px",
	          marginLeft: "10px",
	          marginTop: "5px"
	        },
	        onClick: function onClick() {
	          _this.props.onAddArray({ path: "bucket", payload: [] });
	        }
	      }, _react2.default.createElement("span", null, _react2.default.createElement("icon", {
	        className: "fa fa-trash",
	        style: {
	          color: "white",
	          marginRight: "15px",
	          fontSize: "18px"
	        }
	      })), "REMOVE ALL ITEMS")), _this.state.showForm && _this.state.proceedForward && _this.getPadItems(), !_this.state.proceedForward && _react2.default.createElement("h1", null, "YOUR CELL NUMBER IS REQUIRED TO PROCEED"), !_this.state.showForm && _this.getLoader())));
	    }, _this.getOrderConformation = function () {
	      window.scroll(0, 0);
	      return _react2.default.createElement("div", {
	        style: {
	          fontSize: "12px",
	          fontWeight: "bold",
	          textAlign: "center",
	          marginTop: "70px"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          margin: "auto",
	          border: "5px solid green",
	          width: "100px",
	          height: "100px",
	          borderRadius: "100px",
	          lineHeight: "90px",
	          verticalAlign: "middle"
	        }
	      }, _react2.default.createElement("icon", {
	        className: "fa fa-check fa-3x",
	        style: {
	          color: "green",
	          verticalAlign: "middle"
	        }
	      })), _react2.default.createElement("div", {
	        style: {
	          marginTop: "12px",
	          marginBottom: "12px"
	        }
	      }, "Your order is successfuly submitted"), _react2.default.createElement("div", {
	        style: {
	          marginTop: "10px"
	        }
	      }, (0, _terms2.default)()));
	    }, _this.getOrderUpdateConfirmation = function () {
	      window.scroll(0, 0);
	      return _react2.default.createElement("div", {
	        style: {
	          fontSize: "12px",
	          fontWeight: "bold",
	          textAlign: "center",
	          marginTop: "50px"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          margin: "auto",
	          border: "5px solid green",
	          width: "100px",
	          height: "100px",
	          borderRadius: "100px",
	          lineHeight: "90px",
	          verticalAlign: "middle"
	        }
	      }, _react2.default.createElement("icon", {
	        className: "fa fa-check fa-3x",
	        style: {
	          color: "green",
	          verticalAlign: "middle"
	        }
	      })), _react2.default.createElement("div", {
	        style: {
	          marginTop: "10px",
	          marginBottom: "10px"
	        }
	      }, "Your order has been updated"), _react2.default.createElement("div", {
	        style: {
	          marginTop: "10px"
	        }
	      }, (0, _terms2.default)()));
	    }, _this.getOrderCancellation = function () {
	      window.scroll(0, 0);
	      return _react2.default.createElement("div", {
	        style: {
	          fontSize: "20px",
	          fontWeight: "bold",
	          textAlign: "center",
	          marginTop: "50px"
	        }
	      }, _react2.default.createElement("div", null, "You order has been CANCELLED"), _react2.default.createElement("div", {
	        style: {
	          marginTop: "10px"
	        }
	      }, _react2.default.createElement(_reactackle.Button, {
	        text: "VIEW YOUR ORDERS",
	        onPress: function onPress() {
	          return _this.props.backToList("orderlist", "deliveryRequest");
	        },
	        colorScheme: "primary",
	        disabled: !_this.state.showForm
	      })));
	    }, _this.getItems = function () {
	      var currBucket = _.cloneDeep(_this.props.db["bucket"]);
	      if (currBucket && currBucket.length > 0 && currBucket[0].key !== undefined) {
	        return currBucket.map(function (product) {
	          return _react2.default.createElement("div", {
	            style: {
	              border: "1px solid white",
	              margin: "1px",
	              padding: "0px",
	              marginBottom: "5px"
	            }
	          }, _react2.default.createElement("div", {
	            style: {
	              display: "flex"
	            }
	          }, _react2.default.createElement("div", null, _react2.default.createElement("div", {
	            style: {
	              borderRadius: "30px",
	              color: "#fff",
	              backgroundColor: "rgb(30, 101, 144)",
	              fontSize: "1.5em",
	              border: "0px solid black",
	              cursor: "pointer",
	              fontWeight: "bold",
	              width: "30px",
	              height: "30px",
	              lineHeight: "30px",
	              textAlign: "center",
	              margin: "5px",
	              marginBottom: "15px"
	            },
	            onClick: function onClick() {
	              _this.props.addToBucket(product);
	            }
	          }, "+"), _react2.default.createElement("div", {
	            style: {
	              borderRadius: "30px",
	              color: "#fff",
	              backgroundColor: "red",
	              fontSize: "1.5em",
	              border: "0px solid black",
	              cursor: "pointer",
	              fontWeight: "bold",
	              width: "30px",
	              height: "30px",
	              lineHeight: "30px",
	              textAlign: "center",
	              margin: "5px"
	            },
	            onClick: function onClick() {
	              _this.props.removeFromBucket(product);
	            }
	          }, "-")), _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, {
	            src: product.photos && product.photos.length > 0 ? product.photos[0].url : _backupImage.backupImage,
	            style: {
	              height: "75px",
	              width: "75px",
	              minHeight: "75px",
	              minWidth: "75px",
	              borderRadius: "75px",
	              border: "0px solid gainsboro",
	              objectFill: "cover",
	              margin: "5px",
	              backgroundColor: "white",
	              objectFit: "contain"
	            },
	            afterLoad: function afterLoad() {
	              _this.setState(function (prevState) {
	                return _extends({}, prevState, _defineProperty({}, 0, true));
	              });
	            },
	            onError: function onError() {
	              var probElem = document.getElementById("img" + product.key);
	              if (probElem && probElem !== undefined) {
	                probElem.src = _backupImage.backupImage;
	              }
	            },
	            id: "img" + product.key
	          }), _react2.default.createElement("div", {
	            style: {
	              width: "100%",
	              display: "flex"
	            }
	          }, _react2.default.createElement("table", {
	            className: "table table-lg",
	            style: {
	              margin: "auto"
	            }
	          }, _react2.default.createElement("tr", null, _react2.default.createElement("td", null, product.productNameEnglish), _react2.default.createElement("td", null, _react2.default.createElement("div", {
	            style: {
	              fontSize: "22px",
	              textAlign: "right",
	              margin: "3px"
	            }
	          }, "$", product.amount))), _react2.default.createElement("tr", null, _react2.default.createElement("td", null, product.unit), _react2.default.createElement("td", null)), _react2.default.createElement("tr", null, _react2.default.createElement("td", null, product.quantity, " x ", product.productPrice), _react2.default.createElement("td", null))))), _react2.default.createElement("div", null));
	        });
	      }
	    }, _this.getActionButtons = function (rec) {
	      return _react2.default.createElement("div", {
	        style: {
	          textAlign: "right",
	          width: "100%",
	          display: "flex",
	          justifyContent: "flex-end"
	        }
	      }, _react2.default.createElement("span", null, _react2.default.createElement("div", {
	        style: {
	          borderRadius: "30px",
	          color: "#fff",
	          backgroundColor: "red",
	          fontSize: "1.5em",
	          border: "0px solid black",
	          cursor: "pointer",
	          fontWeight: "bold",
	          width: "30px",
	          height: "30px",
	          lineHeight: "30px",
	          textAlign: "center",
	          margin: "5px"
	        },
	        onClick: function onClick() {
	          _this.props.removeFromBucket(rec);
	        }
	      }, "-")), _react2.default.createElement("span", null, _react2.default.createElement("div", {
	        style: {
	          borderRadius: "30px",
	          color: "#fff",
	          backgroundColor: "rgb(30, 101, 144)",
	          fontSize: "1.5em",
	          border: "0px solid black",
	          cursor: "pointer",
	          fontWeight: "bold",
	          width: "30px",
	          height: "30px",
	          lineHeight: "30px",
	          textAlign: "center",
	          margin: "5px"
	        },
	        onClick: function onClick() {
	          _this.props.addToBucket(rec);
	        }
	      }, "+")));
	    }, _this.getPadItems = function () {
	      return _react2.default.createElement("div", {
	        style: {
	          padding: "5px",
	          fontSize: "12px"
	        }
	      }, _this.getItems());
	    }, _this.getFooter = function () {
	      var currBucket = _.cloneDeep(_this.props.db["bucket"]);
	      //console.log("bug here : " + JSON.stringify(currBucket));
	      if (currBucket && currBucket.length > 0 && currBucket[0].key !== undefined) {
	        var _ref2, _ref3;
	
	        var totAmt = currBucket.reduce(function (sum, item) {
	          sum = sum + parseFloat(item.amount.replace(/,/g, ""));
	          return parseFloat(sum);
	        }, 0);
	        return _react2.default.createElement("div", {
	          style: (_ref2 = {
	            textAlign: "center",
	            position: "fixed",
	            maxWidth: "800px",
	            bottom: "0px",
	            width: "100%",
	            margin: "auto"
	          }, _defineProperty(_ref2, "textAlign", "center"), _defineProperty(_ref2, "backgroundColor", "white"), _defineProperty(_ref2, "padding", "0px"), _defineProperty(_ref2, "display", "flex"), _defineProperty(_ref2, "border", "1px solid grey"), _defineProperty(_ref2, "boxSizing", "border-box"), _defineProperty(_ref2, "boxShadow", "0px 4px 4px rgba(0, 0, 0, 0.5)"), _ref2)
	        }, _react2.default.createElement("div", {
	          style: {
	            borderRadius: "5px",
	            color: "black",
	            backgroundColor: "white",
	            fontSize: "18px",
	            cursor: "pointer",
	            fontWeight: "bold",
	            width: "50%",
	            height: "40px",
	
	            textAlign: "center",
	            opacity: 1,
	
	            margin: "5px"
	          }
	        }, _react2.default.createElement("div", null, _react2.default.createElement("span", {
	          style: { fontSize: "10px", magin: "3px", marginLeft: "10px" }
	        }, "Total:"), " $", (0, _numeral2.default)(totAmt).format("0,0.00")), _react2.default.createElement("div", null, _react2.default.createElement("span", { style: { fontSize: "10px", margin: "3px" } }, "Items: "), " ", currBucket.length)), _react2.default.createElement("div", {
	          style: (_ref3 = {
	            padding: "0.6em 0.6em",
	            borderRadius: "8px",
	            color: "#fff",
	            backgroundColor: "rgb(30, 101, 144)",
	            fontSize: "1.1em",
	            border: "0px",
	            cursor: "pointer",
	            margin: "5px",
	            fontWeight: "bold"
	          }, _defineProperty(_ref3, "border", "1px solid white"), _defineProperty(_ref3, "width", "50%"), _ref3),
	          onClick: function onClick() {
	            _this.saveHandler();
	          }
	        }, _react2.default.createElement("span", null, _react2.default.createElement("icon", {
	          className: "fa fa-paper-plane blink",
	          style: { color: "white", margin: "5px" }
	        })), _react2.default.createElement("span", null, "PLACE ORDER")));
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(OrderPadDirectSupplier, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var todaysDate = (0, _moment2.default)().format("DD-MM-YYYY").toString();
	      var targetDate = todaysDate;
	      var targetDeliveryDate = (0, _moment2.default)().add(1, "day").format("ddd DD-MM-YYYY").toString();
	      var tgtOrder = {
	        name: "",
	        address: ""
	      };
	      this.props.onSetUiFlag("orderStage", "showForm");
	      if (this.props.createNewRec) {
	        if (this.props.orders && this.props.orders.length > 0) {
	          var myOrders = this.props.orders.filter(function (singOrder) {
	            //console.log(singOrder.mobile + " vs " + this.props.cellPhone);
	            return singOrder.mobile === _this2.props.cellPhone;
	          });
	          if (myOrders && myOrders.length > 0) {
	            //console.log(JSON.stringify(myOrders));
	            tgtOrder = myOrders[myOrders.length - 1];
	
	            this.setState(function (prevState) {
	              return _extends({}, prevState, {
	                data: _extends({}, prevState.data, {
	                  payload: _extends({}, prevState.data.payload, {
	                    name: tgtOrder.name,
	                    address: tgtOrder.address,
	                    deliveryDate: targetDate,
	                    targetDeliveryDate: targetDeliveryDate
	                  })
	                }),
	                tgtOrder: tgtOrder
	              });
	            });
	          }
	        } else {
	          this.setState(function (prevState) {
	            return _extends({}, prevState, {
	              data: _extends({}, prevState.data, {
	                payload: _extends({}, prevState.data.payload, {
	                  deliveryDate: targetDate,
	                  targetDeliveryDate: targetDeliveryDate
	                })
	              }),
	              tgtOrder: tgtOrder
	            });
	          });
	          //console.log("orders not found");
	        }
	      } else {
	          //console.log("its not even a new rec" + this.props.operationType);
	        }
	      if (!this.props.cellPhone || this.props.cellPhone === "") {
	        var cellPhone = prompt("Please enter your cell phone to continue");
	
	        if (cellPhone && cellPhone !== undefined && cellPhone !== "") {
	          this.props.onSetUiFlag("cellPhone", cellPhone);
	          //console.log("allOrders length: " + JSON.stringify(this.props.db));
	
	          this.setState(function (prevState) {
	            return _extends({}, prevState, {
	              data: _extends({}, prevState.data, {
	                payload: _extends({}, prevState.data.payload, {
	                  mobile: cellPhone,
	                  deliveryDate: targetDate
	                })
	              }),
	              proceedForward: true
	            });
	          });
	        } else {
	          this.setState(function (prevState) {
	            return _extends({}, prevState, {
	              cellPhone: cellPhone,
	              proceedForward: false
	            });
	          });
	        }
	      } else {
	        this.setState(function (prevState) {
	          return _extends({}, prevState, {
	            data: _extends({}, prevState.data, {
	              payload: _extends({}, prevState.data.payload, {
	                mobile: _this2.props.cellPhone,
	                deliveryDate: targetDate,
	                requestedItems: ""
	              })
	            }),
	            proceedForward: true
	          });
	        });
	      }
	    }
	
	    //single method that work for all fields
	    //takes incoming id of the field and then adds field data to state
	
	
	    /*
	    -webkit-tap-highlight-color: rgba(0,0,0,0);
	    font-size: 14px;
	    line-height: 1.42857143;
	    color: #333;
	    box-sizing: border-box;
	    font-family: "RobotMedium";
	    position: fixed;
	    top: 60px;
	    width: 95%;
	    align-self: center;
	    z-index: 99999;
	    -webkit-tap-highlight-color: rgba(0,0,0,0);
	    font-size: 14px;
	    line-height: 1.42857143;
	    color: #333;
	    box-sizing: border-box;
	    font-family: "RobotMedium";
	    z-index: -1;
	    margin-top: 60px;
	      */
	
	    //f2f4f6
	
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement("div", {
	        style: {
	          marginTop: "40px"
	        }
	      }, this.state.stage === "orderForm" && _react2.default.createElement("div", null, this.getFooter()), this.state.stage === "orderForm" && this.getOrderForm(), this.state.stage === "showConfirmation" && this.getOrderConformation(), this.state.stage === "showUpdateConfirmation" && this.getOrderUpdateConfirmation(), this.state.stage === "showCancellation" && this.getOrderCancellation(), _react2.default.createElement("div", {
	        style: {
	          height: "300px"
	        }
	      }));
	    }
	  }]);
	
	  return OrderPadDirectSupplier;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    userEmail: state.db.currentUser && state.db.currentUser.userEmail ? state.db.currentUser.userEmail : "",
	    currUser: state.db.currentUser,
	    isSuperAdmin: state.ui.isThisSuperAdmin,
	    isAdmin: state.ui.isThisAdmin,
	    userProfile: state.db.userProfile,
	    selectedRecord: state.db["selected" + state.ui.tableName],
	    db: state.db,
	    createNewRec: state.ui.operationType === "add",
	    operationType: state.ui.operationType,
	    orders: state.db.deliveryRequest,
	    users: state.db.users
	  };
	}
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    onAddRecord: function onAddRecord(data) {
	      return dispatch((0, _actions.actionAddArray2Redux)(data));
	    },
	    onSelectRecord: function onSelectRecord(params) {
	      return dispatch((0, _actions.selectARecord)(params));
	    },
	    onSetUiFlag: function onSetUiFlag(flagName, flagVal) {
	      return dispatch((0, _actions.setUiFlag)(flagName, flagVal));
	    },
	    onNotifyUsers: function onNotifyUsers(msgBody, arrayOfUsers) {
	      return dispatch((0, _actions.notifyUsers)(msgBody, arrayOfUsers));
	    },
	    onAddArray: function onAddArray(data) {
	      return dispatch((0, _actions.actionAddArray2Redux)(data));
	    }
	  };
	};
	
	exports.default = (0, _recompose.compose)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _Firebase.withFirebase)(OrderPadDirectSupplier);

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDeviceDetect = __webpack_require__(6);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var PrimeExchService = function (_Component) {
	  _inherits(PrimeExchService, _Component);
	
	  function PrimeExchService() {
	    _classCallCheck(this, PrimeExchService);
	
	    return _possibleConstructorReturn(this, (PrimeExchService.__proto__ || Object.getPrototypeOf(PrimeExchService)).apply(this, arguments));
	  }
	
	  _createClass(PrimeExchService, [{
	    key: "render",
	    value: function render() {
	      var _ref, _ref2;
	
	      return _react2.default.createElement("div", { style: { margin: "10px", textAlign: "center" } }, this.props.appVersion === "2" && _react2.default.createElement("div", null, _react2.default.createElement("div", {
	        style: {
	          marginTop: "10px",
	          marginBottom: "10px"
	        }
	      }, _react2.default.createElement("div", {
	        style: (_ref = {
	          width: "50%",
	          padding: "1px",
	          textAlign: "center",
	          border: "1px solid gainsboro",
	          borderRadius: _reactDeviceDetect.isMobile ? "5px" : "0px",
	          backgroundColor: "rgb(30, 101, 144)",
	          margin: "auto"
	        }, _defineProperty(_ref, "padding", "6px"), _defineProperty(_ref, "fontWeight", "bold"), _defineProperty(_ref, "color", "white"), _defineProperty(_ref, "fontSize", "12px"), _ref),
	        onClick: function onClick() {
	          var msgToApp = {
	            actionType: "switchUrl",
	            payload: {
	              url: "https://www.bit.ly/RP_Login"
	            }
	          };
	
	          if (window && window.ReactNativeWebView) {
	            //console.log("posing autologin message to app");
	            window.ReactNativeWebView.postMessage(JSON.stringify(msgToApp));
	          }
	        }
	      }, _react2.default.createElement("div", null, _react2.default.createElement("i", { className: "fa fa-paper-plane" }), " SEND MONEY"), _react2.default.createElement("div", null, "\u09AB\u09B0\u09AE \u09A4\u09C8\u09B0\u09BF \u0995\u09B0\u09C1\u09A8"))), _react2.default.createElement("div", {
	        style: {
	          marginTop: "10px",
	          marginBottom: "10px"
	        }
	      }, _react2.default.createElement("div", {
	        style: (_ref2 = {
	          width: "50%",
	          padding: "1px",
	          textAlign: "center",
	          border: "1px solid gainsboro",
	          borderRadius: _reactDeviceDetect.isMobile ? "5px" : "0px",
	          backgroundColor: "rgb(30, 101, 144)",
	          margin: "auto"
	        }, _defineProperty(_ref2, "padding", "6px"), _defineProperty(_ref2, "fontWeight", "bold"), _defineProperty(_ref2, "color", "white"), _defineProperty(_ref2, "fontSize", "12px"), _ref2),
	        onClick: function onClick() {
	          var msgToApp = {
	            actionType: "switchUrl",
	            payload: {
	              url: "https://www.bit.ly/Reigister"
	            }
	          };
	
	          if (window && window.ReactNativeWebView) {
	            //console.log("posing autologin message to app");
	            window.ReactNativeWebView.postMessage(JSON.stringify(msgToApp));
	          }
	        }
	      }, _react2.default.createElement("div", null, _react2.default.createElement("i", { className: "fa fa-paper-plane" }), " REGISTER"), _react2.default.createElement("div", null, "\u09AB\u09B0\u09AE \u09A4\u09C8\u09B0\u09BF \u0995\u09B0\u09C1\u09A8")))), this.props.appVersion !== "2" && _react2.default.createElement("div", null, "You are not on the latest version of BCS App. To use this service please upgrade to latest vesion from Play Store or App Store."));
	    }
	  }]);
	
	  return PrimeExchService;
	}(_react.Component);
	
	exports.default = PrimeExchService;

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDeviceDetect = __webpack_require__(6);
	
	var _reactackle = __webpack_require__(5);
	
	var _PhotoUploadPass = __webpack_require__(76);
	
	var _PhotoUploadPass2 = _interopRequireDefault(_PhotoUploadPass);
	
	var _SignPad = __webpack_require__(107);
	
	var _SignPad2 = _interopRequireDefault(_SignPad);
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _lodash = __webpack_require__(22);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var RemitRegistration = function (_Component) {
	  _inherits(RemitRegistration, _Component);
	
	  function RemitRegistration() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, RemitRegistration);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RemitRegistration.__proto__ || Object.getPrototypeOf(RemitRegistration)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      data: {
	        path: "",
	        payload: {
	          senderName: "",
	          senderAddress: "",
	          idType: "PASSPORT",
	          idNumber: "",
	          exchId: "",
	          mobile: _this.props.cellPhone,
	          status: "PENDING",
	          exchange: "Agrani Exchange Pte Ltd",
	          appDate: (0, _moment2.default)().format("DD MMM YYYY"),
	          idVerified: false,
	          inPersonVerified: false,
	          comments: "",
	          internalNotes: ""
	        }
	      },
	      stage: "genInput"
	    }, _this.stateChangeHandler = function (val, id, isPayload) {
	      // console.log(
	      //   "val: " + JSON.stringify(val) + " id: " + id + " isPayload: " + isPayload
	      // );
	      var tmpState = {};
	      tmpState[id] = val;
	
	      if (isPayload) {
	        _this.setState(function (prevState) {
	          if (prevState && prevState.data.payload !== null) {
	            return _extends({}, prevState, {
	              data: _extends({}, prevState.data, {
	                payload: _extends({}, prevState.data.payload, tmpState)
	              })
	            });
	          } else {
	            return _extends({}, prevState, {
	              data: {
	                path: prevState.data.path,
	                payload: _extends({}, tmpState)
	              }
	            });
	          }
	        });
	      } else {
	        _this.setState(function (prevState) {
	          return _extends({}, prevState, tmpState);
	        });
	      }
	    }, _this.getRow = function (heading, value) {
	      return _react2.default.createElement("tr", null, _react2.default.createElement("td", null, heading), _react2.default.createElement("td", null, value));
	    }, _this.getRegFormField = function (fieldId, placeholder, caption, multiline) {
	      return _react2.default.createElement("div", null, _react2.default.createElement("div", {
	        style: {
	          padding: "1px",
	          textAlign: "right",
	          border: "1px solid gainsboro",
	          borderRadius: _reactDeviceDetect.isMobile ? "5px" : "0px",
	          backgroundColor: "white",
	          zIndex: "-9",
	          margin: "5px",
	          fontSize: "12px"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          display: "flex",
	          flexDirection: "row"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          width: "30%",
	          lineHeight: "12px",
	          textAlign: "left",
	          paddingLeft: "5px",
	          margin: "auto"
	        }
	      }, caption), _react2.default.createElement("div", {
	        style: {
	          width: "70%",
	          border: "1px solid gainsboro",
	          borderRadius: "5px",
	          borderTopLeftRadius: "0px",
	          borderBottomLeftRadius: "0px",
	          margin: "2px"
	        }
	      }, _react2.default.createElement(_reactackle.TextField, {
	        value: _this.state.data.payload[fieldId],
	        onChange: function onChange(e) {
	          _this.stateChangeHandler(e.value, fieldId, true);
	          if (fieldId === "textNameBangla") {
	            _this.getBanglaImage(e.value);
	          }
	        },
	        multiline: multiline,
	        fullWidth: true,
	        placeholder: placeholder
	      })))));
	    }, _this.getRegFormTwinButtons = function (fieldId, caption, btn1Text, btn2Text) {
	      return _react2.default.createElement("div", null, _react2.default.createElement("div", {
	        style: {
	          padding: "1px",
	          textAlign: "right",
	          border: "1px solid gainsboro",
	          borderRadius: _reactDeviceDetect.isMobile ? "5px" : "0px",
	          backgroundColor: "white",
	          zIndex: "-9",
	          margin: "5px",
	          fontSize: "12px"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          display: "flex",
	          flexDirection: "row"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          width: "30%",
	          lineHeight: "12px",
	          textAlign: "left",
	          paddingLeft: "5px",
	          margin: "auto"
	        }
	      }, caption), _react2.default.createElement("div", {
	        style: {
	          width: "70%",
	          display: "flex",
	          flexDirection: "row"
	        }
	      }, _react2.default.createElement(_reactackle.Button, {
	        text: btn1Text,
	        colorScheme: _this.state.data.payload[fieldId] === btn1Text ? "primary" : "white",
	        onPress: function onPress() {
	          _this.stateChangeHandler(btn1Text, fieldId, true);
	          _this.props.setScroll(true);
	        }
	      }), _react2.default.createElement(_reactackle.Button, {
	        text: btn2Text,
	        colorScheme: _this.state.data.payload[fieldId] === btn2Text ? "primary" : "white",
	        onPress: function onPress() {
	          _this.stateChangeHandler(btn2Text, fieldId, true);
	          _this.props.setScroll(true);
	        }
	      })))));
	    }, _this.getChoiceButton = function (label, stateVal, stateFldId, iconClass, colorIt) {
	      var _ref2;
	
	      return _react2.default.createElement("div", {
	        style: (_ref2 = {
	          width: "50%",
	          padding: "1px",
	          textAlign: "center",
	          border: "1px solid gainsboro",
	          borderRadius: _reactDeviceDetect.isMobile ? "5px" : "0px",
	          backgroundColor: colorIt ? "rgb(30, 101, 144)" : "white",
	          margin: "auto"
	        }, _defineProperty(_ref2, "padding", "6px"), _defineProperty(_ref2, "fontWeight", "bold"), _defineProperty(_ref2, "color", colorIt ? "white" : "black"), _defineProperty(_ref2, "fontSize", "12px"), _defineProperty(_ref2, "minWidth", "80px"), _defineProperty(_ref2, "maxWidth", "80px"), _ref2),
	        onClick: function onClick() {
	          _this.stateChangeHandler(stateVal, stateFldId, false);
	          _this.props.setScroll(true);
	        }
	      }, _react2.default.createElement("div", null, _react2.default.createElement("i", { className: iconClass }), " ", label));
	    }, _this.getNextBack = function (stageBack, stageNext) {
	      var _ref3, _ref4;
	
	      return _react2.default.createElement("div", null, _react2.default.createElement("table", { style: { width: "100%" } }, _react2.default.createElement("tbody", null, _react2.default.createElement("tr", null, _react2.default.createElement("td", { style: { border: "0px" } }, _react2.default.createElement("div", {
	        style: {
	          textAlign: "center",
	          width: "100%"
	        }
	      }, _react2.default.createElement("div", {
	        style: (_ref3 = {
	          width: "50%",
	          padding: "1px",
	          textAlign: "center",
	          border: "1px solid gainsboro",
	          borderRadius: _reactDeviceDetect.isMobile ? "5px" : "0px",
	          backgroundColor: "rgb(30, 101, 144)",
	          margin: "auto"
	        }, _defineProperty(_ref3, "padding", "6px"), _defineProperty(_ref3, "fontWeight", "bold"), _defineProperty(_ref3, "color", "white"), _defineProperty(_ref3, "fontSize", "12px"), _defineProperty(_ref3, "minWidth", "140px"), _ref3),
	        onClick: function onClick() {
	          _this.stateChangeHandler(stageBack, "stage", false);
	          _this.props.setScroll(true);
	        }
	      }, _react2.default.createElement("div", null, _react2.default.createElement("i", { className: "fa fa-arrow-left" }), " BACK")))), _react2.default.createElement("td", { style: { border: "0px" } }, _react2.default.createElement("div", {
	        style: {
	          textAlign: "center",
	          width: "100%"
	        }
	      }, _react2.default.createElement("div", {
	        style: (_ref4 = {
	          width: "50%",
	          padding: "1px",
	          textAlign: "center",
	          border: "1px solid gainsboro",
	          borderRadius: _reactDeviceDetect.isMobile ? "5px" : "0px",
	          backgroundColor: "rgb(30, 101, 144)",
	          margin: "auto"
	        }, _defineProperty(_ref4, "padding", "6px"), _defineProperty(_ref4, "fontWeight", "bold"), _defineProperty(_ref4, "color", "white"), _defineProperty(_ref4, "fontSize", "12px"), _defineProperty(_ref4, "minWidth", "140px"), _ref4),
	        onClick: function onClick() {
	          _this.stateChangeHandler(stageNext, "stage", false);
	          _this.props.setScroll(true);
	        }
	      }, _react2.default.createElement("div", null, "NEXT ", _react2.default.createElement("i", { className: "fa fa-arrow-right" })))))))));
	    }, _this.getGenInputForm = function () {
	      return _react2.default.createElement("div", null, _react2.default.createElement("p", {
	        style: {
	          backgroundColor: "orange",
	          padding: "5px",
	          fontWeight: "bold"
	        }
	      }, "Registration is Easy (\u09A6\u09DF\u09BE\u0995\u09B0\u09C7 \u09A8\u09BF\u099A\u09C7\u09B0 \u09A4\u09A5\u09CD\u09AF\u0997\u09C1\u09B2\u09CB \u09AD\u09BE\u09B2\u0995\u09B0\u09C7 \u09A6\u09C7\u0996\u09C7 \u09A8\u09BF\u09A8, \u09B8\u09AC\u0995\u09BF\u099B\u09C1 \u09A0\u09BF\u0995 \u09A5\u09BE\u0995\u09B2\u09C7 \u09A8\u09BF\u099A\u09C7\u09B0 \"\u0995\u09A8\u09AB\u09BE\u09B0\u09CD\u09AE\" \u09AC\u09BE\u099F\u09A8\u09C7 \u099A\u09BE\u09AA\u09C1\u09A8\u0964):"), _react2.default.createElement("p", null, _react2.default.createElement("div", null, _this.getRegFormField("senderName", "আবেদনকারীর নাম (ইংরেজিতে)", "FULL NAME", false)), _react2.default.createElement("div", null, _this.getRegFormField("senderAddress", "আবেদনকারীর নাম (ইংরেজিতে)", "ADDRESS", true)), _react2.default.createElement("div", null, _this.getRegFormTwinButtons("idType", "ID TYPE", "PASSPORT", "LICENSE")), _react2.default.createElement("div", null, _this.getRegFormField("idNumber", "আবেদনকারীর নাম (ইংরেজিতে)", "ID #", false)), _react2.default.createElement("div", null, _this.getRegFormField("exchId", "আবেদনকারীর নাম (ইংরেজিতে)", "REMIT ID", false))), _react2.default.createElement("p", null, _react2.default.createElement("div", null, _this.getChoiceButton("NEXT", "photoInput", "stage", "fa fa-arrow-right", true))));
	    }, _this.getReviewPage = function () {
	      var _ref5, _ref6;
	
	      return _react2.default.createElement("div", null, !_this.state.generatingStatement && _react2.default.createElement("div", null, _react2.default.createElement("div", {
	        style: {
	          backgroundColor: "orange",
	          padding: "5px",
	          fontWeight: "bold",
	          marginBottom: "10px"
	        }
	      }, "Please carefully review the following information and press the confirm button (\u09A6\u09DF\u09BE\u0995\u09B0\u09C7 \u09A8\u09BF\u099A\u09C7\u09B0 \u09A4\u09A5\u09CD\u09AF\u0997\u09C1\u09B2\u09CB \u09AD\u09BE\u09B2\u0995\u09B0\u09C7 \u09A6\u09C7\u0996\u09C7 \u09A8\u09BF\u09A8, \u09B8\u09AC\u0995\u09BF\u099B\u09C1 \u09A0\u09BF\u0995 \u09A5\u09BE\u0995\u09B2\u09C7 \u09A8\u09BF\u099A\u09C7\u09B0 \"\u0995\u09A8\u09AB\u09BE\u09B0\u09CD\u09AE\" \u09AC\u09BE\u099F\u09A8\u09C7 \u099A\u09BE\u09AA\u09C1\u09A8\u0964):"), _react2.default.createElement("table", { className: "table table-bordered table-striped" }, _react2.default.createElement("tbody", null, _this.getRow("FULL NAME", _this.state.data.payload.senderName), _this.getRow("ADDRESS", _this.state.data.payload.senderAddress), _this.getRow("ID Type", _this.state.data.payload.idType), _this.getRow("ID #", _this.state.data.payload.idNumber), _this.getRow("Mobile No", _this.state.data.payload.mobile))), _react2.default.createElement("p", null), _react2.default.createElement("div", null, _react2.default.createElement("table", { style: { width: "100%" } }, _react2.default.createElement("tbody", null, _react2.default.createElement("tr", null, _react2.default.createElement("td", { style: { border: "0px" } }, _react2.default.createElement("div", {
	        style: {
	          textAlign: "center",
	          width: "100%"
	        }
	      }, _react2.default.createElement("div", {
	        style: (_ref5 = {
	          width: "50%",
	          padding: "1px",
	          textAlign: "center",
	          border: "1px solid gainsboro",
	          borderRadius: _reactDeviceDetect.isMobile ? "5px" : "0px",
	          backgroundColor: "rgb(30, 101, 144)",
	          margin: "auto"
	        }, _defineProperty(_ref5, "padding", "6px"), _defineProperty(_ref5, "fontWeight", "bold"), _defineProperty(_ref5, "color", "white"), _defineProperty(_ref5, "fontSize", "12px"), _defineProperty(_ref5, "minWidth", "140px"), _ref5),
	        onClick: function onClick() {
	          _this.stateChangeHandler("genInput", "stage", false);
	        }
	      }, _react2.default.createElement("div", null, _react2.default.createElement("i", { className: "fa fa-arrow-left" }), " CHANGE")))), _react2.default.createElement("td", { style: { border: "0px" } }, _react2.default.createElement("div", {
	        style: {
	          textAlign: "center",
	          width: "100%"
	        }
	      }, _react2.default.createElement("div", {
	        style: (_ref6 = {
	          width: "50%",
	          padding: "1px",
	          textAlign: "center",
	          border: "1px solid gainsboro",
	          borderRadius: _reactDeviceDetect.isMobile ? "5px" : "0px",
	          backgroundColor: "rgb(30, 101, 144)",
	          margin: "auto"
	        }, _defineProperty(_ref6, "padding", "6px"), _defineProperty(_ref6, "fontWeight", "bold"), _defineProperty(_ref6, "color", "white"), _defineProperty(_ref6, "fontSize", "12px"), _defineProperty(_ref6, "minWidth", "140px"), _ref6),
	        onClick: function onClick() {
	          confirm("Are you sure you would like to submit this applicatino?") && _this.submitRegistration();
	        }
	      }, _react2.default.createElement("div", null, "SUBMIT ", _react2.default.createElement("i", { className: "fa fa-arrow-right" })))))))))));
	    }, _this.getPhotoInputForm = function () {
	      return _react2.default.createElement("div", null, _react2.default.createElement("div", null, _react2.default.createElement("div", {
	        style: {
	          backgroundColor: "orange",
	          padding: "5px",
	          fontWeight: "bold"
	        }
	      }, "Please upload clear photos of your ID documents"), _react2.default.createElement("p", null, _react2.default.createElement("div", { style: { margin: "0px", textAlign: "center" } }, _react2.default.createElement(_PhotoUploadPass2.default, {
	        title1: "PASSPORT PHOTO",
	        title2: "লোড পাসপোর্ট ফটো",
	        images: _this.state.idImage,
	        fieldName: "idImage",
	        isPayload: false,
	        stateChangeHandler: _this.stateChangeHandler,
	        disabled: false
	      }), _react2.default.createElement(_PhotoUploadPass2.default, {
	        title1: "WORK PERMIT PHOTO (FRONT)",
	        title2: "লোড পারমিটের সামনের ফটো",
	        images: _this.state.wpFrontImage,
	        fieldName: "wpFrontImage",
	        isPayload: false,
	        stateChangeHandler: _this.stateChangeHandler,
	        disabled: false
	      }), _react2.default.createElement(_PhotoUploadPass2.default, {
	        title1: "WORK PERMIT PHOTO (BACK)",
	        title2: "লোড পারমিটের পেছনের ফটো",
	        images: _this.state.wpBackImage,
	        fieldName: "wpBackImage",
	        isPayload: false,
	        stateChangeHandler: _this.stateChangeHandler,
	        disabled: false
	      })), _react2.default.createElement("input", {
	        type: "file",
	        accept: "image/*",
	        id: "uploader",
	        onChange: function onChange(evt) {
	          console.log("clicked");
	          //console.log("triggering main function");
	          event.preventDefault();
	          //console.log(evt.target.result);
	          if (evt.target.files[0]) {
	            _this.idScanTo64(evt.target.files);
	          } else {
	            console.log("gotcha");
	          }
	        },
	        style: {
	          visibility: "hidden",
	          height: "0px"
	        }
	      })), _this.getNextBack("genInput", "review")));
	    }, _this.createRemitRegRec = function () {
	      var cloudPath = "agraniRegs/";
	      var recObj = _lodash2.default.cloneDeep(_this.state.data.payload);
	      recObj.exchange = "Agrani Exchange Pte Ltd";
	      var passApp = _this.props.firebase.db.ref("/" + cloudPath).push();
	      passApp.set(recObj).catch(function (err) {
	        console.log(err);
	        return console.log("some error: " + err);
	      }).then(function (err) {
	        //clear the bucket
	        _this.props.firebase.db.ref("/remSvc" + "/" + _this.props.cellPhone + "/remRegs/" + passApp.key).once("value").then(function (snap) {
	          snap.ref.set(recObj);
	          cloudPath = "primeRegs/";
	          recObj.exchange = "Prime Exchange Co. Pte Ltd";
	          var passApp2 = _this.props.firebase.db.ref("/" + cloudPath).push();
	          passApp2.set(recObj).catch(function (err) {
	            console.log(err);
	            console.log("some error: " + err);
	          }).then(function (err) {
	            //clear the bucket
	            _this.props.firebase.db.ref("/remSvc" + "/" + _this.props.cellPhone + "/remRegs/" + passApp2.key).once("value").then(function (snap) {
	              snap.ref.set(recObj);
	            }).catch(function (err) {
	              console.log(err);
	              console.log("some error: " + err);
	            }).then(function (err) {
	              console.log("updated");
	            });
	          });
	        }).catch(function (err) {
	          console.log(err);
	          console.log("some error: " + err);
	        }).then(function (err) {
	          console.log("updated");
	        });
	      });
	    }, _this.getEmailText = function () {
	      var emTxt = "Dear Sir \n Please see below my application";
	      emTxt = emTxt + " for registration as per the following details: \n";
	      emTxt = emTxt + "\n";
	      emTxt = emTxt + "\n";
	      emTxt = emTxt + "Name: " + _this.state.data.payload.senderName + " \n";
	      emTxt = emTxt + "Adress: " + _this.state.data.payload.senderAddress + " \n";
	      emTxt = emTxt + "Id Type: " + _this.state.data.payload.idType + " \n";
	      emTxt = emTxt + "ID #: " + _this.state.data.payload.idNumber + " \n";
	      emTxt = emTxt + "Mobile: " + _this.state.data.payload.mobile + " \n";
	      emTxt = emTxt + "Application Date: " + _this.state.data.payload.appDate + " \n";
	
	      emTxt = emTxt + "\n";
	      emTxt = emTxt + "\n";
	
	      emTxt = emTxt + "I have attached with this email the following documents: \n";
	      emTxt = emTxt + " - Passport \n - Work Permit (Front & Back) \n - Proof of payment \n";
	      emTxt = emTxt + "For any further information please rechout to me at my phone number provided above.\n";
	      emTxt = emTxt + "\n";
	      emTxt = emTxt + "\n Note: \n";
	      emTxt = emTxt + "";
	      emTxt = emTxt + "- This is a system generated email. \n";
	      emTxt = emTxt + " - Information provided above is as per the data provided by users, and it is the responsibility of users to ensure correct input of all information. \n";
	      emTxt = emTxt + "- For any further information please contact the applicant directly \n";
	      emTxt = emTxt + "\n";
	      emTxt = emTxt + "\n";
	      return emTxt;
	    }, _this.getHtmlRow = function (heading, value) {
	      return "<tr><td style='border: 1px solid black;padding: 5px'>" + heading + "</td><td style='border: 1px solid black;padding: 5px'>" + value + "</td></tr>";
	    }, _this.getEmailHtml = function () {
	      var emTxt = "<p>Dear Sir </p><p> Please find below my application for ";
	      emTxt = emTxt + " remittance registeration as per the following details: </p>";
	      emTxt = emTxt + "<p></p>";
	      emTxt = emTxt + "<table style='border: 1px solid black;max-width: 450px;min-width:450px'><tbody>";
	      emTxt = emTxt + _this.getHtmlRow("Name", _this.state.data.payload.senderName);
	      emTxt = emTxt + _this.getHtmlRow("Address", _this.state.data.payload.senderAddress);
	      emTxt = emTxt + _this.getHtmlRow("ID No.", _this.state.data.payload.idNumber);
	
	      emTxt = emTxt + _this.getHtmlRow("Remittance ID", _this.state.data.payload.exchId);
	      emTxt = emTxt + _this.getHtmlRow("Application Date", _this.state.data.payload.appDate);
	
	      emTxt = emTxt + "</tbody></table>";
	      emTxt = emTxt + "<p></p><p></p>";
	
	      emTxt = emTxt + "<p>I have attached with this email the photos of following documents:</p>";
	      emTxt = emTxt + "<ul><li>Passport</li><li>Work Permit (Front & Back)</li></ul>";
	      emTxt = emTxt + "<p>For any further information please rechout to me at my phone number.</p>";
	      emTxt = emTxt + "<p></p>";
	      emTxt = emTxt + "<p><b>Note:</b></p>";
	      emTxt = emTxt + "<p></p>";
	      emTxt = emTxt + "<p><ul><li>This is a system generated email.</li>";
	      emTxt = emTxt + "<li>Information provided in this application, is as per the data provided by users, and it is the responsibility of users to ensure correct input of all information.</li>";
	      emTxt = emTxt + "<li>For any further information please contact the applicant directly</li>";
	      emTxt = emTxt + "</p>";
	      emTxt = emTxt + "<p></p>";
	      return emTxt;
	    }, _this.submitRegistration = function () {
	      var emailParams = {
	        from: '"BCS Registration Request" helper@brooklynzcommunitysupport.com', // sender address
	        to: "ahmed_fayyaz@outlook.com", // list of receivers
	        subject: "Registeration Request [ " + _this.state.data.payload.senderName + " | " + _this.state.data.payload.idNumber + " | " + _this.props.cellPhone + " ]", // Subject line
	        attachments: [],
	        text: _this.getEmailText(), // plain text body
	        html: _this.getEmailHtml() // html body
	      };
	      if (window.location.hostname !== "localhost") {
	        emailParams.attachments.push({
	          filename: "id.jpg",
	          path: _this.state.idImage[0].b64
	        });
	
	        emailParams.attachments.push({
	          filename: "permitFront.jpg",
	          path: _this.state.wpFrontImage[0].b64
	        });
	
	        emailParams.attachments.push({
	          filename: "permitBack.jpg",
	          path: _this.state.wpBackImage[0].b64
	        });
	      }
	
	      //get state updated with calc fields
	      Promise.all([_this.stateChangeHandler(true, "generatingStatement", false)]).then(function (res) {
	        //console.log("test test: " + res[1]);
	
	        _this.props.onSendEmail(emailParams).then(function (emailResp) {
	          //this.saveHandler();
	          _this.createRemitRegRec();
	          //   let suppNotifyText =
	          //     "New passport form generated by " +
	          //     this.state.data.payload.textName +
	          //     " (" +
	          //     this.state.data.payload.phoneNumber +
	          //     ").";
	          //this.props.onNotifyUsers(suppNotifyText, ["94562455"]);
	          _this.stateChangeHandler(false, "generatingStatement", false);
	          _this.stateChangeHandler("genInput", "stage", false);
	
	          //   this.props.onAddRecord({
	          //     path: "myPassApplication",
	          //     payload: {}
	          //   });
	        }).catch(function (err) {
	          console.log("Salaaa error: " + err);
	          _this.stateChangeHandler(false, "generatingStatement", false);
	        });
	      });
	      //request new statement
	      //once req completed show the stop loader and show statement
	    }, _this.getStatementLoader = function () {
	      return _react2.default.createElement("div", {
	        style: {
	          textAlign: "center",
	          paddingTop: "10px"
	        }
	      }, _react2.default.createElement(_reactackle.CircleProgress, {
	        indeterminate: true,
	        subtitle: "Submitting application... please be patient as it can take upto a minute (\u098F\u0995\u099F\u09C1 \u0985\u09AA\u09C7\u0995\u09CD\u09B7\u09BE \u0995\u09B0\u09C1\u09A8, \u09AB\u09B0\u09AE \u0987\u09AE\u09C7\u0987\u09B2 \u09B9\u09A4\u09C7 \u098F\u0995 \u09AE\u09BF\u09A8\u09BF\u099F\u09C7\u09B0 \u09AE\u09A4\u09CB \u09B2\u09BE\u0997\u09A4\u09C7 \u09AA\u09BE\u09B0\u09C7\u0964)",
	        circleSize: 40,
	        strokeSize: 5,
	        labelPositionY: "bottom",
	        labelPositionX: "center"
	      }));
	    }, _this.getRegRecs = function () {
	      if (_this.props.myRemitRegs && _this.props.myRemitRegs.length > 0) {
	        return _this.props.myRemitRegs.map(function (reg) {
	          return _react2.default.createElement("table", { className: "table table-bordered" }, _react2.default.createElement("tbody", null, _react2.default.createElement("tr", null, _react2.default.createElement("td", { style: { backgroundColor: "white" } }, "Exchange"), _react2.default.createElement("td", { style: { backgroundColor: "white" } }, reg.exchange)), _react2.default.createElement("tr", null, _react2.default.createElement("td", { style: { backgroundColor: "white" } }, "Status"), _react2.default.createElement("td", { style: { backgroundColor: "white" } }, reg.status))));
	        });
	      }
	    }, _this.getRegStatus = function () {
	      return _react2.default.createElement("div", null, _this.props.myRemitRegs && _this.props.myRemitRegs.length > 0 && _react2.default.createElement("p", null, _react2.default.createElement("br", null), _react2.default.createElement("div", null, "Current Registration Status:"), _react2.default.createElement("div", { style: { margin: "10px" } }, _this.getRegRecs())));
	    }, _this.getMainContent = function () {
	      if (!_this.props.myRemitRegs || _this.props.myRemitRegs.length === 0) {
	        return _react2.default.createElement("div", null, _this.state.generatingStatement && _this.getStatementLoader(), _react2.default.createElement("div", null, _this.state.stage === "genInput" && _this.getGenInputForm()), _react2.default.createElement("div", null, _this.state.stage === "photoInput" && _this.getPhotoInputForm()), _react2.default.createElement("div", null, _this.state.stage === "review" && _this.getReviewPage()));
	      } else {
	        return _react2.default.createElement("div", null, _this.getRegStatus());
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  //single method that work for all fields
	  //takes incoming id of the field and then adds field data to state
	
	
	  _createClass(RemitRegistration, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement("div", null, this.getMainContent());
	    }
	  }]);
	
	  return RemitRegistration;
	}(_react.Component);
	
	exports.default = RemitRegistration;

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactackle = __webpack_require__(5);
	
	var _reactDeviceDetect = __webpack_require__(6);
	
	var _RemitRegistration = __webpack_require__(315);
	
	var _RemitRegistration2 = _interopRequireDefault(_RemitRegistration);
	
	var _SendRemittance = __webpack_require__(318);
	
	var _SendRemittance2 = _interopRequireDefault(_SendRemittance);
	
	var _reactIframe = __webpack_require__(441);
	
	var _reactIframe2 = _interopRequireDefault(_reactIframe);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var RemitService = function (_Component) {
	  _inherits(RemitService, _Component);
	
	  function RemitService() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, RemitService);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RemitService.__proto__ || Object.getPrototypeOf(RemitService)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      data: {
	        path: "remitService",
	        payload: {}
	      },
	      searchFilters: {
	        category: "SEND"
	      }
	    }, _this.stateChangeHandler = function (val, id, isPayload) {
	      // console.log(
	      //   "val: " + JSON.stringify(val) + " id: " + id + " isPayload: " + isPayload
	      // );
	      var tmpState = {};
	      tmpState[id] = val;
	
	      if (isPayload) {
	        _this.setState(function (prevState) {
	          if (prevState && prevState.data.payload !== null) {
	            return _extends({}, prevState, {
	              data: _extends({}, prevState.data, {
	                payload: _extends({}, prevState.data.payload, tmpState)
	              })
	            });
	          } else {
	            return _extends({}, prevState, {
	              data: {
	                path: prevState.data.path,
	                payload: _extends({}, tmpState)
	              }
	            });
	          }
	        });
	      } else {
	        _this.setState(function (prevState) {
	          return _extends({}, prevState, tmpState);
	        });
	      }
	    }, _this.categIsSelected = function (categName) {
	      //console.log(categName + " " + this.state.searchFilters.category);
	      var isSelected = false;
	
	      if (_this.state.searchFilters.category === categName) {
	        isSelected = true;
	      }
	
	      return isSelected;
	    }, _this.getCategTabs = function () {
	      //console.log(JSON.stringify(this.props.createTable));
	
	      var categList = [{ name: "SEND", banglaText: "??", icon: "fa fa-flash", color: "blue" }, {
	        name: "STATUS",
	        banglaText: "??",
	        icon: "fa fa-info-circle",
	        color: "oragne"
	      }, { name: "PAYEES", banglaText: "??", icon: "fa fa-heart", color: "red" }, { name: "REGISTER", banglaText: "??", icon: "fa fa-book", color: "black" }];
	
	      if (categList && categList.length > 0) {
	        //console.log("got categ list: " + JSON.stringify(categList));
	        return categList.map(function (item) {
	          return _react2.default.createElement("div", {
	            style: {
	              height: _this.categIsSelected(item.name) ? "37px" : "35px",
	              margin: "1px",
	              backgroundColor: "white",
	              display: "flex",
	              justifyContent: "center",
	              alignItems: "center",
	              minWidth: "24.4%",
	              fontSize: "11px",
	              textAlign: "center",
	              border: _this.categIsSelected(item.name) ? "1px solid gainsboro" : null,
	              borderBottom: _this.categIsSelected(item.name) ? "2px solid grey" : "1px solid gainsboro",
	              borderTopLeftRadius: "5px",
	              borderTopRightRadius: "5px"
	            },
	            onClick: function onClick() {
	              if (item.name === "ALL") {
	                _this.stateChangeHandler({}, "searchFilters", false);
	              } else {
	                _this.stateChangeHandler({ category: item.name }, "searchFilters", false);
	              }
	
	              _this.props.setScroll(true);
	            }
	          }, _react2.default.createElement("div", null, _react2.default.createElement("div", null, item.name, _react2.default.createElement("span", { style: { marginLeft: "3px" } }, _react2.default.createElement("i", { style: { color: item.color }, className: item.icon }))), _react2.default.createElement("div", null, item.banglaText)));
	        });
	      }
	    }, _this.getRegRecs = function () {
	      if (_this.props.myRemitRegs && _this.props.myRemitRegs.length > 0) {
	        return _this.props.myRemitRegs.map(function (reg) {
	          return _react2.default.createElement("table", { className: "table table-bordered" }, _react2.default.createElement("tbody", null, _react2.default.createElement("tr", null, _react2.default.createElement("td", { style: { backgroundColor: "white" } }, "Exchange"), _react2.default.createElement("td", { style: { backgroundColor: "white" } }, reg.exchange)), _react2.default.createElement("tr", null, _react2.default.createElement("td", { style: { backgroundColor: "white" } }, "Status"), _react2.default.createElement("td", { style: { backgroundColor: "white" } }, reg.status))));
	        });
	      }
	    }, _this.getRegStatus = function () {
	      var _ref2;
	
	      return _react2.default.createElement("div", null, _this.props.myRemitRegs && _this.props.myRemitRegs.length > 0 && _react2.default.createElement("p", null, _react2.default.createElement("br", null), _react2.default.createElement("div", null, "Current Registration Status:"), _react2.default.createElement("div", { style: { margin: "10px" } }, _this.getRegRecs())), (!_this.props.myRemitRegs || _this.props.myRemitRegs && _this.props.myRemitRegs.length === 0) && _react2.default.createElement("div", null, _react2.default.createElement("div", { style: { margin: "10px" } }, "You don't have an active exchange account"), _react2.default.createElement("div", { style: { textAlign: "center", padding: "5px" } }, _react2.default.createElement("div", {
	        style: (_ref2 = {
	          width: "50%",
	          padding: "1px",
	          textAlign: "center",
	          border: "1px solid gainsboro",
	          borderRadius: _reactDeviceDetect.isMobile ? "5px" : "0px",
	          backgroundColor: "rgb(30, 101, 144)",
	          margin: "auto"
	        }, _defineProperty(_ref2, "padding", "6px"), _defineProperty(_ref2, "fontWeight", "bold"), _defineProperty(_ref2, "color", "white"), _defineProperty(_ref2, "fontSize", "12px"), _defineProperty(_ref2, "minWidth", "140px"), _ref2),
	        onClick: function onClick() {
	          _this.stateChangeHandler({ category: "REGISTER" }, "searchFilters", false);
	        }
	      }, _react2.default.createElement("div", null, "TAP HERE TO REGISTER")))));
	    }, _this.regCheck = function () {
	      var regStatus = false;
	      if (_this.props.myRemitRegs && _this.props.myRemitRegs.length > 0) {
	        for (var i = 0; i < _this.props.myRemitRegs.length; i++) {
	          if (_this.props.myRemitRegs[i].status && _this.props.myRemitRegs[i].status === "ACTIVE") {
	            regStatus = true;
	          }
	        }
	      }
	      return regStatus;
	    }, _this.getNewRemittance = function () {
	      return _react2.default.createElement("div", null, _react2.default.createElement("div", null, "Prime Test"), _react2.default.createElement("div", null, !_this.regCheck() && _this.getRegStatus()), _this.regCheck() && _react2.default.createElement(_SendRemittance2.default, {
	        myRemitRegs: _this.props.myRemitRegs,
	        onReachApi: _this.props.onReachApi,
	        firebase: _this.props.firebase,
	        agraniRates: _this.props.agraniRates,
	        primeRates: _this.props.primeRates,
	        onAddRecord: _this.props.onAddRecord,
	        myRemitApplication: _this.props.myRemitApplication,
	        setScroll: _this.props.setScroll,
	        cellPhone: _this.props.cellPhone
	      }));
	    }, _this.getViewHistory = function () {
	      return _react2.default.createElement("div", null, "Old Applications");
	    }, _this.getRegistration = function () {
	      return _react2.default.createElement(_RemitRegistration2.default, {
	        firebase: _this.props.firebase,
	        myRemitRegs: _this.props.myRemitRegs,
	        onSendEmail: _this.props.onSendEmail,
	        onNotifyUsers: _this.props.onNotifyUsers,
	        cellPhone: _this.props.cellPhone,
	        setScroll: _this.props.setScroll,
	        regCheck: _this.regCheck()
	      });
	    }, _this.getPayees = function () {
	      return _react2.default.createElement("div", null, "Payees");
	    }, _this.getRegFormField = function (fieldId, placeholder, caption) {
	      return _react2.default.createElement("div", null, _react2.default.createElement("div", {
	        style: {
	          padding: "1px",
	          textAlign: "right",
	          border: "1px solid gainsboro",
	          borderRadius: _reactDeviceDetect.isMobile ? "5px" : "0px",
	          backgroundColor: "white",
	          zIndex: "-9",
	          margin: "5px",
	          fontSize: "12px"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          display: "flex",
	          flexDirection: "row"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          width: "40%",
	          lineHeight: "12px",
	          textAlign: "left",
	          paddingLeft: "5px",
	          margin: "auto"
	        }
	      }, caption), _react2.default.createElement("div", {
	        style: {
	          width: "60%",
	          border: "1px solid gainsboro",
	          borderRadius: "5px",
	          borderTopLeftRadius: "0px",
	          borderBottomLeftRadius: "0px",
	          margin: "2px"
	        }
	      }, _react2.default.createElement(_reactackle.TextField, {
	        value: _this.state.data.payload[fieldId],
	        onChange: function onChange(e) {
	          _this.stateChangeHandler(e.value, fieldId, true);
	          if (fieldId === "textNameBangla") {
	            _this.getBanglaImage(e.value);
	          }
	        },
	        onFocus: function onFocus() {
	          _this.stateChangeHandler(fieldId, "selectedField", false);
	        },
	        onFocusOut: function onFocusOut() {
	          console.log("focus out");
	        },
	        fullWidth: true,
	        placeholder: placeholder
	      })))), _this.state.selectedField && _this.state.selectedField === fieldId && _this.state.availableOptions && _react2.default.createElement("div", {
	        style: {
	          padding: "5px",
	          overflow: "auto",
	          border: "1.5px solid white"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          display: "flex",
	          flexDirection: "row",
	          borderBottom: "1.5px soid white",
	          margin: "-5px",
	          marginBottom: "5px"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          width: "70%",
	          borderBottom: "1.5px solid white",
	          paddingLeft: "5px",
	          textAlign: "left"
	        }
	      }, "Suggestions:"), _react2.default.createElement("div", {
	        style: {
	          width: "30%",
	          textAlign: "right",
	          borderBottom: "1.5px solid white",
	          paddingRight: "5px"
	        },
	        onClick: function onClick() {
	          _this.stateChangeHandler(undefined, "selectedField", false);
	        }
	      }, _react2.default.createElement("icon", {
	        className: "fa fa-close",
	        style: { color: "red", fontSize: "20px" }
	      }))), _this.getSelectionTexts(fieldId)));
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  //single method that work for all fields
	  //takes incoming id of the field and then adds field data to state
	
	
	  _createClass(RemitService, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement("div", null, this.props.regsReady && _react2.default.createElement("div", {
	        style: {
	          padding: "0px"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          margin: "0px",
	          zIndex: "5",
	          width: "100%",
	          display: "flex",
	          alignItems: "flex-end",
	          padding: "2px",
	          flexDirection: "row",
	          maxWidth: "600px"
	        }
	      }, this.getCategTabs()), this.state.searchFilters.category === "SEND" && _react2.default.createElement("div", {
	        style: {
	          backgroundColor: "white",
	          padding: "5px",
	          marginLeft: "4px",
	          marginRight: "4px"
	        }
	      }, this.getNewRemittance()), this.state.searchFilters.category === "STATUS" && _react2.default.createElement("div", {
	        style: {
	          backgroundColor: "white",
	          padding: "5px"
	        }
	      }, this.getViewHistory()), this.state.searchFilters.category === "REGISTER" && _react2.default.createElement("div", {
	        style: {
	          backgroundColor: "white",
	          padding: "5px",
	          marginLeft: "3px",
	          marginRight: "3px"
	        }
	      }, this.getRegistration()), this.state.searchFilters.category === "PAYEES" && _react2.default.createElement("div", {
	        style: {
	          backgroundColor: "white",
	          padding: "5px"
	        }
	      }, this.getPayees())), !this.props.regsReady && _react2.default.createElement("div", null, "Connecting..."));
	    }
	  }]);
	
	  return RemitService;
	}(_react.Component);
	
	exports.default = RemitService;

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.memoryStore = undefined;
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _raf = __webpack_require__(411);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _objectWithoutProperties(obj, keys) {
	  var target = {};for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
	  }return target;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	} /*
	  The MIT License
	  
	  Copyright (c) Jeff Hansen 2018 to present.
	  
	  Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
	  
	  The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
	  
	  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	  */
	
	var memoryStore = exports.memoryStore = {
	  _data: new Map(),
	  get: function get(key) {
	    if (!key) {
	      return null;
	    }
	
	    return this._data.get(key) || null;
	  },
	  set: function set(key, data) {
	    if (!key) {
	      return;
	    }
	    return this._data.set(key, data);
	  }
	};
	
	/**
	 * Component that will save and restore Window scroll position.
	 */
	
	var ScrollPositionManager = function (_React$Component) {
	  _inherits(ScrollPositionManager, _React$Component);
	
	  function ScrollPositionManager(props) {
	    _classCallCheck(this, ScrollPositionManager);
	
	    var _this = _possibleConstructorReturn(this, (ScrollPositionManager.__proto__ || Object.getPrototypeOf(ScrollPositionManager)).apply(this, arguments));
	
	    _this.connectScrollTarget = _this.connectScrollTarget.bind(_this);
	    _this._target = window;
	    return _this;
	  }
	
	  _createClass(ScrollPositionManager, [{
	    key: "connectScrollTarget",
	    value: function connectScrollTarget(node) {
	      this._target = node;
	    }
	  }, {
	    key: "restoreScrollPosition",
	    value: function restoreScrollPosition(pos) {
	      var _this2 = this;
	
	      pos = pos || this.props.scrollStore.get(this.props.scrollKey);
	      if (this._target && pos) {
	        (0, _raf2.default)(function () {
	          scroll(_this2._target, pos.x, pos.y);
	        });
	      }
	    }
	  }, {
	    key: "saveScrollPosition",
	    value: function saveScrollPosition(key) {
	      if (this._target) {
	        var pos = getScrollPosition(this._target);
	        key = key || this.props.scrollKey;
	        this.props.scrollStore.set(key, pos);
	      }
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.restoreScrollPosition();
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.scrollKey !== nextProps.scrollKey) {
	        this.saveScrollPosition();
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      if (this.props.scrollKey !== prevProps.scrollKey) {
	        this.restoreScrollPosition();
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.saveScrollPosition();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          _props$children = _props.children,
	          children = _props$children === undefined ? null : _props$children,
	          props = _objectWithoutProperties(_props, ["children"]);
	
	      return children && children(_extends({}, props, { connectScrollTarget: this.connectScrollTarget }));
	    }
	  }]);
	
	  return ScrollPositionManager;
	}(_react2.default.Component);
	
	exports.default = ScrollPositionManager;
	
	ScrollPositionManager.defaultProps = {
	  scrollStore: memoryStore
	};
	
	function scroll(target, x, y) {
	  if (target instanceof window.Window) {
	    target.scrollTo(x, y);
	  } else {
	    target.scrollLeft = x;
	    target.scrollTop = y;
	  }
	}
	
	function getScrollPosition(target) {
	  if (target instanceof window.Window) {
	    return { x: target.scrollX, y: target.scrollY };
	  }
	
	  return { x: target.scrollLeft, y: target.scrollTop };
	}

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactackle = __webpack_require__(5);
	
	var _reactDeviceDetect = __webpack_require__(6);
	
	var _PhotoUploadPass = __webpack_require__(76);
	
	var _PhotoUploadPass2 = _interopRequireDefault(_PhotoUploadPass);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var SendRemittance = function (_Component) {
	  _inherits(SendRemittance, _Component);
	
	  function SendRemittance() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SendRemittance);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SendRemittance.__proto__ || Object.getPrototypeOf(SendRemittance)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      data: {
	        path: "",
	        payload: {
	          beneficiaryName: "",
	          beneficiaryAddress: "",
	          toCcy: "",
	          selectedExchange: ""
	        }
	      },
	      selectedExchange: "",
	      stage: "input"
	    }, _this.stateChangeHandler = function (val, id, isPayload, postAction) {
	      // console.log(
	      //   "val: " + JSON.stringify(val) + " id: " + id + " isPayload: " + isPayload
	      // );
	      var tmpState = {};
	      tmpState[id] = val;
	
	      if (isPayload) {
	        _this.setState(function (prevState) {
	          if (prevState && prevState.data.payload !== null) {
	            return _extends({}, prevState, {
	              data: _extends({}, prevState.data, {
	                payload: _extends({}, prevState.data.payload, tmpState)
	              })
	            });
	          } else {
	            return _extends({}, prevState, {
	              data: {
	                path: prevState.data.path,
	                payload: _extends({}, tmpState)
	              }
	            });
	          }
	        }, postAction !== undefined && postAction !== null ? postAction : null);
	      } else {
	        _this.setState(function (prevState) {
	          return _extends({}, prevState, tmpState);
	        }, postAction !== undefined && postAction !== null ? postAction : null);
	      }
	    }, _this.getExchanges = function () {
	      var avlblExcgs = _this.props.myRemitRegs.filter(function (exch) {
	        return exch.status === "ACTIVE";
	      });
	      if (avlblExcgs && avlblExcgs.length > 0) {
	        return avlblExcgs.map(function (exch) {
	          var _ref2;
	
	          return _react2.default.createElement("div", { style: { textAlign: "center", padding: "5px" } }, _react2.default.createElement("div", {
	            style: (_ref2 = {
	              width: "80%",
	              padding: "1px",
	              textAlign: "center",
	              border: "1px solid gainsboro",
	              borderRadius: _reactDeviceDetect.isMobile ? "5px" : "0px",
	              backgroundColor: _this.state.data.payload.selectedExchange === exch.exchange ? "rgb(30, 101, 144)" : "gainsboro",
	              margin: "auto"
	            }, _defineProperty(_ref2, "padding", "6px"), _defineProperty(_ref2, "fontWeight", "bold"), _defineProperty(_ref2, "color", _this.state.data.payload.selectedExchange === exch.exchange ? "white" : "black"), _defineProperty(_ref2, "fontSize", "12px"), _defineProperty(_ref2, "minWidth", "140px"), _ref2),
	            onClick: function onClick() {
	              _this.stateChangeHandler(exch.exchange, "selectedExchange", true, null);
	              _this.stateChangeHandler(exch, "customer", true, null);
	              _this.calcAmount("SGD");
	            }
	          }, _react2.default.createElement("div", null, exch.exchange.replace("Pte Ltd", ""))));
	        });
	      }
	    }, _this.getExchangeSelector = function () {
	      return _react2.default.createElement("div", {
	        style: {
	          padding: "5px",
	          border: "1px solid gainsboro",
	          borderRadius: "5px",
	          marginBottom: "10px"
	        }
	      }, (!_this.state.data.payload.selectedExchange || _this.state.data.payload.selectedExchange === "") && _react2.default.createElement("div", null, "Select Exchange Company"), _react2.default.createElement("div", {
	        style: {
	          display: "flex",
	          flexDirection: "row",
	          justifyContent: "space-evenly"
	        }
	      }, _this.getExchanges()), _this.state.data.payload.selectedExchange && _this.state.data.payload.selectedExchange != "" && _this.getRates());
	    }, _this.getLoader = function () {
	      return _react2.default.createElement("div", {
	        style: {
	          textAlign: "center",
	          paddingTop: "10px"
	        }
	      }, _react2.default.createElement(_reactackle.CircleProgress, {
	        indeterminate: true,
	        subtitle: "Loading rates...",
	        circleSize: 20,
	        strokeSize: 2,
	        labelPositionY: "bottom",
	        labelPositionX: "center"
	      }));
	    }, _this.genRateTable = function (rateArray) {
	      if (rateArray && rateArray.length > 0) {
	        return rateArray.map(function (obj) {
	          return _react2.default.createElement("td", {
	            style: {
	              minWidth: "70px",
	              textAlign: "center",
	              padding: "1px",
	              lineHeight: "32px"
	            }
	          }, " " + obj.rate + "  " + obj.toCcy);
	        });
	      }
	    }, _this.getRates = function () {
	      var rates = {};
	      if (_this.state.data.payload.selectedExchange && _this.state.data.payload.selectedExchange.includes("Agrani")) {
	        rates = _this.props.agraniRates;
	      }
	      if (_this.state.data.payload.selectedExchange && _this.state.data.payload.selectedExchange.includes("Prime")) {
	        rates = _this.props.primeRates;
	      }
	
	      return _react2.default.createElement("div", {
	        style: {
	          display: "flex",
	          justifyContent: "center"
	        }
	      }, rates && rates !== undefined && _react2.default.createElement("div", {
	        style: {
	          fontSize: "12px"
	        }
	      }, _react2.default.createElement("table", {
	        className: "table table-bordered",
	        style: { marginBottom: "0px" }
	      }, _react2.default.createElement("tbody", null, _react2.default.createElement("tr", null, _react2.default.createElement("td", {
	        style: {
	          textAlign: "right",
	          minWidth: "70px"
	        }
	      }, "1 SGD =", " "), _this.genRateTable(rates.result))))));
	    }, _this.getRemitForm = function () {
	      return _react2.default.createElement("div", null, _react2.default.createElement("div", null, "Some user help text"), _react2.default.createElement("div", null, "Video link?"));
	    }, _this.getFlag = function (toCcyCode) {
	      if (toCcyCode === "BDT") {
	        return _react2.default.createElement("img", {
	          style: {
	            height: "32px",
	            width: "32px"
	          },
	          src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAF2UlEQVR42sVX3W8UVRQ/587sbneXpaVIMFooiFAFu/1gBQPy0a6YGI2fUV/sg74aUTA++A/45IsPaqI+6aOJJmJMCluIpFCsItIHHwyJGkGCkLaB7e7Ozsy9nnPvnd3ZWkFKiTeZvXfuzpzzO+f8zrlnEFoH0qXg9o1/yMfYjLH96CGxRIrlPPnRvYo2hVUan+NAlsJyOW/dAuB/G5h6fuhtr02807NmPbhkuCLb0eJaCnRNF0oyF7Xsy1dn4crsNCTnvDzCnt5S79NPFNtz7VCt1wCFMIRQTQiLBRIpR1qFaO+lhJW5Djg19QOUD598DZ2hgbHE3sIwUlQc5OAzSvoV6pa9ECeQkiSJlPhS6cCHXhX8L4+/jmJ4oJTZva3oAANATQuHlCPzUMUBGG7WabtGV11EXBLaW0mlIB0CuMbMBnS+VaSYJSralhhCSO/4c2WoHyIADgPYVSAAaADQ5WgvgOYDscJaImDaBdhxNYT95+uwdzaAzqrS+XIhLWC004V31ybhtzYB7QErljbpjWIDgnbJQMIJfmUOagbAYCnz8GDRZZvRXJqEVjl7guSBR/dfTFWgeCUA6SL4yNYYKx2yPskofQUfdSfh1Z40rKS1yelW6xmApBuPQ/DVuAGQ3dlPHhAGgFauSKjJCB4exeeXE3OwKlBQda7PijShnWwXsLOQgVV1slnZMGjrGY7UAfKrNfC+JgCJRwZLbdv6ii6iqT6CQ8HxJwsoI/5KIkx+X4atVyVUhfm/OciaMNTM1ppCM2cDCR+sScH+TSnokGD4RPKVvoT2ie9ZAC4BSD+YL3L8ES0PSIhDymu03DcTwudnK1BNGiFaoe8DBGQqrVv8gc28ydQkdO/JwXSCZIYm/orkcvyF49JMGTE6yR7YWkoVthgPNLKAeaBghqwfP1OFASJePSSlnq/3wca+MS8wMqGC9+9OwIFNbZD1OfUYALlfMggTmmDstAUwuLloagDDExR/1K6eSdBD30xDBYP/pDQ+HFJ0IYWwYccy6GAucBZoAjIRQfOhCWCgp4gcKa1c6WoYUlyXVwP4ffwaVFKLOBRJSYa4gPvaocOT1weQ7O/RhUinoCZWoN20mrx+bry8eAA+AXj0hgAKpUTfBp2GunDIQIMgN0CZQhCOkgfabh4Ah+AKFa6uXcspBDcCkL+nqPOfSCLAnAN8HswS86e+uwY9FXpY3NypkCYSfrbahVc2pyEXJ6FV3gDgMoAH1hdBmrMA9WUqYI2YOXLJh49/rkLFvQkvENZMVUL/ziycyzjghhaAjIqRnRlAeh8DWFeMxKNwGgA4b6cp/n8cL8OdxGR9AN3IEcqk4KFVDjzZl4WV9VArpzpsZq4FUlcF8MdO78fcY4Wx1JZ1wxCRUKe50Gc4pySXzTb6+fVkGQKMTsF/H6z8ItWP+yj9lgXKNmKmGYk8oGxxrpV+fAPveLwwlu5dOyx04TdFiJEK6wHeZaVpElQ6PQdd5FqfQhNgaw+bIJkuKZzodOCZ/qxOQccYrkmtpLQ8IA+wI2hdPXLmAHY9VTiW7V23V/cfNv4Co3Ow2VRwCeXKOHLRh5fPe3B/OYzFHOHUCgc+7ErBEQLQ6be221JnV7MYMRl5XCudOYgbnysczeXXDvHRFxUhfkgIG9BYZ853HkmsOqZzussL9an/J6WpIAUcqqSaTxPTnJieQFkgSvd8M4d/Ooj5FwtHO/LdQ2A9YBoQAdojohXAPK41+mwB1+Mm13+0FTwOAODy6Nk38aGRwrcrert385FqChBau2Mib7ErNS2J3bJpyFy7ODr1FvYO3/tp37P5kSBUpiE17XDslaUZaNFoDmhiBnDsvRMvYDqV3qiEfIli7uqWnP5FgRaKiji2OONta4/Gch6mM6KYhL66lMllPllQ9PZt29FxXXBd3Z5qQIuKALubmpGADreJiYkFP/NaJKdSKURrLr/MayFMPViU25lPSjXe59nzPH2TTCaxXq8v+G14uz7RF5T7N0BMFi4RHEtMAAAAAElFTkSuQmCC"
	        });
	      }
	      if (toCcyCode === "INR") {
	        return _react2.default.createElement("img", {
	          style: {
	            height: "32px",
	            width: "32px"
	          },
	          src: "data:image/png;base64,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"
	        });
	      }
	    }, _this.getCurrencyButton = function (toCcyCode) {
	      return _react2.default.createElement("div", {
	        style: {
	          padding: "1px",
	          paddingLeft: "5px",
	          paddingRight: "5px",
	          textAlign: "center",
	          border: "1px solid gainsboro",
	          borderRadius: _reactDeviceDetect.isMobile ? "5px" : "0px",
	          backgroundColor: _this.state.data.payload.toCcy === toCcyCode ? "rgb(30, 101, 144)" : "gainsboro",
	          marginLeft: "2px",
	          marginRight: "2px",
	
	          fontWeight: "bold",
	          color: _this.state.data.payload.toCcy === toCcyCode ? "white" : "black"
	        },
	        onClick: function onClick() {
	          _this.stateChangeHandler(toCcyCode, "toCcy", true, function () {
	            return _this.calcAmount("SGD");
	          });
	        }
	      }, _react2.default.createElement("span", {
	        style: {
	          marginLeft: "3px",
	          marginRight: "5px"
	        }
	      }, _this.getFlag(toCcyCode)), toCcyCode);
	    }, _this.getAmountsBlock = function () {
	      return _react2.default.createElement("div", {
	        style: {
	          padding: "5px",
	          border: "1px solid gainsboro",
	          borderRadius: "5px",
	          marginBottom: "10px"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          display: "flex",
	          flexDirection: "row",
	          padding: "2px"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          width: "30%",
	          lineHeight: "48px"
	        }
	      }, "To Currency"), _react2.default.createElement("div", {
	        style: {
	          width: "70%",
	          border: "1px solid gainsboro",
	          borderRadius: "5px",
	          borderTopLeftRadius: "0px",
	          borderBottomLeftRadius: "0px",
	          margin: "2px"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          display: "flex",
	          flexDirection: "row",
	          justifyContent: "space-evenly",
	          lineHeight: "24px",
	          margin: "5px"
	        }
	      }, _this.getCurrencyButton("BDT"), " ", _this.getCurrencyButton("INR")))), _react2.default.createElement("div", {
	        style: {
	          display: "flex",
	          flexDirection: "row",
	          padding: "2px"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          width: "30%",
	          lineHeight: "48px"
	        }
	      }, "SGD Amount"), _react2.default.createElement("div", {
	        style: {
	          width: "70%",
	          border: "1px solid gainsboro",
	          borderRadius: "5px",
	          borderTopLeftRadius: "0px",
	          borderBottomLeftRadius: "0px",
	          margin: "2px"
	        }
	      }, _react2.default.createElement(_reactackle.TextField, {
	        value: _this.state.data.payload["sgdAmount"],
	        onChange: function onChange(e) {
	          _this.stateChangeHandler(e.value, "sgdAmount", true, function () {
	            _this.calcAmount("SGD");
	          });
	        },
	        fullWidth: true,
	        placeholder: ""
	      }))), _this.state.data.payload.toCcy && _this.state.data.payload.toCcy !== "" && _react2.default.createElement("div", {
	        style: {
	          display: "flex",
	          flexDirection: "row",
	          padding: "2px"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          width: "30%",
	          lineHeight: "48px"
	        }
	      }, _this.state.data.payload.toCcy, " Amount"), _react2.default.createElement("div", {
	        style: {
	          width: "70%",
	          border: "1px solid gainsboro",
	          borderRadius: "5px",
	          borderTopLeftRadius: "0px",
	          borderBottomLeftRadius: "0px",
	          margin: "2px"
	        }
	      }, _react2.default.createElement(_reactackle.TextField, {
	        value: _this.state.data.payload["destAmount"],
	        onChange: function onChange(e) {
	          _this.stateChangeHandler(e.value, "destAmount", true, function () {
	            _this.calcAmount("destAmount");
	          });
	        },
	        fullWidth: true,
	        placeholder: ""
	      }))));
	    }, _this.getPayeeInputField = function (caption, fldName, multiline, numOfLines) {
	      return _react2.default.createElement("div", {
	        style: {
	          display: "flex",
	          flexDirection: "row",
	          padding: "2px"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          width: "30%",
	          lineHeight: "48px"
	        }
	      }, caption), _react2.default.createElement("div", {
	        style: {
	          width: "70%",
	          border: "1px solid gainsboro",
	          borderRadius: "5px",
	          borderTopLeftRadius: "0px",
	          borderBottomLeftRadius: "0px",
	          margin: "2px",
	          padding: "3px"
	        }
	      }, _react2.default.createElement(_reactackle.TextField, {
	        value: _this.state.data.payload[fldName],
	        onChange: function onChange(e) {
	          _this.stateChangeHandler(e.value, fldName, true);
	        },
	        fullWidth: true,
	        placeholder: "",
	        multiline: multiline,
	        multilineRows: { min: multiline ? numOfLines : 1 }
	      })));
	    }, _this.getBeneficiaryBlock = function () {
	      return _react2.default.createElement("div", {
	        style: {
	          padding: "5px",
	          border: "1px solid gainsboro",
	          borderRadius: "5px",
	          marginBottom: "10px"
	        }
	      }, _react2.default.createElement("div", null, "Payee Info"), _react2.default.createElement("div", {
	        style: {
	          display: "flex",
	          flexDirection: "row",
	          padding: "2px"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          width: "30%",
	          lineHeight: "48px"
	        }
	      }, "Send To"), _react2.default.createElement("div", {
	        style: {
	          width: "70%",
	          border: "1px solid gainsboro",
	          borderRadius: "5px",
	          borderTopLeftRadius: "0px",
	          borderBottomLeftRadius: "0px",
	          margin: "2px",
	          padding: "3px"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          display: "flex",
	          flexDirection: "row",
	          lineHeight: "20px",
	          margin: "auto",
	          overflow: "scroll"
	        }
	      }, _this.getPickUpTypes()))), _this.getPayeeInputField("Name", "payeeName"), _this.getPayeeInputField("Contact", "payeeContact"), _this.getPayeeInputField("Address", "payeeAddress", true, 3), _this.getPayeeInputField("Relation", "payeeRelation"), _this.getPayeeInputField("Purpose", "remitPurpose", true, 3), _this.state.data.payload.pickupType === "BANK ACCOUNT" && _this.getPayeeInputField("Account#", "payeeAccountNumber"), _this.state.data.payload.pickupType === "BANK ACCOUNT" && _this.getPayeeInputField("Account Name", "payeeAccountName", true, 3), _this.state.data.payload.pickupType === "BANK ACCOUNT" && _this.getPayeeInputField("Bank Name", "payeeBankName", true, 3), _react2.default.createElement("div", {
	        style: {
	          padding: "5px",
	          textAlign: "center",
	          border: "1px solid gainsboro",
	          borderRadius: _reactDeviceDetect.isMobile ? "5px" : "0px",
	          backgroundColor: "rgb(30, 101, 144)",
	          margin: "2px",
	          fontWeight: "bold",
	          color: "white"
	        },
	        onClick: function onClick() {
	          _this.stateChangeHandler("photo", "stage", false);
	          _this.props.setScroll(true);
	        }
	      }, "NEXT"));
	    }, _this.getPickUpTypes = function () {
	      if (_this.state.data.payload.selectedExchange && _this.state.data.payload.selectedExchange.includes("Agrani")) {
	        if (_this.state.data.payload.toCcy === "BDT") {
	          return _this.getPickUpButtons(["BKASH", "CASH PICKUP", "BANK ACCOUNT"]);
	        } else {
	          return _this.getPickUpButtons(["CASH PICKUP", "BANK ACCOUNT"]);
	        }
	      }
	
	      if (_this.state.data.payload.selectedExchange && _this.state.data.payload.selectedExchange.includes("Prime")) {
	        return _this.getPickUpButtons(["CASH PICKUP", "BANK ACCOUNT"]);
	      }
	    }, _this.getPickUpButtons = function (btnArray) {
	      //console.log(JSON.stringify(btnArray));
	      if (btnArray && btnArray.length > 0) {
	        return btnArray.map(function (pickupType) {
	          return _react2.default.createElement("span", {
	            style: {
	              padding: "1px",
	              paddingLeft: "5px",
	              paddingRight: "5px",
	              textAlign: "center",
	              border: "1px solid gainsboro",
	              borderRadius: _reactDeviceDetect.isMobile ? "5px" : "0px",
	              backgroundColor: _this.state.data.payload.pickupType === pickupType ? "rgb(30, 101, 144)" : "gainsboro",
	              margin: "2px",
	              fontWeight: "bold",
	              color: _this.state.data.payload.pickupType === pickupType ? "white" : "black"
	            },
	            onClick: function onClick() {
	              _this.stateChangeHandler(pickupType, "pickupType", true);
	            }
	          }, pickupType);
	        });
	      }
	    }, _this.calcAmount = function (fromCcy) {
	      //console.log("ra ra " + fromCcy);
	      var rates = {};
	      if (_this.state.data.payload.selectedExchange && _this.state.data.payload.selectedExchange.includes("Agrani")) {
	        rates = _this.props.agraniRates;
	      }
	      if (_this.state.data.payload.selectedExchange && _this.state.data.payload.selectedExchange.includes("Prime")) {
	        rates = _this.props.primeRates;
	      }
	      if (_this.state.data.payload.toCcy && _this.state.data.payload.toCcy !== "" && rates && rates !== undefined && rates.result && rates.result.length > 0) {
	        if (fromCcy === "SGD") {
	          if (_this.state.data.payload.sgdAmount && _this.state.data.payload.sgdAmount !== "") {
	            //   console.log(
	            //     this.state.data.payload.sgdAmount +
	            //       " : " +
	            //       JSON.stringify(rates.result)
	            //   );
	            //   console.log(
	            //     "calc something here: " +
	            //       this.getTgtAmount(this.state.data.payload.sgdAmount) +
	            //       "  :  " +
	            //       this.getTgtRate(this.state.data.payload.toCcy, rates.result)
	            //   );
	            var srcAmount = _this.getTgtAmount(_this.state.data.payload.sgdAmount);
	            var tgtRate = _this.getTgtRate(_this.state.data.payload.toCcy, rates.result);
	            var tgtAmount = srcAmount * tgtRate;
	            if (!isNaN(tgtAmount)) {
	              _this.stateChangeHandler(tgtAmount.toFixed(2), "destAmount", true);
	              _this.stateChangeHandler(tgtRate, "rate", true);
	            } else {
	              _this.stateChangeHandler("", "destAmount", true);
	            }
	          }
	        } else {
	          var _srcAmount = _this.getTgtAmount(_this.state.data.payload.destAmount);
	          var _tgtRate = _this.getTgtRate(_this.state.data.payload.toCcy, rates.result);
	          var _tgtAmount = _srcAmount / _tgtRate;
	          if (!isNaN(_tgtAmount)) {
	            _this.stateChangeHandler(_tgtAmount.toFixed(2), "sgdAmount", true);
	            _this.stateChangeHandler(_tgtRate, "tgtRate", true);
	          } else {
	            _this.stateChangeHandler("", "sgdAmount", true);
	          }
	        }
	      }
	    }, _this.getTgtRate = function (ccyCode, rates) {
	      if (rates && rates.length > 0) {
	        var tgtRateObj = rates.find(function (rtObj) {
	          return rtObj.toCcy === ccyCode;
	        });
	        //   console.log(
	        //     "ccyCode: " + ccyCode + " tgtRateObj: " + JSON.stringify(tgtRateObj)
	        //   );
	        if (tgtRateObj && tgtRateObj !== undefined && tgtRateObj.toCcy && tgtRateObj.toCcy !== "") {
	          return tgtRateObj.rate;
	        } else {
	          return 1;
	        }
	      } else {
	        return 1;
	      }
	    }, _this.getTgtAmount = function (srcVal) {
	      //console.log("getTgtAmount: " + srcVal);
	      try {
	        if (srcVal && srcVal !== "") {
	          return srcVal;
	        } else {
	          return 0;
	        }
	      } catch (err) {
	        return 0;
	      }
	    }, _this.getInputForm = function () {
	      return _react2.default.createElement("div", null, _react2.default.createElement("div", null, _this.getExchangeSelector()), _this.state.data.payload.selectedExchange && _this.state.data.payload.selectedExchange !== "" && _react2.default.createElement("div", null, _this.getAmountsBlock()), _this.state.data.payload.toCcy && _this.state.data.payload.toCcy !== "" && _react2.default.createElement("div", null, _this.getBeneficiaryBlock()));
	    }, _this.getNextBack = function (stageBack, stageNext) {
	      var _ref3, _ref4;
	
	      return _react2.default.createElement("div", null, _react2.default.createElement("table", { className: "table" }, _react2.default.createElement("tbody", null, _react2.default.createElement("tr", null, _react2.default.createElement("td", { style: { border: "0px" } }, _react2.default.createElement("div", {
	        style: {
	          textAlign: "center",
	          width: "100%"
	        }
	      }, _react2.default.createElement("div", {
	        style: (_ref3 = {
	          width: "50%",
	          padding: "1px",
	          textAlign: "center",
	          border: "1px solid gainsboro",
	          borderRadius: _reactDeviceDetect.isMobile ? "5px" : "0px",
	          backgroundColor: "rgb(30, 101, 144)",
	          margin: "auto"
	        }, _defineProperty(_ref3, "padding", "6px"), _defineProperty(_ref3, "fontWeight", "bold"), _defineProperty(_ref3, "color", "white"), _defineProperty(_ref3, "fontSize", "12px"), _defineProperty(_ref3, "minWidth", "140px"), _ref3),
	        onClick: function onClick() {
	          _this.stateChangeHandler(stageBack, "stage", false);
	          _this.props.setScroll(true);
	        }
	      }, _react2.default.createElement("div", null, _react2.default.createElement("i", { className: "fa fa-arrow-left" }), " BACK")))), _react2.default.createElement("td", { style: { border: "0px" } }, _react2.default.createElement("div", {
	        style: {
	          textAlign: "center",
	          width: "100%"
	        }
	      }, _react2.default.createElement("div", {
	        style: (_ref4 = {
	          width: "50%",
	          padding: "1px",
	          textAlign: "center",
	          border: "1px solid gainsboro",
	          borderRadius: _reactDeviceDetect.isMobile ? "5px" : "0px",
	          backgroundColor: "rgb(30, 101, 144)",
	          margin: "auto"
	        }, _defineProperty(_ref4, "padding", "6px"), _defineProperty(_ref4, "fontWeight", "bold"), _defineProperty(_ref4, "color", "white"), _defineProperty(_ref4, "fontSize", "12px"), _defineProperty(_ref4, "minWidth", "140px"), _ref4),
	        onClick: function onClick() {
	          _this.stateChangeHandler(stageNext, "stage", false);
	          _this.props.setScroll(true);
	        }
	      }, _react2.default.createElement("div", null, "NEXT ", _react2.default.createElement("i", { className: "fa fa-arrow-right" })))))))));
	    }, _this.createRemitAppRec = function () {
	      var cloudPath = "agraniApps/";
	      var recObj = _.cloneDeep(_this.state.data.payload);
	      if (recObj.selectedExchange.includes("Prime")) {
	        cloudPath = "primeApps/";
	      }
	      var passApp = _this.props.firebase.db.ref("/" + cloudPath).push();
	      passApp.set(recObj).catch(function (err) {
	        console.log("some error: " + err);
	      }).then(function (err) {
	        //clear the bucket
	        _this.props.firebase.db.ref("/remSvc" + "/" + _this.props.cellPhone + "/remApps/" + passApp.key).once("value").then(function (snap) {
	          snap.ref.set(recObj);
	        }).catch(function (err) {
	          console.log("some error: " + err);
	        }).then(function (err) {
	          console.log("updated");
	        });
	      });
	    }, _this.getEmailText = function () {
	      var emTxt = "Dear Sir \n Please see below my application";
	      emTxt = emTxt + " for sending remittance as per the following details: \n";
	      emTxt = emTxt + "\n";
	      emTxt = emTxt + "\n";
	      emTxt = emTxt + "Sender Name: " + _this.state.data.payload.customer.senderName + " \n";
	      emTxt = emTxt + "Sender Address: " + _this.state.data.payload.customer.senderAddress + " \n";
	      emTxt = emTxt + "Id Type: " + _this.state.data.payload.customer.idType + " \n";
	      emTxt = emTxt + "ID #: " + _this.state.data.payload.customer.idNumber + " \n";
	      emTxt = emTxt + "Mobile: " + _this.state.data.payload.customer.mobile + " \n";
	      emTxt = tmTxt + "\n";
	      emTxt = tmTxt + "\n";
	      emTxt = tmTxt + "Payment Info: \n";
	      emTxt = tmTxt + "\n";
	      emTxt = tmTxt + "Payee Name: " + _this.state.data.payload.payeeName;
	      emTxt = tmTxt + "Payee Address: " + _this.state.data.payload.payeeAddress;
	      emTxt = tmTxt + "Payee Contact: " + _this.state.data.payload.payeeContact;
	      emTxt = tmTxt + "SGD Amount: " + _this.state.data.payload.sgdAmount;
	      emTxt = tmTxt + "Destination Currency: " + _this.state.data.payload.toCcy;
	      emTxt = tmTxt + "Destination Amount: " + _this.state.data.payload.destAmount;
	      emTxt = tmTxt + "Transfer Type: " + _this.state.data.payload.pickupType;
	      emTxt = tmTxt + "Transfer Type: " + _this.state.data.payload.pickupType;
	
	      emTxt = emTxt + "For any further information please rechout to me at my phone number provided above.\n";
	      emTxt = emTxt + "\n";
	      emTxt = emTxt + "\n Note: \n";
	      emTxt = emTxt + "";
	      emTxt = emTxt + "- This is a system generated email. \n";
	      emTxt = emTxt + " - Information provided above is as per the data provided by users, and it is the responsibility of users to ensure correct input of all information. \n";
	      emTxt = emTxt + "- For any further information please contact the applicant directly \n";
	      emTxt = emTxt + "\n";
	      emTxt = emTxt + "\n";
	      return emTxt;
	    }, _this.getHtmlRow = function (heading, value) {
	      return "<tr><td style='border: 1px solid black;padding: 5px'>" + heading + "</td><td style='border: 1px solid black;padding: 5px'>" + value + "</td></tr>";
	    }, _this.getEmailHtml = function () {
	      var emTxt = "<p>Dear Sir </p><p> Please find below my application for ";
	      emTxt = emTxt + " sending remittance as per the following details: </p>";
	      emTxt = emTxt + "<p></p>";
	      emTxt = emTxt + "<table style='border: 1px solid black;max-width: 450px;min-width:450px'><tbody>";
	      emTxt = emTxt + _this.getHtmlRow("Sender Name", _this.state.data.payload.customer.senderName);
	      emTxt = emTxt + _this.getHtmlRow("Sender Address", _this.state.data.payload.customer.senderAddress);
	      emTxt + _this.getHtmlRow("Id Type", _this.state.data.payload.customer.idType);
	      emTxt = emTxt + _this.getHtmlRow("ID No.", _this.state.data.payload.customer.idNumber);
	
	      emTxt = emTxt + _this.getHtmlRow("Mobile", _this.state.data.payload.customer.mobile);
	      emTxt = emTxt + _this.getHtmlRow("Application Date", _this.state.data.payload.appDate);
	
	      emTxt = emTxt + _this.getHtmlRow("", "");
	      emTxt = emTxt + _this.getHtmlRow("", "");
	      emTxt = emTxt + _this.getHtmlRow("Payment Info", "");
	      emTxt = emTxt + _this.getHtmlRow("Payee Name", _this.state.data.payload.payeeName);
	      emTxt = emTxt + _this.getHtmlRow("Payee Address", _this.state.data.payload.payeeAddress);
	      emTxt = emTxt + _this.getHtmlRow("Payee Contact", _this.state.data.payload.payeeContact);
	      emTxt = emTxt + _this.getHtmlRow("SGD Amount", _this.state.data.payload.sgdAmount);
	      emTxt = emTxt + _this.getHtmlRow("Destination Amount", _this.state.data.payload.destAmount);
	      emTxt = emTxt + _this.getHtmlRow("Destination Currency", _this.state.data.payload.toCcy);
	      emTxt = emTxt + _this.getHtmlRow("Transfer Type", _this.state.data.payload.pickupType);
	
	      emTxt = emTxt + "</tbody></table>";
	      emTxt = emTxt + "<p></p><p></p>";
	
	      emTxt = emTxt + "<p>For any further information please reachout to me at my phone number provided above. </p>";
	
	      emTxt = emTxt + "<p>Notes:</p>";
	
	      emTxt = emTxt + "<ul><li>Information provided in this application, is as per the data provided by users, and it is the responsibility of users to ensure correct input of all information.</li>";
	      emTxt = emTxt + "<li>For any further information please contact the applicant directly</li></ul>";
	      emTxt = emTxt + "</p>";
	      emTxt = emTxt + "<p></p>";
	      return emTxt;
	    }, _this.submitRegistration = function () {
	      var emailParams = {
	        from: '"BCS Remittance Request" helper@brooklynzcommunitysupport.com', // sender address
	        to: "ahmed_fayyaz@outlook.com", // list of receivers
	        subject: "Remittance Request [ " + _this.state.data.payload.senderName + " | " + _this.state.data.payload.idNumber + " | " + _this.props.cellPhone + " ]", // Subject line
	        attachments: [],
	        text: _this.getEmailText(), // plain text body
	        html: _this.getEmailHtml() // html body
	      };
	
	      //get state updated with calc fields
	      Promise.all([_this.stateChangeHandler(true, "generatingStatement", false)]).then(function (res) {
	        //console.log("test test: " + res[1]);
	
	        _this.props.onSendEmail(emailParams).then(function (emailResp) {
	          //this.saveHandler();
	          _this.createRemitRegRec();
	          //   let suppNotifyText =
	          //     "New passport form generated by " +
	          //     this.state.data.payload.textName +
	          //     " (" +
	          //     this.state.data.payload.phoneNumber +
	          //     ").";
	          //this.props.onNotifyUsers(suppNotifyText, ["94562455"]);
	          _this.stateChangeHandler(false, "generatingStatement", false);
	          _this.stateChangeHandler("genInput", "stage", false);
	
	          //   this.props.onAddRecord({
	          //     path: "myPassApplication",
	          //     payload: {}
	          //   });
	        }).catch(function (err) {
	          console.log("Salaaa error: " + err);
	          _this.stateChangeHandler(false, "generatingStatement", false);
	        });
	      });
	      //request new statement
	      //once req completed show the stop loader and show statement
	    }, _this.getReview = function () {
	      var _ref5, _ref6;
	
	      return _react2.default.createElement("div", null, _react2.default.createElement("p", {
	        style: {
	          backgroundColor: "orange",
	          padding: "5px",
	          fontWeight: "bold"
	        }
	      }, "Please carefully review the following information and press the confirm button (\u09A6\u09DF\u09BE\u0995\u09B0\u09C7 \u09A8\u09BF\u099A\u09C7\u09B0 \u09A4\u09A5\u09CD\u09AF\u0997\u09C1\u09B2\u09CB \u09AD\u09BE\u09B2\u0995\u09B0\u09C7 \u09A6\u09C7\u0996\u09C7 \u09A8\u09BF\u09A8, \u09B8\u09AC\u0995\u09BF\u099B\u09C1 \u09A0\u09BF\u0995 \u09A5\u09BE\u0995\u09B2\u09C7 \u09A8\u09BF\u099A\u09C7\u09B0 \"\u0995\u09A8\u09AB\u09BE\u09B0\u09CD\u09AE\" \u09AC\u09BE\u099F\u09A8\u09C7 \u099A\u09BE\u09AA\u09C1\u09A8\u0964):"), _react2.default.createElement("div", null, _react2.default.createElement("p", null, _react2.default.createElement("b", null, "Particulars")), _react2.default.createElement("table", { className: "table table-bordered table-striped" }, _react2.default.createElement("tbody", null, _this.getRow("SGD Amount", _this.state.data.payload.sgdAmount), _this.getRow(_this.state.data.payload.toCcy + " Amount", _this.state.data.payload.destAmount), _this.getRow("Rate", _this.state.data.payload.rate), _this.getRow("Currency", _this.state.data.payload.toCcy), _this.getRow("Payee Name", _this.state.data.payload.payeeName), _this.getRow("Payee Contact", _this.state.data.payload.payeeContact), _this.getRow("Payee Address", _this.state.data.payload.payeeAddress), _this.getRow("Payee Relation", _this.state.data.payload.payeeRelation), _this.getRow("Purpose", _this.state.data.payload.remitPurpose), _this.getRow("Pickup Type", _this.state.data.payload.pickupType), _this.state.data.payload.pickupType === "BANK ACCOUNT" && _this.getRow("Acc Name", _this.state.data.payload.payeeAccountName), _this.state.data.payload.pickupType === "BANK ACCOUNT" && _this.getRow("Acc#", _this.state.data.payload.payeeAccountNumber), _this.state.data.payload.pickupType === "BANK ACCOUNT" && _this.getRow("Bank Name", _this.state.data.payload.payeeBankName)))), _react2.default.createElement("p", null, _react2.default.createElement("span", null, _react2.default.createElement("div", {
	        style: {
	          textAlign: "center",
	          width: "100%"
	        }
	      }, _react2.default.createElement("div", {
	        style: (_ref5 = {
	          width: "50%",
	          padding: "1px",
	          textAlign: "center",
	          border: "1px solid gainsboro",
	          borderRadius: _reactDeviceDetect.isMobile ? "5px" : "0px",
	          backgroundColor: "green",
	          margin: "auto"
	        }, _defineProperty(_ref5, "padding", "6px"), _defineProperty(_ref5, "fontWeight", "bold"), _defineProperty(_ref5, "color", "white"), _defineProperty(_ref5, "fontSize", "12px"), _ref5),
	        onClick: function onClick() {
	          alert("generate email here");
	        }
	      }, _react2.default.createElement("div", null, _react2.default.createElement("i", { className: "fa fa-check" }), " CONFIRM"), _react2.default.createElement("div", null, "\u0995\u09A8\u09AB\u09BE\u09B0\u09CD\u09AE")), _this.state.generatingStatement && _this.getStatementLoader())), !_this.state.generatingStatement && _react2.default.createElement("span", null, _react2.default.createElement("div", {
	        style: {
	          textAlign: "center",
	          width: "100%"
	        }
	      }, _react2.default.createElement("div", {
	        style: (_ref6 = {
	          width: "50%",
	          padding: "1px",
	          textAlign: "center",
	          border: "1px solid gainsboro",
	          borderRadius: _reactDeviceDetect.isMobile ? "5px" : "0px",
	          backgroundColor: "red",
	          margin: "auto"
	        }, _defineProperty(_ref6, "padding", "6px"), _defineProperty(_ref6, "fontWeight", "bold"), _defineProperty(_ref6, "color", "white"), _defineProperty(_ref6, "fontSize", "12px"), _ref6),
	        onClick: function onClick() {
	          _this.stateChangeHandler("input", "stage", false);
	        }
	      }, _react2.default.createElement("div", null, _react2.default.createElement("i", { className: "fa fa-arrow-circle-left" }), " CHANGE"), _react2.default.createElement("div", null, "\u09AA\u09B0\u09BF\u09AC\u09B0\u09CD\u09A4\u09A8 \u0995\u09B0\u09C1\u09A8"))))));
	    }, _this.getPhotoInputForm = function () {
	      return _react2.default.createElement("div", null, _react2.default.createElement("div", null, _react2.default.createElement("div", {
	        style: {
	          backgroundColor: "orange",
	          padding: "5px",
	          fontWeight: "bold",
	          margin: "10px"
	        }
	      }, "Please use internet banking to pay S$", _this.state.data.payload.destAmount, " fee as per the details provided below:"), _react2.default.createElement("div", { style: { margin: "10px" } }, _react2.default.createElement("table", { className: "table table-bordered" }, _react2.default.createElement("tbody", null, _react2.default.createElement("tr", null, _react2.default.createElement("td", { style: { backgroundColor: "white" } }, "Account Name"), _react2.default.createElement("td", { style: { backgroundColor: "white" } }, "ACCOUNT NAME")), _react2.default.createElement("tr", null, _react2.default.createElement("td", { style: { backgroundColor: "white" } }, "Account Number"), _react2.default.createElement("td", { style: { backgroundColor: "white" } }, "888-88-8888-88")), _react2.default.createElement("tr", null, _react2.default.createElement("td", { style: { backgroundColor: "white" } }, "Bank"), _react2.default.createElement("td", { style: { backgroundColor: "white" } }, "Bank Name")), _react2.default.createElement("tr", null, _react2.default.createElement("td", { style: { backgroundColor: "white" } }, "Comments for Recipient / My Initials"), _react2.default.createElement("td", {
	        style: {
	          backgroundColor: "white",
	          border: "2px solid red"
	        }
	      }, "Your Remit ID"))))), _react2.default.createElement("p", null, _react2.default.createElement("div", { style: { margin: "0px", textAlign: "center" } }, _react2.default.createElement(_PhotoUploadPass2.default, {
	        title1: "PAYMENT RECIEPT PHOTO",
	        title2: "ফিস ট্রান্সফার করে থাকলে তার রসিদ এখানে আপলোড করুন",
	        images: _this.state.payPhoto,
	        fieldName: "payPhoto",
	        isPayload: false,
	        stateChangeHandler: _this.stateChangeHandler,
	        disabled: false
	      })), _react2.default.createElement("input", {
	        type: "file",
	        accept: "image/*",
	        id: "uploader",
	        onChange: function onChange(evt) {
	          console.log("clicked");
	          //console.log("triggering main function");
	          event.preventDefault();
	          //console.log(evt.target.result);
	          if (evt.target.files[0]) {
	            _this.idScanTo64(evt.target.files);
	          } else {
	            console.log("gotcha");
	          }
	        },
	        style: {
	          visibility: "hidden",
	          height: "0px"
	        }
	      })), _this.getNextBack("input", "review")));
	    }, _this.getRow = function (heading, value) {
	      return _react2.default.createElement("tr", null, _react2.default.createElement("td", null, heading), _react2.default.createElement("td", null, value));
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SendRemittance, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      //this.stateChangeHandler(true, "rateLoader", false);
	      if (this.props.myRemitApplication && Object.keys(this.props.myRemitApplication).length > 0) {
	        this.setState(this.props.myRemitApplication);
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.props.onAddRecord({
	        path: "myRemitApplication",
	        payload: this.state
	      });
	    }
	
	    //single method that work for all fields
	    //takes incoming id of the field and then adds field data to state
	
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement("div", null, this.state.stage === "input" && this.getInputForm(), this.state.stage === "photo" && this.getPhotoInputForm(), this.state.stage === "review" && this.getReview());
	    }
	  }]);
	
	  return SendRemittance;
	}(_react.Component);
	
	exports.default = SendRemittance;

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(36);
	
	var _reactRedux = __webpack_require__(9);
	
	var _recompose = __webpack_require__(11);
	
	var _Firebase = __webpack_require__(10);
	
	var _actions = __webpack_require__(13);
	
	var _ContentGridVanilla = __webpack_require__(60);
	
	var _ContentGridVanilla2 = _interopRequireDefault(_ContentGridVanilla);
	
	var _reactackle = __webpack_require__(5);
	
	var _getDefs = __webpack_require__(43);
	
	var _getDefs2 = _interopRequireDefault(_getDefs);
	
	var _searchRecords = __webpack_require__(42);
	
	var _getEditView = __webpack_require__(108);
	
	var _getEditView2 = _interopRequireDefault(_getEditView);
	
	var _getMenuList = __webpack_require__(34);
	
	__webpack_require__(53);
	
	var _throttleDebounce = __webpack_require__(54);
	
	var _GridFilters = __webpack_require__(41);
	
	var _GridFilters2 = _interopRequireDefault(_GridFilters);
	
	var _GridDateFilters = __webpack_require__(40);
	
	var _GridDateFilters2 = _interopRequireDefault(_GridDateFilters);
	
	var _reactDeviceDetect = __webpack_require__(6);
	
	var _numeral = __webpack_require__(16);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var _extendedOgDef = __webpack_require__(26);
	
	var _extendedOgDef2 = _interopRequireDefault(_extendedOgDef);
	
	var _getInputField = __webpack_require__(18);
	
	var _getInputField2 = _interopRequireDefault(_getInputField);
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _asyncToGenerator(fn) {
	  return function () {
	    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
	      function step(key, arg) {
	        try {
	          var info = gen[key](arg);var value = info.value;
	        } catch (error) {
	          reject(error);return;
	        }if (info.done) {
	          resolve(value);
	        } else {
	          return Promise.resolve(value).then(function (value) {
	            step("next", value);
	          }, function (err) {
	            step("throw", err);
	          });
	        }
	      }return step("next");
	    });
	  };
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var SupplierAdmin = function (_Component) {
	  _inherits(SupplierAdmin, _Component);
	
	  function SupplierAdmin(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, SupplierAdmin);
	
	    ////console.log("...test... " + JSON.stringify(tableDefs));
	    var _this = _possibleConstructorReturn(this, (SupplierAdmin.__proto__ || Object.getPrototypeOf(SupplierAdmin)).call(this, props));
	
	    _this.handleScroll = function (event) {
	      // console.log(
	      //   "scrolling... " + window.document.querySelector(".content").scrollTop
	      // );
	
	      var last_known_scroll_position = 0;
	      var ticking = false;
	
	      if (_this.state.showGrid) {
	        //console.log("setting scroll pos");
	        last_known_scroll_position = window.document.querySelector(".content").scrollTop;
	
	        if (!ticking) {
	          window.requestAnimationFrame(function () {
	            _this.props.onSetUiFlag("listYPos", window.document.querySelector(".content").scrollTop);
	            ticking = false;
	          });
	
	          ticking = true;
	        }
	      }
	    };
	
	    _this.setScroll = function (setToTop) {
	      //console.log("attempting scroll");
	      var element = window.document.querySelector(".content");
	      if (element && element !== "") {
	        //console.log("setting scroll");
	        if (setToTop) {
	          //console.log("setting to 0");
	          element.scroll(0, 0);
	        } else {
	          //console.log("setting to " + this.props.listYPos);
	          element.scroll(0, parseInt(_this.props.listYPos));
	        }
	      } else {
	        //console.log("element not found");
	      }
	    };
	
	    _this.applyDataCondition = function (singleRecord, dataCondition) {
	      //console.log("~~||~~ " + JSON.stringify(singleRecord));
	      //console.log("~~ in the loop" + JSON.stringify(dataCondition));
	      var tmpRes = false;
	
	      for (var p = 0; p < dataCondition.length; p++) {
	        // console.log(
	        //   "~~~ signRec: " +
	        //     singleRecord[dataCondition[p]["colKey"]] +
	        //     " cond: " +
	        //     dataCondition[p]["colKey"] +
	        //     "=" +
	        //     dataCondition[p]["fieldVal"] +
	        //     " OR " +
	        //     this.props.userProfile[dataCondition[p]["fieldVal"]]
	        // );
	        if (singleRecord[dataCondition[p]["colKey"]] === dataCondition[p]["fieldVal"]) {
	          tmpRes = true;
	        }
	
	        if (singleRecord[dataCondition[p]["colKey"]] === _this.props.userProfile[dataCondition[p]["fieldVal"]]) {
	          tmpRes = true;
	        }
	      }
	      //console.log("~~ returning: " + tmpRes);
	      return tmpRes;
	    };
	
	    _this.loadDataEx = function (allTableDets) {
	      //if (allTableDets.tableName === "visitors") {
	      var recsLimit = 0;
	
	      if (!allTableDets || allTableDets === undefined) {
	        return [];
	      }
	
	      if (_reactDeviceDetect.isMobile) {
	        if (allTableDets.recMobileLimit) {
	          recsLimit = parseInt(allTableDets.recMobileLimit);
	        }
	      } else {
	        if (allTableDets.recMobileLimit) {
	          recsLimit = parseInt(allTableDets.recLimit);
	        }
	      }
	
	      var basePath = "/";
	      var tableName = allTableDets.tableName;
	      if (recsLimit > 0) {
	        _this.props.firebase.db.ref(basePath + tableName).limitToLast(recsLimit).on("value", function (snapshot) {
	          var tmpArray = [];
	          var fbOject = [];
	          Promise.all([snapshot.val()]).then(function (res) {
	            fbOject = res[0];
	            if (fbOject && fbOject !== null && fbOject !== undefined) {
	              Object.keys(fbOject).map(function (key) {
	                var item = _extends({}, fbOject[key], {
	                  key: key
	                });
	                //console.log("~~ Linking " + JSON.stringify(allTableDets));
	                if (allTableDets.dataConditions && allTableDets.dataConditions !== undefined && allTableDets.dataConditions.length > 0) {
	                  //console.log(JSON.stringify(allTableDets.dataConditions));
	                  if (_this.applyDataCondition(item, allTableDets.dataConditions)) {
	                    tmpArray.push(item);
	                  }
	                } else {
	                  tmpArray.push(item);
	                }
	              });
	            }
	            //reverse to have latest at the top
	            tmpArray.reverse();
	            _this.props.onAddRecord({
	              path: tableName,
	              payload: tmpArray
	            });
	          });
	        });
	      } else {
	        _this.props.firebase.db.ref(basePath + tableName).on("value", function (snapshot) {
	          var tmpArray = [];
	          var fbOject = [];
	          Promise.all([snapshot.val()]).then(function (res) {
	            fbOject = res[0];
	            if (fbOject && fbOject !== null && fbOject !== undefined) {
	              Object.keys(fbOject).map(function (key) {
	                var item = _extends({}, fbOject[key], {
	                  key: key
	                });
	                //console.log("~~ Linking " + JSON.stringify(allTableDets));
	                if (allTableDets.dataConditions && allTableDets.dataConditions !== undefined && allTableDets.dataConditions.length > 0) {
	                  //console.log(JSON.stringify(allTableDets.dataConditions));
	                  if (_this.applyDataCondition(item, allTableDets.dataConditions)) {
	                    tmpArray.push(item);
	                  }
	                } else {
	                  tmpArray.push(item);
	                }
	              });
	            }
	            //reverse to have latest at the top
	            tmpArray.reverse();
	            _this.props.onAddRecord({
	              path: tableName,
	              payload: tmpArray
	            });
	          });
	        });
	      }
	      //}
	    };
	
	    _this.loadData = function (tableName, isDeleted) {
	      //console.log(tableName);
	      var recsLimit = 3000;
	      if (_reactDeviceDetect.isMobile) {
	        recsLimit = 2000;
	      }
	      if (tableName === "attendance") {
	        if (_reactDeviceDetect.isMobile) {
	          recsLimit === 2000;
	        } else {
	          recsLimit === 3000;
	        }
	      }
	      var basePath = "/";
	      if (isDeleted) {
	        basePath = "/deletedRecs/";
	      }
	      _this.props.firebase.db.ref(basePath + tableName).limitToLast(recsLimit).on("value", function (snapshot) {
	        ////console.log("Linking " + tableName);
	        var tmpArray = [];
	        var fbOject = [];
	        var projTempArray = [];
	        Promise.all([snapshot.val()]).then(function (res) {
	          //basic updating keys into objects
	          fbOject = res[0];
	          if (fbOject && fbOject !== null && fbOject !== undefined) {
	            tmpArray = Object.keys(fbOject).map(function (key) {
	              return _extends({}, fbOject[key], {
	                key: key
	              });
	            });
	          }
	          //reverse to have latest at the top
	          tmpArray.reverse();
	
	          //filter project table for engineer and contributor
	          if (tableName === "projects" && (_this.props.currUserRole === "ENGINEER" || _this.props.currUserRole === "CONTRIBUTOR")) {
	            projTempArray = tmpArray.filter(function (item) {
	              return item.projectPhase === "IN FLIGHT";
	            });
	
	            //handle delete
	            if (isDeleted) {
	              _this.props.onAddRecord({
	                path: "deleted" + tableName,
	                payload: projTempArray
	              });
	            } else {
	              _this.props.onAddRecord({
	                path: tableName,
	                payload: projTempArray
	              });
	            }
	          } else {
	            //handle delete
	            if (isDeleted) {
	              _this.props.onAddRecord({
	                path: "deleted" + tableName,
	                payload: tmpArray
	              });
	            } else {
	              _this.props.onAddRecord({ path: tableName, payload: tmpArray });
	            }
	          }
	        });
	      });
	    };
	
	    _this.getTopMenu = function () {
	      return _react2.default.createElement("nav", { className: "navbar navbar-default navbar-fixed-top" }, _react2.default.createElement("div", {
	        className: "container-fluid",
	        style: {
	          paddingTop: "25px"
	        }
	      }, _react2.default.createElement("div", { className: "navbar-header" }, _react2.default.createElement("button", {
	        type: "button",
	        className: "pull-left navbar-toggle collapsed",
	        "data-toggle": "collapse",
	        "data-target": "#navMenu",
	        "aria-expanded": "false",
	        style: {
	          marginLeft: "10px"
	        }
	      }, _react2.default.createElement("span", { className: "sr-only" }, "Toggle navigation"), _react2.default.createElement("span", { className: "icon-bar" }), _react2.default.createElement("span", { className: "icon-bar" }), _react2.default.createElement("span", { className: "icon-bar" })), _react2.default.createElement("a", {
	        className: "navbar-brand",
	        href: "#",
	        style: {
	          marginLeft: "-20px",
	          marginRight: "-20px",
	          color: "black"
	        }
	      }, (0, _getMenuList.getCaption)(_this.state.tableName, _this.props.listOfTables, _reactDeviceDetect.isMobile)), _this.state.showGrid && !_this.state.showDash && _react2.default.createElement("button", {
	        type: "button",
	        className: "pull-right navbar-toggle",
	        style: {
	          marginLeft: "10px",
	          marginRight: "10px",
	          marginTop: "10px",
	          paddingRight: "13px",
	          paddingLeft: "13px",
	          paddingTop: "5px",
	          paddingBottom: "5px"
	        }
	      }, _react2.default.createElement("span", {
	        "class": "fa fa-filter fa-lg",
	        "aria-hidden": "true",
	        onClick: function onClick() {
	          _this.setState(function (prevState) {
	            return _extends({}, prevState, {
	              showFilters: !prevState.showFilters
	            });
	          });
	        }
	      })), _this.state.showGrid && _react2.default.createElement("button", {
	        type: "button",
	        className: "pull-right navbar-toggle",
	        style: {
	          marginLeft: "10px",
	          marginRight: "0px",
	          marginTop: "10px",
	          paddingRight: "13px",
	          paddingLeft: "13px",
	          paddingTop: "5px",
	          paddingBottom: "5px"
	        }
	      }, _react2.default.createElement("span", {
	        "class": "fa fa-plus fa-lg",
	        "aria-hidden": "true",
	        onClick: function onClick() {
	          return _this.handleAddNew();
	        }
	      }))), !_this.state.showDash && _this.state.showFilters && _react2.default.createElement("div", {
	        style: {
	          marginTop: "15px",
	          marginBottom: "15px"
	        }
	      }, _this.state.showGrid && _this.state.showFilters && _this.getSearchBar(), _this.state.showGrid && _this.state.showFilters && _this.getFilterDropDowns()), _react2.default.createElement("div", null, _this.getTotals()), _react2.default.createElement("div", { className: "collapse navbar-collapse", id: "navMenu" }, _react2.default.createElement("ul", { className: "nav navbar-nav navbar-left" }, _this.fetchMenus()))));
	    };
	
	    _this.fetchMenus = function () {
	      //console.log("Fetching...");
	      //console.log("Props userMenu: " + JSON.stringify(this.props.userMenus));
	      return (0, _getMenuList.getMenuList)(true, _this.isAdmin(), _this.switchMenu, _this.props.currUserRole, _this.props.userMenus);
	    };
	
	    _this.stateChangeHandler = function (val, id, isPayload) {
	      //console.log("val: " + val + " id: " + id + " isPayload: " + isPayload);
	      var tmpState = {};
	      tmpState[id] = val;
	
	      if (isPayload) {
	        _this.setState(function (prevState) {
	          if (prevState && prevState.data.payload !== null) {
	            return _extends({}, prevState, {
	              data: _extends({}, prevState.data, {
	                payload: _extends({}, prevState.data.payload, tmpState)
	              })
	            });
	          } else {
	            return _extends({}, prevState, {
	              data: {
	                path: prevState.data.path,
	                payload: _extends({}, tmpState)
	              }
	            });
	          }
	        });
	      } else {
	        _this.setState(function (prevState) {
	          return _extends({}, prevState, tmpState);
	        });
	      }
	    };
	
	    _this.logoutApp = function () {
	      var msgToApp = {
	        actionType: "logOut",
	        payload: {}
	      };
	
	      if (window && window.ReactNativeWebView) {
	        //console.log("posing logout message to app");
	        window.ReactNativeWebView.postMessage(JSON.stringify(msgToApp));
	      }
	    };
	
	    _this.switchMenu = function (menuName) {
	      var unhandledMenu = ["checkLists", "clientFeedback", "soa", "chequesPayments", "creditNotes"];
	      if (unhandledMenu.includes(menuName)) {
	        alert("Wheels are spinning.... \nThis feature is coming soon!!!");
	        return;
	      }
	      if (_this.refs && _this.refs.searchText) {
	        _this.refs.searchText.value = "";
	        _this.doDelaySearch();
	      }
	      _this.stateChangeHandler({}, "searchFilters", false);
	      _this.stateChangeHandler({}, "searchDateFilters", false);
	      _this.stateChangeHandler(false, "showPivot", false);
	      if (menuName === "dashboard" || menuName === "bcsHome") {
	        _this.stateChangeHandler(true, "showDash", false);
	        _this.stateChangeHandler(false, "showGrid", false);
	        _this.stateChangeHandler(menuName, "tableName", false);
	      } else if (menuName === "signout") {
	        _this.props.firebase.doSignOut();
	        _this.props.onSignOut();
	        _this.logoutApp();
	        _reactRouter.browserHistory.push("/login");
	      } else {
	        _this.stateChangeHandler(true, "showGrid", false);
	        _this.stateChangeHandler(false, "showDash", false);
	        _this.stateChangeHandler(menuName, "tableName", false);
	        _this.setScroll(true);
	      }
	    };
	
	    _this.isAdmin = function () {
	      return _this.props.isAdmin || _this.props.isSuperAdmin;
	    };
	
	    _this.handleDelete = function (key, path, searchObj) {
	      _this.props.firebase.db.ref("/" + path + "/" + key).remove();
	      _this.genNotification(searchObj, "delete");
	      _this.stateChangeHandler(true, "showGrid", false);
	    };
	
	    _this.handleEdit = function (key, path, fullPayload) {
	      //alert("Here is the key: " + key + " here is the path: " + path);
	      _this.setScroll(true);
	      if (path === "deletedprojectInvoices") {
	        if (window.confirm("Do you wish to restore this item?")) {
	          var cloudPath = "projectInvoices/" + key + "/";
	          _this.props.firebase.db.ref("/" + cloudPath).once("value").then(function (snap) {
	            snap.ref.set(fullPayload);
	          }).catch(function (err) {
	            console.log(err);
	            return "some error: " + err;
	          }).then(function (err) {
	            return _this.handleDelete(key, "deletedRecs/projectInvoices");
	          });
	        }
	      } else {
	        _this.stateChangeHandler(false, "showGrid", false);
	        _this.props.onSelectRecord({ path: path, key: key });
	        _this.props.onSetUiFlag("operationType", "update");
	      }
	    };
	
	    _this.handleAddNew = function () {
	      ////console.log("generating new");
	      var initData = (0, _getMenuList.getInitData)(_this.state.tableName, _this.props.createTable, _this.props.userProfile);
	      if (initData && initData !== undefined) {
	        _this.stateChangeHandler(false, "showGrid", false);
	        _this.props.onSetUiFlag("operationType", "add");
	        _this.props.onSetUiFlag("tableName", _this.state.tableName);
	        _this.props.onAddNew({
	          path: _this.state.tableName,
	          data: _extends({}, initData)
	        });
	      }
	    };
	
	    _this.handleEditCancel = function () {
	      _this.stateChangeHandler(true, "showGrid", false);
	      _this.setScroll(false);
	    };
	
	    _this.getDashView = function () {
	      return _react2.default.createElement("div", null);
	    };
	
	    _this.getFields = function () {
	      ////console.log("test");
	      alert("test");
	    };
	
	    _this.getData = function () {
	      var dTableName = _this.state.tableName;
	      if (_this.state.tableName === "viewReports") {
	        dTableName = "reports";
	      }
	      if (dTableName !== "dashboard" && dTableName !== "bcsHome") {
	        if (_this.state.searchVal === "" && Object(_this.state.searchFilters).keys && Object(_this.state.searchFilters).keys.length === 0) {
	          ////console.log("get data returning all");
	          if (_this.props.db[dTableName] && _this.props.db[dTableName] !== undefined) {
	            return _this.props.db[dTableName].slice(0, 300);
	          } else {
	            return _this.props.db[dTableName];
	          }
	        } else {
	          return (0, _searchRecords.searchRecords)(_this.props.db[dTableName], _this.state.searchVal, _this.state.tableDefs[dTableName].searches, _this.state.searchFilters, _this.state.searchDateFilters);
	        }
	      }
	    };
	
	    _this.doStateUpdateForSearch = function () {
	      _this.setState(function (prevState) {
	        return _extends({}, prevState, {
	          searchVal: _this.refs.searchText.value
	        });
	      });
	    };
	
	    _this.doDelaySearch = function () {
	      ////console.log("doning search...");
	      var q = _this.refs.searchText.value;
	      //this.stateChangeHandler("searchVal", q, false);
	      if (q.length < 5) {
	        _this.getDataThrottled();
	      } else {
	        _this.getDataDebounced();
	      }
	    };
	
	    _this.getSearchBar = function () {
	      return _react2.default.createElement("div", { className: "wrapzz" }, _react2.default.createElement("div", { className: "searchzz" }, _react2.default.createElement("input", {
	        type: "text",
	        className: "searchTermzz",
	        placeholder: "Search...",
	        ref: "searchText",
	        onKeyUp: function onKeyUp() {
	          return _this.doDelaySearch();
	        }
	      }), _react2.default.createElement("button", {
	        type: "submit",
	        className: "searchButtonzz",
	        onClick: function onClick() {
	          _this.setState(function (prevState) {
	            return _extends({}, prevState, {
	              searchVal: _this.refs.searchText.value
	            });
	          });
	          ////console.log("searchText " + this.refs.searchText.value);
	          ////console.log(JSON.stringify(this.state.searchVal));
	        }
	      }, _react2.default.createElement("i", { className: "fa fa-search" }))));
	    };
	
	    _this.getNewButton = function () {
	      if (_this.state.showGrid) {
	        return _react2.default.createElement(_reactackle.Button, {
	          colorScheme: "primary",
	          onPress: function onPress() {
	            return _this.handleAddNew();
	          },
	          text: "Add New"
	        });
	      }
	    };
	
	    _this.recordPoPaymentHandler = function () {};
	
	    _this.getPoPaymentButton = function () {
	      if (_this.state.showGrid && _this.state.tableName === "projectPos") {
	        return _react2.default.createElement("div", {
	          style: {
	            justifyContent: "center",
	            verticalAlign: "middle",
	            padding: "6px",
	            paddingTop: "12px",
	            borderWidth: "0.5px",
	            borderColor: "blue",
	            borderRadius: "2px",
	            backgroundColor: "#2196F3"
	          }
	        }, _react2.default.createElement("a", {
	          href: "javascript:void(0)",
	          "data-toggle": "modal",
	          "data-target": "#myModal",
	          style: {
	            font: "inherit",
	            cursor: "pointer",
	            userSelect: "none",
	            fontFamily: "Open Sans,Helvetica Neue,Helvetica,Roboto,Arial,sans-serif",
	            boxSizing: "border-box",
	            color: "white",
	            textAlign: "inherit",
	            fontSize: "inherit",
	            lineHeight: "1.25",
	            fontWeight: "600",
	            textTransform: "uppercase",
	            paddingTop: "12px"
	          }
	        }, "Add Payment Details"));
	      }
	    };
	
	    _this.getPivotButton = function () {
	      if (_this.state.showGrid && _this.state.tableName !== "reports" && !_reactDeviceDetect.isMobile) {
	        return _react2.default.createElement(_reactackle.Button, {
	          colorScheme: "primary",
	          onPress: function onPress() {
	            return _this.stateChangeHandler(!_this.state.showPivot, "showPivot", false);
	          },
	          text: _this.state.showPivot ? "Show Grid" : "Show Pivot"
	        });
	      }
	    };
	
	    _this.getFiltersList = function () {
	      var filtersList = [];
	      var tableObj = _this.props.createTable.find(function (item) {
	        return item.name === _this.state.tableName;
	      });
	
	      if (tableObj && tableObj !== undefined) {
	        if (tableObj.filters && tableObj.filters !== undefined) {
	          filtersList = tableObj.filters;
	        }
	      }
	
	      return filtersList;
	    };
	
	    _this.getFilterDropDowns = function () {
	      if (_this.state.showGrid) {
	        return _react2.default.createElement("div", null, _react2.default.createElement(_GridFilters2.default, {
	          path: _this.state.tableName,
	          stateHandler: _this.stateChangeHandler,
	          value: _this.state.searchFilters,
	          ogTableDef: _this.state.formDefs,
	          filtersList: _this.getFiltersList()
	        }), _react2.default.createElement(_GridDateFilters2.default, {
	          path: _this.state.tableName,
	          stateHandler: _this.stateChangeHandler,
	          value: _this.state.searchDateFilters,
	          ogTableDef: _this.state.formDefs,
	          filtersList: _this.getFiltersList()
	        }));
	      }
	    };
	
	    _this.getTotals = function () {
	      var totTables = ["projectInvoices", "projectPos"];
	
	      if (totTables.includes(_this.state.tableName)) {
	        var sumField = "";
	        if (_this.state.tableName === "projectInvoices") {
	          sumField = "totalInvoice";
	        } else if (_this.state.tableName === "projectPos") {
	          sumField = "poAmount";
	        }
	        if (sumField !== "") {
	          var filteredRecs = _this.getData();
	          var sum = filteredRecs.reduce(function (totValue, curr) {
	            return totValue + parseFloat(curr[sumField]);
	          }, 0);
	          var gstSum = sum * 1.07;
	          if (_reactDeviceDetect.isMobile) {
	            return _react2.default.createElement("table", { className: "table table-sm", style: { marginBottom: "0px" } }, _react2.default.createElement("tr", null, _react2.default.createElement("td", { style: { width: "50%", textAlign: "left" } }, "TOTAL:", " ", " " + (0, _numeral2.default)(sum.toFixed(2)).format("0,0.00") + "   "), _react2.default.createElement("td", { style: { width: "50%", textAlign: "right" } }, "TOTAL(W GST):", " ", " " + (0, _numeral2.default)(gstSum.toFixed(2)).format("0,0.00"))));
	          } else {
	            return _react2.default.createElement(_reactackle.CardActionsMain, null, _react2.default.createElement("div", {
	              className: "row",
	              style: {
	                marginLeft: "1px",
	                marginRight: "1px",
	                alignItems: "center",
	                padding: "2px",
	                border: "0px",
	                borderBottom: "0px",
	                borderBottomColor: "#cccccc",
	                borderStyle: "solid",
	                paddingBottom: _reactDeviceDetect.isMobile ? "0px" : "2px"
	              }
	            }, _react2.default.createElement("div", {
	              className: "col-sm-2",
	              style: {
	                textAlign: "right",
	                verticalAlign: "center",
	                border: "0px solid gainsboro",
	                width: "80px"
	              }
	            }, _react2.default.createElement("h5", null, "TOTAL")), _react2.default.createElement("div", {
	              className: "col-sm-2",
	              style: {
	                textAlign: "right",
	                verticalAlign: "center",
	                border: "1px solid gainsboro",
	                width: "120px"
	              }
	            }, _react2.default.createElement("h5", null, (0, _numeral2.default)(sum.toFixed(2)).format("0,0.00"))), _react2.default.createElement("div", {
	              className: "col-sm-2",
	              style: {
	                textAlign: "right",
	                verticalAlign: "center",
	                border: "0px solid gainsboro",
	                width: "140px"
	              }
	            }, _react2.default.createElement("h5", null, "TOTAL(W GST)")), _react2.default.createElement("div", {
	              className: "col-sm-2",
	              style: {
	                textAlign: "right",
	                verticalAlign: "center",
	                border: "1px solid gainsboro",
	                width: "120px"
	              }
	            }, _react2.default.createElement("h5", null, (0, _numeral2.default)(gstSum.toFixed(2)).format("0,0.00")))));
	          }
	        }
	      }
	    };
	
	    _this.getTopHeader = function () {
	      if (_reactDeviceDetect.isMobile) {} else {
	        return _react2.default.createElement("div", null, _react2.default.createElement(_reactackle.Card, null, _react2.default.createElement(_reactackle.CardAreaMain, null, _react2.default.createElement(_reactackle.CardContent, null, _react2.default.createElement("div", null, _react2.default.createElement("h1", null, (0, _getMenuList.getCaption)(_this.state.tableName, _this.props.listOfTables, _reactDeviceDetect.isMobile))), _this.getSearchBar(), _this.getFilterDropDowns()), _react2.default.createElement(_reactackle.CardActions, null, _react2.default.createElement(_reactackle.CardActionsSupplemental, null, _this.getNewButton(), _this.getPivotButton(), _this.getPoPaymentButton()), _this.getTotals()))));
	      }
	    };
	
	    _this.getNicerData = function () {
	      var baseData = _this.getData();
	      var tableDefHere = _this.state.tableDefs[_this.state.tableName];
	      var nicerData = baseData.map(function (item) {
	        var tmpObj = {};
	        for (var key in item) {
	          if (tableDefHere && tableDefHere[key] && tableDefHere[key].caption && item[key]) {
	            tmpObj[tableDefHere[key].caption] = item[key];
	          }
	        }
	        return tmpObj;
	      });
	
	      return nicerData;
	    };
	
	    _this.getCsvHeaders = function () {
	      var headerArray = [];
	      var tableDefHere = _this.state.tableDefs[_this.state.tableName];
	      for (var key in tableDefHere) {
	        var tmpObj = {};
	        if (tableDefHere && tableDefHere[key]) {
	          tmpObj["label"] = tableDefHere[key].caption;
	          tmpObj["key"] = key;
	          headerArray.push(tmpObj);
	        }
	      }
	      return headerArray;
	    };
	
	    _this.getGrid = function () {
	      if (_this.state.showGrid) {
	        if (_this.state.tableName !== "reports") {
	          return _react2.default.createElement(_ContentGridVanilla2.default, {
	            data: _this.getData(),
	            tableName: _this.state.tableName,
	            tableDef: _this.state.tableDefs[_this.state.tableName],
	            handleEdit: _this.handleEdit,
	            handleDelete: _this.handleDelete
	          });
	        } else {
	          return _react2.default.createElement(AdvDashboard, {
	            data: _this.getData(),
	            reportData: {
	              attendance: _this.props.db["attendance"],
	              projectPos: _this.props.db["projectPos"],
	              projectInvoices: _this.props.db["projectInvoices"]
	            },
	            tableName: "reports",
	            tableDef: _this.state.tableDefs["reports"],
	            handleEdit: _this.handleEdit,
	            handleDelete: _this.handleDelete
	          });
	        }
	      }
	    };
	
	    _this.getEnrichedString = function (ogString, searchObj) {
	      //console.log(ogString + JSON.stringify(searchObj));
	      var strArray = ogString.split(" ").map(function (word) {
	        //console.log(word + " = " + searchObj[word]);
	        if (searchObj[word] && searchObj[word] !== undefined) {
	          return searchObj[word];
	        } else {
	          return word;
	        }
	      });
	
	      return strArray.join(" ");
	    };
	
	    _this.genNotification = function (recPayload, opType) {
	      var usersList = [];
	      var updateText = undefined;
	      var createText = undefined;
	      var deleteText = undefined;
	      var tableObj = _this.props.createTable.find(function (item) {
	        return item.name === _this.state.tableName;
	      });
	
	      if (tableObj && tableObj !== undefined) {
	        usersList = tableObj.notifyUsers;
	        createText = tableObj.createNotifyText;
	        updateText = tableObj.updateNotifyText;
	        deleteText = tableObj.deleteNotifyText;
	
	        if (opType === "update" && updateText && updateText !== "" && updateText !== null) {
	          //console.log(" updateText: " + updateText + " opType: " + opType);
	          _this.props.onNotifyUsers(_this.getEnrichedString(updateText, recPayload), usersList);
	        } else if (opType === "delete" && deleteText && deleteText !== "" && deleteText !== null) {
	          //console.log(" deleteText: " + deleteText + " opType: " + opType);
	          _this.props.onNotifyUsers(_this.getEnrichedString(deleteText, recPayload), usersList);
	        } else if (opType === "create" && createText && createText !== "" && createText !== null) {
	          //console.log("createText: " + createText + " opType: " + opType);
	          _this.props.onNotifyUsers(_this.getEnrichedString(createText, recPayload), usersList);
	        }
	      }
	    };
	
	    _this.getSelectedPoCount = function () {
	      var poRecs = _this.getData();
	      if (poRecs && poRecs.length && poRecs.length > 0) {
	        return poRecs.length;
	      } else {
	        return 0;
	      }
	    };
	
	    _this.getInputField = function (fieldName, poDefs) {
	      return (0, _getInputField2.default)(fieldName, "projectPos", _this.state.data, _this.stateChangeHandler, false, poDefs, _this.props.db, _reactDeviceDetect.isMobile);
	    };
	
	    _this.getPOPaymentFields = function () {
	      var poDefs = (0, _extendedOgDef2.default)(_this.props.createTable);
	      if (poDefs && poDefs !== undefined && poDefs.projectPos) {
	        //console.log("~~~");
	        //console.log(JSON.stringify(poDefs.projectPos.paymentType));
	        //console.log("~~~: " + JSON.stringify(poDefs.projectPos.paymentType));
	        return _react2.default.createElement("div", null, _this.getInputField("paymentType", poDefs), _this.getInputField("supplierInvoice", poDefs), _this.getInputField("referenceNumber", poDefs), _this.getInputField("paymentDate", poDefs));
	      }
	    };
	
	    _this.getPoPaymentModal = function () {
	      return (
	        //<!-- Modal -->
	        _react2.default.createElement("div", { className: "modal fade", id: "myModal", role: "dialog" }, _react2.default.createElement("div", { className: "modal-dialog" }, _react2.default.createElement("div", { className: "modal-content" }, _react2.default.createElement("div", { className: "modal-header" }, _react2.default.createElement("button", { type: "button", "class": "close", "data-dismiss": "modal" }, "\xD7"), _react2.default.createElement("h4", { className: "modal-title" }, "BULK UPDATE FOR PURCHASE ORDERS")), _react2.default.createElement("div", { className: "modal-body" }, _react2.default.createElement("div", {
	          style: {
	            padding: "20px",
	            backgroundColor: "red",
	            color: "white",
	            fontWeight: "600",
	            marginBottom: "15px"
	          }
	        }, "Please perform this action with utmost care. Once in progress, the upload process cannot be stopped midway.", _react2.default.createElement("p", {
	          style: {
	            fontWeight: "bolder"
	          }
	        }, _this.getSelectedPoCount(), " POs selected for update")), _react2.default.createElement("p", null, "Please fill in following fields and click update"), _react2.default.createElement("div", null, _this.state.tableName === "projectPos" && _this.getPOPaymentFields())), _react2.default.createElement("div", { className: "modal-footer" }, _react2.default.createElement("button", {
	          type: "button",
	          "class": "btn btn-default",
	          onClick: function onClick() {
	            _this.runUpload();
	          }
	        }, "Update"), _react2.default.createElement("button", {
	          type: "button",
	          "class": "btn btn-default",
	          "data-dismiss": "modal"
	        }, "Cancel")))))
	      );
	    };
	
	    _this.runUpload = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	      var allPosFull, allPos, i, currPo;
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              if (!(Object.keys(_this.state.searchFilters).length === 0 && Object.keys(_this.state.searchDateFilters).length === 0 && _this.state.searchVal === "")) {
	                _context.next = 4;
	                break;
	              }
	
	              alert("Please apply some filter criteria before running payment updates");
	              _context.next = 28;
	              break;
	
	            case 4:
	              allPosFull = _this.getData();
	              allPos = _.cloneDeep(allPosFull);
	              i = 0;
	
	            case 7:
	              if (!(i < allPos.length)) {
	                _context.next = 27;
	                break;
	              }
	
	              _context.prev = 8;
	              currPo = allPos[i];
	
	              currPo["paymentType"] = _this.state.data.payload.paymentType;
	              currPo["supplierInvoice"] = _this.state.data.payload.supplierInvoice;
	              currPo["referenceNumber"] = _this.state.data.payload.referenceNumber;
	              currPo["paymentDate"] = _this.state.data.payload.paymentDate;
	              if (currPo.paymentDate === "") {
	                currPo.paymentDate = (0, _moment2.default)().format("DD-MM-YYYY").toString();
	              }
	
	              _context.next = 17;
	              return _this.dataUpdateHandler(currPo, "projectPos/" + currPo.key + "/", "poId");
	
	            case 17:
	              _context.next = 19;
	              return _this.sleep(1000);
	
	            case 19:
	              _context.next = 24;
	              break;
	
	            case 21:
	              _context.prev = 21;
	              _context.t0 = _context["catch"](8);
	
	              console.log("some error: " + _context.t0);
	
	            case 24:
	              i++;
	              _context.next = 7;
	              break;
	
	            case 27:
	              alert("Upload completed");
	
	            case 28:
	            case "end":
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2, [[8, 21]]);
	    }));
	
	    _this.getMainContent = function () {
	      return _react2.default.createElement(_reactackle.MainRegion, null, _this.props.currentUser && _this.props.users && (0, _getMenuList.getSideBar)(false, _this.isAdmin(), _this.switchMenu, _this.props.currUserRole, _this.props.userMenus), _react2.default.createElement(_reactackle.Content, null, _react2.default.createElement(_reactackle.Container, null, _this.state.showGrid && _this.state.showFilters && _this.getTopHeader(), _react2.default.createElement("div", {
	        style: {
	          overflow: "auto",
	          WebkitOverflowScrolling: "touch",
	          scrollBehavior: "smooth",
	          marginTop: "60px"
	        }
	      }, _this.state.showDash && _this.props.userProfile && _this.props.userProfile.userEmail === "ahmed_fayyaz@outlook.com" && _this.getDataUpdating(), _this.getGrid(), _this.state.showDash && _this.getDashView()), !_this.state.showGrid && !_this.state.showDash && _react2.default.createElement("div", {
	        style: {
	          marginTop: _reactDeviceDetect.isMobile ? "-20px" : "-58px"
	        }
	      }, (0, _getEditView2.default)(_this.state.tableName, _this.handleEditCancel, _this.handleDelete, _this.props.create, _this.genNotification))), _react2.default.createElement("div", {
	        style: {
	          minHeight: "500px"
	        }
	      })));
	    };
	
	    _this.sleep = function () {
	      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(milliseconds) {
	        var date, currentDate;
	        return regeneratorRuntime.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                date = Date.now();
	                currentDate = null;
	
	                do {
	                  currentDate = Date.now();
	                } while (currentDate - date < milliseconds);
	
	              case 3:
	              case "end":
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }));
	
	      return function (_x) {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	
	    _this.dataUpdateHandler = function () {
	      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(databucket, cloudPath, idField) {
	        return regeneratorRuntime.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                if (databucket && databucket.key && databucket.key !== "") {
	                  _this.props.firebase.db.ref("/" + cloudPath + "/" + databucket.key + "/").once("value").then(function (snap) {
	                    return snap.ref.set(databucket);
	                  }).catch(function (err) {
	                    console.log("some error: " + err);
	                  }).then(function (err) {
	                    //console.log("Updated Rec: " + databucket[idField]);
	                  });
	                }
	
	              //this.props.handleEditCancel();
	
	              case 1:
	              case "end":
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this2);
	      }));
	
	      return function (_x2, _x3, _x4) {
	        return _ref3.apply(this, arguments);
	      };
	    }();
	
	    _this.dataAddHandler = function () {
	      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(databucket, cloudPath, idField) {
	        var newInv, dbKey;
	        return regeneratorRuntime.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                if (databucket && databucket !== undefined) {
	                  newInv = _this.props.firebase.db.ref("/" + cloudPath).push();
	                  dbKey = newInv.key;
	
	                  newInv.set(databucket).catch(function (err) {
	                    console.log("some error: " + err);
	                  }).then(function (err) {});
	                }
	
	              //this.props.handleEditCancel();
	
	              case 1:
	              case "end":
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this2);
	      }));
	
	      return function (_x5, _x6, _x7) {
	        return _ref4.apply(this, arguments);
	      };
	    }();
	
	    _this.perfDelayUpdates = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
	      return regeneratorRuntime.wrap(function _callee5$(_context5) {
	        while (1) {
	          switch (_context5.prev = _context5.next) {
	            case 0:
	            case "end":
	              return _context5.stop();
	          }
	        }
	      }, _callee5, _this2);
	    }));
	
	    _this.getDataUpdating = function () {
	      // return (
	      //   <div
	      //     style={{
	      //       backgroundColor: "black",
	      //       height: "400px"
	      //     }}
	      //   >
	      //     <div
	      //       style={{
	      //         color: "white"
	      //       }}
	      //     >
	      //       Please do not click on this button
	      //       <div>
	      //         <Button
	      //           colorScheme="primary"
	      //           onPress={() => {
	      //             //this.props.onSetUiFlag("dataUploadButton", true);
	      //             //this.perfDelayUpdates();
	      //             console.log(JSON.stringify(this.props.deliveryRequest));
	      //           }}
	      //           text="Update Action"
	      //         />
	      //       </div>
	      //     </div>
	      //   </div>
	      // );
	    };
	
	    _this.getClients = function () {
	      var allOrders = _this.props.deliveryRequest;
	      if (allOrders && allOrders.length > 0) {
	        return allOrders.map(function (singOrder) {
	          return _react2.default.createElement("tr", null, _react2.default.createElement("td", null, singOrder.name), _react2.default.createElement("td", null, singOrder.author), _react2.default.createElement("td", null, singOrder.mobile), _react2.default.createElement("td", null, singOrder.address));
	        });
	      }
	    };
	
	    _this.state = {
	      data: {
	        path: "",
	        payload: {
	          paymentType: "",
	          supplierInvoice: "",
	          referenceNumber: "",
	          paymentDate: ""
	        }
	      },
	      message: "",
	      hasLoaded: false,
	      tableName: "bcsHome",
	      tableDefs: (0, _getDefs2.default)(_this.props.createTable),
	      searchVal: "",
	      showGrid: false,
	      showDash: true,
	      searchFilters: {},
	      searchDateFilters: {},
	      showFilters: true,
	      showPivot: false,
	      reRenderFlag: false,
	      formDefs: (0, _extendedOgDef2.default)(_this.props.createTable)
	    };
	    _this.getDataDebounced = (0, _throttleDebounce.debounce)(1000, _this.doStateUpdateForSearch);
	    _this.getDataThrottled = (0, _throttleDebounce.throttle)(1000, _this.doStateUpdateForSearch);
	    return _this;
	  }
	
	  _createClass(SupplierAdmin, [{
	    key: "componentDidCatch",
	    value: function componentDidCatch(error, info) {
	      //handle the sending message to backend? store back to db? send notification?
	      console.log("Uncaught : " + error + " | " + info);
	      this.switchMenu("signout");
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.setState(function (prevState) {
	        return _extends({}, prevState, {
	          showFilters: !_reactDeviceDetect.isMobile
	        });
	      });
	
	      //console.log("adding scroll listner");
	      var scrollElement = window.document.querySelector(".content");
	      if (scrollElement && scrollElement !== undefined) {
	        scrollElement.addEventListener("scroll", this.handleScroll, false);
	      }
	
	      if (!this.props.userUid || this.props.userUid === undefined) {
	        console.log("pushing back");
	        _reactRouter.browserHistory.push("/login");
	      } else {
	        //console.log("~ this is admin? " + this.props.isAdmin);
	        var allTableDets = this.props.userMenus;
	        if (allTableDets && allTableDets.length > 0) {
	          for (var k = 0; k < allTableDets.length; k++) {
	            this.loadDataEx(allTableDets[k]);
	          }
	        }
	
	        // this.loadData("projects");
	        // this.loadData("reports");
	        // this.loadData("contacts");
	        // this.loadData("logistics");
	        // this.loadData("notices");
	        // this.loadData("projectDos");
	        // this.loadData("projectPos");
	        // this.loadData("projectQuotes");
	        // this.loadData("suppliers");
	        // this.loadData("tasks");
	        // this.loadData("attendance");
	        // this.props.isAdmin && this.loadData("projectInvoices");
	        this.props.isAdmin && this.loadData("projectInvoices", true);
	        // this.props.isAdmin && this.loadData("projectClaims");
	        // this.props.isAdmin && this.loadData("reports");
	
	        this.props.isAdmin && this.loadData("createFields");
	        this.props.isAdmin && this.loadData("listOfTables");
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      console.log("detaching scroll listner");
	      window.removeEventListener("scroll", this.handleScroll);
	    }
	
	    //single method that work for all fields
	    //takes incoming id of the field and then adds field data to state
	
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement("div", null, this.state.tableName === "projectPos" && this.getPoPaymentModal(), _reactDeviceDetect.isMobile && this.getTopMenu(), _react2.default.createElement("div", {
	        className: "content",
	        style: {
	          marginTop: _reactDeviceDetect.isMobile ? "50px" : "0px"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          minHeight: "50000px"
	        }
	      }, this.getMainContent(), _react2.default.createElement("table", null, _react2.default.createElement("thead", null, _react2.default.createElement("td", null, "NAME"), _react2.default.createElement("td", null, "AUTHOR"), _react2.default.createElement("td", null, "MOBILE"), _react2.default.createElement("td", null, "ADDRESS")), _react2.default.createElement("tbody", null, this.getClients())))));
	    }
	  }]);
	
	  return SupplierAdmin;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    userProfile: state.db.userProfile,
	    userMenus: state.ui.userMenus,
	    users: state.db.users,
	    projects: state.db.projects,
	    attendance: state.db.attendance,
	    contacts: state.db.contacts,
	    logistics: state.db.logistics,
	    notices: state.db.notices,
	    projectInvoices: state.db.projectInvoices,
	    deletedprojectInvoices: state.db.deletedprojectInvoices,
	    projectClaims: state.db.projectClaims,
	    projectDos: state.db.projectDos,
	    projectPos: state.db.projectPos,
	    projectQuotes: state.db.projectQuotes,
	    reports: state.db.reports,
	    suppliers: state.db.suppliers,
	    tasks: state.db.tasks,
	    currentUser: state.db.userProfile,
	    isAdmin: state.ui.isThisAdmin,
	    isSuperAdmin: state.ui.isThisSuperAdmin,
	    userUid: state.ui.userUid,
	    currUserRole: state.ui.currUserRole,
	    createFields: state.db.createFields,
	    createTable: state.db.createTable,
	    testTable: state.db.testTable,
	    listOfTables: state.db.listOfTables,
	    menuDesigner: state.db.menuDesigner,
	    uploadButton: state.ui.dataUploadButton && state.ui.dataUploadButton !== undefined ? state.ui.dataUploadButton : false,
	    db: state.db,
	    listYPos: state.ui.listYPos
	  };
	}
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    onAddRecord: function onAddRecord(data) {
	      return dispatch((0, _actions.actionAddArray2Redux)(data));
	    },
	    onSelectRecord: function onSelectRecord(params) {
	      dispatch((0, _actions.selectARecord)(params));
	      dispatch((0, _actions.setUiFlag)("tableName", params.path));
	    },
	    onAddNew: function onAddNew(data) {
	      return dispatch((0, _actions.initSelectedRecord)(data));
	    },
	    loadStats: function loadStats(parsedRes) {
	      return dispatch((0, _actions.loadAllStats)(parsedRes));
	    },
	    onSetUiFlag: function onSetUiFlag(flagName, flagVal) {
	      return dispatch((0, _actions.setUiFlag)(flagName, flagVal));
	    },
	    onSignOut: function onSignOut() {
	      dispatch((0, _actions.resetRedux)());
	      dispatch((0, _actions.setUiFlag)("userMenus", []));
	    },
	    loadFbData: function loadFbData(tableName, firebase) {
	      return dispatch((0, _actions.loadFbData)(tableName, firebase));
	    },
	    onNotifyUsers: function onNotifyUsers(msgBody, arrayOfUsers) {
	      return dispatch((0, _actions.notifyUsers)(msgBody, arrayOfUsers));
	    },
	    onGetId: function onGetId(data) {
	      return dispatch((0, _actions.getId)(data));
	    },
	    onGetAcctStatement: function onGetAcctStatement(data) {
	      return dispatch((0, _actions.getAcctStatement)(data));
	    },
	    onGetAcctBalance: function onGetAcctBalance(data) {
	      return dispatch((0, _actions.getAcctBalance)(data));
	    }
	  };
	};
	
	exports.default = (0, _recompose.compose)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _Firebase.withFirebase)(SupplierAdmin);

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _recompose = __webpack_require__(11);
	
	var _Firebase = __webpack_require__(10);
	
	var _actions = __webpack_require__(13);
	
	var _WorkerGrid = __webpack_require__(148);
	
	var _WorkerGrid2 = _interopRequireDefault(_WorkerGrid);
	
	var _OpenBazarGrid = __webpack_require__(103);
	
	var _OpenBazarGrid2 = _interopRequireDefault(_OpenBazarGrid);
	
	var _reactackle = __webpack_require__(5);
	
	var _getDefs = __webpack_require__(43);
	
	var _getDefs2 = _interopRequireDefault(_getDefs);
	
	var _searchRecords = __webpack_require__(42);
	
	var _getMenuList = __webpack_require__(34);
	
	__webpack_require__(53);
	
	var _throttleDebounce = __webpack_require__(54);
	
	var _GridFilters = __webpack_require__(41);
	
	var _GridFilters2 = _interopRequireDefault(_GridFilters);
	
	var _GridDateFilters = __webpack_require__(40);
	
	var _GridDateFilters2 = _interopRequireDefault(_GridDateFilters);
	
	var _reactDeviceDetect = __webpack_require__(6);
	
	var _extendedOgDef = __webpack_require__(26);
	
	var _extendedOgDef2 = _interopRequireDefault(_extendedOgDef);
	
	var _getInputField = __webpack_require__(18);
	
	var _getInputField2 = _interopRequireDefault(_getInputField);
	
	var _OrderPad = __webpack_require__(312);
	
	var _OrderPad2 = _interopRequireDefault(_OrderPad);
	
	var _DirectAdmin = __webpack_require__(152);
	
	var _DirectAdmin2 = _interopRequireDefault(_DirectAdmin);
	
	var _rawState = __webpack_require__(62);
	
	var _termsMainPage = __webpack_require__(154);
	
	var _termsMainPage2 = _interopRequireDefault(_termsMainPage);
	
	var _StyledFirebaseAuth = __webpack_require__(183);
	
	var _StyledFirebaseAuth2 = _interopRequireDefault(_StyledFirebaseAuth);
	
	var _SingleRecord = __webpack_require__(77);
	
	var _SingleRecord2 = _interopRequireDefault(_SingleRecord);
	
	var _reactYoutube = __webpack_require__(204);
	
	var _reactYoutube2 = _interopRequireDefault(_reactYoutube);
	
	var _reactLazyLoadImageComponent = __webpack_require__(30);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var WorkerSecure = function (_Component) {
	  _inherits(WorkerSecure, _Component);
	
	  function WorkerSecure(props) {
	    var _this$state;
	
	    _classCallCheck(this, WorkerSecure);
	
	    ////console.log("...test... " + JSON.stringify(tableDefs));
	    //console.log(window.location.hostname + " " + JSON.stringify(localState));
	    var _this = _possibleConstructorReturn(this, (WorkerSecure.__proto__ || Object.getPrototypeOf(WorkerSecure)).call(this, props));
	
	    _this.applyDataCondition = function (singleRecord, dataCondition) {
	      var tmpRes = false;
	
	      for (var p = 0; p < dataCondition.length; p++) {
	        if (singleRecord[dataCondition[p]["colKey"]] === dataCondition[p]["fieldVal"]) {
	          tmpRes = true;
	        }
	
	        if (singleRecord[dataCondition[p]["colKey"]] === _this.props.userProfile[dataCondition[p]["fieldVal"]]) {
	          tmpRes = true;
	        }
	      }
	      //console.log("~~ returning: " + tmpRes);
	      return tmpRes;
	    };
	
	    _this.loadDataEx = function (allTableDets) {
	      var recsLimit = 0;
	
	      if (_reactDeviceDetect.isMobile) {
	        if (allTableDets.recMobileLimit) {
	          recsLimit = parseInt(allTableDets.recMobileLimit);
	        }
	      } else {
	        if (allTableDets.recMobileLimit) {
	          recsLimit = parseInt(allTableDets.recLimit);
	        }
	      }
	
	      var basePath = "/";
	      var tableName = allTableDets.tableName;
	      if (recsLimit > 0) {
	        _this.props.firebase.db.ref(basePath + tableName).limitToLast(recsLimit).on("value", function (snapshot) {
	          var tmpArray = [];
	          var fbOject = [];
	          Promise.all([snapshot.val()]).then(function (res) {
	            fbOject = res[0];
	            if (fbOject && fbOject !== null && fbOject !== undefined) {
	              Object.keys(fbOject).map(function (key) {
	                var item = _extends({}, fbOject[key], {
	                  key: key
	                });
	                //console.log("~~ Linking " + JSON.stringify(allTableDets));
	                if (allTableDets.dataConditions && allTableDets.dataConditions !== undefined && allTableDets.dataConditions.length > 0) {
	                  //console.log(JSON.stringify(allTableDets.dataConditions));
	                  if (_this.applyDataCondition(item, allTableDets.dataConditions)) {
	                    tmpArray.push(item);
	                  }
	                } else {
	                  tmpArray.push(item);
	                }
	              });
	            }
	            //reverse to have latest at the top
	            //tmpArray.reverse();
	            _this.props.onAddRecord({
	              path: tableName,
	              payload: tmpArray
	            });
	          });
	        });
	      } else {
	        _this.props.firebase.db.ref(basePath + tableName).on("value", function (snapshot) {
	          var tmpArray = [];
	          var fbOject = [];
	          Promise.all([snapshot.val()]).then(function (res) {
	            fbOject = res[0];
	            if (fbOject && fbOject !== null && fbOject !== undefined) {
	              Object.keys(fbOject).map(function (key) {
	                var item = _extends({}, fbOject[key], {
	                  key: key
	                });
	                //console.log("~~ Linking " + JSON.stringify(allTableDets));
	                if (allTableDets.dataConditions && allTableDets.dataConditions !== undefined && allTableDets.dataConditions.length > 0) {
	                  //console.log(JSON.stringify(allTableDets.dataConditions));
	                  if (_this.applyDataCondition(item, allTableDets.dataConditions)) {
	                    tmpArray.push(item);
	                  }
	                } else {
	                  tmpArray.push(item);
	                }
	              });
	            }
	            //reverse to have latest at the top
	            //tmpArray.reverse();
	            _this.props.onAddRecord({
	              path: tableName,
	              payload: tmpArray
	            });
	            _this.setState(function (prevState) {
	              return _extends({}, prevState, {
	                formDefs: (0, _extendedOgDef2.default)(_this.props.createTable),
	                tableDefs: (0, _getDefs2.default)(_this.props.createTable)
	              });
	            });
	          });
	        });
	      }
	      //}
	    };
	
	    _this.loadData = function (tableName, isDeleted) {
	      //console.log(tableName);
	      var recsLimit = 3000;
	      if (_reactDeviceDetect.isMobile) {
	        recsLimit = 2000;
	      }
	      if (tableName === "attendance") {
	        if (_reactDeviceDetect.isMobile) {
	          recsLimit === 2000;
	        } else {
	          recsLimit === 3000;
	        }
	      }
	      var basePath = "/";
	      if (isDeleted) {
	        basePath = "/deletedRecs/";
	      }
	      _this.props.firebase.db.ref(basePath + tableName).limitToLast(recsLimit).on("value", function (snapshot) {
	        ////console.log("Linking " + tableName);
	        var tmpArray = [];
	        var fbOject = [];
	        var projTempArray = [];
	        Promise.all([snapshot.val()]).then(function (res) {
	          //basic updating keys into objects
	          fbOject = res[0];
	          if (fbOject && fbOject !== null && fbOject !== undefined) {
	            tmpArray = Object.keys(fbOject).map(function (key) {
	              return _extends({}, fbOject[key], {
	                key: key
	              });
	            });
	          }
	          //reverse to have latest at the top
	          //tmpArray.reverse();
	
	          //filter project table for engineer and contributor
	          if (tableName === "projects" && (_this.props.currUserRole === "ENGINEER" || _this.props.currUserRole === "CONTRIBUTOR")) {
	            projTempArray = tmpArray.filter(function (item) {
	              return item.projectPhase === "IN FLIGHT";
	            });
	
	            //handle delete
	            if (isDeleted) {
	              _this.props.onAddRecord({
	                path: "deleted" + tableName,
	                payload: projTempArray
	              });
	            } else {
	              _this.props.onAddRecord({
	                path: tableName,
	                payload: projTempArray
	              });
	            }
	          } else {
	            //handle delete
	            if (isDeleted) {
	              _this.props.onAddRecord({
	                path: "deleted" + tableName,
	                payload: tmpArray
	              });
	            } else {
	              _this.props.onAddRecord({ path: tableName, payload: tmpArray });
	            }
	          }
	        });
	      });
	    };
	
	    _this.getTopMenu = function () {
	      if (_reactDeviceDetect.isMobile) {
	        return _react2.default.createElement("nav", { className: "navbar navbar-default navbar-fixed-top" }, _react2.default.createElement("div", {
	          className: "container-fluid",
	          style: {
	            paddingTop: "5px"
	          }
	        }, _react2.default.createElement("div", { className: "navbar-header" }, _react2.default.createElement("button", {
	          type: "button",
	          className: "pull-left navbar-toggle collapsed",
	          "data-toggle": "collapse",
	          "data-target": "#navMenu",
	          "aria-expanded": "false",
	          style: {
	            marginLeft: "10px"
	          }
	        }, _react2.default.createElement("span", { className: "sr-only" }, "Toggle navigation"), _react2.default.createElement("span", { className: "icon-bar" }), _react2.default.createElement("span", { className: "icon-bar" }), _react2.default.createElement("span", { className: "icon-bar" })), _react2.default.createElement("a", {
	          className: "navbar-brand",
	          href: "#",
	          style: {
	            marginLeft: "10px",
	            marginRight: "-20px",
	            color: "black"
	          }
	        }, "BCS")), _react2.default.createElement("div", { className: "collapse navbar-collapse", id: "navMenu" }, _react2.default.createElement("ul", { className: "nav navbar-nav navbar-left" }, _this.fetchMenus()))));
	      }
	    };
	
	    _this.fetchMenus = function () {
	      //console.log("Fetching...");
	      //console.log("Props userMenu: " + JSON.stringify(this.props.userMenus));
	      return (0, _getMenuList.getMenuList)(true, _this.isAdmin(), _this.switchMenu, _this.props.currUserRole, _this.props.userMenus);
	    };
	
	    _this.stateChangeHandler = function (val, id, isPayload) {
	      //console.log("val: " + val + " id: " + id + " isPayload: " + isPayload);
	      var tmpState = {};
	      tmpState[id] = val;
	
	      if (isPayload) {
	        _this.setState(function (prevState) {
	          if (prevState && prevState.data.payload !== null) {
	            return _extends({}, prevState, {
	              data: _extends({}, prevState.data, {
	                payload: _extends({}, prevState.data.payload, tmpState)
	              })
	            });
	          } else {
	            return _extends({}, prevState, {
	              data: {
	                path: prevState.data.path,
	                payload: _extends({}, tmpState)
	              }
	            });
	          }
	        });
	      } else {
	        _this.setState(function (prevState) {
	          return _extends({}, prevState, tmpState);
	        });
	      }
	    };
	
	    _this.logoutApp = function () {
	      var msgToApp = {
	        actionType: "logOut",
	        payload: {}
	      };
	
	      if (window && window.ReactNativeWebView) {
	        //console.log("posing logout message to app");
	        window.ReactNativeWebView.postMessage(JSON.stringify(msgToApp));
	      }
	    };
	
	    _this.switchMenu = function (menuName) {
	      if (_this.refs && _this.refs.searchText) {
	        _this.refs.searchText.value = "";
	        _this.doDelaySearch();
	      }
	      _this.stateChangeHandler({}, "searchFilters", false);
	      _this.stateChangeHandler({}, "searchDateFilters", false);
	      _this.stateChangeHandler(false, "showPivot", false);
	
	      if (menuName === "signout") {
	        console.log("signing out");
	        _this.props.firebase.doSignOut();
	        _this.stateChangeHandler("startButtonText", "LOADING ...", false);
	        _this.props.onSignOut();
	        _this.logoutApp();
	        _this.stateChangeHandler("login", "stage", false);
	        _this.stateChangeHandler(false, "isSignIn", false);
	        _this.stateChangeHandler(false, "loginProgress", false);
	        _this.stateChangeHandler("deliveryRequest", "tableName", false);
	      } else {
	        if (menuName === "deliveryRequest") {
	          _this.stateChangeHandler("orderpad", "stage", false);
	        }
	        if (menuName === "openBazar") {
	          _this.stateChangeHandler("openBazarList", "stage", false);
	        }
	        if (menuName === "bcsHome") {
	          _this.stateChangeHandler("login", "stage", false);
	        }
	      }
	    };
	
	    _this.isAdmin = function () {
	      return _this.props.isAdmin || _this.props.isSuperAdmin;
	    };
	
	    _this.handleDelete = function (key, path, searchObj) {
	      _this.props.firebase.db.ref("/" + path + "/" + key).remove();
	      _this.stateChangeHandler(true, "showGrid", false);
	    };
	
	    _this.handleOrderEdit = function (key, path, fullPayload) {
	      if (fullPayload && (fullPayload.status === "" || fullPayload.status === "NEW" || fullPayload.status === undefined || fullPayload.status === "WITH GROCER FOR PRICE")) {
	        console.log("changing stage");
	        _this.stateChangeHandler("orderpad", "stage", false);
	        _this.props.onSelectRecord({ path: path, key: key });
	        _this.props.onSetUiFlag("operationType", "update");
	      }
	    };
	
	    _this.handleBazarEdit = function (key, path, fullPayload) {
	      if (fullPayload) {
	        console.log("changing stage");
	        _this.stateChangeHandler("openBazar", "stage", false);
	        _this.props.onSelectRecord({ path: path, key: key });
	        _this.props.onSetUiFlag("operationType", "update");
	      }
	    };
	
	    _this.handleAddNew = function (stageName) {
	      var initData = (0, _getMenuList.getInitData)(_this.state.tableName, _this.props.createTable, _this.props.userProfile);
	
	      if (initData && initData !== undefined) {
	        _this.stateChangeHandler(stageName, "stage", false);
	
	        _this.props.onSetUiFlag("operationType", "add");
	        _this.props.onSetUiFlag("tableName", _this.state.tableName);
	        _this.props.onAddNew({
	          path: _this.state.tableName,
	          data: _extends({}, initData)
	        });
	      } else {
	        console.log("no init");
	        // console.log(
	        //   "tableName: " +
	        //     this.state.tableName +
	        //     " crTable: " +
	        //     JSON.stringify(this.props.createTable) +
	        //     " " +
	        //     JSON.stringify(initData)
	        // );
	      }
	    };
	
	    _this.backToList = function (listName) {
	      console.log("setting stage to order list");
	      _this.stateChangeHandler(listName, "stage", false);
	    };
	
	    _this.getDashView = function () {
	      return _react2.default.createElement("div", null);
	    };
	
	    _this.getFields = function () {
	      ////console.log("test");
	      alert("test");
	    };
	
	    _this.getData = function () {
	      var dTableName = _this.state.tableName;
	
	      if (_this.state.tableName === "viewReports") {
	        dTableName = "reports";
	      }
	      if (dTableName !== "dashboard") {
	        if (_this.state.tableDefs[dTableName] && _this.state.tableDefs[dTableName] !== undefined && _this.state.refPhoneNumber && _this.state.refPhoneNumber !== "") {
	          return (0, _searchRecords.searchRecords)(_this.props.db[dTableName], _this.state.searchVal, _this.state.tableDefs[dTableName].searches ? _this.state.tableDefs[dTableName].searches : [], _this.state.searchFilters, _this.state.searchDateFilters, _this.state.refPhoneNumber);
	        } else {
	          console.log("returning blank");
	          return [];
	        }
	      }
	    };
	
	    _this.doStateUpdateForSearch = function () {
	      _this.setState(function (prevState) {
	        return _extends({}, prevState, {
	          searchVal: _this.refs.searchText.value
	        });
	      });
	    };
	
	    _this.doDelaySearch = function () {
	      ////console.log("doning search...");
	      var q = _this.refs.searchText.value;
	      //this.stateChangeHandler("searchVal", q, false);
	      if (q.length < 5) {
	        _this.getDataThrottled();
	      } else {
	        _this.getDataDebounced();
	      }
	    };
	
	    _this.getSearchBar = function () {
	      return _react2.default.createElement("div", { className: "wrapzz" }, _react2.default.createElement("div", { className: "searchzz" }, _react2.default.createElement("input", {
	        type: "text",
	        className: "searchTermzz",
	        placeholder: "Search...",
	        ref: "searchText",
	        onKeyUp: function onKeyUp() {
	          return _this.doDelaySearch();
	        }
	      }), _react2.default.createElement("button", {
	        type: "submit",
	        className: "searchButtonzz",
	        onClick: function onClick() {
	          _this.setState(function (prevState) {
	            return _extends({}, prevState, {
	              searchVal: _this.refs.searchText.value
	            });
	          });
	          ////console.log("searchText " + this.refs.searchText.value);
	          ////console.log(JSON.stringify(this.state.searchVal));
	        }
	      }, _react2.default.createElement("i", { className: "fa fa-search" }))));
	    };
	
	    _this.getFiltersList = function () {
	      var filtersList = [];
	      if (_this.props.createTable && _this.props.createTable.length > 0) {
	        var tableObj = _this.props.createTable.find(function (item) {
	          return item.name === _this.state.tableName;
	        });
	
	        if (tableObj && tableObj !== undefined) {
	          if (tableObj.filters && tableObj.filters !== undefined) {
	            filtersList = tableObj.filters;
	          }
	        }
	
	        return filtersList;
	      } else {
	        return [];
	      }
	    };
	
	    _this.getFilterDropDowns = function () {
	      if (_this.state.showGrid) {
	        return _react2.default.createElement("div", null, _react2.default.createElement(_GridFilters2.default, {
	          path: _this.state.tableName,
	          stateHandler: _this.stateChangeHandler,
	          value: _this.state.searchFilters,
	          ogTableDef: _this.state.formDefs,
	          filtersList: _this.getFiltersList()
	        }), _react2.default.createElement(_GridDateFilters2.default, {
	          path: _this.state.tableName,
	          stateHandler: _this.stateChangeHandler,
	          value: _this.state.searchDateFilters,
	          ogTableDef: _this.state.formDefs,
	          filtersList: _this.getFiltersList()
	        }));
	      }
	    };
	
	    _this.getGrid = function () {
	      if (_this.state.stage === "orderlist") {
	        return _react2.default.createElement("div", {
	          style: {
	            overflow: "auto"
	          }
	        }, _react2.default.createElement(_WorkerGrid2.default, {
	          data: _this.getData(),
	          tableName: _this.state.tableName,
	          tableDef: _this.state.tableDefs[_this.state.tableName],
	          handleEdit: _this.handleOrderEdit,
	          handleDelete: _this.handleDelete,
	          role: "worker"
	        }));
	      }
	
	      if (_this.state.stage === "openBazarList") {
	        return _react2.default.createElement("div", {
	          style: {
	            overflow: "auto"
	          }
	        }, _react2.default.createElement(_OpenBazarGrid2.default, {
	          data: _this.getData(),
	          tableName: _this.state.tableName,
	          tableDef: _this.state.tableDefs[_this.state.tableName],
	          handleEdit: _this.handleBazarEdit,
	          handleDelete: _this.handleDelete,
	          role: "worker",
	          phoneNumber: _this.props.firebase.auth.currentUser.phoneNumber
	        }));
	      }
	    };
	
	    _this.getInputField = function (fieldName, poDefs) {
	      return (0, _getInputField2.default)(fieldName, "projectPos", _this.state.data, _this.stateChangeHandler, false, poDefs, _this.props.db, _reactDeviceDetect.isMobile);
	    };
	
	    _this.getNewButton = function () {
	      if (_this.state.showGrid) {
	        return _react2.default.createElement(_reactackle.Button, {
	          colorScheme: "primary",
	          onPress: function onPress() {
	            return _this.handleAddNew("orderpad");
	          },
	          text: "SUBMIT NEW ORDER",
	          fullWidth: true
	        });
	      }
	    };
	
	    _this.getTopHeader = function () {
	      return _react2.default.createElement("table", {
	        className: _reactDeviceDetect.isMobile ? "table table-striped table-bordered table-sm" : "table table-striped table-bordered table-lg"
	      }, _react2.default.createElement("tbody", null, _react2.default.createElement("td", {
	        style: {
	          textAlign: "center",
	          padding: "5px"
	        }
	      }, _this.getNewButton())));
	    };
	
	    _this.getNewBazarButton = function () {
	      if (_this.state.showGrid) {
	        return _react2.default.createElement(_reactackle.Button, {
	          colorScheme: "primary",
	          onPress: function onPress() {
	            return _this.handleAddNew("openBazar");
	          },
	          text: "POST MESSAGE IN BAZAR",
	          fullWidth: true
	        });
	      }
	    };
	
	    _this.getBazarHeader = function () {
	      return _react2.default.createElement("table", {
	        className: _reactDeviceDetect.isMobile ? "table table-striped table-bordered table-sm" : "table table-striped table-bordered table-lg"
	      }, _react2.default.createElement("tbody", null, _react2.default.createElement("td", {
	        style: {
	          textAlign: "center",
	          padding: "5px"
	        }
	      }, _this.getNewBazarButton())));
	    };
	
	    _this.storeAutoLoginToApp = function (phoneNumber) {
	      var elemEmail = document.getElementById("email");
	      var elemPass = document.getElementById("password");
	      var tmpEmail = "";
	      var tmpPass = "";
	      if (elemEmail && elemEmail.value !== "") {
	        tmpEmail = elemEmail.value;
	      }
	
	      if (elemPass && elemPass.value !== "") {
	        tmpPass = elemPass.value;
	      }
	      var msgToApp = {
	        actionType: "storeAutoLogin",
	        payload: {
	          email: tmpEmail,
	          password: tmpPass,
	          company: phoneNumber
	        }
	      };
	
	      if (window && window.ReactNativeWebView) {
	        //console.log("posing autologin message to app");
	        window.ReactNativeWebView.postMessage(JSON.stringify(msgToApp));
	      }
	    };
	
	    _this.getUiForAuth = function () {
	      if (!_this.state.notInitialized && _this.props.firebase && _this.props.firebase.phoneAuthProvider.PROVIDER_ID) {
	        //console.log("heaven");
	        return _react2.default.createElement(_StyledFirebaseAuth2.default, {
	          uiConfig: {
	            // Popup signin flow rather than redirect flow.
	            signInFlow: "popup",
	            // Redirect to /signedIn after sign in is successful. Alternatively you can provide a callbacks.signInSuccess function.
	            signInSuccessUrl: "/workers",
	            // We will display Google and Facebook as auth providers.
	
	            signInOptions: [{
	              provider: _this.props.firebase.phoneAuthProvider.PROVIDER_ID,
	              recaptchaParameters: {
	                type: "image", // 'audio'
	                size: "invisible", // 'invisible' or 'compact'
	                badge: "bottomleft" //' bottomright' or 'inline' applies to invisible.
	              },
	              defaultCountry: "SG", // Set default country to the United Kingdom (+44).
	              // For prefilling the national number, set defaultNationNumber.
	              // This will only be observed if only phone Auth provider is used since
	              // for multiple providers, the NASCAR screen will always render first
	              // with a 'sign in with phone number' button.
	              defaultNationalNumber: "",
	              // You can also pass the full phone number string instead of the
	              // 'defaultCountry' and 'defaultNationalNumber'. However, in this case,
	              // the first country ID that matches the country code will be used to
	              // populate the country selector. So for countries that share the same
	              // country code, the selected country may not be the expected one.
	              // In that case, pass the 'defaultCountry' instead to ensure the exact
	              // country is selected. The 'defaultCountry' and 'defaultNationaNumber'
	              // will always have higher priority than 'loginHint' which will be ignored
	              // in their favor. In this case, the default country will be 'GB' even
	              // though 'loginHint' specified the country code as '+1'.
	              loginHint: ""
	            }]
	          },
	          firebaseAuth: _this.props.firebase.auth
	        });
	      } else {
	        //console.log("hell");
	      }
	    };
	
	    _this.getLoginPage = function () {
	      return _react2.default.createElement("div", {
	        style: {
	          marginTop: "40px"
	        }
	      }, _react2.default.createElement("div", { style: { textAlign: "center" } }, _react2.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, { src: photo.url, style: { minHeight: "200px" } })), _react2.default.createElement("div", {
	        style: {
	          fontSize: "medium",
	          fontWeight: "bold",
	          margin: "5px",
	          textAlign: "center"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          marginTop: "5px"
	        }
	      }, "Welcome to BCS"), _react2.default.createElement("div", {
	        style: {
	          marginTop: "5px",
	          marginBottom: "30px"
	        }
	      })), _react2.default.createElement("div", {
	        style: {
	          border: "0px solid grey",
	          borderRadius: "5px",
	          padding: "5px"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          marginTop: "3px",
	          marginBottom: "3px"
	        }
	      }, _this.getUiForAuth(), window.location.hostname !== _this.state.localhost && _react2.default.createElement("input", {
	        type: "hidden",
	        className: "form-control",
	        id: "company",
	        ref: "company"
	
	        //value="test@test.com"
	      }), window.location.hostname === _this.state.localhost && _react2.default.createElement("input", {
	        type: "hidden",
	        className: "form-control",
	        id: "company",
	        ref: "company",
	        value: _rawState.localState.phoneNumber
	      }), _react2.default.createElement("input", {
	        className: "form-control",
	        id: "email",
	        ref: "email",
	        type: "hidden"
	
	        //value="test@test.com"
	      }), _react2.default.createElement("input", {
	        className: "form-control",
	        id: "password",
	        secure: true,
	        ref: "password",
	        type: "hidden",
	        disabled: _this.state.loginProgress
	      })), _react2.default.createElement("div", {
	        style: {
	          marginTop: "3px",
	          marginBottom: "3px",
	          textAlign: "center",
	          margin: "10px"
	        }
	      })));
	    };
	
	    _this.getMarketingBox = function () {
	      return _react2.default.createElement("div", null, _react2.default.createElement("div", {
	        style: {
	          fontSize: "medium",
	          fontWeight: "bold",
	          margin: "5px",
	          textAlign: "left"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          marginTop: "5px"
	        }
	      }, "We are continously improving to serve you better!")));
	    };
	
	    _this.storeAdmin = function (phoneNumber) {
	      var allMenus = {};
	      var allMenusFromDb = _this.props.menuDesigner;
	
	      if (_this.props.users && _this.props.users.length > 0) {
	        var tgtUser = _this.props.users.find(function (uItem) {
	          if (uItem.userMobile && uItem.userMobile !== "" && uItem.userMobile.includes(phoneNumber)) {
	            //console.log(uItem.userMobile + " is true");
	            return true;
	          } else {
	            //console.log(uItem.userMobile + " is false");
	
	            return false;
	          }
	        });
	
	        //checked and found users
	        if (tgtUser && tgtUser !== undefined) {
	          if (tgtUser.roleName && tgtUser.roleName !== "") {
	            //setting users profile here, this is meant to be the storeadmin or admin
	            _this.props.onAddRecord({
	              path: "userProfile",
	              payload: tgtUser
	            });
	            _this.props.onSetUiFlag("currUserRole", tgtUser.roleName);
	
	            //sorting out user menus
	            if (allMenusFromDb && allMenusFromDb.length > 0) {
	              var userMenu = allMenusFromDb.find(function (singMenu) {
	                return singMenu.name === tgtUser.roleName;
	              });
	              if (userMenu) {
	                allMenus = userMenu.menuItems.map(function (singleMenu) {
	                  var srcTable = _this.props.listOfTables.find(function (item) {
	                    return item.name === singleMenu.tableName;
	                  });
	                  if (srcTable && srcTable !== undefined && srcTable.name) {
	                    return _extends({}, singleMenu, {
	                      menuCaption: srcTable.menu
	                    });
	                  }
	                });
	                var allTableDets = allMenus;
	                if (allTableDets && allTableDets.length > 0) {
	                  for (var k = 0; k < allTableDets.length; k++) {
	                    //console.log(JSON.stringify(allTableDets[k]));
	                    _this.loadDataEx(allTableDets[k]);
	                  }
	                } else {
	                  console.log("tables not linked");
	                }
	                _this.props.onSetUiFlag("userMenus", allMenus);
	              }
	            } else {
	              console.log("menus not received in time");
	            }
	            //returning true for storeAdmin or SuperAdmin
	            return tgtUser.roleName === "STOREADMIN" || tgtUser.roleName === "SUPERADMIN";
	          }
	        } else {
	          //not an admin, this will sendback false and enable worker menus
	          if (allMenusFromDb && allMenusFromDb.length > 0) {
	            var _userMenu = allMenusFromDb.find(function (singMenu) {
	              return singMenu.name === "WORKER";
	            });
	            if (_userMenu) {
	              console.log("found WORKER menu");
	              allMenus = _userMenu.menuItems.map(function (singleMenu) {
	                var srcTable = _this.props.listOfTables.find(function (item) {
	                  return item.name === singleMenu.tableName;
	                });
	                if (srcTable && srcTable !== undefined && srcTable.name) {
	                  return _extends({}, singleMenu, {
	                    menuCaption: srcTable.menu
	                  });
	                }
	              });
	              var _allTableDets = allMenus;
	              if (_allTableDets && _allTableDets.length > 0) {
	                for (var _k = 0; _k < _allTableDets.length; _k++) {
	                  //console.log(JSON.stringify(allTableDets[k]));
	                  _this.loadDataEx(_allTableDets[_k]);
	                }
	              } else {
	                console.log("tables not linked");
	              }
	              _this.props.onSetUiFlag("userMenus", allMenus);
	            }
	          } else {
	            console.log("menus not received in time");
	          }
	        }
	      } else {
	        //alert("users not found " + JSON.stringify(this.props.users));
	      }
	      return false;
	    };
	
	    _this.setupMenusNRole = function (phoneNumber, enterAsWorker) {
	      console.log("setting menus");
	      var thisIsWorker = true;
	      var roleName = "WORKER";
	      if (!enterAsWorker && _this.props.users && _this.props.users.length > 0) {
	        var tgtUser = _this.props.users.find(function (uItem) {
	          if (uItem.userMobile && uItem.userMobile !== "" && uItem.userMobile.includes(phoneNumber)) {
	            //console.log(uItem.userMobile + " is true");
	            return true;
	          } else {
	            //console.log(uItem.userMobile + " is false");
	
	            return false;
	          }
	        });
	
	        if (tgtUser && tgtUser !== undefined) {
	          //admin or store admin
	          if (tgtUser.roleName && tgtUser.roleName !== "") {
	            _this.props.onAddRecord({
	              path: "userProfile",
	              payload: tgtUser
	            });
	            thisIsWorker = false;
	            roleName = tgtUser.roleName;
	          }
	        }
	
	        //setup menus
	        var allMenus = {};
	        var allMenusFromDb = _this.props.menuDesigner;
	        if (allMenusFromDb && allMenusFromDb.length > 0) {
	          var userMenu = allMenusFromDb.find(function (singMenu) {
	            return singMenu.name === roleName;
	          });
	
	          allMenus = userMenu.menuItems.map(function (singleMenu) {
	            var srcTable = _this.props.listOfTables.find(function (item) {
	              return item.name === singleMenu.tableName;
	            });
	            if (srcTable && srcTable !== undefined && srcTable.name) {
	              return _extends({}, singleMenu, {
	                menuCaption: srcTable.menu
	              });
	            }
	          });
	          var allTableDets = allMenus;
	          if (allTableDets && allTableDets.length > 0) {
	            for (var k = 0; k < allTableDets.length; k++) {
	              //console.log(JSON.stringify(allTableDets[k]));
	              _this.loadDataEx(allTableDets[k]);
	            }
	          } else {
	            console.log("tables not linked");
	          }
	          _this.props.onSetUiFlag("userMenus", allMenus);
	          _this.props.onSetUiFlag("currUserRole", roleName);
	        }
	      } else {
	        "roles not setup";
	      }
	    };
	
	    _this.loadBasicData = function (nextAction, enterAsWorker) {
	      console.log("setting up basic stuff");
	      if (_this.props.notLoadedBasicData && _this.props.firebase && _this.props.firebase.auth && _this.props.firebase.auth.currentUser) {
	        var refPhoneNumber = _this.props.firebase.auth.currentUser.phoneNumber;
	        refPhoneNumber = refPhoneNumber.replace("+65", "");
	        _this.storeAutoLoginToApp(refPhoneNumber);
	        _this.props.onSetUiFlag("cellPhone", _this.props.firebase.auth.currentUser.phoneNumber);
	        _this.stateChangeHandler(refPhoneNumber, "refPhoneNumber", "");
	        if (refPhoneNumber !== null && refPhoneNumber !== undefined && refPhoneNumber !== "") {
	          _this.props.loadFbData("createTable", _this.props.firebase, true).then(function (crTableRes) {
	            //console.log("crtable done");
	            _this.props.loadFbData("deliveryRequest", _this.props.firebase, false).then(function (listRes) {
	              //console.log("deliveryRequest done");
	            });
	            _this.props.loadFbData("listOfTables", _this.props.firebase, true).then(function (listRes) {
	              //console.log("listOfTables done");
	              _this.props.loadFbData("menuDesigner", _this.props.firebase, true).then(function (desRes) {
	                console.log("loaded all");
	                _this.props.loadFbData("users", _this.props.firebase, true).then(function (listRes) {
	                  Promise.all([_this.setupMenusNRole(refPhoneNumber, enterAsWorker)]).then(function (resOut) {
	                    console.log("done load all");
	                    if (_this.props.currUserRole === "WORKER") {
	                      //this user is a worker
	                      console.log("entering as non admin now");
	                      if (!enterAsWorker) {
	                        alert("You are not registered as a supplier. Please contact Kabir Hossain at +65 94562455 to sign-up as a supplier.");
	                      } else {
	                        if (nextAction === "orderpad") {
	                          _this.handleAddNew(nextAction);
	                        } else {
	                          _this.stateChangeHandler(nextAction, "stage", false);
	                        }
	                      }
	                    } else {
	                      if (!enterAsWorker) {
	                        console.log("yes this is non worker account");
	                        _this.stateChangeHandler(nextAction, "stage", false);
	                      } else {
	                        //menu problem
	                        if (nextAction === "orderpad") {
	                          _this.handleAddNew(nextAction);
	                        } else {
	                          _this.stateChangeHandler(nextAction, "stage", false);
	                        }
	                      }
	                    }
	                    _this.props.onSetUiFlag("notLoadedBasicData", false);
	                  });
	                });
	              });
	            });
	          }).catch(function (error) {
	            console.log("some error " + error);
	          });
	        }
	      } else {
	        console.log("waiting for auth");
	      }
	    };
	
	    _this.doLogin = function (nextAction, enterAsWorker) {
	      _this.loadBasicData(nextAction, enterAsWorker);
	      console.log("moved in");
	    };
	
	    _this.getMediaEntry = function (vidUrl, headerText, descriptionText, forceWorker, buttonTitle1, nextAction1, buttonTitle2, nextAction2, tableName) {
	      return _react2.default.createElement("div", {
	        style: {
	          textAlign: "center",
	          width: "100%",
	          marginTop: "15px"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          textAlign: "center",
	          border: "2px solid gainsboro",
	          padding: "1px",
	          maxWidth: "800px",
	          margin: "auto",
	          borderRadius: "10px",
	          backgroundColor: "white"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          marginLeft: "5px",
	          marginRight: "5px",
	          textAlign: "left"
	        }
	      }, _react2.default.createElement("h2", {
	        style: {
	          marginTop: "5px"
	        }
	      }, headerText), _react2.default.createElement("div", {
	        style: {
	          marginBottom: "10px",
	          marginTop: "-10px"
	        }
	      }, descriptionText)), _react2.default.createElement(_reactYoutube2.default, {
	        videoId: vidUrl,
	        opts: {
	          height: "240",
	          width: "100%",
	          playerVars: {
	            // https://developers.google.com/youtube/player_parameters
	            autoPlay: 0,
	            controls: 1,
	            loop: 1,
	            modestbranding: 0,
	            rel: 0,
	            showinfo: 0
	          }
	        },
	        onReady: _this._onReady
	      }), _this.props.loginProgress && _react2.default.createElement("div", { style: { margin: "1em" } }, _react2.default.createElement(_reactackle.Preloader, {
	        kind: "linear",
	        indeterminate: true,
	        height: "150",
	        subtitle: "Connecting ...",
	        labelPositionX: "center",
	        labelPositionY: "bottom"
	      })), buttonTitle1 !== "" && nextAction1 !== "" && _react2.default.createElement("div", null, !_this.props.loginProgress && _react2.default.createElement("div", null, _react2.default.createElement("div", {
	        style: {
	          padding: "0.6em 2em",
	          borderRadius: "8px",
	          color: "#fff",
	          backgroundColor: "#1976d2",
	          fontSize: "1.1em",
	          border: "0px",
	          cursor: "pointer",
	          margin: "1em",
	          fontWeight: "bold"
	        },
	        onClick: function onClick() {
	          _this.stateChangeHandler(tableName, "tableName", false);
	          _this.doLogin(nextAction1, forceWorker);
	          window.document.querySelector(".content").scroll(0, 0);
	        }
	      }, buttonTitle1))), buttonTitle2 && buttonTitle2 !== "" && nextAction2 && nextAction2 !== "" && _react2.default.createElement("div", null, !_this.props.loginProgress && _react2.default.createElement("div", null, _react2.default.createElement("div", {
	        style: {
	          padding: "0.6em 2em",
	          borderRadius: "8px",
	          color: "#fff",
	          backgroundColor: "#1976d2",
	          fontSize: "1.1em",
	          border: "0px",
	          cursor: "pointer",
	          margin: "1em",
	          fontWeight: "bold"
	        },
	        onClick: function onClick() {
	          _this.stateChangeHandler(tableName, "tableName", false);
	          _this.doLogin(nextAction1, forceWorker);
	          window.document.querySelector(".content").scroll(0, 0);
	        }
	      }, buttonTitle2)))));
	    };
	
	    _this.getMainContent = function () {
	      return _react2.default.createElement(_reactackle.Container, null, _this.state.stage !== "login" && _this.getTopMenu(), _this.state.isSignedIn && _this.state.stage === "login" && _react2.default.createElement("div", {
	        style: {
	          margin: "auto",
	          textAlign: "center",
	          marginTop: "5px"
	        }
	      }, _react2.default.createElement("h1", null, "Welcome to BCS"), _react2.default.createElement("div", null, "You are signed in as", " ", _this.props.firebase.auth.currentUser.phoneNumber), _react2.default.createElement("div", { style: { marginTop: "5px", marginBottom: "10px" } }, _react2.default.createElement(_reactackle.Button, {
	        text: "Sign Out / Switch Number",
	        colorScheme: "flat",
	        onPress: function onPress() {
	          return _this.switchMenu("signout");
	        },
	        fullWidth: true,
	        radius: "rounded"
	      })), _this.getMediaEntry("zxcNQkLMkbU", "Order Grocery", "With BCS, you can order any thing in seconds. Watch this video to find out more.", true, "ORDER NOW", "orderpad", "VIEW YOUR ORDERS", "orderlist", "deliveryRequest"), _this.getMediaEntry("IMuGBDgqDWw", "Open Bazar", "Connect with community, get updates, share the joy, ask or offer help, buy and sell. Watch this this video to find out more.", false, "ENTER OPEN BAZAR NOW", "openBazarList", "", "", "openBazar"), _this.getMediaEntry("euA3YQsfhFg", "", "Learn BCS", "Watch this video to learn how to use the BCS App for ordering groceries.", ""), _this.getMediaEntry("euA3YQsfhFg", "admin", "Supplier Login", "Watch this video to learn how to use the BCS App if you are our supplier partner.", "ENTER", false), _this.getMediaEntry("euA3YQsfhFg", "", "Join BCS", "Do you want to become a partner with us? Watch this video to find out more or send a whatsapp at +6594562455", ""), _react2.default.createElement("div", { style: { textAlign: "left" } }, (0, _termsMainPage2.default)())), _this.state.stage === "orderlist" && _this.getTopHeader(), _this.state.stage === "openBazarList" && _this.getBazarHeader(), _this.getGrid(), _this.state.stage === "orderpad" && _react2.default.createElement(_OrderPad2.default, {
	        path: _this.state.tableName,
	        backToList: _this.backToList,
	        handleDelete: _this.handleDelete,
	        ogTableDef: (0, _extendedOgDef2.default)(_this.props.createTable),
	        genNotification: _this.genNotification,
	        cellPhone: _this.state.refPhoneNumber
	      }), _this.state.stage === "openBazar" && _react2.default.createElement(_SingleRecord2.default, {
	        path: _this.state.tableName,
	        handleEditCancel: function handleEditCancel() {
	          return _this.backToList("openBazarList");
	        },
	        handleDelete: _this.handleDelete,
	        ogTableDef: (0, _extendedOgDef2.default)(_this.props.createTable),
	        genNotification: function genNotification() {},
	        cellPhone: _this.state.refPhoneNumber
	      }));
	    };
	
	    _this.getLandingPage = function () {
	      var tmpEmail = "";
	      var tmpPassword = "";
	
	      if (_this.refs.email && _this.refs.email.value) {
	        console.log(_this.refs.email.value);
	        tmpEmail = _this.refs.email.value;
	      }
	
	      if (_this.refs.password && _this.refs.password.value) {
	        console.log(_this.refs.password.value);
	        tmpPassword = _this.refs.password.value;
	      }
	
	      return _react2.default.createElement(_DirectAdmin2.default, {
	        company: _this.state.refPhoneNumber,
	        email: tmpEmail,
	        password: tmpPassword,
	        stateChangeHandler: _this.stateChangeHandler
	      });
	    };
	
	    _this.state = (_this$state = {
	      data: {
	        path: "",
	        payload: {
	          paymentType: "",
	          supplierInvoice: "",
	          referenceNumber: "",
	          paymentDate: ""
	        }
	      },
	      message: "",
	      hasLoaded: false,
	      tableName: "deliveryRequest",
	      tableDefs: (0, _getDefs2.default)(_this.props.createTable),
	      searchVal: "",
	      showGrid: true,
	      showDash: false,
	      searchFilters: {},
	      searchDateFilters: {},
	      showFilters: true,
	      showPivot: false,
	      reRenderFlag: false,
	      formDefs: (0, _extendedOgDef2.default)(_this.props.createTable),
	      notInitialized: true,
	      loginProgress: false,
	      logview: [],
	      stage: "login"
	    }, _defineProperty(_this$state, "loginProgress", false), _defineProperty(_this$state, "localhost", _rawState.localState.hostname), _defineProperty(_this$state, "startButtonText", "LOADING ..."), _defineProperty(_this$state, "isSignedIn", true), _defineProperty(_this$state, "notLoadedBasicData", true), _this$state);
	    _this.getDataDebounced = (0, _throttleDebounce.debounce)(1000, _this.doStateUpdateForSearch);
	    _this.getDataThrottled = (0, _throttleDebounce.throttle)(1000, _this.doStateUpdateForSearch);
	    return _this;
	  }
	
	  _createClass(WorkerSecure, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      //    console.log(JSON.stringify(localState));
	      if (this.state.notInitialized && !this.props.firebase.auth && this.props.firebase.auth === undefined) {
	        this.props.onSetUiFlag("operationType", "add");
	
	        this.setState(function (prevState) {
	          return _extends({}, prevState);
	        });
	        this.props.firebase.doInitiate("BROOKLYNZ");
	        this.setState(function (prevState) {
	          return _extends({}, prevState, {
	            notInitialized: false,
	            phoneNumber: window.location.hostname === _this2.state.localhost ? _this2.state.phoneNumber : ""
	          });
	        });
	        this.props.onSetUiFlag("notLoadedBasicData", true);
	      }
	
	      this.unregisterAuthObserver = this.props.firebase.auth.onAuthStateChanged(function (user) {
	        return _this2.setState({ isSignedIn: !!user });
	      });
	      this.props.onSetUiFlag("loginProgress", false);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.unregisterAuthObserver();
	    }
	
	    //single method that work for all fields
	    //takes incoming id of the field and then adds field data to state
	
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement("div", null, _react2.default.createElement("div", { className: "content" }, this.state.stage === "admin" && this.getLandingPage(), _react2.default.createElement("div", null, this.state.stage !== "admin" && this.getMainContent())));
	    }
	  }]);
	
	  return WorkerSecure;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  var _ref;
	
	  return _ref = {
	    userProfile: state.db.userProfile,
	    userMenus: state.ui.userMenus,
	    users: state.db.users,
	    projects: state.db.projects,
	    attendance: state.db.attendance,
	    contacts: state.db.contacts,
	    logistics: state.db.logistics,
	    notices: state.db.notices,
	    projectInvoices: state.db.projectInvoices,
	    deletedprojectInvoices: state.db.deletedprojectInvoices,
	    projectClaims: state.db.projectClaims,
	    projectDos: state.db.projectDos,
	    projectPos: state.db.projectPos,
	    projectQuotes: state.db.projectQuotes,
	    reports: state.db.reports,
	    suppliers: state.db.suppliers,
	    tasks: state.db.tasks,
	    currentUser: state.db.userProfile,
	    isAdmin: state.ui.isThisAdmin,
	    isSuperAdmin: state.ui.isThisSuperAdmin,
	    userUid: state.ui.userUid,
	    currUserRole: state.ui.currUserRole,
	    createFields: state.db.createFields,
	    createTable: state.db.createTable,
	    testTable: state.db.testTable,
	    listOfTables: state.db.listOfTables,
	    menuDesigner: state.db.menuDesigner,
	    cellPhone: state.ui.cellPhone,
	    uploadButton: state.ui.dataUploadButton && state.ui.dataUploadButton !== undefined ? state.ui.dataUploadButton : false,
	    db: state.db,
	    loginProgress: state.ui.loginProgress
	  }, _defineProperty(_ref, "userMenus", state.ui.userMenus), _defineProperty(_ref, "notLoadedBasicData", state.ui.notLoadedBasicData), _ref;
	}
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    onAddRecord: function onAddRecord(data) {
	      return dispatch((0, _actions.actionAddArray2Redux)(data));
	    },
	    onSelectRecord: function onSelectRecord(params) {
	      dispatch((0, _actions.selectARecord)(params));
	      dispatch((0, _actions.setUiFlag)("tableName", params.path));
	    },
	    onAddNew: function onAddNew(data) {
	      return dispatch((0, _actions.initSelectedRecord)(data));
	    },
	    loadStats: function loadStats(parsedRes) {
	      return dispatch((0, _actions.loadAllStats)(parsedRes));
	    },
	    onSetUiFlag: function onSetUiFlag(flagName, flagVal) {
	      return dispatch((0, _actions.setUiFlag)(flagName, flagVal));
	    },
	    onSignOut: function onSignOut() {
	      dispatch((0, _actions.resetRedux)());
	      dispatch((0, _actions.setUiFlag)("userMenus", []));
	    },
	    loadFbData: function loadFbData(tableName, firebase, onceOnly) {
	      return dispatch((0, _actions.loadFbData)(tableName, firebase, onceOnly));
	    },
	    onNotifyUsers: function onNotifyUsers(msgBody, arrayOfUsers) {
	      return dispatch((0, _actions.notifyUsers)(msgBody, arrayOfUsers));
	    },
	    onGetId: function onGetId(data) {
	      return dispatch((0, _actions.getId)(data));
	    },
	    onGetAcctStatement: function onGetAcctStatement(data) {
	      return dispatch((0, _actions.getAcctStatement)(data));
	    },
	    onGetAcctBalance: function onGetAcctBalance(data) {
	      return dispatch((0, _actions.getAcctBalance)(data));
	    },
	    onAddArray: function onAddArray(data) {
	      return dispatch((0, _actions.actionAddArray2Redux)(data));
	    }
	  };
	};
	
	exports.default = (0, _recompose.compose)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _Firebase.withFirebase)(WorkerSecure);

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	};
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(36);
	
	var _reactRedux = __webpack_require__(9);
	
	var _recompose = __webpack_require__(11);
	
	var _Firebase = __webpack_require__(10);
	
	var _actions = __webpack_require__(13);
	
	var _WorkerGrid = __webpack_require__(148);
	
	var _WorkerGrid2 = _interopRequireDefault(_WorkerGrid);
	
	var _ContentGridVanilla = __webpack_require__(60);
	
	var _ContentGridVanilla2 = _interopRequireDefault(_ContentGridVanilla);
	
	var _OpenBazarGrid = __webpack_require__(103);
	
	var _OpenBazarGrid2 = _interopRequireDefault(_OpenBazarGrid);
	
	var _AdminGrid = __webpack_require__(146);
	
	var _AdminGrid2 = _interopRequireDefault(_AdminGrid);
	
	var _MyShopGrid = __webpack_require__(147);
	
	var _MyShopGrid2 = _interopRequireDefault(_MyShopGrid);
	
	var _getDefs = __webpack_require__(43);
	
	var _getDefs2 = _interopRequireDefault(_getDefs);
	
	var _searchRecords = __webpack_require__(42);
	
	var _getMenuList = __webpack_require__(34);
	
	__webpack_require__(53);
	
	var _throttleDebounce = __webpack_require__(54);
	
	var _GridFilters = __webpack_require__(41);
	
	var _GridFilters2 = _interopRequireDefault(_GridFilters);
	
	var _GridDateFilters = __webpack_require__(40);
	
	var _GridDateFilters2 = _interopRequireDefault(_GridDateFilters);
	
	var _reactDeviceDetect = __webpack_require__(6);
	
	var _extendedOgDef = __webpack_require__(26);
	
	var _extendedOgDef2 = _interopRequireDefault(_extendedOgDef);
	
	var _getInputField = __webpack_require__(18);
	
	var _getInputField2 = _interopRequireDefault(_getInputField);
	
	var _DirectAdmin = __webpack_require__(152);
	
	var _DirectAdmin2 = _interopRequireDefault(_DirectAdmin);
	
	var _rawState = __webpack_require__(62);
	
	var _termsMainPage = __webpack_require__(154);
	
	var _termsMainPage2 = _interopRequireDefault(_termsMainPage);
	
	var _reactFirebaseui = __webpack_require__(438);
	
	var _imageText = __webpack_require__(327);
	
	var _bcsShopImage = __webpack_require__(324);
	
	var _bcsOpenBazarImage = __webpack_require__(322);
	
	var _bcsPassportSvcImage = __webpack_require__(323);
	
	var _hcommImage = __webpack_require__(326);
	
	var _SingleRecord = __webpack_require__(77);
	
	var _SingleRecord2 = _interopRequireDefault(_SingleRecord);
	
	var _BuyFromShopGrid = __webpack_require__(286);
	
	var _BuyFromShopGrid2 = _interopRequireDefault(_BuyFromShopGrid);
	
	var _OrderPadDirectSupplier = __webpack_require__(313);
	
	var _OrderPadDirectSupplier2 = _interopRequireDefault(_OrderPadDirectSupplier);
	
	var _BgdPassportService = __webpack_require__(307);
	
	var _BgdPassportService2 = _interopRequireDefault(_BgdPassportService);
	
	var _BgdPassportServiceExt = __webpack_require__(308);
	
	var _BgdPassportServiceExt2 = _interopRequireDefault(_BgdPassportServiceExt);
	
	var _RemitService = __webpack_require__(316);
	
	var _RemitService2 = _interopRequireDefault(_RemitService);
	
	var _getMarketingBox = __webpack_require__(325);
	
	var _numeral = __webpack_require__(16);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactYoutube = __webpack_require__(204);
	
	var _reactYoutube2 = _interopRequireDefault(_reactYoutube);
	
	var _reactackle = __webpack_require__(5);
	
	var _HighComm = __webpack_require__(310);
	
	var _HighComm2 = _interopRequireDefault(_HighComm);
	
	var _tSupplierShopItems = __webpack_require__(159);
	
	var _AgraniService = __webpack_require__(306);
	
	var _AgraniService2 = _interopRequireDefault(_AgraniService);
	
	var _PrimeExchService = __webpack_require__(314);
	
	var _PrimeExchService2 = _interopRequireDefault(_PrimeExchService);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _asyncToGenerator(fn) {
	  return function () {
	    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
	      function step(key, arg) {
	        try {
	          var info = gen[key](arg);var value = info.value;
	        } catch (error) {
	          reject(error);return;
	        }if (info.done) {
	          resolve(value);
	        } else {
	          return Promise.resolve(value).then(function (value) {
	            step("next", value);
	          }, function (err) {
	            step("throw", err);
	          });
	        }
	      }return step("next");
	    });
	  };
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof2(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	//import LogRocket from "logrocket";
	//import setupLogRocketReact from "logrocket-react";
	
	var Workers = function (_Component) {
	  _inherits(Workers, _Component);
	
	  function Workers(props) {
	    var _this$state;
	
	    _classCallCheck(this, Workers);
	
	    ////console.log("...test... " + JSON.stringify(tableDefs));
	    //console.log(window.location.hostname + " " + JSON.stringify(localState));
	    //LogRocket.init("1gfaw4/bcsprod");
	    //setupLogRocketReact(LogRocket);
	    var _this = _possibleConstructorReturn(this, (Workers.__proto__ || Object.getPrototypeOf(Workers)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var crTable = _.cloneDeep(_this.props.createTable);
	    var tDefs = (0, _getDefs2.default)(crTable);
	    var extDefs = (0, _extendedOgDef2.default)(crTable);
	    _this.state = (_this$state = {
	      data: {
	        path: "",
	        payload: {
	          paymentType: "",
	          supplierInvoice: "",
	          referenceNumber: "",
	          paymentDate: ""
	        }
	      },
	      message: "",
	      hasLoaded: false,
	      tableName: "deliveryRequest",
	      testing: false,
	      searchVal: "",
	      showGrid: true,
	      showDash: false,
	      searchFilters: { category: "POPULAR" },
	      searchDateFilters: {},
	      showPivot: false,
	      reRenderFlag: false,
	      tableDefs: tDefs,
	      formDefs: extDefs,
	      notInitialized: true,
	      loginProgress: false,
	      logview: [],
	      stage: "login" }, _defineProperty(_this$state, "loginProgress", false), _defineProperty(_this$state, "localhost", _rawState.localState.hostname), _defineProperty(_this$state, "startButtonText", "LOADING ..."), _defineProperty(_this$state, "isSignedIn", false), _defineProperty(_this$state, "notLoadedBasicData", true), _defineProperty(_this$state, "showFilters", false), _defineProperty(_this$state, "sortByLatest", false), _defineProperty(_this$state, "showMenu", false), _defineProperty(_this$state, "showPreLoader", true), _this$state);
	    _this.getDataDebounced = (0, _throttleDebounce.debounce)(1000, _this.doStateUpdateForSearch);
	    _this.getDataThrottled = (0, _throttleDebounce.throttle)(1000, _this.doStateUpdateForSearch);
	    return _this;
	  }
	
	  // getStaticDataForRedux = (path, data) => {
	  //   //console.log("adding: " + path);
	  //   let tmpArray = [];
	  //   Object.keys(data).map(key => {
	  //     let item = {
	  //       ...data[key],
	  //       key: key
	  //     };
	  //     tmpArray.push(item);
	  //   });
	  //   tmpArray.reverse();
	  //   console.log(path);
	  //   console.log(JSON.stringify(tmpArray));
	  //// this.props.onAddRecord({
	  ////   path: path,
	  ////   payload: tmpArray
	  //// });
	  // };
	
	  _createClass(Workers, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      //console.log("mounted now...");
	      var scDiv = window.document.getElementById("oDiv");
	      if (scDiv && scDiv !== undefined) {
	        scDiv.addEventListener("scroll", this.handleScroll);
	      }
	      try {
	        if (this.state.notInitialized && !this.props.firebase.auth && this.props.firebase.auth === undefined) {
	          this.props.onSetUiFlag("operationType", "add");
	
	          this.setState(function (prevState) {
	            return _extends({}, prevState);
	          });
	          this.props.firebase.doInitiate("BROOKLYNZ");
	          this.setState(function (prevState) {
	            return _extends({}, prevState, {
	              notInitialized: false,
	              phoneNumber: window.location.hostname === _this2.state.localhost ? _this2.state.phoneNumber : ""
	            });
	          });
	          this.props.onSetUiFlag("notLoadedBasicData", true);
	        }
	
	        this.unregisterAuthObserver = this.props.firebase.auth.onAuthStateChanged(function (user) {
	          //console.log("changed now");
	          _this2.setState({ isSignedIn: !!user });
	          if (user) {
	            _this2.loadBasicData();
	            _this2.stateChangeHandler("homepage", "stage", false);
	          } else {
	            //console.log("setting showgoog to true");
	            _this2.stateChangeHandler(true, "showGoog", false);
	          }
	        });
	        //console.log("adding scroll listner");
	
	        this.props.onSetUiFlag("loginProgress", false);
	      } catch (err) {
	        console.log(err);
	      }
	    }
	  }, {
	    key: "componentDidCatch",
	    value: function componentDidCatch(error, info) {
	      //handle the sending message to backend? store back to db? send notification?
	      console.log("Uncaught : " + error + " | " + info);
	      this.switchMenu("bcsHome");
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      try {
	        this.unregisterAuthObserver();
	      } catch (err) {}
	    }
	
	    // getAddPostButton = () => {
	    //   if (
	    //     this.state.stage === "openBazarList" &&
	    //     this.state.tableName === "openBazar"
	    //   ) {
	    //     return (
	    //       <div
	    //         style={{
	    //           padding: "0.5em 0.5em",
	    //           borderRadius: "8px",
	    //           color: "#fff",
	    //           backgroundColor: "rgb(30, 101, 144)",
	    //           fontSize: "1.1em",
	    //           border: "0px",
	    //           cursor: "pointer",
	    //           margin: "5px",
	    //           fontWeight: "bold",
	    //           maxWidth: "140px"
	    //         }}
	    //         onClick={() => {
	    //           this.handleAddNew("openBazar");
	    //         }}
	    //       >
	    //         <span>
	    //           <icon
	    //             className="fa fa-comments"
	    //             style={{
	    //               color: "white",
	    //               marginRight: "15px"
	    //             }}
	    //           />
	    //         </span>
	    //         ADD POST
	    //       </div>
	    //     );
	    //   }
	    // };
	
	    //single method that work for all fields
	    //takes incoming id of the field and then adds field data to state
	
	
	    //Pexels Video by Jessica Politi from Pexels
	
	    /*
	    //stages & tables
	    1. bcsHome - users | front page
	    2. shopFromASupplier - supplierShopItems | order now
	    3. directOrderpad - deliveryRequest | complete order
	    5. selectCategory - ??no table?? | filter products
	     7. openBazar - openBazar | open bazar
	      8. addToShop - supplierShopItems | update products
	    9. supplier - deliveryRequest | pick orders
	    
	    9. login - main login stage
	    10. 
	    //roles
	    1. WORKER
	    2. STOREADMIN
	    3. SUPERADMIN
	    */
	
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement("div", {
	        style: {
	          width: "100%",
	          overflowX: "hidden"
	        },
	        id: "oDiv"
	      }, this.props.loginProgress && _react2.default.createElement("div", {
	        style: {
	          margin: "auto",
	          display: "flex",
	          justifyContent: "center",
	          alignItems: "center",
	          height: "100vh"
	        }
	      }, _react2.default.createElement("img", {
	        src: _imageText.logoB64Text,
	        style: {
	          height: "100px",
	          width: "100px",
	          borderRadius: "100px",
	          animation: "rotation 2s infinite linear",
	          perspective: "1000px"
	        }
	      })), !this.props.loginProgress && _react2.default.createElement("div", null, this.props.currUserRole === "SUPERADMIN" && this.getTopMenu(), _react2.default.createElement("div", null, this.state.stage === "admin" && this.getLandingPage(), _react2.default.createElement("div", null, this.state.stage !== "admin" && this.state.stage !== "text" && this.getMainContent())), this.state.showGrid && this.state.stage === "supplierShopItems" && this.getSearchBar(), _react2.default.createElement("div", {
	        style: {
	          height: "300px"
	        }
	      }), this.getHiddenControls()));
	    }
	  }]);
	
	  return Workers;
	}(_react.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this3 = this;
	
	  this.handleScroll = function (event) {
	    if (_this3.props.currUserRole === "SUPERADMIN") {
	      var scDiv = window.document.getElementById("oDiv");
	      if (scDiv && scDiv !== undefined) {
	        //console.log("scrolling... ");
	        if (_this3.state.showGrid) {
	          _this3.props.onSetUiFlag("listYPos", scDiv.scrollTop);
	        }
	      }
	    }
	  };
	
	  this.setScroll = function (setToTop) {
	    //console.log("attempting scroll");
	    var element = window.document.querySelector("#oDiv");
	    if (element && element !== "") {
	      //console.log("setting scroll");
	      if (setToTop) {
	        //console.log("setting to 0");
	        window.scrollTo(0, 0);
	        element.scroll(0, 0);
	      } else {
	        //console.log("setting to " + this.props.listYPos);
	        if (_this3.props.currUserRole === "SUPERADMIN") {
	          element.scroll(0, parseInt(_this3.props.listYPos));
	        }
	      }
	    } else {
	      console.log("element not found");
	    }
	  };
	
	  this.applyDataCondition = function (singleRecord, dataCondition) {
	    var tmpRes = false;
	
	    for (var p = 0; p < dataCondition.length; p++) {
	      if (singleRecord[dataCondition[p]["colKey"]] === dataCondition[p]["fieldVal"]) {
	        tmpRes = true;
	      }
	
	      if (singleRecord[dataCondition[p]["colKey"]] === _this3.props.userProfile[dataCondition[p]["fieldVal"]]) {
	        tmpRes = true;
	      }
	    }
	    //console.log("~~ returning: " + tmpRes);
	    return tmpRes;
	  };
	
	  this.loadDataEx = function (allTableDets) {
	    var recsLimit = 0;
	
	    if (_reactDeviceDetect.isMobile) {
	      if (allTableDets.recMobileLimit) {
	        recsLimit = parseInt(allTableDets.recMobileLimit);
	      }
	    } else {
	      if (allTableDets.recMobileLimit) {
	        recsLimit = parseInt(allTableDets.recLimit);
	      }
	    }
	
	    var basePath = "/";
	    var tableName = allTableDets.tableName;
	    _this3.props.onSetUiFlag(tableName + "-downloaded", false);
	    if (recsLimit > 0) {
	      _this3.props.firebase.db.ref(basePath + tableName).limitToLast(recsLimit).on("value", function (snapshot) {
	        var tmpArray = [];
	        var fbOject = [];
	        Promise.all([snapshot.val()]).then(function (res) {
	          fbOject = res[0];
	          if (fbOject && fbOject !== null && fbOject !== undefined) {
	            Object.keys(fbOject).map(function (key) {
	              var item = _extends({}, fbOject[key], {
	                key: key
	              });
	              //console.log("~~ Linking " + JSON.stringify(allTableDets));
	              if (allTableDets.dataConditions && allTableDets.dataConditions !== undefined && allTableDets.dataConditions.length > 0) {
	                //console.log(JSON.stringify(allTableDets.dataConditions));
	                if (_this3.applyDataCondition(item, allTableDets.dataConditions)) {
	                  tmpArray.push(item);
	                }
	              } else {
	                tmpArray.push(item);
	              }
	            });
	          }
	          //reverse to have latest at the top
	          tmpArray.reverse();
	          _this3.props.onAddRecord({
	            path: tableName,
	            payload: tmpArray
	          });
	          _this3.props.onSetUiFlag(tableName + "-downloaded", true);
	        });
	      });
	    } else {
	      //console.log("here the load data");
	      _this3.props.firebase.db.ref(basePath + tableName).on("value", function (snapshot) {
	        var tmpArray = [];
	        var fbOject = [];
	        Promise.all([snapshot.val()]).then(function (res) {
	          fbOject = res[0];
	          if (fbOject && fbOject !== null && fbOject !== undefined) {
	            Object.keys(fbOject).map(function (key) {
	              var item = _extends({}, fbOject[key], {
	                key: key
	              });
	              //console.log("~~ Linking " + JSON.stringify(allTableDets));
	              if (allTableDets.dataConditions && allTableDets.dataConditions !== undefined && allTableDets.dataConditions.length > 0) {
	                //console.log(JSON.stringify(allTableDets.dataConditions));
	                if (_this3.applyDataCondition(item, allTableDets.dataConditions)) {
	                  tmpArray.push(item);
	                }
	              } else {
	                tmpArray.push(item);
	              }
	            });
	          }
	          //reverse to have latest at the top
	          //console.log("reversing " + tableName);
	          tmpArray.reverse();
	          _this3.props.onAddRecord({
	            path: tableName,
	            payload: tmpArray
	          });
	          _this3.props.onSetUiFlag(tableName + "-downloaded", true);
	          var crTable = _.cloneDeep(_this3.props.createTable);
	          var tDefs = (0, _getDefs2.default)(crTable);
	          var extDefs = (0, _extendedOgDef2.default)(crTable);
	          _this3.setState(function (prevState) {
	            return _extends({}, prevState, {
	              tableDefs: tDefs,
	              formDefs: extDefs
	            });
	          });
	        });
	      });
	    }
	    //}
	  };
	
	  this.loadData = function (tableName, isDeleted) {
	    //console.log(tableName);
	    var recsLimit = 3000;
	    if (_reactDeviceDetect.isMobile) {
	      recsLimit = 2000;
	    }
	    if (tableName === "attendance") {
	      if (_reactDeviceDetect.isMobile) {
	        recsLimit === 2000;
	      } else {
	        recsLimit === 3000;
	      }
	    }
	    var basePath = "/";
	    if (isDeleted) {
	      basePath = "/deletedRecs/";
	    }
	    _this3.props.firebase.db.ref(basePath + tableName).limitToLast(recsLimit).on("value", function (snapshot) {
	      ////console.log("Linking " + tableName);
	      var tmpArray = [];
	      var fbOject = [];
	      var projTempArray = [];
	      Promise.all([snapshot.val()]).then(function (res) {
	        //basic updating keys into objects
	        fbOject = res[0];
	        if (fbOject && fbOject !== null && fbOject !== undefined) {
	          tmpArray = Object.keys(fbOject).map(function (key) {
	            return _extends({}, fbOject[key], {
	              key: key
	            });
	          });
	        }
	        //reverse to have latest at the top
	        tmpArray.reverse();
	
	        //filter project table for engineer and contributor
	        if (tableName === "projects" && (_this3.props.currUserRole === "ENGINEER" || _this3.props.currUserRole === "CONTRIBUTOR")) {
	          projTempArray = tmpArray.filter(function (item) {
	            return item.projectPhase === "IN FLIGHT";
	          });
	
	          //handle delete
	          if (isDeleted) {
	            _this3.props.onAddRecord({
	              path: "deleted" + tableName,
	              payload: projTempArray
	            });
	          } else {
	            _this3.props.onAddRecord({
	              path: tableName,
	              payload: projTempArray
	            });
	          }
	        } else {
	          //handle delete
	          if (isDeleted) {
	            _this3.props.onAddRecord({
	              path: "deleted" + tableName,
	              payload: tmpArray
	            });
	          } else {
	            _this3.props.onAddRecord({ path: tableName, payload: tmpArray });
	          }
	        }
	      });
	    });
	  };
	
	  this.getPrevOrderProds = function () {
	    console.log("extracting list ");
	    if (_this3.props.db["deliveryRequest"] && _this3.props.db["deliveryRequest"].length > 0) {
	      var myOrders = _this3.props.db["deliveryRequest"].filter(function (ord) {
	        return "+65" + ord.mobile === _this3.props.cellPhone;
	      });
	      var myProds = [];
	      for (var i = 0; i < myOrders.length; i++) {
	        var singOrd = myOrders[i];
	        for (var j = 0; j < singOrd.requestedItems.length; j++) {
	          if (!myProds.includes(singOrd.requestedItems[j].key)) {
	            (function () {
	              var ordItem = singOrd.requestedItems[j];
	              var foundItem = _tSupplierShopItems.tSupplierShopItems.find(function (item) {
	                return item.key === ordItem.key;
	              });
	              myProds.push(foundItem);
	            })();
	          }
	        }
	      }
	      //PREVIOUSLY ORDERED
	      //console.log("extracting here are the: " + JSON.stringify(myProds));
	      _this3.props.onAddArray({ path: "PREVIOUSLY ORDERED", payload: myProds });
	      //return myProds;
	    } else {
	      //console.log("deliveryrequest is empty");
	      return [];
	    }
	  };
	
	  this.getFrequentlyOrder = function () {
	    if (_this3.props.db["deliveryRequest"] && _this3.props.db["deliveryRequest"].length > 0) {
	      var freqProds = {};
	      console.log(_this3.props.db["deliveryRequest"].length);
	      for (var i = 0; i < _this3.props.db["deliveryRequest"].length; i++) {
	        var currOrd = _this3.props.db["deliveryRequest"][i];
	        if (currOrd && currOrd.requestedItems && currOrd.requestedItems.length > 0) {
	          var _loop = function _loop(j) {
	            var currItem = currOrd.requestedItems[j];
	            if (freqProds[currItem.key]) {
	              freqProds[currItem.key]["count"] = freqProds[currItem.key]["count"] + 1;
	            } else {
	              if (_this3.props.db["supplierShopItems"] && _this3.props.db["supplierShopItems"].length > 0) {
	                var newObj = _this3.props.db["supplierShopItems"].find(function (item) {
	                  return item.key === currItem.key;
	                });
	                if (newObj && newObj !== undefined) {
	                  freqProds[currItem.key] = _.cloneDeep(newObj);
	                  freqProds[currItem.key]["count"] = 1;
	                }
	              }
	            }
	          };
	
	          for (var j = 0; j < currOrd.requestedItems.length; j++) {
	            _loop(j);
	          }
	        }
	      }
	
	      freqProds = _.sortBy(freqProds, "count");
	      freqProds = freqProds.reverse();
	      //let finObj = {};
	      // for (let i = 0; i < freqProds.length; i++) {
	      //   finObj[freqProds[i].key] = freqProds[i];
	      // }
	      console.log(JSON.stringify(freqProds));
	      return freqProds;
	      //this.stateChangeHandler(finalArray, "freqProds", false);
	    } else {
	      return [];
	      //this.stateChangeHandler([], "freqProds", false);
	    }
	  };
	
	  this.getMenuDiv = function () {
	    if (_this3.props.currUserRole !== "SUPERADMIN" && _this3.state.stage !== "login") {
	      return _react2.default.createElement("div", {
	        style: {
	          position: "fixed",
	          top: "0px",
	          padding: "5px",
	          left: "50vw",
	          height: "100%",
	          width: "50vw",
	          minWidth: "180px",
	          backgroundColor: "white",
	          borderRadius: "3px",
	          opacity: 1,
	          zIndex: "25",
	          border: "1px solid #E0E6E8",
	          boxSizing: "border-box",
	          boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.5)",
	          overflowY: "hidden",
	          transition: "all 0.3s ease-in-out",
	          transformOrigin: "right top",
	          transform: _this3.state.showMenu ? null : "scaleX(0)"
	        }
	      }, _react2.default.createElement("icon", {
	        className: "fa fa-close",
	        style: {
	          position: "fixed",
	          top: "0",
	          right: "0",
	          margin: "5px",
	          fontSize: "1.5em"
	        },
	        onClick: function onClick() {
	          _this3.stateChangeHandler(!_this3.state.showMenu, "showMenu", false);
	        }
	      }), _react2.default.createElement("ul", {
	        className: "nav navbar-nav navbar-left",
	        style: {
	          width: "100%"
	        }
	      }, _this3.fetchMenus()));
	    }
	  };
	
	  this.getFieldOptionsArray = function (tableName, fieldName, addAll, doSort) {
	    var categList = [];
	    if (_this3.props.createTable && _this3.props.createTable.length > 0) {
	      var shopItems = _this3.props.createTable.find(function (item) {
	        return item.name == tableName;
	      });
	
	      if (shopItems) {
	        var categField = shopItems.fields.find(function (item) {
	          return item.name === fieldName;
	        });
	        if (categField) {
	          categList = _.cloneDeep(categField.staticSource);
	
	          if (doSort) {
	            categList = _.sortBy(categList, "name");
	          }
	        }
	      }
	    }
	    return categList;
	  };
	
	  this.categIsSelected = function (categName) {
	    //console.log(categName + " " + this.state.searchFilters.category);
	    var isSelected = false;
	
	    if (_this3.state.searchFilters.category === categName) {
	      isSelected = true;
	    }
	
	    if (categName === "ALL" && !_this3.state.searchFilters.category) {
	      isSelected = true;
	    }
	    return isSelected;
	  };
	
	  this.getCategTabs = function () {
	    //console.log(JSON.stringify(this.props.createTable));
	
	    var categList = _this3.getFieldOptionsArray("supplierShopItems", "category", true, false);
	
	    if (categList && categList.length > 0) {
	      //console.log("got categ list: " + JSON.stringify(categList));
	      return categList.map(function (item) {
	        return _react2.default.createElement("div", {
	          style: {
	            height: _this3.categIsSelected(item.name) ? "37px" : "35px",
	            margin: "1px",
	            backgroundColor: "white",
	            display: "flex",
	            justifyContent: "center",
	            alignItems: "center",
	            minWidth: "80px",
	            fontSize: "10px",
	            textAlign: "center",
	            fontWeight: _this3.categIsSelected(item.name) ? "bold" : "normal",
	            border: _this3.categIsSelected(item.name) ? "1px solid gainsboro" : null,
	            borderBottom: _this3.categIsSelected(item.name) ? "2px solid grey" : "1px solid gainsboro",
	            borderTopLeftRadius: "5px",
	            borderTopRightRadius: "5px"
	          },
	          onClick: function onClick() {
	            if (item.name === "ALL") {
	              _this3.stateChangeHandler({}, "searchFilters", false);
	            } else {
	              _this3.stateChangeHandler({ category: item.name }, "searchFilters", false);
	            }
	
	            _this3.setScroll(true);
	          }
	        }, item.name);
	      });
	    }
	  };
	
	  this.getOverLay = function () {
	    if (_this3.props.currUserRole !== "SUPERADMIN" && _this3.state.showMenu) {
	      return _react2.default.createElement("div", {
	        style: {
	          position: "fixed",
	          display: "block",
	          width: "100%",
	          height: "100%",
	          top: 0,
	          left: 0,
	          right: 0,
	          bottom: 0,
	          backgroundColor: "rgba(0,0,0,0.5)",
	          zIndex: 9,
	          cursor: "pointer"
	        },
	        onClick: function onClick() {
	          _this3.stateChangeHandler(!_this3.state.showMenu, "showMenu", false);
	        }
	      });
	    }
	  };
	
	  this.getMenuButton = function () {
	    /*
	    show menu items when:
	      shopFromASupplier
	      openBazar
	      homepage
	    */
	    if (_this3.props.currUserRole !== "SUPERADMIN" && _this3.state.stage !== "login") {
	      if (_this3.state.stage === "shopFromASupplier" || _this3.state.stage === "openBazarList" || _this3.state.stage === "openBazar" || _this3.state.stage === "homepage" || _this3.state.stage === "selectCategory" || _this3.state.stage === "orderlist" || _this3.state.stage === "supplier" || _this3.state.stage === "directOrderpad" || _this3.state.stage === "storeAdminElse" || _this3.state.stage === "passportService" || _this3.state.stage === "addToShop" || _this3.state.stage === "hCommService" || _this3.state.stage === "remitService" || _this3.state.stage === "agraniService" || _this3.state.stage === "primeService") {
	        return _react2.default.createElement("div", {
	          style: {
	            padding: "5px",
	            borderRadius: "5px",
	            color: "rgb(30, 101, 144)",
	            zIndex: "20"
	          },
	          onClick: function onClick() {
	            return _this3.stateChangeHandler(!_this3.state.showMenu, "showMenu", false);
	          }
	        }, _react2.default.createElement("icon", {
	          className: "fa fa-bars fa-2x",
	          style: {
	            marginLeft: "2px",
	            marginRight: "2px",
	            marginTop: "2px"
	          }
	        }));
	      }
	    }
	  };
	
	  this.getFilterButton = function () {
	    /* 
	    show filter only if it is NOT SUPERADMIN and stage is showFromASupplier
	    
	    */
	    if (_this3.props.currUserRole !== "SUPERADMIN") {
	      if (_this3.state.stage === "shopFromASupplier") {
	        var _ref3;
	
	        return _react2.default.createElement("div", {
	          style: (_ref3 = {
	            position: "fixed",
	            top: "10px",
	            right: "50px",
	            border: "1px solid grey",
	            padding: "3px",
	            borderRadius: "5px"
	          }, _defineProperty(_ref3, "border", "1px solid #E0E6E8"), _defineProperty(_ref3, "boxSizing", "border-box"), _defineProperty(_ref3, "boxShadow", "0px 4px 4px rgba(0, 0, 0, 0.25)"), _defineProperty(_ref3, "color", "rgb(30, 101, 144)"), _defineProperty(_ref3, "zIndex", "20"), _ref3),
	          onClick: function onClick() {
	            _this3.setScroll(true);
	            _this3.stateChangeHandler("selectCategory", "stage", false);
	          }
	        }, _react2.default.createElement("icon", {
	          className: "fa fa-sliders fa-2x",
	          style: {
	            marginLeft: "2px",
	            marginRight: "2px",
	            marginTop: "2px"
	          }
	        }));
	      }
	    }
	  };
	
	  this.getAddButton = function () {
	    //this should be addToShop view
	    if (_this3.props.currUserRole === "STOREADMIN" && (_this3.state.stage === "addToShop" || _this3.state.stage === "storeAdminElse") && _this3.state.showGrid) {
	      return _react2.default.createElement("div", {
	        style: {
	          padding: "5px",
	          borderRadius: "5px",
	
	          color: "rgb(30, 101, 144)",
	          zIndex: "20"
	        },
	        onClick: function onClick() {
	          _this3.handleAddNew("addToShop");
	        }
	      }, _react2.default.createElement("icon", {
	        className: "fa fa-plus fa-2x",
	        style: {
	          marginLeft: "2px",
	          marginRight: "2px",
	          marginTop: "2px"
	        }
	      }));
	    }
	  };
	
	  this.getCloseButton = function () {
	    //this should be addToShop view
	    if (_this3.props.operationType === "update" && _this3.state.stage === "directOrderpad") {
	      return _react2.default.createElement("div", {
	        style: {
	          padding: "5px",
	          borderRadius: "5px",
	          color: "rgb(30, 101, 144)",
	          zIndex: "20"
	        },
	        onClick: function onClick() {
	          _this3.backToList("orderlist", "deliveryRequest", _this3.state.selectedSupplier);
	          _this3.props.onAddArray({ path: "bucket", payload: [] });
	        }
	      }, _react2.default.createElement("icon", {
	        className: "fa fa-close fa-2x",
	        style: {
	          marginLeft: "2px",
	          marginRight: "2px",
	          marginTop: "2px"
	        }
	      }));
	    }
	  };
	
	  this.getHomeButton = function () {
	    //this should be addToShop view
	    if (_this3.state.stage === "openBazarList" || _this3.state.stage === "orderlist" || _this3.state.stage === "supplier" || _this3.state.stage === "addToShop" || _this3.state.stage === "directOrderpad" || _this3.state.stage === "shopFromASupplier" || _this3.state.stage === "passportService" || _this3.state.stage === "storeAdminElse" || _this3.state.stage === "hCommService" || _this3.state.stage === "remitService" || _this3.state.stage === "agraniService" || _this3.state.stage === "primeService") {
	      return _react2.default.createElement("div", {
	        style: {
	          padding: "5px",
	          borderRadius: "5px",
	          color: "rgb(30, 101, 144)",
	          zIndex: "20"
	        },
	        onClick: function onClick() {
	          _this3.setScroll(true);
	          _this3.stateChangeHandler({}, "searchFilters", false);
	          _this3.stateChangeHandler("homepage", "stage", false);
	          _this3.stateChangeHandler("users", "tableName", false);
	          _this3.stateChangeHandler(true, "showGrid", false);
	        }
	      }, _react2.default.createElement("icon", {
	        className: "fa fa-home fa-2x",
	        style: {
	          marginLeft: "2px",
	          marginRight: "2px",
	          marginTop: "2px"
	        }
	      }));
	    }
	  };
	
	  this.getSupplierButton = function () {
	    //this should be addToShop view
	
	    if (_this3.props.currUserRole === "STOREADMIN" && _this3.state.stage === "homepage") {
	      return _react2.default.createElement("div", {
	        style: {
	          padding: "5px",
	          borderRadius: "5px",
	
	          color: "rgb(30, 101, 144)",
	          zIndex: "20"
	        },
	        onClick: function onClick() {
	          _this3.setScroll(true);
	          _this3.backToList("supplier", "deliveryRequest");
	        }
	      }, _react2.default.createElement("icon", {
	        className: "fa fa-tachometer fa-2x",
	        style: {
	          marginLeft: "2px",
	          marginRight: "2px",
	          marginTop: "2px"
	        }
	      }));
	    }
	  };
	
	  this.getNewOrderButton = function () {
	    if (_this3.state.stage === "orderlist" && _this3.state.tableName === "deliveryRequest") {
	      return _react2.default.createElement("div", {
	        style: {
	          padding: "0.5em 0.5em",
	          borderRadius: "8px",
	          color: "#fff",
	          backgroundColor: "rgb(30, 101, 144)",
	          border: "0px",
	          cursor: "pointer",
	          marginLeft: "10px",
	          marginTop: "5px",
	          fontWeight: "bold",
	          maxWidth: "140px"
	        },
	        onClick: function onClick() {
	          //console.log("doing new order  ");
	          _this3.backToList("shopFromASupplier", "supplierShopItems");
	        }
	      }, _react2.default.createElement("span", null, _react2.default.createElement("icon", {
	        className: "fa fa-shopping-bag",
	        style: {
	          color: "white",
	          marginRight: "15px"
	        }
	      })), "NEW ORDER");
	    }
	  };
	
	  this.getAddMoreItemsButton = function () {
	    if (_this3.state.stage === "directOrderpad" && _this3.state.tableName === "supplierShopItems" && _this3.props.orderStage === "showForm") {
	      return _react2.default.createElement("div", {
	        style: {
	          padding: "0.5em 0.5em",
	          borderRadius: "8px",
	          color: "#fff",
	          backgroundColor: "rgb(30, 101, 144)",
	          border: "0px",
	          cursor: "pointer",
	          marginLef: "5px",
	          fontWeight: "bold",
	          maxWidth: "200px",
	          marginLeft: "10px",
	          marginTop: "5px"
	        },
	        onClick: function onClick() {
	          //console.log("doing new order  ");
	          _this3.backToList("shopFromASupplier", "supplierShopItems", _this3.state.selectedSupplier);
	          _this3.stateChangeHandler(true, "showGrid", false);
	        }
	      }, _react2.default.createElement("span", null, _react2.default.createElement("icon", {
	        className: "fa fa-shopping-bag",
	        style: {
	          color: "white",
	          marginRight: "15px"
	        }
	      })), "ADD MORE");
	    }
	  };
	
	  this.getViewOrdersButton = function () {
	    if (_this3.state.stage === "directOrderpad" && _this3.state.tableName === "supplierShopItems" && (_this3.props.orderStage === "showConfirmation" || _this3.props.orderStage === "showUpdateConfirmation")) {
	      return _react2.default.createElement("div", {
	        style: {
	          padding: "0.5em 0.5em",
	          borderRadius: "8px",
	          color: "#fff",
	          backgroundColor: "rgb(30, 101, 144)",
	          border: "0px",
	          cursor: "pointer",
	          marginTop: "5px",
	          marginLeft: "10px",
	          fontWeight: "bold",
	          maxWidth: "200px"
	        },
	        onClick: function onClick() {
	          _this3.backToList("orderlist", "deliveryRequest", _this3.state.selectedSupplier);
	          _this3.stateChangeHandler({}, "searchFilters", false);
	          _this3.stateChangeHandler(true, "showGrid", false);
	          _this3.props.onAddArray({ path: "bucket", payload: [] });
	        }
	      }, _react2.default.createElement("span", null, _react2.default.createElement("icon", {
	        className: "fa fa-shopping-bag",
	        style: {
	          color: "white",
	          marginRight: "15px"
	        }
	      })), "VIEW YOUR ORDERS");
	    }
	  };
	
	  this.getAddPostPlusButton = function () {
	    //this should be addToShop view
	    if (_this3.state.stage === "openBazarList" && _this3.state.tableName === "openBazar") {
	      return _react2.default.createElement("div", {
	        style: {
	          padding: "5px",
	          borderRadius: "5px",
	
	          color: "rgb(30, 101, 144)",
	          zIndex: "20"
	        },
	        onClick: function onClick() {
	          _this3.handleAddNew("openBazar");
	        }
	      }, _react2.default.createElement("icon", {
	        className: "fa fa-plus fa-2x",
	        style: {
	          marginLeft: "2px",
	          marginRight: "2px",
	          marginTop: "2px"
	        }
	      }));
	    }
	  };
	
	  this.fetchMenus = function () {
	    // console.log("Fetching menus for " + this.props.currUserRole + "...");
	    // console.log(
	    //   "Props userMenu: " +
	    //     JSON.stringify(this.props.userMenus) +
	    //     " props worker menus: " +
	    //     JSON.stringify(this.props.workerMenus)
	    // );
	    // console.log(
	    //   "Props worker menus: " + JSON.stringify(this.props.workerMenus)
	    // );
	    if (_this3.props.currUserRole && _this3.props.userMenus) {
	      var userMenus = _this3.getUserMenu(_this3.props.currUserRole);
	      //console.log("userMenus: " + JSON.stringify(userMenus));
	      return (0, _getMenuList.getMenuList)(true, _this3.isAdmin(), _this3.switchMenu, _this3.props.currUserRole, userMenus && userMenus.length > 0 ? userMenus : _this3.props.workerMenus);
	    }
	  };
	
	  this.getUserMenu = function (userRole) {
	    var allMenusFromDb = _this3.props.menuDesigner;
	    var allOtherMenus = [];
	    if (allMenusFromDb && allMenusFromDb.length > 0) {
	      var userMenu = allMenusFromDb.find(function (singMenu) {
	        return singMenu.name === userRole;
	      });
	
	      if (userMenu && userMenu !== undefined) {
	        allOtherMenus = userMenu.menuItems.map(function (singleMenu) {
	          var srcTable = _this3.props.listOfTables.find(function (item) {
	            return item.name === singleMenu.tableName;
	          });
	          if (srcTable && srcTable !== undefined && srcTable.name) {
	            return _extends({}, singleMenu, {
	              menuCaption: srcTable.menu
	            });
	          } else {
	            console.log("table not found: " + singleMenu.tableName);
	          }
	        });
	      }
	    } else {}
	
	    return allOtherMenus;
	  };
	
	  this.stateChangeHandler = function (val, id, isPayload) {
	    // console.log(
	    //   "val: " + JSON.stringify(val) + " id: " + id + " isPayload: " + isPayload
	    // );
	    var tmpState = {};
	    tmpState[id] = val;
	
	    if (isPayload) {
	      _this3.setState(function (prevState) {
	        if (prevState && prevState.data.payload !== null) {
	          return _extends({}, prevState, {
	            data: _extends({}, prevState.data, {
	              payload: _extends({}, prevState.data.payload, tmpState)
	            })
	          });
	        } else {
	          return _extends({}, prevState, {
	            data: {
	              path: prevState.data.path,
	              payload: _extends({}, tmpState)
	            }
	          });
	        }
	      });
	    } else {
	      _this3.setState(function (prevState) {
	        return _extends({}, prevState, tmpState);
	      });
	    }
	  };
	
	  this.logoutApp = function () {
	    var msgToApp = {
	      actionType: "logOut",
	      payload: {}
	    };
	
	    if (window && window.ReactNativeWebView) {
	      //console.log("posing logout message to app");
	      window.ReactNativeWebView.postMessage(JSON.stringify(msgToApp));
	    }
	  };
	
	  this.switchMenu = function (menuName) {
	    console.log(menuName);
	    _this3.stateChangeHandler(false, "showFilters");
	    if (_this3.refs && _this3.refs.searchText) {
	      _this3.refs.searchText.value = "";
	      _this3.doDelaySearch();
	    }
	
	    _this3.props.onAddArray({
	      path: "bucket",
	      payload: []
	    });
	
	    _this3.stateChangeHandler("", "searchVal", false);
	    _this3.stateChangeHandler({}, "searchDateFilters", false);
	    _this3.stateChangeHandler(false, "showPivot", false);
	
	    if (_this3.props.currUserRole === "SUPERADMIN") {
	      if (menuName === "dashboard") {
	        _this3.stateChangeHandler(true, "showDash", false);
	        _this3.stateChangeHandler(false, "showGrid", false);
	        _this3.stateChangeHandler(menuName, "tableName", false);
	      } else if (menuName === "bcsHome") {
	        _this3.stateChangeHandler("users", "tableName", false);
	        _this3.stateChangeHandler("homepage", "stage", false);
	        _this3.stateChangeHandler(true, "showGrid", false);
	        _this3.stateChangeHandler(false, "showDash", false);
	      } else if (menuName === "signout") {
	        _this3.props.firebase.doSignOut();
	        _this3.props.onSignOut();
	        _this3.logoutApp();
	        _reactRouter.browserHistory.push("/login");
	      } else {
	        _this3.stateChangeHandler(true, "showGrid", false);
	        _this3.stateChangeHandler(false, "showDash", false);
	        _this3.stateChangeHandler(menuName, "tableName", false);
	        _this3.setScroll(true);
	      }
	    } else {
	      if (menuName === "signout") {
	        //console.log("signing out");
	        _this3.props.firebase.doSignOut();
	        _this3.stateChangeHandler("startButtonText", "LOADING ...", false);
	        _this3.props.onSignOut();
	        _this3.logoutApp();
	        _this3.stateChangeHandler("login", "stage", false);
	        _this3.stateChangeHandler(false, "isSignIn", false);
	        _this3.stateChangeHandler(false, "loginProgress", false);
	        _this3.stateChangeHandler("deliveryRequest", "tableName", false);
	      } else {
	        //view orders
	        if (menuName === "deliveryRequest") {
	          _this3.setScroll(true);
	          _this3.stateChangeHandler({}, "searchFilters", false);
	          _this3.stateChangeHandler("orderlist", "stage", false);
	          _this3.stateChangeHandler("deliveryRequest", "tableName", false);
	
	          //supplier to pick orders
	        } else if (menuName === "dqr") {
	          _this3.setScroll(true);
	
	          _this3.stateChangeHandler({}, "searchFilters", false);
	          _this3.stateChangeHandler("supplier", "stage", false);
	          _this3.stateChangeHandler(true, "showGrid", false);
	          _this3.stateChangeHandler("deliveryRequest", "tableName", false);
	
	          //open bazar
	        } else if (menuName === "openBazar") {
	          _this3.setScroll(true);
	          _this3.stateChangeHandler({}, "searchFilters", false);
	          _this3.stateChangeHandler("openBazarList", "stage", false);
	          _this3.stateChangeHandler(true, "showGrid", false);
	          _this3.stateChangeHandler("openBazar", "tableName", false);
	
	          //for adding and updating products to shop
	        } else if (menuName === "supplierShopItems") {
	          _this3.setScroll(true);
	          _this3.stateChangeHandler({}, "searchFilters", false);
	          _this3.stateChangeHandler("addToShop", "stage", false);
	          _this3.stateChangeHandler(true, "showGrid", false);
	          _this3.stateChangeHandler("supplierShopItems", "tableName", false);
	
	          //go back to home
	        } else if (menuName === "bcsHome") {
	          _this3.setScroll(true);
	          _this3.stateChangeHandler({}, "searchFilters", false);
	          _this3.stateChangeHandler("homepage", "stage", false);
	          _this3.stateChangeHandler(true, "showGrid", false);
	          _this3.stateChangeHandler("users", "tableName", false);
	        } else {
	          _this3.setScroll(true);
	          _this3.stateChangeHandler({}, "searchFilters", false);
	          _this3.stateChangeHandler("storeAdminElse", "stage", false);
	          _this3.stateChangeHandler(true, "showGrid", false);
	          _this3.stateChangeHandler(menuName, "tableName", false);
	        }
	      }
	    }
	    _this3.stateChangeHandler(!_this3.state.showMenu, "showMenu", false);
	  };
	
	  this.isAdmin = function () {
	    return _this3.props.isAdmin || _this3.props.isSuperAdmin;
	  };
	
	  this.handleDelete = function (key, path, searchObj) {
	    _this3.props.firebase.db.ref("/" + path + "/" + key).remove();
	    _this3.stateChangeHandler(true, "showGrid", false);
	  };
	
	  this.handleOrderEdit = function (key, path, fullPayload) {
	    console.log("path: " + path);
	    if (fullPayload && fullPayload.status !== "DELIVERED") {
	      _this3.setScroll(true);
	
	      _this3.stateChangeHandler("supplierShopItems", "tableName", false);
	      _this3.stateChangeHandler("directOrderpad", "stage", false);
	      _this3.props.onAddArray({
	        path: "bucket",
	        payload: fullPayload.requestedItems
	      });
	      _this3.props.onSelectRecord({ path: path, key: key });
	      _this3.props.onSetUiFlag("operationType", "update");
	      _this3.props.onSetUiFlag("orderStage", "showForm");
	      _this3.setScroll(true);
	    }
	  };
	
	  this.handleBazarEdit = function (key, path, fullPayload) {
	    if (fullPayload) {
	      _this3.setScroll(true);
	      _this3.stateChangeHandler("openBazar", "stage", false);
	      _this3.props.onSelectRecord({ path: path, key: key });
	      _this3.props.onSetUiFlag("operationType", "update");
	      _this3.stateChangeHandler(false, "showGrid", false);
	    }
	  };
	
	  this.handleMyShopEdit = function (key, path, fullPayload) {
	    if (fullPayload) {
	      //this.setScroll(true);
	      //this.stateChangeHandler("addToShop", "stage", false);
	      _this3.props.onSelectRecord({ path: path, key: key });
	      _this3.props.onSetUiFlag("operationType", "update");
	      //this.stateChangeHandler(false, "showGrid", false);
	    }
	  };
	
	  this.handleAddNew = function (stageName) {
	    //console.log("generating new: " + stageName);
	    // let initData = getInitData(
	    //   this.state.tableName,
	    //   this.props.createTable,
	    //   this.props.userProfile
	    // );
	    // if (initData && initData !== undefined) {
	    //   this.stateChangeHandler(false, "showGrid", false);
	    //   this.props.onSetUiFlag("operationType", "add");
	    //   this.props.onSetUiFlag("tableName", this.state.tableName);
	    //   this.props.onAddNew({
	    //     path: this.state.tableName,
	    //     data: { ...initData }
	    //   });
	    // }
	    _this3.setScroll(true);
	    var initData = (0, _getMenuList.getInitData)(_this3.state.tableName, _this3.props.createTable, _this3.props.userProfile);
	
	    if (initData && initData !== undefined) {
	      window.document.querySelector("#oDiv").scroll(0, 0);
	      _this3.stateChangeHandler(stageName, "stage", false);
	      _this3.stateChangeHandler(false, "showGrid", false);
	      _this3.props.onSetUiFlag("operationType", "add");
	      _this3.props.onSetUiFlag("tableName", _this3.state.tableName);
	      _this3.props.onAddNew({
	        path: _this3.state.tableName,
	        data: _extends({}, initData)
	      });
	    } else {
	      console.log("no init data");
	      // console.log(
	      //   "tableName: " +
	      //     this.state.tableName +
	      //     " crTable: " +
	      //     JSON.stringify(this.props.createTable) +
	      //     " " +
	      //     JSON.stringify(initData)
	      // );
	    }
	  };
	
	  this.backToList = function (listName, tableName, suppName) {
	    _this3.setScroll();
	    _this3.stateChangeHandler(tableName, "tableName", false);
	    _this3.stateChangeHandler(listName, "stage", false);
	    _this3.stateChangeHandler("", "searchVal", false);
	    if (suppName && suppName !== "") {
	      _this3.stateChangeHandler(suppName, "selectedSupplier", false);
	    }
	    //this will be required to be made generic later
	    if (tableName === "supplierShopItems") {
	      _this3.stateChangeHandler("BCS SHOP", "selectedSupplier", false);
	    }
	  };
	
	  this.getDashView = function () {
	    return _react2.default.createElement("div", null);
	  };
	
	  this.getFields = function () {
	    ////console.log("test");
	    alert("test");
	  };
	
	  this.getData = function (customTable) {
	    //console.log("doing get data");
	    var dTableName = "users";
	    if (!customTable) {
	      dTableName = _this3.state.tableName;
	    } else {
	      dTableName = customTable;
	    }
	
	    if (dTableName !== "dashboard") {
	      if (_this3.state.tableDefs[dTableName] && _this3.state.tableDefs[dTableName] !== undefined && _this3.state.refPhoneNumber && _this3.state.refPhoneNumber !== "") {
	        if (_this3.state.stage === "BuyFromSupplier") {
	          return (0, _searchRecords.searchRecords)(_this3.props.db["supplierShopItems"], _this3.state.searchVal, _this3.state.tableDefs["supplierShopItems"].searches ? _this3.state.tableDefs["supplierShopItems"].searches : [], _this3.state.searchFilters, _this3.state.searchDateFilters, _this3.state.refPhoneNumber, true);
	        } else if (_this3.state.stage === "storeAdminElse") {
	          //console.log("searching here....");
	          var result = (0, _searchRecords.searchRecords)(_this3.props.db[dTableName], _this3.state.searchVal, _this3.state.tableDefs[dTableName].searches ? _this3.state.tableDefs[dTableName].searches : [], _this3.state.searchFilters, _this3.state.searchDateFilters);
	          //console.log("searched return " + result.length + " records");
	          return result;
	        } else {
	          //console.log("searching here....");
	          var _result = (0, _searchRecords.searchRecords)(_this3.props.db[dTableName], _this3.state.searchVal, _this3.state.tableDefs[dTableName].searches ? _this3.state.tableDefs[dTableName].searches : [], _this3.state.searchFilters, _this3.state.searchDateFilters, _this3.state.refPhoneNumber);
	          //console.log("searched return " + result.length + " records");
	          return _result;
	        }
	      } else {
	        //console.log("returning blank");
	        return [];
	      }
	    }
	  };
	
	  this.getAdminData = function () {
	    //console.log("looking for data: " + this.state.tableName);
	    //console.log(JSON.stringify(this.state.searchFilters));
	    var dTableName = _this3.state.tableName;
	
	    if (dTableName !== "dashboard") {
	      //console.log("not dash");
	      if (_this3.state.searchVal === "" && Object(_this3.state.searchFilters).keys && Object(_this3.state.searchFilters).keys.length === 0) {
	        //console.log("time to return all data");
	        var allData = _this3.props.db[dTableName];
	        return allData;
	      } else {
	        //console.log("its with some filters");
	        if (_this3.state.tableDefs[dTableName] && _this3.state.tableDefs[dTableName] !== undefined) {
	          //console.log("it has some tableDefs");
	          var allFullData = (0, _searchRecords.searchRecords)(_this3.props.db[dTableName], _this3.state.searchVal, _this3.state.tableDefs[dTableName].searches, _this3.state.searchFilters, _this3.state.searchDateFilters);
	          //console.log(JSON.stringify(allFullData));
	          return allFullData;
	        } else {
	          //console.log("didnt search");
	        }
	      }
	    } else {
	        //console.log("its dash");
	      }
	  };
	
	  this.doStateUpdateForSearch = function () {
	    _this3.setState(function (prevState) {
	      return _extends({}, prevState, {
	        searchVal: _this3.refs.searchText.value,
	        searchFilters: {}
	      });
	    }, function () {
	      _this3.setScroll(true);
	    });
	  };
	
	  this.doDelaySearch = function () {
	    ////console.log("doning search...");
	    var q = _this3.refs.searchText.value;
	    //this.stateChangeHandler("searchVal", q, false);
	
	    if (q.length < 5) {
	      _this3.getDataThrottled();
	    } else {
	      _this3.getDataDebounced();
	    }
	  };
	
	  this.getSearchBar = function () {
	    /*
	    show only if it is not superadmin
	    1. shopFromASupplier
	    2. supplier
	    3. ??openBazar
	    4. addToShop
	     */
	    if (_this3.props.currUserRole !== "SUPERADMIN" && _this3.state.showGrid) {
	      if (_this3.state.stage === "shopFromASupplier" || _this3.state.stage === "supplier" || _this3.state.stage === "openBazarList" || _this3.state.stage === "addToShop") {
	        return _react2.default.createElement("div", null, _react2.default.createElement("div", null, _react2.default.createElement("input", {
	          type: "text",
	          placeholder: "Search...",
	          ref: "searchText",
	          onKeyUp: function onKeyUp() {
	            return _this3.doDelaySearch();
	          },
	          style: _defineProperty({
	            height: "30px",
	            borderRadius: "5px",
	            width: "100%",
	            border: "0px",
	            padding: "5px",
	            margin: "5px"
	          }, "border", "1px solid gainsboro")
	        })));
	      }
	    }
	  };
	
	  this.getFiltersList = function () {
	    var filtersList = [];
	    if (_this3.props.createTable && _this3.props.createTable.length > 0) {
	      var tableObj = _this3.props.createTable.find(function (item) {
	        return item.name === _this3.state.tableName;
	      });
	
	      if (tableObj && tableObj !== undefined) {
	        if (tableObj.filters && tableObj.filters !== undefined) {
	          filtersList = tableObj.filters;
	        }
	      }
	
	      return filtersList;
	    } else {
	      return [];
	    }
	  };
	
	  this.getFilterDropDowns = function () {
	    if (_this3.state.showGrid || true) {
	      return _react2.default.createElement("div", null, _react2.default.createElement(_GridFilters2.default, {
	        path: _this3.state.tableName,
	        stateHandler: _this3.stateChangeHandler,
	        value: _this3.state.searchFilters,
	        ogTableDef: _this3.state.formDefs,
	        filtersList: _this3.getFiltersList()
	      }), _react2.default.createElement(_GridDateFilters2.default, {
	        path: _this3.state.tableName,
	        stateHandler: _this3.stateChangeHandler,
	        value: _this3.state.searchDateFilters,
	        ogTableDef: _this3.state.formDefs,
	        filtersList: _this3.getFiltersList()
	      }));
	    }
	  };
	
	  this.getAllSuppliers = function () {
	    var allSup = _.chain(_this3.props.users).filter(function (item) {
	      return item.roleName === "STOREADMIN";
	    }).pluck("userMobile").filter(function (item) {
	      return item !== "" && item !== null && typeof item === "string";
	    }).value();
	    return allSup;
	  };
	
	  this.getGrid = function () {
	    if (_this3.props.currUserRole === "WORKER" || _this3.props.currUserRole === "STOREADMIN") {
	      if (_this3.state.stage === "orderlist") {
	        //console.log("getting worker grid");
	        return _react2.default.createElement("div", {
	          style: {
	            overflow: "auto"
	          }
	        }, _react2.default.createElement(_WorkerGrid2.default, {
	          data: _this3.getData(),
	          tableName: _this3.state.tableName,
	          tableDef: _this3.state.tableDefs[_this3.state.tableName],
	          handleEdit: _this3.handleOrderEdit,
	          handleDelete: _this3.handleDelete,
	          backToList: _this3.backToList,
	          dataIsLoaded: _this3.props.ui[_this3.state.tableName + "-downloaded"],
	          role: "worker",
	          phoneNumber: _this3.props.firebase.auth.currentUser.phoneNumber,
	          firebase: _this3.props.firebase,
	          updateRecord: _this3.props.onUpdateRecord,
	          onNotifyUsers: _this3.props.onNotifyUsers,
	          allSuppliers: _this3.getAllSuppliers(),
	          stage: _this3.state.stage,
	          repeatOrder: _this3.repeatOrder
	        }));
	      }
	
	      if (_this3.state.stage === "addToShop") {
	        var _React$createElement;
	
	        //console.log("sending MyShopGrid back");
	
	        return _react2.default.createElement(_MyShopGrid2.default, (_React$createElement = {
	          data: _this3.getAdminData(),
	          tableName: _this3.state.tableName,
	          tableDef: _this3.state.tableDefs[_this3.state.tableName],
	          handleEdit: _this3.handleMyShopEdit,
	          handleDelete: _this3.handleDelete,
	          genDirectSupplierOrder: _this3.genDirectSupplierOrder,
	          addToBucket: _this3.addToBucket,
	          removeFromBucket: _this3.removeFromBucket,
	          getBucketDetails: _this3.getBucketDetails,
	          supplierName: _this3.props.userProfile && _this3.props.userProfile["userCompany"] ? _this3.props.userProfile["userCompany"] : "",
	          supplierRole: _this3.props.userProfile && _this3.props.userProfile["roleName"] ? _this3.props.userProfile["roleName"] : "",
	          role: "all",
	          handleEditCancel: function handleEditCancel() {
	            _this3.backToList("addToShop", "supplierShopItems");
	            _this3.stateChangeHandler(true, "showGrid");
	          }
	        }, _defineProperty(_React$createElement, "handleDelete", _this3.handleDelete), _defineProperty(_React$createElement, "ogTableDef", (0, _extendedOgDef2.default)(_this3.props.createTable)), _defineProperty(_React$createElement, "genNotification", _this3.genNotification), _defineProperty(_React$createElement, "refPhoneNumber", _this3.state.refPhoneNumber), _React$createElement));
	      }
	
	      if (_this3.state.stage === "openBazarList") {
	        //console.log("open bazar grid");
	        return _react2.default.createElement(_OpenBazarGrid2.default, {
	          data: _this3.getData(),
	          tableName: _this3.state.tableName,
	          tableDef: _this3.state.tableDefs[_this3.state.tableName],
	          handleEdit: _this3.handleBazarEdit,
	          handleDelete: _this3.handleDelete,
	          handleAddNew: _this3.handleAddNew,
	          role: "worker",
	          phoneNumber: _this3.props.firebase.auth.currentUser.phoneNumber,
	          dataIsLoaded: _this3.props.ui[_this3.state.tableName + "-downloaded"],
	          firebase: _this3.props.firebase,
	          updateRecord: _this3.props.onUpdateRecord,
	          onNotifyUsers: _this3.props.onNotifyUsers
	        });
	      }
	      if (_this3.state.stage === "supplier") {
	        //console.log("sending back adming grid for supplier");
	        return _react2.default.createElement(_AdminGrid2.default, {
	          data: _this3.props.db["deliveryRequest"] && _this3.props.db["deliveryRequest"].length > 0 ? _this3.props.db["deliveryRequest"].slice(0, 250) : [],
	          tableName: _this3.state.tableName,
	          firebase: _this3.props.firebase,
	          updateRecord: _this3.props.onUpdateRecord,
	          onNotifyUsers: _this3.props.onNotifyUsers,
	          tableDef: _this3.state.tableDefs[_this3.state.tableName],
	          handleEdit: _this3.handleEdit,
	          handleDelete: _this3.handleDelete,
	          supplierName: _this3.props.userProfile && _this3.props.userProfile["userCompany"] ? _this3.props.userProfile["userCompany"] : "",
	          supplierRole: _this3.props.userProfile && _this3.props.userProfile["roleName"] ? _this3.props.userProfile["roleName"] : "",
	          role: "grocer",
	          dataIsLoaded: _this3.props.ui[_this3.state.tableName + "-downloaded"],
	          searchVal: _this3.state.searchVal,
	          allSuppliers: _this3.getAllSuppliers(),
	          fetchDistance: _this3.props.onFetchDistance,
	          updateRedux: _this3.props.onAddArray,
	          cellPhone: _this3.props.cellPhone
	        });
	      }
	      if (_this3.state.stage === "storeAdminElse") {
	        console.log("returing vanilla grid");
	        return _react2.default.createElement(_ContentGridVanilla2.default, {
	          data: _this3.getData(),
	          tableName: _this3.state.tableName,
	          tableDef: _this3.state.tableDefs[_this3.state.tableName],
	          handleEdit: _this3.handleEdit,
	          handleDelete: _this3.handleDelete
	        });
	      }
	    }
	  };
	
	  this.getTopMenu = function () {
	    //console.log("getting super admin menus");
	    return _react2.default.createElement("nav", { className: "navbar navbar-default navbar-fixed-top" }, _react2.default.createElement("div", { className: "container-fluid" }, _react2.default.createElement("div", { className: "navbar-header" }, _this3.state.stage !== "login" && _react2.default.createElement("button", {
	      type: "button",
	      className: "pull-left navbar-toggle collapsed",
	      "data-toggle": "collapse",
	      "data-target": "#navMenu",
	      "aria-expanded": "false",
	      style: {
	        marginLeft: "10px"
	      }
	    }, _react2.default.createElement("span", { className: "sr-only" }, "Toggle navigation"), _react2.default.createElement("span", { className: "icon-bar" }), _react2.default.createElement("span", { className: "icon-bar" }), _react2.default.createElement("span", { className: "icon-bar" })), _react2.default.createElement("a", {
	      className: "navbar-brand",
	      href: "#",
	      style: {
	        marginLeft: "-10px",
	        color: "black",
	        marginRight: "-10px",
	        width: "120px",
	        fontSize: "14px",
	        padding: "0px",
	        lineHeight: "50px"
	      }
	    }, (0, _getMenuList.getCaption)(_this3.state.tableName, _this3.props.listOfTables)), _this3.state.stage !== "login" && _this3.state.stage !== "orderpad" && _this3.state.showGrid && !_this3.state.showDash && _react2.default.createElement("button", {
	      type: "button",
	      className: "pull-right navbar-toggle",
	      style: {
	        marginLeft: "0px",
	        marginRight: "10px",
	        marginTop: "10px",
	        paddingRight: "13px",
	        paddingLeft: "13px",
	        paddingTop: "5px",
	        paddingBottom: "5px"
	      }
	    }, _react2.default.createElement("span", {
	      "class": "fa fa-filter fa-lg",
	      "aria-hidden": "true",
	      onClick: function onClick() {
	        _this3.setState(function (prevState) {
	          return _extends({}, prevState, {
	            showFilters: !prevState.showFilters
	          });
	        });
	      }
	    })), _this3.state.stage !== "login" && _this3.state.showGrid && (_this3.props.userProfile.roleName === "SUPERADMIN" || _this3.state.tableName === "supplierShopItems" || _this3.state.tableName === "openBazar") && _react2.default.createElement("button", {
	      type: "button",
	      className: "pull-right navbar-toggle",
	      style: {
	        marginLeft: "0px",
	        marginRight: "10px",
	        marginTop: "10px",
	        paddingRight: "13px",
	        paddingLeft: "13px",
	        paddingTop: "5px",
	        paddingBottom: "5px"
	      }
	    }, _react2.default.createElement("span", {
	      "class": "fa fa-plus fa-lg",
	      "aria-hidden": "true",
	      onClick: function onClick() {
	        if (_this3.props.currUserRole === "SUPERADMIN") {
	          _this3.handleAddNew(_this3.state.tableName);
	          _this3.stateChangeHandler(false, "showGrid", false);
	        } else {
	          if (_this3.state.stage === "openBazarList") {
	            _this3.handleAddNew("openBazar");
	          } else if (_this3.state.stage === "shopFromASupplier") {
	            _this3.handleAddNew("addToShop");
	          } else {
	            _this3.handleAddNew(_this3.state.stage);
	          }
	        }
	      }
	    }))), _this3.state.stage !== "login" && !_this3.state.showDash && _this3.state.showFilters && _react2.default.createElement("div", {
	      style: {
	        marginTop: "15px",
	        marginBottom: "15px"
	      }
	    }, _this3.state.showGrid && _this3.state.showFilters && _this3.getSearchBar()), _react2.default.createElement("div", { className: "collapse navbar-collapse", id: "navMenu" }, _react2.default.createElement("ul", { className: "nav navbar-nav navbar-left" }, _this3.fetchMenus()))));
	  };
	
	  this.getAdminGrid = function () {
	    console.log("getting admin grid");
	    if (_this3.props.currUserRole === "SUPERADMIN") {
	      return _react2.default.createElement(_ContentGridVanilla2.default, {
	        data: _this3.getAdminData(),
	        tableName: _this3.state.tableName,
	        tableDef: _this3.state.tableDefs[_this3.state.tableName],
	        handleEdit: _this3.handleEdit,
	        handleDelete: _this3.handleDelete
	      });
	    }
	  };
	
	  this.deliverOrderByStoreAdmin = function (key, fullPayload) {
	    var rec = _.cloneDeep(fullPayload);
	
	    var cloudPath = "deliveryRequest";
	
	    if (rec && rec.key && rec.key !== "") {
	      rec.status = "DELIVERED";
	      cloudPath = cloudPath + "/" + rec.key;
	
	      _this3.props.firebase.db.ref("/" + cloudPath).once("value").then(function (snap) {
	        return snap.ref.set(rec);
	      }).catch(function (err) {
	        console.log(err);
	        return console.log("some error: " + err);
	      }).then(function (err) {
	        alert("Order successfully updated as DELIVERED.");
	        var phArray = [];
	        phArray.push(rec.mobile);
	        _this3.props.onNotifyUsers("Your order was marked as delivered. If you have not received your items, please wait for a while. If you have already received your items, you can help us by rating the service.", phArray);
	      });
	    } else {
	      console.log("did not save");
	    }
	  };
	
	  this.getInputField = function (fieldName, poDefs) {
	    return (0, _getInputField2.default)(fieldName, "projectPos", _this3.state.data, _this3.stateChangeHandler, false, poDefs, _this3.props.db, _reactDeviceDetect.isMobile);
	  };
	
	  this.getNewBazarListButton = function () {
	    if (_this3.state.showGrid) {
	      return _react2.default.createElement("div", {
	        style: {
	          padding: "0.6em 2em",
	          borderRadius: "8px",
	          color: "#fff",
	          backgroundColor: "rgb(30, 101, 144)",
	          fontSize: "1.1em",
	          border: "0px",
	          cursor: "pointer",
	          margin: "1em",
	          fontWeight: "bold"
	        },
	        onClick: function onClick() {
	          (function () {
	            return _this3.handleAddNew("openBazar");
	          });
	        }
	      }, "POST MESSAGE IN BAZAR");
	    }
	  };
	
	  this.getBazarHeader = function () {
	    return _react2.default.createElement("div", {
	      style: {
	        padding: "5px",
	        position: "absolute",
	        zIndex: "1",
	        marginTop: "60px",
	        marginBottom: "40px",
	        width: "100%",
	        top: 0,
	        left: 0
	      }
	    }, _react2.default.createElement("div", null, _this3.getSearchBar()), _react2.default.createElement("table", {
	      className: _reactDeviceDetect.isMobile ? "table table-striped table-sm" : "table table-striped table-lg"
	    }, _react2.default.createElement("tbody", null, _react2.default.createElement("td", {
	      style: {
	        textAlign: "center",
	        padding: "5px"
	      }
	    }, _this3.getNewBazarListButton()))));
	  };
	
	  this.getShopListHeader = function () {
	    return _react2.default.createElement("div", {
	      style: {
	        padding: "5px",
	        position: "absolute",
	        zIndex: "1",
	        marginTop: "60px",
	        marginBottom: "40px",
	        width: "100%",
	        top: 0,
	        left: 0
	      }
	    }, _react2.default.createElement("div", null, _this3.getSearchBar()));
	  };
	
	  this.getPromoHeader = function () {
	    return _react2.default.createElement("div", {
	      style: {
	        padding: "5px",
	        position: "absolute",
	        zIndex: "1",
	        marginTop: "60px",
	        marginBottom: "40px",
	        width: "100%",
	        top: 0,
	        left: 0
	      }
	    }, _react2.default.createElement("div", null, _this3.getSearchBar()));
	  };
	
	  this.getDirectShopHeader = function () {
	    return _react2.default.createElement("div", {
	      style: {
	        padding: "5px",
	        position: "absolute",
	        zIndex: "1",
	        marginTop: "60px",
	        marginBottom: "40px",
	        width: "100%",
	        top: 0,
	        left: 0
	      }
	    }, _react2.default.createElement("div", null, _this3.getSearchBar()), _react2.default.createElement("table", {
	      className: _reactDeviceDetect.isMobile ? "table table-striped table-sm" : "table table-striped table-lg"
	    }, _react2.default.createElement("tbody", null, _react2.default.createElement("td", {
	      style: {
	        textAlign: "center",
	        padding: "5px"
	      }
	    }, _this3.getNewShopOrderButton()))));
	  };
	
	  this.storeAutoLoginToApp = function (phoneNumber) {
	    var elemEmail = document.getElementById("email");
	    var elemPass = document.getElementById("password");
	    var tmpEmail = "";
	    var tmpPass = "";
	    if (elemEmail && elemEmail.value !== "") {
	      tmpEmail = elemEmail.value;
	    }
	
	    if (elemPass && elemPass.value !== "") {
	      tmpPass = elemPass.value;
	    }
	    var msgToApp = {
	      actionType: "storeAutoLogin",
	      payload: {
	        email: tmpEmail,
	        password: tmpPass,
	        company: phoneNumber
	      }
	    };
	
	    if (window && window.ReactNativeWebView) {
	      //console.log("posing autologin message to app");
	      window.ReactNativeWebView.postMessage(JSON.stringify(msgToApp));
	    }
	  };
	
	  this.getUiForAuth = function () {
	    if (!_this3.state.notInitialized && _this3.props.firebase && _this3.props.firebase.phoneAuthProvider.PROVIDER_ID) {
	      //console.log("heaven");
	      return _react2.default.createElement(_reactFirebaseui.FirebaseAuth, {
	        uiConfig: {
	          // Popup signin flow rather than redirect flow.
	          signInFlow: "popup",
	          // Redirect to /signedIn after sign in is successful. Alternatively you can provide a callbacks.signInSuccess function.
	          signInSuccessUrl: "/workers",
	          callbacks: {
	            signInSuccess: function signInSuccess() {
	              console.log("something something");
	              return false;
	            },
	            signInSuccessWithAuthResult: function signInSuccessWithAuthResult() {
	              return false;
	            }
	          },
	          // We will display Google and Facebook as auth providers.
	
	          signInOptions: [{
	            provider: _this3.props.firebase.phoneAuthProvider.PROVIDER_ID,
	            recaptchaParameters: {
	              type: "image", // 'audio'
	              // size: "compact", // 'invisible' or 'compact'
	              badge: "bottomleft" //' bottomright' or 'inline' applies to invisible.
	            },
	            defaultCountry: "SG", // Set default country to the United Kingdom (+44).
	            // For prefilling the national number, set defaultNationNumber.
	            // This will only be observed if only phone Auth provider is used since
	            // for multiple providers, the NASCAR screen will always render first
	            // with a 'sign in with phone number' button.
	            defaultNationalNumber: "",
	            // You can also pass the full phone number string instead of the
	            // 'defaultCountry' and 'defaultNationalNumber'. However, in this case,
	            // the first country ID that matches the country code will be used to
	            // populate the country selector. So for countries that share the same
	            // country code, the selected country may not be the expected one.
	            // In that case, pass the 'defaultCountry' instead to ensure the exact
	            // country is selected. The 'defaultCountry' and 'defaultNationaNumber'
	            // will always have higher priority than 'loginHint' which will be ignored
	            // in their favor. In this case, the default country will be 'GB' even
	            // though 'loginHint' specified the country code as '+1'.
	            loginHint: ""
	          }]
	        },
	        firebaseAuth: _this3.props.firebase.auth
	      });
	    } else {
	      //console.log("hell");
	    }
	  };
	
	  this.getHiddenControls = function () {
	    return _react2.default.createElement("div", null, window.location.hostname !== _this3.state.localhost && _react2.default.createElement("input", {
	      type: "hidden",
	      className: "form-control",
	      id: "company",
	      ref: "company"
	    }), window.location.hostname === _this3.state.localhost && _react2.default.createElement("input", {
	      type: "hidden",
	      className: "form-control",
	      id: "company",
	      ref: "company",
	      value: _rawState.localState.phoneNumber
	    }), _react2.default.createElement("input", {
	      className: "form-control",
	      id: "appVersion",
	      ref: "appVersion",
	      type: "hidden"
	    }), _react2.default.createElement("input", { className: "form-control", id: "email", ref: "email", type: "hidden" }), _react2.default.createElement("input", {
	      className: "form-control",
	      id: "password",
	      secure: true,
	      ref: "password",
	      type: "hidden",
	      disabled: _this3.state.loginProgress
	    }));
	  };
	
	  this.getLoginPage = function () {
	    if (_this3.state.showGoog) {
	      return _react2.default.createElement("div", {
	        style: {
	          marginTop: "60px"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          border: "0px solid grey",
	          borderRadius: "5px",
	          padding: "5px"
	        }
	      }, _react2.default.createElement("div", {
	        style: {
	          marginTop: "3px",
	          marginBottom: "3px"
	        }
	      }, _this3.getUiForAuth()), !_this3.state.isSignedIn && _this3.state.stage === "login" && (0, _getMarketingBox.getMarketingBox)(), _react2.default.createElement("div", {
	        style: {
	          marginTop: "3px",
	          marginBottom: "3px",
	          textAlign: "center",
	          margin: "10px"
	        }
	      })));
	    } else {
	      return _react2.default.createElement("div", {
	        style: {
	          margin: "auto",
	          display: "flex",
	          justifyContent: "center",
	          alignItems: "center",
	          height: "100vh"
	        }
	      }, _react2.default.createElement("img", {
	        src: _imageText.logoB64Text,
	        style: {
	          height: "100px",
	          width: "100px",
	          borderRadius: "100px",
	          animation: "rotation 2s infinite linear",
	          perspective: "1000px"
	        }
	      }));
	    }
	  };
	
	  this.loadBasicData = function () {
	    if (_this3.props.notLoadedBasicData && _this3.props.firebase && _this3.props.firebase.auth && _this3.props.firebase.auth.currentUser) {
	      var strTokDets = JSON.stringify(_this3.props.firebase.auth.currentUser);
	      var objTokDets = JSON.parse(strTokDets);
	      //console.log("s1 loading data ");
	      var refPhoneNumber = _this3.props.firebase.auth.currentUser.phoneNumber;
	      if (!refPhoneNumber || refPhoneNumber === null || refPhoneNumber === "") {
	        _this3.switchMenu("signout");
	        return;
	      }
	      refPhoneNumber = refPhoneNumber.replace("+65", "");
	      var accessToken = undefined;
	
	      // LogRocket.identify(refPhoneNumber, {
	      //   name: refPhoneNumber,
	      //   email: refPhoneNumber,
	      //   // Add your own custom user variables here, ie:
	      //   subscriptionType: "pro"
	      // });
	      _this3.storeAutoLoginToApp(refPhoneNumber);
	      _this3.props.onSetUiFlag("cellPhone", _this3.props.firebase.auth.currentUser.phoneNumber);
	      _this3.stateChangeHandler(refPhoneNumber, "refPhoneNumber", "");
	      if (refPhoneNumber !== null && refPhoneNumber !== undefined && refPhoneNumber !== "") {
	        _this3.props.onReachApiExtended({
	          fetchQuery: "https://bau0t6mjj6.execute-api.us-east-1.amazonaws.com/default/getAgrani",
	          method: "GET",
	          message: null,
	          path: "agraniRates",
	          headers: {}
	        });
	
	        _this3.props.onReachApiExtended({
	          fetchQuery: "https://m70fg43zh9.execute-api.us-east-1.amazonaws.com/default/getPrime",
	          method: "GET",
	          message: null,
	          path: "primeRates",
	          headers: {}
	        });
	        _this3.props.loadFbData("myPassDetails", _this3.props.firebase, false, "myPassDetails/" + refPhoneNumber, true).then(function (listRes) {
	          //console.log(moment().format("x") + " basic orders done");
	        });
	        accessToken = objTokDets.stsTokenManager.accessToken;
	
	        //passport applictions related stff
	        _this3.props.loadFbData("myPassApps", _this3.props.firebase, false, "myPassApps/+65" + refPhoneNumber).then(function (listRes) {
	          //console.log(moment().format("x") + " basic orders done");
	        });
	        if (accessToken) {
	          _this3.props.onInitialFetch("hCommApps", _this3.props.firebase.dbUrl + "/hCommApps.json", accessToken);
	        }
	        //update first secretary's number here
	        if (refPhoneNumber === "94562455") {
	          _this3.props.loadFbData("hCommApps", _this3.props.firebase, false, "hCommApps").then(function (listRes) {
	            //console.log(moment().format("x") + " basic orders done");
	          });
	        }
	
	        //remittance applications related stuff
	        _this3.props.loadFbData("myRemitApps", _this3.props.firebase, false, "remSvc/+65" + refPhoneNumber + "/remApps").then(function (listRes) {
	          //console.log(moment().format("x") + " basic orders done");
	        });
	        _this3.props.loadFbData("myRemitRegs", _this3.props.firebase, false, "remSvc/+65" + refPhoneNumber + "/remRegs").then(function (listRes) {
	          //console.log(moment().format("x") + " basic orders done");
	        });
	        /************************** */
	        //agranionly
	        if (accessToken) {
	          _this3.props.onInitialFetch("agraniApps", _this3.props.firebase.dbUrl + "/agraniApps.json", accessToken);
	        }
	        //update agrani's numbers here
	        if (refPhoneNumber === "94562455") {
	          _this3.props.loadFbData("agraniApps", _this3.props.firebase, false, "agraniApps").then(function (listRes) {
	            //console.log(moment().format("x") + " basic orders done");
	          });
	        }
	
	        if (accessToken) {
	          _this3.props.onInitialFetch("agraniRegs", _this3.props.firebase.dbUrl + "/agraniRegs.json", accessToken);
	        }
	        //update agrani's numbers here
	        if (refPhoneNumber === "94562455") {
	          _this3.props.loadFbData("agraniRegs", _this3.props.firebase, false, "agraniRegs").then(function (listRes) {
	            //console.log(moment().format("x") + " basic orders done");
	          });
	        }
	        /************************** */
	
	        //PRIME STUFF
	        /************************** */
	        //primeonly
	        if (accessToken) {
	          _this3.props.onInitialFetch("primeApps", _this3.props.firebase.dbUrl + "/primeApps.json", accessToken);
	        }
	        //update agrani's numbers here
	        if (refPhoneNumber === "94562455") {
	          _this3.props.loadFbData("primeApps", _this3.props.firebase, false, "primeApps").then(function (listRes) {
	            //console.log(moment().format("x") + " basic orders done");
	          });
	        }
	
	        if (accessToken) {
	          _this3.props.onInitialFetch("primeRegs", _this3.props.firebase.dbUrl + "/primeRegs.json", accessToken);
	        }
	        //update agrani's numbers here
	        if (refPhoneNumber === "94562455") {
	          _this3.props.loadFbData("primeRegs", _this3.props.firebase, false, "primeRegs").then(function (listRes) {
	            //console.log(moment().format("x") + " basic orders done");
	          });
	        }
	        /************************** */
	        // this.props.onInitialProductsFetch(
	        //   this.props.firebase.dbUrl + "/supplierShopItems.json",
	        //   accessToken
	        // );
	
	        // this.props.onInitialFetch(
	        //   "POPULAR",
	        //   this.props.firebase.dbUrl + "/POPULAR.json",
	        //   accessToken
	        // );
	
	        /*
	        listOfTables: tListOfTables,
	        createTable: tCreateTable,
	        menuDesigner: tMenuDesigner,
	        */
	
	        // if (accessToken) {
	        //   this.props.onInitialFetch(
	        //     "listOfTables",
	        //     this.props.firebase.dbUrl + "/listOfTables.json",
	        //     accessToken
	        //   );
	        // }
	        // if (accessToken) {
	        //   this.props.onInitialFetch(
	        //     "createTable",
	        //     this.props.firebase.dbUrl + "/createTable.json",
	        //     accessToken
	        //   );
	        // }
	        // if (accessToken) {
	        //   this.props.onInitialFetch(
	        //     "menuDesigner",
	        //     this.props.firebase.dbUrl + "/menuDesigner.json",
	        //     accessToken
	        //   );
	        // }
	
	        // if (accessToken) {
	        //   this.props.onInitialFetch(
	        //     "users",
	        //     this.props.firebase.dbUrl + "/users.json",
	        //     accessToken
	        //   );
	        // }
	
	        // this.props
	        //   .loadFbData("supplierShopItems", this.props.firebase, false)
	        //   .then(listrest => {
	        //     //console.log(moment().format("x") + " basic products done");
	        //   });
	
	        _this3.props.loadFbData("openBazar", _this3.props.firebase, false).then(function (listrest) {
	          //console.log(moment().format("x") + " basic products done");
	        });
	
	        var otherRole = "";
	        var tgtUser = undefined;
	        if (_this3.props.users && _this3.props.users.length > 0) {
	          //console.log(JSON.stringify(this.props.users));
	          tgtUser = _this3.props.users.find(function (uItem) {
	            if (uItem.userMobile && uItem.userMobile !== "" && uItem.userMobile.includes(refPhoneNumber)) {
	              //console.log(uItem.userName + " " + uItem.userMobile + " is true");
	              return true;
	            } else {
	              return false;
	            }
	          });
	        }
	        if (tgtUser && tgtUser !== undefined && tgtUser.roleName && tgtUser.roleName !== "") {
	          //console.log("user is found: " + tgtUser.roleName);
	          otherRole = tgtUser.roleName;
	          _this3.props.onAddRecord({
	            path: "userProfile",
	            payload: tgtUser
	          });
	        } else {
	          var usrStrLength = _this3.props.users && _this3.props.users.length > 0 ? _this3.props.users.length : "0";
	          //console.log("user is not found. " + usrStrLength);
	        }
	
	        if (otherRole === "") {
	          otherRole = "WORKER";
	          if (accessToken) {
	            _this3.props.onInitialFetch("deliveryRequest", _this3.props.firebase.dbUrl + "/myOrders/" + refPhoneNumber + ".json", accessToken);
	          }
	          _this3.props.loadFbData("deliveryRequest", _this3.props.firebase, false, "myOrders/" + refPhoneNumber).then(function (listRes) {
	            //console.log(moment().format("x") + " basic orders done");
	          });
	        } else {
	          if (accessToken) {
	            _this3.props.onInitialFetch("deliveryRequest", _this3.props.firebase.dbUrl + "/deliveryRequest.json", accessToken);
	          }
	
	          //load orders
	          //console.log(moment().format("x") + " loading orders");
	          _this3.props.loadFbData("deliveryRequest", _this3.props.firebase, false).then(function (listRes) {
	            //console.log(moment().format("x") + " basic orders done");
	          });
	
	          _this3.props.loadFbData("purchase", _this3.props.firebase, false).then(function (listRes) {
	            //console.log("deliveryRequest done");
	          });
	        }
	
	        _this3.props.onSetUiFlag("currUserRole", otherRole);
	        _this3.props.onSetUiFlag("loginProgress", false);
	        _this3.switchMenu("bcsHome");
	        _this3.stateChangeHandler(false, "showMenu", false);
	      }
	    } else {
	      console.log("waiting for auth");
	    }
	  };
	
	  this.doLogin = function (nextAction, enterAsWorker) {
	    // console.log(
	    //   "nextAction: " + nextAction + " enterAsWorker: " + enterAsWorker
	    // );
	    _this3.stateChangeHandler(enterAsWorker, "enterAsWorker", false);
	    if (_this3.props.currUserRole === "WORKER") {
	      //this user is a worker
	      //console.log("entering as non admin now");
	      if (!enterAsWorker && nextAction === "admin") {
	        alert("You are not registered as a supplier. Please contact Kabir Hossain at +65 94562455 to sign-up as a supplier.");
	        _this3.stateChangeHandler("users", "tableName", false);
	      } else {
	        if (nextAction === "orderpad") {
	          _this3.handleAddNew(nextAction);
	        } else {
	          _this3.stateChangeHandler(nextAction, "stage", false);
	        }
	      }
	    } else {
	      if (!enterAsWorker) {
	        console.log("yes this is non worker account");
	        _this3.stateChangeHandler(nextAction, "stage", false);
	      } else {
	        //menu problem
	        if (nextAction === "orderpad") {
	          _this3.handleAddNew(nextAction);
	        } else {
	          _this3.stateChangeHandler(nextAction, "stage", false);
	        }
	      }
	    }
	  };
	
	  this.getBg = function (actor) {
	    var now = (0, _moment2.default)();
	    var numb = now.seconds();
	    //console.log("numb: " + numb);
	    var bgImage = null;
	    if (actor.bgImage === "bcsshop") {
	      bgImage = _bcsShopImage.bcsShopImage;
	    } else {
	      bgImage = _bcsOpenBazarImage.bcsOpenBazarImage;
	    }
	    if (actor.bgImage === "bcsshop") {
	      return _react2.default.createElement("video", {
	        loop: true,
	        autoPlay: "autoplay",
	        muted: true,
	        preload: "yes",
	        playsinline: "playsinline",
	        poster: bgImage,
	        style: {
	          overflow: "hidden",
	          width: "100%",
	          height: "100%",
	          objectFit: "cover",
	          top: 0,
	          left: 0,
	          borderRadius: "5px",
	          position: "absolute",
	          zIndex: "-1"
	        },
	        id: "vidTest"
	      });
	    } else {
	      return _react2.default.createElement("video", _defineProperty({
	        loop: true,
	        autoPlay: "autoplay",
	        playbackRate: "0.5",
	        id: "vid",
	        muted: true,
	        playsinline: "playsinline",
	        poster: bgImage,
	        style: {
	          overflow: "hidden",
	          width: "100%",
	          height: "100%",
	          objectFit: "cover",
	          top: 0,
	          left: 0,
	          position: "absolute",
	          borderRadius: "5px",
	          zIndex: "-1"
	        }
	      }, "id", "vidTest"));
	    }
	  };
	
	  this.getMediaEntry = function (actor) {
	    var _ref5;
	
	    var forceWorker = actor.forceWorker === "YES";
	    /*
	    
	    */
	
	    // let imgLoader = new Image();
	
	    // imgLoader.src = actor.bgImage;
	    // imgLoader.onload = () => {
	    //   this.props.onSetUiFlag(actor.key, false);
	    // };
	    // if (this.props.ui[actor.key]) {
	    // } else {
	    return _react2.default.createElement("div", {
	      style: (_ref5 = {
	        textAlign: "center",
	        maxWidth: "600px",
	        minHeight: "200px",
	        margin: "auto",
	        borderRadius: "10px",
	        border: "1px solid #E0E6E8",
	        boxSizing: "border-box",
	        boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)"
	      }, _defineProperty(_ref5, "margin", "5px"), _defineProperty(_ref5, "overflow", "hidden"), _defineProperty(_ref5, "position", "relative"), _defineProperty(_ref5, "marginBottom", "20px"), _defineProperty(_ref5, "display", "flex"), _ref5),
	      onClick: function onClick() {
	        _this3.stateChangeHandler(actor.action1, "stage", false);
	
	        //fix this later to make it parametrized
	        if (actor.action1 === "shopFromASupplier") {
	          _this3.stateChangeHandler({ category: "POPULAR" }, "searchFilters", false);
	        } else {
	          _this3.stateChangeHandler({}, "searchFilters", false);
	        }
	
	        _this3.stateChangeHandler(actor.tableName, "tableName", false);
	        _this3.stateChangeHandler(actor.userCompany, "selectedSupplier", false);
	        _this3.stateChangeHandler(forceWorker, "enterAsWorker", false);
	        _this3.setScroll(true);
	      }
	    }, _this3.getBg(actor), _react2.default.createElement("div", {
	      style: {
	        margin: "auto",
	        textAlign: "center",
	        width: "100%",
	        bottom: "0"
	      }
	    }, _react2.default.createElement("div", {
	      style: {
	        width: "45px",
	        height: "45px",
	        position: "absolute",
	        top: "0",
	        right: "0",
	        backgroundColor: "rgb(30, 101, 144)",
	        borderRadius: "60px",
	        margin: "5px",
	        padding: "0px",
	        display: "flex",
	        justifyContent: "center",
	        alignItems: "center",
	        border: "1.4px solid white"
	      }
	    }, _react2.default.createElement("span", {
	      className: "blink",
	      style: {
	        color: "white",
	        fontSize: "12px",
	        lineHeight: "12px",
	        WebkitTextStroke: "1px white"
	      }
	    }, actor.compIntoText)), _react2.default.createElement("div", {
	      style: {
	        textAlign: "center",
	        margin: "auto",
	        marginTop: "0px",
	        color: "white"
	      }
	    }, _react2.default.createElement("div", {
	      style: {
	        marginBottom: "-5px"
	      }
	    }, _react2.default.createElement("span", {
	      style: {
	        fontSize: "26px",
	        fontWeight: "bold",
	        textTransform: "uppercase",
	        textShadow: "-1px -1px 0 #000,  1px -1px 0 #000,-1px  1px 0 #000,1px  1px 0 #000"
	      }
	    }, actor.promoHeader)), _react2.default.createElement("div", {
	      style: {
	        color: "white",
	        fontSize: "18px",
	        textShadow: "-1px -1px 0 #000,  1px -1px 0 #000,-1px  1px 0 #000,1px  1px 0 #000"
	      }
	    }, _react2.default.createElement("span", null, actor.promoDescription)))));
	    //}
	  };
	
	  this.getRemitCard = function () {
	    var _ref6;
	
	    return _react2.default.createElement("div", {
	      style: (_ref6 = {
	        textAlign: "center",
	        maxWidth: "600px",
	        minHeight: "200px",
	        margin: "auto",
	        borderRadius: "10px",
	        border: "1px solid #E0E6E8",
	        boxSizing: "border-box",
	        boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)"
	      }, _defineProperty(_ref6, "margin", "5px"), _defineProperty(_ref6, "overflow", "hidden"), _defineProperty(_ref6, "position", "relative"), _defineProperty(_ref6, "marginBottom", "20px"), _defineProperty(_ref6, "display", "flex"), _defineProperty(_ref6, "backgroundImage", "url(" + _bcsPassportSvcImage.bcsPassportSvcImage + ")"), _defineProperty(_ref6, "backgroundSize", "cover"), _ref6),
	      onClick: function onClick() {
	        _this3.setScroll(true);
	        _this3.stateChangeHandler("remitService", "stage", false);
	        // this.props.onReachApiExtended({
	        //   fetchQuery:
	        //     "https://bau0t6mjj6.execute-api.us-east-1.amazonaws.com/default/getAgrani",
	        //   method: "GET",
	        //   message: null,
	        //   path: "agraniRates",
	        //   headers: {}
	        // });
	
	        // this.props.onReachApiExtended({
	        //   fetchQuery:
	        //     "https://m70fg43zh9.execute-api.us-east-1.amazonaws.com/default/getPrime",
	        //   method: "GET",
	        //   message: null,
	        //   path: "primeRates",
	        //   headers: {}
	        // });
	      }
	    }, _react2.default.createElement("div", {
	      style: {
	        margin: "auto",
	        textAlign: "center",
	        width: "100%",
	        bottom: "0"
	      }
	    }, _react2.default.createElement("div", {
	      style: {
	        width: "45px",
	        height: "45px",
	        position: "absolute",
	        top: "0",
	        right: "0",
	        backgroundColor: "rgb(30, 101, 144)",
	        borderRadius: "60px",
	        margin: "5px",
	        padding: "0px",
	        display: "flex",
	        justifyContent: "center",
	        alignItems: "center",
	        border: "1.4px solid white"
	      }
	    }, _react2.default.createElement("span", {
	      className: "blink",
	      style: {
	        color: "white",
	        fontSize: "12px",
	        lineHeight: "12px",
	        WebkitTextStroke: "1px white"
	      }
	    }, "ENTER")), _react2.default.createElement("div", {
	      style: {
	        textAlign: "center",
	        margin: "auto",
	        marginTop: "5px",
	        color: "white"
	      }
	    }, _react2.default.createElement("div", {
	      style: {
	        marginBottom: "-5px"
	      }
	    }, _react2.default.createElement("span", {
	      style: {
	        fontSize: "26px",
	        fontWeight: "bold",
	        textTransform: "uppercase",
	        textShadow: "-1px -1px 0 #000,  1px -1px 0 #000,-1px  1px 0 #000,1px  1px 0 #000"
	      }
	    }, "SEND MONEY TO HOME")), _react2.default.createElement("div", {
	      style: {
	        color: "white",
	        fontSize: "18px",
	        textShadow: "-1px -1px 0 #000,  1px -1px 0 #000,-1px  1px 0 #000,1px  1px 0 #000"
	      }
	    }, _react2.default.createElement("span", null, "\u098F\u0996\u09A8 \u09A5\u09C7\u0995\u09C7 \u09AE\u09CB\u09AC\u09BE\u0987\u09B2 \u09AB\u09CB\u09A8\u09C7\u0987 \u09AE\u09BE\u09A4\u09CD\u09B0 \u09A6\u09C1\u0987 \u09AE\u09BF\u09A8\u09BF\u099F\u09C7 \u09AA\u09BE\u09B8\u09AA\u09CB\u09B0\u09CD\u099F \u09A8\u09AC\u09BE\u09DF\u09A8\u09C7\u09B0 \u0986\u09AC\u09C7\u09A6\u09A8 \u0995\u09B0\u09BE \u09AF\u09BE\u09AC\u09C7\u0964")), _react2.default.createElement("div", {
	      style: {
	        color: "white",
	        textShadow: "-1px -1px 0 #000,  1px -1px 0 #000,-1px  1px 0 #000,1px  1px 0 #000"
	      }
	    }, _react2.default.createElement("span", null, "\u09B9\u09C7\u09B2\u09CD\u09AA \u09B2\u09BE\u0997\u09B2\u09C7 \u098F\u0987 \u09A8\u09BE\u09AE\u09CD\u09AC\u09BE\u09B0\u09C7 94562455 \u09AB\u09CB\u09A8 \u0995\u09B0\u09C1\u09A8")))));
	  };
	
	  this.getAgraniCard = function () {
	    var _ref7;
	
	    return _react2.default.createElement("div", {
	      style: (_ref7 = {
	        textAlign: "center",
	        maxWidth: "600px",
	        minHeight: "200px",
	        margin: "auto",
	        borderRadius: "10px",
	        border: "1px solid #E0E6E8",
	        boxSizing: "border-box",
	        boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)"
	      }, _defineProperty(_ref7, "margin", "5px"), _defineProperty(_ref7, "overflow", "hidden"), _defineProperty(_ref7, "position", "relative"), _defineProperty(_ref7, "marginBottom", "20px"), _defineProperty(_ref7, "display", "flex"), _defineProperty(_ref7, "backgroundImage", "url(" + _bcsPassportSvcImage.bcsPassportSvcImage + ")"), _defineProperty(_ref7, "backgroundSize", "cover"), _ref7),
	      onClick: function onClick() {
	        _this3.setScroll(true);
	        _this3.stateChangeHandler("agraniService", "stage", false);
	      }
	    }, _react2.default.createElement("div", {
	      style: {
	        margin: "auto",
	        textAlign: "center",
	        width: "100%",
	        bottom: "0"
	      }
	    }, _react2.default.createElement("div", {
	      style: {
	        width: "45px",
	        height: "45px",
	        position: "absolute",
	        top: "0",
	        right: "0",
	        backgroundColor: "rgb(30, 101, 144)",
	        borderRadius: "60px",
	        margin: "5px",
	        padding: "0px",
	        display: "flex",
	        justifyContent: "center",
	        alignItems: "center",
	        border: "1.4px solid white"
	      }
	    }, _react2.default.createElement("span", {
	      className: "blink",
	      style: {
	        color: "white",
	        fontSize: "12px",
	        lineHeight: "12px",
	        WebkitTextStroke: "1px white"
	      }
	    }, "ENTER")), _react2.default.createElement("div", {
	      style: {
	        textAlign: "center",
	        margin: "auto",
	        marginTop: "5px",
	        color: "white"
	      }
	    }, _react2.default.createElement("div", {
	      style: {
	        marginBottom: "-5px"
	      }
	    }, _react2.default.createElement("span", {
	      style: {
	        fontSize: "26px",
	        fontWeight: "bold",
	        textTransform: "uppercase",
	        textShadow: "-1px -1px 0 #000,  1px -1px 0 #000,-1px  1px 0 #000,1px  1px 0 #000"
	      }
	    }, "AGRANI ADMIN CENTER")), _react2.default.createElement("div", {
	      style: {
	        color: "white",
	        fontSize: "18px",
	        textShadow: "-1px -1px 0 #000,  1px -1px 0 #000,-1px  1px 0 #000,1px  1px 0 #000"
	      }
	    }, _react2.default.createElement("span", null, "\u098F\u0996\u09A8 \u09A5\u09C7\u0995\u09C7 \u09AE\u09CB\u09AC\u09BE\u0987\u09B2 \u09AB\u09CB\u09A8\u09C7\u0987 \u09AE\u09BE\u09A4\u09CD\u09B0 \u09A6\u09C1\u0987 \u09AE\u09BF\u09A8\u09BF\u099F\u09C7 \u09AA\u09BE\u09B8\u09AA\u09CB\u09B0\u09CD\u099F \u09A8\u09AC\u09BE\u09DF\u09A8\u09C7\u09B0 \u0986\u09AC\u09C7\u09A6\u09A8 \u0995\u09B0\u09BE \u09AF\u09BE\u09AC\u09C7\u0964")), _react2.default.createElement("div", {
	      style: {
	        color: "white",
	        textShadow: "-1px -1px 0 #000,  1px -1px 0 #000,-1px  1px 0 #000,1px  1px 0 #000"
	      }
	    }, _react2.default.createElement("span", null, "\u09B9\u09C7\u09B2\u09CD\u09AA \u09B2\u09BE\u0997\u09B2\u09C7 \u098F\u0987 \u09A8\u09BE\u09AE\u09CD\u09AC\u09BE\u09B0\u09C7 94562455 \u09AB\u09CB\u09A8 \u0995\u09B0\u09C1\u09A8")))));
	  };
	
	  this.getPrimeCard = function () {
	    var _ref8;
	
	    return _react2.default.createElement("div", {
	      style: (_ref8 = {
	        textAlign: "center",
	        maxWidth: "600px",
	        minHeight: "200px",
	        margin: "auto",
	        borderRadius: "10px",
	        border: "1px solid #E0E6E8",
	        boxSizing: "border-box",
	        boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)"
	      }, _defineProperty(_ref8, "margin", "5px"), _defineProperty(_ref8, "overflow", "hidden"), _defineProperty(_ref8, "position", "relative"), _defineProperty(_ref8, "marginBottom", "20px"), _defineProperty(_ref8, "display", "flex"), _defineProperty(_ref8, "backgroundImage", "url(" + _bcsPassportSvcImage.bcsPassportSvcImage + ")"), _defineProperty(_ref8, "backgroundSize", "cover"), _ref8),
	      onClick: function onClick() {
	        _this3.setScroll(true);
	        _this3.stateChangeHandler("primeService", "stage", false);
	      }
	    }, _react2.default.createElement("div", {
	      style: {
	        margin: "auto",
	        textAlign: "center",
	        width: "100%",
	        bottom: "0"
	      }
	    }, _react2.default.createElement("div", {
	      style: {
	        width: "45px",
	        height: "45px",
	        position: "absolute",
	        top: "0",
	        right: "0",
	        backgroundColor: "rgb(30, 101, 144)",
	        borderRadius: "60px",
	        margin: "5px",
	        padding: "0px",
	        display: "flex",
	        justifyContent: "center",
	        alignItems: "center",
	        border: "1.4px solid white"
	      }
	    }, _react2.default.createElement("span", {
	      className: "blink",
	      style: {
	        color: "white",
	        fontSize: "12px",
	        lineHeight: "12px",
	        WebkitTextStroke: "1px white"
	      }
	    }, "ENTER")), _react2.default.createElement("div", {
	      style: {
	        textAlign: "center",
	        margin: "auto",
	        marginTop: "5px",
	        color: "white"
	      }
	    }, _react2.default.createElement("div", {
	      style: {
	        marginBottom: "-5px"
	      }
	    }, _react2.default.createElement("span", {
	      style: {
	        fontSize: "26px",
	        fontWeight: "bold",
	        textTransform: "uppercase",
	        textShadow: "-1px -1px 0 #000,  1px -1px 0 #000,-1px  1px 0 #000,1px  1px 0 #000"
	      }
	    }, "SEND MONEY VIA PRIME EXCHANGE")), _react2.default.createElement("div", {
	      style: {
	        color: "white",
	        fontSize: "18px",
	        textShadow: "-1px -1px 0 #000,  1px -1px 0 #000,-1px  1px 0 #000,1px  1px 0 #000"
	      }
	    }, _react2.default.createElement("span", null)), _react2.default.createElement("div", {
	      style: {
	        color: "white",
	        textShadow: "-1px -1px 0 #000,  1px -1px 0 #000,-1px  1px 0 #000,1px  1px 0 #000"
	      }
	    }, _react2.default.createElement("span", null)))));
	  };
	
	  this.getPassportCard = function () {
	    var _ref9;
	
	    return _react2.default.createElement("div", {
	      style: (_ref9 = {
	        textAlign: "center",
	        maxWidth: "600px",
	        minHeight: "200px",
	        margin: "auto",
	        borderRadius: "10px",
	        border: "1px solid #E0E6E8",
	        boxSizing: "border-box",
	        boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)"
	      }, _defineProperty(_ref9, "margin", "5px"), _defineProperty(_ref9, "overflow", "hidden"), _defineProperty(_ref9, "position", "relative"), _defineProperty(_ref9, "marginBottom", "20px"), _defineProperty(_ref9, "display", "flex"), _defineProperty(_ref9, "backgroundImage", "url(" + _bcsPassportSvcImage.bcsPassportSvcImage + ")"), _defineProperty(_ref9, "backgroundSize", "cover"), _ref9),
	      onClick: function onClick() {
	        _this3.setScroll(true);
	        _this3.stateChangeHandler("passportService", "stage", false);
	      }
	    }, _react2.default.createElement("div", {
	      style: {
	        margin: "auto",
	        textAlign: "center",
	        width: "100%",
	        bottom: "0"
	      }
	    }, _react2.default.createElement("div", {
	      style: {
	        width: "45px",
	        height: "45px",
	        position: "absolute",
	        top: "0",
	        right: "0",
	        backgroundColor: "rgb(30, 101, 144)",
	        borderRadius: "60px",
	        margin: "5px",
	        padding: "0px",
	        display: "flex",
	        justifyContent: "center",
	        alignItems: "center",
	        border: "1.4px solid white"
	      }
	    }, _react2.default.createElement("span", {
	      className: "blink",
	      style: {
	        color: "white",
	        fontSize: "12px",
	        lineHeight: "12px",
	        WebkitTextStroke: "1px white"
	      }
	    }, "ENTER")), _react2.default.createElement("div", {
	      style: {
	        textAlign: "center",
	        margin: "auto",
	        marginTop: "5px",
	        color: "white"
	      }
	    }, _react2.default.createElement("div", {
	      style: {
	        marginBottom: "-5px"
	      }
	    }, _react2.default.createElement("span", {
	      style: {
	        fontSize: "26px",
	        fontWeight: "bold",
	        textTransform: "uppercase",
	        textShadow: "-1px -1px 0 #000,  1px -1px 0 #000,-1px  1px 0 #000,1px  1px 0 #000"
	      }
	    }, "PASSPORT RENEWAL SERVICE")), _react2.default.createElement("div", {
	      style: {
	        color: "white",
	        fontSize: "18px",
	        textShadow: "-1px -1px 0 #000,  1px -1px 0 #000,-1px  1px 0 #000,1px  1px 0 #000"
	      }
	    }, _react2.default.createElement("span", null, "\u098F\u0996\u09A8 \u09A5\u09C7\u0995\u09C7 \u09AE\u09CB\u09AC\u09BE\u0987\u09B2 \u09AB\u09CB\u09A8\u09C7\u0987 \u09AE\u09BE\u09A4\u09CD\u09B0 \u09A6\u09C1\u0987 \u09AE\u09BF\u09A8\u09BF\u099F\u09C7 \u09AA\u09BE\u09B8\u09AA\u09CB\u09B0\u09CD\u099F \u09A8\u09AC\u09BE\u09DF\u09A8\u09C7\u09B0 \u0986\u09AC\u09C7\u09A6\u09A8 \u0995\u09B0\u09BE \u09AF\u09BE\u09AC\u09C7\u0964")), _react2.default.createElement("div", {
	      style: {
	        color: "white",
	        textShadow: "-1px -1px 0 #000,  1px -1px 0 #000,-1px  1px 0 #000,1px  1px 0 #000"
	      }
	    }, _react2.default.createElement("span", null, "\u09B9\u09C7\u09B2\u09CD\u09AA \u09B2\u09BE\u0997\u09B2\u09C7 \u098F\u0987 \u09A8\u09BE\u09AE\u09CD\u09AC\u09BE\u09B0\u09C7 94562455 \u09AB\u09CB\u09A8 \u0995\u09B0\u09C1\u09A8")))));
	    //}
	  };
	
	  this.getHCommCard = function () {
	    var _ref10;
	
	    return _react2.default.createElement("div", {
	      style: (_ref10 = {
	        textAlign: "center",
	        maxWidth: "600px",
	        minHeight: "200px",
	        margin: "auto",
	        borderRadius: "10px",
	        border: "1px solid #E0E6E8",
	        boxSizing: "border-box",
	        boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)"
	      }, _defineProperty(_ref10, "margin", "5px"), _defineProperty(_ref10, "overflow", "hidden"), _defineProperty(_ref10, "position", "relative"), _defineProperty(_ref10, "marginBottom", "20px"), _defineProperty(_ref10, "display", "flex"), _defineProperty(_ref10, "backgroundImage", "url(" + _hcommImage.hcommImage + ")"), _defineProperty(_ref10, "backgroundSize", "cover"), _ref10),
	      onClick: function onClick() {
	        _this3.setScroll(true);
	        _this3.stateChangeHandler("hCommService", "stage", false);
	      }
	    }, _react2.default.createElement("div", {
	      style: {
	        margin: "auto",
	        textAlign: "center",
	        width: "100%",
	        bottom: "0"
	      }
	    }, _react2.default.createElement("div", {
	      style: {
	        width: "45px",
	        height: "45px",
	        position: "absolute",
	        top: "0",
	        right: "0",
	        backgroundColor: "rgb(30, 101, 144)",
	        borderRadius: "60px",
	        margin: "5px",
	        padding: "0px",
	        display: "flex",
	        justifyContent: "center",
	        alignItems: "center",
	        border: "1.4px solid white"
	      }
	    }, _react2.default.createElement("span", {
	      className: "blink",
	      style: {
	        color: "white",
	        fontSize: "12px",
	        lineHeight: "12px",
	        WebkitTextStroke: "1px white"
	      }
	    }, "ENTER")), _react2.default.createElement("div", {
	      style: {
	        textAlign: "center",
	        margin: "auto",
	        marginTop: "5px",
	        color: "white"
	      }
	    }, _react2.default.createElement("div", {
	      style: {
	        marginBottom: "-5px"
	      }
	    }, _react2.default.createElement("span", {
	      style: {
	        fontSize: "26px",
	        fontWeight: "bold",
	        textTransform: "uppercase",
	        textShadow: "-1px -1px 0 #000,  1px -1px 0 #000,-1px  1px 0 #000,1px  1px 0 #000"
	      }
	    }, "BANGLADESH HIGH COMMISSION")), _react2.default.createElement("div", {
	      style: {
	        color: "white",
	        fontSize: "18px",
	        textShadow: "-1px -1px 0 #000,  1px -1px 0 #000,-1px  1px 0 #000,1px  1px 0 #000"
	      }
	    }, _react2.default.createElement("span", null, "View & Update Applications")))));
	    //}
	  };
	
	  this.getSupplierTile = function (user) {
	    return _react2.default.createElement("div", {
	      style: {
	        textAlign: "center",
	        width: "100%",
	        marginTop: "15px",
	        marginBottom: "20px"
	      }
	    }, _react2.default.createElement("div", {
	      style: {
	        textAlign: "center",
	        padding: "5px",
	        maxWidth: "600px",
	        margin: "auto",
	        borderRadius: "10px",
	        backgroundColor: "white",
	        border: "1px solid #E0E6E8",
	        boxSizing: "border-box",
	        boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)"
	      }
	    }, _react2.default.createElement("div", {
	      style: {
	        marginLeft: "5px",
	        marginRight: "5px",
	        textAlign: "left"
	      }
	    }, _react2.default.createElement("h2", {
	      style: {
	        marginTop: "5px",
	        fontSize: "22px",
	        fontWeight: "bold",
	        textTransform: "uppercase"
	      }
	    }, user.userCompany), _react2.default.createElement("div", {
	      style: {
	        marginBottom: "10px",
	        marginTop: "-5px"
	      }
	    }, _react2.default.createElement("div", null, _react2.default.createElement("span", {
	      style: {
	        margin: "3px"
	      }
	    }, _react2.default.createElement("icon", { "class": "fa fa-user" })), _react2.default.createElement("span", null, " ", user.userName)), _react2.default.createElement("div", null, _react2.default.createElement("span", {
	      style: {
	        margin: "3px"
	      }
	    }, _react2.default.createElement("icon", { "class": "fa fa-phone" })), _react2.default.createElement("span", null, " ", user.userMobile))), _react2.default.createElement("div", {
	      style: {
	        marginBottom: "10px",
	        marginTop: "-5px"
	      }
	    }, user.compIntoText)), _react2.default.createElement("div", null, _react2.default.createElement("div", null, _react2.default.createElement("div", {
	      style: {
	        padding: "0.6em 2em",
	        borderRadius: "8px",
	        color: "#fff",
	        backgroundColor: "rgb(30, 101, 144)",
	        fontSize: "1.1em",
	        border: "0px",
	        cursor: "pointer",
	        margin: "1em",
	        fontWeight: "bold"
	      },
	      onClick: function onClick() {
	        _this3.stateChangeHandler("shopFromASupplier", "stage", false);
	        _this3.stateChangeHandler(user.userCompany, "selectedSupplier", false);
	        _this3.stateChangeHandler("supplierShopItems", "tableName", false);
	        _this3.stateChangeHandler(true, "enterAsWorker", false);
	        _this3.setScroll(true);
	      }
	    }, "CHECK OUT THIS SHOP")))));
	  };
	
	  this.getPromoPageList = function () {
	    var allActors = _this3.props.users;
	    if (allActors && allActors.length > 0) {
	      var data = allActors.filter(function (actor) {
	        return actor.recordType === "STORE USER" || actor.recordType === "PROMOTIONAL";
	      });
	      var tgtActors = _.chain(data).sortBy("sortOrder").value();
	      return tgtActors.map(function (actor) {
	        if (actor.recordType === "PROMOTIONAL") {
	          return _this3.getMediaEntry(actor);
	        }
	      });
	    }
	  };
	
	  this.getPublicNotice = function () {
	    var _ref11, _ref12, _ref13;
	
	    return _react2.default.createElement("div", {
	      style: (_ref11 = {
	        textAlign: "center",
	        minHeight: "200px",
	        height: "215px",
	        margin: "auto",
	        borderRadius: "10px",
	        border: "1px solid #E0E6E8",
	        boxSizing: "border-box",
	        boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)"
	      }, _defineProperty(_ref11, "margin", "5px"), _defineProperty(_ref11, "overflow", "hidden"), _defineProperty(_ref11, "position", "relative"), _defineProperty(_ref11, "marginBottom", "20px"), _defineProperty(_ref11, "backgroundColor", "white"), _defineProperty(_ref11, "padding", "5px"), _ref11)
	    }, _react2.default.createElement("div", {
	      style: {
	        padding: "1px",
	        textAlign: "right",
	        border: "1px solid gainsboro",
	        borderRadius: _reactDeviceDetect.isMobile ? "5px" : "0px",
	        backgroundColor: "white",
	        zIndex: "-9"
	      }
	    }, _react2.default.createElement(_reactackle.TextField, {
	      value: _this3.state["notifyText"],
	      onChange: function onChange(e) {
	        _this3.stateChangeHandler(e.value, "notifyText", false);
	      },
	      fullWidth: true,
	      placeholder: "ENTER NOTIFICATION TEXT",
	      multiline: true,
	      multilineRows: { min: 7 }
	    })), _react2.default.createElement("div", {
	      style: {
	        textAlign: "center",
	        display: "flex",
	        flexDirection: "row",
	        alignItems: "center",
	        justifyContent: "center"
	      }
	    }, _react2.default.createElement("div", {
	      style: (_ref12 = {
	        color: "#333",
	        fontSize: "14px",
	        backgroundColor: "rgb(30, 101, 144)",
	        padding: "5px",
	        borderRadius: "5px"
	      }, _defineProperty(_ref12, "color", "white"), _defineProperty(_ref12, "width", "30%"), _defineProperty(_ref12, "margin", "5px"), _defineProperty(_ref12, "textAlign", "center"), _ref12)
	    }, _react2.default.createElement("div", {
	      onClick: function onClick() {
	        _this3.stateChangeHandler("", "notifyText", false);
	      }
	    }, "CLEAR")), _react2.default.createElement("div", {
	      style: (_ref13 = {
	        color: "#333",
	        fontSize: "14px",
	        backgroundColor: "red",
	        padding: "5px",
	        borderRadius: "5px"
	      }, _defineProperty(_ref13, "color", "white"), _defineProperty(_ref13, "width", "30%"), _defineProperty(_ref13, "margin", "5px"), _defineProperty(_ref13, "textAlign", "center"), _ref13)
	    }, _react2.default.createElement("div", {
	      onClick: function onClick() {
	        var resConfirm = confirm("Please confirm if you would like send this text as notifications to all users?\n \n \n " + _this3.state.notifyText);
	
	        if (resConfirm) {
	          _this3.props.onNotifyUsers(_this3.state.notifyText, [], true);
	        }
	      }
	    }, "NOTIFY USERS"))));
	  };
	
	  this.getHomePage = function () {
	    //console.log("getting home page");
	    if (_this3.state.isSignedIn && _this3.state.stage === "homepage") {
	      if (_this3.state.testing) {
	        return _react2.default.createElement("div", null, _react2.default.createElement("div", null, _react2.default.createElement(_RemitService2.default, {
	          firebase: _this3.props.firebase,
	          myRemitRegs: _this3.props.db["myRemitRegs"],
	          myRemitApps: _this3.props.db["myRemitApps"],
	          onSendEmail: _this3.props.onSendEmail,
	          onNotifyUsers: _this3.props.onNotifyUsers,
	          cellPhone: _this3.props.cellPhone,
	          setScroll: _this3.setScroll
	        })));
	      } else {
	        var _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21;
	
	        return _react2.default.createElement("div", {
	          style: _defineProperty({
	            marginTop: "5px",
	            marginBottom: "10px",
	            textAlign: "left"
	          }, "marginTop", "60px")
	        }, _react2.default.createElement("div", {
	          style: {
	            marginTop: "30px",
	            textAlign: "center",
	            overflowY: scroll,
	            WebkitOverflowScrolling: "touch"
	          }
	        }, _this3.getPromoPageList(), _this3.getPassportCard(), _this3.props.cellPhone === "+6594562455" && _this3.getPrimeCard(), _this3.props.cellPhone === "+6594562455" && _this3.getHCommCard(), _react2.default.createElement("div", {
	          style: (_ref15 = {
	            textAlign: "center",
	            minHeight: "200px",
	            height: "215px",
	            margin: "auto",
	            borderRadius: "10px",
	            border: "1px solid #E0E6E8",
	            boxSizing: "border-box",
	            boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)"
	          }, _defineProperty(_ref15, "margin", "5px"), _defineProperty(_ref15, "overflow", "hidden"), _defineProperty(_ref15, "position", "relative"), _defineProperty(_ref15, "marginBottom", "20px"), _ref15)
	        }, _react2.default.createElement(_reactYoutube2.default, {
	          videoId: "4CaMWXB3o2Y",
	          opts: {
	            height: "215px",
	            width: "100%",
	            playerVars: {
	              // https://developers.google.com/youtube/player_parameters
	              autoPlay: 0,
	              controls: 1,
	              loop: 1,
	              modestbranding: 1,
	              rel: 0,
	              showinfo: 0
	            }
	          },
	          onReady: _this3._onReady
	        })), _react2.default.createElement("div", {
	          style: (_ref16 = {
	            textAlign: "center",
	            minHeight: "200px",
	            height: "215px",
	            margin: "auto",
	            borderRadius: "10px",
	            border: "1px solid #E0E6E8",
	            boxSizing: "border-box",
	            boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)"
	          }, _defineProperty(_ref16, "margin", "5px"), _defineProperty(_ref16, "overflow", "hidden"), _defineProperty(_ref16, "position", "relative"), _defineProperty(_ref16, "marginBottom", "20px"), _ref16)
	        }, _react2.default.createElement(_reactYoutube2.default, {
	          videoId: "fYHkNEd7RQo",
	          opts: {
	            height: "215px",
	            width: "100%",
	            playerVars: {
	              // https://developers.google.com/youtube/player_parameters
	              autoPlay: 0,
	              controls: 1,
	              loop: 1,
	              modestbranding: 1,
	              rel: 0,
	              showinfo: 0
	            }
	          },
	          onReady: _this3._onReady
	        })), _react2.default.createElement("div", {
	          style: (_ref17 = {
	            textAlign: "center",
	            minHeight: "200px",
	            height: "215px",
	            margin: "auto",
	            borderRadius: "10px",
	            border: "1px solid #E0E6E8",
	            boxSizing: "border-box",
	            boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)"
	          }, _defineProperty(_ref17, "margin", "5px"), _defineProperty(_ref17, "overflow", "hidden"), _defineProperty(_ref17, "position", "relative"), _defineProperty(_ref17, "marginBottom", "20px"), _ref17)
	        }, _react2.default.createElement(_reactYoutube2.default, {
	          videoId: "zch9yd3bHi0",
	          opts: {
	            height: "215px",
	            width: "100%",
	            playerVars: {
	              // https://developers.google.com/youtube/player_parameters
	              autoPlay: 0,
	              controls: 1,
	              loop: 1,
	              modestbranding: 1,
	              rel: 0,
	              showinfo: 0
	            }
	          },
	          onReady: _this3._onReady
	        })), _react2.default.createElement("div", {
	          style: (_ref18 = {
	            textAlign: "center",
	            minHeight: "200px",
	            height: "215px",
	            margin: "auto",
	            borderRadius: "10px",
	            border: "1px solid #E0E6E8",
	            boxSizing: "border-box",
	            boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)"
	          }, _defineProperty(_ref18, "margin", "5px"), _defineProperty(_ref18, "overflow", "hidden"), _defineProperty(_ref18, "position", "relative"), _defineProperty(_ref18, "marginBottom", "20px"), _ref18)
	        }, _react2.default.createElement(_reactYoutube2.default, {
	          videoId: "AtXTsVHLTSU",
	          opts: {
	            height: "215px",
	            width: "100%",
	            playerVars: {
	              // https://developers.google.com/youtube/player_parameters
	              autoPlay: 0,
	              controls: 1,
	              loop: 1,
	              modestbranding: 1,
	              rel: 0,
	              showinfo: 0
	            }
	          },
	          onReady: _this3._onReady
	        })), _react2.default.createElement("div", {
	          style: (_ref19 = {
	            textAlign: "center",
	            minHeight: "200px",
	            height: "215px",
	            margin: "auto",
	            borderRadius: "10px",
	            border: "1px solid #E0E6E8",
	            boxSizing: "border-box",
	            boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)"
	          }, _defineProperty(_ref19, "margin", "5px"), _defineProperty(_ref19, "overflow", "hidden"), _defineProperty(_ref19, "position", "relative"), _defineProperty(_ref19, "marginBottom", "20px"), _ref19)
	        }, _react2.default.createElement(_reactYoutube2.default, {
	          videoId: "kL2JVvNxMVk",
	          opts: {
	            height: "215px",
	            width: "100%",
	            playerVars: {
	              // https://developers.google.com/youtube/player_parameters
	              autoPlay: 0,
	              controls: 1,
	              loop: 1,
	              modestbranding: 1,
	              rel: 0,
	              showinfo: 0
	            }
	          },
	          onReady: _this3._onReady
	        })), _react2.default.createElement("div", {
	          style: (_ref20 = {
	            textAlign: "center",
	            minHeight: "200px",
	            height: "215px",
	            margin: "auto",
	            borderRadius: "10px",
	            border: "1px solid #E0E6E8",
	            boxSizing: "border-box",
	            boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)"
	          }, _defineProperty(_ref20, "margin", "5px"), _defineProperty(_ref20, "overflow", "hidden"), _defineProperty(_ref20, "position", "relative"), _defineProperty(_ref20, "marginBottom", "20px"), _ref20)
	        }, _react2.default.createElement(_reactYoutube2.default, {
	          videoId: "p4bksA3-YpM",
	          opts: {
	            height: "215px",
	            width: "100%",
	            playerVars: {
	              // https://developers.google.com/youtube/player_parameters
	              autoPlay: 0,
	              controls: 1,
	              loop: 1,
	              modestbranding: 1,
	              rel: 0,
	              showinfo: 0
	            }
	          },
	          onReady: _this3._onReady
	        })), _this3.props.cellPhone === "+6594562455" && _this3.getPublicNotice(), _react2.default.createElement("div", {
	          style: {
	            margin: "5px",
	            border: "1px solid #ceb5b5",
	            overflow: "hidden",
	            borderRadius: "10px",
	            boxSizing: "border-box",
	            boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)"
	          }
	        }, _react2.default.createElement("div", {
	          style: (_ref21 = {
	            height: "45px",
	            marginBottom: "5px",
	            color: "black",
	            lineHeight: "45px",
	            borderBottom: "1px solid #ceb5b5"
	          }, _defineProperty(_ref21, "marginBottom", "12px"), _defineProperty(_ref21, "fontSize", "14px"), _ref21)
	        }, "YOUR PREVIOUS ORDERS"), _react2.default.createElement("div", {
	          style: {
	            textAlign: "left"
	          }
	        }, _react2.default.createElement(_WorkerGrid2.default, {
	          data: _this3.getData("deliveryRequest"),
	          tableName: "deliveryRequest",
	          tableDef: _this3.state.tableDefs["deliveryRequest"],
	          handleEdit: _this3.handleOrderEdit,
	          handleDelete: _this3.handleDelete,
	          backToList: _this3.backToList,
	          dataIsLoaded: _this3.props.ui["deliveryRequest" + "-downloaded"],
	          role: "worker",
	          phoneNumber: _this3.props.firebase.auth.currentUser.phoneNumber,
	          firebase: _this3.props.firebase,
	          updateRecord: _this3.props.onUpdateRecord,
	          onNotifyUsers: _this3.props.onNotifyUsers,
	          allSuppliers: _this3.getAllSuppliers(),
	          stage: _this3.state.stage,
	          repeatOrder: _this3.repeatOrder
	        }))), _this3.props.currUserRole !== "SUPERADMIN" && _react2.default.createElement("div", null, _react2.default.createElement("div", {
	          style: {
	            textAlign: "center",
	            padding: "5px",
	            maxWidth: "600px",
	            marginTop: "15px",
	            borderRadius: "10px",
	            backgroundColor: "white",
	            border: "1px solid #E0E6E8",
	            boxSizing: "border-box",
	            boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)"
	          }
	        }, _react2.default.createElement("div", {
	          style: {
	            marginLeft: "5px",
	            marginRight: "5px",
	            textAlign: "left"
	          }
	        }, _react2.default.createElement("div", { style: { textAlign: "left" } }, (0, _termsMainPage2.default)()))), _react2.default.createElement("div", {
	          style: {
	            margin: "20px",
	            textAlign: "center",
	            fontSize: "10px"
	          }
	        }, "v1.0.18"), (_this3.props.cellPhone === "+6594562455" || _this3.props.cellPhone === "+6597861234" || _this3.props.cellPhone === "+6594562456") && _react2.default.createElement("div", {
	          onClick: function onClick() {
	            window.confirm("Are you sure you want to refactor products?") && _this3.updatePopular();
	          },
	          style: {
	            height: "45px",
	            margin: "5px",
	            color: "white",
	            backgroundColor: "black",
	            lineHeight: "45px"
	          }
	        }, "Update Popular Prodcuts"), (_this3.props.cellPhone === "+6594562455" || _this3.props.cellPhone === "+6597861234" || _this3.props.cellPhone === "+6594562456") && _react2.default.createElement("div", {
	          onClick: function onClick() {
	            window.confirm("Are you sure you want to refactor products?") && _this3.getAllProductsArray();
	          },
	          style: {
	            height: "45px",
	            margin: "5px",
	            color: "white",
	            backgroundColor: "black",
	            lineHeight: "45px"
	          }
	        }, "Generate all products array"), (_this3.props.cellPhone === "+6594562455" || _this3.props.cellPhone === "+6597861234" || _this3.props.cellPhone === "+6594562456") && _react2.default.createElement("div", {
	          onClick: function onClick() {
	            window.confirm("Are you sure you want to update customer Orders?") && _this3.generateMyOrders();
	          },
	          style: {
	            height: "45px",
	            margin: "5px",
	            color: "white",
	            backgroundColor: "black",
	            lineHeight: "45px"
	          }
	        }, "Updated Customer Orders"))));
	      }
	    }
	  };
	
	  this.getAllProductsArray = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
	    var strTokDets, objTokDets, accessToken;
	    return regeneratorRuntime.wrap(function _callee3$(_context3) {
	      while (1) {
	        switch (_context3.prev = _context3.next) {
	          case 0:
	            strTokDets = JSON.stringify(_this3.props.firebase.auth.currentUser);
	            objTokDets = JSON.parse(strTokDets);
	            accessToken = objTokDets.stsTokenManager.accessToken;
	            _context3.next = 5;
	            return _this3.props.onInitialProductsFetch(_this3.props.firebase.dbUrl + "/supplierShopItems.json", accessToken);
	
	          case 5:
	          case "end":
	            return _context3.stop();
	        }
	      }
	    }, _callee3, _this3);
	  }));
	
	  this.getTotal = function (currBucket) {
	    //console.log("calcing total again: " + JSON.stringify(currBucket));
	    if (currBucket && currBucket.length > 0 && currBucket !== "" && (typeof currBucket === "undefined" ? "undefined" : _typeof(currBucket)) === "object") {
	      try {
	        var totAmt = currBucket.reduce(function (sum, item) {
	          sum = sum + parseFloat(item.amount.replace(/,/g, ""));
	          return parseFloat(sum);
	        }, 0);
	
	        return totAmt.toFixed(2);
	      } catch (err) {
	        return 0;
	      }
	    }
	  };
	
	  this.sleep = function () {
	    var _ref23 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(milliseconds) {
	      var date, currentDate;
	      return regeneratorRuntime.wrap(function _callee4$(_context4) {
	        while (1) {
	          switch (_context4.prev = _context4.next) {
	            case 0:
	              date = Date.now();
	              currentDate = null;
	
	              do {
	                currentDate = Date.now();
	              } while (currentDate - date < milliseconds);
	
	            case 3:
	            case "end":
	              return _context4.stop();
	          }
	        }
	      }, _callee4, _this3);
	    }));
	
	    return function (_x3) {
	      return _ref23.apply(this, arguments);
	    };
	  }();
	
	  this.generateMyOrders = function () {
	    var currOrders = _this3.props.db["deliveryRequest"];
	    var groupedOrders = _.chain(currOrders).groupBy("mobile").value();
	    console.log(JSON.stringify(groupedOrders));
	    _this3.props.firebase.db.ref("/myOrders").once("value").then(function (snap) {
	      return snap.ref.set(groupedOrders);
	    }).catch(function (err) {
	      console.log("some error: " + err);
	    }).then(function (err) {
	      //console.log("Updated Rec: " + databucket[idField]);
	    });
	  };
	
	  this.dataUpdateHandler = function () {
	    var _ref24 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(databucket, cloudPath) {
	      var ordTotal;
	      return regeneratorRuntime.wrap(function _callee5$(_context5) {
	        while (1) {
	          switch (_context5.prev = _context5.next) {
	            case 0:
	              if (databucket && databucket.key && databucket.key !== "") {
	                ordTotal = _this3.getTotal(databucket.requestedItems);
	
	                console.log(ordTotal);
	                databucket["orderTotal"] = ordTotal;
	                _this3.props.firebase.db.ref("/" + cloudPath + "/" + databucket.key + "/").once("value").then(function (snap) {
	                  return snap.ref.set(databucket);
	                }).catch(function (err) {
	                  console.log("some error: " + err);
	                }).then(function (err) {
	                  //console.log("Updated Rec: " + databucket[idField]);
	                });
	              }
	
	            //this.props.handleEditCancel();
	
	            case 1:
	            case "end":
	              return _context5.stop();
	          }
	        }
	      }, _callee5, _this3);
	    }));
	
	    return function (_x4, _x5) {
	      return _ref24.apply(this, arguments);
	    };
	  }();
	
	  this.productsUpdateHandler = function () {
	    var _ref25 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(databucket, categoryKey) {
	      return regeneratorRuntime.wrap(function _callee6$(_context6) {
	        while (1) {
	          switch (_context6.prev = _context6.next) {
	            case 0:
	              _this3.props.firebase.db.ref("/" + categoryKey + "/").once("value").then(function (snap) {
	                return snap.ref.set(databucket);
	              }).catch(function (err) {
	                console.log("some error: " + err);
	              }).then(function (err) {
	                console.log("Updated Rec: " + key);
	              });
	
	            //this.props.handleEditCancel();
	
	            case 1:
	            case "end":
	              return _context6.stop();
	          }
	        }
	      }, _callee6, _this3);
	    }));
	
	    return function (_x6, _x7) {
	      return _ref25.apply(this, arguments);
	    };
	  }();
	
	  this.handleDelete = function (key, path) {
	    _this3.props.firebase.db.ref("/" + path + "/" + key).remove();
	  };
	
	  this.archiveOrders = function () {
	    var _ref26 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(allOrders) {
	      var freqProds;
	      return regeneratorRuntime.wrap(function _callee7$(_context7) {
	        while (1) {
	          switch (_context7.prev = _context7.next) {
	            case 0:
	              // alert("Current Orders: " + allOrders.length);
	              freqProds = _this3.getFrequentlyOrder();
	              //console.log(JSON.stringify(freqProds));
	
	              alert("done");
	            //let cuttOffDate = moment().subtract(30, "day");
	            // for (let i = 0; i < allOrders.length; i++) {
	            //   await this.dataUpdateHandler(allOrders[i], "deliveryRequest");
	            //   await this.sleep(500);
	            // }
	
	            case 2:
	            case "end":
	              return _context7.stop();
	          }
	        }
	      }, _callee7, _this3);
	    }));
	
	    return function (_x8) {
	      return _ref26.apply(this, arguments);
	    };
	  }();
	
	  this.updatePopular = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
	    var freqProds;
	    return regeneratorRuntime.wrap(function _callee8$(_context8) {
	      while (1) {
	        switch (_context8.prev = _context8.next) {
	          case 0:
	            freqProds = _this3.getFrequentlyOrder();
	            //await this.productsUpdateHandler(freqProds, "POPULAR");
	
	            alert("Done");
	
	          case 2:
	          case "end":
	            return _context8.stop();
	        }
	      }
	    }, _callee8, _this3);
	  }));
	
	  this.repeatOrder = function (rec) {
	    //console.log("ok baba " + JSON.stringify(rec));
	    _this3.props.onAddArray({ path: "bucket", payload: rec.requestedItems });
	    _this3.setScroll(true);
	    _this3.stateChangeHandler("directOrderpad", "stage", false);
	    _this3.stateChangeHandler("supplierShopItems", "tableName", false);
	    _this3.stateChangeHandler(false, "showGrid", false);
	  };
	
	  this.genNotification = function (payload, actionType) {
	    console.log(window.location.hostname);
	    if (_this3.state.tableName === "openBazar") {
	      if (payload && payload.message && payload.message !== "") {
	        var notifyText = "BCS Open Bazar(" + payload.name + " says): " + payload.message;
	        _this3.props.onNotifyUsers(notifyText, [], true);
	      }
	    }
	
	    if (_this3.state.tableName === "deliveryRequest") {
	      console.log("this is orders");
	    }
	    if (_this3.state.tableName === "supplierShopItems") {
	      console.log("this is my shop");
	    }
	  };
	
	  this.getSignedInAs = function () {
	    if (_this3.props.firebase.auth && _this3.props.firebase.auth.currentUser && _this3.props.firebase.auth.currentUser.phoneNumber && _this3.state.stage === "homepage") {
	      return _react2.default.createElement("div", {
	        style: {
	          marginLeft: "20px",
	          marginTop: "10px",
	          width: "200px"
	        }
	      }, "Signed in as ", _this3.props.firebase.auth.currentUser.phoneNumber);
	    }
	    if (_this3.props.firebase.auth && _this3.props.firebase.auth.currentUser && _this3.props.firebase.auth.currentUser.phoneNumber && (_this3.state.stage === "passportService" || _this3.state.stage === "hCommService")) {
	      return _react2.default.createElement("div", {
	        style: {
	          marginLeft: "20px",
	          marginTop: "10px",
	          width: "200px"
	        }
	      }, "BCS Passport Svc (BGD)");
	    }
	    if (_this3.props.firebase.auth && _this3.props.firebase.auth.currentUser && _this3.props.firebase.auth.currentUser.phoneNumber && (_this3.state.stage === "remitService" || _this3.state.stage === "agraniService" || _this3.state.stage === "primeService")) {
	      return _react2.default.createElement("div", {
	        style: {
	          marginLeft: "20px",
	          marginTop: "10px",
	          width: "200px"
	        }
	      }, "BCS Remittance Svc (BDT)");
	    }
	  };
	
	  this.getTopNav = function () {
	    var _ref28;
	
	    return _react2.default.createElement("div", {
	      style: (_ref28 = {
	        height: "45px",
	        border: "0px solid black",
	        margin: "auto",
	        display: "flex",
	        flexDirection: "row",
	        justifyContent: "space-between",
	        position: "fixed",
	        top: "0",
	        width: "100%",
	        maxWidth: "600px",
	        zIndex: "25"
	      }, _defineProperty(_ref28, "margin", "0px"), _defineProperty(_ref28, "backgroundColor", "#ebebed"), _defineProperty(_ref28, "paddingTop", "5px"), _defineProperty(_ref28, "boxSizing", _this3.state.stage !== "login" && _this3.state.stage !== "shopFromASupplier" ? "border-box" : null), _defineProperty(_ref28, "boxShadow", _this3.state.stage !== "login" && _this3.state.stage !== "shopFromASupplier" ? "0px 4px 4px rgba(0, 0, 0, 0.25)" : null), _ref28)
	    }, _react2.default.createElement("div", {
	      style: {
	        border: "0px solid red",
	        width: "80%"
	      }
	    }, _this3.getViewOrdersButton(), _this3.getAddMoreItemsButton(), _this3.getNewOrderButton(), _this3.getSearchBar(), _this3.getSignedInAs()), _react2.default.createElement("div", {
	      style: {
	        border: "0px solid green",
	        width: "150px",
	        display: "flex",
	        flexDirection: "row",
	        justifyContent: "flex-end"
	      }
	    }, _this3.getHomeButton(), _this3.getSupplierButton(), _this3.getCloseButton(), _this3.getAddPostPlusButton(), _this3.getAddButton(), _this3.getMenuButton()));
	  };
	
	  this.getRemitAdmins = function () {
	    if (_this3.props.currUserRole !== "SUPERADMIN" && _this3.state.stage === "agraniService") {
	      return _react2.default.createElement("div", null, (_this3.props.cellPhone === "+6594562455" || _this3.props.cellPhone === "+6597861234" || _this3.props.cellPhone === "+6594562456") && _react2.default.createElement(_AgraniService2.default, {
	        cellPhone: _this3.props.cellPhone,
	        firebase: _this3.props.firebase,
	        cancelHandler: function cancelHandler() {
	          _this3.setScroll(true);
	          _this3.stateChangeHandler({}, "searchFilters", false);
	          _this3.stateChangeHandler("homepage", "stage", false);
	          _this3.stateChangeHandler("users", "tableName", false);
	          _this3.stateChangeHandler(true, "showGrid", false);
	        },
	        myRemitRegs: _this3.props.db["agraniRegs"],
	        myRemitApps: _this3.props.db["agraniApps"],
	        selectedExchange: "agrani",
	        setScroll: _this3.setScroll,
	        onSendEmail: _this3.props.onSendEmail,
	        onNotifyUsers: _this3.props.onNotifyUsers
	      }));
	    }
	    if (_this3.props.currUserRole !== "SUPERADMIN" && _this3.state.stage === "primeService") {
	      var appVersion = window.document.getElementById("appVersion");
	      if (appVersion && appVersion !== undefined) {
	        console.log(appVersion.value);
	        return _react2.default.createElement("div", null, _react2.default.createElement(_PrimeExchService2.default, { appVersion: appVersion.value }));
	      }
	    }
	  };
	
	  this.getMainContent = function () {
	    var _ref29;
	
	    return _react2.default.createElement("div", {
	      style: {
	        maxWidth: "600px",
	        margin: "auto"
	      }
	    }, _this3.getTopNav(), _this3.getMenuDiv(), _this3.getOverLay(), !_this3.state.isSignedIn && _this3.state.stage === "login" && _this3.getLoginPage(), _this3.getHomePage(), _this3.state.showGrid && _react2.default.createElement("div", {
	      style: {
	        marginTop: "60px",
	        padding: "5px"
	      }
	    }, _this3.getGrid()), _react2.default.createElement("div", {
	      style: {
	        marginTop: _this3.state.currUserRole === "SUPERADMIN" ? "60px" : "0px"
	      }
	    }, _this3.state.currUserRole === "SUPERADMIN" && _this3.state.showGrid && _this3.getAdminGrid(), _this3.props.currUserRole === "SUPERADMIN" && !_this3.state.showGrid && _react2.default.createElement("div", {
	      style: {
	        paddingLeft: "5px",
	        paddingRight: "5px"
	      }
	    }, _react2.default.createElement(_SingleRecord2.default, {
	      path: _this3.state.tableName,
	      handleEditCancel: function handleEditCancel() {
	        _this3.backToList("superadmin", _this3.state.tableName);
	        _this3.stateChangeHandler(true, "showGrid");
	      },
	      handleDelete: _this3.handleDelete,
	      ogTableDef: (0, _extendedOgDef2.default)(_this3.props.createTable),
	      genNotification: _this3.genNotification,
	      cellPhone: _this3.state.refPhoneNumber
	    }))), _this3.props.currUserRole !== "SUPERADMIN" && _this3.state.stage === "shopFromASupplier" && _react2.default.createElement("div", null, _react2.default.createElement("div", {
	      style: (_ref29 = {
	        position: "fixed",
	        top: "0px",
	        backgroundColor: "#ebebed",
	        borderTop: "1px solid white",
	        margin: "0px",
	        padding: "2px",
	        height: "90px",
	        zIndex: "5",
	        width: "100%",
	        display: "flex",
	        alignItems: "flex-end"
	      }, _defineProperty(_ref29, "padding", "2px"), _defineProperty(_ref29, "overflowX", "scroll"), _defineProperty(_ref29, "flexDirection", "row"), _defineProperty(_ref29, "maxWidth", "600px"), _defineProperty(_ref29, "boxSizing", "border-box"), _defineProperty(_ref29, "boxShadow", "rgba(0,0,0,0.25) 0px 4px 4px"), _ref29)
	    }, _this3.getCategTabs()), _react2.default.createElement(_BuyFromShopGrid2.default, {
	      db: _this3.props.db,
	      tableName: _this3.state.tableName,
	      tableDef: _this3.state.tableDefs[_this3.state.tableName],
	      handleEdit: _this3.handleEdit,
	      handleDelete: _this3.handleDelete,
	      genDirectSupplierOrder: _this3.genDirectSupplierOrder,
	      addToBucket: _this3.addToBucket,
	      removeFromBucket: _this3.removeFromBucket,
	      getBucketDetails: _this3.getBucketDetails,
	      supplierName: _this3.state.selectedSupplier,
	      supplierRole: _this3.props.userProfile && _this3.props.userProfile["roleName"] ? _this3.props.userProfile["roleName"] : "",
	      searchVal: _this3.state.searchVal,
	      role: "all",
	      searchFilters: _this3.state.searchFilters
	      //myProductsKeys={this.getPrevOrderProds()}
	      , loadPrevOrders: _this3.getPrevOrderProds,
	      dataIsLoaded: _this3.props.ui[_this3.state.tableName + "-downloaded"],
	      cellNumber: _this3.props.cellNumber
	    })), _this3.props.currUserRole !== "SUPERADMIN" && _this3.state.stage === "directOrderpad" && _react2.default.createElement(_OrderPadDirectSupplier2.default, {
	      path: "deliveryRequest",
	      backToList: _this3.backToList,
	      handleDelete: _this3.handleDelete,
	      ogTableDef: (0, _extendedOgDef2.default)(_this3.props.createTable),
	      genNotification: _this3.genNotification,
	      cellPhone: _this3.state.refPhoneNumber,
	      addToBucket: _this3.addToBucket,
	      removeFromBucket: _this3.removeFromBucket,
	      getBucketDetails: _this3.getBucketDetails,
	      prodDets: _this3.state.prodDets,
	      addMoreItems: function addMoreItems() {
	        //console.log("doing new order  ");
	        _this3.backToList("shopFromASupplier", "supplierShopItems", _this3.state.selectedSupplier);
	        _this3.stateChangeHandler(true, "showGrid", false);
	      }
	    }), _this3.props.currUserRole !== "SUPERADMIN" && _this3.state.stage === "hCommService" && (_this3.props.cellPhone === "+6594562455" || _this3.props.cellPhone === "+6597861234" || _this3.props.cellPhone === "+6594562456" || _this3.props.cellPhone === "+6590169379") && _react2.default.createElement("div", null, _react2.default.createElement(_HighComm2.default, {
	      applications: _this3.props.db["hCommApps"],
	      firebase: _this3.props.firebase,
	      onNotifyUsers: _this3.props.onNotifyUsers
	    })), _this3.props.currUserRole !== "SUPERADMIN" && _this3.state.stage === "remitServiceAdmin" && (_this3.props.cellPhone === "+6594562455" || _this3.props.cellPhone === "+6597861234" || _this3.props.cellPhone === "+6594562456") && _react2.default.createElement("div", null, "Money transfer Admin here"), _this3.props.currUserRole !== "SUPERADMIN" && _this3.state.stage === "passportService" && (_this3.props.cellPhone === "+6594562455" || _this3.props.cellPhone === "+6597861234" || _this3.props.cellPhone === "+6594562456" || _this3.props.cellPhone === "+6590618524") && _react2.default.createElement(_BgdPassportServiceExt2.default, {
	      cellPhone: _this3.props.cellPhone,
	      firebase: _this3.props.firebase,
	      cancelHandler: function cancelHandler() {
	        _this3.setScroll(true);
	        _this3.stateChangeHandler({}, "searchFilters", false);
	        _this3.stateChangeHandler("homepage", "stage", false);
	        _this3.stateChangeHandler("users", "tableName", false);
	        _this3.stateChangeHandler(true, "showGrid", false);
	      },
	      setScroll: _this3.setScroll
	    }), _this3.props.currUserRole !== "SUPERADMIN" && _this3.state.stage === "remitService" && (_this3.props.cellPhone === "+6594562455" || _this3.props.cellPhone === "+6597861234" || _this3.props.cellPhone === "+6594562456") && _react2.default.createElement(_RemitService2.default, {
	      cellPhone: _this3.props.cellPhone,
	      firebase: _this3.props.firebase,
	      cancelHandler: function cancelHandler() {
	        _this3.setScroll(true);
	        _this3.stateChangeHandler({}, "searchFilters", false);
	        _this3.stateChangeHandler("homepage", "stage", false);
	        _this3.stateChangeHandler("users", "tableName", false);
	        _this3.stateChangeHandler(true, "showGrid", false);
	      },
	      myRemitRegs: _this3.props.db["myRemitRegs"],
	      myRemitApps: _this3.props.db["myRemitApps"],
	      setScroll: _this3.setScroll,
	      onSendEmail: _this3.props.onSendEmail,
	      onNotifyUsers: _this3.props.onNotifyUsers,
	      onReachApi: _this3.props.onReachApi,
	      agraniRates: _this3.props.db["agraniRates"],
	      primeRates: _this3.props.db["primeRates"],
	      regsReady: _this3.props.ui["myRemitRegs-downloaded"],
	      onAddRecord: _this3.props.onAddRecord,
	      myRemitApplication: _this3.props.db["myRemitApplication"]
	    }), _this3.getRemitAdmins(), _this3.props.currUserRole !== "SUPERADMIN" && _this3.state.stage === "passportService" && !(_this3.props.cellPhone === "+6594562455" || _this3.props.cellPhone === "+6597861234" || _this3.props.cellPhone === "+6594562456" || _this3.props.cellPhone === "+6590618524") && _react2.default.createElement(_BgdPassportServiceExt2.default, {
	      cellPhone: _this3.props.cellPhone,
	      firebase: _this3.props.firebase,
	      cancelHandler: function cancelHandler() {
	        _this3.setScroll(true);
	        _this3.stateChangeHandler({}, "searchFilters", false);
	        _this3.stateChangeHandler("homepage", "stage", false);
	        _this3.stateChangeHandler("users", "tableName", false);
	        _this3.stateChangeHandler(true, "showGrid", false);
	      },
	      setScroll: _this3.setScroll
	    }), _this3.props.currUserRole !== "SUPERADMIN" && _this3.state.stage === "openBazar" && _react2.default.createElement("div", {
	      style: {
	        paddingLeft: "5px",
	        paddingRight: "5px"
	      }
	    }, _react2.default.createElement(_SingleRecord2.default, {
	      path: _this3.state.tableName,
	      handleEditCancel: function handleEditCancel() {
	        _this3.backToList("openBazarList", "openBazar");
	        _this3.stateChangeHandler(true, "showGrid");
	      },
	      handleDelete: function handleDelete(key, path, payload) {
	        _this3.handleDelete(key, path, payload);
	        _this3.backToList("openBazarList", "openBazar");
	        _this3.stateChangeHandler(true, "showGrid");
	      },
	      ogTableDef: (0, _extendedOgDef2.default)(_this3.props.createTable),
	      genNotification: _this3.genNotification,
	      cellPhone: _this3.state.refPhoneNumber
	    })), !_this3.state.showGrid && _this3.props.currUserRole === "STOREADMIN" && _this3.state.stage === "addToShop" && _react2.default.createElement(_SingleRecord2.default, {
	      path: _this3.state.tableName,
	      handleEditCancel: function handleEditCancel() {
	        _this3.backToList("addToShop", "supplierShopItems");
	        _this3.stateChangeHandler(true, "showGrid");
	      },
	      handleDelete: _this3.handleDelete,
	      ogTableDef: (0, _extendedOgDef2.default)(_this3.props.createTable),
	      genNotification: _this3.genNotification,
	      cellPhone: _this3.state.refPhoneNumber
	    }), !_this3.state.showGrid && _this3.props.currUserRole === "STOREADMIN" && _this3.state.stage === "storeAdminElse" && _react2.default.createElement(_SingleRecord2.default, {
	      path: _this3.state.tableName,
	      handleEditCancel: function handleEditCancel() {
	        _this3.backToList("storeAdminElse", _this3.state.tableName);
	        _this3.stateChangeHandler(true, "showGrid");
	      },
	      handleDelete: _this3.handleDelete,
	      ogTableDef: (0, _extendedOgDef2.default)(_this3.props.createTable),
	      genNotification: _this3.genNotification,
	      cellPhone: _this3.state.refPhoneNumber
	    }), _this3.state.stage === "shopFromASupplier" && _this3.getShopFromGridHeader());
	  };
	
	  this.removeFromBucket = function (product) {
	    var currBucket = _.cloneDeep(_this3.props.db["bucket"]);
	
	    if (currBucket && currBucket.length > 0) {
	      //update qty up if prod exists
	      var tgtProd = currBucket.find(function (stateProd) {
	        return stateProd.key === product.key;
	      });
	      if (tgtProd && tgtProd !== undefined) {
	        //console.log("bhaiya prod tow mil gaya");
	        if (tgtProd.quantity > 1) {
	          tgtProd.quantity = tgtProd.quantity - 1;
	          tgtProd.amount = (0, _numeral2.default)(tgtProd.quantity * tgtProd.productPrice).format("0,0.00");
	        } else {
	          //remove whole obj
	          currBucket = currBucket.filter(function (stateProd) {
	            return stateProd.key !== product.key;
	          });
	          //console.log(JSON.stringify(currBucket));
	        }
	
	        _this3.props.onAddArray({
	          path: "bucket",
	          payload: currBucket
	        });
	      }
	    }
	  };
	
	  this.getShopFromGridHeader = function () {
	    var currBucket = _.cloneDeep(_this3.props.db["bucket"]);
	
	    if (currBucket && currBucket.length > 0) {
	      var _ref30, _ref31;
	
	      var totAmt = currBucket.reduce(function (sum, item) {
	        sum = sum + parseFloat(item.amount.replace(/,/g, ""));
	        return parseFloat(sum);
	      }, 0);
	      return _react2.default.createElement("div", {
	        style: (_ref30 = {
	          textAlign: "center",
	          position: "fixed",
	          maxWidth: "600px",
	          bottom: "0px",
	          width: "100%",
	          margin: "auto"
	        }, _defineProperty(_ref30, "textAlign", "center"), _defineProperty(_ref30, "backgroundColor", "white"), _defineProperty(_ref30, "padding", "0px"), _defineProperty(_ref30, "display", "flex"), _defineProperty(_ref30, "border", "1px solid grey"), _defineProperty(_ref30, "boxSizing", "border-box"), _defineProperty(_ref30, "boxShadow", "0px 4px 4px rgba(0, 0, 0, 0.5)"), _defineProperty(_ref30, "zIndex", "5"), _ref30)
	      }, _react2.default.createElement("div", {
	        style: {
	          borderRadius: "5px",
	          color: "black",
	          backgroundColor: "white",
	          fontSize: "18px",
	          cursor: "pointer",
	          fontWeight: "bold",
	          width: "50%",
	          height: "40px",
	          textAlign: "center",
	          opacity: 1,
	
	          margin: "5px"
	        }
	      }, _react2.default.createElement("div", null, _react2.default.createElement("span", {
	        style: { fontSize: "10px", magin: "3px", marginLeft: "10px" }
	      }, "Total:"), " $", (0, _numeral2.default)(totAmt).format("0,0.00")), _react2.default.createElement("div", null, _react2.default.createElement("span", { style: { fontSize: "10px", margin: "3px" } }, "Items: "), " ", currBucket.length)), _react2.default.createElement("div", {
	        style: (_ref31 = {
	          padding: "0.6em 0.6em",
	          borderRadius: "8px",
	          color: "#fff",
	          backgroundColor: "rgb(30, 101, 144)",
	
	          fontSize: "1.1em",
	          border: "0px",
	          cursor: "pointer",
	          margin: "5px",
	          fontWeight: "bold"
	        }, _defineProperty(_ref31, "border", "1px solid white"), _defineProperty(_ref31, "width", "50%"), _ref31),
	        onClick: function onClick() {
	          _this3.setScroll(true);
	          _this3.stateChangeHandler("directOrderpad", "stage", false);
	          _this3.stateChangeHandler(false, "showGrid", false);
	        }
	      }, _react2.default.createElement("span", null, _react2.default.createElement("icon", {
	        className: "fa fa-shopping-bag",
	        style: { color: "white", margin: "5px" }
	      })), "VIEW BAG"));
	    }
	  };
	
	  this.getBucketDetails = function (product) {
	    var currBucket = _.cloneDeep(_this3.props.db["bucket"]);
	    if (currBucket && currBucket.length > 0) {
	      var tgtProd = currBucket.find(function (stateProd) {
	        return stateProd.key === product.key;
	      });
	      if (tgtProd && tgtProd !== undefined) {
	        return tgtProd;
	      }
	    }
	  };
	
	  this.addToBucket = function (product) {
	    //console.log("Adding " + JSON.stringify(product));
	    var bucketObj = _extends({}, product, { quantity: 1 });
	    bucketObj.amount = (0, _numeral2.default)(bucketObj.productPrice * bucketObj.quantity).format("0,0.00");
	    var currBucket = _.cloneDeep(_this3.props.db["bucket"]);
	
	    if (currBucket && currBucket.length > 0) {
	      //update qty up if prod exists
	      var tgtProd = currBucket.find(function (stateProd) {
	        return stateProd.key === bucketObj.key;
	      });
	      if (tgtProd && tgtProd !== undefined) {
	        //console.log("bhaiya prod tow mil gaya");
	        tgtProd.quantity = tgtProd.quantity + 1;
	        tgtProd.amount = (0, _numeral2.default)(tgtProd.quantity * tgtProd.productPrice).format("0,0.00");
	      } else {
	        currBucket.push(bucketObj);
	      }
	      _this3.props.onAddArray({
	        path: "bucket",
	        payload: currBucket
	      });
	    } else {
	      _this3.props.onAddArray({
	        path: "bucket",
	        payload: [bucketObj]
	      });
	    }
	  };
	
	  this.handleEdit = function (key, path, fullPayload) {
	    window.document.querySelector("#oDiv").scroll(0, 0);
	    _this3.props.onSelectRecord({ path: path, key: key });
	    _this3.stateChangeHandler(false, "showGrid", false);
	    _this3.props.onSetUiFlag("operationType", "update");
	  };
	
	  this.genDirectSupplierOrder = function (rec) {
	    _this3.stateChangeHandler(rec, "prodDets", false);
	    _this3.stateChangeHandler("directOrderpad", "stage", false);
	    var initData = (0, _getMenuList.getInitData)("deliveryRequest", _this3.props.createTable, _this3.props.userProfile);
	
	    if (initData && initData !== undefined) {
	      _this3.props.onSetUiFlag("operationType", "add");
	      _this3.props.onSetUiFlag("tableName", "deliveryRequest");
	      _this3.props.onAddNew({
	        path: _this3.state.tableName,
	        data: _extends({}, initData)
	      });
	    } else {
	      console.log("no init");
	      // console.log(
	      //   "tableName: " +
	      //     this.state.tableName +
	      //     " crTable: " +
	      //     JSON.stringify(this.props.createTable) +
	      //     " " +
	      //     JSON.stringify(initData)
	      // );
	    }
	    _this3.setScroll(true);
	  };
	
	  this.getLandingPage = function () {
	    var tmpEmail = "";
	    var tmpPassword = "";
	
	    if (_this3.refs.email && _this3.refs.email.value) {
	      console.log(_this3.refs.email.value);
	      tmpEmail = _this3.refs.email.value;
	    }
	
	    if (_this3.refs.password && _this3.refs.password.value) {
	      console.log(_this3.refs.password.value);
	      tmpPassword = _this3.refs.password.value;
	    }
	
	    return _react2.default.createElement(_DirectAdmin2.default, {
	      company: _this3.state.refPhoneNumber,
	      email: tmpEmail,
	      password: tmpPassword,
	      stateChangeHandler: _this3.stateChangeHandler,
	      switchMenu: _this3.switchMenu
	    });
	  };
	};
	
	function mapStateToProps(state) {
	  return {
	    userProfile: state.db.userProfile,
	    users: state.db.users,
	    isAdmin: state.ui.isThisAdmin,
	    isSuperAdmin: state.ui.isThisSuperAdmin,
	    userUid: state.ui.userUid,
	    currUserRole: state.ui.currUserRole,
	    createTable: state.db.createTable,
	    testTable: state.db.testTable,
	    listOfTables: state.db.listOfTables,
	    menuDesigner: state.db.menuDesigner,
	    cellPhone: state.ui.cellPhone,
	    uploadButton: state.ui.dataUploadButton && state.ui.dataUploadButton !== undefined ? state.ui.dataUploadButton : false,
	    db: state.db,
	    operationType: state.ui.operationType,
	    loginProgress: state.ui.loginProgress,
	    notLoadedBasicData: state.ui.notLoadedBasicData,
	    userMenus: state.ui.userMenus,
	    workerMenus: state.ui.workerMenus,
	    listYPos: state.ui.listYPos,
	    orderStage: state.ui.orderStage,
	    ui: state.ui
	  };
	}
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    onAddRecord: function onAddRecord(data) {
	      return dispatch((0, _actions.actionAddArray2Redux)(data));
	    },
	    onUpdateRecord: function onUpdateRecord(data) {
	      return dispatch((0, _actions.actionUpdateRecord2Redux)(data));
	    },
	    onSelectRecord: function onSelectRecord(params) {
	      dispatch((0, _actions.selectARecord)(params));
	      dispatch((0, _actions.setUiFlag)("tableName", params.path));
	    },
	    onAddNew: function onAddNew(data) {
	      return dispatch((0, _actions.initSelectedRecord)(data));
	    },
	    loadStats: function loadStats(parsedRes) {
	      return dispatch((0, _actions.loadAllStats)(parsedRes));
	    },
	    onSetUiFlag: function onSetUiFlag(flagName, flagVal) {
	      return dispatch((0, _actions.setUiFlag)(flagName, flagVal));
	    },
	    onSignOut: function onSignOut() {
	      dispatch((0, _actions.resetRedux)());
	      dispatch((0, _actions.setUiFlag)("userMenus", []));
	    },
	    loadFbData: function loadFbData(tableName, firebase, onceOnly, subPath, singleObj) {
	      return dispatch((0, _actions.loadFbData)(tableName, firebase, onceOnly, subPath, singleObj));
	    },
	    onNotifyUsers: function onNotifyUsers(msgBody, arrayOfUsers, sendToAll) {
	      return dispatch((0, _actions.notifyUsers)(msgBody, arrayOfUsers, sendToAll));
	    },
	    onGetId: function onGetId(data) {
	      return dispatch((0, _actions.getId)(data));
	    },
	    onGetAcctStatement: function onGetAcctStatement(data) {
	      return dispatch((0, _actions.getAcctStatement)(data));
	    },
	    onGetAcctBalance: function onGetAcctBalance(data) {
	      return dispatch((0, _actions.getAcctBalance)(data));
	    },
	    onAddArray: function onAddArray(data) {
	      return dispatch((0, _actions.actionAddArray2Redux)(data));
	    },
	    onFetchDistance: function onFetchDistance(og, dst) {
	      return dispatch((0, _actions.fetchDistance)(og, dst));
	    },
	    onInitialFetch: function onInitialFetch(tableName, url, accessToken) {
	      return dispatch((0, _actions.initialFetch)(tableName, url, accessToken));
	    },
	    onInitialProductsFetch: function onInitialProductsFetch(url, accessToken) {
	      return dispatch((0, _actions.initialProductsFetch)(url, accessToken));
	    },
	    onReachApi: function () {
	      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(objContents) {
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                return _context.abrupt("return", dispatch((0, _actions.reachApi)(objContents)));
	
	              case 1:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, undefined);
	      }));
	
	      return function onReachApi(_x) {
	        return _ref.apply(this, arguments);
	      };
	    }(),
	    onReachApiExtended: function () {
	      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(objContents) {
	        return regeneratorRuntime.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                return _context2.abrupt("return", dispatch((0, _actions.reachApiExtended)(objContents)));
	
	              case 1:
	              case "end":
	                return _context2.stop();
	            }
	          }
	        }, _callee2, undefined);
	      }));
	
	      return function onReachApiExtended(_x2) {
	        return _ref2.apply(this, arguments);
	      };
	    }(),
	    onSendEmail: function onSendEmail(mailParams) {
	      return dispatch((0, _actions.getStatementB64)(undefined, undefined, mailParams));
	    }
	  };
	};
	
	exports.default = (0, _recompose.compose)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _Firebase.withFirebase)(Workers);

/***/ }),
/* 322 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var bcsOpenBazarImage = exports.bcsOpenBazarImage = "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEAkACQAAD/4QB0RXhpZgAATU0AKgAAAAgABAEaAAUAAAABAAAAPgEbAAUAAAABAAAARgEoAAMAAAABAAIAAIdpAAQAAAABAAAATgAAAAAAAACQAAAAAQAAAJAAAAABAAKgAgAEAAAAAQAAAkKgAwAEAAAAAQAAAUAAAAAA/+0AOFBob3Rvc2hvcCAzLjAAOEJJTQQEAAAAAAAAOEJJTQQlAAAAAAAQ1B2M2Y8AsgTpgAmY7PhCfv/iD6xJQ0NfUFJPRklMRQABAQAAD5xhcHBsAhAAAG1udHJSR0IgWFlaIAfkAAEAAgAJAAcAHWFjc3BBUFBMAAAAAEFQUEwAAAAAAAAAAAAAAAAAAAAAAAD21gABAAAAANMtYXBwbAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEWRlc2MAAAFQAAAAYmRzY20AAAG0AAAEhGNwcnQAAAY4AAAAI3d0cHQAAAZcAAAAFHJYWVoAAAZwAAAAFGdYWVoAAAaEAAAAFGJYWVoAAAaYAAAAFHJUUkMAAAasAAAIDGFhcmcAAA64AAAAIHZjZ3QAAA7YAAAAMG5kaW4AAA8IAAAAPmNoYWQAAA9IAAAALG1tb2QAAA90AAAAKGJUUkMAAAasAAAIDGdUUkMAAAasAAAIDGFhYmcAAA64AAAAIGFhZ2cAAA64AAAAIGRlc2MAAAAAAAAACERpc3BsYXkAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABtbHVjAAAAAAAAACYAAAAMaHJIUgAAABQAAAHYa29LUgAAAAwAAAHsbmJOTwAAABIAAAH4aWQAAAAAABIAAAIKaHVIVQAAABQAAAIcY3NDWgAAABYAAAIwZGFESwAAABwAAAJGbmxOTAAAABYAAAJiZmlGSQAAABAAAAJ4aXRJVAAAABQAAAKIZXNFUwAAABIAAAKccm9STwAAABIAAAKcZnJDQQAAABYAAAKuYXIAAAAAABQAAALEdWtVQQAAABwAAALYaGVJTAAAABYAAAL0emhUVwAAAAwAAAMKdmlWTgAAAA4AAAMWc2tTSwAAABYAAAMkemhDTgAAAAwAAAMKcnVSVQAAACQAAAM6ZW5HQgAAABQAAANeZnJGUgAAABYAAANybXMAAAAAABIAAAOIaGlJTgAAABIAAAOadGhUSAAAAAwAAAOsY2FFUwAAABgAAAO4ZW5BVQAAABQAAANeZXNYTAAAABIAAAKcZGVERQAAABAAAAPQZW5VUwAAABIAAAPgcHRCUgAAABgAAAPycGxQTAAAABIAAAQKZWxHUgAAACIAAAQcc3ZTRQAAABAAAAQ+dHJUUgAAABQAAAROcHRQVAAAABYAAARiamFKUAAAAAwAAAR4AEwAQwBEACAAdQAgAGIAbwBqAGnO7LfsACAATABDAEQARgBhAHIAZwBlAC0ATABDAEQATABDAEQAIABXAGEAcgBuAGEAUwB6AO0AbgBlAHMAIABMAEMARABCAGEAcgBlAHYAbgD9ACAATABDAEQATABDAEQALQBmAGEAcgB2AGUAcwBrAOYAcgBtAEsAbABlAHUAcgBlAG4ALQBMAEMARABWAOQAcgBpAC0ATABDAEQATABDAEQAIABjAG8AbABvAHIAaQBMAEMARAAgAGMAbwBsAG8AcgBBAEMATAAgAGMAbwB1AGwAZQB1AHIgDwBMAEMARAAgBkUGRAZIBkYGKQQaBD4EOwRMBD4EQAQ+BDIEOAQ5ACAATABDAEQgDwBMAEMARAAgBeYF0QXiBdUF4AXZX2mCcgAgAEwAQwBEAEwAQwBEACAATQDgAHUARgBhAHIAZQBiAG4A/QAgAEwAQwBEBCYEMgQ1BEIEPQQ+BDkAIAQWBBoALQQ0BDgEQQQ/BDsENQQ5AEMAbwBsAG8AdQByACAATABDAEQATABDAEQAIABjAG8AdQBsAGUAdQByAFcAYQByAG4AYQAgAEwAQwBECTAJAgkXCUAJKAAgAEwAQwBEAEwAQwBEACAOKg41AEwAQwBEACAAZQBuACAAYwBvAGwAbwByAEYAYQByAGIALQBMAEMARABDAG8AbABvAHIAIABMAEMARABMAEMARAAgAEMAbwBsAG8AcgBpAGQAbwBLAG8AbABvAHIAIABMAEMARAOIA7MDxwPBA8kDvAO3ACADvwO4A8wDvQO3ACAATABDAEQARgDkAHIAZwAtAEwAQwBEAFIAZQBuAGsAbABpACAATABDAEQATABDAEQAIABhACAAQwBvAHIAZQBzMKsw6TD8AEwAQwBEdGV4dAAAAABDb3B5cmlnaHQgQXBwbGUgSW5jLiwgMjAyMAAAWFlaIAAAAAAAAPMWAAEAAAABFspYWVogAAAAAAAAg3EAAD2f////u1hZWiAAAAAAAABMDwAAtFMAAArjWFlaIAAAAAAAACdWAAAODwAAyI9jdXJ2AAAAAAAABAAAAAAFAAoADwAUABkAHgAjACgALQAyADYAOwBAAEUASgBPAFQAWQBeAGMAaABtAHIAdwB8AIEAhgCLAJAAlQCaAJ8AowCoAK0AsgC3ALwAwQDGAMsA0ADVANsA4ADlAOsA8AD2APsBAQEHAQ0BEwEZAR8BJQErATIBOAE+AUUBTAFSAVkBYAFnAW4BdQF8AYMBiwGSAZoBoQGpAbEBuQHBAckB0QHZAeEB6QHyAfoCAwIMAhQCHQImAi8COAJBAksCVAJdAmcCcQJ6AoQCjgKYAqICrAK2AsECywLVAuAC6wL1AwADCwMWAyEDLQM4A0MDTwNaA2YDcgN+A4oDlgOiA64DugPHA9MD4APsA/kEBgQTBCAELQQ7BEgEVQRjBHEEfgSMBJoEqAS2BMQE0wThBPAE/gUNBRwFKwU6BUkFWAVnBXcFhgWWBaYFtQXFBdUF5QX2BgYGFgYnBjcGSAZZBmoGewaMBp0GrwbABtEG4wb1BwcHGQcrBz0HTwdhB3QHhgeZB6wHvwfSB+UH+AgLCB8IMghGCFoIbgiCCJYIqgi+CNII5wj7CRAJJQk6CU8JZAl5CY8JpAm6Cc8J5Qn7ChEKJwo9ClQKagqBCpgKrgrFCtwK8wsLCyILOQtRC2kLgAuYC7ALyAvhC/kMEgwqDEMMXAx1DI4MpwzADNkM8w0NDSYNQA1aDXQNjg2pDcMN3g34DhMOLg5JDmQOfw6bDrYO0g7uDwkPJQ9BD14Peg+WD7MPzw/sEAkQJhBDEGEQfhCbELkQ1xD1ERMRMRFPEW0RjBGqEckR6BIHEiYSRRJkEoQSoxLDEuMTAxMjE0MTYxODE6QTxRPlFAYUJxRJFGoUixStFM4U8BUSFTQVVhV4FZsVvRXgFgMWJhZJFmwWjxayFtYW+hcdF0EXZReJF64X0hf3GBsYQBhlGIoYrxjVGPoZIBlFGWsZkRm3Gd0aBBoqGlEadxqeGsUa7BsUGzsbYxuKG7Ib2hwCHCocUhx7HKMczBz1HR4dRx1wHZkdwx3sHhYeQB5qHpQevh7pHxMfPh9pH5Qfvx/qIBUgQSBsIJggxCDwIRwhSCF1IaEhziH7IiciVSKCIq8i3SMKIzgjZiOUI8Ij8CQfJE0kfCSrJNolCSU4JWgllyXHJfcmJyZXJocmtyboJxgnSSd6J6sn3CgNKD8ocSiiKNQpBik4KWspnSnQKgIqNSpoKpsqzysCKzYraSudK9EsBSw5LG4soizXLQwtQS12Last4S4WLkwugi63Lu4vJC9aL5Evxy/+MDUwbDCkMNsxEjFKMYIxujHyMioyYzKbMtQzDTNGM38zuDPxNCs0ZTSeNNg1EzVNNYc1wjX9Njc2cjauNuk3JDdgN5w31zgUOFA4jDjIOQU5Qjl/Obw5+To2OnQ6sjrvOy07azuqO+g8JzxlPKQ84z0iPWE9oT3gPiA+YD6gPuA/IT9hP6I/4kAjQGRApkDnQSlBakGsQe5CMEJyQrVC90M6Q31DwEQDREdEikTORRJFVUWaRd5GIkZnRqtG8Ec1R3tHwEgFSEtIkUjXSR1JY0mpSfBKN0p9SsRLDEtTS5pL4kwqTHJMuk0CTUpNk03cTiVObk63TwBPSU+TT91QJ1BxULtRBlFQUZtR5lIxUnxSx1MTU19TqlP2VEJUj1TbVShVdVXCVg9WXFapVvdXRFeSV+BYL1h9WMtZGllpWbhaB1pWWqZa9VtFW5Vb5Vw1XIZc1l0nXXhdyV4aXmxevV8PX2Ffs2AFYFdgqmD8YU9homH1YklinGLwY0Njl2PrZEBklGTpZT1lkmXnZj1mkmboZz1nk2fpaD9olmjsaUNpmmnxakhqn2r3a09rp2v/bFdsr20IbWBtuW4SbmtuxG8eb3hv0XArcIZw4HE6cZVx8HJLcqZzAXNdc7h0FHRwdMx1KHWFdeF2Pnabdvh3VnezeBF4bnjMeSp5iXnnekZ6pXsEe2N7wnwhfIF84X1BfaF+AX5ifsJ/I3+Ef+WAR4CogQqBa4HNgjCCkoL0g1eDuoQdhICE44VHhauGDoZyhteHO4efiASIaYjOiTOJmYn+imSKyoswi5aL/IxjjMqNMY2Yjf+OZo7OjzaPnpAGkG6Q1pE/kaiSEZJ6kuOTTZO2lCCUipT0lV+VyZY0lp+XCpd1l+CYTJi4mSSZkJn8mmia1ZtCm6+cHJyJnPedZJ3SnkCerp8dn4uf+qBpoNihR6G2oiailqMGo3aj5qRWpMelOKWpphqmi6b9p26n4KhSqMSpN6mpqhyqj6sCq3Wr6axcrNCtRK24ri2uoa8Wr4uwALB1sOqxYLHWskuywrM4s660JbSctRO1irYBtnm28Ldot+C4WbjRuUq5wro7urW7LrunvCG8m70VvY++Cr6Evv+/er/1wHDA7MFnwePCX8Lbw1jD1MRRxM7FS8XIxkbGw8dBx7/IPci8yTrJuco4yrfLNsu2zDXMtc01zbXONs62zzfPuNA50LrRPNG+0j/SwdNE08bUSdTL1U7V0dZV1tjXXNfg2GTY6Nls2fHadtr724DcBdyK3RDdlt4c3qLfKd+v4DbgveFE4cziU+Lb42Pj6+Rz5PzlhOYN5pbnH+ep6DLovOlG6dDqW+rl63Dr++yG7RHtnO4o7rTvQO/M8Fjw5fFy8f/yjPMZ86f0NPTC9VD13vZt9vv3ivgZ+Kj5OPnH+lf65/t3/Af8mP0p/br+S/7c/23//3BhcmEAAAAAAAMAAAACZmYAAPKnAAANWQAAE9AAAApbdmNndAAAAAAAAAABAAEAAAAAAAAAAQAAAAEAAAAAAAAAAQAAAAEAAAAAAAAAAQAAbmRpbgAAAAAAAAA2AACuAAAAUgAAAEPAAACwwAAAJkAAAA1AAABQAAAAVEAAAjMzAAIzMwACMzMAAAAAAAAAAHNmMzIAAAAAAAEMcgAABfj///MdAAAHugAA/XL///ud///9pAAAA9kAAMBxbW1vZAAAAAAAAAYQAACgQAAAAADVGGSAAAAAAAAAAAAAAAAAAAAAAP/AABEIAUACQgMBIgACEQEDEQH/xAAfAAABBQEBAQEBAQAAAAAAAAAAAQIDBAUGBwgJCgv/xAC1EAACAQMDAgQDBQUEBAAAAX0BAgMABBEFEiExQQYTUWEHInEUMoGRoQgjQrHBFVLR8CQzYnKCCQoWFxgZGiUmJygpKjQ1Njc4OTpDREVGR0hJSlNUVVZXWFlaY2RlZmdoaWpzdHV2d3h5eoOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4eLj5OXm5+jp6vHy8/T19vf4+fr/xAAfAQADAQEBAQEBAQEBAAAAAAAAAQIDBAUGBwgJCgv/xAC1EQACAQIEBAMEBwUEBAABAncAAQIDEQQFITEGEkFRB2FxEyIygQgUQpGhscEJIzNS8BVictEKFiQ04SXxFxgZGiYnKCkqNTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqCg4SFhoeIiYqSk5SVlpeYmZqio6Slpqeoqaqys7S1tre4ubrCw8TFxsfIycrS09TV1tfY2dri4+Tl5ufo6ery8/T19vf4+fr/2wBDAAEBAQEBAQIBAQICAgICAgMCAgICAwQDAwMDAwQFBAQEBAQEBQUFBQUFBQUGBgYGBgYHBwcHBwgICAgICAgICAj/2wBDAQEBAQICAgMCAgMIBQQFCAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAj/3QAEACX/2gAMAwEAAhEDEQA/APvzWfBVrHOGRW2k43dK5I6HFZyfMW46CvoDVZxcyGKEgAc4NcjcWttPlZSoYZ561/pLgsfVlrzM/kvEUIxbSR5jb6OHYkScHoKsS2FvB8hKtnoenSti4MEMzJETkfeI6VyOotOz5bcwycY7V9Dh5855k4pGVPLMJGUZKY/GqkMcjy+Yp2qozgjnNOjE+3zV3cZNXbRJZ1MlwWAHAGK9NRSRxc6b2LcDllCP92ugs7VnOZW46CqmmWce8PIAynoD1rovsRuUKRHaB3ry8ZXs3BHbRpvcvRWsXlKOemOtatqjuSqc7QBUWmWktxtgjUkrwc13mk+HXDsZBz3Ar5/E4iMIs9KnTbehzNtZPMGZ0bg9jWtaaPJMDHEhLH+92r0iz8Owwox2jOcj/Oa0LbTUilySErwa2Zp6RPRpYRvcw9E0JjEIbmPK+o9a6mGza1cxwEbRxjuMVcVo4vliOecgj3pu7zDgdTXlzxDl8TPTpUkkOguFLFARkDkVg6g8bkx3IGTnoK6zT9HaZjIBgkc1rr4csyWkuVJIHWsFiIRd3udLws2rXPmbU7CaX5rZSwBOPpWfaabMXxMDz3AxzXvT+HIJN4g4xkAVVi8NxRRHzwAexA/rXt0szXLdHjyy9nkkunLFEVQsW7Zq1psDRjZtBY9jXWXlikKNHnjPGBzWbYW7+a2FJweD0raGKdSLaZl7Oz0RFqNjG8AKnb8wHtXKeUvmEAiQDPB7V6VHY/a8wSgrj5gajtPDCwyO+FO7vmqhiow3H7KW9jzfyfMwYgMd8cVsRwwxW5dfvf1rov7KtbaZkYd+gqvPZjJkTgAfdFdCxkHqkc7ptNyPPNV05rx1lfIA+9WBNYNauVAJUHhj0NepPbxypnHOOKRtFa4hLuu4MeVA7iu2ljOXd6HLOgnqeMX+jyXZUhNq+orAvfDLqE3Z7nrXvl7oxMISBcleqHg1yEujXcspWY42khec/hXp4XM3qos5amER4zcaDE6DZv4PJJ9aS2shprARqSW5BHQfWvYP+EaJUhgOeetc7Lpi294EYkgLkjGa9enmCekjjqYVrocJqE8ggYshZgONtYtnaXygm6UsWGVxxj616OukzST+aAOuBVWXQbpMyOQOegatHmMNjJ4dy1secxwXEVwXlK/KTgAV3OlsjIJbo7cAbcd6JNGUKZWwe3Wo1QonlkYxWk2poSi4vU6VdPSVdyZIPPX1q21tFZQhEGR/tc1i6ddTrPtZmIPb2FbF9dQvGNjDGea89U2p8u51t3iYl35AcBBznLfSmwCAwmRMgbiDnnpUEnzOSWz71DLIBtWA/L1YD1ruqQ0VzmM3Ur+8hYLEcj3rCkndjvl5Zj29auXu+5uiisVwTjmmWMUsbN5p3Hsa3pxVrnM5uUmjPMcv2YsRh8nj2qOweRd5JPJHWtydN6kDjg1hx25Eyxo78tyAOPzrbm6GUtGrGkHZ+DThGVbnp3q8LF1OMDH1/wAKrM6i58rBI9e1RF3uXKNtyk6rvJHrViIMQGqz/Z80hLJjB5GeKkjhCDy2IyPSqaYowbZnhAefeoZTEo2sTzxXQWlrbTSFJcjH3cdDV99FtgpMYOcZGBXNUxcI6Pc3jhm9bnGQ2MIkEg3Eg8V0EGk3FxOsmxsEjPIHStTT9HuSSTF9D6V2un6VIQGfrwAp9a5sRmNPltHVm1Kg29TnYLCNChOdwPIPSujtI3VvMUDaWIH+7WwbJBF5TL8w7DrVi2gWFRviO0DA715VauprRanpUqTRClnMqgnnJzx6VpR6csmCA3YEfWuogtbdo1KLg4H3hiryWiEjcBwcivCr467tA9KnRS3RzbaPCjAbSGGCobnNMvLGRI2DxgED+ddrMlrGvnyrkr0rj9T1NJFckgDufYVWGnVm9dS58sVa1jirmyaJi2DtzXE6tMogYKQdr11+qXxW3LKxA3DBHSvJtev5mUGHhWkwSO9fRZdRbqK2x5FWppyoyNQf7rqckk5rN2jG+Xgdcil3O7fvD+JNZtzcedhYmIx1BBr6mjSvpE5YUG3ykepTJI6mA57Gs8SMvDYzUzRNsLZHFZF5c+VmPJ3ccj3r3cPQSWqO2VCEILmQ65jgmkPmE5JycVn3TpbkpAeQcAH0qpLPMnzMxPOKyLy/8tiWLFm6CuqMfITrxitDQY9ZH6tzVW6kViPK5qjHLPMgYnj3pXYn7uRXXCFtGd9JxitdSOYsAZO6LkelZOS3zHvzW3HuYhHOc8H3qtc2yiUiMACm46nRGUZ6RRnAEnAqzDG4JyKlW0dDuyOPr/8AWqZVIOTQ5WVkW4vYZsajYasBSeRTZgUK49Oaz9pLsR8OrE2S/wCf/wBdHly/5/8A11KJBjv/AJ/Cl8xff/P4UrIz+sxP/9D9GLwTyuzAkk45xWOLadn8vB3H1r0GCCdpFRocg9cGumTRoFQMqcnjBr/Rf60qbvJXP5SjQc9Gzw8+H55HLsWyTzyeKsjQYU4PU817/wD2KsaLvTHAGSKzZ/D0aH95wCxwMU1nav7sSpZdpueHz6HCrqZV5A4z6VGunqjDKZwc/KOK9pn0a0iXczZxUMWkwSMGRcgHBrZ5y7X5fxMVgjyOHT5LufCJgZ+7jmu10vwzcSyNGsTYGMZFei6dZWaXBj2c8c16RaadFCoeLgkDNeXmGaXekdfU7sNgE022cb4c8NW6AFk+fPIIFdxJokFsNxA5OOMVKjNaqzLgnOc1GtypG5gCT6//AKxXgVcVOb3PUo0YxTjYmNvaRxDywQQP1rLuA0+S6ZOMZArWhAuMgELj1712Nhp1tHDk4LHnHt+NctSu4anTSoKTseXJbnIVFwB2NbsHlR87PoRXQ6zbRhxGAFAG4Edc4rhHmZJzuzgHoKqMudXInHllynVx3DSJ5anAAretiht8TfMWHBrjIC90haL8q2zHJBGFkyOwrOaud1GVygqDewAG3Jq6Iont2CqMBeg9a5qctG4Ck8kk1qxbnUFcgHFNx0VjCNW3Qw7jTrFnIK4Y8jAGBVWK1t7dztUfWunmtVkjzHgvWJNazhjgc55rpp1NDmqwZW8wA5wMdKy5b+JGKgEc1eNjPK211PBxxWTPp80b4BzyQRjpXRCockoOzMa6uI12nrkk1Ue4i+7gkdwasTWfnthlI2HjGapPBJ5gG04r06L7nnuD7lS8dQhe3yuOazg5z99q6FbMnK4qRdNQqOMHPJHNdTqIzVJ9znHj3j5C2fc4H8qRYRj5xk1q6hCsGFUfjVIcqG4OapPsZSjZ2EtrBZyVJOcdKpNpdoCQyjOeankY9VJGPSt82ypp+eDz97vXRV54W1FFJnB3GjwRAyQ4BXnmufuLZnkPnEEV1s9/9m+Ypv5x171kSJHPm4PBY/dr107GFSCvocRqKOq7YlKgN17Vx0a3DzsSGwGOc9/pXqc2nm4yqHAznmuWmsdrnc3O4jgGvXwuJXLaW55OKp+8ZKII2LRswJ65NVb6GWW2YQg5zgEdjWuNPRGLgnJ68VoxwxSRAbSWxx6V1zxKir2OdUzhLfTNQQgyPkZ5BNdRZW4WM+YAeamubORgY0BB7VBHa3ifuiDxyTTjVUkm3YuCs9dTLu9LS6lYqAoz1FJbaMYVDhSwIwOMiuut9KkCBph8p5z3q24RP3SjAU8H6VlPGKLsKNNXbODk01pjgllA68VdstHs1yyg5yOfWukkTzZFXoTxV+201X+ZzyvpxUPHtraxKpapsxjphxvVFKjuBR/ZNrKuGUKfQV0E1orZRifXjiqotZw+yEblPeuP28r6s7oON1oYhtVU/Z0G4LwBj0qCHQ45JyHQ5PzV2UGjlpQ8wx3611P9mxWiidec8YrCrXa0udTpJnnUPhZo4sRjBzmtOz0G4EmZc7R6Z5+tegLYTMAwI55/zzV+wtnTcJAOv6VzVMa1eW5pDDnIw6dFG29NpHqetakdiJ49yADnGa2rmx8yYMpCrjkAVaWNVUL6fhXDPMW9LHTGmtyrbWNvCFfALj+I9auGJZMfXJ4pVXnaKmVdpIkOAB1rz6lRyehvFR7Fd7xR97twM9KaNSt4V/fEdzwa56+T90+CeW4rkFuHjdonDHkjrXXTwK3bM3Xa0Oq1PxChhcJkg8AbuPyryrVdZkg3BQCGHGDitq7iXaXUlQMse/Arz7ULmzjy8hZzux7CvdwGHS3RwYivJ6Fe7v5p08xgVUntzXHX9yXiMSsxO7jPY1a1G5klQmElU3DGPpWHcW/noAGIIOa+0y/CrkTOOEG5czZkyTTu2JXY47FqgeR8fLn86e1sQxHocUpi2rXvza+yjWa5XoZZvLp1I3cdxnms26kY9cnPGTVpg0O52wQ7dPTNQyDdESPStYWSNHruZMjFiV54x3pktiLqPzCF4PU1aWBmZmzj2pFjJfY2cd8VdOqFB2d2UVQRfux2qby0zgDH0/yK10ijCAAdhyaqtb+WeTuzWsqlmeny3RSMY4wSD1FNLOoLK31xViReQT0H8qqTMz5C9KtXepdKg3dp2IhOzvgu2P7pp0sqxLuOT9KrCEumwnB9akSNxGEfnAxT5NbnZTp2VmOS4DdBVBXcndk5yanMYXkU0KB0q7GlkP3tRvapNi0bFosjHlh2P//R/YW00u8bdJIoVk4Kj/GtSCzdm8l4st7kgV61aQW9zb4Eaq2M59TWBqe6N2YoFOewr+5VjJyfK0fzu8LGKumYSWDGERs3TnGM49qZNpvnIY5M+2OcVrR/KNzMDkdB2q3EgfOewzQ27mbpo5N9HU2e2Q7ipx93B/nWdFokxVg2ME9h2/Ou2ySBj15+lE6Rq+IBx2wK1hWexEqSOY0/SIbImSYDaCOTW5carCiAQdc4xTZ4WmTyTkN16UyLQ5Gw7nociok77hGD6FtE8+Ivv7/doj06CViMZOMnNasWmWsMQZWJcj5qqodrdaz9DZKx0iQ21lHlCucZwcc1FLeNJASijcRxjn9KxPNQuDIenerqzRgeZCQcdKnlbNFUSRXZZpZiGBBbjkcYqpLp7EkyKMA8n1raiullG+Yjd6CtWOyM6h3+5nkVN7FxVzMskRYQsaY75FOntLuTHymukt7S3gO4E9MYq880SD5zXO6r3sdagpW1OOh8PPI2+bAUeorpLOxs4IREQD79M1oXF9F9nZWI3EfKK52S8aOIDjdjGKxlzS30G+WO2ppzpYRxEqIwfqKwIYbQzEsFJPU5rOnO9WLd/Sq1vFIZCwYsMYweoraMEupz1Kt3ZI0biGBXYxqM7z09KxXUhjgEDNdBFG+8OAfSkmtBKg2Z4PU1oqtupk6Otzj9TP7tY1TkgksP/wBVcE0Uu4793XjIr1xrcj5SPbNZ8uhySSqxUcdMCvSo4rRRZw1cNvLqcBZW7vL5bAgY6kVpJYhiwwS2evQGvQBpDRDcyjBH6VhyxP5xVQFAPHoKpYi7ujJUdNTzLWdOmSQuvI9OtctskXjBHPQV6xqMUaMxc5JOcj1rGht4YwZNvJ9fWvWwWMavdHHVpHAxwyzNsQfXdxVG/uJIQqISSSCR/wDWrvZoMK3yDJyRWbZ2u5Czr1PT2r06OI5k20c9SjrY4ObE0gZgQMD5alLwiLySowD3Ndrqmk28ybApHHbrWB/ZAgGYyy9uea6ue6OOrRs9DEnRFgO3AyQAfrWFNaOoHl7X9c8f412N1prNEOrEMDxVRtOBXG1/yrrp1bHLOnfc486fcyjhQPoc1v2enTpCd0ZwPatqx0orGVkyBnK1sCeG32wyA5/hxRPFAsP1OP8AsxzkRnP0I/pUn2JRH5syfN6/5Fde1xBnaeM9jQ0VteqY3fAHOV5rN132H7BdzjjBHJEjydNwytPvNKtAm9cH+Lj3roZbG3EoLEkbT14rIuCYgTEuecDFUqt9bidK2hxctt5cyyDkDtitSGB5ATF1BHA71b8qSY7h+WK07C2MFyCp3E9RjpW3ttLmapO5USymkG6RNp9MZrUtdMk8veeOTxiuktrWW4cYBCk4I6mtr+yWP3Qx9q8yrmCjtqd9DBc2pztrZQmLDx5IPXFaMlgvlKzKCCR94YAroYbaNI1VQS3G4HtV2dIimHAIHIHavJrYrmldnowppKxykdngkyFUHQUssSxY2Nuz6cVJqXBVf4RnbWdDnef7vNbUcPzR5nITepYVAzBT9M1XfarHJwAetT1DNAs0ZRuAa6KVOzZDK8txDGm+Ntxz06VlPq0Mg8t/l59c1HqHk2cbIjcnoD3rkiJZGHHVua7YwRzVK3LsdDdXcMieWh+p9K5q/uQYysC855Y1bmEkOASOelU5PKVS59666NLVHPWreRw91c3DO8RbA24z2+tc1LYcNExDbsHcR0rubkW8kYVNrE1kTRRhWBzjHNe/hXZcp586pxt1YRwW+7erYYDbgf41z1zGFUFe5rpLtEdmU+o4rNa1Sb5SD1z+NfRYSTjE4pVmpqVjlpLfDliepz0qhcQyHATPfOPr9a6O6EKEmVgAhNZ7TxQYwRhhnNejCq2tj0Vif3XtOvYwPspkO0j9KiltljBhJAyKvT30UL7UZeeeaxrm7WSQyPjHABFdlGMm9Ucscyl1iSIkUWVJHX6UxpIWOz5OD6jmsy4YSyHHTtioyYM4OODit4YZK75jHC4t0qkqlr3L808MY+Uoe3UcVUiZc5LA9sZHNYkkK+azL3PWrSoqnp0IOa0jR8z0Kebyk0lA6ARKvYflWZdQr53YZAOPrWq1xbgjcwJIzxVSdrF33PIAQPzqveWyPrnOn/MZ5t1C54H4VXmQxJuXLewq2bq1KEOwznGKabi2YAbuO1TBzX2ROpT/AJjEfOTu4+vamwhpByCP8/hV64SyuPuPls9AaQBYzh3XpWkeZ62Epw35tBvkMecmjyG9TVwT2394fnR59t/eH50rT/lZj7Sn/MvvP//S/cU6w648lW4OcGnS366gcbsY6r15qWTRnnkMmev93pVIacYZBjIbPJFf3Lofzsm9maVtZ5G84wemKpYud7FQw5IrqNMmhiVllPP61W1HV7S1O0DsSQO1JTd7KNx2XcyY1kSP99lSBnaetTRXNuiEl1J7Dv8AhXMz+IElUyO5VQMZNZL67ZwjJlLd8V1wwdSWqic08TFfaPQItTRwI2yB6GrMk6KMoc/SvL18XWCPhSQ2PT+tXo/FiSkKpP41p/ZtX+QlY2PRnfpd2xGWk+butZN3cxRR5V13N0rmE1W1mk3ksT1OBVe91KCXaIHORnOePSlTwU+ZRlGwSxKs7M1zfgzCOaRcjgjGK0I7m3DYWQfQV57LqsYIMbhiOpPWhdXllAjyeTXcstv5HH9bd7Hrdtc6fj99KoOBirsfiBkGyJ0cduK8xt5ZCvX/AGQfYdK2rIjaDltwHPGa82vhIxO+GJudo+rSzcoSDnn0+lWobibcRctkAVgaYrXL/L/e3Zbiu8jtFnhAk3LtOCccH/GvMrWjZI7KUnJFRJUnIII4GKV9O899wz6+1Z2s6inhVrSV7We7+03kdqkFo8QlO8MxZVldN5AXO1TuxkjpXl/xK/aP8LfDzxfpGh3URt4NUhlfGtwXNgnnRPtaNbwLLFHIAQyo6EODkNwa8PH53Rw+kvwPWwOVVsQ+WktT2k6YIR5zgbRzjqabawWsi78ZDc5X/GvIfiH8fPC2jfCjWvF2nM1tdwWQFj9qdTbG5uCI4f8ASYi6Y3MDltnHYVZ8FeJ/G/iuz0lPC8pOg6ZFbxar4k1VDNca3NGirIlpG+0iN3DF7hu2Ai/xVyU88pzd4O6Lr5XUpR557HtyW0RQBcjA4waoXuu+G9GvbHR9Wu7S3vNSZ0sLaaRUlnMYy3lofmYAdSBgV414m8W+JtS+J4+Evha8stHuDpB1ufVpkF1cNB5nlmKztjtTzE4LSSFgoIwpqW5tPAPwg0TVPHN0sz3Aj36lq15/pWp3rEgJF5jAkl24SNMKCcAAVpPHufwoy+r2Vpddv8z0u/1XS11O10SSe3iu7ppza2rf664W2AMxRBkkIGUs3QZHPIqbfCBuUg4/CvjjwavhbxLpN78RPjXFNaeJL3xCvh+WyBc3GlTwtusrGxeIhxiNzM8qY3sWZuFFdx8SPF/xT+Efg/xB4ntXTxLY6XpUt3ZKYgNWtREmWZ+RFdqDyRiN8clmrVZjO3Ny3X5GcsJGckouz8+p7nd+JtLXX7Pw1cXcCX16rvaWeT50iJ95tvZc8BmwCeASeKZPbSTSny1LKOCVHT6/XtXxZ8WrLwppfwdTVvCVzq174u1dNI8dQavYuv8AaPmRPG63ly+GWGzjSR4/LA27CVVSSTXsfgS9+I1qmqap4xVdc8e6ehtrrw7ZTNZabDaO+5ZNNjOd8c4UFJZgWLZViuMVngs9fO+Zeh1YzKoqnTnHSWt0/wCtj0XWJtO0+5htdSnggmu5DDZpcSpGZ3AyVjDEbmA7DmsuRdkxtplKyJncjAgjBwcg/SodQ8Y+B/EiXWgXdpJqdwkBm1bQZLSOaSwVRwL0TOscHPAZm56gmvF/DWq/EvxTf+V8KdJOiaDZ3CwSXHii+e/0+5jIbd9itkRJowjKOVnEZDYXPWvVp8ScuqXN6bo8+GRSlFynJRXd7M9kuPs6KQ5A46Yz1rIjWR1IjU/KcY6H8jXlS3Hxpudfj8I/2h4cXxBFbLqN5G8cbaabJmKh4rUH7cxzj5jKFXuTXV+E/Eh0O5vPCnjjUrpNTRI9Qu5rllbTFiYlEa3McaCBCTgh1yeNzk4r2KPFFNtWhyruzlr8PVIK6mpPsnr93Y7GSK4YZkTkdMVTexln4YEdOa62+k0rR9KOt6tfWlvaFAyXMsy7JAenl4J8z6LmvOG+IsJvY7yfT7uDQJHFn/bV5A1tsuixCsyyPn7O3QSFF+YjqDXqz4jpR91a+fQ8qnldWo7S923c05tLmhXIJ645qrLa3UADOhw3QnofpVay+Ifg/XvGt98ONOu/M1PToRLPEGDBsY8xUOAC0YZSwBbg9eDXdyWlwsbsUYRxLiSVsKi49WJA/Wu/DZtSqK6mtNDmxeXVaUuScdd/kcJvxww5/wA+1V5bdZ5Fl6ba619LaQASBTxuBUgghuRggkGo49MjjG4ocg5Fd6xEGrqVzhqU2vdscfPaiSTcSSR6U6ztrlp1hhBAY4zgda7O40VpnDKvG30qEaJd28glAJVar63Fq1xewdrmfdaZ8vlseR1HvWK1gsTEN0+v/wBauvZJFOGByeQDT00b7Sd8oAyM9c0lXju2W6S6HIjTlnYDbs963bTQJLJ9zDknjPJrqYRbRM0UnzEYxkelJJfw7C6kZ9DXG8XVd4pFRorqXrG1t4Yxv27uv402/uILWBpVIGOAfrWDL4hhjjyV5HpWVf6mboF2Uhcd65I4afMrrQ1jVUU0i7Hq0KZLEHJ7VJLqlsy7WZV/M1yL3UYPyEj6Cq5nwNwbaPeu95fBvUy+tW6HVSTWFwo3upx0P1qrcyWSoPKIyOuO9c3LdFFy7n+dQx3isMOx9sDrXRSo8q5b6EyxN+hqPeKrfu8EVXOrDds4yKzriaWN/KhLYyRjvkHFYd/eW1nby39/NHDFApkuJZiESNF+8zMcAAetdHLFK/QmfNfle5u3NsLtSWxnqGFc9h7WU5wSOK0jKbIqUkSVZFV0eFg6MjgMGB7ggg5rNvZ5RKYArb8gnp0IyDkVpQcJap6HNiIOEuSSs72HySsy8Y6c8Zrk9XnVIiA2BxkfjUGs+LtM0Cxk1HXZ4rK2jPltPdHaGY9FTu5PooJrlI9et9d0+DVbMzCK5UtELiJoJBgkAsjYIzjIz2xXrYKEXLlclc56kZKHPbRkragkBBAGOm4Cop9UimhZcAk+nesi9ie3dRckgkbs9jn0OBms2SVvOEQLDcflYjAIr6Shh6bSmjyaspKXLYtTXdoPmcHceoz/APWrDuNQWPnIUFuKhublUR3YFijhT+Nc7qGoq8aqgYYYFuP/AK4r2qFCUm2loTPuyWSaF3IkcEN1/GsWa7ikAAYZHAphZ5DubgEcVXNq20GNsE9RnFejToxhabQtL77FYDdksVBzwKi8lmkO4gr6Vo29ncTMUhRmOeAvPHqamj03UJ9wtonkKEBwozjPSt5YiMX8SCmpVHaCvcymijDYFQvZ2rykDJJ6/WtXyir7JAcjrVOW3kjk39Dnr6Z4BrZxja7ZvCjTdlzamPJbsGZUU4BxUrRgVqraXHL4Bz3zTdj4Knv1qoSW3Q6KVOKuomM0bbCF644rPdDn94OfeujeE479aoS2rl/kGffNbJrYqUO5htCSc7ePWlEQHpWu1rN5eMDrUJQIMN9DVRknpcl0/IopaosvynluOe9V58SN5ESlmDYwoyf0rpLKztGuwlwZ2+TeTBE7gc+u0LnHT5q5JtSsNekudHsbDUJTDII9SsdQit45IgzDyjJvchlcYZXRcHp1FeFV4mw0ZuhF3l03t6XSf5HuUsmxUqN+X3d/l95ojQ9YxxZ3n/gPL/hS/wBhax/z6Xn/AIDy/wCFaq6VdKoWPTrUKBhR56Djtxs4+lO/sy9/6B9t/wCBCf8AxuvM/wBasX/z4/GX/wAgdP8Aq5R/nf3R/wDkj//T/aCDxnBk7ZCADzmse98e2sWQrMzZ4PavjYeONWKnbnn/AGqb/wAJjMRmdSW/3+P5V/pdHgWSeuvoz+QqnFMH8LPrSP4gQiQtKxWqp+IWmMGWZmYknntXyyPErON0mQDyOc/0pINWhbcUy3c/NiuuHCkF0f3nNLiFvZo9/l1571XC9Og5rIlu40YJKWzjt71wNprVuCPJ4BYZyev6VuyXvmOG27vfPT9K2/shR0Sf3kfX1L7Rui+thIFXfmtW3ujHKHfO0D1rkY3aR9qKN3oTWnZx3TSbWU/dPGawnhacdzSnXvsd3aagqDeCVyOpNEt7bY3bh17VzkS30jCMplew9P0rbi0K7nfYo+vHSvGxHsU3JSO+kpvZE0KQyHcueDWjFGTICucA8n0rcsvB+pxMhuVwvA3f/Wrp4vDggCpH+8LOOnTPTmvPrZhTgrpnXClO/vGTaxStENqnk8N2rUvdQtvD9ot7dQX0+6QRGOwtpLlwSM5KRgkD3rm/iPqPjnw14Rn1L4c6faatqMEkE4tpn/dzWm8NMVVWDEmPO0qSc9Aa5T4H/H7SfH+q3Ph7xCLbR/EEbfaYLOVZbW2vNPlz9lmt5587iw+R1OGVgeK+NzDPaSn7OWl9U+h9Vg8irSpKuleK37r5b/gdDrnx90jw5r+i+F9L0XU7q/1cXlz5N9ZXloIrOwiDzTErDIzfOyIAB1brU/gD4zy6/wDGfVfD1vbiaHUPD2majpWnNetBh0MiTmJbqKMln4YqoyRzVew8S68nx31rSvF9hqmm3M3gNI9EbT8XaxWqzv8A2i8csbJIZFlaBvlTlQOK5Dw74w+FvxL8H2GuePTF/bWmsmk6te3scmn3sN9ZMUjmeQ7Xg8wDfEXJBBOMjIr4DGfWK8+b2tl9y/yPrVTp06cbUl67v1+XY7T41eI/ENx8QvBR1HwvrVrpWh68dXvdaiMN1AA1nPDGnlwkyZDyDJxwK6iXxb8LfjL4euvCi6nYarazKu+2lkCSwSjlX8uXDpJG3IOMgivK77X/AIx/DGKG61XUx4q0ia8R7DU2EKrLC7Y+xz3sYRba6GQIZnVoZj8reUSDXS+NPD2jfE3SH+I3w5s9K1TV0haz1LRNWheJdRSIFZNO1JdrNa3CEFEnK742/vIaVOvOKkoq77NL8HsQ8PRm46uPaSvZvzW6XofNFn4K0ybxz/wyR8R0ttZfVtPl1XStWtlEciQ27h08+PIDB36w88glflPHvXw7+MXjrRhd/Djxzo17M3hy4W0nvdPUzPBYmPdbTS2+PNNu2Nkc0YYfwtgrz4j8GtC1IaRN4H+JkMTR+IbyNtP8VPPJHqOj67Zptj0edJA7o9qCVtJi6iZAcrlufYPEy/EjxDdBfD5s7f4m+CE8y3Jk+z2viDS5nVZBvIOILoKMpz9nugvbBaaU0pOdNJNP+rndWinDkq+8r+l33X69ty94ujtP2oPg7Dr3gKWJ5VlF/ol6hkjuIL60kKtbSnCSRF8NE6npnOOK8Osvi7r3inx74e1O6N1feBdA1NNM12bUl23Gl+I7qMxwwyvgCeCzk+RnYbld0PSra+J7HVPHvjT9oj4JpdX11o0GmprPh+M+RPqWpLDI1/aToTt+2wKY1yefMQj+LNe6fBfwx4M8X/A6Pw9qk1vrMWqw3D+J7mBN8keo6jma4WRQcxzRllG04IK10RfPUjUas1+PyPNry9jRnFPmXRfy33+XmeceONF8YeAv2oYvG1jE982p+Gt1rpRVR572B8vURbE5xqCxNG8ZI/eQBoxggE/UGnz+HviJ4Xi1bSbw3+mapayWxkGBuikUxypIMZVlyQ6nkEYNfMUWp+K/iV8Kbzw/oUltqXjf4ZeIzYtcDaouNR0vaYnkwxKvf2EmGUn/AFhJPSrnjrUbyDwXqnxg+CM95aQ6hJFZ+MNGgtDLdQ+aQtxNHCCGttRhXcCzDy2HzNyAx6vrsqPNNaqWljkwuEhiXTpz92V93t93ocL+xv4Niuf2e/EvwR1pxHqdhrOvfD271aBy7XMEBdLJw/XbHFKgCg4Urxisbxr4p+JHhv8AZG0T4v8AhnV5prqz0fToI/E1w2NU0jdNFbahBeEj/SrQnedw/eRsAcHrXpHwO1htK8f+JLb9lzTLTUvDclvo10l7qN21vZaRqccTxzR3MaI89xczIEldY8Bm5aQZzXVfAn4UnUl13Svia51q78NeMb5NPtJlMGlRQXZF/BNDp6OyAnzsgytKR2Iry5Yb6zQjBaW0v+h7taboVK062srpqLTvbXr26+Zzuu658I1X4f6Tq9vZ6PeR+JrdNSWafzYtZtLuCQrc/azgXluZQr7mztbAYA19dfEDXLzwLpln4mt9LfVNLFyy6rcadiWezscEJcxwJ/rYYyCZQDuVcFQcGvlf9oLStL+Gs/hfxsZrWx0FPHumy6/pt7EslnH9pZ4muLYkf6MZCwWZMGN1OSARmvpGy8BQfDmym1f4d38Ph7S7Qy3s+m6pifQWidt+5XLrJabixIkicoAf9W1Y0oYijCdK/vLr1scN8PXdKV7p9NbJ9jwrTvB+kfFP4p+Mda0u9hZLOHQYPD+u6fjzId9s85kjcZDKwcb0PDDg1RvPE0niL4N3/wAVplis9U8MtqsMeqW4Hk3a6a7JMpiPBtbop80ZJwehyBXe/sn2/hvxUPiL4p8P2VlZ22pfEG6jig0Sb7VZs9pbwxTvDNGiKySSbmBCL16da8j8deH9Ls9HP7G+pXMP2vXNYhTTTZTrHJe+H7m7NzftKoJaK5t13I443gh16EDshmkPZwlUWrv/AMAzjgJKrNR3jt6ddTZk0LS/htpmm/GmTSbTRbS/0m31DxXpFyyt/ZbXUa3Ek9nuP/LGSUpMqgBlww5XB439oz4yaZ/wqi80j4ZXdr4i1bxFdReGdH8mOSe0FxfnYJJZAvl7I1y5+btXqPxS+CHgzXvFHhn4XaBpenm81e8bXvEF9dL9ruodB0h1l8ovOXYC6u3hjyrDIVsdSB1F7pereO/jq1jdxiXSvAVspSCMmOFtb1BOF2n5f9Gt85HGC1d2GxtRuUOZRj1W/wDwxzzp0ko1JJylrvovLY+PPiP4K0f4aT/CT4beCLiWXxsNbjsdLuraRUmurdI9+s3c2/cNh6qWzgkDpX1JN4A8Q6prUl94n0jTrqKNQLUatqk93LlW5PlRxrCPbaDXi3jbxBptpcr+2frU76bpXhLXI9E0GDZ8up6JdXAtNUVOMtNezlHtgDyLcAcOSPa/iF8Utc8IfD/TNV160trDxX4luCvh/wANR+bdy28NwWaB72OENIGt7fDzsECmT5FHOaulj6f1mzvp/XS/zOyvhsVPCUoU6SlZtt21u916JLQl1HVfEFxfz6Dptzp0dzppha9trKynuWgSRSVQksiq20fhx610ceqRxNvew1aRQR8ohQcfTzK+bLxT8OvF/gpdM0zUL2+utXnsLy+1XbZ3GtJqUTNezfZh5twI4pFSYsyqI1ULnOBXb+L/ABzqlx4gT4c6b4i0nw5eF4r3U9Skt4YRY2JZgI7f7TJNJc3M+wqgEaKqhpG/hU+th8zl73K20vLTX8Ty6uWRk480Y3a31b03dl06dD6K027n1UlY7G7tY1wf9KRQZB6LtZiaq6g7wTBbcBcce4zXCT3HhjVdbdLH+3b+XytglZ7xbRkA5O9UiiLHr8q/lXl2i/FDT5NZ8S+EmYTHQ9UjhtYNIt5buUQTQBxGRArZcOrA7mznivYwOMlJqdRWieJjcFBqSpXbXZaW/NHuMtyTJumO4jjnrQNTtk4JOemBXlOg/ELwj4l1qTw7ptzdpeRweaUvLaS3XzARut/Mc7TcKp3NEpLKAcgV1kNte3SPNtYqpO7jOAO5xX1GGqYarrGR85iFVoy9nOOr+ZLqGpmNjIMgGsGS+DxFY88jv61JqbtHtS6R40blJGBCsB97bkDOO9cbbeK9JPiMeE7kSW15Kok09bxBFDf4Xcy2s2Sruo+8hw/cKRzXpzqwpwTvpsvX1OeEJVZOC3R0DBgm5ifepU8+dPKBZieAB3xXL6lo/jGO2vX0jXnguJEma1i1KxhvVhlYExhPKa2cBTjG4t7g1zHgbx14v8ZfDPw/4xn8P2d/DqXh+zurm5sNSCzGd4gLjfbXFvEnMgbOJsZ4HavNrZtOnPkdJ+uj/LU6o5Sp0lUp1Vvtrf8Ay+9m/wCLPE+l+E7W3n1bzx9pv7fTbeOBN8kk902I1VcjPGSTnAAJq1r11d2Wj3l7pNt/aF1a2Vxc29iX8sXEsUbOsYcA7dxAGcGvnrTdC1e7+LNlD4QhlsLXw9pr6pp3hfxCSkN7eXIaKdrV0km8kQRnh0aRFZgSgXmvoHSfFOnQywLr8UmizNKim21fEMe9uPLS5BNvJkjAw4JH8I6UYfN/ae0jP3V06a/mj0a+QSjKlGi3N2u7K7/4KXdX8zn9I1Z/FnhPTfFHhyaO3GsaRFf2csqidYnuIgy5XgNsc4b6GnfD7xHe67oMsfiWOO31rTJTpusWsOV2zquVlT0jnX54z6cdq5D4KaZJ4V03W/hVeTm7uPC3iC7t4ZMBc6fqDG+tMBdy4RJjHwcfLWR8bNYb4WS2nxa8NKl5qrf8SSXSNrkapDIrOoKx5ctaEebv7Rqw4zWlXFtUI1+267o5MHg4Srzws1aUvhb6dfncmudf1b4TapY6Z4zvLi+8Panem107X7nc9xpkzBnW3v3GQ1ueQlwcbeFfqDTZntvjNrB2uJfCenXGGwQY9duoW6qx62cLDqMiRx/dFevm8TV9Ijmeaxki1CxgmkeMn7FNFPGrMVVy2YXGSoYn5Tg5Oa+PPi3q5+CHhVPAq3EcPhvxJcxaTo1yhaWTQLeQ+ZdFBECXsxCG2Y5iZgM4xXPirUaanKd6b1t1S/y7nrZNhJ15TjTjaqvtdPl/ett3PR/FWsad8R01HT7e8Gn+DtNL/wDCRa4snlLdtH8r2NtJwFizxPKO3yLySa6K21rxJ4hgi0z4d2sdhZeUI4da1WMpEIo1wgtbRtruFAwGkKpjmsHQdIlv5bPXNesGsPDmmRx/8I14fulVI/KhGIb+8j4AbHzxQt9zO9ssflh1n4gR61eNa6VcIltPa3c0+q6iu6x8iEYlcQsjeauGxuZkjycbieK6J4etOHtV1Wnn/kjkpKjGtGnFap63T080urf4dDXi8F2Gnaius6gZ9Y1cLhNWvmEjBT18lAPLiX/c/OszUfEWh6TpzeI7u7ils0hlu5biNw6iO3J8zn1BVga+S/Dmra1Br+ieALjVPEOneGEa51Cx1ceZb32vQB9sFuIo2YW1pCxCklBJIu3hByfXPi7p99rWgeHPhh4dvFnh192S6tmeIouiaYqzXLiXadn3Ut8MvLSDJ6125bnlouMaPuxfLa6u316ndnORTjX5JVueS15knypfdoVvh9rOs23w9Pi/4jXbtPq15PrYWTdttbe9k3W1lGufvJGVG1erZ4rJv/iBMfide+EtGY6g93a2d7ptjLIwOniOMrd/aDtIhjQFXMa7n56Vc8TWV/40+I2m+GtIW8k+yWf9satax7YJbKxXMKLbPGWiL3MnWTKsqKQpGa43SPH/AIL1D42/8Il4KhvLtfCMRj03SvD1r5sZ1O/BW5kuLoMIY/IiyreZJlnbODiox+cU26dOFR05U27Ldu+9kduWcPwpKtVr0vaxkru2lr7XfTtbqen6F4itZ9EsrvxGmxLtWaHVIIyLedRIyAlAzFWGMdckDJAJrzHwv8Rrrx3LdSaQPJsYNUu7ayksbd3urq2tpNgLPJiOMuwPzHnb0WnzeI9YsPgZeeLbxLeys7fQtWETRM91OjrLPDvnc7I/vsF2KpA4O41y0fij/hV3w+8KfDKygFzrWnaZp2mf2fcTgwo90FxcSyrxtYvv8sASkcYA+avVwmJdJ0XicTL2U03aXxN9Nv1OOjhsPiKdWWCw6jKLS02S6t3O31HxHrnhVtQm+Ik1rpkUt0s2jGGNJbnVFuSfKs4YshfOhIPmMMrs+ckYNd9BNaXkUtzfIumi3h8+QTj7TIiKm+UkRkR4Tk5B5AzivAfiBr3w/wBB1R9N13U7u48VaPK+pyan9hWSaS9gttthZWKeYwjtp57mNJEKhSuQ7NnNaer2vj9vCHijRfHd5Y6WT4VE/wDYHh/zEtLCa/mEKQ/bZHMs/wApYsuEjUHCqRivOocR41VcRh6UZTtpHW1v8Ta1Xoey8iwvJRqtpPrdav8Awq/XzZ6jNr3hjUfEFt4C0CZ9f1CaJr+SZXZLS2hCb1eURjaMgqAuckkA4zW0dPIDWovZrua0jRzLEAkVnJLlUZYxuUONpKhyTkdu3kEOpX9h8QbnwTokLyQroVvpel6fY3CRQST2e1bmS6MeHgtYt6sSuGlYFRkkVu/EK6g+BvgS4vPNS/8AEviBotP0lYogkl7euWWKO3gBIitoCWcDnn75ZiWr08uzifLP61JSUXra6T9PM5MypS92OGXJKUVy2+JJ732smv8AJNnVeH7jUfEuo3XhOxazm1PSpo7XUL8lmt23puWVUUA7v76EgKwPJFcZpN3rl/47tdU0i8uNRsY9Sk8P+QE8uCRHjdr25wdsaqoXZDlic5b0rzxvD/iXwP8AChfhvrV7ca3qwiXVNfe3CK3n3cgMWnwKioZZbhsxq8jOVTc+MYFen3njtLjxboM+ixNYaNpUEw1K7vEeWDTby6s5FtbCVEMfmSjDgEFFBC5+8AeStnFSc/Z1pOFtdbO+uivsn5P7zseXUoym8Phvac11zXairbtq2qe52uk2mqa6RqdrJayWt3ua1W03SrsBI3mY4yT0wBiqd7CNNkK6jJBbY+bNxIqZA78n+lUfBuntrfh9LvWJp7eKSSVtP0qEptFq8peLzQgESSsDl1UMQSAWyDUf9p+GdISKXw5a2d3eX29LKK3hAlmELFJHklcbo4o2B3yEYGPlBOK+7y7OMUoR5ocqezbu38ldfifH1cmw1O1OFZVJv+XZLs72atqPtr/Sbye+t4bq1mW0khjWS0dpzJ5ybgSiKSmGygyfmIJFM0mbS9asf7R0m+guI1lkglCBt0TxEq6yjHyMCMYbB9qsaVHd2UuoXmpSxahevZQXU9xMCVV4zLtjgjb5RHEFOwsu4ksxPOBStwyX1l4xt7WCO41ya0g1iyQm3tpZp4srOWAYRvGFxkg7xx6GppZvmFKXNVmuRb6anbQwODrTUI03zSWl7qN7X3t28i8UjMnkQkXD4yEiOWOOTx7DrWHcLdxHzpLPehkAeGWQxSYbBG0hSOhPXFdd41jn0TwjrFxMFt/MtJbezECMJN5QriOVpA5c5zlUwBz05rxrwb8QvFzeKPDXwVuwNRv3PlX3iCa2SG2vdKitg4uLd5N7mYS/unLZQsp25DDHNn/H8cJFRnRbhK3vJpNF4DhJ1lKpGouZdLSaa7q6TdnvY9R0+3vJL6awWG/gtordbjzvlmj5P3fkbOQevFcZ4htfDGqTwarb6za6ZrFs3l2N3fK0Cvk5NvMsoUPE+MEZ+X7y8itX4npqPgu6srzSlluAmtWEEkF0r2bPHPL5TKs6KIpF+bIDR475rUuryfSryaz8RGWyZTsMGrFI7cAttA88F4GJzkBirH0zXLSz9YicoPE8idrKUdH6SXU78Pl9ShGMXQUmm72crad011+Z5tN4i1RZmW50rxD5gYiT7FfxPb7s8+U24Zjz9045GKj/AOEjvv8AoE+K/wDwNh/+Kr046BGx3f2IsuefNS1hKv8A7QPlHIPUc0n/AAj0f/QA/wDJSH/4zXp/2FW/5/xI/taP/PmP3v8AyP/U9jtdSdbYE8A9s1bhuHmlCEAAjOc1y0kDO6levat21iM7LFICM9fwr/YqdOPY/wA9qdWWxorPLM7x54TpWrprmKNpACckDA/nVa006NXbymyBxljXSWkSxr5aqB2LeprkquPQ7aUHfU6BLcRIjR5bdg4rrLRNirGg25bmsjS2gA2zSBNpAUHjNdIoYTLJCpO0183iJNNtrRns4eCbR1um2ADLG2W3YzkYr0PTdKsw+7g7l6AdK4/T7mZtrSKARjHFdppN5HbOXfhu4r4zMnUs0j6nCxilod54Z0Wydz56ADqD616fZ6FpEOVijHufWvNrC/WXD2nzHGDXd6XqrR/Lc4xgYz14/CviMd7Tmbb1Pp8J7PsaU2nebGY4SBmvLviPofiSTwTqkPhtit+bGRrTI/1zp8xiz28wApkcgnjmvXH8SadZB3xEAqF2Z+cAdT+FfG/i34qR/DTxuPHWsaxean4V8S39rA26J2TQrwqUiljIUE2lxkKwxlZNpGQTj5vE4105ctV2T6s9rDYKVWdqMOaXaxxOo+L/AA78HtBtvF9hq/ie3+H17Z2s+lJpSpdvpD3RVgJkkQv9nIPXP7pgykYIrktd8L+KPhlpdv4w8C+Z4002a6lW/tiUuINQ0/U5N9wkkGChVMiRGhxtIPyHNeu+HfBvjLw14dvrMNoOvaRJeajJBbCd4YJLe6kaYQJP5biPBJUo4IHUHtXxx8F/EfiT4X65c+DfHtmfDt3cXjT+EtJ1LUBYLPDMxP2O0u5lNtPIn8AkVPMHRh0r53HwowivdfK/w80/xPscqoVp06suZKSV7bcy7PZ6eSdzvbvwB41vTomrfs2+Jf8AhHYNIuLi5XwrqqC/t5o5l23FvYXErrlHwC0HBBAwFI56DSPjJ8V/H8l7Z2GgafH4g8ORCG6XwvIbPV7a1uWIiV4LgGKeI7WzG4wT02nk+i+JPBEfxhttT08QSWt/Gge7t7NBp2sRuFDRS3FhK3kzhHGVmilUseQ2OK8X8B+IJ/iF8d9XuvEcd74V8T6NoFt4ai1q42xW+pXFhcP50sQYiOcMrKXgY7lzww614SwsZTtKTSf3P1vpf7j1aeY82EnGMFOcd39qKXTo3F9d/M7eLwR4B+JWnXul3934SkluZW8yBLK40HU4LrAd0vYIZTFJLvUFlaNlcDoRVXwR448VeEfFd94I+JGkgRaTpFjenxn4cvJYp7KC4lkhiMuV81rMtGdqSbzDtI5QjHtOtfD/AEXxjcr4f+Ldn/Zet3sDQ6fq+nSbLbVFiUlTaykMPPQc+U37xf4SRXnPwx8T/EzRv2jPiB4M8VaLFqsg03Q7/Tb7eLS7vtFtrYWzt5MimKVlmZ2cB+TIcgdK7a2HoQlCe77r8mv1Rx4XFznhqqpU9FG/LLo7pcyl1WuzQ67vZ4viV4g/4Ta6/trwi2nW2hax4hjKo63l1ie3M4iUJKlvHgLcqFeMsM5HTO/ah0T4haH/AMK4k8OyWut6tZeNrJtF1G6iD6jtFvK8ttIq/u547pIwrSAoQcPhiBXXR6p8L/gVrOqafFK1r4Pvwb3V9G16CW3l0u7um/eTQROu24tJM4dY2YxYGAVrQ+Imk2KWHhjxj8Ir6LWdF8IeILbxFqWhx3KyQrp62s0TTWsuDMmwTK/lFWGwEjGK0qTpxTlF2fktTz5U6zxEZqKlBWV3s32v/kdL4I8Y+C/iA8niXwEuq+C9d1C4/wCJla6rarbwXGoRKFkhu4Cdks8ZG3dlJSoBGQRWhrOp6fpN/reu6/bL4b8UaFpM3iG8vdJkAj1a1XgSKjLicbwqOkwLIWGDzms/xN4i8DW2uz+J9WRrKHUoYIvFfh/VYxi7tkVTbataOP3dwYEYB3iYkxtnIK1U+PvwJ8W6/wCDtLn8GSt4gGkahb6tbaPNcrBezaerLJcWsF0QwubeaIf6pwGyFwTXPHEJQbbvbX5f12G8K51IztyqWyfdPb09Tzv4SXPiH4TapoWo+Mrc22s6xAumeO7YBfLnudYnfULHWYs43+VK7WUox+73Kh4xX0D8ZLW90mztfEng2aS08bajcxaFoF5YKqySs+S4uozlZYIEBkbeDt4wRmtzx94U+F/7WnwmS58Ha8r/ANoCeTQPEdnhrjT75CCVkjOCCkoUTQv3A7gV4/8As+fFPRfjb8S7zWfFEtrp3iDw5YnwimhXwMU0+r25C6veW2/aGDOqqNuSFPOM1UcRSUFBrSeqf5/iZ1YVKtSVdK04bq33aHXRfs46r8KbWPxH8Ap1tNdtlM+pW9wf3GuSyv5lzJKCQoklcs2Pu844IzVH9n34teHfH/xu8ZaDaJd6frE2h6Pq2r6VPGM21zA0li6qSBkMI0I6MBjNfbFt/ZxUwSRNFLEcPFIp3Kfoa+Lf2kvDni3wz8efAOsfAi2ht9c8badrvhvxBcuFia5stOiguo41cg/6Sqs4gc9Cfm4FRj+TBJVqe91p02OrLcRPMG6GId59JPdeT7rouxk/tG+IvFvjifSfCPgb7CdF0nxzotp4h1W+gFxG93JPtW0gjBUOYyd0xJwMBO5rqtE+EuhfCvxXp+mfEq4u/FHhiW6SPQ7/AFsiS20G8ZyY7eSyGIFtpPuwSkExNtjPBBHceNda+ASfBfwdF4NubW1t18caFpdvpkr/AOnC/t7xftME0f32uEO4ynBzy3Svq7xZY+DLnS9TbXI0k0u3tbqa+gdcpLBHGzvGQe21T+QrgjiPb+0q/at/SM1TlSSoy0i/LX5Hwl8HvAmpeMvCmreJvEl/qwtNY8aeIL5dKtbo2VsIRfywxEi2CtIrJGpwzYqx4xs/Bvw4+KHgy2uILDQtEsLfV9fFxHEkaXV9Db+RFDkAvLMFmeQD5mIU1m/sq6BrnhD9mvwL4n8BrPqGla1oMWt3fh6ebzJAl673KPZSOSVkRHAaJvlfsQ1YWj2ulftGw+Jviz4Pumub/RNfksPAkl6jx/YL7RFXzU8qTHlmaZmimJG7HFdmDxcZ0Yx9naf5kVMPatKq6jUFpdaWvt95z3xV8f8AjvQPFS/tA3FjP4b8FWmjHRdZuIiU1u/sZ5TNFOIipFrGs4Rc5MmyUnAxXp2gfDnXvC/7K+oeE/CF9JbeIdR0W+1We9MrXM/27UVMsnzyEs7rG2xWYnkCq2s+ItM/aKTwr4DkhdLHWfO8R+LNPnJEtvaaUfInsJOM7vt7iJs/eEea1NK+I/8AwrP4Oate+JIJLvUfBlxLoMkNuheW6kiO2wSNRlnadCmABk8+ldkKcHUk57NficssXU9hToU1q3+R47qPwZ8Oy+Jfgx4qk17Xr3RG0u50nSZftAiEWpSWCtYsUCmODCRTxgxqreaR82TXv+qH4ffBfw/NrmqWsNiCQA4YPqOoXLDEcaySEzTzStwMk88npXz69l4803wN8NfhzaW0uiSap4xtp57nVCJNQN3sutSuGtbLG2GKKRdq+c+Qp+7VjwT4IsfiF8Sofi3c2cl/Y6JPc2vhy7vpGurjUb/OyfVQ7YVIlw0VuqoBjc4PIrfKqM4ztRgrvr1RnmF1CMq1ZtR6La+ll6l+XU73wneH4geJ5FuvGev407TtGjYMba1z5y2Sv95Yogu+7m4BI56AVynwVuf7P0K5+K/xIvNNl1/xpqc96t+FjjaTTYZGi02CBOZFgSFdyKeTv3HJNSfFXxbpGh/F2ae4jS4mb4e69ZyLYwPeXEFwXhdFkMG7yvMUNyxGQDmvKPDut63F+zT4F8Q+DLCw0CbXPD+iiSeBkOqX5mtEZ7bSkjWV4pHABEkjYiQFiM4r6GVX2dZWV+VaadX6blYXD1q+ElOckoyaTfMk7a2W97Wv8zrfHHxg8afEEX2heAr+LSdD0+ZoNU8Q6kjmJjygjXaQ53HhY0PmSf7I68z8LJdYuNC13SYD/Y+npfDT7zUJIPst5cPbxq8k80m8+VD5b4WLgqp5I5rf0WwvtC8c6H4c1XQbG026VcX3hm0ub55raw1C0AaZJAsW25uSCZGnY7nGcAda+G/ib468TeK/2YbnxFqmu6ZcTeK9VvSND04yqBcNeMl3cXrAeY8SiIRpGNqfOMselOg2qrqV6bba2eif3feelhqcXH6ngJRXNKKUk+aV+rV/zPsb4THSvGHiyLxroWrT3WnQeHTN4XuLu3gs4rOznuHgAECqQBcSxNIZAQ5iCjua7dfH1/4v8H6hp0kP2fxDpLR3OoaSLorM0YlCfaLaSFkZo5FyYzjIPDDNcv4L034a/s2eA7RteS9n0zytM0fV9Vl2TIsyoIoY0iVgVXexCqgbjJOa4/Wp/A/x08LXXiTwrZWmlT2v2mSfULgAanaG1ZkZEtl2zTK+ACHCr8w7gVvTdehP2V487V3Hv872TPNqYejjKXt4Tm1zK83FJJ3s31cvkj2fQNM8UaJ8UPGhS8XULeK30BobbXA0u1ZLe4wsc8W1kOAMkq27vWNq/jPw3rM6eDvFGkPJdXWoR2K6D54dpAQXW9tp9q/uURS4lChkPy8E14lb6pq2neF/+Et8J395ZeLvDdx4f0/xL4QeCJLi9tp5Ikj3yGVkkyrkxyFV2ljG4BOR3Wg2PiD4v65dfGvwdHLBf6PeTaF4XttTAtHCwOV1CO7g+YxfaZVKbDyoVWHWtMurzUZwho30veNvK+zR5GZYaFOcas5qShppGzv0v3T2PYtEuvEfwvsVi8cXlxr2kLLtg1+KEG8tB5nypeRLnzIlX5ROvzAcsO9ef/DDT9NHwfXw1/a8linhvxJr9nb6nY3XlRQxWWo3JjcnmOSNYHUEMCuK9X8Na/D420Jdfsp5LV1la1v9MUbZLO7hO2a3l75VsjOAGXBHBr5P1HRNIi+OU3wWsEW28C61qkV9rzQQ4tofERgFyNHV+iLfxoLmZR/EhT/lpXv43mpwjVUuaMtLdU+ny7nkYKEcRGrTqJwrR96/SSW/z7Hs/jXxfoVrp1lonj66+zA/6fo/j/RYWlsrWRBxNchQRblwQDhjG6kggZrqPBXxS0Tx3cXXw7uLq1Ov6YkS6np4dVgvY5B+7urZJMeZDKACy4JjJKnPBPaa/a+HdR8OanpN4yvpb2E9vfw2oGRbMhRlRBgcZ4HavjtbG3+J3wZli8a2UV14q+F81/p1tq0myWUSaVCXt2LAq5ju7TYsik85JByBXLPDYjD1k6FVSurtPr5XLoYyhicO41YOKUkk10vu/I9SvtBj+HXx0tdD0lpvD3/CU6Fdta2+jAJa/bdOlEszy2xUxsZIn5fAyBjvVPw/4nv5/jtquk+LksbzU7TRbeXQ7uBDaQCzkwdQUI++P7SBtMhB/wBX0wM14d4p17WLf4Y+G/jvo0s9vrtm1h4pg8Darcl5P7NvUSKa0t7uZC4jijuA5OWBOM4xVrxloVx8bfhbq3xL+Fq3z+INN8QXN1pdhBtjnZ7JRFcWFyGOAZYi6Yx8wIIyK83CShVqN/DU+JRv06/1qfSYzB4qhFOo1Upyjy87Xwu+nnsdFpGowR+GbrwReW1+2j6T8RdX0S/nV1aKDTBOLu0T5eREXlQHHAXgcGvmz4vB7X/hOfFOgssvh7TUHg6wAYzW8Op3FzE19dQDkpGzEQsyE4IPGDivo7VPHNz4a8AH4neE/wBwfiHcxtpvhu+jAtrrU7uEW0kMV4uRDJbeTm5ilUACNuVOK+cfG1pofwv+DF5+znqt1dC6A0680211OMwXbzXV/G13CWQssyPIS0boxDL9K6auY3pxoN6a6269Ne19/wATty7J5WnjqcrNNOUb6cqau0u/59D6W1ddC17xjZeCrmQWySW76tqTS3BntL7+zQmLaHdkKN5DyqwHyLjHNea+IrG68T/GnRfBuvPZOl1JL4gZ4j/o02m6dbAQ25Xdji9m3smcMQrY4rrNZ1nxNZa3N4Z8Fra3F9pscl/p+oXMYeXUTAF8/R45MDEu3MUsoLNt28Z3Y8R1TUtIi8e6n8fPhTAmoNpmgaTpFlol0oZNRn12SSVrV2271uIAqNgKW/dkEgZr15YrG04ShKKaXLrtf+bT9DlxOAw9Sq4uVnZ/Ju7jdrZ2Nvx+3iePx1rfjq3iFzoHhiwh0XUp7LMwtLm5xdPepu+dDbuIlkVcgqTzxWboF1pnxB8YS/tO2qO2nWaW2ixOqBkfTFt2fV5wufn2XDR5I5Igx7V03iPWvh38E/gNf3y3Vrf3+sWEs99BE0gub+/1A7GM0W5THF5jhCXGFUAZrzr4QeDLzR/h9afsxeGpZNb0WzszcXOvwCSK2lFxKDeWVozZZrdbpijzjJbO1R3GeHlKGMTup83v2W6fTXQipCnUwkYVG6Lj7rvdRcVu+rf9WMDW9P1nVtH034rWM90dY8f3lxpVnYwP5sVrb7c6bHNC2CghgUzPuBG5jwOtfRHw98G6Z8N4dS8G+GWSzsdMfTtTu7rMdvHPPLC4mupWwAWkkUk5PevIdd1fTdV+JE3xJtrqPU73wnex+Gba4DCCyg84+Td3F7tysMETERQj5nbYfXIj+Kms+ErO11rXdS1mw1u/0KS2tmkvJVSDVdTunWK0s4YDmJbRXcGRjuJA6jki6Gf4PBzqYmEqbxEb6trbr5trrY3zLAOu4YWnUkqdRK7sltt1Wi/E5LxzcxeMfgVP8JfBl/c6i0TX+oeNLzTWQx6fpi6jLPDAkhG2Se6ZV+VclUDGvYZNB8Uade+EXn0/TBpFrqbahFo6s8ESM1q32a51C7k8x3kaQg5wAO59PPPB/wAQPDn7PTeJPht8XNU0U+L4fEmq6n4ng0VN/wBqvZpd5Hlgjy0hhZQi8q0WCvcV498QP26Pg+kknhLT01A+EWiJ8UKkYWYhv9Xp9icsc3LEeahOUTJHt8pmXHeTUovEZjmUXWkvhX2b7OyPQpUZzbwdCj7kGvete6+0/JvzPUvhTrelePPiv4vv4/NbTdL1u01XW9XvVUo17FZxxWlvvAG+3hk82VAvykrGwGa2LnWJtU8FeJYPC1jDq+t+Lor/AFSwhnlZI4tOjjNvazTEglFaONXRByxOQK+Jvh3+0p4O+HOo2mvfZrJb3xb4cvbjT9Ivbhjb2Gp2VxstZ7pQp8yGG1kMcGFJ3KiDnkfoJoHjv4GfDD4U6jrPw48S2Oq/2dbpHLZ3DN/aOq3yARkKjru2KwJP8McIz0Fehwx4tZNWw0oVMbThFuV5X33St1vb5GHEeTRo1VKcHKTcVGK10sr/AI/8A5L4NeFPA+g+DPDPxbtbpdN1Ge0fT/FeuEJcJO8zeRM0lzKwVFinAYHado7U/ZqVr8QtQ+Ker2FxNo/hcJaeEBc3Cr/aWoXreTJeyzOHkeRw3lWyBcKjFhjPHi3wo8JfA34r6JJoXj3xXo/2W41KbU5dNLvBazX92/mH7IrABbVH+6eGlYcAA5r6Yh8bR3eqXvhi4tmv/EXhGxkE1ta7WtzqcoMUGp3Ej4jjhWEq0QZtzO7KgJSurJeKMLjb1aWIjGm7cqjJSlKS6tdF5WN8XlajzSh7823zN3SinqkktXrpd6LojP0zQPFV/wCOikur2z2mi6nc6lqlwIGydau1+VPNDruSzgbYGJADdqjTR18cXt58JLN9UvfD7auupX17YySZkjk2SmOBVIj8ySZOZ5GbCKcAmsXTPB3xSg0fRvCWqazYTJNKIvsCaZsF05bzLu7uzK/mFPmJZnUEkgKveuw8Wam/hL4jQ+CfCdoNb1G90e2XRNLdjb2kAtrgieWb5mMcIiY84Xj6Gt8wwmJqQlXjhHFr7UpfF6R6GmU061aq6UcT391LpFXbu/L8DovEHjvU/h5apaa/ZxrJHFIbB2xPJqA3lF3JEEjgkiZlDjDB+q4ycctpei658Nvhpc+KNfMFxrOp6mJbm+lASGH7dPiGKZlOBHDu5VRj055r0DwP4C8K2EF5rsqaRqOqzO9xf6jEjXsUQcnEUckzhFijA2rgdBuPJrjtcvtV8eazY6V4R0j+0rCy1G2uzexSoLW7khO4GOBVG+CJhmQgHdjAI617WBzDG4SnSxGIUV0S5rtedvTyOSLy/FqeDwkUnK7lKMb3a210tfsrtu5DHavcw3WveID5OmylJtVu7y4Mc2piNSiqyqrPBbKxHlQp80gPzHBObfiDxPeWfizRL/xBa21n4fuoJ00LQoomuL7ULwRlV+0RSECJChLRjGAPvelUY/GbeMb3VL/wk48yx1JYlnkgY6VZx2+RJdtJH5qMXl3DDNnHAxjdXHafcnxbff8ACMNFqEl3rJe4vfFn7vEgikJtXsZHKpFCxXCjIcrnAbOavM+IMFyOvVqTjBOyv19EtbdjShl+Mc40ZpKbW21vPXRt9exV19fEFlfxWdhLBa3Ty+ffpFcJHZaLpvmKQZkKtCWdwqDCgDJODjNeiTeHFj1WWPXrvQvEGrtErSwhStzcKzb02PG7Kg2KpLuuAFGMDiucuPhzf+G57yy8RX9tpMNxc2k97d3cay6e0cIOEkAJO98nAmcIzEctwKq6xpJ8A+GdTuPCMFzHo3iFXT7Pa27QXuozSqrRjTAA85BGWcuVizlgQOK8ivXxFXnqQw6SS0Td2u1463vv1Omrhk4U4uu2+b3mlpbrqtVqtlvbqdnrulR+M9AvL+7tbiwUXnlS39zbHVLOL7KVdGS5JYKMrg4CDsDXX2769LpAvFXTNQiRVedtJkEUcqykYAtHDZDYBA38+lcHpGg6bomi2kPxA0nUfD2m3NskEK/aZuWKbQl0bRnaaXPLOwABPTiiz8NfZBeax8Np9Pv2RI7KCS3uGiurQquY9k8bHznC/MI5oxkYBYDmvDwWe43BP2j5Yyl8VnK/yjJWXbSxrVy+nWf7ybkl0+z566P5tbmnLqXwkilaK80eaOZWKyxnQpQVcH5hgcDB7Dio/wC1vg3/ANAqX/wRzVQHjOztR9l1T4meL1uY/wB3crJpNqziVeHDFbnBIbOSOPSl/wCE60T/AKKb4s/8E9t/8k16v/EQJf8APqP3HV/Y+H7S+8//1fVQyLF9oB/eLwF7VrW8zbVmkIVmGOmB6VyrNMq7g3Gak+2XR2pvGxeRwM1/sxLA1D/On63G+iPS7URCMhW3Hqw9M10sKK+O30ryay1VxPgudzZ7dq7m2v55AvlsQVPz5FebjcFKGtz0aGJvY7sQRPIqoxJBBHvXbROsMA9QM4/pXnEF6pKzREjaeeK24dbeVgGAABwSa+axVCU0rM93DYmC3PTrPUZ5WWKIL05GM11loweUAcsOCPrXlumapDHOGRs5yOK7LT55I5zc7wATketfOY7Cu9nue1hMUnbseq6De3VoxURHHTLZArqJdSu7pQrvwucDFcNY+LYLaPbId3Herx8V2U4OBg9eK+WqZdJzu1c+gpYtJWua5vr6SOaBGjBlheFWkBCqzDAJ2849cc18jyfCnw74w8Lj4Z+KLvXtH1RfO+z2Oq6vdano9/dRESRTRv5sbja4V0j8yOSIH5VPUfTaarbON3TnPvXyV8VxDo3i5/FHi+1vbmWe6ifwm+meWmltdxKQg1JXyokXcxM0vyhfu818lxNkkJpTlFNH1XDOaVlUdGnVcFLqrfq0dJ8StJ+N3hnwzDqfhyO61y7lkjh1G2srsxSvCFw8sF5bg3IIPJS4hnOBzJnk0/G+vXGv/D+PRvGF8fEGhXEcaXun6raWd+kfl/fmhuYVRLho2GSVME64J2kjFdfe/D7w3eaM2m6x4fuf7TtPs011NoerGO+hYoDLJbLlXZASQNhORXl2heAdP+E4m03wr4j06fSdTNyF0XxUTp2o5UBmC3OCsuedwljIJ5zX5nXwPKptfD2u/l6H67Qxlqvs8TX99aKSjFp+d03b12Nm1bxbpfhTYulrql5osY1DwxefapJ7DWLCT7zadqEA+0aZe7QEKsGt5SRmMc43LE+DP2lPCjXXwb1ePT/FVu66lZ6RrMEMOrWdxkGSN5bcwtIsnMcpKSHn5hmvLPBep6p8MtUudK8IxeKLPQpnW41DTdKs454dLinIze2yAuksJkP71YztyQQFPB7nxHa+BYNc/wCF7pYf2/ozXxTXL7S7bytSsZYuF1CJYCxjuIjzIFwXXqMiuCtLD+zbS02s9vvK+rYilO1eXxaxlBxT0fVNP/gnryeG9W8YfD271vw1LBBcXE7Wus+HNazAtvfwcSw+dAuEeNvmjcwFiMEMCa8n+Jl58TdA8L6RqXxSuNT+0eG9bTV/D3imADzY7eZRBc2V4YgUkIjfKyEKsxiXzUDHdXZ+OfHfjn4W+IYvjzKn/CTeBda06Fta13R4nkuhCmEtr2eBchpIwdskgAJTIYAgV7fYfEf4aeI7NnvdVjsrLULbeP7Wgmghu7aYZGDIpjZGB5JPNduGweDnBylP2ctLK90eHJ46liHWrQdehs2vdcfW+z+VjR/tC08WRH4RfF2B01SWyOpWT2e4R6hbqBjUNNY5MUsYZWdAcxk4yVNeFeCD4k8CeLW+HXxr07SJfDF2Hh8N+JrxEKQyB/ktri4AVoTcIflBZVilyqkqwC/P/iv4b2f7Pv7TXgTxn8OfEt1/whmp2HiE2AG7VdK0mZ0h3xMPM+S0bqdh3x46YFfQf7SHjp9V/Z7+KPhnxVbQaTrVh4Ev7pbKCQTWWq2d1D5Vve2kzAebC0jqCMFo225PINefHGxrczqaVYPR/Zkuz/4Y6pYaOHjFU06lCp02afePZx+aZzutaFrXwO8T2XwV1TTIPFPwj8RB7TSPC2pHN7oeoEs0ljbyzF/Otpk3PbqzqwIMauBivQ/2d/F2geHNVu/gFbXq3thpccuqeCrqSJ/tcekK4D6bOkp81LjTnIADHLREHJAr5K+JXhHXv2e/hxp/wx1DWdU1WHwsdJ8R6JFfgXFxqFlYyxmWK3u3P+j3NqzbZVfckkeHGOa+qviH4e0j4veHh8evhPaNZ+OPCMl1daPPMBFcG7tk3TaddIpHnJMhKYPUEMpxWeX1XTqXirOOri9d97Pt2N8wwVKUOWU+eL0U1pZ9HJXfzasef/DW40/9kD9rfxh4XvnmX4c/Ee0PjnTJwDt0rWY5Rb6hwPuwMzq0pH3NysRjJHvk+laFZftEa94E8WaVY6l4b+JOmxeKNJhu1E9v/bmnqsd3JbsPmWSeApNvRgxIJyayPigmtfFP4IaH8fvh6gfVNBSHxlpcCwFvNXyPL1bS5FbIIkgaWJ0OfmRcivDPj7rXiD4R+HPhp8RPh9KdR8N3fjbTNU0GLYXu9Kt7mF3u1tlU/vLRrcnfFkeVjjjisKssNQU6spKVJe8tdUnuv89Tjw/PipRpzlyVrct+krbXf5dGfWWtah4o+EPjLwhaJqdze+GfFHiNfCc9pq5+1T6XPc20sli9vdnbM0LTRCJ45t5G4FWBFeI/tl+PfEXhj4hfCHwv4bRP+EjPjf7bBdOrSWWlWd3ay6a11dopUyRSyuEjj3LudeuAa+sf2rvhr438Rfs5an468I27XVnZWlp410bVrBvOjb+y5o79JUPvGhB54r5S8Y/Br4g/Ev8AZs8R/tb61Zazp8virxNoXibSIJ4x51l4c0a9STT4GycKssUjTuR/G+K5sZxJguR0qVZKMrPV7ImjltZ1PrFWF5Run0TffzNzxJ8ILL9mPxNH+1tp80/iHxYbqHRfGd9rZR5tVtNQmjt99tGF8uzlt2KmIxD5kBRyc5rrv2p/2lLf4c/C/wAfeGfC1ndeJ9e0/wAM6p/aFvpEqfZ9NWSF4xPfXJHlxHLArCCZX6YHJHK/tvaX49+IXhXUfgZ4HZJbm2Oi+I/Gt0zBvsmlXN3EYreMqf8AX3LY291UE16t+2h8Fr/4S/skeJ9L8P6RcaLpTJYWyWtramXf9r1O3jYtsyXd1ZvVj60f27lzlP2FVcrX4+Ru8JiGqM8VFyqX0XRLbX9DyH4G+MdD/Y4+Hth8FvHhn/srT/Dtprfgd5GaaaYyQIt3o8I5ZpIrtsxJnPlOOAFqD9lvwf4n+BfjmP4bePTcQXXxL0658drFOxIs/EZmMmoWakE7i1vKkmAcZhOBSfHP4afFXxD4b1D9pPx9ZX2iap4OuLbVfh9oSxsYrJDMkZkuSQFe5vY22yKB+6UhRkgmvTP23dY1Lw/+z7f/ABm0t7XT/EXhG4tPEfh64mZmKXkn7j7PtX5tswmaM+vHFa4PFxbThK8krrVdS8XLfDyWtR2no9HHa3yOZ+AllompfEf4ofGvRg62WteLm8N6SkLsyTxeH1+zXNwgYnm6vjK7FQAxQE5NeI+DPE+tfGn9tzxrJ4fmlTwd4DTTbTU3QKYdR8VWsbLH2xm1jdgcHlgM19t6H4f8J/srfs66fb3atd2vgzwzB58pGXvNRYCSVs8/Pc3kh98tXzb+yrc2fwV/Zy8Z+Kfi9ZWthqWl+Mdf1PxMlnlfNu5pBcpGoOS0gEixL717Cx1OFShCadtXLz7Hk0Iy9niq/LebtGPl0k/67nln7VnxC8XR/G/4c/BrwZZR3t94hi1OK5uZ7wWv2GG9CRM8spRvKkuLeOeG3I+cl32gkDP0bY+DteudDGmaxqkUNlb4gi8O6Ir2WnW0EK7I4dxYzyqqYBJZAf7gr5/8d+CtQt/2ftd8efEBZf8AhNfH99Y6lZ2tsALm21reJPD+m2zno1ntBcDgDzWOOa+pvEfiXTPB3g+Lxf8AEzi4tbK3a/isENwjXzIqyR24X5m3ykhc9ue1fT5ZKlCpOvXXuWvbt2X+R5OZTrfV8PRw0bzd4treTfVaaJbHzx8X9Qt/ht8Iddt9Ds4LcXWl3lppOn6eqW73l/JbyeXHEnG9urM7k4HJNZfwM8N2fg34c+C9N1WTWn1+18HadawHQz9vfTbX7FAxsnt41AiYMm2VmUmR+pA+UeFfFHXvD2t6cfFHxU1jT9T1LxhA3hu20eMzNbeGbK7nT/USRbleTYp85nAJb7vAxX0P4xXTNQ0+S8+HviSx8NeCbeFXudQlkmWDUYPJzts3UA2sLDAknzlzkKtfP4riSOLxbcZRhBKyS1v6rY+wwPC9bLcBKnUoybk7t7eXKna/XpoeafGb/hJfGfgfV7q31S7vdKsLi21GxmsdMjubyC8UFBbS3dtNCqLKWaJwqs4zhiMGvLLrwL4f8BaJrXw60Swgns75NIutb1AGSZNP1aN49lveyNjFs21o9it+6YK2MMSK/j3xH4c8S+LPD9t4KkstE8OeHhGNfWwvzHcX0Fu48m0s1RBnMjeYJW+Y8qRk19R6/a+FfC/hOPVrOHTNe8NahLHajQreFbjVb6S7BUC3dF/eSvk7o5gCcHkYrOnWq1HOqsVyxT3tq/l+p7H1XDYOnSbwzlOX2NLQfS8093vZ6pbnz14f0nVLGyTxP8aNRbz/AIbXN4tnoTDdLci3JtLK9eAsY9xiZFjwskhkyS/QVBdWviXxU+s6f4ot28OaTrmoQatp+p3dkZba0vrhUMkMzfJcsZXAKkvDGzZB7VOdO8MeHZNO03V4ptltqTR+AJ7cLbT2l2iFmstVupAZS9pFgqCmJBgDJANd14g1+bxbBbaF8X9Nty2r2kv9nXevyi20y9lhwfLt7BP3jTnr+9OD1GKVbOKEsPOFadlF7r/27r9xayaaxFPEUY3k+jaTj5wt7tr9bfeeZ/EgaH9o8N6FdiOK7ttVku9N+IOj2zQubjzSy6Tew3BUyxzyqryN5z42L0faazPHHx50m0t9R+LkUOpwmO5tYvE/hKd5In1DULfI+1NMwAQQkKYnCt58f3iCBjG8SeIvho8kPgj4r+Ip7Lw9Z24sTd+IwTf2gjGxbWO2jbYIC7K0dwPmPyI3HNXvin4E/wCFg/Dya1iFzJ4x8N2n9jWM8xNrBq9jdoy20n2ZQXP2lCpXqY5AcnGawwmMVaDdCspR7PT7mz2MZRoYej7bFYWSnK927630u9ErPbRab3Z9P3uo+NPD+n2HxnuhaW0t7ZwP450jRXS6eS3IzHfxsMgz2qkblVPnjLLnIBrgvBfh7wl8UPg/4i8KI8cx1zxf4r1m01YTSAxqdXuUtLyB0JBeIojggjAwOAam+Gvi34gX/hO08OQiKwvbLSrK0vX1eFRfQXtpEEa3Zl2q6l1ZCjYYrzzxTPDEGjfC2wtb/wAOtDJpsdxd3A8L3MTWhsLzUXM18bJ0HlyxtKWcQtjLn5SMAV+g4SpzxhOzlG2tuumvc/HcRlVeFVwuozv7t7O1notN79NDpfBfxI8V+JvAF1YePHvbWTTjL4b1W6sWN4y3ES+W00kSlG2TDEic8qc7q8En8VaN8NPEy6Ws0er+HNf+H19ZX2uW4KLDcaOGgjvJztkbLCd4JN4ADFfmOK7/AMb/ABA0vwR4mHxy0XUFudJNnFofiiy02Dy7mFvvWVxLExPzB/3LIwBIcc8V5/4ZF/8ACv4S698WvFRvtF8RarLdXt7pLQCSGNbmWRbLTTB1QEyjLLkF3PpXFGmoXhRbju7t83p/ke5Xw7qNzr01KKa0jaLfdNdLdLXPRdUuR4o+BmleAviJoeoWWnXvg+xs9H1dnS+s55V0+MxyxNbYaKUMvK8k4PJ5FeU/AtPFGqeC5vi54PvYLnXbi4jXVrMr5KaukUKRbJXGAl0nlHypgoweGBBNVvht4M1rStP0nwD4Kll8J+JtP0zTZtY0TU2W50SXU7NVLS28St8zzLudHUgMuTjOa7/4I+GW8Can4q0rxal1HqNvrEt5qMmiKbiyddSUzwOE52quGAGOORmvVyuvGrKnKqkmlZNem3e/roc2a8PvCU68aTcU7Plk+jfXyt1V9dCh4Y8BC1+Jl38fvC7XOveH76K7g1LwnKoS58P6ldBRfTW0EmU+0zGNBcRkKXGWRiG58b+Puhaf4v8Ag9qV34Quo3ivNX0S20y1uLd0axnhvVTEDsztby8szqpQjPArqbyTV7r9qXWLnwrqUDP4l8IR6lbS/NBaXb2v2aIi5VcqxWPcmcBlPuKk+NPh6313T7HU/BIk0vxCfFuiadcQ38gigkKyl2ExU7ZVIU+S5Gc4NdWIoU4YKvPE/u4p3b3WmrcX0fkThsZKOIjDD07rlSbuk7P7Mk9XFW0asz1Bv+EUSw/4RHTPN0nVNOvRdaJIpdreCWE/J+8GHPmEssnPzqxzzXxHZ/Fn4OeB/it428Y6vdwaPaWnmeIbPSEIlWbxF5K2GrzIYyWbypIxFG7AA75GXG6s79pz9tvwjYeMb/4efs53d/ZXEUUtnfal4jtVLTTRBjcTWsYOFWJdwXOSz4wea/Kjxv4ss7OytfDHxIubQx6WVTSvLnQX72FxH5kkLEru81GZXAkBDFSOozX4lxj9IfL26dLJantprVSmmttO2v8AWp6/DvDtPEe2weKi6FSV7Ri3yy66Xu7/ADtvsfqT8PPiF8Gvjx4U1/TvihpOpXvhHwNp8njbX9Zt0K6nqggdUs7NWwAIvtco37XI2JjGSa+d/Gf7dXjTXpbPS5LdLaU297p+m3fh1Xsb2G2YIIIpN5KhU2IyhVAZlAIAya8c/Yb8Raprfxhvvh/Zavf6p4Y8S+Hr3wrHa3zKlxbQXqufOa3VsfJchWG3tycV8iWPwy+OmkfFe9RtLMd5pery2yXmsSeTbQTWLOJ90bEsUxGVQYxyPWvw7GeI3E2KqVY1sTvpKMIpKz6826PYrYCWHxdCji17i1s9VfpbzRV0fxj4WutJsdN8O65plzceaJNU0zWRJY3P2w5MlyJE/czybySS7Bjng9q7Hwr4i1zWfFdtoGl6DrOtHSHkWxvNIjErQPKN8kym4O0xIoKhWIBy2CDijT/2ctK8RR2+u+F4pb/WNQ0mXVZdOnVo7Ox8ptslxI5YbVL/ACxxH5u+cV1ek+PPh0dHk+D/AMQdVh1gh4LPTtB8Oyy22n6WzPiR5pofmu1XLM8XqM7q+Tp5c5KTjTTk+snd69j21lkYSn71rvS2zXkjsv2xPiVfxfE3VPipqesQXJ1DXku7DRtKk8lzcC2i86eSXGF8oqQFy+WbGcCvkDUviQJX0n4s6hBbWwtbaeGLT5J/Ot57t3IZrRdgJZsgzO+SDnk8Ctb43+GdL074ya/4j8STjUrDQNXgt3aeYmK5tlijMMUSLkEPHwNvCqOa8H+JumaP8TDdappcMVm+hxrdwaZauyWY05jzHDxhWRiD6tnPWu+hlFSEU+ZXta+728zOFDD8lajQi1H7V3ue86f4j1XxH4jl1HxF9n1K5vvs8Ed1ZMWuX+wukvlKCAIo0ZgFC9k6Z5r6T0lNLstHu/GHxCuZdA0a/MWieH/NSWXEkkbremO2Qo5SQoqoHwGBDnOa+Cf2cvDQuvFMkOtWzolzbrPETI7MRPdW8LEYxgmEy/QZPavrn9oCy8KaZ4XXw18Mru/j1C41O3vvOtg9wL68mT5PJZ2JWJYZAvmfxHoABXNT4ZVVpSnG60t1t93yOCeIp017GpdX6pfcjPf4i+C/g9q11oHgwwvf2liXfVLi4LyJdTfcAhUeVAcHAjViy/3+1em+F7j9pzQZbbQfhUt9ZT6mtv4quEtb0RW7vNHJbT6jcTOWi84Ff4zuXIRQtfJHhP4Yx/DOa00zxdZtfXviAzvHb3UJnt0lRW2umWHmyRsc7ydgbjnmvpTTdG/ai8f2N38PfCSad4b0vTls4W1LU70S3DQ7d0RVioLbiHG2NMls4PGa54cP18I/rNKTpK9uZbtrpdanbOhGq5UaujtdpLX/AIB+tnwj/an8Zx/DLx38RPi5F4dmufCNhYQJ4hsYY4ZrZchI7LzW3+c8znzHGwySHptHNR/DbxdYzeIYPjp4pvm1q91ezGlmyuStyba3vQWjlmk2FLNVnRUVChLISMHjPxD4t8EfEjSPDOl/B6ybTtF8N+GVk+16tMoub/V9elQy3Gow2kRJPkIfLiL5ZQM8Gsb4ZX2rXfj3Rvhn4G0PXZdL1jW9M0zW/FdzbzrJfQykLczn5QIht3DcckHB7V994c+JGZ4LGKhiW68ZyXK5z0V3a93fTqzynk8PZTlGKirO6Wjceye/M/U/Wfxlaahr/hT/AISf4syvqVxa20o03wdpSTQadZbx9mhkupVYfaJcsrMGGxSQNoxmuf8AF+l+M9Z8Jx/B2C2s9H027Fno2of2c8jeTbpGGuVnbfGrSFASFB2x5G7P3a93/aE1bwH4h+Fvh/4NeHNJuItd0ndaeLNU0li0UGladIHtY7iTdthnmCgsx5284LEV8kaN4n0f4ma3eadpul6pe/2dZKNEWxttsdrPGxM0jojb3Tbw8szZ7qM4r+oKPFNWuq9TFRs05RtG9vd0dml7y89DzaGDcqdPE4ZcsU7pO26076Py/wAzo9R8Y+Gfg1baL8JvhK3iFNEtd8Er2nk2VjbW25VumVbaJWkuZUYhGc7S5AOcivS4dC+Feg6DF4P8QaXNdajf3q6nNp+s22y0WR1ItxOvnMESNNqLvCnjI614tB42+HviJntvAeseIbvxBPP9n8SaN4Wsn33b2+BbRRSykiGIT/vHllOTgMM17J448RS+FPCMOqeK5pvC1lZ/ZpdRi2vq81/ebPmhM5VUkEzsAc7ulZ8OZt9ai5Ydy5EuVJJLlW9/fX3u7N86w0aHNU5EnPo5Ntyv5bemqOK+J5tfDGpWvhqygtrvxM93bCG2trJJtGgeQjbALQu5uDtYZYuNhwQAeK7zTfE+keBLK/0VdWivtc82Q6v4m0+8e0uIp94WVZo7giK3RE2KscO5Qq8gkk1478F9Bi03STql3qOqwXI1CaTTo7fTJ7m7heSXO1QB5atIXK7QcgY6V3nxA8ceJrzU5vD3hjREi0u4eTTruyufKt21C+khilME7tCxjkBLF/mOUB3EHiuPFY+Sk/Zr2cvJ+0+bUWt/U9F4VSrexu5OCV7O/S+6Sdlft3ON1L4mafrHiS21zSvGGnXAMTieI20uptcNN8sUP+jiKVnfAHBVVzxmuot7Txl8SfGkKar4Tu9ES2jN1cQ6NKc3Eo+SOR5VlWeErlW8tPmIGC/atiXwxdfYE8WWXh+ysdajtEMuv21yi2dmVYIWt2tsFQIx8sZB3KMY5p/g29+I09ybe313w9q/2zbLc6pePJZWMLswCxiGQKXcoPug4LHNceSSweKnJ1YT51opRX/pXO36bbHn4qFWdVxw7XIlqm9X/hv+tydPDcVsgtrn+31kjASRTe35IZeCMmBief8AaP1NO/sG09df/wDAy+/+R6yb34X/ABNu7ya6/wCE6vo/NlaTy7S0PkLuJOIvlPyD+Hnpiqv/AAqf4m/9D7q3/gIf/iK/RvY/9Ol/4DD/AOSOP6tDvV/8GL/5A//W9LjiadhEoHP9K0rXT4irHjenDAjj86sWVpEjt1LDB3jpz2rZWMTSmOMquea/2j5z/OiMFuZMdlGh3LGM99pzUwMyH92SuSBnI/lXRWtitvl87iRz+FZ91aCc/wB3nOcda4YV1Js3lS5bO5tNPLC4CZIPJxU/2xxwSR9K5gapEi7tr++T/wDWq0qtcOs6NgE8g+1c0sBZXuNVuiOwsZ2K/KX3KfpW+viC9hiCiQgjjnpXBedHH+53YY88GqUt18xDZbB71zTyy+t0dMcW11PWbTxMWb94zZ2/N6ZrXtfEMTsSzFcenevFbSFyGuCxAbkAHpT4dRcS+VsbngHNcdXIou8kd9LNJJWZ9BQaxKI8q7EN2Jqe31mV1m00LBIJk+Zb0M0LqOquB1BBI5BHsa8VW/vdiqOqjk1oWmrXaKdwyenWvKxvDqqU5QbWvlsd2HzqUZxaV7dHszjfE3jSTQfDd9Z3mleJ/DOn21wYLVjEuopFEQDvsrwDNmoz/wAtkMYxjIFVtd8R+HtBsLaaxvfGesatJas+i3PirTJdWjjjkADMstufs7gcZCA8dxXcXcs9/wCWhutQswLhZ5X064NvJKqDb5buvzbCCdwHWuJs9P1nwjNKdDhku9IW8+329lDeOkqMTkr5cqsrg9GZWUkHkGv554v8PsxwkZSg3Xp7+a8rI/o/gPjLJsdJQrSWGrxeijdQl5OUr2b7uyPVPDuo6jo3iK31PV/F+lebJbi48P8AiaxsZLXTLC/eLy5ra9gkbfFDOSGRnd42YFDghSe50Twj4x8DzzfFbW7bSvC3ivUbAHVINNl+y6Zr00Y+V/thEloWP3g0yxsVOD0zXzf9qvzbTL8MdM0+e5uLiaW68G6nctbR3iyASSRwz3IYRbMbthJRjk7fS3aeH4PCcMll4bWWwaSIQ3XhTWZGt1t0uxvVbO4idre4TI+UNDlQOCBmvxyON5LwcbPt/X4n7Lj8hpzj9YpSvJ7Xalbve34dj22x8beHfGuuSeHre4s/A/jKKNLn/RdThk03UY5ScJM9rI4tmduA5R4yeu4HFaug6z4u+Emqa1oC2F9bPCwvfEPhnyi0OyQ7Pt9lFudLViQdwj3Wc/UNA/yV47pun+B/ib4di8B+ItJ07UrR42s7zwrraLp93Lc8ASWMsRADNtJV7eQA94yal8SSa74O0ux+Ddtf3ms6LZRwy+FhfSy2/i7w3cKBiCG7DK0sR27VPzRuPlZV6N4lbHVqU41Gm7dba/PozallKqwWFxFOOq0i5f8ApL3t5PY9P+MHhO9+J/w2t/iD+ylNpN/qVlqUXiCys7FlNjeXdkdsscyrxbXTpvik3Da4Yq4PBrnviZ8NfBXxu/ZrtdFe6eDwT4jiNxpWtwEi48CarM6rPayMGy2mtP8AuLhCR9nYAkFCCvF/ELVvi58FbLSvjf8ADGXSLPVrgxReNbWxhX+xvE1uv/Lw6EIIdStD/rUKhmBJGQMVB8O/iBpXwy8aeJta8T6fbaJY+KrxtV1y0MclzoZlmiUTPPCTujikVg0kiHdHu8z95ExC9uIzaM3Z01zO13HZvvbp6HBSyDExpurCpzKndK+67p/zLa0tHbQ+mZ9O8Eftvfs4ax8MtUll0rxJpUs/hvxEWuI1utD12wBtZZi3BMUjqSjfdljb14rK8KS6n8Oo9O8a6i0jQIbDwP8AE/T7aL7RJYanaosNhrSkdYWAAaTABifJPyV4P8CPCngjwr+0d4q+HUd3e+F21O2ttf8AAf8AadxEZLO5ESxXFjb3cmI9QsJUEZjL8nGCgODXrf7Un7Qev+DviTZfDPxX4eayvZ9Bez8ZXVq6rpfivQVIMhiBIZZrZsExkk7CwBINeZxHxTWwVFYiFPmqN222utG79Dx8Pw/CrW9i1anUi2rbXfxWs9vJ6plzxL8UPh18CP2rL74e6F4i1if/AITHw5Jr+k2CbZvDUfibTbx4NWtHi+Rke4AWTKMpBViu4Gvm/wAAftE+K/Fv7R3hz9mK+0DTtBs/C9l4m8S6FaB2vUn07UIhHHBbzlAX8l3ZMMoYKRmvkv8Aab+DXin4d/GfSLnwtqGlS3tv4Xg1TRNWA8tb28s50uZI5blWKN5MMiwxPsBliJ3YIGfUPFXiG2174ceFf2+/BuopZN4B1Gxn1O0EZlP2fUmaK5t5F3IWMEi52fQmv5zlmmNrSnTxVW8ZX20V73+62h9zhsnounGnU1VlFPzW39M7T4DfHj42ar8EPGn7GGveJ57LUNDn1vws2lW1ykiR298jeWQo+YwI8mw8YX7teY+BvjT8Srz9mCz+G+u6/rCaH4g8FTWugRT3bi1s9RggZbrS5G5KhJYzJBkZKZQDKVy3xH0ux8LftNaN8VPCd9PK3iuxa+t7+6iCC5ul2NNCRuO5bqFxnngqG5Irv/hV4Z8LfFH4PeMPBAt76DS5vG3iG00xJtkM9qrXTvyyklJbed2ClSOmehry7Wur+6+nb0Pbw0qVlTSVn8atqn0s/M6Lwhovi+X4U+GNS1jxQuoan8U/Bj6rrl/pMrMI7ywmSG3dZgx8xIgoEYIGCp9a6jxb+1P8fvFHw58LaXqvijU11GP4g6JpGs2Elx5ka3+mzmZ3RW5KyrEJkHTaw9K+etD1/wAC/Dfwr8M7DRLS8v4bfwNb2GqyRvH5iX8V2Yp5lwD+9c7fMQ4VvvfeGaT4i2vh/Vv2pfAdj4cur77Ld65cTeJWjtlMMeqaLp101rhlf55BFK6zIvAATPPFaU6cYzlKm7afkZZP7OUJJyUnre61Vj71/aa/a2/aV8WaB4Q+D9jr0l9ceIvHOn2xivfLjjFpaK1zJJLKQAqAqNxJx0615r8Tf26PiX8R/iH4H8Ky6BoviLwx4O1S58SatDFF/pPim00I+X5kcikDy0lZfs5YESyAHGBXgvxD8U+ENb/aU8A/D2+e3vbfRde07VNf89XjZ7TUHEPkgHIClSGfJPGBXqd3o1hp3x1+MHxQVLf+yvDupXPh2ySN1RY7PTGe4uCgyNqmQxj5R/DW+BnUi3UVWV9rpnJQjgq3NzR5rfLyP0g8cftNfsofGTWPA+g22reIdL8Lr9m8d6ok6rdPq06/u9H0mDHzSSTTO02wZx5PzYwSPlX4YeGvGv7X37YfxBa/tb7TPh14G8b/ANvarpVvN9stb/XzCqQxXcyqAXgwZJ41zGrgLliM1+RPgnxPrfwj+A0vxq1i2ntvFni977xdYTTRtt0rTLmUtZw244CqFcOQuNxb3r9C/C2vfFP/AIJ9fBHSh8KtVmufEXinTbnWVuZiSl/e3kX2u4u7hPmBjiVtzZOeAM819JkHHmYRxs4zfPCG17avqcFXJsFU9rQwj0kuVPs/tL0Pqfwz8VfAfxM+MviX4ixWt/4gHg4Xun+HtKgKx6dpMUOV1LW9TvZiLe0MoQxRJ80ohDsqnfitTR7fxX4t8K3Hxg/act/s3hDUpY5PBmgaWj2kQtM/url0d0uru4nX540UDbGclASQPJ/hH8ZtQ/aP+Gnw1/Zi8GWvhPTIre3t9Z8favOxmuNb12eP7Ytv9ggCtKrSkzTiSQRsypGT1B9R+N9rZ6d8XbHwne6tq7ag2jPqWu61feZNJdWlx+4ttPtbS3aNbF55FZSkWWEY43DJH7Lk3HizCM6sXzJOzT2v+B81hcrw+Hq/V6K5ZLRPeaXVJ3Sjfurs8C17xX8PbzxQuteCLRNQ8D+D76HxENXT7Pp0t9qQiljh05VlaN7mFXYk7V3tIMDIBNT/ABH8QT+KPA3h3UPiNZ2nhR/Gt+mm2/hbRtQF5DYiwb7XdXl5EYh59ytuscccGAIpJVwJCcj1GHQfiLD4hHxG8YanpPhS28PDz/B/grUDJfxWkawGJFmlmAjjkkBKqwTcjYC98+Ka/onh067Y/EvWLXW9A1T4l6xH4cs9Tspmvr+3tLFBNexzWYbK3uoB8KGJCRR5wAAK9SFWVWNm0l2vr9x9FOGHhKFakvfj9r3pS9OZ6eel2dj8OL6D4q64LzwJp2m3vhJtLn0vTNC8Qzvotzq6W1wWMzTx20sMu2RWL7ZPMOMsODXN+H/iLruu+LtI1D4K6Cba8vH1DS9A06fUXtx5lqdr31jcSwxxXcMc4EaLJncpIRstgTa14ntvAN/J8PfG9gdW0G8n3Wng7QY2+zaZJHiO0l1u3jKMXKKWljh2pvG5vWtnwh8NfHQ8CaytnqB8UQ3bWUl9o4uQ2tQ2cMreTbibAEUMfmB0hJ2Rqq/Mzc01i6KnGhd/q2/6vpYiGTTSniZ8q5vhu/dt1d/5npdy07M8o1q/+HWqWWu29/o9xrHju5uzY6pcaju07VLHWEw0U9wkck1skMUoLLJDKSEwoXHTT+GXwe+FPxQ8OW9n8Wby48U/ES4vryw1TEsqu08bAlrFfLY+RgAxuDlvUV694T8a/Dzwvb3Gkag2o6XpVtezbbyKCPT9Zg1CePcIb27lBF0DECTKmFYH5gRzXhY1bS/F/wDxStvomnaPpMTZa6tJ7e0tL+KZ9we5ZRIjys3ohhBJPXArtwuMdOpafLLtGS/q/e7Iq4BSap0ozg3Z88ZpXS7WVreS9T2LV/hh4d8C2J0vxJ4c02a3uLT7Kuq6hYRXk8HluFMeqQR/Lnft23EkuAeJYxgNXmHjjwj4h/Z8l1D4o6TBqOt6pptvuvrRbyK08rTJNvmC1hgMr25UcxjJDYOFXNZnjvxCvgbwufB2oNJ4T8O3U8ii68PNcTi1VHQJ5wRhb3UEpYljHCgGOQwzV9tT0zR/BWJX1vxpo8kSPbXsnn2iSwNw0yQoVW6iQFiSuGReOe3VWqV5Q55RvFbdOX0VtUvO56OBw8faKnKom53TTbvUXbnb5Yt9lZs2rD4radrWvReOfg7E82ravZQx634c8T2F4097ZrEJY7iJJMLLLbryhhZpJVJG0ECvSfBvxC+HvipXZfEmnsROVtrJJhcRkYJKQOxC3SxEHCSCOaMHDqCuT5H8DLW3+JnhLWPDOkXlxNolhfLHayGIWdk9hvD2wW8J+0CWLDRqQQcLgnkV0UPwi0P4UHU21g6rJ4N1C8k1PzPlmXQNYZ1l+2MxjE0tpcyFvMUsQrncSQxrqy/PcfCKxdOrGUHpOz1+48LEZJlkprCV6XLb4U4Xfdrm6vszzz9qH4Y2Xj74Q6n4+8L3EZeWyMBn0nULe0tLmFpk5uYYXmaZ4z91CVZT0YYrM0bxvrHj2/svDfiP7dFrXwsNlJraQ7rxLvUnu/s9rei3k3E2qwK0pyuDKQGIwM+0fEjQGvfgn4h8XKljqmn3Wi3MsN1HaLZavbbsFvPXcFu4/l+V/lcDBw1WdE/Z9tPC3xZ8EftQeIL7VdI8LeKzZ+HZ9YtMKtsLsIIJ5A2RLb+aFEqMMEOeQQCPRzLP8HhKU8xnONlbmina6ejdn1XkfKqtGGF+q4jnUldQnKO2trcy200V/vKXxTuNG8TXq6b/AGfDe+LNEsI9bsbSJPs0WoWe4xmK5DMoRWJOFVmMZwyk5xXk3w38feGtW+IONEuNVt5td0qTTLyxL7L7Q77S2Fx9muFO0yARk+WxyxTpkGvvjx/pXwI+FPxe8Pat8RPF99qmo6fq48NJo1laRf2fe6dqqsWlh37stA8anafmQ9yOa5/41+Mf2SvAPxO0H4++CvBN7qGr6TfQ6ZqGo6veGNJdPvT9ndniQFHaJnUozgkDjOK8XNPHHJKP73D6z0dmrp2/L16nmYXIsTKi6eNbcOmt/Xe/ZWtax8/+OvhD4k8F/ELw58efFGnxafZzW2t6dKbs/Yv7QH2EX+bcqu0yHymIcqFyfm5Nfkt+0F+1M+l/Ejwh8RIxol5odj4kttRt1S4JZoLYs/ky3BjK+bu6buC3CLg5r9yNR/bq1m7+HVppOoeHdKvdS8Ha1c+KE0nVo0u4zBdSS+bGnyf8tLV3OCOCoHeun8e/tp674hPgiLQPCngiHTZvE9reQRRaZEIpEFtJJGSuPoRx1r8V4k8a8TntCpRjVdCnL3ZU42cX83rfvr6Hdl2WYZVFiK951oW5Z7O3ZpaPyPwB+JXw8+KP7SnxPs/iX+zP4f8AD3i618bW1x4k1rw1euIYNCW3nDTQmZnjeFFdw7PGQC7kbcLX53/En4P6T4S8Ta/qvj23h0y10fVns9X8OrMLjWBq0DNEbM3zZO1Xwwk2/Khw3PX+p39r/wDby8e28Xg3TJtL8PwPf+KJrHGnWSWrtaXFjcR3MO+P5tsiuoPvg9QK4Txz+1/4v+NfxL8EfDXxX4W8J6to3hy/ln8Uj7Ekcmrz6dBiWKaRlZ2t45ZIkYZ+aQYJO2vzzJcbgaWK9niKbnGK06fJ/I9PF1p1ndvWLXK7arXY/m4+DPw9k0Xx9oGteD9H837VbS2V+1grCX7VGnmiQ3Dttzkbt25T1r7h+MGr6ddard/EL4m2YsIprSJ9UvNFddWLapZpHFPI4R44TcOu2QW5kIR28yQnhT+0PxA+KP7J3x6+KekeEdY+Evhay07wWy6l4m/sQiNiZYitpZR5QJE5yZHIBYKMdTXl/wC2frv7LP7UvhOb4W+EI18HaZoTS6gi6NbRz2tt9niNstleJH5Y33crxgyfM2ImJ5wa+qzTivBV8RGnRfLfT/t3z2OdYhRrQUndyd/Tu1fU/Cn4Z+FtP8YaRJpevXF/p9x5ET3NhPP5arpgAksvNkwd9xcO25uOMMASBXeaB8HfAOjfFiPxpo0+k2EWkWLalqN7a2s0VxLdz4t7aC0jdWW5mm3NseNRGzDtgmv3Ysv+CfPivxBo2qX/AMNtT8MXXhux0xIfFniWzlVdn2JMi3t5pgypKwbY+xf3YyoJJr8nvFOseAPgf8Q/Fvin4kPa2uoQy6Ynh3w81w5uLaEwLBDJcRQRKEkK5dGydqNwNxryZTlHdWOyq6uLqKi9LLb836HgWl/D+TXtU8T+Ndes7H/QNdOnXMKiJhp+Y41XzFB/4+HZtshUHdICq4ArP0j9lL4ha5b658V4NIFho1jrUdpYxzXNs0tzcW52OXiDHIQ8bADtB7mvqb4YfFj9nbwal58R/FOn3Wji21m6GiaEdNa+lLT4Eus3TXMpVJLoklI5VJCkYUkk1yln+2r4BS/1S68N/DfVvG2oNdTxaHGtnJFp0B2kxmG3ij2TSMTvmk2gJgqo4zWn9oz5eRbG39l0qNedam3d2Tu9Euy8z5O8G/ALxb8T9Xhm8OR2Nvo99fzXOrarcQNFKFgY28djAFO9FaQkKio0jICzbcgVs61oGsRaCdf+C+jpdX95ff8ACP2usay6xSK0cjxtFp9jKQsa7l2JNKxbYAcLwK92t/i1pfgf4M32o6J8OPFPhbVltBFf+Kr77Pb2I1rVMq52GPzlCDPlRpnlVFfFHhL44eBvHPjzTvBl5pXjS08P2N+0MflwxCXTbFG3EK7AAO0nLy5BC8KRgVxUsZJVHJx2Pe9h9YxFVwlyqL+70Nrw78N/iRoviK4+K3x5uf7R8TKDaWnh9drfZDCpjQTMreWmCR5ca8sx3NtFe+eDvEHjT4cWi/FHU1t7/WNZ1Oz8O2VvNE82nb0iP2uW2toipmNshVBKz+WZWAG7PHUyeFfA154Z1mx8Hal4l0TTp3QaOdRspXl1JRKhYR+XI7iORd2cqA/VnwcV7VNqnw08V+KGsU8b6dZT2llHAmi6ZAl7f29rbHcsbS74VjkuJf3hjRcgkAnC19Xl3ENCfLRxsX7Lze3ey7ng1aGJ92pQW7bb6y7X9Ox8a/FD4han4YGsQeMfG3/CD3NxbLb23hXw9pg+2ukZDsZLtJgFLZyc7Vxxz0r1f9mex8Z/Fbxw17qHibVvBPhG50y1t7m4uLyW+v76eR0jgisMfvJrmd+WjgjKKMgscE175ffD7wANe1DXNN0HVZ/EUlkL+OwWW0eSKzsUyWZlie1tSwwd2JXLEKMtzX0F4B8PfCeMaJFqGoTHxZdWnkJpnhaRrvVItPnjE9xCr4V47yUkLPcyyBY41bYnQV4iyvBV8ZL2FX9wpO8pdI3003u/LUMXD3vZyjeT1utov07HY/B7wZJ458S+NfgjrWnP4c8N+D7ZPEzajp5V5b1tNg2i3u4JGAWUlmmuJpGKoxVQCRmvOvE//CYfELwPF4c+DcU3hPw7qc6waZfSW6vqHiHewE03kHJSzh+YvMS2/wDh616d4Yv9X0zwRe6H4luItM0/UNUv9XtfD92Ehjuxw63PiC4VSZlt02GC2jUjailjkkV0l9o+h2MMXjXXPEd5DYatYmO/v7O0VbXVo3jKBVtVAkKqR8vmNgEDCV/RvBeMWXYerhISUsPN3j72q7x1V0ur9TlxmE99VIw5kuiu1e2rSvu+/TsQ2ulz+FLSPwX8MNFvr2aGKOa81a98ubRoZLcYkm1KG0fMZH3wssoYAfdArC1CTU9Xv4PGPiqFtVsdMRRDa/bI9Mt1kXHl3ElsPOKxGUD7Oo+d1YMQBXN+P08Kz6Ba+K7G21G28Lad9l0/R7aWAW41m/JQeTa6eoU3T7C2YwNpfLyNtXFXdG0zxGdYmuviVp9hLq+oT+fpXhZAw1CKOJVSNpJFV/LYDBJXakeCqivrI46rKDVOlpHZptwS76fk0zy6WAhJxqVJWv0fxX2d/P0Om0L4f+NviNo2pT2Glaz4de5lbVZDBqEd1by3rNhUsoZJosMWO6WZ+p4CZ5DNams/A+laTbT2GpaDqP8AaLi9M+lS6paQwqAst80Vud5iY5ViyLknq1c9rWk/EqXxVFrsqWFxrUlw+nQrbRi+OlJKqxh5rmYKvLHMnDOODxijUNGttD05fCNhaXlzrOro8l9cWBiuZyyzZmJvppwSXIDFFK7c428V8ZmfFtClP2tOmnV1jdJ639NF6Wue5Sw0pVJU4Sbilvpt27/M6b4geFNGu3m8c/C2+0bV7rymgaWK0uPNlKjKx/Y98UNrEmMOzgMo9agbTviX4u8Mi213UbfS9YdhNpcmo2sF5ZTOdpENpcs4iTzMmNd7GTOSMV1F14bu9TuTrlv4elmuktYYnvNL1VEuYyihmaOPzkVpMZViSc1Y1jw54L1TQHuPFdl4tTT76IQSWmrfaJPPEbfK0phMnIOVBHBAyK9/IsNicw9/FVIwfZOUE7d33PAx+MjhlaNJye1tXp0tucDD4C+xQpZ6supi6iURXIxfpiVRh/lWFgvzA8BiB2JqT/hC9P8A7uqfnqH/AMYrGj0j9na0RbVNc123EQEYgTUtWCxheNgGeAvQCn/YP2eP+hi8Qf8Agz1b/Gvvv9XcL5f+D2eN9fX/AEC1P/AWf//X91m0q4QeWmXG7O7pVTy5ojvckdq9WW3smYKeWPU9zTpNDhvmEUQx3Br/AGK/tJX95H+fMsGmrpnm9i88NyshHDdCe9d7HbQ6nDtlAGBwR61Xv9FvYHWK3j+VeNw70mnmeK4AkUfWsK2IU7a7Co0HF2builPAluGhIBwDjFY/AQ7fSuz1GETr5sSYIXbtX09a5VrfOc5zjpXRgJKV22Z1VZ6GPO2Jc45wOab8zDdWvHZl3Lyrlf7tTraSBW8rCq38J7Y/Gu1Jdzj9lLczrWSeIlnXCkYGDxTxjfuIOe1S3UETARuWLA/NgcCrClhsaNSdoI6etQ2kty4xe1iujDOQDwe5rWspFZTkc5/SpIrB2lCbWIPJ4rTGlxxR7tgDDoe1cdScb7nXTpsih5mXjj0rZ+wnUEFsZJIfm3CSAgONvIwSCP0qG2jlyrYAb+6vStVEnVtxU5rhrwUo2Z6FC6vYyYvDV3f+KoNe2WWpXEFktgh1DdC6Dzd3mqyMEJAbByASOK5Ozk8Ba14KvPFVnodzKL25kNpptxP9ot2uoXMYmIIEsAXG7enUHHNeu2keQrSZGeGXsRVLUNPi1bV7TUJnltriz3eVdRRxOSGxuVlkR1OcDnAI7Gvxbirw6oYuftcNFKXd9P8Ahz9o4M8T6mAnFYpSlZWXK0tOzVra9zywa5Z+MvDIsvGPhrTdStrPY9yNFvcX1kiMC7pGBHcYRhuDFcjqHPSuM+MfjjwF4q+GT2PxQvpPHfhy3ulOieLLf/iV+I/DV8cCCK5LBQfmypkYqsqAEsDX0X4i0mabVrDxPLpNlq1paxT/AGgWEcVhq0U5A8q5ibZKkm3BDIBGT1+bGK4HX9G8IRo9lNqksF4RFfSXmm6RA5a8unU27sbeeDyi5R1kWSIDDrnOc1+CcS8OZvS/cyhzRj1vr/n97+4/f+DOK8kxtSE2n7WS6uyT+6yfdpK5n+LvBV78ffg2vw+8QaranVDbxXSa1G/mwJcWqgxNfiFlL+XnH2lQJIs4kVlO6uI8DfDz4i+EPCVvoPjQf2vP4Wm+yQWsgJkltmQulo92hIlyrt9kkYHfG21SSpQ8z4tk1H9n7xc3jnXLGSymtgl3PeeFfLeOGHafLnls3KgqB96JSQRna69+n8XfH/wxrlrJ4j+FWn6Zd3T6cIb+DRJ5rvStQnu5EUWSQOY5NLeRSZDb3AMLOP3Uscqhz+NPE1KFR0q8HTlutN/zP16hQcXJ4WSnG/V25W+36noHww1b4JfFXw5Y/CP4tI2seEtWvLqw8OXOrwGHUPDl5aokn9k3BQMI2iBDW90GVGjB44ql+1brl38BPAni7wB8WNP/AOEj0608Az2/h3UWk+1RwTXWI7W+hbG5YeQk2DxIFP3Wrx+DXdT+JE9rqv7ODzaV4r1WESJoevtgXV9ZbpY7d513bNRjZZI4pmUrdIXR9sgYHuPE/iDwd8Zvh1F408L6PrOgan4k0K80K1l1rb5PhjXxGbe7spDHJgWF1MWR4XWMRPsdela5vRecxVPnbUFp+tz5Svl9HL8Tz1Ha+rWz5umm1/Tc+WrC3uPhj8AZPDnxZurW9m8OvZXWhzQozrd2kvkxbgWb/UOJXU4zjODgqKdfTX3wg0TxR+zRZxS6h4Y8Yy3/AIo03+0iFeN/KxLBuQNvMRIaIH+HnNebftNeAvin4U+C+k2eg6XqPjHTLHV9BkTyo2hv/DevWDJa6jpc6vud2nMchll3+U4KbkBYE9V43+Knir40fBHX9d8EWsc/iXwUDq9jFDaIqXWnGNkZRH8+z92WSTacb04GK/FM3wNfA1Y08RDlb2810aPopY76xCNXkScpWa87aNdvT/M1fiLYy+H/ANkz4ffF7UIba403w1pWk+IJJ1aaW5it0VobqNo87ZA6v/CysoA6039ljSfDXgTxH4F0Frmx1ZPFWhXGv3dt+9E0eqpJFeMXicq+TFcFCzDDbRycV9YfDbQ9Z+Nn7FOjfDy3tpY4Nc8BHTGjkWNEMslt8m77ufnIJBr5V+Bl/wCI4fBPw88VajcQWc+j+J007Up1uoo0Npc2UsEjOd/yIJY0wDgZx3ryalZc6hb+ux8dLO+Z8lrSd1e9rvXfueTeJlu/GNnrvwX8CWVtHc6Tr+tRalqSpIJIoYbs3FvaxFSB502ccH5F+Y9q9F8T+Mfhj4b8a/C3xTFaq+gz+H9d1loo5Whula4jtbUPGFLF5InnbzBjOA7McA16P4cudZ8D+NvGHiQ3senW0PxI1C5kvDeRxq8FzDHLtGXQsd/GATyRWT+zroXjjVv2mPEUHjO3ZYtL8GyahoVi04uk0+y1vVVuJI4tyqVfMbLcEblJIUfL16Kcd7r5HZkmLTdWM6fuxSdv5nbXXf1I9M8A+E9R1vx1458cBoJn8NRXXmWN2s0Viq26/ZUMjJmR12qzFSAWJ2jGK4j4vaVfxfssaF4H17VVa/8AE09rd+KJkt5FuUt7t1utQuAYy7bBHxIWHT8q5e88ca/4K/ZITUv7LmmXx749Oi6Vax2PmXE2nteSyJDbyYDbRCgVSSwVfYYr6A8dajYx+G7uHxVZ28Wt61aSzatNY3UgXStKtF8xrRFZW8xUCgMdyGRznoAK5L/VqTqLVtpJFYfNKWGpSqWvOc3aP6eXqeA6zpK3r+KPHPiHUYI/DPhjR43hg84tAJbyMWukWMUT4LOEDzMoByAh6HNfUfx11fUNS+FGk6e8Ut/8Q/E+kP4G0rQFm2/2Fp7QqxutwUDDJ80zEY6KDXx1onwVPhxl8MfFLV9OtbWVY/HniHT7uOVbfQYr7e9losb5ZSWRY/NkZQ4ERVcIcV7X4L+IXjz4Y+GdR+MHjPShAlxbTGyvbl3uja2C/wDHrDFA4CQ/asK5dnZsYwgopUfYUnRVSy1d33f5n1eHweGw8Pq9GXKl7zb/AJnry36s94/ZW+G/w3/Zi+LFibLUjHcaH8Phe6zrt5MkEK3lrqFuI4WZ22hp0aYxAtufYTX3V4Q8SeDvHmm6j/wUI+M5lj0vxNcyW2jaVqzG2MWi6cotbO+t4wT5txcqrSLgBl8zA65r8Lfgv4I+J3xv+MtprXiiGy1DUbhh4l1u6u53kt55IbiG0trKGG2jZbSIPMIUndsbQzAZxX6+fH3xz4R0j4maX8E/DMsev6zodpDr3jrU2iNrp1lPEuLDSrWIM32e1tx++8hWBYLG0jHkn9J4DwP1WpGs04p7bpNnl8T5bh/b08Lg3+9avJJ2sure9k+pR+IXjT4m+NfHWmeG/EllYX0mq3stj4H8DanG19qkFpLAXiutWMewQlkG5HkLFRwAW5rndb8dj4Q+K45fA2o2utajbaV9ovL77PGgt760Hk3MGnuJnmmdGcRIuyQsoIdlIxXK+OPAeqeOtXsvEV89/a32jW0utavrQv7mG+FhKp+Z7lhIIVk3Ls3KG2D92ir8p5/wrpXh/wD4S7UPGHhO18rTrWz8vRLnW7mGKx8l4xM4tfNh2S3CpIGjlnEpcn5V+b5frcXjqsKknHfv2PpMLldBUYxq2cY391bNPo9df6Z6v4k8VLpmjv4r8fabe+ALfxDGl3eePNYtiuqTSzfMdroSn3SSqKUIHBFd6fBGn+BtFS6+D3iaw1nw7rFksWjXgmSbUbnUHiL7rKS1JeQNtJmhnAQdflAqXx347m07+zLCxs7eCxu7Jrsab8SZbi4mm/dgOLe2hX7M6yY3BFRFUHt0r4y8B6d4Lvbm50TWrLTNBv7vVbjUtV0OGHfpzxzDfB5UUkUEVtHEi4ljjlc7T8wb7p3y3O6kJJtXt969Hb8LHnQ4aqV4QSm40/5d0/VdvnbyPY/i/fN4U8X6Z8Ufids1e8jtF0nVdKtoUuopYUbfvMUTNF59mWAPl5Ux5yO1ZKW3iy+i0LxjZw2tv4G1acNc6uPs19pkNyrg2rxfZwpt1mchZUb7p+8ten+Ivjfo/wAPNFtvF58P6PYWscb3NrbSQy213I8jbVtoJJMx4IbeFSPB67R0rznXPg74Q+KmlPqPgC7uNLv/ABPbtPq2k6XdxXMmpgRmSV/JtTtgmg6ligJxtdVJ3D6eeeUI0FSjNym3dqStbs0767/MzpYD2OJ9u4xjCCcVKMm9901srdN7Hs92ZPD+uz6dotmkkMEVzd3rSQS3sVsGC7p7KQoIonyzBYpB5Y/hx1rltR/4Qq3ggk8AX9xrGk2l1ILjwzF5Ru2mjAXztkWYoHHLPDnDnpzXP6d4p8daRpscHjK6mu/D2nQxadqWp3tncQ2959mgEVompwK8rWrjaold4/nPInYYFe7eFPhz4P1bVodbuI7bwD4tvLMNbfYLSxjikt0HDRyxbbe5tc8/NtkJ5YAmvcwNevKnzKPIu8pafJK9n8rHw+c4ijTqe0lT5qnaKbUlvqmlf/t13PmO68D6tofjPTvjx8L9bvtU0ie4lg1rwdp8GGhhvBgywRPnE0MiK7wPGMgNswTz9ceDfF7x+J7SHULXSr/SPEGnF9LvXbyodYQxt9rtI7c7l80qhZU43EkLgqRV6/07xF4P8XDWtYv9O8L+IZ5be0t/FFreOBrMbnESwwsGRCCdzRT+ZgfcJ6j5++OP7QsrfEC68DeI9P1DS9FiNzqXiTTEhfS7C5uoCQusWUZDLbM8pViWkKzcOp3kivieOOJZZfFUqEoN1rpyhottmrfj1PLyyVbHT2neSektbK/2Hfpt+B2Gm/tN/B7QPGHin9lj4Y6ZpmoLNZXt54a8Q3SNPJHpN8pElgrPn95aMdoyeFHQYr5Z0e51Tx98GNZ8G69fXhGu+DrrR9EuGd5IrPVllW3urQc7E3eU1xGeDncF6CviX416He+BfE9h8WtKmNtPdlb4y2QzDrFrcY2anahSNsyNtM8ak7uWAwTX31+yxrujfEr4DeMdC8USppniHTvGdtr9lps6mHzLxrV57G4RXAP2U3BeRwe2Y8HINfzVDF4utzUMdL3o7dvkbVqNWNKdKo7zWjfR+a/XsfJHwy+I/ir4leD/AAn8OPHMs9r4n8OeMrbT765Y4uBNBFNsmBcHiaMBiejKSK+xNSnuPiF8MNX03Ube3TULX7Zp93ACwV7m2+ZWQ9QHwrAc4zxXwl8bLCLwn+094T/aIt7uNYfFHiCKy8aaTBbvvtdYjtnVJMt5ajLOVUbQGUggkV+lSaXe/D7UNR8darpuoS6BqFvaTX1xJMsBspYl2meaJY5C0DrgMysGU4LAjmuepThFxpJr0RlRm3SVC+p8deNtQ1f4SeOIfiDp72NxceKPAOjeLmspozLDaxXUsVqY3Q4yxRpHBzwQCa6nT7+38JfFPwv8JC6zCPWrvU9L81su2nSW0jgL/wBcJGMZPYYryfX7HUvEep3Gh2OnWFxepqFv4Lsb++nuJm+y3d4JLRECyiLZ5DZTCkYxjrX258U/AtxoPxa8BajdW2kvPZTazEjiF1ZwbIBsksT25wwHtRg+VSqwSsmzlwtfk9pFrqfFH7SM48a/tJ/Dr4U6cVGoypqF/pm4kLFdM0cUUr44woDd+pFd94zt1+HHx88beCfDyKl14dt00KBpjv8AsFptF/qN9OTyzZlVVB5klGc4BrzjwHrOqfEz9pnW/G+sabpS2Fh4em1DSRJBIWh0+xlaJyr+YuDO+X6fdx9a7WK08Q23wSu/G3jbSYJvEPxA1ax1fxDqcjSSTzDVrtTFCWVgdkNkqxhB0APfJropZhSpznzqyVlc3o1oQfNvfc8f8R+JbP4R/CGGCKV7fVPGN4+pMzBpJdtwf3JkwNxYRhSSehNbHgD4fanB4Kb4M+H7YLf3Gr2viT4ia95jSCDT3YK9lEy8NM0pijaQEhXZwOc4wL7w/wCHv2sPjX5F3ocumeHfCbrcajeaVf3MMt9tOILSPf5nkbmG52Uk7VI4zmvUNQ+O2i+DPhPqHhbwHFdWPiPxnrWoaNZQC3gvDaaNY3LWaLHLmB0VGj82LIb96S/981wZXPDN1MZV3baj2SW1zysBOPvYqUPffw/3V0+87Q/tFQ+HvH0fwv8ABVq8+kaSsst5pkE5jsLu7t8Osdxzj7Nan95MTndIAvXNe4fEb4cfAn9pHVL34oa7q+kQtYRWviDxBLLYTz32oOYh9ksrZwVZpJShbyxGAqKOcHNfIvg7wz8MvhP4EvD4m1JNY0wWwnlvof8ARbrU9S3FoLaFLkL5tkrj94ofdM53Bsdfozwpp3iH9l/9n4/GL9oLV7Kx1zxP4jBTR7WFdVgu7PWYDHDbGR3iNsFJQPtbcYwVO1M56sphXi/azl70nZLeye6fyKo4T2s1Wk71ZbeS7H5neDv2tPCHivx/qSeAfC8oL3bPHFbuIGjj4HmyobaVWudoBZ89gq8c13MHiW31Rb/UNch8ZXl1DYfYoo9MuIRJZWcrZDSSskabpnOHaMbVXgEnivMF+Jz/AA71bUNS8YaVovh2Se8ktINM0uRrjUIVgd4ZXjggXyp7hwhxI6BUVh8+1dpxdQ8a+I/izo1no/wb0DxX4fu0WVdOu9Gex8RXuprCT5Uuqzzx28ts3UbAMHoimvso0uX3WfcUcqp00liYq7/P0/U7fRdU+BGqX4+IXxgur60tfDF6+r6d4b0S/trqaW9Gbcm5hlB2SvMxKCUglQWAwK55vjLrnj/xUPFnwu8DzadprJLFq2rzi3luzEkhjS1tdwjjlJyflijz1OSK6nRfhtq3wzttG+L2m+MI7vVbeSbRtOt9X0qz8OaDY3N9bSRXD6qU+0TzzRyN8jARybwAAFzXR6z8NP2ovF32Ky1bxPpOp2uq2AuL7W7W4ih01N3EkQtgUe9KDhlM9vCBgshPNb8kH7yWuxvSwVClUc4Q97v5eh89an470mLwXfeGvGEF1Z6RpRaa+tbW8CzrGs+9jeXqubeB2GIxEC5wcBQa8W8Q+PfhFqvgzw/8T7fQLjwl4a/tFodLbTbIRZiUusot5pCGu7pum87wM/w9T9O+G0/4QbxnLpemWGqeMrFID4f17WZLRLuws7YOPN+xW/7qyhaFgGURQznI+aVq7HxNqn7MWjfEG+1v4nagmj67o2lxTaV4r8Vq3ifUEtXdCEsNHRorKEqr/u3IAHJMeaiUYpanZ9Tptrl+I8Y+DHi7xzZ2OvaF+xr4S8R63e39gqX082oy3IRdwlktmlCKmc/f2nAY4zxX2t8HvjL43+D/AIDv/wDhfEej+Hbq72aZ4a8J+EzFfXT3l1xcPdCyDzPMI9w3SSYBJLDjB8uuPH3wyv8AQrfRfBZ+Jvj/AEeKN7qS6vNOtPCGlXUfclrh5InXOcIto2TwCTzXz18Tf2iPgf4M8M3U8dn4d0rUdy2OkaTYjUtb1CG2nOC08eNMsE54A2lee/WsMRGfLy0vJ/cc2LwtOnK1RXl26/5n6j/DLSLLw/4W1z4veP7+zFlrdwtzYaXFA93rV7eByLe1Y4ZbZNyALGEOQu5uel6Swf4ef2h8WPitc211LeQLqWneHIVleSKXhRLcoVxDGrHDyvnPpnAr5E+Ffx+1rwHplre2Wkwanqd3plnY/brlIbLRfB1hIfNSBbfe8d1qUiMPM8uMCN2P39pB+yLK88P2rR6l8TX1C91Ge7E8FkowZ5NuYHMIBkcYORLdvAF/gUDAr+hci4xwawFKhNe0rPdPa/m1q7+Vvn0xo8NYyWIVerONGmvP3mmui2Semu/oO0R7t9Wk+IXijUm1fxk1l5ttrcke+LR7RgF8jR7CTCwqisPMuZcO/ZOQK09L8UzWiSz6drA8Ua/eW8YurbRI5ba4JJOZrycj5xhVGC6Bey4NbUfgbxh4h0u/utUl0jwdo9hOkUERiiurvVbWUJJM0jvIkMboxZUCFtuCcFua9E0v4X6F4R8MPB8NEtJIgscqxSIIPOAbDebOwZ5GI5JwAfTHJ+9yfKs3x9qcI8kH5WivL+rHnZ1isDglz1ZRb0v7y5ml+h5HofiO/wDE0FrqXjV7Z7uGQoNPtBGGtpJcoFuVDlhIxGPNcrtz3rsP+EH8a6h4YOhWV1JpupWkkpeHR7Aw+Qr7XLCeV3UykFt8gX5jxxXdXnh6/wBdv4pNfFsNNtXS5t9Etd3kTXAxia7+6krJ/CoQAdSTiunlUXEbQ3iR3EbjbJFKgdG5yMqeDgjjiv1LIvA7BQhOVZfvH18++/8Amfi2beMFSVdQoU7wXyb/AA/U8BGn3ul6C9xrp0+5trS4kjL3810l0IwAC0TWyyYVuvzd89KyfDOl/CrRheeNvBtuJNSCj/SprvVbz5ypZFBWPA+Q8Ajpj619EXNnaSkzeSqSeV5SSRkptXthVIXj6Vwcfww0hfDV34X0rDLeCV7m7vzcXN20soAEkZWeJV8vA2r90YAxjivpH4bU6dN0o0ouO/meXHjqjWr87c436X2+Z4r5OsT/AL6U+O0d/mZIJYREpPJCBrYsFHbJzjrR9k1T+/8AED/v9B/8jV9MWdzY6bZxadcLpNxJBGsLzyaLBvkZAFLtiTGWIycVZ/tbS/8An30b/wAEsP8A8cryv9Sqv8qPX/11l/0ET/8AAj//0Pr0RqHEg4IrUtbySBww25GeTUi6Xdn74wPUil/sm7C7lKsPTgV/rhKVGWjkj+B1RkuhsJfRBcsVyRyT0zVdYrOYkLtPHUVkvYXYP3gfb0ojt9QgyY8DPU1MKVP7L/Ec6krWaFmjeOYLEDg5ois1lYmdSD2960xDdLCX4+7yeuaWDaApPLfWteazbMIw11Rj3GkxjLAMD6VD/ZEsyhUVhgZycV2R2M+Wx+NMaYE7IQc9CegFc/1uW6LVNdTj00WRTtwvuKlj0tmO2IDPoBXU7UHPGe/1qaBzG2VAGR1p/WW4spUo32Mm30mZX8yYMcDA2nAq3NZ/ujw27HGfWtaW5hUjyc4x82cimGRpImZBnAzycVzqrKT12No00tjAt7VlPmbT04FXEE4ONrVaUncQeCPepwRGvzt+VOfQ0hKK3ZNCkQjG4nd1I9DWtA26TEwwMelUIoDMm4DIPIIODV5bGeUfuiCR1BOK5pyV30LjWaexaWVoFIiPHb0qrKbe+u1n1C3t7iTcGzPGrcr05I7VJHZXAJSXIxjGBkGugs/DtwdspU5P9a8/ELDu/tLM7YSrPZNehiJouknYJrK0nAj8jyrlFki8oZwm11bAGTjHSvk7xN+yZf6j471Hx/8ADq4s9DuJYbXTXtfMkaHULSFdz/bFGBJmTbjOCuMg84r7ui8N3anew4rTXSTAu+MEPnBJ4FfnHEXBOUZnHlr0k/Q/ROGfEjPcpb+q1nZ7p2f5n4TfGqz8efDjxLf+J5rf/hAvENlqf2iCeLzbq11dQFdZY2GwSKHUOWjIdOpB5NfY/wAEv2gfAGvWU/xS8cWV5b32uFdO+LPhqNFe3aXyd0erWxGB5cy/f/vKc5ytfoB8RPh/4P8Aih4Jbwn44t1vrFztkhfiSJm48yCTBMbgcZHUcHivwI/aN8F/Gn9iHxXp39haTa614MudSgtRLGrG21TTmZmbS9Rjcvslx9whsZ5UjJFfzFxFwhmPDEp4jK5uVCbtK6u4/N9D+rOHvEHIuLMKsLnUfZ4yHw62Un5PZPyZ+onxB8PzfC7R7nwx8bhHF4e+IkFja3OupK91BBrA2zaXcXrf8sSUSK2uGztkUK2Qwr5G8RyeIPhr8adM8U21ibfwl4osJfDOpQoQDp10JvLvbac5wRHL86OBho2yQOtem/s0ftm/s9ftCaX4n+Al7DNp+i2lrbrp/hrVrho7qztb1zby2kN8By1rMqhfOHlsrL84YDPlXhL4Z+Nk8b+LP2X9Z1WxH/CI6+/iHQ7mSU3UmoaYsG5hJaAkmSdTjeGOSCBnivzTP5QxeHdOUFJ7xd7uL3t5Jn1dTJ61GalTl+8grSjp76t7r7XWl5dbDv2YdUufg18Q/E/wN8SaxCf7F1WRtGWbfI32ZwJYgpUEFTE2AR/drA+DWmeALL4yfEX4XvqFveWX9v6latpi27tHJHIwuBH83CjbNtHcYzXkeo+GtL8AfHa28VJqWvana3FmyxW1wsUdzbfZgJrYK5ZyYmhaVCr/ADAIMe134VW+j6X8Ub34sqly0PjHXLvxJat5nl7VOoXNioY7WDAxRR9MYyK/CcQ2nUqTVnHlaXW+z/I/OMwpwgqtWj70bqcW/wCa/K7+ad/J7nnPxk8D3vgvVviHFf68ZvM1Pw5aWllfW0jj7FcQ/uvmjJBnhWPBfGWQHNfaHxPs5tK+IPj/AOJXhGaG71fwx4D0ywhhHmRwXlpqK3s80A3A4cPHFJG2OGXHRq434ieC9C8QftUavrmpWtwRdeFtJihP2kmEJI0kMpK7QDJtwA/YEgDmt74ReKdE1zTfG0viKC/Ez3Gg+FZZbVo5GF1plq9u5ZH25JYBwM9GFe1Vl7kq3WOv3n0GIzvngqqlerBR3Xf+tTM+F3hZovF/ws+H+mXlpPb+Gfh5P4uUwTZj+2agI7eBi7YCsELkHvXeXd74r8efFC08MeMYp7qC91HKrdQo4OiaWySXXmOoy0dxL5cYO7GCa4T4d+DrPwzrPxBtxqDR2lveQ+GPD13e2rNIlrbRmVreTYz4EUkjKO2AK534Var4+0LTvEHibSLuKBnnk8L6BaRXCJNY6XYjzb252MQWaSX5yoB5AHUV5eNuv3k9Iw1TW/N0Xoc2Nw1q6rp+7BKzXWcultzzbx/8WPA3iv4yeKoPF1ndXWgaP48f+3b7RpQ0czBkg0+CSKUEkSFBhVb7inHWvpLUdV0/46/Hbwh8HNasr200fW2SfxgVYtHp+lWwEskU0xGxJHyqsij5F4JzXyr4Ih8W+LvDmiaBp/hCeHVPE3xKsrvUFupdt/qV+nmXFuzQ24JjtbexCtM5VmLdlJr7q+KTxeEvi1bfCzwtb3qDSfC72ep6bLCbO81nX9XuBcjh+Y7QCMPMxXcYlVR96v1DgvJ8FWofXMZ9nWzW+nR+p9LNYms6MMEua6fNO/2ur+W1++h9K+FvHHgr4I/EB/DPgWzjS+8RaTD4c+GmiW1ujNHoGl3DTvrF2kagss87IIY2G5ygJOMmvEdF8T+HLTxb4k17wBo0914y1bxTLY38E8ovo/tWnskEl7eyFUWe6uJFZ0iwIo+GbIAFe3fE7x54T+Bmu3PhDwv/AKT8SLnSo73x3411BoUeLT3iEkiQZbNtEi/6pOBBEpYq7lVP54a38QvEvxQ1nSvhb+yPZXWq6ppV/MniXxdFFKtrDZXHzvHEsxP2dZWKF55S0j4yeu0fXZpm1PEOnSy6LnNbRStb0X5ns5FwpTwvPiMbanQf2m7yl5y128t2j7M+NfivVvhVpE3g7xZqOhXmv6tdf2mLSObfZaY90GX7VfzId19fKjYQtsijJJAwAK3tE+IsfijQtL+Gt1q114j1TwxdQSxXN1Et1o1lZ29qkZeOF8ieaNlVBLIdy5ZlA6V80eHv+Cb3hqXSY9G+M+t+LfEuqXDfbtunSwQ6Np3zbmga4fMtwxzwSFJGSAK/Tjwt8NPC3gfwfpXh3wPCum21tPBDf25df9Os44pFNucI2MkqzSKNzdDzzX1n+oGe42mp1sMqemln/Wp4OJ8QOFMDzezxLrVFrfZdrJdvI+QPjH4R1zWdNutIsZpria6EuoXslu8ibItQwJJLkFwBGob5IV4OOeTWR4R1LxX8D7LT/BbeMtG1D7TGtvaaXqOhxtbW4ZGkUoZmQqxWPJGShPB5xX2J4u+Guiapf3M9nbaTYtfQskcUWnNKIem0s8rne4xydmPRa878c6BrQjhb/hGLLV47OF7GCCzu7eAuqqMNm4iVASAQUaNhz1ruwnhPj6EYykm35fr/AMA8Kr4z5ZiZeyjU5U900vuTujzhpfihqGkOPiHdadLb3tok8mk31sLCzRzIzW8pVCyF8dXKgDHB712Njpsnh/xXZ622hHTblbaJ01jw/eoLmaNsb/s1wqlGUjrHJncvAxXm9t4X1jTbS51yAeJdFkuLVAuma9psOv2dtFkkwR/Z51O3d/Aufl5wK7jwt4mt7vT4Y9W1600udIRMlx4WeaBJgg8oodG1KJHAB6mKV1XtxWGMpUsPP2OIkqdRPT/gXX5o+lo4qtiMNTpYSHNRmnzcqel9tm7q2/vC+Lh4g8SeOp7TwXeaX4gurazMcrrayxa6sblPKgntPNHn24YlmkUfKwyAK47QNM8Q614bvfD3hu4kt9S0y4cv4blHlzWcqghruyZ8ZHUtHt5BIZT1qSb4ieCvFPjLQ/h54w8V+GbjX7NBH5Grk6Hqq+YrND9juELxs0oRWEZNu2AcE810Px0Oo+D9NtviT4nhv/EljbwhLa70lohr1nM5AV4LxMx3LDABST5yMDJya7MJnkZtV5VFeVu2tu/ZnhUuHKdCMaPs/h2vpf79Jel0108+h+EUHgXx9PqNvf3a6rrWh2X9oa54GuYmUahDEN32iy6fZps9lOFJweCDXmPxj+LEnjh9bvviFoN5cWVjDb6L4ZvtQlW5ubQW0iiWPU0YfNCzxjCkMMFcnPJ5vQvG3gX4t3el6Z8Tb+98MapciSSD4hiyk07WbTGI1j1TT5MrEXztll3mCRRwVJAHr3i3xSPDelTWf7QLaRJZQ3dxaaZ42KtDpGryNIVi8xSC9oq8+btYxyMpCNjOOTN8hw/EVOrSxda7j8LSS17WX3XPn3KWTVoV1QfLUvdc13Hu4vfbZbo/KLS/iNBBPe/Dfxppqaf4ffWJWVbCIyT6fdsSwmtpANwwTuCAAFTwK9G+EXhy8+Efxb1D4haqZJdJtIVs9RWVi41izkCXBnt5M5zsImXPKOGTkHjs/i58EPFvwW+H9h8YPh7HN4zvJ7uW81CyiTN6NJ5mF3ZBQY5Psq/MpO5thx3ryTw74t0WIaNfeJ/JvfAHiSzNjq+pWsuZrS2upd1prMKnhGtboqJ4eGjDv/ATj+UuPODcflNeOEzCbSm26c11XVevY3wufYPFSTp1XOm9V0lF9Yy76fefen7QHwm8D/FX4Rr4j8GRpfKx+1/aLP8AePcwRr5tsRjaA8RAZDnOMrXt3wX/AGgNF+NfwV0rxFpcU7SvFHpmoW9xIpEV1Zr5MyNgZ5K5KnpnFfIH7JPi/wAZ/Djx7qf7LXxguNMgeDUJL/wpeWOT9ps03b45IQWKlgRNEBwUY46VzWjSWfwF/bu8S/CPULiddC8a2qeLdAtMGAfbT8s8MGFZPmBLFWIJPTJrgwOFo1NW05RW/wDmebUs6lqdS+8k11jv9/kyn/Z+gfCL9qPTfhzpen281nq/iOy8Ywi5nlb7JaWUUsEqxxk42pO0ZXnAzXvX7X3ji5tfFvgnw1pEdv8AbtcbVtP01JEZm8+6hWNnznP7uIu2c8V5Z+0MnhvQfj54G+IM+lLcyaj4e1/wrGJ7uRHhcNBqKvujj53LERtPTGc9q9g8fapp2pfG3wNrFxZ2ziy8OeIbuKKTeyBjDCm4MTkNjIq6VDkxFW/2Ypr53PPhU5/3kl9lvX9T4n8Q+ILHSfHi+E9GgtLEaxoF98P9JlhVh51zPc2saFvm5PkpIxHsa+jP2uPiN4e+Gnw88O2c+mW13GdaRli3yR7l0+xnH8LfLyVHHcivEvAmjad4s+Mngdp7KCaTTPEer+LjuDARpY2DwxHIbgGW6XHuKp/HPxP4Y+Lv7Y3w3+Blzp5ktNLnv9b11LadnR5EtxNbwSF1ITfsVsYbI571ngsPGvQlSn9pt+voVhF7Tkb6pv7tvv8AxPpb4RWfgr9m/wDZy/4SfxnYTpd3Nu2u6wLWcFmu7zDRQIsinOwFUGSO5r4+/Z//AGftLf4e6t+0T49vLizhklvbvTINQPyTpcXck2z5cslsFkKj5f3hJxw3PV/HHV/CH7R3xos/hRbvqVt4a8H3Y1DX7vzlFpLeQYYqdgG9IAdu08bue1ebfFX4g3Hx61q/g8Iaq194V0HShD4W0DR8RXeq3aMiTX13DIVkFtDCJTCqqckK2eRXnTjGmnThZqDs11b7JeReFxFOnzSneSbtpv5I858b+JNf0423xn1eJb37Tc3OmeHpbWFrjT9NdVIUKQNr3bDjJGIwehNY/wAMvjh4/wBS8L3vgLx7Il5ppaPUteZVMs9lZrIFmgh8wgvEm8SylSGdh8pAGa+X5fjH4r0+/wBItNDXxDcaHZaxNp+i2t6ksMS3F0v2g3RUAxSxfeWGMKHlAO4gc19G6J4n+I/jTxHpXgX4jSaJPNrJmszofhdik91EX3Fr2VQ0UBb5VZJGPlA7cN2+zynKFh37Wo/3kvuR+mZPkzjF1JJOb62uo/8ABPYfG3iLwB4putPsvgFo8mieHxAgm1+R5obK9vLMrFObN4nWSUS43l3ARMMMk1R1vWtD+JGrDQvB2iaxqF7OIUksPDN3I97DIF2PI0yKyr5vLMWIPP3q9d17wx4ZS11DwZ4v1iedNKNto1t4N0Gxia7SCyZ5JoZLuIsURJMFpm8tZcnGMYPZeMvi1o3wx8JzQ/DabSNPFw0Ui+D/AA1IjTSyjHmS362irv2KCWjklUDkZJr3Kkox1m9z13liw9Kc60rXXxSf9WR8RWX7M/hbXvsyeOF1nw1BY6hLZyWcObx4Y1d8hGg58yWTYW2KXbJJNes/CP4R/tQ6t4Uk8IQDQ/CulWWsTrb+IfGN013fJAGOEhs2w6kIVUK7ZBAyK4DVv+Chkvhjwjb+GvhTpni7xNrmpaiyyaTcaZ/YmmWcOd82yaDz5SiKA2MZYZ+YV8PfFD/gpZ8ZLrxde+D5LSx0mXUDG9y2nWctrIoOweat1IzvvKAgv159RVTslpuceExVGFSPLU5pdNNHfaz63P0j/aH8GfDa28NwaF+0FrDa5Pau815qN3dXmm6fgc/PaxusbAADBLYyeSa5nwL8Zfglodpp3w4+BVvYXtjbWdx/bWuz6afIsbWT/SbmVLyVsGEcKOefujlhX5gfEHxLH8UfDV0fEd3d32reI2SG0sbqeTVHgtkPyQRyNmQtIVzwuecV4rHqP7SHh3T7X4bpd6fo3hgxCOfTQEZLm1trhriSaaFQZZo0lDbgRwU2kcAVpk1ajUxHNUhzRWltrvsedSzZV6kqeHhZQdnJ9/Jn6ifHn9t3wJ4X8Oi60YXupXEcr2vh2xGpSWsKWshLR3V+iclQv3IlPyjAJr8ovCfwn+LP7S3xPsLLw1PeatqviS7/ALSvGyVMcEOTJLJISTwg2p2UYA5r6p/ZH/YU8YftSajda/p7nT/Bz3ZGreINTtixZIWO21tIztUk5DBR93jceK/pF+D3wP8Ahl8CvC6+FvhTp0dhE0SR3V86q17clMDdNKRnnH3VIUdhX9F8E+FeP4inGviEqFC9lZa27LToup8Xxlx7g8hU/a2r4qWyv8Pq+voeCfCv9lLTPDGjaTbvI1mLWGJxYWNvi7uZIFwGuLxiWiRUyoCYJ6kmvtPRNHl0u0uJysFjd3IGfsQ87YEXYvzuBltv3mPzE85rYsLcCNVclzxvyTyQOp5rWa3ikI3DH41/ReQeCmQ5db2dLmkur3fmfiuceNufY9uUqign0SW3Y4i78L6Rd6fHY30EV2zc3E91GrO/zhwMgZADAEe/rXRST+YjRE5Jbj2rQu4QdqQgZx0JqeC2h+yk7QJMkgmv1Ojh6dKCpwjZI/McZjq2Inz1ZNs57ZIrfMDmontyPmXvzzW4bcs26ZTu9jUMsKquYwSc8jrXTGdtTldPS5iG2Q/eyAOvNJZwujIwUqZS3lt6IOprXiht5JjFKrKQAZTzgDqPzp91G0kbSWalnmQRQoB93nGP/r0Ou3obU42OMn1qwhneEWQfY5Xfk/Ng4z071F/b9h/z4D8//rV7LBaWscCRvGuVUA5HcCpfs1p/cT/vms/aHXbzP//R/R9raO6P2eTg54FUrjSJrfLKVCZ4z1ruZNCmgYSrgk/nWdNHI2VMZOPWv9Ro4zqfxHUwjucUujPcZMDLkctk/wAqbDprTMyMVGO+a7WC180sqAIQp3cdazBblWOMDnk11UsXo7nNLD2OWmsCmVRiQeDimLYRKNyltwHGfWvQUsYXiDPgAjoKqS6ZAIzLHjgdCM1tDErqZyw/ZHCm3n6llz6UKs/3W5wOK6hNNWd92AD644p8lo0PyOq7exxWv1mPVmTw77HLvAwjBH3u9SPHlVEQGQMMfWt/yVPAUH8KYbWJWyvX07UlWXViVJrcyRHBIOI9uOuR1qQIBGY4xgEdK2jAZ2HBI6Zq+uihTlWX6GlHFRT1ZXsmzlodLuZyXYqAe/firJ0iQDrn2IGK6pLYQp5fyk5PNPWDd6UfXR/V4rcp21tGsKo6r8ox0rRt4kePMIA561LBEqnDgEY6VehhVfubRg5xXnVpXu2XDdM1tJ0uFmDXJB5zg16QYdLECRQKFHBavMnlUENHwR6mrcerTwe+enfFeDi6M6jTbPdo4qMVZM9Ve50xLXZEoOB3rmLmaC4JWPG2uZXU2c/vAck8471WeRixdcqCeBmuWlguXYueLvsXNaMltpMrW7bXVt6nOQcdBXD+OdB0Pxz4ek8M+L7VNR0rUIHgurOb7kgkjOMZztZeqMOQQCK6uSUy2ssDL5m5DgMe4qpLNHdadbXLJgpJCdn0+X+tFfBxnFwqxvF6NMyjjJRkpwlZrVNH8x3jb4NeJ/2L/wBpT/hE/EN2z+HPEtzPFoOv3DbX+w6iPLLyOMqRG4jSeNuGxuI5r2H4ceM38KfEvw/4m8VaZrvh7V7uymsrTU/Bl9/xL57CymP2e6FtMrJAPMVh5YkMZyQqoSK/Yj9qD9nrQv2k/gzqPw51NAbyO2e68P3uP3lreouVUH+5KoKMO/HpX4G/s4+K/iHreizfAm1jbT9b8DW+uahAYmDteWsKpJdW0kcowVcx78ZyGHFfzXxPwwsvxNTDRX7mprH16x/yP7R4H47ec4CliaqXtcPaMu/K9Oa59m/tBavfeFdC0T4jSaNbaho9otrqL+J7ZnaO+UySFY5FDlVZ4XfGecbhnKmsDwLrBg+B3gMR6VZLfafpdxYPatDkiRBBeqj7iQxwXI9+a9EtfhT8YviJHrUvhnVLRNB+JXw+k13wvawRfZbGa5sx5l9pUkLbkS4KuzxOvRgcDkivLk8Q+JdW+H+mX1lZXdwzjT4bCFmCA6h9hl099u7GzDLuYn0r+U+NeGFhcTTrbQqttL0VrfK1/mbcS03TrQw6atOUua3T3f8AODfzPZv+E41nxJ8arrWYrPTpNKbw/ZpZLLao6TS2935UzEYGFDEhADgYJ7103hTxZpEnxL8ReC08PaagufiDHqr3C740liS1t0ldQjDaYpOCOfvA8VxvhbSdTj8UeHvD9gqmeDwLCrhZVLGS3v1WQtkgMWJJ4rl/HGt6/wCBp9c+I3hG1lupND1zxNfXKw/M0ltdRJZTDofulVdfdPavnqdB/V17T4ZWV/M+UwePpSn7GUtJxppPzlez/Axfhh8XF8VrcXun2zSaXbXeu+L7+8YlRc3txcyGKFd6tmKH92rYPzMB6UzU/Ap1nwtZ6T4funa4kkisJX1Oy3RNO8q3N75ZDOHMs7KD8vCg+tRa5qdv8O/g1o2gQ2kEy6lJovhe1ihjBeVFiEtwi45y8vJ9+TXtV7qmi/CrwRd+IfEEy6dqEtzDovh9GRp10yw0udJtR1FXbaoZ7jbET1YgKK+g4W4Tnm+J9nP3aCu2+6Tsl89eh9Dgqs8QnVpxta8Yx63fuqXmlrPvskfQHww1f4XeDvjX47httGuNW0v4U6BY6XHpNndLbW7eILxUbV7i41JSNwi8rZ5RJZssAoAxXzV4x/bP8QfBbU/Gf7TulaS7+L/iVqq2Hg/QL22ctDo9rF5StHM5DxwLtDlgq+ZjGcV8B+KR4u+JPj7XdA+EsPk+DotSm19DrhaPbDAUil1XVokxvmvZFLQxsctk4r6R+AH7OXi/9rD4rat8UvjC+of8IfYyW1tHDJMVlvrq2URiwHdY9vzTbThRhOtfruG4cq18bTynB09tn0t/wD9YeY4PKMtqZpj2qdOCS5ftbfC9LXbV7eepwP7MP7KfxZ/amv28ffErWbq18D6bqM2u3Gr20O2TXLy+DPeCDcSzvA+EjujlUXIjGTmv318B+EfC/wANPBFv4I+H9imj6PpZSztra24lmIQM0txNgPNIzElnckkk10uhQado8UNhaWsVpZ2FsILWxgUJDBBEAFiRRgBVxit6eeO58O2zxRfNJ+/JXkFZfmBzX9TcF+G+ByPl9lBOrJ+9L9PQ/ibxB8WMx4hlUdao40fswWyXQ523eVpw3zZzx+Nd1Y3Vqlz9meMTbN4DkD5ckbSM8jAzXK2cnlSEtGxyjAexI4P4VNZ3J89o2VVAXeSnoTjFfouNpKaemh+YYeq4xTR3V6+nvLLANwMchKkdhnn86wJbWyuSUMhCyNuJzgg1Vhdrq/mS3DlmhdsNwTtwT/KqTOnmHZyM7gR6EdPzrnw1Ll9xbo3qVr6s1m8NK5AtZiBnJ3McDjBwMjtXG+KPg/4K8Q2og1ywinPCCWOV422jnHDH5c87SMZrX82QDbubP1qT7VMibcn61z4zIKWJ/wB4gp+qR3ZZxJiMEmsHXlTv/LJr9TwT4j/sj/Db4m+Ek8LeI3up4opGeATyAGEGTevlzIFkQxj5UIPA65rw/Wfgb+0t8NYp9L+El5Y6tpq2KXIgnuVmvjPb4EUKtOoDxbepYh+45r7re7lCEseApJz7Vz1tB/aGpSXj/un8v7nfkDPSvz3NfBrKsTUdWK9nL+67L7j9Kyfx3z7BwdP2qqxfSav+O5+TP7Rni34/weE5rj4k+CNb0TUFs5LWDUfDdwdUs5J5UDBnIUTQ48slgDtIBXnNfE/wZ+O3xA/Z2v7+bwvf6V4m0G4snl1bwlqc0t9o199vH7yS1WVPN06425BimV48ttyAa/pB1KOW2iVbN3Rd+WKnGdoLfzr5c/aG/ZX+HPxw0lpZYo9A1gXkcya/o8Kx3JOcMJ0GEmRgOQ2Ogr5PHeD+IwVOVfKK/wC87M+2oeP+Hx8Fhc4wi5G1rG+nnZ9vLU+HvhB8afDnwd0+H4jfAbxHcWvhUXyp4x+HvivzLm/8F6dcSAGe12Y82280hisWEAxkFa639on4KwfDHT7X9oT4U3ttrngvxBcGfVVtTFPDFc3zFnvooUG1rOc5WeIr+6zu6bq+Svi3+yj+0D+yXY3HjrwaItb06Ca4EerwR+aBaXfyTJeQAloYXU5kX50x6GvE/wBm79qbxXoOqx+FfENtY32mxXKpr3gu0lKx6zozrJEX0/I4ePcqMqY3pjPJr8h49y/McZg5ZPnOFU5TtyyW8WtpRfdep+grgbJ8zw0cXleMaSSTts30ctFa3nqfUPiDWta1PQrPV9BvwvijwQkOqeHUmk2zXGiI7LHAzHljZHMIfB3QOuelezftG/EWP43+J/BPxX8PQ3NvbXXgSK8cFlV7a9OoQojhlyR5E6kdORwRzXwj48g0e3+Lmi3mgtq+nWdreu2gPrC+Xd29peL9llsruLO4rbSFFbdgtGVbGa7j4A/8J3qXxA8c/BuZUgvE8NXK2tnOjutncrex3E6Ls/h3IJEPTBzX8lTy/FYKVfCVvdnCLbbT1aej/wC3tH8j5hYbFYV1Kc5ctSKbvo3zLqv7slrfvf0Pvb4++PtC1fwB4V1DWrOVta8NeMdOs/FVmswQx/2xZz20VxakLzBc7ldWPqV6ijxp8ZtIg+OHgvwv/ZF0LGTwFqUFzfT3YJt7y6QPbR5EeP3iRtxjPevMPi7pOsfEn9nbTfHfh22F9rWn6baWPiGS2YvJJbRXsVxG6xjJY20oTYeoRn6VQvvC+sn4Pa18QfHNvNodta+KNOuobm+ikEn2HSlFosypgN5Mm5myPvA8V3SxTnQWI5f3lSFrea/Rtmk6sa0VUhb301JLTll/k9T0/wCGniLwt4K1jW/Gl7plzbzWPhi30rStNlvGmluNS1a5eVI0zEjYkW3UsMfKmWzgV8p6p4k0f4RR6T8cvFEmoL4j1rV/EX73akguLxraK2hSJT5bKkbSMQOyIAM19F+C9N8J694q1j47WkaRbNTXwrpcNy3nWiypGqG9WM4b7jBDnkLu5Ga+Of2x/FlloXxR8E/CSxuYvEEnhTR5r2fzoZLdJtTvFRlQM+ckRAyN6IevIrwspzarOrGnNJezh72vW35J6kYaLi404aqEHzf4rXXp+J0fgvwDc+J7C2/Zw+H+qg+I/EcTa54rubqEwSW+jKDI8ruXKIspJDFiCQTxzVXxb+zB8JIv7fm+Ifj6e40HQJLew1PxbpekJaIrS4nh0m1Zpis7xqgxKuXywQYBavj3wt+0XoX7P2k+JvjFLEt94k8STPZR6kbkSAQ8xMHtMYZcgsh3bVwAQa+Q/in8Q/iR+0w3hTwhoWvWZ0fSwz6P4StN4FrdrKWlnuo14LSkk7ycnpx0r7nLMvw+HhGvU0m1669/V/kfccP4XA4TBrEVb+0tZLe76vy+Z+j/AOzr49+E/irx3qHh3xKNXsNQ1KYSrrd7qdxcSw2unIA0SW8SxpLK8YAfY6qPusWGa+iPjj8af+FeavrXhD4X2Gj2emeKbN7zULd7yO0u5oolVI59SvIQJFRhhzbQsg6Ang5+FdF0zxXYaRe+LLOSz03X0sorPUbpblM6dEVCTR2cTcrvyNwXLda7nxL4D8I2vjTw1qdnqkmsw3Okot0YoGxcRmPZLvSQgnfyPYnNcOAz3E1MRTg7KnJtba3Sv9x6lHi2cfq2GcVFT5lf+VqN00jzHV9R8ft4NTwbrnjqxOnyeQz2emT+XbOEYpHFF5USnCDBfn5udxYnNfPvgf4X+DvCWseP9fGr2P2Sx8KTQx3apKyGa5cB2TKgjk46ZNfQkPhf4eXfjK00HSYdamtLeOcyW1wsMcqTCVgQwyQVCkYPU9e9Zeu+EtHh+GHj/S9ItpUiluI4pZJGG6KFXXbuxkElsADpXsZ+5OioRejaT+9Hzeb4itUpqk6vNdLm8nc+JfhX8HbXQL7XfHttrWnyS6Z4ejs4tNEk0U/nXQVVG0Lgl48gfN3J7V1nhLwh8fH8NXNxr2rX2qpr0strpOm2moC/tYoA4AAXc5RVJHZewr0m20LwxoHw4uNVhnurS62+fdy3G2VLh9qafAVVcHAMzY9ME1738G9H0nwRr978VpJ4VsfD+izXlpp1rGyy3t5Ou20iSP8AuiT96w7qh9a9nDUFicYsNzWTla/awU5qEnObaipaeu0UvzE8F/C/w98EdM1/UfiBqVtoWv28NvZQappjC3u9M3Jm+njOfnaRG8lFRQzOSAyjJrI/Yr/ZR8V/tY+K9fmtrjWNL+HKahFbeIdT1GRZL7ULez2iz022nADqGRVeUAgAnkHAzzPiX9nr4v8Ax0+NfhvwVrVnc6lrHie5inneZfIfT7fyxMkTIuRhIP3smT8uQM5Nf1EfCn4T+HPgj8N9K+EfhCEQ6fo9sEWTAD3VwTumuZcdXlck+wwO1f1d4f8AAMMdjIQWH9nh6Fnrq5M+c8S+KVkmXrD02niKqbenw30v9+xb8I+EdB8GeG7XwZ4XsYtM0bS7dbTTdNtRsiiiQYXIGMserMeSSSa7KztEIUsPmx+FXorR5vnI3uevpitaOzZV+UDd2Ff2FTUaMeSlFRVtkfyQ/wB5Jyb5pN3u936lE2ocAfdx6Vfa0hLDy2I+tWYo1HDrz/WrMtu24cbfaueVZ7mypNGZJabioXHHVqR7QxqXTkDrW35ULMrNkY7DjNWDCjIYwo5rFVmi/ZqxztvA0x+XH1NRGxw0h3fNyR9a6iKyVB8ox9O9NaBELXLL8q5UhuPbPvzUPFJaFwo9zj0jUNHaNnfKC7dwEB9fc9KuJaw3Um5lYCI7Y8deO9b9zYTi1MqriSVlyo7D+EfhTjp0kNo8jnnbtck4Cge/QVnLERTvc2jSMY2ik53vSfY1/vvWrFNpvlLiSNvlHzCRTnjrmpPO03+8n/fa1P1qHcr2D7H/0v2GZc89/Ss+WxlkcvH1bPBBr0OXw9cQMouQVY/dz1pq6TKjfOd2PUV/oosxuvdlc/kV4Kd9UeVHSplzuPWsybT34WXkE9q9YbQzJK+WB56HtVMaHFnr06gV6tLM4W+I454F32PNW05pU2Kw5GMGnQ6f5ShJG4HAA716K3h2LBkCkioo9KgjO1l5Na/2gnqpGDwUlucE+nF2zH93/P0pfsSldp+Yjt0rt7nSFUeYPMHsBVFrFkXKhzVLHX+0Q8LLscsmnAt9wCs8afOxOyMdTiutuILmNA8akEnGDVSFJ4stJ9MVpHEyeqZzzpLqjnRaybfl7dcjFXYbYC3aQj5x0x3rYl+dSWB4FVUUEY3FfatlVuvMh0o9NzCZXL78HnpSLC3LYPJrpWhZVBBY9+BUyQOV3H5R+tUsTYj2V9zn7SBpG2MduBnJU1oHTgeRJ+lWn4faDnHrTws2OFbH+feoniLhKlZJoqDTnPPmZ9yP/r1etrcwAhiGzz0qWNJyOhH1q7FbswzJx6YrnlMIxuUfL/fCXIAHGMUyW2kmYmPHXPNahtkztLdfzpTAYRvHTpnvWfPqjSUdNChBbeWxywz0rGuJoxpUscSKBF9/HqGBzXQiHOX3HnrWJbabJHcaot02YdyNH3+RlO4fmKyrzsyYJ2NRo1eNkVuCwIZeOVJxivwm/bI8FWn7Kn7YOhftLx2TzeHPFsN7Z6vBbEAi6aArc8FH4cN5nA9RX7tW8Oy1UwYIY7gW9wMYr4Z/4KI+DZ9Z/ZuvPE3kRXE3hnVbHXolYAv5MbGK4RCRxvR8GvhePMujPL54i15U/eXn0a+4/TvCbOpYXOqNCb/dVvckvKWn/DGZ4L8cab8JfhFpw8Laxbxr4H1Xwx43W01a3+0f8SfVLbFwLeVC5Ub5CGLAKVyuAcV+b/xQu7Xwv8Z7hNS1CP7Ppni3UtXE9sT5UmnTXo+xbMbg0bRzM4xngCvT7v4qw+M9I8ANFcPHbePPhR4p+Ht9ETGrNLpiefBGY1wf3ZiBVm7nC18sfBzwPr93NpOl+GZLvUtVudP0+306wW2TylSOVrMEyzMVO/yiwAzycY4zX8f+LVOFXA4ephtVCVvvjr8tT+kYYCWIpSqOP72nU5EvXRtv7/vPo61+IXw1g8W6bqD61BH/AGZpLw3jRwzFAk14sij/AFfLKo3ccYNdJp/inwprnhLW9b8LajaareXcutQ2WkATLcT/AGu/kmR2jZACi26lyS3QV6J4P/4J5fGyX473Pw48T+ENShur7ws+sRRT3Ntb/ZYxcLEJpiUdWHOdg9MZqlr3w18TfDrRIfi1qfhWW2Fx4Wu/LS6kint5VhWayWe2SEK+GPzFHABx14r8WcU4KjzXSPGyvhiU54b2sWlFU7+fLGb/AMjyHT/Gl5Na2fiDw+Vil8Mxalqwa9Z3tmaWQRq8ajKKEb5VYElmB6AcniHxbqulSeCL/W/DY1q41Twld+INamu7mUeV4et5N1ojBkIiS7uS08nG91KonJr521fQNV1/wjZfBz4T3kdzqniLxM0Wq6A8jQ3EzCRTHHgrhIUVHZwDx6mvq74yeONV8N/C3ypbSHUNbvrz/hJ9RupSRbPo/h+ZLbStNt0BY/ZxKrzBd3zLHuNft/hdh+XBVpQpvs3fe3VeXc+myt0oV6OCUPjcVo7S5eSz+d3K/wCDPF/hl4w+M+oxaT8AfC+i2UnjL4leJ5vFmuao3yxaeLiMXCNJBk7I9Mgmbyoj8gdx1IFfvl4N+HPhv4YeEdI+G/hKPy9N0e3SC0J5d3HMs0jfxSSuS7HqSa+Cv+Ccnw3m8ReH9b/bF8cbLjxL8Qb+SG3uGy32WwgbEiQE/djkcKBjHyxgV+msNssk28FsKSDmv6f8OeG4UVLMZL36mi9D8K8beN6uOxSyek/3VB29ZdX6dF6GPrErf2fLGgVpZ8W6iTgZlIU/XjNaV3apbeRZwOdg3IdvT5eF49hRqECNfWVpGTu3vcHIBUKvBJz7nitmCzW5aUMfuYOT059hX6dOaUlJ9P8Ahj8PjTdnEyLmwjSxWXzlUtn5o8hsemfX1qra2q5TaqBTtw7Zzwc5+lb97BIY1QkfIPlVRgUGyt4IY0dyGRVjZfXCljUwrNrXqaSguayKmX/tQXEiYGSfLPoRjB96rPANyAvkBthz6HnP4V0N3DHDfyYG4LIF+gNZtzp6XNw8AJUMm4AdivY/hzVUaqspeQqm1jGms1DiRJAS2SRjpjimtB8jMzjgZHH/ANetVraJbRGXJbPP0qi4iIw4zzXbCq2cMo2Mm4lzH5TkbZDsPuvV/wDxwH8afp9ksMks7H5miVymc4MhLk598ior+KCXeSAVEYtAD1BmYZP4L37VesrVo5rtxg/vAgXthFArOc7yGmZ2qv8Aa43iUHKQOV/3mIXP5Zput2weM278hrqMce5qzdL5onfaAAYYgw65LDOPzrVuYJD5TyDhriEjPAPzYOf51M58pXs76HP/AGe2+wRSKilzH5ciuMoy4wVYdwRwQa/EX9t79lG7+C93aftPfAnT7GT7LqWNT0CWF3xHOWM0VvEvEtrOCRJEeY/vIT0r9y4LVpPNjZxthlZAR0JB3H8l7+tOEcSi1a5UO0syxorDIDOCQTnoMDFeHnWU4bMKfLWWq2a3T6WPsuE+MMZktZzw0v3cvig/hl6rv5n8vPj/AMZ/CD9or4Upq+j6XrNt4smuItH0/V7i+P8AxINRlRpE025dubqxmVdsMkqq6khd3Art/h/8Rdb8Oa94J/az10yxtoDxeEfHUeGLLYGMwtIychmiKlcjnHrX0H+3l+zfH8K/HGi/tH6NqCpb6pq40bxlbrBsjBkJa2ndY8RskbbVLMM4OSTXzn8UPB+keAvAd5ZeD9Wu9Z0Pxxoj6ppFkZRLLpepxXCRXdqGBAdI5wHjfGdhr+GfHXg3F0ZrHSlzTpv3tPipy/SLX9WP32lm9PF4XD4rDR5Ic1mm7tX+xfrbd+p9u+NPCev6N8DPiXbeFEn+xzRayukXukXDi6vIzGbqKTyo282OPY8R2lQDjOcCuC03VfEHjL9jHTdN8V30+r6pceGksb26lkYq8Uce7IV26JgY9xxT7Tx7eeINUtvHtlKzXvjLwPb6feweaESW4SGSwuTG6gkMphBOQCwOOlfMukeJLnVv2RdH8KQs9nJfOTLdFFmERsy6lSGxk4Unbjbg55r+UKMKkqUvZLaVvRboWTVIRbwta/xtO3a+h7r+z7pt/cfs8/DvT7nU7Czm1HUJ9W1ldTuDayvFFcs0xUFSCGiixywOM8V+fnxA8f3cNh4/+OvxQhkmj8Q69qlzpdlpx82O3smYR2sMcyBmTzV8vMmMbVA719vfE7ww2l/C7wno/wAJra/vWtvh1aWouGQsG1HUYtkyx9B8vnt0/CvlDxV4P8MeHPhn4a8PeI7eM6v4q1yI6fZz7isenaKSn74K2CLm8xFtcYUKWr7LhLJI5tnUqKgoXfM5b+7Hpbs3ZHn08LLE46rhqasqk7+ajDf8vwPxj+JNvfPpuhaPYtKlrPF5l7HEDcmOGfDKzckByNz7c5AHSv0X+FvwYs7P4aDSPCDS/bLu4LTeIJQ2bzTTFFc2dzabSvzRYeCWIMSN27HBx+sP7G3/AATz0HxZ8CfFPi34qW+nDxL4wS6g0iDTHU2ts0cjKt2gQAbZHXbGAMBB1Oa+JfAHgPxP4d8dTfD/AMTaje2Fn4W0LUdT8G6c0kciJqNhNtv7GWMhd5jlWUx91Eq8kHB/oviLgKtgcKsygrwknaL79P8AgH6VgeK8JiXiHh5NumrS6+Sex5poHw30hb7R49d1GaZXWeSCHT4PMEwkcbWMsuBuZGyx52kYIzX0p4W0rw9H4d0bSxZquqaVq8tomoXUzgrEk2VQooGAVYfPk469K5Hw1qmjx6TeeJNC8u6EOr2edJuEYLaxXhLCSMqcbX3DC+xBra8VfEf4zx/BjxD4p8I6TZQy3HiqKwligtklAtpf3e9GZQ0efLDFc8YPUV+JY7CcqoVZJJuSa8kzxcfXn7aj7N2anG/prf8ANHpn9j+FtI8bXupXmk6bLe3CMpmlSV1RIUzuKRuoMgzgMPlIIyKNB8Kyax+xj8SdYGiRG+vvFejW6SQQtLcRx3NwxOAD1woUL2PFeB2nxE+Pnir4R3XjfxDYLH40fVZtN01Vhi8g6dNDFIRKpwMb0yp6546V9gfs/wD7Wvjbwd+zPrt141ksoNctPGPhpdLsJo4lhuJYJfMkTauCy+a245OcdDWGfSq+yUacea1SH3K56NecfZUubeco/g3b7z4q+KnhXSvBv7G974817w/ZpdyfETSfDdlahpraRkitbq7ldldmYMHMZK4AOMd684g8A+FLvXfDWiQatrOn6lfW0tm1pFb8SSqYlco6n90JCQg3biOTnFfvV/wUx8F+F/i58EPFnjTTtRso/EFv8T9Ivk01QrCa3+w2dpeBIzzvRpNy4569a/H+5h07xP8AG99H8KLFbyreX95Z28ErrPHqmozJotqjvz83lrJcdBz09a+t8MVHH5n7/wAUZylbu0+WxllUbN4mpUsotys9rpWT/A/Vn9gv4B2PhDQtV+Mqme7m1GeXQtGu7+VppbixtW2XV0GfJDXc6scjgoijoa+/pNNE7ZjPDjcOMED0I9c0eE/Cdp8P/DumfDrSEC2Ok2MFhZr2/wBHjCvz3LNlvc5rpJbS4Vg8XCkDzATyDnAYeoPQ1/phw9h44bDU4rRtan8pcV5vUzDHVcRPq/XRGWNOcRBFPpn2rRhs2RVU9q1VsZAA0hAPcDpUssUcMLTzSBURSzseAAOSSa9mripJfEeNGhbYzms2nVVXAxycinf2cyH5XXAGT/j1ps/iHw/FHexx31o82nbo57ZpRG/mhNyIS3QPkANjH1rmNH8dwawt5HeabfadJaWcN27LIJQyTDJ2tEvmAoeD8hz1rxq+fwp2Tme7gsmr4iN6ULnWx6d5rKAPMd/ubAWJx6YqS0sHvZJYbVkd7eY286KwJSVfvRsOMMO4PNeAzX6fEfxsVa+mm8PaJNLDf6Pb6o9vdXf7tWhuJEIjkkUSHARSOOTk1a3Q6D4Xab4d6LfS2YmmvbvTXtFvY3E+dzC53h0kOTkMp5GDXnVOK0p8sFc9ehwjWn7sotPzR7K7avNPd2mgWLXstrtj3bwieeU3bAxBUsnG7ngkZrxXW/iv4lfw54hW10Wa21zw9DFc3egXvltfRxtIF+0IqSssqBQ0qYADhRzzWDDe+BtT8DN4q8C2p0u9SU2bPpIZxPcOfLEDWRZXErOMBxuKt8wPGKYqJ8OvBT+OtDtLq6vLePzrS9mYT6nPd30o36Nqx5kkZJX2JL2UKccHPlzzmtUbstDvjlOHopXalLZrs+/n8j0/wPqR8SWun6gfEEUzG1UWlpFgTTl03CSVpVVpBzkrEgC4xkgZrzZvFi3Cy2HiCxvJrrTtWi0zVbm7lDaTp7zOI45PIiCiQuHR1VmYANlyuMVJpeheHvG8I063kddGtrlrr/hHldrLUtJ1YY8xLa5lABhRyZFUFdxOOVNbWt3E1l4Zk+FHhRY76K+jvLC9byNl7pcAAa6vruHLCdhnK4IMjlSCQDWUcdOUld6Gs6FOKUqduZ6W7ed+343PQX+B9pI5d/E/ieNiSSlvJDHEpPZEEWFUfwgdBxTf+FGWP/Q1eLf+/wDD/wDGq+b4v2qW0aJdH1CG2ubi0UW09z9r2ebJENrPtx8u4gnHapP+Gu7X/nytv/A7/wCtWvN5P7zj+tx/lX4n/9P9nvEHjC40q/Hh/wAO2cEmr/ZRdXsE84W002DnM19OC4jQAEgA7nxxxk0R/ETT9X8ZWfhXwnZ32u+dosuqXd9pNvM0Ns++FLZHLgKouVeV4yWztjOAetfIUvhbWfHmtXfw8jtJZdCsL7OsXMV15K3t/wDxtPfyAPc3XTLeR5MPRUY4I9b8O6vZ3uqSeFfhZ4P8O6jewTpZ6pd3lxfXtjbj+KS6v2SM3k68fukUuehZBiv62pY3EwtZNJfcfh9PB4OVOfPK7e3l/XY+kGvdJbVrvQ450N9YW8d1qFsgZngSUErvwOCdpIHUjnFV9LuNP1vTYdY0eaO4trmMSQyxcq6tnBHf1r5A17xPL8C9An8Nz+Im8a67qGsRxXkWhbPD1razXxMaTao6NOyxRFQoUzodo2Ko61YsotF+GfhfRfD/AMPri+EOp+LbWPV9XR/7B0l5pss8Ucpy3kyuuzCiQhSTuya9CHEtWN/dTPGnkkdHqkfXqx+VCwUEAKRg8Gs3eqj5lyO59K+f7bx//YtzdaF4Zv4NZkspDbNb21vOLVZGw/lWm5pru/mwDg+ZHGv8Rr1FfFml2Gl29749aLw3cTxF3sL+5g3xjsGZmRi2PvBVbB4GetfSYbiOg0ozdpP7jy62TV3fljdo6qR7aVNpb8QahWC3Yfu2Lfj0rOFoJFS+tJ45beRQytEVcFWHB4NX4FWFNqE88k4/+tX1VKUZq8Xc+elGcW4yVjPnt5HyrBsA8YrKmsPLIX5xkZBNdT5p96hn2zgBweOldkKk4/CYzppnJTw7EPPaqUdqHy5OPwrrxaRScsjZHvinrZ2ZkCMrKegPatoYpbPcwlh7a3MBbbIG8MeOvTj9actjKxwjfL2zXVnTI87dxPb/ADxTf7OIbAIx65qPrsXsKVM5oWaxt85Vj0x6VMYUBG0t+ddGmlxKd4OSevepDZIvO3j2rN4uPmN0FKyZzL2ydST680qIzAKg46fSu+FlbOgDqemOQajXS7PsCMenNczzOI/qjOP/ALPcHcwJPqOlPe0ldSuCPqK7SKyhT5k7Hoaf/Z8UjFjnJ5xWLzJX3K+qPqcnbWa42TqMY61VhsIY9VnTdlJrdcr3ypIH6Gu2/s1G5+77Vk3enRLqtoMkZ8wE49BkCsp46nJ6sawbS0OTttNjFjGVJ2RuoGfXkcn8K8T/AGldLOsfA/xboroWSXw5fO2ACQYk8xSM8dV719GpZNDvtiw2gM7Dqcqa5Lx/GE8B6+ZfLdW8P35KyqShHlNkNjkAj0ryc+x7jgMRJx5lyvTa+jOvKv3WLo1f5ZJ/c0z+TLwx8RfCEul+GvivK9np2q6T42utAt7eaX/RYX1WwEkUkQYBTulQs3OAMjHNfdUL6f4U+NcXh+0soLWDQX0zVPD+iYe1KfYo5bmdthyw3yI248gFuBX5D6pptt8Tfij4atrE6/PFqfjKysNMtb23aWwf7TIkV2UZm3IkSoUV9hwGwRmv2y8dePtC+J3ivwhYeGGu7jxlrnheaSK7ltbf/RId0jGWeZ8syiCIRoudmAW9Qf8AO+nxjSxeGfu+zUpcsY79Hu+/c/tPIlUxFGpXw8L051b263ck/u87n6jfBH/gpHrfxw1u/wD2ifHXhWDw/eaj4IudA0fw7YXJ1G4uLmG5EkUjz+UvlJ5OZGOwhV684FdHLffBnxh+yd4G8P6h4hjn1DVrvSbzxpLqCC2miiukW3it/NkCotujXPyEDnk9TmvxYsv2vPjt4U+N2l33gVY9O03UYYvB+u6ZoFvaaelwo2Br5Yo41VY5GYIC2SwBOT0r0H47/tb+JfiPqz+F9M1G8j8MeCfE2naRJZ65awShFEiw/aXkG37TB9ph2QqvKIOOuR89icI8PP2miik+bsfTUq04csZP4Yrb/C/8z1vXfBXwJ+C/xI+IH/CP6qk/i3QBq1jDe2yJKIYZVFva3EzE5DTeYRHs5O0t0r4/+P0Xw9tvhLFe/C/xMNf/ANEh0GysIeTBeDytNhUSDAk2tcTu4HQnB6ZrrLHVpdW+EWv6vJpysPEGmS6jBNpgSb7b9juCgvXtrl4hbW8RlEcSRsWZgSKg+EXgfSbj4ufBjwR4N1LS7jw9Yx2enXkVnbj7VLexSG+ufNZjIqlpNhkXeW7Fq/ZODs0hDAQwXtGpSldK+6k1s+1rns4fFwwlX21Gm3KNOc7tbcsJONt9bu/ofun4G+G2j/CfwJofww0aMR2nhvQrHTI0Xp5lvCvnMT6mUuT3rp7ZN2R75bA4yea6W8kN2Jmm4eaRiT7scmoY7BIrYyn36cZ9K/t7LqkaNCnT7JI/zlx8p18RUrSesm3+Jg2FvHdXs1zJgiKIxJx6nJrp7XSVNs10hAClHcY5I54FLpdm0UXmKu4Ss2cDPAIrq7mOOPTGaJWUMoU5BHIqMbi7ytF6Nm+Ew97t9DzW8CM5lOdpPTrxStbRFpGRTtKyTDHUEYUVtaZBazvIt0CVUcdetTvbSCFnReBalTjrl2BH6CtJYlW5banPRpX94x9UgVbudwT/AK8ZB9jis4hGkJbg7uvpmunvbCbUdUaztwWea6RDj+DccDPX1r9CfDf7BujXmlR3Gs61MZJUWV/IiG0EgHCkk5H1r5zNuOMDlcKccZJpyWml3p6HrZZwxjMwlU+rQvy79D8xxNHHIYCjs3TABP41lre27F1mhkj8vO5pAR0/Cv21+HX7I3w28H2/n6hbQanqAyj3F6peMqGO3EecKcdevNdx4m/Zz+E/ia3Fnqvh2zTccm4sP3LjHclcH+dfA1vHvA0qjjHDylDvfX7v+CfWx8IsZKCnKvFS7W0+8/AW2tLO7kt4JcszF5ixPHoPyB/Ordhblbdnz88ssjt6feIH6Yr7l/aI/ZHvvhwjeMfAsrXemmRY5obgkSWu4k7mk5Bj9TgY+lfljovxt8PXv7Q9z8C7S7sbqzj8P2mp2evWE7XNrc3tyWL2ytsVAEVSS244PBFfeYXxQySpSpVZYpRdTRJ6O/n26HzC8Os6nVq0aOFlNwTk+XVcq1b9EkezSwA2zXkq7VNxHtXjtIg/XFaGv3KpZRO2C5uYljT1Jauns/C8niHTY4NLdXIlTzAuSdyNubA68YzkcUkvhltQmWCB9s6XCx2sUg2mVo/mYpuwGPBH3q+gxGf4WEXOU9jwqGTYmbSUDiLSBluJ4A3yShUUSdFZ8h2P4jFaU9tHE1uxPyxXCMOPQEAfrXO+N/FkPgq7tZJLWOWTAhmhmu0QrMWA+bYku35j3rB8U+MdUs7NlUab5nmwMIbcXFySDcJGcPiNSVzkjA6VpQzWk6fN0HPLKyqcii79jN+Mvw4u/ib8KfEXgG1to7ttc064X7MeHzs+V4mwQJEdVIBHPTiv5vbD4qN46/Z7uPhl4qmh0v4h/CXVbWystEltYopNV0+acw3bGQ7X8yEYyuGPfFfth+1p8W/EXw88T/CqxS8nnudX8dw2iWeizPo0s7xRO0cE0zvIrQvIQZEZeQOK/Ir9voal4P8A2lZtLg8LaVaw/Eq/+2T6zLexqy31uVMsCvFnyYndCoZcOxOeK/CfFvEVKtCq8PR57Llld/ZqJq/ysj9m8O8M1Rjh68rRk3KKW/NGyf3p6+iPkuD4ut8I21TRI47ue50G4n1rTbWVJIzItyr3CJKGClVDlgWGcjHArzn4P/EHxHqWp6f4F1zwzfSQXeh6pqqCyEzSRSzTHZKqggtGEbAyMY5zivTvhd4q+FPjfxFq/wATfFd3d/8ACWtd3MNz4e1eWO9jstMspGhMUd3qGTM4UmGJOSV2nK4IroPhF4g+Mvg61m8deF7DU9P8PJr9nbaLd65LJp99cw3M/mNaNPIskDp5fVNhjUY4PFfwBXxssNQr4eTtNcq9521t0/Tuj9Py/IJQhXxsLSk5x0b12d3bsnp6mP4J1nxF8XPFfhax1PdprpPC00EV35MRNmxgWNGldUBKDJyfvdO1dx8WtEj+L/7UcFz8FdZuZk0lpfCt5czWwNrazrcTRCKyliZwRIrTO8kijb949RXZePfjx4s1TwtrOlatqegeE7rRdTTVNB8HyK00eraebvaxt23iOKdHXzPLMP71QSAuBXK/sv8Ag3xnN8YdQ0f7Q1n4sudZS8lm0m5/0Ce71G4RZ7OWxjBihEchbEilv3fyhcc17PA1fG3rTwkP3sk1Fcyu7u7tF2v8merDI8NToznG6qv4pXskpy7dLdT+j/x7ZXPwx/Zki0Pw3pR0fVtP8OW+lWul2eo2/wBrtA22ETrcgAHYCZenPTrX4y/tY/C6Wz8UWHxk8IpNLMn2PxRCyX9vJHd29xjQtaYzAhRLLOLa4cZO0lgeea/bPSb3xP4w+Evi/XtX1TU/FU06zjSdP1bRrR4dDntV2m2jQx4cRyA4dxnoRivC/jB8P9di/Zj8B+ENFtpJ/wDQfEWga5F9jiuHZ2jur233kxkqJLu0ikUEBWYj2Nf13xDm2YVMPRdSqoYeVGzUmtX53e99jzuDKOFwmHxeC9lz1Pae9NapwtZxXz1ufgTpnwp+PkM/iifwzp8cXhp9LOli/lurcI+oWrC4tEScyYSby3B68Ee9e4fsw+Bfifo37P8A4v1b4ta94UubTU5tNllvdT1u1DxRq7QKLiNmZBKC+0Echh719d+CPDXivxr8LEvrvTPENzJpGrPNqcK20EELSxriPZDHAMCEcE8qScE8V6FaWXxHvfBV98PPC66451KJ5ryGUeWbK3d43DW8W0Lv6jhgDyTX8QZ/xq37PCuqtJQUrNaJWejXkfeYvhVxxCp0qM21BP4Xvb/gI/NFvhB8VvF2saxd+DNf8G/2F4U0SCXUH8P6hvVolZIWlKsrfvWd1UgZ5zjivNE/Z28T674Ul8LX3iPw/NLql4tzp011JNttWt/MfzJZViAUfL0znOAK/eGysbvwf4Khs5LHU5p9HgmivpZb0yTXouIQbZ5AzlV2TAqDs+U84rwvQvAPxK8Y+KtLjttI8TagkHiS31G6tor4zWghdXDfaADGA4YgchvUAV7uK49pVIy9hUilC0rSaXzfp19T1YcM18XUourh5cqV27bOO3XqfBPhmy+JHxW8B+H/AIceIdTstR8Vax8QbO9/txkukQw28BSJlVoVC73PLEjICntXtf7GX7OPxHm/au0q28bCwKSeK7nWJrtY3wf7JS4ZYg+wF1EsobLHAPTPFfad3+z58VLPTr7RL208W2wXXLC905p7ubCFSzTwIfMfeix/L6E84xXVfskfDzx3pX7RmpxXdhq2j6abHV7eC81xyCxmkRhsjZizZ2thmwMdBW/hp4g4DC5vSqyzGnCL0d+Wyu7v3r7HlYzhFwy+tL2Um2pJJW1173P0Y1z4eXEszQ293DLcb9w8hWkG/OcqVyDzwa+E/BXxw1TxJ+2frH7PPiOz1XTNR8OWYGn6TDKHtNWglRZ5bq5Jj3RPHHuMMalg2PmYdK+5oPAuhTabpi6fJbW8cEiSLFE6Z81iy7sAhhkndzXzP8ZvgK3ib45fD34mJd3EN94XvJbe1uo2X7Pdme7KXAuVyC8SW4YgggFjyTX9tZ/4y5VOFGnHPaPKm3JKcNUtknzfifheW+F2Joe3nPAttKyd9FrZvzfVLtqfQF/pmp6W8dvBb3F558rRwR29tKZEdTl4mG3LFB1wDxXDa5pviCaxvfDvjGNLOy1K4W30zVLeC4MyK7rmK4thGWUhvlzn5lbIxVfxd8Ltf1bWrm8is9XvITcyR2iS3kcduArb1aJImHyk8bXDAD+KuMvIvGHhbSTbaz4dNy0moRQX9/JCYkhiADhhskyPmxwrnJ+uK+bzP6ROXKMoxzmhZO3xK+78/Jn02W+C+ii8HKTav8S0dk/u1tubPj/wDrPii+07xV4YvtKnniklsrhLWC5t7+6SJg6iMlHjBi5IV1+YZHHbF1DQdHuLnTdR8X6pHa3urO1ha6vA6293GqEnyJhIU2fKMjLZ9q25PB/xa8e6Hdx+JrJbWxma2uk/s2eSKS5AUMjmaSSXbKD/ABMVB9DWL4j8KfGGz0rU5RqeuHTIdLtEeN4ILiaNFmO/zJQ+xwGIxgLu64r5el4/4DEU66jmVBShKybnHVd0m9D2sX4aygo06VJqdtEnb5PW39dRvh3wJ4wl+I1jN4vSObV7fSJtP0XxJpA8o3MQl3S+c8iyLcSCBI92MDAbGOtT+NPCk/h2w1nVNPceEtWtopZY/EluXg068mGCUlUgojyISMkFQxznIxVjUdH+JfjnwtDY+FrrVjc2sEV9b3sEJtZYmg+US3Fi8rQ/MXKMIZFDoTnHSt/S9O+Nn9nRWt5LHZ3p8tbuPULdotPmhDsXJkSdG2MSCwkHy9AWHNfR4LxiyybnGOPp391JuStLm7Pm1t16Hk47gavQlSreyleUb9bprppf8DPufhRq99omka1oLaRY6hplut5od1csPOUzLlys0LlLiOTcSxKjO48qa4UaL4g+Ik1vd2sGmaf400a/jupLOdpbHzruGIhHDASiWF4iVSQ52HBPIxVDwt4M+KWg/Fe+0nRYtU0uG+0gXsFh4ZvVWwjMDmGU2su542ErSLJtZVBK7CM/NWfrmma9/wAJbLL8Y7jV5L2x0IXvhO/tNOa5iTBK+c6TbTDPNOZI7mJWOFUFDggjszXxswGCoVZvFUm4TjB2ldNS+18upyYTw4lXnBQpSblBzWnvRtuuzv5v0Okl1fV7i3b4q65D5ccEj2HirRNZSIT+XE3ls0VzC5glltjhgGCO8fGOlXvF1hq/wj8Z6P8AEPwnaS3Hh3xEg0LxM+nQ/aXt3kiaTTNQUKWPlqx8uQZHyuD1GK8b8FftV/FP4UeEdUmsPDv2S31PWr1NW0nVLc30VqLlwUukieENIsufuuzYB5PFcdov7Q/xw1LwJrPwVsLlLfTbueOBbOxsYrFYre8JuIk2RpEZQkp6eYuFwBwMV+cYj6UsMPGpHD4eNW0+Ve/FejS7dzpwnhZOo5ykpK0OZ3Ts12vbR9j9HLD4UfDLVrGHVbrRPDl5LcxJcSXcpt1edpFDGRgwyC5O4g8881b/AOFMfCv/AKFvwz/31bf4V+Rvi39vP45+C/FWp+DvEFxrQv8ASdQuNMvQLKP/AI+LWRopOkxH3lPc1z//AA8Y+Ln/AD8a1/4BR/8Ax6vD/wCJneIP+hXT/wDA1/mdH/ENcN/PL72f/9T7vuPBn7RWmfCu2sfibp+n+C5ZZDdf2HdXYuNX1ie9ZnCSLHtW1Rs/NhmIXOSMV1F/B4n0q18N6Ho9/cPozXk0WsXelwf2ZosUC2zlIbZIf9Ju8T7RlSN+ME81i/s++J9R+KfhDTPGvi0XHiDxdYLNLqhuII7qHSo5XwUYOyI9yVXBkuJBHCOArHIPYfEG01LxB4qsGs/GD219cmQRN4bT7bDaQhciTUtTk8tpMLkR2tpBGhb70mOa/WMm8S54uhGrjvdb6JnxlXhZtOChZLZqO6W12jzzU7OytvGGnRDS18QayzyP4a8HHbZQ2EcYy2palBEGVACQEV8sueW3E43vB+teLLGSW7/aF1Lwzqmux3ck2j+GLO2fXb23R8eVFb26nyYSMEmXBODyeK+f/id4r+HPw0+ITxaf4q0TU5Y4Layeysc6j4kmnYmSVpoIXXT7eLJyjNJJt5LKzc1Fqv7TfwI0TQ/+Ec0uG68U6ndFlvvD9prcdmfnU/8AH9d2SSPLjkAbkUdK9R8Y4Rw5YTuuy1PVw/AWKqUlNRu/72jt2T7H2X8QPHngXwzPY+KH0rUdY8QWMAext764RZYnvQBNEltATsGAFZiAOOpo1fxI+g3R8RXmlDVLee3VbeyXSPLtLSPPzg3HzBmGeWYjkcCvz6+E3xrtvH08+geA/CI8NW1rKfITwdoD3E0mDjY07xzNNJ1OSwx97HavqKT9mjxf8VPDQsLh9R0q0ulYXF14lt5b67iKuGURxSywoFJGXPl7u2O9cOE4nxWMrqhRpNPu1Zfee1LhHKsJhniMfWjJv7Llr56I9Ih+M3hrwZ4ttH1Cy0Sx0G/jKSPp43XEj7gu6WT5Y4o485Byc9PevpxktZdQKWZV4SN0bg5VlPKkfUVwHgj9mvwroSreeLDBrTWcUUWm28vFjblAA7paqiKpc9QS/wBa94+yW7Dc6RqQMEooGPYYHAHYCv2bhjFYuKnLFPfofh3GccrrVI/2ZBxS3vs+1upwctimeRj3Wq8trHCoYc5z156V6UmiBl3ojYND6MoXPljPqwr7P+1Fda/ifFPLtLpnmZi/55r5nrnjH5VKtsWGdm32FegQ6JCcmNRjPO2rq6JCvIDA/SreaIzWBa1POPsz/wB38Ktx2pb/AFi4FegDS4o+JOPqKuR6baHoo+uK5auZLdGiwXY86FjIOYV47GtJbZUjwYhnuetdrLpoij3xjPbAFaP2GBkBKnPcEVyTzJW5jb6kecmEOmNuKkihIG3aAK9KbT7bZ8oJyOlZcmlspzHFgYB561nHMou6M3gWjjDZgHYFXJqVNOUct1788V1S2vGWAX271Rk2q5XsD3rSOL5tiJ4WzOfa0ZOCuR6iqd5ACEdgBslUjPrnoPc11S+Vt3EH2qDWrQjR5poBl1VZV3HGNjA5/ClVxDWttDONHU4eW1jnvCCuwsHDZ4yS2efzr5T/AGzPEaeAv2ZvGXiSS4mixo4sbcQnDNPdSeUq9CeQT2r7dubGD7Us0ZJLSOMjvznP5V+Ov/BXL4veDPB3w0sPg3fs0ureIb2K7jhQny7W2tCzi5lIywG/G1QDk14XE+axpZbiZSny+61qepkOUvE5hh6K2lJH4k/An4xeG/D2haz4b1NT9s8O2F7NJcRoIw8gkV4FNzn5VDDOwAEkdTX1l8KLXwx8M9Y0y08SX8Orayfh/Y6asrQvFA32+2DQSmQ5eKCK2lLE4zIzDOAa+RbT4c6FbB9A+K/iCx0lda0/UZ9R1RITqsNoZI1WCG6topEA853G1lYvuOBjBFbPgb9sT4Z/D7xt4n1ywtdR12Dwf4RtvBEMH2aRP7RH+jQ/bJj87Rx2qQKEByxB5OeK/wAxcBTw86OKpUE1JN1ErPWSurN7at7eR/YPANKdJYuNF+7CTtHXonq/uufTFt8NPD3hv41Wfg6yWK5jg02yiu9ZvLjyY45jeJcRMiuuTuiRlRD/AAnrVPw1rOjarZ/EOXxomm3vn+P9CKackyWsUUVmupXMaRmJSU3uyq+O4zXlepeI7r9puLxhr/gWyF8lrDaXNv4kSWTas2nxb1gjGEZwACPnIbOOprk/hV8PfGOk/sr+MvGFwPGGr6x4g8S6RNZSajpctjJaxx2k8jvHsLForcN99ThlYZxzUYHNpYuhXwcsRFaWab96N1f8D1uG1VxEp0ZUpNSTcXy7x5bL5XPpbw/Hr2j6JBrNnapczaBrg0660m5mlmZtMsnmlhK2+07IEkILO7YYjkZr6a/ZY0/WND/bK8I6VrTqmqT/ANo6jqNjaThrCK3vNPW5gktoiF2pL5oDYzgocda+dvD9h4ph+HPi3xN4IvW0C91K5v4dV8yRbppIk+eG2EolYx/KpZxsIODnmvTP+CdvheeD9oT4beIfEV6ureINTsr+6v55t5gjsrhWt4ViuNgLnIGE2gADOAK+t8PfEDBU8woYCrRc6kaiip6vlS1fysjTiX+1K1DFxpU7KFOd7vlajK0VZdl56n7/AIt4WUzSY2xqc4HJZuBUepsLWHAQH5envjtXoFvY6Gvi7/hE5/mWSV41fpu8pC5PrgkVR03UNOu9A1K/WHMttdRQx7wCF8yTBzn1HSv9Ip54lBVORtaeXxOy/E/hiOTzcnByS3/DVnM2KWd7cf2FDPbRXcNkLx7VJAZ0iZgiu0Y+YKx4zjFdOfDus/YSmGdShPz8ZxjgZ781k6j4V0+1uT8V9P0a2j8Q3WnyaFJrcQ/fy2KSrIkBG7AAYZBxmvVdb0fUp/EOhzXkpty2nWyLbqrO88wRWwVVmznnLEDmvlcTxjXwt545wp025WfMn8Kv+P4HvUeHIVbRoqUpWV1a255dYeGL+S4NrJG0bv8AKoYYO7sCO3FfWvwZ/Z60XW7uPXfFUsdxYYSJLUNzLOBkKegwQDx7V4vFDqVh461DXLq1d4ZZ2h+WVUZVY4eTauWbb744zXmHh7406P4Hsdel/wCEr0zT723u1e2VZsyIZFK7ij7tzKehUcA/WvzLjjxhwDoVKNPNacJpQekldqV9lrLRbtI+34X8OMR7WM44GpUV30bta2rS736n68w/Dr4beHtSXVrLw/ZwTwxNIk6Iu9QvH3e/1r4V+E/7aJ8Uftsa58BrnVnngtdEnaOGJBHHBc2s6HaYTlzJ5b4JU7SOa+JPiZ/wUg+EfhPwDfx+LPGumaldy2VzCBeXUNgQskRjdgJJEfaWYHcBw3Svz/8Agr+3v+wB+yr4jsfHml6xpd54ksPDn2cNqOpPd3IWVI1nkkuVjcScrujO7KqcYr+V8/8AETDVZ0qkMW6vLKzsqkrqz293/I/pPhTgyNDD4ieNwfKpQfJeUY8k9LOS3t3P65ovGuNJm1BPtd0pmba8cAiKqDtz8xwefxqpc+KfEbafHe6fD5sExMaSPMyupCMSSgGOCPWv5P8Ax/8A8HAx1HwzJbfDzw94hu/Deq3aLZ6yPC901q8lywKJFdSSwo+6QHZIBhuvFUm/4K2ft1fEq8sPAHw8+H3iGITwzRxXF+kUNvHNGMYuZ7Nbryc84B5J4zmijxlWrcqwmX1pt9OVL82jzf8AU7kSlXxlKEX3l+Ox/Ux8QbO78U/Ca7stal8qPUPDk893sjyRuQAn5zxjdmv4mP8AhVXijwp+1h8KdA8IXVzJ4PmfWbZ9Zu4Vj+1pDdXEVreRKOFEm3pnHcda+u/AHxG/4LKeMfEd3p2oWGl2NhLpWbW+1K/neCPLCM2ogufsxJXGSxQI2Mg9q9r8G/8ABNL/AIKi/Fe8u9Y8aeMdG8M2scUUWkSaW1retcwNy5dJiwtjg/Kqbx3zzXm4ytnUsUq6ypOm1ZOcvNbcuqO7KqmVYOclDMVNxvrTT1TVmrtW+8+odC/4lfi2J77U4oHeGXzfNuQTAqptVyA2FUnBH1rzPxT4t+H3h6aDW7nxTp8UNpqiHU5km8xkuFHzqW5xlevrnjNR+Hf+CDf7ROsWN7F8W/i890Lmc/Z10jzbXFoSpSG4EcYErIRywYKR2FeweEv+Ddv4MjwxF4f+L/jrXPGG3UJ9Qaa8tGhk/f5/dfLdFCsYOEJTOMV+v4nxY4wxScVh6FGMo8vWbtrrrZXV7bdD86p8DcO04U5TqVZyUuZpWV7W08r2eup+dfxN/a9/ZXvIr5NF13WJri3vopCYtM8m2kSKXe4FxLKu4H+E4r0C7/4LV/sY/DnwO/hnwd4QOsa9tEl3f313arEwjkErKAvnHnA4A4PNfp/8Lf8AggB+wf8AC7SzpVlpVzqSGR2aTVI7WaVlkOSpkeBmwM4HzZxX1P4C/wCCUn7Enw4sLXTPC/g+0igtFkWNC7EYlzvDYxkNk5rHOOMOKswpLD4vMEqa25YKL+9PY7MHlOQ4WtOthsufvfzVG/8A238mj+Rf9r7/AIKXfA39sPw5oNjpXw1h0mXw74ttPGNrqOiXdxdXEs9jvKRyGO1AWNi3zlTnivzj/bN+Mfhn4p+G9K+J3i7wvqOkWj3Jv4r/AE2yn3veFyxZXumjY7V3Dcgr/Rb0T9iz9knwxpo0TRPA3h2C2ViiwrCWXcfUMx6+9fyW/wDBxN+zVrnwqvtN+Idhotm3w/FuLbTrHT4oYLPTtRc+W3moqiR90eSoB+/zmvCnis6p0Z0v7Tm4TtzLTVLpe115amuJxGDVWFalgYw5b25W7677n8v8HxRtNVvNF1H4R+GDDrNl4mNxDNNeyTy3zXaPNC0pKbQFAw6j5W55FfayfHXUtK+CKaB4+F1e23i94pbvRW82eTS7macrHDamXJMGMMXjVSQAnPBqP9lH9njwH+1J4Sv9ZuvFNjoK+GptOMmishbVL2K3jm3JHDuaNPNjZcDdk7CAvNdj8Svgx+yT4L1zQtH8MeKNV1nWH8Q6eba2byrmwSxBMhWF42EyXEO397E6AKAVAyK+FzCnhcVWo0m7ySvrq9NrvqelltfDyqxqVIO7sl5Pe/4/edH8N/2d9e+Efh621HVV03Q/EfiW6ltZNIMYN7Ksx8yzvYnmLmJViXM0ZKMqncDxivV/hH8G/jJ8U9Z8WeL/AADO2s6wur3Onr4nuRd2sLojHfLDgxqwDpsDsQdwPrk6Gpz+DdA+DB8TeB9W0LVNWktZ/Eh+wafczw2NrYXEyzy3QuHO+4kRFVThQufusMZ/Rr/gm5rNt4v+GkZ8cX2jR+J4tZL3OkwQSxSp5KK8El3boRHG0kbl92VUufu10eGPB6zvOFh8bO0U3e10247JdUn6nn8d4qtgqLx1B6xsldX+fZnwn4P/AGA/2/7fUrufXptI+zzSSRozusxninO95nWW7OHJPfP412Pxl0r9tL9kv4ZXXiDWNX0m10Y6zp+mWVvHLAZZZDG22SYKCTsCcDcRgD1r9+LooZXOBnJAx0I/Divyh/4K+aL4g1r9n3RrXSbeJ7MauGv9QkY5s3aNlgYAMPvudue3HrX9bcT/AEauG5YKriKtJtxhJq7bV0r9W+x+fcKeOefVMfQw6qpRclfRa/dY/G+9/wCClf7TPh+81W5vdUgubCAxaY6WVvFbNdyTAuZiyr05weMGvHdG/bT+MPjnVrrV/C/2m0i06GWe8t0Z9ly8mB5IG4cdWA/E8V87+GdFvNe1Ge9vbmCeWS9to1jkwIikOI1jaTd+7jIXl8MSc4HevtDwR4E0nwlL4o8e6ObHSzFp95qtlYTWT31g0ke2NLeG8kKb43dsbmA9O9fw7j8iyfA0Yy9inJ6dLeXRH7ZiOOMwVONelU5bru/6sct8K/jf+0L8RdT1XX9O1jUvD2mWdlJqFzDYzlnvHtpViEMnluzRgFwSGHzYOK+zfG+uftKaXpunO3xPhtXuDayNZaZd3P26VLllWEeYHXazO2G+U4wa8L8KeDfEPw3+DWs23iG+0PTLyw0iK0vdqiC4hl1K7jlLtvCJcW7MWKurMYgdpyOa9d+MVrZaN8JodZbRfD+oXUlytpd3NrexSnUiLj54rFEdXGEIkyvI5ANLD4jL5Q9vDDp27Ja626+qZ9RlvEdTGYCFfmlzpczvJ97fc9zM+M3jv9qGPV9C8Av8V/EEOqTSSzXFlpU9y222tZUW7Mk7OPLeJeemTggdRXs2oeHPjlfeMPDXg3Xvjm2l6F4hl+xx+IL5Jbj5ip8mNvnDEzH5RIG6kGuEb/hDfir470jU7BUsLpL7StN12eAtaLZxqJ4USVJWZ3cxuu6TlTxuJbAr0f4lWt7ovhq21HTn0rUodL1T+z7nTrifEbzSSQTRG3uV+TciJuGAAxPqcV8hw5m2EjmWDp4ilDl54qacIu6bs+n3Hw+NzrFU8LiZqrZ2bWrsn5XPqC+/4Jq/Gmw0FNA8K/GC50l/PDteSW1zcyOufmJDyjO7PBJ4rLtv+Canx70bTJYNG+OmpC+lk3G9u7e6ulRc5ISJ5doGOgzxX7NTJ9sWC4dWUSWlvKEJ+75kStt6ds4pFt9p2on4V/qLgvADg6tShVll8feSeyP5xq+KfEUbw+uSsj8dbz/gnp8f4NKubTw78a760vZgrfbpYLmdUf8AiKQtJtUHn5QcCoJP+CeX7U9npUn9i/HS4W7njhAubmG5McUqDDOsJk2/PySM1+xi2oE2GHXpjviro0mGQ5YYOK2q/R24MatLL4v5IypeJ2eu6li215n4TeLf2M/2+PC2jPN4R+JUmqagGS2lvGa7AnUME8+K1BMQIB5QMDxya808VfBn9tvwDaSWfivx7q9ndT2v2caoPt72wIbInayicqMdCA/Sv3d+JviG4+Hkek+KCFk0d71NI1lP44xduFgmX3VztPI4Nd14m8U+EfAUNtFr+rW1nJcbWhhkYNJsfgOyjJC++K+JzL6PvCc6jhToxhLtyxf6Nn1OXeK+YRivrMPaRXm0/lqfzQ6R/wANUzWVrb+Bvi48evzW7QSXkt5eHT5iHORcWbfPFIc4ClugyCa91v8A4T/8FArvw/e63pPxM0jVLiwsIreS4uri4TTftRYMYrmMktAD91HkOx+MGv3C1lfhZ468NXPiLV00TVbaGeCx1O+EcSvbpLkxmaUBZEjyAc57jPWvnTXP2NNDmvh4t+BPi270W5hie0m01757nTr1GGPKE2TKq/3MiZB021+fY7wHyGlUdKmqVSp/K1FNdtldH2uWeJVLESSrzqYfzvdenVn5nTaH/wAFOvD1nHdaN4o0KykawgiuG+0/8Ssu8itJDsUNKrqASATtbgis/WfG3/BUHTdDS78H6loutPd2czf2cZIJLbVba2c/aprNyplkaFl2NEcMD1HFd/4l+D37Vfwk8SPaaL4cu79dUeSwvBOyXVmYJgzSXUcyBInWM4DRsiMByoVhmszwnNrvj3UtJsvEOjy+EfH805g8GaPrMBfSLy6spGSW1M2Y8R6hAu+CYMshclCHYBj+eV/Cfhmli1gK2FhCrJXa92+m2ltfU+/q5hKUW6OYKXOtLfk+qPnXXP23P+Ch+mxaM3glbDUH1aIxQ6fc28EMQitmLTKkgVm8yNlYNGQCCPerOq/tw/8ABQjQfGdppp8N6LdReKdIa8RQ0Mdz5Vrh5JFON2U5+RcMccc8V9eeOPhz4DvN3jnX2ijtdN1mY3dg93LpF0boW+Ly1l+0Z8m8ty2YHcKs4UIxOQ1fB9zLbaj8RteuPD3ieyvLDV7C31rwl4ke12QSzaWwkVHWV2UXJmzbXKLtXzNrhiDivjeIPBLLcFTlWlQpyjfeyv5Xty7HHW4qzClT5KdVpWt037d3c91s/wBtX9rDUrSLUYNDS6S4jWZLloSTKrjcHJZSxLA55OfWrP8Aw2R+1r/0LkX/AH5/+wr5UuvHPwu1O5k1LV729tbu4dp7q1gsSI4ZpDueNAP4VYkD2FQf8JX8Hf8AoKal/wCATf418p/qblX/AD4j/wCA/wD2x5H+sWZ/0kf/1dy2+LfxP/aT0CHwv+z/AKNc+JdG0+GOAWenWkei6HuztdTO+7cSc73ii3Hk5HWvoD4c/wDBOz4xeLpZPE/xh8Rad4NvZFihm0fwwZJleCNWQK80rGRyEbCt8pzk5Ffr5oGjaT4Z06PR/Cum2umWcK7Y7XTYFgiX/gKj+taLkFsv97vkYNfuOVeEeBi4zqzbt0vdHy+K8YsXGHJhKKhHu1r/AMA+APhd/wAEyP2TPAmky6f4v0i48bXEzbmu/E8xm285Cog4Ve2M89zX2T4A+G/wx+GNsbPwB4X8P6Cg4VdLsIYTgDjLBc13kEbMN2D61b/eqNwQn86/Q8Fw1l+Ev9WopX3/AKZ+b5nxJmONn7XEVXJkC30joI3eTao2hVJA/IVKsEUreZJ1/vdz+NPVZjIA8bAt04qwYnhB89SvpxxXqpwUdDwqlN7opeVC1wYdvynnP/1qtRWsMT7l/KjyvM5T71SKhiGXJpJ22Eo6It5x8opsgyuDzUYDMNygmqOo31lpdlJqOq3MNnBCpeSWckfKOuAOTjvisKsowTlJ2RVKlKTShG7NNfJQ7SBntQSm7AFeZRfES2vbyRbOy+0W0LKXurmQ2/yv9xkDLjaeuTx71wdt8crFtOjOphdOm/txLfMa/a47vT4Zx5z2xHWQJ99OWQZYAjFedLO6G0Hdnqf2PiUueUGj6KxGxGzBPQkUbFXI44PI96+dPG3x2TwwlzdX8kNpbQatBZR6lsW40+UT4kAZgylTsOI5AdjkEcEYp158T/F3ia11BfDMNzHKRcxeHdQ01DsupYVBKi3lH71hgjYSHPUAiuX+3owXwlrK5vY+l4VQKCQOlOQ2z/cAP4V8ixfHPxHZ+I9P8T6e91rfhm5dNEbTodPeGf7dKivNJFcRb1la22ussbKpjbPUjFS2vxxu7zRBp2jy3uoXtlenT0W3EbJqVncOTBcfaU3JDcKqkAP95gVIyaj+3Y2vy/iTPLZp2Prp3iWLBAB6CqeQw7fWvArrxp8QtL1fR7LRmGtweIbVG0y6Fv5EVqrMBm+Uk/vmf92hUhchsjNepXuv/wBk+PLDw1rl/AZtQJhhtLC2ZxE5zt+0SlsxiQhgjFQDtIHNV/a8JLY56mAlodR5SegqtPaRvwyjGeted+MfjRpfhnwtc67Y2ZuZkuJRaWjMI2uLaCYQyTh24VWJ/d5+8eK9BvfE/h2ztri+nuFHk20cwiYgPK0sbyCOPn5nGwg4/lXVDO6e1zlnlsntqQjT1xhBkdMelVrjTXnRorhcoUKsOmVI6VBY/ETwxdzx2Uhu7W7PE9nc27JJbMsSyuszcIu1WB+9yOldANV0e/s0uBcQgSxedH5p8pmj37N4VsHaWIAPQ54rSObQuk5aMyll8lpbU461tJDaA+S7IGgBlJCoqsvlrkn1I7V+V3/BWr4OeG9e+Clv4vg021bxJDrWn6HbT+dsMtrfT7XhnkKFjEWUFgBXp37VP/BRD9lL9lbxvqFj8RfFUUOtwC20+50u1d5zFFZSMWVowpQZZhu53ZGMivyV/af/AOC0H7Kfx307+2odM8V3Ph6yvrNp2s4tkDXNo/mxs7HO3cT054r+U/FvxapZlluKynAUKlSrdLSD5fdkm3zaLo7H7/wF4XWxOHxWJrQhC3NeT11i9LLVHjni/wDZ38Px+B9J0xv+Ectm8Y6nNHqqw20t8TcaXKbaVLONTFGkext/IO5kz1FdD8G/gD8HH+Kuu32iTQ2tpdeMZdIi8PWmjQxqlpFcu4hllaXdIWMO7nnaenNePfFD/gpp8N7fw34b8YeD/g1NDpHhvUSml3cuuR7GuLlmuRvIX5TK6liucgVmr/wVq+POs6Xdz/B/4beAfDuoGH+1I7y8vIVkneRmV5080L9oZSCNynjkmv5BweS5/UwkLUpJyclJucVZN6X1etu3Y/pnJ82yrA4aMKDTmrqUkntZr8Lt/PyPvf4X+Cb3UPgrrmlX+o6va6br3j+K7eHSdNRHSBo5hJBsgKbY2wp6nkCr998DfGuufHfUr/SbPUpNM0iyurPw8ur2jSTiK58P20ImwW8sASRbXOCN71+TXw7/AOCjH/BUj4s+Co9N+G1/4bg0nTdRa0uhb+THGlzIxVfMd8Dqfl5wetfn78Uv2sf+Cgvi7xff+DfEXj/UNRvEvDBIul3ilYnDkNCJUYAR54/u5AGa3ybw2zD29ePtaUOZNa3bSdr9Etl8zx8o4qy/C1qns6bqxasrdF6abn9VngD9lz40+EfgX4t0bx7f+ForPX/Fo1e4tr69gt5DbMknmOgBOxi7KQAuV56msH4ceFPgh+z98XPAPxY8f/GPwnJL4TsI49Y0+3M93ds8c7zKiSh0VcowVsqc4Ffxg+NPiX+0HqmtR2XjTVNammi8wwRy3Mkn3j84VkODzk15u9/qt9qZtdbe8mkZTKWmdw3mHBLFieduK+8yjwrxWBxaxuHzTkk237kYvpZ6yvv6HyGa8X4edavN4Zr2iaab2jfZrU/0CfGX/Bcn9g34f+LLrxFYXh1aEb3guLe43yzSTkqMRFRhR3ycgV8i6z/wcV/s9eF9P1G20Pw6l295IzxyWMhkWJlyVZ1dDvPpz8tfxs6bpmmRNCXjglbeMOwyQf8AZYYIP519S/Dj9nD4nftZeOgvgfRJ7u+nkhgvDZxmKGMZEKP5aKd3OA20Ejqa/T68MwxydPHZrWmpW2nyfC7q3Ik/xPjsNWyynG1DLKUWvtO7tffd6XP3Z8Q/8HIPxGvIUsfCGgtPbQwFVMqrFK7uQd5C5GBjAIXnPQV8neJf+C2n7eP7QWu22j+CvDi3GoPeSJo9npsbGUmMdVCKuWjUctn8K/Rj9kz/AIN3dI8P3uneNP2itadWgWxvo9Fij+0SpKpY3NrPGjhGibIAYsGAHSv3q+EX7FP7NnwLtreL4b+DrBZLO6mvLS6v4xPJBJcMWkMIwNgPTGTgcV9VgPA2hi60amIwkakbaOpKT1e71d797Wb7nPmfi/Twq9nQmoyX/PpWt+Fj+UnwDF/wWc/bDj0iz0y8udA0nXL2S3vNThW4Mto0bHe91GrIyDcuD659K+kfDH/BDX9tD4ix3Nx8cPjB/Zd8mtie0ls8zwvGFI80w585HIJUKXwM5zX9ZogvmJDqsaMeI4l8tR/wFcCp000xqWKAHGSSOTX6Tw/4D5TgrtqKv0jFJfe7v8T89zDxszad44Wcoxe95N3/ACXy2Pwz8Pf8EK/2OtI8S6V4p8WTa3r99p9mYriK8me6tryRgN0kq3bS/wAQyoAAGcYr7O+HP7A/7LHwkbUIvA3gzTbSLVbj7VfWzf6mRyhQ/ulCoqkEgoAF9q/QMWKtFvI5zUbWVuW2tgN2H8q/UMt4NyjDJOGGTa6vU/OMVxRmdbm5sQ1fezt+R4b4Y+HfgXwbaxaR4X8M6HpttaRiC2itrSPbFGBwseQdq46AYArszbXMsZiWV0j/AOeYJVePYcV2v9myLIWPHPpxUVzaT7QWXIzxivr8FTw9H+FTUfRI+bqRq1FarNy9WeZS6VLJLvKZPTJqz5uu2e2CzeROMBUkZVyOnSu0+y5HTB+lRmzbqQ35V6MsSpJXimYLDcusW0d18Nf2gPH3wqcQSxpe2RIEkE0jtgZ5KnnBr7o8A/tTfDbxWFt9VkOlXL8hLlsofo/A/A1+bEumh13KSfwqgNNUDEqMx9cf/rr4XPvD3LMe/aKPs594/qj6fJuMMdg/dUueHZ/5n7AX/wAZfhhZ30Fg+r2hknOFKOGUf7zDgfjXUW3jLQtQvF07Rrm0uLhlMgiSZSdo74UmvxQbSASSAwB7Y7U7TYNS0PUY9V0KZ4LmH5o5YzsYY7ZHrXyGJ8HqbhL2eK1tpddfU+qpeJtRu08Pp5M/cO7Nulq1zfLFHt/eMw7Fe5OK/ib/AODgf9qy/wDG3xQvP2f/AId30j+dpMFo0szvFZwSQTJcmdkZPKk+7hWDZPIIr+kLwj+1h460yIab4ksYtQX7nmtuSQg8ckAg1/NT/wAFKfjJ4C+Mv7RdxZ2OlWdhqMHi3TbfE8m6Oa206MljJE21DHJKwBKnLDPpX4Z4hZDjMnwc6uMiuXaLWt2/+BqfY4HiininCWBd5J63VreZ+RHwI+DnxS+LHxK+Ifxl+H2nPBc3jeGX+2WDN5l293G0NzBbWccZieUGNpwAyqgTsa+kf2wfgrp/7K3xH8KftC+Ob2R7SS+gkxsWPUJdRL7J5GWEgRuVxkAZJJ968B8b/Hb45aJ4pvv2c/2add8QWkekWc/iC/sNIjEL3lxdzy+XHGiqSojU5DByPLzg5Jr3X9nTxf8AEX4leCrHwf8AtD+ApIdasU33V7rN0yXV3LaPvmvITcKUgmjUjJwQ69Oa/n3MsPjauKoYjDOMac9LR0lydPS39I/WcDRqZlXpxpNNvW/otz3bwBP8G9eQ+G9A8P6hrWg6rqVzeas3ii5ijurNXlybi02CQBIJJA4jLKwCkkmvvv8AYTtpvHv7SXiXwz4k1O/gS4ghs7KynSNYpW8pVSW4il5KbMCOSPqoHXNflt4R+Bnj/wCGVt4xh8NeIGjvNe16UaX4btp4biCZ3lSZkmvegn8hvPQKAXA2YzX6Z/8ABOz4x+HtA/bPC6r4dutX8Y69pI0/Xbidt1rYvYrDGhkVVcwyFNrKflQg/LjNc3DGbV8JnSxWBnrFv3nq97O9+n6nzebqGJpVaNbWP/BP0g+J3w78RfC/W20DxRDtB+aGSMfunTsVbp+Havx8/wCCslzdD9mnTrfRMS6hc+J4be2slm2PcIYZHb5D8rLGUDHJ4OMcmv7SJfCuj+MtCSDxfYWs6zRAPBIBKoB/usQDX5fft8f8EnPhf+1h8Lr/AEbwTP8A8I5rzCN7Od1M1s3lEHy2TIMYfABdOR6V/fi8ZaWLyurhMZRaquDV1s3bt0ufjFLw7nh8dDEUKn7pNO3VL9T/ADufD/hS08H+G77X9a/s/VS1ysMGj6gBJE81wxCHaGXJizu6nb0xX0Xf6b4g8Xad4QhFs9pcah4mXR7u6u7dxpZjht2iS3ggzhiTtcscLkA9s17b8df2F/2mfhb4h074c+MNGtXfw1q9wdQt7cvsW0iZ5Ptj3JUb3kyCNo5GFr27UPj18MR8KtH+1WjXd14a1GTULCzvF3XBlwYvMEmQ6HcOhH3OK/zwzrP6dHD+5Hnr8zjZfZ3Suv69T90x2KwccmjUrq9ROys+nmfnLJ4V8S/DRYrP4jXn9rPpl0dP0tZJxcQGOG9JnYQkNK0MhRlU5ODkDIr6n8ZeNvhveeIP+EX8OWd3LbeKlkc6HDELf7F9mBnlmgLFpGPylQSEPI4r7J/Zs0f4M/t3fFyG50Xwsui67pUGpX1/dRBUAga0WHzASAPMEzM+FOO/fNZvxo+EHwl0j4jSTtfXum/YNUcTXlnHC/n2tsF+0XzOGYjewKhcg9a+fy7jCNKtS+tRlGdpKSTta7T0S9N/U5OFuLXQ0o2tJcr9HJM+Ob3WvhfYfDDT9b1KabV/EkVnFrGiWusxGK/vraMreRyebBwPJiygzktsCsOTj2Xw9o+o+AvD0N9q0LLd63qen3t3p7SxfZI2uZAYtqEMDGIVXI4bd83Qitzwz8BvCvizxBoGk/DuaSDwvPaXBstceJ5FubKaNpftUG4h08kr5ZXcVDPjngV9veBvh14b8IreeJPFWszeIdN8Paeb6JtTtUhlIkikhtSkRGURjjG4FtuDXyWc53HBYiMotyalez3+K6W1lr/XQ4M1rKLxVOSvGV1/wT9jzYW1/NbG2aM+bbW7iGM58rzIg6A44AI4FL4S8Ox+ONd03SDKIbe6vmgeb+JFE7xsSPqpAr+ezXP239Q0rxxeaZ4Q16WfUXvLC3s7eWUr56WqJKyqg4+Yjy0/Kv6iP2Z/Bmj/ABDt4vHGv/abRIJbm62xRFAJPMFxuBOBsXewPvX+ivhp9Jn+16dTDYqg6E4wfL9q+i16dz8Zr8KJV1yLmTaflbqekfF79m34T+EvCz6zZ66llPa7Cv8AaEirHKzj5VDHGC3avy4f9ofwFb+KX8M6n9simSYxSTbAYlwSAw5yynHUZr6V+IH7e/7PXxm1bxH8IL6KDUPDt3M2m3d/ekpHGQrKvkgDKsWjO05AzyDX5T6z8M9F1qOz1zwLNPeXFtPcC0MkrSrIke7aElwAP3YDHI7HmvhM1+lRVyKSoOTxN9NN4vrqfQ5hwvgKklKmuV+Wx9S/GP4k+DvFnwv1Dw011fWlvqtlPaxBbNRL9sgLNCzlz8qrNEuCB8wYHivi2205vjp+zdofxR8Xxwi8sYZ7bXL6eVkWNYrgrAyRqcytxtUZADc89K7HUPh745ZpfENhexXcsdmoSzu5knBCqA7gEjgj73cdK+Zv2jdU8W/BT9nYeBdfhFleanei/CW8JRbZ2bzo1jbOJYZVO4leFOB1r8c8R/HqpxBCjPD0qlGcouLavHR2s79bM5cBlbw0+a2nTqfL/jf9pHxbo2rx6oL1520wSWraNcWyMssTNNGsLMCoj3Q43HaWUFeSa9t+HGsf25LCfh14sOnT6oEksbGdzLFDcEPMlvG5I2bOxI5zgnNflUt/c6vfT6prc0ksjS77kyHO7cD8zfkBmtr4H+HJvid8YNM8P6XLNHG2oxwBoX+UeacDgY5JHJz0r8klgsXVcZ08RJVF9rf0/H5i9rK/Ilufvn+0f8SPiN8ULvwR8HfDsp0rW7i0js9XF6xSP7VGqh3kxgASruIOCMYAPNfO37UX7Dmon4UN460DWzdbbe1stS0fXbj+zblntZUaCWynU7f3crHdEygjqrggV9s/FTxr8PPC+kSePvjHDGo8LWcOlC4SRTOJWUJbBXQHzEfAjdTypINfH9/490n9rTStQbxJpEtze32oz3uiXkk5t2i01ZXjibynODEiwk5I+8euBX7VknF8aeX16+Z0J4vNHP2aateMVonH833OvDU50av1ijNRWzW39XPjPwpfftxfAzwnrfxL8YInifS5ZZZDomqRx63b6laBButdRvcNIJolXdAz/MBjaSOK8vvfhNZzfDfQv2mvg/K118P/ABJczT+JPDMFsyal4f1DU91oPsMH7xTHNMQhm+4x6qrGv1t8Hfs2ftNfBH4beKNSsfEVlqdrcvZ63baHEkglkggIEsYyNjOY12hSMGvjzw18SPC/iz9kfxH410Z9T0y/n1250TVNMs/3CWkt7qCG2do1X93aTyBYJxgeRJsm7Gv3jhXiDM6kaOB4py906UkkqjtZt6K/Z6+p9PRzWdeF8LSV17r728/0Pyfm+PFvpkrabeeHtAu5rdjBLdXFsscszxna0jp/CzEZK9icVH/w0Np//QreGv8Avytfp9Ne/BuOZ4/iB8KbObXlYjW5kuSVkvwf9JYHZyDLuIqL+0P2bf8Aoklr/wCBB/8AiK97/iFMf+fiM/aVf5mf/9b+x74f/DPR9HsP9KCPLISWEoyoB6V5T8RPhVqI1iXULGKPyZHyQnb0wK+vra2i8sAbSBjjFYutpFPC8GO4xj2r7/BcR4qlVdSEtWfKYjKMPOmqbhoj4Jj8E69Llbe3YhSVzwOlLeeEtS09VN3G8ee7dM19WQRWdnI5lGBnv0zXEa/4d1zxEfOsEaSLPyAEda+3wnFNSVSKq2S6s+dxGQ01Funds8NtY/s+WmCsVOVJGao6jdR3MhE3zADjAr1O5+GfiwlQLSTBHzc9q1dK+F7tOv2pZFXcFfIzjPvXsVOJMFB3lUTflqefTyTESWkbep4Iq26LhVPtxTZYlljwwOM19vD4FeGZ7YThmTK9vXHvXFT/AAb061llDGWReRHwB16GsKfG2Dbd7oU+FsSktj5etIdybEHA7Vx/j74XaR8TdJj07UHa3ms5/tVjdopLwzY25UqyOvHGVb65HFfQniDwHfaDD9oVSFztY4BzXYfDf4MyfEe2uLm8vDaJbP5cWxcl8jJbtXVjc/wksNKrOdoPTuzLCZZiIV4qnH31qj8UPjd4J/aD+FviW71FJLzxJo+swG0upbBp18iNgVwVImjBwRn92vIzvFeMfBDxjofjnT7j4dLqGoWus6NJ5Qt9MZLm4S4twu2e702dy6zjHy3VrMCRnOOh/oT8a/CfUvhtGk0eoecZnKgAEHaOh4PfoRXyH4//AGb/AIM/FXVBrnj7w1p91qqKUt9YtI/smoR56bbiLa/5mvg6GTVJx9tl9fnh2krH6UuLMPNqlm2FtUX24v8AFrZs+APDcfiLxzJJrurazDp2u3guItGvbfTFv7HV7RFUz2mp6VI8ago+QzJIX55+Ycx+DPGDfC/xBqOm+LrC4uPDl9FHC+h2CPJPa3sTFvPto5mFyiRnJiyzFV43DAz03jb/AIJ+/Fbwx46HxJ+A3jzVGaCCJY/DuuMNkzwktuEwBXc4JQllye5ry7QPjW2oeM/+FZ/ErTpdH1qG+iktbTVMtf2lxCT+9t2k2sCzcxbWKdu+K8+vxDWwvu4jDted7p+h7byXKsfJzwVX2iXk4tadUfSemxjRPh1L4u+FIbxT4U1EQLeXVrNtuNPu/PzBqk0ahiGhmbdcSwjLhQWXcCa7LRvgl418Xafpmp3egXMwbVrwf8JHoqRwC803U3MguJLV5A2BNiVVLsQDkAV+bH7YH7VP7Rfwl0OO4+Hs0Vnpt0bjzdbtLVbdbibzUKO6oMw3MroUlQfI4JJGRXguoftE/HTwrH4fim13xDf+F/GGnqtxplvKweyeVEnWZJV/5ZoXJjU8gV+fZj4tVsPiZReF5Y3913vfT7jy58EqMuXmst7eXqftpb/AT4teAbG/17V9PvNRvdI8SaVJeanaTrAn9n286tEZbF948sIzu0iMHL5JBqHxn4a8X2/izxTovixNQl0yG0iuvCmpX0MlumqXwL20SyTRMWlawMoKFQC4bfg7Sa/Jf4gfHX9oLRfEGm2934o8S3UXiDwxcafrlnFJKPLOn3KRxTuyk53xuMqeinNVPFn7Yfx68E3Meg2Xje4gsPC+ovb6dot6BPcGSO3do/svmcokAZQxx9047VxVPG9UrSq0rJnNV4Ijpapa/wDXQ/YDxN8INT+FEfhu/wDGOpJbafplt5mo6nJaRpunsYgLS2tvPLsFLM7KxDO7nJGa4aXxD4Z8O6Xc+JdAEOpeMdWv10+68R68Jrmy0BL1SYYInlAa4n8sFY4YVUyysRkLX5V6v+3Z+1N4m+Lej2/ibWbHxYngOzTxJf3erwpJYW928OyFiigAJGGLMxySxFfUHhL/AIKn2viTzta+K/hSK/8AOvYLzS76wCQ7ocx2i3MESq+Jg24+Yf8AVIOASQa9bC+NGBcac505Wls0tH/TM8x4EqYeneE+ZP8AA9vTSvEngf4fzeF/Esmp31xHrMp8Jacyy3k8dzAiSXV9eqhJmkiaQJFaF9qgiMk4JH0HPHZahGdI8U63f6dq99Baa5qttf29te6ve29tjyx9hiP2fTYi5HyF2I7nINeI63458KaVcfbLnXkTVEsZ4/C/2e2uLXS7Zr51klaaeMmUttAUZxJIQWJ5ryS0+Ofw50v+0vDmp6haajHI8l/rGqanybyfOTGlnbjeIkAwiySFsdetffR4owVZKcZ6v7/uOHCcF46q1TpUXJvbTp6nzD+1D/wTT/Zl/bj+JereKNKs9Ug1qKwuLA2DXjajZC7ndZZrrMRhjs3LHhEZwzbsg9a/mn/bT/4J6fEL9ge+tPBus634dmTWxdLZ2+kXE4EVtuDFLtZFJZxgY5Psa/sW0jX/AIlfG/wz9t+F2n67ptlAHSystJsDYxKucM0smEXBGGG0gdMk4r+WL/gpnL4n8d/tmR+A/EEdvLeaeyWFt/ZswmWSKOHMjTM5ZA/Xfg9etfn3HNegqKqUqdrf8OfXZ3l88DSi54n94rKyabsl1SZ+VNp4P1r4kxW2laK0x8PWurwiSDy3i02TUZ4jkxo3Dy+WDj+LGT0zXB+KtO1h9O0kakstz9mb7BZmaQskMPl/ciQjEa7mJKj35r64+FXjS9+FWoah4els7S8TU7DWdLhiuC8kNpcTQhEvocHaZ4YkKhgBgMcGvJ/iVDJe+FtGe3YW5nlkaJSNxaNkXJyemGBFfKQSeFp109738v61LoK2UTmndt3/AOD958z6PPpnh3T5rCZ5ru9u5HjMMKPJAqngMVBwXGCQcdK9y8A/EXxZ8Mvh94p8HeFNkM3iq3tYv7WVv38FhaSMstoucp5dwtwS67eCqkGpvh7f+BtJ+Imk3+vQ3mr6XYTo2u2Nq0aNKeQqW7Eckn73oKd41l06DxT5qxxQQaiNR1K1tCoBt4pLnKQ+nyjaMD0rN11zqMHe55WX4nnpq6959DsP2b/2nJPg5p/iHVrtHi8S3VvcWdlrhht5LNbKeIJJE8BiLNcsyJ5TqygDcT1rL+H+sab8XdAXSPF2l3/iTxdd6rdJoVk1u8qLZSQyM5UwEHzPOMZXggYOR2r598UeMZYNIPgKxS0MH2xL9ryB2BdxEU5U8DGTz/Sv0T/4JQ6t8QIv2tfh1r/hiOaSUanNbakYchfsUmAY5ioJETqvzEDIr18Hl2HniKEJe6pSSdu3/DnrYHNquEjicVGC9o4taq97tfl+B9J/s7/8ENv20PHev6BdeMLa30zw7qGni/1jUYJ1glsbdxlAyzxZLj+MKrbemc1/ZP8Aswfs1/BL9mHw9p/w5+Hg0241xrKM3epwWqQT3BjjVZJYY1yIY3ONxU5kPLda7rQ7TUte0C91myt7m8l1C6WK8upnLTxfaYwE1CEDh44gTHIqgCTaCRnNXvFmkv8A8I3pt3JfzwajpryxXskCLKLiYYjWZkxgQn5W28AZ9RX7TlmR4LB1/awguZbX1t/wT8wzDOMVi6fslLli+2l/+AezxyaFagS3NxkPC10pAIXykbZI3yg/cYjI6gcmtW0uvD08bXKXtssKyiATtIqxNKc/IrsQrNwchSSK8IvNP8U+CJ7O9mWS/sdH8QH+y5LVyYZJroCYAlc+XvV5Im3ZUKc44IrRgs4Ph9pGvfFHxVpH2jVBrH9n6bAsizQWc0yqoW0j+6EaVjuZQGfljjOK+sjnUnblkmmfPvJVC/Mmj3e2Gn6mN2lzR3CgAlk5Xn0bp+VXIrRJJ3hVkd4iFkQMMoSMgMM5BIOa+Z9euvF3g/StSHiCWRLS2vba9lmZswrqN5hIraPPynyid5VeC5APArQ0W+07TvD0/wDZOt2ytqstlNrPie9lWeKaYxoyWttChHmTSIgCoGO0ZY8tik8+mtHYyjk0ZNpbn0Q+nlz91juBIUD0+nfms+bT1E+HRlkI4DcE49PXFfN1t4k8S+IbLxL4gih1GymGpwWNq0sph8/ylVwvlLhDO4DBlztReGJNev6fqvjSy1q2Eyyw6SBJPLezustuIgoKwszAFppCeNg2IqkDJOa2Weu9tP6+Y1w/N6JHWTWnyfOrHHTFVWg8xBGytgdKsx+OtJS2UvF9ruZJVVbDT1L3MSu2A03PlxhRycnj3r0LRbjwjr9s9zpV7FchHZGSFgSpRtrA+wPGeh7VpS4noTlyLcrFcK4qjHmqRsvQ8wNvEqlcVAIEHRW/KvZZdG8PjAbeCRx3rnL7QhbNugbepBIr1aebR7HkzymSV7nnYsfMOApqL7C/J2njiux+w3BOdpqWPTrhhnHPZfWu2OPRyVMGzhhp4Y8hh3JqePSoZsKnUjIHQ49eawvE3ja48P8AihfD109jYxLCk7STlmmmDNtOxeBx35NcDdeL7jT9fvrS2aa4EOqQ3sCyKbpGt5YmjfydoyqsGIYH5Vz2NePieJowbimro+gpcGYiVONVr3Welz2dnHKkKyoXMqx7Nw3BieMjt7Z4Nfxbf8FKY9T8cftPeK/BkPl6te2HiM2sAZzEbW13b2YxwBUdA3JUsGGDg45r+vi8vdUkim/stlu98S2szSw5KqzeYkLsoJhKJgA4K55Ffy2/8FKf2ffBmpftU6qNL02Dw3Y3ukxJNdXl1Hbr/aDvksqJ+9myoYqwBbk5PavzfxOzWGIymo6suXls1trra2u/lY9XLsmr4GvGTjv+TOC+HfxRtnsJ5fD+qeHdNs/DXg14LyVxBpNjd6Y0yOn9m3CeZcOWKMpt7gyKAxJ4zVrxv+0l8Hv2ivgh4n8QeH9G1LwZd+INEgtr2y1e5n1GK4XSrlYUurSeOO3iQKcOCNwIJXPFfP8A40/Yp8NeNfhBD8T/AIB+Fbvxbp9yY7G6vdImkuCPsU6G4iNuyqUZ0zL8pOVz06Uvhbwvr1/4ws/H/wASdOv4tE0jQW8MWen3KtBFa2pPkWwWN94RTkOwPcda/jXLcNhPbQqJyir6c2kl5Jdbtn7jkkZYepTlKXLzLR+Xb1OF/Zo/aG8Y/Br9q+5ttB1u48SCC5fSdRstTsxdWMkcP/HtctuQ/vVPCMCXUHGeK/c39n3V4fhX+0Da/GX4e2mqS6nrer24n0nW5PPgtEudqSxNdwPE/wAzqojXYykDJxX4PWmrap+zp+3p4g0ltafSfDt1rsM2rOsH2yziEMa5e5j48xGY5Az3r9lP2bNS03x/8ZNE8dXd3cx+GZtS8rxFYzSmTSmttPLWsd5bJjdGk4KuoP3WVgCcivN4jyzE4XPKFalBRTa1X2raqMkrWT7nm5vhnh44iUnpdu766627n9bt5+2/qOlxPpkfh+GXU4l3fYJbownywgbzXJQtHHjPJQn0B614D8cP+Cwfw5+Aljotz438G+Jb5df1OfS9OPht4dQEktsu6U7j5S7AQQCGycdK4PWD4ksPDV9L8LvDMpOsFpJdZeMMsOm2yhFSBjlppTEMIuQNx5r8qP27PiPpHwF8ASeFbGxmSSM22pwxzRkLpl3PDI5ijIGFmkSUeaeisRj7or+tOKKeAw2TVsZCKVXl0tK+tvyufnVLO8VGrFTlePp93Y+iv2vP+Cmf7JH7S2jRfCn4h+GtX028eS3K6haagkOrabJNEZo5EeJdp8s43xsxU5xX47fHr9mTW7vwebi21K08QjVzKdO1qwt4leecKGsmmkx5kbSjcs2cruHB5Br8m4fhn47+I/xZsNV0VE028vbeOebVxu8sExZLyAkZ5ycjOa/Yf4GfGfxD8PPEenfCzX760utB1HGjX93bIXuILgwFBcRMD0EpDBO2OSK/hjirFYnFVliYSjzJXeiX32/U9WpOVaLUjN+FfwN+I37EekwfFWPRLzV93g7UV1iSKVJY7a/vY9/lMqnd5ZiPBPU554rO/ZP8A3cfhCP43a+bd7S81J4prGIyCW8iuM7XaQk7VRQQUCYI4z3r7e8f+Kfin4f1OA+JW0n+wZtPtE0ae2uCby9hRxH9pnhwVUbJGUqxJYFucYNcz8NdAbQNCl8E+Ar3TLqK/uHdjbSoDbtbyHcI4ZCSvBwQeo6V+dVcZVjGU6ms5NXaeltbelrkPCSglKKSS+8/Pb4wfFTXPhv8Sr3xN4FuYfsltdWt1DojxqkA0wSJHLHBCw2FVJG5c4OcgAgY+k/HPjrxX+0x4Ij+KfgfU7ew1e60n7Pd+H1jEcMjafEpR4Bkja0ACFB0dS2ea+j/ANq/4DWHjL4d+Fbf4Q6zPpt9O0N/4oudctY7jbpxJVks4HwrnzAcKD8wAryXQNA+HHwd+JGh/DS3v7y90/VbiLUF8Q31vHaCEtaiORHjjGxMNu2bex56V7GKwkVCPO4yq+t77b9A5pbSldH5NeC/hB4/1r4mal45tvCWox3dlp00xtXwy2N40eyG53sybogxDgDJU/Sv62dR/aFm+Ff/AAT2g8CjWLU+KpfD1wDaJIWmDoqxzSB0yFUbW2A53Zz6V+Vfxq+Jfwd/tC6vLmWK81G4kgtY9JFxtcQoEgV4xtIfkZ6jls183ePo/hfr19c3Pw68W3Olaml/b6Dcabqx82OaDfkpFLnadjKIyRwRX1lPiTEYHEReHg/htdpta20uYUIKkpRg9z5u+B3x18Uaj450T4VW8E09tPp8d1rt1b4eaHbM0wUuV2I2OF3YPPfivu74q/EPVdZuda0L4bapBZ2KeHbW3O8H7Tazp8g4Qrhm80qw25O44xXoXxu+H+qab8CdOtLOCx0r+0bLS9S1LUbKMRteT204AlYLtIRuGJzwc9q/Gj4h/tA6LpPxwkufBMd/eaBod+00+kvMxfVLaBvMu3SRslQzKzKcnAIwK8R5TLE1Yyw8krq766vXX8rEzqW3Z9I/DP8Aaov9FeTQZ9Qu4JpYLqC7N0uUMjOVzFJniNQM885NfpOl34N/at/ZU/4QXXdUOo3mp2t9eaFr0qeaNG1HTgrBFP3jHLGpRlUjPXFfhL8YviRB8TrLWb/wZph8O2F9phubLToVEzNBNtkzHOcMTg4av0B/4Jx6BpOk/CK88XeO0vINPaKSxt7qB95Mt0nlBwpO0GPq64znuKvH4aeHj9Ym3o7ct79yotPXofLvxO/Zt+LXwe8D3+ieJLCDU9Uv7QXKXeny74rSzSZEjkdiB5nnhvlCfd6Mcg4+pP2Gv2bPBXwv8DS/tA/Fi7vrSVLc3mlWhiEQF1ASIirnOW3HkEFelfVfgnwT4q8T6zfeJJzFqmg6BpunaHLDI6JPdSX/ANouhdWMTZb915kXmgZ5Y+leIfEPwlrXhLwLea1eX91eaVpeq3C6fa3LNJNL9tUq5KHgR5OPZga7eKMPGGWYWeGxPLUrO8knrbpbsnocMqTjVlybdPM+jfhxZfDr9o7RY7/4qFrjTY9eXWr7R45l3zrES6QXr/LiPcAylVzjgVh+HJvgH4T+IN01/JewX6vJDFLav5sENssk4g3qzFW2wSeTsUgKIyxyTXwFp/7VPjabRbfwTrkdq0FhGQ1pbR+TteF/lDOo+b5R3/E15jpeta38SfGNv4n8aX93baaltb3R0zSUWG8uoZos7hv/AId87IzY+6ARXRkOfY3BUfY00oqMubm15r6W136HVhsPFS5pRv0P6HdP+K3iXV70at8IYbnXFg1BtBvNN1SNI7edYbUyqxnjIeEtuwpUHdivh/42fCzxh4P8d+Jr7w1Jp+j2Xj3T73+0fA8LvfW02p3Ngyvd2806qYmwu+W3PMqeYynIFct8NdA8Q6jcSeLP2f8AxqmoW4u4L248P3itY6jvtokRiy5x5gUbW2EhsE4r7cgSfUfhLF4f+MEP2PWNat5dQ03V2VRPb3ljPMtl5rcszD/U9eY3I7V+jYfxhzrFqeFzHMeSMY3i5RTvJbJu2/b8y8JhYYWUqtG935n512XxF+Pek2cOlLoOoXItoltxcyaZ5zS+WAu9pC/zlsZLd+tWf+Fq/Hz/AKFq9/8ABQP/AIuvp7w7+2v8O/DXh+x8OX/2uCfT7OGymgW8jAjkgQRsgBXICkEVsf8ADeXww/57Xn/gbH/8TXvf8Rkzj/oaQ/8AAC/rdb+c/9f+x268cGC4McJZgPSpbbxVNfPjD/WvzU079vP9ndPiH4h+HHinULnQb7w9ex2Elxq9u8MF5I5IP2Y4LOFI5JA61z/gL/gpB8G/Gni3VLPSWeDw5o2jy6hf+Irl/LWG5S5FstqIxlpXnPzJt5AA98eviOK8hpSVF42KqXa1fVd9NPmfE08zcmuzP011Ocn52OAxJNdB4X1SK32+VIeD09K+fvDPxL8K/ELTLPVPB+pW2qQXsfnWpjlAZlwCTsbDDAIyCOO9duLp4ImnTdGFBLu3ygADJJPYDHJr7aWEhVhGSldPZoKOYKMtGfWdnrEEtvvlPK9elVbu4s7mAx4GDzXg+jz317bR38U7eW8ayJggqyuMqQRwQR0OTVfW/GKeHfIOsXkNuLmdbW3891TzZpD8saZIyx9K8Crg4QTvKx6/9oJq0ke1Jq4VvKPKjgAe1ST6na+VvbB6YB9/xrx+31S8eQ+ejpjIbdwc0kbXNzc7d+FJzjP860jl7tsNYi60PTNSt9F1KzKXYzxkAetRaVrtrpKiO3LwhcKPKAGQKxLeLT4x+/dtx6nOQD7VDNFp7/Msw4znNEaPM1Cb07ClO131IdZvz4tuwtwGbaCEZwWK5+natyD4d+FJvDUik7r1R8sqhvlYjsp7Vi6ek1v5kumMcldvqM1ONTu9KIiIJaQ5O48nNbzlOCUaVS1uhl7OE7ucb3PGdR0q/wBPZrGSMtIXwhVccE8V5j4y/ZP8CftQWq+BvivpMFzFFmS11Jf3V7ZMOQ8E/wB8YIBK5IPpX3Fp2m291Kby4jBaRVGG52kDtmuy0Hw6LRHlnG0hvkduOK0zXiCNTDzpzgrvTUwwOVuliKdanUa5e25/LJ+3L+z3+0v+wza3Pj3U9Eb4xfDBrL+y9Su4bcHUrCxlly41CAMfMRQRtuUwUwCcV+W/izwTo9lZXWmaD4eFp4S1BI9c8N+Ir+S6eXEPEEDhA0QZeI5tjnsxC5r/AEE77TLbVNLk06+WGaCeMxTRyqJI5EYYZWU8MGHBB6iv40f+CsX7G3xY+AOuN8KPgHYXFz4E+INx9o0FbaUxJ4d1K0zK0CBiV8khsRoNvyZXnaK/IsyySNek77rVfqfolbNJYjWSXN+du+x8T6t4u0LXdAsviVpdzpSfb/C1/dRW2L0bNRj2w3CRgEgIu1CQfXNeVfHceF/CHxC+IDxT6RcSaf4d0qDT5YJ3OpzarqTrJPHAs6KRM7AkqpOF+U1jeCZvGd3pfh3wx4QurixstX1qDw/rEcDFBBPf27Q3oVgRwZLdt6nocH1rwn9oSyk162134oeNpby61jXvHAtdKtre4a2a2m0V/sfyxxlo2lby5C0uPuAHqa/G83nGpGnRgvdnfV73T28j56WYTqe/SlZO6t1Vj2HwN4hsta0l/h58O5LzUfsxtjqmnQbbrUdXvZF8+f7ZuCRwwxvkEFjgKRg4zXvPgX9qL4BfCO9uLH7eNZ8Ua0o/sjS9NiigkWWMLDGInQSpBFuB3MVJKp8iljuH4aQeJPGHiv4lX3g74WasNP1PVdQmm1y6glNrCBKCpzKzoAFT5QB8zk/n/YH/AMEmf+CUfw1/Zys7T9oLxfNd6l4uO9NJWaMwJaWzKu2aZASWuJUZgw3FNpHXrX6n4YcHVaNLma5nLrL7Ktul1u7+h3R4ilgafNiIKbe0bu6XdvT7vI7L9nj9m/4r/tC6OnjDxBqll4f8NxXs8VppcMKzSxvG3lyhgH3lywZWMjBwep7V+nXw4/Za+DPw2tov7I0e2u7uKU3AvtSiSVw7ckomNqc9AAfrX0VZafDBAVtUjjVmLFVUKMk5JwO5PNPlhkhALEYPFf0DlfD2GoxVknLq/M+Vz3jXNMb7sZezp9o+6vnbVnlHxU8R3XgnwHqfi+O5MC6RZyai7tE88SpB8zboYyCVxx8vI7A1/ncfHzXtW+Ivx31/4y+OrVL2fUPENxJYyWx2Wdyk0hyxiCh94ibcBwTjmv71v29/itonwQ/ZL8afEDW57SDy9IlsrZrtiima6GwYIBO4LuK45ziv4ovhv4GX4oeBbq+106PFp+n6taapolilv5N9dyOhkPnX8RB8kRkrsxuHUc1+H+PmfQw8cNSekbu/4Kyt/Vj43C0f37k103Pm2+/Z80m+0OfVPB5b+2PD2l6vqlzILiCSyk0xYi32hSp3BlVuYzljhv7pr528cx2g8P6LYa2NwiikKrIQ0cO+VyksqIu4iQdF4xxmv2S8K+JfAEuuXXgXUvCF5E2ozRz6PHpmqqltqEkZ8tZIRIgXyoFcqombdJvIcgdOO+NH7JHjLWtH1D4o3Npp3hfQLnfpumyXcccM+p3LzSTQskfmFYnjJaN3UtGz5KgCvx7hrjBSoVcLVTi0nK7as7tbWbP0fD4uFPK505PaL/GUdj8GWtLfxL43fwlouoWjwaXEsFp9htWR7iefgoM52Ac7iTx2rQ8Z+HLmx1/wvZTssky2028su1QkrtGCueo+XIPfn0r+j39mj/gkl8PfEOgaf8Q/Fvit3/tHTRdJpvh2JFvbi4QE3ET3X3Ew2AcRknk9ufjj9p//AIJo+MNTn074mfCR76bw3pVusmsNrkmbrRpZJBAttK0aZmd5/kiCKD82SADkezlHGeFqYunCE0uTe542X4tRxNJp3S3Pgn9njQtVX4Z678L/AA9pGiXGq+N47qbS9Rvoory5S48PL5y28CMDs8/Lhj34r7o+APwV+Iuh/tNeBvE3wL0+6060uNH0TWILvTYZfs1pe3CL/am5kHDptkby8k8gAVB4F+DE3wU8UeEvhrb+KNGi8ZWXiC5uJ7uGJpIj/pKbIHkKsYZdiEfMD94hiK/oz+B3g6S7upPiN4etbzR9Ft2tRrGkukYaNmkMiX9tFEFWRWdfKde45Brl4l8RoZdV5qa5ot6P/hzsxGNtWly6q5+hMv7Q3gTwd4lt/FulaXc6pdtcx6npd/YZiheyv1Bljmi2sjqjjO5dpz1C4Ofif40/8FOtT8OfFfTPGXhvTdOtNDmvr2w1m501VuLa+ECbbXzCVKxurk7gp5IrzLxJ8Ur66tb/AOHfjW2urK5vm1PxHbWIAt5YLPzZbIW6BeI0jBEojONqzDuM1+LPjb44Lqfg/QPhZIkl3qkXipr+1uN2yGG3IEaw7Cp8085DkqAexr5XFcf5zi6rm6zivLS67/LY5cfj1SklKyuj+on4bf8ABRzxRfa9L4eutP0h4o57Ke6UQxqJBFD58spxlGk2oVTHOfpWbof/AAUKk8V6nqOka74J0a/tbySS7t9IjZobizv7mTEihghSTYwLGX5flU461+Nmh+KtY03wJD4w1G/lF0niaDQ5r7IBiiiN1O0rBQBJsXep7tgAV+oHwZ+FupeK/At98cNUls7LU9RTSp7axZEBWFGIiVu5byny/wAuA7kYyK8vKuPszdRp4p2V/vR05fjaat7ZJxMX9r/9tGO+0vQfg/4c07TdNhku7C8a8tJGuduoXM0zSlwyqDst4pJOf4semK8E8c/tXfCTwxd2aeE9PtpdG8JLZTLpMwZp01GH7L/ZzRY+WPfA1zLJ3O9FPGK+Yfib4l0DWPH3jjwr8Trp72HT/Gl5p9rIzDyLe3t7B2MzbFDlIDIVYKwJz718bP8AA6+8FeI/EEuu6nPftr3hptajlit5bqFmmugYDbuCp2qAkcQIyxMfQA17VLj7OUvfxckui6P+vzPLxNWFSTahY/f3RP26/M0Sy8UapFoL3Fg0FzqNiHDSx3vzST20UYykk0cLBmcDbv3emK5f4gftB+OY/GVrJcabf/YNUmE9ratcma3AkkgKSzsQCzyFyETIQnGAAK+Bf2HPCF7J8Pb65+KkQ83RprfRtL0uXDtZWhLmWWX+F5yrktkck8k1m/thab4v1e5FraXl5qNze6bPP4cW0Rg9jcWLoYN5YkB8F12jGMZHSvDoeIWbwxMoUsY13ZthsbXpSjKnO1tj6Iuv2xPFV/4+0jwT4laWa98SXyWlna2DGO1VzIF8iKOEAMVYEh/mJGc1/Q18LPhPofwu8NQ2mmacYL68gSTVZfNknkln6kGSTJYAn2+lfzz/AAR8ceBf2X4rP4i+KPDNh4h8e+G7TUbi3RpHml0tp7TajlmDBmkZUUYxtOec5rvtD/4KH/FXw7dv4x8Vao+leUqW80blpXlvJYlknlnLYQqX/dxIqgLn71fuPhp4h4WhGVfHYjmqy6a2S7/M5czzPEV3KM5e67aWP6DbuGRHCsh64IPalbS7grtcLyOmexr4/wDg5+2ZpfxC8Homv3UF5P8A2cmqvqkEZSziW5maHyt7nLSo6sRGD8y91HX6j8CfFL4cePb86N4O1aPU5WhWRpYYnEIygZsN0GCcYJzniv6TyjjjB4tKNKonJbpO585PDK946o1DogBA9fyqVNMW2kEjIzY7Doe3WqHjvxr4P+G9pv8AEmpW1qQy+d5jgeUhONzA84zgcc5I9a+WfiT+2l4J8F6lHp1hJbRte3S2Gmvfbs3bMFKTRxx7iyHJ64Y7TnivTxXE2HoRk6lRJJNu7S0XqZuguble59cappuka5p/9l63YW11bHlo7yJZVAP+8DivyV/aE8V6T8M/i7B4a+FNteadcQ3bSRWFk0jRviBiSiSDaiBsb41PzqSVr3hP22bv7Svh9f7Du55HFuzpKQouWJP2WTHCsADg5+b614N+0V8RZvib8QbXWJdN03TNU0QNFcNBK0ko0+TyjGSQB5p+cLtI4VyQwIr+e/Ezxfyv6liKGXzU8QrcttterfVLW57WExOKoLlp1pR29P1R6H4F+I3jzX3ll8I2EGvwRzxTfaLK4+y3N7GqEPiOQOrhmzkBhtwMHnFfzof8FyfA/iHxd8TLT4neA/DOv2U/hfw7Dd6lcTWdyWg8wl4yHOPkRd26Rd6A4+bnFfsf8NP2hPDHw28aaT8OPBhW3sdNurOBrVhuCWU0584ec27eHjYFsHPYGveP+CtXw7sP2qvhLo8PgwWY0ITx2MEqTeReyPHC5hjtcoRtEm0SBiAUz1Nfn/C/ifjsZgKqzCSvFpWezV1qj6bB4328JLFayumn10P5bf2A/DOu3ugNrngbXdQa816x0nUptHvbiW3RNQs5vtbraQRszSSLEpErEoCHwa/Z3x34k/aB8atP4D1vwJf+GTeaesttfHQvt8V7qTK/kGNFYu8ZGPl2thjnIxmvEP2Tfgl8Sv2YPBnjA/FOw0a28RW1xc+ZOCZLxbWGAtZ4c7AIQxklQIMOCufuiuo+PHx88X6P8Ror6e/Syv8AQodPexv7eZ2nyVJllePcwk80PiRcqMHivzLiLiGhPN6ko6xp2ta623SPaxfEkJ+zjJW5NPkv8z8ffG3wZ8Rat+1N4gudX0f7JrOm6HceIdRbUpGFpJeaTDFL9naMoBGjvkSKD8i8Gvsj4QeJtUvvjjcRaXp0d1e+LPCF/q9lp+lRxlNP2TTLFawx2pIlQIVKjaGAwT8wNfeviDxFonxR+G/iH4hapoGj+bpkFxLreoLD5Uuqw3EK+YjIjK0crRFiXUt93kHivgzwl8OtO8AfEj4f6zFrVl4d0y40a4fwv/ZFoGt76yjleW2+03GfME0oYB85BfcCOAa+oxXE0M0wOJxEYfvKcbpu/l5H2WWYrA5rUq2ThHkbSerTvd6vv+B+gkfiT9pbw74c0HwjoWs+Kv7Q0/RlutRuFaZ4NMMcWHWVVOMxpggH+Nh1xX5V/tq/G79rD4y/EfwhoXw+1DVbDQdW1CLSNPuvEIii+0alAWFzJ84VmtyxUebJwWyB0r9MvDsfjbQtc1K+v5obTTY7GK+13UNRtnicxzSHyYkAmfc8zEpDGBlgcnFfKf7Ynx18XfHL4hWnwS+APgm7tNa8PahFbX+r35EjyGSEJJIw8tRFFHEhVVjI27u5BJ9fC4SrWyrEZxiZqFOKsuZ2jKVul+h8BjaFGvz1ak0uW9r9WuiPPtAsvDf7IniSSD4r6tp/ijxsml3FxoqW80cmm2VzLFst40dgUmkJ5AUbQK9M+INl8NPjX8GdN8Xagz+CvG13dWN3rV/psDvY3ZvUIkht4IMMXRh8yhRzzXxx47/Y5vdETQ/ip418SS3+v3ly1nfJqLYtY9SjfaqW4Gdyxw/KxGArDGDX1beeD9Y0e38NNdapaDSdHS3EKwPHKLi5sZAVSIEbkBmIMjHOUBAAOK/IK/sZU4VsNWcpN3btZfJbNHFl9K1F1ej+488vvjNqd1FqeneOLm+uFnsRoUUoB8lYIrmIwRwLuUxFYYtjZySM8DNfS3wh8RfCn4tWt5Z6Fa+INH8UppiONSgVDaSSRnbGViKqxc4HK8+oNfPlr8U/hd408SeJdC8e6TDbr4c1CPUL57C6YpcfaSN8xJXckfQ71AY88ivsWTxv+zvonxZsdS+D+j2N4+vaTLKt1a3UkyFo4MQtJuzkqhyTgfPiuOvha9dx9tFpvZ9DCrSruHtJ6Qf4nn/hP9lH9qX9oX4keHPFGk+J72K00+N4tRsNUDmNIUIPmsdw2NC6+YuByfl716z+1Ho9pNoMngzT9UgttSupJr+21i4kDQsHYQRGLByFaMEsmNwf8a6XS/8AgoX8RPhHoFp4Pj0iO/ggjl1F4tEctLNa28bSTNeO2djFcsR0UA4GSK/Pb4pePPEHjvwBb+JPD1jbSz6vrR0eyniumNvANvn3dtE77ZgwyxDKpB+7xXl08JjKteLrNKzsrJeuvf5nG3HvqfLPiP8AZy+M+ra1r/ib4geKP+EdtvDAj1l3vbGSKS5t4JkSIpH5iudxcMq7cbRuNUfDfwP8T3HhS10rwn41tvFVoXstT8pYHjUW1+Vu1lQn98jk/K8TIcEZUkHNd94Q8E+JvGujTeBZPFUPizUtZ06bTLpb+zmS4sLm4nVI7T7dK6tcRNsAVlIAII29q+1fh3+wzafAGxj+LM8F5rF1ouhRaTLoVndNbQZjik8tLohncSbnCxhMyAjjAFfS51nyo0vYzqL2i2tFWf37eplKatZHuHwt/aA8L/FL4ZzfDDxDm5n06wgFrNeToLsOIQZYis5VWQkf6s8jjjNdV4W+Dv7EH7R/im5+HNvpy6LrDacLjSNRmtGi/tLZGpuSkkZWMcb0KgMARg1+Ty6lqug+NNM8RXWjahohvHSG+sLlpZPnZAUmDvGpKHu55DZ5rof2cfiB478MeLrKSLW9b1OFNXn0++8Pq8xjgcX37u5WNgUfCOzYTBUDccivLnk0VTniMMvfWujer/L/AIcElLZHj/xy+AHiD9mL4lJ4NinkvtI06zmOkTXB2SGyv1/dFo8kgoTsYAnkD6V+hn7DKaj4p+FNj8MtOnt1Gk3dzrOoaZhYzq1rOjRXIjlLEedBw6KB8231r6v+HqeAfjXr9zonjyG1RXa50v8Ati0v9l2ieY+CqsHDr+7IkRhjgkCvjzxH4esf2Zf2tPCOi+B9VOqWOrzX8M5LLLCVCPHBIMEnMjEbo+nGa9SpzYvL1VlTcZa3vs7J7Pr1CnC2hwuo+LtV+H3xi1G30G61b7boOsK2g3qqWW2hiRWupJVOUWNYXwWcDa2PUV7L8QPjp8NfjJYw+GvF9tc6Iuv3qxanrWnTDyrsXN1Ja28s8TH92jSKJCqBScknrXm37ZnxQ1rZp/xp0ix0rSE1VtN0nxzp1iggGqy2MwwY14JDDaZlTqUjJ6V803VzqnilR441a40G20288U6bbX1xHdq1xHALtp4TMoUiCYhgoUsFyM5zxXPlOUxrUY1ow5ktNN791/X5nQ8O38OqP00+Hv7Afw/8M6ppPiObxRob6bd6vFaia7WQfacTBBEivJyWY44BBzivgr9rmXxb+zd8QH8H31w2owW3iWebT9SMaKJdC1JjdWmJRjbFHHmLYufmRsDivtrw78Q/hlcaJ4c8Haxf6hEsGpahMvnbXAWW4KQtGmZFYbyrBh6HpXwb/wAFVNe8MH4UaGum3ltMNI1NrrSNTtcpDdWZu5EFsYjjY8DtJuAPRj0rny/BxnioU3zNyevN0308/wCuxEqbi7H3R+wl8VfC/jnWk8GfECG0sZbewKTatjy3WWZ1mtGV/kyy42kH+E9a+1P2xvGljZ6Povm2d3f37OLSZtIQXYthPKfsV4kMW5milkxG6nBVjwTxX8inwm+Od54x+I0Gk6YJra3mm+3RXVnKYbePy0IeOUNuJUKpK85Dd8V/SV4J1Cz+P37JWqvoUcWqeIvDMDanoQ+1PskV0DTwlkClvMzuCN0cZU5GK7+KqLpxpYOvRTT7aejfn69ByStq9Tibnwh4lS4kS+8K3gnDsJhJpJLhwfm3bkznPXPNQ/8ACJa3/wBCtc/+Cn/7CuS8Jf8ABRHx8vhTTFm8VwWrjT7YPbTM7yRHy1yjs3LMvQk8k10P/DxLxz/0OVp+tfN/6lyOb2L7H//Q7H9tH436H+0H8cr7xW2hWuhf8I+/2GS5Em3+3It+I1LtiSKVACAqq2SecYr4q1XU7H4QR6j4sm0u4k0yAz/brezeT7HA8swkhaeVwf30eNo2fKMsRX2Ncab4Oh1TUtD0WNdR1bTY4dUjnu7Q+Skc24mVo4mmaFwVG7JYfMPmPNefXHjy0l0q603R9Q0+VNX05jLbXdo9xBGbdnXecSBE3cgoU3ZwcnoP4R4i4gr4vFyrYimm5P3mnpLXdW2Vr2Z+TzbSSerPZf2Df2u4/Afw48TfGDwxplhe6xrJbTUjvJifsccKlo3h6EiUt83AyVBNcJ4D/wCCinxh/aE8P6x4G8X69PpzxXN1Dc30Vytq62kxFuqREAl1bkNuGQeRXyN4G+H3xG8E2w17xpO0m65nja1s5IhK6TBTAP34K7d3yoiore/Q15P8LfATz3k0PheBDf3Hmy7fFjtYT2jq5laKPyTKpUDJYuoycAE9voKfFWOjhK2EpY2SoxtyqMtIq7ur6X+YlOSVr6H69/s4/tq/Gz4VvD8PPBXiexFjK6SXDaxdC/ljsrYmOLy2I5fCkGPI7EV7T/wVY/a8+HPxh8K+DrfwiNctbrS9VgmttXsZEjjjuJVB3yxKSRypAUkYr8tYvhivxJ8RaFrS3NrBdgC/u2t3LR2sIkzKs1rhZYWnx+72s2FXnHWofilrV9oev638OvEtuNXivLaC90yWwleOO2wf9Hilmk+7kn++SeQRjmvPw3G+YqhLLlXc4S1knurPo3951PF1JQ5Gz6d8Nft4fHv9kuHV9Ws/FS+JZfFFuJwuryJLaWtwFKwyRmR8rIwPz/wkL05FfpL4W/4KieLtA1F/+E2fR7hY9V0hdXa4RYbfTrW8hxIsEsLSCV2YBgjAHGT0Br+ZD44aV4n8OeL9L8QX2jWl4l/ozQm7mlMulwyxkExoIo871Xh/ORlwfl9R+hPh74P/APCy/BqePvDWpw2+oa5aWuqR6fBa4tt0KjMYVnHzqqkLhQDyRxXs5d4hZhktOhXjinKMlbXWK12tqlZX1NMvqyik09D+3bw7oXh3xBodp4ltZ45rG+gjuLWVGG11lAZcfnW8fBWiRnEiYX+HJr+Ov4fftqfFLwgdBtvF2sapB4f8K+JbaebRdWheBzJGP3bN5chZk6sATt6YFf0AfEH/AIKgfA3RNd8JeFbO5TVp/EGn2l5dX2nlzBZm8dYogyhC53neQMcBea/o7g7xWoZjTlOt+7s1G19W328j6unjKPK5SVmfoxcQ2GlAJYxrtAC4+lc9LbR3kxncKpHTNCW0+rQrJaTh1YBkx3B9K3LHwf4ouYGVWjQD7pfnNfsMpxitWbJOWyOfkuZUdURgoTHzZ71s6rrN/dWykyYUYG0VJcaHPBK1rcupZeGKLxWZJpsrHaHyueKUZQfvPUvVFmy1q/hjAEhAxgZPH4V87/tieApfij8BtStp7ZLy60tk1rTkKb2Wa2Jzt9GKscGveJdHnYAJNsHXGOM1zfjOz3eDtUR7mRIzptxG7KcEBo2BIPbHXNY4xQqRlYWsmm+h/nv3Hjy48Aatqtrcafc3dunjV3kKq/7mQNI5YIWDFyWKsM5Iya/OGD4ztfaLq1pctF9qt57vVbJSpOLq9ndWK5YnKqeFx3INfrJ41/Z7uZp9Q17w5e3U9/p3iG58N6OJZxM19cQpcOJ5oo2xI+5lWMnBySTkDFfPHhX9gD4nWGqNpfxusrTRrjU5LWaPXNUuYLAKZ2VmBTc4fzHkKqw27MbtrZOP50xOR4OWcrA1MQlOdmk3Z9/y7F43JYUZJwlzdd7b62P6Af8AghF/wS6+D/xD+G1t+298edBs7661m3RNJ0PUVF3bRSW5MbXZ3gAmUAHaQQp6V/Rde2tpFeS21oiRwxvsjjjG1VVeFUAdABwK5b9j39nfw1+zj+zloPwg+HLRR6fFZR3S2qXH2j5pVDOyMWOVJOcj5cnIAziu9udMKX8kbbkJbBXg4Nf0lwjh40ZTpxei2PKzaUpwi2rGUluowAcc1aFoX+6c+ma0YbBSV3lvm6cdcVHq1xZaJp0upz+bIsQGY4F8yRiegVR1JxxX1dXG8vvJ2PIp0pI/IP8A4LYeJNB8OfsOan4S199jeK9a0vQ7ZfIMqsPO86ckjlAsKs27txX4efDP4O33xZsodMjuh4X8LaTZi00K4gJn/tGzdTvkSRFBlK/dZ2BwOlfsJ/wUm/sv9omXwLoWl38k9hbXGoapLazWUsbWkkcKlBN1ZRJGTEQVJ35x0wfyIj8b/tFeHrp9S+E+mWrWkLQagbLS3FxYqjrxtsOG8iQL8zKsbqeSBzX8ReN+dwzLNFSpVF+6Vk76Xer+fQqjS95y6dD6v0/4U/C39nyz0W10Kw0+MmTTtPlkvIzfyafp8AMs12Wxny5MecxRchhiub1W407xR8M2+El1aWXig+FtFaykkknCpcaZLNJK13A5XDSRvKoDp8xRh2JNew/s6/FfxL8dvDGseOptJk0LVdJkS1XTjMHhllk/d+RbxyKXaGWU/vonXKrzG7HivNNR+CE3jrW9K8WWUU2maDr9rCgs7Cfy501C8mZZrZJJIwjW/IdAMuoVUI9Pxeli5+0ca8OVrz6/qejTrTs4t6M2f2atD1/4RXUl0ZbO+0p4Le20PSoNz3Ef2qJsOCD8jAKWyep3ZNeifB6TR9L1zVk8a3oTTdRv21C/F1cR28OrareWilp7aNcny1lhfJP3GVjkE1nfFfxZ4b8JeEYfhhDqulSx6PrVxplzrt+YoZnbTx5cqMg2Bki3LHwWfblsE18i/Ef9or4eQ6EmnvDdavcWqXVpY3kywiMSG3kZEEqAeYqKrKsq/LKpy6pIvzdU6TlVTpJty7aP+vU4HJUrI5jWfDHwX8IftTNo3i/QdF1Ca+8Qava6VeTTLBFDHcSpdx3MW3ctwPLmVdpO50yVOa/QD9k7xJ4Ou7W68IeHNWmP9iLf+HHJlLFfIuVhjkHmYzD5jEqOqqMdjX8wPwq/aJ8U3HinwFY+J44pp9EuL22Rrgjd5MKeTCHIHLLGEAbj7owK+/8A9gb4z6PeeJYdJvLgW7Xs8j+XJNmO5le4nlmALKNhO9TgkjjrzX0/FGUuvQdKurpbfj2M54qOzZF/wUN8V+Kfh7+0/cSa+7RT61ZTX02pQzbvPW9tvJknhAOAjFYnCkcMlfn58PbD/hPL7Rl3GW7i07zJZzn76yLGrexy2frX7Q/8FTPBfhnx78FLXx9eaddW2sxTiTStYjhLWjQW8QQQmTAIinVf3TY5ZQGAJr8mv+Cf3heX4g+O5dBtWyivbgrggiBJPPdefXAHNcWW4mKyr6w9HDRv00/U8+tdyv02P26+E3w88L3bXln41tbqDRxqzWsL3SNCsc9oRNFLEjff3Sbfm/uFh/FWRp/7c154C/4SHXvEENrFbiXydPeFSP8ARba5vZI7d2H3wfKjXdwxyc19o+J1ll+F1laa6Y3tLKa41WWABVJhtnEnBOZOsZDFeq546Cv5ZPjF8UdR+JOveMbbSrpYUu/iGtnaRRHATTliYyfQZXdknIz7189wfCWKq1G/hWvpfQ9SjPR32R+nNr4m1r9ry5tdE8Pado9k3iXT9UuIUlylzaX7rbyXlu84xuE5IXe33cg19cfDHwraeDvD92fEd3HHevpi+EYLNX3pY207CO3KFzv/AHbWxjjI5cAydCDX5hfs8+K4xfwahoSCOSzttXv5ds/ltFaP9niyTjPzsB71+heueMNKumsGvLS4fWL7wxa3+oRXs6kSXFt5hE8QI3CeNJOXyqrGrIAzGvYziUoxUI/Cr3NYTT1RxXw2u30271PwxGs8MtrKqrFPIq+ZcLcLCWJ+80agkvj2FfoP4R8IRwwXkPxAgF3qOh2t7qdneMV3qZpJYB5qqSoDRSbkJIKdAOpr5+0f4Z6SPHPhb4wNtkh17w5aW816kbNDFLDCBcKimUu7SOu4HYvtiuH/AGh/2iNN+D/7OHxBuYLWJNd12KTStGnZ521G4+0SKHJTZ5FrtUAEiaSY9WUDNfPYDmqYnlovfr+hPPrqch8MvEXh7xJqOt/FOyuxd2WsQReHBcRP5gijea5mnlwvzCZyionBzuyOleU/tGfs5eItZ8NaN4F8Eana3dzrs0EpmB8i20+xSIuom38ySM/yswwN4x1NfJn7Gfxk1TwLD4Y+H+gQtLqGvW09uk19J5NtMJQY57mMY5R3ysDkfKOnUmuo8c/ErTPhl4jh8O67qenRX9jrUZS2aRbowbNwhmVyxjd8H77oyxnhEduR9hisJ7Otyw1a2+WhU6SdnY+nvhH8G9Y+DttceJPFWt6onirw/Zi+tdDiRlsDp9zfiTy5yrELdS8N5ZH3Awr7q+Bn7SmoeGdBuvGfiE3ll9rlFnouiWoNu6TQO8Zm2KBuL84T1yTwDXzj+yz8V/AH7Q/xB07wobyTUr3VLtbBNN1SG6lhnjsJVecoiOsaXLRhnE8pZnAICIDiu5+N3xq8N/Dz4iWPwvZX1x/Dv2vTrie2UB4nuJmluFHykYC4iDZ4jU8jdzhkGd43AY1Yumn7RaJbFSjFx5WrjPib8bvE3iT4g/8ACP8AjB57iwu9ON3ZtZHe92zlFjLRkblZWkw3VWHtjHo3xI8Wy+JPD1npmn2f/FXWqnTYNPaaKyvfLkQxNJZyuCwZXbCEgb8ELxzXhl58avh9qGkah4l0aGynu7KxiF5qTHybuCC4uURYUnfJhQHDOwhkMm0KAgxXTeLNUv8A4j+Edc+MnwbsLDU/EWhajc+Dr7yNxu/7HjuDm7twx3eacL5bSL8oLODjivCzzF43H42OJxVZ3T2eqXl6NHPTw8Unyq7Plz4c/tIeDfF/gbxD8GviNA+ieK/Dt+ZIbqZfLvLua0crDJMp25lU56Hk9eMVL4Z/aQfxzJab5rqw1XQfHllpWpxRuJN9rcor21w56r88WHBPpWI/7K/w9/ah8DXHifQprm28RadEbPR/E1reG5klu4rhozbXsM2GL9AWVjngjriviX4Z619g/aZ1fQtXmtoLzUNGms9aaQNJbNqWkFHhu9gAbJeHLqVypDDvmvSy/LsParKkmnu122vbyf4CV4y1P221/wALaLqnj7Tdc0Bo5ltltbO9CIebm0ZTknoR5cgBHfAr9YNVTRdUmsNHuFkmdTa2dmiRFYrScjId1+586dPQV+Jngb4jaXpfj/Vr3zITa6ldnUI44H3IszKmVDccKQQAV4AHJr9NPiJ8a7XwVbhr1oVtb6GCKGB9ySC9CRypIhAwyhchx/d55rxnjpU5zhSu9tDahKzOP/b/APFPgzQvidqdprccmoWl7pqQanZaaIknmmtbSOEQM7ktFlZDIGUYwpHevzdb4afBn40fCm/8eGHWfDGqaQ2zVnsAmpTpZpJtVZtzDcFGCsqDhfvLmvTfjGmj/thTazqGoXsWn6noulPdRXkEmTDdRQOwaSM4a4SRIHUj5SIgGxkYPCfD/wABaf8AAf4feG/GXwongm1C60D+2tSuZS1zZyq8iI8XzMFZWBfIwflx34raWK5uarZqTevz89jaTUp80loeryeFNc+H3gQ+G/C2nT6nFFJYywi1XzZNY0jVj9lnd2GdrETAHJ+TGeMV+d/iLRpPhR4c8H+BL6O7uY/BVomnXlk+ZifszNcyIJB99/321tp+9z2r+h/4S+MtR8JaPDoni3S4bJXguZ9OtA4mFj9pt5Z2M3OxpbkAyRQ8LEpGcV+ZfhL9ob4M639u1Hx6i2un6L4kIsdXiZUuZ2idrS4kYqZAFwBK0Yz1Cg4HH1/DfEjjg62GULp6Ppdvt/XmfbZRxhQwtGrh5UOZTXL6eZ9K/B/4ZalrKeG/iR4vsr6fRNOW016PRIZEKyXEtuXSTL/ODbQ87QCFYnvXyX+2N+3X4G1HWNY+F/wA8Iz6Pr11qYs9Qv0kQmaCWM+VdTTf6xHCkMqEY5GTX2r+yr+0donjbxHqHw81qCHV7ae2vrfw3Fd7ntZ5WhK+YsiqsUW1OXBDksdpIPFfz8/tX/A2HwH8f9Nd9OTQtYlmnbU9UsZ7kWnkLIXhluYryAxQMI2VW8iWVdqbtq81hldWtUdXAV8Xz4SKvTpyV7SXS/3ux5+MzDC4zC0qcafLUi9ezR414S8e+MfFvjC8bxrdalPB4cvzpdrZySbreERPmaSTdxliSWdRksea+q/in4h1zx/+1j8Pf2UPhnb297Pd3MWsaitouww+aizGEE/KV24JP0Jr57+G/wAMvFB+KljqniW/bxDYWdzqGnWLRurJcXDPI7jzI8mZUIBaRlCsTiuN+BHibUfgn/wUakuL4zDVLb7Sbm5L4YNqATyo4z8wVY1IHBzxjjpX0FPD4eVScY2ajC9l0e34efUxxUvqzhTpz5o22Prj9q+6/Z+/Z++OOu+EPDFotr4t1XwtJomr6Hezia2F2Ji0ZdVAAAJXOW+bORwa9r8FfsteIvCfwe8N/GPXNVs4ZNZu7SJIdNiZhaByWmxGCB8oXAjBI75r8nfHPxM8TftFfGtbPXdIu9U1678S39zfW1ogjuR/ZrFLMuzBgxcg5X5VKn5jwK/d3wxd/HK0+B0XhbxLpEUmqxyzPpPhqPylvLKF1AVbh03AsUGAyrtB4yK8biOVSjClGhv1Tav2+40zbPvb4aGHdNRcevddF2Pw8+MPjg6Z+13Y2Wj61pGkhby1mOjuzzR3uoQ3KW0SXUaF0HmK/nPHnA5DA4r7k0b9n7R9d8XW3xC0i10nVIbWwuNZ1OW71Vrp7TU57ljG8FtH5bW8ibc+XhmKn5gOK9ng/Y1s9H+IOp/HPxlpXgKDxDCulTab4YuZX8yzu2uVlje4lZjE0jxiVgo3chQQK7D4eQfB3xF8LtQ8InwTZaXpseutqkV7dQNDqM2o3DbTdLLG6KsCNzG+xgV+XtmurF5/hnSp8sHFpWb3S6/M+aqTi9jzb4saH42+E2kWPiDQok8QxNptrrWsaHpMrWl09m10Ghja1fe0INyzN5iksxxwAeM34nftw6R4U+HNr4Q8EeG/E9t4l1G4TXrK4e1ulu4p7iMTXs5CoQYrfYVibJVkkzuGCK+2fDngPSPiJ4d1D413Fppy6hr3heXRFe6ke6+zQ6XvZSd42ymR4t6kgbWI64r27VIfG1l8P/heukC9h1G9+GK2lxDLMrTXEMMfl+XnC4ZxiM8AY9hXmLG5XiYc1em58j+d/TqYy5ex+cngfxxpvxe+H82jaB4psP7L1uwk1DQtV1+cRXNjq1uQZYozEzmGGZkYfvCNpOQDXqHg3xT4hvNK8D6p4CubyS20DWLvR7prmYXS3j6pHNbXbrcBVLY8wKh7BVrD8B/sc674Q8WeKLrWtPEt1Z3Ul/cto6peuJb+BQFi+zzRYkHWQNG+F4yRzX1N8B/APiXwB4Gg8IvDZXy2mstALa0DSyW12ZhPuj80KrBThZApypyOSOPI4gw/1TBe2y+7Te3y69P8zeguV3R4R/wrzxJ/wT8+Gug/tDfEGS71q912+1SzurXTioVLpfMMRNuFZpQYzmQBlwWJr8X/AIx/tM+GtS+N+m/Gaw0W48N2Jt7S80m5ktHtYtSjllCSTQqWcEpJuBfdyB0Ff2FfGv4aeAPHfhfw14f+LHiu08P2kel3er6ZZlRNeNdTuATEqkEYgZeo6HjPNfwjf8FK/hWPhF8Z4PhTrviLV7/TtKe7uTFEFeeDRzJvhktvNuFjKSFsiEBSpzya+o8M8FVxuHVDMJN1Kqv5Ja6KPT7j2eSnOasux+jn7R/xI1nU/hHrHhi31e3s43sD4iS5njfzwY51YxRAIW2zxENlcZEfUjNfB/7K3xd02C3vvg94hC3dp448PXENw1zZlUN3Hm6szGSxZkDx8Hg5Ne1+BvDevfBOf4dWHjrxZP8AELwX8dfB0Gn6fdSWv2a40jThdPb7R5kkojnsp0w235Su5RjdWB8MPAus/CX9pXXPBC6baeM7nwlqMtp/bGkRIsslosTLbXFpGJAjyvuyyg9j3Br6/KMHSwWGlSpPms207WT1ae9tU1Zr7j1sZg1QlGHdJ99z6y+DPxT0GHTdC0Xx9b3Ud34RstQmsYDKghuooxuS0t0bOHjdvMClvmwQOtfmb8ffGnxg1z+0vhr4ls4/+Ef0yV9e0qzdWIiTUtrs8bPzhipbHYkiqc/jG58U+JotKjR7q+E++41RoVikhN3cbNkwXIVolLE5J45zX31+0t4RTVvgP4D+J+n38Uv2XWb7wTveLZ5thbnl5lxuKw3EksUUnI2KMnIIG1HDcuI55QV2r/d1/E8jHUrU/cWp+bP7O994Ye/WyttUt7ZrmRIbnT71fJBTI3ET9F/Gv3q/Yp8S+Pfhf4m1Lwf4xRIvDuq2U5stUtCrqhRxtAMZKuqkhhnHTjmvxCuvgVNNqa63NDY6Vpv2pLNdU3F4rldxEkgCM+7HT5O3OODX7d/AT9n7QPhB4ButZ0zV4/Ef2O6Fvr+giaV3XS720Z/tFkZIowOJEdGI/wBYq4PJFeNxLgY1WpX36P8AzR5VOnrdnxv8QfAGsR+PdbjtvA1s8a6veCN4tVVUZRM+CoxwCOgrkP8AhA9f/wChDi/8Gy/4V9c+IU0y+1++vYrKxulmvJpVuRqioJg7kiTaRkbs5wemax/sVh/0C7L/AMGyf4V83/aC7r8f8zo5Wf/R5rRdT8BX/hTTPFvjC/m1PVYLOeZZJMyx3cScFZVU/M4PHcD0o8N+Mvhb4juvt/jhJLHyrRZY7MK1stugBfzhCSEeMrlQW5zn1r13RP2bYNOe/i8D+G4Y7e1kubm9kjaS6hiQbUkW2lQCI7lGZADuDZrzz4v2Pw91G9m8IeNbnSbaxvwrwaxqUyRy27QIJgyFm4URrt24IYHI5Ff5tUsTQrVHCnKT9LXivJL+mflPs7PU5tPC2jQOutfCu/uNcutQ1AW9rqWsP5caoIwXCttYIzIRsJ5Hb1r8qviJ+0h8V/DHxY1HwvdQul2sv9mQabIPMaKJHGwuxB3kKM7uOCa9y8LftUab4TGr6ZcQT6jbXF7HPaxpPIimeJjHHKURcgLHjaPwNevanrvwX+PkujeL9K8R3dh4m0W5e6uNXsNEJvrW2jGwpdkuytC7EqsjY569K++yzDTwVWUsXQc4NWTs3Z7q9lt02Xl2BU9dVocf4O1rXPDfxC8O+HfCOpX+u2Er3FxrEPh+yEBlvbWMHyXVSxePLKmQQMdBzXp/hn4u+LvEfjP/AISGGO9FjbFx9ghAnNrOvymEh1Zo0xwHIJHIFW/GP7Rtr8MPAmsafqMWm3VyixTy2ErQ6VcyWczFC9rPEWZtpUdMk5DYFfNPgP8AaXvvAGhS6n4P0638KW2vSStbTWWdSkvl3YKTXU+wReVn5SqtnNZ0svqYqEqsqCvsnde91b0S1t2Wy3IjF9UfRPxX8V+BPCmm6cdc1gaLoU1wbvWAwleLzps7o8yAr3yxK7cADFfAH7QX7RnjfwRpnhr/AIVHrV3fWem2wtrbUAMl4YZN8akLnCrn5DzwcV98+D9a+PXxZaA+HNe8O2/h+eyaBr/xlp63k1y7ZDiKFlQOMHAIJ6GpPh78EPgp4/0a98Bq+ha1rWi2RHiAeH9MNqtt5bHhFklAR3GNjch+mK2ynF4XBtfWoe0cXqlrZO+r91WfTVs76EUvgi2fJ/h39oTx9+0/Br/iDxG0UWrPZWKPEqkrN5Rw86IoyCqjHuTUXxz/AG37HRF8MXnhtW/4Si1nUlbcMqW1vYgRWkH+07vl5Co4wFB61+p/wC/ZyT4Mfs/S64nh26m8S63ryQQ6ahS2uRZ+XIsKyyAN5ZLNncRjI6cCvgzSvEOofsteZ4x8bfDrRtctNHv5W1N7SF5rjTrfUFZY4nuHRlcWzEMSBncSTjFehl+a4CeMdTDU+bkfuxUlF3ta332t59T1MZhatPlU43T2sf0j/wDBOH/gpjd+Ev2dT8QP2iLzxR4q8XTzi2h0XyRawW1qq7gYo2UD7xILHJOK/fj9nz9rf4XftD+E5/EnhKV7aWzeOO/026wJ7Z5QSgcDs2Dg+xr+BXW/2rfGPibTtLu/hVNHb6JcSwm71a8tpri5dfMLTWgYr5asu7O7OOmBX9dP/BPzwz8GtL+C0Pi34S2P77VordPEepLFJH9ruYNzKXR2JBHmHJHBPTiv6I8OsyzXNcbUrV+WGHSsoXvNPTV9e5vgcyrQfsmtj9T9S1nSD5tzHNGWlPY5xXJPqliV+WQfhXzn8aPjD8LPgt4BuviH42uZLexsbhbadLDbNP5jSLGVEQO5ihYbgOQK9Fs9KluraG4t5nCzRpMpZedjruBIzxwe9fu1OjTUvZqWx6br3s7nd3epXEMLjT286V1ISHgFwOwz/Ovy3+Lf/BTL4MeExr/wj8Q2d/o3iqfS7u1tNN1VCh+1KhUxOwUqA4PyOODXyb+2f+1n8KvH/wAYNL+Bek/EHW/BWr2hnUa1aW4eztLmJvlNxiRJQhI+Zk3BepzX4jf8FI/jB+014dP/AAmvxp0LTvFUlhaG30z4leBLuC6t7mFTtje/tomkeMOv8WeT1Ga/J+MeK68ac6WXWc1Ll3SV3prdo4ZYmq78v/DngXxZ/bf0b4NXQ+HHgq2jvLI6umvJbGRS1lPdkpcq/wAv+tyoAcdVPav0U/bn+PPw0uvD15rHigQM+jWkF9p2mSqHF9cIoghVgwIw25iFA559BX86vwS+BL/tT69q/iDTdet4dXmVr1NLmjZ1mtxzM3ncbGRscMOle+fE+58bRRxXvxbtr23l0W+GgaPfRQu32xLV/lniIDozbWALEkRjnk1/NubZTTq5nhZyrN4ii7ybb5ulku+z1WwYqWKdNVp3sf1Tf8ETf2lPiD8UfEbaNLFHNrl+pn8S6tqUjOunafbqBaaXp8A4XYDlskY7jNf0gX/hS8W/fUJ496s2Syjue+K/jv8AA/7Wv7MX/BH74f8Ahmx0u0udf+KfiJrW48QSSz7v7NtL0+YI/LThp2U8D7x6kDpX9XH7KXx+8UfG34c2njfxlpDaLHfQR3NjDNIrzvDIu5XmVMrExGPk3Mw74Nf1DwPmVb6s4urzye7vffW1zXLqScVCo7vdE/xz8az+DPCDSaFZrNqKRsY4gSAqgcySFVZlA9lPPrX4Dn9v/wAe+B9XutI+JtuninRtQv3aJxLFaXlu+/aIhKgaC6RBj+GKUDsTX71+Jvh7p/xIs759eEkiXl+22aKR4ZFWMFVKshVgBnjnk1+If7bH7Avwea21C4sri41LVbC5t9UvVfUVt3tcORGblooj5gdsY3KTnqa7OLsRV+ozhTb82RiKcm1NdCxD8S/h5+0jDqPxE+EWraPqM9voyRTadA7r5SszIxuVkwVkjwzJLEcsy7Tng14H8NvhZ4etdJfwp4cu47ifQHxY6uYmOoAIVllXaW/fxXDklgrK8Y6Vzj+G9K+BPw2n8BfC63gF5Y26ajrbzfOPOFvLIiQygKqMhlaTHKl2Ge1fNGqeMPGuq+G7vQ/A2ka7BrmoBZ9fu5raWxZIkKgy+aA8Mr7DkMpRvWv4azKcsVXnOnJ6ta9dNL+hxykm9joPjJryeH/H+o+JfENjc6DbajYM9pq9n++iuLiIyPJC4OBJsUblXAdTjOcV7R8NE8b+BNNuPFXh7VtM1JtOs/7U02DUZFFtprXKxiBJCMiPEcRYkDB3YFfin4x+F/xO0HU9SvtP8R6pr32fU7TU7ixv5JVma3DMGIhLMJFGPndQcdyK7P8AZ1/aC1K41DW7DxI6x6PqN7pNmol3H7TDbQQ7JDkDcAwyoIxnPPNfWRyFRoqUZ8yVvL8DWCS3P0/0L9oGTUfGtqmoeBdBnOsaHf6z/b0s8b3Dvdq8klxYQsf3QDqPmbL7T17V/NF8Wv2yvFOt+PpPCXiSzS7SwSeC1vUgijvpMxuB5zQqFlb5gquAHK/er9vbP48fDjTv2qvEPhfX/C1rqOj6TYsmm+IfMZXESIfOCTH9xGu92yi/xEccV+eOmfAjTdN+Kut/tK6BpAu9Ejki0nRtEtJPst415qE8kS7HkQgyLZw3ModVyWA7V9XkEIYec41qVvdTT0/M568E3Y/OmWb4h3Fzo2sw6HeomranHPptx9kdGuHYeW0MLkYYkn7vrX6W/wDBOfQdLj+OGr6H420y4eLQ7LU5dT0q6GLu3dAAhKjb8wf5MZBya/RH4ueC1+Onx48EfCrQL+S10Gz1OLxAGtIf3cctmnmTXbumAs8MsbxvHgAqQwzWX8aPhbZfCT4w698e/h/qOn2J8W6/prXljJIslyJPtCzSXMY5V43YxAjqGfpxRis3pV1Gmo2lK9kS8PTWkT9APjtqmmfG/wCAd34ZtLy7t7bSbeLR7q201ftTi7t4A0NrdrtUAyoA7Rrkxtnng1+Fn7Nd/afst/EfVNA8RLpukatrdwb3S9S1+YQ6ZHacoXbaCzneR8gx0r77/ZR/aB8f/Hf4eeELmbVIobzWbvXdTmvL9hGnnxZsgJMBdyhJncnO/IAFfnD+3t8HtS8G/Hqwg8V2011pSWdxbaQ0ZLwzhpixWKYjBaNTux26GvlsFlbcq2BraRd7r+vMwq4Rt2R+4Gm638Oovggni/XviLZeINcWz1G7h1HTiIrS43I5aGOEkjYv3QR9K/ji1nxx4k8MeNvETxvJGV1q8mES5VmaYbSjHqcjGfYe9f1efsc/s2fD/wAWeBtD0fwRdW9/daZYNJqN9JEbi1is58yQytOPkWDIzLHgOzfKGr8Ev+ChPwPj+FX7S1xqq3ltJ4a8U3dzrelarHEIo5jPJibfECxQqeVTcSEI9a34HVGjisRh2tJK60tez2QQoyipJ6lP9jL4kfGl/M8O6BFY2mnTTmTxDrlxGzTPDLIrlCzcFUwCiDuM19i/Ez4weOo/GkWt6ldQ32nWFlptkbjfHHueCQzvI0bho87WKAsjYK8YJr2f9nnwj+z/AP8ACJWHw+vLtIfK0w38Wq6DdJe2mrTrEGaIptEsUxXJ8phng4ziuCv/AIbfAvxN4kXwl4D17ULnUree4lgj1vTj5dvA1oZFimuS2zyj+9dQ68HGSOlbY7GUqmInL2dl6E0a93ytWPsDxv8AtKeONG+CPgzWPCN21yLq31EpEGheJLh4hMih0VQuFO3gY5rk9EsLX4i6U/iK7tbX7c+iy3UOlhvMMlzHFmdlABMj5YrwOcYNY3xe+BfxO8FfsPaI2nkanc6LqNzYT2VjFl7CEkRSuzJkOsYA5TJOfQV8W6F8evim3jDwd4V+Fem6tpem2es2kP8AwkNxbyRrdQRzKsjGXZhIpJcLjd9euK+fp5T7dqWFVoxbTb02/rQ3cL7nnth4Fu/g58VrDx98QtRsrUDW7ZtNsY3DSpun2SRTKCOYwvyxxbVHrX27pHhnwFqH7R0+peHfDlprUviS0t728traPCmU3DPJcRu+/wAliB1xhRmsX4tfsfa98Wv2gtF+Jnwl09rhPE/iI6zr9nIqXRtbV75xLcwbjsa3zhniHzKW4wBXtfxE+HN5a+Mrn9nf4LbrjWNRSXTvFXi+xjMFvYadG7M8NtuOF3AAOS42rnnGa+nrVIupG9S8mtbdtOn9XOiDPefh/okf7PfizUfFHg3UW1JNCvdMntYYYWlnVvEMbPK0NypWNII1SRXnZWLADaAWFZHjfQvhz4puNH17WNfttOsdau5dLmktIGae/ucsI/3oOyPk4LyDDbMda+nfh34O0eP4e6L4PLajqC6X4W/s+8utOAi89NMDFNm/93HDJGwEl3M+xyF8pSBz4r4q+GN7pPjezmt9K1K8kt9EnuoNGuhGovLS2k+0IrDIEjIWAS42oX6gYr5HMcPUhP28U+W/TuVZPY5z4Y/Bj4D/AA08Wa1L4p8OQahFcaZEtxBfTyTW0hs7mOSWS4TIB89VFzESTgAr0Fe16P4uh8LeL9b1eHR9P0O6vrCLT/ED2NqBDquqXEX2S7S3kyMizZU+VBwDnJr4z+Df7YPh74g+IdQ8BanFqNhe6TcyRRXGqQlLh4hvZbCdCCCoPywk9QTGeGBrufjH8YNUg+PnhD4aeMdOjt9MtLNbnSbxGUhbidQupRPKuFZreZYEDcFkyTjNRWp151nGonzWvr5HO5WZ87fGX9mk/wBp6D4l+D8tnprxaRe3N9ZR3It7ie5tLhcshTaBMVdWGfm45JNeKfs/fs2/EpP2odA+NvjZIbxNb03VXupLWVZpUkCfZ2W8xwsj71JPJfnua/SvwzYaL4S+JWp6Zr2kWOrX815PeaZHdn5F07UiZA0ee8c2A7E9COMCvr39nL4caB4Rg1K3vtOkD2MNvqsGk6eoW7ZYpVmU+YflzIbcKOMFgw5rtWcTpwdOP2la/kzCUff9opan5w/B39njxd4ruYfHukRqq6Pq00OuWl5wj29vNMQJEBBGCgGevGK+o/jj+0DrTa3olvHHp8el6zpMlrBJHMwNvd+SUYAsSd23IH+yepxWX4s8X+NfhH8RPibrlrpHm6Ja2FnaWHnSlbS/kvnW5lJGCHuBFJIwIPfkV8+fGbSfhRrf7SV/8Jvh5pP2C6v/AA5oXimy1bUrx5LaCWUBpwqKpwFhJ49QaxwuVVK0vbPWPU2pxe54Z+xNq+tfEXxj490Hw1qtnp893dXNnDfyzI6wOks0MhZpDj/j3LbQeMsB3r9fPCnwxsfHNnoHhrwpcadqHh2yhvLa2F6kcdrPM2145HSL5ljimUttABLcA4r+b2x+HB8E+Ete022v5rbUNYgv74CRNsd2gn81ZQeD8zR/KOvzCv6gf2UvDHgbwJ+zPpXjDXZhZXCaWt+ZJF2jMkfmFGHBwCec46Vvn8YwnFReknovkjOtiYxdjwH9qqTxfpX7Od7pekSj+17HxHc211qEMDSQyCS3kgmPm5ATKOPnP3AAuDjNfzhaF4w1DwP4Q1i68UQTXWj6Vrd7EbS0ISZpX8rajbsnnlmYAnB6V+8nhL9pn4f/ALQngfx98O9T1I2Wg2+olIL2WJwht23wySb8hJFuZctz/q0G7nFfltd/ALxH8NPilc/EHRdSuvEmn3mnW2pvbCON4obmFBDMZCqygylSjDaBuXqQa9DK6qpwlRq7rZfpfozohbdnt37BnxZ+IfxK8deHvFemaLbLapdmxij06J7mS3gKbYBOw5RQwJwBg9SK+6/+Cjum6n4d+K/hDUPFEtoRqTReHdQ+077h7yLW4iz26y4IgjjYNgbSMqOgr47/AGZP2gPFnw98exeHdIvJdLs9Y1RIBDpCpp9y6Sghd7EF1AOSQPmYDqK/Qj9uHwPqHx/0W18T+IdRttN03RYrK6/taEtcz299aBv3ckYwz/aUaMp827J7jNd9Otl0KfNrGq3t0trfXua0HaanfTsfzvfBfRvD+ifHzXjLd2lpLNNLDptjeFoGXbMWWHzFA3EbCvmYAbIPevS/Efwi8ReIP2xJviDf2rWVokgk1a5Adzb2hC+UykkFmcYRMYyw4r7/APhp8IfC3iyz8YfEOzhh8OXUM0b6Vq8lqJriaJIj5iXPmnYIpXG/chxH90nvUXwQ8CeIPBEXiHWPj3eRPb66bSfw/qQzJbXUYYSQATAldpYZTgegNa1c2lOpUq0Z9FFxtfbz/H8TsxmJhPZaoyvgV8CPhH40sl1z4Y6enhvW72SbUr2WUMbm9tzITPIXdlZzKAVQpjZnGD1r3n9oDxbrnhfQ7LR/ho9np97NZG282/Jb7U0X+pgNwSXjZQPmU5Bz0xzXMXPxB8Ftr3hew+L/AJV+f3wdrrEMWZrtokWOeMB7dzsVlcZTIIYBTxn/ABf8Q+CPAXjuy8b+H8P4J1vVJdL8R3Gr6gL6G3mtiVjD7lH2acOFCtnkAc4IrxMXiHVmppN/8D+tDz5ty3PFdQ+KWi6pdWHgDxaZVvtfuIY2/tMP5dlfJBGYnTaV4ikbec5Ujkelek6P4v8AD3ifw5b/AA68QQQ/b9K023udEunLx3EunWshsLyDLYJaOWIOu4n92QelcP8AEjRv2SPjHruk/FLVtRkuZ9I1ESCKwdkh1BVZQys3I3W7NEzYwpTNfXFx8E/Dni7XviJ8bfGFvFLJ4O0bTtc0KW0DQpLBdQQm7YLu2vKMNGx+7u7ZrL2UZ4f3IPmd9LdTNwuev/sk7L/4af8ACMWVvPI+k+INW04QKokaTzPNeFVHdgZF74714b8X/Fvxm8P+P/DOpaxqT6XolnKthGl2yefFpU+nMjQyRnDbjO+R7kMa9O/Zg+InhrTf2ZPFXxk8NasjHU44rvRrYERX8N9KGDwAH5TMI42KsODivxd/4KGfGDXZ/iB4d0rXJ7mT/hI/D2nanOJ5AXhe7ihWQZHB2qM8cZyBXncO5ROVWqqkXFyk/wAFr+JU4WSbPre7+HHxps9U8aeM9F1NbTVrbxSmh2fh+MtLJqayQqsMwZWKLhWUneAB619QeDvh98W/hHI/i7xDrdzc38kEuua5ZxJthN3JA0Zthk4O6Z1EmBk4Zhivm79hrxjpvifx5dyibyG1rWbePVFmzvtraziSMSvuOd0oi4Uj5gQeeK+4/wBrf43aXb6DZeIPAkTSHU1uLLT5x8yJcxvtnmePsI14RTnLEHPFdeY5gsNP6vFJ3drfLqOE5K1jktW0L4deNvFuu63JcWol8NTxB59Kkbz4Pty+WTAj7tyxyDDLntg1+LX/AAVd/Zr1DXPgZD8W7vXkvtRn8Yw2FnFLDHFFILw+VIXdyXCpgH5eATX1t+yxb+O7j4sau+uWaWem3Wiagt7aXkux7q1tYlLQwEEqkzmQuqMQ5J3V9c/HvwPo3iL9g2fSNL0n+09ZsoVv9Fhudn2mwuhIJkjv42JQuwQCNg2AcZr7LgzExw+OjUqzSdtH/wAMduCrP2l2z+bzwV8HP2jdC8FfDrTfFKpHFoGi6/418K6g7l7IaPBO32qJSvVhd7flPQketfa+v+LvDWjeIrP4t6tsn1Dw74j03SdTj0yLa5tr5Bcwys+QHfbKVHHYg15r+yb8WrC50XXfA/7SNvqN3qGmeCvEul6RNNcKsOnR6xdRySmXBEY3TEMGUnCngHFel6B8CtQ+HXizWLzwvol94jsdWsNN1GAySsLdLrT4/MLzsV2shjLBcHIwp56V97xTiqDpxeIq8uultvP77tn0mZYyjVr89JWjZafmfO3xmk/Zy0XXNWvPA7XVpB4h1aV7mCYEvaibLAuV4Y5XgY4V/avovw7c6l48+HXjTTfEBims9N8Mg+ELCyuAq2tvZSozSEcsWmead5QwydwJNfml8T4vh/Y+OYvDJu7u6e51lobizt1wE81dqGORiciNnIwRk98Cv0H/AGdHbUbbxZruoeDBq+qmyvvD1xN5qWRaGygcBE28ZnWEBjj5iB3Ncak6NH2kZuSlrr1KrShKm+VHwrr7X3hvTdK8FXVvbyWceoS3scodmdPNbEkjgnaqh22rxn3r9n/2FvHccXw5s9b1a4t/tmiQNaTrM4UtpwvDBcxg90HmRPzkDHavzn+I3w38LTT3t9Ykpa3dkIooAd6WpmxItuZm2iR1cAEp3Fe5/s/WGheEfA58U+JfsJvfCOlXU8zJessep6ZqTJFNCsTLkTLv5xuwV7cGvm8/lTxWFcE3fy3/AKfU82lg1N2TsfZMn7Q3wutpGt7a/wBA8uNike9Ldm2rwMnZycdTTP8Ahoz4a/8AP/4e/wC/dv8A/EV8BavL+wbrmrXWtW2rXVhHeXEl1HYtZhzbrKxcRFg43FAducDOKzvsH7Cn/Qw3P/gD/wDbK+O/1To/yz+4zvT/AJj/0o9J/a48ceHL17Hw/rvh3S006+TTLexIVWtr+FHn+0yjekZjlUlWliChvr16Dxt8SH+LWm2fxC1TStOvNE1sR6BfXrxrc2N1P+8Q3FkY45HiTDOf3oyuCQD0H5qx/CX9ob9lGzFz478L2et319ZQASvbtrFvFNHwvmYTCsqjD7zgds19peDPH37P3wg8DatdePNesory8s/7STQLW2nt5dQjvA0iW0FpED5b+apAA5w2c4NfwDmHC+Gp8uIy9Ko27Jws2++2u/f/AIJ+WSp1Ivmpu/4nw9+0j+xafgFpEnjn4WyzeIvDmlfZf7V8TJdqr2OoyTZTNum11ilj+6Gwe+e1eX+Jv2Tfibq3h7XfHPw91HT7DTLq2TU7/SLW9uBcRQRp5wbfLnzRIN7hC3y+9fq98SPhz8PovC0Wj2vhTUrrw14ijt7LWriO9No9zdXCtIsohkDN5VvJwu/GAcc1+WPxNn+IP7E/jy8+HfxDjub5buwt71Lu3YCFYnHMasco3lxtsOOhNfXZDnGLxNBRpVVKqn1teS06J2uv8tNz0aDc1pucf411DV9J0e8MMlp4gtL/AE/TLq1uFJadQ0aG5haD51SIFhukbaGGMdTX3l+zv8Avg98XvAK6jPpk89rpohSy0vxJcTXItnY4Y28aeVCkZfPyZPbNfnt4d8QaH4u8d2ngX4VaX4mvrF5Ev78+YiSTWtwiqLe4PEYjThWIbDA5AyK/Vvx18Bfj7pngjT/hlpOrf2Dea1cx2WpzWbRNDp1tMuVtNOhU7pZNv+slOOtb8Q4WrToxhz+yu782ui9F19P1sduGwii25j/BH7U/wx+G37QSfB34e69p9lbaNHLa6nexQxuBeFQwtbJ0V0i2k8yIMFjtzwTWL8cP2Nfjf+0r4q8RftCeO7a5sr7W7dP7M0XTtQmM0sVttit2mA2IzL1Z8lVPevjSy8IfDT/gm18afD2l3l3B4jutbbU5Lu4JV3thEBEiFFDfMzZOc43V+uHwu/4Kofsu+CfB3iGDxFrDa54u07Qo5L69nO6O2m2ssFla9BIluMZCfefOa+Vz3LcTl6WOyOjKo5qK5u6v71+133u+iPXymjCEp2ejW36n4T2fxL/aAsZ9Qgs7l/Paf/hF9OS4vZXlS4dzEGiOS0hiAZiSwAzkV+u8n7EPj34f/Dyx8Q/D2/h1bWdRUHWNB1K7uw+oRzKrzNG5kI3o/IUjgYyTjFfmtpj/ABP/AG3f2qtH8GaFpb+ErXTIB4iOpeSIri9LjzXuVjX5EjKrzk8Z55r6t/ah+Ln7dv7EHx0+H/i3xPqEV/4bivFlgltLcoD5nlxXEErHdulWNuO2c8c19FxHlmNqVMJSw7p0qtSLlyN/HbZX/qx6GbOnUnClF6Lc+19a+KlrDqWj/DnxPZnw5ro0+JbbT7iBLm3ut24SWkkRjYJJCoB3s2GBzkYre+DXxQ+M/gz4a+OtL+GHiS78JyRC7SLRoY3hgtriMCWO7gCEq6SopBKtgZ+6RXl/w88Y6l+3N4L1H40/DjOl+ILLxRqEKaaoKjW7W0CieIBgDGZidy9g2R0NeV+FtS0m2udYu9VvL21ivJJJdWstQkVZXDL5JtSzYEaxZyrYwGGK+cyuticqrOeGTpV1pJXvZ9Vp0a7tngOhGEnyI1vgD8P7X4j+LofiV8afFl/J4rv5LTxLrWn6ndvc6NdXEbLJEggIwWuCrlnPEQUZDdK/pbk/4Kb/AAIutG1PQLG2nutW0a1gTUdM0ydPJhmuAQkQuGVd6jH3lAwOgr+MX4xeJ/8AhOvhpq2peFtS1Gyu9FvxYML5gJ/IlZ2tkhECfP8AeaMckMrA+tfoH8Bf2fvF/wAHfgdZ6x4b0w3vi/xLdw3c0F/C88cMKRHlzNhF2ISWZgSDwK/ccDx/m+Gy2piKkk5LRN9L+fprqFO6ukdL8dbPxb8YfiddfEzXdN0axsrLP2e+1HVrieKyQl3nedQjStH90YXB4zXkHhfwun7Xvwzm+HFtrmiaV4fvr+aKb/hBtO8hdQayJLSS3M7RyOGAwu4YzyQa9Y+IH7F+vfEPW7fU/HniCa3sJ7ZbbUtJ8OSEXF4twu3yJZV2rDHgAYALsD279h8adZ+FPwHubT4b/CNtC0MaDb2OlS6RHMq3b30xMLKi9DOR90EHjLNX4Pj8/jjf3tC88S3fmSuovfXo23rt+J14fCcvvSh6aGx+zT/wT/8Ag58LPhlefH74Pazr+o29pBcRXVlqUluIb1bdGLqZIo96ISux0wd4/Ovyw/ag8F/Gz4o+A1g+HlrHfI8jTp4Y8OymzghvGZ7u6ltIS/3bXzzCojbawyeBgV9O/tiftp3/AIE+DGr/AAv+E9hfwa9azQ6bNf6dm4tGuZIWaTcYQoWSNc7jjBOTXoH/AATQ/bL/AGOfAP7M9hrHjS0bUfGFhclXkXH2s/bPkniIYE7CVLgAcLyanLFneEw9bN8RSlXk5rkjZX20u13ufVU5e2w3sW0pN2/rsV/hh4S+D3iL4ReGNR/aK8W6boPjE34h8IT+ONN8y5F4sa/6MLuNDlFdV2yOuVJxk19f/sP/ALXf/BSvR72X4c/Ea7eLT01O4tNMutRtF1cv5M5jFsNojKxMpykq546gGvBf+CgH7KWlftQfA/wt4l+HhvYvFs0kvifSrNEDstkQdqSPGOJDs+Ujg4rz39iL9un9rb4PweF9N8babdXNzc3sug3c2ow+fFcPCd0aqFAeORkDBiM8r61+jcG8T0fq0amG5qVaUmpxctY9nGOi5X5XZ8li8LVoVOVLbez2P3p+En7dnxq8Z3lz4Z+MmiXngrUB4gg0/Ft5kltHbRvII5xIYx5aTfIWVizAHqK8d/bC8b6ddJoWhyvIpg1y5f8A0TDNdXjN5omG7ypCmQerSLt6DODX19+0z488Kv8ADLw/4g1AwiLXrkW19bKwZIy4MjtuXkP02549a/LL4vav8J/AaW1yl3c3NnYWl5qrJb3kjW0bJCYBs+WRAwDlTzy2DjivruPOI8VVthPaScXo1HRO3nur7mU6sr26Hzzp/wC0V8PNQ+H6eP8AWhq0B1/xK1vp1x4eEkE9z/ZsE0ty0sNwXjt42wZDNFxIAAADk1z/AMIPHk3xu8IS29jrHhrxJo0lzOtrq/iPV72S5s4BgQxIYjavGq5yyNK3TgmszX/g54C8RWkFx4I1nUEGgaXf6fcQXssEj20epWY/1gjwI0QTGMlwM4HSvzal8V6l8FLK48SfDiyxLNqMtpMl/fy7owihfKOlRIsKsRwnmMc54HevkMhyXCtctSm1Lz+fX7jncep5P/wUf0XXfhuq3Wh6VoSzCb7Fp/i3w5rdxNOjLnfutppGmQsu4Kd7Y/vHNcT+ybea7fx6TpPiaaDUtTu9Z+1JdtNv/wBXbYiLqOxI5XjDc1T8e/BKPxheT/FS7ltL1LzWYPPtmf7H5Y8l5pIZWk2rGSV2EgHB6CvGvhN4Z1jTfH82qmVtNF3Gmo2rBsKvz/LluMgxyFRjk9a+9nh4Swyp6XXUynioq6tsfVHjn4t2nxG+PGl6v4ZtoLSO9kitr5LvMlml5auIJ3SKEq8cYU/NyC7YbPav29+JPgeX4hfDTRfAGnaal41jrC6larPN5E7vASLOeziSR5A+GdgzSMdjMG9K/HeX9mfxH8BPj14f8C6tLGPtUA1m3vI1Cm4Nw6sqToST8jnO08nGa/fb4Sajcaf8JYdN1W9ezg0YWMMuvaajieCy027iWKN0IJDTfvFUE4bnPANfE8U1p05U3RdrqzKjJPU3rr4av8APAw1bQoNRuvF+oyXN9Noem29vJeSS310wmeSVTlpIY5mRQFxxk8mvxN/b7+J3i/w941/4R/XRdRXGg+GEmgS/i8i5dprtZFMsfOHCxpls5OK+vv8Agot+3R4t+GvwGXXNOB1DVvEl5dWWk3moWz2kmmW27zANyYLsAwDcjc4JPAr8Qv2xvHkXir4c+CPjbZyCWbxH4Mi8P6mXYyG51bSLuIzzMGOcPFJk+oGK6uEslr12sTWsl07nSqezPXv2JPi9qfgnT/ADXURk023tL2RVZwqGV2uJlUlwRjzAuTg8e9fuvcCy+MvgbTryUwXKaxokeo6vFqEv2qzhvsfaGby41BZ5Fj2LtIXJ6cV/Kr8DPHl1rmtxW97CttBplqkS3KOEght/mMsaxEFT5rPkY6Gv2m+CXjzWT4u0HwrYvHPJb2E9pDaSXR8lYYIQwLFeB8vOeprXiDBS+uNp2b/4JlPds/UfxH+2t8LvBH7Mf/Cj/wBnjRoItXv2lXV20/MdjpMd6NruRhTLcqXISM8Rk5PI4+A/2q/AWnftEfsjaX4vtrLfrfhS0Wa2sbpU2z6fpUKQXK25QKzySkeexbLcMMkDNfP+nfEDxZN+1he3mp6ZHcaP4A8UqLzTI1IFxeylUBlVgBKsqMXjUchR716542+Lj+C/CVj4K0G6hmv7Px4unrp7DYsJcXkF1ahW/wBYm2dh152iuOGU2xFJRdnH716vzInFtWuflJ+zv8RYNO+32Wi6airBp8l8WWQREtazKyFQQfny2D/ERkA81+uv7Jn7Pdjd674n8dfEHQ9SitbvwxFfaVpthevcy3F7etEy5DbXC+TvkVc7CgKEHFfk74u/Zs+JvwO13T9X8Q2Fjp9vqN/NBp8SSZnuc3ipvkjz8m0coMkGv6AvE3hL4n/syeBNH+J9klzC+tDQLKHT2+aS2s2kWKSbJyQPssjM4/5Z7lp8UVPZ1I04L42l+KFGio2PlvxV+2x4x8OeErnwdKQ0k1pqslvdwqI7i2vreyZZfISPCjzJpMvwcYAFe3fAv40aZrd9bfDv4j/bbez1v4Z6e2vXbyOZBfyTGESw2jhVjVJWErYG+Q9wBXxH+0r8TvB3hO6vPiG3h2403xbZ6r4jXRHbb9jurC1XcLhUQeWzTx7S0inO5Txya2/2OfjlF8QvG+neNPE+t6eF8T6VYeGpZZkCS2d5d3LmF13cExgEiIffA608Tls6GHUnDTv316fIrl10P0v/AGbfg9rnwg8Zj4UWmNR0rw9c6hG/iS4ihgv3tr+Br2IRoiuYYQ7ofmkdmJ6AV+dn7asHxYu/ibbeCfhuut2nhq6h+2appGhSwxSSyP8APKGnIOElkG5nc7AO3FfqN8RvC3jnwj8aND8R+KfEfn6XeeEINRtUKSQ7porL7DcovPlhZZI/NjU/MN3Xivi743f8FCtD1HVtM+DHw2+FFtr2oR6dH/bV5qzzEQi2+SXdFEh34UbtpPPpXzGX89TGxr0afMuo3TafkYn7HfxF+IHgKXxD4G1PQI9EN/cWd/G97qM9+LicLiznnvpXJnU7wu9E8tSRjbxX1L8PPE2v/Fz4nXXw58XW4mZo5wyW9zd2Kw6oVKoBEu1zsbKNM7v8zDFJ8L/BniD9oL4fxeK/ihptloHh5NNlm8OQWyBbu/tXhYNbhyQLaE5VxEuWXaCcYNfckXwd0z4g+E4PGc1va2/xA8JJbWf20TvHHqFlDtaPzTHjc0igErnlhk0sdm8FWcdE303vb+vkJu2x+Et7+z98U5J734leKbwaA1j4hv5LNpoHmvrr7Grm1gSIsrFkaIr50jcgEgGtjUI7eD432nwIC2+s2kGheH7rw/qpuGkZ9Ti02I6hMytnabyR5VbkfNjdztr7/wDj9oFt4C128+JXiqzuNfvtVNsNO0meVjHp652zag6gdAV2ImOS/XkZ/G74vnUfAhl/aS+ByJf+GNE1K30nUrRsz3NjcWtvHHcXQl6IkkyjjGFyF9668PXnjG7pLoumvRf1uZyaknZH7I251LxJ+0B4etrBza6brek7b+YQhmD2qFJI9/G4gdVBHoa+2dD17w6/iS98baLcXH2jw5pF1o+r2twMLc2Ugjm0+ZiuG2LMFcyAcfvFJ5Nfkd8E/jdYfEv4YWvj+cQRXF1q9vPbr9o8qWG5milLRkgAfMy7tg+8DXuvhz4ja9pXhV9VU/8AExuLWx0gTxJva4tLpsTW82eWBABHrtHQ5r4DEzqUHGNWNpJ2OJVNLtHw98T/AI/+LvAXij4jfDPUZpdTstQ1rTW0uy+0mS2tXa0dJIo87gBEMx5XqVrnPghrPhPUPHHijWPiVbare6nonhLS9PtFsHXJlMHklHB3MAEk4xz9DXF/tY6T4Yj8P63Y6TcQ22q+G/Ej38kEpCS3VnMCiPEDy2w8euc15b+yN8Qb7T/Euq28KpJFqwa5klc/OkllHuDA9TgnoOScCv0bDyjUwfNH3Vp+j/FGlGvzz8j9Mk+Ba3Hifw3qd15d9YwafYPCyESRfZ/ssgjZmxgllUOVzyx5ORivu39rPyLD4BaN8K7G48ibW4IopSCFItkA39/4jxn04714R8N/C1jpWhWE1i1wl089no0Onk5jtbYIssRfn/XMshBUfdHXmsD46+M4fHPxfnjnmKWWngaFYrE2T5Vv/rZF9CcMc18Dn2Yc2PcI7RSaMsRS5mfnDea5Y+B11bRdDcXphuJ9F1S2W1842VkLZojIqZIaeRmGz+FQDkEA49O8NWni34j/AA51+A6Nq2kXVxo9u0r6Y7xwX1qka2zQ3IT5HYxp5gJHDKMY6V+iulfs8fCK9+Cur+NtK0+wgubQyR6XeSO9rFqyzKt0j3VxHlgywiRXc/xHB9K+n/hd4bj+IHhnSPin4lsLTw8tp4fvPD2pHQLhJEnu2uNoWBev7iSR+GAc8djmvp6WK5qfNGNjvpRukj8E/wBmXxN8NPCvgTxt4dur/T7TxloN9pmoIEAvLbbbM2PKhlJ8mYblc4bG7rgcV+l2qfFLQv2hPgTYa94VlRddm1K4tJrZ4sadMbe2juY7y4kj3bVWPMSbl+c47Yr4n/aW+Bnh/wCEd/rvjTwbHdxaR4ng1S3v/CmtrB9pW7k/0e2vYnRQ58yQNIAeAO9b37Ii6R4T8CR+Fb29htrvTtS0rXby0ELrbwwtbLBLHd3OQsk2wBhCo+XODnFermTwk6calNc190/zLasjqv2j7aw8LWMfiO+u4W8PeKNFsbjUTbRx5TU4LaMKN2eVYP8AKN20ADAo/Zx1K6tfDvhjwObq41fSNQ0y70u50u7Pnxl2mEkEnmbgY2jV2CkbiOgwK/Qb4y+GPg38Yf2bDqXxLsdF1TT7W0ubqy0rSIhCZW0991tGG+UY8nIOBzivgz4Dap8LtQ8Bib4afb/CmmyX5lkgXU5Jp/KmBSNYYIYyo2MdwIbAx83WvHo0oPDyVFtJf5afMagfBH7QXhP9szSPHet+BtA8Kanrth4P1S4tbbV47eKd5bO9DtCVcZdo2ix8jEkFeK9O/Z08M+Fvih8B7bw5cefpN5ea5rh8Rf2peFroartBilRHCpETgMkcilSFI96/QL4yaxZeDID8ZPAt+39o33hNb6dpsLJdyaZ5EVpcTsxVcJGTvO3gA965P4YeJP2fP2ofgrCdTvdP/wCEsFt9tu720WOOLUJNOfz7jZyBvUE7WY9DjPOK9qniKlTBv6tT5Wuq1d13W3mNvSyR+ZnjLwzc6F8OtFt/Eesaeuo2mm6rFshtoo57xzP5fmr5Squ8rsBJBBAPavp34ffG+y8E/sV6lrF5q0l9LqvhvUrHVLeNVSQH7QQh80s+Qj7FK4AIUYAp37Rdp8Itfj0/4a/CizsrmXTPD15qVtrWpK5kQQyec0SBc75JxmPHPzAdga/EO+8Z+I/EHw3l+DunwHTV8QTO2nxSzbnKi6JlQEYOXfAHAHIr1skw1bEU062kr67bXf6CtpY/VP8A4JLeLvC3j69XwL44uGeO1aXUo18pXlBEbxKm2Q7QCJmAbnrxirP7YvwGfx5+2X8OrnWYBpvh7WdLvol3Q7Y4JfDzXD+WQxICt5SYU9Rhe9eU/wDBPrTU8FXGvroVpcg7BGJJAZ0RbB0SSOb5eF8wEjBzkV9f/tL/ABo8ReLPhXos9gDNpcp1Wwu455gLiLUpg0tq1uRkgRuzKQfvDg9K4ZOUc2qKL91J2u7Wuhy1RD8IvEPhv4i/GOP4hf2jt8WWWlDRtL2LDFYX9xZo/wBmkvIlQMWjVNqgE4wATxz0H7Yt5rfxy/ZHsPHkdktpqWkeI3Txi1ozQx2s2TA91LCv3YpXTB+oIFfg94G+O974H+Ml54UgimgK6wIrhTnfE6NlipOcZ3nJr+l7whf6T4o8B6t4qWSRLLx54cu7DV9PtR5im4s+La4kD/KCwA3keme9XnWXPDVqdScV3T8rf1YUoW6H5v8A7HXi25uPhn8RLjRwup2sGvabcwyTr5aSLIqWjNEm4FVKA4XPTBOa3f2a/G/7RvxW8fa14B8OJc6kmL7S59MacfYX8uNlhS4dfuRSYUEn6A5r0n4Sz+GPDf7P+q29lp6z30VoF1nWyBaQyXcN98wxjO+NWKqTxjvivTfC/wAbvC3wM+HWtaL8JF0LwcjKh17Xtazdzzz3HImlWHaz5yNgX5cYrx8XmrhiKjpU/ebSj26b/wBXIjOxsftI/sJ+E9Sk0PxlaXel6Ve/ZorXVNC0qCOSCC+t4ButAyghbYOpZWAMnYDJyP05/ZD8E/DL4ofDSz8A2t041WHQJNLi804llXyiYz5blmR1K7RuO4qATgkivx/+FNj+0z8Tvh7rOv6HDrni8afc6d4r0K/02ya0sLyawvg11DFGQrYktZHZSSfmTHOa+r/gh+014S8N/GvTPD2reHU8NaqfEC41GYM80YDFmWaFAADljyTwp5Fcme5FXxdBRxL5kpacr0Vt731fzPRp1LHyL8df2EfCfxRv7yaKNNI8a6XcmXT74W8ZiuZ7Q8Q3Skrjeq7VkUhgSM7hXx14B+IHg3wnZa/p/iO5ktLy8v8AUbG9t7tfntp1L3aGZt3zEvcCNVC8BcEmv6I/jZpWkDxjrPiTQ/JuPtepXCxCPBiljkTerjGcZyQPcV/NV+1H4KuPhP8AtM6j4ntdxttcjg1OOC8QSxNc29uN8ckmPWMEZ+bBFHCWNxGLdXLcTN2gvd17PY9LBY5N8sonDat8Uvh78T/FFl8OfAt3DbWcFtbwfbNWtysMM4VvNSNXY4OWbDemMAV6b8FvCd74ovLz4a/Ei9uYdDNtPp1vNp6xAl5mIQFWJ2qwQNlTk5BPWvib436Fe6B8TtXv/tFrG8h0me5trY73iN1CsjvHgAYQfe4yK9U+Hnxq0fwv8RtA8A6RqUV1a30UsWptMo8yOW3YGF0I5w4ABz/Ca/V1gZLD0pUY3jJX11a0vucGGxG7t3PmrxhqvjHwf4t1Twlp11pktvpeo3OnQSvFEzPHbStErFiOSQoJPeud/wCE48e/89tK/wC/MP8AhXXeMfgB8HZPF2qyN4sERbUrljGJVOzMrfLknt0rnP8Ahnz4Of8AQ3j/AL+J/jXd7b1+5nN7Ol/Kf//Z";

/***/ }),
/* 323 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var bcsPassportSvcImage = exports.bcsPassportSvcImage = "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAMCAgICAgMCAgIDAwMDBAYEBAQEBAgGBgUGCQgKCgkICQkKDA8MCgsOCwkJDRENDg8QEBEQCgwSExIQEw8QEBD/2wBDAQMDAwQDBAgEBAgQCwkLEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBD/wAARCAMgBkADASIAAhEBAxEB/8QAHgAAAQQDAQEBAAAAAAAAAAAAAQACBQYDBAcICQr/xABcEAABAwIFAQYEAwQFBwkFAREBAgMRAAQFBhIhMUEHEyJRYXEUMoGRCCOhFUKxwRYkM1LRCWJykqLh8BclNENTgrLC8WOTo7PSGCY1VHOD0ydEw2SE4jZVdHXE/8QAGwEAAwEBAQEBAAAAAAAAAAAAAAECAwQFBgf/xAA8EQACAgEDAgMGBQMEAgICAwEAAQIRAwQhMRJBBRNRImFxkaHRFDKBseFCwfAGFSNSM/EWJJKiQ2Jygv/aAAwDAQACEQMRAD8A9eE+KOtN4PpR1EePaTzSMlO4+tfXcHzza7CAnqY9KJSZASetJOwiDSKjyAdqHuJe8eElJkGRTDJMwDPHmKeg7SaBTJ5Ez5UnsaO2tgRpjxGkqZBmTTt50iCBQIJEK4oF2GhWndQk04qA3nfypAbAJE+tJSCozFFbi6WtwAajNIjkU5JjaP1pupJVC5E0wqlYgnfzNHwgQDS0wrbg0QJBUfakFgJIBA4IpbxxEUQJG9OIVBgUm0hbsaIjYUDOkQJ3p6l6UiBtTdUkxBEdKob2AFf3gJHlQJJEedP0BO6gTNOgEyAY67VNisxBJiBt5GiQdpO9P3CRJkb02ROqBMbVakD3B+9uJ9adphUjr/xvRiTJ39qBKdJE0N2KgHVMTAFIEgykx5jn9aW+mYpAzyIpUPkJCjuNqBhKZJg04lQ2igSNpiOpFNNgopCB8k7miJBmR7UAqSCIijtpIJ3pNgxqT0O1ApM8CnCCmZ42pAnpt6079RIBEGRREAyqZNIElO/U/akYPWi7VDsB24mjukzPHSlMdNqSlCJ60hgO522mkdZPpRMc0kkxyRTtgIpPn7UCCNireiSZB596WlJIM/rQmIOsxpJk0AepAokomBTQkAkE70NhQREnX1INGAD4R4jwaaCJ33oqJBlJAgxNJJtiaQkwORPSKUkKICUiPMzS5TqjnmgYMR9au6El6g21Ek7np0p0QNQj6UJCTsDPqaPiJ2G386QSXoDcneiCY0g0IUfEBuNqW8700CSAQmCQYPFNgpIQTzTiCDxM+VAlSdwTTGGYAHNDYnUnbzp256QaG8elJsXTQCT/AHqJBiTvQmJoE7gaaLBR7h0nnqaQAO5n3NE7iabBTuTvzRfqNpseRA2NJQHhMbH9aEmPMelIfKeg6TzUtvsCVcjVpPIG9EA/aigyoajv6UgTJkkxR1MoEeFUDkUQopGw3O1IKMRJAoSJiT9qa3IYT5Tt0op8lGQKSkjTq0gRTNKgZBoEknyPSRJA2FIiCI2n0oE7SofakZIhJ3ojuOtxEqCp+1FKgI2386ULmeKBIJ0k7+ZpyYNWhSdREk+lGArrHoeKbHluaSjBid6e5KTEU7BPWkE6UyDBmkCeYnmiT4YFG/cKYoTyRvSGxkcEUEyREiaW4O/SptvZlNWLwgaiFGfOiCEp8SaBUCNuKSI5J2ppC6fURhW5pJBPB2HTikoaSSncUQREbxRwwStCUor2PHvSQmBPlS0K1GIpHVB+1NuhKmNgEkdPailImf4c0iSACokAeVE+KFJkn2pJt8DY0gxqmBThoSmANyaETt0oqCICgab42C7dCMRsJg0NJG4FLUADvRSsGDufKKhN2VSSCngg80hsNufOm7ERrT589aWkxIJ3O/lTku5MUGfPekR4SOaGn1pIBSo06Q6oAnVGoxzThMnrtS4Jgjem8GVRVci2vcSgRAgGiDAJ29qEEHYbHejpJE7AeVQ9mFAIP1ogeYn0oFIUqQrY0QN58uauwrYWoef0oAmefakYKuN6EH6U2xWlyOJ6K3O1NIB46b0ikTMCiBHIpLbgdpDUFKY1DrSGxI5BpwKQZk0BudpNFIkW8kwJAkmgZiU7TTlIIMjaRE0oI2KifaqsYEwkQoxSKUneaBSSJmfcUQN/SKVj+Ip3jpTjKU/MQPWmnUDxRHqRHlRYnQ0gcbfSnes8UNz03NIDoZmhsBT+6Un03pdYoQrVyJpyiSYIoYCJPE7+dCZG/wBRSA1GZ2pa+QBxSaAAJAEinEzuRBppVtpImnad95jkCmnYUNCZ24oxHAigTHAJpDV1mnYUEgjcnnypSPmIkim+OYURR4286LAJPU9aUkUDMAUYHTrSHaB4up+1DyPlzRISAAkyaEfaikFiEFU0QoRMjypadJBoAajyPtRVCuwbwI560VFQhMzTuUggbnmmdYH606BMMGZPlRkBMkb+flS4BnrS1c6SKAEB4iRsKJIBBH2imjWeYpDSD7UuQWwVgA7Uwp69ayeEpKieu1CBEA0wFEbk0p322oaRwZpxkfuqA6zStIKbEAOaaBNELERBiiAmZSaYDYiAobCidxyYpHcwowOtIqBUB0E0MEIc7RxNIEnY0lJBMilI+XfalY6Q2TAAkGnSRvqM+tCQdtgaJ4g8miyRKJI8XINJRMeGksTxv7UACBzx0p8jvsIe/HFKDzP60iN9RFIzEg7UAKNiD/GkInYdPOKUnkdKR6kt/rSbH8QKTJgavvR0lImlMnY70iTwSaYgK2+tIbjbcjzpxIiCkGh4RvG/lQAJGrfkUlRwBSIiCZmlKQfF5UmrACwVK2j608bJpoImTMUiTMDihOtgAClI2pGFKpHyKaSYSskn1pgIwNgqmyRzv5zWQnVJgcUAFCYPI2oAaQSoxpIPU0Npnr+lPAigNtutADdO0kRS3G0H7087jptzTRxuSnyIoENTBG3HlTiNo6DgU30JA9KcAeQelAxqlFO6TS+bciTSiZG0elOBGkelIlcjFFW09OlOjp08zS2AG/PNL+FO7KBGnjn+VEz8yTvSjqoiegijKv7tADQI8SRB60t1JBnikFbwKIgc0CGaAT60PENifOnkEjwx50inw7n/ABoBDAVQAreetPlQ2E0gmN/OkUlShuBQMHygxPPWgPl33HkKEKKoVsmnBGn947UANhRJiCB5jekUx0mnkiZmKWxG1FipGODEiPqKOkmJG/nFEQJTImj4lJgfUzQMaQTOk8HagpJ9Fehp0EqgbUt9ifOKLE1YwI8SZjmYpxTvJpASokmKcArcfagEqGEdD9PSgfMc9afAAAB3oQEmRzxRQUN3IgmigQdNApP70R0oCR/ImhgwKMyBFBHERJ86dAMx7UhAG9SS9gb/AL1LgQT7UZKtpIoxsSRMU6Ko3SIOonrFEDTweacpJIg+9NJKTp/nNc6k2bUkOCETuSPY0wgiUyacAOtOIEz+tO3YON8DQdOxG1OUN5TyaaSCIn70Uc6SeN5qWik2gSvbSnY0flEnaOpqGzNmzBco4avFcfv27OybUEl1wwATwPrXPsU7ZcadzZhmA5VyXf4hY4kjUcWdbW1as7/vEieOvFXGLfOxMVKcqxxcn7l/iOtahEp2pIWQIFYrT4ldqk3Yb7794tyU+wmtjSQNxtUtmju6Bp2k8mmKASQQN6eeY6TQWneennTsmSGpRJk0VDQTvIiklJiAqkBMmZMTRaMxIM8R9acFKGnVxQASRMUldR6UbPcpcWJYIMmDQSmUzAHtSEEyaIM+FNG/YTY8kaZ9aaqD4gSB6GlHijyG9FMHcD39KXG4XbAYNDTMbbilBMpPSkokGJ296aQqEdhExHNNASepNO19OlH92RAJ6k0FAkRAJpI1at4iiE+EzvRQlST5zTsAaoJ/nQIV/dAFEDbURvNOIhJncHypWAwhKQNvpR3I2obpE/TeiJAmNvOmAojpzvFN8QgkbUdSSd1e1O1K5KdutITAqBEg787U0AH5QfWnKWmNj680ApXKd5pxewkhCBsomgEhRjUPr5USTPiTSHzbc0WPgR5I6UpAglJ96SlR8o58+aZqVMaT9adMLMhhREUdPUgbUzWU7x6TTitRERM1L2ewt2LkEz96Q35Emg34lRMehNJSZPkfKgoUJH7pG/NOgEekzTUzx5daduDp560m+wmA6TsBJHWhpj3pExuo704qHmOKb2B1QwpnZSgCKQMnb9aI3kdOaKonj9KpOwQCSODQ3PMUiREUgOCOtFIOBGY2oTPh8/Oj4piaUCdI61NUAifIb0gdQ0DmkmeaGlW6huPOnewCVBjbihwfFNPgkalDjmmmdgBQthhjUPCOs0vESExFCSUyDT0zB52oYkt9xqklIgAChsduvJmsh8aZE78A00pCYk7DmnFhJUMIAVt0oo8JM9dzSA6kjfqKUT4R+tHVYwFU9NiacEK/vUgmRpE7USYjqfKl1dg9w0g6YJI3iKRJA25oq23nkzTgARJp20CVjAUxC5nmkQI1JMGkTHJ2oaZ3BkHiKdUrRPI7SOh3pphW4HHnS8IV5UfmMHY0h8g22JnigYJG1PJ2kj5eaaQNjpPPSq6uwqF4QOSJpJMge9Onp+750pVukAGk2IUaRIAnrQUqNzRnbxT602Aowobc7cxSsEqYCEgzqk9KKUgzPWj4YiNzQEcg71SYwkQQJ28qaqNWxM0SNRGkyaExyIjmpb7B02ETMk04rBGwmPOhA/eVE8U0ykwSPoKE13E07HBRIphJ4BI6z5U6ZEE/pFIDUdueh/3dacWkVwKYE6aRVIB0gJ60kgKATG9DfVCRMU7T2JSS3DsownYDz8qUqR4gY8qBSQd/rRnUNPSh7Fc8CB9j7iiZ+Ubz5UNHU8+VKI3FDaZLXYRBEwk7URKY29d6ASUnTyYpxVI8XPlS2JpjdjvFI7iIoT1O1BRiIPO1Un2LUfUcT0JpSInypp9aclQI0lQg1Mk7GlQhCZGk7UpJJMUAFSZEjzpbwY6UKXqJxsAUZ4FEEKMUDMwAAaQPUEbc1Un3DpoIkJ3HFO+YSBJps+X0M0gQrwkwaCKYgkEQRvQMJ2B3oj+8gbUFALMkweKaHTDq6gCgdx6GhseTvRE8JEjzp8i4EI0wKXp+vlS67EAxQI2G8mh8ByOkk7Hc+dA779fKiCn5QBNDYHrJ+1IYATO5ijuJkCRxQKQSdRijBAEnjePSj4g+QgDUTNLpJmgAeQQRSB2knYGobadDaVbAgJGmevWjsQd9/OkSCNM8UIkaVda0tUQk0LjcfU0QeAkmJ60TsIB38qZztwaRW7H6DJ5+hpGf8QaaSngneiFHkiQKlv0BKgkAcbk0ON1CB60Y6gKnz6UCfFEx70twYhE6hvQUZMxHtSMzsQQPKkVbSBEVoxIUAdI9KPNCdppQoUgFEkE7RQA35owpW0UtgCY3p2kNIQO0dKB6j60QDsOgpEeQ3NCBiO4APEUBHKRS3BgjelsesGhgn2DsZ3Mih+6YHvRjYkbeYNAE7jzqU2HSEcbxEUt0gqHI4mkkJJAUeCNqUSDttTcqChTtS1KPhJpAADmkSPrU2uwwkAjwnbyNNMgABJpAydzHnRnf5aadoVIUgg9QetADqnn1o6QRzQ24607BIKd4BMGmmRPH0o7gydqPqBB9aRVC2mI+tCD0APvRIUNgBSB0qAP3pWTSQpkRxBpagk7gUiZkbTPSmnxDT50dYKN7jpBA25pR5UARAA3p3rV3YUAbmBRV0SDtzSG245PShHmKm0xvgEQdgJ86REjaRRJkb7UlEH5lAAb0J1yKrQOVAHyoHwqnmjtq26+tIFIOnzqupB00gEiIM+lIEHlM/pRUJUTH0oEADdImpcvQKEobTEcbUQP0oz4RI5oblRgbU92IQG8qNAgGNutIgjaIoq4kmD5UdTAapXI86KVSAR0oxskqQY8+lAgdOlNMAKE9aMCDChsKAJ6b0d9Py9ad0AAlO6gqfOiCCmTS38oppMGKQBVPMyaG5HrSGqPEKQnYjqKGu4B07QOTQKdoHNHfrtSjY+m9MABIO5ApEK4FJUadjRT8oO/FKwGwE8jenHVAHShvHSKOokaUiSae4DSmBRjUDJA2ikCQYPPlSKd5PNAA4ESDtFIbpgiDSJBG54pAKO/TzoABBCQKPiiNiPOkeIozIgpoFuMPzkhUe9KQQIonTvv1pAnkKEcUXQxAJSNzxzS4THXpSWI2nbzikoQRB2AnelaAE+g48qIQnkCKbz4pTTpVEwP4UwB1maXIiPrSGxg0iAeDvRQABkaYmhqAIkgyYpcKj0owmONxQ9gBEevrSUnaf40eni2NAjWIkwPSKLsBpIBI6CkkhQmioQD/ABoJhQjagQgeid6EBQjkA8iikD93elChsB7UchVhgRTNwT4jEHanAGfFyKK0yJI9KBkgIMkE0QlX7248qGnUf5+dHrEkQNjXHdm4dAOxG/SgUgbE8U4AjcqKp+lMcQrUDG8RAoXoDdIaTPTenxxJg0weIJWdtqyqKSQRvTZMTVv8Lw/FLdVpiNkzdsLIKmn0BaSRxIII9q2Ew22GWvChA0pSNgB5QKdO4IJMfpTDz9ztS6e7NOp8DwAEimq+bxEaacnfn6Uikb7n12mkIxkySNMEce1JKuQKelG0bUko0ncgVbaJpiToOwG9EJiVJSBRCUwVCkknTztU2OkMMTqgz9KUEE9QY4inKBA9KAjjiqTKjtsIiR5TTdBSdiN6dqlW/wBaC0yNzTVmTS7B06gIM0RKTvxTRpTwTSUSPSetJqx36AWSeB9KSUkmQSDRiFQBM0pAPMelVdKh8gUFD97j3o+GQs804BShKSRvuRSUADttHQ1PUJ+otyNR2/lTNJmZ2p8EzH2JpFCU8QB507BJsbMKBBAok6zTVgdI+tJXy/5v6CnsgFM8SBE/WmkqmFe9VTPHaVlvI9sV4ldBy6UPy7VsguK9x0HvXKbf8T10HCm7yjbutT4O7uFJVp9ZkfpXLm1mPC6kzOWXHB02egCsT4Z46U3vByeOs1x/DPxHZOvSlrErDEMOcPJ0pcbH1Bn9KtFj2mZJxbR8FmrD5Xwh53ulfXXApR1mKfEhqcJ8NF3U9IO9NFwflBSfqaiTdXHdhfdrLZEhYEg/UVnw9u4xBDt5rTb2VsnU/dvq0tNDqSf5CtvNilbexrGG5Ii4KhuQCf4Uu/0iQRXJO0ft/wAu5fuf2TkI/ta5aIL1/cD8knyQid/c1WMN/FFi5KxmHK2HXaViAq2UWFp+wIP2rhn4lh6qMZ58MX0ye56BL6SSTI96ap5E/MOPOuRYV2/ZNxPa6TeYareQ8kOIH/eT/hVuwzOmCY0gvYXidtdpG0tuA/pzXVDVYsv5WOMo5N4st/xCSQDpisgfSVBJUn12FVv9qBSxJB8gTvWyziAOxVt1gVt1lk4XUzAI+9EK9faolu+SpIMfrWwi68MkD71d2HPJIJ1FU6t6fq8IBPWtNFwEwRsCPOaeXwogk+GpfJPJnAB3PWgoqBMfesffwradh50S+kiCYp20G6MpUpMEKpKXJ53rGHQoQk0QRsSQDTsdsMRyIpbK2JoqgjSDJpqegOwoVMFuOJ0wEqIniKPy7p+bzoGZG4AB60QY35AosYCEhRnmgoyfM9DTlAGNJBmgEnk7U0OmHSSJnxe1JUn/AEetEEAyaapYUIHNS7B8AURHhGx4pDURKoPSKOwGnpSEbdaYhSIggT/CnECR7U3belsY5mCKT5C99whIBJppSIkHY0iFRpPzU5CYHn51THSY3TsNShApxDaTtFImdjGn2oCAdtvWlZKoBBBP90cUQVK2UrfpR3gQD67UBMgHrQA3wpkb6v0oaZJ8KRtWQcnfYUgEkzpmjrExuw2QOaQg7mR6CnbTtsaQKTMSIMUXS2KSbGqj92d/OkhKiNlAAdKKpJ1STFHdKSrinsPpMZAHlSAUQSSKOkkBWkCiIVyDRbJGyRsNqKNp8+hp2keRpFIA6xRYJdwEE7npwaEECRyaQBIgGaKhpHO5FAcmMfNxvwaKiSQSBI3FEAjcjminc6jTdMOREEAiNyaW6R4kiigEk7SPWkUKjn0AoodMaQAkKSAJ5pAAzBiOSKQPnsRtvRk/KBx/Gk1QB0QZUJJoBCtWrUY9DR1Eqj0mlqjaeaEwsbJCpJk0YB3CfEOtJQJUB5inCBG2/Shjq+RKEmT9hQJAMAk7UTuJ6U3cH0pCaFuB5kcn1pDUszQKiCY4pFU+FSjv5dKfIcCEkajyaUAbfrRR68UQhW9FsOQQE9OaQgCeTRUIG9CNtqLYgTJSCBESaIjcpPHFNg6dVEHTwKQUNOo7q8+aJ0qEAeKipUjg0wbGf91ardB3CBG4ApAGSJpRB2maUngg9BtRuFUESJExSEDpNIAcb0hESOhmktuSG3YCkg78+dIpSkweeaJhQB3MdZoaZM9apBJNiUJTtPNIJPlFERMztRJ1TvEVKbbG1SABAnrRHyzxQgddqCoAiaoFuIaTyT7dKSQSQFbztS308UQkwDBkGk0OkhEiZSIpoTKirgUTISNyd6SZMgjpUtBVikAfLSJKhBHh60Dq1BI8qMkHccUPYGIADwg8eVE8k7RPNAkiAaUb+tCWwhQCdhQgzESKcIHHIomVioKQwSAByB14pQJnqKPiCR5Dy5oQFbwQJ4q1twDVhkzztQjkninDT05puiBzINCl6ir0D7iaUjpQEnYcGlAmPKq6rFQuh6GkI5JMGjsDAIg0CIO1D3ABBHQe55ojSNyJNIgmATSJ8UJG1KukBb8gUtyDtvSnVz0pGSZ+1P4D2CEynY0xMAEwJPNEggDekRO/WnZNBBgzCeKUbcxQKZpEGQJ2qWUHYAdfOkYmeIpoAHA9qJng0dieBJUBCY53rIDtJNMIlIFIAgRwKStDe4QBpCid6AM70YASD1AimaTB3IncU+uwSfYdvO1AqHykc0kkARM+tE/pRYC3/u/ekBBJjk0lSCIkUoJEgyql03uFoQURsT1NJMFQ3H3oSR8w670jHAA38xU8jTCZmIpafb60og7GgTJG3rTS2HyGTPH2ok7SelCd9gIpddqa24ECZUSBNO1E7Hc03rAXM80pOoFMQKGPYI45NLYDcfehECJ6zQOqd6mgbrgdsFQE0VJSVbjpQ5FEcbgfSmlQkxo52FIwTHWjueNqMA89KqxdI0SVSaSirVpA3oddiKQTG4k1XUKqDuBBMmlsZEySODTVKjrsaOwT71PALcR2AB5pESIAE+dI8TzNLpuN6JbhQ3YA7yRS0q5iikchR5FJXiGkzFO72EhapT5mmz0HWiJ0gbR0o7iU7VTGEzoCj1FAEBMkGlAHXboKUAwCdpk0XtsLkXhJ3AJ9aIImIAoQQSSNqBjczxUqQVXIlHeaOkyN49qG5EkUCSAVp5p9Q6HeH5o3pbmdqBIBInf+VHeYJo6xUI7CgUwZml8s0Y6EzSbdi7jYPM/elCZhaRSMkynrQVE7zI5qk7GEnSqOnAoAHjSCKIg9fvSJ9QAKXUhCESoGm8bD6UR1I6cUplUzvHFGyQxK2ieaBBJMmiSTIMQaQJIP86dj4GgE/LtSCdxJ3p2ohIFKNuDsaXYXI0iSdqAHlJ96cCRJMigTsCeTNJA1QilPMUIjcUUmET1NDrBodoH7hdNjuaEz4dMA7U7YRySKAIPQx0oTsbVoBCtRg0DBEgAmkSoR5UIVwNveq7EhM7EHg7mjqO46UNPSkQAYUZHMVKsCUgKTAUBHlTY8IJJnmkRCiJg0QpJPHArms6LGggkEAx680fCpW06qJOs0h4VEjrSYAgQDuT604Enn+FIqJ2jjrSAJAgjnYnrRYCMAahzQG5BPERRVt4ZFOCRETPpTTaGNHNEjUDBjzpQDzxSSmfl3pANB38QgU8AK2KSPInigQZgppcbn9KAESU+E7ChMfKB5048HeKaATxEUAGdWwHvvFIiSARuelKARB5FIKnwgRG880WA3T1AMHzp3hAkEyKWngq6dKW8bJinbFsBUEwTBG1FSYGqRI8qR2G9IggE+e2/FHALYCRtuKRIKvCJ26UknUIP8aMEnypvmwsA3MFU0tQJIMQBG9OgHgb01SdPAJJoQN7bBCj0gU1cER0pqk8kCqznHP+XsjWSrjGryHCkqat0buO/6I/nSlKMFcnQrpWyx3F1bWrK37l5tlpsStxZASB1JJrhvaT+Ia3tUuYRklaHngSld6rdA8wgdfc1zLtE7X8x55cVbB02WGBQKLZCvm9Vkc1QVKWnof8a8jUeI9Xs4/mebn1l+zj2NzEsZvsUunL7ELldxcOmVrWZKjWoHSBKQB7Vh1GZIimqWoGQJryW3N7HC22ZS4Z8e4pB6GzrMDpWAvFUJAk+QrZZt22vzbpRPkz5+9IW6J3LOKZkwdQxHC8dvcLZSQdbT6k94B0SkHxVYM39sWcM2YU3l69xq6Xhre/dKITrV1K9MA1R7q/eu1pLkBCBpSlPCR6VrrWI+Y0dTWxp584rpi3XxMpcAMEz69aYpwHZFYNQPKjQmPlNTZgZw5Bk08PrYIcZWpBBkFJgz71rlW2/SgpzahNhxui5YP2rZywjQE4gu6ZQIDVz4hHoeavGA9vtk42EY5YO27hPzMeNJ+hg/rXDnbnRsJrEp0qUA34lH9a6IajLi4Z1YtTmhw7XvPXGBZ7wbHEpOFYow+4RKm9ULHuk71u5m7QMIyPaziy1P37qApmxZI178Fw76B9zXlbCynCCLxYS9ckeEajDRPBnzoXN7c3Tin7l1S1rMqKjJJ96634llcenhnb+NUV7S3PQeG/iOy6pzTiuXL5hJ/wDwe4Ss/ZQE1YMO7bsgYo4Ut4y9ZkcJvWNH6pJFeU1q0gx1rH3qyNIJ3rOOvzQfJktfK90qPbdhj9hibfxGGXzF22NiplaVj9DW2MRSJBcGrgjyrw9a317YrD1lduML/vNLKT+lXHCO2jPGEpCXb5GINo203SNRI/0hCq64eKJ/nXyN4a3HL82x61RiKSNIWJ86yt3yDBLo9q4FgXb7hNygIxvDnrNQ/fZX3qD9DBq94H2gYFjgjCsat31/9mHNC5/0VQa7sesw5NkzojKE/wArOlou0fLINZUvoIJ2jrVRTijjS+6eCm1jYpUCCPvW7b4qNifuDXQmqtGlMsqHUKHI+tEOoTIG4quXeYcNw9tNxiF63bIV8ver06vasljmXBMUQBh+N4e+qflbukFX+rM1HnY06bEotvcsGtEFIPWaBUCIFRpvS2YUkhY6EEGkL+TE89a1v0G3WxJyCAJ45pJJHB3rQTeJiOZ2rMl8DSAevrQn6io2Adp3nakDOoDYjisXfDp4vantrCpJ2PrVX3JsyIO/HvT1BIAiQQZmKbJ2CRJ60tQIM+3zUr3HF3sGE8n5qIJjbg0xIMbbzyeaeADCAPShibpiBCtwIpqjCp6RRIUDpA9aCd1eLbijjcEO8RB2I6c9aRlQJgCkAJ2SRSI4SqnsXsACBI5PU0iFAgEyDtxTo4HTyoLgDVGwM8UCqLGzBAI3nekQSTCYBpHSY1c9TRkFMjcedAe4SNUadMxRiNutKJgJVtyaEqnYigcWuBQY3JP0ihCgqBuD508bgmTzFDxJM7iKLHQBKZBoKO0SQOkdKeZInqetY9HWAT12oW5LoQEcHakAJ1AiB608JAASriKRj032iOaASrdgOkyAI+tCEyCJjqKJTJ3EClKRtx5E1NircW2mEk7UJlUAnYUiRG53G1IceLeeKobdcB0AH5dU0iJHEGlG3rQXOnelyJNMClRuNjEbClE7jYAcRQG+w5okEATT2SC0FRkJVERuNqaFb7/ene6gZHWmFJUkzxQVIyGT4YE/pTVJIBE9KSCdgraiBq8RpLYhuzHpkAT1mnEGeaASedOxEzTkkyPDNX1UPkQVCYJokhQg8TTVAE8xHFEpiJj6UrTEpVsBQjccCkkjbc0VcH0po1xsaQdxDiACRSIAGxJ9DTuIA+XzphG86vaacaewchFIpjcnahvMBU07QrbaR6UDGGZ3MelKDzNPUJG3h9DTYA8KvempAJQgc+tJJ1bniiQnoZHlSUjggaZ29KS94hoIGwPHnRHzGfpTVI24lXp0p4T4QVCCOtVdIYoUNpEU3jYjeiBEnc0ogU+pCBuo70d+OlEDUBA360CCk7CaTd8BQoG3hG1JW/ij6+VATMq4NOVAExxQ2KgKMDdJoTA43NHw7aaUEwSZM8UXS3HTFyIJNIAgeKAPOkAZJOxoTuE9aOr1CgAiJ3p4SCNU70JSedqXM9IG1Da7CQtHmeTQCjEDanRB5psgEiP/AE86m0PcW5JnmkRSJgzSmd5FFjECvzikSY6UBvsOfSiUdByadruCTEIABNI6SqN45oK8xRBKdz12FVVcEikc8xtBpEg7il1k80gRMdaW4AgABVEAn5tp8qBB4A9aBKj6dKTb4GvUJASfSjvE0AZGrmaRUnoapMmW/AjJ55FKDuqkNRkkc80BqTpBHNNDFqPlvR22VPpR2mZijEkeEneobVjpsbMbQJH2pEatzQMDwzsePMUY2kGr7WJoaVHg8UdYgxMil4SACaIAgmN6m7ChJ8R6b+tE9QqPIQaSYCdgJ8opsjVMb1NMadCT8u6RS4E0toMUQAYBNO9xNikkbe1JI3BBn2oJ8Konfyokn5eOtHA69RpSdX1neioCZnypQSZA+tLbgc03wLuKFySU8iKQkHjpFLjjeKAUomCB7UqB7Dv9LignnfijuDpjoY3mmgEjSOT0pgFKRE8UhKTHSkPlAHIp20bnekw7A2NNVt+8KWuFRR1JmFcU264EIKJ4H6UjB5MGj0EbmmwrVB602wYdRGxoQSQenpSUd+BPG9H5d0nalyCENBMSJpeMbbUpHCqUE71NjqhBIAlVIaT6U1UzCd6Jj39KtbClQgIPBj1oySYjcUDpiNVKeI+9S0NMSh9DQAUTvG9OVAg0IV169BTWwAIIMeX2pSD4jTxGjwmTTQIoUmJr1BMq/wAaXWeAOlOUBsPWklJVO3FF9h9I3x8Ez7Ut9EQedqXoPvTZI8I6Ubi9w4qiAqgfSlpJEmlER1p32Bqw+HqN6UbkTTZAOomAetFW3TbzqXsxSWwiJiOlNMiTO9OBn286AKSYgnqapsaVhB2nielI8gD/ANaBEbGaQIiQDzSWwUAjffmkEg7qHFFXMzJNLSsDf7UACCn1pEeKYHFITtA6yeaSuZ86adBQgBpB86Kt/D0NICIT0n9KEgmQZA607QnxYoH1oH5RKoikEmZB2pxgDYiaViruN3I2INNPOlShzMU8GN+tLc+Ip4pXuN7oYQd9venaZM9IpBRA080o0+IHY7U27EKJ/wDSmbJPhmnavWhH95XNHAt0wHUDHSkASeaKgd4396Q43Eeho3ZaoB2O6gKGqANyqnHw0CqR5Dzp3SCkSCT+tPXpCYPNMKARP8KW5SSSIG01zM3Y4BMA9RTlEn36GgkDT5zttTo6jb3pCGpjgkfQ0hAMzSQEQfEI8opBSRtCYJigKACFdJjf605JHmQDTdQG0bT0p8kiUiAOKAESAACdxzQSoTCJj1pQDulI9zSUDpMRtQAN1Qk0/T4geKYNQInkcin/ADDnemC4sAUY3MRQMc77+dOICRuKYY+X0pAOgpTMc0knaNUE0gEpgb8UiEgbHigAGCnnejKhAJ43oiDO438qOkAyBPn50CGkBRnqd6GwHG3PsRTpg7CkqANvegYkiYpLJA8Qoao4pijAJngTvQAZHJG1MddbZSXXFJSlA1KUogBI8yelQmaM5YBk6w/aGO4ghhvdSEapW4R0SOpNeY+0ztxx3OneYfhql4fhKhu0lXjd/wBMj+Fc2o1ePTrfd+hjlzwwrc6d2l/iDw7BS9hWUwi+vkjSq6kFpo+Q/vH9K85YzjeKY9fOYni185dXLvzrWd/T6VHqe1CVEk77zWFT8HY14efU5M79rj0PJzZ5Znb4NkuJknamqcBG1ayrgBJPJrH8QsjVtt+lc5ztd2Z3XAYCQKTDLr6ilkSB8xPAp7Nk6tKbi6XoajYRuqs7l0C2GWUd22Og/ifOndItqMVYEpZtQpLQDjn988D2rGpYWrUuaBUEiUmfpWEuT82wqXuRdsyFwkxMCmlUDcjmmLcQRAO9YFvR4aVCSNkLHVUD0pq3UjZJVWkp8iYpvxJjc71VDo3DcDkj2FYjckpO+1apfEyDzW1bYet8948Shsc+dDikXCFgt23LpelpJkdegqVt0sWTZQ14nDys770zvUtNhi3AQgfc1iW5A5B9qCnLp2RmU4r5iZKuTWMPkqMmsCniCSTsKxlcg7n3oM+TMpZ3JpJcTAClViSpRER9aEgGFGkBl71JJA5oKcCRzWIrQlPMqrEpxMbzNArMybkEwFAHypwuFhQ0mCkyFDmtAqG4SfEeKRdWtQZaSorV0jmmtjSKb4Ltgva1nfL7aWLbG1XDCfCGLpPftp/0Uq4+hrq+V/xAWllhblxmLI1u/iAQRb6H1JaUY2Utv+QNcKsrBmyb725IcfWPlI2QfT1rI5cEElTq1e+9aRzzhtGTOmGpnhVJljzXnbGc24mvF8avVPPK2QlPhQ2n+6lI4AqtruyHO9QNJH7yea11PpWfm2pilhB1IURWdu7OaWSUm5Sdsu+BdreeMDCW2MacumkJCQzdnvkADy1bj6Gui4D+IXC7pLTWYMOcs3v33rc942D/AKOxH615/UoGDJPmaAUOTBHoa3hqs2L8sjaGryw25PY+CZ3wbHGPiMKxJi5SdyErGoe6TuKmWcZSSAVp3IgEivEjN09bLD1o8tpYIOpCiCCOsjf9aveCds2a8LBZui3iCQQZfkLCfIKH8wa78fiV/wDkR3Q10HtNUerrfFEGIjn0qQbvkEBUiK4VgHbVlvElJRcPu2CyOLkeEn0Iq/4bmVh9pL7NwhxpfC0mQfrXo488Mv5XZ1R6Z7xdnQWblJMiIP3rZDw0lOkQN96qNrjAWfm486k2cR1EyQY8q1spQonEqSpQgbetPSYJ22qLZvQYMxPpW4i5CkyE7+dV1WFWbKSJ96Sokgb+hrGHEjkSRTgd+RVKmA9OoEwaR3Ikk+5mgFGPSid/lkEGh0iUgKSCJB2pqk6uB96fA4EiiAI8zSsSixiUgJ9dqSgRvp+9PUAolRoBIIgmdImix9IyYElMTRCY3Srpt5iksEkSKJTvEAevWrXA0hFYAAPNGZIiRTQQU+MUdQmOkVMtxO0hhJKiJJkU4lJIJ3IppSrkU7QDGxk07EmOhMQFRQJV8hMz1pJCZgAkHijGx242mpse7GeL+9SUFmIPG9PKZ2SKYoHZKqd2S0xxTq8RE0AgKAjpTplAnYmhJHzbbbUCoQGxBpsEQknrREqIGkGiVAj5QTRwXshFEAUBG8lX14pwJPhPNBSSN+lHAmk90Y+Odx5UQqT8sU4joN/WklIT/CnzyHSD90auDvPWaXrpgDmaREgCJ9KKgJJgkHzNCopJUEgTMR5RTQfHsacQCDIgTNIafmiKbG0NgjY0FESAT0pSpR8WwNEIJIG2w3pcGVbiCQBtEHemrVBHpTyNAhQMGmkKidUChMpuxJO2yaJSCTvvPFBRHEGRTgYO45osaoHBn0ilMH5d6cRChIMAU0lJk/amPgZMiAkCKBAIMgppx8JmDSUJG6iaZLtilOkBKASBzQ1KIAjmiASY3G3SgpMiJMedA3bAFqB3JPpR1b78U/SBBHHQ0xaCk8T60hNNciA4AFIDxCeB5CkFdBO/NJRnYU1swEDsAdo/X1oJ2HhO3NHjb7jrQkiAgdKfcAGTuaUUoMyoiiNjI29apv0F3Bsk708GBAppPmKQkp9PSoGICV7UiCVSTtS44Me9IbbGkAIg7n9KcFCJAG/NJMkTIVSSVb+FO9D3FQNJmYH0oLEA779KeoAkkmD0phEndRj0ouxtVwLeBAiKRmdxTkhUUlbDjejgTBqAV606YTpG5pgBMSJniKMaT60DFo5KjI6Uto1ngdKRJMHaOm29BZ8RgcCmg2sMkb9T1puySrwjcUTJhXApGPlII9TTVsLsAA5078USY4EGkNRkQJmipO4MUgGn/wBaJInbY0ByTQ2SY3JPWkKwqjVERAikmI8QpEEj5d6KRvB2HrVvZUHAJ8hFEEqO30okSYjamwQomDtU7DbaFKvKhBBgAUTAgJMzQlXPEU+CeQnUNqI3E0AoGBG5FIagIkR5GjdlBO5gcAcU0JEyRueKPymARtzNFZJ3G3lR1CarcZseTvThxQ68fcUVA7FJ+lJ8j7CJ2gc0jp0RvPPpSI6g0iDt4iaondDSJJM0vYU6BM6fqaHhBpdxpiEgkz9KRkcUSQr086RBJkiaLS3FQ0ggcwetO0lQO+9IwJBHG+1Az0oVldIQSdoO3lQgzIkUgdBPrS17b/xpPcFQj4plVJKRpiTNAaTvRCiBsNhTJbBvMrM0ZAMJH1o8byJpv+cImi75Et0IIIJAFL90qCZojcweYohSeZ2FFjpgCYppKgYpyzI9KQEHjeKORtVsDSOu1ApgyDsKdHrQM8R70yQpGkCeetFIH3pokbjcUTxPWpVlhmDFNWd486KZmaStPCqLExJICdJ2J5ihG80ikgCI9ZpGRt50cgwxtPWglKlE79KKQU79KKFCYI29KHKhqmNIUDBNAgHkU9RkEgcn9KbMb+VCk2S9nsABM8dKQCjsT4qMwJNEyfejh7jqxs7Aqo7b+lDRB4FO3UTpA3ok7GotjSOvSkT/AHeRRII+agJO3SmnsJ7AT82rzo6R1JKp2pQEpETNDketKrEAmJE8GKUqA26daPAkkE9aBKjJSPDEVbEJUJ9R0FJO4kT7UUpOwiaUQSDHntUOVBv3GwJEkDeTQXA8I604nVtt9qGgjbqaatqwpPYSTHhmiImZKhTSPETyKI6lIH+6hlKlsFR24gUEyncUpBBH8aCZgxuaW6DZjtjtTTpAMCIpbifSl4TEn3pt0HA0kwFRyKRG0z4hRUFHge1EbETBJoTtWTwMJn5uBRkESDR33MAieBSJAVAH2ovuhpbAI3B6RTVK8MJMA09WnmfpTFTwBseaE7EScxtMelMEA6QTFEwSCFTI3okGNt6y4OhDkyOJP1pFRG5BI60BA+byoBSgYFKhUOCuuwTEb0QABIIn0ofMkFWwohQCgngUhcCMncmTRnwgg7THtSCSJI3FDQkb8GgLCSQONvIUzUTtMRWTSjk8GmmOKCkAqO5SmTQ1n+7AokBO4pCCFADgU7AIKiJ3J6UZkaSY96CiRsKIVHSfOkSIgSIJ2FE6UkHmlyqSNulMVMiFCgEZN4jz4FDYEieKQ1Ab7GkogEgDegBbidpnigZ0/KTHQU0mSAVcdOtRuYMw4TlvDnMUxe8Ta2yDutXU9Egckmk2oq2BIFQB3WJjgb1ybtM7eMDykl3DMEUjEMVEpJBlpk+ZPU+grl/ah2/YrmEvYRlgrsMMPgLkw88OpJHyj0FcbXdLWTLu53O/NeVqPEL9nD8zz8+sivZx8kzmnN+OZrxJeJ45eu3LypA1GNCfIDoPaoRTk7cR0rE44TGommat9+K8lpt2zzZNydsyFZ3imFSf3jQK9IEK3p9taO3ijpEISYU4flFFlJWMShx5wN27anCeEipJu0Yw8BVypLjw37sbgU83DGHtljD0QrhThPiV/gK0FK75ZUTx1pNkzfZGy9cLeVqKpHQVjBIkmBNYg4Egk1gddUdwSB7VPJO75NkrgHSRWup0DY70zvRpPiM+1M1SmaYJGVTiQd/0rApZkyNqGraaY44QnigYipMGTWKCtWlsFZJ48qLCHLlRSNgBJNSNsyyzJZkqIgq5qrANrh7bJ719QWronyrbcXqETAngcVhLm+3SmqdKhtSH1SqjItQIjyFa6nY4MnyprjqkisJVMq4PSgSVmYuEpJKQfagpwJmUwKxaykQN6at0FPi2JoK6WZlvJA0AkDpWNTnh8ZkVjKgRzNNDg4UY9KErGotD1qMSg1hU6RMnekpxUbJgedZbewdvCpZlttOxUoTTaSKdswM/EXTwaYaKgevl61OWttb2rZmFuK/f8qc0hmztwywCIG55J+tay3lavBuaQnOlUTZefJUAoggcVgUolZ1ACOaYFhJBJk0x17vCSrYnpU0ZUPUExKSAPeawlwkKCdx1ojVp0k6RWPV0nc8VQxyTI2meop2xgaRHWgVgKkCkVbgt/XagBFaEq0okHmKJUroYVTdl8Qoj0ppU2kEEwaAMiXSVaif1qWwbMeLYI6LjCcQftyNoCpSfcHY1CKcSADEGnoeJGkGKE2uDSDcd4ujrOX+3C+tQljHbEPJPLzMJUI80nY107Lnafl/GoTaYihLoIJbdIbV9jzXlgqUmSrhWxPnWZt2YC99og12Y9bkhzudkNbkhtLc9o2uNtrAIUnfcb9J5qWYxZKplY54rx/gPaDmbAwEWmKLW2PlafJcQPQbyK6Rl3twsnQ03jlsuzVG7rZK0E+3I/WvQxa/HLaWx2x1OKa5pnohi/JjcxEGt9q9QQDqBPHpXMsDznh2MsC4sL1u4QdiUKJ0/4VYbbGkKTpDqYHJ/4Nd0cqatG/SqsuyHwQdxNZQ6iJ5J8qrNviiVbBxHt/wa32bwCTqHPSrTTCiYQpJV80mnAjkHYVHs3IUZBkzwa2kvJJAKhPpzTb7CozlKYBETSJB6/WsRXIBTRTO2/uJmkIyKlW+59RTdzwd/LqKI0nlUUSpKRAO/Smm0AwAmJNGOfCKIG5G/nQSTwCJ/Wm7JTsJT+9x6RSCSYJTO1BRIJEmkCAiDsB1NDtF13HeE8AA+hpSQSokGl4SCRFDRwoiBQkmKTCnnVq2oK0kcyaQGokg9aOhwDzpcAhoChueOk0iUqTJMnishiNjMGmR4jq4mKd2KW41slJ35pwQAkxPQmjCQYTQJI8JPrQx8DZPhKhAPQ80pg6Y25ogyqFfLHNOhMkEe1KxNWNA6DiKR32HQ0SCDA459aAjkU7GlQ0hW0gbCKM69jvRUfmBBimpEE+gqtgsISAdJNPATpI2NAJ29TvQ0zunrUPdjCpEifMxSEJEkA/SgSNIAOo+YpoBUPDuBzVULp7h3XvAgelIkREz6Dzo+FIkmgoiJ1b80E8AKlkQackbSTQPEkbUIJSPIik0CkFfWSdvKmgSd+vFIpUZnk80dKhEGSKpBbkOlIJ2k+tITEBKgZ486ACiidJmlJ5NSk7KAsEGdwaRHWdqcYgKVxFIIC91eEVXVQwEgxP0rGoLJ3VtT4BPX3o+DTtuZIosmT3MY2HmaIAnX1FP0xtTFaYkGN6LsW3YRTHi8+aCeDt1pw3kaqQM7gpMfejgHsDTKtyIph8JO30rKAImN+g86bp1AnrTTY62Aobzv9qcVoGwFKNtyfrTUxAIMmKBNjdQI1Ec+dPQkk7jgUNGobCTPFOKQNyYotAl3AYSYSD7UoE8wfKkVKnpJpE6jtStpjclY2FzM7UTuKcN0mKBSqQUnczQnbJadgAVxMHenKMiSKaCVJ43SB+tOB4nmhjW+w0GIgGeaChqG5M+Yp5VyCOtIBJIil1JMOkYBI2IikpJ1SJ3rJvMhIA6U0gqVvsf40dY622ASmNMGBxNKNRkkRS7uNh16daOoggAbVXwBX3EUp1bJFDYngikr+6oxTVAzIJoHJ+g+EHcGR5xFN0HkUgSAEnYCnjjik24iTRjUSFRNAzHmKyKbRMqV/KmTtA38qFK+RND9xEdKBIJ5McUNRIJ60PCenpTaQ27CdISNt5pm4O5FZAmR/KmqSByI+tNCS2ABJkCKStXnHvTtYgCmQNzO/lTQnQZ2gDxUZ0iVAj1pqUzwSafpMeIVMtgoCCkbkRNIkfu01W53pwSAJB2Mge9U/UaTewCDAid+NqEKHXan6SAJ1T68GgJCoKd6Sdg0xCeoJpEJkSOdjQ3kzRQJSY23neh7BdA8PCj9qWogEDg0ggbAHjiiUAc1Lpg0+QRrMgcjekRpnxj0og6RsdzxQAidQ3PSmn2Ek3uIRpJMSDSVq5HEdKRQFegopEJ+aB50X6Fdho8WxJn1p2mEH9aUg88DcihJO/CaVtkPkRG/hA9QelIQQYFCZPG3nSjxb0WCdB2mAQduKQUo+EgCeaOk9OKIAA81UWUre5j5EUZkSSZolPrzwKXdmJ601JIVb7AkcCP50UmZEUFIgGKPhAAg77TT6rWwKNiAUZIgCgoEe9E+Hmj11K67VKdDpIQAHQn1oFEgkiiEiQJ2FFZOwSKVjSsb0oAf3qQ3lPBFEaum8UWLpADJIHFNmOJFPAV83kd6CgRwZ3p9SQdNbhnbbYU1QkbUSNW9HoU9aV0KmNBGwPTpSGqRIiaIJGxG3nSJgET7Dyp7vkaS7joIG6gTTUgpJmiVk7QJFDUODyaVjuuAbrJkE0Y0kgCgAoH0oEKnkVTruHG4YMA80hKdzQ23gzFHpQnvSJBCSZMD2pwEiKaIO1PE/KdqU7Q47sYYVuSfrSVBCRqG4pxAVwZFABW+3HFJj6bGERwZFCTxwKfI223nelpHvV9VIlxp0hkeERx60Y22G3pTtKjsRAoEKHHFHVYJMbsPCQaKQAZH2FIjYTSgHilJ7A6FE7CJHrzQKBzsBS3kJEcUtKo9KSdBe1CAAHzem1ApjcGT1owB70CYJkRtRyIAG0gxQ3kxzT0p0iD1oQJ2O9NOiqAODIFBIPUD70Sknb9aQEjai7CqN8aSYSdqIAHI2pulQAISB/KngFOwVtWb3NrGEEc8UogbfpRISowQKUFJ0hJ38qGIcCIiOaKeAD5UgNio7x50NJEwdzSFsIrUnadqcSAQTvTDrgeLrvtTyTMdI3oGxKB3Mj2phSI1BUH22oyonbigVSNI4nn1o37AKFddz5xRSuASRvRPiO1MVE87CgBx1A7metORCEg9ZpnJ4H3oqSoEKB24oAcN0HaCZopAMTWMrUk+I/pMUtZ+YHYcUCaHqJO8yKxqUkTtWrfYpY4ZZu4hfXbbFqyJW6tQCU+5/lXnbtQ/Ec6+XMHyOtTbEFC747OL89A/dHrzWGbUQwK5Gc5xxq5HUO0jtly5kNpyzQ4i9xRKfDbIWIQf88jj25rytnPtCzHnXEDe4zeLWEklpobIbHkB0quXmIPXby7l99by3DKlrVqJPmZrW1ymZ3rw82qyah77L0PMy6iWTbhGZ1xR61iK/vTS5Ph8qx6xM9Bya5zkHLcjrxWMrkwNydopJaduni1btlSyPtUshNphTaHQQ9d9SflQf51L2KSQLfCu7R32JrLST4g0D4j70r3EAsJt7dsNoSNkp2H19a07q6uLhZW46VEmaxNkJTqWTPrSJk9zKpakqK1GZ6UC+FeED61iKgqQTsabKUmBTJHiE8nc80CUDYU0nXOowOlNJjwjeaAHbaZrGVHnpQJKYSKxKcnwokq8opDpsCnFRKRHr51sW1i89u/CWzvHU1ltrXuk67pOpY4T5Vsd7tqPsN4oG9gtoQjwto0j15oBaBJO5/hWMuGQsnYbQDWDvQklJJ86YKNmcvEJANMWo86vpWHviDEECmadZ2JnzNAKJkUR8wVJoKURvz5UxSdIMgTNILITBIANBVBKhMkb01ZJIVGwpslIhJmgVqSiCk70hhBQZIG/MUCokghG5MCKxpDjyg01uo8+gqUs7Nm0/NVLix0PAoKcukFnYgHvbpJA6JB/jW6pxIBSmBHA8qxuvBSjpKgB0IrXLqZle46iaZk5NmTWskiSk9YrEqSorDkkdaBuCY0KAj90msKnEklK0wqJ24oJMhWCoFW+9Y1Ed4VqGoKJopKiSYB9KxhCyrWhyN9xQBk4SDvHEUdKuUhIpoISQoKmeZ86IckyBv6UAFRBgaRI5pux9R5UAha5Kdx08zTtJCSk+EjofOgaVjEhDZJmB5U492dJjxKNYiQmQqTtQSR3gUFffoaB9IdSleDVRR/aKEb+dJKAFFagZ8qTalFJITxzSsqMWjIFJgmODEU9AEgdDWABSzKB9POspUtGkFO9AnuZQ0pCQvVPnvTkuHZJO3vWA6tIUFmDSVrSkKgGevWgnclLTE73C3Bd2Vy7bvjYLbUUn71dsF7ZMy4foYvWmL5tJ3WvwOEf6Q2+4rmoLqh6nbczTkuKBGoAeprWGWeN3FnVjzTxqos9JYB2w5axJSGn7pVm6QfDcQB9FcV0CxzBbuoQ406FJUNlAgg/WvGfeQuQtJSBMRxUvg2cMfy+7qwzFH20q5RJUj7ExXdi8RlHaaOvH4gm6kj2db4uFkAnbpUmxiQJBSskzEeleYMD7cnmloYxmyDg4LzCjJ/7p/xrp2W+0TB8cCRY3yFqJjQoaVz7E16GLVY8nDOyOSGX8rOvtXo3lW1Z2rgLHOxqj2mOpUSC7tx7VLWuKJIHjBg+ddKkmXRa+8agcTFEFM771Bs34VBAB+tbqLzUNj6VQmiQJOoEewpERuI9f8a12blBIncxFZgtJkE07YmtjIIGyt6ESdjtSGwnkjrTp8OpWxFFsBSNogRzSESDPrQ20jbeKW4AgbikATrjbrRSTv5mINLcietN1QJFADhMmQAPQ0FgRsncDelpkHkb0VK+x6UANECNQ6UoHzagI9KQO2wB85oQRIER5UWAiNYgnaloEbU8mRAX+lNOvTJ8+lAWKEADbrzQAiCkwRR1CNvtSG41SBQA0/L4jNOgTIO0UOCU6wPpSBVt1n0oAMiKBGxMgUTI8tzSUo6QY9KaAaAOQmJpwCp2P6UBIETSkknnmhgxpSZIPBImkAQITsT04oqJmE0dMgx0G3nTshq2DSQBHX9KRTIlRHMUV8Qk7ikQeFA8TSspRpDYB6SBtNHxTsqSKKQSI8qKNMSaLGCTA3J9KWiQTO9GSBO29IREGKQDSnwgHqaUJAiRSKAd99t6YARton1qkybHgAiD9hxQ0jVp5HNN16vnUNvKnJKt44ilwgTTESCDHTamJSlQlWqnhIJkHcedJQ+3Wmn2CST5AlIIjk9aAgbAUUkEq/hHNIcxtE0wdPYW8z/wKUj3BokHg8UiIlMc70rDpGCSqZ2FFJ1KjpRKdxHA8qbpUSNPnT5Jqh0JHHNFZ1dYPnTDrG21EhUSrcUA3aAUydI6UUQeRwKIUBtG/WhqJghIJG1JtspJJhmOkTQVp2Cldd6cI50wZ396ElR3Koppg7GQkmU7UQkr3Jp2jSmR0patpBG9LqGhsDg8eVGVdKIiJkEdacEgjwGgSTQ2D1BmiQZnhP60iT0USmkJ5PHlSsqxqgBwSaCU+g9+tPUkDc00nYj7U7vYGxLPQ7CglOo87+dNKlHcgVkkEcGPSjjYSpjSjxBU8c0dECepoqEzB3iKBIBG8R5U92HShBJnekrSQSRvQJ3gGJ86KwQI/WiqCgEAaQOopivm08Rv9ayCAEkfemKOowRvzTTsKEmUkj7UY1bGlseaXAhI36UwSAAmZjiks6jCelO1KkAxvzTDOxjY0XQpNcCkD5enBpxVtvz1rGEqMCRtWQolRCuvAodEq2NSR7U6AoxSCYVAjbY0YSSCdqUnsWr7hIIJ08gxTS35jnrRkGR57maSTuQB085rOxgAjalOnekZQeNzSIMD1NUhKKsUeKRp5pRMgqoaFRMD706CkeR9RSdLgY1QSRJG4pQQZBor3NJJCjHHvTXqA0r8RUFU1IiY5FZNCCYMUdKTwAAKFJIOTHBUI6+VPSmOdqBAHAHuaIgbmIov0JUa5FGoSVTQAgkHy8qKVEqgmfSBS21HUYpWx0halCAqAn0oEgK24oaRHXmkQAPDQmJ32AR4djuDAopO+xikIgxz60iSOKpUw43YlDUTHMUlJEAx70UrjpBoSZmpfBXIh4gAOaCoKRKd/enoA3JUT7U1YBAIJB4FO6YtuWDYcid6eoAJNMkySUxtNKSBqJ2HFD33HdjjIlRPPSgrbgCD6cU4GUyRtSkDaYNSAyRMDYeUUlAKIESKSyOQqSOtET8oHPNACHlpFIGPrThqKdQigNwCaYcjFGdulNKvKsihJ3ielDQBsYmmQ07sBj/1poTqM9adsInmN6ICRuIpWU0mJISDBE0iDxE0tQnej4RCt6NwVcGOCDtxRI86cskiUgQOg4ppUYCT9qodJAgcxNEzwVT6GiPl6UNKByd+tJtkqK5HBKEjiZppABhIMU+TGnaaZo0+LePekihKG0T1pKkkSARREmVfakCT81PkVICgIhKZppMAQevFOJMwIIHlSKR5RTuhJtjdQ/SgnSRJG9EhI2iOtGNttjRfcKt7jQEngb9TSSYHImiNzAj1FARq3AmOIigW1igkahSjrwadMcJpeHneaVj6UMlQgA+tHZXAijBPhI3HX0ppTHnTBoW0EGgtQB8/I0SFRJO3lQKRPAj0o2JfobxCaJTG+rnp0oKTIE7GN6IBKoO+1QpG4jGx2PTailRUPI0G0RsJ2+1E87ESftTtBQJ2VvyacJ06gfvQI0AgD0IppWBtEUVe4glB6n5hETQAJnz43NFKiZJ4HFOVpA8IFIeyBpBOxM0AAdgCd6PzbDmgTB+X02ppiFpEmQaRSkCCkx50W4gzqB96CpjeaL3ACNwSfp50Qspgk9N6aCQsnZU0xa0aVrKglKAVqUrZKQOST0FKT7gZFq1TuTO81Ts/9puWezvDzc4tcl250y1ZtqHeL/8ApHqa5z2o/iOw7BW14PkpxN1eSUOXxEttf6A/e9+K8yYzjmJ4zduX+I3j1w8+rUtbiyon6mvM1GuUfZx8+py59VHH7Md2XLtE7Y8yZ+uFG4uFW2Hg/lWjRhCfU9SfU1RPiIOoHciCT1rApUiDzTVqmCBXkyk5u5cnmTnLI7kzOpQO4G1NLnpFYQsxBpQpRCUBSlKMADzqSFvsOLhkmdq2raxXdJD7jndsf3zvq9AKytWbGHNhzFUFTqt0sJ6f6RrWurt25OrQEJ6JSIAHlFJgbbt+0yjuLJvQ3wVclXua0lALlRUTHrzTNQABX5Ute4UBsal7mRkKhPNIlJnfaODWEqVqgCkZiVCDTAybTIiKClwdgD70wExAFNKlIMkUAOWs0xTkiSduppqnNjWe2s9bffXBKGp+ppFRVmBltdy5DB+Xcq8hUkw2zaiAQpw/v+tMLjSQlDSNCOvrWNxSEdfmo5LM42lRVJ9axakpSVLPWsJec4A2pqlKUAIkE0IypthW/wCQ2NN7wiSeT0pigSJA2pIKZJKuBz60zVIyK2AO/wBaYSobj7in+LTp5mmalBJA4oKSQiVK2J4piiRsRtR1aQSpQjyNYlvTBJmOKVjaRkKogpj609m0urw/lakpHKuk061snX095cDQ0flSeT61IhaW0AITCBwBSb2CU0gsssWqToQQ7EKWetMWpSgVwSP0oKc77wgKJHNYlupBLekQoeITv70o7nO23yElSt3en6U0oUtJU2rasa1yk6FGQeDQCglJKhztFUNK2MSkpVH14p6S2SdUkjrQmEEpED0po+Q6NSieYI2pmlBSogqMkCen8KekO6vnTJ86ahtZ8KZKvIDcGipB0FSZMRqHWgnpGJVpJQUknqKyIUUgq0wnzpiAVHvAnUOTFJRkElW1A+lGUKKk6inaBFYVFXiOuQTurpWREpEAAnrPNNchAT3cEkbg0AlQEAHxlBkCN6RI3JSJA3FNJAT4dUeZpJAUCTyRBVSboL3oyLCoBUoA9KfarQ24lTrRcQhYKkSU6hO4kb/aumdkuUOyi9sn8wdp+bmWLdmW7fDGXFpecdPylZCTpR5mtnOvZRl25OGvdlmKOY9c3qj3+FML+IXb+Si4AlOj33rzp6/EpvE7XvO+Hh+aUFlhT91l7GE/hjxPAsOcurjBMLedY03nd39yLhhRGykgpIJ5kGqhjn4dbuwfeas814e45eAO5fs1K03OKNETKUn5SB589KpzWF5p7IM1WV7mrJjDjrSS4xaYm3rYWei/CYVB3j0q1Wfa9g1i252gYil/Gu0O4cULZb7cWeFtp2QptHBMcDgRXnPFqsL6tNPqi/13+x6Ecum1MK1EFGS/TY5/mXI+a8nO27WaMCvMPXcoDqA60oApPmYgH0qEdPdnYk+k8V6WyD2kZfas1XOfO1uwx3A79Jdv8Ex3D3Ll9DxmS2YISJ3EdKi839lXZozghzHi16cA/a7if2EvDtbzN8lXX4ZQ7xsDrvW+Lxby5eXqY0/WtjKfhPmR8zTvb0b3PPQKtQUfpRiVhBM/wro+auwDtGy1hCMyMYSvEsFWnUL61SohI81oIC0/UVzdB0LieNjv1r1cOpxZ49WOVnmZcE8DrIqHJSlJ3Jg9aSlLbOytuhrG4txRBOn3BpGSI5FbmdJcGdLyRAJIngDzrYt7hxh5LzbjiVI+RWrcH3rQMp0K1cGY604EzKhzSDcvWD9qGa8HHdm6F22n9y48R+h5FdDy/wBuOEXRS1ibTlkuBqWVBSJ+m4+1cEDulSRyB186eH0pXJiT0PMV0Y9Vlx8M3hqsmLjdHsPB84WGIMpfsr1p5BEy2udv5VYbXGQRGr1rxRh+M4phDwfwy6ct1jhbaoJ9+hq+Ze7asew4oaxhKLxgbFaQUOD+Vehi8Ri9pqjuhrcb2nsz1hbYprG6o3PWpBq+QVSFEk+lcPwDtgy1iTqGRiJt3VkhKH/DPseDV9tMdSsA97II5kV3xzRmri7OlNTVx4L63dgAAnmtgPBQ9RufKKqNtiwI2WD71LW+JJUkDVNbJjaJsmQNJmKcklQkKO3nUcxe/wB6AT16VspuUkQVT7UyKNoK235pQQQUwDWJLuoaY36DzoeI7FQ3oGkZQonqIJpbhXIimfKeN4k05JKt9O3pQDQ6SZJ4FI8eEDegT01QI4NNUFEJ0qTuaBUP3I/MG4oACIKj500q2kcikNQGw+tA0rHRPPSlAmOk0AV8aSacr20igVDCN5MGfKnCdgkxHnTNRCiE8HrRg9VJoHQ9I0xqMxQOxIn1HvQB6CCenlTSkhJKvvQFB36HajBO1GOI/wB9KYBIoE0NKD/epbxt0/ePFAlPM04mUjQOu3rT5BIW8EgUIUSnUT5mnAkJjkmh13PFIBBU+JNJO+1EwkSeP4U3V4Z8t6dAIp2kE0QduPvSSSvcfQUTq4KaQ2KRskmN6AEbTvQ678jgUACTqVQIRTCfDEHzopEDcbedN1aDGmaekoUIB43iiwqhFSR0oJgq0md6MjhSTHIpcK4jagAaRpkDc9aQTv4RNIEiBM7dOKUQPCNqLCgmTPI/hTZCQFTI+WnJMx6UiEhUz9KAGo3QABSKVE7QB69afwPIdKBVPh6GmmJqwBA8oM01Z3MfrTtwNjwYpriSN5FC5DjgCPPk0ZEQTFOCROxoGBtB352mKbdvYBCBSnzET5UQQqTMjptQlW5O5SNhUgBGmYI5FM7syoAGKyeEmAdxR2B1HjigdjdMJkpgAUFBUxJg08QCUkyKCgogmmhO2BEaiDxRkg8bUgkpHiG1KJgA9OKGAQdtx9abpTJKlDTREcE7+VIkCUkbRIpBVgAgmdvfmgCBKUkk0o2P8xSIE9PpVIXHA0EJHJJnfekojkiB508BI/dJ9BzTYIJPSODTug9oGncTJVTzBEHgb0YCekGmpE7Hg7TUt2UNKTIAG1HTHH721EqjbgbAUkmYIMwaL2C0HSIB4NAbEqj60tz4ZCp3ijMieY8qQDSZM9abuRpAMU+RsCoQd6R1JPg3UdgKpNiqxkRsdvWKPh/dUVe4pxUpWxCfpQTuPSaE0Fdho1zIPHnTkEHpS31bDYUxS0hxKCUhawSkTuY5obtjjGgwfnAJnpROkqA46+tOCgd/tFAiSSCPc80kCEowOnO3nSkGByRTSlSoKiNuopJJSZiih0OgTI2I6GkZO8/ekndBV5GgOJ/nSEIQN96RgiBtRSRB1Sd/KlsDsdqYUDaBHlJpbAlIkigYJJBpyUqJ8IPrR2CgbBQEEjpQIjZXWnSdXEdKafmgbRuSaQBCY8SuvNJUTqAFL368U4JAHi2oEN8IIKgQYpcyqPvSMnZO4oz069aBjfCDGrfrRMbgdKAKZhWx8qRlUqT50WFCP3O1KBMFQHpRheqSIHnTVatU/enyNIQVEqjaf0pBWo9BR3A4hPnTRGqeRQrY9gxwQmDNE7yDG9OnUJA43psA8jmkSLng7UAD+8aBIO3HvTgP7yoNACASSJ4FNg7gEzPPpRUNoIO9IbmE88b8UAAJI/eMCkQnSkEnajpCiRPi6xQV78UwQBzEH0p0wDImevlTNSwd9hTyJE8gUMbBImSBI9KQUJgJn6UAmTBBjzHFOSUpk9afBO41QIVvwfKgDJgz6U4mdjvQXufCYPl50Jh0pg3KQDyTTTqnj2p6I/zt+OIozBiiwcAbkx0paZJ86QkbDigSOQd+kUmwSoJggjj35oAQIpbaSdvc0JkbT7+dJDHGdMCBzTUSNz9DRlOiVc8Uk8bn61ZK5sMiDEH2ps7+hojxDfb2pihHKth96nkbdDvD133oqkbjisaSCTHFPSomNRn2ptD7AUnqOOlGD1A9RRJhR8qG5IB5maVipCkD09BQPiMgUVAAyTRTO5AmkOhsSAZMzvRMb7g0DCdlbUZTHO5osAHy6UIPpFEbmCaUQoGDTQuTbJIO3CRRSo9RtSAIgigAQTuSDUuqLHSgp8Q25ppAURvT4EAnjrTSAZBTA6GhNIqxAA6oPWmkyNkdayaUq4NKExvIp2iTHtwU705IA8R44oykbD70fPcR0o6rAaNMAUQnkDqaJEEE7mKElRkKipdgIQDIppISQZEnakCpag0JUszArknap2/YFkpl7C8vKaxTGh4Qfmt7c+ZI+dQ8ht61llzQwK5MUpKC6pOkX3OOdsu5Hws4jmLEG7dtQ/KZTBdePQIT/PivKnan28Y/ndbmG4epeHYRMJt0LOp0ebh6n04qg5rzlj+b8UexXH79y5uHjMkmEj+6kcAelQRkkmfvXi59VPNtwjzc+rlPaGyMi3dU6zMmsU7+FRA8qYo0FK0jVXKcSVGRRERMViUvTsNz50C6SDPA5JFSFhhPeNpu8Qlq3J2BVCl+3l70rGtzXs7K7xBwJt0DSPmWrZKR6nipFDtnhqYsyXLjhTp4+grHeYmCg2tq0GWAdkDr7nrWgtZUdSiZ60rsHsth7zynnFKWpRUTvvTIVxNDX4oHFHUZ3FBMVXIt+qhyOlJZ8U6z9KClCeabI5G9Bmx2o9OKbO5mgpQG9Y1ugHYEnrSBb8DyoJ3BpmpTioQCpR4Ap1taO3SiRAaG6lGt5KmrVEWqNJ/eUeTTNYr1GNWotgFvgLXEaZ2Sf50S4tQ+YSDvArHAJJUsmTMGkogJUkAb8EUkN+4yKdSEyUyR5msKlqUQkwJ8ulMWqCNRHrTIM7GZMCgRn3mFHagdH7v6Gm6glJ3BA896KQlXyqBn92KTKSGqJKZA6+dYySQSoatqcpe8qSUkbQeBTFFWmUwRTsKoPeAnw7LPlWNS3AqCTFNcOkagSodI60+2t3L1UIGiBOoq486LFQwqW4pIbbKiT4YqStcPbZh24AWoGYI2Hv51ktGGrUAoBLg+ZXmKe6/rMtgAE9N6m9yZSb4Mjy4MpKTHWKwLlXJ2Jj3pykjuQdI2rXdWA0SDpI6jiqtMhJvky97pUUBEBXNay+8dCoB0xB+lNSVuNqIWDJ2NEA6O6Q5pB6zyaEqNEqHtpUQpSVE+dHvAGymFEHkHcfem6ihru24KSnxeLeaTDriUqbQPCoeI/wCFFAELlGrWP5U8K7tggITvyrmsRLAaKEoWCTA8vqKeESmEqCkkbx0NMAp1Ng76T1Ipq0akwleo8msjioaATuZkmNhTULU5KTAHBPFTQnfYI7zRMJKf80U1GgnStZHv0pGUpKgI22I3kUVgKaC1xsZMDpS45Ye16DCpTcqBJA2g/wARRVBb7tUajuCaLoSsAhYSOm/NNIEeMGdtyCafUg9r0A4kpAHegx6UVOAQnf1PnRW2EzocKk9PDM1jmUhSxI9qadie3I4d0tYQCYIiFVd8O7X+0fAcNTgWH5ldRhhBSu00pLTjZ5QoACRFUYJB0uFWgRETvPvTypEpGk+W5kH/AArHLhhmVTVm2PLkxS6oNo6/jfaHhHanjeW7fELKxwywy/YtWreGXNwW7e7WDK/zQIbB2iamu17LfZlbnD7PJuE4K2rFW0925h+Ma/2c7sCLn5klEnZUiuDLI+Up2PSZEVJ4DmnGsq3wvsHuksaxpcbKQpt1I/dWkiFD0NedLw542ngk0l2PQj4gslrURTvuXrMfYxnLs2vPj76+y++/ZIReNhNwCXE8gpSsAOD0E1t5N7XL5GdsRzDnHFrm2xHELcMW+KItQ6vDQTupplUAApgbcRT7D8QBxy4wy07Tss2eN4Ngsu2NlZMt20Pfu6zBJQPIRV3w3tTyf23X68l4p2fMMYnjgFvZ3Lly03bWCuEqRDYXAHTVvXHmebpa1MLruvQ7cXkdSelyV7n3Oa5t7RMVts5ou8I7S8ezHhaVoWt+8U4x3gnxIU2Fcfxrqlzj/wCGHMCrFF43YsuPMhFy3Z4VcIfLyuFIUFGTJGxmapOJdgWEtZ3V2aZfz07eZjaGlTdzha2rdxwD5Ur1Hb1Iiqhgxzp2TZqxG9ay2xc32Dlds6u4tPiGbd3++IEAjoZqnDTaiC/Dyakl8PmDyajTy/54qUX+qRd8xfh3ssKxJ7KmH5uTeZsvFl3B8JKNJdtQJJeV/wBW7HCKjrX8MnaM8vELR5ltF/bWibhhlvxpulnlpLnyhaeomajsN7WrTAcGev8AC2H3874stYxDHr0hxVu2raGByCQdzz0rveQrpzL9pgmC5Jzrh9rgF22m+xnH7jE2XLtdwoSpKWXDKEg8jk1z5dV4hpY7v6f3Rti0+h1U20vqeU8dyNm3LzxtcZyxili+iQpL1osfWYiKhlIdbhtxBQodFJg16F7c+3B25YxLIeH5gax1tNwi5t8asSWCk7gtKTJBHqkgb8V58u7l68fVcPvOPuqIJWtUmva0OozZ4dWWNHi63TYcE+nFK6MUnUNSIjzonxKGgA+pEVjLyjIWkT600OakGAQfSvQOIzkqAgqHtT0rQkCBMbxFYNCwlK1/JHPWkHipWkKgUD2NgPHUZJjmORNTmCZ1zJgKkDDsUeQif7NStSPtxVbMqQnQY2mnB0ghCePSiLcXcRxlKDuDO2Ze7fFNlFtjmHqE7F1hX66T/Ca6jgHaNl/G0AYdijK3CdkFWlYP+j1ryCHB3gJG9ZWnVoX3rbhQpO4Uk7/eu3Hr8sPzbnZj1s1+fc9zWuNzuFAedStviLagIIE87142wDtSzdgQSgXgu2kxCbgayPQHmun5d7eMCuUobxZtdg4dir525855Feji1+OfOx2Q1OLJw6PRLV+naFAnitlu7UT83rXO8HzdYYkyl+wvGn2zwptQNT1vjSFfv7+c7RXWsilwdCRb23+moe9ZApMbmZMcVXWcRQUylw/UVIN3nTX71doVEkNR42+u1PJCen8K0k3CDKUxJ6k1sJUCOdhVXYMzEkfLRkEb8+o2rEUqHWnCSPERFLZ7gEbwBEk9BRUTtB9qAg7TsDtFJKtJ23g0CFoGn5oHn500Jj94b/eiVxEcUdQ4PJphuAtifWm6Z5pBZA+YisifF0kdTRwPgaAtJOk80dSgImkrdMimpA3M9PKafIcgIV0G9PTuD59KakArlUR58U4mdhuPKhuhBSTA1CQd6WoHYCYpqSqfGRA8qcgQo+tSCAlUmIoFUCBxzR0+GQYNMQJ3Jp7AOaKwqVI6cmnKIVzvvNIlUExt5zS2Cdp96QmI/MSBFNcUSRwB69aRVtIUfWl8wg9POqWwJCHiTH2mnCUiBtPSmwY25pFR2E1I2EpVEz9KQGkkn5RvFE6inSPuKQHAI6UE8DNQQSJUd6QWQZVufOgSrXB3p8pJCdqplClXUAjpSMyCaJATyaauSQB96kXLCRwDvFIjpSHhVuRtt9KWpJJCCDTaE0LjYb0CoDw8nzopketCASKEJq+BJIG5k+lO2PkAaWmEwelN4jyPmKQIU8hMEg0VKI5EUinggbnYEU2dXzGnsMWvVsDsOoojfYz9aRBAkGZ86CVEiTRQ6CrYatBBNCIAUetOCuiifahIPzzvtx0pCoaCmAKcqdo+XoKASJgR6UYnkcUACREgmTttSUlYI8UigVkGAKdOpIJIBp8D4DunY0krMx50xKifFyPWjIMeE9eKQVYVK2imqiPETBoKSkiZiDxS1f3qdJhQUqUD4dopKkbo3J5pAwmdZoalHgqp0OhKIPhIAPX1FFQAHO3G9MISAZUok9DTgnYwRuKKFSEZIkHfz86QSVcmZoLUQIjb0ogxETSoKDBVBjc+sUIJMgx70QsJnkAcGgk6zwSPKKKDdBG43gxxTVpChvI86dI2AmgRqSpQ8+DQmCGJAHgCpitN8FWM2i+9gdw6nQeOU71uKXvGyTUZfd4Maw1aEIUlTbyXFTuN0R9KYVvZLHTEg0hxHTypqlxsBRG24MTQ9woOx6cUCkKBGmkNMyYn0ppXqgzMUkCQW9YJTO1PE+c0wyCTqOmhqChpCqdDaHEEq9xS0ICTI2NIGAAnpTCSpQjf0oElQYAMHinapSdo6TTTqHI3p4SDSYm9xoIV4QPrRkgGTxR07cb9PagBJijgAQokkqgUthxsKXKuRHlR7sqGoETNDHVgBkc07pvEUwIkyqZ6inaUxBTt086VhQCABMx5mkUiT4iTNDzgiB50NSjCt/pTfuBcDzJFY43MbyOKyGZmR701W6tjNJWtxth2Sgat4pbBMD6Uj8spABJ60CCII86NwCkyNPJoqMdYHlS1HeImm/MfOaKEwlQO0mPKgNlEmImRNLnwxvPTyowY3iJoYJbAV4jKTvyTTZnY7g+lOJggRBNL5YPSqSHQEzEjTFIjbY80QEwedqUiIg/ap7iqhidjMwacVEyRzSVuY2gUyY2G5mKrkf5hxk7Ac8UlBYkfunpTAszsDHnWQTyaOB9NBWdO3SgST6g0ikn1NCFDy2pck0FERKt5obEyREcedE7EjaPegBO5pCEZA5j6U1OoDcinhR32GwpokmI2600h0IlExGmOo4NHwkTp460lBM8iluoSY28qGqChp4gGOtEoMcUiYiIJ5okny2NFgweFQABAgUAdtx+lICCPaDSg6p6UgSCAByNjQhQJAMbTQIgnfeaRUVKjzEbU6Cg7THSh+9tNGNIIFDcbgkH3pAkEwZCgKEeQ2oKKjvufOnApj1HFAUIQTBMgUCeRO1LYD160PDx1piaCT4OJpvJ+WnE7QBSG0kkSad0NG6FH5Qn6daSJVtED15oQTJG8daclM8CfWsrsYIJ1Anwnako7QofalPMbmkD1IkedACT5j6UTChqPtQIhRBO360imN42FA6BwPpR207AbU2BuYBB5pSokNtJKiowI3JPtTQhLWQN9vao/G8bwzLeFuYxj1+3YWTUhTzn7x8kp5UfQfeqd2n9s2WOzdt/DzpxTHgnwWCFeBr1dUJ4/ujevImeO0rNOfcSXiWY8QLp2S2wmUstD+6hA2H8TXBqdfGHs492ZZs8cC33fp9zqPan+JHEswtvYFk9lzC8LVqbW6o/1i4HHjIOwP90fWa4W++p4ytRJA8+KxFzUrUpX2phLZNeNKcskuqR5eXJLK7kLXJk0SqetNIJ6wOnrWNWudPTzpGdNjiU7kk0ENuXCw0yyXFK4A/42rZsMMub4hQ/LY3K3TwB/M1tKvLXDmizhw+b5nD8yv8Kmw6e7CxaW2FkKvkpuHwJSiZSn1PnWtdX7946pTqweiR5DyrXU6p5QUoiKG/086XJEm3sgxGx3pAGJpoWZiaJIJ1E8UAuBaSU7g7c02QNgNzTgUp3ANMWpPzJO1MBLOnkiglzaT+lNB178jzpBDilBttMqPQb0ieiwLd1CYPoPOs7NkVaXbgEJO+mszLTdoUnWlboEwDIT7edPcdW8e8I3O5BFSNJLgClmO7RCW076RTdwkgjc0TpVulcwZkUwkk6VCCrgnrTsYlKTrMfrWLUQCSZnYRT3CTuFDUdopqnY0wYAH73mKGyqrkQTAIKZJ6nzpAKKIkwDIFMfcSsEbp6jz9aYXEjSSFR50hpoJKkr8R6bCkFSshbiQEjfegEFTmlJUTuJKdzFNLiyrSiARsCpNAn7gBxC/DKiOvoPKmBZ1Hu0HSB1NNPebyEkHaU+dSFvYpRDjwSpREBJO/8AvoK7GKztVXEd6ClkHUOhqRSG2gpDQAB6fzoFSe6AkJ07elYUpW4Cdcp8xSdMzse88oNFGpW5j8s8UxtSw34pWePSKJXpSEa1J321CZrEogNq0r36pO1V0oXSh6lK0lIBIGxKDIrE5oUjShatUyQTtS71WmVJUd4kHYintBtSJUCFSYHNCVDqjEQsCEJn2FOAWWVrMFKYAJ3hVHu/DobWokedBpWlKxz4ST/x51QB0ICdWoajTiohIQFBIrGNSEkEykcEjmgklY1KgBO5k8VLkgM6kJ7oOpgkbkDyo9y8VITb6nCr9xAmfaKlsrZZxDMj7jYcRbYdbJDl5fPkhq3bPUnz8h1NTdxm7CcvBdh2c2Bt0oSpp7FrgBdzcg7SgEfkj23rCeZp9Md3/nJ0Y8HVHzMjqP1f6GsOz7FbKzF7mW+w/L7awFtpvnIddSeqW0gqP2FbuF4Hki6aNth9vmTMGJEnwWbKWGYHTcKWR9qv+GZK7OMJy1dYtmnMmH5ovX8ON4vuMSAuLNXBSkFX5qhM6TE1qWGfxk7KtvYdnr2EYqp5Wm1uW9VtijK3P7zIkrPsYrzpanJkuMefkj046LHjqUqr/wDJlbyfZ3eO425lfLXZdglxdJkufH3Li1NAdVErSkfarw/2R5zfTdN3GE5HwtbNoblllDHfOXKUzrDaQoqJTG+1Uy/sszrfGI45ZYBgWI6VfFvX7yUrugY3NumSFdZEE1L2PaRZYAwbmy7Qrg3zQKELs8vtkidikOvK1RWObzptdH92aY44YL/k/svobmVex7NWb7D9r4TfZQFuCnQbiw0d5PGjwe81IY32X5lyxhT2J5gwrIQsba5Fqu4dbcRDp4SrRwK55l/tBs8s3Dz+EYtmlr4g6lIQ4wGlEmZ0EFIM9QJqUcxPGs9YXespbzxiFre3SLq5WGW7hJeTIBBAGnY8A1M4aiErlJV8P5NFPTSikovq+P8ABs4/2dYmzjDmGnIODXT1uhNwtOCYooKDawCFwtRgQeoqv4zlPK1nbrTcW2asGvAqJu7VFwz9VIg1ZcwtvZZxXCsxYrmvFMHxO7w5DduLzB/C9bpGgIWEqII5BkVZ7ftWulYRh+G2uAYDcMW7cpasMQQwbk9NSXEBY332Jqo5s0KrdP0CWDBJ09vir+xx45DXfsJdy9mHCsUuFHe0S6Wn/fu1xP0NQ2K4BiuCXPweKYVdWbg3IdbKZmvRmR8lZOzFiiGc7m2ZvLlg3Fv8Xa/CPNXIOzKEAQ+ON53q4Y/lPJ72LnJmD5gCMVXZl/E0/D97YYe3vK3dUobV5p2I86mXjPlT6JIS8FWSPWnR400kOQkpneQf+N6Oj8xJJ2Bk1fb+1yKnF14HjrP7JdtXFpRimGK7+1uRwlfdTsk8ylVQeL5IxzD2F4nYpTiuFt+I39me8bSDxrA3QfRVexDUKSt7HjZNLOEqu/gVspUlalEgDpRbdeSoOsLU24ghSFoJBSR1FOKR3kzyOKxjvFrBSCFcCBzW9KSo5/y7ovmHdtfanYAGzzrfoWlAbDh0qc0j93WRqA+tddyJ+IzL1+pvJ+ZcPGW8vG3U8/dWa1Lurm9G8uL3lKjsQRXmklSUFsg6ieI600L3gRqGxI3iuDU+HYNQvaVP3Hdp/EtRp3tK17z0LlvJeVO2C6xvtEzPl7DcnZSsEKQp+xue7V3qZIUltUhS1ECeB5VxbNdnlmwvtOVccfxKzeOtCri27lxPlqG4P0qHF3dIsnLJL7ptlEEoDhCJHEp4mtcOK7sFIQSdySaeDSTwyblJtdl7viLUauOeO0fa7syAkEHTAjk0A4pKkuAcGCTvFYi4VLSVEHpAonUSNUp8k16NnCPcU2tUgnWfm3p+juyEg7HcGaxBCk+KCCSR0rI4gmAVpBjYRFACV4TPeR5zQ2jUD9qYltSSAAASfEVU/UEHQ6NJNADkq0JISQZ6+VITsQPc0xKBGrUD6nakQ8IASYPJNAGRI8adUaByetZUlsIUkEGT4STvWLWpCdMbU3YqiDJoKszJdMFClU4uIUnSCCfUViSiTCN1U5AWFaVJieaCSSwzGsTwh5L+G3z1usCJaUU10fLHbTjdq6hGNoTeMbBSwCl0dOmx+1cvQApIlYAGxq15Wyyy5bDMOPvu2mFJJDKuDcup/cRP6ngVrinkjKoM6NNLN1qONnpTDMyIeabc7w6Fp1AyeqRU/Z4yl0HxzwdyfKuEYXmZB0AKTCRAiPKrjhOYdYSiZETP09q96M3VnvuGx2C0xAKA8USdqlGblLidIPWD61znD8VCkogjfz9qtVhfatO+4G1bcmbWxZ2lAiO8k+u9ZUqiSTHrUbb3BkdJ356VujSpMpMmrSFRlPiOx5HNOCQUkQJA3imCQqI2p5UfKBxTuhUxoQR4lCQOIppgqiANqywQNtx60CklIgb0XYGPQoniRTjKfF3e/QmkUnlRO3QUAdQIBmmgATIgbelKJEAkD0pyEhR43iiEpTsaLENSgREmnBIA2O5ojT58U1StwkHalbHQATtMA87neidIOqSD09qUHkpM+ZFEtyYUenlQthAG6ZQOfOjpkaidogxTiG0iQd/Olq3kj6CgBugJME/8feiZmAdqbwZCRFJRJEeXB86OQEQZgnakNzvxEUyT+8afGwoewAUYIIIOodKBkCYk07ZB3V6g+lDYwAORvTtALvDIAEbUdSgJG8maYCkKO0QKdPWDvTAKjpMgTP3pxhR25j7Uwq+s9aKdx6nakwaEQYEmR1NLVAO8j0oEjf8AhQEK2VyaFuFBJQR1poEHwiI596SSeDJPG3nRBiUk7iqAM6udqcUgwUo49aYBvJMxRJSkiDualoTVcBSSfnJp2xASfpQgRAUmfOlpJSDI46UhAhSZk87UjPQA+9JRG07QJPrTCfF5A8mnQ0h6lFQBSJG/FM0pEp1GPMedP2G4MeRoA6tlDc9RxT4BAkiSN586KYHOxpAAz77UiQrdSTt5VLYwtiJ/SkkzO/vNAK/u8UYJ4IIoCgQJ42pABJ4mkogI0nampOwHJJovcAfvkmKekmBG0igUAKMbfWiQAZnbrSbTHQ4AKBgcdYrGUyrYjanIPzFPA4FIgEE+fFCdBsNAgRpCp60oKUyOZp5gDjb+NMJnaduvoaqxcgWCVAiJ9aREKE8HypwTG4O3nTFGBBO1NNMKvYejg/vH9KapEGZ549ae2Tp3ME80xeowOk1K2YwaQRztO9OkAgGYFNgjaeN4pzaSZIQduTNUJhk7QR9aar5tlAj0pRppQAoFI+tCQPZAURIAUPUEVF3ykN5jwtBCj3lvdaY4Ed3z96k9JCjEb8k8/aou/Uj9v4ZqX40Nv6YSYIITIPlwKTkk6HW1kmVDlQM04xzvHlFFBBHi4onw7T9PShOwGlOpMpHXzphgL0xAPPpT4CfEevFMUAoEg71Q1uPCtStMbdaQDYMRBpoWR0FEgzqUqfQUmSPBAB8pphMek9RRGkcDnzFEo2BKTuYmpS6QBq333pEkGBTRBB9+aeAORvT94UNU5Bnc+3Sgk6lCVbngiipIny+tLRI1TBHMUXaKVLkUhO5G9JKiRsTzR+bYAiKMjpA2qXZIgdpJM01RUTo1CaU+LkgcU6FAbJkedGy3GhqgJPO5oEKCgCkhIFPCZJJTA9aJA6HeqbEMhR2B253pJ9qJIKt/40ZCd081DY9hs9OnrRUZI34pLSnYk7ngedN0+lOxPcSiDMAxSSozB3BogGNqOkdeaakNDVzqnj2oggHbbahpKlCRsfKjKUq08/xpWhDVCSCOlEbgzzRUR0MelJIHPSnYA5EDaKduR4f0pqhBAVvIpEA+EGFClyFAJJ6zQCNiQTsZ5pwSobTJpElO/Sm3Q0BaAnZNNTJAH0rJKVA6zvQ0gDnahSHuAa07AjnekNaiQRzTTsmQeeaAMLBJECnQmOBCt5E+1Eq3IgHbqKWg9RQiflotEpDd0wYAHpRmBBVq/wAKWj96NqbIBkRTu+BvcJGoQdj6UYUEyOlLccjanAiCCCfalYDQNwfOiNW08TFGNKZSD5703Wr98bUMTEo86aCCrqdztToJkdKWkpUE8ikMBHi3JpFMbHfyolSgqAPCOTQkpMcg0AJXpv500wdt5mKREKJO1LUSrZMjmgBAbkHgUgkCQOPKkADqnkjigQN43NVyA4p2kHc0NJPKSDQQCYHAinGRsDPlRwAEyDE0dJIO424pad4nfrTXABAJikt2CJDlUH6U3YHcmfMUTsQUmRS8UmY4rNFsIPnx6UPEDH1FIR0Me9MKiCROwE0ybMh0zClEmmLKQfFMc0lqOyQP+OKqnaJ2pZQ7LLXXmN74nEVoKrfC2F/mkxsXD/1afff0rPJkjiVyKvayy3lzbWFm7ieI31vY2LI/OuH1aW0+56n0G9ec+1j8TpeTcYD2bl21tiFNvYooaX3ehDY/cT681yftJ7YM2dpV0F41dBmxbJ+Hsbc6bdkHyH7x9TvVGWdf7015GfWSy+ytkefm1l+zi+ZlvMRuL15T9y6tbrhKlLJJKiTJJJrWUo8zSUJ5UYppmN+K4Tz31N2wKUCP3Z9aASuJnYbVvYJhzeK4rbYe9ilthzL69C7u6numQf3lR7V0nNOQ+yNvLV1dZKz3c4hidg02t0OoCE3CiYWQCBoSOhkz5Vhk1Ecc1B3ubY9LPLFzVbHJ1OeMJSCSeB51I2uGIBS7iRKUKGzQgLV7+VPQ41hSZYCXbk7Fzon2rTfccdWXHVKWpXJ861b7GLnSs2L3E1uoTatoDbSRASjYD6VpQSJVTkRJOkijJKiDx5UGfWMCRqBFOkRHU07SmR0mrDkzs6zXn24fTl7DFus2bZdubhZ0NMpA5Uo/w5qJyjBdUnSLxqWV9MN2VnQAdUzSKSrefYVM5lyjjeUbti0xy17lVyyLi3UFSl1ozCh6bVDEFLmkmCBIpKcZq4u0OcJY3U1Q0gkSSIOwBPUUxWvTqAO532rqnY5iOQsNZul5qsMJxC6uXUstWlxYO3N2oHksgHuwonqoVhz3bZHtLcuO4Qi0xxxTjZsLSEMW7c+BxzTt3xGykiAIFc71dZfL6Wdq0N4fOU0cztkOv/KCEHlcxp9a3NSGT3Vs2AknxLV8x9axKdJAbSPCNoAoCEbqSSZia6lucPWEeFUkSRtTjISTJ9jxSC1FMpJ+opi951k7jikIekBTZAA+tY3FRpKtAAHIoKbOkBJBPPPSmuGdtAIG31oEErGnUvuyFdetJa0qASQmEjf1NYgpGokkiP3dO9ApUkJ1CJ8QHHNA7b2H6dStXIA3IO49qxzp21lKTvtQMtulEGNMgT/Otd91atJ6mfvQPpZkS8RuNomSTvSS3cXTiW221BR2mdgPM0rK0XcwpatATtJ2KqlmmQ2koaCgT60TlRTkkY7SwRaK0lJW6BGtXEelOWotJVCdRmIHUUUurae0qM6QSaCFIWo7KB5maaZDY4ILrBWQk7iP99NU+UJjYjiQYApJdW46GkL8J/u1jcJMtATuNzSEBQUpKgiFQRO8gVjSNlQ8ZA5jz8qytLbQ44kEQsRueT5UCytslBT8whJO9OwGJRoQAo7q2PrR7pYCgEmdx5RTm1KSSFOpAIjTHBppURB7xaZkEcgmkA9KkBHdJP5g3mI2oFYCdKNS3EifmkGabKAoKUoDYDyFEFKVwIJJ20n+dADW0uLSUQkEgK3/AIVt2Fm5iFzb4Ww3rubp1DSEadUKUoAb9Oa1eVeEJUTwZroXYRYWt92oYam8bQoW7b9wG1D5nENKKT9DWOeflwcjbBBZMkYPuzY7QHb3DFf8k2WQXbTCV6b1NujUq9vAPG4QN1AHgdIqhKwy8t2FOP2r7LQUW9brRA1j92TwfSpvLOesSyxmkZts7a3usRCy+ld0krSl2SdUdTXQ+1z8QKe1fCsOwu6ybhtu7asHvXNJSfiFRqdQUxAMcEGuWEsuJxjGNxfLOzJHDmuUp01skcyyhlN7NWJLtk3rNlZ2yC/eXjqSW7ZocrVHPkB1qWv852eCMHC+z5oWVu2QlWKlA+MuCP30r/6pJ/ujz5qRxUnLXZPg2ENL0XGaXl4ldOpO6mmzoQ3t+7MmufJanUHATqMDeQf8K0xx89uUuFx7yMj/AAsVCHL5ZkfffunHLl+4W++6rU464oqUr1JO5NMWAFIQklU7kgzNMTpBXMnu+fKkApYmB5b8Deul+wtjka6t+51bJ34a+1LPmVW82Zbw2yubJw6WAbpAWog7j0jmDXfexBPa5+H+8ayZnDJ9/ieCY06g29zh7nfpsnFbHVA2HnWx+Evsrz3gNvZ5mb7RGnMtXTa1u4O0ysEPkDZQX8pHMjmvVKUEJ0CPFv5b+tfCeMeK5JTlp3Uon2nhnhmOMY51alRQu07sjyv2i2D7+JYPYXOL/COWljc3bali3Kt+Om/Wvnz2ndhGfey62Zuc22tsWHHlNsuMu94CB++pPIB6TX1CXKklClehk9fWvHf4mPw1dpGZ8yO51y3i11mJpxJQqydWA8wmZAQn5VIH3rPwDXyw5PJySXS/X+xfi+iWXF1wjcl6HlfDc6Znwt23NvjL7ibdwFpp8l1sEf5qpA+lWm17QcOxPC8QwLE13mCftd8LurrDVn4dxURLzJ3IkmQlX0qn47gGLZexBeG45htzYXjU62X2lIUCPcVGuqVqSgAFKtjvwYmvt5Y8eanS+J8hHUZsHsW/gyx3uT04JcsXt2s3uXluAnEcOTrTp6kpMBKv81VdvX2MYazl9zOPZ92gs4K+LZu4Si8X8Lb4khQ2SNRidoIkifKuAZezDieW7lxzDXwW3wEXFs62FsPo/uuIOxFXq2u7TGcGuMw4DgFjiNzZMlVxhWIKU6nDkDly3QVAKQeSIMVx6uGaNST2Xy+R6GiyYXard/O/czVxTCsHzDfuYXi2GJyxmcE+I6U2N0T8qdJ2aJG4IJST5VR7/DbzBsQdw/FLVVtcswFtq6T1HmD513jOuF5czTgqsqXOZL69zFhmHsYnbJawltDAQ42CGh3YKiAPOIqiYa+L55vs57TGDYupaSnDcRfQA9aOKEtpWYlbSpA3Jj6U9Nqm1Xp2/uiNVo4uVd3w+3wfvOcKQlS5WtSUzyKw6jr1mBO3rFSmYcvYtlHHbjAMw25t7q2VukbhQ6KT0KTyDWhp/MEjUk8nqK9SMlNdUeDyJRcXTMMpUgkKMk7J3k00pUDqSkwOYrK+gB9QClApmZ5+lMS6Ur0lUBXAArQViQCW9SZAHM0O8cA3HB2pyStIhZmDtApqkpIVI1ad4JpgPWo7Lkied6yQlyNbigU7DasIbRoU9JMHf/cKchfRwFKQJmgQ4LABUAZBAA9KYSVlSSNRo6iN0uSB5ikVlS9UQQIBHr50AJuTJMH/ADY4pBSgCkqI8z508SsGBKzuVelCWtJTKtYiCRtFAB7swDBPnNBe6xMkDbeiVL2KfKsiADpLqTCjuUmgBIUAoBSd+B7VnjuxATJPQ+VYwEFZUn+zPymN6n7HDcMwfB1ZzzkpbOEMLLbTCFQ/fOjhpvrHmrgCim+DTDjlmn0xMuF4VhljhYzXm15TODsrhDIMO36/+zanoOquAKhMRz7iGY7tDz4SxbMDu7W1QSG7dvolI49SeTVFzVnfFs7Yom+vkoYt2U91aWbX9latdEJH8TyTSw5ayfmPP8q7sONQ3fJ9LptLHTxpcnUsHxtxRT4zz6+VdAwLFFq0+M9P4VyHBis6QJk/4V0bLwWdOx6fwrsizWWx1zA75bgR4jHr7Ve8IeV3aSduNxzxXN8vJOhA35/lXQ8ESA2kqPIAH2rpi2c7LbZKC0pniB/CpZnTpAHCTFQ9ggEJMkkQBUswlQIkSOtbozZsAJO6acISISZJM00AA7T5UQlPI4n60C3D+8SOtAJIHPNOjVJ0j6UOBBJG9ANDNzI/SkfJI5pxABkxv5UgoGQkfenYUMbJTwCKcuSkgdN6dq/d1GaapQGydzQIARIBInagW9wZp6VrUmY+1ApJ55ppsabXA4kAlRE+tDdMmTP6Ch4dhO38aQ/eIHWk2AimRIVJpqZG6iayGekA+tN/eg8UOTQU2JY2OnmgkRtEkiacDKZI3psgbdf5U+ofIUjUD6UT5HcGl8kiRB4pdYJFK2xcA4MyremmTMJoFRJA8tqclJ53j1quB8gQGyNhB86QQAfDyaeAlKYV+lABIEb+9TYmqGhHhgjbmiSBuBB4ogyBAmkYI+U0XuOjGVE9KJAPiP0oqChxEGnJ2A432qm/QKAEAQComPpQAIOyadASrc70SZ2EEUuphQxJSBBlNCIUY45BpHVO24FOhZ3gRV2JoRjkiSeaQKYiZjimyokyJ6U/SAgEipdIlA0o4G0daHn6U0zyE7T0p6lSAkxJMGKLoqgSQYIFA/MEgEU4IAMg8edGARsoQeTT6goA22k/Xg0SRIITBFIgBPh3HQGiN/ENyOal0wox6yN1HafqaSXANk0VJUBAimpQSTMAx5RT2HuFaknwhOwoJKRvG9PS2E7HrvvSKBGo7UtkKhTsSOp4oGIlXXaKMGBttTSEaoJpAOIhIgbUgrwmft0opBnSem4poBAJVRYNA+UngAelIiTI2EcUYBEr5oakz1FUFA8RM7dKUalAhPWCaQKZO31HNIKSkAA9Zo4EEDSSI2ppCySVESOJpx1cGQaBJBIUOTQmAUiBrIAnmgRHG08GnKgAeQ39JoCSaSdABKUyehFKZSBJMDcUSnwyUkwYmgE+GUgCm5DqxqVa+UnwmRULiaFDM2DKDhQ2oXBWiJ1kJEfaTU75AjnyNQGMMB/M+BuqCpbRdaVA7J8KZ9yaVlrZMnUqVqMHb1pSskydqQEDeiNjPPSTTszqxuhKiBNNIIJ0HmnqVG0c8xQTCjpKiKLGBYT+6n60QhJSTJ+lHTEDUSDwDxRPkR9jQ5WNGMEp+Un604KVG4286WhW5jnjenmZSNthuKfUJsZI2E8CkONtp6UVpkeFIBppAkTqBjypdQUEmeRxRE6SRxQJEQBsd/WkhX975am9x7MKYSSQdzRCQpE02RMDj1o8ApSAPWi7CgBOkiaKiJIpGdInmkoJ1ST9OhpBuIGdzuaSidQnfzNASBt1NIoE870yQqCCfKm6oBjYiknZUCZoqOk7/c07GJKtgSN+DSmOOaXiAiBFApTIUk8UmNK0IzuT1ECjwBuRBmaQgmdyo8Cl/mzseaQkL5vmNHTBEcUIgj7GkZ3APrJoKF8xJikTKSmNqQJMJ2nzFNVxzvP6UE0FQTpAgH2oaU7kGN6PI43mkdxA2PtTsfuDMcT9aBAgxsaSfXmkTvPTrSBqhDTvt96Up1QsT/ChvEkbkUgdJgCaA3EEkE++1HxbmKBJ8t6UqHNAmAq3MDYUQITqG586QkQQPvRknfr+lVYUNhahqmmEKHKkmspCjv8AwoEBRgimnQDO8K/3U7DpRAjncUgneNo9BR28p9KLQUEmODAoJhW4Mxx1ppIk+EUZIACQE+1AhwJJ5oKIGxpgSdUaqcOd+KOAW4ekCkCD4idxTVfNsKCkqJlIEGgA6RJG1DVzsNvKkQPrTRJMjY/pQATJIMgbUk6Rzz50imd9I+9Agf3BQARCoBgmiNlQd6ASNjp+1GD7D1osKCInYUwkAyd6eAfpTCgR1NAG5pUIBM+p2pxInfpQVPA6QeKEwJI2O4rIt+8MzAJ69elOS2Xg44CltplOp55xWhttI6qUdgKi8w5qyvk/CHcfzVdvotW1aEsWzRcefXE6UgDb1J2FeSu2Dt9zZ2iurwe2UrCMvod/Jw9glJcT0W6rlZjpxXJqNXHDst5GeScMMeqb/Q6j2r/idw3L5ewHszWi7vEy29jKvEkdCGE/+Y/SvLeJ4pfYtevYjid69c3FwordcdWVLUo9STWsrVqICgeppivEqSIJ42rx55ZZXcjyc2eeZ+70CVhfIkzyaaSZ5k04jbwmT1phCh8vPrUGDt9ha0+tNUUiTyYpEj5UglXkBJretrRphvvrtfjO/dxMe9Jstbmpbsd7K3dSG4mfP2rZN0EtdwwlDTYMgJH86N0+l0DQmAOBO1ayAoGSNqTutyJSa2QihJVIWSOY86cQQNkUjpiZ2ppQkiRM+pippkR4BO/NEbnUdopBCiJ0HbyNHVIk7Ac1Q2rCVeEkJPlxvW0zjmMW9mcOtsTu7e2W4HVNNvKSlShtMA81pLKSJTq39aanYaj12iocVNVLccW4u4ujpWEdtuM4blBnJ72A4ZdstOKKrq4b7x11CtiFlUlRHTcVJDL/AGS5ztLq0yu8rD7hhhDjT77iwQqPzO/JAQlA3jTueK5Nb27r6ygggJ3Ko2HlWwYt0dwz4grmeT71zS0iW+N0ehj1rrpzJSNy+tbPAsVdOEYqq7QwoBm6SlTeqOVAc/rUc685cuKcdeK1KJMk/rWMa4gkkiiAkJKBxHTpXRGNJXycMpXsuBIKVTq3PvSMBOlOxHQ70yEpbIAMDqaJUfnCh5JmtCREEKhLkGJmhr1AJUFTzvyKGykpU2DKtpJoJWrSEkhAOxURMeZqWCV7BVEHuyTAmef0rEpZIEmBPSu5ZRtfw5X2H4dk+9/a11iNyQq4xDuFtqefUmEttDVCAFRJVINUzP3YpnjIbVzimKYSn9nsXPw3fNXCHdJO6ArR1I8q44auMpOMtn7zuyaDJGCyY/aXu7FCUUrZAnU57c1N4h2f58wzDBjuJZOxq1w8Nhz4l2yWlvTEgzHHrVfK221q7yTpM6eDXfcE7YP2/bWdxit/e2WX8EU33trc4k5e3OJLCI+GSlZhDSgN5BAgUanNkxU4Rtdy9JpsWbq82XSzz24VLdPdOSJjbetu2w4BQfunp6hI/nVmzPjVnmPEUXVngtlhdqwFItre1b0pbbJkBR5Urcyo1Fuag1qKQd9tulb45OUU5KrOPM4xfTB2BVwky2pKdCfkMRQWCkgKQpHHirGEJUmSUjSdOk0nZTp7xZ8tt9q1Zgo+plfQdRI8ZI3I3NYe8ZCyVTJEDag844mFTB8xtQWVOqSO9QCUyVRApDBpSFCFhKif3ePvSc/KcQVArIIMztQAASFKO44gHTRWFbK1jbcpjpQAFhKXRBCD96bAC+8WVKUTI8PlTklIOopgp4JPnxTXNe8rBCSOu5oAyrcSvxAaUxOopkzRWqFIDidSACNUb1hTCio6zsCYRJ28qR1LSh1KiEgTxNABAROpKQmR5zTQnu17+ULJ2kelOC+8QSEiRACgf5UUKKvzko1aTEE80ABYSh0rbHSKs3Z7mFeVs7YPjS4CGrlKXj1DS/Asz5Qo1WdJWJXKQeBH33olKu4JkxMcwYqMkFkg4vuaYsjxSU12LNm7LjOC55xPLtst19lm9Ulgtpla2SZSpIHII49q6Fjv4Xc7YNlq5zizdWuI4WlhLloLUFd08tW4bU2PlIHO5NVkWtv2hZOYu7NTic2YCx3bjIMfF2KBspPm4idxyR7VVmM25ltsGGXmMavmcO+I+LSwHlf2sRqBnauJrNJJY5VXNnfWnx31xbUt0/R+jLXjjK8Z7KsCxNaVJu8u3buE3TMeJpCzrQpQ6AmR71z3ZDh/MTJHEzH++r52fM4+y7irmJYPeXuCXFlONMAHvfhFK/tkAiSUmCCJ5qEzflVOXrlD9jdpvcIxBJdw+9QPC43OyVdEuDqk71eCaxyeN/oRnhLNCOaq9UV0KbSFSqCraY+Y1ceyfs4xTtTzzh+V8OUWnHVpcedKSQ20nkn6VT1L7pCdSQTPH++rd2fdqOcOy+4vbzJV+3ZXF+2lp1wtIdVpBkBJV8vWtNRHLLG1i5Zjp3ijlTycH08ypljDcpYBbZewhLiLS1bCE944VqJjcyd+lSBC2wpanNSNoHlXjPst/G5mH9v4fhvacbAYR3akXN8xbqD2qPCrSNo867bb/ik7Lcyl7Bcj458XjDrK1WiLllTDRWAYKnFwkD61+c6nwrWYsn/JG36o+9weI6XLBdEqOrIxOzTiScKdvGfjVsF34TV4ykH54O8etbbymrdjW4pCW0CVLUQI8ya4d2adomU7DHMx3+ascbcuA8yl3Fn0arZC1Nyq3bf+UpCpgAkVGfiMs88dq+QbV/squlX+HtPanmbPUl65MxE7QAJO/NYLQf8ANGDdL1OiWdQg5xVtdjsWNZZyT2g4Y9h+NYZh2LsODQ4VpSsp8hrG4Nec+0z8D+W7m1uMZyFj7+FuMoUv4O9UFsKieHCAUDjmYqi5M/Cv+IOzHxzGZk5eShk3TCU3yyvvhBCFpSdpE7ma41mftD7UHbnEcu5hz5i16hl9bVwgXq1tKWCUqA4kbHavodBoc8MtaTUJpcnga3V4nivVYOfeV7MeXcZyljD+A5gtvh7hncqCtSFpPC0qjxJPQjmmYLj99lzE7XG8KfCLm1cC21FM/Qg8g9RWg484+AX31LCEBtOtRMJHAE8D0rGGir8xWw8xvX1/S3FRnz9D5bzIqali2Oy2uIXWXc7Ydn3KtxiuE4dmS0U4x8Kyh7Q6k6XbchyAUhW432FXPtJvE9teAXz6MtYlb4/l6zF0y+tlpKLltOziYQSQI3jpVHYcca7C8vXN9hhvkM5ncLFosFQfa0+NAjeCav3Z1b4xe5kwrOzuWMv2GXcRvl4eLUf1e7tNaYCFqCRPXwqG9eBmUYNZXs47XfPuPosH/JHy3xJX61f7HJ0ODtA7PnG7pKrjHcpIDrLiZW7cYedlazye7PHoa50lbeoqUoqneQImus9kSrfBO3RzBG2kPWl3d3eEOJPC2VkpPt0rmWN2fwGM39gtCQhi7eZSEeSVECvV0uRxm4R4aTPI1cLxxyPlNpmi86pTxK1jr06U2FNpSS7M9QOB5U5SEuJSECVQATNMK0p8TjaoncTH3r0jzRBelZWCYP8AGsiCgKXrMqI2NYZ0r1hQCVbQacrSDJSZnkbyKYDgrQJSvk7Cie8cZgKgE+IeVIqTuS2FbQBxTkoUDCU7kbSDHFAAGgDwkEpPXqKPelQJUlSQeCKCEJIBUkyTxMUlBQKUAaQZIPrQASlYJKUqMpPFPgJC9BMlUwoegpviEalEAcGsiEatgqaBjACmUlChtO3E1sJQG0SZnY+VNWhxsArSSkjdXkatmX8KwbA8GX2g9oJW3gFsrSzbpWEvYi+B4WWwd4PVfApPbY2w4ZZpdMUYsKwrBcKwV7POelu2+CW5KbZlBCXcReA2aaB5ExqUOB61xzOedMTz7i4xC9YbtbZhHdWNiyCGbRnohAP6k8msmfc+Yz2i46MSxFtq1s7dHc2FgxIZtGeiEDr6q5PWoq0tFGBpHNdmLF0q3yfS6bTQ00aXJls7dSgIB2qz4VYKVHhnf+VYMMwtR0ynkmrtguDbjUnqP4V0xRs2buBYW4QklPp+ldLy9higlMiBtz7VG4Bgk92dI+vtXSMCwcJSgxBPJrphExk2SmAYeQhCiP09KvWEWh2AEgHio/CcNCQkdPb0qz2NroA8PkdvaumKowb9DfsWthAjp+lSKCpOwFYWGtAA+x+lbIBIEcxtWhPI9GxKisAGlHhjUDvM0AIG6YpQn5d5HQUC9w6dxp4ppCp1E8GjsBpIINCVDp9POnewqbAVAmetOG0+Eg0wgDdQgUY1dTHnS3LqluGYMoE9JpkkqV4RA2p8nkED3pAxvsZ8qE2SnYAIEAmkYG+gqNI6uaII1BSRAPJPFA67i08K6DpSIPiiImgZIMnaaREbDVJ5PSi0FUGSeeZ56UDtyCCeJojV/eTA6daUqWAR500KxSk7EgzSkSNt+OKSiEykfrzQCTpEmNv1pN0UlsHw/KonakYEQJJNLY6Qrc0yRqgmN6drsSlYQBJUBQ1EEgKEQOadqBOx2NNJAMEb0DruOBBEn2mkmI8R2/ShuRxtTYV5wKQnuOUCE6UGKKoAE/WgDvAVI86KhAmQSDBoCmIFA4mTxSITIJPSgEk/ukdaUH5oiKLG9hCUkkpMetOMBO3Wmk+HxSQeANzQBhOkwT/KjgAgEbiKM+HxJJPpTUkr2Jpy4G8qgcxtRdiaEBzq4NAiAI3A604kFRH8aB6CYHtTFQJjafpSGgrJ1D3NHcHwpFNIUfb2pDTCRvsuaRKY8MR5E0kwkg7+LcTxQcIT0384oGO8QAIiRxQKTHMHzpSSd+BSGpXG4oAckgGPm9elNJk8SaC4UAoDalJG/MUFKNiMzJn0FIjnfYxzSBnjr/Gh7mR7UrYUhxWTAMR5UNojzocjkUYkgkcUboiS9BbTz+lAjeQaRkKlIJ3p5JJII4FMdbWBMqPI9zQKt5CgeRxRnVA6Cm7DxK56U2xJNgO42MK9aSUad1bj0o+JWxFHxA7iR5cUWHICo6Rt7gUoSrnb3G9IHUPCZpCJGo7+VAqCZ2AUFehFBPkRpj60lTzAj9aSjsQkTSHsIAgGSdjNLwpVztROoSSPp5UIHzGR5zxQNbCKhyNxUNiKFDG8GWkDm5B890D/AAqXB8KfInn0rQxBtK8Qw51S4Uy45pHAMo3k006ElbpkhG2wO3BoRIB69aIHhjyG1MKiE7ddzSHQ8hGwMyaR0jYDffegdUzx5bTSGpSh+9QApkyPqTQKgTz6U4EpJiSfXpTTClevlQUo2OHkTTZ8Ux9qJEGOKAPRJmglqmO0+St6BKhvO/rSiACNj1BoEqVCY670BVA8Sjv96clO3pQMgQBtRBB5NACCE/Nv6bUjuQKRkTEzHXpQJASJ560CCoJ4kbbb0DpQCefKkrTOnypEajsRQMRB2UNxwQaWoCADzMA0FBJEKVuKWnURvx1p9txLZiII4O9GQUkgb0lBYPE0BtuOfKkPnkWg87AUQEg6Rvt50iCRvxTYA5ICvWgdhiARI/WlI0nqaUyIgUkoJAniaCGqDMgmKaTETRJAOnV70OVSR4aVgrFsDOoCkEwnUD1pFIUdtopbROrimim/QcIpRPG/pTQZJAomIO8Gix1tYIVMRHvSM6tqEq/e32pyDO+mgQt9gelAxzvNEKgQNz19KEqJTO8+kUAD1k0eRBO5/T1oK2QCTvST5npQGy5HEwBB3FDUondVBX936ikkbzFKxtbCSSRJNDVCppBUAAGSfSlAVxuaNyYtLkQOolPFEk6tKY4oAAbg7+YogiYPvVpAwHUDwI60lEneOadqAkRQEzrSRtRYUJJgzE0DHUx50lBXQUlSUQD6k0PdArQExPntS1eHrtTxunemncmhi5Y0K4kc0NzsOKdpA5HFLYUk2NxoRST1igRAijM7AUuhHJG9UIAO8n9KW4Pi3FIk/wB2hvBkUlQUOJA2mgZ4g7b7GhEQo0VgzyACIoboRtq8P723T0pi+CpM7iBPnTlRA3AHl0pq/CInp9Kz9xs1bMQXaI8F0w24giPGmQPaqlmbL2XL5zvsw9klrjFsZAusOCVuoHqlWk/Y1P3iilJ2PWoS6vrmxWX7N7Q4J8VeXrNB58/MhKn9DWHTVNJnK8c7Lfw1Y883b4fm5/LeIuqKRa3SlNlK/IpWI+xqv5g/CFmttPxmU8escUtdM7nSqPQpkb11TG8x4Bi6Da52yrZ4q0T/AGyQG3k+ygKoruUMuWWIHEuyntOvcrXy1mLS8dUho/Ukp+4rycmn1GF78EZNLp8n9NHDca7Lu0DLxdXi2Vr9ttn5lJRqEee07VVnEqbnvUFBBiCI+4NeqTnnt2yksnN+Fs5hw9KgF3DLSSNHmFIBBHvFY8Qzl2I5/dLGZ8upwp7YBb8IB9JAj9ayjmcdpHFPwxf0S+Zy78PLGSMcx2+wDONnYusONhy2W+NKkuTB8XPB2FekMb/D12Lqw5VzeYSuyZ0/9It1OKKU/wB4xP8ACuU4v+GfJGbm/iOzTPZw69WiUsOOd6lR8gQoGKi7C/8Axb/h7KG7/L/9Msu23gTbtOkqjqUnSVgDy3rKcuuVwde46dPijiXTljaLO5+Fvs3zIXmsg9pqH7hMhLDy0Lg+R2Cv0qhZn/Cp2t5aR3rGFM4qyd9VmslceqVRXTsH7Wfw4duVyMMxu1uMm5sdACmb1Js3u8/zNwF79RBqxYtkXtq7P7Ev5Dzxc4th0d6lm5PflO3HjJgeoP0pdeSHLKn4fp835VR5Dx7K2YctPi2zDgt3ZOqmA8ypEx68VF6BOoDivY9p2yZkbtkYf2qdmNveBGyrppMFR9EKSQfoqoDFcrfh2zo5cON26sv3b+ylOFVuUqPUJPhV9xVrUPujiz+EST/45foeVVKVvAP2puyYURIru2NfhVzWoG4yfi9ni9qBIlQQsg8RBIJrk2Z8iZvyc463mLLt/ZBswVusEI+/FbRyRlsjzp6bLjftIgVKQBCtJJA49aezaNqOu5CgBsEAwSK6T+H7Csg5rzZ/RvPNkh1l5krYUbhTY1iITAgHr1rsOZ+xHscw2/TZkMYYu4JKNd2pE+xUYB9KmWTodUb4NBPPDqi9zy4t9OnQhJCB8oPlTdIUJUdq73mv8Lj+H2ZxjLmZWnWl+JtDoBSfTWD/ACrk+Pdn2bMvKHx+EPaVH+0QkqQfY01lTM8miz4Xco7FZWEgEoHFY1HaFDfqazqCmzpVIPUHasSypW4Bj1rQ5Wq2Y0EJUkKMg80xSkBXi1AHYCdqeuVGQnxDafKsRZWqVbnTuVHpTBqhqCoKXH1VTkKJT4DzvP8AOmrQArQgKSIn3NBDigPFsSeg4FJjjyArDYlGxRuCDBB85q2Zb7Ws34BibWKKxF3ESwwu2S1eOlaUpUmNSfJSeioMVTCudYCidW0Rz6VsWtgsAOXC/YEVnkxxy7TRvjzT0+8GdSzXj2Sc3ZRscSxGyQ1mJKFNBFu6pbixP9tculI1L8glPua520yhkBDWniTHJ+tOSkDbUNxHHSiFISoykcQN6zx4fLVdiNTq56qSkBGrQUaAPIDimFOleko1bSB605sSZSs7UXFalAuHjqBBFaxtGC35GOOlbQKCYmCOAKa44dAbcQJ52M7U5SI1IbjffSeTWL85udojbcUxhUtJb0hRBChsKb4FcJgqJAg7/SntNodeSFLSnWoJUpUgI9dt4rumDZH7BsZwqzybbY/iN7mV5BW5iVsw4dTpHgZaZ4UmdiSQa5tRqoaerTOrT6SWpvoaVepwdJBKmxB4EngGnArCVNDxDmT/AIVZc4dnGcMguKOY8v3dozrLKHXW4SF8gEjYGOh3qvWzwYubd8pUVNuIUQNtW/Q1rDLHJHqhuZTxTxS6ciokbvKWaLDDk4pdZdxFuwJGm4XarS0Z43IioYNd9xJM8dK9XL7dsLzbZWl24i9tcuYIUjE3sSvEOPXbZRBtWWEpCVao5O4qpp7PMm9o2VDnOzKcu2Fo5caLbCbX411pkEQq6KlpKTvOwPWvOj4jODazwqu56c/DIzSeCVv0OAoWttPdqMEbAhPNY5UCULSVKmU6YEVec0djubsutDFEtNYlauFKrdduSpx5hQlL3d/MlJ9apCy4w4UkEK1QoKEFPoRXo488My6oOzzcuny4HWRUPADZBiSJI3piSJgOaVKGwEAUVoaJKkE8xB4Ht1oOspTpUJIO8FMTWhiO1OaQySFa995g+VBEJUpB1d4ngdPrS0p1JPeE+ETOxBp5T3YS/rSqT4gTTsDYwnE7zCL9m+wq8dtb23WFtvpMQrp7+xq6XGH4X2itLvstWbdlmNCou8LQrw3hjd1jf5ieUfaqEgBI7x2VQdhG2/lRRcXFo+3cNqLS0EKbWkkFB8wRuPesMmLqfVHk6cWd44uE94s692ZdrruVG7+3zfi+IaWrM4c3bW9og3Zaj5O+XuhIPTcVK4LhGJ50we8xnJ2WdGGXD5QvDb91LlteLA2KSILDxnYgQfPpVFRnPAs2NKtO0W1cVclvu7bG7QAXDKRwl1vYOiepOr3qawDG8/dnlg7cZTubPMmDrYVpdQ0H27ZUyFraMltYgHfivMyYKbnBVP6HrYM6UVGftQr9f1IXM/ZpeWt83aYbbv2mIOeB3Bb5Pd3jC43CCfC6nyIM1S79i4srhdpd2r9s4yoocS4gpKSPMGulZd7UMMzddXdv2pX+IYi7iS0qYvSUlDSxtpUkplCOPEkgjyrqGdsmdn11gjisLzpaX6sHt03Nzhd7oumUSJKUXSVB0E+UGOKr8ZPTtQzLnv2E9Di1EXPA6PL6yQolG4JkEGmKUHClRdUSncgHrXX8Q7IcMxnKKc7YS49YMXNx3LLTS03jK1xJSkyl0EdQUGqpe9leO2tqX3cUwptcGGn3/hnCPZ0J39K64avDPhnFk0OeHYgr/N2ZcQwi3wK7x28dw23WFNWi3iW0qHBCeK98fg/ss0js9usdzfeXNy/jFwldt3ypKbdtOlO3Tb614Wsci5xNxaXLOWr6+badQ4VWqO9CkAjUApBO5869AD8RPbZg2cl3mFZTxx7LLQSzb4U9hpTpbCAASdM6gqfevI8X071mNY8CW/J6fhWZ6eUsmdv0o7Z+LTtNYyH2cXOE2eIJbxjGz8Oy2HNLga/fUI3iK+dd0+6t1TqnFEuGSZ59TPWr5nLD+1ztDxp/MWacCzBe3TyjpU7aOQhPRIBEJEdKibDs4zHdPKbxB3DsIQ3BnErxtmPoTP0iujwnS4/DMKg5K3ycviWoy6/M+mL6VwVZSk6DDZ0/MpRNSmV8s45m29XZ4W0dDaCu5uHNmLZocuOL4SkCp7D8EyHhV+6My46vGrhC4ZssM8Fu8TsNdyqNIHok1K5nse1BGCXdtb5Jvsu5XtIuHWGGVBiDsFOPR+bPSSR5CvQnqOqscXV92cmPSuK6p7+5bix7Er/M95h2Tezi8ddwzLiNGHo75LTj7yjLjyZIkkzAG4AruX7Jxfs07IMNz3nftCxm9cJKn8BukpUHbqD3QClDV4TBO5ryClxbbqXQsK0q1CJ2g+dXXBsT7Rc9sWnZ7h+K3V/ZsEvN27rn5TIPzLWpU6Egcma49Von0RSklFO36nXpNeuuTUX1PZehP9g6WHc+3GccbUtNng1tdYrcXI/7SDpTPqTtXNcSvDfX93iACiLi4W8B1laid/vV+zpjuC5Zy0nsvyletXyFOh/G8TZ+W7fT8rbZ6to3671zckp1IESqORHhrp0kHKcsz2T2Ry6uUYY1hXKtv4syK28GkQNpPSjpU62AlBIAjmsSnUr0oWok8metOC/lTJ23JmNq9A88SlHSG0pPh6UIUo/ug+WrY0Uq0kp8KgdyZnajrmEI3jcxxFMAKaUQlStoH0p2pQCSrp6zSQEnQnYIV/sn70oJAbUnUQSCR+lAGRKgRBJBUeAP4UEbagHFGeh6GmrJCUrEgg+VOSgTr1kn0oAdAJKVoPOx86eAoIKidKQYPnSbAS4EuiQfD5b1fMuZUwHAMvntK7TnVtZbbOm2tEkpfxN0Aw20OSmRurpUt1sdGDTy1ElGC/gx4FgeCYFgh7Qu0gqZy6wo/DWySA/ibyd0tNpP7p/eVwBXFe0TtFxztPx39r4shu2tbZHcYfh7GzNmyOEIHAPEnkmsnaT2l4/2qY+MWxcIt7W1T3OHYezsxZsdEIHnESeSZqBtbTURG8Ax6114cXSrlyfTafT49PHph8w2lpJmDyelWPDcMUophCp9qGGYYVETH/Aq7YNgyVKTKep6eldSRux2CYItYSQhRJ6wfIV0TAcvOHTqb8uh8vamYDgAHdju+T5egrpOBYGjSJbG/t5VvGNnPJtD8CwMBKPywd/5e1XvCsI0QdMR5D0puFYTCBpSNo59qtdlZaCPDHXb2rpjH0MOoOH2KEgEjnzqXt2g3Bjg8inMMyBMVsobS2N+taIGrCkHYgQKekkbkxvQTA3KRNOE6tht6imZ8CMEzSHM9aRgE+VAKCgnUCRwKFsPZoImASDNAkgyfuKKvEo7Ez0mgSkETMeUcU7Kiu4pBVI/SjMggCTQiN+lAaidgRTKlwHY7TE0CkgEiY9KdIEAkSBG1NTIJAWaL3MrXYSXElBEGfWgkx0jrtRUDxFHSE7hJ9vSk32NI8WCTJj2pQSPy4HvSJBVA335pQQOlJDvsFGrUAqPpSSI2NABMyDFKSRHnQ3ZKi0AE8aoI9NqRUTzEe1DnfqKcCI86G7GooWw8RA+lE7jdJ3pbq6bDigQsHxKIFCHdCHA9KCgCaO+qDB9aACidqdMFuOSREHegZGx0/zpQZAikfEqTwKERLZikRuY9DS2AlJBpEgq0kQfXegExMqiPSkOLtBJOxBpBUkgqmelIaeZP1pQQZKAoKpoT9wUqTH6mlOqSd/vTVGSfCRRQREUWhVQjwNtqQMbkbcwaQICoP2pLUiNzFDCqFqnmnDgb7CgI0+ET/GlwSk7bUIdbClWobbUTpnTHNNBMSASaW54Bk07Cr4AFHUBHSIoxIEJEjzphVvuDv1mnAcET60PgEqYTxHSgQAY4gTNI/KSkzvSACtjOoCPelVlOhSSBIk0juCNJ+9Hih8wIHNFi6WBHi5EkClpk+KikCPEYA5g0QCrcJVFKthKbuhidI2BO3FO0qKdYO5Mmmq3TAp0kJ07fWmmNpsAg8jenRtJTNAKMSQBFIqVI8+kU7QqkIb7AQRQnfYwKQWs7ngHpR84G5HNKwXoIbTBnbml4vmgkUB0SkT7UgdiYUPruad2TwxACCmZNA+ETRPzdCPfekT67bTtRdIdWxDcEL3NNGmBO004KJKfIHn0pAgyNo96B1vY0q8UzI4E0iArSBvSUCJg7ClvpBijjgqr2FuTtv0rVvUOfFWZSglIdVO226DFbSdQEa9/IVpYlc29vd4cHndKnbgoaE/MrQSQfpQxJM3iVcyN9uaQgbxumBQQJTICR6RSMAgSPKn8SVvwCCTt96d8yhAim6YV1iKUlI3FIOl2PB1gAnjefWgSORxTZUJ2iTRHiEqH2pccldLoBKAdhvTgQeVUPCUwn9abA1SAD701QqrkcomAd9uTQjpCR12patiD7xS6iBzQgaS4FB1DgbUgQNuKURKd+aQMbFW1Ag6tvEr600HV5KH1oSIn6UU6t0xBiRRY+kJBA6b0t0gadzQVskSnfzoz5A0mxxj6jeUg05IkehoLIG3WlKpAFJNh007ERBk9aR3MDrSO+yjxS8JE700/UHG+AkImASBQSqN6UyTET70lEglZHtRZSSoSlbieJ5oaUnbckcGgQeg+9FJXEKEeY86LI4dII09dj500qOreiSTJPB4peEmOpoaFVgEapnalJVuaOkRxxtS8Uxt7UJMt8AhSuOnBPl5USSANqGryoHVMQfvTqyboMHUCQBtzR8X186BBiOtE+eqh7FLcSdpnegSNJNKADpKQKSgNJEUlT5Ik+w0dJ3omSdhtSM88UjufDtVWnsJRYZED70hskzv5UBzH8qCtQ61FUU7kO2UqY3ihBAk0p3g/eiPeRVVRLVC8PJFN1CfFvR0+h33ppJ4I2qrCx5IVQkRHShrTEUjGkgH2qG7E/eGQedx600GUmDtRGxKR+tCedtgPKjdBVhBkBRPG30pGU7xtQKkkCDS5EzTbGmm6Fq4njpRJ22NAjwjTsPKhPSm3ZaVPcJJgkCDSSSNgYBoUpnfakDaaCSAST1pxgDaFGmK8W4pJmOftTsy3CSo7qj2FAyeBzvSkzvuKO0E+VDZfl2bahCYJJjmsSzsQAT5Csq99wfQ0w/LJ5GwrI1Iy7BUDvIiKruJsmVHTAPXz34q1PNk6gTAqHvbYrCo8v51DW5SdHNsdtlKC4gzIrneYLBZ1yk8K/lXZsUwwrJASY3JqmYzghcC4G5mspR9C0zkYx7NeW3Vu4DjV5ZzMoQ4SgjyKSYIrK52uP3SkMZ1ybhmMMpMl1pssPwOSCPDP0qyYtl0L1EokQriKqGJ5ZhS/yiTvO3+6uXJp8c95I0RbsOzD2QYkGLnLuacUypfpI/q96IbEngLG0V1DAMx9seBW/wAbaW1tm7ADuDbPJcWR6QTHtXlu+yyApQ7rfUen+6sGF3GZspXPxWWsZvsNcBmbd4oB+nBrzsnhkeYMa2do9U5kzB2HdoLTGG9pWTP2Tdup8Ll7Y6AhQ2/tANvvW9gGSM3ZKZVddkXaOvErJwju7C+uvjLVA52BIUny2VXCcM/Etn9hgYZnPC8NzLYcLRcsJQ4R/pAc+4q24D2p9hV66i7s7TFckYooFKlsLV3P1IlP3TXFPS5cXKspRVHaTnewxFP7N7UMrP4JcNKkXtmmWnT1I52PUEGo7Fuz3CsXaucWwpqxxawWglHw40rj1jw/oKZl/GccvLNDtviuCZ0whQjSh1KLn0JIlP0IBrOyvJSXEl9GJZKxBRIQtQ7pJPTfdsj7VyuaTqhbvk5vY5CxvCL0XeWMzX+EXI8aWG39KFweD+6QPIirSjtbz7gjpwrtIyjZZgwdyELUloIc0+e50qq5LwfOtmWbvFMNwnOVjbnvLd5r8i7QD1SoSlR46itVjGcgYiVYfjV1dYQ/cuQmxxpgttgk7hDnB95qupS7DUVdMpF/2ffhx7Wbts5exR7KeNtjvENtL+Ec1AyISRpVvHBrYRlrtayckYHnjCLXPWX3EFLOJMtj4ltPTvEKJC9uqd6nM4/h4axxDl1lstBnQC22tQUgqO50rTVGXddtHZW2m0SLtzDGR/0a5QLi3UPcyQNulUpPhMnyYr2oKiz2+V8Jesjfdn2br6zeGpTuHPvnSjzSW1DYD2rXsM4YzlZBsM6Zacu8NcV/0u0SHGwJ6tmd/atez7U+zrM67ZjN+CP4Jimne+tyrSn2UIUB6GaueCsYzbWqr3B7rD845eeGoIQtKbkR5/uE/QHzqupdzRTaj7RSb/IvZz2j2y77C7CyfDqp7zD1C3fa9FoI3/SuTZv7CcTw67cRl+/Q6UkxbXgLLsbcE7H6V3C8yvkzGMTP7Kfu8rY+QoohBZXHUKSrZY9iRW27/SDCMNVhnaBh9tj+Htqlq5tUjvUpPVbf/wBJoWRr8pjk0mDOqa3PHWOZdx3L73dY1hVzaL3UO8TAUOkK4NRoCnCCtcBXSeT1r2ddZabxrDSrK123c2DQheGYkx3zQSOiVK8advKa5NjfZbkfHrm5trbDsSyliTaQGy6gvWKlf6Q3SPeto5k9meXn8HcN8TtHBXTpgrJ2JJistvhGK3rS7iztXHUIUJKUE6TzvE1bc09kGfMtsKvXsLN5ahOpNxbHvEe5joau/wCFvtayvlbGbvJuY+4tnMWdT8M68YC18d0SeCTx7Vc5ezcThxaWTydGTY5GzYtW60qdDiHyZIKdJH3p5gErVuQevlXs3P8AYZJvn21Zq7P3nbZQn4+3Z1hPorR4h134rl+PdhGUczNuYl2Z46hMSRbvOa0kfooVKm+6OjN4TmjvB2jgpaSTBJBrHBT8omDyRVuzP2ZZ0yhAxXBn0twCH0J1NqB9RVQXq1FoxqncjqK1Ur4PLljnjlU1Q1T24UEAGktzcvDcmNh6U1xwpJC0SU8inBKYBQDB/T3opkiWEqSpeo6htI3+xpqlOFASVAgcTzTUyCJSSAIOnyrMltvUAHApBE88UgG/l934QqVAddway2OJXuFXjOIYbe3DF0wQppxpZQtB8wR/GsEFJ2SdzIPNO0uRKjCTtJE7+VDSkqYLZ2uTp2W+3jH2MXFxn3/7pMP+FLZtbjSpKHCID4SfCXB5kGuhvdnPZb2n2VtmSxxJGWrm4s1pt7FhbBub64EfmlpMJQB5bE15wHgHiSmCdgNiKajVJW2pST5E+IGvOy6BP2sMulnp4fEZV0Z49a+p0jMXYNmzCLjE7bDr3D8Sw7CmBcXOJNvhNun/ANmVHbvdyNIk1Vsn5h/ohfP4hcYS3eOoa/JauFFLAcnwqcb/AOsA5g1K5M7W81ZQvMJQu4TiOFYTcm5aw65/sFLV8xI6nyJmrVnHtNwjtUzdg7n9DcHskMrKn3L5/R8QTyHFo0jSOgG/rWf/ADpOOddUfUuL07Snp5OMr4ZZcn9otmcUbzVheYWbjFMSsPhL/D7y+VYul6I1pdgoUgcJTtprcv8ACMi43hlm92lZNvrLMTbx/ZeH298ly7xhHUvr0wlAMQo8iuU9ruQWMjY8zbWOP2F58e0LtLFkkhLCVAEQSpW3uZrFbr7ScsYphHaPiWHYgsgJctry9ZUtl1tPh0SR8sSK5lpoSSy4pVfHZna9ZLqePPG65fK+JYXewDHcew9vMWR7hm8Zu1LcYsLh1DV1pBMhAJHegQdxG1czxbCMWwl8WWLWFxaPIVBS+2UkkchPQ/eu7jtryBitixaWWXLjK71myVF9t5D/AMPvJTapKdQUokwCqN62sQzpgOZcGt8xYrlZOEZDtW3Wvh3ng4/itxGymSAO7WDuVJ2E9a0xazVYnWWNonLotHqF1YZUzzgkNuyQQE8SRuSP4U4q0pUA2ACNJkV19/s+yz2g4raWuR8IxHB8QvLJN4bDu13jCWdwlRWka0ExO4Iqj5k7Lc65TTc3WJYLcOWbLncru7ca2kq9eSmf84CvQw6zHlXNP0PLy6HPj9pK16orKCVIS6lMIGyt+vtTFBBa1BJlKtp5ipXDcr4/itq/d4Vgt7csNCHXGbdS0o+o61GlpxlwNO7qQSFBR0kAc10RyRlwczxyiraMesqUHFGT0SE8+9bVhiWJ4bci7wu+dtX4gracKFH0n/GtZckqMBMGPLentoRCkuAgblRBmq2YozlHhlpOcbXGnWf6V5Xsr1DY0resz8NdK91AaVH1KaN9l7Jlywb3LmcEMvXCgk2OJt904j0DyZQfqBVQQ4oFSRsCnYdTPnRK0qUjUSdO29YeQuzN46jq/wDIkzouYbftMuMEwLDL3C2rjCsvybH9nBDyCskS4vu1HUowJJFdPyr+JTC7C7scMz3k8tW7Nk61cp+Gb0PXEQhZaUOB7zXnO1vLqydTd2F44w8gbFpZSR9jVjd7U873dqizxHHHLxDY2TdsN3A+6ga5cujWXZxTOvB4h5Tu2vqQ2J49iN/ijuJN3a0OurUpLjMskJmQIRtxFI5rzPoKWsx4oNWxT8YsGfvUkznm2QkfHZKy/fqmNSrYtGf/AMmRFZznPKbrZ7/sywxLgEa2r64SPXYqNbpOCSUL+RhKam3LzN38TsfZrZdiGbcv/Cdo3aLif7bs7dy6lp15hlaEidKwoq7xQPlE15/zDYYXYYxcDBcaZxGyUtRauGm1p8JJgELEgx71MDNOTUIJ/wCTe1UP87EX4n/CnO54y60NNp2Y4Cknq7cXDpB/1ormw4p4cjaTafbY6c+eOfEoWlXfcrWGYg9hd63iFuwy440srQHmg4hRPAKVbGu/Yb+IXtxzXkxWRhle0xJDi0I+Ldw9KrcsAf2SwqEAeR6Vx0Z/xJm7Te4NhOD4W4k7KYsGyQfQrBNaeP53zVmZYOP49fXYTKdC3YQn2SmBv7Vpn0z1NSnBbcWYYNRHSp9Mm79Cy/0YypYYtd3mfsw2dpoV3jmE4HDjq54SFiW2xx1NRuPdor93hhy7lLDbXL2DaiFIY3fuE/8At3Ru5022FVFaAkJJOpK4Mjg0x9S9Z0at5CTHIraGm4eR37u3yMXqem1iVJ9+/wAxyXFLVvDaRyfLzpLUlY2SrWkQTMz5UzS6klxaEq/71JbqXHAQkiB+6rk11JUc3YcpRU2EKSlEbpHUigkalBZBRqGwImaBK0qCEkEDYA0lKJGlexG4g9aoQdz4gnrwBtThpGlI1Cd+OtBKQkFbcjeeaekpdQEbpcHyqnagBIaWo6Tp0nffz9DWdsaTCoifsYrD3L6my6tadSSNkmdvOnomO9dVAJ3JoAa2jvZAVBB3ng1nSgwlUQOp/wAaZ4kqlRJEbR7jpXT8mZVwHJ2Xf+VrtYSu3y6gxh2HxD+KXAEpShOxCepMRUTn0L1Z06bTy1M+iBiytlLLWVstK7UO1hx21wNnbDbFKtL2Kv8AIS2P7kgAn1rhvah2o5k7WsxjGcd7q3trdJZsMOYGm3s2Z+RCfpueprJ2q9q2Z+2DMv7cxwpYtbZKmcOw9kwxZMTshA+0nrVZs7VSikEbV1afC4e1N7/sfT4MENNBQh8/UNpaqWRwSZqxYZhmoSQOD09KGG4cpRBjferrguDagJQTtXZGJpwPwbBCowEzuY29K6HgWAL0BS2+p6HypuB4CCkHujEnoNjHtXRsDwIAIlsJkHoPKt4oiTH4HgZTp8Ppx6Cr9heFaUp8I+3pWPCsKSlKSUJP09BVsw+x0lI2Aidq3SMupDrGySmB0/3VMW9uEgFEE8RSt2AlKem/8q20oSgA/rWtVwQFtAAA8uaeEhSiTBEUQCkahvO9ABIOobyIpJsQfDPPtRSdtzuKCUpURtO2/pSCdIMTJ86oGrF0J0k770SkggjbrFNmYVq2px0pTueN6YlFIMJ8zvRIGmNzTRukGkoSCQqgYpSNt/Y0N/mO0dKRhUSFTFDbVEUraDnYQEnfnmnDeAQKBEGCaaSAnwczEmjqF0oJMcTINOCo3UdtqaqSqJk0CAZ36T6UxpUJKYTAkn+NFO5gx9TSAMSQN9qRmCANvI0WJqxEAH/fS1SYIjSKCZ2kRRKdxp6nc02KN8AnTJFOJJGyh9aaTwAN6UTvH1pFC1GRIiBRJB25pAAyCaG48YEjyFANJhB6dBSEzAmltxGnzpBRGySVCgVClRMbSKRJmIEGkuIAiCaUEEEiAOppDBztx5AUlA6pUdiKPvyOvSh8ygKFuFCiBpPPWgn5wD70hB34pHmSN/LyFG9hVjgYnrvFGdpnemgxsnigYJ22pioBnVMgE05Q22MihufCaQkkJCoNK7BoQlI2Jk0TuiVyT50kmOv1oiSDwRTJW73AFf3RBO9IqB+YAR1NIT8nB3NAgbhXIEmm0kOPoElIBSkUgRHWmjVIPPT3p0gyR049aXJVC1eXFAqVwkwDRmY2oHnbnyo5FQ4Hwxp+pppA1Sk+9IeMkjf0okz0j0o4GDcjSd+u9DaN0706FHYp9RSknc0J0FDQdIjyokyUmOk0inbigFEQJ9BQJKkOCZkSJPnRgk6dqaRJg0lQUmTFVQm2hKMAQOTMU0kj96IO9FO4JO3v1oJ5SCQdvOpGg6ojRtFAqMFX3inLQeNX6UAkwdIppg6QgCoauJpcJMkf40iZ2PSmjY6vUih8iUQkQrSJ42BpDbyo7SCTvSVA4Ij1ov0GkBQ1whPA6igueJ38qW5455IpCSZI4ouhiMDfr1qLxW3S/iOEvLRqUzdL0+gLSh9N4qUUSTAHqa0MTBD+HqP/AOFBMTz4FGhPcHwb4hB0AzHU0gCRIAkmKQCVbk0p30g+1F2RGNbiOs7TuOlJRCtioCOnnRBA3gkzvTVAKQdIn6700VQEknwzPrTpJOxpISQNhMURwRpINSMaTp6UJINO34I2oK84mhchVhUjrPNCf3eYpDUBH2okACqszpt0IbJJgUBKuEgChz7UiQZBUB5UrKUaCOIgedIHfkzRBAn0oQkmYIPkKLBRpiJJMUDqB1EgAeVEzqEQfSgodZMevSkxSbXAiCqY2PrRkiJilt/dM0hvsBQWBREAqG870d59OtGAZkbnmgPDsKAEPMAfakpRncE+lKBMAwCKBkmJBjyoAKo/u7kbTRAMTpmmqnYjkUTAEzQAACfDQICIO8zRJ8QApEngfxosTQCZ3KfrRn94UvSd6EGKT9wxCBsFA0kgzBNICUSRNJWkeg6zQtgYiegn3pECPWl4gPDMChsSCZ9aAWwiTImiVCIjegZKvCacoJIgmduaYqQ0x9Kdq2EGDTYVpEiAKIBPSfKndEydCPnpNLcj0poA06v1p312pN2NJcjentSHHoaPPNCYMAigoKgpJ2SeKb12VRgbgH2pQJgD6U+qkZuLuxEAbkzSAAEmgJ46USmPlMmlEJJvgQMiY3pSOSkg/pSAgfxpcSB9qchRjfIpJEzQEmZpEyIHNHcR5daXYpQrgbO0URA60Dud6W/QUIJTS2HGBv503Ukyd+OKA8M7k+lH/OI6U299iYtrYXA2560htx1oTJkc9RRIKd6SdGlegASNzvNEFfkKOxhWmIFAgjYDiqtMiSa3RuaT8ykk+dNUCnYmR5U46gJG3nTQJ3JmN+ayNaoa4gQNXUcVov2wO49jUhpElW/3mmLQFnTsJ6GgCAu7EKkpqBvsHDm4HntV2VbyN08VqvWaVSdAM78VNFKRzPEMv652PXzqvYjlmRskTB8667cYYDMp534qNuMEQsToBj0qXEq0cTv8qqKiru4mehqv3+U1JSYQfsa7td5fRvCAT5af91Q93ltJJhoD6f7qzcB2cBvcqkhR0fxqv32VnBJLZgTXoS8yslQP5W254A/lVfvMqJBP5IPPP/pU+WUmcKt7LGcDufjMHxC6sn07hdu6ps7eoNXzBfxEdqOCobtsYdtcwWqBHd37WpUdRqH86mMQykJWO6Plx/uqt3uU4OzRPM7dPtWGTTwyfmVlJ2dPyf8AiI7Nrh8O3reN5KxFYCS7aPd/Zn1LZ6emkV2HL+bLPNTSw0/l/O1iBpcctHEouSD5sL2+xFeML3K5TJDSo9v91Q4we8w24TeYe69bPtGUusrKFD2I3/WvPyeGwe8HRXVtR7cVg2AWbjl3lHMeJ5LvHlaE2t0otNrPo05KD7pqWsc19oWDoVa5uy7h+P2KQQm7tCEvL8paV4T9DXkLB+3jtXwVpuyxPFGsw2DWwtMXYD6T6hRGpJ9Zro+XfxN5SeQhGL4Pi2WLwGC7ZOfGWn1acgx7Vw5NFmxrZWg3s6/iWEdk2bLdxm7bbwW9cOnu7hBYcCj5JVtHsaqN52F5ryzdnGciYu+0EgFKrZ0jV/3OD9jVxyzn/J+erFFqzc4FmUOxqbQtLVwr3ZcjSfY1MN4bhKX12OXcy4jgd8ydXwd0F90of3Qlfh+xrllN43UkDk6OfWPaPnDAnRhHaplBjG7JatBuG2NFygf6B2PuCKsOANZMx67Te9nudPg7pxSkowbFDq1q/u6FnUI9Catl5c5iaUhnMuWbXFbcEJL9uQpR8/CY/Qmqti3Zz2SZvvgvDrleC4o2qQ3cJLa0r6FJMH7VKYRcWTrV67ltQt825UftSuVF+0SXbcRyokbpHvWS0tsDxZxeIYJjtvdWjgg26oWAeu43+hqCXg3bd2fw9hb9vmvCkePun3NSwkdAokqH6itdjOPZpj75bxnA7/J+NK5cZBQAr/SHhI9xVX6lrJWxK4plJi1tlu4VqbdT86dX5ah5BJlKvrFckzv2T9nufrZSc1Zf+CvEEBu8s090sK6HaIPtNdn+Bz1bW6F4Xi9vmK03BWxpQ9B4lJ2P0NRCMSsbtZw3EybV9LoStm/t9Cp8oI3+laQk+w5qGX8yOO5Pwftc7HH02WX8UGesmtpKl2Trh+Ps2z0Qo8j0VA5q4WGIdnmeLlD+E9/g2MKGjuHlm2fQpP8AdSNlepBNWW4wMWWJuYnga/g3lo0h+2UVtkdQUHcfetTHsCwvHGR/SXL6HH2IW1imHkB1Pro8/OKtTf8AUCh0KoMlFjOOBNocxm2bzPgjsJXoANwkR/djSqqXjfZJ2X9objq8t3i8LxEJKu5UkpOo/wB5B3Eem1bGFXnaLlpXf4BiJzDYgE/DOmVrSPQ7yKlW885AzQ8LTMWGrwDFzKWnjLCkrjo4PXzpN1uiJRhkXTmXzPO2eOxnNWTXVJVafFsJEpfb8QUPMxXP3WXmXihaFIcSJOoQRXtiwxLGik2LjbeZbZpJAcQUh5KPIjhwe3M1VcY7KssdoLr95gtyxZPhJQu0faLelfqnkfwrWOetmjyc/hEZ+1gdHlAuJIJA+lOACgC3t9a6pm/8PeZ8C1XiGXEtyUiElxtXlC0kwPcVzHEcIv8ACHCzf2bzen96PCfY8frWqlGXB5GfS5cH50YCpIBBSvV0jgmnBZV4yTqHX+VBBcUDuSAJG9BaQYQFeJR86qjABKPEZJJVJHpTW51iOJ4orQUKiR3gPiSf40lJbWkLB0ODkR0pAOd7sqKZ240xIH1rAZVASdOnnVvIrLKyAEtwmdyDM01wNKckJKTGwo+IG5Y4m/YYjaYq0GnF2y0vIS6gKQSkyAoHkV3jL34lLvNCcPyxnxxu0Zu7otYhibVsheixKf7JtqISJ6xXnoBbZBCVKQeRqokguw2opP7s7n71y59Jjzr2lv7jq02tzaZ+y9vT1O5Zh7B8FzQ/cYl2SYqq5w+0K3L5+6VptbdtIlJ+I0wVf5oG1cyzVlbNWWWrXD8w2jzVuptT9p+d3rDjZ5U2RtvtNMwrtAzrgGHM4LhWZMRsrNl1TqWGXSGtRH9yI5mZmZq+ZT7bLdy0xDBu1XCLrH7TEktsrvGnwi6t2Qd2mwQQEnqBFccYarTqn7cV8zteTR6j8twk/kb3ZT2+2GT7e0t8w4BiBuMOtDZ2uJ4RdBi57gme6WFDSsT1O4q25dxHMGZs1YD2g22A3tzl+4U5h4t04orXOqe8u3Y0g+ihxxWXKeU+wTtCt72/wO1t7K7vEC1Zw966DYwxEH+sulSh3quCdJqmJ7Oe0/s5sL7GsvZxQzarvPhsPYYWvXi4mO8ba31I9VCPWuGbwZZNxXTL3/2PQxfiMSSm+uPuO447a4Xk85hxy/XhGF4OhCHcRt8LWXn7d8mEpCQO7VqH7wKSK412qZabxLJT2brpdiEqdS/giFoFtfuWpMLDiCPzEiRChJqLxntfxa1zO3hub8p2isPw5HeO4Cy6E2794B/bvFPz776eOlc3zVmzGc6Ys5jGYLpVzcH+zSVeFpvo2gfupHAAq9FodQpqTlX9xa7xLC8bgl+lEEuA4V6NQTykGNuhpEgHvUrKT0SOvvXoDskyRkjHsrNupzN+13Ll9DWIYK5g3evMOK2StLqFawn/ADgCB5Vjzj2BZUvc1XmXOzbNrTuJWNuH720uAo29qkHxD4k7SByFRXoPxLHHI8c01Xc81+FZXBZINO+xwFZAAVEpJ5Hn5UUbpDiAggnZP8zVgzTk3FcvX93h7pF/b2ShN5apK7dU8FLg2qvNsrkob3Bggce9d8JrJHqjwedPFPHKpqhAkJlXikkU1sIS7BBiN460Jd0pJgkmYiIpx0+JUgkDT4thV2RbGOISkBtJT4vLkUkgkhrcT1PkaYttZAdUCABExAilO3JSfOfKjgQQXJ0kiAJnrTVH8vujple4JMRWQOICUqKQsJVtHP1FYlyVqUmEyZO0kegoSAKXUqZ7pUgpMgjzpp0OAIAUAfPcCmu+OSkBBJhIp8q0hB0pSdpJmD1qgDAeSoyAsQCIjimDT8+o+HqJNOUEB0ACFzuR1oDU2oNbx1J2BNADdaTC0ainy4rKlAcBdSgIQOZ5FAa0rSBoVuYjp700E6yhC1RPiExNADjv43oT0AHWgEJQSUSdPAohPeEpiQB4Qd4FBI1CO7O4ifagApLyFByYAOx1dfIiskpUT4QC4OT0P+FM0d42nxcfLI609slahEQOdqQ6GtEtgta9SQeYrMnWdlFIB8529aSW5WVgGQQPauyZNyTl3s7ysjtf7ZbdH7IblWHYUoDvsQf/AHRpMeHafaonPo27s6dLpp6qahD9TVylkvAciZbT2sdsTXw+CtDVheGEw/idwNwkJ5Ces1wDtV7Vcy9r+ZVY3jbnc2jMtYfYNGGbRnohKeJiJPWj2r9rGZ+2HM68dx53RatEt2Fgg/k2jXASkecRJ61WLW0JPE7frXXgw9Hty/MfUYcUNPDy8f8A7Da2mqI5mrHh+GKP7pBPWlh2GlWmW+CauuDYLqUJT58e1dsYlsWDYOVRP8/KuhYFgJI2RyPXypYHgJIHgVH/AB6V0fBMDhAAQZj+VaRiZSfoHAsCkJEGZM8+VX3CMI0IT4aGEYSAkSkzO+3pVrw+wCAAU7DmRXRGNEchsrAICQRsQTtU1b24SBPlTGLYJCSK3kJA5if0rRJGQm0BOxSZO58hTynSQR58UTsrdZNDaCoz/hV2A9JMlato4FIpjcceUUEmRzIoAyZn23pPdgCSDuIPA8qdJO5UfKKUKmASQPPageJo4AcQmOgPtQIBUJUfpS5+bikRBEbiKYAIO1EbABY2oA7CTvSHPn70rAQnUQBt0pEk7CkPPV96C/CASRB5nypAJx/SlsFCAVnTJJmYmiJPWo+0vUYj8Le2pQ7ZvAuNOpUTII5iK3tx9aBy2HDafF+nShwTAjaKUiYO1AmduPWnYg8bmT5RRSSVQTv1PU0ICTJNLc+MjehruA4mQT1nisaynaRTtyNRHNLwkbiT6VV0A47H0/hSEEcnf0pqVchVKCVaQdvQ0gEExtJH0ikZGqDvG1A7DUJ26UZVE7f7qLAPhnc7j/jmmqJO/MnzoqjgHagCRB59qV2AYJAg0lAnbr50golJB4FKVcSKO4AkjcH70djv1pHUQYANAgaeNxTYCBAoqECVDY7c8ClsYA+lCQREE0k6AXi1RPrt50kmZ0piOaEgCEnnzokgyZ5osAzI9faKQidxvTUggD+FEHoRvTTAPXSeT06UiFTHNLaSVff0pGCZHShgACEwOZmlCjvO3lSngq22mkCFGZ3I2iimASVDg+e1Ac8+tEcAHk0AImAZpgGdRPi+nSmkkK+VPpREqG9DSAJ+1C2APhSNuRuKRBHBgmkrkyd+ntSPPpHNDqwB1MQB1o7jYbzSBPET50o2KiYoAIUOtNkAwd59KBJT705KhAgb1NWAgoEbkem1CRM9TtSOkqMClAT4iRNPqaFQU7xIAT0ikQlOyRPrTdyfCCJ3oggpgz7iixgClAxNGJVA68mhHkd6PQAbE/rQmAvER5GhE7Tuf1pbRB3oz5SI9ad2AiBsD0FNmSdR8I5FHUDPnSA8wd6AFuE6gN/5U0kEbbj1px0jaYjmaaQJkERQtgCmSoBKdgJ+tR2LwLrC1FIP9c5PIlCuKkBHIMeW9aeIqCF2JMeK7SniTOhXWknTBqzeC08RQGkbikSVJATSCdtwaaQm62AJKwAOtPgjamKEfLRJjZUz6U27GKU6htO3WkSNiBE0iqeOf5UAAdzPMCprcE2IqA4NKCev8aBOx24pSRsBTAIMcUiQDB6bUiOR1FDoJEmd6W4BMEEad586A0iZPO23NOlIPye9NKRsRselMBGCUhXQb0iBwOKOxAURREzvsI6UAxsJJ4ogETB/SkAATsJpBQgTSBBIkbqmKEA7zvQG25B3pSdQhNABBA248qEGCI3omDzFIx0UaYwGab8pB/nR1QYmRRO4kEfWkIaqJn+dEaiNz4eopEFW0cikflgfWnYB25nfzocknyoAkiI3FOAPSPvSsASZ9ImjvB9eKaUmYPWkoEqFHUApKfFEk04mR6nmkSYjT1mgII2osF7xEmACZjikVSPSlMQFRBoKk8DaiwAEpndO9O3AJnb1pKJUSRsBtSCjpIIoAAUT0pTHG5HnxSbKVbcGgqASIO/WiwasJBMkcdBSAOx60BztxRTAJkGgBGQTPoaBOqZ1QeaMDxc7+dInaQIpgKD/AHjTTGrcURp896WwVB60AAmONpoqBJ2EUgN+D7UCSOtANWEwk6RSABMmgSSSaJSBEGgmMekBnkedAkkU6SZAHFBKiD60WOt7BHJnY0uNhxR2gAEUAI5qbY6XIFClt13okb+lKQBEb9KLCk3YjE6uR5UJIVvxS/hS4O/NMBxMAUAOmo0DKvpSO8xyKPiDdG8oyT5UtISZ/lTVGDvwaIKTEJioSK2YQd507UCmTIAnpSA6k9KQIG3E7+tMQwhQUJiCKaEoIMCssTG0ikB4inTtwKBGstqY4rC5bSQEjY9a31IUkyUz0imaROrgCigIp2wCgVaJnyrSdwxHlBO9WJTYJ0zA8qxLth0APlSodsqNzg6VST5xEVG3WApM6E7H0q9Ktk8FIB8orA9ZJkS2BIJ4qaLXBzS8y6FEjSfPr/jUDfZYSZ8BP/HvXW3sLQpzZsVG3OEa0k92AQeI/wB1S4odtHFL/KqYJ0Hg7f8ABqv3mUipJAQY/wB3vXd7nAUnUSnbpt/uqGvMuJIJ7sHnf6VDgilI4Bf5UMlPdmOevl71X73K28d2T/3f99ehL3KqVbloR5/T2qBvcpIk/lJ/1ahwofUef7jLzrLnfMlxDiJIWglKh9Zq3Zb7aO1/JtuLKzzM/f2SRAtMSHxLURwAoyPoauN7lHTq/q569P8AdUBe5UkH+r/ofL2rHJhjPaSsq0dCyZ+L3DbZpOHZuye5hqdUm4wdcNlR5JaWTz6Guu4P2q9knaM38K3juFXbqxCWLkdxcfZWxPtXkC9yssH+xAB42P8AhUHdZXUlRhs8zsI/lXBk8NxSdx2ZVnvZOXr/AA9KHsu43f4U0lMdypfetHy2VwPaKznEMVubTuM35KscwNLEl+wSAVJnqhW/2VXh/LXaN2oZHKW8BzPeoYb4t3j3rZHlpUOPauqZY/FzeMuIZzxlRBA//WsOVoUPOW1bH7iuHLoM0N47iUa4O7W2WclIxUIyNnK7yziStxh76zoJ8tCv5Gpi8TnNq3FnnfKVtmTDgCpd1YgKWmOukmftVWwHt27HM+hu2u8as0r4FviaQy6CfIqgfY1c7fLjbHd3mSMw3+HtkghlKu/Yc+hJgexrialF1NNFp17yu2mEYDjbrqeznNyrO7CQXMKxCVBKfLSfEP1rFf3mMZfQtzMuW3LZLJAN5bDUzBEbjkD6CrVibF7iSizmvJdhjFtpBL9krQ/qH+bsfsaZh2MYMkKZsMwXNg2lPdfs/GG9KT6BSvEfuatScR9aa9CrYWcKxO4Q9hVzavPNwUavCSD0CgaruaMnnE75xGJWrt1rBguIAebiZAI5+oro+MZLwHEGhcXGFmwu3hCX8NXISD5Acj3FQT2Wc22cOYdibWLWzSCn81fdPpV7cHirjNci6n/VuUA9nGZsvMW+OZAzCpaF/NZ3MatQ5H908VIp7SsIbxa3Y7WMk/BYkwNSL9lvQqP72xkfQmrvY5vwdLQw3H7W5w69XKdDzZSlRB+YHrU4xgOEY9ZLS+3b4pbEmUqSFEDrtJpOS7mkYL+kjcIxDC8cR8fknN7eL2uo961cOS4kH9wK/wAQaic2dnWTMVtXW8TwBVgi6JKzoCdav1QfqBURmT8PGE3Dr2L5OxK7wS9QNSG0Spued99Q/Wqy3mzt37MtFpmjDFZjwqAFuo8akI85Snj/AEhTgk94sJq1U9ynZ3/DWsOF7Lb4aWqC2yUxqHtMH6H6Vx3MuRcy5UuXEYthyglrYupEpj1616twvtlyDmv/AJuTdP4IsqhSbyGm1q/zSrwn6Gpm+ttFnou7JrErNxPgcbQHAqenp9K3jKXc8zN4dgyu4bM8MpWgqUpMwTBPMHyoKKXFf2fA5869R5q7D8oZva+LwQN4XeqXCkJ4SrqI5+4rjmbuwzPuVu+uV4ebu0bMJdYE6h7f4VopJnj5/Ds+HerRzsnYpAHmfShpDm2lI4jas7rS2lqtnmVtOpICkqBCvqDWNxCgSpWkelUcHGzHpUdCZUFDqY3pOHu16HBGkSkTWMLRsUHVI39adp1DvCZPkdzQAwoddcgrAgTzIpOICVhOkzG48vWiRoSdwlQ6T/KgorCdaEjYapHA+lHOw+1GUqcCUpVI2kCZ1Crjljtezxlm4W9h+MuLeVaixacfOtxhgGS20o/ICNtqqCU60DfTt13mmOoIlwEJ6bbqrLJghmVTRpjzTxNODr4HS+0PtJyZmK0aTljJmHWC124TdByzBdadG5cQ+FalSZ+apn/7MedH8u2eP4Ri2F4k5fWJxFFvb6yQ0ACQXI06t+CRXGCqJJJEDY8VIWeP41h9uq0tsVu2mXI1sofUGlJ/uqSDBBrmlpcuKKWnlVeu9nZDV480m9TG79Ni95eyf235Hwe/zllvAsWwywu7Nds9fJbSEllW5AMz05FReI9p7jWVrbJ+X7FzDbS4SlzGnkuan8RdB31K6JjhJ68zWTN/a9nTtDetLDMePu22FNttW4tbVEMNtJ2kNg7mu8YTkH8M2NZGbs8LxFu/v2WFFpbSv+c7y6IkIQyVTsf3YNcebKsCUtTC2/8Ar/c7NPheZ9GllSS78/oQd5nS3tP6J5CyTiVhb5TzLh4abub8KdXZLIh5KoUEqOrjUKkM19ieQ22LbC8aLNhiCkDubi3SizuHEnYKKCpTTk+Q0muK5x7F+0PJGH22OYvl66YsLpwoaWSCW1TshxP7ivTzqJyTnBWTcc/b+JYQnGbuzaWmyRdKUW2Huiyn97SelZx01x8zSz3NXrHFvHqsZZs5dgGbcq3jVraXVrizr7aXRaMGLxptRhJcYJlM+k1zvHcIxTLOKvYLjFo7Z3dsoJeYeIC0KI6xXYMBzjYG5t7rDcz3OI9oGb3e5vMUuBobwptzZSW/764kT6bVcMaxbJmBotsjYzkDNufr67d7i0vcVtzZrW4DB7hekrWkHqSata/UYPZyq/oZz0GDOuvG6+p5kC0oWo7FpZEj1rA4E96pJUAATzvXoXO/4XMQYxS3tcrNYhZ3Vxb/ABNzZ4jaudxaTvoF0lOhRHrEVxvMuSM0ZWcBxzCbhhnWUIuUJ1sOkclDg8J+9ehp9bg1H5ZHnajQZ9M/bW3qVxZSg6YAIER502Vr8Ko0/ug9KzKbISRqAKTuJAJ+lYXfAIKIJ3C0iNq7UcbTXIEKQsQpJCukdKcCw54XPYU7ukrAUFCT8pJjem90EiU6Uq6pKp286BAV+YsFGx677igO8cBC1/LwSdv/AFp2mVakuA+cmKadOsfl8DeTv9qYBTBGptwEnkelZWFNFWt1PiHBpuslxGlKklXzQIFAEtnUhRBUok7UALQQguJc32MjafPanDxgrEwrYmNppFtvUAgadtjO31p57xMphWkjjpNAWEFLfJClqTv0HtWW3Skr1qSTJAgeXrTWkIcWhJQQsmAkCeeIrueSMkZd7Jsrntg7YlBtloBeFYUoAO3LkEpJQd+nB2FZzydHG79Dr0mknqp9MP1foauSsjZW7NMsDtg7YQG7FqThmFLH5t65G23Ucfzrzr2vdr+Z+2fNKsbxx3uLNmUWFg2o9zatHgJExJAEnqaHa92uZm7Y80uY9jThZtWyUWNi2r8q2anYAeZ6mqpa2uoeFImJ4rp0+ncPbnvL9j6nHix4IeXi4/cNnbFUGJHSBVhw7DFK3g8eVHDcMKyB3YjfoauuC4KVAfl9PKu1IYsHwbUQNO+54romBYCSUkI8+npTcDy/JBDR4PSuj4LgKUpTDe+/T0reMUZyl2DgmBgJBUgj6VfcIwlKUjwjjyPlQwrCQjSO7nnp6VbLCxTpTqSRGxreMaIbFZWAaSmE9dz9Km7ZiUweDzTbZlAgcfpW8hCUgRtWlGQEJ0k7bdKeEkjxAEUUpmY2peKIj6U6EEkE8UgCEnxAfzpECefvQJPMgjyFABSBHiWD6UNxvyDRgSB1FIkkyBAFAAUVEA9aUlOxgg0fCdpPsKUQJG8fegBSokgA0QCE7k+ZPlSlKj5GKbBG8EigAkgkCN+tKQDsKE7nzoJKZMHegBwgjYb1juVIZt3Hnd0IQTA3PrWQecH6VhuUh1pwAbFJ2+hpMqKtkNla3cusLwd9TzrAS1Ljb3hiU7AJA2FT87lJHBMGojAmw3geH3F1cFLgZb0AoAEkSRqqVGqJURO+xEEVEHbLyS6txxJBgmhAMkySKBOoRp460RqT4pma0MhSQIKfvSBlJG9ApAIJJ2FDY9dvWn8QHGeu000AzsdqIJBCQob+tKNjKvekMMk+RHnQEggCJHFGQAAVA+g5ocGfOmg7BKtJHB86aFEngD3NLcEKA2owVK255FHfcBaUTpiI+9HdPt0FIp31K54pu6t+KQg8bk/SkSSDttS0EnUNxTiCTAMg0DoYFEbgyPOncgSYJO9CJTEb+VIJ86fUmIRBTIjjcUPlEGSKJBJgcx+lNCjBlQ24nrSGgx0iCTQBTJnVsfKnFckDrHTpS5UoDmetAAMTqB2ikZ5CVE0CCnZREzwKdBSR8xoEDTJ9OaRA1R0iiQkb8kCBQ1A7af5UAEBKjpjakQBuNqSY1TIHpNBRG8iPKl3odBG0piYpCB13Ik0ASTMxNBJA38qtsQgFGKcSUmNqPKZA5psJgk7UgDMnSUkgcUipMxBA8qCioEgGaWxERvSAQ2mRINKI3TtS4EcUhJBgSfSnYxLAHO5pAlQgUCDzuRTkcEmB6UWIBT0Jkjf0oTIk7ilG+6tvOlEkgcAdabQxEQQdQIApBKRung0Eg6effanJBiNPsaOBCAmQkQaMHTO21DfkHb+dAETBNF2ADsNe8e1EQese9AqI9T6UOZJG9ACABnfij4pEHbrRB2AEE+lIkgbpE+lMdDCQVK1AmTG1HZOxHNFCVARFBQlczJAg1NhQVFIA8NaGKpSV4erxbXqSkgbfIqpAmedjECeKjsXuW7ddkhy0uHlKuR3Yb/6tUHxq3+UDahhzsb4BgAGKQUQDJoJJO4O3nRgnaJp2IPI35oGSd+aJJjfgU1PWN/5UxhCgOEiaREpgCD0oFJBJAk0uSSOgpNiEQTEDihuduvA9KcDAAHlxQUAZgzSQCKiZJgE9aQkkEEGiEkRqjfrQJ8OkHam36AKZUZJ2G8UuSN6Q8MEUSmDqj79KLoddxTEaeKXG/NKQSQBQGoGQeDx1oTYhwAVuRvTTrHhA2HFIrVJMbDc0SkzMmirHTG+JR0gzHWnExyabBC9qBT9aYgzPvRhWnf8AhQAJEdTx704apAmhsYyJGoCgDJ42p3/eoCSDGwqLEGSKEEmOhoGetIK3p2AUgfNt7c0FCBECnqJ586adj/KjuARskCgNXO1BRVAkbUfUUOgCVGaGw2PNAGaBKpikA4wACOaQIjYClGwnmgPmCfOgBAkpA4JNIBZ3OwFAneSmnFRPJ54ptjCR+8IihGrYk00kARRCok1LDYUfu0k6QQkijq34O/nTSsiPl3FUnQBJ8UDjpSUD6U1JPmDSmVAGi2IJ8wNqR+aOTyKR+3pQG3FFtgHcnwn9aUck7xSVsYHNEadO53ptjBM0CTECj4QQCfekYnbiixABKeaR0zyaRmJjakNBUJml3APh8qAM0OT6UOFbUuAHGdopR1J38qBBBpCAZJimmAlEciYpeo/WjJAgDbzpK8vOnYATO80jG4JpDbjjrSEFVS9wN0AR4hB/jRiPFHPNDVpIAABoj5J4kxFSn6mnShQmTq5oQEgED9aJ0mZO1AjokSPM0Nir0EJSedvKkR+8BJopgDc0hzzE026JoJEmZ3ojn0oAhJIH286AVqPEA9KmNFJeoAkkkk7CipPhlPNEK1JMck70iIHp0p2x9KMcKSN+PMUCnUkqO1ZFSOOlAhK5G4FNMlo11MyOJHQmsLtrImB9a3gmACnc0DChBHNTbZTiRD1ik7lIkcVqu4YFADu/fpU8pqfDvHO1NU2giFUPcSTKo/g6FSNO3tUVdYEhSZLew2Ph/wB9XpdokjcVrLw8LEaeftU9KfIVJHN7vLaVJP5f0j/fUNd5XSdWlr6ee3vXV3sJQqTprQfwYKP9nScUUvecYvMqI3huQTtsP8ar97lNJ1eEfYf413a5wXUkEI9ODUTeZdIBPPpUyj3Ks4BeZURvDYIB6R/jVfvMqJEygD0geXvXoS8ywVAy0VGoG8ysTIDWxPrWVBGVnnm7yyUkwgg7cf8ArW9l7N3aDkZ4O5azRiNkEK1BsPFTc+qSYP2rrN7lRUHU0qJHU1Xr3KagVQ0Z9z/hWbgpKmi0yxZY/GZnnC1oazhgNli7aQAXmIYejzjdM11vBPxL9iOcrUW+O3ow150gKt8SZkE/6YBFeYr/ACmvc9z/AB/wqv3mWFzHdeQ6/wCFcWTw/FN7KvgVzye/MMwbDMQbZvMmZmXbJ0BTRs7gP25T6tkmt34jNdihKcUwO2x0Ewt6xX8O8B5lCtvpNfPDCn80ZTuU3uXMUu8PeQNlMOFEekRBrqGV/wAWXa1lsNW+OItMeYb4Nw2UOx/pp5P0riyeHzj+R2Kq4PYF3e5VxbTh+JgMLBBDGIW+hST6KOxPsa0D2dWverucuZhewpxapSASppR9RMgH0JrmmXvxf9meZm2rHM+E3WEvL8KzcNB1mf8ASG4+1dEy/fZHzC2XckZobbSk61NWtylSCfVtR/wrjlCePaSKtt8Gc4nnvLyXv29gn7SYaIAvbEypSepKea27bNeVcxNJYaxJpLxRu28goWD5GsDvaHiOVQ6jMFgzdsySm4tFaVpT6tnb7GixjfZL2npBbxHD1YklOkDWGbpv9RJqVFPdmry0is5x7JcuZotwL3CrRRcP9sxCXR5GQIV9RXL8Q7N+0ns6uEO5GzO6/b76MPuDKAn/AET4T9INdxdyFmTA323stYy3dW0Qu2xDk+WlY2J96isSzHiNhboZzZllWHoS7HerSS2VdDrBiDWkcjJ9ma3Ryq07Yl217+x+0bJVxh7zadZvmQVNnboB4kn2Jq/YNjOCZssnHcrZrt8SZUj/AKK6oKWCOm+/3Fb2LWWFYywu4bcw9WoQEd5qCh5EHY1SLjsIyvjbxv8AKtzcZbxjTqZXbrPdoX6CZSPvWvVSsSUl+Xcl8X7Lsh53txb4rbsWt8vYuIbCHR5wrg/euP56/CvmnAkKvMs3acUttQCW4hUH1610lwduXZ24wxjmFsZrwoph55pP54AHMxz7j61cMqdveQMxWqMPcvzgN/q7tNrfeGVgR7TS62vybmGbR4cy/wCSNP3Hh/GcuYtl+9Vh2N2D1q6g7pWk7fXrWkElAIWn69Ir6KYzk7LudrHuscsLbEWnhpLzfMec81w3PX4P1XPeXmQMVaIHi+FuDI9kn/GtI51wzx8/hGTH7WN2vqeXo+VRSmCdiBTFKWgk6TEwPrVnzb2eZwyUtaMw4Fc2yG1Ed5olB9iKrRTP7+59J9q1Ur4PInGWPaSoMxDapVG5UP40nV6QVbwrZI8qcggjRIVAiRRU4hsBK9KtuY3FOxXatGFaEfMskGYPmRTzCzoKdQ9TuaQeBBAVJH8KZqhYWoHUBE06AcSQTpJCwdgOorLZ3b9hcNXFs+6w60sLbdbUUqQQZBBHWsQKlJ7zWCoGJiKSNKlEFRKh0molFSVNDTado6RgXb/2gYfc2ruKYkjHUYelz4NGJgupYdV/1oTwpQ5Gqa6lljBMs/iAwG0Q7l963v8AB2nHb2+ZLDN3ityv/q9IhKUjooivMagpIC0kJjmRvWS0vbyyd+It33mHFQNbailUepBrgz+HQkrw+y/celh8UnH2M/tx9DteNfhuvMPzN8FgubLINWbZvMTfcMfsZAEpS6tMpUuRACJO3FUHGc39ozGI2V7dZsxm+RhLp/Zt64t3QNzC2tcETFaGX+0HNGVn2Th+JOLtxcJu3bN4lxh50HYrSfmrsDf4hcr9oNjZ5N7WMsotsGbdXcv3OGCHVP8A/VgCPA3zqArmktXhaeWKmqqzoUtLni1ibhL0t0Vl78TfaHh+T2suYLmfFBiN0tT2J4jcvd464syEpbmQlAHPrXTuxTtx7IsWwxHZtnHsxUo32jvHUg3abu5/vFvlBJ3kVhwnsT7H+0DBXsO7N8Uw++zO+z8R3H7RWLeyaB+bdOpSoiUxXJMd7PO1LsVzkG7K2uRiVq2blq8w9KnglBEFQIHh+tcqhotVF4oXGa47M6nPW6VxnN9Ue9bnRe37APw/5RF/hmHYe6nNF00CbfD1g2uHKHEpV1UOQCYivNagULhwahMxMjes13c3lzdv3OIuuPPPLKnnFySVepPWtc7gACCkeHfpXseH4Hp8SjKXU+75PH1uZajJ1Rj0r0HuFlA7tvWqTIJ6DrWOUoCjAhQG55gUG0qlXfBQJ8qKVFadMaiOh4NdxxDUplZ/MIKhsDvTlFx1fjkr6mI2oAFwSSBA59aJWrT4RAH71AACwo6NASQOfOikBStRWUQIB3I+1FXdOgSmHD16Gk20taNZkJB3070DoCEpdAAJ1TOoifpWdDa3zDK9RKgAAN/YDqaNu2Xn029s2sqJAQkDfVMQPWu+ZLyFlnsSy4e17tZdSLltPeYZhRgqU4BIkHcrn7VlkydFVu2dek0eTWT6Ycd36fyHIuTcsdjmWR2udsCWkuNo14ZhJALjq4BQT5knoeK8xdsXa/mftozS7mDHXFN2zct2VkhR7q2anYAcE8Sab2u9rmZe2XNLmO464UWqDps7NJ/Lt2+gA/vetVS3tSvYjmunTad4315N5fsfUwx48EFjxcfuG2tipXFWDD8NKoJRM0sNw0qUk6D16VdMIwQqA8HQ9K7kgbodhGDAkAt7z6V0LAsBkJ8IHP8AxzQwTAFFQPddT/xxXR8CwQgI/LGwP8Pat4RM27FgeBpEED+9zV+wnCQgAhAPI/SjhWEhKdPd7kn+HtVsscPCAJTtM1ulS3IbFYWMRKfoKmre32GxmaFsyE7zFbiEaf13rRIzkxNtQPTpWVInnkelJIBOvfmNqcQZ2NMkAGkyY38hShRg6QoUvUn0iklJ/dj2osdMRIMBJO3SkTGw3NBUwNINDcCfvQAYHzEbmkNMxFEGSCaJSnYgGk6BISSIAIihpSTqB2FNnxGeBR1Sd9hUtDew4QDCh12od4Z26UUqO41b9IpunfSQDPNJc0wSfYMwJ89qUaUR58UCNPhG4P8AGgrSgHb2q7Fyxb6SkcnYViul91aXLg0gIZWfLYJrKQQP841q4qWxhd6lWrT8M6NvPSal7miVbGllZ64OBWDQbYDCrVqNOpStgNO+wqYUSPFtJ5HnWhl8JOAYWQdjaNTAgfIK3zOk9B5xQo1wKT3pIA5hRk9fKniOBFNJVI6j23pEgkAbVSfqLpQiCNoEUyCANuBTzMg+dEDfURtFAKKGgnTPWkCR7UZE+GioEpk0twcfQYSR1mnj0Ik0zSBM9OKJKeEmNutUSlbEfIyfWgAmSDvI8qJ6dfakAZ4pNj6WFREQnf3oCdgIFGZiaYqZlXn0p3Yn6oeAZgx9aChB0kADyFIqng0kkzPWIoHYiIGxP1pExuJBpKOwEEUjvSE9gbepoqAI3EmkAAZV+lLgUWNKxREDqNqM9OaA8/MdaBHMHjelZXShAnaNiDvTpAmEkE/8dKbwY60idpEmPWnYkkuRxGmT1G1AJgEAnekVbQJ3NAAp33imKhRpA2EUlTwU8UlGdhQCgDpJmaBK+BwSoJ1GJoADccDyok7ykHnYUvETBiDQ2U4rsISRtHlBFNEIM9aclWlUx0ppUCPP3o6gqghfQ0CCSCeBxQ5Mx96cFAiCfpT6qBJMBAnURtRIkgcCgTKdh1o7A8EmpbFSQgkxuaWqeDuPSgNQgk0ZJJJMbEUbjSQVFOkyZ6namkqmCN6PVIIpCCoSdqvhDatUIEjzG8c0Ttv+tKFJEEDnegVKTIA2PnUkO+4vCR5mknSASRvTSowPtSBOoSkEUg7hICZmmwQdR2ninElPtRmeBt0oW5TigCRBnrvTN1KinKiISfehE7pFMTQY2iYI5NEAkTpG++9CAmAFbmiqEgapn0pX6BTQCdjBj06VqPLCVNa08ugD0Mc1sFQVOqQOK1cT1IRZGP8A9bQN+gIVJ/hQ2L4G4SEwRuKIUmmogykbkiY8qcQkD5eKa2HuxFW8CmLUTJPlRjV1EeXWnEHTpBoFTYzUYB8qXHi60/THG4oBEbeZoVWDTAFT13ogA+IGDwaBTCtuaUdCigS3ErxGZoBW3hO1An90AxT0pEe1NBXUwpI2gxQUDJk0CNKp39hxS1b/ACkUMfVezCUTx0oSBwIpu4MCaKjPhApIKvgcmCfHvttSJQDJoJBiTQIB56UPkptocpAHqKZBBG8U9KhHin2pfvSeKVipcggFUqJNFRPvTSFajHFApIT1kUwuh6lIB3poKZ3M0kjmOgnegQRKtqBXYEddOxoRvtR6SPmpGQQo80CCedvpQ2SY8qcDqSPOmbg707sfax+oBM+dIGdz96ZIPvROrmNqQhytuBsKbBMkceVIL2/45oDVyfOmA9A2n6U4kESQdqak78GIpEkpOxpd6KVVY3UASZpBR5O4ocb8+lImelBI6QdwKGx286CZPFKPFFDoBCR4fKjpo8DYyKUxUuXoOKvkBA4AoSUGTuKM7E0ZBT5+lUmx0hlKYpxCQJNAwR4aBB1Ap33NMAJmjJBgg/aneHrNJugGgHgiltIPBBomCYND/umKYhbp3MyaCgqQeKO4Ej9aStREwYFAC4G/T0pSDzQ3JjmhOketHKBqx0gfLQBmZpGAnY7ml4ZB3jrSQPkR33PPnS9DuKKp6CkJSJjcUN0FggFUlIiOtLqFRxS1atjyaET12600wN/whUAb+dNA6yeeKQkg0gVDYqFZWbBXH+4UJjbcJ86I55H0okj5SOaadEdIDqIgkzRAJTIPFAnYmZPpSAUBv03pvccVQCoJ3O58qeUyJiPpTZSBJB9x50to3JFTVDYQowRNAlXkIpwUJJSN/KgQDuVRVWxJsR5k0Jgjz8qdsIkdetAAGTEE/oKaYOPcUmZImkDt0iiRAjqaATJilZQiBqkdRTdAPCDT0gEDzikROx2NDQDEjV4ZH2ppSmAoJ24O/wDKnweAfCODRIlPM1NsDCphKgf0rGu1QRugEnitjSrT8sRSAXsQmTTSsDQctAqQQfOtF/D0FBIRO9TmkSZFMdbSeAAPeh8AVi4wpvUFFI26RUZdYK1xAA54FXRduo7pmDv71jctgrkKFTQr6TnNzl5tW4Rt6gVC3uWmysggbc7CuqO2GoAgkgc1pXGFpgnSZHnUuJSae6OOXmVW1cIHnwKr13lVBPyQAR0FdyfweSRpnbjeoq6y+lW6kKkcxNT0jOBX2UxyECoC9ysJJSnYbdK9BXeW5IVoJB96hLzK5UfCCN4PNQ4DTo883mWACoBA29q0ba0xbBHlP4PiV3YuqSEldu8UGPcV3W8ymo7aCSeTBqBvMpuEwG1CY86h47RSlRx/EMazpcpUm4zXi7qTt47xxU/c1BtvY7Z3ib63xO4S+g6gvvCTP1rr13lRe4CFQem/nUS/lRZB8Ch9zWbxL0K5NzIv4ou1bI60sP3wxOzGxZfMgj6zH0ivRGRfxl9nuY2DaZytf2U+qAQpJW0r3B2ryw/lNwyC2o/Q1HXOVVp5ZV+tc89Fjn2oVJcH0Aby12cZ/YOK5TxRu1fuBIdw99KZ/wBJoyP0mtdeVM54Fc6HrC3xqyQmUv2y+4uQB/mzCj9fpXgjC3My5ZfTdZfxe8sHUnwqZWoRXZclfi+7SMr91aZqsmMds2/CpRT3b5Hnq6muHJoMkfyOxqz1AxnDDQEWT9xdWrh2NtibRaXP+aTsr6GqZmPs1ynml/vL/CQsBwqcShErSfMECYrFgn4mexztKS3heZ2v2e+ogBrFEJLYPkF8T9qOP4lZZeT+0Ml5ys0JE/kruUXDa086Z1SkRXMscsbpqi+tt0yvuZPzh2evd92e5mufhluhblm/LjPsUng/arHhfa9iOHtlXaNlC8si2vw3+GoK2lp8yOU+29c9vPxJZRtcZOHZqdVYXBIl62Sp5hwzuSpO4+tdtyjmPJmdME+Iy9j+H4gw4mXGkPBwgnzAP6EU5RfTugj0y/K9yVwzG8l9oNn3Ftf4djbbiYcaUU96kHzHI9iBXMs+fhbyNmV957Lrq8GvV8p+VCiPIcH71YcU7GsuXlx+08NbdwnE1HU3fWay0seUxyPSg5e9reSW5uGWs22CSCBs0+keh3CjWan0rZk5MMcqrLGzy1nb8P8A2iZKceK8OVfW7a4Q9bCStPnprm1xavW7qmrtC2nE/uLGlX1mvoPhvahlnMYThWJuvYPeka/hsRb7vfrGqAT9ar+b+xfIOcG3Ll+2a70KKtaHACoeYI3reGVtWzx9R4PGXtYXR4SUlKmjJAPkORSMITtuOk13PN/4XMxWrjt3lK7ZxFhKtSWVK0uafIHg1x7GMAxrAn12mKYZc2zrailQdaUn7SN+K3jNM8bPpcuHaaI/Qt4hLRA1nceVKFtr0BATpEjeZoEt6NJJ1zyR4Yp3eqSEynWATx0qmZDdlLTKjvxRdQ0FKAUo6gOvWgU6/kBAncT/ACpwaUiAE7kEA0ILGunwgLkT+hprbaNZKiClQ5E708OOLBbGmFb6T/jWNsFGySZkwKKGb+FYniGEXqcQwm/uLC5QSEOsOKbWB7gzFdf7MfxNZp7P27xnE8KtMbTiBPxF1cKWLhaeoK53jpI2riyisgr0yU/MZpoKRqDepUifaubUaPDqVWSJ04NZm03/AIpUesrntO/D9nnJeO5Rdwo5cwm3Y+ORcKKfjru8O8JgHUPOTXkpQQp9TjLilN6yEhXzFPSfpWTQ0pshYII+UEbzSCUpGpY3jyistFoY6Jy6JPfsa6vWT1iTnFJr0MWsrnUjSR0rFpEkpgK9TFZSVTpbBg7kEyaK2UEBYTpI5Brts4DGGglIIMhXSkJKYI28qeCGjCdyeUzAowAoBXy9dqY+w1tsyD4Ynwz51sJZuH3G7Vhs964rShCRupXkPP2oMsPLeDDTZUtZ0oSkajv6V6ByNk7KvY1lxXan2qrZC0IDljZKEuKUflAB3Kpis55FB0t2dej0mTWZOmK27v0HZNyPlbsNyz/yqdruhF+2CbCxVCiVEbeHqrj2ryx2t9rmZ+2XNDmO464pq2bJFnaJUdDLc7befmad2wdr2Z+2XM6sbxl1TVmyVJsrMKJSyg/xO1VG0tlKMDyrqwYej2pfmPqoQhgh5WJbfv7xWtpuEhJqw4bhswSN4/nTsNw0qIGkTVywXBtQEInY12JCboWDYLqI8A5jiuhYHgKSkEJTwocD0p2A4CrY90RudzNdFwXAVBIhB453rVRZDYMFwEGDoHXoKv2E4SEJACeAeBTsKwkJSkGZggGrdh9klKN4Jg10QRmzHY2KkkCN5/lU6w3CSANqVvbgTHIPT2rcQ0EBMESDxWgmBA0pAUkekVmSPNJIoEajJiioifm+1OxJC2CY4MzsaRng8Eb0CN5jYdT1pFY6EGeZp2T02GBIG/pRJKVQnYdfOmyVQBA9qMSf4mk2uRtOhJV9aUyYMAGgAQrcijsN5pP1H07AJg8GnAkgkH6Uk+LbryKRgkJAjzmlYJVsAlKvl6UANtQ9qPhSZG3rTZO4p9QumxxV029qR8MJUPeKBICuYNGQN+ZprfcpA1QY69PakQlatuPWgSNXzbjrQUREjgcUmFBSZUT5VrY2085g76LdSg4+062COkp3I9QDWwAQNuTWRCrlT1opNuhxpJPhKtOrxDV0PlFTdFLdkZl9rucEw9ELKBatQV7q+Uc1Jak6TH60Pyy4SGg2jUYbSZCdzABoSB6pn61UfeLuOEgSaZqElRBinBe8dOlJREbjYmh+4AGFAbiImiDMbRvvQJ0xO48/L0pQSOgquxKVDvAJiaBgpiP1psiYKT70T5CDPJFSmUIGTO8/zoqBPiIP1oSSIjnmjuU+Q6j1pipIAPQe9Ekkk9abIHG9Eb+KgLAOJJpQVbjikk7QftSkyd+nFHAglJkAmaHoTHtSBMfWhAjg0WwXIASSNf1oiBwBNISdyPegBMkGi7QunceSNiJ9aQJB3ifLzpo8Iid+D60RqCeODv7UlsUhCdwY3pEgCCYpIncJMmkQPrQMXKuoHnQI5006JOkDpzQCYEzuOlUiWrANW5p3jEb0pgeYpAgpJpWNKhKJJ3im6esU6B1iKB2IAJg07E0gJlNFJIVPIoQDMdDSKt/COKlsEmgq1RvxQCvCaPzbySfKhA/e2pvZBW9hBiT0oGQYJ3pGBsDIpEjpvQhiA6A05J3kfrQgHYdKMjYDf0oABJ6ARQSZH+NGZ3pu8AR1oVIT2CRuDPFAgwaUp1QDv5UiVRsdqoXUOAHyxv1oaOvT0pQZO4PnHSj5iY2pWgq+RuiDqBPlTjpBnpS3EeKfpQO8gCJ5niixpUEkHYikIHMimkSYmlpMyaVlAII360U+h39KSlSYJ6UBuDIikyWn2CE6lE7CaMSYJJoHbw0UkJ8NUuB0AgHaBtWriKRoZKlb9+j7VtkgbVqYgEqbYJJBTcIKeOZ/WhhSM4KkqiekinKUZBEUdAMQNxTeg1c+XnTRnTQgDOoAUdyJP6UQD5AUuAYoKVjkglMnamFRBgEE0/VI24HBpnJoKHbkSetMcVB0poqJHJ2oCCZHNAmIAjYRRgADczR0gDypRI3GwoEo0NUCYKTSg+e1EjadUCaHhPWgOlLcdAmY2oLI2PlQUSneNqUFQ2oBu+AJXK46GnKOk7QD6UzrBI8PPnToj11bb0ibtA2kkb0CSsxMU4QI3FFQIUDG1MfTYAQOOm29KfWkoAGSdopghSSRQDdDiolWomdoo7Hc9aASrTAoQokAigkcQR+6SI5psyd6crmZ42pqVDilZSjYQAkc8UY1dB6VjVyRuN6dqIgUxJ9mODe09aUQINDUqdqPI9aCkkxhBSdh96Qj5VCetFUk7ikSk7kQRQSKeiSRSMqSCCKbJB9aHQq6AUmrFdcDhtAO5jc0YAJ22pgjp0ohSgYnnek7GnfYIIJ2oTSEEk9KKQACeaaHuLaTS5MgE0YEyabxuDQqWxL2dj+RGmmkaTv18qQXHBknpTVEnj2pjdCUZNOTuNyaATvBp/hG80AkNKVbwo/ehBKd1SacTI8O9Mjeal+g2rCE6jHlTlDbY7UAIX19RTXNydPHlTSoNqHQIjmmjcEnp0opUAAZo8ciKKBq+AASNR5pJQk+IzQVAOmaWojadqSsLQYTJkUDA9qR1RJoGCAonilLkT9wUgABVAmTGqkdSRuNqAAJmhbC3DATvMmgFCfYbUgASQeKRAnw/eqTTA21QBtuRtR1HoYNFIB26igok8CszUWmes0dokcnpRGsQI6b0AACArk0DHACCQI3oH5T5xTY8jNOCj06c0WAhJQKW0wOu/1okgiTtQBIPMx1oe4qBshXhTwaI3Ow3oAwY6DmhKpMbe1FDHeGYUJNOSQEgk7zNN7w7AkK96B3459aGAZ8XNDVzJo6T5beYobc00HYckzx9KXj3J5HBoQeAPtSI/dk7evNFgHgAdetJZ235ph1EgExNOmRwDFIBxMqJSeBuab7c0VFJJER7UNpAHWndAEqEkdON6BTOyp86URKjuP50JPE0MBBMmQKBTv8p9xRj+9sKJIjrt60goxqSiJJJnrWFduN1gAzW1ACYPFNiJMSBQLkjnLRB37sc1ru2CVE+AVMrTrSClIFMUhKvlAmgp7FcdwlJJlBMddt6jnsFbJI0faKuDjAMAT61hNmkkyPaKTVhZQbrAG9wE89CBURdZbbInuxEdBXTHbIKVpKBtvuK03MLBJJjc8UqCzlN1lZO/5Q+1Rb+VkEkd2k+0V19eEIJ3A+1aruBoM6gOfI1PSM4vc5UbB2YAHsP8Ki7nKSTJ7iQf8ANH+FdudwFJJAR+hqPfy6hRMJM+VJxdBdHB7vKaBJDIkeg/wqCvcqCFaWRPnA/wAK9BXeWxJBE/8AdP8AjUHe5ZBB1IA6Hb/fWbh6lWee77KwBMtCY8qg7nLndKKkNFJPUbdfSvQV7lUSo6JHTwn/ABqv3mVSJGkgn0Mc+9S4ehSkcJu8DcO69SgmQJM1jwl3Hcs36MUwDErmwumzqDlu6UGZ/X2rr95lRe40Egny/wB9Q9zlRQJHd9PL/fUOF7Mdlz7PPxmdoGWFNWWb8Ntscsk7LdT4H48/7pP0r0PkX8RnZRnotizxv9jYg/4fhLvwhR/ga8Y3GVVDbuz9j/jUZc5aWk6kpII4MHb9dq48mghPdKmUpSXDPotj2WMJzRaf1/CrS/aX8q2wFD0NUxWSswZYdWnKGMuKbCfDZXsuso9E8KFeScodrXaZkItsYZjrz9m2Z+GuCVp56E7iu+5L/FXlzHdFlm22dw64V/1gVKFnznpXDPSZcW63Q+pS2ki64bnJNndBnNOE3eFPIEu3LJ7xhR9I3E+oqy43gGUe0HCw4fg8UtnUgBxJSVpkcBQ/hWNGJ5Px5IvLK5Nwt5AkEpIjpwd+tQK8qDBrl/E8EQ7apelJVbKIUD5ECQfqKxc2mDgpKmrOY52/CZZgKuMr4obdw+MW1ymYHoRXEc0dlWeMpqdOJ4M+phG5fbSVIj36V6xX2oXeXj3OP2j99YIELfbA1pP+cn/CKsWWs/ZIzYwq1wq9sMQKlEOWxeSH0A9FNnf9K1jOT3Z5up8Mw5ONmeAAkSJWRpMQOKCySZ1AAbE17ezr+GbIGd2HMSwe2Xgt65O7ZAQTPPka8/Zy/DR2gZRQu4trQYrZjxJXbiVfUCtI5IyPIzeGZsLbStHIyhvwrZWQpW9EtJRBWDK+DG1Z7mwvLFXd3bC2HUT4HEFJT9DWI6jH5ohQHJrSzz7p0zEptsNpWmVwqD6Uh4VSkkGsgGv5U6UcfXzpoahOoqUfToaYwK8CgqCB50lKXoCktyJJ96S9lAd3sOk09SVK2gAneBxQBh0hUKSCB1npSShSAUkah0is6U+OCmEqH2piRoWQASkcetADG+8RIUk6TwIras8PexK6Ra2zLi3nVBDSEpkk+lZLW0uL66asrS2ccW6oBCAJUozXpDJ+RMrdguVVdqPac+2m9Q3rt7MmShR4AB3k+VSnudmk0k9VOo8LlkRlPIWXexDAh2mdqzzSHG2ybazKQVkncJE8qMV5c7ZO2PMnbPmdzF8VWWMPZUU2VklR0MonmOqiOaydtPbRmftozM5iOKvutYYys/A2QPgaR0Mf3j1NUi1ttR3TW2LTxxy63uz6nFihgh5ePj9x1vbaoEDeasOG4cVR4T9qGHYcVlJg9enrVzwjBUqCfCZPp612RjQ2PwfBNUS2evT1roGCYB8pLZ4PT1o4JgOydhvPT1ro+CYCQACkcHp61slZEn2FgeAI0hXd7g+lXvCsIASDAj6U7CsISjbT1PSrbh9gExKANq3SIYLCxA20Cpxi2QI23O1NZt4AKdvatxLYiFSNtq0iSJKRGwjzrIEnkbR+lJCQTKSDHU09RidhJ86EgEZAnVv1pDfkCPXrTSok7GPQUfEN5+9MQVRBHImgIJ2MRQ1QaSj5CgY4q8wCelDUDO0FPWgCgERzSURqExuN4pPcB0mOsmkFKVsKEgwBx60ASRwPPelYDt9Z2oTvB460k7EySD6U3xGd+TQAQoRsKUTuQkyBFKRp2O/BihuNlDgbmgAjbYiIoFSOSSfaiDtpJ26U3dRncR0FNMVJ8jxJJUsb9abGtWsGIoqJG5iOgoghIgkEc7DalyMaskCByTW2hsqFi0IHeKAk78ria0R4yTMRxUo2dN3hvMjRGnz11MnRUeGRraQ0FN6goNrKJA5IJBp8TJA2rCxu14jqhShPEnVvWVJKT6VaexADsdwaWqR7fpRUNQgHamEqSqRAESaLGOmRBKp86EqB0q4I5ojzUkEeVIgqECI9KLYgA9fOiJPJgU0GNlbRtToVJikFh1CPKKRI39qaNxskkHrRMAEwN+DRYxAgAQkHbrRGwiBvyOgpgHUmnjbxSN6u7FQORA+lLgxvPWiYHymmzIEzM80mxiOx3MjypBUbAUAd9hv5mlKtR1KO+21SKrCN/U+dEAAEkTTfbakFeGOs0AOCkgbCgUzwdvKhwqKMwYNVYxwKQB1PvTNxI680toAB3nypxJJAqWICRAkncmlG+ytutIgczvS0kEEDanbGKSDBG8bmiCZgih4jJI2pTEzz0p2AhMQaUngTS2233pA7kkjbikxUICBI+9NB2TvNIneDxRKgk7b9KQB1ADnmkQB4eCaadRGrb2oiVDxVSAMJmAmj6HpS2HHPnQkec00qCgSkHeY9KPhJ2O/rQKpIEUVcSefSlaQxsGT60U7GCKHy7QZ9aIUeoosQ4nfmmkwes9T6UgVatuKSjJPnT6gpIXXncbR6Udkjbbehz+6KW3/qKmgscqIB6UAAdxTYk7zAp406es07oY0yo+ppJBSfFSSdtVJUnf8AnTuluKhEkkkCBTd0q2ANEGEkH70EglUmkqYDpA6b9ffzpepPFNJAG9IQYMbfzoewx0nkdaisexmwwdFqq+Cj8TctstBKCo6zMHbyqTUoJO5PsRWjiSUK+HWUkqTcNwoHj/dQ99xWSCSIOkRJ2miTEJ/ntTRAO/ToaRCZmINUnsK9hatR0+VO3JBAoDSdh96MmCIp2NX3G6iOtOmduIpbfKY25oEgSZG5pWMSvI8UhCBJ4HFDdUJ86UgJIg7UxUKQeeaRn94yaGpIUeadt15PWlaGBYkSFEe1AzG33pagAQdvWkmSDASRRdktWCIUUn6URtsaPAkbmIoAyYPNMSj0oChPAp0Ac/NzNNAUFSACODNHaCfSKT3FFACVAzPFLUSYo7mAPKmkqg7UqrcpbbBUkKietAI07mYFEEKVvsKcYPp9aN2gq+RmonY8DiiPm1dOtCAkzNGSeSPpRdD5CqInp0rGpRO42NZB5UOCab4JaY2VASetOmRuN/OknfnrSO3H1pN9xrcadjuJ9adqBIH29KaefSl0k9KG0yap7CKhP8aJgq46bUDG9E7xFQnuaAUY2V9Kb6HinEHp086BlJ1bVdkOPoESRBG9IAbkwRFIeZBp0eEnqaLsSi+40Seg9JpEQd9j0IoQZ23ilpncTU7Iq2H1O8UAFDaNjTkxHBmgTB53qn6oXQuRsKPXigSZBAIp8yOgpSE7EbedFi6fQSZgbbU4gFJIFMPJB29KQmIB5o6kCXYQXAhPWgCpRjaD50fQkyBtNAJBPho6gad2OJhOximEyZ4owDEpANCD0TRdiasKtwCk0pVI3oTHANIKE8GluOGw/cJEncdaH5ZICk7mgpZn0oFZmSOOtVTC13FsFEE7dN6BmJ86Kd+R9aSieANulJsSVgAnxKEkbUdumwpE/frQSTxNIHEMBJJGwoAgxKiIpEJnqabyY6UIIq9jdiDM7USrSI2nmmmNt/CKQlQ2FSa9hwUvkdaIB2M8b0hESAY8xxQMK21T5ildgO8Akn9KW8QOOaA8inakVgGJg0wCSnTyBTZ5iDtPNKP3gSaW8zANAB/zuhoqkSE7nimztuE+cCgVkGQN/eix2h0AHYCkTO9BOo+IRPqKKif3tqORJNiB2hJMdKR33TSAkEEQnpREDkxTsQiP3iR9abqknYbCiomR5UhM780h0LgaR96Q2JPAil1J6eXUUiRE7CYigB0gngSqmmCTKoikCOAQSaJKgofLtxQAFGT4dgTNKTO0DzpEyJpKHAHXrQHYOmNgfWkkmNPSmkkKSFbjilwJBhI86AHEbRIE+fWkJAMkb9aaCTyKIKZ9aAENvCFTSKAdxyOgp0TztTCY9xRVjQ0gq2EnypFMn5RsKyDoR1pbjyoEYikHwlJPtWMsJPQjyrY22O0z0oEGJJ36fSgDVXak8AHamfCahBAHrW4JkFJmf4UCkkmBt5UgI1dkFbRr9Y4rC7h6Bvp/hUupJA8Qg/yoFpMEq1e8bUwsrtxhqVGdNR1zhCIMokc/8bVb124USIjyisKrMFWhJ25PnSod0UG6wBC9X5fr/wAbVEXWXUKj8vj/AB9q6WuxTBV1NajmG64TE1L2GmmcpussIOxa89+P5VFXGVkxJZkx5g/yrsL2DoUeNXvWk9gY3JSKXShnF7jKoKSSz+g/wqJuspyD+UfP9fau3v4CNPyTNRt1l6UbIP8Ax9alwKi+xwW9ymAd2jO//HFVzEMrGI7nbfgf7q9B3uWpP9mRUBiGVwAdgOf+OanpKbSOO4Hj+cclPhzAMUfZQlWruV+Nqep0kRPqN66Xh/4nMStbNLGLYA7aXOqXLnD3JS4B/wCyXEH11x6VoYjlcHUAB/x9arGI5W3X4Ukwen++sMmCE+UNP0JbtD7XMIx3DHr3CM4401fOpKTajBkI3jkud7A+k1wPCMXfy5iLmM4fhra8UccLi8QfecU+VbfvAjSPQV0S/wAsLGry3P8AxvUHc5aJJ8Kf0/xrNYIw/KhV3Z1zs1/GfmrAG2sPzWyq5tkDSSoFX11/N9CD716iyD29dnWeG2UWmMJt7m63DSz4Seo8p9K+dz2WiP3E/Yf41ht8OxDDbg3OHXC7dzgqbUQT7771hk0cJLbYpSceD6W517KuzzPNmpWK4UyHVp2umUwsesgV52z3+EPHcMDl9ki9GIW6Rq7hz50/Wa5pkP8AEn2nZIfaRdXysStEDT3bx/dH869Ldnf4sMgZncRb41cnBLsp371QCSr0M1yTwZcPHBz5tNh1H/kjv7jyHjuVsw5adNvjOHO2x3Eq4n3qIKiQNCY86+kF/gOSs/Wgeu7CwxBl9GpLzemVT16zXGM8fhIw6/U9eZauk26lJ/LaCo8XsaUcnqeRm8InG5YXaPImjURqmetOgJHg+YedXXNHZBnfKjpF5hjryJnU2kz9jVOU0pDikLCkKBgpUncVqnZ5U8U8e01RjKSsQUnT0rNbWtxf3Ddna263n3VaG20/MpXkBWfDcLu8RuU2WHMrurhww2y2CpSj6CvTGSsj5L7CcoK7Su059pvEkoDjTDgnu/7oCSZKjQt3SN9Ho56qSpez6mvkvIOUewbKS+1DtPfSm+ZaCre1WflJ4EdVV5D7au2rMXbVmd3FMRdW1hzaybOzCoShPAUR1URWTtt7asxdtWZncUxBblvhjSos7LVshP8AeV0J/hVEtrVSjPM1048fRu+T6zFihggscOAWtqVEeGrBhuHFcDT/AMTQw7DlKIlMbVc8GwUkpiP+DW6iOw4LgyjHg8+vr7V0PAsB3b/LPB/iPShgeAkkbf8AE10bA8EKUoBG0H+NbRiRY/BMDnTKNgD/ABq+4ThOkbpIAB/jTMKwnSlIjqenrVuw+x0gSjYmt4xM2x1lYJA+WQeKmWGEtgbbxSYtwlPG3tW621tMH6VZLEhPhBgCNqyBJMgnjilE7qO1OSNUgDemANhEA0ZBHT2oFUGOPfmhtOw3NFiHCAeKCiVGY5pbknpPH0pBXUcU27DkEDUSZpBUyYpGFAKSZ86W3B4pDCQmNQO4G8eVCFc6Z9aPIhInUIoH5RI39eKBtDjuPfgU1JMjeI2ilIIEnY0oExOxoEIgpVvR17ERzQKk6QZkedAExQIcJ2AP86SwTIJ3NAEczB9KaSUwSJFBVCOonSIkUdwIpADnr1HrSKVDYjmgVAJ1KCTIjcmkfl0pFKTEk8mSKaYUoQTKuKBpWOgp2jmnY3iasEs1YmGVPLsrQXCW08rUmVBI96arj061UsdzPiFzY423cO4SlFq0/bJQt5TaylKOeInfpUy7FwjbosGDXzmIYRZX7zSml3TCX1IJB0lY1RsTPNb55G/NRmXkkZewtMJ8Nkx8pkfIOPSpLcGB4qpNURJU6FuCd+KAIJJE7iiRJ3oxpIInzprkT9BpCoELBHpTtQJG5ihzAiguOQYO9JAJcmY+5pJKhso7eYoJVqOmOKR243+vFPkdDgTMgmetIgqE+XSm6iJURBpSeUK/SkJ7B2V4dUH1o7p/d1CgFFR3A+lIyZJIFNMQYA6RQMkadoJ2IpeKOTNAeFIE/Sih0OVyYG/ShIg+dLeBI36UtJmAOn3pUOgEyYHAofU08gc0NulAgzPtTVeQ2ijvO3FJQCfrRZdUN3j3M0duh38qCjPSAOtH94eVVQqHCZ3ilIgSnrBpszsRNFKjERQxJeoirYeXSh18VFRkbcjmgefMVItgmBE8E0ApW2+wNIkGBMRQ4kDenY0OJ69KUgjc00EjdJkUdyIKZJ2mlQUIHfVINIKJO/FIyNtPFHcpIA36UCFqE78TFJJSrcCBTSBO/nR44O/rVXY6oKvOPrQB4kzvQkRHTrSSZAkyKNmIPKpJkdJpAyZ8jxQ43Mb8CjI6DepAQg+e1DcmQIFHdXSKQIB24qmAkkTvNFfpBmhEnnYcmhPJilYVQ5G256UAQTAoKITuBvx6UpSEwZJPlRYDhAiNxQJnedqI23ANNSRvJquQArxABPE708bGKYk+L5vangH5qSQAPiMFOwpbTt03pAQnUaaSDv1PAolyIB1KVEmtPFI7u2KgP+ktgEmOvHrW8gE7jnitDGQlLTBIkm5aA9PFv+lHYKSdm+dxqEyaW5BE7+VCFRE/alE7zA60qHQU7CCed6fG2xpmw445mlr22NNbAOhIM7g9ZpHSdooFUj1NNJ3indOgHCQRPApSBueDSgHcmkSk8nbzpv3gDxQTIpA6oNCSQCdqEeKelTfcBxAOyuKGrQoADw0gCeOKdG0cii2IQVsQI/3U2NR8KhPWhITvPoKcNhIHNCbbGLjYmkFAykUo2k00RMjiqYqCFEK8PTzpGRKuRQIBVsr29afsANQ2FJO9gG7KG32oyny2oKETSSQR70J1sxiKR0/WlsNopA7bbigdXltQwEZ+gpTM+fSkCf8ACh1/xpOgDMbClvO8UInpv96EE7xEVLYqDKtUQKU9D9aSR4hPlQMgjoDtQAY34n2objcH6UtKunNIGNiN/KgA6uJNCR139DRA24gnpTVfNB69ZqrEl3HCZgmaJNAec80CTvSbrYfcRhRgil4iPD0oFQ0hJ69aM6eaLQNWIE/vGKMTvFDad5NEEf3h7U7rYBh3Okc0eSJ4olIJkGDQiRztUktUhcnWo7UtzMEih8pmdqIVE7VSSFQUidid/WlB+WeKHImQDTfGnoP9LoKexVbBJM7fenT/AHSfrTB5U49J6VLGI+lNWCdop06hv0pK5BmZ6UkyXH0FOoeIbUNpIjbrS2SZ6Gkdx6U7KSATGwmKJVEHgGhPSgBB5BPkafIBIlUkyaXJgml4SQQrkUgB1MUC6UIKkRHTagd9gdzSmNx0NCUcgzNA0qNwncg706QUxFM8UGYpAmfX+FS9x0PgFBBigR4pn60kiTzt/OipJmARJ43pL2RoQAEk8cUhsIJJJoE9CduTS5gHrTDnYKdhIPNCDxTiYB2oDcT1oFVCPMjg00eID0p20aTuPSkOJCdxvQAJ6Dcjenbbb8Uh/fIEnz6UBvPUmk5dh2xEJBBmjrSj08qAKp4oKCSrbfb9aYJ0qHEE9ed6Eq2E8UCVec0Ugkwr9KLEwp0+QnqaOw25jYU3gwCOfKkRvuDtQAVA+dBMzpIEnrS1TsBRURsIMUDYQCOKb5DTwKJPRJj0pTpMKVPl5UCsCiowRTpnmmwTwaIBPSKAFPSIjigY1HSORFGCrfb2NCB/cE0AEK8MHptSPpzSSRvJ1GgCAPXpQGwpUeBNFJI2mgFEkBI0n9KUaZmZ9KQ1uOToJ3kHnagT4gKXSaaTJk7UyqSQ8bgiATSMiADEdKbBnbij4o2E0EJXuCDJkfWkkDodXoaRnrSCTEyNqCuAEdB96AT/AHtxTwqACfuadBUN5IpcA0kYi0hW4HHQ1iW1vqAMDis4G5AMec0NBnnamFbWaqrbVB0pAisXwqN9h9K31JAEjg8UCkkRA9KQRZGrsQoHwJAIrVfw0ER3ad+PWpsJCiEgb/pQW2IgqM9INJlNlXuMKSZ8Cf8Aj6VEXeCpKj4BJ8v/AEq8O2yuD1rUdsUq8+etHShdSexze9y8lYKg3MeY/wB1V6/yyFpP5Ygz0/3V1u6wxPiASTPpUdcYOhXhCR16f76mUQs4rf5VJKhoBEnof8KgbnKklX5Ww9P91dyusCbUSoN7T/x1qMuMutqCj3Y33+Wf51HSylI4XcZQJUIZgz5f7qj38oqEjutv9E/4V3N7LDZJIQmekiP51pv5XQd+7TPt/vpODY+pHCLnKsSO6/Q/4VDXuVXShS0tj8vxcE13+6yskj+yAj0H+NQmJ5UCCGxA1HcFPzQJjmolG0CZzjK3aB2hZEV3mXcbfQ0dlMunWggdII2rvmQvxfYdcaLPP2FrtFhAHxDQK0KVPOwlNcqv8qJT8rYjfjpVbxDKwAMNx/x71hl00J8opbO0e7LLMOQe0LDEqtr2yxFlSdSEp0k/xkVS8d7CMi5ndgYb3ToMBC0ggfU7mvFRwu/wq477Dby4tHJkLZWUH9DW492hdqlvaLsEZ4xkMKGkp+IJMf6R3Fcb0TT2Zdxl+dWepcXuew/8O6HXcTxKxViSUgt2yUhbur1SkT06mvE/bX2xZn7Z8yO4liL7jWFsrIs7PhKB/eUBsT/Co29we4u33Lq7ccffWZW44dSlH1J3rXGBbglJgnyrfHgWMbyWumKpFct7FZ20q+1TmH4YolMpPsRUva4ConZP6evvVmwvAJKTomPStkiGzUwbBCSnwkdNh610DA8vK6NzPXfz9qy4Hl/dJLZH0Hn710TBsASjlH6evvWsdiG6GYJgWgDUDJmdvWr7hGEBMbe1LCcHSkghPPn71a7KxSnbrvFdEYkPncfZWKUiIkxUzb2qUIjg0WLeBIArbQid9NaJIQUJA2+prKlPAFDTBMiBWRKxEeXlQCSBwYpbkQeehpahzpoKVJkeU0DpJhVHUJjqabA6EEUYJAiKRCzuBA9ooIa3CJIgjYetAkncnYetIyBtzS0hSYJ59KBsXhKo8VApkkqHuKQMzEpHpQBUSBHv50CQ5IjciTR53jagnnj60YUfl+/nQy67iUqQEp38qGmR4pnyoEGNgabK+mx96dEocAQNQ2HSkQY4M0JMQSQKcNRE6qLodMaCnTsIjmmglSpgR5Glq1+ECTztRCSOabYNWOmFAmPpQUo6txvRI21H701Mkajv61LSe4mhE6vAkmZ3B4opBKyqdhS8Sdwk/akVwNI680h2Fe5lO55qMzDoay/iilaS0LR5SgRICtB3ipGIOmeK0cwD/wC5/FNaJHwT5IHJhs0PgqHKYsB8OBYakFCj8GyDpPJ0CpBGxlQFaWCqDmC4c4kGHLNhQ2jlsVuKGkA+Zp0Q+WOUAolYNYwVRINOJ6JO1IiDAIn05prYEgTPT2pw52poQpM6RMUgd/EaQuAq8+vvQBgHwwRRKZVI3FBQjrNF2OwK3jTRSd4mIoDZUTzxTlAEyBMU7KoBnUTO9LZex4NHYSeKaBxHNDJY9JEHwmmkbwd+tEnYeIgjp0NNKiTSDlBClRvP1o6hMRxQogbCfCfP0obHwIq8W9IqTGx3NJQiDFIDVG8T1FA93wLcRQUToPU/pSKRMSTHWgDIIigl2gydIImgVCPFJpA/alMGYmgLCCSBPHlS1E70hM6gQTPHpRmAYinyLkaORHTajO/UetCDsob+Y9aQUobHnypDQidpE/WlskARxSMwZ5NEETvQNgG87+4pDmTRPMk9Ipu8+9NMXcdBiTxQPFEmR4qarjw0mEvQR356UdwmRSkBMTMmkTI67U7sORSZBnpR1IGxnfpQCQd5pHb/ABoHQvErxFI2owIkUARJhR38+KREiTQiRTvE0iZPEkcGlAAmkJG5o7jESdIA2pIEzvtSMK3kSaW3CVAUhCGoK8MRHNIqJACt96XIGk8c0iraI2NPcAaincdaHAlXNIQCZnanKKZHlSACQEgagY9KKyOJ3pcDg02JWDx5U7AJJI0kcUv3gCJpKnxKPnIpJmNuaQdwlOkKABj3rTxNorYbAJ/t2jHsoc1uGeTP3rTxBwMsoeOkDvmxurk6htRY0tzbgATSknpS1CACDSke1BN2wweu9Lp69KSiRFAknYfNRwxtBBAmetJW+4pbQBBpsKCjCiBTbbEO8RTAMGm+g460VK22NJJMHbY9POlYxoTKhPQUdStkzxR8PlSKYM0+wmGehNDbcA79KbJEzvR1SPKmnQ3YuunyolXHnQUOhEih6BI96V7gPkkRTZPnQkg+I0pAFNyAW5Ekc04FRGwB96YSQBBkdIowZA4npSsA/KDxPpQEA7CaR5ilOn2pAOnYTuaHHWgomgFef2pt2ASE89eKUBPST50gAonfYijNKgTAUgwD7mlBH8hSMTO8nmkfUUCAd+RxR2nbmlMzQA8QPShDElQPWgAfLrSCRxTjIERIoAHSRSEaZIoBM8yIpCT60AI8x0NOUB0G8UAkp3TvTSoqMigQk6v3ztRJJEjij6waR36fSm2CAJKQI+1LVApAwdqUT1E0qGDbqJpQnqKJHqKBKuQKOAHe21BR3mgD0MyacY0nzp8EbPYaIJ2G9OG436UNgkb+Kj+6aO5QxRAM0ZP1oaQE7b+U0uTPWmQtnQSdpHIpAgCJoJKZk9KWpJMbUmaAnkSI8o2ogwd446ClO8ADakDvG1AA1SY60SgqG53FIAE7kUguARB9CabAA1J25igDt6046gQPP160CSVRHA3qVKyZOgT0NHSImTI4NNAk6f407dJgjaqBqzbPX3mlB3Ip5SRvQBSUwrrWd+haYBIkUdwQY/Slp8WxE04qV8upNHVfAX6DCJOoUArxQBvPWkZABkGaEp689Kpbqx0PVv5TQSAnk0AJG5g+ZopETxt5VL9BNhAgTFABQJid6cpQPP0oajO1CvkEIggbCRSmNhsaOsEQRTFTMjjpRzyDHb+e9DYdIM0TuNulNgfvTvtVBTQdW52ERToOnwkiTvPFNSmCAT4TRCinjxeVAbsMlI4E00KMSeho7x6nmgIIMGaEHAYMyEzIkRSkbauRyKQ2HpQ0xuePOhisQ3Mp6+dGSnqKXhiQd6GnbfnzoAQVJjeaUmZM7UgBBkkCdjS1FXX7UAOA81b03UJgqHltQAI3B2pCSkGY38qKGhwAMlBEjrQ0kwBzRAB67U5PhMpMnilwOqQwieojmnhYKdvOaAJVKQY60EnYimJruOJ67e1NUNR2+1BQPMTFKRIgQTSSBBGnTJG4o6BHhmabuFADmsmsAifmBg0pX2FVGNSTMJBIo+LqKCoJMedIHYwape8qh6N9yfbrSJAJOofSgDI2EA7iipI486iStkvcCimJE/40kwUGSJ96CUkbDmj3QABOxmmnQ7oATqTt0+1ElQEwKI4BjjikIJIUek1LkwbsZEiJInmKR0DwgU4gjccEGkUgALnUZ4q1JWJMYRtJ3mmKbQoyNvengwASRRkKEDaaY1GzXWykzsDNYF2gKTASD5kVvLTAABB9KBhIg/Y0+w+CJOHJJgg+m9a7mHBSp0mOOanSgEbcnrTUNIA3EzU36gV5zCkkbJ+9azmFJIgoAPtVoLWk77J9elN+FBB1pJniKWw9nwU57Bkbp0idMzFQmKYLL9uNMkuGCQf7pro6rRsg6gYiK07nDGXG9akyWjqTPnx/A1nQk7ZzG/y6FpJ7oAKJAqvXuVw4ky3BHpXYXsLSoQEb6ulRl7g6FAq7smD5CiS2LcqdHDsTynye56+vl7VWr3Kilf8AV8zwDXe7zL6HTIQPsKhbnLKDBLYI9AP8KnoY0zgtxlMgkd19wa1k5UX1aMDiAf8ACu4PZXaJnuv0Fa5yq1MBs+vFRQdSOTWeVVc9zH3qy4VlgpAIa/jV9YyuhJB7k8+QqZscvoTH5PEgyBVxiO0V3CMB0xLcRtwTyauuF4QAAT/xvW9YYMEhMN/arBaWBHhCd+grRRIkzDY2SUqlQnmpq3toSkxsKLFqEmSJreZbMHYCat7LYkCWgAdQiBT2kk7DanqAUIggr4pABMR1MUk9hIJSpXMetAgIE0ZMyTE0QAORM0raDgZ/DkilpG3vRUSD4Y+tAAnxHer94+RaVTJJH0ogKSI/WacFJM78U1UJ5MeVJOxIaSSBqMev8qek7cRTYG3tSEpRqjk7U2Ohyo22ifOmgESqPSnBCQRB+9FShwEyeKnq3FzsY06golR+lOJBUFCQBzNKACdt+vlSUCT6+1UWlSAd9gvalyNhI9aQIiOR50t4mNqBJeoCDx+gohWkaRyKGrfmaMFZk7DpQ9hN1wN0gkqinEnTAikBpEJBkUp21Ebmgd0gEbCD4vKaaRKgJ45pEHXqOwIohBAJVsaBL1Y4qExJ+poKSIJnnypifESroeKfsRAP1pV6A6EBpVChPqK0MxjVgGKoUCSbG4iDB/szUhoBEA71gvrRF9Y3Ng48llNw0touq4RqSQSfbmk5bbDRiwltbWDYchZUCizYQoHYyGxW2mDyncVqYTpRhNklKysN27aAuZ1AJAn6x+tbYKhJB96tO1bBvcUbymiFaRvx14ofl8ySYpJI6mld7khIHImeKZplUHnmnlJkwYFJSCACJNJSsXICtQ2UaG3JO1FPi5FJSBPhobob2GmABtuP0pa4OmOaOpMmjAEkCRHNPkY2RG/FAFJOyqcE0FJ0mUjmkSxwM8ge80JlXJPvS1CIKQPM0iIEgyaZdi85mB5CsaHpfUzBlCQqSNjNZCoSQk7+VRdpbW7eL4hdNtQ4tLSSqTJgGgH6slFLUSARTto5MU1IBjelKeAYihgnaFwqAdiJpoO/rTiQeCPahMH93igQidzApGTEU5e6dhHtQCY286OwUAcE8QOlLpsNjR0k7A/SiAAk6poQRjWwCCnjigoA7GnKIA0lXFNBnc80DqhSBwIHUmjsNyKdCdPM1jMBQHSjkOBDVzsRRSDqk0IIAiiJBE8UEpb7iPj8JmPQUCR1I+1EHc8CeIp22xigpq2M2J+WjyNoIpugkSKRgHfmqQuB0Ebz9KCiAYgx1mhqA2p6S2Rual0hNjDsPWimRInYGioDadjRUmBNCaBK0A+LgEiaarWQRI29aUgb9RRSnwkxsetAgFKQaKUiZoiPL2NIxzMUFLbgU+ZpqlggiJ8qRIIoTpBmqsVMOxkiaQgHmaMqI360CkRFSIcVCN6BKZ26U0gn2FIR060FPccqE7TvSB6D+NBXoOetIAjeKfYdUIqM7zULmpd2mzsxZFhK1X9uFLeSVAJ1+Q61NlSQJFR2OCLFpalBJN0zvpn98QPSpfAuHZIBQMSINEgTAmgoaRBoFRHAk00thJbDzxvyDQ5PkfOmpUVK09eTRImhjYZ8jSBMzNLTB8PFDb98x6UEUDTCp86dsBAJBoQCPDMihG3iHPnRRT4HJiABwKS+J8qaZEGnTIoEAKG21AJg9SPWj8op2oeVNAM1HUBRJM+X0poJBkiPWiCCd1A0NBQd9t9ppoO5J3jpRmDtxTVeLcc/xpAHkgDYUtW8iSR50kqHEQetIgzA45oEEEnpvQ0zJJ2og8k02QUkU2McSkDZUfwpsEmeduRTk6J86AIPJpCB4uRR3jSeaB0gxNESSYO1FgElPrSI23O80NuZ5pLJUNhJoGCJ89utOA23M0EqhO/NEqkDSOtD2EuBp+aAOBwDSkjeCBRMTNCEngmgYTI4M0tWk7/WmyvymlI9/QUAOPOw2oDbjjypCTwJPlS3n0oEIkjeaGreTRJCuKBSTwOKCXFt2ggAQSobjpQ3+Ye3E0dJIn6UBtxTRYuf/SKUz5gjypQEmVGiImZpMAEEGACmOPahq9KRSTsSNulIKE6TTslbOhE6jsN6QJAgGSenlRPEK2nYGkQkcqijtuNKgFUxEwKQidxtS3pQVGRR2CgRMkaY4IopGnYGmiCNxvRB8QB2oQwJCpoqge/SnedNIBEEbUWJCRBO53jiipekklI9qG4EJFCD/wB4edHIwk6vFI2FCR8xngTHWkSrdJj2oDTMHaiiU1ISuPCed6KJUQOYiRSMA7QRxvS/zRz1oboo3lLOnbjyoauEmiYG0g0IEweRWUX2GEkJEjY9aGylSBvTiZ5FADqdtPFCW1ioChBgjnrSgcHp604+L/GkY86bYBCIExtQOx260tgIB2pSPmG8dKlWAilMbbGkAkb8nzob9YpHmRpjzFPcAEKUdISYp2iSBG1NKYVqEe5pxJA6Cqba4BsW42BH601XiG5n0pKV4ZANKN4A6U0UnYioDSBIApsweB9aJA4ApHyAquwrFKgDuZG1EkzM+VIAqOob04HT8w2O1SIAE8Az+kU5axsCmI6ClAAMEwelM0mQTEe9CqXI9mEAkBX6RxQB0glQ3HWiSmSQaHiA3HJplPbgStJgI4/jQhBkEUYI6iRxS1kkbx6UUIelO8jb2oEKJ0k7CkDO8R9aCQVEydvSoafcmhOJ0+o/WkmCJIO1IgJ5PqKWoJMpX9KddSoqrQ5WkjwncdIpiSTwTxTkj95XXypwASNh7VN1yKxgJ8/0oyYIPPQigqJ3560iiJOqmmg2BAB3TNIzyB9KIKpginhM9RVWh7LgZBI3oBPSARWQ8bCmQJqbcmLkdqgxM0E6SZINNIMRpANOQI5oaSQUGZPH3oyEiDt6UxSZ3mlG+4JJpJJiAd+OtEBYHNCAn6GKfzxvtVN0hvgZJG0UihRg+VPEpMauelHUJgCp6qEN0yPFyOTSUiTINEACfL1oSkiYjpQpMBACeN/ekpIieKIgbHaaZPiKSdqE2AQmRMDfpTglKRv50eTtEAU0mTCd560NhZjWNSweiTIpwKY4pykjTzAoBBHA2qrTK2YgnpE+VaF+Yct7Zt7uxcuDUkcrA8RA8uKkEq08qEVoXl/bWuIWTLrSlO3anGW9IH5ZCNWo+kAj61mOC3Mncap1fStdy11A7ET61vDqEiDPFOgmAQOad0S3TIF2wBOkia1H8LKv3TVlcZ1jcCQelM+GST4iB5+tVdldRUTgwkk9NutM/YyBwgQferau0TqkNgU1VomCQiYqeeRWVZnCBzpPrua3rfCiDBSamUWiUq4BkzWwlgbAp2pypflCyOasdBHhMVut2gG8b1nQ2EDSU7DyrIBEEce3NLcVsYlGn92YHFO1k7CUjyp43+YgGjpGxA607SBuxoSQONqeqTwKUkHSneaaVqnYCjngVA3Kt6BkHinAqUdhRMTMx70+r1Ax7BUniPKnJBMgbiN/OiU6txSGw438qOq+B3sFMkaZ46U1adiRAHlSK46GfM0dJ9wRRxuKxoEDVSPEnpTlJg6TTVJggCZPNVaNLtBTB3PPlRWJhU0vCJpAJjc1De9kMBJiBSSeNRkmaIUB8quaShJkA+9NST5HdvcEhR8VMEK54okTvKo9qdKYASQSBVNj4AEA9R70QBvqAJHU0iduf8Kao7Ep+vlS55BpsSoAGlMUTsnVIP0paRtvv1igZE+VNNCtAgyBPh5pOajCEHmjJCd4mijdQMT0pMHuIkDeIFAJBp3zHRG486KjHEAjmixNgBk6R0rJal1d/aNWwRrU+2mV7pSCobkdfasJJO8kAmNq2cLgYnZFe4+Ja2jpqFTLgcOSLwwOIsmUEghKSNvOa2woDeBPrWthi1O4ew4skKVJIIgjc1sESYKfpVRltuU7TASSegB8qdChwBtuN6AajaYk0SY8MAjzptkXQ4mVGODSUBwemwrGmAuJIishKQOd6TDljQVTBO3lSIIFATMSKdMCNzO1UWkNVMwufQ0AkneP03olJA+ZRinJICZNEtiaAFEA6RuOvpTeuo7jz60+BzMdSfShIgGN/wBKgKGkRuD+lNA1JGk7xFPOkRoUCPUcUuDMU06JsaBGw+ta1qP65elSdwWgJ4I0mtqeoEzWJkD4m4jVPg/QUXbse9GUJ3JHWkpCdp8qPX2pSZAJ56UXuL3DYSBI3+tKFKghX0NFUk6PWjoHkTTsdjggjrTQCAYinSlMoB486CthuNjSth1MBIETuaGs9DtTdySPtWQpARsN6bdDb9BTPIn60iCBO9NSmNwBNO3IoYmmhAxO9CAUyRQiJM0QoETI9pplp3yEKTA/xpKIjmglsDYk+4FApg0WmKwEgKBG/SnK1AaZ9qATA5IoiVGSoTQxLcbKlDY0DztzTv3RBP1oEweOaLFd8jTtsd6cmAmNW9AkmBAikImTyKKGkIFWqDvTx4uTAoQmfEYoFQSPDx08zQ/cDTEdIMRPvTSoxAMHoKIBKiCk7CaJSNQpE2JJiAODSjSIJknigZ67AeVIyTqpjtCiDE0J8UdBzTwlHM7nemlAO4keopWg2AEgqIG0frRKhxG4/WlpA3gim7FUimL3jiJ3gfWm8mITtToI67nikGyPEqix2GCDE7DpTSSFeVPMp4pq5B0j3oHTQpE8+/rUdjyUrs2kqkAXLB2P+fUgBp35qOzCEKsEaiP+kscn/wBoKL7iW7JKJMKM+lKdpHTeiSUkkEkUpT058qAARMHqaQo6QRuaAjgUCCYUogcCmkzsQaMHTMiaQUYif0p2FgjfxUgY4Ao6TyKBB5j3NSAgNoPHlQ3EAQQBxTtHUzNDg8Ux8gG+xFER+7SPWPKKO2kH70UFPsAbDekFnc9KR1HfaKQBPzCm9wsCtJE89KCUxwIp0AHwz9aQIkAcGkDGwD4kiCaKQI35pTICSnYUjxKeaG7EBQHI5ojRzG4oTtJ5pSIkUWAgBp8IojzpKB0yI5pDjnegKXIokyDtROrkncU0gaZ43og770AIJKUjZNDnbf8AkKKvOdxSmBCTv60ACY8NKIpKASJV16ilpPkCD60AE870AN9uBSMgbiigK1RG0UrBBMHkU0pAO2wPNO1GPD+tNJA4O/kaVjYBCEid4o9CrmaHJmaU77Ag1T3JFq4E9OJolcDSofamqUCAYjptS22k7+VOkCVCBMinSY5ihuVHoPaiY9JqW2J3ewDBB3k0EmREb+dEAAT50t9glRmi0UBRIATqhXnSkDjmN6UyfFuYoQN9VNMQUwTNGN5k00HhIIjgUiqBAnah8gHfoKUyfpTRqkHrEGiTB3+lDARBPJmkQBvSkHaSKA0J3JJpoYkmVSeTTjvwon3phIG+xkRzSQoKGwg0pLYAqEQSZpbx6miVEDj0obCCTuDIqUAQFcbR96BSE70JAKhP8qJSI2mfU1SFQAJOrp1Ec0SVJJIA42jpQIMDmhCwYmB1NEtweyN3T4tqeTBmB60NjsBSOx0Haah7lboSjO4oAkETTjAjbilP1PSjtQBChMAgimxJ2pwSQJ6Uv9HmpuhA1QDtJ4rHIJ8MzWSYMkb0kiVTAE1d0CdCSAd+lLnaIE7gUYIOoiBxQJAmNyNjUoe4gJO/A4FGfSaUgkxTkqA2P1NFiGEkK3AgCmzpMkU5RkGOtNGoHdM+1UnfJadchMajuZ6UtSeoikVK3MED1oCCNqbVkuh+pPAgCklKY/n0pkJ4BohwgaSIqemuAqtx4M+HbakoJjz96GwSPFNApSrZKuaSoQpg6kiiFD5iJ6Uj4QAImgFAbAiPSn+ZD+IDpBJE7+dDTPv0pykpVEHeaaFnVojbzqk9th3sJeyo86yJlIpgIBjrTjJ60NOqDtQlK6maYVA7hNO1aeRNKCSDA8zSquSeA7Dk8fwpBwGAR4TQMKNERp3AkmptWGwvDJEbdKIiNxSBAgGks+REmlyAdgiPWfLakJAnkUJmFHcRSmBAMT50gAZJ5il8okCT60pUk7wqlM7gRTDcXzbnY+tGIIPlTQr+9zTVmep+lNKwoeIIhO4FNKikwelOmNgR9KSkAkACT1pUuGA1JCiSpQg04Kg7RtSSgRE/pRSlI2p7MAEkqmkkKPQb0ogmCT60uNwZnjpSYBnSSCAR70pTwOOaBIPXcc0lGBqTED70LcBEbR50CgaZ8vvRSdQkbmkYTvRbAUaR9YogBIoJKlEyJokzsUkmgOBpImFcHiltMEUikgyQQBtQIIEgcVSVoukFSBEzUViaAnF8HIPzXDyf/hGpRMK3naorFSP2tghWCQLh87efcqpXuOKkmSiCdXyk09Sid9I+1YflIisw3FD5Jku4h4iDxtTXEbhR6bU6duelNJlJ1Ee1C2FxyNKgRA5pJSTsdtqKUgAid4mk5JSCDuDt7USrsC32HFBPykkDmTSSmdiYolzwwAqkAOQrxeVKhUDTxIMdaIAPhTyeJpbDf70tQmaOQFG/AmkCT4SRvSPnTOtFWBk06RzuDwOaBUB0M0kgA+LamqMyARQNBnomIPFAyrY/akSEgbUdUDfpvNV7ynGhSR4RFJJJI1Az7UzmVDk80NuTP3pWHSZjvwNulN1A7RJpoKo3Ud6MQdp+1JISiwQRyTNDf+9+tEq6H+FNhB61dlJUGZGoyTSTKtpoAwNUz5RxRA3nioG1SDME7fLTiQeU0B60ZnrIpvki7GFUJ/30UhOkkiDQACzxsKM7x4Uj1pjcGlYgox1pQCk7mKCVKjjY8UoXERt1NAJtjVeYJpySI3JmmidQEQCKcpOokR8poBtmC6IAbKkEkuJiD61nlQHiMwZrDcJSruwtKlALBIT7in6pOgAR1PSgp7RHJJCZO5PNEKkwTt5UiiU0FIgQDzTRD3ESCQBO28VsYcf+cbQknT8S1tx++KwJTtHlWewI/aFoeSLhuBz+8mlKuljUaZo2RQbZJakp1Kgk/wCcazEFRkUxpKEpWhtOlCHFxB4GtQ3rKIGwNKPBpJ1yKTx1G9Ng8dTR2mhq6807ozlHuhdTtJ9aBPG2806SU0ANpUaBxS5FsDz9KJVBAjSOZNLpBG9LwgQTQC53DIB3O1N2iBJ9qShPzDekDHApt2DvsO5EFPvQJlQQKbsep+9FJT12FIh8hiE+E7dZoagATR1gcDegQIBnrFA0kxhIMEK0jyprIh91eqQqP4UQNz13rWs3UKvLxsuDwKRI8pTQWoqjfjaD9KaUnk9KIVI23ApeokiggbO8nfpThMxNM3mRHtTgZOxoBqwETuYokjTAImkDM7bzQIBMGqtMVUJMADVE0QZMTTQBq6kUhIMyB70PcfUOMaY3mkCR0mlz1Pp6il1ESI5mpFyNIJ5SQPWh1kRHoKeTJJoK5j61ViDJKQRxSJ088AeVA+fSgZgid4pbFU6oDT4dDkAgNuFsz5inKII2EetY29BU8EyPzTsf41kKNpB2pJlpJcg0qAmdqI8zxR42oEp46npVXZnJUNIST19KXhBAjejoVvqG1EaAiRvvuadiTGmVEzwKKCNQPlQUSAD160kkdOKAHqImRO1AFJ3/AI0gCkwaaqSOKVAESqYIM0irbbiikwPIU06TxzSWzAWrcQPrTiUgBKZpoRB1BW3WjB6b/wCFDrsVQYSQTFNiBsKdABCZmnKGxiJ9aEwSXcxbqO809RMbE0ElcQQJ9KMef6UMKXYEqjePvQkgQTuetIqJhIiBtSO+5IMeVN8CSb4CSkDitLGElVohKQCS82RI4Oqt2BrIOwqPxu9tcPsxdXly0y0l5pIW4dI1FUJE+ZqW9h00zeE6YVzMUpA/dopKdUkzPlTjsYPFVdEjNRJJA54opMbwJp3hJAnikoJ3IPFCY0Nkjg7UdpiaRAVudqWgEahq8qbaG4gUrSN+PSlII528qSkg8HelpA4SaSaEkLUTzSO4gA/agSOJ36+lEH1M0w2QIgb9KJI0xTSSeaad9knfy5oEO1bkcCik7Ez0pFI+poQB8vHnQAd+T1FAxJI56UpJ54oJEmeQKA5D4uTEUZgTTSFdAZoySOIiimhsSYO8UjHAFCYpBaoKunU0q9BBPh25k70oPNFO4J0800lUwncUIA9NwN+KJA486BB2I2ikpQKDFMBLSNXhO3nQgjqPegogiEknejuE0qoGKNRjY0lD94gkClqCoBgDr70D5A87AUUAQU9AB9aKFTsCRWMz0SKfAIkneihCiDpB+tApBI8/OgFFNOO4HnSoYDHSmgnVO+1O0qEn+VGfDuCZ8qE6AZ4/3Bt70iVAgKPPKR1ohP8AwaBAG/3NPqAM7yP1pbEbc0tOkbnp9KSZHGmDRswCDtFEJE6gaCtjsIoAiDHI6UmAAZHG5o7HY0JAlU0I2gDnrSEEpkgjaKRAketIEg6VEfWiSNfmKLGII0GNB/woEA80SSdSU+e/vQ85qkIXHNAATCefWkflk/elpIiDt1NMYCByCCDwIoaREpnngU4jSTPy9KCCkqg8UWwFIUI3kedGBHiJpFIJ8M02YUJ3FABhJAMTQKl7yIop0xJMEU3xEATE06CgpKgNjJ9aJUdgdx1PlTVEQCkb8GkCD7UnQEgkjSfLoKEqPO56UUnTtG9N1KG0c71k2Npjpn5hNIQN+lASdztTjAQfOmxABIEJ22pAK3IJOwpFJ4mgdUc0KhpMJEk6TIFFJ+gpJ6ztSVxPWl7gbaCCUpkbigNzqjekFgJGk0ioEUbIQShKo/WkJ46ClBCfCoigQopgmaa94IO6jueKG/8Ae3pJSdUz7U4QdySTSdIGNMxyT9aQT4dxBpxMdKCuBHEzRyPkCzvpGw9BQA23G36mjzuVGetLSSR4p96pMbTQpMQBQWkSSd5ECjMT70SsQEgbzUrYmhigSYNJIg8TSTIJBIpbjcKI9q1raiqHeIneiADsdwTG9BKiVb+VI8TBgGah2hPYJBAphJSIjk0/UJmZmgUhXNCbvcOphTJ5iiVdBNJIjjegVBOxFJ7sQtPQDbyo6gRp1CR0pmoE8mfSkCUmYpqI6HyYEeVNhR2UZopKTtvNBRIMCKVPsIJPUcURxJVseabBSncxSUUn5j9aVDoc5sAIBHpTQNxA+hps7QJokn93npT4QdPoEggCTvTVAkzpmkQrk04EhO1C2KaoCBvOj6CnTBAKJApoIEdKO28Ek05OyORSOJpK5Ch0mlA29aBnfzFLYB0noJodJA5pEgRPNBRMyCIo5HyISkGdt9gaQUlXU/SmlZIB6kbUU6TtB/30/cUoiUQneTQ1FXPFEnaNPXmjqAGkbzT2E4hAGkSKMgb6T96bJ5NHUqJ2qO4uBago70wlRIHTrRUowDAM9KOogRH3qroqr4GqSpSZEAjpUfiEHFsG1Hwh64UCeZDKo+lSUg8A+dV/M9zd2z+GJsEIXcKcuEI1bgKDCjx14qdtqNIJ3uTqtSSmRt5CnpkGOvnWJtwrZbcUggqQlRCuQSN6yKEDUBvzt5U3uKSCqSdopGU9N6IMwelIydxvVcGTbY0CTsBPrRSdStII8opRv60vCniff1pP3DQ0nSsp5A6U9II8REmmKCT495p4UkCE8daTtobTasSuNR5G4oKBJBITNHkHqKUJIA3pcE2BIIGk8GjxsqidI2SBTCTAJFMadhSSVaQdh1pTJIO+1AlKo2I3ikQNjvRdFKN7oQJiJEUB5878n+FI+nWgJGxosdNDh1GqCeKRTChPBpaiOv2oaxJmfc0xW2I7xwKKSZhO3XmgYInyoEwQoUrGk63CRJJ25pAp1SN6R3MdKG07iKTKUa4CQDsB7H0opQoGdVACQYmgVADmPeqE/RDgTEGmkqnSobGkkhR0oBUTttvWVFndK8Ldu8snyQT/AAqHkiu5UcUnyjGQeE7RSnYEnY+lbP7OxIiU4ddkzAhhZ/lWVGXcdcWe7wa+IIEywqJ+1T52Pu0X5c12NDwjY7yNtqC4OwHHSpQZWzG54Rg9yCN9Kkwf1rZayRmZ91tsWGhahIQtxKTHtMmolqcS/qQljlzRAwBwacVaQSJMkR61PjKKLc6MQzJg1koAkhd2kqAHM8ULjD8k2Cdd3nexudMFYbuG0wPOZUf0rnn4jp4qrs0/DZJ7JFQvhcupDLL6reVtjUACYJ9R0ipFsFKQBGobajyfWn47jPZ5hiHHG804Q0pt1lsG6unVkOEyEkNo3BEVnwjNeWMR78DEMGd7pekm1sX1xAk7uLE/auaXjOGCun+37m8fDcmTbv8Aqa5gAE7g7CetYysaVKKgEjzqQOcsotpLHx6HFOnwrtcEblAHIJW4QZrZc7R8mIwtb7V7fW5Da1/lWtuyvbnfSQP1rGXj2JcL6o1j4XkXP7P7EQkzsmTA3jet3DbS8ub60NtbPLIuG90tqMeIb8dK4nefjESnMmIYA3iuI2jNtcBq2eU+glSNjKiEgTuRUvZdqPadmzELzEcDxbFX7RakhC7RZWGkxx4RtPWpy+MuEbcNioeGeZxJHUbTBMWWXmmcOuXlNOL16GiYBWqDWdOAY4vdOD3qh6NGvO2LWHajeZp+KbZzR3xcSkOOJuNJB8xwdz1qVwHI2a7h9S7q3zQVsXK0PlfxAkydwNgR5QPrU/76lBNRtGn+0OUqckd0Vl/G0HQ5hVyhXMKRBj60FYHjG6f2e9IEkRvFcWtMtZtGOXveYFmG4Q24Q0440+QUaRHTznrWK3wDNzWN4g4/huOLccSju0packp9iOKxf+ob/LE0/wBlVfmR2w4Hi6VQvDngSYEgbmmOYTfI+e30b7ypKf51x84R2jtGUZXx1xcgpHwrs/eP4Vt22TO0PF21OXGB4nbJUiO6UlaiTyTBEio/+Qz/AOhUfB4JX1o6v+yMQCASykBXyy6nf233pHCbxCwyXLYOKEhBuGwSPYmapGQez7MFrnnK9/e4RfN29g+HHnXgQhIkzMms3azkjOOLdoGJ43gVgblvu7hLS2VJOoLAjfVtEVq/G8ripRjsYvw7F5nl9fa7/sWphlu53t8QsXITq8N42dvPmns2DlyEhm9sCFp1g/GtAKH+tXLrDImfLLJVtgRwW5RfC17taHXW06VHzlVaGC9lvaNa2VlbXeGp1NtaDouWzvx/fisv99zPiBp/tmLvNfM68q2ZYA14thgKlaQPjmjv5bKpiU4ee9jMOEksf2g+MblPvvXNGuzDHGVNh9hpS2nSuPjWQUnzjVWjeZFzZli0xHMSrOxDTQVchLlyy7r0iZKdW4ofjud8Qr/PgP8A2vA1/wCRfT7nU7i7wa3dZafzNg6FPGEzepgHnfy9K1MQx7KmGModv88ZeYCypCC5foCSodNR2mvM952vZhvb63fvsJwpTYXpUkWLQSfIjw1AWPauMxX+I4VmDJuB3FnbvFdug2CNvOYFdEfFpuNur/z3GC0ELqn9D1cvNuTGonOeDwSBIuvCfrEGo2wzNlVjEMVW9nLAQ2862tlHxiE+ENgKkk+deaW+1RBw5xFxljBypu40pAtQkBAIjgjgRWx/ygWKsbLTmV8FUw4yZIZcSoz5wveqj4vJ+n+foD8PX9Kf0+56gZzZlF1aGms44CrvPl/5ya3PpKq228XwV5WhrMWDOKG0JxFgn9FV5RXmnKpuUNHK2ErRbQtAh4BKgNhs4K2E9o+B3SbB13JeFu988pFx3T76IAmDIWR5Vf8Au0vd/n6Gb8OV7v6fyeq1X+FoUG143hQURMfHsz/4qyL7plIcN9ZpQdwr4puJ/wBavKKM3ZRexi8uFZBw0G1SgIU5dvKC9iSD4qv3av2d9l7eS8l4mrKKlKzVh68S0W9240GlAJOkadz836VS8Wko9Uo7DXh8bUb542/k7szZ3NyjvbZovIAnUyQtMe4oqtbxAJXaPADklsxXhxGWMkWmJsYerC8dtwtlST3WNuojSZAEpMVOYbiOXsLVZWtvjeerJy5dPeC2zNpSiPIFk7cVtHxbDRm/Dsl0ewgDwAT9KSVBRgb15tsM0LsHjp7QO0BsBZicebd2/wC8z/Kpu17SHm7h22/pznJ0IbCtT/wToVPuxM1UfFsEuCH4ZP8AxM7uZAgK26GklccJ3riz3aqGWWFOZyxhJVsVLwyzVJ/1RUkz23YdaoX8TiTryGo/tcOa1r8z4XEitf8Ac8HqT+Ayrb7nWNcqMiKAKdQnptXGc/fiUwXK+XHMdwXDhidwzoX8I7bFlK0qUAo6w6qCB6Gud2v478KSQ3f9m7shPi7nEY+2pFa49bhycMxy6TJDseqlT8oOw6UiobqVsIia824Z+Ofs6xDu03eUMw2KVuFJU08y/EdNwmKsVl+MHsXu1rRcXGN2QAJBds0LEDz0r2rV54dmR5UordHa2Qka0hRPjP0rITt4a5RiH4nexfBsTcwrFc2G0fQlDyu+YUAErAUncT0Iqw4N209lGPNhWF5+wR0K4CrpKD/tRWsJqXDMskXF7ou5MgAiTQ4556VpWGM4XiqA5huJ2d2FcFh9Ln/hJrdUCnZexmBNMlTXAD5J6UkgHlO1Eq4iPCaW8aQCZ8qakgq2DSCeOaIEeKkoiUgbb0VkDxDii2Dp7IWoDelsUyfOaaCFeI0ZHP2FIkBKQrmjIiYpmmTqVxxTiTEK+kU2NBJPTrR2G1NGqAdJ2pGdQEbGkDYRqJPkd6aVEq24o64386MACRQIU+m9KVbBR2oAxuaQUCSQePP1oASzsQikFeGEmDttSBCjsDtTpB5FOx7oW/zEwKh8w2DV9aNi4bQ8hD7akoWgFIOoeLfrUqoknSOK1cSOm1ME7LRIAmRqFIabbMrQ7pRZGx+YeorMVK2TMimutyCtOyh5daDa0rSDPNNbEsynZMUCPt1puvcpPnTiQRso0XuOwSeSCfaglSlHmPX0p3oN4NIhA5osEOAAJI+9M1Qkpnc0iAU+AnzoSoAkEz601TGpCVsZ59TTYM7mackAbHf3opTvGmixDVUCDGqIjrT1CDNDUCClQii6GkNUCOgE+VIyYCY+tLnedulGOvSiyQbeQFHfk8U1J324p5A6n3oboBsEKE8UoTqKyKcU6U7/AK00BXJFFgIESRoG++9Ln286cEDgK28qCSRIIA9KdjAk6eDFP9CZFDpO01j1FKtpjrU8iDrIJGk7bc0kkkxSmQSAAaYDMlUgiqpUN0lsZSUjxARND+0TB86aYKZSdx50R4alkhWkzqBoSYAG/wCtEnbeiQNM8U7GNgJFAqVEinQkHYyabBTsBINTdiew4SUyBQ1Ekz9/KiBHXagInT9/aqTKsQXEEgxQUVJMhR22FAhIkb/yoiFAeGD1qRX6iIGnWTuaRCCdJ3mkQeKaTBnSI9eaBD1bHc/agVHckgx50QN/lEHrTTBkHqfKgYgSRtvtQA3BO1IJOuAdqC0q4B2prkBx1GN9qKgQneDTUgCYO1PHiTvvQBiSCTtweaco9CZHUUiFCQPtTNR8oquRGRJSZIPIG1KQrbmKYlKvKBWSBACTxSbGNkkwnaBSIWTpn1jzNEoSSJJ+lImBv9DSsAAk+LYf8cUJSkEyJPpSgp2I26xTSUlW4gcU7GxxMwIPrTCQPBG/pT1LgzqgU35vEQY/vU0xC8QSVTueTQCtoiadMjVpmNgKCjAkIg07EIGdyDPSgkkE8iKAIJ1byN6eFgcketDYN0bpUSAR96UcST70CrgJ5HIpoJO5rJUdFJGSI2kmgNzzS3HI5oRpIg0qE0hSsninwY3P1pupIAk0SUxsRTon2hdduPWikwkzuTTJ2IO+1LeRvCfOmVVoeFc8UiZEUISRHSgDJ2IA5FKhdKHa9iD0pwIkT1rHpH73HpRKtwB9qTIavgdIHWlM7cRzSgHeftSCQU7kmKaJASQZ1TSgmYH3pADkA7bb0dRkTx50MpNikTKpmjMccDehCwDtRB2J5gCaTRLdg1gHZBJNNTKljwkb70YB8WoQfM0o4g9elVdlJdhxbEmCozxtQSkmCCDtvQCjyVbjpNKdW070W0htNIIB6RIoxIO5j360AkDaaRMGCk+hpbMgCEgfLuKdPXpSPhERAoSCN+KXIUxcnYfWm86pHApwIAJFNBkzG1V7xpDhqCZED0FATMqFEERvtSEckmPSlYuQbhUmmmRPn505XPhSYoETzQmaJCAIhU79acCSYImelNBQBsaR3/kaO4NWEjSDtApbASZoCPP3pBRmBuKG6F0hIUNp360pI4E0tUc0AoDY/ShjpsRBO+xoySdK4j03oHVz0ppEgEjenyFVyOJEkb70p8zM02Dwn/0o+IDipBq+B6txAG9N0kbk7ClqUBvz09aYSudQEgce/lRaEotDgkgyeBxTyUJgEwTTFK6ET6UBqCoETTsrp94+IMAzRBbSYPWmhRCvEIpQCZI4p8icWEnqKASrTr1cUjEjpO1NIUPDHBNL4FJbB1AAKj2pyiYBNAADk0iCdpkUe4S9wRBTCv3j08qiMRQ0cawV9S/G269piZMtEc9OetSpSRz0rC+lC1skAlQJPEDcRv6UnsFW7Mh+Uk9d6eI3MmSKx8o0kHbifKnJUmASKLDoHBRjyHQdaKjp+UmgICQTQBChMRVNjcVLgJiACT50jqUk6kkzTVJMg9KO8nf2FSCiJKvOltO+3pQUCnePekoA8SfKPOnYwpJCtU7DaJpwIVx1piZPhKQelLp4RsOaZElbMmpA4HtQKiOKaB68eVPTCk+tSJx6RpUNlTMHihKlEnTsehoGBJIpbKAFNX3LVhO0FXFKeSBO1IJKz3YTvPSttNgphUXiChWnVomDHr71z6jU4tNHryOkbYcGXNLpijS2HKtz6UhCusjzHSvGP4ovxOdrXZj2p/0ayhiVpaWSbZpRbctkOmVKVuSeuwqi4b+OTt0ZStF65g10WjKddgE6usbGssWtxZoLJB7MqWnljl0tH0HBJII4o7gElPt5V4Twv/KD9oAbbViGTsv3WpvvFqhxuIMEbKqfwj/KFX14tTV72a2MpP8A1N458v1mtVmi97J8tnswEkTOwoz1HnJNeUMA/wAoFlbEkIXifZ5dWqXSRqbxAGPuiujZA/Ft2ZZ8u7TC8NwDHEXNw064NTzRSO7+YTp3J6UPUwW444ZydRR2qR6wajsw4tiGAYNd4thTym7y2bKmF6AYXwNjsan28VyKi1buB+07rvdOhJWhsbieYqFxnH8q49hl5h2hnCmSUoVeqUu4dT/ooBSCTEfWvJ1Pjmm6JQhK2d2LwvP1KUo7ERY9ome7qwcU5mJ5DqnW1IgAQABIEJ4Jms2YM+54vHbVTWY75KUufmtsulIUI9KRZynZghGYnl6ADqawgQT9XuakWLjJi7dKGr3FX1ncqFkygfbvDXxk8up6r6vqfRLHgVVH/wDV/YqGaM6ZyxJhzDWcdxRg94lZ7q+cSopBmOepFVlGJZjxXMlxdX2M4qAyhPN2uAkDqJitvtj7Y+xrsictrrMpzReXN60e6ZYTao16T/nTA9a8S9rHat2ndo2MX7uWG1YZg16qG7JjEmVOqa/dStSSNSvOAB6V3aTS6rMrT2fdOzk1Gp0+J/l3+FHonMnbJ2eZXzTeXWac6vXC4KRbtPruHDG0Qk7fenr/ABZ4H2XZ5wrN13kHG7xu0tUuIadvGmVKaWnwq2K9o333rw5admnaau+dvG8l4q8h1QhbbRWAfpNdR7Y0Y3dYhhlu3g93cqYw62auC0ypQQoIjSYG3Fexj0McVZJSbaPOlrJ5E4pJJnY3fxW2OL/EP3uWrNlV2t5TaxcKUtCXFFQEBEGKsmA/iX7L37e0sMSxK4s3bkJbCyklEjz2kD6V4/vnrm3blWFqSoJ4WCCn7iodF/fFLCnu6bS2s6YO4J4rOegwSXFfqaw1maFU9j6E4lh1jm63Rf5ZxmzxK2XdIdll8OKAHE77fUCrblfALqyLveuBCy5MgkzPrXzdyH2n567L80jMmTcacsrtKVIUkBLjbieqVIUCkj3r6J9gX4mM69peQDmLEWBZXDDxsnXLdtDbZdAkGANpBry9V4f5MOtS9n4fyelg1ks7pR3+P8Fqeti03pC3nzOyWmyT/CmP5UxHErN5u2y3il2FtqAShlaffpvzUtadoedrl4BzMl8Jkwl0p49q08VzFm24P9Zx+/IDS1qK7pZAPTaa8xxwx7v5fydTeRrhL9X9jwF2uYdjGUe1TGLS+wq5snPiUE276SlSRoBFVnBe1TPmScc/a2U8z4haAKAWli4WlJSeUkAwRVj7Q82Y0znfGmrt8Ygwu+Wpxq5OsK9id0n1BqlP3WVr8uBpi4si4sFxtMLAMHYcV9ZpX04otPlHzudN5N0ek8g/iLzHmkBTmLYmi9J8TBuVBK52JSSd66KxnPPS2A4vF8VSWwO7S3frC0+kzXjKyucKw247rD7/ABDvAqRFpunzghdd67OO13JmCMt4VnTGMYQlaQU3KLVtxSBHBBXJ965tTppz9vE7fx/k6cGeF9OVfQ6fY517RH3kfD5jxhBSAe7ViCzqAnnfnetO+us7rx0YndYhdqOgJWsXSgVD1IPSrTl7Hux63ZbxO1vs2OuXQlCk2bEKT5xq/nUpb4pkXEMQ7pCM0qK95Vb24BH+ua8zLkzxdT2r1a+53whhntFfQrLOJ5zYdUtWI4oqS0YN4vTsONzUmHs33CWUfG3UKCkz8QoaidvPeKtr7WQ27pTfwmZ1pbCA5IYHigxG5/hW8VZHTaM4y/h2bWrZSyhCluW4Gr0hMisHqcuTuvmaLFjx8xfyKo4jG0ltQti4lhoklT3i1RHnxtUGw5f3eIKL2G94VoIVpegATxzXRsWxfs+y/hqr9/D8zXDKEd4otPMlMD/8mZNVdHaV2E/G63cOzI08Vbocvmkgz+9s30q8cc0+Hf6/yKc4RddL+RG4ki9XetsqtEhWpK0guzEDgnrT7y3ufikF7DEFCo3S4difptV+tsT7P7tTV5/RfEjbuNKebdOItBsj/SLQEmm311lZFqq8Tk3ElI1Sn/nVskojpDY/jWEp5Fta+ZtFxTrpfyObXFncB+4bTh7KEqSUuqU7JJ6RtWG3ssRftl2rjlrbslktl11RLbaepUQCY9pqavM7ZCaBtmch4gXwQlSv22QRJ5/s61sXzRl45fxOzscpPsvqtnEJfXiq16ARAURoAPtWq8yNJv6krJG6Sf8An6leZ7NLG6YDqM5ZXd21A/HuJn1hTVQlr2S3FpeXVxbZuyyVOBROjEkxE+SgK0za4taW4Vb3YQhTcwJET0qHm9aS7bOYihbjiNRB3Ka7PYl/7OWd3t+xv23ZniD7T1q5mDL7jq3dQ/5wZB3PqalcR7HcbYSi7XeYKhCEeNacUY/Qa5rk2LZktsFfccfvGu/cP5LanAgqA9zFZ8Dz1j+MXC1Yg5ZvMq2AFy22UiIgajXRDSzyRtI5nqIwlX+fuTttgt05cKcLjZZfWAFjeRxMVLYdgWC2qXRiVu1dNIVOpa3GgAOf7NSazYBlbFcatLd3DrzDXVKTC2ziTQUkeoKhBqQusj44LdVi0zbGEhICr1kSd+pVvWXS4PdGqlCW6ZnDvZ5aYU9izWR8NupmUu3lwQY45UafZ507P8dty1i/ZtcYkjCrdAsrdOP3DTVvJPhSAJA2GwIrUvezvNlxltaU4UwruUlxxTd2yYQnczCuNqjexvKie0nBcUxjKbqHrW1cSw5dl5LTJcidJUuATG+1N5ZJNKP0K9ltK/qSGYf2PjVuX8vZbOX7mzbcLa7a/efSqEApSQ+VdSQY6VTG2M0MPM49idta3zVg2lL3w47tepUEnSdlR9K7xg3Y7cWyLpN3mbBEuKg91+02lFMp3kIKjU0/2Z5TVhgYvM54MwkCXS0w69qI228KR+tcssk+rZG6jjS5/d/c4zhGIWuaXjb4Na3lzdoSVrYTbqU6kDk6QNwOpG1Z3LHNFrelJwW/bGtKfFaOD/y16ewzI3Z/bdkgtGLzG79q2xpKmrnD9NtcNLWiDoXKilBHNcP7UMN7Tsp4g7iOW88ZjvMJQ5LSH8RdLqEj++AQFn1ArRuEK6nu/gZw6sibiuP0/sUvFba6CmXF2V2DMkKtlj7SKy2jKrpl14NPrmU6VWygR77VFXXbn2ysOsptM7YitKVg/wDS3I+hmseXu2/tgu7BbZzti63i+5Lj1y4sJMzzP2rboTV3/nzMnkl/1+v8Gr2gXuH4Lly5du8GRfNKQlK7d9SmkLAI5I3EGODXIGM7dlzxQm87L3UqUopUq2xhxM+wWFV1/Omae1LNmXLnAMfz1eXuG3aUh22euClDigoEaioxA9a4crsvxHW4lFq1cFaplp5te/oUqMV6OjSUG3ucWryPbsTKcz9j5SO6yjmazSFxLeLMrEH0Uzv96Td/2I3d0lnElZ0Z/NlxATbOBSfcaI+xqPR2ZZhtStl3KV8pKY1EpKvY7VjvezjGGnkKey9ibWpE7MuH+UV2PpSuv3Of2pLn9vsWDN+D9juccbu8WHaBjGHruW0aLZ7AQ4lASkJA1JeE7AbxUPbdnvZ5a2627LtgwxJcT4kP4fcMq9ONQ/WtFWWL5t1wXZdQUIjS4mCKiLvLD9y4HPjXWEAeIQN96hZore6HCMpbNX+iLZl7s8NrdoewPtky426jxAN4k+0s/QtiK9Jdi2XvxDWr1rmayz5gGOZfU+bR03+MrcaWUkakpOgqCkyOnWvHOHZUcVcFSsS0KXsNt9j1r3x+GzD0WPYXl1kvzqxjFFqXEHdTXSo1HiE9Pjcsct1/noXDSwySUJxW/wDnqd5LeFNFAucwWaVGNSWQt+Nt9wBNbamsqWjSX7nGrt/Vx3FoEjcEj5lelVBCsMZWhD1whtIBmVATW858NfW1uzhjLl0pTg0hhsqlMEE7eteNL/UOrfFHbHwrDH1o2Tm7K7Fqu4tMExO90TCnn0tAnfokHqPOuP8A4gu3fG+z7AMu4plnLeHMKxR9zvQtbjshKAY3I23FdLbylmRzCnmmss4i3LZBcdYLaQd+qorzn+LHJuPIy1k+wcNrqt37gBj4xkrkoTuEhUxtW2k8S1uXKupuvgVLR6SMXsrp9zDgn43XgpLeYcktr4ClWlyUH7KBq75f/GT2Q4wSi9uMSwxaTpPf20pB9wT/AArxhfYBi+FrKbvDbhtRjdTZIP1AioLCsOvsSfNlZ2jj1w66tKWwIJ+nlX0y12SKuaPBejhJ+yfSzA+2nsuzEoJwvPOErKvCEuXAbJPsqKubNw1coD1s4l1pQlK21BYI9xXzCHYrmBjLqMZTeMNXKndCLNJV3jmryUNhWLMHatjuFZo7sO4zlZ5LSG2mC8UJXCQnUlSTB3Bq8XiWLI6IehyxXUuD6iA9d/4UQQBzzXztyn+I/tiwxlsIzlcXmkQBdNpd9hvvV8wf8Z/aLZBKcZwbCr9IVCjoU2o7+hiumOpxS7mDwZGrSPasTA8jTiYEdK492E9vye2V/ErNeXf2XcYW0286RcFxCwtRSAAQD0rr+0+LaZrZSTVowfvHQCI+1EyE6UxJ8/OgCImYI4ppJPqaYDwnbmCKA39poSCSJikDPyjigp2GNzPStPE0qXalBBI1oKYMb6hW5q6aSVHyrRxZQRZKVrg60RI/zh+tAJG9KimCQJ8qxK/LWF7kL2V6GnJHhidqS060FJ2SRE0k22IOydymSaStSRtEdKY0ohPdK5SYp/WPKmIWvfYQRyOlOJkajQgKOnr1oSflImPvQA4EjccUkkAGd6Ek88UQd4RMddqADPpQMU0nomkZA3FAcBmPKfKkSD+7v60jBUfakCeOlA2JQITsBTT4hpomdIEKFNKSoyJEVSFyFO5joKfPh2PFY90mSNupp4gGCdzSY67gUBInpQ8ceIiOlEzBhSeaEgCCD70hBEgT9KXHIk0CdKiPtSSOZoAQ1AQog0diJmkN/mMfSgAQDI255oHTYCk+e1BRnYKINHY9f1oEFKtJIM8eftVIQUqJMAyeo8qdqVMACmhIT4hz1og6pHnQwAOpojSUwTTTAOmR9aRgcn7VI0rCRC4HI2pEKmJA2mkRO51CjAOw3NAhkkffeipMKLmoxQOjVuAacCiIGw8qdCGkkJ438zQSogiR6TT/AEIk0EpI+Yb0hoStuSPQUCJiRtQVEyead4QIB5oBgUqBpgkeVIqVI8JAoSqZVFIkp8SoNABGkmSQDSJ2gER5mgTKdR+gpiZ1SobdaBXQ8bb7AetJKkKmN/Sj7q38qGnrJMb7U0PgImQNt9qCht8u9LaQrr0mnbncddopAAFMbiCKA6gSD0mkQCI5JrGJ4neqpMDITpSZ5FEkQNQJBphUZJKY2ikoEcbjzpUASoRuaBXp5FNIISArjptQJKiCTtNFAPKVrgTIJoKGmJjcxFNghW2++wpEpJkjT9aaAIICYC/99AqEEb/WipXCdIA86QEjc/Sn2AaUp6g7HanBOoiEc06EqMLVpIFNIB06Soyd6Vgbv72np0p2qQU0N1fXigJjjjmsjcUx4TRAM87UIncilpJIPQc00DYuN4FOBSUwZG9D+J6UFCUx602wHExtNKZOkcGhpkz0pBIB3PX9KQxSD0n1pJBCgqNulIpAjelMnV0FACOrgeHz86I32nb1oBaVbD70YmYkgedDEEEbpJVPWgpRGx/ShE76pnrR6bAmnyKkHdQmeKR4ppUTsKd8sTwaPcJ+4RKk8UR670itCudz50klMbzQhWwEK1c0jsOlAjeQmB6UvAOu1BXYOpUgFZUaSSrcigIJMGkR5GR6GndKiab5HiJ35pSnVHM/SaCNIEkmaaTvIO9JcijFNhUTREjemgkn0pBRkiKCmrVIKjJkmaIVvt+lNPQkQKfKRuBTfBHQwbDcGKIPWAaarc7UirpAj1qbDpfYJUE7mJ9KaVpMkCkTA+UUJG5PIpt+hUVQTJ3B2oyIg701JKhO9OkgdKLRVAICU/WjKeTuRQ0nmd6ERxzSElJBmZ9KWrgHb6UiBEjf1NDcqB6Cjkp7KwqkK2IM+lDaDBj0okiQJ35poSZPn0osSYRqO32pbcHnrSCgTA56UhO6jFBXI0yTAO1OGwgiT5007bkUhqUJkAUgW+w6JIWacdqYZiBxRTPmKAFIJ8hSOrVsdookniNqSTt7UybSdghXnRAA5UaG4Go89aRgjc0FXYSsJ21SKKlIG4pkJA3MilGoCN/KmyXFMMgbncmsiVgW9y2Bu6lMbcQoH+ANMkcCPasSnlIeS0DpS4IV7c1Ix6oIJA9dqSPkgpBNJIJTzFBJIB3mKA5HEhQAJ996ABCo29KSVJkwQR02p3hI+WDTsBbcEb+dLbTEfWmp3onkQncUBQTAiBv1mmwEnSNxzJpb7zRBhJ22oHxyDgg+dOlXBFMEEAedO1Ej1FFk1YlJAB2pBMCfOkAQZPFAk/WgfuCYHFLwxJFAERuaBII24NS+Bx52NHEsZ+GwvEbu4UmzsrJBXcO7KUW0glSpPAgExXKPw5fiWtPxAZsxzJdhggsXLFov4UsOFaruyQdGpc8LEpPlCvSt78WuL2mUPw94+r9qpRf4861hbbbMLUhLplzUZhPgSqvAv4U833OVvxMZYxKxxZtrDru7GGPJ79KCWXRoI0zxMfYV8XHTy1mTLLLulx+h9Hj1EcU4Y8aV/wB2dY/GLlTAn+3bEBcZ7wa1eatWNaXQ+sJUJlOtLZE+1cYbyVhzy1Ls8/ZafJSRtduIg+veNir9+NltbX4g8YZWoJS3asJJjwkwQY+1efVh1h/STq1Axp616Ph7gtPFehx5upZHaLVb5FxNRXaWeMYFcq7tRBbxJkJ+bfdRFSOXezHNiHlvotbV/vEwgs4jbuTt/mrNUKwug0HVLC/GNO6eB6Vmwu3L16UIJRtJIPT+FdTdIx5e6On2/ZvnmxtGU3eUcRUjWVamme8Bn/Rmrz2F5YzJhOamXb3Cby1Tb2z+lbjKkEKWCBEjneuBsLvsOUkG5eHiJCm1lJru/wCHDEcXv8wXLV5iF0pCcPfKdbpICgkFPXmuTJGVN2dOnX/Itj6PYNk3EEJtQjCHm2ksNpC30aB8o6qI3rHmjDMOt8Ku2Li4sO8cUhAQ042t6Z3hKSTVXw3AsERcNXlxirlyHmmSBcXRKQS2J5PnNTGD/s7L+LC6wNLLNy8lau9aWDA6g7mvh3LHLI00z6boyqNpr/P1IB7D2WG+6Ztbt47ElDCjP0AqE7Uc/wBh2U5CuM44zht40lkhi3bct1oD70SEjV7ST0Fdnfz/AIixhq725unGO5QXFku6AhIBnf2r5nfip/EDjHarnp9K8TuXcJtD8PZ27jxU2lsbKXp4KlkTPMV16PDDVZljd0cuq1E9PHet/f8AwcE7XO1LNHadmS4xvF8RceLhMJEwgTskDokdBVSwx24cdSz8SuY2349qt7b2GWjyC9hdm7pJJJb8RHuDVgtFZdeDDjuXrVYElRacWlW/lvX2WOMcEVCGyR85NeZLqZQMOVjuH4kS3iF0hrWCFBxQiu5drWJY9g+YbNvD725YV+zLVSu5dUnUSiZ55NU24tMppumn2cEecKnAnQbxQ2+1dP7TsGy/iGYkJvl3Tdw3ZW6UKZfSEhOnjSUnj33rWWV9H6hGKTKJa54zwplCxmS/KkgFIXcqWQevJrY/5TM63rZFxiqrohWnS40hYPuCDWe1yllx1stKxbEUAFSNaUtq2HBgxz71qWvZ9aQsIzEtlBlUrtgowPMJXzFc8p2iljvhFfx3tJzIh42r1vg5SrwkHDLfUPZQRIrtX4Os55pus5uYWvEksYU6h1b1mG09y44UFIUUHYkdD7GuKYjlrCg82+/mJopcSpISq0cBIHUxPSu0fhCw6yPaYvDG8bZtm1Mqh9bK1JgiZ081GepYZKS7F4erzY2e78p5WwHFrRCbnMN1aXbYhxr4cKkA8hZVvx5VP3uR8pJs3Td47ijmhCj4GWwT7c1Dt4J+xLZzEBm5l9dsnUEiyV4/rrq8M4fdO2YUMOu3lrbKgpDCzI07RXx05S7Rs+lj0TW8nt+h8vu2jLWHo7RseOXG7pq0auTFveOBbwOkSVKAA3O8RtXLSxcWinlFs/MkgEckCu69vNpiGEdreZ0X9o/ZKVehQQ8gpVBQnma4h2gu4r8ALrCXu5eSsJKgIJBr6TRZHLFFyR4WeNSfSQv7XuXL3uvhLsqSdtCDH/pVptMMv710Kcw26KEpBEg7VyPF+0TtBwC/atGMecKikSQCNj0rIx2n9pgQlP8ASB7Rq1ncEz/hXqeWulNM43kp9LR6UyjmXNWUnkPW2AX11bCR3K21uD3AFehezzMWL5lcRd2WT8USEA96k2i0aBHJkcV8/me1ntJbdNwjNDqXFI0CGxxNS+BdunbNgr3f4Vnm/tXUkqCkREn0rg1Xh+LURpun6/4zo0+syYHtwfRa4s+0O9vxeMZJxE/moS2Ph3lEBIPiMDehi+Dds9zYiyVg+IMs6isoFk7sOseHavCZ/FT+JMeP/lXxJClR8rbe/wBdNZG/xTfiQUIV2s4pvyQET/CuXF4UoKm0dz8TlN019T3AjKfaBctJt3Ms4su2WPElbTpSDHMEChg/ZpmjBsXGKqyNdXboIKCq33T6Qa8ZYZ+Jf8R17eM2bva9jUOLAUToIAPoRTMW/Ez+IRu8XaK7XMbAYXpRCkiPXYCqXhzdttUZvxCmvZPf1/YZ7vbixLWUrwstBSS0sISlIPQgxWW1wrPAY7heX2rdtRUD37yQkb+c8elfPC5/EZ2+Yiju7jtbzEvu9x/WIqPc7au2p+3Fse1PMAaUoy2LshMzJmOTIBrJ+EQ9TReJyXY+hTvZ3mV0vXlxl5lHi0kqWkahO0CeK08RwvNeWcPxHEXsEw4IsrVV13TwbcbLSdyVIUrxD0jevA47cO3XdL3bBmdQSQADiDh/nVi7Nu07tbzbnnDMDxftMxZ+2xJ7uX0X+IL+HWggyHZkaduoqV4Z07uV0D8Qcux6/GdcOv7W0u7jLuEkvpBWG7FtI+kDYVUe0ntAyfk7Lt/jj+DWDLwZ7m2Sm3SCt08JG3/EVZ8M7MsQTaslWcssKDQ0hTd8nSPTjavI34lsw3IzdcZcGI29/b4YgISu2cDjC3DuVpVwqJifetcEJzydMl9P4JzZYRx9Se/xKji+YbjMWNv4reKSHHVBQQkylAI+VPpUhh96ErhslO0TVSyk73F3cIvLdl5XhVK0cAiraliwW406ltpAU4NQCdinqIr3nHp/KeRGTatm9Z9oGO5axNpm1ty53xMOd4QOOCK7rlDPdlmIW7LrSbO4fPjCySgRGwJ+tcatLDDH1pcNkwPFKQlshMeu9WGzsLJhaSzbsNqUdQKEKkH18Vc2fHHMqlyb4pzi7idIzddZhRizhsu7Xadw54o8IEbz57VD9jOCP4t2bJw+1U00y3jDynDG6lFtqNhwNjvWgznuytbC5wjFnEPMpYcAWltRXJBgHxcTV8/Che5QtOzPETmXClXWKLxdXwwbdWEFHdIgKSCNp3nmvMyxlhxyVnZiyRnlimi64LlbH13Fws3ykWukAlJgqAGwIirHZYJqtkXNw8psIGw7z5gekVbsAzHlK3U/cXWA4e00hlC2kpaA8QWrVJUSTtHJqWy7ni1xHHbli2TYJsiArQllvUkzJ0wN9iBvXizn2lL6HrqKXCJvDcFxBfZLc2mHl5bv7Ts3AWkEq0wdUAen8Kg8UyVj2MqTafBPKDiwnSpxCDJ4+Y87V0nMeKXSezp+6w5wyp5tpKEpCVoUW1AAweZiuVY7jOZVMqdZaW0tDbSkq4UpaU7mfPmnmmpOPV6Iy06l7fTXLOdZ57B8tW6Pj8UxDEbK7eKi0zZG3cQQPmWqTIgneAaoeDdmWWcOurywczBixTbp+JUEtMEKB9yJO1RuFYvnLN/axhycEuXe6tHCkNgFTZZ1/n6vPUCf0romZcCawnNOJsnCrpbK0gsqSgqBbPCZG23FdnmeVUbvYxcXmk/7HLO2rKuV2skuJwnMWNqev2NaUu2zIA8QMKKVkjivKqbTMOD32hu/aubVsiAsALHrIr1b2z4ph2CZDvbp3BHne5YktSpBgKEjp/GvKT3bXlUd0y9kZ5RbUQol0glPlz/OvZ8OnLofY87XJQpPcseHYg7qWEXVy0rwygvnzmQZqy2uYsctVBdjj+ItEJIBbulp+8GqDhXa52bIcSq+yriwBSStSbr5fICUmpS27Uux94lwt4xbuFUtkwRHqI3rqmsj2TOSGWH9SLMrO+fLdxx1vH8QfQUkaTcE/oabY9pmaEoWh3ElAwNKHbZtwKVPqmoIZy7J8Sd7y3zZilkrQCoC1Q4JPQElJkda3GHOy69ebdc7SLJhBQmW3LfdW5nUdex/hUuMkqbKajykSuG55zFiF98Q7YYU4EkFR/ZrQ2+iRNe3+wPHHXexjCbm4wrCX1KxrEEiLJGhqA1ASjgTO9eKrQ5LQpAwTPmCLKCouF1ZCV+UAKMEfrXtHsHwxrFexuyVgOJ2q0WOM3ilqKlKS6tTbROkx0jzrzNbGUccmdWBJzj8TrFvmC9s2UiybsmVqPzN2bKSP9nasuI5ozDd4dH7avEjXEIfUgcdAIioMZSxN9KbhzHrZgHfR3ClKAI9FRUqzlOwZYQnEcwXtw24fmYbQ3BHSCDXiRnkqur6nrPFBO+n6FTefVeuXFveXS7gp3KnXCSPuTXnP8Xd0ljD8o2rISAs3En/ALqd69cIyflBhwupRfOlXz97ckT/AKoFebvxlvYHbYXl/BbXA7NtKX3HO9C1qd+SI1E7J+nNb6SbnmVy3CcahLpW1HkrDsQxw4k1a4JeXibp1YQ00wtRUtZ4AA3P2rqGFZb7R7W1Q9d5dxa7ulqIW65hzilQemyZiofs5wpLWOnG8OdftbywUFMPIdUkIcIIBSedQ8/Wusp7Qu06Wg9njG3E8BIxN2f1NfQ6nLFx8uUqPH0uK/aoqVvhWf2UWlv/AEMxdaW3ElKU2b4nnjw/pWfNPZFmHtKwc4ZiPZ5jaHDuh4YU8VsGdtJ08VZcR7RO0tt5hL2c8dUEqBIViToSPaFVrXeZs/Xbjq157x5TawIaN67t/tV5VRvn6fydnQ07S+v8HmxjI+cciZkdydna0XhT7CCu2ViLS2FOtk+EwRIG3NSlzlvG+9ItzbXCVbjurlCp36bzXS8y5dxDMd61iGPXj94+2kMIefdU4oNk8SozA/nXNMawm8wPFHbK8aKFNrlsSN09I969fS6mOVdL5X1ODPplj3jwd4/CljuH9n2YcwOZ0fdwe1v7Jlth120WsLcStRIGnjY161wjOOUsfd7nL2Pov3AgO6U262/DwTv5V88cjrvLi9uGm096GkApbgqiesdK9Kfh1Ri4zvdKvmVpYOGKSj8spAPeJ869DHqpLMsS4OGekgsTyLk9I60jYUhuNueprGkEgCdiAZp42gD617Neh5lKh0gJAjninAHamJGoydp/SiD4pPtSsVhUQDtt9K0sVH9TUFSZUgkJT01Ct1WlUio7G30W9mVKsXbkkgaG3g3G/wAxURwOo60PYpLqdEgQCJJ3NIKVG/TimhY/eBB8vKnbRINIbajsNclKkuA++1ZAdhO4PFNUREncHasbRWk92pZBmU+1URZk1SowmT50RzvzQEgcUeDJpMdJ8AM6uYpTHP6UCSTsDRETvx50yaCFbc80lf8AG1Y1TAM7fenCD50F00rQRIG3PnFEk7Ac0kkCYPpQGqduPM0EN2HbUZO1KTPp5U0gbgCQTO9LSOdJBoAJKuKCgQQYmOhpbRBV9KI0jYGfSgLAD4pPJpxMUIn+NI+EgnigewCQTvQjyFIkb6EyaAKiRIgj7U6BscgHcjr1NI77SaCB+6TBpKMe/lSFYBKdzSUkEEzvRjgSZnpQOyonahbAIApATqkdCelBRhQX0NIEER1FLoUkH0pgEKKyY2pqUwT+tEEAEwQR50k7nb60MaT5EIGwV9TSI2KhwTvQJM7bgU6QkRIpDavcaRvMSAPrTSDGxj3ogaZCZII22olIAneadksSSobzyZI6UVK1GAQaRgCQB500qUY22pAEgEiST0pSCNqSZ3KRudjRmD4gKAGlY/u0AdUp0yKSgArxbUUpEeE7mnYBHEHgUCN9/rRJlJSoEetAcSZEUUAiUglQMJpFYiNO3nTYEQdzzvSUuAB+gpA3YQQDM7UisRBNNJI22mf0pJIPCjQBkIESNxTSgSfImZpDXA1CKRUU8UAwKCSAF7jge9JCpOkjbmkpc6SJgc0E6J2Mb7T5U7AJO8AxQ086SJoHVPhI+lOJAJUB/jQ3YBjYBQHuKZ11J1CDzTionYcCkpYI09f500wsIiNzxuKxqlSo6UQqEj2iiTtPoIosABO5E7eVO0hKSqIEjakNo3gq60yFpVqK9QpJAb8gREx0pGeADx50PSdj186RSUgTvWaOitgyPOaQVvsAaUSf5UIIVGnegbth3M6dugoElO0URuJH/pQmTHSgTvuPCjOkCgdztTZP25pxO+/NAAJJ6b0hKQd+RSKoEHmiCDzQSqESkp2G9AcRFIcb0QDNAxEmImRSBOmJjyilt/60iAIHB8qrjkSQQUx600lQJBijtG889KRid6kqrAB4QRzTtRgCmgwIXS3+WDTJb33FulUjiiYImCaAjgmSKcNQiaadBe2wEqM87UQU8kceVAROnypbdKlsYSsSSobdKAB3MClINFKwNvLcmnQqFq3jSQKRk7ihAgEc0geZg09mUEnqaAUY3pFQUkAGiRttzSAAjnUKR2529KMgiEnegBJhW/1o5EKCTudqRGrdI+9AE6J/nRlQEASKQJUhAkCR1oAk9eRSBCtqJQkCfKmMRMxHShJG5pddutKIMDc0iU2wkidM7dDSMeIA8UPCd+nSiTAM+9U3YUxRKRvSOwAApHSQCOelITwakpe1wAwkzAk+tJMbkigfCIABpEmIA3O1A2qdIJ8RkmlBAPUUBsPFtRkFPMGgXAYPpFCRxREhIM70okEdTxTQmIeLrTd9WkcUpOwA52mnHbcDek/cCVA1ajxSmORS1DqIPlSUJ3oHQgEjkb0p0KG9KDInejEmdNA1FsW0bDjk1hXpVetgAnwk+n1rL8qYJjak2+01cLYK097dpQ2yiZUshWpWkewqZbD6WOU2pAQqZC06h7UxCT4p4PNT6stYm6zbuv8AcWbZbjVcupbB3PAO/FYRhOCtgG6zbZEOTCbZpb249RArmnrsGPac0ax02Sf5UQ8gdRB4EUvF5VJY8/k7LGXsPzBjOIYg8zid6bK3TbMICyoT4iCdhtQYzD2euqDVtb4u94SZW82mSOgisMvi2mxfmZpDRZsl9KuiNAMjcgTvtWQBRI0gGs97mjKFs4hDOWr5Yc2ly/CSI9AnetfEs7ZbtLRa2cpEKOwLt4ojjnYb1y/7/pLqzoXhmdLgad5jziid4CUyfemdj+brbtBxtOFYzlSysklS0ILFytSiEpkzNMzBnWzwbNGL4D/RO0casL4sMuquFpK2wkTMdZNbS8XwwgsktkyI+HZevy+9WZDIUIG4pAHVO1Qt32rWzS1IbyfhwSnb+2cNc4zR+IrGMMsDd2OUsHDguFIAU45o0Dz3mazx+OabI6Kn4bmgrkjsc/Y0AYVOw964XhP4gs34nbF+6y/gjASrSA2lZ567qrNa9uWabzFm8MbtcHbC3Ut6+4UeTE7qrp/3PA30pkfgcqV0dumQY8+lNckc1zT8QfahmPsjtMFGG4PZXL+ItqLpdCuhHiTB29q5E/8Ai9zTZ2pW7l3CXnNMgHWnf18VN6/E7TZnHTZJO0iO/HbjjjeAZay+0jS245fXyxuZ7oJbSf8AbNfO7JuJXWEZ1wzHLdf5tretXKZ80uAj+Fe5+0Tt7wztUtcNdzz2cMuJtGHGUizxFduQhwgrGwIkwN/SuXHDvw32LpcT2ZZhaWOEoxpKwP8AXaM15GkksLklvd8NHb0OWSM5dq+h238WfaJi9l+IF7BLS9DeHHAMOu0MaQQHHWyoq43JO9cvVmpLiP61h9pcAzqDtq2oEee6anM2Zm7K+27NrGacWw/MuHYsq0tMIbRavMraLbSdDZVqTJJnc+lY829m2Q8o4+vAsVzvjNncsJhwmxQ+0ARI3C01mozx46l6+o7jJu9yBD+TcTlb2V8IWtO2kWbcH7Cn2mBdl6HSv+iOGhatoAWkJ/1VCsf7G7OrZ4t23aiyNYkF/C3GQB5khSqSct2DziWLHPmWboKV8xvSyY8/GkRT6ciWyNVKFUyTdy12cXbYaXglqxEgJbedk+u6zVq7KMFyVlPGby9w6yUCLJ4lTj61IiOAD1rLgn4Ze1THMPZxbCrvL9zaXSApp5vFmlIUPMGauuVfwr9qNop34tzA+6cYU2VJxNtUKPXasYyknUjWFL8jXzRMZm/HF2HYEtdr/wAnmYb91DIROgMJUsAAKEubDmpTsR/F1kbtizj/AEHw/s0dyza21o5efHFaLq4cKVJGjTCYB1GTqPA2qm4n+CzN+LWQau8Ty8Vp+VwX6ZI+xirL+HP8J+bezrOb2PYve4AUP2LlohNviKXFqKlpggafSvM8rErUYW/g/wCDs6n1J5Mn1R0T8SWZMn4V2UY2lq7x5L16hOHsK7lltKVufvDxEmEpVXzWbyzg+IXzzxzXbtalEpVcsubJAgA6QelfSbt27Cu0PtEwxnK9w1hmFW9hcm7U8vFklS0lBSmUlEDknrzXB8x/gOx0s4fcZTzPlxtnuSu7dxLH21BatiCgIbECJkEmt/Daw35kOlv3M5tVDzKl1pr4r+x5VcyFaHS61m3AXQOEquloO3SFIH8akrXI1w62lVrfYaUgbAXqAVE+UmvRWD/gKzI6UX2L5/ycLLYhNriZJWOsHTt9q6X2U/gnyXh2Pt3udb6zx+wVIZtbO+URqAJGshKSU7dDXqS1GPq6Gn8n+5gtNKutyX9/oeK3eznNd4oNYbhSFuSNK27ptUef71dN7SOzjN2K5kaxLCMvYnctixt0KXb2zjiSsJhQ8IPWvXmXRlnAr5xvL3ZdkrDVMQpK28KD7qUk9XHCTMcGr7b9oucX7V2cacaRp/KbYQlvSPoPUVx5fEIV0xNY6ObqVfWvufPjB+wDtjxlJRhnZ1mJzVvPwDiU/UqAirVh/wCDz8RN21qV2d31vrVH5riEbeW6ua+ieUMUxDGuzzMSsRxK7fdSplHeuOkqAPMHpUTiOEsfA2yFB1aVLJGpRUoHbkk1GXVvCot91f8Al2aYsHmSlFLjb6e6j57XP4DPxDXVy2W8CsLdCDqULjFGQAPIwqRXUuw38IfaZkHOX9Icfey9bWwbUlaWsVQtYMeUV6hZw3DbFq7bXZNrDiiDKAqsK7PCUNoDNsyEhCpQW9IH6Vzz8Rlki4/b7Gy0nRvta+P3GHKNwbfU9j2EpGncKvAJHtBNWTHLPHMv2FujMWaWLT4hs/DodvlwUgbGANokVQrwusPuJw7DkqSpAKiQCkAncz0rpHbk2lvEcFKUS5+z3AkhMmJFc0ccfKeSF0ud/wCAyZJrLGEmnd9jyD2k9huP5ozVi2b/APlPyl8FidwlfdXbzyyISEjbuz5czXPcU/C6i8Q5bt9omVUl1clSF3K2wof53dbV6hzHhbjOErUlC/AwFALAEnqTWJzDbD9i2a7FpSy/DigngqPU+ldEdTUOmKa/X+Alp03z9DxBmX8CWN4jc/thrtQygWEgIKgLswry/sa0X/wR4rh6Qg9qeTHFkbgKuxB32P5Br3Ff4Uyq1Sx3HgKiSjiTHNVbF8Gt3bwNotZUgArM7TXTHXPZb/P+DGeliv8AP5PKOD/gS7QswB9zLeacpYi1aNl65ebun0oZRH7xU0N9ifpVeP4WccaJI7QckuwSJbxFyFEeRLQFfRDsMabsMm5+Qm2SkG0Qkp4Grun68yLw9i1aSlm2Qhv5ynqSRvXY8vTTd7/D7HN0qTcdtv8APU89Xf4dc2W6ktpzHlNwg7BGMt7j2UBFNZ7BM86lBIwZ4+TeLWx/89XvMmD2Nxf3Lq7YLKnSCAI2qj4th1vZPdyywppCtp1GR9a1jKM/X/P0MWnF7JfX7kzgP4e+0drE7Z+6wRpduHRrW3eMOQP+6smtHMXYrnOwxp+3fwF5JUS6gFBKu7/vaRJj1qv2rb9spzubm4SDO5dJma6JhbCbHscxXMdm69b46i+S2jEUrIfQzKZbSvmDPFbw0/Wm1IxllUKbjfzOfvZAxe3X3Vy0wwNUytRT9NxSayK8sSzc2KEhfiJekGtgdpnaPh6lJZzpiTgV4VJdfKwRHkomsau0XMrqVOXtvh93KSNa7VCXD/3kgVD0kk76rLWoj3iFzI7geX/znh50kf8AWmftFWHIWUV2mbMPf+NtEFLoIhRKvptv9628IVb4liPwibANr+EafdUVSAVJkAVfMjstYPj9jiiMPtbtds7q7m5QVNrMfvDaR1rzssp48nlvY68XTNdaOw2uC2dpgisRWlSu5bU8rUsgSBP8q8PdoOLYbjV2/e3CFWLj5U4FJ8SDvxHSvoFmnHnWcEtn28vYK21drSi6ZNqNPdkeIJiCK+dPaRbosrp5oMLSEKWkbzA1bD7Vfh3S5vew18moJUROHX7D147cXV3bWyQlAh1RBVHltViRmKyCm2U3tmpKtkq7zg/aqBmFpld+lGpIaS02qSrrHlWnZpQ69p+LAKPlCZ2r2pOL2o8iMmuDuOF4vYAd6cctIR4QnvhufapdjNBYdU6zd2YaSP3nx964qzbtWLXe298or2J1iKkXMc+Kte6W8kBYISZ+asVFSVmnVNHR7zMVzoulqxDClhxBSP640lfXpMnamdmeec2YVfuYllu8tDYB5LT7FzdJaQswJO+4O3IrjN1ZPJuG3W3oSFSrfmt64+GS8GVFSUphUDgmKt4sc4NUQ8k4yTTpn0m7Ns2ZXzlhBbv865WsLgAJetFXSlvAnqdLZkGuhZfssgsOtXGG5yQu4ZSrxWVg4riJ3Vor5j5N14fiTGOYXijjNwzARpVBHrXtDsM7X8FRZN4PmdbbV46AhD/dkpd1HgjzPnXgazw+MLlhjfuPZ0uvnkqGWVe89dN3ttjnZniTmXr9/wDIxK2Hf3Vp3ckAnZIUZ+9c77Tc5ZfyTkc4kvA3MTvlp7lpb944gLdUPEQhEaQB6mrx2bYnZ49knMbOFOC5FtidqhSGjujY7EV537cH7vH84qw7DmVuYfhqDblJWmO8J8ZgnkRFckMbyZoRrsr297OlTjDFN9Xd9+dl6Ep2DLu3m73NdnkTCrVlcWzaltKcjqseNR9K6b2m4pmpjCcHxHCcVuMOC3HLRbNo53TYBSFJMJAE7KqX7MsiYtl7ImB4eLVnS8z8S6Fvx4nIVOw9q3O1bA7RGSGr/HscNgxa37KAmyaD69a0kCdRSB1rDPmy5MzUFSX6FYI48eNSly/1PI34g8w5xxHsmx23xTMt/dsBglbKrwqSoSPmHWvAzT9utZCtOoRIHQV9BfxAnLWHdm+Moaxi8ecdtVaGXLRGlzcbKUlew9Yrwc49hKXNRwpkazyJH8DXsaOU93Lc49altQENsLQAGkqP+jVi7PMFsb7P2Wra8ZCG3cVtmnQDBLa3AlW442JqMtL3CGyNeEJVPRDqhVryTcWCc75fetcLd1pxS2KErega+8TpBJGwmK6+q5bHIoqrOs/huyThGI9tOXrG+y7b3tpcYbjNyUOMJelCLlTYCkueEkEcnpFemfxD9jfZo92GZxxez7LMMtcUsMKdct7tNqwytlyU+NIb5MVwv8NGNWdj2+5Y/aPxFu2rC8dtiQvw6jcuKISoj5ZBFeru3jHsOT2JZyYZtikXWFOSpy4K1EGIgACvC8Sk4alO64PY8OuUXsfHnDMjF+9DSpCNQ1AHpX1I/Cemwwf8OuE4baoDOjGb1ahwSVJaj34NeDMCs2W7ou9ygj+7yN/even4Y8Vv7DscR+z3/hlHFnQ4tLSFFQCEwBqB0x6V7OrmpaSV+48rCq1XsruzsVrislptrU7vvok/wmps2uM3luhuzwm+c1KkBNuvf9KjbbOGZG2kMt5ivlFahw6U9P8ANin4je4zfMIVd3D1wSr5nXlKM/U18gnjTt38j3+rI32JFWDZoQ2e+wktg7kvPNtx91CvLn4u8DfxRzAb1GI4QkNPPtd2nEEKUo6RsYJG3vXog60OqBKEmBMivN34um+7wvL6g0nu1XzqiUjro4Fdminj/ERSTImsnRK2uPT+TBlbJ2AZc7H8rX2O27ir3HLvEMQacZudMsJW22lPhBn5SZ43rQubfLCrMOs216gIJCB8SSSfoPLrV2xHCrzM/Zd2V4fkq3axI4PgLjV+2i4bStl1a0q0kEjeQZqt4h2Z9oK7bvP6OOJ0gyPjWABHrr2r18zn1tNfQ4tMoRwp9W/xQ2zssolFwDY4lcO2ih+Yq72WCBvpCfM+dZ7O3yQppVzeMXhWSQQ1dqTB8oiorA8gZ9Dl25d4G2grIIH7StwPvrrLa5Gzq24pambJttS9QSvE7Y7fRyskpvevoWui7v6ombKyyXeJWluyulOBIPdqulqSZ84IPHrXOe1zJTTdgrMzbTbiC6GFmFAtoHygSfpXS7HJGaiVONNYSg7FSv2pbif/AIlSuL5Bv8wZKxjCb3EMGaUtgrQhWIoUdaQT+4VRxWanPDlUol9EMicdtzzp2c4/mfKeJXV3kLG7vCry4ai6ctnSnvmwZSkj0JJr0Z2C9o3aNmXNTuG5wzRiV+wmzcdQ1cOSnUFAg+4k1xnsSyhheI41e/0iu1lhNslTJsbpHeE6v3gUnaPTrXfOzBGQ7bOhssFtMWGINWzqe+fuW1NluRqBQEAz6zXt6fLJ6uMWeRmxryJ7cHakolIP604q3CY1HrQC1RwJPT1pDUDMe9fUN0eBwgkEjVSV+6oTRJjwxPpTd+CZPQdKBp7CUYOx60y6ZL1s6E6ZCZOrg+Y9/KnkCY6neg4vQy6SJBQQfCDE9d6mXA4xtjgCpRkc9aIBFIFIG4NAGBztPNNcBKNbsQnYE80lQUx1FJGidjQiFQrrTuienaxNuFSdQG42IPn5U/VtBTvWBYUhXetkE9QDyPSnhaCnvEnVPl5U2gSZkA6k7UoAnWqRTDKoiUjmjwRtIqUwkunYR6Ab0lA7AxPSkgET50JIMHearsTYSqFCfbajqkaZ5pspCtM7xSCSFAq5G8U1QDt4BnfrROwkqphIVxxRhJEdakAgjVuOaSoG0R7U0kAQDJoyYPmaB7AKQAFfTilKCQmkkiJnfrNACVao+tAggSDBpoBHFOnoOlJUkRTugaoQMCSd6UhRnrQgBJJ+WYHWgEEHUVgiNgKErCh26TvO280EEnYqkUp6TTUzqCevlSAcoaCEJ28wORSKtR0iRt+tIKkT160gfFMbDeaAByAFcjmDzSBKDvSSQpMRtQVKjoO1Oi200EKk7jcU0gkxMzR16U77HrRkT4RHvT4E36CCkpGkkxSBBETJpgSrZR4owIlJ5o2JaHEaQSrf0FKeDpI96BJAg7k9KCioJgGZPWkwHE6jtsaaoAlJBII5pE+EeAz5npRAUVSQCTSKca3EZjeJHWhAI25oKV4YI4opiZQduvpQSIlUQTztRAUmCUkyD1pu5JBMinEpAGo+1ADRMwTxsRRUjbbielAgTII8RkikQmTM7HpQNoCjzsJNNgj5RTl6RBAVRJIHrQIMjYEeKmwNwftQ/wBFQmiFnTuKAFp3lPEU2JO4HmaIPhChuaMp1Ek8CDvQApE+Qocq0/WkCkbTzSIGr594oAJ+YyTP6UCEeR35pAq+WRHl1oLUYJBAjigAyODANJaVaZH3phk7jeKcVEJHXzFAU+Qp+Ubz70pHn4Ymmjz6GkpI3IP7pkUWBvQNvSidMSihvzH3pEbb7+1QdNMPTfk0hKT60uNjxQOoERxQOTaew8qOolQ5pvmRRUdR2po9RQKQpMiBRmDFKSSII2NGJ5oBKxCT4uKRPnvSJg7bzSJjdQ29KLELUoCfLigN496R59KRIAgdelACVJgGlBHAoyJ0n9aaQY54oAPHXfyogyd9qA2HI+tLbpQIJVHsaSSJ44oJAJMnfyowPI0DqwmCADQTvEknfpR0xvINNggQOaArsHlPrQiBPU0f4UFAg7EGnYUEK8MDnypSAdiJpoJCtR9qcZO8bnjagBCeSd6RI4oFWx2O1IEqECgELUAmneA+tNG3++jMJkRA60JDVtATsYUN6f7b+VNjz6UNU8bUhBMkyaWoJ9qKYkgjakR0EUBQNweaW6jzFIA8xxzS1TztQCXoICB6Upjij152oEeR+1BVMWxAA29KAI+golIiTz0oDmCDFBLQdR6UFkgbiaMDke1IAExQVF0DhMxNJMAhUUt+YEdCKXSKAcXYXBqPM0NOrbiKdQIUQYBoBxCCQBq9aEn9zigRAj0ikmQkQYCfuaCUrCNt+DSMjc7k9aI/zt6AIO43oNKSESkkA8UiBuQKU7yeKRO3uPOjkGLmBMUd+TzQTBTMfWaUqiI8NAIQEn1qBxl1LWY8Bb+GU6q4W8CoTqSEonYjid6nplUpgT51pvAqxnDGGlJS6tbmlauE/lkSSeBJ3rPL+U0xfnTJ7NZS/jIWQsrFo1yZgd0nr61EYKpD1uyHAELGopBPrV8vsGwtq4Uq/wAaQt0WzIcatbfvFhSUAGFEgQa00JymzapSzhGIXQ3MvPJa3J8kgxX59mwN5ZSlJLf1PqdLkSxRUYt/p9yr9o+GpxXIOTLdSZjFLhcJ6EA1C2OXWmVh9KVakFQEkbGuoZlxHArTLuXEnL1u/bvuv90h1xa+5gSSCCCZmqcnOdk1idxYN5VwdlDIKpLClGOJ3VV+IYoSyp9aWy9fT4GejyTSlUXy/T1+JVMSxhNpes2dxaQiVSopjeOlal3iWG3zKmXCG52AWYNXgZnbeeKm8FwMrDZUg/s5s++5mtW/zljFoErYwnB+7CEqUBhzQJny2rz1hxJ/+T6M6vMm9uj6mh2B/AN5/ZYtXm1kd8RCgSAE7/xqudpTqbTPmPOKu2zGIOKhRgoG1dK7I834vmDPDVi/aWDVobd5Sw1ZttqKhEbgA+dVXOvaTmCwzviuHWKrMst3brSlG0aWqAY3JTJ+tenmxx/CQg5bXzRxrJk/G30716/wc2xVPc+NoagoEkggiuRZsdbubz4B6NBSpUT6716Iuu1/NzbyrcXVulQZ1hSbZmTB6eGqbnDtrz7bIacw7E7ZKidJU5YsL268orjx44Ql+b6fydWWWSS3j9f4OQWTHw7CkNphCoGx2AFYsPX3marNSORdNgHVxuINdCd7cM9PMNtP31kvxblWGW+/+xWlbds+eHMx2rd1iFkhhbiW5Thlt8sgdEA13YIKORNyOZuVcfX+CW/G9cvvXmXW2tCGk21wsSr97WmvKF3aoe7vXuvSBKDtAr27+KXOV7k2/wAERhLVqQ/aLdU3c2jbwnXt86TEg9K8x4z2wY++txbuCZeOkk74Lbzv0+TiurIoym0nRyYr6Xt3OV3mlm07sBagngxIqIxkAMOQk6ggST1NdhX2mqubbRe5Qyu8NPg/5naAP2AqAv8APdpdLcbdyFlVKFgeEYeUf+FYrTCoxf5v3CXU1uil9n7wRmbB2Utq0/GMavXxir1+Il12+z9ePOAoDmhKh6AGB9qzdnuY8Cvcz4e2vIWC2zzl4hKXWS6CnxCCBqjat/tmx/JVrnfELTGcquX77LiQt9u+Wz+6P3QkjrXbkj1YluuTklGpo4a/bsFSUuNlYSJEjjeq7jLocWO5QlE6j4h6V1h7G+yS8KP+ZcbtVDqm+QsfZSBNQWK4d2WXepdnm3F7d0gnTcWCFpHpKVVlCMrdf2LdVRI9j3azd5QRb4ZiVwt3CnoS41qkI6ah5e1esMFx7BsRsLd/Dr3vGlAaFoghQHSK8bYVk/K14w3rz0y0kmCP2e4dz05rvHZLh2Tcuv2+G3/as03ZK8MDCn1d2SeRv51ya3Ryyrqhydul1PS6lwdxZefUhTaMQUU7whAgVdOzEODOGAabsAOX7OpJ9FCsWF5ByyGkPW3adbvIX4goYU7CgTsfmq45ByZl5jN2D3Cc7IuFs3aFIaRh7iO8UDOnUVQK8fTY8mPURtd/d9zvzZscsUqfZ9n9iK/E1au4h2j3jPxSO7Rh1v8AkqB3+eT+tclsWm7LC/2c60hLLaNKduQea772zYFkzFu0e7u8Uze/Z36LRply1Rh6n9KACQZCgN9X6VSV5IyE86pm4z5fENoH5aMEiB795V6zDlyZ5OO+/qvuY6DNjx6eKfPwf2K0q6t7O37xprvQ0yEAIPRIgfSrT2GYsjFcWs1JZ0suNuqBnqEq2oKyJkK6Uhu2zrjUAcDCEwPu6Ku/ZjhGXMp4pb/sPFbnE31IWAbrD0NBsaSdSYUfFtG/manS6aSyqU/3Kz515cuePR/Y5vl7B8UucQdtLPCLx599CXHHmmFLConYwPXir0x2b5qxBhRVl++abR8veDu4M8+I1sHPea7sJdXjtw2nuIKGl92mfQJiobHccfewa7D7z7upAQCtZUSpRA6zVSWBS3bb+ARlmklSS+b+x1nJuVMRwrJGNYZcsIt3Lh5Cm1OPohQAG5IMD61DrwO6OkXuK4WmCUgrvdRk9Nga3cqO992d4w2hAhL7aAPPZP2qBdS4l5tP5aNKgZI+9dWqeJQxxavb1/gx0qyeZkfVW/pfYznAlp/Jtsx4KFDwqSpLypj2TUbd5fTdd2Hc6Ye0tKiSluzfUFjiDMVMBXctqddcJ2UEmPOoJaG7i7ZTATKChJJ3meRXEp4o7dH1Z0vHP/t9EY2ss4Oh5xV/ncIaUBqLeFOplM/3ir+VdB7VWsCVdYb8djL1s6bVSWkotC9rRI3O4g1z7GW5Jtrp0KBjjbw6htVo7bFttYvhYCEkIw1w7npqEb16GOUHp5tR7ruzgzRl5+P2vX0+xTcUwjKjzYRc5pxABxMH/miSU/8AvKjb93s/tWWbRzOOLJSn5VIwWAY93K0bu4f+AW406sN93CE8xI4qKdcYdtmbZ5kOrUNp6ec+VcfmRfMPq/udaxyf9T+n2N69/wCTa60sKz1i6HgCR/zMJj/3lVxWFdnAuXnh2h46hGoJXqwQGI9naxYnaWReVbpGtSSSFoGk+1VhaL5BWWkDQtUAKPJq4zgn+X6v7kSjJcyf0+x2fs5sMpWuRs4jBMzv4lauW6jcPu2RYVb/AJLkHSVHVsSdvKuA3+TsmvMMlrtPtlBaUp/Mwe4TIA/zVGuu9lPeL7Oc/OOJCQm38c7QPh3K86P4igssFC0pAQInoCK9SXS4xs443cmiIxbImCM3LjSO03AD3qypKl2V4kj38FUbMWQbRTxQz2gZXcUVEw5cOtatuZWjapjGL1u5U9KNKUOKEjkb+lUTFk2qn+8UvYAyZ3P+Nb4XFdvqc+W1yJPZtiRQs2uN5cuDEhKcUa3PpMVc2crZgX2QX2WUYcy5fquu+Sm3fbdSoAgzqBia5Xc924h1CQlSCQJ4g1ecIR3fYhduXLkLViQSN9onivU08ob16HFk4s5pjHZvnu1c+IfyvifdhM60MlYj00zUIu2u7b8m/s3bdTYOzjZQf1qxu4jiNl47a+uWQkeENvKAHtvtTHc75sW2kLxy4fandDyu8Eeypoj0tkT61sdV7GsAdxrMmIIasHLkpwqycUlDRcKEkGFEAbA+ddnw/Ia03raU4e1arKo725bLaE/6SyNh61x3IuZ8YtrrF7nAb57CrsWFkXbizfW0XgQSAoJIG3SsWL9tfa9b4e0wz2lZhsni+4C58ctRKAnYQT515uq0yyZm+qv0/k9HTT6Md1/nyPT2YMrXuIYM1bIxjL5CQCP+dm9MccmvDf4gMBXgOOYxgV4i3WW1BaVMuJcQQoSNCxsoc8UB+Kv8QFs6LS87VsZfcRIUHAlaeDHIrDhnb32n53753NF9huJrt/ykfGYaw5/FPFLT+H+RcoyJ1Osjmj0yRyrD1Kw7GVW9w028ktJVDjaV7HjmrXbO4Ilo97gdnMz/ANHT/IV1DEcTsbXsyv8APd5kvK+JY3aXSLRCf2YhtCmVR8wbAkg9a46jtoy9e3JTjHZPhYCUhRVZXbzAjrtqIr0HhnNKmjiUo1RMl/AbgXBOCWZAEJPcp/wply3ldlpJRgluD+8EJjfzrW/pn2Z4mbdFvgmN4Ku+IQ0pF0m5QCowAQUgx6zW7f5TRZ4xd4Y3mXD3zauaHNYWjSocgiD96nypxftFRmm6NB6+wa1sFN22XbAuKJSFqbKiZ+taGXLay724Xitl3zyHUlJ07aY32NS2IZTaSgqGZcGCkDXoL6oMbwPDztUEypeIXjjltiNraMKUJ75wifbaaqPsmcnvsdWyxfZatEdyjCEEKmVloDarvguacNt3U/AW4bQJ0wsg8eU1xvAbG0tVrYvs+WiULJPgt3HDHtXQcMdyPbIHxGZcReUAACxZJQNuOVz+lTODluioy9T0/wBj3a/imR+y/M7dnaMLS7dWykK4WlwhYCp6ketc/wAHv8dzNmS3w8quC9ib6UqWV/OtZ6/rWLKGKYLedneNvWthduMpurNLoefCO9USvSQQkwBvNXLsZvLDE8/4RaM5LtVqtnviFKcunnYCEneAUiuPUwWH/kVXR1YskpVBcWesMOvrlFszaJRoDbYbShThIASAB/Cqh203OKNdn2HYfbMOXbt9j4W6lDRUQ0y0d9uBqUOav7CHH1tqt8BwlLqiENBVt16bqJMk1x7tO7SMVxTOD1rl3MlxZ2mCtiw/qFwWmXnk7urhMAyowPavmcONKTm3Z7k3KowSrvycU7e8CW/2bYuk2im3HLZTaVuJKQiSN68SJym53Zbub+1Ecpnc17o7c86Z0u+yzHcPvM24k9auspQ605cKUhaSobEH2rwpiV2sXGhTqVrPJHMV6+hXstI49a3JLqNlnLDq4NstkpTuR3oBn2qWwf4/BMWsL1DSQu1u2bhIUoKHgWCNuvFQGEXqmnVIiFxPPO9beJOPXKS6tBXpKQJPBmu2OOnscadLY9B9g0Yr2rZWW1cIRcN4ZivemJlblw84Y8tlAV6z7ScIxBfZPme3uLdS0owp5LaUlKlbIJmK8Q/h/wAYwjCe0bBr7E8dt8CtrUOLuLp13Tz3hhIg7GUg16Z7SO3TJ2I5BxnCMOz67f3l5aPMNJS6rQSpJABTABG9eH4pp8mTVRkotnq+G6iMIO2jxrh7Lba4QpSTB353r3F+GGxvMX7K1WVu42kW2ILXqKSpRJSOhI/jXhezeu7dCEKSCpMSehPnXqjsa7asM7L8hN22NW77hvX1vNIt0hU8CSSa9fUYXPTyjFb7Hk48nRqFJvaz1U1llTTSFPYi/rSdvAluP1VUkcEYWykv4i6GkndPeSSfRQAivPiPxStXw1YRkvGLtsfvaYSPfY1sr/EJnlxAtLbJDdq4shSPiX9O0esCvCj4fqXxBHsvW4L3kdxcw/D7NalBg3AUggqccWAD7A15/wDxaXdlaZVwVtGG2QU7fKlZaJXs2dtRMxWvedsPaq64lLjWCWqVKiO/bUOPPWa5r2w4rmrNlthreOZlwJ0NuLcbabdVqSrTG5CdPXzrq0/h2ojlTnSVmGXX4Zxa3PP3bVjt9Yf0cuLF/wCGJtV6O6JhEESKq+B9suaLDwXt+3ctrRo0rEH31c1P9ql0xa/syzxO3tbsNsOBJUdSQZHBB4qpWRyi4pLtzhLfQHQDsPPmvq5qGR+0jwepxfss6HgvbZh9038Pf97a7wVKOoK9yK6ZlvHrDE0IOG3VqGQIDgXJJ8o5rzyDk1ta1M4LbEbpSIO3lxVmy9i2D2ahfsWTVupsEDu0lIPrXDm0UZKscqOrFrJp77nprC327d0FKGlRuSlBBO1XfKWNPIugy6ptkPsuoWVmBukxuetefMA7abTA2w/e4bZXqACSlxpIVH+lG9egfw0ds/ZZm/MmMXGY8oWt/ZsWTYatzatqLSyoyvcRPSvMy+G5MjqO7O/H4hjxe1JHAcpZoxLLeabheHWQuUBRbuAFpSUpCuQSR1r0R2JW97iuemsyWQYVhwtbhLh+IaU4hw6YBQFFXnvxXkftZu8KuMSv3sPsLdlp2+eWAhASoJKiQNunpVr/AAXXCWu3uxYYKh3+GXwUhJgKhKSPfg17Gl0kXOE5fmR5mu1Lx9cVw2fRVJCgJJ4HNOnbfYVjSAACTtxtWRRSAlMHc17x5Xl3wGNOodZpajIInfypsrI6e/SiCoggD2qhKNcjgoTJJ8t6xvahbvJSnUVNq0wCTO3lvRJOw4oPuttNOOL4CDBHIJgSKllKNOx6fF8ygSaJOjjpTZJSNPB5MUQOZ86a2QNWISo7HeiZmZ3pu4MDYedKd/F4p6UNE9L7DiATWJcoGwlB5HrWQEASOu9I+RosrprkGraUmEnzNFKgU79KYQlCgQmUjlPlRbUkjwGZ86ZH5jJufl2FIwfLbzphIIhJoaidoBEwaBdDHkgcxt5UioKhQMgefFNSpIGw3PnRGwgigFFthEHmNqEqHWd+aUgCE0UFQJBIj0oBqgyNMj603UIKSNj5daBSkRzzvFLVq5I9KAbXYcCmZKaQBSfSmghJG9IrBEEbetA0I6o34FKVH5gDQk8AbcjeiSpW5ESIoKa2scNlR0GwoLgmI3oSZjmlChuB/jQZ2wcCDKaQAiUpKh60jqVIVyKABIERv6UFSVKxxUEmKBcRqA3A9POgCIg80DE6Y3oJTDKQoxvPnS1pPUex6GhwQPOhBHiAG3pQabMySFeIHf0pusK8PQU1WxJED0oAAQQACdyKapicWuB4MSAN45oyk8CU9TTT59OTTlFI8SUj6daRPvG6tPv6USSRKTRMmZVTACCUwYNA3TVoQkGQdztSAAPynakUwNjBpCTOxg+tBLdgI3pxMRxTVTpMdKIkgAEE0CCVbTtqPSmySTJgcikoK2kifTegSTEjbrQUkFQQoEjY/wAaIOlIT02peFRJJEelNHOxnpQS3YSCTuZFIcRSSOhMRwKaudEHcn7U+QHFSZMiD500EJGxJE0SAnfmaaolI5pBQ8naJ28opgIIKlCZ2owYKzHEiKEJ4JMRJoDgcQABAO1E6RGwkcedY1GEwPOTRTv4iaACZnV0oKJiZ2okg88RTZUJ2nyBpoDIICeN6aRTQRGrVBpatyNW1IBw6KHANIA/Mk7n+NN4GpUkelIK3HO9BVJEhO5B4oQZmdqQOoEnmkCVDjg1kbq2OABFEkfamglJ8WwpSQJNFVyU0ExwDtSgdDTQoc0fUVQk13DESeIpaulBQ1CZpIgGKBP3BEwDSPi4opJSJNAgq8VDdFRQuRA5FLY777UueeKRJnbeN6AaQADM7H3pw6z5dKbtyaURuKBJIXpFIikNzHWlztRZNNhlJPketCY6miQJgSZpGE7be1C3AQIpFYEgDgUNzS4oAUyowvaiR5U0Ez8sin7dJFA4pMQieaSgCqfLrSI4iioGNxNMv4gPXbmhBHBonihtE8dKQNII1byaR3kGkdQVxS5MGn1WJJAiPpQkRtR1AEjmgoiJIgUiaDJEjmkCqCTS+aCDRGo7DegpRrcQJIO/NAgcmlPkKRidzSsJbBSRqjpFCY2Tv70tuRQSd9uaZPUx8jb0ocb0AoxNKTzS6kUrYZlQAgA80gSaaAZ0xzvNOgASPvRdcjS3FtuEz7dKWx96SdxFEJ+9FjEePWgCobkmlv50jtHWjqYCOpRgR60Y8+RSg7nST5k1iW82gAKIkkAAHrUuSXIkh532KhS2Gw4rctsHxW52tsMu3J6pZUQfrFbacq5hkd5hbqAeCuE/xNQ88I8yRajJ8IiB68URG8QZ86l7nLVzYtd7iOJYZZpKdQD9ylJge1Z8Ny5hl6+GV5ktidRT+UytQn3MCsHrcMXvItYMkuIlf3UJJgeQpqrhpDiGVOoQ44FaEEiVxzAqy4jhuVMIffZub+/ulWj3w72hCWwFSPOaiLu8yW9btXF5l1942rwcacXelJSR1lIH261y5fGNNjdWa49DlybpbGqQNz59OtRF4V3OYcK0OKSzoumlehKABt14NWBGdsHWLkWeWMPUtCQUocWoqJ689K8k4h2nZ0uvxDYphTOZruxwp7HEtfCWx1tsNq0gpQk8dfvU4/FMWpuMSvweTHOKl3PaGKH4XEHGpSVJYaGw/wDZoFZ2u7btk69fJ/45qxu4VhqLtal2pdcCG21KdUd9KAJgfSmPC3t0BX7MsdzpEtA7kjfevjtTGEs0rfc+i0+aSxKCj9SBzSUHK+WENHXDl0QQJgbVz84JiN44u8cYLwJUEKbQqTvIERXbcRurluwwhNs8ltpzv9SEIABgiPb6VFKvr50KAxO60HchLsD22qtf5bzVJ9l293xMdE5yjJxS5ff3/A4+hGPBlZVlLEXtX5cs2rkj6RWV7AcdabCrHLuJltWgLSq2WVGOkHium319eKV3TN242QkworkA+ZrSexe60hKn3laUzqCjvA3rjjHEt1Z2dOV+i+ZH9juBYta5zVid5hj9sfg3EAPN6SFEjr7T0rnGccjZwv8ANmJYph2Bvvqdv3lg6NinWfECDvXcOznu3sbcuCsLCbVxXqJUOfWuZXmPXHw67Zt5aSS4UxIM6z5V6Obo/DY7bXJ58VNauVPdJFJw7IuacLUtWI5dubta2lIEJ/syeD7VXM29n2aV2CWU4A7rBAADYHH1rqT+K3rlonvnlqOlKVR5mqtjV+6n8t19ToWufEAQkeVcilibV2dbeR+hx93s3zu402pzKtzaqG4S4kHUJ9DWvhfZbnZnMFq67l67LAuUKJIACU6hJk8V0p59rvEFbDZ221IG1U3HXbRzFm1IZQpJeQFQhP8AeHTrXdglFzVNmU06t19ToH4xMv43jt7llzL+BvYgj4R9JcYTrA8YgSOa8v3XZ9nJSlPPZQxUhXy93arUDHsK9N/iq0t4tl7DmrYMsNWbrbbbY0pELHQcVwG5DzLIAcdQlPyhDhTHtXXOON5G5NnFjU3BtUUK8ynmtph5LeWMXQmI/wCgO7b/AOjVWxjA8yMJHeYBiSfBEmzdA++muonFMWtrd161xvEG94IRcrH86gr7PGfMO3YzniyWUjSJvFx/GqhGHKbJm8lVSKx2YIum874Kl62dbPxjYAW2UyZHmK2u3pg3HaRjakEGXQnkAAhIn+VWjIees4Yrm3CsPxHMV3csO3TYUlxzXInzO9DtOzVc2ufMXw8fCPMW9yUIS7btr2gf3hNdriniW/cxV9abOFXOFKGlzXuid55qJvbYoSQgzqB5HWuvu45avNBFzgOFrSI+S0Qkn2IiKquPO5aWl1asBb/MBSO7dWkJ238651zSLexRwu+VbNqZuEpKCICR5VdcrYpfuNtMXcFRcHjCdoFbeBWfZy5YW7T2BXqXw2AtwXpIkdYirtguH9nrT7SkYPfPdYTfEAj7Vu2kq2M4SadnbexDO4u2hlnEEFZQNdusnkdU/wCFeguzlVtcZ0wMJSWim+bIEc7mvMmTsb7N8FxGzuG8oXept0eJWJrOxMTEV6w7PDgis4YMvD8EQkuXKFIdVcLJR1mODzXk5NIoaqE7W7PUhqFPTyVO6Zg7XrIu9qOLKZZLiy3bmQflGjr6VUrzCEtvlbbau8ISVBR2/wDSuh9qmIYFZ50xhy/wFm4e7xpBULtxtSwGwQSAYjf9KrCcYy8hLgOVrdZVxquXSAPLmuTWY4edJqSuw0bksMaj+xEWuNXVs0FQ262kwUDkAdZq1ZBu7q/xK1dDfcoSHEkeUpMEk9N6hLC6wRTrjicJtEtavE0S4f8AzVasqOYXit/8FZYW000sELAKjqgcbkxwKyxNdSfUv8/Q3zbxdxa+X3I1WRM3KKAqwKG+6A/MeQhKT58yayPdnGPXtgGb/MWBMNFaS4k3C3FaUmdyBFb7lzilwUfGPr8MDUT5D14rWxS+QEFptYkjTvvzUvLjUrr6go5OOpL9DpGA4RbYVkXEWHsXZcRcXDSu/bbUUgnSAIME1GXmDYA44F3GNvqLCtMNNJSFE+81nyxrPZxiwcJWpF03A4iNJAqurvEt3iGHmFAuHUnVBH0r0NXJS6HXZepy6eMnPJ7Xf7EwcKweQ73+IqSjYQ4mT/sVgThWW1FRdbvlOI5JeEb9Jioq8vkvKTbN/lpnUVRAUr6U1rE3kOrQ4UKagAcc8VyqXbpR0uNcyfzNi6/o/wB62p23uSpSgEBFxAG4iQR51Zu11WBuYnYWeKWfeXLtmS04XihOnV4k6QQTz51R7tbd7dtIXpRpeRxun5hVm7ckWqsfw5wqSHmsNc0SmSPGNxXfibelm67nBlj/APZgrfc5xiBwpoqb/YPeNhO3d3a5j2KqhGMVwpClBzK6WYTILjrx/gqm3zFyl5NycThJI1J7oaSny34oXL5Lq7UWjzyFfMpKgQBHQTXLDL6xXyR1eX08tv8AVkfc4xgpbKW8DtnnlLEDv3kqM9RKqq+M5ywazxBuxZytau3DvVT7wA/26stzFtdNO3LQ0rghSkcAb1zTM+Y8PONNW/wyHAtSglSYBRG+9b45uUrpfJEThXd/Nnb+yzGWr/IGeH04Pas2TFuv4lhDrhW4ruF7alEwNMjavLeL5ry0y6lj+hxQzwgt4q4FRHqkivSPZFdW57I+0G5bSthtDK1KCgOPh17z968s4paYVizTVxbXupI8SdJ6R1r0ZbpeycSS62iKu8zZEcS4TlLFGUpVulvF0k87/M0armMPdlV+4gO2uZLFeylFTrL4PsO7Tt9ay4nlx9dszd2/eArnoJUNXlVSxjArsXaHXVGFEp0kVrhlGulxM8keVZs3+G9nPeKZsc24w2ogEd9hqFJH1S5Vpcw7Dv8AkfVY22Lg2qcTQr4t23KAVk7DSCo+e9cfubK8trxwNnwnYA8/autXbFyOwVJUgq04kyVE+er/AAr0cPSk0l2OF8pHOr/Bx3Shb5gwxaY2SHFBRA9CkRUMrL98w0VKDbnCgW3UrEUy5ZWbj8z5RwrrHn6VHlSmbpyEr0yBM7UoSS5RU1tuzvPY9l/EMxY5j1pb3FskW2G2JUm4ukW4MggAFZEnY7CpXMnZLmlK27hpnB3bZL5MqxW2Uo+HiAuap+SlPi9xUsuPECwtRoSo9U7mOvSsGYLd2+Vb9yypHdOFRUoajqiuXIoPM2zXEpOFEHddgufV47cXbmX2lsr0lK2n2VgbHoF1HWvZVnjCG3lOZUvSVLKklq2K9XkRFK+S5hKXn2rxannDp8StQA9qqhViTSnXGr19rVIBQ4pMnz2Ndceit7ObInZ1xeX8at+yy/Zu8JvW7o3JcFqthSVqBAEhMTtHlFeecQwZpGI6SwWShEkOtlGkz1BFejsLxzH2exPEcXZxB7461fSht5LqtYlIGkKPQ/yrjTHaJ2j2158Nd5luLxtKdRTcBLo9hqHFbyUYtbmSbZUn8tOP3+H3lm0hHcOIJ0JI0kKG1XvtELyM9Y5coUltD92XAkmJ26eXtTbHtHxTv7e2xjL+B3feup1qVaIaKQSIMoArtmP5hZyzlQ4tYYJZum6xW5YvGr60buQogDxjWDA9KWSN420zXGuqSo8x3l3cOrKC4EBR3JM0x5q3ZcSmUjWQCAYB28q7mzmbL1y60b7s1yu+2tBJU3ZdwST1OggfpWPCsndl2asAxTHXcvYhgZsbptpaWbhLoOokBSQ4DA2865VNIuWN9RxRIbtnCpatYI1QOQKuWEXlxcBKGsPuHdISfkJBG3kKl7zL+FYSn/mq8F5aOqCEpWgId3mAUias2DWmKWSWm2sLvGgYCQUqEef0o67JlBr3nRshC5tuz3GLW5t12xNzaOAOp0TsuBJrs34bcExq4zU/iGHWKLhbFiTpRcNgoKlRJ34ia592bYBiWZ8NxPBmm7ZL/wCS+U3jyG0hCAoqUpSzAEe5PSvSvZNkbPGSMl3+LZcxHLTOLY6lttl5VwpbdnbJkhaQEeNZJ2HA9eK4fEGvL6e7R26PG+q0i0Z5z3g2SLZWC3z1+nGH2SjRZFDjtmhYjUoqMBSuB1A3rlWH5HwD459m3OJNBAQ44HXWp33/ALvlVsw7sAxR64dxTM/aTh63rpRdedDTjy3Fk7qJJEmrW32ZZUw+4fv7vPuJPqdSNSGLBCUwkeZUa8Bf8a6Y1+p7Fu7d7+5/Y4B+IPLmB4J2XYvfWb918UloKbQtKFoJkfMZ/lXhF/HrxRWldnaOKJ3ULZJMH1r67587HOyrEbT+j2ZW8w4ow9bNPKSi6QykpWJjZMjiqBa/hp/DVhg7+17IEXYKdQ+NxV9Z9ODFdWHWR0V48tWZZcMtXCMsabX+e9HzFYxoNyXMAsHCOpZIKfsRWG/xVV42LewwC2ZUpYBUkrJBnoJr6tWnZx2L4WpKcF7C8msqEQp+zL5n3cNWrDbbAsJUpeC5QyxhykEQq2wa3Qr6HTNVLxrEna3+f2M4+F5Gt9vl/J8icEynnjFXWl22UcUxBPiGq2snnOvkkHeunYD+Hzt1xoIXhXY9mN1KtMqXhrqB91gV9OBnzMzSE27OKltsaie7QGx6RApjmZMxP2ZU9i92tCx4gXjB+1TL/UEKfSv8+ZUfCJetfr/B8/rL8HH4krppDiuzx+1Sdx39wy1HuCrar7h34TO2i+y5hVkbvA7Du3FofW5iSSFFRGlI0JVXuDs4furjNDet9akuM3EgqJ1eAb1UMMbCMPte9UIRB8W8GeayyeLTemjmS/M2vkPF4djeWWN9q+v6nnvDvwXZ1Q0j9sdrWXrRCzp0tuPvqT6fKBVgwn8IWVUNJfxntafcbU4UA22FadSh0BW4ZG3lXaBeAHWletKZVsOvnUXbsKRhbDbiDIuFnnzVNcsvFs9bfudX+2447NnP8ydi/YZkTKGIZhxLFM2YouwZdcS0lxloKUlJI4RsNvOvIdt2odj2b2GX7vKWa2VNvKR+Ti7ITp6EAsnfnrXsrt3vrS17NMwMFYddfsbhtKExtqQd+dq+Z+RmwjCh3qAglSiEk+u1ej4VqfxPU5rj4nNr9JHTQi8fc63mTKn4fs3OMvDGc7WIYCkhCmrR8Jkz/mE1Xn+x/sWfTpsO0/H2V/LpucvNkf7FxUOha0gJcKUCSdhE1iQpMlRXpOrb1r23lvtXzPJcLe5up7FcmIV8PYdsmHNkbpTc4Pctx9UlVWfBOw3A3VIs2u1fLd/cOnShmLpsqJ8h3J3qkh1h24V3bgkeauvlVq7KUp/5UMuMPoJYN6O+IMRsaeOXVLpZMmoRbpWZv/s83AxRX/6T8kONsrKSy5fvIUB5eJoCuqdlPZ7bZEfxd9OacqrdxBhttCWMYZ8RTq6KIjciuK5wSgZsxpTOktpvn0tlW3h1naKgkvd6VNFwpjiFcVqp+XL2XwZqMGuP8+Z1TMf4du0Z63RcYdZ4djaFKMJbvbeR1n+03586t/4YeyrtGyj2y4de432cKs7E2V0h2+S2lQbJR4RrCiN44rhNriV/3IZdu3gGhCIWeKWFY9jNteOLaxS7bCiB4XDtFVjzRhLq3Jy4vMW59VPgb3SCMPuJV8v5SoPtQ+FvUeNdncJkdWlCPuK+YiO0DOCAsN5qxMhs7RdLEe2+1SFp2z9qmHI7yw7QceZnbw37s/TxV1/j48/5+5Cw1wz6SuPBhAKyYJCRHJp/eIndYAMiJ8q+d9t+JXtzbBcT2j4u5JAh14rG3oaxI/Fb+I5jEnHkZ2S6y243Db1g0sFJ+aZTVQ12ObpEz08qtH0VJVuUj+dROZbl60wZ59tSQoLbT44iCsA88bGvLeafxH9qOF22Wrqyxa2QMVwhq9emyaUFOqUQr93bjiqtjP4ru1C9tnbG+Thl2xsS2qzSjWUkKHyweRVy1UIupERxSlG0e5Vq3UlIAGoxv0phABnrFeOML/Gt2ghhu4xHK+AqKkyUBpwH1311Zbf8brndA3HZvZPOASru711sfaTR+Lx1s7JWCR6i+ZJIVxuaPBk15asvx5YLd3KLa77L3GCVFCu5xU7ED/OQamUfjXyajxXmRsVbSPmLWINrMD0LYq1qIPuJ4ZcI9GTA9aKTAM8muF2n4xeya/Yt1sWOPMvXbiGkIfbaCUlSo1KVq2SPOK7G1jmC3IQtjMGDLK06gE4kydunWtI5Yy4ZHl06fJIzIgiawuN794hQCh06VlZU0+ru273D9zyb9gJ+p1VXca7RezjL2KvYHjGf8BYvLcp71HxeoJChI8QEUvNjdWarDJq4onkvgHQ4SlXlEzRhRTO4qvf8ovZy8pLac+4CvUfCDeJSYPG5imXPaNkLDbpmxu874Ily5ALSDftFSgTA6+dWpJrZmTTTLJMkECj4+ZketPDSiEKSthQWBGh5CiR0iFVk/Z2JQFJs3iOpCZ/hNJOL7g77GHSRtv8AUxRTJOxEjnekpD6QCthxPukx+orEH29am9QCo1GqUkS43yZp33AoEiSTzWPWmJ1zSB176hPSm9+Agh6Ykk/Y0llJXt0E703dI5pHu5knfrQS00xwV129hREk/wAqx60J6E77GiFQogcmg0lwZYIgo48qbrEzzBph1QJ2JojwpBBG3lQZ1QguEzEA0vEOsU0FSlQEyKOpYPG3lTQN9IVSDsBSkJGognziiVCAYoavQAUhN3sKJVIVTfHuDSIJOwIEE0NR21Hc8CgtRrkJBUTChsYokAGZM9dqWmCYNNUREAnUKKojqbCFBQIE+tKRPh4ApskjbnrxQSU7hM/WgutzNIUogTHQedMBJ2mTNNJGqdRFKVg6o+tA+ldw6wSI386cCd4MGJjpTEgpSVEQCaRWZ23PFAdCCCdh9xSgDeR7cUAZE9YoddQ6UPYzcaY7YiIO1KCoFKU0DuQopG9Lw7wdJ4AFHBPA4QlM/XigVKKZ2+hpm4EEyeoJpagBMx57U+w67iUFGCIijtI2n3NAGRBHh6UioD5dzUtF8KwlUwDweKR6zvHpQ1AgR96ATMmZ96W5N2OBGkiRvQ8JmSSOKbACZ3J43pyQENkq4J2qgdMUwCR0NIaSCohQMRPSm7lMkxPBFIAJG6jB9aRIUHUqDwKdJJg/pWOSBAIFElXyk88mmOhwBA3CSeo8qACTxO3pSSSB4hIPBopnf1oapjSVbiUqEwPPqKG0gmQRQBAAPBphK9Wo8UO0EVbolJUdyYHl60TtQGyT1ilPqKyN48jo22oCQoGkkiImTQJ8ck7CivQtoSQAiCPoKKfIEihrkTxS9Qd6dGfPASYMCTRMnf8AWmk+u9ECeDS5ZXSIcmTFKeCPPmhPiII+ppDiCBE7UNIY4GVE+tIrPGqKZx0+1GBMGkTFNciJVM8UjHyjnmkFSN6MGdyPanZVJ7hTBHFDYfu0uATNCSd52oCTpBUTJHTmgASSCZjpR42O9IEa/pvTQumxFPnFKD5e1IqBjelMgjpSbDpFuNhSIO5nk0gRyd/U0gVHjihclJ2tgEkHzinBZjk0AOZO/pSAgzBmqbolp8i3ASmdgKGkknptSJkbSfpTgfMGiwUUICBsN6AKjsaKiQNhvQEx1ip6h0kHSDuaImNtvSoLMWOX+BG3uLXD2r23AUu9HfhDrTIiVpSdlQSJEipthw3KEu2qC4h1IWhSQVGCAR/GpWWL7lLG0roO878ijOo+grft8u45d6Tb4Tdq1cHuiB7b1mbyvi6tIcZaZCuO9eQn+dRLUY4fmkkXHHKWyREgQJPPnRO0ncSeYqTdwFq2IF1jeHNqJggKWtX2Ca2BgmCJtVXbuPuuBsSUM2hkx0BURXLLxPTQ5kaLSZ5LaLIRJnbmgQTIg1Ot2mWl9yHGcVcU4NSdS20esEAEiseOX+B4Tl9OK2GXg+8m/TZlD12opTKCrVsPSsf940z4bZb0GaK6pKkQxISCTtA3mkgKcILTanDxCQT/AAqQwPMJW269dYNhbPdQlISwFSTuSSomtW9z5i1reFkYs7b94spCGgEBIPERxXLPx7HF1GNnRHw3I+WR+J4nh2CFKcYvWLEuJCkJuXA2pQPkk7mmYXj+D43eIw7C75m5u3ElSGG5LikjkhPJHrWfMjVti7ltd3S3Lm47vT3jw1r0gf3lcV4//ET2v3fZN264Tj1jbhXwmDpYKA8W9WtapJKfQVGHxyWfJ5XR9QyaGOFJzkezbrAM0s6HWsNQxbp/tXLpDiQnfkaRMVvYZhNvdMAX+IOoeO6k29sSlO/MrIn7V5Z7HPxM2fafnDBsARbX7F7iFylvSX9bI5JneenlXqx3EE216tCnkbI8R25mubW+J6rFLorpOvT+G4nC5OzYbwXAHlNoWvFCpC/EoLbQF/SDFb7mE4CwPDhwV4tipwkp/WDUOziD7ryEW7JeSogkpST/AAqaDV1espNpbuvgyQUp5+prycniWsm9ps6o6PTRW6+ZkwRvDrjGbSx/Y9gplxQ1FxsKWR7kx+lQ+JY9ibbLxw64RaNmEoW0hKYOuIEDyFWfLWCYgzjNrcPMBvSoKUXHkaoHkAZqpnLdh3D1srHsLWEvKWpXeuLM6j0Ca2ctTLEnJu7ZjJYFnqNVXxAvNl8Wm2l4jcLQn98LJWSBvUQ3ijtzcLK3X3FPImVqPAmAfvUsnBsDbhNxmRUzum1slGfqsgfpTnLDJlkErcfxm6WUwBLTQ/QGudwycya+a+50dUOUn8mU3G3/AIy1UmQ5KNJKvpVryctf9WfceAcVcJUB5jUNqbc3OVA2Bb5VLsDZVxiK9/cJAqz5Xu8MbctXLfArC3Up1MAJUoiTGylEmtMMYqauS+v2GnPpdRfHu+5Vc22i7vMuNlClBCL1ZWEnmopjLmI4hZ9xa2F7cNl3UlLbKjwPOKvGZsz401f4kmxeQwpu5W2lTbSJhKokmJqtOY1mi7bUq4x/EN1QPz1R9piufN5MskuqT5fC/kNOsnkx6Yrhd/4Iy27PMzNLuXHcuXKA8fmcKUDiOVHavKx7PcxW/b85fv2bPcIzCgqUm5aUQnvESICpPHlXp3EF4m6i5ZcUp4khWpSiok/WvG2XVPufiYbW+xMZmQFNqMavz0jTPMbV1eGSxedWO3t3oyzKfmx6mvl/J9G8Uxb4bHbhgmQdOlOrf5R0rWaZvMXaC7a2uQoLj+yUZHWNqmr3EnU4tdi2Fsy6053epDKSvYDfURNaD11jj76bg43c92CQtvvSAvyHO1cuaGFZpdUnz2X8nVp5ZXii4RXHd/wbl7hmPJwvAGrfD31lpt9L/AUgkgpkGOah2cBx1ClvP2ymyVq2U+iIn1VW/mi4uVYZgSPiVIedYeKQtXzqGmAarzKSphKbxttLsAq0iZV1rTX+T51tO6Xdei9xjoll8tuLXL7e/wCJKXmDYm63+X8GlcHZV22NvvUccFxAoKF3GFIVEf8AT0SB9KwvWalthTboRB3AHIqNU0tu4c3WhsJJ2kAx7Vzxen/6v5/wdbjm7yXy/kunZ1ht6xi9469d4c6yLQtpFvcBxQUTuTtsK5rc5d0uFIx/AdSFKUCu96EzxpO9dC7MVBy9xNy3Uoj4LUBPUkxXIMLW6ItXnpCmlCdpBnrXZqXBYoOrW/8AnB50Fk/Ezp77EzdZaUob5my+ifEEm+JB+mmaq+LZKDq0dzmvLbelJBnESPF9UVYnoTbEGCQBJneqFmLDS4ENMOKQp094op3Ek8VxrJhuuiv1/g7GslU5V+n8jXclYoAdGbcpr2j/AO+kmP8AUqu33ZveO4oxdKzflZKC6hyP2oNWxGw8I5ppsr9DqSoLBQoguBWxTHWq9mFjTe2qfiSWw6lI35OsCu3B5fmKl/nyOefWtm/oda/Ejli9zPi+D3FljWDWndWzgjEL9NupUqEFM8gGd64i52b5juEvNt4xltzcj/7+MAH2kiuo/i/cU3mTLtqPApGGrIKB/wC03+teeLi8lCm1OEq22PTfeu3KoOe6f+foc0G1CkyUveyPOiWStNxgagoxpbxy2Udusa6rGIdl2e7hJKLCzdS4kxGIW6h+i61MRu2lWymAUMkSZSmT96peNTcW/wDV31FSTpmI+kU4KF7WRLrW7Ohdn3Z3nfCs7YZd4rgC2re1dStTqHW1pAH+iTUH2o5PzTd56xfFV4BfixuL1amnUMkoXwNiKwdjTLlv2iYGAVuJW+ATqkTBrL2g4riSc940Wr19hCrxfhQ4pITvxsa65NLCq4swjblb5Ky5g2L2X/S8HvbZKedbC5P3FVLMnytpYWoqJ1FsiCketXdvOmabdQLeZsRJSZ3uVqM/eonH8/ZjDa3rh5u5UoHxXFshZMeZKa5o03Vmk7a4K/gqi9bJCG/GgSTPFWDDcRfZ/NS4SkbEzv8ASKy4L2kYg9bjVgmDKBAG2Gsj9QnerRZdoTrj7VyctZfaCAEqAwi3BO/onn1reSitur6GML4olcr3JvL+1ZWoJUtxAJnbmvbnZM9Gc8AY75KlIuUDnf5TI/SvMeVO1/E1YpZNpwHLTai82lOnBmJjUOumvYvZ1m/FLvNuGWT9lhaEP3ASVM2DTa9ME7FKQRXn5oRWbH7ff0Z34pS8mdR7epQe2t8jtgx9DuKNWzbZYKUlEqUe7TtPSoG0xy2WtaXX0A8J0rG49a6T2m57xCy7ScXwq3srBwWzrbYW5ZMrXBQDuVJk81Aq7RsXS4QwuxbAndNiyJH+rXlauOOeWXXKt/Q7NHLIsMVGN7ev8EOMTszpbQpDWpJJSTBJmrp2YW9xiOONM4chKw2lS3SVhICYjmfWta37SczONom5aniRatCPsmrRlTNOM47irLV2+CgNuK0pQlPj7tUHYCp00MSzRqV/pX9y88srxyuKW3rf9kbDuXrSybaRcZuw9pOkSENOPKj9BQcy/kpts3dzmLEroCCe5tUJJH/eNQjFm78Ey5qSAhpKYKp3itch95BSt0IaKY8PzFQVTeXFCVLGvm/uHlTa3m/p9jrODWuW05LvkWSbx61NwkuBxaUuaxEbgRUaLLLlzpUjBn1LQYld6oRPJMCn5V7sZExH4dokG9SIPXZO9QOJpuV3jVw0ShAJJSlWkADz8xXdqs7h5dJL2fT7nNpdP1yyW3s/Ux/DZSRfBbWWbZbvyhZvXlEdI+YRVaxLNeBWbz7AyVhSwwYRqW8QSOsle9Tlxe2tkwoot2w+ppUKQARq/wAa5ZiWv4su3NykLKgpKXFgQTzsOa4nqp3UUvkvsdPkQXd/NnRcNzcxctsXKMp4S6VLSoww6Y3HikqImrh2y4q7h2K2SWMFwy8cVaFaTdW/eK+b5QZ4qjYcUIs7ZLXeKcCUyAnYmNzHSrj2xouHsw4apK1JQLDUSEzvr4r1YZ3LSyb5VdjgzYorUQXx7nK8WzlftIC28q5bWsthS0qw+d/LmoOzzjiLj7wfyZlVlxYB1JwtJP1M1M4pYWz7Sld2AsgpO5AHWZ+tQotXLZ9dta2y1lxsLLgaWoHbkbcVwRy5G9/2X2Ovy8fH9zdGccRUXWrnK+XW9ChucMSrX9zVExrPyF4m8wvIeTn1tqjvF4OnUQORzVyetn1lvvLW4UVuDWQ0rwkHbpXPsdyi7+1n7huwuRJkKDK91HcniuiM2uV9DJ44f4zpXZrmVON9nudLz+jGE2DeHNLQqytbUtW9wksqV40g7zEHcbVwK7zFlZm3aI7K8oAGCot2z6CZ6Sl6u99keEXmGdmHaEbphxKrlk9ylSVArHcrGwPvFeZsQsrlClB22fYSkeEKQefKvUlP2VSOLpXVIbj/AGhZWtkEM9l2AIS2jSnRcXaNp5I701UrzP2WLgtfG9nVmnuxMtX74n7k1o5iaK0rUspPIgmqZibyC0tYUIHh1JVsKrDl23SMJ473Ju4zJ2eXrqu/yXfIcBMlrEdj9FI5q2311lhXZg80W8TtsL+LQVICkOPBXSOEkb1xA3riLg90vvEFJCj1mungXKuyB64WYcF4gaSB14j1r1cEk7+BxTi4lGucLyDeLV8PnDEGVqGwuMLnb1KV1rt5KsbxJGG5ywh8zAbdC2FK9PEIn61Wrm6ZZvO7Ph8wdt/Kmm8UbmWx4FJIEjZP1qoPHLlEtt8na8mYU9g2NYmvFLC7uLZzD7ZDblo+2AClO8lQII9BWe/OW0pKzY4+n97Sk27k/SRFc2xnMOJYNfNuNXDiCbRiPFP7g6cVIYPnY37Kg48hu4CdOpXBrlz4W59S3R0YZpqmYsewbJrtwtwYrjdmu4glLuHNkiPZ3eo85Wy4GyE50WYEBLmFrQI9Slw/wrfzTiLS8TUEeIBjVIPt04qnuXi0uqchWkp85qsdJUZ5LR0/C7Fq37KMYwK0xJp9blwhSXVBSEz5EkTP0rk68m4m08q4QqycU2k7B8Sr2k10Vi5uP+TC8utwlNwjUrjfYAVzhu7Kr9pTxWCmVTz9IrqyNKvgYLdOzVbyvjz15aLVh7aEB1BWkLC5hUkyK79jOFXmPZCRa27dumMbv1qFxcIZ8ICRtqIma4u2+E4wwtK1aJSDpUdzNdJ7XGmnOz/D2lrIK8cvVEKPJSlOwH8vWhu4OzTG2ppmknI2cLdpKlZeunENplJZAdSUxsRpmRW7gQucPyDmi3v7FxharmyA75somVLkQd6qeB3tyxZpetbl5haED+zcKD+lXjCc9ZkayZjNy/jS75TDlshv4wC4SkKUoFMLkb1wKO7SZ0t290csxS2/bOI2Viq/RaISVL1KPO0cSKueCYlkvLwebdzPf4u6tBa7ppkMpBOxBWSdvYVyXtlzG1iTNo1c4La27jThWX7VJaJ24KQY/hXMbbFXNalNXBZRHVXFXHG5oynk6WfQTsgzUtzMCLZ0YTb4UhKHHLa3dSorUJhTi1bmIPpXsfKWMNvZcsnkkBDtsHEweihIFfHPs8z8cAugXLz4hpba23GS4YIIiZ9K+p/Yp2iZKxrsvwFeA4Am4NphrNs65c4i6olxKBMhMQK8LxjTScVO6/U9bw3U9T6a3Z1MX6O7BU4UhUbHkmsOJXDZt1w6kFTSpBA8q1bbOdqpkFGVcJSZ8QcQ45I/7yzWrjnaHi+E2QubHCsFZKUEiLBsmT0kg18/jx41JdU18n9j1pvK7qP1R0HtAeQjF2mdK1rXhtuQlCCSR3fpVWw+zzFdWqUWmXMRXCQJ+HXz9txV/wA2ZxxqyxO3aZvywlWH2r5CAB4lplXTjaq/cZvx58FbmLXKgNj+aoA/rW2vjheon1yfPZL7i0Tzfh4KKVV6v7GC0yTmwMKcOX7lbq1SS6Eo0j/vGsv9DcypQtL1vaW6Sfndu2hH6zUZc4ncXMK75biiYMq1feawp1QoFWgidhwK51PSRXEn8vsdDWdvlfJ/cmGspuobQi8x/B2ikmSbhS9/+6mn3OVLBxosXecLQJUN+4tXFz9SRUC2wt0hTi/ENvm5rL3wSgtpKiEjdIOx9qSy4OY47+LYvLyt7zf6JfyXjImF5VwfF0/s7Fb64d+HeJCmAkEaPEZJJnyrTby5kp6xBJxu4Chu2XkIgHfkJrD2avh3MzaV7n4d8Rz+5WTDloZDgC9lkGAZMmvQyZb0kGordvbn09Tkx4U88/afC716+hktMIyyyhKLfLi1IH/b3zith5gRWyq0wNhKCnLOGkBWpIcQpwj/AFlGnWaXblCkssur3I2Sqf4U5/D70oSj4RYc4AWQk/rXL5uZx9mK/SK+x0Sx4E6k/nJ/cqPa9jSbDsyzRd4fh1hblvCbpR7u0aTI7syPlNfLzAc84kMMW5fYZhTiG0pKE/AM8RAMhPNfUrtUy3dXvZtmaycetbb4jCLpMvPtpABbMEknivmErs+u2MOLTWJYWpRbSkAXqPL3r2fCZZ3J9SfyODxBYfKisdc+pKN5mwxbZ77K+BPKPVVmkbeXhitdWYMtqJZfyJl8FW+runE/wXWrb5OvUPl0PW6+ISm6Qd/vRuez/NdxcJvLbB33AY3bKVCPoa93zJrn9jx6x+o5t3JGoLdyJZBYOkqTdPo289lmrFkVzJzmeMMThuV3rW7D6Qy8jEnFpQo9ShSd/aarVxkjMd4FKbwPEho3KkW6j/AVYezvAMWsM7YRcXWF3rSG3gVqdYUkbA7yQBRGbc1aMsiSTpkbm/8A5OVZrxVvErDMSLj4xwLLN2yElWoyQkt7e01BvYZ2ZLcJs73MjIHIcQwuPtE0/tFsLwZzxxXwzgS5euKQru1RBMzNVJlbzKSl4qKzyojgVMsrcmmkUoqrbLurAezpTaTaZwxNBiPz8OBIPWQldaltlHLS3CprtAtkpnfXh7oM/Qmquw8FJABAPMzuay2ylh0uqKd+fF1oWWL26Skr2TLGrJuHKcWGM8YOoqVytDyfv4KZc5C0W+q3zflx4/3RdrSqfYoH8ar7j8FRGw9RQcWQ0CFAR822xpXB9hdD9SetsiY4pk9xfYM8knYoxFr+ZrK32d5oUVOIRZPAify79lQH+3VebceFpoClAjYyoxRRqSwkOKVskwZinFxTXI0nW51nMeT8z3mFZZYw3CnroWeGJZd7oBelQO/WqJd5OzfbvOpXl7EiJgn4dRG/pXQ80JV/RvK6W1HWnD0KMq/SqS7fYgy64GcQfaXyC26oR9K6M/Q5bmWK3GkRi8vY/b2xU5gd+ABJKrZcD9KwOWWI9ylarS4Tt8pZUAB9qnLfMmbGEd03mDEdGmNIuFQfpNbrWb82ss6zj14Y+YFwkD9awUY+rGot8HPDZItrlLx8LhcmDtBit+6bKmJT4jtzxV4az1ml6G3sTC0ngONJUD9xWve5txu8AburawWEH/8AAmdz76atP3kq/Qo9+1qsyrVo0gKH+aat2VMxNPWxU6UFbY8RJMkAbk1B5tzPe2+Gks4TYLhSUK/qiNWg/NHr5VEWGJ5NRDzF7jTCvlIUlsgjy2qMsXkhUWXGfQ02jtLuKO3Ce8F4lKXO7LaFEwAI5+9UztqxJu4z9iKw2VflMifPSkRV+yledkWMWTD68WzA4tkJ1si1txuOmrVI94qpZ9zZkXHMw3t25ki6SdXdpWMTUVqSNgT4Yn2rz9PHJ53tOq9Wd8sy8ptLk5neXS3rTvAtSChaFEauo4qEx/4jEMVNwl93+zSnVJ2NdJbd7NnnCX8Gx63B+bub5te//ebFR2I4d2apuEvHEczsgqgaWbdyAfMahNenDrT5+p5smpFbwXHcZt76EXlyUN26EAd6YkTuB51LP5yzCyEP2eL3TLjboJKHFJPtsa3bfBMkd8W7TMWIp2CtT+GiTPnpWa2E5UwW4GkZxtEJnbvLF0ceema2U8kdkwXStmb2AduPana2xabz1jzfdLVo0Yg6mB9FV03s+/ED2uXuXs24m9njFbh/CbRpVsp10uBKiozzM7VytGRLRLRUxmjBndUmSp1H8UVc8kZTcwbLGam14xhahdWjelTVx+WgBXKyQIG9bYZzcvaexGSMI18TYT+LLtsQ8A7mpbkmIXbNK29ympBP4vu1i1fbbXidm5I312LRn9K5Y5lS+deSLW+wp4rUSjTiLMKPoSoCsdx2d5veuEutYeyvTyWr1lcfZZqPNzLg1lHC32O2t/jM7S2A25cW2DvBRBIVaD/yxW+x+N7PDdwpm4yngFykmdSkuJ/gquAt5Bz06NNvly9flUANo1n9KwP5Gzvbvkv5axVoAbp+EXI/Tmh6nKuP2I8rG9z0sx+N7FVKm6yHhRE79088g/SVGpuw/GzguvTiXZ5cATEsYn4o9lNmvIi8Jxa2PduYfftkK8RWwqf4Vm+FumU94u0eTq6lKhNT+Oyx7B5WN7HtG1/Gh2XXLYNzlLMdsqSCE3LCxv8A90VOOfii7MmsEtcddw7MFvbXa1NtgoZWoxzPiEV4ObS4txeobBXXaauuOqUvsrwB5CtKRdvpJ9PL1rpw6uc0+r+5lPClNJcM9cWn4rexi7SVOYri1mhP7rtiFE/6q+Kkbb8THYfdoCxntLO+kd9ZOo38tga+fzmh1saVDqBG1RL+H3i0NlteyXVLO3pSWtfct6aJ9Kbbt97F7yA32kYQjeIdU43+ikVKWHaZkHE8Raw7Ds6YTdvXEBltq5BWtR6ARua+Wa3LguqLgDnSCJ2rpfYriFs12q5PLyUW6GsVZl9aiEtz1V5CrhrYuXtGOTD0QclyfSkEqBUQSSOTSkgQk7dRW5Y4Hil7bC6wq0cxG2V8txaJLrTh66VAb71lGWsxqVpTgN9MSQbdQP8ACuvzoPhoyUZNcEbzsnrTzpA5E+1SAyvmJJ/+8V9/7k05eU8yQCcCvQCerdPzYeovK9xFQlRkbHoYoESBI52qVGVcxwJwS733H5cTTk5SzCuSjBrlZTuQkAkfrS86HqifLm+CIO6jCZnqafsUaeakV5VzI2dLmCXSD5KSB/OnKyrmJsalYQ+nyJKQP40nnx+pbhKuCM0jSBFNkKI3kDaDUp/RvHCPFYrSAZJ1I/xrG7l/FWkBa7dCQTAKnmx/5qbzY3xJBHFPuiPBBEx9aaZnWOu5qVbyvjdwoi3sg6UoK1hDzZIA5J8XFaZslaQTcWiQJBJu2oB/1qnz8b26kLycl3RrmVc7CgrYgcnzoqVaIUEKxXCgpXCV4gyk/qqjqsNfdHG8GSr1xS3/APrqnlgl+YPIklwKABANAKMxM0VKs0t94rGcJCNQTq/aDJEn1Cop7TdtcN95b4rhjoBjU3ftKE/RVJ58ceZCWGa5RjUdO00hAEgbnpWUstd0u4XiOGpbb2Ws3zQCfeVVqtvsvAOMPIdQeFIUClXqD1FVHLGfDB45Y92PkQExEUUhITOojfpTP3oUZoifIkHyrSzNxCrad9/agCrg/WkkKBIJnrSKgQRMjzoIaFqMaiJ86B3TuaU7SNvelMDUB96B7ocokbcChqgAhXFBUCInjrQ2SmSCR6UN7DXO47UdjHPXqaJMnbmmyDISDuYpadBIMgetJOypJXsIlXJANISedyKSlSIkUwKCYAMmaH7hxaSJWUqHJ8zSiDJjcQaaYg6QN+ZFGNQP8KmjSNhkI3kDy3oBWowYg8mlA0idIHrSXoTG/wBelK6CxBJ4O5ok6TwIoCImeaUAjfmi7KjQdunWiBG8gUAAnmhEjUTJ6UUNq0HUSZiZokGN5Apg3PmBsSKdxzQ6QkukJ4AB3pAHTBO9NkEnzolW2kfekq7FciCfMwaWokz0pAjlXWlyQQKFZFMRKY3Joaj7ijqOqJpHc7c0cDrbccCImQTQ4O3PrSAnYdOaz2zNo4kuXLzgjo0iVfrWOfPj08evI6RpixSyvpgrZghY22FLS5IKvOfIRUileEtYaMTGE3jifixbBFy+GtXhKioaQfLiodvOFs7eu2reWbJkNL0FbrzitXmYnivOn41pourOqOgzSdIzTAMxz50pA4VHvWdrHb9V0EN4XhbbCxKf6vPX1JrDmHOmJYQEIbFjbyAdSLJA28txWL8dwx7M2/2vMu6B3jY31gfWkHE7+KZ53qGte0TH7t65/wCdAhCYLYFs2P0is4z1jD7Dzpxx+SooBQ2hIRA8gKj/AH/F/wBWU/CslcolEqC9mvFJ2CTM08W90DKmHAOvgUf5Vyi57U85vqdsbTM92XW1mHFOBJieIq8Xma8yp7DcMzCrF7pvFncact13IWdZQnVCduRWsfGIy3itjLJ4dLFDqcu9E6AU+Eq3B3HUU4svqAAaXKtkjTuaofZFid5jeU7jEsRuHX33sVu5cWZUYUIk1fGb6/PZtnO7XeOpu2ENotVqWQpsT+6eU/Su3UaryIqVHPDB1uSb4Iu/F6jHcILDFsEMqJug6yCpxv8AuGRuJ8/Kpmyx7HLt65bGJXKG0pSEpbhKQBtACYgCKgsAySjH7TD7/E8UsytbKiC+t1x4gnrA/nVgy7l7LmAPXH/OpW6VQpVvYAGJ4la6+L1GXLlyuV0n7z6XBDFigotW17n9iXaOKh1N09e3TobT3qQp1Q4B86gbK7eXauKZblRgpHnJk1d7O4y9fOhnRiDoLDm6loRslJJEAHnfrVds8Sy0hom1y+nSB4e/uXFT9iBWUsckl1S2fvsqOS5uMYP6L9yOXdoauEdQESSIEHy5rN8a0myJcuEqUs7pSQpQHtWe8xS1QpPw+FYUyuIEWqVn3Oua2v6R4pb2BcZuQzCfmYbQ2R7QkRXPUU95fQ3TnX5fm/4ZFWtvi13esuWlhfPJSCApFuvce8RNbmPZRzI7lFDbOGqYccxjv1JeWlshruonxEdTWN/MmIOXIP7Ru3FaZSFvqMn2msuNpub7LmGou1F0qxJ1Z18ABkf412YOipU3x7ji1LyqCuuUaWD5WvxbqTd3eGMFSoOq7SqNvJGqsico5bN2m7xbHg6lpUuJtmFmSOACQK27O0CWNSHNM/NtpHvWiu40OJZUpCQVid9yPOp6oL+n6mnTP/t9P/ZPXOFZS7s3BuMUdaPhQhCG20jbzVJr5y/5QxzKTee2WbXCL63uxhlqEXBu+8lPeOSVJ0gSeNq+g2NYnaN2yEqu0JCum5P0Ar5xf5QVu7czg1eDDrhdmmztUfEqaKUhRWvwmeK6dI080VSPL18WoJ23uav4IV4Cx2x5bGm6ul9+QlDzaFN6tCtyOa+oCMYctyRbN2luUCAGbdtMn3iZr5U/gVWlztsy4gWz61IdWpIQ2VT4FRNfUnD8PxG9vFi5wu6YbkgFxKUA+wkmK6/E8jhNb0duCEZYYOSJZnE8UuUyu+eSVqEgLgEeUCsd7Z3NvbJLiQEFZCUgc1ldw+7tSksNMthKSJU7MnpwKlbdi6urVCbt1tJABIaVMefIrxnLqdpnT7MFaRD5PS5/SWyUhACJOoARJg/pVDXeuoKvyinvVKBM8jUf02rruCWWBWeJ29xZl1TwURLi56Hyqtv2eV3HUKXly2eLZmVyYJPkTFdOSSeGO97v+xzJt6i4rsimXF60kNpSttBIKlGQOPSsJ793u3Gm1XKT1bQoxPtXSW8QwXD1p+EwTD21DfUm3SD94rFe5mcJJZkKV0Bge0CuJ0u50qWRv8v1/g5+9geYLgBLOBX8q8UqaUlMe5irZl3BMbZfw9u6t22YdSo63k7eIdATWUYriLl66tTm3AlZqLz7nG6ylkfHsxvq0jCsNubtKgqIUhslMR11RWmJ48Uk1uE/NUW7SRM4xlLH7vFb9xm/wxlt+7dWhTrxJIKpiAKwIyEW7UnEM1oJ1StLDWofSSN6o+Q83XeZ8jZexZ6VO4hhlveK3k6ltyqfLxA1cWnljCWLmXEJW5xG53oyqDm249x4sOSEEurj3GNWXcoYepZfxbE7gqI1Ed2kD9K8ZZfdyE92/pv7HDsaF0vMv5anb1tSFKD/AIZSG5jbzr1ti1uLoupNyE6oJTuSB9OK8N9mtzfs/iAsFJQ6ypWZ9KQpB2SbiJ3Hl/Gu/wALcfNapLY580azRTbZ9IbrDL043fqtrR5ZdcUvVpgAe52rGjBb5QQi8KWEkk+O4Qk+m01t3T9ycQvC46pSUv6U+LoI2rHoNy+DcteFJEVw5lBZ2pJvf1NsEsqxRSaSr0v+5mx/BmrqxwQu4jbNuWlu4ElZUrVJTJBA34qp3GD261q/+6ZlEqB8DTh4+lWjMXct2+DBI8Is1wkDeCoVWFd2oLTpKACenStNaovO043su/uRnouuWK1Lu/T1+AHMMtm2jOYtSZk93ZqhP3VWoGcIGptzHLsq31D4DgH11U43tsu7UyhepASPDO1PcFigEmRr58e0xWUPLquhfX7nTJSa9qT+n2LF2ZDDLfEMSbsbm5uJstTqltBEAEwAATJ5rlTljlpy3FwziuJIQQVBSrVqUgnjZUmuq9lC0OLxRZSApNoARztJri6FOXjJtm9IbDZj0M136ppYMdr1PPxJ/iZ7vsSisLy04QBi2KSTIUGW0wfUaqr+MYbly1SlacxYspIEEC2ZPingeIVIXLoYSElzxKTtHXaqrirqFKImFAg79a41kjy4L6/c6+mV31P6fYbcM4E20dV7jbiFAwAzbpJj/vGqVibWUFXzCi7mArD6Fd0pq3CSSoQNQV5x0qexDEAVJVrRABgnmqcxf2juMtpdRubpACpkDxjyrqwSj5qdGUov1Olfijw/DcTxjL7+NYriVjiCbNwJYtrZt5OjvOSorT122+9ef7jLuAJecU7mfEh4tST+yUqJPXh6u/fjFxvXnnLlshCWv+bFSVeXffzivNWP4mtbot0XKkrIBltMz512SmnN9SOKCc43dfL7GnimDZTZuSbrPlxbgpiVYO4ZM8EBz+dQj+U8qXneOMdpTKUajJXhzyQPpJqLzJcPm0Q0kn5yfEd9q0k6U4XCFELUk6veqhOPU/ZCaklyXvsxy1hmE53wy4Yzlh+JIbc1pDVu82SIPGoRP1qB7S8vLRnTF7i0xrClh+9dVodeUhSJPB2ia2Ox5D9/nnCbZDiQlaykwegBqA7Swm3znjTbunUnEHU777aq2ySUca+JirU16mva5SxAFa27vD3kxwi8QST6b1XsyYJjTFmt13CHygklK0QsafPY1vFsIIUlSTAkCoHMt9cs27i0PqSBzCiIrnjSZvNOjcwDLOaH2UJZwLEXNadadFqsmOnAq4sZUzMWUKOWcTSscn4RyftFUfLWP4w00w8nFbmflB71Ux5c1ebbMOLhaHf2pdKJ2I7xW3611TjBrlmMersXfIuWs0HG7BCsvXwIfRALCgdlDzG1e4uzDCcUts84Q/fWK2E9/Mu6QQNJ43mvDOWccxReIMqaun5LiNIEyZPWvdvZfe291nDA0aR3neCCRJ2Qr+Yriy4sTz47buzsxyyeRPZcFU7WMq5hxXtWxy+sbFC2n30ISTcNoJIQkRuoHc1E3fZ/n3Dn22rrLLgLqTH5re301Vf+0fFPgc+YsyLRDs3U7pBM6U/Wod7G8QS8pMFCgAAfIeVeJqliWWXXd2dukeTyYJVVIh8Mynm+1CUrwJ5AgTLyORz+9V97OcFxhrHhcYowbVCGlCQpK+UnyJqut4ziK1KS5cEgjbc1ZsiXLy8XbduHgdbSxBO3ymlpfLWaL3LzOflSTa4fb+SZtcBy+htkrvb59BT4vElH2gU13C8pIhSsMXcFEgB59RgzyIIio3D7pKra3nUo90N524rUucRtW0qaWfFJ5MUnl6ZXS+RccSr2m/mdIw5VhaZOvnGLFlppNygKRyCTHnVfGO2STAw1tGrySNq3bdabvs5vVW41Fd82THQak1VX7fE1PKDOH3a0gn5GFq2nbgV3a3JNeW1/1RyabHj6sil6ku9nBxqW7dlhMkSEspHHWo24zpija0hVyEayUJTpHlPlWijAcfuyqMDxHxKkK+GWP5Vifylm4XDahl7EHUhRM9yqRtFcccuou42ayhgqtvoTjmaLtxlu3L7oLpAJneJjepbtgx66wvHbC0t7txtLlkVFKVEfv81WGsoZvW826jL16glaSsrbgJ3EnmrJ2z5azLjOOYZfYHg796lu0U0tTYBCTrnevVw+atNOTu7Rw5vKeogrVb+hzTE8yYo+Zt8RuGiCNel1Q1AdDvuK0cVxa7LLoYvrlK3AFFxLqpTt03qQvMi9oKnToylfAHaSlO4+9Rt1kPtHdTp/ohiWpKQCYRBHn81cCyZ273+p1PyKq19Ci3uccyMXAsLzEXL23EaAp1aVg+RINQX9Jrj4p1u+OJMBZAbWm6cASONiFbVbrnsk7Tn3tRyffJbJJPhRuPP5pqPuOyTtIcd1OZSxHSgjSlOgpjz5ruWTI4/8l/UxflLuvoXbs9cLWQM8Yrht/drurayVodeuFuLR+UskAqJ9DXnDFsz5l+NQu3zVizYUjUQLxZ3Pua9PZIytjmB9nWcsNvsIuWb7ELdaLNhaIW8osrTA36kgV5txDsr7UmUh1XZ9jziT4ElFopR29BzXXbai7ZxqMZSkU6/zZmthtT5zbipK1H53yoD71U8Uz3nO1UGnsYbubU8Jetm1n7kGrziPZrn4WaU3WRccRplSpsHht/q1z3NmUM6WTSCrKuMNomfzLBwbf6tdWPM00mzKeKKXBFvY8L64dW5h2FKVHhUMPaB9ZIFW74oOdkLuILsrJRF+lHc91DfWFaR12rmLlviOtQdtbm28UfmMqR77EV0hQWz2NuW7QlYxBKp59p+5r1MMruvQ4sq9Tkd4jCHn++cy5apWo/uOuD6jxQPtWndYThS0qVbs3DKiAZ70KE+xFb17bPuuKKFIUob8Vp3QdLBSpIUsgDYQKIySRnJUSWNX9thWJtJuMLtL1K7C2Sn4psqCYbG4AIg1htsx4bcISEZOwQCTOhpxJX9dda2crTEby5batLVx51FswCGwSY0CNqhbHC8cw9BeusJv1JSNRhlcJ9eKqTadk7FmuMz4ZpDF5kbCgtcp16ntQT5Dx8UU3mUi2PiMno2Efl3jqf0JNVe+cvXnmnDY3jcdF2607Rt0pi/iNKiUOGCD8hgVG92ymn6nZrR3K6ezu+ausLumcOU+jvGm3gVztB1KHpVKNv2TPXICcSx+1UEkgqbZdH6EGKnrO7Z/5Obpm5SQpdyjUop6ACB95rnl3b2RuS+0pImQQTtW89optWSkmixs5Ky5fPtXGH51abhYKW7q1U3qE8SJE1es7YFhrmVrWzzEm4fYdxO6fZNq+lOlRCZPBnaNorlNugrcR3bh8SgB9DXQs/37jGWcG0JcUFYle6lASEjwR/Gs5yj5dJGuP8yRAowHLlqBa2l9iTaXEf8AWBDkbjaBB61NW+WRZZRxti2xJu479Vqv+zKQgpUrmSR1qpjFu+Wwtp0EgGImrdhl3GT8wr1cKtEmTH7yq8/l7HVFvscA7VMPube2eU8lKUkCFBUg7+dcxsGm+4vJcR/YgDf/ADhXVO1V5N1ZuNOOgJBCkkdN+tczssOQpm5Wm58GgBXh3AkceddOB1E5M28iUyMtq0dxArcbVqYA9vF7V66/D7nbM+Sri0cbsrheF3iUpuEFBCVoI+ZJOxIryhkvC7Jx66CLlxwENoWgp07FQr0FgOMLt+4tm4QhoBKBHAFZaiEcicZ8MrDkljfVE+iuD5NzXimHt4phWEOPN3KEOtL75EKQRII8VSmO5AzbieHItP2c006RqIcfTsAOdprlf4Wu2a6vsKcyPfvud7apLlkoqI8P7yPWORXeG8VvC2+S6pLgbVCp3Ag18NqsOPS5+hpn1umzT1ONSb3+BdMwZRvcUvrR9OJ2TKv2batrQ4VSClHQAbjeom57PLoOBTmYLfSoeMtsk6PuoTUtj188i/tlJUIOG2hk9SUVHN3Vw4QVEQf71PVOEs8nKNv9Q00MnkRqdKvcG3yLglmBqx5x9cyA2hKAffY1tIwLLCEHvFXqlpBnU9KZ+gG1aC7tB3XcJ8gNQrBZvlTRbALilKMJTKj9AKyUocdKNXja3cmTWHYNl1i0QbtpT6xPyyB/E1nGHZRCkrOXrVR4lY1GsNtZ4u8yhLOFXe/J7lQ/lWdWEY2G/Fg9wCOFKAT/ABIq4Y8j/JH6GMnhv25/ORMZWewkYwyzh+E2tqUodWlTSNJjTVXazxi4bbKXUoUedIirFlHDb9jHGVPlpAaacCgp9BUSUxwCTFU39h3IcUleM4KnSoz/AFlRI32+VBrvnDULTQUE1K37vQwxvTrPO6ape832sdv1hby3Va1klXSTWjc4revupc+IX+XuraacMIbt5VcZpsD6NMOuH+ApOWeX0JhzMd6o8lLNilP2Kl1wSw5+Juv1X3OxZcKWy/8A1f2KB2zYtco7OM0qt21uOfst9CQUxEoO59BXzYtb14YeyHnDq0JCiFcxX057TP6Cs5Gx1V65mC4ZGHXBWEdy2VDQfQ7V851WvZw6wgpGPMeEEgraUQPsK9fweEouSclv7zg8RzdWKPstEI3iKlDSVGJkVuNX100yVMvOCT0VUqzh3ZctAnM+YGRtP/N7K4P/ALwVgVhGRigm2zxet8kd7hv8gs178VNcfueO+nlkazmTFmdaWrtwAGNJWePeawYx2gY5gOBXeJMYtcNLQiAUuKBmfet4YTgRQQnN1oExIWu3cAn6A1zXtztrfBMpNpZzRh98u7fSkMW+sLgbkkKSNvrVx8xur+pjkqjoNp2iZqxWwaTiGMXDxdSA4SskmmjNV40+8UhCpQArvWwsEfWoTs4y7c4zl+1vWsxYI13zSSGnropcB8j4Y/WrC5kLFy8pDGJ4Q8Tzov2/5xTccifqKDxtWhM5jQ2pLruEYa4U/vKtURPlxT3M4sPpUg5dwkFZjWm1Skj2inN9m+bAyHbdqxfBiUt4gyoj6aqxtdm+d0q3y7cLgzLS0LA94NR1ZfTb4FVj9Rtti+BJWtt/LNi4SQSdJBPpsaztYhlMom4yuysK/dS+4gp9oVWJ3ImeLZRfeypiMT4SGFbnz2FRL+Xc0tCXcDxBCUnk2y4/hS6m/wAy+g4xinsSybrKbg1HA320f9mi6Vtv5kE1laRkd9QLljiSUkwQLpO33TVfNjfNtDvrG4SOstn/AArD+YwopnTq/dI3pqe+6XyHJbbM7hmVeXEYZgLd2/eNNmzSLbu9DhKJ21TG/HFU65tsoqdlnMF0kk767NJgfRdZM7vKGX8ov95qIw+Bt61RFKcNwp8NagYn1rXNJOfBGPF7GzLmcPy7rhGagCeCq1UB+hNZf2NhKwW2Mz2ZB2OptwfwBqjhUtqCdaSTxyQaBdcbGnUoep5rHqiuxooOPDLgrCBbuFlu+s3wNgoOED9RNMcwC5WhShe2R9rgDf61Tl3j7iwsqSAIBPUAVlfvXggLC3Ajk+tPqXoRTfcn8Uy5frt3WwbVxSm1GPiG4MCfOuIOXrzfeNotXQQoggIPn510rEXlrw9xaVqjSTEzPvXO1ZkxdBCjfOykECVVolBcFPZc2SOXcyYpgt+zcWyHJkBSCDCk+RHWug3uF4+u7dujgN+0HPzAVWjgkeY24rjqs9Y2pfc3Fw4pCVeHbk+9dKwHOGYbxubnGLxRCQPG6pRG3G5qHihfUyFlkn0m2m3v2HFfEWj6AeAppQn7itK+UsuhCwUE7gLTBj61MIzZial6DfF3TBGtW+9ZV44q8vm3LsJdUkQQd5o6YdmJyaXBApdKHCUlOpQj0963WXXAmCASnfYbx5+tWK4xRvugS2yQCNKS0kkfWK1hi9i4nRcWbDhBkHugD7GBT8uv6gUnXBrNXQctijQQrbg7VccmLD2V832qyVunDIbG/Oqq41i2GNILisMt1lZgJUgj67Gr3kC4wzEsPzAk2LDIasNbndyC4J2B32FbYY9M+TOdyStVucPXYNMgOKCgorndUTURithfOuJdZdU1KthqMTXW7rKuWL1CUqwjQsq1d4i4cn9SRHsK13MlYC20sabzvQJaULzZPukoMisep3SZvPG5cnPrH9s2zACn3FqlJlLhn1rMcczXbOTaYlftKJAJTcKG33q6MZRtVtkO3L5MwdJTx6bVtWeSMEccV8Rd4kymIBKG1/zFV5rjumSoVtRWrDPmb7N9LTWZcRBEatb6lE/c1Mt9pebEvLC8ZWv/APGQf41tP5LwU3A7nGn2kqMErtEqiPOF0XchYdqXozE0tYgjvLRSQQfUKVVLLkly/qHQkayO0TMyntJdt3ep126DP6Vd8VzTfHs2wnFHLSyccduXUOIXbp0fRMfrVNTk19o6msVslrSNKk6XBH+zVivmbO67P8Ny6rFLc31lcLWpvfdKvpW2PI4J2TOMbi2VhGb7VadT+WMEX+9vZhO/0IpP5uwZDQcfyZhDpJ3TDiBH0UK015NxBxWi2XbqTEz34H8a1X8n46lRSptBSIOpDyCI8uawWSXNfQtwg3yb11mXKb5AGQrZhXMs3boH0BJqcyXi2TkZowksZbuGbs3rQYcF1qQhROxIKd6qn9D8x3LPxLGFLKEyNYUkjb6zUvlTA8ewfNOB3l/gTpbRdtO6HkEIdSlQJBKTOn2NZZMjcWq+glGMd1+56xwrtPzLl24ucJTiN41aNuq7tttakhqd9hPrNWXD854niAF2rHbpagZ1l5RJ9OaoOK5g7LMSxN93HDjOD3yoKrTDGG1MJ220l1ZVx51J4TinY+hIescYzenaNJt7UiR5gKr56ayV7Mvkz3ISx0l0/QuD+acYWtShi92Dq6OkTT1ZjxnShtWL3hSqCQHlVpYfmPsYuCGl3ub23gPlKLWFe1Trdx2Sgtnvc2LkSP8Ao4IHrtXO/wASlvP/APb+TpWTD+Xp+hHft/FUgqXid2UoGlIU+ox9zWS2x3ElNEt3byCeqXCCakDddk8EBnNTh8y9bp/8prK1f9mLbSVIwvMi0nYTfMj/APZ1CefvP/8AYpSxLiD+RAt4pft3LzxvHgVQd3CT+pojEbvvkly7dJV/7Q1K3mJ9mTbgV+wsxKBEEftBoGf/AHdYG8b7L2XpOWsyqI41Yk0B/wDKq+nI9uv6leZD/p9DE8q4WxHfLAUoDdZk/rWpiJIbHfLJ0mdjtU8rNXZkW0q/ovmAx+7+1UT/APKrE9mHs5Ud8l44r/SxpAG//wCRpeTkT2kvmQsie/Q/kvuXb8PzwurzNOHEkOLwZxTaiTKdyDv9q4/iDK37TuO/WtAPIHlzXd+wfEsmXGO4mxg+BXdm+vC3S4p2+76WwoSmNKYO/NUO/wA45Ywm3UwjIZebBICV4kUk7/6G1de8ccV1L5nPgfVLLUXVr0955zz7hqMYYS2NTvdmSYmI4qms5duXUNN3CR3SQoaDtM16YVn3srw63eSrs0c1OL1KAxRS5J5g6BWle5i7K8RUlK+zZWgJBB/abqVb9Nk1UZ5IRpTXzJyJ5HTi18jztngu2HZ3+zcPa+GDb6D+X1PEk+1WbsY72zwVpi6Cgttal6lK3Mjmun5wxbsgs8AW2rsk+Ka2UErxq4G/mYTvW7kTF8iPWyXbbspsmWliE6cYuCRsPMVU5SljalJfMznCnBOL+n3OH9s7N8rC7+9tLtyEwo6SZgdBFerOzl0v5IwR1RJ12DB32/cFU7NWJ9n79s/a3PZTZ3DaW1FQXiVzB24kVfsqXFlc5fsXsPsU2duplHdsJUVBtMbJBO5j1r2fAJtKUXK/7Hn+NY1JwnTXJMpUVAp4IPn0olUCATQRHAAE+dAmDBA+tfSHi9SCFKEk9TQiEkA706DtKVAE89Kaqdex2oHs1YSCB/PzoQdPE+hpFceCI23pcjYzRTu2QpJukJSSFf8AG1HdI3O/l6UATHmTzQVOo+fFOy6XcOoEGdt52pKImBvPU80wKHig/KYohU7mhmaW48hIGwoQNYge9ARyDNLUdUxv0pWadqJGABuBPUiiSEmANhxSVxq8zvSTJikbLgJ3TJH6xS2UNIG3vQUVfL9aBhPhBO4mi0iWq4HGJO0j1padtR68U1MDjr50UTqAPQUupC27jh4UgzQnUN1c9KUlIE8TQMfNI2NNsaa4Dt+9tAjaiQAAQeu9N3gkjf2mkkjgg0MocICtuvFIEwR0Jpu2sb8b0gogExIBmpT9Bd9gp0+VIqIMTAoSCZB2HFEkFVNOxNWHY7ikOpHSgSCJ6elAiTAPIihlVfI6NXl9a3LO2ur1C27Rl14hJGlCSTPsK05g/SateF4hfs4J3bbyw2EKOlB07+vnXheN08Cv1PS8LjJ5H0+gHMtYg5lyxS7bLQ61iJdCbhYa2LcbajUM5k17vVqQq0SvVOlV22SN56HirDeuXCcOw9w263kIvXEr1AHSO7Tvv9a1C/3dwspc7vVCU69o+1fLZOm0peh7OLHNOW/f0/k1V5cL6mkP3WHMaR8oeWv+CKgc19n1tiqmUP5msB3fi3tXXJ/gKlviHWsXcQ7dDSlIgJMKj2qLxfEWGcQZ0OhwOeGFCNNR7D7FSU/+37Gqz2eYcoOu/wBK7aTp1d3hqxx7rFYG+z/CrZpxpeb7tQcJVLeGCBPu5UmG71QUhizfUlZEqS0qD7bb1qYpeYtbW6ja4HiDrqUkhKbVZmPpBo6I+hEpSkq6v2+xTx2YZIReupczZiinkDUoJw5oH1iXTFXS9wTK73ZTl/BFX+JmxcxB95t/um0vlxMyFSdIG5qjYXa5puLm/fGWcUbcuVQEuW6gVeR3q8Y5g2O/8l2XMLbw67VetXV06600ypxSdUgSE8c10KTUHSow1MWoLqd7o81ZZ7dcOyTieL5SscHxK/tLTGLruXVNEykr6lvYmRXqLA7zLWM9k+ZLwPYqi0uEMLvQW0B5sGDDYBjr1r5Z5q7Qso5bz/iWXs2ZczI9iLeIPBwW2Ipt20kuHYtqaUZ+or6Z4BgF0rsax1GFYfck39vYKZbW2pKiNKSAmQAfUxXsamcpYIuXdHPijjyYHlXNpfUw2d6zbos7XDsSuUWiGFIQq4CUrI1TKhxq9qx4Pc3rlxcNO3CborUO67lsle3mBPnUxla+vMLs7dtzALJ0MNArlCUupVJmZEK6dRVwwDHkrYK22+50H5dGkivlcmOKn1We9GM1G6+pq5Osr9vEUqucPuUxbvmHGymfyz51q4XlrGr20Wn4NTZTHKkiD5VEdsHatc5LwrC8Q77Sb7GrLDiSs7pdXCh/qhVXC3xe8Uh8SUpS5pSBxpFbSismOPus5oRySm5xaXYjjkPFUlLly7atFf8AfePT2FSDuSlvWPctX7bQCfnI1An03/jTn71y4dSlThCUp21bzWS9vi3YIQ5cySngHmsmopVRo45a3l9DXTlHC7NSHrzFXXlQZ0kJj22Nbl7h2BKwqwbdU+GRcPKbV3ni1aUzuI6VX3Bc3C0tss3bvh20NKVz7Cp93AMcfwLDGhhryi28+tWqEqTISBIJHlXXhg5Rko+hx6ioqKlLuhqE5etW0pFot9skqCHjrEjpJ3pjOO4e08rubK1YKFhPhbSCB03isTeXsTZZSHRbsmT4XbpA+uxNa7eWnVEpdxfDUjVJIUtwz9E/zrOWPI+TeLwN7u/qTGNXrFu0p5bXicIUrSTv618vP8opihf7UHW1Kclmys06TJ3JWevoRX1Iv8ItHbb+s4uvUlIE29sNv9cxXy9/yiljlRztKuE2mJYm5iLdvYoWp5LZaKdKjvp3CuIro0WOa1Eer90eb4hKLgopP5A/yd61PdtGDOd+pUIeMdB+WqvqS44U3qEalQASQOvHNfMP/J32mGs9s2Ej44XKy0+O6LSkT+Wd9QNfUNT1t8eltvC7QQPmUkrV+prt8WUfMjv2OzBJwxRSjexpX+khQVcAjkJJGxpl7dMC0RLuhKTJ0mN6lUXqkLHwzTCN4OhlA/lWe6vcTWgNodV49iAYArxpKCW0n8v5NVkna9lfP+DRy1h167fWrybO47hJWoKU2UiCgjrUQvLmNMJbbdsi0kHl1xCJ+5qz2WIXK3AhT6vAy6CgnYqCDBqjtqdcKXXHQpSoBJH1gTXTOeKOGF2+fd6fEyh5stRJ7LZer+xuO5dxNSyt25w9lIM+O7SSB7JBorwFLoM5gsGzE+BDjkfoN60bp1YdEKAABkf3qxOrctZcSrUHEzvtFc/nYlxH6/ZHV5eR7dXyS/uSjWC4LbqUbnM9y9G5S1ZhO3upVcP/ABvZpy3lTsCxZllWKvrxe5t8MCQ801qCzqV0MjSgz711u7Wbhgkuoa8O6prxD/lMc4rwjLOUcsMuhSrk3uIuqB40JS2n9VmttLNZMsYRgvr9zk10XhxNyk38vsejvwXdoGBZq/DjlvE2sCtnHmS9hjhdUVT3SzpBAjooV3hrFmXWErbwqySUAhE24VHtqJrw7/kubvE8c7EccwRq3fdThON94mE7JDrQPPumvbVrh+KFgMqtlJMdVJ/xro1s8uPM4wVL4GsYYGuqT595hxHNeM2LJ+EeQyUpJPdIQj+VeFOy3tAzjmDtrw3DXMbun0PZgGppSwUqHf7g7cRXuK9ypi9wy8VFhuZAU4tUJEcqhO1eE+yjINzZdr+EYovGsPuGUY0la+5cdlUPHZMoAMxW3h08s8tzdo5prAsq6KPobiFqGMRujcX1i0nvyqS7Kh6FKQd6xpvsIK1A4yVFHIatlGPvFZbu0tXHrlLgSUm5UD7zWJvC7K2WsMI0qcTseYriy5sfnOod/VmuGP8Axrqk+OyX2N3MNngVz+y3rq6vtTVoe67hKRqQSOZ4NQL1pl5ALjdpizgH/wC8ITP6VMY++zZ3Fg27uE4ekDbrqqFbxVruyVwJJATG/tVa7UyjqGlBdu3uDQ4bxJtvv3ruaD+H5beu0N/0exAqUkKChiMT7+CmqssAbcW6jLN2SNvFiqoO3+jWO4xdxu9C1NwjSQmNtprTvMQeuUAWjRcKFggATPpNc8dQ74j8kdTwxSu382XLs5uMMSnE3sPwQWkW5UoG6U7qCSdtxtvXOWrrKi7Nt9OS51plKRfuiJ6V0HsuacFlijq0Qk2oSg+nirm6VMt2zCHXdigBUrGx9K9HU5JLBjlS+SPOxYovUZFK+3dmZT+W3U63sltjSAk6sRdnfpUNif8AQm6ZLoyUj8tZQqMTeTuPoa2724tfkJBSkjSZmPWKqt3i60OrQlxgMBRKpIBJPBrkWe+Uvkjp8mns3839zKuwyK+kKdyCkA7j/nR6arLyeza0xe3ZGQ+7eFwiHEYo6YOoQYI33rbvscDLafh0hZB/dUOK5+zjovMxWza3EqeVetiNQP8A1g2HpW+GS60qRE4pd382dG/Erc5JtM5WDGa8u3OJ3KbErbfZvzbBKe8PhICT1rh+M4v2MpK3bnI+PJKCdXdY+kCPTUzXUvxTBxrtHsmrx1IbThidaVf3i6oia895ttrK8W4VBSSQYgbfbrXXLJ0z4TOXHC42jfdxD8P+Z2R3OTs52irfc6ceYJWfLdiOajrtrsRYBZTh2dmgPDJxG2Wr792KrNgEICDaW40EnWma08ZvUl9Xe2YSCsJHrWvnJ7JCcL7s6N2aWnZw3njDTldzMaL4OKLaL0slqNJ5KQDx6VUM/wCGdnb+bsYXiWNY6zeOXzq193Zocb16jIHiBrZ7InUtdqWEOkkNpWoz5QhW1QPaEWFZ2xd9LqgVX7x44lRrbJJeSm0ZKFTswXGAZHdSn4XP7zalHxIuMLUnb3So1WMzZQsnbZxNjm/B3wRKe8dU0T/rJgVkdNoXBpuIKeZqu5vWhVosIJJ0Hg771y45L0NZt9Nk3g2Rrh8Is/6S5Zb/AHwV4s2B9at9vld63dDP9JctL25RiiFJPpXGMJIDbKXApJ/dnrAqawm2ubl1CUqKE6iSSNjXZ/x80/mc8Oprk9OdmGQ38TzFZuO5py0x3Vy0SHcSCQvxDZO1e1OzjKy7TO2F3BzHgFx3T6lqYt73vXFeEiAI6TXzx7Ou/VmXDGg6ohu6aMyfOvc/Y624e0bBnHVJSe/XB1SVeBVcWWWOepxpp323/g7oRm9PN9W1PsWntAykzcZ5xTElZuwRgvXCV9zcXC0uIhIGkgJNVl7L6bi9UtGdcvtJ3SQVPLP0IRQ7TsPcue1DHHkuEti5QDtwQhOw3qs3jTaLlwhHiJJBANeHqZw8+SceG+/8HXo4ZPJjUu3oiyf0ebBUr+mmAhA21Q/J+zdXfs7wzD7HFkLucWtcSKW1aGrYuDfT8yipI2idvWuLMakLUkpUUjxAEmAetdQ7MXB/SBkgEBTZBJBG2k9KrS5Mfnx6Yb36mmoxZHik5SdV6JFoTiOFN2rRtcs4ajUPBr1rCR6ya07zNd7Zv6bOww1gDnurNuR6zE1pM3LDdihRe1+GdIEkfQVqi0xjEXpt8NuykpKfBbrlU/Typ/iMqk+jb4JfYSw4elOX1f3Om4XmPEV5IusUN04p5FwlCFAARMbCAKq15nDHg9p/a92mVCfzCAKsWGYXiTGQ3rIWC++N2hfdKEEjwzz7VVcQy7jTrqg3h69KDqGpaBz03Nehq8uf2Ohv8qOTTrT9c+quduPcNuczYnc6g3i1xBkGX1T/ABqNOKXThV39w85vCSp5Rjb3rbbyzjKUE/BobJA8RdRyfYmirLOKoUFrNuNo8T4BJHpXL16hxt39To/4EtqI125Nx8M27duiLlpQPeHbxj1qf7bnQrN2HNG6dbQ3ZEkNrImV+U1Gt5fuy8ytbtjAfQVHv5XsueIqy9r+CO3+P216xcWqSizCCh1wpUfETMBJrth5r0km7u0cOSUJaiHTxTOa3zttbJQRq0GAgnc/U1B3OKi3feaCEkaQd1SAfat3EMuY3eLi0xDDWtA1KSt1wEzxH5ZqEuspY7c3HxT2NYYkJT3a0964sk+cBFcsfPeyv5nX1YiLxTEcOdcJulBCQoDw7SfWq9ir2DPrda7jQhOyFAc1P3+VMQSUqvMVw9CEkfuvEfX8uq/jeXEuuKjGMOO+0h/p7NkRWsfMkqIbidB7Pre1/wCSPPbFu4pKU26lpUFGUEsL439K833rt01bjuMTukKLcyl9SeR6GvRvZth7Ccg5wwlnF7N34q1WVLb7wNtQ0sStS0J6HgTXALjBrNFsll7NuXtWgJKvjFCYHmUD7V6jjk6Y02cEWlKRWxjWYbdKnhmLE0lEiRdOcf61QGK59z+0zobzdjQbWvcG/dMjyjVU8q2sg2uzTmXAnV6j8t8OPqKreMYBduKBZxLCVJ1SP+cGxJ9N6rG8y5szyuNWiu3PaB2hB5R/pbiqkDYJcfKtP32FWU5mxy27LV42++l2+XfaC46hKgpPIBBTHSqxe5fxEhRKLRRJPhavmlT9lVPYxhuMK7KkYYhhTj6bySy2Qsgb77elergcultvsefN8FCd7QLy7c13OGYS5tJ1WLYg9flArUXmDBb1Z/aOWLMpI3NqtbSvfckfpUDdYZiVulLb+GXjRSOVsKT99utaCSpK3D4geNxxShOTe5LcWtkT2ev2OLllduu5Q6ptrW2uDCdAiFDmq7bXLbTZLbygFGNlGpbNFijFcbU1+0Ley7q1Y8VxqAJ7tOwgGtBrKWlBSnM+BDrCn1pP/hraSleyF2CcUeZeQyzdPJJE7PK3rdYxi/YZKUX1ylJ3P5qtv1rTGU71+4S61jOCLCdiU3w+vMVJvZOxg2rira5w5wqTACb1uefKaXTkaqmJyXCLgby8/wCTa4xFy6dee+KS2nXCvDzG/SqEi9XfuFF3YWfhnlhA/gKv9lg2PO5OOCIskuuKf70hDqTwB1Biq6nKGabfW87lm90yN0I1kj6U8ylFKKFGUVyVu4dbscQtLJGH22hQLmtClJIVI2iYroma805gy9l7DVYLeu2hexC88SFD8xHh249RVHxGwukYhb/G4fdWzqFaUpcZUk7niCKtmacGusVwDClB9ltTdzdKCFqI1qBSFAfasnahuawSbNJGf8WuG0ovm7O9JRubi0bUqfUwDUxa5ntbjLeOJu8CsAlBtgpu1QpnvJUqCSCePbrVQOX79hyFrt1gDcpc/TepG1scQayzjSvhyStdukFBCiYKj9q4+pN7nUl07o492xXeEKZbXg7d1brWoBxDiwsffauVsXDoZeSHDBRuJ53q/wDaZqCAQkzqAgiufsoLiH1KTBQ3MR6iunT7ROXL+Ys/Z66r4y5BVpbShKlf60cV33BLnKYUBd43eHT8patB/NQrztk95SL10LEpLYkAR1FdXwhaQlARwBJ8VRmdO6DGm90ehOzXO+WcsZhsMbtl4s6uzeClaVoQVonxDruRNe9bTMOUrm0F7hmX8QfDlul5PxWJbaFpnfQgdI618uMKClJba7p0rUqAQkzNe4ewd7NeYeyu3XbMOrfs0rsULXq8egbE7bQDFeB4vjbhHJGKtP0PX8Nl7ThKT+Z6nzFmO0tcSt2WsBslf1C1VqdK1EJKJSkbgECodrNy1OlCcNwpCeZFoFb/APeJpub8Pxo4hbuM4a85GGWYCwBo1hoSJJFV1WFY+tDTvwQQCfHK0j9Aa8bNPMsjjBfT+D1dPjweTFyfb1JoZtx9FyF2l1a2iTyGbVpM/YVmbz7mRST8RjV2VTpVoXpHuAOlQ68s4/eMIuG0W7YUSSVOHgewoqyljhSCu6tUpVB1ErJH0gVjGeq9X+xooaZu6XyJP+lWLXjQU7i9yuVGZeVx962La7bcKVOqQqTyd6jrXK6WWUt3uNIUslR/KY2A9yvepdnAMKDehGM3jqgAd0pbH8FVq46ia9p/UpzxR2ivp/BNZKdaGb7ZCFJBU2+ISNj4apiFKCChyElKlQn61eMjWOG2eZbdQTcOXRLgQovAojTvtAqDassEUt0uNNghxZUgrXsZMwdX8q6MuKX4WEW97ZhjyVqZNLsv7kH8W2hlcKGs7JrFcXZDGvWNWniJqxnC8quNF1FqEbEBGrUP1prJsMPaPd4ZaqBEAqaSrb6ivP8Aw8pbuS+p2rI3xE5pn25beyZjyX3UaBhtxGtQEnujXzaefSRCXEgK6TtX1G7Qrt+2yjjV5ZvdyoYe+oBLadI8B5TEV87/APlBzO6pu4XiKnVgDlCYVA22iK9jwfTqM5e19P5ODxPI/KVqt/UoRcKEhIgnnZVAkFIUtZ38t66C/wBoGL3bCm7xnD1KiYVYsn/yVFN5qadBU7h9g4Jifgmkx9k19F5D9TwHl6lsinwtSpASB6nYVxftixUXWOM4c2qRZtyqOqlb16UuMw2PeAuYHhLgCZJVbDf3iK8l9oGNtZgzdieKW9o1asuvqDbTRJSlI2AEkmNq2xYul23Znly3DpOndk98bjAmGQdJaUpvUP7wM/wNdK71xalIb3IEbCuN9g+PYdZYndYXi2Epv23k942lT6mwg8E7fSvQyxlxS2x+wUpS4NRKbtUx6TNPLicndmGCfTaZWCt9KiNXG/rW1YXa21ylWjUZJBipw2uWHVqCMLu0oUR4vjBJH+pWw3hOUSrSxb4oOQr+tIPtHgoWKVbM2c0ytP4ziibpTTWK3IB4CXVJ0/UVutZlzMn8trMWJJCeEi6Ud/qa3rnLeXFH+rv4sgjY6ktLH0IINPRlzBE2irlnGrxDyTKWnLIGfXUHKXTlixKcH2ExmjOVupF0zmq+bWkQsLcJKj5zW+3nLPuKXItjmt0uXCggOvNBwJHmQRUfbYOxcoDacVWg8kuWzgB/1dVPXhDTOk2+P22qQR+W8kg/6lD67BuNF9zhfYng+GYCxcu2l4/cWup1w26CFkGCQFJOniqMvMqW7pSX8Hw90JTP51qk7+kRVszzZqusFywWL9k6LPSXFFYSuVcjwz94qmryviqla2bvDnAZEG6SP0VFVlvquKFja6dzeXmeyuWR3mVcEIiAE2pQr7hVa6cSwMgi4ylhxkA+Fbgn6aq0zl/Fk3JacTb94qNIFy3BH3pXWA4i22kqtkkn5ghxKjP0NZN5O6+hsnCuTeTieT9P9YyU2tR6t3bqQf1NFVxkF1tSHMrXyFHcBGISB901EJwbGLYjThV5Czsruzpplzh+MJCj+ybvUOVBlRkdaT44JbitrNjGj2fNYbcj9mY006tJ7sfFNrSnbqNA2rijuXbRxxbiMetNJ6FKwevpXSsaRdO2zqXbS4bASZKmzPpXJ7ptT3eNoe0bnxAzNaYva/MiZxuOzBcZbYRC/wBu4esbQCV+HzPFdawLKmTUNttt55ddC20KLq8KW2nVG4HjJI9a4i5ZPMpQhbxWTI43ium5buTcWiUl8K0IACVcGBTm4xWy+pljjKcqsvQyjgLbuu1zrYlR2KnLV1I/Says5KSp6Gc04Q7q2B1OJA+6ar6EnuUkLECdtVZrV4lQIUFJGyh61nGcXt0nS4NLknnsi4iAss4zhTwnkXgT/EVrN9n2ZHZFuqyePmm+bEfdQrGytuStSgJ5M/ypzd8llaU95wqQZAg1blBbNfUz39TKMgZwSg97heop/uvIP6g1dezTLeYLFjMNteYW8y5cWRS2lUErVPAiqkhwOuqTKkgJJKhVx7OrlTP9IGGVKVqwt06kmCNxBq8Ml1ETbr9UVpWW89W1xquMvX6EpMJ/IVHvQcwvHENhF3ZXWvVq/s1fwisX7Sxj44/D4m+loCAO+V/Ctl3MuP2qptsbu07f9of8axax87nU8sk+wlJuWWxDS0ng+E1F4zf9w0EOXSh0KULgz5VJ2ufc1sqP/Oy1p3nXuKdedoWZElOh1lwLlR1W7ZH6pqHCEu/0E8k+aKkjHUIhkhaFoEEg7ipZvFEraUG7gLcUAAD1rZRnrGXXim4tMOV1JVZNE/woOZqU+5qewPCFRxNmgH9KajDjq+jF1zW/SbaHypfeAhRCASQoTVZRmdpeervCkOIAYt2gR/dUdzNWB/PbFqzqcy7hsfvBDZSIHnBrgOSs+2//ACq4ljFzhTFy3fvrKGlKUlCBJiIM8etawxdT2kRmyuGO5RPQTr2owADI3EzFZH1t/DpOkFQgbHasDebMuXCyteWEnVudN2sH9ZrdRmbJhaCX8vXoTqA8N4P5pquh9pEdd00jTeuFNNggImKbgr2JPYvZJDiVOLuW0NAbSSoACZrcub/IbqSRh+MN7ztcNqj28IrNl2/yKvHcPKbvHG1oumu7GhpQnUOTIgT1qMkLi7Y+qPoRPb7c51yx2kXGHBhaHTasuabUB4AEdVIkfTmqpg2c+0lCNHw+KkqO0Wqz/wCWrp+KTEl2Xaip6zunAlyyZKtKiJJmqDhWaL5ZEXNwAmFAhRmubRYseTEnJHZ4hOeLMkn2RbGc2dp7hDYw/FDJCpFouf8Aw1cMDz32oWt62q4wnGLtpIhSHbVfHp4aqNnnLFEBCfiXyg+biif41ZG8zX7zCVO3TnHOo1c9Nhns19DkjqMqfJ6Gwa1zNjVhbXn9G8Tm5QF6fg3CZI44qcZypnCNH9FMXAPQWix/EVL9nmZnzlDCyp1H/RkEFSATx61brfMEuBThbdKTt+WNq+VzKEcjXZH0WGeWeKMqRz1/Kmczt/RXFkECATaL/Xak1krOy1I0ZVxT1ItFwPWum/0kfU4lIaCUgcpSkCaY/j9xElwb9AR/hSc8fZs2/wCRrZKznj2Rc4oY0O4FfEgyT3Jn7UxGV8yvOBpnAr5ZBBI7g810pONKQjvlr0gjaBWAY+8VLUYSg8FIiTT83GvUUXlap0S/4fsuYxgOZr+6xWyctkv4c60hK4kqJBgCaomJZIzFiQIGGvlRKiE7FR36Ca7F2O4u9dZsNu+Cts2DpiOsp3rm+K4zjNpev928E904sATuIURWr6Z4k7Zhp1OOTIlzsc1xHsnz6+rS3k/Eu7O2os7H15qUY7I83tpbW/gz1uRA1LbmD0jfmrE5nbGG0FKr1xJHiiTWvc5sxe6Qgu3qnEggkVCnja3v6G7WWT3oiMW7Iscv7FVml9TjxJJbLMAfWYpYN2c5rwcN2xwdK540uITv57ms9zmJ9JC13Lo1dQramHH3EjuPiXVeGQomYpuWNrpmmTLHktNtfIkLvs9zXctLbTl9anViAA80ef8AvVZ8uWT2HYPbWT6dDjDYacTIOlQ5G21c4vscuVtLX8Y9wZ3Pl0q/ZJdS5lyzdSTBaSSD1Ne7/p/oWSfQ325PH8Yvoj1Mn5VAJO58qWqInb24ppMHbjpSG5kiRX2C4PnVT2HK3MpP1pSdUpNCUg8gelIkjcUFcLpCTvHlSgKgmmCeSiDSnWYnf0oslRY5SgCfF9KHIkJgnqKJBCtxE770CVAwKRadbMSSYhQmlvqEbChOkeVFKxwkcU7F0oJidppajG4gdRS3iSSBPShq38U0X6jlGyT+oiiCBwoGsZO0jg0h6bGobZtdGUKn261jIgHpG1DnZJIJ8qS4SOfEOBSYWPkbRxFBKgTEmKbqgySJopMCOh4oqxONjtyOfpQEE6oO20RTRKT4dz5U7UoAJmOu9JtoSVBKgB4Z9qSSkqCp28pmmyRt1NHYAhR35qk7LCoqCiAeaCkkpiBvTdQABg04GQdQMSBNDpIVdx3ygkDg8Chq0mYIFIK5SKBB5JqU2C3HbEzS1bEU3bodhRgczQ36jClO+3nM1bLK3Nvg7L9ypIFw5oSmZlPmftVTSNJG+/WNoq92mGvXeD4asNpDLRKysqSkGOgk+teF45bwxS9T0/C2lJtv0Nu+tm7W2wu28HdqW88shAEGEgRNa7ruHPKaSplpLi1CSGxJEdNuakMcs9Vph4ViFqzq7xAClKPVMaYB4rXFpastsj4+3cVMCGlqP3javlMkJ3/6PWwyxyi733fqaobdadUsOkhUaSQPCPeKj8RunHbsWYuHypaSpag4QAAedjU0s2bD6xdXiilwjQlNqSRt5lVQ1+3hAudYxDEEuKSUEN2zYET6qNSpSju2vmjd9NL2X8iLu0BslpDy/FHiKyZ+9aqrm0sELdtg0gkeIoTJJrfUjANBbdvsX5AnS0J/Q0y4aytZsqV8LiTmnn81Anfz0Vak/X6kdvyv5EHd25fcYu3bfWgACVgfWtrNeIXGEZUyl8IHE/FO3MhB0gaSIJI96JxTL9426hi2xHQzOtPxqNuu35VZ83X2EjKOWXn7G8cb+DfuGEpvEJKBtIUrQdRO3QVs3ULs49U5dKVV/wCj4t9o1xcYj224zcuPl5b2MPhTh8Sv7Ujnr719dsGxN9PYfjgdv1uobYsW0grJJhKJiZjYmvlXls2d72qX1xfFs68UcKiqJMuzH6819cLO1wKz7Lb51nAXG7IOW3e25uzrcV4QkhRT4eeIr2NavL00a9CNB0rRuLXdG1l39mHD2FO5js2HXGtRaKFqVuOgAAP3qcs7bBU6nl47cOFJ3DNmlH6qX/KqvYjCVWCAq2baZIHgdVq07xE1J2KWge5s2nFsqX4dKSQSK+Z8yN2o/U9qcW+ZNL9PseZPx95/wDLWH5OwK3cxVT7l+5jCddwgBwMJCR4UiR4l+desMtYngeM5fwvFrXB0OM4naMXQL9w4vZbYV0jzr5o/5SHH8Qd7WcNsLi3fbZwzCGGW1LbUkEuurWYn0SK94fhjxr+kX4fsj4q0yXHBhaLdZIHzNkoj14r1ckXHRRnGKu/Q8/RuORZOtvaXr7vdXodUF3ZoKFJwbD2yn5VdxqP+0TW7+2sQbtyq1DSPBoTpZSInrsKYxg+IuEFVu2B5KMR9YrYucKf7sNIWgSNyncDevOeXN8PodL/DXXP1IdF7mC5SEvYxcqgEEBwgR7VnxRu9cw7CUruFHQq5Kt/mgoj+NbbOArt3Vf8AOqnAofKGQAPqSalDh1i7Y2dtdh7h6FBf+cmZ2rXFkn0S6mYZ3i9noXf09zK1aMJ0rDhEieBxWiLZTb4Wp7wpVJTqg6fOKt5wfDGWylEwpZUZJPTitVvDcJYdDrbDZ1nlSQYH2rGTXVbN45ttka2JPWLjYZU4IVsSTzXyj/yhjiGO2u/DElnubJKTG0hmT6E719ab27Q06hDCYJUNUKI0jzAr5Q/5RrH7pPbhiuE3N+6m2t1Wam2lKOkfkDeK6PD4r8SnE8zxGcuiNqtyY/ycSF3PbfhndtSGra5UowNvyzX1I+BvzcruLdvvEqTsZ/kBXzD/AMm5itg920YbbJfaLncXOkJiSA2T0r6qtrfU4Ql5SUn1rt8YpZI36G8ZyhGPTxX92QTFpiHf93CUKG51JUAf0rbvLLEO5S42pC1JmUgx+pNbdzLCtalTvE0S40pP5joE/SvISi+xo8mRpO/oYcPsi2sv3bwdIac7zuUxCSjfnrWmjKlogJCHHi2pIKFLc3B9QAOlS9i82p15KVA6LZZ2O/y1CXWKOr1NsBxRMBASgq/gK6MySxQpXz/YwgpyzSalWyNtGWsDaWg3OtwnqkqI/jSu8Ly2geG0bWtIIhXUfWsNuxjayFfBXiiBuFNKSPpNZrrDL55Yccs1NrjdRUkD+NZPFla2g/kaPpUvbyX+pEXGbco4dmRrJrVvaN4u7aG+QwG06ywlWkrO3mYr5Z/5VHtJv8Y7WDlRN2fgcEwq1YQwkABLj5Ljn3AT9q+jN5h2JK7c22lPWSFt5XcgOXCQSFXI8pMbV8fvx84wrGPxA5pujidpdhzEVMTbLKkpSwhLQG4Hka9HwzDleZSyJnm66ePoShzZ6P8A8kZna5YxjPGUzc/lP2FtfIaJ5UhwpJH0UK+mFnjF6wylaEpUpQk8Ajevjt/kuMbw+w/EIMLv715j9q4Td2yA0kEuEJC43/0DX11bvMsssghWK3BTuCXW0T9hWviulcs3V1JKu7PUwZITwxbjdrsiQvcw3XdvIdWhai2tUaTAGmvAXYZi/wAZ2q4JhynktqdxgSoDUCe9JivcGJY7lxvD3A3gC3tSFmXb1RIgEmdIG31rwr+HPMeA3/a7lqzZyow1cO42gC5bu3DpAdJ+U7EVn4djUMjaknt2MpTXnKotI+jQYw1N1cpdU+4oPrVAAgb+dB12yBDnwrm3Gtwnasbj7abl1SYWC8vxaY/eNMduAFBJIiOory3ll5rpLk3hibSbvj1N3GlWar62Dtgw6U2SClTgPhBJ22PpUYi2w9ZCv2ZaGCSJaB3+tbmYr5m1v2luqShHwLRk+pVVWfzbhyXGrW3L7q3N5Qwrp6iunXTl+IaXu7L0I0cF5Sf9/eTDreGLuEF3CbIKSIA7hPH1FRF++i3C2bG2tta16R/V0QmRMcVpYdmG4xm8dYTg162GlkBxbDg1jz4reVhdxcIW65b341uBWlNuobgQOm/NYxlk4Z0OOOO8qLFkW5e/ZWLuOlkFm3BhCAAPCrkcdKoNniq7sEpQy6oo47lEfoK6DlK0fawPG0N2NyytxgpbS40pKlnSqNiPWqBbYfjjLaFJwLEdm9J02y+fXw16OeU/Lxpehw4Vi/EZOOwnsScGom0QSUwSGU7fpUNfC2cCVvobSEgEjuW4n18NTb+GZgcbWlvAsSIIAT/VVjf7VWcUscxoZ0u5exMuyRpTZOnr/o1yrJk72dEo427VETdvNNPpQAhCY2DbKIg/Sqy9fpTjttb25aSVXbbaT8O1qEqA2OmQd6mrvDczPOAjL2KD0Nk6CP8AZqp2GX81PZss/iMv4m02u/a/PVZuBKAFiSSUxW2HJJ5EmKcYV2Jv8R99d2+fmcOTZ2l03b4e0oOXFo28sytYgqUDI249a8+Y3jDjvetKwnBgSTH/ADWzA/Su9/iUscad7RFnD7K9fZTYsJ7xtlSwVa1mCUiJ3G3rXBcWw+/QVrdwm9BB/et1iPfauxzabo5IRjKFkBbYu++pTRy5gaksJhM4ehOoT7VoX+K2zSkou8q4CrxFWkWv6bRWZDd42++0bG4hSZSCyqefaoG/Rei7UPh3NPEqSREU45K5JeNXaLX2fX+G3GcrRLeW8Ns3pUQtltQUkQTtJ9Ki834fl++zTiL11lu0cWu6cUp5LjiCrc7kBUTWTsuS/d5+sQoSolyR/d8JFRWaH3mM34ox8ehsNXbiVJI9a3zTflpihC50aV1lvL6VuKRg7jYKR8t0qf8AaBqn5pyng77CrhF3iCFACEjQtMfYVcnX23VNhTh2O58/Sqrmq7aRrDSwraNIVxXFjbTNZxqNMx4TkbJd0EtLzBiupMHw2zXhP3q5Yd2XZQCEqGZcaVvKUFlkav1rl2G3jiFDQ713K+pq+YbjYLbLPfaYPnXZ1UuEckY78nYuzrs7yXbZlw513MOKJb75IOhDQUJOwmCOfSvZPZ5kvLOD53wm6scUxC5uGnSUJdU3okpIJMJE7dK8OZBvF32ZMMtm3we8uUbTP7017W7Mr5L2e8GQ0RpLyp3/AMxVcE8kXqcdI9CONrTzbfZkhnXL+B3udMXxBy9v2nPiocSCgIKglPEpJj61CO5bymCtSsSxAqgmC63B2/0KxZ8cuVZ+xxsXboR8bqCekaU8VDpYD1wpSS4pUGDGw868nU5Y+dJ9K5Z16fG1ijv2RIpscjpWpDP7bLidgVutaFe3h3q65CbwNvF7ZywTd96U8vOJUBsRxpma52DLqEEKbU2SdquvZ+7cO4+wwlpSirbZO/Bp6bMp5YpRV2Vmg1il1N8Ms1pi158EyoypKk76YAn2Fa7uKvd7oDjqQsQrSoisNll/Nb1khn9jXiCz4SVJ0z9Sa0brLOdUXjMW1u00rZXxN203G/I3k1SjqG+HXwYQnp0ultX+heHLp1rJVy6HCVOXSUBRJJgiqSQlhtPeKlKQNirk1fHcGUclmxXe2aCLhCu8U8C3IgEFQneaqFxk9brwKsewpCo/7RxUf7MV16zFmfQ0n+VHPpM+KLye9vsart4lUBKRHkkx9awi/e+IQoq4ned+K2nctpbcAczdhg0ncBh0n9BSRg+GNvILubbQx5WTh/nXGtNle7X1X3OxajH2v5P7EfYPxiTMKKyt9Ez5lQkmp3tmv0WuabRoJJWu0AG3HjNa+H5fy+cRZd/pcVlLyFBtFioT4htJVUt2rYVgV9mBl/EcfcsnkWqUlItC6NOowZ1Df0r0oYskdJOL9V3X3PPzZoy1cJb8Ps/scufvO5uC82iNQBV5kVW7rE12uIOAKgPKBUTyfTerriWXMt3Lf5faDc26Ijw4VP8A+0qm4nkLIdzepN12o4itxEEpGESD5f8AWVwLDk/xr7nUssLvf5P7GljWJa0q8eyiIQFCPtVQv7zQrRp8XWTVyv8AKGQLtQSrtIv0OJJE/sSOP/ytQd7kLs/dd7xXapfFSTP/AN5CZP0crSOPIuf3X3JeSFbX8n9i3dlrBvOzTPzryjLVm4U+5ZXsfTbpXmLGCp+zt+8CT3aQNJ3HFet8gYPgmF9nWarOwzOq8YuWHPibhVmposJ7pYnSVHVsSeelebsQybk9hkMHtWsQSkaS5hT4UesmCa9mpOCPLtRnI5EcMsytx123bMqI1FPStHE0Wja9TKQgKUJ08GuiXeSMvKCWWO03B1Abkqs7lM+f7pqsY92e2uxt+0XLzkGTHfoj3lFXijk6lRnl6WrRz95La7tTSkBTZUSAfOrLdYctrsvd0iELvioBJIKVQQDWBzJK2XJGa8BeOokEXRA+5SPtU5e4TiN12aDDbO7sHXFXqj3gu0pbMA+HWYEzXs4U2nfocORpKmceau7lq3QG719K08LCzNY3LvEltEKv3Fhe5CzqH61Kjs6zu0lxXwDT45AZumnDH/dVvWvdYBmSxa13mCXjegiVFkwJ4EiRUY7XJDpLYrufA7a4wq4CkEuIQNh4pCBVWXeqS2HFqIJEneKtnaK7bW2OuW11bqdCIgqJRB0p3MCq643l5baUu4a4o9Si7UN58iK0lJytMhGtaYkFrAJ0lXyzsfSpVd26lRKXVQkSY6mtBeHZdQe+IvwUkBIRcIMTwTKKkBZYS8YNziKQlMEy2f5CiNLgR0i1uWn+xxbneLSpWIgDSdwQBVARieI27pXb4i/JACtDpG/0NXloYa12XLtQ++2wL3V3i2wVFUCQAP41UmMKs2Va28VZUhY1BJYVI+xNXkbbVMcIxXJtt5yzZaO2otsdukskpLiFPlQO+4gzV4zzfq/YmX3bkNtq+KvWVBCQBKSnc+vrXO3LIXV5btJLISFAKOspiCN9xXQM34zhdrgGFC6wpjEUqxC8AStxYKVSkmNJHII5rLI24M0x7SIlq/1IBUvc7+lbvxKH8vYolbalQtkAxtvqqPGKZPdaBfy7c2pP/Y3hMfRQNbiXcsOZaxH4e+xG3b71nUp1CXIVKoCdJBIPXyrh6XZ09RwntRu27Z5LnchwBZlJPWqdhuZEJW7cLwm1cQ0jUUKHzbgfzqy9q1u21Cmb9u5CldAUqHuDXP7JKyxeKQogIZk7/wCcmurFBVuc2WTci4sZrtcZWLNnAbSzWkhfeNjxEBQ24rqGXrpy3ZadBDaiBvA4rhuVlJOKJacIGuEyTA+YV3jDWcOQWy/jNk0GjKUh4H+VOUb4JUqRccKxu6Wtsi7fBJOyVkEecV7L/CJjLbuQsasXStbrF6lwlZ4Cm+nvFeKQnCFth9rMNk2qYMFRKfsK9Z/hAdwdjDcyqezaksHuAQiycXsAqY43rzvEVJYJJHVoWlmVnrnMuLuM4wltt3SBh9oodQNTf+6oNnGcQUv8tWttJIkeVSmbU5aGMp+LxHEitWH2h021siAgN+EytXJB8qgUXWTraFpGYnusF1hv+CTXy+RTlkbuv1PfwzqCpPg37rHVoQ0nUlIUdJ1Dn2rDcYm6fB38oSkR0il+0spXLaEKytd3KU+JPfYkQQf+4gVjGacAS4UtZNsUjiXrp1cR0PiFKMXPdyRam62i/p9xrOJqetEIW4CZVp1jYVl/aLdsQ4+73ZIgFS/Ca1LzNbTa0pYylgCWyZK27XvCB/3iaz22bsWLi02iMNZSOENWLKen+jVeXF8y+jBTne0fqWPs2vE3eaMN7u671Ke+1ALnbSd6rot8YXdXbLOHXlwoOOd2U26yYnjaatXZznXG8Uzdh+HOYoF2r6HSpsNpSkkJkcCtFWZ8dccuA7j19qS8tIAeIAAMcCuqcMT00bltb7fyc8MmR55vpXC7/wAERh+B5wVZhLmXMT1idhbL+nSpFjL2bywRcYHcsgD53lIbH2Ua1mnLt+4VcuYtcuKJOynlED9a03FrLhLilL33J3rkccVbN/T+TovJd2vr9zDnTAsVTlHFbbErjDLZLti+3rfxFkDdBE/NXzmdyDi7Y7uzu8IuOiC1ft7gcEb17t7TAHclY0FeJKrB4COCdBr5xs3CbdlKkpIWnaZ3nrXr+FQx3Lps5dfLI8Uep9/T+SxryPnFClLTYsOTwW7ppWr7KrCns1z6talIyxeOBRBhEGfsTUXb4l3YUkt78zNJGNXKiol9ST+5Dh6V9DGMUt7PClkcOCPz5lvOWV8q4nj19lrEmGbZhSVPKYUG0E7bq45NeUFqKiVK3JMk13HtxzNfowRjC0YncFu+clbXeHSUp8x7muGSTyaqKSWxlNpvYsORMSOGZktHRMOksq9lbD9a9L291eqtWC806ghEmWyJ26V5Ns7l+zuWru2cU26ysLQpPIUNx/CvXOQe1PNOJ4CwBmG6IS2k6VOzG2/NNpPkmMnGWxidxBKUpBJSRwCqJNbFpiDgkodTBG/i4q0q7Rs1hHcuY2VpHOtptf6FNPOfcacUPiFWD8jlViyR/wCGltHazbqvsVb9qFsqSlydvPekrE3FAKQQoJ5JM1YF5rLz63V4PgrsjxFVi3/ICtd7Ndk4EpVlHA0kEghFuUT5EwqhxTV2TcV2NayxB5durU6kSdtgaeLyQdb+sDlJG8Vv2ePYZ3RL2ScGcSf3O8eT9tKpp5xbLJJUrIloiR4g3evJInykmhfEXWiy5jaXZ4Nll9xaNNxY6m9G0Capq79a1LLg36+oroebbvBE5dyw9dYPcqY+DKWUt3WnugCNp0nV1qj/ABeQVrPeWeNtr66bhtSY+qZraUN6sUK6UyOQtp5S3FJ69RT3bthDZQhAHG8VthnIzqAti+xplB5C0NqP6EU9rDcjKSQvHsWQFcf1RJ3/ANasnF+v1C1dkecQeSjT3hIPrxW6Mw3aQ1btPupQlMEJURPv51kcwXKi4Rb5zeaJBhLuHEk/ZW1BWXMCCErZzzakkbpXaOpP33FT0yvYpuN7kfe5nxG3tXlWeJPtGFTCyZ28jXEXMXTblxSrKzdKVFR1NmVST5Gu332V7C4sLlNvnPCEqKFABTbsnbpCTXjO8fuG7l5tVytelxSZ1HeCaqNp7ik/Z2L/AI5me1QnSvCLVBVuShJ3HTk12XKmdlYvZsA4ThTSE26EHu7FtJAjmYryn3i1cqUd+pr1RkTJWOfsSwVb3eDP62ULhvEmSoSNgoFQg+lEk5bJEKSc11Mt1veYclJP7OszIgBTCY/hSWbK4QUJw2xbWDJKWomfY8UHcj5uRoSzh7LqCTui8ZWSPOEqNZmMl5sZ2VgtzvwpMKn7GpUWuxr1RXDNFTVkBpXh7IEwSlShP61gVh1kt5K02xEEKKQ6RI9zNSLmWs1tlzvcuYkPX4ZRH8KxnD8da0qXgN8IPJt1gn04pU/QL6t4s2rRu1dAW1bPBA2KS7J/UVduzteEtKx0Kt7hrvcNcQVFaVx12hIiueoF7ZrLTtlcMaxsVtKH8auGQm13LmINNoTBsHSoHaRt51UFcqSJyUqtkEm0whD6xbO3sp28QR/jvWO6wi1LKnf2rcJcTuGzZhWo+4XApvxzKV6UJakgAiRO3tWO6vHSUhpY0T8vE+/pWcoU+DV2pWabVvhylloYmS6gwpJtyI/2qVzl1tULaxZB08JcbWkn0HNZTasG8ViQXztp6g0l3613KwOEkcipUF3Q+ty4ZqMZXvHllxGI2aTsNLilpI/2accs39vcFtLtm6pABUUPTE/SnYhdXDzChbEhUp3gHaa27J4tuIQ64ApQ8QH86PLhYo5Jp0VrOFnd4XlnFcQi3IYt3Co98mQYjbffmvL2Xn3GsctHGwoqU6EiDuZNd/7fMZNplRy0bXoN88hsJB5SNzXm5K1JcC0mCDIjzq8UVFbE6huSUWepcOwHMzdul64wa7bUoCJQdx51KtYDmJaU91hVy64ZEBomR9BVQyBmRzFMFt0P3S1wgRrVMnrV6avNCgLdRSqI1JMGmsdmWLLLpVkU9huZWVEP4VeJQDB1MKEVrW1zdYTesPu265ZeS5pWgpBgzE1Yl4xdCdV28noQHDvUdd4xiK23GviHVTsn8wwR6zUShF9zdytU0aPbB2hYbn7M7WKX+Eowl1Fs2ypFlqW2oD96XFEgnyG1QmGO5Y8ClXeI6zsClpER96gM02GKWuJpTcsa1KbBlpQWk+W6ZoYa1fmP6hcbiJDSqcUscaSFlbyNOTOpYe/kFLbZub7HjGx0ttDerPZPdnbjelN9mFSR0CGZrkVszdCEC0fn/wDFqBH6VabDC8c0Nn9kXviEj+rOb+R4qMkkuxPTtVnvbs6tuz97JeDXLTuZ1JNqgwRbxxVst7js3ZJBXmgLHTXbx/4a5J2Y2GYUZMwdhWGYilSLVCQn4RySAOnhq2owbMKFlasLxATuCbZyP4V8jqcr8yXsfufTaHFGWBXN/MuTeIdnTRhbWZhv/wBtbD/y1lOL9mmqU22Y1eeq4YH/AJKpqsBx10FZwjEHAk8ptlmP02pisAzDuGsCxNZgglNo4T/CuVZJLiF/P7nSsUO838y8Ivuzd0EG1zIschPxbMf+CsQxDs9kpRh2ZEpHH9fa2/8Ah1W2sv5nbbB/o9ihMRBt1g/URTmsv5nYMjLt+rvNyO4VtT653+T6MHix1tP6nY+xs5SVmsqwi0xJL4tVkqurlCwEymfCEAyfOaqGO4tkO3xm7Q/gmJrV37kkXyACoKMwO7NTfYbhOOWOd23cUwu4s2XbV1sF5JTuYIAn2qj5nwHHbjMF9pwe5MXDkQ3sRqO9d7m/ITUfoceKEHmye1tt3Mr992X3ThU/gGNkr2URiDcf/KpLd7LmmyhjLmNK/wBK/b//ADdV9eV8yaCkYFd+X9lWwnJ+ae7CjgV5HmGDtXK5zS/J9Gb9GJv87+ZJKvuzF5opdytiepJjSnE0g/ctVhDfZY4dX9HcZB9MVT/+arTayRmh8FTOA3qwfJo7fwrE9lXH2XksuYTchfynwxv96jzMj4h9BvHh4U/r/JIPnsvFvpOUsVWIMFWL9P8A3dTGCKwtdi0rB7Vy3tSkaELc1qA8iogT9qra8n5mUydGBXaiONh4v19asWB2F7hdi1Z4lbuW9w0IW04IKfcV9D4A350rjW3pR5XivSsS6Xe/rZIEqG+n6dKMAck/SguCdiQfKKSVK+Ugz5Cvs1uj55R7hAnY0OEkHegFgEgTPlS3iQkgnqaFZM0qsIOrzM9RQEb7AEUtXh1REGDQO5iBMczQwSvcclU7mT70CTuB14oDYgc0SN/DSGDWICTyetOACQY2msfiHNPCiQKrgaoRJ0nfcUek9elMAJUQOu1FQAGxn+VDVsUmSZAUJB386aSQjbk0FKUQJgeVEE6ai72NqoRMcUQkgcqJnpQB0jYyTvRDgkpJIp0u4BIIPhEj0oBSTuZoDbwAx57xS1ACIPlPSk5VwA4yDyT1BPShJMkilq30kwYodT0joKV2A4yACfqTSKjG0RTVEkSkyKXPHlSumKxyt4iB5UVHSQB9aYkzsfLekVKmTTdPcY4EjxT70dU800mdyNUilpSPEBFSxNjiSE+52NFJPNNClCAIid5pbA/NSFRkSVKIINXyxK0YdaoBAIZBE9B1qgogqA4HkK6PhFmhGHWr76u8UprbwxpHlXz3j9+VFX3Pa8Hl0yk6MOZHu6ZwZKzsWX1b+epNajdyi1tw662t3WfCEpJ6elWm/Qh2xs1atKUaiACRO/8AuqLLwbJcCHCT11EzXyOdxeTd9kezppScWorlv9yJwy5u7xJW5ZvqKVEbsq/wrUvGLwXRcVYXAgGFFuB+tTIv+7J0ygJUYAJqKxDEgp5SnPzQBGgjY/SsnKF02dMlkfNIhnmL8J/rNqQQr5iUj+JrUurfFrplaWAlbcFQhxMT96kf2pbquRFq0FoUFA6AIitPFroPXST8WhlBMqTsEifatri13Mvbir2K9bWOKtrKXbNLSXTukvtiB5bGpfPWDXb+VsBTZMIWhnDHUkd8gaeoiVCRzxWijG7Vpx1hzQt0bgkDcUe1dbreWsLGlKyzl91aYjaRNdEel4m2cWsculP4/sfJvItrbu9oFyly3bLn7SUEhekie89fWK+uKcMxhPZRfYdcto75x23UW1uIhQQkH5pMccV8j+yu0sns7B+5t0rW5dpIUsTyqvrU3iSmOzRV9bEB44iyhATEk6Yjyr3/ABDbTw+Bx6RP8J+pVezztCwF1WH4Zc4sLTEbwJ0W48RLilEpbWI5gdYrsoxq4Uwr4ppp1YURAkj7HivKFnm3Gsm4FdWtrY3WJXuIYsxfYgLVZLyWW9coK1oCSQN9jGwE11Hsmz5lvGMm4pnC+x/GXMPdvHnbYO2aGXAykAwQVkDcK8+K8fLhn0dcGvmellnBqTe9e4+Yf44M6XWZvxBZoQq5UpqyxL4JhsuFSUIZQEgAcck19Ff8njmhd/8Ahpw1hVxvh2JXVuoD10rH8TXyS7Y8z2GaO0nGsew5T62b7ELm6QX41kLdUQdvSK+k3+S4x6yxLswzRlq5s0Orsb9m63dUE6XEEcA77or2cuG9B0y7Hl+Ey2mmr7/X+T3G/iKlstHvfnkisFxiJabJU8lIHG43rZWvDwwx/UrY7GElBVH3JoP4gWUH4VNu2EJ8QSwjn7V848S7y+n/AKPXjN8KH1Ne1xRpyAXNS+QBuf0rdvlYihjDi1h107Lb2rQ0oxKkwD5cVgtccv3UkKulgED5Dp6+lamPvPPuWLj907uw4QS4Tv3kb+ddGOGOMZbv5L7nPnc3OGyW/wAez+BtqtcbWe8VaFrc/wBoUpB+5FY22bwaWHVWLSwZSj4pJMfSaLbzVtZtqdckHiOtRxvWU4k2heqVHYRWKjjfs0/n/H9zVLI+Gvl/Jv39q8y4XH8Rsm5EgpStZ+0CfvXyL/ylFsw7234g6rGfjH13FqlbYtS0ED4dMblRnpX1xv7m3aCnrqAD8u87jiK+O3+ULvWsR7f8bTbKKZu7bf8A/h0Ca7PDen8QqVUeR4lGXTG3e50D/Jf4TYK7fGXnWl62La7ShSFRHgHpxX1zDVqHNmnVDbdT5j7AV8of8lhhxR2zv3rj63Axh10COY+XevqurErJt3T3iBq4ClAce5rs8Xl/yxpdu6OhRbhBeiNhTFqoBJtWyU7yvUr+dBbTC1g/CWxI82Qf4zWndYxaoBX3uoJAJCd4H0rC5jpUErtrC6dBBIKW4H6xXkLJPtt+iQRxOX/sm2nRb21ypsIRoYWR3aQIMegqEexW6SO8VfPgbT4zAqQYW/d4W+46kMBy2WCkjUUEjqB/jULaWTjTa23rgqVsNQZ2Me6q6NTlyrFCpVz3J08cayS6l6GY3veJ8T7i9RjxEn+NMuW2lrbW1EgEKgTTHLW1bcHeOPr8WwUpKY/Q05abdlhd2XHC00YKSsSfsK8+UcjVyf1O+4RpxT+R5Q/FH2mXPY5289nefD3zlklDlpfNtn+2YVuUH1kfpXyH7YcTusWz5i1/euLU/cXb77gXyFOOqXH2Ir6if5Sl+2t8Py682dLqbxtaU6iSDCiT/wAeVfMrtpYRdZoOYG1pSjFEB1QHRYACv5V63gWZt9Mo+qv4HDr9Co4nlWS2qfT6J2Wv8F2aW8o/iQyPij6ilpeKtWzhmBodls/+KvtPusOlhRc0q0kIBUf0r4KdmuNXGVs5YRmKzuEpfw28auWyRMKQoKH8K/QdY55ub7B7PErS8U58Yy1cpSjYEOIC+nvXV4zhjJxk2beGyk9Oq7N/5wVe+wTGnrR9y1w++UoMuBOm3XudJ9K8R/hZytmGw7X8q3uL4BiTVsnFEKKzbKSkQowZIjmve2Ys7rZwt5aX3Uhu2eUvSsiDoNeGfww4s5edpGTEd+8suXyFErcJmSefP2ri8Mgozbi9ypuTy012Z9Irm8tEXLjaMKYBLi9KnCVSepiYofGvNgrZs7NtQROoMCtVSnHbt1zuzIdUBAn940Xk3jjZbbtnSSmB4TXE8+Z5Gltv2S+xUMOPpV+nd/cxZyzNjeH4w1a2TpS38G05IA3USQTxUU3jeaH9evHbgx1QrTG3HFTuYsLvrnFW3EWq1INmynVA0yJkb8GoxdliLAKEWh8RlQKkD+ddesy6hZ5KDdfqRovwywpySv8ASzWuMazG0AhvE7qZMqW8dwPKoTGcdzUHlKtcfukCJKe8V5ehrNi9rjSbgsIYKQSVakutwJ4G6qwN4BdfDrViLjbDyxAT8Qg7e81hGepq25fU6v8AgfCXyRZMi4tilzljMd3f4g+8tpmUErJKDoVMEmuf/HXvcpQMdxRDndhR/ri5BP1966JkvBk4VlDMVul23Ut5pZIDqSEgoVAJGwrmruW7tDpV8SxDzSAFC4SuAD6cc136iWTog1fBw4fL87J/nY17zFMZbSpaMwYoUgDVN44ZHkINQWI5szCELSMexJEaSmbtyQP9apa/wXFgjU1e2WlfyS8kceflVYx3AcUaaU4/d2ZmOLkH7GuOMs93udF4rt0amM5vzW09bqbzTiDaFGFJTdub/rUXgeb85XWc8GtbjN+KO2jl+yhbL144pKwVjwkavKaxX2DYnf2ZQLqxBQrUmLtHy1GZSy5ejOOBYncYhYptrbEGXnCbpM6Uq3gck+ldOneRzXVYNY2nwWT8SGfM2YF2kXOH4DmXELC1XaMOhFvcKQnWSoaiAedufSuD4z2sdprbTiTnnGFoWTqAulE+tdr/ABGZcvMZ7QnMUsriy7p2xtglLt220uBqPyrI89q4diuTsYfbeS3+zhCpX/zixMdf360k8jk1Gzkh5SXtUKy7V+0ttlfw2eMXAQBoAuCAPoahMf7YO1NKEfF5uxFYdcJPekEn13FZbLKOMJ7xajZpAPhnELff1+etbFuz3Ml078YW7a5aCgUf123MJ67a606ssXSv6lpYvcye7Ls9Z1x7N1raY7jaru3VqS4hSU+PYwNkzUPmzO2OtY5fWKL1lTbF26gIXbtq0gHYTpmpLsoytmHCc5299d4YthgKWnWXW1J4/wA1RqnZnw3G3c04i61g9wtty8dMoRIIKjBmtskpdCb5Mag5sj8f7SMQsbZSjY4Y8pMaUOWSCD9gN6ql1nPC79JViOUcL71Y0hTaVNz9jtW5mTCL1pWq6we7/L2gsq/wqnZmct2u5YbbUyT4iF7RWWPJLrpjnFRVovGHYvk0oBd7P7B5R/eXcviPXZQq22ON5MS0lbPZvh6zAAK7i4HX0XXKMPf1MIStYKtM+HmKs+FXIS+lsvFR/wCzjkV0zyUqpGSjG1udx7NMx5ZVmbDNPZ1hYPfpgC4uNv8A4leyuyy9w27zdh6GsqYfZL1rKHmXHSpI0HjUoj9K8I9lmJqTmzCkFgKIuAtQAnavavYneuPZ7wxgKUuNZUdJhI0Kg+m5rz5zctRCLit/cdiivw838e5LZyzDhLOcMXs3MqYY863clCnHO8KlmBuYUB9qj7fHcKQVacr4SNQiA05J+66089PWVtnvHHLl1QWq9WNOgk8Co0XLTzRctErImNRQRvXkZ8sseSUYpc+iOrT4YTxRbvhd2TrGKYfcoUGcr4G1Gx12yyCfKddWrIWL3bWYg03hmH2QeRBcs2S2pUAnSSVHbiue2qLsNjSy6uTx3av8Kv8AkhtacYs3XGlpClRuggcHzqtJqMk8sdkt/RIvPhxeVL4Pv7vibbV8u9tUreuXLgubqJWT4vrWo65+e2t1SQtMlCY4Ap9jlzFyhTSLdhAUsrCnX4Bn0CeK2rfKeKOSq8xW1SoKGnQhSuOhJjb2ol1ylu/myo5cUIpIsbgLeQyphI1m6Q6AeqjvVMViVybwNalDUowI5866C6xbW+VDav3OgfEoQFoRMKgdJqvLwvCy9Kru5cKT4VwlO/2NdOvxTk8dNflXcx0eZJ5Nm/afYrN7qLpUQYiTPlWp3i0KIUghsg6Sas91hbLrsMofMnxEuIH/AJDWg/h1k4tKXDdlelQA71Aj7Irh8iadWvmdTztr8rIaycH7Ws3NagUutkgDpqFTvbfpXme1ZWFFKrIKAHEhZrAzhdpaXjKkP3EqKTu6mSZHkmpjtkbw1zF7MXjH5vw0JcLqhtqO0AfrXrYsTWjnF1yjzs8r1UHT4ZyS+YZbIcbQZUiFQYAquusMKvFPkL1BIEkzHtV1vMKbeZJDalSARF0QI+1Rf7Bt0toXc20Ag7C4WZPrXnrTvtJHXHKo7NMpOJLZCyUx4TupKdjVavLlHiSlKpBj5eRXScTwRpSAhFlaHXPzOuCPqDVYdwOztAGkYShbyjJWb1Yjf/Rrphh6Vdr/AD9CJZK7MuHZxquuy3OqWhphlZ8Sd/7FXFeT8UYu7lxTwb2677pNevch3KbfJWZmDYEWotnVPBNyXFKUGzwdIjb0Nec8TXhLCln+jN8WSlJQRiqZ/wDk16k8UpxjTODrXmS2OUvLuUNlKiqEqUEkjkTxVcxy6cS2lCCtEnYeVdKvncHZIL+VMWSlXylGKtLjfy7gVXsVTlN1wJfwvHW1Anbv2N/qWxXRhxNGGTLHg56XXzKlvklR5Ig+1XtUWvZRDZCVIvSvY7gkf76jLjDcplWsJxpsHZJ7thf02Wmph79mp7PlhLt2GUXYTqcYBJMHaAqK9TBFtP4HnZWrVnJbi/fcINuFkxBVxSs8bxK2UGGL19BKtxrP35qUfTgmhYF2tSgAQDbqB/iagbtFuQlbN22VpXvynUJ43FPGpJ7mc6vYje2bErq6v02Lrqlot3yEkJGr5R15rnibooAT3xIPTyrpGe8cewfGri4tgwtLzn7zaXARA6HioO2z9iL40mzwxbYB3Ni1P3itJJN7slJpFYt7x9ToQPENiB6VYLa6cQ3K24iSNuakXM83eoqcy9gjraOqrBBP6VtDNNuArVlrBVIcTwLQpjz4VUqk66g39Czt67nsvDohSV3ZBTPWKrrbjbASlLBBAHhG8bVfbTG8KZ7LncRfy7ZuMIvCkWo1pbGw8WxmfrVBRnbKVyvu38oqMgH8m9WkJ9pBrTIraSCL7m/ZOuLOrTKV+XJM1P59adXhGF9y2tRbu7nXpTMTp5qv4fi2SLm5bT+zsft5cEaLppwDfblA2qzZ8esDhNilgqXqubhRUtOlUyNornyr/jZrivqsqLguG7cKctbhAHUtkBXlWRtbgy5fgLCYdaO4OxM/xrEbh1fiLqxIiNRgeoHSs6XE3eXMSQ+84T3jW/PE+dcybSN26OJ5/UVFSyEyTBgdRVRsllLVz4QZZj28Qq3Z/Z7oBtBmVH7TtVNtxDb4P/Z9PcV04PynLkW5I4Es968oAEpSkiEj+8Ku9pdHSkx4ineelUrLiB31wXAdJaiQeuoV0DC2rRDLba2EKXBP5i1Gf1FKa3sS5JfCrswEkypUEivZP4QL4Jynmcj5krb0z/oKryLYPWjCdJsLSRJ1lEk/c16+/CNnbL2Vcg5pxjMZw+3tre5aUFqYQVKUUKhAB5PFef4jC9O0zt0brMmepO0rMNpguZmU3t2y2heX8OWda4CPyzM1wvMX4nsAwIP2mF25xN9saUdyklEgdVVz/wDEB+JbG+0DMzabS4OHYWzaMIYZbACykJiVKHn5cCuRKzGnEFhu8uXXEpO2p5QgGuDB4VHJJ5Mz57HoZNf5WNQhylydKuvxHdquYrk2uFMXVgFK0gWtosQP9KDNQuJ5k7Ur0qF/ieItOE8ruNH8SKqysVw5gpY0aiBJJWTJrbaxK07kOhCdQ42H6mvVxaPFDaMaPLyavNJ7sl2cydpKW2AxjtwlaVEuK+PSIH+tVvwDtO7RsLWUKzEH9YKQ24sOAg9SQD/GqLb453UpU22JE71st5j1PJQCNIE7HmryafHLaSHHPle8ZbnrD8P3bRd2ubsJRm1i3DSS4O9tllS5KFR4SBt9a6JlO5ZzW8/cYNjtotsvLKkhJLkajEpMfpXkHsyxk32dsKYLit1qAHQeE1oWnaBjGX8aVfYRiDjDjLy0DQrTPiOxrny+G4MmJJKqv4G2DW5Mc3KW90e90ZPuk6nf26pC54+FAB+veU66yxatISp7GHyVCTGlP8lVyDsz7fGc126MNxp9DOJJECPldA8vWrq/mBTuvv1FISqAJr5jURell0OJ7uHJHOlKLZvZlwLKwwHEBdO3r7K7N3UBdJCgdJ2Hgj1r5y3CezlVx3beDYo2jUoKnEUkyDE/2de+Mz3qLjLd6w28AXbdY3WJB0mvmhfuuIuXglerQsiSY/e3r0fBs6lOWy4MPEI9OBNPuXxVv2btNAIscfSoDYjEGVf/ALIVFXWH5DeMs32NWwXtJbZdj9U1ArvEuAAQoJAGxqOvr0W1uVORoTJInaBX0KcWfPO29zj/AG2vYanNpw7CcWev7W0aCUreZ7pSVHcjSCR5da53Ujj+JHFcZvcRJP8AWHlLHsTt+kVHVvsuDJu2Ib7edehuw6wTiuWe9VjOGsONOKa7p94pcI52ABrzyNjV+7JMWVZ4y5bFYSlYDm58juPtQ6rcR6SbyvfOGBiWHqCTBKnVCfXin3GWMWt9DbVxhqx+8sXaRHvNRtlijigHEuEqnielZDi1yLpaisDV8yYqfYNYN0SNrl/EFqUGnbFwc7Xbcn9axP5YxxwBRt2CVKkEXLZiPrRw/EA/cKK2xxB2qQQ+33BQlpJBJHy8mock+BS9p0RVvgOZEtr0YRcuLBj8qFA/Y1kRhuZJKLnAb0LIkpSySQPPapizvLVtgIXaMpITAKU9KCLmxUpTjdqnWnmOp9acWrDyyxZybxF/KGVGlWdypxm1UlxCGlEpJI5jjpXObtF0yo9/ZOpUk8KbUNvXauo47fLby/gIauHWkLtyF92spmD771WLm7UHlf8AOV3Kjt+eowPvW+VpNMUY+yimNvOobKFK0EGY4p9tfO92tLgTGrbzNW4YhdIW26nE74r5UfiCR9jQTjt2y+ou3pdUdxrQhQ/VNYtJ9yopoqTrres6VxqEkeVR+I3jzS2lNLhAO4Iq/vY2FOpXcs2yiRsV2zUf+GohWL2ouv6xYWDw3I1WrZT/AAqLfCHve5VLq9fTZPrbk6UqIPXg15ZuSS84SeVmfvXsa9xqxStwKwfDnknlBZCRB543rzhc5UwN2+uQVXbX5iiAlSdI3OwkVcbXIpbxRRADXc+z+80YHbtd6ogJSZCt/rXNrjL2C25UjXfhXQqSiBXbsisZTdwli3tsFfQ4lsa3FXSiFkDcwAIpytrYyqpbm1Y3ymSVIdcAWdt4+vvU5aX7zpGi6dTO4BWRP2rZtMIy6dTyrW71DaBdAR90GtxGGYMlJUzb3UKG39bTP/y/51HtLubqMKujE1mHE7RWtOK3II2hLyhp/WpNrOWPNRpx29kjaHlQf1qFctMHUSXGsQBiNnW1R+gpJw6y8Kk31+3tsnuEHbznWJqrmu4NRXBZWO0LMqQrTj1+DEwXCePerT2cZpx3F7m9avb9boRYurQFgEagNj+tcwtsLZBdS1iL4KzELtQJHn4Vn7TXR+yvC7XDb27W9igdDli6jQWC3p8PMyRW2FzcrbMpdLRFf03xtN4ppb1qo7ply1bV+mmsVxmm9UoFzD8Mdj5tVmjf9K0rnL7qbp25axG0WlxUJlLsj/ZrTvMNvEqBcumEjbgObR/3aiUpblSjFOkSxzA2hsl7A8IWIABNsPP0NMGacPccUw5ljCXDHzBCkn9FVDDB8UcISF26kkD/AKyOeOaRynj7TxUgWilGAAi6b2/WoWVpgkq3ZLsY9gratLmVLIH+8l1wSfvWYYll5y7/AP6cZSvTKT8U5P0BNVh3LmZChSXGEbK1DS8gmZ96QwrMibgpaw551yNkoAUf402+40r4ONfiSx6wvcfsMJw6xVaotGC44kvFyVLO3PGwrjQ+bnmrF2g4hdYjm/FLi81B1L5aIUII07R+lVwGDNUTN3I7j2DXWULm2fw/MF7ibF02v8o2zaFIg+eo121nBshLG2YcUZE9bRKv/NXkjIGIGyzA1CykO+Hbz6V6Ptnn3rdKlJUOCTp6U3NLlGeONNpFpfy1kx14LazteICf3V4Wfvs5WjfZbwEMOaM4sqTpMD4NaSf1NQSrtxDkIRIjqTTRdlTK3XBJKdhqis2480a9LKTcXiReOK75UyTOrn9a3rDHQgBJcKoO4UowP1rTvjglxianFNvWadISpKD3gJ85NSlnZ5OkF3EsSRqHCWUffdVEboUvzUSGH4vbrAUrQpXMmT/OrPZ5uu2WQhi5KQePGf8AGoOzw7s/Tucaxgxv/wBFbO3+tU41ZdngZ1pxfGieAPhmgPr4qzl13sy401uj192a5rubjI+GLuENrV8Mn50gn71bTmq7LEagElMFMCvOnZt2v5DwSxYwXG1Y27h7CNCF2rbQdQB/pGDXZMDz7+HzHQhtnNeaGXFbBt63t0EfXVXy2s0eshkcot0/Rn0Wi1OnWJQkt/gXayzNcllaQ4lJgCSkcU1WbrtD4b7+Ux/d60bRjsoUypxnF8yupMQpCbYinGy7MVXHdpxHNJJHJTbgVwdGde05fX+TvU8T36foBWZHXGwHXAfENykGP0rYvsXu0ALacTATMlA39tqf+z+zdASkXeZlgbkE243+1bCrfs+Kfz3cyrTwgoctwfWZTFN+bLdy+v8AIdeJb9P0LJ2LYrdXma7Zu6cUoOIcCYEbwIMxVUzPjF7a47fNuOhakXLqSSATso9avnZJb5FZzXaKwo453xQ5pF4+yWxAnhCAZ+tQeasM7N3cwYg5ct5jcWu5dUrun2Eo1ajOmUExXRHzPKVP6nLCcfOnUX27HPHc03qASLjcjYbDr51mGYsUdE94B6BVWFOA9l+tSRbZl0EST8ZbyPp3dbCcE7NyB+XmIpHUXjAP/wAusWsi7/U0co3vB/IqwzDi6WQWbkpB4hQk1rjHsVQopU+54hMA8VbRh/ZiG9KrLMiv/wCOY/8AzdPRhvZe6ZOHZkUrgTiLX8m6Uo5JK+r6leZFcQfyRSXcZxNLcN3DiSQdtR3q65UcUvCWVFesqmd5MzTbnCezIiE4Tj0iRJxNv/8ANVu4OzhNtZIawZm4RbJnSl50OLk8yQB/Cve8A6vPak729bPL8WfXiTqtzdJM8eHk0tiAAOOtGQBq6CmlZQN4ANfbRVI+eWyHEAETyfWhAUvfcUCsaht0296aIQuAZJ3oqzOS22MgMGD03JoGCZMfzps+LfeaOodAZqW9xqqESRsBS1KkbwRQVKiFHmKCgogSeaapoB61RtzTQIg6tj5CjpOyjyOaakc8iSSZpOVcAZTAG8+/WsZJKiNKYiBH86I8p2odastrYkNRVsomNqcPBPi3jamAq4Ow86MqVsoggVEWqsoIMkEneNzTjpBPUxNMkCB0PWeKXHiA24NZt77iHGN1TvO9HUk7/wDpWKFdUxq3pwUB4RuOtN12BmTVq3CoimlR3XA29OtNgA+H7eVFXzADVAp1StDQoIBnijqSYAkU0KmBqHrFFUAmFDY9aUVZK3DqhRilICvOmTJKpE+ho6eo5FDY2OncHgcUpnlW3pQBBTISreiVCRMSPKkthIMwSU8mkEwCTM88dKaCCeRvTj0EwBxNDdjsemCSAnauo2DLgw2z03TKQphJhRJI+gFcubI1QhUkdPOuu2LCfgLUjwywjgxXzf8AqF1CCq9z1vDPZt3Rs3iLQsWrK71epLWohDIIMk77qBqOXbWSSCV3TiTtslKY/jW9iDTguGyhlRSLZAKiOdztWg6FhHiWhKgZkKECvl8zXW/ZPU035d5ephGH4RcCRb32xICe/R9/lrTfwTBluF82t4lSAdxdAH9EVmL8QkPtAqKl6S4kKI861H7ly3SCp5ISuSPzUgxHvWTb/wCq+R1Uq3m/maH7Iy+p+VW14ZM6lXZ3PlsKjMXtstlYbcwd4pMkrVeOJH6VsO3KSsut90pXBSFhRPtFQuNM3zyE67LwqOlJLqQPYnircnD+lESUZLaT+bMIwzLjzSizgrK1pG2q5uFSn/XFHtkewy1wS5fucJYV8Plwqa1uOgIAQuUgJWBttzNQeI4Li9u24rWw14Dt3sEbefX6Vu9s+H4liuEt4ZhS7Z65vcvIYbbKynUtaFASYIA35JrpVvHbVHLqo+ylzz6+h8l+x9wu9qOHWz1wruHL1Ci35+MQPOvr7il7hNvkARgtum1ViSW1NKUsJCo2V82oGR5183slfgo7css5ysszYra4Q3bWt6h58tYhrUlAUCYATuYBr6IP3tpiXZY1cNutEKxSElaidUT5pmfpXra7NDJiioO6W5GjilpVGXNlawLBLG5dUzettmxvGdkFMalKJkE9Oarva7g2H9nPYvmm9wzDUtM4dg9ybZKSVBtSklIAHuRXonLL9orBsOIbZD3ds64bSneNxAG1ecf8oPnxnLH4dL/D8HvlWtzj2JM2aj3itakBWtaRJ/zK8ONPLGEfU01s5YsMtqPjPeyvEl99OoAIM+1fQ7/JS4o9/SPN2XmgVIvMNZfACh8zbhn9FV88HC5eXrt6vcOrLhPmTXuH/JgYyvBe3i0t0H/p1jc24BOxOjUP/DX2Goj1aeUfced4S3Cbrlp/c+qyrG5eSym2Z1BIgL1Hf6RT3sExFaVoWjSXCIISSOKm1Yg6FjUQBG9F+51eJJHH2r41zvlHp+ZmexDYdgF2yklalr22SAE7/c1v4ng7V2LNl+3LbjbKjPfRAK+NhvvSt8RS4XEpfCj1AO4rWzLf3DV9ZBqyunkrtOG2irfXxtW+GbljlSMcim5xjJ9/7D05cZ0oCnU6UmUiST/EUw4LhSH+9cZQXDIUqN/1rJbrxRxkLZwm9SOBqbI/jWNuxxd1wqctCknkLcQCP1qEsje0WbLpTqc18wYgvDLC3lq0bdXqGkrQDpV5ivjp+OzGLnEvxDZjtr11DjVreNhGpsApIZR1AFfYbF8Iv02+sqtUHkanTAO/kDXxR/ygOGvYd2/ZlL2JW1w45iStaGdZ7uGkR8wFd/hqktSlJHm+ISglHpd7npn/ACZ3wLnaRdItksycJfDiUgeIakc+dfTi0OHIGk2TSekBsV8jf8lIrFldsGMKsGEOhnBVd4XXSkNoLiAVDbc+lfWVoWDTpHxt28Z4CEJA+9b+KqUs/Kr3nV0KeKN3wuCXC7dENtoRp6AVjSFd8pwhKBG0HYn1Faa37ZxX5Vu8r1U6Ex9hT1vNtpCWbYEea3FGvMUEuZL6/YxUGtqf+fqZbp521w27efUkpRbuKKZkVVncbt0gaXAVLMwB6Vam7m3fZfYVaMqQplUySoEbAgyfWtdi1tG1pFtZ2SCn/wDd0n9YrXUY4PHBOXr2HhnLHOTcfT/O5V3b9D4UO7cSqJBFa9sq+VZqbcadW2pRgFBJP+FXW5u7lnZD2kpBPhQB9tq1DiGJqTKrx1I8wYrk/wCGP9T+X8nbHNOatRXz/g+cf+UQt8fvcaw039lcW+FYcbVZuHUFKVO3BdQlMnqA3+prwz2uZVNpgluQkrXbEqU4TsQeP0r3f+PbMeAo/ENhmWu0LE7n+iysv2tw6F3CtLdzreS277iTz51xftF7NcJv8oqxHDrpeK2JtNKC1pVqT0UlSdiYr1/D80MGNVw3zR85rJZMmRys8PYD/wDfVhO3z9a+8v4fMuXeaexPJONqx+wBuMFtkqWpxRV4U6OiekV8KLe0fwTNPwbjZQu2fIhaNxB2kGvtV+BbMf7a/Ddl9BeCzhzl1ZuE/uw5qH6Kru8WcfJ6mr/Wj2PCeqeJqDrc61jfZ3h7eAYkxf5na0myf1Bm0WojwHcGRXjj8LmAYNYdpuUHMOzGm/UbpsIbVZFOxHIJO21e0s2X5TlnF3m3EpUiwuSiBvPdqivD34QA4e1DJgVJV37ZO528JmK8vw3JGcmoRr5/3OjNCUMtt3s/Q+j7t/dBbml3bWowNuprXN27KnHJ8AO8b09eF4otaiLJxCdZMkACJ9TT3MNv3B3f5CJEeN1P+NcLx6qWW6dX7xReCMVwQmb3Xnc0IYAJQ3YsK1KJgE6p+u1aiFoC1tFvY7pnfV5mpvNOBvv4ui6bvLJJDDSCl18pMpnfYHbeot3AL4ytrGMLQSZOpbigPQQmunWQyyzy22NNFmxxwRvn4MjbxSSpTriEpSlILZCRJ85qCxB1h1tbSGitSt90dDxVhusuXqoLmYcNSI6NOn+VYf6OoEfE5ospIiE27lZRxZKqvqvudHnw/wAT+xI5QQpnIGZnHGw1LZTsOYb529TXPr99Yw5VlapKChJ0qUPKK61g+GWreTcZsBizK0vagt1Daob8PUHc1z26yhZurU09nCyU2oQAbV0e8kGu7U45TjBR7L3fc87FOPnZH7/R/Yp98h8trWtCe9BUlIBHOkb1A5gxe+t8NZbUkLWU6UkbwdprozmT8OtVKcazdZpSpWrSqxdI3Ef3qgMZyxYXAFuvOtglQOoKThb5Hp1rj8mT/wAR1ecrpp18H9jl7lxdu3TF2haGmWxpUlSpKiaOArJzvgDPepIOIshyPVYq0XuVcDdWm3c7Q8PJgwE4Y+ZE+9MyxkPA2c64Ld2+drO4eYvWlpt0WLyFLIVxqO31rbDCcciFLLFp/Yhu3u5LWf79hZ0o+FtZ1cyQquKYoyhZfUQhQWSOOa712+ZOs8a7QbrEH88YZha12dshVtdMPKUAkGFeAQZmuT4rkRpy3U4O0bAFq3TCbe5TM/8AdrofXKbdbHNCXsUygMG1W7oDYKyJ8QjaovF2ktOQJAUd+TVsPZ5cMXouR2hYApKUkFIS+qJ4k6K0MTykHX+7VnXAEyqNRU8kH/4dNY8j3ozbS7mbsjuEpz7Ytl3aHIJmB4DXP8TunP8AlDzPbLu3U/D372jxkD5yBXT+yjK4wfOVrdO4/g993AUpKLZ5alOSkyEhSRxIqiY32fX7+d8axa2zJgziL67eWltV0Q4iVEwqUxNb5I5FFbMF09fuK1j+OXNjhxdsr5zvCvRIUdUVVLjMGKXaIfvFulJEazJ296vuI9nWOXTPc293hT+4ICMQaH8SKql72a5ttCtv9kreUVf9U82v7Qo1nHqUveXJwqjLhubccbQlRvCjkShI1R7x6Vc8IzvjTt406cSfSlAG0gfrVYwPsz7QFNJP9Fr1SSTA0p/xq44R2VdolyRGTMQOxAOgQP1rpnPI1W5yKMW7s6J2d56x20zThd01jdx3irhKD442J49q9l9m+arzFc3YbaLxF51ta3CUqcJ3Sg9K8cdm3ZL2gJzdhRuMq3iEB2TqWjp9a9idluQsxYLnHD8UxDDnGbdvWSVLQYlBHQk1xzlk82C3rudcPLjgnbV0buYsxrt8y4jZquXiUXa0j80iB/IVoNZkcglm7fMEkS6rmnZmyhma9zXijrWC37rL12tbTjbEoKTwdVaJyXm+2bURlu9jzMIA+5rx80NR5knFPn0O3Dk0/lRUqul6G07mN4AkvrJP+cYqYyxiTt7ibbYWpQbBX6fIZqks5czmvVqwFtISTCTeMkx/r1cuz7CcVRdl7F2GsOb0qSnU+26pZ0ngIJ6T9qNNDUvLHqTqy82bD5Uqa4/U3WMYQbZpKXQYQndXHArIi+GoS7AJ2gVr/sHAPhe6czFcOjQAPh7QJIEbQVKpzdvk5vSlV3jbqmkz4i2iSPKBvQ9LklLlL9Uaw1MFGlF/J/3LMFB3Kl07JhV4CPTYVVV3aWQEJMkbwTP1q6F3CG8rOhNrcOW4uAkpU8EqKiBvqHpVOQ/llpDiGcuOLUFGdd+tXseK7tXp+pw9pKor1+xx6TL0ynUW936e73mc3+pKArwz186iXL19d0pTLYCI0yrqJrdVmTCW7kWn9GmhCNUquXDWZV7hrjS3k5YtJABGpxxU/wC0K5Fp1d+Yvr9jqlml2g/p9yEce7zFLZUJbX3iAARAHiAqX7ZrtaMxsMoYbW4mzSpIcXpBlZmtRjFLEqtbhzK2HJcKkkpV3pI8Uc6zVg7V71m3xW0YVgVjerdYTC7htSoTrMjZQ2r0seJfhZJyXK9Tz805PUwbj2focrdeVbBSnkLb2gBO4iah8XuS64e6dcCUyQOaud7i1kkhoZNwdaV+GVNrMj211C3+LYSy+2gZFwVQUlW5bdBBEbfPXH5EP+6+v2Ol5JLmP7FLU/eJu0pQuRvsqRUVdO3dxcQPOf41e7rGsGELVkfA5UY3admPP+0qIvMxYRakpbyLgYAGkFKXzP8A8Wmsa/7L6/Yl5G/6f2JDIzbychZqZb3dVavKUAP/AGS9q844jdRaxqMhAM8ztttXqbJd/aYllTM7icFs7H4OxWuLcOBLv5SzCipRPQjaOa81rz7lZ7QLns9wc6kpBSh64T089e1ewoXjSs4XL/kexTcTuCtrvQADG229VHE31ADvUEBfWup4tmfJRlCezOwbVzrTiFzv9Co1z7H80ZIffLK8mFtaASFMYm4k+0KSa2w45LZtHLkdXsU+47sphJOkEnnip6/Sf+StZA1I/aKZ9/8Ag1qOY9kVaC2nLmIJSI8P7REn03RU+9eZbuOzR7+o3zViL4Syl9KnQvodUAEfSvXwRdP4HDNtnG7lSEJVpdKVJMbGoq7cCpUqFafEDVudb7PXbdwJex9kOqMLKWlafSOtQTljlYISi3zO9JMf1myI+5SYqYRlF0K/UrfaThZexjRZNpJQuVEQCQUCJqkjBsxtKKba2HjEhIUmP41fu1BpVriQuvjbe4Lq4IaUSUwkblJ9KozuIlCVEQNcxNTkl7W4JtKjGzgmbFgrOEuqjkIAMD6Gpi1tcaQ2G3MGu0CJSC0ozUK1iylOhK3yE8q0mB7Vu4Nj60Xami+e6XBEqOw61N+pSTOptN4kz2RO/E27jYN8VFlaSlSU8A8cVzxAtFBaErGoAFciK6lYuNOdmXx3er0nEo06jITpH6VWXHG9RLdw5oAACZnnyrbJKOxlFclcwhtCnULJAhYkzxvzXSM0t4U7guHLxTE3LJTt5daC3b94FbgnVuIqtixS9dBxDjcJAKQWkqM+fFb2f21HLmGS9qBxC6UkiJA8Mpj3rFtNOjWPVexHuYdhS5LGZ7aCDGthaZH605uyDeCYgwziFo+VrRpUh3TETzqAiqqtCEwe8AI3g1vsXCU5dxBSlQQ81MEmDvFYR9rc25OX9o1veWygX2iApRhQMg/UVSrdzS08CfmRH6irTnlS1nUFKSgK2SePtVSbJAXAmU7/AHroxUlsc87vclcEe7tq8QGypbiEad/84VfcNssTfW2LfDrlalDfS0SJ8hXPcGBLrukq193IKeniFXa1xG9IT3l26SB/fNKTQL3FvtsDx4wl3DXkGB84AH8am2Wcz2tp+z3HEtW6194Wi8AkqA5ImqS3fPBKVF5ZJ23VxW9a3bpc8bh2B2J5qfZew1fqdYzXgT7uIWbiMTsGg7YMGHrgIhWmDA3ketareXUNkKdzPhAK48KXVqI+yeKgs53Ta7vDloUogYewkSeduK0bV4LIUNwNp6j/ABq/ZUqK3iqLuzguCNOgO5vtHCdyGrdxUfeK3kWOUW97rNF2E6hCW7Gf4rFUO1uZX4pUEKIjVW87dECAoAL3gcGpW3CJkmy/a8nBKE2l/iryjsrU0hAgekmKkcPXklr/AKXaYm8snw6X0Nx7+E1z63uQllC1KA/0ordF3oSH0LSoDy4qnJeg+Fydo7Mn8suZyw9rDsKumrlTig08u61hMJ3OkJE1WMUzVlmzxW4acyhauOpeWNb146Sog8wCBz0rW7LHb1zO2FlhLqSVqAUE7CU+cVV8RwbHLrHbsHBL0FNw54u4UNgo7zHFE5VjVCjFNtyZ0XDe039nOpfscq4E28IKHVNOLUk9I1LIn6V6p7Lu2lzOeXu/OEYAzfWh0PpThbZUfJW4PNeI7fLePuFKkWLgUCJStSUQOnJrqXYJa5osc9M2NuGwxfBTTqPiUSrbY7nz8q8nX4pZsT6Vuju02SMJK+D19i+fMds8BuXmHrRmLVwqS1aMpk6T5Ir5x3XaXmJdy8hy4tXUKcUopds2l9T5pr6C3eUc1P4W40/bMhBYcB7x4IB8J3J4FfPHEuz3H0XLmm5wpcqUuE3yD14nj9a8zwfJnWSXXZ6evhjWFKKXJlOfrkNgXGE4M6AP/wC3NA/oKqXaH2lFjKuIKTgWCd660plKk2KEqSV+GQRwQDUs/kLMS3EpWvD0rUNk/tBnj/WrkXblhmN5cFhhWKoYR8VqfR3T6HApI25Qoivo4Sk3ujxHGMU2ciV5RQpTNKtzmFU7kvFLTBsx2OI31uu4t23IdaQvSpSTtzBioKnDimgPaGDYrkK6sm3k5Pvk6oKg3ipP8UcVLIuOzImTl/HEKV+8nEmyAfq3/OuRdnV3iF/l22XbW77gKQkqSkqAMbyQKtzjVwloB1laRsAVNkb/AGrFunVG8Ipxuy3oX2bs6llWYGBO+gNLj9BTjbdnl2uU5ixu3RykmwQsg+2sTVVuVsItzLyBICdz1rA6yEttlLwJA/d6eRpWvQmUN9mdAtsHyM/bpSnPN+TGxXhYH8HK1f2Lly2cItc5F1KzyqxUn7iaqeH3bzVslmQqST9v40e8U4ASYmdMjpStXwVvR0/M+HYf/R/LAXmO2aQwytKHFoWlL8nkADb61WLrAbR9YdazPhCdX7qnVgg/6tb2cnBcZCyqCD+Q0tKCNgZIJrnt/cOd+W0gx1itctJ2whdIt7uVHglNwxmfBVpO2j4qD6bRSbyff3b6WmsZwbV/n3yE/wAapDt86VpHeeEf8CszjxS+CtJMgK8R61ClCS4+oqfqXS+yNjzxSGXcPd07eG/aMn21VHI7N85OKn9mpWAZ8Nw1/wDVVdvLtagHO8VJ4+1aDGIulxP5rpSoxsql7F9y6lItVz2ZZ4KnFJy7cOSmAlC0Enb3ryRieL4tbYndIdeUhxt5aFJIB0kEyK9NXd84UrRrVJG3i4/315TxEzeXE/8AbL/jVwrsTktRpmw5jeJPT3l0pRVzXcOzmzx9GDsPLwTEAlxoKS6q3cCVA+Rjj1rz8OK9M9kWeM0M5dtmDmK/PdpCG9VwpWhIGyQCdhVSrp3Oe3aon1rWypSHGXQpQ6gjelbXDxKVBRSB1JPFWtfaHmhhgKbxy8TG/heME+tMw/tHzPcfl3OKvOKUYhYBj7isFT3T+h0pNclbTeJckBSSfOR51mbum1StSkhSRASo9BVqdzvjAUtL7tsowAUrtWyD7yKz2mdVPud1eYPgyxpmf2e0DHuE1aV9yG62op2G4gv9pLSFAI0SAVcGujdmN58dit1ZFQn4V0zEggCoYY1hd3dJbVgeF6kKJ/LtwmUx1Aq7ZHvcOViTrllg2HWrhYc1KZaKTEcc1th2a3Msl17KKMvFHm71U6zCzsd9q21YyotaSg7nhXAraucXwV+4cUvLVgTqOtSVOgqPp4qxqxfLKFhV1lS3dQdtAuXE7+4M1Epxt7nQ8cuaNZONN7h1IG3IEGsL2ZQhru2iAVCOOlbwucm3Eqay2tj/ADRerI+6hWFxGR0mThWIoKv7l0DH3TUucXw0HR7mYm75u+t1IddSlRAA22FQmOYyMsYDeX904FfDIccSU7dNt6sTSOz8DS4nGUCP3X2pn6p4rl/b/eZaw3IzrOE3+IrfunkNpbfSjSUmSrcewqW72sWN1LdbHl68uXby4duXl6lvLLiieqiZNYKRJPNECRxW9GLd7ktlXGbjL+PWWMWjhQ7bPJUFDkedessDzbiGL2zV3cXz/eHYqS8QT7gGvHrNu8uQhpZPoK9QdkeFWWOZZtri5zLY2LxSElp5LmqR5kJqWr4FGlPqZdW8w3RSu0dvniz0Clav41iVjNm1bKbVbWzukK3cZQqT9RW07khwyprNOCrAPJdWP/LWm9kPErlKg1jGDmB/+F6QR9RU9M12OiLi3ZxrHLe6tcScduGEthzxo0EEEE+Qo2bLuylMvHUYI7skR703F7Vq1xi4tnVlzQspBC9vpW7h94RAIc0hO35xFNY7W5lkklI27PDMRdd71uyu1JI8MMqqYaw/FQwU/AXKSk7ksq/wrFZ4ugNkquXk6R4UpeUI/Wtq1xhtYUXO8VJ1SVqJ+80vJSH5rqh7OGY5oAaw+8O3RhUfwqTsrbMLKEk4bfJ6hRYWJ/Sms5mdcST3q0hIhI71UH9azt5iUkJ06wdUklaufvWb0yk7spZpLsXTLOaM+YE1psm8RCTBCS2tSSPQEV0fLvbNiXftt49gdwANlrZbUD9orjVrmy6Q4VIeCnEjkLI/nvWx/TTEEOpIvViT4kpVXNm0WLM6kjfFq8uP8p6xwfN2D46ULtHbnVA/LWwoK9txV0OEYi+whaMKvggjbVbL3/SK8Tt51xZIT3d28d5Mq6ferTl/tpzjgo7tvElPIBgIdSFpj615uTwPG/yTPQx+K5F+ZI9vdleB4uxm7DlX9he2jGpepx1hSAAU+ZFRWccGx1WZsUbssHu3GE3K9K0MLUIk7yBXM+wn8SNtcZxwe0zJbwC4SpxlIVHhPTyq7Zv7SMDvc5Yo1huNNOJN0spRwTMbGa48+hnpsVO2jo0etWbNNppbLkYxlnM6wopwPEVAj/8AA3N/rFZk5czA0pPe4LiQBTB/q6wP4VHt5uv0n8m8UENnYauBSczbiCzK7wn/ADdW1ea1hre7/Q9FvLLmjfbytjyZWjAcTWhcFJ+FWf5U5GWcx60lvAsSMbwi1cJ/hWCyzZcoQtPxbhE9FmshzPfKQW28RuACflS4qf40l5V7t1+gf8vajOrC8V3Q5gF+VTpH9XXz9qkMEtriztgxdMOMOJUdTTo0qT71X3cYcQA6X4PMq+afepnLt38ZZfEuuFSlqUSqdzBr3vAljWpqHoeZ4upvAur1JfUOkxxTlSEiRJimSmOCB50gQDwok9elfcR4PmWx+wSFGfagIkxG3nTRP+JobzCYp1tsJ8Dp5JPFFStxCTHmKaFEmAN+ooSomCNp3qW0nuNpUZOBJG1Y1rIVHNHcQlKuTtNMCpBiJ9KqNMXI4lYkTz9KckEJEmZ4po8REEGPLenbyDvPkaVpcAthxACoSCRTBOqZ4pFZ4MD+NABOkxTi7LuyRMgbJJPvSKhA8MQOCaZrJgcjc0QZEfcViSEkcpSSTS1BCYjmhJIkcDaiFAkTwOtACSVJG52pwUOSfSmKBUIURFIBJghPpTAerhJB60CvYAK3mgVwAEiSDQnxTsKQ0IlY4VEbU4lIjaZpupRPAIogAkhThg8AdKboBylCNhAoEwIVyeBSKgTBM9SKA45geVJuwseV7AGd+aEyJCiPemhYB53oqI1SEk7c0CFJUYSafqXHO4O58hTArcET5UQpR2HHX2oAzNHWvwpn1PNdYwezLeH2rvxTrpU0kkrWT06DoK5M0r8yIMjyrr2GtKcsbdK7hxKEtIEIZGxgdSf5V8/48m4QS9T1/Dm4wb7Gy/8ACpcaC2W3SGUGVp45PWtO7uG0sOAWrQStO0AD+Fb14LBLzae5uVuFpCVKCwjwwY6GtJ8WesW3wThMTK7g7j6AV8nnwvzH7S+v2PS07XSn0t/58TTReoU0h1LcIiTA2JrVNxb3ATdylJAUEg1tr+BStthNoyW0pPh71zb/AGq1hfYakLRb4fboSnfxKWr/AM1c/lL/ALL6/Y9CE3/TB/T7kVZ37zxvGW1JSkLICQZmojEbtSGghewKtJHqasDTmHpLz37LsiD4iQhYn/bqNubnDHHAlGC2RWDMqaWQn1+eqWmb4kvr9i/Naf5P2+5AYyofCPhllJJQqfUVRfxS9tmTewixtcw5rdl13DrVuzsmHB3j2xmB0A86sHa92r9nvZBk6/zxmqwsG2rNlRaaU2rXdO6ZS2gauT+lfGD8Q3b9nT8Q2f7vO+cLlOtSEsWls1IZtWEbIbQnoADz1Nev4doXnVN7dzxPE9e4zisa3X6ntGw/yjXZpf4nbtuZWxxhlSwFlbrakokwSN+BzXtGxxbD8Z7JcCx7CLhC7K6xIPtOJOoFKkGCa+CLKlIWlSSYr3H+Dj8XmM5Wsbfsezehi8wG5d/qLj7QcVavK22n90z9K9XU+GYoY28K3K0eseoXlT/Nar7H0wsGcOVYtvNZrtxpQiCxbuL6esTXhz/KbZkwRrLWS8sMZjuri8U9eXxSqz7pJSlCUJJOonlRHFermb8WaGmm323tKEakqIg7dCK+an4+MzuY/wBsDeHrLiUYPhTNtoUdgta1LVA+qd68rQwhLUJJVXxJ8UlOMFFvl+77HmnD7RZBIdbB/wCOten/AMDGONZZ7f8AKV1eFC2nL1NuoBwie8BR/OvM9k0pSPAgkDrXVOw68dwvtFwDEGoC7fELVwdIIdT/ACr6eTi4tdzn0G2WKPu45ftpdIRZW8J4KypW31NPdxFju+8RaW6FjhXcJMVpO2tw28HFlJD+6NB1kg7/ALsxWyvDLkpU0T4gPCoBUR67V8fKbi2l+yPTawd2BOLPtp7xp9wA7Hu0hMfYCpG7xFagyVXjoKmELgKIkEq32O9alvhr9uyrXrWEj5dIE/UmtxNjdvXDTTNqhzRbNhSlPBIElWw2M1XVlliklL0/cwyywxlFpf5QwsqcaQtpwzydUn+NNab1OKWgAK6wOtSLOEYrrh1u0QgAwS8pZ+2lP8afb4TcD+0etwRzpSrf9a53iyd2T+Kgk0iBxG5e0aFBU7gQD5V8T/8AKFXQuvxD5pedbUHFYoQsgbbNIAFfcnE8LsXIU+ta0jlCQB718SPxyX1jjP4hc1sKwy0bFtjLyAttuFOaUJHiPXiurwpdOq35OTXZY5oQSR2H/JGNNu9pualKSBpwKJPIHfJH8q+opbtGTqKiZPI4r53/AOS7sbCyx/Ma7K1YbK8LQFrCfEZcET+tfRSyate7DLrSFp3AB3Fb+Lpy1C+B6MVKGOMl6IK2FyktnSkgTPlWZbVwpoBlIcEEK3p5v7Fl34ZtlCViOE7RWF7E22FJZ0JRqJJI8q87oS2J6skq2Ni3w65FrdNpbjUwUoOrncU1tDzWo7c7AmkjFFN2106hY/KbEJETuoCtK4xp55YZI2AJ23munNGCxwXuf7mUIZZzkjZeaddWXH1oCEAEgST/AAite4W42o90ttLYKTJSTyYER1rGziSVBaC4TAGoHgRUXdYm5cXiGmnQhHeoHsNXNcyhjlubOE4x+B8n/wDKk5osMd7b7lrDb7vDb4TZWK0lJTC0KcUufbUB615dyN2zdpnZ/auYfl7GJtHEEJt3wHUNn+8kH5TV5/Ghi7eYe1zGccbuFrTeYhfONyNggXK0DfqITtXAUtErKUqVCU6q+q0GNPTRjR8/N+07JsqxfFMccxnE7g3F1cOqedccO61HcmvrN/kv8btrrsezFl+7skuu4biyLiVOKI0ut+UjqivknlBYXjbCXVEoEmCZFfTT/Jp4neN5kzRl2ytVXCLzDm7lSUCYLbkfwXRr03hcUtz1fDOndcL413PdOcb5FvlvF7+1wy1dfbw64UEqYkbNHn6V41/CLjf7U7UMoONYVY2a3nQVBi0S3ACFSJia9e5/YzDZZEzHcowRxnRhV34ipAgd2qDuRXkz8IuDY3Y9puU7m7w5DNukkhZdQeUGDAJPWvI8MWWM7mqXwo6MvlyyPy32fe+x9A2LJgArdGtYnxKMk1idZtyXG0QmETIT51rKv+6aIF00hWsp3CjB+lOafb71wP3BUpSQNSGSB+prgqTyK/X1MIxkle5HZkUpOOP6U7Blnb6GtFNyENKEJO+w9KlMcGHPYw6lbt0hYaaCw00D+7I3+tR5aw6HAr9oK6CUoEinq8TlqZu1z6nbo8sY4Ipp/IjMSbubpoFohKVcb1pW+DqUtJcfkz+6JNS6mbNTKNVteK0qMjvUgAenhrGph4wm0tXAkyCS8CR/s1isPdtHX58ktosk7dOjImPBCoKNUK67gVz65UlS0IcIEJMecxXREJatsjY2l1lx7opJchS1EJjeNuRVAvMOUm6bdubNxrQVpOi9J6f6FejqYrpxq1wefp5vzcjp8kViC2kp0yZSBJSJNVfGLhKrjukNKIIBPSrRdW7Div8AoK9MAEm6I389kVH3+GWpWVs2jinFJHhN34dv+5NcXk+9HX5tbtMo92ttt4ONshIbEK1fpTcqXN0c+YGGOTfNRsI52qau7S3cdLScGdUQgzGIEQfq2a1MrC2Zzlg6k4S98T8SjulLv9SErChGoBoSK6tNhqa3RnPIpJuiqfiMurm27R7kXLYCjaWoABgJ2PSuT4o7qQoSqSSTvFd77eU5du+0W8F7h94/cBm3StTWIpZBOiRCe5V7c1yrFLfKkGMHxsqIMBGLtED7sV1dEm7ObFL/AI6Zz4OvfDvzKVJI/e6VWMSuXQtUvbzv4prpNzY5PTb3He2eZW506dN6wpIPWfyRVLxGyyut5TbDeMp1RCl3TJP2Df8AOrUW3uZvIo7MlOyO3xFea7RVoSXlhegJG5Ok1WMwuW72P4i24CHhdvJcKVQQrUZn610Tsk/Z9jnK1+BuMQccDLpQHtETp3kp349KpuLYPZ3ONXt2jEbpBduHVnVbpVJ1E7+KujKpLGiIyi5WVl+zbXblbfeKWiIM/wA6omYsQuUnuXlFDizpAB2joa6jd4XcsMEtYiypSx+YldupOk+4Jmuf5mwhtbfei9tVSdJPjkEnmNNckJtTsuctiKwzFb5JYZW8sonodUb81e8JSC6EuulYmYUomqvhWRrpNwwbfHsOXq6BTn/0V0/BMl3KlgPX1kk+YUsj/wANej7UtjnclF7ouvZWkuZtw3uyBD4jwzXsvsmU8rOlm0sEAd6fCBB8FeUuzHKC0Zsw5ScdsNQe8IUHdzHno61677McCu8OzhYP3WKsOCHAGkJXJOn1EV50lN6mCfB1KaWmmioZyvcTGcMdSMWu0pF+6hKe9UAlI4AE1UWNQvnlLvnnAUDwrdUYMmeTV3zHglxieacbftbttaF37vi7tyUnV126VFs5FxI3CnDe26kf/i3AR7yBXk55ZXOVN7P1/k9HSyjHFHbt6EU1eNIaASG0HglKRx67Vfezt1w36Q6QQGHlCE8/lmqycgXRUW/22wN41fDr6npuKu3Z/lg4biCnLi+TcKbaWPAgo5QR1Jmlpet5Fb+oaidQld8PsbtuG2bJCFJQCpAKVJ5IjrTXw2G9SE6lpSYjeJ52rZt7SzatGS8pbmoAaFLPEcbVslixBCBaIJUmBqKjP3NZdKu+o0U5NezF/Qkk3ITkZxxCDCr7SEn2qjYZelKluEBJ1GRHka6Tas2TuVPhnWLcsG70aO7lMwOnnUSxlnBApP8AzdY90pMlKWE7qPXcV3a1404dTr2V2OHT5HGU9v6mUe+vbZ3GO773QvudcyI5j/Gty2xtDLJ766ZWkEJACwD61cl4NYW51W1iyVITAUGUavvFa7uFquCtanHWyDqMITt+lccJ4ls2/l/J1LJJq6Xz/goltj1i620tpxHzJSnU4CQNXlzV17Vbywtsx2D126lINmEiVRMr/wB9ZbjD3DZoLV68hxKQNiN9xW/ndm6us0MtIvX27dmxSru0KiVKWoTPsK9TDkxvSzd7Wu38nn5Op6iHrucwvcQswoFNwwUmNwoGq9jGIWa75Fr3zMKQZVqEprotzgt24slOLYkxwAEXB0/aqniWX8wIUojOGKp8UpSXTMT51xrNibq38v5OyWHI9nRUMQebbBKr1sokDxLFVnEsUtS8ptL1vI2TpcHFdEvsOx9KYXmLETKjI+LUDUDd4XjyEEJzVfJKvl8YUfqSJrVTwr+p/L+TNwyRW5t9m14peV85Mp0lKrBaVQZ/6lyvK100lduhX5YUEJB8Q5iK9f8AZr+27ezzRcXmMXV25a4eSyt5YIR4XDsmADuB5159vcXxy7thcv5gu9bo1qBQ2RJ90166UJ44uzz5N+Y9jlWJLKWS4p6SkdVVQ8VKUXAK3/EUEz5Hyrp2NX+MMv8AeftDWmJKXLVlQ/8ADVFv8cxR9/ubi2w17R4vFhzBABO/KK3xYk+5hlk64KldDS0pfeEKTGlZgc1bVXDw7IFHYn9opP8ApGIrQvsZW7YulGF4KtQWQlIw9sfwFTAuHLrs+SFW9q2hN7ASlnS2CB5edelpvZjJHFN3Ry/Vqa1yQskwPeoxRSbdaV/2qSekVZlodu1uNM2VghSN9m1Qr7KqIfwy+BBFrbRq8WlSwr6STTire5Mru2RWdMOw/GcSUbrEEYeWVAjU0pZXKRI2O1V1OR8JulFKM8WaUxJ1WrvPlUznNi4GKKcUwtsE/MSDrgbkVXkpSXCnxCD+6KnI49Q17Rl/oLhCtQZz3gq1JP7yHh9DCTFbFj2cW6lEN5vwEuFXHxDidvYoqA/Zi2HXAEhAVuI61v2FjdKuAtaxBPzGlFwfKBXHg7Hh+B3jXZuMIbxTDHT8cXu9NwEtHbjUYg+lQScpYyuRavWD/XUi+aVPpzW+3Zts9mzt0+9KRdhKUTtMVQ1qAKVJAbSdudgOpraajasUYtpysuzOVsytQRhbqjHi0FK4/wBU1o9pqbzD8AwpsAtn4t86XWuASJgGoGxvHW71pu0U4DI1FJKQd6tPaJgmJ5nwKxbsjqVbXTqFFbwSd42GojiKycV0ui4yd7lLat2NaWnEI0qO3h9KzPtd1g98hlUpDzRjgyJrYOXMcZ0vLw94pT4dSSFDj0JrFcWF4zg92X7R9P5rf7h35rOjSTRyrNlq5cPJaeWlkEyTMiKhP2HYJWhpOMMkup3PAFSWdHSeAQUmPWKqSCCFbcCnji65MXJN7liXg1thzFw61iKH1hKUhLZB2KhJqy2GGNlptS1PkFI6J3qhYcsILsTJQNx/pCr/AGV+pbKEKWmUxxtTlGtxXfBMtYVbqTOh0g8fmAfyqSwzBwHkFbSCjmO+I/WKjLW71ISVKB8oqXt33ISpDTitf91JIpL1BFsxayTevWKxbWwS3atg61LJ22jYj705rBgUhWizb3mEtEz91Gji3xQVZfDW7jqV2zZgIPMbzWdiwxdxAWMMvYA57lUUSbs0UU6bNq2webhsL+ESlPiOm1SDx+tS/wCxrN1QLl2Ek7pLbDSN/omo6zwvHiSsWbgQPDKiBv5c1LfsnFSpAeZSgAb6nUj+dTTB7OjN+wbFzZy+fKleEgLA/gKmLTD2024YdxC8KUCEgXCht9OlaFvhNw1DnxFsSDJl9P8AjWzbIW6oleI2CD/nPiKqKk+UKKUXuWnJymLLNNgu2U6T3kQt1SkkxEkTUS7bYE3fXLztlbOKU6uSUyQrV5ms2WMMS3mCxuEY3ZPEO6g0y4orUY4G386xXOD4f8S+4vNFqgqcV4A0tWnfj3rRxksf6idSmbCMQw+3AS0w0kp6iKs2Sc1Lss1YTdWzkFu8aUCn/SFU5Vhl0q7tzNDpE7hFoZJ+qhVk7PbDIjmacJbuMWxdxJumydFq2P3huNSjXLl6ul0a40k0e1M4409c4BeuJcIbWw5E8kaDXzPaxjuitEEoSTt5V9NcaayEvDbll1WYSO6cTCnWEp+XbYCvnJcN9nHxDiX2ccQnWoHunG1cGP3hXz3hGPJ5s918z3tbkvTxVPkhzi60NKfSoafmI9eleaO1fGBi+cbpaXApFuEsJI425/U16cxt7sttMJu7kX+YWktMqUqWmiQANt5HWvHF+6m4vHn0qWoOOKUCrkgnaa+mxRmvzHz+RpKka9KlSgmtTAIrcbQ00gvLQFiOI4rXYZdecDbSCtR3gCalnrF9Fg8ssKlKQVGNkiad0hnX+xTtExlGGryu3idxb2TLgPcIdIQQese9dys81Yow03GL3gA2SQ6Rxx1ryX2SqbObG7R2+trVD6Y724UUoBBkTAJ/SvVVplgPNJcGacDcQdwU3KgP1TxSpt2TGuolbrNF+613lzii3FHc95C5/StZvE2nBLncqKupZQT/AApruTb267sNYtg5Snj+uJAPtPNNZyTjim1AXOGr5H5d82SfTmhNm1o2WLlpQV3KLFTY2hdk2rf/AFeK2Uu2yxpvbHClpPOmwbT9NhWlaZOzE0CyhpkqJ20XTapH0VWx/QrNRICMMcWs+TyCftNafoS5NcMtWNtWV7ljA7V20tihKVKSFN+BO/AAOwqvLyph761OmwsAB5pUSffxcVNY7g+OsZPwG2asHVXTJWHQkElO+01B3GF5qabAcw6+bKt1HuVb+g2qJ7umilXStwW2QbR8ua7ewcJVtIcTpH0WZrI/kXDXiEDDGEADSVC4XCvbfatq0exO1SW37C6TtpktK5+1C4u70pIUy+EgD/q1AfwrPpSQkveRdzkbBlqLYsShKfCQbk+L9K13uz3LSBpasb9JSJJ+MTA9horbu8Qvk6X0svoAVxBAP3FR7mYH0lZWVkb6tUipSSZcVL1IfE8rYC1r1XN+GoJWouIJA9Bpry1iuTnBid0i1xO2WjvllAWSFadRidua9P4pcB1hYWoyvkyY968tYjmR5jGbpxFuhQS6tPiPMKPl7VUa6vZCa9m2zWXlW9ZUrXdWwKRJ8Sv8K9A9meA4c1hdmxbYuha12qVuabRXhWeU7qE+4rz4/mO4uHFOKYSSo/3jXb+yzF03NlauIUEL0AhOr70ZFSOet0dScys28C2L5adX767QhP6KNaJy9Y4a8HRjCHQkeHRaumZ+lSVtir5bLavCFceKtZWJFNyhB6mpXQdCbjuY14NcPuB34gJ2EJW04Pb92szWWxdrLqr5hpwbQorSZ99MRUq3i7oUkpYASABBrctcbQlZJYQorI2Jk1agnwZNsrtpgSmHFKF5buFAjUlzb+FXTs6LjOJPPOuNKJt3UCXAYkVrDF20ytTaBq3iJqYyDfIXmRFu8hCULbdJ9tNaQglKwpvcqD1sV3Cmrd+2WoKMAXCJ/jWZ3AsXuG9VvhbrpSZlshUfagm4tDcqbubZslSzuU+vnW8hdmpb7SW0pkCSNoFYS03VKzoeaUWRJyxmRtPeKwO8SEyVHuzWvc4Tji2tacHvjHBRbqUP0FWMIte7LalykpH73J9aDF01bag3qa0iIQohKvUxUy00eGxPM2VH9kY22tK3sNugmZksKEfpXBu37FLlzGLTBlqXpZb70pUIO/G3tXqE3bbSkusFxCgZ8K1c/evHvbPmG6zH2hYpc3Vw48GHPhmytUlKEbRP3ohiUZJ2JzbgyiVkR8vXasdZ2UOLbUUAGDXQvQ5zbtQI0CfOupdlGKrtnDZmClKwoJM9dq5japfEIKBV77O8WOAY6i6XYMXSFtlsofBKUk/vCOtTNWqDjc7kbk6zqa3V1ANZVOqLYCNURBCTFYbPHHLxKblFvZpSofKLYRUza3eFtHvLiwtXU6TI0FO/0NYdFdzfqbWyON4s7li6xG671q6sHkrCYT+cHD1JmNPtWzaW2WFFPxOK3rYAkKTapJ/8VRGYbK+GOP3Bw5xtl1xSkaASCmelYUt3CjKWHPCOSkmu2NKNmWTeRcGLTJC0EuZgxU6eALNJA/2qkLO1yI3OrH8VUk9TZImP9eqUlm80d26w4mRwlJHtWVFvcJRPwrwCUxwaxc77COg2dlkAJ1PY/jKUzIKLJs7f64qS+B7OXElX9Jce84Fg1/8AnKoNoxiABS5Yv6YEENKj+FbTTN0lSf6o+BMfKrf9KG6Gro6BZYb2eaVJTjuMFJEybNvV/wCOtleE9nZCT/SHHUkmUgWDX/11TGLfFViE4ZdaTwQ0o/yraNpi6UoUuxu/UlhQ+nFRaa4Hsy5pwbs8UEq/pFmHxHxf1ZqPtqqRbwfsy7vfMeZyAd4tGI/8VU+0t8SU2Yw+622kMqP8q202uKDSkYZeAHbZhX+FZya9Co8cnWOzLD8ht5xw9OX8Wxi4uSsx8Yw22iY/zVGpvO9pkBjOF6vGsazDb3pdIWLO2ZLaT/mlSpqg9lbF9b52wpw2F20ht4lSlMqCeOpIqZ7V2MSus8Yld22HXLiHXCrWhlSkn2IFbS2xJvcWCKlll1OtkTVlnHK+Cup+CzTmVxlKtkP2zBB8/wB6uhYJ2o9jF22j9s4rm1l47KKbS3KPp4przf8AB4u6CkYNiJI32tVn+VORa4o2AhzDLxKpgf1dYP8ACvKz4cWZ+1BfU9OGR417Mj2VgGL9iWJMkYfmTML8mQFN24V7ETUy5bdmaSQi8zKAedKbaK8YYZb45bkvN4ZiSD0Wm3ck+8Crlg+cs92CUstWOJvtD5kLtXN/rFeVl8Pr8iX62deLWR/qb+Z6bdsuzJYJVfZpcChpgptwKkcNTgqLMNYAq7+FTwbgJ1yOfl2riGF9oN3cthrFMv4qw4QNhaOET9q6rkW/TeYOh1tLqCpa5S4koUN/I712eCY549V7Ua295n4jlxz0/syvcs4WVgyTPnQ8OlJ1Himh1RO4oladOn9K+yt8HzyQTI248qIgDT500Dwgr5AoxvAO1ON0NodG0jk+lDVKtJkCKbMRpBJHkaJ1cgifalVsGlQhBPp680pHMnamjQN1KOqaJBkCRuYNDdEoKTO3XzpToESJoDqTz0imkgEqHtvTTaBIesgrBIJJFIJSeR7g1jC90zzNEFU7g6T1NPqKokUkgQQJpDZJMTQkHrt9KAWQCAJ8vesxD0kqEE7eVCUgGFAECmgmPWnGE/ugzQAiqBseN6XBG8U0mCQd6IIkBRoAQUB4txNEkDZQEUBwoDrxSXsBrHrAoAcJ3JTAoAwJk88U0Ejnp50SZHhP3oGPlPzUJmBsBM0wqOkQPrSO4HnQIfIGwV7wNqRISI1GmqUVEiYpRO5486AH6kgTvJopJHIPpTRIHp0oE7gdBQBssH83cSJ2ArtLL7dvhrOohJS0k/pXGLQIU+hM7KUBv612xjAbO0tEqZtmgtSEgmBPA618747bUaPW0MlGFS9SPvUuKvFvNgqSpDekyONI9fWtDErTEXoSw2TqHJcCan3WQzfPI2AlIj6Co7ELptu6SmSIkbHc18plpz3PX08pNRUfQr7GG4ghCUuN6nRMwSrb6DetZ9N5h6EMuG2ShUkrUoyPsKmXL4am0oBAEz1AqIunm1sFCnNiI38yamHRe6Oq8q7mvatuuW6y0O8lZBMKAjz3FVzNWMYXlHDbrHMfxjDrGwsmVXL9w86pKG2hyonT+lSFpeJs7Z0B8IjWZWYEb7+3+FfLv8fH4tH+0HHH+yvI2IJOAYcotYhcMq/6W8k7gRygR9679Np/xc1CC27nBrdU9PHZ2zk/4t/xL4v2+57fXa3DjOWsMcWzhlsFGFImC6odVKifQQK4GlsubJpvjUdyVVtWjZUSQFcxxX12DFDBHojwj5ttylb5Y+3tVlSUQTJ3ruPYnku4t804NimIWqVJN41oQoEBQKhzVLydla+cvWLl7DCsBJcShZjUOhr0b2Q4ccfzdg9jiClWLK7tpAcKNQQdY6deKzyzdM9Lw6Lhng+9n1ON9Zot27Fduz8SyW0l5CEpMaOSAK+L34p8+Yh2ldt+bcVubsP2zWKOW1tAgBpn8tEekJr7EZkcy9le0xjM11nFsW2E2VxdrKbRZUENtEmVTB2FfETFEW+L4s9d29+h5NytT3eqQU6ipRVMfWvC8OhLz5Smi/E2smWKivpREWDUzqbkjaPSrhk9arbEmX2BoU2sKlPIIqPtsC7tKV/GMKUo7Def4VYcIwx1p9C+9ZGpXM9B9K9p3dEad9OSL959y+zDFW8YyFlnGpCk3mEWrhVHJLY1fqKsmIYmUrQ3aiEkbADdXrXI/wALmYGMa7DcoF23t3E21j8MpUKJJbUU+cV1e6xC3aSDbWzCFk89yDt9a+V1OGGPNJOW9nqzhLzb6b/XYQLyLRYW4QpY67+dSAukWy2UpuNSiwgc+U/41oW2K3KlKIdSgJE6QhI+tZrzFLhVyhtu8WnQy2s6VQNwd4FOCisbala27fyc+WM5TUZJd+/u+BKsP3BRqdQok8BKDWRCLie8S04fSIrQGItXTCXU3aiAASAo71GG9h9TWkhKp087n61EsmL3/T+TKOnnNutiTxPvB4iA1JnxuJB/Uivhf+NyxvW+3vM6ri4t1F/HLtX9WfSvSPDsYNfbW8IeaZRpghYkwCRXw7/GKl938QWbi22nw49d/WFAfyrr8M6HqLin8/4Rz62EoKMWz1d/kocJunMZzff/ABqCn4Floh5Sp2c5gA19HTa3bTTjjF3bOug+FvSpIJ/0jx9q+dv+Sh71Jzo6+E933NukbcErUT/AV9G7LuHWS4ACkHfar8Vmnn2XY9RqUcUHe1IjLSyu33g7id03bECdDKe8M/6RIH6VILw6xcSgOXd6SkkkpQgFQP3rMooJBBSADtWRD2lZDQkqgeESa86OatmkROUpb2NtbPC2be7b7i4cDiUBQccBkFXTbzrG1g2GoWV/DOJjYfnK/WIreYS8UXE26jCUmdJ38VAPBKSpTSwZM+Cu3LJ9EKiuPT/2cnU+qXtP5mobLB7cFKcPSSvZRK1mf1qs5yucGy/lvGcfOEWQGGWL92VKSok6G1K/velWRy4UpRJSEpnYrUEz9649+K3F8SwXsEzs9YNKDtzhps2z3qU+J0hGxJ5IJrjeXOn7Kpf/AOTWXSoPqf1Pip+IG6exHE8FvnWGGVXeFJuVtsp0pCnHXFGB9a5SEuBxzSIhufpXTO2W2v73FMIQGFEN4WhKdInYOrAG3saopwi+W8r+qubNQVBJgmvrtJUMKTZ40ou9kZ+z9LRzIwl22FwmFeAmOnM174/Abj4wTtuw/DmW/hmsStri0VpcV1RqEifNFeGMi4dc22Yre5ftXEtBBClKQYmK9X/hqx7DcE7YcqYhd3Llu2jEmUrcSgKIC1aCfXkVlqJOb6I9z0vD10tWfS/tVuSz2d5mfKhH7HuoB33Daoryl+Dq3ec7YcrKcUIC1mDvsGzXsDtqy9hWGdl2bf2jdXb6GcIuApTJSlUFECJB868w/hHy/heGdsGAu2jl6hKC6EfEupUd2zAhKRXh+GQks0up3+p15pxyTc48dP8AY97N27YEDQqd96xuqbZQsk7hPMda1g5Zf2ibu9MEjT4Uj+E0125w5wFC7Z92YEF6P4CuZadPJyufUwUZNcP/AD4kfjTobxy8UgjVpZkRvGmtVV4ztDSyQP7tTWMO4ecVuG/2Z3i0pbDi+8KZ222HpWsLmxbIT+y2AnyU6smnrMUfPlc0t/f9jp0uWXkxSi38vuRaltoZUru9AWZ3mtW2xBQuFd+40lvTsI3HqSTU64uyXxhNvB81L/xqJvbLCdJcXl6zdUqUj+0P38XFc6x41KutfX7HWsspf0v5r7m3dutqyHjb+tIT3olQVsB4Otc/U+248q4aeS7KSndU9a6CTZWXZ3ip/Y9kllKig2yUKDa/lHiGqf1qkJxPD7ZC0oyvg6QkSEhtzaP+/Xo6nFFxgrXBw6eUvMyOu/uIW5uVpCkgqSdjIHH3qKubtDDkltRKR9561b/25h8aXcvYTuJju3P/AK6iL7EsIK1OnK2DrVHJbc/+uuZQil+ZHQ5S/wCv1RTX8YQt/YFMDdKk1pZev0nPGDGGyj41KwZ8pqy3+PYQtAQvKWCrVwT3Tv8A+cqLyrfYNcZywi2byjg7a3bsNpdaQ6FoJndPjI+9dGCKWRbolytP2SnduF8hXaLcOoQVJW3bnbcgd2K5niNw2EqSNk7wTINdk7ZcUwrCc8X9s7lbCr9TbLEOP96FqlA6pWB+lc9xTNmXHWdK+zzBDO3hcuJH17yt69rdoxg301RQbjEFu2L7DSwkBSFH2qn396CVurSkb8+XpXQMTxTLy2XEM5LsEKXAUU3D+/8AtVUL28yuxJdyWypLfMXr4/nWyinyzGTt8E/2VuBvNNreJTJS06EnmJT0qo3GIONYneoKAoF5wgkyR4jXROyzEsv4rmNm1sMrJsXe6dUm4F445EJ2GhW2/FVt9WVH33nxlhxt0uK1H45cTqM7RtvVZU+hExXtFc+JcdZcbCQiQdU/yqjY6LZL5ZCJIjZXnXU1jKC51YXeoBB1FN4DPtKao+Pf8nDeIFpP7ebcUrQkFxtw79flFc8H7SRtJOiBwTF2rd5KFFKVAyNO3WulYNjxUlKkPGJ61W7TLXZ8h1DrT+PKVuTIZ+sbVdsKwfsw7mW77NBdkcpt9P6CuveqtfM5nFy5Reey/ELi9zlhTaHdIFylRjbYGT+lezOz29euM1Wmv5YdKd53015T7IcL7M2812AYfzKXFrUBqctzHh9E16z7PbLLreZ7ZWGv4o48lDik/EraKRsJ+VIPWuTI61EE2dXGmnS7EPdMOox3Fn0PMhld8+oADf5jTEOLfcKO9TKEgneJE1gucUyq1e37i1Y4VpvHkqKXGAkq1mYlJ2meawt4vk7vHnGkY24sJAKi6yNvL5YrxcuGUpttr5no4cyjCK6Xx6GR+7tUKKVuNakEH5hyKsGSXm7h9bkoJS2tXh67Gqo4jJl0rW5b46NZk/1lgT/sVZciv5etMQLWHW18oqbUAbt5KwIBPCUp/jRgwOOWMnJfMWbM5YpLofHu+5nZZLqEPAymBBMbVs29hfBXeueIiYn/ABrNb4yhpnu2cMsUEqG4ZEb+5O9PZzHiine7CkNj5QlLSAB+lN4YJ+1P6P8AgayZ+moxX6s2MRsbhvJjiGyrUb4OjQqTpjmareE43dnTaPIeUQNKXA2oz6cVcrjFcYcyoLhN0pi4+MS2VpidFV8ZgzIg6F4k+PFAOrmu/V4sUnBSk/yrt/JyaWWVObSXL7/wOVfXlvcaFM3TiFpACm21kz9q3re5uHUqSm3vTO27Ch/KoLEMw5gZdcJxe7SAOA4dvWo22zFi1w4vvMav1qidJuViJ681zLT6dcyfy/k6JSyPel/n6Fuds8TcbAYs7gkEDSWlTE1v5ztsQXj7T1pYXDza7VCCppsqgpUowY96oBxnFlOsAYveQHkDd9RMah61Ye1rFL+yzFZsW14620bMrKEOFIJ1xO1d2HDihppq21aOHLLJ+Jg3V0xzlljCFknCr1aZ/wCwVx9qhsUs8ZcuUuN4DiCwEqBi2WY/Sq/+2b4KgYhcDUPlDqt/1qCzBmjE2HPBi981oEq0vrG33rkWHCt02dnm5m+xaL3C8aeGtOXMSUVDV/0Vf+FVbFsvZicMjL2JgTG1ovf9Kq17mfHi4t5nMWJJ1AgpN04YPtNV5vNuaWkJL+bMSUoKOnTcuCB9FU1DE97fy/kUnlW7o6vlK0v8PwLM7V1YXNup6zU2yH2VIUtXdrkAGJ5HFed7rBcyt4aPiMEv0aUAAKs3JMD/AEa9A9j+KXuJ5WzneYjilzdu2VoCwXrhbhaV3ThkajtuB9q4PdZ/z2wgOsZyxxsDom+c4+9evGMeiKs87qfmN0UPGLbFhaqW9hN0lUb6rVY3+21czxhQZunO+tn21KQANTSgAftXW8R7Qe0BbjylZ8x0auf66uR5dapmIdqHaIu5cZXnbEnAlGqF3BUNuu/WuvFFd39P5McitbnMrm7ZSksKRocWskJCSJq5XALXZUl0upAN+Tp6natC9z3nxLKnW8wvvK30hZSd59RUpfZlzK32VHHXbwKxP47u1KLaSAkztHBNenp4qpW+x52RbpHNkvd2e9IShXWDFFOItOhHflKiSODvzSt8/ZkuGkPXCrJcg6u9sWlat+m1YTml55Wp7AsKck6t7bSB9iKcFG+RTsiu0kqbvkNKt0OeJQBUVbceVVFtyVFa8OQDITIdV/A1Yu0DFLe7xlduixTbqYKgVCSHAQOAaqb+K29umFLQmdyYk1M4rrFubWIBl1UIwxZCG+UXJSCZ9q3bBDQsUv8AwKmlkwR8Tq/Upqtoxq3eue7SCqfb61Jt4s1aoQ53RUd9yaXQgpnT3XUN9l6krZuO5ViBTAUkq1BI3BIiPpVBaFiHACu6IWobuJSQNvSKvi8Tbd7KVXJjbEUmCmQITvVGN8lDSXfCUz0jkVeRJtIINoxMYnY2z6UN3TpWHUtqC7SIJUANwqIqd7ULtpGCWDlogl39pXaFkmdhpgx9ahmbq1XeC4gqUpSCU/Wp7ONuxcYbhzjjTjin718yggaSYO81nNtRpGia6kVH4txCAtBcSNMEatk1nRiuJt4HduN3r+kPNg/mEBMgxFMu7QN2w7tp5RIIUAoEzPtWm8l1rAbtlQUNbzcQJ08gTWXU+4N06Of53xC5uEJQ6sLRq6gSD71UW40rn+7/ADqezI7q1oWsFaVxwR/GoFskBYAmUx+tXhurZE+Taw2O+II5Tt77V0DDcWebZSlNvb642IbTVAw0JLjkj/qzG8RuKtduoN6Wu9aJVtMyJ96JyaBFqTmfE1NBAWgAcQ2kfyqRYzNifdIQi6UkDmDH8KrNskDSF3CEiD8wVH8N63bV+zU+kF+ZP7qCf8KjdsNu5e8ax+7V8D3LzrMWyZhZ3I6/rWBrHMRW3C759aVGI7w/41oZmdDzlgi2KpFmiSlHvud+a1GWtLYCvi1qUIgNpH2OrmnO7LUulKyaRi953mhRcShPJ1Vupv34CguSRPJJioayt9Cpesr99P7uhaEx781Lt2alNgu4K4oGP/1+NvYIO9Q7sJTiyQTiymkp7xYjndW9UbNHbHb4OV2mDNIurokhSlmUIP8AM1p9p+YLbDLAYbbWTtnevGZS+XAG/LcAzXHFKUVElRJnmqhHfqE2kqLPddp+e7m7TepzJeW7iPk+HdLQR7aeKxWHaNnbD3e8YzJemValBx0rCj6zVbpetamdnb8m9uS7u4RZZmbaZW5CRcIHhJ/zh0rvnZ7jFs5mrB7hpaQhN00sGeRqG8+VeFJPnXqL8Ivae0cyYVk7HE2pLF0yq0cW0hSnElfjQoqBnnaufNhjKDrbY0xzcZI+l19ibLmH3DnfAlaFxJ42PWvnDiVw2q6ebSpKXApRUOvJr6p5hxljCcMuzh9shlbTSg3pQNoSdyIg/WvnpfdpWPPuul/Et0OKSBpTGyttoivmvBoRWaajL6H0mul/9eLaPPfajifwOWHmkufmXJDUA9Dua4UTvttXdvxKZ6xDHzheB3TrTiW1LuVFLKEqk7DxAA8dK4Qea+rgqR85mdyNq1thcKSk7SvSZMbRUxj+C2eHYXZ3Vulet75iSYO3SoJt9TUQBIOoE7xWe8xW8vm22bhwKQ18qQAAK0dGLuzHZLUm4SUrUgnaUmDXWezbD7K8ucMbv3rcIub5bbjTzWs3ACJ0gxG3qa5LaqbS6FKKtvITU4xmLGsDDasNu9ICytKi0CW1RyJ4kUrWyGdF7ZMPw7LeK2N9hGHM2yEXWqW0ASAAY2ro+V7w3eGNrQ4FSAEq8wRNebcXzNjuZz/z5i/fJbOoawBJ9IFelex28y3juV7OxsrFKbxllKC+88shZTsqQI00p0uAumiba70ISUrOmNt9h60wa1LUgqIMTI4q8MZQs0rQr4dlSY4S+sD+dNVlfD1uqbNk4hCdzouTJ+6aUVLk0q+CsWPfBhQKzJJ3HNJTlzMJcMj1q3WuWsLDKj8DiCVAwZuUGfoUVgVlu0LoLVhfITG6/iGz9I0impST3CCrk38UuLn+gWCvPKVCFrQhWozHMk1XXsaxNt0f198BO6PzDt+tW7F8Otk5FsLK6F8PhX3CgNoStZ23BGwqqP4K3dKC7MXmhI0+O3AUT9FVeZU1uEW62Q8ZnxNqFDEnySAf7RW361hVnXG21JKMZuBO4/MNYzhDSApN4+8wf3dVuTt57E7VjbwKxuj4cR1GJ8NuvYedYqUrKSuPBvPdpObWkpQrGLlbY3hRJAJ8hWE58zIshSr7X1ktpMn6itC8ywQnSzfOqPn8K7sPaKw2+WrsMz8ahKkn5VtOiR5zppuTvclLekbV92g46LcqK7VZH960bP8AEV4txx5T+MXzziQFOXDizCQBJUegr2LeZSvXUFpF5bKUvgqK0gepJSK8m5gyxilvjV5bqQ0pQuHACl1MbK96UW7thJezuV0nrzXozslzO8jL9kyMr4I4hlIb7xVmCte/KlTJNcEVgGJoSolgQj5vENv1r0B2SZbxW3yxbXFw0yhp9IUkruG0zv8A6Uj6iqk6Rnte52S3vMKcALmXMPMjfwrA+2qnIuMBtyFJyrYaj/nujb/WqJQC0gNm5tEniPiEH/zVkXbXTziEaWykcQ8jf23rH2vQ3tMsVvd5cfJLmVbYbf8Abu/404Ky2tSlsZe7kAfu3Kt/uDUAlt+3T+Y2Y+kj9azWxuHkk21m+4D1S2SBVxySi+BSgicaOXlrUF4XcqSAPluo/ik1LZQbwBOZmF2VheIeUlYTruApIGkz+6N6qduziLBcL1ldIE7SwofyqbyYh9ONWynWHUL1FUqQR0PUitoZG5UJqo1Zp3yMj/EOqAxlC0uKmXW1J5P+bRasspoWpxnEMVQFAapbbWP4ioHGu+F/cobacCVOqgEHYTt0pwuEssuFSkyB5DnypPI03SH0rbcsV1YZZUyNOOXqAjzs0mfrrrQTY4I64WWsduJWNu8tIg/RfFRNvijfcuBYQUkiIPArCm6QpwFDgn908Gpc2+UHl7WmSOL2eFYTh9zePZnYBaaU7CrZaQNIPqa8L4rduX2JXV44oKU+8paiOsmvUna7jirDJGIKLsuOIDQk86jH+NeUFSSSetTDfcU10xSEBJqSw9sFhZJjcdK0mkrWoBtJqYsTdMIKS6AVgEQdwQa0tIyNqxZWSQGiesxVlwuwu0pFw3ZvKA4ISY+9Q1rdPlUKuDEyTNT9jdXhb/LvFx0AcIEUnUlYHbMs5NzC7hzTqTZK1JBCTctgiQDxq25qYXknNJ2aw8LJEQ2+2fr81czyneuIaLTjhUBwKs7b7gJKVqGnz3rGNLk6MdtFExI3Vrj11aXa3WVtLKFIC+D14rO1fs27o7t53Urb+0MR96xYuvL68SdW9cP2zxkqKU69Z9N9qysWeV3EJdcxy7Sqdv6p/wDzV0wdx2Msn5iWVi1u5pU4XHFx+8tSh/GnWeLPIWoLCdBVIAJEVgt7XK86X8yXKY3SRYdPL5q2E2WVS6UjMV4Ejcr+D/QjVtSap2iUTbebbpy3KFYg+kDwgd4SI9q1mcb7laVh1WvkLkz/ABrWRZ5P1Br+kt0Qd/8AoO4Hn89STWF5CIQHs33yQYAIw8E8/wCnSpvdE3vRvW2eMQbOlF+6UjjxkRW+12hYts38Y8oDf5yajmcA7PHEqKc3Ymd9/wDm1O3+3T04BkxJBts2360x+9hwT/8AtKhuVl0mTFvn3G1OHTiVxpUflLp2/Wt+2z7jzgIRiT8A8azUTbZeycCl5WbcRG0QMOSRPv3lSjeX8jBKSnOWICDJ/wCbU7f/ABKOp+gkqdMs+Q844/fZisLe5xC4Ul64SlaVOEpIniKme0vH8bw7N19ZW2K3bDAWC2226pKQI8qhsj4Hk+2zRh1zZ5lvrh5FygoQ7ZBtKt+p1mPtVu7ULHIyc03TuYcxYlbXR06kMWKXGxt/eKwf0pzUpYytO0sr6ltRz+3zrmK21Ns4zegEyYfVv+tE5zxvVqVidwogzCnCT/Gtz4Tsr3H9I8dn/wD17f8A+co/B9l4YUhvGsZcVIHiskJ/XvDXE45Hsn9TtU8a4Qms7426ghy/fUenjUJ/Wnt57x9lRCcQum5PR9W361msWezYghzGsXQofuizQsn/AOIK3BZ9kxTqXmTHkrG8fsxv+btS4ZY7p/UUXCvy/QzW3aPjIakY3el0bSXlGu7dhuOXuNZWcu8Qu3bp5NytBW6vUY6DeuButdmJT+XjuLhIMSqxbB+vjrvPYM3gCMrL/YN3c3LHxK5XcNBCgqBtAJFdehc/M9o4tS4qlH1OoIIWIkK9qcTHhJiaaCoGI26GkVajseP417BNDpEaSTSCpWCJ34pv70rMbc0UlJTBPsaLoKEsgkAGDE0Q4EkpIVTdYUsmJ3gfSgopJkhQJ4FAmZAfF4RQhRlRMQegrGoqnUEge9FOrcqP6xQFIyAqjxJP0pusf3Z8h1pqViYCjPAHmKW4JkdaCapjiVkzAEGmyZIPiETEwaBMDiN6BKtyFCOpoKdkkYB0jYjrSkjYmgoKgHYk9T0oTq6fWoJClRCpBMelOkTzMjY0wSAdyIp0idjNABP95PJoHV8pNCCTqOwFIKAEEigByDETAoSI5IIoc/KZjaOlEbCI94oAJJO8CkoyQrYewpqVQJNIgg8ieKAHFUbzuaOkESRTCSQAAJFHxnj60DCk8TxFL+FAwE88UpEc0CHBSeABPrTwoDaNuorHyKQIHHIFAG7YwX0JAIOoAV3Nrv1JT85bSBI7yNo/0a4bhygm6ZUpcALSTO201223xezWytTbyHQIALZkeXSvnvGsji4/qerpIt4tl3DiCArEHgbduARvrUTwPIioLEgw2tWuyYdEb6kqM/dVTV7dsG+fV34JUudgdhFR2Ispum1otnm9ZH7xIH8K+Wzzl5jkv7HqaZRio9d8e8iG8QtQNPwVkmE8dyI/Wo69u7NCVLFtZJAiU/CtkmfcVnVhS75GhtxBMQVp1afptvXmb8a34g8N7A+z9zC8OxS1fzfjSe4w60lXeMtx47hQgjSnYCYkmphHLmmoQ5/Q21GXT4YObRyP8fX4xLLI+DXvYv2dfBjMGINKZxfELe3bT8I0rlpJAnWoEyegr5eOLU64pbhJKjJ61L4r+28yYncYviNwq5vLxxTrrjjgKnFkySZ61t2OTcRulJAtkkHb+1HNfZaTBDS41Hv3Pl8kpZp9bXJXmEKU4kJTJmr5knBLcvpvMQYdWlt0ENpbKgr3qRwXsxu33N7FGoHcl5Iiui5e7PMVs09yypCASJi6QNR+9bPNFM0hjae5uYbfN3WNC6trZ+EtaYDZBHkK6l2UYPfYnmLC7Ruxfl26bSTEHde/8arWDdnmJNOh965QlShKiLxBAHTrXZOx3LL9nnnAnE3rTikXjSkp+JSvhQnad65J5OqLPQ0cF+IhR3T8ZV//AEZ7Cc13FgjSoMnDUKCfl7zS3HqSFV8orVj8yUKJ0kAdDIr6xf5RbM+H5W7F7bCGC45/STFFtuNB6P7FvvNQ2O4WUfwr5pdnPZ3j2fMbawjCbdTrrviWoiAkTzP8BXl+GOKhKXaxZ3LNqHSNbA8LvsSeasrKzW9cOqhKAdyT5V2/I34ccXxJHxWZMR/Z7Z3LTbet2B9hXoLsv/C5a5Sw1F5j1th7+LQPAbluGh0Ud9lVasUyheYHaLu768aWjVoaYs3UPLg8lW6QKnJ4jGU+mLo7Y6SONJz3Z2j8LWXm8B7M2cAw4O3DGH3TiNa1DUNQCuB05+1doVaOOJW33SoI5CFCf0ri34W755djjFp3dyhxDzTml5KJCSCNtKiCK9DpuIbEoEj0rz9TUsjcty9RmyRkqK5b4bcm37p1laSIIUkGQPLeK2rjBFqeFw2XS4WGkFpKQCAB1JPrUw5ceBRUIIBMfStS5xNNvcupWQkIbaJOqORTjFeU79xzSzZZzVc7mK3wi6CNCrRbSYj+0SCfsDT0YI93kLUhCCP+0kj9K3P2klLSXO9BChIjesTa1XKyGw6euyTWflrZJE+ZldtujSv8HQlAQ7coU2VbgBRUr0ma+Gv4oRbYt275ou7dlTTVxjV8rugqdP5kc9a+5N+u8T4U4deOhB3KWlT9Nq+CH4ihjlj2vYw3dJftVvYpfLQlY3098oz713eGQmtS7VbHJquYW7Pfn+TGyoyLLNqhcuNtrYtkqSkgkypR5MwduRXvazwOzbQpsKc0gBIlwk/U9a8I/wCSdFzdZazjc3Ly3FrXahMn5UjXtXv1pi4b1wykwedYp+JxlPPsehmn0bJ1sv2QxFnZqUlotpMbTG9SVrZMMtlkSEkzGo1Gjvk3oQUJgp1FYPhHpUg44mIS+nVHST/KuXFGSd/3OTK26VmR9DLTKwhsblKTtJO9RqcLw7vw+iwY7xP72gSK23UTarWq5CTqQJCCeDWHuSpWk3y5mdmf/wCaurUY8kulL09UZY6je/7mJ20sO+D4tm0uITpCgI2PNeQv8o7mcYT2TYVl5LyEO41ia3yjqpu3bKt/ZS017CeZto0qfuNvIJFci7auwbsq7a38Mb7QhjL6cLS6GG7a7DKSHNOvVA3nSOtcUsM+tOTVL3o6Fc49KtnxA7S7LFbJzB3Gbgt6MGYWQrf5lKP86q4Rmdh42/xiPA0Hp0giI9q+v2VPwn/huxLHc32eL5EuMWTgmJs4bZousQcIbZDCF76Y1GSf8avWE/hd/DU1cXjo7D8CUWLNxwF7vV6tEQkyvjevdhq4tKMabMXp8iTyLj/PefGPJ/7bvsXtGcQKF29wlSiO7HQDrzXW8u4azhGIsYilpKH7d1LyJ2gpIII+1fUi37HOxXDu4/YvYhkhh1PhCl4YF6R5bk1eLTIvZ3gaC/hPZzlW3fEbt4SyJUfUg1yZNfC7TX1+x3YdNlh0ya3RT+2fN6b3sCxfHiouKxDLqHQiNypTaD+m9cG/CZirF/2yYCyAk6Uuq+obNelvxA4k5hvYhmy4s2bVnuMOUlKUMNgQVJTAGmOtedvwnY7dXva9hbD9uwsOMvAFDCGyhQRMykb7bfWo8OjHrm4O791Dk31NNVSfc9rPpaK2xp5mTWMNwqRpjpNY0PPqe2tWByU6gTzWRRxFagChhCfJLcE/WuKEUsl9Xf0K9tRr+5lxJLacWvXtQBJQD/qCou7BSrUGyQOCCBP1qRxk3LuLXSdNuhCNMK7oFcaRyTzWmpvE1tjTfwOgDSR/KlrVj/Ezbl39BaOUo4ovbj1/gYy+VoSFraTJj+03j0rWv7pi2t1i4ft2xBgrUKc2nFWXlI/adylLYHlBn6Vq3a8aklGJ3BSpJ3JmP5Vyvyepe0/l/J1xU27VfP8Ag2viPiOzvGH0rCk98IUFSCAU71zC/wARtbW6Dbq2wXQopIIjYda6vcXl9ZZBxK5+Nd74OoSHByJKRtVNacxZVwVjGbzuyCY70jSNtq9bVuKWPfscelU3kyUlyUm7x61SrSbhmFAHcgcCoXEMWS8koQ4lw7fJ7fxrpzy70uFIxW80qJMd+oR7b1XrxF+tSirGr9SgQABcLEHz2NcqeN/mb+X8nS4ST4Xz/g5RiWNJStZTcEKGwjcRT+zfES92n5cY+Imb9CzHBiaumKLxJbLiUZgxVGrlJvHIP61rZJVjNzm7BsPu8bxJ62cu0hxtV0oggA8/pXVp3iWRckTjJRd0Ub8ROJfDdp2JMONJJCWEpBUAT+UmYri+L45bONqaAcbTMEJWkkb816I7aMTxRHaPidsjGsSt02waQ22w/oCUlpJI6+dcuvsVxS0Ki1mLFCpY3LjgUCPLcVs4qT5+hzY5SUODlgxBkJfUb9JUkp0hwgHbzFV69xZ934iLhspSehBP6V0nEsxY9bBam8wLICTIU0giT9KrqsyYzcjRcP27qkyAo2rP6+HetFjSfInMl+x++SnMLTyladFu6YkSfD/vqDWULuXUof16lqVE8yTVv7Ort7EcxKCre1AVbOqUG7dtBMDiUpBFVS2wxq6uHrl+zZOocFkRz0qs76McYsUHbciOLPdrUlZhR5EQB9aqGO2NsLs3CSlSp49fer8rA7YNhCLdob6ipQOqfcHiqnmDBbRsjuG2EvF1MqGseGd+tcUGlLZmz6lHYZhl1akpTMEJ5PPqasFv3a2UrbdIhYia1cAwbC7i7l21ZUSnedRB/Wuh4ZljLq29NzY20EbAah/5q7+jqXJzqcvQuvYdbs3WcWCEzDbqjtEbdK9edmlolnNFu4NIJZdEJ+m9ea+xPL+DWmZ7di2t2G1XAU0VAFRCYnaTsa9UZJwzDrLMzLVkCFIacKldVcVxSilrYO7OmUn+Emq7HGcUwyytsfxR1u38bl8+okknlZmtL4T4lxYKSkaRsetXp5jDL27uHri2tkLNw6V6WwCfGaejCstjWXLK2USAdSkiRXlZcKcn7X7nZilLoSopgJSJbGyiOsTVs7PXHDjWtSti2pIBj+6aw3zGWLVvuzhzLinFhAHdBQHrFW7IzeHW9+hjDrdlkBBUS0ju+h5q8EEskX1cdgzTn5ck12Ie1funmJabcVoiYQSdXsBW9ZoxPXKrG6VPiBFur/CrJ+Q02grRGlMc7n9aehi3KgXLZmFD95O+1L/j72EcuRRtJDlMvryZpctndYvEqWgiFARzBqtPt3TjOttl1poL8KlKT9uav1iWP2GVqab0m4MgDbitFx9phtJaQ2lJ4CQADXXrpwhKDaf5V3OLT5csZTUVy2UMs3DpUp/Skckh1G4n3rAvDLdydQQVpVI0PoCv/FxV3ubjUgluET5CsWt14LZNv0A1RyK4lqIPs/mddZJLdr/P1KA7blboZtXGllDiSpBfRMhU8zVk7XLcLzHaXp7sJNkkEqcSI8Z2g7+e9TT1g2LRSFISkEifU+tb2aNP9J0gtAlNo34iNzKlV6GLKpaWbrZNdzjyJy1EFfZnFL5mFNFF4yFDxSlc7eUioTE8NurhxZU8zpA31OAGu1Xga0qUESdRkR7VBXt8hq4caS2kagAkFO6q5Fmi9kvr/B3eVNd/ocGxvKeMAG5s32XG1GD+cBp+9Vu5sMZt2Q28/YKCT4yq8QDHrwK9B3mI7aFEEJ322AjrUSi5ZumlpQlpYJVPStYZcfpv8f4M5wl/UyC7Hi25knOVr8RZF523UpIQ+hYCQyvlQMDevP8AfPW62FMjF8J1pTpIVibCd/LdVenbDuMOyFna4aabSDhzyvCOSGl15xRZ4anDGC5h7W7aTpLY8vavXi4yhFtHl7rIyhX2m4acUm/w1txW4H7Ttzt1MhdUq/wDEnroO2zuHOIUCkEYgxJPp46v+YcMwd5SCbBpvSdRKUx9K57jNvhbKgQyjStROlSRtXdhSfBzTk2yKxDLmZ2kqcGGd6kdGn21kx7KqdxKxxdHZMlleFXLlz8cF/Cob1LCeqtNQCsJwZxBfFq2UkwNv4VZHsIs19mmhYJa+OiNRmPKvQxR6Uzlm16HLVYXi6mQu5wa7aBnwm3UI8ulR77TrKwgtPIJ+UKSdt+Kmv6M2pQtbLmkSQAFRUS409aOi3ZxG5UNzpD6gAahNt7kyVs1szY3iVljtw5h7gbWTCjCTPhHnUYjM+PpV4rppSyRBWw2f5Vs5vsnRii7tVyhaVhP9o4BJgcTUMWllzWe6407OpMfrTlKSb32JpG/b5wzEbpVqlFjoUZJNo0SfI/LUu3mrGntTKrTCnSONVg1M/6tV1Fv3NypwaHSEpJCHEqO/wBa3re4SlRdatVBSd+mx+9OMminFLgvrmYG7fszfvrjCcNWUYmm3LXw35YlHzaQRJnrVDuc6YU253RylhS1q30aFo+uy6urKHXuzTQ9ZKUTiaHPCgkqlO5gVUXLJC9Sjh6+8BhBWyoEfpNVNuNCVBwzGMGvrhKXslWDZ1eItXDydM/U1L52VZowrDThzC0OKvrgO+LVEADmoeyty1c6TCSpSUlOgiTPrUlnTFMQwfDbBdm8hJev7hDqdIMjbzqG+qDsS5KpeXKktyogbxPnWEr7zCLpciUuNmD0iazrzZeqStl5lhwjYSwmNvpWP9s9/hF53thbQh5qYbgGZ5iskkau/Q5Xm1CFrU8VhSwSDt/Oq00rSF+qYqyZovba4W601ZBtSd9SVEiJ4g/41W2uF/6P860hsjJ8mzYEJUvUYBRB+9XCxdZKBt4RtudhVOsTpWs+Sd/uKutmcN7hKl27yp3P50fpFLIwWxIIuWRpEiImOYrdtrhhSgUlII+5plicIKSoYclRPEuqIrcZew5MFvDmdyQT4j/OounTBMsGLOIYasVnTKmAdzHnWoxiaEpQwFcmSBUs7dWbiLRbtoy4gMJELQTp9Oa2GGrBKUvow+01f/igaqTSZfS2rRqW1464CoKABPPHFbpx5u3ty64JQlMlXSK37e4SgJU3b2ySfJoAH9K2sSvnvg1sFtoIcG47pIER7VOz3DofLPN2eMadxrGnLpbgUCokAHj0qucVZ87WymXmbgoSkPqcIhIG01WDzV43sRLkc0nUsA1nNoQNU+GhZaviUBKUKJ4ChtU0tbiR48PtSDuYRuP1pSdMRXVTO9SuVcfusrZjwzMVkoh/Drpu5RHUpUDH1AqMdVqcUYA34FNTsRV8oD7pYErHe0XJNlm7Cxh7mFY1hybu2Ub9pKlIW3I2naDII9K8E4rkTMnxt13a8OX+YsAC+bJO59a9J/gTzerHvwrYQz3mt3A7m8w5QiVQk94kSTxC68xXVyv4+50yFIdcO5kTqNfM6HHDBrMsI9j6PNKWXRQm39DkOe+w3tVzDjb2JMYdYu26QEN6cSYkAemqqn/9nvtZJIbywFgbym6ZP/mrtt8w45dBSVqIUDqKeBUPd2Ttq2XAta5Jkjb619DHNBbHhSxu7s5UPw79si062cj3rwPHdrQv+BrA7+H/ALaGSoOdm+N+EwdNvqj7V0Vhb/jAdeAWTME70/KKMabz7hT1vilwiMStZSH1AEaxsRwZ8q0jKMnVmcoNK0cwY7HO1S1u0N3HZ1mAGePgHD/AVKYx2YZ7t8LdcdyTjTatMQbJyefKK9EdreI4212h4/Z2+JXYbUpUtsvKSEnSNwAfeovBMYx22w9hLWJYkCkqkuurkfc1M5Ri92Uscjy+1kbNqdQusrYwyPDuuxdHUeaa632Q2eOZfxK9thhN8i3YfSpJcYUlOkp35Fdhs83ZsnuhmHEkR0L6v4TFTreas1pZSXcduykncKdJn6UdcH3DyXfJksMUubkIBbKUdZEACpI4o2x+8QUyN61VZ1zAygTizy0QPCTIrXOfsTB0uXQWQdQCmkn+VadUZdx01sTFtiSHmFLLiVa1SIjapFq41JTCkyPXafOoe3zU9eMhS3GkrkmUso/wpHH8VbnTc2rojhdqg7fao643sxdMluWa+UFZdtLlalaFPuoJHU1GWtzbhASkgRttzWXMONXzOSbDEbazs3FLuFNrC2UlKRHIHnVbbzPdoSP+aMKO8+G3j+dbzipNOxRezRYwph1CiYV09jWs88GFIHh0kbKiKihmhaNRGC4ekK5AbIg+m9FGZWg2C5hNoSONlf41n0JlJv0JNq6YCVkKHO6qyG+sSwpxLoJ6z/KoxOYbVTag5grCgog/2q0/TY1qLx/BVhSXMtEAiNrpzahKiOGZ8RvEPIUhtaQPTmvCePPoazTiK3SSE3ToiP8AONe1nMewBlOg5dfUFHxf1ojb022+9eIc2KaXmTFCy2UN/GvaUkyQNZ69aVbmkmvLJPDswYZaoPfNKUT007Cu8diOINBCcQtWxpU3tI3O52NeX5mvUvYE/k8ZZtkv2uKi7SmHFpfRoWdR+VOmQPc0pq1sc75VnXxeWDog2bUq52FNTa4Y68grw9gTsDoHNNacyq6f+k4q0BEktoV/Otot5X1BVvjGIpTB2NsgyenWkkdLcK9k2GsHwBbIbVhtuokzJSN/0rG3lfAXFGcOYSSqZQI2+lZrVWANK0uY5cp97Xj7KraF7giNRYx0ynjVbkfzpqD5IW3cj1ZYwsq0tMncwAVEjbz9akstYOi3zLZNMaktlRnUokbA+ZpNKwx1Slpx1Eq6FlYqSy2i0RjNusYwzcqC/C22heo7cbgVUYPqsUna2IB9Cbq+ebN7eNK1qAUi7cSOfIKplvg35qlfGXZWDus3CpP3rPd2Fmu8fuGsZtQpDqlFBKgRvxxWeFLZ/q2K2WpX99ZAH6U3B2F1sa+I2gtrVa131ykkEAagSffaoW8tXLZDT6Lx5ZcEypls9PUVMPWr5Cg/iVg4SPlD+0+5FaLthiL9ue7vMOJRwPjEjb60mmzRtNHn78R+YXGsIw/L6XELNy6q4cPdISoBOwEgDzNef0sLcMpSSD1r0F2o9jXaLnPNSr+xYwxdoyylCCcTZEgcwCrzqss/h07SJKk4XYED+7iduR/46StLcym1dI5ta2joTHcKE7yR1qTbw+8CUrdYUB6Jir+1+HztISsI/o+haz0ResH9NVbCewztGYJ1ZTvXtJ3KVJXH1BNZyTvgWz4Oft2NyCVt2y9vIVIWzOINoC027oWP3Y5q9/8AI12hNpBGR78pH7xZ1fesjPZHnNKis5IxNYSNW1msgH6c1aVR2EjHlPFMEssRZ/aNndPNrTpW2V914oj14NdGFtZLaDrGFpLajuDdLCoH0iufvdnWcLFAdRk3GWoPhJsXBP1irrhWHZsbw9pFzlzE9Wn9+0cEn7VEem/aH1SXDOYZms3P26+9b2NwlgqPd6wVfrWJhm5BADCpO5lMbVK3Tt5b41dNvrdYWhRlvURB9R51J2jz7kJcvHDHAJraCpbDlyRDdnduAq+HMEyIH8aem1uFA6WT5RHWrXbKShYCLh4ECSA4RUhb4oWyYunkwZgLJqXHfkVlJaQ4galskLTtMdKkLWxW+kLZbUtIE8cGrV+07Z7Wpdw4T5lZ2raZxK2tWgA8uDyNZEmhJBZV7W3flTSW1z1CRUozYXakwWDpHImCKsDOK26lygLSB11kVIMY+1brB1uSTxrJ/nUTfStwtor9taXyz3PclH+kkxW29h2IMNSq1QEg7kbn7VPKzMfCQ86ocHUswPpNbtjnC+tXdTF4tKlDY6z/AI0k1RVSZo9n7r/9LMNSpohCLhCtUEDmrR22l1vOd0taVOa20GQCR8orJg2dMSfxC1aViD6l96hMKcMHf3q0dpGO3GFZnWgPlGplsmFEfu8TVS3x0VhThkb9UcMbdu5CU2y/EdoSf4VtJXdoWUOtuQtP9w/wrpTPaDiiVaUXrqQBAh4msg7RsZQ53LV2+kq66zXG4qufobKM+EjmVreeOCy4VEb+E7Gs5UtRlpLhUfNJmuoW+dsccWUoxF1RMzK9/rRbzPiDiVXC31H90wTBpRUe7+ge3Hajmlsi4cnU05Ij9w16X/DF3jeVr9K9Qm9UodOUiuXLzjfMLT3CyElXIUf8a7T2G43fY3hl+9euqcUzchGpXIBSK6tE4+b7LMNUp9Kb9TqiF6IPUiilwkGYM00SNgqQP4U5GwKjAr2DMcVEphYHltO1NC0kQSqQdqXzDiTzsdqClQRtvxtRYDuCVAQDx4aW56/pQ1qJ32n60gfmCiRO8EUC4Q8GE6eaaYSQYj2pusCQFDekNhvt7c0OuELkdqIIB+h8hTtXiGkb+dYpREARPn50tSgNlAmgdB8KvErcjaaKtI33nkU0KCvnAigSkgkDf+VAyRIgyOm1IEwYMUwmePmHNHUAQNp9aggeFyNxsKG3B4oEyAZmkVbEnb+dAD1GOAKbEKiJMdKU7atNAwBq6nagByTp2iBSkng03UnzoEAjaga3MhINLZQ1TvNYw5tp8v1rE9e21uQh+5ZQpZhKVKiaArfY2DCTOuDS1wklJ5rXRd2y1lpNwlS0CVJ2kD1FZWnGnmytlQUOJBkUA1Rk3PXagCJ09axXD7dpbrunlFLKIKl6TA+u9Mtby2vmhc2byXUK4UkzStDSNuSknzoTGxG5rRTi+HKuhZpv2Tcf9mTBreB21Eyf4Ci+464skcJSly9YbVuC4kfrXoBNpbISEpaAEACNq4DgX/3zthxLyBzz4hXfmgEvJU4Ad4Ak/wA6+d8ZUZyimz0MLaxKveV8q/rFwrQdSVlJPr5VHX+I29s82jvEoWUqAjmpbFlsWl68fhbZ0rWSfyUk/Wq9e4rYrUbl+2s2GbcFSiu2biAJJJI2G1fMzxY1JpSPYxSm4KbW1epzLtc7ccu9jmRr7NuZHf6vboKW2gvxPOkHShPmTt7Cvi32vdp+ae3DtCxPPuZ3iq4v3T3TWo6Ldn9xtHkAP1rsv49fxYK7dO0tWX8t3Q/obllSrexQ02lKbh/hx8xzMQn0E9a83YVjVkyQDaD1UE719D4Z4e9PHzJfmf0R4ufVPVZLfC4LDguBKUhCwyFKnk7xV+wXBlgCLcJ23Mdap2G5+wWwQjvbJXUBQT5c9aueD9qGFIt1O/shBbQnWpSmpMdP416Txye6I6ol5wPLqXAg6UaTyRVtscDYFylCUpBT5bVQ8K7arFtTYbwqdR0JBttp6byd6nW/xAYXZ3K2X8vpW42ooVNsCJBg9ax8mV2zXzYrudZtcKbTapUWkASPXeui9lOGodzhhTIcbt0i5QouaSdMGZhIk1wBn8QOF24sE/sKTflZZa+HBkIMGR05rs/YLn45zz9hlqMum1bYV3i3SwlCUpn/AH1GbH0Y5TfodWgn1540zpn4oshZI7WBhuGZv7U38Pt8DU+oIs8IW6oF5KQSdawCYQI45NH8LXZ72AZNfu8OyfmHHscxRsfEPXVzhDbKkpECB4yOtSnaJgGCYjmK4eub4BC1KDgDw+cCATPSaH4cMuHDsVxh+0XqbW0oKWjcAlaY/QGvnsOXG8ThJVfa2ejhwNZHJvm99vsd7VlnKtxapxtKcWcU64bcpHdIJhOong1kcyPlDFGS6/g13cJBIBduwB5cBNStta3bOW7Jtu3eWU3KyqG1E/KOnlW9aNrKChxhbW8woad/Y71zZYRg10wT/SyajLq6pcP1NHI2ScuZXcfcwTAk2xuQEuFT7jhIHHJq5uNMhHdt2jUxO4JH8ajsIUi3SpLqggzBJgSfvUiu+s7cae/KyTBAQTBrZZJOKtL6HFnl7e1v5gaSsNKUploFO2zYFad3eXpu3UIbRpQG+EAz4aj8y9oOA5bCG8TTdaFq0KW21IQY6zFZEZis7mzexvDVJuLNwIh0CEjwgbkxG9dNZoYruraMoK5dbjsSyLq8iC8sbdNqwquLouhJedVHmskVUrDtNsLty5s7mzUxdsg6Wy6nQ57L2+0VvYHmcYza3V+MNeZbtXO5dC3ATqiYTAk81nlhqIRuTdfE2jGKttEhfqbdeZcedVKFjqY5r4Bdvz6x2tYm4klZGJXpTJ8318elfeZvEcOzDauP4XduqRbKh9EFDyCd40KTyYMTXyj7e/wb5kv8y32bcCvkFt24vLsWa3Q46EBalmSkQk6ZMGt/Dbw53PI3RzauKk49K4PR3+SQDruR85PuhQi7tmgof6KzH6179bUG1K1Hbg+teHf8mFlpyw7MszKwrES0LjEbdxSnEBZWC0qIPA3r2rh+E4m0kC6xo3Dkk6lNJH0gU/ErlnbR1Zenu+y/ZGypaVOEJEqFYbl/u3GmVJ3PJPlSuMHfDvejFngYACEJCAD5+ZpyMEtwoOXD7rquveK1bGvMWOXJEZwVNmV91LFitbnCnW0jr50mHoSVPKAkTqrYdw9v4IstmB3qVcDw+1ZWrG3NufzVSRyFRt9K7s2K+netjnjlST+JE3N80hrZxJnqeKrmI3Nt3xUt7YJ3JSSDVouk2luAg3DyhxAdO1QtxijLLv5TrvhBJ1LJ3+tcEsMeWz0NO5dNpHJOzi4cdzH2ju2zanWXMzBLZS2qfDatV0zBrJ19m+Um0eKl2biAkoIkmNhNUrsvv1DEu0R/WCF5teETwe4a2roFjiCG2r+8aaA0WS3JA6yK7NNjSyqm+P7F5pzWnarbb+xGpwa4aGk2pQNU7gCPuayXtliKmFt4fh7rpTBKtSIJ586228bD25bCd4MDk1tXGOBOnvNKUJ2E1xRxxXc1c8ySqjj/AOInDcw3/YVmezXbt26nLQFTjz6UJTDiTuZ5rhf4RsJvrLtiw5d3e2TqE2tzAZuAuD3fMADzrtX4rczLX2JZoIUoJca0pBGx8Q/wrgv4N8Vdc7YrENJQdOH3aiVI1HSETt9hXqeGY05uS2o5Mkpucuvmme60uteFZkkAcCtopKtJbDhJ8kmsYv8AFHGWyi7W3rSCQEgfyp4cxIKSXMTuDuOFQOlYwWHrS6nz6fyKfW43t8/4MmKMvG+uSi1fcJUIKUGCNI9PStF8YmGgGcPuNht+WTv9q1szPYqjFL9xvEblthtQKENulIACa0k4netJRru7txtYStKu8UdM+ZmsdYtO8827u3/nJrpcOR4oyVce8kAxjBgrw+5mAD+UYJrFcYbiT7DiFYZcEEQIQZ4rVQ4FuqV8c8ogzCnlc/eg6/cOK06ytMT/AGhmuWtPz7X0OtY83al+j+5LXWH3rmR721+AeU+46FJa0HUQFJ3iqZdYFmALDrGC3pkHhrzq2XjzychOvN3Cgv4tA1lZ41pkTVDx28u3nNPeqQ2PETrM/wAa9TVrHULvg4dKsnXkprn3/c2V4RmmJGBXpKRz3BqHdwDNCtf/ANzWIqS4qd2jvWsbppSVMLuApY33UeOdzxWm7atus6i8qSqZS4dq408fv+h1tZU6tfL+THiOVc2OpUUZaxNagZgW5rWyZlXNljm/CcSvss4gwyxcFTq3WVJQBB5NaN7aWXd6HHnpiQrvCKx9nqozzhaA8+qXVplTiiFDSeldOBQeRVyRNTcHbXy/kgO2HK2bsT7RcVxLCsvYpeW7jjel1i2UtJHdpESOa5hmHKOfrdpUZCxgoIMuLtVwAOelXbtkxTEbftHxwWeJXLTabhKAEuKCRDaegNcpxbMGLpSoqxe8Gowfz1QZ+tdjik92ckXJQog8YyhnxCVKfydjCS7pUmLRZBSeOBVddy5mtrwrypirRBggWrhCSfpVivsw4wtKkrxrEAWxCCm6cER0ia2+ztvF8143c2F92g3WC29vbquVvruVnWQdkJE8mf0raGHzJUn9P5M3Ns3uySzvrPMAcvrC5Yb+GeSXHGVJIJTsNxUc1bXqFaDavpQCpKSWlCRPnFdQwPL9qzmO3t8J7RF4taONqQ4u6u9aGiobrUgEkad6hxly7wDF7hjMHaxdJtEpULV0PFDalz4QSVQlPrV5tNOdJdghk7M59el9gw6hSCQY8J/nVAxy9bF6tlxzxJjVttXbsIssVxnM5wu57QHGLNtguJuDcF1C1H5UJIkSfPgU6+ylaMIebx3PS7fFFrSbRh7u0pUjfxqWfbYDmuCOlySl1KJu5pKji2A4mqS0hQHCRv68V0TBbxxyB3B1DYAgnfzq15LyInEsKTjmPdrtvYFy8dt2WmrdpZSlBgKWoiIJ/TesF1eZuwHFUsW+b/imiJbW242oFPugQa68mOWKKc7+X8mKyW6SOldiCXrvNtvqhIZZcc1SNzEbV6jyEG0ZlSA4pak27kqPHIrzB2RZuzq5mBZexi8cQi1cXCIiBEyIrpGD9tWZcQaSvC7u5LzqghHeKaS23ufEoqVuNvIda8XU6vDpdTHJJvb3HfHFlz6eWOKW/f8AxG1f3TTOI3o7xI03LshRg/Oa02sxM96604hPdBKTrBnffaIqDyz+IbMWLZzTlPEMY1quA4pp5tSQlakjUUiJA23FdKaztiyVr1YpcAAQJXyfYcVzzyYp+1fPu/k6I4s0VVL5v7FUN1YuFJCgCYg6TP3irV2d3ls5e3F2hDi0MoUhZKFCN4ncecVsKzdma4WgW+IPlIJkqWePYVlvsexdOE315fXdzcJYb71DYCnSpQIISECJJNTjyYoztS+n8hlxZeh9SVfF/YsdxguN3AA/ZzkpRBlSR/OmHCceU2EKt0bbwp9A/nVYydnJ3OODuYveYc/Y3Lb67R62ebKVocRGqR5SeammXSt1SXQgJB2iup+RHs3+q+xnBZpJe0vl/Jam7O5tMthp1+2aKrgqOp0adxsJ4mtVGFEtNm5ubaZ2CXZ/lW0hTaMAYJB0m6VPvvUS7dOhxAQ8rcmEzWniM8MJxUot+yu5xaWOWTlT7vsbL9olJ7lN3YNlJGoKcUdvomsiygsqSjErJKiCkHUqAf8AVqGcXeO4g/KylsNIg8ySTP8AKscFhlTinVHSCZifXjrXD5uHtD6natPOS3l9ESztqp4NW5xC1KiUT4l7mRx4az5nbZXmFazf27ak2zWpC9eoCVQdgZ61FMI1fDvalklaFbiOTsIrLm8sM5nWu4QpUsW8BI2SQXPEfavQxZIS0sn07Wu5xzxyWoglLs+yIq6YLqxoxmxEg/Ml0GP9SqriWXLteIC4azXhTRJBCFtvE/fTVndYW+A4zcCBJME71FYslx5xxKuFNJhXUGa4+rFLmP1Z6Lxzr8/0X2KviuSsZunA6znfB2QlJhJbe6/9yqirI+b8PfcctO0PLrjaiTpebuER5zDZmrJe3N1YOqkLdQBt6VCW2KXF5bKWTuhxaDv5f+ta48mNflX1MXGf/b6Il7LDblPZ7m6zfxzDrr4mycbVcWynO6YHdKBKipII5njgVx53Kdu5h7Abztl54tthMt3DpBIHq2Nq6/apnsvzqFqSHFWL0ahufyz1rjeX8O7P2sut3OaszHDlBQSlkLSiUAbwVcqJ4Fe9hj5kYxSPKyJxnIrmO5Kbctz/APdjgPhGoS+RP+zXLMZyI734edzLgrqFSQE3QAA+orrCGuyrMd5ibmH56bbw63CkNOOuCS8D/ZqUYExVRxy37JLfC0YK7mQNY3DqkuOOFSbkchLaUjYgdSd678cPLdtNnLkUmc4uMq3zfhaxfCFpSZJTfI/hUxcYbft5HFg5cWWpV4F6xco7sjy1g8+lTXZjk3s6zLguLYtnXOwwx22cDNnbKWhHeiJ1qUSIG8VL31l2PWWS0ZRxLHdF0b5blvcvH8l+eEI0gyoDrMV3QdJ0mcrhKTOODK2JluP6mtUqA7u5QfUdap2N5bzay62bbLl04oFXiQtKhP0M16Qv8s/hMwixdsjnRb+Krab0Keu0pShw/NqQn14rzrnU4dg2L3Nvgt0p63DxDDyT8w9Kzcd1aaCUZJWyA7R7J61xJk3lspn8tJEp2CihMx9ZqptO27LwU0kR19TVwza3h9/isYnjLtuEobCIaU4JKEk7AiKgW8AwJV2NOaiUbEzZLkfQGicW3sSuDWsbdHfre7tIUtWoq9OlS9u3YyVLbCSrkp6msrGC4GWh3eb2AoEhSDaOSBxNb6ctWTTUpzVZqiDpLDgV70JSexS3Jdi4t/8Ak/fYWV/l4ihcAbRA9arRftVPAo1JVHRREfrVvwnDmLjJt9hv7ZsdKrhC/izrCBE+HiZqvpymHnSwjHsJckAhSX1J29ZTWkk3RCNNSG1uNpauXUwoEEuEwayZ5ty3hFq0+6pxAv7hfiV1MVsOZTvmH0IZxXCnSlwFWm8SY32561s5xSq3tGEXJGr4x9XhIIgwQZHnUU+h2Puc7dZcCQnYGIHinampcU3g9+0swFutAkx5HyqdfdSuFAApPFaItrVvDb3QlKlLWgqJE8TXPFGrk0cpzB3crLakzwSOu9QbZjV6irTmq2t0slxtCQeRA9aqiTE+1Xjexg3ZntfmXJIBSat9hrcbSQ2TAA2HSqjZSorRtunaem4q84bbtJaCiSVHbZUTRPka53M7T7oQAlrcnfepBl9wJCdEbnkjite3tLfwn4ZszxttUm3aWSla3bdufRIqeS1SJ59ehi0V3iEgspmVAD353p7WMWjCADes/wCuP5VhuWLdQw8aEKItSkGPl34rMli1S2E6EyPShpdVisyNZksSpH9bTA9CQI9hUncXabyzdumbltbaGyTKoPHkYpMJtktJSlAA0gbDkV2bsyxPsXwfA2Xc14fauYwp0uqdvX0JZDaf+rCSN1HaN/OkrkaLqlseQ864NeYoxZLskBQb1E6yEzMRE81UTlXGZKW7UOqHRtYUfeBvX0H7QbrsR7W8AuLfCbqytbq2Cu8ZSr4du12MBtZgkiJ22rhvYF2ldmHZYMwYTmO6t3Lq/uVNs4rdNKfU3agwO60nZUg+hmqgptVQZMXS1b5PNFvhOJWl4kOWagpEEgkCB6+VSj67vWr/AJvUEhPQgk/avY97lDsH7Q7G5x/DRYXF2+gKF3cPBhbiY/dSDuQfMVodh+cuxDs6w/GMvZstbXv37hxAxBTJW8AD4AnoRwDNTNT4rcbwpd9jxG82VPKCW1AlRhPWsWmD7V7+Vmr8OGTH7y5s3suousa8TeJKaDjrSR00jZJPWvIPbbc5OvM9XFxkm5afsFNp1vNNd22tw/MQnyrVXW6IlicFbPdP+TLvsBxPsfzTlrEb/EkPs4535Zt3G0gsLt0hRTqBOqU+1c5xR7IyMaxBGGYDjTrSbh0JdcxRtteyiN0hhQ6edcl/DxnfHuzrAH8Zwa6DK7i4VrlexTEcdanLfMLtyt27fPidUpapPBJJ/nXGtHGOoll9Tpjqf/r+VfDL8F5HuVti1w3GgSAFhd+0YPv3I2p7uDZTebXqscZTqBG12yoR5j8sVT8PxLUolDiEguGd5MVLnGI8LSirSNynbmulYcfocrySNhOT8moMB/H0o5Oq1t1mZ9Fpp2DZKym1mnDL60x7FgGLxl3unMJaGspVISVh8x7wa1TfuFKBrhMkSOtb2XLwKxyzCdJm7aSRE8qFVHFC7QpTk1TJftEtrTEc74ndWxeStx4lUWmtCfCNioLBP2qLbtFMoShV8owZOixWf01VNdotwMM7QcVtG3FKQ3cACf8ARFaIxVQbQQQCDJ9BTywi3uh9TXI1xuyBQRfLkblS7FwBPpW203YrbLbuK2zKAdy806JniISa1n8VlkqWvcCdh096jHcVRcFKVKBPMppeVFB112J921wt5vu0Yw0kHaVMPbfXRUAu0t7FxaLrH7AlCpSvS8BHqS2KmLTEFJt0qeQJAnfmKyd2zeT8Q2goVwlVU8S7CWRmgziWCoaDaMYw8k77OK/+mtu2xHCrgQ3jFjM/9rpn0kgVtt2OFtJlLDBgRwNq0nLHCEqC27VpIUColKBVRwqKG5uSLhiimD2c2Diby2IReLGvvUluY41bAmqWpaEjvmb2wInci6Rtv71fbUWo7P8ACwvQbc37oCFdDHQVptYZg1oNKMMt/wAwFSjoBPNVlag0RjfUropj7V86jU05alBOyhdNeL/apzeHYqrxBhCkgbkPoP8AOro1l/ALplXf4fbqAVOyAN61F5Vywkuxg1trc2kIExWLyVwjXpK+E3SG9IZBUk8a0msN3Z4rbp744TdfmeLVGx9qsiMqZd7mWsOtkad920kj61spwHAO7Dn7KY1JHPdjempt8olpIoFzheNKYW6jCbwkjVHdq+3FeO8zW10jHsRD9q80s3LilJWggiVE7ivft3heDstKdZs0BaQTrSIgnivE+bccxL+luLtXGKuhLV24gJUvpq9aE7dDkvYKKG186Vfau6di10+zh7aClzRJ20EjmqI29h93bhdziY8IgSsda7F2V5txdNgxhKcXu/2e0FJbS25CRPIBG9TPijF3Ze0XYKgCNE9dJ29K3G7wKVoCyY6E8itpWJYi8oJXi2IFMCU/EKj7GnW6Lov96xiN0lSeil6gD9RSUfQ3U62GoAfSolRk+21OZbTqPdrTI3IEU8YVjVxd/GJzA+lsmFtlCSVH02p7+H462s/s/EGpiFl1hCv5VXQ2NtJWZG3FNkwkHrI86sHZ+Q3nDC7p5BKg9IH0NVe0ss2qeIOKWBRwoGwQD94q25LtLxnNWF96+wpKriDDKUlIg1UY7kSlaZVsWu1jGr1tpyNFw5sRM+I01V0oFJKlaVCDIgA1OY9hryMTu1MItAhTiiYYBI355rVaw+8W34/hFJE7KZ3IjmQaqTaYN9JEh4rQe8WFJSCea1xpfUIdBBPAHSplllzRpVh+FqQEkFJZXJ9SddaKMPvGHW1oasAhZjwtLED/AF6lSUgTb2K3iK3ZVoXGqAJ6VFONvECVRtwDyavKsLt7kLDmGWWsj5+8dE+sajTWMmOOJC37O1ABhBDyx96TbbotcWyjIXDSnHFeMSFEnyPFW7JeLW2EYTjt/eFwMMWJUopSVFO8atulC8yvhyZbNhpWlW8XZ8Q+qdqsWS8ItcPcxC3XYr7l+0W2tQugsRtt8g86ePqWRGGTmygIzCq9ZF1ZvuqbdEpVuJ+9YLfE8STcpbF1dSN5DigB+tWW/wAtWanyi3tbppLcgA3LcH6aK3mMo2ot0lpm/WR8wS61PvuKmVrubJ090U53HcVauAlWK3QhXHfq2HlzUwxnXHQO6Tj14EIHyh5W3l1rHe5Htry771q4vmikHUlaEGP1FMGTmVEBnFbgpkAqNoNh6wup65ra/qWnFI5lmRyyvceuLl27eS+tUuLXC9XtG/3rPZW+GmCrGglXoyT/ADrSzlhJwjH32G3VvNgx35aKAr71HMrUIAWYT5bVrCVLcyyqpFzZt8Jc068yA7Hi2M/xrO3h2CqdGrMqEACf+jKP86qbb7itlKkpBBisjdwQpSVGAQOm9K0yOktzeDZfckJzggx+6LNe/wBZrYTgWCOKSlzODKCRIm1WY/Wqay4pLmpBEc1ua3lIC0CCQZrNqKH0l0by7l1CFlvO/eKAHh+AWAPPfVWf+j+XUthbGb+9UNyPglgD66qqNiHEoUtxsgEbVsJfWICSNJ69KzdNlSXdluYwbAlIBczJCid4tVEe3NS9hgGXFtr73M/dj90CxUqT76tqobdwvcqWAoesVu2lwrxFKhB5g1XUlsylutjoGDYVgzWKW6E4+lxKHUlMWqhq3267Vdu03DMGxjHEOXWZDYuJYQnu1Whc1bbGQoVyHBHSMStiVADvkauhG9dH7WNLOYmnTKdVqhUkaTxVWo4nQsUXLNz2IVnKOXkqKzn1CSOB+z1f/XW0xl3LBXDnaKjvZG5wpShH/vBVVF0hIUEucCSdq0EXHfXZcSqEbCTxXn+bG6aO3y67nQE4Bl0vFTWfEFcbkYasSf8AXNMtsKwFolu6zoGUkkgpsFqBP+sKqFtdpF0VJekpTwTG1Bu6+JUtsFJAM/MNqfmxkqoflK+TotlgWSViLjtJbZPn+yXD/wCeu1diWG4Rh+H36cFzIMYQt8FbibRVuEHTsIUozXlTu3FLCQ4kKBkSYBr0H+Glak2eNNOFMd82oQZnwmuvQyjLLsjk1i6YLfud6SQQAk7jn0pCflJ5NMTqTtvTipR2SkgV7ZzrcMweYjaiCgpJ32O9MJgSoGaBUQJ4B86AHISj94SOtAmFxMDzikCBtuAd/WgDKvCdqAEIKtyDFOnxDSd/40w/LvzM0gTO4gedADlbeRikopjUYFNkhIneSdxQUpEyDz0oAdIJBjb1p8pHmPpWL5dv1o7HeQfpQBvICiAECT0A3oJfbW6ppDqS4j5kzBH0rjmH9t+C5Sy62o4w4cRYB8RhXdrImNzXIsA/FRbLxl7F8Ssnri7u1ujvmXdLZ0K8Uk8dK8/8Rm81R6PZrd3wdKwYna690ewittsFTigOpJPFEALTCT828jrXnA/i7vLlTOD4Xlq2u7fFHm2NSnfG2SYkqj1/SvQdil23sGkOQFIA1aSYHoDXVCTlyjGWLpj1XZua5PzAmkopI8j51h1AEgo3PQc0y6u2LNhVzcvhttCSpS1bBI9at0jE2UyByfpQK1E+IHbzrlWbvxG5Ayqe7buTiToTubYgoHoVedYL38RmS2cqJzA3es/EuNqUi1DmtSFDgK4ipc41dlLjqOtrJRuVbgT03rnGecyZzbzflrLTV9h7eE4q86hpbjJLjLiEFex2BJA2k1yHEPxduDC3BZYa04+AU6leEaj1BHlXGM2dvWdMfsLfDL3FlqVaXYu7e6QR37To4KV8jyrGeWDaSdgnKEk0evmc5Z2btc5Yq3i9k/iOXnVNa12hC7hlTWvxnUeRI2HSrxlN+7fy9YYlelhL16w3dLSwIQkrSDtPPNec+x9l3tNXcYhd9puYmMefs+5xBthm3DTzIEJ16mzrVud/WtPOnaF2l/hrzjlvDccze1j+SMTX8K2q8t2mri10adSdSAJASZB9K2jGC2s0c5bRycs7V28Z8zFkPs4xPHcDxQW6mO7C2FJlFxqWEhJH/eqwdnxvF5NwzEr/ALhNziFo3dOpZQUpSVJngn1rz65iVz+JfO+IZRs85Mu5ew3E3bos2SULb+Et1IDbizuVKW6qUiQAAea9CJyneN2SLFGbsXQ02gISWyygpSBAAhBipqKb9QTnGDi3yVvLebsx5n7WcyZQxhxm8sstWVo+m7U1+YlTpJSzMxISmfaumJVHhKgAekTVdyhk7L+S7R+2wi3dU7dvG4url9wuPXLp5W4s7qP8KnwoE6vKnFdCoUpuSS9Ccy1pVitoVHcPI4368V3Ri+79xDibd0jV83dlI/WuG5OSk5gsEFA/6QifLmvQKAlKkoCQJIia+c8Y/PFHdhkliX6lcvm3C44tTae87xR2G0TzXz0/ymv4lhkTBUdj2S8cAxvGWC5iqmZCra1VsG5/vL39QB617R7fu3DK/Yn2bY52jZgcbW1hjZTbW4I13FyZDbQ3ndQ39ATX5/O0vtAzD2q55xvPuZrkv4hjF0u6eIPhTqJhA8kgbD0FcHh2k87M8k1sv3DV6l9CwRfxK1bNLurpDQIlah96632T9iWeu1G/ew3JmX3sQubdouuhMBLbY5UoqIAG4+9c8ypbqcxS3CGSVlUghUDn2rufZL2m9oPZo9f3mRnk2j1w04y8fmlMyRBHoPtX0rfY5cUIy/MVnN34dO1zCMQscGdyTfi4u7s2zakpCkLdUuEJChsPfirq7+HftRyjhF5h+PZWe+Mtmgh9Nv8Am90UrE6inbiuk5a7cu3ftscRleytsKT/AFNd98cv8paO5Pi8e4medp96din4n+2vs4wa1w7MDOXcSQ/ilzY6Fla3G1M6dYKQEAJ8SYPWueM5L2epWavTRSpvcqrHYrnHCcAwzMWIZfuWLK6T3zLziY1pnkDr71pYB2dYvma/umcGwK8xK5Lq1L7hguKTK9p0jbeuh5U7W+03OmZ7HK2N3Tf7IU00HW2kgdy04uISemxMe1WnJ/bnnzsrvcWyp2eZHtWEYpeFClPOOOvOoaWqFg7R4ZV5VblXst7g9OqTb2ZzvFOx7NGVc1ZQRjmXry202dwq5LjRSGlqc8KVeRIE16z/AA3ZUcw/NFriNyyhKFupa0LROpKiJMER0615zw/8V3aFn3PGIZRxjDcLxG1dWsIuVNKQ5oSehBIPvXrfsouMZdx3Dk4nYrwtrumnEPXLZSg8ERBJO1cOrySjjrY9DQYVCSldrc9LO2+CJRq+CaLa3SjUlCSQSD6cVNWGH4TZtobtGENd4QYTsDtzzVLZXhKU6nsxWjOt4lC0oWgkRHKo235irLb4ngTLTfeZptiU8agmSY9VCvmoabI3twdmSEVG42v0ZZWWbNy1DbjCFAOHYjaYFZxaWqU94hpEjnwCqc72gZCt7Z1V1mm3/qyy446Hm0pSFbSo6iANvOtf/ly7GrfA3MxOdpGC/sq3c7h27N6jukOf3VKEgH0rueByfy+Z5s4Sh6l6Q8NYOgb095SFCQI8/aqlkrtR7PO0cPryPmmwxpFoQHlWb+tKCeJMVabhxoIP5WojzUSKynh6NpNX8H9iZQcZJNNHn/8AFxl7uMn22e8KfxS2dsb+3RiarFzY2ZlKlLQQQQDpkxMV2LAMNwJWWbfDMOS3e4Nc26YWVd4l9C0gkkjmZqYbQxdsKacs2S24ChSFJkKB2IIOxBqiYn2V9nZxJ7Tk7D2tBCUpaC20cT8qVAfpTjFeRUpdzaFy/wCH9TiXZFk3BcUzP2p5JxN2+SvLOIPBiyeehag4FrZWhf8AaFASExv512ns2w7C8S7IcCsrJxy0ZuMPafcuGFStLoHjcClTuFA7mvOf4weyHK3ZtgFh255Dtr/CcxWj7eFTYPOEkOJX3byUlWy21wrmCmQQa5l+Gbtqz128dpGH9luY7nF8Hwdq0OJvM2qzZ98HGQ84k92RIcKx/wBwnzrpxYHqMTl1NVz+g+vzJdCe6/svqet8uIwy37H7vM+YscdUvELZdxcXri0NFpltS+7jSAAAN/WTXxq7UfxKdq+JY8803nO9DF2H2nEMr0JeYWsgTHMogHzmvsBmH8PnYcxhRWOzvCQhhtUIWlS0gAH91RKf0r4adpLzlxmvSoQhsrQ2iAEoR3ioAHkBW/hklPNKm695z6tyx5Fv6n1e/wAlNil7jHZHmi4umFju8WZbR3aDBSGq9wI+KS0XlsOIQDEkceteEf8AJJfFI7G82L74lH7aZSACYkM7/wAq92tFbigDJB6VGvcPPad2dedPqtcUv2Qm7pgvgBwqUrYQDzWS57y20uOpchRCQE7kk+lbelKhuAOnFLvEd5BVuB9TXHFRX5jlc23sjA82+tkqQQT3wJhYGwHrVTbzsF5n/o2wLZZ1FtaRcDvm/wDOKDymOoqyXryvhnCnb+sBBA4MJO5rleZcyPZG7TGM34phdw5l+/wcYZcYhb26nfg7hLxWkuBAKghQVGrgECt8+TGpRi1yvUrDB02ywdoeabbKjLbt7dot0uwoPFJcQklQACo3gmja2V28ti8eurBt1aEr7tXenSSPRP8AOvPf4ue17I+NZVy0rKmb8MfvsPzJZ3T7QJSty2b1LWgFQA3IGx5NeYfxs9uOKZpzgnG+y7tEv/2W3ZW7Chh184033xUoqStII0rEiZqMeLHJdMoM6VllGFX7j07+HHOlo5njtIyxd4vahy8zbcOWzr7pJWpKBIS0fFG0zXZs2Z7wDJmD3aLjHLN26v2fhWULSWm0kkHkmSfSvh/2iZgz3aZuuGsKxnEUgpZceLNwpJUstiVEyJJ6+dRln2r58y5g16hGb71lwuIVbN99rV3gM6xMwBFevh0mKovvVGefVRX/ABu9vhvR91bPOXZs1aIfuc8WtstaErW0p5hJRI81LrDifaf2LsqCb7tJsCCBCf2naJk/6xr4F5Yx/FcRxu8xC/vnH7m6KnXXnFSpaySSonzM1fMPxK7Nwgl9xRA4JrPJosEXVFY9S8rXO/vPsT+JprKaewTMd29a39zbJtg4gG7QnWVqREEJM7cVxL8FrWDOdrbS8Gwm/Rpw65Ki8+HNKSkbHwjzFXjt8t3r38Llwu1C3lsZfsnFoAJJCUtTtXK/wMouLntYdaWm4AOE3fKVJ0nSAJ26TXHpJq5l5F0SkrvY+gJS+pIKgE6YABIH86ytpUothRQDrEyseYrXZw+ztWUt6UyoaZPJIrIhlPetwlGy0xt61wYlFZFt39RStxr+38jMctEOXl4h9LKkuqmVOpTAgbEE1FC3QtJl63S2gR4rhMAR/urZxzCLa6xS/unbcFfeHSrz8IqoXOW8Uu5Cr9LbcRCUbned96x1U8T1E9nds6tFGUsSqXb0/kkb3Dwp7vGLm2kEkw+nfatF164ALDWI2YWoahqfHAG/SsN/csYaHQ/pCnnEpUr1A5j1qMSq1ublN73oOgxDZ/diIrOM8XaP1O1QyPZy+he30Kd7PHG33bZM3IJWVwidQgT51Rb0M95oF/YSoEeN6P1jerbiCmrrssf7khCXLwDdM7hYnaucI7ppSbVy2SpllswCkQN5r0Na1FwUt7S7nm6VS68lPuzMtFumQm5tXZ8JLbkgfpUNfX9jbI7oXrJXMwnXsfcIqUcucOKSltCEFCZATHlxxWq+3Zv2aXSgEKIVHEGuT2Y/lX1OnpknyVbFMRSXEpTfWip32UuEj/VrbyMptvOdg6vEbV0I1qS2z3ilklJgAFAp96tlIUjSgInen9nd001n3D3EJUEoU4SrT00muvSuDyKl9SJt9L3KF21W1srPWOrfx/DmHHLsHuVOqCkApGxASYrkOL2Np3C3DmDCYSogJN0oEkdRKa6/2jlhfabmJ4nd3EF8q9B/Kue45b2gWoKSgjcxAMn6121ByOFflKU7gTzqlFjHsLc1JJgXcfoRVXx3KmJ3eG3du1fYegPMlJWLpI526+9WrGnLNgqcabbJTIJCRNVVeIgd42pyEK8UHyNbx6eE3ZlbeyKt2JZmtezLPt/h+d+9sGbqzS0HkIU833iElJktgyFiCFf4VBYzn3Kt5lbM2XLPNDL91cru3bQvuKSFFe6EJK+oiIrvHZdcW/7bcu2ghRFk8PppiuQZmyzhON2mIW2IW7bqXUOFSSJJ5gj1qsuRdK61aF7SezJF/N+C4n2fv3dni4atxafDL/NDa0Od38sEzM1zHFs7NXl1geCF567VYutOXDjhJhKU8T5k9PevP72O4rbFdgL1xaDchagvclSJSmfPavUTjOXcAw+0u7lSba3aQ2488dySQCVE89aeXEtO01bTZWLUebZmedv8zoYsbDDXnnG9TiAUHuxqSUgEmB1n0iu5ZRwy9sMHscNctIVa27TK1yIUoJAJG/JNcqwTtc7LW/A5my2WnSJSVrVP0q42HbL2NOISyM0WaSFJkrC0jnjilOLmqadDg+p3Z6S7EbG6/pOpKklIXZuJJdWkCD7mN6ty+xfMWK5lUxhCHHrN9arl4rdaUkwZCQkGSJjauI9lfb92D4Lm+zur/OuE2tvKgtaysgJKOT4favS+S/xVfhisMTL7XazgTaUtLRu4pIAJHmPKvI1fhf4nOvYl8j0MeonhwtwatFFy3huQbvtNQ/gWIW+LX+FNvt3jJWlt1h5SQj8wE7QAQkVeMy5wy/lDDV4jmXFLbCQtYRblxaFpWqeDB2k8Vwq5/F9+H7sw7Ysw4h+2rfMGXsztWtw5e4awXLixvGgpspUk6SttSYMgkgzUj2q/jD/Cd2jdmWLZasswLVdOhh9li8sFNBxTbqF6EqIKQogECfvWa0clU44HS7DeqklTluz0Pgt89iOFW958O0nWCCVOpSFR1G/Bmq9aZ/tXM0f0Vw7EbG4uO9Sm5sI/PaAVsoRJIjeeIqr/AP23/wAKVhgNriGEZ3btbdoBtvDmrFfeNxtoCEp0iPQx61Xuw78QHZb2oduec8+5dwe8v/hcEtcPs3LXCnLi8UAXC66sNpJbSSUpTJkhJpYdDKORuWJ17+EXkzy8u7OuZrzajAcbOEtXFh8SXgp2yKyh9aVQdaAfmmegnar4MMxDZGthB0yBpUVR61zmyA7Qe1HDc/YlkJzDsNyzhrttY3OLWYZvbm5eUiVobV40NoSkwVQZUdq6fbXajdLcRr8RAEDbasck4JRXTv8AEWNZmruiVxFHwuVrdpy6LbhuCoK7kq3g7RI/jUA2VIR367pS9O5ItwPflc1P48lx3AbBZUWv6yomDM+FVRPwve27cPwVjfbpWviM4qcfZ36UZaJezJyl3ZHXeMMsE3C3bhKVokfkpjfjfXWs3jLKkONW7Ny+VJJ8KUhSJHvTrqxse+VauureVpRInjc8VH4heowoLYw62QCtlYABOqR1FcHmR/6r6/c71ibW0nRMt3b6k2zrjdylHeNJSCEAkyInc/WtjtEeZVmvu20XanmrVorDakhKklSoG4PlUZhgvb1myN+8W1K7iU6t9QI5EVu9oV+7h+cu8ZQhQctmEKBk6fEuDFerhmvwk3S5POywrVQin2ZCP4l8AhpJsLmXFBIULpBg+R8O3FRn7WulPvXiMAu3VBHcqSb5pMgEmQNB61v3N8u8RqVaJ1KWeD+v8a02X0pfuWXkEoDY8Q5k9Nq5sc1LmKOqUEly/mQ2J3F4GwtvKl5qUmY+NZPXj5KpjV09hrbx/ozi6EOurWofF26gJImPCK6HdXFsUFKVLSUpmCZmoF4MXNsFIe1pQtQUAflPlVRkov8AKvr9zKaXZmlhOItO5Azeq6wvEWbFFm6t5Tq2lO7NnZATtx1Jry/2m2VljOXE2+CZdx5dza3DN7aF5VsULWhYWAqDIBE/evU7iNPZ5nVFoVGcPd71E8/lGuFvMo+DZb+bU2IlfpXuKVwi65PPnvJ7nmTMV9bt/wBJ8JxbLucEWmJXYxSyU1hKXg3cLILjbsL2TqSIUmZB3AqFzpn3INzjOW71h7MFs9avqD7N5g4ZWpC2yk6JchRCo2MbV6HxPuktvNFSVEiAI2A864T2+2Fhe5JvXXENKdt29bK/3kLTuCDyK6scqaTX7nJPYicyZlyBimB27Flj148MRKCyh2wbb1wsajs6ojTFDNOYmcWwvL9pas4qxg2GXVxcKxR7DXNFw+oBKW0JSTwJJM+1ebck3Kr3OGX7TEHFOMB9CA2o7aVElX3PNeyMcV/+jSyYaACE3p5+XgzH2r0op0+k5HOzi9y7Y4rjK3F3C2GQpsm47haQ4G1SNoJkz9K6r2V5d7I8wXWKXPahmxVrh1i2lTLVue7U8qd5WsDSI8t6pAaac7t11IWkE8iKxYlYtXtk/bhWlLzakmBv6VMV18itXbOk412f9lfaN2nYLlvs8zpYN2N8pw3N25rKLVptEjVqA1LIEQNjUzjnZz2HdlCX8vZ0xZN7d4goqtMT0FfdgDZPdo/vE/MTtXmy4TmHL9+u0/YpfQuFpW26VEeHccjb/GofE8UcDTdq7YO2hS+l1Dl0lQCgDOgKBjepcIVu9zRSi3bWx3227ArHEsjP52wPM9u644pbgs9gploElOuTuSAeOOtWLI2Fdhmb8CwzLmKvu4dmN9krfeUSe9I5AUYSgAR96862uPYXiDtou3vT3xZW7p1KGhJ2AO+2+1ZLJvEb7FkXN5hdyGGWltNNKBhZMSoqny2j1pOEY7C6ovhHrY9k/YXl/K93hz/aQtV5evf1dpTzfdgAbSoE6j/hXnK9tktYhdItH0uMsuKQ24kfOAYCvrzWfDcFV/QpSl2xat8Mu0rUkrha3FggAcwkDf1rVsnHXnltN2JCdyVqekHf/RpzjwgjKPZGtagpUpS0SSrSJE9azZkv7O1YtLe/tFXPePOAFDnd6dvY1n+Fu0uArtgUEpUqVCRvvAiorOzLqGbdxVstMXTyQCBuBG+3SlxGkZ8yNR3EMBS3oXh16mI4uE//AE1qOXmBnDb15hN62kKbBK9Kup44rQfU+rSlaDB9Oa1FlbWD3/ep0gutQk/WslI2aVclOzVcWTzChbvrWZnSpERVUQJk+QqazC+laobTANQzaVK1aRwmTWkVsYvkzWZjvD/mGdvUVfrJDK2m/wCtoTIHQzXPmAoa428Jn71c7N4FhtbkCRpEUpiLE3bMpQD+0Aog/wDZmf41usiyGlJu3SfNLcb+9QLFy2W0np5zW4ytvSDPJj2NZ3RZaSbRRZbcfuEqDXhKQPua3bZGFGFOPXbivlA0pioS9faZTaBKgD8OCT6mnW+IaZBWke/nTY1xdlhCrXTP5wIPRQ4qPxr4O9sVpYbeW42tK063BpkfTb3rB8UC2BKiV7gxzTUFRCmwhSyekGpWyNEkigZpuUovnr2zt1Bp5CoaWrxtKIhW8bjiqhd3Pes2qQ2U90gifMzzV8zZgeIlDt7Y2z7yQhQc0oKoB68VSO7auPgrZIhUFKt+s8VtBujCT3LBlm4sEssP3zpbLf5TRS4NRlXi2PSCKkcZxPAHnEWjF88ApUuOLagJSN42mdxVGTCXGdyBsT6Sd6m7pSFaGwZ1JifIUTe6GpOqO9YdmP8ACbf2mEYc7gruHOBDKcVxBxlbjh0iXO7TMKK1QJIGkTUR2vZU/D4y1heKdnONouDcYi0h+xt1qU6phSvFKTskgTEHrXn3wh3SVqACo1ASQK6Bk3L2Jvpssx2uAquLS0K06y6hAdWOCAo8jyoqK3EvQ9yYbmz8MTfcZfy3gX7Fw7DG0oeQplOpMjYqcWCVTyapWYMaynh2PptctYjhWKYavSovM2qFpKJnYqTz04rzxg2ZReY2+AgoZxB0MltxwJKHUIMhQniODMVO5XuMUv8ACkv4Hhq7tkSgTcNtN6hwJURP0rKU5SfFHTDo6akd/wAT7Zvw6Ydmm1tsTbYtbVGlF7aItEhbZI57woiPpVDz3249jGFY83aZaYsMStXEqIdZshDYnYKJgz9K83527jD8axG2zRYOrxlb4dWEOpKW06fC3IJBmQSfSqMlyXgsgczEVvaq0jKTSlSR6me7fez1CPFg1sUpOw+DkR962MF/EX2UNYlbOXOEWzCEPIUXRZuSjfkQeleWrh5KkEdekVo0oTbVtESaapI9i5h/ER2QYpme+vg0xetuuym4dYeSpwAbE7iPtWF7t07GlDWLS2mCDs/J9t68gjY04hR3mtOtehJ66b7b+xZQktMpnYjU8NvtW1h/af2LYzdsWNgwFXLytKEIeeGonpxXjir52KWL99n2zRbsLdW2hbgSlMnYeVLr9wNo9lWjeT1BBVglyY2IF6d/bbatlTWWSEpTg920iefiZ9ulQdjZ4khB12F3BO35Cp/hUhF0tHct2dxqB4U2ZPtWXmT5NFBM212mVFMqCrPEm0IUOLhJPv8ALWspOSCoJW3i5BkCHkc/6taqkXbi1MuIUjzkVicswlJgypHPhMRUPLOSuilGHcv9xbZb/oLh6FftBFmzfqcbUlSC5r6zIiIrRLuAvwLW8xAaZ+dLfHTitPEH3EdmFs3qbKW8QXJCvF8u30qkpu7pnQsqCdWwM7GtZyTq12CEE1szotq1YNtHTiL0Tunuk7+vzc0Ta2KXDcDEnoVEpUwJ/RVU2wx9ySyVBcneTUucQbUzKzHX0qdvQOl+pMqt8OdSpAxNxKSYj4fkf61ItYcgFCcVCtoEtnb9ahvj+8SENrQCNtjuRWqXlrnu5EnkCaOpLsCg73ZMPW+HlpSV4y0J2MNKrwN2jtIt89Y8006HUIv3khYTGrxHp0r2s+tRaK1FSoMjevFHaKlYztjYUN/jXD9zSUuqXApJqJW5nmvSHYVlVN9l60v045hzZcKgWlqc7xEK5PhIrzfBr0J+H43CMOSQsFsBRg+9VJpK2YS5R3y2yq80ApGK4asjzdIBH+rW81gVyw7CbzDwnglNwKhmnHXIJISFHeKym4SytKO9BSpUD/ChZEuxt5b9SeGCYgrUG37NQJG4uE8e9YhgeLjVCWimR4u/SZrTDybcaVKgAyPX9aCLloOl9LhJO2nVsTT81cUDxtEj/R3MQHeoaZKTwfiUaj+tTGU8Ixu2zBhtxd2ae7afCnCl5J23EwDVVtsRS68pKNJWBI35qVyxelnH7RTpkF9IHWPOnHLHq4BwaXJtY3l7NC8RvLlGHgtOPLUgpeRunUY2nypwwzFkNhLmGuI1IggQZ9RVHx7EX28bu2EqUgi5cCo8p2pzt2442El1YlPNKcqY3FlnVgOPlYW3hdxpAA3TJNat1hOONIDicPuJB+XuzqNU+2xa4TdK7u6dgEpT4yPrW6cSuEJITePSkSVd4dvbes1NLkajRIuJx1h4rcwa8TuP+oVvFbdvd3zaS45ZXCCswQplX67VwzOHbdmzLOY7rA2bt0BCULbWtxRkETvvUaz+I3Ow+fEnimCNIdWP51vDpq7CTcdmd8uA7cOa0WzqQBM90YqWyK467iV7ZuJXHwbqwVIiYjbeuAWn4ksyIbDZxG7V5pLhgevNT+B/ikvrF9xd8zc3etpSBqc2So8Ee1axim+TGcurg6JfXN01cqQ4F7K6pPFbeGXj6QXCfANiNNczc/EvjFzCX7u6cSob6m0mKCPxCY6HJYU7oXAA7pJ3+1ZvFGXc1Tb5OgOYoppbjlyvTpUdgKhrbF2k3Tiy+pKSSQmdqqmI/iFxS0tHLhSknQfkVbN+I+UxUjZdrOZ7u0ZubrDrJtTyNRQu1bOkeu1YShHG92NzV0kUTO91cXeZHmjdOFABIAVtWvh9kUqGh94FexKV1s5qxGzx3HHMSubxpi4WBrSljS39NNZMOtsPSdYxthIPQoUJH2rSC7izS6pbEjZ2XdKIXduQreA51863EN2rS9RfUox8wXB+9ajKMOcJS5mC3bUONTaj/AVspw/BnSA5mu00TwGHD/KmZpGa0ft23R1Wn1k/U1JpxJtsBKHlaRzBO1RKMOy6nUhObmSob7WzoBp/7KwNRGrOVsmeEi1d/jFQ77lqu5Nox0uoLJfUZ4AVwKLOLsNqhZjyIO9ajGX8ACQsZ1ttX/8AjO7fSKLuXMvLOoZ5tieABauis22+xaSb3JBOMssqU4gqUvnmakLfMHepU62hJUI3MSP0qJYy5gDzStWerK3VGkd5ZvH+FbbGU8CUgj/lCw4bAFRtHx9eKlt9kC6H2LFa5uxJ1xrubndSkpIIBnerZ2r4++zilo400Fa7ZB8Q1b1z60y1g1rctLa7RMOdIWmUi3fEifMiuhdqWBWuKO4Y89mG1sdNslIL6HDqHn4Qa3gpeWyL6cn6FObznctrClLaEDjQD/KnuZ7vFq/JfaTp3juUD+Va39AMLWoup7SMDI/uhi4n2+SKJyBh1uoKOfMG8W0d2+P/ACGsEppW0Xtyb1pn3FGCoEMr1DktJMfcVsDtMxi2gpUzpJ4DCQP4VEf0Rt23AbfOeFr8MHwvR/4a3RlDDywlSc/YGtR5QE3E/q3FZyb7DXTyzbczzdP+IpaC1EGQ2mu1fh3xu4xZjGTdu6lNOtpSQAISUn+dcSYybhCQTcZ5wMnyh/8A/N12r8OeA4fg7eMLs8ftMRD7rZX8P3kNwmADrSnmt9H1eZuc+oSnFdK7o7imSkb09K52JisKVHfYwKatYT41LSkeZ2H6164ktqMutU+HcGkBG5SYrjGf+3RzCrx3B8ILSXGiUKgFxc+Y6CqWx+InMuH3Cnru/s7q1ZSFuMrYDb6wOUiDzWTz406bKlCUOT02RB0nYDmk8vQhx1tOpSRISDztXHsgfiLy3nbFV4S9ZKwxzuy42H1ypUfMTtAiujWObct4m8Lawxe2uHFbANq1T51pytjNZIt0aic45WF06tzMN6GGWyL1tNoA7ZL81bRo/WKblbN+H5juH04VjNtitmhXgumUlKT7g9ahsx4Pi1hiWL4lYYa7imHY9bFu8btykXDLgRp1pCiEqERIkcVQuyjMGO9m2BOZZzD2fZrWm3fcXbXVtYB4OtkkgkIWSCPI1nGO/wCY2yv2fYXdfI7HjGccsZfuAnMmLosGVeexO3MmRt5RWxg2J22K23xdhei9snN2bhDakBxPQgECfeuMZ+7VMiZ3ypiDuHuvqvcuul69sbu1LN0ylSCkS2sTBKhvxUxl3tQyxkTCMHyTjK727x9qwa72xw60XcvIOkbEJ4q1CV22RN1UEt+/uo6BmPOGXMttkY9mFGDOqUO6Nwkdy6PIK51elMwTPWWsxXnw+XcWTiKdI7wpSJbVEkGK472n5px/tDxDA8Mwfs1ze3h9ldpu33rjDyyVKEQEhR8hySK6h2f4HiFijEMUxdrubnF7s3S7dMQ0IASmR6Df1qUpXuxZckIVBLdny2xLthxS9tVOXyyi8DpQ+W+CrffSTUvlHEXcwYIhTd18MxalSNJtwoqKjJKjJkmqQ5gOFus3dw9cpbuziZa7g8BvxE7++1dmsMuYTheHsosyO5SEksjkeZJFefJ9KvuVBrp6mWrK91Y4AcOulP3eIs2Fwm5LKQEICh7Ca6Djf4mc1N5qVi9liDrLLiBFsoEoR5iOvvXHzf2+GKDjBU8l0FOkoIKT5etWx3Ld5i+T0XNpbsNPB5IuGSnX4SJSoqiU9RTWeeOLmhSm1G+x0bG/xZ4jmbBGcOscO+GWCkPvFZSVKA3iOBVUvPxB59NouxbxdRt3GygocXIAIid64u9Z3mH3C7O8UlhS1avETB34jpWu+1cuKLz2gIAKQDA26etYZM+TLsnyQmmtiRxLGHnXVFt0uhZhSyTsa1xdP3KxaqxMMqSnxeGZ32itCwscTxPEcPwzD094q5dDaUJB3JMeVdHPZq7lu+xA4tYKbXaOFkKVqWguD92YEUoYnBWxpJLcgMMsMOesL03WMOMlKQpoKaCu9VMc9K07jCMKwZxN21jCbsugfk6SFJX996bmxWi5V37rTAcIJ7tMQOoFVB/EUWyi/apdWpCvCpfEDrFCbktiXK+DrvZZ28nspx9y/dsEvflKQ4lYICgegrH2xdut/wBq+M5XfxQ2qcLRiEpY0bs6oCiSRvtXHHcRsb1Gm5aLqlkqK561F5pvbZqysrZl0pQ0pS9lzBjyrrWVxikxpyk05dj3l+H7PWSrPtbzuUXVtZ2zKblHeAJS0Qq6BQEkdIGwr1U0+3cNNXDKgpl1IWlQ6g8EV8a8pZqcssev+5dhCgFhKz4V+KRxXvv8L/bIrNLF3/SLF0puIS2005cQhOnYBDZ6Rya7opTh1I2/8i96PThIkCYB6UkkJ8cjSOQK51m3tnyzlrDbm5Ve2bl0hSk27KbpK+9PnI4E81G5D7dsEzRl1/F8actMPuLcmWg8PzABJ0gn6Vm5pGcU5puJ3DKGL2NrnDBbK4Ue8u7tCG0x8xr0c02pKhEDqYFfOLsa7Rms6fiQwG+ZN2q0+JSq3YWZIhPvE19ErTEb19xBRh6kIOxK1gRv5V874lkUpppnfCE3gjL4/ueIfx0/hj7ffxS4vYYRl3MOX8GydgaS63bXTzoduLpUhby0obI4ICd9t/OvJKv8lP2oYfZP/FdpGUA47pCUti4UpMGTsUCvsM7Z37jSkfAJKTMEvbnfbaKpWO5OxTEH4Rb6QTKiHh4f9mvD/wBw1OCXTGe3wOnDptPPnn4nzOyf/kxc5YFfWt7e9p2X3C0AShuzeJ5nqfKt538F+JZRvNd7n22uQ6pS4Zw8nYnaZc9a+jaMiKY/OvLlCUIAB/O1EjyjRVQzJ2cZevn3XjiNw2Ao+FASQlPlMVcvE9Tz17foda0WLJtFN0eAcR/Bm3cWrSMF7T7jCdTSlXKmsMBcdWVEmFJeBAgxFcJ7bOxO/wCxV3ArpzOr+ZU4zdutFL9mUKbUlI3HjVqJkV9dLfsqygvDUFq7ugrTtLnI8tk+9eNvxqZAwZPaR2T4Jh/eqS/iLrzyVrUrSAtpIIkbDfyro0fiGWeZQk9jHVadY4LoTTOXfgk7PMX7c82YhgV9me9wxm1Wm1UthIDjyxq+dUhQSkDZIiu2t/hZyPbZiurrMOYscxdq2cfszbOPLQFBKlJnUHJgxxUh/ktcvWFs9mXNL7ajcPZguW2llRACAFH6zNdZx3NeV7bG7y2uMEve8Fy84tSb1JlRWokxp9/vXVrsk1P2GauEOuEWv6U/1ZxO5/Dtl9nMWF5pwt92zYwjD3LBixtbZGgoU4pYJMzIKo9hXp68wI4LmPKlihanQ5hbDkJQARpSABsSSdvSqVhuL4NduFmywp6HGy4dd0TAJiICRXWnPiL7tCy9a7DuMNaQXdUKAUkiEjjgc81wZMk5Y6mzeMfLlFxW2/7HgH8eGO2+H5idt33HXLm3wpBt7hh0oW2FOK8JHBEieJrm34S+2Du8dtsAzNibirq3UpWHF1Y0qWpJGgk+fI9q6D/lDUuXPatimGqvrdKLDCLUC3I0qKStwyFfvExwa8fYeX2nlu2drodaHeIWNlAjcfWuvwyT8jps4cWdxyOUuLZ9KcaxF25yTiuUm7YtnEUNIcf7wBXgJVwPOfOuP4Z2PvWfZXjXZkjNF461mDEGL1T60gdwpszCU8SZ5rm/ZN+JzF7S2bwntEw1F2wsBIxFfea2/IKSkiQPOvSGA3/9IrVnEcr3eX8TtJkKYuXtY8wROx+lRPDlwu09jr6MWZuUVzyda/AL2Zp7LMKzHbuY0q7buF2w1ugJCSNW3NeuncUwtpKg5f2wX0Heg1xD8LlmF2mYP2pYW7aC6wQlC1OBRhX97iu+sWuHKnu2EJSNuK5dTJynb3ZhrJRWSmuK/ZGlbYrahpALiSpw+FU7KPkIrRxK9s0Yo+l58gjSohLS1EbDyFWFFtYpWnSyiU7jbisJatl3L6ihOoqgmPSlFPyXt3RyRyJZOpWebfxlYvh2IdjjdqwbiU4zaGSytI4cjeK4J+EfABgv4ge/XZ3C1nCrNtpSWjGk4PbH+demfxiXOGWvZO25epcLLWM2esMtKcUfnjwpkke1cr/Dnj2C4h24W37LavAv9lMqc7+zcZBSnC7VsaStIn5Tx5zXbopS8uSrYrEvblOK7P8AY9GZttnL3C7q0LDzKXWVJD6mDpbJESfECRvXwG7Qst27+d3WMNxT4hlKlAPd0UzDihwTX6Bu0bEzbZRxW5QdPd2jivL901+ezOGaltZuL1uw2YSAd9gdRqfCVeeS9xlq7lODkfWr/Je5WucB7EcwMpuWnA9jSVoOkp37hPhO9eyWLXGCtJUq3bGkbBJVB8+a8if5L/F3cd7BcQvXGwhZx1aIT6Mt17TYKUkidR61GuV6h7nXqpyxza+H7I0XGsXSkJbFsqeSpZT9gEmsbGHYmptIfurfWfnKUH7b71LqVAM0g42kT51z9KckcPmyXBDuYQ41Z/DpCSXXysk6j0O/TesCMJxBKyPiWUtmBASsEf7VTVyvWlCkoJhfOnjatR+6eRsm3cKjsAEH/CtdTFWqXZdi8eScr3K/iuTcMx5h7Dcbs7S/srlJaeZfaK0LSdiClRI49K+Jf4tbi9wPOeMYPZWWFM2LSrcNlhK9RbYuH22tZUqFKKUgKMbhCeIM/clbd4l9tSbV6ArUrwmvhh+Ly3xRnPeIqubVbbbzlu2nUnqXrhY6zwafhvmPM7VKvSidRNpxaZxztQvGG833gxHD3VL0M7kRB7sVTE3OE6tT1grT5VP53t1N5iu0LPi79AUVCT8oqr4onS+4gwACIAFfQQiuDGWVttssuWk215dkYLY6XG0fma5II+9XfC2sWsb1i4VbMqKFhUevTaqv2RWV1d3d+q2tlu6G0k6Ekkb+VdbwXAcRusVt0JsXkanUIKlIVpEmJJjpXLmbjko9DRptxddz6p9uWaMSsvwx4ktF64zdHBrJouNmCJDcxHBrmX4N73F8T7Tf6ziLr7Ywq6U4HX1GDCdxJrpv4iMHSr8PeMYe1i+GNlGHWgccW6qISUdAnrFcg/BxhN2x2mvvqxCyeQ1g15/YPFfOmDwIrzdGsiyZOs6sijKUuldvQ9p4laqubhp843atBpROkLUr+Ca3LIsLuLdKcUtlDWD4QqVGfUVpIQl5r6Vnw1pIv2AOq0gn61yYcuNZElDv6sqeNrG05ce5fY3cRttVzcuftFlCVrOoKbUdJ222qP8A2GqCtzG2xO/9gqI+9SGIMpC7sBQTrdJG3qKxXFs1rIAGwiax1OTE80vY7vu/uYaeUowSUvovsRDuV8NvWnWr7EmLhBWDvaK2I6c1CqyPlbDYVh1+zbuLJA/qa17+xVVmaDQQ7JUk96sKIPFQ107aMujWBCHE+Jck7wNvvXOpY1LaC+b+53YuuV3N/T7G5iFnbo7PU2isWgG8SA+bX97XxoB/nVGfwrBhcllWNrKktkLCcPVIHE/PvV7xdaP6ApW0kKAvQTHQhZmqEcRU7fO2oa0rTbpUpSTuDqIAH2r0tdvKLfojn0kW+vfuzSfyfltRhObFtuObkHDzPHl3laq8qYIGksN54eEbR+yyZ9h3lbF4GEPC7UVFxMyFf8c1Eru3Ft3DjTdulWsgFR8SfeuKGWLT9n9zoWNt/mf0+xoYxlXAEDQrPSkzvJwpW0eY10sg5ewe3zU07bZwVevpQvQz+zlNBQ0mTqKzH2rVvL9lNrcquljZJVPoB0rL2atMJzhaXSSCSw7G3zeCYrp0sl17IWWDjF7/AOfIpefsDywvOuOP3WeTZPqvFDuf2Wp3QvqnUFifeKoWNZfyzLimu0tLzgMBBwZxHPrrNWXtJWh7OGOXTugE4m+T5zNcpxgrcW65qkJ6ExXepRW7OLo9lNGpmDs3wfEG1FvtUbaCvEQMLeA9tlVR8W7N8NbtCxbdplgpWmCtdm+FA/WrEu6UEqQlfew2SY3Cfr51APrtlFXxCBsdjTU1zX1BQSLl2MZXTl7E31XWcLHGosXUgJacbKJAE7iCKrV5kq1txeXTmZ8OkNLAUUOADYkdD7VaOyuyL2N3aLbrYOq8RATA3quYq+VWl3+TJNus879eBVZ5dMYsySVs+f8AfMJOJKWXEnVeLRHG2rma9R9o+XkLylcNt43hjw+DBAQ4omNI6FI32rzDdJX8U2NPhXfLOvrOobV6Yzo0W7K41KJHwKiR0J07V262VKCObSpNTPKtu0k3BSFbTAIG1TeF2aXbxCFHZKgVSBWjaWSHXVK79CesFUdeKsmD2QRdocVcphK0kpSFEnyFeko3E4Uazlof2g8AuYcUYjny/wDSrjkjK7OYMZ+DedIHgHh53UJ/Tp61AXFkw5dvEXjQK1KUUK1bEng7V1PsZwC2cxguKxm1aUlxoJZPeFala+gAiZ2+tJ2o1EuD3DmDsrwZOaL6yt3Hwlu5WlAlJhIQIBJ43PNR152b4Qx8QhNw+VNsOatWkDUBO5/l1murY1heFXWZsQuf6SMW5ubp1xbLqHdSCUhJQdO20TvUTjuC4WxYYi6MftHFs2ryyhtt6d+hnYnbaa5pLqdLkutveee8HwRNxjGGYc7cFPxl6hlcGCAoAK3mvpj/AJMrK2G5XzfncN3KklzBmkqJbBUWwtRPB8zNfPDALWxv885bQ3iKEJvb9IcCkqPcgbePzkSdq+l/4ELTDLLMudF4fibN4sYG2HEttKT3YkgE6vOKz1O2J2jfD7Vr3HrS4/o6+hDqsavi2QNm7ZAn7mtpm4y4jwi9xVzUZ+Rob1S3sRU1Fr3JCUD5hzt5VntbsupS4WigqMAK5NfIrPBbdC+v3PplptvzP6fY6LjF7gLOWLN+/evWrbvVKSoaQ5IBngEHrUTgeJZOx6yVcYTd3Ny2woNulL6ZbX5KEbGqV254bmZ/sZbx7J2NN2GJYSxdXAS8CWn2koUpaCRuCQnY1UPw05UxXK2SEZizDiJxDFc2sWuIvotge5t2y3qQgTyYXufOunWamSzdDgq6Vv8AocOmwxcJKM31dT2O1PWOAIulOm0vFOd2IPxXI6baa1RhmAOkl7DLpKuZF3v/AOGs6nwsyUlCiBGodKCk+IuBtRKZgedcn4hvmK+SOlYqW7fzY1m3wW3uGXRa3oSHUAk3hIBkRsE70c4M2N1mhaLnC3Vvi3alwXpaSd1QNISeJO9YGS58SzqhJLreoRud+KGfbtu0zW+jxDXas9dttVehik56aUkls0cWTGlqYpt8PuzQLOXWCULw+6P97/nEgA+kprTfuMtMLKTgd0taxuoX3T/UrAB37SfFIPAH3qPxF4ocWVuCEpA22rFZGnukdU8aq03839zYvXstuAJ/Yl0BvI+PIP8A4Kp+LY12f4QFsu4BiSCVEQjE1bk//k63Lq5SRJH1qHxC5YcbglCyVkgKgxVOfU9kjFQp8v5s3Gr/AAK4yBmW4tcLumrMWa1Pocuitx5OgzCikadp6Vye9vuzZ23QP2FjASpsFIOJAkH3LddQRdA9mmdCsBYXZOjZMhIDaq8/XLlvctIWEqQkIABGw42r1+tLHDqRxSXtSZsYg32flhYasMaQYKYVetqE/wCpXD+2/D8kOZCx9dpbYoLtuzWWS7cJ7vVHUBMkfWr7mG8Ra6Gy/spUyK5L2sYg6/lDFUIUFo+FWAqeBFdWKcXwc01Z5K7NRZHPuXPjfiCybxoOhpQCyJPyk7D617gxZvLKsmWNi6nFU2KbhamglTZd1byVE7V4TyISnOeBqI//AFxkj/Wr2/ijqRk/D0dVXLhHSPrXr4rUGef3KgvB8mJQm2F/jTa5k9401H6KmtO6wvLLaHEDGb1HhJ3tgY2O2yq3rxlKFFQTJgDbaoe4CkrVrgiDtNTGfZIbVvZkXm9q0tcTSq3ue9AaQZKIIGkVQ83Lau8IvkgyUNFYngECavmbsQxDDcVaas7tQSWU6iBx4R51Ts05gxG8y5iFvc3RUFMrSQoAyK55yXUUk2jmuTLhf9J7VrvIZXJjgEBMgR6Emu1sPayktuBEbyByetcW7P7xxjOWHPthIKNcawCPk9ea7gznfFUvw2LY+Lb8hB28+KbUW7kxxt8Fiwi6U9lPEg4qUC5aB34I61qpUhu3U5Gog6QQKnbPF31ZPvcVTaW6n03CEgqaToH0iKrj+cbrUVvYdhpMzpFmiCPPiujJGFLcjGnuxiblt5WidZ1JSo7bb1rZnbavLdhx1RKRcOpQobREVtW2Pt3Lrbn7Iw4Bxe+lhKAPt1Fa2ZTbvWlq05cM239ZdCUmQFevWsWrixt3Iqb+FNq8abpwbyYV0rTxjDWP2DfFp1xJC0+LVuImKm37FtSEoGKWaidvnI/lWhf2ROFXjRuWFuEogJdHrWajSK2ZxfGLZ9pCVvuhRJ6VGtEDUD1TFWDM1m/bNJU4EhKldFA7/Q1X2wDqn+6aeN7Ihj2ApWsJP7p/jVqsGSWm9RBI48IqqNAb7xtVzw60vENtuBkA6QQdQFLImNI2mEeGFuKMCNgI/hUjaW2looceWU8kSBv9q1GLK+JJDbbcc6nEwP1rcDd20IJaUQNvGmPvNR8RrclbltNwm2bNw4kIZSmEq5rI1htu4g67p8kH/tTsaauzuWkWwUG0LUykmVgDrvW3aYZdpPeOXVqUHfZ4Hb6CrYvygVhjHhUq8uFb7fnK4+9ZkWNklsrl1UTy6rb9azN4e+s73Nt4iSPzNx+lMewx9bwQi9t0pAnZRIP1ipZabZqtZgvMEumn8OUpLe4UjVKVg+YNaWZsDbxhJx3LHw7WgFd5ZLXpUPNaOn0rcXllxSZOL2exmRqPt0rC/gLNvavPOYuwpbaFeBKVgq24mKnnlA0mchBUX20EbqUlKT/3jVvey9dLCRrUskxATJPtVet0JVfWSLj+zUtoE/5veEGu63eBZetsauEjHlW3w7pShtNupWj6zv0rWabVkd6OZZc7P3H79u8zDYFvD0rlTKV6XngOh/ug9TXV7PF0pdQllptm3YT3bLCB4G0+QH86wM4Rl5b4WrNDyytRKj8GT95VUhZYRlUvHvMyXJmd0WUgn6qrNmkFT3OS5qi4zNiTrb60pXcMqhJgboV/IV0vshvVM5JsmVLAASrbpuTXOc2s4U3mHES3dXC20XDYQShIJT3azJE7Ga6r2Q2OUHMk4avEsVxRl1TcLSzbIUJBMxKt6p/kQpfnOG9qIbGcb10gKUpYJnedqriGG1uiNG/AFWPtgawljtBxNrA7u5ubMKR3blw2EOHwiZAJA3qsYYw9c3zTTI1LUdhtvTUXVETdyNy4tVNsKXO2mRUSlRSdUCat19g1+1auKfaCUhJ4UP8AGqeZiiF1uJqh7aVuuBKOVGpM2dy0wuFnwp1Vr4Mwq4vm20gEyTuY/WrlcZfuDYXL5WykJZUd3BJEeVKcqaQJWUNt9TZlKU7+lX7sexi+tc4NO2z6rdaWXCFtnSePMVQEBO+ry2966H2I4U3jOchhZxG3slOMOQ8/q0iBJGwnetX7iXweprB567ZF0/e3ReWBKg+vxH13p7zaStM3NyY3H9YXsfvWxhWXvh7cIbxzDXSkRGpwf+Wtr+jzjrwIxnC0eSS8qT/s1KbktzWDNNm3W6pxz9o3yVACSLpfPpvTWf2nbPuXDWYMRbUR/wDhKjP3qWbwJ5CXEIxfDFq0x/bQefUVjGVbx5ZKcTw/cD5rgD+VDTSKkWq1TdYlkZpVzevkquV6ngo6pjzqGawN4rV/z3e6gdUaxP0kVYLLDr+zyILcXdlqReKVrD4LcEcavOo74K5bbUl68sZ51C5RtP1rTJul8CIUkzSXl7Wo3Axe6UomDOk/wFYnMvFaypzGbsiNISQiPtpqascMxAtKUpdspKzAIukT9ppyrC6SolDjOxg/nI/jNZdLstSXdkScGXpKE4k8PCAPymo/8FC+y9d3TSEs4ghpQ/uWzQB9/DUqq1vWhKWkEnzeQf505yzxxVuHvhEKRHzJcRt+tWl7h9SXcrf9Gr1lIS5iQeSd1BTDZ/lXkbtDZwdedcY14E1Iu1hRS4oTvuYGwr2u9ZX3dd78IvxCAQob+29eCO1T4+xz/j9m8462pu+clBVxJms6l1ClJdAlYdgb8ItMKIUZEl5R+u1dk7Hry2sMHZw5rCrdLxUod6sqUYnymP0rzi1iF4xJauXEEjfSqK772F4TmbFMMt7+2wTEblnvFgPoZUpCiCNpinJMxpXudstMMv7h9LhFoQkfIGVJ2+i6lThylDWjDLEKQZk99z6eOsljZY6iFPYTdIhIB/KVsak0WV62oFdpcmRt+URNNx2NZSp7EGqyxVSgpWHWRQNwO8dH/mrRdw7MCLguKw6y7n+4m4cSf51af66nV3tg+gH95TSgP4Vlbte8l0MOKURBISaagUshWu4xG3Vray9bKIkbXq95/wC5UxlO1xO6xixbfwVplYuEwo3hUBO3GgfxqT0qaISple0dDtWbDHVoxezWytSVouER7zRGNMmTbK9juWVNY1f3iMNfWpx1alAXyUwZ6S2dq1BhDhZCzhF8QBJ03yD9vy6s1/eB3FLxD5V/0hwHyO9JNwwlsNBUJHTVRJPehp7blStcq2DzpvRa4mBHy960d/8AVpl1gVslBWkYk2pStJQpLUKHodQ/hVpQ41b2xCFoSFE8H9a0FJtL5I753UpvaAqJNQ47Aot7njzt7YOF9oriW3lOxbtKBUgJPHBgkH3qpsM3jrCb4Mr7heyVAfveVXT8SDbbfaGstAhHwzUT7VznDsXucP1NJJWyv50FRg+o8j61WNqiMqfWS7KQhye6WD9ak7e2D0qU3pIG0CajrNzC7xaNN2tClDdC3Ig+9WO2wy1ShSS8pUnwqDhFV19iKEhhxWkIQYI3IHHlW7btlDJ2I0ek71gD2FYe0pFxfrQFcJDpJP05qOusZN2FW+GJdbSeVqcMms1JxdsfSaeNLvbu4t2m+7U13qVkBQ5nrXeHMq37jDVwjEcLUhTYP5T5Vp24ICdjXEbPDIKVaSdSgCSOa7flS4dDSdSyQQBsdtqz6oyVFtW7TKDnCwusLx42y+7dUG0qK2TqRv0nzrUtHZkKMmY2FWzOtzdXFyq2D6wyFaiAdiagbWyac0oLi0e38atPbYJKmIhSiYMee21NbSpK9oSQPLapu0tlMgNtvK8QknYxUpbtOOJGu5JBO40p5+1Nb7kqiol9QEaZ/wBE71s29y4Nvl2nff8ASrqhixbUFFY7w/MYT/hW6hdm1u04Ij+4gyPtUyZSuL3RSba9ckjSSVDpvWdN6EEhICzHMdavINlGsqCVFOxSlI/lWa3aw7UQNMgwSpKf8KmSvuV1S5KQi7eV4FeEpAmRW5aXS9JSpYB40lUAirs2xhaQQlhtSdwSAD/Kt63u7G3RHwlqsadgWUEj7ihqinKTKK1coUto+aoBmB6dK7f2rtJes8GcZIIVZpO+0GKpAvMMDw12DCtJkANpIn02ro/aHiFxgNhg6u6a7t63BKVNIVHB6j1rbDTxshJxzJ+5nIUtOkAQCZjzrYuLa4aaSS2VA9RMCrCznC3SQpOH2ayT/wBZat/4VvIzsx3YdNlYpO4gWzZCvpFYyg75KTd1RT7daG1qcDqgFiT4Y/WaAeWp5KGEd8neSmI/xq3W2aba6vUtnBsOUVbCbJsgfpWfEsWs7F8sOYPhcp3/ACbRsHf1ArGWJva9zRzS4RUVud4kqUlKFCUmrL2bdrNp2U426/ibL79pdNQAyT4VjgkeXrTv23h7xT3OX8N9Nduif4VG4vj7SUP/ABlph1paCyfbc7lpLaypQOmNt96vCngmpJ2ZSSypxkdmzZ+LDKNjhNuLBL6nrlr81TagC0T0361x67/ERa/n3V3fX2Jp0zaF0qBt1b7GDChx0rizVpYX+Fs4q5dredRc6Axr2WjaYA56710jtUwDIScCsWsj3AKbdhtVyGnSolwgSIjaNxXa885pvbY545VOXlx/yitY32mLx/FE3zLKe9UB3hCymT5+lU7G85Ymu5fL12S4kHSsKlUeUmpfDcKTeEXTakm3bGzhVshR/vbc0sWwnDMNw1N29a2F2l1wgnXDmryB8q4+qDnRpLI2i+9jWG53u8CfzNgTyL9DdubcNt/2hLkktkxyKv8A2OZmuxm+wyRiNje2d23cquXg0qAnb/rARI/hvWn+H3P+HYMu0wzLmXMNasL9aG7hC3VIcS71USSZ29q9aYbljLtldKxGywWyt7t0Qt1DKQtfuqJNerix9FSjweZCcsieKX5v85JxgpLKST0G9EhJOxAHlFNB/dmCOax3d7a2Nsu7vLlLDLYlTiyABWzO6CeyPLv4icHcR2sKcwV1ixevstrN24WQsPoQ6mARI3Bjet38MltfOdofaReY/eNX+JtYu2yu7DIblPdggJEnSOetR3b1nLLWJdo7D1hjDD6G8tXbSylyE69QIE7cx0qwfh60o7UO09oGUnErV0f95gEfzqcXb9R+JJdMb59n9z0UgIiAArz2rSxrH8Gy1ZpvcYvkWjC3EtBxQ21K4BittEjSP73FYrq0tr1HdXds0+3M6HWwpM+e9VVDilW58WGrlKrgqcUsH4xKjsfWRXVHsyG2W6hxjS0owNJgjYf4VzVpDxdt21knvH0yRv1iuqHLtzduuulhvu0qkBZhR8zHFeHmyxg11A21FIx4ddXOIPl5byEIbSVAr3kR/Grhgmb2rDDn7Rq6uG33gFFYeOlYH7pHFVt63tLAyU+N5ISnTxEeVQ71q3rXNwpkJgwUx9awnNZl0XsJtPYnsezQtSmnkrTrRxoTsPXeo24xI36wG0KUtSCtQTEKJ67VX1tXCLhy4Lzi2kIiVcE+XtvUpg6GHWXFpQvvABASkxFaRjHDHYIxrk3sMxXEcAuBfM3aUXLEKZWD4kEbiD03qTd7ZM74y+1h15i7i7dSy4tCUga1q5Uo8k1WX2Wil51xxzUCISPKte1as5VcFfiQZSBsT71usrcaHu+Scx7Gbu/vEm5JSpPygj0/StW+tm1WqDiLiWwQIbT82/pTcQLN0pu5QlIUhKSNJkHpNbgt7e6Cbi5SUFKZBB1ER5isptxSJkm90Vqwy3d3t0tTdsttlJ+cgDadp8qjc54dhuHi3ahDjilqCiTJGw/SrnfYq/a2gSgnSBqM7T5TXPMddcv1JefXqVKirYDwx09acMmTI9+Ap2Z8ktWicXvnkWfeaUAtpSnZPi5q9W2L4lh7y77D7AtOq3cUk+Iz1mfSqRlO3Ui8xAsFbaQACVGBGrapjGMRUlxplLzngE7GAr6VdyU6RckW2zxzE8QuCL0lxKAVKV3uwmpJnH1pPwtssIQEGVT9TvXNrbE3G9KGEr/OWdck+L0nyqZubhwIaDRKUyNSQKicG53YopR2R6//AAJuu3/bngKnEy2Xlr1xEQg9T9a+r1m8yFEJcnSa+WP4ElH/AJaMvsNFQ/JdWoEeTZ396+oeHWlwh8PKuHNEGUhRjevM1zSnBHsyivIjv2/uyVXdaxLcxHMGoXFL91uEtWrq9ShJS2o7fatcOvoQQbu4O53KiZqBxXFVoUUKcek/vJOwH3rxc2WDdb/Q20+j9r1NvFkOPMJDaH5J3QGVk/wqmYq1iq+9trbBMRW2N9aLVe/6VNXVyhDJD61hAEySreqNi+NIcu1LtUXMBUHS4ADH93ea57hdHpKM4eza+TLHheG401Y+LDL5Ig7LYVIB968k/iXwLMT34hezh1rKOJ4kq2sX3O5YSgL/ALcEQFqSN9PJPSvRyMWbS18T3qwsJghSiT9a8wds+Jvj8QuC3NyvQi1y+4+NLhOofnq3PQ+Cu3RqPnLp95y6yUmlZff8nbljMGWezheLXuDusNvYlcuFTpHJbREwd5NeOvxO/iK7TOyjtoxnJtpY2KWbd0OaLliV+MauiuN9q9w/gRYCMiWRUlD2n4laQpcz+W2CCPpXzF/GgGnvxF48llvShLiEDbckJG9erganq2pb7HD4llnjyY+l9kdZ7CPxQdr2du0fAstizwpTd/eNMLDdsUqKVKAMEq8q+pjlm832kYW8kKbtGbVlsumN1BChp2322r46/hVw5CO1vLrq2j4LxkmPRYNfXm5uLV7tWSpSUsufBspSCqP3FbVPisIxjFpVyehglPJhg5er/Y+e/wDlD7bDrjt1xy+axtoE2Fkz3RtlpCNOomSRBO9eXMOFk02u4VjVstJSUjShzr/3a9G/jJwzOGfvxMZvy3lWwu8Qu7lqxt0WjKNSlFLUmB5x1rlWGfhe7c8PWE3fZ/jNuwEalhaEgg/U0tFPHhwR65JHkwhJu4p02yAsLTCbm1ShV+0rQIMoWAfuKlMLSvBbtu5wvG3LJ1BBKmXFt+wkGp49nOZcG1fH5cuGVJHjCgIH61AXb7WtTLS0IUkweNq6Y5VKX/GzWmnZ9Of8nriuKYtkHMN1mXGrrEX279ltpayCUo7uYmATXrRT9qlA7tLhHMFUV4+/ycjCx2VY685q/MxVpI1cbNdDXrcIQ7KN9TexjrXn6zK1maUV8jo1cVLK3J+n7IkEPIcS2Q0BPHiJqLv71DV26E2aFAqIJKlc/es9tdsNqQ13qArUAAVCRvURi7jLt84hDwSdZEBaeZ9658meccKaXf0X2ObBjh5tS4o5Z+JfHmrHIlkp3DbdYexdhASrUf3XDtv6VUuynHbO87XrVpuxt9ScNSSvR4gBhtmY5/ziKP40HrvCuym2uCsgN4w0dzuPyXvL1rn/AOHa9RddvlzhyrpPe22DNy0FSQVYbZf4RXXo8s3hlfO/Y6UodTUff+x6c7VcaGGZBxi8bsbZxDdjcqXqaCkgBtRgg+1fnqz7iX7Uzgq6FswzqS2NLKAhP0A2r9A/a/hl+/2aZhsrdtrW7hN0nW46EoTLSxJJ2FfADMOV8Rdzau0Q5bOqbS3JQ4FJ3HQjmq8IlJ5pdbPP1cYrLHo4PsV/ksytn8NC1tlsFWOXHCBPyI6xXsZu4uNWyvqBXkP/ACaGD3mXvw4t4Veol13Gbh4KSCUQUJ/ejavXILjawgMOK9UgkUtblyedJJ7HXqoxWWSa3/hG4Hn1GEn60PzXCQXFT6KNa/e3AUQm2c0+oFPSXCAvunRJiNp/jXNHJke/UzjcUuxkcC1IQO8UfEZEnypgPJMEp2BJ/wB9AvOoY7xTLi/GQEiOIrUbuFKVCbN9MnkwP51rmk1KKcuy7jhG0zZUtrWlxw8GZPpX57+3rFcaxPPLj+IuWziXbxjR3SVatMlSZJJ6K3r9AmJF8NPlnD3Vw0sgpXJJ08AedfEbtf8Awydu+K49a3uD9j2cXym7aU4sYU73YQG0AGY6KCqrRZY4s7eSXb1M5q5Ro8750Si5zZiSnQqPitMfRNVLF7dDN04ltJACgP0r0Jmv8LvbAjMOJXF5kfMdsx35Wlw4a5CxA3BI9aouK9imY7d9X7Qt8UZiCsrsyCPU16+PUY5O0yZ4nJuiP7G1LReXoC1pJQnYKiu04Ou5exCzaQ66Sp9sGVngqA8/WuT5Sw23yxePuYffoxAkBLiRAUggnwkTXRcn5jQ/mfC23LFaQbtkkdT407T5VzajqyZV0np6NdPTE+l/4onXrXsEx9kOpSO4tGVJiNQ7xvb6Vzf8DRRcZ9xFDrridWCPhEJCpEp1H0jyrsf4qLXALXsRxi9cwZD3fOWaQ0u8cHiU4kmY5iuafgpbw5WfMTdtMMZtiMFuCVNrcUQJR1Uojr5V52ii4ynTvk6s2ZSctq2PY9hYW7CNDl1euHclWhKR9q27RtAvWFW6HFfmpkrUBt9BvWNNxISJO4iAa2LFwG+t0DaXBya5dPkvNGNdzLMpdLbb4Zr4vcNvG5Qhq58Dyj4FgalA+21aVziqWEF26w9YHkh6ZP2rL3oU/dqCpIuXRseoXWtiBQ43oTsJk+tRqMiWWXsrl9itPij0xIsYmp151tNoolwEwX4Bn6VHXzDd2ti2u7J8I1a0hFyTuk+emtrCUKuk3b9w2e9ZuHW0wdoBiku7Sy4gttLCp69KmLTf5UdjSS2v5sm75Nu/kBLQtl6F3YQEl2CPHzIFc/vbWxtbx1xu2cLi0BLn58SOdvKrtiN6hrs7t32jCVX0AH/TO1Ue7Ns/u+0SkxJTvuCNq9HVezKLa7I8/TW3N78si7+9w9m3U2mwW46uY1XCjUL8HcruXLhzDUhpSpGi7cBJ+oIqevU2DC1EoEEyCeairnFiUqbSwrRuQeK5bvsvkdLXo2QF7aOKdcQcMt+7XIOq9cKiDzMJqZ7PGg/my2tsJwptlaG1qLjt4taQgASAnSN49agb/EUoK3VuqUR0BEH1qw9kNy4vObdwkiEsO6iN/CQK6MFKSdIWRNx/lnIu0e1xC5zPjVxh+X7VTBxO4JU7iTiFKVrIPhCCBJHE1SL2zS4yUu5UKf72jFlCRHq3XSs5BxvGcXeVcpSq5xW5UlMSn+0V9q5tib2IMLUAtCgkyNKp+9OGZyk9kRGCcCqXGH4UkKRc4Be26QP+qxDUSPct/wAq0P2XldxJ1YbiyFwAFjEWyR9O6qefxFy5bKCAAgRxzUG9cEOklMAGJiuhZE1tRnLHTJ/JL9hhN5cmyYuypdq42VXDqFbbcQgGfWqbjwtUYfeLbt7kE2y0NlTydIASdz4Zq85GUyq6xBy9SgJRYu6Jg+I9PQ1R8Y7xzDLxpCgT8MtIREkHSanVZY9MYvkySq6PBjkpFlIknElk/wCsmvT2crGzaw7Eblxy7LblsoAKSmU7f7682uW3iwu17pwOjElLclBGlJWkAk/Q/avVOe22Xsu4k2gSE2q1JUNyRprt10tofE5NKvZmzx3aQq5Xq22UeeTP6VZcFTNw0pRhIcTuVRUFh5abdUHGjA2nqTVqwa5tnblpruvEkp0+Lj1iK9jG/ZOCjE4htWJvgLGnWvxJVI+b/jeuldjyW1Y5C1pW137IUAsg7ObQJ/WK56U2qb5aDbuqAUoKXqgEk/6P6V1fsGxzA8KzlbXN1gC7pNvc27vdqdhJh0QFDRuJjascs5Qg5wV12KxRU5pN0dEzTk3H8Gxm/wAWucExC3w+6uLh74l9pxKPEBEKMAg/pvVJzB3BsMTbaW2EfDPqQpE7+LcATv8A6Vd+7Y/xK4d2h43iWTXMPdNxhhUi4ZLRS2I8juP/AErg+ccXwdzDcabtcLW2tNk9pdVcFREKgkJ7sbTG014vheu1Ot6nqMPQ0z0dZpIaVVjn1WcYyUr4jtEwhPflQNwXFExt4D0FfTv/ACeVm2MwZ+Ytm0lP7JZK1ajskqIKQQdzMEn0r5i9lzqB2hYG8u2U+lvUpbYXpKgEGTMGK+pn4AL6yu8T7QL6ww1y3KcFtwpSnCrUdatgCkbCvS1NPC7MMKZ6tbwLB1NFL7Rcg7AuKH6zQVhmGlYbRYsaEGZK1yNvQ71q3Ny61ZocKilJ0zI5p9s6VlYSpITHPWa+JjkadJL5H1XkL81/Uzdq1haXHYljDD7SUtt4NiK5BI0wwvitTs4wZFpkHLDQUAkYDYCdyr/o6Od6f2x3C2+wfHnSrZOX8RUo9I7pVY8i4m8cpZZtiykIOC2ISufJhFd+syTU+n3R/Y8nTY23JL1f7ksjCCtwPruCVgeEKAHXrFJ3DbkL1LvNSQCAO7G8+tZ8UxJrCbV+7cSVBhpTywnkgAn+VcXvPxRZMZUpT9tiBAUIDegn12JrjjLI3/6O6ONPc6jYYdiyvhnb29bcPfiUsMBKdOrYyokjbyqTz7bftDMTjQCUli3aIWEJJ31SJI9K4BcfjQ7McIc03ODY42hLoXIDRTsZgGaqGZf8pT2KuZkuXv6P5nS2ppCAQyzspMz/ANZvzXr4ceaemfF37jmyYf8AnjKtqZ379j3ZXpRighAnu+5bifONNaF1g2KXD6kO3iQnSCCGG4PpEVlyzmW1zjlzCs24c0sWeNWTV/bhxOlwNuCU6gJEx61vKu0oBBcOx3gzFccZZFtL9kbyxwS2RUr/ACriTjwcTiSGQD4ki0ag/wCzUWcr4i3J/arekkmRZtSR9qt1/egAlayeu/lUY5iCFsjSEkAxI3itIylf8GEo1tEjbZm7wPs7zrcN3rTxt7Nxbbfw6EIUrR1AA1Hp7V57xa5xsK7ti4wtLaoKAvDkHboOleh8Ze19mmbyltSlG1chQTIJ0cV5kvngfG84qeY1TXqpy6U36HEoW22VvG0Zgc/OcRgVzp87EJA+gO1cr7SLW8ZyxjJdw/CW1vWruos2ukgFJEjxc11u/tr66ZUqxtbl8D95ppSwT9BXMc+ZdzfiOB4glvL2LOKLCwG27J1U7HyTWsckIvt9DDJBpHjXJryms24K62ltRbu2iA4JSTr2kAgxXt7Enrq6yfhr6LKybdU87CChfdoVO5HinePOvHuB9nmfLHMGGuP5Ix9opfaWSrDXhtr3Py17Ofau2ck4U3cWNyCHXdWplSSDPWa9jHNdDpnn9LbpFGun8bLjjarTDikERCXE/wDnqIvBicrcUxZnoQCsT+pqxYhdaWylSCkmI2g1CvreWCoIOkjYx1qI5E6Llikir5uQ8cVL14tphC2kFpJc0k+EedUjMSHTgt+QppSe6Vq0OpJG3kDV4z1dKvMWbUGk/lIQjfcbJAqq5mY05cv9CAFd0ok6YjbzFZ5Ipyth0yWxznJKkjNdm6pCUp8cBJgDweZrrlsEJWl3ugknlWtMH9a5XkFhf9LsPUu3JTqWCI2+QdK7cwy04VIctUBKfNM1TUaJXVF7FjacK8j3ujdIuG5SlQ8vf1qjXDL6nSpbCw0khJII4H1qzu2CXch4naIR4XLlkgdP+N62k4ZhibULVbIJCJMoBmBVZJVQ4Rk9qKrbMOfE2ymUrCFOJBlMAb0M6EIt7ZaliWrl5BPnFTq8Iw5LjTzNq2FJUlaYSBwfKoDPFsp63YNswlLS7h5R53VtNR5kXFj8uV8FVN04PAAFtkTMzFYnlkYfdKQuVFSNvvFBSLplOhDG2+0GaCU3BwS5Wm0KFuPNpB3iN5rOM0u43Bp2kc7zGsuOBSRABg1DNidXoK7HkPsSxntbViLjGYsKwhOHLQlYvu8leoGCkISZ46xVle/B7ilmsNP9pWApU4kQPh39wfpWUtZgxbTlRpDR58q6oQbPPDSTvvG2/rU6wpQSlClmUgGB5V0HMnYGvKKVqfzrY3ak6k6be2cnb36VR7rDGMPfDKLhbhJ0p0tkEn7VUdThzf8AjlZM9Lmx/njQhcAGVKJUN/epNh1C0RztwPOta3wa6LxC7NSvIaymP0rfawW6acSU28k7buER+lNSTZDhNdiy4g6Ft2HfaSRap5nr/wClMYfaQgnYzI23pt2rES7aWqLRohu3CDJI8+fOmNsYipxtHwLIPTdRBPrVSnFbNhUlsS1spDre5AIAInetl11IASkgqVvWvbs4oGigWVoknkyvcfek7Z4uloOEW6Nv+zUr+dRaKUJVwBLvCEgqVJkeVYbhTgt3dW4KDIms9rb3qkFZZtzvEhtQ38+a3E4JjF+3ptLcuFIOpLNqpRPuBO1Q5JvkIqS5RxsKWh9jw+JChE8Eh6uxZl1JzNiRESX944HpXL8Wy1mS3Ce+wHEkAF0eKzcSI1g7Eiuy3WHNOYtcPvpSlxRSAO51EjSOTXRkdxpERjK7SIa1BWr8zZI/eBrftnWUJgqk+Vbn7OBXIS1HEC3TtW7aWlukJDpSrcyfh0H/AMtZJquTdRyPscczOrvMZvySUDvWpg9dC4roHZveIGU7BpS9I7rg8cneapGcEPsY5ihaZUpBfSSe7gfIsGOnWut9l+KqTkzCbL4GzAaYglVmhRJk7nUmTVyalBJMlQk8nB5+7RyF5yxFaRspwEfaoXCkleIMI81Vee1PDTfZyxC+CEoLi0+BlkJQNgNgOKrKcu4harQ6lLgWnxfJVRyRSqzPJjnGW6Jq9SfgXkzuGzB+lUg8VclovxaLD9m5pUnlIiB61Vu5a38DkAwP+IpY5WTKMu6M2AqCcTZJ41V0q6YKsHuyNgWFbT6Vz7CGkHEWyxbuqVPgB4Jq93rmNXFklv4Q27RSsuq0FSlJA4FTkabHCEn2OZMaSl4H/s9vvV87IkFrN6FNNpUtLKtJHA8O9QaW8pA+FF5uN4B/wroHZHcZNYzhbqYw+6uFqaWFJdWtCSNPnVyyLiiJY5PZHd8MWfhdQcMhABJ4NbmtSXElJEkcjcVs2+GOvtN3GF21mhlcKShxxwwPoRW+/heJqB/5pwpJjZQfdIn6qNTa9ToprsR1sHyVDUCB6xWcuOtp2BJPUGszOF4y0oL+Ew3eNQS66JPmJJFPTZYul1RXhlm8Z4+KUP5UutFOE5bUWGzdXeZAu7VTmj+uBUapVxzVXbsn24SXfCPlPX2NXOxsVtZNulrwhoPd6k92m6JST/paZH2qqKv7/wDsmsFtUFJIM3hIj/UractkxY8U2mkjGyb1iVrCtMgAg/yrN4nUHWo6TuQeKf8AtW/SvuLbA2nFckm6OkDoPk/lWK4vMUKyhzB7RG0+G9M//LqFJPhh0ZFs0YXLZ1TDiFOFaHJSoDjj/fUbZsIwi3FpbXLziUGYdcKtI/ux5VPoevUkrfwElKuFovUgfqita5YYeCyvCrttQEjTctqEgbcpFS9lsxeXL0Ie4vlAueJWqOtePe0pwu56xlZM6rpRr2k1g9m62Vrtr9GpMKV3zawD7QJryl2jZUws5zxRVniV33arhSvHbbgnkbKpQbu29hyxzlDg5pFdo7FcWv7S0QzbXzjSdajCXFD+BrnX9EwZ7u8dXB4+HUCfpNdh7HcmYQvBkXTmb7m1vlukG0GGFxKgD/fKwBVzlaqLOaWOdrZnWLPMGLobSn9pXHrDh/xqWt8cxxMRiL+nnd0g/wAajmsvfDOd2m6uHEGIPcIKvtrqUVhtvbW4dUL8uEEBsWid/rrrOGV8NnR5Uk94j3M3ZiU4W04zeEAQAXlET7TWS2zPjjKg4cTuC5PJcMionu3y8SGLxABE/wBWJj7E1uoZt/ElxV0Fnr8I4a082uWJ4JS4RK/08zK0SG8YuZVyCvmpnKGbMZv8at7a9v3V2y3E96kxunrVIdetGVFL77yQnYk2jv8AhU7k91hGPWa2rsKSHEme4cSCJ43TVwy26sbwSin7JP5lzFithjt3a2V84Ge/UWkqA8KJ2jbmslvjeKXaEqfukxPzFtIn9KiM5OWbGZLwvvqDwdUoBLaykDy+XmtOzx+3QFlx1HdxE904f4p5puftch5EqWxbV4rfMkKaLB28Uso/wrRucXvi8VLatloVsT3KZH0io4Y3hT7OlN4lCj1Uhwf+WtcYjZuIUX8TYVJ+VIWCN+d01Msl8MHhkv6Tyz+KW4Fz2iJd0ISfg2h4UhI2noK40NH7012L8TKW3c7279upK0uWLapSNuVbfpXHu6cJMIJ+lEXtuTni+vjsZmlWYMONLUOkKFS+DNsvXC0hK9AbVIKj5VEtsEbLSoescVYstMkXitvD3S5AHO1NSVmPS2Y2F4cp4KVYPK6H83/dU9ZP4WysFWFLUlW2kvkH3mK0LazBWFtpKgSflqXw6x+KdKVISY9d6wlJstQ33J6zu8EUEq/YcJEbF9RmuyZczFlk2Ov+guHtwAARcvyTHPzc1yW1wG+cBbtMPuHONIS2TFdFwnJec7SzQ5e4Jc27KwNJcCUg/ciojl3pFdCe6RX88u2N7jGtjuMOSuCWvGpI9ZqMw2zs1PAKx2yG8SrXx/q07tCw7ErC7DOIW6rdwpCkJURKh5yNqqrDcJC4meorZOuQnFI6L8BYNkBOY8PJM7jvP/ppjtjblwJazBZHzAC//pqnMuSAuTMwBWwlSlLCwmPQdapuJKi3uXm1wTDnG1ODNuFpUqNlBwEf7NbT2C4a0ElrOGEr2MlIcEH6pqgocdcWkNp9SPSsKrl1KgEpIgmfWsW0+UaqNxuzpCMJw0N6/wCl2EuK6x3u33TWdvCrRYCU5swhCBxu5v8A7Nc4YcdSkpKDBGw1bCtth5wkgDcATHlS6hRXqzpFvhOHFRS7nDCUA9CXNz6Qit1rBbFCSU5xwVTh9Xdh9UVzRpxy4WkkaBO0mDNSTPibJL6pSYE7ifvUdauw7nQLPALddwhX9K8JWnr43B9flrpfabll7HcEwLu8Zw627i2KSbpxQDg2gpKUnYD+NeerRbigpDbqgSnkHg/zrt2Z729ey3l5F2tKAi10wE8jbrW+OdQbRm1/yxplNT2cYiN2MyYIUAGCl9yCf9Sth3s5xPum1rx/AhI63CwJPT5KKFhmNLqST1NZ1i4ca8avCT5frXO80U+DVRle7M1j2c4k4tLrOYsCGnyulEx6eCtm+7NcWuHe9RmbADIEg3hB/wDDWpaKuG1j4dShtzvJrG8u+Qkl50gztKT1qHmTKWNtm/b9m+MpRBzHl1G+yDfAK/VNcu7dsu4tlTCWrh/FcNeRdrLYNpch0pAG4MAQDNdGTdOoQlNxpUqY1Cuf9slq3iOHWin2JQ2omN4J9YO9PzYx3HHGk38DjeEF2zXYuMvurUhetaQCEDyj+dXa3zG5bOhXeoBVKloCp1b1UbzG27S0b+BtytsTpAG58yRWha4w7d2JcTZpSVLgKJ8QV1A9KSUsztnB0pM6ZY5xsXXrhIeKW1gEoUjZRnbaqbjGIYliF8+e7bLdvuCP3R0mKzZew83lupd2O5f1wkrMR5Vu4nhn7Myl8Ra3CX7zErpaVsoIUUJb+UH3JmohGMZWmXGV+yjJ2RZvxLAM1WmIG2NxY2Lqn1WyflV9OsV63/8AtYlK+7s8JYaSpA0NuE60n26ivEzeKY2FQ5bmzWToWpDYQYiI2FT+FW79u+1fXV2t9QSfCscbczM1tk1mbGqjLY44wfmua7nrFj8X11hjVw5jWCIe8Ut6DpCR7darGevxQXebsCVh1pbfBF4ELLZnUJ9eK8xZgx2/kJaCVTMLJ48jTcPvblpoXF9DaI8KydlGiOoz5Ybvc743CSaMnaLf3jt/a3pxFTi3UKEqUSa7L+CPtDRh2ecy2OaMeRrxFFupLjp2WtII3UTttFecc43yb55lVsvUhJIiN/eoPLGLXeEYu46y4pKykSQeK6dLkniV9zHXY/MxV32fyPtDa3tpeNB60dbdSrgtrCh+lP75udHepCgJgnePOK+fWE9qmIZVwexvMPx68YbuWxMvySoc7cis7P4hsaXcruUY9furUCgq1z4fKtJeJqG0oMzhmuKcjnbfYJmBa2HRidtKVhZGlSdgdq6E32f4wtPwyLxsOaT41oUpPrU3j+WcNuFMO3NoSprdKw4oGfQA1bcNtGzYo0vKPhACZ5EV8Hk8U1GZJTf0R+sx/wBMeHzVOL+bOVO9keOvui4dxFlZGyZbIE+lR2K9jGPXzyA7iDA0jbTMD333rtqcPcjdl0oTxG8+da5ZZW6UISr3OwrNeJaiEtmaL/Svhn/V/N/crPZLlW57O7y8v8XFninxTSW0IUjSEGeRIO9TObF45jhiyatrNJUdxI0jpEDmtt5hW4SlaYIPyiRVTzfmy+y+60m0t0qSsEqUtPWeKiWtz6jJzuzWfgegxRS6dkVrH+yjGsbj/wC6Vpr+8CkwTVePYLfhQS/mcrKdyA0qI8pmuoZQzOzmoC0hFvcQoq1K8Kh6T1qytsKZWGSsEHaTBrb/AHHW6bZy+iEv9OeGZF1Rh9Wc1tuyCwNvZIReMMrtgsrcDZl0nid+lSGGdkeGuX7LWJYs7dWZILoYAacKeoSpQIBjrBroKsOeCUpaLS1EEKAO9AWz9pHeEjRzCgKheKap7zkP/wCNeGrdw3+LNG47IewZtXdXWB5tWhY0gft1nZPr/Vag8R7EuwO9HdW+VszkNElKzmJI/wD+arOGnLhSg6tIkEgap3+9ZUYcgL/NeGydwF1UfF9RezD/AOM+GxXtQ+r+5z1jsK7KcOU6/a4NjjTjog97jiVg+47gTUTedguWLt43Nrd3LZiAlboc+pOkV1xvDkhWpbqgBsJVIP8AjWNzC0ugupuG0QYKdQFJ+Mau/wA1Av8ATfhj26Pq/ucTV+HtkpWlvH1JkkpAaE/cmuWZju7jJeZLnAG20Xb1osIDxMagU8aa9gqw5q2tUvC5lY6lQivH3aShK+1jEytClt/EpTIEzsOtej4T4hqNVllHLK6R5niXgWg07xrFGrdcv7nrD8J+bV9ledML7Qcfsbq6sba2WE27ZCXFqWjSJKthFeo8wf5UTs3yljTWC3+QsZVrbDilJumpAO2wjf71ScE7QvwsYflGwsmsgOXeIIw9pC1G1USp3uwCdlf3t5r55du2H5gwbPZZxbDLlh1y1buEIcag9ysqKDHIEeddmKU82fozRTX+e85vENJpMSUXjara3w/hufZLAfxo9iWP4FY4n+1rywcvEBwWztqta0z0KgNJ+hpuJfiR7Fr9C1Ix++CSANSLFfzT7V8nsr9vdhhOB2ODXDGLOi1bCFIFvKPpvVltu3vK9w6SbPGmkKIAR8LqiPPeoy6aEG2oGK0+lT/4p/X+D6QX/wCJ/sIDgsncexFS+JFm4naofEe3Psp+HDuHX+JqQV6gFNrJg8wBFeKsLzxgmLtN36lOEq2T3jJmPrW9d5xSCRYYg+oI5QGwI/3VwtY4u+nf4nTHQqS3v5nrprt37JLFWjEHMUSpfRLCyTPmoq/lXAe17OGSc1dopzLgV7dGyOEqsUKWlSF94W30xEkaZcTJmea5rcZ4cWFNh27Cv7wSkD9DUJcZhduHjr1KBMeFJMetZxzeXPqxpWbLwvFNJzs9Yfhx7b+yfskyxbWOMDEDehNwFpt2S5qC4CQFatuI4rxl2/8AZjcdqPa5jXaDla4tbDCLt8Fm3vFuF4AAAztv581MHFL4z3b5bQo7E8pH2/hWpd5jxNDwm9uHRwkRI/jXR+MyqayQSTI1HgukzSU5Xa95Kdg+SUdnOd8JzNmS+burWzuEOrbtwoqUlJkg7CvaqvxT9lgzb+32W8SatSyGg0q3QXVEJiZUvTzxtNeEWs1Yim5Sybm/QtzknUE064v3GH/iXbhZO3PQedXl1WTKl5ispeH6eMUo3SOzdoHabeYj2s4h2kZSatLW7Rcd9h9zcW4WtRKNOl1IGkiJ4JrXxDtm7X8dDwxDNGDMvKICO6wkEcbkFQ2+lcY/pbdO3ItUuXZAO45A9pNbyM0LauR3rl6WyP8ArBun9aw3UemhQ0mniulXRLZnxLtUxa3cQ/m3DdKwUEnDgCZ9qqLHZWbhaX7rM9sFpAU5+UQArzFTxzJc3KlIY72D8zipiPoaF1d98lpxt5XgJ1BKYE+u9XjyZoLbYc/D9LLeS+p6x/Cz255C7EMh3eUszWl1iz1xeG7DlsG9CRoCY8R9K7In8cnZAwnQxlnG5HypbLU/xr52t4vct6HW191AhKdMSfPmsNxeud+HzdLU6sylpK9I95mnOfmS6ppN/r9yJaHTZJW09/ez6RWn43+yxltt9OVcZmTOru9YPmRW8v8AHT2TBYS1l7F3VrMq0Lb8PvvXzhVf3rbKim8eLaICtIlQ9PmrDbu3SklacQuUpJ3SWwIP+sK1hqYY49PQv1/9mT8I0rlvF/NnvTPf4sOwXtCw5eVs4dm2IY3hveJf+GuXW1t96mdJ08zuaouF9t3YbkS9exns97MrvL+JOt938ZauNpXoIA0kxMeFP+qK8mN39+w44ly4cfSfEFFAA+p1c0y4xV93Z926TqElOyY/WslqZQl1Riv0v7mkPCtLHs/mz01nH8VOMZswO9y/c4/iK7K/ZWw+2tSJW2pMFIOnfmvIOK9j+GXOaFYrhWIuYfbLCA1au2xcOw5nUNj7VOLxFxKEoZSsiTqJUFbegmtdGKYj3pXbC4JAISZTr+gJq4azL1dSpfoTLwjSX1dP1PY34avxR5Y7FOzdvImI5Zv8Qu2rp19bqHUNphUcAg+VdaT/AJQDJTiO8byXiG2xBvECP9mvnA9jV9aqQEpunX18la0jbzO9YlZlx1C0Jaw90MaZWpahur+VE9XJvqaTYpeF6TJLqyQ3fvf3PpO9/lAchtiG8rXayOUi7BIPr4K0nf8AKG5PQs93ki9dQlOpTiLsED0+WvndZ4/fv6VO272hZ2OtO5PU7zArdeuL1u4CGlqS3IOoqABMeU70fim95RRa8E0NX0/V/c+hTf8AlAMpXNshVlkS+fcXKlNi7EAe+itQf5QPL51KGQrlCU7HXegR9dFfPw4ndqd1G9WlIkeFIHHPWn/tJh1BSq8UlR8WgCTp9TxWWTWubtxRrHwTQpfk+r+578a/yh2BfIjIT6pHhi8kf+Gte+/ygGHra0oyagKn5TcKP6xXg1OOjWFOPqUlIARPhpr2ayhkuNupDUlKoVNOfiOWcVDpRUfBdBHfo3+L+56mzt+Ltec7f4VjL7bE6k6kO6jE7zXE8Yx7D8bu1uPXq2S4CCkMbqPkN65y5mi4d8SGkKbBgwsAjy2rTXj1s44tN8CoL2A72NJ9INENdqI7LYJeE6NvaI3BewjAbG9vL0Zmve8uXC440q3EIJJMTPrU7hfZlhGE4ra4mxizr4s3UOhJSlGopMx6cVp2+ZQtTbXxC1og6knaeg9ayrzAywFNqd0MpHzFcnfpFYPV6ly6rs0h4VpIU1Gvmej+1v8AEh/yr5Ldydf5c/Zabl1lbly1cF3ToWFQAQNjFO7CO1bLPYrjl7irzT2NLvrD4ZLKVdyEAkKJJg+QFebUYuu5tw/buuvD+6dKY+vNOGL4q2yoWlmStRMhb449PSjDrZ45OSS3Ll4dpZX1Lk96s/jmy7cL7hfZs4gJE6l4jz/sUU/jmwGyfbXbdmwcUk7LTiB2+mmvATGMX6IdubmRMKCXAY9K2EZgW6UNNvNhKfEVBfij6VutdkjvGEfkZvwnQvlP/wDJ/c923X44sD8bzfZ6yrWStX9Zc3WfPitJz8b2HBvvHezfDwraP6y6f4GvC1zjPc3SGFuBZUZEmNq3bLGGMPcK03BdUsk7nZPoBS/HZZ/0Rv8A/wAjXhGgSpL6v7ntex/HXZrbdQjs3sGwSVR3zsKPnzWiv8bdjevraX2aYQgaY1LceP8A5hXjRWPLeeceUpCkIMgFQknyjpTsQzCH7RxhpAbcSmFJJOlXuZ/hTWtyt10R+SB+GaGPEPq/ue2nvxxYErCGMFfyLhJtUK1lpKnFIBHBCff1qvr/ABl2Tj3dtdm+AFkSAQHufbVXjSzxMKaQy5d92E8JQZH3p5zC80r4ZpxIUlRIdTvJHHO1Tk1+a94r5IheGaFL2Y/Vnse7/F5bPoAZ7NMuLEFSkupe8Pv4q0lfirYICrnsmyslJTIOt/efTVXkT9sqfKe9vG+8IJWQ4Cragu/eftUOLxAvFCjClbAenO9ZrWZWvagvkh/7do1/T9T1h/8Aajwt8KU72VZXUgetxv58KoWn4sm8FfVc4d2f4JZq+ULtVPJJSem6jXjlrE8WQZffbbZK5Gl4SlU+UTBrfYxHErm4cau3kBOkKSsL2JNaficuNKUUvkT+B0bddP1Z6gc/Elgd8lZxDsuwhZUpS9ffOjUokmYmJqOT20ZIvm3HbvIGENrnwJCnjq9yFRXngXF8RDa2CEyCC/InpWO5xLvAlJUy2sIhQR8p8zxWa1mT0XyNY+H6OTrp+rO+udo+W8QChZ9nmE27cfMl9wmPqear+OdoWVcFsnsQvMk2brTB1EtuulXpCQZJrldljNpbILFt3cpIK9SdoPSsWLYjdvYhZYnZYubJFslSO6bWCh3V5ginHW5E6dV8DR+F6N8I9Xdmn4zMKynlq1wLAuyvBHbdAU4HrlK1OqKjJCpE/rVd7Re3zOHaE5iDKrteFYPizQacwyxPdNIQRCkgxqg9d6hezTs+yziPZs7mzNGazbOuPKDVnbu92YTtqV1mf5VR7vG8DYdfZReqPckpStfi1J6EmuDUeLT1U3hjyvcbaLw/QYsluCv3/wA7Fkw7OGZcKwW1y5hOMXLOFYeju7VjUAltMzA2nn1rQxPGcVxVI/a2IuXKVgpIKjxHXzqLczlltppKm7gpUYlJTJ9xtwa07zNmXnlh3viqPCRBH8tq5nk1Xqz2Vg0L4jFfI0L7KeVMYUF3+XbO50q8Lga49xWpb5EyYypbrOAWadKgoBKY3FWC0x7K/d6FFaSogfJ/MUHMwZbbaU+46ruwsJktmPvR16v1fzY1i8PTrpj8kQbOTctQ4G8t2q1E6jLQ235rew3BMJw1Zdt8Pt2lgj5URv51tt5qy4sf1d5adR07p4H8TTkY9gNuye8eDviOhQSRHrvRGeri+X82NYdBPbpiv0RAYEzaq7QM0XV0hlw9zZqJiZJC5+u1WC7scIxVLrBw9tSHEkK7xAhU81VMIxvCF5xzS+CsNKtrItHTttrnarLZ43hTQF004oyEhQKIMV1aqWeTXPCObBi0ai01Hl9kYsOyfljDrpN2zl3DmXkbIdaZCSkcbGNp8qumFZhxrJ3f3OWsZuMIdum0tum3fU2XEDgHSdxVV/pLhb7/AHTS1eE/LvJHnFbb+YsB0Nurc1RsTpM+1c+OWoXDf1Oh49FV1H5Is7/ajn9xtCUZ2xfRMqC79wn0PNYV9qGfGZ1ZtxZajuVC+cA9OtU5/GsDUsvNqdSk8gs8+tMXdYWtvvmLh4wRqBTBjy25quvUJ22wi9LXC+RM9o3ap2iX2SMVw+7zji7tquxebLK7xwpKCgyIJ43p+BdonaA3l/C2zm7Fy2ixZSEC8XAAQI21cRtVMzte/F5Zv7W1acdcuLdxtpIRzKY3q45IyXmHMGD2xw7LmIuN2rNqzcuqZhtjXCEFav3QTW88ueeOrbd+vuOdz0ePJculKvcbv/KZnO9tnbR3M2KvIWjQ4hV25BBkQQVcelVPC0i4bu03JUtaLtwAlRAAEbCrrnTIz+QbvE8Kx7EMMZv8JxD4C4Zbe1rK9AVrSmASiCN/P2qgYbeYVhwuSt/vUrunHRpMDSqOZ4rmktRVTs2hl0WRdWJqn6I3H27EDR8G2oDeFNah771HuYRl9xz4p7CbRapkktJB+gis1xiOFuKKleBHJgDj70bbFsFCFLDhInSONj96nozV3N09H7voWOzzzjeH2TGH2GLYkxaNJDbbLd0tKEJHCQkHYUv+UHG7cJYVmPFUHVslFw7/AI1V14vghcDpWoKJ0glwc+01Ss2C8vcWVeYddoDakJSkB2FA9duBW+Lz5SqUmvmY5cmlgrSTOiY1n/HWn22mcRvXQsKJLjzgJI4gzQwztHzBd3Ldku8u2Ek7BNy4BMcneqPl+4trpTSsafadU2NDSkOyR5zxViYxHK1m4lGh0L1ETr6inOOZd2/1OnHq/DJ4qcFfwRdEZpxbQpp3Fb8tuj8xHxC9Kknz3rTVfLdc71ta1nz1KiPWtBOYsvKYQ+X39QVukQQBWVWbMuNgh1byNQOmBuQP5e9ZVqm926+Jz9WjirVE/hucs2Yc2nDrDMuJ2zCfEhli6WhInyANZH+0HPKkuMqzRjCgQZCsQdg/Qmqecdw+W7xtu4KFqhBCZAT5kzWyrH8tFKmCq7713eO72+9U56nhN/MhS0bd0vkiVdzbmJDKUJzViEkcC8c2PHnWo5fYutGl7E7h9AhXjuFrJPrJqrt5gwNi/XaLZuEto3Ijatx3E2F6fgNaYHikSaaepjvuHXo2uz/REim0S6e9dYO/VSZrA9bWjigytlCADBgCsbeY7VNqEqdeStatBIRMVltMUwa2a13ZfUUeILW2Tq9amctUt038yI5NGnwvoa7+D2JUHFN2ykqg+ICaYMJwu5QUiyYIneWxJrbaxrAL5ZUl90JElIDWwH13rBc5iwBpC2w5c6T/AHEAq/3Coa1L/NZv5uij6fJDLLLeBsufEqsGQ5/+KSnT9utZ38MtmmlBtlsJUYALe4/nWovGMNDZFpcrSkGQXEyY8o86TeNYaH203l44ZM6SkzHmKfl51w382T5ujfp8kZDhrCkQLZKUkyU6fKthVhaqa1KUhMbRpimpxfLlu4parp4FJ/ebJkVuqzBlVIUhb6jKZB0gfpNJvVSdK/mzRrRPsvkiNdsrRoIdLbR1AydIM1jtsOsLhsrXaICZkyBE+0VIt45lFYWUPLeIMNxASdt9uRFaq8xZeYPdFSiZkJQ1qEefpWfTqVtKwUtH2r6GMYLhjr0t27QAj5mxPqKejDsPZXpFm2NRgQgQfpTbfMGFoVpcQ7qT4kgNfMD9a27jMGCykhZBEEKV4Y9h50PFk95qsmlW1L5IYnDre1bUbe3AC9lBCAkqPqRWRlTJEOoCyDCtSR9KYcey+66si5dnoEoJE/emIzJgCG1NKC2tP7ykTv8AQ0njzVUUHmaXvRmctrF1UO2LCEx8ykjetT9kWC3A61YsETHibTNZ1ZjwJ5gvOOXDiUDZKWxueg3NKzzLl1Q7xSnEr0zAROk+XMTUrBm5ob1Glqk0YrjC8PCt7FkOeiByfanMWlkwCF2LKFjbdocVkezHltsqfU4pQVEw3pM+UdaP7awBz8xu4elW5JRx71fTkXAo5NLVbGobXB1rVrsGnAoEEgAb+XFawwu1KkOLw1ooQSNmht9RUijGMvpf/MNwoHf+zP8A6VsN5py0oqbSpzwpnZOw9xTePN3TCWXTJVS+hGIw61LiUjDUJEbAIFbruGWLKgBZtAJSNgncz6Vldzfk5lR7+5dStAIMJkx0npTE5qyvcJ71Ny6ELPChvHvT6M6WyYlk0j5o1EYdhSlKKbMFYUCrgJFSNvbllRNqSwkDlhZSr9IrSYzFlZLiEBxwpUSpQ0HdI6mK37fM2X3Rosg/pUrSZbGlIPHrS6Mq3E56V7bBUFXCQPin1AyCHH1kgexO9aD2DWLi1KbtwpQPi2nf3rcvMUwpKgC+5JME6REe9BGNYTbpSw+/3IWSBKRP8aq8siJS0yW1EWbJCHC38OwpABUG1IBJ9TQdsXG0BFvbsNKXuQ2ymakf2zgrsLDqndPKkpAMeu9PbxSwbeLhUtJjTMAkJPsaFjyi87BwkvkQ7WCturDlxaIWFElUtjc+c1sowuz7tQQ2QEbJCYAHvUmcfwS2Ue9DriQSgBISmJ5JKqw3GM4G0Ep7tRSTCVjSZnzA3FOGPNJ7WOWTTL8yRFtYDYvK72+sGilR3CkAqI6TW4MCsuThzS1A8FA4rdGOYFb6FKhzaE8Ej6b1kbzHgSHHdSH1KgEaSAVefNTLFkXqWs+CuxE3GDWUEsYXbkcqlAE1pO4XZElS8Kt/MwwN/SrYrH8AdIatrd9UkcgbGd+JrVXj+AoeShaX51AfKkb+W55qHhzpA82mfoQNnhloHtTWH2rYSRpT3UVnusPwtToWuxaOnYhIGkGpp7F8BQ6HW2nCFyQZBP8Ax61gXmLLKXFOJtChtQ8QEzPmZ/lVqGSW4nk08eUiLtsIwhohTWF2wUVdWdo+1bqMBwv4hSWcNQHVAmQ2EgU1zMlm8gKDhS0lW8AKI8tprMjMFotxGt4lKuQAJSPvtVrHkIlk0ze6X0AS1ZAtu2w8MhJTz7x0rTQ8XiFtIcCBv82x3/jW9d4xgruoKXp1fMTE/eawt47hQBC0pSkDYggD0ogs8XyzTzNKlskJFyGylsOKMkkA8RWw2+0hwKISvzgbmtZeNYAlamHBCynwgKG/16UW8Wy9/wBQFqWmQoah+m9NzzXu2ZuelltSJId2ZJRobVvBEmKYlvDHFKKmxz/d5qNfzNl55xu3XcKQoykAkT7UU47gzLoaXdNgc6TIke/Sm1qG7VkLJpF6Gw/bJcPgZKVAxqBgKrXftbZP5YY0lXzKBms72OYQlSNAJSvdCSoCfUSaX7cwJtxRWIHOmQdx9aFk1C5spLSvfY1XrYggNrMIEDUJBNaz1qt1HeP6kmIISmEbeXrUzb4vhTqyEhcLndKBAn3rWXiOEsKWHlFSEK8RKRx9+apZc7Vbj6NJdqvoYLFlkHRcL/LCRCYAj286YvC8IUsIXaMPFUqJ7tM/U1kexTLy094lxaUCEkEajPpWZGMYIq3LyYUocygzFS3nns7J/wDqR9PoaScNtW1JU1h9swI2GhImsCGbZp0tNsNnSZlCQPoKkP6Q4ReuIbUwRsQrYbR+lZG8XwMHunVoTp6AAmPPY1KWWL2RXVpZLt9DXb+CUVKVamOICpNYEWrDbgKlTM+GDMfetm5zDgVq6lT2rSCEoVEzW7+2srt6FlRQsDUVaZI+lWp6h72yH+EXoaCEuF0pZZCELEf2nNFbbjWoJBUSNIkkwfqakbjG8vBSFWxSttXjCtGmtdONYFepU60sqgxpI9aTnnfqax/BxV7Ec0w+6N1ALG+mNMf41kcXflLaU7FGxjaD57cVt2OKZdUl0PNL1oPBX+sRtRbxzClqcAYASQSFkgk/ak45477i8zR3Sr6GgLp9t9S7o98V8ggzQaW/3odXbB3aAFiBHTapAYnl9hQL60BRgqkmfSnrx/LqFuFT6loHBKJCfY01lzve2JrRt7pfQ0mrhx4rBt0JcnokEEVsNizUopulJSfNSQRPpRZxbLS7ttAuHU6jEJbAJEc+1bTWLZRlMqdcKSQQmCenntVJ6h82T06RP2UvoRl1g2C3a+9TaWq1qEBxxlKh+orQeyvgyFIcVh9usTuEW6RP6VPjMWXSpwWiUpbHKd5H3FMbx/AFvd25dJSnSVbJk7fSuaWPNKVuzaH4WPKX0IV7LWXVQpzAbEBSRALCZB+1YE5UwJKypOD2iFf3kIAI/wB1WFGO4A4ItlSnqVA8isCMfy4S4VXKSpUhQ0Gab82O25S/BvlL5IibfKeAkErw60M7T3KQJpMYRhFrdFBwm2g/vBsCalWsSy+4v8nWUgCdjz7RUtlzCnc65jw/LuApLt3iL3w7CAmJVzv5DYyalvK/UP8A6UE5NRr9C29n2DWzdku9btmE96qISjgA1D/iFx22wPIzDSpPxt8xbnRGpSCqVAT6Cuh4XhTmEMpsS3/YgI8Jnccma8y/jBzNoxnLmXkPEJZV8WtH90lQAn7GvpNHh6Yxh3Pl8zxuc8jS6VZxrNWcLnEMdvcJceLbKbhXckxskcA+1ZsNwi/KgXHHFJO/HP6VzzOTpGOXhSr/AK1W4PrU5kTtOv8AAnUWeKPKfsjtuAVI9fWvof8Akjj6oK2j4nPi02TWPHN9KfyOis2TjLQb0KSJM+CCa3bVkNvJAQF7cFAO32qdwLM2DYq0m9tXw4gQOn6+VTTmP4alCYbQsatiQNq8ifi7TalHdH0GL/SkMiuOTb4fybXZ07kfDvi15rwS1unDp7n4hlZAG8iEEVOY1mvsftWT8PkrDS8UgwcPdWJH1qu4e3jeYbx23y5lvFMRWiAr4C274pJ4BHStf4xSH3Grm3U0/brKHre5ToeQobEKT0M1yZtbOS66av3nRp/9PaXHN4fMTku3crOZc84Sp9xOE5atLdJ3QG8OWQlXQQai8v4lmm5xq3bxnCbVvDlJUs6bZCFT03roa75hOibFkKO5VArXexRDTyipASCNjAFXi8YaVdJrqP8ASuPJxKv0NvD04c+4mxtcOZuHCZ0pt0rV/Ct9zCkJbLj2XlNJa3WfhdKR77U/s6xVC8+Ye0DBIWCR1r0Rili25YOI7wKGgnSo+nrXdj8Qc1cUeBqvAIYM3ldR5ttb3BLZwKThFk8RyHGAQqui57vrOxyjgF+vDrV1u4aJSgo8KNhskTtUPeWNmHFW92v4VIJJWgJIUZ8yPKs9viaXmE2d7ipcZbJSw2+kLCBHKRG1arxTGk4yRi/AZxkpJ7FXVnGxVbICMBsApJ8Kg1Cj7ms4z3bSovYRYbAeEIO1WBrD7G7dTb2mIsl1xQQhDjaR4v8AU61YH8hYwynW9ZWUCAtKQ2J+unmnHxGE+F9CH4LkTpspVhm/DnHUJ/Y1q0nzbQBFbgzXhDCHHv2RbulR31pSTNX7LeD4PhoNji2C2tzcDdKltoPh85A3q0t5dyzdIATly0AI4LKBvS/G2rUTF+Ezi66jiP8AS7C1ElOCWg2mCNqpXbBnG3vsBZtLLLlkgpcKi4ykhfHvEfSvUa8i4CuFIy/ZEfvANA/yrUuuzfKN4UpvMqYY6lBkBduCKf4y/wCkuPhsod9z5whLzbblxdqUhUqShBB2njmtGyvSbtLTrp0NIOlJ6KHlX0euOxrs1uJNxkrBnAoyZtUGtcdhfZOHO8RkHAzr6/CJmrWq79Jyy8HyviSPn9hWZcTOKNOKaacZEBxtX7yf41K21sq+W1esA/lgugcbnj3r3c32EdlDTwdHZ3g6FjdC/hgY+1bCOxns0ajTkfCAQY2t6jJrIdFQjuT/ALPljsmjxXYrbSfjMQUhLugflEbg+tbaQ5fsrcQe7hJlYSAI8t69l3PYx2X36y8/kjDFrInV3RE/Smr7Fey1YbQMo4egARsggfaa82fW31LkcPCckO6PD+Xuz3OOeMzWeWcvW6r69xV4WtjbApSp10/KkEkAcGST0rudr/k4vxVPBtT+QFOgiVBzEGEgegGszXojLGQMm5Ox6xzHlrLdlh+J4W6H7S5aQdTah1E7TvXam+3ztIbQlr+kLqiARqLSP8K7sWWcl7cq/QS8JzOTtqjwjiH+Ta/FG33T9t2d2ygmdSBiDIIkf6dU1/8Aye34q8Ovbi4/5O9DakaSE39sSSPZdfSQ9vXaIUlKsbWeoPdo/jG9aL/bNnVaNKsXUAoyfyk7n7VfXkg/Ymn8V/JtHwvasj+R8ucwfhc7f8IeUjGMlXSFplJl9s7+kKNc2v7HMGU79zC8UYctbpkwttShKY86+s+M47e484p3FFodMyVaQJNcpzJ2CdlGacQdxfG8ps3N2+Zcc71YKj9FRXStY1Gshnm8Hj0+w9zzW1j2N2/dIdaeXoPzqfk/41ku81453oNu3cLSPmKVQSalFYRgbKkha7kkpnxun/Gi7Y4KUlvu1AR8/wAQTXx6cU7SP0hvLXss0bbM2OIbWE3byVK5h6Y+1YV5hx5Tvc/Gr19VhQ1H6VstYJhpdHwveNb8pX4TWN/AMLZB+IunHVKJ2GxH15p3F9h9WbsyMuswYy2Q0u6cJVsZcEfStG+xM3CAm+dec8J0+KY9DVis8EwUXKXjZXEBOmVveEH0rO9g+EJUf7ffkHffyO9X1Q4S3IccstpMrNpKLVK7QuB1Q3KFQQD61kZxXE7gKUh15rudgSuZ9ZNWNGGYelKl92AAABCoPpWRNta2iobsU9yRKlKXuTR5q7K2WoST5KzbYhjZdUl25eW2rxJSXSVH7HYCtq4xW5LAKLh5CQfEVuEGpNbNm26XUM6QEiISPFPrNOuDhJAW7YqJO2qDAHrvSlNvdIpdcVTZWrTE3G50Xziy4oxLpj7VuPYxibLcs3TiCDIBWRU8tjL5SlSLK0SYkKkkz7VpB3DVlcIaTp8IlXP+FTGSu6J6Z0RRxTFmwVKv1tmdXhcO9OZzBilu6n426cet1nUClekz0E9KkwuwumEsu4dbpbT4iQSVKH8BWncW+FHQ600EJEn82CPbarTjN7ozlf8ASyMfx/F2FJW5iKS2JUlrWSTP6Vnbxpp5r811bZcEgLSFlR95gVvrtcPcZbL7VqTwNlH+cU829q2ruWCw2gJmQNwfpT6or+miVDI+XZqJxi9U7pauXWEI2SdcmY8wNqjrvELlVwt+9unVymRKkyoDzqYbQtsEpebLRMExAisj4sXFJa7xiVp2ATqJo8xPsLLglNckAxjbJtypbiUIEfIrzPEVkRiiSsoDyk6j4ZUOPWBxUyjCrUyh1DZMCAERp+9M7iyaK2HW0loCAEx+tU80JcIlYJJcmm3iF/oCLd1YbSqZUoSB5Uxm/wAQUXEraX3aiTKHCAfKphLeB21to7oILnU/4Uu7wkg2zL/drHmmdvrU+Y3skPy2uWVs3d6X1N3GshxWkpbJUQa2G3SyCgXKweiVb8es/pU4tGHW+p4rCEK3GpI/wpWruHPKUtq4gFMzpTv6itE3VpBTW1kIq4uU3C3E2oUdI0yOenHHFJt24Upf9TStQ3AC9v0qxJXbpWpT0qREJ1aTJ8+Kx/EW7IK9Lfi27tIA3+gpJ+oRT4ZX03T/AH6W12KEpT8ydUj/AFulOfcu3lBCGkhCRto8ZPpNT7GIFCdC7e10KPU9ftT7e7aU93TLVsjbVKV8H12qfMdVQPG+LK21c37iS4lhLaQAJKOD5T1rIu8vVI7py4UQBsU/8bVYjeMtn4RwsFazqSUp29d4ohyw0EPttLST83SreRtXQo4dqTKzhy7taC45eFLm6DpQSAP8ae0p9LykFRWlJCkhZO9Wli5sWQpDjLCEqHA3gUxzFLJZ/IsmzA07tkSPSo8yVg8SbSTK6+q9US405LiUyR5im2y21LD1wlpDiwPErYzVuRdWyW9Rt2tXBUG4UPT1Fafx+EoV32jvFIkBKWhuaIzlVDljrchFPnUm3L51gyEhyZPTasCr7u3AU3jIUAZkTJ8tuatKL+z7svCza8JlZCBqFBGK4eEBSbVohJkHu0gA+ta9Uox4sckprkr9s+4W5duUIMatMq/Wa13333lpUq6bS2RKADE+lW5OMWj7JWe5K4jSUJn/AH1hbxuzQlAXb258JMdxJ+wqFOVcB01tZV03r9srutTSivzB2PuKIvXUBaGmEOuCVJJSdj71cnMUatmwt1DCdYkDuyAP02rVcxe2So/1dC1LH7rZ/wAKcckmqcRPHX9RVfinlBtZDurc6dHBPrG1FD96+18Om1WtRMKidJ+38atTmYLFLSUGwS2TyVjST9aKMas3gUtMJJa+ZSTCR7+tLqdcEeXX9RAW5uEAD4UpSkwBuAn6xWK6fu1tkIbdUoqhKUAkAfzqwqzJhjKlM92V6RqUW0kwT57UBmqwDiEC0cSpZ2UUFMetS3KPKNFB9NJlcP7TcdQnSGdKN5EkR0oG0UlTi33jsAowhRM1aV5ltEJWtxlr8vceDUY9/Wn2ON2+JNLuGrJxCUgFSigAD1A5ocupXQKPTs2UxuzullTwvX9CDq8TRg/U1kZt7py4bacUpLYOoflaqtasYQklhppCkqBITBn3phx1hhSO8tgAs+Gd9x1qVKf5UUsW2zIBxt0OqSxbp0KIAWWyffb0oN4Zia3y+m3Cy0YLiknxj2qeczIoJWylhooJmdME+kc0z+kzsgfCBvSInSaHKS7C8tXdkebO7caS7oErV+6g8eREU5OGNoYFykkrUY0BJO/p5VuvZpaaDSHmFd4o7ENnanHMYSDpsVAAjSrSdSif5URlkS4KckvZsiXUYkyzLDCS46kBJKYAE7z61ndZuy0n4mStRE92ng1tjHXV6kpw5S0p3kNqP3PSnWmZnij/AO9JMqEHQop26T50qm0thppIhDavLdU1LoK1fKU7SPpWX4Jw3CVNqUjSCSkjy+lTas0MBZU/hCG0qmFKSoDUOh8q1XM521w8WWcIQ4pMglOr7HatpOajwZJxTNN20U6tK/hSpYO507R0G1J6xvFFLbSdE7yUxBrevM1LYQm3ODd22oSkqSqSrr0rH/SK77v87CXG1EABAagwOo96iLmi9nsmRr1hcoCQ6C6EGAsN+I1jcw50pKEpWkPeGNBn+O1TasfuvhzcC2dCUDgtHY9B5T9aLOOrukF4W5WqPEQ0fCfI/wC6jryLZomk9kyNtsHIZCyy4PKESrb0prlmhbRT8G+VJGxSITPqKlLfMCEsKL6UoVq0ypsgT5Sazoxpp5HegPd2nYoSxqn1BpNT9BrEntZXmWrruVt2+GvKKRpCu42KetY7O1xNTmlWGrbZHDfcmVeu1WRzHywA2lDjaFDYKZ8QnisqMYuw0h82VyogwSlkiD5Vr1yUeA8mu5WrrA72/SCmzcaQhWoDuyCv771lVg2IOIS00i57yY1KbIA8iPMVaxjt2pYcVaurChGnuCTI/wCOKy22IX739YVYIhR8IUgpUSP4CuZSm+VsOOGL3bKgMs4u0CG23FKTMDTqO/UTTUWmPJLamsKuy58igW428yIq7N4viLf5jNmguR8qXUnccjcbUrzMeLMMd44zocWJKQoEx5SBM0SkmJY+l7MqRwbE3gi5dwy4RcTulTSgCPKsDmAZgD6kuYTchBOvwtKIq5W+ZrpYWq4tVaEcrU7CSfrxWC4xXEnn2zYt3KzPzJTqE+U0k5LZjcf/AOxz3PasyW+AldteYjZpZcbAAKkhYUoJiDUtZYZizLKG22r2GxLiltFRVB6/Sl2l4niD2V3l3DKwC+xKVJA4cTyem9WVzHMXS8oi1cbaP9oFJlU9ADERXW4dOKMqV2/7HJ0/80l1dkRYwnFLi5Tcs2b5QNjKN/tNY7jDL5KgQy6I1EwmDPTaaknswX9mhVwrC9KArSYamd/aKLmKXbpW8qw8CtiS0EpHrJFZOcm/cdCxUqbI1WHYjbupEqbVpkpMK/3VsOM4ohYWi2UtO2+iB7eX1ratn8TdTqas23VK4SG0qEdDMVvnFb20cRbOYYH3FI1K0BJSkeRAqJTS2ZXRXJCsW12CVuWhSoiVDwz7bUx9m+BQgWjukiQQABH0qeXil2tS2xheokypIbHFZrbErtrUpOGFTUCZQBt6moUpJ+yaRhF8soeDMYg7nXG7Zu3Xr+DtCoBHQFdWK5t8QaWoBpwSY0FumYBiV0e0TMFwxhyW0rtrRROwAgrgSfOf0q4KN3dKSV2Mrc+QjSdRmurUS6VG/RGGCCSe/dlObfcSgoNi/ESShIgn1nigu6cgaLN9JA6Qf91ddyz2Z5tzWEvN4Wq0tl3rGHqduEaEIuHjCEqB3nk8cA10Kx7NeyvILl8rP+YXsQxXBccRZXOH2DIW3c2yQCpY1BJIJMAhQ61liw5J+1Bbe8jNqsGJ9Kl1S9FuedcEy9m7NOI22FZcw9d1c3iw2yw2nW4onppFdMy9+GfPNxcYPf5vzLhWV8JxNV638TerVqbcth42y2CNydhvVwxvtkwDD2msGyRltvBbaxxl3FrF5FuBcSdkJVJV4UjpJ5Nc1xzN2I3SAbzE8SU24868NbaVIS4skqKU9JJ6VooY4O8j6vhwc6Wp1DTtQXzf2Li1ddi2RmUotsv4hnPErjA3mrpx9KUW9riCiNC2goaoSBv5zVbzT21Z+zCMSt1rbwy3xe3tbS9s7BCWWn0sJ0oKgZUCAehFUa+zDa2lq88tp9QSk6iWQAI9JmqyvPdm0rXbNIUtQKoNurUr9DVpykn5UUl/nca0uCE7yPqfq9/4N9zEnbm7cDyQpwE6la5JV6yZprjriUOBu1ZjRuArxE/WtRrHnH1puH8PaYLpC9fdAxPpFaF/ey+EWzUlStzpgH6RXO4za3O3qh2JNh1TjAT8GU6BqUVHcVnabfU2UIYGgkKEnYn68VCKbfFs24oO+Iqnu5j+NYVLuStC2+/SCdQ1aj+lTFtbCk1FbkxdW98bvSm0bUkNlJSFGZ+nSns2NyWS5h7Kw9B1haCE+seQqFRiN6sKabSgqBkrXIIrOxiOKNOJaS4oeadZgg06mHTCa5NvuENLStDCQ8EgK2SpAPWK3U2FneP9zctN6U7ILa4UZ6kcVX7/AB94FLS+9nVpOhO6T9BWRN86Wu5/rCtW/iUQR7RRKEo+0KEIXsyebtMQbWiGtLZlKtUgKHTrzWB99QbSi4UopJIII6j2JMVom5UtIZNsXEsqglTi+o39/pWLvcIeWEvYd4lEpI71WlI84oXVyaPp4s30X6mFPW6yVoQkKaS2hQST1Bk70bl5aWy633iPESAgFJSTEgb1pFWGtlKm8MU6gDkLIgfTetVGJXHxCmvh4KRJSdX06U91+VC6IvubjDwYJ02bzq1/vLE7T/pc1je75hxbrLPdFW4G8/TetRd7dLWsPklfklWkD9Kazc3Sbcv6VaUzCCZMjoCQat9fJm8UEqJVbrbymm1Wj6oOrwr1AbckztT7tt8n/oSHAgadanCNvQTWlYY5ch9AtbQJBB1KWI3+1SNnjVwh0hLNqvvCUKJbUR+oqZynRpGOJmFlCLW3WWrYrDiYKu8O3pzSwwXDbSWn7dxfi2W2eRPUVtvYubl8s/D2rng0yNgk+0VpL/adokOoebcUgkFCUyftArNOc1uNwxj3cKsjcpuHXULIk6NED6+KtV+1tW73VaOEq8iQEn05mgtTdykvLcS0VR+7BT6GKCX1WxBR3TpCgkK0Gd/pTfWuRKGPsbChfOp0qZt0og8ukqn6Gmu2rKHEXL7rfeIABDYPB9TWB6+JUVOvNlxcgtpBOkD9JoYXchcOruUo1K0+NATI+1W3Jx2L6Y1TZKJcsCP6ulLpEEKTGoegE08LZZW5cEllOjdIRudvetZOKIQpTYU0sgn5ESRHrFNuMQKjpLzEHYJHJ+4rNuXqaeVF7pj27+web0KSEhUaVPFQUB1k71mDrT2hSrq1OnwkBatWmPOK1lNJQEBxDKi6nwpUkEz5U5m9Th74bThzJWodG9h6E01kUeENwVXY9do2lbbjNwyUpVLgGqSPMVgcTauPuMOsugKXA0q8MeZ3rccxFjvoct7TWQIBjc+sViXf/DLWUpsCsp1LAGxHkDHNS2/QlOLRgbb+HQtltp9GuYWrcAeQIMTWa2LSbcKRZ3ZdJJISOR5880E44yu0R3lsyNRIKUtlWn2MUx3Ma2EtM2zaUagdPeNCNvXpS6ZxQoxg+5kTcKbZ7w2V2lZIIlCkgjzkmsNvjTC0uBWGXLbuvkrJmsdxjOIgIQu2t1qQIOkjafSK1UYhdvLSXENNhoeKUA6vSYpRT9Aljindk4g6Ukrw91SVdCVKPHTetW4bw5RD5w19lxKQCmDJ9ASa0XMWLSYW4O9SmR0g+vrQ+PdLQC3A4VGe8CATPuetavqq2UkvUmVv4HczanClEKgqUkEkH1NMauMKYb7m3w4o8RH5gPTr51DfHhwrbbWhbpQSqBCj+vWhbqvCoRY6lKTqCtMwPLz+tZqKDpV7s20JWgKV4kpSYISTGn71vJdULcwhRbKRGtQ2E+1RH7QxVlzuW7Ns6t1BMnb1PFPTiONKWvUw00kAaQfECOpmqatWikoLkkba8C+91JDigfmmIHpQWELbSXbZ9beqVKSrePSRQZvXxbuPOW7SnwAAkwDHU1mW686x8QGYQpImR1+lZNtcC6FLgKm75pkXjBX/AJgcB1EeXNBAvbpSW3A7pXv4WyYjkc8Vpt4kCCUBClwfAtfH+FPZur63hdxbBSVCYQsiBV1fI+hLZG83b3DaC38O4mQT1ANNGF3igHPhloBAJMcx6zWKzxRxhBWpKp1TpI1QPfoK328TtHULN7dBlTZCgW1AwD5/+lJRkmTKKjyzWNpcOPy024CBPOrT+tPGDurSh55b+oGSkKCAU+smpBWIWDwSsPrISCdSQBqFaruKWpABD5VEHxhIA+tOpNg2mtuDELDSFOhNyAqAAlQjb60lYY+tM/Bv6nOFa07n135rK3jFsgwxcpU42mFBTnhj6Dmnqx/DWbdL9wlSUKHzBRkK862WN9zNSruJFotpjZt3WkQEFxJmtZ+2xNYb7hhxKVfNKhtH1pLxC23uC+FKG6PzQQR9Kazitq8VJU42qBsnvvvyP5VilUipPqXI5xN82NK7dt0uDxKSdO3TrWo7Z4oHviEYeEju4UAkHVP1rMjFWVglDzcpX4YeBEdZ2pj+M2jj0Jv2yU7RMD71o249iY40+5rWVvi6StFzaoQyD4QSJ+1ZA1jLjgeRblAQdKQFDSdqxv4oAjSVFQJA1FU/XYTWw3idq4nQi4CyDChHH1NT5rT4K8pJbM1Li3x99yU2rK1FW6VuJVv9aNra4qHzbfBOBKTKtSgoE9QIrMV2r2landAHQcz7kUVXLSB3rD5hY0lQT19DQ5NK0ifKrhiZscTS8SjDktkSolaAvbyE9fStX9iXQuF3AcQXANUFHPkCPSttlb7yg27cpgnZRVKp+tbbTKGlF0vltxCgd1khXuKbnOKsS0+OT3e5GfAXLhLryWypKR4AJAPWPKszLWIKH9YYDKdtS4G46VNrVYOtqcacSoD5kpSUifTzrUtX8LbWFXBKkEnwuLO/t5Vj5zk6N3p4x3s08Qt3WYKA8ppKZUoK5nyFRrbbjDxcacdbUCU/mERB6xUw8bJffOIT4Adgt7mtNeIWxUgptmpMT+bq3H8q2jOVUjLyo3dmLuFMJ7zuVvLcUS4vUPD6DatQqCWu6VbPQFGTrSCqnKvF3FybdtkpAk6kDbf60gpIQG3kqbKJVLiIJHmN6uMnHdonog2MUq/U18M2j8tfyoUR4f1rFbOXjbgULMoWraEJ0gx50G12NytLifkVsFKbkk+QrZcu7e20oFkQlUiVQFgego8y+wfh4y7jbvE72VtXbCo2KQhAI/4Fa17dvS18LbO60ie8JEBPXYb1n+IsW1OLebLQbA17ceu5prv7OuSVsGQfmUhIEfrvVRn07NbEeSm6sYm4vnQEW/fI0EEaYiPPettPeoUH22tK9wpwrCtXukVoPYo1h7bjrbAMCBp0zHtWpbZhD5KSwWp30q8JmnFSbtBLHCKpyJUG871x5pt1Ck/KNAAV9ZrXNzeIBX8O6pwgnu0pCYPnRReuOqIdsVKB+UlZgCig2yVd7cIQQCeNyP1q5Tld0ZLFF8s2W8axF+3l2xuG1J3QFHUn35ou4ncluWmLkkxKlo6+h8q1GLnC1A9+26ATsJkke1S9s5Ya0pGG3LigPDqbUDHnWLm27aNI4ldWaC8RvFrDj1o+lSdxA1Db2NbVtiF24yCVXOrVqJkc+UdK3m1tBRccsL0IRJASgx9az/E2YtoOCvoUrxypsrkeY22qZZ2ti44le7K+3dYmbgm5tbqFKJ32EenNZkv3qFFm3u32VrM6ijYelWBr9m9yp0W9/wDmcxbkJB+1bARhzSwHrG6UQASFIH+FE87S3Qfhep2pFfb/AGiCXy93mojwpRA9T70+1wxxYW4q8Lalq1DvNhI4NWRLlg64XGLW7V3fzS0pSf0rVu0d7rcS2622CIhrgVMcl9ipYtuSKDd2tXd3OYGCFyISkgE+tdt/DFhqGsZx/MqFJUMs4M6+HenxD57lqOd4Us1yZ1jD/h1NhpfepEoUlHXyr0N2P4fb5c/D6/iHhReZrzCpKhEqFvbNgJB8gVrJ+laY5Kct0cWsXSo4k37TS/Tlm63iDaWigNEngEGK8BfiXzH+2+13ES2pRatXkW7cmdIR/vJr3S7dN2tq9eukBLLa3CekJE/yr5p54xdWM5qvsSWvUX7pbpV5yqa9rQrrn8Dk8Tl5WllJd2kRuaiVYpdKJmVneoEEpNTGYl6r98H+9/KoevdxKonw+vknnbROZfzNieBXAdsrhYSfmTOyveuxZYzzhmOMwtz4a6IIKFEQfY1wNCtJ2NbrDpQUrQopUDsQa4ddoMWqW+z9T2fB/Gs+iajdx9GejV4YrHH27a2xy+sFmSl21fWg6gkkfL7CoDL+Un8Ovji9xjN1c3KjrWt5SjJPUzuag+zntEtsOxO1RjyyW0KEPdQPWumW1vhuIW4dtrhRbXMFJkETtxXzedanSQ8lv2foffab8F4nlWogvar9f19RHFPzEh64bWojiJ384pr11aPNq71Se9SPDpgVq/0ZYRcd427OngH/AI3reTgNoGi82whYV84KI0/evMcox5PbapbknkF8IzXh1ytGopeB1HY+1eqXLpp+y2QlJUmCZry7glqnD+5uksBXdqChp2JI3mvRuD4g5iOEMOlEBxCTs2Ntq9Pw7IpJo+X8VxyWeMzxT2pdonaLgGdMVwa1umixb3LiWh3CDCJ25FWLsT7WsaxzGRhub2Le5Q0pCQAyEkJPB29a3vxSZStsKxxjHrTWXMSnvhtpCkxEVxbI2Iv4Rm9lxtwoU4NKvIxuK+m02HDqMKcop9j4/wAX1WqwZ24yaT3SPcl5YZaeeTiNrhQRdN+NtesyCOvMVb8Pu1YrhKHA28pRQAVAGNVVPB0W+KYNa4i0mVPMpUJ2PFWXJuILabewtQVqbVqAH90nevOUI4m4rY7IamWaKkzRvbN3D327mXIQrknaIirtgyS+0lp5pQ1DU2f1qvZgvQllbZRqnwkEUMm4tcKtQhb7y37dcFPI09P0oS3aY5tp2XxhtxkfmSUncSdxT3XUqCUiCB1PNYVvvPthTJAJAJChTYe4KZPnFSo9wluZ9bS90hKIHnuaSm0KBiPcmtN0BEalABO0EUA4gCVufcwYrXZk2zdQ8tBCdIpy3E/9cUhB8q0nbhOrZQg8GaKFBxBBIUD1nrWc4pFxbRlS6yjbWZP0rG8WhBSpO/PrR7kBOpIlIJ2PFN7tShCkpCU+nWo+BbkrtjkF1KUpBBPn7U9SgndzYTO29YEJfQsLKdQHrFZFHwguIUB1600yJKPYSXWJAkzuBT3HS0EeIe5NaalK57xM77RWu6VOckqMTAVxWlbmZJBxlRKlP7qMEU8ltSfBHodVQocLahCAY862mXkOJGpsAjpTluB5IexBts6i2lKE7EFO8dNpprt9aOJgBAKimJB/xqsqu8XLX5TzSSeUqMyPWdxWwn4soQXbi2WlPiJSswPTevJ8lJcnuLVSomziNuFKWm0UpKfD8ihJHkayjE7NSkKTatoUnlShuP1qFVeXBACLlAJ3BDm32isD7d84z+WWzpOowQB+tCw1yWtVJliTeWfeKbatAdXK50j7ztWRT1k22V90XHCfAQ5qAH86rbbuJNo7r4ZpQTupHy/qBT9OJutoWllpuBsJI/lQsaTtkvUTssL72CqtkJew91TkglXfFCSfaslxfYWi0SLLCiXQfGpd0FbegjpVbm+UNLiW06Y8aiVR+lK4cxBSdLL9v3Y+ZQ/9KaxRZfnto3LnFWkaVJtioR8s8UwYwly5QlFp4P8Asw5EH1k1HoOIFetkK0on5VEiPqKyCyxF38xFw0hSjsNG4+tCxpOmZvUZJLksLxt04Wi8uLXD1OOL0BKnRrT13T0HrNaS3rW4SH04a0gCBrSdjUKbXE06ofC0cLQkc/WsBRelSLfulISo+CCYB8qtYoS3QvxEkqs3nL5lxxSUNpbMgktkCPSsyLlpDQX8KlQUZUJ5Pqa0LazdS4UpUtLkHVsQP4VkuLa8SyNaFOhRnQFEE+tX0JbGSyvqNx64t1DQi2QmRJb70CR771nRqbYVcrbDbYE6e+Jge8VCPXq0gsizWgJHAH+6kVKS3F1Y3CwrcHeB71Dw2arPJcMmmMT71IRb2h7oggal6tRPXcVnResMLbRcYeypxAkanI+giq9qe7kLDDoaSnYhsisbi3O7Qv8AZj6nONZSRM/ShYUuwPUTe7LOvH0aykYW2nvNtRdUYrXucTUp1DtpYiW/nKVnSof6JG3vUChy5SEq+ABA8JASYJnzNbCl3DtwUoZS2BsUmBv96Fhg+xP4mfqb799dOKQpppuZ8SeoHSKTiiG0qctlBQO8kGT58VGdzeMlt56wuCkqOmEkBXnvWVzFClUG0WluSFNiQfvFV5avYbzyaNl+9QlnQ5aLKwoSrXIj20mstu+hTWk2qNJVAXMAfpWhc4pcrb02toWh0O5/WKx2l7dupS00084G/GoFsq+pIHFNwpbmaz7ko2Xbj8xtDbOkcatWqPIimNuOIcVqsUzOwPUeZ2rQdxd5x4h5tTiUgSnuzIpisQbYZ7xu2WUKGyikmeesbVPlvsaee0bwvmhK3bdDSuEGIis7T3xRSoJSFJOykggD/Gq6xjqVvtpcQlR4jRH8qkEZltbW40oZbS2AdomTVLFfA1qWvzEm2i8Vdd6qz1pndRKjTrj4hLCmXkqDSiYShZ2P8q0l5nceTC0hlK+ISUyPtWo5jlkSphwNhSokBBkj3qHjl2QlqEzftSlVqu3WwdKVyFKJWr70xi6ZtC46tagvV4kFRIT678VpN4sEkNBpCmRuEiUmffk1jexhC3FPJsWio+FS9Z/URVShtsjNZGndk67jMOB1bqYUIBCydVIYgGSX4CFEQnaKrrN2paS6kNJU3sTpMj0gDamoxlNu0GXwlxRUFgrKtth6b1UIRqglnv8AMy0M3AWgtt3CHNadyuZB9xFOcubYNJLiUjRIOpJ3+s1XrTH3glCm7MOoV4gRuk+hrfuMdcu20tPNoQpudtMA+kUOLiylmtWjZ/a0r763aSuPkUJAjz9qztPh1SncQudCyBpU2SahbjEFStlF40ydkgBKgSPtQuLx9mzi5uQEJiCRz50qspZXROO3DrqRbO3LgbO4URt9q12haIDgU+44sGDzz0HpUT+1mWLdbriUoKxKSAVfb1rJh967dW5NqApajAUsc+tNpJWHm9iUNupai9bJcU6NlIcJEesVhXe2lqmLpwuKcVAA8KdX1rELS9bahy+abcVtCJMg+e80xnD3kMJOsLUskhwpJjfqCazjFNB5knyZ7dPxBXcWgWFEDvACSIHr5VkZaXdKKVPSxvrVJkH09K0jhamCGhcNp1hU/lEE/asrLSHEi1bcnSmCA2UhQ9Kl4orcI6qSfSbF5aQ6pp7UWnAktK4CzNNaX3LSlXDCUKkBPdzrCesmlZM4w08tyxh0adJIbBhPlBOxrG+3ijJQbpKm3UzIUxyOnWqcIzjRXmy5M1pcNhxaFNugzEBMz+tPRiClvaGLZLSWzudI1AdYBFaLn7QvEBwuqQSqAvu53/1tq1za3aHDrulmNioiJnzk044oxJefIiRfW98Sq+1rcaQkqaOnSrnjmJFYFYipDqllzvCvdIWnf2mawNBCkFZQ46Y0phB0k+pmsSkqQhTrxWykEaUaCY/WqcIv2SFlyIcvETBtAgOJUZCVpMT5isqsWLb7a1NPOGPlB0yodAa0bu4twuX1PIChCSGoI/WnLuWkNhKdQUlXhlMkDzjmn5casnzZJ2TH7XuG0Oqtu+YSoDWrUYM9DtuK0xjV+pvS3dlsAkDQogAfT+NRarpTqSgIWQVQSJTJ+u9Br9qIJ7thS2SClQCVK26yKpYk+wnqJXsSrmaLvEENtYgt25VISkOOk6gPesicdK/B8OhpxSoB1mR7RUD8S/buFTWFrJGwPdK0j2mswvH3nS89hwQs7T3cn77Ch41wHnz4JnvLq7T3ulSjtHeKIHNNXmLE2rhLamEJSlIHelZVq9KhxYYlvqtlgKXLXptwRP2oqtsRFwi1cYVqjUQtMpBHWJqahwVHUSlsbb2JXiiUNB2EkgJQqACeu43o/G4sm2cQlC3GgANayQJ6lRFaHfIS4bRy371JmVIIEHqdztT2r9paPhXGStA4lESB9d6aiuQU2iYtsdxJxsN3CUuNiQQpQI38gRXozsX7F8BzPkFfaDmbGlM96VN2eGsPFvWhJgqUQPTzryxdXNtr/J0oOmAhSd0j6VlxXtUzvlTKjuHYLjhYZQQ4lsI2STzHoa4dXp8uZdGmpN/p+wpaioPzG18DoXaXhzeUsVH7PeDlq86e7DhBKY8j1FVlOY7m3tw4lh3UVa9SjsT51F3uN4pjjNq/ilwu4c7pMFSfTcxSTa6WyXW1LCxG7f8AKr0mDJiwqGoacl6FefNbRdkojNN4lCVoQ8gpSVap2nr7VpDNmJAKcskLLi9wpfr0pjdpauuhL7SggyEpQkb8/wCdT02TzZ7u1s193MoWlIBJHma1ccaKjkzPdszW+P5iIDKVBsEwRpn3261tC/xBpZbQ8AtJ1FSo0kfXetRTN5cBCVYdchw7AOtjb2M1kaw++cWGw06lxSurKSkD6GKHHHLih+Zm7Gx+08S7stLQNalalLX4kBPTaJms9tiOIhxX5jTZb8RW2gKM9ABFa9xZXdlbIbuG1KD26ClkACPUmBRsWEOLaQy26wufEtSAoT7zT6IpbDU5y5K3nm4v1ZfffUHtLbzSyHCSAdYgjy35q+WuYL4tlRTbunuYKNDh8fnPANU/PmG3rOVrlQuFAd60FJUEpKiViCIUau2G4JijaFXbty68ltsd6htxseGN58UE1rJxnhV+r/sYxc45X8F/cixjOJae6urXUDwnu/CD/A1kbxfGLa4QTbykxCYiR9akvGq1SwHrmFL1EHR142mnpsn31pPdXKlwUoUhKSkDzJHFc0lHhnVGUq3MNxj+Y7uHdYZQrbdAJPpIjasdle5iSUhlEnUdgRVmwjIN3jLrabRF7cOuuhtLCGErceUeAgckn0FW/K/ZHatXuFDMlu9hVlieJ/szvrzSyWFp3cKtSRASAZkgSIoUYP2YxswlqXiftSOZv4lma3b0qdUh0GPGlInynepTBcIzpmFJRZ4Xd37bSkNvOW9uVttLWqEhagCBPSSK6oxedieSsaxfDsRyucyvYRjKDZXrt8n4e4tmlbgoQkhQXHUnaozNn4msUeOYMJynZYZlvBcbvGb921w60S2pBbACEhaUpJAjb3rRYU1cmkZvPqMj/wCOG3q/4DZdg15lpOZMz5/zXYZWu8GuLOwxDD3lC5ff1QdTYaVA0pM9eakc19qPY5lC2xjB8g4Be45dNX9i9hGOXwBbQlopW4nuwEqhapBG1cTzJmR7H713FcTxK8vLq4Ot+5eUpbilHqSSf1qFTd2jsqVdOIUTpSVDc+u52q28UWm1b941ps01U5X7uF9y9doPb1n7OOYb/NONos03GKXCblxLbK0oCkJ0o0iZgDYb1UB2k5suFruHLa2eab3CYgAR5TWO2GGFRS/iVyVtggpUyI9qxXn7GQ2XG5QCrSSlYJJ54qZZot2zRYcmOPTDZIa9n7Fr10Pv4LaoWgfMhB1AeXNBzOWNpCe4w4eGFEmdh7E1juGLFwJK7pUuDwmE/wAjTmLZmYbvVgkjUdEbDbmal9DWyKxrJVMyDPmOtocU/YJcBnwBBgz5ma1DnbEC2sOWrJClRvO3pzWw+cPLq20PvPKAkGIExvE1rPWzLxb+JuUaTBCQEbj1g80ouD2aE45LGWear23bdQ3YJUondZlUA+lJeccQcAJYaWVK0ShKgAPU0E4jgzKzaG9cWDOoJQU7CsZucC+HUylRSVGZIJmfWKpdCXGwqzeoms33r6i2q2ZMSCSVbeo3otZhdWhST8MEp8tX670mFZftXNYcfJAgrCSNj0k1javsPQlbrFsXUn++iRG/pSflN7RIk8j2kxrOYr1lxwtsJWAIISTED6zT38xXBhTKWyVJ6BRg7cmmt31hcQwi1UQpOk6GwD7bbmnNWeXkoDykqbQFaSFTJq20uxK6+zMCcav1wHGUpSZggcqjqZojMOKpKGmmlrBUOUn67zUotOWylxBuTblJI1FJUFT1HSsimcILQUcUBbACZU2odPb+FQskZLeJXRJdyGusdxR0w4PBP7pJPtztT2cwJdOrumUBxUQqZPpzWylrAwlSlPtKSkmVhKoPkIitG3wnLray9cvBtBPCFK5+opxS4ohvJF7OzaXjF0yJSplqIVyQd/XyrA5j12p1bZuWVeQbKjA85FYrjCssLWH2Xwkp8KdSydX6VmtsCwNThcRjLTbagfCQYny4rVY4h1ZDVczEUNhpC9SlgwdRJFZWM24ilghpBWpRCUju9p++9YhlixcdLjmL27aY2VPA+1FOC2JQojGWEBPhG5Ez5QOaqsfDRMnmfBs3GYsTXoS7bNOrVypCdISOgisjeYsX1JBRbpSlUpSpNaiMNbZb7prF2JVsStSjP3TWF61DDyUtYnZFWyT84P8AA0vKT3SBTyR5ZIIzHiLriCkNMKQohKAvn6VlRjWLqQ64i/tSpG8KmB51qJw8Bgtt4lYHSSUqJJJPoYmtVrCmn30IVjdq1O6yomPoAN6I4k9qFLPlX5TbucZukoCPiLdSiCVAiN/em2eJ3i1ytZbfSNQkFQEdCKByxZMLLjOYbB8q3CtKoP6VkGDtOt6Hcy2jSSoEJ8RUfqKXlwrcqOTI+WZl45jjLx7q5bXog8nY+0Vn/pTjgRrLYUf3IR18z6ViewxTJR8NmS1GrbwkyR6j+dFnCmCUqfzFa60EgfmKH6RH0rOMIvg2nknVoTeaswK1A60E+TR08+XWsjWO3sqWu+aMbH8s7edJhi9SpTjWL2C06oElRj2qQZS+hvQjFsPdVBIbDShJPMbRUSxqT2Gp5H+Zmg5mG7cb+IUyh1pkSlSUK3HnWunHrlxqRaLHeKMflEn34qTScUfRobVZNJa53TAB8xzSYs7p/U0MwW9vpEhISVyOvB2qXjrsaRnN8MjFYhflInDQmPNqFH605/4z4VSXkoSpQCglCdJBH8a3msBt0O6BmNrvANQClHbz61uJwi3viQvM9qpbKIKVJVJ+tNS3qi+mdXZWLW4xptwpNsUhBlBBBmaY/epWrvbl0pUDuJiP91TaMLNu6U2+ZWFlWyoOlPsCd6zP5fef06cRYCmxAhwqB96csvR2DHF1uyJtW3LdZeDbRSoSVKHA6dKZeXxuUkNXAbQiIXE6h5ACpJ2wvbZwi4xphTakhPznxfYVr6Lq3OoLSpKQNJQQAD51Cle5Um1sjCC/e/1Vu7QVlO3eJVx61juLfF8OeQ0L9pSCNQUE7E9AdqkWbPGrlXePXKW0pElZ3Mee1Zl4W2twLexRtbh2kqUQZ9IpNpO+xnGEm+SH+KxBt0heJMq1AKJCDx5cGTWZ6+eY/NRfMgqMpUQoaR7RNZHcJWp9d01ikxACkiJ9INOOBvYmgKuMRFqpsynWj5t/82ncJOkJeanuarWI4g/cJtRdtpCRJWBCfrIpvxVyhaXF3iNDRKilDg0q96kja21o+UuXfeBQI70QlGrz8z9qY5hCnGgEX7CU887J9Yim3Tqti5ObVI02MXduSp9T8lmRso6fbimLxR1hADjqkNKhSQHgqCfWOKyv4RZWKAFXzalLG4TABB6imXuF2SwUMOlKUeEq0ApUOlUowSpmUpZ0jeTj6w13Ntd92AJLnOo+QisC75aHG3V37C9JlSgfmHkZrQctEtpbtG3AJEDSAATTFYeLcJZvHW29Ww2Co9IJ/hU1jkwWXNW5MvYk9dp723xJtLafCqdz7bVpKFv8ouErCyS5EJUR/GtdNkxZkK7pSgQSspSlOk+orKxh1tcEPN3KdLgM6iISenWqioRY1PJLkyd7bWzJRaPv6SCkd6d4PMEViRialNBtLZWmNJSpZJV681IM4c18L3KHGCpIMKU2lW3WtL4W1UgJYcX3iVfuNoIG3PPFU3F7FSc6DYX1oG+6Sy00pKjqSgkK0+Zp15iQWtNuFMuJiRv0+lFlpCVHWhZdK/CO5EafvxW3c5cavW1OquAXdUpS22AUj+EVMnHG0ZRc2qAi7Kmmjb92wpUobKgfD5z6Uxh91lRVc3VsVN+EFKNMnzBmTW2xhaFOJb7xQUlMElKZHn6UFYZYrWlxy8uFFlc+FKIKfICeazclKVrg6KmkRNi+pVy4+hDaQlWonWTJ9BG1Zk4vfqLzr1m2WyYbTO5HnUra27CiWm2nW+8UfmQmY9wKVxl+yunG1IurwaJkJCNh5RFVKSb3Jipx3I1N2q9ue8KnO47uSWhBBHnNY1Y62HDbl1LrbZBSCncH3qVs8sYHdSPi7psJB3UEATWFGWcP1qRb3riwVCZCQY85qV0ClORptY2lTxcexATJhBMFKax22MpavFLSsvpUdp5T7VNXeWMPecTF6nwpgpBQfpz+tYW8rYaVkm9jSDCNKYPsZ3FWpQeyIeSa4I8Y6+VkXDbTbZWC3qHiBrbOPWKnFJddQ4og61Nj5Y4nelcZWZfbSt5zSlfEKG0ek0UZVw+1t1qaQskkA6UifvPFOUYtUXGeV7ofaYiFtF8LcA092WlpjpyPFWNWKlMNtShTY/uQB6RO5rZcwSztG0LcY7wBEkIGv/zAVrpw1t5JdtbZ5OobLWEeH6BRrLy49kX5+Qwv3xu2VpU43pWkglSdyfKtUq7htKGMQRuj5DBAPpWw7lk3YtmhdPMqSvxa2/yxPKpBrTuctOocVbLurYITMKSNzHWtYQguGTLLKXYYxjzdspVup5AWnSTp0gK+s1sLxtDz3euXCgylMaZSTt6xWJ3KQettbd+II4KRH8awM5YUGRbOKQ0gI/tRKj9quoS2MlkyLejebzhg7aIuEXCnGxIUgx9utadxma2vUpLaH/AvVIWEz6GQa03crXCUKX3sJC4Egp289xWmrBb63WQHBpn90qj+FEcWOPtETz5WqRMHMFg4ru7k3CApIGlKxv8ApWqrHsLQ+q3axF8eEa0K6GsQwTXEXqkqTBJ0L29uta7+AqSpdx3qXFKSZ0ayr33FawhCXJmsuSO5vHM2GusdwthxSUnZxKwCPuK0m8UwxxSkIQ84fVXi/wB1BOX7hKG1NXySuJJLSuPttWw7gmIttHW9rBIhKUuH6gxVLHCMtjKWXM3ZrjGXFq0AXVuscahq2+9ZncXtWWT3Tzy18qdSDIPtNaL+G4mbhKXbwtHf8spXx781lFjfQCbj94fKFb+9XOON7CjmyMfb4mpp8XAvbrvP3StJEnz2qXbzLcXGy7y9dcBAOlKjP1BrVaw/Gu+Qbp1RSoeHwqj7xW82m9aKQ624EzKQCqDPt1rNwg+C4Ty8kic23wYUiyuMQ0JA+UKMkciK2LPOWLMhanE3pESQoK5rBbYi/bOJYYsbkIVuooc+YDrMbVJOYgphKA3Y3f5q41KuSoGP/WuSeGL2o7oZZy2aM9vmjF7hhV2TetlXynvV6Z9uK0VZjzE4669rcdBSArxiE/WtpOY7hhPdfsu4cSokCH+R5QazWeaMLtWFfF5dvUoCvCoPASryMDeslGVONGzyN1exiss241vaWZdMbqR3ihqH0rNc5kzA6Eo7lopUYUPGmB5EmsrOK2g8Vpgb7JJ2Pec/WNq3E4kptzu3cOui8kbHWdO/mI3qZ+xSexp1uWyRD3WNYl3C3EMOOLUNh4onyG/XavXuY8Atcp5fyrk62s22X8NwS2cvFJASV3TqQ44VEckSBv5VxDsSy/bZ47WMr5YvWVusXWJsreCkgIDTZ1uST0hNdv7QsdtMezli2K2iUNMP3Ky0gDSlKAYSB9BW+JJLdcnFvl1e/EI/V/8Ao5n2t4yjLfZljt6UlKl2i2UEf3l7CPvXzbvniq5KiZE717n/ABbY+cP7Nm8MbWkm+u0gx0Cd/wCdeELlXi2r3fDI7Nnkf6in0YccF3t/2M+NXDT9+4tpUpMEH6VH0Vc0K9dKlR8dkm8k3JiG1OS4ocU2lMUyU2uDbYuNwCTE1astZ6xTAFpbQ93lsFT3SuJ8x5VTEGCD5VmDu5IrDLghmXTJWj0tF4hm0slODpnorL+dbLG0NBi6QVFMqQNlJPkfOrKcQtyEtrdXJHCzM15ZsL64srhFzbPKbWgyFJMV07LfaEMRUi2xd8NuiAlekQfrXyuv8InhTnh3X1P0bwb/AFJi1aWPUezL17M7TZqDTSUqvdtJUAd/pXeMjpducuWb7SgoKbG2revMlreoDrKlguoUNlA8/avS/ZS6HcsWq0BSEgqSEkHaDXD4W/aaZ1ePVGEJI5p+KjBbk5Ms8VLCdNvc6FEDcah/urxuu6FviFvdNiO7eTvHrXvv8RuGOYn2W4kv4lH9XUh4JKSJgwTXgPEbdt0KS3cMpkSN9/OvsPDpJxkvefCeNRcoQl8T2z2N4wu7yi0w6sBbJKZUrkbRVstcXYwPHWL510pZWlSH9MnboYFeXPw/Z5xhu6bsLm5CkJuA0tKyIUnptXqq4t7J1ABtGVlQ1SOhrl10PLnfqYeGZVkh0ehabmxex6yTd4fcN6VgKStQO8+lRjGD4tg6FONr0rW6lSyOCB0qQyNftOWjjCVR3RjxdPetrE37kuEDSoJnTG+1cj6p0z1IxcnuWfC3Hbq1Q+l1QVsSQqDWw9cuqWpb7hUoEeImYFVzKl6HW1sElJ9+amu5cLmt0K22OqI9KFSQSjTNxwJWBrQVGea1XGQvwhhOknis9s8puAqQY8qT7p1Hw+u1JNouNNGMMstBKlNgkcbbU1zS4shppI25mN6e6vvCkoWogeaaxlS3PkPOw8NPYUWYHkOhJCTpA3kedJi5eA8bJXwSR0oFbiAQomD0G9PD6mU+GVa/MUNUE3Y5y6SpMocKT9t603rh9KO8Lilb8TzWvftYi6oBBCVAyPDE0xoXBGm4fCSdhqgBJrRQpWLqT2Nxi4ae21TCt56Csjlu0glaETPBrC1bL0gOlKNpJO01vMJAGhSkmB4YEzUOTM3F2aYS2EeNuT5imh1kGAkAn1rZctlrUSAQfaBWLuFIJCm0lQIg80m7dh0nkRu3D1y4t5lpxKvDARKpFZGsKs1klTbkE/vJHhNOQhxtzXh9s0ylXOwMn71lcauACj4iyQpR3CTKh9JiuCONtWenxyaqsPtHHStdukqbECFQI6+1OYs0MJWtlljSfJ0A/fesrlqw6gp+IJ6ElQP+yDtWN+1aZbhLrRT/AKQ+8DetGttuRp90PtcRwh54KdwsqcnxgOEhQHqBWwcYsW3VfCYallThOlBfJ/lWqxbptykoeb28QSlQ61sh6zfC9QDbjZhJCANuu4NTsnTGnuFxQumyoqKVKHiSXgqD9qwN2eGtkd8tlAO6fGCSr+FB+4aCypF93QHyg+In1MGtZ3EipAWL5kAGBJO5+9V0+gJuzOq0w5AU+MS8C9ihT236Vrv2OGKCO6KTtsnvCAfUUO+LidffoMdAklJ+s0dTzy0vtuJUpOwSW9SY8gNQ/Wjpa3ZMrexoqYswsNtXX5oV4oc2A9h1rYuk2zSwlC0lYAUFl2TPp1FZkLuUp1BoKUqQUIZCdI8zBP8AGo1+8uXVKcQAkp5hMHbz8VPnhGbbXJncb75vvHFoISNcJckn6T/Gsjf7PUhK0oAQPECtwfzNRibh0LKlXKvH8wQ3I35HO9YnirX3Sm1IQuSpencjygHarTX9QN3wT7mLYUy3pcZtjrEJT8RsPX5ua0O6wJ1PjtW1KRKgS+AP41HF5+3YIJJaG6fy5J+k1HPXjtxpWi1cKgqQS2oJP1BprpTpEzkq3JtBwlQUlCEhIHIfSoD9d6ydzhfdIS3e2ra1iCnvpn7KqHbcQnSHrVZ2hR7pSo9t6zOXTSAAqxVoA3CWjPptzTk6dIXVaJVprDglaU3SYSIV3bkwfONW9MDeGoCwhTQSpO+tQO/1VtUaq7LbgScNfKOJLa0kfaZqRedSu3Sy8y8lRGoINsqCPc1nJKrYRtcD7fErbuu6XetNoQCVwtSj+jlMS5hLy2xbIYWFbFZlU+8rkVhfW640Ut2j2sbKUWzuB02ETSZVIJXb3YUFDYoV+pimmjTk3bdGAoZd1WtkrlOru1Dr0/MrGDa2qwhtFohsjwqBg+x8f861FJutP5iXwgKIHMGfpWN65ew9tACbnqYSNR95IqqbIyPpRs2ptIU4tNkhInUSN4niSud6c85aXzh+GXZtoSY0I2/825rRbuFuBJbZeAcGorWZn0IIig6p1RS0+w5pPKkq+U/6taJRRmm5rc2Vt4eylfem3k8Akg/QaqDRsFS42603qEDQY9/3q07VMLKUIc0kE/mAlXuPDWFy3WXYTbrSpW4glJ/8NSkk9iqZKLu7cWoUpTaykwCpHzA+uqmsPNFsNi9YSUKJShBOw8tlVhtb02MMi1WpauSAISPQ6P5UHEd64EpsnUtmVFZXBnzEJq3FRW41TMvcXKgt4Osp22UGySfoVU+0YCkpQ7eOF0klOhEq/wDFsK19LjhSEtOuJG8B4gx/q1mcCYStu3fRq2jvdynqJCazvbYm5Jm3akhpSGiqN0lxxCQdvWd6bdYha2LYcD7ZU78ym1GVxG53rAyylw927gqlIJhPeugwfTwUjhpS+bj4JICdtAKSB90jal2obbnyjItdncNC6VfqQSdKUrSo6PWTtWNjFGrdfes3ynVNxspgQuPrW4+rFEsJsvhQpK9+61pj030iK2rM4jaFBU0Ck8DVG/8Aq1nbS3N8aXBD3Ljbi0uvMlsK3Kt1EH2kVuWK8PbBWwHVGdKVKtiUnbqCYFTl5iuKraNsyy2CSZ0ugFR8pIP8K10YhiNu0ENWrqiszBVq394AqE5JWU4xTs1rcW9s8l4OXKU8rS2yVR7GpAZhsFuoQLcphKk94oaCfWIrQfusWSVpvVEJSmVFLgO/rtWgth+8Sm4FhbORI1FwJn0iKqUfM7D83p2RtB69uX3E2lw+2v8AeWUbKHvBms74ShpLiL64L06YLZWPU8RUOuztloUlVhbNLSqSpRSqfbisyGC0yF2yGn0woFBWkR68cU4woTyWtjbXii0LBubq4EiNfdaTHmaw3F5csJWELuu7UJ43PlWJFkwhS1XFuFd6AlALqIn/AApM4K1qUlFgySsRq7xEj6zTce5mm3wOtbnEbtPduvOFIVG6QRB4kyKzLavrLZq/XcFwTpJOkenWtM4cnDgovqZLm4SlC0lJ9/WsBFwhBdQzbFKZEL06QenWalK37JXmNMkjiN7b60u2Q/MVqIQqVAeW424rXcvb5YF4i3KSP+rmQOs8VpOpCnO902ojYxo3mmm2sLVMlFq+6ojS2UpIT7kmPsK1XS9xObZut4/iAX3NvZ90l3dSvm385AoF7EFBTTpWUFWpSO70pXH+cQayW9xaNw0WrVJVukBCUgj/AFhFDvEKSs/DMEAmCYIj18VG0dxv2kaKlqYXpVbPaZ8KinXH+ztWycJfQhu4SAWyIPeGB7kxtUow40+ylbNnaJbAk6WuR5bKO9bDFxhrTLwdsm+/G6O/KdM9NppKTfYXluK3IRVmyVFxKtQSNtwQf0prVm++wlaiCpPiGhMpSD0IippdzZPWypw3CnnnNilIhSPX5qa7i7PdKBw+2SQAmUo2Mcg+L2qVKSkJ4248EejCsRLSu8K3AiVFaEiQPSRUjhrVs6ly4v0ghCAEo7kErPTeR/CnIzC0q27hNrZNLUkbtckeRhVabeYl2neDvkbeCAqFA+g1TSk72FCKib6l4d3SkvYasPKIMJCdMDjcnmtB34Zt1RTh/cea9SZPrt1phzBcXLSrl5WspHVXi/U1muMVU/ZNu/ssqaKTpcSkSVeZ8e/2qHGnbNW+pGi7bsFSX78FxpagA6CgqHtPFY7q0ZKg03bsobI1JW64gKV6RpMfet3DrlxptYv8PYXqA8LiSQDPMBVbqzbhISyw262BOhI438tdU8lDjibINNs66osqw61Czw7CAQPLURVfz7h90zlS6Uq3Y7qAAtATIk9SOtdBFzaJanu2lEcISgyfUeP+FVrtNvrN7Jd+02wG1JDc6jBgqG/zmftWmCX/ACxXvMNVj6cUm12LBguEvWVs0i2wppa+7bJcKkSPCPIVvpsbli5XcXNnb3RUP7J5wBv3BFHDcdd7pm3RaAMoQid0gxpH+dW++5apRpQhSG1bSFElauYEGsJvom7OqEI9KNK0wm1YBuRb2i0aoSyh5ISD5zHnWd1nEHDqPdstBJ06FhLaT67c1shRfaV8Ew46AmUjXpM9Z3oqavWlNISEKQpPiAWo+LyEr/lWc+lvqNFCuApvXVJaSq6T3gMJBfGhSfPj7UUd0EqdUlsJSSFKbUJ91ExTy/coYCbi2SkOEkBaid+NyFUrZ9KG1N36yzB0J0rJTv1A1fxqXGK3ZXWzXu1tvhbL1w6EfOJgkj69KFhb2iSl21S28kwVIKQSo9dPlUg18N3yku3QfG2lCZn76uKk8OshduIbbC1OGS22hpWoj2BM1TpLYbW1s572o2zKsuPKFl3SHXGUJSEJ2lwbA1cm8LduELatbEICFae8U2CYPQEe1dSwX8Omau0+2wG2xVz4PCMxXfcMXj2ghAblRWWwsKhOk8x+tWC+tOxbs2wLEbPHMets645a4qLVLAXc2aUstKhazAUklRBHPtW8ITljpcXe5534qPm1D2ntsv8AKOcZW7PcbzGb1ywwEXxw62Vd3TlulKlMNJmVmeODIrqNn2Z5TyTiuBNdquYbRm2xfCV4s5ZM67d/TA7pvX4gpSiT8qY9RVSzx29u5hxfHsSwa4t8KtMxWFvhlxZtL16bZkEJQFqSDuSSSIJ61yS9xld1coLz79x3behor1uKCfIEq2HpU3jup7v6Grw58+8n0r0W7+Z2N/t+wXJ9tlZ/s9yg1a4vgVzcXNxc31uhwvOKJCAFJUFEJSf3uoFcjzH2vZtza9+ycdxW5vrb4h6/Zs1PLKUPOElakjcBRnmtCzfatblu7asX3nG1d4lt1BUhRBmFJ1b0RcWLalXDrD7a3F6tIb0wSdwDPFT1za22Rvi0+LE7q368kM49crbLjTCwDzpXya1n0G50rcwtxbwEpSYk7etWJzELRsreQp3QTGhKTJV9TxSddafCVrXdJiBICpA8pBrCalLg6+quUUc39/aOlTWVcRIAEgFML361ts3Fzdt969l9y1W2dkOAbz6TVpF3a21wpxtD62gZSApWx6bkmsNxiltiDQCviWzq8Sgopn2IVWvUulJrcGn2INFwuQTa6AoeMKV4T7dfvRcFt83cJ71KpJ1CB5EQan0vWjjPcpfuUgdVaiSOm4NFFzhyVANKWQNyFr1H2qZuP6i6W+SuGzSUquEtkKBJJkR9fSmIWEkd6VoCudK0gKHkKtDmJYc5rblQUrghJgehHWo913Bbpak3F64P3R4SgJ9Zn+VT7XSNKokIl+wbULVSHSCYkuIKvb2rEu0wRlzvXcHmFGF60pgVOpYygEgHEXFujkAncz61gxU5bdbDDFy4VA7lZmKhR33ITbdog3m8AuVFSrRkhUAGQSBv161qqFikloW4SjTt4tQ242BrdTY4KCNBbWomSE7A/rW2cPwRbSWWkOsyZKkKkj9eKqMUmVbfKIX4bBlAi8tCFqEpLfA9N6yrwzA7tIdbZeJTCQFHefaKlHMFwxtxrvL8SsS54VTM8c7VkRhWD6wlZeWATu2YUR7mrttbHO4KTIEWWEWdyC2zcB4n5QATtW7cWuHP2+hy1eKSZWNtJ8qkLm1wZa0Jtg8hWr/rE6lT5c1jOE2nepN644lB3TCCNvvUqUmHQo8EcLXDlIC02ym0NyY1gpHtKaCUMLhy3QotHbSFp39I01JtYZgASQ9cLGs6oWTHPrWuuywUp7xD/dysxCyAPpNdEJ2jJwkYWcNs3EO6LE6huZKdj7aax/A226X7IF1PUqAgf6tOfesGlju3HQVHVKpkj08VYEXtqCVpdW5qVEKmfb5qOp8iUUt2bM2TJS23hmhon5glK1H66RtTkvYaGoFo2oiTuET9tFY27/DlFSXGFahwEjb7aq1XbqxtA4lLKdZ2T5/WTVLI63GnGzbbThzh1iwZSep2BA9tMVlCrcJQhu2bc5IUEpEf7FRhvCSlIZY2EgGZ3+vpW03eWmjw+J4mSgAgfxqHJtlqSlyZbm+tylDardpShulKkpM/TTWNx5pVylSsNaMxIUlMewARRN80tKm3lJSRsEpEx+sitYXCS+mLlIciUlKST/GrhOyJRvsbzdvZsnvF2yG+83CSgJG//d3FPUu2S2ZQ0tCOEgAAn6JrXXfr1D4q9KRG3epMj1G9OLoglu8KZAIVEAevNEpC8tUbTarFKCp+zbWkcDUJ9vkrW+Ks9QAwpDgAkALG3oPBWwFtN2vfO4gTq/dSnefPmhbXTUall2AY1FBEn3mpU1xZXlWK1fwjQQjDQhSOEgDn3005DWHrWkm1Ac1bAuAb+XyCshfbP5qbvuI2OlPB+prGL9CXEly9ZkjwyAN/XxU/ei8aXDNhy1w5Sfy7a3SQSI70JE+RATWnc4dbD85bBacHhHjCh+ia2GcQsbiQ+8EKk+FpSYMdYJn9ajby8PxCy26haORIkiPWaUYyXBbUJcGR5m0aUO5+J1JTJUHTE/6lMUq1aAKnFEjeCVaj/sVus3BW1u60NYHzpG3+1Te9QpIQhVrIJ1L2BH11Ul1dxXRrufC90XUMwDJK+9KVAeR/L3rXbU28QlNvCOpD5H1HhqQeS2ohKVtAcQ2UH+dMVbuthRZdQoHjUBx96u65I3itjRQ/hbbxSUXCQniFFUH301tLuLFsBTblwE8mSUkH/VrEdBUEvptxpJMaQQRTO/atlKNsi32OqAmdX6UukamzZDzTqwEl/VuSlbiiCfQadqyNLaYUkpUp1R3IJUQP0rEw8xcBDrrKGydpCwSfP2rK8G2SO4eS4kklH52kR6xSmq2LU0zZXibq0JC2y2D8pSFD+VIXK16g2ylUEFKQtaRPmNua1VtXBLZN8yIkhIeEe24rF3TrbiwtdsZEjWsGT9qiEb7FPKkiS/aV+28kLsQVpTsFKJmf+7WZOK4o6gtm1t0GIgrMJ8+ATWgq0twgK75IJTMBaTH8aa1bsoSpTTqUub+JBT9pqelego5GzdL90G9TVqgEK/Mh1cfTanf0heZbCHLVCHFTMqKhA9k1q4bZEEhxlDg+ZQU4NU+c/wAq2G7VSEApt7RKCSEwsT/x9afTSstKL4NW6xe7fBDzOrggQoSR9K038SxF1KGSjYwJ1LBCeg4qSLTdsoruAygT8zbiQZ67EUnb43aBbJAU0FbJK0mPXamlKS6kLrt0Rar26ALDCEK8UlKlKJAHXjeinEXyD36rYjndBBEc71IItUNQu3s0qcHyqU6BIncbVr3lu8HC2pplCHJVCXQrR70mnJWXSaswrxF8Ed2beFAE+IzHpIp5xJTUobWwypXEpmfp0rTeQpp9SWWUrA4Upzr9uKwvNu3S0rbtLfUhPzLdHP8Aq1Mo2kzFZFHdm+vF1nvFC6bPQgNfwrHb4rZt6i86ygKR4tSdIBHU7VGuYZiTiCV2dvKdwA6P8KarDsQW2G/hrdS0iI1pJA+1awipcilkTJZvGcMk/wDOVu4Un9xJBH+6npzQl50pXcsgEiF6JCAPOodjBcRZGg4eyNQ5Do3P2rI9hmIuoQz8ISkDxAKCt/tRLHFPczeX0J9GYMOW28PiWdS9g4Jgj2rUZxrBUrUh9TRSSIJTJnzrQRYXSVIaGDMOT4RLqgJ+1blthCfEVWDSVAgEB8lU+gioeLp3NVnfobjmNYSy6HGb5p0hITDYKJHseKyNZgsHSp1LSU7aUiUyfrUGvBUsqKxhgbiYBWTI+1bLVm02hClWSNz8pUqAOvSkoKrQnqPVGzc47h7qkMNJWoJ2UUEJ1H0rOze4c1cFxgMknlKtjPrUE9gqC4taWhpUdglwkD2kbVq/DoQotQk7wo6iI+umr8mMo0T59uyw3N5gtwtSn2gFBUqUkBvV9jz9KBxDCXGCUvBASdKJUSr+VV5OHPFxJS60pMHSQtUH/ZrZRhCJ7511KVJ6Batz9RUrCojWRPkmH720Fs0F3bAKDoUlRMkH1JinPYngYfDDFw73fVCuVfUGIqBcwsOkr1o5HhU4T/Ks7VtaPjxhJ3hRk/8A01binsx+fubruJ4O6pTBuHwQNkpPr0M70+3xPBWXRcG1dcBjfgz9600izaWkMLZTpInxE/ypr6kIfIcTKT++CDv6QKVWqF5iTs2bzHrVDoWll3uzsYG/tuYpisdwsx3zCFJkEy2CQPL5qY3e2bQ1u2JUVDTPebKPqCNqx3VzhbjYU2hepJ4CZkfapUFF3Rfm2rs2jjuGoQU2zZQpW0LA2A8xO1aDuOWj4DXw2taJghMpH1mtNFu2o983brZQSd1KO4+nFZ23cKbb7ksPrWqYUlZj7Vqqr3mLyOS2YwYth7Tepx380gykJ2HHWaFpjFgXTCEEKO54MfesV1b2adFy3Kkp2Ukngn060122s3yp5Vu+lRAkByAftVRox63e5mevcMLks2LS531Hj+Nalw7ZOJluxZbXvBQowrz3reUMFYT4bdLKymdDjxJP1rGtooSh5osICxulazP0HBqWlH8pt24I1jEU2ZhppKTB1Qv5h61mdxPvUA/BFSQNyFmB+lb6bGwf0qS0pRSPEQdOo+kc1sNNWQa0v260lufAp7dRijzGthKEpEMLmycX48NCSgapKySfOntuoUoBu0WlBGoa3CI/Spq2uGnW98KUe73kOAk/pWxb/DOKWHmUIC9wQrdPpR5zNFpn3IJpAceJctCDBICnSnb02rKlY7hQNi6lPQl4x/4anv6gtyGXVQmVf2kkAfSnLaZvbgl1dy60oaSlKtKR61Pnu9kNYJLgg7Y2wSpLhVGyR+ZEfpRdd/P7plKghzYhLkAfpVgZtMOtlrShlakKSB+aqY9jAraaw3BFqcdDG7aQZSszJ8qjzd9zRYpJFZaLLZLKLXvXJG/fKhXvUrZ3dqXN8LbbIMTrKyK32mMGaJC7QAEgkFJn35pzycIZQCwh0q3UQlHA+ppeYpcoSxSfJrs31spxTFy24lY3lDhIJ+vFSFvjAs2iGLV6QfEVp4+vWtdl3CLhoFTDiVdZA59JVW5bu4WlBS9bXKNYgQoEe/NZ5EmbxhS4PRH4MMKdXj+ce1B1l9NvlnAXmG1lQKTdXPgSPcJBNTNwGhcgETPMKirB2Nt22VPwqu31valFznTHVuIK1Arct7cBPHQTPXrVZU6guFardSZOxiumNRikcGkvIsmb/tKl8I7Hlf8AGjj5dxbB8DbkJYtluqST1Udv4V5ZauVWt0i4SlClIMwtMj6iuz/imxxOL9qOIttrlNqEW6fTSnf9TXD3DKjX0Ph8OnEvefNf6iyv8R0eiSE4vWsqgCd4HFNpUq9A+aFSpUqAFSpUqAHJWQKyNvQQZj2NYaVJqy4zlHgu+Xu0LEcGQhh5ReZQQUgndMeVe8Ow3Mj+YcpW+KEpKn3FKUnjcmvm0lRiK9y/hQxTV2dtN3LwCkuqSnxxI9K8bW6THiaywVN8n0vh/imfVVp8rtLj3HWO1i1fxTIWO2K20rDtm4BG0Ebj+FfOi+ZWi4UhcghRmDM19IcWeXdWN1Yq1KQ+0pHEjcRXztzPbOWOPX1ipsgNPrR9lGq8PbU3Fdzs8Wj/APVi/R/uiQ7K8QVYZkW2kfMA4meZBr3LhOIWt5htspt1KlraSqAY6edfP7LL6mM0WYQdOtXdmTHP/pXuTsxTd3mV2XVv25LI0qR3yEmB7murxCF4lJ9jw/C8vl6jp9S55RuGbbGn7ZdwVJdIXp1TB4qyYwm4Q6oW50QTHrVHsr+xwLNNncFA71z5kBOtH3Eius3eLMrt0Ot2FssKMmWgrf6140XKqR9I30zp9ynZUWlvGwzfXRZbWIKgCrefLaug3yLS2SHBifepJHDRSY+9c9xe+tlXhe+At2ANwWmdO/3qz2b4vcMS6gngEEHjzpJdmROPTK3wyVZFq44ktYqhOoSUraJ39q2FWjeoAYuwUyf+qVI+lV2WtaStY50gzuPepBlSVTCBPAI5rdRSRnKXSzdNqW3AkYpblE7akqE/pTzZIcSSMRtxHSF/4Vo3FsHAEqEqPWmNtPsKC0tmOD4ufKo5kS/VG8vDSTpcxS2BHBAXx9qyJwttKdYxO3IO5krI/hWmNaYlBBV1maKQUKIdnT033Jod3Ro1aszO4O2BqOJ2niPTVt/s1o3WB2zjiWkYzYpWTJJKwY/1azHvTGhs79AZNalyEkKdcToUkbTtV3XcmD6Gby8NaabKP2lZrV8pCVqn+FY22rZCtrlgQB8zkfSoW1cccK3FmCVciAfrQUHe8UpadYUdyf8AdR0XuxOb4LH3JdTCLpges7UBZShRTdME+fX1qIZUlKkJ7wEz0M1INtKhShr3k+9RRKk2zxQ1jSQ5ocv7hLYgp0HYj/Snmt53FsMI1hy/J/fHeHc+dQzgxRb6F3mEu9wRsCgCCfIAfxpy7F9ZW0GnUpIlIAQJ/Q1ytRs71Jyjsb6L1kGUXL7RcmEkAqPHrSfftmjDmJPRyCBx9JqORgyEKLjturXOknwkkfRNbDlo+lGm3s2lr6EpSf8Ay80+hJWNdcdyRbvcPGhtOI3JIA1L3B/jTLq9wwKLqLx+CYBgmPua0DZ36Sha7Es6oBAaSZ9fk2ovWV448W+7cUUkQVJG589kUlH0LW+7M7l7hq3ARcurUrmAoER96zLubB9oBLjqCjceJQn9K1l2lw20rVYrMglKghPzdd+7rKiwdKElu0WO8RCy6mft+UIopRe41N+gk4zbAqYcw4uqiElb6kif9WtNzGw6kJZw5ttwkhXjVz0201sKtr4FTfw6VbEH8oqA8v8AqqxOjF7YIX+zg6EwCgW4E/8AwqpTSE1KjE3j18qWl2aZP/ZlQJ/2KY7coUjvEWyFOEeJstkR6kxUghvGHGEvNICRuFI7vYDyBDW1AYfizzoVcYYlSUifCkJKvr3c0nJGdNumajF2+4kqVYWqVKEDQry84TWNL2JF5Q+FtudgZ2Hr4amv2TcNWyXkpWXlncutpgeny0VWWKOJlKEoUVQpSeoHppqOtcFwXTuazjCylku3TY2AISgR9IFbjOG4aph1Tjx3OwU2kAesRvUXcWePtOltplBk7TOsfTRtTnMNuUo/Ourlm553GkR/q0+lJXZcmpdhqsGsUa3Gb4trKwfGhPXkcULmyt2nS8i+a1gaTrA6+ZisC7PF47lCmVtJIOogjfruUyaavD8URNy4i3UlO28j+UUN9O9kfBGVb9qxBucTRt5NJP8AGsGIXeFPMKbbuu8QIOzSY+/NV5/NV5b5ktsCuMAdbdulBCXlq0Nx5jberXbYcq3eLjlw0Ggdw24E6o6Eg1p0KKTfciE1li3j7bES1e2baIDTSkhJSFKZBgee4p1wu0QyHGbtKi38vgASR7RtUiqzt3VLKHLVtSidviEyB95NBvD0vFTRvWUN7eE3GqD5xqiofRd2VGGSuCBRetOgttvWsAkphkHT7nanm+71QbfuLcg/37XVU+ixYZGpN/aug9NY3PnuusgtdadS3WUn91YuRAHp+ZWyyomWOT5IRd9Zstl25uLIHYQm2SFA+0j+NYXL1p9QPxrQWegtgJH3q3CwGhtk3LKVblRW8DI/95tRssMxJali2urbSDKUJuACo/8AvhSWRdkT5ZVGm2QpC0YiwkQQU/Cgx9dVY0tW67gn463KohOlhKv/ADVb38MxFaggXrDMpjQq9SJV9HZopwh5CElWL2CVIHyfFJTuOs97NCk2K625K2hFpbguJu7Y6Ruk2okj6qrKU2Nxad28+Shwak6bVIgeXzVY1N31uQpvGrJwHf8A6STpPlu6DWG6bvW4W5jFqlRBWAq9gKnr/a7CpclJlJKK3Kzd4dhbiG2bZx9YQrVqSwlOmOOFzHvWxbsW7ZQhu8XKj8xbSfoBqq7WOS844hhYxezesl2agVBxeJ26RpBg7G4B542rYtcqYvcLYtmsewo3K1I7xpV2wkobVHi1G7An0reOGUuEzmy6zDD2W1ZSXFWtk0pdziSllBhE2yCD7K10rOwt8dxBNthWNtvPKTLidbaCPMAKWAOu9d3XgOG5TvcOxXC7CwxO+tkh1f8AzyGg2onYnVe6TAjYV0TAc75hs8tXWM4zjOGpatZcW47dpUQiZI/JuxwDxuTNdENE2/aZwT8SX/8AGjzllfs1YxTG7nL13m5rC3bWDcPqYbukBUTGzyRMCZBrqOWexvsxvsCU3c9ozb10XCRiCbYICU7eANm60zzvFW/H/wASWC4dhxXgmaLXE71spLdsE3TaHJI1J1KuTx7Vz7M/4qe0bE7JLWGYkzgykKKlqt1LdK9uCHHiE79YqpR02Ne09yV+O1PFxXyOgWvYd2G2yXFHNLDy3ACpwugwqN1SLwCTVPzVl38OGFtPYI5na7YukyjvrfD3X0tkjYj+tlBO88niuR5kztnnOj6bzHs1O4i8EaEOOOlJA/0Q4NhVddusVQO6ViMhQjXJBP0LsVjkyadLaJ1Q0OZ75Mr+ZOvXHZ+h520t7m+eaQFIS8s92pxQOzpGswTzG4E1A3KcKuF6ra6ukwfCpSELJH+uJrEjF8RbCGnHgpCY1LDp2PsHK23cXxIOJCcVTsCZRspI9SXK5XJXbOxYuj2bv4uyPctLNKg45ePalGRrbQnUP9eRWq47ZoUlpy5dJUrwgoSRP+v/ACrfdexfvwljF7hx5fiUG1yNJ6bO1gU/jBcUhVyrQNW5VKj7fmVblFrYpY5Q4ZgWWWkuW7bwQpOygtHPt44pjiGWS2668vupHeKSkJUPKBrM1um+vkK1pxO6cbg+BLkaD7d7WZd7fLtiWMVukqEBQKpmd9/zt6JSTRLUnumYCvC2llwF1wKBmSCJ9Rqprr2ErQFhrSRsSSABPuqnITiRVrucauEd4D4QQCIjgd7tWwwi8UguIxC4W2CANREyOsd6azUUt0zZTk9qI9lODvWyWWFbjxKUXE7np1rOhrA21qL7qQ6rYQtIA+uqpJdq846VXuJuKTAITqgo+hc/Sgi0ZDaXU4pcgFPiOpIAHmPzabkn+UluSdMixYpf1KtL9sJ2CEa0q8X+kVVvN2zgT3Ll+kFQEBCBsepnVSUHWSpfxtykGd23gCfeXKK2r55lAXiLyQqFbOgkD/3m9D4BRkuBownEnCUrxNbaARp7tQgg8TpV1rJfYFdhtLrV6+FpO57yR9iqkqwe71K1Yk8gQIClbqk/6e9bCXWLdQBu7lRc8J0qEo39V9fapre0Vck6ZpIwq2ahbeJOuazB1q0afrrrI+wEakN3ykLIAQlKwsE+Z3k+9Zyq0UkBeIvIQAQlJeBUTtz44NJ4M3gS2i9uQW16kqDqEiANhGo0V1csnJlcVRGXVjf98hTWItrKt3EgDwDzgqk039nG5uEqexAlCRCS2EoO3TdW1TLdk336HBc3L0J8UvAH2B11tNYZYkKdSb3QndSfi9z6A64pr2d0ZRuS5IRzBCt1EPOrQqYS48lUR/nTW3b4TerKfh75hDLYIJSEqIH0NSjlvZSVNNXrJJ2UbtUkfRdNtWbZaZt3b7SFHwh4kK8wZWd6lyjJFxjJbmocBJcSpWNL4gQAfsCofrW6jA3XbYFvGUh2dIDrCQI6+IE709VoPiFvvuX2nSEwl/ZI6AnVReQUJSlq7xEKnwKTd+Ee/jioajLjY1UpIz2mG27cKxLFDdlCdI/LhKR9OKqvaza2zGVLlNq4pKQW0qHmkqG//EVPpYulOpW3d3rydMKSsg7+sLqs9pi3P6J3CA5dJhTY0kyD4hvOqt8MEskXfcjU5E8Tv0LkzaMNWTKMPvEMktAqcQ8SpXhHM7ULdnE2EpU5jy0tcgIcCAT/AI1oOg6W3HLzEnE92hI31njgDvKzByClptV82I3Uog/pq2rOUYqTbKc9lRutJVcSl7FnAlHCS6kJ+4FbDLVlBaD6ladh+aFb/baoNKL0Eqt14o73aZWpVqrSlM8mFGp1fZ9mLE8GRjV1jisHw99pT9xiLly2DaMoKdSlN69f7yeR1qJLHTk38twWo6VSf1N3DsMQVJSLhwH9wKSgR6gxVkyv2VY1mzGbaywq2v7m9u1abZCQ2UuKHIk7D3O1VvsDveyawyRn+5zjil9njHmcUYtMCbavH7dLTJSrXcah4SAY8Jjiur5k/FDmZu4tGez3DnMqYTbYd+z2rRAafUEn51B1SdUq9ZoyadKrez/zghZ8+TbHGvi1/Zs209jeVMjWbznalmW8y9iYdSLLDbRtu9deSFQ44tafCgJ6DrFWi57Y+zXs5zJcX3ZFhDLxGDDDbbGHnXmLkOKH5jxQoFIVIEDivNF1i1y+Ct7EL1RXuFPKTJn161GLfvk3IUrELkgJ2lSAP41ccsIKoov8L1e1qH1e69jqed+0LM3aA3hTeOYy/dpwZhVvZKF1oKEqI1fKgTMDmf1qi3mBsKUsO3jmhZmfjFbq+1QTrgUtKRiFwlW+mHAdU/WnMsYi9ClYhd90gwkEohUngb1Obqnu5HXGUMaqCpe4mF4DbpTravH3SNwPjT/9PNMdsEtlXxDziQACoC7KTJ4ExWgi0uUqBXid5A3T8mnfpzWZu1S4SLv4xSUnfxAfwM1iku5rGcmtgqw64U3pZxR5Ko1f9KnY9PlotWayZur94atyo3QIMdIIrNbW9kEoSu0vFoVuPzQkqPSJVP0o3lvhJSVoYeDhMEqdBV95puSqin1LgYjDrdbaC1iSSCD4TcgKT6Hak7ZLbT3LWLTqB+W4JAnpUS7bYQ0ouOOXSNvl71IHPnNKzGCpQorXeOKJJ0of2+871k4rgm5PlkknBnG0AXOKKGoeH87SB501VkykloYwqJgBN4TH0io65fy+gpYWu7EjZXfbpHUTPtWi9d5fSFBx6+SQd1CJJ/1xV+XF+onllDkmBYsBSkt4xpdA8IXdKJjzpqrcJQonFWwnSEym53/UTUR3uXrortmXL/v91SHAdQ9JV/Ok1g9vclLTd3fgTMltsD22XR0R77Ceom+ODM6zdMrCWcXK0rBEi5+SfemKw02097jpIO5Pe6f5093BMNHiXd4jEwrWlG5/1qy/svC1s6lsYgsJJAGlJnbr4qpRUd07DzJPk1Wmm9KVKxMuFPi/tkkR6mtj9lqQlKnr8AjcICwDHI6b1lRa4T3P5rd8lUfunr5fNWi6/hduT3j+I7HUlBSNvOVBe1Je0LzK5NvuHVon9ohKiYCAoT7msRt8QZQp1WJIS6NtRWAI9aLeLZbuRKDiKVAiYVtx/pb1gVjGAKac+GViGuIA1iP/ABUdPuJ82uWZEMYw08Aq4FwFifCvTIrOpN4WEIL3Ek6l7z5c1pMYzg7iU6ru+1eQgg+/iB+lbS73C0Q6q9uEJBhW42PoNUUO06oayS7M2GbrEk2waWW29G48IUT9aD9veupIcv2WwoJ0kuwSfKOlai8Zw0LhFy+4mNMrUCoz7LgVhcxhsIS+18Qkjw6yQR9RrrRRXcPMdWZk2LyUEftJBcid3TE+1aL7GIBIQLkFahIl0GPPaaSsct+8DneuLBVuVaAZ9PHwKCsctg9reecgq2nTsk8kePf2pwjXJjlyuWwvgcRabC7m/S0VyQpT/wClZ1YTfhpDrWLNaVJ8TYdkx57xSdvW3bjwuXOhIIQpRSkK+muj+00LdQlk3CyEkGFJ5P8A3quWNepEVS3NZjDcUW6UoxBkmJAcVsR9DzQThOKpac728ZR0nmfvWyby/QYcdUhAEJ3TBHnPeVkN0EtKfF26DqnUIKR/t0dEfUdqtjumTPwC9u+eMr4Zm7CnsGFpi1sm7tk3V6pC+7UJSSkJMGPWpxv/ACbH4i0wpNzloqA2nEFHf/Urm+TvxcdtuD4Kxg1p2j4vb29iFW7LYUClDaSQlKfENgAKml/jJ7dkMKCu07HEkiAvUkR9NRraenwPfzH8jz+jVv8Arj8jjeI5czDhWM32DXt5aJfw65ds3wPDDrailW5VJEgxWBDF8gpWrErI6BJSFmR/vpltifxd5fKvrpxT7r6rguL3JW4ZKjKxJJmthOKENqdcf06TAWAkceX5lQ8cFVM7Y5JcGG4wnEXkBa7u1hW+9wdP6VmbwjESnu2rq37xG57t1StQ960rbETclYRfLQFc7wT/ALdb6XQRqViFxKhAA0kn/b3pdCBzcN2wN4di7bkG/tQgq3lcfX0rKpGItLUk4s1pSelxpBHuTWu5e2luEOuXl3pSSNQKffgOcVpDELRZW63iz58XASB69XJNV5cU9kZrUtvk3HLbFFEab21Ug/LF4FR7msDtviDikze2sTEd8D/E0x3F8KWlIdu3NW8k9PUfmViYx+1UooYxgqZA+Yng+R/NqlBegPO+zNtvCr5a++bcaWFD91+R9QKS7S+bWhSWUeSj3ggfr+lY28esinSrH3GieE6wPqfzaei9YW7LuMJHhkEK59R+bB9qnp7MuOX1ZlUzi7cS+wAkTClz/A0Db4kdLrD9vKtikOk7/fasguEJQDZ4yt1ShMF9Mk+wd2ply5b9238Rjqrd2dwCf0IdqFjj2DzunuNAxNxZSm4QdCvF3jkj+NYlN4mfGlLSQlRgrWQD6iDTk4si1b1N4glyRp1bGRPP9tWF7MT2psm4dW2neArT9x3lXHC1wRLUxiK5GJuoCEuNBJ2JQokkeW5rAHsRZWUIuGVjn+0PHqCqs5xzElhSFqDR5b/PEn3/ADdqh8zYjn/C8OYx63yybjCnXC2LwXCykLGxHhXGxIqnjjspNJv1Zm9VJLZP9Ff7Ep8RfKlpy7RrmUpLwEDz5rI3c4mITIWqdil4f40cKYzDjyXBhGHYniJaQFvKtUKc7sdCYcPX2oKucbw53u3WL9txJghwKbj7uVLxxg6cl8xQ1RsBWIpUpS1oC1CU/nAQZ94pqrnHNSjqZTo3MuD7zO9OcxzE33Em4eWENiCRcCR93YrAMVunT+TfrK0q4+IJkfR2lSS9nc1jqOxnL2LaA+LdnSRJ0r2+gmsLdzjVyVItkMaUmQO+RMfeslviOMJlVz3oCATPf+Hf077at+2xq9S4NK1O94gBJ+KKkoP/AL6mkv6kV5klwzTbvMctwpu3baSECYL6R94VTS7jLiFLcdQAdwe+TsfQTUscSKHla713vVCSlFzA+xdrXuMWxJtHeMOLQmIOu4IB9Z73+FJpPdGinJsinUYi60HnQktxsVupmfvvWFljEkrCkvtFEgqQt4R/GplOJYlBbVcuKKSCVfEnSNun50VtN45eoc1jFbgoIie/UI9odqG4x5C3J2mRGh65X3dsGGvFwl1EJ9jJrC9h92lYQ860qOAq5QAf1qeuMQuGWBdjGLhCFb61PKg//Fo/tjELphSLTGrhakCVf1hUR/76qSi90DbXDKsvAb9a1KZt7b5oJS6j6bg0UYbcgoaVa2zyySIDiDEfWrUxiOJNKGrElpWYOkXak7ehDn8qyu4ziCl985dXiSnZBTcGD9Q5+tS6k6YXJlW+AxFToaQlpPh8Se8SQkfeaypwHEWiohq0lY3VKZH1qaVjGKvXGhu8WojfdxalH0nvK3k4pjIQUIxnuknYoLipkeUrpSjG9jVST5RTm8I1OaPi7JsgdHERM0RgVw2sKK7R0k+IocTP0mrUvGcWUpWi8unkgSfzlAfWFH+NZTj2KhCXLdagYiC+5M/Q8UKO+7IdlJOXbtK1LC7RBKvlLiZA861n8MvmFLCW7ZwqPKXUEe4FW25xvGXWyleIXSVk+KXVT7Vrt32MqW2sYi+EAwuFLmZ5EA1cV6kuXvKspm/I7t1hKiNwSpHHrQSl5SVAMpbg+EJSk/zq6Kv8cXb62711xMkElS59OBIrXL1+tB/OvCDsNJVHrG21Gy4I6mVI4dcPpTpQkrG8qKE7/esXwN444UOWqYnlDiCP0NXu2ViTraSL4pCT8p1lW3n4aSTfKhIfcUlZgQon9AmkppmnlykrKYvB71wJVbsB4nkFxJn261pnDMZQpSRaISAZnWJFdGt3n0qFsLttLiflUO8B54PhrKXb5t2XLw8yQW1Gf9il1xigUJyOciwxWP8AoyieTPH1pz2H4i0ARhxUedo5+ldCvL67lRafcCCZWpLKkyf9EINRVxjGKIUSnvFpVCTLBj6flUoNSCcXEqHwmLvIUtOGBtRjrI+8U1nCsYCi5+zNRg8Kgz7xvVuYxS/JSsi3kAkHuoI8+W62nsZxlSkhDjBC07a2wB77NVq9uCXbRR0W2OLZCF4epC0mSXBsR9tzQbt8WQ3qNrPi3SB09oq3i8xbQHHLxkKnSEttST7flU83mJuNBLbzK3InSu3SCPXV3dQ+mTpCWNlPQvGXGu6OGumDGrePtFFxN+UaP2c4IEJAVBJ8+OKtnxuKBxKH3LNtz5tKkoBPpHdjesyLvFEqdWk2KyIAQtCZ29m6bVDUmtinJwy/WhCUWqw3BXOoiVfasrOD4g/DzTa9tzuZn3iKubeL4s03rNvYvFJEoLKNInncIrCnF8QUrS98I03E6Utpgf8Aw6mpPg0jJVZX05cccbQu5adcc2CtlSD7xQcwS+PgetXNCVR8yoj7VYnMTfUouC5bUTsdDaYBj/Qp7GIrbZUXXmFOfuqAST7xoFRKL4kzdSVWV1nDEto02+H3ENnUfzVQNuYisa8FfLguHWLhgOQUadSiT5xFWZy8OhTjL6Aoidwnf6aDWsrE9TCSp9KVgxpIbI+5TtUpUPzNtyKFhigQG3cOeW2olXhWTzz+7TDhTqjDdk4AeUknb7Cplq/GtSChgpUeQEkffTW0m4w+5UkIabt0pIBKG0kq9pHFT0lRzNshGLEMsJQLVb0AhSAtQifpUzlPImbs3Y/Z5eyzhtzdYhiLwZtWEOEFxREgSqB0PNb0WI/M0tKHRKkgH9BXQuw7OeAZH7UMp5ux5s2+H4Xijbtw62jWoNwQfCn5ueKIQUpdN1Ys+onjxSljjbXBLtfgd/Ec4kvXmQLlMRGvEGdz121VE5i/CN235Swq+zFimULm2wywaL9y8m6bWGkDlRCVTAr6HJ/F/wBgLrhdRmO5hJ2CcMXx7RP1qp9q34quwnM3ZrmvLuGYy98ZiOGv21ufglJBUpMDfpvFW/D8l31bfoeXg8R8R6kpYtm12Z8wlWDlvL3erUpSgNMmT6it9GCYitsX6La5CFSEkkwqOam722tl63GdK1p4CAI/Wta1aDjRCLpKFI4bISST7jauNxp7M+h6rZr4fl/Gbt9CLdtxa1AflmZVPlzWve4RizSyyhTra1K0hvXHjmAN+N62rq5VZuKU5cNwYI0gbfpXQPw+ZVts/wDbHlHL6Cp0PYi268RBIba/MVt/3RWiiptHPrM60+GU2+x6T7RcJtclYFlLsvt8Qb7rK2CMId6zcujW6SfOYrn97f2WGWL98/ds92y2pwyo8AE1Q/xBfiKw3DO0XGbjMzdyxdXV66AhtBUICilI6dAK5h2lZ+u38lX6rF9xHfshO5/dP84NdM8kdq2UnsXotGscY4W94xTa+Kv6nlzPmLOY1mbEMTeWVuP3DiyT1lRNVJXJNSF66XHVuKJkmo9Xn619Vgh0QSPzjxTN5+olP1bBSIpCnLXrOogD2rY80bSpUqAFSpUqAFSpUqAMzCUFpxSvmA2rtXYPlKyz/a3Njiz9623h2gsFh9TcKM+W01xBKikEDrXcvwxIzFeYxf2eW8AGMON2/euW5vG7YoE/OCsjUeRtxWOeMpQfRydGmyPHkXoz1Jl68Xl2wawdL7rzTCdIW86VukepPNePu1htFnnvF20tKAXcKcTJ6K3rvt9mPGssYp8NjPZff27gKmvBdJclafmQVAESPeuFduCr+8zb+0r3K93gnxbKHG2LhwLJTxqBHnFcGmwzx5VKb3Z9VqZYpaSUI87Okc874W9/b3QUIaeSqJ9a9i9ieNqdsHrRcd2SlwegI3rxfdJKSrc16Y7CMeBcw9WoAPtd2oH0HNdupSliZ83p5eVnjI9D4g0yD34UhAQoKG0GrxZ3Dd3l8PIVqUACTzVHeU7ctD8tSwpE9N6tGRn/AIrDVW6kjwEo0gwK+chNXsfYZEvZkaOJuuLR3PdA6OpEg+tWHKzqyytieBAI2FRmIWakIU8tQSU/MODWbKDlmLp1+5N082mAEsOpQQT6lKh+lXJvqseWnG0TbiQCtUAJEmCmslldJKfCpJKeIFSdw1l9whaWsSbC/wC7cNk+3yVgCsr2SFOKtMSMbKAfbOr/AGK3iktu5zTTl2F8S7ElfP2prlwtKgtBb5/eTWFGZcohKh8NielKtk982T/4aanM2VEqIRb4iqRwtbf8YquiXoLrUVRstXZInXHkY2NN7wuT3oCVDcHkmta4zVl23A12GIuDpoLZ/jWuM45VcUtS7TFmwBtCWyf41LxyuqE80EiWadWrcLEJ3IFYX2g8k98UqJ8xNRrOb8qKcPdu4mQrxQWG5H2VWQZtyigEOLxSDuB3Lcn/AGqflyXJHmQGfBptmyWHdSSf7MjrWRoMXLepLikxsRP86wf0vygtSG3n8TQkEmVW7aSB/r1qXuL5X1EWeJ4k22fESLNsg/8AxNqKm96G5w7ksG7RtKEId0ujfYfN9a22XEk7vA7c1VWcwZdVM4zfIIMHVh6Y/wDm1KpxLKbbfe/t29KFRuLADf6uUnjfKF5kL2PICHV3DZPxilGdvEOPOAa2WbFDrk3eIQjTsBpBn7GKlWcoutoP9dQtyASqVfyVWI5UvnVkJxRiSIgKVx/rV40dbg7SR3LVYq2Zh/ZGX3NDKMTb1K5St1IUT14b4ptxlvDysJsromAI/OEHffYNSa2G8q37QH9ftyD+94wR/tGtljLWIoCkpvmtfCSAvf66tq1WtwyXKJ8/G9usj0Zasln8wPrCFeItKUqfaGqnLXLGR7p5aVrzG4lIGnTbIKvXlonatC3yviqStxGIJLihEBSgJ69a2UYPjiSAb+duZWQP1rSGuwe4mUoy/rLI3kDstW2l1NzmtTgU3La8PQBpJ8Z/sh0iNqsCez7sNQtuH87vSgSlzDmEpT5Qe5Nc4dy5j13qnFWoUNlHVt9jWkctZhtnXGrbF2lyJgrUABH1pfjdNy6M24VTyOzouKZc7JLa5WjDbDHH7QNoDYeaDbve6vEDpZKdIHBiTWsvDuydSnmU2OOLbbahqZ1d7PGzAhMT68VQk5NzJcwp3G0qKDsEqJH3oHs/xZ0kLxFGpQgBKTR+K0zXb9TSOWK5kzol9bfh9tyj9jYRm15QcAcU73bcJ/e4tyZrUvGuwG5t+9bw3NSbpa92XVNpQhseTnw5JV/3QKpaezi5cR3X7SA0QVaU+L+FY/8Ak5Q3P/O0GZCyzKh/Cpjq9OndClLG+Jv5suuH4V2HXOKBp9nGm7FxgBJdcTqQ9P7yhbRpA/zZqvZpa7Ora5ZYyraLKG0qS6LtalJcVOxbKbcEiPMVpHs3UUlw44pIG4hiQfXmsn/JhbupDpxYlexjuBJ/XanLW6eXCSGvKTvrZHhmxbKlotLZAI+RvvQfv3ArXu7zBEkNpw0DeSmVK/i1+tSp7OiZAxZQ3jdkbD71mY7LG9JWnGVFSuQbdBHuZNStbgXdGyyQ9WQTVzgfxYP7LT4hKggrkeW/db0+6VZvJBbs3lBEyHNahH+rt9qsLfZ8xpSheJ924NiQwn+FPc7N2Qha3cTVwSD3Sd/0rCetxJ7Mcs2NLZs8/KzxmLMnaRh2HYndLctLF7umWEp+RAnbYT+ldULK9alptghKFAglLmqPaKoWWey7Gx2qouLtCmbU3Dqu9KNgmNiPeu1Ds8Q4UJGKuFQAkhkV26rPp49CwtVXb1OPw7NOGGTzXbk+fQqjq7fuplsFO8905P02pqFMrbSlNqVKXulSm1iD6+dW1OQWkwhWLOBIO+lhIn9KSsl2TRVOMrS3uQAwn9ZrlefEt5PY6nq4pFZQ026Ed/bJbWmdJCVgK9N62kttAhtN8lC0jxJQyRE/96ppnJ4f1FrFllURKmEkwOvFP/oSruilWNkKI3It0jb6Uo6rC3sylqYtWRTt5bsISlN0lSSd09wenX5qD2KIW0EWr6gTv+UwqFeXCulSKOz8OgqVjanJ3UoWw3qYtcj4JZf1hL153yACgrCCgkcygp3n3rSGXEn1NmU9TFcIqds4q9U3ZtXxU66dCAGVlQJ6gaxNW/LXZDm7G71xq4xlrDFNpC2/j7d5PeDzGlSiIAmTU+1d2baVKGGWSXlJB7xvDrdOk/Ruf1raYxVSLAWlgtlKU/2inLJglQIMgnu5/Wu7FqNHv1z2PPyazPLaEaJiz7Kcr5VtbpvN1pieaLpaZt7nBrm5Zt2T+8Co/N1+1SFrjmXspWGjB8v3TLStDjCLm+uHIWroZTG0DkxVDvMSxW4vUXrmJW6zbBIQ38Ax3YgyNSdMK+tV/EMKucUfLj+NOOKcPhShlKUASeEgQOa0/wBz0OFezycssGo1DvLL9/2Wxc7jtdy5aXzdnjuO2qla0vqS3cXCEoc9UgAGN+BG9Zcb7fOza4Q9aO2F9ehLuvvre8W0HlDhQMBWnnY+dc2OQ2FOEqxO41TBJSD9N6Yrs/t0tFtOJ3WjzUgTWb8fwT2izSOhxL8ys1sR7YcaNw8nC853NvaukpQ2tAXoaKidEkyeTvNVu5xVToAGZXylSioiVAfbvIq0N9mrK0BBxm7UlJ8IIB/nWVzs7s1PIKsZeWsbBPdD/GsZeJ4pbuR2Y/Kx8Kv0KWlbfdlw5ruQOTDOx9vzayEpd0uv5ufWJ2/K39j+ZvVxPZ3YaFKGJPAJImBP2FZG8hNLAt28UfOraQkCB9K53rsPNnTLNS2ZT3cew5oJZczbialgSdCQAR/740xV1g7zneNZgxIKIBSomI/+LVwV2d2mpfe4tcOKB+YRCacOzhDwEYvcd3EcSDQtfp33IhlSe7KiziWHtOEqx3EF6hBJ3PvPfb1n+Pw4h1xOM3/eQImdwB59/wDpVqa7N2WgVIxq6IOyYTAB67TTj2UpDvfnFLlRWIGobH9af4/Tye7LeWKKUHMMdh1OJX+lZ8TiAZJ9u+2oOHCe5SlGMXeozqLqimfKR3x3q+tZCatAEDErlUDaRAHtvFbKck2fd6nMUuSoyqQUgx9qHrMTWzKepxruzmDjjDwKHr+60lQI0Hbbr/bVl0NslwnHb3SsfOVFMbf/AI3eukLyZYvsIUnELtlMwnx8n3rXZyXh7a0FeI4iNRIlTnUdZo/HYuGzP8ZhT2e5RRc4clAcXi2IOFI1K3mfWS7NZziloi3QTjV6hO+2sKJ+7siri5kzCmDCcSu+8/dPeTtT3sq4S/oSby9BKo2UUg7fwqJa3HF8l/jca3ZQ7jEWnLZKji2IdyD/AHzH/wA2sSr61nUh+6I40qcO/wD8XaugqyRgpOgYnd+RHeEQPcU25yJhDrRaXcXS0NjUVd4SSPqa0euwRWzMZ6yN+yznBWEOfmYteyudLYI0gHgA97xWwoWqG0F7MDyUogGCSR6D86r0MrYKhg29u/dhtwFX9qeB5npWC4y5g9gtpTDt+62r5m0u7zGxBis34lpo+05ELXwhuVVq4w59KLhjH712CE/mpIB5/wDa1iW/bB1ak4lcrLIhQII+n9rV2XlGwulMrRe3fiAKgpUAJ+nWsycmWYWt5q4eVo2nUSAPXeKta3DK+lmkfEIZO5QVXWGrcS67iF4CrxJUUE/cB3mnLurFSe9OK3a1kHxaCnw9eHdqvCcr4W48oPOkGJTCin+BrUusv4Uy4bcLc1oAcCQsiR7zWEfEtO3TZMtdjrYpf7dwttCUJxO5I1TIcWI9pd3rPa4wxCg1fvoA3jvFCfeXauKsmWS4cOIlsyFwVq8J+hFbScrM6kL/AGitZXuCFqIB+9aS1+n7SHHW46bb/cpIxdkvFZurolXIU+T+ne1uOZgvQ0lDFy8pCxphJQI+he2qxDDWEuuNOqeT4in5iqUg8kEisTOD4SX7izfNwhCPGl0DYkfWub/c9O3yTHxPBW7fyKz37qmw07iGIpX8qVBxO468PQRSbdvUKCLXFbl2BMFSQB/8berG3guCYtaP3No/cBxiTKZTqI4getJ3CMGs7IX627tp3bUiSdRI96p+JYZbWP8A3TDHdXRW1v3zSwt3EH1Fckw+AQegjvags8WN1iWAras8TW6oaFdyX5SQFA8azvXSxh+H2pt8Su23FMLI1MrBlQjpvNdJy12h2/Z84nMeSsuYVZ3l038O1cBtbq2kqAB0pcWpO8dQa0xa/FCVqVULP4jp542kt2c/yX2Jdr+fMqt5wyll7E77Aw8m0VfJuEIHfEgafE4Cd1AbbV2DL3YX2O9nuchbdrHa/aXRw+0NxfYSq3fRrfKf+jd4lwnr8wPSqdm3tL7QsxYXhGVMRzC8vD8PU65bIaBZ7tThBUVRsrcbA8dKpy7Vq+udKsQu1rcKgp5xZ6bSd6cfFNF1dKbb9+xhj1sdR7OSTivRL+/8I6dhv4kMDyflTHcqdlWBDLisfxAXVxcIufiFpt0yEseMmQJO8g71xj8Q/ajmLtMw6/zFmvHnb7Evg0WqXO6baHdpVIENmNpO5FWa57PHbxpa15oUlKiFFIcUCfLmqznLs1bTlq+DONOXd2to9xblWyjXS9bG4qTSW3odOTJpYY35cN65rf5nF+xF1xeGYuyjFLi1CrltSu6SlUiDM6lAV2Ft+2bDbKsYWlPAUdIJPnsvY1UewTs4xOytMWVmC5usKWXkFluNnhpMn6V1RfZ7hF0PHmx8r+VZgCfTjatNfrMM8z6Zpr3NEeG51g08YzTsrfxti2A0cx3biD4ZUpHhPp461rhnC74Jtn8QcfaUQRqWE8dd11b0dn2X3mAFZjWvePE4QTHUithrs8wdKZRmhsKG2kKVqSPOK4VqIcp1+qO5a3FXtWc6dyvlsoS+m7cQSdklxJE++vap2wRhtuwhk4robRsUhSZHt4zvVra7P8FCCU5rUlJ3J74zA361jYyLgTykuW+ZHFxKlQ6oD04q5amFVKX1EtZgj+VMr797gxWlVviiEIT/AHyCR/tTTTimGtLMY8yoLB3AEDy5XVia7OLB5KynORTrVuC6qRWweyvA0oIczunxQkStRIP86zWWDd2vmjT/AHDElVMphx53vC0i+YuAmZ8SRM/9+tdeYbe3SojFWUySTDokenz1eh2aYO85p/ps4lxImUpI2rWX2U4Sod4MyqdK1fMpREeo22q3mxJXa+aM5a/HW1/IpZzM28wHEPIcUoQIuU+EekrrV/ajty8Fm/KFcqAuUk+86/ar0/2Y4bb+H+lCyobApWf8Kw/8luGqW2VZqfOreQsj6cVnHW4E/aaFHW436lJdu21LIaxBQn54uEmT6jvKchlp7dN44kr8RX3oQPadddJZ7OcvWiybnM4STulPeKBO3MgVhOScv3HiazY9pG+nvlFJg9BFXLUQfEkglrsK2plCtbpNopIt70kKITCn0kE9f3+azIvXWFqSu7/I5KC8mIM8eOru5kzCVIAYzQ4FchXeKIHSIikciWI0A5vcVE7a1QkfQUefDnq4Jlr8dFEXijSSUt4oNUQAp9MD1+fasS8xqaH5mJtED/2yN/prk1em+znDnlhbGZHndSiB+YoRHXcbin/8ndqXUruszOhCSU6dUb+hAqsepxd2iX4jjo5yvMbly5oDy3VABeoOI3H/ALysf7duO7dNviHdlJhQVdpAn37zeunu9mWCOISq3ze2CANagtRX/ACsC+zLDyA8M8CAdJSSZn7RWksuFd18xPW42rSZyZWN4vICb1hsp3/6UnxyeCddZXsRv1uIbexBt0ElWlNwkgHynXXUkdnFi0FC2ze44dW/du7T57isycg26VwvNDwP90LAJNKWrxR22M1qFLls5QzdrWsi5vVJGokd3cJJ6x+/HNNdur4L7wYwvqUgXCY6nfx115XZ5hyAHP6VXKUyP34n+dY19m+GtOD/AO625SVHYB2ealanHPd/uOWqjBUjlltcXKkI14i+0pRChDwhU+zgimKvGu9U29eKVE6oWnUU9f8ArK6+32d4XB73N9xpB8IW7Jn0MVhvOzDD0rC280FSSJIK5UfcxWv4jHza+Yo6mEebOUB9hqCm8SrbUlKnUnb1Pe1uWix3Y7m7QEpG7Tbw29f7WuiHs1sHEFaMxvhSRI8YH6RWNPZ/hxRH9KXUlWyiCBqrNavHzf7D/F4m97KEb20I0DGNClTE3Cdtuv5lN/aKUstrtsScWUGSU3QCfp+ZvXSEdlKFuttJzmpCZIlWyR6kx/KgezZWn4ZvNqwSeJEH9Kcs8fUr8XiOYv46lIA+NcTIkhL6DvPl3m1NGYA6kKVeBpI8JlxIkR595XR7js4dt16F5meAE+Kdh9aY52dhshr+lK3FLE6h8sUnnxJbsX43GnSOTYRiNxb/ABTC1pDXercCkvJIhR2211Jv46+EdypbTZWIb/NQNU+fjrpI7OQhsoTme4UqNlFE++01DY5l39iNtIXiN3cpIkLLUpj/AFtjUZdbDGurYUtXBRsoyLnEXXy5ZJUr8rxw4NQ0nyDh2rOm3xpQTdO3SnGyAtBUZCZ5EaqtDDV6+8pTrq20saVNGQUJH7xIJJmoNx69dvXCh67eduJK3k+FKUHyge1cK8VcptJKjhnrZqSpbGBq5xJain9qOtrKd0pV8sdJKxPsKeLi+UrSMTeccTvIWkBPpIdmtN/ELld2y0+4468yPCAjV59dvrtW/gyLhtDt29dv2zrngU02ClKxE6j7V1LxHpXt8FLXqT9pbGlcX925JXem5PIIuNyR0jvaRu8w3DBuVO3TaUQ22kPnVPWPzasD7C7sCyZQ6VK0lCndvciDzWri+FYmwttxoaihBUlaxO3kQOTSn4qor2PqOWfbqiiGGI4raoceS8+gFXzKfSlST5GXea0mcTx10Or78KUVE7XYn/5tT6WVrc73Eu9tQSkFwtgifMA1msbextrpTD1zcXLYUQkiNhO3MinDxeMYuUkZrPHlkKxiGMhpBc75e3zIuQAkeo72sKcecZBWzjD2nmBcRv7h3erdcWt82ou2iHENuo8SFO6Y9SKj8MfNu5LYWl9a1IWgJmERsQY4qX4zCrir/Ub1CjvTK2zi7lzrQrEHFOtBK1gKOoDoZ73imWeI4yhp1TOJXCdLmtwlzwKA/wA4O7fUVdcLwy6dZdeXLHdhWyxuriDvz7VC4vZpGKIxCyuVeEDUlSQAsR4gRERU4/GouXSlX+e4xlnm4db+RHDF8yNt61OXS0qhY/OSgeYI/N3rHdY1mppJUV3SVKBWWlv8/wCdPeyRVqy1hCry5dfcVqWsS2CNUjjbaP4VqYhcOIddZaw1ENO+JWklYjgEepmkvHW8jxwgtvec/wCMyc9JWGMw5jdcLgedIbjUlL+4/wDizVQ7S8czhevWzCb+/TYNgLUg3ynG5kSSJgH/AArpNpcXzdsE2+H3DTi9cqcgpTB8iJio1zAF5mfUvFsMbUN+7cIgbRwkc10Y/F1HIp5IrpX6mE9ZkzxcY2n8j3T/AJNbFsJw69zNd49mBj9qYkm1s7BFw8pK3WxqUrQQpRG+mvbOI50yS/a4gvEre2dVhfdm6bcCFOIK1aQNK0yRvzXxZwPHseyljgucGzFfWeIsFHdoZOnTvJBgz05E1f8AEfxH9tN9iaboZ8vrrEEeBTqoKg1OrQdUyAQD71rHxTBJLrjb+BclDI+pumfVbGshdl19Z41dO9n2COGwslvi4VYWxCiEqkApEggivjvibuYn8SuTZPhAC1KUtLqtKQSSOF710S+/FZ22Zjtn8LXne/shfuJTdrQIW4kIKDJHQiZFcZxnMGYrbEEXAskFC3QlKm29AgmNQisc+sxTklpFT73sdmk1WPTY5xlvdfQsWH/0gdKVPXnxA30jvHP4FzatlprMLCFKeuUrKieH1mPfx1ibaGJrCrTEXu7OtBbcbKiFxuY5/Wsr5t8Ps0OXSXe9Zjw6QAsex9q8/wD3dqXTLn3Hbi8QwctM17l7H3Ww2sBQG6ZWsz6fPPStixcxVaApTTMp30reWkq9B4jtWC6vrYWaH2GH1FwRrcQkfQCOPWtJOJotXFIe7uEjVDKQkzHGoTVLxKUm0lsaw8Uw9VVsbvxd808lTtg0kSSoayAn28XWtVWOJS6UfCNBQOykmdP11VIWhXdMsv32GvtoeB0aCmFeR3FYbmxw+3CX7txy0t9fjKWkKUDxvCauPi2Pq6Gisnien9GaZfxDE0uLNuhSUSrQpShI+iq1WrR1BKhYolIlOhxwz1g71aGcqYPdpJtseslBEqKl24Co94rPa5KYvdLmEY1YPKQdCwGwpQn0Art/FxSNI6nBONp0VlhN220U/sZmAd0qUsah5/8ABplxb3jiS4nCULIACe6K9ufSro32UXS20m4urc7yCizBTHptFY3uyy6T4bfEsOQiZlVmCf8ACqjqYy4Zf4rD6lFcdxi3CgzgjYIMBSu8THqYTQadxc6jd4O26qAUhttfX101c/8AktxkoKF4vh265B+FAOn7bUm+yy8SSo43YqUoci3T0PtWi1EFzyJanHN8lQU3dwpw4EEp4gqc522ILYrFD+tBRgjiIkStbigD6Q3V+b7MMRCkLXitnJGylWwn9KcnspuZLjl7YqVJI/qgE0vxCeyB6nC9myjrs7lwl13CkLKjAJW7Kj7FmayN2eIWoUsYP3SSCIUlwSDz/wBVVxd7K795On4iyAUZ/wCj7x6UUdleKNtw5iVmQIASGP4+dDzJK73GtTgRTn8MW42l1WH2Yjedaid/P8ml+zbdDBCcMZSZlQ7ufruzVtHZRiSytbl5aKC9/CzHt0oHslxJ138u6swAn5ShQA49N6SnJu0V+M0yfP0KmnBHUoU43ZMkJHypbM/QdzRGEjuvDhOkg7ju9W/n/YVeGOyjFEpWlGJWrW3hSGFL/XaPtSb7MsdYWFfFtDadKXCEz7FJrSE5cyQficD3jKiktYYe6Rpw5CHUqOzlqRp+vc8U+4bv2UjVh9rI2UAwpQA9fydxVyf7OsadSorubVCtUgpdOw/1awK7L8YI7xl611xB1LVM1l1Sb42N4Z9Ol7UymqW8pBKU2oUkwWy0QB5cs0xNnc96H/hsPCCII0E6j/7qKuKuyrHHVAvPsSf89Zj2p47Hsc0HRfW6No3WoH1rTrUVSRL1GC/zFHurJpLgKG7FtKTz3ABPnP5dJm2tGipx5qyWVyEkNgpA9tFXZnshzC1rLlwxJkgd+qJ8zSY7JMyghQvLdfTSHV/xpKXoilqNPe8kU5LOHrSlthjDkqMEJ7hI399Ip7WFgqK+8w5CgdpSP8NquCOynMxUAbu2SEqPhLyj+s1ke7JswLZUDdWildAXln+dJym3waLUaVqupFVXaOOIKlPWkJATr7pED2JrVKA2C0k2bpO41Ntkn6zVqHZJmklTS7lsgQQnvlEA+niFNPZfm1JDalW+hOySX1D/AM1JTcEJ5tM1+ZFJThjqtTzjraVKkElpsQenBrKlphhttKru2cKAdWzZ1T9ZFXF7swzg7KEutLjr3pO3vqrA72UZ51pWl9hIH74eMp/2qpZZS3/sZ+Zpo/1FUIshbq7xLCSVQSUNjf18dYWHrVu5KytLoTsPC2PpGqauTnZfm7TK3rcxsZePi9YnatQ9lWd1vFZuLTuz/wC1JJjrzzSc047BLU4f+xWMQdwcNqStLSAqJBI/+uRQR+yu7DgOoASFgpA+xck1bf8AkrzutYSHbXUP3lOqj/xVl/5NM9yEuNsPqT4YD6oj0lVUm5KmS82G/wAxUXHkaBqYLg4TChH27ymW9/aFwoIShRMbrEk+v5kVcv8Ak67QVL1BDaQNoD5gj71hf7P87pcOnDWlp4H56Qfed6V77Gi1WKO3Uitu4ihhnSHyHT1VsI9Pza0cVxtC8NW4jENRYCVwJkkKHk4Yq5HIGfgmUsJSJ4U+DA60Ljs1zld2z1s62C26gpI74TBpPd+0yvxWF/1IikY8koQ6L3QAJ3UdRn173itxWY3HmFJbunFDT8uuf/OTTmuzzPNu0i1RYqWhKdJJdEkfWsg7PM7wmMMuVNjhIuANuvSqlaVEfjsHDkjVZxgEpbddCXE9Tq/kqs7WJWqUKBdKiRtoJj2Mqp1v2c5nbaLRwZ0L4Kl3MnfncipBOQMdbCEqwAKQR4ki4+b6xXG8cuDtxa3B/wBkRaLsFxJQWiU7iSdQH+vvXrj/ACemUrnGe0HGs7dyl61wiyTaIUoLJS+6ZOk+MfKk7bc815bbyZizB1JwcoSo7JbuDIHp4K97fgqVlLInZStvGs42GGYvjGIO3b1vcOJLiEpGhsEkp6JJj1rbTYZue6PL8b1ePNp/Lwu23232/Q8Bfiw7W8RylmPMOQrbLmB3FvcYq6/8S/ahVwg94rZKttI9Iql5vK3shrfRsl23QtQCvOOk1j/HIyWe1zFVJVraduXHW3BBS4grUQoROxmrTa5POZslW1hcWN5bqctGwHkJKgrwjgRS1mDHpsOHMo79W/rse3p9SpeJ5cXUlHojXC3a955Huo7xUHrWrB8q9DO/huZuCpxteNHqAWBvTXfwu6iFMXmKEKA8PwwkH1r3o+O6JLl//iz4jU/6c1zm2ul//wDcfueeoNIAngV6KtvwpqWhK38VxKZIUkWoSUxwNzWtd/hlbw9pV3eYpfpZSYgtIk/Wm/8AUPh8eZ/R/Y4M/gmr00HkmlS//tH7nn7SfKlBru1p2FYA40cRZxm4Nug92pLjaQZj19a0nuw7AWrZD/8ASW5K3VSGwwmAnznVvSX+odA3XU/kzyopydHFoNHSfKu3tfh8w5y1+N/pO4GQfmUylI++qtVfYhgrq0i3zM4lWrxoDQVA8xvTX+ofD26U/o/sdOTSTxtKTW/vT/ucZg0oNdrb/DwytKiM1SQJ09wJ/wDFTE/h/tlKWkZr0GAUhVtP8FUl/qLw1/8A8n0f2KnocuOuqt/evucXg+VdV7Bhitjjy8ZsX+5aZQUOLS5pVv02qUT+HS4cgIzXbEq3SPhjv/tVb+z/ALOn8mG9t3sSbvA4QVFpsgIjz3rk1/j+jnp5R0+T2vg0ev4L4f0a7HLUV03vui+t5yxdLiicTdRqEnS4fvXGe3fFr7Fb60fvL03C229KFlUkCeK67bZddv0h1orAVJEN+EAdZqp547MX8zraV+0be2aaCt3Aoz7RXzvh3i0cWpi9RN177Z+h+O5vDsehnHE49UltVHnB/vXUEnpvXYuw91aLW3uTe2rSbd/dK3SFET5eVN/5CnHAEJzHYtg7mW1lUecTUplbstOX3lqazPbOpUZCe7UhSf419f8A774fJV5n0f2PylYpTkpR/dHsHDsKtLmwauUY5hgSUggi623+m1S+Vr+8y4+5b2OLtaH16ym2fCxt51xDI+Z0WuEowK5u0P8Aw+wfQn50z/KrPY4/ZYViDDy7kjviUpQOv+FeBPxDTLI+mSo+q00llwdbfG3bk7RiOaMc0lTd+2sneFspJj7VVsWzJdX7abG9xE2yHFpJW02lJSmdyNIBNVnF+1LLLLzVs7cqS58qkgDc/eoHEc9YE3fsobu++7zchEFSB61vPX6fotTRC1GKq6lf6E7iXYR2sY7cXOP5e/Ec/YYQpQUyHcGu/A2RtqMkRPkTVhyXkbM2U7E22d+17C8cW8vSw8jC7tCyOu6hpNc6ex3KdriHe312oqcGgJWTIB6xMVVLk3iiq1ue0YXTCHVLtUXGGpUGZMgAhX/EV149fo3BdWZ/KP2s8vM35jk8vD9T0Tg2C4Re4tcMY5i7Tdkw0tffsvNgrUDsmCSUkjzFdZwLL/4U7e2ZdxnN+LXzjqQooW6EaT1T+WB968Tu3ObXAEN57sLnYeBWFgGeBJCvWt3BbzGbC+atsbzFaOtE7soYKFHyjyrSXiGglt1/X+DV43mfV1/LY9u4kv8ACcparBKLtLEeBxi4fDifYKBBrjefbbsvw67bX2f43il5buBZdTeJT3jR6AFPzCubO43gqUNNrvX9Khp8TZE1icxHLTzwabvVF0uJSlJEAn3IqfxumapP6npY/C8uNdShJ38SbAtrgrS28oeEaZEEmsfdKt1lbiFFJTynefeoj9r4FY3IbcfUhKOg339xW0c14Nq1MXBUg8neR6EVL1mF7ua+ZMfDdU+IP5MyPoubyGPglLQVEhZO8eRrTubFbS9lPLSnZSEKIEdN5rbtM3YMl7QbpTbRJCVTM/Ste+zJgnxPhuO8KpKRulO1T+NwJfnXzFPwzVpW8b+TMjd5bqQhAs3UaTphStQ+lZELAU4C2tYA21iD9PKo79pYa82SFttluVSSon6RWNeJ4MgtuXd+StQmNXPlzvVfi8DVuS+Zn/t2qr/xv5Mr37LtmLcOraSltSiEpST0rEqyadJXpaQlPCk7H2qWDrd7bF8aFNIIBMwB60xl6yQ4sOQoDyiK/JXKXqStNFOiOlpKUtIIIPVI4NNlagoa/CmdvOtpTtitCkNISEo3UJ3FY7tdk8tAslttkDeTJpKUo7WWtMojkvttMq0DYRJmd+tZLx62Sw0XSprUOY2rXurlhNu0tLKCSOm2r1rEO4cCVDUegBk/Wqjkmu5EoJPYzNXTRbUhCIAG37tNbctLVzXcu6iREJJ4p60WndALVpM+Ek/xrQdVblxbCHUlA4PmYoWWcuWxt9PYkWL1svJBWCyNyCd63Hb6wdUlxgFKCYO/iqFbcs0tFKnELOwJkSDWBd2xbEuKegngHaPpVdeR7WxKd9idLzLKXiHisiIg7xTrU4fctrcWCFpO25qpoeW8uS8UpUTB4raw69grS+8VCPCERJ9TWs5ZlHkqOVJ00WNS7Z6FB4qhXiAMTTU4hhjTqVLSoQvaTzUG0pam+9aUA2D0MnfanLbLSCp5TZSDAk7/AFrHrycdRt1bWkWC4xOwKiEhBCidgP40f2lYpASw6mSPFtxVYKWQ8PzQrUOm0VlZvW1AsobA6aiKT8ytmyJZ2ndFjTitmxqW2lLylGNQEgU9WLNvtJRIaVulQjiqokp7/ufitASBsE7T9KMtvXCQbhSSNgRt+lHt/wDZh+KfoT7r6ECAhslJA1xztTrfGmw2lAdgAc8VC933luUd+QQd/pTG7mxbtV94vUQOQJAqoTmvysp6h1ckWdeN2C4QpKVECZSZFFm8w11IW+logHWQsb+0VUrQ21yslt0QPmPka2khh+4LRcISkDSTzSnKb9ltkvI5VsWVrHMPQHUMNx4T4i2EwPQ1gt7i0cdSu5dKkkSEJG5qEW6hYKWhInRpV+tPYaDegOPBKiqAJqFknGPSmbwbrct/eYdbNgoTKFJ+UHea1v6m63qU4lU+DmCKr6XB3bi9e7ZCSdW3p9aa3fakIt+/QFJBJVG4J9OtJZcyX5hdTvgnXrq2tg2w22spndU81qqxBlEkKUViZAFRL1/qTBeKlJIlINFm7t31qBuwNW0JQZq1lypckSTW5KKuLdxhaYC0qGoEnk1kw++ttQU6hIIESgQBFQKnrcksknUSAVBWwTWBd1a2jv8AVrgrCRqk+/lQp5ZLk51lmtkizuYlZPXBWhoBtB3I4JHO1Yr3FrAuo0sr0pEnVwU+VQjOJ2LidD5gubSExz1rYdu7NxIbCN0CFLnkVDlkT3NY5HImlYlhaLZLqGPGpMBECK1bW7ZK0Pd0lQH7sCR5mo5goelPeoQlPiTPP2rPcKw1tbaluqHBUQIEUSy5HsmxO27olUXVs06HFQW/IpkA+dMZvbRbymrUczvWqu9wxxRW2SluIIUriPSmuLwwLDjRaAMSqdopSyz9Wav0okcO+GSVIdSCFglRUQN6a/cs26gAUdyJkBUxUZc27TqltNuJQFAQQZkec0U2toGngu4a3SAJVyRU+bJv8zMqbRKM4tarbTrUEiY8In61sLxm0cP5iUkM7AmOPaq25aWawWmrpJKgCQCBH1rIm0FqEsrWkuHcgH7b1XmSW9k+3FXJEy7ilo8UpaBDahIJGwrB8S025+S+UIWYOpIM1DXACHylpzUpBidW2rqKxNkd6px5xKRHhAPWtFmyNckV1uyyNPYUrU0q6UCJJgdentWC41vLQWnSptHB6TUbbWrRcK1woKAUo6p2/wDWtju0B0KaU3BV3agDt9RUPUTT5YPGr2NhLqG20B5xHgBKo3Kj0HrWH4pt8lC2CnUAZJFK9sm0OONjSvSdSdKq1lsOlCFo8cmCnr6UefKb5B43MchdspWh1ZI1Ec9K2Em2BWpLiigR/wCprB8ElaEtPLaLmkqhI3B6Cayt2TYZbIKQonxDV08qUss/Up6d8sy3aGgvvkAgNjZA3BrCgsoh51kpJIUDEbVk+EQh1xkBRlUbK2IrIbcakIclaJII6gVDzdXLBaehpxNhxTaGbcCeSCBtRTchCkMFtPzErMDfyBitpFsw0wW0spKgQFHjbpFY/hLRS1vdwols9FHcxS8+UdkwjpK3NVdyyl1Q+HbMHSJHAp3xtqFhfdIUZ0kRO3oabeGw7ru0qJdO6zWMMW7LAcNvusyneJ9QKrzJSXIpaSXZGVd3YlCpaBC5KpE7+VIXNq0mENFI/d09PeghlkN/ElGkcpJOxIrA0VNJVCUlCyBMzBPQU1KVXYfgpegLhduGwkKSr1I3msLoZeah5QICSdJTJms5KNmg0hXj0jUmSD0PrWNpC0vEKUkFSoKiP5UuprdkPQyNCVd0pFmz3fe7mEQBBreCCtou3IC0AhOiOtbulTawXSkQkgA8Gkyod4C+lHdvQEoncn+VW8s+wvwjiYilp4FLjICSBpmDEUH+5W2wli3SEpPRAG9aylPPLBagJQQAAmTp4E71uIWVnunQpsoITqI2jrvR5mRb2aR0jdbG8y2y4044tlZXOo7CAPKK0kNN63HnWEmUaUIRBPv71soZST3jVwSqNJSJ3AEg1t2uFJUhClFC1jdYA6Vk8sk7sv8ADPsjTC9B0NsK22CufpWM926pBW1tBnzn2qUXh76X1JQkJSnVBG4rSXbsquEIfuEICY1DyJqXmySdWXLTzMSVW7bK1Lb06Bpk7UkvW7SFKSzrWRqnkkVu/s9u4QVqbCitR8O/I5/lWa4wk2aBbKhHepCdQ9RxNVDK0uSHppyW5As3R+KUsoSJ3A1celbClNoBW80UpUd1RBrdODpZd1juwVABGrafQVuXTCbhtIbCEpbKUSs7AdT96l523ViennwQJdtUq1KZJ1bHYb+tbFvcMtPflIShO8gCJrO3hzjnfNLdS4oeLWkQDFYWsKc1tvKBCFKgcn+FHmO+TJ4pwdManErMvOqQ0kOFMhZEiR5Vktyy638QpSdhr2HBprGGB51L6y2hoAwlPvWG5bWpRTbqAUkSAP51TyN7JlOEySaubJpMlCS6ARrjeaYrEEJSkqabKEpJUFJ5+tRS7a4MNaior67bH6VkFjc2rJHxHiTwqdqUJzg9pFqE5G65cg6XiwS2rbYTFNS+6tYSi2T3YEAxEz1rV7i9unQtbqFJSBqSlRAUT1jpS03uuGLkBsKA3MRHWqbklyHluPJtv9+GlBbIAAITtJrDbWjiwl5Fugp67QABTrq+LLigl7vFhAK9J6+VabGI3eosr1BHMKIBM/4VCeSrbE9O5KzfXh5aAcDIjdRUeTWH4UNaghsysatIHM808XouHg0oLKyDCguAD/KtQrfYWHSqXVmCCRt9atSl07syen6XuzOzbL/s0HuwkFWkyKcH3loAcbSsgnkcisSlqHg+JHeHcg7xWFq4aStCm+8WnbxjYAzQpT4bB44p0SLlqsIbdaCUhYmDtWshtkkJWQ5E76DBNa7l9iKrglSVbCUJKOB5+1Fu5vWz3nfJQFiVTAH2p9Ulu2aLGq5JBdsw0FPMJ0KbMaI3JrYJYeZD7qAHW/nII2HnUcm+F1a61HxyQd4BrVuXDaJCy2olY37tX8aXVOWyZu8Ke6ZKO31pKmlJWqQFJAGxrW+J1ISlDBJChJP8KxW7Dj7ClbjSkFIIgwOprat1NtqK316UhIWnT1im8047WYz07fcwOuNNlYUhXhVMjn2p/wC0Eto7xKdKuVSI2pqrqyeu9K1x4S5EQJpl6i0aSHA4lQUdgD0rTzJveyVp3e7MhvUqOtlegEcDetXvG3HdLjST1JnYVmZS2BoAQSrZB4MUvh/zCwgIGowpRUJ2rHzZt1ZDwe8zLuQ0lKkuDkcJpIu7mSlKiQZjYSPKmqdh7uQoLb08JAJ+lajrgbA0akFMyo7Vfn5OLHDBH1N5K7h1lLdwQUJgHrqVWN4iVtuM6UApKkj+8f5Vh/aSnLYoSlJSiJVxFaqrs+NYd1FRmZmPpWizZGqbHDFHmzfe79aVu6GoTCRrRJH1przSL637hhoEoISQIAHrWkH3XEa3YWEJkED+Ip1rfi1V3rJCCUxATPPQ+lDy5GqbBxRkawJjvpbKCVJKV+W9ZmMpsWtmCh1oNoGkJEcVgRjAbWW2AYAI1AQdvesreJXSVEhBiR4VmJ26VCyZUqsqPTFGs7le0al5LKVOTJWkAQDW63hKC18Cu3QEujWVHg+9MYunlBsqJbn5wT08hQcvrhTv5Q3IMFR2T7Cp8zJL80ikoyZlRluzQ2Q400pST4QkfKfOsdzhoWw3bBshaf3hyB/hWK3Wp24CH7sNo52MD29a23bkpBU2vUrVAA5SPWqeaUdrHGCXDGsYCzfgC9ZaUz01Dkj0rG7lm3Citu0ZCSqeI3rY7x9MSHPHxG+n1FNWcRabDaNUTsVRAHnWbzS4ixTxwSs1BhjTDhQzbolJAmPv9K137C1N0VLskIcSJSoJ3qT1KBCkvJUTAAJiTFa13dgOFvwp8xM7+VTDLNsw8q9xjxZW0hJb8YHiB3K6xOYXh7qQtdig6wBrInT6UxLjp/MS2FK4T/wazReLILKW0lJBKZ3n+dbedOKq6JUNx9vZN2j4V8O2SRIbSDx7CtkYfhz7qnzatNOk6ir/ADvUedYylVvbQ83LsnfVEisHxwRAcKUJTHg6E+9Qs0nwHlqzOnDMLuntD7aFnffb+FbTOVMIW2644EAdQFDwgjpWkblhta3GYWqExHTetV64uFBxlu1UQ4JSf87yrXHlfp9SvIt2jeOV8t2xDtsy1KdisgFYA2596xf0Wyyi7VfJt2+8Uk+KSJP0rEnv1W+u6aIcQPpWWxubhesJtpS3GlU7fWnLUTbck/qJ4E2Zk4NgNs0hXwraid5A326TWu/gGBXDri12wCQgBCFK+u1byH2nihLraDoV44PWs17eOIJNow25IgSIFY/iJJ7Pct6W+CLtcNwyzWAyyoBcrUZJINZE4bhDbigqxDiSkkBW5BPWnoxO4unNKbNACPmI6K9qyP4i426XFoQlY0gq9KiWTK5bsz8hw2SGrwfBnWG7dNpo7wwmAOvU1hbyvl2wcS43YoW4gKkpgffat9q9UUNJdYMQFAxz6in3l6yl5BWxrSQSSDE/Wp8/Kn0xbRS08jVXbWHdoloKCwUrBGyQeg+lMVhGC3qTaP4eksJBIDZiawP4swi6AbbKkEbg8H2pDFkrDiU2akmYTp4A6/Wri8qSaE8Nckh3GFsBtlqy7xk7IgcU60s7PvD3GHhlRUPFMSfWKhzjSEOoSUkI6eGIre/b6SnvGkfvQNp+taLJmitxvE4rcu+Bdo2a8opTaYFi9xboMp0oXsJ/hUXdZhfvr5dxfQt7qSkTJ5mqx+00OhQ16XAuUyIMUjjCVqCglJcSqJPyn1q3rdW10OTpdrBKPFE25cK1nUorKFaikJ2VWxiWYrjEWLe3XaWySyCE6WEIJ+qQJ+tVpeYHWnRrBI0yFJ339q2EY54/Gy6XFLiC2OPOmtZq4JuwSle0SSaun2ykuqWCmTATMVjTiF0twpJOhY8Mjf8AWtZeJOP6hr8SQNZAj+FZEvjSQ2kkFMBQMke9ZLxDUx3bBRl6GynE7024IKSoQCkJEitVN9frLikuyk+YkA9dqwLcWpwM6gkq+Up3mKeRMgNFMjQQJGomqfiOobTcmFSXY3WMxXwaUC5b+EiCn96s6cfeOtK9KdMHaN5qKSltp2XLUk6dKUg/rWw5ZNuoKy2dSR4p2k1v/vOpgl7bG8TfY3f6RrcUlsFGkEgniKH7acc2UUJAPOogkVg+DtkNQWUKKVbHXzPtTFYey8Spvw87lXhB8jVR8f1T26iHjl2RvOYtbOlLTakhfU71hcxa6tngO7C2QYBk7Vqqw1psJUyuVk6ZkdKAZYBUm4eXqHJSdhWkvHNRLllwxvmjdaxR1934gtKQhIIkq2NFOIJWVbhCU+KSonbrWmVstyjUsiNuo/Wsbq3XCpDQbDZEAcD61K8c1Ke8tjbyHJcG5+2UpWUtW6dxt/jRexq5SU6W2U79Qa1VF1hCV/CkKIhIgHw+dMW60+lLy2lIEQsz5e9EvHNW91Iz/DpbtG6jGbjvSEIaMblQmJp1pizqV9zcNSpxOygrY1qv3TS0JbtmNKiQPl2NMUm5uUrbU2jQ2ImZitP991cd+oFhTfBKN4opVybd1ZCUTzyKc9fNLlKr1KN+UNyarqWbhrUtVu2pAE6io0341sgarZ4T80DY0/8AfNW1SYliadIsDS2Z71WMu6Y8QDYEb871ms71ClOf119cnwEJSSB5xxUPbOoaSkFhRUTsJn3BrdFzaoWS1ZnYagTO5rmXjOq6t5HStOpq+5nevHgVq+IUUJTAJSCdVaab7EklIUqe8JMkdKzDE2S6WDbgkQqI4pKetj+YhGgQTAM/WauXi2p7TMvwSf5jScvMUW2psOQonwzM/WtphzEggLWhKiBuY5NYV4rbrWSGyCBKldfet1jGme5ISQCgAzHzGkvFNUnvN0XHRQrc17J7Enbgl54DTOlITzPmazvIvgpIUQoyNUD5fvWN/ErItIWslKQdWpIIk+la6sYaduWyjvIUZgiiHimpi9pOio6NLuSKrhkNfDXVo6VkxqSqK1+9tw73PeupSUnYK3NaS8YZdcUmF+ckdaZ+0Wi/41n5oIjgVb8W1d7yFLTQrklVvJDUturSrgHVM00XqwUJXdK3G41RWghxLtwFtrCyVEwd9vMVmunbVwtOqSrZRBEQZrZeM6pf1HOtMm9jcDzyED+sKcn90cD3piboBxRStSpMEBeyfao34plFwvUveJkGmWbja3SlbrjbYMqkc+1U/GtU+5pLSp7WTbtysNAoW5MA+hFBvFH2mgvvikgGUHrUbb4jal0pLSyNkhXQCst3fW+pXdM6iDETSh47qYu1Ia0y4s5l2tdlTfahibOJLxRVq80lLZGiZQDMeldJwdS8PwhizVdSbdlLW4G4SIrXVdanZDIQIjyrIi8w5lAQ+kKKjzvWn/yDV5EoSnaROTSRc/M70bgxK5BMvbEAj2rM3c3RASl4pQTqCqhXMRtnHSlpk6ukfKE09nESlelKFQQSCnf9KheM6iOzZn+HV8kwLy6UHGyXAtaCEkGFA+dQGK4Til7hhsXHyfFIcB6nrWdm9U6e+U4o+LYqSQY60968cUSAYSflEHc1w59blyy6nLcnJo4z4ZBs5CxGxt28NtL6WkDUsOoSslfIMmtRvs+xbuE27vw2gTpWlAQrfkiN6tjGIOrKGlKXJIEkbCPKszzxccGm6VoiN9jNZfjc0d+r6I414NhlLc55fdmNwLP4Fq47uSIVqUqQD13iZ9KKey5eiPjFBQKe8dTqKiByOeK6GFtdwGFOHVPzKM05CzrDivGAIO3P0q34pqUqUzSfgeJsojeQbWydcu03Dz6TwmSCkeZjmtZeS7kuvOi5fKpCm1IbI0p8tzvXQ1sW6UB10lCnJUNM/wCFNVbu3CULZIE6gFTzFQvEtQnbdjXhC5OeW2RLqxuUOXD9y6gjdCjGr0JFZzlDFE3L1zZvtWrbyO7DaW1AD9TJq5f84JKSTEHSZpG0v1qIW44lA3BSY3rRa/NPe/oJeEuSpEDaYJmNnDhYN4m54YSlYMb/AGrVdypiP7PFqH1d8VFOpZ1BQn/easyrd5KUISFpUPEVHk+tYHFXRUApyUp2KhtUfjc1239CZ+EyS5Kk92cO3LyEd6Ww1upQT4lH3FYFZCxFq6CxdygjxeHdXkKuxfxBSSEK8JETMT9a104pfhZQtKUgDz1fxrda/Mo/m/Y514V7ir2GScSZv0PXFwkpb8WhKIk+9bWM4DiN46hTGJllAXulKSoVZGsRuUBOwVI6+dF29ultBS2jp1GCnYGsZa3O5KV3+gLw1400u5Sf6CXjuKIxJy4bcbCt0FsyKyjJLTmJJW64pDKCfy0oIJJ9atv7Qu7dKQULCOonzrIrEFOLQtaVA6YJiateIam/aZC8LV8FAc7Mry8xP4r9op7krHdhSSVBPkZ5rYsuzG7axB03OJKft1KKm0AaSN/4VeE3AuLjSCrSOSNoP0rKhy4S4iUBJEjdMTVS8U1Ul0qX0RU/ClfVW5X2MttWL0svKWD4tCkjaKib/Ii7rEE4iMYcQG1ha0wSfoelXBbzrawFoiCd5PFO78vOflgK1evNc8NbqMcuqL3K/wBuuPS1sSlleMNWLZcR32kASpMqFaeJYg73P9UaaKiSSjQI/WmMJuHJtWQEqT8287VjfuEtbLSFTCSNPltXZPxfUZYdLO3ys6j02W/Kt3kK6wfTmbBL1nEUkBJYUC2oddiOamFX/ZS0hKE4NizJgDUFNq9yUwNvrXNre9UpwodWoAfKCftWYvqQYukBKYJAH731rSPjWpjFKk18CYY9RjVdb+bOlEdjj6VBsYglZgIWphP+0knn2NVrGbzKNjchOD5eN22nwy6NCjPMQTFVJh60V3iYIUTuD+8PMU/9oWmgIZUErTsAa3/3vNVKMU/gWsmrj/W/qWxGJZNdQ2/c4I/bKWfGlHjKB9qpT2YFKv7hNvl6W2lkNOlElQ6Hitt66UYJWUH90g7H6UxpQ1LWp48clO01jk8Wz5OUl8FQeZq3H87X6s//2Q==";

/***/ }),
/* 324 */
/***/ (function(module, exports) {

	"use strict";Object.defineProperty(exports,"__esModule",{value:true});var bcsShopImage=exports.bcsShopImage="data:image/jpeg;base64,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";

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getMarketingBox = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var getMarketingBox = exports.getMarketingBox = function getMarketingBox() {
	  return _react2.default.createElement("div", null, _react2.default.createElement("div", {
	    style: {
	      fontSize: "medium",
	      fontWeight: "bold",
	      margin: "5px",
	      textAlign: "left"
	    }
	  }, _react2.default.createElement("div", {
	    style: {
	      marginTop: "5px",
	      padding: "10px",
	      textAlign: "center"
	    }
	  }, "We are continously improving to serve you better!")));
	};

/***/ }),
/* 326 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var hcommImage = exports.hcommImage = "data:image/jpeg;base64,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";

/***/ }),
/* 327 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var logoB64Text = exports.logoB64Text = "data:image/png;base64,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";

/***/ }),
/* 328 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var mrpPmtImage = exports.mrpPmtImage = "data:image/jpeg;base64,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";

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var ogTableDef = {
	  users: {
	    roleName: {
	      caption: "ROLE NAME",
	      inputValidator: "",
	      type: "search",
	      enabled: true,
	      selectorSource: {
	        type: "static",
	        table: "",
	        tableField: "value",
	        staticSource: [{ value: "SALES" }, { value: "ENGINEER" }, { value: "CONTRIBUTOR" }, { value: "QS" }, { value: "ADMIN" }, { value: "SUPERADMIN" }]
	      }
	    },
	    userName: {
	      caption: "NAME",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    },
	    userEmail: {
	      caption: "EMAIL (LOGIN ID)",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    },
	    userEmployeeId: {
	      caption: "EMPLOYEE ID",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    },
	
	    userDesignation: {
	      caption: "DESIGNATION",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    },
	    userNotes: {
	      caption: "NOTES",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "textarea",
	      enabled: true
	    }
	  },
	  contacts: {
	    contactCompany: {
	      caption: "COMPANY NAME",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    },
	    contactTrade: {
	      caption: "TRADE (CATEGORY)",
	      inputValidator: "",
	      type: "input",
	      enabled: true,
	      selectorSource: {}
	    },
	    contactName: {
	      caption: "NAME",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    },
	
	    contactEmail: {
	      caption: "EMAIL",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    },
	    contactPhone: {
	      caption: "PHONE",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    },
	    contactMailingAddress: {
	      caption: "MAILING ADDRESS",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "textarea",
	      enabled: true
	    },
	    contactNotes: {
	      caption: "NOTES",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "textarea",
	      enabled: true
	    }
	  },
	  suppliers: {
	    supplierCompany: {
	      caption: "COMPANY NAME",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    },
	    supplierTrade: {
	      caption: "TRADE (CATEGORY)",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    },
	    supplierName: {
	      caption: "CONTACT PERSON",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    },
	
	    supplierEmail: {
	      caption: "EMAIL",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    },
	    supplierFax: {
	      caption: "FAX",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    },
	    supplierMailingAddress: {
	      caption: "SUPPLIER MAILING ADDRESS",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    },
	    supplierPhone: {
	      caption: "PHONE",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    }
	  },
	  notices: {
	    noticeTitle: {
	      caption: "NOTICETITLE",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    },
	    noticeDetails: {
	      caption: "NOTICE DETAILS",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "textarea",
	      enabled: true
	    }
	  },
	  projectInvoices: {
	    invoiceId: {
	      caption: "ID",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    },
	    invoiceStatus: {
	      caption: "STATUS",
	      selectorSource: {
	        type: "static",
	        table: "",
	        tableField: "name",
	        staticSource: [{
	          name: "ISSUED",
	          key: "ISSUED"
	        }, {
	          name: "Cheque Submitted",
	          key: "Cheque Submitted"
	        }, {
	          dayName: "PUBLIC HOLIDAY",
	          key: "PUBLIC HOLIDAY",
	          dayTypeId: "PUBLIC HOLIDAY"
	        }]
	      },
	      inputValidator: "",
	      type: "search",
	      enabled: true
	    },
	    invoiceDate: {
	      caption: "DATE",
	      selectorSource: {
	        type: "dateBetween",
	        dateFormat: "DD-MM-YYYY",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    },
	    companyName: {
	      caption: "COMPANY",
	      selectorSource: {
	        type: "table",
	        table: "contacts",
	        tableField: "contactCompany",
	        staticSource: []
	      },
	      inputValidator: "",
	      type: "search",
	      enabled: true
	    },
	    contactFax: {
	      caption: "FAX",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    },
	    contactName: {
	      caption: "CONTACT NAME",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    },
	    contactPhone: {
	      caption: "CONTACT PHONE",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    },
	    email: {
	      caption: "EMAIL",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    },
	    clientPo: {
	      caption: "CLIENT PO",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    },
	    invoiceTerms: {
	      caption: "TERMS",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    },
	    invoiceTemplate: {
	      caption: "TEMPLATE",
	      selectorSource: {
	        type: "static",
	        table: "",
	        tableField: "name",
	        staticSource: [{
	          name: "WITHOUT SIGNATURE",
	          key: "65691"
	        }, {
	          name: "WITH SIGNATURE",
	          key: "65986"
	        }]
	      },
	      inputValidator: "",
	      type: "search",
	      enabled: true
	    },
	    mailingAddress: {
	      caption: "MAILING ADDRESS",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    },
	    projectName: {
	      caption: "PROJECT",
	      selectorSource: {
	        type: "table",
	        table: "projects",
	        tableField: "projectName",
	        staticSource: []
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    },
	    salutation: {
	      caption: "SALUTATION",
	      selectorSource: {
	        type: "static",
	        table: "",
	        tableField: "name",
	        staticSource: [{
	          name: "Dear Sir,",
	          key: "Dear Sir,"
	        }, {
	          name: "Dear Madam,",
	          key: "Dear Madam,"
	        }]
	      },
	      inputValidator: "",
	      type: "search",
	      enabled: true
	    },
	    totalInvoice: {
	      caption: "TOTAL INVOICE",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    },
	    items: {
	      caption: "ITEMS",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "array",
	      enabled: true,
	
	      colDefs: [{
	        name: "ITEM",
	        key: "item",
	        editable: true,
	        resizable: true
	      }, {
	        name: "DESCRIPTION",
	        key: "description",
	        editable: true,
	        resizable: true
	      }, {
	        name: "UNIT",
	        key: "unit",
	        editable: true,
	        resizable: true
	      }, {
	        name: "QUANTITY",
	        key: "quantity",
	        editable: true,
	        resizable: true
	      }, {
	        name: "RATE",
	        key: "rate",
	        editable: true,
	        resizable: true
	      }, {
	        name: "AMOUNT",
	        key: "amount",
	        disabled: true,
	        mode: "calc",
	        rule: "quantity*rate",
	        resizable: true
	      }],
	      emptyRow: {
	        item: "",
	        description: "",
	        unit: "",
	        rate: "",
	        quantity: ""
	      }
	    }
	  },
	  deletedprojectInvoices: {
	    invoiceId: {
	      caption: "ID",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    },
	    invoiceStatus: {
	      caption: "STATUS",
	      selectorSource: {
	        type: "static",
	        table: "",
	        tableField: "name",
	        staticSource: [{
	          name: "ISSUED",
	          key: "ISSUED"
	        }, {
	          name: "Cheque Submitted",
	          key: "Cheque Submitted"
	        }, {
	          dayName: "PUBLIC HOLIDAY",
	          key: "PUBLIC HOLIDAY",
	          dayTypeId: "PUBLIC HOLIDAY"
	        }]
	      },
	      inputValidator: "",
	      type: "search",
	      enabled: true
	    },
	    invoiceDate: {
	      caption: "DATE",
	      selectorSource: {
	        type: "dateBetween",
	        dateFormat: "DD-MM-YYYY",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    },
	    companyName: {
	      caption: "COMPANY",
	      selectorSource: {
	        type: "table",
	        table: "contacts",
	        tableField: "contactCompany",
	        staticSource: []
	      },
	      inputValidator: "",
	      type: "search",
	      enabled: true
	    },
	    contactFax: {
	      caption: "FAX",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    },
	    contactName: {
	      caption: "CONTACT NAME",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    },
	    contactPhone: {
	      caption: "CONTACT PHONE",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    },
	    email: {
	      caption: "EMAIL",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    },
	    clientPo: {
	      caption: "CLIENT PO",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    },
	    invoiceTerms: {
	      caption: "TERMS",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    },
	    invoiceTemplate: {
	      caption: "TEMPLATE",
	      selectorSource: {
	        type: "static",
	        table: "",
	        tableField: "name",
	        staticSource: [{
	          name: "WITHOUT SIGNATURE",
	          key: "65691"
	        }, {
	          name: "WITH SIGNATURE",
	          key: "65986"
	        }]
	      },
	      inputValidator: "",
	      type: "search",
	      enabled: true
	    },
	    mailingAddress: {
	      caption: "MAILING ADDRESS",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    },
	    projectName: {
	      caption: "PROJECT",
	      selectorSource: {
	        type: "table",
	        table: "projects",
	        tableField: "projectName",
	        staticSource: []
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    },
	    salutation: {
	      caption: "SALUTATION",
	      selectorSource: {
	        type: "static",
	        table: "",
	        tableField: "name",
	        staticSource: [{
	          name: "Dear Sir,",
	          key: "Dear Sir,"
	        }, {
	          name: "Dear Madam,",
	          key: "Dear Madam,"
	        }]
	      },
	      inputValidator: "",
	      type: "search",
	      enabled: true
	    },
	    totalInvoice: {
	      caption: "TOTAL INVOICE",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    },
	    items: {
	      caption: "ITEMS",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "array",
	      enabled: true,
	
	      colDefs: [{
	        name: "ITEM",
	        key: "item",
	        editable: true,
	        resizable: true
	      }, {
	        name: "DESCRIPTION",
	        key: "description",
	        editable: true,
	        resizable: true
	      }, {
	        name: "UNIT",
	        key: "unit",
	        editable: true,
	        resizable: true
	      }, {
	        name: "QUANTITY",
	        key: "quantity",
	        editable: true,
	        resizable: true
	      }, {
	        name: "RATE",
	        key: "rate",
	        editable: true,
	        resizable: true
	      }, {
	        name: "AMOUNT",
	        key: "amount",
	        disabled: true,
	        mode: "calc",
	        rule: "quantity*rate",
	        resizable: true
	      }],
	      emptyRow: {
	        item: "",
	        description: "",
	        unit: "",
	        rate: "",
	        quantity: ""
	      }
	    }
	  },
	  projectClaims: {
	    accSubConSum: {
	      caption: "ACCSUBCONSUM",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    },
	    author: {
	      caption: "AUTHOR",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    },
	    bqItems: {
	      caption: "BQITEMS",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    },
	    bqVoList: {
	      caption: "BQVOLIST",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    },
	    claimDate: {
	      caption: "CLAIMDATE",
	      selectorSource: {
	        type: "dateBetween",
	        dateFormat: "DD-MM-YYYY",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    },
	    claimId: {
	      caption: "CLAIMID",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    },
	    claimStatus: {
	      caption: "CLAIMSTATUS",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    },
	    companyName: {
	      caption: "COMPANYNAME",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    },
	    contactFax: {
	      caption: "CONTACTFAX",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    },
	    contactKey: {
	      caption: "CONTACTKEY",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    },
	    contactName: {
	      caption: "CONTACTNAME",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    },
	    contactPhone: {
	      caption: "CONTACTPHONE",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    },
	    discountPercent: {
	      caption: "DISCOUNTPERCENT",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    },
	    email: {
	      caption: "EMAIL",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    },
	    invItems: {
	      caption: "INVITEMS",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    },
	    mailingAddress: {
	      caption: "MAILINGADDRESS",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    },
	    projectId: {
	      caption: "PROJECTID",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    },
	    projectKey: {
	      caption: "PROJECTKEY",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    },
	    projectName: {
	      caption: "PROJECTNAME",
	      selectorSource: {
	        type: "table",
	        table: "projects",
	        tableField: "projectName",
	        staticSource: []
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    },
	    quoteId: {
	      caption: "QUOTEID",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    },
	    quoteKey: {
	      caption: "QUOTEKEY",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    },
	    retentionPercent: {
	      caption: "RETENTIONPERCENT",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    },
	    salutation: {
	      caption: "SALUTATION",
	      selectorSource: {
	        type: "static",
	        table: "",
	        tableField: "name",
	        staticSource: [{
	          name: "Dear Sir,",
	          key: "Dear Sir,"
	        }, {
	          name: "Dear Madam,",
	          key: "Dear Madam,"
	        }]
	      },
	      inputValidator: "",
	      type: "search",
	      enabled: true
	    },
	    totPmtRcvd: {
	      caption: "TOTPMTRCVD",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    },
	    updateDateTime: {
	      caption: "UPDATEDATETIME",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    },
	    voItems: {
	      caption: "VOITEMS",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    },
	    voSum: {
	      caption: "VOSUM",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    }
	  },
	  projectQuotes: {
	    quoteId: {
	      caption: "QUOTE ID",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    },
	    quoteDate: {
	      caption: "QUOTE DATE",
	      selectorSource: {
	        type: "dateBetween",
	        dateFormat: "DD-MM-YYYY",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    },
	    companyName: {
	      caption: "COMPANY",
	      selectorSource: {
	        type: "table",
	        table: "contacts",
	        tableField: "companyName",
	        staticSource: []
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true,
	      isMust: true
	    },
	    projectName: {
	      caption: "PROJECT NAME",
	      selectorSource: {
	        type: "table",
	        table: "projects",
	        tableField: "projectName",
	        staticSource: []
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true,
	      isMust: true
	    },
	    estimatedSchedule: {
	      caption: "ESTIMATED SCHEDULE",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "textarea",
	      enabled: true
	    },
	    genCoditions: {
	      caption: "GENERAL TERMS & CONDITIONS",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "textarea",
	      enabled: true
	    },
	    techNotes: {
	      caption: "TECHNICAL NOTES",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "textarea",
	      enabled: true
	    },
	    additionalReqs: {
	      caption: "ADDITIONAL NOTES",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "textarea",
	      enabled: true
	    },
	    contactFax: {
	      caption: "FAX",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    },
	    contactKey: {
	      caption: "CONTACTKEY",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    },
	    contactName: {
	      caption: "CLIENT'S QS",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    },
	    contactPhone: {
	      caption: "PHONE",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    },
	    email: {
	      caption: " QS EMAIL",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    },
	    items: {
	      caption: "ITEMS",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "array",
	      enabled: true,
	
	      colDefs: [{
	        name: "ITEM",
	        key: "item",
	        editable: true,
	        resizable: true
	      }, {
	        name: "DESCRIPTION",
	        key: "description",
	        editable: true,
	        resizable: true
	      }, {
	        name: "UNIT",
	        key: "unit",
	        editable: true,
	        resizable: true
	      }, {
	        name: "QUANTITY",
	        key: "estimatedQuantity",
	        editable: true,
	        resizable: true
	      }, {
	        name: "RATE",
	        key: "rate",
	        editable: true,
	        resizable: true
	      }, {
	        name: "AMOUNT",
	        key: "amount",
	        disabled: true,
	        mode: "calc",
	        rule: "estimatedQuantity*rate",
	        resizable: true
	      }],
	      emptyRow: {
	        item: "",
	        description: "",
	        unit: "",
	        rate: "",
	        estimatedQuantity: ""
	      }
	    },
	    mailingAddress: {
	      caption: "MAILING ADDRESS",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    },
	    projectId: {
	      caption: "PROJECTID",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    },
	    projectKey: {
	      caption: "PROJECTKEY",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    },
	    author: {
	      caption: "AUTHOR",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    },
	    quoteType: {
	      caption: "QUOTE TYPE",
	      selectorSource: {
	        type: "static",
	        table: "",
	        tableField: "name",
	        staticSource: [{
	          name: "BQ",
	          key: "BQ"
	        }, {
	          name: "VO",
	          key: "VO"
	        }]
	      },
	      inputValidator: "",
	      type: "search",
	      enabled: true
	    },
	    rateOnly: {
	      caption: "RATE ONLY",
	      selectorSource: {
	        type: "static",
	        table: "",
	        tableField: "name",
	        staticSource: [{
	          name: "RATE ONLY",
	          key: "RATE ONLY"
	        }, {
	          name: "NORMAL",
	          key: "NORMAL"
	        }]
	      },
	      inputValidator: "",
	      type: "search",
	      enabled: true
	    },
	    salutation: {
	      caption: "SALUTATION",
	      selectorSource: {
	        type: "static",
	        table: "",
	        tableField: "name",
	        staticSource: [{
	          name: "Dear Sir,",
	          key: "Dear Sir,"
	        }, {
	          name: "Dear Madam,",
	          key: "Dear Madam,"
	        }]
	      },
	      inputValidator: "",
	      type: "search",
	      enabled: true,
	      isMust: true
	    },
	    totalAmount: {
	      caption: "TOTAL QUOTE",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    },
	    updateDateTime: {
	      caption: "UPDATEDATETIME",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    }
	  },
	  reports: {
	    categ: {
	      caption: "CATEG",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true,
	      isMust: true
	    },
	    key: {
	      caption: "KEY",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    },
	    reportName: {
	      caption: "REPORTNAME",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    },
	    selectedCategory: {
	      caption: "SELECTEDCATEGORY",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    },
	    selectedGroupBy: {
	      caption: "SELECTEDGROUPBY",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    },
	    updateDateTime: {
	      caption: "UPDATEDATETIME",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    }
	  },
	  viewReports: {
	    categ: {
	      caption: "CATEG",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    },
	    key: {
	      caption: "KEY",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    },
	    reportName: {
	      caption: "REPORTNAME",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    },
	    selectedCategory: {
	      caption: "SELECTEDCATEGORY",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    },
	    selectedGroupBy: {
	      caption: "SELECTEDGROUPBY",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    },
	    updateDateTime: {
	      caption: "UPDATEDATETIME",
	      selectorSource: {
	        type: "",
	        table: ""
	      },
	      inputValidator: "",
	      type: "input",
	      enabled: true
	    }
	  },
	  createFields: {
	    name: {
	      caption: "NAME",
	      inputValidator: "",
	      type: "input",
	      enabled: true,
	      selectorSource: {
	        staticSource: []
	      }
	    },
	    caption: {
	      caption: "CAPTION",
	      inputValidator: "",
	      type: "input",
	      enabled: true,
	      selectorSource: {
	        staticSource: []
	      }
	    },
	    defaultValue: {
	      caption: "DEFAULT VALUE",
	      inputValidator: "",
	      type: "textarea",
	      enabled: true,
	      selectorSource: {
	        staticSource: []
	      }
	    },
	    placeholder: {
	      caption: "PLACEHOLDER",
	      inputValidator: "",
	      type: "textarea",
	      enabled: true,
	      selectorSource: {
	        staticSource: []
	      }
	    },
	    type: {
	      caption: "INPUT TYPE",
	      inputValidator: "",
	      type: "search",
	      enabled: true,
	      selectorSource: {
	        type: "static",
	        table: "",
	        tableField: "name",
	        staticSource: [{
	          name: "input",
	          key: "input"
	        }, {
	          name: "textarea",
	          key: "textarea"
	        }, {
	          name: "search",
	          key: "search"
	        }, {
	          name: "calendar",
	          key: "calendar"
	        }, {
	          name: "array",
	          key: "array"
	        }, {
	          name: "calculation",
	          key: "calculation"
	        }, {
	          name: "accountingRule",
	          key: "accountingRule"
	        }, {
	          name: "photoUpload",
	          key: "photoUpload"
	        }]
	      }
	    },
	    calcType: {
	      caption: "CALC TYPE",
	      inputValidator: "",
	      type: "search",
	      enabled: true,
	      selectorSource: {
	        type: "static",
	        table: "",
	        tableField: "name",
	        staticSource: [{
	          name: "subFieldsSum",
	          key: "subFieldsSum"
	        }, {
	          name: "mainFieldCalc",
	          key: "mainFieldCalc"
	        }]
	      }
	    },
	    subFieldOperation: {
	      caption: "SUB OPERATION",
	      inputValidator: "",
	      type: "search",
	      enabled: true,
	      selectorSource: {
	        type: "static",
	        table: "",
	        tableField: "name",
	        staticSource: [{
	          name: "SUM",
	          key: "SUM"
	        }, {
	          name: "AVERAGE",
	          key: "AVERAGE"
	        }]
	      }
	    },
	    subGridName: {
	      caption: "SUB GRID NAME",
	      inputValidator: "",
	      type: "input",
	      enabled: true,
	      selectorSource: {
	        staticSource: []
	      }
	    },
	    subGridField: {
	      caption: "SUB GRID FIELD",
	      inputValidator: "",
	      type: "input",
	      enabled: true,
	      selectorSource: {
	        staticSource: []
	      }
	    },
	    formula: {
	      caption: "FORMULA",
	      inputValidator: "",
	      type: "input",
	      enabled: true,
	      selectorSource: {
	        staticSource: []
	      }
	    },
	    triggerField: {
	      caption: "TRIGGER FIELD",
	      inputValidator: "",
	      type: "input",
	      enabled: true,
	      selectorSource: {
	        staticSource: []
	      }
	    },
	    inputValidator: {
	      caption: "VALIDATOR",
	      inputValidator: "",
	      type: "input",
	      enabled: true,
	      selectorSource: {
	        staticSource: []
	      }
	    },
	    enabled: {
	      caption: "ENABLED",
	      inputValidator: "",
	      type: "search",
	      enabled: true,
	      selectorSource: {
	        type: "static",
	        table: "",
	        tableField: "name",
	        staticSource: [{ name: "true", key: true }, { name: "false", key: false }]
	      }
	    },
	    isMust: {
	      caption: "IS MANDATORY",
	      inputValidator: "",
	      type: "search",
	      enabled: true,
	      selectorSource: {
	        type: "static",
	        table: "",
	        tableField: "name",
	        staticSource: [{ name: "true", key: true }, { name: "false", key: false }]
	      }
	    },
	    isHidden: {
	      caption: "IS HIDDEN",
	      inputValidator: "",
	      type: "search",
	      enabled: true,
	      selectorSource: {
	        type: "static",
	        table: "",
	        tableField: "name",
	        staticSource: [{ name: "true", key: true }, { name: "false", key: false }]
	      }
	    },
	    isSecure: {
	      caption: "IS PASSWORD",
	      inputValidator: "",
	      type: "search",
	      enabled: true,
	      selectorSource: {
	        type: "static",
	        table: "",
	        tableField: "name",
	        staticSource: [{ name: "true", key: true }, { name: "false", key: false }]
	      }
	    },
	    selectorType: {
	      caption: "SELECTOR TYPE",
	      inputValidator: "",
	      type: "search",
	      enabled: true,
	      selectorSource: {
	        type: "static",
	        table: "",
	        tableField: "value",
	        staticSource: [{ value: "static" }, { value: "table" }]
	      }
	    },
	    selectorTable: {
	      caption: "MANDATORY",
	      inputValidator: "",
	      type: "input",
	      enabled: true,
	      selectorSource: {
	        staticSource: []
	      }
	    },
	    numOfLines: {
	      caption: "NO. OF LINES",
	      inputValidator: "",
	      type: "input",
	      enabled: true,
	      selectorSource: {
	        staticSource: []
	      }
	    },
	    dateFormatOut: {
	      caption: "DATE FORMAT OUT",
	      inputValidator: "",
	      type: "search",
	      enabled: true,
	      selectorSource: {
	        type: "static",
	        table: "",
	        tableField: "name",
	        staticSource: [{
	          name: "DD-MM-YYYY h:mm a",
	          key: "DD-MM-YYYY h:mm a"
	        }, {
	          name: "DD-MM-YYYY",
	          key: "DD-MM-YYYY"
	        }]
	      }
	    },
	    dateFormat: {
	      caption: "DATE FORMAT",
	      inputValidator: "",
	      type: "search",
	      enabled: true,
	      selectorSource: {
	        type: "static",
	        table: "",
	        tableField: "name",
	        staticSource: [{
	          name: "dd-MM-yyyy h:mm a",
	          key: "dd-MM-yyyy h:mm a"
	        }, {
	          name: "dd-MM-yyyy",
	          key: "dd-MM-yyyy"
	        }]
	      }
	    },
	    dateMaxDetail: {
	      caption: "MAX DETAIL",
	      inputValidator: "",
	      type: "search",
	      enabled: true,
	      selectorSource: {
	        type: "static",
	        table: "",
	        tableField: "name",
	        staticSource: [{
	          name: "minute",
	          key: "minute"
	        }, {
	          name: "hour",
	          key: "hour"
	        }, {
	          name: "day",
	          key: "day"
	        }]
	      }
	    }
	  },
	  createTable: {
	    name: {
	      caption: "FORM NAME",
	      inputValidator: "",
	      type: "input",
	      enabled: true,
	      selectorSource: {
	        staticSource: []
	      }
	    },
	    caption: {
	      caption: "FORM CAPTION",
	      inputValidator: "",
	      type: "input",
	      enabled: true,
	      selectorSource: {
	        staticSource: []
	      }
	    },
	    menu: {
	      caption: "MENU CAPTION",
	      inputValidator: "",
	      type: "input",
	      enabled: true,
	      selectorSource: {
	        staticSource: []
	      }
	    },
	    createNotifyText: {
	      caption: "CREATE TEXT",
	      inputValidator: "",
	      type: "textarea",
	      numOfLines: "5",
	      enabled: true,
	      selectorSource: {
	        staticSource: []
	      }
	    },
	    updateNotifyText: {
	      caption: "UPDATE TEXT",
	      inputValidator: "",
	      type: "textarea",
	      numOfLines: "5",
	      enabled: true,
	      selectorSource: {
	        staticSource: []
	      }
	    },
	    deleteNotifyText: {
	      caption: "DELETE TEXT",
	      inputValidator: "",
	      type: "textarea",
	      numOfLines: "5",
	      enabled: true,
	      selectorSource: {
	        staticSource: []
	      }
	    },
	    fullText: {
	      caption: "FULL TEXT",
	      inputValidator: "",
	      type: "textarea",
	      enabled: true,
	      selectorSource: {
	        staticSource: []
	      }
	    }
	  },
	  listOfTables: {
	    name: {
	      caption: "TABLE NAME",
	      inputValidator: "",
	      type: "input",
	      enabled: true,
	      selectorSource: {
	        staticSource: []
	      }
	    },
	    caption: {
	      caption: "TABLE CAPTION",
	      inputValidator: "",
	      type: "input",
	      enabled: true,
	      selectorSource: {
	        staticSource: []
	      }
	    },
	    menu: {
	      caption: "MENU CAPTION",
	      inputValidator: "",
	      type: "input",
	      enabled: true,
	      selectorSource: {
	        staticSource: []
	      }
	    }
	  },
	  menuDesigner: {
	    name: {
	      caption: "MENU NAME",
	      inputValidator: "",
	      type: "input",
	      enabled: true,
	      selectorSource: {
	        staticSource: []
	      },
	      isMust: true
	    }
	  }
	};
	
	exports.default = ogTableDef;

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _login = __webpack_require__(151);
	
	var _login2 = _interopRequireDefault(_login);
	
	__webpack_require__(912);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	exports.default = function () {
	  return _react2.default.createElement(_login2.default, null);
	};

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _slicedToArray = function () {
	  function sliceIterator(arr, i) {
	    var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
	      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
	        _arr.push(_s.value);if (i && _arr.length === i) break;
	      }
	    } catch (err) {
	      _d = true;_e = err;
	    } finally {
	      try {
	        if (!_n && _i["return"]) _i["return"]();
	      } finally {
	        if (_d) throw _e;
	      }
	    }return _arr;
	  }return function (arr, i) {
	    if (Array.isArray(arr)) {
	      return arr;
	    } else if (Symbol.iterator in Object(arr)) {
	      return sliceIterator(arr, i);
	    } else {
	      throw new TypeError("Invalid attempt to destructure non-iterable instance");
	    }
	  };
	}();
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactLifecyclesCompat = __webpack_require__(91);
	
	var _DayInput = __webpack_require__(431);
	
	var _DayInput2 = _interopRequireDefault(_DayInput);
	
	var _MonthInput = __webpack_require__(432);
	
	var _MonthInput2 = _interopRequireDefault(_MonthInput);
	
	var _MonthSelect = __webpack_require__(433);
	
	var _MonthSelect2 = _interopRequireDefault(_MonthSelect);
	
	var _YearInput = __webpack_require__(434);
	
	var _YearInput2 = _interopRequireDefault(_YearInput);
	
	var _Hour12Input = __webpack_require__(495);
	
	var _Hour12Input2 = _interopRequireDefault(_Hour12Input);
	
	var _Hour24Input = __webpack_require__(496);
	
	var _Hour24Input2 = _interopRequireDefault(_Hour24Input);
	
	var _MinuteInput = __webpack_require__(497);
	
	var _MinuteInput2 = _interopRequireDefault(_MinuteInput);
	
	var _SecondInput = __webpack_require__(498);
	
	var _SecondInput2 = _interopRequireDefault(_SecondInput);
	
	var _AmPm = __webpack_require__(494);
	
	var _AmPm2 = _interopRequireDefault(_AmPm);
	
	var _Divider = __webpack_require__(334);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	var _NativeInput = __webpack_require__(332);
	
	var _NativeInput2 = _interopRequireDefault(_NativeInput);
	
	var _dateFormatter = __webpack_require__(336);
	
	var _dates = __webpack_require__(157);
	
	var _propTypes3 = __webpack_require__(109);
	
	var _utils = __webpack_require__(158);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
	  } else {
	    obj[key] = value;
	  }return obj;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	function _toConsumableArray(arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
	      arr2[i] = arr[i];
	    }return arr2;
	  } else {
	    return Array.from(arr);
	  }
	}
	
	var defaultMinDate = new Date(-8.64e15);
	var defaultMaxDate = new Date(8.64e15);
	var allViews = ['hour', 'minute', 'second'];
	
	var datesAreDifferent = function datesAreDifferent(date1, date2) {
	  return date1 && !date2 || !date1 && date2 || date1 && date2 && date1.getTime() !== date2.getTime();
	};
	
	var isSameDate = function isSameDate(date, year, month, day) {
	  return (0, _dates.getYear)(date) === year && (0, _dates.getMonth)(date) === month && (0, _dates.getDay)(date) === day;
	};
	
	var getValueFromRange = function getValueFromRange(valueOrArrayOfValues, index) {
	  if (Array.isArray(valueOrArrayOfValues)) {
	    return valueOrArrayOfValues[index];
	  }
	
	  return valueOrArrayOfValues;
	};
	
	var parseAndValidateDate = function parseAndValidateDate(rawValue) {
	  if (!rawValue) {
	    return null;
	  }
	
	  var valueDate = new Date(rawValue);
	
	  if (isNaN(valueDate.getTime())) {
	    throw new Error('Invalid date: ' + rawValue);
	  }
	
	  return valueDate;
	};
	
	var getDetailValue = function getDetailValue(value, minDate, maxDate) {
	  if (!value) {
	    return null;
	  }
	
	  return (0, _utils.between)(value, minDate, maxDate);
	};
	
	var getValueFrom = function getValueFrom(value) {
	  var valueFrom = getValueFromRange(value, 0);
	
	  return parseAndValidateDate(valueFrom);
	};
	
	var getDetailValueFrom = function getDetailValueFrom(value, minDate, maxDate) {
	  var valueFrom = getValueFrom(value);
	
	  return getDetailValue(valueFrom, minDate, maxDate);
	};
	
	var getValueTo = function getValueTo(value) {
	  var valueTo = getValueFromRange(value, 1);
	
	  return parseAndValidateDate(valueTo);
	};
	
	var getDetailValueTo = function getDetailValueTo(value, minDate, maxDate) {
	  var valueTo = getValueTo(value);
	
	  return getDetailValue(valueTo, minDate, maxDate);
	};
	
	var isValidInput = function isValidInput(element) {
	  return element.tagName === 'INPUT' && element.type === 'number';
	};
	
	var findInput = function findInput(element, property) {
	  var nextElement = element;
	  do {
	    nextElement = nextElement[property];
	  } while (nextElement && !isValidInput(nextElement));
	  return nextElement;
	};
	
	var focus = function focus(element) {
	  return element && element.focus();
	};
	
	var _renderCustomInputs = function _renderCustomInputs(placeholder, elementFunctions, allowMultipleInstances) {
	  var usedFunctions = [];
	  var pattern = new RegExp(Object.keys(elementFunctions).map(function (el) {
	    return el + '+';
	  }).join('|'), 'g');
	  var matches = placeholder.match(pattern);
	
	  return placeholder.split(pattern).reduce(function (arr, element, index) {
	    var divider = element &&
	    // eslint-disable-next-line react/no-array-index-key
	    _react2.default.createElement(_Divider2.default, { key: 'separator_' + index }, element);
	    var res = [].concat(_toConsumableArray(arr), [divider]);
	    var currentMatch = matches && matches[index];
	
	    if (currentMatch) {
	      var renderFunction = elementFunctions[currentMatch] || elementFunctions[Object.keys(elementFunctions).find(function (elementFunction) {
	        return currentMatch.match(elementFunction);
	      })];
	
	      if (!allowMultipleInstances && usedFunctions.includes(renderFunction)) {
	        res.push(currentMatch);
	      } else {
	        res.push(renderFunction(currentMatch));
	        usedFunctions.push(renderFunction);
	      }
	    }
	    return res;
	  }, []);
	};
	
	var DateTimeInput = function (_PureComponent) {
	  _inherits(DateTimeInput, _PureComponent);
	
	  function DateTimeInput() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, DateTimeInput);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DateTimeInput.__proto__ || Object.getPrototypeOf(DateTimeInput)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      amPm: null,
	      year: null,
	      month: null,
	      day: null,
	      hour: null,
	      minute: null,
	      second: null
	    }, _this.onClick = function (event) {
	      if (event.target === event.currentTarget) {
	        // Wrapper was directly clicked
	        var firstInput = event.target.children[1];
	        focus(firstInput);
	      }
	    }, _this.onKeyDown = function (event) {
	      switch (event.key) {
	        case 'ArrowLeft':
	        case 'ArrowRight':
	        case _this.dateDivider:
	        case _this.timeDivider:
	          {
	            event.preventDefault();
	
	            var input = event.target;
	
	            var property = event.key === 'ArrowLeft' ? 'previousElementSibling' : 'nextElementSibling';
	            var nextInput = findInput(input, property);
	            focus(nextInput);
	            break;
	          }
	        default:
	      }
	    }, _this.onKeyUp = function (event) {
	      var key = event.key,
	          input = event.target;
	
	      var isNumberKey = !isNaN(parseInt(key, 10));
	
	      if (!isNumberKey) {
	        return;
	      }
	
	      var value = input.value;
	
	      var max = parseInt(input.getAttribute('max'), 10);
	
	      /**
	       * Given 1, the smallest possible number the user could type by adding another digit is 10.
	       * 10 would be a valid value given max = 12, so we won't jump to the next input.
	       * However, given 2, smallers possible number would be 20, and thus keeping the focus in
	       * this field doesn't make sense.
	       */
	      if (value * 10 > max) {
	        var property = 'nextElementSibling';
	        var nextInput = findInput(input, property);
	        focus(nextInput);
	      }
	    }, _this.onChange = function (event) {
	      var _event$target = event.target,
	          name = _event$target.name,
	          value = _event$target.value;
	
	      switch (name) {
	        case 'hour12':
	          {
	            _this.setState(function (prevState) {
	              return {
	                hour: value ? (0, _dates.convert12to24)(parseInt(value, 10), prevState.amPm) : null
	              };
	            }, _this.onChangeExternal);
	            break;
	          }
	        case 'hour24':
	          {
	            _this.setState({ hour: value ? parseInt(value, 10) : null }, _this.onChangeExternal);
	            break;
	          }
	        default:
	          {
	            _this.setState(_defineProperty({}, name, value ? parseInt(value, 10) : null), _this.onChangeExternal);
	          }
	      }
	    }, _this.onChangeNative = function (event) {
	      var onChange = _this.props.onChange;
	      var value = event.target.value;
	
	      if (!onChange) {
	        return;
	      }
	
	      var processedValue = function () {
	        if (!value) {
	          return null;
	        }
	
	        var _value$split = value.split('T'),
	            _value$split2 = _slicedToArray(_value$split, 2),
	            valueDate = _value$split2[0],
	            valueTime = _value$split2[1];
	
	        var _valueDate$split = valueDate.split('-'),
	            _valueDate$split2 = _slicedToArray(_valueDate$split, 3),
	            yearString = _valueDate$split2[0],
	            monthString = _valueDate$split2[1],
	            dayString = _valueDate$split2[2];
	
	        var year = parseInt(yearString, 10);
	        var monthIndex = parseInt(monthString, 10) - 1 || 0;
	        var date = parseInt(dayString, 10) || 1;
	
	        var _valueTime$split = valueTime.split(':'),
	            _valueTime$split2 = _slicedToArray(_valueTime$split, 3),
	            hourString = _valueTime$split2[0],
	            minuteString = _valueTime$split2[1],
	            secondString = _valueTime$split2[2];
	
	        var hour = parseInt(hourString, 10) || 0;
	        var minute = parseInt(minuteString, 10) || 0;
	        var second = parseInt(secondString, 10) || 0;
	
	        return new Date(year, monthIndex, date, hour, minute, second);
	      }();
	
	      onChange(processedValue, false);
	    }, _this.onChangeAmPm = function (event) {
	      var value = event.target.value;
	
	      _this.setState({ amPm: value }, _this.onChangeExternal);
	    }, _this.onChangeExternal = function () {
	      var onChange = _this.props.onChange;
	
	      if (!onChange) {
	        return;
	      }
	
	      var formElements = [_this.dayInput, _this.monthInput, _this.yearInput, _this.hour12Input, _this.hour24Input, _this.minuteInput, _this.secondInput, _this.amPmInput].filter(Boolean);
	
	      var formElementsWithoutSelect = formElements.slice(0, -1);
	
	      var values = {};
	      formElements.forEach(function (formElement) {
	        values[formElement.name] = formElement.value;
	      });
	
	      if (formElementsWithoutSelect.every(function (formElement) {
	        return !formElement.value;
	      })) {
	        onChange(null, false);
	      } else if (formElements.every(function (formElement) {
	        return formElement.value && formElement.checkValidity();
	      })) {
	        var year = parseInt(values.year, 10);
	        var month = parseInt(values.month || 1, 10);
	        var day = parseInt(values.day || 1, 10);
	        var hour = parseInt(values.hour24 || (0, _dates.convert12to24)(values.hour12, values.amPm) || 0, 10);
	        var minute = parseInt(values.minute || 0, 10);
	        var second = parseInt(values.second || 0, 10);
	
	        var proposedValue = new Date(year, month - 1, day, hour, minute, second);
	        var processedValue = proposedValue;
	        onChange(processedValue, false);
	      }
	    }, _this.renderDay = function (currentMatch) {
	      var _this$props = _this.props,
	          dayAriaLabel = _this$props.dayAriaLabel,
	          dayPlaceholder = _this$props.dayPlaceholder,
	          showLeadingZeros = _this$props.showLeadingZeros;
	      var _this$state = _this.state,
	          day = _this$state.day,
	          month = _this$state.month,
	          year = _this$state.year;
	
	      if (currentMatch && currentMatch.length > 2) {
	        throw new Error('Unsupported token: ' + currentMatch);
	      }
	
	      var showLeadingZerosFromFormat = currentMatch && currentMatch.length === 2;
	
	      return _react2.default.createElement(_DayInput2.default, _extends({
	        key: 'day'
	      }, _this.commonInputProps, {
	        ariaLabel: dayAriaLabel,
	        month: month,
	        placeholder: dayPlaceholder,
	        showLeadingZeros: showLeadingZerosFromFormat || showLeadingZeros,
	        value: day,
	        year: year
	      }));
	    }, _this.renderMonth = function (currentMatch) {
	      var _this$props2 = _this.props,
	          locale = _this$props2.locale,
	          monthAriaLabel = _this$props2.monthAriaLabel,
	          monthPlaceholder = _this$props2.monthPlaceholder,
	          showLeadingZeros = _this$props2.showLeadingZeros;
	      var _this$state2 = _this.state,
	          month = _this$state2.month,
	          year = _this$state2.year;
	
	      if (currentMatch && currentMatch.length > 4) {
	        throw new Error('Unsupported token: ' + currentMatch);
	      }
	
	      if (currentMatch.length > 2) {
	        return _react2.default.createElement(_MonthSelect2.default, _extends({
	          key: 'month'
	        }, _this.commonInputProps, {
	          ariaLabel: monthAriaLabel,
	          locale: locale,
	          placeholder: monthPlaceholder,
	          short: currentMatch.length === 3,
	          value: month,
	          year: year
	        }));
	      }
	
	      var showLeadingZerosFromFormat = currentMatch && currentMatch.length === 2;
	
	      return _react2.default.createElement(_MonthInput2.default, _extends({
	        key: 'month'
	      }, _this.commonInputProps, {
	        ariaLabel: monthAriaLabel,
	        placeholder: monthPlaceholder,
	        showLeadingZeros: showLeadingZerosFromFormat || showLeadingZeros,
	        value: month,
	        year: year
	      }));
	    }, _this.renderYear = function () {
	      var _this$props3 = _this.props,
	          yearAriaLabel = _this$props3.yearAriaLabel,
	          yearPlaceholder = _this$props3.yearPlaceholder;
	      var year = _this.state.year;
	
	      return _react2.default.createElement(_YearInput2.default, _extends({
	        key: 'year'
	      }, _this.commonInputProps, {
	        ariaLabel: yearAriaLabel,
	        placeholder: yearPlaceholder,
	        value: year,
	        valueType: 'day'
	      }));
	    }, _this.renderHour = function (currentMatch) {
	      if (/h/.test(currentMatch)) {
	        return _this.renderHour12(currentMatch);
	      }
	
	      return _this.renderHour24(currentMatch);
	    }, _this.renderHour12 = function (currentMatch) {
	      var _this$props4 = _this.props,
	          hourAriaLabel = _this$props4.hourAriaLabel,
	          hourPlaceholder = _this$props4.hourPlaceholder;
	      var _this$state3 = _this.state,
	          amPm = _this$state3.amPm,
	          hour = _this$state3.hour;
	
	      if (currentMatch && currentMatch.length > 2) {
	        throw new Error('Unsupported token: ' + currentMatch);
	      }
	
	      var showLeadingZeros = currentMatch && currentMatch.length === 2;
	
	      return _react2.default.createElement(_Hour12Input2.default, _extends({
	        key: 'hour12'
	      }, _this.commonInputProps, _this.commonTimeInputProps, {
	        amPm: amPm,
	        ariaLabel: hourAriaLabel,
	        placeholder: hourPlaceholder,
	        showLeadingZeros: showLeadingZeros,
	        value: hour
	      }));
	    }, _this.renderHour24 = function (currentMatch) {
	      var _this$props5 = _this.props,
	          hourAriaLabel = _this$props5.hourAriaLabel,
	          hourPlaceholder = _this$props5.hourPlaceholder;
	      var hour = _this.state.hour;
	
	      if (currentMatch && currentMatch.length > 2) {
	        throw new Error('Unsupported token: ' + currentMatch);
	      }
	
	      var showLeadingZeros = currentMatch && currentMatch.length === 2;
	
	      return _react2.default.createElement(_Hour24Input2.default, _extends({
	        key: 'hour24'
	      }, _this.commonInputProps, _this.commonTimeInputProps, {
	        ariaLabel: hourAriaLabel,
	        placeholder: hourPlaceholder,
	        showLeadingZeros: showLeadingZeros,
	        value: hour
	      }));
	    }, _this.renderMinute = function (currentMatch) {
	      var _this$props6 = _this.props,
	          minuteAriaLabel = _this$props6.minuteAriaLabel,
	          minutePlaceholder = _this$props6.minutePlaceholder;
	      var _this$state4 = _this.state,
	          hour = _this$state4.hour,
	          minute = _this$state4.minute;
	
	      if (currentMatch && currentMatch.length > 2) {
	        throw new Error('Unsupported token: ' + currentMatch);
	      }
	
	      var showLeadingZeros = currentMatch && currentMatch.length === 2;
	
	      return _react2.default.createElement(_MinuteInput2.default, _extends({
	        key: 'minute'
	      }, _this.commonInputProps, _this.commonTimeInputProps, {
	        ariaLabel: minuteAriaLabel,
	        hour: hour,
	        placeholder: minutePlaceholder,
	        showLeadingZeros: showLeadingZeros,
	        value: minute
	      }));
	    }, _this.renderSecond = function (currentMatch) {
	      var _this$props7 = _this.props,
	          secondAriaLabel = _this$props7.secondAriaLabel,
	          secondPlaceholder = _this$props7.secondPlaceholder;
	      var _this$state5 = _this.state,
	          hour = _this$state5.hour,
	          minute = _this$state5.minute,
	          second = _this$state5.second;
	
	      if (currentMatch && currentMatch.length > 2) {
	        throw new Error('Unsupported token: ' + currentMatch);
	      }
	
	      var showLeadingZeros = currentMatch ? currentMatch.length === 2 : true;
	
	      return _react2.default.createElement(_SecondInput2.default, _extends({
	        key: 'second'
	      }, _this.commonInputProps, _this.commonTimeInputProps, {
	        ariaLabel: secondAriaLabel,
	        hour: hour,
	        minute: minute,
	        placeholder: secondPlaceholder,
	        showLeadingZeros: showLeadingZeros,
	        value: second
	      }));
	    }, _this.renderAmPm = function () {
	      var _this$props8 = _this.props,
	          amPmAriaLabel = _this$props8.amPmAriaLabel,
	          locale = _this$props8.locale;
	      var amPm = _this.state.amPm;
	
	      return _react2.default.createElement(_AmPm2.default, _extends({
	        key: 'ampm'
	      }, _this.commonInputProps, _this.commonTimeInputProps, {
	        ariaLabel: amPmAriaLabel,
	        locale: locale,
	        onChange: _this.onChangeAmPm,
	        value: amPm
	      }));
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(DateTimeInput, [{
	    key: 'renderCustomInputs',
	    value: function renderCustomInputs() {
	      var placeholder = this.placeholder;
	      var format = this.props.format;
	
	      var elementFunctions = {
	        d: this.renderDay,
	        M: this.renderMonth,
	        y: this.renderYear,
	        h: this.renderHour,
	        H: this.renderHour,
	        m: this.renderMinute,
	        s: this.renderSecond,
	        a: this.renderAmPm
	      };
	
	      var allowMultipleInstances = typeof format !== 'undefined';
	      return _renderCustomInputs(placeholder, elementFunctions, allowMultipleInstances);
	    }
	  }, {
	    key: 'renderNativeInput',
	    value: function renderNativeInput() {
	      var _props = this.props,
	          disabled = _props.disabled,
	          maxDate = _props.maxDate,
	          minDate = _props.minDate,
	          name = _props.name,
	          nativeInputAriaLabel = _props.nativeInputAriaLabel,
	          required = _props.required;
	      var value = this.state.value;
	
	      return _react2.default.createElement(_NativeInput2.default, {
	        key: 'time',
	        ariaLabel: nativeInputAriaLabel,
	        disabled: disabled,
	        maxDate: maxDate || defaultMaxDate,
	        minDate: minDate || defaultMinDate,
	        name: name,
	        onChange: this.onChangeNative,
	        required: required,
	        value: value,
	        valueType: this.valueType
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var className = this.props.className;
	
	      return _react2.default.createElement('div', {
	        className: className,
	        onClick: this.onClick,
	        role: 'presentation'
	      }, this.renderNativeInput(), this.renderCustomInputs());
	    }
	  }, {
	    key: 'formatTime',
	    get: function get() {
	      var maxDetail = this.props.maxDetail;
	
	      var options = { hour: 'numeric' };
	      var level = allViews.indexOf(maxDetail);
	      if (level >= 1) {
	        options.minute = 'numeric';
	      }
	      if (level >= 2) {
	        options.second = 'numeric';
	      }
	
	      return (0, _dateFormatter.getFormatter)(options);
	    }
	
	    // eslint-disable-next-line class-methods-use-this
	
	  }, {
	    key: 'formatNumber',
	    get: function get() {
	      var options = { useGrouping: false };
	
	      return (0, _dateFormatter.getFormatter)(options);
	    }
	  }, {
	    key: 'dateDivider',
	    get: function get() {
	      return this.datePlaceholder.match(/[^0-9a-z]/i)[0];
	    }
	  }, {
	    key: 'timeDivider',
	    get: function get() {
	      return this.timePlaceholder.match(/[^0-9a-z]/i)[0];
	    }
	  }, {
	    key: 'datePlaceholder',
	    get: function get() {
	      var locale = this.props.locale;
	
	      var year = 2017;
	      var monthIndex = 11;
	      var day = 11;
	
	      var date = new Date(year, monthIndex, day);
	
	      return (0, _dateFormatter.formatDate)(locale, date).replace(this.formatNumber(locale, year), 'y').replace(this.formatNumber(locale, monthIndex + 1), 'M').replace(this.formatNumber(locale, day), 'd');
	    }
	  }, {
	    key: 'timePlaceholder',
	    get: function get() {
	      var locale = this.props.locale;
	
	      var hour24 = 21;
	      var hour12 = 9;
	      var minute = 13;
	      var second = 14;
	      var date = new Date(2017, 0, 1, hour24, minute, second);
	
	      return this.formatTime(locale, date).replace(this.formatNumber(locale, hour12), 'h').replace(this.formatNumber(locale, hour24), 'H').replace(this.formatNumber(locale, minute), 'mm').replace(this.formatNumber(locale, second), 'ss').replace(new RegExp((0, _utils.getAmPmLabels)(locale).join('|')), 'a');
	    }
	  }, {
	    key: 'placeholder',
	    get: function get() {
	      var format = this.props.format;
	
	      if (format) {
	        return format;
	      }
	
	      return this.datePlaceholder + '\xA0' + this.timePlaceholder;
	    }
	  }, {
	    key: 'maxTime',
	    get: function get() {
	      var maxDate = this.props.maxDate;
	
	      if (!maxDate) {
	        return null;
	      }
	
	      var _state = this.state,
	          year = _state.year,
	          month = _state.month,
	          day = _state.day;
	
	      if (!isSameDate(maxDate, year, month, day)) {
	        return null;
	      }
	
	      return (0, _dates.getHoursMinutesSeconds)(maxDate);
	    }
	  }, {
	    key: 'minTime',
	    get: function get() {
	      var minDate = this.props.minDate;
	
	      if (!minDate) {
	        return null;
	      }
	
	      var _state2 = this.state,
	          year = _state2.year,
	          month = _state2.month,
	          day = _state2.day;
	
	      if (!isSameDate(minDate, year, month, day)) {
	        return null;
	      }
	
	      return (0, _dates.getHoursMinutesSeconds)(minDate);
	    }
	  }, {
	    key: 'commonInputProps',
	    get: function get() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          className = _props2.className,
	          disabled = _props2.disabled,
	          isWidgetOpen = _props2.isWidgetOpen,
	          maxDate = _props2.maxDate,
	          minDate = _props2.minDate,
	          required = _props2.required;
	
	      return {
	        className: className,
	        disabled: disabled,
	        maxDate: maxDate || defaultMaxDate,
	        minDate: minDate || defaultMinDate,
	        onChange: this.onChange,
	        onKeyDown: this.onKeyDown,
	        onKeyUp: this.onKeyUp,
	        placeholder: '--',
	        // This is only for showing validity when editing
	        required: required || isWidgetOpen,
	        itemRef: function itemRef(ref, name) {
	          // Save a reference to each input field
	          _this2[name + 'Input'] = ref;
	        }
	      };
	    }
	  }, {
	    key: 'commonTimeInputProps',
	    get: function get() {
	      var maxTime = this.maxTime,
	          minTime = this.minTime;
	
	      return {
	        maxTime: maxTime,
	        minTime: minTime
	      };
	    }
	
	    /**
	     * Returns value type that can be returned with currently applied settings.
	     */
	
	  }, {
	    key: 'valueType',
	    get: function get() {
	      var maxDetail = this.props.maxDetail;
	
	      return maxDetail;
	    }
	
	    /**
	     * Called when non-native date input is changed.
	     */
	
	    /**
	     * Called when native date input is changed.
	     */
	
	    /**
	     * Called after internal onChange. Checks input validity. If all fields are valid,
	     * calls props.onChange.
	     */
	
	  }], [{
	    key: 'getDerivedStateFromProps',
	    value: function getDerivedStateFromProps(nextProps, prevState) {
	      var minDate = nextProps.minDate,
	          maxDate = nextProps.maxDate;
	
	      var nextState = {};
	
	      /**
	       * If isWidgetOpen flag has changed, we have to update it.
	       * It's saved in state purely for use in getDerivedStateFromProps.
	       */
	      if (nextProps.isWidgetOpen !== prevState.isWidgetOpen) {
	        nextState.isWidgetOpen = nextProps.isWidgetOpen;
	      }
	
	      /**
	       * If the next value is different from the current one  (with an exception of situation in
	       * which values provided are limited by minDate and maxDate so that the dates are the same),
	       * get a new one.
	       */
	      var nextValue = getDetailValueFrom(nextProps.value, minDate, maxDate);
	      var values = [nextValue, prevState.value];
	      if (
	      // Toggling calendar visibility resets values
	      nextState.isCalendarOpen // Flag was toggled
	      || datesAreDifferent.apply(undefined, _toConsumableArray(values.map(function (value) {
	        return getDetailValueFrom(value, minDate, maxDate);
	      }))) || datesAreDifferent.apply(undefined, _toConsumableArray(values.map(function (value) {
	        return getDetailValueTo(value, minDate, maxDate);
	      })))) {
	        if (nextValue) {
	          var _convert24to = (0, _dates.convert24to12)((0, _dates.getHours)(nextValue));
	
	          var _convert24to2 = _slicedToArray(_convert24to, 2);
	
	          nextState.amPm = _convert24to2[1];
	
	          nextState.year = (0, _dates.getYear)(nextValue);
	          nextState.month = (0, _dates.getMonth)(nextValue);
	          nextState.day = (0, _dates.getDay)(nextValue);
	          nextState.hour = (0, _dates.getHours)(nextValue);
	          nextState.minute = (0, _dates.getMinutes)(nextValue);
	          nextState.second = (0, _dates.getSeconds)(nextValue);
	        } else {
	          nextState.amPm = null;
	          nextState.year = null;
	          nextState.month = null;
	          nextState.day = null;
	          nextState.hour = null;
	          nextState.minute = null;
	          nextState.second = null;
	        }
	        nextState.value = nextValue;
	      }
	
	      return nextState;
	    }
	  }]);
	
	  return DateTimeInput;
	}(_react.PureComponent);
	
	exports.default = DateTimeInput;
	
	DateTimeInput.defaultProps = {
	  maxDetail: 'minute',
	  name: 'datetime'
	};
	
	var isValue = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.instanceOf(Date)]);
	
	DateTimeInput.propTypes = {
	  amPmAriaLabel: _propTypes2.default.string,
	  className: _propTypes2.default.string.isRequired,
	  dayAriaLabel: _propTypes2.default.string,
	  dayPlaceholder: _propTypes2.default.string,
	  disabled: _propTypes2.default.bool,
	  format: _propTypes2.default.string,
	  hourAriaLabel: _propTypes2.default.string,
	  hourPlaceholder: _propTypes2.default.string,
	  isWidgetOpen: _propTypes2.default.bool,
	  locale: _propTypes2.default.string,
	  maxDate: _propTypes3.isMaxDate,
	  maxDetail: _propTypes2.default.oneOf(allViews),
	  minDate: _propTypes3.isMinDate,
	  minuteAriaLabel: _propTypes2.default.string,
	  minutePlaceholder: _propTypes2.default.string,
	  monthAriaLabel: _propTypes2.default.string,
	  monthPlaceholder: _propTypes2.default.string,
	  name: _propTypes2.default.string,
	  nativeInputAriaLabel: _propTypes2.default.string,
	  onChange: _propTypes2.default.func,
	  required: _propTypes2.default.bool,
	  secondAriaLabel: _propTypes2.default.string,
	  secondPlaceholder: _propTypes2.default.string,
	  showLeadingZeros: _propTypes2.default.bool,
	  value: _propTypes2.default.oneOfType([isValue, _propTypes2.default.arrayOf(isValue)]),
	  yearAriaLabel: _propTypes2.default.string,
	  yearPlaceholder: _propTypes2.default.string
	};
	
	(0, _reactLifecyclesCompat.polyfill)(DateTimeInput);

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = NativeInput;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _dates = __webpack_require__(157);
	
	var _propTypes3 = __webpack_require__(109);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function NativeInput(_ref) {
	  var ariaLabel = _ref.ariaLabel,
	      disabled = _ref.disabled,
	      maxDate = _ref.maxDate,
	      minDate = _ref.minDate,
	      name = _ref.name,
	      onChange = _ref.onChange,
	      required = _ref.required,
	      value = _ref.value,
	      valueType = _ref.valueType;
	
	  var nativeValueParser = function () {
	    switch (valueType) {
	      case "hour":
	        return function (receivedValue) {
	          return (0, _dates.getISOLocalDate)(receivedValue) + "T" + (0, _dates.getHours)(receivedValue) + ":00";
	        };
	      case "minute":
	        return function (receivedValue) {
	          return (0, _dates.getISOLocalDate)(receivedValue) + "T" + (0, _dates.getHoursMinutes)(receivedValue);
	        };
	      case "second":
	        return _dates.getISOLocalDateTime;
	      default:
	        throw new Error("Invalid valueType.");
	    }
	  }();
	
	  var step = function () {
	    switch (valueType) {
	      case "hour":
	        return 3600;
	      case "minute":
	        return 60;
	      case "second":
	        return 1;
	      default:
	        throw new Error("Invalid valueType.");
	    }
	  }();
	
	  function stopPropagation(event) {
	    event.stopPropagation();
	  }
	
	  return _react2.default.createElement("input", {
	    type: "datetime-local",
	    "aria-label": ariaLabel,
	    disabled: disabled,
	    max: maxDate ? nativeValueParser(maxDate) : null,
	    min: minDate ? nativeValueParser(minDate) : null,
	    name: name,
	    onChange: onChange,
	    onFocus: stopPropagation,
	    required: required,
	    step: step,
	    style: {
	      visibility: "hidden",
	      position: "absolute",
	      top: "-9999px",
	      left: "-9999px"
	    },
	    value: value ? nativeValueParser(value) : ""
	  });
	}
	
	NativeInput.propTypes = {
	  ariaLabel: _propTypes2.default.string,
	  disabled: _propTypes2.default.bool,
	  maxDate: _propTypes3.isMaxDate,
	  minDate: _propTypes3.isMinDate,
	  name: _propTypes2.default.string,
	  onChange: _propTypes2.default.func,
	  required: _propTypes2.default.bool,
	  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.instanceOf(Date)]),
	  valueType: _propTypes3.isValueType
	};

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _slicedToArray = function () {
	  function sliceIterator(arr, i) {
	    var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
	      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
	        _arr.push(_s.value);if (i && _arr.length === i) break;
	      }
	    } catch (err) {
	      _d = true;_e = err;
	    } finally {
	      try {
	        if (!_n && _i["return"]) _i["return"]();
	      } finally {
	        if (_d) throw _e;
	      }
	    }return _arr;
	  }return function (arr, i) {
	    if (Array.isArray(arr)) {
	      return arr;
	    } else if (Symbol.iterator in Object(arr)) {
	      return sliceIterator(arr, i);
	    } else {
	      throw new TypeError("Invalid attempt to destructure non-iterable instance");
	    }
	  };
	}();
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactLifecyclesCompat = __webpack_require__(91);
	
	var _makeEventProps = __webpack_require__(403);
	
	var _makeEventProps2 = _interopRequireDefault(_makeEventProps);
	
	var _mergeClassNames = __webpack_require__(29);
	
	var _mergeClassNames2 = _interopRequireDefault(_mergeClassNames);
	
	var _reactFit = __webpack_require__(439);
	
	var _reactFit2 = _interopRequireDefault(_reactFit);
	
	var _entry = __webpack_require__(425);
	
	var _entry2 = _interopRequireDefault(_entry);
	
	var _entry3 = __webpack_require__(429);
	
	var _entry4 = _interopRequireDefault(_entry3);
	
	var _DateTimeInput = __webpack_require__(331);
	
	var _DateTimeInput2 = _interopRequireDefault(_DateTimeInput);
	
	var _propTypes3 = __webpack_require__(109);
	
	var _utils = __webpack_require__(158);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _objectWithoutProperties(obj, keys) {
	  var target = {};for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
	  }return target;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var allViews = ["hour", "minute", "second"];
	var baseClassName = "react-datetime-picker";
	var outsideActionEvents = ["mousedown", "focusin", "touchstart"];
	
	var DateTimePicker = function (_PureComponent) {
	  _inherits(DateTimePicker, _PureComponent);
	
	  function DateTimePicker() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, DateTimePicker);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DateTimePicker.__proto__ || Object.getPrototypeOf(DateTimePicker)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.onOutsideAction = function (event) {
	      if (_this.wrapper && !_this.wrapper.contains(event.target)) {
	        _this.closeWidgets();
	      }
	    }, _this.onDateChange = function (value) {
	      var closeWidgets = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	      var prevValue = _this.props.value;
	
	      if (prevValue) {
	        var valueWithHour = new Date(value);
	        valueWithHour.setHours(prevValue.getHours(), prevValue.getMinutes(), prevValue.getSeconds(), prevValue.getMilliseconds());
	
	        _this.onChange(valueWithHour, closeWidgets);
	      } else {
	        _this.onChange(value, closeWidgets);
	      }
	    }, _this.onChange = function (value) {
	      var closeWidgets = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	      _this.setState(function (prevState) {
	        return {
	          isCalendarOpen: prevState.isCalendarOpen && !closeWidgets,
	          isClockOpen: prevState.isClockOpen && !closeWidgets
	        };
	      });
	
	      var onChange = _this.props.onChange;
	
	      if (onChange) {
	        onChange(value);
	      }
	    }, _this.onFocus = function (event) {
	      var _this$props = _this.props,
	          disabled = _this$props.disabled,
	          onFocus = _this$props.onFocus;
	
	      if (onFocus) {
	        onFocus(event);
	      }
	
	      // Internet Explorer still fires onFocus on disabled elements
	      if (disabled) {
	        return;
	      }
	
	      switch (event.target.name) {
	        case "day":
	        case "month":
	        case "year":
	          _this.openCalendar();
	          break;
	        case "hour12":
	        case "hour24":
	        case "minute":
	        case "second":
	          _this.openClock();
	          break;
	        default:
	      }
	    }, _this.openClock = function () {
	      _this.setState({
	        isCalendarOpen: false,
	        isClockOpen: true
	      });
	    }, _this.openCalendar = function () {
	      _this.setState({
	        isCalendarOpen: true,
	        isClockOpen: false
	      });
	    }, _this.toggleCalendar = function () {
	      _this.setState(function (prevState) {
	        return {
	          isCalendarOpen: !prevState.isCalendarOpen,
	          isClockOpen: false
	        };
	      });
	    }, _this.closeWidgets = function () {
	      _this.setState(function (prevState) {
	        if (!prevState.isCalendarOpen && !prevState.isClockOpen) {
	          return null;
	        }
	
	        return {
	          isCalendarOpen: false,
	          isClockOpen: false
	        };
	      });
	    }, _this.stopPropagation = function (event) {
	      return event.stopPropagation();
	    }, _this.clear = function () {
	      return _this.onChange(null);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(DateTimePicker, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.handleOutsideActionListeners();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps, prevState) {
	      var _state = this.state,
	          isCalendarOpen = _state.isCalendarOpen,
	          isClockOpen = _state.isClockOpen;
	      var _props = this.props,
	          onCalendarClose = _props.onCalendarClose,
	          onCalendarOpen = _props.onCalendarOpen,
	          onClockClose = _props.onClockClose,
	          onClockOpen = _props.onClockOpen;
	
	      var isWidgetOpen = isCalendarOpen || isClockOpen;
	      var prevIsWidgetOpen = prevState.isCalendarOpen || prevState.isClockOpen;
	
	      if (isWidgetOpen !== prevIsWidgetOpen) {
	        this.handleOutsideActionListeners();
	      }
	
	      if (isCalendarOpen !== prevState.isCalendarOpen) {
	        (0, _utils.callIfDefined)(isCalendarOpen ? onCalendarOpen : onCalendarClose);
	      }
	
	      if (isClockOpen !== prevState.isClockOpen) {
	        (0, _utils.callIfDefined)(isClockOpen ? onClockOpen : onClockClose);
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.handleOutsideActionListeners(false);
	    }
	  }, {
	    key: "handleOutsideActionListeners",
	    value: function handleOutsideActionListeners(shouldListen) {
	      var _this2 = this;
	
	      var _state2 = this.state,
	          isCalendarOpen = _state2.isCalendarOpen,
	          isClockOpen = _state2.isClockOpen;
	
	      var isWidgetOpen = isCalendarOpen || isClockOpen;
	
	      var shouldListenWithFallback = typeof shouldListen !== "undefined" ? shouldListen : isWidgetOpen;
	      var fnName = shouldListenWithFallback ? "addEventListener" : "removeEventListener";
	      outsideActionEvents.forEach(function (eventName) {
	        return document[fnName](eventName, _this2.onOutsideAction);
	      });
	    }
	  }, {
	    key: "renderInputs",
	    value: function renderInputs() {
	      var _props2 = this.props,
	          amPmAriaLabel = _props2.amPmAriaLabel,
	          calendarAriaLabel = _props2.calendarAriaLabel,
	          calendarIcon = _props2.calendarIcon,
	          clearAriaLabel = _props2.clearAriaLabel,
	          clearIcon = _props2.clearIcon,
	          dayAriaLabel = _props2.dayAriaLabel,
	          dayPlaceholder = _props2.dayPlaceholder,
	          disableCalendar = _props2.disableCalendar,
	          disabled = _props2.disabled,
	          format = _props2.format,
	          hourAriaLabel = _props2.hourAriaLabel,
	          hourPlaceholder = _props2.hourPlaceholder,
	          locale = _props2.locale,
	          maxDate = _props2.maxDate,
	          maxDetail = _props2.maxDetail,
	          minDate = _props2.minDate,
	          minuteAriaLabel = _props2.minuteAriaLabel,
	          minutePlaceholder = _props2.minutePlaceholder,
	          monthAriaLabel = _props2.monthAriaLabel,
	          monthPlaceholder = _props2.monthPlaceholder,
	          name = _props2.name,
	          nativeInputAriaLabel = _props2.nativeInputAriaLabel,
	          required = _props2.required,
	          secondAriaLabel = _props2.secondAriaLabel,
	          secondPlaceholder = _props2.secondPlaceholder,
	          showLeadingZeros = _props2.showLeadingZeros,
	          value = _props2.value,
	          yearAriaLabel = _props2.yearAriaLabel,
	          yearPlaceholder = _props2.yearPlaceholder;
	      var _state3 = this.state,
	          isCalendarOpen = _state3.isCalendarOpen,
	          isClockOpen = _state3.isClockOpen;
	
	      var _concat = [].concat(value),
	          _concat2 = _slicedToArray(_concat, 1),
	          valueFrom = _concat2[0];
	
	      var ariaLabelProps = {
	        amPmAriaLabel: amPmAriaLabel,
	        dayAriaLabel: dayAriaLabel,
	        hourAriaLabel: hourAriaLabel,
	        minuteAriaLabel: minuteAriaLabel,
	        monthAriaLabel: monthAriaLabel,
	        nativeInputAriaLabel: nativeInputAriaLabel,
	        secondAriaLabel: secondAriaLabel,
	        yearAriaLabel: yearAriaLabel
	      };
	
	      var placeholderProps = {
	        dayPlaceholder: dayPlaceholder,
	        hourPlaceholder: hourPlaceholder,
	        minutePlaceholder: minutePlaceholder,
	        monthPlaceholder: monthPlaceholder,
	        secondPlaceholder: secondPlaceholder,
	        yearPlaceholder: yearPlaceholder
	      };
	
	      return _react2.default.createElement("div", { className: baseClassName + "__wrapper" }, _react2.default.createElement(_DateTimeInput2.default, _extends({}, ariaLabelProps, placeholderProps, {
	        className: baseClassName + "__inputGroup",
	        disabled: disabled,
	        format: format,
	        isWidgetOpen: isCalendarOpen || isClockOpen,
	        locale: locale,
	        maxDate: maxDate,
	        maxDetail: maxDetail,
	        minDate: minDate,
	        name: name,
	        onChange: this.onChange,
	        placeholder: this.placeholder,
	        required: required,
	        showLeadingZeros: showLeadingZeros,
	        value: valueFrom
	      })), clearIcon !== null && _react2.default.createElement("button", {
	        "aria-label": clearAriaLabel,
	        className: baseClassName + "__clear-button " + baseClassName + "__button",
	        disabled: disabled,
	        onClick: this.clear,
	        onFocus: this.stopPropagation,
	        type: "button"
	      }, clearIcon), calendarIcon !== null && !disableCalendar && _react2.default.createElement("button", {
	        "aria-label": calendarAriaLabel,
	        className: baseClassName + "__calendar-button " + baseClassName + "__button",
	        disabled: disabled,
	        onClick: this.toggleCalendar,
	        onFocus: this.stopPropagation,
	        onBlur: this.resetValue,
	        type: "button"
	      }, calendarIcon));
	    }
	  }, {
	    key: "renderCalendar",
	    value: function renderCalendar() {
	      var disableCalendar = this.props.disableCalendar;
	      var isCalendarOpen = this.state.isCalendarOpen;
	
	      if (isCalendarOpen === null || disableCalendar) {
	        return null;
	      }
	
	      var _props3 = this.props,
	          calendarClassName = _props3.calendarClassName,
	          dateTimePickerClassName = _props3.className,
	          dateTimePickerMaxDetail = _props3.maxDetail,
	          onChange = _props3.onChange,
	          value = _props3.value,
	          calendarProps = _objectWithoutProperties(_props3, ["calendarClassName", "className", "maxDetail", "onChange", "value"]);
	
	      var className = baseClassName + "__calendar";
	
	      return _react2.default.createElement(_reactFit2.default, null, _react2.default.createElement("div", {
	        className: (0, _mergeClassNames2.default)(className, className + "--" + (isCalendarOpen ? "open" : "closed"))
	      }, _react2.default.createElement(_entry2.default, _extends({
	        className: calendarClassName,
	        onChange: this.onDateChange,
	        value: value || null
	      }, calendarProps))));
	    }
	  }, {
	    key: "renderClock",
	    value: function renderClock() {
	      var disableClock = this.props.disableClock;
	      var isClockOpen = this.state.isClockOpen;
	
	      if (isClockOpen === null || disableClock) {
	        return null;
	      }
	
	      var _props4 = this.props,
	          clockClassName = _props4.clockClassName,
	          dateTimePickerClassName = _props4.className,
	          maxDetail = _props4.maxDetail,
	          onChange = _props4.onChange,
	          value = _props4.value,
	          clockProps = _objectWithoutProperties(_props4, ["clockClassName", "className", "maxDetail", "onChange", "value"]);
	
	      var className = baseClassName + "__clock";
	
	      var _concat3 = [].concat(value),
	          _concat4 = _slicedToArray(_concat3, 1),
	          valueFrom = _concat4[0];
	
	      var maxDetailIndex = allViews.indexOf(maxDetail);
	
	      return _react2.default.createElement(_reactFit2.default, null, _react2.default.createElement("div", {
	        className: (0, _mergeClassNames2.default)(className, className + "--" + (isClockOpen ? "open" : "closed"))
	      }, _react2.default.createElement(_entry4.default, _extends({
	        className: clockClassName,
	        renderMinuteHand: maxDetailIndex > 0,
	        renderSecondHand: maxDetailIndex > 1,
	        value: valueFrom
	      }, clockProps))));
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var _props5 = this.props,
	          className = _props5.className,
	          disabled = _props5.disabled;
	      var _state4 = this.state,
	          isCalendarOpen = _state4.isCalendarOpen,
	          isClockOpen = _state4.isClockOpen;
	
	      return _react2.default.createElement("div", _extends({
	        className: (0, _mergeClassNames2.default)(baseClassName, baseClassName + "--" + (isCalendarOpen || isClockOpen ? "open" : "closed"), baseClassName + "--" + (disabled ? "disabled" : "enabled"), className)
	      }, this.eventProps, {
	        onFocus: this.onFocus,
	        ref: function ref(_ref2) {
	          if (!_ref2) {
	            return;
	          }
	
	          _this3.wrapper = _ref2;
	        }
	      }), this.renderInputs(), this.renderCalendar(), this.renderClock());
	    }
	  }, {
	    key: "eventProps",
	    get: function get() {
	      return (0, _makeEventProps2.default)(this.props);
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps, prevState) {
	      var nextState = {};
	
	      if (nextProps.isCalendarOpen !== prevState.isCalendarOpenProps) {
	        nextState.isCalendarOpen = nextProps.isCalendarOpen;
	        nextState.isCalendarOpenProps = nextProps.isCalendarOpen;
	      }
	
	      if (nextProps.isClockOpen !== prevState.isClockOpenProps) {
	        nextState.isClockOpen = nextProps.isClockOpen;
	        nextState.isClockOpenProps = nextProps.isClockOpen;
	      }
	
	      return nextState;
	    }
	  }]);
	
	  return DateTimePicker;
	}(_react.PureComponent);
	
	exports.default = DateTimePicker;
	
	var iconProps = {
	  xmlns: "http://www.w3.org/2000/svg",
	  width: 19,
	  height: 19,
	  viewBox: "0 0 19 19",
	  stroke: "black",
	  strokeWidth: 2
	};
	
	var CalendarIcon = _react2.default.createElement("svg", _extends({}, iconProps, {
	  className: baseClassName + "__calendar-button__icon " + baseClassName + "__button__icon"
	}), _react2.default.createElement("rect", { width: "15", height: "15", x: "2", y: "2", fill: "none" }), _react2.default.createElement("line", { x1: "6", y1: "0", x2: "6", y2: "4" }), _react2.default.createElement("line", { x1: "13", y1: "0", x2: "13", y2: "4" }));
	
	var ClearIcon = _react2.default.createElement("svg", _extends({}, iconProps, {
	  className: baseClassName + "__clear-button__icon " + baseClassName + "__button__icon"
	}), _react2.default.createElement("line", { x1: "4", y1: "4", x2: "15", y2: "15" }), _react2.default.createElement("line", { x1: "15", y1: "4", x2: "4", y2: "15" }));
	
	DateTimePicker.defaultProps = {
	  calendarIcon: CalendarIcon,
	  clearIcon: ClearIcon,
	  isCalendarOpen: null,
	  isClockOpen: null,
	  maxDetail: "minute"
	};
	
	var isValue = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.instanceOf(Date)]);
	
	DateTimePicker.propTypes = {
	  amPmAriaLabel: _propTypes2.default.string,
	  calendarAriaLabel: _propTypes2.default.string,
	  calendarClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]),
	  calendarIcon: _propTypes2.default.node,
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]),
	  clearAriaLabel: _propTypes2.default.string,
	  clearIcon: _propTypes2.default.node,
	  clockClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]),
	  dayAriaLabel: _propTypes2.default.string,
	  dayPlaceholder: _propTypes2.default.string,
	  disableCalendar: _propTypes2.default.bool,
	  disableClock: _propTypes2.default.bool,
	  disabled: _propTypes2.default.bool,
	  format: _propTypes2.default.string,
	  hourAriaLabel: _propTypes2.default.string,
	  hourPlaceholder: _propTypes2.default.string,
	  isCalendarOpen: _propTypes2.default.bool,
	  isClockOpen: _propTypes2.default.bool,
	  locale: _propTypes2.default.string,
	  maxDate: _propTypes3.isMaxDate,
	  maxDetail: _propTypes2.default.oneOf(allViews),
	  minDate: _propTypes3.isMinDate,
	  minuteAriaLabel: _propTypes2.default.string,
	  minutePlaceholder: _propTypes2.default.string,
	  monthAriaLabel: _propTypes2.default.string,
	  monthPlaceholder: _propTypes2.default.string,
	  name: _propTypes2.default.string,
	  nativeInputAriaLabel: _propTypes2.default.string,
	  onCalendarClose: _propTypes2.default.func,
	  onCalendarOpen: _propTypes2.default.func,
	  onChange: _propTypes2.default.func,
	  onClockClose: _propTypes2.default.func,
	  onClockOpen: _propTypes2.default.func,
	  onFocus: _propTypes2.default.func,
	  required: _propTypes2.default.bool,
	  secondAriaLabel: _propTypes2.default.string,
	  secondPlaceholder: _propTypes2.default.string,
	  showLeadingZeros: _propTypes2.default.bool,
	  value: _propTypes2.default.oneOfType([isValue, _propTypes2.default.arrayOf(isValue)]),
	  yearAriaLabel: _propTypes2.default.string,
	  yearPlaceholder: _propTypes2.default.string
	};
	
	(0, _reactLifecyclesCompat.polyfill)(DateTimePicker);

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var Divider = function Divider(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement('span', { className: 'react-datetime-picker__inputGroup__divider' }, children);
	};
	
	Divider.propTypes = {
	  children: _propTypes2.default.node
	};
	
	exports.default = Divider;

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(908);
	
	__webpack_require__(909);
	
	var _DateTimePicker = __webpack_require__(333);
	
	var _DateTimePicker2 = _interopRequireDefault(_DateTimePicker);
	
	__webpack_require__(913);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	exports.default = _DateTimePicker2.default;
	
	// File is created during build phase and placed in dist directory
	// eslint-disable-next-line import/no-unresolved

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.formatDate = exports.getFormatter = undefined;
	
	var _getUserLocale = __webpack_require__(82);
	
	var _getUserLocale2 = _interopRequireDefault(_getUserLocale);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	/* eslint-disable import/prefer-default-export */
	
	var getFormatter = exports.getFormatter = function getFormatter(options) {
	  return function (locale, date) {
	    return date.toLocaleString(locale || (0, _getUserLocale2.default)(), options);
	  };
	};
	
	var formatDateOptions = { day: 'numeric', month: 'numeric', year: 'numeric' };
	var formatDate = exports.formatDate = getFormatter(formatDateOptions);

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(17);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRedux = __webpack_require__(9);
	
	var _reactRouter = __webpack_require__(36);
	
	var _configureStore = __webpack_require__(23);
	
	var _configureStore2 = _interopRequireDefault(_configureStore);
	
	var _routes = __webpack_require__(338);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	var _Firebase = __webpack_require__(10);
	
	var _Firebase2 = _interopRequireDefault(_Firebase);
	
	var _app = __webpack_require__(156);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	_reactDom2.default.render(_react2.default.createElement("div", null, _react2.default.createElement(_reactRedux.Provider, { store: _configureStore2.default }, _react2.default.createElement(_Firebase.FirebaseContext.Provider, { value: new _Firebase2.default() }, _react2.default.createElement(_reactRouter.Router, { history: _reactRouter.browserHistory, routes: _routes2.default }, _react2.default.createElement(_app.App2, null))))), document.getElementById("container"));
	
	// If you want your app to work offline and load faster, you can change
	// unregister() to register() below. Note this comes with some pitfalls.
	// Learn more about service workers: http://bit.ly/CRA-PWA
	//serviceWorker.register();
	
	// for bundling your styles
	// import "./bundle.scss";
	// console.log("starting...");
	// ReactDOM.render(
	//   <Provider store={configureStore}>
	//     <Router history={browserHistory} routes={routes} />
	//   </Provider>,
	//   document.querySelector(".react-root")
	// );
	
	// import React from 'react';
	// import ReactDOM from 'react-dom';
	// import { Provider } from 'react-redux';
	// import './index.css';
	
	// import store from "./store";
	// import App from "./components/App";

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(36);
	
	var _app = __webpack_require__(156);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _index_home = __webpack_require__(330);
	
	var _index_home2 = _interopRequireDefault(_index_home);
	
	var _login = __webpack_require__(151);
	
	var _login2 = _interopRequireDefault(_login);
	
	var _LandingPage = __webpack_require__(311);
	
	var _LandingPage2 = _interopRequireDefault(_LandingPage);
	
	var _Grocer = __webpack_require__(309);
	
	var _Grocer2 = _interopRequireDefault(_Grocer);
	
	var _Workers = __webpack_require__(321);
	
	var _Workers2 = _interopRequireDefault(_Workers);
	
	var _WorkerSecure = __webpack_require__(320);
	
	var _WorkerSecure2 = _interopRequireDefault(_WorkerSecure);
	
	var _SupplierAdmin = __webpack_require__(319);
	
	var _SupplierAdmin2 = _interopRequireDefault(_SupplierAdmin);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	exports.default = _react2.default.createElement(_reactRouter.Route, { path: "/", component: _app2.default }, _react2.default.createElement(_reactRouter.IndexRoute, { component: _index_home2.default }), _react2.default.createElement(_reactRouter.Route, { path: "/landingPage", component: _LandingPage2.default }), _react2.default.createElement(_reactRouter.Route, { path: "/rajdhani", component: _Grocer2.default }), _react2.default.createElement(_reactRouter.Route, { path: "/zara", component: _Grocer2.default }), _react2.default.createElement(_reactRouter.Route, { path: "/tanmoy", component: _Grocer2.default }), _react2.default.createElement(_reactRouter.Route, { path: "/supplier4", component: _Grocer2.default }), _react2.default.createElement(_reactRouter.Route, { path: "/supplier5", component: _Grocer2.default }), _react2.default.createElement(_reactRouter.Route, { path: "/workers", component: _Workers2.default }), _react2.default.createElement(_reactRouter.Route, { path: "/workersecure", component: _WorkerSecure2.default }), _react2.default.createElement(_reactRouter.Route, { path: "/login", component: _login2.default }), _react2.default.createElement(_reactRouter.Route, { path: "/supplieradmin", component: _SupplierAdmin2.default }));

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = dbAddRecord;
	
	var _utils = __webpack_require__(79);
	
	var _configureStore = __webpack_require__(23);
	
	var _configureStore2 = _interopRequireDefault(_configureStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function dbAddRecord(data, idToken) {
	  var state = _configureStore2.default.getState();
	  var fbDbUrl = state.db.team.fbDbUrl;
	  var fbCloudUrl = state.db.team.fbCloudUrl;
	  return function (dispatch) {
	    var fetchQuery = fbDbUrl + "/" + data.path + ".json";
	    fetchQuery = fetchQuery + "?auth=" + idToken;
	
	    //logger("DEBUG","dbAddRecord(data)", "Adding record to DB: "+fetchQuery+" | "+JSON.stringify(data.payload));
	    return fetch(fetchQuery, {
	      method: "POST",
	      body: JSON.stringify(data.payload)
	    }).then(function (res) {
	      return res.json();
	    }).then(function (parsedRes) {
	      //logger("DEBUG","dbAddRecord(data)", "Upload to firebase successful " + parsedRes.name);
	      return parsedRes.name;
	    }).catch(function (err) {
	      (0, _utils.logger)("BASIC", "dbAddRecord(data)", "Add project unsuccessful -> " + err);
	      alert("We are unable to complete your request at this time, please check your network connection or contact support.[dbAddRecord" + data.path + "][" + err + "]");
	      //console.log("We are unable to complete your request at this time, please check your network connection or contact support.[dbAddRecord"+data.path+"]["+err+"]");
	    });
	  };
	}

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = dbDeleteRecord;
	
	var _configureStore = __webpack_require__(23);
	
	var _configureStore2 = _interopRequireDefault(_configureStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function dbDeleteRecord(data, idToken) {
	  //console.log(JSON.stringify(data));
	  return function (dispatch) {
	    var state = _configureStore2.default.getState();
	    var fbDbUrl = state.db.team.fbDbUrl;
	    var fbCloudUrl = state.db.team.fbCloudUrl;
	    //logger("DEBUG", "dbDeleteRecord(data)", "Deleting task from DB" + data.payload.key);
	
	    var fetchQuery = fbDbUrl + "/" + data.path + "/" + data.payload.key + ".json";
	    fetchQuery = fetchQuery + "?auth=" + idToken;
	
	    return fetch(fetchQuery, {
	      method: "DELETE"
	    }).then(function (res) {
	      return res.json();
	    }).then(function (parsedRes) {
	      //logger("DEBUG", "dbDeleteRecord(data)", "Delete from DB successful "+JSON.stringify(parsedRes));
	      return "Success";
	    }).catch(function (err) {
	      //logger("BASIC", "dbDeleteRecord(data)", "Delete record unsuccessful -> " + err);
	      alert("We are unable to complete your request at this time, please check your network connection or contact support.[delete]");
	      //console.log("We are unable to complete your request at this time, please check your network connection or contact support.[delete]");
	    });
	  };
	}

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = dbGetAutoId;
	
	var _configureStore = __webpack_require__(23);
	
	var _configureStore2 = _interopRequireDefault(_configureStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function dbGetAutoId(targetTable, idToken) {
	  return function (dispatch) {
	    //console.log("requeting id now");
	    var state = _configureStore2.default.getState();
	    var fbDbUrl = state.db.team.fbDbUrl;
	    var fbCloudUrl = state.db.team.fbCloudUrl;
	    var fetchQuery = "";
	
	    fetchQuery = fbCloudUrl + "/getAutoId";
	    //console.log("getID URL: " + fetchQuery);
	    return fetch(fetchQuery, {
	      method: "POST",
	      body: JSON.stringify({ path: targetTable }),
	      headers: {
	        authorization: "Bearer " + idToken
	      }
	    }).then(function (res) {
	      return res.json();
	    }).then(function (parsedRes) {
	      //console.log("returning this from fb: " + JSON.stringify(parsedRes));
	      return parsedRes;
	    }).catch(function (err) {
	      console.log("[RECS] dbGetId(" + targetTable + "). We are unable to complete your request at this time, please check your network connection or contact support[getRecord][" + err + "]");
	    });
	  };
	}

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = dbGetRecords;
	
	var _configureStore = __webpack_require__(23);
	
	var _configureStore2 = _interopRequireDefault(_configureStore);
	
	var _actions = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function dbGetRecords(targetTable, idToken, criteria, isCustomPath, fieldsArray) {
	  return function (dispatch) {
	    //let fetchQuery = "https://brooklynzdev.firebaseio.com/";
	    var state = _configureStore2.default.getState();
	
	    var fbDbUrl = state.db.team.fbDbUrl;
	    var fbCloudUrl = state.db.team.fbCloudUrl;
	    var fetchQuery = "";
	    if (isCustomPath === true) {
	      //console.log(targetTable+' this is custom path')
	      fetchQuery = fbCloudUrl + "/" + targetTable;
	    } else {
	      //console.log(targetTable+' this is NOT custom path')
	      fetchQuery = fbCloudUrl + "/getRecordsLight";
	    }
	    //console.log("Fetching records, "+targetTable+", criteria :"+JSON.stringify(criteria)+" fetchURL: "+fetchQuery);
	    //fetchQuery= fetchQuery+targetTable+".json?";
	    var requestBody = {};
	    if (isCustomPath === true) {
	      requestBody = criteria;
	    } else {
	      if (criteria === undefined) {
	        requestBody = {
	          path: targetTable
	        };
	      } else {
	        if (fieldsArray && fieldsArray !== undefined) {
	          requestBody = {
	            path: targetTable,
	            criteria: criteria,
	            requiredFields: fieldsArray
	          };
	        } else {
	          requestBody = {
	            path: targetTable,
	            criteria: criteria
	          };
	        }
	      }
	    }
	
	    //logger("DEBUG","dbGetRecords("+targetTable+")", ">>request: "+JSON.stringify(requestBody));
	
	    return fetch(fetchQuery, {
	      method: "POST",
	      body: JSON.stringify(requestBody),
	      headers: {
	        authorization: "Bearer " + idToken
	      }
	    }).then(function (res) {
	      return res.json();
	    }).then(function (parsedRes) {
	      //logger("DEBUG","dbGetRecords("+targetTable+")", "Fetching all "+targetTable+"  successful");
	      //logger("DEBUG","dbGetRecords("+targetTable+")", "Results: " + JSON.stringify(parsedRes));
	      return parsedRes;
	    }).catch(function (err) {
	      //logger("BASIC","dbGetRecords("+targetTable+")"+ "Fetch projects from db failed "+err);
	      dispatch((0, _actions.uiStopLoading)());
	      alert("[RECS] dbGetRecords(" + targetTable + "). We are unable to complete your request at this time, please check your network connection or contact support[getRecord][" + err + "]");
	      //console.log("[RECS]We are unable to complete your request at this time, please check your network connection or contact support[getRecord]["+err+"]");
	    });
	  };
	}

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = dbUpdateRecord;
	
	var _utils = __webpack_require__(79);
	
	var _configureStore = __webpack_require__(23);
	
	var _configureStore2 = _interopRequireDefault(_configureStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function dbUpdateRecord(data, idToken) {
	  return function (dispatch) {
	    var state = _configureStore2.default.getState();
	    var fbDbUrl = state.db.team.fbDbUrl;
	    var fbCloudUrl = state.db.team.fbCloudUrl;
	
	    var fetchQuery = fbDbUrl + "/" + data.path + ".json";
	    fetchQuery = fetchQuery + "?auth=" + idToken;
	    return fetch(fetchQuery, {
	      method: "PATCH",
	      body: (0, _utils.convert2FirebaseJson)(data.payload)
	    }).then(function (res) {
	      return res.json();
	    }).then(function (parsedRes) {
	      console.log(JSON.stringify(parsedRes));
	      (0, _utils.logger)("DEBUG", "dbUpdateRecord(data)", "Updating record successful -> " + JSON.stringify(parsedRes));
	      return parsedRes.key;
	    }).catch(function (err) {
	      (0, _utils.logger)("DEBUG", "dbUpdateRecord(data)", "Record update failed -> " + err);
	      alert("---We are unable to complete your request at this time, please check your network connection or contact support[dbUpdate]");
	      console.log("---We are unable to complete your request at this time, please check your network connection or contact support[dbUpdate]");
	    });
	  };
	}

/***/ }),
/* 344 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getDistance;
	//https://maps.googleapis.com/maps/api/distancematrix/json?units=imperial&origins=HyMW%2BWP%20Kolkata%20India&destinations=GCG2%2B3M%20Kolkata%20India&key=AIzaSyDWHwImfa_wQA1w43SUupEvSxo8eCfnUPo
	
	function getDistance(origin, destination) {
	  return function (dispatch) {
	    var fbCloudUrl = "https://maps.googleapis.com/maps/api/distancematrix/json?units=imperial&";
	
	    var og = "origins=" + encodeURIComponent(origin);
	    var dst = "destinations=" + encodeURIComponent(destination);
	
	    var fetchQuery = fbCloudUrl + og + "&" + dst + "&key=AIzaSyDWHwImfa_wQA1w43SUupEvSxo8eCfnUPo";
	    return fetch(fetchQuery, {
	      method: "GET"
	    }).then(function (res) {
	      return res.json();
	    }).then(function (parsedRes) {
	      return parsedRes;
	    }).catch(function (err) {
	      console.log("Could not fetch distance" + err);
	    });
	  };
	}

/***/ }),
/* 345 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getFbRtData;
	function getFbRtData(tgtUrl, accessToken) {
	  return function (dispatch) {
	    var url = tgtUrl + "?auth=" + accessToken;
	    return fetch(url, {
	      method: "GET"
	    }).then(function (res) {
	      //console.log(res);
	      return res.json();
	    }).then(function (parsedRes) {
	      return parsedRes;
	    }).catch(function (err) {
	      console.log(" db initial load s1 " + err);
	    });
	  };
	}

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.sendNotificationToASegment = undefined;
	
	var _utils = __webpack_require__(79);
	
	var sendNotificationToASegment = exports.sendNotificationToASegment = function sendNotificationToASegment(objContents, userSegment) {
	  var headers = {
	    "Content-Type": "application/json; charset=utf-8",
	    Authorization: "Basic ODU5NDBhNGItYzM2Mi00NDAzLTgyMjYtZTdiZjgzNjk5ZGI2"
	  };
	
	  if (window.location.hostname !== "app.brooklynzcommunitysupport.com") {
	    console.log("skipping notifications: " + JSON.stringify(objContents) + " /n" + JSON.stringify(userSegment));
	    return "";
	  }
	
	  var message = {
	    app_id: "0d38dda0-5c2d-45f3-91f5-1ffcf292104b",
	    contents: objContents,
	    //include_external_user_ids: ["ahmed_fayyaz@outlook.com"]
	    included_segments: userSegment
	  };
	
	  //alert(JSON.stringify(arrExternalUserIds));
	  var fetchQuery = "https://onesignal.com:443/api/v1/notifications";
	
	  //logger("DEBUG","dbAddRecord(data)", "Adding record to DB: "+fetchQuery+" | "+JSON.stringify(data.payload));
	  fetch(fetchQuery, {
	    method: "POST",
	    body: JSON.stringify(message),
	    headers: headers
	  }).then(function (res) {
	    return res.json();
	  }).then(function (parsedRes) {
	    //logger("DEBUG","dbAddRecord(data)", "Upload to firebase successful " + parsedRes.name);
	    //alert(JSON.stringify(parsedRes));
	  }).catch(function (err) {
	    (0, _utils.logger)("BASIC", "sendNotification(data)", "Send notification was unsuccessful -> " + err);
	    alert("We are unable to complete your request at this time, please check your network connection or contact support.[sendNotification]");
	    //console.log("We are unable to complete your request at this time, please check your network connection or contact support.[dbAddRecord"+data.path+"]["+err+"]");
	  });
	};

/***/ }),
/* 347 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var sendSingleUserANotification = exports.sendSingleUserANotification = function sendSingleUserANotification(objContents, arrExternalUserIds) {
	  // alert(
	  //   JSON.stringify(objContents) +
	  //     " ID LIST: " +
	  //     JSON.stringify(arrExternalUserIds)
	  // );
	  // return "";
	
	  if (window.location.hostname !== "app.brooklynzcommunitysupport.com") {
	    console.log("skipping notifications: " + JSON.stringify(objContents) + " \n" + JSON.stringify(arrExternalUserIds));
	    return "";
	  }
	
	  var headers = {
	    "Content-Type": "application/json; charset=utf-8",
	    Authorization: "Basic ODU5NDBhNGItYzM2Mi00NDAzLTgyMjYtZTdiZjgzNjk5ZGI2"
	  };
	
	  var message = {
	    app_id: "0d38dda0-5c2d-45f3-91f5-1ffcf292104b",
	    contents: objContents,
	    include_external_user_ids: arrExternalUserIds
	  };
	
	  //alert(JSON.stringify(arrExternalUserIds));
	  var fetchQuery = "https://onesignal.com:443/api/v1/notifications";
	
	  //logger("DEBUG","dbAddRecord(data)", "Adding record to DB: "+fetchQuery+" | "+JSON.stringify(data.payload));
	  fetch(fetchQuery, {
	    method: "POST",
	    body: JSON.stringify(message),
	    headers: headers
	  }).then(function (res) {
	    return res.json();
	  }).then(function (parsedRes) {
	    //logger("DEBUG","dbAddRecord(data)", "Upload to firebase successful " + parsedRes.name);
	  }).catch(function (err) {
	    if (err !== "") {
	      alert("We are unable to complete your request at this time, please check your network connection or contact support.[sendNotification]" + err);
	    }
	  });
	};

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = dbGetStatement;
	
	var _configureStore = __webpack_require__(23);
	
	var _configureStore2 = _interopRequireDefault(_configureStore);
	
	var _path = __webpack_require__(178);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	//https://aymvqol5ch.execute-api.us-east-1.amazonaws.com/default/genPdfB64
	
	function dbGetStatement(templatID, jsonData) {
	  console.log("about to do a fetch with this: ||" + JSON.stringify(jsonData));
	  return function (dispatch) {
	    // const state = configureStore.getState();
	    // let fbDbUrl = state.db.team.fbDbUrl;
	    // let fbCloudUrl = state.db.team.fbCloudUrl;
	    // let fetchQuery = "";
	
	    var headersObj = _defineProperty({}, "Content-Type", "application/json; charset=utf-8");
	
	    var fetchQuery = "https://oj9p2ekyv7.execute-api.us-east-1.amazonaws.com/default/generatepdf-dev-generatepdf";
	    //console.log("getStatement URL: " + fetchQuery);
	
	    return fetch(fetchQuery, {
	      method: "POST",
	      body: JSON.stringify({ template: templatID, data: jsonData }),
	      headers: headersObj
	    }).then(function (res) {
	      return res.json();
	    }).then(function (parsedRes) {
	      // console.log(
	      //   "returning this from pdf genertor: " + JSON.stringify(parsedRes)
	      // );
	      return parsedRes;
	    }).catch(function (err) {
	      console.log("error occured: " + err);
	      alert("[RECS] dbGetId(" + targetTable + "). We are unable to complete your request at this time, please check your network connection or contact support[getRecord][" + err + "]");
	    });
	  };
	}

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = dbGetStatementB64;
	
	var _configureStore = __webpack_require__(23);
	
	var _configureStore2 = _interopRequireDefault(_configureStore);
	
	var _path = __webpack_require__(178);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function dbGetStatementB64(templatID, jsonData, mailParams) {
	  return function (dispatch) {
	    // const state = configureStore.getState();
	    // let fbDbUrl = state.db.team.fbDbUrl;
	    // let fbCloudUrl = state.db.team.fbCloudUrl;
	    // let fetchQuery = "";
	
	    var headersObj = _defineProperty({}, "Content-Type", "application/json; charset=utf-8");
	
	    var fetchQuery = "https://aymvqol5ch.execute-api.us-east-1.amazonaws.com/default";
	    //console.log("getStatement URL: " + fetchQuery);
	
	    var msgBody = {};
	    if (templatID !== undefined && jsonData !== undefined) {
	      msgBody = {
	        pdfParams: { template: templatID, data: jsonData },
	        mailParams: mailParams
	      };
	    } else {
	      msgBody = {
	        mailParams: mailParams
	      };
	    }
	
	    return fetch(fetchQuery, {
	      method: "POST",
	      body: JSON.stringify(msgBody),
	      headers: headersObj
	    }).then(function (res) {
	      return res.json();
	    }).then(function (parsedRes) {
	      // console.log(
	      //   "returning this from pdf genertor: " + JSON.stringify(parsedRes)
	      // );
	      return parsedRes;
	    }).catch(function (err) {
	      console.log("error occured: " + err);
	      alert("[RECS] dbGetId(" + targetTable + "). We are unable to complete your request at this time, please check your network connection or contact support[getRecord][" + err + "]");
	    });
	  };
	}

/***/ }),
/* 350 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var staticDb = exports.staticDb = {
	  taskExtendedStatus: [{
	    statusName: "ASSIGNED",
	    key: "ASSIGNED",
	    statusId: "ASSIGNED"
	  }, {
	    statusName: "COMPLETED",
	    key: "COMPLETED",
	    statusId: "COMPLETED"
	  }, {
	    statusName: "DEFERRED",
	    key: "DEFERRED",
	    statusId: "DEFERRED"
	  }, {
	    statusName: "DELAYED",
	    key: "DELAYED",
	    statusId: "DELAYED"
	  }, {
	    statusName: "UPCOMING",
	    key: "UPCOMING",
	    statusId: "UPCOMING"
	  }],
	  expiredToken: "",
	  statsAllTasks: {
	    path: "statsAllTasks",
	    queryObj: {
	      path: "tasks",
	      criteria: {
	        andArray: [],
	        orArray: []
	      },
	      statQuery: {
	        path: "tasks",
	        targetOperation: "COUNT",
	        groupBy: "taskStatus"
	      }
	    }
	  },
	  statsMyTasks: {
	    path: "statsMyTasks",
	    queryObj: {
	      path: "tasks",
	      criteria: {
	        andArray: [],
	        orArray: []
	      },
	      statQuery: {
	        path: "tasks",
	        targetOperation: "COUNT",
	        groupBy: "taskStatus"
	      }
	    }
	  },
	  statsAllProjects: {
	    path: "statsAllProjects",
	    queryObj: {
	      path: "projects",
	      criteria: {},
	      statQuery: {
	        path: "projects",
	        targetOperation: "COUNT",
	        groupBy: "projectPhase"
	      }
	    }
	  },
	  statsAllProjectQuotes: {
	    path: "statsAllProjectQuotes",
	    queryObj: {
	      path: "projectQuotes",
	      criteria: {},
	      statQuery: {
	        path: "projectQuotes",
	        targetOperation: "SUM",
	        sumField: "totalAmount"
	      }
	    }
	  },
	  statsAllProjectInvoices: {
	    path: "statsAllProjectInvoices",
	    queryObj: {
	      path: "tasks",
	      criteria: {},
	      statQuery: {
	        path: "projectInvoices",
	        targetOperation: "SUM",
	        sumField: "totalInvoice",
	        groupBy: "invoiceStatus"
	      }
	    }
	  },
	  statsAllAttendance: {
	    path: "statsAllProjectInvoices",
	    queryObj: {
	      path: "tasks",
	      criteria: {},
	      statQuery: {
	        path: "projectInvoices",
	        targetOperation: "SUM",
	        sumField: "totalInvoice",
	        groupBy: "invoiceStatus"
	      }
	    }
	  },
	  reportings: [{
	    displayName: "ATTENDANCE",
	    tableName: "attendance",
	    groupBy: [{ displayName: "PROJECT", fieldName: "projectName" }, { displayName: "MONTH", fieldName: "month" }, { displayName: "EMPLOYEE", fieldName: "employeeName" }],
	    subGroupBy: [{ displayName: "PROJECT", fieldName: "projectName" }, { displayName: "MONTH", fieldName: "month" }, { displayName: "EMPLOYEE", fieldName: "employeeName" }],
	    sumFields: [{ displayName: "OT HOURS", fieldName: "otHours" }, { displayName: "WEEKDAYS", fieldName: "weekdays" }, { displayName: "SUNDAYS", fieldName: "sundays" }, { displayName: "PUBLIC HOLIDAYS", fieldName: "phDays" }],
	    filters: [{ displayName: "MONTHS", fieldName: "month" }, { displayName: "PROJECT", fieldName: "projectName" }, { displayName: "EMPLOYEE", fieldName: "employeeName" }],
	    show: {
	      gb: true,
	      sgb: true,
	      months: true,
	      projects: true,
	      employee: true
	    }
	  }, {
	    displayName: "PURCHASE ORDERS",
	    tableName: "projectPos",
	    groupBy: [{ displayName: "PROJECT", fieldName: "projectName" }, { displayName: "MONTH", fieldName: "month" }],
	    subGroupBy: [{ displayName: "PROJECT", fieldName: "projectName" }, { displayName: "MONTH", fieldName: "month" }],
	    sumFields: [{ displayName: "PO TOTAL", fieldName: "poAmount" }],
	    filters: [{ displayName: "MONTHS", fieldName: "month" }, { displayName: "PROJECT", fieldName: "projectName" }],
	    show: {
	      gb: true,
	      sgb: true,
	      months: true,
	      projects: true,
	      employee: false
	    }
	  }, {
	    displayName: "INVOICES",
	    tableName: "projectInvoices",
	    groupBy: [{ displayName: "PROJECT", fieldName: "projectName" }, { displayName: "MONTH", fieldName: "month" }],
	    subGroupBy: [{ displayName: "PROJECT", fieldName: "projectName" }, { displayName: "MONTH", fieldName: "month" }],
	    sumFields: [{ displayName: "INVOICE TOTAL", fieldName: "totalInvoice" }],
	    filters: [{ displayName: "MONTHS", fieldName: "month" }, { displayName: "PROJECT", fieldName: "projectName" }],
	    show: {
	      gb: true,
	      sgb: true,
	      months: true,
	      projects: true,
	      employee: false
	    }
	  }],
	  reports: {
	    reportName: "test report",
	    displayName: "ATTENDANCE",
	    tableName: "attendance",
	    selectedGroupBy: [{ displayName: "MONTH", fieldName: "month" }],
	    SelectedSubGroupBy: [],
	    selectedSumFields: [{ displayName: "OT HOURS", fieldName: "otHours" }],
	    selectedFilters: [{
	      displayName: "PROJECT",
	      fieldName: "projectName",
	      values: ["abc"]
	    }]
	  },
	  createFields: {
	    key: "",
	    name: "",
	    lastAction: "",
	    updateDateTime: "",
	    createDateTime: "",
	    author: ""
	  },
	  createTable: {
	    key: "",
	    name: "",
	    lastAction: "",
	    updateDateTime: "",
	    createDateTime: "",
	    author: ""
	  },
	  listOfTables: {
	    key: "",
	    name: "",
	    caption: "",
	    menu: "",
	    updateDateTime: "",
	    createDateTime: "",
	    author: ""
	  },
	  menuDesigner: {
	    name: "",
	    menuItems: [""]
	  }
	};

/***/ }),
/* 351 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var localState0 = exports.localState0 = {
	  prodAdmin: {
	    hostname: "localhost",
	    phoneNumber: "04065662",
	    login: "ahmed_fayyaz@outlook.com",
	    password: "p123456",
	    envName: "prod"
	  },
	  prodStore: {
	    hostname: "localhost",
	    phoneNumber: "94562450",
	    login: "supp1@bcs.com",
	    password: "p123456",
	    envName: "prod"
	  },
	  prodWorker: {
	    hostname: "localhost",
	    phoneNumber: "97861234",
	    login: "",
	    password: "",
	    envName: "prod"
	  },
	  prodBlank: {
	    hostname: "localhost2",
	    phoneNumber: "",
	    login: "",
	    password: "",
	    envName: "prod"
	  },
	  devAdmin: {
	    hostname: "localhost",
	    phoneNumber: "04065662",
	    login: "ahmed_fayyaz@outlook.com",
	    password: "p123456",
	    envName: "dev"
	  },
	  devStore: {
	    hostname: "localhost",
	    phoneNumber: "00002450",
	    login: "supp1@bcs.com",
	    password: "devpass",
	    envName: "dev"
	  },
	  devWorker: {
	    hostname: "localhost",
	    phoneNumber: "98761234",
	    login: "ismita@bcs.com.sg",
	    password: "p123456",
	    envName: "dev"
	  },
	  devBlank: {
	    hostname: "localhost",
	    phoneNumber: "",
	    login: "",
	    password: "",
	    envName: "dev"
	  }
	};

/***/ }),
/* 352 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var tCreateTable = exports.tCreateTable = [{
	  caption: "INVENTORY",
	  createNotifyText: "",
	  dashColumns: ["product", "unit", "quantity", "purchasePrice"],
	  deleteNotifyText: "",
	  fields: [{
	    caption: "PURCHASE DATE",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    dateFormat: "dd-MM-yyyy",
	    dateFormatOut: "DD-MM-YYYY",
	    dateMaxDetail: "day",
	    enabled: "true",
	    expanded: false,
	    name: "purchaseDate",
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "calendar"
	  }, {
	    caption: "PRODUCT",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    enabled: "true",
	    expanded: false,
	    isMust: "true",
	    name: "product",
	    otherFieldsToUpdate: [{ src: "unit", tgt: "unit" }, { src: "photos", tgt: "photos" }],
	    selectorType: "table",
	    staticSource: [{ name: "" }],
	    table: "supplierShopItems",
	    tableField: "productNameEnglish",
	    type: "search"
	  }, {
	    caption: "UNIT",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    expanded: false,
	    name: "unit",
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "input"
	  }, {
	    caption: "PHOTOS",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    enabled: "false",
	    expanded: true,
	    name: "photos",
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "photoUpload"
	  }, {
	    caption: "QUANTITY",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    expanded: false,
	    name: "quantity",
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "input"
	  }, {
	    caption: "PURCHASE PRICE",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    expanded: false,
	    name: "purchasePrice",
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "input"
	  }],
	  key: "-MESPxTvKu3mKREwBQCB",
	  menu: "INVENTORY",
	  name: "inventory",
	  searchColumns: ["product", "unit", "quantity"],
	  updateNotifyText: ""
	}, {
	  caption: "PURCHASE",
	  createNotifyText: "",
	  dashColumns: ["date", "receiptAmount", "supplierPurchase", "sellAmount", "cashToShoper", "dayEndCashReturn", "notes", "photos"],
	  deleteNotifyText: "",
	  fields: [{
	    caption: "DATE",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    dateFormat: "dd-MM-yyyy",
	    dateFormatOut: "DD-MM-YYYY",
	    dateMaxDetail: "day",
	    defaultValue: "currentDate",
	    enabled: "true",
	    expanded: false,
	    isMust: "true",
	    name: "date",
	    otherFieldsToUpdate: [{ src: "", tgt: "" }],
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "calendar"
	  }, {
	    caption: "EXTERNAL PURCHASE",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    enabled: "true",
	    expanded: false,
	    isMust: "true",
	    name: "receiptAmount",
	    otherFieldsToUpdate: [{ src: "", tgt: "" }],
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "input"
	  }, {
	    caption: "WHOLE SALE PURCHASE",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    enabled: "true",
	    expanded: false,
	    name: "supplierPurchase",
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "input"
	  }, {
	    caption: "SELL AMOUNT",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    expanded: false,
	    name: "sellAmount",
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "input"
	  }, {
	    caption: "CASH RECIEVED SHOPPER",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    expanded: false,
	    name: "cashToShoper",
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "input"
	  }, {
	    caption: "CASH RETURNED BY SHOPPER",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    enabled: "true",
	    expanded: false,
	    name: "dayEndCashReturn",
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "input"
	  }, {
	    caption: "PAID ONLINE",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    expanded: false,
	    name: "onlinePayments",
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "input"
	  }, {
	    caption: "NOTES",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    enabled: "true",
	    expanded: false,
	    isMust: "false",
	    name: "notes",
	    numOfLines: "8",
	    otherFieldsToUpdate: [{ src: "", tgt: "" }],
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "textarea"
	  }, {
	    caption: "REC PHOTOS",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    expanded: false,
	    name: "photos",
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "photoUpload"
	  }],
	  key: "-MAt7wR8fQGN1dloefzz",
	  menu: "PURCHASE",
	  name: "purchase",
	  searchColumns: ["date", "receiptAmount", "notes"],
	  updateNotifyText: ""
	}, {
	  caption: "SOURCE SUPPLIER",
	  createNotifyText: "",
	  dashColumns: ["name", "phone", "address"],
	  deleteNotifyText: "",
	  fields: [{
	    caption: "NAME",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    enabled: "true",
	    expanded: false,
	    isMust: "true",
	    name: "name",
	    otherFieldsToUpdate: [{ src: "", tgt: "" }],
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "input"
	  }, {
	    caption: "PHONE",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    enabled: "true",
	    expanded: false,
	    isMust: "true",
	    name: "phone",
	    otherFieldsToUpdate: [{ src: "", tgt: "" }],
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "input"
	  }, {
	    caption: "ADDRESS",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    enabled: "true",
	    expanded: false,
	    isMust: "true",
	    name: "address",
	    numOfLines: "3",
	    otherFieldsToUpdate: [{ src: "", tgt: "" }],
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "textarea"
	  }, {
	    caption: "BCS SHOP",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    expanded: false,
	    name: "bcsShop",
	    selectorType: "table",
	    staticSource: [{ name: "DRY FOOD" }, { name: "GARMENTS" }, { name: "FRESH PRODUCE" }, { name: "" }],
	    table: "users",
	    tableField: "userCompany",
	    type: "search"
	  }],
	  menu: "SOURCE SUPPLIR",
	  name: "sourceSupplier",
	  searchColumns: ["name", "phone", "address"],
	  updateNotifyText: "",
	  key: "-M9wSYF2FUW-5LK_09dm"
	}, {
	  caption: "APP PHOTOS",
	  createNotifyText: "",
	  dashColumns: ["name", "photos"],
	  deleteNotifyText: "",
	  fields: [{
	    caption: "NAME",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    expanded: false,
	    name: "name",
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "input"
	  }, {
	    caption: "PHOTOS URL",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    expanded: false,
	    name: "photos",
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "input"
	  }, {
	    caption: "PHOTOS",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    enabled: "true",
	    expanded: false,
	    isMust: "true",
	    name: "photos",
	    otherFieldsToUpdate: [{ src: "", tgt: "" }],
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "photoUpload"
	  }],
	  key: "-M9rtsy6Ywpm7MhVYuGo",
	  menu: "APP PHOTOS",
	  name: "appPhotos",
	  searchColumns: ["name"],
	  updateNotifyText: ""
	}, {
	  caption: "SUPPLIER",
	  createNotifyText: "",
	  deleteNotifyText: "",
	  menu: "SUPPLIER",
	  name: "dqr",
	  updateNotifyText: "",
	  key: "-M97w7qNguBWJr0YGfkZ"
	}, {
	  caption: "OPEN BAZAR",
	  createNotifyText: "",
	  dashColumns: ["title", "message", "photos"],
	  deleteNotifyText: "",
	  fields: [{
	    caption: "YOUR NAME",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    expanded: false,
	    isMust: "true",
	    name: "name",
	    placeholder: "YOUR NAME",
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "input"
	  }, {
	    caption: "TITLE",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    enabled: "true",
	    expanded: false,
	    isMust: "true",
	    name: "title",
	    otherFieldsToUpdate: [{ src: "", tgt: "" }],
	    placeholder: "SUBJECT OR TITLE",
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "input"
	  }, {
	    caption: "MESSAGE TYPE",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    defaultValue: "SELLING",
	    expanded: false,
	    name: "messageType",
	    placeholder: "10",
	    selectorType: "static",
	    staticSource: [{ name: "GENERAL MESSAGE" }, { name: "SELLING" }, { name: "BUYING" }],
	    type: "search"
	  }, {
	    caption: "PRICE",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    defaultValue: "",
	    expanded: false,
	    name: "price",
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "input"
	  }, {
	    caption: "MESSAGE",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    expanded: false,
	    name: "message",
	    numOfLines: "8",
	    placeholder: "Your Message",
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "textarea"
	  }, {
	    caption: "PHOTOS",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    enabled: "true",
	    expanded: false,
	    isMust: "false",
	    name: "photos",
	    otherFieldsToUpdate: [{ src: "", tgt: "" }],
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "photoUpload"
	  }, {
	    caption: "AUTHOR",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    expanded: true,
	    name: "author",
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "input"
	  }],
	  key: "-M809qA-6Cp2CQRfBEpb",
	  menu: "OPEN BAZAR",
	  name: "openBazar",
	  searchColumns: ["title", "message", "name", "price"],
	  updateNotifyText: ""
	}, {
	  caption: "RIZI TEST",
	  createNotifyText: "",
	  dashColumns: ["name", "notes"],
	  deleteNotifyText: "",
	  fields: [{
	    caption: "NAME",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    enabled: "true",
	    expanded: false,
	    isMust: "true",
	    name: "name",
	    otherFieldsToUpdate: [{ src: "", tgt: "" }],
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "input"
	  }, {
	    caption: "NOTES",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    expanded: false,
	    name: "notes",
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "textarea"
	  }, {
	    caption: "PHOTOS",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    expanded: false,
	    name: "photos",
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "photoUpload"
	  }, {
	    caption: "PHOTO2",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    expanded: true,
	    name: "photo2",
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "photoUpload"
	  }],
	  key: "-M7joh6z5JnR4NBkB5VH",
	  menu: "RIZI MENU",
	  name: "riziTest",
	  searchColumns: ["name", "notes"],
	  updateNotifyText: ""
	}, {
	  caption: "MY SHOP",
	  createNotifyText: "",
	  dashColumns: ["productNameEnglish", "category", "sortOrder", "searchText", "productPrice", "availability", "isPopular", "unit", "productSupplier", "photos"],
	  deleteNotifyText: "",
	  fields: [{
	    caption: "CATEGORY",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    expanded: true,
	    name: "category",
	    selectorType: "static",
	    staticSource: [{ name: "ALL" }, { name: "POPULAR" }, { name: "রান্না করা খাবার" }, { name: "PREVIOUSLY ORDERED" }, { name: "FRUITS VEGETABLES " }, { name: "MEAT FISH" }, { name: "COOKING OIL INGREDIENTS" }, { name: "PICKLES" }, { name: "RICE DAAL NOODLES" }, { name: "EGGS DAIRY" }, { name: "SNACKS DRY FOOD" }, { name: "DRINKS DESSERT" }, { name: "TOILETRIES" }, { name: "SANITARY" }, { name: "LAUNDRY CLEANING" }, { name: "COSMETICS" }, { name: "KITCHEN DINING" }, { name: "TUPPERWARE CONTAINER" }, { name: "BABY TOYS" }, { name: "ELECTRONICS ACCESSORIES" }, { name: "STATIONARY" }, { name: "OTHERS" }],
	    type: "search"
	  }, {
	    caption: "AVAILABILITY",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    enabled: "true",
	    expanded: false,
	    name: "availability",
	    selectorType: "static",
	    staticSource: [{ name: "AVAILABLE" }, { name: "OUT OF STOCK, TOPPING UP IN PROGRESS" }],
	    type: "search"
	  }, {
	    caption: "NAME ENGLISH",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    enabled: "true",
	    expanded: false,
	    isMust: "true",
	    name: "productNameEnglish",
	    otherFieldsToUpdate: [{ src: "", tgt: "" }],
	    placeholder: "NAME ENGLISH",
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "input"
	  }, {
	    caption: "SEARCH TEXT",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    expanded: false,
	    name: "searchText",
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "input"
	  }, {
	    caption: "SORTY ORDER",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    defaultValue: "G",
	    expanded: false,
	    isMust: "true",
	    name: "sortOrder",
	    placeholder: "input an alphabet such as A, B ...",
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "input"
	  }, {
	    caption: "PRICE",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    expanded: false,
	    name: "productPrice",
	    placeholder: "PRICE",
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "input"
	  }, {
	    caption: "PHOTOS",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    expanded: false,
	    name: "photos",
	    placeholder: "",
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "photoUpload"
	  }, {
	    caption: "UNIT",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    expanded: false,
	    name: "unit",
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "input"
	  }, {
	    caption: "POPULAR",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    expanded: false,
	    name: "isPopular",
	    selectorType: "static",
	    staticSource: [{ name: "YES" }, { name: "NO" }],
	    type: "search"
	  }, {
	    caption: "SOURCE SUPPLIER",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    expanded: false,
	    name: "sourceSupplier",
	    selectorType: "table",
	    staticSource: [{ name: "" }],
	    table: "sourceSupplier",
	    tableField: "name",
	    type: "search"
	  }, {
	    caption: "Description",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    expanded: false,
	    name: "productDescription",
	    numOfLines: "5",
	    placeholder: "Add description about product",
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "textarea"
	  }, {
	    caption: "SUPPLIER",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    defaultValue: "userCompany",
	    expanded: false,
	    isHidden: "true",
	    name: "productSupplier",
	    otherFieldsToUpdate: [{ src: "userName", tgt: "supplierContactName" }, { src: "userMobile", tgt: "supplierContactPhone" }],
	    selectorType: "table",
	    staticSource: [{ name: "" }],
	    table: "users",
	    tableField: "userCompany",
	    type: "search"
	  }, {
	    caption: "SUPPLIER NAME",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    defaultValue: "userName",
	    expanded: false,
	    isHidden: "true",
	    name: "supplierContactName",
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "input"
	  }, {
	    caption: "CONTACT PHONE",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    defaultValue: "userMobile",
	    expanded: false,
	    isHidden: "true",
	    name: "supplierContactPhone",
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "input"
	  }],
	  filters: ["isPopular", "category", "availability"],
	  key: "-M7Xa21YxX5JQ0yDS8aJ",
	  menu: "MY SHOP",
	  name: "supplierShopItems",
	  searchColumns: ["productNameEnglish", "productPrice", "productSupplier", "productDescription", "isPopular"],
	  updateNotifyText: ""
	}, {
	  author: "",
	  caption: "ORDERS",
	  createDateTime: "",
	  createNotifyText: "",
	  dashColumns: ["name", "mobile", "address", "deliveryDate", "targetDeliveryDate", "orderTotal", "salesTotal", "status", "mealType", "deliveredBy"],
	  deleteNotifyText: "",
	  fields: [{
	    caption: "ORDER DATE",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    dateFormat: "dd-MM-yyyy",
	    dateFormatOut: "DD-MM-YYYY",
	    dateMaxDetail: "day",
	    defaultValue: "currentDate",
	    expanded: false,
	    isMust: "true",
	    name: "deliveryDate",
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "calendar"
	  }, {
	    caption: "STATUS",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    defaultValue: "NEW",
	    expanded: false,
	    name: "status",
	    selectorType: "static",
	    staticSource: [{ name: "NEW" }, { name: "WITH GROCER FOR PRICE" }, { name: "WITH GROCER FOR PACKING" }, { name: "WAITING FOR LORRY" }, { name: "LOADED ON LORRY" }, { name: "DELIVERED" }, { name: "CANCELLED" }],
	    type: "search"
	  }, {
	    caption: "ORDER TYPE",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    expanded: false,
	    name: "mealType",
	    selectorType: "static",
	    staticSource: [{ name: "LUNCH" }, { name: "DINNER" }, { name: "GROCERY ONLY" }, { name: "MIX (FOOD PLUS GROCERY)" }, { name: "OTHERS" }],
	    type: "search"
	  }, {
	    caption: "DELIVERED BY",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    expanded: false,
	    name: "deliveredBy",
	    selectorType: "static",
	    staticSource: [{ name: "BCS" }, { name: "DHAKA" }, { name: "TAXI" }],
	    type: "search"
	  }, {
	    caption: "TAXI AMOUNT",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    expanded: false,
	    name: "taxiAmount",
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "input"
	  }, {
	    caption: "TAXI PAID BY",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    expanded: false,
	    name: "taxiPaidBy",
	    selectorType: "table",
	    staticSource: [{ name: "" }],
	    table: "users",
	    tableField: "userName",
	    type: "search"
	  }, {
	    caption: "PAID TO",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    enabled: "true",
	    expanded: false,
	    name: "paidTo",
	    selectorType: "static",
	    staticSource: [{ name: "BCS" }, { name: "DHAKA" }],
	    type: "search"
	  }, {
	    caption: "PAYMENT TYPE",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    enabled: "true",
	    expanded: false,
	    name: "paymentType",
	    selectorType: "static",
	    staticSource: [{ name: "CASH" }, { name: "ONLINE" }, { name: "" }],
	    type: "search"
	  }, {
	    calcType: "mainFieldCalc",
	    caption: "SUPPLIER AMOUNT",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    enabled: "true",
	    expanded: true,
	    isMust: "false",
	    name: "supplierAmount",
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "input"
	  }, {
	    caption: "PAY TO SUPPLIER",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    expanded: false,
	    name: "payToSupplier",
	    selectorType: "static",
	    staticSource: [{ name: "PENDING" }, { name: "PAID" }],
	    type: "search"
	  }, {
	    caption: "MOBILE#",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    enabled: "true",
	    expanded: false,
	    isMust: "true",
	    name: "mobile",
	    otherFieldsToUpdate: [{ src: "", tgt: "" }],
	    placeholder: "92290596",
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "input"
	  }, {
	    caption: "NAME",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    expanded: false,
	    isMust: "true",
	    name: "name",
	    placeholder: "তোমার নাম YOUR NAME",
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "input"
	  }, {
	    caption: "ADDRESS",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    expanded: false,
	    isMust: "true",
	    name: "address",
	    placeholder: "আপনার ঠিকানা UNIT 04-62 BLOCK 768 CHUA CHUKONG S110876",
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "textarea"
	  }, {
	    caption: "TARGET DELIVERY DATE",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    dateFormat: "dd-MM-yyyy",
	    dateFormatOut: "DD-MM-YYYY",
	    dateMaxDetail: "day",
	    expanded: false,
	    name: "targetDeliveryDate",
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "input"
	  }, {
	    caption: "ANY SPECIAL INSTRUCTIONS",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    expanded: false,
	    name: "specialInstructions",
	    numOfLines: "3",
	    placeholder: "সন্ধ্যা 4 টা থেকে সন্ধ্যা between টার মধ্যে পৌঁছে দিন\nInput any special instructions like delivery only on tuesday and wednesday is possible",
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "textarea"
	  }, {
	    calcType: "subFieldsSum",
	    caption: "ORDER TOTAL",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    expanded: false,
	    name: "orderTotal",
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    subFieldOperation: "SUM",
	    subGridField: "amount",
	    subGridName: "requestedItems",
	    triggerField: "requestedItems",
	    type: "calculation"
	  }, {
	    caption: "ACTUAL SALE",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    enabled: "true",
	    expanded: false,
	    name: "salesTotal",
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "input"
	  }, {
	    caption: "ORDERED ITEMS",
	    colDefs: [{
	      editable: true,
	      key: "productNameEnglish",
	      name: "NAME",
	      resizable: true
	    }, { editable: true, key: "unit", name: "UNIT", resizable: true }, {
	      editable: true,
	      key: "productPrice",
	      name: "PRICE",
	      resizable: true
	    }, { editable: true, key: "quantity", name: "QTY", resizable: true }, { editable: true, key: "amount", name: "AMT", resizable: true }],
	    defaultValue: "",
	    expanded: false,
	    isMust: "true",
	    name: "requestedItems",
	    numOfLines: "25",
	    placeholder: "Onion 1Kg\nDates 1Packet\nSugar 1Kg\n\nপেঁয়াজ 1 কেজি\nতারিখ 1 প্যাকেট\nচিনি 1 কেজি",
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "array"
	  }, {
	    caption: "SUPPLIER",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    enabled: "true",
	    expanded: false,
	    name: "supplier",
	    selectorType: "static",
	    staticSource: [{ name: "ALL" }, { name: "RAJDHANI" }, { name: "TANMOY" }, { name: "ZARA" }, { name: "SUPPLIER4" }, { name: "SUPPLIER5" }],
	    type: "search"
	  }, {
	    caption: "SUPPLIER PRICES",
	    colDefs: [{
	      editable: true,
	      key: "supplierName",
	      name: "SUPPLIER",
	      resizable: true
	    }, { editable: true, key: "price", name: "PRICE", resizable: true }, { editable: true, key: "notes", name: "NOTES", resizable: true }],
	    expanded: false,
	    name: "supplierPrices",
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "array"
	  }, {
	    caption: "PHOTOS",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    enabled: "true",
	    expanded: false,
	    name: "photos",
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "photoUpload"
	  }],
	  filters: ["status", "deliveryDate", "targetDeliveryDate", "mealType"],
	  key: "-M5tSI7US3QYXqi7K7XU",
	  lastAction: "",
	  menu: "ORDERS",
	  name: "deliveryRequest",
	  searchColumns: ["mobile", "name", "address", "status", "deliveryDate", "mealType", "targetDeliveryDate", "orderTotal"],
	  updateDateTime: "",
	  updateNotifyText: ""
	}, {
	  author: "ahmed_fayyaz@outlook.com",
	  caption: "USERS",
	  createDateTime: "",
	  createNotifyText: "",
	  dashColumns: ["userName", "sortOrder", "userCompany", "recordType", "roleName", "userMobile", "userAddress"],
	  deleteNotifyText: "",
	  fields: [{
	    caption: "RECORD TYPE",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    defaultValue: "STORE USER",
	    expanded: false,
	    name: "recordType",
	    selectorType: "static",
	    staticSource: [{ name: "STANDARD USER" }, { name: "PROMOTIONAL" }, { name: "STORE USER" }],
	    type: "search"
	  }, {
	    caption: "SORT ORDER",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    defaultValue: "",
	    expanded: false,
	    name: "sortOrder",
	    placeholder: "1",
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "input"
	  }, {
	    caption: "ROLE NAME",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    dateFormat: "dd-MM-yyyy",
	    dateFormatOut: "DD-MM-YYYY",
	    dateMaxDetail: "day",
	    defaultValue: "",
	    enabled: "true",
	    expanded: false,
	    isMust: "true",
	    name: "roleName",
	    selectorType: "table",
	    staticSource: [{ name: "SALES" }, { name: "ENGINEER" }, { name: "CONTRIBUTOR" }, { name: "QS" }, { name: "ADMIN" }, { name: "SUPERADMIN" }],
	    table: "menuDesigner",
	    tableField: "name",
	    type: "search"
	  }, {
	    caption: "NAME",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    dateFormat: "dd-MM-yyyy",
	    dateFormatOut: "DD-MM-YYYY",
	    dateMaxDetail: "day",
	    defaultValue: "",
	    enabled: "true",
	    expanded: false,
	    isMust: "true",
	    name: "userName",
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    table: "",
	    tableField: "",
	    type: "input"
	  }, {
	    caption: "EMAIL",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    expanded: false,
	    name: "userEmail",
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "input"
	  }, {
	    caption: "MOBILE",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    enabled: "true",
	    expanded: false,
	    name: "userMobile",
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "input"
	  }, {
	    caption: "ADDRESS",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    dateFormat: "dd-MM-yyyy",
	    dateFormatOut: "DD-MM-YYYY",
	    dateMaxDetail: "day",
	    defaultValue: "",
	    enabled: "true",
	    expanded: false,
	    isMust: "true",
	    name: "userAddress",
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    table: "",
	    tableField: "",
	    type: "textarea"
	  }, {
	    caption: "COMPANY",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    defaultValue: "BROOKLYNZ STAINLESS STEEL PTE LTD",
	    enabled: "true",
	    expanded: false,
	    name: "userCompany",
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "input"
	  }, {
	    caption: "COMP INTRO TEXT",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    expanded: false,
	    name: "compIntoText",
	    numOfLines: "5",
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "textarea"
	  }, {
	    caption: "BACKGROUND IMAGE",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    expanded: false,
	    name: "bgImage",
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "input"
	  }, {
	    caption: "YOUTUBE VID ID",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    expanded: false,
	    name: "vidUrl",
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "input"
	  }, {
	    caption: "PROMO HEADER",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    expanded: false,
	    name: "promoHeader",
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "input"
	  }, {
	    caption: "PROMO DESCRIPTION",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    expanded: false,
	    name: "promoDescription",
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "textarea"
	  }, {
	    caption: "ENTER AS WORKER",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    defaultValue: "YES",
	    expanded: false,
	    name: "forceWorker",
	    selectorType: "static",
	    staticSource: [{ name: "YES" }, { name: "NO" }],
	    type: "search"
	  }, {
	    caption: "BUTTON1 TEXT",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    expanded: false,
	    name: "btn1Text",
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "input"
	  }, {
	    caption: "ACTION1",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    expanded: false,
	    name: "action1",
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "input"
	  }, {
	    caption: "BUTTON2 TEXT",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    expanded: false,
	    name: "btn2Text",
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "input"
	  }, {
	    caption: "ACTION2",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    expanded: false,
	    name: "action2",
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "input"
	  }, {
	    caption: "TABLE NAME",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    expanded: false,
	    name: "tableName",
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "input"
	  }, {
	    caption: "TABLE NAME2",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    expanded: false,
	    name: "tableName2",
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "input"
	  }],
	  filters: ["roleName"],
	  key: "17",
	  lastAction: "",
	  menu: "USER",
	  name: "users",
	  searchColumns: ["userName", "roleName"],
	  updateDateTime: "",
	  updateNotifyText: ""
	}, {
	  author: "",
	  caption: "ACCOUNTS",
	  createDateTime: "",
	  createNotifyText: "",
	  dashColumns: ["accountName", "accountSubCategory", "accountDescription", "accountType", "gstRate", "defaultContraAccount"],
	  deleteNotifyText: "",
	  fields: [{
	    caption: "ACCOUNT NAME",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    enabled: "true",
	    expanded: false,
	    isMust: "true",
	    name: "accountName",
	    otherFieldsToUpdate: [{ src: "", tgt: "" }],
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "input"
	  }, {
	    caption: "DESCRIPTION",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    expanded: false,
	    name: "accountDescription",
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "textarea"
	  }, {
	    caption: "GST RATE",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    defaultValue: "0.07",
	    expanded: false,
	    name: "gstRate",
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "input"
	  }, {
	    caption: "ACCOUNT TYPE",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    expanded: false,
	    name: "accountType",
	    selectorType: "static",
	    staticSource: [{ name: "EXPENSE" }, { name: "INCOME" }, { name: "ASSET" }, { name: "LIABILITY" }, { name: "CAPITAL" }, { name: "SYS INTERNAL" }],
	    type: "search"
	  }, {
	    caption: "SUB CATEGORY",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    expanded: false,
	    name: "accountSubCategory",
	    selectorType: "static",
	    staticSource: [{ name: "INDIRECT EXPENSES" }, { name: "OTHER INCOME" }],
	    type: "search"
	  }, {
	    caption: "DEF CONTRA ACCOUNT",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    expanded: false,
	    name: "defaultContraAccount",
	    selectorType: "table",
	    staticSource: [{ name: "" }],
	    table: "accounts",
	    tableField: "accountName",
	    type: "search"
	  }, {
	    caption: "ACCOUNTING RULES",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    expanded: true,
	    name: "accountingRules",
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "accountingRule"
	  }],
	  filters: ["accountType"],
	  key: "4",
	  lastAction: "",
	  menu: "ACCOUNTS",
	  name: "accounts",
	  searchColumns: ["accountName", "accountDescription"],
	  updateDateTime: "",
	  updateNotifyText: ""
	}, {
	  author: "",
	  caption: "PAYMENT TYPES",
	  createDateTime: "",
	  createNotifyText: "",
	  dashColumns: ["paymentName"],
	  deleteNotifyText: "",
	  fields: [{
	    caption: "NAME",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    enabled: "true",
	    expanded: false,
	    isMust: "true",
	    name: "paymentName",
	    otherFieldsToUpdate: [{ src: "", tgt: "" }],
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "input"
	  }, {
	    caption: "DESCRIPTION",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    enabled: "true",
	    expanded: false,
	    isMust: "true",
	    name: "paymentDescription",
	    otherFieldsToUpdate: [{ src: "", tgt: "" }],
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "input"
	  }, {
	    caption: "DEFAULT ACCOUNT",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    expanded: false,
	    name: "defaultAccount",
	    selectorType: "table",
	    staticSource: [{ name: "" }],
	    table: "accounts",
	    tableField: "accountName",
	    type: "search"
	  }],
	  key: "3",
	  lastAction: "",
	  menu: "PAYMENT TYPES",
	  name: "paymentTypes",
	  searchColumns: ["paymentName"],
	  updateDateTime: "",
	  updateNotifyText: ""
	}, {
	  author: "",
	  caption: "EXPENSE",
	  createDateTime: "",
	  createNotifyText: "",
	  dashColumns: ["entryDate", "supplier", "expenseDescription", "account", "paymentType", "invoiceNumber", "gstAmount", "gstTotalAmount", "contraAccount"],
	  deleteNotifyText: "",
	  fields: [{
	    caption: "ENTRY DATE",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    dateFormat: "dd-MM-yyyy",
	    dateFormatOut: "DD-MM-YYYY",
	    dateMaxDetail: "day",
	    defaultValue: "currentDate",
	    enabled: "true",
	    expanded: false,
	    isMust: "true",
	    name: "entryDate",
	    otherFieldsToUpdate: [{ src: "", tgt: "" }],
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "calendar"
	  }, {
	    caption: "DESCRIPTION",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    expanded: false,
	    name: "expenseDescription",
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "input"
	  }, {
	    caption: "PROJECT",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    enabled: "true",
	    expanded: false,
	    name: "project",
	    selectorType: "table",
	    staticSource: [{ name: "" }],
	    table: "projects",
	    tableField: "projectName",
	    type: "search"
	  }, {
	    caption: "SUPPLIER",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    expanded: false,
	    name: "supplier",
	    selectorType: "table",
	    staticSource: [{ name: "" }],
	    table: "suppliers",
	    tableField: "supplierCompany",
	    type: "search"
	  }, {
	    caption: "SUPPLIER INVOICE#",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    expanded: false,
	    name: "invoiceNumber",
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "input"
	  }, {
	    caption: "EXPENSE ACCOUNT",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    expanded: false,
	    name: "account",
	    otherFieldsToUpdate: [{ src: "gstRate", tgt: "gstRate" }, { src: "accountSubCategory", tgt: "accountSubCategory" }],
	    selectorType: "table",
	    staticSource: [{ name: "" }],
	    table: "accounts",
	    tableField: "accountName",
	    type: "search"
	  }, {
	    caption: "SUB CATEGORY",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    expanded: false,
	    name: "accountSubCategory",
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "input"
	  }, {
	    caption: "GST RATE",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    expanded: false,
	    name: "gstRate",
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "input"
	  }, {
	    caption: "BEFORE GST AMT",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    expanded: false,
	    name: "amount",
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "input"
	  }, {
	    caption: "PAYMENT TYPE",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    enabled: "true",
	    expanded: false,
	    name: "paymentType",
	    otherFieldsToUpdate: [{ src: "defaultAccount", tgt: "contraAccount" }],
	    selectorType: "table",
	    staticSource: [{ name: "" }],
	    table: "paymentTypes",
	    tableField: "paymentName",
	    type: "search"
	  }, {
	    caption: "REF NUMBER",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    expanded: false,
	    name: "referenceNumber",
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "input"
	  }, {
	    caption: "PAYMENT DATE",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    dateFormat: "dd-MM-yyyy",
	    dateFormatOut: "DD-MM-YYYY",
	    dateMaxDetail: "day",
	    defaultValue: "currentDate",
	    expanded: false,
	    name: "paymentDate",
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "calendar"
	  }, {
	    caption: "CONTRA ACCOUNT",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    expanded: true,
	    name: "contraAccount",
	    selectorType: "table",
	    staticSource: [{ name: "" }],
	    table: "accounts",
	    tableField: "accountName",
	    type: "search"
	  }, {
	    calcType: "mainFieldCalc",
	    caption: "GST",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    expanded: false,
	    formula: [{ name: "", operand1: "amount", operand2: "gstRate", operation: "*" }],
	    name: "gstAmount",
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    triggerField: "amount",
	    type: "calculation"
	  }, {
	    calcType: "mainFieldCalc",
	    caption: "TOTAL(INCL GST)",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    expanded: false,
	    formula: [{
	      name: "",
	      operand1: "amount",
	      operand2: "gstAmount",
	      operation: "+"
	    }],
	    name: "gstTotalAmount",
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    triggerField: "gstAmount",
	    type: "calculation"
	  }],
	  filters: ["entryDate"],
	  key: "2",
	  lastAction: "",
	  menu: "EXPENSE",
	  name: "expense",
	  searchColumns: ["supplier", "account"],
	  updateDateTime: "",
	  updateNotifyText: ""
	}, {
	  author: "",
	  caption: "BOOK KEEPING",
	  createDateTime: "",
	  createNotifyText: "",
	  dashColumns: ["bookingDate", "debitAccount", "creditAccount", "amount", "description"],
	  deleteNotifyText: "",
	  fields: [{
	    caption: "DATE",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    dateFormat: "dd-MM-yyyy",
	    dateFormatOut: "DD-MM-YYYY",
	    dateMaxDetail: "day",
	    defaultValue: "currentDate",
	    enabled: "true",
	    expanded: false,
	    isMust: "true",
	    name: "bookingDate",
	    otherFieldsToUpdate: [{ src: "", tgt: "" }],
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "calendar"
	  }, {
	    caption: "DEBIT (RECEIVED BY)",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    enabled: "true",
	    expanded: false,
	    isMust: "true",
	    name: "debitAccount",
	    selectorType: "table",
	    staticSource: [{ name: "" }],
	    table: "accounts",
	    tableField: "accountName",
	    type: "search"
	  }, {
	    caption: "CREDIT (TAKEN FROM)",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    enabled: "true",
	    expanded: false,
	    isMust: "true",
	    name: "creditAccount",
	    selectorType: "table",
	    staticSource: [{ name: "" }],
	    table: "accounts",
	    tableField: "accountName",
	    type: "search"
	  }, {
	    caption: "AMOUNT",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    expanded: false,
	    name: "amount",
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "input"
	  }, {
	    caption: "DESCRIPTION",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    expanded: false,
	    name: "description",
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "input"
	  }, {
	    caption: "REFERENCE NUMBER",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    enabled: "true",
	    expanded: false,
	    isMust: "true",
	    name: "refNumber",
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "input"
	  }],
	  filters: ["bookingDate", "debitAccount", "creditAccount"],
	  key: "1",
	  lastAction: "",
	  menu: "BOOK KEEPING",
	  name: "accountingEntry",
	  searchColumns: ["debitAccount", "creditAccount", "amount"],
	  updateDateTime: "",
	  updateNotifyText: ""
	}, {
	  author: "",
	  caption: "ACCOUNT ENQUIRIES",
	  createDateTime: "",
	  createNotifyText: "",
	  dashColumns: ["accEnquiryName", "enquiryDate", "accName"],
	  deleteNotifyText: "",
	  fields: [{
	    caption: "ENQUIRY NAME",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    expanded: false,
	    name: "accEnquiryName",
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "input"
	  }, {
	    caption: "ENQUIRY DATE",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    dateFormat: "dd-MM-yyyy",
	    dateFormatOut: "DD-MM-YYYY",
	    dateMaxDetail: "day",
	    defaultValue: "currentDate",
	    expanded: false,
	    name: "enquiryDate",
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "calendar"
	  }, {
	    caption: "ACCOUNT",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    defaultValue: "",
	    enabled: "true",
	    expanded: false,
	    isMust: "true",
	    name: "accName",
	    selectorType: "table",
	    staticSource: [{ name: "" }],
	    table: "accounts",
	    tableField: "accountName",
	    type: "search"
	  }, {
	    caption: "ENQUIRY TYPE",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    enabled: "true",
	    expanded: false,
	    name: "enquiryType",
	    selectorType: "static",
	    staticSource: [{ name: "ACCOUNT STATEMENT" }, { name: "DAILY BALANCE VIEW" }],
	    type: "search"
	  }, {
	    caption: "FROM DATE",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    dateFormat: "dd-MM-yyyy",
	    dateFormatOut: "DD-MM-YYYY",
	    dateMaxDetail: "day",
	    defaultValue: "currentDate",
	    expanded: false,
	    name: "fromDate",
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "calendar"
	  }, {
	    caption: "TO DATE",
	    colDefs: [{ editable: true, key: "", name: "", resizable: true }],
	    dateFormat: "dd-MM-yyyy",
	    dateFormatOut: "DD-MM-YYYY",
	    dateMaxDetail: "day",
	    defaultValue: "currentDate",
	    expanded: false,
	    name: "toDate",
	    selectorType: "",
	    staticSource: [{ name: "" }],
	    type: "calendar"
	  }],
	  filters: ["accName", "enquiryDate"],
	  key: "0",
	  lastAction: "",
	  menu: "ACCOUNT ENQUIRY",
	  name: "accountEnquiry",
	  searchColumns: ["accEnquiryName", "accName", "enquiryDate"],
	  updateDateTime: "",
	  updateNotifyText: ""
	}];

/***/ }),
/* 353 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var tListOfTables = exports.tListOfTables = [{
	  caption: "INVENTORY",
	  key: "-MESPxTjVmc7yGcRzTCZ",
	  menu: "INVENTORY",
	  name: "inventory"
	}, {
	  caption: "PURCHASE",
	  key: "-MAt7wQodmOn3zkcbYn0",
	  menu: "PURCHASE",
	  name: "purchase"
	}, {
	  caption: "SOURCE SUPPLIER",
	  menu: "SOURCE SUPPLIR",
	  name: "sourceSupplier",
	  key: "-M9wSYEqew_khvMeny2j"
	}, {
	  caption: "APP PHOTOS",
	  key: "-M9rtsy-MvKtsLkpkCWg",
	  menu: "APP PHOTOS",
	  name: "appPhotos"
	}, {
	  caption: "SUPPLIER",
	  menu: "SUPPLIER",
	  name: "dqr",
	  key: "-M97w7q92MbnSQuc4Y2P"
	}, {
	  caption: "BCS HOME",
	  menu: "BCS HOME",
	  name: "bcsHome",
	  updateDateTime: "26/05/2020 08:15:00",
	  key: "-M8CtnxbMWDVSrp1DFvw"
	}, {
	  caption: "OPEN BAZAR",
	  key: "-M809q9K3KcbiL02k6bO",
	  menu: "OPEN BAZAR",
	  name: "openBazar"
	}, {
	  caption: "RIZI TEST",
	  key: "-M7joh6NZutkn-61UBGS",
	  menu: "RIZI MENU",
	  name: "riziTest"
	}, {
	  caption: "MY SHOP",
	  key: "-M7Xa21919ZTFYbeP4fR",
	  menu: "MY SHOP",
	  name: "supplierShopItems"
	}, {
	  caption: "ORDERS",
	  key: "-M5tSI70237W5vV7YYh5",
	  menu: "ORDERS",
	  name: "deliveryRequest"
	}, {
	  author: "ahmed_fayyaz@outlook.com",
	  caption: "CREATE FORM",
	  createDateTime: "",
	  key: "32",
	  menu: "CREATE FORM",
	  name: "formDefinitions",
	  updateDateTime: "15/03/2020 04:14:42"
	}, {
	  author: "ahmed_fayyaz@outlook.com",
	  caption: "CREATE TABLE",
	  createDateTime: "",
	  key: "30",
	  menu: "CREATE TABLE",
	  name: "listOfTables",
	  updateDateTime: "15/03/2020 04:15:03"
	}, {
	  author: "ahmed_fayyaz@outlook.com",
	  caption: "CREATE MENU",
	  createDateTime: "",
	  key: "28",
	  menu: "CREATE MENU",
	  name: "menuDesigner",
	  updateDateTime: "15/03/2020 04:15:38"
	}, {
	  author: "ahmed_fayyaz@outlook.com",
	  caption: "USERS",
	  createDateTime: "",
	  key: "19",
	  menu: "USER",
	  name: "users",
	  updateDateTime: "15/03/2020 06:21:07"
	}, {
	  author: "ahmed_fayyaz@outlook.com",
	  caption: "DASHBOARD",
	  createDateTime: "",
	  key: "18",
	  menu: "DASHBOARD",
	  name: "dashboard",
	  updateDateTime: "15/03/2020 06:21:47"
	}, {
	  author: "ahmed_fayyaz@outlook.com",
	  caption: "SIGN OUT",
	  createDateTime: "",
	  key: "16",
	  menu: "SIGN OUT",
	  name: "signout",
	  updateDateTime: "15/03/2020 06:26:34"
	}, {
	  author: "ahmed_fayyaz@outlook.com",
	  caption: "LIST OF TABLES",
	  createDateTime: "",
	  key: "15",
	  menu: "LIST OF TABLES",
	  name: "listOfTables",
	  updateDateTime: "15/03/2020 06:26:49"
	}, {
	  author: "ahmed_fayyaz@outlook.com",
	  caption: "CREATE FORM",
	  createDateTime: "",
	  key: "10",
	  menu: "CREATE FORM",
	  name: "createTable",
	  updateDateTime: "15/03/2020 07:51:10"
	}, { caption: "ACCOUNTS", key: "5", menu: "ACCOUNTS", name: "accounts" }, {
	  caption: "PAYMENT TYPES",
	  key: "4",
	  menu: "PAYMENT TYPES",
	  name: "paymentTypes"
	}, { caption: "ACCT ENTRY", key: "3", menu: "ACCT ENTRY", name: "bookKeeping" }, { caption: "EXPENSE", key: "2", menu: "EXPENSE", name: "expense" }, {
	  caption: "BOOK KEEPING",
	  key: "1",
	  menu: "BOOK KEEPING",
	  name: "accountingEntry"
	}, {
	  author: "ahmed_fayyaz@outlook.com",
	  caption: "ACCOUNT ENQUIRIES",
	  createDateTime: "",
	  key: "0",
	  menu: "ACCOUNT ENQUIRY",
	  name: "accountEnquiry",
	  updateDateTime: "26/04/2020 01:33:03"
	}];

/***/ }),
/* 354 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var tMenuDesigner = exports.tMenuDesigner = [{
	  author: "ahmed_fayyaz@outlook.com",
	  key: "-MERhiQhxxarbPfBBENs",
	  menuItems: [{
	    displayToggle: "YES",
	    menuCaption: "ORDERS",
	    mobileRecLimit: "",
	    recLimit: "",
	    tableCaption: "ORDERS",
	    tableName: "deliveryRequest"
	  }, {
	    displayToggle: "YES",
	    menuCaption: "SOURCE SUPPLIR",
	    mobileRecLimit: "",
	    recLimit: "",
	    tableCaption: "SOURCE SUPPLIER",
	    tableName: "sourceSupplier"
	  }, {
	    displayToggle: "YES",
	    menuCaption: "PURCHASE",
	    mobileRecLimit: "",
	    recLimit: "",
	    tableCaption: "PURCHASE",
	    tableName: "purchase"
	  }, {
	    displayToggle: "YES",
	    menuCaption: "OPEN BAZAR",
	    mobileRecLimit: "",
	    recLimit: "",
	    tableCaption: "OPEN BAZAR",
	    tableName: "openBazar"
	  }, {
	    displayToggle: "YES",
	    menuCaption: "MY SHOP",
	    mobileRecLimit: "",
	    recLimit: "",
	    tableCaption: "MY SHOP",
	    tableName: "supplierShopItems"
	  }, {
	    displayToggle: "YES",
	    menuCaption: "SIGN OUT",
	    mobileRecLimit: "",
	    recLimit: "",
	    tableCaption: "SIGN OUT",
	    tableName: "signout"
	  }],
	  name: "SALESADMIN",
	  updateDateTime: "Tue 11-08-20 6:56 pm"
	}, {
	  author: "ahmed_fayyaz@outlook.com",
	  menuItems: [""],
	  name: "PROMO",
	  updateDateTime: "05/06/2020 05:45:20",
	  key: "-M92REy6SD5mIWH8yvL6"
	}, {
	  author: "ahmed_fayyaz@outlook.com",
	  key: "-M71UZqdToF1w_zhxVIC",
	  menuItems: [{
	    displayToggle: "YES",
	    menuCaption: "BCS HOME",
	    mobileRecLimit: "",
	    recLimit: "",
	    tableCaption: "BCS HOME",
	    tableName: "bcsHome"
	  }, {
	    menuCaption: "DELIVERY REQUEST",
	    mobileRecLimit: "",
	    recLimit: "",
	    tableCaption: "DELIVERY REQUEST",
	    tableName: "deliveryRequest"
	  }, {
	    displayToggle: "YES",
	    menuCaption: "SIGN OUT",
	    mobileRecLimit: "",
	    recLimit: "",
	    tableCaption: "SIGN OUT",
	    tableName: "signout"
	  }],
	  name: "ORDERADMIN",
	  updateDateTime: "26/05/2020 12:24:27"
	}, {
	  author: "ahmed_fayyaz@outlook.com",
	  key: "-M70och0B-89dvRhHbrd",
	  menuItems: [{
	    displayToggle: "YES",
	    menuCaption: "BCS HOME",
	    menuIcon: "fa fa-home",
	    mobileRecLimit: "",
	    recLimit: "",
	    tableCaption: "BCS HOME",
	    tableName: "bcsHome"
	  }, {
	    displayToggle: "YES",
	    menuCaption: "SUPPLIER",
	    menuIcon: "fa fa-tachometer",
	    mobileRecLimit: "",
	    recLimit: "",
	    tableCaption: "SUPPLIER",
	    tableName: "dqr"
	  }, {
	    menuCaption: "MY SHOP",
	    menuIcon: "fa fa-check-circle",
	    mobileRecLimit: "",
	    recLimit: "",
	    tableCaption: "MY SHOP",
	    tableName: "supplierShopItems"
	  }, {
	    menuCaption: "PURCHASE",
	    menuIcon: "fa fa-truck",
	    mobileRecLimit: "",
	    recLimit: "",
	    tableCaption: "PURCHASE",
	    tableName: "purchase"
	  }, {
	    menuCaption: "OPEN BAZAR",
	    menuIcon: "fa fa-users",
	    mobileRecLimit: "",
	    recLimit: "",
	    tableCaption: "OPEN BAZAR",
	    tableName: "openBazar"
	  }, {
	    displayToggle: "YES",
	    menuCaption: "SIGN OUT",
	    menuIcon: "fa fa-sign-out",
	    mobileRecLimit: "",
	    recLimit: "",
	    tableCaption: "SIGN OUT",
	    tableName: "signout"
	  }],
	  name: "STOREADMIN",
	  updateDateTime: "29/06/2020 10:54:39"
	}, {
	  author: "ahmed_fayyaz@outlook.com",
	  key: "-M5ug25nl8d498px1OFz",
	  menuItems: [{
	    displayToggle: "YES",
	    menuCaption: "BCS HOME",
	    menuIcon: "fa fa-home",
	    mobileRecLimit: "",
	    recLimit: "",
	    tableCaption: "BCS HOME",
	    tableName: "bcsHome"
	  }, {
	    menuCaption: "DELIVERY REQUEST",
	    menuIcon: "fa fa-shopping-cart",
	    mobileRecLimit: "",
	    recLimit: "",
	    tableCaption: "DELIVERY REQUEST",
	    tableName: "deliveryRequest"
	  }, {
	    menuCaption: "OPEN BAZAR",
	    menuIcon: "fa fa-users",
	    mobileRecLimit: "",
	    recLimit: "",
	    tableCaption: "OPEN BAZAR",
	    tableName: "openBazar"
	  }, {
	    menuCaption: "SIGN OUT",
	    menuIcon: "fa fa-sign-out",
	    mobileRecLimit: "",
	    recLimit: "",
	    tableCaption: "SIGN OUT",
	    tableName: "signout"
	  }],
	  name: "WORKER",
	  updateDateTime: "15/06/2020 05:44:40"
	}, {
	  author: "ahmed_fayyaz@outlook.com",
	  key: "-M5ug-ocMGBo5XVgszQA",
	  menuItems: [{
	    menuCaption: "DELIVERY REQUEST",
	    mobileRecLimit: "",
	    recLimit: "",
	    tableCaption: "DELIVERY REQUEST",
	    tableName: "deliveryRequest"
	  }, {
	    displayToggle: "YES",
	    menuCaption: "SIGN OUT",
	    mobileRecLimit: "",
	    recLimit: "",
	    tableCaption: "SIGN OUT",
	    tableName: "signout"
	  }],
	  name: "GROCER",
	  updateDateTime: "26/05/2020 12:32:58"
	}, {
	  author: "ahmed_fayyaz@outlook.com",
	  key: "6",
	  menuItems: [{
	    menuCaption: "BCS HOME",
	    mobileRecLimit: "",
	    recLimit: "",
	    tableCaption: "BCS HOME",
	    tableName: "bcsHome"
	  }, {
	    displayToggle: "YES",
	    menuCaption: "OPEN BAZAR",
	    mobileRecLimit: "",
	    recLimit: "",
	    tableCaption: "OPEN BAZAR",
	    tableName: "openBazar"
	  }, {
	    displayToggle: "YES",
	    menuCaption: "DELIVERY REQUEST",
	    mobileRecLimit: "",
	    recLimit: "",
	    tableCaption: "DELIVERY REQUEST",
	    tableName: "deliveryRequest"
	  }, {
	    menuCaption: "PURCHASE",
	    mobileRecLimit: "",
	    recLimit: "",
	    tableCaption: "PURCHASE",
	    tableName: "purchase"
	  }, {
	    displayToggle: "YES",
	    menuCaption: "INVENTORY",
	    mobileRecLimit: "",
	    recLimit: "",
	    tableCaption: "INVENTORY",
	    tableName: "inventory"
	  }, {
	    menuCaption: "SOURCE SUPPLIR",
	    mobileRecLimit: "",
	    recLimit: "",
	    tableCaption: "SOURCE SUPPLIER",
	    tableName: "sourceSupplier"
	  }, {
	    displayToggle: "YES",
	    menuCaption: "MY SHOP",
	    mobileRecLimit: "",
	    recLimit: "",
	    tableCaption: "MY SHOP",
	    tableName: "supplierShopItems"
	  }, {
	    displayToggle: "YES",
	    menuCaption: "USERS",
	    mobileRecLimit: "",
	    recLimit: "",
	    tableCaption: "USERS",
	    tableName: "users"
	  }, {
	    menuCaption: "APP PHOTOS",
	    mobileRecLimit: "",
	    recLimit: "",
	    tableCaption: "APP PHOTOS",
	    tableName: "appPhotos"
	  }, {
	    displayToggle: "YES",
	    menuCaption: "CREATE FORM",
	    mobileRecLimit: "",
	    recLimit: "",
	    tableCaption: "CREATE FORM",
	    tableName: "createTable"
	  }, {
	    displayToggle: "YES",
	    menuCaption: "LIST OF TABLES",
	    mobileRecLimit: "",
	    recLimit: "",
	    tableCaption: "LIST OF TABLES",
	    tableName: "listOfTables"
	  }, {
	    displayToggle: "YES",
	    menuCaption: "CREATE MENU",
	    mobileRecLimit: "",
	    recLimit: "",
	    tableCaption: "CREATE MENU",
	    tableName: "menuDesigner"
	  }, {
	    displayToggle: "YES",
	    menuCaption: "SIGN OUT",
	    mobileRecLimit: "",
	    recLimit: "",
	    tableCaption: "SIGN OUT",
	    tableName: "signout"
	  }],
	  name: "SUPERADMIN",
	  updateDateTime: "Tue 11-08-20 10:08 pm"
	}];

/***/ }),
/* 355 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var tPopularItems = exports.tPopularItems = [{
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-M9Y1WO275HFH9pHbU8S",
	  photos: [{
	    imageName: "9c4fbc90-c105-11ea-8470-83fbeadd4a74.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F9c4fbc90-c105-11ea-8470-83fbeadd4a74.jpg?alt=media&token=652de7ef-294d-4561-b258-c1e2405bdd78"
	  }],
	  productNameEnglish: "Green chilli ",
	  productPrice: "2.00",
	  productSupplier: "BCS SHOP",
	  searchText: "কাঁচা মরিচ ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "200gm",
	  updateDateTime: "Sun 20-12-20 11:30 pm",
	  count: 828
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-M9XzYPESx_Db7uv0jTY",
	  photos: [{
	    imageName: "253a8c50-abd1-11ea-b76c-0b360dd92c32.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F253a8c50-abd1-11ea-b76c-0b360dd92c32.jpg?alt=media&token=9e5d3417-818c-4a1e-ad72-bc1a2cd428db"
	  }],
	  productNameEnglish: "Onion bag",
	  productPrice: "6",
	  productSupplier: "BCS SHOP",
	  searchText: "পেঁয়াজ পেয়াজ onion piaz piaj",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1 bag (3 kg)",
	  updateDateTime: "Sun 20-12-20 11:29 pm",
	  count: 507
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-M9Y5jNlVNJ0uW1ec5mh",
	  photos: [{
	    imageName: "379757a0-b204-11ea-aac4-61b5279351b7.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F379757a0-b204-11ea-aac4-61b5279351b7.jpg?alt=media&token=35add90b-6fbe-4299-883c-394530faf678"
	  }],
	  productNameEnglish: "Tomatoes ",
	  productPrice: "3.50",
	  productSupplier: "BCS SHOP",
	  searchText: "টমেটো ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1KG",
	  updateDateTime: "17/07/2020 08:30:35",
	  count: 429
	}, {
	  author: "+6594562455",
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-M9cN73SCaTMPoEWcX6s",
	  photos: [{
	    imageName: "47401e70-c7f9-11ea-9d1d-d9f4bc315562.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F47401e70-c7f9-11ea-9d1d-d9f4bc315562.jpg?alt=media&token=74597a21-45ff-4906-ab66-9ae3d1f5e84a"
	  }],
	  productNameEnglish: "GINGER",
	  productPrice: "1.40",
	  productSupplier: "BCS SHOP",
	  searchText: "আদা",
	  sortOrder: "a",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "200gm",
	  updateDateTime: "30/07/2020 12:11:30",
	  count: 418
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-MA4UQ6KFh5415O1ZtaT",
	  photos: [{
	    imageName: "c17e83e0-bdac-11ea-8ba8-ddb60ef370d4.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fc17e83e0-bdac-11ea-8ba8-ddb60ef370d4.jpg?alt=media&token=8a79f382-93c1-4836-8ae4-a80f4acdba89"
	  }],
	  productNameEnglish: "Cucumber",
	  productPrice: "1.30",
	  productSupplier: "BCS SHOP",
	  searchText: "shosha sosa shoshi salad",
	  sortOrder: "a",
	  sourceSupplier: "Sheng siong ",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "500gm",
	  updateDateTime: "03/08/2020 04:21:46",
	  count: 371
	}, {
	  author: "+6594562455",
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-M9YWCesWwfEYegG51K-",
	  photos: [{
	    imageName: "a5b99b00-c81e-11ea-99a6-3f4f89ed7cd9.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fa5b99b00-c81e-11ea-99a6-3f4f89ed7cd9.jpg?alt=media&token=fe01e8d1-51c3-4c4a-a8d1-18b0009544b7"
	  }],
	  productNameEnglish: "Garlic ",
	  productPrice: "1.40",
	  productSupplier: "BCS SHOP",
	  searchText: "রসুন রসূন রশুন ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "200gms",
	  updateDateTime: "30/07/2020 12:13:08",
	  count: 356
	}, {
	  author: "+6589050302",
	  availability: "AVAILABLE",
	  category: "EGGS DAIRY",
	  isPopular: "YES",
	  key: "-M9ay5D0iIseTdskzY0e",
	  photos: [{
	    imageName: "20cb1dc0-afc2-11ea-a37e-bd24eb8f726f.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F20cb1dc0-afc2-11ea-a37e-bd24eb8f726f.jpg?alt=media&token=c06cd2ef-a9e3-4e75-9225-398ef140c872"
	  }],
	  productNameEnglish: "Egg ",
	  productPrice: "5.90",
	  productSupplier: "BCS SHOP",
	  searchText: "ডিম ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "30pcs",
	  updateDateTime: "Wed 05-08-20 5:07 pm",
	  count: 351
	}, {
	  author: "+6594562455",
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-MDNgqX2N9uYblwrgjBF",
	  photos: [{
	    imageName: "33f95940-d928-11ea-b868-6be4132c903f.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F33f95940-d928-11ea-b868-6be4132c903f.jpg?alt=media&token=73f1c40f-992b-4680-8550-d3b417923214"
	  }],
	  productNameEnglish: "Lime",
	  productPrice: "1.50",
	  productSupplier: "BCS SHOP",
	  searchText: "lemon lime lamon লেবু লেভূ লেবো ",
	  sortOrder: "a",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "250gm",
	  updateDateTime: "Sat 08-08-20 11:43 am",
	  count: 290
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-M9Xz1UTYCxt-drlSFrg",
	  photos: [{
	    imageName: "94fa4b80-abd0-11ea-b76c-0b360dd92c32.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F94fa4b80-abd0-11ea-b76c-0b360dd92c32.jpg?alt=media&token=2a1daa66-e53c-440b-82a3-47cd3dd2e2cf"
	  }],
	  productNameEnglish: "Potato bag ",
	  productPrice: "5.5",
	  productSupplier: "BCS SHOP",
	  searchText: "আলু ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "4kg",
	  updateDateTime: "08/07/2020 06:05:43",
	  count: 281
	}, {
	  availability: "AVAILABLE",
	  category: "MEAT FISH",
	  isPopular: "YES",
	  key: "-M9YXmiqrCkl2UACh3XY",
	  photos: [{
	    imageName: "0db6e000-b2a8-11ea-a456-b52272a954da.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F0db6e000-b2a8-11ea-a456-b52272a954da.jpg?alt=media&token=22522c58-0786-4c5c-8673-9ec22520f0bf"
	  }],
	  productNameEnglish: "Mutton Marrow ",
	  productPrice: "6.50",
	  productSupplier: "BCS SHOP",
	  searchText: "খাসির পায়া ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1kg",
	  updateDateTime: "23/07/2020 01:01:18",
	  count: 269
	}, {
	  author: "+6589050302",
	  availability: "AVAILABLE",
	  category: "MEAT FISH",
	  isPopular: "YES",
	  key: "-M9YYE7XExSI-8nZhIvy",
	  photos: [{
	    imageName: "63d1a8e0-d3fe-11ea-a0e0-7d366b7a98ae.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F63d1a8e0-d3fe-11ea-a0e0-7d366b7a98ae.jpg?alt=media&token=d7fa02b4-e3af-46cf-b6d4-75212ec12a19"
	  }],
	  productNameEnglish: "Mutton  (price vary depending on quality)",
	  productPrice: "11.50",
	  productSupplier: "BCS SHOP",
	  searchText: "খাসির মাংস ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1kg",
	  updateDateTime: "Mon 10-08-20 2:37 pm",
	  count: 263
	}, {
	  availability: "AVAILABLE",
	  category: "MEAT FISH",
	  isPopular: "YES",
	  key: "-M9YYpBjUhHmun6KH3hq",
	  photos: [{
	    imageName: "33253800-c81f-11ea-99a6-3f4f89ed7cd9.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F33253800-c81f-11ea-99a6-3f4f89ed7cd9.jpg?alt=media&token=56442d8a-c2c3-4408-81d8-991dff35744f"
	  }],
	  productNameEnglish: "Duck frozen",
	  productPrice: "11",
	  productSupplier: "BCS SHOP",
	  searchText: "হাঁস ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1 packet",
	  updateDateTime: "17/07/2020 07:18:46",
	  count: 246
	}, {
	  author: "+6589050302",
	  availability: "AVAILABLE",
	  category: "SNACKS DRY FOOD",
	  key: "-M9bShlvpc1WRxgKblin",
	  photos: [{
	    imageName: "c9d077b0-c7fc-11ea-9d1d-d9f4bc315562.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fc9d077b0-c7fc-11ea-9d1d-d9f4bc315562.jpg?alt=media&token=afd126af-c8e3-4bcc-b3f9-a79c3b21654f"
	  }],
	  productNameEnglish: "Pran puffed rice 1packet",
	  productPrice: "0.90",
	  productSupplier: "BCS SHOP",
	  searchText: "মুড়ি মুরি ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1",
	  updateDateTime: "23/07/2020 07:29:23",
	  count: 245
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-MAB_ZvZGKR0d9NJnjha",
	  photos: [{
	    imageName: "cdaf1c30-b229-11ea-9201-9d4c56efae0c.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fcdaf1c30-b229-11ea-9201-9d4c56efae0c.jpg?alt=media&token=89515213-7acd-4581-badb-c1e2514e16c8"
	  }],
	  productNameEnglish: "Banana",
	  productPrice: "2.50",
	  productSupplier: "BCS SHOP",
	  searchText: "kola kala kela benana কলা কেলা ",
	  sortOrder: "a",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "5 to 6 pcs",
	  updateDateTime: "03/08/2020 03:55:59",
	  count: 233
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-M9a0bvd5rTsA52SgzV4",
	  photos: [{
	    imageName: "e3140940-f898-11ea-aaa8-a9cfb87a7f3a.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2Fe3140940-f898-11ea-aaa8-a9cfb87a7f3a.jpg?alt=media&token=dd62c212-4dd4-4927-9f9b-6fe69504e258"
	  }],
	  productNameEnglish: "Dates ",
	  productPrice: "5",
	  productSupplier: "BCS SHOP",
	  searchText: "খেজুর ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "500gm",
	  updateDateTime: "Thu 17-09-20 11:50 am",
	  count: 230
	}, {
	  availability: "AVAILABLE",
	  category: "MEAT FISH",
	  isPopular: "YES",
	  key: "-M9YY1Vs-DmZEPBdZ7Py",
	  photos: [{
	    imageName: "de857390-bf78-11ea-aa1e-9169bb2ab543.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fde857390-bf78-11ea-aa1e-9169bb2ab543.jpg?alt=media&token=4e793d06-81c3-4017-859b-7dc6d76e3ebe"
	  }],
	  productNameEnglish: "Beef ",
	  productPrice: "9.50",
	  productSupplier: "BCS SHOP",
	  searchText: "গরুর মাংস",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1kg",
	  updateDateTime: "23/07/2020 01:00:56",
	  count: 218
	}, {
	  author: "+6594562455",
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-MA0G8ynMhI4HuYx49i8",
	  photos: [{
	    imageName: "590236d0-bc59-11ea-b7df-33e703b87300.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F590236d0-bc59-11ea-b7df-33e703b87300.jpg?alt=media&token=5d090713-f8a2-4eab-b103-a5fb23518b29"
	  }],
	  productNameEnglish: "Coriander",
	  productPrice: "2",
	  productSupplier: "BCS SHOP",
	  searchText: "ধনিয়া পাতা ",
	  sortOrder: "a",
	  sourceSupplier: "FAHIM ENTERPRISE PTE LTD",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "100gm",
	  updateDateTime: "Sat 08-08-20 11:48 am",
	  count: 191
	}, {
	  availability: "AVAILABLE",
	  category: "RICE DAAL NOODLES",
	  isPopular: "YES",
	  key: "-M9bErwUjb0ZFLlRHkYo",
	  photos: [{
	    imageName: "2adcfe70-bd9e-11ea-9c87-8df410c3c074.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F2adcfe70-bd9e-11ea-9c87-8df410c3c074.jpg?alt=media&token=46f3c241-9144-437b-866d-44ee601590f8"
	  }],
	  productNameEnglish: "Masoor dhal lentils spit 500gm",
	  productPrice: "2.5",
	  productSupplier: "BCS SHOP",
	  searchText: "মশুর মসুর মুশুরি ডাল dhal dal",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "500gm",
	  updateDateTime: "17/07/2020 08:56:23",
	  count: 180
	}, {
	  availability: "AVAILABLE",
	  category: "MEAT FISH",
	  isPopular: "YES",
	  key: "-M9zpdyjH06nAqwc_-f7",
	  photos: [{
	    imageName: "be0749e0-b037-11ea-9e6b-fd3fc5d44f8f.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fbe0749e0-b037-11ea-9e6b-fd3fc5d44f8f.jpg?alt=media&token=33798c90-e1ae-418d-a0e5-22033d0d0584"
	  }],
	  productDescription: "3 pcs is 1kg",
	  productNameEnglish: "Ilish Fish - Small ",
	  productPrice: "4",
	  productSupplier: "BCS SHOP",
	  searchText: "ilish elish elis ilis ইলিশ ",
	  sortOrder: "a",
	  sourceSupplier: "TERRY TRADING CO PTE LTD",
	  supplierContactName: "arif",
	  supplierContactPhone: "84124637",
	  unit: "1 PC",
	  updateDateTime: "03/08/2020 05:23:58",
	  count: 169
	}, {
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-M9aX0eXXs2r-3O7c1OV",
	  photos: [{
	    imageName: "0a4ef8a0-f7cf-11ea-9ca4-275d4c37dc1b.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F0a4ef8a0-f7cf-11ea-9ca4-275d4c37dc1b.jpg?alt=media&token=a0cd1cab-f6c4-43c4-85eb-64e1773c957a"
	  }],
	  productNameEnglish: "PRAN MUSTARD SEEDS OIL ",
	  productPrice: "2.60 ",
	  productSupplier: "BCS SHOP",
	  searchText: "সরিষার তেল ",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "250ml",
	  updateDateTime: "Wed 16-09-20 11:45 am",
	  count: 160
	}, {
	  category: "MEAT FISH",
	  isPopular: "YES",
	  key: "-M9a3auhPEiHX8_zYJ8T",
	  photos: [{
	    imageName: "c22b5180-afbd-11ea-a37e-bd24eb8f726f.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fc22b5180-afbd-11ea-a37e-bd24eb8f726f.jpg?alt=media&token=e57daca0-c1dd-4eff-acfa-416ea81009ce"
	  }],
	  productNameEnglish: "Chicken wings ",
	  productPrice: "5",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1kg ",
	  updateDateTime: "04/07/2020 09:29:39",
	  count: 148
	}, {
	  category: "SNACKS DRY FOOD",
	  isPopular: "YES",
	  key: "-M9aaXMmcESUiLyIFlYy",
	  photos: [{
	    imageName: "5abc8280-ddee-11ea-a50a-71ea37251d72.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F5abc8280-ddee-11ea-a50a-71ea37251d72.jpg?alt=media&token=6b453a6d-88da-433e-b338-508941e8076a"
	  }],
	  productNameEnglish: "DRY CAKE pran",
	  productPrice: "2.80",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1 pkt 350g",
	  updateDateTime: "Fri 14-08-20 1:24 pm",
	  count: 146
	}, {
	  availability: "AVAILABLE",
	  category: "TUPPERWARE CONTAINER",
	  isPopular: "YES",
	  key: "-M9a0sA0Y0KbX1e3hP5d",
	  photos: [{
	    imageName: "70c59220-e8f1-11ea-b634-e7e7c4cb042d.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F70c59220-e8f1-11ea-b634-e7e7c4cb042d.jpg?alt=media&token=abcd4376-9b86-4528-91b2-fec809d6969d"
	  }],
	  productNameEnglish: "Curry Plastic String Bag",
	  productPrice: "0.70",
	  productSupplier: "BCS SHOP",
	  searchText: "কারী পেপার কারি ব্যাগ ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1 roll ",
	  updateDateTime: "Fri 28-08-20 1:43 pm",
	  count: 139
	}, {
	  availability: "AVAILABLE",
	  category: "MEAT FISH",
	  isPopular: "YES",
	  key: "-M9Y_GalhAf1EZpTmHm_",
	  photos: [{
	    imageName: "4cd98e20-afbc-11ea-a37e-bd24eb8f726f.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F4cd98e20-afbc-11ea-a37e-bd24eb8f726f.jpg?alt=media&token=5d46c383-874d-448b-9321-1d4cb2e4bd48"
	  }],
	  productNameEnglish: "Rui fish ",
	  productPrice: "6.50",
	  productSupplier: "BCS SHOP",
	  searchText: "রুই মাছ ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1kg",
	  updateDateTime: "Tue 29-09-20 4:41 pm",
	  count: 139
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-M9a0LDvo6faRtgYPazt",
	  photos: [{
	    imageName: "7327d800-e8e4-11ea-b634-e7e7c4cb042d.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F7327d800-e8e4-11ea-b634-e7e7c4cb042d.jpg?alt=media&token=01659db6-d97f-4b29-877b-f2dc6a154c60"
	  }],
	  productNameEnglish: "Salt ",
	  productPrice: "1.40",
	  productSupplier: "BCS SHOP",
	  searchText: "লবণ লবন",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1kg",
	  updateDateTime: "Fri 28-08-20 12:10 pm",
	  count: 136
	}, {
	  availability: "AVAILABLE",
	  category: "রান্না করা খাবার",
	  key: "-MCR8fQQxxiYmMT6iqAp",
	  photos: [{
	    imageName: "91ea92d0-c811-11ea-99a6-3f4f89ed7cd9.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F91ea92d0-c811-11ea-99a6-3f4f89ed7cd9.jpg?alt=media&token=b933cde8-e062-4c09-b5df-24a8f3aa6838"
	  }],
	  productNameEnglish: "কচু ভর্তা mashed taro - Delivery by taxi, pay as meter-fare. ",
	  productPrice: "1",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "1 serving ",
	  updateDateTime: "Tue 11-08-20 6:47 pm",
	  count: 131
	}, {
	  author: "+6594562455",
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-M9cNYNyXrvqE6nUaFKc",
	  photos: [{
	    imageName: "8eb5b060-aca3-11ea-b1f6-655d279c50ce.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F8eb5b060-aca3-11ea-b1f6-655d279c50ce.jpg?alt=media&token=b4c0576c-a46a-44ea-a20d-11cf008e982a"
	  }],
	  productNameEnglish: "LIMES lemon",
	  productPrice: "1.50",
	  productSupplier: "BCS SHOP",
	  searchText: "লেবু  কাগুজী ",
	  sortOrder: "a",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "250gm",
	  updateDateTime: "Sat 08-08-20 11:44 am",
	  count: 130
	}, {
	  category: "COSMETICS",
	  isPopular: "YES",
	  key: "-M9bBN6Cns4Ya5sBUZvD",
	  photos: [{
	    imageName: "f96bfd60-e8da-11ea-b634-e7e7c4cb042d.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2Ff96bfd60-e8da-11ea-b634-e7e7c4cb042d.jpg?alt=media&token=89db75f0-26ba-4dd0-a1d1-8a1edafaa6fb"
	  }],
	  productNameEnglish: "Dettol soap",
	  productPrice: "4",
	  productSupplier: "BCS SHOP",
	  searchText: "detol sop sabun",
	  sortOrder: "75g",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "pack of 4 pcs",
	  updateDateTime: "Fri 28-08-20 11:03 am",
	  count: 129
	}, {
	  author: "+6594562455",
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-M9YW2R7LfkaxZEJ6Ev5",
	  photos: [{
	    imageName: "115db770-c81e-11ea-99a6-3f4f89ed7cd9.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F115db770-c81e-11ea-99a6-3f4f89ed7cd9.jpg?alt=media&token=4fa3df14-1c00-44e4-bd8e-31b4340d72e4"
	  }],
	  productNameEnglish: "Onion ",
	  productPrice: "2.00",
	  productSupplier: "BCS SHOP",
	  searchText: "onion piaz piaj পেঁয়াজ পেয়াজ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1kg ",
	  updateDateTime: "Fri 07-08-20 8:27 pm",
	  count: 122
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-M9Y-M8Psr7VBfwBi9uI",
	  photos: [{
	    imageName: "b7c3abb0-abd1-11ea-b76c-0b360dd92c32.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fb7c3abb0-abd1-11ea-b76c-0b360dd92c32.jpg?alt=media&token=3243ad4c-9c84-4933-affc-1397c26316c9"
	  }],
	  productNameEnglish: "Cauliflower ",
	  productPrice: "5",
	  productSupplier: "BCS SHOP",
	  searchText: "ফুলকপি ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1kg ",
	  updateDateTime: "08/07/2020 06:07:38",
	  count: 122
	}, {
	  availability: "AVAILABLE",
	  category: "SNACKS DRY FOOD",
	  isPopular: "YES",
	  key: "-MA-jxAY58AOBdeov11V",
	  photos: [{
	    imageName: "49158100-b05b-11ea-8357-d5a4954c59fc.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F49158100-b05b-11ea-8357-d5a4954c59fc.jpg?alt=media&token=e3a9b308-dd01-4615-88c2-df10f1c61547"
	  }],
	  productNameEnglish: "PRAN Hot Chanachur ",
	  productPrice: "0.90",
	  productSupplier: "BCS SHOP",
	  searchText: "চানাচুর ",
	  sortOrder: "a",
	  sourceSupplier: "KHAN PRODUCTS PTE LTD.",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "150G",
	  updateDateTime: "03/08/2020 04:42:40",
	  count: 118
	}, {
	  availability: "AVAILABLE",
	  category: "রান্না করা খাবার",
	  key: "-MCQxdBRu9m2vsPCNd7-",
	  photos: [{
	    imageName: "f99a1bb0-d6e6-11ea-8976-95d75731af67.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Ff99a1bb0-d6e6-11ea-8976-95d75731af67.jpg?alt=media&token=2b4864ff-386d-4517-b542-dc96ab9531ef"
	  }],
	  productNameEnglish: "খাসির বিরানী স্পেশাল Mutton Briyani - Delivery by taxi, pay as meter-fare. ",
	  productPrice: "7",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "1 serving ",
	  updateDateTime: "Tue 11-08-20 6:43 pm",
	  count: 117
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-MBEKS4n6InBM-7Pyuqh",
	  photos: [{
	    imageName: "1192dc50-bc59-11ea-b7df-33e703b87300.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F1192dc50-bc59-11ea-b7df-33e703b87300.jpg?alt=media&token=3559c821-d04d-4d69-b4a0-7887d7e74fe6"
	  }],
	  productNameEnglish: "Green Grapes ",
	  productPrice: "4.50",
	  productSupplier: "BCS SHOP",
	  searchText: "আঙ্গুর আঙুর ",
	  sortOrder: "a",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "500gm",
	  updateDateTime: "Mon 21-09-20 3:37 pm",
	  count: 116
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-M9YGnHxxGqnARPsRDxa",
	  photos: [{
	    imageName: "b8ea5860-f733-11ea-885a-2b4d96b2f26b.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2Fb8ea5860-f733-11ea-885a-2b4d96b2f26b.jpg?alt=media&token=4a9b442e-13e4-426c-8f7d-b075c2d45a3e"
	  }],
	  productNameEnglish: "bitter melon ",
	  productPrice: "5",
	  productSupplier: "BCS SHOP",
	  searchText: "করল্লা ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1kg",
	  updateDateTime: "Fri 18-09-20 6:22 pm",
	  count: 105
	}, {
	  availability: "AVAILABLE",
	  category: "SNACKS DRY FOOD",
	  isPopular: "YES",
	  key: "-M9aVAEroX6hfNMnZlj6",
	  photos: [{
	    imageName: "f60ff850-ac59-11ea-bbe4-619ccaa778ae.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Ff60ff850-ac59-11ea-bbe4-619ccaa778ae.jpg?alt=media&token=6c8fb7e5-3e4f-4055-a03f-840ad423c18b"
	  }],
	  productNameEnglish: "RAISINS ",
	  productPrice: "2 ",
	  productSupplier: "BCS SHOP",
	  searchText: "maiwa কিচমিচ ",
	  sortOrder: "a",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "150gms",
	  updateDateTime: "23/07/2020 12:45:56",
	  count: 104
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-M9YEMBOnzZygQ5XCB9U",
	  photos: [{
	    imageName: "a7a8cfe0-abda-11ea-8036-6322e2b6fd90.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fa7a8cfe0-abda-11ea-8036-6322e2b6fd90.jpg?alt=media&token=ea2fe2d9-04bd-45fd-99b1-9933f95d19de"
	  }],
	  productNameEnglish: "calabash ",
	  productPrice: "2",
	  productSupplier: "BCS SHOP",
	  searchText: "লাউ ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1kg",
	  updateDateTime: "17/07/2020 08:32:47",
	  count: 100
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-MA4MUO3ordS6KdiUfku",
	  photos: [{
	    imageName: "47866d60-bf81-11ea-85e3-735b22b1a0db.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F47866d60-bf81-11ea-85e3-735b22b1a0db.jpg?alt=media&token=bf2dc684-71aa-4ea2-8d3f-af91965453b6"
	  }],
	  productNameEnglish: "Shim Bean",
	  productPrice: "6.50",
	  productSupplier: "BCS SHOP",
	  searchText: "শিম ছিম  sim shim seem ",
	  sortOrder: "a",
	  sourceSupplier: "Amman trading ",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1KG",
	  updateDateTime: "03/08/2020 04:26:35",
	  count: 100
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-M9aS4IY6quwHYKAvjXX",
	  photos: [{
	    imageName: "03b4edf0-ac58-11ea-bbe4-619ccaa778ae.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F03b4edf0-ac58-11ea-bbe4-619ccaa778ae.jpg?alt=media&token=0859059e-6ed2-4914-b8ea-9d5354cb1a40"
	  }],
	  productNameEnglish: "GARAM MASALA",
	  productPrice: "3.70",
	  productSupplier: "BCS SHOP",
	  searchText: "গরম মসলা ",
	  sortOrder: "a",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1pkt",
	  updateDateTime: "17/07/2020 07:51:43",
	  count: 99
	}, {
	  availability: "AVAILABLE",
	  category: "রান্না করা খাবার",
	  key: "-MCXB9pCvM1-zyyx3mEz",
	  photos: [{
	    imageName: "9fb805e0-c8fd-11ea-91d6-d9d33e68425f.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F9fb805e0-c8fd-11ea-91d6-d9d33e68425f.jpg?alt=media&token=d934f38a-071b-4e1e-b3c2-49a8a227fa38"
	  }],
	  productNameEnglish: "ভাত white rice - Delivery by taxi, pay as meter-fare. ",
	  productPrice: "1",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "Kabir",
	  supplierContactPhone: "94562455",
	  unit: "1 Serving",
	  updateDateTime: "Tue 11-08-20 6:44 pm",
	  count: 98
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  key: "-M9b0j9_hMaT1Csp0yn-",
	  photos: [{
	    imageName: "097e8f90-f89b-11ea-aaa8-a9cfb87a7f3a.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F097e8f90-f89b-11ea-aaa8-a9cfb87a7f3a.jpg?alt=media&token=376cd4db-cf71-4542-b4d0-5bcd941bce01"
	  }],
	  productNameEnglish: "ROYAL APPLE",
	  productPrice: "3 ",
	  productSupplier: "BCS SHOP",
	  searchText: "আপেল ",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "5pcs",
	  updateDateTime: "Thu 17-09-20 12:05 pm",
	  count: 97
	}, {
	  availability: "AVAILABLE",
	  category: "DRINKS DESSERT",
	  isPopular: "YES",
	  key: "-M9acdO504KEU3NWLjzn",
	  photos: [{
	    imageName: "098170d0-ac5f-11ea-bbe4-619ccaa778ae.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F098170d0-ac5f-11ea-bbe4-619ccaa778ae.jpg?alt=media&token=898f30fa-1c3b-4c88-9319-cc14e2c84f7d"
	  }],
	  productNameEnglish: "SUGAR",
	  productPrice: "1.50",
	  productSupplier: "BCS SHOP",
	  searchText: "চিনি  ",
	  sortOrder: "a",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1Kg Packet",
	  updateDateTime: "17/07/2020 07:32:49",
	  count: 96
	}, {
	  availability: "AVAILABLE",
	  category: "COSMETICS",
	  isPopular: "YES",
	  key: "-M9bU3WAyP6vNO30iLZ4",
	  photos: [{
	    imageName: "636ef970-ac80-11ea-9b70-29a530f3e931.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F636ef970-ac80-11ea-9b70-29a530f3e931.jpg?alt=media&token=c6cc4818-e3dd-490b-b005-01bff27b3f65"
	  }],
	  productNameEnglish: "Gilette blade",
	  productPrice: "1.20",
	  productSupplier: "BCS SHOP",
	  searchText: "ব্লেড",
	  sortOrder: "x",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1 Pkt",
	  updateDateTime: "17/07/2020 03:08:41",
	  count: 93
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-M9Y-cMWFKAa3SBkMufK",
	  photos: [{
	    imageName: "cce05570-abd1-11ea-b76c-0b360dd92c32.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fcce05570-abd1-11ea-b76c-0b360dd92c32.jpg?alt=media&token=cde2016d-51b6-4050-bff9-067a501c3d7e"
	  }],
	  productNameEnglish: "Cabbage ",
	  productPrice: "3.5",
	  productSupplier: "BCS SHOP",
	  searchText: "বাধাকপি পাতাকপি ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1kg",
	  updateDateTime: "08/07/2020 06:08:21",
	  count: 93
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-M9YSL-0prcztEj2MH5X",
	  photos: [{
	    imageName: "ff7c0d60-abe2-11ea-99a0-ada8a2be9f1b.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fff7c0d60-abe2-11ea-99a0-ada8a2be9f1b.jpg?alt=media&token=a59b7fe6-4135-4487-b3b1-a1ad75bf4d6d"
	  }],
	  productNameEnglish: "Broccoli ",
	  productPrice: "5.5",
	  productSupplier: "BCS SHOP",
	  searchText: "ব্রকোলি ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1kg",
	  updateDateTime: "Wed 02-12-20 10:21 am",
	  count: 91
	}, {
	  author: "+6594562455",
	  availability: "AVAILABLE",
	  category: "MEAT FISH",
	  isPopular: "YES",
	  key: "-M9YYZThoI3vTcDmU6d5",
	  photos: [{
	    imageName: "efae5970-abe6-11ea-99a0-ada8a2be9f1b.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fefae5970-abe6-11ea-99a0-ada8a2be9f1b.jpg?alt=media&token=e19b59dd-8ca4-4349-9716-82d1369e98c7"
	  }, {
	    imageName: "68b0df30-d3fd-11ea-a0e0-7d366b7a98ae.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F68b0df30-d3fd-11ea-a0e0-7d366b7a98ae.jpg?alt=media&token=4e1c3011-50be-46f0-ab15-5d380e0cb817"
	  }],
	  productNameEnglish: "Chicken",
	  productPrice: "6",
	  productSupplier: "BCS SHOP",
	  searchText: "মুরগি মুরগী ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1.5kg ",
	  updateDateTime: "01/08/2020 09:48:25",
	  count: 91
	}, {
	  availability: "AVAILABLE",
	  category: "রান্না করা খাবার",
	  key: "-MCQxtNNMYXBX8xmTm7x",
	  photos: [{
	    imageName: "8346f870-d6e6-11ea-8976-95d75731af67.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F8346f870-d6e6-11ea-8976-95d75731af67.jpg?alt=media&token=157e0fa3-00d5-4548-af23-9575bbac25a6"
	  }],
	  productNameEnglish: "খাসির খিচুরি স্পেশাল  mutton khichuri - Delivery by taxi, pay as meter-fare. ",
	  productPrice: "7",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "1 serving ",
	  updateDateTime: "Tue 11-08-20 6:42 pm",
	  count: 90
	}, {
	  availability: "AVAILABLE",
	  category: "TOILETRIES",
	  photos: [{
	    imageName: "1df0eb10-e67d-11ea-9786-7f7137f3f585.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F1df0eb10-e67d-11ea-9786-7f7137f3f585.jpg?alt=media&token=16b83173-3df0-4d56-a3b8-9911c72dd3e8"
	  }],
	  productNameEnglish: "Mama detergent powder",
	  productPrice: "2.50",
	  productSupplier: "BCS SHOP",
	  searchText: "Detergrnt powder",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "1kg",
	  updateDateTime: "Tue 25-08-20 10:46 am",
	  key: "-MFYVeAeF1eu5WHENFbn",
	  count: 89
	}, {
	  availability: "AVAILABLE",
	  category: "রান্না করা খাবার",
	  key: "-MCR0bUOwveXN1jXgscq",
	  photos: [{
	    imageName: "a4472470-c80c-11ea-99a6-3f4f89ed7cd9.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fa4472470-c80c-11ea-99a6-3f4f89ed7cd9.jpg?alt=media&token=75f78750-428d-49c2-8bd8-1c13989818a1"
	  }],
	  productNameEnglish: "শাক spinach - Delivery by taxi, pay as meter-fare. ",
	  productPrice: "1",
	  productSupplier: "BCS SHOP",
	  searchText: "",
	  sortOrder: "a",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "1 serving ",
	  updateDateTime: "Tue 11-08-20 6:48 pm",
	  count: 88
	}, {
	  availability: "AVAILABLE",
	  category: "RICE DAAL NOODLES",
	  isPopular: "YES",
	  key: "-M9_z0n6fZMwZEkO3MGg",
	  photos: [{
	    imageName: "aedfe0d0-ac45-11ea-ba1a-4bcfa8bf5006.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Faedfe0d0-ac45-11ea-ba1a-4bcfa8bf5006.jpg?alt=media&token=06c9af4c-2dc9-4c0f-a22f-eff214fdf9aa"
	  }],
	  productNameEnglish: "Rice Kali jera  ",
	  productPrice: "5",
	  productSupplier: "BCS SHOP",
	  searchText: "Kalojeera Rice zira কালো জিরা চাউল ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1kg",
	  updateDateTime: "23/07/2020 12:58:15",
	  count: 88
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-MA4Nz1M4RpvVw3tSrQR",
	  photos: [{
	    imageName: "61b7ff00-bdb5-11ea-8ba8-ddb60ef370d4.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F61b7ff00-bdb5-11ea-8ba8-ddb60ef370d4.jpg?alt=media&token=a5464231-fb92-483c-b9f6-c46abc99578d"
	  }],
	  productNameEnglish: "Pointed Gourd",
	  productPrice: "6",
	  productSupplier: "BCS SHOP",
	  searchText: "potol ",
	  sortOrder: "a",
	  sourceSupplier: "Amman trading ",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1kg",
	  updateDateTime: "03/08/2020 04:25:09",
	  count: 87
	}, {
	  availability: "AVAILABLE",
	  category: "রান্না করা খাবার",
	  key: "-MCQrmhygF7gQa3IavNv",
	  photos: [{
	    imageName: "c7335310-c806-11ea-99a6-3f4f89ed7cd9.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fc7335310-c806-11ea-99a6-3f4f89ed7cd9.jpg?alt=media&token=74f1c1e7-50d6-404a-b62f-f781706b6a25"
	  }],
	  productNameEnglish: "গরুর মাংস  Beef Curry - Delivery by taxi, pay as meter-fare. ",
	  productPrice: "5",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "1 serving ",
	  updateDateTime: "Tue 11-08-20 6:48 pm",
	  count: 86
	}, {
	  availability: "AVAILABLE",
	  category: "রান্না করা খাবার",
	  key: "-MCWkR6NjvZA27TfckdU",
	  photos: [{
	    imageName: "a9bc04d0-c8ec-11ea-91d6-d9d33e68425f.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fa9bc04d0-c8ec-11ea-91d6-d9d33e68425f.jpg?alt=media&token=29e2b7b3-d972-4465-add1-89c066ce3cd9"
	  }],
	  productNameEnglish: "ইলিশ মাছ ilish fish curry - Delivery by taxi, pay as meter-fare. ",
	  productPrice: "5",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "Kabir",
	  supplierContactPhone: "94562455",
	  unit: "1 serving ",
	  updateDateTime: "Tue 11-08-20 6:45 pm",
	  count: 86
	}, {
	  availability: "AVAILABLE",
	  category: "DRINKS DESSERT",
	  isPopular: "YES",
	  key: "-M9adMyGbl5sEoSO32-G",
	  photos: [{
	    imageName: "fa049c20-c826-11ea-99a6-3f4f89ed7cd9.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Ffa049c20-c826-11ea-99a6-3f4f89ed7cd9.jpg?alt=media&token=422a5305-33a0-4c49-b19b-91e1e0c87417"
	  }],
	  productNameEnglish: "SHEMAI",
	  productPrice: "1",
	  productSupplier: "BCS SHOP",
	  searchText: "সেমাই ",
	  sortOrder: "a",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1 pkt",
	  updateDateTime: "17/07/2020 08:13:56",
	  count: 86
	}, {
	  availability: "AVAILABLE",
	  category: "SNACKS DRY FOOD",
	  key: "-MEfelSS4pQkEVJ_ds8w",
	  photos: [{
	    imageName: "e38b6c40-ddf6-11ea-a50a-71ea37251d72.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2Fe38b6c40-ddf6-11ea-a50a-71ea37251d72.jpg?alt=media&token=f8ddf301-b918-4469-adbb-c692e52ea8ac"
	  }],
	  productNameEnglish: "sweet toast pran",
	  productPrice: "2.00",
	  productSupplier: "BCS SHOP",
	  searchText: "toast ",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "1 pkt 350g",
	  updateDateTime: "Fri 14-08-20 4:15 pm",
	  count: 86
	}, {
	  availability: "AVAILABLE",
	  category: "OTHERS",
	  photos: [{
	    imageName: "7171a1a0-0200-11eb-a8a9-31b609c2f968.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F7171a1a0-0200-11eb-a8a9-31b609c2f968.jpg?alt=media&token=ca50bf2e-b0f7-4dca-a51a-54b63e0437c8"
	  }],
	  productNameEnglish: "Socks",
	  productPrice: "2",
	  productSupplier: "BCS SHOP",
	  searchText: "মুজা",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "3 pcs",
	  updateDateTime: "Tue 29-09-20 11:04 am",
	  key: "-MIMoLyFOfruboBr4c6b",
	  count: 84
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-MA4MzYjKNqu56ROR_7d",
	  photos: [{
	    imageName: "962ee5f0-bdce-11ea-8ba8-ddb60ef370d4.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F962ee5f0-bdce-11ea-8ba8-ddb60ef370d4.jpg?alt=media&token=718ad6e5-d580-4ee0-9965-7aaee126ac23"
	  }],
	  productNameEnglish: "Taro Root ",
	  productPrice: "6",
	  productSupplier: "BCS SHOP",
	  searchText: "kochu kacha kacho কচু কচুর ছরা ",
	  sortOrder: "a",
	  sourceSupplier: "Veg mart ",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1kg",
	  updateDateTime: "03/08/2020 04:25:58",
	  count: 83
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-M9Y1KPJE0XuOLGxP41o",
	  photos: [{
	    imageName: "ea6810e0-c104-11ea-8470-83fbeadd4a74.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fea6810e0-c104-11ea-8470-83fbeadd4a74.jpg?alt=media&token=393c1c30-82f6-40e0-a6d2-e52d0ca425ad"
	  }],
	  productNameEnglish: "Ladyfinger  ",
	  productPrice: "5",
	  productSupplier: "BCS SHOP",
	  searchText: "ঢেঁড়শ ঢেঁড়স ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1kg",
	  updateDateTime: "08/07/2020 06:22:27",
	  count: 82
	}, {
	  availability: "AVAILABLE",
	  category: "TUPPERWARE CONTAINER",
	  isPopular: "YES",
	  key: "-M9YWPKH6wupC6XKrA8-",
	  photos: [{
	    imageName: "97fbbf20-abe5-11ea-99a0-ada8a2be9f1b.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F97fbbf20-abe5-11ea-99a0-ada8a2be9f1b.jpg?alt=media&token=26ed90f0-9141-4123-ba6c-745d89b1bf9b"
	  }],
	  productNameEnglish: "Makan paper ",
	  productPrice: "3.90",
	  productSupplier: "BCS SHOP",
	  searchText: "মাকান পেপার ভাতের প্যাকেট ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1 packet ",
	  updateDateTime: "17/07/2020 08:42:43",
	  count: 81
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-MA0HZHWnF1HIYhUqzL8",
	  photos: [{
	    imageName: "4b63d840-bc58-11ea-b7df-33e703b87300.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F4b63d840-bc58-11ea-b7df-33e703b87300.jpg?alt=media&token=a8a0acab-0394-4137-b528-fcb07dfc9e02"
	  }],
	  productNameEnglish: "Red Grapes",
	  productPrice: "4.50",
	  productSupplier: "BCS SHOP",
	  searchText: "লাল আঙ্গুর ",
	  sortOrder: "a",
	  sourceSupplier: "Sheng siong ",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "500gm",
	  updateDateTime: "Mon 21-09-20 3:38 pm",
	  count: 80
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-M9XzO90h7UOuD09Pl9g",
	  photos: [{
	    imageName: "e2db46b0-abd0-11ea-b76c-0b360dd92c32.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fe2db46b0-abd0-11ea-b76c-0b360dd92c32.jpg?alt=media&token=45d6c7fe-894e-4782-ad44-5339cac68c34"
	  }],
	  productNameEnglish: "Potato ",
	  productPrice: "2",
	  productSupplier: "BCS SHOP",
	  searchText: "আলু ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1kg",
	  updateDateTime: "08/07/2020 06:05:20",
	  count: 79
	}, {
	  availability: "AVAILABLE",
	  category: "PICKLES",
	  isPopular: "YES",
	  key: "-M9aWOR41HDGXQM1UaW-",
	  photos: [{
	    imageName: "ea186f50-ac81-11ea-b4b2-63d9e39acaf7.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fea186f50-ac81-11ea-b4b2-63d9e39acaf7.jpg?alt=media&token=a589dc38-cee4-4faf-9603-1d54438c10b9"
	  }],
	  productNameEnglish: "PRAN MANGO PICKLE",
	  productPrice: " 3.2",
	  productSupplier: "BCS SHOP",
	  searchText: "আমের আচার",
	  sortOrder: "a",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1 btl",
	  updateDateTime: "17/07/2020 07:38:49",
	  count: 77
	}, {
	  category: "DRINKS DESSERT",
	  key: "-M9g56tFxoB1fRkZZD9F",
	  photos: [{
	    imageName: "8f622520-ad34-11ea-9a01-db9ea96fa329.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F8f622520-ad34-11ea-9a01-db9ea96fa329.jpg?alt=media&token=1fc71b99-2a2c-426f-bdb0-2b359fdcbf25"
	  }],
	  productNameEnglish: "NESCAFE ORIGINAL 3 IN 1 INSTANT COFFEE",
	  productPrice: "7.50",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "35 per pack",
	  updateDateTime: "04/07/2020 11:24:20",
	  count: 77
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-M9aRdZyiIAso0X611a2",
	  photos: [{
	    imageName: "b8db3f50-ac57-11ea-bbe4-619ccaa778ae.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fb8db3f50-ac57-11ea-bbe4-619ccaa778ae.jpg?alt=media&token=f869a70e-0bf3-4b27-80d6-cf9145ff45c1"
	  }],
	  productNameEnglish: "CINNAMON ",
	  productPrice: "2",
	  productSupplier: "BCS SHOP",
	  searchText: "দারুচিনি",
	  sortOrder: "q",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1 pkt",
	  updateDateTime: "23/07/2020 12:52:38",
	  count: 73
	}, {
	  author: "+6589050302",
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-MA4VexMK1sATknlT1Hj",
	  photos: [{
	    imageName: "736eba60-bc55-11ea-b7df-33e703b87300.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F736eba60-bc55-11ea-b7df-33e703b87300.jpg?alt=media&token=c5088de9-6c92-4b31-bc7c-9191b79f2bac"
	  }],
	  productNameEnglish: "Red Spinach",
	  productPrice: "3.20",
	  productSupplier: "BCS SHOP",
	  searchText: "lal shak sak লাল শাক সবজি সব্জি ",
	  sortOrder: "a",
	  sourceSupplier: "Veg mart ",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1kg",
	  updateDateTime: "Tue 18-08-20 10:52 am",
	  count: 73
	}, {
	  availability: "AVAILABLE",
	  category: "PICKLES",
	  isPopular: "YES",
	  key: "-M9aW7edgmjmeVJGuQDg",
	  photos: [{
	    imageName: "906b0bb0-ac5a-11ea-bbe4-619ccaa778ae.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F906b0bb0-ac5a-11ea-bbe4-619ccaa778ae.jpg?alt=media&token=0d5ccf96-888e-4839-9527-6ee38c6b6752"
	  }],
	  productNameEnglish: "PRAN OLIVE PICKLE",
	  productPrice: "3.20",
	  productSupplier: "BCS SHOP",
	  searchText: "জলপাইর আচার",
	  sortOrder: "a",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1 btl",
	  updateDateTime: "17/07/2020 07:38:26",
	  count: 73
	}, {
	  availability: "AVAILABLE",
	  category: "DRINKS DESSERT",
	  isPopular: "YES",
	  key: "-M9abIGxJKlE1oLFhixj",
	  photos: [{
	    imageName: "4e108430-ac5e-11ea-bbe4-619ccaa778ae.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F4e108430-ac5e-11ea-bbe4-619ccaa778ae.jpg?alt=media&token=5153f384-472c-4c7e-8d5d-65c8f3afa2ca"
	  }],
	  productNameEnglish: "ISABGOL",
	  productPrice: "2.80 ",
	  productSupplier: "BCS SHOP",
	  searchText: "ইছবগুল",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1 pkt small",
	  updateDateTime: "17/07/2020 08:49:03",
	  count: 71
	}, {
	  author: "+6589050302",
	  category: "DRINKS DESSERT",
	  isPopular: "YES",
	  key: "-M9gIBXZJGdkFxuAn3mh",
	  photos: [{
	    imageName: "886561d0-ad3c-11ea-9a01-db9ea96fa329.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F886561d0-ad3c-11ea-9a01-db9ea96fa329.jpg?alt=media&token=3ab8b277-a7bf-41c9-960f-4cb0f1cb7394"
	  }],
	  productNameEnglish: "SPRITE",
	  productPrice: "2.50",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1.5L",
	  updateDateTime: "11/07/2020 07:19:01",
	  count: 69
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-M9acBvzo_FyEcT4Sy6f",
	  photos: [{
	    imageName: "ca7b4140-ac5e-11ea-bbe4-619ccaa778ae.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fca7b4140-ac5e-11ea-bbe4-619ccaa778ae.jpg?alt=media&token=4e0e8eed-939d-434c-8934-3e09de7f84a0"
	  }],
	  productNameEnglish: "GHEE",
	  productPrice: "3.80 ",
	  productSupplier: "BCS SHOP",
	  searchText: "ঘি ",
	  sortOrder: "a",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "100gms",
	  updateDateTime: "17/07/2020 07:11:57",
	  count: 69
	}, {
	  availability: "AVAILABLE",
	  category: "রান্না করা খাবার",
	  key: "-MCyaRbCwGD5sQknunF3",
	  photos: [{
	    imageName: "6cd1f460-cd53-11ea-9688-f37030ef31de.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F6cd1f460-cd53-11ea-9688-f37030ef31de.jpg?alt=media&token=b0631769-f9ff-4fef-989f-41b57c970c2f"
	  }],
	  productNameEnglish: "করলা ভাজী - Delivery by taxi, pay as meter-fare. ",
	  productPrice: "1",
	  productSupplier: "BCS SHOP",
	  sortOrder: "g",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "1 serving",
	  updateDateTime: "Tue 11-08-20 6:44 pm",
	  count: 68
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  key: "-M9azGy9V0WyqpXj0Fnx",
	  photos: [{
	    imageName: "598c4b40-f89a-11ea-aaa8-a9cfb87a7f3a.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F598c4b40-f89a-11ea-aaa8-a9cfb87a7f3a.jpg?alt=media&token=24f5c465-1f6c-436a-8cb0-abe73572625b"
	  }],
	  productNameEnglish: "PINEAPPLE ",
	  productPrice: "2",
	  productSupplier: "BCS SHOP",
	  searchText: "আনারস ",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1 pc",
	  updateDateTime: "Thu 17-09-20 12:00 pm",
	  count: 68
	}, {
	  availability: "AVAILABLE",
	  category: "MEAT FISH",
	  isPopular: "YES",
	  key: "-M9zxNO5xPdfu9fs1xXG",
	  photos: [{
	    imageName: "28148060-b03c-11ea-9737-25db4b55bc7b.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F28148060-b03c-11ea-9737-25db4b55bc7b.jpg?alt=media&token=b78474e7-b834-42be-8761-59103a522186"
	  }],
	  productNameEnglish: "Rohu Fish",
	  productPrice: "5.50",
	  productSupplier: "BCS SHOP",
	  searchText: "রুই মাছ ",
	  sortOrder: "a",
	  sourceSupplier: "AYSHA SUPERMARKET PTE LTD",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1KG",
	  updateDateTime: "03/08/2020 05:19:02",
	  count: 68
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-M9aQxDONOGmx6jfGsIZ",
	  photos: [{
	    imageName: "62e5aa00-f7d3-11ea-9ca4-275d4c37dc1b.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F62e5aa00-f7d3-11ea-9ca4-275d4c37dc1b.jpg?alt=media&token=f59c35ed-827b-4519-8f99-9a89a34bbb90"
	  }],
	  productNameEnglish: "DRY CHILLI ",
	  productPrice: "1.50",
	  productSupplier: "BCS SHOP",
	  searchText: "শুকনা মরিচ লাল মরিচ ",
	  sortOrder: "a",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1 pkt",
	  updateDateTime: "Wed 16-09-20 12:16 pm",
	  count: 68
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-M9aPVOkQxrHnTECKuuC",
	  photos: [{
	    imageName: "da671460-de06-11ea-a50a-71ea37251d72.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2Fda671460-de06-11ea-a50a-71ea37251d72.jpg?alt=media&token=f5a3c8c0-fcc1-4da3-a7ee-be044efff30e"
	  }],
	  productNameEnglish: "DC CUMIN POWDER ",
	  productPrice: "3.80",
	  productSupplier: "BCS SHOP",
	  searchText: "জিরার গুঁড়া পাউডার ",
	  sortOrder: "a",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1 btl 200g",
	  updateDateTime: "Fri 14-08-20 4:20 pm",
	  count: 66
	}, {
	  availability: "AVAILABLE",
	  category: "MEAT FISH",
	  isPopular: "YES",
	  key: "-M9aa9kk1vImV8YpWvXX",
	  photos: [{
	    imageName: "575f2290-ac5d-11ea-a00d-954b17f61eb9.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F575f2290-ac5d-11ea-a00d-954b17f61eb9.jpg?alt=media&token=48cef136-ff9c-468a-945c-3a86b315c180"
	  }],
	  productNameEnglish: "Olive bard ",
	  productPrice: "5.5",
	  productSupplier: "BCS SHOP",
	  searchText: "মাছ ",
	  sortOrder: "d",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1kg",
	  updateDateTime: "17/07/2020 07:36:39",
	  count: 66
	}, {
	  availability: "AVAILABLE",
	  category: "SNACKS DRY FOOD",
	  isPopular: "YES",
	  key: "-MA-kPUXlw_fuYi26H_Z",
	  photos: [{
	    imageName: "7ae9a1b0-bb79-11ea-9bec-f98d55a4d196.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F7ae9a1b0-bb79-11ea-9bec-f98d55a4d196.jpg?alt=media&token=07e55a5f-06fe-4b12-8cf2-52100c798bac"
	  }],
	  productNameEnglish: "PRAN Hot Chanachur - Bombay Mix",
	  productPrice: "2",
	  productSupplier: "BCS SHOP",
	  searchText: "চানাচুর ",
	  sortOrder: "a",
	  sourceSupplier: "RAJDHANI ENTERPRISE PTE LTD",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "300gm",
	  updateDateTime: "03/08/2020 04:40:42",
	  count: 65
	}, {
	  availability: "AVAILABLE",
	  category: "EGGS DAIRY",
	  isPopular: "YES",
	  key: "-M9YV1R47lPAdYHNFpMi",
	  photos: [{
	    imageName: "ceed5840-f898-11ea-aaa8-a9cfb87a7f3a.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2Fceed5840-f898-11ea-aaa8-a9cfb87a7f3a.jpg?alt=media&token=e54b879e-b9c1-451e-9290-c805bc6c07a5"
	  }],
	  productNameEnglish: "Egg ",
	  productPrice: "2.80",
	  productSupplier: "BCS SHOP",
	  searchText: "ডিম ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "10pcs",
	  updateDateTime: "Thu 17-09-20 11:49 am",
	  count: 64
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-M9aRBklNAIDF9JOcKsC",
	  photos: [{
	    imageName: "55b9f160-f738-11ea-885a-2b4d96b2f26b.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F55b9f160-f738-11ea-885a-2b4d96b2f26b.jpg?alt=media&token=16644f6d-4e4a-4cca-a4a7-9502e87dca56"
	  }],
	  productNameEnglish: "BAY LEAF",
	  productPrice: "1.40",
	  productSupplier: "BCS SHOP",
	  searchText: "তেজ পাতা",
	  sortOrder: "a",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1 pkt",
	  updateDateTime: "Tue 15-09-20 5:47 pm",
	  count: 64
	}, {
	  availability: "AVAILABLE",
	  category: "রান্না করা খাবার",
	  key: "-MCQu3407vHD39i2hP0P",
	  photos: [{
	    imageName: "2debe7b0-c808-11ea-99a6-3f4f89ed7cd9.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F2debe7b0-c808-11ea-99a6-3f4f89ed7cd9.jpg?alt=media&token=94f03c54-1eaa-4189-b193-07e206a6ef52"
	  }],
	  productNameEnglish: "খাসির মাংস Mutton curry - Delivery by taxi, pay as meter-fare. ",
	  productPrice: "5",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "1 serving",
	  updateDateTime: "Tue 11-08-20 6:43 pm",
	  count: 63
	}, {
	  author: "+6589050302",
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-M9bFJPUfqMNttFWJLgM",
	  photos: [{
	    imageName: "63ca27e0-ac77-11ea-8ded-437354ec7423.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F63ca27e0-ac77-11ea-8ded-437354ec7423.jpg?alt=media&token=f6e057d7-8089-4ce0-9410-6a43081ccbe4"
	  }],
	  productNameEnglish: "Vegetable oil",
	  productPrice: "9.50",
	  productSupplier: "BCS SHOP",
	  searchText: "তেল তৈল ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "5L Bottle",
	  updateDateTime: "29/07/2020 02:40:39",
	  count: 62
	}, {
	  availability: "AVAILABLE",
	  category: "RICE DAAL NOODLES",
	  isPopular: "YES",
	  key: "-M9bEiKuAy12yg2CASFh",
	  photos: [{
	    imageName: "fe2216d0-b231-11ea-b6a3-23fbd917d0cb.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Ffe2216d0-b231-11ea-b6a3-23fbd917d0cb.jpg?alt=media&token=6f51e17b-1284-472c-90f3-49df7ecd0d3f"
	  }],
	  productNameEnglish: "Moong dhal lentils ",
	  productPrice: "2.5",
	  productSupplier: "BCS SHOP",
	  searchText: "mug dal mog mong mag dhal ডাল",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "409gm",
	  updateDateTime: "17/07/2020 08:55:42",
	  count: 62
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-M9bJ5RXMyXyUlmbf8WR",
	  photos: [{
	    imageName: "bdc954d0-ac79-11ea-90b2-195942e61adb.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fbdc954d0-ac79-11ea-90b2-195942e61adb.jpg?alt=media&token=02b0bb15-a44b-4c94-816e-2f64d4f63033"
	  }],
	  productNameEnglish: "Vegetable oil",
	  productPrice: "2.8",
	  productSupplier: "BCS SHOP",
	  searchText: "তেল তৈল",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1L Bottle",
	  updateDateTime: "17/07/2020 03:13:04",
	  count: 62
	}, {
	  category: "MEAT FISH",
	  key: "-M9b6XWMW4dWuzwjBQDW",
	  photos: [{
	    imageName: "0e1f8f60-ac72-11ea-8ded-437354ec7423.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F0e1f8f60-ac72-11ea-8ded-437354ec7423.jpg?alt=media&token=9d5f7d1b-3bcc-467b-b82a-76ad2703a339"
	  }],
	  productNameEnglish: "Chicken",
	  productPrice: "3.5",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1pc 800gm",
	  updateDateTime: "04/07/2020 11:32:06",
	  count: 61
	}, {
	  category: "MEAT FISH",
	  isPopular: "YES",
	  key: "-M9zxx8mwFMeson_IRkz",
	  photos: [{
	    imageName: "d1e6c670-b03c-11ea-9737-25db4b55bc7b.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fd1e6c670-b03c-11ea-9737-25db4b55bc7b.jpg?alt=media&token=9c8f5020-1867-4b38-8fa7-597e616207f2"
	  }],
	  productNameEnglish: "Catla Fish",
	  productPrice: "5.50",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  sourceSupplier: "AYSHA SUPERMARKET PTE LTD",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1KG",
	  updateDateTime: "03/08/2020 05:23:26",
	  count: 60
	}, {
	  availability: "AVAILABLE",
	  category: "রান্না করা খাবার",
	  key: "-MCR7zvnQzc1AeZpRsk0",
	  photos: [{
	    imageName: "3a79ee10-c811-11ea-99a6-3f4f89ed7cd9.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F3a79ee10-c811-11ea-99a6-3f4f89ed7cd9.jpg?alt=media&token=a26699e9-de8d-4e6a-86bf-04274fbcd3d8"
	  }],
	  productNameEnglish: "মিক্স সব্জি mixed vege - Delivery by taxi, pay as meter-fare. ",
	  productPrice: "1",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "1 serving ",
	  updateDateTime: "Tue 11-08-20 6:47 pm",
	  count: 59
	}, {
	  availability: "AVAILABLE",
	  category: "EGGS DAIRY",
	  isPopular: "YES",
	  key: "-MABkOB9PgFDrB6Dv8D_",
	  photos: [{
	    imageName: "de9c87a0-bc4f-11ea-b7df-33e703b87300.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fde9c87a0-bc4f-11ea-b7df-33e703b87300.jpg?alt=media&token=8606e8f7-8b04-43b7-b055-09d58a6c0147"
	  }],
	  productNameEnglish: "Nestle Everyday Intant Milk Powder",
	  productPrice: "11",
	  productSupplier: "BCS SHOP",
	  searchText: "milk dudh dod ধুদ ",
	  sortOrder: "c",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "600gm",
	  updateDateTime: "Tue 18-08-20 9:35 am",
	  count: 58
	}, {
	  availability: "AVAILABLE",
	  category: "SNACKS DRY FOOD",
	  isPopular: "YES",
	  key: "-MA-oxGQ_WnEFDAPleoG",
	  photos: [{
	    imageName: "5e3f1ac0-b216-11ea-921f-9db4b33fb426.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F5e3f1ac0-b216-11ea-921f-9db4b33fb426.jpg?alt=media&token=c75ffd76-551e-448c-b3bd-a8bab4d76e16"
	  }],
	  productNameEnglish: "PRAN Special Toast Biscuit ",
	  productPrice: "2",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  sourceSupplier: "TERRY TRADING CO PTE LTD",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "350g",
	  updateDateTime: "03/08/2020 04:38:34",
	  count: 56
	}, {
	  availability: "AVAILABLE",
	  category: "OTHERS",
	  isPopular: "YES",
	  key: "-MAuUm3Qs70W-bsoD_Ci",
	  photos: [{
	    imageName: "8ae9f9d0-01ff-11eb-b3c7-236ec5a8a539.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F8ae9f9d0-01ff-11eb-b3c7-236ec5a8a539.jpg?alt=media&token=d22c1735-ae5c-424a-a3b6-ba84cb76dcb4"
	  }],
	  productNameEnglish: "Lungi - Bangladeshi & large size",
	  productPrice: "10",
	  productSupplier: "BCS SHOP",
	  searchText: "longi loongi lunge লুঙ্গি লুঙ্গী ",
	  sortOrder: "m",
	  sourceSupplier: "TANMOY ENTERPRISE PTE LTD",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "1 pc",
	  updateDateTime: "Tue 29-09-20 10:57 am",
	  count: 55
	}, {
	  category: "COSMETICS",
	  isPopular: "YES",
	  key: "-MA-sRL3qefgUMb_UOtv",
	  photos: [{
	    imageName: "1a2d7c20-b214-11ea-921f-9db4b33fb426.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F1a2d7c20-b214-11ea-921f-9db4b33fb426.jpg?alt=media&token=4e348ad6-5cfa-47ed-82bb-f1c7a4ef338c"
	  }],
	  productNameEnglish: "Fair and Handsome Advanced Whitening Cream",
	  productPrice: "4.20",
	  productSupplier: "BCS SHOP",
	  searchText: "fair & handsome ফেইস ক্রিম",
	  sortOrder: "x",
	  sourceSupplier: "MUSTAFA CENTRE",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "50G",
	  updateDateTime: "17/07/2020 06:32:49",
	  count: 55
	}, {
	  author: "+6589050302",
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-MA4XcGeK3fGezqp242G",
	  photos: [{
	    imageName: "9635a610-bdb5-11ea-8ba8-ddb60ef370d4.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F9635a610-bdb5-11ea-8ba8-ddb60ef370d4.jpg?alt=media&token=f349ff7f-4bf3-4fff-bd73-0269501e0056"
	  }],
	  productNameEnglish: "Green Papaya",
	  productPrice: "3.50",
	  productSupplier: "BCS SHOP",
	  searchText: "kacha pepe কাচা পেঁপে পেপে ",
	  sortOrder: "a",
	  sourceSupplier: "Veg mart ",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1kg",
	  updateDateTime: "Fri 21-08-20 4:31 pm",
	  count: 54
	}, {
	  availability: "AVAILABLE",
	  category: "RICE DAAL NOODLES",
	  isPopular: "YES",
	  key: "-M9faHN_6liw96XMkKvd",
	  photos: [{
	    imageName: "1f949a60-ad21-11ea-9a01-db9ea96fa329.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F1f949a60-ad21-11ea-9a01-db9ea96fa329.jpg?alt=media&token=cc2aeda7-af86-483b-a3e1-2cd897649ea3"
	  }],
	  productNameEnglish: "MAGGI 2-MIN CURRY NOODLES",
	  productPrice: "2.90",
	  productSupplier: "BCS SHOP",
	  searchText: "mi goreng",
	  sortOrder: "a",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "5x79g Packets",
	  updateDateTime: "17/07/2020 06:54:18",
	  count: 53
	}, {
	  availability: "AVAILABLE",
	  category: "RICE DAAL NOODLES",
	  isPopular: "YES",
	  key: "-M9aVSMCT5Ptf6z4V_RH",
	  photos: [{
	    imageName: "39359b30-ac5a-11ea-abb9-bdb7271566ee.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F39359b30-ac5a-11ea-abb9-bdb7271566ee.jpg?alt=media&token=bc3b3ed4-680c-4e06-89a9-78472234b2f4"
	  }],
	  productNameEnglish: "Rice ",
	  productPrice: "14.9",
	  productSupplier: "BCS SHOP",
	  searchText: "চাউল ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "10kg",
	  updateDateTime: "23/07/2020 12:45:01",
	  count: 53
	}, {
	  availability: "AVAILABLE",
	  category: "POPULAR",
	  isPopular: "YES",
	  key: "-M9fIeLqNa6uImfqltyH",
	  photos: [{
	    imageName: "9354b8a0-f97e-11ea-8999-bfa3df93f633.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F9354b8a0-f97e-11ea-8999-bfa3df93f633.jpg?alt=media&token=3718d897-6ec4-4b58-992b-e029e262f565"
	  }],
	  productNameEnglish: "Carrot 1kg ",
	  productPrice: "3.5",
	  productSupplier: "BCS SHOP",
	  searchText: "শাক সবজি সব্জি গাঁজর গাজর ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1kg",
	  updateDateTime: "Fri 18-09-20 3:14 pm",
	  count: 53
	}, {
	  category: "RICE DAAL NOODLES",
	  isPopular: "YES",
	  key: "-MA-qjY8tZLSruvj_oBv",
	  photos: [{
	    imageName: "6201d390-b05f-11ea-8357-d5a4954c59fc.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F6201d390-b05f-11ea-8357-d5a4954c59fc.jpg?alt=media&token=75707566-396b-4928-bd91-e700686d6a6f"
	  }],
	  productNameEnglish: "PRAN Chinigura Aromatic Rice",
	  productPrice: "4.50",
	  productSupplier: "BCS SHOP",
	  searchText: "পুলাওর চাউল ",
	  sortOrder: "a",
	  sourceSupplier: "AYSHA SUPERMARKET PTE LTD",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1Kg",
	  updateDateTime: "03/08/2020 04:35:31",
	  count: 52
	}, {
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-M9YUfCHK8nxBXdjiJRN",
	  photos: [{
	    imageName: "630beac0-abe4-11ea-99a0-ada8a2be9f1b.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F630beac0-abe4-11ea-99a0-ada8a2be9f1b.jpg?alt=media&token=983ece57-623a-4c70-9ba4-de656b02edde"
	  }],
	  productNameEnglish: "Sponge ",
	  productPrice: "1.5",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1kg",
	  updateDateTime: "04/07/2020 09:21:27",
	  count: 52
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-M9cLdWJVsksCUdGRgRj",
	  photos: [{
	    imageName: "644cdde0-aca2-11ea-b1f6-655d279c50ce.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F644cdde0-aca2-11ea-b1f6-655d279c50ce.jpg?alt=media&token=8d7f8193-7f41-41f3-a64e-429368edbbdd"
	  }],
	  productNameEnglish: "BRINJAL ",
	  productPrice: "5",
	  productSupplier: "BCS SHOP",
	  searchText: "বেগুন বেগূন",
	  sortOrder: "a",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1kg",
	  updateDateTime: "17/07/2020 02:52:35",
	  count: 52
	}, {
	  availability: "AVAILABLE",
	  category: "EGGS DAIRY",
	  isPopular: "YES",
	  key: "-MABjiEtSQvbCSB-t1ux",
	  photos: [{
	    imageName: "ae547e80-bc50-11ea-b7df-33e703b87300.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fae547e80-bc50-11ea-b7df-33e703b87300.jpg?alt=media&token=e5e3a84e-1a4e-44e5-bea6-9e551bb27f0c"
	  }],
	  productNameEnglish: "Nestle Everyday Intant Milk Powder",
	  productPrice: "6",
	  productSupplier: "BCS SHOP",
	  searchText: "milk dudh dod powder ধুদ ",
	  sortOrder: "c",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "300gm",
	  updateDateTime: "03/08/2020 04:11:05",
	  count: 51
	}, {
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-MA0JocbXImUuWFjH6Ch",
	  photos: [{
	    imageName: "b27d3680-b211-11ea-921f-9db4b33fb426.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fb27d3680-b211-11ea-921f-9db4b33fb426.jpg?alt=media&token=13981dc9-eabd-4cd2-a395-3bb289017930"
	  }],
	  productNameEnglish: "Bottle Gourd",
	  productPrice: "3",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  sourceSupplier: "S.K.K minimart ",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1Kg",
	  updateDateTime: "03/08/2020 04:29:22",
	  count: 51
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-M9YXM8PU-56kPNuswb1",
	  photos: [{
	    imageName: "2d402df0-abe6-11ea-99a0-ada8a2be9f1b.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F2d402df0-abe6-11ea-99a0-ada8a2be9f1b.jpg?alt=media&token=cf7ca708-43d5-43a4-8d59-f2d6ccc47bfe"
	  }],
	  productNameEnglish: "Spiny gourd ",
	  productPrice: " 5.5",
	  productSupplier: "BCS SHOP",
	  searchText: "কারকল ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1kg",
	  updateDateTime: "17/07/2020 07:23:30",
	  count: 50
	}, {
	  availability: "AVAILABLE",
	  category: "DRINKS DESSERT",
	  key: "-MEfRF_oewwv035TCXPk",
	  photos: [{
	    imageName: "9201ae00-ddee-11ea-a50a-71ea37251d72.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F9201ae00-ddee-11ea-a50a-71ea37251d72.jpg?alt=media&token=483d8be6-e128-48ee-aa65-270258f8b6f8"
	  }],
	  productNameEnglish: "basil seeds tukma Pran",
	  productPrice: "1.8",
	  productSupplier: "BCS SHOP",
	  searchText: "tukma dana ",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "1 pkt 100g",
	  updateDateTime: "Fri 14-08-20 4:13 pm",
	  count: 50
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  key: "-MEfybskqSgPAmRbKKRe",
	  photos: [{
	    imageName: "55e9df40-de03-11ea-a50a-71ea37251d72.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F55e9df40-de03-11ea-a50a-71ea37251d72.jpg?alt=media&token=afed655d-6893-410d-8ca2-55fe79475e68"
	  }],
	  productNameEnglish: "turmeric powder pran",
	  productPrice: "3.80",
	  productSupplier: "BCS SHOP",
	  searchText: "holud",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "1 jar 250g",
	  updateDateTime: "Fri 14-08-20 4:17 pm",
	  count: 47
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  key: "-M9Y4AEtGCuFmPazEOcn",
	  photos: [{
	    imageName: "428601a0-f734-11ea-885a-2b4d96b2f26b.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F428601a0-f734-11ea-885a-2b4d96b2f26b.jpg?alt=media&token=3437c6f2-a9e1-4f33-b7e9-482a9694df90"
	  }],
	  productNameEnglish: "Eggplant ",
	  productPrice: "5",
	  productSupplier: "BCS SHOP",
	  searchText: "গোল বেগুন ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1KG",
	  updateDateTime: "Tue 15-09-20 5:17 pm",
	  count: 47
	}, {
	  availability: "AVAILABLE",
	  category: "RICE DAAL NOODLES",
	  isPopular: "",
	  key: "-ME2kI4Y8ht02vbEv9uV",
	  photos: [{
	    imageName: "c2f04820-d7de-11ea-942d-b9f1e760c600.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fc2f04820-d7de-11ea-942d-b9f1e760c600.jpg?alt=media&token=3c4cd649-eeea-4e59-ba14-27e37a6cd9e9"
	  }],
	  productNameEnglish: "Rice - house brand 25kg",
	  productPrice: "34",
	  productSupplier: "BCS SHOP",
	  searchText: "rice",
	  sortOrder: "a",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "25kg",
	  updateDateTime: "Wed 02-12-20 10:20 am",
	  count: 47
	}, {
	  availability: "AVAILABLE",
	  category: "SNACKS DRY FOOD",
	  isPopular: "YES",
	  key: "-M9aUta2ZW3uTbaB-UsJ",
	  photos: [{
	    imageName: "d7e77b00-ac59-11ea-bbe4-619ccaa778ae.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fd7e77b00-ac59-11ea-bbe4-619ccaa778ae.jpg?alt=media&token=e82f3068-a359-4d59-ad04-7a1317b3da4c"
	  }],
	  productNameEnglish: "ALMOND ",
	  productPrice: "2",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1 pkt",
	  updateDateTime: "23/07/2020 12:46:52",
	  count: 45
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  key: "-M9cYGhK2EUcpGwMdTBz",
	  photos: [{
	    imageName: "1a317c90-acaa-11ea-ab51-0f18e1d42bbd.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F1a317c90-acaa-11ea-ab51-0f18e1d42bbd.jpg?alt=media&token=63c6c4c7-00e2-4f0d-bfde-00a4e9080c96"
	  }],
	  productNameEnglish: "PUMPKIN (1kg)",
	  productPrice: "4",
	  productSupplier: "BCS SHOP",
	  searchText: "মিষ্টি কুমড়া মিস্টি ",
	  sortOrder: "g",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1kg",
	  updateDateTime: "17/07/2020 02:43:00",
	  count: 45
	}, {
	  availability: "AVAILABLE",
	  category: "EGGS DAIRY",
	  isPopular: "YES",
	  key: "-M9ayXnPTIZLPeIsVKIy",
	  photos: [{
	    imageName: "859f9950-bf8b-11ea-85e3-735b22b1a0db.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F859f9950-bf8b-11ea-85e3-735b22b1a0db.jpg?alt=media&token=feeb6233-fae4-4319-b830-d02a86d405de"
	  }],
	  productNameEnglish: "Meiji milk ",
	  productPrice: "6",
	  productSupplier: "BCS SHOP",
	  searchText: "fresh milk দুধ গরুর দুধ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "2L",
	  updateDateTime: "06/07/2020 09:24:42",
	  count: 45
	}, {
	  availability: "AVAILABLE",
	  category: "রান্না করা খাবার",
	  key: "-MCRA-WbZ8wZGd0NCVYC",
	  photos: [{
	    imageName: "6d422780-c812-11ea-99a6-3f4f89ed7cd9.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F6d422780-c812-11ea-99a6-3f4f89ed7cd9.jpg?alt=media&token=245e524c-7edc-46d9-b689-500b37ea48ea"
	  }],
	  productNameEnglish: "আলুর ভর্তা spicy mashed potato - Delivery by taxi, pay as meter-fare. ",
	  productPrice: "1",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "1 serving ",
	  updateDateTime: "Tue 11-08-20 6:46 pm",
	  count: 44
	}, {
	  availability: "AVAILABLE",
	  category: "PICKLES",
	  isPopular: "YES",
	  key: "-M9aVn49Kj6Vx8QpDqtJ",
	  photos: [{
	    imageName: "566ba230-ac5a-11ea-bbe4-619ccaa778ae.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F566ba230-ac5a-11ea-bbe4-619ccaa778ae.jpg?alt=media&token=ac9d7b01-1703-49c2-b16a-523110e1c10c"
	  }],
	  productNameEnglish: "PRAN CHILLI PICKLE",
	  productPrice: "3.2",
	  productSupplier: "BCS SHOP",
	  searchText: "মরিচের আচার ",
	  sortOrder: "a",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1 btl",
	  updateDateTime: "17/07/2020 07:38:21",
	  count: 44
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  key: "-MGajFuMfZ35eVylCMyq",
	  photos: [{
	    imageName: "40f06ea0-f0bf-11ea-ba7d-67bd2d78e913.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F40f06ea0-f0bf-11ea-ba7d-67bd2d78e913.jpg?alt=media&token=82428541-1ba2-4944-87ee-192f3a6c0338"
	  }],
	  productNameEnglish: "Garlic 1 bag",
	  productPrice: "9",
	  productSupplier: "BCS SHOP",
	  searchText: "Garlic",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "1 bag",
	  updateDateTime: "Mon 07-09-20 12:45 pm",
	  count: 44
	}, {
	  availability: "AVAILABLE",
	  category: "MEAT FISH",
	  isPopular: "YES",
	  key: "-M9a01C0di5V5yqY-TI8",
	  photos: [{
	    imageName: "f7b6c520-ac46-11ea-ba1a-4bcfa8bf5006.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Ff7b6c520-ac46-11ea-ba1a-4bcfa8bf5006.jpg?alt=media&token=979f21dc-bcfe-45bb-9a80-9574a3b8c01d"
	  }],
	  productNameEnglish: "Beef liver ",
	  productPrice: "5.5",
	  productSupplier: "BCS SHOP",
	  searchText: "গরুর কলিজা ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1kg",
	  updateDateTime: "23/07/2020 12:57:35",
	  count: 43
	}, {
	  category: "RICE DAAL NOODLES",
	  key: "-M9bEIvlWNBonUmZ9tjK",
	  photos: [{
	    imageName: "d8406a40-ac76-11ea-8ded-437354ec7423.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fd8406a40-ac76-11ea-8ded-437354ec7423.jpg?alt=media&token=e36c2ce6-7cbb-4953-a788-e97be6dd7d76"
	  }],
	  productNameEnglish: "House yellow gran",
	  productPrice: "2.5",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "500g",
	  updateDateTime: "04/07/2020 08:37:06",
	  count: 43
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  key: "-M9f5MRLGTyvg4nAONHR",
	  photos: [{
	    imageName: "ac00d520-f896-11ea-aaa8-a9cfb87a7f3a.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2Fac00d520-f896-11ea-aaa8-a9cfb87a7f3a.jpg?alt=media&token=fc3dcaf3-9569-432a-90d7-4eb1f19a07bc"
	  }],
	  productNameEnglish: "Lychee",
	  productPrice: "3.5",
	  productSupplier: "BCS SHOP",
	  searchText: "লিচু লীচু ফল ",
	  sortOrder: "g",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "500gm",
	  updateDateTime: "Thu 17-09-20 11:34 am",
	  count: 43
	}, {
	  author: "+6584124637",
	  isPopular: "YES",
	  key: "-M94SdSeP41Szh-wrWfT",
	  photos: [{
	    imageName: "6412cc70-a74f-11ea-a14e-4374971e8751.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F6412cc70-a74f-11ea-a14e-4374971e8751.jpg?alt=media&token=a0cc3232-a09a-4453-bf63-1dcaeea80e83"
	  }, {
	    imageName: "7af12360-a74f-11ea-a14e-4374971e8751.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F7af12360-a74f-11ea-a14e-4374971e8751.jpg?alt=media&token=f25c18cd-576f-4418-b0b8-b1fa02598ee9"
	  }],
	  productDescription: "Free prayer mats for migrant brothers who does not have prayer mat. ",
	  productNameEnglish: "Prayer mats ",
	  productPrice: "Free ",
	  productSupplier: "FREE PRAYER MAT",
	  supplierContactName: "Kabir",
	  supplierContactPhone: "94562455",
	  updateDateTime: "17/06/2020 10:35:38",
	  count: 41
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-MABXAIcpABQfGW7lI7F",
	  photos: [{
	    imageName: "b64648c0-bf80-11ea-85e3-735b22b1a0db.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fb64648c0-bf80-11ea-85e3-735b22b1a0db.jpg?alt=media&token=f787ebe8-3b5d-45b6-b77a-338e1b461c99"
	  }],
	  productNameEnglish: "Orange (Malta)",
	  productPrice: "6",
	  productSupplier: "BCS SHOP",
	  searchText: "komola malta কমলা মালটা ",
	  sortOrder: "a",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "5 pcs",
	  updateDateTime: "03/08/2020 03:56:14",
	  count: 41
	}, {
	  availability: "AVAILABLE",
	  category: "DRINKS DESSERT",
	  isPopular: "YES",
	  key: "-M9afcR3fAF6iuy36Ovu",
	  photos: [{
	    imageName: "0d7136b0-ac61-11ea-bbe4-ef7bbce60778.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F0d7136b0-ac61-11ea-bbe4-ef7bbce60778.jpg?alt=media&token=a377c659-95bc-41e7-86eb-c1a85c6d4774"
	  }],
	  productNameEnglish: "Coffee ye ye ",
	  productPrice: "13.50",
	  productSupplier: "BCS SHOP",
	  searchText: "কফি ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "100pcs",
	  updateDateTime: "17/07/2020 08:12:24",
	  count: 40
	}, {
	  availability: "AVAILABLE",
	  category: "MEAT FISH",
	  isPopular: "YES",
	  key: "-M9a_0-2n-GYPYpy2QX6",
	  photos: [{
	    imageName: "e04f6610-ac5c-11ea-a00d-954b17f61eb9.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fe04f6610-ac5c-11ea-a00d-954b17f61eb9.jpg?alt=media&token=d08dcef5-139c-492a-92aa-18b9655b6dc6"
	  }],
	  productNameEnglish: "prawns $16 to $30/1kg",
	  productPrice: "18",
	  productSupplier: "BCS SHOP",
	  searchText: "চিংড়ি মাছ ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1 kg",
	  updateDateTime: "23/07/2020 12:43:05",
	  count: 40
	}, {
	  availability: "AVAILABLE",
	  category: "SNACKS DRY FOOD",
	  key: "-MEfmmg-H4wL9EEg2t16",
	  photos: [{
	    imageName: "68c74100-ddfb-11ea-a50a-71ea37251d72.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F68c74100-ddfb-11ea-a50a-71ea37251d72.jpg?alt=media&token=1da3667b-b911-4aba-a5a9-be787b749aa7"
	  }],
	  productNameEnglish: "chanachur hot 150g pran",
	  productPrice: "0.90",
	  productSupplier: "BCS SHOP",
	  searchText: "chanachur ",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "1 pkt 150g",
	  updateDateTime: "Fri 14-08-20 4:16 pm",
	  count: 40
	}, {
	  availability: "AVAILABLE",
	  category: "রান্না করা খাবার",
	  key: "-MCR8w6gC2C8s2l4M1hd",
	  photos: [{
	    imageName: "c551e7e0-c811-11ea-99a6-3f4f89ed7cd9.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fc551e7e0-c811-11ea-99a6-3f4f89ed7cd9.jpg?alt=media&token=aa22d044-dabd-49c5-bbe6-35ac8325053f"
	  }],
	  productNameEnglish: "ছুট মাছ  small fish curry - Delivery by taxi, pay as meter-fare. ",
	  productPrice: "4",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "1 serving ",
	  updateDateTime: "Tue 11-08-20 6:46 pm",
	  count: 39
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  key: "-MFLZTbxvM6MFf8kb2ym",
	  photos: [{
	    imageName: "ac2a8d60-e483-11ea-8a88-a93d6c394935.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2Fac2a8d60-e483-11ea-8a88-a93d6c394935.jpg?alt=media&token=6a9d6725-42f2-4ccc-bc4f-d6db00e37be1"
	  }],
	  productNameEnglish: "Red chilli ",
	  productPrice: "1.5",
	  productSupplier: "BCS SHOP",
	  searchText: "লাল কাঁচা মরিচ",
	  sortOrder: "a",
	  supplierContactName: "Kabir",
	  supplierContactPhone: "94562455",
	  unit: "200g",
	  updateDateTime: "Wed 02-12-20 10:21 am",
	  count: 39
	}, {
	  availability: "AVAILABLE",
	  category: "SNACKS DRY FOOD",
	  isPopular: "NO",
	  key: "-M9aaC7nHYMy5XdSKVR6",
	  photos: [{
	    imageName: "bcdbf850-ac5d-11ea-bbe4-619ccaa778ae.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fbcdbf850-ac5d-11ea-bbe4-619ccaa778ae.jpg?alt=media&token=af322bc6-c4d3-4053-a024-e9a32cee307d"
	  }],
	  productNameEnglish: "TOAST ",
	  productPrice: "2",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1 pkt",
	  updateDateTime: "23/07/2020 12:32:33",
	  count: 38
	}, {
	  availability: "AVAILABLE",
	  category: "DRINKS DESSERT",
	  key: "-MCFqELs7pn6hJ5HC77t",
	  photos: [{
	    imageName: "07c78780-c658-11ea-8937-41f6a00ee84d.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F07c78780-c658-11ea-8937-41f6a00ee84d.jpg?alt=media&token=2640edda-a253-4dc8-92b4-00b85773333a"
	  }],
	  productNameEnglish: "Red Bull Energy Drink",
	  productPrice: "6.70",
	  productSupplier: "BCS SHOP",
	  searchText: "রেডবুল ",
	  sortOrder: "g",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "6 pcs x 250ml",
	  updateDateTime: "03/08/2020 03:26:32",
	  count: 38
	}, {
	  availability: "OUT OF STOCK, TOPPING UP IN PROGRESS",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-MDxtMUlxU5qBOzL7Irf",
	  photos: [{
	    imageName: "e47946b0-d6fb-11ea-82eb-219eb13e1aa0.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fe47946b0-d6fb-11ea-82eb-219eb13e1aa0.jpg?alt=media&token=c332da8e-6d70-4b27-8bc2-3906dab13ee0"
	  }],
	  productNameEnglish: "Sunflower oil ",
	  productPrice: "13.50",
	  productSupplier: "BCS SHOP",
	  searchText: "G",
	  sortOrder: "G",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "5L",
	  updateDateTime: "Wed 16-09-20 11:35 am",
	  count: 37
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  key: "-MEg0nusCP-6UF_64iQi",
	  photos: [{
	    imageName: "32a793a0-de04-11ea-a50a-71ea37251d72.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F32a793a0-de04-11ea-a50a-71ea37251d72.jpg?alt=media&token=bab13879-c2b9-44db-81c6-f210583f03d9"
	  }],
	  productNameEnglish: "coriander powder pran",
	  productPrice: "2.5",
	  productSupplier: "BCS SHOP",
	  searchText: "coriander",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "1 jar 200g",
	  updateDateTime: "Fri 14-08-20 4:43 pm",
	  count: 37
	}, {
	  availability: "AVAILABLE",
	  category: "রান্না করা খাবার",
	  key: "-MCRBqPtysKzn9y35Vp3",
	  photos: [{
	    imageName: "2c161540-c813-11ea-99a6-3f4f89ed7cd9.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F2c161540-c813-11ea-99a6-3f4f89ed7cd9.jpg?alt=media&token=c9861ad2-9fd6-4d4d-b17c-a0ca1d52012d"
	  }],
	  productNameEnglish: "কাতলা মাছ catla fish curry - Delivery by taxi, pay as meter-fare. ",
	  productPrice: "4",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "1 serving ",
	  updateDateTime: "Tue 11-08-20 6:45 pm",
	  count: 36
	}, {
	  availability: "AVAILABLE",
	  category: "SNACKS DRY FOOD",
	  isPopular: "YES",
	  key: "-MAB9V1JLwAGA1zCB0hy",
	  photos: [{
	    imageName: "af7cc410-b5bc-11ea-8808-e1e7c83edfc8.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Faf7cc410-b5bc-11ea-8808-e1e7c83edfc8.jpg?alt=media&token=1fe738cc-b954-4daf-bd5c-018587483d3a"
	  }],
	  productNameEnglish: "PRAN Chanachur - Hot 1kg Pack ",
	  productPrice: "6",
	  productSupplier: "BCS SHOP",
	  searchText: "channachur chanacor ",
	  sortOrder: "a",
	  sourceSupplier: "GLOBAL PIONEEER PTE LTD",
	  supplierContactName: "Kabir",
	  supplierContactPhone: "94562455",
	  unit: "1kg",
	  updateDateTime: "03/08/2020 03:58:41",
	  count: 36
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-M9bJC6AZeWff8sR21LX",
	  photos: [{
	    imageName: "514a0f10-ac84-11ea-905e-b59fb9963ca1.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F514a0f10-ac84-11ea-905e-b59fb9963ca1.jpg?alt=media&token=186d6c18-e5e4-424b-a294-eab6f8e85802"
	  }],
	  productNameEnglish: "Vegetable oil",
	  productPrice: "5.80",
	  productSupplier: "BCS SHOP",
	  searchText: "তেল তৈল ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "2L Bottle",
	  updateDateTime: "Fri 28-08-20 11:57 am",
	  count: 36
	}, {
	  availability: "AVAILABLE",
	  category: "রান্না করা খাবার",
	  key: "-MHVDYR3ye_hNAYgtCWm",
	  photos: [{
	    imageName: "f24ea0e0-f984-11ea-98b2-bdfbde6255e9.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2Ff24ea0e0-f984-11ea-98b2-bdfbde6255e9.jpg?alt=media&token=bbba37df-1b44-485f-8597-953919ce52ba"
	  }],
	  productNameEnglish: "কালো  জিরা ভর্তা ।",
	  productPrice: "1",
	  productSupplier: "BCS SHOP",
	  searchText: "kalo jera vorta.",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "1 serving.",
	  updateDateTime: "Fri 18-09-20 4:21 pm",
	  count: 36
	}, {
	  availability: "AVAILABLE",
	  category: "রান্না করা খাবার",
	  key: "-MCR9GdJufTtT8m56H-1",
	  photos: [{
	    imageName: "f3b228c0-c811-11ea-99a6-3f4f89ed7cd9.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Ff3b228c0-c811-11ea-99a6-3f4f89ed7cd9.jpg?alt=media&token=1389e0eb-e748-4908-8f6a-76710cdba94f"
	  }],
	  productNameEnglish: "ডাল ভর্তা  Mashed lentil - Delivery by taxi, pay as meter-fare.  ",
	  productPrice: "1",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "1 serving ",
	  updateDateTime: "Tue 11-08-20 6:46 pm",
	  count: 34
	}, {
	  category: "EGGS DAIRY",
	  isPopular: "YES",
	  key: "-M9Y0ixv1jxpZF_BdfTy",
	  photos: [{
	    imageName: "1cf52090-abd2-11ea-b76c-0b360dd92c32.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F1cf52090-abd2-11ea-b76c-0b360dd92c32.jpg?alt=media&token=3177d850-f72d-4b52-add8-1c73565f5f68"
	  }],
	  productNameEnglish: "Honey  ",
	  productPrice: "6.5",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "500ml",
	  updateDateTime: "04/07/2020 09:14:33",
	  count: 34
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  key: "-M9fHMrVBEGYkGPsl98Q",
	  photos: [{
	    imageName: "f954d920-ad14-11ea-8bc0-03f48af12a9c.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Ff954d920-ad14-11ea-8bc0-03f48af12a9c.jpg?alt=media&token=50a9ce25-4ef7-4149-97b4-413063b91f9f"
	  }],
	  productNameEnglish: "PAGODA FINE SALT",
	  productPrice: "0.90",
	  productSupplier: "BCS SHOP",
	  searchText: "লবণ লবন ",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "500g",
	  updateDateTime: "17/07/2020 08:50:31",
	  count: 34
	}, {
	  availability: "AVAILABLE",
	  category: "DRINKS DESSERT",
	  isPopular: "YES",
	  key: "-MBZKEFOmp9p-uw3Bn5n",
	  photos: [{
	    imageName: "30743ec0-bf8d-11ea-85e3-735b22b1a0db.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F30743ec0-bf8d-11ea-85e3-735b22b1a0db.jpg?alt=media&token=e2b19a51-7dc8-4665-982a-e0c6fba31e4f"
	  }],
	  productNameEnglish: "SIS Refined White Sugar",
	  productPrice: "1.90",
	  productSupplier: "BCS SHOP",
	  searchText: "চিনি ",
	  sortOrder: "a",
	  sourceSupplier: "Sheng siong ",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "1kg",
	  updateDateTime: "17/07/2020 07:32:58",
	  count: 33
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-M9Y9D065-hddXvOvSpc",
	  photos: [{
	    imageName: "168de720-f734-11ea-885a-2b4d96b2f26b.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F168de720-f734-11ea-885a-2b4d96b2f26b.jpg?alt=media&token=2e5d791c-cfe6-4d98-828e-a8d9ec8210a9"
	  }],
	  productNameEnglish: "Radish ",
	  productPrice: "4",
	  productSupplier: "BCS SHOP",
	  searchText: "মুলা ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1kg",
	  updateDateTime: "Tue 15-09-20 5:16 pm",
	  count: 33
	}, {
	  availability: "AVAILABLE",
	  category: "DRINKS DESSERT",
	  key: "-MA4cGShaIl7o-YkQkFm",
	  photos: [{
	    imageName: "659d4fd0-bc52-11ea-b7df-33e703b87300.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F659d4fd0-bc52-11ea-b7df-33e703b87300.jpg?alt=media&token=53698db7-deb9-4657-9712-87bcbe08649d"
	  }],
	  productNameEnglish: "Young Coconut",
	  productPrice: "2.50",
	  productSupplier: "BCS SHOP",
	  searchText: "ডাবের পানি নারিকেল পানি ",
	  sortOrder: "a",
	  sourceSupplier: "B&S minimart ",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1PC",
	  updateDateTime: "17/07/2020 02:12:13",
	  count: 33
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "NO",
	  key: "-M9YZA49hWE54KVe0tCV",
	  photos: [{
	    imageName: "6bdc1a00-bdad-11ea-8ba8-ddb60ef370d4.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F6bdc1a00-bdad-11ea-8ba8-ddb60ef370d4.jpg?alt=media&token=d2412a77-2d03-45c8-9cc1-1610484cc04b"
	  }],
	  productNameEnglish: "Baby Cucumber ",
	  productPrice: "2",
	  productSupplier: "BCS SHOP",
	  searchText: "shosha  ছোট  শশা শসা ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "500gm",
	  updateDateTime: "28/07/2020 06:04:42",
	  count: 33
	}, {
	  availability: "AVAILABLE",
	  category: "SNACKS DRY FOOD",
	  key: "-MEfnE2YRECG5CSHrUtD",
	  photos: [{
	    imageName: "f611cc00-ddfc-11ea-a50a-71ea37251d72.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2Ff611cc00-ddfc-11ea-a50a-71ea37251d72.jpg?alt=media&token=f83a126e-c360-4e31-9b8f-53537c243e7c"
	  }],
	  productNameEnglish: "chanachur hot 300g",
	  productPrice: "1.80",
	  productSupplier: "BCS SHOP",
	  searchText: "chanachur",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "1 pkt 300g",
	  updateDateTime: "Fri 14-08-20 4:16 pm",
	  count: 33
	}, {
	  availability: "AVAILABLE",
	  category: "RICE DAAL NOODLES",
	  isPopular: "YES",
	  key: "-M9glXjaEe-mKWvEMYkB",
	  photos: [{
	    imageName: "047157e0-ad4f-11ea-9947-39ad013963aa.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F047157e0-ad4f-11ea-9947-39ad013963aa.jpg?alt=media&token=41b67f4a-8e77-4c84-b40c-e0d7a10cd76d"
	  }],
	  productNameEnglish: "Uncle Cook's Ponni Rice",
	  productPrice: "7.8",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "5Kg",
	  updateDateTime: "03/08/2020 06:59:38",
	  count: 32
	}, {
	  category: "DRINKS DESSERT",
	  key: "-M9bCf_WwXB4rAW5mkgT",
	  photos: [{
	    imageName: "d1ef1840-ac75-11ea-8ded-437354ec7423.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fd1ef1840-ac75-11ea-8ded-437354ec7423.jpg?alt=media&token=f5efc351-df92-4c74-944a-afc119a630ff"
	  }],
	  productNameEnglish: "Coca cola",
	  productPrice: "2.5",
	  productSupplier: "BCS SHOP",
	  sortOrder: "f",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1L Bottle",
	  updateDateTime: "04/07/2020 08:43:06",
	  count: 32
	}, {
	  availability: "AVAILABLE",
	  category: "PICKLES",
	  photos: [{
	    imageName: "78e64740-de0d-11ea-9698-4d47c48636b6.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F78e64740-de0d-11ea-9698-4d47c48636b6.jpg?alt=media&token=748ec572-b5c5-4569-91b4-b56dffd8c98e"
	  }],
	  productNameEnglish: "pran garlic pickle",
	  productPrice: "3.20",
	  productSupplier: "BCS SHOP",
	  searchText: "rosun acher",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "1 jar",
	  updateDateTime: "Fri 14-08-20 5:07 pm",
	  key: "-MEgDFKInKeMU-2jR-B9",
	  count: 31
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-M9aEGTP2736X6CBBnXa",
	  photos: [{
	    imageName: "87a98890-ac4f-11ea-95e2-e74f5187871b.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F87a98890-ac4f-11ea-95e2-e74f5187871b.jpg?alt=media&token=49f5c0fe-472b-4833-bd94-5e60cc5c65fd"
	  }],
	  productNameEnglish: "CORIANDER POWDER",
	  productPrice: "2.50",
	  productSupplier: "BCS SHOP",
	  searchText: "ধনিয়ার গুঁড়া ",
	  sortOrder: "a",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1 pkt",
	  updateDateTime: "17/07/2020 08:01:23",
	  count: 31
	}, {
	  category: "EGGS DAIRY",
	  isPopular: "YES",
	  key: "-M9gCSog7V0Vdy8tUqRW",
	  photos: [{
	    imageName: "09d1d8b0-ad39-11ea-9a01-db9ea96fa329.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F09d1d8b0-ad39-11ea-9a01-db9ea96fa329.jpg?alt=media&token=0e6309ca-1e09-4b48-9349-d330afa8a9eb"
	  }],
	  productNameEnglish: "MILKMAID FULL CREAM SWEETENED CONDENSED MILK",
	  productPrice: "1.80",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "392g",
	  updateDateTime: "04/07/2020 11:07:20",
	  count: 31
	}, {
	  availability: "AVAILABLE",
	  category: "রান্না করা খাবার",
	  key: "-MHVG19Kcy11GUx62ZHn",
	  photos: [{
	    imageName: "83a71300-f986-11ea-98b2-bdfbde6255e9.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F83a71300-f986-11ea-98b2-bdfbde6255e9.jpg?alt=media&token=da735328-9af7-411e-ab71-4e72c5633557"
	  }],
	  productNameEnglish: "শরিষা  ভর্তা  ।",
	  productPrice: "1",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "1 serving",
	  updateDateTime: "Fri 18-09-20 4:21 pm",
	  count: 31
	}, {
	  category: "RICE DAAL NOODLES",
	  key: "-M9b8JWwYFz517RGfvJ_",
	  photos: [{
	    imageName: "1759f790-ac73-11ea-8ded-437354ec7423.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F1759f790-ac73-11ea-8ded-437354ec7423.jpg?alt=media&token=87c9c6c7-6838-45e5-a421-679aa0408600"
	  }, {
	    imageName: "21c9c7f0-ac73-11ea-8ded-437354ec7423.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F21c9c7f0-ac73-11ea-8ded-437354ec7423.jpg?alt=media&token=033a0dad-aa01-4f30-9273-cba66ffad7db"
	  }],
	  productNameEnglish: "Big curry noodels",
	  productPrice: "3.1",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1 Pkt",
	  updateDateTime: "04/07/2020 08:49:23",
	  count: 31
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  key: "-M9b-7mBkiQTOHJc8uAO",
	  photos: [{
	    imageName: "a3e41fb0-f89a-11ea-aaa8-a9cfb87a7f3a.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2Fa3e41fb0-f89a-11ea-aaa8-a9cfb87a7f3a.jpg?alt=media&token=87a4a44c-3b0a-42cf-b613-d3a7b86c04f8"
	  }],
	  productNameEnglish: "MANGO ",
	  productPrice: "8",
	  productSupplier: "BCS SHOP",
	  searchText: "আম ",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1 kg",
	  updateDateTime: "Mon 21-09-20 3:34 pm",
	  count: 29
	}, {
	  category: "FRUITS VEGETABLES ",
	  key: "-M9b-MLpqXrFjouqCo9g",
	  photos: [{
	    imageName: "e3403770-f89a-11ea-aaa8-a9cfb87a7f3a.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2Fe3403770-f89a-11ea-aaa8-a9cfb87a7f3a.jpg?alt=media&token=b68ac054-e6a1-4338-a8cd-35365f3e48e5"
	  }],
	  productNameEnglish: "POMEGRANATE ",
	  productPrice: "3",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1 pc",
	  updateDateTime: "Thu 17-09-20 12:04 pm",
	  count: 29
	}, {
	  availability: "AVAILABLE",
	  category: "SNACKS DRY FOOD",
	  isPopular: "YES",
	  key: "-M9aUTJYmnr3ay_dMfFU",
	  photos: [{
	    imageName: "88b87c00-ac59-11ea-bbe4-619ccaa778ae.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F88b87c00-ac59-11ea-bbe4-619ccaa778ae.jpg?alt=media&token=806628c8-d92a-4854-998b-769cf8e22f6b"
	  }],
	  productNameEnglish: "CASHEW ",
	  productPrice: "2.50",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1 pkt",
	  updateDateTime: "23/07/2020 12:47:08",
	  count: 29
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-M9aTBq-BrOibWA7X8Y-",
	  photos: [{
	    imageName: "ce7ab830-ac58-11ea-bbe4-619ccaa778ae.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fce7ab830-ac58-11ea-bbe4-619ccaa778ae.jpg?alt=media&token=0348fe5e-a6e4-4e9a-9cef-f0f783d50486"
	  }],
	  productNameEnglish: "FENUGREEK ",
	  productPrice: "2.5",
	  productSupplier: "BCS SHOP",
	  searchText: "মেথি",
	  sortOrder: "a",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1 pkt",
	  updateDateTime: "23/07/2020 12:50:35",
	  count: 28
	}, {
	  availability: "AVAILABLE",
	  category: "COSMETICS",
	  isPopular: "YES",
	  key: "-M9hI30fYjFeEKpztA36",
	  photos: [{
	    imageName: "7e4b19c0-ad63-11ea-a545-3fca42f11c6b.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F7e4b19c0-ad63-11ea-a545-3fca42f11c6b.jpg?alt=media&token=f89a5dfc-e44a-4e86-a476-6a4592e4a004"
	  }],
	  productNameEnglish: "Shaving Blade",
	  productPrice: "1",
	  productSupplier: "BCS SHOP",
	  searchText: "shave shaving saving ব্লেড ",
	  sortOrder: "x",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1 Pkt",
	  updateDateTime: "03/08/2020 06:55:41",
	  count: 28
	}, {
	  availability: "AVAILABLE",
	  category: "রান্না করা খাবার",
	  photos: [{
	    imageName: "8d5bb440-f987-11ea-98b2-bdfbde6255e9.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F8d5bb440-f987-11ea-98b2-bdfbde6255e9.jpg?alt=media&token=f3dad4d2-92af-4b70-b443-2779ae1cb9ff"
	  }],
	  productNameEnglish: "মাছের ডিম ভাজি।",
	  productPrice: "2",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "1 serving",
	  updateDateTime: "Fri 18-09-20 4:18 pm",
	  key: "-MHVHnnh2iPjqWz6WrV5",
	  count: 28
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-M9aQc7YsWNmDmoolF11",
	  photos: [{
	    imageName: "0b0b8ce0-ac57-11ea-bbe4-619ccaa778ae.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F0b0b8ce0-ac57-11ea-bbe4-619ccaa778ae.jpg?alt=media&token=2a3877ce-a6ee-49ba-b688-70de2d971d96"
	  }],
	  productNameEnglish: "DC DRY CHILLI POWDER ",
	  productPrice: "3.50",
	  productSupplier: "BCS SHOP",
	  searchText: "মরিচের গুঁড়া ",
	  sortOrder: "a",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1 btl",
	  updateDateTime: "17/07/2020 07:57:15",
	  count: 28
	}, {
	  availability: "AVAILABLE",
	  category: "EGGS DAIRY",
	  key: "-M9b5gixFFWFZu_8K2gD",
	  photos: [{
	    imageName: "78b34d40-ac71-11ea-8ded-437354ec7423.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F78b34d40-ac71-11ea-8ded-437354ec7423.jpg?alt=media&token=5313c355-f51e-4170-8e2b-3fd689895acf"
	  }],
	  productNameEnglish: "Bread",
	  productPrice: "2.9",
	  productSupplier: "BCS SHOP",
	  searchText: "পাউরুটি পাওরোটি",
	  sortOrder: "d",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1 Pkt",
	  updateDateTime: "06/07/2020 09:40:20",
	  count: 28
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-M9YBFF3IOwSaJ5jdXxt",
	  photos: [{
	    imageName: "86af5890-f897-11ea-aaa8-a9cfb87a7f3a.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F86af5890-f897-11ea-aaa8-a9cfb87a7f3a.jpg?alt=media&token=e3172c68-6f4a-4e1e-b1d5-def8c76d97e3"
	  }],
	  productNameEnglish: " wax gourd ",
	  productPrice: "3.5",
	  productSupplier: "BCS SHOP",
	  searchText: "চালকোমড়া",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1kg",
	  updateDateTime: "Thu 17-09-20 11:40 am",
	  count: 28
	}, {
	  availability: "AVAILABLE",
	  category: "LAUNDRY CLEANING",
	  key: "-M9bBs4PdfnxhlDzHxTx",
	  photos: [{
	    imageName: "28eaf7a0-ac75-11ea-8ded-437354ec7423.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F28eaf7a0-ac75-11ea-8ded-437354ec7423.jpg?alt=media&token=dded438e-c6a6-42e7-83a1-a1e3e8232eee"
	  }],
	  productNameEnglish: "Fab perfect washing powder ",
	  productPrice: "6.8",
	  productSupplier: "BCS SHOP",
	  searchText: "ওয়াশিং পাউডার ",
	  sortOrder: "f",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "2.1Kg",
	  updateDateTime: "17/07/2020 07:56:39",
	  count: 27
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-M9aQ4t5M-cz1xzBmOfI",
	  photos: [{
	    imageName: "dcc3dd10-ac56-11ea-bbe4-619ccaa778ae.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fdcc3dd10-ac56-11ea-bbe4-619ccaa778ae.jpg?alt=media&token=91619b71-70f4-4a45-96b4-043c11dd2dfe"
	  }],
	  productNameEnglish: "DC TURMERIC POWDER ",
	  productPrice: "3.70",
	  productSupplier: "BCS SHOP",
	  searchText: "হলুদের গুঁড়া হলুদ ",
	  sortOrder: "a",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1 btl",
	  updateDateTime: "23/07/2020 12:54:39",
	  count: 27
	}, {
	  author: "+6589050302",
	  category: "COSMETICS",
	  isPopular: "NO",
	  key: "-M9qx3DztDO4jxgP57j_",
	  photos: [{
	    imageName: "a7b53410-aedc-11ea-9b4b-4bd8d539c6a6.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fa7b53410-aedc-11ea-9b4b-4bd8d539c6a6.jpg?alt=media&token=8e4acb94-2c64-4ae6-9551-d48f8f537fa9"
	  }],
	  productNameEnglish: "Parachute Coconut Hair Oil",
	  productPrice: "3.50",
	  productSupplier: "BCS SHOP",
	  sortOrder: "k",
	  sourceSupplier: "MUSTAFA CENTRE",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "200ML",
	  updateDateTime: "Tue 25-08-20 10:01 am",
	  count: 27
	}, {
	  availability: "AVAILABLE",
	  category: "RICE DAAL NOODLES",
	  key: "-M9hjms-69uHkY6aPAh0",
	  photos: [{
	    imageName: "00b8a060-ad75-11ea-8617-6988f4fcb266.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F00b8a060-ad75-11ea-8617-6988f4fcb266.jpg?alt=media&token=c61cbe55-8a1b-4bd0-8d7d-49a4346f852b"
	  }],
	  productNameEnglish: "Housebrand Ponni Rice",
	  productPrice: "8.5",
	  productSupplier: "BCS SHOP",
	  searchText: "চাউল rice",
	  sortOrder: "b",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "5Kg",
	  updateDateTime: "03/08/2020 06:51:41",
	  count: 27
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-MA4XjnSy0_iJBg1YE3w",
	  photos: [{
	    imageName: "e95f8440-bc53-11ea-b7df-33e703b87300.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fe95f8440-bc53-11ea-b7df-33e703b87300.jpg?alt=media&token=b2d5737c-b2c2-4a88-9a39-a80f2ffd9ad8"
	  }],
	  productNameEnglish: " Malabar Spinach",
	  productPrice: "5",
	  productSupplier: "BCS SHOP",
	  searchText: "poishak puishak shak পুঁইশাক পুইশাক ",
	  sortOrder: "a",
	  sourceSupplier: "B&S minimart ",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1kg",
	  updateDateTime: "03/08/2020 04:19:53",
	  count: 27
	}, {
	  availability: "AVAILABLE",
	  category: "রান্না করা খাবার",
	  key: "-MCR8Fw96_IPSx7ezDb2",
	  photos: [{
	    imageName: "5cde4050-c811-11ea-99a6-3f4f89ed7cd9.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F5cde4050-c811-11ea-99a6-3f4f89ed7cd9.jpg?alt=media&token=9fbae84a-126c-4869-97cd-e5655b73ad45"
	  }],
	  productNameEnglish: "মিষ্টি কুমড়া pumkin vege - Delivery by taxi, pay as meter-fare. ",
	  productPrice: "1",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "1 serving ",
	  updateDateTime: "Tue 11-08-20 6:47 pm",
	  count: 26
	}, {
	  availability: "OUT OF STOCK, TOPPING UP IN PROGRESS",
	  category: "OTHERS",
	  isPopular: "YES",
	  key: "-MAuV2lPINSwTniomMlp",
	  photos: [{
	    imageName: "3e521340-b92b-11ea-bcad-f16312f4aa54.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F3e521340-b92b-11ea-bcad-f16312f4aa54.jpg?alt=media&token=6bc2029c-be52-4eec-8cfa-5cd4e63354ae"
	  }],
	  productNameEnglish: "Gamsa - Bangladeshi Gamsa",
	  productPrice: "5",
	  productSupplier: "BCS SHOP",
	  searchText: "gamsa gamca gamcha গামছা ",
	  sortOrder: "m",
	  sourceSupplier: "TANMOY ENTERPRISE PTE LTD",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "1 pc",
	  updateDateTime: "Tue 25-08-20 11:45 am",
	  count: 25
	}, {
	  availability: "AVAILABLE",
	  category: "রান্না করা খাবার",
	  key: "-MCR9THHUwxHT0yCpCK6",
	  photos: [{
	    imageName: "23c71e80-c812-11ea-99a6-3f4f89ed7cd9.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F23c71e80-c812-11ea-99a6-3f4f89ed7cd9.jpg?alt=media&token=7a711649-1626-455d-8215-e3a9860aa7f1"
	  }],
	  productNameEnglish: "বাধাঁকপি cabbage - Delivery by taxi, pay as meter-fare. ",
	  productPrice: "1",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "1 serving ",
	  updateDateTime: "Tue 11-08-20 6:46 pm",
	  count: 24
	}, {
	  category: "FROZEN",
	  isPopular: "YES",
	  key: "-M9a4CZ78AOClgPOpNxT",
	  photos: [{
	    imageName: "6bbed500-ac49-11ea-ba1a-4bcfa8bf5006.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F6bbed500-ac49-11ea-ba1a-4bcfa8bf5006.jpg?alt=media&token=d5cff067-856b-447e-9a85-edd0d3a73555"
	  }],
	  productNameEnglish: "chicken drumstick   ",
	  productPrice: "4",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1kg",
	  updateDateTime: "04/07/2020 09:30:07",
	  count: 24
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  photos: [{
	    imageName: "4fbdfc10-e122-11ea-8469-c1686cba6d19.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F4fbdfc10-e122-11ea-8469-c1686cba6d19.jpg?alt=media&token=e50af00e-c1d9-4625-b94a-9f7832addccf"
	  }],
	  productNameEnglish: "Arum lobe",
	  productPrice: "6.00",
	  productSupplier: "BCS SHOP",
	  searchText: "Kachur lati",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "1 kg",
	  updateDateTime: "Tue 18-08-20 3:22 pm",
	  key: "-MF-RiWAtk49xfQvcQ0k",
	  count: 24
	}, {
	  availability: "AVAILABLE",
	  category: "রান্না করা খাবার",
	  key: "-MHVHKvftDDCPt3j1R-8",
	  photos: [{
	    imageName: "3ae48f20-f987-11ea-98b2-bdfbde6255e9.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F3ae48f20-f987-11ea-98b2-bdfbde6255e9.jpg?alt=media&token=9c03f659-6de2-4ae8-a483-39de6b2cae1b"
	  }],
	  productNameEnglish: "হাঁস এর মাংস রান্না।",
	  productPrice: "6",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "1 serving .",
	  updateDateTime: "Fri 18-09-20 4:18 pm",
	  count: 24
	}, {
	  availability: "AVAILABLE",
	  category: "রান্না করা খাবার",
	  key: "-MDKs4BC155HT4MpXh_N",
	  photos: [{
	    imageName: "96689730-d0e0-11ea-aade-65854897e2af.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F96689730-d0e0-11ea-aade-65854897e2af.jpg?alt=media&token=afeec514-ce2b-4005-8752-fde751847904"
	  }],
	  productNameEnglish: "চিকেন বিরানি  Chicken Briyani (not everyday available) - Delivery by taxi, pay as meter-fare. ",
	  productPrice: "6",
	  productSupplier: "BCS SHOP",
	  searchText: "চিকেন বিরানি ",
	  sortOrder: "a",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "1 serving ",
	  updateDateTime: "Tue 11-08-20 6:44 pm",
	  count: 24
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-MA4Da4f67pdMPLcn-m-",
	  photos: [{
	    imageName: "b373dcf0-bf82-11ea-85e3-735b22b1a0db.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fb373dcf0-bf82-11ea-85e3-735b22b1a0db.jpg?alt=media&token=63926f40-da9c-467b-b58b-0a8bffae0475"
	  }],
	  productNameEnglish: "Drumstick",
	  productPrice: "6.50",
	  productSupplier: "BCS SHOP",
	  searchText: "সইজনা সাজনা ",
	  sortOrder: "a",
	  sourceSupplier: "MADURAI MEENAKSHI MINIMART",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1kg",
	  updateDateTime: "03/08/2020 04:26:43",
	  count: 24
	}, {
	  availability: "AVAILABLE",
	  category: "রান্না করা খাবার",
	  key: "-MCRAQqB_mm1I7ffCCQg",
	  photos: [{
	    imageName: "9b0f9e40-c812-11ea-99a6-3f4f89ed7cd9.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F9b0f9e40-c812-11ea-99a6-3f4f89ed7cd9.jpg?alt=media&token=b8d00adb-4a78-4692-a08b-d9742444d78c"
	  }],
	  productNameEnglish: "মাছের মাথা fish head curry Small - Delivery by taxi, pay as meter-fare. ",
	  productPrice: "4",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "1 serving ",
	  updateDateTime: "Tue 11-08-20 6:46 pm",
	  count: 23
	}, {
	  availability: "AVAILABLE",
	  category: "EGGS DAIRY",
	  isPopular: "YES",
	  key: "-MBZLVLQXyTSh5pehqLR",
	  photos: [{
	    imageName: "0b0d3e60-bf8e-11ea-85e3-735b22b1a0db.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F0b0d3e60-bf8e-11ea-85e3-735b22b1a0db.jpg?alt=media&token=98d5462b-d434-4893-a76e-e90c91f9bca5"
	  }],
	  productNameEnglish: "Gardenia Super Soft Wholemeal Bread",
	  productPrice: "3.5",
	  productSupplier: "BCS SHOP",
	  searchText: "পাউরুটি পাওরোটি ",
	  sortOrder: "g",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "600gm pkt",
	  updateDateTime: "03/08/2020 03:40:48",
	  count: 23
	}, {
	  availability: "AVAILABLE",
	  category: "DRINKS DESSERT",
	  photos: [{
	    imageName: "b936ee50-f7ce-11ea-9ca4-275d4c37dc1b.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2Fb936ee50-f7ce-11ea-9ca4-275d4c37dc1b.jpg?alt=media&token=c1f3cd55-0ebd-423e-9f7b-26c46189b56f"
	  }],
	  productNameEnglish: "Pran lachcha shemi",
	  productPrice: "1.70",
	  productSupplier: "BCS SHOP",
	  searchText: " lachcha shemi",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "200g",
	  updateDateTime: "Wed 16-09-20 11:43 am",
	  key: "-MHK-YgxQtovzCL12aCX",
	  count: 23
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-M9aDmJfZ26UqwhujLhA",
	  photos: [{
	    imageName: "2903cc10-ac4f-11ea-95e2-e74f5187871b.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F2903cc10-ac4f-11ea-95e2-e74f5187871b.jpg?alt=media&token=5157bf34-ad86-474d-bf50-f6401dca9beb"
	  }],
	  productNameEnglish: "CUMIN POWDER",
	  productPrice: "3.50",
	  productSupplier: "BCS SHOP",
	  searchText: "জিরার গুঁড়া ",
	  sortOrder: "a",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1 packet",
	  updateDateTime: "17/07/2020 07:58:13",
	  count: 23
	}, {
	  availability: "AVAILABLE",
	  category: "EGGS DAIRY",
	  isPopular: "YES",
	  key: "-MABjJi6SUbQ8eTcAd04",
	  photos: [{
	    imageName: "197d5b00-bc51-11ea-b7df-33e703b87300.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F197d5b00-bc51-11ea-b7df-33e703b87300.jpg?alt=media&token=062360d1-e98d-411a-af84-081a86567545"
	  }],
	  productNameEnglish: "Enricos Instant Milk Powder",
	  productPrice: "10",
	  productSupplier: "BCS SHOP",
	  searchText: "milk dud dood powder ধুদ ",
	  sortOrder: "c",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "635gm",
	  updateDateTime: "03/08/2020 03:55:05",
	  count: 22
	}, {
	  author: "+6589050302",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-M9bFo5eMFcy5tHOyT4I",
	  photos: [{
	    imageName: "bab43780-ac77-11ea-8ded-437354ec7423.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fbab43780-ac77-11ea-8ded-437354ec7423.jpg?alt=media&token=963e0410-83b1-42fc-8b27-114977dd6974"
	  }],
	  productNameEnglish: "Vegetable oil",
	  productPrice: "6.20",
	  productSupplier: "BCS SHOP",
	  searchText: "তেল তৈল",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "3L Bottle",
	  updateDateTime: "29/07/2020 02:40:52",
	  count: 22
	}, {
	  availability: "AVAILABLE",
	  category: "MEAT FISH",
	  isPopular: "YES",
	  key: "-M9YVFGS1aZS8hhaFMb-",
	  photos: [{
	    imageName: "e35086a0-abe4-11ea-99a0-ada8a2be9f1b.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fe35086a0-abe4-11ea-99a0-ada8a2be9f1b.jpg?alt=media&token=e2323664-15e7-4ee9-920c-b765fbb86483"
	  }],
	  productNameEnglish: "Fish baby fish",
	  productPrice: "4",
	  productSupplier: "BCS SHOP",
	  searchText: "ছোট মাছ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: " 1 packet",
	  updateDateTime: "Sun 20-12-20 11:28 pm",
	  count: 22
	}, {
	  availability: "AVAILABLE",
	  category: "OTHERS",
	  key: "-MFYfAtBRvgQShD8sJic",
	  photos: [{
	    imageName: "9d69ead0-e683-11ea-9786-7f7137f3f585.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F9d69ead0-e683-11ea-9786-7f7137f3f585.jpg?alt=media&token=e81bf61a-6b93-4c43-849e-9bc8ac156da7"
	  }],
	  productNameEnglish: "BD Lungi",
	  productPrice: "8",
	  productSupplier: "BCS SHOP",
	  searchText: "Lungi",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "1 pc",
	  updateDateTime: "Tue 29-09-20 10:26 am",
	  count: 21
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-M9aTVD1cwIwhtaqReNX",
	  photos: [{
	    imageName: "f04821a0-ac58-11ea-bbe4-619ccaa778ae.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Ff04821a0-ac58-11ea-bbe4-619ccaa778ae.jpg?alt=media&token=b3c70bc6-b839-4717-8275-0a13fd2d023e"
	  }],
	  productNameEnglish: "NIGELLA SEEDS ",
	  productPrice: "2.50",
	  productSupplier: "BCS SHOP",
	  searchText: "কালোজিরা",
	  sortOrder: "a",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1 pkt ",
	  updateDateTime: "23/07/2020 12:50:01",
	  count: 21
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  photos: [{
	    imageName: "08d9b330-f7ce-11ea-9ca4-275d4c37dc1b.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F08d9b330-f7ce-11ea-9ca4-275d4c37dc1b.jpg?alt=media&token=0ab0d7ab-a6f5-4784-988c-7fb85cbd6ea5"
	  }],
	  productNameEnglish: "Saffy sunflower",
	  productPrice: "14",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "5 L",
	  updateDateTime: "Wed 16-09-20 11:38 am",
	  key: "-MHJzQbjEXxFWdlUEMSV",
	  count: 20
	}, {
	  availability: "AVAILABLE",
	  category: "TUPPERWARE CONTAINER",
	  isPopular: "YES",
	  key: "-M9a2COGsCqlkCzrn6zP",
	  photos: [{
	    imageName: "5c267b30-ac48-11ea-ba1a-4bcfa8bf5006.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F5c267b30-ac48-11ea-ba1a-4bcfa8bf5006.jpg?alt=media&token=b7299a94-a39a-4d4b-afba-fff28c83d61a"
	  }],
	  productNameEnglish: "Plastic bag ",
	  productPrice: "0.70",
	  productSupplier: "BCS SHOP",
	  searchText: "প্লাষ্টিক প্যাকেট ",
	  sortOrder: "x",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1 packet",
	  updateDateTime: "23/07/2020 12:55:53",
	  count: 20
	}, {
	  availability: "OUT OF STOCK, TOPPING UP IN PROGRESS",
	  category: "DRINKS DESSERT",
	  isPopular: "YES",
	  key: "-MA-oFKOeZeM-mQuLaZ3",
	  photos: [{
	    imageName: "518409f0-c100-11ea-8470-83fbeadd4a74.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F518409f0-c100-11ea-8470-83fbeadd4a74.jpg?alt=media&token=fd0b2094-6d22-4412-b912-9bbf77e8da93"
	  }],
	  productNameEnglish: "Lachcha Shemai",
	  productPrice: "1.50",
	  productSupplier: "BCS SHOP",
	  searchText: "লাচ্ছা সেমাই ",
	  sortOrder: "a",
	  sourceSupplier: "TRISHA EXPORT & IMPORT PTE LTD MINIMART",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "125g Packet",
	  updateDateTime: "Wed 16-09-20 11:38 am",
	  count: 19
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-M9YANJFg1D08vwrvhm1",
	  photos: [{
	    imageName: "24b72040-f898-11ea-aaa8-a9cfb87a7f3a.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F24b72040-f898-11ea-aaa8-a9cfb87a7f3a.jpg?alt=media&token=7a26b0b8-9da8-4697-a324-15de9739248f"
	  }],
	  productNameEnglish: "Green Plantains banana ",
	  productPrice: "6.00",
	  productSupplier: "BCS SHOP",
	  searchText: "কাঁচা কলা ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1kg",
	  updateDateTime: "Thu 17-09-20 11:44 am",
	  count: 19
	}, {
	  availability: "AVAILABLE",
	  category: "OTHERS",
	  photos: [{
	    imageName: "13a4cb20-e684-11ea-9786-7f7137f3f585.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F13a4cb20-e684-11ea-9786-7f7137f3f585.jpg?alt=media&token=c8135dfc-00cc-4bb0-a557-ddfd23c852c9"
	  }],
	  productNameEnglish: "BD Gamsa",
	  productPrice: "4.5",
	  productSupplier: "BCS SHOP",
	  searchText: "Gamsa",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "1 pc",
	  updateDateTime: "Tue 25-08-20 11:36 am",
	  key: "-MFYfxsA5OQoH8IP5nlX",
	  count: 19
	}, {
	  availability: "AVAILABLE",
	  category: "SNACKS DRY FOOD",
	  isPopular: "",
	  key: "-MHFul2QZyxooWaFH1y6",
	  photos: [{
	    imageName: "2d8bc640-f72f-11ea-885a-2b4d96b2f26b.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F2d8bc640-f72f-11ea-885a-2b4d96b2f26b.jpg?alt=media&token=f4f0d783-4812-45c4-b3e5-20b781d6caaf"
	  }],
	  productNameEnglish: "Muri moa 1 jar",
	  productPrice: "3",
	  productSupplier: "BCS SHOP",
	  searchText: "Moa",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "400g",
	  updateDateTime: "Tue 15-09-20 4:50 pm",
	  count: 19
	}, {
	  category: "TOILETRIES",
	  key: "-M9fcF5ZkBOD12P39W6C",
	  photos: [{
	    imageName: "2742e450-ad22-11ea-bbe8-977967140bbe.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F2742e450-ad22-11ea-bbe8-977967140bbe.jpg?alt=media&token=20a426d3-5a61-41c0-bf5d-cac18dc2f593"
	  }],
	  productNameEnglish: "Toothpost colgate advanced white valuepack",
	  productPrice: "6.5",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "160gm×2pc",
	  updateDateTime: "04/07/2020 11:21:01",
	  count: 19
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-M9cMHEZQIK86s60YiGI",
	  photos: [{
	    imageName: "178554e0-bdac-11ea-8ba8-ddb60ef370d4.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F178554e0-bdac-11ea-8ba8-ddb60ef370d4.jpg?alt=media&token=1430bbd5-0925-4ce0-850c-99f5ed839fce"
	  }],
	  productNameEnglish: "PAPAYA (1kg)",
	  productPrice: "5",
	  productSupplier: "BCS SHOP",
	  searchText: "paka pepe পাকা পেঁপে ",
	  sortOrder: "a",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1kg",
	  updateDateTime: "23/07/2020 11:38:24",
	  count: 18
	}, {
	  availability: "AVAILABLE",
	  category: "DRINKS DESSERT",
	  isPopular: "YES",
	  key: "-M9aRmMLeT1fzaHZUOLK",
	  photos: [{
	    imageName: "eb144d90-ac57-11ea-985e-71484f367323.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Feb144d90-ac57-11ea-985e-71484f367323.jpg?alt=media&token=3d7a2556-c483-41e1-9b7f-2cb2304f1474"
	  }],
	  productNameEnglish: "Horlicks refill ",
	  productPrice: "7.90",
	  productSupplier: "BCS SHOP",
	  searchText: "হরলিক্স ",
	  sortOrder: "g",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "400g",
	  updateDateTime: "17/07/2020 07:41:20",
	  count: 18
	}, {
	  category: "MEAT FISH",
	  isPopular: "YES",
	  key: "-M9zp2dHatratHCAkQ7R",
	  photos: [{
	    imageName: "6448bd80-b037-11ea-9e6b-fd3fc5d44f8f.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F6448bd80-b037-11ea-9e6b-fd3fc5d44f8f.jpg?alt=media&token=5c22ec8a-4c8c-4e1f-be8f-b627ac0b6929"
	  }],
	  productDescription: "1pic 600G to 900G.",
	  productNameEnglish: "Ilish Fish - Medium",
	  productPrice: "25",
	  productSupplier: "BCS SHOP",
	  searchText: "ilish elis elish hisla ইলিশ ",
	  sortOrder: "a",
	  sourceSupplier: "TERRY TRADING CO PTE LTD",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1kg",
	  updateDateTime: "03/08/2020 05:24:13",
	  count: 18
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-M9b3EfDyq60NlPy0uO8",
	  photos: [{
	    imageName: "d6304170-e8db-11ea-b634-e7e7c4cb042d.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2Fd6304170-e8db-11ea-b634-e7e7c4cb042d.jpg?alt=media&token=a556f9c9-2e21-463f-8d57-9cb517b61bd6"
	  }],
	  productNameEnglish: "ATTA Flour",
	  productPrice: "1.80",
	  productSupplier: "BCS SHOP",
	  searchText: "atta",
	  sortOrder: "a",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1Kg Packet",
	  updateDateTime: "Fri 28-08-20 11:09 am",
	  count: 18
	}, {
	  availability: "AVAILABLE",
	  category: "রান্না করা খাবার",
	  key: "-MCQyJtJM1kmln_OE3uJ",
	  photos: [{
	    imageName: "9f409760-c80a-11ea-99a6-3f4f89ed7cd9.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F9f409760-c80a-11ea-99a6-3f4f89ed7cd9.jpg?alt=media&token=4f4eccb4-d964-40bf-a792-e19c40a1c92a"
	  }],
	  productNameEnglish: "পেঁপে ভর্তা  mashed papaya - Delivery by taxi, pay as meter-fare. ",
	  productPrice: "1",
	  productSupplier: "BCS SHOP",
	  searchText: "",
	  sortOrder: "a",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "1 serving ",
	  updateDateTime: "Tue 11-08-20 6:48 pm",
	  count: 17
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  key: "-M9fKkWFv5n6-RqH2DpL",
	  photos: [{
	    imageName: "07832630-ad17-11ea-8bc0-03f48af12a9c.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F07832630-ad17-11ea-8bc0-03f48af12a9c.jpg?alt=media&token=13bbb1f5-cd46-42c8-82d7-ff23b01d0a55"
	  }],
	  productNameEnglish: "PAGODA SEA SALT",
	  productPrice: "0.90",
	  productSupplier: "BCS SHOP",
	  searchText: "লবণ লবন",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "500g",
	  updateDateTime: "17/07/2020 08:50:15",
	  count: 17
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-MHJwuApldBM-FqskEBo",
	  photos: [{
	    imageName: "a10a7e70-f7cc-11ea-9ca4-275d4c37dc1b.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2Fa10a7e70-f7cc-11ea-9ca4-275d4c37dc1b.jpg?alt=media&token=2f1cd8b1-8072-43f0-bb05-11c203012f00"
	  }],
	  productNameEnglish: "pran chilli powder",
	  productPrice: "3.50",
	  productSupplier: "BCS SHOP",
	  searchText: "chilli powder",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "250g",
	  updateDateTime: "Wed 16-09-20 5:33 pm",
	  count: 17
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-MA-stIMYdnOFUC6-HLs",
	  photos: [{
	    imageName: "aa6a0610-c0ff-11ea-8470-83fbeadd4a74.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Faa6a0610-c0ff-11ea-8470-83fbeadd4a74.jpg?alt=media&token=034120b7-cba3-4703-a626-c8c8c4ec2234"
	  }],
	  productNameEnglish: "RADHUNI GARAM MASALA POWDER ",
	  productPrice: "2.20",
	  productSupplier: "BCS SHOP",
	  searchText: "গরম মশলা ",
	  sortOrder: "a",
	  sourceSupplier: "RAJDHANI ENTERPRISE PTE LTD",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "80g",
	  updateDateTime: "Tue 18-08-20 8:37 am",
	  count: 16
	}, {
	  availability: "AVAILABLE",
	  category: "DRINKS DESSERT",
	  isPopular: "YES",
	  key: "-M9pvV6nBjpjHiV6X0CV",
	  photos: [{
	    imageName: "94c360c0-aeb4-11ea-a578-077a102352bb.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F94c360c0-aeb4-11ea-a578-077a102352bb.jpg?alt=media&token=72ca56df-f33d-4162-b57c-e093b5130775"
	  }],
	  productNameEnglish: "Jaggery / Gour / Gur",
	  productPrice: "3.5",
	  productSupplier: "BCS SHOP",
	  searchText: "gur sugare cane মিঠাই ",
	  sortOrder: "a",
	  sourceSupplier: "TERRY TRADING CO PTE LTD",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: " 500gm",
	  updateDateTime: "03/08/2020 06:21:02",
	  count: 16
	}, {
	  availability: "AVAILABLE",
	  category: "DRINKS DESSERT",
	  isPopular: "YES",
	  key: "-MB8X5eB7StmB_sv4Fli",
	  photos: [{
	    imageName: "437a1230-bb76-11ea-9bec-f98d55a4d196.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F437a1230-bb76-11ea-9bec-f98d55a4d196.jpg?alt=media&token=b6760277-0838-48c4-a15c-87a32db02106"
	  }],
	  productNameEnglish: "PRAN Orange Powder ",
	  productPrice: "4.50",
	  productSupplier: "BCS SHOP",
	  searchText: "orange juice powder অরেঞ্জ জুস",
	  sortOrder: "g",
	  sourceSupplier: "GLOBAL PIONEEER PTE LTD",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "500ml",
	  updateDateTime: "03/08/2020 03:44:33",
	  count: 16
	}, {
	  availability: "AVAILABLE",
	  category: "COSMETICS",
	  key: "-M9qZ5EiIDdsa9Zg3LpE",
	  photos: [{
	    imageName: "5bcb99e0-aecd-11ea-b774-7962c3b67908.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F5bcb99e0-aecd-11ea-b774-7962c3b67908.jpg?alt=media&token=851cd3dd-5f35-4a51-a06d-e274dd956981"
	  }],
	  productNameEnglish: "Garnier Light Foam Facial Wash",
	  productPrice: "6.8",
	  productSupplier: "BCS SHOP",
	  searchText: "ফেইস ওয়াশ ",
	  sortOrder: "d",
	  sourceSupplier: "MUSTAFA CENTRE",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1pc of 100ML",
	  updateDateTime: "03/08/2020 06:01:46",
	  count: 16
	}, {
	  category: "MEAT FISH",
	  isPopular: "YES",
	  key: "-MA-081YlnomuMShqhCU",
	  photos: [{
	    imageName: "b2e7ad50-b03e-11ea-9737-25db4b55bc7b.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fb2e7ad50-b03e-11ea-9737-25db4b55bc7b.jpg?alt=media&token=a3257c88-e921-4c8d-8c84-7b8ba4eb1f30"
	  }],
	  productNameEnglish: "Tilapia ",
	  productPrice: "6",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  sourceSupplier: "AYSHA SUPERMARKET PTE LTD",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1KG",
	  updateDateTime: "03/08/2020 05:00:12",
	  count: 16
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-MA-s21eYOIHIgZgZ47u",
	  photos: [{
	    imageName: "01912890-f7d0-11ea-9ca4-275d4c37dc1b.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F01912890-f7d0-11ea-9ca4-275d4c37dc1b.jpg?alt=media&token=f0c6568d-56df-442a-b030-aca55b7ae8e9"
	  }],
	  productNameEnglish: "PRAN Garam Masala",
	  productPrice: "3.50",
	  productSupplier: "BCS SHOP",
	  searchText: "গরম মসলা ",
	  sortOrder: "a",
	  sourceSupplier: "KHAN PRODUCTS PTE LTD.",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "130g",
	  updateDateTime: "Wed 16-09-20 11:54 am",
	  count: 16
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  key: "-M9az5-Me-d8aZxa8GQ6",
	  photos: [{
	    imageName: "ef2c6410-f899-11ea-aaa8-a9cfb87a7f3a.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2Fef2c6410-f899-11ea-aaa8-a9cfb87a7f3a.jpg?alt=media&token=cf50a739-762a-4e82-a0c5-c51e14099503"
	  }],
	  productNameEnglish: "SWEET POTATOES ",
	  productPrice: "5",
	  productSupplier: "BCS SHOP",
	  searchText: "মিষ্টি আলু ",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1Kg",
	  updateDateTime: "Fri 02-10-20 11:09 am",
	  count: 16
	}, {
	  category: "RICE DAAL NOODLES",
	  key: "-M9maT0lAzHbQKcGlLMR",
	  photos: [{
	    imageName: "a14a4b60-ae32-11ea-8070-f3cc7bbcb5d1.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fa14a4b60-ae32-11ea-8070-f3cc7bbcb5d1.jpg?alt=media&token=7b230263-aba4-444d-a265-51b6a6df402a"
	  }],
	  productNameEnglish: "Ooty Pooni Rice - By Sri Ambikas",
	  productPrice: "9",
	  productSupplier: "BCS SHOP",
	  sortOrder: "b",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "5Kg",
	  updateDateTime: "03/08/2020 06:48:19",
	  count: 16
	}, {
	  availability: "AVAILABLE",
	  category: "DRINKS DESSERT",
	  isPopular: "NO",
	  key: "-M9aUEBtt43r8qUiG-Jk",
	  photos: [{
	    imageName: "74a5c830-ac59-11ea-abb9-bdb7271566ee.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F74a5c830-ac59-11ea-abb9-bdb7271566ee.jpg?alt=media&token=b1d26395-81c3-4f04-859f-5e1a62451811"
	  }],
	  productNameEnglish: "Super coffee",
	  productPrice: "6",
	  productSupplier: "BCS SHOP",
	  searchText: "কফি ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: " 40 pkts",
	  updateDateTime: "23/07/2020 12:47:40",
	  count: 15
	}, {
	  availability: "AVAILABLE",
	  category: "EGGS DAIRY",
	  key: "-M9b6-8mJq4PnN0R5X6L",
	  photos: [{
	    imageName: "bba5f940-ac71-11ea-8ded-437354ec7423.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fbba5f940-ac71-11ea-8ded-437354ec7423.jpg?alt=media&token=cb0a2a4e-70fb-468c-9348-6340c159e0f6"
	  }],
	  productNameEnglish: "Bread",
	  productPrice: "3.8",
	  productSupplier: "BCS SHOP",
	  searchText: "পাউরুটি পাওরোটি",
	  sortOrder: "d",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1 Pkt",
	  updateDateTime: "06/07/2020 09:40:11",
	  count: 14
	}, {
	  availability: "AVAILABLE",
	  category: "রান্না করা খাবার",
	  photos: [{
	    imageName: "dd057e00-f986-11ea-98b2-bdfbde6255e9.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2Fdd057e00-f986-11ea-98b2-bdfbde6255e9.jpg?alt=media&token=3a7a79ed-35e7-4cfa-bd33-2f2c88eb7355"
	  }],
	  productNameEnglish: "ভুড়ি রান্না।",
	  productPrice: "5",
	  productSupplier: "BCS SHOP",
	  searchText: "vure ranna.",
	  sortOrder: "1",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "1 serving",
	  updateDateTime: "Fri 18-09-20 4:13 pm",
	  key: "-MHVGfdf1MsX6RnFMzmV",
	  count: 14
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-M9bGBYZ5VvgyNm1gak2",
	  photos: [{
	    imageName: "e0b871f0-c804-11ea-9d1d-d9f4bc315562.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fe0b871f0-c804-11ea-9d1d-d9f4bc315562.jpg?alt=media&token=32776a49-4223-4e2c-9b57-805ce21daad6"
	  }],
	  productNameEnglish: "Duck oil 2L",
	  productPrice: "6",
	  productSupplier: "BCS SHOP",
	  searchText: "তেল তৈল ",
	  sortOrder: "d",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "2L",
	  updateDateTime: "17/07/2020 04:09:55",
	  count: 14
	}, {
	  availability: "AVAILABLE",
	  category: "SNACKS DRY FOOD",
	  key: "-MMUcA_ECvMzzCGqXyd6",
	  photos: [{
	    imageName: "8068ba40-2a41-11eb-bc77-4b3aa6852856.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F8068ba40-2a41-11eb-bc77-4b3aa6852856.jpg?alt=media&token=e0c10147-5cad-43d6-a818-0fe5a78abc05"
	  }],
	  productDescription: "Peanut Biscuit",
	  productNameEnglish: "Pran Cookies Peanut Biscuit",
	  productPrice: "3.5",
	  productSupplier: "BCS SHOP",
	  searchText: "cookies peanut biscuit",
	  sortOrder: "G",
	  supplierContactName: "Kabir",
	  supplierContactPhone: "94562455",
	  unit: "Bottle",
	  updateDateTime: "Fri 27-11-20 11:30 am",
	  count: 14
	}, {
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-MA0Gzo9OmETYuiqg36L",
	  photos: [{
	    imageName: "c0663890-bc58-11ea-b7df-33e703b87300.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fc0663890-bc58-11ea-b7df-33e703b87300.jpg?alt=media&token=39849a01-d994-4832-ac04-15fca8882d58"
	  }],
	  productNameEnglish: "Strawberries",
	  productPrice: "4.50",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  sourceSupplier: "Sheng siong ",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "250g",
	  updateDateTime: "Mon 21-09-20 3:39 pm",
	  count: 13
	}, {
	  availability: "AVAILABLE",
	  category: "DRINKS DESSERT",
	  isPopular: "YES",
	  key: "-MAZejYrhHO1ZLsEJ3AF",
	  photos: [{
	    imageName: "496b2ba0-bc4f-11ea-b7df-33e703b87300.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F496b2ba0-bc4f-11ea-b7df-33e703b87300.jpg?alt=media&token=684a42d8-1e00-4d42-9f9a-ad6f514604f9"
	  }],
	  productNameEnglish: "Rock Sugar",
	  productPrice: "2.20",
	  productSupplier: "BCS SHOP",
	  searchText: "mirchi মির্চি মির্ছি ",
	  sortOrder: "g",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "350g",
	  updateDateTime: "03/08/2020 03:46:25",
	  count: 13
	}, {
	  author: "+6589050302",
	  availability: "AVAILABLE",
	  category: "LAUNDRY CLEANING",
	  isPopular: "YES",
	  key: "-MBZOXMuKXHpRPhG7DoH",
	  photos: [{
	    imageName: "e14e8730-bf8f-11ea-85e3-735b22b1a0db.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fe14e8730-bf8f-11ea-85e3-735b22b1a0db.jpg?alt=media&token=7394dbcb-27e6-4c79-a3d3-250cef082cd9"
	  }],
	  productNameEnglish: "FAB Detergent Powder - Downy",
	  productPrice: "11.50",
	  productSupplier: "BCS SHOP",
	  searchText: "ওয়াশিং পাউডার কাপড় ধুয়ার পাউডার",
	  sortOrder: "g",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "4.7kg",
	  updateDateTime: "Thu 06-08-20 12:46 pm",
	  count: 13
	}, {
	  availability: "AVAILABLE",
	  category: "SNACKS DRY FOOD",
	  isPopular: "YES",
	  key: "-M9aUeq2jeBQO3RmM6qP",
	  photos: [{
	    imageName: "b42e2010-ac59-11ea-bbe4-619ccaa778ae.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fb42e2010-ac59-11ea-bbe4-619ccaa778ae.jpg?alt=media&token=1388583b-af31-4f72-9810-0a5c20199038"
	  }],
	  productNameEnglish: "PEANUT ",
	  productPrice: "0.80",
	  productSupplier: "BCS SHOP",
	  searchText: "বাদাম ",
	  sortOrder: "a",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "100G",
	  updateDateTime: "23/07/2020 12:46:44",
	  count: 13
	}, {
	  category: "COOKING OIL INGREDIENTS",
	  key: "-M9fWgVH0Saajjgwca01",
	  photos: [{
	    imageName: "4f592d90-ad1e-11ea-9a01-db9ea96fa329.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F4f592d90-ad1e-11ea-9a01-db9ea96fa329.jpg?alt=media&token=25af8b2c-bd2d-4313-bc12-165cd8b23390"
	  }],
	  productNameEnglish: "OKI PREMIUM SUNFLOWER OIL",
	  productPrice: "7.90",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "2L",
	  updateDateTime: "Tue 18-08-20 9:07 am",
	  count: 13
	}, {
	  category: "MEAT FISH",
	  isPopular: "YES",
	  key: "-M9zz8Y5c7-PpsTsEobK",
	  photos: [{
	    imageName: "0d5bd5e0-c5bb-11ea-8edb-cd6b1542138d.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F0d5bd5e0-c5bb-11ea-8edb-cd6b1542138d.jpg?alt=media&token=36469c2b-0749-41a0-ae7a-26f5fca51c98"
	  }],
	  productNameEnglish: "Catfish",
	  productPrice: "7",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  sourceSupplier: "AYSHA SUPERMARKET PTE LTD",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1KG",
	  updateDateTime: "03/08/2020 05:19:27",
	  count: 13
	}, {
	  availability: "AVAILABLE",
	  category: "RICE DAAL NOODLES",
	  isPopular: "YES",
	  key: "-M9bESNPxTDsCiuOhYQe",
	  photos: [{
	    imageName: "222cc2f0-bd9f-11ea-9c87-8df410c3c074.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F222cc2f0-bd9f-11ea-9c87-8df410c3c074.jpg?alt=media&token=274dc654-a767-4c6c-906f-f62cc865739b"
	  }],
	  productNameEnglish: "Channa dhal lentils 500gm",
	  productPrice: "2.5",
	  productSupplier: "BCS SHOP",
	  searchText: "chana dal dhal ডাল",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "500gm",
	  updateDateTime: "17/07/2020 08:55:55",
	  count: 13
	}, {
	  category: "SNACKS DRY FOOD",
	  isPopular: "YES",
	  key: "-M9b9n5oKPtCjUoynwer",
	  photos: [{
	    imageName: "f00ecde0-ac73-11ea-8ded-437354ec7423.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Ff00ecde0-ac73-11ea-8ded-437354ec7423.jpg?alt=media&token=54d0d0a4-6b52-442c-946e-541d50fa28b9"
	  }],
	  productNameEnglish: "Biscuits",
	  productPrice: "4",
	  productSupplier: "BCS SHOP",
	  searchText: "sweet biscuit buiskit",
	  sortOrder: "d",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1 packet",
	  updateDateTime: "04/07/2020 08:46:22",
	  count: 12
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-MA4Na2HCRG67mD6NL0z",
	  photos: [{
	    imageName: "80ddab90-bdb6-11ea-8ba8-ddb60ef370d4.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F80ddab90-bdb6-11ea-8ba8-ddb60ef370d4.jpg?alt=media&token=148e4f5f-0c4f-45f9-97a9-eb6a2c3a470d"
	  }],
	  productNameEnglish: "Sponge Gourd",
	  productPrice: "6",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  sourceSupplier: "Amman trading ",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1kg",
	  updateDateTime: "03/08/2020 04:25:41",
	  count: 12
	}, {
	  availability: "AVAILABLE",
	  category: "রান্না করা খাবার",
	  key: "-MCRDjCeuWwGy19C9iJN",
	  photos: [{
	    imageName: "71693af0-c81d-11ea-99a6-3f4f89ed7cd9.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F71693af0-c81d-11ea-99a6-3f4f89ed7cd9.jpg?alt=media&token=4b572523-e57a-4634-8474-893337f38f05"
	  }],
	  productNameEnglish: "মুরগির মাংস  chicken curry - Delivery by taxi, pay as meter-fare. ",
	  productPrice: "4 ",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "1 serving ",
	  updateDateTime: "Tue 11-08-20 6:45 pm",
	  count: 12
	}, {
	  availability: "AVAILABLE",
	  category: "DRINKS DESSERT",
	  photos: [{
	    imageName: "9d552330-2a43-11eb-97e8-9befc076c3e3.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F9d552330-2a43-11eb-97e8-9befc076c3e3.jpg?alt=media&token=73082170-4d97-4773-b699-97a11f23f03c"
	  }],
	  productDescription: "Milk Tea Sticks",
	  productNameEnglish: "Milk Tea Sticks",
	  productPrice: "4.95",
	  productSupplier: "BCS SHOP",
	  searchText: "milk tea",
	  sortOrder: "G",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "Bag(25 Sticks)",
	  updateDateTime: "Thu 19-11-20 7:46 pm",
	  key: "-MMUfeXIb0tl1MtLtJGE",
	  count: 12
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-MA-EUUCDoHoerBWyGXD",
	  photos: [{
	    imageName: "575b0190-b047-11ea-9737-25db4b55bc7b.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F575b0190-b047-11ea-9737-25db4b55bc7b.jpg?alt=media&token=f5e170aa-ba5d-4d33-aa9a-70c6627dff4e"
	  }],
	  productNameEnglish: "RADHUNI Beef Masala",
	  productPrice: "3.50",
	  productSupplier: "BCS SHOP",
	  searchText: "গরুর মাংস মসলা",
	  sortOrder: "a",
	  sourceSupplier: "KHAN PRODUCTS PTE LTD.",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "68G",
	  updateDateTime: "03/08/2020 04:54:49",
	  count: 12
	}, {
	  availability: "AVAILABLE",
	  category: "EGGS DAIRY",
	  key: "-M9bHoKF-2K9TkktZI1L",
	  photos: [{
	    imageName: "eda24870-ac78-11ea-90b2-195942e61adb.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Feda24870-ac78-11ea-90b2-195942e61adb.jpg?alt=media&token=10aa5058-9dc1-4df5-9b5d-ba4eb5adab9c"
	  }],
	  productNameEnglish: "Cake traditional 1packet",
	  productPrice: "2.5",
	  productSupplier: "BCS SHOP",
	  searchText: "কেক ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1 pkt",
	  updateDateTime: "17/07/2020 03:16:29",
	  count: 11
	}, {
	  availability: "AVAILABLE",
	  category: "EGGS DAIRY",
	  isPopular: "YES",
	  key: "-M9ccYf_UiWa3q-Eyubz",
	  photos: [{
	    imageName: "5399f5e0-acad-11ea-ab51-0f18e1d42bbd.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F5399f5e0-acad-11ea-ab51-0f18e1d42bbd.jpg?alt=media&token=21615a34-8ecf-4244-8310-23c58e04ed51"
	  }],
	  productNameEnglish: "FARMHOUSE FRESH UHT MILK",
	  productPrice: "3.50",
	  productSupplier: "BCS SHOP",
	  searchText: "fresh milk ধুদ ",
	  sortOrder: "a",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1L",
	  updateDateTime: "23/07/2020 12:28:18",
	  count: 11
	}, {
	  category: "EGGS DAIRY",
	  isPopular: "YES",
	  key: "-M9b4GhsoKiSOk7LB9RD",
	  photos: [{
	    imageName: "8231fc50-ac70-11ea-9366-875156fdc5b0.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F8231fc50-ac70-11ea-9366-875156fdc5b0.jpg?alt=media&token=63f79f59-7260-4728-aac4-89908bf5dab5"
	  }],
	  productNameEnglish: "HL banana/strawberry milk",
	  productPrice: "6",
	  productSupplier: "BCS SHOP",
	  searchText: "fresh milk",
	  sortOrder: "d",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "2 x 1L",
	  updateDateTime: "05/07/2020 12:10:24",
	  count: 11
	}, {
	  availability: "AVAILABLE",
	  category: "RICE DAAL NOODLES",
	  isPopular: "YES",
	  key: "-M9fZqq9ZQaum3QmTD2W",
	  photos: [{
	    imageName: "407ffdb0-ad20-11ea-9a01-db9ea96fa329.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F407ffdb0-ad20-11ea-9a01-db9ea96fa329.jpg?alt=media&token=234d5097-afd8-47b9-be11-31dbce5f6f5d"
	  }],
	  productNameEnglish: "MYOJO CHICKEN ABALONE FLAVOURED INSTANT NOODLES ",
	  productPrice: "2.5",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "5 pack 79gm",
	  updateDateTime: "17/07/2020 06:53:25",
	  count: 11
	}, {
	  category: "MEAT FISH",
	  isPopular: "YES",
	  key: "-M9zzmXCYPD7EUwz7pRI",
	  photos: [{
	    imageName: "8f6a0e30-c5bb-11ea-8edb-cd6b1542138d.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F8f6a0e30-c5bb-11ea-8edb-cd6b1542138d.jpg?alt=media&token=48e71bcf-2931-464f-b488-ba579dba1e9a"
	  }],
	  productDescription: "Price not stable  $13~$23.",
	  productNameEnglish: "Silver Pomfret",
	  productPrice: "15",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  sourceSupplier: "RAJDHANI ENTERPRISE PTE LTD",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1KG",
	  updateDateTime: "03/08/2020 05:19:59",
	  count: 11
	}, {
	  author: "+6589050302",
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  key: "-M9aW8grXeHaS2bkydWz",
	  photos: [{
	    imageName: "a2db8130-ac5a-11ea-943a-e361d08112a3.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fa2db8130-ac5a-11ea-943a-e361d08112a3.jpg?alt=media&token=7b6e03c4-43f6-4548-aeb3-0d72cf3688cc"
	  }],
	  productNameEnglish: "Gold oil 2kg",
	  productPrice: "9.80",
	  productSupplier: "BCS SHOP",
	  searchText: "তেল ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "2L",
	  updateDateTime: "Mon 10-08-20 12:01 pm",
	  count: 11
	}, {
	  category: "DRINKS DESSERT",
	  key: "-M9b3lrh63IHxC_1Mssm",
	  photos: [{
	    imageName: "4db120f0-ac70-11ea-9366-875156fdc5b0.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F4db120f0-ac70-11ea-9366-875156fdc5b0.jpg?alt=media&token=89f1f325-5fca-465b-88ba-d8436e533a81"
	  }],
	  productNameEnglish: "Orange juice drink",
	  productPrice: "4.5",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "2L",
	  updateDateTime: "05/07/2020 12:14:31",
	  count: 11
	}, {
	  availability: "OUT OF STOCK, TOPPING UP IN PROGRESS",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-MAZdpGYWmipvq1nf4Ja",
	  photos: [{
	    imageName: "f27709e0-bc4e-11ea-b7df-33e703b87300.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Ff27709e0-bc4e-11ea-b7df-33e703b87300.jpg?alt=media&token=249abff1-d69c-46c5-a563-12c2ce077a2f"
	  }],
	  productNameEnglish: "Himalay Coriander Powder",
	  productPrice: "2.50",
	  productSupplier: "BCS SHOP",
	  searchText: "ধনিয়ার গুঁড়া ",
	  sortOrder: "g",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "125g",
	  updateDateTime: "Fri 14-08-20 4:18 pm",
	  count: 10
	}, {
	  availability: "AVAILABLE",
	  category: "RICE DAAL NOODLES",
	  isPopular: "YES",
	  key: "-M9bG0Ew_O0J9zgK08Ft",
	  photos: [{
	    imageName: "bd161c50-ac77-11ea-891a-2516dcf49b13.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fbd161c50-ac77-11ea-891a-2516dcf49b13.jpg?alt=media&token=121ac522-9835-41e2-bc69-159b7b01944f"
	  }],
	  productNameEnglish: "SELF RAISING FLOUR",
	  productPrice: "2.80 ",
	  productSupplier: "BCS SHOP",
	  searchText: "maida mayda fine ata atta আটা ময়দা",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1Kg Packet",
	  updateDateTime: "17/07/2020 04:13:25",
	  count: 10
	}, {
	  availability: "AVAILABLE",
	  category: "TOILETRIES",
	  key: "-M9b7HZfPuATJUBkTdCs",
	  photos: [{
	    imageName: "91e2cab0-ac72-11ea-83ef-037972cabc05.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F91e2cab0-ac72-11ea-83ef-037972cabc05.jpg?alt=media&token=755f870a-7fbe-4703-bc41-4a71cf5cfed5"
	  }],
	  productNameEnglish: "DOVE BODY WASH",
	  productPrice: "7.5",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "Btl ",
	  updateDateTime: "Wed 02-12-20 10:22 am",
	  count: 10
	}, {
	  category: "MEAT FISH",
	  isPopular: "YES",
	  key: "-M9znavrxvUDOHWhLi0C",
	  photos: [{
	    imageName: "80f4a260-b036-11ea-9e6b-fd3fc5d44f8f.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F80f4a260-b036-11ea-9e6b-fd3fc5d44f8f.jpg?alt=media&token=fe5cdec9-0d8a-47a6-851c-1a6933987683"
	  }],
	  productDescription: "1pcs is 900gm to 1.5kg",
	  productNameEnglish: "Ilish Fish - Large",
	  productPrice: "30",
	  productSupplier: "BCS SHOP",
	  searchText: "elish ilis elis isish fish ইলিশ ",
	  sortOrder: "a",
	  sourceSupplier: "TERRY TRADING CO PTE LTD",
	  supplierContactName: "arif",
	  supplierContactPhone: "84124637",
	  unit: "1KG ",
	  updateDateTime: "03/08/2020 05:24:38",
	  count: 10
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  key: "-M9azxw85yqueK8BLY-D",
	  photos: [{
	    imageName: "83655650-f89a-11ea-aaa8-a9cfb87a7f3a.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F83655650-f89a-11ea-aaa8-a9cfb87a7f3a.jpg?alt=media&token=003237b8-013d-48f9-a76a-a63fd9e36fd1"
	  }],
	  productNameEnglish: "MANGO ",
	  productPrice: "3.50",
	  productSupplier: "BCS SHOP",
	  searchText: "আম ",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1 pc",
	  updateDateTime: "Mon 21-09-20 3:34 pm",
	  count: 10
	}, {
	  author: "+6589050302",
	  availability: "AVAILABLE",
	  category: "EGGS DAIRY",
	  isPopular: "NO",
	  key: "-M9Y03q7FRuMQjK5r4uT",
	  photos: [{
	    imageName: "2e329130-c103-11ea-8470-83fbeadd4a74.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F2e329130-c103-11ea-8470-83fbeadd4a74.jpg?alt=media&token=4beb50e2-d473-4791-b9ba-e679e035548d"
	  }],
	  productNameEnglish: "Yogurt ",
	  productPrice: "1.10",
	  productSupplier: "BCS SHOP",
	  searchText: "দই দধি ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1pc",
	  updateDateTime: "Wed 16-09-20 8:08 am",
	  count: 10
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  photos: [{
	    imageName: "2a89fc70-01fa-11eb-b3c7-236ec5a8a539.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F2a89fc70-01fa-11eb-b3c7-236ec5a8a539.jpg?alt=media&token=7c5f9ad7-c20f-4e07-bbda-15170cc0a6a7"
	  }],
	  productNameEnglish: "Kasundi ",
	  productPrice: "2",
	  productSupplier: "BCS SHOP",
	  searchText: "Kasundi ",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "300g",
	  updateDateTime: "Tue 29-09-20 10:19 am",
	  key: "-MIMe1KwabBD0YmmG3qm",
	  count: 10
	}, {
	  category: "COOKING OIL INGREDIENTS",
	  key: "-M9fY8PRxRRgFSg4VoDC",
	  photos: [{
	    imageName: "355bc6e0-ad1f-11ea-9a01-db9ea96fa329.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F355bc6e0-ad1f-11ea-9a01-db9ea96fa329.jpg?alt=media&token=867996e2-0035-4b7e-b3f9-314b813338ec"
	  }],
	  productNameEnglish: "GOLDEN CIRCLE SUNFLOWER OIL",
	  productPrice: "15",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "5L",
	  updateDateTime: "04/07/2020 11:50:50",
	  count: 9
	}, {
	  availability: "AVAILABLE",
	  category: "RICE DAAL NOODLES",
	  isPopular: "YES",
	  key: "-M9aVKAJjayljKS9Th5s",
	  photos: [{
	    imageName: "2b985630-f899-11ea-aaa8-a9cfb87a7f3a.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F2b985630-f899-11ea-aaa8-a9cfb87a7f3a.jpg?alt=media&token=1e4a7b65-b3c4-453c-a5c3-5d45e4d79ba4"
	  }],
	  productNameEnglish: "Rice ",
	  productPrice: "7.8",
	  productSupplier: "BCS SHOP",
	  searchText: "চাউল",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "5kg",
	  updateDateTime: "Thu 17-09-20 11:52 am",
	  count: 9
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-MA4RT70EXT1R-MsMAVd",
	  photos: [{
	    imageName: "0046bbe0-bdb4-11ea-8ba8-ddb60ef370d4.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F0046bbe0-bdb4-11ea-8ba8-ddb60ef370d4.jpg?alt=media&token=3b0fb145-bf3f-429f-b4fe-bd7a7ca49ca7"
	  }],
	  productNameEnglish: "Ridge Gourd",
	  productPrice: "6.20",
	  productSupplier: "BCS SHOP",
	  searchText: "jinga zinga jingha ",
	  sortOrder: "a",
	  sourceSupplier: "Veg mart ",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1kg",
	  updateDateTime: "03/08/2020 04:24:11",
	  count: 9
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-M9aSP39jNTjGW4ykAwz",
	  photos: [{
	    imageName: "4b14b810-ac58-11ea-bbe4-619ccaa778ae.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F4b14b810-ac58-11ea-bbe4-619ccaa778ae.jpg?alt=media&token=6247c545-4ff3-4cc8-8671-6d198ed11612"
	  }],
	  productNameEnglish: "BLACK PEPPER ",
	  productPrice: "3.20",
	  productSupplier: "BCS SHOP",
	  searchText: "গোল মরিচ",
	  sortOrder: "a",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1pkt",
	  updateDateTime: "23/07/2020 12:51:48",
	  count: 9
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-M9YXC8HFxzWybtMNJwR",
	  photos: [{
	    imageName: "0bad0e60-abe6-11ea-99a0-ada8a2be9f1b.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F0bad0e60-abe6-11ea-99a0-ada8a2be9f1b.jpg?alt=media&token=31a8943b-38a7-4aac-9cc1-b10e7eddbba0"
	  }],
	  productNameEnglish: "yardlong long bean",
	  productPrice: "4.5",
	  productSupplier: "BCS SHOP",
	  searchText: "বরবটি ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1kg",
	  updateDateTime: "17/07/2020 08:33:48",
	  count: 9
	}, {
	  availability: "AVAILABLE",
	  category: "COSMETICS",
	  isPopular: "YES",
	  key: "-MA-vTilQKSysy5VlORf",
	  photos: [{
	    imageName: "905237c0-bc59-11ea-b7df-33e703b87300.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F905237c0-bc59-11ea-b7df-33e703b87300.jpg?alt=media&token=b5a6f868-7444-4f54-bd7e-e85fd004c443"
	  }],
	  productNameEnglish: "Fair & Lovely Daily Whitening Cream",
	  productPrice: "5.20",
	  productSupplier: "BCS SHOP",
	  searchText: "ফেইস ক্রিম",
	  sortOrder: "x",
	  sourceSupplier: "MUSTAFA CENTRE",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "25G",
	  updateDateTime: "17/07/2020 06:31:59",
	  count: 9
	}, {
	  availability: "OUT OF STOCK, TOPPING UP IN PROGRESS",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-MAZe6naCD3X8bi9CORd",
	  photos: [{
	    imageName: "26a8dae0-bc4f-11ea-b7df-33e703b87300.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F26a8dae0-bc4f-11ea-b7df-33e703b87300.jpg?alt=media&token=4ec20587-3bbf-4fe4-a841-948d61bb46d9"
	  }],
	  productNameEnglish: "Himalay Cumin Powder",
	  productPrice: "3.50",
	  productSupplier: "BCS SHOP",
	  searchText: "zira jeera jira জিরা ",
	  sortOrder: "g",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "125g",
	  updateDateTime: "Fri 14-08-20 4:18 pm",
	  count: 8
	}, {
	  category: "KITCHEN DINING",
	  isPopular: "YES",
	  key: "-M9agD1h6myA-aTwEf9n",
	  photos: [{
	    imageName: "4e8585c0-ac61-11ea-bbe4-ef7bbce60778.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F4e8585c0-ac61-11ea-bbe4-ef7bbce60778.jpg?alt=media&token=1aac9faa-a6d2-4d17-8f9d-69f4b8cd7d6a"
	  }],
	  productNameEnglish: "Dish plate washing sumu ",
	  productPrice: "2.5",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1 container",
	  updateDateTime: "05/07/2020 12:52:00",
	  count: 8
	}, {
	  availability: "AVAILABLE",
	  category: "রান্না করা খাবার",
	  key: "-MCRAxQoO6xt9ez_xpWK",
	  photos: [{
	    imageName: "d4c358c0-c812-11ea-99a6-3f4f89ed7cd9.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fd4c358c0-c812-11ea-99a6-3f4f89ed7cd9.jpg?alt=media&token=b868a8b5-6897-4cd9-9b7f-ab3521db00fa"
	  }],
	  productNameEnglish: "কৈ মাছ  Koi fish curry - Delivery by taxi, pay as meter-fare. ",
	  productPrice: "4",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "1 serving ",
	  updateDateTime: "Tue 11-08-20 6:45 pm",
	  count: 8
	}, {
	  category: "COSMETICS",
	  isPopular: "YES",
	  key: "-MA-tazsHlmvFvZ0mjFU",
	  photos: [{
	    imageName: "4c030310-b213-11ea-921f-9db4b33fb426.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F4c030310-b213-11ea-921f-9db4b33fb426.jpg?alt=media&token=1558cce1-de64-4608-8ba1-14666e3d733c"
	  }],
	  productNameEnglish: "Fair & Handsome Advanced Whitening Cream",
	  productPrice: "5.20",
	  productSupplier: "BCS SHOP",
	  searchText: "fair & handsome ফেইস ক্রিম",
	  sortOrder: "x",
	  sourceSupplier: "MUSTAFA CENTRE",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "50G",
	  updateDateTime: "03/08/2020 04:33:26",
	  count: 8
	}, {
	  availability: "AVAILABLE",
	  category: "MEAT FISH",
	  isPopular: "YES",
	  key: "-M9a2iFZWTS972ahdFLF",
	  photos: [{
	    imageName: "b046e380-ac48-11ea-ba1a-4bcfa8bf5006.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fb046e380-ac48-11ea-ba1a-4bcfa8bf5006.jpg?alt=media&token=22920773-af55-4253-b1d8-dc02ba62bde0"
	  }],
	  productNameEnglish: "Fish small ",
	  productPrice: "5.5",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1 packet",
	  updateDateTime: "06/07/2020 07:12:48",
	  count: 8
	}, {
	  availability: "AVAILABLE",
	  category: "EGGS DAIRY",
	  isPopular: "YES",
	  key: "-MBIm9l66dbWcOIQ7hNU",
	  photos: [{
	    imageName: "ddad7f90-bd06-11ea-83e5-cbed5ea0d8b3.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fddad7f90-bd06-11ea-83e5-cbed5ea0d8b3.jpg?alt=media&token=c286cf2e-8b36-4a7a-a45b-11bd6579576c"
	  }],
	  productNameEnglish: "Nespray Everyday Instant Milk Powder",
	  productPrice: "9.95",
	  productSupplier: "BCS SHOP",
	  searchText: "milk naspry nespry nestly powder ধুদ ",
	  sortOrder: "g",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "550g",
	  updateDateTime: "03/08/2020 03:41:59",
	  count: 8
	}, {
	  category: "COOKING OIL INGREDIENTS",
	  key: "-M9fWDRRy5rGN0ssRTbd",
	  photos: [{
	    imageName: "09735940-ad1e-11ea-9a01-db9ea96fa329.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F09735940-ad1e-11ea-9a01-db9ea96fa329.jpg?alt=media&token=28d27ee0-f020-4787-9258-5f72de09ff3b"
	  }],
	  productNameEnglish: "MAGGI CHILLI SAUCE",
	  productPrice: "2.70",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "500g",
	  updateDateTime: "04/07/2020 11:56:56",
	  count: 8
	}, {
	  availability: "AVAILABLE",
	  category: "DRINKS DESSERT",
	  isPopular: "YES",
	  key: "-MB8XrLyYdlYzf0Rutzt",
	  photos: [{
	    imageName: "8e563c60-bb77-11ea-9bec-f98d55a4d196.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F8e563c60-bb77-11ea-9bec-f98d55a4d196.jpg?alt=media&token=bcb1f0ad-b14d-4db9-a63c-e615ef251469"
	  }],
	  productNameEnglish: "PRAN Frooto Mango Juice",
	  productPrice: "2.50",
	  productSupplier: "BCS SHOP",
	  searchText: "amer juice mango mengo আমের রস জুস ",
	  sortOrder: "g",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "1000ml",
	  updateDateTime: "03/08/2020 03:43:36",
	  count: 8
	}, {
	  category: "COSMETICS",
	  isPopular: "YES",
	  key: "-MA-t186nywzez5LkCVy",
	  photos: [{
	    imageName: "a2ae5c00-b213-11ea-921f-9db4b33fb426.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fa2ae5c00-b213-11ea-921f-9db4b33fb426.jpg?alt=media&token=0f958146-9d0d-43e9-a07a-d5d2437402f6"
	  }],
	  productNameEnglish: "Fair & Handsome Advanced Whitening Cream - Oil Control",
	  productPrice: "4.20",
	  productSupplier: "BCS SHOP",
	  searchText: "ফেইস ক্রিম",
	  sortOrder: "x",
	  sourceSupplier: "MUSTAFA CENTRE",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "50G",
	  updateDateTime: "03/08/2020 04:34:26",
	  count: 8
	}, {
	  availability: "AVAILABLE",
	  category: "RICE DAAL NOODLES",
	  isPopular: "YES",
	  key: "-MBZW8vSHpbvJHgwGif3",
	  photos: [{
	    imageName: "7807e5f0-bf94-11ea-85e3-735b22b1a0db.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F7807e5f0-bf94-11ea-85e3-735b22b1a0db.jpg?alt=media&token=f17c7097-80ff-4b86-857c-8b9b2c041e35"
	  }],
	  productNameEnglish: "India Gate Premium Basmati Rice",
	  productPrice: "20.50",
	  productSupplier: "BCS SHOP",
	  searchText: "বাসমতি চাউল ",
	  sortOrder: "a",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "5kg",
	  updateDateTime: "03/08/2020 03:28:48",
	  count: 8
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "NO",
	  key: "-MA4cWSW0HAda4zBywEU",
	  photos: [{
	    imageName: "ff26c0d0-b119-11ea-810a-c5e0250e7646.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fff26c0d0-b119-11ea-810a-c5e0250e7646.jpg?alt=media&token=c10f409e-fbee-4c33-99d1-8f1533db8b86"
	  }],
	  productNameEnglish: "Coconut",
	  productPrice: "2.50",
	  productSupplier: "BCS SHOP",
	  searchText: "নারিকেল ",
	  sortOrder: "a",
	  sourceSupplier: "Minaka trading ",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1PC",
	  updateDateTime: "17/07/2020 02:11:44",
	  count: 8
	}, {
	  availability: "AVAILABLE",
	  category: "LAUNDRY CLEANING",
	  key: "-M9bAZLU-a_Q-V-WlbbY",
	  photos: [{
	    imageName: "7884e2e0-ac74-11ea-8ded-437354ec7423.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F7884e2e0-ac74-11ea-8ded-437354ec7423.jpg?alt=media&token=640f2b31-ab60-48c9-bc9a-fac131af8e2a"
	  }],
	  productNameEnglish: "Detergent powder home niks",
	  productPrice: "8.5",
	  productSupplier: "BCS SHOP",
	  searchText: "ওয়াশিং পাউডার ",
	  sortOrder: "f",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "5Kg",
	  updateDateTime: "17/07/2020 07:56:35",
	  count: 8
	}, {
	  category: "SNACKS DRY FOOD",
	  key: "-MA-ozuXRBn4GTx3Mhpe",
	  photos: [{
	    imageName: "2dac4270-b216-11ea-921f-9db4b33fb426.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F2dac4270-b216-11ea-921f-9db4b33fb426.jpg?alt=media&token=e0e21e43-159a-49b0-a77b-9312df500800"
	  }],
	  productNameEnglish: "Pringles Original Potato Chips",
	  productPrice: "2.70",
	  productSupplier: "BCS SHOP",
	  sortOrder: "h",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "147G",
	  updateDateTime: "03/08/2020 04:37:00",
	  count: 8
	}, {
	  author: "+6589050302",
	  category: "DRINKS DESSERT",
	  key: "-M9fioFzWCqGG8o7tc88",
	  photos: [{
	    imageName: "55884d60-ad26-11ea-9a01-db9ea96fa329.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F55884d60-ad26-11ea-9a01-db9ea96fa329.jpg?alt=media&token=f9fdd525-8908-49e8-bc7a-0253dc6b4adb"
	  }],
	  productNameEnglish: "OSK 100% JAPANESE GREEN TEA",
	  productPrice: "7.95",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "50 per pack",
	  updateDateTime: "17/07/2020 08:54:46",
	  count: 8
	}, {
	  author: "+6589050302",
	  availability: "AVAILABLE",
	  category: "EGGS DAIRY",
	  isPopular: "YES",
	  key: "-MABkwxm7pStALGAF3ev",
	  photos: [{
	    imageName: "4ba4f990-bc50-11ea-b7df-33e703b87300.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F4ba4f990-bc50-11ea-b7df-33e703b87300.jpg?alt=media&token=f55e6d5a-4cc4-4653-8c6f-62ec45f5b57c"
	  }],
	  productNameEnglish: "Nestle Everyday Instant Milk Powder ",
	  productPrice: "20.90",
	  productSupplier: "BCS SHOP",
	  searchText: "milk ধুদ ",
	  sortOrder: "c",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "1kg Packet",
	  updateDateTime: "Thu 13-08-20 10:50 pm",
	  count: 7
	}, {
	  category: "TUPPERWARE CONTAINER",
	  key: "-M9q5QC6nrc4MfVdUoN0",
	  photos: [{
	    imageName: "5b02a9c0-aebb-11ea-9600-53e79e8cda87.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F5b02a9c0-aebb-11ea-9600-53e79e8cda87.jpg?alt=media&token=809b5b04-7592-4e2f-a094-2d248028db9a"
	  }],
	  productDescription: " 5PCS OF 1 PACK",
	  productNameEnglish: "Glad Soup & Salad Containers",
	  productPrice: "5.90",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  sourceSupplier: "MUSTAFA CENTRE",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "5PCS",
	  updateDateTime: "03/08/2020 06:14:27",
	  count: 7
	}, {
	  category: "RICE DAAL NOODLES",
	  key: "-M9b8iXcL7dhjtXM7st6",
	  photos: [{
	    imageName: "49a41cd0-ac73-11ea-8ded-437354ec7423.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F49a41cd0-ac73-11ea-8ded-437354ec7423.jpg?alt=media&token=27c4bcd5-378a-415e-8b95-5102e1e649a3"
	  }],
	  productNameEnglish: "Noodles tom yam/asam laksa/kari letup",
	  productPrice: "2.5",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1 Pkt",
	  updateDateTime: "04/07/2020 08:48:26",
	  count: 7
	}, {
	  category: "RICE DAAL NOODLES",
	  isPopular: "YES",
	  key: "-M9bH7pWwS_Hs2PnjPxw",
	  photos: [{
	    imageName: "78b62f40-ac78-11ea-891a-2516dcf49b13.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F78b62f40-ac78-11ea-891a-2516dcf49b13.jpg?alt=media&token=288e7221-e028-41a5-bbb2-f548e74e5773"
	  }],
	  productNameEnglish: "BASIL SEEDS",
	  productPrice: "3 ",
	  productSupplier: "BCS SHOP",
	  searchText: "tokma tukma tukh malanga",
	  sortOrder: "c",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "100g",
	  updateDateTime: "04/07/2020 08:27:20",
	  count: 7
	}, {
	  availability: "AVAILABLE",
	  category: "SNACKS DRY FOOD",
	  isPopular: "NO",
	  key: "-M9a_DoeaS6RlzomcExY",
	  photos: [{
	    imageName: "23c3c530-ac5d-11ea-bbe4-619ccaa778ae.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F23c3c530-ac5d-11ea-bbe4-619ccaa778ae.jpg?alt=media&token=e15f3569-efc2-473e-932f-af0cc080335f"
	  }],
	  productNameEnglish: "TOAST ",
	  productPrice: "2",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1 pkt",
	  updateDateTime: "23/07/2020 12:33:50",
	  count: 7
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  key: "-M9bG1j4cuWPwuqeWkuI",
	  photos: [{
	    imageName: "dfdb2c30-ac77-11ea-8ded-437354ec7423.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fdfdb2c30-ac77-11ea-8ded-437354ec7423.jpg?alt=media&token=8f88031d-2ff0-402b-8bdf-079d45a83130"
	  }],
	  productNameEnglish: "Soya bean oil ",
	  productPrice: "12.5",
	  productSupplier: "BCS SHOP",
	  searchText: "তেল তৈল ",
	  sortOrder: "d",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "5L",
	  updateDateTime: "17/07/2020 04:10:11",
	  count: 7
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  key: "-M9fMr2qCr1ml6DTdCaT",
	  photos: [{
	    imageName: "52a9c6e0-ad18-11ea-8bc0-03f48af12a9c.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F52a9c6e0-ad18-11ea-8bc0-03f48af12a9c.jpg?alt=media&token=02bc8234-8baf-4684-87ec-49f11199e839"
	  }],
	  productNameEnglish: "MAGGI TOMATO KETCHUP (HEALTHIER CHOICE)",
	  productPrice: "2",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "475g",
	  updateDateTime: "17/07/2020 08:30:55",
	  count: 7
	}, {
	  availability: "AVAILABLE",
	  category: "TOILETRIES",
	  key: "-MBZVee48Q_dgFNvFRDp",
	  photos: [{
	    imageName: "41a8d4b0-bf94-11ea-85e3-735b22b1a0db.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F41a8d4b0-bf94-11ea-85e3-735b22b1a0db.jpg?alt=media&token=27ac8c4c-13f3-47cb-9533-c4477ac2050e"
	  }],
	  productNameEnglish: "Ginvera Natural Bath Shower Gel  ",
	  productPrice: "4.95",
	  productSupplier: "BCS SHOP",
	  searchText: "শাওয়ার ফোম ",
	  sortOrder: "g",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "1L",
	  updateDateTime: "03/08/2020 03:29:54",
	  count: 7
	}, {
	  category: "DRINKS DESSERT",
	  key: "-M9gAmjVmP2ozJ5t6z3s",
	  photos: [{
	    imageName: "044d73a0-ad38-11ea-9a01-db9ea96fa329.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F044d73a0-ad38-11ea-9a01-db9ea96fa329.jpg?alt=media&token=0b38f9fa-338f-46b9-8112-5212ecc38a16"
	  }],
	  productNameEnglish: "POKKA ICE LEMON TEA (1.5l)",
	  productPrice: "2.30",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  updateDateTime: "04/07/2020 11:23:01",
	  count: 7
	}, {
	  availability: "AVAILABLE",
	  category: "RICE DAAL NOODLES",
	  key: "-M9bFbu8vwHane1xIr1u",
	  photos: [{
	    imageName: "567cf3a0-e8dc-11ea-b634-e7e7c4cb042d.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F567cf3a0-e8dc-11ea-b634-e7e7c4cb042d.jpg?alt=media&token=19a68641-bb80-493c-b780-710c4536c9b1"
	  }],
	  productNameEnglish: "PLAIN FLOUR (1kg)",
	  productPrice: "2 ",
	  productSupplier: "BCS SHOP",
	  searchText: "এটা ময়দা ",
	  sortOrder: "a",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1kg",
	  updateDateTime: "Fri 28-08-20 11:12 am",
	  count: 7
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-MA-4o4Bq8366luSWQfN",
	  photos: [{
	    imageName: "48ce3da0-b041-11ea-9737-25db4b55bc7b.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F48ce3da0-b041-11ea-9737-25db4b55bc7b.jpg?alt=media&token=c34dcb2b-a64d-44ee-b72f-471880e904e4"
	  }],
	  productNameEnglish: "PRAN Meat Masala ",
	  productPrice: "3.50",
	  productSupplier: "BCS SHOP",
	  searchText: "মাংস মসলা",
	  sortOrder: "a",
	  sourceSupplier: "MUSTAFA CENTRE",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "100g",
	  updateDateTime: "03/08/2020 04:59:21",
	  count: 7
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-MDSxVCslP0DQpLhyEuA",
	  photos: [{
	    imageName: "546a95d0-d21c-11ea-aa6f-8f310b43ab36.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F546a95d0-d21c-11ea-aa6f-8f310b43ab36.jpg?alt=media&token=a10fac92-656a-41b2-8c4e-665864e878ed"
	  }],
	  productNameEnglish: "S&W Organic Apple Cider Vinegar",
	  productPrice: "7.90",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "Kabir",
	  supplierContactPhone: "94562455",
	  unit: "473ml ",
	  updateDateTime: "03/08/2020 03:18:41",
	  count: 6
	}, {
	  author: "+6589050302",
	  availability: "AVAILABLE",
	  category: "RICE DAAL NOODLES",
	  isPopular: "YES",
	  key: "-M98XebbkWBaYir3DchI",
	  photos: [{
	    imageName: "c72d6f00-a7ee-11ea-9efa-45bf0dbedfb0.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fc72d6f00-a7ee-11ea-9efa-45bf0dbedfb0.jpg?alt=media&token=fe2bf965-c7d3-44e6-bf61-c6080eedf639"
	  }],
	  productDescription: "Best rice ",
	  productNameEnglish: "Rice ponni ",
	  productPrice: "$8",
	  productSupplier: "TANMOY",
	  searchText: "চাউল ",
	  sortOrder: "a",
	  supplierContactName: "Moni",
	  supplierContactPhone: "96220740",
	  unit: "5kg",
	  updateDateTime: "Sun 30-08-20 8:46 am",
	  count: 6
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  key: "-M9bY_Q2RTlndObGkIIm",
	  photos: [{
	    imageName: "333c3b20-ac83-11ea-add8-bd9e7e764e64.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F333c3b20-ac83-11ea-add8-bd9e7e764e64.jpg?alt=media&token=5d71581c-65e6-417f-b22c-ef6c3b2a70ff"
	  }],
	  productNameEnglish: "Fennel flower 100gm",
	  productPrice: "2.2",
	  productSupplier: "BCS SHOP",
	  searchText: " মৌরি",
	  sortOrder: "c",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "100gm",
	  updateDateTime: "17/07/2020 03:07:41",
	  count: 6
	}, {
	  category: "EGGS DAIRY",
	  key: "-M9gboJ-Kb2YSSVTcp0e",
	  photos: [{
	    imageName: "1fbadfe0-ad49-11ea-9a01-db9ea96fa329.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F1fbadfe0-ad49-11ea-9a01-db9ea96fa329.jpg?alt=media&token=09645012-9ea6-454b-8c2d-b5ef0279514a"
	  }],
	  productNameEnglish: "Nespray Fortified Full Cream Instant Milk Powder",
	  productPrice: "12.50",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "600g",
	  updateDateTime: "03/08/2020 07:03:20",
	  count: 6
	}, {
	  availability: "AVAILABLE",
	  category: "COSMETICS",
	  key: "-M9mc8ytLAQtxJEccOPX",
	  photos: [{
	    imageName: "8e20f0b0-ae33-11ea-8070-f3cc7bbcb5d1.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F8e20f0b0-ae33-11ea-8070-f3cc7bbcb5d1.jpg?alt=media&token=17739c96-f6a4-4311-bad4-36c5a380d5ca"
	  }],
	  productNameEnglish: "Garnier Men Turbo Light Cooling Foam ",
	  productPrice: "10.50",
	  productSupplier: "BCS SHOP",
	  searchText: "ফেইস ওয়াশ ",
	  sortOrder: "x",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "100ml",
	  updateDateTime: "03/08/2020 06:45:38",
	  count: 6
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-MA-Gj6E5dx9nQhb3Ce_",
	  photos: [{
	    imageName: "f56d3bb0-b217-11ea-921f-9db4b33fb426.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Ff56d3bb0-b217-11ea-921f-9db4b33fb426.jpg?alt=media&token=29bc3bcc-2d37-4edd-8a7c-cc4c78f8e1d8"
	  }],
	  productNameEnglish: "RADHUNI Kala Vuna Masala",
	  productPrice: "3.50",
	  productSupplier: "BCS SHOP",
	  searchText: "কালা ভুনা মসলা ",
	  sortOrder: "a",
	  sourceSupplier: "RAJDHANI ENTERPRISE PTE LTD",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "80g",
	  updateDateTime: "03/08/2020 04:52:05",
	  count: 6
	}, {
	  category: "MEAT FISH",
	  isPopular: "YES",
	  key: "-MA--py-a2EMdns3ljY1",
	  photos: [{
	    imageName: "7ed87f80-b03e-11ea-9737-25db4b55bc7b.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F7ed87f80-b03e-11ea-9737-25db4b55bc7b.jpg?alt=media&token=9dbd3be0-3355-4d02-83eb-1b29764ce67b"
	  }],
	  productNameEnglish: "Anabas Testudineus",
	  productPrice: "12",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  sourceSupplier: "KHAN PRODUCTS PTE LTD.",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1KG",
	  updateDateTime: "03/08/2020 05:20:31",
	  count: 6
	}, {
	  availability: "AVAILABLE",
	  category: "রান্না করা খাবার",
	  key: "-MD4cxuovAy6ZGT2kouJ",
	  photos: [{
	    imageName: "db3035d0-ce65-11ea-ad6f-2324c1fe3ac0.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fdb3035d0-ce65-11ea-ad6f-2324c1fe3ac0.jpg?alt=media&token=53937bc0-3ecc-465e-a5be-8da7dcb7a4d3"
	  }],
	  productNameEnglish: "Lao chingri curry - Delivery by taxi, pay as meter-fare. ",
	  productPrice: "4",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "Kabir",
	  supplierContactPhone: "94562455",
	  unit: "1 serving ",
	  updateDateTime: "Tue 11-08-20 6:44 pm",
	  count: 6
	}, {
	  availability: "AVAILABLE",
	  category: "RICE DAAL NOODLES",
	  isPopular: "YES",
	  key: "-M9a57Nre5UDcjazBxYD",
	  photos: [{
	    imageName: "18c5b8a0-e8e4-11ea-b634-e7e7c4cb042d.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F18c5b8a0-e8e4-11ea-b634-e7e7c4cb042d.jpg?alt=media&token=7058c195-98e7-4b91-a358-48ce46e0e590"
	  }],
	  productNameEnglish: "Rice Cinigora ",
	  productPrice: "5",
	  productSupplier: "BCS SHOP",
	  searchText: "চিনিগুঁড়া ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1kg",
	  updateDateTime: "Fri 28-08-20 12:08 pm",
	  count: 6
	}, {
	  category: "MEAT FISH",
	  isPopular: "YES",
	  key: "-M9a2QTdetZeIHqGAUar",
	  photos: [{
	    imageName: "790847b0-ac48-11ea-ba1a-4bcfa8bf5006.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F790847b0-ac48-11ea-ba1a-4bcfa8bf5006.jpg?alt=media&token=049c102a-db22-4066-bbd6-5906774e76bb"
	  }],
	  productNameEnglish: "Fish small fish ",
	  productPrice: "5.5",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1 packet",
	  updateDateTime: "04/07/2020 09:28:25",
	  count: 6
	}, {
	  category: "COSMETICS",
	  key: "-M9gOUNg5ksrhHVA8-P4",
	  photos: [{
	    imageName: "2e812830-ad40-11ea-b044-d71d8f034373.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F2e812830-ad40-11ea-b044-d71d8f034373.jpg?alt=media&token=ef88be7c-b3f5-46e6-a5d6-d1d3234c9bc9"
	  }],
	  productNameEnglish: "Shaving razor kai fixed type",
	  productPrice: "3.5",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "5pcs 1packet",
	  updateDateTime: "04/07/2020 10:16:29",
	  count: 6
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-MA-nsPshOgTcNls80ZJ",
	  photos: [{
	    imageName: "825e7b50-bc5a-11ea-b7df-33e703b87300.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F825e7b50-bc5a-11ea-b7df-33e703b87300.jpg?alt=media&token=3fc67247-a966-491d-8450-8be463c7ca4b"
	  }],
	  productNameEnglish: "Pears",
	  productPrice: "3.95",
	  productSupplier: "BCS SHOP",
	  searchText: "ফল ",
	  sortOrder: "a",
	  sourceSupplier: "Sheng siong ",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "4pcs",
	  updateDateTime: "03/08/2020 04:39:26",
	  count: 6
	}, {
	  category: "SNACKS DRY FOOD",
	  key: "-MA-rg5hNW3ZbRV3v9Jv",
	  photos: [{
	    imageName: "800199a0-b214-11ea-921f-9db4b33fb426.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F800199a0-b214-11ea-921f-9db4b33fb426.jpg?alt=media&token=45477024-02fe-4447-878c-a490d9940512"
	  }],
	  productNameEnglish: "Calbee Prawn Crackers ",
	  productPrice: "2.70",
	  productSupplier: "BCS SHOP",
	  sortOrder: "h",
	  sourceSupplier: "Sheng siong ",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "150G",
	  updateDateTime: "17/07/2020 06:33:45",
	  count: 6
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  key: "-M9bGSR_j7gaxUZ9Kc0f",
	  photos: [{
	    imageName: "1232e600-ac78-11ea-8ded-437354ec7423.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F1232e600-ac78-11ea-8ded-437354ec7423.jpg?alt=media&token=f067dcfa-91c9-450a-bae5-db864f4e022e"
	  }],
	  productNameEnglish: "Gold oil sunflower ",
	  productPrice: "16.2",
	  productSupplier: "BCS SHOP",
	  searchText: "তেল তৈল ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  updateDateTime: "17/07/2020 04:08:18",
	  count: 6
	}, {
	  category: "COOKING OIL INGREDIENTS",
	  key: "-M9b6D6itMcUK3KyLdFp",
	  photos: [{
	    imageName: "e9e45a40-ac71-11ea-83ef-037972cabc05.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fe9e45a40-ac71-11ea-83ef-037972cabc05.jpg?alt=media&token=3a8ce57a-ae06-43e5-93d6-8eafb97be97d"
	  }],
	  productNameEnglish: "PLAIN PARATHA",
	  productPrice: "7.70",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "2 Kg",
	  updateDateTime: "04/07/2020 11:32:50",
	  count: 6
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-MA0MsR80E1n5sC5-OGS",
	  photos: [{
	    imageName: "23246470-bf83-11ea-85e3-735b22b1a0db.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F23246470-bf83-11ea-85e3-735b22b1a0db.jpg?alt=media&token=638f8e2e-413c-4906-82cb-2102fe5d5e3d"
	  }],
	  productNameEnglish: "Lemon Grass",
	  productPrice: "1",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  sourceSupplier: "Sheng siong ",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "100G",
	  updateDateTime: "03/08/2020 04:28:01",
	  count: 6
	}, {
	  availability: "AVAILABLE",
	  category: "RICE DAAL NOODLES",
	  key: "-M9m_CxjtnUINLfRzie8",
	  photos: [{
	    imageName: "d15c2950-ae31-11ea-8070-f3cc7bbcb5d1.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fd15c2950-ae31-11ea-8070-f3cc7bbcb5d1.jpg?alt=media&token=2869470d-d387-4b94-b012-8fe360fba59c"
	  }],
	  productNameEnglish: "Golden Pineapple AAA Thai Premium Fragrant Rice",
	  productPrice: "25",
	  productSupplier: "BCS SHOP",
	  searchText: "চাউল rice",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "10Kg",
	  updateDateTime: "Fri 27-11-20 11:30 am",
	  count: 6
	}, {
	  category: "TOILETRIES",
	  key: "-M9bB5dnsCXDomgJ_OBA",
	  photos: [{
	    imageName: "563bf250-f89b-11ea-aaa8-a9cfb87a7f3a.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F563bf250-f89b-11ea-aaa8-a9cfb87a7f3a.jpg?alt=media&token=bc346ebc-e30f-4488-bded-668fc3aae7a8"
	  }],
	  productNameEnglish: "Hand wash",
	  productPrice: "3.2",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "200ml",
	  updateDateTime: "Thu 17-09-20 12:07 pm",
	  count: 5
	}, {
	  availability: "OUT OF STOCK, TOPPING UP IN PROGRESS",
	  category: "OTHERS",
	  isPopular: "YES",
	  key: "-MAuWje35ZQxDS99_aGV",
	  photos: [{
	    imageName: "48809f70-b92c-11ea-bcad-f16312f4aa54.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F48809f70-b92c-11ea-bcad-f16312f4aa54.jpg?alt=media&token=815ade9d-1279-4404-9cc5-ad1762f68393"
	  }],
	  productNameEnglish: "Lungi - Malaysian & Indonesian ",
	  productPrice: "8",
	  productSupplier: "BCS SHOP",
	  searchText: "lungi loongi sarong লুঙ্গি লুঙ্গী ",
	  sortOrder: "m",
	  sourceSupplier: "TANMOY ENTERPRISE PTE LTD",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "1 pc",
	  updateDateTime: "Tue 29-09-20 10:56 am",
	  count: 5
	}, {
	  availability: "OUT OF STOCK, TOPPING UP IN PROGRESS",
	  category: "COOKING INGREDIENTS",
	  isPopular: "YES",
	  key: "-MAZdA2vloIV39grJ-lO",
	  photos: [{
	    imageName: "bb849240-bc4e-11ea-b7df-33e703b87300.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fbb849240-bc4e-11ea-b7df-33e703b87300.jpg?alt=media&token=0864398c-055b-493e-a542-3af485529ec0"
	  }],
	  productNameEnglish: "Himalay Turmeric Powder",
	  productPrice: "2.50",
	  productSupplier: "BCS SHOP",
	  searchText: "holud holdi turmeric turmaric হলুদের গুঁড়া হলুদ ",
	  sortOrder: "g",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1.25G",
	  updateDateTime: "Fri 14-08-20 4:17 pm",
	  count: 5
	}, {
	  availability: "AVAILABLE",
	  category: "SNACKS DRY FOOD",
	  isPopular: "NO",
	  key: "-M9a_1bytLy0Nu3atm0R",
	  photos: [{
	    imageName: "f81b9f70-ac5c-11ea-bbe4-619ccaa778ae.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Ff81b9f70-ac5c-11ea-bbe4-619ccaa778ae.jpg?alt=media&token=141646ea-3a5b-4fe8-b0fd-9308269e54ec"
	  }],
	  productNameEnglish: "TOAST",
	  productPrice: "2",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1 pkt",
	  updateDateTime: "23/07/2020 12:34:05",
	  count: 5
	}, {
	  category: "SNACKS DRY FOOD",
	  key: "-MA-qJBBcd7sXZTc9zt_",
	  photos: [{
	    imageName: "e9800500-b215-11ea-921f-9db4b33fb426.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fe9800500-b215-11ea-921f-9db4b33fb426.jpg?alt=media&token=36ba7acc-839f-40ff-b993-be707f5ea6fb"
	  }],
	  productNameEnglish: "Pringles Sour Cream & Onion Potato Chips ",
	  productPrice: "2.70",
	  productSupplier: "BCS SHOP",
	  sortOrder: "h",
	  sourceSupplier: "Sheng siong ",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "147G",
	  updateDateTime: "03/08/2020 04:36:37",
	  count: 5
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-MDS5ujR6BVHM84V5qY5",
	  photos: [{
	    imageName: "0e7cae30-d1fb-11ea-af02-8f9212f09cdc.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F0e7cae30-d1fb-11ea-af02-8f9212f09cdc.jpg?alt=media&token=4cf63167-8847-46fc-ac5e-a00d53c19f93"
	  }],
	  productNameEnglish: "Bragg Organic Apple Cider Vinegar ",
	  productPrice: "13",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "Kabir",
	  supplierContactPhone: "94562455",
	  unit: "946ml",
	  updateDateTime: "03/08/2020 03:18:29",
	  count: 5
	}, {
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-MA4WSi3YxwmKiQR-BNs",
	  photos: [{
	    imageName: "ecbaa0b0-bc54-11ea-b7df-33e703b87300.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fecbaa0b0-bc54-11ea-b7df-33e703b87300.jpg?alt=media&token=2f85db9e-f690-4bf9-9357-cccf6c5747b8"
	  }],
	  productNameEnglish: "Chow Chow",
	  productPrice: "0.60",
	  productSupplier: "BCS SHOP",
	  searchText: "শাক সবজি সব্জি ",
	  sortOrder: "a",
	  sourceSupplier: "Amman trading ",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "100Gm",
	  updateDateTime: "03/08/2020 04:21:11",
	  count: 5
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-MA4Mhz5_iloZFQAnB3V",
	  photos: [{
	    imageName: "a123f670-bdcf-11ea-8ba8-ddb60ef370d4.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fa123f670-bdcf-11ea-8ba8-ddb60ef370d4.jpg?alt=media&token=3406769c-8a30-4422-a360-1d21150f6c17"
	  }],
	  productNameEnglish: "Amla",
	  productPrice: "6.70",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  sourceSupplier: "Veg mart ",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1kg",
	  updateDateTime: "03/08/2020 04:26:08",
	  count: 5
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-MA-C1A-sCAahqoQPvZV",
	  photos: [{
	    imageName: "f1445240-b045-11ea-9737-25db4b55bc7b.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Ff1445240-b045-11ea-9737-25db4b55bc7b.jpg?alt=media&token=b82d5e26-9d1e-4b5d-acdf-6892445078c1"
	  }],
	  productNameEnglish: "RADHUNI Meat Masala",
	  productPrice: "3.50",
	  productSupplier: "BCS SHOP",
	  searchText: "গরুর মাংস মসলা",
	  sortOrder: "a",
	  sourceSupplier: "KHAN PRODUCTS PTE LTD.",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "100G",
	  updateDateTime: "03/08/2020 04:58:05",
	  count: 5
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-MA-HwsBZXu5J459CxaK",
	  photos: [{
	    imageName: "978bbc80-b049-11ea-9737-25db4b55bc7b.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F978bbc80-b049-11ea-9737-25db4b55bc7b.jpg?alt=media&token=c15d7f86-7648-49ac-a6f4-677cb741606f"
	  }],
	  productNameEnglish: "PRAN Duck Masala",
	  productPrice: "3.50",
	  productSupplier: "BCS SHOP",
	  searchText: "হাঁসের মসলা ",
	  sortOrder: "a",
	  sourceSupplier: "RAJDHANI ENTERPRISE PTE LTD",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "60gm",
	  updateDateTime: "03/08/2020 04:50:39",
	  count: 5
	}, {
	  category: "COOKING OIL INGREDIENTS",
	  key: "-M9fUL-PSLdd30YrWxBO",
	  photos: [{
	    imageName: "e2c5e110-ad1c-11ea-9a01-db9ea96fa329.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fe2c5e110-ad1c-11ea-9a01-db9ea96fa329.jpg?alt=media&token=63201167-0871-45b0-9cff-b678fbc51ee9"
	  }],
	  productNameEnglish: "OKI PREMIUM SOYA BEAN OIL",
	  productPrice: "7.40",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "2L",
	  updateDateTime: "04/07/2020 11:51:54",
	  count: 5
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-MA-FDxT3W7EN2Xf9xNn",
	  photos: [{
	    imageName: "dfc09bd0-b047-11ea-9737-25db4b55bc7b.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fdfc09bd0-b047-11ea-9737-25db4b55bc7b.jpg?alt=media&token=7d962d31-6b99-4c5b-8f25-b0b8edd83e2f"
	  }],
	  productNameEnglish: "RADHUNI Fish Curry Masala",
	  productPrice: "3.50",
	  productSupplier: "BCS SHOP",
	  searchText: "মাছের মসলা",
	  sortOrder: "a",
	  sourceSupplier: "FAHIM ENTERPRISE PTE LTD",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "100G",
	  updateDateTime: "03/08/2020 04:53:41",
	  count: 5
	}, {
	  availability: "AVAILABLE",
	  category: "DRINKS DESSERT",
	  key: "-MEfZDL2i8fOR8Yu5BpS",
	  photos: [{
	    imageName: "1be55ff0-ddf3-11ea-a50a-71ea37251d72.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F1be55ff0-ddf3-11ea-a50a-71ea37251d72.jpg?alt=media&token=c985fea1-dc8b-419a-92b6-e8f822a0a70d"
	  }],
	  productNameEnglish: "sat isabgol pran",
	  productPrice: "3.00",
	  productSupplier: "BCS SHOP",
	  searchText: "isabgol esobgul isopgol",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "1 pkt 100g",
	  updateDateTime: "Fri 14-08-20 4:16 pm",
	  count: 5
	}, {
	  availability: "AVAILABLE",
	  category: "TOILETRIES",
	  key: "-MBZWpNvXzV571CAQ62z",
	  photos: [{
	    imageName: "f54164b0-bf94-11ea-85e3-735b22b1a0db.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Ff54164b0-bf94-11ea-85e3-735b22b1a0db.jpg?alt=media&token=19ad6bd8-8ddd-4fdb-ad7f-08086827c923"
	  }],
	  productNameEnglish: "Neutrogena Deep Clean Blackhead eliminating daily scrub",
	  productPrice: "13.60",
	  productSupplier: "BCS SHOP",
	  searchText: "ফেইস ওয়াশ ",
	  sortOrder: "g",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "100gm",
	  updateDateTime: "03/08/2020 03:27:39",
	  count: 5
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  key: "-M9cXeynbwtq5zd_TsHl",
	  photos: [{
	    imageName: "b6486630-aca9-11ea-ab51-0f18e1d42bbd.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fb6486630-aca9-11ea-ab51-0f18e1d42bbd.jpg?alt=media&token=d03056ac-cd88-4d96-b004-7ed1029391fd"
	  }],
	  productNameEnglish: "YELLOW WATERMELON",
	  productPrice: "2.2",
	  productSupplier: "BCS SHOP",
	  searchText: "ফল ",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1 Kg",
	  updateDateTime: "Mon 21-09-20 3:37 pm",
	  count: 5
	}, {
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-MA-tUS7aOooCDdRb5ll",
	  photos: [{
	    imageName: "1c5525c0-b061-11ea-8357-d5a4954c59fc.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F1c5525c0-b061-11ea-8357-d5a4954c59fc.jpg?alt=media&token=dc0bb154-2c99-49b0-aff7-3c9cce03764c"
	  }],
	  productNameEnglish: "PRAN Curry Powder",
	  productPrice: "4.50",
	  productSupplier: "BCS SHOP",
	  searchText: "মসলা ",
	  sortOrder: "a",
	  sourceSupplier: "GAZIPUR TRADING PTE LTD ",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "200G",
	  updateDateTime: "03/08/2020 04:33:47",
	  count: 4
	}, {
	  availability: "AVAILABLE",
	  category: "SNACKS DRY FOOD",
	  isPopular: "NO",
	  key: "-M9a_YqhjXIpKB7_yC_b",
	  photos: [{
	    imageName: "3a2c76f0-ac5d-11ea-bbe4-619ccaa778ae.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F3a2c76f0-ac5d-11ea-bbe4-619ccaa778ae.jpg?alt=media&token=10e0d0a5-0aa5-48a0-b5c8-bf72ce4be9e0"
	  }],
	  productNameEnglish: "TOAST ",
	  productPrice: "2",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1 pkt",
	  updateDateTime: "23/07/2020 12:33:28",
	  count: 4
	}, {
	  category: "FRUITS VEGETABLES ",
	  key: "-M9bE9qlAKL7zmPvEStf",
	  photos: [{
	    imageName: "c4aaaea0-ac76-11ea-8ded-437354ec7423.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fc4aaaea0-ac76-11ea-8ded-437354ec7423.jpg?alt=media&token=c974a64a-f7b5-4fa1-9db5-9b788a8aebd2"
	  }],
	  productNameEnglish: "House green peas",
	  productPrice: "2.5",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "500gm",
	  updateDateTime: "04/07/2020 08:41:26",
	  count: 4
	}, {
	  availability: "AVAILABLE",
	  category: "LAUNDRY CLEANING",
	  isPopular: "NO",
	  key: "-MBZQu1RsS-9QxxS5if2",
	  photos: [{
	    imageName: "4b99b870-bf91-11ea-85e3-735b22b1a0db.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F4b99b870-bf91-11ea-85e3-735b22b1a0db.jpg?alt=media&token=6ce26509-6fce-4a04-b439-571b4e5c5b06"
	  }],
	  productNameEnglish: "Comfort Fabric Conditioner ",
	  productPrice: "8.50",
	  productSupplier: "BCS SHOP",
	  searchText: "কাপড়ের কন্ডিশনার ",
	  sortOrder: "G",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "5L",
	  updateDateTime: "03/08/2020 03:34:23",
	  count: 4
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-MA4p5aqO6oRSOzE2akk",
	  photos: [{
	    imageName: "b8777d30-bdaa-11ea-8ba8-ddb60ef370d4.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fb8777d30-bdaa-11ea-8ba8-ddb60ef370d4.jpg?alt=media&token=7a2ebcdb-2a16-4e7d-a5b5-a51bb6d7a2b2"
	  }],
	  productNameEnglish: "Asparagus",
	  productPrice: "1.30",
	  productSupplier: "BCS SHOP",
	  searchText: "শতমূলী ",
	  sortOrder: "a",
	  sourceSupplier: "Sheng siong ",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "100G",
	  updateDateTime: "03/08/2020 04:18:07",
	  count: 4
	}, {
	  category: "TOILETRIES",
	  isPopular: "NO",
	  key: "-M9pSVz724fKYscsYo5M",
	  photos: [{
	    imageName: "658d1060-aea2-11ea-9600-53e79e8cda87.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F658d1060-aea2-11ea-9600-53e79e8cda87.jpg?alt=media&token=13c54b10-010c-4ed1-b731-50814fea17d8"
	  }],
	  productNameEnglish: "Harpic Toilet Cleaner Gel - Lavender Gel (Triple Pack)",
	  productPrice: "7.90",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  sourceSupplier: "MUSTAFA CENTRE",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "3 x 500ml",
	  updateDateTime: "03/08/2020 06:39:04",
	  count: 4
	}, {
	  category: "SNACKS DRY FOOD",
	  key: "-MA-qrE1HieKjeQuTrEM",
	  photos: [{
	    imageName: "d4390c60-b214-11ea-921f-9db4b33fb426.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fd4390c60-b214-11ea-921f-9db4b33fb426.jpg?alt=media&token=4f51f18a-ead2-4643-8f80-e28608e94849"
	  }],
	  productNameEnglish: "Roller Coaster Potato Rings Cheese",
	  productPrice: "2.20",
	  productSupplier: "BCS SHOP",
	  sortOrder: "h",
	  sourceSupplier: "Sheng siong ",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "100g",
	  updateDateTime: "04/07/2020 08:18:51",
	  count: 4
	}, {
	  author: "+6589050302",
	  category: "COSMETICS",
	  isPopular: "NO",
	  key: "-M9qwX0kiI-lR8hHtXgf",
	  photos: [{
	    imageName: "43ca48f0-aedc-11ea-9b4b-4bd8d539c6a6.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F43ca48f0-aedc-11ea-9b4b-4bd8d539c6a6.jpg?alt=media&token=62dffcf9-d577-426e-8455-1d872a352955"
	  }],
	  productNameEnglish: "Parachute Coconut Hair Oil",
	  productPrice: "5.50",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  sourceSupplier: "MUSTAFA CENTRE",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "300ML",
	  updateDateTime: "Tue 25-08-20 10:02 am",
	  count: 4
	}, {
	  availability: "AVAILABLE",
	  category: "EGGS DAIRY",
	  isPopular: "YES",
	  key: "-MA-ktuqryWbJ1oNe27B",
	  photos: [{
	    imageName: "cab1b550-b216-11ea-921f-9db4b33fb426.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fcab1b550-b216-11ea-921f-9db4b33fb426.jpg?alt=media&token=82c4d1d3-fc45-4b34-8ba7-2f3986be66e8"
	  }],
	  productNameEnglish: "Meiji Fresh Milk - Fullcream",
	  productPrice: "3.8",
	  productSupplier: "BCS SHOP",
	  searchText: "fresh milk দুধ গরুর দুধ",
	  sortOrder: "a",
	  sourceSupplier: "Sheng siong ",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "830ml",
	  updateDateTime: "03/08/2020 04:40:15",
	  count: 4
	}, {
	  availability: "AVAILABLE",
	  category: "LAUNDRY CLEANING",
	  key: "-M9pKnaBOD1D8sHjw_gB",
	  photos: [{
	    imageName: "b025d7b0-ae9d-11ea-9600-53e79e8cda87.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fb025d7b0-ae9d-11ea-9600-53e79e8cda87.jpg?alt=media&token=c863610e-5db1-45af-9b1c-2fd066334842"
	  }],
	  productNameEnglish: "CIF Cream Surface Cleanser - Lemon",
	  productPrice: "2.30",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "500ml",
	  updateDateTime: "03/08/2020 06:44:45",
	  count: 4
	}, {
	  category: "COSMETICS",
	  key: "-M9gKgvBNYEfi7GuI0gp",
	  photos: [{
	    imageName: "ea7248b0-ad3d-11ea-b044-d71d8f034373.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fea7248b0-ad3d-11ea-b044-d71d8f034373.jpg?alt=media&token=23e8e3f7-ba07-4ee2-a375-4d193ab8a223"
	  }],
	  productNameEnglish: "Shaving foam sensitive",
	  productPrice: "5",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "200ml",
	  updateDateTime: "04/07/2020 10:19:58",
	  count: 4
	}, {
	  availability: "AVAILABLE",
	  category: "RICE DAAL NOODLES",
	  key: "-MFsRVzvqlSw2jAmJbf5",
	  photos: [{
	    imageName: "f979c5b0-e9ae-11ea-88e9-2b8db057b537.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2Ff979c5b0-e9ae-11ea-88e9-2b8db057b537.jpg?alt=media&token=596bc825-14ea-4551-a3e8-0cc03582f03e"
	  }],
	  productNameEnglish: "Jaguar rice",
	  productPrice: "35",
	  productSupplier: "BCS SHOP",
	  searchText: "rice",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "25kg",
	  updateDateTime: "Wed 02-12-20 10:20 am",
	  count: 4
	}, {
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-MA-JybhhoZnd2xV63lY",
	  photos: [{
	    imageName: "cea1f350-b04a-11ea-9737-25db4b55bc7b.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fcea1f350-b04a-11ea-9737-25db4b55bc7b.jpg?alt=media&token=681ee9ef-0064-4948-9650-ab9f11d7211c"
	  }],
	  productNameEnglish: "PRAN Haleem Masala Mix",
	  productPrice: "3.90",
	  productSupplier: "BCS SHOP",
	  searchText: "হালীম মিক্স ",
	  sortOrder: "a",
	  sourceSupplier: "RAJDHANI ENTERPRISE PTE LTD",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "200G",
	  updateDateTime: "03/08/2020 04:49:29",
	  count: 4
	}, {
	  availability: "AVAILABLE",
	  category: "RICE DAAL NOODLES",
	  isPopular: "YES",
	  key: "-M9abk1BKoOu9ucf_i0P",
	  photos: [{
	    imageName: "9cd4b370-ac5e-11ea-bbe4-619ccaa778ae.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F9cd4b370-ac5e-11ea-bbe4-619ccaa778ae.jpg?alt=media&token=11a6a33d-b137-45d3-9d2b-ad3afd188bed"
	  }],
	  productNameEnglish: "BASIL SEEDS ",
	  productPrice: "2.50 ",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "80gm",
	  updateDateTime: "23/07/2020 12:30:54",
	  count: 4
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-MA4S3yetf2_0OsXdh_r",
	  photos: [{
	    imageName: "f001f570-bdb2-11ea-8ba8-ddb60ef370d4.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Ff001f570-bdb2-11ea-8ba8-ddb60ef370d4.jpg?alt=media&token=898fb46b-1f78-45f0-ab01-9c639e3ce5d3"
	  }],
	  productNameEnglish: "Chinese Spinach",
	  productPrice: "6",
	  productSupplier: "BCS SHOP",
	  searchText: "শাক সবজি সব্জি ",
	  sortOrder: "a",
	  sourceSupplier: "Sheng siong ",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1kg",
	  updateDateTime: "03/08/2020 04:23:19",
	  count: 4
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-MA-HPrZgnI3W4ygoyv-",
	  photos: [{
	    imageName: "422b3310-b049-11ea-9737-25db4b55bc7b.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F422b3310-b049-11ea-9737-25db4b55bc7b.jpg?alt=media&token=db1d4ae7-2a5e-4164-beb4-1151e24ac62e"
	  }],
	  productNameEnglish: "RADHUNI Kacchi Biryani Masala",
	  productPrice: "3.50",
	  productSupplier: "BCS SHOP",
	  searchText: "খিচুড়ি মসলা",
	  sortOrder: "a",
	  sourceSupplier: "KHAN PRODUCTS PTE LTD.",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "40g",
	  updateDateTime: "03/08/2020 04:51:31",
	  count: 4
	}, {
	  availability: "AVAILABLE",
	  category: "EGGS DAIRY",
	  isPopular: "YES",
	  key: "-M9b53-gYj3fNL3pj_SH",
	  photos: [{
	    imageName: "1b77f630-ac71-11ea-8ded-437354ec7423.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F1b77f630-ac71-11ea-8ded-437354ec7423.jpg?alt=media&token=965addb9-5921-433a-9f34-f72bf36b9e9d"
	  }],
	  productNameEnglish: "HL banana/strawberry milk",
	  productPrice: "3.5",
	  productSupplier: "BCS SHOP",
	  searchText: "fresh milk",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1L",
	  updateDateTime: "23/07/2020 12:30:15",
	  count: 4
	}, {
	  availability: "AVAILABLE",
	  category: "KITCHEN DINING",
	  isPopular: "NO",
	  key: "-M9Y0JRabxNgOzFRkwKB",
	  photos: [{
	    imageName: "789397f0-c104-11ea-8470-83fbeadd4a74.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F789397f0-c104-11ea-8470-83fbeadd4a74.jpg?alt=media&token=c6042177-aa13-4df6-9285-dc86d85b4507"
	  }],
	  productNameEnglish: "Rice cooker  big/small (price vary depending on size)",
	  productPrice: "32",
	  productSupplier: "BCS SHOP",
	  searchText: "রাইস কুকার ",
	  sortOrder: "x",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "Small",
	  updateDateTime: "08/07/2020 06:19:47",
	  count: 4
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-MA4Sr5vL2D5WLOZOmOg",
	  photos: [{
	    imageName: "9a953700-bdb2-11ea-8ba8-ddb60ef370d4.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F9a953700-bdb2-11ea-8ba8-ddb60ef370d4.jpg?alt=media&token=1c8727fb-8e93-4f75-92f6-77d32bbcc8cf"
	  }],
	  productNameEnglish: "Snake Gourd",
	  productPrice: "6",
	  productSupplier: "BCS SHOP",
	  searchText: "kioda",
	  sortOrder: "a",
	  sourceSupplier: "Veg mart ",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1KG",
	  updateDateTime: "03/08/2020 04:22:47",
	  count: 4
	}, {
	  availability: "AVAILABLE",
	  category: "KITCHEN DINING",
	  key: "-M9XOy8oD7hBLxHrPrJX",
	  photos: [{
	    imageName: "5a2486a0-c102-11ea-8470-83fbeadd4a74.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F5a2486a0-c102-11ea-8470-83fbeadd4a74.jpg?alt=media&token=76f61b35-0100-44eb-9d57-c4bac42986dd"
	  }],
	  productNameEnglish: "Cutting board",
	  productPrice: "  5",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1 pc",
	  updateDateTime: "08/07/2020 06:04:18",
	  count: 4
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  key: "-M9b5Bp3rmdHU8muuty_",
	  photos: [{
	    imageName: "4b76a4d0-ac71-11ea-83ef-037972cabc05.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F4b76a4d0-ac71-11ea-83ef-037972cabc05.jpg?alt=media&token=a11dd7c0-eddb-4e21-8a2a-d75748c554d6"
	  }],
	  productNameEnglish: "EX VIRGIN OLIVE OIL (500g)",
	  productPrice: "9",
	  productSupplier: "BCS SHOP",
	  searchText: "অলিভ অয়েল",
	  sortOrder: "g",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "500g",
	  updateDateTime: "17/07/2020 07:35:50",
	  count: 4
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-MA-DAJ7J3Q4gm8p6wKi",
	  photos: [{
	    imageName: "9c1606f0-b046-11ea-9737-25db4b55bc7b.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F9c1606f0-b046-11ea-9737-25db4b55bc7b.jpg?alt=media&token=a1c6f9d6-7e57-4f6a-92d2-541d9b842aed"
	  }],
	  productNameEnglish: "RADHUNI Chicken Roast Masala",
	  productPrice: "3",
	  productSupplier: "BCS SHOP",
	  searchText: "রোস্ট মসলা",
	  sortOrder: "a",
	  sourceSupplier: "FAHIM ENTERPRISE PTE LTD",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "35G",
	  updateDateTime: "03/08/2020 04:55:51",
	  count: 3
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-M9aOOa2t7sa0B0gRCVr",
	  productNameEnglish: "TURMERIC POWDER",
	  productPrice: "3.80",
	  productSupplier: "BCS SHOP",
	  searchText: "হলুদের গুঁড়া",
	  sortOrder: "a",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1 pkt",
	  updateDateTime: "Fri 14-08-20 4:52 pm",
	  count: 3
	}, {
	  category: "LAUNDRY CLEANING",
	  isPopular: "NO",
	  key: "-M9qcstKKSzKgQ2W8Bup",
	  photos: [{
	    imageName: "64199450-aed0-11ea-9cc0-814fbb741388.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F64199450-aed0-11ea-9cc0-814fbb741388.jpg?alt=media&token=1f9802e1-9582-4cfd-8c7d-1728e0481e5a"
	  }],
	  productNameEnglish: "TOP Concentrated Liquid Detergent",
	  productPrice: "4.95",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  sourceSupplier: "Sheng siong ",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1.5KG",
	  updateDateTime: "03/08/2020 05:57:11",
	  count: 3
	}, {
	  category: "DRINKS DESSERT",
	  key: "-M9fhS6QGXX68eQ9dmb3",
	  photos: [{
	    imageName: "802adf70-ad25-11ea-9a01-db9ea96fa329.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F802adf70-ad25-11ea-9a01-db9ea96fa329.jpg?alt=media&token=7621a176-01e6-40cd-b809-31d3b39e5a1c"
	  }],
	  productNameEnglish: "POKKA JASMINE GREEN TEA",
	  productPrice: "2.30",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1.5L",
	  updateDateTime: "04/07/2020 11:26:34",
	  count: 3
	}, {
	  category: "COOKING OIL INGREDIENTS",
	  key: "-M9fHP84oZPiAZSRRsOP",
	  photos: [{
	    imageName: "bbcff260-ad14-11ea-9aab-f922f3904dfb.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fbbcff260-ad14-11ea-9aab-f922f3904dfb.jpg?alt=media&token=934ff842-6292-41be-a5f6-9974a4382200"
	  }],
	  productNameEnglish: "Tamarind",
	  productPrice: "8",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1 box",
	  updateDateTime: "05/07/2020 12:07:26",
	  count: 3
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  key: "-M9b4vSa-PhukassruCo",
	  photos: [{
	    imageName: "20d2f6c0-ac71-11ea-83ef-037972cabc05.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F20d2f6c0-ac71-11ea-83ef-037972cabc05.jpg?alt=media&token=ff856e15-d9cc-4c1f-85c8-cac13e95f741"
	  }],
	  productNameEnglish: "OLIVE OIL (500g)",
	  productPrice: "8.90",
	  productSupplier: "BCS SHOP",
	  searchText: "অলিভ অয়েল",
	  sortOrder: "g",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "500g",
	  updateDateTime: "17/07/2020 07:36:02",
	  count: 3
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-MA4Ro3P0gWz-3jP48Hf",
	  photos: [{
	    imageName: "8716b770-bdb3-11ea-8ba8-ddb60ef370d4.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F8716b770-bdb3-11ea-8ba8-ddb60ef370d4.jpg?alt=media&token=a0ca6b1d-bd33-4760-a2c5-d8fda67aea78"
	  }],
	  productNameEnglish: "Beetroot",
	  productPrice: "6.30",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  sourceSupplier: "Amman trading ",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1kg",
	  updateDateTime: "03/08/2020 04:23:27",
	  count: 3
	}, {
	  category: "EGGS DAIRY",
	  isPopular: "YES",
	  key: "-M9Y0vKi7518NwH69ezs",
	  photos: [{
	    imageName: "86d52960-abd2-11ea-8036-6322e2b6fd90.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F86d52960-abd2-11ea-8036-6322e2b6fd90.jpg?alt=media&token=2d3b7e72-63a9-443d-a1b2-2ba5ba38dd63"
	  }],
	  productNameEnglish: "Honey ",
	  productPrice: "11",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1L",
	  updateDateTime: "04/07/2020 09:16:35",
	  count: 3
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-MA4QI8ipDkr4X8KBkor",
	  photos: [{
	    imageName: "c52412a0-bdb4-11ea-8ba8-ddb60ef370d4.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fc52412a0-bdb4-11ea-8ba8-ddb60ef370d4.jpg?alt=media&token=b5d18bfe-7750-4a31-9b59-84a9e88a4192"
	  }],
	  productNameEnglish: "Water Spinach",
	  productPrice: "4.50",
	  productSupplier: "BCS SHOP",
	  searchText: "shak sak kolmi shak শাক সবজি সব্জি ",
	  sortOrder: "a",
	  sourceSupplier: "Veg mart ",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1KG",
	  updateDateTime: "03/08/2020 04:24:21",
	  count: 3
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-MA-CZjNP6303XAWLm3m",
	  photos: [{
	    imageName: "48f81a80-b046-11ea-9737-25db4b55bc7b.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F48f81a80-b046-11ea-9737-25db4b55bc7b.jpg?alt=media&token=8c0b64c1-d561-41b4-8682-1c1d3e49861b"
	  }],
	  productNameEnglish: "RADHUNI Chicken Masala",
	  productPrice: "2.90",
	  productSupplier: "BCS SHOP",
	  searchText: "চিকেন কারি মসলা ",
	  sortOrder: "a",
	  sourceSupplier: "RAJDHANI ENTERPRISE PTE LTD",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "20G",
	  updateDateTime: "03/08/2020 04:56:19",
	  count: 3
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-M9aUAXelq_RZ3rWlftI",
	  photos: [{
	    imageName: "537ba3a0-ac59-11ea-bbe4-619ccaa778ae.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F537ba3a0-ac59-11ea-bbe4-619ccaa778ae.jpg?alt=media&token=1555adaf-446a-4c95-93c1-57199b0e6efd"
	  }],
	  productNameEnglish: "STAR ANISE ",
	  productPrice: "2.70",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1 pkt",
	  updateDateTime: "23/07/2020 12:47:57",
	  count: 3
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-MA4Q4kMB-2H30JLy_Tc",
	  photos: [{
	    imageName: "1013ba40-bdb5-11ea-8ba8-ddb60ef370d4.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F1013ba40-bdb5-11ea-8ba8-ddb60ef370d4.jpg?alt=media&token=ca1800da-00c4-4a5d-8e27-541faa9ef57b"
	  }],
	  productNameEnglish: "Mustard Spinach",
	  productPrice: " 4.50",
	  productSupplier: "BCS SHOP",
	  searchText: "শাক সবজি সব্জি ",
	  sortOrder: "a",
	  sourceSupplier: "Sai shanmuga",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1KG",
	  updateDateTime: "03/08/2020 04:24:56",
	  count: 3
	}, {
	  category: "TOILETRIES",
	  key: "-M9qQN2dHSWptq7fJzue",
	  photos: [{
	    imageName: "2394d4b0-aec8-11ea-9cc0-814fbb741388.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F2394d4b0-aec8-11ea-9cc0-814fbb741388.jpg?alt=media&token=e0893cba-c5bf-451d-b2b6-02913362973d"
	  }],
	  productDescription: " (10x200 per pack)",
	  productNameEnglish: "PurSoft 4-ply Unscented Toilet Tissue Roll",
	  productPrice: "7.95",
	  productSupplier: "BCS SHOP",
	  sortOrder: "k",
	  sourceSupplier: "Sheng siong ",
	  supplierContactName: "arif",
	  supplierContactPhone: "84124637",
	  unit: "10 ROLLS",
	  updateDateTime: "03/08/2020 06:10:46",
	  count: 3
	}, {
	  category: "COSMETICS",
	  key: "-MA3zG1eWkBbKPxN7U2B",
	  photos: [{
	    imageName: "528111c0-b211-11ea-921f-9db4b33fb426.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F528111c0-b211-11ea-921f-9db4b33fb426.jpg?alt=media&token=d655ecbd-cf81-4bf6-86e4-c07f1465b077"
	  }],
	  productNameEnglish: "Himalaya Oil Control Facial Wash",
	  productPrice: "6.95",
	  productSupplier: "BCS SHOP",
	  searchText: "ফেইস ওয়াশ ",
	  sortOrder: "x",
	  sourceSupplier: "MUSTAFA CENTRE",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "100ML",
	  updateDateTime: "03/08/2020 04:27:51",
	  count: 3
	}, {
	  availability: "AVAILABLE",
	  category: "EGGS DAIRY",
	  isPopular: "YES",
	  key: "-MA-kMYufmGnT6XGDUuI",
	  photos: [{
	    imageName: "bdea5130-bc5a-11ea-b7df-33e703b87300.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fbdea5130-bc5a-11ea-b7df-33e703b87300.jpg?alt=media&token=f0c580f0-f44b-4340-8622-95a8c448576d"
	  }],
	  productNameEnglish: "Meiji Chocolate Fresh Milk - Fullcream",
	  productPrice: "6.50",
	  productSupplier: "BCS SHOP",
	  searchText: "চকলেট দুধ ",
	  sortOrder: "a",
	  sourceSupplier: "Sheng siong ",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "2L",
	  updateDateTime: "03/08/2020 04:41:31",
	  count: 3
	}, {
	  category: "MEAT FISH",
	  isPopular: "YES",
	  key: "-M9zyaGEkwWHN4gqOv1u",
	  photos: [{
	    imageName: "375432e0-b03d-11ea-9737-25db4b55bc7b.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F375432e0-b03d-11ea-9737-25db4b55bc7b.jpg?alt=media&token=4411a332-092b-42e5-ac8f-e1d8eba8890e"
	  }],
	  productNameEnglish: "Mrigal Carp",
	  productPrice: "6",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  sourceSupplier: "RAJDHANI ENTERPRISE PTE LTD",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1KG",
	  updateDateTime: "03/08/2020 05:19:16",
	  count: 3
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  key: "-M9f6-hjDca9ThhkT2Hd",
	  photos: [{
	    imageName: "bc718dc0-ad0d-11ea-873f-e1ac34f7defb.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fbc718dc0-ad0d-11ea-873f-e1ac34f7defb.jpg?alt=media&token=37b690be-6f9d-4570-a5fc-9c51cfa9cfaf"
	  }],
	  productNameEnglish: "Red dragonfruits 1pcs",
	  productPrice: "3",
	  productSupplier: "BCS SHOP",
	  searchText: "ফল ",
	  sortOrder: "g",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  updateDateTime: "17/07/2020 02:38:26",
	  count: 3
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  key: "-MFibGQ-UkRLc5KS5egA",
	  photos: [{
	    imageName: "78902f00-e834-11ea-a70c-3f9f15f1ac0f.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F78902f00-e834-11ea-a70c-3f9f15f1ac0f.jpg?alt=media&token=8d492700-63b7-4f9c-b6c3-0cc418dd1bba"
	  }],
	  productNameEnglish: "Shan curry powdser",
	  productPrice: "1.30",
	  productSupplier: "BCS SHOP",
	  searchText: "curry powdser",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "1009",
	  updateDateTime: "Thu 27-08-20 3:11 pm",
	  count: 3
	}, {
	  category: "TOILETRIES",
	  key: "-M9qYI1DC5DjkLn0Bs38",
	  photos: [{
	    imageName: "c88cbf10-aecc-11ea-9cc0-814fbb741388.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fc88cbf10-aecc-11ea-9cc0-814fbb741388.jpg?alt=media&token=d62e26c4-b6ff-4dbe-80cc-77dc252ceb46"
	  }],
	  productDescription: "(20 x185 per pack)",
	  productNameEnglish: "Scott Extra Regular 2-ply Toilet Tissue Roll ",
	  productPrice: "6.95",
	  productSupplier: "BCS SHOP",
	  sortOrder: "k",
	  sourceSupplier: "Sheng siong ",
	  supplierContactName: "arif",
	  supplierContactPhone: "84124637",
	  unit: "20rolls of 1packet",
	  updateDateTime: "03/08/2020 06:03:42",
	  count: 3
	}, {
	  category: "FRUITS VEGETABLES ",
	  key: "-M9b4ZZZ7PcOh0dRuFGt",
	  photos: [{
	    imageName: "e95d4560-ac70-11ea-83ef-037972cabc05.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fe95d4560-ac70-11ea-83ef-037972cabc05.jpg?alt=media&token=f36c38b9-4c29-4d2e-839e-1e5c8c5d5f0d"
	  }],
	  productNameEnglish: "LYCHEE ",
	  productPrice: "2.50",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1 tin",
	  updateDateTime: "05/07/2020 12:09:39",
	  count: 3
	}, {
	  category: "SNACKS DRY FOOD",
	  key: "-M9b9Op5cDWf7IC8FFcy",
	  photos: [{
	    imageName: "bf2745e0-ac73-11ea-8ded-437354ec7423.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fbf2745e0-ac73-11ea-8ded-437354ec7423.jpg?alt=media&token=520e2bfc-0d06-498c-a981-3242f6248a5f"
	  }],
	  productNameEnglish: "Swiss roll cake",
	  productPrice: "4",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "24 pcs1 Pkt",
	  updateDateTime: "04/07/2020 08:48:37",
	  count: 3
	}, {
	  category: "RICE DAAL NOODLES",
	  key: "-M9b6LuJF4v10S5epeVw",
	  photos: [{
	    imageName: "dd707c80-ac71-11ea-8ded-437354ec7423.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fdd707c80-ac71-11ea-8ded-437354ec7423.jpg?alt=media&token=1f3a11e0-40f5-4c9a-8ecc-1162674a012c"
	  }],
	  productNameEnglish: "Noodles",
	  productPrice: "3.8",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1 Pkt",
	  updateDateTime: "04/07/2020 11:32:29",
	  count: 3
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  photos: [{
	    imageName: "c421a070-e82a-11ea-b1ae-e3e3c2d1f850.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2Fc421a070-e82a-11ea-b1ae-e3e3c2d1f850.jpg?alt=media&token=07f14e77-8d80-45e6-883c-21c101e6d174"
	  }],
	  productNameEnglish: "Shan  meat masala ",
	  productPrice: "1.50",
	  productSupplier: "BCS SHOP",
	  searchText: "beef masala",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "100g",
	  updateDateTime: "Thu 27-08-20 2:01 pm",
	  key: "-MFiVVjX_u5zP1rN9Ry4",
	  count: 3
	}, {
	  category: "STATIONARY",
	  isPopular: "NO",
	  key: "-MA97iEs6t-46LTZdr79",
	  photos: [{
	    imageName: "f3f5da60-b1c9-11ea-825a-3b8acfde6ce7.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Ff3f5da60-b1c9-11ea-825a-3b8acfde6ce7.jpg?alt=media&token=2126a9bb-b23a-4e19-b90a-dad4ee598980"
	  }],
	  productNameEnglish: "Zebra Gel Ink Pen 0.5m (Blue, Black, Red)",
	  productPrice: "1.70",
	  productSupplier: "BCS SHOP",
	  searchText: "কলম ",
	  sortOrder: "n",
	  sourceSupplier: "MUSTAFA CENTRE",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1 Pc",
	  updateDateTime: "03/08/2020 04:05:06",
	  count: 3
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-MA4TIuNH4iVUoOtOw9y",
	  photos: [{
	    imageName: "354dc920-bdb2-11ea-8ba8-ddb60ef370d4.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F354dc920-bdb2-11ea-8ba8-ddb60ef370d4.jpg?alt=media&token=eb5c5fad-95a9-4526-a381-ec948a1f1588"
	  }],
	  productNameEnglish: "Corn",
	  productPrice: "6",
	  productSupplier: "BCS SHOP",
	  searchText: "butta bhotta botta",
	  sortOrder: "a",
	  sourceSupplier: "Sai shanmuga",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1KG",
	  updateDateTime: "03/08/2020 04:22:32",
	  count: 3
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-MA4YlCmN4oegMgqBchv",
	  photos: [{
	    imageName: "18831770-b117-11ea-810a-c5e0250e7646.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F18831770-b117-11ea-810a-c5e0250e7646.jpg?alt=media&token=306c4a1c-00c9-4de9-b081-8a36cc3198ca"
	  }],
	  productNameEnglish: "Green Spinach",
	  productPrice: "5",
	  productSupplier: "BCS SHOP",
	  searchText: "ডাটা শাক ",
	  sortOrder: "a",
	  sourceSupplier: "B&S minimart ",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1KG",
	  updateDateTime: "03/08/2020 04:19:36",
	  count: 3
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  photos: [{
	    imageName: "18b54780-e82c-11ea-b1ae-e3e3c2d1f850.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F18b54780-e82c-11ea-b1ae-e3e3c2d1f850.jpg?alt=media&token=bf58c58e-92c1-486b-9dcb-ba6d328154e6"
	  }],
	  productNameEnglish: "Shan bombay biryani",
	  productPrice: "1.50",
	  productSupplier: "BCS SHOP",
	  searchText: " bombay biryani",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "60g",
	  updateDateTime: "Thu 27-08-20 2:11 pm",
	  key: "-MFiXeZ-jb04oeSw6EvZ",
	  count: 3
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  key: "-M9cYvMUq77vUI_OoT1F",
	  photos: [{
	    imageName: "7f025ae0-acaa-11ea-ab51-0f18e1d42bbd.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F7f025ae0-acaa-11ea-ab51-0f18e1d42bbd.jpg?alt=media&token=86f6c9d0-27ce-4dcc-9319-d9bf2021235b"
	  }],
	  productNameEnglish: "CHERRIES ",
	  productPrice: "5",
	  productSupplier: "BCS SHOP",
	  searchText: " চেরি ",
	  sortOrder: "g",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "250gm",
	  updateDateTime: "17/07/2020 02:42:16",
	  count: 3
	}, {
	  category: "TOILETRIES",
	  key: "-M9puZTivnTeQamZ9h6T",
	  photos: [{
	    imageName: "21140d50-aeb4-11ea-9600-53e79e8cda87.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F21140d50-aeb4-11ea-9600-53e79e8cda87.jpg?alt=media&token=81b19c6e-5506-4e8d-9fac-a5c6a206ff24"
	  }],
	  productDescription: "(4x 130 per pack)",
	  productNameEnglish: "PurSoft 3-ply Tissue Soft Pack - Sakura",
	  productPrice: "5.85",
	  productSupplier: "BCS SHOP",
	  sortOrder: "k",
	  sourceSupplier: "Giant supermarket ",
	  supplierContactName: "arif",
	  supplierContactPhone: "84124637",
	  unit: "4 box of 1 pack",
	  updateDateTime: "03/08/2020 06:24:16",
	  count: 3
	}, {
	  category: "COSMETICS",
	  key: "-M9gPGIcBzoPH_xk4Hz7",
	  photos: [{
	    imageName: "9f9ab590-ad40-11ea-93aa-6d00775cfd30.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F9f9ab590-ad40-11ea-93aa-6d00775cfd30.jpg?alt=media&token=68fa78d7-9e96-4868-95e6-4412c436c044"
	  }],
	  productNameEnglish: "Shaving  razor gillette blue ll disposable",
	  productPrice: "6.2",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "5pcs 1 Pkt",
	  updateDateTime: "04/07/2020 10:16:13",
	  count: 3
	}, {
	  availability: "AVAILABLE",
	  category: "MEAT FISH",
	  key: "-MGaNOtrs0L79H33eYUy",
	  photos: [{
	    imageName: "a6c3d130-f0b1-11ea-ba7d-67bd2d78e913.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2Fa6c3d130-f0b1-11ea-ba7d-67bd2d78e913.jpg?alt=media&token=7709abad-f84a-4486-a87b-be3911a8159d"
	  }],
	  productNameEnglish: "  Fish sea bass",
	  productPrice: "13",
	  productSupplier: "BCS SHOP",
	  searchText: "sea bass",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "1 kg",
	  updateDateTime: "Mon 07-09-20 12:41 pm",
	  count: 3
	}, {
	  availability: "AVAILABLE",
	  category: "TOILETRIES",
	  key: "-MBZTrIFVTqwGck8rn8m",
	  photos: [{
	    imageName: "f1102900-bf92-11ea-85e3-735b22b1a0db.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Ff1102900-bf92-11ea-85e3-735b22b1a0db.jpg?alt=media&token=50b005e2-febd-48d7-8794-60c091da833b"
	  }],
	  productNameEnglish: "JOHNSON'S Baby Cotton Touch Bath Hair & Body ",
	  productPrice: "10.90",
	  productSupplier: "BCS SHOP",
	  searchText: "বেবি শাওয়ার জেল বাচ্চাদের সেম্পো ",
	  sortOrder: "g",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "500ml",
	  updateDateTime: "03/08/2020 03:32:25",
	  count: 2
	}, {
	  category: "DRINKS DESSERT",
	  key: "-M9gJtbCb0YkR0UOC832",
	  photos: [{
	    imageName: "93e32a50-ad3d-11ea-9a01-db9ea96fa329.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F93e32a50-ad3d-11ea-9a01-db9ea96fa329.jpg?alt=media&token=d465428e-eb58-4e56-a18a-4730941b0d60"
	  }],
	  productNameEnglish: "NESCAFE WHITE COFFEE GAO SIEW DAI",
	  productPrice: "7.30",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "620g",
	  updateDateTime: "04/07/2020 10:20:27",
	  count: 2
	}, {
	  availability: "AVAILABLE",
	  category: "DRINKS DESSERT",
	  key: "-MA5NwKyqKA9eFI0wbuP",
	  photos: [{
	    imageName: "871ca320-b137-11ea-b71d-553b8acbaa9c.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F871ca320-b137-11ea-b71d-553b8acbaa9c.jpg?alt=media&token=bc7e80ca-9767-4d15-8574-d0e5221168cf"
	  }],
	  productNameEnglish: "Basil Seed Drink - Strawberry",
	  productPrice: "1.90",
	  productSupplier: "BCS SHOP",
	  searchText: "জুস তুকমার ",
	  sortOrder: "a",
	  sourceSupplier: "Hao mart ",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "290ML",
	  updateDateTime: "03/08/2020 04:14:55",
	  count: 2
	}, {
	  category: "COSMETICS",
	  key: "-MA3zhczyKdhiqCr32ZG",
	  photos: [{
	    imageName: "052bb4c0-b211-11ea-921f-9db4b33fb426.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F052bb4c0-b211-11ea-921f-9db4b33fb426.jpg?alt=media&token=e7f225f8-f2ae-4237-9713-ab74cb16d6d8"
	  }],
	  productNameEnglish: "Himalaya Purifying Neem Facial Wash",
	  productPrice: "8.50",
	  productSupplier: "BCS SHOP",
	  searchText: "ফেইস ওয়াশ ",
	  sortOrder: "x",
	  sourceSupplier: "MUSTAFA CENTRE",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "100ml",
	  updateDateTime: "03/08/2020 04:27:34",
	  count: 2
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  key: "-M9b5ar5vEu4FvrUc5PY",
	  photos: [{
	    imageName: "8aedbea0-ac71-11ea-83ef-037972cabc05.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F8aedbea0-ac71-11ea-83ef-037972cabc05.jpg?alt=media&token=83c21cb4-13c3-4fba-a834-0765f3336e9b"
	  }],
	  productNameEnglish: "EX VIRGIN OLIVE OIL (1l)",
	  productPrice: "16",
	  productSupplier: "BCS SHOP",
	  searchText: "অলিভ অয়েল",
	  sortOrder: "a",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1l",
	  updateDateTime: "17/07/2020 07:35:39",
	  count: 2
	}, {
	  availability: "AVAILABLE",
	  category: "EGGS DAIRY",
	  key: "-MBZN9kTGTqkO56A11u1",
	  photos: [{
	    imageName: "0d6df540-bf8f-11ea-85e3-735b22b1a0db.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F0d6df540-bf8f-11ea-85e3-735b22b1a0db.jpg?alt=media&token=8961a300-1fe0-4fa1-bf4d-709c0211f5c9"
	  }],
	  productNameEnglish: "Skippy Peanut Butter Spread - Grape Stripe",
	  productPrice: "7",
	  productSupplier: "BCS SHOP",
	  searchText: "পিনাট বাটার ",
	  sortOrder: "G",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "530gm",
	  updateDateTime: "03/08/2020 03:36:01",
	  count: 2
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-MABh5F4COBtDnGWP0a5",
	  photos: [{
	    imageName: "58c0c6d0-b22e-11ea-b6a3-23fbd917d0cb.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F58c0c6d0-b22e-11ea-b6a3-23fbd917d0cb.jpg?alt=media&token=735b5ca8-1c8a-4ba7-af19-27cb07214585"
	  }],
	  productNameEnglish: "Cinnamon Powder ",
	  productPrice: "1.50",
	  productSupplier: "BCS SHOP",
	  searchText: "thenga masala দারচিনি দারুচিনি ",
	  sortOrder: "a",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "50gm",
	  updateDateTime: "03/08/2020 03:55:24",
	  count: 2
	}, {
	  category: "COOKING OIL INGREDIENTS",
	  key: "-M9fEv9wilhI77kVkDgi",
	  photos: [{
	    imageName: "79b1c9e0-ad13-11ea-8bc0-03f48af12a9c.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F79b1c9e0-ad13-11ea-8bc0-03f48af12a9c.jpg?alt=media&token=2ffbae79-99c5-4212-b576-e0e505d8c906"
	  }],
	  productNameEnglish: "KARA UHT NATURAL COCONUT CREAM",
	  productPrice: "1",
	  productSupplier: "BCS SHOP",
	  searchText: "নারিকেল ক্রিম ",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "200ml",
	  updateDateTime: "17/07/2020 02:32:43",
	  count: 2
	}, {
	  availability: "AVAILABLE",
	  category: "COSMETICS",
	  key: "-M9qa24w0jVeMHfHk1AX",
	  photos: [{
	    imageName: "6a8fb3c0-aece-11ea-b774-7962c3b67908.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F6a8fb3c0-aece-11ea-b774-7962c3b67908.jpg?alt=media&token=2afb5185-b527-40a9-ad71-6e043bc75fd6"
	  }],
	  productNameEnglish: "Oil Control Facial Cleanser Moisturizing Skin Care Deep Cleansing",
	  productPrice: "9",
	  productSupplier: "BCS SHOP",
	  searchText: "ফেইস ওয়াশ ",
	  sortOrder: "k",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1 pc of 100ML",
	  updateDateTime: "03/08/2020 06:00:28",
	  count: 2
	}, {
	  category: "FRUITS VEGETABLES ",
	  key: "-M9fIYlyi8xetbpfusCw",
	  photos: [{
	    imageName: "892f5340-ad15-11ea-abb1-91c43b08e32b.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F892f5340-ad15-11ea-abb1-91c43b08e32b.jpg?alt=media&token=4bb9b087-f6d1-4d94-9fe4-1d9e1c8f954b"
	  }],
	  productNameEnglish: "Starfruit",
	  productPrice: "3.7",
	  productSupplier: "BCS SHOP",
	  searchText: "কামরাঙ্গা কামরাঙা ",
	  sortOrder: "d",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1 Pkt",
	  updateDateTime: "17/07/2020 02:18:09",
	  count: 2
	}, {
	  category: "TOILETRIES",
	  key: "-M9qUoKPglLjSU6mkOlJ",
	  photos: [{
	    imageName: "da5e9580-aeca-11ea-9cc0-814fbb741388.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fda5e9580-aeca-11ea-9cc0-814fbb741388.jpg?alt=media&token=71e145eb-7628-449b-ba7a-7fb143f431b9"
	  }],
	  productDescription: "(10x220 per pack)",
	  productNameEnglish: "PurSoft 3-ply Unscented Toilet Tissue Roll",
	  productPrice: "7.55",
	  productSupplier: "BCS SHOP",
	  sortOrder: "k",
	  sourceSupplier: "Sheng siong ",
	  supplierContactName: "arif",
	  supplierContactPhone: "84124637",
	  unit: "10 ROLLS",
	  updateDateTime: "03/08/2020 06:10:53",
	  count: 2
	}, {
	  category: "TOILETRIES",
	  key: "-M9gGFKEWkHfoqW5in6t",
	  photos: [{
	    imageName: "2a2ab8a0-ad3b-11ea-b044-d71d8f034373.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F2a2ab8a0-ad3b-11ea-b044-d71d8f034373.jpg?alt=media&token=f35abdf8-f1c8-4c68-b7d0-81829f447870"
	  }],
	  productNameEnglish: "Toothpaste with toothbrush darlie double action travel kit     ",
	  productPrice: "5",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  updateDateTime: "04/07/2020 10:54:32",
	  count: 2
	}, {
	  category: "KITCHEN DINING",
	  key: "-M9po6TUpI01bzNV0pbR",
	  photos: [{
	    imageName: "2e88b610-aeb0-11ea-9600-53e79e8cda87.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F2e88b610-aeb0-11ea-9600-53e79e8cda87.jpg?alt=media&token=1e157c4b-141d-45fa-a064-4dcad4405183"
	  }],
	  productDescription: "(4x1pre pack)",
	  productNameEnglish: "3M Scotch Brite Scrub Sponges - Heavy Duty",
	  productPrice: "4.90",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  sourceSupplier: "MUSTAFA CENTRE",
	  supplierContactName: "arif",
	  supplierContactPhone: "84124637",
	  unit: "1 packet",
	  updateDateTime: "03/08/2020 06:29:20",
	  count: 2
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  key: "-M9f6NsuqgGRpQGN_8t1",
	  photos: [{
	    imageName: "169a2f10-c653-11ea-8937-41f6a00ee84d.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F169a2f10-c653-11ea-8937-41f6a00ee84d.jpg?alt=media&token=e2a6c182-c7e7-4795-8fc8-8c003bd260fa"
	  }],
	  productNameEnglish: "Capsicum green msia 1kg",
	  productPrice: "4.5",
	  productSupplier: "BCS SHOP",
	  sortOrder: "g",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1 kg",
	  updateDateTime: "15/07/2020 12:24:50",
	  count: 2
	}, {
	  availability: "AVAILABLE",
	  category: "KITCHEN DINING",
	  isPopular: "NO",
	  key: "-MBZMcaPJsYk9yNqB2rR",
	  photos: [{
	    imageName: "8234a190-bf8e-11ea-85e3-735b22b1a0db.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F8234a190-bf8e-11ea-85e3-735b22b1a0db.jpg?alt=media&token=9fc38ddf-89a0-4a9d-96b8-11c71de2c0ae"
	  }],
	  productNameEnglish: "Kitchen Towel Rolls ",
	  productPrice: "4.50",
	  productSupplier: "BCS SHOP",
	  searchText: "কিচেন তোয়ালে ",
	  sortOrder: "G",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "6 roll pack",
	  updateDateTime: "03/08/2020 03:37:10",
	  count: 2
	}, {
	  category: "COSMETICS",
	  key: "-M9gRgxHShbWEYSu17Cn",
	  photos: [{
	    imageName: "33d1b690-ad42-11ea-93aa-6d00775cfd30.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F33d1b690-ad42-11ea-93aa-6d00775cfd30.jpg?alt=media&token=875b5b96-20bd-4317-a434-3d372ee73b39"
	  }],
	  productNameEnglish: "Shaving Razor gillette mach3 ",
	  productPrice: "10.60",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  updateDateTime: "04/07/2020 10:15:35",
	  count: 2
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  key: "-M9f8BRtoL4FZNlxklmG",
	  photos: [{
	    imageName: "3d7676f0-ad0f-11ea-873f-e1ac34f7defb.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F3d7676f0-ad0f-11ea-873f-e1ac34f7defb.jpg?alt=media&token=b0dda013-3aa5-4134-86a9-baf88f84a0f0"
	  }],
	  productNameEnglish: "Capsicum msia 3pic one set",
	  productPrice: "5",
	  productSupplier: "BCS SHOP",
	  sortOrder: "g",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "3 pcs",
	  updateDateTime: "15/07/2020 12:21:53",
	  count: 2
	}, {
	  category: "COSMETICS",
	  key: "-M9gKOicoJLEhs3LeP7H",
	  photos: [{
	    imageName: "70a89c50-ad3d-11ea-b044-d71d8f034373.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F70a89c50-ad3d-11ea-b044-d71d8f034373.jpg?alt=media&token=c4a59294-5ba1-4a78-8794-0c400f5270df"
	  }, {
	    imageName: "7485d680-ad3d-11ea-b044-d71d8f034373.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F7485d680-ad3d-11ea-b044-d71d8f034373.jpg?alt=media&token=3f02f0f4-aa9d-4165-9cbd-320544ceb0c7"
	  }],
	  productNameEnglish: "Shaving foam gillette foamy lemon lime",
	  productPrice: "7",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "175ml",
	  updateDateTime: "04/07/2020 10:20:11",
	  count: 2
	}, {
	  category: "EGGS DAIRY",
	  key: "-M9fJG42PU0cJpHalor2",
	  photos: [{
	    imageName: "20dde440-ad16-11ea-8bc0-03f48af12a9c.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F20dde440-ad16-11ea-8bc0-03f48af12a9c.jpg?alt=media&token=d3d56b08-6320-4678-8f69-edfcce6be78b"
	  }],
	  productNameEnglish: "AYAM BRAND COCONUT MILK",
	  productPrice: "1.50",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "200ml",
	  updateDateTime: "05/07/2020 12:03:09",
	  count: 2
	}, {
	  availability: "AVAILABLE",
	  category: "DRINKS DESSERT",
	  isPopular: "NO",
	  key: "-MA916B8NAJzyeMs1Zke",
	  photos: [{
	    imageName: "e5c26f20-b1c5-11ea-825a-3b8acfde6ce7.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fe5c26f20-b1c5-11ea-825a-3b8acfde6ce7.jpg?alt=media&token=5ecfdd83-beb4-4893-a59c-bdf95216aafa"
	  }],
	  productNameEnglish: "Vitamilk Soymilk",
	  productPrice: "1.50",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  sourceSupplier: "Hao mart ",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "300ML",
	  updateDateTime: "03/08/2020 04:06:48",
	  count: 2
	}, {
	  availability: "AVAILABLE",
	  category: "RICE DAAL NOODLES",
	  key: "-M9bFHt2KBV_U_2AlTyE",
	  photos: [{
	    imageName: "c7527db0-e8dd-11ea-b634-e7e7c4cb042d.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2Fc7527db0-e8dd-11ea-b634-e7e7c4cb042d.jpg?alt=media&token=dce8fe2a-07fd-44be-86f3-d60ee842ceee"
	  }],
	  productNameEnglish: "BAKERS WHEAT FLOUR",
	  productPrice: "2",
	  productSupplier: "BCS SHOP",
	  searchText: "আটা ময়দা",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1Kg",
	  updateDateTime: "Fri 28-08-20 11:23 am",
	  count: 2
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-MA-h-OaWhiWRfI_qBp3",
	  photos: [{
	    imageName: "7ff8ef60-b059-11ea-8357-d5a4954c59fc.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F7ff8ef60-b059-11ea-8357-d5a4954c59fc.jpg?alt=media&token=e7a607ef-2500-4107-95d0-2dd6284fd2f9"
	  }],
	  productNameEnglish: "PRAN Chicken Masala Powder",
	  productPrice: "3.50",
	  productSupplier: "BCS SHOP",
	  searchText: "চিকেন কারি মসলা ",
	  sortOrder: "c",
	  sourceSupplier: "GAZIPUR TRADING PTE LTD ",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "100G",
	  updateDateTime: "03/08/2020 04:45:00",
	  count: 2
	}, {
	  category: "COSMETICS",
	  key: "-M9gY6ErV_g_Qj3_Keuw",
	  photos: [{
	    imageName: "1f7f16c0-ad46-11ea-93aa-6d00775cfd30.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F1f7f16c0-ad46-11ea-93aa-6d00775cfd30.jpg?alt=media&token=59053b15-dc2f-46c9-9582-aa081c9e2961"
	  }],
	  productNameEnglish: "Shaving rezor gillette vector ",
	  productPrice: "5",
	  productSupplier: "BCS SHOP",
	  sortOrder: "k",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  updateDateTime: "04/07/2020 09:42:12",
	  count: 2
	}, {
	  category: "COOKING OIL INGREDIENTS",
	  key: "-M9fS0nIqI8eUKzfLF7t",
	  photos: [{
	    imageName: "7a48e020-ad1b-11ea-8bc0-03f48af12a9c.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F7a48e020-ad1b-11ea-8bc0-03f48af12a9c.jpg?alt=media&token=eaf48a60-1e24-47dd-992f-a5b47261b712"
	  }],
	  productNameEnglish: "NATUREL CANOLA OIL",
	  productPrice: "9.80",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "2L",
	  updateDateTime: "04/07/2020 11:53:52",
	  count: 2
	}, {
	  category: "DRINKS DESSERT",
	  key: "-M9fkswjeL4wt6eRouVn",
	  photos: [{
	    imageName: "985ca680-ad27-11ea-9a01-db9ea96fa329.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F985ca680-ad27-11ea-9a01-db9ea96fa329.jpg?alt=media&token=97a8a80b-b5f2-4bf8-9348-13092ef6f040"
	  }],
	  productNameEnglish: "UFC REFRESH 100% NATURAL COCONUT WATER",
	  productPrice: "3.80",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1L",
	  updateDateTime: "04/07/2020 11:24:44",
	  count: 2
	}, {
	  category: "KITCHEN DINING",
	  key: "-M9fBN8ThHVka9M64fw_",
	  photos: [{
	    imageName: "2111b7c0-ad11-11ea-9aab-f922f3904dfb.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F2111b7c0-ad11-11ea-9aab-f922f3904dfb.jpg?alt=media&token=03cc8cbf-b3ac-4a18-9e9e-ec8e37f819b8"
	  }],
	  productNameEnglish: "Spoon",
	  productPrice: "5",
	  productSupplier: "BCS SHOP",
	  searchText: "চামচ ",
	  sortOrder: "x",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1 pc",
	  updateDateTime: "17/07/2020 02:37:47",
	  count: 2
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-M9aSvkrW8JCLm9Dvxhy",
	  photos: [{
	    imageName: "7d11cec0-ac58-11ea-bbe4-619ccaa778ae.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F7d11cec0-ac58-11ea-bbe4-619ccaa778ae.jpg?alt=media&token=3b63f196-00de-4f2d-a8f3-55fdca947c35"
	  }],
	  productNameEnglish: "MUSTARD SEEDS ",
	  productPrice: "1.50",
	  productSupplier: "BCS SHOP",
	  searchText: " সরিষা",
	  sortOrder: "a",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1 pkt",
	  updateDateTime: "23/07/2020 12:51:08",
	  count: 2
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  photos: [{
	    imageName: "1c08ab80-e81c-11ea-b1ae-e3e3c2d1f850.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F1c08ab80-e81c-11ea-b1ae-e3e3c2d1f850.jpg?alt=media&token=46849882-ebb9-494c-ad90-cad43e536f1d"
	  }],
	  productNameEnglish: "Shan turmeric powder",
	  productPrice: "1.80",
	  productSupplier: "BCS SHOP",
	  searchText: "turmeric powder",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "200g",
	  updateDateTime: "Thu 27-08-20 12:16 pm",
	  key: "-MFi7SivFrmiI3eW1WxW",
	  count: 2
	}, {
	  category: "TOILETRIES",
	  key: "-M9gCMyomakJx06w1EuF",
	  photos: [{
	    imageName: "db223f50-ad38-11ea-b044-d71d8f034373.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fdb223f50-ad38-11ea-b044-d71d8f034373.jpg?alt=media&token=af6a4cc1-2e16-4caa-b67b-62e6262c1697"
	  }],
	  productNameEnglish: "Toothpaste darlie shiny whiteenamel care",
	  productPrice: "4.5",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "140gm",
	  updateDateTime: "04/07/2020 11:09:32",
	  count: 2
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-M9af2C6QcBOgCNLYrUY",
	  photos: [{
	    imageName: "9d3f4a30-ac60-11ea-bbe4-ef7bbce60778.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F9d3f4a30-ac60-11ea-bbe4-ef7bbce60778.jpg?alt=media&token=80081c6c-38c4-4a13-8fce-16deb8c7238c"
	  }],
	  productNameEnglish: "Apple cider vinegar ",
	  productPrice: "3.5",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "473ml",
	  updateDateTime: "17/07/2020 08:35:47",
	  count: 2
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  key: "-MFi4VtLQhsiCgJTHMAp",
	  photos: [{
	    imageName: "338ffe90-e81a-11ea-b1ae-e3e3c2d1f850.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F338ffe90-e81a-11ea-b1ae-e3e3c2d1f850.jpg?alt=media&token=cdd93cdd-734c-4f8b-a9a0-15f3292205ae"
	  }],
	  productNameEnglish: "Shan garam masala powder",
	  productPrice: "2.20",
	  productSupplier: "BCS SHOP",
	  searchText: "garam masala",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "50g",
	  updateDateTime: "Thu 27-08-20 1:14 pm",
	  count: 2
	}, {
	  category: "RICE DAAL NOODLES",
	  key: "-M9b7apudcJmYv59Ojtf",
	  photos: [{
	    imageName: "a4d8c3e0-ac72-11ea-8ded-437354ec7423.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fa4d8c3e0-ac72-11ea-8ded-437354ec7423.jpg?alt=media&token=3fdfb1e2-e845-4f55-afa8-65dabfb98b1b"
	  }],
	  productNameEnglish: "Cup noodles chicken",
	  productPrice: "2",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1 Pkt",
	  updateDateTime: "04/07/2020 11:30:17",
	  count: 2
	}, {
	  availability: "AVAILABLE",
	  category: "DRINKS DESSERT",
	  key: "-M9gEU9ioX8yOm2Yyle8",
	  photos: [{
	    imageName: "462f8810-ad3a-11ea-9a01-db9ea96fa329.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F462f8810-ad3a-11ea-9a01-db9ea96fa329.jpg?alt=media&token=e2518ae1-0f3e-42d6-970a-ae2b3ca8b55b"
	  }],
	  productNameEnglish: "MILO ACTIV-GO LOWER IN SUGER",
	  productPrice: "7",
	  productSupplier: "BCS SHOP",
	  searchText: "মিলো",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "15 x 33g",
	  updateDateTime: "17/07/2020 08:47:34",
	  count: 2
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  key: "-MEfpcbKWce6xFoMeF0M",
	  photos: [{
	    imageName: "6967e670-ddfe-11ea-a50a-71ea37251d72.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F6967e670-ddfe-11ea-a50a-71ea37251d72.jpg?alt=media&token=869b475b-d16c-4506-adbe-c3a36a93074f"
	  }],
	  productNameEnglish: "beef masala pran",
	  productPrice: "2.50",
	  productSupplier: "BCS SHOP",
	  searchText: "beef masala",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "1 pkt 100g",
	  updateDateTime: "Fri 14-08-20 4:16 pm",
	  count: 2
	}, {
	  availability: "AVAILABLE",
	  category: "RICE DAAL NOODLES",
	  key: "-M9hkaEMkQ8ozocccNLY",
	  photos: [{
	    imageName: "6b90c4d0-ad75-11ea-8617-6988f4fcb266.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F6b90c4d0-ad75-11ea-8617-6988f4fcb266.jpg?alt=media&token=ec4a1442-e561-4df4-ac3f-54d6f4aebf45"
	  }],
	  productNameEnglish: "Royal India Basmati Rice ",
	  productPrice: "19.90",
	  productSupplier: "BCS SHOP",
	  searchText: "চাউল rice",
	  sortOrder: "b",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "5Kg",
	  updateDateTime: "03/08/2020 06:51:12",
	  count: 2
	}, {
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-MA4Vt8UuRY3ZbTkrlKM",
	  photos: [{
	    imageName: "2abbbc50-bc55-11ea-b7df-33e703b87300.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F2abbbc50-bc55-11ea-b7df-33e703b87300.jpg?alt=media&token=e55ce384-e792-4d17-8245-6c216c702e44"
	  }],
	  productNameEnglish: "Arugula",
	  productPrice: "2.6",
	  productSupplier: "BCS SHOP",
	  searchText: "শাক সবজি সব্জি ",
	  sortOrder: "a",
	  sourceSupplier: "Sheng siong ",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "500gm",
	  updateDateTime: "17/07/2020 02:14:45",
	  count: 2
	}, {
	  category: "DRINKS DESSERT",
	  isPopular: "YES",
	  key: "-M9gdKMWElwiXoeMBUTl",
	  photos: [{
	    imageName: "0c3c6050-ad4a-11ea-9a01-db9ea96fa329.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F0c3c6050-ad4a-11ea-9a01-db9ea96fa329.jpg?alt=media&token=da35e7b2-d853-4a7f-b7c9-59179208129b"
	  }],
	  productNameEnglish: "Nescafe Instant Soluble Coffee Jar - Deluxe",
	  productPrice: "7.50",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "200gm Bottle",
	  updateDateTime: "Tue 18-08-20 9:46 am",
	  count: 2
	}, {
	  category: "DRINKS DESSERT",
	  key: "-M9fkE_F7sw40RiQnwnz",
	  photos: [{
	    imageName: "34867be0-ad27-11ea-9a01-db9ea96fa329.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F34867be0-ad27-11ea-9a01-db9ea96fa329.jpg?alt=media&token=edcb9fa4-f5cf-47a1-9cdf-42a48d6c66d2"
	  }],
	  productNameEnglish: "VITASOY ORIGINAL SOYA BEAN DRINK",
	  productPrice: "3.20",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "6 x 250ml",
	  updateDateTime: "04/07/2020 11:25:05",
	  count: 2
	}, {
	  category: "DRINKS DESSERT",
	  key: "-M9gGl_ykmk2MFL967d-",
	  photos: [{
	    imageName: "ab7f64f0-ad3b-11ea-9a01-db9ea96fa329.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fab7f64f0-ad3b-11ea-9a01-db9ea96fa329.jpg?alt=media&token=28b32328-b7e6-4533-89a6-2a7720829dab"
	  }],
	  productNameEnglish: "OLD TOWN 3 IN 1 CLASSIC WHITE COFFEE MIX",
	  productPrice: "7.50",
	  productSupplier: "BCS SHOP",
	  sortOrder: "g",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "15x38g",
	  updateDateTime: "04/07/2020 10:53:14",
	  count: 2
	}, {
	  category: "COOKING OIL INGREDIENTS",
	  key: "-M9fUyvL2TFHVdiq4r-Y",
	  photos: [{
	    imageName: "47b061e0-ad1d-11ea-9a01-db9ea96fa329.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F47b061e0-ad1d-11ea-9a01-db9ea96fa329.jpg?alt=media&token=e3e14745-32f5-4c48-84fa-302273e30645"
	  }],
	  productNameEnglish: "NATUREL SUNFLOWER OIL",
	  productPrice: "5.80",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1L",
	  updateDateTime: "04/07/2020 11:51:43",
	  count: 2
	}, {
	  category: "STATIONARY",
	  isPopular: "NO",
	  key: "-MA96ThUvng4JLtbcjqV",
	  photos: [{
	    imageName: "173bf690-b1c9-11ea-825a-3b8acfde6ce7.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F173bf690-b1c9-11ea-825a-3b8acfde6ce7.jpg?alt=media&token=b5014879-f5ae-4b31-afab-d3883bfed06e"
	  }],
	  productNameEnglish: "Pen Pilot G2 0.5M gel ink rollerball pen",
	  productPrice: "2.50",
	  productSupplier: "BCS SHOP",
	  searchText: "কলম ",
	  sortOrder: "n",
	  sourceSupplier: "MUSTAFA CENTRE",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1pc",
	  updateDateTime: "17/07/2020 02:07:26",
	  count: 2
	}, {
	  category: "RICE DAAL NOODLES",
	  key: "-M9hjeXdH6PLlcrwMShr",
	  photos: [{
	    imageName: "c9023c80-ad74-11ea-8617-6988f4fcb266.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fc9023c80-ad74-11ea-8617-6988f4fcb266.jpg?alt=media&token=0eab69cb-5644-4eea-82b5-df16dc3ad2e3"
	  }],
	  productNameEnglish: "Royal Umbrella Jasmine Fragrant Rice ",
	  productPrice: "18.3",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "5kg",
	  updateDateTime: "03/08/2020 06:52:09",
	  count: 2
	}, {
	  availability: "AVAILABLE",
	  category: "OTHERS",
	  key: "-MAywiPOYxcEO50-mrk9",
	  photos: [{
	    imageName: "5131adb0-e8e0-11ea-b634-e7e7c4cb042d.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F5131adb0-e8e0-11ea-b634-e7e7c4cb042d.jpg?alt=media&token=46317372-b7a9-44ec-b42e-d9d4640e5c52"
	  }],
	  productNameEnglish: "Surgical Face mask",
	  productPrice: "18.90",
	  productSupplier: "BCS SHOP",
	  searchText: "মাস্ক ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "50pcs of 1packet.",
	  updateDateTime: "Fri 28-08-20 1:45 pm",
	  count: 1
	}, {
	  category: "TOILETRIES",
	  isPopular: "NO",
	  key: "-M9qZ4eweURh0156FPwh",
	  photos: [{
	    imageName: "799de0e0-aecd-11ea-9cc0-814fbb741388.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F799de0e0-aecd-11ea-9cc0-814fbb741388.jpg?alt=media&token=9f4d3099-d075-4d13-b04a-edba711d5cbd"
	  }],
	  productNameEnglish: "Pursoft Kitchen Towel Roll",
	  productPrice: "6.20",
	  productSupplier: "BCS SHOP",
	  sortOrder: "k",
	  sourceSupplier: "MUSTAFA CENTRE",
	  supplierContactName: "arif",
	  supplierContactPhone: "84124637",
	  unit: "6pcs of 1packet ",
	  updateDateTime: "03/08/2020 06:02:22",
	  count: 1
	}, {
	  availability: "AVAILABLE",
	  category: "EGGS DAIRY",
	  isPopular: "NO",
	  key: "-MBZUisJUWEgSH-uDmYN",
	  photos: [{
	    imageName: "b7abd190-bf93-11ea-85e3-735b22b1a0db.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fb7abd190-bf93-11ea-85e3-735b22b1a0db.jpg?alt=media&token=4b714d25-1da0-4055-88cc-df0192a8b02e"
	  }],
	  productNameEnglish: "Ayam Brand Tuna Mayonnaise - Hot",
	  productPrice: "2.65",
	  productSupplier: "BCS SHOP",
	  searchText: "টুনা মায়োনিস্ ",
	  sortOrder: "g",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "100gm containter",
	  updateDateTime: "03/08/2020 03:32:08",
	  count: 1
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-MA4b6SEakaGudeVUHPy",
	  photos: [{
	    imageName: "28ec8770-b119-11ea-810a-c5e0250e7646.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F28ec8770-b119-11ea-810a-c5e0250e7646.jpg?alt=media&token=2b2007cc-f32f-435b-a46a-4ff6c42a7443"
	  }],
	  productNameEnglish: "Radicchio",
	  productPrice: "6",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  sourceSupplier: "Sheng siong ",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1KG",
	  updateDateTime: "03/08/2020 04:19:09",
	  count: 1
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-MA-INBhfRZ_Ufq7sGye",
	  photos: [{
	    imageName: "d91ba430-b049-11ea-9737-25db4b55bc7b.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fd91ba430-b049-11ea-9737-25db4b55bc7b.jpg?alt=media&token=f58486ae-0eb0-4b0a-8280-3013d3695dbf"
	  }],
	  productNameEnglish: "PRAN Bbq Masala",
	  productPrice: "3.60",
	  productSupplier: "BCS SHOP",
	  searchText: "BBQ মসলা ",
	  sortOrder: "a",
	  sourceSupplier: "KHAN PRODUCTS PTE LTD.",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "50G",
	  updateDateTime: "03/08/2020 04:50:20",
	  count: 1
	}, {
	  author: "+6594562455",
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  key: "-M9b11V3Y0kE8aCjjY_1",
	  photos: [{
	    imageName: "c0e255a0-ac6e-11ea-83ef-037972cabc05.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fc0e255a0-ac6e-11ea-83ef-037972cabc05.jpg?alt=media&token=7117ff9a-187c-4536-8bca-e43bb6ad46fb"
	  }],
	  productNameEnglish: "YELLOW LEMON lime",
	  productPrice: "1.80",
	  productSupplier: "BCS SHOP",
	  searchText: "লেবু ",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "2 pcs ",
	  updateDateTime: "Sat 08-08-20 11:47 am",
	  count: 1
	}, {
	  category: "TOILETRIES",
	  key: "-M9bAvuFocwVT1Lt_S9j",
	  photos: [{
	    imageName: "b7134a60-ac74-11ea-8ded-437354ec7423.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fb7134a60-ac74-11ea-8ded-437354ec7423.jpg?alt=media&token=43bf3fb2-c434-44fd-8a0f-0a75e5c7c0a8"
	  }, {
	    imageName: "c05f3430-ac74-11ea-8ded-437354ec7423.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fc05f3430-ac74-11ea-8ded-437354ec7423.jpg?alt=media&token=49833320-a797-4748-a3a4-8f4c4659512b"
	  }],
	  productNameEnglish: "Hand wash",
	  productPrice: "4.2",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "500ml",
	  updateDateTime: "04/07/2020 08:45:02",
	  count: 1
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-MA-Dnh-n931gdIbkaF9",
	  photos: [{
	    imageName: "01e6f020-b047-11ea-9737-25db4b55bc7b.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F01e6f020-b047-11ea-9737-25db4b55bc7b.jpg?alt=media&token=8e0626a6-ffbf-4565-b402-ecc9a5403ead"
	  }],
	  productNameEnglish: "RADHUNI Meat Masala",
	  productPrice: "3.50",
	  productSupplier: "BCS SHOP",
	  searchText: "খাসির মাংস মসলা ",
	  sortOrder: "a",
	  sourceSupplier: "KHAN PRODUCTS PTE LTD.",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "20G",
	  updateDateTime: "03/08/2020 04:57:52",
	  count: 1
	}, {
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-MA-gbxP3URtD4qfXJQ3",
	  photos: [{
	    imageName: "3d7f9210-b059-11ea-8357-d5a4954c59fc.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F3d7f9210-b059-11ea-8357-d5a4954c59fc.jpg?alt=media&token=99eaa607-195e-4d6c-a4d5-6db3773047b7"
	  }],
	  productNameEnglish: "PRAN Chicken Roast Masala Powder",
	  productPrice: "2.90",
	  productSupplier: "BCS SHOP",
	  searchText: "চিকেন রোস্ট মসলা",
	  sortOrder: "c",
	  sourceSupplier: "TERRY TRADING CO PTE LTD",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "35G",
	  updateDateTime: "03/08/2020 04:45:29",
	  count: 1
	}, {
	  availability: "AVAILABLE",
	  category: "RICE DAAL NOODLES",
	  key: "-M9m_b44ut235CDhnAM2",
	  photos: [{
	    imageName: "052e9c40-ae32-11ea-8070-f3cc7bbcb5d1.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F052e9c40-ae32-11ea-8070-f3cc7bbcb5d1.jpg?alt=media&token=eb07da47-4065-43f6-bc5b-2fae72aa0a3e"
	  }],
	  productNameEnglish: "Royal Umbrella Jasmine Fragrant Rice",
	  productPrice: "10.90",
	  productSupplier: "BCS SHOP",
	  searchText: "চাউল rice",
	  sortOrder: "b",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "2.5kg",
	  updateDateTime: "03/08/2020 06:50:08",
	  count: 1
	}, {
	  availability: "AVAILABLE",
	  category: "EGGS DAIRY",
	  isPopular: "NO",
	  key: "-MBZSgMuAhBkuSScVIda",
	  photos: [{
	    imageName: "6b7bfe40-bf92-11ea-85e3-735b22b1a0db.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F6b7bfe40-bf92-11ea-85e3-735b22b1a0db.jpg?alt=media&token=0bc32690-6e45-4876-8478-ce39d63fc9aa"
	  }],
	  productNameEnglish: "Greenfields Fresh Milk - Chocolate Malt",
	  productPrice: "3.30",
	  productSupplier: "BCS SHOP",
	  searchText: "গ্রীনফিল্ড চকলেট মাল্ট",
	  sortOrder: "G",
	  supplierContactName: "Ahmed Fayyaz",
	  supplierContactPhone: "97861239",
	  unit: "1L",
	  updateDateTime: "03/08/2020 03:33:35",
	  count: 1
	}, {
	  category: "KITCHEN DINING",
	  key: "-M9b8c4xiaoUzpBsxhG0",
	  photos: [{
	    imageName: "6253d860-ac73-11ea-83ef-037972cabc05.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F6253d860-ac73-11ea-83ef-037972cabc05.jpg?alt=media&token=af1e5d07-f220-4cb4-9a04-4e604cec50d8"
	  }],
	  productNameEnglish: "CUTTING BOARD ",
	  productPrice: "10 ",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1 pc",
	  updateDateTime: "04/07/2020 08:49:03",
	  count: 1
	}, {
	  category: "COSMETICS",
	  key: "-M9qmo8m2Y8rF36Tbf4W",
	  photos: [{
	    imageName: "41bad8a0-aed6-11ea-a496-7103817df0c1.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F41bad8a0-aed6-11ea-a496-7103817df0c1.jpg?alt=media&token=6b66c4d5-23da-47ca-a35a-781a8d967487"
	  }],
	  productNameEnglish: "Himani Navratna Revita Hair Oil",
	  productPrice: "9",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  sourceSupplier: "MUSTAFA CENTRE",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "200ML",
	  updateDateTime: "03/08/2020 05:40:44",
	  count: 1
	}, {
	  availability: "AVAILABLE",
	  category: "COSMETICS",
	  key: "-M9qhy-cLtcoJBhXeJtE",
	  photos: [{
	    imageName: "5c6692a0-aed3-11ea-8a8d-4f5b661598fc.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F5c6692a0-aed3-11ea-8a8d-4f5b661598fc.jpg?alt=media&token=e4c1bfcf-2cc8-4898-8221-388a449348dc"
	  }],
	  productNameEnglish: "Nivea Whitening Acne Oil Control + Pore Minimiser Cleanser & Scrub",
	  productPrice: "9.9",
	  productSupplier: "BCS SHOP",
	  searchText: "ফেইস ওয়াশ ",
	  sortOrder: "x",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "100ML",
	  updateDateTime: "03/08/2020 05:49:48",
	  count: 1
	}, {
	  availability: "AVAILABLE",
	  category: "COSMETICS",
	  key: "-M9qjQc6sQmiIIgkR9b1",
	  photos: [{
	    imageName: "17a96a60-aed4-11ea-8a8d-4f5b661598fc.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F17a96a60-aed4-11ea-8a8d-4f5b661598fc.jpg?alt=media&token=d9c31e7d-444f-499f-b3c4-327b24329b29"
	  }],
	  productNameEnglish: "L`OREAL Men Expert Pure & Matte Charcoal Black Icy Foam",
	  productPrice: "11.10",
	  productSupplier: "BCS SHOP",
	  searchText: "ফেইস ওয়াশ ",
	  sortOrder: "d",
	  sourceSupplier: "MUSTAFA CENTRE",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "100ML ",
	  updateDateTime: "03/08/2020 05:46:24",
	  count: 1
	}, {
	  availability: "AVAILABLE",
	  category: "SANITARY",
	  isPopular: "NO",
	  key: "-MA-j9aKGGE3T3ChzTIC",
	  photos: [{
	    imageName: "0fedf400-bc5b-11ea-b7df-33e703b87300.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F0fedf400-bc5b-11ea-b7df-33e703b87300.jpg?alt=media&token=e830a52d-703a-48fa-b45a-5375a2757a05"
	  }],
	  productNameEnglish: "Shieldtox All Insect Killer Spray - Powergard",
	  productPrice: "4.20",
	  productSupplier: "BCS SHOP",
	  sortOrder: "o",
	  sourceSupplier: "MUSTAFA CENTRE",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "270ml",
	  updateDateTime: "03/08/2020 04:44:15",
	  count: 1
	}, {
	  category: "TOILETRIES",
	  key: "-M9fhaow2dFpVyUAre4G",
	  photos: [{
	    imageName: "726617b0-ad25-11ea-b044-d71d8f034373.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F726617b0-ad25-11ea-b044-d71d8f034373.jpg?alt=media&token=f9156b26-6dc4-406e-a45a-751652817148"
	  }],
	  productNameEnglish: "Tootthpast colgate sensitive pro relief whitening",
	  productPrice: "9",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "110gm",
	  updateDateTime: "04/07/2020 11:26:16",
	  count: 1
	}, {
	  category: "COOKING OIL INGREDIENTS",
	  key: "-M9fOV-yMxcL9A6pqBzA",
	  photos: [{
	    imageName: "5312cc70-ad19-11ea-8bc0-03f48af12a9c.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F5312cc70-ad19-11ea-8bc0-03f48af12a9c.jpg?alt=media&token=7a7ec498-d269-4746-8efe-5de37bf4e9ed"
	  }],
	  productNameEnglish: "BORGES OLIVE OIL EXTRA LIGHT",
	  productPrice: "29",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "2L",
	  updateDateTime: "04/07/2020 11:54:04",
	  count: 1
	}, {
	  availability: "AVAILABLE",
	  category: "RICE DAAL NOODLES",
	  key: "-M9ma8CcI51a_N56Srhs",
	  photos: [{
	    imageName: "61e7cb00-ae32-11ea-8070-f3cc7bbcb5d1.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F61e7cb00-ae32-11ea-8070-f3cc7bbcb5d1.jpg?alt=media&token=56868607-b2b0-401a-8d39-7586d85c1ed7"
	  }],
	  productNameEnglish: "Paddy Land Jasmine Fragrant Rice",
	  productPrice: "8.6",
	  productSupplier: "BCS SHOP",
	  searchText: "চাউল rice",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "5Kg",
	  updateDateTime: "03/08/2020 06:49:22",
	  count: 1
	}, {
	  availability: "AVAILABLE",
	  category: "RICE DAAL NOODLES",
	  key: "-MDeJ5jT1rQq8hlzdcn4",
	  photos: [{
	    imageName: "f1a90000-d3fe-11ea-a0e0-7d366b7a98ae.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Ff1a90000-d3fe-11ea-a0e0-7d366b7a98ae.jpg?alt=media&token=08e2aa38-1766-4926-8fdb-3f8c0b40293d"
	  }],
	  productNameEnglish: "Green Moong Dal",
	  productPrice: "4.50",
	  productSupplier: "BCS SHOP",
	  searchText: "ডাল",
	  sortOrder: "a",
	  supplierContactName: "Kabir",
	  supplierContactPhone: "94562455",
	  unit: "1kg ",
	  updateDateTime: "03/08/2020 03:04:50",
	  count: 1
	}, {
	  category: "DRINKS DESSERT",
	  key: "-M9gHdslTGbvMaokHlSy",
	  photos: [{
	    imageName: "34a36d30-ad3c-11ea-9a01-db9ea96fa329.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F34a36d30-ad3c-11ea-9a01-db9ea96fa329.jpg?alt=media&token=3d5c1a5c-0ab6-4b95-a38c-d3bab259cf03"
	  }],
	  productNameEnglish: "CERES WHISPERS OF SUMMER 100% JUICE",
	  productPrice: "2.70",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1L",
	  updateDateTime: "04/07/2020 10:22:07",
	  count: 1
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  photos: [{
	    imageName: "7e731120-e81c-11ea-b1ae-e3e3c2d1f850.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F7e731120-e81c-11ea-b1ae-e3e3c2d1f850.jpg?alt=media&token=9f6aa663-b083-4a98-a759-f034ba6ee7cc"
	  }],
	  productNameEnglish: "Shan fenugreek leaves",
	  productPrice: "1.50",
	  productSupplier: "BCS SHOP",
	  searchText: "fenugreek leaves",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "50g",
	  updateDateTime: "Thu 27-08-20 12:19 pm",
	  key: "-MFi855Nl5zEHaWo1qSO",
	  count: 1
	}, {
	  availability: "AVAILABLE",
	  category: "DRINKS DESSERT",
	  isPopular: "NO",
	  key: "-M9aQByOxtIHQ-5lwDs9",
	  photos: [{
	    imageName: "fc4310c0-ac56-11ea-985e-71484f367323.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Ffc4310c0-ac56-11ea-985e-71484f367323.jpg?alt=media&token=3bd0a4ca-eee5-4113-a4b7-df8a68f2a7c7"
	  }],
	  productNameEnglish: "Milo ",
	  productPrice: "9",
	  productSupplier: "BCS SHOP",
	  searchText: "মিলো ",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "900gms",
	  updateDateTime: "17/07/2020 08:47:16",
	  count: 1
	}, {
	  availability: "AVAILABLE",
	  category: "COSMETICS",
	  key: "-M9ql62AvOC-_TkeZPGZ",
	  photos: [{
	    imageName: "48b0e100-aed5-11ea-8a8d-4f5b661598fc.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F48b0e100-aed5-11ea-8a8d-4f5b661598fc.jpg?alt=media&token=762b21a3-6998-4591-bfa3-a67a33b1806b"
	  }],
	  productNameEnglish: "Himalaya Men Intense Oil Clear Lemon Face Wash",
	  productPrice: "9.2",
	  productSupplier: "BCS SHOP",
	  searchText: "ফেইস ওয়াশ ",
	  sortOrder: "x",
	  sourceSupplier: "MUSTAFA CENTRE",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "100ML",
	  updateDateTime: "03/08/2020 05:42:58",
	  count: 1
	}, {
	  category: "COOKING OIL INGREDIENTS",
	  key: "-M9b2rYajYMImsSvokyT",
	  photos: [{
	    imageName: "deacb7f0-ac6f-11ea-83ef-037972cabc05.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fdeacb7f0-ac6f-11ea-83ef-037972cabc05.jpg?alt=media&token=f4d091e6-6f8e-4939-8176-eda885e02668"
	  }],
	  productNameEnglish: "SWEETENED CREAMER ",
	  productPrice: "1.20",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1 tin",
	  updateDateTime: "05/07/2020 12:17:32",
	  count: 1
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  key: "-MFoUZc12Nwex7SCUlaW",
	  photos: [{
	    imageName: "90a6ce10-e914-11ea-8fce-359ac42234fb.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F90a6ce10-e914-11ea-8fce-359ac42234fb.jpg?alt=media&token=00299e97-b1f4-44ad-b1df-09ddd50899c9"
	  }],
	  productNameEnglish: "Shan daal masala ",
	  productPrice: "2.60",
	  productSupplier: "BCS SHOP",
	  searchText: "daal masala",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "100g",
	  updateDateTime: "Fri 28-08-20 6:04 pm",
	  count: 1
	}, {
	  category: "STATIONARY",
	  isPopular: "NO",
	  key: "-M9qxlJlSduEAkgi-FoD",
	  photos: [{
	    imageName: "194fd850-aedd-11ea-9b4b-4bd8d539c6a6.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F194fd850-aedd-11ea-9b4b-4bd8d539c6a6.jpg?alt=media&token=6322dafb-96e7-4815-b563-68c5b2bbc548"
	  }],
	  productNameEnglish: "Marker pen ",
	  productPrice: "1.5",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  sourceSupplier: "MUSTAFA CENTRE",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1 Pen",
	  updateDateTime: "04/07/2020 08:56:19",
	  count: 1
	}, {
	  category: "KITCHEN DINING",
	  key: "-MA4sgeQJgpkoZouqO1P",
	  photos: [{
	    imageName: "d17d1a30-b123-11ea-b0bf-cbb30a1eed12.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fd17d1a30-b123-11ea-b0bf-cbb30a1eed12.jpg?alt=media&token=3d227a15-d5ed-4952-8bb1-24e812cf1847"
	  }],
	  productNameEnglish: "Wooden Angular Spoon (30cm)",
	  productPrice: "6.50",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  sourceSupplier: "Sheng siong ",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "PER PC",
	  updateDateTime: "03/08/2020 04:16:51",
	  count: 1
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  photos: [{
	    imageName: "26349da0-e833-11ea-a70c-3f9f15f1ac0f.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F26349da0-e833-11ea-a70c-3f9f15f1ac0f.jpg?alt=media&token=47418b1c-51e8-453c-a50b-da162f423e1d"
	  }],
	  productNameEnglish: "Malka turmeric powder",
	  productPrice: "1.30",
	  productSupplier: "BCS SHOP",
	  searchText: " turmeric powder",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "100g",
	  updateDateTime: "Thu 27-08-20 3:01 pm",
	  key: "-MFiiCMnPa_ZArGp15n9",
	  count: 1
	}, {
	  category: "MEAT FISH",
	  isPopular: "YES",
	  key: "-MA--EcLlJD8siFnyC5a",
	  photos: [{
	    imageName: "1a588050-b03e-11ea-9737-25db4b55bc7b.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F1a588050-b03e-11ea-9737-25db4b55bc7b.jpg?alt=media&token=35e46cda-8e33-4ea6-ba14-621032a29a0e"
	  }],
	  productNameEnglish: "Silver Carp",
	  productPrice: "6",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  sourceSupplier: "TERRY TRADING CO PTE LTD",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1KG",
	  updateDateTime: "03/08/2020 05:20:09",
	  count: 1
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-MA4aIACmAC5fCV5M-7F",
	  photos: [{
	    imageName: "ff0095b0-bc52-11ea-b7df-33e703b87300.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fff0095b0-bc52-11ea-b7df-33e703b87300.jpg?alt=media&token=024e42da-b7bf-47c2-b344-8c14a05f6b5c"
	  }],
	  productNameEnglish: "Peas",
	  productPrice: "6.5",
	  productSupplier: "BCS SHOP",
	  searchText: "মটর ",
	  sortOrder: "a",
	  sourceSupplier: "Minaka trading ",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1KG",
	  updateDateTime: "03/08/2020 04:19:24",
	  count: 1
	}, {
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-MA0M1ZNeHSwSvsOVwJt",
	  photos: [{
	    imageName: "2054fdf0-b073-11ea-9c7f-87aca56d8623.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F2054fdf0-b073-11ea-9c7f-87aca56d8623.jpg?alt=media&token=860fad18-fcfd-4275-9939-4203727eea0e"
	  }],
	  productNameEnglish: "Rock Melon",
	  productPrice: "7.90",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  sourceSupplier: "Sheng siong ",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1 pc",
	  updateDateTime: "03/08/2020 04:28:16",
	  count: 1
	}, {
	  category: "TOILETRIES",
	  key: "-M9qf1UxVbQed3GYVmKW",
	  photos: [{
	    imageName: "84476210-aed1-11ea-8a8d-4f5b661598fc.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F84476210-aed1-11ea-8a8d-4f5b661598fc.jpg?alt=media&token=e05d02ac-d02c-4757-a096-f5e3cd59c29a"
	  }],
	  productNameEnglish: "Colgate Plax Ice Mouthwash",
	  productPrice: "6.3",
	  productSupplier: "BCS SHOP",
	  sortOrder: "k",
	  sourceSupplier: "Sheng siong ",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "250ML",
	  updateDateTime: "03/08/2020 05:54:06",
	  count: 1
	}, {
	  category: "TOILETRIES",
	  key: "-M9r-cDBn4vIQlIH5Wh_",
	  photos: [{
	    imageName: "e08affc0-aede-11ea-9cc0-814fbb741388.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fe08affc0-aede-11ea-9cc0-814fbb741388.jpg?alt=media&token=e019ddee-9a47-4bcf-8cf1-e01dd2371534"
	  }],
	  productNameEnglish: "Dettol Antiseptic Germicide",
	  productPrice: "12.55",
	  productSupplier: "BCS SHOP",
	  sortOrder: "k",
	  sourceSupplier: "MUSTAFA CENTRE",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1L",
	  updateDateTime: "03/08/2020 05:32:51",
	  count: 1
	}, {
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-MA4X1ylVhS1ea28CGLI",
	  photos: [{
	    imageName: "ab534fa0-bc54-11ea-b7df-33e703b87300.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fab534fa0-bc54-11ea-b7df-33e703b87300.jpg?alt=media&token=9062ee47-ae37-49a1-8749-4b3fd2f81fb5"
	  }],
	  productNameEnglish: "Raddish ",
	  productPrice: "4.50",
	  productSupplier: "BCS SHOP",
	  searchText: "শাক সবজি সব্জি ",
	  sortOrder: "a",
	  sourceSupplier: "Giant supermarket ",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1KG",
	  updateDateTime: "03/08/2020 04:20:59",
	  count: 1
	}, {
	  category: "COOKING OIL INGREDIENTS",
	  key: "-M9fEJ2SMkO5D8A_eiQ7",
	  photos: [{
	    imageName: "1ad63050-ad13-11ea-8bc0-03f48af12a9c.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F1ad63050-ad13-11ea-8bc0-03f48af12a9c.jpg?alt=media&token=b4790a09-ae84-4756-87df-3a03864bf3b6"
	  }],
	  productNameEnglish: "LEE KUM KEE PANDA OYSTER SAUCE",
	  productPrice: "3.80",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "510g",
	  updateDateTime: "05/07/2020 12:29:30",
	  count: 1
	}, {
	  category: "KITCHEN DINING",
	  isPopular: "NO",
	  key: "-M9qfo7RSObSm8Oraur9",
	  photos: [{
	    imageName: "08b7cd50-aed2-11ea-8a8d-4f5b661598fc.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F08b7cd50-aed2-11ea-8a8d-4f5b661598fc.jpg?alt=media&token=e73a451b-6a67-4b34-a4ca-f884bb65b1af"
	  }],
	  productNameEnglish: "Vegetable / Fruit Peeler",
	  productPrice: "4.5",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  sourceSupplier: "MUSTAFA CENTRE",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1PC",
	  updateDateTime: "03/08/2020 05:51:41",
	  count: 1
	}, {
	  category: "RICE DAAL NOODLES",
	  key: "-M9fDXrY0QwDR0Fy97Zl",
	  photos: [{
	    imageName: "9e29fd70-ad12-11ea-8bc0-03f48af12a9c.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F9e29fd70-ad12-11ea-8bc0-03f48af12a9c.jpg?alt=media&token=cad40c24-43a0-4722-8d7e-46309f977a36"
	  }],
	  productNameEnglish: "SAN REMO PASTA LINGUINE",
	  productPrice: "2.60",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "500g",
	  updateDateTime: "05/07/2020 12:30:29",
	  count: 1
	}, {
	  category: "RICE DAAL NOODLES",
	  key: "-M9fViWxjrPp1dB01tGR",
	  photos: [{
	    imageName: "bc02fa30-ad1d-11ea-9a01-db9ea96fa329.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fbc02fa30-ad1d-11ea-9a01-db9ea96fa329.jpg?alt=media&token=bcd0b863-4411-4a10-86c3-263d8e475175"
	  }],
	  productNameEnglish: "NATUREL ORGANIC MACARONI",
	  productPrice: "3.80",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "500g",
	  updateDateTime: "05/07/2020 12:00:21",
	  count: 1
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  photos: [{
	    imageName: "06bf2ff0-e81d-11ea-b1ae-e3e3c2d1f850.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F06bf2ff0-e81d-11ea-b1ae-e3e3c2d1f850.jpg?alt=media&token=1ed00fea-c10f-442e-822d-c34ca83dc316"
	  }],
	  productNameEnglish: "Shan chapli kabab",
	  productPrice: "1.50",
	  productSupplier: "BCS SHOP",
	  searchText: "chapli kabab",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "100g",
	  updateDateTime: "Thu 27-08-20 12:23 pm",
	  key: "-MFi8xY4_rUfIzh2LtYC",
	  count: 1
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  photos: [{
	    imageName: "e6067790-e82c-11ea-b1ae-e3e3c2d1f850.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2Fe6067790-e82c-11ea-b1ae-e3e3c2d1f850.jpg?alt=media&token=79917cba-8080-423b-8b87-b8bd4685ff1e"
	  }],
	  productNameEnglish: "Shan haleem mix",
	  productPrice: "2.60",
	  productSupplier: "BCS SHOP",
	  searchText: "haleem mix",
	  sortOrder: "a",
	  supplierContactName: "Ismita",
	  supplierContactPhone: "userMobile",
	  unit: "300g",
	  updateDateTime: "Thu 27-08-20 2:16 pm",
	  key: "-MFiYxfbB1MBnMi7xRA0",
	  count: 1
	}, {
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-MA-faWokfFjVRxskzQs",
	  photos: [{
	    imageName: "a4296b90-b058-11ea-8357-d5a4954c59fc.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fa4296b90-b058-11ea-8357-d5a4954c59fc.jpg?alt=media&token=493121d9-37b6-4122-97cc-0e1d7270aa20"
	  }],
	  productNameEnglish: "PRAN Tehari Masala",
	  productPrice: "3.90",
	  productSupplier: "BCS SHOP",
	  searchText: "তেহারি মসলা",
	  sortOrder: "c",
	  sourceSupplier: "RAJDHANI ENTERPRISE PTE LTD",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "50G",
	  updateDateTime: "03/08/2020 04:47:09",
	  count: 1
	}, {
	  availability: "AVAILABLE",
	  category: "RICE DAAL NOODLES",
	  key: "-M9fYouusyu6N1mtP-ee",
	  photos: [{
	    imageName: "a0082060-ad1f-11ea-9a01-db9ea96fa329.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fa0082060-ad1f-11ea-9a01-db9ea96fa329.jpg?alt=media&token=5f36bec9-4091-42b6-b726-42e0e716409e"
	  }],
	  productNameEnglish: "NISSIN SEAFOOD FLAVOUR CUP NOODLES",
	  productPrice: "2",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "Cup 75g",
	  updateDateTime: "17/07/2020 06:53:40",
	  count: 1
	}, {
	  category: "COOKING OIL INGREDIENTS",
	  key: "-M9fX8o43RsfQQVRYJay",
	  photos: [{
	    imageName: "9a69f1c0-ad1e-11ea-9a01-db9ea96fa329.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F9a69f1c0-ad1e-11ea-9a01-db9ea96fa329.jpg?alt=media&token=eff85424-43fc-4615-a3bb-6f69ffe926ac"
	  }],
	  productNameEnglish: "BORGES OLIVE OIL",
	  productPrice: "8.50",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "500ml",
	  updateDateTime: "04/07/2020 11:51:13",
	  count: 1
	}, {
	  category: "COOKING OIL INGREDIENTS",
	  key: "-M9fQhmeLH__-yY3QLsP",
	  photos: [{
	    imageName: "acaee740-ad1a-11ea-8bc0-03f48af12a9c.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Facaee740-ad1a-11ea-8bc0-03f48af12a9c.jpg?alt=media&token=0fc3a22f-d19c-4c2c-a6ba-f351d97db93d"
	  }],
	  productNameEnglish: "NARCISSUS RICE VINEGAR",
	  productPrice: "1.50",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "600g",
	  updateDateTime: "05/07/2020 12:01:03",
	  count: 1
	}, {
	  category: "LAUNDRY CLEANING",
	  key: "-M9pXG6GmKhzZ5upS7CK",
	  photos: [{
	    imageName: "4cf653b0-aea5-11ea-9600-53e79e8cda87.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F4cf653b0-aea5-11ea-9600-53e79e8cda87.jpg?alt=media&token=2faef842-57d9-47ce-84e0-70e669614c9e"
	  }],
	  productNameEnglish: "Ajax Fabuloso Multi Purpose Cleaner - Lavender Fresh",
	  productPrice: "7.05",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  sourceSupplier: "MUSTAFA CENTRE",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1 bottol of 3L",
	  updateDateTime: "03/08/2020 06:36:51",
	  count: 1
	}, {
	  availability: "AVAILABLE",
	  category: "MEAT FISH",
	  isPopular: "YES",
	  key: "-M9a2_CWuCbIou2qTCuq",
	  photos: [{
	    imageName: "9e45aa90-ac48-11ea-ba1a-4bcfa8bf5006.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F9e45aa90-ac48-11ea-ba1a-4bcfa8bf5006.jpg?alt=media&token=8bca4183-b6de-42fa-b59f-fe1b125e7b31"
	  }],
	  productNameEnglish: "Fish small ",
	  productPrice: "5.5",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1 packet",
	  updateDateTime: "06/07/2020 07:13:04",
	  count: 1
	}, {
	  availability: "AVAILABLE",
	  category: "COSMETICS",
	  key: "-M9qkW5FbzfMwsH1NsOs",
	  photos: [{
	    imageName: "cf6f2950-aed4-11ea-8a8d-4f5b661598fc.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fcf6f2950-aed4-11ea-8a8d-4f5b661598fc.jpg?alt=media&token=21252db9-ae32-4f42-af7c-3b353c66fccd"
	  }],
	  productNameEnglish: "Himalaya Men Power Glow Licorice Face Wash",
	  productPrice: "9.5",
	  productSupplier: "BCS SHOP",
	  searchText: "ফেইস ওয়াশ ",
	  sortOrder: "x",
	  sourceSupplier: "MUSTAFA CENTRE",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "100ML",
	  updateDateTime: "03/08/2020 05:43:44",
	  count: 1
	}, {
	  availability: "AVAILABLE",
	  category: "COSMETICS",
	  isPopular: "NO",
	  key: "-M9qi8NirqjB3PjCGJ1X",
	  photos: [{
	    imageName: "888520e0-aed3-11ea-8a8d-4f5b661598fc.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F888520e0-aed3-11ea-8a8d-4f5b661598fc.jpg?alt=media&token=330079ea-2946-4a4c-b20a-1d1809979bb0"
	  }],
	  productNameEnglish: "Nivea Multi-Effect 8 Oil Control Face Wash",
	  productPrice: "9.9",
	  productSupplier: "BCS SHOP",
	  searchText: "ফেইস ওয়াশ ",
	  sortOrder: "x",
	  sourceSupplier: "MUSTAFA CENTRE",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "100ML",
	  updateDateTime: "03/08/2020 05:48:30",
	  count: 1
	}, {
	  category: "SANITARY",
	  key: "-M9gIt0XRkIKwvG7mT3P",
	  photos: [{
	    imageName: "ce7664d0-ad3c-11ea-b044-d71d8f034373.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fce7664d0-ad3c-11ea-b044-d71d8f034373.jpg?alt=media&token=aab092f8-636b-46c0-b6df-f231cb4a47c8"
	  }],
	  productNameEnglish: "Toothbrush darlie charcoal clean    ",
	  productPrice: "5",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "1pc",
	  updateDateTime: "04/07/2020 10:21:04",
	  count: 1
	}, {
	  availability: "AVAILABLE",
	  category: "FRUITS VEGETABLES ",
	  isPopular: "YES",
	  key: "-MA4UgzmLJisWqpgWd3O",
	  photos: [{
	    imageName: "4df926a0-bdac-11ea-8ba8-ddb60ef370d4.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F4df926a0-bdac-11ea-8ba8-ddb60ef370d4.jpg?alt=media&token=2a248587-1839-4b03-8bef-5a2d1ef69bd3"
	  }],
	  productNameEnglish: "Curry Leaves",
	  productPrice: "1.60",
	  productSupplier: "BCS SHOP",
	  sortOrder: "a",
	  sourceSupplier: "Veg mart ",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "100G",
	  updateDateTime: "03/08/2020 04:21:36",
	  count: 1
	}, {
	  category: "DRINKS DESSERT",
	  key: "-M9b3SnWKBFpNCAcrE7G",
	  photos: [{
	    imageName: "1d14abb0-ac70-11ea-9366-875156fdc5b0.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F1d14abb0-ac70-11ea-9366-875156fdc5b0.jpg?alt=media&token=2c3a8293-dd81-4091-ad6a-d17764a3f6a3"
	  }],
	  productNameEnglish: " Orange juice drink  2litres ",
	  productPrice: "4.8",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "2L",
	  updateDateTime: "05/07/2020 12:15:42",
	  count: 1
	}, {
	  category: "TOILETRIES",
	  key: "-M9qW3hb6pRhivor4ItI",
	  photos: [{
	    imageName: "a205baa0-aecb-11ea-9cc0-814fbb741388.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fa205baa0-aecb-11ea-9cc0-814fbb741388.jpg?alt=media&token=a4a75886-cde8-4914-9068-bcb4393bb9ee"
	  }],
	  productNameEnglish: "Onwards Kitchen Towel Roll ",
	  productPrice: "6.50",
	  productSupplier: "BCS SHOP",
	  sortOrder: "k",
	  sourceSupplier: "Sheng siong ",
	  supplierContactName: "arif",
	  supplierContactPhone: "84124637",
	  unit: "8 rolls of 1 packet",
	  updateDateTime: "03/08/2020 06:04:40",
	  count: 1
	}, {
	  availability: "AVAILABLE",
	  category: "MEAT FISH",
	  key: "-M9bIu5zRY9p3Btp4DAn",
	  photos: [{
	    imageName: "980b7750-ac79-11ea-90b2-195942e61adb.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F980b7750-ac79-11ea-90b2-195942e61adb.jpg?alt=media&token=027ff7b0-fa85-49af-9498-9ec8277bee00"
	  }],
	  productNameEnglish: "Chicken nuggets 900gm 1packet ",
	  productPrice: "9",
	  productSupplier: "BCS SHOP",
	  searchText: "চিকেন নাগেট ",
	  sortOrder: "d",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "900gm",
	  updateDateTime: "17/07/2020 03:14:07",
	  count: 1
	}, {
	  category: "LAUNDRY CLEANING",
	  key: "-M9plDFNnX5i4BDGvIG7",
	  photos: [{
	    imageName: "6c1e77a0-aeae-11ea-9600-53e79e8cda87.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F6c1e77a0-aeae-11ea-9600-53e79e8cda87.jpg?alt=media&token=9a927ad4-8ecf-4547-98fd-19c87846e81b"
	  }],
	  productDescription: "(1.6l) REFILL",
	  productNameEnglish: "Softlan Anti-Wrinkles Fabric Conditioner",
	  productPrice: "3.90",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  sourceSupplier: "Sheng siong ",
	  supplierContactName: "arif",
	  supplierContactPhone: "84124637",
	  unit: "1 packet of 1.6L",
	  updateDateTime: "03/08/2020 06:31:40",
	  count: 1
	}, {
	  category: "TOILETRIES",
	  key: "-M9fDzi6Dop6f0UEozcs",
	  photos: [{
	    imageName: "aac5d590-ad12-11ea-9aab-f922f3904dfb.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Faac5d590-ad12-11ea-9aab-f922f3904dfb.jpg?alt=media&token=7b3936ca-bf59-4ffd-bdcd-d12fa3308775"
	  }],
	  productNameEnglish: "Cottony Kleenex 3ply B/T",
	  productPrice: "17",
	  productSupplier: "BCS SHOP",
	  searchText: "টিস্যু পেপার ",
	  sortOrder: "d",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  unit: "20roll x 1packet ",
	  updateDateTime: "17/07/2020 02:37:11",
	  count: 1
	}, {
	  category: "FRUITS VEGETABLES ",
	  key: "-M9b4LZs7VKuhHdtk47B",
	  photos: [{
	    imageName: "c71bbd60-ac70-11ea-83ef-037972cabc05.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fc71bbd60-ac70-11ea-83ef-037972cabc05.jpg?alt=media&token=519a77a1-35dc-43bd-8959-9129a6d6492c"
	  }],
	  productNameEnglish: "LONGAN",
	  productPrice: "3",
	  productSupplier: "BCS SHOP",
	  sortOrder: "d",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1 tin",
	  updateDateTime: "05/07/2020 12:09:56",
	  count: 1
	}, {
	  category: "COSMETICS",
	  key: "-M9gN5Ldhfx7tnCST-p7",
	  photos: [{
	    imageName: "724c0130-ad3f-11ea-b044-d71d8f034373.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F724c0130-ad3f-11ea-b044-d71d8f034373.jpg?alt=media&token=1774d9e1-0442-4b0a-bd3e-9bb6a16caef7"
	  }],
	  productNameEnglish: "Shaving foam denim foam black 300ml",
	  productPrice: "5.5",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  supplierContactName: "ARIF",
	  supplierContactPhone: "84124637",
	  updateDateTime: "04/07/2020 10:17:17",
	  count: 1
	}, {
	  availability: "AVAILABLE",
	  category: "COOKING OIL INGREDIENTS",
	  isPopular: "YES",
	  key: "-M9aTqdEuYIFo6kUyqf-",
	  photos: [{
	    imageName: "1cb17480-ac59-11ea-bbe4-619ccaa778ae.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F1cb17480-ac59-11ea-bbe4-619ccaa778ae.jpg?alt=media&token=7d33c4d9-a403-449c-a06b-9a44907e7357"
	  }],
	  productNameEnglish: "NUTMEG ",
	  productPrice: "1.50",
	  productSupplier: "BCS SHOP",
	  searchText: "জায়ফল",
	  sortOrder: "x",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1 pkt",
	  updateDateTime: "23/07/2020 12:49:03",
	  count: 1
	}, {
	  category: "LAUNDRY CLEANING",
	  key: "-M9pNpff9SWiowz5uO0H",
	  photos: [{
	    imageName: "8b742820-ae9f-11ea-9600-53e79e8cda87.jpg",
	    status: "DONE",
	    url: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F8b742820-ae9f-11ea-9600-53e79e8cda87.jpg?alt=media&token=41fa6fac-d443-4ba8-80a8-5e5aede36c4d"
	  }],
	  productNameEnglish: "TOP Concentrated Liquid Detergent Refill - Anti Bacterial",
	  productPrice: "4.95",
	  productSupplier: "BCS SHOP",
	  sortOrder: "x",
	  supplierContactName: "IQBAL",
	  supplierContactPhone: "89050302",
	  unit: "1.6Kg",
	  updateDateTime: "03/08/2020 06:43:03",
	  count: 1
	}];

/***/ }),
/* 356 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var tUsers = exports.tUsers = [{
	  author: "ahmed_fayyaz@outlook.com",
	  createDateTime: "11/08/2020, 6:40:50 pm",
	  forceWorker: "YES",
	  key: "-MERfafvtg7AdNWI-YBj",
	  recordType: "STANDARD USER",
	  roleName: "SUPERADMIN",
	  updateDateTime: "Wed 12-08-20 3:11 pm",
	  userAddress: "SG",
	  userCompany: "BCS SHOP",
	  userEmail: "ismita@bcs.com.sg",
	  userName: "Ismita"
	}, {
	  createDateTime: "03/08/2020, 2:02:56 pm",
	  forceWorker: "YES",
	  key: "-MDmUI_6VOQLD-DOBn64",
	  recordType: "STANDARD USER",
	  roleName: "STOREADMIN",
	  updateDateTime: "03/08/2020 02:03:48",
	  userAddress: "SG",
	  userCompany: "BCS SHOP",
	  userMobile: "91004975",
	  userName: "Samita"
	}, {
	  compIntoText: "BCS ",
	  createDateTime: "6/24/2020, 10:06:59 AM",
	  forceWorker: "",
	  key: "-MAZ4DNib4HJ3dfTdFRD",
	  recordType: "STANDARD USER",
	  roleName: "STOREADMIN",
	  updateDateTime: "Wed 05-08-20 12:32 pm",
	  userAddress: "12 lorong 14 geylang ",
	  userCompany: "BCS SHOP",
	  userMobile: "89059785",
	  userName: "RABIUL"
	}, {
	  createDateTime: "11/06/2020, 12:48:08",
	  forceWorker: "YES",
	  key: "-M9WGubQrQe6v-e09yS2",
	  recordType: "STANDARD USER",
	  roleName: "STOREADMIN",
	  updateDateTime: "19/06/2020 02:51:28",
	  userAddress: "SG",
	  userCompany: "BCS SHOP",
	  userMobile: "84124637",
	  userName: "ARIF"
	}, {
	  createDateTime: "11/06/2020, 12:46:46",
	  forceWorker: "YES",
	  key: "-M9WGaJFo5ekyw4nxHNT",
	  recordType: "STANDARD USER",
	  roleName: "STOREADMIN",
	  updateDateTime: "19/06/2020 02:25:18",
	  userAddress: "SG",
	  userCompany: "BCS SHOP",
	  userMobile: "89050302",
	  userName: "IQBAL"
	}, {
	  bgImage: "bcsshot",
	  compIntoText: "Home cook Bangladeshi food for family events at a reasonable price. ",
	  createDateTime: "06/06/2020, 03:05:42",
	  forceWorker: "",
	  key: "-M94Rpcyodb7D6vx3MQQ",
	  recordType: "STANDARD USER",
	  roleName: "STOREADMIN",
	  sortOrder: "9",
	  updateDateTime: "29/06/2020 06:35:47",
	  userAddress: "AU",
	  userCompany: "",
	  userMobile: "97861234",
	  userName: "Ahmed Test"
	}, {
	  action1: "openBazarList",
	  bgImage: "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F67446270-b1c5-11ea-b3a7-b78f6358f9d9.jpg?alt=media&token=119bb924-d06c-4fb0-9b5e-b2f83c51de82",
	  btn1Text: "ENTER OPEN BAZAR NOW",
	  compIntoText: "ENTER",
	  createDateTime: "06/06/2020, 01:10:34",
	  forceWorker: "YES",
	  key: "-M941QVE3u0_jRZg1gAO",
	  promoDescription: "Ask or offer help, buy, Sell and share the joy",
	  promoHeader: "OPEN BAZAR",
	  recordType: "PROMOTIONAL",
	  roleName: "WORKER",
	  sortOrder: "2",
	  tableName: "openBazar",
	  updateDateTime: "01/07/2020 12:13:27",
	  userAddress: "SG",
	  userCompany: "",
	  userName: "OPEN BAZAR"
	}, {
	  action1: "shopFromASupplier",
	  action2: "orderlist",
	  bgImage: "bcsshop",
	  btn1Text: "SHOP NOW",
	  btn2Text: "VIEW ORDERS",
	  compIntoText: "SHOP NOW",
	  createDateTime: "06/06/2020, 01:07:01",
	  forceWorker: "YES",
	  key: "-M9417tDiDRdz8761a1M",
	  promoDescription: "Tap Shop Now or call us at +65 9456 2455 ",
	  promoHeader: "BUY GROCERY AND MORE",
	  recordType: "PROMOTIONAL",
	  roleName: "WORKER",
	  sortOrder: "1",
	  tableName: "supplierShopItems",
	  tableName2: "deliveryRequest",
	  updateDateTime: "01/07/2020 04:04:44",
	  userAddress: "SG",
	  userCompany: "BCS SHOP",
	  userName: "BCS SHOP"
	}, {
	  author: "ahmed_fayyaz@outlook.com",
	  createDateTime: "20/05/2020, 23:36:23",
	  password: "review",
	  roleName: "STOREADMIN",
	  updateDateTime: "20/05/2020 11:37:49",
	  userAddress: "US",
	  userCompany: "APPLE",
	  userEmail: "apple@bcs.com",
	  userMobile: "98764444",
	  userName: "Apple Review",
	  key: "-M7mIUIObJ5zQjme1Chz"
	}, {
	  createDateTime: "20/05/2020, 19:55:28",
	  key: "-M7mIR64HDztc9hUpkqB",
	  password: "p123456",
	  recordType: "",
	  roleName: "STOREADMIN",
	  updateDateTime: "11/06/2020 12:45:26",
	  userAddress: "35 Desker road Singapore 206795",
	  userCompany: "KASH PHUL PTE LTD",
	  userDesignation: "Manager ",
	  userEmail: "kashphul@bcs.com",
	  userFin: "G3257975u",
	  userMobile: "98918844",
	  userName: "Sam ",
	  userNationality: "BANGLADESH"
	}, {
	  author: "ahmed_fayyaz@outlook.com",
	  createDateTime: "19/05/2020, 00:15:04",
	  password: "p123456",
	  roleName: "STOREADMIN",
	  updateDateTime: "19/05/2020 12:16:10",
	  userAddress: "sg",
	  userCompany: "Live TV (Coming Soon)",
	  userEmail: "supp1@bcs.com",
	  userMobile: "97861239",
	  userName: "Ahmed",
	  userNationality: "SINGAPORE",
	  key: "-M7c84iK3kpjcX-RErH4"
	}, {
	  createDateTime: "18/05/2020, 12:12:18",
	  key: "-M7_Yf3DkOc9msPgzNKW",
	  password: "ferdous1",
	  recordType: "",
	  roleName: "STOREADMIN",
	  sortOrder: "5",
	  updateDateTime: "11/06/2020 12:43:38",
	  userAddress: "Ferdous Khan Products Grocery",
	  userCompany: "FERDOUS KHAN PRODUCTS GROCERY",
	  userEmail: "ferdous@bcs.com",
	  userMobile: "98537192",
	  userName: "Ferdous Khan"
	}, {
	  author: "ahmed_fayyaz@outlook.com",
	  createDateTime: "14/05/2020, 00:11:02",
	  password: "review1",
	  roleName: "STOREADMIN",
	  updateDateTime: "14/05/2020 12:12:00",
	  userAddress: "review",
	  userCompany: "Google",
	  userEmail: "review@bcs.com",
	  userMobile: "98764444",
	  userName: "Google Reviewer",
	  key: "-M7DNAn9Ojwl2_Xhhtwq"
	}, {
	  createDateTime: "13/05/2020, 18:42:05",
	  key: "-M7CCBK63TQATDLysfci",
	  password: "tanmoy1",
	  recordType: "",
	  roleName: "STOREADMIN",
	  sortOrder: "4",
	  updateDateTime: "11/06/2020 12:43:53",
	  userAddress: "Tanmoy SG",
	  userCompany: "TANMOY",
	  userEmail: "tanmoy@bcs.com",
	  userMobile: "96220740",
	  userName: "Moni"
	}, {
	  author: "ahmed_fayyaz@outlook.com",
	  createDateTime: "12/05/2020, 15:37:43",
	  password: "donnie100",
	  roleName: "ORDERADMIN",
	  updateDateTime: "12/05/2020 03:38:53",
	  userAddress: "SG",
	  userCompany: "Donnie",
	  userEmail: "donnie@bcs.com",
	  userMobile: "86693532",
	  userName: "Donnie",
	  key: "-M76O8hvM4XAOcwB7zMT"
	}, {
	  createDateTime: "12/05/2020, 15:34:00",
	  key: "-M76NCv43POTmJsAagwB",
	  password: "p123456",
	  roleName: "STOREADMIN",
	  updateDateTime: "16/06/2020 07:36:08",
	  userAddress: "SG",
	  userCompany: "BCS SHOP",
	  userEmail: "kabir@bcs.com",
	  userMobile: "94562455",
	  userName: "Kabir"
	}, {
	  createDateTime: "11/05/2020, 13:41:36",
	  key: "-M70ozM98C0SlaHVaj0W",
	  password: "lamiah",
	  recordType: "",
	  roleName: "STOREADMIN",
	  sortOrder: "6",
	  updateDateTime: "11/06/2020 12:43:59",
	  userAddress: "Tuas south ave 6 Singapore 637779",
	  userCompany: "Lamiah Enterprise Pte Ltd",
	  userEmail: "lamiah@bcs.com",
	  userMobile: "82206632",
	  userName: "Lamiah Enterprise Pte Ltd"
	}, {
	  author: "ahmed_fayyaz@outlook.com",
	  createDateTime: "27/04/2020, 18:11:24",
	  password: "foodPass",
	  roleName: "WORKER",
	  updateDateTime: "27/04/2020 06:12:18",
	  userAddress: "some address",
	  userCompany: "BROOKLYNZ STAINLESS STEEL PTE LTD",
	  userDesignation: "",
	  userEmail: "worker@worker.com.sg",
	  userFin: "",
	  userMobile: "",
	  userName: "WORKERS",
	  userNationality: "",
	  userWorkPermit: "",
	  key: "-M5ugPqf18ttmq9ZsiP-"
	}, {
	  key: "1",
	  password: "sdf",
	  recordType: "STANDARD USER",
	  roleName: "SUPERADMIN",
	  updateDateTime: "15/06/2020 05:37:33",
	  userAddress: "Sydney Australia",
	  userCompany: "BCS SHOP",
	  userDesignation: "Technology",
	  userEmail: "ahmed_fayyaz@outlook.com",
	  userEmployeeId: "0",
	  userFin: "G6050046R",
	  userMobile: "97861239",
	  userName: "Ahmed Fayyaz",
	  userNotes: "some notes again",
	  userWorkPermit: "NA"
	}, {
	  createDateTime: "",
	  key: "0",
	  lastAction: "",
	  recordType: "STANDARD USER",
	  roleName: "STOREADMIN",
	  sortDateTime: 8469394345473,
	  updateDateTime: "30/06/2020 10:53:05",
	  userAddress: "sg",
	  userCompany: "TECHNO STEEL",
	  userDesignation: "Technlogy",
	  userEmail: "ahmed_fayyaz2@outlook.com",
	  userEmployeeId: "XXX",
	  userMobile: "+923465379140",
	  userName: "Ahmed Fayyaz",
	  userNotes: "some thing"
	}];

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.resetRedux = exports.actionDeleteARecord = exports.clearAllExistingRecords = exports.actionUpdateRecord2Redux = exports.actionAddArray2Redux = exports.actionAddRecord2Redux = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.reachApi = reachApi;
	exports.reachApiExtended = reachApiExtended;
	exports.fetchDistance = fetchDistance;
	exports.uploadPhoto = uploadPhoto;
	exports.deletePhoto = deletePhoto;
	exports.getAcctStatement = getAcctStatement;
	exports.getAcctBalance = getAcctBalance;
	exports.loadAllStats = loadAllStats;
	exports.notifyUsers = notifyUsers;
	exports.fetchRecords = fetchRecords;
	exports.initialProductsFetch = initialProductsFetch;
	exports.initialFetch = initialFetch;
	exports.loadFbData = loadFbData;
	exports.setupUsers = setupUsers;
	exports.getId = getId;
	exports.getStatement = getStatement;
	exports.getStatementB64 = getStatementB64;
	exports.fetchStats = fetchStats;
	exports.addRecord = addRecord;
	exports.updateRecord = updateRecord;
	exports.deleteRecord = deleteRecord;
	exports.selectARecord = selectARecord;
	exports.actionAddSingleRecord = actionAddSingleRecord;
	exports.initSelectedRecord = initSelectedRecord;
	
	var _actionTypes = __webpack_require__(80);
	
	var _index = __webpack_require__(13);
	
	var _ui = __webpack_require__(160);
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__(900);
	
	var _dbGetRecords = __webpack_require__(342);
	
	var _dbGetRecords2 = _interopRequireDefault(_dbGetRecords);
	
	var _getFbRtData = __webpack_require__(345);
	
	var _getFbRtData2 = _interopRequireDefault(_getFbRtData);
	
	var _dbAddRecord = __webpack_require__(339);
	
	var _dbAddRecord2 = _interopRequireDefault(_dbAddRecord);
	
	var _dbUpdateRecord = __webpack_require__(343);
	
	var _dbUpdateRecord2 = _interopRequireDefault(_dbUpdateRecord);
	
	var _dbDeleteRecord = __webpack_require__(340);
	
	var _dbDeleteRecord2 = _interopRequireDefault(_dbDeleteRecord);
	
	var _dbGetStatement = __webpack_require__(348);
	
	var _dbGetStatement2 = _interopRequireDefault(_dbGetStatement);
	
	var _dbGetStatementB = __webpack_require__(349);
	
	var _dbGetStatementB2 = _interopRequireDefault(_dbGetStatementB);
	
	var _dbGetAutoId = __webpack_require__(341);
	
	var _dbGetAutoId2 = _interopRequireDefault(_dbGetAutoId);
	
	var _rawState = __webpack_require__(62);
	
	var _sendNotificationToASegment = __webpack_require__(346);
	
	var _sendSingleUserANotification = __webpack_require__(347);
	
	var _configureStore = __webpack_require__(23);
	
	var _configureStore2 = _interopRequireDefault(_configureStore);
	
	var _getDistance = __webpack_require__(344);
	
	var _getDistance2 = _interopRequireDefault(_getDistance);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	//import { logger } from "../../app/utils/utils.js";
	
	
	/*========================================================================
	passport scan operations
	==========================================================================*/
	
	//GET PHOTO TEXT
	function reachApi(objContents) {
	  var _this = this;
	
	  //console.log('fbRegisterUser: ' + userId + ' ' + password);
	  //alert(JSON.stringify(objContents));
	  return function () {
	    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch) {
	      var onSuccess, onError, headers, message, fetchQuery;
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              onError = function onError(error) {
	                return error;
	              };
	
	              onSuccess = function onSuccess(success) {
	                //console.log("darn it now...");
	                return success;
	              };
	
	              dispatch((0, _index.setUiFlag)("mainLoadMessage", "Processing ID..."));
	              headers = objContents.headers;
	              message = objContents.message;
	              //alert(JSON.stringify(arrExternalUserIds));
	
	              fetchQuery = objContents.fetchQuery;
	              _context.next = 8;
	              return fetch(fetchQuery, {
	                method: objContents.method,
	                body: message,
	                headers: headers
	              }).then(function (res) {
	                return res.json();
	              }).then(function (parsedRes) {
	                //alert(JSON.stringify(parsedRes));
	                dispatch(actionAddSingleRecord({
	                  path: objContents.path,
	                  payload: parsedRes
	                }));
	                dispatch((0, _index.setUiFlag)("idScanInProgress", false));
	                return onSuccess(parsedRes);
	              }).catch(function (err) {
	                alert("We are unable to complete your request at this time, please check your network connection or contact support. " + err);
	                return onError(err);
	                ////console.log("We are unable to complete your request at this time, please check your network connection or contact support.[dbAddRecord"+data.path+"]["+err+"]");
	              });
	
	            case 8:
	            case "end":
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }));
	
	    return function (_x) {
	      return _ref.apply(this, arguments);
	    };
	  }();
	}
	
	//GET PHOTO TEXT
	function reachApiExtended(objContents) {
	  return function (dispatch) {
	    var headers = objContents.headers;
	    var message = objContents.message;
	    var fetchQuery = objContents.fetchQuery;
	    fetch(fetchQuery, {
	      method: objContents.method,
	      body: message,
	      headers: headers
	    }).then(function (res) {
	      return res.json();
	    }).then(function (parsedRes) {
	      dispatch(actionAddSingleRecord({
	        path: objContents.path,
	        payload: parsedRes
	      }));
	      return "";
	    }).catch(function (err) {
	      return err;
	      ////console.log("We are unable to complete your request at this time, please check your network connection or contact support.[dbAddRecord"+data.path+"]["+err+"]");
	    });
	  };
	}
	/*========================================================================
	google maps operations
	==========================================================================*/
	
	//GET DISTANCE
	function fetchDistance(origin, destination) {
	  var _this2 = this;
	
	  return function () {
	    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch) {
	      var onSuccess, onError;
	      return regeneratorRuntime.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              onError = function onError(error) {
	                return error;
	              };
	
	              onSuccess = function onSuccess(success) {
	                return success;
	              };
	
	              _context2.prev = 2;
	
	              dispatch((0, _getDistance2.default)(origin, destination)).then(function (returnData) {
	                if (returnData && returnData !== undefined) {
	                  //logger("DEBUG", "fetchRecords(" + data.path + ")", "Adding :" + JSON.stringify(returnData.length + " items"));
	                  dispatch(actionAddSingleRecord({ path: "distance", payload: returnData }));
	
	                  return onSuccess(returnData);
	                }
	              });
	              _context2.next = 10;
	              break;
	
	            case 6:
	              _context2.prev = 6;
	              _context2.t0 = _context2["catch"](2);
	
	              console.log("Some error: " + _context2.t0);
	              return _context2.abrupt("return", onError(_context2.t0));
	
	            case 10:
	            case "end":
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this2, [[2, 6]]);
	    }));
	
	    return function (_x2) {
	      return _ref2.apply(this, arguments);
	    };
	  }();
	}
	
	/*========================================================================
	photo operations
	==========================================================================*/
	
	//UPLOAD PHOTO
	function uploadPhoto(firebase, imageName, imagePath, photoBlob, dbKey, cloudPath) {
	  var _this3 = this;
	
	  return function () {
	    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(dispatch) {
	      var onSuccess, onError, bucketRef;
	      return regeneratorRuntime.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              onError = function onError(error) {
	                return error;
	              };
	
	              onSuccess = function onSuccess(success) {
	                console.log("success from upload: " + success);
	                return success;
	              };
	
	              _context3.prev = 2;
	              bucketRef = firebase.storage.ref(imagePath + "/" + imageName).put(photoBlob);
	
	
	              bucketRef.on("state_changed", function (snapshot) {
	                //progress
	              }, function (error) {
	                console.log(error);
	              }, function () {
	                //completed
	                firebase.storage.ref(imagePath).child(imageName).getDownloadURL().then(function (url) {
	                  //save url to db here
	
	                  firebase.db.ref("/" + cloudPath + "/" + dbKey).once("value").then(function (snap) {
	                    var resRef = snap.val();
	                    var res = _.cloneDeep(resRef);
	                    var tgtImage = res.photos.find(function (item) {
	                      return item.imageName === imageName;
	                    });
	                    if (tgtImage && tgtImage !== undefined) {
	                      tgtImage.url = url;
	                      tgtImage.status = "DONE";
	                    }
	
	                    return snap.ref.set(res);
	                  }).catch(function (err) {
	                    console.log(err);
	                    console.log("some error: " + err);
	                  }).then(function (err) {});
	                });
	              });
	
	              return _context3.abrupt("return", onSuccess("some url"));
	
	            case 8:
	              _context3.prev = 8;
	              _context3.t0 = _context3["catch"](2);
	
	              console.log("Some error: " + _context3.t0);
	              return _context3.abrupt("return", onError(_context3.t0));
	
	            case 12:
	            case "end":
	              return _context3.stop();
	          }
	        }
	      }, _callee3, _this3, [[2, 8]]);
	    }));
	
	    return function (_x3) {
	      return _ref3.apply(this, arguments);
	    };
	  }();
	}
	
	function deletePhoto(firebase, imageName, imagePath, dbKey, cloudPath) {
	  var _this4 = this;
	
	  return function () {
	    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(dispatch) {
	      var onSuccess, onError, bucketRef;
	      return regeneratorRuntime.wrap(function _callee4$(_context4) {
	        while (1) {
	          switch (_context4.prev = _context4.next) {
	            case 0:
	              onError = function onError(error) {
	                return error;
	              };
	
	              onSuccess = function onSuccess(success) {
	                console.log("success from upload: " + success);
	                return success;
	              };
	
	              _context4.prev = 2;
	
	              //console.log(imageName);
	              bucketRef = firebase.storage.ref().child(imagePath + "/" + imageName);
	
	
	              bucketRef.delete().then(function () {
	                if (dbKey && dbKey !== null && cloudPath && cloudPath !== null) {
	                  firebase.db.ref("/" + cloudPath + "/" + dbKey).once("value").then(function (snap) {
	                    var resRef = snap.val();
	                    var res = _.cloneDeep(resRef);
	                    var newArray = res.photos.filter(function (item) {
	                      return item.imageName !== imageName;
	                    });
	
	                    res.photos = newArray;
	
	                    return snap.ref.set(res);
	                  }).catch(function (err) {
	                    console.log(err);
	                    console.log("some error: " + err);
	                  }).then(function (err) {});
	                }
	              }).catch(function (error) {
	                console.log(error);
	              });
	
	              return _context4.abrupt("return", onSuccess("some url"));
	
	            case 8:
	              _context4.prev = 8;
	              _context4.t0 = _context4["catch"](2);
	
	              console.log("Some error: " + _context4.t0);
	              return _context4.abrupt("return", onError(_context4.t0));
	
	            case 12:
	            case "end":
	              return _context4.stop();
	          }
	        }
	      }, _callee4, _this4, [[2, 8]]);
	    }));
	
	    return function (_x4) {
	      return _ref4.apply(this, arguments);
	    };
	  }();
	}
	
	/*========================================================================
	accounting operations
	==========================================================================*/
	
	//GEN AUTO ID
	function getAcctStatement(reqParams) {
	  var _this5 = this;
	
	  /*
	   receives:
	  {
	    accIdArry:[{accName: 'xxx'}]
	    fromDate: DD-MM-YYYY,
	    toDate: DD-MM-YYYY,
	  }
	   */
	  return function () {
	    var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(dispatch) {
	      var onSuccess, onError, db, success, finalResults, i, accName, acctEntries;
	      return regeneratorRuntime.wrap(function _callee5$(_context5) {
	        while (1) {
	          switch (_context5.prev = _context5.next) {
	            case 0:
	              onError = function onError(error) {
	                return error;
	              };
	
	              onSuccess = function onSuccess(success) {
	                return success;
	              };
	
	              _context5.prev = 2;
	              db = _configureStore2.default.getState().db;
	              success = {};
	              finalResults = [];
	
	              if (!(db && db.accounts && db.accounts.length > 0)) {
	                _context5.next = 18;
	                break;
	              }
	
	              i = 0;
	
	            case 8:
	              if (!(i < reqParams.accIdArray.length)) {
	                _context5.next = 17;
	                break;
	              }
	
	              accName = reqParams.accIdArray[i].accName;
	              _context5.next = 12;
	              return getStmtEntry(accName, db, reqParams);
	
	            case 12:
	              acctEntries = _context5.sent;
	
	              finalResults = finalResults.concat(acctEntries);
	
	            case 14:
	              i++;
	              _context5.next = 8;
	              break;
	
	            case 17:
	              success = finalResults;
	
	            case 18:
	              return _context5.abrupt("return", onSuccess(success));
	
	            case 21:
	              _context5.prev = 21;
	              _context5.t0 = _context5["catch"](2);
	
	              console.log("Some error: " + _context5.t0);
	              return _context5.abrupt("return", onError(_context5.t0));
	
	            case 25:
	            case "end":
	              return _context5.stop();
	          }
	        }
	      }, _callee5, _this5, [[2, 21]]);
	    }));
	
	    return function (_x5) {
	      return _ref5.apply(this, arguments);
	    };
	  }();
	}
	
	var getStmtEntry = function () {
	  var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(accName, db, reqParams) {
	    var tgtAccount, allEntries, rules, j, singleRule, ruleResults;
	    return regeneratorRuntime.wrap(function _callee6$(_context6) {
	      while (1) {
	        switch (_context6.prev = _context6.next) {
	          case 0:
	            //iterate through rules
	            //collect entries
	            //combine and sort
	            tgtAccount = db.accounts.find(function (item) {
	              return item.accountName === accName;
	            });
	
	            if (!(tgtAccount && tgtAccount !== undefined)) {
	              _context6.next = 18;
	              break;
	            }
	
	            allEntries = [];
	            rules = tgtAccount.accountingRules;
	            j = 0;
	
	          case 5:
	            if (!(j < rules.length)) {
	              _context6.next = 14;
	              break;
	            }
	
	            singleRule = rules[j];
	            _context6.next = 9;
	            return getEntriesForRule(accName, db, singleRule, reqParams);
	
	          case 9:
	            ruleResults = _context6.sent;
	
	            //console.log("rulesResult: " + JSON.stringify(ruleResults));
	            allEntries = allEntries.concat(ruleResults);
	
	          case 11:
	            j++;
	            _context6.next = 5;
	            break;
	
	          case 14:
	            if (allEntries.length > 0) {
	              allEntries = _.chain(allEntries).sortBy("jsDate").reverse().value();
	            }
	            //console.log("allEntries: " + JSON.stringify(allEntries));
	            return _context6.abrupt("return", allEntries);
	
	          case 18:
	            return _context6.abrupt("return", []);
	
	          case 19:
	          case "end":
	            return _context6.stop();
	        }
	      }
	    }, _callee6, undefined);
	  }));
	
	  return function getStmtEntry(_x6, _x7, _x8) {
	    return _ref6.apply(this, arguments);
	  };
	}();
	
	var getEntriesForRule = function () {
	  var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(accName, db, singleRule, reqParams) {
	    var finalResult, tgtTable, accEntries;
	    return regeneratorRuntime.wrap(function _callee7$(_context7) {
	      while (1) {
	        switch (_context7.prev = _context7.next) {
	          case 0:
	            //table
	            //direction
	            //amount field
	            //match field
	            //start date
	            //end date
	            finalResult = [];
	            tgtTable = db[singleRule.targetTable];
	            accEntries = tgtTable.filter(function (tgtRec) {
	              var filterResult = true;
	              //check for match field
	              if (singleRule.matchField && tgtRec[singleRule.matchField] && tgtRec[singleRule.matchField] !== accName) {
	                filterResult = false;
	              }
	              //check date
	              var recDate = tgtRec[singleRule.acctDateField];
	              var momRecDate = (0, _moment2.default)(recDate, "DD-MM-YYYY");
	              var momStDate = (0, _moment2.default)(reqParams.fromDate, "DD-MM-YYYY");
	              var momEndDate = (0, _moment2.default)(reqParams.endDate, "DD-MM-YYYY");
	              if (!momRecDate.isBetween(momStDate, momEndDate, "[]", "minute")) {
	                filterResult = false;
	              }
	              return filterResult;
	            });
	
	            if (!(accEntries && accEntries.length > 0)) {
	              _context7.next = 8;
	              break;
	            }
	
	            finalResult = accEntries.map(function (item) {
	              return {
	                side: singleRule.accSide,
	                amount: item[singleRule.amountField],
	                date: item[singleRule.acctDateField],
	                description: item[singleRule.referenceField],
	                jsDate: (0, _moment2.default)(item[singleRule.acctDateField], "DD-MM-YYYY")
	              };
	            });
	            return _context7.abrupt("return", finalResult);
	
	          case 8:
	            return _context7.abrupt("return", []);
	
	          case 9:
	          case "end":
	            return _context7.stop();
	        }
	      }
	    }, _callee7, undefined);
	  }));
	
	  return function getEntriesForRule(_x9, _x10, _x11, _x12) {
	    return _ref7.apply(this, arguments);
	  };
	}();
	
	//GEN AUTO ID
	function getAcctBalance(reqParams) {
	  var _this6 = this;
	
	  /*
	   receives:
	  {
	    accIdArry:[{accName: 'xxx'}]
	    fromDate: DD-MM-YYYY,
	    toDate: DD-MM-YYYY,
	  }
	   */
	  return function () {
	    var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(dispatch) {
	      var onSuccess, onError, db, success, tmpArray, i, accName, acctEntries, _i, currIndex, prevIndex, currNetDebit, currNetCredit, prevClosingDebit, prevClosingCredit, runningDebit, runningCredit;
	
	      return regeneratorRuntime.wrap(function _callee8$(_context8) {
	        while (1) {
	          switch (_context8.prev = _context8.next) {
	            case 0:
	              onError = function onError(error) {
	                return error;
	              };
	
	              onSuccess = function onSuccess(success) {
	                return success;
	              };
	
	              _context8.prev = 2;
	              db = _configureStore2.default.getState().db;
	              success = {};
	              tmpArray = [];
	
	              if (!(db && db.accounts && db.accounts.length > 0)) {
	                _context8.next = 19;
	                break;
	              }
	
	              i = 0;
	
	            case 8:
	              if (!(i < reqParams.accIdArray.length)) {
	                _context8.next = 18;
	                break;
	              }
	
	              accName = reqParams.accIdArray[i].accName;
	              _context8.next = 12;
	              return getStmtEntry(accName, db, reqParams);
	
	            case 12:
	              acctEntries = _context8.sent;
	
	
	              tmpArray = _.chain(acctEntries).groupBy("date").map(function (value, key) {
	                return {
	                  date: key,
	                  jsDate: (0, _moment2.default)(key, "DD-MM-YYYY"),
	                  debit: _.chain(value).filter(function (item) {
	                    return item.side === "DEBIT";
	                  }).reduce(function (sum, curr, index) {
	                    var amt = parseFloat(curr.amount);
	                    sum = sum + amt;
	                    if (sum > 0) {
	                      sum = parseFloat(sum.toFixed(2));
	                    }
	                    return sum;
	                  }, 0).value(),
	                  credit: _.chain(value).filter(function (item) {
	                    return item.side === "CREDIT";
	                  }).reduce(function (sum, curr, index) {
	                    var amt = parseFloat(curr.amount);
	                    sum = sum + amt;
	                    if (sum > 0) {
	                      sum = parseFloat(sum.toFixed(2));
	                    }
	                    return sum;
	                  }, 0).value()
	                };
	              }).map(function (item) {
	                return _extends({}, item, {
	                  netDebit: item.debit > item.credit ? parseFloat((item.debit - item.credit).toFixed(2)) : 0,
	                  netCredit: item.credit > item.debit ? parseFloat((item.credit - item.debit).toFixed(2)) : 0
	                });
	              }).reverse().value();
	
	              for (_i = 0; _i < tmpArray.length; _i++) {
	                if (_i === 0) {
	                  tmpArray[_i].closingDebitBalance = tmpArray[_i].netDebit;
	                  tmpArray[_i].closingCreditBalance = tmpArray[_i].netCredit;
	                } else {
	                  currIndex = _i;
	                  prevIndex = _i - 1;
	                  currNetDebit = tmpArray[currIndex].netDebit;
	                  currNetCredit = tmpArray[currIndex].netCredit;
	                  prevClosingDebit = tmpArray[prevIndex].closingDebitBalance;
	                  prevClosingCredit = tmpArray[prevIndex].closingCreditBalance;
	                  runningDebit = currNetDebit + prevClosingDebit;
	                  runningCredit = currNetCredit + prevClosingCredit;
	
	                  tmpArray[_i].closingDebitBalance = runningDebit > runningCredit ? parseFloat((runningDebit - runningCredit).toFixed(2)) : 0;
	                  tmpArray[_i].closingCreditBalance = runningCredit > runningDebit ? parseFloat((runningCredit - runningDebit).toFixed(2)) : 0;
	                }
	              }
	
	            case 15:
	              i++;
	              _context8.next = 8;
	              break;
	
	            case 18:
	              success = tmpArray.reverse();
	
	            case 19:
	              return _context8.abrupt("return", onSuccess(success));
	
	            case 22:
	              _context8.prev = 22;
	              _context8.t0 = _context8["catch"](2);
	
	              console.log("Some error: " + _context8.t0);
	              return _context8.abrupt("return", onError(_context8.t0));
	
	            case 26:
	            case "end":
	              return _context8.stop();
	          }
	        }
	      }, _callee8, _this6, [[2, 22]]);
	    }));
	
	    return function (_x13) {
	      return _ref8.apply(this, arguments);
	    };
	  }();
	}
	
	/*========================================================================
	Firebase related complex operations, multiple updates
	==========================================================================*/
	
	function loadAllStats(parsedRes) {
	  return function (dispatch) {};
	}
	
	function notifyUsers(msgBody, arrayOfUserIds, sendToAll) {
	  var _this7 = this;
	
	  return function () {
	    var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(dispatch) {
	      var onSuccess, onError;
	      return regeneratorRuntime.wrap(function _callee9$(_context9) {
	        while (1) {
	          switch (_context9.prev = _context9.next) {
	            case 0:
	              onError = function onError(error) {
	                return error;
	              };
	
	              onSuccess = function onSuccess(success) {
	                //console.log(tableName + ": Total Records: " + success.length);
	                return success;
	              };
	
	              _context9.prev = 2;
	
	              if (true) {
	                if (sendToAll) {
	                  //console.log("sending to segment skipped");
	                  (0, _sendNotificationToASegment.sendNotificationToASegment)({ en: msgBody }, ["Subscribed Users"]);
	                } else {
	                  //console.log("sending to users: " + JSON.stringify(arrayOfUserIds));
	                  (0, _sendSingleUserANotification.sendSingleUserANotification)({ en: msgBody }, arrayOfUserIds);
	                }
	              }
	              return _context9.abrupt("return", onSuccess(true));
	
	            case 7:
	              _context9.prev = 7;
	              _context9.t0 = _context9["catch"](2);
	
	              console.log("Some error: " + _context9.t0);
	              return _context9.abrupt("return", onError(_context9.t0));
	
	            case 11:
	            case "end":
	              return _context9.stop();
	          }
	        }
	      }, _callee9, _this7, [[2, 7]]);
	    }));
	
	    return function (_x14) {
	      return _ref9.apply(this, arguments);
	    };
	  }();
	}
	
	//READ ALL RECORDS FROM A TARGET TABLE
	function fetchRecords(isNotPull, data, idToken, criteria, isCustomPath, fieldsArray) {
	  //logger("DEBUG", "fetchRecords(" + data.path + ")", ">>Criteria :" + JSON.stringify(criteria)+" isCustomPath: "+isCustomPath);
	  //console.log('getHours received: '+isCustomPath);
	  if (isCustomPath === undefined || isCustomPath === "") {
	    //console.log(data.path+' setting customPath to false, when recvd val was: '+isCustomPath);
	    isCustomPath = false;
	  }
	  return function (dispatch) {
	    //console.log("fetchRecords: got token from authGetToken ");
	    if (isNotPull) {
	      //console.log("starting loader");
	      dispatch((0, _index.uiStartLoading)());
	    } else {
	      //console.log("It's a pull refresh");
	    }
	    dispatch(clearAllExistingRecords(data));
	    dispatch((0, _dbGetRecords2.default)(data.path, idToken, criteria, isCustomPath, fieldsArray)).then(function (returnData) {
	      if (returnData && returnData !== undefined) {
	        //logger("DEBUG", "fetchRecords(" + data.path + ")", "Adding :" + JSON.stringify(returnData.length + " items"));
	        dispatch(actionAddArray2Redux({ path: data.path, payload: returnData }));
	
	        dispatch((0, _ui.uiStopLoading)());
	        //logger("DEBUG", "fetchRecords(" + data.path + ")", "Successful fetch: " + data.path);
	        return returnData;
	      }
	    }).catch(function (err) {
	      //logger("BASIC", "fetchRecords(" + data.path + ")", "Some error fetching data" + err);
	      alert("Not able to completed your request. Please check network connection and try again. " + err + " REQU: " + JSON.stringify(data));
	      dispatch(_ui.uiStopLoading);
	    });
	  };
	}
	
	function initialProductsFetch(url, accessToken) {
	  return function (dispatch) {
	    //console.log(url);
	    //console.log(moment().format("x") + " db initial loading s1 " + tableName);
	
	    dispatch((0, _getFbRtData2.default)(url, accessToken)).then(function (returnData) {
	      if (returnData && returnData !== undefined) {
	        var tmpArray = Object.keys(returnData).map(function (key) {
	          return _extends({}, returnData[key], {
	            key: key
	          });
	        });
	        tmpArray = tmpArray.reverse();
	        console.log(JSON.stringify(tmpArray));
	        dispatch(actionAddArray2Redux({
	          path: "supplierShopItems",
	          payload: tmpArray
	        }));
	        var groupedProds = _.chain(tmpArray).groupBy("category").value();
	        Object.keys(groupedProds).map(function (key) {
	          if (key !== "POPULAR" && key !== undefined) {
	            dispatch(actionAddArray2Redux({ path: key, payload: groupedProds[key] }));
	          }
	        });
	
	        return "";
	      } else {
	        console.log("db initial loading s1 " + tableName + " loaded nothing");
	      }
	    }).catch(function (err) {
	      console.log("db initial loading s1 " + tableName + " " + err);
	    });
	  };
	}
	
	function initialFetch(tableName, url, accessToken) {
	  return function (dispatch) {
	    //console.log(url);
	    //console.log(moment().format("x") + " db initial loading s1 " + tableName);
	
	    dispatch((0, _getFbRtData2.default)(url, accessToken)).then(function (returnData) {
	      if (returnData && returnData !== undefined) {
	        //logger("DEBUG", "fetchRecords(" + data.path + ")", "Adding :" + JSON.stringify(returnData.length + " items"));
	        // console.log(
	        //   moment().format("x") +
	        //     " db initial loading s1 " +
	        //     tableName +
	        //     " rcvd data"
	        // );
	        var tmpArray = Object.keys(returnData).map(function (key) {
	          return _extends({}, returnData[key], {
	            key: key
	          });
	        });
	        tmpArray = tmpArray.reverse();
	
	        dispatch(actionAddArray2Redux({ path: tableName, payload: tmpArray }));
	
	        return "";
	      } else {
	        console.log("db initial loading s1 " + tableName + " loaded nothing");
	      }
	    }).catch(function (err) {
	      console.log("db initial loading s1 " + tableName + " " + err);
	    });
	  };
	}
	
	function loadFbData(tableName, firebase, onceOnly, subPath, singleObj) {
	  var _this8 = this;
	
	  return function () {
	    var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(dispatch) {
	      var onSuccess, onError, tgtFbTable, tmpArray, fbOject, revArray, _tmpArray, _fbOject, finRes;
	
	      return regeneratorRuntime.wrap(function _callee10$(_context10) {
	        while (1) {
	          switch (_context10.prev = _context10.next) {
	            case 0:
	              onError = function onError(error) {
	                return error;
	              };
	
	              onSuccess = function onSuccess(success) {
	                // console.log(tableName + ": Total Records: " + success.length);
	
	                return success;
	              };
	
	              tgtFbTable = tableName;
	
	              if (subPath) {
	                tgtFbTable = subPath;
	              }
	              _context10.prev = 4;
	
	              if (!onceOnly) {
	                _context10.next = 14;
	                break;
	              }
	
	              tmpArray = [];
	              fbOject = [];
	              _context10.next = 10;
	              return firebase.db.ref("/" + tgtFbTable).once("value", function (snapshot) {
	                if (snapshot && snapshot !== undefined) {
	                  var res = snapshot.val();
	                  // console.log(
	                  //   moment().format("x") +
	                  //     " db snapshotting s1 " +
	                  //     tableName +
	                  //     " res received"
	                  // );
	
	                  if (res && res !== undefined) {
	                    tmpArray = Object.keys(res).map(function (key) {
	                      return _extends({}, res[key], {
	                        key: key
	                      });
	                    });
	                    // console.log(
	                    //   moment().format("x") +
	                    //     " db keys " +
	                    //     tableName +
	                    //     " keys processed"
	                    // );
	                    revArray = tmpArray.reverse();
	                    // console.log("dispatching results now");
	                    // console.log(
	                    //   moment().format("x") +
	                    //     " db reversing " +
	                    //     tableName +
	                    //     " reversing done"
	                    // );
	                    if (singleObj) {
	                      dispatch(actionAddSingleRecord({
	                        path: tableName,
	                        payload: res
	                      }));
	                    } else {
	                      dispatch(actionAddArray2Redux({
	                        path: tableName,
	                        payload: revArray
	                      }));
	                    }
	                    return revArray;
	                  } else {
	                    // console.log("no data with async for " + tableName);
	                  }
	                }
	              });
	
	            case 10:
	              revArray = _context10.sent;
	              return _context10.abrupt("return", onSuccess(revArray));
	
	            case 14:
	              _tmpArray = [];
	              _fbOject = [];
	
	              dispatch((0, _index.setUiFlag)(tableName + "-downloaded", false));
	              _context10.next = 19;
	              return firebase.db.ref("/" + tgtFbTable).on("value", function (snapshot) {
	                if (snapshot && snapshot !== undefined) {
	                  var res = snapshot.val();
	                  // console.log(
	                  //   moment().format("x") +
	                  //     " db snapshotting s1 " +
	                  //     tableName +
	                  //     " res received"
	                  // );
	                  if (res && res !== undefined) {
	                    _tmpArray = Object.keys(res).map(function (key) {
	                      return _extends({}, res[key], {
	                        key: key
	                      });
	                    });
	                    // console.log(
	                    //   moment().format("x") +
	                    //     " db keys " +
	                    //     tableName +
	                    //     " keys processed"
	                    // );
	                    var _revArray = _tmpArray.reverse();
	                    // console.log(
	                    //   moment().format("x") +
	                    //     " db snapshotting " +
	                    //     tableName +
	                    //     " res received"
	                    // );
	                    //console.log("dispatching results now");
	                    if (singleObj) {
	                      dispatch(actionAddSingleRecord({
	                        path: tableName,
	                        payload: res
	                      }));
	                    } else {
	                      dispatch(actionAddArray2Redux({
	                        path: tableName,
	                        payload: _revArray
	                      }));
	                    }
	                    dispatch((0, _index.setUiFlag)(tableName + "-downloaded", true));
	                  } else {
	                    dispatch((0, _index.setUiFlag)(tableName + "-downloaded", true));
	                    console.log("no data with async for " + tableName);
	                  }
	                }
	              });
	
	            case 19:
	              finRes = _context10.sent;
	              return _context10.abrupt("return", onSuccess([]));
	
	            case 21:
	              _context10.next = 28;
	              break;
	
	            case 23:
	              _context10.prev = 23;
	              _context10.t0 = _context10["catch"](4);
	
	              console.log("Some error: " + _context10.t0);
	              dispatch((0, _index.setUiFlag)(tableName + "-downloaded", true));
	              return _context10.abrupt("return", onError(_context10.t0));
	
	            case 28:
	            case "end":
	              return _context10.stop();
	          }
	        }
	      }, _callee10, _this8, [[4, 23]]);
	    }));
	
	    return function (_x15) {
	      return _ref10.apply(this, arguments);
	    };
	  }();
	}
	
	//setup users and admin status:
	function setupUsers(currEmail, firebase, teamName, fbCloudUrl, fbDbUrl) {
	  var _this9 = this;
	
	  return function () {
	    var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(dispatch) {
	      var onSuccess, onError;
	      return regeneratorRuntime.wrap(function _callee11$(_context11) {
	        while (1) {
	          switch (_context11.prev = _context11.next) {
	            case 0:
	              onError = function onError(error) {
	                return error;
	              };
	
	              onSuccess = function onSuccess(success) {
	                // console.log("rcvd this into success: " + JSON.stringify(success));
	                // dispatch(
	                //   actionAddSingleRecord({
	                //     path: parsedRes.tableName,
	                //     payload: success
	                //   })
	                // );
	                return success;
	              };
	
	              _context11.prev = 2;
	
	              firebase.db.ref("/users").on("value", function (snapshot) {
	                console.log("Linking users");
	                var tmpArray = [];
	                var fbOject = [];
	                Promise.all([snapshot.val()]).then(function (res) {
	                  fbOject = res[0];
	                  //console.log("now recieved the response for teams loading");
	                  tmpArray = Object.keys(fbOject).map(function (key) {
	                    return _extends({}, fbOject[key], {
	                      key: key
	                    });
	                  });
	                  tmpArray.reverse();
	                  //console.log("array reversed");
	                  ////console.log("Total Records: " + tmpArray.length);
	                  dispatch(actionAddArray2Redux({ path: "users", payload: tmpArray }));
	
	                  var currentUser = {};
	
	                  //
	
	                  currentUser = tmpArray.find(function (userObj) {
	                    if (userObj.userEmail === currEmail) {
	                      return userObj;
	                    }
	                  });
	
	                  //console.log("admin status: " + JSON.stringify(currentUser));
	
	                  dispatch(actionAddSingleRecord({
	                    path: "userProfile",
	                    payload: currentUser
	                  }));
	
	                  if (currentUser !== undefined) {
	                    console.log("~!@~!@ " + JSON.stringify(currentUser));
	                    var isThisAdmin = currentUser.roleName === "ADMIN" || currentUser.roleName === "SUPERADMIN";
	                    var isThisSuperAdmin = currentUser.roleName === "SUPERADMIN";
	                    dispatch((0, _index.setUiFlag)("currUserRole", currentUser.roleName));
	                    dispatch((0, _index.setUiFlag)("isThisAdmin", isThisAdmin));
	                    dispatch((0, _index.setUiFlag)("isThisSuperAdmin", isThisSuperAdmin));
	
	                    dispatch(actionAddSingleRecord({
	                      path: "currentUser",
	                      payload: currentUser
	                    }));
	
	                    dispatch(actionAddSingleRecord({
	                      path: "team",
	                      payload: {
	                        name: teamName,
	                        fbCloudUrl: fbCloudUrl,
	                        fbDbUrl: fbDbUrl
	                      }
	                    }));
	                    return onSuccess("success");
	                  }
	                });
	              });
	              _context11.next = 10;
	              break;
	
	            case 6:
	              _context11.prev = 6;
	              _context11.t0 = _context11["catch"](2);
	
	              console.log("Some error: " + _context11.t0);
	              return _context11.abrupt("return", onError(_context11.t0));
	
	            case 10:
	            case "end":
	              return _context11.stop();
	          }
	        }
	      }, _callee11, _this9, [[2, 6]]);
	    }));
	
	    return function (_x16) {
	      return _ref11.apply(this, arguments);
	    };
	  }();
	}
	
	//GEN AUTO ID
	function getId(parsedRes) {
	  var _this10 = this;
	
	  return function () {
	    var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(dispatch) {
	      var onSuccess, onError, success;
	      return regeneratorRuntime.wrap(function _callee12$(_context12) {
	        while (1) {
	          switch (_context12.prev = _context12.next) {
	            case 0:
	              onError = function onError(error) {
	                return error;
	              };
	
	              onSuccess = function onSuccess(success) {
	                console.log("rcvd this into success: " + JSON.stringify(success));
	                dispatch(actionAddSingleRecord({
	                  path: parsedRes.tableName,
	                  payload: success
	                }));
	                return success;
	              };
	
	              _context12.prev = 2;
	              _context12.next = 5;
	              return dispatch((0, _dbGetAutoId2.default)(parsedRes.idPrefix, parsedRes.idToken));
	
	            case 5:
	              success = _context12.sent;
	              return _context12.abrupt("return", onSuccess(success));
	
	            case 9:
	              _context12.prev = 9;
	              _context12.t0 = _context12["catch"](2);
	              return _context12.abrupt("return", onError(_context12.t0));
	
	            case 12:
	            case "end":
	              return _context12.stop();
	          }
	        }
	      }, _callee12, _this10, [[2, 9]]);
	    }));
	
	    return function (_x17) {
	      return _ref12.apply(this, arguments);
	    };
	  }();
	}
	
	//GET PO STATEMENT
	function getStatement(templateId, jsonData) {
	  var _this11 = this;
	
	  return function () {
	    var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(dispatch) {
	      var onSuccess, onError, success;
	      return regeneratorRuntime.wrap(function _callee13$(_context13) {
	        while (1) {
	          switch (_context13.prev = _context13.next) {
	            case 0:
	              onError = function onError(error) {
	                console.log("rcvd this into error: " + JSON.stringify(error));
	                return error;
	              };
	
	              onSuccess = function onSuccess(success) {
	                //console.log("rcvd this into success: " + JSON.stringify(success));
	                return success;
	              };
	
	              _context13.prev = 2;
	              _context13.next = 5;
	              return dispatch((0, _dbGetStatement2.default)(templateId, jsonData));
	
	            case 5:
	              success = _context13.sent;
	              return _context13.abrupt("return", onSuccess(success));
	
	            case 9:
	              _context13.prev = 9;
	              _context13.t0 = _context13["catch"](2);
	              return _context13.abrupt("return", onError(_context13.t0));
	
	            case 12:
	            case "end":
	              return _context13.stop();
	          }
	        }
	      }, _callee13, _this11, [[2, 9]]);
	    }));
	
	    return function (_x18) {
	      return _ref13.apply(this, arguments);
	    };
	  }();
	}
	
	//GET PO STATEMENT B64
	function getStatementB64(templateId, jsonData, mailParams) {
	  var _this12 = this;
	
	  return function () {
	    var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14(dispatch) {
	      var onSuccess, onError, success;
	      return regeneratorRuntime.wrap(function _callee14$(_context14) {
	        while (1) {
	          switch (_context14.prev = _context14.next) {
	            case 0:
	              onError = function onError(error) {
	                console.log("rcvd this into error: " + JSON.stringify(error));
	                return error;
	              };
	
	              onSuccess = function onSuccess(success) {
	                //console.log("rcvd this into success: " + JSON.stringify(success));
	                return success;
	              };
	
	              _context14.prev = 2;
	              _context14.next = 5;
	              return dispatch((0, _dbGetStatementB2.default)(templateId, jsonData, mailParams));
	
	            case 5:
	              success = _context14.sent;
	              return _context14.abrupt("return", onSuccess(success));
	
	            case 9:
	              _context14.prev = 9;
	              _context14.t0 = _context14["catch"](2);
	              return _context14.abrupt("return", onError(_context14.t0));
	
	            case 12:
	            case "end":
	              return _context14.stop();
	          }
	        }
	      }, _callee14, _this12, [[2, 9]]);
	    }));
	
	    return function (_x19) {
	      return _ref14.apply(this, arguments);
	    };
	  }();
	}
	
	//READ ALL STATS FROM A TARGET TABLE
	function fetchStats(queryObj, idToken) {
	  var _this13 = this;
	
	  console.log("fetchStats(" + queryObj.path + ")", "queryObj :" + JSON.stringify(queryObj));
	  return function () {
	    var _ref15 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15(dispatch) {
	      var data;
	      return regeneratorRuntime.wrap(function _callee15$(_context15) {
	        while (1) {
	          switch (_context15.prev = _context15.next) {
	            case 0:
	              //console.log("fetchStats: got token from authGetToken ");
	              data = { path: queryObj.path };
	
	
	              dispatch(clearAllExistingRecords(data));
	              dispatch(localGetStats(queryObj)).then(function (returnData) {
	                console.log("========>fetchStats(" + queryObj.path + "). Completed: " + JSON.stringify(returnData));
	                dispatch(actionAddArray2Redux({
	                  path: queryObj.path,
	                  payload: returnData
	                }));
	                dispatch((0, _ui.uiStopLoading)());
	              }).catch(function (err) {
	                console.log("Some error ====>");
	              });
	
	            case 3:
	            case "end":
	              return _context15.stop();
	          }
	        }
	      }, _callee15, _this13);
	    }));
	
	    return function (_x20) {
	      return _ref15.apply(this, arguments);
	    };
	  }();
	}
	
	//ADD PROJECT TO FIREBASE DATABASE AND THEN ADD TO REDUX
	function addRecord(data, idToken, multi) {
	  return function (dispatch) {
	    (0, _index.uiStartLoading)();
	
	    dispatch(authGetToken()).then(function (token) {
	      dispatch((0, _dbAddRecord2.default)(data, token)).then(function (resKey) {
	        var dataBundle = _extends({}, data, {
	          key: resKey
	        });
	        dispatch(actionAddRecord2Redux(dataBundle));
	        /*console.log(
	              "Creating notification now: here is data: " +
	                JSON.stringify(data)
	            );*/
	        if (data.path === "notices" || data.path === "logistics" || data.path === "tasks") {
	          //console.log("notification conditin is met");
	          //alert(data.notificationText);
	          (0, _sendNotificationToASegment.sendNotificationToASegment)({ en: data.notificationText }, ["Active Users"]);
	        }
	        dispatch(selectARecord({
	          key: dataBundle.key,
	          path: dataBundle.path
	        }));
	        (0, _ui.uiStopLoading)();
	        if (multi === "yes") {
	          alert("Record Added");
	        }
	      }).catch(function (err) {
	        //logger("DEBUG", "addRecord(data)", "Caught exception " + err);
	        alert("Not able to completed your request. Please check network connection and try again. " + err);
	        dispatch((0, _ui.uiStopLoading)());
	      });
	    });
	  };
	}
	
	//UPDATE AN EXISTING PROJECT TO FIREBASE DATABASE AND ALSO UPDATE INTO REDUX STATE
	function updateRecord(data) {
	  //logger("DEBUG", "updateRecord(data)", "-------Updating record to DB " + JSON.stringify(data));
	  return function (dispatch) {
	    dispatch((0, _dbUpdateRecord2.default)(data, token)).then(function (resKey) {
	      //logger("DEBUG", "--updateRecord(data)", "Updating record to redux " + JSON.stringify(data));
	      dispatch(actionUpdateRecord2Redux(data));
	      if (data.path === "notices" || data.path === "logistics" || data.path === "tasks") {
	        //console.log("notification conditin is met");
	        //alert(data.notificationText);
	        if (data.notificationText !== "") {
	          (0, _sendNotificationToASegment.sendNotificationToASegment)({ en: data.notificationText }, ["Active Users"]);
	        }
	      }
	      dispatch((0, _ui.uiStopLoading)());
	    }).catch(function (err) {
	      //logger("DEBUG", "updateRecord(data)", "!!!--Caught exception " + err);
	      alert("Not able to completed your request. Please check network connection and try again. " + err);
	      dispatch((0, _ui.uiStopLoading)());
	    });
	  };
	}
	
	function deleteRecord(data) {
	  //logger("DEBUG", "deleteARecord(data)", "-------Deleting record from DB " + JSON.stringify(data));
	  return function (dispatch) {
	    if (_rawState.useLocal) {
	      dispatch((0, _index.uiStartLoading)());
	      //logger("DEBUG", "deleteARecord(data)", "Deleting record from redux " + JSON.stringify(data));
	      dispatch(actionDeleteARecord(data));
	      dispatch((0, _ui.uiStopLoading)());
	    } else {
	      dispatch((0, _index.uiStartLoading)());
	      dispatch(authGetToken()).then(function (token) {
	        dispatch((0, _dbDeleteRecord2.default)(data, token)).then(function (resKey) {
	          //logger("DEBUG", "deleteARecord(data)", "Deleting record from redux " + JSON.stringify(data));
	          dispatch(actionDeleteARecord(data));
	          dispatch((0, _ui.uiStopLoading)());
	        }).catch(function (err) {
	          //logger("DEBUG", "deleteARecord(data)", "!!!--Caught exception " + err);
	          alert("We are unable to complete your request at this time, please check your network connection or contact support");
	          dispatch((0, _ui.uiStopLoading)());
	        });
	      }).catch(function (err) {
	        //logger("DEBUG", "deleteARecord(data)", "!!!--Caught exception " + err);
	        alert("We are unable to complete your request at this time, please check your network connection or contact support");
	        dispatch((0, _ui.uiStopLoading)());
	      });
	    }
	  };
	}
	
	function getMsSinceMidnight(d) {
	  var e = new Date(d);
	  return "-KXX" + (d - e.setHours(0, 0, 0, 0));
	}
	
	/*========================================================================
	All things Redux, updates to redux state
	==========================================================================*/
	//ADD A NEW RECORD TO REDUX, THIS IS DONE AFTER FIREBASE HAS BEEN DONE
	var actionAddRecord2Redux = exports.actionAddRecord2Redux = function actionAddRecord2Redux(data) {
	  //logger("FULL", "actionAddRecord2Redux", "Adding record to Redux " + JSON.stringify(data));
	  return _extends({
	    type: _actionTypes.ADD_RECORD
	  }, data);
	};
	
	//USED FOR REFRESHING FULL LIST/TABLE TO REDUX, THIS IS DONE AFTER FIREBASE HAS BEEN DONE
	var actionAddArray2Redux = exports.actionAddArray2Redux = function actionAddArray2Redux(data) {
	  //logger("FULL", "actionAddRecord2Redux", "Adding record to Redux " + JSON.stringify(data));
	  return _extends({
	    type: _actionTypes.ADD_ARRAY
	  }, data);
	};
	
	//SELECT A RECORD FOR EDITING OR VIEWING
	function selectARecord(data) {
	  //logger("DEBUG", "selectARecord(data)", "Selecting a record " + JSON.stringify(data));
	  return _extends({
	    type: _actionTypes.SELECT_RECORD
	  }, data);
	}
	
	//SELECT A RECORD FOR EDITING OR VIEWING
	function actionAddSingleRecord(data) {
	  // console.log(
	  //   "into action in db actionAddSingleRecord: Rcvd this: " +
	  //     JSON.stringify(data)
	  // );
	  return _extends({
	    type: _actionTypes.ADD_SINGLE_RECORD
	  }, data);
	}
	
	//CLEAR SELECTED RECORD TO RE-INIT FOR NEW RECORDS
	function initSelectedRecord(data) {
	  //logger("DEBUG", "initSelectedRecord(data)", "Selecting a record " + JSON.stringify(data));
	  return _extends({
	    type: _actionTypes.INIT_SELECT_RECORD
	  }, data);
	}
	
	//ADD A NEW RECORD TO REDUX, THIS IS DONE AFTER FIREBASE HAS BEEN DONE
	var actionUpdateRecord2Redux = exports.actionUpdateRecord2Redux = function actionUpdateRecord2Redux(data) {
	  //logger("DEBUG", "actionUpdateRecord2Redux", "Updating a record in redux " + JSON.stringify(data));
	  return _extends({
	    type: _actionTypes.UPDATE_RECORD
	  }, data);
	};
	
	//CLEAR ALL EXISTING RECORDS FROM AN ARRAY
	var clearAllExistingRecords = exports.clearAllExistingRecords = function clearAllExistingRecords(data) {
	  //logger("DEBUG", "clearAllExistingRecords", "Clearing all records for " + data.path);
	  return {
	    type: _actionTypes.CLEAR_ALL_RECORDS,
	    path: data.path
	  };
	};
	
	//DELETE RECORD FROM DB AND FIREBASE
	var actionDeleteARecord = exports.actionDeleteARecord = function actionDeleteARecord(data) {
	  //logger("DEBUG", "deleteARecord", "Deleting record for:  " + data.path + ": " + data.payload.key);
	  return _extends({
	    type: _actionTypes.DELETE_RECORD
	  }, data);
	};
	
	//RESET FIREBASE ON LOGOUT
	var resetRedux = exports.resetRedux = function resetRedux() {
	  return {
	    type: _actionTypes.RESET_STORE
	  };
	};

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	//static initial data
	
	
	var _actionTypes = __webpack_require__(80);
	
	var _lodash = __webpack_require__(22);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _tUsers = __webpack_require__(356);
	
	var _tListOfTables = __webpack_require__(353);
	
	var _tCreateTable = __webpack_require__(352);
	
	var _tMenuDesigner = __webpack_require__(354);
	
	var _tSupplierShopItems = __webpack_require__(159);
	
	var _tPopularItems = __webpack_require__(355);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var groupedProds = _lodash2.default.chain(_tSupplierShopItems.tSupplierShopItems).groupBy("category").value();
	//console.log(JSON.stringify(groupedProds));
	
	var initialState = _extends({
	  users: _tUsers.tUsers,
	  listOfTables: _tListOfTables.tListOfTables,
	  createTable: _tCreateTable.tCreateTable,
	  menuDesigner: _tMenuDesigner.tMenuDesigner,
	  supplierShopItems: _tSupplierShopItems.tSupplierShopItems
	}, groupedProds, {
	  POPULAR: _tPopularItems.tPopularItems
	});
	
	var dbReducer = function dbReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _actionTypes.ADD_RECORD:
	      if (state[action.path]) {
	        var _newArray = [].concat(_toConsumableArray(state[action.path]));
	        _newArray = _newArray.concat(_extends({}, action.payload, {
	          key: action.key
	        }));
	
	        var newAddState = _extends({}, state);
	        newAddState[action.path] = _newArray;
	        return newAddState;
	      } else {
	        var newState = _extends({}, state);
	
	        newState[action.path] = [];
	        newState[action.path].push(_extends({
	          key: action.key
	        }, action.payload));
	
	        return newState;
	      }
	
	    case _actionTypes.ADD_ARRAY:
	      var newArrayState = _extends({}, state);
	      newArrayState[action.path] = action.payload;
	      return newArrayState;
	
	    case _actionTypes.UPDATE_RECORD:
	      var newArray = [].concat(_toConsumableArray(state[action.path]));
	      newArray = newArray.map(function (record, index) {
	        if (record.key === action.payload.key) {
	          return action.payload;
	        }
	        return record;
	      });
	      var newUpdateState = _extends({}, state);
	      newUpdateState[action.path] = newArray;
	      newUpdateState["selected" + action.path] = action.payload;
	      return newUpdateState;
	
	    case _actionTypes.DELETE_RECORD:
	      newArray = [].concat(_toConsumableArray(state[action.path]));
	      newArray = newArray.filter(function (item) {
	        return item.key !== action.payload.key;
	      });
	
	      var newDelState = _extends({}, state);
	      newDelState[action.path] = newArray;
	      return newDelState;
	
	    case _actionTypes.CLEAR_ALL_RECORDS:
	      var newClearState = _extends({}, state);
	      newClearState[action.path] = [];
	      return newClearState;
	
	    case _actionTypes.SELECT_RECORD:
	      var newSelectState = _extends({}, state);
	      newSelectState["selected" + action.path] = state[action.path].find(function (data) {
	        return data.key === action.key;
	      });
	
	      return newSelectState;
	
	    case _actionTypes.ADD_SINGLE_RECORD:
	      var newAddSingleState = _lodash2.default.cloneDeep(state);
	
	      newAddSingleState[action.path] = action.payload;
	
	      return newAddSingleState;
	
	    case _actionTypes.INIT_SELECT_RECORD:
	      var newInitState = _extends({}, state);
	      newInitState["selected" + action.path] = _extends({}, action.data);
	      return newInitState;
	
	    case _actionTypes.RESET_STORE:
	      return initialState;
	    default:
	      return state;
	  }
	};
	
	exports.default = dbReducer;

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _actionTypes = __webpack_require__(80);
	
	var _utils = __webpack_require__(79);
	
	var initialState = {
	  showSpinner: false,
	  showMenuButton: false,
	  editMode: false,
	  pullRefresh: false,
	  showSelectorProjects: false,
	  showSelectorUsers: false,
	  showSelectorPhases: false,
	  operationType: "",
	  id4photos: "",
	  notLoggedIn: true,
	  loginProgress: true,
	  workerMenus: [{
	    displayToggle: "YES",
	    menuCaption: "BCS HOME",
	    menuIcon: "fa fa-home",
	    mobileRecLimit: "",
	    recLimit: "",
	    tableCaption: "BCS HOME",
	    tableName: "bcsHome"
	  }, {
	    menuCaption: "ORDERS",
	    menuIcon: "fa fa-shopping-cart",
	    mobileRecLimit: "",
	    recLimit: "",
	    tableCaption: "DELIVERY REQUEST",
	    tableName: "deliveryRequest"
	  }, {
	    menuCaption: "OPEN BAZAR",
	    menuIcon: "fa fa-users",
	    mobileRecLimit: "",
	    recLimit: "",
	    tableCaption: "OPEN BAZAR",
	    tableName: "openBazar"
	  }, {
	    menuCaption: "SIGN OUT",
	    menuIcon: "fa fa-sign-out",
	    mobileRecLimit: "",
	    recLimit: "",
	    tableCaption: "SIGN OUT",
	    tableName: "signout"
	  }],
	  userMenus: [{
	    displayToggle: "YES",
	    menuCaption: "BCS HOME",
	    menuIcon: "fa fa-home",
	    mobileRecLimit: "",
	    recLimit: "",
	    tableCaption: "BCS HOME",
	    tableName: "bcsHome"
	  }, {
	    displayToggle: "YES",
	    menuCaption: "SUPPLIER",
	    menuIcon: "fa fa-th-list",
	    mobileRecLimit: "",
	    recLimit: "",
	    tableCaption: "SUPPLIER",
	    tableName: "dqr"
	  }, {
	    menuCaption: "MY SHOP",
	    menuIcon: "fa fa-check-circle",
	    mobileRecLimit: "",
	    recLimit: "",
	    tableCaption: "MY SHOP",
	    tableName: "supplierShopItems"
	  }, {
	    menuCaption: "OPEN BAZAR",
	    menuIcon: "fa fa-users",
	    mobileRecLimit: "",
	    recLimit: "",
	    tableCaption: "OPEN BAZAR",
	    tableName: "openBazar"
	  }, {
	    displayToggle: "YES",
	    menuCaption: "SIGN OUT",
	    menuIcon: "fa fa-sign-out",
	    mobileRecLimit: "",
	    recLimit: "",
	    tableCaption: "SIGN OUT",
	    tableName: "signout"
	  }]
	};
	
	var uiReducer = function uiReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _actionTypes.UI_START_LOADING:
	      (0, _utils.logger)("FULL", "uiReducer", "starting spinner");
	      return _extends({}, state, {
	        showSpinner: true
	      });
	    case _actionTypes.UI_STOP_LOADING:
	      (0, _utils.logger)("FULL", "uiReducer", "Stopping spinner");
	      return _extends({}, state, {
	        showSpinner: false
	      });
	    case _actionTypes.SHOW_BAR:
	      return _extends({}, state, {
	        showMenuButton: true
	      });
	    case _actionTypes.HIDE_BAR:
	      return _extends({}, state, {
	        showMenuButton: false
	      });
	    case _actionTypes.EDIT_MODE_ON:
	      return _extends({}, state, {
	        editMode: true
	      });
	    case _actionTypes.EDIT_MODE_OFF:
	      return _extends({}, state, {
	        editMode: false
	      });
	    case _actionTypes.LIST_PULL_REFRESHING_ON:
	      return _extends({}, state, {
	        pullRefresh: true
	      });
	    case _actionTypes.LIST_PULL_REFRESHING_OFF:
	      return _extends({}, state, {
	        pullRefresh: false
	      });
	
	    case _actionTypes.SET_UI_FLAG:
	      var newState = _extends({}, state);
	      newState[action.flagName] = action.status;
	
	      return _extends({}, newState);
	
	    default:
	      return state;
	  }
	};
	
	exports.default = uiReducer;

/***/ }),
/* 360 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createChangeEmitter = exports.createChangeEmitter = function createChangeEmitter() {
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  function listen(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function () {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  function emit() {
	    currentListeners = nextListeners;
	    var listeners = currentListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      listeners[i].apply(listeners, arguments);
	    }
	  }
	
	  return {
	    listen: listen,
	    emit: emit
	  };
	};

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

	var conversions = __webpack_require__(162);
	
	/*
		this function routes a model to all other models.
	
		all functions that are routed have a property `.conversion` attached
		to the returned synthetic function. This property is an array
		of strings, each with the steps in between the 'from' and 'to'
		color models (inclusive).
	
		conversions that are not possible simply are not included.
	*/
	
	function buildGraph() {
		var graph = {};
		// https://jsperf.com/object-keys-vs-for-in-with-closure/3
		var models = Object.keys(conversions);
	
		for (var len = models.length, i = 0; i < len; i++) {
			graph[models[i]] = {
				// http://jsperf.com/1-vs-infinity
				// micro-opt, but this is simple.
				distance: -1,
				parent: null
			};
		}
	
		return graph;
	}
	
	// https://en.wikipedia.org/wiki/Breadth-first_search
	function deriveBFS(fromModel) {
		var graph = buildGraph();
		var queue = [fromModel]; // unshift -> queue -> pop
	
		graph[fromModel].distance = 0;
	
		while (queue.length) {
			var current = queue.pop();
			var adjacents = Object.keys(conversions[current]);
	
			for (var len = adjacents.length, i = 0; i < len; i++) {
				var adjacent = adjacents[i];
				var node = graph[adjacent];
	
				if (node.distance === -1) {
					node.distance = graph[current].distance + 1;
					node.parent = current;
					queue.unshift(adjacent);
				}
			}
		}
	
		return graph;
	}
	
	function link(from, to) {
		return function (args) {
			return to(from(args));
		};
	}
	
	function wrapConversion(toModel, graph) {
		var path = [graph[toModel].parent, toModel];
		var fn = conversions[graph[toModel].parent][toModel];
	
		var cur = graph[toModel].parent;
		while (graph[cur].parent) {
			path.unshift(graph[cur].parent);
			fn = link(conversions[graph[cur].parent][cur], fn);
			cur = graph[cur].parent;
		}
	
		fn.conversion = path;
		return fn;
	}
	
	module.exports = function (fromModel) {
		var graph = deriveBFS(fromModel);
		var conversion = {};
	
		var models = Object.keys(graph);
		for (var len = models.length, i = 0; i < len; i++) {
			var toModel = models[i];
			var node = graph[toModel];
	
			if (node.parent === null) {
				// no possible conversion, or this node is the source model.
				continue;
			}
	
			conversion[toModel] = wrapConversion(toModel, graph);
		}
	
		return conversion;
	};
	


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

	/* MIT license */
	var colorNames = __webpack_require__(27);
	var swizzle = __webpack_require__(38);
	
	var reverseNames = {};
	
	// create a list of reverse color names
	for (var name in colorNames) {
		if (colorNames.hasOwnProperty(name)) {
			reverseNames[colorNames[name]] = name;
		}
	}
	
	var cs = module.exports = {
		to: {},
		get: {}
	};
	
	cs.get = function (string) {
		var prefix = string.substring(0, 3).toLowerCase();
		var val;
		var model;
		switch (prefix) {
			case 'hsl':
				val = cs.get.hsl(string);
				model = 'hsl';
				break;
			case 'hwb':
				val = cs.get.hwb(string);
				model = 'hwb';
				break;
			default:
				val = cs.get.rgb(string);
				model = 'rgb';
				break;
		}
	
		if (!val) {
			return null;
		}
	
		return {model: model, value: val};
	};
	
	cs.get.rgb = function (string) {
		if (!string) {
			return null;
		}
	
		var abbr = /^#([a-f0-9]{3,4})$/i;
		var hex = /^#([a-f0-9]{6})([a-f0-9]{2})?$/i;
		var rgba = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/;
		var per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/;
		var keyword = /(\D+)/;
	
		var rgb = [0, 0, 0, 1];
		var match;
		var i;
		var hexAlpha;
	
		if (match = string.match(hex)) {
			hexAlpha = match[2];
			match = match[1];
	
			for (i = 0; i < 3; i++) {
				// https://jsperf.com/slice-vs-substr-vs-substring-methods-long-string/19
				var i2 = i * 2;
				rgb[i] = parseInt(match.slice(i2, i2 + 2), 16);
			}
	
			if (hexAlpha) {
				rgb[3] = Math.round((parseInt(hexAlpha, 16) / 255) * 100) / 100;
			}
		} else if (match = string.match(abbr)) {
			match = match[1];
			hexAlpha = match[3];
	
			for (i = 0; i < 3; i++) {
				rgb[i] = parseInt(match[i] + match[i], 16);
			}
	
			if (hexAlpha) {
				rgb[3] = Math.round((parseInt(hexAlpha + hexAlpha, 16) / 255) * 100) / 100;
			}
		} else if (match = string.match(rgba)) {
			for (i = 0; i < 3; i++) {
				rgb[i] = parseInt(match[i + 1], 0);
			}
	
			if (match[4]) {
				rgb[3] = parseFloat(match[4]);
			}
		} else if (match = string.match(per)) {
			for (i = 0; i < 3; i++) {
				rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
			}
	
			if (match[4]) {
				rgb[3] = parseFloat(match[4]);
			}
		} else if (match = string.match(keyword)) {
			if (match[1] === 'transparent') {
				return [0, 0, 0, 0];
			}
	
			rgb = colorNames[match[1]];
	
			if (!rgb) {
				return null;
			}
	
			rgb[3] = 1;
	
			return rgb;
		} else {
			return null;
		}
	
		for (i = 0; i < 3; i++) {
			rgb[i] = clamp(rgb[i], 0, 255);
		}
		rgb[3] = clamp(rgb[3], 0, 1);
	
		return rgb;
	};
	
	cs.get.hsl = function (string) {
		if (!string) {
			return null;
		}
	
		var hsl = /^hsla?\(\s*([+-]?(?:\d*\.)?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/;
		var match = string.match(hsl);
	
		if (match) {
			var alpha = parseFloat(match[4]);
			var h = (parseFloat(match[1]) + 360) % 360;
			var s = clamp(parseFloat(match[2]), 0, 100);
			var l = clamp(parseFloat(match[3]), 0, 100);
			var a = clamp(isNaN(alpha) ? 1 : alpha, 0, 1);
	
			return [h, s, l, a];
		}
	
		return null;
	};
	
	cs.get.hwb = function (string) {
		if (!string) {
			return null;
		}
	
		var hwb = /^hwb\(\s*([+-]?\d*[\.]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/;
		var match = string.match(hwb);
	
		if (match) {
			var alpha = parseFloat(match[4]);
			var h = ((parseFloat(match[1]) % 360) + 360) % 360;
			var w = clamp(parseFloat(match[2]), 0, 100);
			var b = clamp(parseFloat(match[3]), 0, 100);
			var a = clamp(isNaN(alpha) ? 1 : alpha, 0, 1);
			return [h, w, b, a];
		}
	
		return null;
	};
	
	cs.to.hex = function () {
		var rgba = swizzle(arguments);
	
		return (
			'#' +
			hexDouble(rgba[0]) +
			hexDouble(rgba[1]) +
			hexDouble(rgba[2]) +
			(rgba[3] < 1
				? (hexDouble(Math.round(rgba[3] * 255)))
				: '')
		);
	};
	
	cs.to.rgb = function () {
		var rgba = swizzle(arguments);
	
		return rgba.length < 4 || rgba[3] === 1
			? 'rgb(' + Math.round(rgba[0]) + ', ' + Math.round(rgba[1]) + ', ' + Math.round(rgba[2]) + ')'
			: 'rgba(' + Math.round(rgba[0]) + ', ' + Math.round(rgba[1]) + ', ' + Math.round(rgba[2]) + ', ' + rgba[3] + ')';
	};
	
	cs.to.rgb.percent = function () {
		var rgba = swizzle(arguments);
	
		var r = Math.round(rgba[0] / 255 * 100);
		var g = Math.round(rgba[1] / 255 * 100);
		var b = Math.round(rgba[2] / 255 * 100);
	
		return rgba.length < 4 || rgba[3] === 1
			? 'rgb(' + r + '%, ' + g + '%, ' + b + '%)'
			: 'rgba(' + r + '%, ' + g + '%, ' + b + '%, ' + rgba[3] + ')';
	};
	
	cs.to.hsl = function () {
		var hsla = swizzle(arguments);
		return hsla.length < 4 || hsla[3] === 1
			? 'hsl(' + hsla[0] + ', ' + hsla[1] + '%, ' + hsla[2] + '%)'
			: 'hsla(' + hsla[0] + ', ' + hsla[1] + '%, ' + hsla[2] + '%, ' + hsla[3] + ')';
	};
	
	// hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
	// (hwb have alpha optional & 1 is default value)
	cs.to.hwb = function () {
		var hwba = swizzle(arguments);
	
		var a = '';
		if (hwba.length >= 4 && hwba[3] !== 1) {
			a = ', ' + hwba[3];
		}
	
		return 'hwb(' + hwba[0] + ', ' + hwba[1] + '%, ' + hwba[2] + '%' + a + ')';
	};
	
	cs.to.keyword = function (rgb) {
		return reverseNames[rgb.slice(0, 3)];
	};
	
	// helpers
	function clamp(num, min, max) {
		return Math.min(Math.max(min, num), max);
	}
	
	function hexDouble(num) {
		var str = num.toString(16).toUpperCase();
		return (str.length < 2) ? '0' + str : str;
	}


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(366);
	
	var emptyObject = __webpack_require__(364);
	var _invariant = __webpack_require__(365);
	
	if (false) {
	  var warning = require('fbjs/lib/warning');
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillMount`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillReceiveProps`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillUpdate`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillUpdate: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Similar to ReactClassInterface but for static methods.
	   */
	  var ReactClassStaticInterface = {
	    /**
	     * This method is invoked after a component is instantiated and when it
	     * receives new props. Return an object to update state in response to
	     * prop changes. Return null to indicate no change to state.
	     *
	     * If an object is returned, its keys will be merged into the existing state.
	     *
	     * @return {object || null}
	     * @optional
	     */
	    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isAlreadyDefined = name in Constructor;
	      if (isAlreadyDefined) {
	        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
	          ? ReactClassStaticInterface[name]
	          : null;
	
	        _invariant(
	          specPolicy === 'DEFINE_MANY_MERGED',
	          'ReactClass: You are attempting to define ' +
	            '`%s` on your component more than once. This conflict may be ' +
	            'due to a mixin.',
	          name
	        );
	
	        Constructor[name] = createMergedResultFunction(Constructor[name], property);
	
	        return;
	      }
	
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
	        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
	          'Did you mean UNSAFE_componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ }),
/* 366 */
85,
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(19)();
	// imports
	exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:400,500,700);", ""]);
	
	// module
	exports.push([module.id, ".mdl-button{background:0 0;border:none;border-radius:2px;color:#000;position:relative;height:36px;margin:0;min-width:64px;padding:0 16px;display:inline-block;font-family:Roboto,Helvetica,Arial,sans-serif;font-size:14px;font-weight:500;text-transform:uppercase;line-height:1;letter-spacing:0;overflow:hidden;will-change:box-shadow;transition:box-shadow .2s cubic-bezier(.4,0,1,1),background-color .2s cubic-bezier(.4,0,.2,1),color .2s cubic-bezier(.4,0,.2,1);outline:0;cursor:pointer;text-decoration:none;text-align:center;line-height:36px;vertical-align:middle}.mdl-button::-moz-focus-inner{border:0}.mdl-button:hover{background-color:hsla(0,0%,62%,.2)}.mdl-button:focus:not(:active){background-color:rgba(0,0,0,.12)}.mdl-button:active{background-color:hsla(0,0%,62%,.4)}.mdl-button.mdl-button--colored{color:#3f51b5}.mdl-button.mdl-button--colored:focus:not(:active){background-color:rgba(0,0,0,.12)}input.mdl-button[type=submit]{-webkit-appearance:none}.mdl-button--raised{background:hsla(0,0%,62%,.2);box-shadow:0 2px 2px 0 rgba(0,0,0,.14),0 3px 1px -2px rgba(0,0,0,.2),0 1px 5px 0 rgba(0,0,0,.12)}.mdl-button--raised:active{box-shadow:0 4px 5px 0 rgba(0,0,0,.14),0 1px 10px 0 rgba(0,0,0,.12),0 2px 4px -1px rgba(0,0,0,.2);background-color:hsla(0,0%,62%,.4)}.mdl-button--raised:focus:not(:active){box-shadow:0 0 8px rgba(0,0,0,.18),0 8px 16px rgba(0,0,0,.36);background-color:hsla(0,0%,62%,.4)}.mdl-button--raised.mdl-button--colored{background:#3f51b5;color:#fff}.mdl-button--raised.mdl-button--colored:active,.mdl-button--raised.mdl-button--colored:focus:not(:active),.mdl-button--raised.mdl-button--colored:hover{background-color:#3f51b5}.mdl-button--raised.mdl-button--colored .mdl-ripple{background:#fff}.mdl-button--fab{border-radius:50%;font-size:24px;height:56px;margin:auto;min-width:56px;width:56px;padding:0;overflow:hidden;background:hsla(0,0%,62%,.2);box-shadow:0 1px 1.5px 0 rgba(0,0,0,.12),0 1px 1px 0 rgba(0,0,0,.24);position:relative;line-height:normal}.mdl-button--fab .material-icons{position:absolute;top:50%;left:50%;transform:translate(-12px,-12px);line-height:24px;width:24px}.mdl-button--fab.mdl-button--mini-fab{height:40px;min-width:40px;width:40px}.mdl-button--fab .mdl-button__ripple-container{border-radius:50%;-webkit-mask-image:-webkit-radial-gradient(circle,#fff,#000)}.mdl-button--fab:active{box-shadow:0 4px 5px 0 rgba(0,0,0,.14),0 1px 10px 0 rgba(0,0,0,.12),0 2px 4px -1px rgba(0,0,0,.2);background-color:hsla(0,0%,62%,.4)}.mdl-button--fab:focus:not(:active){box-shadow:0 0 8px rgba(0,0,0,.18),0 8px 16px rgba(0,0,0,.36);background-color:hsla(0,0%,62%,.4)}.mdl-button--fab.mdl-button--colored{background:#ff4081;color:#fff}.mdl-button--fab.mdl-button--colored:active,.mdl-button--fab.mdl-button--colored:focus:not(:active),.mdl-button--fab.mdl-button--colored:hover{background-color:#ff4081}.mdl-button--fab.mdl-button--colored .mdl-ripple{background:#fff}.mdl-button--icon{border-radius:50%;font-size:24px;height:32px;margin-left:0;margin-right:0;min-width:32px;width:32px;padding:0;overflow:hidden;color:inherit;line-height:normal}.mdl-button--icon .material-icons{position:absolute;top:50%;left:50%;transform:translate(-12px,-12px);line-height:24px;width:24px}.mdl-button--icon.mdl-button--mini-icon{height:24px;min-width:24px;width:24px}.mdl-button--icon.mdl-button--mini-icon .material-icons{top:0;left:0}.mdl-button--icon .mdl-button__ripple-container{border-radius:50%;-webkit-mask-image:-webkit-radial-gradient(circle,#fff,#000)}.mdl-button__ripple-container{display:block;height:100%;left:0;position:absolute;top:0;width:100%;z-index:0;overflow:hidden}.mdl-button.mdl-button--disabled .mdl-button__ripple-container .mdl-ripple,.mdl-button[disabled] .mdl-button__ripple-container .mdl-ripple{background-color:transparent}.mdl-button--primary.mdl-button--primary{color:#3f51b5}.mdl-button--primary.mdl-button--primary .mdl-ripple{background:#fff}.mdl-button--primary.mdl-button--primary.mdl-button--fab,.mdl-button--primary.mdl-button--primary.mdl-button--raised{color:#fff;background-color:#3f51b5}.mdl-button--accent.mdl-button--accent{color:#ff4081}.mdl-button--accent.mdl-button--accent .mdl-ripple{background:#fff}.mdl-button--accent.mdl-button--accent.mdl-button--fab,.mdl-button--accent.mdl-button--accent.mdl-button--raised{color:#fff;background-color:#ff4081}.mdl-button.mdl-button--disabled.mdl-button--disabled,.mdl-button[disabled][disabled]{color:rgba(0,0,0,.26);cursor:default;background-color:transparent}.mdl-button--fab.mdl-button--disabled.mdl-button--disabled,.mdl-button--fab[disabled][disabled]{background-color:rgba(0,0,0,.12);color:rgba(0,0,0,.26)}.mdl-button--raised.mdl-button--disabled.mdl-button--disabled,.mdl-button--raised[disabled][disabled]{background-color:rgba(0,0,0,.12);color:rgba(0,0,0,.26);box-shadow:none}.mdl-button--colored.mdl-button--disabled.mdl-button--disabled,.mdl-button--colored[disabled][disabled]{color:rgba(0,0,0,.26)}.mdl-button .material-icons{vertical-align:middle}.mdl-card{display:flex;flex-direction:column;font-size:16px;font-weight:400;min-height:200px;overflow:hidden;width:330px;z-index:1;position:relative;background:#fff;border-radius:2px;box-sizing:border-box}.mdl-card__media{background-color:#ff4081;background-repeat:repeat;background-position:50% 50%;background-size:cover;background-origin:padding-box;background-attachment:scroll;box-sizing:border-box}.mdl-card__title{align-items:center;color:#000;display:block;display:flex;justify-content:stretch;line-height:normal;padding:16px;perspective-origin:165px 56px;transform-origin:165px 56px;box-sizing:border-box}.mdl-card__title.mdl-card--border{border-bottom:1px solid rgba(0,0,0,.1)}.mdl-card__title-text{align-self:flex-end;color:inherit;display:block;display:flex;font-size:24px;font-weight:300;line-height:normal;overflow:hidden;transform-origin:149px 48px;margin:0}.mdl-card__subtitle-text{font-size:14px;color:rgba(0,0,0,.54);margin:0}.mdl-card__supporting-text{color:rgba(0,0,0,.54);font-size:1rem;line-height:18px;overflow:hidden;padding:16px;width:90%}.mdl-card__supporting-text.mdl-card--border{border-bottom:1px solid rgba(0,0,0,.1)}.mdl-card__actions{font-size:16px;line-height:normal;width:100%;background-color:transparent;padding:8px;box-sizing:border-box}.mdl-card__actions.mdl-card--border{border-top:1px solid rgba(0,0,0,.1)}.mdl-card--expand{flex-grow:1}.mdl-card__menu{position:absolute;right:16px;top:16px}.mdl-dialog{border:none;box-shadow:0 9px 46px 8px rgba(0,0,0,.14),0 11px 15px -7px rgba(0,0,0,.12),0 24px 38px 3px rgba(0,0,0,.2);width:280px}.mdl-dialog__title{padding:24px 24px 0;margin:0;font-size:2.5rem}.mdl-dialog__actions{padding:8px 8px 8px 24px;display:flex;flex-direction:row-reverse;flex-wrap:wrap}.mdl-dialog__actions>*{margin-right:8px;height:36px}.mdl-dialog__actions>:first-child{margin-right:0}.mdl-dialog__actions--full-width{padding:0 0 8px}.mdl-dialog__actions--full-width>*{height:48px;flex:0 0 100%;padding-right:16px;margin-right:0;text-align:right}.mdl-dialog__content{padding:20px 24px 24px;color:rgba(0,0,0,.54)}.mdl-progress{display:block;position:relative;height:4px;width:500px;max-width:100%}.mdl-progress>.bar{display:block;position:absolute;top:0;bottom:0;width:0;transition:width .2s cubic-bezier(.4,0,.2,1)}.mdl-progress>.progressbar{background-color:#3f51b5;z-index:1;left:0}.mdl-progress>.bufferbar{background-image:linear-gradient(90deg,hsla(0,0%,100%,.7),hsla(0,0%,100%,.7)),linear-gradient(90deg,#3f51b5,#3f51b5);z-index:0;left:0}.mdl-progress>.auxbar{right:0}@supports (-webkit-appearance:none){.mdl-progress:not(.mdl-progress--indeterminate):not(.mdl-progress--indeterminate)>.auxbar,.mdl-progress:not(.mdl-progress__indeterminate):not(.mdl-progress__indeterminate)>.auxbar{background-image:linear-gradient(90deg,hsla(0,0%,100%,.7),hsla(0,0%,100%,.7)),linear-gradient(90deg,#3f51b5,#3f51b5);mask:url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIj8+Cjxzdmcgd2lkdGg9IjEyIiBoZWlnaHQ9IjQiIHZpZXdQb3J0PSIwIDAgMTIgNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogIDxlbGxpcHNlIGN4PSIyIiBjeT0iMiIgcng9IjIiIHJ5PSIyIj4KICAgIDxhbmltYXRlIGF0dHJpYnV0ZU5hbWU9ImN4IiBmcm9tPSIyIiB0bz0iLTEwIiBkdXI9IjAuNnMiIHJlcGVhdENvdW50PSJpbmRlZmluaXRlIiAvPgogIDwvZWxsaXBzZT4KICA8ZWxsaXBzZSBjeD0iMTQiIGN5PSIyIiByeD0iMiIgcnk9IjIiIGNsYXNzPSJsb2FkZXIiPgogICAgPGFuaW1hdGUgYXR0cmlidXRlTmFtZT0iY3giIGZyb209IjE0IiB0bz0iMiIgZHVyPSIwLjZzIiByZXBlYXRDb3VudD0iaW5kZWZpbml0ZSIgLz4KICA8L2VsbGlwc2U+Cjwvc3ZnPgo=)}}.mdl-progress:not(.mdl-progress--indeterminate)>.auxbar,.mdl-progress:not(.mdl-progress__indeterminate)>.auxbar{background-image:linear-gradient(90deg,hsla(0,0%,100%,.9),hsla(0,0%,100%,.9)),linear-gradient(90deg,#3f51b5,#3f51b5)}.mdl-progress.mdl-progress--indeterminate>.bar1,.mdl-progress.mdl-progress__indeterminate>.bar1{background-color:#3f51b5;animation-name:indeterminate1;animation-duration:2s;animation-iteration-count:infinite;animation-timing-function:linear}.mdl-progress.mdl-progress--indeterminate>.bar3,.mdl-progress.mdl-progress__indeterminate>.bar3{background-image:none;background-color:#3f51b5;animation-name:indeterminate2;animation-duration:2s;animation-iteration-count:infinite;animation-timing-function:linear}@keyframes indeterminate1{0%{left:0;width:0}50%{left:25%;width:75%}75%{left:100%;width:0}}@keyframes indeterminate2{0%{left:0;width:0}50%{left:0;width:0}75%{left:0;width:25%}to{left:100%;width:0}}.mdl-shadow--2dp{box-shadow:0 2px 2px 0 rgba(0,0,0,.14),0 3px 1px -2px rgba(0,0,0,.2),0 1px 5px 0 rgba(0,0,0,.12)}.mdl-shadow--3dp{box-shadow:0 3px 4px 0 rgba(0,0,0,.14),0 3px 3px -2px rgba(0,0,0,.2),0 1px 8px 0 rgba(0,0,0,.12)}.mdl-shadow--4dp{box-shadow:0 4px 5px 0 rgba(0,0,0,.14),0 1px 10px 0 rgba(0,0,0,.12),0 2px 4px -1px rgba(0,0,0,.2)}.mdl-shadow--6dp{box-shadow:0 6px 10px 0 rgba(0,0,0,.14),0 1px 18px 0 rgba(0,0,0,.12),0 3px 5px -1px rgba(0,0,0,.2)}.mdl-shadow--8dp{box-shadow:0 8px 10px 1px rgba(0,0,0,.14),0 3px 14px 2px rgba(0,0,0,.12),0 5px 5px -3px rgba(0,0,0,.2)}.mdl-shadow--16dp{box-shadow:0 16px 24px 2px rgba(0,0,0,.14),0 6px 30px 5px rgba(0,0,0,.12),0 8px 10px -5px rgba(0,0,0,.2)}.mdl-shadow--24dp{box-shadow:0 9px 46px 8px rgba(0,0,0,.14),0 11px 15px -7px rgba(0,0,0,.12),0 24px 38px 3px rgba(0,0,0,.2)}.mdl-spinner{display:inline-block;position:relative;width:28px;height:28px}.mdl-spinner:not(.is-upgraded).is-active:after{content:\"Loading...\"}.mdl-spinner.is-upgraded.is-active{animation:mdl-spinner__container-rotate 1.568s linear infinite}@keyframes mdl-spinner__container-rotate{to{transform:rotate(1turn)}}.mdl-spinner__layer{position:absolute;width:100%;height:100%;opacity:0}.mdl-spinner__layer-1{border-color:#42a5f5}.mdl-spinner--single-color .mdl-spinner__layer-1{border-color:#3f51b5}.mdl-spinner.is-active .mdl-spinner__layer-1{animation:mdl-spinner__fill-unfill-rotate 5332ms cubic-bezier(.4,0,.2,1) infinite both,mdl-spinner__layer-1-fade-in-out 5332ms cubic-bezier(.4,0,.2,1) infinite both}.mdl-spinner__layer-2{border-color:#f44336}.mdl-spinner--single-color .mdl-spinner__layer-2{border-color:#3f51b5}.mdl-spinner.is-active .mdl-spinner__layer-2{animation:mdl-spinner__fill-unfill-rotate 5332ms cubic-bezier(.4,0,.2,1) infinite both,mdl-spinner__layer-2-fade-in-out 5332ms cubic-bezier(.4,0,.2,1) infinite both}.mdl-spinner__layer-3{border-color:#fdd835}.mdl-spinner--single-color .mdl-spinner__layer-3{border-color:#3f51b5}.mdl-spinner.is-active .mdl-spinner__layer-3{animation:mdl-spinner__fill-unfill-rotate 5332ms cubic-bezier(.4,0,.2,1) infinite both,mdl-spinner__layer-3-fade-in-out 5332ms cubic-bezier(.4,0,.2,1) infinite both}.mdl-spinner__layer-4{border-color:#4caf50}.mdl-spinner--single-color .mdl-spinner__layer-4{border-color:#3f51b5}.mdl-spinner.is-active .mdl-spinner__layer-4{animation:mdl-spinner__fill-unfill-rotate 5332ms cubic-bezier(.4,0,.2,1) infinite both,mdl-spinner__layer-4-fade-in-out 5332ms cubic-bezier(.4,0,.2,1) infinite both}@keyframes mdl-spinner__fill-unfill-rotate{12.5%{transform:rotate(135deg)}25%{transform:rotate(270deg)}37.5%{transform:rotate(405deg)}50%{transform:rotate(540deg)}62.5%{transform:rotate(675deg)}75%{transform:rotate(810deg)}87.5%{transform:rotate(945deg)}to{transform:rotate(3turn)}}@keyframes mdl-spinner__layer-1-fade-in-out{0%{opacity:.99}25%{opacity:.99}26%{opacity:0}89%{opacity:0}90%{opacity:.99}to{opacity:.99}}@keyframes mdl-spinner__layer-2-fade-in-out{0%{opacity:0}15%{opacity:0}25%{opacity:.99}50%{opacity:.99}51%{opacity:0}}@keyframes mdl-spinner__layer-3-fade-in-out{0%{opacity:0}40%{opacity:0}50%{opacity:.99}75%{opacity:.99}76%{opacity:0}}@keyframes mdl-spinner__layer-4-fade-in-out{0%{opacity:0}65%{opacity:0}75%{opacity:.99}90%{opacity:.99}to{opacity:0}}.mdl-spinner__gap-patch{position:absolute;box-sizing:border-box;top:0;left:45%;width:10%;height:100%;overflow:hidden;border-color:inherit}.mdl-spinner__gap-patch .mdl-spinner__circle{width:1000%;left:-450%}.mdl-spinner__circle-clipper{display:inline-block;position:relative;width:50%;height:100%;overflow:hidden;border-color:inherit}.mdl-spinner__circle-clipper.mdl-spinner__left{float:left}.mdl-spinner__circle-clipper.mdl-spinner__right{float:right}.mdl-spinner__circle-clipper .mdl-spinner__circle{width:200%}.mdl-spinner__circle{box-sizing:border-box;height:100%;border-width:3px;border-style:solid;border-color:inherit;border-bottom-color:transparent!important;border-radius:50%;animation:none;position:absolute;top:0;right:0;bottom:0;left:0}.mdl-spinner__left .mdl-spinner__circle{border-right-color:transparent!important;transform:rotate(129deg)}.mdl-spinner.is-active .mdl-spinner__left .mdl-spinner__circle{animation:mdl-spinner__left-spin 1333ms cubic-bezier(.4,0,.2,1) infinite both}.mdl-spinner__right .mdl-spinner__circle{left:-100%;border-left-color:transparent!important;transform:rotate(-129deg)}.mdl-spinner.is-active .mdl-spinner__right .mdl-spinner__circle{animation:mdl-spinner__right-spin 1333ms cubic-bezier(.4,0,.2,1) infinite both}@keyframes mdl-spinner__left-spin{0%{transform:rotate(130deg)}50%{transform:rotate(-5deg)}to{transform:rotate(130deg)}}@keyframes mdl-spinner__right-spin{0%{transform:rotate(-130deg)}50%{transform:rotate(5deg)}to{transform:rotate(-130deg)}}.mdl-textfield{position:relative;font-size:16px;display:inline-block;box-sizing:border-box;width:300px;max-width:100%;margin:0;padding:20px 0}.mdl-textfield .mdl-button{position:absolute;bottom:20px}.mdl-textfield--align-right{text-align:right}.mdl-textfield--full-width{width:100%}.mdl-textfield--expandable{min-width:32px;width:auto;min-height:32px}.mdl-textfield--expandable .mdl-button--icon{top:16px}.mdl-textfield__input{border:none;border-bottom:1px solid rgba(0,0,0,.12);display:block;font-size:16px;font-family:Helvetica,Arial,sans-serif;margin:0;padding:4px 0;width:100%;background:0 0;text-align:left;color:inherit}.mdl-textfield__input[type=number]{-moz-appearance:textfield}.mdl-textfield__input[type=number]::-webkit-inner-spin-button,.mdl-textfield__input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.mdl-textfield.is-focused .mdl-textfield__input{outline:0}.mdl-textfield.is-invalid .mdl-textfield__input{border-color:#d50000;box-shadow:none}.mdl-textfield.is-disabled .mdl-textfield__input,fieldset[disabled] .mdl-textfield .mdl-textfield__input{background-color:transparent;border-bottom:1px dotted rgba(0,0,0,.12);color:rgba(0,0,0,.26)}.mdl-textfield textarea.mdl-textfield__input{display:block}.mdl-textfield__label{bottom:0;color:rgba(0,0,0,.26);font-size:16px;left:0;right:0;pointer-events:none;position:absolute;display:block;top:24px;width:100%;overflow:hidden;white-space:nowrap;text-align:left}.mdl-textfield.has-placeholder .mdl-textfield__label,.mdl-textfield.is-dirty .mdl-textfield__label{visibility:hidden}.mdl-textfield--floating-label .mdl-textfield__label{transition-duration:.2s;transition-timing-function:cubic-bezier(.4,0,.2,1)}.mdl-textfield--floating-label.has-placeholder .mdl-textfield__label{transition:none}.mdl-textfield.is-disabled.is-disabled .mdl-textfield__label,fieldset[disabled] .mdl-textfield .mdl-textfield__label{color:rgba(0,0,0,.26)}.mdl-textfield--floating-label.has-placeholder .mdl-textfield__label,.mdl-textfield--floating-label.is-dirty .mdl-textfield__label,.mdl-textfield--floating-label.is-focused .mdl-textfield__label{color:#3f51b5;font-size:12px;top:4px;visibility:visible}.mdl-textfield--floating-label.has-placeholder .mdl-textfield__expandable-holder .mdl-textfield__label,.mdl-textfield--floating-label.is-dirty .mdl-textfield__expandable-holder .mdl-textfield__label,.mdl-textfield--floating-label.is-focused .mdl-textfield__expandable-holder .mdl-textfield__label{top:-16px}.mdl-textfield--floating-label.is-invalid .mdl-textfield__label{color:#d50000;font-size:12px}.mdl-textfield__label:after{background-color:#3f51b5;bottom:20px;content:\"\";height:2px;left:45%;position:absolute;transition-duration:.2s;transition-timing-function:cubic-bezier(.4,0,.2,1);visibility:hidden;width:10px}.mdl-textfield.is-focused .mdl-textfield__label:after{left:0;visibility:visible;width:100%}.mdl-textfield.is-invalid .mdl-textfield__label:after{background-color:#d50000}.mdl-textfield__error{color:#d50000;position:absolute;font-size:12px;margin-top:3px;visibility:hidden;display:block}.mdl-textfield.is-invalid .mdl-textfield__error{visibility:visible}.mdl-textfield__expandable-holder{position:relative;margin-left:32px;transition-duration:.2s;transition-timing-function:cubic-bezier(.4,0,.2,1);display:inline-block;max-width:.1px}.mdl-textfield.is-dirty .mdl-textfield__expandable-holder,.mdl-textfield.is-focused .mdl-textfield__expandable-holder{max-width:600px}.mdl-textfield__expandable-holder .mdl-textfield__label:after{bottom:0}dialog{position:absolute;left:0;right:0;width:-moz-fit-content;width:-webkit-fit-content;width:fit-content;height:-moz-fit-content;height:-webkit-fit-content;height:fit-content;margin:auto;border:solid;padding:1em;background:#fff;color:#000;display:block}dialog:not([open]){display:none}dialog+.backdrop{background:rgba(0,0,0,.1)}._dialog_overlay,dialog+.backdrop{position:fixed;top:0;right:0;bottom:0;left:0}dialog.fixed{position:fixed;top:50%;transform:translateY(-50%)}.firebaseui-container{background-color:#fff;box-sizing:border-box;-moz-box-sizing:border-box;-webkit-box-sizing:border-box;color:rgba(0,0,0,.87);direction:ltr;font:16px Roboto,arial,sans-serif;margin:0 auto;max-width:360px;overflow:visible;position:relative;text-align:left;width:100%}.firebaseui-container.mdl-card{overflow:visible}.firebaseui-card-header{padding:24px 24px 0}.firebaseui-card-content,.firebaseui-card-footer{padding:0 24px}.firebaseui-card-actions{box-sizing:border-box;display:table;font-size:14px;padding:8px 24px 24px;text-align:left;width:100%}.firebaseui-form-links{display:table-cell;vertical-align:middle;width:100%}.firebaseui-form-actions{display:table-cell;text-align:right;white-space:nowrap;width:100%}.firebaseui-subtitle,.firebaseui-title{color:rgba(0,0,0,.87);direction:ltr;font-size:20px;font-weight:500;line-height:24px;margin:0;padding:0;text-align:left}.firebaseui-title{padding-bottom:16px}.firebaseui-subtitle{margin:16px 0}.firebaseui-text{color:rgba(0,0,0,.87);direction:ltr;font-size:16px;line-height:24px;text-align:left}.firebaseui-id-page-password-recovery-email-sent p.firebaseui-text{margin:16px 0}.firebaseui-text-emphasis{font-weight:700}.firebaseui-error{color:#dd2c00;direction:ltr;font-size:12px;line-height:16px;margin:0;text-align:left}.firebaseui-text-input-error{margin:-16px 0 16px}.firebaseui-error-wrapper{min-height:16px}.firebaseui-list-item{direction:ltr;margin:0;padding:0;text-align:left}.firebaseui-hidden{display:none}.firebaseui-relative-wrapper{position:relative}.firebaseui-label{color:rgba(0,0,0,.54);direction:ltr;font-size:16px;text-align:left}.mdl-textfield--floating-label.is-dirty .mdl-textfield__label,.mdl-textfield--floating-label.is-focused .mdl-textfield__label{color:#757575}.firebaseui-input,.firebaseui-input-invalid{border-radius:0;color:rgba(0,0,0,.87);direction:ltr;font-size:16px;width:100%}input.firebaseui-input,input.firebaseui-input-invalid{direction:ltr;text-align:left}.firebaseui-input-invalid{border-color:#dd2c00}.firebaseui-textfield{width:100%}.firebaseui-textfield.mdl-textfield .firebaseui-input{border-color:rgba(0,0,0,.12)}.firebaseui-textfield.mdl-textfield .firebaseui-label:after{background-color:#3f51b5}.firebaseui-textfield-invalid.mdl-textfield .firebaseui-input{border-color:#dd2c00}.firebaseui-textfield-invalid.mdl-textfield .firebaseui-label:after{background-color:#dd2c00}.firebaseui-button{display:inline-block;height:36px;margin-left:8px;min-width:88px}.firebaseui-link{color:#4285f4;font-variant:normal;font-weight:400;text-decoration:none}.firebaseui-link:hover{text-decoration:underline}.firebaseui-indent{margin-left:1em}.firebaseui-tos{color:#757575;direction:ltr;font-size:12px;line-height:16px;margin-bottom:24px;margin-top:0;text-align:left}.firebaseui-provider-sign-in-footer>.firebaseui-tos{text-align:center}.firebaseui-tos-list{list-style:none;text-align:right}.firebaseui-inline-list-item{display:inline-block;margin-left:5px;margin-right:5px}.firebaseui-page-provider-sign-in,.firebaseui-page-select-tenant{background:inherit}.firebaseui-idp-list,.firebaseui-tenant-list{list-style:none;margin:1em 0;padding:0}.firebaseui-idp-button,.firebaseui-tenant-button{direction:ltr;font-weight:500;height:auto;line-height:normal;max-width:220px;min-height:40px;padding:8px 16px;text-align:left;width:100%}.firebaseui-idp-list>.firebaseui-list-item,.firebaseui-tenant-list>.firebaseui-list-item{margin-bottom:15px;text-align:center}.firebaseui-idp-icon-wrapper{display:table-cell;vertical-align:middle}.firebaseui-idp-icon{height:18px;width:18px}.firebaseui-idp-favicon,.firebaseui-idp-icon{border:none;display:inline-block;vertical-align:middle}.firebaseui-idp-favicon{height:14px;margin-right:5px;width:14px}.firebaseui-idp-text{color:#fff;display:table-cell;font-size:14px;padding-left:16px;text-transform:none;vertical-align:middle}.firebaseui-idp-text.firebaseui-idp-text-long{display:table-cell}.firebaseui-idp-text.firebaseui-idp-text-short{display:none}@media (max-width:268px){.firebaseui-idp-text.firebaseui-idp-text-long{display:none}.firebaseui-idp-text.firebaseui-idp-text-short{display:table-cell}}@media (max-width:320px){.firebaseui-recaptcha-container>div>div{transform:scale(.9);-webkit-transform:scale(.9);transform-origin:0 0;-webkit-transform-origin:0 0}}.firebaseui-idp-google>.firebaseui-idp-text{color:#757575}[data-provider-id=\"yahoo.com\"]>.firebaseui-idp-icon-wrapper>.firebaseui-idp-icon{height:22px;width:22px}.firebaseui-info-bar{background-color:#f9edbe;border:1px solid #f0c36d;box-shadow:0 2px 4px rgba(0,0,0,.2);-webkit-box-shadow:0 2px 4px rgba(0,0,0,.2);-moz-box-shadow:0 2px 4px rgba(0,0,0,.2);left:10%;padding:8px 16px;position:absolute;right:10%;text-align:center;top:0}.firebaseui-info-bar-message{font-size:12px;margin:0}.firebaseui-dialog{box-sizing:border-box;color:rgba(0,0,0,.87);font:16px Roboto,arial,sans-serif;height:auto;padding:24px;text-align:left}.firebaseui-dialog-icon-wrapper{display:table-cell;vertical-align:middle}.firebaseui-dialog-icon{float:left;height:40px;margin-right:24px;width:40px}.firebaseui-progress-dialog-message{display:table-cell;font-size:16px;font-weight:400;min-height:40px;vertical-align:middle}.firebaseui-progress-dialog-loading-icon{height:28px;margin:6px 30px 6px 6px;width:28px}.firebaseui-icon-done{background-image:url(https://www.gstatic.com/images/icons/material/system/2x/done_googgreen_36dp.png);background-position:50%;background-repeat:no-repeat;background-size:36px 36px}.firebaseui-phone-number{display:flex}.firebaseui-country-selector{background-image:url(https://www.gstatic.com/images/icons/material/system/1x/arrow_drop_down_grey600_18dp.png);background-position:100%;background-repeat:no-repeat;background-size:18px auto;border-radius:0;border-bottom:1px solid rgba(0,0,0,.12);color:rgba(0,0,0,.87);flex-shrink:0;font-size:16px;font-weight:400;height:auto;line-height:normal;margin:20px 24px 20px 0;padding:4px 20px 4px 0;width:90px}.firebaseui-country-selector-flag{display:inline-block;margin-right:1ex}.firebaseui-flag{background-image:url(https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/flags_sprite_2x.png);background-size:100% auto;filter:drop-shadow(1px 1px 1px rgba(0,0,0,.54));height:14px;width:24px}.firebaseui-list-box-dialog{max-height:90%;overflow:auto;padding:8px 0 0}.firebaseui-list-box-actions{padding-bottom:8px}.firebaseui-list-box-icon-wrapper{padding-right:24px}.firebaseui-list-box-icon-wrapper,.firebaseui-list-box-label-wrapper{display:table-cell;vertical-align:top}.firebaseui-list-box-dialog-button{color:rgba(0,0,0,.87);direction:ltr;font-size:16px;font-weight:400;height:auto;line-height:normal;min-height:48px;padding:14px 24px;text-align:left;text-transform:none;width:100%}.firebaseui-phone-number-error{margin-left:114px}.mdl-progress.firebaseui-busy-indicator{height:2px;left:0;position:absolute;top:55px;width:100%}.mdl-spinner.firebaseui-busy-indicator{height:56px;left:0;margin:auto;position:absolute;right:0;top:30%;width:56px}.firebaseui-callback-indicator-container .firebaseui-busy-indicator{top:0}.firebaseui-callback-indicator-container{height:120px}.firebaseui-new-password-component{display:inline-block;position:relative;width:100%}.firebaseui-input-floating-button{background-position:50%;background-repeat:no-repeat;display:block;height:24px;position:absolute;right:0;top:20px;width:24px}.firebaseui-input-toggle-on{background-image:url(https://www.gstatic.com/images/icons/material/system/1x/visibility_black_24dp.png)}.firebaseui-input-toggle-off{background-image:url(https://www.gstatic.com/images/icons/material/system/1x/visibility_off_black_24dp.png)}.firebaseui-input-toggle-focus{opacity:.87}.firebaseui-input-toggle-blur{opacity:.38}.firebaseui-recaptcha-wrapper{display:table;margin:0 auto;padding-bottom:8px}.firebaseui-recaptcha-container{display:table-cell}.firebaseui-recaptcha-error-wrapper{caption-side:bottom;display:table-caption}.firebaseui-change-phone-number-link{display:block}.firebaseui-resend-container{direction:ltr;margin:20px 0;text-align:center}.firebaseui-id-resend-countdown{color:rgba(0,0,0,.38)}.firebaseui-id-page-phone-sign-in-start .firebaseui-form-actions div{float:left}@media (max-width:480px){.firebaseui-container{box-shadow:none;max-width:none;width:100%}.firebaseui-card-header{border-bottom:1px solid #e0e0e0;margin-bottom:16px;padding:16px 24px 0}.firebaseui-title{padding-bottom:16px}.firebaseui-card-actions{padding-right:24px}.firebaseui-busy-indicator{top:0}}.mdl-textfield__label{font-weight:400;margin-bottom:0}.firebaseui-id-page-blank,.firebaseui-id-page-spinner{background:inherit;height:64px}.firebaseui-email-sent{background-image:url(https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/success_status.png);background-position:50%;background-repeat:no-repeat;background-size:64px 64px;height:64px;margin-top:16px;text-align:center}.firebaseui-text-justify{text-align:justify}.firebaseui-flag-KY{background-position:0 0}.firebaseui-flag-AC{background-position:0 -14px}.firebaseui-flag-AE{background-position:0 -28px}.firebaseui-flag-AF{background-position:0 -42px}.firebaseui-flag-AG{background-position:0 -56px}.firebaseui-flag-AI{background-position:0 -70px}.firebaseui-flag-AL{background-position:0 -84px}.firebaseui-flag-AM{background-position:0 -98px}.firebaseui-flag-AO{background-position:0 -112px}.firebaseui-flag-AQ{background-position:0 -126px}.firebaseui-flag-AR{background-position:0 -140px}.firebaseui-flag-AS{background-position:0 -154px}.firebaseui-flag-AT{background-position:0 -168px}.firebaseui-flag-AU{background-position:0 -182px}.firebaseui-flag-AW{background-position:0 -196px}.firebaseui-flag-AX{background-position:0 -210px}.firebaseui-flag-AZ{background-position:0 -224px}.firebaseui-flag-BA{background-position:0 -238px}.firebaseui-flag-BB{background-position:0 -252px}.firebaseui-flag-BD{background-position:0 -266px}.firebaseui-flag-BE{background-position:0 -280px}.firebaseui-flag-BF{background-position:0 -294px}.firebaseui-flag-BG{background-position:0 -308px}.firebaseui-flag-BH{background-position:0 -322px}.firebaseui-flag-BI{background-position:0 -336px}.firebaseui-flag-BJ{background-position:0 -350px}.firebaseui-flag-BL{background-position:0 -364px}.firebaseui-flag-BM{background-position:0 -378px}.firebaseui-flag-BN{background-position:0 -392px}.firebaseui-flag-BO{background-position:0 -406px}.firebaseui-flag-BQ{background-position:0 -420px}.firebaseui-flag-BR{background-position:0 -434px}.firebaseui-flag-BS{background-position:0 -448px}.firebaseui-flag-BT{background-position:0 -462px}.firebaseui-flag-BV{background-position:0 -476px}.firebaseui-flag-BW{background-position:0 -490px}.firebaseui-flag-BY{background-position:0 -504px}.firebaseui-flag-BZ{background-position:0 -518px}.firebaseui-flag-CA{background-position:0 -532px}.firebaseui-flag-CC{background-position:0 -546px}.firebaseui-flag-CD{background-position:0 -560px}.firebaseui-flag-CF{background-position:0 -574px}.firebaseui-flag-CG{background-position:0 -588px}.firebaseui-flag-CH{background-position:0 -602px}.firebaseui-flag-CI{background-position:0 -616px}.firebaseui-flag-CK{background-position:0 -630px}.firebaseui-flag-CL{background-position:0 -644px}.firebaseui-flag-CM{background-position:0 -658px}.firebaseui-flag-CN{background-position:0 -672px}.firebaseui-flag-CO{background-position:0 -686px}.firebaseui-flag-CP{background-position:0 -700px}.firebaseui-flag-CR{background-position:0 -714px}.firebaseui-flag-CU{background-position:0 -728px}.firebaseui-flag-CV{background-position:0 -742px}.firebaseui-flag-CW{background-position:0 -756px}.firebaseui-flag-CX{background-position:0 -770px}.firebaseui-flag-CY{background-position:0 -784px}.firebaseui-flag-CZ{background-position:0 -798px}.firebaseui-flag-DE{background-position:0 -812px}.firebaseui-flag-DG{background-position:0 -826px}.firebaseui-flag-DJ{background-position:0 -840px}.firebaseui-flag-DK{background-position:0 -854px}.firebaseui-flag-DM{background-position:0 -868px}.firebaseui-flag-DO{background-position:0 -882px}.firebaseui-flag-DZ{background-position:0 -896px}.firebaseui-flag-EA{background-position:0 -910px}.firebaseui-flag-EC{background-position:0 -924px}.firebaseui-flag-EE{background-position:0 -938px}.firebaseui-flag-EG{background-position:0 -952px}.firebaseui-flag-EH{background-position:0 -966px}.firebaseui-flag-ER{background-position:0 -980px}.firebaseui-flag-ES{background-position:0 -994px}.firebaseui-flag-ET{background-position:0 -1008px}.firebaseui-flag-EU{background-position:0 -1022px}.firebaseui-flag-FI{background-position:0 -1036px}.firebaseui-flag-FJ{background-position:0 -1050px}.firebaseui-flag-FK{background-position:0 -1064px}.firebaseui-flag-FM{background-position:0 -1078px}.firebaseui-flag-FO{background-position:0 -1092px}.firebaseui-flag-FR{background-position:0 -1106px}.firebaseui-flag-GA{background-position:0 -1120px}.firebaseui-flag-GB{background-position:0 -1134px}.firebaseui-flag-GD{background-position:0 -1148px}.firebaseui-flag-GE{background-position:0 -1162px}.firebaseui-flag-GF{background-position:0 -1176px}.firebaseui-flag-GG{background-position:0 -1190px}.firebaseui-flag-GH{background-position:0 -1204px}.firebaseui-flag-GI{background-position:0 -1218px}.firebaseui-flag-GL{background-position:0 -1232px}.firebaseui-flag-GM{background-position:0 -1246px}.firebaseui-flag-GN{background-position:0 -1260px}.firebaseui-flag-GP{background-position:0 -1274px}.firebaseui-flag-GQ{background-position:0 -1288px}.firebaseui-flag-GR{background-position:0 -1302px}.firebaseui-flag-GS{background-position:0 -1316px}.firebaseui-flag-GT{background-position:0 -1330px}.firebaseui-flag-GU{background-position:0 -1344px}.firebaseui-flag-GW{background-position:0 -1358px}.firebaseui-flag-GY{background-position:0 -1372px}.firebaseui-flag-HK{background-position:0 -1386px}.firebaseui-flag-HM{background-position:0 -1400px}.firebaseui-flag-HN{background-position:0 -1414px}.firebaseui-flag-HR{background-position:0 -1428px}.firebaseui-flag-HT{background-position:0 -1442px}.firebaseui-flag-HU{background-position:0 -1456px}.firebaseui-flag-IC{background-position:0 -1470px}.firebaseui-flag-ID{background-position:0 -1484px}.firebaseui-flag-IE{background-position:0 -1498px}.firebaseui-flag-IL{background-position:0 -1512px}.firebaseui-flag-IM{background-position:0 -1526px}.firebaseui-flag-IN{background-position:0 -1540px}.firebaseui-flag-IO{background-position:0 -1554px}.firebaseui-flag-IQ{background-position:0 -1568px}.firebaseui-flag-IR{background-position:0 -1582px}.firebaseui-flag-IS{background-position:0 -1596px}.firebaseui-flag-IT{background-position:0 -1610px}.firebaseui-flag-JE{background-position:0 -1624px}.firebaseui-flag-JM{background-position:0 -1638px}.firebaseui-flag-JO{background-position:0 -1652px}.firebaseui-flag-JP{background-position:0 -1666px}.firebaseui-flag-KE{background-position:0 -1680px}.firebaseui-flag-KG{background-position:0 -1694px}.firebaseui-flag-KH{background-position:0 -1708px}.firebaseui-flag-KI{background-position:0 -1722px}.firebaseui-flag-KM{background-position:0 -1736px}.firebaseui-flag-KN{background-position:0 -1750px}.firebaseui-flag-KP{background-position:0 -1764px}.firebaseui-flag-KR{background-position:0 -1778px}.firebaseui-flag-KW{background-position:0 -1792px}.firebaseui-flag-AD{background-position:0 -1806px}.firebaseui-flag-KZ{background-position:0 -1820px}.firebaseui-flag-LA{background-position:0 -1834px}.firebaseui-flag-LB{background-position:0 -1848px}.firebaseui-flag-LC{background-position:0 -1862px}.firebaseui-flag-LI{background-position:0 -1876px}.firebaseui-flag-LK{background-position:0 -1890px}.firebaseui-flag-LR{background-position:0 -1904px}.firebaseui-flag-LS{background-position:0 -1918px}.firebaseui-flag-LT{background-position:0 -1932px}.firebaseui-flag-LU{background-position:0 -1946px}.firebaseui-flag-LV{background-position:0 -1960px}.firebaseui-flag-LY{background-position:0 -1974px}.firebaseui-flag-MA{background-position:0 -1988px}.firebaseui-flag-MC{background-position:0 -2002px}.firebaseui-flag-MD{background-position:0 -2016px}.firebaseui-flag-ME{background-position:0 -2030px}.firebaseui-flag-MF{background-position:0 -2044px}.firebaseui-flag-MG{background-position:0 -2058px}.firebaseui-flag-MH{background-position:0 -2072px}.firebaseui-flag-MK{background-position:0 -2086px}.firebaseui-flag-ML{background-position:0 -2100px}.firebaseui-flag-MM{background-position:0 -2114px}.firebaseui-flag-MN{background-position:0 -2128px}.firebaseui-flag-MO{background-position:0 -2142px}.firebaseui-flag-MP{background-position:0 -2156px}.firebaseui-flag-MQ{background-position:0 -2170px}.firebaseui-flag-MR{background-position:0 -2184px}.firebaseui-flag-MS{background-position:0 -2198px}.firebaseui-flag-MT{background-position:0 -2212px}.firebaseui-flag-MU{background-position:0 -2226px}.firebaseui-flag-MV{background-position:0 -2240px}.firebaseui-flag-MW{background-position:0 -2254px}.firebaseui-flag-MX{background-position:0 -2268px}.firebaseui-flag-MY{background-position:0 -2282px}.firebaseui-flag-MZ{background-position:0 -2296px}.firebaseui-flag-NA{background-position:0 -2310px}.firebaseui-flag-NC{background-position:0 -2324px}.firebaseui-flag-NE{background-position:0 -2338px}.firebaseui-flag-NF{background-position:0 -2352px}.firebaseui-flag-NG{background-position:0 -2366px}.firebaseui-flag-NI{background-position:0 -2380px}.firebaseui-flag-NL{background-position:0 -2394px}.firebaseui-flag-NO{background-position:0 -2408px}.firebaseui-flag-NP{background-position:0 -2422px}.firebaseui-flag-NR{background-position:0 -2436px}.firebaseui-flag-NU{background-position:0 -2450px}.firebaseui-flag-NZ{background-position:0 -2464px}.firebaseui-flag-OM{background-position:0 -2478px}.firebaseui-flag-PA{background-position:0 -2492px}.firebaseui-flag-PE{background-position:0 -2506px}.firebaseui-flag-PF{background-position:0 -2520px}.firebaseui-flag-PG{background-position:0 -2534px}.firebaseui-flag-PH{background-position:0 -2548px}.firebaseui-flag-PK{background-position:0 -2562px}.firebaseui-flag-PL{background-position:0 -2576px}.firebaseui-flag-PM{background-position:0 -2590px}.firebaseui-flag-PN{background-position:0 -2604px}.firebaseui-flag-PR{background-position:0 -2618px}.firebaseui-flag-PS{background-position:0 -2632px}.firebaseui-flag-PT{background-position:0 -2646px}.firebaseui-flag-PW{background-position:0 -2660px}.firebaseui-flag-PY{background-position:0 -2674px}.firebaseui-flag-QA{background-position:0 -2688px}.firebaseui-flag-RE{background-position:0 -2702px}.firebaseui-flag-RO{background-position:0 -2716px}.firebaseui-flag-RS{background-position:0 -2730px}.firebaseui-flag-RU{background-position:0 -2744px}.firebaseui-flag-RW{background-position:0 -2758px}.firebaseui-flag-SA{background-position:0 -2772px}.firebaseui-flag-SB{background-position:0 -2786px}.firebaseui-flag-SC{background-position:0 -2800px}.firebaseui-flag-SD{background-position:0 -2814px}.firebaseui-flag-SE{background-position:0 -2828px}.firebaseui-flag-SG{background-position:0 -2842px}.firebaseui-flag-SH{background-position:0 -2856px}.firebaseui-flag-SI{background-position:0 -2870px}.firebaseui-flag-SJ{background-position:0 -2884px}.firebaseui-flag-SK{background-position:0 -2898px}.firebaseui-flag-SL{background-position:0 -2912px}.firebaseui-flag-SM{background-position:0 -2926px}.firebaseui-flag-SN{background-position:0 -2940px}.firebaseui-flag-SO{background-position:0 -2954px}.firebaseui-flag-SR{background-position:0 -2968px}.firebaseui-flag-SS{background-position:0 -2982px}.firebaseui-flag-ST{background-position:0 -2996px}.firebaseui-flag-SV{background-position:0 -3010px}.firebaseui-flag-SX{background-position:0 -3024px}.firebaseui-flag-SY{background-position:0 -3038px}.firebaseui-flag-SZ{background-position:0 -3052px}.firebaseui-flag-TA{background-position:0 -3066px}.firebaseui-flag-TC{background-position:0 -3080px}.firebaseui-flag-TD{background-position:0 -3094px}.firebaseui-flag-TF{background-position:0 -3108px}.firebaseui-flag-TG{background-position:0 -3122px}.firebaseui-flag-TH{background-position:0 -3136px}.firebaseui-flag-TJ{background-position:0 -3150px}.firebaseui-flag-TK{background-position:0 -3164px}.firebaseui-flag-TL{background-position:0 -3178px}.firebaseui-flag-TM{background-position:0 -3192px}.firebaseui-flag-TN{background-position:0 -3206px}.firebaseui-flag-TO{background-position:0 -3220px}.firebaseui-flag-TR{background-position:0 -3234px}.firebaseui-flag-TT{background-position:0 -3248px}.firebaseui-flag-TV{background-position:0 -3262px}.firebaseui-flag-TW{background-position:0 -3276px}.firebaseui-flag-TZ{background-position:0 -3290px}.firebaseui-flag-UA{background-position:0 -3304px}.firebaseui-flag-UG{background-position:0 -3318px}.firebaseui-flag-UM{background-position:0 -3332px}.firebaseui-flag-UN{background-position:0 -3346px}.firebaseui-flag-US{background-position:0 -3360px}.firebaseui-flag-UY{background-position:0 -3374px}.firebaseui-flag-UZ{background-position:0 -3388px}.firebaseui-flag-VA{background-position:0 -3402px}.firebaseui-flag-VC{background-position:0 -3416px}.firebaseui-flag-VE{background-position:0 -3430px}.firebaseui-flag-VG{background-position:0 -3444px}.firebaseui-flag-VI{background-position:0 -3458px}.firebaseui-flag-VN{background-position:0 -3472px}.firebaseui-flag-VU{background-position:0 -3486px}.firebaseui-flag-WF{background-position:0 -3500px}.firebaseui-flag-WS{background-position:0 -3514px}.firebaseui-flag-XK{background-position:0 -3528px}.firebaseui-flag-YE{background-position:0 -3542px}.firebaseui-flag-YT{background-position:0 -3556px}.firebaseui-flag-ZA{background-position:0 -3570px}.firebaseui-flag-ZM{background-position:0 -3584px}.firebaseui-flag-ZW{background-position:0 -3598px}", ""]);
	
	// exports


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(19)();
	// imports
	
	
	// module
	exports.push([module.id, ".react-calendar{width:350px;max-width:100%;background:#fff;border:1px solid #a0a096;font-family:Arial,Helvetica,sans-serif;line-height:1.125em}.react-calendar,.react-calendar *,.react-calendar :after,.react-calendar :before{box-sizing:border-box}.react-calendar button{margin:0;border:0;outline:none}.react-calendar button:enabled:hover{cursor:pointer}.react-calendar__navigation{height:44px;margin-bottom:1em}.react-calendar__navigation button{min-width:44px;background:none}.react-calendar__navigation button:enabled:focus,.react-calendar__navigation button:enabled:hover{background-color:#e6e6e6}.react-calendar__navigation button[disabled]{background-color:#f0f0f0}.react-calendar__month-view__weekdays{text-align:center;text-transform:uppercase;font-weight:700;font-size:.75em}.react-calendar__month-view__weekdays__weekday{padding:.5em}.react-calendar__month-view__weekNumbers{font-weight:700}.react-calendar__month-view__weekNumbers .react-calendar__tile{display:flex;align-items:center;justify-content:center;font-size:.75em;padding:1em 0.66667em}.react-calendar__month-view__days__day--weekend{color:#d10000}.react-calendar__month-view__days__day--neighboringMonth{color:#757575}.react-calendar__century-view .react-calendar__tile,.react-calendar__decade-view .react-calendar__tile,.react-calendar__year-view .react-calendar__tile{padding:2em .5em}.react-calendar__tile{max-width:100%;text-align:center;padding:.75em .5em;background:none}.react-calendar__tile:disabled{background-color:#f0f0f0}.react-calendar__tile:enabled:focus,.react-calendar__tile:enabled:hover{background-color:#e6e6e6}.react-calendar__tile--hasActive{background:#76baff}.react-calendar__tile--hasActive:enabled:focus,.react-calendar__tile--hasActive:enabled:hover{background:#a9d4ff}.react-calendar__tile--active{background:#006edc;color:#fff}.react-calendar__tile--active:enabled:focus,.react-calendar__tile--active:enabled:hover{background:#1087ff}.react-calendar--selectRange .react-calendar__tile--hover{background-color:#e6e6e6}", ""]);
	
	// exports


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(19)();
	// imports
	
	
	// module
	exports.push([module.id, ".react-clock{display:block;position:relative}.react-clock,.react-clock *,.react-clock :after,.react-clock :before{box-sizing:border-box}.react-clock__face{position:absolute;top:0;bottom:0;left:0;right:0;border:1px solid #000;border-radius:50%}.react-clock__hand{position:absolute;top:0;bottom:0;left:50%;right:50%}.react-clock__hand__body{position:absolute;background-color:#000;transform:translateX(-50%)}.react-clock__mark{position:absolute;top:0;bottom:0;left:50%;right:50%}.react-clock__mark__body{position:absolute;background-color:#000;transform:translateX(-50%)}.react-clock__mark__number{position:absolute;left:-40px;width:80px;text-align:center}.react-clock__second-hand__body{background-color:red}", ""]);
	
	// exports


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(19)();
	// imports
	
	
	// module
	exports.push([module.id, ".lazy-load-image-background.blur{filter:blur(15px)}.lazy-load-image-background.blur.lazy-load-image-loaded{filter:blur(0);transition:filter .3s}.lazy-load-image-background.blur>img{opacity:0}.lazy-load-image-background.blur.lazy-load-image-loaded>img{opacity:1;transition:opacity .3s}", ""]);
	
	// exports


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(19)();
	// imports
	
	
	// module
	exports.push([module.id, ".container{display:flex;flex-direction:column}.messages{overflow-y:scroll;overflow-x:hidden;flex-grow:1;padding:20px}h3{text-align:center;padding:20px 0;margin:0;border-bottom:1px solid #ddd;background-color:#eee}.chat-input{position:relative;overflow:hidden;padding:0 40px;flex-shrink:0}.chat-input input[type=text]{width:100%;margin-left:-20px;margin-right:-20px}.message.from-me{justify-content:flex-end;margin-bottom:1px;text-align:right}.message.from-me .message-body{background-color:#eee;color:#000}.message{margin-bottom:10px}.message-body{max-width:80%;display:inline-block;padding:5px;background-color:#2481b9;color:#fff;border:1px;border-radius:5px;padding-right:50px}.username{font-weight:700;font-size:.9rem;color:#999;margin-bottom:0}", ""]);
	
	// exports


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(19)();
	// imports
	
	
	// module
	exports.push([module.id, "@page{margin:2cm;@top-center{content:element(pageHeader)}@bottom-center{content:element(pageFooter)}}#pageHeader{position:running(pageHeader)}#pageFooter{position:running(pageFooter)}", ""]);
	
	// exports


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(19)();
	// imports
	
	
	// module
	exports.push([module.id, ".images{display:flex;flex-wrap:wrap;margin:2px;border:\"1px solid grey\"}.images .img,.images .pic{flex-basis:31%;margin:2px;border-radius:4px;border:\"1px solid grey\"}.images .img{width:112px;height:93px;background-size:cover;margin-right:2px;background-position:50%;display:flex;align-items:center;justify-content:center;cursor:pointer;position:relative;overflow:hidden;border:\"1px solid gainsboro\"}.images .img:nth-child(3n){margin-right:0}.images .img:after{content:\"\";width:100%;height:100%;transition:opacity .1s ease-in;border-radius:4px;opacity:0;position:absolute}.images .img:hover:after{display:block;background-color:#000;opacity:.5}.images .img:hover span{display:block;color:#fff}.images .pic{background-color:#f5f7fa;align-self:center;text-align:center;padding:40px 0;text-transform:uppercase;color:#848ea1;font-size:12px;cursor:pointer}", ""]);
	
	// exports


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(19)();
	// imports
	
	
	// module
	exports.push([module.id, "body{background-color:gray;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none}.container{width:100%;height:100vh;top:10%;left:10%}.sigContainer{width:80%;height:80%;margin:0 auto;background-color:#fff}.sigPad{width:100%;height:150px;border:1px solid #dcdcdc}.buttons{width:100%;height:30px}.sigImage{background-size:200px 50px;width:200px;height:50px;background-color:#fff}", ""]);
	
	// exports


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(19)();
	// imports
	
	
	// module
	exports.push([module.id, "@media screen and (min-width:480px){.wrap{width:380px;position:absolute;top:40%;left:50%;margin:5px;transform:translate(-50%,-50%)}}@media screen and (max-width:480px){.wrap{width:100%;position:absolute;padding:10px;margin-top:20px;top:40%;left:50%;transform:translate(-50%,-50%)}}.selectorWidth{width:-webkit-fill-available}", ""]);
	
	// exports


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(19)();
	// imports
	
	
	// module
	exports.push([module.id, ".searchzz,.wrapzz{width:100%}.searchzz{position:relative;display:flex}.searchTermzz{width:100%;border:3px solid #00b4cc;border-right:none;padding:5px;height:auto;border-radius:5px 0 0 5px;outline:none;color:#9dbfaf}.searchTermzz:focus{color:#00b4cc}.searchButtonzz{width:40px;height:36px;border:1px solid #00b4cc;background:#00b4cc;text-align:center;color:#fff;border-radius:0 5px 5px 0;cursor:pointer;font-size:20px}.navbardiv{position:fixed;top:0;height:50px;line-height:50px;font-weight:700;font-family:Helvetica;font-size:30px;background:#008b8b;width:100%;padding:0 20px;color:#fff;opacity:.2}.content{margin-top:50px;height:calc(100vh - 50px);overflow:auto}@keyframes rotation{0%{transform:rotateY(0deg)}to{transform:rotateY(359deg)}}body{position:relative}.blink{animation:blinker 1s linear infinite}@keyframes blinker{50%{opacity:.1}}.blink-one{animation:blinker-one 1s linear infinite}@keyframes blinker-one{0%{opacity:0}}.blink-two{animation:blinker-two 1.4s linear infinite}@keyframes blinker-two{to{opacity:0}}.fade-in-video{opacity:0;transition:opacity .8s linear}.fade-in-video.is-playing{opacity:1}", ""]);
	
	// exports


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(19)();
	// imports
	
	
	// module
	exports.push([module.id, "@font-face{font-family:RobotMedium;src:url(" + __webpack_require__(920) + ")}*{font-family:RobotMedium}", ""]);
	
	// exports


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(19)();
	// imports
	
	
	// module
	exports.push([module.id, ".react-datetime-picker{display:inline-flex;position:relative}.react-datetime-picker,.react-datetime-picker *,.react-datetime-picker :after,.react-datetime-picker :before{box-sizing:border-box}.react-datetime-picker--disabled{background-color:#f0f0f0;color:#6d6d6d}.react-datetime-picker__wrapper{display:flex;opacity:1}.react-datetime-picker__inputGroup{min-width:calc(4px + 12px + .54em * 6 + .217em * 2);flex-grow:1;display:flex;padding:0 2px;align-items:baseline}.react-datetime-picker__inputGroup__divider{padding:1px 0;white-space:pre}.react-datetime-picker__inputGroup__input{min-width:.54em;height:calc(100% - 2px);position:relative;padding:1px;border:0;background:none;font:inherit;box-sizing:content-box;-moz-appearance:textfield}.react-datetime-picker__inputGroup__input::-webkit-inner-spin-button,.react-datetime-picker__inputGroup__input::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.react-datetime-picker__inputGroup__input:invalid{background:rgba(255,0,0,.1)}.react-datetime-picker__inputGroup__input--hasLeadingZero{margin-left:-.54em;padding-left:calc(1px + .54em)}.react-datetime-picker__inputGroup__amPm{font:inherit;-moz-appearance:menulist}.react-datetime-picker__button{border:0;background:transparent;padding:4px 6px}.react-datetime-picker__button:enabled{cursor:pointer}.react-datetime-picker__button:enabled:focus .react-datetime-picker__button__icon,.react-datetime-picker__button:enabled:hover .react-datetime-picker__button__icon{stroke:#0078d7}.react-datetime-picker__button:disabled .react-datetime-picker__button__icon{stroke:#6d6d6d}.react-datetime-picker__button svg{display:inherit}.react-datetime-picker__calendar,.react-datetime-picker__clock{position:absolute;top:100%;left:0;z-index:100}.react-datetime-picker__calendar--closed,.react-datetime-picker__clock--closed{display:none}.react-datetime-picker__calendar{width:350px;max-width:100vw}.react-datetime-picker__calendar .react-calendar{border-width:thin}.react-datetime-picker__clock{width:200px;height:200px;max-width:100vw;padding:25px;background-color:#fff;border:thin solid #a0a096}", ""]);
	
	// exports


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * This is the web browser implementation of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = __webpack_require__(380);
	exports.log = log;
	exports.formatArgs = formatArgs;
	exports.save = save;
	exports.load = load;
	exports.useColors = useColors;
	exports.storage = 'undefined' != typeof chrome
	               && 'undefined' != typeof chrome.storage
	                  ? chrome.storage.local
	                  : localstorage();
	
	/**
	 * Colors.
	 */
	
	exports.colors = [
	  'lightseagreen',
	  'forestgreen',
	  'goldenrod',
	  'dodgerblue',
	  'darkorchid',
	  'crimson'
	];
	
	/**
	 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
	 * and the Firebug extension (any Firefox version) are known
	 * to support "%c" CSS customizations.
	 *
	 * TODO: add a `localStorage` variable to explicitly enable/disable colors
	 */
	
	function useColors() {
	  // NB: In an Electron preload script, document will be defined but not fully
	  // initialized. Since we know we're in Chrome, we'll just detect this case
	  // explicitly
	  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
	    return true;
	  }
	
	  // is webkit? http://stackoverflow.com/a/16459606/376773
	  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
	  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
	    // is firebug? http://stackoverflow.com/a/398120/376773
	    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
	    // is firefox >= v31?
	    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
	    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
	    // double check webkit in userAgent just in case we are in a worker
	    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
	}
	
	/**
	 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
	 */
	
	exports.formatters.j = function(v) {
	  try {
	    return JSON.stringify(v);
	  } catch (err) {
	    return '[UnexpectedJSONParseError]: ' + err.message;
	  }
	};
	
	
	/**
	 * Colorize log arguments if enabled.
	 *
	 * @api public
	 */
	
	function formatArgs(args) {
	  var useColors = this.useColors;
	
	  args[0] = (useColors ? '%c' : '')
	    + this.namespace
	    + (useColors ? ' %c' : ' ')
	    + args[0]
	    + (useColors ? '%c ' : ' ')
	    + '+' + exports.humanize(this.diff);
	
	  if (!useColors) return;
	
	  var c = 'color: ' + this.color;
	  args.splice(1, 0, c, 'color: inherit')
	
	  // the final "%c" is somewhat tricky, because there could be other
	  // arguments passed either before or after the %c, so we need to
	  // figure out the correct index to insert the CSS into
	  var index = 0;
	  var lastC = 0;
	  args[0].replace(/%[a-zA-Z%]/g, function(match) {
	    if ('%%' === match) return;
	    index++;
	    if ('%c' === match) {
	      // we only are interested in the *last* %c
	      // (the user may have provided their own)
	      lastC = index;
	    }
	  });
	
	  args.splice(lastC, 0, c);
	}
	
	/**
	 * Invokes `console.log()` when available.
	 * No-op when `console.log` is not a "function".
	 *
	 * @api public
	 */
	
	function log() {
	  // this hackery is required for IE8/9, where
	  // the `console.log` function doesn't have 'apply'
	  return 'object' === typeof console
	    && console.log
	    && Function.prototype.apply.call(console.log, console, arguments);
	}
	
	/**
	 * Save `namespaces`.
	 *
	 * @param {String} namespaces
	 * @api private
	 */
	
	function save(namespaces) {
	  try {
	    if (null == namespaces) {
	      exports.storage.removeItem('debug');
	    } else {
	      exports.storage.debug = namespaces;
	    }
	  } catch(e) {}
	}
	
	/**
	 * Load `namespaces`.
	 *
	 * @return {String} returns the previously persisted debug modes
	 * @api private
	 */
	
	function load() {
	  var r;
	  try {
	    r = exports.storage.debug;
	  } catch(e) {}
	
	  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
	  if (!r && typeof process !== 'undefined' && 'env' in process) {
	    r = ({"NODE_ENV":"production"}).DEBUG;
	  }
	
	  return r;
	}
	
	/**
	 * Enable namespaces listed in `localStorage.debug` initially.
	 */
	
	exports.enable(load());
	
	/**
	 * Localstorage attempts to return the localstorage.
	 *
	 * This is necessary because safari throws
	 * when a user disables cookies/localstorage
	 * and you attempt to access it.
	 *
	 * @return {LocalStorage}
	 * @api private
	 */
	
	function localstorage() {
	  try {
	    return window.localStorage;
	  } catch (e) {}
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(45)))

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * This is the common logic for both the Node.js and web browser
	 * implementations of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
	exports.coerce = coerce;
	exports.disable = disable;
	exports.enable = enable;
	exports.enabled = enabled;
	exports.humanize = __webpack_require__(406);
	
	/**
	 * The currently active debug mode names, and names to skip.
	 */
	
	exports.names = [];
	exports.skips = [];
	
	/**
	 * Map of special "%n" handling functions, for the debug "format" argument.
	 *
	 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
	 */
	
	exports.formatters = {};
	
	/**
	 * Previous log timestamp.
	 */
	
	var prevTime;
	
	/**
	 * Select a color.
	 * @param {String} namespace
	 * @return {Number}
	 * @api private
	 */
	
	function selectColor(namespace) {
	  var hash = 0, i;
	
	  for (i in namespace) {
	    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
	    hash |= 0; // Convert to 32bit integer
	  }
	
	  return exports.colors[Math.abs(hash) % exports.colors.length];
	}
	
	/**
	 * Create a debugger with the given `namespace`.
	 *
	 * @param {String} namespace
	 * @return {Function}
	 * @api public
	 */
	
	function createDebug(namespace) {
	
	  function debug() {
	    // disabled?
	    if (!debug.enabled) return;
	
	    var self = debug;
	
	    // set `diff` timestamp
	    var curr = +new Date();
	    var ms = curr - (prevTime || curr);
	    self.diff = ms;
	    self.prev = prevTime;
	    self.curr = curr;
	    prevTime = curr;
	
	    // turn the `arguments` into a proper Array
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	
	    args[0] = exports.coerce(args[0]);
	
	    if ('string' !== typeof args[0]) {
	      // anything else let's inspect with %O
	      args.unshift('%O');
	    }
	
	    // apply any `formatters` transformations
	    var index = 0;
	    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
	      // if we encounter an escaped % then don't increase the array index
	      if (match === '%%') return match;
	      index++;
	      var formatter = exports.formatters[format];
	      if ('function' === typeof formatter) {
	        var val = args[index];
	        match = formatter.call(self, val);
	
	        // now we need to remove `args[index]` since it's inlined in the `format`
	        args.splice(index, 1);
	        index--;
	      }
	      return match;
	    });
	
	    // apply env-specific formatting (colors, etc.)
	    exports.formatArgs.call(self, args);
	
	    var logFn = debug.log || exports.log || console.log.bind(console);
	    logFn.apply(self, args);
	  }
	
	  debug.namespace = namespace;
	  debug.enabled = exports.enabled(namespace);
	  debug.useColors = exports.useColors();
	  debug.color = selectColor(namespace);
	
	  // env-specific initialization logic for debug instances
	  if ('function' === typeof exports.init) {
	    exports.init(debug);
	  }
	
	  return debug;
	}
	
	/**
	 * Enables a debug mode by namespaces. This can include modes
	 * separated by a colon and wildcards.
	 *
	 * @param {String} namespaces
	 * @api public
	 */
	
	function enable(namespaces) {
	  exports.save(namespaces);
	
	  exports.names = [];
	  exports.skips = [];
	
	  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
	  var len = split.length;
	
	  for (var i = 0; i < len; i++) {
	    if (!split[i]) continue; // ignore empty strings
	    namespaces = split[i].replace(/\*/g, '.*?');
	    if (namespaces[0] === '-') {
	      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
	    } else {
	      exports.names.push(new RegExp('^' + namespaces + '$'));
	    }
	  }
	}
	
	/**
	 * Disable debug output.
	 *
	 * @api public
	 */
	
	function disable() {
	  exports.enable('');
	}
	
	/**
	 * Returns true if the given mode name is enabled, false otherwise.
	 *
	 * @param {String} name
	 * @return {Boolean}
	 * @api public
	 */
	
	function enabled(name) {
	  var i, len;
	  for (i = 0, len = exports.skips.length; i < len; i++) {
	    if (exports.skips[i].test(name)) {
	      return false;
	    }
	  }
	  for (i = 0, len = exports.names.length; i < len; i++) {
	    if (exports.names[i].test(name)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * Coerce `val`.
	 *
	 * @param {Mixed} val
	 * @return {Mixed}
	 * @api private
	 */
	
	function coerce(val) {
	  if (val instanceof Error) return val.stack || val.message;
	  return val;
	}


/***/ }),
/* 381 */
/***/ (function(module, exports) {

	module.exports = function deepFreeze (o) {
	  Object.freeze(o);
	
	  var oIsFunction = typeof o === "function";
	  var hasOwnProp = Object.prototype.hasOwnProperty;
	
	  Object.getOwnPropertyNames(o).forEach(function (prop) {
	    if (hasOwnProp.call(o, prop)
	    && (oIsFunction ? prop !== 'caller' && prop !== 'callee' && prop !== 'arguments' : true )
	    && o[prop] !== null
	    && (typeof o[prop] === "object" || typeof o[prop] === "function")
	    && !Object.isFrozen(o[prop])) {
	      deepFreeze(o[prop]);
	    }
	  });
	  
	  return o;
	};


/***/ }),
/* 382 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var detectElementOverflow = function detectElementOverflow(element, container) {
	  return {
	    get collidedTop() {
	      return element.getBoundingClientRect().top < container.getBoundingClientRect().top;
	    },
	    get collidedBottom() {
	      return element.getBoundingClientRect().bottom > container.getBoundingClientRect().bottom;
	    },
	    get collidedLeft() {
	      return element.getBoundingClientRect().left < container.getBoundingClientRect().left;
	    },
	    get collidedRight() {
	      return element.getBoundingClientRect().right > container.getBoundingClientRect().right;
	    },
	    get overflowTop() {
	      return container.getBoundingClientRect().top - element.getBoundingClientRect().top;
	    },
	    get overflowBottom() {
	      return element.getBoundingClientRect().bottom - container.getBoundingClientRect().bottom;
	    },
	    get overflowLeft() {
	      return container.getBoundingClientRect().left - element.getBoundingClientRect().left;
	    },
	    get overflowRight() {
	      return element.getBoundingClientRect().right - container.getBoundingClientRect().right;
	    }
	  };
	};
	
	exports.default = detectElementOverflow;

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {(function() {
	
	  // nb. This is for IE10 and lower _only_.
	  var supportCustomEvent = window.CustomEvent;
	  if (!supportCustomEvent || typeof supportCustomEvent === 'object') {
	    supportCustomEvent = function CustomEvent(event, x) {
	      x = x || {};
	      var ev = document.createEvent('CustomEvent');
	      ev.initCustomEvent(event, !!x.bubbles, !!x.cancelable, x.detail || null);
	      return ev;
	    };
	    supportCustomEvent.prototype = window.Event.prototype;
	  }
	
	  /**
	   * @param {Element} el to check for stacking context
	   * @return {boolean} whether this el or its parents creates a stacking context
	   */
	  function createsStackingContext(el) {
	    while (el && el !== document.body) {
	      var s = window.getComputedStyle(el);
	      var invalid = function(k, ok) {
	        return !(s[k] === undefined || s[k] === ok);
	      }
	      if (s.opacity < 1 ||
	          invalid('zIndex', 'auto') ||
	          invalid('transform', 'none') ||
	          invalid('mixBlendMode', 'normal') ||
	          invalid('filter', 'none') ||
	          invalid('perspective', 'none') ||
	          s['isolation'] === 'isolate' ||
	          s.position === 'fixed' ||
	          s.webkitOverflowScrolling === 'touch') {
	        return true;
	      }
	      el = el.parentElement;
	    }
	    return false;
	  }
	
	  /**
	   * Finds the nearest <dialog> from the passed element.
	   *
	   * @param {Element} el to search from
	   * @return {HTMLDialogElement} dialog found
	   */
	  function findNearestDialog(el) {
	    while (el) {
	      if (el.localName === 'dialog') {
	        return /** @type {HTMLDialogElement} */ (el);
	      }
	      el = el.parentElement;
	    }
	    return null;
	  }
	
	  /**
	   * Blur the specified element, as long as it's not the HTML body element.
	   * This works around an IE9/10 bug - blurring the body causes Windows to
	   * blur the whole application.
	   *
	   * @param {Element} el to blur
	   */
	  function safeBlur(el) {
	    if (el && el.blur && el !== document.body) {
	      el.blur();
	    }
	  }
	
	  /**
	   * @param {!NodeList} nodeList to search
	   * @param {Node} node to find
	   * @return {boolean} whether node is inside nodeList
	   */
	  function inNodeList(nodeList, node) {
	    for (var i = 0; i < nodeList.length; ++i) {
	      if (nodeList[i] === node) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * @param {HTMLFormElement} el to check
	   * @return {boolean} whether this form has method="dialog"
	   */
	  function isFormMethodDialog(el) {
	    if (!el || !el.hasAttribute('method')) {
	      return false;
	    }
	    return el.getAttribute('method').toLowerCase() === 'dialog';
	  }
	
	  /**
	   * @param {!HTMLDialogElement} dialog to upgrade
	   * @constructor
	   */
	  function dialogPolyfillInfo(dialog) {
	    this.dialog_ = dialog;
	    this.replacedStyleTop_ = false;
	    this.openAsModal_ = false;
	
	    // Set a11y role. Browsers that support dialog implicitly know this already.
	    if (!dialog.hasAttribute('role')) {
	      dialog.setAttribute('role', 'dialog');
	    }
	
	    dialog.show = this.show.bind(this);
	    dialog.showModal = this.showModal.bind(this);
	    dialog.close = this.close.bind(this);
	
	    if (!('returnValue' in dialog)) {
	      dialog.returnValue = '';
	    }
	
	    if ('MutationObserver' in window) {
	      var mo = new MutationObserver(this.maybeHideModal.bind(this));
	      mo.observe(dialog, {attributes: true, attributeFilter: ['open']});
	    } else {
	      // IE10 and below support. Note that DOMNodeRemoved etc fire _before_ removal. They also
	      // seem to fire even if the element was removed as part of a parent removal. Use the removed
	      // events to force downgrade (useful if removed/immediately added).
	      var removed = false;
	      var cb = function() {
	        removed ? this.downgradeModal() : this.maybeHideModal();
	        removed = false;
	      }.bind(this);
	      var timeout;
	      var delayModel = function(ev) {
	        if (ev.target !== dialog) { return; }  // not for a child element
	        var cand = 'DOMNodeRemoved';
	        removed |= (ev.type.substr(0, cand.length) === cand);
	        window.clearTimeout(timeout);
	        timeout = window.setTimeout(cb, 0);
	      };
	      ['DOMAttrModified', 'DOMNodeRemoved', 'DOMNodeRemovedFromDocument'].forEach(function(name) {
	        dialog.addEventListener(name, delayModel);
	      });
	    }
	    // Note that the DOM is observed inside DialogManager while any dialog
	    // is being displayed as a modal, to catch modal removal from the DOM.
	
	    Object.defineProperty(dialog, 'open', {
	      set: this.setOpen.bind(this),
	      get: dialog.hasAttribute.bind(dialog, 'open')
	    });
	
	    this.backdrop_ = document.createElement('div');
	    this.backdrop_.className = 'backdrop';
	    this.backdrop_.addEventListener('click', this.backdropClick_.bind(this));
	  }
	
	  dialogPolyfillInfo.prototype = {
	
	    get dialog() {
	      return this.dialog_;
	    },
	
	    /**
	     * Maybe remove this dialog from the modal top layer. This is called when
	     * a modal dialog may no longer be tenable, e.g., when the dialog is no
	     * longer open or is no longer part of the DOM.
	     */
	    maybeHideModal: function() {
	      if (this.dialog_.hasAttribute('open') && document.body.contains(this.dialog_)) { return; }
	      this.downgradeModal();
	    },
	
	    /**
	     * Remove this dialog from the modal top layer, leaving it as a non-modal.
	     */
	    downgradeModal: function() {
	      if (!this.openAsModal_) { return; }
	      this.openAsModal_ = false;
	      this.dialog_.style.zIndex = '';
	
	      // This won't match the native <dialog> exactly because if the user set top on a centered
	      // polyfill dialog, that top gets thrown away when the dialog is closed. Not sure it's
	      // possible to polyfill this perfectly.
	      if (this.replacedStyleTop_) {
	        this.dialog_.style.top = '';
	        this.replacedStyleTop_ = false;
	      }
	
	      // Clear the backdrop and remove from the manager.
	      this.backdrop_.parentNode && this.backdrop_.parentNode.removeChild(this.backdrop_);
	      dialogPolyfill.dm.removeDialog(this);
	    },
	
	    /**
	     * @param {boolean} value whether to open or close this dialog
	     */
	    setOpen: function(value) {
	      if (value) {
	        this.dialog_.hasAttribute('open') || this.dialog_.setAttribute('open', '');
	      } else {
	        this.dialog_.removeAttribute('open');
	        this.maybeHideModal();  // nb. redundant with MutationObserver
	      }
	    },
	
	    /**
	     * Handles clicks on the fake .backdrop element, redirecting them as if
	     * they were on the dialog itself.
	     *
	     * @param {!Event} e to redirect
	     */
	    backdropClick_: function(e) {
	      if (!this.dialog_.hasAttribute('tabindex')) {
	        // Clicking on the backdrop should move the implicit cursor, even if dialog cannot be
	        // focused. Create a fake thing to focus on. If the backdrop was _before_ the dialog, this
	        // would not be needed - clicks would move the implicit cursor there.
	        var fake = document.createElement('div');
	        this.dialog_.insertBefore(fake, this.dialog_.firstChild);
	        fake.tabIndex = -1;
	        fake.focus();
	        this.dialog_.removeChild(fake);
	      } else {
	        this.dialog_.focus();
	      }
	
	      var redirectedEvent = document.createEvent('MouseEvents');
	      redirectedEvent.initMouseEvent(e.type, e.bubbles, e.cancelable, window,
	          e.detail, e.screenX, e.screenY, e.clientX, e.clientY, e.ctrlKey,
	          e.altKey, e.shiftKey, e.metaKey, e.button, e.relatedTarget);
	      this.dialog_.dispatchEvent(redirectedEvent);
	      e.stopPropagation();
	    },
	
	    /**
	     * Focuses on the first focusable element within the dialog. This will always blur the current
	     * focus, even if nothing within the dialog is found.
	     */
	    focus_: function() {
	      // Find element with `autofocus` attribute, or fall back to the first form/tabindex control.
	      var target = this.dialog_.querySelector('[autofocus]:not([disabled])');
	      if (!target && this.dialog_.tabIndex >= 0) {
	        target = this.dialog_;
	      }
	      if (!target) {
	        // Note that this is 'any focusable area'. This list is probably not exhaustive, but the
	        // alternative involves stepping through and trying to focus everything.
	        var opts = ['button', 'input', 'keygen', 'select', 'textarea'];
	        var query = opts.map(function(el) {
	          return el + ':not([disabled])';
	        });
	        // TODO(samthor): tabindex values that are not numeric are not focusable.
	        query.push('[tabindex]:not([disabled]):not([tabindex=""])');  // tabindex != "", not disabled
	        target = this.dialog_.querySelector(query.join(', '));
	      }
	      safeBlur(document.activeElement);
	      target && target.focus();
	    },
	
	    /**
	     * Sets the zIndex for the backdrop and dialog.
	     *
	     * @param {number} dialogZ
	     * @param {number} backdropZ
	     */
	    updateZIndex: function(dialogZ, backdropZ) {
	      if (dialogZ < backdropZ) {
	        throw new Error('dialogZ should never be < backdropZ');
	      }
	      this.dialog_.style.zIndex = dialogZ;
	      this.backdrop_.style.zIndex = backdropZ;
	    },
	
	    /**
	     * Shows the dialog. If the dialog is already open, this does nothing.
	     */
	    show: function() {
	      if (!this.dialog_.open) {
	        this.setOpen(true);
	        this.focus_();
	      }
	    },
	
	    /**
	     * Show this dialog modally.
	     */
	    showModal: function() {
	      if (this.dialog_.hasAttribute('open')) {
	        throw new Error('Failed to execute \'showModal\' on dialog: The element is already open, and therefore cannot be opened modally.');
	      }
	      if (!document.body.contains(this.dialog_)) {
	        throw new Error('Failed to execute \'showModal\' on dialog: The element is not in a Document.');
	      }
	      if (!dialogPolyfill.dm.pushDialog(this)) {
	        throw new Error('Failed to execute \'showModal\' on dialog: There are too many open modal dialogs.');
	      }
	
	      if (createsStackingContext(this.dialog_.parentElement)) {
	        console.warn('A dialog is being shown inside a stacking context. ' +
	            'This may cause it to be unusable. For more information, see this link: ' +
	            'https://github.com/GoogleChrome/dialog-polyfill/#stacking-context');
	      }
	
	      this.setOpen(true);
	      this.openAsModal_ = true;
	
	      // Optionally center vertically, relative to the current viewport.
	      if (dialogPolyfill.needsCentering(this.dialog_)) {
	        dialogPolyfill.reposition(this.dialog_);
	        this.replacedStyleTop_ = true;
	      } else {
	        this.replacedStyleTop_ = false;
	      }
	
	      // Insert backdrop.
	      this.dialog_.parentNode.insertBefore(this.backdrop_, this.dialog_.nextSibling);
	
	      // Focus on whatever inside the dialog.
	      this.focus_();
	    },
	
	    /**
	     * Closes this HTMLDialogElement. This is optional vs clearing the open
	     * attribute, however this fires a 'close' event.
	     *
	     * @param {string=} opt_returnValue to use as the returnValue
	     */
	    close: function(opt_returnValue) {
	      if (!this.dialog_.hasAttribute('open')) {
	        throw new Error('Failed to execute \'close\' on dialog: The element does not have an \'open\' attribute, and therefore cannot be closed.');
	      }
	      this.setOpen(false);
	
	      // Leave returnValue untouched in case it was set directly on the element
	      if (opt_returnValue !== undefined) {
	        this.dialog_.returnValue = opt_returnValue;
	      }
	
	      // Triggering "close" event for any attached listeners on the <dialog>.
	      var closeEvent = new supportCustomEvent('close', {
	        bubbles: false,
	        cancelable: false
	      });
	      this.dialog_.dispatchEvent(closeEvent);
	    }
	
	  };
	
	  var dialogPolyfill = {};
	
	  dialogPolyfill.reposition = function(element) {
	    var scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
	    var topValue = scrollTop + (window.innerHeight - element.offsetHeight) / 2;
	    element.style.top = Math.max(scrollTop, topValue) + 'px';
	  };
	
	  dialogPolyfill.isInlinePositionSetByStylesheet = function(element) {
	    for (var i = 0; i < document.styleSheets.length; ++i) {
	      var styleSheet = document.styleSheets[i];
	      var cssRules = null;
	      // Some browsers throw on cssRules.
	      try {
	        cssRules = styleSheet.cssRules;
	      } catch (e) {}
	      if (!cssRules) { continue; }
	      for (var j = 0; j < cssRules.length; ++j) {
	        var rule = cssRules[j];
	        var selectedNodes = null;
	        // Ignore errors on invalid selector texts.
	        try {
	          selectedNodes = document.querySelectorAll(rule.selectorText);
	        } catch(e) {}
	        if (!selectedNodes || !inNodeList(selectedNodes, element)) {
	          continue;
	        }
	        var cssTop = rule.style.getPropertyValue('top');
	        var cssBottom = rule.style.getPropertyValue('bottom');
	        if ((cssTop && cssTop !== 'auto') || (cssBottom && cssBottom !== 'auto')) {
	          return true;
	        }
	      }
	    }
	    return false;
	  };
	
	  dialogPolyfill.needsCentering = function(dialog) {
	    var computedStyle = window.getComputedStyle(dialog);
	    if (computedStyle.position !== 'absolute') {
	      return false;
	    }
	
	    // We must determine whether the top/bottom specified value is non-auto.  In
	    // WebKit/Blink, checking computedStyle.top == 'auto' is sufficient, but
	    // Firefox returns the used value. So we do this crazy thing instead: check
	    // the inline style and then go through CSS rules.
	    if ((dialog.style.top !== 'auto' && dialog.style.top !== '') ||
	        (dialog.style.bottom !== 'auto' && dialog.style.bottom !== '')) {
	      return false;
	    }
	    return !dialogPolyfill.isInlinePositionSetByStylesheet(dialog);
	  };
	
	  /**
	   * @param {!Element} element to force upgrade
	   */
	  dialogPolyfill.forceRegisterDialog = function(element) {
	    if (window.HTMLDialogElement || element.showModal) {
	      console.warn('This browser already supports <dialog>, the polyfill ' +
	          'may not work correctly', element);
	    }
	    if (element.localName !== 'dialog') {
	      throw new Error('Failed to register dialog: The element is not a dialog.');
	    }
	    new dialogPolyfillInfo(/** @type {!HTMLDialogElement} */ (element));
	  };
	
	  /**
	   * @param {!Element} element to upgrade, if necessary
	   */
	  dialogPolyfill.registerDialog = function(element) {
	    if (!element.showModal) {
	      dialogPolyfill.forceRegisterDialog(element);
	    }
	  };
	
	  /**
	   * @constructor
	   */
	  dialogPolyfill.DialogManager = function() {
	    /** @type {!Array<!dialogPolyfillInfo>} */
	    this.pendingDialogStack = [];
	
	    var checkDOM = this.checkDOM_.bind(this);
	
	    // The overlay is used to simulate how a modal dialog blocks the document.
	    // The blocking dialog is positioned on top of the overlay, and the rest of
	    // the dialogs on the pending dialog stack are positioned below it. In the
	    // actual implementation, the modal dialog stacking is controlled by the
	    // top layer, where z-index has no effect.
	    this.overlay = document.createElement('div');
	    this.overlay.className = '_dialog_overlay';
	    this.overlay.addEventListener('click', function(e) {
	      this.forwardTab_ = undefined;
	      e.stopPropagation();
	      checkDOM([]);  // sanity-check DOM
	    }.bind(this));
	
	    this.handleKey_ = this.handleKey_.bind(this);
	    this.handleFocus_ = this.handleFocus_.bind(this);
	
	    this.zIndexLow_ = 100000;
	    this.zIndexHigh_ = 100000 + 150;
	
	    this.forwardTab_ = undefined;
	
	    if ('MutationObserver' in window) {
	      this.mo_ = new MutationObserver(function(records) {
	        var removed = [];
	        records.forEach(function(rec) {
	          for (var i = 0, c; c = rec.removedNodes[i]; ++i) {
	            if (!(c instanceof Element)) {
	              continue;
	            } else if (c.localName === 'dialog') {
	              removed.push(c);
	            }
	            removed = removed.concat(c.querySelectorAll('dialog'));
	          }
	        });
	        removed.length && checkDOM(removed);
	      });
	    }
	  };
	
	  /**
	   * Called on the first modal dialog being shown. Adds the overlay and related
	   * handlers.
	   */
	  dialogPolyfill.DialogManager.prototype.blockDocument = function() {
	    document.documentElement.addEventListener('focus', this.handleFocus_, true);
	    document.addEventListener('keydown', this.handleKey_);
	    this.mo_ && this.mo_.observe(document, {childList: true, subtree: true});
	  };
	
	  /**
	   * Called on the first modal dialog being removed, i.e., when no more modal
	   * dialogs are visible.
	   */
	  dialogPolyfill.DialogManager.prototype.unblockDocument = function() {
	    document.documentElement.removeEventListener('focus', this.handleFocus_, true);
	    document.removeEventListener('keydown', this.handleKey_);
	    this.mo_ && this.mo_.disconnect();
	  };
	
	  /**
	   * Updates the stacking of all known dialogs.
	   */
	  dialogPolyfill.DialogManager.prototype.updateStacking = function() {
	    var zIndex = this.zIndexHigh_;
	
	    for (var i = 0, dpi; dpi = this.pendingDialogStack[i]; ++i) {
	      dpi.updateZIndex(--zIndex, --zIndex);
	      if (i === 0) {
	        this.overlay.style.zIndex = --zIndex;
	      }
	    }
	
	    // Make the overlay a sibling of the dialog itself.
	    var last = this.pendingDialogStack[0];
	    if (last) {
	      var p = last.dialog.parentNode || document.body;
	      p.appendChild(this.overlay);
	    } else if (this.overlay.parentNode) {
	      this.overlay.parentNode.removeChild(this.overlay);
	    }
	  };
	
	  /**
	   * @param {Element} candidate to check if contained or is the top-most modal dialog
	   * @return {boolean} whether candidate is contained in top dialog
	   */
	  dialogPolyfill.DialogManager.prototype.containedByTopDialog_ = function(candidate) {
	    while (candidate = findNearestDialog(candidate)) {
	      for (var i = 0, dpi; dpi = this.pendingDialogStack[i]; ++i) {
	        if (dpi.dialog === candidate) {
	          return i === 0;  // only valid if top-most
	        }
	      }
	      candidate = candidate.parentElement;
	    }
	    return false;
	  };
	
	  dialogPolyfill.DialogManager.prototype.handleFocus_ = function(event) {
	    if (this.containedByTopDialog_(event.target)) { return; }
	
	    event.preventDefault();
	    event.stopPropagation();
	    safeBlur(/** @type {Element} */ (event.target));
	
	    if (this.forwardTab_ === undefined) { return; }  // move focus only from a tab key
	
	    var dpi = this.pendingDialogStack[0];
	    var dialog = dpi.dialog;
	    var position = dialog.compareDocumentPosition(event.target);
	    if (position & Node.DOCUMENT_POSITION_PRECEDING) {
	      if (this.forwardTab_) {  // forward
	        dpi.focus_();
	      } else {  // backwards
	        document.documentElement.focus();
	      }
	    } else {
	      // TODO: Focus after the dialog, is ignored.
	    }
	
	    return false;
	  };
	
	  dialogPolyfill.DialogManager.prototype.handleKey_ = function(event) {
	    this.forwardTab_ = undefined;
	    if (event.keyCode === 27) {
	      event.preventDefault();
	      event.stopPropagation();
	      var cancelEvent = new supportCustomEvent('cancel', {
	        bubbles: false,
	        cancelable: true
	      });
	      var dpi = this.pendingDialogStack[0];
	      if (dpi && dpi.dialog.dispatchEvent(cancelEvent)) {
	        dpi.dialog.close();
	      }
	    } else if (event.keyCode === 9) {
	      this.forwardTab_ = !event.shiftKey;
	    }
	  };
	
	  /**
	   * Finds and downgrades any known modal dialogs that are no longer displayed. Dialogs that are
	   * removed and immediately readded don't stay modal, they become normal.
	   *
	   * @param {!Array<!HTMLDialogElement>} removed that have definitely been removed
	   */
	  dialogPolyfill.DialogManager.prototype.checkDOM_ = function(removed) {
	    // This operates on a clone because it may cause it to change. Each change also calls
	    // updateStacking, which only actually needs to happen once. But who removes many modal dialogs
	    // at a time?!
	    var clone = this.pendingDialogStack.slice();
	    clone.forEach(function(dpi) {
	      if (removed.indexOf(dpi.dialog) !== -1) {
	        dpi.downgradeModal();
	      } else {
	        dpi.maybeHideModal();
	      }
	    });
	  };
	
	  /**
	   * @param {!dialogPolyfillInfo} dpi
	   * @return {boolean} whether the dialog was allowed
	   */
	  dialogPolyfill.DialogManager.prototype.pushDialog = function(dpi) {
	    var allowed = (this.zIndexHigh_ - this.zIndexLow_) / 2 - 1;
	    if (this.pendingDialogStack.length >= allowed) {
	      return false;
	    }
	    if (this.pendingDialogStack.unshift(dpi) === 1) {
	      this.blockDocument();
	    }
	    this.updateStacking();
	    return true;
	  };
	
	  /**
	   * @param {!dialogPolyfillInfo} dpi
	   */
	  dialogPolyfill.DialogManager.prototype.removeDialog = function(dpi) {
	    var index = this.pendingDialogStack.indexOf(dpi);
	    if (index === -1) { return; }
	
	    this.pendingDialogStack.splice(index, 1);
	    if (this.pendingDialogStack.length === 0) {
	      this.unblockDocument();
	    }
	    this.updateStacking();
	  };
	
	  dialogPolyfill.dm = new dialogPolyfill.DialogManager();
	  dialogPolyfill.formSubmitter = null;
	  dialogPolyfill.useValue = null;
	
	  /**
	   * Installs global handlers, such as click listers and native method overrides. These are needed
	   * even if a no dialog is registered, as they deal with <form method="dialog">.
	   */
	  if (window.HTMLDialogElement === undefined) {
	
	    /**
	     * If HTMLFormElement translates method="DIALOG" into 'get', then replace the descriptor with
	     * one that returns the correct value.
	     */
	    var testForm = document.createElement('form');
	    testForm.setAttribute('method', 'dialog');
	    if (testForm.method !== 'dialog') {
	      var methodDescriptor = Object.getOwnPropertyDescriptor(HTMLFormElement.prototype, 'method');
	      if (methodDescriptor) {
	        // nb. Some older iOS and older PhantomJS fail to return the descriptor. Don't do anything
	        // and don't bother to update the element.
	        var realGet = methodDescriptor.get;
	        methodDescriptor.get = function() {
	          if (isFormMethodDialog(this)) {
	            return 'dialog';
	          }
	          return realGet.call(this);
	        };
	        var realSet = methodDescriptor.set;
	        methodDescriptor.set = function(v) {
	          if (typeof v === 'string' && v.toLowerCase() === 'dialog') {
	            return this.setAttribute('method', v);
	          }
	          return realSet.call(this, v);
	        };
	        Object.defineProperty(HTMLFormElement.prototype, 'method', methodDescriptor);
	      }
	    }
	
	    /**
	     * Global 'click' handler, to capture the <input type="submit"> or <button> element which has
	     * submitted a <form method="dialog">. Needed as Safari and others don't report this inside
	     * document.activeElement.
	     */
	    document.addEventListener('click', function(ev) {
	      dialogPolyfill.formSubmitter = null;
	      dialogPolyfill.useValue = null;
	      if (ev.defaultPrevented) { return; }  // e.g. a submit which prevents default submission
	
	      var target = /** @type {Element} */ (ev.target);
	      if (!target || !isFormMethodDialog(target.form)) { return; }
	
	      var valid = (target.type === 'submit' && ['button', 'input'].indexOf(target.localName) > -1);
	      if (!valid) {
	        if (!(target.localName === 'input' && target.type === 'image')) { return; }
	        // this is a <input type="image">, which can submit forms
	        dialogPolyfill.useValue = ev.offsetX + ',' + ev.offsetY;
	      }
	
	      var dialog = findNearestDialog(target);
	      if (!dialog) { return; }
	
	      dialogPolyfill.formSubmitter = target;
	    }, false);
	
	    /**
	     * Replace the native HTMLFormElement.submit() method, as it won't fire the
	     * submit event and give us a chance to respond.
	     */
	    var nativeFormSubmit = HTMLFormElement.prototype.submit;
	    var replacementFormSubmit = function () {
	      if (!isFormMethodDialog(this)) {
	        return nativeFormSubmit.call(this);
	      }
	      var dialog = findNearestDialog(this);
	      dialog && dialog.close();
	    };
	    HTMLFormElement.prototype.submit = replacementFormSubmit;
	
	    /**
	     * Global form 'dialog' method handler. Closes a dialog correctly on submit
	     * and possibly sets its return value.
	     */
	    document.addEventListener('submit', function(ev) {
	      var form = /** @type {HTMLFormElement} */ (ev.target);
	      if (!isFormMethodDialog(form)) { return; }
	      ev.preventDefault();
	
	      var dialog = findNearestDialog(form);
	      if (!dialog) { return; }
	
	      // Forms can only be submitted via .submit() or a click (?), but anyway: sanity-check that
	      // the submitter is correct before using its value as .returnValue.
	      var s = dialogPolyfill.formSubmitter;
	      if (s && s.form === form) {
	        dialog.close(dialogPolyfill.useValue || s.value);
	      } else {
	        dialog.close();
	      }
	      dialogPolyfill.formSubmitter = null;
	    }, true);
	  }
	
	  dialogPolyfill['forceRegisterDialog'] = dialogPolyfill.forceRegisterDialog;
	  dialogPolyfill['registerDialog'] = dialogPolyfill.registerDialog;
	
	  if ("function" === 'function' && 'amd' in __webpack_require__(252)) {
	    // AMD support
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() { return dialogPolyfill; }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof module === 'object' && typeof module['exports'] === 'object') {
	    // CommonJS support
	    module['exports'] = dialogPolyfill;
	  } else {
	    // all others
	    window['dialogPolyfill'] = dialogPolyfill;
	  }
	})();
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(33)(module)))

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),
/* 385 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(265);
	
	//# sourceMappingURL=index.cjs.js.map


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(269);
	
	//# sourceMappingURL=index.cjs.js.map


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(271);
	
	//# sourceMappingURL=index.cjs.js.map


/***/ }),
/* 389 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var loopAsync = exports.loopAsync = function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var isSync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  var done = function done() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    isDone = true;
	
	    if (isSync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = args;
	      return;
	    }
	
	    callback.apply(undefined, args);
	  };
	
	  var next = function next() {
	    if (isDone) return;
	
	    hasNext = true;
	
	    if (isSync) return; // Iterate instead of recursing if possible.
	
	    isSync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work(currentTurn++, next, done);
	    }
	
	    isSync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(undefined, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  };
	
	  next();
	};

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;
	
	var _BrowserProtocol = __webpack_require__(111);
	
	Object.defineProperty(exports, 'getUserConfirmation', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.getUserConfirmation;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.go;
	  }
	});
	
	var _warning = __webpack_require__(32);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _LocationUtils = __webpack_require__(44);
	
	var _DOMUtils = __webpack_require__(84);
	
	var _DOMStateStorage = __webpack_require__(166);
	
	var _PathUtils = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HashChangeEvent = 'hashchange';
	
	var getHashPath = function getHashPath() {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  var href = window.location.href;
	  var hashIndex = href.indexOf('#');
	  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
	};
	
	var pushHashPath = function pushHashPath(path) {
	  return window.location.hash = path;
	};
	
	var replaceHashPath = function replaceHashPath(path) {
	  var hashIndex = window.location.href.indexOf('#');
	
	  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
	};
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation(pathCoder, queryKey) {
	  var path = pathCoder.decodePath(getHashPath());
	  var key = (0, _PathUtils.getQueryStringValueFromPath)(path, queryKey);
	
	  var state = void 0;
	  if (key) {
	    path = (0, _PathUtils.stripQueryStringValueFromPath)(path, queryKey);
	    state = (0, _DOMStateStorage.readState)(key);
	  }
	
	  var init = (0, _PathUtils.parsePath)(path);
	  init.state = state;
	
	  return (0, _LocationUtils.createLocation)(init, undefined, key);
	};
	
	var prevLocation = void 0;
	
	var startListener = exports.startListener = function startListener(listener, pathCoder, queryKey) {
	  var handleHashChange = function handleHashChange() {
	    var path = getHashPath();
	    var encodedPath = pathCoder.encodePath(path);
	
	    if (path !== encodedPath) {
	      // Always be sure we have a properly-encoded hash.
	      replaceHashPath(encodedPath);
	    } else {
	      var currentLocation = getCurrentLocation(pathCoder, queryKey);
	
	      if (prevLocation && currentLocation.key && prevLocation.key === currentLocation.key) return; // Ignore extraneous hashchange events
	
	      prevLocation = currentLocation;
	
	      listener(currentLocation);
	    }
	  };
	
	  // Ensure the hash is encoded properly.
	  var path = getHashPath();
	  var encodedPath = pathCoder.encodePath(path);
	
	  if (path !== encodedPath) replaceHashPath(encodedPath);
	
	  (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
	
	  return function () {
	    return (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
	  };
	};
	
	var updateLocation = function updateLocation(location, pathCoder, queryKey, updateHash) {
	  var state = location.state,
	      key = location.key;
	
	
	  var path = pathCoder.encodePath((0, _PathUtils.createPath)(location));
	
	  if (state !== undefined) {
	    path = (0, _PathUtils.addQueryStringValueToPath)(path, queryKey, key);
	    (0, _DOMStateStorage.saveState)(key, state);
	  }
	
	  prevLocation = location;
	
	  updateHash(path);
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location, pathCoder, queryKey) {
	  return updateLocation(location, pathCoder, queryKey, function (path) {
	    if (getHashPath() !== path) {
	      pushHashPath(path);
	    } else {
	       false ? (0, _warning2.default)(false, 'You cannot PUSH the same path using hash history') : void 0;
	    }
	  });
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location, pathCoder, queryKey) {
	  return updateLocation(location, pathCoder, queryKey, function (path) {
	    if (getHashPath() !== path) replaceHashPath(path);
	  });
	};

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.replaceLocation = exports.pushLocation = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;
	
	var _BrowserProtocol = __webpack_require__(111);
	
	Object.defineProperty(exports, 'getUserConfirmation', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.getUserConfirmation;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.go;
	  }
	});
	
	var _LocationUtils = __webpack_require__(44);
	
	var _PathUtils = __webpack_require__(28);
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
	  return (0, _LocationUtils.createLocation)(window.location);
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location) {
	  window.location.href = (0, _PathUtils.createPath)(location);
	  return false; // Don't update location
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
	  window.location.replace((0, _PathUtils.createPath)(location));
	  return false; // Don't update location
	};

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(14);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(112);
	
	var _BrowserProtocol = __webpack_require__(111);
	
	var BrowserProtocol = _interopRequireWildcard(_BrowserProtocol);
	
	var _RefreshProtocol = __webpack_require__(391);
	
	var RefreshProtocol = _interopRequireWildcard(_RefreshProtocol);
	
	var _DOMUtils = __webpack_require__(84);
	
	var _createHistory = __webpack_require__(113);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Creates and returns a history object that uses HTML5's history API
	 * (pushState, replaceState, and the popstate event) to manage history.
	 * This is the recommended method of managing history in browsers because
	 * it provides the cleanest URLs.
	 *
	 * Note: In browsers that do not support the HTML5 history API full
	 * page reloads will be used to preserve clean URLs. You can force this
	 * behavior using { forceRefresh: true } in options.
	 */
	var createBrowserHistory = function createBrowserHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Browser history needs a DOM') : (0, _invariant2.default)(false) : void 0;
	
	  var useRefresh = options.forceRefresh || !(0, _DOMUtils.supportsHistory)();
	  var Protocol = useRefresh ? RefreshProtocol : BrowserProtocol;
	
	  var getUserConfirmation = Protocol.getUserConfirmation,
	      getCurrentLocation = Protocol.getCurrentLocation,
	      pushLocation = Protocol.pushLocation,
	      replaceLocation = Protocol.replaceLocation,
	      go = Protocol.go;
	
	
	  var history = (0, _createHistory2.default)(_extends({
	    getUserConfirmation: getUserConfirmation }, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: go
	  }));
	
	  var listenerCount = 0,
	      stopListener = void 0;
	
	  var startListener = function startListener(listener, before) {
	    if (++listenerCount === 1) stopListener = BrowserProtocol.startListener(history.transitionTo);
	
	    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopListener();
	    };
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    return startListener(listener, true);
	  };
	
	  var listen = function listen(listener) {
	    return startListener(listener, false);
	  };
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen
	  });
	};
	
	exports.default = createBrowserHistory;

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(32);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(14);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(112);
	
	var _DOMUtils = __webpack_require__(84);
	
	var _HashProtocol = __webpack_require__(390);
	
	var HashProtocol = _interopRequireWildcard(_HashProtocol);
	
	var _createHistory = __webpack_require__(113);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DefaultQueryKey = '_k';
	
	var addLeadingSlash = function addLeadingSlash(path) {
	  return path.charAt(0) === '/' ? path : '/' + path;
	};
	
	var HashPathCoders = {
	  hashbang: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '!' ? path : '!' + path;
	    },
	    decodePath: function decodePath(path) {
	      return path.charAt(0) === '!' ? path.substring(1) : path;
	    }
	  },
	  noslash: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '/' ? path.substring(1) : path;
	    },
	    decodePath: addLeadingSlash
	  },
	  slash: {
	    encodePath: addLeadingSlash,
	    decodePath: addLeadingSlash
	  }
	};
	
	var createHashHistory = function createHashHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Hash history needs a DOM') : (0, _invariant2.default)(false) : void 0;
	
	  var queryKey = options.queryKey,
	      hashType = options.hashType;
	
	
	   false ? (0, _warning2.default)(queryKey !== false, 'Using { queryKey: false } no longer works. Instead, just don\'t ' + 'use location state if you don\'t want a key in your URL query string') : void 0;
	
	  if (typeof queryKey !== 'string') queryKey = DefaultQueryKey;
	
	  if (hashType == null) hashType = 'slash';
	
	  if (!(hashType in HashPathCoders)) {
	     false ? (0, _warning2.default)(false, 'Invalid hash type: %s', hashType) : void 0;
	
	    hashType = 'slash';
	  }
	
	  var pathCoder = HashPathCoders[hashType];
	
	  var getUserConfirmation = HashProtocol.getUserConfirmation;
	
	
	  var getCurrentLocation = function getCurrentLocation() {
	    return HashProtocol.getCurrentLocation(pathCoder, queryKey);
	  };
	
	  var pushLocation = function pushLocation(location) {
	    return HashProtocol.pushLocation(location, pathCoder, queryKey);
	  };
	
	  var replaceLocation = function replaceLocation(location) {
	    return HashProtocol.replaceLocation(location, pathCoder, queryKey);
	  };
	
	  var history = (0, _createHistory2.default)(_extends({
	    getUserConfirmation: getUserConfirmation }, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: HashProtocol.go
	  }));
	
	  var listenerCount = 0,
	      stopListener = void 0;
	
	  var startListener = function startListener(listener, before) {
	    if (++listenerCount === 1) stopListener = HashProtocol.startListener(history.transitionTo, pathCoder, queryKey);
	
	    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopListener();
	    };
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    return startListener(listener, true);
	  };
	
	  var listen = function listen(listener) {
	    return startListener(listener, false);
	  };
	
	  var goIsSupportedWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();
	
	  var go = function go(n) {
	     false ? (0, _warning2.default)(goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
	
	    history.go(n);
	  };
	
	  var createHref = function createHref(path) {
	    return '#' + pathCoder.encodePath(history.createHref(path));
	  };
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    go: go,
	    createHref: createHref
	  });
	};
	
	exports.default = createHashHistory;

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(32);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(14);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _LocationUtils = __webpack_require__(44);
	
	var _PathUtils = __webpack_require__(28);
	
	var _createHistory = __webpack_require__(113);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	var _Actions = __webpack_require__(83);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createStateStorage = function createStateStorage(entries) {
	  return entries.filter(function (entry) {
	    return entry.state;
	  }).reduce(function (memo, entry) {
	    memo[entry.key] = entry.state;
	    return memo;
	  }, {});
	};
	
	var createMemoryHistory = function createMemoryHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  if (Array.isArray(options)) {
	    options = { entries: options };
	  } else if (typeof options === 'string') {
	    options = { entries: [options] };
	  }
	
	  var getCurrentLocation = function getCurrentLocation() {
	    var entry = entries[current];
	    var path = (0, _PathUtils.createPath)(entry);
	
	    var key = void 0,
	        state = void 0;
	    if (entry.key) {
	      key = entry.key;
	      state = readState(key);
	    }
	
	    var init = (0, _PathUtils.parsePath)(path);
	
	    return (0, _LocationUtils.createLocation)(_extends({}, init, { state: state }), undefined, key);
	  };
	
	  var canGo = function canGo(n) {
	    var index = current + n;
	    return index >= 0 && index < entries.length;
	  };
	
	  var go = function go(n) {
	    if (!n) return;
	
	    if (!canGo(n)) {
	       false ? (0, _warning2.default)(false, 'Cannot go(%s) there is not enough history', n) : void 0;
	
	      return;
	    }
	
	    current += n;
	    var currentLocation = getCurrentLocation();
	
	    // Change action to POP
	    history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
	  };
	
	  var pushLocation = function pushLocation(location) {
	    current += 1;
	
	    if (current < entries.length) entries.splice(current);
	
	    entries.push(location);
	
	    saveState(location.key, location.state);
	  };
	
	  var replaceLocation = function replaceLocation(location) {
	    entries[current] = location;
	    saveState(location.key, location.state);
	  };
	
	  var history = (0, _createHistory2.default)(_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: go
	  }));
	
	  var _options = options,
	      entries = _options.entries,
	      current = _options.current;
	
	
	  if (typeof entries === 'string') {
	    entries = [entries];
	  } else if (!Array.isArray(entries)) {
	    entries = ['/'];
	  }
	
	  entries = entries.map(function (entry) {
	    return (0, _LocationUtils.createLocation)(entry);
	  });
	
	  if (current == null) {
	    current = entries.length - 1;
	  } else {
	    !(current >= 0 && current < entries.length) ?  false ? (0, _invariant2.default)(false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : (0, _invariant2.default)(false) : void 0;
	  }
	
	  var storage = createStateStorage(entries);
	
	  var saveState = function saveState(key, state) {
	    return storage[key] = state;
	  };
	
	  var readState = function readState(key) {
	    return storage[key];
	  };
	
	  return _extends({}, history, {
	    canGo: canGo
	  });
	};
	
	exports.default = createMemoryHistory;

/***/ }),
/* 395 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = hoistNonReactMethods;
	var REACT_PROTOTYPE = {
	  autobind: true,
	  childContextTypes: true,
	  componentDidMount: true,
	  componentDidUpdate: true,
	  componentWillMount: true,
	  componentWillReceiveProps: true,
	  componentWillUnmount: true,
	  componentWillUpdate: true,
	  contextTypes: true,
	  displayName: true,
	  forceUpdate: true,
	  getChildContext: true,
	  getDefaultProps: true,
	  getDOMNode: true,
	  getInitialState: true,
	  isMounted: true,
	  mixins: true,
	  propTypes: true,
	  render: true,
	  replaceProps: true,
	  replaceState: true,
	  setProps: true,
	  setState: true,
	  shouldComponentUpdate: true,
	  statics: true,
	  updateComponent: true
	};
	
	var REACT_STATICS = {
	  childContextTypes: true,
	  contextTypes: true,
	  defaultProps: true,
	  displayName: true,
	  getDefaultProps: true,
	  mixins: true,
	  propTypes: true,
	  type: true
	};
	
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  arguments: true,
	  arity: true
	};
	
	var defaultConfig = {
	  delegateTo: function delegateTo(w) {
	    return w.refs.child;
	  },
	  hoistStatics: true
	};
	
	function hoistNonReactMethods(targetComponent, sourceComponent, config) {
	  var targetComponentName = targetComponent.displayName || targetComponent.name || 'Wrapper';
	  var sourceComponentName = sourceComponent.displayName || sourceComponent.name || 'WrappedComponent';
	  var hoistStatics = config && typeof config.hoistStatics !== 'undefined' ? config.hoistStatics : defaultConfig.hoistStatics;
	  var delegateTo = config && typeof config.delegateTo !== 'undefined' ? config.delegateTo : defaultConfig.delegateTo;
	  // backwards compatible where config option is delegateTo function
	  if (typeof config === 'function') delegateTo = config;
	
	  if (hoistStatics) {
	    var statics = Object.getOwnPropertyNames(sourceComponent).filter(function (k) {
	      return !REACT_STATICS[k] && !KNOWN_STATICS[k];
	    });
	
	    statics.forEach(function (methodName) {
	      if (targetComponent[methodName]) console.warn('Static method ' + methodName + ' already exists in wrapper component ' + targetComponentName + ', and won\'t be hoisted. Consider changing the name on ' + sourceComponentName + '.');
	      targetComponent[methodName] = sourceComponent[methodName];
	    });
	  }
	
	  var methods = Object.getOwnPropertyNames(sourceComponent.prototype).filter(function (k) {
	    return !REACT_PROTOTYPE[k];
	  });
	
	  methods.forEach(function (methodName) {
	    if (targetComponent.prototype[methodName]) {
	      console.warn('Method ' + methodName + ' already exists in wrapper component ' + targetComponentName + ', and won\'t be hoisted. Consider changing the name on ' + sourceComponentName + '.');
	      return;
	    }
	
	    targetComponent.prototype[methodName] = function () {
	      var _sourceComponent$prot;
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return (_sourceComponent$prot = sourceComponent.prototype[methodName]).call.apply(_sourceComponent$prot, [delegateTo.call(this, this)].concat(args));
	    };
	  });
	
	  return targetComponent;
	}
	//# sourceMappingURL=index.js.map

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var ReactIs = __webpack_require__(123);
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextType: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    getDerivedStateFromError: true,
	    getDerivedStateFromProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    callee: true,
	    arguments: true,
	    arity: true
	};
	
	var FORWARD_REF_STATICS = {
	    '$$typeof': true,
	    render: true,
	    defaultProps: true,
	    displayName: true,
	    propTypes: true
	};
	
	var MEMO_STATICS = {
	    '$$typeof': true,
	    compare: true,
	    defaultProps: true,
	    displayName: true,
	    propTypes: true,
	    type: true
	};
	
	var TYPE_STATICS = {};
	TYPE_STATICS[ReactIs.ForwardRef] = FORWARD_REF_STATICS;
	
	function getStatics(component) {
	    if (ReactIs.isMemo(component)) {
	        return MEMO_STATICS;
	    }
	    return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
	}
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = Object.prototype;
	
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') {
	        // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        var targetStatics = getStatics(targetComponent);
	        var sourceStatics = getStatics(sourceComponent);
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try {
	                    // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
	   true ? factory(exports) :
	  typeof define === 'function' && define.amd ? define(['exports'], factory) :
	  (global = global || self, factory(global.idb = {}));
	}(this, function (exports) { 'use strict';
	
	  function toArray(arr) {
	    return Array.prototype.slice.call(arr);
	  }
	
	  function promisifyRequest(request) {
	    return new Promise(function(resolve, reject) {
	      request.onsuccess = function() {
	        resolve(request.result);
	      };
	
	      request.onerror = function() {
	        reject(request.error);
	      };
	    });
	  }
	
	  function promisifyRequestCall(obj, method, args) {
	    var request;
	    var p = new Promise(function(resolve, reject) {
	      request = obj[method].apply(obj, args);
	      promisifyRequest(request).then(resolve, reject);
	    });
	
	    p.request = request;
	    return p;
	  }
	
	  function promisifyCursorRequestCall(obj, method, args) {
	    var p = promisifyRequestCall(obj, method, args);
	    return p.then(function(value) {
	      if (!value) return;
	      return new Cursor(value, p.request);
	    });
	  }
	
	  function proxyProperties(ProxyClass, targetProp, properties) {
	    properties.forEach(function(prop) {
	      Object.defineProperty(ProxyClass.prototype, prop, {
	        get: function() {
	          return this[targetProp][prop];
	        },
	        set: function(val) {
	          this[targetProp][prop] = val;
	        }
	      });
	    });
	  }
	
	  function proxyRequestMethods(ProxyClass, targetProp, Constructor, properties) {
	    properties.forEach(function(prop) {
	      if (!(prop in Constructor.prototype)) return;
	      ProxyClass.prototype[prop] = function() {
	        return promisifyRequestCall(this[targetProp], prop, arguments);
	      };
	    });
	  }
	
	  function proxyMethods(ProxyClass, targetProp, Constructor, properties) {
	    properties.forEach(function(prop) {
	      if (!(prop in Constructor.prototype)) return;
	      ProxyClass.prototype[prop] = function() {
	        return this[targetProp][prop].apply(this[targetProp], arguments);
	      };
	    });
	  }
	
	  function proxyCursorRequestMethods(ProxyClass, targetProp, Constructor, properties) {
	    properties.forEach(function(prop) {
	      if (!(prop in Constructor.prototype)) return;
	      ProxyClass.prototype[prop] = function() {
	        return promisifyCursorRequestCall(this[targetProp], prop, arguments);
	      };
	    });
	  }
	
	  function Index(index) {
	    this._index = index;
	  }
	
	  proxyProperties(Index, '_index', [
	    'name',
	    'keyPath',
	    'multiEntry',
	    'unique'
	  ]);
	
	  proxyRequestMethods(Index, '_index', IDBIndex, [
	    'get',
	    'getKey',
	    'getAll',
	    'getAllKeys',
	    'count'
	  ]);
	
	  proxyCursorRequestMethods(Index, '_index', IDBIndex, [
	    'openCursor',
	    'openKeyCursor'
	  ]);
	
	  function Cursor(cursor, request) {
	    this._cursor = cursor;
	    this._request = request;
	  }
	
	  proxyProperties(Cursor, '_cursor', [
	    'direction',
	    'key',
	    'primaryKey',
	    'value'
	  ]);
	
	  proxyRequestMethods(Cursor, '_cursor', IDBCursor, [
	    'update',
	    'delete'
	  ]);
	
	  // proxy 'next' methods
	  ['advance', 'continue', 'continuePrimaryKey'].forEach(function(methodName) {
	    if (!(methodName in IDBCursor.prototype)) return;
	    Cursor.prototype[methodName] = function() {
	      var cursor = this;
	      var args = arguments;
	      return Promise.resolve().then(function() {
	        cursor._cursor[methodName].apply(cursor._cursor, args);
	        return promisifyRequest(cursor._request).then(function(value) {
	          if (!value) return;
	          return new Cursor(value, cursor._request);
	        });
	      });
	    };
	  });
	
	  function ObjectStore(store) {
	    this._store = store;
	  }
	
	  ObjectStore.prototype.createIndex = function() {
	    return new Index(this._store.createIndex.apply(this._store, arguments));
	  };
	
	  ObjectStore.prototype.index = function() {
	    return new Index(this._store.index.apply(this._store, arguments));
	  };
	
	  proxyProperties(ObjectStore, '_store', [
	    'name',
	    'keyPath',
	    'indexNames',
	    'autoIncrement'
	  ]);
	
	  proxyRequestMethods(ObjectStore, '_store', IDBObjectStore, [
	    'put',
	    'add',
	    'delete',
	    'clear',
	    'get',
	    'getAll',
	    'getKey',
	    'getAllKeys',
	    'count'
	  ]);
	
	  proxyCursorRequestMethods(ObjectStore, '_store', IDBObjectStore, [
	    'openCursor',
	    'openKeyCursor'
	  ]);
	
	  proxyMethods(ObjectStore, '_store', IDBObjectStore, [
	    'deleteIndex'
	  ]);
	
	  function Transaction(idbTransaction) {
	    this._tx = idbTransaction;
	    this.complete = new Promise(function(resolve, reject) {
	      idbTransaction.oncomplete = function() {
	        resolve();
	      };
	      idbTransaction.onerror = function() {
	        reject(idbTransaction.error);
	      };
	      idbTransaction.onabort = function() {
	        reject(idbTransaction.error);
	      };
	    });
	  }
	
	  Transaction.prototype.objectStore = function() {
	    return new ObjectStore(this._tx.objectStore.apply(this._tx, arguments));
	  };
	
	  proxyProperties(Transaction, '_tx', [
	    'objectStoreNames',
	    'mode'
	  ]);
	
	  proxyMethods(Transaction, '_tx', IDBTransaction, [
	    'abort'
	  ]);
	
	  function UpgradeDB(db, oldVersion, transaction) {
	    this._db = db;
	    this.oldVersion = oldVersion;
	    this.transaction = new Transaction(transaction);
	  }
	
	  UpgradeDB.prototype.createObjectStore = function() {
	    return new ObjectStore(this._db.createObjectStore.apply(this._db, arguments));
	  };
	
	  proxyProperties(UpgradeDB, '_db', [
	    'name',
	    'version',
	    'objectStoreNames'
	  ]);
	
	  proxyMethods(UpgradeDB, '_db', IDBDatabase, [
	    'deleteObjectStore',
	    'close'
	  ]);
	
	  function DB(db) {
	    this._db = db;
	  }
	
	  DB.prototype.transaction = function() {
	    return new Transaction(this._db.transaction.apply(this._db, arguments));
	  };
	
	  proxyProperties(DB, '_db', [
	    'name',
	    'version',
	    'objectStoreNames'
	  ]);
	
	  proxyMethods(DB, '_db', IDBDatabase, [
	    'close'
	  ]);
	
	  // Add cursor iterators
	  // TODO: remove this once browsers do the right thing with promises
	  ['openCursor', 'openKeyCursor'].forEach(function(funcName) {
	    [ObjectStore, Index].forEach(function(Constructor) {
	      // Don't create iterateKeyCursor if openKeyCursor doesn't exist.
	      if (!(funcName in Constructor.prototype)) return;
	
	      Constructor.prototype[funcName.replace('open', 'iterate')] = function() {
	        var args = toArray(arguments);
	        var callback = args[args.length - 1];
	        var nativeObject = this._store || this._index;
	        var request = nativeObject[funcName].apply(nativeObject, args.slice(0, -1));
	        request.onsuccess = function() {
	          callback(request.result);
	        };
	      };
	    });
	  });
	
	  // polyfill getAll
	  [Index, ObjectStore].forEach(function(Constructor) {
	    if (Constructor.prototype.getAll) return;
	    Constructor.prototype.getAll = function(query, count) {
	      var instance = this;
	      var items = [];
	
	      return new Promise(function(resolve) {
	        instance.iterateCursor(query, function(cursor) {
	          if (!cursor) {
	            resolve(items);
	            return;
	          }
	          items.push(cursor.value);
	
	          if (count !== undefined && items.length == count) {
	            resolve(items);
	            return;
	          }
	          cursor.continue();
	        });
	      });
	    };
	  });
	
	  function openDb(name, version, upgradeCallback) {
	    var p = promisifyRequestCall(indexedDB, 'open', [name, version]);
	    var request = p.request;
	
	    if (request) {
	      request.onupgradeneeded = function(event) {
	        if (upgradeCallback) {
	          upgradeCallback(new UpgradeDB(request.result, event.oldVersion, request.transaction));
	        }
	      };
	    }
	
	    return p.then(function(db) {
	      return new DB(db);
	    });
	  }
	
	  function deleteDb(name) {
	    return promisifyRequestCall(indexedDB, 'deleteDatabase', [name]);
	  }
	
	  exports.openDb = openDb;
	  exports.deleteDb = deleteDb;
	
	  Object.defineProperty(exports, '__esModule', { value: true });
	
	}));


/***/ }),
/* 398 */
/***/ (function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}


/***/ }),
/* 399 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/**
	 * Returns the object type of the given payload
	 *
	 * @param {*} payload
	 * @returns {string}
	 */
	function getType(payload) {
	    return Object.prototype.toString.call(payload).slice(8, -1);
	}
	/**
	 * Returns whether the payload is undefined
	 *
	 * @param {*} payload
	 * @returns {payload is undefined}
	 */
	function isUndefined(payload) {
	    return getType(payload) === 'Undefined';
	}
	/**
	 * Returns whether the payload is null
	 *
	 * @param {*} payload
	 * @returns {payload is null}
	 */
	function isNull(payload) {
	    return getType(payload) === 'Null';
	}
	/**
	 * Returns whether the payload is a plain JavaScript object (excluding special classes or objects with other prototypes)
	 *
	 * @param {*} payload
	 * @returns {payload is {[key: string]: any}}
	 */
	function isPlainObject(payload) {
	    if (getType(payload) !== 'Object')
	        return false;
	    return (payload.constructor === Object && Object.getPrototypeOf(payload) === Object.prototype);
	}
	/**
	 * Returns whether the payload is a plain JavaScript object (excluding special classes or objects with other prototypes)
	 *
	 * @param {*} payload
	 * @returns {payload is {[key: string]: any}}
	 */
	function isObject(payload) {
	    return isPlainObject(payload);
	}
	/**
	 * Returns whether the payload is an any kind of object (including special classes or objects with different prototypes)
	 *
	 * @param {*} payload
	 * @returns {payload is {[key: string]: any}}
	 */
	function isAnyObject(payload) {
	    return getType(payload) === 'Object';
	}
	/**
	 * Returns whether the payload is an object like a type passed in < >
	 *
	 * Usage: isObjectLike<{id: any}>(payload) // will make sure it's an object and has an `id` prop.
	 *
	 * @template T this must be passed in < >
	 * @param {*} payload
	 * @returns {payload is T}
	 */
	function isObjectLike(payload) {
	    return isAnyObject(payload);
	}
	/**
	 * Returns whether the payload is a function
	 *
	 * @param {*} payload
	 * @returns {payload is Function}
	 */
	function isFunction(payload) {
	    return getType(payload) === 'Function';
	}
	/**
	 * Returns whether the payload is an array
	 *
	 * @param {*} payload
	 * @returns {payload is undefined}
	 */
	function isArray(payload) {
	    return getType(payload) === 'Array';
	}
	/**
	 * Returns whether the payload is a string
	 *
	 * @param {*} payload
	 * @returns {payload is string}
	 */
	function isString(payload) {
	    return getType(payload) === 'String';
	}
	/**
	 * Returns whether the payload is a string, BUT returns false for ''
	 *
	 * @param {*} payload
	 * @returns {payload is string}
	 */
	function isFullString(payload) {
	    return isString(payload) && payload !== '';
	}
	/**
	 * Returns whether the payload is ''
	 *
	 * @param {*} payload
	 * @returns {payload is string}
	 */
	function isEmptyString(payload) {
	    return payload === '';
	}
	/**
	 * Returns whether the payload is a number
	 *
	 * This will return false for NaN
	 *
	 * @param {*} payload
	 * @returns {payload is number}
	 */
	function isNumber(payload) {
	    return (getType(payload) === 'Number' && !isNaN(payload));
	}
	/**
	 * Returns whether the payload is a boolean
	 *
	 * @param {*} payload
	 * @returns {payload is boolean}
	 */
	function isBoolean(payload) {
	    return getType(payload) === 'Boolean';
	}
	/**
	 * Returns whether the payload is a regular expression
	 *
	 * @param {*} payload
	 * @returns {payload is RegExp}
	 */
	function isRegExp(payload) {
	    return getType(payload) === 'RegExp';
	}
	/**
	 * Returns whether the payload is a date, and that the date is Valid
	 *
	 * @param {*} payload
	 * @returns {payload is Date}
	 */
	function isDate(payload) {
	    return (getType(payload) === 'Date' && !isNaN(payload));
	}
	/**
	 * Returns whether the payload is a Symbol
	 *
	 * @param {*} payload
	 * @returns {payload is symbol}
	 */
	function isSymbol(payload) {
	    return (getType(payload) === 'Symbol');
	}
	/**
	 * Returns whether the payload is a primitive type (eg. Boolean | Null | Undefined | Number | String | Symbol)
	 *
	 * @param {*} payload
	 * @returns {(payload is boolean | null | undefined | number | string | symbol)}
	 */
	function isPrimitive(payload) {
	    return (isBoolean(payload) ||
	        isNull(payload) ||
	        isUndefined(payload) ||
	        isNumber(payload) ||
	        isString(payload) ||
	        isSymbol(payload));
	}
	/**
	 * Does a generic check to check that the given payload is of a given type.
	 * In cases like Number, it will return true for NaN as NaN is a Number (thanks javascript!);
	 * It will, however, differentiate between object and null
	 *
	 * @template T
	 * @param {*} payload
	 * @param {T} type
	 * @throws {TypeError} Will throw type error if type is an invalid type
	 * @returns {payload is T}
	 */
	function isType(payload, type) {
	    if (!(type instanceof Function)) {
	        throw new TypeError('Type must be a function');
	    }
	    if (!type.hasOwnProperty('prototype')) {
	        throw new TypeError('Type is not a class');
	    }
	    // Classes usually have names (as functions usually have names)
	    var name = type.name;
	    return (getType(payload) === name) || Boolean(payload && (payload.constructor === type));
	}
	
	exports.getType = getType;
	exports.isUndefined = isUndefined;
	exports.isNull = isNull;
	exports.isPlainObject = isPlainObject;
	exports.isObject = isObject;
	exports.isAnyObject = isAnyObject;
	exports.isObjectLike = isObjectLike;
	exports.isFunction = isFunction;
	exports.isArray = isArray;
	exports.isString = isString;
	exports.isFullString = isFullString;
	exports.isEmptyString = isEmptyString;
	exports.isNumber = isNumber;
	exports.isBoolean = isBoolean;
	exports.isRegExp = isRegExp;
	exports.isDate = isDate;
	exports.isSymbol = isSymbol;
	exports.isPrimitive = isPrimitive;
	exports.isType = isType;


/***/ }),
/* 400 */
/***/ (function(module, exports) {

	
	module.exports = function load (src, opts, cb) {
	  var head = document.head || document.getElementsByTagName('head')[0]
	  var script = document.createElement('script')
	
	  if (typeof opts === 'function') {
	    cb = opts
	    opts = {}
	  }
	
	  opts = opts || {}
	  cb = cb || function() {}
	
	  script.type = opts.type || 'text/javascript'
	  script.charset = opts.charset || 'utf8';
	  script.async = 'async' in opts ? !!opts.async : true
	  script.src = src
	
	  if (opts.attrs) {
	    setAttributes(script, opts.attrs)
	  }
	
	  if (opts.text) {
	    script.text = '' + opts.text
	  }
	
	  var onend = 'onload' in script ? stdOnEnd : ieOnEnd
	  onend(script, cb)
	
	  // some good legacy browsers (firefox) fail the 'in' detection above
	  // so as a fallback we always set onload
	  // old IE will ignore this and new IE will set onload
	  if (!script.onload) {
	    stdOnEnd(script, cb);
	  }
	
	  head.appendChild(script)
	}
	
	function setAttributes(script, attrs) {
	  for (var attr in attrs) {
	    script.setAttribute(attr, attrs[attr]);
	  }
	}
	
	function stdOnEnd (script, cb) {
	  script.onload = function () {
	    this.onerror = this.onload = null
	    cb(null, script)
	  }
	  script.onerror = function () {
	    // this.onload = null here is necessary
	    // because even IE9 works not like others
	    this.onerror = this.onload = null
	    cb(new Error('Failed to load ' + this.src), script)
	  }
	}
	
	function ieOnEnd (script, cb) {
	  script.onreadystatechange = function () {
	    if (this.readyState != 'complete' && this.readyState != 'loaded') return
	    this.onreadystatechange = null
	    cb(null, script) // there is no way to catch loading errors in IE8
	  }
	}


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used to compose bitmasks for comparison styles. */
	var UNORDERED_COMPARE_FLAG = 1,
	    PARTIAL_COMPARE_FLAG = 2;
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/,
	    reLeadingDot = /^\./,
	    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var Symbol = root.Symbol,
	    Uint8Array = root.Uint8Array,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    splice = arrayProto.splice;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView'),
	    Map = getNative(root, 'Map'),
	    Promise = getNative(root, 'Promise'),
	    Set = getNative(root, 'Set'),
	    WeakMap = getNative(root, 'WeakMap'),
	    nativeCreate = getNative(Object, 'create');
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	}
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  return this.has(key) && delete this.__data__[key];
	}
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	}
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	}
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  return true;
	}
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  return getMapData(this, key)['delete'](key);
	}
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  getMapData(this, key).set(key, value);
	  return this;
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values ? values.length : 0;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  this.__data__ = new ListCache(entries);
	}
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	}
	
	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  return this.__data__['delete'](key);
	}
	
	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var cache = this.__data__;
	  if (cache instanceof ListCache) {
	    var pairs = cache.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      return this;
	    }
	    cache = this.__data__ = new MapCache(pairs);
	  }
	  cache.set(key, value);
	  return this;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  // Safari 9 makes `arguments.length` enumerable in strict mode.
	  var result = (isArray(value) || isArguments(value))
	    ? baseTimes(value.length, String)
	    : [];
	
	  var length = result.length,
	      skipIndexes = !!length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = isKey(path, object) ? [path] : castPath(path);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	/**
	 * The base implementation of `getTag`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  return objectToString.call(value);
	}
	
	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {boolean} [bitmask] The bitmask of comparison flags.
	 *  The bitmask may be composed of the following flags:
	 *     1 - Unordered comparison
	 *     2 - Partial comparison
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, customizer, bitmask, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
	}
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = arrayTag,
	      othTag = arrayTag;
	
	  if (!objIsArr) {
	    objTag = getTag(object);
	    objTag = objTag == argsTag ? objectTag : objTag;
	  }
	  if (!othIsArr) {
	    othTag = getTag(other);
	    othTag = othTag == argsTag ? objectTag : othTag;
	  }
	  var objIsObj = objTag == objectTag && !isHostObject(object),
	      othIsObj = othTag == objectTag && !isHostObject(other),
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, equalFunc, customizer, bitmask, stack)
	      : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
	  }
	  if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
	}
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
	}
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
	  };
	}
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value) {
	  return isArray(value) ? value : stringToPath(value);
	}
	
	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
	  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & UNORDERED_COMPARE_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!seen.has(othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
	              return seen.add(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, customizer, bitmask, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= UNORDERED_COMPARE_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
	  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
	      objProps = keys(object),
	      objLength = objProps.length,
	      othProps = keys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11,
	// for data views in Edge < 14, and promises in Node.js.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = objectToString.call(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : undefined;
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = isKey(path, object) ? [path] : castPath(path);
	
	  var result,
	      index = -1,
	      length = path.length;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result) {
	    return result;
	  }
	  var length = object ? object.length : 0;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoize(function(string) {
	  string = toString(string);
	
	  var result = [];
	  if (reLeadingDot.test(string)) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, string) {
	    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result);
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Assign cache to `_.memoize`.
	memoize.Cache = MapCache;
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	/**
	 * Creates an object with the same keys as `object` and values generated
	 * by running each own enumerable string keyed property of `object` thru
	 * `iteratee`. The iteratee is invoked with three arguments:
	 * (value, key, object).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Object} Returns the new mapped object.
	 * @see _.mapKeys
	 * @example
	 *
	 * var users = {
	 *   'fred':    { 'user': 'fred',    'age': 40 },
	 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	 * };
	 *
	 * _.mapValues(users, function(o) { return o.age; });
	 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.mapValues(users, 'age');
	 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	 */
	function mapValues(object, iteratee) {
	  var result = {};
	  iteratee = baseIteratee(iteratee, 3);
	
	  baseForOwn(object, function(value, key, object) {
	    result[key] = iteratee(value, key, object);
	  });
	  return result;
	}
	
	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = mapValues;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(33)(module)))

/***/ }),
/* 402 */
/***/ (function(module, exports) {

	/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_INTEGER = 1.7976931348623157e+308,
	    NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Creates a function that invokes `func`, with the `this` binding and arguments
	 * of the created function, while it's called less than `n` times. Subsequent
	 * calls to the created function return the result of the last `func` invocation.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Function
	 * @param {number} n The number of calls at which `func` is no longer invoked.
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new restricted function.
	 * @example
	 *
	 * jQuery(element).on('click', _.before(5, addContactToList));
	 * // => Allows adding up to 4 contacts to the list.
	 */
	function before(n, func) {
	  var result;
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  n = toInteger(n);
	  return function() {
	    if (--n > 0) {
	      result = func.apply(this, arguments);
	    }
	    if (n <= 1) {
	      func = undefined;
	    }
	    return result;
	  };
	}
	
	/**
	 * Creates a function that is restricted to invoking `func` once. Repeat calls
	 * to the function return the value of the first invocation. The `func` is
	 * invoked with the `this` binding and arguments of the created function.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new restricted function.
	 * @example
	 *
	 * var initialize = _.once(createApplication);
	 * initialize();
	 * initialize();
	 * // => `createApplication` is invoked once
	 */
	function once(func) {
	  return before(2, func);
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite(value),
	      remainder = result % 1;
	
	  return result === result ? (remainder ? result - remainder : result) : 0;
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = once;


/***/ }),
/* 403 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.focusEvents = exports.keyboardEvents = exports.touchEvents = exports.mouseEvents = void 0;
	// As defined on the list of supported mouse events: https://reactjs.org/docs/events.html#mouse-events
	var mouseEvents = ['onClick', 'onContextMenu', 'onDoubleClick', 'onDrag', 'onDragEnd', 'onDragEnter', 'onDragExit', 'onDragLeave', 'onDragOver', 'onDragStart', 'onDrop', 'onMouseDown', 'onMouseEnter', 'onMouseLeave', 'onMouseMove', 'onMouseOut', 'onMouseOver', 'onMouseUp']; // As defined on the list of supported touch events: https://reactjs.org/docs/events.html#touch-events
	
	exports.mouseEvents = mouseEvents;
	var touchEvents = ['onTouchCancel', 'onTouchEnd', 'onTouchMove', 'onTouchStart']; // As defined on the list of supported keyboard events: https://reactjs.org/docs/events.html#keyboard-events
	
	exports.touchEvents = touchEvents;
	var keyboardEvents = ['onKeyDown', 'onKeyPress', 'onKeyUp']; // As defined on the list of supported keyboard events: https://reactjs.org/docs/events.html#focus-events
	
	exports.keyboardEvents = keyboardEvents;
	var focusEvents = ['onFocus', 'onBlur'];
	/**
	 * Returns an object with on-event callback props curried with provided args.
	 * @param {Object} props Props passed to a component.
	 * @param {Function=} getArgs A function that returns argument(s) on-event callbacks
	 *   shall be curried with.
	 */
	
	exports.focusEvents = focusEvents;
	
	var makeEventProps = function makeEventProps(props, getArgs) {
	  var eventProps = {};
	  [].concat(mouseEvents, touchEvents, keyboardEvents, focusEvents).forEach(function (eventName) {
	    if (props[eventName]) {
	      eventProps[eventName] = function (event) {
	        return getArgs ? props[eventName](event, getArgs(eventName)) : props[eventName](event);
	      };
	    }
	  });
	  return eventProps;
	};
	
	var _default = makeEventProps;
	exports.default = _default;

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var isWhat = __webpack_require__(399);
	
	function assignProp(carry, key, newVal, originalObject) {
	    var propType = originalObject.propertyIsEnumerable(key)
	        ? 'enumerable'
	        : 'nonenumerable';
	    if (propType === 'enumerable')
	        carry[key] = newVal;
	    if (propType === 'nonenumerable') {
	        Object.defineProperty(carry, key, {
	            value: newVal,
	            enumerable: false,
	            writable: true,
	            configurable: true
	        });
	    }
	}
	function mergeRecursively(origin, newComer, extensions) {
	    // work directly on newComer if its not an object
	    if (!isWhat.isPlainObject(newComer)) {
	        // extend merge rules
	        if (extensions && isWhat.isArray(extensions)) {
	            extensions.forEach(function (extend) {
	                newComer = extend(origin, newComer);
	            });
	        }
	        return newComer;
	    }
	    // define newObject to merge all values upon
	    var newObject = {};
	    if (isWhat.isPlainObject(origin)) {
	        var props_1 = Object.getOwnPropertyNames(origin);
	        var symbols_1 = Object.getOwnPropertySymbols(origin);
	        newObject = props_1.concat(symbols_1).reduce(function (carry, key) {
	            // @ts-ignore
	            var targetVal = origin[key];
	            if ((!isWhat.isSymbol(key) && !Object.getOwnPropertyNames(newComer).includes(key)) ||
	                (isWhat.isSymbol(key) && !Object.getOwnPropertySymbols(newComer).includes(key))) {
	                assignProp(carry, key, targetVal, origin);
	            }
	            return carry;
	        }, {});
	    }
	    var props = Object.getOwnPropertyNames(newComer);
	    var symbols = Object.getOwnPropertySymbols(newComer);
	    var result = props.concat(symbols).reduce(function (carry, key) {
	        // re-define the origin and newComer as targetVal and newVal
	        var newVal = newComer[key];
	        var targetVal = (isWhat.isPlainObject(origin))
	            // @ts-ignore
	            ? origin[key]
	            : undefined;
	        // extend merge rules
	        if (extensions && isWhat.isArray(extensions)) {
	            extensions.forEach(function (extend) {
	                newVal = extend(targetVal, newVal);
	            });
	        }
	        // When newVal is an object do the merge recursively
	        if (targetVal !== undefined && isWhat.isPlainObject(newVal)) {
	            newVal = mergeRecursively(targetVal, newVal, extensions);
	        }
	        assignProp(carry, key, newVal, newComer);
	        return carry;
	    }, newObject);
	    return result;
	}
	/**
	 * Merge anything recursively.
	 * Objects get merged, special objects (classes etc.) are re-assigned "as is".
	 * Basic types overwrite objects or other basic types.
	 *
	 * @param {(IConfig | any)} origin
	 * @param {...any[]} newComers
	 * @returns the result
	 */
	function merge(origin) {
	    var newComers = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        newComers[_i - 1] = arguments[_i];
	    }
	    var extensions = null;
	    var base = origin;
	    if (isWhat.isPlainObject(origin) && origin.extensions && Object.keys(origin).length === 1) {
	        base = {};
	        extensions = origin.extensions;
	    }
	    return newComers.reduce(function (result, newComer) {
	        return mergeRecursively(result, newComer, extensions);
	    }, base);
	}
	
	function concatArrays(originVal, newVal) {
	    if (isWhat.isArray(originVal) && isWhat.isArray(newVal)) {
	        // concat logic
	        return originVal.concat(newVal);
	    }
	    return newVal; // always return newVal as fallback!!
	}
	
	exports.merge = merge;
	exports.concatArrays = concatArrays;
	exports.default = merge;


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./en-SG": 171,
		"./en-SG.js": 171,
		"./en-au": 172,
		"./en-au.js": 172,
		"./en-ca": 173,
		"./en-ca.js": 173,
		"./en-gb": 174,
		"./en-gb.js": 174,
		"./en-ie": 175,
		"./en-ie.js": 175,
		"./en-il": 176,
		"./en-il.js": 176,
		"./en-nz": 177,
		"./en-nz.js": 177
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 405;


/***/ }),
/* 406 */
/***/ (function(module, exports) {

	/**
	 * Helpers.
	 */
	
	var s = 1000;
	var m = s * 60;
	var h = m * 60;
	var d = h * 24;
	var y = d * 365.25;
	
	/**
	 * Parse or format the given `val`.
	 *
	 * Options:
	 *
	 *  - `long` verbose formatting [false]
	 *
	 * @param {String|Number} val
	 * @param {Object} [options]
	 * @throws {Error} throw an error if val is not a non-empty string or a number
	 * @return {String|Number}
	 * @api public
	 */
	
	module.exports = function(val, options) {
	  options = options || {};
	  var type = typeof val;
	  if (type === 'string' && val.length > 0) {
	    return parse(val);
	  } else if (type === 'number' && isNaN(val) === false) {
	    return options.long ? fmtLong(val) : fmtShort(val);
	  }
	  throw new Error(
	    'val is not a non-empty string or a valid number. val=' +
	      JSON.stringify(val)
	  );
	};
	
	/**
	 * Parse the given `str` and return milliseconds.
	 *
	 * @param {String} str
	 * @return {Number}
	 * @api private
	 */
	
	function parse(str) {
	  str = String(str);
	  if (str.length > 100) {
	    return;
	  }
	  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
	    str
	  );
	  if (!match) {
	    return;
	  }
	  var n = parseFloat(match[1]);
	  var type = (match[2] || 'ms').toLowerCase();
	  switch (type) {
	    case 'years':
	    case 'year':
	    case 'yrs':
	    case 'yr':
	    case 'y':
	      return n * y;
	    case 'days':
	    case 'day':
	    case 'd':
	      return n * d;
	    case 'hours':
	    case 'hour':
	    case 'hrs':
	    case 'hr':
	    case 'h':
	      return n * h;
	    case 'minutes':
	    case 'minute':
	    case 'mins':
	    case 'min':
	    case 'm':
	      return n * m;
	    case 'seconds':
	    case 'second':
	    case 'secs':
	    case 'sec':
	    case 's':
	      return n * s;
	    case 'milliseconds':
	    case 'millisecond':
	    case 'msecs':
	    case 'msec':
	    case 'ms':
	      return n;
	    default:
	      return undefined;
	  }
	}
	
	/**
	 * Short format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtShort(ms) {
	  if (ms >= d) {
	    return Math.round(ms / d) + 'd';
	  }
	  if (ms >= h) {
	    return Math.round(ms / h) + 'h';
	  }
	  if (ms >= m) {
	    return Math.round(ms / m) + 'm';
	  }
	  if (ms >= s) {
	    return Math.round(ms / s) + 's';
	  }
	  return ms + 'ms';
	}
	
	/**
	 * Long format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtLong(ms) {
	  return plural(ms, d, 'day') ||
	    plural(ms, h, 'hour') ||
	    plural(ms, m, 'minute') ||
	    plural(ms, s, 'second') ||
	    ms + ' ms';
	}
	
	/**
	 * Pluralization helper.
	 */
	
	function plural(ms, n, name) {
	  if (ms < n) {
	    return;
	  }
	  if (ms < n * 1.5) {
	    return Math.floor(ms / n) + ' ' + name;
	  }
	  return Math.ceil(ms / n) + ' ' + name + 's';
	}


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
	(function() {
	  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - nodeLoadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    moduleLoadTime = getNanoSeconds();
	    upTime = process.uptime() * 1e9;
	    nodeLoadTime = moduleLoadTime - upTime;
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	//# sourceMappingURL=performance-now.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(45)))

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(409);
	
	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,
	
	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };
	
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 409 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strictUriEncode = __webpack_require__(906);
	var objectAssign = __webpack_require__(85);
	
	function encoderForArrayFormat(opts) {
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, index) {
					return value === null ? [
						encode(key, opts),
						'[',
						index,
						']'
					].join('') : [
						encode(key, opts),
						'[',
						encode(index, opts),
						']=',
						encode(value, opts)
					].join('');
				};
	
			case 'bracket':
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'[]=',
						encode(value, opts)
					].join('');
				};
	
			default:
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'=',
						encode(value, opts)
					].join('');
				};
		}
	}
	
	function parserForArrayFormat(opts) {
		var result;
	
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, accumulator) {
					result = /\[(\d*)\]$/.exec(key);
	
					key = key.replace(/\[\d*\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					}
	
					if (accumulator[key] === undefined) {
						accumulator[key] = {};
					}
	
					accumulator[key][result[1]] = value;
				};
	
			case 'bracket':
				return function (key, value, accumulator) {
					result = /(\[\])$/.exec(key);
					key = key.replace(/\[\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					} else if (accumulator[key] === undefined) {
						accumulator[key] = [value];
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
	
			default:
				return function (key, value, accumulator) {
					if (accumulator[key] === undefined) {
						accumulator[key] = value;
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
		}
	}
	
	function encode(value, opts) {
		if (opts.encode) {
			return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
		}
	
		return value;
	}
	
	function keysSorter(input) {
		if (Array.isArray(input)) {
			return input.sort();
		} else if (typeof input === 'object') {
			return keysSorter(Object.keys(input)).sort(function (a, b) {
				return Number(a) - Number(b);
			}).map(function (key) {
				return input[key];
			});
		}
	
		return input;
	}
	
	exports.extract = function (str) {
		return str.split('?')[1] || '';
	};
	
	exports.parse = function (str, opts) {
		opts = objectAssign({arrayFormat: 'none'}, opts);
	
		var formatter = parserForArrayFormat(opts);
	
		// Create an object with no prototype
		// https://github.com/sindresorhus/query-string/issues/47
		var ret = Object.create(null);
	
		if (typeof str !== 'string') {
			return ret;
		}
	
		str = str.trim().replace(/^(\?|#|&)/, '');
	
		if (!str) {
			return ret;
		}
	
		str.split('&').forEach(function (param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			// https://github.com/sindresorhus/query-string/pull/37
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;
	
			// missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			val = val === undefined ? null : decodeURIComponent(val);
	
			formatter(decodeURIComponent(key), val, ret);
		});
	
		return Object.keys(ret).sort().reduce(function (result, key) {
			var val = ret[key];
			if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
				// Sort object keys, not values
				result[key] = keysSorter(val);
			} else {
				result[key] = val;
			}
	
			return result;
		}, Object.create(null));
	};
	
	exports.stringify = function (obj, opts) {
		var defaults = {
			encode: true,
			strict: true,
			arrayFormat: 'none'
		};
	
		opts = objectAssign(defaults, opts);
	
		var formatter = encoderForArrayFormat(opts);
	
		return obj ? Object.keys(obj).sort().map(function (key) {
			var val = obj[key];
	
			if (val === undefined) {
				return '';
			}
	
			if (val === null) {
				return encode(key, opts);
			}
	
			if (Array.isArray(val)) {
				var result = [];
	
				val.slice().forEach(function (val2) {
					if (val2 === undefined) {
						return;
					}
	
					result.push(formatter(key, val2, result.length));
				});
	
				return result.join('&');
			}
	
			return encode(key, opts) + '=' + encode(val, opts);
		}).filter(function (x) {
			return x.length > 0;
		}).join('&') : '';
	};


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(407)
	  , root = typeof window === 'undefined' ? global : window
	  , vendors = ['moz', 'webkit']
	  , suffix = 'AnimationFrame'
	  , raf = root['request' + suffix]
	  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]
	
	for(var i = 0; !raf && i < vendors.length; i++) {
	  raf = root[vendors[i] + 'Request' + suffix]
	  caf = root[vendors[i] + 'Cancel' + suffix]
	      || root[vendors[i] + 'CancelRequest' + suffix]
	}
	
	// Some versions of FF have rAF but not cAF
	if(!raf || !caf) {
	  var last = 0
	    , id = 0
	    , queue = []
	    , frameDuration = 1000 / 60
	
	  raf = function(callback) {
	    if(queue.length === 0) {
	      var _now = now()
	        , next = Math.max(0, frameDuration - (_now - last))
	      last = next + _now
	      setTimeout(function() {
	        var cp = queue.slice(0)
	        // Clear queue here to prevent
	        // callbacks from appending listeners
	        // to the current frame's queue
	        queue.length = 0
	        for(var i = 0; i < cp.length; i++) {
	          if(!cp[i].cancelled) {
	            try{
	              cp[i].callback(last)
	            } catch(e) {
	              setTimeout(function() { throw e }, 0)
	            }
	          }
	        }
	      }, Math.round(next))
	    }
	    queue.push({
	      handle: ++id,
	      callback: callback,
	      cancelled: false
	    })
	    return id
	  }
	
	  caf = function(handle) {
	    for(var i = 0; i < queue.length; i++) {
	      if(queue[i].handle === handle) {
	        queue[i].cancelled = true
	      }
	    }
	  }
	}
	
	module.exports = function(fn) {
	  // Wrap in a new function to prevent
	  // `cancel` potentially being assigned
	  // to the native rAF function
	  return raf.call(root, fn)
	}
	module.exports.cancel = function() {
	  caf.apply(root, arguments)
	}
	module.exports.polyfill = function(object) {
	  if (!object) {
	    object = root;
	  }
	  object.requestAnimationFrame = raf
	  object.cancelAnimationFrame = caf
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(1));
	
	var _reactLifecyclesCompat = __webpack_require__(91);
	
	var _mergeClassNames = _interopRequireDefault(__webpack_require__(29));
	
	var _Navigation = _interopRequireDefault(__webpack_require__(413));
	
	var _CenturyView = _interopRequireDefault(__webpack_require__(179));
	
	var _DecadeView = _interopRequireDefault(__webpack_require__(180));
	
	var _YearView = _interopRequireDefault(__webpack_require__(182));
	
	var _MonthView = _interopRequireDefault(__webpack_require__(181));
	
	var _dates = __webpack_require__(15);
	
	var _propTypes2 = __webpack_require__(12);
	
	var _utils = __webpack_require__(119);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	var baseClassName = 'react-calendar';
	var allViews = ['century', 'decade', 'year', 'month'];
	var allValueTypes = [].concat(_toConsumableArray(allViews.slice(1)), ['day']);
	
	var datesAreDifferent = function datesAreDifferent(date1, date2) {
	  return date1 && !date2 || !date1 && date2 || date1 && date2 && date1.getTime() !== date2.getTime();
	};
	/**
	 * Returns views array with disallowed values cut off.
	 */
	
	
	var getLimitedViews = function getLimitedViews(minDetail, maxDetail) {
	  return allViews.slice(allViews.indexOf(minDetail), allViews.indexOf(maxDetail) + 1);
	};
	/**
	 * Determines whether a given view is allowed with currently applied settings.
	 */
	
	
	var isViewAllowed = function isViewAllowed(view, minDetail, maxDetail) {
	  var views = getLimitedViews(minDetail, maxDetail);
	  return views.indexOf(view) !== -1;
	};
	/**
	 * Gets either provided view if allowed by minDetail and maxDetail, or gets
	 * the default view if not allowed.
	 */
	
	
	var getView = function getView(view, minDetail, maxDetail) {
	  if (isViewAllowed(view, minDetail, maxDetail)) {
	    return view;
	  }
	
	  return getLimitedViews(minDetail, maxDetail).pop();
	};
	/**
	 * Returns value type that can be returned with currently applied settings.
	 */
	
	
	var getValueType = function getValueType(maxDetail) {
	  return allValueTypes[allViews.indexOf(maxDetail)];
	};
	
	var getValueFrom = function getValueFrom(value) {
	  if (!value) {
	    return null;
	  }
	
	  var rawValueFrom = value instanceof Array && value.length === 2 ? value[0] : value;
	
	  if (!rawValueFrom) {
	    return null;
	  }
	
	  var valueFromDate = new Date(rawValueFrom);
	
	  if (isNaN(valueFromDate.getTime())) {
	    throw new Error("Invalid date: ".concat(value));
	  }
	
	  return valueFromDate;
	};
	
	var getDetailValueFrom = function getDetailValueFrom(value, minDate, maxDate, maxDetail) {
	  var valueFrom = getValueFrom(value);
	
	  if (!valueFrom) {
	    return null;
	  }
	
	  var detailValueFrom = (0, _dates.getBegin)(getValueType(maxDetail), valueFrom);
	  return (0, _utils.between)(detailValueFrom, minDate, maxDate);
	};
	
	var getValueTo = function getValueTo(value) {
	  if (!value) {
	    return null;
	  }
	
	  var rawValueTo = value instanceof Array && value.length === 2 ? value[1] : value;
	
	  if (!rawValueTo) {
	    return null;
	  }
	
	  var valueToDate = new Date(rawValueTo);
	
	  if (isNaN(valueToDate.getTime())) {
	    throw new Error("Invalid date: ".concat(value));
	  }
	
	  return valueToDate;
	};
	
	var getDetailValueTo = function getDetailValueTo(value, minDate, maxDate, maxDetail) {
	  var valueTo = getValueTo(value);
	
	  if (!valueTo) {
	    return null;
	  }
	
	  var detailValueTo = (0, _dates.getEnd)(getValueType(maxDetail), valueTo);
	  return (0, _utils.between)(detailValueTo, minDate, maxDate);
	};
	
	var getDetailValueArray = function getDetailValueArray(value, minDate, maxDate, maxDetail) {
	  if (value instanceof Array) {
	    return value;
	  }
	
	  return [getDetailValueFrom(value, minDate, maxDate, maxDetail), getDetailValueTo(value, minDate, maxDate, maxDetail)];
	};
	
	var getActiveStartDate = function getActiveStartDate(props) {
	  var activeStartDate = props.activeStartDate,
	      maxDate = props.maxDate,
	      maxDetail = props.maxDetail,
	      minDate = props.minDate,
	      minDetail = props.minDetail,
	      value = props.value,
	      view = props.view;
	  var rangeType = getView(view, minDetail, maxDetail);
	  var valueFrom = getDetailValueFrom(value, minDate, maxDate, maxDetail) || activeStartDate || new Date();
	  return (0, _dates.getBegin)(rangeType, valueFrom);
	};
	
	var Calendar =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(Calendar, _Component);
	
	  function Calendar() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Calendar);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Calendar)).call.apply(_getPrototypeOf2, [this].concat(args)));
	
	    _defineProperty(_assertThisInitialized(_this), "state", {});
	
	    _defineProperty(_assertThisInitialized(_this), "setActiveStartDate", function (activeStartDate) {
	      var onActiveDateChange = _this.props.onActiveDateChange;
	
	      _this.setState({
	        activeStartDate: activeStartDate
	      }, function () {
	        var view = _this.state.view;
	        (0, _utils.callIfDefined)(onActiveDateChange, {
	          activeStartDate: activeStartDate,
	          view: view
	        });
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "drillDown", function (activeStartDate) {
	      if (!_this.drillDownAvailable) {
	        return;
	      }
	
	      var _this$props = _this.props,
	          maxDetail = _this$props.maxDetail,
	          minDetail = _this$props.minDetail,
	          onDrillDown = _this$props.onDrillDown;
	      var views = getLimitedViews(minDetail, maxDetail);
	
	      _this.setState(function (prevState) {
	        var nextView = views[views.indexOf(prevState.view) + 1];
	        return {
	          activeStartDate: activeStartDate,
	          view: nextView
	        };
	      }, function () {
	        var view = _this.state.view;
	        (0, _utils.callIfDefined)(onDrillDown, {
	          activeStartDate: activeStartDate,
	          view: view
	        });
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "drillUp", function () {
	      if (!_this.drillUpAvailable) {
	        return;
	      }
	
	      var _this$props2 = _this.props,
	          maxDetail = _this$props2.maxDetail,
	          minDetail = _this$props2.minDetail,
	          onDrillUp = _this$props2.onDrillUp;
	      var views = getLimitedViews(minDetail, maxDetail);
	
	      _this.setState(function (prevState) {
	        var nextView = views[views.indexOf(prevState.view) - 1];
	        var activeStartDate = (0, _dates.getBegin)(nextView, prevState.activeStartDate);
	        return {
	          activeStartDate: activeStartDate,
	          view: nextView
	        };
	      }, function () {
	        var _this$state = _this.state,
	            activeStartDate = _this$state.activeStartDate,
	            view = _this$state.view;
	        (0, _utils.callIfDefined)(onDrillUp, {
	          activeStartDate: activeStartDate,
	          view: view
	        });
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onChange", function (value) {
	      var _this$props3 = _this.props,
	          onChange = _this$props3.onChange,
	          selectRange = _this$props3.selectRange;
	      var nextValue;
	      var callback;
	
	      if (selectRange) {
	        var previousValue = _this.state.value; // Range selection turned on
	
	        if (!previousValue || [].concat(previousValue).length !== 1 // 0 or 2 - either way we're starting a new array
	        ) {
	            // First value
	            nextValue = (0, _dates.getBegin)(_this.valueType, value);
	          } else {
	          // Second value
	          nextValue = (0, _dates.getValueRange)(_this.valueType, previousValue, value);
	
	          callback = function callback() {
	            return (0, _utils.callIfDefined)(onChange, nextValue);
	          };
	        }
	      } else {
	        // Range selection turned off
	        nextValue = _this.getProcessedValue(value);
	
	        callback = function callback() {
	          return (0, _utils.callIfDefined)(onChange, nextValue);
	        };
	      }
	
	      _this.setState({
	        value: nextValue
	      }, callback);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onMouseOver", function (value) {
	      _this.setState(function (prevState) {
	        if (prevState.hover && prevState.hover.getTime() === value.getTime()) {
	          return null;
	        }
	
	        return {
	          hover: value
	        };
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onMouseLeave", function () {
	      _this.setState({
	        hover: null
	      });
	    });
	
	    return _this;
	  }
	
	  _createClass(Calendar, [{
	    key: "getProcessedValue",
	
	    /**
	     * Gets current value in a desired format.
	     */
	    value: function getProcessedValue(value) {
	      var _this$props4 = this.props,
	          minDate = _this$props4.minDate,
	          maxDate = _this$props4.maxDate,
	          maxDetail = _this$props4.maxDetail,
	          returnValue = _this$props4.returnValue;
	
	      var processFunction = function () {
	        switch (returnValue) {
	          case 'start':
	            return getDetailValueFrom;
	
	          case 'end':
	            return getDetailValueTo;
	
	          case 'range':
	            return getDetailValueArray;
	
	          default:
	            throw new Error('Invalid returnValue.');
	        }
	      }();
	
	      return processFunction(value, minDate, maxDate, maxDetail);
	    }
	    /**
	     * Called when the user uses navigation buttons.
	     */
	
	  }, {
	    key: "renderContent",
	    value: function renderContent() {
	      var _this$props5 = this.props,
	          calendarType = _this$props5.calendarType,
	          locale = _this$props5.locale,
	          maxDate = _this$props5.maxDate,
	          minDate = _this$props5.minDate,
	          renderChildren = _this$props5.renderChildren,
	          selectRange = _this$props5.selectRange,
	          tileClassName = _this$props5.tileClassName,
	          tileContent = _this$props5.tileContent,
	          tileDisabled = _this$props5.tileDisabled;
	      var _this$state2 = this.state,
	          activeStartDate = _this$state2.activeStartDate,
	          hover = _this$state2.hover,
	          value = _this$state2.value,
	          view = _this$state2.view;
	      var onMouseOver = this.onMouseOver,
	          valueType = this.valueType;
	      var commonProps = {
	        activeStartDate: activeStartDate,
	        hover: hover,
	        locale: locale,
	        maxDate: maxDate,
	        minDate: minDate,
	        onMouseOver: selectRange ? onMouseOver : null,
	        tileClassName: tileClassName,
	        tileContent: tileContent || renderChildren,
	        // For backwards compatibility
	        tileDisabled: tileDisabled,
	        value: value,
	        valueType: valueType
	      };
	      var clickAction = this.drillDownAvailable ? this.drillDown : this.onChange;
	
	      switch (view) {
	        case 'century':
	          {
	            var onClickDecade = this.props.onClickDecade;
	            return _react["default"].createElement(_CenturyView["default"], _extends({
	              onClick: (0, _utils.mergeFunctions)(clickAction, onClickDecade)
	            }, commonProps));
	          }
	
	        case 'decade':
	          {
	            var onClickYear = this.props.onClickYear;
	            return _react["default"].createElement(_DecadeView["default"], _extends({
	              onClick: (0, _utils.mergeFunctions)(clickAction, onClickYear)
	            }, commonProps));
	          }
	
	        case 'year':
	          {
	            var _this$props6 = this.props,
	                formatMonth = _this$props6.formatMonth,
	                onClickMonth = _this$props6.onClickMonth;
	            return _react["default"].createElement(_YearView["default"], _extends({
	              formatMonth: formatMonth,
	              onClick: (0, _utils.mergeFunctions)(clickAction, onClickMonth)
	            }, commonProps));
	          }
	
	        case 'month':
	          {
	            var _this$props7 = this.props,
	                formatShortWeekday = _this$props7.formatShortWeekday,
	                onClickDay = _this$props7.onClickDay,
	                onClickWeekNumber = _this$props7.onClickWeekNumber,
	                showFixedNumberOfWeeks = _this$props7.showFixedNumberOfWeeks,
	                showNeighboringMonth = _this$props7.showNeighboringMonth,
	                showWeekNumbers = _this$props7.showWeekNumbers;
	            var onMouseLeave = this.onMouseLeave;
	            return _react["default"].createElement(_MonthView["default"], _extends({
	              calendarType: calendarType,
	              formatShortWeekday: formatShortWeekday,
	              onClick: (0, _utils.mergeFunctions)(clickAction, onClickDay),
	              onClickWeekNumber: onClickWeekNumber,
	              onMouseLeave: onMouseLeave,
	              showFixedNumberOfWeeks: showFixedNumberOfWeeks,
	              showNeighboringMonth: showNeighboringMonth,
	              showWeekNumbers: showWeekNumbers
	            }, commonProps));
	          }
	
	        default:
	          throw new Error("Invalid view: ".concat(view, "."));
	      }
	    }
	  }, {
	    key: "renderNavigation",
	    value: function renderNavigation() {
	      var showNavigation = this.props.showNavigation;
	
	      if (!showNavigation) {
	        return null;
	      }
	
	      var _this$props8 = this.props,
	          formatMonthYear = _this$props8.formatMonthYear,
	          locale = _this$props8.locale,
	          maxDate = _this$props8.maxDate,
	          maxDetail = _this$props8.maxDetail,
	          minDate = _this$props8.minDate,
	          minDetail = _this$props8.minDetail,
	          navigationAriaLabel = _this$props8.navigationAriaLabel,
	          navigationLabel = _this$props8.navigationLabel,
	          next2AriaLabel = _this$props8.next2AriaLabel,
	          next2Label = _this$props8.next2Label,
	          nextAriaLabel = _this$props8.nextAriaLabel,
	          nextLabel = _this$props8.nextLabel,
	          prev2AriaLabel = _this$props8.prev2AriaLabel,
	          prev2Label = _this$props8.prev2Label,
	          prevAriaLabel = _this$props8.prevAriaLabel,
	          prevLabel = _this$props8.prevLabel;
	      var _this$state3 = this.state,
	          activeStartDate = _this$state3.activeStartDate,
	          view = _this$state3.view;
	      return _react["default"].createElement(_Navigation["default"], {
	        activeStartDate: activeStartDate,
	        drillUp: this.drillUp,
	        formatMonthYear: formatMonthYear,
	        locale: locale,
	        maxDate: maxDate,
	        minDate: minDate,
	        navigationAriaLabel: navigationAriaLabel,
	        navigationLabel: navigationLabel,
	        next2AriaLabel: next2AriaLabel,
	        next2Label: next2Label,
	        nextAriaLabel: nextAriaLabel,
	        nextLabel: nextLabel,
	        prev2AriaLabel: prev2AriaLabel,
	        prev2Label: prev2Label,
	        prevAriaLabel: prevAriaLabel,
	        prevLabel: prevLabel,
	        setActiveStartDate: this.setActiveStartDate,
	        view: view,
	        views: getLimitedViews(minDetail, maxDetail)
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props9 = this.props,
	          className = _this$props9.className,
	          selectRange = _this$props9.selectRange;
	      var value = this.state.value;
	      var onMouseLeave = this.onMouseLeave;
	      var valueArray = [].concat(value);
	      return _react["default"].createElement("div", {
	        className: (0, _mergeClassNames["default"])(baseClassName, selectRange && valueArray.length === 1 && "".concat(baseClassName, "--selectRange"), className)
	      }, this.renderNavigation(), _react["default"].createElement("div", {
	        className: "".concat(baseClassName, "__viewContainer"),
	        onBlur: selectRange ? onMouseLeave : null,
	        onMouseLeave: selectRange ? onMouseLeave : null
	      }, this.renderContent()));
	    }
	  }, {
	    key: "drillDownAvailable",
	    get: function get() {
	      var _this$props10 = this.props,
	          maxDetail = _this$props10.maxDetail,
	          minDetail = _this$props10.minDetail;
	      var view = this.state.view;
	      var views = getLimitedViews(minDetail, maxDetail);
	      return views.indexOf(view) < views.length - 1;
	    }
	  }, {
	    key: "drillUpAvailable",
	    get: function get() {
	      var _this$props11 = this.props,
	          maxDetail = _this$props11.maxDetail,
	          minDetail = _this$props11.minDetail;
	      var view = this.state.view;
	      var views = getLimitedViews(minDetail, maxDetail);
	      return views.indexOf(view) > 0;
	    }
	  }, {
	    key: "valueType",
	    get: function get() {
	      var maxDetail = this.props.maxDetail;
	      return getValueType(maxDetail);
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps, prevState) {
	      var minDate = nextProps.minDate,
	          maxDate = nextProps.maxDate,
	          minDetail = nextProps.minDetail,
	          maxDetail = nextProps.maxDetail;
	      var nextState = {};
	      /**
	       * If the next activeStartDate is different from the current one, update
	       * activeStartDate (for display) and activeStartDateProps (for future comparisons)
	       */
	
	      var nextActiveStartDate = getActiveStartDate(nextProps);
	
	      if (datesAreDifferent(nextActiveStartDate, prevState.activeStartDateProps)) {
	        nextState.activeStartDate = nextActiveStartDate;
	        nextState.activeStartDateProps = nextActiveStartDate;
	      }
	      /**
	       * If the next view is different from the current one, and the previously set view is not
	       * valid based on minDetail and maxDetail, get a new one.
	       */
	
	
	      var nextView = getView(nextProps.view, minDetail, maxDetail);
	
	      if (nextView !== prevState.viewProps && !isViewAllowed(prevState.view, minDetail, maxDetail)) {
	        nextState.view = nextView;
	        nextState.viewProps = nextView;
	      }
	      /**
	       * If the next value is different from the current one (with an exception of situation in
	       * which values provided are limited by minDate and maxDate so that the dates are the same),
	       * get a new one.
	       */
	
	
	      var values = [nextProps.value, prevState.valueProps];
	
	      if (nextState.view // Allowed view changed
	      || datesAreDifferent.apply(void 0, _toConsumableArray(values.map(function (value) {
	        return getValueFrom(value, minDate, maxDate, maxDetail);
	      }))) || datesAreDifferent.apply(void 0, _toConsumableArray(values.map(function (value) {
	        return getValueTo(value, minDate, maxDate, maxDetail);
	      })))) {
	        nextState.value = nextProps.value;
	        nextState.valueProps = nextProps.value;
	      }
	
	      if (!nextProps.selectRange && prevState.hover) {
	        nextState.hover = null;
	      }
	
	      return nextState;
	    }
	  }]);
	
	  return Calendar;
	}(_react.Component);
	
	exports["default"] = Calendar;
	Calendar.defaultProps = {
	  maxDetail: 'month',
	  minDetail: 'century',
	  returnValue: 'start',
	  showNavigation: true,
	  showNeighboringMonth: true,
	  view: 'month'
	};
	Calendar.propTypes = {
	  activeStartDate: _propTypes["default"].instanceOf(Date),
	  calendarType: _propTypes2.isCalendarType,
	  className: _propTypes2.isClassName,
	  formatMonth: _propTypes["default"].func,
	  formatMonthYear: _propTypes["default"].func,
	  formatShortWeekday: _propTypes["default"].func,
	  locale: _propTypes["default"].string,
	  maxDate: _propTypes2.isMaxDate,
	  maxDetail: _propTypes["default"].oneOf(allViews),
	  minDate: _propTypes2.isMinDate,
	  minDetail: _propTypes["default"].oneOf(allViews),
	  navigationAriaLabel: _propTypes["default"].string,
	  navigationLabel: _propTypes["default"].func,
	  next2AriaLabel: _propTypes["default"].string,
	  next2Label: _propTypes["default"].node,
	  nextAriaLabel: _propTypes["default"].string,
	  nextLabel: _propTypes["default"].node,
	  onActiveDateChange: _propTypes["default"].func,
	  onChange: _propTypes["default"].func,
	  onClickDay: _propTypes["default"].func,
	  onClickDecade: _propTypes["default"].func,
	  onClickMonth: _propTypes["default"].func,
	  onClickWeekNumber: _propTypes["default"].func,
	  onClickYear: _propTypes["default"].func,
	  onDrillDown: _propTypes["default"].func,
	  onDrillUp: _propTypes["default"].func,
	  prev2AriaLabel: _propTypes["default"].string,
	  prev2Label: _propTypes["default"].node,
	  prevAriaLabel: _propTypes["default"].string,
	  prevLabel: _propTypes["default"].node,
	  renderChildren: _propTypes["default"].func,
	  // For backwards compatibility
	  returnValue: _propTypes["default"].oneOf(['start', 'end', 'range']),
	  selectRange: _propTypes["default"].bool,
	  showFixedNumberOfWeeks: _propTypes["default"].bool,
	  showNavigation: _propTypes["default"].bool,
	  showNeighboringMonth: _propTypes["default"].bool,
	  showWeekNumbers: _propTypes["default"].bool,
	  tileClassName: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes2.isClassName]),
	  tileContent: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].node]),
	  tileDisabled: _propTypes["default"].func,
	  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes2.isValue]),
	  view: _propTypes["default"].oneOf(allViews)
	};
	(0, _reactLifecyclesCompat.polyfill)(Calendar);

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = Navigation;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(1));
	
	var _dates = __webpack_require__(15);
	
	var _dateFormatter = __webpack_require__(88);
	
	var _propTypes2 = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var className = 'react-calendar__navigation';
	
	function Navigation(_ref) {
	  var date = _ref.activeStartDate,
	      drillUp = _ref.drillUp,
	      formatMonthYear = _ref.formatMonthYear,
	      locale = _ref.locale,
	      maxDate = _ref.maxDate,
	      minDate = _ref.minDate,
	      navigationAriaLabel = _ref.navigationAriaLabel,
	      navigationLabel = _ref.navigationLabel,
	      next2AriaLabel = _ref.next2AriaLabel,
	      next2Label = _ref.next2Label,
	      nextAriaLabel = _ref.nextAriaLabel,
	      nextLabel = _ref.nextLabel,
	      prev2AriaLabel = _ref.prev2AriaLabel,
	      prev2Label = _ref.prev2Label,
	      prevAriaLabel = _ref.prevAriaLabel,
	      prevLabel = _ref.prevLabel,
	      setActiveStartDate = _ref.setActiveStartDate,
	      view = _ref.view,
	      views = _ref.views;
	  var drillUpAvailable = views.indexOf(view) > 0;
	  var shouldShowPrevNext2Buttons = view !== 'century';
	  var previousActiveStartDate = (0, _dates.getBeginPrevious)(view, date);
	  var previousActiveStartDate2 = shouldShowPrevNext2Buttons && (0, _dates.getBeginPrevious2)(view, date);
	  var nextActiveStartDate = (0, _dates.getBeginNext)(view, date);
	  var nextActiveStartDate2 = shouldShowPrevNext2Buttons && (0, _dates.getBeginNext2)(view, date);
	
	  var prevButtonDisabled = function () {
	    if (previousActiveStartDate.getFullYear() < 1000) {
	      return true;
	    }
	
	    var previousActiveEndDate = (0, _dates.getEndPrevious)(view, date);
	    return minDate && minDate >= previousActiveEndDate;
	  }();
	
	  var prev2ButtonDisabled = shouldShowPrevNext2Buttons && function () {
	    if (previousActiveStartDate2.getFullYear() < 1000) {
	      return true;
	    }
	
	    var previousActiveEndDate = (0, _dates.getEndPrevious2)(view, date);
	    return minDate && minDate >= previousActiveEndDate;
	  }();
	
	  var nextButtonDisabled = maxDate && maxDate <= nextActiveStartDate;
	  var next2ButtonDisabled = shouldShowPrevNext2Buttons && maxDate && maxDate <= nextActiveStartDate2;
	
	  function onClickPrevious() {
	    setActiveStartDate(previousActiveStartDate);
	  }
	
	  function onClickPrevious2() {
	    setActiveStartDate(previousActiveStartDate2);
	  }
	
	  function onClickNext() {
	    setActiveStartDate(nextActiveStartDate);
	  }
	
	  function onClickNext2() {
	    setActiveStartDate(nextActiveStartDate2);
	  }
	
	  var label = function () {
	    switch (view) {
	      case 'century':
	        return (0, _dates.getCenturyLabel)(date);
	
	      case 'decade':
	        return (0, _dates.getDecadeLabel)(date);
	
	      case 'year':
	        return (0, _dates.getYear)(date);
	
	      case 'month':
	        return formatMonthYear(locale, date);
	
	      default:
	        throw new Error("Invalid view: ".concat(view, "."));
	    }
	  }();
	
	  return _react["default"].createElement("div", {
	    className: className,
	    style: {
	      display: 'flex'
	    }
	  }, prev2Label !== null && shouldShowPrevNext2Buttons && _react["default"].createElement("button", {
	    "aria-label": prev2AriaLabel,
	    className: "".concat(className, "__arrow ").concat(className, "__prev2-button"),
	    disabled: prev2ButtonDisabled,
	    onClick: onClickPrevious2,
	    type: "button"
	  }, prev2Label), _react["default"].createElement("button", {
	    "aria-label": prevAriaLabel,
	    className: "".concat(className, "__arrow ").concat(className, "__prev-button"),
	    disabled: prevButtonDisabled,
	    onClick: onClickPrevious,
	    type: "button"
	  }, prevLabel), _react["default"].createElement("button", {
	    "aria-label": navigationAriaLabel,
	    className: "react-calendar__navigation__label",
	    disabled: !drillUpAvailable,
	    onClick: drillUp,
	    style: {
	      flexGrow: 1
	    },
	    type: "button"
	  }, navigationLabel ? navigationLabel({
	    date: date,
	    view: view,
	    label: label
	  }) : label), _react["default"].createElement("button", {
	    "aria-label": nextAriaLabel,
	    className: "".concat(className, "__arrow ").concat(className, "__next-button"),
	    disabled: nextButtonDisabled,
	    onClick: onClickNext,
	    type: "button"
	  }, nextLabel), next2Label !== null && shouldShowPrevNext2Buttons && _react["default"].createElement("button", {
	    "aria-label": next2AriaLabel,
	    className: "".concat(className, "__arrow ").concat(className, "__next2-button"),
	    disabled: next2ButtonDisabled,
	    onClick: onClickNext2,
	    type: "button"
	  }, next2Label));
	}
	
	Navigation.defaultProps = {
	  formatMonthYear: _dateFormatter.formatMonthYear,
	  navigationAriaLabel: '',
	  next2AriaLabel: '',
	  next2Label: '»',
	  nextAriaLabel: '',
	  nextLabel: '›',
	  prev2AriaLabel: '',
	  prev2Label: '«',
	  prevAriaLabel: '',
	  prevLabel: '‹'
	};
	Navigation.propTypes = {
	  activeStartDate: _propTypes["default"].instanceOf(Date).isRequired,
	  drillUp: _propTypes["default"].func.isRequired,
	  formatMonthYear: _propTypes["default"].func,
	  locale: _propTypes["default"].string,
	  maxDate: _propTypes["default"].instanceOf(Date),
	  minDate: _propTypes["default"].instanceOf(Date),
	  navigationAriaLabel: _propTypes["default"].string,
	  navigationLabel: _propTypes["default"].func,
	  next2AriaLabel: _propTypes["default"].string,
	  next2Label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
	  nextAriaLabel: _propTypes["default"].string,
	  nextLabel: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
	  prev2AriaLabel: _propTypes["default"].string,
	  prev2Label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
	  prevAriaLabel: _propTypes["default"].string,
	  prevLabel: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
	  setActiveStartDate: _propTypes["default"].func.isRequired,
	  view: _propTypes2.isView.isRequired,
	  views: _propTypes2.isViews.isRequired
	};

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = Decade;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(1));
	
	var _Tile = _interopRequireDefault(__webpack_require__(86));
	
	var _dates = __webpack_require__(15);
	
	var _propTypes2 = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var className = 'react-calendar__century-view__decades__decade';
	
	function Decade(_ref) {
	  var classes = _ref.classes,
	      point = _ref.point,
	      otherProps = _objectWithoutProperties(_ref, ["classes", "point"]);
	
	  return _react["default"].createElement(_Tile["default"], _extends({}, otherProps, {
	    classes: [].concat(classes, className),
	    maxDateTransform: _dates.getEndOfDecade,
	    minDateTransform: _dates.getBeginOfDecade,
	    view: "century"
	  }), (0, _dates.getDecadeLabel)(point));
	}
	
	Decade.propTypes = _objectSpread({}, _propTypes2.tileProps, {
	  point: _propTypes["default"].number.isRequired
	});

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = Decades;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _TileGroup = _interopRequireDefault(__webpack_require__(87));
	
	var _Decade = _interopRequireDefault(__webpack_require__(414));
	
	var _dates = __webpack_require__(15);
	
	var _propTypes = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function Decades(props) {
	  var activeStartDate = props.activeStartDate;
	  var start = (0, _dates.getBeginOfCenturyYear)(activeStartDate);
	  var end = start + 99;
	  return _react["default"].createElement(_TileGroup["default"], _extends({}, props, {
	    className: "react-calendar__century-view__decades",
	    dateTransform: _dates.getBeginOfDecade,
	    dateType: "decade",
	    end: end,
	    start: start,
	    step: 10,
	    tile: _Decade["default"]
	  }));
	}
	
	Decades.propTypes = _objectSpread({}, _propTypes.tileGroupProps);

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = Year;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(1));
	
	var _Tile = _interopRequireDefault(__webpack_require__(86));
	
	var _dates = __webpack_require__(15);
	
	var _propTypes2 = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var className = 'react-calendar__decade-view__years__year';
	
	function Year(_ref) {
	  var classes = _ref.classes,
	      point = _ref.point,
	      otherProps = _objectWithoutProperties(_ref, ["classes", "point"]);
	
	  return _react["default"].createElement(_Tile["default"], _extends({}, otherProps, {
	    classes: [].concat(classes, className),
	    maxDateTransform: _dates.getEndOfYear,
	    minDateTransform: _dates.getBeginOfYear,
	    view: "decade"
	  }), point);
	}
	
	Year.propTypes = _objectSpread({}, _propTypes2.tileProps, {
	  point: _propTypes["default"].number.isRequired
	});

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = Years;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _TileGroup = _interopRequireDefault(__webpack_require__(87));
	
	var _Year = _interopRequireDefault(__webpack_require__(416));
	
	var _dates = __webpack_require__(15);
	
	var _propTypes = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function Years(props) {
	  var activeStartDate = props.activeStartDate;
	  var start = (0, _dates.getBeginOfDecadeYear)(activeStartDate);
	  var end = start + 9;
	  return _react["default"].createElement(_TileGroup["default"], _extends({}, props, {
	    className: "react-calendar__decade-view__years",
	    dateTransform: function dateTransform(year) {
	      return new Date(year, 0, 1);
	    },
	    dateType: "year",
	    end: end,
	    start: start,
	    tile: _Year["default"]
	  }));
	}
	
	Years.propTypes = _objectSpread({}, _propTypes.tileGroupProps);

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = Day;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(1));
	
	var _Tile = _interopRequireDefault(__webpack_require__(86));
	
	var _dates = __webpack_require__(15);
	
	var _dateFormatter = __webpack_require__(88);
	
	var _propTypes2 = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var className = 'react-calendar__month-view__days__day';
	
	function Day(_ref) {
	  var calendarType = _ref.calendarType,
	      classes = _ref.classes,
	      currentMonthIndex = _ref.currentMonthIndex,
	      date = _ref.date,
	      otherProps = _objectWithoutProperties(_ref, ["calendarType", "classes", "currentMonthIndex", "date"]);
	
	  return _react["default"].createElement(_Tile["default"], _extends({}, otherProps, {
	    classes: [].concat(classes, className, (0, _dates.isWeekend)(date, calendarType) ? "".concat(className, "--weekend") : null, date.getMonth() !== currentMonthIndex ? "".concat(className, "--neighboringMonth") : null),
	    date: date,
	    formatAbbr: _dateFormatter.formatLongDate,
	    maxDateTransform: _dates.getEndOfDay,
	    minDateTransform: _dates.getBeginOfDay,
	    view: "month"
	  }), (0, _dates.getDay)(date));
	}
	
	Day.propTypes = _objectSpread({}, _propTypes2.tileProps, {
	  currentMonthIndex: _propTypes["default"].number.isRequired
	});

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = Days;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(1));
	
	var _TileGroup = _interopRequireDefault(__webpack_require__(87));
	
	var _Day = _interopRequireDefault(__webpack_require__(418));
	
	var _dates = __webpack_require__(15);
	
	var _propTypes2 = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function Days(props) {
	  var activeStartDate = props.activeStartDate,
	      calendarType = props.calendarType;
	
	  var showFixedNumberOfWeeks = props.showFixedNumberOfWeeks,
	      showNeighboringMonth = props.showNeighboringMonth,
	      otherProps = _objectWithoutProperties(props, ["showFixedNumberOfWeeks", "showNeighboringMonth"]);
	
	  var year = (0, _dates.getYear)(activeStartDate);
	  var monthIndex = (0, _dates.getMonthIndex)(activeStartDate);
	  var hasFixedNumberOfWeeks = showFixedNumberOfWeeks || showNeighboringMonth;
	  var dayOfWeek = (0, _dates.getDayOfWeek)(activeStartDate, calendarType);
	  var offset = hasFixedNumberOfWeeks ? 0 : dayOfWeek;
	  /**
	   * Defines on which day of the month the grid shall start. If we simply show current
	   * month, we obviously start on day one, but if showNeighboringMonth is set to
	   * true, we need to find the beginning of the week the first day of the month is in.
	   */
	
	  var start = (hasFixedNumberOfWeeks ? -dayOfWeek : 0) + 1;
	  /**
	   * Defines on which day of the month the grid shall end. If we simply show current
	   * month, we need to stop on the last day of the month, but if showNeighboringMonth
	   * is set to true, we need to find the end of the week the last day of the month is in.
	   */
	
	  var end = function () {
	    if (showFixedNumberOfWeeks) {
	      // Always show 6 weeks
	      return start + 6 * 7 - 1;
	    }
	
	    var daysInMonth = (0, _dates.getDaysInMonth)(activeStartDate);
	
	    if (showNeighboringMonth) {
	      var activeEndDate = new Date(year, monthIndex, daysInMonth);
	      return daysInMonth + (7 - (0, _dates.getDayOfWeek)(activeEndDate, calendarType) - 1);
	    }
	
	    return daysInMonth;
	  }();
	
	  return _react["default"].createElement(_TileGroup["default"], _extends({}, otherProps, {
	    className: "react-calendar__month-view__days",
	    count: 7,
	    currentMonthIndex: monthIndex,
	    dateTransform: function dateTransform(day) {
	      return new Date(year, monthIndex, day);
	    },
	    dateType: "day",
	    end: end,
	    offset: offset,
	    start: start,
	    tile: _Day["default"]
	  }));
	}
	
	Days.propTypes = _objectSpread({
	  calendarType: _propTypes2.isCalendarType.isRequired,
	  showFixedNumberOfWeeks: _propTypes["default"].bool,
	  showNeighboringMonth: _propTypes["default"].bool
	}, _propTypes2.tileGroupProps);

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = WeekNumber;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function WeekNumber(_ref) {
	  var date = _ref.date,
	      onClickWeekNumber = _ref.onClickWeekNumber,
	      weekNumber = _ref.weekNumber;
	  return onClickWeekNumber ? _react["default"].createElement("button", {
	    className: "react-calendar__tile",
	    onClick: function onClick() {
	      return onClickWeekNumber(weekNumber, date);
	    },
	    style: {
	      flexGrow: 1
	    },
	    type: "button"
	  }, _react["default"].createElement("span", null, weekNumber)) : _react["default"].createElement("div", {
	    className: "react-calendar__tile",
	    style: {
	      flexGrow: 1
	    }
	  }, _react["default"].createElement("span", null, weekNumber));
	}
	
	WeekNumber.propTypes = {
	  date: _propTypes["default"].instanceOf(Date).isRequired,
	  onClickWeekNumber: _propTypes["default"].func,
	  weekNumber: _propTypes["default"].number.isRequired
	};

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = WeekNumbers;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(1));
	
	var _WeekNumber = _interopRequireDefault(__webpack_require__(420));
	
	var _Flex = _interopRequireDefault(__webpack_require__(118));
	
	var _dates = __webpack_require__(15);
	
	var _propTypes2 = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function WeekNumbers(props) {
	  var activeStartDate = props.activeStartDate,
	      calendarType = props.calendarType,
	      onClickWeekNumber = props.onClickWeekNumber,
	      onMouseLeave = props.onMouseLeave,
	      showFixedNumberOfWeeks = props.showFixedNumberOfWeeks;
	
	  var numberOfWeeks = function () {
	    if (showFixedNumberOfWeeks) {
	      return 6;
	    }
	
	    var numberOfDays = (0, _dates.getDaysInMonth)(activeStartDate);
	    var startWeekday = (0, _dates.getDayOfWeek)(activeStartDate, calendarType);
	    var days = numberOfDays - (7 - startWeekday);
	    return 1 + Math.ceil(days / 7);
	  }();
	
	  var dates = function () {
	    var year = (0, _dates.getYear)(activeStartDate);
	    var monthIndex = (0, _dates.getMonthIndex)(activeStartDate);
	    var day = (0, _dates.getDay)(activeStartDate);
	    var result = [];
	
	    for (var index = 0; index < numberOfWeeks; index += 1) {
	      result.push((0, _dates.getBeginOfWeek)(new Date(year, monthIndex, day + index * 7), calendarType));
	    }
	
	    return result;
	  }();
	
	  var weekNumbers = dates.map(function (date) {
	    return (0, _dates.getWeekNumber)(date, calendarType);
	  });
	  return _react["default"].createElement(_Flex["default"], {
	    className: "react-calendar__month-view__weekNumbers",
	    count: numberOfWeeks,
	    direction: "column",
	    onFocus: onMouseLeave,
	    onMouseOver: onMouseLeave,
	    style: {
	      flexBasis: 'calc(100% * (1 / 8)',
	      flexShrink: 0
	    }
	  }, weekNumbers.map(function (weekNumber, weekIndex) {
	    return _react["default"].createElement(_WeekNumber["default"], {
	      key: weekNumber,
	      date: dates[weekIndex],
	      onClickWeekNumber: onClickWeekNumber,
	      weekNumber: weekNumber
	    });
	  }));
	}
	
	WeekNumbers.propTypes = {
	  activeStartDate: _propTypes["default"].instanceOf(Date).isRequired,
	  calendarType: _propTypes2.isCalendarType.isRequired,
	  onClickWeekNumber: _propTypes["default"].func,
	  onMouseLeave: _propTypes["default"].func,
	  showFixedNumberOfWeeks: _propTypes["default"].bool
	};

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = Weekdays;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(1));
	
	var _Flex = _interopRequireDefault(__webpack_require__(118));
	
	var _dates = __webpack_require__(15);
	
	var _dateFormatter = __webpack_require__(88);
	
	var _propTypes2 = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function Weekdays(props) {
	  var calendarType = props.calendarType,
	      formatShortWeekday = props.formatShortWeekday,
	      locale = props.locale,
	      onMouseLeave = props.onMouseLeave;
	  var anyDate = new Date();
	  var beginOfMonth = (0, _dates.getBeginOfMonth)(anyDate);
	  var year = (0, _dates.getYear)(beginOfMonth);
	  var monthIndex = (0, _dates.getMonthIndex)(beginOfMonth);
	  var weekdays = [];
	
	  for (var weekday = 1; weekday <= 7; weekday += 1) {
	    var weekdayDate = new Date(year, monthIndex, weekday - (0, _dates.getDayOfWeek)(beginOfMonth, calendarType));
	    var abbr = (0, _dateFormatter.formatWeekday)(locale, weekdayDate);
	    weekdays.push(_react["default"].createElement("div", {
	      key: weekday,
	      className: "react-calendar__month-view__weekdays__weekday"
	    }, _react["default"].createElement("abbr", {
	      "aria-label": abbr,
	      title: abbr
	    }, formatShortWeekday(locale, weekdayDate).replace('.', ''))));
	  }
	
	  return _react["default"].createElement(_Flex["default"], {
	    className: "react-calendar__month-view__weekdays",
	    count: 7,
	    onFocus: onMouseLeave,
	    onMouseOver: onMouseLeave
	  }, weekdays);
	}
	
	Weekdays.defaultProps = {
	  formatShortWeekday: _dateFormatter.formatShortWeekday
	};
	Weekdays.propTypes = {
	  calendarType: _propTypes2.isCalendarType.isRequired,
	  formatShortWeekday: _propTypes["default"].func,
	  locale: _propTypes["default"].string,
	  onMouseLeave: _propTypes["default"].func
	};

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = Month;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(1));
	
	var _Tile = _interopRequireDefault(__webpack_require__(86));
	
	var _dates = __webpack_require__(15);
	
	var _dateFormatter = __webpack_require__(88);
	
	var _propTypes2 = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var className = 'react-calendar__year-view__months__month';
	
	function Month(_ref) {
	  var classes = _ref.classes,
	      date = _ref.date,
	      formatMonth = _ref.formatMonth,
	      locale = _ref.locale,
	      otherProps = _objectWithoutProperties(_ref, ["classes", "date", "formatMonth", "locale"]);
	
	  return _react["default"].createElement(_Tile["default"], _extends({}, otherProps, {
	    classes: [].concat(classes, className),
	    date: date,
	    formatAbbr: _dateFormatter.formatMonthYear,
	    locale: locale,
	    maxDateTransform: _dates.getEndOfMonth,
	    minDateTransform: _dates.getBeginOfMonth,
	    view: "year"
	  }), formatMonth(locale, date));
	}
	
	Month.defaultProps = {
	  formatMonth: _dateFormatter.formatMonth
	};
	Month.propTypes = _objectSpread({}, _propTypes2.tileProps, {
	  formatMonth: _propTypes["default"].func
	});

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = Months;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(1));
	
	var _TileGroup = _interopRequireDefault(__webpack_require__(87));
	
	var _Month = _interopRequireDefault(__webpack_require__(423));
	
	var _dates = __webpack_require__(15);
	
	var _propTypes2 = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function Months(props) {
	  var activeStartDate = props.activeStartDate;
	  var start = 0;
	  var end = 11;
	  var year = (0, _dates.getYear)(activeStartDate);
	  return _react["default"].createElement(_TileGroup["default"], _extends({}, props, {
	    className: "react-calendar__year-view__months",
	    dateTransform: function dateTransform(monthIndex) {
	      return new Date(year, monthIndex, 1);
	    },
	    dateType: "month",
	    end: end,
	    start: start,
	    tile: _Month["default"]
	  }));
	}
	
	Months.propTypes = _objectSpread({}, _propTypes2.tileGroupProps, {
	  locale: _propTypes["default"].string
	});

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "Calendar", {
	  enumerable: true,
	  get: function get() {
	    return _Calendar["default"];
	  }
	});
	Object.defineProperty(exports, "CenturyView", {
	  enumerable: true,
	  get: function get() {
	    return _CenturyView["default"];
	  }
	});
	Object.defineProperty(exports, "DecadeView", {
	  enumerable: true,
	  get: function get() {
	    return _DecadeView["default"];
	  }
	});
	Object.defineProperty(exports, "YearView", {
	  enumerable: true,
	  get: function get() {
	    return _YearView["default"];
	  }
	});
	Object.defineProperty(exports, "MonthView", {
	  enumerable: true,
	  get: function get() {
	    return _MonthView["default"];
	  }
	});
	exports["default"] = void 0;
	
	var _Calendar = _interopRequireDefault(__webpack_require__(412));
	
	var _CenturyView = _interopRequireDefault(__webpack_require__(179));
	
	var _DecadeView = _interopRequireDefault(__webpack_require__(180));
	
	var _YearView = _interopRequireDefault(__webpack_require__(182));
	
	var _MonthView = _interopRequireDefault(__webpack_require__(181));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _default = _Calendar["default"];
	exports["default"] = _default;

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = Clock;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(1));
	
	var _mergeClassNames = _interopRequireDefault(__webpack_require__(29));
	
	var _Hand = _interopRequireDefault(__webpack_require__(427));
	
	var _Mark = _interopRequireDefault(__webpack_require__(428));
	
	var _dates = __webpack_require__(120);
	
	var _propTypes2 = __webpack_require__(121);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function Clock(_ref) {
	  var className = _ref.className,
	      hourHandLength = _ref.hourHandLength,
	      hourHandOppositeLength = _ref.hourHandOppositeLength,
	      hourHandWidth = _ref.hourHandWidth,
	      hourMarksLength = _ref.hourMarksLength,
	      hourMarksWidth = _ref.hourMarksWidth,
	      minuteHandLength = _ref.minuteHandLength,
	      minuteHandOppositeLength = _ref.minuteHandOppositeLength,
	      minuteHandWidth = _ref.minuteHandWidth,
	      minuteMarksLength = _ref.minuteMarksLength,
	      minuteMarksWidth = _ref.minuteMarksWidth,
	      renderHourMarks = _ref.renderHourMarks,
	      renderMinuteHand = _ref.renderMinuteHand,
	      renderMinuteMarks = _ref.renderMinuteMarks,
	      renderNumbers = _ref.renderNumbers,
	      renderSecondHand = _ref.renderSecondHand,
	      secondHandLength = _ref.secondHandLength,
	      secondHandOppositeLength = _ref.secondHandOppositeLength,
	      secondHandWidth = _ref.secondHandWidth,
	      size = _ref.size,
	      value = _ref.value;
	
	  function renderMinuteMarksFn() {
	    if (!renderMinuteMarks) {
	      return null;
	    }
	
	    var minuteMarks = [];
	
	    for (var i = 1; i <= 60; i += 1) {
	      var isHourMark = renderHourMarks && !(i % 5);
	
	      if (!isHourMark) {
	        minuteMarks.push(_react["default"].createElement(_Mark["default"], {
	          key: "minute_".concat(i),
	          angle: i * 6,
	          length: minuteMarksLength,
	          name: "minute",
	          width: minuteMarksWidth
	        }));
	      }
	    }
	
	    return minuteMarks;
	  }
	
	  function renderHourMarksFn() {
	    if (!renderHourMarks) {
	      return null;
	    }
	
	    var hourMarks = [];
	
	    for (var i = 1; i <= 12; i += 1) {
	      hourMarks.push(_react["default"].createElement(_Mark["default"], {
	        key: "hour_".concat(i),
	        angle: i * 30,
	        length: hourMarksLength,
	        name: "hour",
	        number: renderNumbers ? i : null,
	        width: hourMarksWidth
	      }));
	    }
	
	    return hourMarks;
	  }
	
	  function renderFace() {
	    return _react["default"].createElement("div", {
	      className: "react-clock__face"
	    }, renderMinuteMarksFn(), renderHourMarksFn());
	  }
	
	  function renderHourHandFn() {
	    var angle = value ? (0, _dates.getHours)(value) * 30 + (0, _dates.getMinutes)(value) / 2 + (0, _dates.getSeconds)(value) / 600 : 0;
	    return _react["default"].createElement(_Hand["default"], {
	      angle: angle,
	      length: hourHandLength,
	      name: "hour",
	      oppositeLength: hourHandOppositeLength,
	      width: hourHandWidth
	    });
	  }
	
	  function renderMinuteHandFn() {
	    if (!renderMinuteHand) {
	      return null;
	    }
	
	    var angle = value ? (0, _dates.getHours)(value) * 360 + (0, _dates.getMinutes)(value) * 6 + (0, _dates.getSeconds)(value) / 10 : 0;
	    return _react["default"].createElement(_Hand["default"], {
	      angle: angle,
	      length: minuteHandLength,
	      name: "minute",
	      oppositeLength: minuteHandOppositeLength,
	      width: minuteHandWidth
	    });
	  }
	
	  function renderSecondHandFn() {
	    if (!renderSecondHand) {
	      return null;
	    }
	
	    var angle = value ? (0, _dates.getMinutes)(value) * 360 + (0, _dates.getSeconds)(value) * 6 : 0;
	    return _react["default"].createElement(_Hand["default"], {
	      angle: angle,
	      length: secondHandLength,
	      name: "second",
	      oppositeLength: secondHandOppositeLength,
	      width: secondHandWidth
	    });
	  }
	
	  return _react["default"].createElement("time", {
	    className: (0, _mergeClassNames["default"])('react-clock', className),
	    dateTime: value instanceof Date ? value.toISOString() : value,
	    style: {
	      width: "".concat(size, "px"),
	      height: "".concat(size, "px")
	    }
	  }, renderFace(), renderHourHandFn(), renderMinuteHandFn(), renderSecondHandFn());
	}
	
	Clock.defaultProps = {
	  hourHandLength: 50,
	  hourHandWidth: 4,
	  hourMarksLength: 10,
	  hourMarksWidth: 3,
	  minuteHandLength: 70,
	  minuteHandWidth: 2,
	  minuteMarksLength: 6,
	  minuteMarksWidth: 1,
	  renderHourMarks: true,
	  renderMinuteHand: true,
	  renderMinuteMarks: true,
	  renderSecondHand: true,
	  secondHandLength: 90,
	  secondHandWidth: 1,
	  size: 150
	};
	Clock.propTypes = {
	  className: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].arrayOf(_propTypes["default"].string)]),
	  hourHandLength: _propTypes2.isHandLength,
	  hourHandOppositeLength: _propTypes2.isOppositeHandLength,
	  hourHandWidth: _propTypes2.isHandWidth,
	  hourMarksLength: _propTypes2.isMarkLength,
	  hourMarksWidth: _propTypes2.isMarkWidth,
	  minuteHandLength: _propTypes2.isHandLength,
	  minuteHandOppositeLength: _propTypes2.isOppositeHandLength,
	  minuteHandWidth: _propTypes2.isHandWidth,
	  minuteMarksLength: _propTypes2.isMarkLength,
	  minuteMarksWidth: _propTypes2.isMarkWidth,
	  renderHourMarks: _propTypes["default"].bool,
	  renderMinuteHand: _propTypes["default"].bool,
	  renderMinuteMarks: _propTypes["default"].bool,
	  renderNumbers: _propTypes["default"].bool,
	  renderSecondHand: _propTypes["default"].bool,
	  secondHandLength: _propTypes2.isHandLength,
	  secondHandOppositeLength: _propTypes2.isOppositeHandLength,
	  secondHandWidth: _propTypes2.isHandWidth,
	  size: _propTypes["default"].number,
	  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].instanceOf(Date)])
	};

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = Hand;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes2 = __webpack_require__(121);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function Hand(_ref) {
	  var angle = _ref.angle,
	      name = _ref.name,
	      length = _ref.length,
	      oppositeLength = _ref.oppositeLength,
	      width = _ref.width;
	  return _react["default"].createElement("div", {
	    className: "react-clock__hand react-clock__".concat(name, "-hand"),
	    style: {
	      transform: "rotate(".concat(angle, "deg)")
	    }
	  }, _react["default"].createElement("div", {
	    className: "react-clock__hand__body react-clock__".concat(name, "-hand__body"),
	    style: {
	      width: "".concat(width, "px"),
	      top: "".concat(50 - length / 2, "%"),
	      bottom: "".concat(50 - oppositeLength / 2, "%")
	    }
	  }));
	}
	
	Hand.defaultProps = {
	  angle: 0,
	  length: 100,
	  oppositeLength: 10,
	  width: 1
	};
	Hand.propTypes = {
	  angle: _propTypes["default"].number,
	  length: _propTypes2.isHandLength,
	  name: _propTypes["default"].string.isRequired,
	  oppositeLength: _propTypes2.isHandLength,
	  width: _propTypes["default"].number
	};

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = Mark;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes2 = __webpack_require__(121);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function Mark(_ref) {
	  var angle = _ref.angle,
	      length = _ref.length,
	      name = _ref.name,
	      width = _ref.width,
	      number = _ref.number;
	  return _react["default"].createElement("div", {
	    className: "react-clock__mark react-clock__".concat(name, "-mark"),
	    style: {
	      transform: "rotate(".concat(angle, "deg)")
	    }
	  }, _react["default"].createElement("div", {
	    className: "react-clock__mark__body react-clock__".concat(name, "-mark__body"),
	    style: {
	      width: "".concat(width, "px"),
	      top: 0,
	      bottom: "".concat(100 - length / 2, "%")
	    }
	  }), number && _react["default"].createElement("div", {
	    className: "react-clock__mark__number",
	    style: {
	      transform: "rotate(-".concat(angle, "deg)"),
	      top: "".concat(length / 2, "%")
	    }
	  }, number));
	}
	
	Mark.defaultProps = {
	  angle: 0,
	  length: 10,
	  width: 1
	};
	Mark.propTypes = {
	  angle: _propTypes["default"].number,
	  length: _propTypes2.isMarkLength,
	  name: _propTypes["default"].string.isRequired,
	  number: _propTypes["default"].number,
	  width: _propTypes2.isMarkWidth
	};

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "Clock", {
	  enumerable: true,
	  get: function get() {
	    return _Clock["default"];
	  }
	});
	exports["default"] = void 0;
	
	var _Clock = _interopRequireDefault(__webpack_require__(426));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _default = _Clock["default"];
	exports["default"] = _default;

/***/ }),
/* 430 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isDefined = void 0;
	
	/* eslint-disable import/prefer-default-export */
	
	/**
	 * Checks whether a variable is defined.
	 *
	 * @param {*} variable Variable to check
	 */
	var isDefined = function isDefined(variable) {
	  return typeof variable !== 'undefined';
	};
	
	exports.isDefined = isDefined;

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = DayInput;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(1));
	
	var _Input = _interopRequireDefault(__webpack_require__(122));
	
	var _dates = __webpack_require__(89);
	
	var _propTypes2 = __webpack_require__(90);
	
	var _utils = __webpack_require__(63);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function DayInput(_ref) {
	  var maxDate = _ref.maxDate,
	      minDate = _ref.minDate,
	      month = _ref.month,
	      year = _ref.year,
	      otherProps = _objectWithoutProperties(_ref, ["maxDate", "minDate", "month", "year"]);
	
	  var currentMonthMaxDays = function () {
	    if (!month) {
	      return 31;
	    }
	
	    return (0, _dates.getDaysInMonth)(new Date(year, month - 1, 1));
	  }();
	
	  var maxDay = (0, _utils.min)(currentMonthMaxDays, maxDate && year === (0, _dates.getYear)(maxDate) && month === (0, _dates.getMonth)(maxDate) && (0, _dates.getDay)(maxDate));
	  var minDay = (0, _utils.max)(1, minDate && year === (0, _dates.getYear)(minDate) && month === (0, _dates.getMonth)(minDate) && (0, _dates.getDay)(minDate));
	  return _react["default"].createElement(_Input["default"], _extends({
	    max: maxDay,
	    min: minDay,
	    name: "day"
	  }, otherProps));
	}
	
	DayInput.propTypes = {
	  ariaLabel: _propTypes["default"].string,
	  className: _propTypes["default"].string.isRequired,
	  disabled: _propTypes["default"].bool,
	  itemRef: _propTypes["default"].func,
	  maxDate: _propTypes2.isMaxDate,
	  minDate: _propTypes2.isMinDate,
	  month: _propTypes["default"].number,
	  onChange: _propTypes["default"].func,
	  onKeyDown: _propTypes["default"].func,
	  onKeyUp: _propTypes["default"].func,
	  placeholder: _propTypes["default"].string,
	  required: _propTypes["default"].bool,
	  showLeadingZeros: _propTypes["default"].bool,
	  value: _propTypes["default"].number,
	  year: _propTypes["default"].number
	};

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = MonthInput;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(1));
	
	var _Input = _interopRequireDefault(__webpack_require__(122));
	
	var _dates = __webpack_require__(89);
	
	var _propTypes2 = __webpack_require__(90);
	
	var _utils = __webpack_require__(63);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function MonthInput(_ref) {
	  var maxDate = _ref.maxDate,
	      minDate = _ref.minDate,
	      year = _ref.year,
	      otherProps = _objectWithoutProperties(_ref, ["maxDate", "minDate", "year"]);
	
	  var maxMonth = (0, _utils.min)(12, maxDate && year === (0, _dates.getYear)(maxDate) && (0, _dates.getMonth)(maxDate));
	  var minMonth = (0, _utils.max)(1, minDate && year === (0, _dates.getYear)(minDate) && (0, _dates.getMonth)(minDate));
	  return _react["default"].createElement(_Input["default"], _extends({
	    max: maxMonth,
	    min: minMonth,
	    name: "month"
	  }, otherProps));
	}
	
	MonthInput.propTypes = {
	  ariaLabel: _propTypes["default"].string,
	  className: _propTypes["default"].string.isRequired,
	  disabled: _propTypes["default"].bool,
	  itemRef: _propTypes["default"].func,
	  maxDate: _propTypes2.isMaxDate,
	  minDate: _propTypes2.isMinDate,
	  onChange: _propTypes["default"].func,
	  onKeyDown: _propTypes["default"].func,
	  onKeyUp: _propTypes["default"].func,
	  placeholder: _propTypes["default"].string,
	  required: _propTypes["default"].bool,
	  showLeadingZeros: _propTypes["default"].bool,
	  value: _propTypes["default"].number,
	  year: _propTypes["default"].number
	};

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = MonthSelect;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(1));
	
	var _mergeClassNames = _interopRequireDefault(__webpack_require__(29));
	
	var _dates = __webpack_require__(89);
	
	var _dateFormatter = __webpack_require__(435);
	
	var _propTypes2 = __webpack_require__(90);
	
	var _utils = __webpack_require__(63);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function MonthSelect(_ref) {
	  var ariaLabel = _ref.ariaLabel,
	      className = _ref.className,
	      itemRef = _ref.itemRef,
	      locale = _ref.locale,
	      maxDate = _ref.maxDate,
	      minDate = _ref.minDate,
	      _short = _ref["short"],
	      year = _ref.year,
	      value = _ref.value,
	      placeholder = _ref.placeholder,
	      otherProps = _objectWithoutProperties(_ref, ["ariaLabel", "className", "itemRef", "locale", "maxDate", "minDate", "short", "year", "value", "placeholder"]);
	
	  var maxMonth = (0, _utils.min)(12, maxDate && year === (0, _dates.getYear)(maxDate) && (0, _dates.getMonth)(maxDate));
	  var minMonth = (0, _utils.max)(1, minDate && year === (0, _dates.getYear)(minDate) && (0, _dates.getMonth)(minDate));
	
	  var dates = _toConsumableArray(Array(12)).map(function (el, index) {
	    return new Date(2019, index, 1);
	  });
	
	  var name = 'month';
	  var formatter = _short ? _dateFormatter.formatShortMonth : _dateFormatter.formatMonth;
	  return _react["default"].createElement("select", _extends({
	    "aria-label": ariaLabel,
	    className: (0, _mergeClassNames["default"])("".concat(className, "__input"), "".concat(className, "__").concat(name)),
	    name: name,
	    ref: function ref(_ref2) {
	      if (itemRef) {
	        itemRef(_ref2, name);
	      }
	    },
	    value: value !== null ? value : ''
	  }, otherProps), !value && _react["default"].createElement("option", {
	    value: ""
	  }, placeholder), dates.map(function (date) {
	    var month = (0, _dates.getMonth)(date);
	    var disabled = month < minMonth || month > maxMonth;
	    return _react["default"].createElement("option", {
	      key: month,
	      disabled: disabled,
	      value: month
	    }, formatter(locale, date));
	  }));
	}
	
	MonthSelect.propTypes = {
	  ariaLabel: _propTypes["default"].string,
	  className: _propTypes["default"].string.isRequired,
	  disabled: _propTypes["default"].bool,
	  itemRef: _propTypes["default"].func,
	  locale: _propTypes["default"].string,
	  maxDate: _propTypes2.isMaxDate,
	  minDate: _propTypes2.isMinDate,
	  onChange: _propTypes["default"].func,
	  onKeyDown: _propTypes["default"].func,
	  onKeyUp: _propTypes["default"].func,
	  placeholder: _propTypes["default"].string,
	  required: _propTypes["default"].bool,
	  "short": _propTypes["default"].bool,
	  value: _propTypes["default"].number,
	  year: _propTypes["default"].number
	};
	MonthSelect.defaultProps = {
	  placeholder: '--'
	};

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = YearInput;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(1));
	
	var _Input = _interopRequireDefault(__webpack_require__(122));
	
	var _dates = __webpack_require__(89);
	
	var _propTypes2 = __webpack_require__(90);
	
	var _utils = __webpack_require__(63);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function YearInput(_ref) {
	  var maxDate = _ref.maxDate,
	      minDate = _ref.minDate,
	      valueType = _ref.valueType,
	      otherProps = _objectWithoutProperties(_ref, ["maxDate", "minDate", "valueType"]);
	
	  var maxYear = (0, _utils.min)(275760, maxDate && (0, _dates.getYear)(maxDate));
	  var minYear = (0, _utils.max)(1000, minDate && (0, _dates.getYear)(minDate));
	
	  var yearStep = function () {
	    if (valueType === 'century') {
	      return 10;
	    }
	
	    return 1;
	  }();
	
	  return _react["default"].createElement(_Input["default"], _extends({
	    max: maxYear,
	    min: minYear,
	    name: "year",
	    step: yearStep
	  }, otherProps));
	}
	
	YearInput.propTypes = {
	  ariaLabel: _propTypes["default"].string,
	  className: _propTypes["default"].string.isRequired,
	  disabled: _propTypes["default"].bool,
	  itemRef: _propTypes["default"].func,
	  maxDate: _propTypes2.isMaxDate,
	  minDate: _propTypes2.isMinDate,
	  onChange: _propTypes["default"].func,
	  onKeyDown: _propTypes["default"].func,
	  onKeyUp: _propTypes["default"].func,
	  placeholder: _propTypes["default"].string,
	  required: _propTypes["default"].bool,
	  value: _propTypes["default"].number,
	  valueType: _propTypes2.isValueType
	};
	YearInput.defaultProps = {
	  placeholder: '----'
	};

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getFormatter = getFormatter;
	exports.formatShortMonth = exports.formatMonth = void 0;
	
	var _getUserLocale = _interopRequireDefault(__webpack_require__(82));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function getFormatter(options) {
	  return function (locale, date) {
	    return date.toLocaleString(locale || (0, _getUserLocale["default"])(), options);
	  };
	}
	/**
	 * Changes the hour in a Date to ensure right date formatting even if DST is messed up.
	 * Workaround for bug in WebKit and Firefox with historical dates.
	 * For more details, see:
	 * https://bugs.chromium.org/p/chromium/issues/detail?id=750465
	 * https://bugzilla.mozilla.org/show_bug.cgi?id=1385643
	 *
	 * @param {Date} date Date.
	 */
	
	
	function toSafeHour(date) {
	  var safeDate = new Date(date);
	  return new Date(safeDate.setHours(12));
	}
	
	function getSafeFormatter(options) {
	  return function (locale, date) {
	    return getFormatter(options)(locale, toSafeHour(date));
	  };
	}
	
	var formatMonthOptions = {
	  month: 'long'
	};
	var formatShortMonthOptions = {
	  month: 'short'
	};
	var formatMonth = getSafeFormatter(formatMonthOptions);
	exports.formatMonth = formatMonth;
	var formatShortMonth = getSafeFormatter(formatShortMonthOptions);
	exports.formatShortMonth = formatShortMonth;

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

	/** @license React v16.10.1
	 * react-dom.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	/*
	 Modernizr 3.0.0pre (Custom Build) | MIT
	*/
	'use strict';var aa=__webpack_require__(2),n=__webpack_require__(85),r=__webpack_require__(902);function t(a){for(var b=a.message,c="https://reactjs.org/docs/error-decoder.html?invariant="+b,d=1;d<arguments.length;d++)c+="&args[]="+encodeURIComponent(arguments[d]);a.message="Minified React error #"+b+"; visit "+c+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ";return a}if(!aa)throw t(Error(227));var ba=null,ca={};
	function da(){if(ba)for(var a in ca){var b=ca[a],c=ba.indexOf(a);if(!(-1<c))throw t(Error(96),a);if(!ea[c]){if(!b.extractEvents)throw t(Error(97),a);ea[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;if(fa.hasOwnProperty(h))throw t(Error(99),h);fa[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ha(k[e],g,h);e=!0}else f.registrationName?(ha(f.registrationName,g,h),e=!0):e=!1;if(!e)throw t(Error(98),d,a);}}}}
	function ha(a,b,c){if(ia[a])throw t(Error(100),a);ia[a]=b;ja[a]=b.eventTypes[c].dependencies}var ea=[],fa={},ia={},ja={};function ka(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var la=!1,ma=null,na=!1,oa=null,pa={onError:function(a){la=!0;ma=a}};function qa(a,b,c,d,e,f,g,h,k){la=!1;ma=null;ka.apply(pa,arguments)}
	function ra(a,b,c,d,e,f,g,h,k){qa.apply(this,arguments);if(la){if(la){var l=ma;la=!1;ma=null}else throw t(Error(198));na||(na=!0,oa=l)}}var sa=null,ta=null,ua=null;function va(a,b,c){var d=a.type||"unknown-event";a.currentTarget=ua(c);ra(d,b,void 0,a);a.currentTarget=null}function wa(a,b){if(null==b)throw t(Error(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}
	function xa(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var ya=null;function za(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)va(a,b[d],c[d]);else b&&va(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function Aa(a){null!==a&&(ya=wa(ya,a));a=ya;ya=null;if(a){xa(a,za);if(ya)throw t(Error(95));if(na)throw a=oa,na=!1,oa=null,a;}}
	var Ba={injectEventPluginOrder:function(a){if(ba)throw t(Error(101));ba=Array.prototype.slice.call(a);da()},injectEventPluginsByName:function(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!ca.hasOwnProperty(c)||ca[c]!==d){if(ca[c])throw t(Error(102),c);ca[c]=d;b=!0}}b&&da()}};
	function Ca(a,b){var c=a.stateNode;if(!c)return null;var d=sa(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw t(Error(231),b,typeof c);
	return c}var Da=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Da.hasOwnProperty("ReactCurrentDispatcher")||(Da.ReactCurrentDispatcher={current:null});Da.hasOwnProperty("ReactCurrentBatchConfig")||(Da.ReactCurrentBatchConfig={suspense:null});
	var Ea=/^(.*)[\\\/]/,x="function"===typeof Symbol&&Symbol.for,Fa=x?Symbol.for("react.element"):60103,Ga=x?Symbol.for("react.portal"):60106,Ha=x?Symbol.for("react.fragment"):60107,Ia=x?Symbol.for("react.strict_mode"):60108,Ja=x?Symbol.for("react.profiler"):60114,Ka=x?Symbol.for("react.provider"):60109,La=x?Symbol.for("react.context"):60110,Ma=x?Symbol.for("react.concurrent_mode"):60111,Na=x?Symbol.for("react.forward_ref"):60112,Oa=x?Symbol.for("react.suspense"):60113,Pa=x?Symbol.for("react.suspense_list"):
	60120,Qa=x?Symbol.for("react.memo"):60115,Ra=x?Symbol.for("react.lazy"):60116;x&&Symbol.for("react.fundamental");x&&Symbol.for("react.responder");x&&Symbol.for("react.scope");var Sa="function"===typeof Symbol&&Symbol.iterator;function Ta(a){if(null===a||"object"!==typeof a)return null;a=Sa&&a[Sa]||a["@@iterator"];return"function"===typeof a?a:null}
	function Ua(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
	function Va(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case Ha:return"Fragment";case Ga:return"Portal";case Ja:return"Profiler";case Ia:return"StrictMode";case Oa:return"Suspense";case Pa:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case La:return"Context.Consumer";case Ka:return"Context.Provider";case Na:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
	"ForwardRef");case Qa:return Va(a.type);case Ra:if(a=1===a._status?a._result:null)return Va(a)}return null}function Wa(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=Va(a.type);c=null;d&&(c=Va(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Ea,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
	var Xa=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),Ya=null,Za=null,$a=null;function ab(a){if(a=ta(a)){if("function"!==typeof Ya)throw t(Error(280));var b=sa(a.stateNode);Ya(a.stateNode,a.type,b)}}function bb(a){Za?$a?$a.push(a):$a=[a]:Za=a}function cb(){if(Za){var a=Za,b=$a;$a=Za=null;ab(a);if(b)for(a=0;a<b.length;a++)ab(b[a])}}function db(a,b){return a(b)}function eb(a,b,c,d){return a(b,c,d)}function fb(){}
	var gb=db,hb=!1,ib=!1;function jb(){if(null!==Za||null!==$a)fb(),cb()}new Map;new Map;new Map;var kb=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,lb=Object.prototype.hasOwnProperty,mb={},nb={};
	function ob(a){if(lb.call(nb,a))return!0;if(lb.call(mb,a))return!1;if(kb.test(a))return nb[a]=!0;mb[a]=!0;return!1}function pb(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
	function qb(a,b,c,d){if(null===b||"undefined"===typeof b||pb(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function B(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var C={};
	"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){C[a]=new B(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];C[b]=new B(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){C[a]=new B(a,2,!1,a.toLowerCase(),null,!1)});
	["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){C[a]=new B(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){C[a]=new B(a,3,!1,a.toLowerCase(),null,!1)});
	["checked","multiple","muted","selected"].forEach(function(a){C[a]=new B(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){C[a]=new B(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){C[a]=new B(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){C[a]=new B(a,5,!1,a.toLowerCase(),null,!1)});var rb=/[\-:]([a-z])/g;function sb(a){return a[1].toUpperCase()}
	"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(rb,
	sb);C[b]=new B(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(rb,sb);C[b]=new B(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(rb,sb);C[b]=new B(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){C[a]=new B(a,1,!1,a.toLowerCase(),null,!1)});
	C.xlinkHref=new B("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){C[a]=new B(a,1,!1,a.toLowerCase(),null,!0)});function tb(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}
	function ub(a,b,c,d){var e=C.hasOwnProperty(b)?C[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(qb(b,c,e,d)&&(c=null),d||null===e?ob(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
	function vb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
	function xb(a){var b=vb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
	null;delete a[b]}}}}function yb(a){a._valueTracker||(a._valueTracker=xb(a))}function zb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=vb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function Ab(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
	function Bb(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=tb(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Cb(a,b){b=b.checked;null!=b&&ub(a,"checked",b,!1)}
	function Db(a,b){Cb(a,b);var c=tb(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Eb(a,b.type,c):b.hasOwnProperty("defaultValue")&&Eb(a,b.type,tb(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
	function Gb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
	function Eb(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function Hb(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function Ib(a,b){a=n({children:void 0},b);if(b=Hb(b.children))a.children=b;return a}
	function Jb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+tb(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
	function Kb(a,b){if(null!=b.dangerouslySetInnerHTML)throw t(Error(91));return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Lb(a,b){var c=b.value;if(null==c){c=b.defaultValue;b=b.children;if(null!=b){if(null!=c)throw t(Error(92));if(Array.isArray(b)){if(!(1>=b.length))throw t(Error(93));b=b[0]}c=b}null==c&&(c="")}a._wrapperState={initialValue:tb(c)}}
	function Mb(a,b){var c=tb(b.value),d=tb(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Nb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var Ob={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
	function Pb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Qb(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Pb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
	var Rb,Sb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Ob.svg||"innerHTML"in a)a.innerHTML=b;else{Rb=Rb||document.createElement("div");Rb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=Rb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
	function Tb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}function Ub(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Vb={animationend:Ub("Animation","AnimationEnd"),animationiteration:Ub("Animation","AnimationIteration"),animationstart:Ub("Animation","AnimationStart"),transitionend:Ub("Transition","TransitionEnd")},Wb={},Xb={};
	Xa&&(Xb=document.createElement("div").style,"AnimationEvent"in window||(delete Vb.animationend.animation,delete Vb.animationiteration.animation,delete Vb.animationstart.animation),"TransitionEvent"in window||delete Vb.transitionend.transition);function Yb(a){if(Wb[a])return Wb[a];if(!Vb[a])return a;var b=Vb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Xb)return Wb[a]=b[c];return a}
	var Zb=Yb("animationend"),$b=Yb("animationiteration"),ac=Yb("animationstart"),bc=Yb("transitionend"),dc="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),ec=!1,fc=[],gc=null,hc=null,ic=null,jc=new Map,kc=new Map,lc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),
	mc="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");function nc(a){var b=oc(a);lc.forEach(function(c){pc(c,a,b)});mc.forEach(function(c){pc(c,a,b)})}function qc(a,b,c,d){return{blockedOn:a,topLevelType:b,eventSystemFlags:c|32,nativeEvent:d}}
	function rc(a,b){switch(a){case "focus":case "blur":gc=null;break;case "dragenter":case "dragleave":hc=null;break;case "mouseover":case "mouseout":ic=null;break;case "pointerover":case "pointerout":jc.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":kc.delete(b.pointerId)}}function sc(a,b,c,d,e){if(null===a||a.nativeEvent!==e)return qc(b,c,d,e);a.eventSystemFlags|=d;return a}
	function tc(a,b,c,d){switch(b){case "focus":return gc=sc(gc,a,b,c,d),!0;case "dragenter":return hc=sc(hc,a,b,c,d),!0;case "mouseover":return ic=sc(ic,a,b,c,d),!0;case "pointerover":var e=d.pointerId;jc.set(e,sc(jc.get(e)||null,a,b,c,d));return!0;case "gotpointercapture":return e=d.pointerId,kc.set(e,sc(kc.get(e)||null,a,b,c,d)),!0}return!1}function uc(a){if(null!==a.blockedOn)return!1;var b=vc(a.topLevelType,a.eventSystemFlags,a.nativeEvent);return null!==b?(a.blockedOn=b,!1):!0}
	function wc(a,b,c){uc(a)&&c.delete(b)}function xc(){for(ec=!1;0<fc.length;){var a=fc[0];if(null!==a.blockedOn)break;var b=vc(a.topLevelType,a.eventSystemFlags,a.nativeEvent);null!==b?a.blockedOn=b:fc.shift()}null!==gc&&uc(gc)&&(gc=null);null!==hc&&uc(hc)&&(hc=null);null!==ic&&uc(ic)&&(ic=null);jc.forEach(wc);kc.forEach(wc)}function yc(a,b){a.blockedOn===b&&(a.blockedOn=null,ec||(ec=!0,r.unstable_scheduleCallback(r.unstable_NormalPriority,xc)))}
	function zc(a){function b(b){return yc(b,a)}if(0<fc.length){yc(fc[0],a);for(var c=1;c<fc.length;c++){var d=fc[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==gc&&yc(gc,a);null!==hc&&yc(hc,a);null!==ic&&yc(ic,a);jc.forEach(b);kc.forEach(b)}var D=0,E=2,Ac=1024;function Bc(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,(b.effectTag&(E|Ac))!==D&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function Cc(a){if(Bc(a)!==a)throw t(Error(188));}
	function Dc(a){var b=a.alternate;if(!b){b=Bc(a);if(null===b)throw t(Error(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return Cc(e),a;if(f===d)return Cc(e),b;f=f.sibling}throw t(Error(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
	c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw t(Error(189));}}if(c.alternate!==d)throw t(Error(190));}if(3!==c.tag)throw t(Error(188));return c.stateNode.current===c?a:b}function Ec(a){a=Dc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
	function Fc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function Gc(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}function Hc(a,b,c){if(b=Ca(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=wa(c._dispatchListeners,b),c._dispatchInstances=wa(c._dispatchInstances,a)}
	function Ic(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Gc(b);for(b=c.length;0<b--;)Hc(c[b],"captured",a);for(b=0;b<c.length;b++)Hc(c[b],"bubbled",a)}}function Jc(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Ca(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=wa(c._dispatchListeners,b),c._dispatchInstances=wa(c._dispatchInstances,a))}function Kc(a){a&&a.dispatchConfig.registrationName&&Jc(a._targetInst,null,a)}
	function Lc(a){xa(a,Ic)}function Mc(){return!0}function Nc(){return!1}function F(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?Mc:Nc;this.isPropagationStopped=Nc;return this}
	n(F.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=Mc)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=Mc)},persist:function(){this.isPersistent=Mc},isPersistent:Nc,destructor:function(){var a=this.constructor.Interface,
	b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=Nc;this._dispatchInstances=this._dispatchListeners=null}});F.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
	F.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;Oc(c);return c};Oc(F);function Pc(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
	function Qc(a){if(!(a instanceof this))throw t(Error(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function Oc(a){a.eventPool=[];a.getPooled=Pc;a.release=Qc}var Rc=F.extend({animationName:null,elapsedTime:null,pseudoElement:null}),Sc=F.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),Tc=F.extend({view:null,detail:null}),Uc=Tc.extend({relatedTarget:null});
	function Vc(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
	var Wc={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},Xc={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
	116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},Yc={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Zc(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Yc[a])?!!b[a]:!1}function $c(){return Zc}
	var ad=Tc.extend({key:function(a){if(a.key){var b=Wc[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=Vc(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?Xc[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:$c,charCode:function(a){return"keypress"===a.type?Vc(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===
	a.type?Vc(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),bd=0,cd=0,dd=!1,fd=!1,gd=Tc.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:$c,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=bd;bd=a.screenX;return dd?"mousemove"===a.type?a.screenX-
	b:0:(dd=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;var b=cd;cd=a.screenY;return fd?"mousemove"===a.type?a.screenY-b:0:(fd=!0,0)}}),hd=gd.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),id=gd.extend({dataTransfer:null}),jd=Tc.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:$c}),kd=F.extend({propertyName:null,
	elapsedTime:null,pseudoElement:null}),ld=gd.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),md=[["blur","blur",0],["cancel","cancel",0],["click","click",0],["close","close",0],["contextmenu","contextMenu",0],["copy","copy",0],["cut","cut",0],["auxclick","auxClick",0],["dblclick","doubleClick",0],["dragend","dragEnd",
	0],["dragstart","dragStart",0],["drop","drop",0],["focus","focus",0],["input","input",0],["invalid","invalid",0],["keydown","keyDown",0],["keypress","keyPress",0],["keyup","keyUp",0],["mousedown","mouseDown",0],["mouseup","mouseUp",0],["paste","paste",0],["pause","pause",0],["play","play",0],["pointercancel","pointerCancel",0],["pointerdown","pointerDown",0],["pointerup","pointerUp",0],["ratechange","rateChange",0],["reset","reset",0],["seeked","seeked",0],["submit","submit",0],["touchcancel","touchCancel",
	0],["touchend","touchEnd",0],["touchstart","touchStart",0],["volumechange","volumeChange",0],["drag","drag",1],["dragenter","dragEnter",1],["dragexit","dragExit",1],["dragleave","dragLeave",1],["dragover","dragOver",1],["mousemove","mouseMove",1],["mouseout","mouseOut",1],["mouseover","mouseOver",1],["pointermove","pointerMove",1],["pointerout","pointerOut",1],["pointerover","pointerOver",1],["scroll","scroll",1],["toggle","toggle",1],["touchmove","touchMove",1],["wheel","wheel",1],["abort","abort",
	2],[Zb,"animationEnd",2],[$b,"animationIteration",2],[ac,"animationStart",2],["canplay","canPlay",2],["canplaythrough","canPlayThrough",2],["durationchange","durationChange",2],["emptied","emptied",2],["encrypted","encrypted",2],["ended","ended",2],["error","error",2],["gotpointercapture","gotPointerCapture",2],["load","load",2],["loadeddata","loadedData",2],["loadedmetadata","loadedMetadata",2],["loadstart","loadStart",2],["lostpointercapture","lostPointerCapture",2],["playing","playing",2],["progress",
	"progress",2],["seeking","seeking",2],["stalled","stalled",2],["suspend","suspend",2],["timeupdate","timeUpdate",2],[bc,"transitionEnd",2],["waiting","waiting",2]],nd={},od={},pd=0;for(;pd<md.length;pd++){var qd=md[pd],rd=qd[0],sd=qd[1],td=qd[2],ud="on"+(sd[0].toUpperCase()+sd.slice(1)),vd={phasedRegistrationNames:{bubbled:ud,captured:ud+"Capture"},dependencies:[rd],eventPriority:td};nd[sd]=vd;od[rd]=vd}
	var wd={eventTypes:nd,getEventPriority:function(a){a=od[a];return void 0!==a?a.eventPriority:2},extractEvents:function(a,b,c,d,e){b=od[a];if(!b)return null;switch(a){case "keypress":if(0===Vc(d))return null;case "keydown":case "keyup":a=ad;break;case "blur":case "focus":a=Uc;break;case "click":if(2===d.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=gd;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=
	id;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=jd;break;case Zb:case $b:case ac:a=Rc;break;case bc:a=kd;break;case "scroll":a=Tc;break;case "wheel":a=ld;break;case "copy":case "cut":case "paste":a=Sc;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=hd;break;default:a=F}c=a.getPooled(b,c,d,e);Lc(c);return c}},xd=wd.getEventPriority,zd=10,Ad=[];
	function Bd(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d=c;if(3===d.tag)d=d.stateNode.containerInfo;else{for(;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo}if(!d)break;var e=c.tag;5!==e&&6!==e||a.ancestors.push(c);c=Cd(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var f=Fc(a.nativeEvent);d=a.topLevelType;e=a.eventSystemFlags;for(var g=a.nativeEvent,h=null,k=0;k<ea.length;k++){var l=ea[k];l&&(l=l.extractEvents(d,e,b,g,f))&&(h=wa(h,l))}Aa(h)}}
	var Dd=!0;function G(a,b){Ed(b,a,!1)}function Ed(a,b,c){switch(xd(b)){case 0:var d=Fd.bind(null,b,1);break;case 1:d=Gd.bind(null,b,1);break;default:d=Hd.bind(null,b,1)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function Fd(a,b,c){hb||fb();var d=Hd,e=hb;hb=!0;try{eb(d,a,b,c)}finally{(hb=e)||jb()}}function Gd(a,b,c){Hd(a,b,c)}
	function Id(a,b,c,d){if(Ad.length){var e=Ad.pop();e.topLevelType=a;e.eventSystemFlags=b;e.nativeEvent=c;e.targetInst=d;a=e}else a={topLevelType:a,eventSystemFlags:b,nativeEvent:c,targetInst:d,ancestors:[]};try{if(b=Bd,c=a,ib)b(c,void 0);else{ib=!0;try{gb(b,c,void 0)}finally{ib=!1,jb()}}}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,Ad.length<zd&&Ad.push(a)}}
	function Hd(a,b,c){if(Dd)if(0<fc.length&&-1<lc.indexOf(a))a=qc(null,a,b,c),fc.push(a);else{var d=vc(a,b,c);null===d?rc(a,c):-1<lc.indexOf(a)?(a=qc(d,a,b,c),fc.push(a)):tc(d,a,b,c)||(rc(a,c),Id(a,b,c,null))}}
	function vc(a,b,c){var d=Fc(c),e=Cd(d);if(null!==e)if(d=Bc(e),null===d)e=null;else{var f=d.tag;if(13===f){a:{if(13===d.tag&&(e=d.memoizedState,null===e&&(d=d.alternate,null!==d&&(e=d.memoizedState)),null!==e)){d=e.dehydrated;break a}d=null}if(null!==d)return d;e=null}else if(3===f){if(d.stateNode.hydrate)return 3===d.tag?d.stateNode.containerInfo:null;e=null}else d!==e&&(e=null)}Id(a,b,c,e);return null}
	function Jd(a){if(!Xa)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}var Kd=new ("function"===typeof WeakMap?WeakMap:Map);function oc(a){var b=Kd.get(a);void 0===b&&(b=new Set,Kd.set(a,b));return b}
	function pc(a,b,c){if(!c.has(a)){switch(a){case "scroll":Ed(b,"scroll",!0);break;case "focus":case "blur":Ed(b,"focus",!0);Ed(b,"blur",!0);c.add("blur");c.add("focus");break;case "cancel":case "close":Jd(a)&&Ed(b,a,!0);break;case "invalid":case "submit":case "reset":break;default:-1===dc.indexOf(a)&&G(a,b)}c.add(a)}}
	var Ld={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
	floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},Md=["Webkit","ms","Moz","O"];Object.keys(Ld).forEach(function(a){Md.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);Ld[b]=Ld[a]})});function Nd(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||Ld.hasOwnProperty(a)&&Ld[a]?(""+b).trim():b+"px"}
	function Od(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=Nd(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var Pd=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
	function Qd(a,b){if(b){if(Pd[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw t(Error(137),a,"");if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw t(Error(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw t(Error(61));}if(null!=b.style&&"object"!==typeof b.style)throw t(Error(62),"");}}
	function Rd(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}function Sd(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=oc(a);b=ja[b];for(var d=0;d<b.length;d++)pc(b[d],a,c)}function Td(){}
	function Ud(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function Vd(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function Wd(a,b){var c=Vd(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Vd(c)}}
	function Xd(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?Xd(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}function Yd(){for(var a=window,b=Ud();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=Ud(a.document)}return b}
	function Zd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}var $d="$",ae="/$",be="$?",ce="$!",de=null,ee=null;function fe(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
	function ge(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var he="function"===typeof setTimeout?setTimeout:void 0,ie="function"===typeof clearTimeout?clearTimeout:void 0;function je(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}
	function ke(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if(c===$d||c===ce||c===be){if(0===b)return a;b--}else c===ae&&b++}a=a.previousSibling}return null}var le=Math.random().toString(36).slice(2),me="__reactInternalInstance$"+le,ne="__reactEventHandlers$"+le,oe="__reactContainere$"+le;
	function Cd(a){var b=a[me];if(b)return b;for(var c=a.parentNode;c;){if(b=c[oe]||c[me]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=ke(a);null!==a;){if(c=a[me])return c;a=ke(a)}return b}a=c;c=a.parentNode}return null}function pe(a){a=a[me]||a[oe];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function qe(a){if(5===a.tag||6===a.tag)return a.stateNode;throw t(Error(33));}function re(a){return a[ne]||null}var se=null,te=null,ue=null;
	function ve(){if(ue)return ue;var a,b=te,c=b.length,d,e="value"in se?se.value:se.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return ue=e.slice(a,1<d?1-d:void 0)}var we=F.extend({data:null}),xe=F.extend({data:null}),ye=[9,13,27,32],ze=Xa&&"CompositionEvent"in window,Ae=null;Xa&&"documentMode"in document&&(Ae=document.documentMode);
	var Be=Xa&&"TextEvent"in window&&!Ae,Ce=Xa&&(!ze||Ae&&8<Ae&&11>=Ae),De=String.fromCharCode(32),Ee={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
	captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},Fe=!1;
	function Ge(a,b){switch(a){case "keyup":return-1!==ye.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function He(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var Ie=!1;function Je(a,b){switch(a){case "compositionend":return He(b);case "keypress":if(32!==b.which)return null;Fe=!0;return De;case "textInput":return a=b.data,a===De&&Fe?null:a;default:return null}}
	function Ke(a,b){if(Ie)return"compositionend"===a||!ze&&Ge(a,b)?(a=ve(),ue=te=se=null,Ie=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return Ce&&"ko"!==b.locale?null:b.data;default:return null}}
	var Le={eventTypes:Ee,extractEvents:function(a,b,c,d,e){var f;if(ze)b:{switch(a){case "compositionstart":var g=Ee.compositionStart;break b;case "compositionend":g=Ee.compositionEnd;break b;case "compositionupdate":g=Ee.compositionUpdate;break b}g=void 0}else Ie?Ge(a,d)&&(g=Ee.compositionEnd):"keydown"===a&&229===d.keyCode&&(g=Ee.compositionStart);g?(Ce&&"ko"!==d.locale&&(Ie||g!==Ee.compositionStart?g===Ee.compositionEnd&&Ie&&(f=ve()):(se=e,te="value"in se?se.value:se.textContent,Ie=!0)),b=we.getPooled(g,
	c,d,e),f?b.data=f:(f=He(d),null!==f&&(b.data=f)),Lc(b),f=b):f=null;(a=Be?Je(a,d):Ke(a,d))?(c=xe.getPooled(Ee.beforeInput,c,d,e),c.data=a,Lc(c)):c=null;return null===f?c:null===c?f:[f,c]}},Me={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function Ne(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!Me[a.type]:"textarea"===b?!0:!1}
	var Oe={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function Pe(a,b,c){a=F.getPooled(Oe.change,a,b,c);a.type="change";bb(c);Lc(a);return a}var Qe=null,Re=null;function Se(a){Aa(a)}function Te(a){var b=qe(a);if(zb(b))return a}function Ue(a,b){if("change"===a)return b}var Ve=!1;Xa&&(Ve=Jd("input")&&(!document.documentMode||9<document.documentMode));
	function We(){Qe&&(Qe.detachEvent("onpropertychange",Xe),Re=Qe=null)}function Xe(a){if("value"===a.propertyName&&Te(Re))if(a=Pe(Re,a,Fc(a)),hb)Aa(a);else{hb=!0;try{db(Se,a)}finally{hb=!1,jb()}}}function Ye(a,b,c){"focus"===a?(We(),Qe=b,Re=c,Qe.attachEvent("onpropertychange",Xe)):"blur"===a&&We()}function Ze(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return Te(Re)}function $e(a,b){if("click"===a)return Te(b)}function af(a,b){if("input"===a||"change"===a)return Te(b)}
	var bf={eventTypes:Oe,_isInputEventSupported:Ve,extractEvents:function(a,b,c,d,e){b=c?qe(c):window;var f=b.nodeName&&b.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===b.type)var g=Ue;else if(Ne(b))if(Ve)g=af;else{g=Ze;var h=Ye}else(f=b.nodeName)&&"input"===f.toLowerCase()&&("checkbox"===b.type||"radio"===b.type)&&(g=$e);if(g&&(g=g(a,c)))return Pe(g,d,e);h&&h(a,b,c);"blur"===a&&(a=b._wrapperState)&&a.controlled&&"number"===b.type&&Eb(b,"number",b.value)}},cf={mouseEnter:{registrationName:"onMouseEnter",
	dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",dependencies:["pointerout","pointerover"]}},df={eventTypes:cf,extractEvents:function(a,b,c,d,e){var f="mouseover"===a||"pointerover"===a,g="mouseout"===a||"pointerout"===a;if(f&&0===(b&32)&&(d.relatedTarget||d.fromElement)||!g&&!f)return null;
	b=e.window===e?e:(b=e.ownerDocument)?b.defaultView||b.parentWindow:window;if(g){if(g=c,c=(c=d.relatedTarget||d.toElement)?Cd(c):null,null!==c&&(f=Bc(c),c!==f||5!==c.tag&&6!==c.tag))c=null}else g=null;if(g===c)return null;if("mouseout"===a||"mouseover"===a){var h=gd;var k=cf.mouseLeave;var l=cf.mouseEnter;var m="mouse"}else if("pointerout"===a||"pointerover"===a)h=hd,k=cf.pointerLeave,l=cf.pointerEnter,m="pointer";a=null==g?b:qe(g);b=null==c?b:qe(c);k=h.getPooled(k,g,d,e);k.type=m+"leave";k.target=
	a;k.relatedTarget=b;d=h.getPooled(l,c,d,e);d.type=m+"enter";d.target=b;d.relatedTarget=a;e=g;m=c;if(e&&m)a:{h=e;l=m;a=0;for(g=h;g;g=Gc(g))a++;g=0;for(c=l;c;c=Gc(c))g++;for(;0<a-g;)h=Gc(h),a--;for(;0<g-a;)l=Gc(l),g--;for(;a--;){if(h===l||h===l.alternate)break a;h=Gc(h);l=Gc(l)}h=null}else h=null;l=h;for(h=[];e&&e!==l;){a=e.alternate;if(null!==a&&a===l)break;h.push(e);e=Gc(e)}for(e=[];m&&m!==l;){a=m.alternate;if(null!==a&&a===l)break;e.push(m);m=Gc(m)}for(m=0;m<h.length;m++)Jc(h[m],"bubbled",k);for(m=
	e.length;0<m--;)Jc(e[m],"captured",d);return[k,d]}};function ef(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var ff="function"===typeof Object.is?Object.is:ef,gf=Object.prototype.hasOwnProperty;function hf(a,b){if(ff(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!gf.call(b,c[d])||!ff(a[c[d]],b[c[d]]))return!1;return!0}
	var jf=Xa&&"documentMode"in document&&11>=document.documentMode,kf={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},lf=null,mf=null,nf=null,of=!1;
	function pf(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(of||null==lf||lf!==Ud(c))return null;c=lf;"selectionStart"in c&&Zd(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return nf&&hf(nf,c)?null:(nf=c,a=F.getPooled(kf.select,mf,a,b),a.type="select",a.target=lf,Lc(a),a)}
	var qf={eventTypes:kf,extractEvents:function(a,b,c,d,e){b=e.window===e?e.document:9===e.nodeType?e:e.ownerDocument;var f;if(!(f=!b)){a:{b=oc(b);f=ja.onSelect;for(var g=0;g<f.length;g++)if(!b.has(f[g])){b=!1;break a}b=!0}f=!b}if(f)return null;b=c?qe(c):window;switch(a){case "focus":if(Ne(b)||"true"===b.contentEditable)lf=b,mf=c,nf=null;break;case "blur":nf=mf=lf=null;break;case "mousedown":of=!0;break;case "contextmenu":case "mouseup":case "dragend":return of=!1,pf(d,e);case "selectionchange":if(jf)break;
	case "keydown":case "keyup":return pf(d,e)}return null}};Ba.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));sa=re;ta=pe;ua=qe;Ba.injectEventPluginsByName({SimpleEventPlugin:wd,EnterLeaveEventPlugin:df,ChangeEventPlugin:bf,SelectEventPlugin:qf,BeforeInputEventPlugin:Le});new Set;var rf=[],sf=-1;function H(a){0>sf||(a.current=rf[sf],rf[sf]=null,sf--)}
	function I(a,b){sf++;rf[sf]=a.current;a.current=b}var tf={},J={current:tf},K={current:!1},uf=tf;function vf(a,b){var c=a.type.contextTypes;if(!c)return tf;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function N(a){a=a.childContextTypes;return null!==a&&void 0!==a}
	function wf(a){H(K,a);H(J,a)}function xf(a){H(K,a);H(J,a)}function zf(a,b,c){if(J.current!==tf)throw t(Error(168));I(J,b,a);I(K,c,a)}function Af(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw t(Error(108),Va(b)||"Unknown",e);return n({},c,{},d)}function Bf(a){var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||tf;uf=J.current;I(J,b,a);I(K,K.current,a);return!0}
	function Cf(a,b,c){var d=a.stateNode;if(!d)throw t(Error(169));c?(b=Af(a,b,uf),d.__reactInternalMemoizedMergedChildContext=b,H(K,a),H(J,a),I(J,b,a)):H(K,a);I(K,c,a)}
	var Df=r.unstable_runWithPriority,Ef=r.unstable_scheduleCallback,Ff=r.unstable_cancelCallback,Gf=r.unstable_shouldYield,Hf=r.unstable_requestPaint,If=r.unstable_now,Jf=r.unstable_getCurrentPriorityLevel,Kf=r.unstable_ImmediatePriority,Lf=r.unstable_UserBlockingPriority,Mf=r.unstable_NormalPriority,Nf=r.unstable_LowPriority,Of=r.unstable_IdlePriority,Pf={},Qf=void 0!==Hf?Hf:function(){},Rf=null,Sf=null,Tf=!1,Uf=If(),Vf=1E4>Uf?If:function(){return If()-Uf};
	function Wf(){switch(Jf()){case Kf:return 99;case Lf:return 98;case Mf:return 97;case Nf:return 96;case Of:return 95;default:throw t(Error(332));}}function Xf(a){switch(a){case 99:return Kf;case 98:return Lf;case 97:return Mf;case 96:return Nf;case 95:return Of;default:throw t(Error(332));}}function Yf(a,b){a=Xf(a);return Df(a,b)}function Zf(a,b,c){a=Xf(a);return Ef(a,b,c)}function $f(a){null===Rf?(Rf=[a],Sf=Ef(Kf,ag)):Rf.push(a);return Pf}function bg(){if(null!==Sf){var a=Sf;Sf=null;Ff(a)}ag()}
	function ag(){if(!Tf&&null!==Rf){Tf=!0;var a=0;try{var b=Rf;Yf(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Rf=null}catch(c){throw null!==Rf&&(Rf=Rf.slice(a+1)),Ef(Kf,bg),c;}finally{Tf=!1}}}function cg(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var dg={current:null},eg=null,fg=null,gg=null;function hg(){gg=fg=eg=null}function ig(a,b){var c=a.type._context;I(dg,c._currentValue,a);c._currentValue=b}
	function jg(a){var b=dg.current;H(dg,a);a.type._context._currentValue=b}function kg(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}function lg(a,b){eg=a;gg=fg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(mg=!0),a.firstContext=null)}
	function ng(a,b){if(gg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)gg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===fg){if(null===eg)throw t(Error(308));fg=b;eg.dependencies={expirationTime:0,firstContext:b,responders:null}}else fg=fg.next=b}return a._currentValue}var og=!1;
	function pg(a){return{baseState:a,firstUpdate:null,lastUpdate:null,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}function qg(a){return{baseState:a.baseState,firstUpdate:a.firstUpdate,lastUpdate:a.lastUpdate,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}
	function rg(a,b){return{expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null,nextEffect:null}}function sg(a,b){null===a.lastUpdate?a.firstUpdate=a.lastUpdate=b:(a.lastUpdate.next=b,a.lastUpdate=b)}
	function tg(a,b){var c=a.alternate;if(null===c){var d=a.updateQueue;var e=null;null===d&&(d=a.updateQueue=pg(a.memoizedState))}else d=a.updateQueue,e=c.updateQueue,null===d?null===e?(d=a.updateQueue=pg(a.memoizedState),e=c.updateQueue=pg(c.memoizedState)):d=a.updateQueue=qg(e):null===e&&(e=c.updateQueue=qg(d));null===e||d===e?sg(d,b):null===d.lastUpdate||null===e.lastUpdate?(sg(d,b),sg(e,b)):(sg(d,b),e.lastUpdate=b)}
	function ug(a,b){var c=a.updateQueue;c=null===c?a.updateQueue=pg(a.memoizedState):vg(a,c);null===c.lastCapturedUpdate?c.firstCapturedUpdate=c.lastCapturedUpdate=b:(c.lastCapturedUpdate.next=b,c.lastCapturedUpdate=b)}function vg(a,b){var c=a.alternate;null!==c&&b===c.updateQueue&&(b=a.updateQueue=qg(b));return b}
	function wg(a,b,c,d,e,f){switch(c.tag){case 1:return a=c.payload,"function"===typeof a?a.call(f,d,e):a;case 3:a.effectTag=a.effectTag&-4097|64;case 0:a=c.payload;e="function"===typeof a?a.call(f,d,e):a;if(null===e||void 0===e)break;return n({},d,e);case 2:og=!0}return d}
	function xg(a,b,c,d,e){og=!1;b=vg(a,b);for(var f=b.baseState,g=null,h=0,k=b.firstUpdate,l=f;null!==k;){var m=k.expirationTime;m<e?(null===g&&(g=k,f=l),h<m&&(h=m)):(yg(m,k.suspenseConfig),l=wg(a,b,k,l,c,d),null!==k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastEffect?b.firstEffect=b.lastEffect=k:(b.lastEffect.nextEffect=k,b.lastEffect=k)));k=k.next}m=null;for(k=b.firstCapturedUpdate;null!==k;){var A=k.expirationTime;A<e?(null===m&&(m=k,null===g&&(f=l)),h<A&&(h=A)):(l=wg(a,b,k,l,c,d),null!==
	k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastCapturedEffect?b.firstCapturedEffect=b.lastCapturedEffect=k:(b.lastCapturedEffect.nextEffect=k,b.lastCapturedEffect=k)));k=k.next}null===g&&(b.lastUpdate=null);null===m?b.lastCapturedUpdate=null:a.effectTag|=32;null===g&&null===m&&(f=l);b.baseState=f;b.firstUpdate=g;b.firstCapturedUpdate=m;zg(h);a.expirationTime=h;a.memoizedState=l}
	function Ag(a,b,c){null!==b.firstCapturedUpdate&&(null!==b.lastUpdate&&(b.lastUpdate.next=b.firstCapturedUpdate,b.lastUpdate=b.lastCapturedUpdate),b.firstCapturedUpdate=b.lastCapturedUpdate=null);Bg(b.firstEffect,c);b.firstEffect=b.lastEffect=null;Bg(b.firstCapturedEffect,c);b.firstCapturedEffect=b.lastCapturedEffect=null}function Bg(a,b){for(;null!==a;){var c=a.callback;if(null!==c){a.callback=null;var d=b;if("function"!==typeof c)throw t(Error(191),c);c.call(d)}a=a.nextEffect}}
	var Cg=Da.ReactCurrentBatchConfig,Dg=(new aa.Component).refs;function Eg(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;d=a.updateQueue;null!==d&&0===a.expirationTime&&(d.baseState=c)}
	var Ig={isMounted:function(a){return(a=a._reactInternalFiber)?Bc(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Fg(),e=Cg.suspense;d=Gg(d,a,e);e=rg(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);tg(a,e);Hg(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Fg(),e=Cg.suspense;d=Gg(d,a,e);e=rg(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);tg(a,e);Hg(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Fg(),d=Cg.suspense;
	c=Gg(c,a,d);d=rg(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);tg(a,d);Hg(a,c)}};function Jg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!hf(c,d)||!hf(e,f):!0}
	function Kg(a,b,c){var d=!1,e=tf;var f=b.contextType;"object"===typeof f&&null!==f?f=ng(f):(e=N(b)?uf:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?vf(a,e):tf);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Ig;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
	function Lg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Ig.enqueueReplaceState(b,b.state,null)}
	function Mg(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Dg;var f=b.contextType;"object"===typeof f&&null!==f?e.context=ng(f):(f=N(b)?uf:J.current,e.context=vf(a,f));f=a.updateQueue;null!==f&&(xg(a,f,c,e,d),e.state=a.memoizedState);f=b.getDerivedStateFromProps;"function"===typeof f&&(Eg(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==
	typeof e.componentWillMount||(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Ig.enqueueReplaceState(e,e.state,null),f=a.updateQueue,null!==f&&(xg(a,f,c,e,d),e.state=a.memoizedState));"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Ng=Array.isArray;
	function Og(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw t(Error(309));var d=c.stateNode}if(!d)throw t(Error(147),a);var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Dg&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw t(Error(284));if(!c._owner)throw t(Error(290),a);}return a}
	function Pg(a,b){if("textarea"!==a.type)throw t(Error(31),"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"");}
	function Qg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=Rg(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
	E,c):d;b.effectTag=E;return c}function g(b){a&&null===b.alternate&&(b.effectTag=E);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Sg(c,a.mode,d),b.return=a,b;b=e(b,c,d);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props,d),d.ref=Og(a,b,c),d.return=a,d;d=Tg(c.type,c.key,c.props,null,a.mode,d);d.ref=Og(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
	c.implementation)return b=Ug(c,a.mode,d),b.return=a,b;b=e(b,c.children||[],d);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Vg(c,a.mode,d,f),b.return=a,b;b=e(b,c,d);b.return=a;return b}function A(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Sg(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Fa:return c=Tg(b.type,b.key,b.props,null,a.mode,c),c.ref=Og(a,null,b),c.return=a,c;case Ga:return b=Ug(b,a.mode,c),b.return=a,b}if(Ng(b)||
	Ta(b))return b=Vg(b,a.mode,c,null),b.return=a,b;Pg(a,b)}return null}function w(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Fa:return c.key===e?c.type===Ha?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case Ga:return c.key===e?l(a,b,c,d):null}if(Ng(c)||Ta(c))return null!==e?null:m(a,b,c,d,null);Pg(a,c)}return null}function L(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
	a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Fa:return a=a.get(null===d.key?c:d.key)||null,d.type===Ha?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case Ga:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Ng(d)||Ta(d))return a=a.get(c)||null,m(b,a,d,e,null);Pg(b,d)}return null}function wb(e,g,h,k){for(var l=null,m=null,q=g,y=g=0,z=null;null!==q&&y<h.length;y++){q.index>y?(z=q,q=null):z=q.sibling;var p=w(e,q,h[y],k);if(null===p){null===q&&(q=z);break}a&&
	q&&null===p.alternate&&b(e,q);g=f(p,g,y);null===m?l=p:m.sibling=p;m=p;q=z}if(y===h.length)return c(e,q),l;if(null===q){for(;y<h.length;y++)q=A(e,h[y],k),null!==q&&(g=f(q,g,y),null===m?l=q:m.sibling=q,m=q);return l}for(q=d(e,q);y<h.length;y++)z=L(q,e,y,h[y],k),null!==z&&(a&&null!==z.alternate&&q.delete(null===z.key?y:z.key),g=f(z,g,y),null===m?l=z:m.sibling=z,m=z);a&&q.forEach(function(a){return b(e,a)});return l}function M(e,g,h,k){var l=Ta(h);if("function"!==typeof l)throw t(Error(150));h=l.call(h);
	if(null==h)throw t(Error(151));for(var m=l=null,q=g,y=g=0,z=null,p=h.next();null!==q&&!p.done;y++,p=h.next()){q.index>y?(z=q,q=null):z=q.sibling;var M=w(e,q,p.value,k);if(null===M){null===q&&(q=z);break}a&&q&&null===M.alternate&&b(e,q);g=f(M,g,y);null===m?l=M:m.sibling=M;m=M;q=z}if(p.done)return c(e,q),l;if(null===q){for(;!p.done;y++,p=h.next())p=A(e,p.value,k),null!==p&&(g=f(p,g,y),null===m?l=p:m.sibling=p,m=p);return l}for(q=d(e,q);!p.done;y++,p=h.next())p=L(q,e,y,p.value,k),null!==p&&(a&&null!==
	p.alternate&&q.delete(null===p.key?y:p.key),g=f(p,g,y),null===m?l=p:m.sibling=p,m=p);a&&q.forEach(function(a){return b(e,a)});return l}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===Ha&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Fa:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){if(7===k.tag?f.type===Ha:k.elementType===f.type){c(a,k.sibling);d=e(k,f.type===Ha?f.props.children:f.props,h);d.ref=Og(a,k,f);d.return=a;a=d;break a}c(a,
	k);break}else b(a,k);k=k.sibling}f.type===Ha?(d=Vg(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Tg(f.type,f.key,f.props,null,a.mode,h),h.ref=Og(a,d,f),h.return=a,a=h)}return g(a);case Ga:a:{for(k=f.key;null!==d;){if(d.key===k){if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d.return=a;a=d;break a}c(a,d);break}else b(a,d);d=d.sibling}d=Ug(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||
	"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h),d.return=a,a=d):(c(a,d),d=Sg(f,a.mode,h),d.return=a,a=d),g(a);if(Ng(f))return wb(a,d,f,h);if(Ta(f))return M(a,d,f,h);l&&Pg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,t(Error(152),a.displayName||a.name||"Component");}return c(a,d)}}var Wg=Qg(!0),Xg=Qg(!1),Yg={},Zg={current:Yg},$g={current:Yg},ah={current:Yg};function bh(a){if(a===Yg)throw t(Error(174));return a}
	function ch(a,b){I(ah,b,a);I($g,a,a);I(Zg,Yg,a);var c=b.nodeType;switch(c){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Qb(null,"");break;default:c=8===c?b.parentNode:b,b=c.namespaceURI||null,c=c.tagName,b=Qb(b,c)}H(Zg,a);I(Zg,b,a)}function dh(a){H(Zg,a);H($g,a);H(ah,a)}function eh(a){bh(ah.current);var b=bh(Zg.current);var c=Qb(b,a.type);b!==c&&(I($g,a,a),I(Zg,c,a))}function fh(a){$g.current===a&&(H(Zg,a),H($g,a))}var O={current:0};
	function gh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||c.data===be||c.data===ce))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if((b.effectTag&64)!==D)return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function hh(a,b){return{responder:a,props:b}}
	var ih=Da.ReactCurrentDispatcher,jh=0,kh=null,P=null,lh=null,mh=null,Q=null,nh=null,oh=0,ph=null,qh=0,rh=!1,sh=null,th=0;function uh(){throw t(Error(321));}function vh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!ff(a[c],b[c]))return!1;return!0}
	function wh(a,b,c,d,e,f){jh=f;kh=b;lh=null!==a?a.memoizedState:null;ih.current=null===lh?xh:yh;b=c(d,e);if(rh){do rh=!1,th+=1,lh=null!==a?a.memoizedState:null,nh=mh,ph=Q=P=null,ih.current=yh,b=c(d,e);while(rh);sh=null;th=0}ih.current=zh;a=kh;a.memoizedState=mh;a.expirationTime=oh;a.updateQueue=ph;a.effectTag|=qh;a=null!==P&&null!==P.next;jh=0;nh=Q=mh=lh=P=kh=null;oh=0;ph=null;qh=0;if(a)throw t(Error(300));return b}
	function Ah(){ih.current=zh;jh=0;nh=Q=mh=lh=P=kh=null;oh=0;ph=null;qh=0;rh=!1;sh=null;th=0}function Eh(){var a={memoizedState:null,baseState:null,queue:null,baseUpdate:null,next:null};null===Q?mh=Q=a:Q=Q.next=a;return Q}function Fh(){if(null!==nh)Q=nh,nh=Q.next,P=lh,lh=null!==P?P.next:null;else{if(null===lh)throw t(Error(310));P=lh;var a={memoizedState:P.memoizedState,baseState:P.baseState,queue:P.queue,baseUpdate:P.baseUpdate,next:null};Q=null===Q?mh=a:Q.next=a;lh=P.next}return Q}
	function Gh(a,b){return"function"===typeof b?b(a):b}
	function Hh(a){var b=Fh(),c=b.queue;if(null===c)throw t(Error(311));c.lastRenderedReducer=a;if(0<th){var d=c.dispatch;if(null!==sh){var e=sh.get(c);if(void 0!==e){sh.delete(c);var f=b.memoizedState;do f=a(f,e.action),e=e.next;while(null!==e);ff(f,b.memoizedState)||(mg=!0);b.memoizedState=f;b.baseUpdate===c.last&&(b.baseState=f);c.lastRenderedState=f;return[f,d]}}return[b.memoizedState,d]}d=c.last;var g=b.baseUpdate;f=b.baseState;null!==g?(null!==d&&(d.next=null),d=g.next):d=null!==d?d.next:null;if(null!==
	d){var h=e=null,k=d,l=!1;do{var m=k.expirationTime;m<jh?(l||(l=!0,h=g,e=f),m>oh&&(oh=m,zg(oh))):(yg(m,k.suspenseConfig),f=k.eagerReducer===a?k.eagerState:a(f,k.action));g=k;k=k.next}while(null!==k&&k!==d);l||(h=g,e=f);ff(f,b.memoizedState)||(mg=!0);b.memoizedState=f;b.baseUpdate=h;b.baseState=e;c.lastRenderedState=f}return[b.memoizedState,c.dispatch]}
	function Ih(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};null===ph?(ph={lastEffect:null},ph.lastEffect=a.next=a):(b=ph.lastEffect,null===b?ph.lastEffect=a.next=a:(c=b.next,b.next=a,a.next=c,ph.lastEffect=a));return a}function Jh(a,b,c,d){var e=Eh();qh|=a;e.memoizedState=Ih(b,c,void 0,void 0===d?null:d)}
	function Kh(a,b,c,d){var e=Fh();d=void 0===d?null:d;var f=void 0;if(null!==P){var g=P.memoizedState;f=g.destroy;if(null!==d&&vh(d,g.deps)){Ih(0,c,f,d);return}}qh|=a;e.memoizedState=Ih(b,c,f,d)}function Lh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function Mh(){}
	function Nh(a,b,c){if(!(25>th))throw t(Error(301));var d=a.alternate;if(a===kh||null!==d&&d===kh)if(rh=!0,a={expirationTime:jh,suspenseConfig:null,action:c,eagerReducer:null,eagerState:null,next:null},null===sh&&(sh=new Map),c=sh.get(b),void 0===c)sh.set(b,a);else{for(b=c;null!==b.next;)b=b.next;b.next=a}else{var e=Fg(),f=Cg.suspense;e=Gg(e,a,f);f={expirationTime:e,suspenseConfig:f,action:c,eagerReducer:null,eagerState:null,next:null};var g=b.last;if(null===g)f.next=f;else{var h=g.next;null!==h&&
	(f.next=h);g.next=f}b.last=f;if(0===a.expirationTime&&(null===d||0===d.expirationTime)&&(d=b.lastRenderedReducer,null!==d))try{var k=b.lastRenderedState,l=d(k,c);f.eagerReducer=d;f.eagerState=l;if(ff(l,k))return}catch(m){}finally{}Hg(a,e)}}
	var zh={readContext:ng,useCallback:uh,useContext:uh,useEffect:uh,useImperativeHandle:uh,useLayoutEffect:uh,useMemo:uh,useReducer:uh,useRef:uh,useState:uh,useDebugValue:uh,useResponder:uh},xh={readContext:ng,useCallback:function(a,b){Eh().memoizedState=[a,void 0===b?null:b];return a},useContext:ng,useEffect:function(a,b){return Jh(516,192,a,b)},useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Jh(4,36,Lh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Jh(4,
	36,a,b)},useMemo:function(a,b){var c=Eh();b=void 0===b?null:b;a=a();c.memoizedState=[a,b];return a},useReducer:function(a,b,c){var d=Eh();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={last:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=Nh.bind(null,kh,a);return[d.memoizedState,a]},useRef:function(a){var b=Eh();a={current:a};return b.memoizedState=a},useState:function(a){var b=Eh();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={last:null,
	dispatch:null,lastRenderedReducer:Gh,lastRenderedState:a};a=a.dispatch=Nh.bind(null,kh,a);return[b.memoizedState,a]},useDebugValue:Mh,useResponder:hh},yh={readContext:ng,useCallback:function(a,b){var c=Fh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&vh(b,d[1]))return d[0];c.memoizedState=[a,b];return a},useContext:ng,useEffect:function(a,b){return Kh(516,192,a,b)},useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Kh(4,36,Lh.bind(null,b,a),c)},
	useLayoutEffect:function(a,b){return Kh(4,36,a,b)},useMemo:function(a,b){var c=Fh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&vh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a},useReducer:Hh,useRef:function(){return Fh().memoizedState},useState:function(a){return Hh(Gh,a)},useDebugValue:Mh,useResponder:hh},Oh=null,Ph=null,Qh=!1;
	function Rh(a,b){var c=Sh(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function Th(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
	function Uh(a){if(Qh){var b=Ph;if(b){var c=b;if(!Th(a,b)){b=je(c.nextSibling);if(!b||!Th(a,b)){a.effectTag=a.effectTag&~Ac|E;Qh=!1;Oh=a;return}Rh(Oh,c)}Oh=a;Ph=je(b.firstChild)}else a.effectTag=a.effectTag&~Ac|E,Qh=!1,Oh=a}}function Vh(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;Oh=a}
	function Wh(a){if(a!==Oh)return!1;if(!Qh)return Vh(a),Qh=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!ge(b,a.memoizedProps))for(b=Ph;b;)Rh(a,b),b=je(b.nextSibling);Vh(a);if(13===a.tag)if(a=a.memoizedState,a=null!==a?a.dehydrated:null,null===a)a=Ph;else a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if(c===ae){if(0===b){a=je(a.nextSibling);break a}b--}else c!==$d&&c!==ce&&c!==be||b++}a=a.nextSibling}a=null}else a=Oh?je(a.stateNode.nextSibling):null;Ph=a;return!0}
	function Xh(){Ph=Oh=null;Qh=!1}var Yh=Da.ReactCurrentOwner,mg=!1;function R(a,b,c,d){b.child=null===a?Xg(b,null,c,d):Wg(b,a.child,c,d)}function Zh(a,b,c,d,e){c=c.render;var f=b.ref;lg(b,e);d=wh(a,b,c,d,f,e);if(null!==a&&!mg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
	function ai(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!bi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ci(a,b,g,d,e,f);a=Tg(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:hf,c(e,d)&&a.ref===b.ref))return $h(a,b,f);b.effectTag|=1;a=Rg(g,d,f);a.ref=b.ref;a.return=b;return b.child=a}
	function ci(a,b,c,d,e,f){return null!==a&&hf(a.memoizedProps,d)&&a.ref===b.ref&&(mg=!1,e<f)?$h(a,b,f):di(a,b,c,d,f)}function ei(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function di(a,b,c,d,e){var f=N(c)?uf:J.current;f=vf(b,f);lg(b,e);c=wh(a,b,c,d,f,e);if(null!==a&&!mg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
	function fi(a,b,c,d,e){if(N(c)){var f=!0;Bf(b)}else f=!1;lg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=E),Kg(b,c,d,e),Mg(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=ng(l):(l=N(c)?uf:J.current,l=vf(b,l));var m=c.getDerivedStateFromProps,A="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;A||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
	"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Lg(b,g,d,l);og=!1;var w=b.memoizedState;k=g.state=w;var L=b.updateQueue;null!==L&&(xg(b,L,d,g,e),k=b.memoizedState);h!==d||w!==k||K.current||og?("function"===typeof m&&(Eg(b,c,m,d),k=b.memoizedState),(h=og||Jg(b,c,h,d,w,k,l))?(A||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&
	g.UNSAFE_componentWillMount()),"function"===typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,h=b.memoizedProps,g.props=b.type===b.elementType?h:cg(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=ng(l):(l=N(c)?uf:J.current,l=vf(b,l)),m=c.getDerivedStateFromProps,(A=
	"function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Lg(b,g,d,l),og=!1,k=b.memoizedState,w=g.state=k,L=b.updateQueue,null!==L&&(xg(b,L,d,g,e),w=b.memoizedState),h!==d||k!==w||K.current||og?("function"===typeof m&&(Eg(b,c,m,d),w=b.memoizedState),(m=og||Jg(b,c,h,d,k,w,l))?(A||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||
	("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,w,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,w,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=
	d,b.memoizedState=w),g.props=d,g.state=w,g.context=l,d=m):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return gi(a,b,c,d,f,e)}
	function gi(a,b,c,d,e,f){ei(a,b);var g=(b.effectTag&64)!==D;if(!d&&!g)return e&&Cf(b,c,!1),$h(a,b,f);d=b.stateNode;Yh.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Wg(b,a.child,null,f),b.child=Wg(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Cf(b,c,!0);return b.child}function hi(a){var b=a.stateNode;b.pendingContext?zf(a,b.pendingContext,b.pendingContext!==b.context):b.context&&zf(a,b.context,!1);ch(a,b.containerInfo)}
	var ii={dehydrated:null,retryTime:1};
	function ji(a,b,c){var d=b.mode,e=b.pendingProps,f=O.current,g=!1,h;(h=(b.effectTag&64)!==D)||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);I(O,f&1,b);if(null===a){if(g){g=e.fallback;e=Vg(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Vg(g,d,c,null);c.return=b;e.sibling=c;b.memoizedState=
	ii;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=Xg(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=Rg(a,a.pendingProps,0);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=Rg(d,e,d.expirationTime);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=ii;b.child=c;return d}c=Wg(b,a.child,e.children,c);b.memoizedState=null;return b.child=c}a=a.child;
	if(g){g=e.fallback;e=Vg(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Vg(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=E;e.childExpirationTime=0;b.memoizedState=ii;b.child=e;return c}b.memoizedState=null;return b.child=Wg(b,a,e.children,c)}
	function ki(a,b,c,d,e){var f=a.memoizedState;null===f?a.memoizedState={isBackwards:b,rendering:null,last:d,tail:c,tailExpiration:0,tailMode:e}:(f.isBackwards=b,f.rendering=null,f.last=d,f.tail=c,f.tailExpiration=0,f.tailMode=e)}
	function li(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=O.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&(a.effectTag&64)!==D)a:for(a=b.child;null!==a;){if(13===a.tag){if(null!==a.memoizedState){a.expirationTime<c&&(a.expirationTime=c);var g=a.alternate;null!==g&&g.expirationTime<c&&(g.expirationTime=c);kg(a.return,c)}}else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;
	a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(O,d,b);if(0===(b.mode&2))b.memoizedState=null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)d=c.alternate,null!==d&&null===gh(d)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);ki(b,!1,e,c,f);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){d=e.alternate;if(null!==d&&null===gh(d)){b.child=e;break}d=e.sibling;e.sibling=c;c=e;e=d}ki(b,!0,c,null,f);break;case "together":ki(b,
	!1,null,null,void 0);break;default:b.memoizedState=null}return b.child}function $h(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&zg(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw t(Error(153));if(null!==b.child){a=b.child;c=Rg(a,a.pendingProps,a.expirationTime);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Rg(a,a.pendingProps,a.expirationTime),c.return=b;c.sibling=null}return b.child}
	function mi(a){a.effectTag|=4}var ni,oi,pi,qi;ni=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};oi=function(){};
	pi=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;bh(Zg.current);a=null;switch(c){case "input":f=Ab(g,f);d=Ab(g,d);a=[];break;case "option":f=Ib(g,f);d=Ib(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Kb(g,f);d=Kb(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=Td)}Qd(c,d);var h,k;c=null;for(h in f)if(!d.hasOwnProperty(h)&&f.hasOwnProperty(h)&&null!=f[h])if("style"===
	h)for(k in g=f[h],g)g.hasOwnProperty(k)&&(c||(c={}),c[k]="");else"dangerouslySetInnerHTML"!==h&&"children"!==h&&"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(ia.hasOwnProperty(h)?a||(a=[]):(a=a||[]).push(h,null));for(h in d){var l=d[h];g=null!=f?f[h]:void 0;if(d.hasOwnProperty(h)&&l!==g&&(null!=l||null!=g))if("style"===h)if(g){for(k in g)!g.hasOwnProperty(k)||l&&l.hasOwnProperty(k)||(c||(c={}),c[k]="");for(k in l)l.hasOwnProperty(k)&&g[k]!==l[k]&&(c||(c={}),
	c[k]=l[k])}else c||(a||(a=[]),a.push(h,c)),c=l;else"dangerouslySetInnerHTML"===h?(l=l?l.__html:void 0,g=g?g.__html:void 0,null!=l&&g!==l&&(a=a||[]).push(h,""+l)):"children"===h?g===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(h,""+l):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&(ia.hasOwnProperty(h)?(null!=l&&Sd(e,h),a||g===l||(a=[])):(a=a||[]).push(h,l))}c&&(a=a||[]).push("style",c);e=a;(b.updateQueue=e)&&mi(b)}};qi=function(a,b,c,d){c!==d&&mi(b)};
	function ri(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
	function si(a){switch(a.tag){case 1:N(a.type)&&wf(a);var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:dh(a);xf(a);b=a.effectTag;if((b&64)!==D)throw t(Error(285));a.effectTag=b&-4097|64;return a;case 5:return fh(a),null;case 13:return H(O,a),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return H(O,a),null;case 4:return dh(a),null;case 10:return jg(a),null;default:return null}}function ti(a,b){return{value:a,source:b,stack:Wa(b)}}
	var ui="function"===typeof WeakSet?WeakSet:Set;function vi(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=Wa(c));null!==c&&Va(c.type);b=b.value;null!==a&&1===a.tag&&Va(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function wi(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){xi(a,c)}}function yi(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){xi(a,c)}else b.current=null}
	function Di(a,b){switch(b.tag){case 0:case 11:case 15:Ei(2,0,b);break;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:cg(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}break;case 3:case 5:case 6:case 4:case 17:break;default:throw t(Error(163));}}
	function Ei(a,b,c){c=c.updateQueue;c=null!==c?c.lastEffect:null;if(null!==c){var d=c=c.next;do{if(0!==(d.tag&a)){var e=d.destroy;d.destroy=void 0;void 0!==e&&e()}0!==(d.tag&b)&&(e=d.create,d.destroy=e());d=d.next}while(d!==c)}}
	function Fi(a,b,c){"function"===typeof Gi&&Gi(b);switch(b.tag){case 0:case 11:case 14:case 15:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;Yf(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){xi(g,h)}}a=a.next}while(a!==d)})}break;case 1:yi(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&wi(b,c);break;case 5:yi(b);break;case 4:Hi(a,b,c)}}
	function Ii(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;null!==b&&Ii(b)}function Ji(a){return 5===a.tag||3===a.tag||4===a.tag}
	function Ki(a){a:{for(var b=a.return;null!==b;){if(Ji(b)){var c=b;break a}b=b.return}throw t(Error(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw t(Error(161));}c.effectTag&16&&(Tb(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Ji(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&E)continue b;
	if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&E)){c=c.stateNode;break a}}for(var e=a;;){var f=5===e.tag||6===e.tag;if(f){var g=f?e.stateNode:e.stateNode.instance;if(c)if(d){f=b;var h=g;g=c;8===f.nodeType?f.parentNode.insertBefore(h,g):f.insertBefore(h,g)}else b.insertBefore(g,c);else d?(h=b,8===h.nodeType?(f=h.parentNode,f.insertBefore(g,h)):(f=h,f.appendChild(g)),h=h._reactRootContainer,null!==h&&void 0!==h||null!==f.onclick||(f.onclick=Td)):b.appendChild(g)}else if(4!==
	e.tag&&null!==e.child){e.child.return=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e.return||e.return===a)return;e=e.return}e.sibling.return=e.return;e=e.sibling}}
	function Hi(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw t(Error(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var h=a,k=d,l=c,m=k;;)if(Fi(h,m,l),null!==m.child&&4!==m.tag)m.child.return=m,m=m.child;else{if(m===k)break;for(;null===m.sibling;){if(null===m.return||m.return===k)break a;m=m.return}m.sibling.return=m.return;m=m.sibling}g?(h=
	f,k=d.stateNode,8===h.nodeType?h.parentNode.removeChild(k):h.removeChild(k)):f.removeChild(d.stateNode)}else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Fi(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
	function Li(a,b){switch(b.tag){case 0:case 11:case 14:case 15:Ei(4,8,b);break;case 1:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[ne]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Cb(c,d);Rd(a,e);b=Rd(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?Od(c,h):"dangerouslySetInnerHTML"===g?Sb(c,h):"children"===g?Tb(c,h):ub(c,g,h,b)}switch(a){case "input":Db(c,d);break;case "textarea":Mb(c,
	d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?Jb(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?Jb(c,!!d.multiple,d.defaultValue,!0):Jb(c,!!d.multiple,d.multiple?[]:"",!1))}}}break;case 6:if(null===b.stateNode)throw t(Error(162));b.stateNode.nodeValue=b.memoizedProps;break;case 3:b=b.stateNode;b.hydrate&&(b.hydrate=!1,zc(b.containerInfo));break;case 12:break;case 13:c=b;null===b.memoizedState?d=!1:(d=!0,c=b.child,Mi=Vf());
	if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=Nd("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){f=a.child.sibling;f.return=a;a=f;continue}else if(null!==a.child){a.child.return=
	a;a=a.child;continue}if(a===c)break a;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}Ni(b);break;case 19:Ni(b);break;case 17:break;case 20:break;case 21:break;default:throw t(Error(163));}}function Ni(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new ui);b.forEach(function(b){var d=Oi.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}var Pi="function"===typeof WeakMap?WeakMap:Map;
	function Qi(a,b,c){c=rg(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Ri||(Ri=!0,Si=d);vi(a,b)};return c}
	function Ti(a,b,c){c=rg(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){vi(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===Ui?Ui=new Set([this]):Ui.add(this),vi(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
	var Vi=Math.ceil,Wi=Da.ReactCurrentDispatcher,Xi=Da.ReactCurrentOwner,S=0,Yi=8,Zi=16,$i=32,aj=0,bj=1,cj=2,dj=3,ej=4,fj=5,gj=6,T=S,U=null,V=null,W=0,X=aj,hj=null,ij=1073741823,jj=1073741823,kj=null,lj=0,mj=!1,Mi=0,nj=500,Y=null,Ri=!1,Si=null,Ui=null,oj=!1,pj=null,qj=90,rj=null,sj=0,tj=null,uj=0;function Fg(){return(T&(Zi|$i))!==S?1073741821-(Vf()/10|0):0!==uj?uj:uj=1073741821-(Vf()/10|0)}
	function Gg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=Wf();if(0===(b&4))return 99===d?1073741823:1073741822;if((T&Zi)!==S)return W;if(null!==c)a=1073741821-25*(((1073741821-a+(c.timeoutMs|0||5E3)/10)/25|0)+1);else switch(d){case 99:a=1073741823;break;case 98:a=1073741821-10*(((1073741821-a+15)/10|0)+1);break;case 97:case 96:a=1073741821-25*(((1073741821-a+500)/25|0)+1);break;case 95:a=2;break;default:throw t(Error(326));}null!==U&&a===W&&--a;return a}var vj=0;
	function Hg(a,b){if(50<sj)throw sj=0,tj=null,t(Error(185));a=wj(a,b);if(null!==a){var c=Wf();1073741823===b?(T&Yi)!==S&&(T&(Zi|$i))===S?xj(a):(Z(a),T===S&&bg()):Z(a);(T&4)===S||98!==c&&99!==c||(null===rj?rj=new Map([[a,b]]):(c=rj.get(a),(void 0===c||c>b)&&rj.set(a,b)))}}
	function wj(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(U===e&&(zg(b),X===ej&&yj(e,W)),zj(e,b));return e}
	function Aj(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Bj(a,b))return b;b=a.lastPingedTime;a=a.nextKnownPendingLevel;return b>a?b:a}
	function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=$f(xj.bind(null,a));else{var b=Aj(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Fg();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Pf&&Ff(c)}a.callbackExpirationTime=
	b;a.callbackPriority=d;b=1073741823===b?$f(xj.bind(null,a)):Zf(d,Cj.bind(null,a),{timeout:10*(1073741821-b)-Vf()});a.callbackNode=b}}}
	function Cj(a,b){uj=0;if(b)return b=Fg(),Dj(a,b),Z(a),null;var c=Aj(a);if(0!==c){b=a.callbackNode;if((T&(Zi|$i))!==S)throw t(Error(327));Ej();a===U&&c===W||Fj(a,c);if(null!==V){var d=T;T|=Zi;var e=Gj(a);do try{Hj();break}catch(h){Ij(a,h)}while(1);hg();T=d;Wi.current=e;if(X===bj)throw b=hj,Fj(a,c),yj(a,c),Z(a),b;if(null===V)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,Jj(a,c),d=X,U=null,d){case aj:case bj:throw t(Error(345));case cj:if(2!==c){Dj(a,2);break}Kj(a);break;case dj:yj(a,
	c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Lj(e));if(1073741823===ij&&(e=Mi+nj-Vf(),10<e)){if(mj){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Fj(a,c);break}}f=Aj(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=he(Kj.bind(null,a),e);break}Kj(a);break;case ej:yj(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Lj(e));if(mj&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Fj(a,c);break}e=Aj(a);if(0!==e&&e!==c)break;if(0!==
	d&&d!==c){a.lastPingedTime=d;break}1073741823!==jj?d=10*(1073741821-jj)-Vf():1073741823===ij?d=0:(d=10*(1073741821-ij)-5E3,e=Vf(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*Vi(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=he(Kj.bind(null,a),d);break}Kj(a);break;case fj:if(1073741823!==ij&&null!==kj){f=ij;var g=kj;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=Vf()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);
	if(10<d){yj(a,c);a.timeoutHandle=he(Kj.bind(null,a),d);break}}Kj(a);break;case gj:yj(a,c);break;default:throw t(Error(329));}Z(a);if(a.callbackNode===b)return Cj.bind(null,a)}}return null}
	function xj(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if(a.finishedExpirationTime===b)Kj(a);else{if((T&(Zi|$i))!==S)throw t(Error(327));Ej();a===U&&b===W||Fj(a,b);if(null!==V){var c=T;T|=Zi;var d=Gj(a);do try{Mj();break}catch(e){Ij(a,e)}while(1);hg();T=c;Wi.current=d;if(X===bj)throw c=hj,Fj(a,b),yj(a,b),Z(a),c;if(null!==V)throw t(Error(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;Jj(a,b);X===gj?yj(a,b):(U=null,Kj(a));Z(a)}}return null}
	function Nj(){(T&(1|Zi|$i))===S&&(Oj(),Ej())}function Jj(a,b){var c=a.firstBatch;null!==c&&c._defer&&c._expirationTime>=b&&(Zf(97,function(){c._onComplete();return null}),X=gj)}function Oj(){if(null!==rj){var a=rj;rj=null;a.forEach(function(a,c){Dj(c,a);Z(c)});bg()}}function Pj(a,b){var c=T;T|=1;try{return a(b)}finally{T=c,T===S&&bg()}}function Qj(a,b,c,d){var e=T;T|=4;try{return Yf(98,a.bind(null,b,c,d))}finally{T=e,T===S&&bg()}}
	function Rj(a,b){var c=T;T&=-2;T|=Yi;try{return a(b)}finally{T=c,T===S&&bg()}}
	function Fj(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,ie(c));if(null!==V)for(c=V.return;null!==c;){var d=c;switch(d.tag){case 1:var e=d.type.childContextTypes;null!==e&&void 0!==e&&wf(d);break;case 3:dh(d);xf(d);break;case 5:fh(d);break;case 4:dh(d);break;case 13:H(O,d);break;case 19:H(O,d);break;case 10:jg(d)}c=c.return}U=a;V=Rg(a.current,null,b);W=b;X=aj;hj=null;jj=ij=1073741823;kj=null;lj=0;mj=!1}
	function Ij(a,b){do{try{hg();Ah();if(null===V||null===V.return)return X=bj,hj=b,null;a:{var c=a,d=V.return,e=V,f=b;b=W;e.effectTag|=2048;e.firstEffect=e.lastEffect=null;if(null!==f&&"object"===typeof f&&"function"===typeof f.then){var g=f,h=0!==(O.current&1),k=d;do{var l;if(l=13===k.tag){var m=k.memoizedState;if(null!==m)l=null!==m.dehydrated?!0:!1;else{var A=k.memoizedProps;l=void 0===A.fallback?!1:!0!==A.unstable_avoidThisFallback?!0:h?!1:!0}}if(l){var w=k.updateQueue;if(null===w){var L=new Set;
	L.add(g);k.updateQueue=L}else w.add(g);if(0===(k.mode&2)){k.effectTag|=64;e.effectTag&=-2981;if(1===e.tag)if(null===e.alternate)e.tag=17;else{var wb=rg(1073741823,null);wb.tag=2;tg(e,wb)}e.expirationTime=1073741823;break a}f=void 0;e=b;var M=c.pingCache;null===M?(M=c.pingCache=new Pi,f=new Set,M.set(g,f)):(f=M.get(g),void 0===f&&(f=new Set,M.set(g,f)));if(!f.has(e)){f.add(e);var q=Sj.bind(null,c,g,e);g.then(q,q)}k.effectTag|=4096;k.expirationTime=b;break a}k=k.return}while(null!==k);f=Error((Va(e.type)||
	"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+Wa(e))}X!==fj&&(X=cj);f=ti(f,e);k=d;do{switch(k.tag){case 3:g=f;k.effectTag|=4096;k.expirationTime=b;var y=Qi(k,g,b);ug(k,y);break a;case 1:g=f;var z=k.type,p=k.stateNode;if((k.effectTag&64)===D&&("function"===typeof z.getDerivedStateFromError||null!==p&&"function"===typeof p.componentDidCatch&&
	(null===Ui||!Ui.has(p)))){k.effectTag|=4096;k.expirationTime=b;var u=Ti(k,g,b);ug(k,u);break a}}k=k.return}while(null!==k)}V=Tj(V)}catch(v){b=v;continue}break}while(1)}function Gj(){var a=Wi.current;Wi.current=zh;return null===a?zh:a}function yg(a,b){a<ij&&2<a&&(ij=a);null!==b&&a<jj&&2<a&&(jj=a,kj=b)}function zg(a){a>lj&&(lj=a)}function Mj(){for(;null!==V;)V=Uj(V)}function Hj(){for(;null!==V&&!Gf();)V=Uj(V)}
	function Uj(a){var b=Vj(a.alternate,a,W);a.memoizedProps=a.pendingProps;null===b&&(b=Tj(a));Xi.current=null;return b}
	function Tj(a){V=a;do{var b=V.alternate;a=V.return;if((V.effectTag&2048)===D){a:{var c=b;b=V;var d=W,e=b.pendingProps;switch(b.tag){case 2:break;case 16:break;case 15:case 0:break;case 1:N(b.type)&&wf(b);break;case 3:dh(b);xf(b);d=b.stateNode;d.pendingContext&&(d.context=d.pendingContext,d.pendingContext=null);(null===c||null===c.child)&&Wh(b)&&mi(b);oi(b);break;case 5:fh(b);d=bh(ah.current);var f=b.type;if(null!==c&&null!=b.stateNode)pi(c,b,f,e,d),c.ref!==b.ref&&(b.effectTag|=128);else if(e){var g=
	bh(Zg.current);if(Wh(b)){e=b;f=void 0;c=e.stateNode;var h=e.type,k=e.memoizedProps;c[me]=e;c[ne]=k;switch(h){case "iframe":case "object":case "embed":G("load",c);break;case "video":case "audio":for(var l=0;l<dc.length;l++)G(dc[l],c);break;case "source":G("error",c);break;case "img":case "image":case "link":G("error",c);G("load",c);break;case "form":G("reset",c);G("submit",c);break;case "details":G("toggle",c);break;case "input":Bb(c,k);G("invalid",c);Sd(d,"onChange");break;case "select":c._wrapperState=
	{wasMultiple:!!k.multiple};G("invalid",c);Sd(d,"onChange");break;case "textarea":Lb(c,k),G("invalid",c),Sd(d,"onChange")}Qd(h,k);l=null;for(f in k)k.hasOwnProperty(f)&&(g=k[f],"children"===f?"string"===typeof g?c.textContent!==g&&(l=["children",g]):"number"===typeof g&&c.textContent!==""+g&&(l=["children",""+g]):ia.hasOwnProperty(f)&&null!=g&&Sd(d,f));switch(h){case "input":yb(c);Gb(c,k,!0);break;case "textarea":yb(c);Nb(c,k);break;case "select":case "option":break;default:"function"===typeof k.onClick&&
	(c.onclick=Td)}d=l;e.updateQueue=d;null!==d&&mi(b)}else{k=f;c=e;h=b;l=9===d.nodeType?d:d.ownerDocument;g===Ob.html&&(g=Pb(k));g===Ob.html?"script"===k?(k=l.createElement("div"),k.innerHTML="<script>\x3c/script>",l=k.removeChild(k.firstChild)):"string"===typeof c.is?l=l.createElement(k,{is:c.is}):(l=l.createElement(k),"select"===k&&(k=l,c.multiple?k.multiple=!0:c.size&&(k.size=c.size))):l=l.createElementNS(g,k);k=l;k[me]=h;k[ne]=c;c=k;ni(c,b,!1,!1);b.stateNode=c;g=d;var m=Rd(f,e);switch(f){case "iframe":case "object":case "embed":G("load",
	c);d=e;break;case "video":case "audio":for(d=0;d<dc.length;d++)G(dc[d],c);d=e;break;case "source":G("error",c);d=e;break;case "img":case "image":case "link":G("error",c);G("load",c);d=e;break;case "form":G("reset",c);G("submit",c);d=e;break;case "details":G("toggle",c);d=e;break;case "input":Bb(c,e);d=Ab(c,e);G("invalid",c);Sd(g,"onChange");break;case "option":d=Ib(c,e);break;case "select":c._wrapperState={wasMultiple:!!e.multiple};d=n({},e,{value:void 0});G("invalid",c);Sd(g,"onChange");break;case "textarea":Lb(c,
	e);d=Kb(c,e);G("invalid",c);Sd(g,"onChange");break;default:d=e}Qd(f,d);h=void 0;k=f;l=c;var A=d;for(h in A)if(A.hasOwnProperty(h)){var w=A[h];"style"===h?Od(l,w):"dangerouslySetInnerHTML"===h?(w=w?w.__html:void 0,null!=w&&Sb(l,w)):"children"===h?"string"===typeof w?("textarea"!==k||""!==w)&&Tb(l,w):"number"===typeof w&&Tb(l,""+w):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(ia.hasOwnProperty(h)?null!=w&&Sd(g,h):null!=w&&ub(l,h,w,m))}switch(f){case "input":yb(c);
	Gb(c,e,!1);break;case "textarea":yb(c);Nb(c,e);break;case "option":null!=e.value&&c.setAttribute("value",""+tb(e.value));break;case "select":d=c;c=e;d.multiple=!!c.multiple;h=c.value;null!=h?Jb(d,!!c.multiple,h,!1):null!=c.defaultValue&&Jb(d,!!c.multiple,c.defaultValue,!0);break;default:"function"===typeof d.onClick&&(c.onclick=Td)}fe(f,e)&&mi(b)}null!==b.ref&&(b.effectTag|=128)}else if(null===b.stateNode)throw t(Error(166));break;case 6:if(c&&null!=b.stateNode)qi(c,b,c.memoizedProps,e);else{if("string"!==
	typeof e&&null===b.stateNode)throw t(Error(166));f=bh(ah.current);bh(Zg.current);Wh(b)?(d=b.stateNode,e=b.memoizedProps,d[me]=b,d.nodeValue!==e&&mi(b)):(d=b,e=(9===f.nodeType?f:f.ownerDocument).createTextNode(e),e[me]=b,d.stateNode=e)}break;case 11:break;case 13:H(O,b);e=b.memoizedState;if((b.effectTag&64)!==D){b.expirationTime=d;break a}d=null!==e;e=!1;null===c?Wh(b):(f=c.memoizedState,e=null!==f,d||null===f||(f=c.child.sibling,null!==f&&(h=b.firstEffect,null!==h?(b.firstEffect=f,f.nextEffect=h):
	(b.firstEffect=b.lastEffect=f,f.nextEffect=null),f.effectTag=8)));if(d&&!e&&0!==(b.mode&2))if(null===c&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(O.current&1))X===aj&&(X=dj);else{if(X===aj||X===dj)X=ej;0!==lj&&null!==U&&(yj(U,W),zj(U,lj))}if(d||e)b.effectTag|=4;break;case 7:break;case 8:break;case 12:break;case 4:dh(b);oi(b);break;case 10:jg(b);break;case 9:break;case 14:break;case 17:N(b.type)&&wf(b);break;case 19:H(O,b);e=b.memoizedState;if(null===e)break;f=(b.effectTag&64)!==D;h=e.rendering;
	if(null===h)if(f)ri(e,!1);else{if(X!==aj||null!==c&&(c.effectTag&64)!==D)for(c=b.child;null!==c;){h=gh(c);if(null!==h){b.effectTag|=64;ri(e,!1);e=h.updateQueue;null!==e&&(b.updateQueue=e,b.effectTag|=4);b.firstEffect=b.lastEffect=null;for(e=b.child;null!==e;)f=e,c=d,f.effectTag&=E,f.nextEffect=null,f.firstEffect=null,f.lastEffect=null,h=f.alternate,null===h?(f.childExpirationTime=0,f.expirationTime=c,f.child=null,f.memoizedProps=null,f.memoizedState=null,f.updateQueue=null,f.dependencies=null):(f.childExpirationTime=
	h.childExpirationTime,f.expirationTime=h.expirationTime,f.child=h.child,f.memoizedProps=h.memoizedProps,f.memoizedState=h.memoizedState,f.updateQueue=h.updateQueue,c=h.dependencies,f.dependencies=null===c?null:{expirationTime:c.expirationTime,firstContext:c.firstContext,responders:c.responders}),e=e.sibling;I(O,O.current&1|2,b);b=b.child;break a}c=c.sibling}}else{if(!f)if(c=gh(h),null!==c){if(b.effectTag|=64,f=!0,ri(e,!0),null===e.tail&&"hidden"===e.tailMode){d=c.updateQueue;null!==d&&(b.updateQueue=
	d,b.effectTag|=4);b=b.lastEffect=e.lastEffect;null!==b&&(b.nextEffect=null);break}}else Vf()>e.tailExpiration&&1<d&&(b.effectTag|=64,f=!0,ri(e,!1),b.expirationTime=b.childExpirationTime=d-1);e.isBackwards?(h.sibling=b.child,b.child=h):(d=e.last,null!==d?d.sibling=h:b.child=h,e.last=h)}if(null!==e.tail){0===e.tailExpiration&&(e.tailExpiration=Vf()+500);d=e.tail;e.rendering=d;e.tail=d.sibling;e.lastEffect=b.lastEffect;d.sibling=null;e=O.current;e=f?e&1|2:e&1;I(O,e,b);b=d;break a}break;case 20:break;
	case 21:break;default:throw t(Error(156),b.tag);}b=null}d=V;if(1===W||1!==d.childExpirationTime){e=0;for(f=d.child;null!==f;)c=f.expirationTime,h=f.childExpirationTime,c>e&&(e=c),h>e&&(e=h),f=f.sibling;d.childExpirationTime=e}if(null!==b)return b;null!==a&&(a.effectTag&2048)===D&&(null===a.firstEffect&&(a.firstEffect=V.firstEffect),null!==V.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=V.firstEffect),a.lastEffect=V.lastEffect),1<V.effectTag&&(null!==a.lastEffect?a.lastEffect.nextEffect=
	V:a.firstEffect=V,a.lastEffect=V))}else{b=si(V,W);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=V.sibling;if(null!==b)return b;V=a}while(null!==V);X===aj&&(X=fj);return null}function Lj(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Kj(a){var b=Wf();Yf(99,Wj.bind(null,a,b));return null}
	function Wj(a,b){Ej();if((T&(Zi|$i))!==S)throw t(Error(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw t(Error(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Lj(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=d-1);d<=a.lastPingedTime&&
	(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===U&&(V=U=null,W=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=T;T|=$i;Xi.current=null;de=Dd;var g=Yd();if(Zd(g)){if("selectionStart"in g)var h={start:g.selectionStart,end:g.selectionEnd};else a:{h=(h=g.ownerDocument)&&h.defaultView||window;var k=h.getSelection&&h.getSelection();if(k&&0!==k.rangeCount){h=k.anchorNode;var l=k.anchorOffset,m=k.focusNode;k=k.focusOffset;
	try{h.nodeType,m.nodeType}catch(Fb){h=null;break a}var A=0,w=-1,L=-1,wb=0,M=0,q=g,y=null;b:for(;;){for(var z;;){q!==h||0!==l&&3!==q.nodeType||(w=A+l);q!==m||0!==k&&3!==q.nodeType||(L=A+k);3===q.nodeType&&(A+=q.nodeValue.length);if(null===(z=q.firstChild))break;y=q;q=z}for(;;){if(q===g)break b;y===h&&++wb===l&&(w=A);y===m&&++M===k&&(L=A);if(null!==(z=q.nextSibling))break;q=y;y=q.parentNode}q=z}h=-1===w||-1===L?null:{start:w,end:L}}else h=null}h=h||{start:0,end:0}}else h=null;ee={focusedElem:g,selectionRange:h};
	Dd=!1;Y=e;do try{Xj()}catch(Fb){if(null===Y)throw t(Error(330));xi(Y,Fb);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(g=a,h=b;null!==Y;){var p=Y.effectTag;p&16&&Tb(Y.stateNode,"");if(p&128){var u=Y.alternate;if(null!==u){var v=u.ref;null!==v&&("function"===typeof v?v(null):v.current=null)}}switch(p&(E|12|Ac)){case E:Ki(Y);Y.effectTag&=~E;break;case 6:Ki(Y);Y.effectTag&=~E;Li(Y.alternate,Y);break;case Ac:Y.effectTag&=~Ac;break;case 1028:Y.effectTag&=~Ac;Li(Y.alternate,Y);break;case 4:Li(Y.alternate,
	Y);break;case 8:l=Y,Hi(g,l,h),Ii(l)}Y=Y.nextEffect}}catch(Fb){if(null===Y)throw t(Error(330));xi(Y,Fb);Y=Y.nextEffect}while(null!==Y);v=ee;u=Yd();p=v.focusedElem;h=v.selectionRange;if(u!==p&&p&&p.ownerDocument&&Xd(p.ownerDocument.documentElement,p)){null!==h&&Zd(p)&&(u=h.start,v=h.end,void 0===v&&(v=u),"selectionStart"in p?(p.selectionStart=u,p.selectionEnd=Math.min(v,p.value.length)):(v=(u=p.ownerDocument||document)&&u.defaultView||window,v.getSelection&&(v=v.getSelection(),l=p.textContent.length,
	g=Math.min(h.start,l),h=void 0===h.end?g:Math.min(h.end,l),!v.extend&&g>h&&(l=h,h=g,g=l),l=Wd(p,g),m=Wd(p,h),l&&m&&(1!==v.rangeCount||v.anchorNode!==l.node||v.anchorOffset!==l.offset||v.focusNode!==m.node||v.focusOffset!==m.offset)&&(u=u.createRange(),u.setStart(l.node,l.offset),v.removeAllRanges(),g>h?(v.addRange(u),v.extend(m.node,m.offset)):(u.setEnd(m.node,m.offset),v.addRange(u))))));u=[];for(v=p;v=v.parentNode;)1===v.nodeType&&u.push({element:v,left:v.scrollLeft,top:v.scrollTop});"function"===
	typeof p.focus&&p.focus();for(p=0;p<u.length;p++)v=u[p],v.element.scrollLeft=v.left,v.element.scrollTop=v.top}ee=null;Dd=!!de;de=null;a.current=c;Y=e;do try{for(p=d;null!==Y;){var Bh=Y.effectTag;if(Bh&36){var cc=Y.alternate;u=Y;v=p;switch(u.tag){case 0:case 11:case 15:Ei(16,32,u);break;case 1:var ed=u.stateNode;if(u.effectTag&4)if(null===cc)ed.componentDidMount();else{var Zj=u.elementType===u.type?cc.memoizedProps:cg(u.type,cc.memoizedProps);ed.componentDidUpdate(Zj,cc.memoizedState,ed.__reactInternalSnapshotBeforeUpdate)}var Ch=
	u.updateQueue;null!==Ch&&Ag(u,Ch,ed,v);break;case 3:var Dh=u.updateQueue;if(null!==Dh){g=null;if(null!==u.child)switch(u.child.tag){case 5:g=u.child.stateNode;break;case 1:g=u.child.stateNode}Ag(u,Dh,g,v)}break;case 5:var pk=u.stateNode;null===cc&&u.effectTag&4&&(v=pk,fe(u.type,u.memoizedProps)&&v.focus());break;case 6:break;case 4:break;case 12:break;case 13:if(null===u.memoizedState){var zi=u.alternate;if(null!==zi){var Ai=zi.memoizedState;if(null!==Ai){var Bi=Ai.dehydrated;null!==Bi&&zc(Bi)}}}break;
	case 19:case 17:case 20:case 21:break;default:throw t(Error(163));}}if(Bh&128){u=Y;var yd=u.ref;if(null!==yd){var Ci=u.stateNode;switch(u.tag){case 5:var yf=Ci;break;default:yf=Ci}"function"===typeof yd?yd(yf):yd.current=yf}}Y=Y.nextEffect}}catch(Fb){if(null===Y)throw t(Error(330));xi(Y,Fb);Y=Y.nextEffect}while(null!==Y);Y=null;Qf();T=f}else a.current=c;if(oj)oj=!1,pj=a,qj=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&(Ui=null);1073741823===b?a===tj?sj++:
	(sj=0,tj=a):sj=0;"function"===typeof Yj&&Yj(c.stateNode,d);Z(a);if(Ri)throw Ri=!1,a=Si,Si=null,a;if((T&Yi)!==S)return null;bg();return null}function Xj(){for(;null!==Y;){var a=Y.effectTag;(a&256)!==D&&Di(Y.alternate,Y);(a&512)===D||oj||(oj=!0,Zf(97,function(){Ej();return null}));Y=Y.nextEffect}}function Ej(){if(90!==qj){var a=97<qj?97:qj;qj=90;return Yf(a,ak)}}
	function ak(){if(null===pj)return!1;var a=pj;pj=null;if((T&(Zi|$i))!==S)throw t(Error(331));var b=T;T|=$i;for(a=a.current.firstEffect;null!==a;){try{var c=a;if((c.effectTag&512)!==D)switch(c.tag){case 0:case 11:case 15:Ei(128,0,c),Ei(0,64,c)}}catch(d){if(null===a)throw t(Error(330));xi(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}T=b;bg();return!0}function bk(a,b,c){b=ti(c,b);b=Qi(a,b,1073741823);tg(a,b);a=wj(a,1073741823);null!==a&&Z(a)}
	function xi(a,b){if(3===a.tag)bk(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){bk(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===Ui||!Ui.has(d))){a=ti(b,a);a=Ti(c,a,1073741823);tg(c,a);c=wj(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
	function Sj(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);U===a&&W===c?X===ej||X===dj&&1073741823===ij&&Vf()-Mi<nj?Fj(a,W):mj=!0:Bj(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,a.finishedExpirationTime===c&&(a.finishedExpirationTime=0,a.finishedWork=null),Z(a)))}function Oi(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=1;1===b&&(b=Fg(),b=Gg(b,a,null));a=wj(a,b);null!==a&&Z(a)}var Vj;
	Vj=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||K.current)mg=!0;else{if(d<c){mg=!1;switch(b.tag){case 3:hi(b);Xh();break;case 5:eh(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:N(b.type)&&Bf(b);break;case 4:ch(b,b.stateNode.containerInfo);break;case 10:ig(b,b.memoizedProps.value);break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;if(0!==d&&d>=c)return ji(a,b,c);I(O,O.current&
	1,b);b=$h(a,b,c);return null!==b?b.sibling:null}I(O,O.current&1,b);break;case 19:d=b.childExpirationTime>=c;if((a.effectTag&64)!==D){if(d)return li(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);I(O,O.current,b);if(!d)return null}return $h(a,b,c)}mg=!1}}else mg=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=E);a=b.pendingProps;e=vf(b,J.current);lg(b,c);e=wh(null,b,d,a,e,c);b.effectTag|=1;if("object"===
	typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;Ah();if(N(d)){var f=!0;Bf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;var g=d.getDerivedStateFromProps;"function"===typeof g&&Eg(b,d,g,a);e.updater=Ig;b.stateNode=e;e._reactInternalFiber=b;Mg(b,d,a,c);b=gi(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:e=b.elementType;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=E);a=b.pendingProps;Ua(e);if(1!==e._status)throw e._result;
	e=e._result;b.type=e;f=b.tag=ck(e);a=cg(e,a);switch(f){case 0:b=di(null,b,e,a,c);break;case 1:b=fi(null,b,e,a,c);break;case 11:b=Zh(null,b,e,a,c);break;case 14:b=ai(null,b,e,cg(e.type,a),d,c);break;default:throw t(Error(306),e,"");}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:cg(d,e),di(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:cg(d,e),fi(a,b,d,e,c);case 3:hi(b);d=b.updateQueue;if(null===d)throw t(Error(282));e=b.memoizedState;e=null!==e?e.element:
	null;xg(b,d,b.pendingProps,null,c);d=b.memoizedState.element;if(d===e)Xh(),b=$h(a,b,c);else{if(e=b.stateNode.hydrate)Ph=je(b.stateNode.containerInfo.firstChild),Oh=b,e=Qh=!0;if(e)for(c=Xg(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&~E|Ac,c=c.sibling;else R(a,b,d,c),Xh();b=b.child}return b;case 5:return eh(b),null===a&&Uh(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:null,g=e.children,ge(d,e)?g=null:null!==f&&ge(d,f)&&(b.effectTag|=16),ei(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=
	b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&Uh(b),null;case 13:return ji(a,b,c);case 4:return ch(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Wg(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:cg(d,e),Zh(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;
	e=b.pendingProps;g=b.memoizedProps;f=e.value;ig(b,f);if(null!==g){var h=g.value;f=ff(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0;if(0===f){if(g.children===e.children&&!K.current){b=$h(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=rg(c,null),l.tag=2,tg(h,l));h.expirationTime<c&&(h.expirationTime=
	c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);kg(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=g}}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,lg(b,c),e=ng(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;
	case 14:return e=b.type,f=cg(e,b.pendingProps),f=cg(e.type,f),ai(a,b,e,f,d,c);case 15:return ci(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:cg(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=E),b.tag=1,N(d)?(a=!0,Bf(b)):a=!1,lg(b,c),Kg(b,d,e,c),Mg(b,d,e,c),gi(null,b,d,!0,a,c);case 19:return li(a,b,c)}throw t(Error(156),b.tag);};var Yj=null,Gi=null;
	function dk(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Yj=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Gi=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
	function ek(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=D;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function Sh(a,b,c,d){return new ek(a,b,c,d)}
	function bi(a){a=a.prototype;return!(!a||!a.isReactComponent)}function ck(a){if("function"===typeof a)return bi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===Na)return 11;if(a===Qa)return 14}return 2}
	function Rg(a,b){var c=a.alternate;null===c?(c=Sh(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=D,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
	firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
	function Tg(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)bi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case Ha:return Vg(c.children,e,f,b);case Ma:g=8;e|=7;break;case Ia:g=8;e|=1;break;case Ja:return a=Sh(12,c,b,e|8),a.elementType=Ja,a.type=Ja,a.expirationTime=f,a;case Oa:return a=Sh(13,c,b,e),a.type=Oa,a.elementType=Oa,a.expirationTime=f,a;case Pa:return a=Sh(19,c,b,e),a.elementType=Pa,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case Ka:g=
	10;break a;case La:g=9;break a;case Na:g=11;break a;case Qa:g=14;break a;case Ra:g=16;d=null;break a}throw t(Error(130),null==a?a:typeof a,"");}b=Sh(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Vg(a,b,c,d){a=Sh(7,a,d,b);a.expirationTime=c;return a}function Sg(a,b,c){a=Sh(6,a,null,b);a.expirationTime=c;return a}
	function Ug(a,b,c){b=Sh(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
	function fk(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=this.firstBatch=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
	function Bj(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function yj(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
	function zj(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Dj(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}
	function gk(a,b,c,d,e,f){var g=b.current;a:if(c){c=c._reactInternalFiber;b:{if(Bc(c)!==c||1!==c.tag)throw t(Error(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(N(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw t(Error(171));}if(1===c.tag){var k=c.type;if(N(k)){c=Af(c,k,h);break a}}c=h}else c=tf;null===b.context?b.context=c:b.pendingContext=c;b=f;e=rg(d,e);e.payload={element:a};b=void 0===b?null:b;null!==b&&
	(e.callback=b);tg(g,e);Hg(g,d);return d}function hk(a,b,c,d){var e=b.current,f=Fg(),g=Cg.suspense;e=Gg(f,e,g);return gk(a,b,c,e,g,d)}function ik(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function jk(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:Ga,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
	Ya=function(a,b,c){switch(b){case "input":Db(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=re(d);if(!e)throw t(Error(90));zb(d);Db(d,e)}}}break;case "textarea":Mb(a,c);break;case "select":b=c.value,null!=b&&Jb(a,!!c.multiple,b,!1)}};
	function kk(a){var b=1073741821-25*(((1073741821-Fg()+500)/25|0)+1);b<=vj&&--b;this._expirationTime=vj=b;this._root=a;this._callbacks=this._next=null;this._hasChildren=this._didComplete=!1;this._children=null;this._defer=!0}kk.prototype.render=function(a){if(!this._defer)throw t(Error(250));this._hasChildren=!0;this._children=a;var b=this._root._internalRoot,c=this._expirationTime,d=new lk;gk(a,b,null,c,null,d._onCommit);return d};
	kk.prototype.then=function(a){if(this._didComplete)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
	kk.prototype.commit=function(){var a=this._root._internalRoot,b=a.firstBatch;if(!this._defer||null===b)throw t(Error(251));if(this._hasChildren){var c=this._expirationTime;if(b!==this){this._hasChildren&&(c=this._expirationTime=b._expirationTime,this.render(this._children));for(var d=null,e=b;e!==this;)d=e,e=e._next;if(null===d)throw t(Error(251));d._next=e._next;this._next=b;a.firstBatch=this}this._defer=!1;b=c;if((T&(Zi|$i))!==S)throw t(Error(253));Dj(a,b);Z(a);bg();b=this._next;this._next=null;
	b=a.firstBatch=b;null!==b&&b._hasChildren&&b.render(b._children)}else this._next=null,this._defer=!1};kk.prototype._onComplete=function(){if(!this._didComplete){this._didComplete=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++)(0,a[b])()}};function lk(){this._callbacks=null;this._didCommit=!1;this._onCommit=this._onCommit.bind(this)}lk.prototype.then=function(a){if(this._didCommit)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
	lk.prototype._onCommit=function(){if(!this._didCommit){this._didCommit=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++){var c=a[b];if("function"!==typeof c)throw t(Error(191),c);c()}}};function mk(a,b,c){c=null!=c&&!0===c.hydrate;var d=new fk(a,b,c),e=Sh(3,null,null,2===b?7:1===b?3:0);d.current=e;e.stateNode=d;a[oe]=d.current;c&&0!==b&&nc(9===a.nodeType?a:a.ownerDocument);return d}function nk(a,b,c){this._internalRoot=mk(a,b,c)}function ok(a,b){this._internalRoot=mk(a,2,b)}
	ok.prototype.render=nk.prototype.render=function(a,b){var c=this._internalRoot,d=new lk;b=void 0===b?null:b;null!==b&&d.then(b);hk(a,c,null,d._onCommit);return d};ok.prototype.unmount=nk.prototype.unmount=function(a){var b=this._internalRoot,c=new lk;a=void 0===a?null:a;null!==a&&c.then(a);hk(null,b,null,c._onCommit);return c};
	ok.prototype.createBatch=function(){var a=new kk(this),b=a._expirationTime,c=this._internalRoot,d=c.firstBatch;if(null===d)c.firstBatch=a,a._next=null;else{for(c=null;null!==d&&d._expirationTime>=b;)c=d,d=d._next;a._next=d;null!==c&&(c._next=a)}return a};function qk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}db=Pj;eb=Qj;fb=Nj;gb=function(a,b){var c=T;T|=2;try{return a(b)}finally{T=c,T===S&&bg()}};
	function rk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new nk(a,0,b?{hydrate:!0}:void 0)}
	function sk(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=ik(g);h.call(a)}}hk(b,g,a,e)}else{f=c._reactRootContainer=rk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=ik(g);k.call(a)}}Rj(function(){hk(b,g,a,e)})}return ik(g)}function tk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!qk(b))throw t(Error(200));return jk(a,b,null,c)}
	var wk={createPortal:tk,findDOMNode:function(a){if(null==a)a=null;else if(1!==a.nodeType){var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw t(Error(188));throw t(Error(268),Object.keys(a));}a=Ec(b);a=null===a?null:a.stateNode}return a},hydrate:function(a,b,c){if(!qk(b))throw t(Error(200));return sk(null,a,b,!0,c)},render:function(a,b,c){if(!qk(b))throw t(Error(200));return sk(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){if(!qk(c))throw t(Error(200));
	if(null==a||void 0===a._reactInternalFiber)throw t(Error(38));return sk(a,b,c,!1,d)},unmountComponentAtNode:function(a){if(!qk(a))throw t(Error(40));return a._reactRootContainer?(Rj(function(){sk(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:function(){return tk.apply(void 0,arguments)},unstable_batchedUpdates:Pj,unstable_interactiveUpdates:function(a,b,c,d){Nj();return Qj(a,b,c,d)},unstable_discreteUpdates:Qj,unstable_flushDiscreteUpdates:Nj,flushSync:function(a,
	b){if((T&(Zi|$i))!==S)throw t(Error(187));var c=T;T|=1;try{return Yf(99,a.bind(null,b))}finally{T=c,bg()}},unstable_createRoot:uk,unstable_createSyncRoot:vk,unstable_flushControlled:function(a){var b=T;T|=1;try{Yf(99,a)}finally{T=b,T===S&&bg()}},__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{Events:[pe,qe,re,Ba.injectEventPluginsByName,fa,Lc,function(a){xa(a,Kc)},bb,cb,Hd,Aa,Ej,{current:!1}]}};function uk(a,b){if(!qk(a))throw t(Error(299),"unstable_createRoot");return new ok(a,b)}
	function vk(a,b){if(!qk(a))throw t(Error(299),"unstable_createRoot");return new nk(a,1,b)}
	(function(a){var b=a.findFiberByHostInstance;return dk(n({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Da.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=Ec(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:Cd,bundleType:0,version:"16.10.1",
	rendererPackageName:"react-dom"});var xk={default:wk},yk=xk&&wk||xk;module.exports=yk.default||yk;


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ELEMENT_ID = 'firebaseui_container';
	
	var firebaseUiDeletion = Promise.resolve();
	
	var FirebaseAuth = function (_React$Component) {
	  _inherits(FirebaseAuth, _React$Component);
	
	  function FirebaseAuth(props) {
	    _classCallCheck(this, FirebaseAuth);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.uiConfig = props.uiConfig;
	    _this.firebaseAuth = props.firebaseAuth;
	    _this.className = props.className;
	    _this.uiCallback = props.uiCallback;
	    _this.unregisterAuthObserver = function () {};
	    return _this;
	  }
	
	  FirebaseAuth.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    __webpack_require__(907);
	
	    var firebaseui = __webpack_require__(165);
	
	    return firebaseUiDeletion.then(function () {
	      _this2.firebaseUiWidget = firebaseui.auth.AuthUI.getInstance() || new firebaseui.auth.AuthUI(_this2.firebaseAuth);
	      if (_this2.uiConfig.signInFlow === 'popup') {
	        _this2.firebaseUiWidget.reset();
	      }
	
	      _this2.userSignedIn = false;
	      _this2.unregisterAuthObserver = _this2.firebaseAuth.onAuthStateChanged(function (user) {
	        if (!user && _this2.userSignedIn) {
	          _this2.firebaseUiWidget.reset();
	        }
	        _this2.userSignedIn = !!user;
	      });
	
	      if (_this2.uiCallback) {
	        _this2.uiCallback(_this2.firebaseUiWidget);
	      }
	
	      _this2.firebaseUiWidget.start('#' + ELEMENT_ID, _this2.uiConfig);
	    });
	  };
	
	  FirebaseAuth.prototype.componentWillUnmount = function componentWillUnmount() {
	    var _this3 = this;
	
	    firebaseUiDeletion = firebaseUiDeletion.then(function () {
	      _this3.unregisterAuthObserver();
	      return _this3.firebaseUiWidget.delete();
	    });
	    return firebaseUiDeletion;
	  };
	
	  FirebaseAuth.prototype.render = function render() {
	    return _react2.default.createElement('div', { className: this.className, id: ELEMENT_ID });
	  };
	
	  return FirebaseAuth;
	}(_react2.default.Component);
	
	exports.default = FirebaseAuth;
	//# sourceMappingURL=FirebaseAuth.js.map

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _FirebaseAuth = __webpack_require__(437);
	
	var _FirebaseAuth2 = _interopRequireDefault(_FirebaseAuth);
	
	var _StyledFirebaseAuth = __webpack_require__(183);
	
	var _StyledFirebaseAuth2 = _interopRequireDefault(_StyledFirebaseAuth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.FirebaseAuth = _FirebaseAuth2.default;
	exports.StyledFirebaseAuth = _StyledFirebaseAuth2.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _reactDom = __webpack_require__(17);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(1));
	
	var _detectElementOverflow = _interopRequireDefault(__webpack_require__(382));
	
	var _utils = __webpack_require__(440);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var isBrowser = typeof window !== 'undefined';
	var isDisplayContentsSupported = isBrowser && 'CSS' in window && 'supports' in window.CSS && CSS.supports('display', 'contents');
	var isMutationObserverSupported = isBrowser && 'MutationObserver' in window;
	
	var capitalize = function capitalize(a) {
	  return a[0].toUpperCase() + a.slice(1);
	};
	
	var findScrollContainer = function findScrollContainer(element) {
	  if (!element) {
	    return undefined;
	  }
	
	  var parent = element.parentElement;
	
	  while (parent) {
	    var _window$getComputedSt = window.getComputedStyle(parent),
	        overflow = _window$getComputedSt.overflow;
	
	    if (overflow.split(' ').every(function (o) {
	      return o === 'auto' || o === 'scroll';
	    })) {
	      return parent;
	    }
	
	    parent = parent.parentElement;
	  }
	
	  return document.documentElement;
	};
	
	var alignAxis = function alignAxis(_ref) {
	  var axis = _ref.axis,
	      container = _ref.container,
	      element = _ref.element,
	      invertAxis = _ref.invertAxis,
	      secondary = _ref.secondary,
	      spacing = _ref.spacing;
	  var style = window.getComputedStyle(element);
	  var scrollContainer = findScrollContainer(element);
	  var parent = container.parentElement;
	  var parentCollisions = (0, _detectElementOverflow.default)(parent, scrollContainer);
	  var isX = axis === 'x';
	  var startProperty = isX ? 'left' : 'top';
	  var endProperty = isX ? 'right' : 'bottom';
	  var sizeProperty = isX ? 'width' : 'height';
	  var overflowStartProperty = "overflow".concat(capitalize(startProperty));
	  var overflowEndProperty = "overflow".concat(capitalize(endProperty));
	  var uppercasedSizeProperty = capitalize(sizeProperty);
	  var offsetSizeProperty = "offset".concat(uppercasedSizeProperty);
	  var clientSizeProperty = "client".concat(uppercasedSizeProperty);
	  var minSizeProperty = "min-".concat(sizeProperty);
	  var scrollbarWidth = scrollContainer[offsetSizeProperty] - scrollContainer[clientSizeProperty];
	  var availableStartSpace = -parentCollisions[overflowStartProperty] - spacing;
	  var availableEndSpace = -parentCollisions[overflowEndProperty] - spacing - scrollbarWidth;
	
	  if (secondary) {
	    availableStartSpace += parent[clientSizeProperty];
	    availableEndSpace += parent[clientSizeProperty];
	  }
	
	  var offsetSize = element[offsetSizeProperty];
	
	  var displayStart = function displayStart() {
	    element.style[startProperty] = 'unset';
	    element.style[endProperty] = secondary ? '0' : '100%';
	  };
	
	  var displayEnd = function displayEnd() {
	    element.style[startProperty] = secondary ? '0' : '100%';
	    element.style[endProperty] = 'unset';
	  };
	
	  var displayIfFits = function displayIfFits(availableSpace, display) {
	    var fits = offsetSize <= availableSpace;
	
	    if (fits) {
	      display();
	    }
	
	    return fits;
	  };
	
	  var displayStartIfFits = function displayStartIfFits() {
	    return displayIfFits(availableStartSpace, displayStart);
	  };
	
	  var displayEndIfFits = function displayEndIfFits() {
	    return displayIfFits(availableEndSpace, displayEnd);
	  };
	
	  var displayWhereverShrinkedFits = function displayWhereverShrinkedFits() {
	    var moreSpaceStart = availableStartSpace > availableEndSpace;
	    var minSize = style[minSizeProperty] && parseInt(style[minSizeProperty], 10);
	
	    var shrinkToSize = function shrinkToSize(size) {
	      if (minSize && size < minSize) {
	        (0, _utils.warnOnDev)("<Fit />'s child will not fit anywhere with its current ".concat(minSizeProperty, " of ").concat(minSize, "px."));
	      }
	
	      var newSize = Math.max(size, minSize || 0);
	      (0, _utils.warnOnDev)("<Fit />'s child needed to have its ".concat(sizeProperty, " decreased to ").concat(newSize, "px."));
	      element.style[sizeProperty] = "".concat(newSize, "px");
	    };
	
	    if (moreSpaceStart) {
	      shrinkToSize(availableStartSpace);
	      displayStart();
	    } else {
	      shrinkToSize(availableEndSpace);
	      displayEnd();
	    }
	  };
	
	  var fits;
	
	  if (invertAxis) {
	    fits = displayStartIfFits() || displayEndIfFits();
	  } else {
	    fits = displayEndIfFits() || displayStartIfFits();
	  }
	
	  if (!fits) {
	    displayWhereverShrinkedFits();
	  }
	};
	
	var alignMainAxis = function alignMainAxis(args) {
	  return alignAxis(args);
	};
	
	var alignSecondaryAxis = function alignSecondaryAxis(args) {
	  return alignAxis(_objectSpread({}, args, {
	    axis: args.axis === 'x' ? 'y' : 'x',
	    secondary: true
	  }));
	};
	
	var alignBothAxis = function alignBothAxis(args) {
	  var invertAxis = args.invertAxis,
	      invertSecondaryAxis = args.invertSecondaryAxis,
	      commonArgs = _objectWithoutProperties(args, ["invertAxis", "invertSecondaryAxis"]);
	
	  alignMainAxis(_objectSpread({}, commonArgs, {
	    invertAxis: invertAxis
	  }));
	  alignSecondaryAxis(_objectSpread({}, commonArgs, {
	    invertAxis: invertSecondaryAxis
	  }));
	};
	
	var Fit =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(Fit, _Component);
	
	  function Fit() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Fit);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Fit)).call.apply(_getPrototypeOf2, [this].concat(args)));
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onMutation", function () {
	      _this.fit();
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "mutationObserver", isMutationObserverSupported && new MutationObserver(_this.onMutation));
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "fit", function () {
	      var _assertThisInitialize = _assertThisInitialized(_assertThisInitialized(_this)),
	          container = _assertThisInitialize.container,
	          element = _assertThisInitialize.element;
	
	      if (!element) {
	        return;
	      }
	
	      var elementWidth = element.clientWidth;
	      var elementHeight = element.clientHeight; // No need to recalculate - already did that for current dimensions
	
	      if (_this.elementWidth === elementWidth && _this.elementHeight === elementHeight) {
	        return;
	      } // Save the dimensions so that we know we don't need to repeat the function if unchanged
	
	
	      _this.elementWidth = elementWidth;
	      _this.elementHeight = elementHeight;
	      var parent = container.parentElement;
	      /**
	       * We need to ensure that <Fit />'s child has a absolute position. Otherwise,
	       * we wouldn't be able to place the child in the correct position.
	       */
	
	      var style = window.getComputedStyle(element);
	      var position = style.position;
	
	      if (position !== 'absolute') {
	        (0, _utils.warnOnDev)('<Fit />\'s child does not have absolute position. You should apply `position: absolute` to it.');
	        element.style.position = 'absolute';
	      }
	      /**
	       * We need to ensure that <Fit />'s parent has a relative position. Otherwise,
	       * we wouldn't be able to place the child in the correct position.
	       */
	
	
	      var parentStyle = window.getComputedStyle(parent);
	      var parentPosition = parentStyle.position;
	
	      if (parentPosition !== 'relative' && parentPosition !== 'absolute') {
	        (0, _utils.warnOnDev)('<Fit />\'s parent does not have relative position. You should apply `position: relative` to it.');
	        parent.style.position = 'relative';
	      }
	
	      var _this$props = _this.props,
	          invertAxis = _this$props.invertAxis,
	          invertSecondaryAxis = _this$props.invertSecondaryAxis,
	          mainAxis = _this$props.mainAxis,
	          spacing = _this$props.spacing;
	      alignBothAxis({
	        container: container,
	        element: element,
	        invertAxis: invertAxis,
	        invertSecondaryAxis: invertSecondaryAxis,
	        axis: mainAxis,
	        spacing: spacing
	      });
	    });
	
	    return _this;
	  }
	
	  _createClass(Fit, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (!isDisplayContentsSupported) {
	        // eslint-disable-next-line react/no-find-dom-node
	        var element = (0, _reactDom.findDOMNode)(this);
	        this.container = element;
	        this.element = element;
	      }
	
	      this.fit();
	
	      if (isMutationObserverSupported) {
	        this.mutationObserver.observe(this.element, {
	          attributes: true,
	          attributeFilter: ['class', 'style']
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var children = this.props.children;
	
	      var child = _react.default.Children.only(children);
	
	      if (isDisplayContentsSupported) {
	        return _react.default.createElement("div", {
	          style: {
	            display: 'contents'
	          },
	          ref: function ref(_ref2) {
	            _this2.container = _ref2;
	            _this2.element = _ref2 && _ref2.firstChild;
	          }
	        }, child);
	      }
	
	      return child;
	    }
	  }]);
	
	  return Fit;
	}(_react.Component);
	
	exports.default = Fit;
	Fit.propTypes = {
	  children: _propTypes.default.node,
	  invertAxis: _propTypes.default.bool,
	  invertSecondaryAxis: _propTypes.default.bool,
	  mainAxis: _propTypes.default.oneOf(['x', 'y']),
	  spacing: _propTypes.default.number
	};
	Fit.defaultProps = {
	  mainAxis: 'y',
	  spacing: 8
	};

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.warnOnDev = exports.isProduction = void 0;
	
	/**
	 * Checks whether we're running on a production build or not.
	 */
	var isProduction = ("production") === 'production';
	exports.isProduction = isProduction;
	
	var consoleOnDev = function consoleOnDev(method) {
	  if (!isProduction) {
	    var _console;
	
	    for (var _len = arguments.length, message = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      message[_key - 1] = arguments[_key];
	    }
	
	    // eslint-disable-next-line no-console
	    (_console = console)[method].apply(_console, message);
	  }
	};
	
	var warnOnDev = function warnOnDev() {
	  for (var _len2 = arguments.length, message = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    message[_key2] = arguments[_key2];
	  }
	
	  return consoleOnDev.apply(void 0, ['warn'].concat(message));
	};
	
	exports.warnOnDev = warnOnDev;

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var react_1 = __importDefault(__webpack_require__(2));
	var object_assign_1 = __importDefault(__webpack_require__(85));
	var Iframe = function (_a) {
	    var url = _a.url, allowFullScreen = _a.allowFullScreen, position = _a.position, display = _a.display, height = _a.height, width = _a.width, overflow = _a.overflow, styles = _a.styles, onLoad = _a.onLoad, onMouseOver = _a.onMouseOver, onMouseOut = _a.onMouseOut, scrolling = _a.scrolling, id = _a.id, frameBorder = _a.frameBorder, ariaHidden = _a.ariaHidden, sandbox = _a.sandbox, allow = _a.allow, className = _a.className, title = _a.title, ariaLabel = _a.ariaLabel, ariaLabelledby = _a.ariaLabelledby, name = _a.name, target = _a.target, loading = _a.loading, importance = _a.importance, referrerpolicy = _a.referrerpolicy, allowpaymentrequest = _a.allowpaymentrequest, src = _a.src;
	    var defaultProps = object_assign_1.default({
	        src: src || url,
	        target: target || null,
	        style: {
	            position: position || null,
	            display: display || "block",
	            overflow: overflow || null
	        },
	        scrolling: scrolling || null,
	        allowpaymentrequest: allowpaymentrequest || null,
	        importance: importance || null,
	        sandbox: sandbox || null,
	        loading: loading || null,
	        styles: styles || null,
	        name: name || null,
	        className: className || null,
	        referrerpolicy: referrerpolicy || null,
	        title: title || null,
	        allow: allow || null,
	        id: id || null,
	        "aria-labelledby": ariaLabelledby || null,
	        "aria-hidden": ariaHidden || null,
	        "aria-label": ariaLabel || null,
	        width: width || null,
	        height: height || null,
	        onLoad: onLoad || null,
	        onMouseOver: onMouseOver || null,
	        onMouseOut: onMouseOut || null
	    });
	    var props = Object.create(null);
	    for (var _i = 0, _b = Object.keys(defaultProps); _i < _b.length; _i++) {
	        var prop = _b[_i];
	        if (defaultProps[prop] != null) {
	            props[prop] = defaultProps[prop];
	        }
	    }
	    for (var _c = 0, _d = Object.keys(props.style); _c < _d.length; _c++) {
	        var i = _d[_c];
	        if (props.style[i] == null) {
	            delete props.style[i];
	        }
	    }
	    if (allowFullScreen) {
	        if ("allow" in props) {
	            var currentAllow = props.allow.replace("fullscreen", "");
	            props.allow = ("fullscreen " + currentAllow.trim()).trim();
	        }
	        else {
	            props.allow = "fullscreen";
	        }
	    }
	    if (frameBorder >= 0) {
	        if (!props.style.hasOwnProperty("border")) {
	            props.style.border = frameBorder;
	        }
	    }
	    return react_1.default.createElement("iframe", __assign({}, props));
	};
	exports.default = Iframe;


/***/ }),
/* 442 */
/***/ (function(module, exports) {

	/** @license React v16.10.0
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';Object.defineProperty(exports,"__esModule",{value:!0});
	var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.suspense_list"):
	60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.fundamental"):60117,w=b?Symbol.for("react.responder"):60118,x=b?Symbol.for("react.scope"):60119;function y(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case h:return a;default:return u}}case t:case r:case d:return u}}}function z(a){return y(a)===m}
	exports.typeOf=y;exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;
	exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===v||a.$$typeof===w||a.$$typeof===x)};exports.isAsyncMode=function(a){return z(a)||y(a)===l};exports.isConcurrentMode=z;exports.isContextConsumer=function(a){return y(a)===k};exports.isContextProvider=function(a){return y(a)===h};
	exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return y(a)===n};exports.isFragment=function(a){return y(a)===e};exports.isLazy=function(a){return y(a)===t};exports.isMemo=function(a){return y(a)===r};exports.isPortal=function(a){return y(a)===d};exports.isProfiler=function(a){return y(a)===g};exports.isStrictMode=function(a){return y(a)===f};exports.isSuspense=function(a){return y(a)===p};


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _core = __webpack_require__(186);
	
	var _skeleton = __webpack_require__(185);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var SkeletonTheme =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(SkeletonTheme, _Component);
	
	  function SkeletonTheme() {
	    _classCallCheck(this, SkeletonTheme);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(SkeletonTheme).apply(this, arguments));
	  }
	
	  _createClass(SkeletonTheme, [{
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          color = _this$props.color,
	          highlightColor = _this$props.highlightColor,
	          children = _this$props.children;
	      var themeStyles =
	      /*#__PURE__*/
	      (0, _core.css)(".react-loading-skeleton{background-color:", color, ";background-image:linear-gradient( 90deg,", color, ",", highlightColor, ",", color, " );};label:SkeletonTheme;" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9za2VsZXRvbi10aGVtZS5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFZMkIiLCJmaWxlIjoiLi4vc3JjL3NrZWxldG9uLXRoZW1lLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0LCB7IENvbXBvbmVudCB9IGZyb20gXCJyZWFjdFwiO1xuaW1wb3J0IHsgY3NzIH0gZnJvbSBcIkBlbW90aW9uL2NvcmVcIjtcbmltcG9ydCB7IGRlZmF1bHRCYXNlQ29sb3IsIGRlZmF1bHRIaWdobGlnaHRDb2xvciB9IGZyb20gXCIuL3NrZWxldG9uXCI7XG5cbmV4cG9ydCBkZWZhdWx0IGNsYXNzIFNrZWxldG9uVGhlbWUgZXh0ZW5kcyBDb21wb25lbnQge1xuICBzdGF0aWMgZGVmYXVsdFByb3BzID0ge1xuICAgIGNvbG9yOiBkZWZhdWx0QmFzZUNvbG9yLFxuICAgIGhpZ2hsaWdodENvbG9yOiBkZWZhdWx0SGlnaGxpZ2h0Q29sb3JcbiAgfTtcblxuICByZW5kZXIoKSB7XG4gICAgY29uc3QgeyBjb2xvciwgaGlnaGxpZ2h0Q29sb3IsIGNoaWxkcmVuIH0gPSB0aGlzLnByb3BzO1xuICAgIGNvbnN0IHRoZW1lU3R5bGVzID0gY3NzYFxuICAgICAgLnJlYWN0LWxvYWRpbmctc2tlbGV0b24ge1xuICAgICAgICBiYWNrZ3JvdW5kLWNvbG9yOiAke2NvbG9yfTtcbiAgICAgICAgYmFja2dyb3VuZC1pbWFnZTogbGluZWFyLWdyYWRpZW50KFxuICAgICAgICAgIDkwZGVnLFxuICAgICAgICAgICR7Y29sb3J9LFxuICAgICAgICAgICR7aGlnaGxpZ2h0Q29sb3J9LFxuICAgICAgICAgICR7Y29sb3J9XG4gICAgICAgICk7XG4gICAgICB9XG4gICAgYDtcbiAgICByZXR1cm4gPGRpdiBjc3M9e3RoZW1lU3R5bGVzfT57Y2hpbGRyZW59PC9kaXY+O1xuICB9XG59XG4iXX0= */"));
	      return (0, _core.jsx)("div", {
	        css: themeStyles
	      }, children);
	    }
	  }]);
	
	  return SkeletonTheme;
	}(_react.Component);
	
	exports.default = SkeletonTheme;
	
	_defineProperty(SkeletonTheme, "defaultProps", {
	  color: _skeleton.defaultBaseColor,
	  highlightColor: _skeleton.defaultHighlightColor
	});

/***/ }),
/* 444 */
[936, 188, 448, 451],
/* 445 */
[937, 187],
/* 446 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/* eslint-disable */
	// Inspired by https://github.com/garycourt/murmurhash-js
	// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
	function murmur2(str) {
	  // 'm' and 'r' are mixing constants generated offline.
	  // They're not really 'magic', they just happen to work well.
	  // const m = 0x5bd1e995;
	  // const r = 24;
	  // Initialize the hash
	  var h = 0; // Mix 4 bytes at a time into the hash
	
	  var k,
	      i = 0,
	      len = str.length;
	
	  for (; len >= 4; ++i, len -= 4) {
	    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
	    k =
	    /* Math.imul(k, m): */
	    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
	    k ^=
	    /* k >>> r: */
	    k >>> 24;
	    h =
	    /* Math.imul(k, m): */
	    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
	    /* Math.imul(h, m): */
	    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
	  } // Handle the last few bytes of the input array
	
	
	  switch (len) {
	    case 3:
	      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
	
	    case 2:
	      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
	
	    case 1:
	      h ^= str.charCodeAt(i) & 0xff;
	      h =
	      /* Math.imul(h, m): */
	      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
	  } // Do a few final mixes of the hash to ensure the last few
	  // bytes are well-incorporated.
	
	
	  h ^= h >>> 13;
	  h =
	  /* Math.imul(h, m): */
	  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
	  return ((h ^ h >>> 15) >>> 0).toString(36);
	}
	
	exports.default = murmur2;


/***/ }),
/* 447 */
142,
/* 448 */
259,
/* 449 */
145,
/* 450 */
260,
/* 451 */
261,
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(17);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // This file is a fallback for a consumer who is not yet on React 16
	// as createPortal was introduced in React 16
	
	var Portal = function (_React$Component) {
	  _inherits(Portal, _React$Component);
	
	  function Portal() {
	    _classCallCheck(this, Portal);
	
	    return _possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).apply(this, arguments));
	  }
	
	  _createClass(Portal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.renderPortal();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(props) {
	      this.renderPortal();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      _reactDom2.default.unmountComponentAtNode(this.defaultNode || this.props.node);
	      if (this.defaultNode) {
	        document.body.removeChild(this.defaultNode);
	      }
	      this.defaultNode = null;
	      this.portal = null;
	    }
	  }, {
	    key: 'renderPortal',
	    value: function renderPortal(props) {
	      if (!this.props.node && !this.defaultNode) {
	        this.defaultNode = document.createElement('div');
	        document.body.appendChild(this.defaultNode);
	      }
	
	      var children = this.props.children;
	      // https://gist.github.com/jimfb/d99e0678e9da715ccf6454961ef04d1b
	      if (typeof this.props.children.type === 'function') {
	        children = _react2.default.cloneElement(this.props.children);
	      }
	
	      this.portal = _reactDom2.default.unstable_renderSubtreeIntoContainer(this, children, this.props.node || this.defaultNode);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return Portal;
	}(_react2.default.Component);
	
	exports.default = Portal;
	
	
	Portal.propTypes = {
	  children: _propTypes2.default.node.isRequired,
	  node: _propTypes2.default.any
	};

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(17);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _utils = __webpack_require__(455);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Portal = function (_React$Component) {
	  _inherits(Portal, _React$Component);
	
	  function Portal() {
	    _classCallCheck(this, Portal);
	
	    return _possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).apply(this, arguments));
	  }
	
	  _createClass(Portal, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.defaultNode) {
	        document.body.removeChild(this.defaultNode);
	      }
	      this.defaultNode = null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!_utils.canUseDOM) {
	        return null;
	      }
	      if (!this.props.node && !this.defaultNode) {
	        this.defaultNode = document.createElement('div');
	        document.body.appendChild(this.defaultNode);
	      }
	      return _reactDom2.default.createPortal(this.props.children, this.props.node || this.defaultNode);
	    }
	  }]);
	
	  return Portal;
	}(_react2.default.Component);
	
	Portal.propTypes = {
	  children: _propTypes2.default.node.isRequired,
	  node: _propTypes2.default.any
	};
	
	exports.default = Portal;

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PortalCompat = __webpack_require__(189);
	
	var _PortalCompat2 = _interopRequireDefault(_PortalCompat);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var KEYCODES = {
	  ESCAPE: 27
	};
	
	var PortalWithState = function (_React$Component) {
	  _inherits(PortalWithState, _React$Component);
	
	  function PortalWithState(props) {
	    _classCallCheck(this, PortalWithState);
	
	    var _this = _possibleConstructorReturn(this, (PortalWithState.__proto__ || Object.getPrototypeOf(PortalWithState)).call(this, props));
	
	    _this.portalNode = null;
	    _this.state = { active: !!props.defaultOpen };
	    _this.openPortal = _this.openPortal.bind(_this);
	    _this.closePortal = _this.closePortal.bind(_this);
	    _this.wrapWithPortal = _this.wrapWithPortal.bind(_this);
	    _this.handleOutsideMouseClick = _this.handleOutsideMouseClick.bind(_this);
	    _this.handleKeydown = _this.handleKeydown.bind(_this);
	    return _this;
	  }
	
	  _createClass(PortalWithState, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.closeOnEsc) {
	        document.addEventListener('keydown', this.handleKeydown);
	      }
	      if (this.props.closeOnOutsideClick) {
	        document.addEventListener('click', this.handleOutsideMouseClick);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.props.closeOnEsc) {
	        document.removeEventListener('keydown', this.handleKeydown);
	      }
	      if (this.props.closeOnOutsideClick) {
	        document.removeEventListener('click', this.handleOutsideMouseClick);
	      }
	    }
	  }, {
	    key: 'openPortal',
	    value: function openPortal(e) {
	      if (this.state.active) {
	        return;
	      }
	      if (e && e.nativeEvent) {
	        e.nativeEvent.stopImmediatePropagation();
	      }
	      this.setState({ active: true }, this.props.onOpen);
	    }
	  }, {
	    key: 'closePortal',
	    value: function closePortal() {
	      if (!this.state.active) {
	        return;
	      }
	      this.setState({ active: false }, this.props.onClose);
	    }
	  }, {
	    key: 'wrapWithPortal',
	    value: function wrapWithPortal(children) {
	      var _this2 = this;
	
	      if (!this.state.active) {
	        return null;
	      }
	      return _react2.default.createElement(
	        _PortalCompat2.default,
	        {
	          node: this.props.node,
	          key: 'react-portal',
	          ref: function ref(portalNode) {
	            return _this2.portalNode = portalNode;
	          }
	        },
	        children
	      );
	    }
	  }, {
	    key: 'handleOutsideMouseClick',
	    value: function handleOutsideMouseClick(e) {
	      if (!this.state.active) {
	        return;
	      }
	      var root = this.portalNode.props.node || this.portalNode.defaultNode;
	      if (!root || root.contains(e.target) || e.button && e.button !== 0) {
	        return;
	      }
	      this.closePortal();
	    }
	  }, {
	    key: 'handleKeydown',
	    value: function handleKeydown(e) {
	      if (e.keyCode === KEYCODES.ESCAPE && this.state.active) {
	        this.closePortal();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children({
	        openPortal: this.openPortal,
	        closePortal: this.closePortal,
	        portal: this.wrapWithPortal,
	        isOpen: this.state.active
	      });
	    }
	  }]);
	
	  return PortalWithState;
	}(_react2.default.Component);
	
	PortalWithState.propTypes = {
	  children: _propTypes2.default.func.isRequired,
	  defaultOpen: _propTypes2.default.bool,
	  node: _propTypes2.default.any,
	  closeOnEsc: _propTypes2.default.bool,
	  closeOnOutsideClick: _propTypes2.default.bool,
	  onOpen: _propTypes2.default.func,
	  onClose: _propTypes2.default.func
	};
	
	PortalWithState.defaultProps = {
	  onOpen: function onOpen() {},
	  onClose: function onClose() {}
	};
	
	exports.default = PortalWithState;

/***/ }),
/* 455 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = undefined;
	
	var _react = __webpack_require__(2);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _storeShape = __webpack_require__(191);
	
	var _storeShape2 = _interopRequireDefault(_storeShape);
	
	var _warning = __webpack_require__(192);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var didWarnAboutReceivingStore = false;
	function warnAboutReceivingStore() {
	  if (didWarnAboutReceivingStore) {
	    return;
	  }
	  didWarnAboutReceivingStore = true;
	
	  (0, _warning2["default"])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
	}
	
	var Provider = function (_Component) {
	  _inherits(Provider, _Component);
	
	  Provider.prototype.getChildContext = function getChildContext() {
	    return { store: this.store };
	  };
	
	  function Provider(props, context) {
	    _classCallCheck(this, Provider);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	    _this.store = props.store;
	    return _this;
	  }
	
	  Provider.prototype.render = function render() {
	    return _react.Children.only(this.props.children);
	  };
	
	  return Provider;
	}(_react.Component);
	
	exports["default"] = Provider;
	
	
	if (false) {
	  Provider.prototype.componentWillReceiveProps = function (nextProps) {
	    var store = this.store;
	    var nextStore = nextProps.store;
	
	
	    if (store !== nextStore) {
	      warnAboutReceivingStore();
	    }
	  };
	}
	
	Provider.propTypes = {
	  store: _storeShape2["default"].isRequired,
	  children: _propTypes2["default"].element.isRequired
	};
	Provider.childContextTypes = {
	  store: _storeShape2["default"].isRequired
	};

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports["default"] = connect;
	
	var _react = __webpack_require__(2);
	
	var _storeShape = __webpack_require__(191);
	
	var _storeShape2 = _interopRequireDefault(_storeShape);
	
	var _shallowEqual = __webpack_require__(458);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _wrapActionCreators = __webpack_require__(459);
	
	var _wrapActionCreators2 = _interopRequireDefault(_wrapActionCreators);
	
	var _warning = __webpack_require__(192);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _isPlainObject = __webpack_require__(468);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _hoistNonReactStatics = __webpack_require__(396);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _invariant = __webpack_require__(14);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var defaultMapStateToProps = function defaultMapStateToProps(state) {
	  return {};
	}; // eslint-disable-line no-unused-vars
	var defaultMapDispatchToProps = function defaultMapDispatchToProps(dispatch) {
	  return { dispatch: dispatch };
	};
	var defaultMergeProps = function defaultMergeProps(stateProps, dispatchProps, parentProps) {
	  return _extends({}, parentProps, stateProps, dispatchProps);
	};
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	var errorObject = { value: null };
	function tryCatch(fn, ctx) {
	  try {
	    return fn.apply(ctx);
	  } catch (e) {
	    errorObject.value = e;
	    return errorObject;
	  }
	}
	
	// Helps track hot reloading.
	var nextVersion = 0;
	
	function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
	  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	  var shouldSubscribe = Boolean(mapStateToProps);
	  var mapState = mapStateToProps || defaultMapStateToProps;
	
	  var mapDispatch = void 0;
	  if (typeof mapDispatchToProps === 'function') {
	    mapDispatch = mapDispatchToProps;
	  } else if (!mapDispatchToProps) {
	    mapDispatch = defaultMapDispatchToProps;
	  } else {
	    mapDispatch = (0, _wrapActionCreators2["default"])(mapDispatchToProps);
	  }
	
	  var finalMergeProps = mergeProps || defaultMergeProps;
	  var _options$pure = options.pure,
	      pure = _options$pure === undefined ? true : _options$pure,
	      _options$withRef = options.withRef,
	      withRef = _options$withRef === undefined ? false : _options$withRef;
	
	  var checkMergedEquals = pure && finalMergeProps !== defaultMergeProps;
	
	  // Helps track hot reloading.
	  var version = nextVersion++;
	
	  return function wrapWithConnect(WrappedComponent) {
	    var connectDisplayName = 'Connect(' + getDisplayName(WrappedComponent) + ')';
	
	    function checkStateShape(props, methodName) {
	      if (!(0, _isPlainObject2["default"])(props)) {
	        (0, _warning2["default"])(methodName + '() in ' + connectDisplayName + ' must return a plain object. ' + ('Instead received ' + props + '.'));
	      }
	    }
	
	    function computeMergedProps(stateProps, dispatchProps, parentProps) {
	      var mergedProps = finalMergeProps(stateProps, dispatchProps, parentProps);
	      if (false) {
	        checkStateShape(mergedProps, 'mergeProps');
	      }
	      return mergedProps;
	    }
	
	    var Connect = function (_Component) {
	      _inherits(Connect, _Component);
	
	      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	        return !pure || this.haveOwnPropsChanged || this.hasStoreStateChanged;
	      };
	
	      function Connect(props, context) {
	        _classCallCheck(this, Connect);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	        _this.version = version;
	        _this.store = props.store || context.store;
	
	        (0, _invariant2["default"])(_this.store, 'Could not find "store" in either the context or ' + ('props of "' + connectDisplayName + '". ') + 'Either wrap the root component in a <Provider>, ' + ('or explicitly pass "store" as a prop to "' + connectDisplayName + '".'));
	
	        var storeState = _this.store.getState();
	        _this.state = { storeState: storeState };
	        _this.clearCache();
	        return _this;
	      }
	
	      Connect.prototype.computeStateProps = function computeStateProps(store, props) {
	        if (!this.finalMapStateToProps) {
	          return this.configureFinalMapState(store, props);
	        }
	
	        var state = store.getState();
	        var stateProps = this.doStatePropsDependOnOwnProps ? this.finalMapStateToProps(state, props) : this.finalMapStateToProps(state);
	
	        if (false) {
	          checkStateShape(stateProps, 'mapStateToProps');
	        }
	        return stateProps;
	      };
	
	      Connect.prototype.configureFinalMapState = function configureFinalMapState(store, props) {
	        var mappedState = mapState(store.getState(), props);
	        var isFactory = typeof mappedState === 'function';
	
	        this.finalMapStateToProps = isFactory ? mappedState : mapState;
	        this.doStatePropsDependOnOwnProps = this.finalMapStateToProps.length !== 1;
	
	        if (isFactory) {
	          return this.computeStateProps(store, props);
	        }
	
	        if (false) {
	          checkStateShape(mappedState, 'mapStateToProps');
	        }
	        return mappedState;
	      };
	
	      Connect.prototype.computeDispatchProps = function computeDispatchProps(store, props) {
	        if (!this.finalMapDispatchToProps) {
	          return this.configureFinalMapDispatch(store, props);
	        }
	
	        var dispatch = store.dispatch;
	
	        var dispatchProps = this.doDispatchPropsDependOnOwnProps ? this.finalMapDispatchToProps(dispatch, props) : this.finalMapDispatchToProps(dispatch);
	
	        if (false) {
	          checkStateShape(dispatchProps, 'mapDispatchToProps');
	        }
	        return dispatchProps;
	      };
	
	      Connect.prototype.configureFinalMapDispatch = function configureFinalMapDispatch(store, props) {
	        var mappedDispatch = mapDispatch(store.dispatch, props);
	        var isFactory = typeof mappedDispatch === 'function';
	
	        this.finalMapDispatchToProps = isFactory ? mappedDispatch : mapDispatch;
	        this.doDispatchPropsDependOnOwnProps = this.finalMapDispatchToProps.length !== 1;
	
	        if (isFactory) {
	          return this.computeDispatchProps(store, props);
	        }
	
	        if (false) {
	          checkStateShape(mappedDispatch, 'mapDispatchToProps');
	        }
	        return mappedDispatch;
	      };
	
	      Connect.prototype.updateStatePropsIfNeeded = function updateStatePropsIfNeeded() {
	        var nextStateProps = this.computeStateProps(this.store, this.props);
	        if (this.stateProps && (0, _shallowEqual2["default"])(nextStateProps, this.stateProps)) {
	          return false;
	        }
	
	        this.stateProps = nextStateProps;
	        return true;
	      };
	
	      Connect.prototype.updateDispatchPropsIfNeeded = function updateDispatchPropsIfNeeded() {
	        var nextDispatchProps = this.computeDispatchProps(this.store, this.props);
	        if (this.dispatchProps && (0, _shallowEqual2["default"])(nextDispatchProps, this.dispatchProps)) {
	          return false;
	        }
	
	        this.dispatchProps = nextDispatchProps;
	        return true;
	      };
	
	      Connect.prototype.updateMergedPropsIfNeeded = function updateMergedPropsIfNeeded() {
	        var nextMergedProps = computeMergedProps(this.stateProps, this.dispatchProps, this.props);
	        if (this.mergedProps && checkMergedEquals && (0, _shallowEqual2["default"])(nextMergedProps, this.mergedProps)) {
	          return false;
	        }
	
	        this.mergedProps = nextMergedProps;
	        return true;
	      };
	
	      Connect.prototype.isSubscribed = function isSubscribed() {
	        return typeof this.unsubscribe === 'function';
	      };
	
	      Connect.prototype.trySubscribe = function trySubscribe() {
	        if (shouldSubscribe && !this.unsubscribe) {
	          this.unsubscribe = this.store.subscribe(this.handleChange.bind(this));
	          this.handleChange();
	        }
	      };
	
	      Connect.prototype.tryUnsubscribe = function tryUnsubscribe() {
	        if (this.unsubscribe) {
	          this.unsubscribe();
	          this.unsubscribe = null;
	        }
	      };
	
	      Connect.prototype.componentDidMount = function componentDidMount() {
	        this.trySubscribe();
	      };
	
	      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        if (!pure || !(0, _shallowEqual2["default"])(nextProps, this.props)) {
	          this.haveOwnPropsChanged = true;
	        }
	      };
	
	      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
	        this.tryUnsubscribe();
	        this.clearCache();
	      };
	
	      Connect.prototype.clearCache = function clearCache() {
	        this.dispatchProps = null;
	        this.stateProps = null;
	        this.mergedProps = null;
	        this.haveOwnPropsChanged = true;
	        this.hasStoreStateChanged = true;
	        this.haveStatePropsBeenPrecalculated = false;
	        this.statePropsPrecalculationError = null;
	        this.renderedElement = null;
	        this.finalMapDispatchToProps = null;
	        this.finalMapStateToProps = null;
	      };
	
	      Connect.prototype.handleChange = function handleChange() {
	        if (!this.unsubscribe) {
	          return;
	        }
	
	        var storeState = this.store.getState();
	        var prevStoreState = this.state.storeState;
	        if (pure && prevStoreState === storeState) {
	          return;
	        }
	
	        if (pure && !this.doStatePropsDependOnOwnProps) {
	          var haveStatePropsChanged = tryCatch(this.updateStatePropsIfNeeded, this);
	          if (!haveStatePropsChanged) {
	            return;
	          }
	          if (haveStatePropsChanged === errorObject) {
	            this.statePropsPrecalculationError = errorObject.value;
	          }
	          this.haveStatePropsBeenPrecalculated = true;
	        }
	
	        this.hasStoreStateChanged = true;
	        this.setState({ storeState: storeState });
	      };
	
	      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
	        (0, _invariant2["default"])(withRef, 'To access the wrapped instance, you need to specify ' + '{ withRef: true } as the fourth argument of the connect() call.');
	
	        return this.refs.wrappedInstance;
	      };
	
	      Connect.prototype.render = function render() {
	        var haveOwnPropsChanged = this.haveOwnPropsChanged,
	            hasStoreStateChanged = this.hasStoreStateChanged,
	            haveStatePropsBeenPrecalculated = this.haveStatePropsBeenPrecalculated,
	            statePropsPrecalculationError = this.statePropsPrecalculationError,
	            renderedElement = this.renderedElement;
	
	
	        this.haveOwnPropsChanged = false;
	        this.hasStoreStateChanged = false;
	        this.haveStatePropsBeenPrecalculated = false;
	        this.statePropsPrecalculationError = null;
	
	        if (statePropsPrecalculationError) {
	          throw statePropsPrecalculationError;
	        }
	
	        var shouldUpdateStateProps = true;
	        var shouldUpdateDispatchProps = true;
	        if (pure && renderedElement) {
	          shouldUpdateStateProps = hasStoreStateChanged || haveOwnPropsChanged && this.doStatePropsDependOnOwnProps;
	          shouldUpdateDispatchProps = haveOwnPropsChanged && this.doDispatchPropsDependOnOwnProps;
	        }
	
	        var haveStatePropsChanged = false;
	        var haveDispatchPropsChanged = false;
	        if (haveStatePropsBeenPrecalculated) {
	          haveStatePropsChanged = true;
	        } else if (shouldUpdateStateProps) {
	          haveStatePropsChanged = this.updateStatePropsIfNeeded();
	        }
	        if (shouldUpdateDispatchProps) {
	          haveDispatchPropsChanged = this.updateDispatchPropsIfNeeded();
	        }
	
	        var haveMergedPropsChanged = true;
	        if (haveStatePropsChanged || haveDispatchPropsChanged || haveOwnPropsChanged) {
	          haveMergedPropsChanged = this.updateMergedPropsIfNeeded();
	        } else {
	          haveMergedPropsChanged = false;
	        }
	
	        if (!haveMergedPropsChanged && renderedElement) {
	          return renderedElement;
	        }
	
	        if (withRef) {
	          this.renderedElement = (0, _react.createElement)(WrappedComponent, _extends({}, this.mergedProps, {
	            ref: 'wrappedInstance'
	          }));
	        } else {
	          this.renderedElement = (0, _react.createElement)(WrappedComponent, this.mergedProps);
	        }
	
	        return this.renderedElement;
	      };
	
	      return Connect;
	    }(_react.Component);
	
	    Connect.displayName = connectDisplayName;
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.contextTypes = {
	      store: _storeShape2["default"]
	    };
	    Connect.propTypes = {
	      store: _storeShape2["default"]
	    };
	
	    if (false) {
	      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
	        if (this.version === version) {
	          return;
	        }
	
	        // We are hot reloading!
	        this.version = version;
	        this.trySubscribe();
	        this.clearCache();
	      };
	    }
	
	    return (0, _hoistNonReactStatics2["default"])(Connect, WrappedComponent);
	  };
	}

/***/ }),
/* 458 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = shallowEqual;
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var hasOwn = Object.prototype.hasOwnProperty;
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = wrapActionCreators;
	
	var _redux = __webpack_require__(136);
	
	function wrapActionCreators(actionCreators) {
	  return function (dispatch) {
	    return (0, _redux.bindActionCreators)(actionCreators, dispatch);
	  };
	}

/***/ }),
/* 460 */
[939, 193, 463, 464],
/* 461 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 462 */
[940, 465],
/* 463 */
[941, 193],
/* 464 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ }),
/* 465 */
/***/ (function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ }),
/* 466 */
[942, 461],
/* 467 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ }),
/* 468 */
[943, 460, 462, 467],
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _resizeDetectorStyles = __webpack_require__(470);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ResizeDetector = function (_Component) {
	  _inherits(ResizeDetector, _Component);
	
	  function ResizeDetector() {
	    _classCallCheck(this, ResizeDetector);
	
	    var _this = _possibleConstructorReturn(this, (ResizeDetector.__proto__ || Object.getPrototypeOf(ResizeDetector)).call(this));
	
	    _this.state = {
	      expandChildHeight: 0,
	      expandChildWidth: 0,
	      expandScrollLeft: 0,
	      expandScrollTop: 0,
	      shrinkScrollTop: 0,
	      shrinkScrollLeft: 0,
	      lastWidth: 0,
	      lastHeight: 0
	    };
	
	    _this.reset = _this.reset.bind(_this);
	    _this.handleScroll = _this.handleScroll.bind(_this);
	    return _this;
	  }
	
	  _createClass(ResizeDetector, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.forceUpdate();
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _containerSize = this.containerSize(),
	          _containerSize2 = _slicedToArray(_containerSize, 2),
	          width = _containerSize2[0],
	          height = _containerSize2[1];
	
	      this.reset(width, height);
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return this.props !== nextProps || this.state !== nextState;
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.expand.scrollLeft = this.expand.scrollWidth;
	      this.expand.scrollTop = this.expand.scrollHeight;
	
	      this.shrink.scrollLeft = this.shrink.scrollWidth;
	      this.shrink.scrollTop = this.shrink.scrollHeight;
	    }
	  }, {
	    key: 'containerSize',
	    value: function containerSize() {
	      return [this.props.handleWidth && this.container.parentElement.offsetWidth, this.props.handleHeight && this.container.parentElement.offsetHeight];
	    }
	  }, {
	    key: 'reset',
	    value: function reset(containerWidth, containerHeight) {
	      if (typeof window === 'undefined') {
	        return;
	      }
	
	      var parent = this.container.parentElement;
	
	      var position = 'static';
	      if (parent.currentStyle) {
	        position = parent.currentStyle.position;
	      } else if (window.getComputedStyle) {
	        position = window.getComputedStyle(parent).position;
	      }
	      if (position === 'static') {
	        parent.style.position = 'relative';
	      }
	
	      this.setState({
	        expandChildHeight: this.expand.offsetHeight + 10,
	        expandChildWidth: this.expand.offsetWidth + 10,
	        lastWidth: containerWidth,
	        lastHeight: containerHeight
	      });
	    }
	  }, {
	    key: 'handleScroll',
	    value: function handleScroll() {
	      if (typeof window === 'undefined') {
	        return;
	      }
	
	      var state = this.state;
	
	      var _containerSize3 = this.containerSize(),
	          _containerSize4 = _slicedToArray(_containerSize3, 2),
	          width = _containerSize4[0],
	          height = _containerSize4[1];
	
	      if (width !== state.lastWidth || height !== state.lastHeight) {
	        this.props.onResize(width, height);
	      }
	
	      this.reset(width, height);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var state = this.state;
	
	
	      var expandStyle = _extends({}, _resizeDetectorStyles.expandChildStyle, {
	        width: state.expandChildWidth,
	        height: state.expandChildHeight
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { style: _resizeDetectorStyles.parentStyle, ref: function ref(e) {
	            _this2.container = e;
	          } },
	        _react2.default.createElement(
	          'div',
	          { style: _resizeDetectorStyles.parentStyle, onScroll: this.handleScroll, ref: function ref(e) {
	              _this2.expand = e;
	            } },
	          _react2.default.createElement('div', { style: expandStyle })
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: _resizeDetectorStyles.parentStyle, onScroll: this.handleScroll, ref: function ref(e) {
	              _this2.shrink = e;
	            } },
	          _react2.default.createElement('div', { style: _resizeDetectorStyles.shrinkChildStyle })
	        )
	      );
	    }
	  }]);
	
	  return ResizeDetector;
	}(_react.Component);
	
	exports.default = ResizeDetector;
	
	
	ResizeDetector.propTypes = {
	  handleWidth: _propTypes2.default.bool,
	  handleHeight: _propTypes2.default.bool,
	  onResize: _propTypes2.default.func
	};
	
	ResizeDetector.defaultProps = {
	  handleWidth: false,
	  handleHeight: false,
	  onResize: function onResize(e) {
	    return e;
	  }
	};

/***/ }),
/* 470 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var parentStyle = exports.parentStyle = {
	  position: 'absolute',
	  left: 0,
	  top: 0,
	  right: 0,
	  bottom: 0,
	  overflow: 'scroll',
	  zIndex: -1,
	  visibility: 'hidden'
	};
	
	var shrinkChildStyle = exports.shrinkChildStyle = {
	  position: 'absolute',
	  left: 0,
	  top: 0,
	  width: '200%',
	  height: '200%'
	};
	
	var expandChildStyle = exports.expandChildStyle = {
	  position: 'absolute',
	  left: 0,
	  top: 0,
	  width: '100%',
	  height: '100%'
	};

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ResizeDetector = __webpack_require__(469);
	
	var _ResizeDetector2 = _interopRequireDefault(_ResizeDetector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ResizeDetector2.default;

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

	!function(root, factory) {
	     true ? module.exports = factory(__webpack_require__(2)) : "function" == typeof define && define.amd ? define([ "react" ], factory) : "object" == typeof exports ? exports.MediaQuery = factory(require("react")) : root.MediaQuery = factory(root.React);
	}("undefined" != typeof self ? self : this, function(__WEBPACK_EXTERNAL_MODULE_1__) {
	    return function(modules) {
	        function __webpack_require__(moduleId) {
	            if (installedModules[moduleId]) return installedModules[moduleId].exports;
	            var module = installedModules[moduleId] = {
	                i: moduleId,
	                l: !1,
	                exports: {}
	            };
	            return modules[moduleId].call(module.exports, module, module.exports, __webpack_require__), 
	            module.l = !0, module.exports;
	        }
	        var installedModules = {};
	        return __webpack_require__.m = modules, __webpack_require__.c = installedModules, 
	        __webpack_require__.d = function(exports, name, getter) {
	            __webpack_require__.o(exports, name) || Object.defineProperty(exports, name, {
	                configurable: !1,
	                enumerable: !0,
	                get: getter
	            });
	        }, __webpack_require__.n = function(module) {
	            var getter = module && module.__esModule ? function() {
	                return module.default;
	            } : function() {
	                return module;
	            };
	            return __webpack_require__.d(getter, "a", getter), getter;
	        }, __webpack_require__.o = function(object, property) {
	            return Object.prototype.hasOwnProperty.call(object, property);
	        }, __webpack_require__.p = "", __webpack_require__(__webpack_require__.s = 6);
	    }([ function(module, __webpack_exports__, __webpack_require__) {
	        "use strict";
	        function _slicedToArray(arr, i) {
	            return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
	        }
	        function _nonIterableRest() {
	            throw new TypeError("Invalid attempt to destructure non-iterable instance");
	        }
	        function _iterableToArrayLimit(arr, i) {
	            var _arr = [], _n = !0, _d = !1, _e = void 0;
	            try {
	                for (var _s, _i = arr[Symbol.iterator](); !(_n = (_s = _i.next()).done) && (_arr.push(_s.value), 
	                !i || _arr.length !== i); _n = !0) ;
	            } catch (err) {
	                _d = !0, _e = err;
	            } finally {
	                try {
	                    _n || null == _i.return || _i.return();
	                } finally {
	                    if (_d) throw _e;
	                }
	            }
	            return _arr;
	        }
	        function _arrayWithHoles(arr) {
	            if (Array.isArray(arr)) return arr;
	        }
	        var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1), __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__), __WEBPACK_IMPORTED_MODULE_1_matchmediaquery__ = __webpack_require__(7), __WEBPACK_IMPORTED_MODULE_1_matchmediaquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_matchmediaquery__), __WEBPACK_IMPORTED_MODULE_2_hyphenate_style_name__ = __webpack_require__(2), __WEBPACK_IMPORTED_MODULE_3_shallow_equal_objects__ = __webpack_require__(9), __WEBPACK_IMPORTED_MODULE_3_shallow_equal_objects___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_shallow_equal_objects__), __WEBPACK_IMPORTED_MODULE_4__toQuery__ = __webpack_require__(10), __WEBPACK_IMPORTED_MODULE_5__Context__ = __webpack_require__(5), makeQuery = function(settings) {
	            return settings.query || Object(__WEBPACK_IMPORTED_MODULE_4__toQuery__.a)(settings);
	        }, hyphenateKeys = function(obj) {
	            if (!obj) return null;
	            var keys = Object.keys(obj);
	            return 0 === keys.length ? null : keys.reduce(function(result, key) {
	                return result[Object(__WEBPACK_IMPORTED_MODULE_2_hyphenate_style_name__.a)(key)] = obj[key], 
	                result;
	            }, {});
	        }, useIsUpdate = function() {
	            var ref = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useRef(!1);
	            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.useEffect(function() {
	                ref.current = !0;
	            }, []), ref.current;
	        }, useDevice = function(deviceFromProps) {
	            var deviceFromContext = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useContext(__WEBPACK_IMPORTED_MODULE_5__Context__.a), getDevice = function() {
	                return hyphenateKeys(deviceFromProps) || hyphenateKeys(deviceFromContext);
	            }, _React$useState = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useState(getDevice), _React$useState2 = _slicedToArray(_React$useState, 2), device = _React$useState2[0], setDevice = _React$useState2[1];
	            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.useEffect(function() {
	                var newDevice = getDevice();
	                __WEBPACK_IMPORTED_MODULE_3_shallow_equal_objects___default()(device, newDevice) || setDevice(newDevice);
	            }, [ deviceFromProps, deviceFromContext ]), device;
	        }, useQuery = function(settings) {
	            var getQuery = function() {
	                return makeQuery(settings);
	            }, _React$useState3 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useState(getQuery), _React$useState4 = _slicedToArray(_React$useState3, 2), query = _React$useState4[0], setQuery = _React$useState4[1];
	            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.useEffect(function() {
	                var newQuery = getQuery();
	                query !== newQuery && setQuery(newQuery);
	            }, [ settings ]), query;
	        }, useMatchMedia = function(query, device) {
	            var getMatchMedia = function() {
	                return __WEBPACK_IMPORTED_MODULE_1_matchmediaquery___default()(query, device || {}, !!device);
	            }, _React$useState5 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useState(getMatchMedia), _React$useState6 = _slicedToArray(_React$useState5, 2), mq = _React$useState6[0], setMq = _React$useState6[1], isUpdate = useIsUpdate();
	            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.useEffect(function() {
	                return isUpdate && setMq(getMatchMedia()), function() {
	                    mq.dispose();
	                };
	            }, [ query, device ]), mq;
	        }, useMatches = function(mediaQuery) {
	            var _React$useState7 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useState(mediaQuery.matches), _React$useState8 = _slicedToArray(_React$useState7, 2), matches = _React$useState8[0], setMatches = _React$useState8[1];
	            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.useEffect(function() {
	                var updateMatches = function() {
	                    setMatches(mediaQuery.matches);
	                };
	                return mediaQuery.addListener(updateMatches), updateMatches(), function() {
	                    mediaQuery.removeListener(updateMatches);
	                };
	            }, [ mediaQuery ]), matches;
	        }, useMediaQuery = function(settings, device, onChange) {
	            var deviceSettings = useDevice(device), query = useQuery(settings);
	            if (!query) throw new Error("Invalid or missing MediaQuery!");
	            var mq = useMatchMedia(query, deviceSettings), matches = useMatches(mq), isUpdate = useIsUpdate();
	            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.useEffect(function() {
	                isUpdate && onChange && onChange(matches);
	            }, [ matches ]), matches;
	        };
	        __webpack_exports__.a = useMediaQuery;
	    }, function(module, exports) {
	        module.exports = __WEBPACK_EXTERNAL_MODULE_1__;
	    }, function(module, __webpack_exports__, __webpack_require__) {
	        "use strict";
	        function toHyphenLower(match) {
	            return "-" + match.toLowerCase();
	        }
	        function hyphenateStyleName(name) {
	            if (cache.hasOwnProperty(name)) return cache[name];
	            var hName = name.replace(uppercasePattern, toHyphenLower);
	            return cache[name] = msPattern.test(hName) ? "-" + hName : hName;
	        }
	        var uppercasePattern = /[A-Z]/g, msPattern = /^ms-/, cache = {};
	        __webpack_exports__.a = hyphenateStyleName;
	    }, function(module, exports, __webpack_require__) {
	        "use strict";
	        module.exports = __webpack_require__(13);
	    }, function(module, exports, __webpack_require__) {
	        "use strict";
	        module.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
	    }, function(module, __webpack_exports__, __webpack_require__) {
	        "use strict";
	        var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1), __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__), Context = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext();
	        __webpack_exports__.a = Context;
	    }, function(module, __webpack_exports__, __webpack_require__) {
	        "use strict";
	        Object.defineProperty(__webpack_exports__, "__esModule", {
	            value: !0
	        });
	        var __WEBPACK_IMPORTED_MODULE_0__useMediaQuery__ = __webpack_require__(0), __WEBPACK_IMPORTED_MODULE_1__Component__ = __webpack_require__(17), __WEBPACK_IMPORTED_MODULE_2__Context__ = __webpack_require__(5);
	        __webpack_require__.d(__webpack_exports__, "default", function() {
	            return __WEBPACK_IMPORTED_MODULE_1__Component__.a;
	        }), __webpack_require__.d(__webpack_exports__, "useMediaQuery", function() {
	            return __WEBPACK_IMPORTED_MODULE_0__useMediaQuery__.a;
	        }), __webpack_require__.d(__webpack_exports__, "Context", function() {
	            return __WEBPACK_IMPORTED_MODULE_2__Context__.a;
	        });
	    }, function(module, exports, __webpack_require__) {
	        "use strict";
	        function Mql(query, values, forceStatic) {
	            function addListener(listener) {
	                mql && mql.addListener(listener);
	            }
	            function removeListener(listener) {
	                mql && mql.removeListener(listener);
	            }
	            function update(evt) {
	                self.matches = evt.matches, self.media = evt.media;
	            }
	            function dispose() {
	                mql && mql.removeListener(update);
	            }
	            var self = this;
	            if (dynamicMatch && !forceStatic) {
	                var mql = dynamicMatch.call(window, query);
	                this.matches = mql.matches, this.media = mql.media, mql.addListener(update);
	            } else this.matches = staticMatch(query, values), this.media = query;
	            this.addListener = addListener, this.removeListener = removeListener, this.dispose = dispose;
	        }
	        function matchMedia(query, values, forceStatic) {
	            return new Mql(query, values, forceStatic);
	        }
	        var staticMatch = __webpack_require__(8).match, dynamicMatch = "undefined" != typeof window ? window.matchMedia : null;
	        module.exports = matchMedia;
	    }, function(module, exports, __webpack_require__) {
	        "use strict";
	        function matchQuery(mediaQuery, values) {
	            return parseQuery(mediaQuery).some(function(query) {
	                var inverse = query.inverse, typeMatch = "all" === query.type || values.type === query.type;
	                if (typeMatch && inverse || !typeMatch && !inverse) return !1;
	                var expressionsMatch = query.expressions.every(function(expression) {
	                    var feature = expression.feature, modifier = expression.modifier, expValue = expression.value, value = values[feature];
	                    if (!value) return !1;
	                    switch (feature) {
	                      case "orientation":
	                      case "scan":
	                        return value.toLowerCase() === expValue.toLowerCase();
	
	                      case "width":
	                      case "height":
	                      case "device-width":
	                      case "device-height":
	                        expValue = toPx(expValue), value = toPx(value);
	                        break;
	
	                      case "resolution":
	                        expValue = toDpi(expValue), value = toDpi(value);
	                        break;
	
	                      case "aspect-ratio":
	                      case "device-aspect-ratio":
	                      case "device-pixel-ratio":
	                        expValue = toDecimal(expValue), value = toDecimal(value);
	                        break;
	
	                      case "grid":
	                      case "color":
	                      case "color-index":
	                      case "monochrome":
	                        expValue = parseInt(expValue, 10) || 1, value = parseInt(value, 10) || 0;
	                    }
	                    switch (modifier) {
	                      case "min":
	                        return value >= expValue;
	
	                      case "max":
	                        return value <= expValue;
	
	                      default:
	                        return value === expValue;
	                    }
	                });
	                return expressionsMatch && !inverse || !expressionsMatch && inverse;
	            });
	        }
	        function parseQuery(mediaQuery) {
	            return mediaQuery.split(",").map(function(query) {
	                query = query.trim();
	                var captures = query.match(RE_MEDIA_QUERY), modifier = captures[1], type = captures[2], expressions = captures[3] || "", parsed = {};
	                return parsed.inverse = !!modifier && "not" === modifier.toLowerCase(), parsed.type = type ? type.toLowerCase() : "all", 
	                expressions = expressions.match(/\([^\)]+\)/g) || [], parsed.expressions = expressions.map(function(expression) {
	                    var captures = expression.match(RE_MQ_EXPRESSION), feature = captures[1].toLowerCase().match(RE_MQ_FEATURE);
	                    return {
	                        modifier: feature[1],
	                        feature: feature[2],
	                        value: captures[2]
	                    };
	                }), parsed;
	            });
	        }
	        function toDecimal(ratio) {
	            var numbers, decimal = Number(ratio);
	            return decimal || (numbers = ratio.match(/^(\d+)\s*\/\s*(\d+)$/), decimal = numbers[1] / numbers[2]), 
	            decimal;
	        }
	        function toDpi(resolution) {
	            var value = parseFloat(resolution);
	            switch (String(resolution).match(RE_RESOLUTION_UNIT)[1]) {
	              case "dpcm":
	                return value / 2.54;
	
	              case "dppx":
	                return 96 * value;
	
	              default:
	                return value;
	            }
	        }
	        function toPx(length) {
	            var value = parseFloat(length);
	            switch (String(length).match(RE_LENGTH_UNIT)[1]) {
	              case "em":
	              case "rem":
	                return 16 * value;
	
	              case "cm":
	                return 96 * value / 2.54;
	
	              case "mm":
	                return 96 * value / 2.54 / 10;
	
	              case "in":
	                return 96 * value;
	
	              case "pt":
	                return 72 * value;
	
	              case "pc":
	                return 72 * value / 12;
	
	              default:
	                return value;
	            }
	        }
	        exports.match = matchQuery, exports.parse = parseQuery;
	        var RE_MEDIA_QUERY = /(?:(only|not)?\s*([^\s\(\)]+)(?:\s*and)?\s*)?(.+)?/i, RE_MQ_EXPRESSION = /\(\s*([^\s\:\)]+)\s*(?:\:\s*([^\s\)]+))?\s*\)/, RE_MQ_FEATURE = /^(?:(min|max)-)?(.+)/, RE_LENGTH_UNIT = /(em|rem|px|cm|mm|in|pt|pc)?$/, RE_RESOLUTION_UNIT = /(dpi|dpcm|dppx)?$/;
	    }, function(module, exports, __webpack_require__) {
	        "use strict";
	        function shallowEqualObjects(objA, objB) {
	            if (objA === objB) return !0;
	            if (!objA || !objB) return !1;
	            var aKeys = Object.keys(objA), bKeys = Object.keys(objB), len = aKeys.length;
	            if (bKeys.length !== len) return !1;
	            for (var i = 0; i < len; i++) {
	                var key = aKeys[i];
	                if (objA[key] !== objB[key]) return !1;
	            }
	            return !0;
	        }
	        module.exports = shallowEqualObjects;
	    }, function(module, __webpack_exports__, __webpack_require__) {
	        "use strict";
	        var __WEBPACK_IMPORTED_MODULE_0_hyphenate_style_name__ = __webpack_require__(2), __WEBPACK_IMPORTED_MODULE_1__mediaQuery__ = __webpack_require__(11), negate = function(cond) {
	            return "not ".concat(cond);
	        }, keyVal = function(k, v) {
	            var realKey = Object(__WEBPACK_IMPORTED_MODULE_0_hyphenate_style_name__.a)(k);
	            return "number" == typeof v && (v = "".concat(v, "px")), !0 === v ? realKey : !1 === v ? negate(realKey) : "(".concat(realKey, ": ").concat(v, ")");
	        }, join = function(conds) {
	            return conds.join(" and ");
	        };
	        __webpack_exports__.a = function(obj) {
	            var rules = [];
	            return Object.keys(__WEBPACK_IMPORTED_MODULE_1__mediaQuery__.a.all).forEach(function(k) {
	                var v = obj[k];
	                null != v && rules.push(keyVal(k, v));
	            }), join(rules);
	        };
	    }, function(module, __webpack_exports__, __webpack_require__) {
	        "use strict";
	        function ownKeys(object, enumerableOnly) {
	            var keys = Object.keys(object);
	            if (Object.getOwnPropertySymbols) {
	                var symbols = Object.getOwnPropertySymbols(object);
	                enumerableOnly && (symbols = symbols.filter(function(sym) {
	                    return Object.getOwnPropertyDescriptor(object, sym).enumerable;
	                })), keys.push.apply(keys, symbols);
	            }
	            return keys;
	        }
	        function _objectSpread(target) {
	            for (var i = 1; i < arguments.length; i++) {
	                var source = null != arguments[i] ? arguments[i] : {};
	                i % 2 ? ownKeys(source, !0).forEach(function(key) {
	                    _defineProperty(target, key, source[key]);
	                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(source).forEach(function(key) {
	                    Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
	                });
	            }
	            return target;
	        }
	        function _defineProperty(obj, key, value) {
	            return key in obj ? Object.defineProperty(obj, key, {
	                value: value,
	                enumerable: !0,
	                configurable: !0,
	                writable: !0
	            }) : obj[key] = value, obj;
	        }
	        var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(12), __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__), stringOrNumber = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([ __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number ]), matchers = {
	            orientation: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf([ "portrait", "landscape" ]),
	            scan: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf([ "progressive", "interlace" ]),
	            aspectRatio: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
	            deviceAspectRatio: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
	            height: stringOrNumber,
	            deviceHeight: stringOrNumber,
	            width: stringOrNumber,
	            deviceWidth: stringOrNumber,
	            color: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
	            colorIndex: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
	            monochrome: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
	            resolution: stringOrNumber
	        }, features = _objectSpread({
	            minAspectRatio: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
	            maxAspectRatio: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
	            minDeviceAspectRatio: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
	            maxDeviceAspectRatio: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
	            minHeight: stringOrNumber,
	            maxHeight: stringOrNumber,
	            minDeviceHeight: stringOrNumber,
	            maxDeviceHeight: stringOrNumber,
	            minWidth: stringOrNumber,
	            maxWidth: stringOrNumber,
	            minDeviceWidth: stringOrNumber,
	            maxDeviceWidth: stringOrNumber,
	            minColor: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
	            maxColor: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
	            minColorIndex: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
	            maxColorIndex: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
	            minMonochrome: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
	            maxMonochrome: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
	            minResolution: stringOrNumber,
	            maxResolution: stringOrNumber
	        }, matchers), types = {
	            all: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
	            grid: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
	            aural: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
	            braille: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
	            handheld: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
	            print: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
	            projection: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
	            screen: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
	            tty: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
	            tv: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
	            embossed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool
	        }, all = _objectSpread({}, types, {}, features);
	        matchers.type = Object.keys(types), __webpack_exports__.a = {
	            all: all,
	            types: types,
	            matchers: matchers,
	            features: features
	        };
	    }, function(module, exports, __webpack_require__) {
	        var ReactIs = __webpack_require__(3);
	        module.exports = __webpack_require__(14)(ReactIs.isElement, !0);
	    }, function(module, exports, __webpack_require__) {
	        "use strict";
	        !function() {
	            function isValidElementType(type) {
	                return "string" == typeof type || "function" == typeof type || type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || "object" == typeof type && null !== type && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE);
	            }
	            function typeOf(object) {
	                if ("object" == typeof object && null !== object) {
	                    var $$typeof = object.$$typeof;
	                    switch ($$typeof) {
	                      case REACT_ELEMENT_TYPE:
	                        var type = object.type;
	                        switch (type) {
	                          case REACT_ASYNC_MODE_TYPE:
	                          case REACT_CONCURRENT_MODE_TYPE:
	                          case REACT_FRAGMENT_TYPE:
	                          case REACT_PROFILER_TYPE:
	                          case REACT_STRICT_MODE_TYPE:
	                          case REACT_SUSPENSE_TYPE:
	                            return type;
	
	                          default:
	                            var $$typeofType = type && type.$$typeof;
	                            switch ($$typeofType) {
	                              case REACT_CONTEXT_TYPE:
	                              case REACT_FORWARD_REF_TYPE:
	                              case REACT_PROVIDER_TYPE:
	                                return $$typeofType;
	
	                              default:
	                                return $$typeof;
	                            }
	                        }
	
	                      case REACT_LAZY_TYPE:
	                      case REACT_MEMO_TYPE:
	                      case REACT_PORTAL_TYPE:
	                        return $$typeof;
	                    }
	                }
	            }
	            function isAsyncMode(object) {
	                return hasWarnedAboutDeprecatedIsAsyncMode || (hasWarnedAboutDeprecatedIsAsyncMode = !0, 
	                lowPriorityWarning$1(!1, "The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), 
	                isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
	            }
	            function isConcurrentMode(object) {
	                return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
	            }
	            function isContextConsumer(object) {
	                return typeOf(object) === REACT_CONTEXT_TYPE;
	            }
	            function isContextProvider(object) {
	                return typeOf(object) === REACT_PROVIDER_TYPE;
	            }
	            function isElement(object) {
	                return "object" == typeof object && null !== object && object.$$typeof === REACT_ELEMENT_TYPE;
	            }
	            function isForwardRef(object) {
	                return typeOf(object) === REACT_FORWARD_REF_TYPE;
	            }
	            function isFragment(object) {
	                return typeOf(object) === REACT_FRAGMENT_TYPE;
	            }
	            function isLazy(object) {
	                return typeOf(object) === REACT_LAZY_TYPE;
	            }
	            function isMemo(object) {
	                return typeOf(object) === REACT_MEMO_TYPE;
	            }
	            function isPortal(object) {
	                return typeOf(object) === REACT_PORTAL_TYPE;
	            }
	            function isProfiler(object) {
	                return typeOf(object) === REACT_PROFILER_TYPE;
	            }
	            function isStrictMode(object) {
	                return typeOf(object) === REACT_STRICT_MODE_TYPE;
	            }
	            function isSuspense(object) {
	                return typeOf(object) === REACT_SUSPENSE_TYPE;
	            }
	            Object.defineProperty(exports, "__esModule", {
	                value: !0
	            });
	            var hasSymbol = "function" == typeof Symbol && Symbol.for, REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for("react.element") : 60103, REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 60106, REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for("react.fragment") : 60107, REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 60108, REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 60114, REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 60109, REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 60110, REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for("react.async_mode") : 60111, REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 60111, REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 60112, REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 60113, REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for("react.suspense_list") : 60120, REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 60115, REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 60116, REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for("react.fundamental") : 60117, REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for("react.responder") : 60118, lowPriorityWarning = function() {}, printWarning = function(format) {
	                for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) args[_key - 1] = arguments[_key];
	                var argIndex = 0, message = "Warning: " + format.replace(/%s/g, function() {
	                    return args[argIndex++];
	                });
	                "undefined" != typeof console && console.warn(message);
	                try {
	                    throw new Error(message);
	                } catch (x) {}
	            };
	            lowPriorityWarning = function(condition, format) {
	                if (void 0 === format) throw new Error("`lowPriorityWarning(condition, format, ...args)` requires a warning message argument");
	                if (!condition) {
	                    for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) args[_key2 - 2] = arguments[_key2];
	                    printWarning.apply(void 0, [ format ].concat(args));
	                }
	            };
	            var lowPriorityWarning$1 = lowPriorityWarning, AsyncMode = REACT_ASYNC_MODE_TYPE, ConcurrentMode = REACT_CONCURRENT_MODE_TYPE, ContextConsumer = REACT_CONTEXT_TYPE, ContextProvider = REACT_PROVIDER_TYPE, Element = REACT_ELEMENT_TYPE, ForwardRef = REACT_FORWARD_REF_TYPE, Fragment = REACT_FRAGMENT_TYPE, Lazy = REACT_LAZY_TYPE, Memo = REACT_MEMO_TYPE, Portal = REACT_PORTAL_TYPE, Profiler = REACT_PROFILER_TYPE, StrictMode = REACT_STRICT_MODE_TYPE, Suspense = REACT_SUSPENSE_TYPE, hasWarnedAboutDeprecatedIsAsyncMode = !1;
	            exports.typeOf = typeOf, exports.AsyncMode = AsyncMode, exports.ConcurrentMode = ConcurrentMode, 
	            exports.ContextConsumer = ContextConsumer, exports.ContextProvider = ContextProvider, 
	            exports.Element = Element, exports.ForwardRef = ForwardRef, exports.Fragment = Fragment, 
	            exports.Lazy = Lazy, exports.Memo = Memo, exports.Portal = Portal, exports.Profiler = Profiler, 
	            exports.StrictMode = StrictMode, exports.Suspense = Suspense, exports.isValidElementType = isValidElementType, 
	            exports.isAsyncMode = isAsyncMode, exports.isConcurrentMode = isConcurrentMode, 
	            exports.isContextConsumer = isContextConsumer, exports.isContextProvider = isContextProvider, 
	            exports.isElement = isElement, exports.isForwardRef = isForwardRef, exports.isFragment = isFragment, 
	            exports.isLazy = isLazy, exports.isMemo = isMemo, exports.isPortal = isPortal, exports.isProfiler = isProfiler, 
	            exports.isStrictMode = isStrictMode, exports.isSuspense = isSuspense;
	        }();
	    }, function(module, exports, __webpack_require__) {
	        "use strict";
	        function emptyFunctionThatReturnsNull() {
	            return null;
	        }
	        var ReactIs = __webpack_require__(3), assign = __webpack_require__(15), ReactPropTypesSecret = __webpack_require__(4), checkPropTypes = __webpack_require__(16), has = Function.call.bind(Object.prototype.hasOwnProperty), printWarning = function() {};
	        printWarning = function(text) {
	            var message = "Warning: " + text;
	            "undefined" != typeof console && console.error(message);
	            try {
	                throw new Error(message);
	            } catch (x) {}
	        }, module.exports = function(isValidElement, throwOnDirectAccess) {
	            function getIteratorFn(maybeIterable) {
	                var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	                if ("function" == typeof iteratorFn) return iteratorFn;
	            }
	            function is(x, y) {
	                return x === y ? 0 !== x || 1 / x == 1 / y : x !== x && y !== y;
	            }
	            function PropTypeError(message) {
	                this.message = message, this.stack = "";
	            }
	            function createChainableTypeChecker(validate) {
	                function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	                    if (componentName = componentName || ANONYMOUS, propFullName = propFullName || propName, 
	                    secret !== ReactPropTypesSecret) {
	                        if (throwOnDirectAccess) {
	                            var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
	                            throw err.name = "Invariant Violation", err;
	                        }
	                        if ("undefined" != typeof console) {
	                            var cacheKey = componentName + ":" + propName;
	                            !manualPropTypeCallCache[cacheKey] && manualPropTypeWarningCount < 3 && (printWarning("You are manually calling a React.PropTypes validation function for the `" + propFullName + "` prop on `" + componentName + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."), 
	                            manualPropTypeCallCache[cacheKey] = !0, manualPropTypeWarningCount++);
	                        }
	                    }
	                    return null == props[propName] ? isRequired ? new PropTypeError(null === props[propName] ? "The " + location + " `" + propFullName + "` is marked as required in `" + componentName + "`, but its value is `null`." : "The " + location + " `" + propFullName + "` is marked as required in `" + componentName + "`, but its value is `undefined`.") : null : validate(props, propName, componentName, location, propFullName);
	                }
	                var manualPropTypeCallCache = {}, manualPropTypeWarningCount = 0, chainedCheckType = checkType.bind(null, !1);
	                return chainedCheckType.isRequired = checkType.bind(null, !0), chainedCheckType;
	            }
	            function createPrimitiveTypeChecker(expectedType) {
	                function validate(props, propName, componentName, location, propFullName, secret) {
	                    var propValue = props[propName];
	                    if (getPropType(propValue) !== expectedType) return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + getPreciseType(propValue) + "` supplied to `" + componentName + "`, expected `" + expectedType + "`.");
	                    return null;
	                }
	                return createChainableTypeChecker(validate);
	            }
	            function createArrayOfTypeChecker(typeChecker) {
	                function validate(props, propName, componentName, location, propFullName) {
	                    if ("function" != typeof typeChecker) return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
	                    var propValue = props[propName];
	                    if (!Array.isArray(propValue)) {
	                        return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + getPropType(propValue) + "` supplied to `" + componentName + "`, expected an array.");
	                    }
	                    for (var i = 0; i < propValue.length; i++) {
	                        var error = typeChecker(propValue, i, componentName, location, propFullName + "[" + i + "]", ReactPropTypesSecret);
	                        if (error instanceof Error) return error;
	                    }
	                    return null;
	                }
	                return createChainableTypeChecker(validate);
	            }
	            function createInstanceTypeChecker(expectedClass) {
	                function validate(props, propName, componentName, location, propFullName) {
	                    if (!(props[propName] instanceof expectedClass)) {
	                        var expectedClassName = expectedClass.name || ANONYMOUS;
	                        return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + getClassName(props[propName]) + "` supplied to `" + componentName + "`, expected instance of `" + expectedClassName + "`.");
	                    }
	                    return null;
	                }
	                return createChainableTypeChecker(validate);
	            }
	            function createEnumTypeChecker(expectedValues) {
	                function validate(props, propName, componentName, location, propFullName) {
	                    for (var propValue = props[propName], i = 0; i < expectedValues.length; i++) if (is(propValue, expectedValues[i])) return null;
	                    var valuesString = JSON.stringify(expectedValues, function(key, value) {
	                        return "symbol" === getPreciseType(value) ? String(value) : value;
	                    });
	                    return new PropTypeError("Invalid " + location + " `" + propFullName + "` of value `" + String(propValue) + "` supplied to `" + componentName + "`, expected one of " + valuesString + ".");
	                }
	                return Array.isArray(expectedValues) ? createChainableTypeChecker(validate) : (printWarning(arguments.length > 1 ? "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])." : "Invalid argument supplied to oneOf, expected an array."), 
	                emptyFunctionThatReturnsNull);
	            }
	            function createObjectOfTypeChecker(typeChecker) {
	                function validate(props, propName, componentName, location, propFullName) {
	                    if ("function" != typeof typeChecker) return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
	                    var propValue = props[propName], propType = getPropType(propValue);
	                    if ("object" !== propType) return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` supplied to `" + componentName + "`, expected an object.");
	                    for (var key in propValue) if (has(propValue, key)) {
	                        var error = typeChecker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
	                        if (error instanceof Error) return error;
	                    }
	                    return null;
	                }
	                return createChainableTypeChecker(validate);
	            }
	            function createUnionTypeChecker(arrayOfTypeCheckers) {
	                function validate(props, propName, componentName, location, propFullName) {
	                    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	                        if (null == (0, arrayOfTypeCheckers[i])(props, propName, componentName, location, propFullName, ReactPropTypesSecret)) return null;
	                    }
	                    return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to `" + componentName + "`.");
	                }
	                if (!Array.isArray(arrayOfTypeCheckers)) return printWarning("Invalid argument supplied to oneOfType, expected an instance of array."), 
	                emptyFunctionThatReturnsNull;
	                for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	                    var checker = arrayOfTypeCheckers[i];
	                    if ("function" != typeof checker) return printWarning("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + " at index " + i + "."), 
	                    emptyFunctionThatReturnsNull;
	                }
	                return createChainableTypeChecker(validate);
	            }
	            function createShapeTypeChecker(shapeTypes) {
	                function validate(props, propName, componentName, location, propFullName) {
	                    var propValue = props[propName], propType = getPropType(propValue);
	                    if ("object" !== propType) return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` supplied to `" + componentName + "`, expected `object`.");
	                    for (var key in shapeTypes) {
	                        var checker = shapeTypes[key];
	                        if (checker) {
	                            var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
	                            if (error) return error;
	                        }
	                    }
	                    return null;
	                }
	                return createChainableTypeChecker(validate);
	            }
	            function createStrictShapeTypeChecker(shapeTypes) {
	                function validate(props, propName, componentName, location, propFullName) {
	                    var propValue = props[propName], propType = getPropType(propValue);
	                    if ("object" !== propType) return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` supplied to `" + componentName + "`, expected `object`.");
	                    var allKeys = assign({}, props[propName], shapeTypes);
	                    for (var key in allKeys) {
	                        var checker = shapeTypes[key];
	                        if (!checker) return new PropTypeError("Invalid " + location + " `" + propFullName + "` key `" + key + "` supplied to `" + componentName + "`.\nBad object: " + JSON.stringify(props[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  "));
	                        var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
	                        if (error) return error;
	                    }
	                    return null;
	                }
	                return createChainableTypeChecker(validate);
	            }
	            function isNode(propValue) {
	                switch (typeof propValue) {
	                  case "number":
	                  case "string":
	                  case "undefined":
	                    return !0;
	
	                  case "boolean":
	                    return !propValue;
	
	                  case "object":
	                    if (Array.isArray(propValue)) return propValue.every(isNode);
	                    if (null === propValue || isValidElement(propValue)) return !0;
	                    var iteratorFn = getIteratorFn(propValue);
	                    if (!iteratorFn) return !1;
	                    var step, iterator = iteratorFn.call(propValue);
	                    if (iteratorFn !== propValue.entries) {
	                        for (;!(step = iterator.next()).done; ) if (!isNode(step.value)) return !1;
	                    } else for (;!(step = iterator.next()).done; ) {
	                        var entry = step.value;
	                        if (entry && !isNode(entry[1])) return !1;
	                    }
	                    return !0;
	
	                  default:
	                    return !1;
	                }
	            }
	            function isSymbol(propType, propValue) {
	                return "symbol" === propType || !!propValue && ("Symbol" === propValue["@@toStringTag"] || "function" == typeof Symbol && propValue instanceof Symbol);
	            }
	            function getPropType(propValue) {
	                var propType = typeof propValue;
	                return Array.isArray(propValue) ? "array" : propValue instanceof RegExp ? "object" : isSymbol(propType, propValue) ? "symbol" : propType;
	            }
	            function getPreciseType(propValue) {
	                if (void 0 === propValue || null === propValue) return "" + propValue;
	                var propType = getPropType(propValue);
	                if ("object" === propType) {
	                    if (propValue instanceof Date) return "date";
	                    if (propValue instanceof RegExp) return "regexp";
	                }
	                return propType;
	            }
	            function getPostfixForTypeWarning(value) {
	                var type = getPreciseType(value);
	                switch (type) {
	                  case "array":
	                  case "object":
	                    return "an " + type;
	
	                  case "boolean":
	                  case "date":
	                  case "regexp":
	                    return "a " + type;
	
	                  default:
	                    return type;
	                }
	            }
	            function getClassName(propValue) {
	                return propValue.constructor && propValue.constructor.name ? propValue.constructor.name : ANONYMOUS;
	            }
	            var ITERATOR_SYMBOL = "function" == typeof Symbol && Symbol.iterator, FAUX_ITERATOR_SYMBOL = "@@iterator", ANONYMOUS = "<<anonymous>>", ReactPropTypes = {
	                array: createPrimitiveTypeChecker("array"),
	                bool: createPrimitiveTypeChecker("boolean"),
	                func: createPrimitiveTypeChecker("function"),
	                number: createPrimitiveTypeChecker("number"),
	                object: createPrimitiveTypeChecker("object"),
	                string: createPrimitiveTypeChecker("string"),
	                symbol: createPrimitiveTypeChecker("symbol"),
	                any: function() {
	                    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
	                }(),
	                arrayOf: createArrayOfTypeChecker,
	                element: function() {
	                    function validate(props, propName, componentName, location, propFullName) {
	                        var propValue = props[propName];
	                        if (!isValidElement(propValue)) {
	                            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + getPropType(propValue) + "` supplied to `" + componentName + "`, expected a single ReactElement.");
	                        }
	                        return null;
	                    }
	                    return createChainableTypeChecker(validate);
	                }(),
	                elementType: function() {
	                    function validate(props, propName, componentName, location, propFullName) {
	                        var propValue = props[propName];
	                        if (!ReactIs.isValidElementType(propValue)) {
	                            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + getPropType(propValue) + "` supplied to `" + componentName + "`, expected a single ReactElement type.");
	                        }
	                        return null;
	                    }
	                    return createChainableTypeChecker(validate);
	                }(),
	                instanceOf: createInstanceTypeChecker,
	                node: function() {
	                    function validate(props, propName, componentName, location, propFullName) {
	                        return isNode(props[propName]) ? null : new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to `" + componentName + "`, expected a ReactNode.");
	                    }
	                    return createChainableTypeChecker(validate);
	                }(),
	                objectOf: createObjectOfTypeChecker,
	                oneOf: createEnumTypeChecker,
	                oneOfType: createUnionTypeChecker,
	                shape: createShapeTypeChecker,
	                exact: createStrictShapeTypeChecker
	            };
	            return PropTypeError.prototype = Error.prototype, ReactPropTypes.checkPropTypes = checkPropTypes, 
	            ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache, ReactPropTypes.PropTypes = ReactPropTypes, 
	            ReactPropTypes;
	        };
	    }, function(module, exports, __webpack_require__) {
	        "use strict";
	        function toObject(val) {
	            if (null === val || void 0 === val) throw new TypeError("Object.assign cannot be called with null or undefined");
	            return Object(val);
	        }
	        /*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	        var getOwnPropertySymbols = Object.getOwnPropertySymbols, hasOwnProperty = Object.prototype.hasOwnProperty, propIsEnumerable = Object.prototype.propertyIsEnumerable;
	        module.exports = function() {
	            try {
	                if (!Object.assign) return !1;
	                var test1 = new String("abc");
	                if (test1[5] = "de", "5" === Object.getOwnPropertyNames(test1)[0]) return !1;
	                for (var test2 = {}, i = 0; i < 10; i++) test2["_" + String.fromCharCode(i)] = i;
	                if ("0123456789" !== Object.getOwnPropertyNames(test2).map(function(n) {
	                    return test2[n];
	                }).join("")) return !1;
	                var test3 = {};
	                return "abcdefghijklmnopqrst".split("").forEach(function(letter) {
	                    test3[letter] = letter;
	                }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, test3)).join("");
	            } catch (err) {
	                return !1;
	            }
	        }() ? Object.assign : function(target, source) {
	            for (var from, symbols, to = toObject(target), s = 1; s < arguments.length; s++) {
	                from = Object(arguments[s]);
	                for (var key in from) hasOwnProperty.call(from, key) && (to[key] = from[key]);
	                if (getOwnPropertySymbols) {
	                    symbols = getOwnPropertySymbols(from);
	                    for (var i = 0; i < symbols.length; i++) propIsEnumerable.call(from, symbols[i]) && (to[symbols[i]] = from[symbols[i]]);
	                }
	            }
	            return to;
	        };
	    }, function(module, exports, __webpack_require__) {
	        "use strict";
	        function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	            for (var typeSpecName in typeSpecs) if (has(typeSpecs, typeSpecName)) {
	                var error;
	                try {
	                    if ("function" != typeof typeSpecs[typeSpecName]) {
	                        var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.");
	                        throw err.name = "Invariant Violation", err;
	                    }
	                    error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	                } catch (ex) {
	                    error = ex;
	                }
	                if (!error || error instanceof Error || printWarning((componentName || "React class") + ": type specification of " + location + " `" + typeSpecName + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof error + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."), 
	                error instanceof Error && !(error.message in loggedTypeFailures)) {
	                    loggedTypeFailures[error.message] = !0;
	                    var stack = getStack ? getStack() : "";
	                    printWarning("Failed " + location + " type: " + error.message + (null != stack ? stack : ""));
	                }
	            }
	        }
	        var printWarning = function() {}, ReactPropTypesSecret = __webpack_require__(4), loggedTypeFailures = {}, has = Function.call.bind(Object.prototype.hasOwnProperty);
	        printWarning = function(text) {
	            var message = "Warning: " + text;
	            "undefined" != typeof console && console.error(message);
	            try {
	                throw new Error(message);
	            } catch (x) {}
	        }, checkPropTypes.resetWarningCache = function() {
	            loggedTypeFailures = {};
	        }, module.exports = checkPropTypes;
	    }, function(module, __webpack_exports__, __webpack_require__) {
	        "use strict";
	        function _objectWithoutProperties(source, excluded) {
	            if (null == source) return {};
	            var key, i, target = _objectWithoutPropertiesLoose(source, excluded);
	            if (Object.getOwnPropertySymbols) {
	                var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
	                for (i = 0; i < sourceSymbolKeys.length; i++) key = sourceSymbolKeys[i], excluded.indexOf(key) >= 0 || Object.prototype.propertyIsEnumerable.call(source, key) && (target[key] = source[key]);
	            }
	            return target;
	        }
	        function _objectWithoutPropertiesLoose(source, excluded) {
	            if (null == source) return {};
	            var key, i, target = {}, sourceKeys = Object.keys(source);
	            for (i = 0; i < sourceKeys.length; i++) key = sourceKeys[i], excluded.indexOf(key) >= 0 || (target[key] = source[key]);
	            return target;
	        }
	        function MediaQuery(_ref) {
	            var children = _ref.children, device = _ref.device, onChange = _ref.onChange, settings = _objectWithoutProperties(_ref, [ "children", "device", "onChange" ]), matches = Object(__WEBPACK_IMPORTED_MODULE_0__useMediaQuery__.a)(settings, device, onChange);
	            return "function" == typeof children ? children(matches) : matches ? children : null;
	        }
	        __webpack_exports__.a = MediaQuery;
	        var __WEBPACK_IMPORTED_MODULE_0__useMediaQuery__ = __webpack_require__(0);
	    } ]);
	});
	//# sourceMappingURL=react-responsive.js.map

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(24);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _Link = __webpack_require__(194);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexLink> is used to link to an <IndexRoute>.
	 */
	var IndexLink = (0, _createReactClass2.default)({
	  displayName: 'IndexLink',
	
	  render: function render() {
	    return _react2.default.createElement(_Link2.default, _extends({}, this.props, { onlyActiveOnIndex: true }));
	  }
	});
	
	exports.default = IndexLink;
	module.exports = exports['default'];

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(24);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(1);
	
	var _routerWarning = __webpack_require__(47);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(14);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Redirect = __webpack_require__(196);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	var _InternalPropTypes = __webpack_require__(64);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexRedirect> is used to redirect from an indexRoute.
	 */
	/* eslint-disable react/require-render-return */
	var IndexRedirect = (0, _createReactClass2.default)({
	  displayName: 'IndexRedirect',
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = _Redirect2.default.createRouteFromReactElement(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    to: _propTypes.string.isRequired,
	    query: _propTypes.object,
	    state: _propTypes.object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRedirect;
	module.exports = exports['default'];

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(24);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(1);
	
	var _routerWarning = __webpack_require__(47);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(14);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(31);
	
	var _InternalPropTypes = __webpack_require__(64);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
	 * a JSX route config.
	 */
	/* eslint-disable react/require-render-return */
	var IndexRoute = (0, _createReactClass2.default)({
	  displayName: 'IndexRoute',
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = (0, _RouteUtils.createRouteFromReactElement)(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    path: _InternalPropTypes.falsy,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: _propTypes.func,
	    getComponents: _propTypes.func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRoute;
	module.exports = exports['default'];

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(24);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(1);
	
	var _invariant = __webpack_require__(14);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(31);
	
	var _InternalPropTypes = __webpack_require__(64);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A <Route> is used to declare which components are rendered to the
	 * page when the URL matches a given pattern.
	 *
	 * Routes are arranged in a nested tree structure. When a new URL is
	 * requested, the tree is searched depth-first to find a route whose
	 * path matches the URL.  When one is found, all routes in the tree
	 * that lead to it are considered "active" and their components are
	 * rendered into the DOM, nested in the same order as in the tree.
	 */
	/* eslint-disable react/require-render-return */
	var Route = (0, _createReactClass2.default)({
	  displayName: 'Route',
	
	  statics: {
	    createRouteFromReactElement: _RouteUtils.createRouteFromReactElement
	  },
	
	  propTypes: {
	    path: _propTypes.string,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: _propTypes.func,
	    getComponents: _propTypes.func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Route> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Route;
	module.exports = exports['default'];

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(14);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(24);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(1);
	
	var _createTransitionManager2 = __webpack_require__(200);
	
	var _createTransitionManager3 = _interopRequireDefault(_createTransitionManager2);
	
	var _InternalPropTypes = __webpack_require__(64);
	
	var _RouterContext = __webpack_require__(128);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _RouteUtils = __webpack_require__(31);
	
	var _RouterUtils = __webpack_require__(197);
	
	var _routerWarning = __webpack_require__(47);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var propTypes = {
	  history: _propTypes.object,
	  children: _InternalPropTypes.routes,
	  routes: _InternalPropTypes.routes, // alias for children
	  render: _propTypes.func,
	  createElement: _propTypes.func,
	  onError: _propTypes.func,
	  onUpdate: _propTypes.func,
	
	  // PRIVATE: For client-side rehydration of server match.
	  matchContext: _propTypes.object
	};
	
	var prefixUnsafeLifecycleMethods = parseFloat(_react2.default.version) >= 16.3;
	
	/**
	 * A <Router> is a high-level API for automatically setting up
	 * a router that renders a <RouterContext> with all the props
	 * it needs each time the URL changes.
	 */
	var Router = (0, _createReactClass2.default)({
	  displayName: 'Router',
	
	  propTypes: propTypes,
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      render: function render(props) {
	        return _react2.default.createElement(_RouterContext2.default, props);
	      }
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      location: null,
	      routes: null,
	      params: null,
	      components: null
	    };
	  },
	  handleError: function handleError(error) {
	    if (this.props.onError) {
	      this.props.onError.call(this, error);
	    } else {
	      // Throw errors by default so we don't silently swallow them!
	      throw error; // This error probably occurred in getChildRoutes or getComponents.
	    }
	  },
	  createRouterObject: function createRouterObject(state) {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext.router;
	    }
	
	    var history = this.props.history;
	
	    return (0, _RouterUtils.createRouterObject)(history, this.transitionManager, state);
	  },
	  createTransitionManager: function createTransitionManager() {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext.transitionManager;
	    }
	
	    var history = this.props.history;
	    var _props = this.props,
	        routes = _props.routes,
	        children = _props.children;
	
	
	    !history.getCurrentLocation ?  false ? (0, _invariant2.default)(false, 'You have provided a history object created with history v4.x or v2.x ' + 'and earlier. This version of React Router is only compatible with v3 ' + 'history objects. Please change to history v3.x.') : (0, _invariant2.default)(false) : void 0;
	
	    return (0, _createTransitionManager3.default)(history, (0, _RouteUtils.createRoutes)(routes || children));
	  },
	
	
	  // this method will be updated to UNSAFE_componentWillMount below for React versions >= 16.3
	  componentWillMount: function componentWillMount() {
	    var _this = this;
	
	    this.transitionManager = this.createTransitionManager();
	    this.router = this.createRouterObject(this.state);
	
	    this._unlisten = this.transitionManager.listen(function (error, state) {
	      if (error) {
	        _this.handleError(error);
	      } else {
	        // Keep the identity of this.router because of a caveat in ContextUtils:
	        // they only work if the object identity is preserved.
	        (0, _RouterUtils.assignRouterState)(_this.router, state);
	        _this.setState(state, _this.props.onUpdate);
	      }
	    });
	  },
	
	
	  // this method will be updated to UNSAFE_componentWillReceiveProps below for React versions >= 16.3
	  /* istanbul ignore next: sanity check */
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	     false ? (0, _routerWarning2.default)(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;
	
	     false ? (0, _routerWarning2.default)((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlisten) this._unlisten();
	  },
	  render: function render() {
	    var _state = this.state,
	        location = _state.location,
	        routes = _state.routes,
	        params = _state.params,
	        components = _state.components;
	
	    var _props2 = this.props,
	        createElement = _props2.createElement,
	        render = _props2.render,
	        props = _objectWithoutProperties(_props2, ['createElement', 'render']);
	
	    if (location == null) return null; // Async match
	
	    // Only forward non-Router-specific props to routing context, as those are
	    // the only ones that might be custom routing context props.
	    Object.keys(propTypes).forEach(function (propType) {
	      return delete props[propType];
	    });
	
	    return render(_extends({}, props, {
	      router: this.router,
	      location: location,
	      routes: routes,
	      params: params,
	      components: components,
	      createElement: createElement
	    }));
	  }
	});
	
	if (prefixUnsafeLifecycleMethods) {
	  Router.prototype.UNSAFE_componentWillReceiveProps = Router.prototype.componentWillReceiveProps;
	  Router.prototype.UNSAFE_componentWillMount = Router.prototype.componentWillMount;
	  delete Router.prototype.componentWillReceiveProps;
	  delete Router.prototype.componentWillMount;
	}
	
	exports.default = Router;
	module.exports = exports['default'];

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = getTransitionUtils;
	
	var _AsyncUtils = __webpack_require__(125);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PendingHooks = function PendingHooks() {
	  var _this = this;
	
	  _classCallCheck(this, PendingHooks);
	
	  this.hooks = [];
	
	  this.add = function (hook) {
	    return _this.hooks.push(hook);
	  };
	
	  this.remove = function (hook) {
	    return _this.hooks = _this.hooks.filter(function (h) {
	      return h !== hook;
	    });
	  };
	
	  this.has = function (hook) {
	    return _this.hooks.indexOf(hook) !== -1;
	  };
	
	  this.clear = function () {
	    return _this.hooks = [];
	  };
	};
	
	function getTransitionUtils() {
	  var enterHooks = new PendingHooks();
	  var changeHooks = new PendingHooks();
	
	  function createTransitionHook(hook, route, asyncArity, pendingHooks) {
	    var isSync = hook.length < asyncArity;
	
	    var transitionHook = function transitionHook() {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      hook.apply(route, args);
	
	      if (isSync) {
	        var callback = args[args.length - 1];
	        // Assume hook executes synchronously and
	        // automatically call the callback.
	        callback();
	      }
	    };
	
	    pendingHooks.add(transitionHook);
	
	    return transitionHook;
	  }
	
	  function getEnterHooks(routes) {
	    return routes.reduce(function (hooks, route) {
	      if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3, enterHooks));
	      return hooks;
	    }, []);
	  }
	
	  function getChangeHooks(routes) {
	    return routes.reduce(function (hooks, route) {
	      if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4, changeHooks));
	      return hooks;
	    }, []);
	  }
	
	  function runTransitionHooks(length, iter, callback) {
	    if (!length) {
	      callback();
	      return;
	    }
	
	    var redirectInfo = void 0;
	    function replace(location) {
	      redirectInfo = location;
	    }
	
	    (0, _AsyncUtils.loopAsync)(length, function (index, next, done) {
	      iter(index, replace, function (error) {
	        if (error || redirectInfo) {
	          done(error, redirectInfo); // No need to continue.
	        } else {
	          next();
	        }
	      });
	    }, callback);
	  }
	
	  /**
	   * Runs all onEnter hooks in the given array of routes in order
	   * with onEnter(nextState, replace, callback) and calls
	   * callback(error, redirectInfo) when finished. The first hook
	   * to use replace short-circuits the loop.
	   *
	   * If a hook needs to run asynchronously, it may use the callback
	   * function. However, doing so will cause the transition to pause,
	   * which could lead to a non-responsive UI if the hook is slow.
	   */
	  function runEnterHooks(routes, nextState, callback) {
	    enterHooks.clear();
	    var hooks = getEnterHooks(routes);
	    return runTransitionHooks(hooks.length, function (index, replace, next) {
	      var wrappedNext = function wrappedNext() {
	        if (enterHooks.has(hooks[index])) {
	          next.apply(undefined, arguments);
	          enterHooks.remove(hooks[index]);
	        }
	      };
	      hooks[index](nextState, replace, wrappedNext);
	    }, callback);
	  }
	
	  /**
	   * Runs all onChange hooks in the given array of routes in order
	   * with onChange(prevState, nextState, replace, callback) and calls
	   * callback(error, redirectInfo) when finished. The first hook
	   * to use replace short-circuits the loop.
	   *
	   * If a hook needs to run asynchronously, it may use the callback
	   * function. However, doing so will cause the transition to pause,
	   * which could lead to a non-responsive UI if the hook is slow.
	   */
	  function runChangeHooks(routes, state, nextState, callback) {
	    changeHooks.clear();
	    var hooks = getChangeHooks(routes);
	    return runTransitionHooks(hooks.length, function (index, replace, next) {
	      var wrappedNext = function wrappedNext() {
	        if (changeHooks.has(hooks[index])) {
	          next.apply(undefined, arguments);
	          changeHooks.remove(hooks[index]);
	        }
	      };
	      hooks[index](state, nextState, replace, wrappedNext);
	    }, callback);
	  }
	
	  /**
	   * Runs all onLeave hooks in the given array of routes in order.
	   */
	  function runLeaveHooks(routes, prevState) {
	    for (var i = 0, len = routes.length; i < len; ++i) {
	      if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
	    }
	  }
	
	  return {
	    runEnterHooks: runEnterHooks,
	    runChangeHooks: runChangeHooks,
	    runLeaveHooks: runLeaveHooks
	  };
	}
	module.exports = exports['default'];

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouterContext = __webpack_require__(128);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _routerWarning = __webpack_require__(47);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  if (false) {
	    middlewares.forEach(function (middleware, index) {
	      process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(middleware.renderRouterContext || middleware.renderRouteComponent, 'The middleware specified at index ' + index + ' does not appear to be ' + 'a valid React Router middleware.') : void 0;
	    });
	  }
	
	  var withContext = middlewares.map(function (middleware) {
	    return middleware.renderRouterContext;
	  }).filter(Boolean);
	  var withComponent = middlewares.map(function (middleware) {
	    return middleware.renderRouteComponent;
	  }).filter(Boolean);
	
	  var makeCreateElement = function makeCreateElement() {
	    var baseCreateElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _react.createElement;
	    return function (Component, props) {
	      return withComponent.reduceRight(function (previous, renderRouteComponent) {
	        return renderRouteComponent(previous, props);
	      }, baseCreateElement(Component, props));
	    };
	  };
	
	  return function (renderProps) {
	    return withContext.reduceRight(function (previous, renderRouterContext) {
	      return renderRouterContext(previous, renderProps);
	    }, _react2.default.createElement(_RouterContext2.default, _extends({}, renderProps, {
	      createElement: makeCreateElement(renderProps.createElement)
	    })));
	  };
	};
	
	module.exports = exports['default'];

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createBrowserHistory = __webpack_require__(392);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _createRouterHistory = __webpack_require__(199);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createBrowserHistory2.default);
	module.exports = exports['default'];

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(46);
	
	function routeParamsChanged(route, prevState, nextState) {
	  if (!route.path) return false;
	
	  var paramNames = (0, _PatternUtils.getParamNames)(route.path);
	
	  return paramNames.some(function (paramName) {
	    return prevState.params[paramName] !== nextState.params[paramName];
	  });
	}
	
	/**
	 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
	 * the change from prevState to nextState. We leave routes if either
	 * 1) they are not in the next state or 2) they are in the next state
	 * but their params have changed (i.e. /users/123 => /users/456).
	 *
	 * leaveRoutes are ordered starting at the leaf route of the tree
	 * we're leaving up to the common parent route. enterRoutes are ordered
	 * from the top of the tree we're entering down to the leaf route.
	 *
	 * changeRoutes are any routes that didn't leave or enter during
	 * the transition.
	 */
	function computeChangedRoutes(prevState, nextState) {
	  var prevRoutes = prevState && prevState.routes;
	  var nextRoutes = nextState.routes;
	
	  var leaveRoutes = void 0,
	      changeRoutes = void 0,
	      enterRoutes = void 0;
	  if (prevRoutes) {
	    var parentIsLeaving = false;
	    leaveRoutes = prevRoutes.filter(function (route) {
	      if (parentIsLeaving) {
	        return true;
	      } else {
	        var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
	        if (isLeaving) parentIsLeaving = true;
	        return isLeaving;
	      }
	    });
	
	    // onLeave hooks start at the leaf route.
	    leaveRoutes.reverse();
	
	    enterRoutes = [];
	    changeRoutes = [];
	
	    nextRoutes.forEach(function (route) {
	      var isNew = prevRoutes.indexOf(route) === -1;
	      var paramsChanged = leaveRoutes.indexOf(route) !== -1;
	
	      if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
	    });
	  } else {
	    leaveRoutes = [];
	    changeRoutes = [];
	    enterRoutes = nextRoutes;
	  }
	
	  return {
	    leaveRoutes: leaveRoutes,
	    changeRoutes: changeRoutes,
	    enterRoutes: enterRoutes
	  };
	}
	
	exports.default = computeChangedRoutes;
	module.exports = exports['default'];

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(125);
	
	var _PromiseUtils = __webpack_require__(195);
	
	function getComponentsForRoute(nextState, route, callback) {
	  if (route.component || route.components) {
	    callback(null, route.component || route.components);
	    return;
	  }
	
	  var getComponent = route.getComponent || route.getComponents;
	  if (getComponent) {
	    var componentReturn = getComponent.call(route, nextState, callback);
	    if ((0, _PromiseUtils.isPromise)(componentReturn)) componentReturn.then(function (component) {
	      return callback(null, component);
	    }, callback);
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously fetches all components needed for the given router
	 * state and calls callback(error, components) when finished.
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getComponents method.
	 */
	function getComponents(nextState, callback) {
	  (0, _AsyncUtils.mapAsync)(nextState.routes, function (route, index, callback) {
	    getComponentsForRoute(nextState, route, callback);
	  }, callback);
	}
	
	exports.default = getComponents;
	module.exports = exports['default'];

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(46);
	
	/**
	 * Extracts an object of params the given route cares about from
	 * the given params object.
	 */
	function getRouteParams(route, params) {
	  var routeParams = {};
	
	  if (!route.path) return routeParams;
	
	  (0, _PatternUtils.getParamNames)(route.path).forEach(function (p) {
	    if (Object.prototype.hasOwnProperty.call(params, p)) {
	      routeParams[p] = params[p];
	    }
	  });
	
	  return routeParams;
	}
	
	exports.default = getRouteParams;
	module.exports = exports['default'];

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createHashHistory = __webpack_require__(393);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _createRouterHistory = __webpack_require__(199);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createHashHistory2.default);
	module.exports = exports['default'];

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = isActive;
	
	var _PatternUtils = __webpack_require__(46);
	
	function deepEqual(a, b) {
	  if (a == b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) {
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return deepEqual(item, b[index]);
	    });
	  }
	
	  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
	    for (var p in a) {
	      if (!Object.prototype.hasOwnProperty.call(a, p)) {
	        continue;
	      }
	
	      if (a[p] === undefined) {
	        if (b[p] !== undefined) {
	          return false;
	        }
	      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
	        return false;
	      } else if (!deepEqual(a[p], b[p])) {
	        return false;
	      }
	    }
	
	    return true;
	  }
	
	  return String(a) === String(b);
	}
	
	/**
	 * Returns true if the current pathname matches the supplied one, net of
	 * leading and trailing slash normalization. This is sufficient for an
	 * indexOnly route match.
	 */
	function pathIsActive(pathname, currentPathname) {
	  // Normalize leading slash for consistency. Leading slash on pathname has
	  // already been normalized in isActive. See caveat there.
	  if (currentPathname.charAt(0) !== '/') {
	    currentPathname = '/' + currentPathname;
	  }
	
	  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
	  // `/foo` as active, but in this case, we would already have failed the
	  // match.
	  if (pathname.charAt(pathname.length - 1) !== '/') {
	    pathname += '/';
	  }
	  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
	    currentPathname += '/';
	  }
	
	  return currentPathname === pathname;
	}
	
	/**
	 * Returns true if the given pathname matches the active routes and params.
	 */
	function routeIsActive(pathname, routes, params) {
	  var remainingPathname = pathname,
	      paramNames = [],
	      paramValues = [];
	
	  // for...of would work here but it's probably slower post-transpilation.
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    var route = routes[i];
	    var pattern = route.path || '';
	
	    if (pattern.charAt(0) === '/') {
	      remainingPathname = pathname;
	      paramNames = [];
	      paramValues = [];
	    }
	
	    if (remainingPathname !== null && pattern) {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	
	      if (remainingPathname === '') {
	        // We have an exact match on the route. Just check that all the params
	        // match.
	        // FIXME: This doesn't work on repeated params.
	        return paramNames.every(function (paramName, index) {
	          return String(paramValues[index]) === String(params[paramName]);
	        });
	      }
	    }
	  }
	
	  return false;
	}
	
	/**
	 * Returns true if all key/value pairs in the given query are
	 * currently active.
	 */
	function queryIsActive(query, activeQuery) {
	  if (activeQuery == null) return query == null;
	
	  if (query == null) return true;
	
	  return deepEqual(query, activeQuery);
	}
	
	/**
	 * Returns true if a <Link> to the given pathname/query combination is
	 * currently active.
	 */
	function isActive(_ref, indexOnly, currentLocation, routes, params) {
	  var pathname = _ref.pathname,
	      query = _ref.query;
	
	  if (currentLocation == null) return false;
	
	  // TODO: This is a bit ugly. It keeps around support for treating pathnames
	  // without preceding slashes as absolute paths, but possibly also works
	  // around the same quirks with basenames as in matchRoutes.
	  if (pathname.charAt(0) !== '/') {
	    pathname = '/' + pathname;
	  }
	
	  if (!pathIsActive(pathname, currentLocation.pathname)) {
	    // The path check is necessary and sufficient for indexOnly, but otherwise
	    // we still need to check the routes.
	    if (indexOnly || !routeIsActive(pathname, routes, params)) {
	      return false;
	    }
	  }
	
	  return queryIsActive(query, currentLocation.query);
	}
	module.exports = exports['default'];

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _Actions = __webpack_require__(83);
	
	var _invariant = __webpack_require__(14);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _createMemoryHistory = __webpack_require__(198);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	var _createTransitionManager = __webpack_require__(200);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _RouteUtils = __webpack_require__(31);
	
	var _RouterUtils = __webpack_require__(197);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A high-level API to be used for server-side rendering.
	 *
	 * This function matches a location to a set of routes and calls
	 * callback(error, redirectLocation, renderProps) when finished.
	 *
	 * Note: You probably don't want to use this in a browser unless you're using
	 * server-side rendering with async routes.
	 */
	function match(_ref, callback) {
	  var history = _ref.history,
	      routes = _ref.routes,
	      location = _ref.location,
	      options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);
	
	  !(history || location) ?  false ? (0, _invariant2.default)(false, 'match needs a history or a location') : (0, _invariant2.default)(false) : void 0;
	
	  history = history ? history : (0, _createMemoryHistory2.default)(options);
	  var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes));
	
	  if (location) {
	    // Allow match({ location: '/the/path', ... })
	    location = history.createLocation(location);
	  } else {
	    location = history.getCurrentLocation();
	  }
	
	  transitionManager.match(location, function (error, redirectLocation, nextState) {
	    var renderProps = void 0;
	
	    if (nextState) {
	      var router = (0, _RouterUtils.createRouterObject)(history, transitionManager, nextState);
	      renderProps = _extends({}, nextState, {
	        router: router,
	        matchContext: { transitionManager: transitionManager, router: router }
	      });
	    }
	
	    callback(error, redirectLocation && history.createLocation(redirectLocation, _Actions.REPLACE), renderProps);
	  });
	}
	
	exports.default = match;
	module.exports = exports['default'];

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = matchRoutes;
	
	var _AsyncUtils = __webpack_require__(125);
	
	var _PromiseUtils = __webpack_require__(195);
	
	var _PatternUtils = __webpack_require__(46);
	
	var _routerWarning = __webpack_require__(47);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _RouteUtils = __webpack_require__(31);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getChildRoutes(route, location, paramNames, paramValues, callback) {
	  if (route.childRoutes) {
	    return [null, route.childRoutes];
	  }
	  if (!route.getChildRoutes) {
	    return [];
	  }
	
	  var sync = true,
	      result = void 0;
	
	  var partialNextState = {
	    location: location,
	    params: createParams(paramNames, paramValues)
	  };
	
	  var childRoutesReturn = route.getChildRoutes(partialNextState, function (error, childRoutes) {
	    childRoutes = !error && (0, _RouteUtils.createRoutes)(childRoutes);
	    if (sync) {
	      result = [error, childRoutes];
	      return;
	    }
	
	    callback(error, childRoutes);
	  });
	
	  if ((0, _PromiseUtils.isPromise)(childRoutesReturn)) childRoutesReturn.then(function (childRoutes) {
	    return callback(null, (0, _RouteUtils.createRoutes)(childRoutes));
	  }, callback);
	
	  sync = false;
	  return result; // Might be undefined.
	}
	
	function getIndexRoute(route, location, paramNames, paramValues, callback) {
	  if (route.indexRoute) {
	    callback(null, route.indexRoute);
	  } else if (route.getIndexRoute) {
	    var partialNextState = {
	      location: location,
	      params: createParams(paramNames, paramValues)
	    };
	
	    var indexRoutesReturn = route.getIndexRoute(partialNextState, function (error, indexRoute) {
	      callback(error, !error && (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    });
	
	    if ((0, _PromiseUtils.isPromise)(indexRoutesReturn)) indexRoutesReturn.then(function (indexRoute) {
	      return callback(null, (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    }, callback);
	  } else if (route.childRoutes || route.getChildRoutes) {
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	        return;
	      }
	
	      var pathless = childRoutes.filter(function (childRoute) {
	        return !childRoute.path;
	      });
	
	      (0, _AsyncUtils.loopAsync)(pathless.length, function (index, next, done) {
	        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
	          if (error || indexRoute) {
	            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
	            done(error, routes);
	          } else {
	            next();
	          }
	        });
	      }, function (err, routes) {
	        callback(null, routes);
	      });
	    };
	
	    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	function assignParams(params, paramNames, paramValues) {
	  return paramNames.reduce(function (params, paramName, index) {
	    var paramValue = paramValues && paramValues[index];
	
	    if (Array.isArray(params[paramName])) {
	      params[paramName].push(paramValue);
	    } else if (paramName in params) {
	      params[paramName] = [params[paramName], paramValue];
	    } else {
	      params[paramName] = paramValue;
	    }
	
	    return params;
	  }, params);
	}
	
	function createParams(paramNames, paramValues) {
	  return assignParams({}, paramNames, paramValues);
	}
	
	function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
	  var pattern = route.path || '';
	
	  if (pattern.charAt(0) === '/') {
	    remainingPathname = location.pathname;
	    paramNames = [];
	    paramValues = [];
	  }
	
	  // Only try to match the path if the route actually has a pattern, and if
	  // we're not just searching for potential nested absolute paths.
	  if (remainingPathname !== null && pattern) {
	    try {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	    } catch (error) {
	      callback(error);
	    }
	
	    // By assumption, pattern is non-empty here, which is the prerequisite for
	    // actually terminating a match.
	    if (remainingPathname === '') {
	      var match = {
	        routes: [route],
	        params: createParams(paramNames, paramValues)
	      };
	
	      getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
	        if (error) {
	          callback(error);
	        } else {
	          if (Array.isArray(indexRoute)) {
	            var _match$routes;
	
	             false ? (0, _routerWarning2.default)(indexRoute.every(function (route) {
	              return !route.path;
	            }), 'Index routes should not have paths') : void 0;
	            (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
	          } else if (indexRoute) {
	             false ? (0, _routerWarning2.default)(!indexRoute.path, 'Index routes should not have paths') : void 0;
	            match.routes.push(indexRoute);
	          }
	
	          callback(null, match);
	        }
	      });
	
	      return;
	    }
	  }
	
	  if (remainingPathname != null || route.childRoutes) {
	    // Either a) this route matched at least some of the path or b)
	    // we don't have to load this route's children asynchronously. In
	    // either case continue checking for matches in the subtree.
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	      } else if (childRoutes) {
	        // Check the child routes to see if any of them match.
	        matchRoutes(childRoutes, location, function (error, match) {
	          if (error) {
	            callback(error);
	          } else if (match) {
	            // A child route matched! Augment the match and pass it up the stack.
	            match.routes.unshift(route);
	            callback(null, match);
	          } else {
	            callback();
	          }
	        }, remainingPathname, paramNames, paramValues);
	      } else {
	        callback();
	      }
	    };
	
	    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously matches the given location to a set of routes and calls
	 * callback(error, state) when finished. The state object will have the
	 * following properties:
	 *
	 * - routes       An array of routes that matched, in hierarchical order
	 * - params       An object of URL parameters
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getChildRoutes method.
	 */
	function matchRoutes(routes, location, callback, remainingPathname) {
	  var paramNames = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
	  var paramValues = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
	
	  if (remainingPathname === undefined) {
	    // TODO: This is a little bit ugly, but it works around a quirk in history
	    // that strips the leading slash from pathnames when using basenames with
	    // trailing slashes.
	    if (location.pathname.charAt(0) !== '/') {
	      location = _extends({}, location, {
	        pathname: '/' + location.pathname
	      });
	    }
	    remainingPathname = location.pathname;
	  }
	
	  (0, _AsyncUtils.loopAsync)(routes.length, function (index, next, done) {
	    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
	      if (error || match) {
	        done(error, match);
	      } else {
	        next();
	      }
	    });
	  }, callback);
	}
	module.exports = exports['default'];

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = withRouter;
	
	var _invariant = __webpack_require__(14);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(24);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _hoistNonReactStatics = __webpack_require__(489);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _ContextUtils = __webpack_require__(126);
	
	var _PropTypes = __webpack_require__(127);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	function withRouter(WrappedComponent, options) {
	  var withRef = options && options.withRef;
	
	  var WithRouter = (0, _createReactClass2.default)({
	    displayName: 'WithRouter',
	
	    mixins: [(0, _ContextUtils.ContextSubscriber)('router')],
	
	    contextTypes: { router: _PropTypes.routerShape },
	    propTypes: { router: _PropTypes.routerShape },
	
	    getWrappedInstance: function getWrappedInstance() {
	      !withRef ?  false ? (0, _invariant2.default)(false, 'To access the wrapped instance, you need to specify ' + '`{ withRef: true }` as the second argument of the withRouter() call.') : (0, _invariant2.default)(false) : void 0;
	
	      return this.wrappedInstance;
	    },
	    render: function render() {
	      var _this = this;
	
	      var router = this.props.router || this.context.router;
	      if (!router) {
	        return _react2.default.createElement(WrappedComponent, this.props);
	      }
	
	      var params = router.params,
	          location = router.location,
	          routes = router.routes;
	
	      var props = _extends({}, this.props, { router: router, params: params, location: location, routes: routes });
	
	      if (withRef) {
	        props.ref = function (c) {
	          _this.wrappedInstance = c;
	        };
	      }
	
	      return _react2.default.createElement(WrappedComponent, props);
	    }
	  });
	
	  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
	  WithRouter.WrappedComponent = WrappedComponent;
	
	  return (0, _hoistNonReactStatics2.default)(WithRouter, WrappedComponent);
	}
	module.exports = exports['default'];

/***/ }),
/* 489 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    getDerivedStateFromProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    callee: true,
	    arguments: true,
	    arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault(ex) {
	  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
	}
	
	var _objectWithoutProperties = _interopDefault(__webpack_require__(72));
	
	var _extends = _interopDefault(__webpack_require__(57));
	
	var _toConsumableArray = _interopDefault(__webpack_require__(140));
	
	var _objectSpread = _interopDefault(__webpack_require__(100));
	
	var _classCallCheck = _interopDefault(__webpack_require__(68));
	
	var _createClass = _interopDefault(__webpack_require__(69));
	
	var _possibleConstructorReturn = _interopDefault(__webpack_require__(73));
	
	var _getPrototypeOf = _interopDefault(__webpack_require__(70));
	
	var _inherits = _interopDefault(__webpack_require__(71));
	
	var _assertThisInitialized = _interopDefault(__webpack_require__(55));
	
	var _defineProperty = _interopDefault(__webpack_require__(56));
	
	var React = __webpack_require__(2);
	
	var React__default = _interopDefault(React);
	
	var memoizeOne = _interopDefault(__webpack_require__(117));
	
	var core = __webpack_require__(101);
	
	var reactDom = __webpack_require__(17);
	
	var __chunk_1 = __webpack_require__(129);
	
	var __chunk_2 = __webpack_require__(202);
	
	var _css = _interopDefault(__webpack_require__(75));
	
	var diacritics = [{
	  base: 'A',
	  letters: /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g
	}, {
	  base: 'AA',
	  letters: /[\uA732]/g
	}, {
	  base: 'AE',
	  letters: /[\u00C6\u01FC\u01E2]/g
	}, {
	  base: 'AO',
	  letters: /[\uA734]/g
	}, {
	  base: 'AU',
	  letters: /[\uA736]/g
	}, {
	  base: 'AV',
	  letters: /[\uA738\uA73A]/g
	}, {
	  base: 'AY',
	  letters: /[\uA73C]/g
	}, {
	  base: 'B',
	  letters: /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g
	}, {
	  base: 'C',
	  letters: /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g
	}, {
	  base: 'D',
	  letters: /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g
	}, {
	  base: 'DZ',
	  letters: /[\u01F1\u01C4]/g
	}, {
	  base: 'Dz',
	  letters: /[\u01F2\u01C5]/g
	}, {
	  base: 'E',
	  letters: /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g
	}, {
	  base: 'F',
	  letters: /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g
	}, {
	  base: 'G',
	  letters: /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g
	}, {
	  base: 'H',
	  letters: /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g
	}, {
	  base: 'I',
	  letters: /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g
	}, {
	  base: 'J',
	  letters: /[\u004A\u24BF\uFF2A\u0134\u0248]/g
	}, {
	  base: 'K',
	  letters: /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g
	}, {
	  base: 'L',
	  letters: /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g
	}, {
	  base: 'LJ',
	  letters: /[\u01C7]/g
	}, {
	  base: 'Lj',
	  letters: /[\u01C8]/g
	}, {
	  base: 'M',
	  letters: /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g
	}, {
	  base: 'N',
	  letters: /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g
	}, {
	  base: 'NJ',
	  letters: /[\u01CA]/g
	}, {
	  base: 'Nj',
	  letters: /[\u01CB]/g
	}, {
	  base: 'O',
	  letters: /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g
	}, {
	  base: 'OI',
	  letters: /[\u01A2]/g
	}, {
	  base: 'OO',
	  letters: /[\uA74E]/g
	}, {
	  base: 'OU',
	  letters: /[\u0222]/g
	}, {
	  base: 'P',
	  letters: /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g
	}, {
	  base: 'Q',
	  letters: /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g
	}, {
	  base: 'R',
	  letters: /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g
	}, {
	  base: 'S',
	  letters: /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g
	}, {
	  base: 'T',
	  letters: /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g
	}, {
	  base: 'TZ',
	  letters: /[\uA728]/g
	}, {
	  base: 'U',
	  letters: /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g
	}, {
	  base: 'V',
	  letters: /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g
	}, {
	  base: 'VY',
	  letters: /[\uA760]/g
	}, {
	  base: 'W',
	  letters: /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g
	}, {
	  base: 'X',
	  letters: /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g
	}, {
	  base: 'Y',
	  letters: /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g
	}, {
	  base: 'Z',
	  letters: /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g
	}, {
	  base: 'a',
	  letters: /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g
	}, {
	  base: 'aa',
	  letters: /[\uA733]/g
	}, {
	  base: 'ae',
	  letters: /[\u00E6\u01FD\u01E3]/g
	}, {
	  base: 'ao',
	  letters: /[\uA735]/g
	}, {
	  base: 'au',
	  letters: /[\uA737]/g
	}, {
	  base: 'av',
	  letters: /[\uA739\uA73B]/g
	}, {
	  base: 'ay',
	  letters: /[\uA73D]/g
	}, {
	  base: 'b',
	  letters: /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g
	}, {
	  base: 'c',
	  letters: /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g
	}, {
	  base: 'd',
	  letters: /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g
	}, {
	  base: 'dz',
	  letters: /[\u01F3\u01C6]/g
	}, {
	  base: 'e',
	  letters: /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g
	}, {
	  base: 'f',
	  letters: /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g
	}, {
	  base: 'g',
	  letters: /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g
	}, {
	  base: 'h',
	  letters: /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g
	}, {
	  base: 'hv',
	  letters: /[\u0195]/g
	}, {
	  base: 'i',
	  letters: /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g
	}, {
	  base: 'j',
	  letters: /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g
	}, {
	  base: 'k',
	  letters: /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g
	}, {
	  base: 'l',
	  letters: /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g
	}, {
	  base: 'lj',
	  letters: /[\u01C9]/g
	}, {
	  base: 'm',
	  letters: /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g
	}, {
	  base: 'n',
	  letters: /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g
	}, {
	  base: 'nj',
	  letters: /[\u01CC]/g
	}, {
	  base: 'o',
	  letters: /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g
	}, {
	  base: 'oi',
	  letters: /[\u01A3]/g
	}, {
	  base: 'ou',
	  letters: /[\u0223]/g
	}, {
	  base: 'oo',
	  letters: /[\uA74F]/g
	}, {
	  base: 'p',
	  letters: /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g
	}, {
	  base: 'q',
	  letters: /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g
	}, {
	  base: 'r',
	  letters: /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g
	}, {
	  base: 's',
	  letters: /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g
	}, {
	  base: 't',
	  letters: /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g
	}, {
	  base: 'tz',
	  letters: /[\uA729]/g
	}, {
	  base: 'u',
	  letters: /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g
	}, {
	  base: 'v',
	  letters: /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g
	}, {
	  base: 'vy',
	  letters: /[\uA761]/g
	}, {
	  base: 'w',
	  letters: /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g
	}, {
	  base: 'x',
	  letters: /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g
	}, {
	  base: 'y',
	  letters: /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g
	}, {
	  base: 'z',
	  letters: /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g
	}];
	
	var stripDiacritics = function stripDiacritics(str) {
	  for (var i = 0; i < diacritics.length; i++) {
	    str = str.replace(diacritics[i].letters, diacritics[i].base);
	  }
	
	  return str;
	};
	
	var trimString = function trimString(str) {
	  return str.replace(/^\s+|\s+$/g, '');
	};
	
	var defaultStringify = function defaultStringify(option) {
	  return "".concat(option.label, " ").concat(option.value);
	};
	
	var createFilter = function createFilter(config) {
	  return function (option, rawInput) {
	    var _ignoreCase$ignoreAcc = _objectSpread({
	      ignoreCase: true,
	      ignoreAccents: true,
	      stringify: defaultStringify,
	      trim: true,
	      matchFrom: 'any'
	    }, config),
	        ignoreCase = _ignoreCase$ignoreAcc.ignoreCase,
	        ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents,
	        stringify = _ignoreCase$ignoreAcc.stringify,
	        trim = _ignoreCase$ignoreAcc.trim,
	        matchFrom = _ignoreCase$ignoreAcc.matchFrom;
	
	    var input = trim ? trimString(rawInput) : rawInput;
	    var candidate = trim ? trimString(stringify(option)) : stringify(option);
	
	    if (ignoreCase) {
	      input = input.toLowerCase();
	      candidate = candidate.toLowerCase();
	    }
	
	    if (ignoreAccents) {
	      input = stripDiacritics(input);
	      candidate = stripDiacritics(candidate);
	    }
	
	    return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
	  };
	};
	
	var _ref =  true ? {
	  name: "1laao21-a11yText",
	  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap;"
	} : {
	  name: "1laao21-a11yText",
	  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap;",
	  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkExMXlUZXh0LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVFNIiwiZmlsZSI6IkExMXlUZXh0LmpzIiwic291cmNlc0NvbnRlbnQiOlsiLy8gQGZsb3dcbi8qKiBAanN4IGpzeCAqL1xuaW1wb3J0IHsgdHlwZSBFbGVtZW50Q29uZmlnIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsganN4IH0gZnJvbSAnQGVtb3Rpb24vY29yZSc7XG5cbi8vIEFzc2lzdGl2ZSB0ZXh0IHRvIGRlc2NyaWJlIHZpc3VhbCBlbGVtZW50cy4gSGlkZGVuIGZvciBzaWdodGVkIHVzZXJzLlxuY29uc3QgQTExeVRleHQgPSAocHJvcHM6IEVsZW1lbnRDb25maWc8J3NwYW4nPikgPT4gKFxuICAgIDxzcGFuXG4gICAgICBjc3M9e3tcbiAgICAgICAgbGFiZWw6ICdhMTF5VGV4dCcsXG4gICAgICAgIHpJbmRleDogOTk5OSxcbiAgICAgICAgYm9yZGVyOiAwLFxuICAgICAgICBjbGlwOiAncmVjdCgxcHgsIDFweCwgMXB4LCAxcHgpJyxcbiAgICAgICAgaGVpZ2h0OiAxLFxuICAgICAgICB3aWR0aDogMSxcbiAgICAgICAgcG9zaXRpb246ICdhYnNvbHV0ZScsXG4gICAgICAgIG92ZXJmbG93OiAnaGlkZGVuJyxcbiAgICAgICAgcGFkZGluZzogMCxcbiAgICAgICAgd2hpdGVTcGFjZTogJ25vd3JhcCcsXG4gICAgICB9fVxuICAgICAgey4uLnByb3BzfVxuICAgIC8+XG4pO1xuXG5leHBvcnQgZGVmYXVsdCBBMTF5VGV4dDtcbiJdfQ== */"
	};
	
	var A11yText = function A11yText(props) {
	  return core.jsx("span", _extends({
	    css: _ref
	  }, props));
	};
	
	var DummyInput =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(DummyInput, _Component);
	
	  function DummyInput() {
	    _classCallCheck(this, DummyInput);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(DummyInput).apply(this, arguments));
	  }
	
	  _createClass(DummyInput, [{
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          inProp = _this$props.in,
	          out = _this$props.out,
	          onExited = _this$props.onExited,
	          appear = _this$props.appear,
	          enter = _this$props.enter,
	          exit = _this$props.exit,
	          innerRef = _this$props.innerRef,
	          emotion = _this$props.emotion,
	          props = _objectWithoutProperties(_this$props, ["in", "out", "onExited", "appear", "enter", "exit", "innerRef", "emotion"]);
	
	      return core.jsx("input", _extends({
	        ref: innerRef
	      }, props, {
	        css:
	        /*#__PURE__*/
	        _css({
	          label: 'dummyInput',
	          // get rid of any default styles
	          background: 0,
	          border: 0,
	          fontSize: 'inherit',
	          outline: 0,
	          padding: 0,
	          // important! without `width` browsers won't allow focus
	          width: 1,
	          // remove cursor on desktop
	          color: 'transparent',
	          // remove cursor on mobile whilst maintaining "scroll into view" behaviour
	          left: -100,
	          opacity: 0,
	          position: 'relative',
	          transform: 'scale(0)'
	        },  true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkR1bW15SW5wdXQuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBWVEiLCJmaWxlIjoiRHVtbXlJbnB1dC5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8vIEBmbG93XG4vKiogQGpzeCBqc3ggKi9cbmltcG9ydCB7IENvbXBvbmVudCB9IGZyb20gJ3JlYWN0JztcbmltcG9ydCB7IGpzeCB9IGZyb20gJ0BlbW90aW9uL2NvcmUnO1xuXG5leHBvcnQgZGVmYXVsdCBjbGFzcyBEdW1teUlucHV0IGV4dGVuZHMgQ29tcG9uZW50PGFueT4ge1xuICByZW5kZXIgKCkge1xuICAgIGNvbnN0IHsgaW46IGluUHJvcCwgb3V0LCBvbkV4aXRlZCwgYXBwZWFyLCBlbnRlciwgZXhpdCwgaW5uZXJSZWYsIGVtb3Rpb24sIC4uLnByb3BzIH0gPSB0aGlzLnByb3BzO1xuICAgIHJldHVybihcbiAgICAgIDxpbnB1dFxuICAgICAgICByZWY9e2lubmVyUmVmfVxuICAgICAgICB7Li4ucHJvcHN9XG4gICAgICAgIGNzcz17e1xuICAgICAgICAgIGxhYmVsOiAnZHVtbXlJbnB1dCcsXG4gICAgICAgICAgLy8gZ2V0IHJpZCBvZiBhbnkgZGVmYXVsdCBzdHlsZXNcbiAgICAgICAgICBiYWNrZ3JvdW5kOiAwLFxuICAgICAgICAgIGJvcmRlcjogMCxcbiAgICAgICAgICBmb250U2l6ZTogJ2luaGVyaXQnLFxuICAgICAgICAgIG91dGxpbmU6IDAsXG4gICAgICAgICAgcGFkZGluZzogMCxcbiAgICAgICAgICAvLyBpbXBvcnRhbnQhIHdpdGhvdXQgYHdpZHRoYCBicm93c2VycyB3b24ndCBhbGxvdyBmb2N1c1xuICAgICAgICAgIHdpZHRoOiAxLFxuXG4gICAgICAgICAgLy8gcmVtb3ZlIGN1cnNvciBvbiBkZXNrdG9wXG4gICAgICAgICAgY29sb3I6ICd0cmFuc3BhcmVudCcsXG5cbiAgICAgICAgICAvLyByZW1vdmUgY3Vyc29yIG9uIG1vYmlsZSB3aGlsc3QgbWFpbnRhaW5pbmcgXCJzY3JvbGwgaW50byB2aWV3XCIgYmVoYXZpb3VyXG4gICAgICAgICAgbGVmdDogLTEwMCxcbiAgICAgICAgICBvcGFjaXR5OiAwLFxuICAgICAgICAgIHBvc2l0aW9uOiAncmVsYXRpdmUnLFxuICAgICAgICAgIHRyYW5zZm9ybTogJ3NjYWxlKDApJyxcbiAgICAgICAgfX1cbiAgICAgIC8+XG4gICAgKTtcbiAgfVxufVxuIl19 */")
	      }));
	    }
	  }]);
	
	  return DummyInput;
	}(React.Component);
	
	var NodeResolver =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(NodeResolver, _Component);
	
	  function NodeResolver() {
	    _classCallCheck(this, NodeResolver);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(NodeResolver).apply(this, arguments));
	  }
	
	  _createClass(NodeResolver, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.props.innerRef(reactDom.findDOMNode(this));
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.props.innerRef(null);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	
	  return NodeResolver;
	}(React.Component);
	
	var STYLE_KEYS = ['boxSizing', 'height', 'overflow', 'paddingRight', 'position'];
	var LOCK_STYLES = {
	  boxSizing: 'border-box',
	  // account for possible declaration `width: 100%;` on body
	  overflow: 'hidden',
	  position: 'relative',
	  height: '100%'
	};
	
	function preventTouchMove(e) {
	  e.preventDefault();
	}
	
	function allowTouchMove(e) {
	  e.stopPropagation();
	}
	
	function preventInertiaScroll() {
	  var top = this.scrollTop;
	  var totalScroll = this.scrollHeight;
	  var currentScroll = top + this.offsetHeight;
	
	  if (top === 0) {
	    this.scrollTop = 1;
	  } else if (currentScroll === totalScroll) {
	    this.scrollTop = top - 1;
	  }
	} // `ontouchstart` check works on most browsers
	// `maxTouchPoints` works on IE10/11 and Surface
	
	
	function isTouchDevice() {
	  return 'ontouchstart' in window || navigator.maxTouchPoints;
	}
	
	var canUseDOM = !!(window.document && window.document.createElement);
	var activeScrollLocks = 0;
	
	var ScrollLock =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(ScrollLock, _Component);
	
	  function ScrollLock() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, ScrollLock);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ScrollLock)).call.apply(_getPrototypeOf2, [this].concat(args)));
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "originalStyles", {});
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "listenerOptions", {
	      capture: false,
	      passive: false
	    });
	
	    return _this;
	  }
	
	  _createClass(ScrollLock, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      if (!canUseDOM) return;
	      var _this$props = this.props,
	          accountForScrollbars = _this$props.accountForScrollbars,
	          touchScrollTarget = _this$props.touchScrollTarget;
	      var target = document.body;
	      var targetStyle = target && target.style;
	
	      if (accountForScrollbars) {
	        // store any styles already applied to the body
	        STYLE_KEYS.forEach(function (key) {
	          var val = targetStyle && targetStyle[key];
	          _this2.originalStyles[key] = val;
	        });
	      } // apply the lock styles and padding if this is the first scroll lock
	
	
	      if (accountForScrollbars && activeScrollLocks < 1) {
	        var currentPadding = parseInt(this.originalStyles.paddingRight, 10) || 0;
	        var clientWidth = document.body ? document.body.clientWidth : 0;
	        var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
	        Object.keys(LOCK_STYLES).forEach(function (key) {
	          var val = LOCK_STYLES[key];
	
	          if (targetStyle) {
	            targetStyle[key] = val;
	          }
	        });
	
	        if (targetStyle) {
	          targetStyle.paddingRight = "".concat(adjustedPadding, "px");
	        }
	      } // account for touch devices
	
	
	      if (target && isTouchDevice()) {
	        // Mobile Safari ignores { overflow: hidden } declaration on the body.
	        target.addEventListener('touchmove', preventTouchMove, this.listenerOptions); // Allow scroll on provided target
	
	        if (touchScrollTarget) {
	          touchScrollTarget.addEventListener('touchstart', preventInertiaScroll, this.listenerOptions);
	          touchScrollTarget.addEventListener('touchmove', allowTouchMove, this.listenerOptions);
	        }
	      } // increment active scroll locks
	
	
	      activeScrollLocks += 1;
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      var _this3 = this;
	
	      if (!canUseDOM) return;
	      var _this$props2 = this.props,
	          accountForScrollbars = _this$props2.accountForScrollbars,
	          touchScrollTarget = _this$props2.touchScrollTarget;
	      var target = document.body;
	      var targetStyle = target && target.style; // safely decrement active scroll locks
	
	      activeScrollLocks = Math.max(activeScrollLocks - 1, 0); // reapply original body styles, if any
	
	      if (accountForScrollbars && activeScrollLocks < 1) {
	        STYLE_KEYS.forEach(function (key) {
	          var val = _this3.originalStyles[key];
	
	          if (targetStyle) {
	            targetStyle[key] = val;
	          }
	        });
	      } // remove touch listeners
	
	
	      if (target && isTouchDevice()) {
	        target.removeEventListener('touchmove', preventTouchMove, this.listenerOptions);
	
	        if (touchScrollTarget) {
	          touchScrollTarget.removeEventListener('touchstart', preventInertiaScroll, this.listenerOptions);
	          touchScrollTarget.removeEventListener('touchmove', allowTouchMove, this.listenerOptions);
	        }
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return ScrollLock;
	}(React.Component);
	
	_defineProperty(ScrollLock, "defaultProps", {
	  accountForScrollbars: true
	});
	
	var _ref$1 =  true ? {
	  name: "1dsbpcp",
	  styles: "position:fixed;left:0;bottom:0;right:0;top:0;"
	} : {
	  name: "1dsbpcp",
	  styles: "position:fixed;left:0;bottom:0;right:0;top:0;",
	  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"
	}; // NOTE:
	// We shouldn't need this after updating to React v16.3.0, which introduces:
	// - createRef() https://reactjs.org/docs/react-api.html#reactcreateref
	// - forwardRef() https://reactjs.org/docs/react-api.html#reactforwardref
	
	
	var ScrollBlock =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(ScrollBlock, _PureComponent);
	
	  function ScrollBlock() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, ScrollBlock);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ScrollBlock)).call.apply(_getPrototypeOf2, [this].concat(args)));
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
	      touchScrollTarget: null
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getScrollTarget", function (ref) {
	      if (ref === _this.state.touchScrollTarget) return;
	
	      _this.setState({
	        touchScrollTarget: ref
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "blurSelectInput", function () {
	      if (document.activeElement) {
	        document.activeElement.blur();
	      }
	    });
	
	    return _this;
	  }
	
	  _createClass(ScrollBlock, [{
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          children = _this$props.children,
	          isEnabled = _this$props.isEnabled;
	      var touchScrollTarget = this.state.touchScrollTarget; // bail early if not enabled
	
	      if (!isEnabled) return children;
	      /*
	       * Div
	       * ------------------------------
	       * blocks scrolling on non-body elements behind the menu
	        * NodeResolver
	       * ------------------------------
	       * we need a reference to the scrollable element to "unlock" scroll on
	       * mobile devices
	        * ScrollLock
	       * ------------------------------
	       * actually does the scroll locking
	       */
	
	      return core.jsx("div", null, core.jsx("div", {
	        onClick: this.blurSelectInput,
	        css: _ref$1
	      }), core.jsx(NodeResolver, {
	        innerRef: this.getScrollTarget
	      }, children), touchScrollTarget ? core.jsx(ScrollLock, {
	        touchScrollTarget: touchScrollTarget
	      }) : null);
	    }
	  }]);
	
	  return ScrollBlock;
	}(React.PureComponent);
	
	var ScrollCaptor =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(ScrollCaptor, _Component);
	
	  function ScrollCaptor() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, ScrollCaptor);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ScrollCaptor)).call.apply(_getPrototypeOf2, [this].concat(args)));
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "isBottom", false);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "isTop", false);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "scrollTarget", void 0);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "touchStart", void 0);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "cancelScroll", function (event) {
	      event.preventDefault();
	      event.stopPropagation();
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleEventDelta", function (event, delta) {
	      var _this$props = _this.props,
	          onBottomArrive = _this$props.onBottomArrive,
	          onBottomLeave = _this$props.onBottomLeave,
	          onTopArrive = _this$props.onTopArrive,
	          onTopLeave = _this$props.onTopLeave;
	      var _this$scrollTarget = _this.scrollTarget,
	          scrollTop = _this$scrollTarget.scrollTop,
	          scrollHeight = _this$scrollTarget.scrollHeight,
	          clientHeight = _this$scrollTarget.clientHeight;
	      var target = _this.scrollTarget;
	      var isDeltaPositive = delta > 0;
	      var availableScroll = scrollHeight - clientHeight - scrollTop;
	      var shouldCancelScroll = false; // reset bottom/top flags
	
	      if (availableScroll > delta && _this.isBottom) {
	        if (onBottomLeave) onBottomLeave(event);
	        _this.isBottom = false;
	      }
	
	      if (isDeltaPositive && _this.isTop) {
	        if (onTopLeave) onTopLeave(event);
	        _this.isTop = false;
	      } // bottom limit
	
	
	      if (isDeltaPositive && delta > availableScroll) {
	        if (onBottomArrive && !_this.isBottom) {
	          onBottomArrive(event);
	        }
	
	        target.scrollTop = scrollHeight;
	        shouldCancelScroll = true;
	        _this.isBottom = true; // top limit
	      } else if (!isDeltaPositive && -delta > scrollTop) {
	        if (onTopArrive && !_this.isTop) {
	          onTopArrive(event);
	        }
	
	        target.scrollTop = 0;
	        shouldCancelScroll = true;
	        _this.isTop = true;
	      } // cancel scroll
	
	
	      if (shouldCancelScroll) {
	        _this.cancelScroll(event);
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onWheel", function (event) {
	      _this.handleEventDelta(event, event.deltaY);
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onTouchStart", function (event) {
	      // set touch start so we can calculate touchmove delta
	      _this.touchStart = event.changedTouches[0].clientY;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onTouchMove", function (event) {
	      var deltaY = _this.touchStart - event.changedTouches[0].clientY;
	
	      _this.handleEventDelta(event, deltaY);
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getScrollTarget", function (ref) {
	      _this.scrollTarget = ref;
	    });
	
	    return _this;
	  }
	
	  _createClass(ScrollCaptor, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.startListening(this.scrollTarget);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.stopListening(this.scrollTarget);
	    }
	  }, {
	    key: "startListening",
	    value: function startListening(el) {
	      // bail early if no element is available to attach to
	      if (!el) return; // all the if statements are to appease Flow 😢
	
	      if (typeof el.addEventListener === 'function') {
	        el.addEventListener('wheel', this.onWheel, false);
	      }
	
	      if (typeof el.addEventListener === 'function') {
	        el.addEventListener('touchstart', this.onTouchStart, false);
	      }
	
	      if (typeof el.addEventListener === 'function') {
	        el.addEventListener('touchmove', this.onTouchMove, false);
	      }
	    }
	  }, {
	    key: "stopListening",
	    value: function stopListening(el) {
	      // all the if statements are to appease Flow 😢
	      if (typeof el.removeEventListener === 'function') {
	        el.removeEventListener('wheel', this.onWheel, false);
	      }
	
	      if (typeof el.removeEventListener === 'function') {
	        el.removeEventListener('touchstart', this.onTouchStart, false);
	      }
	
	      if (typeof el.removeEventListener === 'function') {
	        el.removeEventListener('touchmove', this.onTouchMove, false);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return React__default.createElement(NodeResolver, {
	        innerRef: this.getScrollTarget
	      }, this.props.children);
	    }
	  }]);
	
	  return ScrollCaptor;
	}(React.Component);
	
	var ScrollCaptorSwitch =
	/*#__PURE__*/
	function (_Component2) {
	  _inherits(ScrollCaptorSwitch, _Component2);
	
	  function ScrollCaptorSwitch() {
	    _classCallCheck(this, ScrollCaptorSwitch);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(ScrollCaptorSwitch).apply(this, arguments));
	  }
	
	  _createClass(ScrollCaptorSwitch, [{
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          isEnabled = _this$props2.isEnabled,
	          props = _objectWithoutProperties(_this$props2, ["isEnabled"]);
	
	      return isEnabled ? React__default.createElement(ScrollCaptor, props) : this.props.children;
	    }
	  }]);
	
	  return ScrollCaptorSwitch;
	}(React.Component);
	
	_defineProperty(ScrollCaptorSwitch, "defaultProps", {
	  isEnabled: true
	});
	
	var instructionsAriaMessage = function instructionsAriaMessage(event) {
	  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var isSearchable = context.isSearchable,
	      isMulti = context.isMulti,
	      label = context.label,
	      isDisabled = context.isDisabled;
	
	  switch (event) {
	    case 'menu':
	      return "Use Up and Down to choose options".concat(isDisabled ? '' : ', press Enter to select the currently focused option', ", press Escape to exit the menu, press Tab to select the option and exit the menu.");
	
	    case 'input':
	      return "".concat(label ? label : 'Select', " is focused ").concat(isSearchable ? ',type to refine list' : '', ", press Down to open the menu, ").concat(isMulti ? ' press left to focus selected values' : '');
	
	    case 'value':
	      return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
	  }
	};
	
	var valueEventAriaMessage = function valueEventAriaMessage(event, context) {
	  var value = context.value,
	      isDisabled = context.isDisabled;
	  if (!value) return;
	
	  switch (event) {
	    case 'deselect-option':
	    case 'pop-value':
	    case 'remove-value':
	      return "option ".concat(value, ", deselected.");
	
	    case 'select-option':
	      return isDisabled ? "option ".concat(value, " is disabled. Select another option.") : "option ".concat(value, ", selected.");
	  }
	};
	
	var valueFocusAriaMessage = function valueFocusAriaMessage(_ref) {
	  var focusedValue = _ref.focusedValue,
	      getOptionLabel = _ref.getOptionLabel,
	      selectValue = _ref.selectValue;
	  return "value ".concat(getOptionLabel(focusedValue), " focused, ").concat(selectValue.indexOf(focusedValue) + 1, " of ").concat(selectValue.length, ".");
	};
	
	var optionFocusAriaMessage = function optionFocusAriaMessage(_ref2) {
	  var focusedOption = _ref2.focusedOption,
	      getOptionLabel = _ref2.getOptionLabel,
	      options = _ref2.options;
	  return "option ".concat(getOptionLabel(focusedOption), " focused").concat(focusedOption.isDisabled ? ' disabled' : '', ", ").concat(options.indexOf(focusedOption) + 1, " of ").concat(options.length, ".");
	};
	
	var resultsAriaMessage = function resultsAriaMessage(_ref3) {
	  var inputValue = _ref3.inputValue,
	      screenReaderMessage = _ref3.screenReaderMessage;
	  return "".concat(screenReaderMessage).concat(inputValue ? ' for search term ' + inputValue : '', ".");
	};
	
	var formatGroupLabel = function formatGroupLabel(group) {
	  return group.label;
	};
	
	var getOptionLabel = function getOptionLabel(option) {
	  return option.label;
	};
	
	var getOptionValue = function getOptionValue(option) {
	  return option.value;
	};
	
	var isOptionDisabled = function isOptionDisabled(option) {
	  return !!option.isDisabled;
	};
	
	var defaultStyles = {
	  clearIndicator: __chunk_2.clearIndicatorCSS,
	  container: __chunk_2.containerCSS,
	  control: __chunk_2.css,
	  dropdownIndicator: __chunk_2.dropdownIndicatorCSS,
	  group: __chunk_2.groupCSS,
	  groupHeading: __chunk_2.groupHeadingCSS,
	  indicatorsContainer: __chunk_2.indicatorsContainerCSS,
	  indicatorSeparator: __chunk_2.indicatorSeparatorCSS,
	  input: __chunk_2.inputCSS,
	  loadingIndicator: __chunk_2.loadingIndicatorCSS,
	  loadingMessage: __chunk_2.loadingMessageCSS,
	  menu: __chunk_2.menuCSS,
	  menuList: __chunk_2.menuListCSS,
	  menuPortal: __chunk_2.menuPortalCSS,
	  multiValue: __chunk_2.multiValueCSS,
	  multiValueLabel: __chunk_2.multiValueLabelCSS,
	  multiValueRemove: __chunk_2.multiValueRemoveCSS,
	  noOptionsMessage: __chunk_2.noOptionsMessageCSS,
	  option: __chunk_2.optionCSS,
	  placeholder: __chunk_2.placeholderCSS,
	  singleValue: __chunk_2.css$1,
	  valueContainer: __chunk_2.valueContainerCSS
	}; // Merge Utility
	// Allows consumers to extend a base Select with additional styles
	
	function mergeStyles(source) {
	  var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}; // initialize with source styles
	
	  var styles = _objectSpread({}, source); // massage in target styles
	
	
	  Object.keys(target).forEach(function (key) {
	    if (source[key]) {
	      styles[key] = function (rsCss, props) {
	        return target[key](source[key](rsCss, props), props);
	      };
	    } else {
	      styles[key] = target[key];
	    }
	  });
	  return styles;
	}
	
	var colors = {
	  primary: '#2684FF',
	  primary75: '#4C9AFF',
	  primary50: '#B2D4FF',
	  primary25: '#DEEBFF',
	  danger: '#DE350B',
	  dangerLight: '#FFBDAD',
	  neutral0: 'hsl(0, 0%, 100%)',
	  neutral5: 'hsl(0, 0%, 95%)',
	  neutral10: 'hsl(0, 0%, 90%)',
	  neutral20: 'hsl(0, 0%, 80%)',
	  neutral30: 'hsl(0, 0%, 70%)',
	  neutral40: 'hsl(0, 0%, 60%)',
	  neutral50: 'hsl(0, 0%, 50%)',
	  neutral60: 'hsl(0, 0%, 40%)',
	  neutral70: 'hsl(0, 0%, 30%)',
	  neutral80: 'hsl(0, 0%, 20%)',
	  neutral90: 'hsl(0, 0%, 10%)'
	};
	var borderRadius = 4; // Used to calculate consistent margin/padding on elements
	
	var baseUnit = 4; // The minimum height of the control
	
	var controlHeight = 38; // The amount of space between the control and menu */
	
	var menuGutter = baseUnit * 2;
	var spacing = {
	  baseUnit: baseUnit,
	  controlHeight: controlHeight,
	  menuGutter: menuGutter
	};
	var defaultTheme = {
	  borderRadius: borderRadius,
	  colors: colors,
	  spacing: spacing
	};
	var defaultProps = {
	  backspaceRemovesValue: true,
	  blurInputOnSelect: __chunk_1.isTouchCapable(),
	  captureMenuScroll: !__chunk_1.isTouchCapable(),
	  closeMenuOnSelect: true,
	  closeMenuOnScroll: false,
	  components: {},
	  controlShouldRenderValue: true,
	  escapeClearsValue: false,
	  filterOption: createFilter(),
	  formatGroupLabel: formatGroupLabel,
	  getOptionLabel: getOptionLabel,
	  getOptionValue: getOptionValue,
	  isDisabled: false,
	  isLoading: false,
	  isMulti: false,
	  isRtl: false,
	  isSearchable: true,
	  isOptionDisabled: isOptionDisabled,
	  loadingMessage: function loadingMessage() {
	    return 'Loading...';
	  },
	  maxMenuHeight: 300,
	  minMenuHeight: 140,
	  menuIsOpen: false,
	  menuPlacement: 'bottom',
	  menuPosition: 'absolute',
	  menuShouldBlockScroll: false,
	  menuShouldScrollIntoView: !__chunk_1.isMobileDevice(),
	  noOptionsMessage: function noOptionsMessage() {
	    return 'No options';
	  },
	  openMenuOnFocus: false,
	  openMenuOnClick: true,
	  options: [],
	  pageSize: 5,
	  placeholder: 'Select...',
	  screenReaderStatus: function screenReaderStatus(_ref) {
	    var count = _ref.count;
	    return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
	  },
	  styles: {},
	  tabIndex: '0',
	  tabSelectsValue: true
	};
	var instanceId = 1;
	
	var Select =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(Select, _Component); // Misc. Instance Properties
	  // ------------------------------
	  // TODO
	  // Refs
	  // ------------------------------
	  // Lifecycle
	  // ------------------------------
	
	
	  function Select(_props) {
	    var _this;
	
	    _classCallCheck(this, Select);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(Select).call(this, _props));
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
	      ariaLiveSelection: '',
	      ariaLiveContext: '',
	      focusedOption: null,
	      focusedValue: null,
	      inputIsHidden: false,
	      isFocused: false,
	      menuOptions: {
	        render: [],
	        focusable: []
	      },
	      selectValue: []
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "blockOptionHover", false);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "isComposing", false);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "clearFocusValueOnUpdate", false);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "commonProps", void 0);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "components", void 0);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "hasGroups", false);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "initialTouchX", 0);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "initialTouchY", 0);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "inputIsHiddenAfterUpdate", void 0);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "instancePrefix", '');
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "openAfterFocus", false);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "scrollToFocusedOptionOnUpdate", false);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "userIsDragging", void 0);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "controlRef", null);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getControlRef", function (ref) {
	      _this.controlRef = ref;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "focusedOptionRef", null);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getFocusedOptionRef", function (ref) {
	      _this.focusedOptionRef = ref;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "menuListRef", null);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getMenuListRef", function (ref) {
	      _this.menuListRef = ref;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "inputRef", null);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getInputRef", function (ref) {
	      _this.inputRef = ref;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "cacheComponents", function (components) {
	      _this.components = __chunk_2.defaultComponents({
	        components: components
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "focus", _this.focusInput);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "blur", _this.blurInput);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onChange", function (newValue, actionMeta) {
	      var _this$props = _this.props,
	          onChange = _this$props.onChange,
	          name = _this$props.name;
	      onChange(newValue, _objectSpread({}, actionMeta, {
	        name: name
	      }));
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "setValue", function (newValue) {
	      var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'set-value';
	      var option = arguments.length > 2 ? arguments[2] : undefined;
	      var _this$props2 = _this.props,
	          closeMenuOnSelect = _this$props2.closeMenuOnSelect,
	          isMulti = _this$props2.isMulti;
	
	      _this.onInputChange('', {
	        action: 'set-value'
	      });
	
	      if (closeMenuOnSelect) {
	        _this.inputIsHiddenAfterUpdate = !isMulti;
	
	        _this.onMenuClose();
	      } // when the select value should change, we should reset focusedValue
	
	
	      _this.clearFocusValueOnUpdate = true;
	
	      _this.onChange(newValue, {
	        action: action,
	        option: option
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "selectOption", function (newValue) {
	      var _this$props3 = _this.props,
	          blurInputOnSelect = _this$props3.blurInputOnSelect,
	          isMulti = _this$props3.isMulti;
	      var selectValue = _this.state.selectValue;
	
	      if (isMulti) {
	        if (_this.isOptionSelected(newValue, selectValue)) {
	          var candidate = _this.getOptionValue(newValue);
	
	          _this.setValue(selectValue.filter(function (i) {
	            return _this.getOptionValue(i) !== candidate;
	          }), 'deselect-option', newValue);
	
	          _this.announceAriaLiveSelection({
	            event: 'deselect-option',
	            context: {
	              value: _this.getOptionLabel(newValue)
	            }
	          });
	        } else {
	          if (!_this.isOptionDisabled(newValue, selectValue)) {
	            _this.setValue([].concat(_toConsumableArray(selectValue), [newValue]), 'select-option', newValue);
	
	            _this.announceAriaLiveSelection({
	              event: 'select-option',
	              context: {
	                value: _this.getOptionLabel(newValue)
	              }
	            });
	          } else {
	            // announce that option is disabled
	            _this.announceAriaLiveSelection({
	              event: 'select-option',
	              context: {
	                value: _this.getOptionLabel(newValue),
	                isDisabled: true
	              }
	            });
	          }
	        }
	      } else {
	        if (!_this.isOptionDisabled(newValue, selectValue)) {
	          _this.setValue(newValue, 'select-option');
	
	          _this.announceAriaLiveSelection({
	            event: 'select-option',
	            context: {
	              value: _this.getOptionLabel(newValue)
	            }
	          });
	        } else {
	          // announce that option is disabled
	          _this.announceAriaLiveSelection({
	            event: 'select-option',
	            context: {
	              value: _this.getOptionLabel(newValue),
	              isDisabled: true
	            }
	          });
	        }
	      }
	
	      if (blurInputOnSelect) {
	        _this.blurInput();
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "removeValue", function (removedValue) {
	      var selectValue = _this.state.selectValue;
	
	      var candidate = _this.getOptionValue(removedValue);
	
	      var newValue = selectValue.filter(function (i) {
	        return _this.getOptionValue(i) !== candidate;
	      });
	
	      _this.onChange(newValue.length ? newValue : null, {
	        action: 'remove-value',
	        removedValue: removedValue
	      });
	
	      _this.announceAriaLiveSelection({
	        event: 'remove-value',
	        context: {
	          value: removedValue ? _this.getOptionLabel(removedValue) : ''
	        }
	      });
	
	      _this.focusInput();
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "clearValue", function () {
	      var isMulti = _this.props.isMulti;
	
	      _this.onChange(isMulti ? [] : null, {
	        action: 'clear'
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "popValue", function () {
	      var selectValue = _this.state.selectValue;
	      var lastSelectedValue = selectValue[selectValue.length - 1];
	      var newValue = selectValue.slice(0, selectValue.length - 1);
	
	      _this.announceAriaLiveSelection({
	        event: 'pop-value',
	        context: {
	          value: lastSelectedValue ? _this.getOptionLabel(lastSelectedValue) : ''
	        }
	      });
	
	      _this.onChange(newValue.length ? newValue : null, {
	        action: 'pop-value',
	        removedValue: lastSelectedValue
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getOptionLabel", function (data) {
	      return _this.props.getOptionLabel(data);
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getOptionValue", function (data) {
	      return _this.props.getOptionValue(data);
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getStyles", function (key, props) {
	      var base = defaultStyles[key](props);
	      base.boxSizing = 'border-box';
	      var custom = _this.props.styles[key];
	      return custom ? custom(base, props) : base;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getElementId", function (element) {
	      return "".concat(_this.instancePrefix, "-").concat(element);
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getActiveDescendentId", function () {
	      var menuIsOpen = _this.props.menuIsOpen;
	      var _this$state = _this.state,
	          menuOptions = _this$state.menuOptions,
	          focusedOption = _this$state.focusedOption;
	      if (!focusedOption || !menuIsOpen) return undefined;
	      var index = menuOptions.focusable.indexOf(focusedOption);
	      var option = menuOptions.render[index];
	      return option && option.key;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "announceAriaLiveSelection", function (_ref2) {
	      var event = _ref2.event,
	          context = _ref2.context;
	
	      _this.setState({
	        ariaLiveSelection: valueEventAriaMessage(event, context)
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "announceAriaLiveContext", function (_ref3) {
	      var event = _ref3.event,
	          context = _ref3.context;
	
	      _this.setState({
	        ariaLiveContext: instructionsAriaMessage(event, _objectSpread({}, context, {
	          label: _this.props['aria-label']
	        }))
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onMenuMouseDown", function (event) {
	      if (event.button !== 0) {
	        return;
	      }
	
	      event.stopPropagation();
	      event.preventDefault();
	
	      _this.focusInput();
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onMenuMouseMove", function (event) {
	      _this.blockOptionHover = false;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onControlMouseDown", function (event) {
	      var openMenuOnClick = _this.props.openMenuOnClick;
	
	      if (!_this.state.isFocused) {
	        if (openMenuOnClick) {
	          _this.openAfterFocus = true;
	        }
	
	        _this.focusInput();
	      } else if (!_this.props.menuIsOpen) {
	        if (openMenuOnClick) {
	          _this.openMenu('first');
	        }
	      } else {
	        //$FlowFixMe
	        if (event.target.tagName !== 'INPUT') {
	          _this.onMenuClose();
	        }
	      } //$FlowFixMe
	
	
	      if (event.target.tagName !== 'INPUT') {
	        event.preventDefault();
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onDropdownIndicatorMouseDown", function (event) {
	      // ignore mouse events that weren't triggered by the primary button
	      if (event && event.type === 'mousedown' && event.button !== 0) {
	        return;
	      }
	
	      if (_this.props.isDisabled) return;
	      var _this$props4 = _this.props,
	          isMulti = _this$props4.isMulti,
	          menuIsOpen = _this$props4.menuIsOpen;
	
	      _this.focusInput();
	
	      if (menuIsOpen) {
	        _this.inputIsHiddenAfterUpdate = !isMulti;
	
	        _this.onMenuClose();
	      } else {
	        _this.openMenu('first');
	      }
	
	      event.preventDefault();
	      event.stopPropagation();
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onClearIndicatorMouseDown", function (event) {
	      // ignore mouse events that weren't triggered by the primary button
	      if (event && event.type === 'mousedown' && event.button !== 0) {
	        return;
	      }
	
	      _this.clearValue();
	
	      event.stopPropagation();
	      _this.openAfterFocus = false;
	
	      if (event.type === 'touchend') {
	        _this.focusInput();
	      } else {
	        setTimeout(function () {
	          return _this.focusInput();
	        });
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onScroll", function (event) {
	      if (typeof _this.props.closeMenuOnScroll === 'boolean') {
	        if (event.target instanceof HTMLElement && __chunk_1.isDocumentElement(event.target)) {
	          _this.props.onMenuClose();
	        }
	      } else if (typeof _this.props.closeMenuOnScroll === 'function') {
	        if (_this.props.closeMenuOnScroll(event)) {
	          _this.props.onMenuClose();
	        }
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onCompositionStart", function () {
	      _this.isComposing = true;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onCompositionEnd", function () {
	      _this.isComposing = false;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onTouchStart", function (_ref4) {
	      var touches = _ref4.touches;
	      var touch = touches.item(0);
	
	      if (!touch) {
	        return;
	      }
	
	      _this.initialTouchX = touch.clientX;
	      _this.initialTouchY = touch.clientY;
	      _this.userIsDragging = false;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onTouchMove", function (_ref5) {
	      var touches = _ref5.touches;
	      var touch = touches.item(0);
	
	      if (!touch) {
	        return;
	      }
	
	      var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
	      var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
	      var moveThreshold = 5;
	      _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onTouchEnd", function (event) {
	      if (_this.userIsDragging) return; // close the menu if the user taps outside
	      // we're checking on event.target here instead of event.currentTarget, because we want to assert information
	      // on events on child elements, not the document (which we've attached this handler to).
	
	      if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) {
	        _this.blurInput();
	      } // reset move vars
	
	
	      _this.initialTouchX = 0;
	      _this.initialTouchY = 0;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onControlTouchEnd", function (event) {
	      if (_this.userIsDragging) return;
	
	      _this.onControlMouseDown(event);
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onClearIndicatorTouchEnd", function (event) {
	      if (_this.userIsDragging) return;
	
	      _this.onClearIndicatorMouseDown(event);
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onDropdownIndicatorTouchEnd", function (event) {
	      if (_this.userIsDragging) return;
	
	      _this.onDropdownIndicatorMouseDown(event);
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleInputChange", function (event) {
	      var inputValue = event.currentTarget.value;
	      _this.inputIsHiddenAfterUpdate = false;
	
	      _this.onInputChange(inputValue, {
	        action: 'input-change'
	      });
	
	      _this.onMenuOpen();
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onInputFocus", function (event) {
	      var _this$props5 = _this.props,
	          isSearchable = _this$props5.isSearchable,
	          isMulti = _this$props5.isMulti;
	
	      if (_this.props.onFocus) {
	        _this.props.onFocus(event);
	      }
	
	      _this.inputIsHiddenAfterUpdate = false;
	
	      _this.announceAriaLiveContext({
	        event: 'input',
	        context: {
	          isSearchable: isSearchable,
	          isMulti: isMulti
	        }
	      });
	
	      _this.setState({
	        isFocused: true
	      });
	
	      if (_this.openAfterFocus || _this.props.openMenuOnFocus) {
	        _this.openMenu('first');
	      }
	
	      _this.openAfterFocus = false;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onInputBlur", function (event) {
	      if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
	        _this.inputRef.focus();
	
	        return;
	      }
	
	      if (_this.props.onBlur) {
	        _this.props.onBlur(event);
	      }
	
	      _this.onInputChange('', {
	        action: 'input-blur'
	      });
	
	      _this.onMenuClose();
	
	      _this.setState({
	        focusedValue: null,
	        isFocused: false
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onOptionHover", function (focusedOption) {
	      if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) {
	        return;
	      }
	
	      _this.setState({
	        focusedOption: focusedOption
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "shouldHideSelectedOptions", function () {
	      var _this$props6 = _this.props,
	          hideSelectedOptions = _this$props6.hideSelectedOptions,
	          isMulti = _this$props6.isMulti;
	      if (hideSelectedOptions === undefined) return isMulti;
	      return hideSelectedOptions;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onKeyDown", function (event) {
	      var _this$props7 = _this.props,
	          isMulti = _this$props7.isMulti,
	          backspaceRemovesValue = _this$props7.backspaceRemovesValue,
	          escapeClearsValue = _this$props7.escapeClearsValue,
	          inputValue = _this$props7.inputValue,
	          isClearable = _this$props7.isClearable,
	          isDisabled = _this$props7.isDisabled,
	          menuIsOpen = _this$props7.menuIsOpen,
	          onKeyDown = _this$props7.onKeyDown,
	          tabSelectsValue = _this$props7.tabSelectsValue,
	          openMenuOnFocus = _this$props7.openMenuOnFocus;
	      var _this$state2 = _this.state,
	          focusedOption = _this$state2.focusedOption,
	          focusedValue = _this$state2.focusedValue,
	          selectValue = _this$state2.selectValue;
	      if (isDisabled) return;
	
	      if (typeof onKeyDown === 'function') {
	        onKeyDown(event);
	
	        if (event.defaultPrevented) {
	          return;
	        }
	      } // Block option hover events when the user has just pressed a key
	
	
	      _this.blockOptionHover = true;
	
	      switch (event.key) {
	        case 'ArrowLeft':
	          if (!isMulti || inputValue) return;
	
	          _this.focusValue('previous');
	
	          break;
	
	        case 'ArrowRight':
	          if (!isMulti || inputValue) return;
	
	          _this.focusValue('next');
	
	          break;
	
	        case 'Delete':
	        case 'Backspace':
	          if (inputValue) return;
	
	          if (focusedValue) {
	            _this.removeValue(focusedValue);
	          } else {
	            if (!backspaceRemovesValue) return;
	
	            if (isMulti) {
	              _this.popValue();
	            } else if (isClearable) {
	              _this.clearValue();
	            }
	          }
	
	          break;
	
	        case 'Tab':
	          if (_this.isComposing) return;
	
	          if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
	          // option is already selected; it breaks the flow of navigation
	          openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) {
	            return;
	          }
	
	          _this.selectOption(focusedOption);
	
	          break;
	
	        case 'Enter':
	          if (event.keyCode === 229) {
	            // ignore the keydown event from an Input Method Editor(IME)
	            // ref. https://www.w3.org/TR/uievents/#determine-keydown-keyup-keyCode
	            break;
	          }
	
	          if (menuIsOpen) {
	            if (!focusedOption) return;
	            if (_this.isComposing) return;
	
	            _this.selectOption(focusedOption);
	
	            break;
	          }
	
	          return;
	
	        case 'Escape':
	          if (menuIsOpen) {
	            _this.inputIsHiddenAfterUpdate = false;
	
	            _this.onInputChange('', {
	              action: 'menu-close'
	            });
	
	            _this.onMenuClose();
	          } else if (isClearable && escapeClearsValue) {
	            _this.clearValue();
	          }
	
	          break;
	
	        case ' ':
	          // space
	          if (inputValue) {
	            return;
	          }
	
	          if (!menuIsOpen) {
	            _this.openMenu('first');
	
	            break;
	          }
	
	          if (!focusedOption) return;
	
	          _this.selectOption(focusedOption);
	
	          break;
	
	        case 'ArrowUp':
	          if (menuIsOpen) {
	            _this.focusOption('up');
	          } else {
	            _this.openMenu('last');
	          }
	
	          break;
	
	        case 'ArrowDown':
	          if (menuIsOpen) {
	            _this.focusOption('down');
	          } else {
	            _this.openMenu('first');
	          }
	
	          break;
	
	        case 'PageUp':
	          if (!menuIsOpen) return;
	
	          _this.focusOption('pageup');
	
	          break;
	
	        case 'PageDown':
	          if (!menuIsOpen) return;
	
	          _this.focusOption('pagedown');
	
	          break;
	
	        case 'Home':
	          if (!menuIsOpen) return;
	
	          _this.focusOption('first');
	
	          break;
	
	        case 'End':
	          if (!menuIsOpen) return;
	
	          _this.focusOption('last');
	
	          break;
	
	        default:
	          return;
	      }
	
	      event.preventDefault();
	    });
	
	    var value = _props.value;
	    _this.cacheComponents = memoizeOne(_this.cacheComponents, __chunk_2.exportedEqual).bind(_assertThisInitialized(_assertThisInitialized(_this)));
	
	    _this.cacheComponents(_props.components);
	
	    _this.instancePrefix = 'react-select-' + (_this.props.instanceId || ++instanceId);
	
	    var _selectValue = __chunk_1.cleanValue(value);
	
	    var _menuOptions = _props.menuIsOpen ? _this.buildMenuOptions(_props, _selectValue) : {
	      render: [],
	      focusable: []
	    };
	
	    _this.state.menuOptions = _menuOptions;
	    _this.state.selectValue = _selectValue;
	    return _this;
	  }
	
	  _createClass(Select, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.startListeningComposition();
	      this.startListeningToTouch();
	
	      if (this.props.closeMenuOnScroll && document && document.addEventListener) {
	        // Listen to all scroll events, and filter them out inside of 'onScroll'
	        document.addEventListener('scroll', this.onScroll, true);
	      }
	
	      if (this.props.autoFocus) {
	        this.focusInput();
	      }
	    }
	  }, {
	    key: "UNSAFE_componentWillReceiveProps",
	    value: function UNSAFE_componentWillReceiveProps(nextProps) {
	      var _this$props8 = this.props,
	          options = _this$props8.options,
	          value = _this$props8.value,
	          menuIsOpen = _this$props8.menuIsOpen,
	          inputValue = _this$props8.inputValue; // re-cache custom components
	
	      this.cacheComponents(nextProps.components); // rebuild the menu options
	
	      if (nextProps.value !== value || nextProps.options !== options || nextProps.menuIsOpen !== menuIsOpen || nextProps.inputValue !== inputValue) {
	        var selectValue = __chunk_1.cleanValue(nextProps.value);
	
	        var menuOptions = nextProps.menuIsOpen ? this.buildMenuOptions(nextProps, selectValue) : {
	          render: [],
	          focusable: []
	        };
	        var focusedValue = this.getNextFocusedValue(selectValue);
	        var focusedOption = this.getNextFocusedOption(menuOptions.focusable);
	        this.setState({
	          menuOptions: menuOptions,
	          selectValue: selectValue,
	          focusedOption: focusedOption,
	          focusedValue: focusedValue
	        });
	      } // some updates should toggle the state of the input visibility
	
	
	      if (this.inputIsHiddenAfterUpdate != null) {
	        this.setState({
	          inputIsHidden: this.inputIsHiddenAfterUpdate
	        });
	        delete this.inputIsHiddenAfterUpdate;
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var _this$props9 = this.props,
	          isDisabled = _this$props9.isDisabled,
	          menuIsOpen = _this$props9.menuIsOpen;
	      var isFocused = this.state.isFocused;
	
	      if ( // ensure focus is restored correctly when the control becomes enabled
	      isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
	      isFocused && menuIsOpen && !prevProps.menuIsOpen) {
	        this.focusInput();
	      } // scroll the focused option into view if necessary
	
	
	      if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
	        __chunk_1.scrollIntoView(this.menuListRef, this.focusedOptionRef);
	      }
	
	      this.scrollToFocusedOptionOnUpdate = false;
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.stopListeningComposition();
	      this.stopListeningToTouch();
	      document.removeEventListener('scroll', this.onScroll, true);
	    }
	  }, {
	    key: "onMenuOpen",
	    // ==============================
	    // Consumer Handlers
	    // ==============================
	    value: function onMenuOpen() {
	      this.props.onMenuOpen();
	    }
	  }, {
	    key: "onMenuClose",
	    value: function onMenuClose() {
	      var _this$props10 = this.props,
	          isSearchable = _this$props10.isSearchable,
	          isMulti = _this$props10.isMulti;
	      this.announceAriaLiveContext({
	        event: 'input',
	        context: {
	          isSearchable: isSearchable,
	          isMulti: isMulti
	        }
	      });
	      this.onInputChange('', {
	        action: 'menu-close'
	      });
	      this.props.onMenuClose();
	    }
	  }, {
	    key: "onInputChange",
	    value: function onInputChange(newValue, actionMeta) {
	      this.props.onInputChange(newValue, actionMeta);
	    } // ==============================
	    // Methods
	    // ==============================
	
	  }, {
	    key: "focusInput",
	    value: function focusInput() {
	      if (!this.inputRef) return;
	      this.inputRef.focus();
	    }
	  }, {
	    key: "blurInput",
	    value: function blurInput() {
	      if (!this.inputRef) return;
	      this.inputRef.blur();
	    } // aliased for consumers
	
	  }, {
	    key: "openMenu",
	    value: function openMenu(focusOption) {
	      var _this$state3 = this.state,
	          menuOptions = _this$state3.menuOptions,
	          selectValue = _this$state3.selectValue,
	          isFocused = _this$state3.isFocused;
	      var isMulti = this.props.isMulti;
	      var openAtIndex = focusOption === 'first' ? 0 : menuOptions.focusable.length - 1;
	
	      if (!isMulti) {
	        var selectedIndex = menuOptions.focusable.indexOf(selectValue[0]);
	
	        if (selectedIndex > -1) {
	          openAtIndex = selectedIndex;
	        }
	      } // only scroll if the menu isn't already open
	
	
	      this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
	      this.inputIsHiddenAfterUpdate = false;
	      this.onMenuOpen();
	      this.setState({
	        focusedValue: null,
	        focusedOption: menuOptions.focusable[openAtIndex]
	      });
	      this.announceAriaLiveContext({
	        event: 'menu'
	      });
	    }
	  }, {
	    key: "focusValue",
	    value: function focusValue(direction) {
	      var _this$props11 = this.props,
	          isMulti = _this$props11.isMulti,
	          isSearchable = _this$props11.isSearchable;
	      var _this$state4 = this.state,
	          selectValue = _this$state4.selectValue,
	          focusedValue = _this$state4.focusedValue; // Only multiselects support value focusing
	
	      if (!isMulti) return;
	      this.setState({
	        focusedOption: null
	      });
	      var focusedIndex = selectValue.indexOf(focusedValue);
	
	      if (!focusedValue) {
	        focusedIndex = -1;
	        this.announceAriaLiveContext({
	          event: 'value'
	        });
	      }
	
	      var lastIndex = selectValue.length - 1;
	      var nextFocus = -1;
	      if (!selectValue.length) return;
	
	      switch (direction) {
	        case 'previous':
	          if (focusedIndex === 0) {
	            // don't cycle from the start to the end
	            nextFocus = 0;
	          } else if (focusedIndex === -1) {
	            // if nothing is focused, focus the last value first
	            nextFocus = lastIndex;
	          } else {
	            nextFocus = focusedIndex - 1;
	          }
	
	          break;
	
	        case 'next':
	          if (focusedIndex > -1 && focusedIndex < lastIndex) {
	            nextFocus = focusedIndex + 1;
	          }
	
	          break;
	      }
	
	      if (nextFocus === -1) {
	        this.announceAriaLiveContext({
	          event: 'input',
	          context: {
	            isSearchable: isSearchable,
	            isMulti: isMulti
	          }
	        });
	      }
	
	      this.setState({
	        inputIsHidden: nextFocus !== -1,
	        focusedValue: selectValue[nextFocus]
	      });
	    }
	  }, {
	    key: "focusOption",
	    value: function focusOption() {
	      var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
	      var pageSize = this.props.pageSize;
	      var _this$state5 = this.state,
	          focusedOption = _this$state5.focusedOption,
	          menuOptions = _this$state5.menuOptions;
	      var options = menuOptions.focusable;
	      if (!options.length) return;
	      var nextFocus = 0; // handles 'first'
	
	      var focusedIndex = options.indexOf(focusedOption);
	
	      if (!focusedOption) {
	        focusedIndex = -1;
	        this.announceAriaLiveContext({
	          event: 'menu'
	        });
	      }
	
	      if (direction === 'up') {
	        nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
	      } else if (direction === 'down') {
	        nextFocus = (focusedIndex + 1) % options.length;
	      } else if (direction === 'pageup') {
	        nextFocus = focusedIndex - pageSize;
	        if (nextFocus < 0) nextFocus = 0;
	      } else if (direction === 'pagedown') {
	        nextFocus = focusedIndex + pageSize;
	        if (nextFocus > options.length - 1) nextFocus = options.length - 1;
	      } else if (direction === 'last') {
	        nextFocus = options.length - 1;
	      }
	
	      this.scrollToFocusedOptionOnUpdate = true;
	      this.setState({
	        focusedOption: options[nextFocus],
	        focusedValue: null
	      });
	      this.announceAriaLiveContext({
	        event: 'menu',
	        context: {
	          isDisabled: isOptionDisabled(options[nextFocus])
	        }
	      });
	    }
	  }, {
	    key: "getTheme",
	    // ==============================
	    // Getters
	    // ==============================
	    value: function getTheme() {
	      // Use the default theme if there are no customizations.
	      if (!this.props.theme) {
	        return defaultTheme;
	      } // If the theme prop is a function, assume the function
	      // knows how to merge the passed-in default theme with
	      // its own modifications.
	
	
	      if (typeof this.props.theme === 'function') {
	        return this.props.theme(defaultTheme);
	      } // Otherwise, if a plain theme object was passed in,
	      // overlay it with the default theme.
	
	
	      return _objectSpread({}, defaultTheme, this.props.theme);
	    }
	  }, {
	    key: "getCommonProps",
	    value: function getCommonProps() {
	      var clearValue = this.clearValue,
	          getStyles = this.getStyles,
	          setValue = this.setValue,
	          selectOption = this.selectOption,
	          props = this.props;
	      var classNamePrefix = props.classNamePrefix,
	          isMulti = props.isMulti,
	          isRtl = props.isRtl,
	          options = props.options;
	      var selectValue = this.state.selectValue;
	      var hasValue = this.hasValue();
	
	      var getValue = function getValue() {
	        return selectValue;
	      };
	
	      var cx = __chunk_1.classNames.bind(null, classNamePrefix);
	
	      return {
	        cx: cx,
	        clearValue: clearValue,
	        getStyles: getStyles,
	        getValue: getValue,
	        hasValue: hasValue,
	        isMulti: isMulti,
	        isRtl: isRtl,
	        options: options,
	        selectOption: selectOption,
	        setValue: setValue,
	        selectProps: props,
	        theme: this.getTheme()
	      };
	    }
	  }, {
	    key: "getNextFocusedValue",
	    value: function getNextFocusedValue(nextSelectValue) {
	      if (this.clearFocusValueOnUpdate) {
	        this.clearFocusValueOnUpdate = false;
	        return null;
	      }
	
	      var _this$state6 = this.state,
	          focusedValue = _this$state6.focusedValue,
	          lastSelectValue = _this$state6.selectValue;
	      var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
	
	      if (lastFocusedIndex > -1) {
	        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
	
	        if (nextFocusedIndex > -1) {
	          // the focused value is still in the selectValue, return it
	          return focusedValue;
	        } else if (lastFocusedIndex < nextSelectValue.length) {
	          // the focusedValue is not present in the next selectValue array by
	          // reference, so return the new value at the same index
	          return nextSelectValue[lastFocusedIndex];
	        }
	      }
	
	      return null;
	    }
	  }, {
	    key: "getNextFocusedOption",
	    value: function getNextFocusedOption(options) {
	      var lastFocusedOption = this.state.focusedOption;
	      return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
	    }
	  }, {
	    key: "hasValue",
	    value: function hasValue() {
	      var selectValue = this.state.selectValue;
	      return selectValue.length > 0;
	    }
	  }, {
	    key: "hasOptions",
	    value: function hasOptions() {
	      return !!this.state.menuOptions.render.length;
	    }
	  }, {
	    key: "countOptions",
	    value: function countOptions() {
	      return this.state.menuOptions.focusable.length;
	    }
	  }, {
	    key: "isClearable",
	    value: function isClearable() {
	      var _this$props12 = this.props,
	          isClearable = _this$props12.isClearable,
	          isMulti = _this$props12.isMulti; // single select, by default, IS NOT clearable
	      // multi select, by default, IS clearable
	
	      if (isClearable === undefined) return isMulti;
	      return isClearable;
	    }
	  }, {
	    key: "isOptionDisabled",
	    value: function isOptionDisabled(option, selectValue) {
	      return typeof this.props.isOptionDisabled === 'function' ? this.props.isOptionDisabled(option, selectValue) : false;
	    }
	  }, {
	    key: "isOptionSelected",
	    value: function isOptionSelected(option, selectValue) {
	      var _this2 = this;
	
	      if (selectValue.indexOf(option) > -1) return true;
	
	      if (typeof this.props.isOptionSelected === 'function') {
	        return this.props.isOptionSelected(option, selectValue);
	      }
	
	      var candidate = this.getOptionValue(option);
	      return selectValue.some(function (i) {
	        return _this2.getOptionValue(i) === candidate;
	      });
	    }
	  }, {
	    key: "filterOption",
	    value: function filterOption(option, inputValue) {
	      return this.props.filterOption ? this.props.filterOption(option, inputValue) : true;
	    }
	  }, {
	    key: "formatOptionLabel",
	    value: function formatOptionLabel(data, context) {
	      if (typeof this.props.formatOptionLabel === 'function') {
	        var inputValue = this.props.inputValue;
	        var selectValue = this.state.selectValue;
	        return this.props.formatOptionLabel(data, {
	          context: context,
	          inputValue: inputValue,
	          selectValue: selectValue
	        });
	      } else {
	        return this.getOptionLabel(data);
	      }
	    }
	  }, {
	    key: "formatGroupLabel",
	    value: function formatGroupLabel(data) {
	      return this.props.formatGroupLabel(data);
	    } // ==============================
	    // Mouse Handlers
	    // ==============================
	
	  }, {
	    key: "startListeningComposition",
	    // ==============================
	    // Composition Handlers
	    // ==============================
	    value: function startListeningComposition() {
	      if (document && document.addEventListener) {
	        document.addEventListener('compositionstart', this.onCompositionStart, false);
	        document.addEventListener('compositionend', this.onCompositionEnd, false);
	      }
	    }
	  }, {
	    key: "stopListeningComposition",
	    value: function stopListeningComposition() {
	      if (document && document.removeEventListener) {
	        document.removeEventListener('compositionstart', this.onCompositionStart);
	        document.removeEventListener('compositionend', this.onCompositionEnd);
	      }
	    }
	  }, {
	    key: "startListeningToTouch",
	    // ==============================
	    // Touch Handlers
	    // ==============================
	    value: function startListeningToTouch() {
	      if (document && document.addEventListener) {
	        document.addEventListener('touchstart', this.onTouchStart, false);
	        document.addEventListener('touchmove', this.onTouchMove, false);
	        document.addEventListener('touchend', this.onTouchEnd, false);
	      }
	    }
	  }, {
	    key: "stopListeningToTouch",
	    value: function stopListeningToTouch() {
	      if (document && document.removeEventListener) {
	        document.removeEventListener('touchstart', this.onTouchStart);
	        document.removeEventListener('touchmove', this.onTouchMove);
	        document.removeEventListener('touchend', this.onTouchEnd);
	      }
	    }
	  }, {
	    key: "buildMenuOptions",
	    // ==============================
	    // Menu Options
	    // ==============================
	    value: function buildMenuOptions(props, selectValue) {
	      var _this3 = this;
	
	      var _props$inputValue = props.inputValue,
	          inputValue = _props$inputValue === void 0 ? '' : _props$inputValue,
	          options = props.options;
	
	      var toOption = function toOption(option, id) {
	        var isDisabled = _this3.isOptionDisabled(option, selectValue);
	
	        var isSelected = _this3.isOptionSelected(option, selectValue);
	
	        var label = _this3.getOptionLabel(option);
	
	        var value = _this3.getOptionValue(option);
	
	        if (_this3.shouldHideSelectedOptions() && isSelected || !_this3.filterOption({
	          label: label,
	          value: value,
	          data: option
	        }, inputValue)) {
	          return;
	        }
	
	        var onHover = isDisabled ? undefined : function () {
	          return _this3.onOptionHover(option);
	        };
	        var onSelect = isDisabled ? undefined : function () {
	          return _this3.selectOption(option);
	        };
	        var optionId = "".concat(_this3.getElementId('option'), "-").concat(id);
	        return {
	          innerProps: {
	            id: optionId,
	            onClick: onSelect,
	            onMouseMove: onHover,
	            onMouseOver: onHover,
	            tabIndex: -1
	          },
	          data: option,
	          isDisabled: isDisabled,
	          isSelected: isSelected,
	          key: optionId,
	          label: label,
	          type: 'option',
	          value: value
	        };
	      };
	
	      return options.reduce(function (acc, item, itemIndex) {
	        if (item.options) {
	          // TODO needs a tidier implementation
	          if (!_this3.hasGroups) _this3.hasGroups = true;
	          var items = item.options;
	          var children = items.map(function (child, i) {
	            var option = toOption(child, "".concat(itemIndex, "-").concat(i));
	            if (option) acc.focusable.push(child);
	            return option;
	          }).filter(Boolean);
	
	          if (children.length) {
	            var groupId = "".concat(_this3.getElementId('group'), "-").concat(itemIndex);
	            acc.render.push({
	              type: 'group',
	              key: groupId,
	              data: item,
	              options: children
	            });
	          }
	        } else {
	          var option = toOption(item, "".concat(itemIndex));
	
	          if (option) {
	            acc.render.push(option);
	            acc.focusable.push(item);
	          }
	        }
	
	        return acc;
	      }, {
	        render: [],
	        focusable: []
	      });
	    } // ==============================
	    // Renderers
	    // ==============================
	
	  }, {
	    key: "constructAriaLiveMessage",
	    value: function constructAriaLiveMessage() {
	      var _this$state7 = this.state,
	          ariaLiveContext = _this$state7.ariaLiveContext,
	          selectValue = _this$state7.selectValue,
	          focusedValue = _this$state7.focusedValue,
	          focusedOption = _this$state7.focusedOption;
	      var _this$props13 = this.props,
	          options = _this$props13.options,
	          menuIsOpen = _this$props13.menuIsOpen,
	          inputValue = _this$props13.inputValue,
	          screenReaderStatus = _this$props13.screenReaderStatus; // An aria live message representing the currently focused value in the select.
	
	      var focusedValueMsg = focusedValue ? valueFocusAriaMessage({
	        focusedValue: focusedValue,
	        getOptionLabel: this.getOptionLabel,
	        selectValue: selectValue
	      }) : ''; // An aria live message representing the currently focused option in the select.
	
	      var focusedOptionMsg = focusedOption && menuIsOpen ? optionFocusAriaMessage({
	        focusedOption: focusedOption,
	        getOptionLabel: this.getOptionLabel,
	        options: options
	      }) : ''; // An aria live message representing the set of focusable results and current searchterm/inputvalue.
	
	      var resultsMsg = resultsAriaMessage({
	        inputValue: inputValue,
	        screenReaderMessage: screenReaderStatus({
	          count: this.countOptions()
	        })
	      });
	      return "".concat(focusedValueMsg, " ").concat(focusedOptionMsg, " ").concat(resultsMsg, " ").concat(ariaLiveContext);
	    }
	  }, {
	    key: "renderInput",
	    value: function renderInput() {
	      var _this$props14 = this.props,
	          isDisabled = _this$props14.isDisabled,
	          isSearchable = _this$props14.isSearchable,
	          inputId = _this$props14.inputId,
	          inputValue = _this$props14.inputValue,
	          tabIndex = _this$props14.tabIndex;
	      var Input = this.components.Input;
	      var inputIsHidden = this.state.inputIsHidden;
	      var id = inputId || this.getElementId('input');
	
	      if (!isSearchable) {
	        // use a dummy input to maintain focus/blur functionality
	        return React__default.createElement(DummyInput, {
	          id: id,
	          innerRef: this.getInputRef,
	          onBlur: this.onInputBlur,
	          onChange: __chunk_1.noop,
	          onFocus: this.onInputFocus,
	          readOnly: true,
	          disabled: isDisabled,
	          tabIndex: tabIndex,
	          value: ""
	        });
	      } // aria attributes makes the JSX "noisy", separated for clarity
	
	
	      var ariaAttributes = {
	        'aria-autocomplete': 'list',
	        'aria-label': this.props['aria-label'],
	        'aria-labelledby': this.props['aria-labelledby']
	      };
	      var _this$commonProps = this.commonProps,
	          cx = _this$commonProps.cx,
	          theme = _this$commonProps.theme,
	          selectProps = _this$commonProps.selectProps;
	      return React__default.createElement(Input, _extends({
	        autoCapitalize: "none",
	        autoComplete: "off",
	        autoCorrect: "off",
	        cx: cx,
	        getStyles: this.getStyles,
	        id: id,
	        innerRef: this.getInputRef,
	        isDisabled: isDisabled,
	        isHidden: inputIsHidden,
	        onBlur: this.onInputBlur,
	        onChange: this.handleInputChange,
	        onFocus: this.onInputFocus,
	        selectProps: selectProps,
	        spellCheck: "false",
	        tabIndex: tabIndex,
	        theme: theme,
	        type: "text",
	        value: inputValue
	      }, ariaAttributes));
	    }
	  }, {
	    key: "renderPlaceholderOrValue",
	    value: function renderPlaceholderOrValue() {
	      var _this4 = this;
	
	      var _this$components = this.components,
	          MultiValue = _this$components.MultiValue,
	          MultiValueContainer = _this$components.MultiValueContainer,
	          MultiValueLabel = _this$components.MultiValueLabel,
	          MultiValueRemove = _this$components.MultiValueRemove,
	          SingleValue = _this$components.SingleValue,
	          Placeholder = _this$components.Placeholder;
	      var commonProps = this.commonProps;
	      var _this$props15 = this.props,
	          controlShouldRenderValue = _this$props15.controlShouldRenderValue,
	          isDisabled = _this$props15.isDisabled,
	          isMulti = _this$props15.isMulti,
	          inputValue = _this$props15.inputValue,
	          placeholder = _this$props15.placeholder;
	      var _this$state8 = this.state,
	          selectValue = _this$state8.selectValue,
	          focusedValue = _this$state8.focusedValue,
	          isFocused = _this$state8.isFocused;
	
	      if (!this.hasValue() || !controlShouldRenderValue) {
	        return inputValue ? null : React__default.createElement(Placeholder, _extends({}, commonProps, {
	          key: "placeholder",
	          isDisabled: isDisabled,
	          isFocused: isFocused
	        }), placeholder);
	      }
	
	      if (isMulti) {
	        var selectValues = selectValue.map(function (opt, index) {
	          var isOptionFocused = opt === focusedValue;
	          return React__default.createElement(MultiValue, _extends({}, commonProps, {
	            components: {
	              Container: MultiValueContainer,
	              Label: MultiValueLabel,
	              Remove: MultiValueRemove
	            },
	            isFocused: isOptionFocused,
	            isDisabled: isDisabled,
	            key: _this4.getOptionValue(opt),
	            index: index,
	            removeProps: {
	              onClick: function onClick() {
	                return _this4.removeValue(opt);
	              },
	              onTouchEnd: function onTouchEnd() {
	                return _this4.removeValue(opt);
	              },
	              onMouseDown: function onMouseDown(e) {
	                e.preventDefault();
	                e.stopPropagation();
	              }
	            },
	            data: opt
	          }), _this4.formatOptionLabel(opt, 'value'));
	        });
	        return selectValues;
	      }
	
	      if (inputValue) {
	        return null;
	      }
	
	      var singleValue = selectValue[0];
	      return React__default.createElement(SingleValue, _extends({}, commonProps, {
	        data: singleValue,
	        isDisabled: isDisabled
	      }), this.formatOptionLabel(singleValue, 'value'));
	    }
	  }, {
	    key: "renderClearIndicator",
	    value: function renderClearIndicator() {
	      var ClearIndicator = this.components.ClearIndicator;
	      var commonProps = this.commonProps;
	      var _this$props16 = this.props,
	          isDisabled = _this$props16.isDisabled,
	          isLoading = _this$props16.isLoading;
	      var isFocused = this.state.isFocused;
	
	      if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) {
	        return null;
	      }
	
	      var innerProps = {
	        onMouseDown: this.onClearIndicatorMouseDown,
	        onTouchEnd: this.onClearIndicatorTouchEnd,
	        'aria-hidden': 'true'
	      };
	      return React__default.createElement(ClearIndicator, _extends({}, commonProps, {
	        innerProps: innerProps,
	        isFocused: isFocused
	      }));
	    }
	  }, {
	    key: "renderLoadingIndicator",
	    value: function renderLoadingIndicator() {
	      var LoadingIndicator = this.components.LoadingIndicator;
	      var commonProps = this.commonProps;
	      var _this$props17 = this.props,
	          isDisabled = _this$props17.isDisabled,
	          isLoading = _this$props17.isLoading;
	      var isFocused = this.state.isFocused;
	      if (!LoadingIndicator || !isLoading) return null;
	      var innerProps = {
	        'aria-hidden': 'true'
	      };
	      return React__default.createElement(LoadingIndicator, _extends({}, commonProps, {
	        innerProps: innerProps,
	        isDisabled: isDisabled,
	        isFocused: isFocused
	      }));
	    }
	  }, {
	    key: "renderIndicatorSeparator",
	    value: function renderIndicatorSeparator() {
	      var _this$components2 = this.components,
	          DropdownIndicator = _this$components2.DropdownIndicator,
	          IndicatorSeparator = _this$components2.IndicatorSeparator; // separator doesn't make sense without the dropdown indicator
	
	      if (!DropdownIndicator || !IndicatorSeparator) return null;
	      var commonProps = this.commonProps;
	      var isDisabled = this.props.isDisabled;
	      var isFocused = this.state.isFocused;
	      return React__default.createElement(IndicatorSeparator, _extends({}, commonProps, {
	        isDisabled: isDisabled,
	        isFocused: isFocused
	      }));
	    }
	  }, {
	    key: "renderDropdownIndicator",
	    value: function renderDropdownIndicator() {
	      var DropdownIndicator = this.components.DropdownIndicator;
	      if (!DropdownIndicator) return null;
	      var commonProps = this.commonProps;
	      var isDisabled = this.props.isDisabled;
	      var isFocused = this.state.isFocused;
	      var innerProps = {
	        onMouseDown: this.onDropdownIndicatorMouseDown,
	        onTouchEnd: this.onDropdownIndicatorTouchEnd,
	        'aria-hidden': 'true'
	      };
	      return React__default.createElement(DropdownIndicator, _extends({}, commonProps, {
	        innerProps: innerProps,
	        isDisabled: isDisabled,
	        isFocused: isFocused
	      }));
	    }
	  }, {
	    key: "renderMenu",
	    value: function renderMenu() {
	      var _this5 = this;
	
	      var _this$components3 = this.components,
	          Group = _this$components3.Group,
	          GroupHeading = _this$components3.GroupHeading,
	          Menu = _this$components3.Menu,
	          MenuList = _this$components3.MenuList,
	          MenuPortal = _this$components3.MenuPortal,
	          LoadingMessage = _this$components3.LoadingMessage,
	          NoOptionsMessage = _this$components3.NoOptionsMessage,
	          Option = _this$components3.Option;
	      var commonProps = this.commonProps;
	      var _this$state9 = this.state,
	          focusedOption = _this$state9.focusedOption,
	          menuOptions = _this$state9.menuOptions;
	      var _this$props18 = this.props,
	          captureMenuScroll = _this$props18.captureMenuScroll,
	          inputValue = _this$props18.inputValue,
	          isLoading = _this$props18.isLoading,
	          loadingMessage = _this$props18.loadingMessage,
	          minMenuHeight = _this$props18.minMenuHeight,
	          maxMenuHeight = _this$props18.maxMenuHeight,
	          menuIsOpen = _this$props18.menuIsOpen,
	          menuPlacement = _this$props18.menuPlacement,
	          menuPosition = _this$props18.menuPosition,
	          menuPortalTarget = _this$props18.menuPortalTarget,
	          menuShouldBlockScroll = _this$props18.menuShouldBlockScroll,
	          menuShouldScrollIntoView = _this$props18.menuShouldScrollIntoView,
	          noOptionsMessage = _this$props18.noOptionsMessage,
	          onMenuScrollToTop = _this$props18.onMenuScrollToTop,
	          onMenuScrollToBottom = _this$props18.onMenuScrollToBottom;
	      if (!menuIsOpen) return null; // TODO: Internal Option Type here
	
	      var render = function render(props) {
	        // for performance, the menu options in state aren't changed when the
	        // focused option changes so we calculate additional props based on that
	        var isFocused = focusedOption === props.data;
	        props.innerRef = isFocused ? _this5.getFocusedOptionRef : undefined;
	        return React__default.createElement(Option, _extends({}, commonProps, props, {
	          isFocused: isFocused
	        }), _this5.formatOptionLabel(props.data, 'menu'));
	      };
	
	      var menuUI;
	
	      if (this.hasOptions()) {
	        menuUI = menuOptions.render.map(function (item) {
	          if (item.type === 'group') {
	            var type = item.type,
	                group = _objectWithoutProperties(item, ["type"]);
	
	            var headingId = "".concat(item.key, "-heading");
	            return React__default.createElement(Group, _extends({}, commonProps, group, {
	              Heading: GroupHeading,
	              headingProps: {
	                id: headingId
	              },
	              label: _this5.formatGroupLabel(item.data)
	            }), item.options.map(function (option) {
	              return render(option);
	            }));
	          } else if (item.type === 'option') {
	            return render(item);
	          }
	        });
	      } else if (isLoading) {
	        var message = loadingMessage({
	          inputValue: inputValue
	        });
	        if (message === null) return null;
	        menuUI = React__default.createElement(LoadingMessage, commonProps, message);
	      } else {
	        var _message = noOptionsMessage({
	          inputValue: inputValue
	        });
	
	        if (_message === null) return null;
	        menuUI = React__default.createElement(NoOptionsMessage, commonProps, _message);
	      }
	
	      var menuPlacementProps = {
	        minMenuHeight: minMenuHeight,
	        maxMenuHeight: maxMenuHeight,
	        menuPlacement: menuPlacement,
	        menuPosition: menuPosition,
	        menuShouldScrollIntoView: menuShouldScrollIntoView
	      };
	      var menuElement = React__default.createElement(__chunk_2.MenuPlacer, _extends({}, commonProps, menuPlacementProps), function (_ref6) {
	        var ref = _ref6.ref,
	            _ref6$placerProps = _ref6.placerProps,
	            placement = _ref6$placerProps.placement,
	            maxHeight = _ref6$placerProps.maxHeight;
	        return React__default.createElement(Menu, _extends({}, commonProps, menuPlacementProps, {
	          innerRef: ref,
	          innerProps: {
	            onMouseDown: _this5.onMenuMouseDown,
	            onMouseMove: _this5.onMenuMouseMove
	          },
	          isLoading: isLoading,
	          placement: placement
	        }), React__default.createElement(ScrollCaptorSwitch, {
	          isEnabled: captureMenuScroll,
	          onTopArrive: onMenuScrollToTop,
	          onBottomArrive: onMenuScrollToBottom
	        }, React__default.createElement(ScrollBlock, {
	          isEnabled: menuShouldBlockScroll
	        }, React__default.createElement(MenuList, _extends({}, commonProps, {
	          innerRef: _this5.getMenuListRef,
	          isLoading: isLoading,
	          maxHeight: maxHeight
	        }), menuUI))));
	      }); // positioning behaviour is almost identical for portalled and fixed,
	      // so we use the same component. the actual portalling logic is forked
	      // within the component based on `menuPosition`
	
	      return menuPortalTarget || menuPosition === 'fixed' ? React__default.createElement(MenuPortal, _extends({}, commonProps, {
	        appendTo: menuPortalTarget,
	        controlElement: this.controlRef,
	        menuPlacement: menuPlacement,
	        menuPosition: menuPosition
	      }), menuElement) : menuElement;
	    }
	  }, {
	    key: "renderFormField",
	    value: function renderFormField() {
	      var _this6 = this;
	
	      var _this$props19 = this.props,
	          delimiter = _this$props19.delimiter,
	          isDisabled = _this$props19.isDisabled,
	          isMulti = _this$props19.isMulti,
	          name = _this$props19.name;
	      var selectValue = this.state.selectValue;
	      if (!name || isDisabled) return;
	
	      if (isMulti) {
	        if (delimiter) {
	          var value = selectValue.map(function (opt) {
	            return _this6.getOptionValue(opt);
	          }).join(delimiter);
	          return React__default.createElement("input", {
	            name: name,
	            type: "hidden",
	            value: value
	          });
	        } else {
	          var input = selectValue.length > 0 ? selectValue.map(function (opt, i) {
	            return React__default.createElement("input", {
	              key: "i-".concat(i),
	              name: name,
	              type: "hidden",
	              value: _this6.getOptionValue(opt)
	            });
	          }) : React__default.createElement("input", {
	            name: name,
	            type: "hidden"
	          });
	          return React__default.createElement("div", null, input);
	        }
	      } else {
	        var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
	
	        return React__default.createElement("input", {
	          name: name,
	          type: "hidden",
	          value: _value
	        });
	      }
	    }
	  }, {
	    key: "renderLiveRegion",
	    value: function renderLiveRegion() {
	      if (!this.state.isFocused) return null;
	      return React__default.createElement(A11yText, {
	        "aria-live": "polite"
	      }, React__default.createElement("p", {
	        id: "aria-selection-event"
	      }, "\xA0", this.state.ariaLiveSelection), React__default.createElement("p", {
	        id: "aria-context"
	      }, "\xA0", this.constructAriaLiveMessage()));
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$components4 = this.components,
	          Control = _this$components4.Control,
	          IndicatorsContainer = _this$components4.IndicatorsContainer,
	          SelectContainer = _this$components4.SelectContainer,
	          ValueContainer = _this$components4.ValueContainer;
	      var _this$props20 = this.props,
	          className = _this$props20.className,
	          id = _this$props20.id,
	          isDisabled = _this$props20.isDisabled,
	          menuIsOpen = _this$props20.menuIsOpen;
	      var isFocused = this.state.isFocused;
	      var commonProps = this.commonProps = this.getCommonProps();
	      return React__default.createElement(SelectContainer, _extends({}, commonProps, {
	        className: className,
	        innerProps: {
	          id: id,
	          onKeyDown: this.onKeyDown
	        },
	        isDisabled: isDisabled,
	        isFocused: isFocused
	      }), this.renderLiveRegion(), React__default.createElement(Control, _extends({}, commonProps, {
	        innerRef: this.getControlRef,
	        innerProps: {
	          onMouseDown: this.onControlMouseDown,
	          onTouchEnd: this.onControlTouchEnd
	        },
	        isDisabled: isDisabled,
	        isFocused: isFocused,
	        menuIsOpen: menuIsOpen
	      }), React__default.createElement(ValueContainer, _extends({}, commonProps, {
	        isDisabled: isDisabled
	      }), this.renderPlaceholderOrValue(), this.renderInput()), React__default.createElement(IndicatorsContainer, _extends({}, commonProps, {
	        isDisabled: isDisabled
	      }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
	    }
	  }]);
	
	  return Select;
	}(React.Component);
	
	_defineProperty(Select, "defaultProps", defaultProps);
	
	exports.Select = Select;
	exports.createFilter = createFilter;
	exports.defaultProps = defaultProps;
	exports.defaultTheme = defaultTheme;
	exports.mergeStyles = mergeStyles;


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault(ex) {
	  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
	}
	
	var _objectWithoutProperties = _interopDefault(__webpack_require__(72));
	
	var _extends = _interopDefault(__webpack_require__(57));
	
	var _classCallCheck = _interopDefault(__webpack_require__(68));
	
	var _createClass = _interopDefault(__webpack_require__(69));
	
	var _possibleConstructorReturn = _interopDefault(__webpack_require__(73));
	
	var _getPrototypeOf = _interopDefault(__webpack_require__(70));
	
	var _inherits = _interopDefault(__webpack_require__(71));
	
	var _assertThisInitialized = _interopDefault(__webpack_require__(55));
	
	var _defineProperty = _interopDefault(__webpack_require__(56));
	
	var React = __webpack_require__(2);
	
	var React__default = _interopDefault(React);
	
	var defaultProps = {
	  defaultInputValue: '',
	  defaultMenuIsOpen: false,
	  defaultValue: null
	};
	
	var manageState = function manageState(SelectComponent) {
	  var _class, _temp;
	
	  return _temp = _class =
	  /*#__PURE__*/
	  function (_Component) {
	    _inherits(StateManager, _Component);
	
	    function StateManager() {
	      var _getPrototypeOf2;
	
	      var _this;
	
	      _classCallCheck(this, StateManager);
	
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(StateManager)).call.apply(_getPrototypeOf2, [this].concat(args)));
	
	      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "select", void 0);
	
	      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
	        inputValue: _this.props.inputValue !== undefined ? _this.props.inputValue : _this.props.defaultInputValue,
	        menuIsOpen: _this.props.menuIsOpen !== undefined ? _this.props.menuIsOpen : _this.props.defaultMenuIsOpen,
	        value: _this.props.value !== undefined ? _this.props.value : _this.props.defaultValue
	      });
	
	      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onChange", function (value, actionMeta) {
	        _this.callProp('onChange', value, actionMeta);
	
	        _this.setState({
	          value: value
	        });
	      });
	
	      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onInputChange", function (value, actionMeta) {
	        // TODO: for backwards compatibility, we allow the prop to return a new
	        // value, but now inputValue is a controllable prop we probably shouldn't
	        var newValue = _this.callProp('onInputChange', value, actionMeta);
	
	        _this.setState({
	          inputValue: newValue !== undefined ? newValue : value
	        });
	      });
	
	      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onMenuOpen", function () {
	        _this.callProp('onMenuOpen');
	
	        _this.setState({
	          menuIsOpen: true
	        });
	      });
	
	      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onMenuClose", function () {
	        _this.callProp('onMenuClose');
	
	        _this.setState({
	          menuIsOpen: false
	        });
	      });
	
	      return _this;
	    }
	
	    _createClass(StateManager, [{
	      key: "focus",
	      value: function focus() {
	        this.select.focus();
	      }
	    }, {
	      key: "blur",
	      value: function blur() {
	        this.select.blur();
	      } // FIXME: untyped flow code, return any
	
	    }, {
	      key: "getProp",
	      value: function getProp(key) {
	        return this.props[key] !== undefined ? this.props[key] : this.state[key];
	      } // FIXME: untyped flow code, return any
	
	    }, {
	      key: "callProp",
	      value: function callProp(name) {
	        if (typeof this.props[name] === 'function') {
	          var _this$props;
	
	          for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	            args[_key2 - 1] = arguments[_key2];
	          }
	
	          return (_this$props = this.props)[name].apply(_this$props, args);
	        }
	      }
	    }, {
	      key: "render",
	      value: function render() {
	        var _this2 = this;
	
	        var _this$props2 = this.props,
	            defaultInputValue = _this$props2.defaultInputValue,
	            defaultMenuIsOpen = _this$props2.defaultMenuIsOpen,
	            defaultValue = _this$props2.defaultValue,
	            props = _objectWithoutProperties(_this$props2, ["defaultInputValue", "defaultMenuIsOpen", "defaultValue"]);
	
	        return React__default.createElement(SelectComponent, _extends({}, props, {
	          ref: function ref(_ref) {
	            _this2.select = _ref;
	          },
	          inputValue: this.getProp('inputValue'),
	          menuIsOpen: this.getProp('menuIsOpen'),
	          onChange: this.onChange,
	          onInputChange: this.onInputChange,
	          onMenuClose: this.onMenuClose,
	          onMenuOpen: this.onMenuOpen,
	          value: this.getProp('value')
	        }));
	      }
	    }]);
	
	    return StateManager;
	  }(React.Component), _defineProperty(_class, "defaultProps", defaultProps), _temp;
	};
	
	exports.manageState = manageState;


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

	!function(e,t){ true?module.exports=t(__webpack_require__(1),__webpack_require__(2),__webpack_require__(903),__webpack_require__(917)):"function"==typeof define&&define.amd?define(["prop-types","react","signature_pad","trim-canvas"],t):"object"==typeof exports?exports.SignatureCanvas=t(require("prop-types"),require("react"),require("signature_pad"),require("trim-canvas")):e.SignatureCanvas=t(e["prop-types"],e.react,e.signature_pad,e["trim-canvas"])}(this,function(e,t,n,r){return function(e){function t(r){if(n[r])return n[r].exports;var a=n[r]={exports:{},id:r,loaded:!1};return e[r].call(a.exports,a,a.exports,t),a.loaded=!0,a.exports}var n={};return t.m=e,t.c=n,t.p="",t(0)}([function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function a(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function u(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},c=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),f=n(1),p=r(f),l=n(2),d=r(l),v=n(3),h=r(v),_=n(4),g=r(_),m=function(e){function t(){var e,n,r,u;o(this,t);for(var s=arguments.length,c=Array(s),f=0;f<s;f++)c[f]=arguments[f];return n=r=i(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(c))),r._sigPad=null,r._excludeOurProps=function(){var e=r.props,t=(e.canvasProps,e.clearOnResize,a(e,["canvasProps","clearOnResize"]));return t},r.getCanvas=function(){return r._canvas},r.getTrimmedCanvas=function(){var e=document.createElement("canvas");return e.width=r._canvas.width,e.height=r._canvas.height,e.getContext("2d").drawImage(r._canvas,0,0),(0,g.default)(e)},r.getSignaturePad=function(){return r._sigPad},r._checkClearOnResize=function(){r.props.clearOnResize&&r._resizeCanvas()},r._resizeCanvas=function(){var e=r.props.canvasProps||{},t=e.width,n=e.height;if(!t||!n){var a=r._canvas,o=Math.max(window.devicePixelRatio||1,1);t||(a.width=a.offsetWidth*o),n||(a.height=a.offsetHeight*o),a.getContext("2d").scale(o,o),r.clear()}},r.on=function(){return window.addEventListener("resize",r._checkClearOnResize),r._sigPad.on()},r.off=function(){return window.removeEventListener("resize",r._checkClearOnResize),r._sigPad.off()},r.clear=function(){return r._sigPad.clear()},r.isEmpty=function(){return r._sigPad.isEmpty()},r.fromDataURL=function(e,t){return r._sigPad.fromDataURL(e,t)},r.toDataURL=function(e,t){return r._sigPad.toDataURL(e,t)},r.fromData=function(e){return r._sigPad.fromData(e)},r.toData=function(){return r._sigPad.toData()},u=n,i(r,u)}return u(t,e),c(t,[{key:"componentDidMount",value:function(){this._sigPad=new h.default(this._canvas,this._excludeOurProps()),this._resizeCanvas(),this.on()}},{key:"componentWillUnmount",value:function(){this.off()}},{key:"componentDidUpdate",value:function(){Object.assign(this._sigPad,this._excludeOurProps())}},{key:"render",value:function(){var e=this,t=this.props.canvasProps;return d.default.createElement("canvas",s({ref:function(t){e._canvas=t}},t))}}]),t}(l.Component);m.propTypes={velocityFilterWeight:p.default.number,minWidth:p.default.number,maxWidth:p.default.number,minDistance:p.default.number,dotSize:p.default.oneOfType([p.default.number,p.default.func]),penColor:p.default.string,throttle:p.default.number,onEnd:p.default.func,onBegin:p.default.func,canvasProps:p.default.object,clearOnResize:p.default.bool},m.defaultProps={clearOnResize:!0},t.default=m},function(t,n){t.exports=e},function(e,n){e.exports=t},function(e,t){e.exports=n},function(e,t){e.exports=r}])});

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = _interopDefault(__webpack_require__(2));
	var PropTypes = _interopDefault(__webpack_require__(1));
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  return _extends.apply(this, arguments);
	}
	
	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}
	
	function _objectWithoutProperties(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;
	
	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }
	
	  if (Object.getOwnPropertySymbols) {
	    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
	
	    for (i = 0; i < sourceSymbolKeys.length; i++) {
	      key = sourceSymbolKeys[i];
	      if (excluded.indexOf(key) >= 0) continue;
	      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
	      target[key] = source[key];
	    }
	  }
	
	  return target;
	}
	
	var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
	
	var isIE = isBrowser ? !!document.documentElement.currentStyle : false;
	var hiddenTextarea = isBrowser && document.createElement('textarea');
	var HIDDEN_TEXTAREA_STYLE = {
	  'min-height': '0',
	  'max-height': 'none',
	  height: '0',
	  visibility: 'hidden',
	  overflow: 'hidden',
	  position: 'absolute',
	  'z-index': '-1000',
	  top: '0',
	  right: '0'
	};
	var SIZING_STYLE = ['letter-spacing', 'line-height', 'font-family', 'font-weight', 'font-size', 'font-style', 'tab-size', 'text-rendering', 'text-transform', 'width', 'text-indent', 'padding-top', 'padding-right', 'padding-bottom', 'padding-left', 'border-top-width', 'border-right-width', 'border-bottom-width', 'border-left-width', 'box-sizing'];
	var computedStyleCache = {};
	function calculateNodeHeight(uiTextNode, uid, useCache, minRows, maxRows) {
	  if (useCache === void 0) {
	    useCache = false;
	  }
	
	  if (minRows === void 0) {
	    minRows = null;
	  }
	
	  if (maxRows === void 0) {
	    maxRows = null;
	  }
	
	  if (hiddenTextarea.parentNode === null) {
	    document.body.appendChild(hiddenTextarea);
	  } // Copy all CSS properties that have an impact on the height of the content in
	  // the textbox
	
	
	  var nodeStyling = calculateNodeStyling(uiTextNode, uid, useCache);
	
	  if (nodeStyling === null) {
	    return null;
	  }
	
	  var paddingSize = nodeStyling.paddingSize,
	      borderSize = nodeStyling.borderSize,
	      boxSizing = nodeStyling.boxSizing,
	      sizingStyle = nodeStyling.sizingStyle; // Need to have the overflow attribute to hide the scrollbar otherwise
	  // text-lines will not calculated properly as the shadow will technically be
	  // narrower for content
	
	  Object.keys(sizingStyle).forEach(function (key) {
	    hiddenTextarea.style[key] = sizingStyle[key];
	  });
	  Object.keys(HIDDEN_TEXTAREA_STYLE).forEach(function (key) {
	    hiddenTextarea.style.setProperty(key, HIDDEN_TEXTAREA_STYLE[key], 'important');
	  });
	  hiddenTextarea.value = uiTextNode.value || uiTextNode.placeholder || 'x';
	  var minHeight = -Infinity;
	  var maxHeight = Infinity;
	  var height = hiddenTextarea.scrollHeight;
	
	  if (boxSizing === 'border-box') {
	    // border-box: add border, since height = content + padding + border
	    height = height + borderSize;
	  } else if (boxSizing === 'content-box') {
	    // remove padding, since height = content
	    height = height - paddingSize;
	  } // measure height of a textarea with a single row
	
	
	  hiddenTextarea.value = 'x';
	  var singleRowHeight = hiddenTextarea.scrollHeight - paddingSize;
	
	  if (minRows !== null || maxRows !== null) {
	    if (minRows !== null) {
	      minHeight = singleRowHeight * minRows;
	
	      if (boxSizing === 'border-box') {
	        minHeight = minHeight + paddingSize + borderSize;
	      }
	
	      height = Math.max(minHeight, height);
	    }
	
	    if (maxRows !== null) {
	      maxHeight = singleRowHeight * maxRows;
	
	      if (boxSizing === 'border-box') {
	        maxHeight = maxHeight + paddingSize + borderSize;
	      }
	
	      height = Math.min(maxHeight, height);
	    }
	  }
	
	  var rowCount = Math.floor(height / singleRowHeight);
	  return {
	    height: height,
	    minHeight: minHeight,
	    maxHeight: maxHeight,
	    rowCount: rowCount
	  };
	}
	
	function calculateNodeStyling(node, uid, useCache) {
	  if (useCache === void 0) {
	    useCache = false;
	  }
	
	  if (useCache && computedStyleCache[uid]) {
	    return computedStyleCache[uid];
	  }
	
	  var style = window.getComputedStyle(node);
	
	  if (style === null) {
	    return null;
	  }
	
	  var sizingStyle = SIZING_STYLE.reduce(function (obj, name) {
	    obj[name] = style.getPropertyValue(name);
	    return obj;
	  }, {});
	  var boxSizing = sizingStyle['box-sizing']; // IE (Edge has already correct behaviour) returns content width as computed width
	  // so we need to add manually padding and border widths
	
	  if (isIE && boxSizing === 'border-box') {
	    sizingStyle.width = parseFloat(sizingStyle.width) + parseFloat(style['border-right-width']) + parseFloat(style['border-left-width']) + parseFloat(style['padding-right']) + parseFloat(style['padding-left']) + 'px';
	  }
	
	  var paddingSize = parseFloat(sizingStyle['padding-bottom']) + parseFloat(sizingStyle['padding-top']);
	  var borderSize = parseFloat(sizingStyle['border-bottom-width']) + parseFloat(sizingStyle['border-top-width']);
	  var nodeInfo = {
	    sizingStyle: sizingStyle,
	    paddingSize: paddingSize,
	    borderSize: borderSize,
	    boxSizing: boxSizing
	  };
	
	  if (useCache) {
	    computedStyleCache[uid] = nodeInfo;
	  }
	
	  return nodeInfo;
	}
	
	var purgeCache = function purgeCache(uid) {
	  return delete computedStyleCache[uid];
	};
	
	function autoInc(seed) {
	  if (seed === void 0) {
	    seed = 0;
	  }
	
	  return function () {
	    return ++seed;
	  };
	}
	
	var uid = autoInc();
	
	/**
	 * <TextareaAutosize />
	 */
	var noop = function noop() {}; // IE11 has a problem with eval source maps, can be reproduced with:
	// eval('"use strict"; var onNextFrame = window.cancelAnimationFrame; onNextFrame(4);')
	// so we bind window as context in dev modes
	
	
	var _ref = isBrowser && window.requestAnimationFrame ?  true ? [window.requestAnimationFrame, window.cancelAnimationFrame] : [window.requestAnimationFrame.bind(window), window.cancelAnimationFrame.bind(window)] : [setTimeout, clearTimeout];
	var onNextFrame = _ref[0];
	var clearNextFrameAction = _ref[1];
	
	var TextareaAutosize =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(TextareaAutosize, _React$Component);
	
	  function TextareaAutosize(props) {
	    var _this;
	
	    _this = _React$Component.call(this, props) || this;
	    _this._resizeLock = false;
	
	    _this._onRootDOMNode = function (node) {
	      _this._rootDOMNode = node;
	
	      if (_this.props.inputRef) {
	        _this.props.inputRef(node);
	      }
	    };
	
	    _this._onChange = function (event) {
	      if (!_this._controlled) {
	        _this._resizeComponent();
	      }
	
	      _this.props.onChange(event);
	    };
	
	    _this._resizeComponent = function (callback) {
	      if (callback === void 0) {
	        callback = noop;
	      }
	
	      if (typeof _this._rootDOMNode === 'undefined') {
	        callback();
	        return;
	      }
	
	      var nodeHeight = calculateNodeHeight(_this._rootDOMNode, _this._uid, _this.props.useCacheForDOMMeasurements, _this.props.minRows, _this.props.maxRows);
	
	      if (nodeHeight === null) {
	        callback();
	        return;
	      }
	
	      var height = nodeHeight.height,
	          minHeight = nodeHeight.minHeight,
	          maxHeight = nodeHeight.maxHeight,
	          rowCount = nodeHeight.rowCount;
	      _this.rowCount = rowCount;
	
	      if (_this.state.height !== height || _this.state.minHeight !== minHeight || _this.state.maxHeight !== maxHeight) {
	        _this.setState({
	          height: height,
	          minHeight: minHeight,
	          maxHeight: maxHeight
	        }, callback);
	
	        return;
	      }
	
	      callback();
	    };
	
	    _this.state = {
	      height: props.style && props.style.height || 0,
	      minHeight: -Infinity,
	      maxHeight: Infinity
	    };
	    _this._uid = uid();
	    _this._controlled = typeof props.value === 'string';
	    return _this;
	  }
	
	  var _proto = TextareaAutosize.prototype;
	
	  _proto.render = function render() {
	    var _props = this.props,
	        _minRows = _props.minRows,
	        _maxRows = _props.maxRows,
	        _onHeightChange = _props.onHeightChange,
	        _useCacheForDOMMeasurements = _props.useCacheForDOMMeasurements,
	        _inputRef = _props.inputRef,
	        props = _objectWithoutProperties(_props, ["minRows", "maxRows", "onHeightChange", "useCacheForDOMMeasurements", "inputRef"]);
	    props.style = _extends({}, props.style, {
	      height: this.state.height
	    });
	    var maxHeight = Math.max(props.style.maxHeight || Infinity, this.state.maxHeight);
	
	    if (maxHeight < this.state.height) {
	      props.style.overflow = 'hidden';
	    }
	
	    return React.createElement("textarea", _extends({}, props, {
	      onChange: this._onChange,
	      ref: this._onRootDOMNode
	    }));
	  };
	
	  _proto.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    this._resizeComponent(); // Working around Firefox bug which runs resize listeners even when other JS is running at the same moment
	    // causing competing rerenders (due to setState in the listener) in React.
	    // More can be found here - facebook/react#6324
	
	
	    this._resizeListener = function () {
	      if (_this2._resizeLock) {
	        return;
	      }
	
	      _this2._resizeLock = true;
	
	      _this2._resizeComponent(function () {
	        return _this2._resizeLock = false;
	      });
	    };
	
	    window.addEventListener('resize', this._resizeListener);
	  };
	
	  _proto.componentWillReceiveProps = function componentWillReceiveProps() {
	    var _this3 = this;
	
	    this._clearNextFrame();
	
	    this._onNextFrameActionId = onNextFrame(function () {
	      return _this3._resizeComponent();
	    });
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
	    if (this.state.height !== prevState.height) {
	      this.props.onHeightChange(this.state.height, this);
	    }
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this._clearNextFrame();
	
	    window.removeEventListener('resize', this._resizeListener);
	    purgeCache(this._uid);
	  };
	
	  _proto._clearNextFrame = function _clearNextFrame() {
	    clearNextFrameAction(this._onNextFrameActionId);
	  };
	
	  return TextareaAutosize;
	}(React.Component);
	
	TextareaAutosize.propTypes = {
	  value: PropTypes.string,
	  onChange: PropTypes.func,
	  onHeightChange: PropTypes.func,
	  useCacheForDOMMeasurements: PropTypes.bool,
	  minRows: PropTypes.number,
	  maxRows: PropTypes.number,
	  inputRef: PropTypes.func
	};
	TextareaAutosize.defaultProps = {
	  onChange: noop,
	  onHeightChange: noop,
	  useCacheForDOMMeasurements: false
	};
	
	module.exports = TextareaAutosize;


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = AmPm;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(1));
	
	var _mergeClassNames = _interopRequireDefault(__webpack_require__(29));
	
	var _dates = __webpack_require__(48);
	
	var _propTypes2 = __webpack_require__(49);
	
	var _utils = __webpack_require__(50);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }
	
	function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	function AmPm(_ref) {
	  var ariaLabel = _ref.ariaLabel,
	      className = _ref.className,
	      disabled = _ref.disabled,
	      itemRef = _ref.itemRef,
	      locale = _ref.locale,
	      maxTime = _ref.maxTime,
	      minTime = _ref.minTime,
	      onChange = _ref.onChange,
	      required = _ref.required,
	      value = _ref.value;
	  var amDisabled = minTime && (0, _dates.convert24to12)((0, _dates.getHours)(minTime))[1] === 'pm';
	  var pmDisabled = maxTime && (0, _dates.convert24to12)((0, _dates.getHours)(maxTime))[1] === 'am';
	  var name = 'amPm';
	
	  var _getAmPmLabels = (0, _utils.getAmPmLabels)(locale),
	      _getAmPmLabels2 = _slicedToArray(_getAmPmLabels, 2),
	      amLabel = _getAmPmLabels2[0],
	      pmLabel = _getAmPmLabels2[1];
	
	  return _react["default"].createElement("select", {
	    "aria-label": ariaLabel,
	    className: (0, _mergeClassNames["default"])("".concat(className, "__input"), "".concat(className, "__").concat(name)),
	    disabled: disabled,
	    name: name,
	    onChange: onChange,
	    ref: function ref(_ref2) {
	      if (itemRef) {
	        itemRef(_ref2, name);
	      }
	    },
	    required: required,
	    value: value !== null ? value : ''
	  }, !value && _react["default"].createElement("option", {
	    value: ""
	  }, "--"), _react["default"].createElement("option", {
	    disabled: amDisabled,
	    value: "am"
	  }, amLabel), _react["default"].createElement("option", {
	    disabled: pmDisabled,
	    value: "pm"
	  }, pmLabel));
	}
	
	AmPm.propTypes = {
	  ariaLabel: _propTypes["default"].string,
	  className: _propTypes["default"].string.isRequired,
	  disabled: _propTypes["default"].bool,
	  itemRef: _propTypes["default"].func,
	  locale: _propTypes["default"].string,
	  maxTime: _propTypes2.isTime,
	  minTime: _propTypes2.isTime,
	  onChange: _propTypes["default"].func,
	  required: _propTypes["default"].bool,
	  value: _propTypes["default"].oneOf(['am', 'pm'])
	};

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = Hour12Input;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(1));
	
	var _Input = _interopRequireDefault(__webpack_require__(93));
	
	var _dates = __webpack_require__(48);
	
	var _propTypes2 = __webpack_require__(49);
	
	var _utils = __webpack_require__(50);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }
	
	function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function Hour12Input(_ref) {
	  var amPm = _ref.amPm,
	      hour = _ref.hour,
	      maxTime = _ref.maxTime,
	      minTime = _ref.minTime,
	      value = _ref.value,
	      otherProps = _objectWithoutProperties(_ref, ["amPm", "hour", "maxTime", "minTime", "value"]);
	
	  var maxHour = function () {
	    if (!maxTime) {
	      return 12;
	    }
	
	    var _convert24to = (0, _dates.convert24to12)((0, _dates.getHours)(maxTime)),
	        _convert24to2 = _slicedToArray(_convert24to, 2),
	        maxHourResult = _convert24to2[0],
	        maxAmPm = _convert24to2[1];
	
	    if (maxAmPm !== amPm) {
	      // pm is always after am, so we should ignore validation
	      return 12;
	    }
	
	    return (0, _utils.min)(12, maxHourResult);
	  }();
	
	  var minHour = function () {
	    if (!minTime) {
	      return 1;
	    }
	
	    var _convert24to3 = (0, _dates.convert24to12)((0, _dates.getHours)(minTime)),
	        _convert24to4 = _slicedToArray(_convert24to3, 2),
	        minHourResult = _convert24to4[0],
	        minAmPm = _convert24to4[1];
	
	    if (minAmPm !== amPm) {
	      // pm is always after am, so we should ignore validation
	      return 1;
	    }
	
	    if (minHourResult === 12) {
	      // If minHour is 12 am/pm, user should be able to enter 12, 1, ..., 11.
	      return 1;
	    }
	
	    return (0, _utils.max)(1, minHourResult);
	  }();
	
	  var value12 = value !== null ? (0, _dates.convert24to12)(value)[0] : null;
	  return _react["default"].createElement(_Input["default"], _extends({
	    max: maxHour,
	    min: minHour,
	    name: "hour12",
	    nameForClass: "hour",
	    value: value12
	  }, otherProps));
	}
	
	Hour12Input.propTypes = {
	  amPm: _propTypes["default"].string,
	  ariaLabel: _propTypes["default"].string,
	  className: _propTypes["default"].string.isRequired,
	  disabled: _propTypes["default"].bool,
	  hour: _propTypes["default"].number,
	  itemRef: _propTypes["default"].func,
	  maxTime: _propTypes2.isTime,
	  minTime: _propTypes2.isTime,
	  onChange: _propTypes["default"].func,
	  onKeyDown: _propTypes["default"].func,
	  onKeyUp: _propTypes["default"].func,
	  placeholder: _propTypes["default"].string,
	  required: _propTypes["default"].bool,
	  showLeadingZeros: _propTypes["default"].bool,
	  value: _propTypes["default"].number
	};

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = Hour24Input;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(1));
	
	var _Input = _interopRequireDefault(__webpack_require__(93));
	
	var _dates = __webpack_require__(48);
	
	var _propTypes2 = __webpack_require__(49);
	
	var _utils = __webpack_require__(50);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function Hour24Input(_ref) {
	  var hour = _ref.hour,
	      maxTime = _ref.maxTime,
	      minTime = _ref.minTime,
	      otherProps = _objectWithoutProperties(_ref, ["hour", "maxTime", "minTime"]);
	
	  var maxHour = (0, _utils.min)(23, maxTime && (0, _dates.getHours)(maxTime));
	  var minHour = (0, _utils.max)(0, minTime && (0, _dates.getHours)(minTime));
	  return _react["default"].createElement(_Input["default"], _extends({
	    max: maxHour,
	    min: minHour,
	    name: "hour24",
	    nameForClass: "hour"
	  }, otherProps));
	}
	
	Hour24Input.propTypes = {
	  ariaLabel: _propTypes["default"].string,
	  className: _propTypes["default"].string.isRequired,
	  disabled: _propTypes["default"].bool,
	  hour: _propTypes["default"].number,
	  itemRef: _propTypes["default"].func,
	  maxTime: _propTypes2.isTime,
	  minTime: _propTypes2.isTime,
	  onChange: _propTypes["default"].func,
	  onKeyDown: _propTypes["default"].func,
	  onKeyUp: _propTypes["default"].func,
	  placeholder: _propTypes["default"].string,
	  required: _propTypes["default"].bool,
	  showLeadingZeros: _propTypes["default"].bool,
	  value: _propTypes["default"].number
	};

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = MinuteInput;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(1));
	
	var _Input = _interopRequireDefault(__webpack_require__(93));
	
	var _dates = __webpack_require__(48);
	
	var _propTypes2 = __webpack_require__(49);
	
	var _utils = __webpack_require__(50);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function MinuteInput(_ref) {
	  var hour = _ref.hour,
	      maxTime = _ref.maxTime,
	      minTime = _ref.minTime,
	      otherProps = _objectWithoutProperties(_ref, ["hour", "maxTime", "minTime"]);
	
	  var maxMinute = (0, _utils.min)(59, maxTime && hour === (0, _dates.getHours)(maxTime) && (0, _dates.getMinutes)(maxTime));
	  var minMinute = (0, _utils.max)(0, minTime && hour === (0, _dates.getHours)(minTime) && (0, _dates.getMinutes)(minTime));
	  return _react["default"].createElement(_Input["default"], _extends({
	    max: maxMinute,
	    min: minMinute,
	    name: "minute"
	  }, otherProps));
	}
	
	MinuteInput.propTypes = {
	  ariaLabel: _propTypes["default"].string,
	  className: _propTypes["default"].string.isRequired,
	  disabled: _propTypes["default"].bool,
	  hour: _propTypes["default"].number,
	  itemRef: _propTypes["default"].func,
	  maxTime: _propTypes2.isTime,
	  minTime: _propTypes2.isTime,
	  onChange: _propTypes["default"].func,
	  onKeyDown: _propTypes["default"].func,
	  onKeyUp: _propTypes["default"].func,
	  placeholder: _propTypes["default"].string,
	  required: _propTypes["default"].bool,
	  showLeadingZeros: _propTypes["default"].bool,
	  value: _propTypes["default"].number
	};
	MinuteInput.defaultProps = {
	  showLeadingZeros: true
	};

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = SecondInput;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(1));
	
	var _Input = _interopRequireDefault(__webpack_require__(93));
	
	var _dates = __webpack_require__(48);
	
	var _propTypes2 = __webpack_require__(49);
	
	var _utils = __webpack_require__(50);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function SecondInput(_ref) {
	  var hour = _ref.hour,
	      maxTime = _ref.maxTime,
	      minTime = _ref.minTime,
	      minute = _ref.minute,
	      otherProps = _objectWithoutProperties(_ref, ["hour", "maxTime", "minTime", "minute"]);
	
	  var maxSecond = (0, _utils.min)(59, maxTime && hour === (0, _dates.getHours)(maxTime) && minute === (0, _dates.getMinutes)(maxTime) && (0, _dates.getSeconds)(maxTime));
	  var minSecond = (0, _utils.max)(0, minTime && hour === (0, _dates.getHours)(minTime) && minute === (0, _dates.getMinutes)(minTime) && (0, _dates.getSeconds)(minTime));
	  return _react["default"].createElement(_Input["default"], _extends({
	    max: maxSecond,
	    min: minSecond,
	    name: "second"
	  }, otherProps));
	}
	
	SecondInput.propTypes = {
	  ariaLabel: _propTypes["default"].string,
	  className: _propTypes["default"].string.isRequired,
	  disabled: _propTypes["default"].bool,
	  hour: _propTypes["default"].number,
	  itemRef: _propTypes["default"].func,
	  maxTime: _propTypes2.isTime,
	  minTime: _propTypes2.isTime,
	  minute: _propTypes["default"].number,
	  onChange: _propTypes["default"].func,
	  onKeyDown: _propTypes["default"].func,
	  onKeyUp: _propTypes["default"].func,
	  placeholder: _propTypes["default"].string,
	  required: _propTypes["default"].bool,
	  showLeadingZeros: _propTypes["default"].bool,
	  value: _propTypes["default"].number
	};
	SecondInput.defaultProps = {
	  showLeadingZeros: true
	};

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getFormatter = getFormatter;
	
	var _getUserLocale = _interopRequireDefault(__webpack_require__(82));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/* eslint-disable import/prefer-default-export */
	function getFormatter(options) {
	  return function (locale, date) {
	    return date.toLocaleString(locale || (0, _getUserLocale["default"])(), options);
	  };
	}

/***/ }),
/* 500 */
/***/ (function(module, exports) {

	'use strict';
	
	// do not edit .js files directly - edit src/index.jst
	
	
	
	module.exports = function equal(a, b) {
	  if (a === b) return true;
	
	  if (a && b && typeof a == 'object' && typeof b == 'object') {
	    if (a.constructor !== b.constructor) return false;
	
	    var length, i, keys;
	    if (Array.isArray(a)) {
	      length = a.length;
	      if (length != b.length) return false;
	      for (i = length; i-- !== 0;)
	        if (!equal(a[i], b[i])) return false;
	      return true;
	    }
	
	
	
	    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
	    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
	    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
	
	    keys = Object.keys(a);
	    length = keys.length;
	    if (length !== Object.keys(b).length) return false;
	
	    for (i = length; i-- !== 0;)
	      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
	
	    for (i = length; i-- !== 0;) {
	      var key = keys[i];
	
	      if (!equal(a[key], b[key])) return false;
	    }
	
	    return true;
	  }
	
	  // true if both NaN, false otherwise
	  return a!==a && b!==b;
	};


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

	/** @license React v16.10.1
	 * react.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var h=__webpack_require__(85),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,aa=n?Symbol.for("react.suspense_list"):60120,ba=n?Symbol.for("react.memo"):
	60115,ca=n?Symbol.for("react.lazy"):60116;n&&Symbol.for("react.fundamental");n&&Symbol.for("react.responder");n&&Symbol.for("react.scope");var z="function"===typeof Symbol&&Symbol.iterator;
	function A(a){for(var b=a.message,c="https://reactjs.org/docs/error-decoder.html?invariant="+b,d=1;d<arguments.length;d++)c+="&args[]="+encodeURIComponent(arguments[d]);a.message="Minified React error #"+b+"; visit "+c+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ";return a}var B={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},C={};
	function D(a,b,c){this.props=a;this.context=b;this.refs=C;this.updater=c||B}D.prototype.isReactComponent={};D.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw A(Error(85));this.updater.enqueueSetState(this,a,b,"setState")};D.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function E(){}E.prototype=D.prototype;function F(a,b,c){this.props=a;this.context=b;this.refs=C;this.updater=c||B}var G=F.prototype=new E;
	G.constructor=F;h(G,D.prototype);G.isPureReactComponent=!0;var H={current:null},I={suspense:null},J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
	function M(a,b,c){var d,e={},g=null,l=null;if(null!=b)for(d in void 0!==b.ref&&(l=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,d)&&!L.hasOwnProperty(d)&&(e[d]=b[d]);var f=arguments.length-2;if(1===f)e.children=c;else if(1<f){for(var k=Array(f),m=0;m<f;m++)k[m]=arguments[m+2];e.children=k}if(a&&a.defaultProps)for(d in f=a.defaultProps,f)void 0===e[d]&&(e[d]=f[d]);return{$$typeof:p,type:a,key:g,ref:l,props:e,_owner:J.current}}
	function da(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function N(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var O=/\/+/g,P=[];function Q(a,b,c,d){if(P.length){var e=P.pop();e.result=a;e.keyPrefix=b;e.func=c;e.context=d;e.count=0;return e}return{result:a,keyPrefix:b,func:c,context:d,count:0}}
	function R(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>P.length&&P.push(a)}
	function S(a,b,c,d){var e=typeof a;if("undefined"===e||"boolean"===e)a=null;var g=!1;if(null===a)g=!0;else switch(e){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(d,a,""===b?"."+T(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var l=0;l<a.length;l++){e=a[l];var f=b+T(e,l);g+=S(e,f,c,d)}else if(null===a||"object"!==typeof a?f=null:(f=z&&a[z]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),l=
	0;!(e=a.next()).done;)e=e.value,f=b+T(e,l++),g+=S(e,f,c,d);else if("object"===e)throw c=""+a,A(Error(31),"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,"");return g}function U(a,b,c){return null==a?0:S(a,"",b,c)}function T(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function ea(a,b){a.func.call(a.context,b,a.count++)}
	function fa(a,b,c){var d=a.result,e=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?V(a,d,c,function(a){return a}):null!=a&&(N(a)&&(a=da(a,e+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(O,"$&/")+"/")+c)),d.push(a))}function V(a,b,c,d,e){var g="";null!=c&&(g=(""+c).replace(O,"$&/")+"/");b=Q(b,g,d,e);U(a,fa,b);R(b)}function W(){var a=H.current;if(null===a)throw A(Error(321));return a}
	var X={Children:{map:function(a,b,c){if(null==a)return a;var d=[];V(a,d,null,b,c);return d},forEach:function(a,b,c){if(null==a)return a;b=Q(null,null,b,c);U(a,ea,b);R(b)},count:function(a){return U(a,function(){return null},null)},toArray:function(a){var b=[];V(a,b,null,function(a){return a});return b},only:function(a){if(!N(a))throw A(Error(143));return a}},createRef:function(){return{current:null}},Component:D,PureComponent:F,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,
	_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:x,render:a}},lazy:function(a){return{$$typeof:ca,_ctor:a,_status:-1,_result:null}},memo:function(a,b){return{$$typeof:ba,type:a,compare:void 0===b?null:b}},useCallback:function(a,b){return W().useCallback(a,b)},useContext:function(a,b){return W().useContext(a,b)},useEffect:function(a,b){return W().useEffect(a,b)},useImperativeHandle:function(a,
	b,c){return W().useImperativeHandle(a,b,c)},useDebugValue:function(){},useLayoutEffect:function(a,b){return W().useLayoutEffect(a,b)},useMemo:function(a,b){return W().useMemo(a,b)},useReducer:function(a,b,c){return W().useReducer(a,b,c)},useRef:function(a){return W().useRef(a)},useState:function(a){return W().useState(a)},Fragment:r,Profiler:u,StrictMode:t,Suspense:y,unstable_SuspenseList:aa,createElement:M,cloneElement:function(a,b,c){if(null===a||void 0===a)throw A(Error(267),a);var d=h({},a.props),
	e=a.key,g=a.ref,l=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,l=J.current);void 0!==b.key&&(e=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(k in b)K.call(b,k)&&!L.hasOwnProperty(k)&&(d[k]=void 0===b[k]&&void 0!==f?f[k]:b[k])}var k=arguments.length-2;if(1===k)d.children=c;else if(1<k){f=Array(k);for(var m=0;m<k;m++)f[m]=arguments[m+2];d.children=f}return{$$typeof:p,type:a.type,key:e,ref:g,props:d,_owner:l}},createFactory:function(a){var b=M.bind(null,a);b.type=a;return b},
	isValidElement:N,version:"16.10.1",unstable_withSuspenseConfig:function(a,b){var c=I.suspense;I.suspense=void 0===b?null:b;try{a()}finally{I.suspense=c}},__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentDispatcher:H,ReactCurrentBatchConfig:I,ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:h}},Y={default:X},Z=Y&&X||Y;module.exports=Z.default||Z;


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactackleCore = __webpack_require__(3);
	
	var _AccordionItem = __webpack_require__(205);
	
	var _AccordionItem2 = _interopRequireDefault(_AccordionItem);
	
	var _AccordionStyled = __webpack_require__(512);
	
	var _theme = __webpack_require__(513);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	(0, _reactackleCore.registerDefaultComponentTheme)('accordion', _theme2.default);
	
	var propTypes = {
	  /**
	   * Speed of exit animation
	   */
	  items: _propTypes2.default.arrayOf(_propTypes2.default.shape(_extends({}, _AccordionItem2.default.propTypes, {
	    content: _propTypes2.default.node
	  }))),
	  /**
	   * Define if Item has state itself
	   */
	  stateless: _propTypes2.default.bool,
	  /**
	   * Array of expanded Item's ids
	   */
	  expandedItemIds: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  /**
	   * Expand all items at once
	   */
	  expandAll: _propTypes2.default.bool,
	  /**
	   * If true, only one item may be expanded at one time
	   */
	  single: _propTypes2.default.bool,
	  /**
	   * Function to be called on Item title click
	   */
	  onChange: _propTypes2.default.func
	};
	
	var defaultProps = {
	  items: [],
	  expandedItemIds: [],
	  expandAll: false,
	  single: false,
	  stateless: false,
	  onChange: _reactackleCore.noop
	};
	
	var Accordion = function (_Component) {
	  _inherits(Accordion, _Component);
	
	  function Accordion(props) {
	    _classCallCheck(this, Accordion);
	
	    var _this = _possibleConstructorReturn(this, (Accordion.__proto__ || Object.getPrototypeOf(Accordion)).call(this, props));
	
	    if (!props.stateless) {
	      var expandedItemIds = void 0;
	      if (props.expandAll) expandedItemIds = props.items.map(function (item) {
	        return item.id;
	      });else expandedItemIds = props.expandedItemIds;
	
	      _this.state = {
	        expandedItemIds: expandedItemIds
	      };
	    }
	    _this._handleItemExpand = _this._handleItemExpand.bind(_this);
	    return _this;
	  }
	
	  _createClass(Accordion, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(_ref) {
	      var expandedItemIds = _ref.expandedItemIds;
	
	      if (expandedItemIds !== this.props.expandedItemIds && !this.props.stateless) this.setState({ expandedItemIds: expandedItemIds });
	    }
	  }, {
	    key: '_getExpandedItemIds',
	    value: function _getExpandedItemIds() {
	      if (!this.props.stateless) return this.state.expandedItemIds;
	
	      return this.props.expandedItemIds;
	    }
	  }, {
	    key: '_toggleItemExpand',
	    value: function _toggleItemExpand(itemId) {
	      var expandedItemIds = this._getExpandedItemIds().slice();
	      var idx = expandedItemIds.indexOf(itemId);
	
	      if (expandedItemIds.length && expandedItemIds.includes(itemId)) expandedItemIds.splice(idx, 1);else if (this.props.single) expandedItemIds = [itemId];else expandedItemIds.push(itemId);
	
	      return expandedItemIds;
	    }
	  }, {
	    key: '_isExpanded',
	    value: function _isExpanded(itemId) {
	      if (!this.props.stateless) return this.state.expandedItemIds.includes(itemId);
	
	      return this.props.expandedItemIds.includes(itemId);
	    }
	  }, {
	    key: '_handleItemExpand',
	    value: function _handleItemExpand(_ref2) {
	      var id = _ref2.id;
	
	      var newExpandedIds = this._toggleItemExpand(id);
	
	      if (!this.props.stateless) {
	        this.setState({
	          expandedItemIds: newExpandedIds
	        });
	      }
	      this.props.onChange({
	        expandedItemIds: newExpandedIds
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var items = this.props.items && this.props.items.map(function (item, index) {
	        var expanded = _this2._isExpanded(item.id);
	
	        return _react2.default.createElement(
	          _AccordionItem2.default,
	          _extends({
	            key: (0, _reactackleCore.getKey)(item, index),
	            id: item.id,
	            title: item.title,
	            expanded: expanded,
	            headerSlot: item.headerSlot,
	            onToggleExpanded: _this2._handleItemExpand
	          }, item),
	          item.content
	        );
	      });
	
	      return _react2.default.createElement(
	        _AccordionStyled.AccordionStyled,
	        { role: 'presentation' },
	        items,
	        this.props.children
	      );
	    }
	  }]);
	
	  return Accordion;
	}(_react.Component);
	
	exports.default = Accordion;
	
	
	Accordion.propTypes = propTypes;
	Accordion.defaultProps = defaultProps;
	Accordion.displayName = 'Accordion';

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ContentStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  contentBlank: _propTypes2.default.bool,
	  expanded: _propTypes2.default.bool
	};
	
	var defaultProps = {
	  expanded: false,
	  contentBlank: false
	};
	
	var size = function size(_ref) {
	  var themeFromProvider = _ref.theme,
	      contentBlank = _ref.contentBlank;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var _theme$reactackle$com = theme.reactackle.components.accordion.item.content,
	      paddingY = _theme$reactackle$com.paddingY,
	      paddingX = _theme$reactackle$com.paddingX;
	
	
	  return !contentBlank && (0, _styledComponents.css)(['padding:', ' ', ';'], (0, _reactackleCore.getValueString)(paddingY), (0, _reactackleCore.getValueString)(paddingX));
	};
	
	var expanded = function expanded(_ref2) {
	  var themeFromProvider = _ref2.theme,
	      expanded = _ref2.expanded;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  return expanded ? '\n      pointer-events: auto;\n      opacity: 1;\n      position: relative;\n      z-index: 1;\n      transform: translateY(0);\n    ' : (0, _styledComponents.css)(['transform:translateY(', ');pointer-events:none;opacity:0;position:fixed;z-index:-1;'], (0, _reactackleCore.getValueString)(theme.reactackle.components.accordion.item.content.animatedOffset));
	};
	
	var ContentStyled = exports.ContentStyled = _styledComponents2.default.dd.withConfig({
	  displayName: 'ContentStyled'
	})(['margin:0;', ' ', ' ', ''], size, expanded, (0, _reactackleCore.transition)('transform'));
	
	ContentStyled.propTypes = propTypes;
	ContentStyled.defaultProps = defaultProps;

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.HeadingStyled = undefined;
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HeadingStyled = exports.HeadingStyled = _styledComponents2.default.dt.withConfig({
	  displayName: 'HeadingStyled'
	})(['position:relative;z-index:2;']);

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.IconExpandWrapperStyled = undefined;
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var size = function size(_ref) {
	  var themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var path = theme.reactackle.components.accordion.item;
	
	  var _theme$reactackle$com = theme.reactackle.components.accordion.item.expandIcon,
	      height = _theme$reactackle$com.height,
	      width = _theme$reactackle$com.width;
	
	
	  return (0, _styledComponents.css)(['min-height:', ';width:', ';'], (0, _reactackleCore.getValueString)(path.title.minHeight), (0, _reactackleCore.getValueString)(width || height));
	};
	
	var IconExpandWrapperStyled = exports.IconExpandWrapperStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'IconExpandWrapperStyled'
	})(['display:flex;align-items:center;', ''], size);
	
	IconExpandWrapperStyled.displayName = 'IconExpandWrapperStyled';

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.IconWrapperStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  expanded: _propTypes2.default.bool
	};
	
	var defaultProps = {
	  expanded: false
	};
	
	var expanded = function expanded(_ref) {
	  var themeFromProvider = _ref.theme,
	      expanded = _ref.expanded;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var styleKey = expanded ? 'expanded' : 'collapsed';
	
	  var _theme$reactackle$com = theme.reactackle.components.accordion.item.expandIcon[styleKey],
	      opacity = _theme$reactackle$com.opacity,
	      rotateDegree = _theme$reactackle$com.rotateDegree;
	
	
	  return (0, _styledComponents.css)(['opacity:', ';', ''], opacity, rotateDegree !== null && 'transform: rotate(' + rotateDegree + ');');
	};
	
	var size = function size(_ref2) {
	  var themeFromProvider = _ref2.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var _theme$reactackle$com2 = theme.reactackle.components.accordion.item.expandIcon,
	      height = _theme$reactackle$com2.height,
	      width = _theme$reactackle$com2.width,
	      imgHeight = _theme$reactackle$com2.imgHeight,
	      imgWidth = _theme$reactackle$com2.imgWidth;
	
	
	  return (0, _styledComponents.css)(['', ''], (0, _reactackleCore.iconSizeMixin)((0, _reactackleCore.getValueString)(height), (0, _reactackleCore.getValueString)(imgHeight || height), (0, _reactackleCore.getValueString)(width || height), (0, _reactackleCore.getValueString)(imgWidth || imgHeight || height)));
	};
	
	var IconWrapperStyled = exports.IconWrapperStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'IconWrapperStyled'
	})(['display:flex;align-items:center;', ' ', ' ', ''], expanded, size, (0, _reactackleCore.transition)('opacity, transform'));
	
	IconWrapperStyled.propTypes = propTypes;
	IconWrapperStyled.defaultProps = defaultProps;

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TitleBoxStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  expanded: _propTypes2.default.bool
	};
	
	var defaultProps = {
	  expanded: false
	};
	
	var ALIGN_MAP = {
	  top: 'flex-start',
	  end: 'flex-end',
	  bottom: 'center',
	  stretch: 'stretch'
	};
	
	var style = function style(_ref) {
	  var expanded = _ref.expanded,
	      themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var pathKey = expanded ? 'expanded' : 'collapsed';
	  var path = theme.reactackle.components.accordion.item.title[pathKey];
	
	  return '\n    background-color: ' + path.backgroundColor + ';\n    opacity: ' + path.opacity + ';\n    \n    &:hover {    \n      background-color: ' + path.hover.backgroundColor + ';\n      opacity: ' + path.hover.opacity + ';\n    }\n    \n    &:focus {    \n      background-color: ' + path.focus.backgroundColor + ';\n      opacity: ' + path.focus.opacity + ';\n    }\n  ';
	};
	
	var size = function size(_ref2) {
	  var themeFromProvider = _ref2.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var _theme$reactackle$com = theme.reactackle.components.accordion.item.title,
	      align = _theme$reactackle$com.align,
	      minHeight = _theme$reactackle$com.minHeight;
	
	
	  return (0, _styledComponents.css)(['align-items:', ';', ''], ALIGN_MAP[align], minHeight && 'min-height: ' + (0, _reactackleCore.getValueString)(minHeight) + ';');
	};
	
	var expanded = function expanded(_ref3) {
	  var themeFromProvider = _ref3.theme,
	      expanded = _ref3.expanded;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var styleKey = expanded ? 'expanded' : 'collapsed';
	
	  var color = theme.reactackle.components.accordion.item.title[styleKey].color;
	
	
	  return (0, _styledComponents.css)(['color:', ';'], color);
	};
	
	var TitleBoxStyled = exports.TitleBoxStyled = _styledComponents2.default.button.withConfig({
	  displayName: 'TitleBoxStyled'
	})(['width:100%;display:flex;cursor:pointer;text-align:left;', ' &,&:hover,&:focus{outline:none;box-shadow:none;background-color:transparent;border:0 solid transparent;padding:0;}', ' ', ' ', ''], (0, _reactackleCore.transition)('background-color, opacity'), style, size, expanded);
	
	TitleBoxStyled.propTypes = propTypes;
	TitleBoxStyled.defaultProps = defaultProps;

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TitleContentStyled = undefined;
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TitleContentStyled = exports.TitleContentStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'TitleContentStyled'
	})(['flex-grow:1;min-width:0;']);
	
	TitleContentStyled.displayName = 'TitleContentStyled';

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TitleStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  expanded: _propTypes2.default.bool
	};
	
	var defaultProps = {
	  expanded: false
	};
	
	var expanded = function expanded(_ref) {
	  var themeFromProvider = _ref.theme,
	      expanded = _ref.expanded;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var styleKey = expanded ? 'expanded' : 'collapsed';
	
	  var _theme$reactackle$com = theme.reactackle.components.accordion.item.title[styleKey],
	      fontSize = _theme$reactackle$com.fontSize,
	      lineHeight = _theme$reactackle$com.lineHeight,
	      fontWeight = _theme$reactackle$com.fontWeight,
	      color = _theme$reactackle$com.color,
	      textTransform = _theme$reactackle$com.textTransform,
	      paddingTop = _theme$reactackle$com.paddingTop,
	      paddingBottom = _theme$reactackle$com.paddingBottom,
	      paddingLeft = _theme$reactackle$com.paddingLeft,
	      paddingRight = _theme$reactackle$com.paddingRight;
	
	
	  return (0, _styledComponents.css)(['font-size:', ';line-height:', ';color:', ';font-weight:', ';text-transform:', ';padding-top:', ';padding-bottom:', ';padding-left:', ';padding-right:', ';'], (0, _reactackleCore.getValueString)(fontSize), lineHeight, color, fontWeight, textTransform, (0, _reactackleCore.getValueString)(paddingTop), (0, _reactackleCore.getValueString)(paddingBottom), (0, _reactackleCore.getValueString)(paddingLeft), (0, _reactackleCore.getValueString)(paddingRight));
	};
	
	var TitleStyled = exports.TitleStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'TitleStyled'
	})(['flex-grow:1;position:relative;z-index:1;user-select:none;', ''], expanded);
	
	TitleStyled.propTypes = propTypes;
	TitleStyled.defaultProps = defaultProps;

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _HeadingStyled = __webpack_require__(504);
	
	Object.keys(_HeadingStyled).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _HeadingStyled[key];
	    }
	  });
	});
	
	var _TitleBoxStyled = __webpack_require__(507);
	
	Object.keys(_TitleBoxStyled).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _TitleBoxStyled[key];
	    }
	  });
	});
	
	var _TitleContentStyled = __webpack_require__(508);
	
	Object.keys(_TitleContentStyled).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _TitleContentStyled[key];
	    }
	  });
	});
	
	var _TitleStyled = __webpack_require__(509);
	
	Object.keys(_TitleStyled).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _TitleStyled[key];
	    }
	  });
	});
	
	var _IconExpandWrapperStyled = __webpack_require__(505);
	
	Object.keys(_IconExpandWrapperStyled).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _IconExpandWrapperStyled[key];
	    }
	  });
	});
	
	var _IconWrapperStyled = __webpack_require__(506);
	
	Object.keys(_IconWrapperStyled).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _IconWrapperStyled[key];
	    }
	  });
	});
	
	var _ContentStyled = __webpack_require__(503);
	
	Object.keys(_ContentStyled).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ContentStyled[key];
	    }
	  });
	});

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AccordionItem = exports.Accordion = undefined;
	
	var _Accordion = __webpack_require__(502);
	
	var _Accordion2 = _interopRequireDefault(_Accordion);
	
	var _AccordionItem = __webpack_require__(205);
	
	var _AccordionItem2 = _interopRequireDefault(_AccordionItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Accordion = _Accordion2.default;
	exports.AccordionItem = _AccordionItem2.default;

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AccordionStyled = undefined;
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var separator = function separator(_ref) {
	  var themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var _theme$reactackle$com = theme.reactackle.components.accordion.separator,
	      style = _theme$reactackle$com.style,
	      color = _theme$reactackle$com.color,
	      thickness = _theme$reactackle$com.thickness;
	
	
	  return (0, _styledComponents.css)(['border-top:', ' ', ' ', ';'], (0, _reactackleCore.getValueString)(thickness), style, color);
	};
	
	var AccordionStyled = exports.AccordionStyled = _styledComponents2.default.dl.withConfig({
	  displayName: 'AccordionStyled'
	})(['width:100%;> dd + dt{', '}'], separator);
	
	AccordionStyled.displayName = 'AccordionStyled';

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactackleIcons = __webpack_require__(7);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var titleFontSize = _reactackleCore.fontSize[-1];
	var titleLineHeight = 1.5;
	var titlePadY = _reactackleCore.baseModule;
	
	exports.default = {
	  item: {
	    title: {
	      align: 'top', // One of: top, center, bottom, stretch
	      minHeight: function minHeight(base) {
	        return titleFontSize * titleLineHeight + titlePadY(base) * 2;
	      },
	
	      collapsed: {
	        backgroundColor: _reactackleCore.colorWhite,
	        opacity: 0.7,
	        fontSize: titleFontSize,
	        lineHeight: 1.5,
	        fontWeight: _reactackleCore.fontWeightNormal,
	        color: _reactackleCore.bodyFontColor,
	        textTransform: 'uppercase',
	        paddingTop: (0, _reactackleCore.bmodule)(1),
	        paddingBottom: (0, _reactackleCore.bmodule)(1),
	        paddingLeft: (0, _reactackleCore.bmodule)(2),
	
	        hover: {
	          backgroundColor: _reactackleCore.colorPaletteGrey50,
	          opacity: 1
	        },
	
	        focus: {
	          backgroundColor: _reactackleCore.colorPaletteGrey75,
	          opacity: 1
	        }
	      },
	
	      expanded: {
	        backgroundColor: _reactackleCore.colorWhite,
	        opacity: 1,
	        fontSize: titleFontSize,
	        lineHeight: 1.5,
	        fontWeight: _reactackleCore.fontWeightSemibold,
	        color: _reactackleCore.bodyFontColor,
	        textTransform: 'uppercase',
	        paddingTop: (0, _reactackleCore.bmodule)(1),
	        paddingBottom: (0, _reactackleCore.bmodule)(1),
	        paddingLeft: (0, _reactackleCore.bmodule)(2),
	        paddingRight: (0, _reactackleCore.bmodule)(2),
	
	        hover: {
	          backgroundColor: _reactackleCore.colorPaletteGrey50,
	          opacity: 1
	        },
	
	        focus: {
	          backgroundColor: _reactackleCore.colorPaletteGrey75,
	          opacity: 1
	        }
	      }
	    },
	
	    expandIcon: {
	      height: 24,
	      width: null,
	      imgHeight: 20,
	      imgWidth: null,
	
	      expanded: {
	        opacity: 1,
	        rotateDegree: '90deg',
	        iconElement: _react2.default.createElement(_reactackleIcons.IconArrowChevronRight, { size: 'custom', color: 'currentColor' })
	      },
	
	      collapsed: {
	        opacity: 0.7,
	        rotateDegree: 0,
	        iconElement: _react2.default.createElement(_reactackleIcons.IconArrowChevronRight, { size: 'custom', color: 'currentColor' })
	      }
	    },
	
	    content: {
	      paddingY: (0, _reactackleCore.bmodule)(1.5),
	      paddingX: (0, _reactackleCore.bmodule)(2),
	      animatedOffset: -20
	    }
	  },
	  separator: {
	    style: 'solid',
	    color: _reactackleCore.colorBorder,
	    thickness: 1
	  }
	};

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactackleCore = __webpack_require__(3);
	
	var _reactackleButton = __webpack_require__(94);
	
	var _styles = __webpack_require__(519);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var buttonAdditionalProps = {
	  /**
	   * Close alert on button click
	   */
	  closeAlert: _propTypes2.default.bool,
	  /**
	   * Specify Button component. We use Reactackle Button as a default.
	   */
	  buttonComponent: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func])
	};
	
	var propTypes = {
	  /**
	   * Alert item id
	   */
	  id: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  /**
	   * Changes Alert layout direction to vertical (buttons will be placed under
	   * Alert content)
	   */
	  vertical: _propTypes2.default.bool,
	  /**
	   * Alert color scheme
	   */
	  colorScheme: _propTypes2.default.oneOf(['default', 'warning', 'error', 'success', 'info']),
	  /**
	   * Array of Alert's buttons
	   */
	  buttons: _propTypes2.default.arrayOf(_propTypes2.default.shape.apply(_propTypes2.default, [_reactackleButton.Button.propTypes].concat(_toConsumableArray(buttonAdditionalProps)))),
	  /**
	   * Function to be called on Close button click
	   */
	  onClose: _propTypes2.default.func,
	  /**
	   * Speed of exit animation
	   */
	  closeAnimation: _propTypes2.default.bool
	};
	
	var defaultProps = {
	  id: '',
	  colorScheme: 'default',
	  vertical: false,
	  buttons: [],
	  onClose: _reactackleCore.noop,
	  closeAnimation: false
	};
	
	var Alert = function (_Component) {
	  _inherits(Alert, _Component);
	
	  function Alert(props) {
	    _classCallCheck(this, Alert);
	
	    var _this = _possibleConstructorReturn(this, (Alert.__proto__ || Object.getPrototypeOf(Alert)).call(this, props));
	
	    _this._handleClose = _this._handleClose.bind(_this);
	    return _this;
	  }
	
	  _createClass(Alert, [{
	    key: '_handleClose',
	    value: function _handleClose() {
	      this.props.onClose(this.props.id);
	    }
	  }, {
	    key: '_renderButtonsArea',
	    value: function _renderButtonsArea() {
	      var _this2 = this;
	
	      if (this.props.buttons && this.props.buttons.length) {
	        var buttons = this.props.buttons.map(function (button, index) {
	          var pressHandler = function pressHandler() {
	            if (button.action) button.action();
	            if (button.closeAlert) _this2._handleClose();
	          };
	
	          if (button.buttonComponent) {
	            var buttonElement = void 0;
	            if (typeof button.buttonComponent === "function") {
	              var _Button = button.buttonComponent;
	              buttonElement = _react2.default.createElement(_Button, { key: (0, _reactackleCore.getKey)(button, index) });
	            } else {
	              buttonElement = _react2.default.cloneElement(button.buttonComponent, {
	                key: (0, _reactackleCore.getKey)(button, index)
	              });
	            }
	            return buttonElement;
	          }
	
	          return _react2.default.createElement(_reactackleButton.Button, _extends({}, button, {
	            onPress: pressHandler,
	            key: (0, _reactackleCore.getKey)(button, index)
	          }));
	        });
	
	        return _react2.default.createElement(
	          _styles.ActionsStyled,
	          null,
	          _react2.default.createElement(
	            _styles.ActionsWrapperStyled,
	            null,
	            buttons
	          )
	        );
	      }
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var buttonsArea = this._renderButtonsArea();
	
	      return _react2.default.createElement(
	        _styles.AlertStyled,
	        {
	          vertical: this.props.vertical,
	          colorScheme: this.props.colorScheme,
	          animateExit: this.props.closeAnimation,
	          role: 'alert'
	        },
	        _react2.default.createElement(
	          _styles.ContentStyled,
	          null,
	          this.props.children
	        ),
	        buttonsArea
	      );
	    }
	  }]);
	
	  return Alert;
	}(_react.Component);
	
	exports.default = Alert;
	
	
	Alert.propTypes = propTypes;
	Alert.defaultProps = defaultProps;
	Alert.displayName = 'Alert';

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ActionsStyled = undefined;
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var style = function style(_ref) {
	  var themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var _theme$reactackle$com = theme.reactackle.components.alertsArea.item.actions,
	      paddingY = _theme$reactackle$com.paddingY,
	      paddingX = _theme$reactackle$com.paddingX;
	
	
	  return (0, _styledComponents.css)(['padding:', ' ', ';'], (0, _reactackleCore.getValueString)(paddingY), (0, _reactackleCore.getValueString)(paddingX));
	};
	
	var ActionsStyled = exports.ActionsStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'ActionsStyled'
	})(['flex-shrink:0;display:flex;align-items:center;', ''], style);

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ActionsWrapperStyled = undefined;
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var style = function style(_ref) {
	  var themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var _theme$reactackle$com = theme.reactackle.components.alertsArea.item.actions,
	      itemSpacingX = _theme$reactackle$com.itemSpacingX,
	      itemSpacingY = _theme$reactackle$com.itemSpacingY;
	
	
	  return (0, _styledComponents.css)(['margin:-', ' -', ';& > *{margin:', ' ', ';}'], (0, _reactackleCore.getValueString)(itemSpacingY), (0, _reactackleCore.getValueString)(itemSpacingX), (0, _reactackleCore.getValueString)(itemSpacingY), (0, _reactackleCore.getValueString)(itemSpacingX));
	};
	
	var ActionsWrapperStyled = exports.ActionsWrapperStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'ActionsWrapperStyled'
	})(['flex-shrink:0;flex-grow:1;text-align:right;', ''], style);

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AlertStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  animateExit: _propTypes2.default.bool,
	  vertical: _propTypes2.default.bool,
	  colorScheme: _propTypes2.default.oneOf(['default', 'warning', 'error', 'success', 'info'])
	};
	
	var defaultProps = {
	  animateExit: false,
	  vertical: false,
	  colorScheme: 'default'
	};
	
	var style = function style(_ref) {
	  var themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var _theme$reactackle$com = theme.reactackle.components.alertsArea.item.colorScheme,
	      borderRadius = _theme$reactackle$com.borderRadius,
	      minWidth = _theme$reactackle$com.minWidth,
	      maxWidth = _theme$reactackle$com.maxWidth,
	      fontSize = _theme$reactackle$com.fontSize;
	
	
	  return (0, _styledComponents.css)(['border-radius:', ';min-width:', ';max-width:', ';font-size:', ';'], (0, _reactackleCore.getValueString)(borderRadius), (0, _reactackleCore.getValueString)(minWidth), (0, _reactackleCore.getValueString)(maxWidth), (0, _reactackleCore.getValueString)(fontSize));
	};
	
	var layoutDirection = function layoutDirection(_ref2) {
	  var vertical = _ref2.vertical;
	  return vertical ? '\n    flex-direction: column;\n    align-items: stretch;\n  ' : '\n    layout-direction: row;\n    align-items: center;\n  ';
	};
	
	var animation = function animation(_ref3) {
	  var themeFromProvider = _ref3.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var _theme$reactackle$com2 = theme.reactackle.components.alertsArea.item.animation.in,
	      name = _theme$reactackle$com2.name,
	      speed = _theme$reactackle$com2.speed,
	      timingFunction = _theme$reactackle$com2.timingFunction;
	
	
	  return 'animation: ' + name + ' ' + speed + ' ' + timingFunction + ';';
	};
	
	var animationExit = function animationExit(_ref4) {
	  var themeFromProvider = _ref4.theme,
	      animateExit = _ref4.animateExit;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var _theme$reactackle$com3 = theme.reactackle.components.alertsArea.item.animation.out,
	      name = _theme$reactackle$com3.name,
	      speed = _theme$reactackle$com3.speed,
	      timingFunction = _theme$reactackle$com3.timingFunction;
	
	
	  return animateExit && 'animation: ' + name + ' ' + speed + ' ' + timingFunction + ';';
	};
	
	var colorScheme = function colorScheme(_ref5) {
	  var colorScheme = _ref5.colorScheme,
	      themeFromProvider = _ref5.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var _theme$reactackle$com4 = theme.reactackle.components.alertsArea.item.colorScheme[colorScheme],
	      textColor = _theme$reactackle$com4.textColor,
	      backgroundColor = _theme$reactackle$com4.backgroundColor;
	
	
	  return '\n    color: ' + textColor + ';\n    background-color: ' + backgroundColor + ';\n  ';
	};
	
	var AlertStyled = exports.AlertStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'AlertStyled'
	})(['width:100%;display:flex;', ' ', ' ', ' ', ' ', ''], style, layoutDirection, animation, animationExit, colorScheme);
	
	AlertStyled.propTypes = propTypes;
	AlertStyled.defaultProps = defaultProps;

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ContentStyled = undefined;
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var style = function style(_ref) {
	  var themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var _theme$reactackle$com = theme.reactackle.components.alertsArea.item,
	      fontSize = _theme$reactackle$com.fontSize,
	      lineHeight = _theme$reactackle$com.lineHeight,
	      paddingY = _theme$reactackle$com.paddingY,
	      paddingX = _theme$reactackle$com.paddingX;
	
	
	  return (0, _styledComponents.css)(['font-size:', ';line-height:', ';padding:', ' ', ';'], (0, _reactackleCore.getValueString)(fontSize), lineHeight, (0, _reactackleCore.getValueString)(paddingY), (0, _reactackleCore.getValueString)(paddingX));
	};
	
	var ContentStyled = exports.ContentStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'ContentStyled'
	})(['flex-grow:1;user-select:none;cursor:default;color:currentColor;', ''], style);

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AlertStyled = __webpack_require__(517);
	
	Object.keys(_AlertStyled).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _AlertStyled[key];
	    }
	  });
	});
	
	var _ContentStyled = __webpack_require__(518);
	
	Object.keys(_ContentStyled).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ContentStyled[key];
	    }
	  });
	});
	
	var _ActionsStyled = __webpack_require__(515);
	
	Object.keys(_ActionsStyled).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ActionsStyled[key];
	    }
	  });
	});
	
	var _ActionsWrapperStyled = __webpack_require__(516);
	
	Object.keys(_ActionsWrapperStyled).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ActionsWrapperStyled[key];
	    }
	  });
	});

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactackleCore = __webpack_require__(3);
	
	var _Alert = __webpack_require__(514);
	
	var _Alert2 = _interopRequireDefault(_Alert);
	
	var _theme = __webpack_require__(523);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	var _AlertsWrapperStyled = __webpack_require__(522);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	(0, _reactackleCore.registerDefaultComponentTheme)('alertsArea', _theme2.default);
	
	var propTypes = {
	  /**
	   * Defines timeout for Alert close event
	   */
	  defaultTimeout: _propTypes2.default.number,
	  /**
	   * Array of Alerts
	   */
	  alerts: _propTypes2.default.arrayOf(_propTypes2.default.shape(_extends({}, _Alert2.default.propTypes, {
	    content: _propTypes2.default.node
	  }))),
	  /**
	   * Specify function to be called on Close button click
	   */
	  onClose: _propTypes2.default.func,
	  /**
	   * Speed of exit animation
	   */
	  animationDuration: _propTypes2.default.number,
	  /**
	   * Horizontal position of Alert area relatively ro the window
	   */
	  positionX: _propTypes2.default.oneOf(['left', 'right']),
	  /**
	   * Vertical position of Alert area relatively ro the window
	   */
	  positionY: _propTypes2.default.oneOf(['top', 'bottom'])
	};
	
	var defaultProps = {
	  defaultTimeout: 3000,
	  alerts: [],
	  onClose: _reactackleCore.noop,
	  animationDuration: 300,
	  positionX: 'right',
	  positionY: 'bottom'
	};
	
	var AlertArea = function (_Component) {
	  _inherits(AlertArea, _Component);
	
	  function AlertArea(props) {
	    _classCallCheck(this, AlertArea);
	
	    var _this = _possibleConstructorReturn(this, (AlertArea.__proto__ || Object.getPrototypeOf(AlertArea)).call(this, props));
	
	    _this.state = {
	      currentAlert: 0,
	      queue: [],
	      closeAnimation: false
	    };
	    _this._timeoutId = null;
	    _this._handleAlertClose = _this._handleAlertClose.bind(_this);
	    _this._closeCurrentAlert = _this._closeCurrentAlert.bind(_this);
	    return _this;
	  }
	
	  _createClass(AlertArea, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._setupTimeout();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (nextProps.alerts !== this.props.alerts) {
	        this.setState({
	          currentAlert: 0,
	          queue: [],
	          closeAnimation: false
	        }, function () {
	          _this2._setupTimeout();
	        });
	      }
	    }
	  }, {
	    key: '_handleAlertClose',
	    value: function _handleAlertClose() {
	      this.setState({
	        closeAnimation: true
	      });
	      this._timeoutId = setTimeout(this._closeCurrentAlert, this.props.animationDuration);
	    }
	  }, {
	    key: '_closeCurrentAlert',
	    value: function _closeCurrentAlert() {
	      var _this3 = this;
	
	      var alert = this._getAlert();
	      if (alert) {
	        this.setState(function (prevState) {
	          return {
	            currentAlert: prevState.currentAlert + 1,
	            closeAnimation: false
	          };
	        }, function () {
	          _this3.props.onClose(alert.id);
	          _this3._setupTimeout();
	        });
	      }
	    }
	  }, {
	    key: '_setupTimeout',
	    value: function _setupTimeout() {
	      this._timeoutId = null;
	      var alert = this._getAlert();
	      if (alert) {
	        var timeout = alert.timeout === 0 || alert.timeout ? +alert.timeout : this.props.defaultTimeout;
	        if (timeout) {
	          this._timeoutId = timeout > this.props.animationDuration ? setTimeout(this._handleAlertClose, timeout - this.props.animationDuration) : setTimeout(this._closeCurrentAlert, timeout);
	        }
	      }
	    }
	  }, {
	    key: '_getAlert',
	    value: function _getAlert() {
	      var _state = this.state,
	          currentAlert = _state.currentAlert,
	          queue = _state.queue;
	
	      var queueIndex = currentAlert - this.props.alerts.length;
	      if (currentAlert < this.props.alerts.length) return this.props.alerts[currentAlert];else if (queueIndex < queue.length) return queue[queueIndex];
	      return null;
	    }
	  }, {
	    key: '_renderCurrentAlert',
	    value: function _renderCurrentAlert() {
	      var closeAnimation = this.state.closeAnimation;
	
	      var alert = this._getAlert();
	      if (alert) {
	        return _react2.default.createElement(
	          _Alert2.default,
	          _extends({
	            id: alert.id,
	            closeAnimation: closeAnimation,
	            onClose: this._handleAlertClose
	          }, alert),
	          alert.content
	        );
	      }
	      return null;
	    }
	  }, {
	    key: 'addToQueue',
	    value: function addToQueue(alert) {
	      var _this4 = this;
	
	      this.setState({
	        queue: [].concat(_toConsumableArray(this.state.queue), [alert])
	      }, function () {
	        if (!_this4._timeoutId) _this4._setupTimeout();
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var currentAlert = this._renderCurrentAlert();
	      return _react2.default.createElement(
	        _AlertsWrapperStyled.AlertsWrapperStyled,
	        {
	          positionX: this.props.positionX,
	          positionY: this.props.positionY
	        },
	        currentAlert
	      );
	    }
	  }]);
	
	  return AlertArea;
	}(_react.Component);
	
	exports.default = AlertArea;
	
	
	AlertArea.propTypes = propTypes;
	AlertArea.defaultProps = defaultProps;
	AlertArea.displayName = 'AlertArea';

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AlertArea = undefined;
	
	var _AlertArea = __webpack_require__(520);
	
	var _AlertArea2 = _interopRequireDefault(_AlertArea);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.AlertArea = _AlertArea2.default;

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AlertsWrapperStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  positionX: _propTypes2.default.oneOf(['left', 'right']),
	  positionY: _propTypes2.default.oneOf(['top', 'bottom'])
	};
	
	var defaultProps = {
	  positionX: 'right',
	  positionY: 'bottom'
	};
	
	var position = function position(_ref) {
	  var themeFromProvider = _ref.theme,
	      positionX = _ref.positionX,
	      positionY = _ref.positionY;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var oppositePosY = positionY === 'top' ? 'bottom' : 'top';
	
	  var _theme$reactackle$com = theme.reactackle.components.alertsArea.wrapper,
	      marginX = _theme$reactackle$com.marginX,
	      marginY = _theme$reactackle$com.marginY,
	      zIndex = _theme$reactackle$com.zIndex,
	      itemsSpacing = _theme$reactackle$com.itemsSpacing;
	
	
	  return (0, _styledComponents.css)(['margin:', ' ', ';z-index:', ';', ':0;', ':0;', ':auto;& > * + *{margin-top:', ';}'], (0, _reactackleCore.getValueString)(marginY), (0, _reactackleCore.getValueString)(marginX), zIndex, positionX, positionY, oppositePosY, (0, _reactackleCore.getValueString)(itemsSpacing));
	};
	
	var AlertsWrapperStyled = exports.AlertsWrapperStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'AlertsWrapperStyled'
	})(['position:fixed;right:0;display:flex;', ''], position);
	
	AlertsWrapperStyled.propTypes = propTypes;
	AlertsWrapperStyled.defaultProps = defaultProps;

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactackleCore = __webpack_require__(3);
	
	exports.default = {
	  wrapper: {
	    marginX: (0, _reactackleCore.bmodule)(1),
	    marginY: (0, _reactackleCore.bmodule)(1),
	    zIndex: _reactackleCore.zIndexOverlay,
	    itemsSpacing: 2
	  },
	
	  item: {
	    borderRadius: _reactackleCore.radiusDefault,
	    minWidth: '20em',
	    maxWidth: '35em',
	    fontSize: _reactackleCore.fontSizeBody,
	    lineHeight: 1.5,
	    paddingY: (0, _reactackleCore.bmodule)(2),
	    paddingX: (0, _reactackleCore.bmodule)(3),
	
	    actions: {
	      paddingY: (0, _reactackleCore.bmodule)(2),
	      paddingX: (0, _reactackleCore.bmodule)(3),
	      itemSpacingX: 2,
	      itemSpacingY: 2
	    },
	
	    colorScheme: {
	      default: {
	        textColor: _reactackleCore.bodyFontColorAlt,
	        backgroundColor: 'rgba(0,0,0,0.8)'
	      },
	      warning: {
	        textColor: _reactackleCore.colorWarningForeground,
	        backgroundColor: _reactackleCore.colorWarning
	      },
	      error: {
	        textColor: _reactackleCore.colorErrorForeground,
	        backgroundColor: _reactackleCore.colorError
	      },
	      success: {
	        textColor: _reactackleCore.colorSuccessForeground,
	        backgroundColor: _reactackleCore.colorSuccess
	      },
	      info: {
	        textColor: _reactackleCore.colorInfoForeground,
	        backgroundColor: _reactackleCore.colorInfo
	      }
	    },
	
	    animation: {
	      in: {
	        name: _reactackleCore.fadeInDown,
	        speed: '300ms',
	        timingFunction: 'ease-in'
	      },
	
	      out: {
	        name: _reactackleCore.fadeOutRight,
	        speed: '150ms',
	        timingFunction: 'ease-in'
	      }
	    }
	  }
	};

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactackleCore = __webpack_require__(3);
	
	var _AppStyled = __webpack_require__(540);
	
	var _theme = __webpack_require__(541);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	(0, _reactackleCore.registerDefaultComponentTheme)('app', _theme2.default);
	
	var propTypes = {
	  /**
	   * Set App height to be equal to the window height, so the <Content /> will
	   * become scrollable.
	   */
	  fixed: _propTypes2.default.bool
	};
	
	var defaultProps = {
	  fixed: false
	};
	
	var childContextTypes = _defineProperty({}, _reactackleCore.APP_CHANNEL, _propTypes2.default.func.isRequired);
	
	var App = function (_Component) {
	  _inherits(App, _Component);
	
	  function App(props) {
	    _classCallCheck(this, App);
	
	    var _this = _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this, props));
	
	    _this._broadcast = (0, _reactackleCore.createBroadcast)({
	      fixed: _this.props.fixed
	    });
	    return _this;
	  }
	
	  _createClass(App, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return _extends({}, this.context, _defineProperty({}, _reactackleCore.APP_CHANNEL, this._broadcast.subscribe));
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.fixed !== nextProps.fixed) {
	        this._broadcast.publish({
	          fixed: nextProps.fixed
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _AppStyled.AppStyled,
	        { fixed: this.props.fixed },
	        this.props.children
	      );
	    }
	  }]);
	
	  return App;
	}(_react.Component);
	
	exports.default = App;
	
	
	App.childContextTypes = childContextTypes;
	App.propTypes = propTypes;
	App.defaultProps = defaultProps;
	App.displayName = 'App';

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = BottomRegion;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BottomRegionStyled = __webpack_require__(528);
	
	var _BottomRegionContentStyled = __webpack_require__(527);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {};
	var defaultProps = {};
	
	function BottomRegion(props) {
	  return _react2.default.createElement(
	    _BottomRegionStyled.BottomRegionStyled,
	    null,
	    _react2.default.createElement(
	      _BottomRegionContentStyled.BottomRegionContentStyled,
	      null,
	      props.children
	    )
	  );
	}
	
	BottomRegion.propTypes = propTypes;
	BottomRegion.defaultProps = defaultProps;
	BottomRegion.displayName = 'BottomRegion';

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BottomRegion = undefined;
	
	var _BottomRegion = __webpack_require__(525);
	
	var _BottomRegion2 = _interopRequireDefault(_BottomRegion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.BottomRegion = _BottomRegion2.default;

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BottomRegionContentStyled = undefined;
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var base = function base(_ref) {
	  var themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var fontFamily = theme.reactackle.fontFamily[theme.reactackle.body.fontFamily];
	
	  return '\n    font-family: ' + fontFamily + ';\n  ';
	};
	
	var BottomRegionContentStyled = exports.BottomRegionContentStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'BottomRegionContentStyled'
	})(['width:100%;display:flex;box-sizing:border-box;', ';'], base);
	
	BottomRegionContentStyled.displayName = 'BottomRegionContentStyled';

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BottomRegionStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  fixed: _propTypes2.default.bool
	};
	
	var defaultProps = {
	  fixed: false
	};
	
	var base = function base(_ref) {
	  var themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var fontFamily = theme.reactackle.fontFamily[theme.reactackle.body.fontFamily];
	
	  return '\n    font-family: ' + fontFamily + ';\n  ';
	};
	
	var BottomRegionStyled = exports.BottomRegionStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'BottomRegionStyled'
	})(['width:100%;flex-shrink:0;box-sizing:border-box;', ';'], base);
	
	BottomRegionStyled.propTypes = propTypes;
	BottomRegionStyled.defaultProps = defaultProps;
	BottomRegionStyled.displayName = 'BottomRegionStyled';

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _withExternalPropsApp = __webpack_require__(206);
	
	var _withExternalPropsApp2 = _interopRequireDefault(_withExternalPropsApp);
	
	var _ContentStyled = __webpack_require__(531);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  externalProps: _propTypes2.default.shape({
	    fixed: _propTypes2.default.bool
	  })
	};
	
	var defaultProps = {
	  externalProps: {
	    fixed: false
	  }
	};
	
	var _Content = function _Content(props) {
	  return _react2.default.createElement(
	    _ContentStyled.ContentStyled,
	    { appFixed: props.externalProps.fixed },
	    props.children
	  );
	};
	
	_Content.displayName = 'Content';
	exports.default = (0, _withExternalPropsApp2.default)(_Content);
	
	
	_Content.propTypes = propTypes;
	_Content.defaultProps = defaultProps;

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Content = undefined;
	
	var _Content = __webpack_require__(529);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Content = _Content2.default;

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ContentStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  appFixed: _propTypes2.default.bool,
	  theme: _propTypes2.default.object
	};
	var defaultProps = {
	  appFixed: false
	};
	
	var style = function style(_ref) {
	  var themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var backgroundColor = theme.reactackle.components.app.content.backgroundColor;
	
	
	  var fontFamily = theme.reactackle.fontFamily[theme.reactackle.body.fontFamily];
	
	  return '\n    background-color: ' + backgroundColor + ';\n    font-family: ' + fontFamily + ';\n  ';
	};
	
	var appFixed = function appFixed(_ref2) {
	  var appFixed = _ref2.appFixed;
	  return appFixed ? '\n      overflow-y: auto;\n      flex-shrink: initial;\n    ' : '';
	};
	
	var ContentStyled = exports.ContentStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'ContentStyled'
	})(['flex-grow:1;display:flex;flex-direction:column;align-items:stretch;position:relative;max-width:100%;min-width:0;box-sizing:border-box;', ' ', ';'], style, appFixed);
	
	ContentStyled.propTypes = propTypes;
	ContentStyled.defaultProps = defaultProps;
	ContentStyled.displayName = 'ContentStyled';

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports._MainRegion = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _withExternalPropsApp = __webpack_require__(206);
	
	var _withExternalPropsApp2 = _interopRequireDefault(_withExternalPropsApp);
	
	var _MainRegionStyled = __webpack_require__(534);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  externalProps: _propTypes2.default.shape({
	    fixed: _propTypes2.default.bool
	  })
	};
	
	var defaultProps = {
	  externalProps: {
	    fixed: false
	  }
	};
	
	var _MainRegion = exports._MainRegion = function _MainRegion(props) {
	  return _react2.default.createElement(
	    _MainRegionStyled.MainRegionStyled,
	    { appFixed: props.externalProps.fixed },
	    props.children
	  );
	};
	
	_MainRegion.displayName = 'MainRegion';
	exports.default = (0, _withExternalPropsApp2.default)(_MainRegion);
	
	
	_MainRegion.propTypes = propTypes;
	_MainRegion.defaultProps = defaultProps;

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MainRegion = undefined;
	
	var _Content = __webpack_require__(530);
	
	Object.keys(_Content).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Content[key];
	    }
	  });
	});
	
	var _MainRegion = __webpack_require__(532);
	
	var _MainRegion2 = _interopRequireDefault(_MainRegion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.MainRegion = _MainRegion2.default;

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MainRegionStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  appFixed: _propTypes2.default.bool
	};
	
	var defaultProps = {
	  appFixed: false
	};
	
	var appFixed = function appFixed(_ref) {
	  var appFixed = _ref.appFixed;
	  return appFixed ? '\n      overflow-y: auto;\n      flex-shrink: initial;\n    ' : '';
	};
	
	var base = function base(_ref2) {
	  var themeFromProvider = _ref2.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var fontFamily = theme.reactackle.fontFamily[theme.reactackle.body.fontFamily];
	
	  return '\n    font-family: ' + fontFamily + ';\n  ';
	};
	
	var MainRegionStyled = exports.MainRegionStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'MainRegionStyled'
	})(['width:100%;flex-grow:1;position:relative;z-index:1;display:flex;align-items:stretch;box-sizing:border-box;', ' ', ';'], base, appFixed);
	
	MainRegionStyled.propTypes = propTypes;
	MainRegionStyled.defaultProps = defaultProps;
	MainRegionStyled.displayName = 'MainRegionStyled';

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = TopRegion;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TopRegionStyled = __webpack_require__(538);
	
	var _TopRegionContentStyled = __webpack_require__(537);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {};
	var defaultProps = {};
	
	function TopRegion(props) {
	  return _react2.default.createElement(
	    _TopRegionStyled.TopRegionStyled,
	    null,
	    _react2.default.createElement(
	      _TopRegionContentStyled.TopRegionContentStyled,
	      null,
	      props.children
	    )
	  );
	}
	
	TopRegion.propTypes = propTypes;
	TopRegion.defaultProps = defaultProps;
	TopRegion.displayName = 'TopRegion';

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TopRegion = undefined;
	
	var _TopRegion = __webpack_require__(535);
	
	var _TopRegion2 = _interopRequireDefault(_TopRegion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.TopRegion = _TopRegion2.default;

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TopRegionContentStyled = undefined;
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var base = function base(_ref) {
	  var themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var fontFamily = theme.reactackle.fontFamily[theme.reactackle.body.fontFamily];
	
	  return '\n    font-family: ' + fontFamily + ';\n  ';
	};
	
	var TopRegionContentStyled = exports.TopRegionContentStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'TopRegionContentStyled'
	})(['width:100%;display:flex;box-sizing:border-box;', ';'], base);
	
	TopRegionContentStyled.displayName = 'TopRegionContentStyled';

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TopRegionStyled = undefined;
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var base = function base(_ref) {
	  var themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var fontFamily = theme.reactackle.fontFamily[theme.reactackle.body.fontFamily];
	
	  return '\n    font-family: ' + fontFamily + ';\n  ';
	};
	
	var TopRegionStyled = exports.TopRegionStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'TopRegionStyled'
	})(['width:100%;display:flex;flex-direction:column;flex-shrink:0;box-sizing:border-box;', ';'], base);
	
	TopRegionStyled.displayName = 'TopRegionStyled';

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.App = undefined;
	
	var _BottomRegion = __webpack_require__(526);
	
	Object.keys(_BottomRegion).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _BottomRegion[key];
	    }
	  });
	});
	
	var _TopRegion = __webpack_require__(536);
	
	Object.keys(_TopRegion).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _TopRegion[key];
	    }
	  });
	});
	
	var _MainRegion = __webpack_require__(533);
	
	Object.keys(_MainRegion).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _MainRegion[key];
	    }
	  });
	});
	
	var _App = __webpack_require__(524);
	
	var _App2 = _interopRequireDefault(_App);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.App = _App2.default;

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AppStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  fixed: _propTypes2.default.bool,
	  theme: _propTypes2.default.object
	};
	
	var defaultProps = {
	  fixed: false
	};
	
	var base = function base(_ref) {
	  var themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var fontFamily = theme.reactackle.fontFamily[theme.reactackle.body.fontFamily];
	
	  return '\n    min-height: ' + (0, _reactackleCore.getValueString)(theme.reactackle.components.app.minHeight) + ';\n    font-family: ' + fontFamily + ';\n  ';
	};
	
	var fixed = function fixed(_ref2) {
	  var fixed = _ref2.fixed;
	  return fixed ? 'max-height: 100vh;' : '';
	};
	
	var AppStyled = exports.AppStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'AppStyled'
	})(['display:flex;flex-direction:column;align-items:stretch;flex-grow:1;width:100%;max-width:100%;position:relative;box-sizing:border-box;', ';', ';'], base, fixed);
	
	AppStyled.propTypes = propTypes;
	AppStyled.defaultProps = defaultProps;
	AppStyled.displayName = 'AppStyled';

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactackleCore = __webpack_require__(3);
	
	exports.default = {
	  minHeight: '100vh',
	
	  content: {
	    backgroundColor: _reactackleCore.bodyBackgroundColor
	  }
	};

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Dmitriy Malakhov
	 */
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.recalculateAllAutoPosition = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _exenv = __webpack_require__(384);
	
	var _exenv2 = _interopRequireDefault(_exenv);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactPortal = __webpack_require__(190);
	
	var _lodash = __webpack_require__(170);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SCROLL_THROTTLE_DELAY = 20;
	
	var propTypes = {
	  /**
	   * Define the element to which the component will be positioned
	   */
	  parent: _propTypes2.default.object,
	  /**
	   * Define boundaries to which the component will be positioned
	   */
	  wrapper: _propTypes2.default.object,
	  /**
	   * Determines css position property. We recommend to use 'absolute'
	   * positioning as it requires less calculations and is more effective.
	   */
	  positionStyle: _propTypes2.default.oneOf(['fixed', 'absolute']),
	  /**
	   * Determines whether AutoPosition component visible or not
	   */
	  visible: _propTypes2.default.bool,
	  /**
	   * Determines x axis position
	   */
	  positionX: _propTypes2.default.oneOf(['left', 'right']),
	  /**
	   * Determines y axis position
	   */
	  positionY: _propTypes2.default.oneOf(['top', 'bottom']),
	  /**
	   * Set the bypass curcuit: along the outer or inner border of the component
	   */
	  type: _propTypes2.default.oneOf(['outer', 'inner']),
	  /**
	   * Set priority direction. The positioned component doesn't fit boundaries
	   * in default direction this defines which side this component will try to
	   * occupy first: opposite horizontal or opposite vertical.
	   */
	  direction: _propTypes2.default.oneOf(['vertical', 'horizontal']),
	  /**
	   * Set the tolerance for verifying that the positioned component fits its
	   * boundaries
	   */
	  overflowMargin: _propTypes2.default.number,
	  /**
	   * When AutoPosition component dont fit in window, display it in center
	   */
	  /* eslint-disable react/no-unused-prop-types */
	  allowedShowByCenter: _propTypes2.default.bool,
	  /**
	   * Allow the component to change its position along the current edge
	   */
	  allowedSlideOnCurrentEdge: _propTypes2.default.bool,
	  /**
	   * Allow the component to jump to the opposite edge if necessary
	   */
	  allowedSlideOnOppositeEdge: _propTypes2.default.bool,
	  /**
	   * Allow the component to jump to the adjacent edge if necessary
	   */
	  allowedSlideOnAdjacentEdge: _propTypes2.default.bool,
	  /**
	   * Allow the component to change bypass circuit if necessary
	   */
	  allowedChangeType: _propTypes2.default.bool,
	  /**
	   * Set positioning priority template
	   */
	  slidePriority: _propTypes2.default.arrayOf(_propTypes2.default.oneOf(['slideOnCurrentEdge', 'slideOnOppositeEdge', 'slideOnAdjacentEdge', 'changeType'])),
	  /* eslint-enable react/no-unused-prop-types */
	  /**
	   * Specify function to call on overflow
	   */
	  onOverflow: _propTypes2.default.func,
	  // ...Portal.propTypes,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element]).isRequired,
	  onOpen: _propTypes2.default.func
	};
	
	var defaultProps = {
	  parent: window,
	  wrapper: window,
	  positionStyle: 'absolute',
	  visible: false,
	  positionX: 'left',
	  positionY: 'top',
	  type: 'inner',
	  direction: 'horizontal',
	  overflowMargin: -5,
	  allowedShowByCenter: false,
	  slidePriority: ['slideOnAdjacentEdge', 'changeType', 'slideOnOppositeEdge', 'slideOnCurrentEdge'],
	  allowedSlideOnCurrentEdge: true,
	  allowedSlideOnOppositeEdge: true,
	  allowedSlideOnAdjacentEdge: false,
	  allowedChangeType: false,
	  onOverflow: _reactackleCore.noop,
	  onOpen: _reactackleCore.noop
	};
	
	var autoPositionInstances = [];
	
	var AutoPosition = function (_Component) {
	  _inherits(AutoPosition, _Component);
	
	  function AutoPosition(props) {
	    _classCallCheck(this, AutoPosition);
	
	    var _this = _possibleConstructorReturn(this, (AutoPosition.__proto__ || Object.getPrototypeOf(AutoPosition)).call(this, props));
	
	    _this._domNode = null;
	
	    _this.state = {
	      visible: props.visible,
	      currentPosition: {
	        top: null,
	        left: null
	      },
	      currentDirection: props.direction,
	      currentPositionX: props.positionX,
	      currentPositionY: props.positionY,
	      currentType: props.type
	    };
	
	    _this._handleScrollThrottled = (0, _lodash2.default)(_this._handleScroll.bind(_this), SCROLL_THROTTLE_DELAY);
	
	    _this._saveRef = _this._saveRef.bind(_this);
	    _this._handleResize = _this._handleResize.bind(_this);
	    return _this;
	  }
	
	  _createClass(AutoPosition, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      autoPositionInstances.push(this);
	
	      window.addEventListener('resize', this._handleResize);
	
	      window.addEventListener('scroll', this._handleScrollThrottled, true);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var positionX = nextProps.positionX,
	          positionY = nextProps.positionY,
	          type = nextProps.type,
	          direction = nextProps.direction,
	          parent = nextProps.parent;
	
	
	      if (positionX !== this.props.positionX || positionY !== this.props.positionY || type !== this.props.type || direction !== this.props.direction || parent !== this.props.parent) this._recalculatePosition(nextProps);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var index = autoPositionInstances.indexOf(this);
	
	      if (index + 1) {
	        autoPositionInstances = [].concat(_toConsumableArray(autoPositionInstances.slice(0, index)), _toConsumableArray(autoPositionInstances.slice(index + 1)));
	      }
	
	      window.removeEventListener('resize', this._handleResize);
	
	      window.removeEventListener('scroll', this._handleScrollThrottled, true);
	    }
	  }, {
	    key: 'recalculatePosition',
	    value: function recalculatePosition() {
	      this._recalculatePosition(this.props);
	    }
	  }, {
	    key: '_handleResize',
	    value: function _handleResize() {
	      if (!this.props.visible) return;
	      this._recalculatePosition(this.props);
	    }
	  }, {
	    key: '_handleScroll',
	    value: function _handleScroll() {
	      if (!this.props.visible) return;
	
	      var forceRecalculate = this.props.positionStyle === 'fixed';
	      this._recalculatePosition(this.props, forceRecalculate);
	    }
	  }, {
	    key: '_recalculatePosition',
	    value: function _recalculatePosition(props) {
	      var _this2 = this;
	
	      var initDirection = props.direction,
	          positionY = props.positionY,
	          positionX = props.positionX,
	          type = props.type,
	          allowedShowByCenter = props.allowedShowByCenter,
	          parent = props.parent,
	          slidePriority = props.slidePriority,
	          allowedSlideOnCurrentEdge = props.allowedSlideOnCurrentEdge,
	          allowedSlideOnOppositeEdge = props.allowedSlideOnOppositeEdge,
	          allowedSlideOnAdjacentEdge = props.allowedSlideOnAdjacentEdge,
	          allowedChangeType = props.allowedChangeType;
	      var _state = this.state,
	          currentDirection = _state.currentDirection,
	          currentPositionY = _state.currentPositionY,
	          currentPositionX = _state.currentPositionX,
	          currentType = _state.currentType;
	
	
	      var initPosition = this._getPositions({
	        positionY: positionY,
	        positionX: positionX,
	        type: type,
	        direction: initDirection,
	        parent: parent
	      });
	
	      var currentPosition = this._getPositions({
	        positionY: currentPositionY,
	        positionX: currentPositionX,
	        type: currentType,
	        direction: currentDirection,
	        parent: parent
	      });
	
	      var overflowByCurrentPosition = this._overflowCheck(currentPosition),
	          overflowByInitPosition = this._overflowCheck(initPosition);
	
	      var newPosition = currentPosition,
	          newDirection = currentDirection,
	          newPositionY = currentPositionY,
	          newPositionX = currentPositionX,
	          newType = currentType;
	
	      if (!overflowByInitPosition.length) {
	        newPosition = initPosition;
	        newDirection = initDirection;
	        newPositionX = positionX;
	        newPositionY = positionY;
	        newType = type;
	      }
	
	      if (overflowByInitPosition.length) {
	        var availablePropArrays = [],
	            idxAllow = [];
	
	        var sortItems = function sortItems(firstItem, items) {
	          items.splice(items.indexOf(firstItem), 1);
	          return [firstItem].concat(items);
	        };
	
	        slidePriority.forEach(function (priority, idx) {
	          if (priority === 'slideOnCurrentEdge') {
	            if (currentDirection === 'horizontal') {
	              idxAllow.positionY = idx;
	
	              if (allowedSlideOnCurrentEdge) availablePropArrays.push(sortItems(positionY, ['top', 'bottom']));else availablePropArrays.push([positionY]);
	            } else {
	              idxAllow.positionX = idx;
	
	              if (allowedSlideOnCurrentEdge) availablePropArrays.push(sortItems(positionX, ['left', 'right']));else availablePropArrays.push([positionX]);
	            }
	          }
	
	          if (priority === 'slideOnOppositeEdge') {
	            if (currentDirection === 'horizontal') {
	              idxAllow.positionX = idx;
	
	              if (allowedSlideOnOppositeEdge && currentDirection === initDirection) availablePropArrays.push(sortItems(positionX, ['left', 'right']));else availablePropArrays.push([positionX]);
	            } else {
	              idxAllow.positionY = idx;
	
	              if (allowedSlideOnOppositeEdge && currentDirection === initDirection) availablePropArrays.push(sortItems(positionY, ['top', 'bottom']));else availablePropArrays.push([positionY]);
	            }
	          }
	
	          if (priority === 'slideOnAdjacentEdge') {
	            idxAllow.direction = idx;
	
	            if (allowedSlideOnAdjacentEdge && currentDirection === initDirection) {
	              availablePropArrays.push(sortItems(initDirection, ['horizontal', 'vertical']));
	            } else {
	              availablePropArrays.push([currentDirection]);
	            }
	          }
	
	          if (priority === 'changeType') {
	            idxAllow.type = idx;
	
	            if (allowedChangeType) availablePropArrays.push(sortItems(type, ['outer', 'inner']));else availablePropArrays.push([type]);
	          }
	        });
	
	        var propCombinations = availablePropArrays.reduce(function (acc, cur) {
	          var ret = [];
	          acc.forEach(function (acc) {
	            return cur.forEach(function (cur) {
	              return ret.push(acc.concat([cur]));
	            });
	          });
	          return ret;
	        }, [[]]);
	
	        var lastCheckPosition = newPosition;
	
	        var newProps = propCombinations.find(function (combination) {
	          lastCheckPosition = _this2._getPositions({
	            positionY: combination[idxAllow.positionY] || positionY,
	            positionX: combination[idxAllow.positionX] || positionX,
	            type: combination[idxAllow.type] || type,
	            direction: combination[idxAllow.direction],
	            parent: parent
	          });
	
	          var overflow = _this2._overflowCheck(lastCheckPosition);
	          return !overflow.length;
	        });
	
	        if (newProps) {
	          newPosition = lastCheckPosition;
	          newDirection = newProps[idxAllow.direction];
	          newPositionY = newProps[idxAllow.positionY];
	          newPositionX = newProps[idxAllow.positionX];
	          newType = newProps[idxAllow.type];
	        } else if (allowedShowByCenter) {
	          newPosition = this._getCenterPosition();
	        }
	
	        this.props.onOverflow(overflowByCurrentPosition);
	      }
	
	      this.setState({
	        currentPosition: newPosition,
	        currentDirection: newDirection,
	        currentPositionX: newPositionX,
	        currentPositionY: newPositionY,
	        currentType: newType
	      });
	    }
	  }, {
	    key: '_handleContentMounted',
	    value: function _handleContentMounted() {
	      this.recalculatePosition();
	      this.props.onOpen();
	    }
	  }, {
	    key: '_saveRef',
	    value: function _saveRef(ref) {
	      this._domNode = ref;
	      if (ref) this._handleContentMounted();
	    }
	  }, {
	    key: '_overflowCheck',
	    value: function _overflowCheck(_ref) {
	      var top = _ref.top,
	          left = _ref.left;
	
	      var overflow = [];
	
	      if (!this._domNode) return overflow;
	
	      var wrapper = this.props.wrapper,
	          contentSize = this._domNode.getBoundingClientRect();
	
	
	      var wrapperTop = 0,
	          wrapperLeft = 0,
	          wrapperBottom = 0,
	          wrapperRight = 0;
	
	      if (wrapper instanceof Window) {
	        wrapperBottom = window.innerHeight;
	        wrapperRight = window.innerWidth;
	      } else if (wrapper instanceof HTMLElement) {
	        var wrapperSize = wrapper.getBoundingClientRect();
	
	        wrapperTop = wrapperSize.top;
	        wrapperLeft = wrapperSize.left;
	        wrapperBottom = wrapperSize.bottom;
	        wrapperRight = wrapperSize.right;
	      }
	
	      if (left + contentSize.width > wrapperRight - this.props.overflowMargin || left < wrapperLeft + this.props.overflowMargin) overflow.push('horizontal');
	
	      if (top + contentSize.height > wrapperBottom - this.props.overflowMargin || top < wrapperTop + this.props.overflowMargin) overflow.push('vertical');
	
	      return overflow;
	    }
	  }, {
	    key: '_getCenterPosition',
	    value: function _getCenterPosition() {
	      var viewportWidth = window.innerWidth,
	          viewportHeight = window.innerHeight,
	          contentSize = this._domNode.getBoundingClientRect();
	
	      return {
	        left: viewportWidth / 2 - contentSize.width / 2,
	        top: viewportHeight / 2 - contentSize.height / 2
	      };
	    }
	  }, {
	    key: '_getPositions',
	    value: function _getPositions(_ref2) {
	      var positionX = _ref2.positionX,
	          positionY = _ref2.positionY,
	          type = _ref2.type,
	          direction = _ref2.direction,
	          parent = _ref2.parent;
	
	      if (this._domNode && parent) {
	        var parentRect = parent.getBoundingClientRect(),
	            contentRect = this._domNode.getBoundingClientRect();
	
	        if (positionX === 'left' && positionY === 'bottom') {
	          if (type === 'outer') {
	            if (direction === 'horizontal') {
	              return {
	                top: parentRect.top - (contentRect.height - parentRect.height),
	                left: parentRect.left - contentRect.width
	              };
	            } else {
	              return {
	                top: parentRect.bottom,
	                left: parentRect.left
	              };
	            }
	          } else {
	            return {
	              top: parentRect.top - (contentRect.height - parentRect.height),
	              left: parentRect.left
	            };
	          }
	        } else if (positionX === 'left' && positionY === 'top') {
	          if (type === 'outer') {
	            if (direction === 'horizontal') {
	              return {
	                top: parentRect.top,
	                left: parentRect.left - contentRect.width
	              };
	            } else {
	              return {
	                top: parentRect.top - contentRect.height,
	                left: parentRect.left
	              };
	            }
	          } else {
	            return {
	              top: parentRect.top,
	              left: parentRect.left
	            };
	          }
	        } else if (positionX === 'right' && positionY === 'top') {
	          if (type === 'outer') {
	            if (direction === 'horizontal') {
	              return {
	                top: parentRect.top,
	                left: parentRect.right
	              };
	            } else {
	              return {
	                top: parentRect.top - contentRect.height,
	                left: parentRect.right - contentRect.width
	              };
	            }
	          } else {
	            return {
	              top: parentRect.top,
	              left: parentRect.right - contentRect.width
	            };
	          }
	        } else if (positionX === 'right' && positionY === 'bottom') {
	          if (type === 'outer') {
	            if (direction === 'horizontal') {
	              return {
	                top: parentRect.bottom - contentRect.height,
	                left: parentRect.right
	              };
	            } else {
	              return {
	                top: parentRect.bottom,
	                left: parentRect.right - contentRect.width
	              };
	            }
	          } else {
	            return {
	              top: parentRect.bottom - contentRect.height,
	              left: parentRect.right - contentRect.width
	            };
	          }
	        }
	      }
	
	      return {
	        top: 0,
	        left: 0
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var children = this.props.children;
	
	      if (!_exenv2.default.canUseDOM) return null;
	      var style = _extends({
	        position: 'fixed',
	        zIndex: 9000
	      }, this.state.currentPosition);
	
	      return !this.props.visible ? null : _react2.default.createElement(
	        _reactPortal.Portal,
	        null,
	        _react2.default.createElement(
	          'div',
	          { style: style, ref: this._saveRef },
	          typeof children !== 'function' ? children : children({
	            positionX: this.state.currentPositionX,
	            positionY: this.state.currentPositionY
	          })
	        )
	      );
	    }
	  }]);
	
	  return AutoPosition;
	}(_react.Component);
	
	exports.default = AutoPosition;
	var recalculateAllAutoPosition = exports.recalculateAllAutoPosition = function recalculateAllAutoPosition() {
	  autoPositionInstances.forEach(function (instance) {
	    return instance.recalculatePosition();
	  });
	};
	
	AutoPosition.propTypes = propTypes;
	AutoPosition.defaultProps = defaultProps;
	AutoPosition.displayName = 'AutoPosition';

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(170);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactackleButton = __webpack_require__(94);
	
	var _reactackleCore = __webpack_require__(3);
	
	var _reactackleIcons = __webpack_require__(7);
	
	var _BreadcrumbsItem = __webpack_require__(207);
	
	var _styles = __webpack_require__(560);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	(0, _reactackleCore.registerDefaultComponentTheme)('breadcrumbs', _styles.componentTheme);
	
	var propTypes = {
	  /**
	   * Array of breadcrumbs items
	   */
	  items: _propTypes2.default.arrayOf(_propTypes2.default.shape(_BreadcrumbsItem.BreadcrumbsItem.propTypes)).isRequired,
	  /**
	   * If true, breadcrumbs will become scrollable to fit wrapper width
	   */
	  overflow: _propTypes2.default.bool,
	  /**
	   * Component to be used as a link in BreadcrumbItem
	   */
	  linkComponent: _propTypes2.default.func,
	  /**
	   * Define component's color scheme
	   */
	  colorScheme: _propTypes2.default.oneOf(['light', 'dark']),
	  /**
	   * Vertical align of items
	   */
	  alignItems: _propTypes2.default.oneOf(['top', 'center', 'bottom']),
	  /**
	   * Type of separator between items
	   */
	  separatorType: _propTypes2.default.oneOf(['text', 'icon']),
	  /**
	   * Define separator
	   */
	  separatorIcon: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
	  /**
	   * Function to be used on item's click
	   */
	  onItemClick: _propTypes2.default.func
	};
	var defaultProps = {
	  linkComponent: null,
	  overflow: false,
	  colorScheme: 'dark',
	  alignItems: 'center',
	  separatorType: 'icon',
	  separatorIcon: _react2.default.createElement(_reactackleIcons.IconArrowChevronRight, { size: 'custom', color: 'inherit' }),
	  onItemClick: _reactackleCore.noop
	};
	
	var Breadcrumbs = function (_Component) {
	  _inherits(Breadcrumbs, _Component);
	
	  function Breadcrumbs(props) {
	    _classCallCheck(this, Breadcrumbs);
	
	    var _this = _possibleConstructorReturn(this, (Breadcrumbs.__proto__ || Object.getPrototypeOf(Breadcrumbs)).call(this, props));
	
	    _this.itemDomNodes = new Map();
	    _this.wrapperDomNode = null;
	    _this.lastId = props.items.length - 1;
	    _this.scrollAfterRender = false;
	    _this.animateScroll = false;
	    _this.animateEnd = true;
	
	    _this.state = {
	      showLeftButton: false,
	      showRightButton: false,
	      offset: 0,
	      id: 0
	    };
	
	    _this._handleNext = _this._handleNext.bind(_this);
	    _this._handlePrev = _this._handlePrev.bind(_this);
	    _this._handleTransitionEnd = _this._handleTransitionEnd.bind(_this);
	    _this._handleResize = (0, _lodash2.default)(_this._handleResize.bind(_this), 100);
	    _this._saveWrapListRef = _this._saveWrapListRef.bind(_this);
	    _this._saveItemRef = _this._saveItemRef.bind(_this);
	    _this._saveContainerRef = _this._saveContainerRef.bind(_this);
	    return _this;
	  }
	
	  _createClass(Breadcrumbs, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.containerDomNode.addEventListener('transitionend', this._handleTransitionEnd, false);
	      this._showButtonsAndScroll(this.lastId);
	      window.addEventListener('resize', this._handleResize, false);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.items !== this.props.items) {
	        this.lastId = nextProps.items.length - 1;
	
	        this.setState({
	          showLeftButton: false,
	          showRightButton: false,
	          offset: 0,
	          id: 0
	        });
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (prevProps.items !== this.props.items) {
	        this._showButtonsAndScroll(this.lastId);
	        this.animateScroll = false;
	      } else if (this.props.overflow && this.scrollAfterRender) {
	        this._scrollToElement(this.state.id, this.state.id >= prevState.id);
	        this.scrollAfterRender = false;
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this._handleResize, false);
	      this.containerDomNode.removeEventListener('transitionend', this._handleTransitionEnd, false);
	    }
	  }, {
	    key: '_isOverflow',
	    value: function _isOverflow() {
	      if (!this.props.overflow || this.itemDomNodes.size < 2) return false;
	
	      var lastItem = this.itemDomNodes.get(this.lastId),
	          firstItem = this.itemDomNodes.get(0),
	          lastItemSize = lastItem.getBoundingClientRect(),
	          firstItemSize = firstItem.getBoundingClientRect(),
	          wrapListSize = this.wrapperDomNode.getBoundingClientRect(),
	          overflowToRight = lastItemSize.right > wrapListSize.right,
	          overflowToLeft = firstItemSize.left < wrapListSize.left;
	
	      return overflowToRight || overflowToLeft;
	    }
	  }, {
	    key: '_handleTransitionEnd',
	    value: function _handleTransitionEnd() {
	      this.animateEnd = true;
	    }
	  }, {
	    key: '_handleResize',
	    value: function _handleResize() {
	      this.animateScroll = false;
	      this._scrollToCurrent();
	    }
	  }, {
	    key: '_showButtonsAndScroll',
	    value: function _showButtonsAndScroll(id) {
	      var newState = {
	        showLeftButton: false,
	        showRightButton: false,
	        id: id
	      };
	
	      if (this._isOverflow()) {
	        if (id === 0) {
	          newState.showRightButton = true;
	          newState.showLeftButton = false;
	        }
	
	        if (id === this.lastId) {
	          newState.showRightButton = false;
	          newState.showLeftButton = true;
	        }
	
	        if (id > 0 && id < this.lastId) {
	          newState.showRightButton = true;
	          newState.showLeftButton = true;
	        }
	
	        this.scrollAfterRender = true;
	      }
	
	      this.setState(newState);
	    }
	  }, {
	    key: '_saveItemRef',
	    value: function _saveItemRef(index, ref) {
	      if (ref) this.itemDomNodes.set(index, ref);else this.itemDomNodes.delete(index);
	    }
	  }, {
	    key: '_saveWrapListRef',
	    value: function _saveWrapListRef(ref) {
	      this.wrapperDomNode = ref;
	    }
	  }, {
	    key: '_saveContainerRef',
	    value: function _saveContainerRef(ref) {
	      this.containerDomNode = ref;
	    }
	  }, {
	    key: '_scrollToElement',
	    value: function _scrollToElement(id, alignRight) {
	      if (this.itemDomNodes.size && this.itemDomNodes.get(id)) {
	        var elSize = this.itemDomNodes.get(id).getBoundingClientRect(),
	            wrapperSize = this.wrapperDomNode.getBoundingClientRect();
	
	        var offset = this.state.offset + elSize.left - wrapperSize.left;
	
	        if (alignRight) offset -= wrapperSize.width - elSize.width;
	
	        this.setState({
	          offset: offset
	        });
	      }
	    }
	  }, {
	    key: '_scrollToCurrent',
	    value: function _scrollToCurrent() {
	      this._showButtonsAndScroll(this.state.id);
	    }
	  }, {
	    key: '_handleNext',
	    value: function _handleNext() {
	      if (!this.animateEnd) return;
	
	      var wrapListSize = this.wrapperDomNode.getBoundingClientRect();
	      var newId = this.state.id;
	
	      while (newId < this.lastId) {
	        newId += 1;
	
	        if (!this.itemDomNodes.has(newId)) break;
	
	        var newItem = this.itemDomNodes.get(newId),
	            newItemSize = newItem.getBoundingClientRect();
	
	        if (newItemSize.right > wrapListSize.right) {
	          this._showButtonsAndScroll(newId);
	          break;
	        }
	      }
	
	      this.animateScroll = true;
	      this.animateEnd = false;
	    }
	  }, {
	    key: '_handlePrev',
	    value: function _handlePrev() {
	      if (!this.animateEnd) return;
	
	      var wrapListSize = this.wrapperDomNode.getBoundingClientRect();
	      var newId = this.state.id;
	
	      while (newId > 0) {
	        newId -= 1;
	
	        if (!this.itemDomNodes.has(newId)) break;
	
	        var newItem = this.itemDomNodes.get(newId),
	            newItemSize = newItem.getBoundingClientRect();
	
	        if (newItemSize.left < wrapListSize.left) {
	          this._showButtonsAndScroll(newId);
	          break;
	        }
	      }
	
	      this.animateScroll = true;
	      this.animateEnd = false;
	    }
	  }, {
	    key: '_renderLeftButton',
	    value: function _renderLeftButton() {
	      if (!this.props.overflow || !this.state.showLeftButton) return null;
	
	      return _react2.default.createElement(
	        _styles.NavigationButtonStyled,
	        { left: true },
	        _react2.default.createElement(_reactackleButton.Button, {
	          icon: _react2.default.createElement(_reactackleIcons.IconArrowChevronLeft, { size: 'custom', color: 'inherit' }),
	          onPress: this._handlePrev,
	          colorScheme: this.props.colorScheme === 'light' ? 'flatLight' : 'flat'
	        })
	      );
	    }
	  }, {
	    key: '_renderRightButton',
	    value: function _renderRightButton() {
	      if (!this.props.overflow || !this.state.showRightButton) return null;
	
	      return _react2.default.createElement(
	        _styles.NavigationButtonStyled,
	        { right: true },
	        _react2.default.createElement(_reactackleButton.Button, {
	          icon: _react2.default.createElement(_reactackleIcons.IconArrowChevronRight, { size: 'custom', color: 'inherit' }),
	          onPress: this._handleNext,
	          colorScheme: this.props.colorScheme === 'light' ? 'flatLight' : 'flat'
	        })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          separatorType = _props.separatorType,
	          separatorIcon = _props.separatorIcon,
	          linkComponent = _props.linkComponent,
	          onItemClick = _props.onItemClick,
	          colorScheme = _props.colorScheme,
	          alignItems = _props.alignItems,
	          items = _props.items;
	
	
	      var BreadcrumbsItemsList = items.map(function (item, index, array) {
	        return _react2.default.createElement(_BreadcrumbsItem.BreadcrumbsItem, _extends({
	          index: index,
	          title: item.title,
	          subtitle: item.subtitle,
	          separatorType: separatorType,
	          separatorIcon: separatorIcon,
	          home: item.home,
	          itemHref: item.itemHref,
	          isActive: index === array.length - 1,
	          linkComponent: linkComponent,
	          onClick: onItemClick,
	          saveRef: _this2._saveItemRef,
	          options: item.options,
	          key: (0, _reactackleCore.getKey)(item, index),
	          colorScheme: colorScheme
	        }, item));
	      });
	
	      var style = {
	        transform: 'translateX(-' + this.state.offset + 'px)'
	      };
	
	      if (this.animateScroll) style.transition = '0.3s ease-in-out';
	
	      return _react2.default.createElement(
	        _styles.BreadcrumbsStyled,
	        { 'aria-label': 'Breadcrumb' },
	        this._renderLeftButton(),
	        _react2.default.createElement(
	          _styles.ListWrapperStyled,
	          { innerRef: this._saveWrapListRef },
	          _react2.default.createElement(
	            _styles.ListStyled,
	            {
	              style: style,
	              alignItems: alignItems,
	              innerRef: this._saveContainerRef
	            },
	            BreadcrumbsItemsList
	          )
	        ),
	        this._renderRightButton()
	      );
	    }
	  }]);
	
	  return Breadcrumbs;
	}(_react.Component);
	
	exports.default = Breadcrumbs;
	
	
	Breadcrumbs.propTypes = propTypes;
	Breadcrumbs.defaultProps = defaultProps;

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactackleCore = __webpack_require__(3);
	
	var _reactackleIcons = __webpack_require__(7);
	
	var _styles = __webpack_require__(554);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MenuItemType = _propTypes2.default.shape({
	  type: _propTypes2.default.func,
	  submenuGroup: _propTypes2.default.shape({
	    type: _propTypes2.default.func,
	    // Lazy function for circular structure
	    data: _propTypes2.default.arrayOf(function () {
	      return function () {
	        return MenuItemType;
	      }();
	    })
	  })
	});
	
	var propTypes = {
	  /**
	   * Define component's color scheme
	   */
	  colorScheme: _propTypes2.default.oneOf(['light', 'dark']),
	  /**
	   * Item index
	   */
	  index: _propTypes2.default.number,
	  /**
	   * Adds home icon
	   */
	  home: _propTypes2.default.bool,
	  /**
	   * Item's title
	   */
	  title: _propTypes2.default.string,
	  /**
	   * Item's subtitle
	   */
	  subtitle: _propTypes2.default.string,
	  /**
	   * Define separator
	   */
	  separatorIcon: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
	  /**
	   * Item's href
	   */
	  itemHref: _propTypes2.default.string,
	  /**
	   * Active item isn't clickable and have special appearance
	   */
	  isActive: _propTypes2.default.bool,
	  /**
	   * Component to be used as a link
	   */
	  linkComponent: _propTypes2.default.func,
	  /**
	   * Content's vertical align
	   */
	  alignItems: _propTypes2.default.oneOf(['top', 'center', 'bottom']),
	  options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    text: _propTypes2.default.string,
	    linkHref: _propTypes2.default.string,
	    type: _propTypes2.default.func,
	    data: _propTypes2.default.arrayOf(MenuItemType)
	  })),
	  /**
	   * ariaCurrentValue value
	   */
	  ariaCurrentValue: _propTypes2.default.string,
	  saveRef: _propTypes2.default.func,
	  onClick: _propTypes2.default.func,
	  // eslint-disable-next-line react/require-default-props
	  theme: _propTypes2.default.object
	};
	
	var defaultProps = {
	  colorScheme: 'dark',
	  index: 0,
	  home: false,
	  title: '',
	  subtitle: '',
	  separatorIcon: _react2.default.createElement(_reactackleIcons.IconArrowChevronRight, { size: 'custom', color: 'currentColor' }),
	  itemHref: '#',
	  isActive: false,
	  linkComponent: null,
	  alignItems: 'center',
	  saveRef: _reactackleCore.noop,
	  onClick: _reactackleCore.noop,
	  options: [],
	  ariaCurrentValue: 'item'
	};
	
	var BreadcrumbsItem = function (_Component) {
	  _inherits(BreadcrumbsItem, _Component);
	
	  function BreadcrumbsItem(props) {
	    _classCallCheck(this, BreadcrumbsItem);
	
	    var _this = _possibleConstructorReturn(this, (BreadcrumbsItem.__proto__ || Object.getPrototypeOf(BreadcrumbsItem)).call(this, props));
	
	    _this.state = {
	      left: 0,
	      top: 0,
	      isPortalOpened: false
	    };
	    _this._wrapper = null;
	    _this._createElementRef = _this._createElementRef.bind(_this);
	    _this._handleClick = _this._handleClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(BreadcrumbsItem, [{
	    key: '_handleClick',
	    value: function _handleClick(event) {
	      if (this.props.onClick !== _reactackleCore.noop) this.props.onClick({ index: this.props.index }, event);
	    }
	  }, {
	    key: '_createElementRef',
	    value: function _createElementRef(ref) {
	      this._wrapper = ref;
	      this.props.saveRef(this.props.index, ref);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          colorScheme = _props.colorScheme,
	          isActive = _props.isActive,
	          alignItems = _props.alignItems,
	          theme = _props.theme,
	          ariaCurrentValue = _props.ariaCurrentValue,
	          separatorIcon = _props.separatorIcon;
	
	
	      var componentThemePath = theme.reactackle.components.breadcrumbs.item;
	
	      var breadcrumbsIcon = this.props.home && _react2.default.createElement(
	        _styles.IconHomeStyled,
	        { colorScheme: colorScheme },
	        componentThemePath.iconHome.source
	      );
	
	      var itemHref = this.props.itemHref && !this.props.isActive ? this.props.itemHref : null;
	
	      var subtitle = this.props.subtitle && _react2.default.createElement(
	        _styles.SubtitleStyled,
	        { colorScheme: colorScheme },
	        this.props.subtitle
	      );
	
	      var arrow = this.props.options && this.props.options.length ? _react2.default.createElement(
	        _styles.IconBoxStyled,
	        { colorScheme: colorScheme },
	        componentThemePath.iconMenuSource
	      ) : null;
	
	      var AnchorElement = this.props.linkComponent ? _styles.AnchorStyled.withComponent(this.props.linkComponent) : _styles.AnchorStyled;
	
	      var ariaProps = {};
	      if (ariaCurrentValue && isActive) ariaProps = { 'aria-current': ariaCurrentValue };
	
	      var separator = _react2.default.createElement(
	        _styles.SeparatorStyled,
	        { colorScheme: colorScheme },
	        separatorIcon
	      );
	
	      return _react2.default.createElement(
	        _styles.BreadcrumbsItemStyled,
	        {
	          innerRef: this._createElementRef,
	          colorScheme: colorScheme
	        },
	        _react2.default.createElement(
	          AnchorElement,
	          _extends({
	            href: itemHref,
	            alignItems: alignItems,
	            onClick: this._handleClick,
	            colorScheme: colorScheme,
	            active: isActive
	          }, ariaProps),
	          breadcrumbsIcon,
	          _react2.default.createElement(
	            _styles.TextBoxStyled,
	            null,
	            _react2.default.createElement(
	              _styles.TitleStyled,
	              { colorScheme: colorScheme, active: isActive },
	              this.props.title
	            ),
	            subtitle
	          ),
	          arrow
	        ),
	        separator
	      );
	    }
	  }]);
	
	  return BreadcrumbsItem;
	}(_react.Component);
	
	BreadcrumbsItem.propTypes = propTypes;
	BreadcrumbsItem.defaultProps = defaultProps;
	BreadcrumbsItem.displayName = 'BreadcrumbsItem';
	
	exports.default = (0, _reactackleCore.withTheme)(BreadcrumbsItem);

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AnchorStyled = undefined;
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  alignItems: _propTypes2.default.oneOf(['top', 'center', 'bottom'])
	};
	
	var defaultProps = {
	  alignItems: 'center'
	};
	
	var ALIGN_MAP = {
	  top: 'flex-start',
	  center: 'center',
	  bottom: 'flex-end'
	};
	
	var align = function align(_ref) {
	  var alignItems = _ref.alignItems;
	  return 'align-items: ' + ALIGN_MAP[alignItems] + ';';
	};
	
	var colorScheme = function colorScheme(_ref2) {
	  var active = _ref2.active,
	      colorScheme = _ref2.colorScheme,
	      themeFromProvider = _ref2.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var stateKey = active ? 'active' : 'default';
	  var path = theme.reactackle.components.breadcrumbs.item.colorScheme[colorScheme][stateKey];
	
	  var opacity = path.opacity,
	      color = path.color;
	
	
	  var hoverOpacity = path.hover.opacity || opacity;
	  var hoverColor = path.hover.color || color;
	
	  return (0, _styledComponents.css)(['opacity:', ';color:', ';&:hover{opacity:', ';color:', ';}&:focus{opacity:', ';color:', ';}'], opacity, color, hoverOpacity, hoverColor, path.focus.opacity || hoverOpacity, path.focus.color || hoverColor);
	};
	
	var active = function active(_ref3) {
	  var active = _ref3.active;
	  return active ? '\n    &,\n    &:hover,\n    &:focus {\n      cursor: default;\n    }\n  ' : '\n    &,\n    &:hover,\n    &:focus {\n      cursor: pointer;\n    }\n  ';
	};
	
	var AnchorStyled = exports.AnchorStyled = _styledComponents2.default.a.withConfig({
	  displayName: 'AnchorStyled'
	})(['text-decoration:none;display:flex;', ' ', ' ', ''], colorScheme, active, align);
	
	AnchorStyled.propTypes = propTypes;
	AnchorStyled.defaultProps = defaultProps;

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BreadcrumbsItemStyled = undefined;
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var size = function size(_ref) {
	  var themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var maxWidth = theme.reactackle.components.breadcrumbs.item.maxWidth;
	
	
	  return (0, _styledComponents.css)(['', ''], maxWidth && 'max-width: ' + (0, _reactackleCore.getValueString)(maxWidth) + ';');
	};
	
	var colorScheme = function colorScheme(_ref2) {
	  var colorScheme = _ref2.colorScheme,
	      themeFromProvider = _ref2.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var color = theme.reactackle.components.breadcrumbs.item.colorScheme[colorScheme].default.color;
	
	
	  return '\n    color: ' + color + ';\n  ';
	};
	
	var BreadcrumbsItemStyled = exports.BreadcrumbsItemStyled = _styledComponents2.default.li.withConfig({
	  displayName: 'BreadcrumbsItemStyled'
	})(['display:flex;align-items:center;flex-shrink:0;color:inherit;position:relative;user-select:none;', ' ', ''], size, colorScheme);

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.IconBoxStyled = undefined;
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ALIGN_MAP = {
	  top: 'flex-start',
	  center: 'center',
	  bottom: 'flex-end'
	};
	
	var align = function align(_ref) {
	  var themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var alignSelf = theme.reactackle.components.breadcrumbs.item.icon.alignSelf;
	
	
	  return 'align-self: ' + ALIGN_MAP[alignSelf] + ';';
	};
	
	var size = function size(_ref2) {
	  var themeFromProvider = _ref2.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var _theme$reactackle$com = theme.reactackle.components.breadcrumbs.item.icon,
	      height = _theme$reactackle$com.height,
	      width = _theme$reactackle$com.width,
	      imgHeight = _theme$reactackle$com.imgHeight,
	      imgWidth = _theme$reactackle$com.imgWidth,
	      marginLeft = _theme$reactackle$com.marginLeft,
	      marginY = _theme$reactackle$com.marginY;
	
	
	  return (0, _styledComponents.css)(['margin:', ' 0;margin-left:', ';', ''], (0, _reactackleCore.getValueString)(marginY), (0, _reactackleCore.getValueString)(marginLeft), (0, _reactackleCore.iconSizeMixin)((0, _reactackleCore.getValueString)(height), (0, _reactackleCore.getValueString)(imgHeight || height), (0, _reactackleCore.getValueString)(width || height), (0, _reactackleCore.getValueString)(imgWidth || imgHeight || height)));
	};
	
	var colorScheme = function colorScheme(_ref3) {
	  var colorScheme = _ref3.colorScheme,
	      themeFromProvider = _ref3.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var path = theme.reactackle.components.breadcrumbs.item.icon;
	
	  return '\n    color: ' + path.colorScheme[colorScheme].color + ';\n    opacity: ' + path.opacity + ';\n  ';
	};
	
	var IconBoxStyled = exports.IconBoxStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'IconBoxStyled'
	})(['display:inline-flex;', ' ', ' ', ''], align, size, colorScheme);

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.IconHome = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactackleIcons = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	var IconHome = exports.IconHome = function IconHome(props) {
	  return _react2.default.createElement(
	    _reactackleIcons.IconSvg,
	    props,
	    _react2.default.createElement(
	      'svg',
	      { viewBox: '0 0 24 24' },
	      _react2.default.createElement('path', { d: 'M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z' })
	    )
	  );
	};
	/* eslint-enable max-len */
	
	IconHome.displayName = 'IconHome';

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.IconHomeStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  colorScheme: _propTypes2.default.oneOf(['light', 'dark'])
	};
	
	var defaultProps = {
	  colorScheme: 'dark'
	};
	
	var ALIGN_MAP = {
	  top: 'flex-start',
	  center: 'center',
	  bottom: 'flex-end'
	};
	
	var align = function align(_ref) {
	  var themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var alignSelf = theme.reactackle.components.breadcrumbs.item.iconHome.alignSelf;
	
	
	  return 'align-self: ' + ALIGN_MAP[alignSelf] + ';';
	};
	
	var size = function size(_ref2) {
	  var themeFromProvider = _ref2.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var _theme$reactackle$com = theme.reactackle.components.breadcrumbs.item.iconHome,
	      height = _theme$reactackle$com.height,
	      width = _theme$reactackle$com.width,
	      imgHeight = _theme$reactackle$com.imgHeight,
	      imgWidth = _theme$reactackle$com.imgWidth;
	
	
	  return (0, _styledComponents.css)(['     ', ''], (0, _reactackleCore.iconSizeMixin)((0, _reactackleCore.getValueString)(height), (0, _reactackleCore.getValueString)(imgHeight || height), (0, _reactackleCore.getValueString)(width || height), (0, _reactackleCore.getValueString)(imgWidth || imgHeight || height)));
	};
	
	var spacing = function spacing(_ref3) {
	  var themeFromProvider = _ref3.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var _theme$reactackle$com2 = theme.reactackle.components.breadcrumbs.item.iconHome,
	      marginY = _theme$reactackle$com2.marginY,
	      marginRight = _theme$reactackle$com2.marginRight;
	
	
	  return (0, _styledComponents.css)(['     margin-right:', ';margin-top:', ';margin-bottom:', ';'], (0, _reactackleCore.getValueString)(marginRight), (0, _reactackleCore.getValueString)(marginY), (0, _reactackleCore.getValueString)(marginY));
	};
	
	var colorScheme = function colorScheme(_ref4) {
	  var colorScheme = _ref4.colorScheme,
	      themeFromProvider = _ref4.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var path = theme.reactackle.components.breadcrumbs.item.icon;
	
	  return '\n    color: ' + path.colorScheme[colorScheme].color + ';\n    opacity: ' + path.opacity + ';\n  ';
	};
	
	var IconHomeStyled = exports.IconHomeStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'IconHomeStyled'
	})(['display:flex;align-items:center;', ' ', ' ', ' ', ''], spacing, size, align, colorScheme);
	
	IconHomeStyled.propTypes = propTypes;
	IconHomeStyled.defaultProps = defaultProps;

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SeparatorStyled = undefined;
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var size = function size(_ref) {
	  var themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var _theme$reactackle$com = theme.reactackle.components.breadcrumbs.item.separator,
	      height = _theme$reactackle$com.height,
	      width = _theme$reactackle$com.width,
	      imgHeight = _theme$reactackle$com.imgHeight,
	      imgWidth = _theme$reactackle$com.imgWidth,
	      fontSize = _theme$reactackle$com.fontSize,
	      marginY = _theme$reactackle$com.marginY,
	      marginX = _theme$reactackle$com.marginX;
	
	
	  return (0, _styledComponents.css)(['font-size:', ';line-height:', ';margin:', ' ', ';', ''], (0, _reactackleCore.getValueString)(fontSize), height, (0, _reactackleCore.getValueString)(marginY), (0, _reactackleCore.getValueString)(marginX), (0, _reactackleCore.iconSizeMixin)((0, _reactackleCore.getValueString)(height), (0, _reactackleCore.getValueString)(imgHeight || height), (0, _reactackleCore.getValueString)(width || height), (0, _reactackleCore.getValueString)(imgWidth || imgHeight || height)));
	};
	
	var colorScheme = function colorScheme(_ref2) {
	  var colorScheme = _ref2.colorScheme,
	      themeFromProvider = _ref2.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var path = theme.reactackle.components.breadcrumbs.item.separator;
	
	  return '\n    opacity: ' + path.opacity + ';\n    color: ' + path.colorScheme[colorScheme].color + ';\n    fill: ' + path.colorScheme[colorScheme].color + ';\n  ';
	};
	
	var SeparatorStyled = exports.SeparatorStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'SeparatorStyled'
	})(['display:inline-flex;align-items:center;text-align:center;', ' ', ' li:last-child &{display:none;pointer-events:none;position:fixed;width:0;height:0;}'], size, colorScheme);

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SubtitleStyled = undefined;
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fontStyle = function fontStyle(_ref) {
	  var colorScheme = _ref.colorScheme,
	      themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var path = theme.reactackle.components.breadcrumbs.item.subtitle;
	
	  var marginTop = path.marginTop,
	      fontSize = path.fontSize,
	      lineHeight = path.lineHeight,
	      fontWeight = path.fontWeight,
	      textTransform = path.textTransform;
	
	
	  return (0, _styledComponents.css)(['margin-top:', ';font-size:', ';line-height:', ';font-weight:', ';text-transform:', ';color:', ';'], (0, _reactackleCore.getValueString)(marginTop), (0, _reactackleCore.getValueString)(fontSize), lineHeight, fontWeight, textTransform, path.colorScheme[colorScheme].color);
	};
	
	var SubtitleStyled = exports.SubtitleStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'SubtitleStyled'
	})(['', ''], fontStyle);

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TextBoxStyled = undefined;
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var size = function size(_ref) {
	  var themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var _theme$reactackle$com = theme.reactackle.components.breadcrumbs.item.textBox,
	      paddingY = _theme$reactackle$com.paddingY,
	      paddingX = _theme$reactackle$com.paddingX;
	
	
	  return (0, _styledComponents.css)(['padding:', ' ', ';'], (0, _reactackleCore.getValueString)(paddingY), (0, _reactackleCore.getValueString)(paddingX));
	};
	
	var TextBoxStyled = exports.TextBoxStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'TextBoxStyled'
	})(['', ''], size);

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TitleStyled = undefined;
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fontStyle = function fontStyle(_ref) {
	  var colorScheme = _ref.colorScheme,
	      themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var path = theme.reactackle.components.breadcrumbs.item.title;
	
	  var fontSize = path.fontSize,
	      lineHeight = path.lineHeight,
	      fontWeight = path.fontWeight,
	      textTransform = path.textTransform;
	
	
	  return (0, _styledComponents.css)(['font-size:', ';line-height:', ';color:', ';font-weight:', ';text-transform:', ';'], (0, _reactackleCore.getValueString)(fontSize), lineHeight, path.colorScheme[colorScheme].color, fontWeight, textTransform);
	};
	
	var state = function state(_ref2) {
	  var active = _ref2.active,
	      themeFromProvider = _ref2.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var stateKey = active ? 'active' : 'default';
	  var path = theme.reactackle.components.breadcrumbs.item.title.state[stateKey];
	
	  var textDecoration = path.textDecoration;
	
	
	  var hoverTD = path.hover.textDecoration || textDecoration;
	
	  return (0, _styledComponents.css)(['text-decoration:', ';li > *:hover &{text-decoration:', ';}li > *:focus &{text-decoration:', ';}'], textDecoration, hoverTD, path.focus.textDecoration || hoverTD);
	};
	
	var TitleStyled = exports.TitleStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'TitleStyled'
	})(['', ' ', ''], fontStyle, state);

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BreadcrumbsItemStyled = __webpack_require__(546);
	
	Object.keys(_BreadcrumbsItemStyled).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _BreadcrumbsItemStyled[key];
	    }
	  });
	});
	
	var _AnchorStyled = __webpack_require__(545);
	
	Object.keys(_AnchorStyled).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _AnchorStyled[key];
	    }
	  });
	});
	
	var _TextBoxStyled = __webpack_require__(552);
	
	Object.keys(_TextBoxStyled).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _TextBoxStyled[key];
	    }
	  });
	});
	
	var _TitleStyled = __webpack_require__(553);
	
	Object.keys(_TitleStyled).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _TitleStyled[key];
	    }
	  });
	});
	
	var _SubtitleStyled = __webpack_require__(551);
	
	Object.keys(_SubtitleStyled).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _SubtitleStyled[key];
	    }
	  });
	});
	
	var _IconBoxStyled = __webpack_require__(547);
	
	Object.keys(_IconBoxStyled).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _IconBoxStyled[key];
	    }
	  });
	});
	
	var _IconHomeStyled = __webpack_require__(549);
	
	Object.keys(_IconHomeStyled).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _IconHomeStyled[key];
	    }
	  });
	});
	
	var _SeparatorStyled = __webpack_require__(550);
	
	Object.keys(_SeparatorStyled).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _SeparatorStyled[key];
	    }
	  });
	});

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Breadcrumbs = undefined;
	
	var _BreadcrumbsItem = __webpack_require__(207);
	
	Object.keys(_BreadcrumbsItem).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _BreadcrumbsItem[key];
	    }
	  });
	});
	
	var _Breadcrumbs = __webpack_require__(543);
	
	var _Breadcrumbs2 = _interopRequireDefault(_Breadcrumbs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Breadcrumbs = _Breadcrumbs2.default;

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BreadcrumbsStyled = undefined;
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BreadcrumbsStyled = exports.BreadcrumbsStyled = _styledComponents2.default.nav.withConfig({
	  displayName: 'BreadcrumbsStyled'
	})(['display:flex;max-width:100%;list-style-type:none;padding:0;margin:0;']);

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ListStyled = undefined;
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  alignItems: _propTypes2.default.oneOf(['top', 'center', 'bottom'])
	};
	
	var defaultProps = {
	  alignItems: 'center'
	};
	
	var ALIGN_MAP = {
	  top: 'flex-start',
	  center: 'center',
	  bottom: 'flex-end'
	};
	
	var align = function align(_ref) {
	  var alignItems = _ref.alignItems;
	  return 'align-items: ' + ALIGN_MAP[alignItems] + ';';
	};
	
	var ListStyled = exports.ListStyled = _styledComponents2.default.ol.withConfig({
	  displayName: 'ListStyled'
	})(['list-style-type:none;padding:0;margin:0;flex-grow:1;display:flex;', ''], align);
	
	ListStyled.propTypes = propTypes;
	ListStyled.defaultProps = defaultProps;

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ListWrapperStyled = undefined;
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ListWrapperStyled = exports.ListWrapperStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'ListWrapperStyled'
	})(['overflow:hidden;']);

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.NavigationButtonStyled = undefined;
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  left: _propTypes2.default.bool,
	  right: _propTypes2.default.bool
	};
	
	var defaultProps = {
	  left: false,
	  right: false
	};
	
	var margin = function margin(_ref) {
	  var left = _ref.left,
	      right = _ref.right,
	      themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var path = theme.reactackle.components.breadcrumbs.navigation;
	
	  return (0, _styledComponents.css)(['', ' ', ''], left && 'margin-right: ' + (0, _reactackleCore.getValueString)(path.margin), right && 'margin-left: ' + (0, _reactackleCore.getValueString)(path.margin));
	};
	
	var NavigationButtonStyled = exports.NavigationButtonStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'NavigationButtonStyled'
	})(['display:flex;align-items:center;', ''], margin);
	
	NavigationButtonStyled.propTypes = propTypes;
	NavigationButtonStyled.defaultProps = defaultProps;

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.componentTheme = undefined;
	
	var _BreadcrumbsStyled = __webpack_require__(556);
	
	Object.keys(_BreadcrumbsStyled).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _BreadcrumbsStyled[key];
	    }
	  });
	});
	
	var _ListWrapperStyled = __webpack_require__(558);
	
	Object.keys(_ListWrapperStyled).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ListWrapperStyled[key];
	    }
	  });
	});
	
	var _ListStyled = __webpack_require__(557);
	
	Object.keys(_ListStyled).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ListStyled[key];
	    }
	  });
	});
	
	var _NavigationButtonStyled = __webpack_require__(559);
	
	Object.keys(_NavigationButtonStyled).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _NavigationButtonStyled[key];
	    }
	  });
	});
	
	var _theme = __webpack_require__(561);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.componentTheme = _theme2.default;

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactackleIcons = __webpack_require__(7);
	
	var _reactackleCore = __webpack_require__(3);
	
	var _IconHome = __webpack_require__(548);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  item: {
	    maxWidth: null,
	
	    colorScheme: {
	      light: {
	        default: {
	          color: _reactackleCore.bodyFontColorAlt,
	          opacity: 1,
	
	          hover: {
	            color: null, // will take defaults if null
	            opacity: null // will take defaults if null
	          },
	
	          focus: {
	            color: null, // will take hover if null
	            opacity: null // will take hover if null
	          }
	        },
	
	        active: {
	          color: _reactackleCore.bodyFontColorAlt,
	          opacity: 0.7,
	
	          hover: {
	            color: null, // will take defaults if null
	            opacity: null // will take defaults if null
	          },
	
	          focus: {
	            color: null, // will take hover if null
	            opacity: null // will take hover if null
	          }
	        }
	      },
	
	      dark: {
	        default: {
	          color: _reactackleCore.bodyFontColor,
	          opacity: 1,
	
	          hover: {
	            color: null, // will take defaults if null
	            opacity: null // will take defaults if null
	          },
	
	          focus: {
	            color: null, // will take hover if null
	            opacity: null // will take hover if null
	          }
	        },
	
	        active: {
	          color: _reactackleCore.bodyFontColor,
	          opacity: 0.7,
	
	          hover: {
	            color: null, // will take defaults if null
	            opacity: null // will take defaults if null
	          },
	
	          focus: {
	            color: null, // will take hover if null
	            opacity: null // will take hover if null
	          }
	        }
	      }
	    },
	
	    textBox: {
	      paddingY: (0, _reactackleCore.bmodule)(1),
	      paddingX: 0
	    },
	
	    title: {
	      fontSize: _reactackleCore.fontSizeBody,
	      lineHeight: 1.5,
	      fontWeight: _reactackleCore.fontWeightSemibold,
	      textTransform: 'none',
	
	      colorScheme: {
	        dark: {
	          color: 'currentColor'
	        },
	        light: {
	          color: 'currentColor'
	        }
	      },
	
	      state: {
	        default: {
	          textDecoration: 'none',
	
	          hover: {
	            textDecoration: 'underline' // will take defaults if null
	          },
	
	          focus: {
	            textDecoration: null // will take hover if null
	          }
	        },
	
	        active: {
	          textDecoration: 'none',
	
	          hover: {
	            textDecoration: null // will take defaults if null
	          },
	
	          focus: {
	            textDecoration: null // will take hover if null
	          }
	        }
	      }
	    },
	
	    subtitle: {
	      marginTop: 0,
	      fontSize: _reactackleCore.fontSizeSmall,
	      lineHeight: 1.5,
	      fontWeight: _reactackleCore.fontWeightNormal,
	      textTransform: 'none',
	
	      colorScheme: {
	        dark: {
	          color: 'currentColor'
	        },
	        light: {
	          color: 'currentColor'
	        }
	      }
	    },
	
	    icon: {
	      height: 24,
	      width: null, // will take height as a default
	      imgHeight: 20, // will take height as a default
	      imgWidth: null, // will take width as a default
	      opacity: 0.5,
	      marginLeft: (0, _reactackleCore.bmodule)(0.5),
	      marginY: 0,
	      alignSelf: 'center', // One of 'top', 'center', 'bottom'
	
	      colorScheme: {
	        dark: {
	          color: 'currentColor'
	        },
	        light: {
	          color: 'currentColor'
	        }
	      }
	    },
	
	    separator: {
	      marginY: 0,
	      marginX: (0, _reactackleCore.bmodule)(1),
	      height: 24,
	      width: null, // will take height as a default
	      imgHeight: 20, // will take height as a default
	      imgWidth: null, // will take width as a default
	      fontSize: _reactackleCore.fontSizeBody,
	      opacity: 0.5,
	      iconSource: _react2.default.createElement(_reactackleIcons.IconArrowChevronRight, { size: 'custom', color: 'currentColor' }),
	
	      colorScheme: {
	        dark: {
	          color: 'currentColor'
	        },
	        light: {
	          color: 'currentColor'
	        }
	      }
	    },
	
	    iconHome: {
	      source: _react2.default.createElement(_IconHome.IconHome, { size: 'custom', color: 'currentColor' }),
	      marginY: 8,
	      marginRight: (0, _reactackleCore.bmodule)(0.5),
	      alignSelf: 'top', // One of 'top', 'center', 'bottom'
	      height: 16,
	      width: null, // will take height as a default
	      imgHeight: null, // will take height as a default
	      imgWidth: null, // will take width as a default
	      opacity: 0.5,
	
	      colorScheme: {
	        dark: {
	          color: 'currentColor'
	        },
	        light: {
	          color: 'currentColor'
	        }
	      }
	    },
	
	    iconMenuSource: _react2.default.createElement(_reactackleIcons.IconArrowDropDown, { size: 'custom', color: 'currentColor' })
	  },
	
	  navigation: {
	    margin: (0, _reactackleCore.bmodule)(1)
	  }
	};

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactackleCore = __webpack_require__(3);
	
	var _ButtonStyled = __webpack_require__(564);
	
	var _ButtonTextStyled = __webpack_require__(566);
	
	var _ButtonTitleStyled = __webpack_require__(567);
	
	var _ButtonSubtitleStyled = __webpack_require__(565);
	
	var _ButtonIconStyled = __webpack_require__(563);
	
	var _theme = __webpack_require__(569);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	(0, _reactackleCore.registerDefaultComponentTheme)('button', _theme2.default);
	
	var propTypes = {
	  /** Define button's main text */
	  text: _propTypes2.default.string,
	  /**
	   * Define button's alternate text for the user,
	   * if he/she for some reason can't see the component
	   */
	  alternateTitle: _propTypes2.default.string,
	  /** Define button's subtitle */
	  subtitle: _propTypes2.default.string,
	  /** Define button's size */
	  size: _propTypes2.default.oneOf(['inline', 'small', 'normal', 'large']),
	  /** Narrow button has smaller horizontal paddings */
	  narrow: _propTypes2.default.bool,
	  /** Define button's color */
	  colorScheme: _propTypes2.default.oneOf(['primary', 'secondary', 'alert', 'success', 'warning', 'info', 'flat', 'flatLight', 'white', 'link']),
	  /** Outlined button has border and transparent background */
	  outlined: _propTypes2.default.bool,
	  /** Define button's radius */
	  radius: _propTypes2.default.oneOf(['none', 'default', 'rounded']),
	  /** Raised button has shadow */
	  raised: _propTypes2.default.bool,
	  /** Set disable to true if interaction with button isn't available to user */
	  disabled: _propTypes2.default.bool,
	  /** Swap icon and text position */
	  iconPositionRight: _propTypes2.default.bool,
	  /**
	   * Define icon (see IconSvg or IconCustom props)
	   */
	  icon: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func]),
	  /**
	   * Stop onClick event's propagation and only call onPress
	   */
	  stopPressPropagation: _propTypes2.default.bool,
	  /**
	   * Specify function to call on Button press
	   */
	  onPress: _propTypes2.default.func,
	  /**
	   * The URL to link to when the button is clicked
	   */
	  href: _propTypes2.default.string
	};
	
	var defaultProps = {
	  text: '',
	  alternateTitle: '',
	  subtitle: '',
	  size: 'normal',
	  narrow: false,
	  colorScheme: 'flat',
	  outlined: false,
	  radius: 'default',
	  raised: false,
	  disabled: false,
	  iconPositionRight: false,
	  icon: null,
	  stopPressPropagation: false,
	  onPress: _reactackleCore.noop,
	  href: ''
	};
	
	var Button = function (_Component) {
	  _inherits(Button, _Component);
	
	  function Button(props) {
	    _classCallCheck(this, Button);
	
	    var _this = _possibleConstructorReturn(this, (Button.__proto__ || Object.getPrototypeOf(Button)).call(this, props));
	
	    _this._handleClick = _this._handleClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(Button, [{
	    key: '_handleClick',
	    value: function _handleClick(event) {
	      if (!this.props.disabled) {
	        if (this.props.stopPressPropagation) event.stopPropagation();
	        this.props.onPress(event);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var subtitle = this.props.text && this.props.subtitle ? _react2.default.createElement(
	        _ButtonSubtitleStyled.ButtonSubtitleStyled,
	        { size: this.props.size },
	        this.props.subtitle
	      ) : null;
	
	      var buttonText = this.props.text ? _react2.default.createElement(
	        _ButtonTextStyled.ButtonTextStyled,
	        {
	          text: this.props.text,
	          subtitle: this.props.subtitle,
	          size: this.props.size,
	          iconPositionRight: this.props.iconPositionRight
	        },
	        subtitle,
	        _react2.default.createElement(
	          _ButtonTitleStyled.ButtonTitleStyled,
	          { size: this.props.size },
	          this.props.text
	        )
	      ) : null;
	
	      var iconElement = void 0;
	
	      if (typeof this.props.icon === "function") {
	        var Icon = this.props.icon;
	        iconElement = _react2.default.createElement(Icon, null);
	      } else {
	        iconElement = this.props.icon;
	      }
	
	      var buttonIcon = this.props.icon ? _react2.default.createElement(
	        _ButtonIconStyled.ButtonIconBoxStyled,
	        {
	          iconPositionRight: this.props.iconPositionRight,
	          size: this.props.size,
	          disabled: this.props.disabled
	        },
	        iconElement
	      ) : null;
	
	      return _react2.default.createElement(
	        _ButtonStyled.ButtonStyled,
	        {
	          colorScheme: this.props.colorScheme,
	          size: this.props.size,
	          narrow: this.props.narrow,
	          radius: this.props.radius,
	          disabled: this.props.disabled,
	          outlined: this.props.outlined,
	          text: this.props.text,
	          title: this.props.alternateTitle,
	          subtitle: this.props.subtitle,
	          raised: this.props.raised,
	          onClick: this._handleClick,
	          href: this.props.href
	        },
	        buttonIcon,
	        buttonText
	      );
	    }
	  }]);
	
	  return Button;
	}(_react.Component);
	
	exports.default = Button;
	
	
	Button.propTypes = propTypes;
	Button.defaultProps = defaultProps;
	Button.displayName = 'Button';

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ButtonIconBoxStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /** Define button's size */
	  size: _propTypes2.default.oneOf(['inline', 'small', 'normal', 'large']),
	  /** Swap icon and text position */
	  iconPositionRight: _propTypes2.default.bool
	};
	
	var defaultProps = {
	  size: 'normal',
	  iconPositionRight: false
	};
	
	// PROP RECEIVERS
	var iconStyleProps = function iconStyleProps(_ref) {
	  var themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var path = theme.reactackle.components.button;
	  var opacityAmount = path.iconOpacity;
	
	  return (0, _styledComponents.css)(['opacity:', ';svg{fill:currentColor;}'], opacityAmount);
	};
	
	var iconSizeProps = function iconSizeProps(_ref2) {
	  var size = _ref2.size,
	      themeFromProvider = _ref2.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var path = theme.reactackle.components.button.size[size].icon;
	
	  return (0, _styledComponents.css)(['', ' ', ''], (0, _reactackleCore.iconSizeMixin)((0, _reactackleCore.getValueString)(path.width), (0, _reactackleCore.getValueString)(path.imgSize || path.width), (0, _reactackleCore.getValueString)(path.height || path.width)), size === 'inline' && '\n      display: inline-flex;\n      align-self: center;\n    ');
	};
	
	var ButtonIconBoxStyled = exports.ButtonIconBoxStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'ButtonIconStyled__ButtonIconBoxStyled'
	})(['order:', ';display:flex;align-items:center;justify-content:center;', ';', ';'], function (props) {
	  return props.iconPositionRight ? '2' : '1';
	}, iconStyleProps, iconSizeProps);
	
	ButtonIconBoxStyled.propTypes = propTypes;
	ButtonIconBoxStyled.defaultProps = defaultProps;
	ButtonIconBoxStyled.displayName = 'ButtonIconBoxStyled';

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ButtonStyled = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _color = __webpack_require__(208);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var propTypes = {
	  /** Define button's main text */
	  text: _propTypes2.default.string,
	  /** Define button's subtitle */
	  subtitle: _propTypes2.default.string,
	  /** Define button's size */
	  size: _propTypes2.default.oneOf(['inline', 'small', 'normal', 'large']),
	  /** Narrow button has smaller horizontal paddings */
	  narrow: _propTypes2.default.bool,
	  /** Define button's color */
	  colorScheme: _propTypes2.default.oneOf(['primary', 'secondary', 'alert', 'success', 'warning', 'info', 'flat', 'flatLight', 'white', 'link']),
	  /** Outlined button has border and transparent background */
	  outlined: _propTypes2.default.bool,
	  /** Define button's radius */
	  radius: _propTypes2.default.oneOf(['none', 'default', 'rounded']),
	  /** Raised button has shadow */
	  raised: _propTypes2.default.bool,
	  /** Set disable to true if interaction with button isn't available to user */
	  disabled: _propTypes2.default.bool,
	  /**
	   * Define component theme config
	   * See https://github.com/styled-components/styled-components/blob/master/docs/theming.md
	   * for more information
	   */
	  // eslint-disable-next-line react/require-default-props
	  theme: _propTypes2.default.object
	};
	
	var defaultProps = {
	  text: '',
	  subtitle: '',
	  size: 'normal',
	  narrow: false,
	  colorScheme: 'flat',
	  outlined: false,
	  radius: 'default',
	  raised: false,
	  disabled: false
	};
	
	// PROP RECEIVERS
	var sizeProps = function sizeProps(_ref) {
	  var size = _ref.size,
	      narrow = _ref.narrow,
	      text = _ref.text,
	      radius = _ref.radius,
	      themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var paddingY = theme.reactackle.components.button.size[size].paddingY;
	  var paddingX = theme.reactackle.components.button.size[size].paddingX;
	
	  var narrowPaddingX = theme.reactackle.components.button.size[size].narrowPaddingX;
	
	  var roundedPaddingX = theme.reactackle.components.button.size[size].roundedPaddingX;
	
	  var py = text ? (0, _reactackleCore.getValueString)(paddingY) : 0;
	
	  var px = null;
	  if (narrow) px = (0, _reactackleCore.getValueString)(narrowPaddingX);else if (!text) px = '0 !important';else if (radius === 'rounded') px = (0, _reactackleCore.getValueString)(roundedPaddingX);else px = (0, _reactackleCore.getValueString)(paddingX);
	
	  return 'padding: ' + py + ' ' + px + ';';
	};
	
	var radiusProps = function radiusProps(_ref2) {
	  var radius = _ref2.radius,
	      size = _ref2.size,
	      themeFromProvider = _ref2.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var minHeight = theme.reactackle.components.button.size[size].minHeight;
	  var borderRadiusDefault = theme.reactackle.components.button.borderRadiusDefault;
	
	  var rad = null;
	  if (radius === 'rounded') rad = 'border-radius: ' + (0, _reactackleCore.getValueString)(minHeight) + ';';else if (radius === 'default') rad = 'border-radius: ' + (0, _reactackleCore.getValueString)(borderRadiusDefault) + ';';else rad = 'border-radius: 0;';
	
	  return rad;
	};
	
	var kindProps = function kindProps(_ref3) {
	  var colorScheme = _ref3.colorScheme,
	      outlined = _ref3.outlined,
	      themeFromProvider = _ref3.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var backgroundColor = theme.reactackle.components.button.colorScheme[colorScheme].backgroundColor;
	
	  var bgTransparency = (0, _color2.default)(backgroundColor).alpha() === 1;
	
	  var hoverBackgroundColor = theme.reactackle.components.button.colorScheme[colorScheme].hover.backgroundColor;
	
	  var focusBackgroundColor = theme.reactackle.components.button.colorScheme[colorScheme].focus.backgroundColor;
	
	  var colorDark = theme.reactackle.components.button.text.colorDark;
	  var colorLight = theme.reactackle.components.button.text.colorLight;
	  var fontColor = theme.reactackle.components.button.colorScheme[colorScheme].fontColor || (0, _reactackleCore.foreground)(backgroundColor, colorDark, colorLight);
	
	  var hoverFontColor = theme.reactackle.components.button.colorScheme[colorScheme].hover.fontColor;
	
	  var focusFontColor = theme.reactackle.components.button.colorScheme[colorScheme].focus.fontColor;
	
	  var borderWidth = theme.reactackle.components.button.borderWidth;
	  var borderStyle = theme.reactackle.components.button.borderStyle;
	
	  return (0, _styledComponents.css)(['', ''], outlined ? '\n        border-width: ' + (0, _reactackleCore.getValueString)(borderWidth) + ';\n        border-style: ' + borderStyle + ';\n        border-color: ' + (bgTransparency ? backgroundColor : fontColor) + ';\n        background-color: ' + (0, _color2.default)(backgroundColor).fade(1) + ';\n        color: ' + (bgTransparency ? backgroundColor : fontColor) + ';\n        \n        &:hover,\n        &:focus,\n        &:active {      \n          border-color: ' + (bgTransparency ? hoverBackgroundColor : hoverFontColor) + ';\n          background-color: ' + (bgTransparency ? (0, _color2.default)(hoverBackgroundColor).fade(0.9) : (0, _color2.default)(hoverFontColor).fade(0.9)) + ';\n          color: ' + (bgTransparency ? hoverBackgroundColor : hoverFontColor) + ';\n        }\n      ' : '          \n        background-color: ' + backgroundColor + ';\n        color: ' + fontColor + ';\n        border-width: 0;\n  \n        &:hover {\n          background-color: ' + hoverBackgroundColor + ';\n          color: ' + hoverFontColor + ';\n        }\n        \n        &:focus,\n        &:active {      \n          background-color: ' + focusBackgroundColor + ';\n          color: ' + focusFontColor + ';\n        }\n      ');
	};
	
	var elevation = function elevation(_ref4) {
	  var raised = _ref4.raised;
	  return '\n  ' + (raised ? (0, _reactackleCore.boxShadow)(0) + '\n              \n        &:hover,\n        &:focus,\n        &:active { \n          ' + (0, _reactackleCore.boxShadow)(2) + '    \n        }\n      ' : '\n      &:hover,\n      &:focus,\n      &:active { \n        box-shadow: none  \n      }\n    ') + '\n';
	};
	
	var disabled = function disabled(_ref5) {
	  var disabled = _ref5.disabled,
	      themeFromProvider = _ref5.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var backgroundColor = theme.reactackle.components.button.disabled.backgroundColor;
	
	  var fontColor = theme.reactackle.components.button.disabled.fontColor;
	
	  // remove pointerEvents when https://github.com/facebook/react/issues/4251 is resolved
	  return (0, _styledComponents.css)(['', ''], disabled ? '\n          box-shadow: none;\n          pointer-events: none;\n          &,\n          &:hover,\n          &:focus,\n          &:active {\n            cursor: default;\n            background-color: ' + backgroundColor + ';\n            border-color: ' + backgroundColor + ';\n            color: ' + fontColor + ';\n            box-shadow: none;\n          };\n        ' : null);
	};
	
	var textProps = function textProps(_ref6) {
	  var subtitle = _ref6.subtitle,
	      size = _ref6.size,
	      themeFromProvider = _ref6.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var fontSize = theme.reactackle.components.button.size[size].fontSize;
	  var lineHeight = theme.reactackle.components.button.size[size].lineHeight;
	  var textTransform = theme.reactackle.components.button.text.textTransform;
	  var fontWeight = theme.reactackle.components.button.text.fontWeight;
	
	  var fontFamily = theme.reactackle.fontFamily[theme.reactackle.body.fontFamily];
	
	  return '   \n    font-size: ' + (0, _reactackleCore.getValueString)(fontSize) + ';\n    line-height: ' + lineHeight + ';\n    text-align: ' + (subtitle ? 'left' : 'center') + ';\n    text-decoration: none;\n    text-transform: ' + textTransform + ';\n    font-weight: ' + fontWeight + ';\n    \n    &,\n    & *,\n    *::after,\n    *::before {\n      font-family: ' + fontFamily + ';\n      box-sizing: border-box;\n    }\n  ';
	};
	
	// STYLES
	var Button = _styledComponents2.default.button.withConfig({
	  displayName: 'ButtonStyled__Button'
	})(['-webkit-appearance:none;-moz-appearance:none;cursor:pointer;margin:0;position:relative;display:inline-flex;user-select:none;vertical-align:middle;align-items:center;justify-content:center;box-sizing:border-box;text-decoration:none;&:hover,&:focus,&:active{outline:none;}', ';', ';', ';', ';', ';', ';', ';'], kindProps, textProps, sizeProps, radiusProps, elevation, disabled, (0, _reactackleCore.transition)('color, background-color, border, box-shadow'));
	
	var Anchor = Button.withComponent('a');
	
	// eslint-disable-next-line react/prop-types
	var ButtonStyled = function ButtonStyled(_ref7) {
	  var href = _ref7.href,
	      props = _objectWithoutProperties(_ref7, ['href']);
	
	  return href && href.length ? _react2.default.createElement(Anchor, _extends({ href: href }, props)) : _react2.default.createElement(Button, props);
	};
	
	exports.ButtonStyled = ButtonStyled;
	ButtonStyled.propTypes = propTypes;
	ButtonStyled.defaultProps = defaultProps;
	ButtonStyled.displayName = 'ButtonStyled';

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ButtonSubtitleStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /** Define button's size */
	  size: _propTypes2.default.oneOf(['inline', 'small', 'normal', 'large']),
	  /**
	   * Define theme
	   * See https://github.com/styled-components/styled-components/blob/master/docs/theming.md
	   * for more information
	   */
	  theme: _propTypes2.default.object
	};
	var defaultProps = {
	  size: 'normal'
	};
	
	// PROP RECEIVERS
	var subtitleSizeProps = function subtitleSizeProps(_ref) {
	  var size = _ref.size,
	      themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var _theme$reactackle$com = theme.reactackle.components.button.size[size],
	      subtitleFontSize = _theme$reactackle$com.subtitleFontSize,
	      subtitleLineHeight = _theme$reactackle$com.subtitleLineHeight;
	  var _theme$reactackle$com2 = theme.reactackle.components.button.subtitle,
	      fontWeight = _theme$reactackle$com2.fontWeight,
	      textTransform = _theme$reactackle$com2.textTransform,
	      fontColor = _theme$reactackle$com2.fontColor,
	      fontOpacity = _theme$reactackle$com2.fontOpacity,
	      subtitleTitleSpacing = _theme$reactackle$com2.subtitleTitleSpacing;
	
	
	  return '\n    font-size: ' + (0, _reactackleCore.getValueString)(subtitleFontSize) + ';\n    line-height: ' + subtitleLineHeight + ';\n    font-weight: ' + fontWeight + ';\n    text-transform: ' + textTransform + ';\n    color: ' + fontColor + ';\n    opacity: ' + fontOpacity + ';\n    margin-bottom: ' + (0, _reactackleCore.getValueString)(subtitleTitleSpacing) + ';\n  ';
	};
	
	var ButtonSubtitleStyled = exports.ButtonSubtitleStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'ButtonSubtitleStyled'
	})(['', ';color:inherit;'], subtitleSizeProps);
	
	ButtonSubtitleStyled.propTypes = propTypes;
	ButtonSubtitleStyled.defaultProps = defaultProps;
	ButtonSubtitleStyled.displayName = 'ButtonSubtitleStyled';

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ButtonTextStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /** Define button's size */
	  size: _propTypes2.default.oneOf(['inline', 'small', 'normal', 'large']),
	  /** Swap icon and text position */
	  iconPositionRight: _propTypes2.default.bool,
	  /**
	   * Define theme
	   * See https://github.com/styled-components/styled-components/blob/master/docs/theming.md
	   * for more information
	   */
	  theme: _propTypes2.default.object
	};
	
	var defaultProps = {
	  size: 'normal',
	  iconPositionRight: false
	};
	
	/* Prop Receivers */
	var textSizeProps = function textSizeProps(_ref) {
	  var size = _ref.size,
	      iconPositionRight = _ref.iconPositionRight,
	      themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var _theme$reactackle$com = theme.reactackle.components.button.size[size],
	      textPaddingY = _theme$reactackle$com.textPaddingY,
	      textPaddingX = _theme$reactackle$com.textPaddingX;
	
	
	  return (0, _styledComponents.css)(['padding:', ' ', ';order:', ';'], (0, _reactackleCore.getValueString)(textPaddingY), (0, _reactackleCore.getValueString)(textPaddingX), iconPositionRight ? '1' : '2');
	};
	
	/* Styles */
	var ButtonTextStyled = exports.ButtonTextStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'ButtonTextStyled'
	})(['flex-grow:1;min-width:0;', ';'], textSizeProps);
	
	ButtonTextStyled.propTypes = propTypes;
	ButtonTextStyled.defaultProps = defaultProps;
	ButtonTextStyled.displayName = 'ButtonTextStyled';

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ButtonTitleStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /** Define button's size */
	  size: _propTypes2.default.oneOf(['inline', 'small', 'normal', 'large']),
	  /**
	   * Define theme
	   * See https://github.com/styled-components/styled-components/blob/master/docs/theming.md
	   * for more information
	   */
	  theme: _propTypes2.default.object
	};
	
	var defaultProps = {
	  size: 'normal'
	};
	
	var titleSizeProps = function titleSizeProps(_ref) {
	  var size = _ref.size,
	      themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var lineHeight = theme.reactackle.components.button.size[size].lineHeight;
	
	  var _theme$reactackle$com = theme.reactackle.components.button.text,
	      fontWeight = _theme$reactackle$com.fontWeight,
	      textTransform = _theme$reactackle$com.textTransform;
	
	
	  return '\n    font-size: inherit;\n    line-height: ' + lineHeight + ';\n    font-weight: ' + fontWeight + ';\n    text-transform: ' + textTransform + ';\n  ';
	};
	
	var ButtonTitleStyled = exports.ButtonTitleStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'ButtonTitleStyled'
	})(['color:inherit;text-align:inherit;', ';'], titleSizeProps);
	
	ButtonTitleStyled.propTypes = propTypes;
	ButtonTitleStyled.defaultProps = defaultProps;
	ButtonTitleStyled.displayName = 'ButtonTitleStyled';

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.buttonColorConstants = exports.buttonHeightConstants = exports.buttonSizeConstants = exports.buttonConstants = undefined;
	
	var _reactackleCore = __webpack_require__(3);
	
	var buttonConstants = exports.buttonConstants = {
	  functionFactor: 0.15
	};
	
	var buttonSizeConstants = exports.buttonSizeConstants = {
	  small: {
	    lineHeight: 1,
	    fontSize: _reactackleCore.fontSize['-1'],
	    paddingY: 0,
	    textPaddingY: _reactackleCore.baseModule,
	
	    subtitleFontSize: _reactackleCore.fontSize['-1'],
	    subtitleLineHeight: 1
	  },
	  normal: {
	    lineHeight: 1.25,
	    fontSize: _reactackleCore.fontSize[0],
	    paddingY: 0,
	    textPaddingY: _reactackleCore.baseModule,
	
	    subtitleFontSize: _reactackleCore.fontSize[0],
	    subtitleLineHeight: 1.25
	  },
	  large: {
	    lineHeight: 1.15,
	    fontSize: _reactackleCore.fontSize[1],
	    paddingY: 0,
	    textPaddingY: _reactackleCore.oneAndHalfBaseModule,
	
	    subtitleFontSize: _reactackleCore.fontSize[1],
	    subtitleLineHeight: 1.15
	  }
	};
	
	var buttonHeightConstants = exports.buttonHeightConstants = {
	  buttonSmallMinHeight: function buttonSmallMinHeight(base) {
	    return buttonSizeConstants.small.lineHeight * buttonSizeConstants.small.fontSize + (buttonSizeConstants.small.paddingY + buttonSizeConstants.small.textPaddingY(base)) * 2;
	  },
	
	  buttonNormalMinHeight: function buttonNormalMinHeight(base) {
	    return buttonSizeConstants.normal.lineHeight * buttonSizeConstants.normal.fontSize + (buttonSizeConstants.normal.paddingY + buttonSizeConstants.normal.textPaddingY(base)) * 2;
	  },
	
	  buttonLargeMinHeight: function buttonLargeMinHeight(base) {
	    return buttonSizeConstants.large.lineHeight * buttonSizeConstants.large.fontSize + (buttonSizeConstants.large.paddingY + buttonSizeConstants.large.textPaddingY(base)) * 2;
	  }
	};
	
	var buttonColorConstants = exports.buttonColorConstants = {
	  primary: {
	    backgroundColor: _reactackleCore.colorMain,
	    fontColor: function fontColor(_ref) {
	      var color = _ref.color;
	      return color.mainFgTextColor;
	    }
	  },
	
	  secondary: {
	    backgroundColor: _reactackleCore.colorSecondary,
	    fontColor: function fontColor(_ref2) {
	      var color = _ref2.color;
	      return color.secondaryFgTextColor;
	    }
	  },
	
	  alert: {
	    backgroundColor: function backgroundColor(_ref3) {
	      var color = _ref3.color;
	      return color.alert;
	    },
	    fontColor: function fontColor(_ref4) {
	      var color = _ref4.color;
	      return color.alertFgTextColor;
	    }
	  },
	
	  success: {
	    backgroundColor: function backgroundColor(_ref5) {
	      var color = _ref5.color;
	      return color.success;
	    },
	    fontColor: function fontColor(_ref6) {
	      var color = _ref6.color;
	      return color.successFgTextColor;
	    }
	  },
	
	  warning: {
	    backgroundColor: function backgroundColor(_ref7) {
	      var color = _ref7.color;
	      return color.warning;
	    },
	    fontColor: function fontColor(_ref8) {
	      var color = _ref8.color;
	      return color.warningFgTextColor;
	    }
	  },
	
	  info: {
	    backgroundColor: function backgroundColor(_ref9) {
	      var color = _ref9.color;
	      return color.info;
	    },
	    fontColor: function fontColor(_ref10) {
	      var color = _ref10.color;
	      return color.infoFgTextColor;
	    }
	  },
	
	  link: {
	    backgroundColor: _reactackleCore.colorTransparent,
	    fontColor: function fontColor(_ref11) {
	      var colorAnchor = _ref11.colorAnchor;
	      return colorAnchor;
	    }
	  }
	};

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _color = __webpack_require__(208);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _reactackleCore = __webpack_require__(3);
	
	var _constants = __webpack_require__(568);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  functionFactor: _constants.buttonConstants.functionFactor,
	  iconOpacity: 1,
	
	  borderRadiusDefault: _reactackleCore.radiusDefault,
	  borderStyle: 'solid',
	  borderWidth: 1,
	
	  disabled: {
	    backgroundColor: _reactackleCore.colorPaletteGrey100,
	    fontColor: function fontColor(_ref) {
	      var _fontColor = _ref.fontColor;
	      return _fontColor.medium;
	    }
	  },
	
	  text: {
	    fontSize: _constants.buttonSizeConstants.normal.fontSize,
	    fontFamily: function fontFamily(_ref2) {
	      var body = _ref2.body;
	      return body.fontFamily;
	    },
	    fontAlign: function fontAlign(_ref3) {
	      var direction = _ref3.direction;
	      return direction.float;
	    },
	    fontWeight: _reactackleCore.fontWeightSemibold,
	    lineHeight: _constants.buttonSizeConstants.normal.lineHeight,
	
	    textTransform: 'uppercase',
	
	    colorLight: _reactackleCore.colorWhite,
	    colorDark: _reactackleCore.colorBlack
	  },
	
	  subtitle: {
	    fontColor: 'inherit',
	    fontOpacity: 0.9,
	    fontWeight: function fontWeight(_ref4) {
	      var _fontWeight = _ref4.fontWeight;
	      return _fontWeight.normal;
	    },
	    textTransform: 'none',
	
	    subtitleTitleSpacing: (0, _reactackleCore.bmodule)(0.5)
	  },
	
	  size: {
	    small: {
	      fontSize: _constants.buttonSizeConstants.small.fontSize,
	      lineHeight: _constants.buttonSizeConstants.small.lineHeight,
	
	      paddingY: _constants.buttonSizeConstants.small.paddingY,
	      paddingX: (0, _reactackleCore.bmodule)(1),
	      narrowPaddingX: 0,
	      roundedPaddingX: (0, _reactackleCore.bmodule)(2),
	
	      textPaddingY: _constants.buttonSizeConstants.small.textPaddingY,
	      textPaddingX: (0, _reactackleCore.bmodule)(0.75),
	      minHeight: _constants.buttonHeightConstants.buttonSmallMinHeight,
	
	      subtitleFontSize: _constants.buttonSizeConstants.small.subtitleFontSize,
	      subtitleLineHeight: _constants.buttonSizeConstants.small.subtitleLineHeight,
	
	      icon: {
	        width: 24,
	        height: null,
	        imgSize: null
	      }
	    },
	
	    normal: {
	      fontSize: _constants.buttonSizeConstants.normal.fontSize + 1,
	      lineHeight: _constants.buttonSizeConstants.normal.lineHeight,
	      paddingX: (0, _reactackleCore.bmodule)(1),
	      narrowPaddingX: 0,
	      roundedPaddingX: (0, _reactackleCore.bmodule)(2),
	      paddingY: _constants.buttonSizeConstants.normal.paddingY,
	      textPaddingY: _constants.buttonSizeConstants.normal.textPaddingY,
	      textPaddingX: (0, _reactackleCore.bmodule)(0.75),
	      minHeight: _constants.buttonHeightConstants.buttonNormalMinHeight,
	
	      subtitleFontSize: _constants.buttonSizeConstants.normal.subtitleFontSize,
	      subtitleLineHeight: _constants.buttonSizeConstants.normal.subtitleLineHeight,
	
	      icon: {
	        width: 30,
	        height: null,
	        imgSize: null
	      }
	    },
	
	    large: {
	      fontSize: _constants.buttonSizeConstants.large.fontSize,
	      lineHeight: _constants.buttonSizeConstants.large.lineHeight,
	      paddingX: (0, _reactackleCore.bmodule)(2.5),
	      narrowPaddingX: (0, _reactackleCore.bmodule)(1.5),
	      roundedPaddingX: (0, _reactackleCore.bmodule)(3),
	      paddingY: _constants.buttonSizeConstants.large.paddingY,
	      textPaddingY: _constants.buttonSizeConstants.large.textPaddingY,
	      textPaddingX: (0, _reactackleCore.bmodule)(0.75),
	      minHeight: _constants.buttonHeightConstants.buttonLargeMinHeight,
	
	      subtitleFontSize: _constants.buttonSizeConstants.large.subtitleFontSize,
	      subtitleLineHeight: _constants.buttonSizeConstants.large.lineHeight,
	
	      icon: {
	        width: 36,
	        height: null,
	        imgSize: null
	      }
	    },
	
	    inline: {
	      fontSize: 'inherit',
	      lineHeight: 'inherit',
	      paddingX: '0.75em',
	      narrowPaddingX: '0.5em',
	      paddingY: 0,
	      textPaddingY: '0.3em',
	      textPaddingX: '0.35em',
	      minHeight: 0,
	
	      subtitleFontSize: 'inherit',
	      subtitleLineHeight: 'inherit',
	
	      icon: {
	        width: '1.5em',
	        height: null,
	        imgSize: null
	      }
	    },
	
	    link: {
	      fontSize: 'inherit',
	      lineHeight: 'inherit',
	      paddingX: 0,
	      narrowPaddingX: 0,
	      paddingY: 0,
	      smallPaddingY: (0, _reactackleCore.bmodule)(0.5),
	      textPaddingY: 0,
	      textPaddingX: 0,
	      minHeight: 0,
	
	      subtitleFontSize: 'inherit',
	      subtitleLineHeight: 'inherit'
	    }
	  },
	
	  colorScheme: {
	    flat: {
	      backgroundColor: _reactackleCore.colorTransparent,
	      fontColor: _reactackleCore.bodyFontColor,
	
	      hover: {
	        backgroundColor: function backgroundColor(_ref5) {
	          var color = _ref5.color;
	          return (0, _color2.default)(color.black).fade(0.9);
	        },
	        fontColor: _reactackleCore.bodyFontColor
	      },
	
	      focus: {
	        backgroundColor: function backgroundColor(_ref6) {
	          var color = _ref6.color;
	          return (0, _color2.default)(color.black).fade(0.8);
	        },
	        fontColor: _reactackleCore.bodyFontColor
	      }
	    },
	
	    flatLight: {
	      backgroundColor: _reactackleCore.colorTransparent,
	      fontColor: _reactackleCore.colorWhite,
	
	      hover: {
	        backgroundColor: function backgroundColor(_ref7) {
	          var color = _ref7.color;
	          return (0, _color2.default)(color.white).fade(0.8);
	        },
	        fontColor: _reactackleCore.colorWhite
	      },
	
	      focus: {
	        backgroundColor: function backgroundColor(_ref8) {
	          var color = _ref8.color;
	          return (0, _color2.default)(color.white).fade(0.6);
	        },
	        fontColor: _reactackleCore.colorWhite
	      }
	    },
	
	    white: {
	      backgroundColor: _reactackleCore.colorWhite,
	      fontColor: _reactackleCore.colorMain,
	
	      hover: {
	        backgroundColor: _reactackleCore.colorPaletteGrey100,
	        fontColor: _reactackleCore.colorMain
	      },
	
	      focus: {
	        backgroundColor: _reactackleCore.colorPaletteGrey100,
	        fontColor: _reactackleCore.colorMain
	      }
	    },
	
	    primary: {
	      backgroundColor: _constants.buttonColorConstants.primary.backgroundColor,
	      fontColor: _constants.buttonColorConstants.primary.fontColor,
	
	      hover: {
	        backgroundColor: function backgroundColor(base) {
	          return (0, _color2.default)(_constants.buttonColorConstants.primary.backgroundColor(base)).darken(_constants.buttonConstants.functionFactor);
	        },
	        fontColor: _constants.buttonColorConstants.primary.fontColor
	      },
	
	      focus: {
	        backgroundColor: function backgroundColor(base) {
	          return (0, _color2.default)(_constants.buttonColorConstants.primary.backgroundColor(base)).darken(_constants.buttonConstants.functionFactor);
	        },
	        fontColor: _constants.buttonColorConstants.primary.fontColor
	      }
	    },
	
	    secondary: {
	      backgroundColor: _constants.buttonColorConstants.secondary.backgroundColor,
	      fontColor: _constants.buttonColorConstants.secondary.fontColor,
	
	      hover: {
	        backgroundColor: function backgroundColor(base) {
	          return (0, _color2.default)(_constants.buttonColorConstants.secondary.backgroundColor(base)).darken(_constants.buttonConstants.functionFactor);
	        },
	        fontColor: _constants.buttonColorConstants.secondary.fontColor
	      },
	
	      focus: {
	        backgroundColor: function backgroundColor(base) {
	          return (0, _color2.default)(_constants.buttonColorConstants.secondary.backgroundColor(base)).darken(_constants.buttonConstants.functionFactor);
	        },
	        fontColor: _constants.buttonColorConstants.secondary.fontColor
	      }
	    },
	
	    alert: {
	      backgroundColor: _constants.buttonColorConstants.alert.backgroundColor,
	      fontColor: _constants.buttonColorConstants.alert.fontColor,
	
	      hover: {
	        backgroundColor: function backgroundColor(base) {
	          return (0, _color2.default)(_constants.buttonColorConstants.alert.backgroundColor(base)).darken(_constants.buttonConstants.functionFactor);
	        },
	        fontColor: _constants.buttonColorConstants.alert.fontColor
	      },
	
	      focus: {
	        backgroundColor: function backgroundColor(base) {
	          return (0, _color2.default)(_constants.buttonColorConstants.alert.backgroundColor(base)).darken(_constants.buttonConstants.functionFactor);
	        },
	        fontColor: _constants.buttonColorConstants.alert.fontColor
	      }
	    },
	
	    success: {
	      backgroundColor: _constants.buttonColorConstants.success.backgroundColor,
	      fontColor: _constants.buttonColorConstants.success.fontColor,
	
	      hover: {
	        backgroundColor: function backgroundColor(base) {
	          return (0, _color2.default)(_constants.buttonColorConstants.success.backgroundColor(base)).darken(_constants.buttonConstants.functionFactor);
	        },
	        fontColor: _constants.buttonColorConstants.success.fontColor
	      },
	
	      focus: {
	        backgroundColor: function backgroundColor(base) {
	          return (0, _color2.default)(_constants.buttonColorConstants.success.backgroundColor(base)).darken(_constants.buttonConstants.functionFactor);
	        },
	        fontColor: _constants.buttonColorConstants.success.fontColor
	      }
	    },
	
	    warning: {
	      backgroundColor: _constants.buttonColorConstants.warning.backgroundColor,
	      fontColor: _constants.buttonColorConstants.warning.fontColor,
	
	      hover: {
	        backgroundColor: function backgroundColor(base) {
	          return (0, _color2.default)(_constants.buttonColorConstants.warning.backgroundColor(base)).darken(_constants.buttonConstants.functionFactor);
	        },
	        fontColor: _constants.buttonColorConstants.warning.fontColor
	      },
	
	      focus: {
	        backgroundColor: function backgroundColor(base) {
	          return (0, _color2.default)(_constants.buttonColorConstants.warning.backgroundColor(base)).darken(_constants.buttonConstants.functionFactor);
	        },
	        fontColor: _constants.buttonColorConstants.warning.fontColor
	      }
	    },
	
	    info: {
	      backgroundColor: _constants.buttonColorConstants.info.backgroundColor,
	      fontColor: _constants.buttonColorConstants.info.fontColor,
	
	      hover: {
	        backgroundColor: function backgroundColor(base) {
	          return (0, _color2.default)(_constants.buttonColorConstants.info.backgroundColor(base)).darken(_constants.buttonConstants.functionFactor);
	        },
	        fontColor: _constants.buttonColorConstants.info.fontColor
	      },
	
	      focus: {
	        backgroundColor: function backgroundColor(base) {
	          return (0, _color2.default)(_constants.buttonColorConstants.info.backgroundColor(base)).darken(_constants.buttonConstants.functionFactor);
	        },
	        fontColor: _constants.buttonColorConstants.info.fontColor
	      }
	    },
	
	    link: {
	      backgroundColor: function backgroundColor(base) {
	        return (0, _color2.default)(_constants.buttonColorConstants.link.backgroundColor(base)).darken(_constants.buttonConstants.functionFactor);
	      },
	      fontColor: _constants.buttonColorConstants.link.fontColor,
	      textAlign: 'left',
	      fontWeight: _reactackleCore.fontWeightSemibold,
	      textTransform: 'none',
	
	      hover: {
	        textDecoration: 'underline',
	        backgroundColor: function backgroundColor(base) {
	          return (0, _color2.default)(_constants.buttonColorConstants.link.backgroundColor(base)).darken(_constants.buttonConstants.functionFactor);
	        },
	        fontColor: _constants.buttonColorConstants.link.fontColor
	      },
	
	      focus: {
	        backgroundColor: function backgroundColor(base) {
	          return (0, _color2.default)(_constants.buttonColorConstants.link.backgroundColor(base)).darken(_constants.buttonConstants.functionFactor);
	        },
	        fontColor: _constants.buttonColorConstants.link.fontColor
	      }
	    }
	  }
	};

/***/ }),
/* 570 */
362,
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactackleCore = __webpack_require__(3);
	
	var _CardStyled = __webpack_require__(609);
	
	var _theme = __webpack_require__(610);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	(0, _reactackleCore.registerDefaultComponentTheme)('card', _theme2.default);
	
	var propTypes = {
	  /**
	   * Determines size of the card
	   */
	  size: _propTypes2.default.oneOf(['default', 'medium', 'large', 'xlarge']),
	  /**
	   * Determines the shadow size. Min: 0 - no shadow
	   */
	  elevation: _propTypes2.default.number,
	  /**
	   * Determines whether to show shadow
	   */
	  noShadow: _propTypes2.default.bool
	};
	
	var defaultProps = {
	  size: 'default',
	  elevation: 1,
	  noShadow: false
	};
	
	var childContextTypes = _defineProperty({}, _reactackleCore.CARD_CHANNEL, _propTypes2.default.func.isRequired);
	
	var Card = function (_Component) {
	  _inherits(Card, _Component);
	
	  function Card(props) {
	    _classCallCheck(this, Card);
	
	    var _this = _possibleConstructorReturn(this, (Card.__proto__ || Object.getPrototypeOf(Card)).call(this, props));
	
	    _this._broadcast = (0, _reactackleCore.createBroadcast)({
	      size: _this.props.size
	    });
	    return _this;
	  }
	
	  _createClass(Card, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return _extends({}, this.context, _defineProperty({}, _reactackleCore.CARD_CHANNEL, this._broadcast.subscribe));
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.size !== nextProps.size) {
	        this._broadcast.publish({
	          size: nextProps.size
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          elevation = _props.elevation,
	          noShadow = _props.noShadow,
	          children = _props.children;
	
	
	      return _react2.default.createElement(
	        _CardStyled.CardStyled,
	        { elevation: elevation, noShadow: noShadow },
	        children
	      );
	    }
	  }]);
	
	  return Card;
	}(_react.Component);
	
	exports.default = Card;
	
	
	Card.childContextTypes = childContextTypes;
	Card.propTypes = propTypes;
	Card.defaultProps = defaultProps;
	Card.displayName = 'Card';

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports._CardActions = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _withExternalPropsCard = __webpack_require__(37);
	
	var _withExternalPropsCard2 = _interopRequireDefault(_withExternalPropsCard);
	
	var _CardActionsStyled = __webpack_require__(580);
	
	var _externalPropTypes = __webpack_require__(51);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = _externalPropTypes.externalPropTypes;
	var defaultProps = _externalPropTypes.externalDefaultProps;
	
	var _CardActions = exports._CardActions = function _CardActions(_ref) {
	  var children = _ref.children,
	      externalProps = _ref.externalProps;
	  return _react2.default.createElement(
	    _CardActionsStyled.CardActionsStyled,
	    { size: externalProps.size },
	    children
	  );
	};
	
	_CardActions.displayName = 'CardActions';
	exports.default = (0, _withExternalPropsCard2.default)(_CardActions);
	
	
	_CardActions.propTypes = propTypes;
	_CardActions.defaultProps = defaultProps;

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports._CardActionsMain = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _withExternalPropsCard = __webpack_require__(37);
	
	var _withExternalPropsCard2 = _interopRequireDefault(_withExternalPropsCard);
	
	var _CardActionsMainStyled = __webpack_require__(575);
	
	var _externalPropTypes = __webpack_require__(51);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = _externalPropTypes.externalPropTypes;
	var defaultProps = _externalPropTypes.externalDefaultProps;
	
	var _CardActionsMain = exports._CardActionsMain = function _CardActionsMain(props) {
	  return _react2.default.createElement(
	    _CardActionsMainStyled.CardActionsMainStyled,
	    { size: props.externalProps.size },
	    props.children
	  );
	};
	
	_CardActionsMain.displayName = 'CardActionsMain';
	exports.default = (0, _withExternalPropsCard2.default)(_CardActionsMain);
	
	
	_CardActionsMain.propTypes = propTypes;
	_CardActionsMain.defaultProps = defaultProps;

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CardActionsMain = undefined;
	
	var _CardActionsMain = __webpack_require__(573);
	
	var _CardActionsMain2 = _interopRequireDefault(_CardActionsMain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.CardActionsMain = _CardActionsMain2.default;

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CardActionsMainStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	var _CardAreaSideStyled = __webpack_require__(95);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  size: _propTypes2.default.oneOf(['default', 'medium', 'large', 'xlarge']),
	  theme: _propTypes2.default.object
	};
	
	var defaultProps = {
	  size: 'default'
	};
	
	/** Prop Receivers */
	var sizeProps = function sizeProps(_ref) {
	  var themeFromProvider = _ref.theme,
	      size = _ref.size;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var _theme$reactackle$com = theme.reactackle.components.card.actions.size[size],
	      itemsSpacingHorizontal = _theme$reactackle$com.itemsSpacingHorizontal,
	      itemsSpacingVertical = _theme$reactackle$com.itemsSpacingVertical;
	
	
	  var itemsMarginY = (0, _reactackleCore.getValueString)(itemsSpacingVertical),
	      itemsMarginX = (0, _reactackleCore.getValueString)(itemsSpacingHorizontal);
	
	  return (0, _styledComponents.css)(['margin:-', ' -', ';justify-content:flex-end;& > *{margin:', ' ', ';}', ' &{flex-direction:column;align-items:flex-start;justify-content:flex-start;}'], itemsMarginY, itemsMarginX, itemsMarginY, itemsMarginX, _CardAreaSideStyled.CardAreaSideStyled);
	};
	
	/** Styles */
	var CardActionsMainStyled = exports.CardActionsMainStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'CardActionsMainStyled'
	})(['display:flex;flex-grow:1;text-align:right;', ';'], sizeProps);
	
	CardActionsMainStyled.propTypes = propTypes;
	CardActionsMainStyled.defaultProps = defaultProps;
	CardActionsMainStyled.displayName = 'CardActionsMainStyled';

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports._CardActionsSupplemental = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _withExternalPropsCard = __webpack_require__(37);
	
	var _withExternalPropsCard2 = _interopRequireDefault(_withExternalPropsCard);
	
	var _CardActionsSupplementalStyled = __webpack_require__(578);
	
	var _externalPropTypes = __webpack_require__(51);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = _externalPropTypes.externalPropTypes;
	var defaultProps = _externalPropTypes.externalDefaultProps;
	
	var _CardActionsSupplemental = exports._CardActionsSupplemental = function _CardActionsSupplemental(props) {
	  return _react2.default.createElement(
	    _CardActionsSupplementalStyled.CardActionsSupplementalStyled,
	    { size: props.externalProps.size },
	    props.children
	  );
	};
	
	_CardActionsSupplemental.displayName = 'CardActionsSupplemental';
	exports.default = (0, _withExternalPropsCard2.default)(_CardActionsSupplemental);
	
	
	_CardActionsSupplemental.propTypes = propTypes;
	_CardActionsSupplemental.defaultProps = defaultProps;

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CardActionsSupplemental = undefined;
	
	var _CardActionsSupplemental = __webpack_require__(576);
	
	var _CardActionsSupplemental2 = _interopRequireDefault(_CardActionsSupplemental);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.CardActionsSupplemental = _CardActionsSupplemental2.default;

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CardActionsSupplementalStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	var _CardAreaSideStyled = __webpack_require__(95);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  size: _propTypes2.default.oneOf(['default', 'medium', 'large', 'xlarge']),
	  theme: _propTypes2.default.object
	};
	
	var defaultProps = {
	  size: 'default'
	};
	
	/** Prop Receivers */
	var sizeProps = function sizeProps(_ref) {
	  var themeFromProvider = _ref.theme,
	      size = _ref.size;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var _theme$reactackle$com = theme.reactackle.components.card.actions.size[size],
	      itemsSpacingHorizontal = _theme$reactackle$com.itemsSpacingHorizontal,
	      itemsSpacingVertical = _theme$reactackle$com.itemsSpacingVertical;
	
	
	  var itemsMarginY = (0, _reactackleCore.getValueString)(itemsSpacingVertical),
	      itemsMarginX = (0, _reactackleCore.getValueString)(itemsSpacingHorizontal);
	
	  return (0, _styledComponents.css)(['margin:-', ' -', ';justify-content:flex-start;& > *{margin:', ' ', ';}', ' &{flex-direction:column;align-items:flex-start;justify-content:flex-end;}'], itemsMarginY, itemsMarginX, itemsMarginY, itemsMarginX, _CardAreaSideStyled.CardAreaSideStyled);
	};
	
	/** Styles */
	var CardActionsSupplementalStyled = exports.CardActionsSupplementalStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'CardActionsSupplementalStyled'
	})(['display:flex;text-align:left;', ';'], sizeProps);
	
	CardActionsSupplementalStyled.propTypes = propTypes;
	CardActionsSupplementalStyled.defaultProps = defaultProps;
	CardActionsSupplementalStyled.displayName = 'CardActionsSupplementalStyled';

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CardActions = undefined;
	
	var _CardActionsMain = __webpack_require__(574);
	
	Object.keys(_CardActionsMain).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _CardActionsMain[key];
	    }
	  });
	});
	
	var _CardActionsSupplemental = __webpack_require__(577);
	
	Object.keys(_CardActionsSupplemental).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _CardActionsSupplemental[key];
	    }
	  });
	});
	
	var _CardActions = __webpack_require__(572);
	
	var _CardActions2 = _interopRequireDefault(_CardActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.CardActions = _CardActions2.default;

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CardActionsStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	var _CardAreaSideStyled = __webpack_require__(95);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  size: _propTypes2.default.oneOf(['default', 'medium', 'large', 'xlarge']),
	  theme: _propTypes2.default.object
	};
	
	var defaultProps = {
	  size: 'default'
	};
	
	var sizeProps = function sizeProps(_ref) {
	  var themeFromProvider = _ref.theme,
	      size = _ref.size;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var source = theme.reactackle.components.card.actions.size[size];
	
	  var _source$mainRegion = source.mainRegion,
	      mainPaddingY = _source$mainRegion.paddingY,
	      mainPaddingX = _source$mainRegion.paddingX;
	  var _source$sideRegion = source.sideRegion,
	      sidePaddingY = _source$sideRegion.paddingY,
	      sidePaddingX = _source$sideRegion.paddingX;
	
	
	  return (0, _styledComponents.css)(['padding:', ' ', ';', ' &{padding:', ' ', ';flex-direction:column;}'], (0, _reactackleCore.getValueString)(mainPaddingY), (0, _reactackleCore.getValueString)(mainPaddingX), _CardAreaSideStyled.CardAreaSideStyled, (0, _reactackleCore.getValueString)(sidePaddingY), (0, _reactackleCore.getValueString)(sidePaddingX));
	};
	
	var CardActionsStyled = exports.CardActionsStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'CardActionsStyled'
	})(['display:flex;position:relative;', ';'], sizeProps);
	
	CardActionsStyled.propTypes = propTypes;
	CardActionsStyled.defaultProps = defaultProps;
	CardActionsStyled.displayName = 'CardActionsStyled';

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = CardAreaMain;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CardAreaMainStyled = __webpack_require__(583);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CardAreaMain(props) {
	  return _react2.default.createElement(
	    _CardAreaMainStyled.CardAreaMainStyled,
	    null,
	    props.children
	  );
	}
	
	CardAreaMain.displayName = 'CardAreaMain';

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CardAreaMain = undefined;
	
	var _CardAreaMain = __webpack_require__(581);
	
	var _CardAreaMain2 = _interopRequireDefault(_CardAreaMain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.CardAreaMain = _CardAreaMain2.default;

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CardAreaMainStyled = undefined;
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {};
	var defaultProps = {};
	
	var CardAreaMainStyled = exports.CardAreaMainStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'CardAreaMainStyled'
	})(['flex-grow:1;']);
	
	CardAreaMainStyled.propTypes = propTypes;
	CardAreaMainStyled.defaultProps = defaultProps;
	CardAreaMainStyled.displayName = 'CardAreaMainStyled';

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = CardAreaSide;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CardAreaSideStyled = __webpack_require__(95);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CardAreaSide(props) {
	  return _react2.default.createElement(
	    _CardAreaSideStyled.CardAreaSideStyled,
	    null,
	    props.children
	  );
	}
	
	CardAreaSide.displayName = 'CardAreaSide';

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CardAreaSide = undefined;
	
	var _CardAreaSide = __webpack_require__(584);
	
	var _CardAreaSide2 = _interopRequireDefault(_CardAreaSide);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.CardAreaSide = _CardAreaSide2.default;

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports._CardContent = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _withExternalPropsCard = __webpack_require__(37);
	
	var _withExternalPropsCard2 = _interopRequireDefault(_withExternalPropsCard);
	
	var _CardContentStyled = __webpack_require__(591);
	
	var _externalPropTypes = __webpack_require__(51);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = _extends({
	  first: _propTypes2.default.bool,
	  last: _propTypes2.default.bool
	}, _externalPropTypes.externalPropTypes);
	
	var defaultProps = _extends({
	  first: false,
	  last: false
	}, _externalPropTypes.externalDefaultProps);
	
	var _CardContent = exports._CardContent = function _CardContent(_ref) {
	  var last = _ref.last,
	      first = _ref.first,
	      children = _ref.children,
	      externalProps = _ref.externalProps;
	  return _react2.default.createElement(
	    _CardContentStyled.CardContentStyled,
	    { last: last, first: first, size: externalProps.size },
	    children
	  );
	};
	
	_CardContent.displayName = 'CardContent';
	exports.default = (0, _withExternalPropsCard2.default)(_CardContent);
	
	
	_CardContent.propTypes = propTypes;
	_CardContent.defaultProps = defaultProps;

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports._CardContentText = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _withExternalPropsCard = __webpack_require__(37);
	
	var _withExternalPropsCard2 = _interopRequireDefault(_withExternalPropsCard);
	
	var _CardContentTextStyled = __webpack_require__(589);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  externalProps: _propTypes2.default.shape({
	    size: _propTypes2.default.oneOf(['default', 'medium', 'large', 'xlarge'])
	  })
	};
	
	var defaultProps = {
	  externalProps: {
	    size: 'default'
	  }
	};
	
	var _CardContentText = exports._CardContentText = function _CardContentText(props) {
	  return _react2.default.createElement(
	    _CardContentTextStyled.CardContentTextStyled,
	    { size: props.externalProps.size },
	    props.children
	  );
	};
	
	_CardContentText.displayName = 'CardContentText';
	exports.default = (0, _withExternalPropsCard2.default)(_CardContentText);
	
	
	_CardContentText.propTypes = propTypes;
	_CardContentText.defaultProps = defaultProps;

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CardContentText = undefined;
	
	var _CardContentText = __webpack_require__(587);
	
	var _CardContentText2 = _interopRequireDefault(_CardContentText);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.CardContentText = _CardContentText2.default;

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CardContentTextStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  size: _propTypes2.default.oneOf(['default', 'medium', 'large', 'xlarge']),
	  theme: _propTypes2.default.object
	};
	
	var defaultProps = {
	  size: 'default'
	};
	
	/** Prop Receivers */
	var fontProps = function fontProps(_ref) {
	  var themeFromProvider = _ref.theme,
	      size = _ref.size;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var _theme$reactackle$com = theme.reactackle.components.card.contentText.size[size],
	      fontSize = _theme$reactackle$com.fontSize,
	      lineHeight = _theme$reactackle$com.lineHeight,
	      fontColor = _theme$reactackle$com.fontColor,
	      fontWeight = _theme$reactackle$com.fontWeight,
	      similarElementsSpacing = _theme$reactackle$com.similarElementsSpacing;
	
	
	  return '\n    font-size: ' + (0, _reactackleCore.getValueString)(fontSize) + ';\n    line-height: ' + lineHeight + ';\n    color: ' + fontColor + ';\n    font-weight: ' + fontWeight + ';\n    \n    & + & { margin-top: ' + (0, _reactackleCore.getValueString)(similarElementsSpacing) + '; }\n  ';
	};
	
	/** Styles */
	var CardContentTextStyled = exports.CardContentTextStyled = _styledComponents2.default.p.withConfig({
	  displayName: 'CardContentTextStyled'
	})(['position:relative;margin:0;', ';'], fontProps);
	
	CardContentTextStyled.propTypes = propTypes;
	CardContentTextStyled.defaultProps = defaultProps;
	CardContentTextStyled.displayName = 'CardContentTextStyled';

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CardContent = undefined;
	
	var _CardContentText = __webpack_require__(588);
	
	Object.keys(_CardContentText).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _CardContentText[key];
	    }
	  });
	});
	
	var _CardContent = __webpack_require__(586);
	
	var _CardContent2 = _interopRequireDefault(_CardContent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.CardContent = _CardContent2.default;

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CardContentStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	var _CardMediaStyled = __webpack_require__(96);
	
	var _CardHeaderPrimaryStyled = __webpack_require__(209);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  first: _propTypes2.default.bool,
	  last: _propTypes2.default.bool,
	  size: _propTypes2.default.oneOf(['default', 'medium', 'large', 'xlarge']),
	  theme: _propTypes2.default.object
	};
	
	var defaultProps = {
	  first: false,
	  last: false,
	  size: 'default'
	};
	
	/** Prop Receivers */
	var fontProps = function fontProps(_ref) {
	  var themeFromProvider = _ref.theme,
	      size = _ref.size;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var _theme$reactackle$com = theme.reactackle.components.card.contentText.size[size],
	      fontSize = _theme$reactackle$com.fontSize,
	      lineHeight = _theme$reactackle$com.lineHeight,
	      fontColor = _theme$reactackle$com.fontColor,
	      fontColorInMedia = _theme$reactackle$com.fontColorInMedia,
	      fontWeight = _theme$reactackle$com.fontWeight;
	
	
	  return (0, _styledComponents.css)(['font-size:', ';line-height:', ';color:', ';font-weight:', ';', ' &{color:', ';}'], (0, _reactackleCore.getValueString)(fontSize), lineHeight, fontColor, fontWeight, _CardMediaStyled.CardMediaStyled, fontColorInMedia);
	};
	
	var sizeProps = function sizeProps(_ref2) {
	  var themeFromProvider = _ref2.theme,
	      first = _ref2.first,
	      last = _ref2.last,
	      size = _ref2.size;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var _theme$reactackle$com2 = theme.reactackle.components.card.content.size[size],
	      paddingX = _theme$reactackle$com2.paddingX,
	      paddingY = _theme$reactackle$com2.paddingY,
	      paddingYLarge = _theme$reactackle$com2.paddingYLarge,
	      similarElementsSpacing = _theme$reactackle$com2.similarElementsSpacing;
	
	
	  return (0, _styledComponents.css)(['padding:', ' ', ';', ' ', ' & + &{padding-top:', ';}', ' + &{padding-top:0;}'], (0, _reactackleCore.getValueString)(paddingY), (0, _reactackleCore.getValueString)(paddingX), first && 'padding-top: ' + (0, _reactackleCore.getValueString)(paddingYLarge) + ';', last && 'padding-bottom: ' + (0, _reactackleCore.getValueString)(paddingYLarge) + ';', (0, _reactackleCore.getValueString)(similarElementsSpacing), _CardHeaderPrimaryStyled.CardHeaderPrimaryStyled);
	};
	
	/** Styles */
	var CardContentStyled = exports.CardContentStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'CardContentStyled'
	})(['position:relative;', ' ', ';'], fontProps, sizeProps);
	
	CardContentStyled.propTypes = propTypes;
	CardContentStyled.defaultProps = defaultProps;
	CardContentStyled.displayName = 'CardContentStyled';

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports._CardHeaderPrimary = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _withExternalPropsCard = __webpack_require__(37);
	
	var _withExternalPropsCard2 = _interopRequireDefault(_withExternalPropsCard);
	
	var _CardHeaderPrimaryStyled = __webpack_require__(209);
	
	var _CardHeaderBoxStyled = __webpack_require__(594);
	
	var _CardHeaderTextStyled = __webpack_require__(596);
	
	var _CardSubheaderStyled = __webpack_require__(597);
	
	var _CardHeaderMediaStyled = __webpack_require__(595);
	
	var _externalPropTypes = __webpack_require__(51);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = _extends({
	  first: _propTypes2.default.bool,
	  last: _propTypes2.default.bool,
	  title: _propTypes2.default.string,
	  subtitle: _propTypes2.default.string
	}, _externalPropTypes.externalPropTypes);
	
	var defaultProps = _extends({
	  first: false,
	  last: false,
	  title: '',
	  subtitle: ''
	}, _externalPropTypes.externalDefaultProps);
	
	var _CardHeaderPrimary = exports._CardHeaderPrimary = function _CardHeaderPrimary(props) {
	  var subtitle = props.subtitle ? _react2.default.createElement(
	    _CardSubheaderStyled.CardSubheaderStyled,
	    { size: props.externalProps.size },
	    props.subtitle
	  ) : null;
	
	  var titleMedia = props.children ? _react2.default.createElement(
	    _CardHeaderMediaStyled.CardHeaderMediaStyled,
	    { size: props.externalProps.size },
	    props.children
	  ) : null;
	
	  return _react2.default.createElement(
	    _CardHeaderPrimaryStyled.CardHeaderPrimaryStyled,
	    {
	      size: props.externalProps.size,
	      last: props.last,
	      first: props.first
	    },
	    _react2.default.createElement(
	      _CardHeaderBoxStyled.CardHeaderBoxStyled,
	      null,
	      _react2.default.createElement(
	        _CardHeaderTextStyled.CardHeaderTextStyled,
	        { size: props.externalProps.size },
	        props.title
	      ),
	      subtitle
	    ),
	    titleMedia
	  );
	};
	
	_CardHeaderPrimary.displayName = 'CardHeaderPrimary';
	exports.default = (0, _withExternalPropsCard2.default)(_CardHeaderPrimary);
	
	
	_CardHeaderPrimary.propTypes = propTypes;
	_CardHeaderPrimary.defaultProps = defaultProps;

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CardHeaderPrimary = undefined;
	
	var _CardHeaderPrimary = __webpack_require__(592);
	
	var _CardHeaderPrimary2 = _interopRequireDefault(_CardHeaderPrimary);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.CardHeaderPrimary = _CardHeaderPrimary2.default;

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CardHeaderBoxStyled = undefined;
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {};
	var defaultProps = {};
	
	/** Styles */
	var CardHeaderBoxStyled = exports.CardHeaderBoxStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'CardHeaderBoxStyled'
	})(['flex-grow:1;']);
	
	CardHeaderBoxStyled.propTypes = propTypes;
	CardHeaderBoxStyled.defaultProps = defaultProps;
	CardHeaderBoxStyled.displayName = 'CardHeaderBoxStyled';

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CardHeaderMediaStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  size: _propTypes2.default.oneOf(['default', 'medium', 'large', 'xlarge']),
	  theme: _propTypes2.default.object
	};
	
	var defaultProps = {
	  size: 'default'
	};
	
	/** Prop Receivers */
	var sizeProps = function sizeProps(_ref) {
	  var themeFromProvider = _ref.theme,
	      size = _ref.size;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var _theme$reactackle$com = theme.reactackle.components.card.headerPrimary.size[size],
	      headerPaddingX = _theme$reactackle$com.paddingX,
	      headerPaddingY = _theme$reactackle$com.paddingY;
	  var _theme$reactackle$com2 = theme.reactackle.components.card.headerMedia.size[size],
	      width = _theme$reactackle$com2.width,
	      height = _theme$reactackle$com2.height,
	      marginX = _theme$reactackle$com2.marginX,
	      titleMediaSpacing = _theme$reactackle$com2.titleMediaSpacing,
	      marginY = _theme$reactackle$com2.marginY;
	
	
	  var mx = 'calc(' + (0, _reactackleCore.getValueString)(marginX) + ' - ' + (0, _reactackleCore.getValueString)(headerPaddingX) + ')';
	
	  var my = 'calc(' + (0, _reactackleCore.getValueString)(marginY) + ' - ' + (0, _reactackleCore.getValueString)(headerPaddingY) + ')';
	
	  return '\n    width: ' + (0, _reactackleCore.getValueString)(width) + ';\n    height: ' + (0, _reactackleCore.getValueString)(height) + ';\n    margin: ' + my + 'px ' + mx + 'px ' + my + 'px ' + (0, _reactackleCore.getValueString)(titleMediaSpacing) + ';\n  ';
	};
	
	/** Styles */
	var CardHeaderMediaStyled = exports.CardHeaderMediaStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'CardHeaderMediaStyled'
	})(['display:flex;flex-shrink:0;', ';'], sizeProps);
	
	CardHeaderMediaStyled.propTypes = propTypes;
	CardHeaderMediaStyled.defaultProps = defaultProps;
	CardHeaderMediaStyled.displayName = 'CardHeaderMediaStyled';

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CardHeaderTextStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	var _CardMediaStyled = __webpack_require__(96);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  size: _propTypes2.default.oneOf(['default', 'medium', 'large', 'xlarge']),
	  theme: _propTypes2.default.object
	};
	
	var defaultProps = {
	  size: 'default'
	};
	
	/** Prop Receivers */
	var fontProps = function fontProps(_ref) {
	  var themeFromProvider = _ref.theme,
	      size = _ref.size;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var _theme$reactackle$com = theme.reactackle.components.card.headerPrimary.size[size],
	      fontSize = _theme$reactackle$com.fontSize,
	      lineHeight = _theme$reactackle$com.lineHeight,
	      fontColor = _theme$reactackle$com.fontColor,
	      fontColorInMedia = _theme$reactackle$com.fontColorInMedia,
	      fontWeight = _theme$reactackle$com.fontWeight;
	
	
	  return (0, _styledComponents.css)(['font-size:', ';line-height:', ';color:', ';font-weight:', ';', ' &{color:', ';}'], (0, _reactackleCore.getValueString)(fontSize), lineHeight, fontColor, fontWeight, _CardMediaStyled.CardMediaStyled, fontColorInMedia);
	};
	
	/** Styles */
	var CardHeaderTextStyled = exports.CardHeaderTextStyled = _styledComponents2.default.h2.withConfig({
	  displayName: 'CardHeaderTextStyled'
	})(['margin:0;', ';'], fontProps);
	
	CardHeaderTextStyled.propTypes = propTypes;
	CardHeaderTextStyled.defaultProps = defaultProps;
	CardHeaderTextStyled.displayName = 'CardHeaderTextStyled';

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CardSubheaderStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	var _CardMediaStyled = __webpack_require__(96);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  size: _propTypes2.default.oneOf(['default', 'medium', 'large', 'xlarge']),
	  theme: _propTypes2.default.object
	};
	
	var defaultProps = {
	  size: 'default'
	};
	
	/** Prop Receivers */
	var fontProps = function fontProps(_ref) {
	  var themeFromProvider = _ref.theme,
	      size = _ref.size;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var _theme$reactackle$com = theme.reactackle.components.card.subheaderPrimary.size[size],
	      fontSize = _theme$reactackle$com.fontSize,
	      lineHeight = _theme$reactackle$com.lineHeight,
	      fontColor = _theme$reactackle$com.fontColor,
	      fontColorInMedia = _theme$reactackle$com.fontColorInMedia,
	      fontWeight = _theme$reactackle$com.fontWeight,
	      subtitleTitleSpacing = _theme$reactackle$com.subtitleTitleSpacing;
	
	
	  return (0, _styledComponents.css)(['font-size:', ';line-height:', ';color:', ';font-weight:', ';margin-top:', ';', ' &{color:', ';}'], (0, _reactackleCore.getValueString)(fontSize), lineHeight, fontColor, fontWeight, (0, _reactackleCore.getValueString)(subtitleTitleSpacing), _CardMediaStyled.CardMediaStyled, fontColorInMedia);
	};
	
	/** Styles */
	var CardSubheaderStyled = exports.CardSubheaderStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'CardSubheaderStyled'
	})(['margin:0;', ';'], fontProps);
	
	CardSubheaderStyled.propTypes = propTypes;
	CardSubheaderStyled.defaultProps = defaultProps;
	CardSubheaderStyled.displayName = 'CardSubheaderStyled';

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports._CardHeaderSecondary = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _withExternalPropsCard = __webpack_require__(37);
	
	var _withExternalPropsCard2 = _interopRequireDefault(_withExternalPropsCard);
	
	var _CardHeaderSecondaryStyled = __webpack_require__(601);
	
	var _CardHeaderSecondaryTextBoxStyled = __webpack_require__(602);
	
	var _CardHeaderSecondaryTextStyled = __webpack_require__(603);
	
	var _CardSubheaderSecondaryStyled = __webpack_require__(604);
	
	var _CardHeaderSecondaryImageStyled = __webpack_require__(600);
	
	var _externalPropTypes = __webpack_require__(51);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = _extends({
	  image: _propTypes2.default.string,
	  title: _propTypes2.default.string,
	  subtitle: _propTypes2.default.string
	}, _externalPropTypes.externalPropTypes);
	
	var defaultProps = _extends({
	  image: '',
	  title: '',
	  subtitle: ''
	}, _externalPropTypes.externalDefaultProps);
	
	var _CardHeaderSecondary = exports._CardHeaderSecondary = function _CardHeaderSecondary(props) {
	  var image = props.image ? _react2.default.createElement(_CardHeaderSecondaryImageStyled.CardHeaderSecondaryImageStyled, {
	    style: { backgroundImage: 'url(\'' + props.image + '\')' },
	    size: props.externalProps.size
	  }) : null;
	
	  var subtitle = props.subtitle ? _react2.default.createElement(
	    _CardSubheaderSecondaryStyled.CardSubheaderSecondaryStyled,
	    { size: props.externalProps.size },
	    props.subtitle
	  ) : null;
	
	  return _react2.default.createElement(
	    _CardHeaderSecondaryStyled.CardHeaderSecondaryStyled,
	    { size: props.externalProps.size },
	    image,
	    _react2.default.createElement(
	      _CardHeaderSecondaryTextBoxStyled.CardHeaderSecondaryTextBoxStyled,
	      null,
	      _react2.default.createElement(
	        _CardHeaderSecondaryTextStyled.CardHeaderSecondaryTextStyled,
	        { size: props.externalProps.size },
	        props.title
	      ),
	      subtitle
	    )
	  );
	};
	
	_CardHeaderSecondary.displayName = 'CardHeaderSecondary';
	exports.default = (0, _withExternalPropsCard2.default)(_CardHeaderSecondary);
	
	
	_CardHeaderSecondary.propTypes = propTypes;
	_CardHeaderSecondary.defaultProps = defaultProps;

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CardHeaderSecondary = undefined;
	
	var _CardHeaderSecondary = __webpack_require__(598);
	
	var _CardHeaderSecondary2 = _interopRequireDefault(_CardHeaderSecondary);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.CardHeaderSecondary = _CardHeaderSecondary2.default;

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CardHeaderSecondaryImageStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  size: _propTypes2.default.oneOf(['default', 'medium', 'large', 'xlarge']),
	  theme: _propTypes2.default.object
	};
	
	var defaultProps = {
	  size: 'default'
	};
	
	/** PropReceivers */
	var styleProps = function styleProps(_ref) {
	  var themeFromProvider = _ref.theme,
	      size = _ref.size;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var _theme$reactackle$com = theme.reactackle.components.card.headerSecondaryImage.size[size],
	      width = _theme$reactackle$com.width,
	      height = _theme$reactackle$com.height,
	      imageTextSpacing = _theme$reactackle$com.imageTextSpacing;
	
	
	  return '\n    width: ' + (0, _reactackleCore.getValueString)(width) + ';\n    height: ' + (0, _reactackleCore.getValueString)(height) + ';\n    margin-right: ' + (0, _reactackleCore.getValueString)(imageTextSpacing) + ';\n  ';
	};
	
	/** Styles */
	var CardHeaderSecondaryImageStyled = exports.CardHeaderSecondaryImageStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'CardHeaderSecondaryImageStyled'
	})(['overflow:hidden;background-size:cover;background-position:center;background-repeat:no-repeat;border-radius:50%;', ';'], styleProps);
	
	CardHeaderSecondaryImageStyled.propTypes = propTypes;
	CardHeaderSecondaryImageStyled.defaultProps = defaultProps;
	CardHeaderSecondaryImageStyled.displayName = 'CardHeaderSecondaryImageStyled';

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CardHeaderSecondaryStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  size: _propTypes2.default.oneOf(['default', 'medium', 'large', 'xlarge']),
	  theme: _propTypes2.default.object
	};
	
	var defaultProps = {
	  size: 'default'
	};
	
	/** Prop Receivers */
	var sizeProps = function sizeProps(_ref) {
	  var themeFromProvider = _ref.theme,
	      size = _ref.size;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var _theme$reactackle$com = theme.reactackle.components.card.headerSecondary.size[size],
	      paddingX = _theme$reactackle$com.paddingX,
	      paddingY = _theme$reactackle$com.paddingY;
	
	
	  return '\n    padding: ' + (0, _reactackleCore.getValueString)(paddingY) + ' ' + (0, _reactackleCore.getValueString)(paddingX) + ';\n  ';
	};
	
	/** Styles */
	var CardHeaderSecondaryStyled = exports.CardHeaderSecondaryStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'CardHeaderSecondaryStyled'
	})(['display:flex;', ';'], sizeProps);
	
	CardHeaderSecondaryStyled.propTypes = propTypes;
	CardHeaderSecondaryStyled.defaultProps = defaultProps;
	CardHeaderSecondaryStyled.displayName = 'CardHeaderSecondaryStyled';

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CardHeaderSecondaryTextBoxStyled = undefined;
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** Styles */
	var CardHeaderSecondaryTextBoxStyled = exports.CardHeaderSecondaryTextBoxStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'CardHeaderSecondaryTextBoxStyled'
	})(['display:flex;flex-direction:column;justify-content:center;']);
	
	CardHeaderSecondaryTextBoxStyled.displayName = 'CardHeaderSecondaryTextBoxStyled';

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CardHeaderSecondaryTextStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  size: _propTypes2.default.oneOf(['default', 'medium', 'large', 'xlarge']),
	  theme: _propTypes2.default.object
	};
	
	var defaultProps = {
	  size: 'default'
	};
	
	/** Prop Receivers */
	var fontProps = function fontProps(_ref) {
	  var themeFromProvider = _ref.theme,
	      size = _ref.size;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var _theme$reactackle$com = theme.reactackle.components.card.headerSecondary.size[size],
	      fontSize = _theme$reactackle$com.fontSize,
	      lineHeight = _theme$reactackle$com.lineHeight,
	      fontColor = _theme$reactackle$com.fontColor,
	      fontWeight = _theme$reactackle$com.fontWeight;
	
	
	  return '\n    font-size: ' + (0, _reactackleCore.getValueString)(fontSize) + ';\n    line-height: ' + lineHeight + ';\n    color: ' + fontColor + ';\n    font-weight: ' + fontWeight + ';\n  ';
	};
	
	/** Styles */
	var CardHeaderSecondaryTextStyled = exports.CardHeaderSecondaryTextStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'CardHeaderSecondaryTextStyled'
	})(['margin:0;', ';'], fontProps);
	
	CardHeaderSecondaryTextStyled.propTypes = propTypes;
	CardHeaderSecondaryTextStyled.defaultProps = defaultProps;
	CardHeaderSecondaryTextStyled.displayName = 'CardHeaderSecondaryTextStyled';

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CardSubheaderSecondaryStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  size: _propTypes2.default.oneOf(['default', 'medium', 'large', 'xlarge']),
	  theme: _propTypes2.default.object
	};
	
	var defaultProps = {
	  size: 'default'
	};
	
	/** Prop Receivers */
	var fontProps = function fontProps(_ref) {
	  var themeFromProvider = _ref.theme,
	      size = _ref.size;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var _theme$reactackle$com = theme.reactackle.components.card.subheaderSecondary.size[size],
	      fontSize = _theme$reactackle$com.fontSize,
	      lineHeight = _theme$reactackle$com.lineHeight,
	      fontColor = _theme$reactackle$com.fontColor,
	      fontWeight = _theme$reactackle$com.fontWeight;
	
	
	  return '\n    font-size: ' + (0, _reactackleCore.getValueString)(fontSize) + ';\n    line-height: ' + lineHeight + ';\n    color: ' + fontColor + ';\n    font-weight: ' + fontWeight + ';\n  ';
	};
	
	/** Styles */
	var CardSubheaderSecondaryStyled = exports.CardSubheaderSecondaryStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'CardSubheaderSecondaryStyled'
	})(['margin:0;', ';'], fontProps);
	
	CardSubheaderSecondaryStyled.propTypes = propTypes;
	CardSubheaderSecondaryStyled.defaultProps = defaultProps;
	CardSubheaderSecondaryStyled.displayName = 'CardSubheaderSecondaryStyled';

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = CardMedia;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _CardMediaStyled = __webpack_require__(96);
	
	var _CardMediaContentStyled = __webpack_require__(607);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  mediaElement: _propTypes2.default.element
	};
	
	var defaultProps = {
	  mediaElement: null
	};
	
	function CardMedia(props) {
	  return _react2.default.createElement(
	    _CardMediaStyled.CardMediaStyled,
	    null,
	    props.mediaElement,
	    props.children ? _react2.default.createElement(
	      _CardMediaContentStyled.CardMediaContentStyled,
	      null,
	      props.children
	    ) : null
	  );
	}
	
	CardMedia.propTypes = propTypes;
	CardMedia.defaultProps = defaultProps;
	CardMedia.displayName = 'CardMedia';

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CardMedia = undefined;
	
	var _CardMedia = __webpack_require__(605);
	
	var _CardMedia2 = _interopRequireDefault(_CardMedia);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.CardMedia = _CardMedia2.default;

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CardMediaContentStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  theme: _propTypes2.default.object
	};
	
	var styleProps = function styleProps(_ref) {
	  var themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var backgroundColor = theme.reactackle.components.card.media.overlayBackgroundColor;
	
	  return 'background-color: ' + backgroundColor + ';';
	};
	
	/** Styles */
	var CardMediaContentStyled = exports.CardMediaContentStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'CardMediaContentStyled'
	})(['width:100%;position:absolute;bottom:0;', ';'], styleProps);
	
	CardMediaContentStyled.propTypes = propTypes;
	CardMediaContentStyled.displayName = 'CardMediaContentStyled';

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Card = undefined;
	
	var _CardActions = __webpack_require__(579);
	
	Object.keys(_CardActions).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _CardActions[key];
	    }
	  });
	});
	
	var _CardAreaMain = __webpack_require__(582);
	
	Object.keys(_CardAreaMain).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _CardAreaMain[key];
	    }
	  });
	});
	
	var _CardAreaSide = __webpack_require__(585);
	
	Object.keys(_CardAreaSide).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _CardAreaSide[key];
	    }
	  });
	});
	
	var _CardContent = __webpack_require__(590);
	
	Object.keys(_CardContent).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _CardContent[key];
	    }
	  });
	});
	
	var _CardHeaderPrimary = __webpack_require__(593);
	
	Object.keys(_CardHeaderPrimary).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _CardHeaderPrimary[key];
	    }
	  });
	});
	
	var _CardHeaderSecondary = __webpack_require__(599);
	
	Object.keys(_CardHeaderSecondary).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _CardHeaderSecondary[key];
	    }
	  });
	});
	
	var _CardMedia = __webpack_require__(606);
	
	Object.keys(_CardMedia).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _CardMedia[key];
	    }
	  });
	});
	
	var _Card = __webpack_require__(571);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Card = _Card2.default;

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CardStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  elevation: _propTypes2.default.number,
	  theme: _propTypes2.default.object
	};
	
	var defaultProps = {
	  elevation: 1
	};
	
	var baseProps = function baseProps(_ref) {
	  var themeFromProvider = _ref.theme,
	      elevation = _ref.elevation,
	      noShadow = _ref.noShadow;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var fontFamily = theme.reactackle.fontFamily[theme.reactackle.body.fontFamily];
	
	  var _theme$reactackle$com = theme.reactackle.components.card.card,
	      borderRadius = _theme$reactackle$com.borderRadius,
	      backgroundColor = _theme$reactackle$com.backgroundColor;
	
	
	  return (0, _styledComponents.css)(['border-radius:', ';background-color:', ';display:flex;align-items:stretch;', ';&,&*,*::after,*::before{font-family:', ';box-sizing:border-box;}'], (0, _reactackleCore.getValueString)(borderRadius), backgroundColor, !noShadow && (0, _reactackleCore.boxShadow)(elevation - 1), fontFamily);
	};
	
	var CardStyled = exports.CardStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'CardStyled'
	})(['width:100%;', ';'], baseProps);
	
	CardStyled.propTypes = propTypes;
	CardStyled.defaultProps = defaultProps;
	CardStyled.displayName = 'CardStyled';

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.sizeConstants = undefined;
	
	var _reactackleCore = __webpack_require__(3);
	
	var sizeConstants = exports.sizeConstants = {
	  paddingX: _reactackleCore.twoAndHalfBaseModule,
	  paddingYLarge: _reactackleCore.twoAndHalfBaseModule,
	  paddingY: _reactackleCore.oneAndHalfBaseModule,
	
	  medium: {
	    paddingX: _reactackleCore.fiveBaseModule,
	    paddingY: _reactackleCore.tripleBaseModule,
	    paddingYLarge: _reactackleCore.fiveBaseModule
	  },
	
	  large: {
	    paddingX: _reactackleCore.sevenAndHalfBaseModule,
	    paddingY: _reactackleCore.fourAndHalfBaseModule,
	    paddingYLarge: _reactackleCore.sevenAndHalfBaseModule
	  },
	
	  xlarge: {
	    paddingX: _reactackleCore.tenBaseModule,
	    paddingY: _reactackleCore.sixBaseModule,
	    paddingYLarge: _reactackleCore.tenBaseModule
	  }
	};
	
	exports.default = {
	  card: {
	    borderRadius: _reactackleCore.radiusDefault,
	    backgroundColor: _reactackleCore.colorWhite
	  },
	
	  headerPrimary: {
	    size: {
	      default: {
	        fontColor: _reactackleCore.bodyFontColor,
	        fontColorInMedia: _reactackleCore.bodyFontColorAlt,
	        fontSize: _reactackleCore.fontSizeHeadline,
	        fontWeight: _reactackleCore.fontWeightNormal,
	        lineHeight: 1.3,
	        paddingX: sizeConstants.paddingX,
	        paddingY: sizeConstants.paddingY,
	        paddingYLarge: sizeConstants.paddingYLarge,
	        similarElementsSpacing: _reactackleCore.baseModule
	      },
	
	      medium: {
	        fontColor: _reactackleCore.bodyFontColor,
	        fontColorInMedia: _reactackleCore.bodyFontColorAlt,
	        fontSize: _reactackleCore.fontSizeHeadline,
	        fontWeight: _reactackleCore.fontWeightNormal,
	        lineHeight: 1.3,
	        paddingX: sizeConstants.medium.paddingX,
	        paddingY: sizeConstants.medium.paddingY,
	        paddingYLarge: sizeConstants.medium.paddingYLarge,
	        similarElementsSpacing: _reactackleCore.baseModule
	      },
	
	      large: {
	        fontColor: _reactackleCore.bodyFontColor,
	        fontColorInMedia: _reactackleCore.bodyFontColorAlt,
	        fontSize: _reactackleCore.fontSizeHeadline,
	        fontWeight: _reactackleCore.fontWeightNormal,
	        lineHeight: 1.3,
	        paddingX: sizeConstants.large.paddingX,
	        paddingY: sizeConstants.large.paddingY,
	        paddingYLarge: sizeConstants.large.paddingYLarge,
	        similarElementsSpacing: _reactackleCore.baseModule
	      },
	
	      xlarge: {
	        fontColor: _reactackleCore.bodyFontColor,
	        fontColorInMedia: _reactackleCore.bodyFontColorAlt,
	        fontSize: _reactackleCore.fontSizeHeadline,
	        fontWeight: _reactackleCore.fontWeightNormal,
	        lineHeight: 1.3,
	        paddingX: sizeConstants.xlarge.paddingX,
	        paddingY: sizeConstants.xlarge.paddingY,
	        paddingYLarge: sizeConstants.xlarge.paddingYLarge,
	        similarElementsSpacing: _reactackleCore.baseModule
	      }
	    }
	  },
	
	  subheaderPrimary: {
	    size: {
	      default: {
	        fontColor: _reactackleCore.fontColorMedium,
	        fontColorInMedia: _reactackleCore.fontColorLight,
	        fontSize: _reactackleCore.fontSizeBody,
	        fontWeight: _reactackleCore.fontWeightNormal,
	        lineHeight: 1.3,
	        subtitleTitleSpacing: _reactackleCore.halfBaseModule
	      },
	
	      medium: {
	        fontColor: _reactackleCore.fontColorMedium,
	        fontColorInMedia: _reactackleCore.fontColorLight,
	        fontSize: _reactackleCore.fontSizeBody,
	        fontWeight: _reactackleCore.fontWeightNormal,
	        lineHeight: 1.3,
	        subtitleTitleSpacing: _reactackleCore.halfBaseModule
	      },
	
	      large: {
	        fontColor: _reactackleCore.fontColorMedium,
	        fontColorInMedia: _reactackleCore.fontColorLight,
	        fontSize: _reactackleCore.fontSizeBody,
	        fontWeight: _reactackleCore.fontWeightNormal,
	        lineHeight: 1.3,
	        subtitleTitleSpacing: _reactackleCore.halfBaseModule
	      },
	
	      xlarge: {
	        fontColor: _reactackleCore.fontColorMedium,
	        fontColorInMedia: _reactackleCore.fontColorLight,
	        fontSize: _reactackleCore.fontSizeBody,
	        fontWeight: _reactackleCore.fontWeightNormal,
	        lineHeight: 1.3,
	        subtitleTitleSpacing: _reactackleCore.halfBaseModule
	      }
	    }
	  },
	
	  headerMedia: {
	    size: {
	      default: {
	        width: _reactackleCore.tenBaseModule,
	        height: _reactackleCore.tenBaseModule,
	        marginX: sizeConstants.paddingX,
	        marginY: sizeConstants.paddingY,
	        titleMediaSpacing: _reactackleCore.doubleBaseModule
	      },
	
	      medium: {
	        width: _reactackleCore.tenBaseModule,
	        height: _reactackleCore.tenBaseModule,
	        marginX: sizeConstants.medium.paddingX,
	        marginY: sizeConstants.medium.paddingY,
	        titleMediaSpacing: _reactackleCore.doubleBaseModule
	      },
	
	      large: {
	        width: _reactackleCore.tenBaseModule,
	        height: _reactackleCore.tenBaseModule,
	        marginX: sizeConstants.large.paddingX,
	        marginY: sizeConstants.large.paddingY,
	        titleMediaSpacing: _reactackleCore.doubleBaseModule
	      },
	
	      xlarge: {
	        width: _reactackleCore.tenBaseModule,
	        height: _reactackleCore.tenBaseModule,
	        marginX: sizeConstants.xlarge.paddingX,
	        marginY: sizeConstants.xlarge.paddingY,
	        titleMediaSpacing: _reactackleCore.doubleBaseModule
	      }
	    }
	  },
	
	  headerSecondary: {
	    size: {
	      default: {
	        fontColor: _reactackleCore.bodyFontColor,
	        fontColorInMedia: _reactackleCore.bodyFontColorAlt,
	        fontSize: _reactackleCore.fontSizeBody2,
	        fontWeight: _reactackleCore.fontWeightSemibold,
	        lineHeight: 1.3,
	        paddingX: sizeConstants.paddingX,
	        paddingY: sizeConstants.paddingY
	      },
	
	      medium: {
	        fontColor: _reactackleCore.bodyFontColor,
	        fontColorInMedia: _reactackleCore.bodyFontColorAlt,
	        fontSize: _reactackleCore.fontSizeBody2,
	        fontWeight: _reactackleCore.fontWeightSemibold,
	        lineHeight: 1.3,
	        paddingX: sizeConstants.medium.paddingX,
	        paddingY: sizeConstants.medium.paddingY
	      },
	
	      large: {
	        fontColor: _reactackleCore.bodyFontColor,
	        fontColorInMedia: _reactackleCore.bodyFontColorAlt,
	        fontSize: _reactackleCore.fontSizeBody2,
	        fontWeight: _reactackleCore.fontWeightSemibold,
	        lineHeight: 1.3,
	        paddingX: sizeConstants.large.paddingX,
	        paddingY: sizeConstants.large.paddingY
	      },
	
	      xlarge: {
	        fontColor: _reactackleCore.bodyFontColor,
	        fontSize: _reactackleCore.fontSizeBody2,
	        fontWeight: _reactackleCore.fontWeightSemibold,
	        lineHeight: 1.3,
	        paddingX: sizeConstants.xlarge.paddingX,
	        paddingY: sizeConstants.xlarge.paddingY
	      }
	    }
	  },
	
	  subheaderSecondary: {
	    size: {
	      default: {
	        fontColor: _reactackleCore.fontColorMedium,
	        fontSize: _reactackleCore.fontSizeBody,
	        fontWeight: _reactackleCore.fontWeightNormal,
	        lineHeight: 1.3,
	        subtitleTitleSpacing: _reactackleCore.halfBaseModule
	      },
	
	      medium: {
	        fontColor: _reactackleCore.fontColorMedium,
	        fontSize: _reactackleCore.fontSizeBody,
	        fontWeight: _reactackleCore.fontWeightNormal,
	        lineHeight: 1.3,
	        subtitleTitleSpacing: _reactackleCore.halfBaseModule
	      },
	
	      large: {
	        fontColor: _reactackleCore.fontColorMedium,
	        fontSize: _reactackleCore.fontSizeBody,
	        fontWeight: _reactackleCore.fontWeightNormal,
	        lineHeight: 1.3,
	        subtitleTitleSpacing: _reactackleCore.halfBaseModule
	      },
	
	      xlarge: {
	        fontColor: _reactackleCore.fontColorMedium,
	        fontSize: _reactackleCore.fontSizeBody,
	        fontWeight: _reactackleCore.fontWeightNormal,
	        lineHeight: 1.3,
	        subtitleTitleSpacing: _reactackleCore.halfBaseModule
	      }
	    }
	  },
	
	  headerSecondaryImage: {
	    size: {
	      default: {
	        width: _reactackleCore.fiveAndHalfBaseModule,
	        height: _reactackleCore.fiveAndHalfBaseModule,
	        imageTextSpacing: _reactackleCore.baseModule
	      },
	
	      medium: {
	        width: _reactackleCore.fiveAndHalfBaseModule,
	        height: _reactackleCore.fiveAndHalfBaseModule,
	        imageTextSpacing: _reactackleCore.baseModule
	      },
	
	      large: {
	        width: _reactackleCore.fiveAndHalfBaseModule,
	        height: _reactackleCore.fiveAndHalfBaseModule,
	        imageTextSpacing: _reactackleCore.baseModule
	      },
	
	      xlarge: {
	        width: _reactackleCore.fiveAndHalfBaseModule,
	        height: _reactackleCore.fiveAndHalfBaseModule,
	        imageTextSpacing: _reactackleCore.baseModule
	      }
	    }
	  },
	
	  media: {
	    overlayBackgroundColor: 'rgba(0, 0, 0, 0.25)'
	  },
	
	  content: {
	    size: {
	      default: {
	        paddingX: sizeConstants.paddingX,
	        paddingY: sizeConstants.paddingY,
	        paddingYLarge: sizeConstants.paddingYLarge,
	        similarElementsSpacing: _reactackleCore.baseModule
	      },
	
	      medium: {
	        paddingX: sizeConstants.medium.paddingX,
	        paddingY: sizeConstants.medium.paddingY,
	        paddingYLarge: sizeConstants.medium.paddingYLarge,
	        similarElementsSpacing: _reactackleCore.baseModule
	      },
	
	      large: {
	        paddingX: sizeConstants.large.paddingX,
	        paddingY: sizeConstants.large.paddingY,
	        paddingYLarge: sizeConstants.large.paddingYLarge,
	        similarElementsSpacing: _reactackleCore.baseModule
	      },
	
	      xlarge: {
	        paddingX: sizeConstants.xlarge.paddingX,
	        paddingY: sizeConstants.xlarge.paddingY,
	        paddingYLarge: sizeConstants.xlarge.paddingYLarge,
	        similarElementsSpacing: _reactackleCore.baseModule
	      }
	    }
	  },
	
	  contentText: {
	    size: {
	      default: {
	        fontSize: _reactackleCore.fontSizeBody,
	        lineHeight: 1.6,
	        fontColor: _reactackleCore.bodyFontColor,
	        fontWeight: _reactackleCore.fontWeightNormal,
	        similarElementsSpacing: _reactackleCore.baseModule,
	        fontColorInMedia: _reactackleCore.bodyFontColorAlt
	      },
	
	      medium: {
	        fontSize: _reactackleCore.fontSizeBody,
	        lineHeight: 1.6,
	        fontColor: _reactackleCore.bodyFontColor,
	        fontWeight: _reactackleCore.fontWeightNormal,
	        similarElementsSpacing: _reactackleCore.baseModule,
	        fontColorInMedia: _reactackleCore.bodyFontColorAlt
	      },
	
	      large: {
	        fontSize: _reactackleCore.fontSizeBody,
	        lineHeight: 1.6,
	        fontColor: _reactackleCore.bodyFontColor,
	        fontWeight: _reactackleCore.fontWeightNormal,
	        similarElementsSpacing: _reactackleCore.baseModule,
	        fontColorInMedia: _reactackleCore.bodyFontColorAlt
	      },
	
	      xlarge: {
	        fontSize: _reactackleCore.fontSizeBody,
	        lineHeight: 1.6,
	        fontColor: _reactackleCore.bodyFontColor,
	        fontWeight: _reactackleCore.fontWeightNormal,
	        similarElementsSpacing: _reactackleCore.baseModule,
	        fontColorInMedia: _reactackleCore.bodyFontColorAlt
	      }
	    }
	  },
	
	  actions: {
	    size: {
	      default: {
	        itemsSpacingHorizontal: _reactackleCore.halfBaseModule,
	        itemsSpacingVertical: _reactackleCore.quarterBaseModule,
	
	        mainRegion: {
	          paddingY: sizeConstants.paddingY,
	          paddingX: sizeConstants.paddingX
	        },
	
	        sideRegion: {
	          paddingY: sizeConstants.paddingY,
	          paddingX: sizeConstants.paddingX
	        }
	      },
	
	      medium: {
	        itemsSpacingHorizontal: _reactackleCore.halfBaseModule,
	        itemsSpacingVertical: _reactackleCore.quarterBaseModule,
	
	        mainRegion: {
	          paddingY: sizeConstants.paddingY,
	          paddingX: sizeConstants.paddingX
	        },
	
	        sideRegion: {
	          paddingY: sizeConstants.paddingY,
	          paddingX: sizeConstants.paddingX
	        }
	      },
	
	      large: {
	        itemsSpacingHorizontal: _reactackleCore.halfBaseModule,
	        itemsSpacingVertical: _reactackleCore.quarterBaseModule,
	
	        mainRegion: {
	          paddingY: sizeConstants.paddingY,
	          paddingX: sizeConstants.paddingX
	        },
	
	        sideRegion: {
	          paddingY: sizeConstants.paddingY,
	          paddingX: sizeConstants.paddingX
	        }
	      },
	
	      xlarge: {
	        itemsSpacingHorizontal: _reactackleCore.halfBaseModule,
	        itemsSpacingVertical: _reactackleCore.quarterBaseModule,
	
	        mainRegion: {
	          paddingY: sizeConstants.paddingY,
	          paddingX: sizeConstants.paddingX
	        },
	
	        sideRegion: {
	          paddingY: sizeConstants.paddingY,
	          paddingX: sizeConstants.paddingX
	        }
	      }
	    }
	  }
	};

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactackleCore = __webpack_require__(3);
	
	var _reactackleTooltipIcon = __webpack_require__(52);
	
	var _CheckboxStyled = __webpack_require__(617);
	
	var _CheckboxElementStyled = __webpack_require__(614);
	
	var _CheckboxInputStyled = __webpack_require__(616);
	
	var _CheckboxLabelStyled = __webpack_require__(210);
	
	var _LabelElementStyled = __webpack_require__(618);
	
	var _LabelTextStyled = __webpack_require__(619);
	
	var _MessageStyled = __webpack_require__(620);
	
	var _CheckboxIcon = __webpack_require__(612);
	
	var _CheckboxIcon2 = _interopRequireDefault(_CheckboxIcon);
	
	var _theme = __webpack_require__(621);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	(0, _reactackleCore.registerDefaultComponentTheme)('checkbox', _theme2.default);
	
	var propTypes = {
	  /**
	   * Determines whether to check Checkbox by default
	   */
	  defaultChecked: _propTypes2.default.bool,
	  /**
	   * Determines Checkbox checked state
	   */
	  checked: _propTypes2.default.bool,
	  /**
	   * Determines whether to disable checkbox
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * Label of Checkbox
	   */
	  label: _propTypes2.default.string,
	  /**
	   * Label Component
	   */
	  labelElement: _propTypes2.default.element,
	  /**
	   * Add tooltip
	   */
	  tooltip: _propTypes2.default.string,
	  /**
	   * Pass error message
	   */
	  errorMessage: _propTypes2.default.string,
	  /**
	   * Specify function that will be called on Checkbox checked state change
	   */
	  onChange: _propTypes2.default.func
	};
	
	var defaultProps = {
	  defaultChecked: false,
	  checked: void 0,
	  disabled: false,
	  label: '',
	  tooltip: '',
	  errorMessage: '',
	  labelElement: null,
	  onChange: _reactackleCore.noop
	};
	
	var nextId = 0;
	
	var Checkbox = function (_Component) {
	  _inherits(Checkbox, _Component);
	
	  function Checkbox(props) {
	    _classCallCheck(this, Checkbox);
	
	    var _this = _possibleConstructorReturn(this, (Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).call(this, props));
	
	    _this._inputId = 'checkbox-' + nextId++;
	
	    _this.state = {
	      checked: (0, _reactackleCore.isUndef)(props.checked) ? props.defaultChecked : props.checked,
	      focused: false
	    };
	
	    _this._handleChange = _this._handleChange.bind(_this);
	    _this._handleFocus = _this._handleFocus.bind(_this);
	    _this._handleBlur = _this._handleBlur.bind(_this);
	    _this._changeCheckedState = _this._changeCheckedState.bind(_this);
	    _this._keyboardListener = _this._keyboardListener.bind(_this);
	    return _this;
	  }
	
	  _createClass(Checkbox, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.checked !== this.props.checked && (0, _reactackleCore.isUndef)(nextProps.checked)) {
	        this.setState({
	          checked: this.props.checked
	        });
	      }
	      var isDefaultValueChanged = nextProps.defaultChecked !== this.props.defaultChecked;
	
	      if (isDefaultValueChanged) {
	        this.setState({ checked: nextProps.defaultChecked });
	      }
	    }
	  }, {
	    key: '_handleChange',
	    value: function _handleChange(event) {
	      this._changeCheckedState(event.target.checked);
	    }
	  }, {
	    key: '_changeCheckedState',
	    value: function _changeCheckedState(checked) {
	      if ((0, _reactackleCore.isUndef)(this.props.checked)) {
	        this.setState({
	          checked: checked
	        });
	      }
	
	      this.props.onChange({
	        value: checked
	      });
	    }
	  }, {
	    key: '_handleFocus',
	    value: function _handleFocus() {
	      this._toggleKeyboardListener(true);
	      this.setState({ focused: true });
	    }
	  }, {
	    key: '_handleBlur',
	    value: function _handleBlur() {
	      this._toggleKeyboardListener(false);
	      this.setState({ focused: false });
	    }
	  }, {
	    key: '_keyboardListener',
	    value: function _keyboardListener(e) {
	      var key = e.keyCode || e.which;
	      if (key === _reactackleCore.keyboardCodes.SPACE) {
	        this._changeCheckedState(!this.state.checked);
	      }
	    }
	  }, {
	    key: '_toggleKeyboardListener',
	    value: function _toggleKeyboardListener(condition) {
	      if (condition) {
	        document.addEventListener('keypress', this._keyboardListener);
	      } else {
	        document.removeEventListener('keypress', this._keyboardListener);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var checked = (0, _reactackleCore.isUndef)(this.props.checked) ? this.state.checked : this.props.checked;
	
	      var tooltip = this.props.tooltip && (this.props.label || this.props.labelElement) ? _react2.default.createElement(_reactackleTooltipIcon.TooltipIcon, { text: this.props.tooltip }) : null;
	
	      var label = this.props.label ? _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement(
	          _LabelTextStyled.LabelTextStyled,
	          { hasTooltip: !!this.props.tooltip },
	          this.props.label
	        ),
	        tooltip
	      ) : null;
	
	      var labelElement = this.props.labelElement ? _react2.default.createElement(
	        _LabelElementStyled.LabelElementStyled,
	        { hasTooltip: !!this.props.tooltip },
	        this.props.labelElement,
	        tooltip && _react2.default.createElement(
	          _LabelTextStyled.LabelTextStyled,
	          null,
	          tooltip
	        )
	      ) : null;
	
	      var checkboxIcon = !this.props.label && !this.props.labelElement ? _react2.default.createElement(_CheckboxIcon2.default, {
	        disabled: this.disabled,
	        checked: checked,
	        tooltipText: this.props.tooltip
	      }) : _react2.default.createElement(_CheckboxIcon2.default, {
	        disabled: this.props.disabled,
	        checked: checked
	      });
	
	      var message = this.props.errorMessage ? _react2.default.createElement(
	        _MessageStyled.MessageStyled,
	        null,
	        this.props.errorMessage
	      ) : null;
	
	      return _react2.default.createElement(
	        _CheckboxStyled.CheckboxStyled,
	        null,
	        _react2.default.createElement(
	          _CheckboxElementStyled.CheckboxElementStyled,
	          {
	            textFree: !this.props.label && !this.props.labelElement
	          },
	          _react2.default.createElement(_CheckboxInputStyled.CheckboxInputStyled, {
	            id: this._inputId,
	            type: 'checkbox',
	            checked: checked,
	            disabled: this.disabled,
	            onChange: this._handleChange,
	            tabIndex: -1
	          }),
	          _react2.default.createElement(
	            _CheckboxLabelStyled.CheckboxLabelStyled,
	            {
	              textFree: !this.props.label && !this.props.labelElement,
	              disabled: this.disabled,
	              checked: checked,
	              htmlFor: this._inputId,
	              tabIndex: this.disabled ? -1 : 0,
	              onFocus: this._handleFocus,
	              onBlur: this._handleBlur
	            },
	            checkboxIcon,
	            label,
	            labelElement
	          )
	        ),
	        message
	      );
	    }
	  }, {
	    key: 'disabled',
	    get: function get() {
	      return this.props.disabled || !!this.props.errorMessage;
	    }
	  }]);
	
	  return Checkbox;
	}(_react.Component);
	
	exports.default = Checkbox;
	
	
	Checkbox.propTypes = propTypes;
	Checkbox.defaultProps = defaultProps;
	Checkbox.displayName = 'Checkbox';

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactackleTooltip = __webpack_require__(66);
	
	var _reactackleCore = __webpack_require__(3);
	
	var _CheckboxIconStyled = __webpack_require__(615);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  checked: _propTypes2.default.bool,
	  disabled: _propTypes2.default.bool,
	  tooltipText: _propTypes2.default.string,
	  theme: _propTypes2.default.object.isRequired,
	  Tooltip: _propTypes2.default.func.isRequired,
	  toggleTooltip: _propTypes2.default.func.isRequired,
	  showTooltip: _propTypes2.default.func,
	  hideTooltip: _propTypes2.default.func
	};
	
	var defaultProps = {
	  checked: void 0,
	  disabled: false,
	  tooltipText: '',
	  showTooltip: _reactackleCore.noop,
	  hideTooltip: _reactackleCore.noop
	};
	
	var CheckboxIconComponent = function CheckboxIconComponent(props) {
	  var Tooltip = props.Tooltip;
	
	  var tooltip = props.tooltipText ? _react2.default.createElement(
	    Tooltip,
	    null,
	    props.tooltipText
	  ) : null;
	
	  var tooltipManagementProps = props.tooltipText ? {
	    onClick: props.toggleTooltip,
	    onFocus: props.showTooltip,
	    onBlur: props.hideTooltip,
	    onMouseEnter: props.showTooltip,
	    onMouseLeave: props.hideTooltip,
	    tabIndex: 1
	  } : {};
	
	  return _react2.default.createElement(
	    _CheckboxIconStyled.CheckboxIconStyled,
	    _extends({
	      checked: props.checked,
	      disabled: props.disabled
	    }, tooltipManagementProps),
	    props.theme.reactackle.components.checkbox.icon.element,
	    tooltip
	  );
	};
	
	CheckboxIconComponent.propTypes = propTypes;
	CheckboxIconComponent.defaultProps = defaultProps;
	CheckboxIconComponent.displayName = 'CheckboxIcon';
	
	exports.default = (0, _reactackleCore.withTheme)((0, _reactackleTooltip.withTooltip)(CheckboxIconComponent, true));

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Checkbox = undefined;
	
	var _Checkbox = __webpack_require__(611);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Checkbox = _Checkbox2.default;

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CheckboxElementStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  textFree: _propTypes2.default.bool,
	  theme: _propTypes2.default.object
	};
	
	var defaultProps = {
	  textFree: false
	};
	
	var checkboxSizeProps = function checkboxSizeProps(_ref) {
	  var themeFromProvider = _ref.theme,
	      textFree = _ref.textFree;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var size = theme.reactackle.components.checkbox.input.size;
	
	
	  return '\n    max-width: ' + (textFree ? (0, _reactackleCore.getValueString)(size) : '100%') + ';  \n  ';
	};
	
	var CheckboxElementStyled = exports.CheckboxElementStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'CheckboxElementStyled'
	})(['display:flex;cursor:pointer;', ';'], checkboxSizeProps);
	
	CheckboxElementStyled.displayName = 'CheckboxElementStyled';
	CheckboxElementStyled.propTypes = propTypes;
	CheckboxElementStyled.defaultProps = defaultProps;

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CheckboxIconStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleIcons = __webpack_require__(7);
	
	var _reactackleCore = __webpack_require__(3);
	
	var _CheckboxLabelStyled = __webpack_require__(210);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  disabled: _propTypes2.default.bool,
	  checked: _propTypes2.default.bool
	};
	
	var defaultProps = {
	  disabled: false,
	  checked: false
	};
	
	/* Prop Receivers */
	var iconSize = function iconSize(_ref) {
	  var themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var path = theme.reactackle.components.checkbox;
	  var _path$input = path.input,
	      size = _path$input.size,
	      borderWidth = _path$input.borderWidth;
	  var _path$icon = path.icon,
	      imgSize = _path$icon.imgSize,
	      iconSize = _path$icon.size;
	
	
	  var outerSize = 'calc(' + (0, _reactackleCore.getValueString)(size) + ' - ' + borderWidth * 2 + 'px)';
	
	  return (0, _styledComponents.css)(['     ', ''], (0, _reactackleCore.iconSizeMixin)(outerSize, (0, _reactackleCore.getValueString)(imgSize || iconSize), outerSize));
	};
	
	var iconPosition = function iconPosition(_ref2) {
	  var themeFromProvider = _ref2.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var borderWidth = theme.reactackle.components.checkbox.input.borderWidth;
	
	
	  return '\n    top: ' + (0, _reactackleCore.getValueString)(borderWidth) + ';\n    left: ' + (0, _reactackleCore.getValueString)(borderWidth) + ';\n  ';
	};
	
	var iconStyle = function iconStyle(_ref3) {
	  var checked = _ref3.checked,
	      disabled = _ref3.disabled,
	      themeFromProvider = _ref3.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var path = theme.reactackle.components.checkbox.icon.style;
	  var source = checked ? path.checked : path;
	
	  return !disabled ? (0, _styledComponents.css)(['opacity:', ';', ';&:hover,', ':hover &{color:', ';opacity:', ';}&:focus,', ':focus &{color:', ';opacity:', ';}'], source.opacity, (0, _reactackleIcons.iconStyleMixin)(source.color), _CheckboxLabelStyled.CheckboxLabelStyled, source.hover.color, source.hover.opacity, _CheckboxLabelStyled.CheckboxLabelStyled, source.focus.color, source.focus.opacity) : (0, _styledComponents.css)(['&,&:hover,', ':hover &,&:focus,', ':focus &{opacity:', ';', ';}'], _CheckboxLabelStyled.CheckboxLabelStyled, _CheckboxLabelStyled.CheckboxLabelStyled, source.disabled.opacity, (0, _reactackleIcons.iconStyleMixin)(source.color));
	};
	
	/* Styles */
	var CheckboxIconStyled = exports.CheckboxIconStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'CheckboxIconStyled'
	})(['position:absolute;z-index:1;', ';', ';', ';', ';&:focus{box-shadow:none;outline:none;}'], iconSize, iconPosition, iconStyle, (0, _reactackleCore.transition)('color, opacity'));
	
	CheckboxIconStyled.propTypes = propTypes;
	CheckboxIconStyled.defaultProps = defaultProps;
	CheckboxIconStyled.displayName = 'CheckboxIconStyled';

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CheckboxInputStyled = undefined;
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CheckboxInputStyled = exports.CheckboxInputStyled = _styledComponents2.default.input.withConfig({
	  displayName: 'CheckboxInputStyled'
	})(['', ';', ';'], /* Prettier workaround until issue is not fixed:
	                   https://github.com/prettier/prettier/issues/2291 */'', _reactackleCore.elementInvisible);
	
	CheckboxInputStyled.displayName = 'CheckboxInputStyled';

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CheckboxStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  textFree: _propTypes2.default.bool,
	  theme: _propTypes2.default.object
	};
	
	var defaultProps = {
	  textFree: false
	};
	
	var checkboxSizeProps = function checkboxSizeProps(_ref) {
	  var themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var size = theme.reactackle.components.checkbox.input.size;
	  var _theme$reactackle$com = theme.reactackle.components.checkbox.label,
	      fontSize = _theme$reactackle$com.fontSize,
	      lineHeight = _theme$reactackle$com.lineHeight;
	
	
	  var fontFamily = theme.reactackle.fontFamily[theme.reactackle.body.fontFamily];
	
	  return '\n    min-width: ' + (0, _reactackleCore.getValueString)(size) + ';\n    min-height: ' + (0, _reactackleCore.getValueString)(size) + ';\n    line-height: ' + lineHeight + ';\n    font-size: ' + (0, _reactackleCore.getValueString)(fontSize) + ';\n    \n    &,\n    & *,\n    *::after,\n    *::before {\n      font-family: ' + fontFamily + ';\n      box-sizing: border-box;\n    }    \n  ';
	};
	
	var spacing = function spacing(_ref2) {
	  var themeFromProvider = _ref2.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var spacing = theme.reactackle.components.checkbox.checkboxesSpacing;
	
	
	  return '& + & { margin-top: ' + (0, _reactackleCore.getValueString)(spacing) + '; }';
	};
	
	var CheckboxStyled = exports.CheckboxStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'CheckboxStyled'
	})(['position:relative;user-select:none;', ';', ';'], spacing, checkboxSizeProps);
	
	CheckboxStyled.propTypes = propTypes;
	CheckboxStyled.defaultProps = defaultProps;
	CheckboxStyled.displayName = 'CheckboxStyled';

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LabelElementStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  hasTooltip: _propTypes2.default.bool
	};
	
	var defaultProps = {
	  hasTooltip: _propTypes2.default.bool
	};
	
	var spacing = function spacing(_ref) {
	  var themeFromProvider = _ref.theme,
	      hasTooltip = _ref.hasTooltip;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var labelTooltipSpacing = theme.reactackle.components.checkbox.label.labelTooltipSpacing;
	
	
	  return hasTooltip ? '\n      & > *:last-child {\n        margin-left: ' + (0, _reactackleCore.getValueString)(labelTooltipSpacing) + ';\n      }\n    ' : '';
	};
	
	var LabelElementStyled = exports.LabelElementStyled = _styledComponents2.default.span.withConfig({
	  displayName: 'LabelElementStyled'
	})(['display:flex;', ';'], spacing);
	
	LabelElementStyled.displayName = 'LabelElementStyled';
	LabelElementStyled.propTypes = propTypes;
	LabelElementStyled.defaultProps = defaultProps;

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LabelTextStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  hasTooltip: _propTypes2.default.bool
	};
	
	var defaultProps = {
	  hasTooltip: void 0
	};
	
	var spacing = function spacing(_ref) {
	  var themeFromProvider = _ref.theme,
	      hasTooltip = _ref.hasTooltip;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var labelTooltipSpacing = theme.reactackle.components.checkbox.label.labelTooltipSpacing;
	
	
	  return hasTooltip ? ' padding-right: ' + (0, _reactackleCore.getValueString)(labelTooltipSpacing) + ';' : '';
	};
	
	var LabelTextStyled = exports.LabelTextStyled = _styledComponents2.default.span.withConfig({
	  displayName: 'LabelTextStyled'
	})(['', ';', ';'], /* Prettier workarount until issue is not fixed: https://github.com/prettier/prettier/issues/2291 */'', spacing);
	
	LabelTextStyled.displayName = 'LabelTextStyled';
	LabelTextStyled.propTypes = propTypes;
	LabelTextStyled.defaultProps = defaultProps;

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MessageStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  theme: _propTypes2.default.object
	};
	
	var styleProps = function styleProps(_ref) {
	  var themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var _theme$reactackle$com = theme.reactackle.components.checkbox.errorMessage,
	      messageCheckboxSpacing = _theme$reactackle$com.messageCheckboxSpacing,
	      lineHeight = _theme$reactackle$com.lineHeight,
	      fontSize = _theme$reactackle$com.fontSize,
	      fontColor = _theme$reactackle$com.fontColor;
	
	
	  var checkboxSize = (0, _reactackleCore.getValueString)(theme.reactackle.components.checkbox.input.size);
	
	  var checkboxTextSpacing = (0, _reactackleCore.getValueString)(theme.reactackle.components.checkbox.label.checkboxTextSpacing);
	
	  var offset = 'calc(' + checkboxSize + ' + ' + checkboxTextSpacing + ')';
	
	  return (0, _styledComponents.css)(['padding-left:', ';font-size:', ';color:', ';line-height:', ';margin-top:', ';'], offset, (0, _reactackleCore.getValueString)(fontSize), fontColor, lineHeight, (0, _reactackleCore.getValueString)(messageCheckboxSpacing));
	};
	
	var MessageStyled = exports.MessageStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'MessageStyled'
	})(['', ';', ';'], /* Prettier workarount until issue is not fixed: https://github.com/prettier/prettier/issues/2291 */'', styleProps);
	
	MessageStyled.propTypes = propTypes;
	MessageStyled.displayName = 'MessageStyled';

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactackleCore = __webpack_require__(3);
	
	var _reactackleIcons = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  checkboxesSpacing: (0, _reactackleCore.bmodule)(1),
	
	  input: {
	    size: (0, _reactackleCore.bmodule)(2.25),
	    cursor: 'pointer',
	    borderWidth: 1, // Only numbers accepted
	    borderRadius: _reactackleCore.radiusDefault,
	    backgroundColor: _reactackleCore.colorTransparent,
	    borderColor: _reactackleCore.colorPaletteGrey300,
	
	    hover: {
	      backgroundColor: _reactackleCore.colorTransparent,
	      borderColor: _reactackleCore.colorPaletteGrey500
	    },
	
	    focus: {
	      backgroundColor: _reactackleCore.colorTransparent,
	      borderColor: _reactackleCore.colorSecondary
	    },
	
	    disabled: {
	      backgroundColor: _reactackleCore.colorPaletteGrey100,
	      borderColor: _reactackleCore.colorPaletteGrey300
	    },
	
	    checked: {
	      backgroundColor: _reactackleCore.colorSecondary,
	      borderColor: _reactackleCore.colorSecondary,
	
	      hover: {
	        backgroundColor: _reactackleCore.colorSecondary,
	        borderColor: _reactackleCore.colorSecondary
	      },
	
	      focus: {
	        backgroundColor: _reactackleCore.colorSecondary,
	        borderColor: _reactackleCore.colorSecondary
	      },
	
	      disabled: {
	        backgroundColor: _reactackleCore.colorPaletteGrey200,
	        borderColor: _reactackleCore.colorPaletteGrey300
	      }
	    }
	  },
	
	  icon: {
	    size: (0, _reactackleCore.bmodule)(2),
	    imgSize: null,
	    element: _react2.default.createElement(_reactackleIcons.IconCheck, { size: 'custom', color: 'currentColor' }),
	
	    style: {
	      color: _reactackleCore.colorTransparent,
	      opacity: 1,
	
	      hover: {
	        color: _reactackleCore.colorWhite,
	        opacity: 0.3
	      },
	
	      focus: {
	        color: _reactackleCore.colorWhite,
	        opacity: 0.5
	      },
	
	      disabled: {
	        color: _reactackleCore.colorTransparent,
	        opacity: 1
	      },
	
	      checked: {
	        color: _reactackleCore.colorWhite,
	        opacity: 1,
	
	        hover: {
	          color: _reactackleCore.colorWhite,
	          opacity: 0.6
	        },
	
	        focus: {
	          color: _reactackleCore.colorWhite,
	          opacity: 0.6
	        },
	
	        disabled: {
	          color: _reactackleCore.colorWhite,
	          opacity: 0.75
	        }
	      }
	    }
	  },
	
	  label: {
	    checkboxTextSpacing: (0, _reactackleCore.bmodule)(1),
	    labelTooltipSpacing: (0, _reactackleCore.bmodule)(1),
	    fontSize: _reactackleCore.fontSizeBody,
	    fontColor: _reactackleCore.colorPaletteGrey900,
	    lineHeight: 1.5,
	
	    disabled: {
	      color: _reactackleCore.colorPaletteGrey500
	    }
	  },
	
	  errorMessage: {
	    messageCheckboxSpacing: (0, _reactackleCore.bmodule)(0.5),
	    fontSize: _reactackleCore.fontSizeSmall,
	    fontColor: _reactackleCore.colorError,
	    lineHeight: 1.25
	  }
	};

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Theme = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _lodash = __webpack_require__(169);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _createBroadcast = __webpack_require__(133);
	
	var _misc = __webpack_require__(97);
	
	var _theme = __webpack_require__(132);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var THEME_MIXIN_CHANNEL = '__reactackle_theme_mixin__';
	
	var propTypes = {
	  mixin: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func])
	};
	
	var defaultProps = {
	  mixin: {}
	};
	
	var contextTypes = _defineProperty({}, THEME_MIXIN_CHANNEL, _propTypes2.default.func);
	
	var childContextTypes = _defineProperty({}, THEME_MIXIN_CHANNEL, _propTypes2.default.func.isRequired);
	
	var Theme = exports.Theme = function (_Component) {
	  _inherits(Theme, _Component);
	
	  function Theme(props, context) {
	    _classCallCheck(this, Theme);
	
	    var _this = _possibleConstructorReturn(this, (Theme.__proto__ || Object.getPrototypeOf(Theme)).call(this, props, context));
	
	    _this._unsubscribeToOuter = null;
	    _this._unsubscribeDefaultTheme = null;
	    _this._broadcast = null;
	    _this._outerMixin = {};
	    _this._currentMixin = {};
	
	    _this.state = {
	      theme: {}
	    };
	
	    _this._updateTheme = _this._updateTheme.bind(_this);
	    return _this;
	  }
	
	  _createClass(Theme, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return _extends({}, this.context, _defineProperty({}, THEME_MIXIN_CHANNEL, this._broadcast.subscribe));
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      if (this.context[THEME_MIXIN_CHANNEL]) {
	        var subscribe = this.context[THEME_MIXIN_CHANNEL];
	        this._unsubscribeToOuter = subscribe(function (mixin) {
	          _this2._outerMixin = mixin;
	        });
	      }
	
	      this._currentMixin = this._getMixin(this.props.mixin);
	      this._broadcast = (0, _createBroadcast.createBroadcast)(this._currentMixin);
	      this._unsubscribeDefaultTheme = _theme.defaultThemeBlueprintBroadcast.subscribe(this._updateTheme);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.mixin !== nextProps.mixin) {
	        this._currentMixin = this._getMixin(nextProps.mixin);
	
	        this._broadcast.publish(this._currentMixin);
	        this._updateTheme();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this._unsubscribeDefaultTheme();
	      if (this.context[THEME_MIXIN_CHANNEL]) this._unsubscribeToOuter();
	    }
	  }, {
	    key: '_updateTheme',
	    value: function _updateTheme() {
	      this.setState({ theme: (0, _theme.composeReactackleTheme)(this._currentMixin) });
	    }
	  }, {
	    key: '_getMixin',
	    value: function _getMixin(mixin) {
	      if ((0, _misc.isFunction)(mixin)) return mixin(this._outerMixin);
	
	      if (this.context[THEME_MIXIN_CHANNEL]) return (0, _lodash2.default)({}, this._outerMixin, mixin);
	
	      return this.props.mixin;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _styledComponents.ThemeProvider,
	        { theme: this.state.theme },
	        this.props.children
	      );
	    }
	  }]);
	
	  return Theme;
	}(_react.Component);
	
	Theme.childContextTypes = childContextTypes;
	Theme.contextTypes = contextTypes;
	Theme.propTypes = propTypes;
	Theme.defaultProps = defaultProps;
	Theme.displayName = 'Theme';

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.withTheme = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _hoistNonReactMethods = __webpack_require__(395);
	
	var _hoistNonReactMethods2 = _interopRequireDefault(_hoistNonReactMethods);
	
	var _theme = __webpack_require__(132);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var CHANNEL = '__styled-components__';
	
	var contextTypes = _defineProperty({}, CHANNEL, _propTypes2.default.func);
	
	function isClassComponent(Component) {
	  return Boolean(Component && Component.prototype && Component.prototype.isReactComponent);
	}
	
	var withTheme = exports.withTheme = function withTheme(WrappedComponent) {
	  var isStatefull = isClassComponent(WrappedComponent);
	
	  var WithTheme = function (_Component) {
	    _inherits(WithTheme, _Component);
	
	    function WithTheme(props) {
	      _classCallCheck(this, WithTheme);
	
	      var _this = _possibleConstructorReturn(this, (WithTheme.__proto__ || Object.getPrototypeOf(WithTheme)).call(this, props));
	
	      _this.state = {
	        theme: {}
	      };
	
	      _this._unsubscribe = null;
	      return _this;
	    }
	
	    _createClass(WithTheme, [{
	      key: 'componentWillMount',
	      value: function componentWillMount() {
	        var _this2 = this;
	
	        if (this.context[CHANNEL]) {
	          var subscribe = this.context[CHANNEL];
	
	          this._unsubscribe = subscribe(function (theme) {
	            _this2.setState({ theme: theme });
	          });
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        if (this._unsubscribe) this._unsubscribe();
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _this3 = this;
	
	        var theme = (0, _theme.extractThemeOrDefault)(this.state.theme);
	
	        var props = _extends({}, this.props, {
	          theme: theme
	        });
	
	        if (isStatefull) props.ref = function (ref) {
	          _this3.wrappedComponent = ref;
	        };
	
	        return _react2.default.createElement(WrappedComponent, props);
	      }
	    }]);
	
	    return WithTheme;
	  }(_react.Component);
	
	  WithTheme.contextTypes = contextTypes;
	  WithTheme.displayName = 'WithTheme(' + WrappedComponent.displayName + ')';
	
	  WithTheme.propTypes = _extends({}, WrappedComponent.propTypes, {
	    theme: _propTypes2.default.object
	  });
	
	  WithTheme.defaultProps = _extends({}, WrappedComponent.defaultProps);
	
	  return isStatefull ? (0, _hoistNonReactMethods2.default)(WithTheme, WrappedComponent, function (c) {
	    return c.wrappedComponent;
	  }) : WithTheme;
	};

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.injectGlobalStyle = undefined;
	
	var _templateObject = _taggedTemplateLiteral(['    \n    html,\n    body {\n      font-size: 100%;\n      display: flex;\n      align-items: stretch;\n      overflow-x: hidden;\n    }\n    \n    body {\n      cursor: default;\n      background-color: ', ';\n      color: ', ';\n      font-family: ', ';\n      font-weight: ', ';\n      line-height: ', ';\n      position: relative;\n      width: 100%;\n      display: flex;\n      min-height: 100vh;\n      flex-direction: column;\n    }\n  '], ['    \n    html,\n    body {\n      font-size: 100%;\n      display: flex;\n      align-items: stretch;\n      overflow-x: hidden;\n    }\n    \n    body {\n      cursor: default;\n      background-color: ', ';\n      color: ', ';\n      font-family: ', ';\n      font-weight: ', ';\n      line-height: ', ';\n      position: relative;\n      width: 100%;\n      display: flex;\n      min-height: 100vh;\n      flex-direction: column;\n    }\n  ']);
	
	var _styledComponents = __webpack_require__(4);
	
	var _base = __webpack_require__(130);
	
	var _base2 = _interopRequireDefault(_base);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var injectGlobalStyle = exports.injectGlobalStyle = function injectGlobalStyle() {
	  // eslint-disable-next-line no-unused-expressions
	  (0, _styledComponents.injectGlobal)(_templateObject, _base2.default.body.backgroundColor, _base2.default.body.fontColor, _base2.default.fontFamily[_base2.default.body.fontFamily], _base2.default.body.fontWeight, _base2.default.body.lineHeight);
	};

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Dmitriy Malakhov
	 */
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.withExternalProps = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(115);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var withExternalProps = exports.withExternalProps = function withExternalProps(channel) {
	  return function (WrappedComponent) {
	    var contextTypes = _defineProperty({}, channel, _propTypes2.default.func);
	
	    var WithExternalProps = function (_Component) {
	      _inherits(WithExternalProps, _Component);
	
	      function WithExternalProps(props) {
	        _classCallCheck(this, WithExternalProps);
	
	        var _this = _possibleConstructorReturn(this, (WithExternalProps.__proto__ || Object.getPrototypeOf(WithExternalProps)).call(this, props));
	
	        _this.state = {
	          externalProps: {}
	        };
	
	        _this._unsubscribe = null;
	        return _this;
	      }
	
	      _createClass(WithExternalProps, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	          var _this2 = this;
	
	          if (this.context[channel]) {
	            var subscribe = this.context[channel];
	            this._unsubscribe = subscribe(function (state) {
	              _this2.setState({
	                externalProps: state
	              });
	            });
	          }
	        }
	      }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	          if (this._unsubscribe) this._unsubscribe();
	        }
	      }, {
	        key: 'render',
	        value: function render() {
	          return _react2.default.createElement(
	            WrappedComponent,
	            _extends({}, this.props, {
	              externalProps: this.state.externalProps
	            }),
	            this.props.children
	          );
	        }
	      }]);
	
	      return WithExternalProps;
	    }(_react.Component);
	
	    WithExternalProps.propTypes = (0, _lodash2.default)(WrappedComponent.propTypes, ['externalProps']);
	
	    WithExternalProps.defaultProps = (0, _lodash2.default)(WrappedComponent.defaultProps, ['externalProps']);
	
	    WithExternalProps.contextTypes = contextTypes;
	    WithExternalProps.displayName = 'WithExternalProps(' + WrappedComponent.displayName + ')';
	
	    return WithExternalProps;
	  };
	};

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _animations = __webpack_require__(627);
	
	Object.keys(_animations).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _animations[key];
	    }
	  });
	});
	
	var _media = __webpack_require__(628);
	
	Object.keys(_media).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _media[key];
	    }
	  });
	});
	
	var _mixinsStyle = __webpack_require__(630);
	
	Object.keys(_mixinsStyle).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _mixinsStyle[key];
	    }
	  });
	});
	
	var _mixinsElements = __webpack_require__(629);
	
	Object.keys(_mixinsElements).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _mixinsElements[key];
	    }
	  });
	});

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.animations = undefined;
	
	var _styledComponents = __webpack_require__(4);
	
	var Spin = (0, _styledComponents.keyframes)(['   0%{transform:rotate(0deg);}100%{transform:rotate(359deg);}']);
	
	var Bounce = (0, _styledComponents.keyframes)(['from,20%,53%,80%,100%{-timoutg-function:cubic-bezier(0.215,0.610,0.355,1.000);transform:translate3d(0,0,0);}40%,43%{-timing-function:cubic-bezier(0.755,0.050,0.855,0.060);transform:translate3d(0,-30px,0);}70%{-timing-function:cubic-bezier(0.755,0.050,0.855,0.060);transform:translate3d(0,-15px,0);}90%{transform:translate3d(0,-4px,0);}']);
	
	var Flash = (0, _styledComponents.keyframes)(['from,50%,100%{opacity:1;}25%,75%{opacity:0;}']);
	
	var Pulse = (0, _styledComponents.keyframes)(['from{transform:scale3d(1,1,1);}50%{transform:scale3d(1.05,1.05,1.05);}100%{transform:scale3d(1,1,1);}']);
	
	var RubberBand = (0, _styledComponents.keyframes)(['from{transform:scale3d(1,1,1);}30%{transform:scale3d(1.25,0.75,1);}40%{transform:scale3d(0.75,1.25,1);}50%{transform:scale3d(1.15,0.85,1);}65%{transform:scale3d(.95,1.05,1);}75%{transform:scale3d(1.05,.95,1);}100%{transform:scale3d(1,1,1);}']);
	
	var Shake = (0, _styledComponents.keyframes)(['from,100%{transform:translate3d(0,0,0);}10%,30%,50%,70%,90%{transform:translate3d(-10px,0,0);}20%,40%,60%,80%{transform:translate3d(10px,0,0);}']);
	
	var Swing = (0, _styledComponents.keyframes)(['20%{transform:rotate3d(0,0,1,15deg);}40%{transform:rotate3d(0,0,1,-10deg);}60%{transform:rotate3d(0,0,1,5deg);}80%{transform:rotate3d(0,0,1,-5deg);}100%{transform:rotate3d(0,0,1,0deg);}']);
	
	var Tada = (0, _styledComponents.keyframes)(['from{transform:scale3d(1,1,1);}10%,20%{transform:scale3d(.9,.9,.9) rotate3d(0,0,1,-3deg);}30%,50%,70%,90%{transform:scale3d(1.1,1.1,1.1) rotate3d(0,0,1,3deg);}40%,60%,80%{transform:scale3d(1.1,1.1,1.1) rotate3d(0,0,1,-3deg);}100%{transform:scale3d(1,1,1);}']);
	
	var Wobble = (0, _styledComponents.keyframes)(['from{transform:none;}15%{transform:translate3d(-25%,0,0) rotate3d(0,0,1,-5deg);}30%{transform:translate3d(20%,0,0) rotate3d(0,0,1,3deg);}45%{transform:translate3d(-15%,0,0) rotate3d(0,0,1,-3deg);}60%{transform:translate3d(10%,0,0) rotate3d(0,0,1,2deg);}75%{transform:translate3d(-5%,0,0) rotate3d(0,0,1,-1deg);}100%{transform:none;}']);
	
	var Jello = (0, _styledComponents.keyframes)(['from,11.1%,100%{transform:none;}22.2%{transform:skewX(-12.5deg) skewY(-12.5deg);}33.3%{transform:skewX(6.25deg) skewY(6.25deg);}44.4%{transform:skewX(-3.125deg) skewY(-3.125deg);}55.5%{transform:skewX(1.5625deg) skewY(1.5625deg);}66.6%{transform:skewX(-0.78125deg) skewY(-0.78125deg);}77.7%{transform:skewX(0.390625deg) skewY(0.390625deg);}88.8%{transform:skewX(-0.1953125deg) skewY(-0.1953125deg);}']);
	
	var BounceIn = (0, _styledComponents.keyframes)(['from,20%,40%,60%,80%,100%{-timing-function:cubic-bezier(0.215,0.610,0.355,1.000);}0%{opacity:0;transform:scale3d(.3,.3,.3);}20%{transform:scale3d(1.1,1.1,1.1);}40%{transform:scale3d(.9,.9,.9);}60%{opacity:1;transform:scale3d(1.03,1.03,1.03);}80%{transform:scale3d(.97,.97,.97);}100%{opacity:1;transform:scale3d(1,1,1);}']);
	
	var BounceInDown = (0, _styledComponents.keyframes)(['from,60%,75%,90%,100%{-timing-function:cubic-bezier(0.215,0.610,0.355,1.000);}0%{opacity:0;transform:translate3d(0,-3000px,0);}60%{opacity:1;transform:translate3d(0,25px,0);}75%{transform:translate3d(0,-10px,0);}90%{transform:translate3d(0,5px,0);}100%{transform:none;}']);
	
	var BounceInLeft = (0, _styledComponents.keyframes)(['from,60%,75%,90%,100%{-timing-function:cubic-bezier(0.215,0.610,0.355,1.000);}0%{opacity:0;transform:translate3d(0,-3000px,0);}60%{opacity:1;transform:translate3d(0,25px,0);}75%{transform:translate3d(0,-10px,0);}90%{transform:translate3d(0,5px,0);}100%{transform:none;}']);
	
	var BounceInRight = (0, _styledComponents.keyframes)(['from,60%,75%,90%,100%{-timing-function:cubic-bezier(0.215,0.610,0.355,1.000);}from{opacity:0;transform:translate3d(3000px,0,0);}60%{opacity:1;transform:translate3d(-25px,0,0);}75%{transform:translate3d(10px,0,0);}90%{transform:translate3d(-5px,0,0);}100%{transform:none;}']);
	
	var BounceInUp = (0, _styledComponents.keyframes)(['from,60%,75%,90%,100%{-timing-function:cubic-bezier(0.215,0.610,0.355,1.000);}from{opacity:0;transform:translate3d(0,3000px,0);}60%{opacity:1;transform:translate3d(0,-20px,0);}75%{transform:translate3d(0,10px,0);}90%{transform:translate3d(0,-5px,0);}100%{transform:translate3d(0,0,0);}']);
	
	var BounceOut = (0, _styledComponents.keyframes)(['20%{transform:scale3d(.9,.9,.9);}50%,55%{opacity:1;transform:scale3d(1.1,1.1,1.1);}100%{opacity:0;transform:scale3d(.3,.3,.3);}']);
	
	var BounceOutDown = (0, _styledComponents.keyframes)(['20%{transform:translate3d(0,10px,0);}40%,45%{opacity:1;transform:translate3d(0,-20px,0);}100%{opacity:0;transform:translate3d(0,2000px,0);}']);
	
	var BounceOutLeft = (0, _styledComponents.keyframes)(['20%{opacity:1;transform:translate3d(20px,0,0);}100%{opacity:0;transform:translate3d(-2000px,0,0);}']);
	
	var BounceOutRight = (0, _styledComponents.keyframes)(['20%{opacity:1;transform:translate3d(-20px,0,0);}100%{opacity:0;transform:translate3d(2000px,0,0);}']);
	
	var BounceOutUp = (0, _styledComponents.keyframes)(['20%{transform:translate3d(0,-10px,0);}40%,45%{opacity:1;transform:translate3d(0,20px,0);}100%{opacity:0;transform:translate3d(0,-2000px,0);}']);
	
	var FadeIn = (0, _styledComponents.keyframes)(['from{opacity:0;}100%{opacity:1;}']);
	
	var FadeInDownSmall = (0, _styledComponents.keyframes)(['from{opacity:0;transform:translate3d(0,-20px,0);}100%{opacity:1;transform:translate3d(0,0,0);}']);
	
	var FadeInDown = (0, _styledComponents.keyframes)(['from{opacity:0;transform:translate3d(0,-80px,0);}100%{opacity:1;transform:translate3d(0,0,0);}']);
	
	var FadeInDownBig = (0, _styledComponents.keyframes)(['from{opacity:0;transform:translate3d(0,-2000px,0);}100%{opacity:1;transform:none;}']);
	
	var FadeInLeft = (0, _styledComponents.keyframes)(['from{opacity:0;transform:translate3d(-10%,0,0);}100%{opacity:1;transform:none;}']);
	
	var FadeInLeftBig = (0, _styledComponents.keyframes)(['from{opacity:0;ransform:translate3d(-2000px,0,0);}100%{opacity:1;transform:none;}']);
	
	var FadeInRight = (0, _styledComponents.keyframes)(['from{opacity:0;transform:translate3d(20%,0,0);}100%{opacity:1;transform:none;}']);
	
	var FadeInRightBig = (0, _styledComponents.keyframes)(['from{opacity:0;transform:translate3d(2000px,0,0);}100%{opacity:1;transform:none;}']);
	
	var FadeInUp = (0, _styledComponents.keyframes)(['from{opacity:0;transform:translate3d(0,100%,0);}100%{opacity:1;transform:none;}']);
	
	var FadeInUpBig = (0, _styledComponents.keyframes)(['from{opacity:0;transform:translate3d(0,2000px,0);}100%{opacity:1;transform:none;}']);
	
	var FadeOut = (0, _styledComponents.keyframes)(['from{opacity:1;}100%{opacity:0;}']);
	
	var FadeOutDown = (0, _styledComponents.keyframes)(['from{opacity:1;}100%{opacity:0;transform:translate3d(0,100%,0);}']);
	
	var FadeOutDownBig = (0, _styledComponents.keyframes)(['from{opacity:1;}100%{opacity:0;transform:translate3d(0,2000px,0);}']);
	
	var FadeOutLeft = (0, _styledComponents.keyframes)(['from{opacity:1;}100%{opacity:0;transform:translate3d(-100%,0,0);}']);
	
	var FadeOutLeftBig = (0, _styledComponents.keyframes)(['from{opacity:1;}100%{opacity:0;transform:translate3d(-2000px,0,0);}']);
	
	var FadeOutRight = (0, _styledComponents.keyframes)(['from{opacity:1;}100%{opacity:0;transform:translate3d(100%,0,0);}']);
	
	var FadeOutRightBig = (0, _styledComponents.keyframes)(['from{opacity:1;}100%{opacity:0;transform:translate3d(2000px,0,0);}']);
	
	var FadeOutUp = (0, _styledComponents.keyframes)(['from{opacity:1;}100%{opacity:0;transform:translate3d(0,-80px,0);}']);
	
	var FadeOutUpBig = (0, _styledComponents.keyframes)(['from{opacity:1;}100%{opacity:0;transform:translate3d(0,-2000px,0);}']);
	
	var Flip = (0, _styledComponents.keyframes)(['from{transform:perspective(400px) rotate3d(0,1,0,-360deg);-timing-function:ease-out;}40%{transform:perspective(400px) translate3d(0,0,150px) rotate3d(0,1,0,-190deg);-timing-function:ease-out;}50%{transform:perspective(400px) translate3d(0,0,150px) rotate3d(0,1,0,-170deg);-timing-function:ease-in;}80%{transform:perspective(400px) scale3d(.95,.95,.95);-timing-function:ease-in;}100%{transform:perspective(400px);-timing-function:ease-in;}']);
	
	var FlipInX = (0, _styledComponents.keyframes)(['from{transform:perspective(400px) rotate3d(1,0,0,90deg);-timing-function:ease-in;opacity:0;}40%{transform:perspective(400px) rotate3d(1,0,0,-20deg);-timing-function:ease-in;}60%{transform:perspective(400px) rotate3d(1,0,0,10deg);opacity:1;}80%{transform:perspective(400px) rotate3d(1,0,0,-5deg);}100%{transform:perspective(400px);}']);
	
	var FlipInY = (0, _styledComponents.keyframes)(['from{transform:perspective(400px) rotate3d(0,1,0,90deg);-timing-function:ease-in;opacity:0;}40%{transform:perspective(400px) rotate3d(0,1,0,-20deg);-timing-function:ease-in;}60%{transform:perspective(400px) rotate3d(0,1,0,10deg);opacity:1;}80%{transform:perspective(400px) rotate3d(0,1,0,-5deg);}100%{transform:perspective(400px);}']);
	
	var FlipOutX = (0, _styledComponents.keyframes)(['from{transform:perspective(400px);}30%{transform:perspective(400px) rotate3d(1,0,0,-20deg);opacity:1;}100%{transform:perspective(400px) rotate3d(1,0,0,90deg);opacity:0;}']);
	
	var FlipOutY = (0, _styledComponents.keyframes)(['from{transform:perspective(400px);}30%{transform:perspective(400px) rotate3d(0,1,0,-15deg);opacity:1;}100%{transform:perspective(400px) rotate3d(0,1,0,90deg);opacity:0;}']);
	
	var LightSpeedIn = (0, _styledComponents.keyframes)(['from{transform:translate3d(100%,0,0) skewX(-30deg);opacity:0;}60%{transform:skewX(20deg);opacity:1;}80%{transform:skewX(-5deg);opacity:1;}100%{transform:none;opacity:1;}']);
	
	var LightSpeedOut = (0, _styledComponents.keyframes)(['from{opacity:1;}100%{transform:translate3d(100%,0,0) skewX(30deg);opacity:0;}']);
	
	var RotateIn = (0, _styledComponents.keyframes)(['from{transform-origin:center;transform:rotate3d(0,0,1,-200deg);opacity:0;}100%{transform-origin:center;transform:none;opacity:1;}']);
	
	var RotateInDownLeft = (0, _styledComponents.keyframes)(['from{transform-origin:left bottom;transform:rotate3d(0,0,1,-45deg);opacity:0;}100%{transform-origin:left bottom;transform:none;opacity:1;}']);
	
	var RotateInDownRight = (0, _styledComponents.keyframes)(['from{transform-origin:right bottom;transform:rotate3d(0,0,1,45deg);opacity:0;}100%{transform-origin:right bottom;transform:none;opacity:1;}']);
	
	var RotateInUpLeft = (0, _styledComponents.keyframes)(['from{transform-origin:left bottom;transform:rotate3d(0,0,1,45deg);opacity:0;}100%{transform-origin:left bottom;transform:none;opacity:1;}']);
	
	var RotateInUpRight = (0, _styledComponents.keyframes)(['from{transform-origin:right bottom;transform:rotate3d(0,0,1,-90deg);opacity:0;}100%{transform-origin:right bottom;transform:none;opacity:1;}']);
	
	var RotateOut = (0, _styledComponents.keyframes)(['from{transform-origin:center;opacity:1;}100%{transform-origin:center;transform:rotate3d(0,0,1,200deg);opacity:0;}']);
	
	var RotateOutDownLeft = (0, _styledComponents.keyframes)(['from{transform-origin:left bottom;opacity:1;}100%{transform-origin:left bottom;transform:rotate3d(0,0,1,45deg);opacity:0;}']);
	
	var RotateOutDownRight = (0, _styledComponents.keyframes)(['from{transform-origin:right bottom;opacity:1;}100%{transform-origin:right bottom;transform:rotate3d(0,0,1,-45deg);opacity:0;}']);
	
	var RotateOutUpLeft = (0, _styledComponents.keyframes)(['from{transform-origin:left bottom;opacity:1;}100%{transform-origin:left bottom;transform:rotate3d(0,0,1,-45deg);opacity:0;}']);
	
	var RotateOutUpRight = (0, _styledComponents.keyframes)(['from{transform-origin:right bottom;opacity:1;}100%{transform-origin:right bottom;transform:rotate3d(0,0,1,90deg);opacity:0;}']);
	
	var Hinge = (0, _styledComponents.keyframes)(['0%{transform-origin:top left;-timing-function:ease-in-out;}20%,60%{transform:rotate3d(0,0,1,80deg);transform-origin:top left;-timing-function:ease-in-out;}40%,80%{transform:rotate3d(0,0,1,60deg);transform-origin:top left;-timing-function:ease-in-out;opacity:1;}100%{transform:translate3d(0,700px,0);opacity:0;}']);
	
	var RollIn = (0, _styledComponents.keyframes)(['from{opacity:0;transform:translate3d(-100%,0,0) rotate3d(0,0,1,-120deg);}100%{opacity:1;transform:none;}']);
	
	var RollOut = (0, _styledComponents.keyframes)(['from{opacity:1;}100%{opacity:0;transform:translate3d(100%,0,0) rotate3d(0,0,1,120deg);}']);
	
	var ZoomIn = (0, _styledComponents.keyframes)(['from{opacity:0;transform:scale3d(.3,.3,.3);}50%{opacity:1;}']);
	
	var ZoomInDown = (0, _styledComponents.keyframes)(['from{opacity:0;transform:scale3d(.1,.1,.1) translate3d(0,-1000px,0);-timing-function:cubic-bezier(0.550,0.055,0.675,0.190);}60%{opacity:1;transform:scale3d(.475,.475,.475) translate3d(0,60px,0);-timing-function:cubic-bezier(0.175,0.885,0.320,1);}']);
	
	var ZoomInLeft = (0, _styledComponents.keyframes)(['from{opacity:0;transform:scale3d(.1,.1,.1) translate3d(-1000px,0,0);-timing-function:cubic-bezier(0.550,0.055,0.675,0.190);}60%{opacity:1;transform:scale3d(.475,.475,.475) translate3d(10px,0,0);-timing-function:cubic-bezier(0.175,0.885,0.320,1);}']);
	
	var ZoomInRight = (0, _styledComponents.keyframes)(['from{opacity:0;transform:scale3d(.1,.1,.1) translate3d(1000px,0,0);-timing-function:cubic-bezier(0.550,0.055,0.675,0.190);}60%{opacity:1;transform:scale3d(.475,.475,.475) translate3d(-10px,0,0);-timing-function:cubic-bezier(0.175,0.885,0.320,1);}']);
	
	var ZoomInUp = (0, _styledComponents.keyframes)(['from{opacity:0;transform:scale3d(.1,.1,.1) translate3d(0,1000px,0);-timing-function:cubic-bezier(0.550,0.055,0.675,0.190);}60%{opacity:1;transform:scale3d(.475,.475,.475) translate3d(0,-60px,0);-timing-function:cubic-bezier(0.175,0.885,0.320,1);}']);
	
	var ZoomOut = (0, _styledComponents.keyframes)(['from{opacity:1;}50%{opacity:0;transform:scale3d(.3,.3,.3);}']);
	
	var ZoomOutDown = (0, _styledComponents.keyframes)(['40%{opacity:1;transform:scale3d(.475,.475,.475) translate3d(0,-60px,0);-timing-function:cubic-bezier(0.550,0.055,0.675,0.190);}100%{opacity:0;transform:scale3d(.1,.1,.1) translate3d(0,2000px,0);transform-origin:center bottom;-timing-function:cubic-bezier(0.175,0.885,0.320,1);}']);
	
	var ZoomOutLeft = (0, _styledComponents.keyframes)(['40%{opacity:1;transform:scale3d(.475,.475,.475) translate3d(42px,0,0);}100%{opacity:0;transform:scale(.1) translate3d(-2000px,0,0);transform-origin:left center;}']);
	
	var ZoomOutRight = (0, _styledComponents.keyframes)(['40%{opacity:1;transform:scale3d(.475,.475,.475) translate3d(-42px,0,0);}100%{opacity:0;transform:scale(.1) translate3d(2000px,0,0);transform-origin:right center;}']);
	
	var ZoomOutUp = (0, _styledComponents.keyframes)(['40%{opacity:1;transform:scale3d(.475,.475,.475) translate3d(0,60px,0);-timing-function:cubic-bezier(0.550,0.055,0.675,0.190);}100%{opacity:0;transform:scale3d(.1,.1,.1) translate3d(0,-2000px,0);transform-origin:center bottom;-timing-function:cubic-bezier(0.175,0.885,0.320,1);}']);
	
	var SlideInDown = (0, _styledComponents.keyframes)(['from{transform:translate3d(0,-100%,0);visibility:visible;}100%{transform:translate3d(0,0,0);}']);
	
	var SlideInLeft = (0, _styledComponents.keyframes)(['from{transform:translate3d(-100%,0,0);visibility:visible;}100%{transform:translate3d(0,0,0);}']);
	
	var SlideInRight = (0, _styledComponents.keyframes)(['from{transform:translate3d(100%,0,0);visibility:visible;}100%{transform:translate3d(0,0,0);}']);
	
	var SlideInUp = (0, _styledComponents.keyframes)(['from{transform:translate3d(0,100%,0);visibility:visible;}100%{transform:translate3d(0,0,0);}']);
	
	var SlideOutDown = (0, _styledComponents.keyframes)(['from{transform:translate3d(0,0,0);}90%{opacity:1;}100%{visibility:hidden;opacity:0;transform:translate3d(0,100%,0);}']);
	
	var SlideOutLeft = (0, _styledComponents.keyframes)(['from{transform:translate3d(0,0,0);}100%{visibility:hidden;transform:translate3d(-100%,0,0);}']);
	
	var SlideOutRight = (0, _styledComponents.keyframes)(['from{transform:translate3d(0,0,0);}100%{visibility:hidden;transform:translate3d(100%,0,0);}']);
	
	var SlideOutUp = (0, _styledComponents.keyframes)(['from{transform:translate3d(0,0,0);}100%{visibility:hidden;transform:translate3d(0,-100%,0);}']);
	
	var Hide = (0, _styledComponents.keyframes)(['from{opacity:1;}80%{opacity:0;}100%{display:none;}']);
	
	var animations = exports.animations = {
	  bounce: Bounce,
	  bounceIn: BounceIn,
	  bounceInDown: BounceInDown,
	  bounceInLeft: BounceInLeft,
	  bounceInRight: BounceInRight,
	  bounceInUp: BounceInUp,
	  bounceOut: BounceOut,
	  bounceOutDown: BounceOutDown,
	  bounceOutLeft: BounceOutLeft,
	  bounceOutRight: BounceOutRight,
	  bounceOutUp: BounceOutUp,
	  fadeIn: FadeIn,
	  fadeInDown: FadeInDown,
	  fadeInDownSmall: FadeInDownSmall,
	  fadeInDownBig: FadeInDownBig,
	  fadeInLeft: FadeInLeft,
	  fadeInLeftBig: FadeInLeftBig,
	  fadeInRight: FadeInRight,
	  fadeInRightBig: FadeInRightBig,
	  fadeInUp: FadeInUp,
	  fadeInUpBig: FadeInUpBig,
	  fadeOut: FadeOut,
	  fadeOutDown: FadeOutDown,
	  fadeOutDownBig: FadeOutDownBig,
	  fadeOutLeft: FadeOutLeft,
	  fadeOutLeftBig: FadeOutLeftBig,
	  fadeOutRight: FadeOutRight,
	  fadeOutRightBig: FadeOutRightBig,
	  fadeOutUp: FadeOutUp,
	  fadeOutUpBig: FadeOutUpBig,
	  flash: Flash,
	  flip: Flip,
	  flipInX: FlipInX,
	  flipInY: FlipInY,
	  flipOutX: FlipOutX,
	  flipOutY: FlipOutY,
	  hide: Hide,
	  hinge: Hinge,
	  jello: Jello,
	  lightSpeedIn: LightSpeedIn,
	  lightSpeedOut: LightSpeedOut,
	  pulse: Pulse,
	  rotateIn: RotateIn,
	  rotateInDownLeft: RotateInDownLeft,
	  rotateInDownRight: RotateInDownRight,
	  rotateInUpLeft: RotateInUpLeft,
	  rotateInUpRight: RotateInUpRight,
	  rotateOut: RotateOut,
	  rotateOutDownLeft: RotateOutDownLeft,
	  rotateOutDownRight: RotateOutDownRight,
	  rotateOutUpLeft: RotateOutUpLeft,
	  rotateOutUpRight: RotateOutUpRight,
	  rollIn: RollIn,
	  rollOut: RollOut,
	  rubberBand: RubberBand,
	  shake: Shake,
	  slideInDown: SlideInDown,
	  slideInLeft: SlideInLeft,
	  slideInRight: SlideInRight,
	  slideInUp: SlideInUp,
	  slideOutDown: SlideOutDown,
	  slideOutLeft: SlideOutLeft,
	  slideOutRight: SlideOutRight,
	  slideOutUp: SlideOutUp,
	  spin: Spin,
	  swing: Swing,
	  tada: Tada,
	  wobble: Wobble,
	  zoomIn: ZoomIn,
	  zoomInDown: ZoomInDown,
	  zoomInLeft: ZoomInLeft,
	  zoomInRight: ZoomInRight,
	  zoomInUp: ZoomInUp,
	  zoomOut: ZoomOut,
	  zoomOutDown: ZoomOutDown,
	  zoomOutLeft: ZoomOutLeft,
	  zoomOutRight: ZoomOutRight,
	  zoomOutUp: ZoomOutUp
	};

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.media = undefined;
	
	var _styledComponents = __webpack_require__(4);
	
	var _base = __webpack_require__(130);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _misc = __webpack_require__(97);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var generateMediaQueryArg = function generateMediaQueryArg(name, value, baseDivider) {
	  if (!(0, _misc.isValidPositiveNumberOrZero)(baseDivider) || !baseDivider) throw new Error('Invalid \'baseDivider\' value: ' + baseDivider);
	  if (!(0, _misc.isUndef)(value)) {
	    if (typeof value === 'string') return '(' + name + ': ' + value + ')';else if ((0, _misc.isValidPositiveNumberOrZero)(value)) return '(' + name + ': ' + value / baseDivider + 'em)';else throw new Error('Invalid media query \'' + name + '\' value: ' + value);
	  } else {
	    return void 0;
	  }
	};
	
	/**
	 * MEDIA QUERIES
	 * iterate through the sizes and create a media template
	 */
	var media = exports.media = function media(fromWidth, untilWidth) {
	  var baseDivider = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _base2.default.breakpointsEmBase;
	  return function () {
	    var argNames = ['min-width', 'max-width'];
	
	    var query = [fromWidth, untilWidth].map(function (value, index) {
	      return generateMediaQueryArg(argNames[index], value, baseDivider);
	    }).filter(Boolean).join(' and ');
	
	    return query.length ? (0, _styledComponents.css)(['@media ', '{', '}'], query, _styledComponents.css.apply(undefined, arguments)) : null;
	  };
	};

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.triangle = undefined;
	exports.iconSizeMixin = iconSizeMixin;
	
	var _styledComponents = __webpack_require__(4);
	
	var _styleFunctions = __webpack_require__(211);
	
	/**
	 * Icon size mixin
	 */
	function iconSizeMixin(height) {
	  var imgHeight = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : height;
	  var width = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : height;
	  var imgWidth = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : imgHeight;
	
	  return (0, _styledComponents.css)(['     &,& > *{width:', ';height:', ';line-height:', ' !important;align-items:center;justify-content:center;', '}svg{width:', ';height:', ';}'], width, height, height, imgHeight && imgHeight !== 'inherit' && 'background-size: ' + imgHeight + ';', imgWidth, imgHeight);
	}
	
	/**
	 * Generate triangle
	 * @param {string} direction - triangle direction
	 * @param {string} [color='currentcolor'] - triangle color
	 * @param {number} [width=1] - triangle width
	 * @param {number} [height=width/2] - triangle height
	 * @param {string} [unit='em'] - size unit
	 */
	var triangle = exports.triangle = function triangle(direction) {
	  var color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'currentcolor';
	  var width = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
	  var height = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : width / 2;
	  var unit = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'em';
	
	  var perpendicularBorder = height + ' solid transparent';
	
	  return '\n    width: 0;\n    height: 0;\n    \n    border-' + (0, _styleFunctions.oppositeDirection)(direction.toLowerCase()) + ':\n      ' + (height + unit) + ' solid $color;\n    border-' + direction + ': 0 solid transparent;\n    \n    ' + (direction.toLowerCase() === 'top' || direction.toLowerCase() === 'bottom' ? '\n        border-left:   ' + perpendicularBorder + ';\n        border-right:  ' + perpendicularBorder + ';\n      ' : '\n        border-top:   ' + perpendicularBorder + ';\n        border-bottom:  ' + perpendicularBorder + ';\n      ') + '    \n  ';
	};

/***/ }),
/* 630 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Set SVG Icons as Background
	 * @param {string} svg - path to svg-image or base-64
	 * @param {string} [positionX='center'] - the x-alignement of image
	 * @param {string} [positionY='center] - the y-alignement of image
	 * @param {string} size - size of image
	 */
	var svgBackground = exports.svgBackground = function svgBackground(svg, size, positionX, positionY) {
	  return '\n  background-image: url(\'' + svg + '\');\n  background-position: ' + (positionX || 'center') + ' ' + (positionY || 'center') + ';\n  background-size: ' + size + ';\n  background-repeat: no-repeat;\n';
	};
	
	/**
	 * Set side radius to the component
	 * @param {string} side - side of the component
	 * @param {string} [radius=radiusConstants.default] - radius of side
	 */
	var sideRadius = exports.sideRadius = function sideRadius(side, radius) {
	  return '\n  ' + ((side === 'left' || side === 'right') && '\n    border-bottom-' + side + '-radius: ' + radius + ';\n    border-top-' + side + '-radius: ' + radius + ';\n  ') + '\n  \n  ' + ((side === 'top' || side === 'bottom') && '\n    border-' + side + '-left-radius: ' + radius + ';\n    border-' + side + '-right-radius: ' + radius + ';\n  ') + '\n';
	};
	
	/**
	 * Set transition
	 * @param {string} property - transitioned propertied
	 * @param {string} [speed='300ms'] - transition speed
	 * @param {string} [ease='ease-out'] - transition easing function
	 * @param {string} [delay='0ms'] - transition delay
	 */
	var transition = exports.transition = function transition(property, speed, ease, delay) {
	  return '\n  transition-property: ' + property + ';\n  transition-duration: ' + (speed || '300ms') + ';\n  transition-timing-function: ' + (ease || 'ease-out') + ';\n  transition-delay: ' + (delay || '0ms') + ';\n';
	};
	
	/**
	 * Visibility
	 */
	var elementInvisible = exports.elementInvisible = '\n  position: fixed;\n  opacity: 0;\n  pointer-events: none;\n  margin: 0;\n  padding: 0;\n  width: 0;\n  height: 0;\n';
	
	var elementInvisibleOff = exports.elementInvisibleOff = '\n  position: static;\n  opacity: initial;\n  pointer-events: initial;\n';
	
	/**
	 * Box shadow
	 */
	var boxShadow = exports.boxShadow = function boxShadow() {
	  var elevation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	  var color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'rgba(0, 0, 0, 0.1)';
	
	  var blur1 = 2;
	  var offset1 = 0;
	  var x1 = 0;
	  var y1 = blur1 / 2;
	
	  var blur2 = (blur1 + 1) * Math.abs(elevation);
	  var offset2 = (offset1 + 0.25) * Math.abs(elevation);
	  var x2 = 0;
	  var y2 = (y1 + 0.5) * elevation;
	
	  var blur3 = blur2 + 1;
	  var offset3 = offset2 + 0.25;
	  var x3 = 0;
	  var y3 = y2 + 0.5;
	
	  var shadow1 = x1 + 'px ' + y1 + 'px ' + blur1 + 'px ' + offset1 + 'px ' + color;
	  var shadow2 = x2 + 'px ' + y2 + 'px ' + blur2 + 'px ' + offset2 + 'px ' + color;
	  var shadow3 = x3 + 'px ' + y3 + 'px ' + blur3 + 'px ' + offset3 + 'px ' + color;
	
	  return 'box-shadow: ' + shadow1 + ', ' + shadow2 + ', ' + shadow3 + ';';
	};

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.injectResetStyle = undefined;
	
	var _templateObject = _taggedTemplateLiteral(['\n    *,\n    *::before,\n    *::after {\n      box-sizing: border-box; /* 1 */\n    }\n    \n    html {\n      font-family: sans-serif;      \n      -ms-text-size-adjust: 100%; /* 2 */\n      -webkit-text-size-adjust: 100%; /* 2 */\n    }\n    \n    body {\n      margin: 0; /* 3 */\n    }\n    \n    p:first-child { margin-top: 0; }\n    p:last-child { margin-bottom: 0; }\n  '], ['\n    *,\n    *::before,\n    *::after {\n      box-sizing: border-box; /* 1 */\n    }\n    \n    html {\n      font-family: sans-serif;      \n      -ms-text-size-adjust: 100%; /* 2 */\n      -webkit-text-size-adjust: 100%; /* 2 */\n    }\n    \n    body {\n      margin: 0; /* 3 */\n    }\n    \n    p:first-child { margin-top: 0; }\n    p:last-child { margin-bottom: 0; }\n  ']);
	
	var _styledComponents = __webpack_require__(4);
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	/*
	 * Reset
	 * Normalization of HTML elements
	 * We recommend you to use Normalize - https://github.com/necolas/normalize.css
	 * or https://github.com/twbs/bootstrap/blob/v4-dev/scss/_reboot.scss
	 */
	
	/*
	 * 1 - Set box-sizing to border-box to be sure that width isn't affected by
	 * padding or border
	 *
	 * 2 - Prevent adjustments of font size after orientation changes in IE on
	 * Windows Phone and in iOS.
	 *
	 * 3 - Remove the margin in all browsers (opinionated).
	 *
	*/
	
	var injectResetStyle = exports.injectResetStyle = function injectResetStyle() {
	  // eslint-disable-next-line no-unused-expressions
	  (0, _styledComponents.injectGlobal)(_templateObject);
	};

/***/ }),
/* 632 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/** Base Module Calculations */
	var baseModule = exports.baseModule = function baseModule(_ref) {
	  var baseModule = _ref.baseModule;
	  return baseModule;
	};
	var halfBaseModule = exports.halfBaseModule = function halfBaseModule(_ref2) {
	  var baseModule = _ref2.baseModule;
	  return baseModule * 0.5;
	};
	var oneAndHalfBaseModule = exports.oneAndHalfBaseModule = function oneAndHalfBaseModule(_ref3) {
	  var baseModule = _ref3.baseModule;
	  return baseModule * 1.5;
	};
	var doubleBaseModule = exports.doubleBaseModule = function doubleBaseModule(_ref4) {
	  var baseModule = _ref4.baseModule;
	  return baseModule * 2;
	};
	var twoAndHalfBaseModule = exports.twoAndHalfBaseModule = function twoAndHalfBaseModule(_ref5) {
	  var baseModule = _ref5.baseModule;
	  return baseModule * 2.5;
	};
	var tripleBaseModule = exports.tripleBaseModule = function tripleBaseModule(_ref6) {
	  var baseModule = _ref6.baseModule;
	  return baseModule * 3;
	};
	
	var multiplierFunctions = Object.create(null);
	
	var bmodule = exports.bmodule = function bmodule(multiplier) {
	  if (!multiplierFunctions[multiplier]) {
	    multiplierFunctions[multiplier] = function (_ref7) {
	      var baseModule = _ref7.baseModule;
	      return baseModule * multiplier;
	    };
	  }
	
	  return multiplierFunctions[multiplier];
	};
	
	/** Size parameters */
	var contentWidth = exports.contentWidth = function contentWidth(_ref8) {
	  var contentWidth = _ref8.contentWidth;
	  return contentWidth;
	};
	var totalColumns = exports.totalColumns = function totalColumns(_ref9) {
	  var totalColumns = _ref9.totalColumns;
	  return totalColumns;
	};
	
	var radiusDefault = exports.radiusDefault = function radiusDefault(_ref10) {
	  var radiusDefault = _ref10.radiusDefault;
	  return radiusDefault;
	};
	var radiusRounded = exports.radiusRounded = function radiusRounded(_ref11) {
	  var radiusRounded = _ref11.radiusRounded;
	  return radiusRounded;
	};
	
	/** Breakpoints */
	var breakpointXsmall = exports.breakpointXsmall = function breakpointXsmall(_ref12) {
	  var breakpoints = _ref12.breakpoints;
	  return breakpoints.xsmall;
	};
	var breakpointSmall = exports.breakpointSmall = function breakpointSmall(_ref13) {
	  var breakpoints = _ref13.breakpoints;
	  return breakpoints.small;
	};
	var breakpointMedium = exports.breakpointMedium = function breakpointMedium(_ref14) {
	  var breakpoints = _ref14.breakpoints;
	  return breakpoints.medium;
	};
	var breakpointLarge = exports.breakpointLarge = function breakpointLarge(_ref15) {
	  var breakpoints = _ref15.breakpoints;
	  return breakpoints.large;
	};
	var breakpointXlarge = exports.breakpointXlarge = function breakpointXlarge(_ref16) {
	  var breakpoints = _ref16.breakpoints;
	  return breakpoints.xlarge;
	};
	var breakpointXxlarge = exports.breakpointXxlarge = function breakpointXxlarge(_ref17) {
	  var breakpoints = _ref17.breakpoints;
	  return breakpoints.xxlarge;
	};
	
	/** Colors */
	var colorWhite = exports.colorWhite = function colorWhite(_ref18) {
	  var color = _ref18.color;
	  return color.white;
	};
	var colorBlack = exports.colorBlack = function colorBlack(_ref19) {
	  var color = _ref19.color;
	  return color.black;
	};
	var colorTransparent = exports.colorTransparent = function colorTransparent(_ref20) {
	  var color = _ref20.color;
	  return color.transparent;
	};
	
	var colorMain = exports.colorMain = function colorMain(_ref21) {
	  var color = _ref21.color;
	  return color.main;
	};
	var colorMainForeground = exports.colorMainForeground = function colorMainForeground(_ref22) {
	  var color = _ref22.color;
	  return color.mainFgTextColor;
	};
	var colorSecondary = exports.colorSecondary = function colorSecondary(_ref23) {
	  var color = _ref23.color;
	  return color.secondary;
	};
	var colorSecondaryForeground = exports.colorSecondaryForeground = function colorSecondaryForeground(_ref24) {
	  var color = _ref24.color;
	  return color.secondaryFgTextColor;
	};
	var colorAlert = exports.colorAlert = function colorAlert(_ref25) {
	  var color = _ref25.color;
	  return color.alert;
	};
	var colorAlertForeground = exports.colorAlertForeground = function colorAlertForeground(_ref26) {
	  var color = _ref26.color;
	  return color.alertFgTextColor;
	};
	var colorWarning = exports.colorWarning = function colorWarning(_ref27) {
	  var color = _ref27.color;
	  return color.warning;
	};
	var colorWarningForeground = exports.colorWarningForeground = function colorWarningForeground(_ref28) {
	  var color = _ref28.color;
	  return color.warningFgTextColor;
	};
	var colorError = exports.colorError = function colorError(_ref29) {
	  var color = _ref29.color;
	  return color.alert;
	};
	var colorErrorForeground = exports.colorErrorForeground = function colorErrorForeground(_ref30) {
	  var color = _ref30.color;
	  return color.alertFgTextColor;
	};
	var colorSuccess = exports.colorSuccess = function colorSuccess(_ref31) {
	  var color = _ref31.color;
	  return color.success;
	};
	var colorSuccessForeground = exports.colorSuccessForeground = function colorSuccessForeground(_ref32) {
	  var color = _ref32.color;
	  return color.successFgTextColor;
	};
	var colorInfo = exports.colorInfo = function colorInfo(_ref33) {
	  var color = _ref33.color;
	  return color.info;
	};
	var colorInfoForeground = exports.colorInfoForeground = function colorInfoForeground(_ref34) {
	  var color = _ref34.color;
	  return color.infoFgTextColor;
	};
	
	var colorPaletteGrey50 = exports.colorPaletteGrey50 = function colorPaletteGrey50(_ref35) {
	  var colorPaletteGrey = _ref35.colorPaletteGrey;
	  return colorPaletteGrey[50];
	};
	var colorPaletteGrey75 = exports.colorPaletteGrey75 = function colorPaletteGrey75(_ref36) {
	  var colorPaletteGrey = _ref36.colorPaletteGrey;
	  return colorPaletteGrey[75];
	};
	var colorPaletteGrey100 = exports.colorPaletteGrey100 = function colorPaletteGrey100(_ref37) {
	  var colorPaletteGrey = _ref37.colorPaletteGrey;
	  return colorPaletteGrey[100];
	};
	var colorPaletteGrey200 = exports.colorPaletteGrey200 = function colorPaletteGrey200(_ref38) {
	  var colorPaletteGrey = _ref38.colorPaletteGrey;
	  return colorPaletteGrey[200];
	};
	var colorPaletteGrey300 = exports.colorPaletteGrey300 = function colorPaletteGrey300(_ref39) {
	  var colorPaletteGrey = _ref39.colorPaletteGrey;
	  return colorPaletteGrey[300];
	};
	var colorPaletteGrey400 = exports.colorPaletteGrey400 = function colorPaletteGrey400(_ref40) {
	  var colorPaletteGrey = _ref40.colorPaletteGrey;
	  return colorPaletteGrey[400];
	};
	var colorPaletteGrey500 = exports.colorPaletteGrey500 = function colorPaletteGrey500(_ref41) {
	  var colorPaletteGrey = _ref41.colorPaletteGrey;
	  return colorPaletteGrey[500];
	};
	var colorPaletteGrey600 = exports.colorPaletteGrey600 = function colorPaletteGrey600(_ref42) {
	  var colorPaletteGrey = _ref42.colorPaletteGrey;
	  return colorPaletteGrey[600];
	};
	var colorPaletteGrey700 = exports.colorPaletteGrey700 = function colorPaletteGrey700(_ref43) {
	  var colorPaletteGrey = _ref43.colorPaletteGrey;
	  return colorPaletteGrey[700];
	};
	var colorPaletteGrey800 = exports.colorPaletteGrey800 = function colorPaletteGrey800(_ref44) {
	  var colorPaletteGrey = _ref44.colorPaletteGrey;
	  return colorPaletteGrey[800];
	};
	var colorPaletteGrey900 = exports.colorPaletteGrey900 = function colorPaletteGrey900(_ref45) {
	  var colorPaletteGrey = _ref45.colorPaletteGrey;
	  return colorPaletteGrey[900];
	};
	
	var colorBorder = exports.colorBorder = function colorBorder(_ref46) {
	  var colorBorder = _ref46.colorBorder;
	  return colorBorder;
	};
	var colorAnchor = exports.colorAnchor = function colorAnchor(_ref47) {
	  var colorAnchor = _ref47.colorAnchor;
	  return colorAnchor;
	};
	
	var colorBrandFacebook = exports.colorBrandFacebook = function colorBrandFacebook(_ref48) {
	  var colorBrand = _ref48.colorBrand;
	  return colorBrand.facebook;
	};
	var colorBrandVkontakte = exports.colorBrandVkontakte = function colorBrandVkontakte(_ref49) {
	  var colorBrand = _ref49.colorBrand;
	  return colorBrand.vkontakte;
	};
	var colorBrandGooglePlus = exports.colorBrandGooglePlus = function colorBrandGooglePlus(_ref50) {
	  var colorBrand = _ref50.colorBrand;
	  return colorBrand.googlePlus;
	};
	
	/** Font */
	var fontFamilySansSerif = exports.fontFamilySansSerif = function fontFamilySansSerif(_ref51) {
	  var fontFamily = _ref51.fontFamily;
	  return fontFamily.sansSerif;
	};
	var fontFamilySerif = exports.fontFamilySerif = function fontFamilySerif(_ref52) {
	  var fontFamily = _ref52.fontFamily;
	  return fontFamily.serif;
	};
	var fontFamilyMonospace = exports.fontFamilyMonospace = function fontFamilyMonospace(_ref53) {
	  var fontFamily = _ref53.fontFamily;
	  return fontFamily.monospace;
	};
	
	var fontWeightLight = exports.fontWeightLight = function fontWeightLight(_ref54) {
	  var fontWeight = _ref54.fontWeight;
	  return fontWeight.light;
	};
	var fontWeightNormal = exports.fontWeightNormal = function fontWeightNormal(_ref55) {
	  var fontWeight = _ref55.fontWeight;
	  return fontWeight.normal;
	};
	var fontWeightSemibold = exports.fontWeightSemibold = function fontWeightSemibold(_ref56) {
	  var fontWeight = _ref56.fontWeight;
	  return fontWeight.semibold;
	};
	var fontWeightBold = exports.fontWeightBold = function fontWeightBold(_ref57) {
	  var fontWeight = _ref57.fontWeight;
	  return fontWeight.bold;
	};
	
	var fontSizeXsmall = exports.fontSizeXsmall = function fontSizeXsmall(_ref58) {
	  var fontSize = _ref58.fontSize;
	  return fontSize[-2];
	};
	var fontSizeSmall = exports.fontSizeSmall = function fontSizeSmall(_ref59) {
	  var fontSize = _ref59.fontSize;
	  return fontSize[-1];
	};
	var fontSizeBody = exports.fontSizeBody = function fontSizeBody(_ref60) {
	  var fontSize = _ref60.fontSize;
	  return fontSize[0];
	};
	var fontSizeBody2 = exports.fontSizeBody2 = function fontSizeBody2(_ref61) {
	  var fontSize = _ref61.fontSize;
	  return fontSize[1];
	};
	var fontSizeTitle = exports.fontSizeTitle = function fontSizeTitle(_ref62) {
	  var fontSize = _ref62.fontSize;
	  return fontSize[2];
	};
	var fontSizeHeadline = exports.fontSizeHeadline = function fontSizeHeadline(_ref63) {
	  var fontSize = _ref63.fontSize;
	  return fontSize[3];
	};
	var fontSizeDisplay1 = exports.fontSizeDisplay1 = function fontSizeDisplay1(_ref64) {
	  var fontSize = _ref64.fontSize;
	  return fontSize[4];
	};
	var fontSizeDisplay2 = exports.fontSizeDisplay2 = function fontSizeDisplay2(_ref65) {
	  var fontSize = _ref65.fontSize;
	  return fontSize[5];
	};
	var fontSizeDisplay3 = exports.fontSizeDisplay3 = function fontSizeDisplay3(_ref66) {
	  var fontSize = _ref66.fontSize;
	  return fontSize[6];
	};
	var fontSizeDisplay4 = exports.fontSizeDisplay4 = function fontSizeDisplay4(_ref67) {
	  var fontSize = _ref67.fontSize;
	  return fontSize[7];
	};
	
	var fontColorLight = exports.fontColorLight = function fontColorLight(_ref68) {
	  var fontColor = _ref68.fontColor;
	  return fontColor.light;
	};
	var fontColorMedium = exports.fontColorMedium = function fontColorMedium(_ref69) {
	  var fontColor = _ref69.fontColor;
	  return fontColor.medium;
	};
	
	/** Other */
	var directionText = exports.directionText = function directionText(_ref70) {
	  var direction = _ref70.direction;
	  return direction.text;
	};
	var directionFloat = exports.directionFloat = function directionFloat(_ref71) {
	  var direction = _ref71.direction;
	  return direction.float;
	};
	
	var zIndexBase = exports.zIndexBase = function zIndexBase(_ref72) {
	  var zIndex = _ref72.zIndex;
	  return zIndex.base;
	};
	var zIndexNav = exports.zIndexNav = function zIndexNav(_ref73) {
	  var zIndex = _ref73.zIndex;
	  return zIndex.nav;
	};
	var zIndexAlertMobile = exports.zIndexAlertMobile = function zIndexAlertMobile(_ref74) {
	  var zIndex = _ref74.zIndex;
	  return zIndex.alertMobile;
	};
	var zIndexDropdown = exports.zIndexDropdown = function zIndexDropdown(_ref75) {
	  var zIndex = _ref75.zIndex;
	  return zIndex.dropdown;
	};
	var zIndexOverlay = exports.zIndexOverlay = function zIndexOverlay(_ref76) {
	  var zIndex = _ref76.zIndex;
	  return zIndex.overlay;
	};
	var zIndexModal = exports.zIndexModal = function zIndexModal(_ref77) {
	  var zIndex = _ref77.zIndex;
	  return zIndex.modal;
	};
	var zIndexPopup = exports.zIndexPopup = function zIndexPopup(_ref78) {
	  var zIndex = _ref78.zIndex;
	  return zIndex.popup;
	};
	var zIndexAlertDesktop = exports.zIndexAlertDesktop = function zIndexAlertDesktop(_ref79) {
	  var zIndex = _ref79.zIndex;
	  return zIndex.alertDesktop;
	};
	var zIndexTooltip = exports.zIndexTooltip = function zIndexTooltip(_ref80) {
	  var zIndex = _ref80.zIndex;
	  return zIndex.tooltip;
	};
	var zIndexMoon = exports.zIndexMoon = function zIndexMoon(_ref81) {
	  var zIndex = _ref81.zIndex;
	  return zIndex.moon;
	};
	
	/** Body Settings */
	var bodyBackgroundColor = exports.bodyBackgroundColor = function bodyBackgroundColor(_ref82) {
	  var body = _ref82.body;
	  return body.bgColor;
	};
	var bodyFontColor = exports.bodyFontColor = function bodyFontColor(_ref83) {
	  var body = _ref83.body;
	  return body.fontColor;
	};
	var bodyFontColorAlt = exports.bodyFontColorAlt = function bodyFontColorAlt(_ref84) {
	  var body = _ref84.body;
	  return body.fontColorAlt;
	};
	var bodyFontFamily = exports.bodyFontFamily = function bodyFontFamily(_ref85) {
	  var fontFamily = _ref85.fontFamily;
	  return fontFamily.sansSerif;
	};
	var bodyFontWeight = exports.bodyFontWeight = function bodyFontWeight(_ref86) {
	  var body = _ref86.body;
	  return body.fontWeight;
	};
	var bodyLineHeight = exports.bodyLineHeight = function bodyLineHeight(_ref87) {
	  var body = _ref87.body;
	  return body.lineHeight;
	};

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _misc = __webpack_require__(97);
	
	Object.keys(_misc).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _misc[key];
	    }
	  });
	});
	
	var _polyfills = __webpack_require__(637);
	
	Object.keys(_polyfills).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _polyfills[key];
	    }
	  });
	});
	
	var _index = __webpack_require__(636);
	
	Object.keys(_index).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _index[key];
	    }
	  });
	});
	
	var _createBroadcast = __webpack_require__(133);
	
	Object.keys(_createBroadcast).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _createBroadcast[key];
	    }
	  });
	});
	
	var _contextChannel = __webpack_require__(635);
	
	Object.keys(_contextChannel).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _contextChannel[key];
	    }
	  });
	});
	
	var _colors = __webpack_require__(634);
	
	Object.keys(_colors).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _colors[key];
	    }
	  });
	});

/***/ }),
/* 634 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * @typedef {Object} RGB
	 * @property {number} R
	 * @property {number} G
	 * @property {number} B
	 */
	
	/**
	 * @typedef {Object} HSV
	 * @property {number} H
	 * @property {number} S
	 * @property {number} V
	 */
	
	/**
	 *
	 * @param {HSV} hsv
	 * @returns {RGB}
	 */
	var hsv2rgb = exports.hsv2rgb = function hsv2rgb(hsv) {
	  var h = hsv.H / 360 * 6,
	      s = hsv.S / 100,
	      v = hsv.V / 100;
	
	  var i = Math.floor(h),
	      f = h - i,
	      p = v * (1 - s),
	      q = v * (1 - f * s),
	      t = v * (1 - (1 - f) * s),
	      mod = i % 6,
	      r = [v, q, p, p, t, v][mod],
	      g = [t, v, v, q, p, p][mod],
	      b = [p, p, t, v, v, q][mod];
	
	  return {
	    R: Math.round(r * 255),
	    G: Math.round(g * 255),
	    B: Math.round(b * 255)
	  };
	};
	
	/**
	 *
	 * @param {RGB} rgb
	 * @returns {string}
	 */
	var rgb2html = exports.rgb2html = function rgb2html(rgb) {
	  return '#' + rgb.R.toString(16) + rgb.G.toString(16) + rgb.B.toString(16);
	};
	
	/**
	 *
	 * @param {number} from
	 * @param {number} to
	 * @param {number} x
	 * @returns {number}
	 */
	var linear = exports.linear = function linear(from, to, x) {
	  return from + (to - from) * x;
	};
	
	/**
	 *
	 * @param {HSV} color1
	 * @param {HSV} color2
	 * @param {number} x
	 * @returns {HSV}
	 */
	var interpolateHSV = exports.interpolateHSV = function interpolateHSV(color1, color2, x) {
	  return {
	    H: Math.round(linear(color1.H, color2.H, x)),
	    S: Math.round(linear(color1.S, color2.S, x)),
	    V: Math.round(linear(color1.V, color2.V, x))
	  };
	};
	
	/**
	 *
	 * @param {string} hex
	 * @param {number} [lum=0]
	 * @return {string}
	 */
	var colorLuminance = exports.colorLuminance = function colorLuminance(hex) {
	  var lum = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	  // validate hex string
	  var validHex = String(hex).replace(/[^0-9a-f]/gi, '');
	
	  if (validHex.length < 6) {
	    validHex = validHex[0] + validHex[0] + validHex[1] + validHex[1] + validHex[2] + validHex[2];
	  }
	
	  // convert to decimal and change luminosity
	  var rgb = '#',
	      c = void 0,
	      i = void 0;
	
	  for (i = 0; i < 3; i++) {
	    c = parseInt(validHex.substr(i * 2, 2), 16);
	    c = Math.round(Math.min(Math.max(0, c + c * lum), 255)).toString(16);
	    rgb += ('00' + c).substr(c.length);
	  }
	
	  return rgb;
	};

/***/ }),
/* 635 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var CARD_CHANNEL = exports.CARD_CHANNEL = '__reactackle-card__';
	var APP_CHANNEL = exports.APP_CHANNEL = '__reactackle-app__';

/***/ }),
/* 636 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var removeQuotes = function removeQuotes(string) {
	  var unquotedString = void 0,
	      matchRegExp = /^"(.*)"$/;
	  if (typeof string === 'string' || string instanceof String) {
	    if (string.indexOf("'") > -1 // safari workaround
	    ) matchRegExp = /^'(.*)'$/;
	    unquotedString = string.match(matchRegExp)[1].replace(/`/g, '"');
	  }
	
	  return unquotedString;
	};
	
	var getSassConstants = exports.getSassConstants = function getSassConstants() {
	  if (window.getComputedStyle && window.getComputedStyle(document.body, '::before')) {
	    var style = window.getComputedStyle(document.body, '::before');
	    if (style && style.content) return JSON.parse(removeQuotes(style.content));else return {};
	  }
	
	  return {};
	};

/***/ }),
/* 637 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// touchevents
	var isTouchDeviceCachedValue = null;
	var isTouch = exports.isTouch = function isTouch() {
	  if (isTouchDeviceCachedValue !== null) return isTouchDeviceCachedValue;
	
	  isTouchDeviceCachedValue = navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0 || typeof document.body.ongesturestart === 'function';
	
	  return isTouchDeviceCachedValue;
	};

/***/ }),
/* 638 */
362,
/* 639 */
[944, 638],
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactPortal = __webpack_require__(190);
	
	var _reactackleCore = __webpack_require__(3);
	
	var _DialogHeading = __webpack_require__(215);
	
	var _DialogCloseButton = __webpack_require__(650);
	
	var _DialogContent = __webpack_require__(213);
	
	var _DialogButton = __webpack_require__(647);
	
	var _DialogActions = __webpack_require__(212);
	
	var _ModalStyled = __webpack_require__(666);
	
	var _BackdropStyled = __webpack_require__(664);
	
	var _OverflowWrapperStyled = __webpack_require__(667);
	
	var _RegionMainStyled = __webpack_require__(668);
	
	var _RegionSideStyled = __webpack_require__(669);
	
	var _ContentWrapperStyled = __webpack_require__(665);
	
	var _theme = __webpack_require__(670);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	(0, _reactackleCore.registerDefaultComponentTheme)('dialog', _theme2.default);
	
	var ButtonType = _propTypes2.default.shape(_extends({}, _DialogButton.DialogButton.propTypes, {
	  id: _propTypes2.default.number
	}));
	
	var propTypes = {
	  /**
	   * Determine whether to render backdrop
	   */
	  backdrop: _propTypes2.default.bool,
	  /**
	   * If set to true, the content of the Dialog will be scrollable
	   */
	  scrollable: _propTypes2.default.bool,
	  /**
	   * Determine whether to render dialog
	   */
	  open: _propTypes2.default.bool,
	  /**
	   * Determine whether to render close button
	   */
	  haveCloseButton: _propTypes2.default.bool,
	  /**
	   * Determine whether to close dialog on ESC key down
	   */
	  closeOnEscape: _propTypes2.default.bool,
	  /**
	   * Determine whether to close dialog on backdrop click
	   */
	  closeOnBackdropClick: _propTypes2.default.bool,
	  /**
	   * Title of the dialog
	   */
	  title: _propTypes2.default.string,
	  /**
	   * Subtitle of the dialog
	   */
	  subtitle: _propTypes2.default.string,
	  /**
	   * Buttons of the left side of the dialog
	   */
	  buttonsLeft: _propTypes2.default.arrayOf(ButtonType),
	  /**
	   * Buttons of the right side of the dialog
	   */
	  buttons: _propTypes2.default.arrayOf(ButtonType),
	  /**
	   * Minimum width of the dialog
	   */
	  minWidth: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  /**
	   * Padding size in the dialog
	   */
	  paddingSize: _propTypes2.default.oneOf(['none', 'default']),
	  /**
	   * Determine whether to render dialog in full window size
	   */
	  fullWindowSize: _propTypes2.default.bool,
	  /**
	   * Determine whether to render dialog with transparent background
	   */
	  transparentBg: _propTypes2.default.bool,
	  /**
	   * Determine whether to display dialog content in flex mode
	   */
	  dialogContentFlex: _propTypes2.default.bool,
	  /**
	   * Dialog aside element
	   */
	  regionAside: _propTypes2.default.element,
	  /**
	   * Dialog aside element max width
	   */
	  regionAsideMaxWidth: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  /**
	   * Determine whether to show dialog aside element in dialog
	   */
	  regionAsideShow: _propTypes2.default.bool,
	  /**
	   * @ignore
	   */
	  // eslint-disable-next-line react/require-default-props
	  theme: _propTypes2.default.object,
	  /**
	   * Specify function to call on ENTER key press
	   */
	  onEnterKeyPress: _propTypes2.default.func,
	  /**
	   * Specify function to call on dialog close
	   */
	  onClose: _propTypes2.default.func,
	  /**
	   * Specify function to call just before dialog close
	   */
	  onBeforeClose: _propTypes2.default.func,
	  /**
	   * Determines whether to display already mounted dialog
	   */
	  visible: _propTypes2.default.bool
	};
	
	var defaultProps = {
	  backdrop: false,
	  scrollable: false,
	  open: false,
	  haveCloseButton: false,
	  closeOnEscape: false,
	  closeOnBackdropClick: false,
	  title: '',
	  subtitle: '',
	  buttons: [],
	  buttonsLeft: [],
	  minWidth: 0,
	  paddingSize: 'default',
	  fullWindowSize: false,
	  transparentBg: false,
	  dialogContentFlex: false,
	  regionAside: null,
	  regionAsideMaxWidth: 150,
	  regionAsideShow: false,
	  onEnterKeyPress: _reactackleCore.noop,
	  onClose: _reactackleCore.noop,
	  onBeforeClose: _reactackleCore.noop,
	  visible: true
	};
	
	var ESC = 27,
	    ENTER = 13;
	
	var _Dialog = function (_Component) {
	  _inherits(_Dialog, _Component);
	
	  function _Dialog(props) {
	    _classCallCheck(this, _Dialog);
	
	    var _this = _possibleConstructorReturn(this, (_Dialog.__proto__ || Object.getPrototypeOf(_Dialog)).call(this, props));
	
	    _this.canHaveBackdrop = true;
	    _this._keyboardListened = false;
	    _this._backupBodyStyle = {
	      height: null,
	      overflowY: null
	    };
	
	    _this._handleBackdropClick = _this._handleBackdropClick.bind(_this);
	    _this._handleKeyUp = _this._handleKeyUp.bind(_this);
	    _this._handleDialogClose = _this._handleDialogClose.bind(_this);
	    return _this;
	  }
	
	  _createClass(_Dialog, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._toggleKeyboardListener(this._isVisible());
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this._toggleKeyboardListener(this._isVisible(nextProps));
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this._toggleKeyboardListener(false);
	    }
	  }, {
	    key: '_toggleKeyboardListener',
	    value: function _toggleKeyboardListener(condition) {
	      if (condition && !this._keyboardListened) {
	        this._keyboardListened = true;
	        document.body.addEventListener('keyup', this._handleKeyUp);
	      } else if (!condition && this._keyboardListened) {
	        this._keyboardListened = false;
	        document.body.removeEventListener('keyup', this._handleKeyUp);
	      }
	    }
	  }, {
	    key: '_isVisible',
	    value: function _isVisible() {
	      var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	
	      return source.open && source.visible;
	    }
	  }, {
	    key: '_handleDialogClose',
	    value: function _handleDialogClose() {
	      var willNotClose = this.props.onBeforeClose() === false;
	
	      if (!willNotClose) this.props.onClose();
	    }
	  }, {
	    key: '_handleBackdropClick',
	    value: function _handleBackdropClick() {
	      if (this.props.closeOnBackdropClick) this._handleDialogClose();
	    }
	  }, {
	    key: '_handleKeyUp',
	    value: function _handleKeyUp(event) {
	      if (event.keyCode === ESC && this.props.closeOnEscape) this._handleDialogClose();else if (event.keyCode === ENTER) this.props.onEnterKeyPress(this._handleDialogClose);
	    }
	  }, {
	    key: '_renderCloseButton',
	    value: function _renderCloseButton() {
	      if (!this.props.haveCloseButton) return null;
	
	      return _react2.default.createElement(_DialogCloseButton.DialogCloseButton, {
	        onClick: this._handleDialogClose,
	        transparentBg: this.props.transparentBg
	      });
	    }
	  }, {
	    key: '_renderRegionAside',
	    value: function _renderRegionAside() {
	      if (!this.props.regionAside) return null;
	
	      return _react2.default.createElement(
	        _RegionSideStyled.RegionSideStyled,
	        { regionAsideMaxWidth: this.props.regionAsideMaxWidth },
	        this.props.regionAside
	      );
	    }
	  }, {
	    key: '_renderButtonsLeft',
	    value: function _renderButtonsLeft() {
	      var _this2 = this;
	
	      if (!this.props.buttonsLeft.length) return null;
	
	      var buttonsLeftList = this.props.buttonsLeft.map(function (button, index) {
	        return _react2.default.createElement(_DialogButton.DialogButton, _extends({}, button, {
	          key: (0, _reactackleCore.getKey)(button, index),
	          onCloseDialog: _this2._handleDialogClose
	        }));
	      });
	
	      return _react2.default.createElement(
	        _DialogActions.DialogActionsRegion,
	        { alignLeft: true },
	        buttonsLeftList
	      );
	    }
	  }, {
	    key: '_renderButtons',
	    value: function _renderButtons() {
	      var _this3 = this;
	
	      if (!this.props.buttons.length) return null;
	
	      var buttonsList = this.props.buttons.map(function (button, index) {
	        return _react2.default.createElement(_DialogButton.DialogButton, _extends({}, button, {
	          key: (0, _reactackleCore.getKey)(button, index),
	          onCloseDialog: _this3._handleDialogClose
	        }));
	      });
	
	      return _react2.default.createElement(
	        _DialogActions.DialogActionsRegion,
	        null,
	        buttonsList
	      );
	    }
	  }, {
	    key: '_renderActions',
	    value: function _renderActions() {
	      if (!this.props.buttons.length && !this.props.buttonsLeft.length) return null;
	
	      var buttonsLeft = this._renderButtonsLeft(),
	          buttons = this._renderButtons();
	
	      return _react2.default.createElement(
	        _DialogActions.DialogActions,
	        null,
	        buttonsLeft,
	        buttons
	      );
	    }
	  }, {
	    key: '_renderBackdrop',
	    value: function _renderBackdrop() {
	      if (!this.canHaveBackdrop || !this.props.backdrop) return null;
	
	      return _react2.default.createElement(_BackdropStyled.BackdropStyled, { onClick: this._handleBackdropClick });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var closeButton = this._renderCloseButton(),
	          regionAside = this._renderRegionAside(),
	          actions = this._renderActions(),
	          backdrop = this._renderBackdrop();
	
	      var followsHeading = !!this.props.title || !!this.props.subtitle,
	          hasRegionAside = this.props.regionAside !== null;
	
	      return !this.props.open ? null : _react2.default.createElement(
	        _reactPortal.Portal,
	        null,
	        _react2.default.createElement(
	          _ModalStyled.ModalStyled,
	          { visible: this.props.visible },
	          backdrop,
	          _react2.default.createElement(
	            _OverflowWrapperStyled.OverflowWrapperStyled,
	            {
	              customMinWidth: this.props.minWidth,
	              hasRegionAside: hasRegionAside,
	              regionAsideMaxWidth: this.props.regionAsideMaxWidth,
	              regionAsideShow: this.props.regionAsideShow
	            },
	            _react2.default.createElement(
	              _ContentWrapperStyled.ContentWrapperStyled,
	              {
	                paddingSize: this.props.paddingSize,
	                fullWindowSize: this.props.fullWindowSize,
	                customMinWidth: this.props.minWidth,
	                hasTransparentBg: this.props.transparentBg,
	                hasRegionAside: hasRegionAside,
	                regionAsideMaxWidth: this.props.regionAsideMaxWidth,
	                regionAsideShow: this.props.regionAsideShow
	              },
	              _react2.default.createElement(
	                _RegionMainStyled.RegionMainStyled,
	                { scrollable: this.props.scrollable },
	                closeButton,
	                _react2.default.createElement(_DialogHeading.DialogHeading, {
	                  title: this.props.title,
	                  subtitle: this.props.subtitle,
	                  paddingSize: this.props.paddingSize,
	                  haveCloseButton: this.props.haveCloseButton
	                }),
	                _react2.default.createElement(
	                  _DialogContent.DialogContent,
	                  {
	                    flex: this.props.dialogContentFlex,
	                    paddingSize: this.props.paddingSize,
	                    scrollable: this.props.scrollable,
	                    followsHeading: followsHeading
	                  },
	                  this.props.children
	                ),
	                actions
	              ),
	              regionAside
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return _Dialog;
	}(_react.Component);
	
	_Dialog.propTypes = propTypes;
	_Dialog.defaultProps = defaultProps;
	_Dialog.displayName = 'Dialog';
	
	exports.default = (0, _reactackleCore.withTheme)(_Dialog);

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = DialogActions;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DialogActionsStyled = __webpack_require__(645);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function DialogActions(props) {
	  return _react2.default.createElement(
	    _DialogActionsStyled.DialogActionsStyled,
	    null,
	    props.children
	  );
	}
	
	DialogActions.displayName = 'DialogActions';

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = DialogActionsRegion;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _DialogActionsRegionStyled = __webpack_require__(644);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  alignLeft: _propTypes2.default.bool
	};
	
	var defaultProps = {
	  alignLeft: false
	};
	
	function DialogActionsRegion(props) {
	  return _react2.default.createElement(
	    _DialogActionsRegionStyled.DialogActionsRegionStyled,
	    { alignLeft: props.alignLeft },
	    props.children
	  );
	}
	
	DialogActionsRegion.propTypes = propTypes;
	DialogActionsRegion.defaultProps = defaultProps;
	DialogActionsRegion.displayName = 'DialogActionsRegion';

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DialogActionsRegion = undefined;
	
	var _DialogActionsRegion = __webpack_require__(642);
	
	var _DialogActionsRegion2 = _interopRequireDefault(_DialogActionsRegion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.DialogActionsRegion = _DialogActionsRegion2.default;

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DialogActionsRegionStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  alignLeft: _propTypes2.default.bool,
	  /**
	   * Define theme
	   * See https://github.com/styled-components/styled-components/blob/master/docs/theming.md
	   * for more information
	   */
	  theme: _propTypes2.default.object
	};
	
	var defaultProps = {
	  alignLeft: false
	};
	
	/** Prop Receivers */
	var align = function align(_ref) {
	  var alignLeft = _ref.alignLeft;
	  return alignLeft ? '\n    text-align: left;\n    justify-content: flex-start;\n  ' : '\n    text-align: right;\n    justify-content: flex-end;\n  ';
	};
	
	var childrenSpacing = function childrenSpacing(_ref2) {
	  var themeFromProvider = _ref2.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var _theme$reactackle$com = theme.reactackle.components.dialog.actionItem,
	      marginX = _theme$reactackle$com.marginX,
	      marginY = _theme$reactackle$com.marginY;
	
	
	  return '\n    & > * {\n      margin: ' + (0, _reactackleCore.getValueString)(marginY) + ' ' + (0, _reactackleCore.getValueString)(marginX) + ';\n    }\n  ';
	};
	
	/** Styles */
	var DialogActionsRegionStyled = exports.DialogActionsRegionStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'DialogActionsRegionStyled'
	})(['flex-grow:1;display:flex;margin:0 !important;', ' ', ';'], align, childrenSpacing);
	
	DialogActionsRegionStyled.propTypes = propTypes;
	DialogActionsRegionStyled.defaultProps = defaultProps;
	DialogActionsRegionStyled.displayName = 'DialogActionsRegionStyled';

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DialogActionsStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * Define theme
	   * See https://github.com/styled-components/styled-components/blob/master/docs/theming.md
	   * for more information
	   */
	  theme: _propTypes2.default.object
	};
	
	var baseProps = function baseProps(_ref) {
	  var themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var _theme$reactackle$com = theme.reactackle.components.dialog.actions,
	      paddingX = _theme$reactackle$com.paddingX,
	      paddingY = _theme$reactackle$com.paddingY;
	  var _theme$reactackle$com2 = theme.reactackle.components.dialog.actionItem,
	      marginX = _theme$reactackle$com2.marginX,
	      marginY = _theme$reactackle$com2.marginY;
	
	
	  var py = typeof paddingY === 'number' && typeof marginY === 'number' ? paddingY - marginY + 'px' : 'calc(' + (0, _reactackleCore.getValueString)(paddingY) + ' - ' + (0, _reactackleCore.getValueString)(marginY) + ')';
	
	  var px = typeof paddingX === 'number' && typeof marginX === 'number' ? paddingX - marginX + 'px' : 'calc(' + (0, _reactackleCore.getValueString)(paddingX) + ' - ' + (0, _reactackleCore.getValueString)(marginX) + ')';
	
	  return '\n    padding: ' + py + ' ' + px + ';\n\n    > * {\n      margin: ' + (0, _reactackleCore.getValueString)(marginX) + ' ' + (0, _reactackleCore.getValueString)(marginY) + ';\n    }\n  ';
	};
	
	var DialogActionsStyled = exports.DialogActionsStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'DialogActionsStyled'
	})(['position:relative;display:flex;justify-content:flex-end;flex-shrink:0;', ';'], baseProps);
	
	DialogActionsStyled.propTypes = propTypes;
	DialogActionsStyled.displayName = 'DialogActionsStyled';

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactackleButton = __webpack_require__(94);
	
	var _reactackleCore = __webpack_require__(3);
	
	var _DialogButtonStyled = __webpack_require__(648);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = _extends({}, _reactackleButton.Button.propTypes, {
	  onCloseDialog: _propTypes2.default.func
	});
	
	var defaultProps = _extends({}, _reactackleButton.Button.defaultProps, {
	  onCloseDialog: _reactackleCore.noop
	});
	
	var DialogButton = function (_Component) {
	  _inherits(DialogButton, _Component);
	
	  function DialogButton(props) {
	    _classCallCheck(this, DialogButton);
	
	    var _this = _possibleConstructorReturn(this, (DialogButton.__proto__ || Object.getPrototypeOf(DialogButton)).call(this, props));
	
	    _this._handleButtonPress = _this._handleButtonPress.bind(_this);
	    return _this;
	  }
	
	  _createClass(DialogButton, [{
	    key: '_handleButtonPress',
	    value: function _handleButtonPress() {
	      this.props.onPress(this.props.onCloseDialog);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _DialogButtonStyled.DialogButtonStyled,
	        null,
	        _react2.default.createElement(_reactackleButton.Button, _extends({}, this.props, { narrow: true, onPress: this._handleButtonPress }))
	      );
	    }
	  }]);
	
	  return DialogButton;
	}(_react.Component);
	
	exports.default = DialogButton;
	
	
	DialogButton.propTypes = propTypes;
	DialogButton.defaultProps = defaultProps;
	DialogButton.displayName = 'DialogButton';

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DialogButton = undefined;
	
	var _DialogButton = __webpack_require__(646);
	
	var _DialogButton2 = _interopRequireDefault(_DialogButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.DialogButton = _DialogButton2.default;

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DialogButtonStyled = undefined;
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DialogButtonStyled = exports.DialogButtonStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'DialogButtonStyled'
	})(['display:flex;flex-shrink:0;']);
	
	DialogButtonStyled.displayName = 'DialogButtonStyled';

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactackleCore = __webpack_require__(3);
	
	var _DialogCloseButtonStyled = __webpack_require__(651);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  transparentBg: _propTypes2.default.bool,
	  onClick: _propTypes2.default.func,
	  // eslint-disable-next-line react/require-default-props
	  theme: _propTypes2.default.object
	};
	
	var defaultProps = {
	  transparentBg: false,
	  onClick: _reactackleCore.noop
	};
	
	var _DialogCloseButton = function _DialogCloseButton(props) {
	  return _react2.default.createElement(
	    _DialogCloseButtonStyled.DialogCloseButtonStyled,
	    {
	      transparentBg: props.transparentBg,
	      onClick: props.onClick
	    },
	    props.theme.reactackle.components.dialog.closeButton.iconElement
	  );
	};
	
	_DialogCloseButton.propTypes = propTypes;
	_DialogCloseButton.defaultProps = defaultProps;
	_DialogCloseButton.displayName = 'DialogCloseButton';
	
	exports.default = (0, _reactackleCore.withTheme)(_DialogCloseButton);

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DialogCloseButton = undefined;
	
	var _DialogCloseButton = __webpack_require__(649);
	
	var _DialogCloseButton2 = _interopRequireDefault(_DialogCloseButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.DialogCloseButton = _DialogCloseButton2.default;

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DialogCloseButtonStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  transparentBg: _propTypes2.default.bool
	};
	
	var defaultProps = {
	  transparentBg: false
	};
	
	/** Prop Receivers */
	var sizeProps = function sizeProps(_ref) {
	  var themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var _theme$reactackle$com = theme.reactackle.components.dialog.closeButton,
	      width = _theme$reactackle$com.width,
	      height = _theme$reactackle$com.height,
	      imgSize = _theme$reactackle$com.imgSize;
	
	
	  return (0, _styledComponents.css)(['     ', ''], (0, _reactackleCore.iconSizeMixin)((0, _reactackleCore.getValueString)(width), (0, _reactackleCore.getValueString)(imgSize || width), (0, _reactackleCore.getValueString)(height || width)));
	};
	
	var styleProps = function styleProps(_ref2) {
	  var themeFromProvider = _ref2.theme,
	      transparentBg = _ref2.transparentBg;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var path = theme.reactackle.components.dialog.closeButton.style,
	      source = transparentBg ? path.modalWithTransparentBg : path;
	
	  return '\n    color: ' + source.color + ';\n    opacity: ' + source.opacity + ';\n\n    &:hover {\n      color: ' + source.hover.color + ';\n      opacity: ' + source.hover.opacity + ';\n    }\n\n    &:focus {\n      color: ' + source.focus.color + ';\n      opacity: ' + source.focus.opacity + ';\n    }\n  ';
	};
	
	/** Styles */
	var DialogCloseButtonStyled = exports.DialogCloseButtonStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'DialogCloseButtonStyled'
	})(['position:absolute;top:0;right:0;display:flex;z-index:9;cursor:pointer;', ' ', ' ', ';'], sizeProps, styleProps, (0, _reactackleCore.transition)('color, opacity'));
	
	DialogCloseButtonStyled.propTypes = propTypes;
	DialogCloseButtonStyled.defaultProps = defaultProps;
	DialogCloseButtonStyled.displayName = 'DialogCloseButtonStyled';

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = DialogContent;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _DialogContentStyled = __webpack_require__(656);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  bordered: _propTypes2.default.bool,
	  flex: _propTypes2.default.bool,
	  scrollable: _propTypes2.default.bool,
	  followsHeading: _propTypes2.default.bool,
	  paddingSize: _propTypes2.default.oneOf(['none', 'default'])
	};
	
	var defaultProps = {
	  bordered: false,
	  flex: false,
	  scrollable: false,
	  followsHeading: false,
	  paddingSize: 'default'
	};
	
	function DialogContent(props) {
	  return _react2.default.createElement(
	    _DialogContentStyled.DialogContentStyled,
	    {
	      bordered: props.bordered,
	      displayFlex: props.flex,
	      paddingSize: props.paddingSize,
	      scrollable: props.scrollable,
	      followsHeading: props.followsHeading
	    },
	    props.children
	  );
	}
	
	DialogContent.propTypes = propTypes;
	DialogContent.defaultProps = defaultProps;
	DialogContent.displayName = 'DialogContent';

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = DialogContentText;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DialogContentTextStyled = __webpack_require__(655);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function DialogContentText(props) {
	  return _react2.default.createElement(
	    _DialogContentTextStyled.DialogContentTextStyled,
	    null,
	    props.children
	  );
	}
	
	DialogContentText.displayName = 'DialogContentText';

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DialogContentText = undefined;
	
	var _DialogContentText = __webpack_require__(653);
	
	var _DialogContentText2 = _interopRequireDefault(_DialogContentText);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.DialogContentText = _DialogContentText2.default;

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DialogContentTextStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * Define theme
	   * See https://github.com/styled-components/styled-components/blob/master/docs/theming.md
	   * for more information
	   */
	  theme: _propTypes2.default.object
	};
	
	/** Prop Receivers */
	var baseProps = function baseProps(_ref) {
	  var themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var _theme$reactackle$com = theme.reactackle.components.dialog.content,
	      fontSize = _theme$reactackle$com.fontSize,
	      lineHeight = _theme$reactackle$com.lineHeight,
	      color = _theme$reactackle$com.color,
	      fontWeight = _theme$reactackle$com.fontWeight,
	      similarTextBlockSpacing = _theme$reactackle$com.similarTextBlockSpacing;
	
	
	  return (0, _styledComponents.css)(['fontSize:', ';line-height:', ';color:', ';font-weight:', ';& + &{margin-top:', ';}'], (0, _reactackleCore.getValueString)(fontSize), lineHeight, color, fontWeight, (0, _reactackleCore.getValueString)(similarTextBlockSpacing));
	};
	
	/** Styles */
	var DialogContentTextStyled = exports.DialogContentTextStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'DialogContentTextStyled'
	})(['margin:0;', ';'], baseProps);
	
	DialogContentTextStyled.propTypes = propTypes;
	DialogContentTextStyled.displayName = 'DialogContentTextStyled';

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DialogContentStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  bordered: _propTypes2.default.bool,
	  scrollable: _propTypes2.default.bool,
	  displayFlex: _propTypes2.default.bool,
	  followsHeading: _propTypes2.default.bool,
	  paddingSize: _propTypes2.default.oneOf(['none', 'default']),
	  /**
	   * Define theme
	   * See https://github.com/styled-components/styled-components/blob/master/docs/theming.md
	   * for more information
	   */
	  theme: _propTypes2.default.object
	};
	
	var defaultProps = {
	  bordered: false,
	  scrollable: false,
	  displayFlex: false,
	  followsHeading: false,
	  paddingSize: 'default'
	};
	
	/** Prop Receivers */
	var baseProps = function baseProps(_ref) {
	  var themeFromProvider = _ref.theme,
	      paddingSize = _ref.paddingSize,
	      followsHeading = _ref.followsHeading,
	      bordered = _ref.bordered,
	      displayFlex = _ref.displayFlex;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var _theme$reactackle$com = theme.reactackle.components.dialog.content,
	      paddingX = _theme$reactackle$com.paddingX,
	      paddingY = _theme$reactackle$com.paddingY,
	      fontSize = _theme$reactackle$com.fontSize,
	      lineHeight = _theme$reactackle$com.lineHeight,
	      color = _theme$reactackle$com.color,
	      fontWeight = _theme$reactackle$com.fontWeight,
	      borderWidth = _theme$reactackle$com.borderWidth,
	      borderColor = _theme$reactackle$com.borderColor;
	
	
	  var py = (0, _reactackleCore.getValueString)(paddingY),
	      px = (0, _reactackleCore.getValueString)(paddingX);
	
	  var padding = paddingSize !== 'none' ? 'padding: ' + py + ' ' + px + ';' : '';
	
	  return (0, _styledComponents.css)(['font-size:', ';line-height:', ';color:', ';font-weight:', ';', ' ', ' & + &{padding-top:0;margin-top:-calc(', ' / 2);}', ' ', ''], (0, _reactackleCore.getValueString)(fontSize), lineHeight, color, fontWeight, padding, followsHeading && 'padding-top: 0;', py, bordered ? 'border-top: ' + (0, _reactackleCore.getValueString)(borderWidth) + ' solid ' + borderColor + ';' : '', displayFlex && 'display: flex;');
	};
	
	var scrollable = function scrollable(_ref2) {
	  var scrollable = _ref2.scrollable;
	  return scrollable ? 'overflow-y: auto;' : '';
	};
	
	/** Styles */
	var DialogContentStyled = exports.DialogContentStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'DialogContentStyled'
	})(['flex-grow:1;position:relative;', ' ', ';'], baseProps, scrollable);
	
	DialogContentStyled.propTypes = propTypes;
	DialogContentStyled.defaultProps = defaultProps;
	DialogContentStyled.displayName = 'DialogContentStyled';

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = DialogHeading;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _DialogTitle = __webpack_require__(214);
	
	var _DialogHeadingStyled = __webpack_require__(662);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  haveCloseButton: _propTypes2.default.bool,
	  title: _propTypes2.default.string,
	  subtitle: _propTypes2.default.string
	};
	
	var defaultProps = {
	  haveCloseButton: false,
	  title: '',
	  subtitle: ''
	};
	
	function DialogHeading(props) {
	  var title = props.title || props.subtitle ? _react2.default.createElement(_DialogTitle.DialogTitle, {
	    haveCloseButton: props.haveCloseButton,
	    title: props.title,
	    subtitle: props.subtitle
	  }) : null;
	
	  return title ? _react2.default.createElement(
	    _DialogHeadingStyled.DialogHeadingStyled,
	    null,
	    title
	  ) : null;
	}
	
	DialogHeading.propTypes = propTypes;
	DialogHeading.defaultProps = defaultProps;
	DialogHeading.displayName = 'DialogHeading';

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = DialogTitle;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _DialogTitleStyled = __webpack_require__(660);
	
	var _DialogTitleTextStyled = __webpack_require__(661);
	
	var _DialogSubtitleTextStyled = __webpack_require__(659);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  haveCloseButton: _propTypes2.default.bool,
	  title: _propTypes2.default.string,
	  subtitle: _propTypes2.default.string,
	  paddingSize: _propTypes2.default.oneOf(['none', 'default'])
	};
	
	var defaultProps = {
	  haveCloseButton: false,
	  title: '',
	  subtitle: '',
	  paddingSize: 'default'
	};
	
	function DialogTitle(props) {
	  var subtitle = props.subtitle ? _react2.default.createElement(
	    _DialogSubtitleTextStyled.DialogSubtitleTextStyled,
	    null,
	    props.subtitle
	  ) : null;
	
	  return _react2.default.createElement(
	    _DialogTitleStyled.DialogTitleStyled,
	    {
	      paddingSize: props.paddingSize,
	      haveCloseButton: props.haveCloseButton
	    },
	    _react2.default.createElement(
	      _DialogTitleTextStyled.DialogTitleTextStyled,
	      null,
	      props.title
	    ),
	    subtitle
	  );
	}
	
	DialogTitle.propTypes = propTypes;
	DialogTitle.defaultProps = defaultProps;
	DialogTitle.displayName = 'DialogTitle';

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DialogSubtitleTextStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * Define theme
	   * See https://github.com/styled-components/styled-components/blob/master/docs/theming.md
	   * for more information
	   */
	  theme: _propTypes2.default.object
	};
	
	/** Prop Receivers */
	var baseProps = function baseProps(_ref) {
	  var themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var _theme$reactackle$com = theme.reactackle.components.dialog.subtitle,
	      fontSize = _theme$reactackle$com.fontSize,
	      lineHeight = _theme$reactackle$com.lineHeight,
	      color = _theme$reactackle$com.color,
	      fontWeight = _theme$reactackle$com.fontWeight,
	      subtitleTitleSpacing = _theme$reactackle$com.subtitleTitleSpacing;
	
	
	  return '\n    font-size: ' + (0, _reactackleCore.getValueString)(fontSize) + ';\n    line-height: ' + lineHeight + ';\n    color: ' + color + ';\n    font-weight: ' + fontWeight + ';\n    margin-top: ' + (0, _reactackleCore.getValueString)(subtitleTitleSpacing) + ';\n  ';
	};
	
	/** Styles */
	var DialogSubtitleTextStyled = exports.DialogSubtitleTextStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'DialogSubtitleTextStyled'
	})(['margin:0;', ';'], baseProps);
	
	DialogSubtitleTextStyled.propTypes = propTypes;
	DialogSubtitleTextStyled.displayName = 'DialogSubtitleTextStyled';

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DialogTitleStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  haveCloseButton: _propTypes2.default.bool,
	  paddingSize: _propTypes2.default.oneOf(['none', 'default']),
	  /**
	   * Define theme
	   * See https://github.com/styled-components/styled-components/blob/master/docs/theming.md
	   * for more information
	   */
	  theme: _propTypes2.default.object
	};
	
	var defaultProps = {
	  haveCloseButton: false,
	  paddingSize: 'default'
	};
	
	/** Prop Receivers */
	var baseProps = function baseProps(_ref) {
	  var themeFromProvider = _ref.theme,
	      paddingSize = _ref.paddingSize,
	      haveCloseButton = _ref.haveCloseButton;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var _theme$reactackle$com = theme.reactackle.components.dialog.title,
	      paddingX = _theme$reactackle$com.paddingX,
	      paddingY = _theme$reactackle$com.paddingY;
	
	
	  var paddingXValue = (0, _reactackleCore.getValueString)(paddingX);
	
	  var width = theme.reactackle.components.dialog.closeButton.width,
	      py = paddingSize !== 'none' ? '' + (0, _reactackleCore.getValueString)(paddingY) : 0,
	      px = paddingSize !== 'none' ? '' + paddingXValue : 0;
	
	
	  var pxRight = haveCloseButton ? 'calc(' + paddingXValue + ' + ' + (0, _reactackleCore.getValueString)(width) + ')' : '' + paddingXValue;
	
	  return '\n    padding: ' + py + ' ' + pxRight + ' ' + py + ' ' + px + ';\n  ';
	};
	
	/** Styles */
	var DialogTitleStyled = exports.DialogTitleStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'DialogTitleStyled'
	})(['display:flex;flex-direction:column;flex-shrink:0;flex-grow:1;', ';'], baseProps);
	
	DialogTitleStyled.propTypes = propTypes;
	DialogTitleStyled.defaultProps = defaultProps;
	DialogTitleStyled.displayName = 'DialogTitleStyled';

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DialogTitleTextStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * Define theme
	   * See https://github.com/styled-components/styled-components/blob/master/docs/theming.md
	   * for more information
	   */
	  theme: _propTypes2.default.object
	};
	
	/** Prop Receivers */
	var baseProps = function baseProps(_ref) {
	  var themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var _theme$reactackle$com = theme.reactackle.components.dialog.title,
	      fontSize = _theme$reactackle$com.fontSize,
	      lineHeight = _theme$reactackle$com.lineHeight,
	      color = _theme$reactackle$com.color,
	      fontWeight = _theme$reactackle$com.fontWeight;
	
	
	  return '\n    font-size: ' + (0, _reactackleCore.getValueString)(fontSize) + ';\n    line-height: ' + lineHeight + ';\n    color: ' + color + ';\n    font-weight: ' + fontWeight + ';\n  ';
	};
	
	/** Styles */
	var DialogTitleTextStyled = exports.DialogTitleTextStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'DialogTitleTextStyled'
	})(['margin:0;', ';'], baseProps);
	
	DialogTitleTextStyled.propTypes = propTypes;
	DialogTitleTextStyled.displayName = 'DialogTitleTextStyled';

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DialogHeadingStyled = undefined;
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DialogHeadingStyled = exports.DialogHeadingStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'DialogHeadingStyled'
	})(['position:relative;flex-shrink:0;']);
	
	DialogHeadingStyled.displayName = 'DialogHeadingStyled';

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Dialog = undefined;
	
	var _DialogActions = __webpack_require__(212);
	
	Object.keys(_DialogActions).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _DialogActions[key];
	    }
	  });
	});
	
	var _DialogContent = __webpack_require__(213);
	
	Object.keys(_DialogContent).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _DialogContent[key];
	    }
	  });
	});
	
	var _DialogHeading = __webpack_require__(215);
	
	Object.keys(_DialogHeading).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _DialogHeading[key];
	    }
	  });
	});
	
	var _Dialog = __webpack_require__(640);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Dialog = _Dialog2.default;

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BackdropStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  theme: _propTypes2.default.object
	};
	
	var baseProps = function baseProps(_ref) {
	  var themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var margin = theme.reactackle.components.dialog.window.margin;
	  var _theme$reactackle$com = theme.reactackle.components.dialog.backdrop,
	      backgroundColor = _theme$reactackle$com.backgroundColor,
	      zIndex = _theme$reactackle$com.zIndex;
	
	
	  return '\n    padding: ' + (0, _reactackleCore.getValueString)(margin) + ';\n    z-index: ' + zIndex + ';\n    background-color: ' + backgroundColor + ';\n    animation: ' + _reactackleCore.animations.fadeIn + ' 300ms ease-in;\n  ';
	};
	
	var BackdropStyled = exports.BackdropStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'BackdropStyled'
	})(['display:block;width:100%;height:100%;position:fixed;top:0;left:0;', ';'], baseProps);
	
	BackdropStyled.propTypes = propTypes;
	BackdropStyled.displayName = 'BackdropStyled';

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ContentWrapperStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  fullWindowSize: _propTypes2.default.bool,
	  scrollable: _propTypes2.default.bool,
	  hasTransparentBg: _propTypes2.default.bool,
	  hasRegionAside: _propTypes2.default.bool,
	  regionAsideMaxWidth: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  regionAsideShow: _propTypes2.default.bool,
	  customMinWidth: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  theme: _propTypes2.default.object
	};
	
	var defaultProps = {
	  fullWindowSize: false,
	  scrollable: false,
	  hasTransparentBg: false,
	  hasRegionAside: false,
	  regionAsideMaxWidth: 150,
	  regionAsideShow: false,
	  customMinWidth: 0
	};
	
	var boxShadow3 = (0, _reactackleCore.boxShadow)(3);
	
	/** Prop Receivers */
	var baseProps = function baseProps(_ref) {
	  var themeFromProvider = _ref.theme,
	      fullWindowSize = _ref.fullWindowSize,
	      scrollable = _ref.scrollable,
	      hasTransparentBg = _ref.hasTransparentBg;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var _theme$reactackle$com = theme.reactackle.components.dialog.window,
	      zIndex = _theme$reactackle$com.zIndex,
	      backgroundColor = _theme$reactackle$com.backgroundColor,
	      margin = _theme$reactackle$com.margin,
	      borderRadius = _theme$reactackle$com.borderRadius;
	
	
	  var dialogBgColor = hasTransparentBg ? 'transparent' : backgroundColor,
	      dialogBorderRadius = hasTransparentBg ? '0' : (0, _reactackleCore.getValueString)(borderRadius);
	
	  return (0, _styledComponents.css)(['z-index:', ';background-color:', ';max-height:calc(100vh - ', ' * 2);border-radius:', ';animation:', ' 300ms ease-in;', ' ', ''], zIndex, dialogBgColor, (0, _reactackleCore.getValueString)(margin), (0, _reactackleCore.getValueString)(dialogBorderRadius), _reactackleCore.animations.fadeIn, scrollable && 'max-height: 100%;', fullWindowSize && '\n      max-width: 100vw;\n      width: 100%;\n      height: 100%;\n      flex-grow: 1;\n    ');
	};
	
	/** Styles */
	var ContentWrapperStyled = exports.ContentWrapperStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'ContentWrapperStyled'
	})(['position:relative;margin:auto;display:flex;width:100%;', ';', ';'], baseProps, boxShadow3);
	
	ContentWrapperStyled.propTypes = propTypes;
	ContentWrapperStyled.defaultProps = defaultProps;
	ContentWrapperStyled.displayName = 'ContentWrapperStyled';

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ModalStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  scrollable: _propTypes2.default.bool
	};
	
	var defaultProps = {
	  scrollable: false
	};
	
	/** Prop Receivers */
	var baseProps = function baseProps(_ref) {
	  var themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var zIndex = theme.reactackle.components.dialog.window.zIndex;
	
	
	  var fontFamily = theme.reactackle.fontFamily[theme.reactackle.body.fontFamily];
	
	  return '\n    z-index: ' + (zIndex + 1) + ';\n    \n    &,\n    & *,\n    *::after,\n    *::before {\n      font-family: ' + fontFamily + ';\n      box-sizing: border-box;\n    }\n  ';
	};
	
	var visible = function visible(_ref2) {
	  var visible = _ref2.visible;
	  return 'display: ' + (visible ? 'flex' : 'none') + ';';
	};
	
	/** Styles */
	var ModalStyled = exports.ModalStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'ModalStyled'
	})(['position:fixed;width:100%;height:100vh;top:0;left:0;justify-content:space-between;align-items:center;display:flex;overflow:hidden;will-change:transform,opacity;', ';', ';', ';'], visible, baseProps, (0, _reactackleCore.transition)('opacity, transform'));
	
	ModalStyled.propTypes = propTypes;
	ModalStyled.defaultProps = defaultProps;
	ModalStyled.displayName = 'ModalStyled';

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.OverflowWrapperStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  regionAsideMaxWidth: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  regionAsideShow: _propTypes2.default.bool,
	  customMinWidth: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  theme: _propTypes2.default.object
	};
	
	var defaultProps = {
	  regionAsideMaxWidth: 150,
	  regionAsideShow: false,
	  customMinWidth: 0
	};
	/** Prop Receivers */
	var baseProps = function baseProps(_ref) {
	  var customMinWidth = _ref.customMinWidth,
	      hasRegionAside = _ref.hasRegionAside,
	      regionAsideMaxWidth = _ref.regionAsideMaxWidth,
	      regionAsideShow = _ref.regionAsideShow,
	      themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var zIndex = theme.reactackle.components.dialog.backdrop.zIndex;
	  var _theme$reactackle$com = theme.reactackle.components.dialog.window,
	      minWidth = _theme$reactackle$com.minWidth,
	      maxWidth = _theme$reactackle$com.maxWidth,
	      margin = _theme$reactackle$com.margin;
	
	
	  var max = (0, _reactackleCore.getValueString)(maxWidth);
	
	  var dialogMinWidth = customMinWidth !== 0 ? (0, _reactackleCore.getValueString)(customMinWidth) : (0, _reactackleCore.getValueString)(minWidth);
	
	  var asideMaxWidth = regionAsideMaxWidth !== 0 ? (0, _reactackleCore.getValueString)(regionAsideMaxWidth) : (0, _reactackleCore.getValueString)(theme.reactackle.components.dialog.sideRegion.maxWidth);
	
	  var windowMaxWidth = hasRegionAside && regionAsideShow ? 'calc(' + max + ' + ' + asideMaxWidth + ')' : max;
	
	  return (0, _styledComponents.css)(['padding:', ';z-index:', ';min-width:', ';max-width:', ';'], (0, _reactackleCore.getValueString)(margin), zIndex + 1, dialogMinWidth, windowMaxWidth);
	};
	
	var fullWindow = function fullWindow(_ref2) {
	  var fullWindowSize = _ref2.fullWindowSize;
	  return fullWindowSize ? '\n    min-height: 100vh;\n    min-width: 100vw;\n    flex-direction: column;\n  ' : '';
	};
	
	/** Styles */
	var OverflowWrapperStyled = exports.OverflowWrapperStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'OverflowWrapperStyled'
	})(['overflow:auto;position:relative;top:0;bottom:0;left:0;right:0;margin:auto;display:flex;align-items:stretch;max-height:100vh;width:100%;', ';', ';'], baseProps, fullWindow);
	
	OverflowWrapperStyled.propTypes = propTypes;
	OverflowWrapperStyled.defaultProps = defaultProps;
	OverflowWrapperStyled.displayName = 'OverflowWrapperStyled';

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.RegionMainStyled = undefined;
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RegionMainStyled = exports.RegionMainStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'RegionMainStyled'
	})(['flex-grow:1;position:relative;display:flex;flex-direction:column;overflow-y:auto;']);
	
	RegionMainStyled.displayName = 'RegionMainStyled';

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.RegionSideStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  regionAsideMaxWidth: _propTypes2.default.number,
	  theme: _propTypes2.default.object
	};
	
	var defaultProps = {
	  regionAsideMaxWidth: null
	};
	
	/** Prop Receivers */
	var baseProps = function baseProps(_ref) {
	  var themeFromProvider = _ref.theme,
	      regionAsideMaxWidth = _ref.regionAsideMaxWidth;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var _theme$reactackle$com = theme.reactackle.components.dialog.sideRegion,
	      backgroundColor = _theme$reactackle$com.backgroundColor,
	      maxWidth = _theme$reactackle$com.maxWidth;
	  var borderRadius = theme.reactackle.components.dialog.window.borderRadius,
	      asideMaxWidthSrc = regionAsideMaxWidth || maxWidth;
	
	
	  return (0, _styledComponents.css)(['background-color:', ';max-width:', ';', ''], backgroundColor, (0, _reactackleCore.getValueString)(asideMaxWidthSrc), (0, _reactackleCore.sideRadius)('right', '' + (0, _reactackleCore.getValueString)(borderRadius)));
	};
	
	/** Styles */
	var RegionSideStyled = exports.RegionSideStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'RegionSideStyled'
	})(['flex-shrink:0;display:flex;align-items:stretch;', ';'], baseProps);
	
	RegionSideStyled.propTypes = propTypes;
	RegionSideStyled.defaultProps = defaultProps;
	RegionSideStyled.displayName = 'RegionSideStyled';

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.dialogConstants = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactackleCore = __webpack_require__(3);
	
	var _reactackleIcons = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dialogConstants = exports.dialogConstants = {
	  paddingX: (0, _reactackleCore.bmodule)(2),
	  paddingY: (0, _reactackleCore.bmodule)(2),
	  paddingYSmall: (0, _reactackleCore.bmodule)(1.5)
	};
	
	exports.default = {
	  window: {
	    minWidth: 280,
	    maxWidth: 640,
	    backgroundColor: _reactackleCore.colorWhite,
	    borderRadius: _reactackleCore.radiusDefault,
	    zIndex: _reactackleCore.zIndexModal,
	    margin: (0, _reactackleCore.bmodule)(1)
	  },
	
	  sideRegion: {
	    backgroundColor: _reactackleCore.colorPaletteGrey200,
	    maxWidth: 320
	  },
	
	  closeButton: {
	    width: 40,
	    height: null,
	    imgSize: 24,
	    iconElement: _react2.default.createElement(_reactackleIcons.IconCross, { size: 'custom', color: 'inherit' }),
	
	    style: {
	      color: _reactackleCore.bodyFontColor,
	      opacity: 0.46,
	
	      hover: {
	        color: _reactackleCore.bodyFontColor,
	        opacity: 1
	      },
	
	      focus: {
	        color: _reactackleCore.bodyFontColor,
	        opacity: 0.7
	      },
	
	      modalWithTransparentBg: {
	        color: _reactackleCore.colorWhite,
	        opacity: 0.46,
	
	        hover: {
	          color: _reactackleCore.colorWhite,
	          opacity: 1
	        },
	
	        focus: {
	          color: _reactackleCore.colorWhite,
	          opacity: 0.7
	        }
	      }
	    }
	  },
	
	  title: {
	    paddingX: dialogConstants.paddingX,
	    paddingY: dialogConstants.paddingY,
	    fontSize: _reactackleCore.fontSizeTitle,
	    lineHeight: 1.3,
	    color: _reactackleCore.bodyFontColor,
	    fontWeight: _reactackleCore.fontWeightSemibold
	  },
	
	  subtitle: {
	    subtitleTitleSpacing: (0, _reactackleCore.bmodule)(1),
	    fontSize: _reactackleCore.fontSizeBody,
	    lineHeight: 1.3,
	    color: _reactackleCore.fontColorMedium,
	    fontWeight: _reactackleCore.fontWeightNormal
	  },
	
	  content: {
	    paddingX: dialogConstants.paddingX,
	    paddingY: dialogConstants.paddingY,
	    fontSize: _reactackleCore.fontSizeBody,
	    lineHeight: 1.5,
	    color: _reactackleCore.bodyFontColor,
	    fontWeight: _reactackleCore.fontWeightNormal,
	    similarTextBlockSpacing: (0, _reactackleCore.bmodule)(1),
	
	    borderWidth: 1,
	    borderColor: _reactackleCore.colorBorder
	  },
	
	  actions: {
	    paddingX: dialogConstants.paddingX,
	    paddingY: dialogConstants.paddingY
	  },
	
	  actionItem: {
	    marginX: '0.5em',
	    marginY: (0, _reactackleCore.bmodule)(0.5)
	  },
	
	  backdrop: {
	    backgroundColor: 'rgba(0, 0, 0, 0.9)',
	    zIndex: 1
	  }
	};

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactackleCore = __webpack_require__(3);
	
	var _FormMessageStyled = __webpack_require__(680);
	
	var _theme = __webpack_require__(216);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	(0, _reactackleCore.registerDefaultComponentTheme)('form', _theme2.default);
	
	var propTypes = {
	  /**
	   * Determines error text of the form
	   */
	  errorMessage: _propTypes2.default.string,
	  /**
	   * Specify function that will be called on Form submit
	   */
	  onSubmit: _propTypes2.default.func
	};
	var defaultProps = {
	  errorMessage: '',
	  onSubmit: _reactackleCore.noop
	};
	
	var Form = function (_Component) {
	  _inherits(Form, _Component);
	
	  function Form() {
	    _classCallCheck(this, Form);
	
	    var _this = _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).call(this));
	
	    _this.domNode = null;
	
	    _this._scrollToError = _this._scrollToError.bind(_this);
	    _this._handleSubmit = _this._handleSubmit.bind(_this);
	    _this._saveRef = _this._saveRef.bind(_this);
	    return _this;
	  }
	
	  _createClass(Form, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.errorMessage) this._scrollToError();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (this.props.errorMessage) this._scrollToError();
	    }
	  }, {
	    key: '_scrollToError',
	    value: function _scrollToError() {
	      if (this.domNode) {
	        this.domNode.scrollIntoView({
	          behavior: 'smooth'
	        });
	      }
	    }
	  }, {
	    key: '_saveRef',
	    value: function _saveRef(ref) {
	      this.domNode = ref;
	    }
	  }, {
	    key: '_handleSubmit',
	    value: function _handleSubmit(e) {
	      e.preventDefault();
	      if (this.props.onSubmit) this.props.onSubmit();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          errorMessage = _props.errorMessage,
	          children = _props.children;
	
	      var message = errorMessage ? _react2.default.createElement(
	        _FormMessageStyled.FormMessageStyled,
	        null,
	        errorMessage
	      ) : null;
	
	      return _react2.default.createElement(
	        'form',
	        { ref: this._saveRef, onSubmit: this._handleSubmit },
	        message,
	        children
	      );
	    }
	  }]);
	
	  return Form;
	}(_react.Component);
	
	exports.default = Form;
	
	
	Form.propTypes = propTypes;
	Form.defaultProps = defaultProps;
	Form.displayName = 'Form';

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = FormItem;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactackleCore = __webpack_require__(3);
	
	var _FormItemStyled = __webpack_require__(677);
	
	var _theme = __webpack_require__(678);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _reactackleCore.registerDefaultComponentTheme)('formItem', _theme2.default);
	
	function FormItem(props) {
	  return _react2.default.createElement(
	    _FormItemStyled.FormItemStyled,
	    null,
	    props.children
	  );
	}
	FormItem.displayName = 'FormItem';

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = FormItemLabel;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FormItemLabelStyled = __webpack_require__(675);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function FormItemLabel(props) {
	  return _react2.default.createElement(
	    _FormItemLabelStyled.FormItemLabelStyled,
	    null,
	    props.children
	  );
	}
	
	FormItemLabel.displayName = 'FormItemLabel';

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FormItemLabel = undefined;
	
	var _FormItemLabel = __webpack_require__(673);
	
	var _FormItemLabel2 = _interopRequireDefault(_FormItemLabel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.FormItemLabel = _FormItemLabel2.default;

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FormItemLabelStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * Define theme
	   * See https://github.com/styled-components/styled-components/blob/master/docs/theming.md
	   * for more information
	   */
	  theme: _propTypes2.default.object
	};
	
	/** PROP RECEIVERS */
	var baseProps = function baseProps(_ref) {
	  var themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var _theme$reactackle$com = theme.reactackle.components.formItem.label,
	      color = _theme$reactackle$com.color,
	      fontSize = _theme$reactackle$com.fontSize,
	      lineHeight = _theme$reactackle$com.lineHeight,
	      textTransform = _theme$reactackle$com.textTransform,
	      fontWeight = _theme$reactackle$com.fontWeight,
	      marginBottom = _theme$reactackle$com.marginBottom;
	
	
	  return '\n    color: ' + color + ';\n    font-size: ' + (0, _reactackleCore.getValueString)(fontSize) + ';\n    line-height: ' + lineHeight + ';\n    text-transform: ' + textTransform + ';\n    font-weight: ' + fontWeight + ';\n    margin-bottom: ' + (0, _reactackleCore.getValueString)(marginBottom) + ';\n  ';
	};
	
	/** EXPORT STYLES */
	var FormItemLabelStyled = exports.FormItemLabelStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'FormItemLabelStyled'
	})(['display:flex;flex-direction:column;justify-content:center;user-select:none;', ' ', ';'], baseProps, (0, _reactackleCore.transition)('color'));
	
	FormItemLabelStyled.propTypes = propTypes;
	FormItemLabelStyled.displayName = 'FormItemLabelStyled';

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FormItem = undefined;
	
	var _FormItemLabel = __webpack_require__(674);
	
	Object.keys(_FormItemLabel).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _FormItemLabel[key];
	    }
	  });
	});
	
	var _FormItem = __webpack_require__(672);
	
	var _FormItem2 = _interopRequireDefault(_FormItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.FormItem = _FormItem2.default;

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FormItemStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * Define theme
	   * See https://github.com/styled-components/styled-components/blob/master/docs/theming.md
	   * for more information
	   */
	  theme: _propTypes2.default.object
	};
	
	/** PROP RECEIVERS */
	var baseProps = function baseProps(_ref) {
	  var themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var spacing = theme.reactackle.components.formItem.spacing;
	
	
	  var fontFamily = theme.reactackle.fontFamily[theme.reactackle.body.fontFamily];
	
	  return '\n    input,\n    textarea,\n    button,\n    select {\n      margin-top: 0;\n      margin-bottom: 0;\n    }\n    \n    & + & {\n      margin-top: ' + (0, _reactackleCore.getValueString)(spacing) + ';\n    }\n    \n    &,\n    & *,\n    *::after,\n    *::before {\n      font-family: ' + fontFamily + ';\n      box-sizing: border-box;\n    }\n  ';
	};
	
	/** EXPORT STYLES */
	var FormItemStyled = exports.FormItemStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'FormItemStyled'
	})(['', ';'], baseProps);
	
	FormItemStyled.propTypes = propTypes;
	FormItemStyled.displayName = 'FormItemStyled';

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _color2 = __webpack_require__(682);
	
	var _color3 = _interopRequireDefault(_color2);
	
	var _reactackleCore = __webpack_require__(3);
	
	var _theme = __webpack_require__(216);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  spacing: _theme2.default.gutter,
	
	  label: {
	    fontSize: function fontSize(_ref) {
	      var _fontSize = _ref.fontSize;
	      return _fontSize[-2];
	    },
	    lineHeight: 1,
	    textTransform: 'none',
	    fontWeight: function fontWeight(_ref2) {
	      var _fontWeight = _ref2.fontWeight;
	      return _fontWeight.normal;
	    },
	    marginBottom: _reactackleCore.baseModule,
	    color: function color(_ref3) {
	      var _color = _ref3.color;
	      return (0, _color3.default)(_color.black).lighten(0.54);
	    },
	
	    focus: {
	      color: _theme2.default.themeColor
	    },
	
	    disabled: {
	      color: function color(_ref4) {
	        var fontColor = _ref4.fontColor;
	        return fontColor.medium;
	      }
	    }
	  }
	};

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Form = undefined;
	
	var _FormItem = __webpack_require__(676);
	
	Object.keys(_FormItem).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _FormItem[key];
	    }
	  });
	});
	
	var _Form = __webpack_require__(671);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Form = _Form2.default;

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FormMessageStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * Define theme
	   * See https://github.com/styled-components/styled-components/blob/master/docs/theming.md
	   * for more information
	   */
	  theme: _propTypes2.default.object
	};
	
	/** PROP RECEIVERS */
	var baseProps = function baseProps(_ref) {
	  var themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var _theme$reactackle$com = theme.reactackle.components.form.message,
	      marginBottom = _theme$reactackle$com.marginBottom,
	      fontSize = _theme$reactackle$com.fontSize,
	      lineHeight = _theme$reactackle$com.lineHeight,
	      backgroundColor = _theme$reactackle$com.backgroundColor,
	      color = _theme$reactackle$com.color,
	      paddingY = _theme$reactackle$com.paddingY,
	      paddingX = _theme$reactackle$com.paddingX;
	
	
	  var fontFamily = theme.reactackle.fontFamily[theme.reactackle.body.fontFamily];
	
	  return '\n    font-size: ' + (0, _reactackleCore.getValueString)(fontSize) + ';\n    line-height: ' + lineHeight + ';\n    background-color: ' + backgroundColor + ';\n    color: ' + color + ';\n    padding: ' + (0, _reactackleCore.getValueString)(paddingY) + ' ' + (0, _reactackleCore.getValueString)(paddingX) + ';\n    margin-bottom: ' + (0, _reactackleCore.getValueString)(marginBottom) + ';\n    \n    &,\n    & *,\n    *::after,\n    *::before {\n      font-family: ' + fontFamily + ';\n      box-sizing: border-box;\n    }\n  ';
	};
	
	var errorProps = function errorProps(_ref2) {
	  var themeFromProvider = _ref2.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var _theme$reactackle$com2 = theme.reactackle.components.form.message.error,
	      color = _theme$reactackle$com2.color,
	      backgroundColor = _theme$reactackle$com2.backgroundColor,
	      paddingY = _theme$reactackle$com2.paddingY,
	      paddingX = _theme$reactackle$com2.paddingX;
	
	
	  return '\n    background-color: ' + backgroundColor + ';\n    color: ' + color + ';\n    padding: ' + (0, _reactackleCore.getValueString)(paddingY) + ' ' + (0, _reactackleCore.getValueString)(paddingX) + ';\n  ';
	};
	
	/** EXPORT STYLES */
	var FormMessageStyled = exports.FormMessageStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'FormMessageStyled'
	})(['', ';', ';'], baseProps, errorProps);
	
	FormMessageStyled.propTypes = propTypes;
	FormMessageStyled.displayName = 'FormMessageStyled';

/***/ }),
/* 681 */
362,
/* 682 */
[944, 681],
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Column = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ColumnStyled = __webpack_require__(684);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * Shows how much space takes the column on different screen sizes.
	   * Total number of columns: 12.
	   */
	  size: _propTypes2.default.shape({
	    xsmall: _propTypes2.default.number,
	    small: _propTypes2.default.number,
	    medium: _propTypes2.default.number,
	    large: _propTypes2.default.number,
	    xlarge: _propTypes2.default.number
	  }),
	  /** Set content flow direction */
	  layoutDirection: _propTypes2.default.oneOf(['horizontal', 'vertical']),
	  /**
	   * Set content align along main axis
	   * Main axis for layoutDirection = horizontal equals x-axis,
	   * and for layoutDirection = vertical it equals y-axis
	   */
	  mainAxisAlign: _propTypes2.default.oneOf(['start', 'end', 'center', 'evenSpaceBetween', 'evenSpaceAround']),
	  /**
	   * Set content align along cross axis
	   * Cross axis for layoutDirection = horizontal equals y-axis,
	   * and for layoutDirection = vertical it equals x-axis
	   */
	  crossAxisAlign: _propTypes2.default.oneOf(['start', 'end', 'center', 'stretch', 'baseline']),
	  /**
	   * Shows on which screens block should be centered.
	   * Centering starts from the smallest breakpoint, marked as true, up to
	   * the next breakpoint marked as false.
	   */
	  centered: _propTypes2.default.shape({
	    xsmall: _propTypes2.default.bool,
	    small: _propTypes2.default.bool,
	    medium: _propTypes2.default.bool,
	    large: _propTypes2.default.bool,
	    xlarge: _propTypes2.default.bool
	  }),
	  /** Removes column paddings */
	  collapsed: _propTypes2.default.bool
	};
	
	var defaultProps = {
	  size: { xsmall: 12 },
	  layoutDirection: 'vertical',
	  mainAxisAlign: 'start',
	  crossAxisAlign: 'start',
	  centered: null,
	  collapsed: false
	};
	
	var Column = exports.Column = function Column(props) {
	  return _react2.default.createElement(
	    _ColumnStyled.ColumnStyled,
	    {
	      collapsed: props.collapsed,
	      centered: props.centered,
	      layoutDirection: props.layoutDirection,
	      mainAxisAlign: props.mainAxisAlign,
	      crossAxisAlign: props.crossAxisAlign,
	      size: props.size
	    },
	    props.children
	  );
	};
	
	Column.propTypes = propTypes;
	Column.defaultProps = defaultProps;
	Column.displayName = 'Column';

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ColumnStyled = undefined;
	
	var _templateObject = _taggedTemplateLiteral(['\n        padding-left: ', ';\n        padding-right: ', ';\n      '], ['\n        padding-left: ', ';\n        padding-right: ', ';\n      ']),
	    _templateObject2 = _taggedTemplateLiteral(['\n            margin-left: auto;\n            margin-right: auto;\n          '], ['\n            margin-left: auto;\n            margin-right: auto;\n          ']),
	    _templateObject3 = _taggedTemplateLiteral(['\n            margin-left: 0;\n            margin-right: 0;\n          '], ['\n            margin-left: 0;\n            margin-right: 0;\n          ']),
	    _templateObject4 = _taggedTemplateLiteral(['\n          width:\n            ', ';\n          max-width:\n            ', ';\n        '], ['\n          width:\n            ', ';\n          max-width:\n            ', ';\n        ']);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var propTypes = {
	  /**
	   * Shows how much space takes the column on different screen sizes.
	   * Total number of columns: 12.
	   */
	  size: _propTypes2.default.shape({
	    xsmall: _propTypes2.default.number,
	    small: _propTypes2.default.number,
	    medium: _propTypes2.default.number,
	    large: _propTypes2.default.number,
	    xlarge: _propTypes2.default.number
	  }),
	  /** Set content flow direction */
	  layoutDirection: _propTypes2.default.oneOf(['horizontal', 'vertical']),
	  /** Set content align along horizontal axis */
	  horizontalAlign: _propTypes2.default.oneOf(['start', 'end', 'center', 'space-between', 'space-around']),
	  /** Set content align along vertical axis */
	  verticalAlign: _propTypes2.default.oneOf(['stretch', 'center', 'start', 'end', 'baseline']),
	  /** Removes column paddings */
	  collapsed: _propTypes2.default.bool,
	  /**
	   * Shows on which screens block should be centered.
	   * Centering starts from the smallest breakpoint, marked as true, up to
	   * the next breakpoint marked as false.
	   */
	  centered: _propTypes2.default.shape({
	    xsmall: _propTypes2.default.bool,
	    small: _propTypes2.default.bool,
	    medium: _propTypes2.default.bool,
	    large: _propTypes2.default.bool,
	    xlarge: _propTypes2.default.bool
	  }),
	  /**
	   * Define component theme config
	   * See https://github.com/styled-components/styled-components/blob/master/docs/theming.md
	   * for more information
	   */
	  theme: _propTypes2.default.object
	};
	
	var defaultProps = {
	  size: { xsmall: 12 },
	  layoutDirection: 'vertical',
	  horizontalAlign: 'start',
	  verticalAlign: 'start',
	  collapsed: false,
	  centered: null
	};
	
	/** PROP RECEIVERS */
	var collapsed = function collapsed(_ref) {
	  var collapsed = _ref.collapsed,
	      themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var _theme$reactackle$com = theme.reactackle.components.grid.column,
	      gutterHorizontal = _theme$reactackle$com.gutterHorizontal,
	      breakpoints = _theme$reactackle$com.breakpoints;
	
	
	  var baseGutter = 'calc(' + (0, _reactackleCore.getValueString)(gutterHorizontal) + ' / 2)';
	
	  var paddingScale = breakpoints.map(function (item) {
	    var gutter = 'calc(' + (0, _reactackleCore.getValueString)(item.gutterHorizontal) + ' / 2)';
	
	    return (0, _styledComponents.css)(['', ''], (0, _reactackleCore.media)(item.breakpoint)(_templateObject, gutter, gutter));
	  });
	
	  return collapsed ? '\n      padding-left: 0;\n      padding-right: 0;\n    ' : (0, _styledComponents.css)(['padding-left:', ';padding-right:', ';', ''], baseGutter, baseGutter, paddingScale);
	};
	
	var centered = function centered(_ref2) {
	  var centered = _ref2.centered,
	      themeFromProvider = _ref2.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var mediaQuery = theme.reactackle.breakpoints;
	
	  var breakpoints = Object.keys(centered || {}).map(function (key) {
	    var isBase = key === 'xsmall';
	
	    if (isBase) {
	      return centered[key] ? '\n            margin-left: auto;\n            margin-right: auto;\n          ' : '\n            margin-left: 0;\n            margin-right: 0;\n          ';
	    } else {
	      return centered[key] ? (0, _styledComponents.css)(['     ', ''], (0, _reactackleCore.media)(mediaQuery[key])(_templateObject2)) : (0, _styledComponents.css)(['     ', ''], (0, _reactackleCore.media)(mediaQuery[key])(_templateObject3));
	    }
	  });
	
	  return centered ? breakpoints : null;
	};
	
	var calculateColumnWidth = function calculateColumnWidth(columnsAmount) {
	  var totalColumns = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _reactackleCore.defaultTheme.totalColumns;
	  return columnsAmount / totalColumns * 100 + '%';
	};
	
	var size = function size(_ref3) {
	  var size = _ref3.size,
	      themeFromProvider = _ref3.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var mediaQuery = theme.reactackle.breakpoints;
	
	  var breakpoints = Object.keys(size || {}).map(function (key) {
	    return key === 'xsmall' ? '\n        width:\n          ' + calculateColumnWidth(size[key], theme.reactackle.totalColumns) + ';\n        max-width:\n          ' + calculateColumnWidth(size[key], theme.reactackle.totalColumns) + ';\n      ' : (0, _styledComponents.css)(['', ''], (0, _reactackleCore.media)(mediaQuery[key])(_templateObject4, calculateColumnWidth(size[key], theme.reactackle.totalColumns), calculateColumnWidth(size[key], theme.reactackle.totalColumns)));
	  });
	
	  return size ? breakpoints : null;
	};
	
	var mapMain = {
	  start: 'flex-start',
	  end: 'flex-end',
	  center: 'center',
	  evenSpaceBetween: 'space-between',
	  evenSpaceAround: 'space-around'
	};
	
	var mapCross = {
	  start: 'flex-start',
	  end: 'flex-end',
	  center: 'center',
	  stretch: 'stretch',
	  baseline: 'baseline'
	};
	
	var contentFlow = function contentFlow(_ref4) {
	  var layoutDirection = _ref4.layoutDirection,
	      mainAxisAlign = _ref4.mainAxisAlign,
	      crossAxisAlign = _ref4.crossAxisAlign;
	
	  var flowDirection = layoutDirection === 'horizontal' ? 'row' : 'column';
	
	  return '\n    flex-direction: ' + flowDirection + ';\n    justify-content: ' + mapMain[mainAxisAlign] + ';\n    align-items: ' + mapCross[crossAxisAlign] + ';\n  ';
	};
	
	var base = function base(_ref5) {
	  var themeFromProvider = _ref5.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var fontFamily = theme.reactackle.fontFamily[theme.reactackle.body.fontFamily];
	
	  return '\n    font-family: ' + fontFamily + ';\n    box-sizing: border-box;\n  ';
	};
	
	/** STYLES */
	var ColumnStyled = exports.ColumnStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'ColumnStyled'
	})(['display:flex;flex-shrink:0;position:relative;width:100%;max-width:100%;', ' ', ' ', ' ', ' ', ';'], base, collapsed, centered, size, contentFlow);
	
	ColumnStyled.propTypes = propTypes;
	ColumnStyled.defaultProps = defaultProps;
	ColumnStyled.displayName = 'ColumnStyled';

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Container = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ContainerStyled = __webpack_require__(686);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /** Container will have maximum width and will be centered on screen */
	  boxed: _propTypes2.default.bool,
	  /** Container will occupy all available space */
	  spread: _propTypes2.default.bool
	};
	
	var defaultProps = {
	  boxed: false,
	  spread: false
	};
	
	var Container = exports.Container = function Container(props) {
	  return _react2.default.createElement(
	    _ContainerStyled.ContainerStyled,
	    { boxed: props.boxed, spread: props.spread },
	    props.children
	  );
	};
	
	Container.propTypes = propTypes;
	Container.defaultProps = defaultProps;
	Container.displayName = 'Container';

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ContainerStyled = undefined;
	
	var _templateObject = _taggedTemplateLiteral(['\n      padding:\n        ', ' ', ';\n    '], ['\n      padding:\n        ', ' ', ';\n    ']);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var propTypes = {
	  /** Container will have maximum width and will br centered on screen */
	  boxed: _propTypes2.default.bool,
	  /** Container will occupy all available space */
	  spread: _propTypes2.default.bool /**
	                                   * Define component theme config
	                                   * See https://github.com/styled-components/styled-components/blob/master/docs/theming.md
	                                   * for more information
	                                   */
	  , theme: _propTypes2.default.object
	};
	
	var defaultProps = {
	  boxed: false,
	  spread: false
	};
	
	/** PROP RECEIVERS */
	var padding = function padding(_ref) {
	  var themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var obj = theme.reactackle.components.grid.container.breakpoints;
	
	  var breakpoints = obj.map(function (item) {
	    return (0, _styledComponents.css)(['', ''], (0, _reactackleCore.media)(item.breakpoint)(_templateObject, (0, _reactackleCore.getValueString)(item.paddingY), (0, _reactackleCore.getValueString)(item.paddingX)));
	  });
	
	  var _theme$reactackle$com = theme.reactackle.components.grid.container,
	      paddingY = _theme$reactackle$com.paddingY,
	      paddingX = _theme$reactackle$com.paddingX;
	
	
	  return (0, _styledComponents.css)(['padding:', ' ', ';', ''], (0, _reactackleCore.getValueString)(paddingY), (0, _reactackleCore.getValueString)(paddingX), breakpoints);
	};
	
	var spread = function spread(_ref2) {
	  var spread = _ref2.spread;
	  return spread && 'flex-grow: 1;';
	};
	
	var boxed = function boxed(_ref3) {
	  var boxed = _ref3.boxed,
	      themeFromProvider = _ref3.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  return boxed ? 'max-width:\n        ' + (0, _reactackleCore.getValueString)(theme.reactackle.components.grid.row.maxWidth) + ';' : 'max-width: 100%;';
	};
	
	var base = function base(_ref4) {
	  var themeFromProvider = _ref4.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var fontFamily = theme.reactackle.fontFamily[theme.reactackle.body.fontFamily];
	
	  return '\n    font-family: ' + fontFamily + ';\n    box-sizing: border-box;\n  ';
	};
	
	/** STYLES */
	var ContainerStyled = exports.ContainerStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'ContainerStyled'
	})(['width:100%;margin:0 auto;', ';', ' ', ' ', ' ', ';'], (0, _reactackleCore.transition)('padding'), base, padding, boxed, spread);
	
	ContainerStyled.propTypes = propTypes;
	ContainerStyled.defaultProps = defaultProps;
	ContainerStyled.displayName = 'ContainerStyled';

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FlexRegion = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _FlexRegionStyled = __webpack_require__(688);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /** Container will occupy all available space */
	  spread: _propTypes2.default.bool,
	  /** Set content flow direction */
	  layoutDirection: _propTypes2.default.oneOf(['horizontal', 'vertical'])
	};
	
	var defaultProps = {
	  spread: false,
	  layoutDirection: 'vertical'
	};
	
	var FlexRegion = exports.FlexRegion = function FlexRegion(props) {
	  return _react2.default.createElement(
	    _FlexRegionStyled.FlexRegionStyled,
	    {
	      spread: props.spread,
	      layoutDirection: props.layoutDirection
	    },
	    props.children
	  );
	};
	
	FlexRegion.propTypes = propTypes;
	FlexRegion.defaultProps = defaultProps;
	FlexRegion.displayName = 'FlexRegion';

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FlexRegionStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /** Container will occupy all available space */
	  spread: _propTypes2.default.bool,
	  /** Set content flow direction */
	  layoutDirection: _propTypes2.default.oneOf(['horizontal', 'vertical'])
	};
	
	var defaultProps = {
	  spread: false,
	  layoutDirection: 'vertical'
	};
	
	/** PROP RECEIVERS */
	var contentFlow = function contentFlow(_ref) {
	  var layoutDirection = _ref.layoutDirection;
	
	  var flexDirection = layoutDirection === 'horizontal' ? 'row' : 'column';
	
	  return '\n    flex-direction: ' + flexDirection + ';\n  ';
	};
	
	var spread = function spread(_ref2) {
	  var spread = _ref2.spread;
	  return spread && 'flex-grow: 1;';
	};
	
	var base = function base(_ref3) {
	  var themeFromProvider = _ref3.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var fontFamily = theme.reactackle.fontFamily[theme.reactackle.body.fontFamily];
	
	  return '\n    font-family: ' + fontFamily + ';\n    box-sizing: border-box;\n  ';
	};
	
	/** STYLES */
	var FlexRegionStyled = exports.FlexRegionStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'FlexRegionStyled'
	})(['width:auto;display:flex;', ' ', ' ', ';'], base, spread, contentFlow);
	
	FlexRegionStyled.propTypes = propTypes;
	FlexRegionStyled.defaultProps = defaultProps;
	FlexRegionStyled.displayName = 'FlexRegionStyled';

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PaddingBox = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PaddingBoxStyled = __webpack_require__(690);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /** Set padding size*/
	  paddingSize: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['small', 'medium', 'large']), _propTypes2.default.string]),
	  /**
	   * Remove corresponding paddings
	   */
	  removePadding: _propTypes2.default.oneOf(['none', 'horizontal', 'vertical']),
	  /** Container will occupy all available space */
	  spread: _propTypes2.default.bool
	};
	
	var defaultProps = {
	  paddingSize: 'small',
	  removePadding: 'none',
	  spread: false
	};
	
	var PaddingBox = exports.PaddingBox = function PaddingBox(props) {
	  return _react2.default.createElement(
	    _PaddingBoxStyled.PaddingBoxStyled,
	    {
	      paddingSize: props.paddingSize,
	      removePadding: props.removePadding,
	      spread: props.spread
	    },
	    props.children
	  );
	};
	
	PaddingBox.propTypes = propTypes;
	PaddingBox.defaultProps = defaultProps;
	PaddingBox.displayName = 'PaddingBox';

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PaddingBoxStyled = undefined;
	
	var _templateObject = _taggedTemplateLiteral(['\n          padding-left: ', ';\n          padding-right: ', ';\n        '], ['\n          padding-left: ', ';\n          padding-right: ', ';\n        ']),
	    _templateObject2 = _taggedTemplateLiteral(['\n          padding-top: ', ';\n          padding-bottom: ', ';\n        '], ['\n          padding-top: ', ';\n          padding-bottom: ', ';\n        ']);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var propTypes = {
	  /** Set padding size*/
	  paddingSize: _propTypes2.default.oneOf(['small', 'medium', 'large']),
	  /** Remove corresponding paddings */
	  removePadding: _propTypes2.default.oneOf(['none', 'horizontal', 'vertical']),
	  /** Container will occupy all available space */
	  spread: _propTypes2.default.bool,
	  /**
	   * Define component theme config
	   * See https://github.com/styled-components/styled-components/blob/master/docs/theming.md
	   * for more information
	   */
	  theme: _propTypes2.default.object
	};
	
	var defaultProps = {
	  paddingSize: 'small',
	  removePadding: 'none',
	  spread: false
	};
	
	/** PROP RECEIVERS */
	var padding = function padding(_ref) {
	  var paddingSize = _ref.paddingSize,
	      removePadding = _ref.removePadding,
	      themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var source = theme.reactackle.components.grid.paddingBox[paddingSize];
	  var breakpoints = source.breakpoints;
	
	  var pxScale = removePadding !== 'horizontal' && breakpoints.map(function (item) {
	    return (0, _styledComponents.css)(['', ''], (0, _reactackleCore.media)(item.breakpoint)(_templateObject, (0, _reactackleCore.getValueString)(item.paddingX), (0, _reactackleCore.getValueString)(item.paddingX)));
	  });
	
	  var px = removePadding !== 'horizontal' ? (0, _styledComponents.css)(['padding-left:', ';padding-right:', ';', ''], (0, _reactackleCore.getValueString)(source.paddingX), (0, _reactackleCore.getValueString)(source.paddingX), pxScale) : '\n      padding-left: 0;  \n      padding-right: 0;  \n    ';
	
	  var pyScale = removePadding !== 'vertical' && breakpoints.map(function (item) {
	    return (0, _styledComponents.css)(['', ''], (0, _reactackleCore.media)(item.breakpoint)(_templateObject2, (0, _reactackleCore.getValueString)(item.paddingY), (0, _reactackleCore.getValueString)(item.paddingY)));
	  });
	
	  var py = removePadding !== 'vertical' ? (0, _styledComponents.css)(['padding-top:', ';padding-bottom:', ';', ''], (0, _reactackleCore.getValueString)(source.paddingY), (0, _reactackleCore.getValueString)(source.paddingY), pyScale) : '\n        padding-top: 0;\n        padding-bottom: 0;\n      ';
	
	  return (0, _styledComponents.css)(['', ' ', ''], px, py);
	};
	
	var spread = function spread(_ref2) {
	  var spread = _ref2.spread;
	  return spread && 'flex-grow: 1;';
	};
	
	var base = function base(_ref3) {
	  var themeFromProvider = _ref3.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var fontFamily = theme.reactackle.fontFamily[theme.reactackle.body.fontFamily];
	
	  return '\n    font-family: ' + fontFamily + ';\n    box-sizing: border-box;\n  ';
	};
	
	/** STYLES */
	var PaddingBoxStyled = exports.PaddingBoxStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'PaddingBoxStyled'
	})(['', ' ', ' ', ' ', ';'], (0, _reactackleCore.transition)('padding'), base, padding, spread);
	
	PaddingBoxStyled.propTypes = propTypes;
	PaddingBoxStyled.defaultProps = defaultProps;
	PaddingBoxStyled.displayName = 'PaddingBoxStyled';

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Row = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _RowStyled = __webpack_require__(692);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /** Set content flow direction */
	  layoutDirection: _propTypes2.default.oneOf(['horizontal', 'vertical']),
	  /** Fix row width */
	  fixedWidth: _propTypes2.default.bool,
	  /**
	   * If true, Row will have negative margins to compensate Column gutters
	   */
	  compensateGutter: _propTypes2.default.bool,
	  /** If true, content will wrap */
	  wrapContent: _propTypes2.default.bool,
	  /**
	   * Set size ratio for row
	   * @example Row with expandRatio={2} will take twice more size than Row
	   * with expandRatio={1}
	   */
	  expandRatio: _propTypes2.default.number
	};
	var defaultProps = {
	  layoutDirection: 'horizontal',
	  compensateGutter: false,
	  fixedWidth: false,
	  wrapContent: false,
	  expandRatio: 0.0
	};
	
	var Row = exports.Row = function Row(props) {
	  return _react2.default.createElement(
	    _RowStyled.RowStyled,
	    {
	      style: { flexGrow: props.expandRatio },
	      layoutDirection: props.layoutDirection,
	      compensateGutter: props.compensateGutter,
	      fixedWidth: props.fixedWidth,
	      wrapContent: props.wrapContent,
	      expandRatio: props.expandRatio
	    },
	    props.children
	  );
	};
	
	Row.propTypes = propTypes;
	Row.defaultProps = defaultProps;
	Row.displayName = 'Row';

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.RowStyled = undefined;
	
	var _templateObject = _taggedTemplateLiteral(['\n        margin-left: ', ';\n        margin-right: ', ';\n        width: ', ';\n        max-width: ', ';\n      '], ['\n        margin-left: ', ';\n        margin-right: ', ';\n        width: ', ';\n        max-width: ', ';\n      ']);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var propTypes = {
	  /** Set content flow direction */
	  layoutDirection: _propTypes2.default.oneOf(['horizontal', 'vertical']),
	  /** Fix row width */
	  fixedWidth: _propTypes2.default.bool,
	  /**
	   * If true, Row will have negative margins to compensate Column gutters
	   */
	  compensateGutter: _propTypes2.default.bool,
	  /** If true, content will wrap */
	  wrapContent: _propTypes2.default.bool,
	  /**
	   * Set size ratio for row
	   * @example Row with expandRatio={2} will take twice more size than Row
	   * with expandRatio={1}
	   */
	  expandRatio: _propTypes2.default.number,
	  /**
	   * Define component theme config
	   * See https://github.com/styled-components/styled-components/blob/master/docs/theming.md
	   * for more information
	   */
	  theme: _propTypes2.default.object
	};
	
	var defaultProps = {
	  layoutDirection: 'horizontal',
	  compensateGutter: false,
	  fixedWidth: false,
	  wrapContent: false,
	  expandRatio: 0.0
	};
	
	/** PROP RECEIVERS */
	var width = function width(_ref) {
	  var compensateGutter = _ref.compensateGutter,
	      fixedWidth = _ref.fixedWidth,
	      themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var maxWidth = fixedWidth ? '' + (0, _reactackleCore.getValueString)(theme.reactackle.components.grid.row.maxWidth) : '100%';
	
	  var gutter = (0, _reactackleCore.getValueString)(theme.reactackle.components.grid.column.gutterHorizontal);
	
	  var defaultMargin = 'calc(-' + gutter + ' / 2})',
	      gutterScale = theme.reactackle.components.grid.column.breakpoints;
	
	  var gutteredMaxWidth = 'calc(' + maxWidth + ' - ' + gutter + ')';
	
	  var breakpoints = gutterScale.map(function (item) {
	    var margin = 'calc(-' + (0, _reactackleCore.getValueString)(item.gutterHorizontal) + ' / 2)';
	
	    var width = 'calc(' + maxWidth + ' + ' + (0, _reactackleCore.getValueString)(item.gutterHorizontal) + ')';
	
	    return (0, _styledComponents.css)(['', ''], (0, _reactackleCore.media)(item.breakpoint)(_templateObject, margin, margin, width, width));
	  });
	
	  return compensateGutter ? (0, _styledComponents.css)(['margin-left:', ';margin-right:', ';width:', ';max-width:', ';', ''], defaultMargin, defaultMargin, gutteredMaxWidth, gutteredMaxWidth, breakpoints) : '\n      margin: auto;\n      width: 100%;\n      max-width: ' + maxWidth + ';\n    ';
	};
	
	var contentFlow = function contentFlow(_ref2) {
	  var layoutDirection = _ref2.layoutDirection,
	      wrapContent = _ref2.wrapContent;
	
	  var flexDirection = layoutDirection === 'horizontal' ? 'row' : 'column';
	  var wrap = wrapContent && 'flex-wrap: wrap;';
	
	  return '\n    flex-direction: ' + flexDirection + ';\n    ' + wrap + '\n  ';
	};
	
	var expand = function expand(_ref3) {
	  var expandRatio = _ref3.expandRatio;
	  return 'flex-grow: ' + expandRatio + ';';
	};
	
	var base = function base(_ref4) {
	  var themeFromProvider = _ref4.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var fontFamily = theme.reactackle.fontFamily[theme.reactackle.body.fontFamily];
	
	  return '\n    font-family: ' + fontFamily + ';\n    box-sizing: border-box;\n  ';
	};
	
	/** STYLES */
	var RowStyled = exports.RowStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'RowStyled'
	})(['display:flex;flex-shrink:0;', ' ', ' ', ' ', ';'], base, width, expand, contentFlow);
	
	RowStyled.propTypes = propTypes;
	RowStyled.defaultProps = defaultProps;
	RowStyled.displayName = 'RowStyled';

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Container = __webpack_require__(685);
	
	Object.keys(_Container).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Container[key];
	    }
	  });
	});
	
	var _Column = __webpack_require__(683);
	
	Object.keys(_Column).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Column[key];
	    }
	  });
	});
	
	var _FlexRegion = __webpack_require__(687);
	
	Object.keys(_FlexRegion).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _FlexRegion[key];
	    }
	  });
	});
	
	var _PaddingBox = __webpack_require__(689);
	
	Object.keys(_PaddingBox).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _PaddingBox[key];
	    }
	  });
	});
	
	var _Row = __webpack_require__(691);
	
	Object.keys(_Row).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Row[key];
	    }
	  });
	});
	
	var _reactackleCore = __webpack_require__(3);
	
	var _theme = __webpack_require__(694);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _reactackleCore.registerDefaultComponentTheme)('grid', _theme2.default);

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactackleCore = __webpack_require__(3);
	
	exports.default = {
	  row: {
	    maxWidth: function maxWidth(_ref) {
	      var contentWidth = _ref.contentWidth;
	      return contentWidth;
	    }
	  },
	
	  paddingBox: {
	    small: {
	      paddingY: _reactackleCore.halfBaseModule,
	      paddingX: _reactackleCore.halfBaseModule,
	
	      breakpoints: [{
	        breakpoint: function breakpoint(_ref2) {
	          var breakpoints = _ref2.breakpoints;
	          return breakpoints.medium;
	        },
	        paddingY: _reactackleCore.baseModule,
	        paddingX: _reactackleCore.baseModule
	      }]
	    },
	
	    medium: {
	      paddingY: _reactackleCore.baseModule,
	      paddingX: _reactackleCore.baseModule,
	
	      breakpoints: [{
	        breakpoint: function breakpoint(_ref3) {
	          var breakpoints = _ref3.breakpoints;
	          return breakpoints.medium;
	        },
	        paddingY: _reactackleCore.doubleBaseModule,
	        paddingX: _reactackleCore.doubleBaseModule
	      }]
	    },
	
	    large: {
	      paddingY: _reactackleCore.twoAndHalfBaseModule,
	      paddingX: _reactackleCore.twoAndHalfBaseModule,
	
	      breakpoints: [{
	        breakpoint: function breakpoint(_ref4) {
	          var breakpoints = _ref4.breakpoints;
	          return breakpoints.medium;
	        },
	        paddingY: _reactackleCore.fourBaseModule,
	        paddingX: _reactackleCore.fourBaseModule
	      }]
	    }
	  },
	
	  container: {
	    paddingY: _reactackleCore.baseModule,
	    paddingX: _reactackleCore.baseModule,
	
	    breakpoints: [{
	      breakpoint: function breakpoint(_ref5) {
	        var breakpoints = _ref5.breakpoints;
	        return breakpoints.medium;
	      },
	      paddingY: _reactackleCore.doubleBaseModule,
	      paddingX: _reactackleCore.doubleBaseModule
	    }, {
	      breakpoint: function breakpoint(_ref6) {
	        var breakpoints = _ref6.breakpoints;
	        return breakpoints.large;
	      },
	      paddingY: _reactackleCore.tripleBaseModule,
	      paddingX: _reactackleCore.tripleBaseModule
	    }]
	  },
	
	  column: {
	    gutterHorizontal: _reactackleCore.baseModule,
	    gutterVertical: _reactackleCore.baseModule,
	
	    breakpoints: [{
	      breakpoint: function breakpoint(_ref7) {
	        var breakpoints = _ref7.breakpoints;
	        return breakpoints.medium;
	      },
	      gutterHorizontal: _reactackleCore.doubleBaseModule,
	      gutterVertical: _reactackleCore.doubleBaseModule
	    }, {
	      breakpoint: function breakpoint(_ref8) {
	        var breakpoints = _ref8.breakpoints;
	        return breakpoints.large;
	      },
	      gutterHorizontal: _reactackleCore.tripleBaseModule,
	      gutterVertical: _reactackleCore.tripleBaseModule
	    }]
	  }
	};

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactResizeDetector = __webpack_require__(471);
	
	var _reactResizeDetector2 = _interopRequireDefault(_reactResizeDetector);
	
	var _reactackleCore = __webpack_require__(3);
	
	var _HeaderStyled = __webpack_require__(705);
	
	var _HeaderWrapperStyled = __webpack_require__(706);
	
	var _HeaderContentWrapperStyled = __webpack_require__(704);
	
	var _HeaderBackgroundContainerStyled = __webpack_require__(703);
	
	var _theme = __webpack_require__(707);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	(0, _reactackleCore.registerDefaultComponentTheme)('header', _theme2.default);
	
	var propTypes = {
	  /**
	   * Background image url
	   */
	  backgroundImage: _propTypes2.default.string,
	  /**
	   * Customize header background color
	   */
	  backgroundColor: _propTypes2.default.string,
	  /**
	   * Define header position. Fixed header will be always visible on the screen.
	   */
	  behavior: _propTypes2.default.oneOf(['static', 'fixed']),
	  /**
	   * If true, the header's height will condense to condensedHeaderHeight as the
	   * user scrolls down from the top of the content area.
	   * @type {boolean}
	   * @default false
	   */
	  // eslint-disable-next-line react/no-unused-prop-types
	  condenses: _propTypes2.default.bool,
	  /**
	   * If true, the condensed header is always shown and does not move away.
	   * @type {boolean}
	   * @default false
	   */
	  keepCondensedHeader: _propTypes2.default.bool,
	  /**
	   * The height of the header when it is condensed.
	   * @type {number}
	   * @default 0
	   */
	  condensedHeaderHeight: _propTypes2.default.number,
	  /**
	   * Define header's padding size. 'Blank' means zero paddings.
	   */
	  size: _propTypes2.default.oneOf(['default', 'blank', 'dense']),
	  /**
	   * Specify function to call when Header offset is changed
	   */
	  onChangeOffset: _propTypes2.default.func
	};
	
	var defaultProps = {
	  backgroundImage: '',
	  backgroundColor: '',
	  behavior: 'static',
	  condenses: false,
	  keepCondensedHeader: false,
	  condensedHeaderHeight: 0,
	  size: 'default',
	  onChangeOffset: _reactackleCore.noop
	};
	
	var Header = function (_Component) {
	  _inherits(Header, _Component);
	
	  function Header(props) {
	    _classCallCheck(this, Header);
	
	    var _this = _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).call(this, props));
	
	    _this._scrollListened = false;
	    _this._refHeader = null;
	    _this._refWrapper = null;
	    _this._headerHeight = null;
	    _this._headerOffset = null;
	
	    _this._saveRefHeader = _this._saveRefHeader.bind(_this);
	    _this._saveRefWrapper = _this._saveRefWrapper.bind(_this);
	    _this._handleScroll = _this._handleScroll.bind(_this);
	    _this._applyHeaderStyle = _this._applyHeaderStyle.bind(_this);
	    return _this;
	  }
	
	  _createClass(Header, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _refHeader$getBoundin = this._refHeader.getBoundingClientRect(),
	          width = _refHeader$getBoundin.width;
	
	      var _refWrapper$getBoundi = this._refWrapper.getBoundingClientRect(),
	          height = _refWrapper$getBoundi.height;
	
	      this._applyHeaderStyle({ width: width, height: height });
	      this._toggleScrollListener();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this._toggleScrollListener(this._isCondensed(nextProps));
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this._toggleScrollListener(false);
	    }
	  }, {
	    key: '_isCondensed',
	    value: function _isCondensed() {
	      var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	
	      return source.condenses;
	    }
	  }, {
	    key: '_toggleScrollListener',
	    value: function _toggleScrollListener() {
	      var condition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._isCondensed();
	
	      if (condition && !this._scrollListened) {
	        this._scrollListened = true;
	        window.addEventListener('scroll', this._handleScroll);
	      } else if (!condition && this._scrollListened) {
	        this._scrollListened = false;
	        window.removeEventListener('scroll', this._handleScroll);
	      }
	    }
	  }, {
	    key: '_handleScroll',
	    value: function _handleScroll() {
	      var _props = this.props,
	          condensedHeaderHeight = _props.condensedHeaderHeight,
	          keepCondensedHeader = _props.keepCondensedHeader;
	
	      var finalHeaderOffset = keepCondensedHeader ? this._headerHeight - condensedHeaderHeight : this._headerHeight;
	      var newWindowOffset = window.pageYOffset;
	      var newHeaderOffset = newWindowOffset > finalHeaderOffset ? finalHeaderOffset : newWindowOffset;
	
	      if (this._headerOffset !== newHeaderOffset) {
	        this._applyHeaderStyle({ offset: newHeaderOffset });
	        this.props.onChangeOffset({ offset: newHeaderOffset });
	      }
	    }
	  }, {
	    key: '_applyHeaderStyle',
	    value: function _applyHeaderStyle(_ref) {
	      var height = _ref.height,
	          width = _ref.width,
	          offset = _ref.offset;
	
	      if (!(0, _reactackleCore.isUndef)(height)) {
	        this._headerHeight = height;
	        this._refHeader.style.height = height + 'px';
	      }
	      if (!(0, _reactackleCore.isUndef)(width)) this._refWrapper.style.width = width + 'px';
	      if (!(0, _reactackleCore.isUndef)(offset)) {
	        this._headerOffset = offset;
	        this._refWrapper.style.transform = 'translateY(-' + offset + 'px)';
	      }
	    }
	  }, {
	    key: '_saveRefHeader',
	    value: function _saveRefHeader(ref) {
	      this._refHeader = ref;
	    }
	  }, {
	    key: '_saveRefWrapper',
	    value: function _saveRefWrapper(ref) {
	      this._refWrapper = ref;
	    }
	  }, {
	    key: '_renderInnerBackground',
	    value: function _renderInnerBackground() {
	      var backgroundImage = this.props.backgroundImage;
	
	
	      if (!backgroundImage) return null;
	
	      return _react2.default.createElement(_HeaderBackgroundContainerStyled.HeaderBackgroundContainerStyled, {
	        style: { backgroundImage: 'url(' + backgroundImage + ')' }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          behavior = _props2.behavior,
	          size = _props2.size,
	          backgroundColor = _props2.backgroundColor,
	          children = _props2.children;
	
	      var innerBg = this._renderInnerBackground();
	
	      return _react2.default.createElement(
	        _HeaderStyled.HeaderStyled,
	        {
	          size: size,
	          customBackgroundColor: backgroundColor,
	          innerRef: this._saveRefHeader
	        },
	        _react2.default.createElement(
	          _HeaderWrapperStyled.HeaderWrapperStyled,
	          {
	            innerRef: this._saveRefWrapper,
	            size: size,
	            behavior: behavior,
	            customBackgroundColor: backgroundColor
	          },
	          innerBg,
	          _react2.default.createElement(
	            _HeaderContentWrapperStyled.HeaderContentWrapperStyled,
	            null,
	            children
	          )
	        ),
	        _react2.default.createElement(_reactResizeDetector2.default, {
	          handleWidth: true,
	          onResize: function onResize(width) {
	            return _this2._applyHeaderStyle({ width: width });
	          }
	        })
	      );
	    }
	  }]);
	
	  return Header;
	}(_react.Component);
	
	exports.default = Header;
	
	
	Header.propTypes = propTypes;
	Header.defaultProps = defaultProps;
	Header.displayName = 'Header';

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = HeaderRegion;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _HeaderRegionStyled = __webpack_require__(698);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  spread: _propTypes2.default.bool,
	  horizontalAlign: _propTypes2.default.oneOf(['start', 'end', 'center', 'space-between', 'space-around']),
	  /** Set content align along vertical axis */
	  verticalAlign: _propTypes2.default.oneOf(['stretch', 'center', 'start', 'end', 'baseline']),
	  size: _propTypes2.default.oneOf(['blank', 'dense', 'default'])
	};
	
	var defaultProps = {
	  spread: false,
	  horizontalAlign: 'start',
	  verticalAlign: 'stretch',
	  size: 'default'
	};
	
	function HeaderRegion(props) {
	  return _react2.default.createElement(
	    _HeaderRegionStyled.HeaderRegionStyled,
	    {
	      spread: props.spread,
	      horizontalAlign: props.horizontalAlign,
	      verticalAlign: props.verticalAlign,
	      size: props.size
	    },
	    props.children
	  );
	}
	
	HeaderRegion.propTypes = propTypes;
	HeaderRegion.defaultProps = defaultProps;
	HeaderRegion.displayName = 'HeaderRegion';

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.HeaderRegion = undefined;
	
	var _HeaderRegion = __webpack_require__(696);
	
	var _HeaderRegion2 = _interopRequireDefault(_HeaderRegion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.HeaderRegion = _HeaderRegion2.default;

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.HeaderRegionStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  spread: _propTypes2.default.bool,
	  horizontalAlign: _propTypes2.default.oneOf(['start', 'end', 'center', 'space-between', 'space-around']),
	  verticalAlign: _propTypes2.default.oneOf(['stretch', 'center', 'start', 'end', 'baseline']),
	  size: _propTypes2.default.oneOf(['blank', 'dense', 'default']),
	  theme: _propTypes2.default.object
	};
	
	var defaultProps = {
	  spread: false,
	  horizontalAlign: 'start',
	  verticalAlign: 'stretch',
	  size: 'default'
	};
	
	/** PROP RECEIVERS */
	var sizeProps = function sizeProps(_ref) {
	  var size = _ref.size,
	      themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var source = size === 'default' ? theme.reactackle.components.header.region.size : theme.reactackle.components.header.region.size[size];
	
	  var paddingY = source.paddingY,
	      paddingX = source.paddingX;
	
	
	  return '\n    padding: ' + (0, _reactackleCore.getValueString)(paddingY) + ' ' + (0, _reactackleCore.getValueString)(paddingX) + ';\n\n    &:first-child { padding-left: 0 }\n    &:last-child { padding-right: 0 }\n  ';
	};
	
	var mapMain = {
	  start: 'flex-start',
	  end: 'flex-end',
	  center: 'center',
	  evenSpaceBetween: 'space-between',
	  evenSpaceAround: 'space-around'
	};
	
	var mapCross = {
	  start: 'flex-start',
	  end: 'flex-end',
	  center: 'center',
	  stretch: 'stretch',
	  baseline: 'baseline'
	};
	
	var alignProps = function alignProps(_ref2) {
	  var horizontalAlign = _ref2.horizontalAlign,
	      verticalAlign = _ref2.verticalAlign;
	  return '\n  justify-content: ' + mapMain[horizontalAlign] + ';\n  align-items: ' + mapCross[verticalAlign] + ';\n';
	};
	
	var spread = function spread(_ref3) {
	  var spread = _ref3.spread;
	  return spread ? 'flex-grow: 1;' : '';
	};
	
	/** STYLES */
	var HeaderRegionStyled = exports.HeaderRegionStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'HeaderRegionStyled'
	})(['flex-shrink:0;display:flex;', ' ', ' ', ';'], sizeProps, alignProps, spread);
	
	HeaderRegionStyled.propTypes = propTypes;
	HeaderRegionStyled.defaultProps = defaultProps;
	HeaderRegionStyled.displayName = 'HeaderRegionStyled';

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = HeaderTitle;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _HeaderTitleStyled = __webpack_require__(701);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  colorScheme: _propTypes2.default.oneOf(['light', 'dark']),
	  size: _propTypes2.default.oneOf(['default', 'blank', 'dense'])
	};
	
	var defaultProps = {
	  colorScheme: 'light',
	  size: 'default'
	};
	
	function HeaderTitle(props) {
	  return _react2.default.createElement(
	    _HeaderTitleStyled.HeaderTitleStyled,
	    { colorScheme: props.colorScheme, size: props.size },
	    props.children
	  );
	}
	
	HeaderTitle.propTypes = propTypes;
	HeaderTitle.defaultProps = defaultProps;

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.HeaderTitle = undefined;
	
	var _HeaderTitle = __webpack_require__(699);
	
	var _HeaderTitle2 = _interopRequireDefault(_HeaderTitle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.HeaderTitle = _HeaderTitle2.default;

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.HeaderTitleStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  colorScheme: _propTypes2.default.oneOf(['light', 'dark']),
	  size: _propTypes2.default.oneOf(['default', 'blank', 'dense']),
	  theme: _propTypes2.default.object
	};
	
	var defaultProps = {
	  colorScheme: 'light',
	  size: 'default'
	};
	
	/** PROP RECEIVERS */
	var sizeProps = function sizeProps(_ref) {
	  var themeFromProvider = _ref.theme,
	      size = _ref.size;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var source = size === 'default' ? theme.reactackle.components.header.title.size : theme.reactackle.components.header.title.size[size];
	
	  var fontSize = source.fontSize,
	      fontWeight = source.fontWeight,
	      lineHeight = source.lineHeight,
	      paddingY = source.paddingY,
	      paddingX = source.paddingX;
	
	
	  return '\n    padding: ' + (0, _reactackleCore.getValueString)(paddingY) + ' ' + (0, _reactackleCore.getValueString)(paddingX) + ';\n    font-size: ' + (0, _reactackleCore.getValueString)(fontSize) + ';\n    font-weight: ' + fontWeight + ';\n    line-height: ' + lineHeight + ';\n  ';
	};
	
	var styleProps = function styleProps(_ref2) {
	  var themeFromProvider = _ref2.theme,
	      colorScheme = _ref2.colorScheme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var fontColor = theme.reactackle.components.header.title.fontColor[colorScheme];
	
	  return '\n    color: ' + fontColor + ';\n  ';
	};
	
	/** STYLES */
	var HeaderTitleStyled = exports.HeaderTitleStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'HeaderTitleStyled'
	})(['margin:0;flex-grow:1;user-select:none;cursor:default;', ' ', ';'], sizeProps, styleProps);
	
	HeaderTitleStyled.propTypes = propTypes;
	HeaderTitleStyled.defaultProps = defaultProps;
	HeaderTitleStyled.displayName = 'HeaderTitleStyled';

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Header = undefined;
	
	var _HeaderTitle = __webpack_require__(700);
	
	Object.keys(_HeaderTitle).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _HeaderTitle[key];
	    }
	  });
	});
	
	var _HeaderRegion = __webpack_require__(697);
	
	Object.keys(_HeaderRegion).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _HeaderRegion[key];
	    }
	  });
	});
	
	var _Header = __webpack_require__(695);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Header = _Header2.default;

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.HeaderBackgroundContainerStyled = undefined;
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HeaderBackgroundContainerStyled = exports.HeaderBackgroundContainerStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'HeaderBackgroundContainerStyled'
	})(['position:absolute;width:100%;height:100%;top:0;left:0;z-index:0;background-size:cover;background-position:center;background-repeat:no-repeat;']);
	
	HeaderBackgroundContainerStyled.displayName = 'HeaderBackgroundContainerStyled';

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.HeaderContentWrapperStyled = undefined;
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** STYLES */
	var HeaderContentWrapperStyled = exports.HeaderContentWrapperStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'HeaderContentWrapperStyled'
	})(['flex-grow:1;z-index:1;display:flex;flex-direction:row;']);
	
	HeaderContentWrapperStyled.displayName = 'HeaderContentWrapperStyled';

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.HeaderStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  customBackgroundColor: _propTypes2.default.string,
	  size: _propTypes2.default.oneOf(['default', 'blank', 'dense']),
	  theme: _propTypes2.default.object
	};
	
	var defaultProps = {
	  customBackgroundColor: '',
	  size: 'default'
	};
	
	/** PROP RECEIVERS */
	var sizeProps = function sizeProps(_ref) {
	  var size = _ref.size,
	      themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var source = size !== 'default' ? theme.reactackle.components.header.header.size[size] : theme.reactackle.components.header.header.size;
	
	  return '\n    min-height: ' + (0, _reactackleCore.getValueString)(source.minHeight) + ';\n  ';
	};
	
	var baseProps = function baseProps(_ref2) {
	  var themeFromProvider = _ref2.theme,
	      customBackgroundColor = _ref2.customBackgroundColor;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var _theme$reactackle$com = theme.reactackle.components.header.header,
	      zIndex = _theme$reactackle$com.zIndex,
	      backgroundColor = _theme$reactackle$com.backgroundColor;
	
	
	  var fontFamily = theme.reactackle.fontFamily[theme.reactackle.body.fontFamily];
	
	  var headerBackground = customBackgroundColor || backgroundColor;
	
	  return '\n    background-color: ' + headerBackground + ';\n    z-index: ' + zIndex + ';\n    \n    &,\n    & *,\n    *::after,\n    *::before {\n      font-family: ' + fontFamily + ';\n      box-sizing: border-box;\n    }\n  ';
	};
	
	/** STYLES */
	var HeaderStyled = exports.HeaderStyled = _styledComponents2.default.header.withConfig({
	  displayName: 'HeaderStyled'
	})(['padding:0;position:relative;width:100%;', ';', ';', ';'], baseProps, sizeProps, (0, _reactackleCore.transition)('height'));
	
	HeaderStyled.propTypes = propTypes;
	HeaderStyled.defaultProps = defaultProps;
	HeaderStyled.displayName = 'HeaderStyled';

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.HeaderWrapperStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  customBackgroundColor: _propTypes2.default.string,
	  behavior: _propTypes2.default.oneOf(['static', 'fixed']),
	  width: _propTypes2.default.number,
	  size: _propTypes2.default.oneOf(['default', 'blank', 'dense']),
	  theme: _propTypes2.default.object
	};
	
	var defaultProps = {
	  customBackgroundColor: '',
	  behavior: 'static',
	  size: 'default'
	};
	
	/** PROP RECEIVERS */
	var sizeProps = function sizeProps(_ref) {
	  var size = _ref.size,
	      themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var source = size !== 'default' ? theme.reactackle.components.header.header.size[size] : theme.reactackle.components.header.header.size;
	
	  var paddingY = source.paddingY,
	      paddingX = source.paddingX,
	      minHeight = source.minHeight;
	
	
	  return '\n    min-height: ' + (0, _reactackleCore.getValueString)(minHeight) + ';\n    padding: ' + (0, _reactackleCore.getValueString)(paddingY) + ' ' + (0, _reactackleCore.getValueString)(paddingX) + ';\n  ';
	};
	
	var styleProps = function styleProps(_ref2) {
	  var themeFromProvider = _ref2.theme,
	      customBackgroundColor = _ref2.customBackgroundColor;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var backgroundColor = theme.reactackle.components.header.header.backgroundColor,
	      headerBackground = customBackgroundColor || backgroundColor;
	
	
	  return '\n    background-color: ' + headerBackground + ';\n  ';
	};
	
	var modeProps = function modeProps(_ref3) {
	  var behavior = _ref3.behavior;
	
	  var styles = null;
	
	  if (behavior === 'fixed') {
	    styles = '\n      top: 0;\n      position: fixed;\n      will-change: transform;\n    ';
	  }
	
	  return styles;
	};
	
	/** STYLES */
	var HeaderWrapperStyled = exports.HeaderWrapperStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'HeaderWrapperStyled'
	})(['display:flex;align-items:stretch;flex-grow:1;z-index:1;transform:translateZ(0);', ';', ';', ';', ';'], (0, _reactackleCore.transition)('transform, top, height', '150ms'), sizeProps, styleProps, modeProps);
	
	HeaderWrapperStyled.propTypes = propTypes;
	HeaderWrapperStyled.defaultProps = defaultProps;
	HeaderWrapperStyled.displayName = 'HeaderWrapperStyled';

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactackleCore = __webpack_require__(3);
	
	exports.default = {
	  header: {
	    backgroundColor: _reactackleCore.colorMain,
	    zIndex: _reactackleCore.zIndexNav,
	
	    fontColor: {
	      dark: _reactackleCore.bodyFontColor,
	      light: _reactackleCore.bodyFontColorAlt
	    },
	
	    size: {
	      paddingY: 0,
	      paddingX: _reactackleCore.doubleBaseModule,
	      regionsSpacing: _reactackleCore.doubleBaseModule,
	      fontSize: _reactackleCore.fontSizeBody,
	      minHeight: _reactackleCore.eightBaseModule,
	
	      blank: {
	        paddingY: 0,
	        paddingX: _reactackleCore.doubleBaseModule,
	        regionsSpacing: _reactackleCore.doubleBaseModule,
	        fontSize: _reactackleCore.fontSizeBody,
	        minHeight: 0
	      },
	
	      dense: {
	        paddingY: 0,
	        paddingX: _reactackleCore.doubleBaseModule,
	        regionsSpacing: _reactackleCore.doubleBaseModule,
	        fontSize: _reactackleCore.fontSizeBody,
	        minHeight: _reactackleCore.fiveBaseModule
	      }
	    }
	  },
	
	  region: {
	    size: {
	      paddingY: _reactackleCore.oneAndHalfBaseModule,
	      paddingX: 0,
	
	      blank: {
	        paddingY: 0,
	        paddingX: 0
	      },
	
	      dense: {
	        paddingY: _reactackleCore.halfBaseModule,
	        paddingX: 0
	      }
	    }
	  },
	
	  item: {
	    size: {
	      paddingY: 0,
	      paddingX: _reactackleCore.baseModule,
	
	      blank: {
	        paddingY: 0,
	        paddingX: _reactackleCore.baseModule
	      },
	
	      dense: {
	        paddingY: 0,
	        paddingX: _reactackleCore.baseModule
	      }
	    }
	  },
	
	  title: {
	    fontColor: {
	      dark: _reactackleCore.bodyFontColor,
	      light: _reactackleCore.bodyFontColorAlt
	    },
	
	    size: {
	      fontSize: _reactackleCore.fontSizeTitle,
	      fontWeight: _reactackleCore.fontWeightSemibold,
	      lineHeight: 1.3,
	      paddingY: 0,
	      paddingX: _reactackleCore.baseModule,
	
	      blank: {
	        fontSize: _reactackleCore.fontSizeTitle,
	        fontWeight: _reactackleCore.fontWeightSemibold,
	        lineHeight: 1.3,
	        paddingY: 0,
	        paddingX: _reactackleCore.baseModule
	      },
	
	      dense: {
	        fontSize: _reactackleCore.fontSizeTitle,
	        fontWeight: _reactackleCore.fontWeightSemibold,
	        lineHeight: 1.3,
	        paddingY: 0,
	        paddingX: _reactackleCore.baseModule
	      }
	    }
	  }
	};

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.IconCustom = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _IconCustomStyled = __webpack_require__(710);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//eslint-disable-next-line
	var DEFAULT_ICON_DARK = 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIxLjAuMiwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9ItCh0LvQvtC5XzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCA0OCA0OCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDggNDg7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7b3BhY2l0eTowLjU0O30KCS5zdDF7ZmlsbDpub25lO3N0cm9rZTojMDAwMDAwO3N0cm9rZS13aWR0aDoyO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1saW5lam9pbjpyb3VuZDtzdHJva2UtbWl0ZXJsaW1pdDoxMDt9Cjwvc3R5bGU+CjxnIGNsYXNzPSJzdDAiPgoJPHBvbHlnb24gY2xhc3M9InN0MSIgcG9pbnRzPSIzNCwxNCAxOCwxNCAxOCwzMCAzNCwzMCAJIi8+Cgk8cmVjdCB4PSIxNCIgeT0iMTgiIGNsYXNzPSJzdDEiIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIvPgoJPGc+CgkJPGxpbmUgY2xhc3M9InN0MSIgeDE9IjE0IiB5MT0iMTgiIHgyPSIxOCIgeTI9IjE0Ii8+Cgk8L2c+Cgk8bGluZSBjbGFzcz0ic3QxIiB4MT0iMzQiIHkxPSIzMCIgeDI9IjMwIiB5Mj0iMzQiLz4KCTxnPgoJCTxsaW5lIGNsYXNzPSJzdDEiIHgxPSIzMCIgeTE9IjE4IiB4Mj0iMzQiIHkyPSIxNCIvPgoJPC9nPgo8L2c+Cjwvc3ZnPgo=';
	var DEFAULT_ICON_LIGHT = 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIxLjAuMiwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9ItCh0LvQvtC5XzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCA0OCA0OCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDggNDg7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7b3BhY2l0eTowLjU0O30KCS5zdDF7ZmlsbDpub25lO3N0cm9rZTojRkZGRkZGO3N0cm9rZS13aWR0aDoyO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1saW5lam9pbjpyb3VuZDtzdHJva2UtbWl0ZXJsaW1pdDoxMDt9Cjwvc3R5bGU+CjxnIGNsYXNzPSJzdDAiPgoJPHBvbHlnb24gY2xhc3M9InN0MSIgcG9pbnRzPSIzNCwxNCAxOCwxNCAxOCwzMCAzNCwzMCAJIi8+Cgk8cmVjdCB4PSIxNCIgeT0iMTgiIGNsYXNzPSJzdDEiIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIvPgoJPGc+CgkJPGxpbmUgY2xhc3M9InN0MSIgeDE9IjE0IiB5MT0iMTgiIHgyPSIxOCIgeTI9IjE0Ii8+Cgk8L2c+Cgk8bGluZSBjbGFzcz0ic3QxIiB4MT0iMzQiIHkxPSIzMCIgeDI9IjMwIiB5Mj0iMzQiLz4KCTxnPgoJCTxsaW5lIGNsYXNzPSJzdDEiIHgxPSIzMCIgeTE9IjE4IiB4Mj0iMzQiIHkyPSIxNCIvPgoJPC9nPgo8L2c+Cjwvc3ZnPgo=';
	
	var propTypes = {
	  /** Turns on/off icon's border */
	  border: _propTypes2.default.bool,
	  /** Set icon's border width */
	  borderWidth: _propTypes2.default.number,
	  /** Make icon rounded */
	  rounded: _propTypes2.default.bool,
	  /** Set icon size */
	  size: _propTypes2.default.oneOf(['custom', 'small', 'normal', 'large', 'xlarge']),
	  /** Set icon's color scheme */
	  colorScheme: _propTypes2.default.oneOf(['light', 'dark', 'default']),
	  /** Set exact icon's border color */
	  color: _propTypes2.default.string,
	  /** Set icon's background color */
	  backgroundColor: _propTypes2.default.string,
	  /** Set icon's flipping plane */
	  flip: _propTypes2.default.oneOf(['none', 'horizontal', 'vertical']),
	  /** Rotate icon by some degree */
	  rotate: _propTypes2.default.number,
	  /** Set icon's source */
	  src: _propTypes2.default.string
	};
	
	var defaultProps = {
	  src: '',
	  border: false,
	  borderWidth: 0,
	  rounded: false,
	  size: 'normal',
	  colorScheme: 'default',
	  color: '',
	  backgroundColor: '',
	  flip: 'none',
	  rotate: 0
	};
	
	var IconCustom = exports.IconCustom = function IconCustom(props) {
	  var iconDefault = props.colorScheme === 'light' ? DEFAULT_ICON_LIGHT : DEFAULT_ICON_DARK;
	
	  return _react2.default.createElement(_IconCustomStyled.IconCustomStyled, {
	    border: props.border,
	    borderWidth: props.borderWidth,
	    rounded: props.rounded,
	    sizeKey: props.size,
	    colorScheme: props.colorScheme,
	    customColor: props.color,
	    bgColor: props.backgroundColor,
	    flip: props.flip,
	    rotate: props.rotate,
	    src: props.src || iconDefault
	  });
	};
	
	IconCustom.propTypes = propTypes;
	IconCustom.defaultProps = defaultProps;
	IconCustom.displayName = 'IconCustom';

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.IconCustom = undefined;
	
	var _IconCustom = __webpack_require__(708);
	
	exports.IconCustom = _IconCustom.IconCustom;

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.IconCustomStyled = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	var _iconsPropType = __webpack_require__(134);
	
	var _styleMixins = __webpack_require__(217);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = _extends({}, _iconsPropType.iconsPropType, {
	  /** Set icon's source */
	  src: _propTypes2.default.string
	});
	
	var defaultProps = {
	  src: '',
	  border: false,
	  rounded: false,
	  size: 'normal',
	  colorScheme: 'default',
	  color: '',
	  backgroundColor: '',
	  flip: 'none',
	  rotate: 0
	};
	
	var IconImg = function IconImg(_ref) {
	  var src = _ref.src;
	  return '        \n  background-image: url(\'' + src + '\');\n';
	};
	
	// STYLES
	var IconCustomStyled = exports.IconCustomStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'IconCustomStyled'
	})(['text-align:center;flex-shrink:0;position:relative;background-position:center;background-repeat:no-repeat;box-sizing:border-box;', ';', ';', ';', ';', ';', ';', ';'], (0, _reactackleCore.transition)('background-color, color, opacity'), _styleMixins.sizeProps, _styleMixins.backgroundProps, _styleMixins.border, _styleMixins.borderRadius, _styleMixins.transform, IconImg);
	
	IconCustomStyled.propTypes = propTypes;
	IconCustomStyled.defaultProps = defaultProps;
	IconCustomStyled.displayName = 'IconCustomStyled';

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _IconSvg = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IconArrowBack = function IconArrowBack(props) {
	  return _react2.default.createElement(
	    _IconSvg.IconSvg,
	    props,
	    _react2.default.createElement(
	      'svg',
	      { viewBox: '0 0 24 24' },
	      _react2.default.createElement('polygon', { points: '20,11 8.4,11 13.7,5.7 12.3,4.3 4.6,12 12.3,19.7 13.7,18.3 8.4,13 20,13' })
	    )
	  );
	};
	
	exports.default = IconArrowBack;

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _IconSvg = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IconArrowChevronLeft = function IconArrowChevronLeft(props) {
	  return _react2.default.createElement(
	    _IconSvg.IconSvg,
	    props,
	    _react2.default.createElement(
	      'svg',
	      { viewBox: '0 0 24 24' },
	      _react2.default.createElement('polygon', { points: '13.8,18.2 7.6,12 13.8,5.8 15.2,7.2 10.4,12 15.2,16.8' })
	    )
	  );
	};
	
	exports.default = IconArrowChevronLeft;

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _IconSvg = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IconArrowChevronRight = function IconArrowChevronRight(props) {
	  return _react2.default.createElement(
	    _IconSvg.IconSvg,
	    props,
	    _react2.default.createElement(
	      'svg',
	      { viewBox: '0 0 24 24' },
	      _react2.default.createElement('polygon', { points: '9.7,5.8 8.3,7.2 13.1,12 8.3,16.8 9.7,18.2 15.9,12' })
	    )
	  );
	};
	
	exports.default = IconArrowChevronRight;

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _IconSvg = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IconArrowDropDown = function IconArrowDropDown(props) {
	  return _react2.default.createElement(
	    _IconSvg.IconSvg,
	    props,
	    _react2.default.createElement(
	      'svg',
	      { viewBox: '0 0 24 24' },
	      _react2.default.createElement('path', { d: 'M7,10l5,5l5-5H7z' })
	    )
	  );
	};
	
	exports.default = IconArrowDropDown;

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _IconSvg = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IconArrowForward = function IconArrowForward(props) {
	  return _react2.default.createElement(
	    _IconSvg.IconSvg,
	    props,
	    _react2.default.createElement(
	      'svg',
	      { viewBox: '0 0 24 24' },
	      _react2.default.createElement('polygon', { points: '12.7,4.3 11.3,5.7 16.6,11 5,11 5,13 16.6,13 11.3,18.3 12.7,19.7 20.4,12' })
	    )
	  );
	};
	
	exports.default = IconArrowForward;

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _IconSvg = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IconCheck = function IconCheck(props) {
	  return _react2.default.createElement(
	    _IconSvg.IconSvg,
	    props,
	    _react2.default.createElement(
	      'svg',
	      { viewBox: '0 0 24 24' },
	      _react2.default.createElement('polygon', { points: '9,19.4 3.3,13.7 4.7,12.3 9,16.6 19.8,5.8 21.2,7.2' })
	    )
	  );
	};
	
	exports.default = IconCheck;

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _IconSvg = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IconCross = function IconCross(props) {
	  return _react2.default.createElement(
	    _IconSvg.IconSvg,
	    props,
	    _react2.default.createElement(
	      'svg',
	      { viewBox: '0 0 24 24' },
	      _react2.default.createElement('polygon', { points: '19.2,6.2 17.8,4.8 12,10.6 6.2,4.8 4.8,6.2 10.6,12 4.8,17.8 6.2,19.2 12,13.4 17.8,19.2 19.2,17.8 13.4,12' })
	    )
	  );
	};
	
	exports.default = IconCross;

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _IconSvg = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IconDefault = function IconDefault(props) {
	  return _react2.default.createElement(_IconSvg.IconSvg, props);
	};
	
	exports.default = IconDefault;

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _IconSvg = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IconEye = function IconEye(props) {
	  return _react2.default.createElement(
	    _IconSvg.IconSvg,
	    props,
	    _react2.default.createElement(
	      'svg',
	      { viewBox: '0 0 24 24' },
	      _react2.default.createElement('path', { d: 'M12,4.5C7,4.5,2.7,7.6,1,12c1.7,4.4,6,7.5,11,7.5s9.3-3.1,11-7.5C21.3,7.6,17,4.5,12,4.5z M12,17c-2.8,0-5-2.2-5-5 s2.2-5,5-5s5,2.2,5,5S14.8,17,12,17z M12,9c-1.7,0-3,1.3-3,3s1.3,3,3,3s3-1.3,3-3S13.7,9,12,9z' })
	    )
	  );
	};
	
	exports.default = IconEye;

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _IconSvg = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IconEyeClosed = function IconEyeClosed(props) {
	  return _react2.default.createElement(
	    _IconSvg.IconSvg,
	    props,
	    _react2.default.createElement(
	      'svg',
	      { viewBox: '0 0 24 24' },
	      _react2.default.createElement(
	        'g',
	        null,
	        _react2.default.createElement('path', { d: 'M19.7,7.4L17.1,10c0.2,0.6,0.4,1.3,0.4,2c0,3-2.5,5.5-5.5,5.5c-0.7,0-1.4-0.1-2-0.4l-1.8,1.8c1.2,0.4,2.4,0.6,3.8,0.6 c5,0,9.3-3.1,11-7.5C22.3,10.2,21.2,8.6,19.7,7.4z' }),
	        _react2.default.createElement('path', { d: 'M15.5,12c0-0.1,0-0.2,0-0.3l-3.8,3.8c0.1,0,0.2,0,0.3,0C13.9,15.5,15.5,13.9,15.5,12z' }),
	        _react2.default.createElement('path', { d: 'M19.3,2.3l-3,3C15,4.8,13.6,4.5,12,4.5C7,4.5,2.7,7.6,1,12c0.8,1.9,2,3.6,3.7,4.9l-2.4,2.4l1.4,1.4l17-17L19.3,2.3z M6.5,12C6.5,9,9,6.5,12,6.5c0.9,0,1.7,0.2,2.5,0.6L13,8.6c-0.3-0.1-0.6-0.1-0.9-0.1c-1.9,0-3.5,1.6-3.5,3.5c0,0.3,0,0.7,0.1,1 l-1.5,1.5C6.7,13.7,6.5,12.9,6.5,12z' })
	      )
	    )
	  );
	};
	
	exports.default = IconEyeClosed;

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.IconEyeClosed = exports.IconEye = exports.IconDefault = exports.IconCross = exports.IconCheck = exports.IconArrowForward = exports.IconArrowDropDown = exports.IconArrowChevronRight = exports.IconArrowChevronLeft = exports.IconArrowBack = exports.IconSvg = undefined;
	
	var _IconArrowBack = __webpack_require__(711);
	
	var _IconArrowBack2 = _interopRequireDefault(_IconArrowBack);
	
	var _IconArrowChevronLeft = __webpack_require__(712);
	
	var _IconArrowChevronLeft2 = _interopRequireDefault(_IconArrowChevronLeft);
	
	var _IconArrowChevronRight = __webpack_require__(713);
	
	var _IconArrowChevronRight2 = _interopRequireDefault(_IconArrowChevronRight);
	
	var _IconArrowDropDown = __webpack_require__(714);
	
	var _IconArrowDropDown2 = _interopRequireDefault(_IconArrowDropDown);
	
	var _IconArrowForward = __webpack_require__(715);
	
	var _IconArrowForward2 = _interopRequireDefault(_IconArrowForward);
	
	var _IconCheck = __webpack_require__(716);
	
	var _IconCheck2 = _interopRequireDefault(_IconCheck);
	
	var _IconCross = __webpack_require__(717);
	
	var _IconCross2 = _interopRequireDefault(_IconCross);
	
	var _IconDefault = __webpack_require__(718);
	
	var _IconDefault2 = _interopRequireDefault(_IconDefault);
	
	var _IconEye = __webpack_require__(719);
	
	var _IconEye2 = _interopRequireDefault(_IconEye);
	
	var _IconEyeClosed = __webpack_require__(720);
	
	var _IconEyeClosed2 = _interopRequireDefault(_IconEyeClosed);
	
	var _IconSvg = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.IconSvg = _IconSvg.IconSvg;
	exports.IconArrowBack = _IconArrowBack2.default;
	exports.IconArrowChevronLeft = _IconArrowChevronLeft2.default;
	exports.IconArrowChevronRight = _IconArrowChevronRight2.default;
	exports.IconArrowDropDown = _IconArrowDropDown2.default;
	exports.IconArrowForward = _IconArrowForward2.default;
	exports.IconCheck = _IconCheck2.default;
	exports.IconCross = _IconCross2.default;
	exports.IconDefault = _IconDefault2.default;
	exports.IconEye = _IconEye2.default;
	exports.IconEyeClosed = _IconEyeClosed2.default;

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	var _iconsPropType = __webpack_require__(134);
	
	var _styleMixins = __webpack_require__(217);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = _extends({}, _iconsPropType.iconsPropType);
	
	var defaultProps = {
	  border: false,
	  borderWidth: 0,
	  rounded: false,
	  size: 'normal',
	  colorScheme: 'default',
	  color: '',
	  backgroundColor: '',
	  flip: 'none',
	  rotate: 0
	};
	
	var colorProps = function colorProps(_ref) {
	  var themeFromProvider = _ref.theme,
	      customColor = _ref.customColor,
	      colorScheme = _ref.colorScheme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var iconTheme = theme.reactackle.components.icon;
	  var colorSource = customColor || iconTheme.color[colorScheme];
	
	  return '\n    svg,\n    svg * {\n      fill: ' + colorSource + ';\n    }\n  ';
	};
	
	var IconSvgStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'IconSvgStyled'
	})(['box-sizing:border-box;position:relative;', ';svg{position:absolute;top:50%;left:50%;transform:translate3d(-50%,-50%,0);fill:currentColor;}', ';', ';', ';', ';', ';', '  '], (0, _reactackleCore.transition)('background-color, color, opacity'), _styleMixins.sizeProps, _styleMixins.backgroundProps, colorProps, _styleMixins.border, _styleMixins.borderRadius, _styleMixins.transform);
	
	IconSvgStyled.propTypes = propTypes;
	IconSvgStyled.defaultProps = defaultProps;
	IconSvgStyled.displayName = 'IconStyled';
	
	exports.default = IconSvgStyled;

/***/ }),
/* 723 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var iconStyleMixin = exports.iconStyleMixin = function iconStyleMixin(color) {
	  return "\n  color: " + color + ";\n  border-color: currentColor;\n  \n  svg { fill: currentColor; }\n";
	};

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactackleCore = __webpack_require__(3);
	
	exports.default = {
	  borderWidth: 1,
	  borderRadius: _reactackleCore.radiusDefault,
	
	  color: {
	    default: 'currentColor',
	    light: 'rgba(255, 255, 255, 0.54)',
	    dark: 'rgba(0, 0, 0, 0.54)'
	  },
	
	  size: {
	    small: {
	      borderWidth: 1,
	      height: 18,
	      width: null,
	      imgSize: null,
	      borderedImgSize: null,
	      roundedImgSize: null
	    },
	
	    normal: {
	      borderWidth: 1,
	      height: 24,
	      width: null,
	      imgSize: null,
	      borderedImgSize: null,
	      roundedImgSize: null
	    },
	
	    large: {
	      borderWidth: 2,
	      height: 36,
	      width: null,
	      imgSize: null,
	      borderedImgSize: null,
	      roundedImgSize: null
	    },
	
	    xlarge: {
	      borderWidth: 2,
	      height: 48,
	      width: null,
	      imgSize: null,
	      borderedImgSize: null,
	      roundedImgSize: null
	    }
	  }
	};

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(116);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactackleTextField = __webpack_require__(232);
	
	var _reactackleAutoposition = __webpack_require__(65);
	
	var _reactackleCore = __webpack_require__(3);
	
	var _InputAutocompleteStyled = __webpack_require__(727);
	
	var _OptionsListStyled = __webpack_require__(729);
	
	var _OptionStyled = __webpack_require__(728);
	
	var _theme = __webpack_require__(730);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	(0, _reactackleCore.registerDefaultComponentTheme)('inputAutocomplete', _theme2.default);
	
	var propTypes = _extends({}, _reactackleTextField.TextField.propTypes, {
	  /**
	   * Value of the TextField
	   */
	  value: _propTypes2.default.any,
	  /**
	   * Default value of the TextField
	   */
	  defaultValue: _propTypes2.default.any,
	  /**
	   * Array of options
	   */
	  options: _propTypes2.default.array,
	  /**
	   * Handler for TextField change event
	   */
	  onChange: _propTypes2.default.func,
	  /**
	   * Handler for TextField focus event
	   */
	  onFocus: _propTypes2.default.func,
	  /**
	   * Handler for TextField blur event
	   */
	  onBlur: _propTypes2.default.func,
	  /**
	   * Specify maximum amount of options, visible at the same time without
	   * scrolling
	   */
	  maxOptionsVisible: _propTypes2.default.number,
	  /**
	   * Define boundaries to which the options list will be positioned
	   */
	  wrapper: _propTypes2.default.object
	});
	
	var defaultProps = _extends({}, _reactackleTextField.TextField.defaultProps, {
	  options: [],
	  onChange: _reactackleCore.noop,
	  onFocus: _reactackleCore.noop,
	  onBlur: _reactackleCore.noop,
	  maxOptionsVisible: 5,
	  wrapper: window
	});
	
	var keysInputPropTypes = Object.keys(_reactackleTextField.TextField.propTypes);
	
	var _InputAutocomplete = function (_Component) {
	  _inherits(_InputAutocomplete, _Component);
	
	  function _InputAutocomplete(props) {
	    _classCallCheck(this, _InputAutocomplete);
	
	    var _this = _possibleConstructorReturn(this, (_InputAutocomplete.__proto__ || Object.getPrototypeOf(_InputAutocomplete)).call(this, props));
	
	    _this._optionsInFocus = false;
	    _this._needUpdatePositionOptions = false;
	
	    _this._handleChange = _this._handleChange.bind(_this);
	    _this._handleOptionClick = _this._handleOptionClick.bind(_this);
	    _this._handleFocusInput = _this._handleFocusInput.bind(_this);
	    _this._handleBlurInput = _this._handleBlurInput.bind(_this);
	    _this._handleKeyDown = _this._handleKeyDown.bind(_this);
	    _this._handleOptionMouseEnter = _this._handleOptionMouseEnter.bind(_this);
	    _this._handleOptionMouseLeave = _this._handleOptionMouseLeave.bind(_this);
	    _this._handleUpdatePortal = _this._handleUpdatePortal.bind(_this);
	    _this._saveRefInputWrapper = _this._saveRefInputWrapper.bind(_this);
	    _this._saveRefAutoPosition = _this._saveRefAutoPosition.bind(_this);
	    _this._saveRefInput = _this._saveRefInput.bind(_this);
	    _this._saveOptionsListRef = _this._saveOptionsListRef.bind(_this);
	    // eslint-disable-next-line max-len
	    _this._setScrollPositionByOptionKey = _this._setScrollPositionByOptionKey.bind(_this);
	
	    _this._input = null;
	    _this._autoPosition = null;
	    _this._optionsList = null;
	    _this._optonsRefsByIndex = {};
	
	    var value = (0, _reactackleCore.isUndef)(props.value) ? props.defaultValue : props.value;
	
	    _this.state = {
	      inputRef: null,
	      value: value,
	      highlightedOption: -1,
	      showOptions: false
	    };
	
	    _this.userValue = value;
	    return _this;
	  }
	
	  _createClass(_InputAutocomplete, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.value !== this.props.value) {
	        var newState = {};
	        var needUpdateState = false;
	
	        if ((0, _reactackleCore.isUndef)(nextProps.value)) {
	          newState.value = this.props.value;
	          needUpdateState = true;
	        }
	
	        if (nextProps.options.length) {
	          newState.showOptions = true;
	          needUpdateState = true;
	        }
	
	        if (needUpdateState) this.setState(newState);
	      }
	
	      if (nextProps.options.length !== this.props.options.length) this._needUpdatePositionOptions = true;
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('keydown', this._handleKeyDown, false);
	    }
	  }, {
	    key: '_handleFocusInput',
	    value: function _handleFocusInput() {
	      window.addEventListener('keydown', this._handleKeyDown, false);
	
	      if (this.props.options.length && !this.state.showOptions) {
	        this.setState({
	          showOptions: true
	        });
	      }
	
	      this.props.onFocus();
	    }
	  }, {
	    key: 'focus',
	    value: function focus() {
	      this._input.focus();
	    }
	  }, {
	    key: '_handleBlurInput',
	    value: function _handleBlurInput() {
	      window.removeEventListener('keydown', this._handleKeyDown, false);
	
	      if (!this._optionsInFocus) {
	        this.setState({
	          showOptions: false,
	          highlightedOption: -1
	        });
	      }
	
	      this.props.onBlur();
	    }
	  }, {
	    key: '_handleKeyDown',
	    value: function _handleKeyDown(e) {
	      if (!this.state.showOptions) return;
	
	      if (e.keyCode === _reactackleCore.keyboardCodes.DOWN) {
	        e.preventDefault();
	        this._nextOption();
	      }
	
	      if (e.keyCode === _reactackleCore.keyboardCodes.UP) {
	        e.preventDefault();
	        this._prevOption();
	      }
	
	      if (e.keyCode === _reactackleCore.keyboardCodes.ENTER) {
	        var option = this._getCurrentOption();
	        var newState = {
	          showOptions: false,
	          highlightedOption: -1
	        };
	
	        if (option) {
	          var value = option.value;
	
	
	          this.props.onChange({
	            value: value,
	            option: option,
	            complete: true
	          });
	
	          if ((0, _reactackleCore.isUndef)(this.props.value)) newState.value = value;
	        }
	
	        this.setState(newState);
	      }
	
	      if (e.keyCode === _reactackleCore.keyboardCodes.ESC) {
	        if (this.props.options.length) {
	          this.setState({
	            highlightedOption: -1,
	            showOptions: false
	          });
	
	          this.props.onBlur();
	        }
	      }
	    }
	  }, {
	    key: '_handleChange',
	    value: function _handleChange(_ref) {
	      var value = _ref.value;
	
	      this.userValue = value;
	      this.props.onChange({
	        value: value,
	        option: this._getCurrentOption(),
	        complete: false
	      });
	
	      var newState = {
	        showOptions: !!value
	      };
	
	      if ((0, _reactackleCore.isUndef)(this.props.value)) newState.value = value;
	
	      this.setState(newState);
	    }
	  }, {
	    key: '_handleOptionClick',
	    value: function _handleOptionClick(_ref2) {
	      var nativeEvent = _ref2.nativeEvent;
	      var target = nativeEvent.target,
	          index = target.getAttribute('data-index'),
	          value = this.props.options[index].value;
	
	
	      this._optionsInFocus = false;
	
	      this.props.onChange({
	        value: value,
	        option: this._getCurrentOption(),
	        complete: true
	      });
	
	      var newState = {
	        showOptions: false,
	        highlightedOption: -1
	      };
	
	      if ((0, _reactackleCore.isUndef)(this.props.value)) newState.value = value;
	
	      this.setState(newState);
	    }
	  }, {
	    key: '_handleOptionMouseEnter',
	    value: function _handleOptionMouseEnter(_ref3) {
	      var nativeEvent = _ref3.nativeEvent;
	      var relatedTarget = nativeEvent.relatedTarget,
	          index = relatedTarget.getAttribute('data-index');
	
	
	      this._optionsInFocus = true;
	
	      this.setState({
	        highlightedOption: parseInt(index, 10)
	      });
	    }
	  }, {
	    key: '_handleOptionMouseLeave',
	    value: function _handleOptionMouseLeave() {
	      this._optionsInFocus = false;
	
	      this.setState({
	        highlightedOption: -1
	      });
	    }
	  }, {
	    key: '_handleUpdatePortal',
	    value: function _handleUpdatePortal() {
	      if (this._needUpdatePositionOptions) {
	        this._recalculateOptionsPosition();
	        this._needUpdatePositionOptions = false;
	      }
	    }
	  }, {
	    key: '_getCurrentOption',
	    value: function _getCurrentOption() {
	      return this._getOption(this.state.highlightedOption);
	    }
	  }, {
	    key: '_getOption',
	    value: function _getOption(index) {
	      if (index === -1) return null;
	      return this.props.options[index];
	    }
	  }, {
	    key: '_nextOption',
	    value: function _nextOption() {
	      var index = this.state.highlightedOption + 1;
	
	      if (index > this.props.options.length - 1) index = 0;
	
	      this._highlightOption(index);
	      this._setScrollPositionByOptionKey(index);
	    }
	  }, {
	    key: '_prevOption',
	    value: function _prevOption() {
	      var index = this.state.highlightedOption - 1;
	
	      if (index <= -1) index = this.props.options.length - 1;
	      this._highlightOption(index);
	      this._setScrollPositionByOptionKey(index);
	    }
	  }, {
	    key: '_highlightOption',
	    value: function _highlightOption(index) {
	      var newState = {
	        highlightedOption: index
	      };
	
	      var value = '';
	
	      if (index === -1) value = this.userValue;else value = this.props.options[index].value;
	
	      this.props.onChange({
	        value: value,
	        option: index !== -1 ? this.props.options[index] : null,
	        complete: false
	      });
	
	      if ((0, _reactackleCore.isUndef)(this.props.value)) newState.value = value;
	
	      this.setState(newState);
	    }
	  }, {
	    key: '_recalculateOptionsPosition',
	    value: function _recalculateOptionsPosition() {
	      if (this._autoPosition) this._autoPosition.recalculatePosition();
	    }
	  }, {
	    key: '_saveRefInput',
	    value: function _saveRefInput(ref) {
	      this._input = ref;
	    }
	  }, {
	    key: '_saveRefInputWrapper',
	    value: function _saveRefInputWrapper(inputWrapperRef) {
	      this.setState({ inputWrapperRef: inputWrapperRef });
	    }
	  }, {
	    key: '_saveRefAutoPosition',
	    value: function _saveRefAutoPosition(ref) {
	      this._autoPosition = ref;
	    }
	  }, {
	    key: '_saveOptionsListRef',
	    value: function _saveOptionsListRef(ref) {
	      this._optionsList = ref;
	    }
	  }, {
	    key: '_saveOptionRefByIndex',
	    value: function _saveOptionRefByIndex(index) {
	      var _this2 = this;
	
	      return function (ref) {
	        _this2._optonsRefsByIndex[index] = ref;
	      };
	    }
	  }, {
	    key: '_setScrollPositionByOptionKey',
	    value: function _setScrollPositionByOptionKey(key) {
	      var paddingY = this.props.theme.reactackle.components.inputAutocomplete.optionsList.paddingY;
	      this._optionsList.scrollTop = this._optonsRefsByIndex[key].offsetTop - paddingY;
	    }
	  }, {
	    key: '_renderOptions',
	    value: function _renderOptions() {
	      var _this3 = this;
	
	      if (!this.props.options.length || !this.state.showOptions) return null;
	
	      var options = this.props.options.map(function (option, index) {
	        var key = (0, _reactackleCore.getKey)(option, index);
	
	        return _react2.default.createElement(
	          _OptionStyled.OptionStyled,
	          {
	            key: key,
	            innerRef: _this3._saveOptionRefByIndex(index),
	            'data-index': index,
	            onClick: _this3._handleOptionClick,
	            onMouseEnter: _this3._handleOptionMouseEnter,
	            onMouseLeave: _this3._handleOptionMouseLeave,
	            focused: _this3.state.highlightedOption === index
	          },
	          option.value
	        );
	      });
	
	      return _react2.default.createElement(
	        _reactackleAutoposition.AutoPosition,
	        {
	          wrapper: this.props.wrapper,
	          ref: this._saveRefAutoPosition,
	          parent: this.state.inputWrapperRef,
	          positionX: 'left',
	          positionY: 'bottom',
	          type: 'outer',
	          direction: 'vertical',
	          onUpdate: this._handleUpdatePortal,
	          visible: true
	        },
	        _react2.default.createElement(
	          _OptionsListStyled.OptionsListStyled,
	          {
	            maxLines: this.props.maxOptionsVisible,
	            innerRef: this._saveOptionsListRef
	          },
	          options
	        )
	      );
	    }
	  }, {
	    key: '_renderInput',
	    value: function _renderInput() {
	      var pickProps = (0, _lodash2.default)(this.props, keysInputPropTypes);
	      var value = (0, _reactackleCore.isUndef)(this.props.value) ? this.state.value : this.props.value;
	
	      return _react2.default.createElement(_reactackleTextField.TextField, _extends({}, pickProps, {
	        ref: this._saveRefInput,
	        value: value,
	        onChange: this._handleChange,
	        onFocus: this._handleFocusInput,
	        onBlur: this._handleBlurInput
	      }));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var TextField = this._renderInput(),
	          options = this._renderOptions();
	
	      return _react2.default.createElement(
	        _InputAutocompleteStyled.InputAutocompleteStyled,
	        null,
	        _react2.default.createElement(
	          'div',
	          { ref: this._saveRefInputWrapper },
	          TextField
	        ),
	        options
	      );
	    }
	  }]);
	
	  return _InputAutocomplete;
	}(_react.Component);
	
	_InputAutocomplete.defaultProps = defaultProps;
	_InputAutocomplete.propTypes = propTypes;
	_InputAutocomplete.displayName = 'InputAutocomplete';
	
	var InputAutocomplete = (0, _reactackleCore.withTheme)(_InputAutocomplete);
	InputAutocomplete.withoutHOC = _InputAutocomplete;
	exports.default = InputAutocomplete;

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.InputAutocomplete = undefined;
	
	var _InputAutocomplete = __webpack_require__(725);
	
	var _InputAutocomplete2 = _interopRequireDefault(_InputAutocomplete);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.InputAutocomplete = _InputAutocomplete2.default;

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.InputAutocompleteStyled = undefined;
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var base = function base(_ref) {
	  var themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var fontFamily = theme.reactackle.fontFamily[theme.reactackle.body.fontFamily];
	
	  return '\n    &,\n    & *,\n    *::after,\n    *::before {\n      font-family: ' + fontFamily + ';\n      box-sizing: border-box;\n    }\n  ';
	};
	
	var InputAutocompleteStyled = exports.InputAutocompleteStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'InputAutocompleteStyled'
	})(['position:relative;', ';'], base);
	
	InputAutocompleteStyled.displayName = 'InputAutocompleteStyled';

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.OptionStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  focused: _propTypes2.default.bool,
	  theme: _propTypes2.default.object
	};
	
	var defaultProps = {
	  focused: false
	};
	
	var base = function base(_ref) {
	  var themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var _theme$reactackle$com = theme.reactackle.components.inputAutocomplete.option,
	      fontSize = _theme$reactackle$com.fontSize,
	      lineHeight = _theme$reactackle$com.lineHeight,
	      textTransform = _theme$reactackle$com.textTransform,
	      paddingY = _theme$reactackle$com.paddingY,
	      paddingX = _theme$reactackle$com.paddingX,
	      borderRadius = _theme$reactackle$com.borderRadius;
	
	
	  return '\n    padding: ' + (0, _reactackleCore.getValueString)(paddingY) + ' ' + (0, _reactackleCore.getValueString)(paddingX) + ';\n    border-radius: ' + (0, _reactackleCore.getValueString)(borderRadius) + ';\n    font-size: ' + (0, _reactackleCore.getValueString)(fontSize) + ';\n    line-height: ' + lineHeight + ';\n    text-transform: ' + textTransform + ';\n  ';
	};
	
	var style = function style(_ref2) {
	  var themeFromProvider = _ref2.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var source = theme.reactackle.components.inputAutocomplete.option.style;
	
	  return '\n    color: ' + source.fontColor + ';\n    background-color: ' + source.backgroundColor + ';\n    font-weight: ' + source.fontWeight + ';\n    \n    &:hover {\n      color: ' + source.hover.fontColor + ';\n      background-color: ' + source.hover.backgroundColor + ';\n      font-weight: ' + source.hover.fontWeight + ';\n    }\n    \n    &:focus {\n      color: ' + source.focus.fontColor + ';\n      background-color: ' + source.focus.backgroundColor + ';\n      font-weight: ' + source.focus.fontWeight + ';\n    }    \n  ';
	};
	
	var focused = function focused(_ref3) {
	  var themeFromProvider = _ref3.theme,
	      focused = _ref3.focused;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var source = theme.reactackle.components.inputAutocomplete.option.style;
	
	  return focused ? '\n      color: ' + source.focus.fontColor + ';\n      background-color: ' + source.focus.backgroundColor + ';\n      font-weight: ' + source.focus.fontWeight + ';  \n    ' : '';
	};
	
	var OptionStyled = exports.OptionStyled = _styledComponents2.default.li.withConfig({
	  displayName: 'OptionStyled'
	})(['cursor:pointer;', ';', ';', ';', ';'], base, style, focused, (0, _reactackleCore.transition)('color, background-color'));
	
	OptionStyled.propTypes = propTypes;
	OptionStyled.defaultProps = defaultProps;
	OptionStyled.displayName = 'OptionStyled';

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.OptionsListStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  maxLines: _propTypes2.default.number,
	  theme: _propTypes2.default.object
	};
	
	var defaultProps = {
	  maxLines: 5
	};
	
	var style = function style(_ref) {
	  var themeFromProvider = _ref.theme,
	      maxLines = _ref.maxLines;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var _theme$reactackle$com = theme.reactackle.components.inputAutocomplete.optionsList,
	      backgroundColor = _theme$reactackle$com.backgroundColor,
	      paddingY = _theme$reactackle$com.paddingY,
	      paddingX = _theme$reactackle$com.paddingX,
	      borderRadius = _theme$reactackle$com.borderRadius,
	      minWidth = _theme$reactackle$com.minWidth,
	      maxWidth = _theme$reactackle$com.maxWidth;
	  var _theme$reactackle$com2 = theme.reactackle.components.inputAutocomplete.option,
	      lineHeight = _theme$reactackle$com2.lineHeight,
	      itemPaddingY = _theme$reactackle$com2.paddingY;
	
	
	  var fontFamily = theme.reactackle.fontFamily[theme.reactackle.body.fontFamily];
	
	  var py = (0, _reactackleCore.getValueString)(paddingY),
	      itemPy = (0, _reactackleCore.getValueString)(itemPaddingY),
	      textHeight = lineHeight * maxLines - 1;
	
	  var maxHeight = 'calc(' + py + ' * 2 + ' + textHeight + 'em + ' + itemPy + ' * ' + 2 * maxLines + ')';
	
	  return '\n    padding: ' + py + ' ' + (0, _reactackleCore.getValueString)(paddingX) + ';\n    background-color: ' + backgroundColor + ';\n    border-radius: ' + (0, _reactackleCore.getValueString)(borderRadius) + ';\n    max-height: ' + maxHeight + ';\n    width: 100%;\n    min-width: ' + (0, _reactackleCore.getValueString)(minWidth) + ';\n    max-width: ' + (0, _reactackleCore.getValueString)(maxWidth) + ';\n    animation: ' + _reactackleCore.animations.fadeInDownSmall + ' 150ms ease-in;\n    animation-fill-mode: both;\n    \n    &,\n    & *,\n    *::after,\n    *::before {\n      font-family: ' + fontFamily + ';\n      box-sizing: border-box;\n    }\n  ';
	};
	
	var OptionsListStyled = exports.OptionsListStyled = _styledComponents2.default.ul.withConfig({
	  displayName: 'OptionsListStyled'
	})(['margin:0;list-style-type:none;width:100%;overflow-y:auto;z-index:1;user-select:none;', ';', ';'], style, (0, _reactackleCore.boxShadow)(3));
	
	OptionsListStyled.propTypes = propTypes;
	OptionsListStyled.defaultProps = defaultProps;
	OptionsListStyled.displayName = 'OptionsListStyled';

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactackleCore = __webpack_require__(3);
	
	exports.default = {
	  optionsList: {
	    backgroundColor: _reactackleCore.colorWhite,
	    paddingY: _reactackleCore.halfBaseModule,
	    paddingX: 0,
	    borderRadius: _reactackleCore.radiusDefault,
	    minWidth: 140,
	    maxWidth: '100vw'
	  },
	
	  option: {
	    fontSize: _reactackleCore.fontSizeBody,
	    textTransform: 'none',
	    lineHeight: 1.5, // Only number accepted
	    paddingY: _reactackleCore.halfBaseModule,
	    paddingX: _reactackleCore.oneAndHalfBaseModule,
	    borderRadius: 0,
	
	    style: {
	      fontColor: _reactackleCore.bodyFontColor,
	      backgroundColor: _reactackleCore.colorTransparent,
	      fontWeight: _reactackleCore.fontWeightNormal,
	
	      hover: {
	        fontColor: _reactackleCore.bodyFontColor,
	        backgroundColor: 'rgba(0, 0, 0, 0.1)',
	        fontWeight: _reactackleCore.fontWeightNormal
	      },
	
	      focus: {
	        fontColor: _reactackleCore.bodyFontColor,
	        backgroundColor: 'rgba(0, 0, 0, 0.15)',
	        fontWeight: _reactackleCore.fontWeightNormal
	      }
	    }
	  }
	};

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactackleCore = __webpack_require__(3);
	
	var _broadcastsConstants = __webpack_require__(98);
	
	var _MenuStyled = __webpack_require__(755);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  /**
	   * Changes layout direction from vertical to horizontal
	   */
	  inline: _propTypes2.default.bool,
	  /**
	   * Set to 'light' for using menu on dark background
	   */
	  colorScheme: _propTypes2.default.oneOf(['light', 'dark'])
	};
	
	var defaultProps = {
	  inline: false,
	  colorScheme: 'dark'
	};
	
	var Menu = function (_Component) {
	  _inherits(Menu, _Component);
	
	  function Menu(props) {
	    _classCallCheck(this, Menu);
	
	    var _this = _possibleConstructorReturn(this, (Menu.__proto__ || Object.getPrototypeOf(Menu)).call(this, props));
	
	    _this._broadcast = (0, _reactackleCore.createBroadcast)({
	      colorScheme: _this.props.colorScheme,
	      inline: _this.props.inline
	    });
	    return _this;
	  }
	
	  _createClass(Menu, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return _extends({}, this.context, _defineProperty({}, _broadcastsConstants.MENU_BROADCAST, this._broadcast.subscribe));
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.colorScheme !== nextProps.colorScheme || this.props.inline !== nextProps.inline) {
	        this._broadcast.publish({
	          colorScheme: nextProps.colorScheme,
	          inline: nextProps.inline
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _MenuStyled.MenuStyled,
	        null,
	        this.props.children
	      );
	    }
	  }]);
	
	  return Menu;
	}(_react.Component);
	
	exports.default = Menu;
	
	
	Menu.propTypes = propTypes;
	Menu.defaultProps = defaultProps;
	Menu.displayName = 'Menu';
	Menu.childContextTypes = _defineProperty({}, _broadcastsConstants.MENU_BROADCAST, _propTypes2.default.func.isRequired);

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MenuGroup = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactackleCore = __webpack_require__(3);
	
	var _broadcastsConstants = __webpack_require__(98);
	
	var _MenuGroupStyled = __webpack_require__(734);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  /**
	   * Changes layout direction from vertical to horizontal
	   */
	  inline: _propTypes2.default.bool,
	  /**
	   * Set to 'light' for using menu on dark background
	   */
	  nestingLevel: _propTypes2.default.number
	};
	
	var defaultProps = {
	  inline: false,
	  nestingLevel: 0
	};
	
	var MenuGroup = exports.MenuGroup = function (_Component) {
	  _inherits(MenuGroup, _Component);
	
	  function MenuGroup(props) {
	    _classCallCheck(this, MenuGroup);
	
	    var _this = _possibleConstructorReturn(this, (MenuGroup.__proto__ || Object.getPrototypeOf(MenuGroup)).call(this, props));
	
	    _this._broadcast = (0, _reactackleCore.createBroadcast)({
	      nestingLevel: _this.props.nestingLevel
	    });
	
	    _this._createElementRef = _this._createElementRef.bind(_this);
	    return _this;
	  }
	
	  _createClass(MenuGroup, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return _extends({}, this.context, _defineProperty({}, _broadcastsConstants.MENU_GROUP_BROADCAST, this._broadcast.subscribe));
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.nestingLevel !== nextProps.nestingLevel) {
	        this._broadcast.publish({
	          nestingLevel: nextProps.nestingLevel
	        });
	      }
	    }
	  }, {
	    key: '_createElementRef',
	    value: function _createElementRef(ref) {
	      this.element = ref;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          inline = _props.inline;
	
	
	      return _react2.default.createElement(
	        _MenuGroupStyled.MenuGroupStyled,
	        { ref: this._createElementRef, inline: inline },
	        children
	      );
	    }
	  }]);
	
	  return MenuGroup;
	}(_react.Component);
	
	MenuGroup.propTypes = propTypes;
	MenuGroup.defaultProps = defaultProps;
	MenuGroup.displayName = 'MenuGroup';
	MenuGroup.childContextTypes = _defineProperty({}, _broadcastsConstants.MENU_GROUP_BROADCAST, _propTypes2.default.func.isRequired);
	
	exports.default = (0, _reactackleCore.withExternalProps)(_broadcastsConstants.MENU_BROADCAST)(function (_ref) {
	  var externalProps = _ref.externalProps,
	      props = _objectWithoutProperties(_ref, ['externalProps']);
	
	  return _react2.default.createElement(MenuGroup, _extends({}, externalProps, props));
	});

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MenuGroup = undefined;
	
	var _MenuGroup = __webpack_require__(732);
	
	var _MenuGroup2 = _interopRequireDefault(_MenuGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.MenuGroup = _MenuGroup2.default; // eslint-disable-next-line

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MenuGroupStyled = undefined;
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var inline = function inline(_ref) {
	  var inline = _ref.inline;
	  return inline && '\n  display: flex;\n  align-items: stretch;\n';
	};
	
	var MenuGroupStyled = exports.MenuGroupStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'MenuGroupStyled'
	})(['display:block;', ''], inline);
	
	MenuGroupStyled.displayName = 'MenuGroupStyled';

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MenuItem = undefined;
	
	var _MenuItem$childContex;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactackleIcons = __webpack_require__(7);
	
	var _reactackleCore = __webpack_require__(3);
	
	var _broadcastsConstants = __webpack_require__(98);
	
	var _MenuItemStyled = __webpack_require__(746);
	
	var _AnchorStyled = __webpack_require__(739);
	
	var _ContentStyled = __webpack_require__(740);
	
	var _TextPrimaryStyled = __webpack_require__(747);
	
	var _TextSecondaryStyled = __webpack_require__(749);
	
	var _IconLeftStyled = __webpack_require__(743);
	
	var _IconRightStyled = __webpack_require__(744);
	
	var _ImageStyled = __webpack_require__(745);
	
	var _ExpandButtonStyled = __webpack_require__(741);
	
	var _ExpandIconStyled = __webpack_require__(742);
	
	var _AddonRightStyled = __webpack_require__(738);
	
	var _TextRightStyled = __webpack_require__(748);
	
	var _MenuLink = __webpack_require__(736);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  /**
	   * Item id
	   */
	  id: _propTypes2.default.string,
	  /**
	   * Defines left icon element
	   */
	  iconLeft: _propTypes2.default.element,
	  /**
	   * Defines right icon element
	   */
	  iconRight: _propTypes2.default.element,
	  /**
	   * Defines right text element
	   */
	  textRight: _propTypes2.default.string,
	  /**
	   * Defines left image element
	   */
	  image: _propTypes2.default.string,
	  /**
	   * Defines item's link
	   */
	  linkHref: _propTypes2.default.string,
	  /**
	   * Primary item text
	   */
	  text: _propTypes2.default.string,
	  /**
	   * Secondary item text
	   */
	  textSecondary: _propTypes2.default.string,
	  /**
	   * Allow item to behave like a link
	   */
	  renderLink: _propTypes2.default.bool,
	  /**
	   * Define link component
	   */
	  linkComponent: _propTypes2.default.func,
	  /**
	   * Primary right add-on element
	   */
	  addonRight: _propTypes2.default.element,
	  /**
	   * Define item colorScheme
	   */
	  colorScheme: _propTypes2.default.oneOf(['light', 'dark']),
	  /**
	   * Display item as active
	   */
	  active: _propTypes2.default.bool,
	  /**
	   * Simulate image offset for item without image
	   */
	  addImageOffset: _propTypes2.default.bool,
	  /**
	   * Simulate image offset for item without left icon
	   */
	  addIconOffset: _propTypes2.default.bool,
	  /**
	   * Simulate item offset for nested trees
	   */
	  nestingLevel: _propTypes2.default.number,
	  /**
	   * Set item inClick function
	   */
	  onClick: _propTypes2.default.func,
	  /**
	   * Define expand icon element
	   */
	  iconExpand: _propTypes2.default.element
	};
	
	var defaultProps = {
	  id: '',
	  iconLeft: null,
	  iconRight: null,
	  textRight: '',
	  image: '',
	  linkHref: '#',
	  text: '',
	  textSecondary: '',
	  renderLink: false,
	  linkComponent: _MenuLink.MenuLink,
	  addonRight: null,
	  colorScheme: 'dark',
	  active: false,
	  addImageOffset: false,
	  addIconOffset: false,
	  nestingLevel: 0,
	  onClick: _reactackleCore.noop,
	  iconExpand: _react2.default.createElement(_reactackleIcons.IconArrowChevronRight, { color: 'currentColor', size: 'custom' })
	};
	
	var MenuItem = exports.MenuItem = function (_React$Component) {
	  _inherits(MenuItem, _React$Component);
	
	  function MenuItem(props) {
	    _classCallCheck(this, MenuItem);
	
	    var _this = _possibleConstructorReturn(this, (MenuItem.__proto__ || Object.getPrototypeOf(MenuItem)).call(this, props));
	
	    _this._broadcast = (0, _reactackleCore.createBroadcast)({
	      nestingLevel: _this.props.nestingLevel,
	      colorScheme: _this.props.colorScheme
	    });
	
	    _this.state = {
	      submenuOpen: false
	    };
	    _this._toggleMenu = _this._toggleMenu.bind(_this);
	    _this._handleClick = _this._handleClick.bind(_this);
	    _this._createElementRef = _this._createElementRef.bind(_this);
	    _this._handleExpandIconClick = _this._handleExpandIconClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(MenuItem, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      var _extends2;
	
	      return _extends({}, this.context, (_extends2 = {}, _defineProperty(_extends2, _broadcastsConstants.MENU_BROADCAST, this._broadcast.subscribe), _defineProperty(_extends2, _broadcastsConstants.MENU_GROUP_BROADCAST, this._broadcast.subscribe), _extends2));
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.colorScheme !== nextProps.colorScheme) {
	        this._broadcast.publish({
	          colorScheme: nextProps.colorScheme
	        });
	      }
	    }
	  }, {
	    key: '_toggleMenu',
	    value: function _toggleMenu(open) {
	      if (this.props.children) {
	        this.setState({
	          submenuOpen: typeof open === 'boolean' ? open : !this.state.submenuOpen
	        });
	      }
	    }
	  }, {
	    key: '_handleExpandIconClick',
	    value: function _handleExpandIconClick(event) {
	      event.preventDefault();
	      this._toggleMenu();
	    }
	  }, {
	    key: '_handleClick',
	    value: function _handleClick() {
	      if (!this.props.children) this.closeRootMenu();else this._toggleMenu();
	      this.props.onClick();
	    }
	  }, {
	    key: 'closeRootMenu',
	    value: function closeRootMenu() {
	      document.dispatchEvent(new MouseEvent('click'));
	    }
	  }, {
	    key: '_createElementRef',
	    value: function _createElementRef(ref) {
	      this.element = ref;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var href = this.props.linkHref;
	      var iconLeft = this.props.iconLeft && _react2.default.createElement(
	        _IconLeftStyled.IconLeftStyled,
	        {
	          colorScheme: this.props.colorScheme,
	          active: this.props.active
	        },
	        this.props.iconLeft
	      );
	
	      var iconRight = this.props.iconRight && _react2.default.createElement(
	        _IconRightStyled.IconRightStyled,
	        {
	          colorScheme: this.props.colorScheme,
	          active: this.props.active
	        },
	        this.props.iconRight
	      );
	
	      var textRight = this.props.textRight && _react2.default.createElement(
	        _TextRightStyled.TextRightStyled,
	        {
	          colorScheme: this.props.colorScheme,
	          active: this.props.active
	        },
	        this.props.textRight
	      );
	
	      var image = this.props.image && _react2.default.createElement(_ImageStyled.ImageStyled, {
	        imageOnly: !this.props.text && !this.props.iconLeft && !this.props.iconRight,
	        style: { backgroundImage: 'url(' + this.props.image + ')' }
	      });
	
	      var textSecondary = this.props.textSecondary && _react2.default.createElement(
	        _TextSecondaryStyled.TextSecondaryStyled,
	        {
	          colorScheme: this.props.colorScheme,
	          active: this.props.active
	        },
	        this.props.textSecondary
	      );
	
	      var text = this.props.text && _react2.default.createElement(
	        _ContentStyled.ContentStyled,
	        {
	          nestingLevel: this.props.nestingLevel,
	          addImageOffset: this.props.addImageOffset,
	          addIconOffset: this.props.addIconOffset
	        },
	        _react2.default.createElement(
	          _TextPrimaryStyled.TextPrimaryStyled,
	          null,
	          this.props.text
	        ),
	        textSecondary
	      );
	
	      var expandButton = this.props.children && _react2.default.createElement(
	        _ExpandButtonStyled.ExpandButtonStyled,
	        {
	          colorScheme: this.props.colorScheme,
	          active: this.props.active,
	          onClick: this._handleExpandIconClick
	        },
	        _react2.default.createElement(
	          _ExpandIconStyled.ExpandIconStyled,
	          { opened: this.state.submenuOpen },
	          this.props.iconExpand
	        )
	      );
	
	      var ItemWrapper = this.props.renderLink ? _AnchorStyled.AnchorStyled.withComponent(this.props.linkComponent) : _AnchorStyled.AnchorStyled.withComponent('div');
	
	      var itemWrapperProps = {
	        colorScheme: this.props.colorScheme,
	        active: this.props.active,
	        onClick: this._handleClick
	      };
	
	      if (this.props.renderLink) itemWrapperProps.href = href;
	
	      var addonRight = this.props.addonRight && _react2.default.createElement(
	        _AddonRightStyled.AddonRightStyled,
	        null,
	        this.props.addonRight
	      );
	
	      var children = this.props.children;
	
	      return _react2.default.createElement(
	        _MenuItemStyled.MenuItemStyled,
	        {
	          innerRef: this._createElementRef,
	          tabIndex: -1,
	          id: this.props.id
	        },
	        _react2.default.createElement(
	          ItemWrapper,
	          itemWrapperProps,
	          iconLeft,
	          image,
	          text,
	          textRight,
	          iconRight,
	          addonRight,
	          expandButton
	        ),
	        this.state.submenuOpen && children
	      );
	    }
	  }]);
	
	  return MenuItem;
	}(_react2.default.Component);
	
	MenuItem.propTypes = propTypes;
	MenuItem.defaultProps = defaultProps;
	MenuItem.displayName = 'MenuItem';
	MenuItem.childContextTypes = (_MenuItem$childContex = {}, _defineProperty(_MenuItem$childContex, _broadcastsConstants.MENU_BROADCAST, _propTypes2.default.func.isRequired), _defineProperty(_MenuItem$childContex, _broadcastsConstants.MENU_GROUP_BROADCAST, _propTypes2.default.func.isRequired), _MenuItem$childContex);
	
	var MenuItemWithMenuProps = (0, _reactackleCore.withExternalProps)(_broadcastsConstants.MENU_BROADCAST)(function (_ref) {
	  var externalProps = _ref.externalProps,
	      props = _objectWithoutProperties(_ref, ['externalProps']);
	
	  return _react2.default.createElement(MenuItem, _extends({}, externalProps, props));
	});
	
	exports.default = (0, _reactackleCore.withExternalProps)(_broadcastsConstants.MENU_GROUP_BROADCAST)(function (_ref2) {
	  var externalProps = _ref2.externalProps,
	      props = _objectWithoutProperties(_ref2, ['externalProps']);
	
	  return _react2.default.createElement(MenuItemWithMenuProps, _extends({}, externalProps, props));
	});

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MenuLink = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MenuLink = exports.MenuLink = function MenuLink(props) {
	  return _react2.default.createElement(
	    "a",
	    props,
	    props.children
	  );
	};

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MenuItem = undefined;
	
	var _MenuItem = __webpack_require__(735);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.MenuItem = _MenuItem2.default; // eslint-disable-next-line

/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AddonRightStyled = undefined;
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var size = function size(_ref) {
	  var themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var _theme$reactackle$com = theme.reactackle.components.menu.item.addonRight,
	      marginLeft = _theme$reactackle$com.marginLeft,
	      marginRight = _theme$reactackle$com.marginRight;
	
	
	  return (0, _styledComponents.css)(['margin:0 ', ' 0 ', ';'], (0, _reactackleCore.getValueString)(marginLeft), (0, _reactackleCore.getValueString)(marginRight));
	};
	
	var AddonRightStyled = exports.AddonRightStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'AddonRightStyled'
	})(['', ''], size);
	
	AddonRightStyled.displayName = 'AddonRightStyled';

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AnchorStyled = undefined;
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var size = function size(_ref) {
	  var themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var _theme$reactackle$com = theme.reactackle.components.menu.item,
	      minHeight = _theme$reactackle$com.minHeight,
	      paddingY = _theme$reactackle$com.paddingY,
	      paddingX = _theme$reactackle$com.paddingX;
	
	
	  return (0, _styledComponents.css)(['min-height:', ';padding:', ' ', ';'], (0, _reactackleCore.getValueString)(minHeight), (0, _reactackleCore.getValueString)(paddingY), (0, _reactackleCore.getValueString)(paddingX));
	};
	
	var colorScheme = function colorScheme(_ref2) {
	  var colorScheme = _ref2.colorScheme,
	      active = _ref2.active,
	      themeFromProvider = _ref2.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var path = theme.reactackle.components.menu.item.colorScheme[colorScheme];
	
	  var defaultBgColor = path.backgroundColor,
	      backgroundColorHover = path.backgroundColorHover,
	      backgroundColorFocus = path.backgroundColorFocus,
	      backgroundColorActive = path.backgroundColorActive,
	      defaultColor = path.color,
	      colorHover = path.colorHover,
	      colorFocus = path.colorFocus,
	      colorActive = path.colorActive;
	
	
	  return active ? (0, _styledComponents.css)(['&,&:hover,&:focus{background-color:', ';color:', ';}'], backgroundColorActive || defaultBgColor, colorActive || defaultColor) : (0, _styledComponents.css)(['background-color:', ';color:', ';&:hover{background-color:', ';color:', ';}&:focus{background-color:', ';color:', ';}'], defaultBgColor, defaultColor, backgroundColorHover || defaultBgColor, colorHover || defaultColor, backgroundColorFocus || defaultBgColor, colorFocus || defaultColor);
	};
	
	var AnchorStyled = exports.AnchorStyled = _styledComponents2.default.a.withConfig({
	  displayName: 'AnchorStyled'
	})(['width:100%;display:flex;flex-grow:1;padding:0;align-items:center;text-decoration:none;position:relative;cursor:pointer;user-select:none;', ' ', ' ', ' &:hover,&:focus{outline:none;}'], size, colorScheme, (0, _reactackleCore.transition)('background-color'));
	
	AnchorStyled.displayName = 'AnchorStyled';

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ContentStyled = undefined;
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var offset = function offset(_ref) {
	  var nestingLevel = _ref.nestingLevel,
	      addImageOffset = _ref.addImageOffset,
	      addIconOffset = _ref.addIconOffset,
	      themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var path = theme.reactackle.components.menu.item;
	  var iconPath = path.iconLeft;
	  var imgPath = path.image;
	  var levelOffset = path.levelOffset;
	
	  var offset = [addIconOffset && [(0, _reactackleCore.getValueString)(iconPath.width || iconPath.height), (0, _reactackleCore.getValueString)(iconPath.marginLeft), (0, _reactackleCore.getValueString)(iconPath.marginRight)].join(' + '), addImageOffset && [(0, _reactackleCore.getValueString)(imgPath.width), (0, _reactackleCore.getValueString)(imgPath.marginLeft), (0, _reactackleCore.getValueString)(imgPath.marginRight)].join(' + '), nestingLevel && (typeof levelOffset === 'string' ? levelOffset + ' * ' + nestingLevel : levelOffset * nestingLevel + 'px')];
	
	  return addIconOffset || addImageOffset || nestingLevel ? 'padding-left: calc(' + offset.filter(Boolean).join(' + ') + ');' : null;
	};
	
	var ContentStyled = exports.ContentStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'ContentStyled'
	})(['flex-grow:1;', ''], offset);
	
	ContentStyled.displayName = 'ContentStyled';

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ExpandButtonStyled = undefined;
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var size = function size(_ref) {
	  var themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var _theme$reactackle$com = theme.reactackle.components.menu.item.expandButton,
	      marginLeft = _theme$reactackle$com.marginLeft,
	      marginRight = _theme$reactackle$com.marginRight,
	      borderRadius = _theme$reactackle$com.borderRadius;
	  var _theme$reactackle$com2 = theme.reactackle.components.menu.item.expandButton.icon,
	      height = _theme$reactackle$com2.height,
	      width = _theme$reactackle$com2.width;
	
	
	  return (0, _styledComponents.css)(['width:', ';height:', ';line-height:', ';margin-left:', ';margin-right:', ';border-radius:', ';'], (0, _reactackleCore.getValueString)(width || height), (0, _reactackleCore.getValueString)(height), (0, _reactackleCore.getValueString)(height), (0, _reactackleCore.getValueString)(marginLeft), (0, _reactackleCore.getValueString)(marginRight), (0, _reactackleCore.getValueString)(borderRadius));
	};
	
	var colorScheme = function colorScheme(_ref2) {
	  var colorScheme = _ref2.colorScheme,
	      active = _ref2.active,
	      themeFromProvider = _ref2.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var colorKey = active ? 'active' : 'default';
	  var path = theme.reactackle.components.menu.item.expandButton.colorScheme[colorScheme];
	
	  var defaultBgColor = path.default.backgroundColor;
	  var defaultColor = path.default.color;
	  var defaultOpacity = path.default.opacity;
	
	  var _path$colorKey = path[colorKey],
	      backgroundColor = _path$colorKey.backgroundColor,
	      color = _path$colorKey.color,
	      opacity = _path$colorKey.opacity;
	
	
	  return (0, _styledComponents.css)(['background-color:', ';color:', ';opacity:', ';&:hover{background-color:', ';color:', ';opacity:', ';}&:focus{background-color:', ';color:', ';opacity:', ';}'], backgroundColor || defaultBgColor, color || defaultColor, opacity || defaultOpacity, path[colorKey].hover.backgroundColor || defaultBgColor, path[colorKey].hover.color || defaultColor, path[colorKey].hover.opacity || defaultOpacity, path[colorKey].focus.backgroundColor || defaultBgColor, path[colorKey].focus.color || defaultColor, path[colorKey].focus.opacity || defaultOpacity);
	};
	
	var ExpandButtonStyled = exports.ExpandButtonStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'ExpandButtonStyled'
	})(['overflow:hidden;position:relative;background-size:cover;', ' ', ' ', ''], size, colorScheme, (0, _reactackleCore.transition)('background-color, color, opacity'));
	
	ExpandButtonStyled.displayName = 'ExpandButtonStyled';

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ExpandIconStyled = undefined;
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var opened = function opened(_ref) {
	  var opened = _ref.opened;
	  return opened ? 'transform: rotate(90deg);' : 'transform: rotate(0deg);';
	};
	
	var size = function size(_ref2) {
	  var themeFromProvider = _ref2.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var _theme$reactackle$com = theme.reactackle.components.menu.item.expandButton.icon,
	      height = _theme$reactackle$com.height,
	      width = _theme$reactackle$com.width,
	      imgHeight = _theme$reactackle$com.imgHeight,
	      imgWidth = _theme$reactackle$com.imgWidth;
	
	
	  return (0, _styledComponents.css)(['     ', ''], (0, _reactackleCore.iconSizeMixin)((0, _reactackleCore.getValueString)(height), (0, _reactackleCore.getValueString)(imgHeight || height), (0, _reactackleCore.getValueString)(width || height), (0, _reactackleCore.getValueString)(imgWidth || imgHeight)));
	};
	
	var ExpandIconStyled = exports.ExpandIconStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'ExpandIconStyled'
	})(['position:absolute;right:0;top:0;height:inherit;width:inherit;align-items:center;display:flex;', ' ', ' ', ''], opened, size, (0, _reactackleCore.transition)('transform'));
	
	ExpandIconStyled.displayName = 'ExpandIconStyled';

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.IconLeftStyled = undefined;
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var size = function size(_ref) {
	  var themeFromProvider = _ref.theme,
	      iconOnly = _ref.iconOnly;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var _theme$reactackle$com = theme.reactackle.components.menu.item.iconLeft,
	      height = _theme$reactackle$com.height,
	      width = _theme$reactackle$com.width,
	      imgHeight = _theme$reactackle$com.imgHeight,
	      imgWidth = _theme$reactackle$com.imgWidth,
	      marginLeft = _theme$reactackle$com.marginLeft,
	      marginRight = _theme$reactackle$com.marginRight;
	
	
	  var mLeft = iconOnly ? 0 : (0, _reactackleCore.getValueString)(marginLeft);
	  var mRight = iconOnly ? 0 : (0, _reactackleCore.getValueString)(marginRight);
	
	  return (0, _styledComponents.css)(['margin:0 ', ' 0 ', ';', ''], mLeft, mRight, (0, _reactackleCore.iconSizeMixin)((0, _reactackleCore.getValueString)(height), (0, _reactackleCore.getValueString)(imgHeight || height), (0, _reactackleCore.getValueString)(width || height), (0, _reactackleCore.getValueString)(imgWidth || imgHeight)));
	};
	
	var color = function color(_ref2) {
	  var themeFromProvider = _ref2.theme,
	      colorScheme = _ref2.colorScheme,
	      active = _ref2.active;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var path = theme.reactackle.components.menu.item.iconLeft.colorScheme[colorScheme];
	
	  var defaultColor = path.default.color;
	  var defaultOpacity = path.default.opacity;
	
	  return active ? '\n      color: ' + (path.active.color || defaultColor) + ';\n      opacity: ' + (path.active.opacity || defaultOpacity) + ';\n    ' : '\n      color: ' + defaultColor + ';\n      opacity: ' + defaultOpacity + ';\n    ';
	};
	
	var IconLeftStyled = exports.IconLeftStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'IconLeftStyled'
	})(['flex-shrink:0;', ' ', ' ', ''], size, color, (0, _reactackleCore.transition)('color, width, height, opacity, transform'));
	
	IconLeftStyled.displayName = 'IconLeftStyled';

/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.IconRightStyled = undefined;
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var size = function size(_ref) {
	  var themeFromProvider = _ref.theme,
	      iconOnly = _ref.iconOnly;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var _theme$reactackle$com = theme.reactackle.components.menu.item.iconRight,
	      height = _theme$reactackle$com.height,
	      width = _theme$reactackle$com.width,
	      imgHeight = _theme$reactackle$com.imgHeight,
	      imgWidth = _theme$reactackle$com.imgWidth,
	      marginLeft = _theme$reactackle$com.marginLeft,
	      marginRight = _theme$reactackle$com.marginRight;
	
	
	  var mLeft = iconOnly ? 0 : (0, _reactackleCore.getValueString)(marginLeft);
	  var mRight = iconOnly ? 0 : (0, _reactackleCore.getValueString)(marginRight);
	
	  return (0, _styledComponents.css)(['margin:0 ', ' 0 ', ';', ''], mLeft, mRight, (0, _reactackleCore.iconSizeMixin)((0, _reactackleCore.getValueString)(height), (0, _reactackleCore.getValueString)(imgHeight || height), (0, _reactackleCore.getValueString)(width || height), (0, _reactackleCore.getValueString)(imgWidth || imgHeight)));
	};
	
	var color = function color(_ref2) {
	  var themeFromProvider = _ref2.theme,
	      colorScheme = _ref2.colorScheme,
	      active = _ref2.active;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var path = theme.reactackle.components.menu.item.iconRight.colorScheme[colorScheme];
	
	  var defaultColor = path.default.color;
	  var defaultOpacity = path.default.opacity;
	
	  return active ? (0, _styledComponents.css)(['color:', ';opacity:', ';'], path.active.color || defaultColor, path.active.opacity || defaultOpacity) : '\n      color: ' + defaultColor + ';\n      opacity: ' + defaultOpacity + ';\n    ';
	};
	
	var IconRightStyled = exports.IconRightStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'IconRightStyled'
	})(['flex-shrink:0;', ' ', ' ', ''], size, color, (0, _reactackleCore.transition)('color, width, height, opacity, transform'));
	
	IconRightStyled.displayName = 'IconRightStyled';

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ImageStyled = undefined;
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var size = function size(_ref) {
	  var themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var _theme$reactackle$com = theme.reactackle.components.menu.item.image,
	      width = _theme$reactackle$com.width,
	      height = _theme$reactackle$com.height,
	      marginLeft = _theme$reactackle$com.marginLeft,
	      marginRight = _theme$reactackle$com.marginRight,
	      borderRadius = _theme$reactackle$com.borderRadius;
	
	
	  return (0, _styledComponents.css)(['width:', ';height:', ';margin-left:', ';margin-right:', ';border-radius:', ';'], (0, _reactackleCore.getValueString)(width), (0, _reactackleCore.getValueString)(height || width), (0, _reactackleCore.getValueString)(marginLeft), (0, _reactackleCore.getValueString)(marginRight), (0, _reactackleCore.getValueString)(borderRadius));
	};
	
	var ImageStyled = exports.ImageStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'ImageStyled'
	})(['overflow:hidden;position:relative;background-size:cover;', ''], size);
	
	ImageStyled.displayName = 'ImageStyled';

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MenuItemStyled = undefined;
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MenuItemStyled = exports.MenuItemStyled = _styledComponents2.default.li.withConfig({
	  displayName: 'MenuItemStyled'
	})(['display:flex;flex-direction:column;padding:0;align-items:stretch;position:relative;user-select:none;&:focus{outline:none}']);
	
	MenuItemStyled.displayName = 'MenuItemStyled';

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TextPrimaryStyled = undefined;
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var font = function font(_ref) {
	  var themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var _theme$reactackle$com = theme.reactackle.components.menu.item,
	      fontSize = _theme$reactackle$com.fontSize,
	      lineHeight = _theme$reactackle$com.lineHeight;
	
	
	  return (0, _styledComponents.css)(['font-size:', ';line-height:', ';'], (0, _reactackleCore.getValueString)(fontSize), lineHeight);
	};
	
	var TextPrimaryStyled = exports.TextPrimaryStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'TextPrimaryStyled'
	})(['color:currentColor;', ' ', ''], font, (0, _reactackleCore.transition)('color'));
	
	TextPrimaryStyled.displayName = 'TextPrimaryStyled';

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TextRightStyled = undefined;
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var size = function size(_ref) {
	  var themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var _theme$reactackle$com = theme.reactackle.components.menu.item.textRight,
	      marginLeft = _theme$reactackle$com.marginLeft,
	      marginRight = _theme$reactackle$com.marginRight;
	
	
	  return (0, _styledComponents.css)(['padding:0 ', ' 0 ', ';'], (0, _reactackleCore.getValueString)(marginRight), (0, _reactackleCore.getValueString)(marginLeft));
	};
	
	var font = function font(_ref2) {
	  var themeFromProvider = _ref2.theme,
	      colorScheme = _ref2.colorScheme,
	      active = _ref2.active;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var path = theme.reactackle.components.menu.item.textRight;
	  var colorPath = path.colorScheme[colorScheme];
	  var defaultColor = colorPath.default.color;
	  var defaultOpacity = colorPath.default.opacity;
	
	  var fontSize = path.fontSize,
	      lineHeight = path.lineHeight;
	
	
	  return (0, _styledComponents.css)(['font-size:', ';line-height:', ';', ''], (0, _reactackleCore.getValueString)(fontSize), lineHeight, active ? (0, _styledComponents.css)(['color:', ';opacity:', ';'], colorPath.active.color || defaultColor, colorPath.active.opacity || defaultOpacity) : '\n          color: ' + defaultColor + ';\n          opacity: ' + defaultOpacity + ';\n        ');
	};
	
	var TextRightStyled = exports.TextRightStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'TextRightStyled'
	})(['', ' ', ''], size, font);
	
	TextRightStyled.displayName = 'TextRightStyled';

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TextSecondaryStyled = undefined;
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var font = function font(_ref) {
	  var themeFromProvider = _ref.theme,
	      colorScheme = _ref.colorScheme,
	      active = _ref.active;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var path = theme.reactackle.components.menu.item.textSecondary;
	  var colorPath = path.colorScheme[colorScheme];
	  var defaultColor = colorPath.default.color;
	  var defaultOpacity = colorPath.default.opacity;
	
	  var fontSize = path.fontSize,
	      lineHeight = path.lineHeight;
	
	
	  return (0, _styledComponents.css)(['font-size:', ';line-height:', ';', ''], (0, _reactackleCore.getValueString)(fontSize), lineHeight, active ? (0, _styledComponents.css)(['color:', ';opacity:', ';'], colorPath.active.color || defaultColor, colorPath.active.opacity || defaultOpacity) : '\n        color: ' + defaultColor + ';\n        opacity: ' + defaultOpacity + ';\n      ');
	};
	
	var spacing = function spacing(_ref2) {
	  var themeFromProvider = _ref2.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var spacingTop = theme.reactackle.components.menu.item.textSecondary.spacingTop;
	
	  return (0, _styledComponents.css)(['padding-top:', ';'], (0, _reactackleCore.getValueString)(spacingTop));
	};
	
	var TextSecondaryStyled = exports.TextSecondaryStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'TextSecondaryStyled'
	})(['', ' ', ' ', ''], font, spacing, (0, _reactackleCore.transition)('color'));
	
	TextSecondaryStyled.displayName = 'TextSecondaryStyled';

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MenuList = undefined;
	
	var _MenuList$childContex;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactackleCore = __webpack_require__(3);
	
	var _MenuListStyled = __webpack_require__(752);
	
	var _TitleStyled = __webpack_require__(753);
	
	var _broadcastsConstants = __webpack_require__(98);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  /**
	   * List title
	   */
	  title: _propTypes2.default.string,
	  /**
	  * Simulate item offset for nested trees
	  */
	  nestingLevel: _propTypes2.default.number,
	  /**
	   * Adds border to visually separate two lists
	   */
	  bordered: _propTypes2.default.bool,
	  /**
	   * Define item colorScheme
	   */
	  colorScheme: _propTypes2.default.oneOf(['light', 'dark']),
	  /**
	   * Set to 'light' for using menu on dark background
	   */
	  inline: _propTypes2.default.bool
	};
	
	var defaultProps = {
	  title: '',
	  nestingLevel: 0,
	  colorScheme: 'dark',
	  bordered: false,
	  inline: false
	};
	
	var MenuList = exports.MenuList = function (_Component) {
	  _inherits(MenuList, _Component);
	
	  function MenuList(props) {
	    _classCallCheck(this, MenuList);
	
	    var _this = _possibleConstructorReturn(this, (MenuList.__proto__ || Object.getPrototypeOf(MenuList)).call(this, props));
	
	    _this._broadcast = (0, _reactackleCore.createBroadcast)({
	      inline: _this.props.inline,
	      colorScheme: _this.props.colorScheme,
	      nestingLevel: _this.props.nestingLevel
	    });
	    return _this;
	  }
	
	  _createClass(MenuList, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      var _extends2;
	
	      return _extends({}, this.context, (_extends2 = {}, _defineProperty(_extends2, _broadcastsConstants.MENU_BROADCAST, this._broadcast.subscribe), _defineProperty(_extends2, _broadcastsConstants.MENU_GROUP_BROADCAST, this._broadcast.subscribe), _extends2));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          title = _props.title,
	          bordered = _props.bordered,
	          inline = _props.inline;
	
	
	      var titleBox = title && _react2.default.createElement(
	        _TitleStyled.TitleStyled,
	        null,
	        title
	      );
	
	      return _react2.default.createElement(
	        _MenuListStyled.MenuListStyled,
	        { bordered: bordered, inline: inline },
	        titleBox,
	        children
	      );
	    }
	  }]);
	
	  return MenuList;
	}(_react.Component);
	
	MenuList.propTypes = propTypes;
	MenuList.defaultProps = defaultProps;
	MenuList.displayName = 'MenuList';
	MenuList.childContextTypes = (_MenuList$childContex = {}, _defineProperty(_MenuList$childContex, _broadcastsConstants.MENU_BROADCAST, _propTypes2.default.func.isRequired), _defineProperty(_MenuList$childContex, _broadcastsConstants.MENU_GROUP_BROADCAST, _propTypes2.default.func.isRequired), _MenuList$childContex);
	
	var MenuListWithMenuProps = (0, _reactackleCore.withExternalProps)(_broadcastsConstants.MENU_BROADCAST)(function (_ref) {
	  var externalProps = _ref.externalProps,
	      props = _objectWithoutProperties(_ref, ['externalProps']);
	
	  return _react2.default.createElement(MenuList, _extends({}, externalProps, props));
	});
	
	exports.default = (0, _reactackleCore.withExternalProps)(_broadcastsConstants.MENU_GROUP_BROADCAST)(function (_ref2) {
	  var externalProps = _ref2.externalProps,
	      props = _objectWithoutProperties(_ref2, ['externalProps']);
	
	  return _react2.default.createElement(MenuListWithMenuProps, _extends({}, externalProps, props));
	});

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MenuList = undefined;
	
	var _MenuList = __webpack_require__(750);
	
	var _MenuList2 = _interopRequireDefault(_MenuList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.MenuList = _MenuList2.default; // eslint-disable-next-line

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MenuListStyled = undefined;
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var size = function size(_ref) {
	  var themeFromProvider = _ref.theme,
	      inline = _ref.inline;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var _theme$reactackle$com = theme.reactackle.components.menu.list,
	      paddingY = _theme$reactackle$com.paddingY,
	      paddingX = _theme$reactackle$com.paddingX;
	
	
	  return inline ? (0, _styledComponents.css)(['padding:', ' ', ';'], (0, _reactackleCore.getValueString)(paddingX), (0, _reactackleCore.getValueString)(paddingY)) : (0, _styledComponents.css)(['padding:', ' ', ';'], (0, _reactackleCore.getValueString)(paddingY), (0, _reactackleCore.getValueString)(paddingX));
	};
	
	var inline = function inline(_ref2) {
	  var inline = _ref2.inline;
	  return inline && '\n  display: flex;\n  align-items: stretch;\n  flex-direction: row;\n';
	};
	
	var bordered = function bordered(_ref3) {
	  var inline = _ref3.inline,
	      bordered = _ref3.bordered,
	      themeFromProvider = _ref3.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var borderDir = inline ? 'left' : 'top';
	
	  var _theme$reactackle$com2 = theme.reactackle.components.menu.separator,
	      thickness = _theme$reactackle$com2.thickness,
	      color = _theme$reactackle$com2.color,
	      style = _theme$reactackle$com2.style;
	
	
	  return bordered && (0, _styledComponents.css)(['border-', ':', ' ', ' ', ';'], borderDir, (0, _reactackleCore.getValueString)(thickness), style, color);
	};
	
	var MenuListStyled = exports.MenuListStyled = _styledComponents2.default.ul.withConfig({
	  displayName: 'MenuListStyled'
	})(['margin:0;list-style-type:none;display:block;', ' ', ' ', ''], size, bordered, inline);
	
	MenuListStyled.displayName = 'MenuListStyled';

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TitleStyled = undefined;
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var size = function size(_ref) {
	  var themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var _theme$reactackle$com = theme.reactackle.components.menu.listTitle,
	      paddingTop = _theme$reactackle$com.paddingTop,
	      paddingBottom = _theme$reactackle$com.paddingBottom,
	      paddingX = _theme$reactackle$com.paddingX;
	
	
	  var itemPx = theme.reactackle.components.menu.item.paddingX;
	
	  return (0, _styledComponents.css)(['padding:', '  ', '  ', ';'], (0, _reactackleCore.getValueString)(paddingTop), (0, _reactackleCore.getValueString)(paddingX || itemPx), (0, _reactackleCore.getValueString)(paddingBottom || paddingTop));
	};
	
	var typography = function typography(_ref2) {
	  var themeFromProvider = _ref2.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var _theme$reactackle$com2 = theme.reactackle.components.menu.listTitle,
	      fontSize = _theme$reactackle$com2.fontSize,
	      fontWeight = _theme$reactackle$com2.fontWeight,
	      fontColor = _theme$reactackle$com2.fontColor,
	      lineHeight = _theme$reactackle$com2.lineHeight,
	      textTransform = _theme$reactackle$com2.textTransform;
	
	
	  return (0, _styledComponents.css)(['font-size:', ';font-weight:', ';line-height:', ';text-transform:', ';color:', ';'], (0, _reactackleCore.getValueString)(fontSize), fontWeight, lineHeight, textTransform, fontColor);
	};
	
	var TitleStyled = exports.TitleStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'TitleStyled'
	})(['margin:0;list-style-type:none;display:block;', ' ', ''], typography, size);
	
	TitleStyled.displayName = 'TitleStyled';

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Menu = undefined;
	
	var _MenuItem = __webpack_require__(737);
	
	Object.keys(_MenuItem).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _MenuItem[key];
	    }
	  });
	});
	
	var _MenuList = __webpack_require__(751);
	
	Object.keys(_MenuList).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _MenuList[key];
	    }
	  });
	});
	
	var _MenuGroup = __webpack_require__(733);
	
	Object.keys(_MenuGroup).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _MenuGroup[key];
	    }
	  });
	});
	
	var _reactackleCore = __webpack_require__(3);
	
	var _theme = __webpack_require__(756);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	var _Menu = __webpack_require__(731);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _reactackleCore.registerDefaultComponentTheme)('menu', _theme2.default);
	
	exports.Menu = _Menu2.default;

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MenuStyled = undefined;
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Menu = _styledComponents2.default.nav.withConfig({
	  displayName: 'MenuStyled__Menu'
	})(['padding:0;margin:0;']);
	
	var MenuDiv = Menu.withComponent('div');
	
	// eslint-disable-next-line react/prop-types
	var MenuStyled = function MenuStyled(_ref) {
	  var wrapWithDiv = _ref.wrapWithDiv,
	      props = _objectWithoutProperties(_ref, ['wrapWithDiv']);
	
	  return wrapWithDiv ? _react2.default.createElement(MenuDiv, props) : _react2.default.createElement(Menu, props);
	};
	
	exports.MenuStyled = MenuStyled;
	MenuStyled.displayName = 'MenuStyled';

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactackleCore = __webpack_require__(3);
	
	exports.default = {
	  list: {
	    paddingY: _reactackleCore.baseModule,
	    paddingX: 0
	  },
	
	  listTitle: {
	    paddingTop: _reactackleCore.baseModule,
	    paddingBottom: null, // will take paddingTop if null
	    paddingX: null, // will take item's paddingX if null
	    fontSize: _reactackleCore.fontSizeSmall,
	    fontWeight: _reactackleCore.fontWeightSemibold,
	    fontColor: _reactackleCore.colorPaletteGrey500,
	    lineHeight: 1.3,
	    textTransform: 'uppercase'
	  },
	
	  item: {
	    paddingY: _reactackleCore.baseModule,
	    paddingX: _reactackleCore.doubleBaseModule,
	    levelOffset: _reactackleCore.oneAndHalfBaseModule,
	    minHeight: 0,
	    fontSize: _reactackleCore.fontSizeBody,
	    lineHeight: 1.25,
	
	    colorScheme: {
	      dark: {
	        backgroundColor: 'transparent',
	        backgroundColorHover: 'rgba(0,0,0,0.05)', // If null will take 'backgroundColor' as a default
	        backgroundColorFocus: 'rgba(0,0,0,0.07)', // If null will take 'backgroundColor' as a default
	        backgroundColorActive: 'rgba(0,0,0,0.07)', // If null will take 'backgroundColor' as a default
	
	        color: _reactackleCore.bodyFontColor,
	        colorHover: null, // If null will take 'color' as a default
	        colorFocus: null, // If null will take 'color' as a default
	        colorActive: null // If null will take 'color' as a default
	      },
	
	      light: {
	        backgroundColor: 'transparent',
	        backgroundColorHover: 'rgba(255,255,255,0.05)', // If null will take 'backgroundColor' as a default
	        backgroundColorFocus: 'rgba(255,255,255,0.07)', // If null will take 'backgroundColor' as a default
	        backgroundColorActive: 'rgba(255,255,255,0.07)', // If null will take 'backgroundColor' as a default
	
	        color: _reactackleCore.bodyFontColorAlt,
	        colorHover: null, // If null will take 'color' as a default
	        colorFocus: null, // If null will take 'color' as a default
	        colorActive: null // If null will take 'color' as a default
	      }
	    },
	
	    textSecondary: {
	      fontSize: _reactackleCore.fontSizeSmall,
	      lineHeight: 1.25,
	      spacingTop: _reactackleCore.halfBaseModule,
	
	      colorScheme: {
	        dark: {
	          default: {
	            color: _reactackleCore.colorPaletteGrey500,
	            opacity: 1
	          },
	
	          active: {
	            color: null, // If null will take 'color' as a default
	            opacity: null // If null will take 'opacity' as a default
	          }
	        },
	
	        light: {
	          default: {
	            color: _reactackleCore.colorPaletteGrey500,
	            opacity: 1
	          },
	
	          active: {
	            color: null, // If null will take 'color' as a default
	            opacity: null // If null will take 'opacity' as a default
	          }
	        }
	      }
	    },
	
	    iconLeft: {
	      height: 24,
	      width: null, // If null will take 'height' as a default
	      imgHeight: 20, // If null will take 'height' as a default
	      imgWidth: null, // If null will take 'imgHeight' as a default
	      marginLeft: _reactackleCore.doubleBaseModule,
	      marginRight: 0,
	
	      colorScheme: {
	        dark: {
	          default: {
	            color: _reactackleCore.colorPaletteGrey500,
	            opacity: 1
	          },
	
	          active: {
	            color: null, // If null will take default 'color' as a default
	            opacity: null // If null will take default 'opacity' as a default
	          }
	        },
	
	        light: {
	          default: {
	            color: _reactackleCore.colorPaletteGrey500,
	            opacity: 1
	          },
	
	          active: {
	            color: null, // If null will take default 'color' as a default
	            opacity: null // If null will take default 'opacity' as a default
	          }
	        }
	      }
	    },
	
	    iconRight: {
	      height: 24,
	      width: null, // If null will take 'height' as a default
	      imgHeight: 20, // If null will take 'height' as a default
	      imgWidth: null, // If null will take 'imgHeight' as a default
	      marginLeft: _reactackleCore.baseModule,
	      marginRight: _reactackleCore.doubleBaseModule,
	
	      colorScheme: {
	        dark: {
	          default: {
	            color: _reactackleCore.colorPaletteGrey500,
	            opacity: 1
	          },
	
	          active: {
	            color: null, // If null will take default 'color' as a default
	            opacity: null // If null will take default 'opacity' as a default
	          }
	        },
	
	        light: {
	          default: {
	            color: _reactackleCore.colorPaletteGrey500,
	            opacity: 1
	          },
	
	          active: {
	            color: null, // If null will take default 'color' as a default
	            opacity: null // If null will take default 'opacity' as a default
	          }
	        }
	      }
	    },
	
	    image: {
	      width: 40,
	      height: null, // If null will take 'width' as a default
	      marginLeft: 0,
	      marginRight: _reactackleCore.doubleBaseModule,
	      borderRadius: '50%'
	    },
	
	    expandButton: {
	      marginLeft: 0,
	      marginRight: 0,
	      borderRadius: '50%',
	
	      icon: {
	        height: 24,
	        width: null, // If null will take 'height' as a default
	        imgHeight: 20, // If null will take 'height' as a default
	        imgWidth: null // If null will take 'imgHeight' as a default
	      },
	
	      colorScheme: {
	        dark: {
	          default: {
	            backgroundColor: 'transparent',
	            color: _reactackleCore.colorPaletteGrey500,
	            opacity: 1,
	
	            hover: {
	              backgroundColor: 'rgba(0,0,0,0.07)', // If null will take
	              // 'backgroundColor' as a default
	              color: null, // If null will take 'color' as a default
	              opacity: null // If null will take 'opacity' as a default
	            },
	
	            focus: {
	              backgroundColor: 'rgba(0,0,0,0.1)', // If null will take 'backgroundColor' as a default
	              color: null, // If null will take 'color' as a default
	              opacity: null // If null will take 'opacity' as a default
	            }
	          },
	
	          active: {
	            backgroundColor: null, // If null will take 'backgroundColor' as a default
	            color: null, // If null will take 'color' as a default
	            opacity: null, // If null will take 'opacity' as a default
	
	            hover: {
	              backgroundColor: null, // If null will take 'backgroundColor' as a default
	              color: null, // If null will take 'color' as a default
	              opacity: null // If null will take 'opacity' as a default
	            },
	
	            focus: {
	              backgroundColor: null, // If null will take 'backgroundColor' as a default
	              color: null, // If null will take 'color' as a default
	              opacity: null // If null will take 'opacity' as a default
	            }
	          }
	        },
	
	        light: {
	          default: {
	            backgroundColor: 'transparent', // If null will take
	            // 'backgroundColor' as a default
	            color: _reactackleCore.colorPaletteGrey500,
	            opacity: 1,
	
	            hover: {
	              backgroundColor: 'rgba(255,255,255,0.07)', // If null will take
	              // 'backgroundColor' as a default
	              color: null, // If null will take 'color' as a default
	              opacity: null // If null will take 'opacity' as a default
	            },
	
	            focus: {
	              backgroundColor: 'rgba(255,255,255,0.1)', // If null will take 'backgroundColor' as a default
	              color: null, // If null will take 'color' as a default
	              opacity: null // If null will take 'opacity' as a default
	            }
	          },
	
	          active: {
	            backgroundColor: null, // If null will take 'backgroundColor' as a default
	            color: null, // If null will take 'color' as a default
	            opacity: null, // If null will take 'opacity' as a default
	
	            hover: {
	              backgroundColor: null, // If null will take 'backgroundColor' as a default
	              color: null, // If null will take 'color' as a default
	              opacity: null // If null will take 'opacity' as a default
	            },
	
	            focus: {
	              backgroundColor: null, // If null will take 'backgroundColor' as a default
	              color: null, // If null will take 'color' as a default
	              opacity: null // If null will take 'opacity' as a default
	            }
	          }
	        }
	      }
	    },
	
	    addonRight: {
	      marginLeft: _reactackleCore.baseModule,
	      marginRight: _reactackleCore.doubleBaseModule
	    },
	
	    textRight: {
	      marginLeft: _reactackleCore.baseModule,
	      marginRight: _reactackleCore.doubleBaseModule,
	      fontSize: _reactackleCore.fontSizeSmall,
	      lineHeight: 1.2,
	
	      colorScheme: {
	        dark: {
	          default: {
	            color: _reactackleCore.colorPaletteGrey500,
	            opacity: 1
	          },
	
	          active: {
	            color: null, // If null will take 'color' as a default
	            opacity: null // If null will take 'opacity' as a default
	          }
	        },
	
	        light: {
	          default: {
	            color: _reactackleCore.colorPaletteGrey500,
	            opacity: 1
	          },
	
	          active: {
	            color: null, // If null will take 'color' as a default
	            opacity: null // If null will take 'opacity' as a default
	          }
	        }
	      }
	    }
	  },
	
	  separator: {
	    thickness: 1,
	    color: _reactackleCore.colorBorder,
	    style: 'solid'
	  }
	};

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BgLineStyled = undefined;
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var style = function style(_ref) {
	  var themeFromProvider = _ref.theme,
	      customThickness = _ref.customThickness;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var strokeSize = theme.reactackle.components.progress.circle.strokeSize;
	  var colourDefault = theme.reactackle.components.progress.circle.bgLine.colourDefault;
	
	
	  return (0, _styledComponents.css)(['stroke:', ';stroke-width:', ';'], colourDefault, (0, _reactackleCore.getValueString)(customThickness || strokeSize));
	};
	
	var BgLineStyled = exports.BgLineStyled = _styledComponents2.default.circle.withConfig({
	  displayName: 'BgLineStyled'
	})(['fill:none;stroke-dasharray:0 158;transform-origin:center;', ''], style);
	
	BgLineStyled.displayName = 'BgLineStyled';

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CircleBoxStyled = undefined;
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var style = function style(_ref) {
	  var themeFromProvider = _ref.theme,
	      customDiameter = _ref.customDiameter;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var diameter = theme.reactackle.components.progress.circle.diameter;
	
	
	  return (0, _styledComponents.css)(['width:', ';height:', ';'], (0, _reactackleCore.getValueString)(customDiameter || diameter), (0, _reactackleCore.getValueString)(customDiameter || diameter));
	};
	
	var rotateAnimation = function rotateAnimation(_ref2) {
	  var themeFromProvider = _ref2.theme,
	      indeterminate = _ref2.indeterminate;
	
	  var animationConfig = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider).reactackle.components.progress.circle.animation.svg;
	
	  var duration = animationConfig.transitionDuration;
	
	
	  var animation = (0, _styledComponents.keyframes)(['100%{transform:rotate(360deg);}']);
	
	  return !indeterminate ? null : (0, _styledComponents.css)(['animation:', 'ms ', ' linear infinite;'], duration, animation);
	};
	
	var CircleBoxStyled = exports.CircleBoxStyled = _styledComponents2.default.svg.withConfig({
	  displayName: 'CircleBoxStyled'
	})(['margin:auto;border-radius:50%;display:block;max-width:100%;max-height:100%;', ' ', ''], rotateAnimation, style);
	
	CircleBoxStyled.displayName = 'CircleBoxStyled';

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CircleWrapperStyled = undefined;
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CircleWrapperStyled = exports.CircleWrapperStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'CircleWrapperStyled'
	})(['transform:rotate(-90deg);']);
	
	CircleWrapperStyled.displayName = 'CircleWrapperStyled';

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ContentWrapperStyled = undefined;
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var style = function style(_ref) {
	  var themeFromProvider = _ref.theme,
	      customDiameter = _ref.customDiameter;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var diameter = theme.reactackle.components.progress.circle.diameter;
	
	
	  return (0, _styledComponents.css)(['width:', ';height:', ';'], (0, _reactackleCore.getValueString)(customDiameter || diameter), (0, _reactackleCore.getValueString)(customDiameter || diameter));
	};
	
	var ContentWrapperStyled = exports.ContentWrapperStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'ContentWrapperStyled'
	})(['margin:auto;display:block;max-width:100%;max-height:100%;order:2;', ''], style);
	
	ContentWrapperStyled.displayName = 'ContentWrapperStyled';

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PrimaryLineStyled = undefined;
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var style = function style(_ref) {
	  var themeFromProvider = _ref.theme,
	      customThickness = _ref.customThickness;
	
	  var componentTheme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider).reactackle.components.progress;
	
	  var strokeSize = componentTheme.circle.strokeSize;
	
	
	  return (0, _styledComponents.css)(['stroke-width:', ';'], (0, _reactackleCore.getValueString)(customThickness || strokeSize));
	};
	
	var strokeAnimation = function strokeAnimation(_ref2) {
	  var themeFromProvider = _ref2.theme,
	      circleLength = _ref2.circleLength,
	      indeterminate = _ref2.indeterminate;
	
	  var animationConfig = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider).reactackle.components.progress.circle.animation.circle;
	
	  var animation = (0, _styledComponents.keyframes)(['0%{stroke-dasharray:', ' ', ';stroke-dashoffset:', ';}50%{stroke-dasharray:', ' ', ';stroke-dashoffset:', ';}100%{stroke-dasharray:', ' ', ';stroke-dashoffset:', ';}'], 0.02 * circleLength, circleLength, 0 * -circleLength, 0.75 * circleLength, circleLength, 0 * -circleLength, 0.75 * circleLength, circleLength, 1 * -circleLength);
	
	  var duration = animationConfig.transitionDuration;
	
	
	  return !indeterminate ? null : (0, _styledComponents.css)(['animation:', 'ms ', ' ease-in-out infinite;'], duration, animation);
	};
	
	var PrimaryLineStyled = exports.PrimaryLineStyled = _styledComponents2.default.circle.withConfig({
	  displayName: 'PrimaryLineStyled'
	})(['fill:none;stroke-dasharray:0 158;transform-origin:center;', ' ', ''], strokeAnimation, style);
	
	PrimaryLineStyled.displayName = 'PrimaryLineStyled';

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SecondaryLineStyled = undefined;
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var style = function style(_ref) {
	  var themeFromProvider = _ref.theme,
	      customThickness = _ref.customThickness;
	
	  var componentTheme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider).reactackle.components.progress;
	
	  var strokeSize = componentTheme.circle.strokeSize.strokeSize;
	
	
	  return (0, _styledComponents.css)(['stroke-width:', ';'], (0, _reactackleCore.getValueString)(customThickness || strokeSize));
	};
	
	var SecondaryLineStyled = exports.SecondaryLineStyled = _styledComponents2.default.circle.withConfig({
	  displayName: 'SecondaryLineStyled'
	})(['fill:none;stroke-dasharray:0 158;transform-origin:center;', ''], style);
	
	SecondaryLineStyled.displayName = 'SecondaryLineStyled';

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ContentWrapperStyled = undefined;
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var style = function style(_ref) {
	  var themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var thickness = theme.reactackle.components.progress.linear.thickness;
	  var colourDefault = theme.reactackle.components.progress.linear.background.colourDefault;
	
	
	  return (0, _styledComponents.css)(['height:', ';background-color:', ';'], (0, _reactackleCore.getValueString)(thickness), colourDefault);
	};
	
	var ContentWrapperStyled = exports.ContentWrapperStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'ContentWrapperStyled'
	})(['position:relative;width:100%;overflow:hidden;order:2;', ''], style);
	
	ContentWrapperStyled.displayName = 'ContentWrapperStyled';

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LinearProgressStyled = undefined;
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LinearProgressStyled = exports.LinearProgressStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'LinearProgressStyled'
	})(['justify-content:flex-start;align-items:stretch;display:flex;flex-direction:column;']);
	
	LinearProgressStyled.displayName = 'LinearProgressStyled';

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PrimaryLineStyled = undefined;
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var barProgress = (0, _styledComponents.keyframes)(['0%{transform:scaleX(1) translateX(-100%);}50%{transform:scaleX(1) translateX(0%);}75%{transform:scaleX(1) translateX(0%);animation-timing-function:cubic-bezier(.28,.62,.37,.91);}100%{transform:scaleX(0) translateX(0%);}']);
	
	var indeterminate = function indeterminate(_ref) {
	  var indeterminate = _ref.indeterminate;
	  return indeterminate ? (0, _styledComponents.css)(['background-color:transparent !important;width:100%;transform-origin:right center;animation:', ' 2s linear infinite;'], barProgress) : '';
	};
	
	var style = function style(_ref2) {
	  var themeFromProvider = _ref2.theme;
	
	  var componentTheme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider).reactackle.components.progress;
	
	  return (0, _styledComponents.css)(['height:', ';'], (0, _reactackleCore.getValueString)(componentTheme.linear.thickness));
	};
	
	var PrimaryLineStyled = exports.PrimaryLineStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'PrimaryLineStyled'
	})(['position:absolute;top:0;left:0;width:100%;transform:scaleX(0);transform-origin:left center;will-change:transform;', ' ', ' ', ''], style, indeterminate, (0, _reactackleCore.transition)('transform, background-color', '800ms'));
	
	PrimaryLineStyled.displayName = 'PrimaryLineStyled';

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SecondaryLineStyled = undefined;
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var style = function style(_ref) {
	  var themeFromProvider = _ref.theme;
	
	  var componentTheme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider).reactackle.components.progress;
	
	  return (0, _styledComponents.css)(['height:', ';'], (0, _reactackleCore.getValueString)(componentTheme.linear.thickness));
	};
	
	var SecondaryLineStyled = exports.SecondaryLineStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'SecondaryLineStyled'
	})(['position:absolute;top:0;left:0;width:100%;transform:scaleX(0);transform-origin:left center;will-change:transform;', ''], style);
	
	SecondaryLineStyled.displayName = 'SecondaryLineStyled';

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SplitterStyled = undefined;
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _color = __webpack_require__(110);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var splitterProgress = (0, _styledComponents.keyframes)(['0%{transform:scaleX(.75) translateX(-125%);}30%{transform:scaleX(.75) translateX(-125%);animation-timing-function:cubic-bezier(.42,0,.6,.8);}90%{transform:scaleX(.75) translateX(125%);}100%{transform:scaleX(.75) translateX(125%);}']);
	
	var style = function style(_ref) {
	  var themeFromProvider = _ref.theme;
	
	  var componentTheme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider).reactackle.components.progress;
	
	  return (0, _styledComponents.css)(['height:', ';background-color:', ';'], (0, _reactackleCore.getValueString)(componentTheme.linear.thickness), (0, _color2.default)(componentTheme.linear.mainLine.color).string());
	};
	
	var SplitterStyled = exports.SplitterStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'SplitterStyled'
	})(['content:\'\';position:absolute;top:0;left:0;width:100%;will-change:transform;transform-origin:center center;animation:', ' 2s linear infinite;', ' ', ''], splitterProgress, style, (0, _reactackleCore.transition)('transform, background-color', '800ms'));
	
	SplitterStyled.displayName = 'SplitterStyled';

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Preloader = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(115);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _CircleProgress = __webpack_require__(218);
	
	var _LinearProgress = __webpack_require__(219);
	
	var _ProgressHolderStyled = __webpack_require__(769);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = _extends({}, _LinearProgress.LinearProgress.propTypes, _CircleProgress.CircleProgress.propTypes, {
	  /**
	  * Kind of loader, used for styling
	  */
	  kind: _propTypes2.default.oneOf(['linear', 'circle']).isRequired,
	  /**
	   * Width of the Preloader
	   */
	  width: _propTypes2.default.string,
	  /**
	   * height of the Preloader
	   */
	  height: _propTypes2.default.string,
	  /**
	   * Content horizontal align
	   */
	  alignX: _propTypes2.default.oneOf(['left', 'center', 'right']),
	  /**
	   * Content vertical align
	   */
	  alignY: _propTypes2.default.oneOf(['top', 'bottom', 'center'])
	});
	
	var defaultProps = _extends({}, _LinearProgress.LinearProgress.defaultProps, _CircleProgress.CircleProgress.defaultProps, {
	  width: '',
	  height: '',
	  alignX: 'center',
	  alignY: 'center'
	});
	
	var preloaderProps = ['width', 'height', 'alignX', 'alignY', 'children'];
	
	var Preloader = exports.Preloader = function Preloader(props) {
	  var kind = props.kind,
	      width = props.width,
	      height = props.height,
	      alignY = props.alignY,
	      alignX = props.alignX;
	
	
	  var Progress = kind === 'linear' ? _LinearProgress.LinearProgress : _CircleProgress.CircleProgress;
	
	  return _react2.default.createElement(
	    _ProgressHolderStyled.ProgressHolderStyled,
	    {
	      kind: kind,
	      customWidth: width,
	      customHeight: height,
	      alignX: alignX,
	      alignY: alignY
	    },
	    _react2.default.createElement(
	      Progress,
	      (0, _lodash2.default)(props, preloaderProps),
	      props.children
	    )
	  );
	};
	
	Preloader.propTypes = propTypes;
	Preloader.defaultProps = defaultProps;
	Preloader.displayName = 'Preloader';

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ProgressHolderStyled = undefined;
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var alignXMap = {
	  left: 'flex-start',
	  center: 'center',
	  right: 'flex-end'
	};
	
	var alignYMap = {
	  top: 'flex-start',
	  center: 'center',
	  bottom: 'flex-end'
	};
	
	var align = function align(_ref) {
	  var alignX = _ref.alignX,
	      alignY = _ref.alignY;
	  return '\n  align-items: ' + alignYMap[alignY] + ';\n  justify-content: ' + alignXMap[alignX] + ';\n';
	};
	
	var style = function style(_ref2) {
	  var themeFromProvider = _ref2.theme,
	      customHeight = _ref2.customHeight,
	      customWidth = _ref2.customWidth;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var _theme$reactackle$com = theme.reactackle.components.progress.preloader,
	      backgroundColor = _theme$reactackle$com.backgroundColor,
	      loaderMaxWidth = _theme$reactackle$com.loaderMaxWidth,
	      height = _theme$reactackle$com.height,
	      width = _theme$reactackle$com.width;
	
	
	  return (0, _styledComponents.css)(['background-color:', ';width:', ';height:', ';& > *{max-width:', ';}'], backgroundColor, (0, _reactackleCore.getValueString)(customWidth || width), (0, _reactackleCore.getValueString)(customHeight || height), (0, _reactackleCore.getValueString)(loaderMaxWidth));
	};
	
	var ProgressHolderStyled = exports.ProgressHolderStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'ProgressHolderStyled'
	})(['width:100%;height:100%;margin:auto;position:relative;pointer-events:none;display:flex;', ' ', ' & > *{width:100%;}'], style, align);
	
	ProgressHolderStyled.displayName = 'ProgressHolderStyled';

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LabelWrapperStyled = undefined;
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var positionMap = {
	  top: {
	    order: 1,
	    opposite: 'bottom'
	  },
	  bottom: {
	    order: 3,
	    opposite: 'top'
	  }
	};
	
	var align = function align(_ref) {
	  var labelAlign = _ref.labelAlign;
	  return 'text-align: ' + labelAlign + ';';
	};
	
	var position = function position(_ref2) {
	  var labelPositionY = _ref2.labelPositionY,
	      progressType = _ref2.progressType,
	      themeFromProvider = _ref2.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var labelPadding = theme.reactackle.components.progress.circle.labelCenteredPadding;
	
	  var spacing = labelPositionY !== 'center' ? theme.reactackle.components.progress[progressType].labelSpacing[labelPositionY] : null;
	
	  return labelPositionY !== 'center' ? (0, _styledComponents.css)(['order:', ';margin-', ':', ';'], positionMap[labelPositionY].order, positionMap[labelPositionY].opposite, (0, _reactackleCore.getValueString)(spacing)) : '\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    justify-content: center;\n    padding: ' + (0, _reactackleCore.getValueString)(labelPadding) + ';\n    word-wrap: break-word;\n  ';
	};
	
	var LabelWrapperStyled = exports.LabelWrapperStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'LabelWrapperStyled'
	})(['', ' ', ''], align, position);
	
	LabelWrapperStyled.displayName = 'LabelWrapperStyled';

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SupplementTextStyled = undefined;
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var style = function style(_ref) {
	  var themeFromProvider = _ref.theme,
	      progressType = _ref.progressType;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var _theme$reactackle$com = theme.reactackle.components.progress[progressType].supplementText,
	      fontSize = _theme$reactackle$com.fontSize,
	      lineHeight = _theme$reactackle$com.lineHeight,
	      fontWeight = _theme$reactackle$com.fontWeight;
	
	
	  return (0, _styledComponents.css)(['font-size:', ';line-height:', ';font-weight:', ';'], (0, _reactackleCore.getValueString)(fontSize), lineHeight, fontWeight);
	};
	
	var SupplementTextStyled = exports.SupplementTextStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'SupplementTextStyled'
	})(['', ''], style);
	
	SupplementTextStyled.displayName = 'SupplementTextStyled';

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ValueLabelStyled = undefined;
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var style = function style(_ref) {
	  var themeFromProvider = _ref.theme,
	      progressType = _ref.progressType;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var _theme$reactackle$com = theme.reactackle.components.progress[progressType].valueLabel,
	      fontSize = _theme$reactackle$com.fontSize,
	      lineHeight = _theme$reactackle$com.lineHeight,
	      fontWeight = _theme$reactackle$com.fontWeight;
	
	
	  return (0, _styledComponents.css)(['font-size:', ';line-height:', ';font-weight:', ';'], (0, _reactackleCore.getValueString)(fontSize), lineHeight, fontWeight);
	};
	
	var ValueLabelStyled = exports.ValueLabelStyled = _styledComponents2.default.label.withConfig({
	  displayName: 'ValueLabelStyled'
	})(['display:block;', ''], style);
	
	ValueLabelStyled.displayName = 'ValueLabelStyled';

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CircleProgress = __webpack_require__(218);
	
	Object.keys(_CircleProgress).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _CircleProgress[key];
	    }
	  });
	});
	
	var _LinearProgress = __webpack_require__(219);
	
	Object.keys(_LinearProgress).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _LinearProgress[key];
	    }
	  });
	});
	
	var _Preloader = __webpack_require__(768);
	
	Object.keys(_Preloader).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Preloader[key];
	    }
	  });
	});
	
	var _reactackleCore = __webpack_require__(3);
	
	var _theme = __webpack_require__(774);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _reactackleCore.registerDefaultComponentTheme)('progress', _theme2.default);

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _color = __webpack_require__(110);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var preloaderBackgroundColor = function preloaderBackgroundColor(base) {
	  return (0, _color2.default)(base.colorPaletteGrey[100]).fade(0.4).string();
	};
	
	exports.default = {
	  circle: {
	    strokeSize: 10,
	    circleSize: 100,
	    labelCenteredPadding: _reactackleCore.baseModule,
	
	    labelSpacing: {
	      top: _reactackleCore.baseModule,
	      bottom: _reactackleCore.baseModule
	    },
	
	    valueLabel: {
	      fontSize: _reactackleCore.fontSizeBody,
	      fontWeight: _reactackleCore.fontWeightSemibold,
	      lineHeight: 1.5
	    },
	
	    supplementText: {
	      fontSize: _reactackleCore.fontSizeSmall,
	      fontWeight: _reactackleCore.fontWeightNormal,
	      lineHeight: 1.25
	    },
	
	    bgLine: {
	      colourDefault: _reactackleCore.colorPaletteGrey200
	    },
	
	    mainLine: {
	      color: _reactackleCore.colorMain,
	      startColor: { h: 45, s: 94, v: 100 },
	      endColor: { h: 121, s: 56, v: 69 }
	    },
	
	    secondaryLine: {
	      color: null,
	      opacity: 0.15
	    },
	
	    animation: {
	      svg: {
	        transitionDuration: 1000
	      },
	      circle: {
	        transitionDuration: 2000
	      }
	    }
	  },
	
	  linear: {
	    thickness: 4,
	
	    labelSpacing: {
	      top: _reactackleCore.baseModule,
	      bottom: _reactackleCore.baseModule
	    },
	
	    valueLabel: {
	      fontSize: _reactackleCore.fontSizeBody,
	      fontWeight: _reactackleCore.fontWeightSemibold,
	      lineHeight: 1.5
	    },
	
	    supplementText: {
	      fontSize: _reactackleCore.fontSizeSmall,
	      fontWeight: _reactackleCore.fontWeightNormal,
	      lineHeight: 1.25
	    },
	
	    background: {
	      colourDefault: _reactackleCore.colorPaletteGrey200
	    },
	
	    mainLine: {
	      color: _reactackleCore.colorMain,
	      startColor: { h: 45, s: 94, v: 100 },
	      endColor: { h: 121, s: 56, v: 69 }
	    },
	
	    secondaryLine: {
	      color: null,
	      opacity: 0.15
	    }
	  },
	
	  preloader: {
	    backgroundColor: preloaderBackgroundColor,
	    loaderMaxWidth: 300,
	    width: '100%',
	    height: 100
	  }
	};

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Radio = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactackleCore = __webpack_require__(3);
	
	var _RadioStyled = __webpack_require__(777);
	
	var _RadioLabelStyled = __webpack_require__(776);
	
	var _theme = __webpack_require__(781);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	(0, _reactackleCore.registerDefaultComponentTheme)('radio', _theme2.default);
	
	var nextId = 0;
	
	var propTypes = {
	  /**
	   * Value of the radio
	   */
	  value: _propTypes2.default.any,
	  /**
	   * Determines whether radio is checked
	   */
	  checked: _propTypes2.default.bool,
	  /**
	   * Determines whether radio is checked by default
	   */
	  defaultChecked: _propTypes2.default.bool,
	  /**
	   * Determines whether radio is diables
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * Determines label text of the radio
	   */
	  text: _propTypes2.default.string,
	  /**
	   * Specify function to call on radio value change
	   */
	  onChange: _propTypes2.default.func,
	  /**
	   * Item's index for group binding
	   */
	  index: _propTypes2.default.number
	};
	var defaultProps = {
	  value: void 0,
	  checked: void 0,
	  defaultChecked: false,
	  disabled: false,
	  text: '',
	  onChange: _reactackleCore.noop,
	  index: 0
	};
	
	var Radio = exports.Radio = function (_Component) {
	  _inherits(Radio, _Component);
	
	  function Radio(props) {
	    _classCallCheck(this, Radio);
	
	    var _this = _possibleConstructorReturn(this, (Radio.__proto__ || Object.getPrototypeOf(Radio)).call(this, props));
	
	    _this._inputId = 'radio-' + nextId++;
	
	    _this.state = {
	      checked: (0, _reactackleCore.isUndef)(_this.props.checked) ? props.defaultChecked : _this.props.checked
	    };
	
	    _this._handleChange = _this._handleChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(Radio, [{
	    key: '_handleChange',
	    value: function _handleChange(event) {
	      var checked = event.target.checked;
	
	      this.props.onChange({
	        value: this.props.value,
	        index: this.props.index
	      });
	
	      if (this.props.checked === null) this.setState({ checked: checked });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var checked = (0, _reactackleCore.isUndef)(this.props.checked) ? this.state.checked : this.props.checked;
	
	      return _react2.default.createElement(
	        _RadioStyled.RadioStyled,
	        null,
	        _react2.default.createElement('input', {
	          id: this._inputId,
	          type: 'radio',
	          checked: checked,
	          disabled: this.props.disabled,
	          onChange: this._handleChange,
	          tabIndex: '0'
	        }),
	        _react2.default.createElement(
	          _RadioLabelStyled.RadioLabelStyled,
	          {
	            checked: checked,
	            disabled: this.props.disabled,
	            htmlFor: this._inputId
	          },
	          this.props.text
	        )
	      );
	    }
	  }]);
	
	  return Radio;
	}(_react.Component);
	
	Radio.propTypes = propTypes;
	Radio.defaultProps = defaultProps;
	Radio.displayName = 'Radio';

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.RadioLabelStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  checked: _propTypes2.default.bool,
	  disabled: _propTypes2.default.bool,
	  /**
	   * Define theme
	   * See https://github.com/styled-components/styled-components/blob/master/docs/theming.md
	   * for more information
	   */
	  theme: _propTypes2.default.object
	};
	var defaultProps = {
	  checked: false,
	  disabled: false
	};
	
	/** PROP RECEIVERS */
	var inputBase = function inputBase(_ref) {
	  var themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var _theme$reactackle$com = theme.reactackle.components.radio.input,
	      size = _theme$reactackle$com.size,
	      borderWidth = _theme$reactackle$com.borderWidth,
	      borderRadius = _theme$reactackle$com.borderRadius;
	  var _theme$reactackle$com2 = theme.reactackle.components.radio.label,
	      fontSize = _theme$reactackle$com2.fontSize,
	      lineHeight = _theme$reactackle$com2.lineHeight;
	
	
	  var borderWdth = (0, _reactackleCore.getValueString)(borderWidth),
	      sizeString = (0, _reactackleCore.getValueString)(size),
	      top = 'calc(' + lineHeight / 2 + 'em - ' + sizeString + ' / 2 - ' + borderWdth + ')';
	
	  return '\n    top: ' + top + ';\n    width: ' + sizeString + ';\n    height: ' + sizeString + ';\n    border-radius: ' + (0, _reactackleCore.getValueString)(borderRadius) + ';\n    border-width: ' + borderWdth + ';\n    border-style: solid;\n    font-size: ' + (0, _reactackleCore.getValueString)(fontSize) + ';\n  ';
	};
	
	var labelBase = function labelBase(_ref2) {
	  var themeFromProvider = _ref2.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var size = (0, _reactackleCore.getValueString)(theme.reactackle.components.radio.input.size);
	
	  var _theme$reactackle$com3 = theme.reactackle.components.radio.label,
	      inputLabelSpacing = _theme$reactackle$com3.inputLabelSpacing,
	      fontSize = _theme$reactackle$com3.fontSize,
	      lineHeight = _theme$reactackle$com3.lineHeight;
	
	
	  return '\n    padding-left: calc(' + size + ' + ' + (0, _reactackleCore.getValueString)(inputLabelSpacing) + ');\n    font-size: ' + (0, _reactackleCore.getValueString)(fontSize) + ';\n    line-height: ' + lineHeight + ';\n    min-width: ' + size + ';\n    min-height: ' + size + ';\n  ';
	};
	
	var labelStateProps = function labelStateProps(_ref3) {
	  var checked = _ref3.checked,
	      disabled = _ref3.disabled,
	      themeFromProvider = _ref3.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var source = null;
	  var inputSource = null;
	  var styles = null;
	
	  if (checked) {
	    source = theme.reactackle.components.radio.label.checked;
	    inputSource = theme.reactackle.components.radio.input.checked;
	  } else {
	    source = theme.reactackle.components.radio.label;
	    inputSource = theme.reactackle.components.radio.input;
	  }
	
	  var inputDefault = (0, _styledComponents.css)(['     background-color:', ';border-color:', ';', '    '], inputSource.backgroundColor, inputSource.borderColor, checked ? 'box-shadow:\n         inset 0 0 0 0.5px ' + inputSource.borderColor + ',\n         inset 0 0 0 ' + (0, _reactackleCore.getValueString)(inputSource.knobOffsetSize) + '\n            ' + inputSource.knobOffsetColor + ';' : null);
	
	  var inputHover = (0, _styledComponents.css)(['     background-color:', ';border-color:', ';', '    '], inputSource.hover.backgroundColor, inputSource.hover.borderColor, checked ? 'box-shadow:\n         inset 0 0 0 0.5px ' + inputSource.hover.borderColor + ',\n         inset 0 0 0 ' + (0, _reactackleCore.getValueString)(inputSource.hover.knobOffsetSize) + '\n            ' + inputSource.hover.knobOffsetColor + ';' : null);
	
	  var inputFocus = (0, _styledComponents.css)(['     background-color:', ';border-color:', ';', '    '], inputSource.focus.backgroundColor, inputSource.focus.borderColor, checked ? 'box-shadow:\n           inset 0 0 0 0.5px ' + inputSource.focus.borderColor + ',\n           inset 0 0 0 ' + (0, _reactackleCore.getValueString)(inputSource.focus.knobOffsetSize) + '\n              ' + inputSource.focus.knobOffsetColor + ';' : null);
	
	  var inputDisabled = (0, _styledComponents.css)(['     background-color:', ';border-color:', ';cursor:default;', '  '], inputSource.disabled.backgroundColor, inputSource.disabled.borderColor, checked ? 'box-shadow:\n           inset 0 0 0 0.5px ' + inputSource.disabled.borderColor + ',\n           inset 0 0 0 ' + (0, _reactackleCore.getValueString)(inputSource.disabled.knobOffsetSize) + '\n              ' + inputSource.disabled.knobOffsetColor + ';' : null);
	
	  if (!disabled) {
	    styles = (0, _styledComponents.css)(['color:', ';&:before{', '}&:hover,&:focus:hover,input[type=\'radio\']:focus + &:hover{color:', ';&:before{', '}}&:focus,input[type=\'radio\']:focus + &{color:', ';&:before{', '}}'], source.fontColor, inputDefault, source.hover.fontColor, inputHover, source.focus.fontColor, inputFocus);
	  } else {
	    styles = (0, _styledComponents.css)(['         &,&:hover,&:focus,input[type=\'radio\']:disabled:focus + &{color:', ';cursor:default;&:before{', '}}'], source.disabled.fontColor, inputDisabled);
	  }
	
	  return styles;
	};
	
	/** STYLES */
	var RadioLabelStyled = exports.RadioLabelStyled = _styledComponents2.default.label.withConfig({
	  displayName: 'RadioLabelStyled'
	})(['position:relative;cursor:pointer;display:block;user-select:none;', ' ', ' ', ';&:before{content:\'\';display:block;position:absolute;left:0;', ' ', ';}'], labelBase, labelStateProps, (0, _reactackleCore.transition)('color'), inputBase, (0, _reactackleCore.transition)('color, background-color, border-color'));
	
	RadioLabelStyled.propTypes = propTypes;
	RadioLabelStyled.defaultProps = defaultProps;
	RadioLabelStyled.displayName = 'RadioLabelStyled';

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.RadioStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * Define theme
	   * See https://github.com/styled-components/styled-components/blob/master/docs/theming.md
	   * for more information
	   */
	  theme: _propTypes2.default.object
	};
	
	// PROP RECEIVERS
	var baseProps = function baseProps(_ref) {
	  var themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var _theme$reactackle$com = theme.reactackle.components.radio.input,
	      size = _theme$reactackle$com.size,
	      similarItemsSpacing = _theme$reactackle$com.similarItemsSpacing;
	
	
	  var fontFamily = theme.reactackle.fontFamily[theme.reactackle.body.fontFamily];
	
	  return '\n    min-width: ' + (0, _reactackleCore.getValueString)(size) + ';\n    min-height: ' + (0, _reactackleCore.getValueString)(size) + ';\n    \n    & + & {\n      margin-top: ' + (0, _reactackleCore.getValueString)(similarItemsSpacing) + ';\n    }\n    \n    &,\n    & *,\n    *::after,\n    *::before {\n      font-family: ' + fontFamily + ';\n      box-sizing: border-box;\n    }\n  ';
	};
	
	var RadioStyled = exports.RadioStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'RadioStyled'
	})(['user-select:none;', ' input[type=\'radio\']{', ';}'], baseProps, _reactackleCore.elementInvisible);
	
	RadioStyled.propTypes = propTypes;
	RadioStyled.displayName = 'RadioStyled';

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactackleCore = __webpack_require__(3);
	
	var _Radio = __webpack_require__(775);
	
	var _RadioGroupStyled = __webpack_require__(780);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  /**
	   * Default value of the RadioGroup
	   */
	  defaultValue: _propTypes2.default.any,
	  /**
	   * Value of the RadioGroup
	   */
	  value: _propTypes2.default.any,
	  /**
	   * Options of the RadioGroup
	   */
	  options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    value: _propTypes2.default.any.isRequired,
	    text: _propTypes2.default.string,
	    disabled: _propTypes2.default.bool
	  })),
	  /**
	   * Specify function to call on RadioGroup value change
	   */
	  onChange: _propTypes2.default.func
	};
	var defaultProps = {
	  defaultValue: void 0,
	  value: void 0,
	  options: [],
	  onChange: _reactackleCore.noop
	};
	
	var RadioGroup = function (_Component) {
	  _inherits(RadioGroup, _Component);
	
	  function RadioGroup(props) {
	    _classCallCheck(this, RadioGroup);
	
	    var _this = _possibleConstructorReturn(this, (RadioGroup.__proto__ || Object.getPrototypeOf(RadioGroup)).call(this, props));
	
	    _this.state = {
	      value: (0, _reactackleCore.isUndef)(props.value) ? props.defaultValue : props.value
	    };
	
	    _this._handleChange = _this._handleChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(RadioGroup, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.value !== this.props.value && (0, _reactackleCore.isUndef)(nextProps.value)) {
	        this.setState({
	          value: this.props.value
	        });
	      }
	    }
	  }, {
	    key: '_getCurrentValue',
	    value: function _getCurrentValue() {
	      return (0, _reactackleCore.isUndef)(this.props.value) ? this.state.value : this.props.value;
	    }
	  }, {
	    key: '_handleChange',
	    value: function _handleChange(_ref) {
	      var value = _ref.value;
	
	      var currentValue = this._getCurrentValue();
	
	      if (currentValue === value) return;
	
	      if ((0, _reactackleCore.isUndef)(this.props.value)) {
	        this.setState({
	          value: value
	        });
	      }
	
	      this.props.onChange({
	        value: value
	      });
	    }
	  }, {
	    key: '_renderOptions',
	    value: function _renderOptions() {
	      var _this2 = this;
	
	      var value = this._getCurrentValue();
	
	      return this.props.options.map(function (item, k) {
	        return _react2.default.createElement(_Radio.Radio, _extends({}, item, {
	          key: (0, _reactackleCore.getKey)(item, k),
	          index: k,
	          onChange: _this2._handleChange,
	          checked: value === item.value
	        }));
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var options = this._renderOptions();
	
	      return _react2.default.createElement(
	        _RadioGroupStyled.RadioGroupStyled,
	        null,
	        options
	      );
	    }
	  }]);
	
	  return RadioGroup;
	}(_react.Component);
	
	exports.default = RadioGroup;
	
	
	RadioGroup.propTypes = propTypes;
	RadioGroup.defaultProps = defaultProps;
	RadioGroup.displayName = 'RadioGroup';

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.RadioGroup = undefined;
	
	var _RadioGroup = __webpack_require__(778);
	
	var _RadioGroup2 = _interopRequireDefault(_RadioGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.RadioGroup = _RadioGroup2.default;

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.RadioGroupStyled = undefined;
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var base = function base(_ref) {
	  var themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var fontFamily = theme.reactackle.fontFamily[theme.reactackle.body.fontFamily];
	
	  return '\n    &,\n    & *,\n    *::after,\n    *::before {\n      font-family: ' + fontFamily + ';\n      box-sizing: border-box;\n    }\n  ';
	};
	
	/** STYLES */
	var RadioGroupStyled = exports.RadioGroupStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'RadioGroupStyled'
	})(['', ';', ';'], /* Prettier workarount until issue is not fixed: https://github.com/prettier/prettier/issues/2291 */'', base);
	
	RadioGroupStyled.displayName = 'RadioGroupStyled';

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactackleCore = __webpack_require__(3);
	
	var radioConstants = {
	  backgroundColorDefault: _reactackleCore.colorTransparent,
	  backgroundColorChecked: _reactackleCore.colorSecondary,
	  labelColorDefault: _reactackleCore.bodyFontColor,
	  labelColorDisabled: _reactackleCore.colorPaletteGrey500
	};
	
	exports.default = {
	  input: {
	    similarItemsSpacing: (0, _reactackleCore.bmodule)(1),
	    size: (0, _reactackleCore.bmodule)(2.25),
	    borderWidth: 1,
	    borderRadius: _reactackleCore.radiusRounded,
	    backgroundColor: radioConstants.backgroundColorDefault,
	    borderColor: _reactackleCore.colorPaletteGrey400,
	
	    hover: {
	      backgroundColor: radioConstants.backgroundColorDefault,
	      borderColor: _reactackleCore.colorPaletteGrey600
	    },
	
	    focus: {
	      backgroundColor: radioConstants.backgroundColorDefault,
	      borderColor: _reactackleCore.colorSecondary
	    },
	
	    disabled: {
	      backgroundColor: _reactackleCore.colorPaletteGrey100,
	      borderColor: _reactackleCore.colorPaletteGrey300
	    },
	
	    checked: {
	      backgroundColor: radioConstants.backgroundColorChecked,
	      borderColor: _reactackleCore.colorSecondary,
	      knobOffsetSize: 3,
	      knobOffsetColor: _reactackleCore.colorWhite,
	
	      hover: {
	        backgroundColor: radioConstants.backgroundColorChecked,
	        borderColor: _reactackleCore.colorPaletteGrey500,
	        knobOffsetSize: 3,
	        knobOffsetColor: _reactackleCore.colorWhite
	      },
	
	      focus: {
	        backgroundColor: radioConstants.backgroundColorChecked,
	        borderColor: _reactackleCore.colorSecondary,
	        knobOffsetSize: 3,
	        knobOffsetColor: _reactackleCore.colorWhite
	      },
	
	      disabled: {
	        backgroundColor: _reactackleCore.colorPaletteGrey200,
	        borderColor: _reactackleCore.colorPaletteGrey300,
	        knobOffsetSize: 3,
	        knobOffsetColor: _reactackleCore.colorWhite
	      }
	    }
	  },
	
	  label: {
	    inputLabelSpacing: (0, _reactackleCore.bmodule)(1),
	    fontSize: function fontSize(_ref) {
	      var _fontSize = _ref.fontSize;
	      return _fontSize[0];
	    },
	    lineHeight: 1.5,
	    fontColor: radioConstants.labelColorDefault,
	
	    hover: {
	      fontColor: radioConstants.labelColorDefault
	    },
	
	    focus: {
	      fontColor: radioConstants.labelColorDefault
	    },
	
	    disabled: {
	      fontColor: radioConstants.labelColorDisabled
	    },
	
	    checked: {
	      fontColor: radioConstants.labelColorDefault,
	
	      hover: {
	        fontColor: radioConstants.labelColorDefault
	      },
	
	      focus: {
	        fontColor: radioConstants.labelColorDefault
	      },
	
	      disabled: {
	        fontColor: radioConstants.labelColorDisabled
	      }
	    }
	  }
	};

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.OptionCustom = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactackleCore = __webpack_require__(3);
	
	var _OptionCustomStyled = __webpack_require__(783);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  fullWidth: _propTypes2.default.bool,
	  dense: _propTypes2.default.bool,
	  selected: _propTypes2.default.bool,
	  disabled: _propTypes2.default.bool,
	  text: _propTypes2.default.string,
	  onClick: _propTypes2.default.func,
	  onKeyDown: _propTypes2.default.func,
	  index: _propTypes2.default.number
	};
	
	var defaultProps = {
	  fullWidth: false,
	  dense: false,
	  selected: false,
	  disabled: false,
	  text: '',
	  onClick: _reactackleCore.noop,
	  onKeyDown: _reactackleCore.noop,
	  index: 0
	};
	
	var OptionCustom = exports.OptionCustom = function (_Component) {
	  _inherits(OptionCustom, _Component);
	
	  function OptionCustom(props) {
	    _classCallCheck(this, OptionCustom);
	
	    var _this = _possibleConstructorReturn(this, (OptionCustom.__proto__ || Object.getPrototypeOf(OptionCustom)).call(this, props));
	
	    _this.state = {};
	
	    _this._handleKeyDown = _this._handleKeyDown.bind(_this);
	    _this._handleClick = _this._handleClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(OptionCustom, [{
	    key: '_handleKeyDown',
	    value: function _handleKeyDown(event) {
	      if (event.keyCode === 32) {
	        event.preventDefault();
	        this.props.onClick(this.props.index);
	      }
	      this.props.onKeyDown(this.props.index, event);
	    }
	  }, {
	    key: '_handleClick',
	    value: function _handleClick() {
	      this.props.onClick(this.props.index);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var itemProps = !this.props.disabled ? {
	        onClick: this._handleClick,
	        onKeyDown: this._handleKeyDown,
	        tabIndex: 0
	      } : {};
	
	      return _react2.default.createElement(
	        _OptionCustomStyled.OptionCustomStyled,
	        _extends({}, itemProps, {
	          disabled: this.props.disabled,
	          selected: this.props.selected,
	          dense: this.props.dense,
	          fullWidth: this.props.fullWidth
	        }),
	        this.props.text
	      );
	    }
	  }]);
	
	  return OptionCustom;
	}(_react.Component);
	
	OptionCustom.propTypes = propTypes;
	OptionCustom.defaultProps = defaultProps;
	OptionCustom.displayName = 'OptionCustom';

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.OptionCustomStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  fullWidth: _propTypes2.default.bool,
	  dense: _propTypes2.default.bool,
	  disabled: _propTypes2.default.bool,
	  selected: _propTypes2.default.bool,
	  /**
	   * Define theme
	   * See https://github.com/styled-components/styled-components/blob/master/docs/theming.md
	   * for more information
	   */
	  theme: _propTypes2.default.object
	};
	
	var defaultProps = {
	  fullWidth: false,
	  dense: false,
	  disabled: false,
	  selected: false
	};
	
	/** Prop Receivers */
	var styleProps = function styleProps(_ref) {
	  var themeFromProvider = _ref.theme,
	      disabled = _ref.disabled,
	      selected = _ref.selected;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var path = theme.reactackle.components.selectBox.option.style;
	  var source = path;
	
	  if (disabled) source = path.disabled;else if (selected) source = path.selected;
	
	  return (0, _styledComponents.css)(['color:', ';background-color:', ';', ''], source.fontColor, source.backgroundColor, !disabled && !selected ? '\n        color: ' + source.fontColor + ';\n        background-color:  ' + source.backgroundColor + ';\n        \n        &:hover {          \n          color: ' + source.hover.fontColor + ';\n          background-color:  ' + source.hover.backgroundColor + ';\n        }\n        \n        &:focus {          \n          color: ' + source.focus.fontColor + ';\n          background-color:  ' + source.focus.backgroundColor + ';\n          outline: none;\n        }\n      ' : '\n        &,\n        &:hover,\n        &:focus {\n          color: ' + source.fontColor + ';\n          background-color:  ' + source.backgroundColor + ';\n          outline: none;\n        }\n      ');
	};
	
	var sizeProps = function sizeProps(_ref2) {
	  var themeFromProvider = _ref2.theme,
	      dense = _ref2.dense,
	      fullWidth = _ref2.fullWidth;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var path = theme.reactackle.components.selectBox.option.size;
	  var source = path;
	
	  if (dense && !fullWidth) source = path.dense;else if (fullWidth && !dense) source = path.fullWidth;else if (fullWidth && dense) source = path.denseFullWidth;
	
	  var _source = source,
	      paddingY = _source.paddingY,
	      paddingX = _source.paddingX,
	      lineHeight = _source.lineHeight,
	      fontSize = _source.fontSize;
	
	
	  return '\n    padding: ' + (0, _reactackleCore.getValueString)(paddingY) + ' ' + (0, _reactackleCore.getValueString)(paddingX) + ';\n    line-height: ' + lineHeight + ';\n    font-size: ' + (0, _reactackleCore.getValueString)(fontSize) + ';\n  ';
	};
	
	/** STYLES */
	var OptionCustomStyled = exports.OptionCustomStyled = _styledComponents2.default.li.withConfig({
	  displayName: 'OptionCustomStyled'
	})(['cursor:pointer;', ' ', ' ', ';'], styleProps, sizeProps, (0, _reactackleCore.transition)('color, background-color'));
	
	OptionCustomStyled.propTypes = propTypes;
	OptionCustomStyled.defaultProps = defaultProps;
	OptionCustomStyled.displayName = 'OptionCustomStyled';

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.OptionsListCustom = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactackleCore = __webpack_require__(3);
	
	var _OptionCustom = __webpack_require__(782);
	
	var _OptionPropTypeCustom = __webpack_require__(222);
	
	var _OptionsListStyled = __webpack_require__(785);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  fullWidth: _propTypes2.default.bool,
	  dense: _propTypes2.default.bool,
	  options: _propTypes2.default.arrayOf(_OptionPropTypeCustom.OptionPropTypeCustom),
	  selectedItem: _OptionPropTypeCustom.OptionPropTypeCustom,
	  onChange: _propTypes2.default.func,
	  createListRef: _propTypes2.default.func,
	  maxLines: _propTypes2.default.number
	};
	
	var defaultProps = {
	  fullWidth: false,
	  dense: false,
	  options: [],
	  selectedItem: {},
	  onChange: _reactackleCore.noop,
	  createListRef: _reactackleCore.noop,
	  maxLines: 5.5
	};
	
	var OptionsListCustom = exports.OptionsListCustom = function (_Component) {
	  _inherits(OptionsListCustom, _Component);
	
	  function OptionsListCustom(props) {
	    _classCallCheck(this, OptionsListCustom);
	
	    var _this = _possibleConstructorReturn(this, (OptionsListCustom.__proto__ || Object.getPrototypeOf(OptionsListCustom)).call(this, props));
	
	    _this._handleOptionClick = _this._handleOptionClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(OptionsListCustom, [{
	    key: '_handleOptionClick',
	    value: function _handleOptionClick(index) {
	      this.select(this.props.options[index]);
	    }
	  }, {
	    key: 'select',
	    value: function select(item) {
	      this.props.onChange({
	        value: item
	      });
	    }
	  }, {
	    key: '_renderOptions',
	    value: function _renderOptions() {
	      var _this2 = this;
	
	      return this.props.options.map(function (item, index) {
	        return _react2.default.createElement(_OptionCustom.OptionCustom, {
	          key: (0, _reactackleCore.getKey)(item, index),
	          text: item.text,
	          selected: item === _this2.props.selectedItem,
	          disabled: item.disabled,
	          item: item,
	          index: index,
	          dense: _this2.props.dense,
	          fullWidth: _this2.props.fullWidth,
	          onClick: _this2._handleOptionClick
	        });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var options = this._renderOptions();
	
	      return _react2.default.createElement(
	        _OptionsListStyled.OptionsListStyled,
	        {
	          innerRef: this.props.createListRef,
	          dense: this.props.dense,
	          fullWidth: this.props.fullWidth,
	          maxLines: this.props.maxLines
	        },
	        options
	      );
	    }
	  }]);
	
	  return OptionsListCustom;
	}(_react.Component);
	
	OptionsListCustom.propTypes = propTypes;
	OptionsListCustom.defaultProps = defaultProps;
	OptionsListCustom.displayName = 'OptionsListCustom';

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.OptionsListStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  fullWidth: _propTypes2.default.bool,
	  dense: _propTypes2.default.bool,
	  /**
	   * Define  theme
	   * See https://github.com/styled-components/styled-components/blob/master/docs/theming.md
	   * for more information
	   */
	  theme: _propTypes2.default.object
	};
	
	var defaultProps = {
	  fullWidth: false,
	  dense: false
	};
	
	/** Prop Receivers */
	var baseProps = function baseProps(_ref) {
	  var themeFromProvider = _ref.theme,
	      maxLines = _ref.maxLines;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var _theme$reactackle$com = theme.reactackle.components.selectBox.optionsList,
	      borderRadius = _theme$reactackle$com.borderRadius,
	      backgroundColor = _theme$reactackle$com.backgroundColor,
	      minWidth = _theme$reactackle$com.minWidth,
	      maxWidth = _theme$reactackle$com.maxWidth,
	      paddingY = _theme$reactackle$com.size.paddingY;
	  var _theme$reactackle$com2 = theme.reactackle.components.selectBox.option.size,
	      fontSize = _theme$reactackle$com2.fontSize,
	      itemPaddingY = _theme$reactackle$com2.paddingY,
	      lineHeight = _theme$reactackle$com2.lineHeight;
	
	
	  var fontFamily = theme.reactackle.fontFamily[theme.reactackle.body.fontFamily];
	
	  var py = (0, _reactackleCore.getValueString)(paddingY),
	      itemPy = (0, _reactackleCore.getValueString)(itemPaddingY),
	      textHeight = lineHeight * maxLines;
	
	  var maxHeight = 'calc(' + py + ' * 2 + ' + textHeight + 'em + ' + itemPy + ' * ' + 2 * maxLines + ')';
	
	  return '\n    font-size: ' + (0, _reactackleCore.getValueString)(fontSize) + ';\n    min-width: ' + (0, _reactackleCore.getValueString)(minWidth) + ';\n    max-width: ' + (0, _reactackleCore.getValueString)(maxWidth) + ';\n    max-height: ' + maxHeight + ';\n    background-color:  ' + backgroundColor + ';\n    border-radius: ' + (0, _reactackleCore.getValueString)(borderRadius) + ';\n    \n    &,\n    & *,\n    *::after,\n    *::before {\n      font-family: ' + fontFamily + ';\n      box-sizing: border-box;\n    }\n  ';
	};
	
	var sizeProps = function sizeProps(_ref2) {
	  var themeFromProvider = _ref2.theme,
	      dense = _ref2.dense,
	      fullWidth = _ref2.fullWidth;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var path = theme.reactackle.components.selectBox.optionsList.size;
	  var source = path;
	
	  if (dense && !fullWidth) source = path.dense;else if (fullWidth && !dense) source = path.fullWidth;else if (fullWidth && dense) source = path.denseFullWidth;
	
	  var _source = source,
	      paddingY = _source.paddingY,
	      paddingX = _source.paddingX;
	
	
	  return 'padding: ' + (0, _reactackleCore.getValueString)(paddingY) + ' ' + (0, _reactackleCore.getValueString)(paddingX) + ';';
	};
	
	/** Styles */
	var OptionsListStyled = exports.OptionsListStyled = _styledComponents2.default.ul.withConfig({
	  displayName: 'OptionsListStyled'
	})(['overflow-y:auto;max-height:100vh;list-style-type:none;width:100%;z-index:1;user-select:none;margin:0;', ' ', ' ', ';'], (0, _reactackleCore.boxShadow)(1), baseProps, sizeProps);
	
	OptionsListStyled.propTypes = propTypes;
	OptionsListStyled.defaultProps = defaultProps;
	OptionsListStyled.displayName = 'OptionsListStyled';

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.OptionsListNative = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactackleCore = __webpack_require__(3);
	
	var _OptionPropTypeNative = __webpack_require__(223);
	
	var _SelectElementStyled = __webpack_require__(787);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  fullWidth: _propTypes2.default.bool,
	  dense: _propTypes2.default.bool,
	  bordered: _propTypes2.default.bool,
	  options: _propTypes2.default.arrayOf(_OptionPropTypeNative.OptionPropTypeNative),
	  value: _propTypes2.default.number,
	  disabled: _propTypes2.default.bool,
	  placeholder: _propTypes2.default.string,
	  colorScheme: _propTypes2.default.oneOf(['neutral', 'error', 'success']),
	  onChange: _propTypes2.default.func
	};
	
	var defaultProps = {
	  fullWidth: false,
	  dense: false,
	  bordered: false,
	  colorScheme: 'neutral',
	  options: [],
	  value: -1,
	  disabled: false,
	  placeholder: '',
	  onChange: _reactackleCore.noop
	};
	
	var OptionsListNative = exports.OptionsListNative = function (_Component) {
	  _inherits(OptionsListNative, _Component);
	
	  function OptionsListNative(props) {
	    _classCallCheck(this, OptionsListNative);
	
	    var _this = _possibleConstructorReturn(this, (OptionsListNative.__proto__ || Object.getPrototypeOf(OptionsListNative)).call(this, props));
	
	    _this._handleChange = _this._handleChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(OptionsListNative, [{
	    key: '_handleChange',
	    value: function _handleChange(event) {
	      this.setState({
	        value: event.target.value
	      });
	
	      this.props.onChange({
	        value: this.props.options[event.target.value] || null
	      });
	    }
	  }, {
	    key: '_renderOptions',
	    value: function _renderOptions() {
	      if (!this.props.options.length) return null;
	
	      return [_react2.default.createElement(
	        'option',
	        { value: -1, key: -1, disabled: true },
	        this.props.placeholder
	      )].concat(_toConsumableArray(this.props.options.map(function (item, idx) {
	        return _react2.default.createElement(
	          'option',
	          {
	            value: idx,
	            key: (0, _reactackleCore.getKey)(item, idx),
	            disabled: item.disabled || false
	          },
	          item.text
	        );
	      })));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var options = this._renderOptions();
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _SelectElementStyled.SelectElementStyled,
	          {
	            value: this.props.value,
	            disabled: this.props.disabled,
	            dense: this.props.dense,
	            fullWidth: this.props.fullWidth,
	            bordered: this.props.bordered,
	            colorScheme: this.props.colorScheme,
	            onChange: this._handleChange
	          },
	          options
	        )
	      );
	    }
	  }]);
	
	  return OptionsListNative;
	}(_react.Component);
	
	OptionsListNative.propTypes = propTypes;
	OptionsListNative.defaultProps = defaultProps;
	OptionsListNative.displayName = 'OptionsListNative';

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SelectElementStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  fullWidth: _propTypes2.default.bool,
	  dense: _propTypes2.default.bool,
	  disabled: _propTypes2.default.bool,
	  focused: _propTypes2.default.bool,
	  bordered: _propTypes2.default.bool,
	  colorScheme: _propTypes2.default.oneOf(['neutral', 'error', 'success']),
	  /**
	   * Define theme
	   * See https://github.com/styled-components/styled-components/blob/master/docs/theming.md
	   * for more information
	   */
	  theme: _propTypes2.default.object
	};
	
	var defaultProps = {
	  fullWidth: false,
	  dense: false,
	  disabled: false,
	  focused: false,
	  bordered: false,
	  colorScheme: 'neutral'
	};
	
	/** Prop Receivers */
	var sizeProps = function sizeProps(_ref) {
	  var dense = _ref.dense,
	      fullWidth = _ref.fullWidth,
	      bordered = _ref.bordered,
	      themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var path = theme.reactackle.components.selectBox.selectBox,
	      styleKey = bordered ? 'bordered' : 'underlined';
	  var source = path[styleKey].size;
	
	  if (dense && !fullWidth) source = path[styleKey].size.dense;else if (dense && fullWidth) source = path[styleKey].size.denseFullWidth;else if (!dense && fullWidth) source = path[styleKey].size.fullWidth;
	
	  var _source = source,
	      paddingY = _source.paddingY,
	      paddingX = _source.paddingX,
	      lineHeight = _source.lineHeight,
	      fontSize = _source.fontSize;
	  var minWidth = path.minWidth;
	
	
	  var sizeDependentStyles = null;
	  if (fullWidth) {
	    sizeDependentStyles = '\n      display: flex;\n      align-items: center;\n    ';
	  }
	
	  return (0, _styledComponents.css)(['padding:', ' ', ';line-height:', ';font-size:', ';min-height:', 'em;min-width:', ';', ''], (0, _reactackleCore.getValueString)(paddingY), (0, _reactackleCore.getValueString)(paddingX), lineHeight, (0, _reactackleCore.getValueString)(fontSize), lineHeight, (0, _reactackleCore.getValueString)(minWidth), sizeDependentStyles);
	};
	
	var styleProps = function styleProps(_ref2) {
	  var disabled = _ref2.disabled,
	      focused = _ref2.focused,
	      colorScheme = _ref2.colorScheme,
	      themeFromProvider = _ref2.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var source = theme.reactackle.components.selectBox.selectBox.style;
	
	  var fontFamily = theme.reactackle.fontFamily[theme.reactackle.body.fontFamily];
	
	  if (disabled) {
	    return '\n      cursor: default;\n      user-select: none;\n      \n      &,\n      &:hover,\n      &:focus {\n        background-color: ' + source.disabled.backgroundColor + ';\n        color: ' + source.disabled.fontColor + ';\n        border-color: ' + source.disabled.borderColor + ';\n        border-style: ' + source.disabled.borderStyle + ';\n        outline: none;\n      }\n    ';
	  } else if (colorScheme === 'neutral' && !focused) {
	    return (0, _styledComponents.css)(['background-color:', ';color:', ';border-color:', ';border-style:', ';cursor:pointer;&:hover{outline:none;background-color:', ';color:', ';border-color:', ';border-style:', ';}&:focus{outline:none;cursor:pointer;background-color:', ';color:', ';border-color:', ';border-style:', ';}'], source.backgroundColor, source.fontColor, source.borderColor, source.borderStyle, source.hover.backgroundColor, source.hover.fontColor, source.hover.borderColor, source.hover.borderStyle, source.focus.backgroundColor, source.focus.fontColor, source.focus.borderColor, source.focus.borderStyle);
	  }
	
	  return (0, _styledComponents.css)(['&,&:hover,&:focus{background-color:', ';color:', ';border-color:', ';border-style:', ';outline:none;cursor:pointer;}&,& *,*::after,*::before{font-family:', ';box-sizing:border-box;}'], source[colorScheme].backgroundColor, source[colorScheme].fontColor, source[colorScheme].borderColor, source[colorScheme].borderStyle, fontFamily);
	};
	
	var borderProps = function borderProps(_ref3) {
	  var bordered = _ref3.bordered,
	      fullWidth = _ref3.fullWidth,
	      themeFromProvider = _ref3.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var source = bordered ? theme.reactackle.components.selectBox.selectBox.bordered : theme.reactackle.components.selectBox.selectBox.underlined;
	
	  var borderWidth = source.borderWidth,
	      borderRadius = source.borderRadius;
	
	
	  return bordered ? (0, _styledComponents.css)(['border-width:', ';border-radius:', ';'], fullWidth ? '0' : (0, _reactackleCore.getValueString)(borderWidth), (0, _reactackleCore.getValueString)(borderRadius)) : (0, _styledComponents.css)(['border-width:0;border-bottom-width:', ';border-radius:', ';'], fullWidth ? '0' : (0, _reactackleCore.getValueString)(borderWidth), (0, _reactackleCore.getValueString)(borderRadius));
	};
	
	/** Styles */
	var SelectElementStyled = exports.SelectElementStyled = _styledComponents2.default.select.withConfig({
	  displayName: 'SelectElementStyled'
	})(['position:relative;width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:100%;position:relative;flex-grow:1;font-family:inherit;', ' ', ' ', ' ', ';'], sizeProps, styleProps, borderProps, (0, _reactackleCore.transition)('color, background, border'));
	
	SelectElementStyled.propTypes = propTypes;
	SelectElementStyled.defaultProps = defaultProps;
	SelectElementStyled.displayName = 'SelectElementStyled';

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = SelectBox;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactackleCore = __webpack_require__(3);
	
	var _SelectBoxCustom = __webpack_require__(789);
	
	var _SelectBoxNative = __webpack_require__(794);
	
	var _theme = __webpack_require__(797);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _reactackleCore.registerDefaultComponentTheme)('selectBox', _theme2.default);
	
	var propTypes = _extends({}, _SelectBoxNative.SelectBoxNative.propTypes, _SelectBoxCustom.SelectBoxCustom.propTypes, {
	  /**
	   * Type of the SelectBox
	   */
	  type: _propTypes2.default.oneOf(['custom', 'native'])
	});
	
	var defaultProps = _extends({}, _SelectBoxNative.SelectBoxNative.defaultProps, _SelectBoxCustom.SelectBoxCustom.defaultProps, {
	  type: 'custom'
	});
	
	function SelectBox(props) {
	  var Select = props.type === 'custom' ? _SelectBoxCustom.SelectBoxCustom : _SelectBoxNative.SelectBoxNative;
	
	  return _react2.default.createElement(Select, props);
	}
	
	SelectBox.propTypes = propTypes;
	SelectBox.defaultProps = defaultProps;
	SelectBox.displayName = 'SelectBox';

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SelectBoxCustom = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactackleTooltipIcon = __webpack_require__(52);
	
	var _reactackleAutoposition = __webpack_require__(65);
	
	var _reactackleCore = __webpack_require__(3);
	
	var _OptionPropTypeCustom = __webpack_require__(222);
	
	var _OptionsListCustom = __webpack_require__(784);
	
	var _SelectBoxCustomStyled = __webpack_require__(793);
	
	var _ContentBoxStyled = __webpack_require__(224);
	
	var _WrapperStyled = __webpack_require__(230);
	
	var _ButtonStyled = __webpack_require__(791);
	
	var _ButtonTextStyled = __webpack_require__(792);
	
	var _ArrowIconStyled = __webpack_require__(790);
	
	var _SelectBoxStyled = __webpack_require__(229);
	
	var _SelectBoxLabelStyled = __webpack_require__(227);
	
	var _SelectBoxLabelTextStyled = __webpack_require__(228);
	
	var _SelectBoxInfoBoxStyled = __webpack_require__(226);
	
	var _MessageStyled = __webpack_require__(225);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  /**
	   * Determines whether SelectBox is full width
	   */
	  fullWidth: _propTypes2.default.bool,
	  /**
	   * Determines dense of the SelectBox
	   */
	  dense: _propTypes2.default.bool,
	  /**
	   * Determines whether SelectBox is disabled
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * Default value of the SelectBox
	   */
	  defaultValue: _propTypes2.default.any,
	  /**
	   * Value of the SelectBox
	   */
	  value: _propTypes2.default.any,
	  /**
	   * Reverse options list
	   */
	  reverse: _propTypes2.default.bool,
	  /**
	   * Define help or error message
	   */
	  message: _propTypes2.default.string,
	  /**
	   * Determines placeholder of the SelectBox
	   */
	  placeholder: _propTypes2.default.string,
	  /**
	   * Tooltip text of the SelectBox
	   */
	  tooltip: _propTypes2.default.string,
	  /**
	   * Label text of the SelectBox
	   */
	  label: _propTypes2.default.string,
	  /**
	   * Specify maximum amount of options, visible at the same time without
	   * scrolling
	   */
	  maxOptionsVisible: _propTypes2.default.number,
	  /**
	   * Determines label position
	   */
	  labelPosition: _propTypes2.default.oneOf(['top', 'side']),
	  /**
	   * Determines whether SelectBox is bordered
	   */
	  bordered: _propTypes2.default.bool,
	  /**
	   * Color scheme of the SelectBox
	   */
	  colorScheme: _propTypes2.default.oneOf(['neutral', 'error', 'success']),
	  /**
	   * @ignore
	   */
	  theme: _propTypes2.default.object.isRequired,
	  /**
	   * Determines options of the SelectBox
	   */
	  options: _propTypes2.default.arrayOf(_OptionPropTypeCustom.OptionPropTypeCustom),
	  /**
	   * Specify function to call on SelectBox value change
	   */
	  onChange: _propTypes2.default.func
	};
	
	var defaultProps = {
	  fullWidth: false,
	  dense: false,
	  disabled: false,
	  defaultValue: void 0,
	  value: void 0,
	  reverse: false,
	  message: '',
	  placeholder: '',
	  label: '',
	  labelPosition: 'top',
	  tooltip: '',
	  bordered: false,
	  colorScheme: 'neutral',
	  options: [],
	  onChange: _reactackleCore.noop,
	  maxOptionsVisible: 5
	};
	
	var openSelectBox = null;
	
	var clickHandler = function clickHandler(event) {
	  if (openSelectBox) {
	    var listDOMNode = openSelectBox._optionsList;
	    if (listDOMNode && !listDOMNode.contains(event.target)) openSelectBox.close();
	  }
	};
	
	var KEYS = {
	  SPACE: 32,
	  DOWN_ARROW: 40,
	  UP_ARROW: 38
	};
	
	var customSelectBoxesNum = 0;
	var nextId = 0;
	
	var _SelectBoxCustom = function (_Component) {
	  _inherits(_SelectBoxCustom, _Component);
	
	  function _SelectBoxCustom(props) {
	    _classCallCheck(this, _SelectBoxCustom);
	
	    var _this = _possibleConstructorReturn(this, (_SelectBoxCustom.__proto__ || Object.getPrototypeOf(_SelectBoxCustom)).call(this, props));
	
	    _this.state = {
	      id: 'select-box-' + nextId++,
	      value: (0, _reactackleCore.isUndef)(props.value) ? props.defaultValue : props.value,
	      open: false,
	      onTop: false,
	      checkOverflowHeight: false
	    };
	
	    _this._optionsList = null;
	    _this._listWrapper = null;
	    _this._handleChange = _this._handleChange.bind(_this);
	    _this._createListRef = _this._createListRef.bind(_this);
	    _this._handleKeyDown = _this._handleKeyDown.bind(_this);
	    _this._handleLinkClick = _this._handleLinkClick.bind(_this);
	    _this._handleWrapperClick = _this._handleWrapperClick.bind(_this);
	    _this.open = _this.open.bind(_this);
	    _this.close = _this.close.bind(_this);
	    _this.toggle = _this.toggle.bind(_this);
	    _this._createListWrapperRef = _this._createListWrapperRef.bind(_this);
	    return _this;
	  }
	
	  _createClass(_SelectBoxCustom, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (!customSelectBoxesNum) window.addEventListener('click', clickHandler, false);
	
	      customSelectBoxesNum++;
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.value !== this.props.value && (0, _reactackleCore.isUndef)(nextProps.value)) {
	        this.setState({
	          value: this.props.value
	        });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      customSelectBoxesNum--;
	
	      if (!customSelectBoxesNum) window.removeEventListener('click', clickHandler, false);
	    }
	  }, {
	    key: '_createListRef',
	    value: function _createListRef(ref) {
	      this._optionsList = ref;
	    }
	  }, {
	    key: '_createListWrapperRef',
	    value: function _createListWrapperRef(ref) {
	      this._listWrapper = ref;
	    }
	  }, {
	    key: '_getCurrentValue',
	    value: function _getCurrentValue() {
	      return (0, _reactackleCore.isUndef)(this.props.value) ? this.state.value : this.props.value;
	    }
	  }, {
	    key: '_handleLinkClick',
	    value: function _handleLinkClick() {
	      this.open();
	    }
	  }, {
	    key: 'toggle',
	    value: function toggle() {
	      if (this.state.open) this.close();else this._handleLinkClick();
	    }
	  }, {
	    key: 'open',
	    value: function open() {
	      if (this.props.disabled || this.state.open) return;
	      this.setState({
	        open: true
	      });
	
	      if (openSelectBox) openSelectBox.close();
	      openSelectBox = this;
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      if (!this.state.open) return;
	
	      this.setState({
	        open: false
	      });
	
	      openSelectBox = null;
	    }
	  }, {
	    key: '_handleChange',
	    value: function _handleChange(_ref) {
	      var value = _ref.value;
	
	      var newState = {
	        open: false
	      };
	
	      openSelectBox = null;
	
	      if ((0, _reactackleCore.isUndef)(this.props.value)) newState.value = value.value;
	
	      this.setState(newState);
	
	      this.props.onChange({
	        value: value.value
	      });
	    }
	  }, {
	    key: '_handleWrapperClick',
	    value: function _handleWrapperClick(event) {
	      event.stopPropagation();
	    }
	  }, {
	    key: '_handleKeyDown',
	    value: function _handleKeyDown(e) {
	      if (e.keyCode === KEYS.SPACE) {
	        this._handleLinkClick();
	        e.preventDefault();
	      }
	    }
	  }, {
	    key: '_renderLabel',
	    value: function _renderLabel() {
	      var tooltip = this.props.tooltip ? _react2.default.createElement(_reactackleTooltipIcon.TooltipIcon, { text: this.props.tooltip }) : null;
	
	      return _react2.default.createElement(
	        _SelectBoxLabelStyled.SelectBoxLabelStyled,
	        {
	          htmlFor: this.state.id,
	          dense: this.props.dense,
	          fullWidth: this.props.fullWidth,
	          labelPosition: this.props.labelPosition,
	          bordered: this.props.bordered,
	          disabled: this.props.disabled,
	          colorScheme: this.props.colorScheme,
	          focus: this.state.open
	        },
	        _react2.default.createElement(
	          _SelectBoxLabelTextStyled.SelectBoxLabelTextStyled,
	          null,
	          this.props.label
	        ),
	        tooltip
	      );
	    }
	  }, {
	    key: '_renderMessage',
	    value: function _renderMessage() {
	      if (!this.props.message) return null;
	
	      return _react2.default.createElement(
	        _SelectBoxInfoBoxStyled.SelectBoxInfoBoxStyled,
	        {
	          dense: this.props.dense,
	          fullWidth: this.props.fullWidth,
	          labelPosition: this.props.labelPosition,
	          bordered: this.props.bordered,
	          disabled: this.props.disabled
	        },
	        _react2.default.createElement(
	          _MessageStyled.MessageStyled,
	          {
	            colorScheme: this.props.colorScheme,
	            disabled: this.props.disabled,
	            focus: this.state.open
	          },
	          this.props.message
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var data = this.props.reverse ? [].concat(_toConsumableArray(this.props.options)).reverse() : this.props.options;
	
	      var value = this._getCurrentValue(),
	          hasValue = !(0, _reactackleCore.isUndef)(value) && value !== null;
	
	      var selectedItem = hasValue ? data.find(function (item) {
	        return item.value === value;
	      }) : null;
	
	      var text = hasValue && selectedItem ? selectedItem.text : this.props.placeholder;
	
	      var label = this._renderLabel(),
	          message = this._renderMessage();
	
	      return _react2.default.createElement(
	        _SelectBoxStyled.SelectBoxStyled,
	        null,
	        _react2.default.createElement(
	          _SelectBoxCustomStyled.SelectBoxCustomStyled,
	          { onClick: this._handleWrapperClick },
	          _react2.default.createElement(
	            _ContentBoxStyled.ContentBoxStyled,
	            { labelPosition: this.props.labelPosition },
	            label,
	            _react2.default.createElement(
	              _WrapperStyled.WrapperStyled,
	              { innerRef: this._createListWrapperRef },
	              _react2.default.createElement(
	                _ButtonStyled.ButtonStyled,
	                {
	                  fullWidth: this.props.fullWidth,
	                  dense: this.props.dense,
	                  bordered: this.props.bordered,
	                  disabled: this.props.disabled,
	                  focused: this.state.open,
	                  colorScheme: this.props.colorScheme,
	                  tabIndex: 0,
	                  onClick: this._handleLinkClick,
	                  onKeyDown: this._handleKeyDown
	                },
	                _react2.default.createElement(
	                  _ButtonTextStyled.ButtonTextStyled,
	                  {
	                    dense: this.props.dense,
	                    fullWidth: this.props.fullWidth,
	                    bordered: this.props.bordered
	                  },
	                  text
	                ),
	                _react2.default.createElement(
	                  _ArrowIconStyled.ArrowIconStyled,
	                  {
	                    fullWidth: this.props.fullWidth,
	                    dense: this.props.dense,
	                    disabled: this.props.disabled,
	                    focused: this.state.open,
	                    colorScheme: this.props.colorScheme
	                  },
	                  this.props.theme.reactackle.components.selectBox.icon.element
	                )
	              ),
	              _react2.default.createElement(
	                _reactackleAutoposition.AutoPosition,
	                {
	                  parent: this._listWrapper,
	                  positionX: 'left',
	                  positionY: 'top',
	                  type: 'inner',
	                  direction: 'vertical',
	                  visible: this.state.open
	                },
	                _react2.default.createElement(_OptionsListCustom.OptionsListCustom, {
	                  createListRef: this._createListRef,
	                  options: data,
	                  selectedItem: selectedItem,
	                  placeholder: this.props.placeholder,
	                  maxLines: this.props.maxOptionsVisible,
	                  onChange: this._handleChange
	                })
	              )
	            )
	          ),
	          message
	        )
	      );
	    }
	  }]);
	
	  return _SelectBoxCustom;
	}(_react.Component);
	
	_SelectBoxCustom.propTypes = propTypes;
	_SelectBoxCustom.defaultProps = defaultProps;
	_SelectBoxCustom.displayName = 'SelectBoxCustom';
	
	var SelectBoxCustom = exports.SelectBoxCustom = (0, _reactackleCore.withTheme)(_SelectBoxCustom);

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ArrowIconStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleIcons = __webpack_require__(7);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  fullWidth: _propTypes2.default.bool,
	  dense: _propTypes2.default.bool,
	  disabled: _propTypes2.default.bool,
	  focused: _propTypes2.default.bool,
	  colorScheme: _propTypes2.default.oneOf(['neutral', 'error', 'success'])
	};
	
	var defaultProps = {
	  fullWidth: false,
	  dense: false,
	  disabled: false,
	  focused: false,
	  colorScheme: 'neutral'
	};
	
	/** Prop Receivers */
	var sizeProps = function sizeProps(_ref) {
	  var dense = _ref.dense,
	      fullWidth = _ref.fullWidth,
	      themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var path = theme.reactackle.components.selectBox.icon.size;
	  var source = path;
	
	  if (dense && !fullWidth) source = path.dense;else if (dense && fullWidth) source = path.denseFullWidth;else if (!dense && fullWidth) source = path.fullWidth;
	
	  var _source = source,
	      boxSize = _source.boxSize,
	      imgSize = _source.imgSize;
	
	
	  return (0, _styledComponents.css)(['     ', ''], (0, _reactackleCore.iconSizeMixin)((0, _reactackleCore.getValueString)(boxSize), (0, _reactackleCore.getValueString)(imgSize || boxSize), (0, _reactackleCore.getValueString)(boxSize)));
	};
	
	var styleProps = function styleProps(_ref2) {
	  var themeFromProvider = _ref2.theme,
	      disabled = _ref2.disabled,
	      focused = _ref2.focused,
	      colorScheme = _ref2.colorScheme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var path = theme.reactackle.components.selectBox.icon.state;
	  var source = path[colorScheme];
	
	  if (disabled) source = path.disabled;else if (colorScheme === 'neutral' && !focused && !disabled) source = path;else if (colorScheme === 'neutral' && focused && !disabled) source = path.focus;
	
	  var _source2 = source,
	      color = _source2.color,
	      opacity = _source2.opacity;
	
	
	  return '\n    &,\n    &:hover,\n    &:focus {\n      opacity: ' + opacity + ';\n      ' + (0, _reactackleIcons.iconStyleMixin)(color) + ';\n    }\n  ';
	};
	
	/** Styles */
	var ArrowIconStyled = exports.ArrowIconStyled = _styledComponents2.default.span.withConfig({
	  displayName: 'ArrowIconStyled'
	})(['pointer-events:none;display:flex;', ' ', ' ', ';'], sizeProps, styleProps, (0, _reactackleCore.transition)('color, opacity'));
	
	ArrowIconStyled.propTypes = propTypes;
	ArrowIconStyled.defaultProps = defaultProps;
	ArrowIconStyled.displayName = 'ArrowIconStyled';

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ButtonStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  fullWidth: _propTypes2.default.bool,
	  dense: _propTypes2.default.bool,
	  disabled: _propTypes2.default.bool,
	  focused: _propTypes2.default.bool,
	  bordered: _propTypes2.default.bool,
	  colorScheme: _propTypes2.default.oneOf(['neutral', 'error', 'success']),
	  /**
	   * Define theme
	   * See https://github.com/styled-components/styled-components/blob/master/docs/theming.md
	   * for more information
	   */
	  theme: _propTypes2.default.object
	};
	
	var defaultProps = {
	  fullWidth: false,
	  dense: false,
	  disabled: false,
	  focused: false,
	  bordered: false,
	  colorScheme: 'neutral'
	};
	
	/** Prop Receivers */
	var sizeProps = function sizeProps(_ref) {
	  var fullWidth = _ref.fullWidth,
	      themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var minWidth = theme.reactackle.components.selectBox.selectBox.minWidth;
	
	
	  var sizeDependentStyles = null;
	  if (fullWidth) {
	    sizeDependentStyles = '\n      display: flex;\n      align-items: center;\n    ';
	  }
	
	  return (0, _styledComponents.css)(['min-width:', ';', ''], (0, _reactackleCore.getValueString)(minWidth), sizeDependentStyles);
	};
	
	var styleProps = function styleProps(_ref2) {
	  var disabled = _ref2.disabled,
	      focused = _ref2.focused,
	      colorScheme = _ref2.colorScheme,
	      themeFromProvider = _ref2.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var source = theme.reactackle.components.selectBox.selectBox.style;
	
	  if (disabled) {
	    return '\n      cursor: default;\n      user-select: none;\n      \n      &,\n      &:hover,\n      &:focus {\n        background-color: ' + source.disabled.backgroundColor + ';\n        color: ' + source.disabled.fontColor + ';\n        border-color: ' + source.disabled.borderColor + ';\n        border-style: ' + source.disabled.borderStyle + ';\n        outline: none;\n      }\n    ';
	  }
	
	  if (colorScheme === 'neutral') {
	    if (focused) {
	      return '\n        outline: none;\n        cursor: pointer; \n        background-color: ' + source.focus.backgroundColor + ';\n        color: ' + source.focus.fontColor + ';\n        border-color: ' + source.focus.borderColor + ';\n        border-style: ' + source.focus.borderStyle + ';\n      ';
	    }
	
	    return (0, _styledComponents.css)(['background-color:', ';color:', ';border-color:', ';border-style:', ';cursor:pointer;&:hover{outline:none;background-color:', ';color:', ';border-color:', ';border-style:', ';}'], source.backgroundColor, source.fontColor, source.borderColor, source.borderStyle, source.hover.backgroundColor, source.hover.fontColor, source.hover.borderColor, source.hover.borderStyle);
	  }
	
	  return (0, _styledComponents.css)(['background-color:', ';color:', ';border-color:', ';border-style:', ';cursor:pointer;&:hover{outline:none;background-color:', ';color:', ';border-color:', ';border-style:', ';}&:focus{outline:none;background-color:', ';color:', ';border-color:', ';border-style:', ';}'], source[colorScheme].backgroundColor, source[colorScheme].fontColor, source[colorScheme].borderColor, source[colorScheme].borderStyle, source[colorScheme].hover.backgroundColor, source[colorScheme].hover.fontColor, source[colorScheme].hover.borderColor, source[colorScheme].hover.borderStyle, source[colorScheme].hover.backgroundColor, source[colorScheme].hover.fontColor, source[colorScheme].hover.borderColor, source[colorScheme].hover.borderStyle);
	};
	
	var borderProps = function borderProps(_ref3) {
	  var bordered = _ref3.bordered,
	      fullWidth = _ref3.fullWidth,
	      themeFromProvider = _ref3.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var source = bordered ? theme.reactackle.components.selectBox.selectBox.bordered : theme.reactackle.components.selectBox.selectBox.underlined;
	
	  var borderWidth = source.borderWidth,
	      borderRadius = source.borderRadius;
	
	
	  return bordered ? (0, _styledComponents.css)(['border-width:', ';border-radius:', ';'], fullWidth ? '0' : (0, _reactackleCore.getValueString)(borderWidth), (0, _reactackleCore.getValueString)(borderRadius)) : (0, _styledComponents.css)(['border-width:0;border-bottom-width:', ';border-radius:', ';'], fullWidth ? '0' : (0, _reactackleCore.getValueString)(borderWidth), (0, _reactackleCore.getValueString)(borderRadius));
	};
	
	/** Styles */
	var ButtonStyled = exports.ButtonStyled = _styledComponents2.default.button.withConfig({
	  displayName: 'ButtonStyled'
	})(['display:flex;width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;flex-grow:1;user-select:none;max-width:100%;position:relative;align-items:center;text-align:left;padding:0;', ' ', ' ', ' ', ' &:focus{outline:none;}'], sizeProps, styleProps, borderProps, (0, _reactackleCore.transition)('color, background, border'));
	
	ButtonStyled.propTypes = propTypes;
	ButtonStyled.defaultProps = defaultProps;
	ButtonStyled.displayName = 'ButtonStyled';

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ButtonTextStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  fullWidth: _propTypes2.default.bool,
	  dense: _propTypes2.default.bool,
	  bordered: _propTypes2.default.bool,
	  /**
	   * Define theme
	   * See https://github.com/styled-components/styled-components/blob/master/docs/theming.md
	   * for more information
	   */
	  theme: _propTypes2.default.object
	};
	
	var defaultProps = {
	  fullWidth: false,
	  dense: false,
	  bordered: false
	};
	
	/** Prop Receivers */
	var sizeProps = function sizeProps(_ref) {
	  var dense = _ref.dense,
	      fullWidth = _ref.fullWidth,
	      bordered = _ref.bordered,
	      themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var path = theme.reactackle.components.selectBox.selectBox,
	      styleKey = bordered ? 'bordered' : 'underlined';
	
	  var source = path[styleKey].size;
	
	  if (dense && !fullWidth) source = path[styleKey].size.dense;else if (dense && fullWidth) source = path[styleKey].size.denseFullWidth;else if (!dense && fullWidth) source = path[styleKey].size.fullWidth;
	
	  var _source = source,
	      paddingY = _source.paddingY,
	      paddingX = _source.paddingX,
	      lineHeight = _source.lineHeight,
	      fontSize = _source.fontSize;
	
	
	  return '\n    padding: ' + (0, _reactackleCore.getValueString)(paddingY) + ' ' + (0, _reactackleCore.getValueString)(paddingX) + ';\n    line-height: ' + lineHeight + ';\n    font-size: ' + (0, _reactackleCore.getValueString)(fontSize) + ';\n    min-height: ' + lineHeight + 'em;\n  ';
	};
	
	/** Styles */
	var ButtonTextStyled = exports.ButtonTextStyled = _styledComponents2.default.span.withConfig({
	  displayName: 'ButtonTextStyled'
	})(['overflow:hidden;text-overflow:ellipsis;flex-grow:1;', ';'], sizeProps);
	
	ButtonTextStyled.propTypes = propTypes;
	ButtonTextStyled.defaultProps = defaultProps;
	ButtonTextStyled.displayName = 'ButtonTextStyled';

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SelectBoxCustomStyled = undefined;
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SelectBoxCustomStyled = exports.SelectBoxCustomStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'SelectBoxCustomStyled'
	})(['display:flex;position:relative;flex-direction:column;width:100%;']);
	
	SelectBoxCustomStyled.displayName = 'SelectBoxCustomStyled';

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SelectBoxNative = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactackleTooltipIcon = __webpack_require__(52);
	
	var _reactackleCore = __webpack_require__(3);
	
	var _OptionsListNative = __webpack_require__(786);
	
	var _OptionPropTypeNative = __webpack_require__(223);
	
	var _SelectBoxStyled = __webpack_require__(229);
	
	var _SelectBoxLabelStyled = __webpack_require__(227);
	
	var _SelectBoxLabelTextStyled = __webpack_require__(228);
	
	var _SelectBoxInfoBoxStyled = __webpack_require__(226);
	
	var _MessageStyled = __webpack_require__(225);
	
	var _ContentBoxStyled = __webpack_require__(224);
	
	var _WrapperStyled = __webpack_require__(230);
	
	var _SelectBoxNativeStyled = __webpack_require__(795);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  /**
	   * Determines whether SelectBox is full width
	   */
	  fullWidth: _propTypes2.default.bool,
	  /**
	   * Determines dense of the SelectBox
	   */
	  dense: _propTypes2.default.bool,
	  /**
	   * Determines whether SelectBox is disabled
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * Default value of the SelectBox
	   */
	  defaultValue: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  /**
	   * Default value of the SelectBox
	   */
	  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  /**
	   * Reverse options list
	   */
	  reverse: _propTypes2.default.bool,
	  /**
	   * Define help or error message
	   */
	  message: _propTypes2.default.string,
	  /**
	   * Determines placeholder of the SelectBox
	   */
	  placeholder: _propTypes2.default.string,
	  /**
	   * Tooltip text of the SelectBox
	   */
	  tooltip: _propTypes2.default.string,
	  /**
	   * Label text of the SelectBox
	   */
	  label: _propTypes2.default.string,
	  /**
	   * Determines label position
	   */
	  labelPosition: _propTypes2.default.oneOf(['top', 'side']),
	  /**
	   * Determines whether SelectBox is bordered
	   */
	  bordered: _propTypes2.default.bool,
	  /**
	   * Color scheme of the SelectBox
	   */
	  colorScheme: _propTypes2.default.oneOf(['neutral', 'error', 'success']),
	  /**
	   * Determines options of the SelectBox
	   */
	  options: _propTypes2.default.arrayOf(_OptionPropTypeNative.OptionPropTypeNative),
	  /**
	   * Specify function to call on SelectBox value change
	   */
	  onChange: _propTypes2.default.func
	};
	var defaultProps = {
	  fullWidth: false,
	  dense: false,
	  disabled: false,
	  defaultValue: void 0,
	  value: void 0,
	  reverse: false,
	  message: '',
	  placeholder: '',
	  tooltip: '',
	  label: '',
	  labelPosition: 'top',
	  bordered: false,
	  colorScheme: 'neutral',
	  options: [],
	  onChange: _reactackleCore.noop
	};
	
	var nextId = 0;
	
	var SelectBoxNative = exports.SelectBoxNative = function (_Component) {
	  _inherits(SelectBoxNative, _Component);
	
	  function SelectBoxNative(props) {
	    _classCallCheck(this, SelectBoxNative);
	
	    var _this = _possibleConstructorReturn(this, (SelectBoxNative.__proto__ || Object.getPrototypeOf(SelectBoxNative)).call(this, props));
	
	    _this.state = {
	      id: 'select-box-' + nextId++,
	      value: (0, _reactackleCore.isUndef)(props.value) ? props.defaultValue : props.value
	    };
	    _this._handleChange = _this._handleChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(SelectBoxNative, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.value !== this.props.value && (0, _reactackleCore.isUndef)(nextProps.value)) {
	        this.setState({
	          value: this.props.value
	        });
	      }
	    }
	  }, {
	    key: '_handleChange',
	    value: function _handleChange(_ref) {
	      var value = _ref.value;
	
	      if ((0, _reactackleCore.isUndef)(this.props.value)) {
	        this.setState({
	          value: value.value
	        });
	      }
	
	      this.props.onChange({
	        value: value.value
	      });
	    }
	  }, {
	    key: '_renderLabel',
	    value: function _renderLabel() {
	      var tooltip = this.props.tooltip ? _react2.default.createElement(_reactackleTooltipIcon.TooltipIcon, { text: this.props.tooltip }) : null;
	
	      return _react2.default.createElement(
	        _SelectBoxLabelStyled.SelectBoxLabelStyled,
	        {
	          htmlFor: this.state.id,
	          dense: this.props.dense,
	          fullWidth: this.props.fullWidth,
	          labelPosition: this.props.labelPosition,
	          bordered: this.props.bordered,
	          disabled: this.props.disabled,
	          colorScheme: this.props.colorScheme,
	          focus: this.state.open
	        },
	        _react2.default.createElement(
	          _SelectBoxLabelTextStyled.SelectBoxLabelTextStyled,
	          null,
	          this.props.label
	        ),
	        tooltip
	      );
	    }
	  }, {
	    key: '_renderMessage',
	    value: function _renderMessage() {
	      if (!this.props.message) return null;
	
	      return _react2.default.createElement(
	        _SelectBoxInfoBoxStyled.SelectBoxInfoBoxStyled,
	        {
	          dense: this.props.dense,
	          fullWidth: this.props.fullWidth,
	          labelPosition: this.props.labelPosition,
	          bordered: this.props.bordered,
	          disabled: this.props.disabled
	        },
	        _react2.default.createElement(
	          _MessageStyled.MessageStyled,
	          {
	            colorScheme: this.props.colorScheme,
	            disabled: this.props.disabled
	          },
	          this.props.message
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var options = this.props.reverse ? [].concat(_toConsumableArray(this.props.options)).reverse() : this.props.options;
	
	      var currentValue = (0, _reactackleCore.isUndef)(this.props.value) ? this.state.value : this.props.value;
	
	      var value = options.findIndex(function (item) {
	        return item.value === currentValue;
	      });
	
	      var label = this._renderLabel(),
	          message = this._renderMessage();
	
	      return _react2.default.createElement(
	        _SelectBoxStyled.SelectBoxStyled,
	        null,
	        _react2.default.createElement(
	          _SelectBoxNativeStyled.SelectBoxNativeStyled,
	          null,
	          _react2.default.createElement(
	            _ContentBoxStyled.ContentBoxStyled,
	            null,
	            label,
	            _react2.default.createElement(
	              _WrapperStyled.WrapperStyled,
	              null,
	              _react2.default.createElement(_OptionsListNative.OptionsListNative, {
	                options: options,
	                value: value,
	                disabled: this.props.disabled,
	                placeholder: this.props.placeholder,
	                dense: this.props.dense,
	                fullWidth: this.props.fullWidth,
	                bordered: this.props.bordered,
	                colorScheme: this.props.colorScheme,
	                onChange: this._handleChange
	              })
	            )
	          ),
	          message
	        )
	      );
	    }
	  }]);
	
	  return SelectBoxNative;
	}(_react.Component);
	
	SelectBoxNative.propTypes = propTypes;
	SelectBoxNative.defaultProps = defaultProps;
	SelectBoxNative.displayName = 'SelectBoxNative';

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SelectBoxNativeStyled = undefined;
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SelectBoxNativeStyled = exports.SelectBoxNativeStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'SelectBoxNativeStyled'
	})(['display:flex;position:relative;flex-direction:column;width:100%;']);
	
	SelectBoxNativeStyled.displayName = 'SelectBoxNativeStyled';

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SelectBox = undefined;
	
	var _SelectBox = __webpack_require__(788);
	
	var _SelectBox2 = _interopRequireDefault(_SelectBox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.SelectBox = _SelectBox2.default;

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactackleCore = __webpack_require__(3);
	
	var _reactackleIcons = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var constants = {
	  themeColor: _reactackleCore.colorSecondary,
	  fontColor: _reactackleCore.bodyFontColor,
	  backgroundColor: _reactackleCore.colorTransparent,
	  borderStyle: 'solid',
	
	  size: {
	    paddingY: (0, _reactackleCore.bmodule)(1),
	    paddingX: (0, _reactackleCore.bmodule)(1),
	    fontSize: _reactackleCore.fontSizeBody,
	    lineHeight: 1.5, // Only number accepted
	
	    dense: {
	      paddingY: (0, _reactackleCore.bmodule)(0.5),
	      paddingX: (0, _reactackleCore.bmodule)(0.5),
	      fontSize: _reactackleCore.fontSizeBody,
	      lineHeight: 1.5 // Only number accepted
	    },
	
	    fullWidth: {
	      paddingY: (0, _reactackleCore.bmodule)(1.5),
	      paddingX: (0, _reactackleCore.bmodule)(1.5),
	      fontSize: _reactackleCore.fontSizeBody,
	      lineHeight: 1.5 // Only number accepted
	    },
	
	    denseFullWidth: {
	      paddingY: (0, _reactackleCore.bmodule)(1),
	      paddingX: (0, _reactackleCore.bmodule)(1),
	      fontSize: _reactackleCore.fontSizeBody,
	      lineHeight: 1.5 // Only number accepted
	    }
	  },
	
	  underlined: {
	    paddingY: (0, _reactackleCore.bmodule)(1)
	  },
	
	  iconOuter: {
	    opacity: 0.54
	  },
	
	  iconInner: {
	    opacity: 0.46
	  }
	};
	
	exports.default = {
	  selectBox: {
	    themeColor: constants.themeColor,
	    placeholderFontColor: _reactackleCore.fontColorMedium,
	    minWidth: 120,
	
	    style: {
	      fontColor: constants.fontColor,
	      backgroundColor: constants.backgroundColor,
	      borderColor: _reactackleCore.colorPaletteGrey300,
	      borderStyle: constants.borderStyle,
	
	      hover: {
	        fontColor: constants.fontColor,
	        backgroundColor: 'rgba(0,0,0,0.03)',
	        borderColor: constants.themeColor,
	        borderStyle: constants.borderStyle
	      },
	
	      focus: {
	        fontColor: constants.fontColor,
	        backgroundColor: _reactackleCore.colorWhite,
	        borderColor: constants.themeColor,
	        borderStyle: constants.borderStyle
	      },
	
	      disabled: {
	        fontColor: _reactackleCore.fontColorMedium,
	        backgroundColor: _reactackleCore.colorTransparent,
	        borderColor: _reactackleCore.colorPaletteGrey300,
	        borderStyle: 'dotted'
	      },
	
	      error: {
	        fontColor: _reactackleCore.colorError,
	        backgroundColor: constants.backgroundColor,
	        borderColor: _reactackleCore.colorError,
	        borderStyle: constants.borderStyle,
	
	        hover: {
	          fontColor: _reactackleCore.colorError,
	          backgroundColor: 'rgba(0,0,0,0.03)',
	          borderColor: _reactackleCore.colorError,
	          borderStyle: constants.borderStyle
	        },
	
	        focus: {
	          fontColor: _reactackleCore.colorError,
	          backgroundColor: 'rgba(0,0,0,0.03)',
	          borderColor: _reactackleCore.colorError,
	          borderStyle: constants.borderStyle
	        }
	      },
	
	      success: {
	        fontColor: constants.fontColor,
	        backgroundColor: constants.backgroundColor,
	        borderColor: _reactackleCore.colorSuccess,
	        borderStyle: constants.borderStyle,
	
	        hover: {
	          fontColor: constants.fontColor,
	          backgroundColor: 'rgba(0,0,0,0.03)',
	          borderColor: _reactackleCore.colorSuccess,
	          borderStyle: constants.borderStyle
	        },
	
	        focus: {
	          fontColor: constants.fontColor,
	          backgroundColor: 'rgba(0,0,0,0.03)',
	          borderColor: _reactackleCore.colorSuccess,
	          borderStyle: constants.borderStyle
	        }
	      }
	    },
	
	    bordered: {
	      borderWidth: 1,
	      borderRadius: _reactackleCore.radiusDefault,
	
	      size: {
	        paddingY: constants.size.paddingY,
	        paddingX: constants.size.paddingX,
	        lineHeight: constants.size.lineHeight,
	        fontSize: constants.size.fontSize,
	
	        dense: {
	          paddingY: constants.size.dense.paddingY,
	          paddingX: constants.size.dense.paddingX,
	          lineHeight: constants.size.lineHeight,
	          fontSize: constants.size.dense.fontSize
	        },
	
	        fullWidth: {
	          paddingY: constants.size.fullWidth.paddingY,
	          paddingX: constants.size.fullWidth.paddingX,
	          lineHeight: constants.size.lineHeight,
	          fontSize: constants.size.fullWidth.fontSize
	        },
	
	        denseFullWidth: {
	          paddingY: constants.size.denseFullWidth.paddingY,
	          paddingX: constants.size.denseFullWidth.paddingX,
	          lineHeight: constants.size.lineHeight,
	          fontSize: constants.size.denseFullWidth.fontSize
	        }
	      }
	    },
	
	    underlined: {
	      borderWidth: 2,
	      borderRadius: 0,
	
	      size: {
	        paddingY: constants.size.paddingY,
	        paddingX: 0,
	        lineHeight: constants.size.lineHeight,
	        fontSize: constants.size.fontSize,
	
	        dense: {
	          paddingY: constants.size.dense.paddingY,
	          paddingX: 0,
	          lineHeight: constants.size.lineHeight,
	          fontSize: constants.size.dense.fontSize
	        },
	
	        fullWidth: {
	          paddingY: constants.size.fullWidth.paddingY,
	          paddingX: 0,
	          lineHeight: constants.size.lineHeight,
	          fontSize: constants.size.fullWidth.fontSize
	        },
	
	        denseFullWidth: {
	          paddingY: constants.size.denseFullWidth.paddingY,
	          paddingX: 0,
	          lineHeight: constants.size.lineHeight,
	          fontSize: constants.size.denseFullWidth.fontSize
	        }
	      }
	    }
	  },
	
	  label: {
	    positionTop: {
	      fontSize: _reactackleCore.fontSizeSmall,
	      lineHeight: 1,
	      textTransform: 'none',
	      fontWeight: _reactackleCore.fontWeightNormal,
	
	      style: {
	        fontColor: _reactackleCore.fontColorMedium,
	
	        disabled: {
	          fontColor: _reactackleCore.fontColorMedium
	        },
	
	        focus: {
	          fontColor: constants.themeColor
	        },
	
	        error: {
	          fontColor: _reactackleCore.colorError
	        },
	
	        success: {
	          fontColor: _reactackleCore.colorSuccess
	        }
	      },
	
	      size: {
	        bordered: {
	          labelSelectSpacing: (0, _reactackleCore.bmodule)(1),
	
	          dense: {
	            labelSelectSpacing: (0, _reactackleCore.bmodule)(0.5)
	          },
	
	          fullWidth: {
	            labelSelectSpacing: (0, _reactackleCore.bmodule)(0.5)
	          },
	
	          denseFullWidth: {
	            labelSelectSpacing: (0, _reactackleCore.bmodule)(0.5)
	          }
	        },
	
	        underlined: {
	          labelSelectSpacing: (0, _reactackleCore.bmodule)(0.5),
	
	          dense: {
	            labelSelectSpacing: (0, _reactackleCore.bmodule)(0.5)
	          },
	
	          fullWidth: {
	            labelSelectSpacing: (0, _reactackleCore.bmodule)(0.5)
	          },
	
	          denseFullWidth: {
	            labelSelectSpacing: (0, _reactackleCore.bmodule)(0.5)
	          }
	        }
	      }
	    },
	
	    positionSide: {
	      fontSize: _reactackleCore.fontSizeBody,
	      lineHeight: _reactackleCore.bodyLineHeight,
	      textTransform: 'none',
	      fontWeight: _reactackleCore.fontWeightNormal,
	      width: '30%',
	
	      style: {
	        fontColor: _reactackleCore.bodyFontColor,
	
	        disabled: {
	          fontColor: _reactackleCore.fontColorMedium
	        },
	
	        focus: {
	          fontColor: constants.themeColor
	        },
	
	        error: {
	          fontColor: _reactackleCore.colorError
	        },
	
	        success: {
	          fontColor: _reactackleCore.colorSuccess
	        }
	      },
	
	      size: {
	        bordered: {
	          labelSelectSpacing: (0, _reactackleCore.bmodule)(1),
	
	          dense: {
	            labelSelectSpacing: (0, _reactackleCore.bmodule)(1)
	          },
	
	          fullWidth: {
	            labelSelectSpacing: (0, _reactackleCore.bmodule)(1)
	          },
	
	          denseFullWidth: {
	            labelSelectSpacing: (0, _reactackleCore.bmodule)(1)
	          }
	        },
	        underlined: {
	          labelSelectSpacing: (0, _reactackleCore.bmodule)(1),
	
	          dense: {
	            labelSelectSpacing: (0, _reactackleCore.bmodule)(1)
	          },
	
	          fullWidth: {
	            labelSelectSpacing: (0, _reactackleCore.bmodule)(1)
	          },
	
	          denseFullWidth: {
	            labelSelectSpacing: (0, _reactackleCore.bmodule)(1)
	          }
	        }
	      },
	
	      breakpoints: [{
	        breakpoint: _reactackleCore.breakpointMedium,
	        width: 150
	      }]
	    },
	
	    labelTooltipSpacing: (0, _reactackleCore.bmodule)(1)
	  },
	
	  icon: {
	    iconTextSpacing: (0, _reactackleCore.bmodule)(0.5),
	    element: _react2.default.createElement(_reactackleIcons.IconArrowDropDown, { size: 'custom', color: 'inherit' }),
	
	    state: {
	      color: 'inherit',
	      opacity: constants.iconInner.opacity,
	
	      disabled: {
	        color: 'inherit',
	        opacity: 0.35
	      },
	
	      focus: {
	        color: 'inherit',
	        opacity: 1
	      },
	
	      error: {
	        color: constants.fontColor,
	        opacity: constants.iconInner.opacity
	      },
	
	      success: {
	        color: constants.fontColor,
	        opacity: constants.iconInner.opacity
	      }
	    },
	
	    size: {
	      boxSize: function boxSize(base) {
	        return constants.size.fontSize(base) * constants.size.lineHeight + constants.size.paddingY(base) * 2;
	      },
	      imgSize: 30,
	
	      dense: {
	        boxSize: function boxSize(base) {
	          return constants.size.dense.fontSize(base) * constants.size.dense.lineHeight + constants.size.dense.paddingY(base) * 2;
	        },
	        imgSize: 26
	      },
	
	      fullWidth: {
	        boxSize: function boxSize(base) {
	          return constants.size.fullWidth.fontSize(base) * constants.size.fullWidth.lineHeight + constants.size.fullWidth.paddingY(base) * 2;
	        },
	        imgSize: 30
	      },
	
	      denseFullWidth: {
	        boxSize: function boxSize(base) {
	          return constants.size.denseFullWidth.fontSize(base) * constants.size.denseFullWidth.lineHeight + constants.size.denseFullWidth.paddingY(base) * 2;
	        },
	        imgSize: 30
	      }
	    }
	  },
	
	  message: {
	    messageSelectSpacing: (0, _reactackleCore.bmodule)(1),
	    fontSize: _reactackleCore.fontSizeSmall,
	    lineHeight: 1,
	
	    style: {
	      fontColor: _reactackleCore.fontColorMedium,
	
	      disabled: {
	        fontColor: _reactackleCore.fontColorMedium
	      },
	
	      focus: {
	        fontColor: _reactackleCore.fontColorMedium
	      },
	
	      error: {
	        fontColor: _reactackleCore.colorError
	      },
	
	      success: {
	        fontColor: _reactackleCore.colorSuccess
	      }
	    }
	  },
	
	  optionsList: {
	    borderRadius: _reactackleCore.radiusDefault,
	    backgroundColor: _reactackleCore.colorWhite,
	    minWidth: '5em',
	    maxWidth: '14em',
	
	    size: {
	      paddingY: (0, _reactackleCore.bmodule)(1),
	      paddingX: 0,
	
	      dense: {
	        paddingY: (0, _reactackleCore.bmodule)(1),
	        paddingX: 0
	      },
	
	      fullWidth: {
	        paddingY: (0, _reactackleCore.bmodule)(1),
	        paddingX: 0
	      },
	
	      denseFullWidth: {
	        paddingY: (0, _reactackleCore.bmodule)(1),
	        paddingX: 0
	      }
	    }
	  },
	
	  option: {
	    size: {
	      paddingY: (0, _reactackleCore.bmodule)(1),
	      paddingX: (0, _reactackleCore.bmodule)(2),
	      lineHeight: constants.size.lineHeight,
	      fontSize: constants.size.fontSize,
	
	      dense: {
	        paddingY: (0, _reactackleCore.bmodule)(1),
	        paddingX: (0, _reactackleCore.bmodule)(2),
	        lineHeight: constants.size.lineHeight,
	        fontSize: constants.size.dense.fontSize
	      },
	
	      fullWidth: {
	        paddingY: (0, _reactackleCore.bmodule)(1),
	        paddingX: (0, _reactackleCore.bmodule)(2),
	        lineHeight: constants.size.lineHeight,
	        fontSize: constants.size.fullWidth.fontSize
	      },
	
	      denseFullWidth: {
	        paddingY: (0, _reactackleCore.bmodule)(1),
	        paddingX: (0, _reactackleCore.bmodule)(2),
	        lineHeight: constants.size.lineHeight,
	        fontSize: constants.size.denseFullWidth.fontSize
	      }
	    },
	
	    style: {
	      fontColor: constants.fontColor,
	      backgroundColor: _reactackleCore.colorTransparent,
	
	      hover: {
	        fontColor: constants.fontColor,
	        backgroundColor: _reactackleCore.colorPaletteGrey100
	      },
	
	      focus: {
	        fontColor: constants.fontColor,
	        backgroundColor: _reactackleCore.colorPaletteGrey100
	      },
	
	      disabled: {
	        fontColor: _reactackleCore.fontColorMedium,
	        backgroundColor: _reactackleCore.colorTransparent
	      },
	
	      selected: {
	        fontColor: constants.themeColor,
	        backgroundColor: _reactackleCore.colorTransparent
	      }
	    }
	  }
	};

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactackleCore = __webpack_require__(3);
	
	var _SidebarToggle = __webpack_require__(231);
	
	var _SidebarStyled = __webpack_require__(809);
	
	var _SidebarBoxStyled = __webpack_require__(808);
	
	var _theme = __webpack_require__(810);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	(0, _reactackleCore.registerDefaultComponentTheme)('sidebar', _theme2.default);
	
	var propTypes = {
	  /**
	   * Determines whether sidebar have toggle button
	   */
	  haveToggleButton: _propTypes2.default.bool,
	  /**
	   * Determines text of toggle button
	   */
	  toggleButtonText: _propTypes2.default.string,
	  /**
	   * Determines whether sidebar is expanded
	   */
	  expanded: _propTypes2.default.bool,
	  /**
	   * Determines whether to render Sidebar on the right side
	   */
	  attachToRight: _propTypes2.default.bool,
	  /**
	   * Allow to Sidebar to collapse on narrow screens
	   * requires haveToggleButton prop set to true
	   */
	  autoCollapsing: _propTypes2.default.bool,
	  /**
	   * Specify function to call on ToggleButton click
	   */
	  onToggle: _propTypes2.default.func
	};
	
	var defaultProps = {
	  haveToggleButton: false,
	  toggleButtonText: 'Collapse',
	  expanded: void 0,
	  attachToRight: false,
	  autoCollapsing: false,
	  onToggle: _reactackleCore.noop
	};
	
	var Sidebar = function (_Component) {
	  _inherits(Sidebar, _Component);
	
	  function Sidebar(props) {
	    _classCallCheck(this, Sidebar);
	
	    var _this = _possibleConstructorReturn(this, (Sidebar.__proto__ || Object.getPrototypeOf(Sidebar)).call(this, props));
	
	    _this.state = {
	      expanded: (0, _reactackleCore.isUndef)(props.expanded) ? true : props.expanded
	    };
	
	    _this._handleToggle = _this._handleToggle.bind(_this);
	    return _this;
	  }
	
	  _createClass(Sidebar, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.expanded !== this.props.expanded && (0, _reactackleCore.isUndef)(nextProps.expanded)) {
	        this.setState({
	          expanded: this.props.expanded
	        });
	      }
	    }
	  }, {
	    key: '_getCurrentExpanded',
	    value: function _getCurrentExpanded() {
	      return (0, _reactackleCore.isUndef)(this.props.expanded) ? this.state.expanded : this.props.expanded;
	    }
	  }, {
	    key: '_handleToggle',
	    value: function _handleToggle() {
	      var expanded = !this._getCurrentExpanded();
	
	      if ((0, _reactackleCore.isUndef)(this.props.expanded)) {
	        this.setState({
	          expanded: expanded
	        });
	      }
	
	      this.props.onToggle(expanded);
	    }
	  }, {
	    key: '_renderToggleButton',
	    value: function _renderToggleButton() {
	      if (!this.props.haveToggleButton) return null;
	
	      var expanded = this._getCurrentExpanded();
	
	      return _react2.default.createElement(_SidebarToggle.SidebarToggle, {
	        toggleButtonText: this.props.toggleButtonText,
	        expanded: expanded,
	        autoCollapsing: this.props.autoCollapsing,
	        onClick: this._handleToggle
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var toggleButton = this._renderToggleButton(),
	          expanded = this._getCurrentExpanded();
	
	      return _react2.default.createElement(
	        _SidebarStyled.SidebarStyled,
	        {
	          expanded: expanded,
	          autoCollapsing: this.props.autoCollapsing,
	          attachToRight: this.props.attachToRight,
	          haveToggleButton: this.props.haveToggleButton
	        },
	        _react2.default.createElement(
	          _SidebarBoxStyled.SidebarBoxStyled,
	          {
	            expanded: expanded,
	            autoCollapsing: this.props.autoCollapsing,
	            attachToRight: this.props.attachToRight,
	            haveToggleButton: this.props.haveToggleButton
	          },
	          toggleButton,
	          this.props.children
	        )
	      );
	    }
	  }]);
	
	  return Sidebar;
	}(_react.Component);
	
	exports.default = Sidebar;
	
	
	Sidebar.propTypes = propTypes;
	Sidebar.defaultProps = defaultProps;
	Sidebar.displayName = 'Sidebar';

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = SidebarRegion;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SidebarRegionStyled = __webpack_require__(801);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  spread: _propTypes2.default.bool,
	  scrollable: _propTypes2.default.bool,
	  bordered: _propTypes2.default.bool,
	  /**
	   * If region is scrollable, it requires some minHeight set
	   * to work properly
	   */
	  scrollableMinHeight: _propTypes2.default.number
	};
	
	var defaultProps = {
	  spread: false,
	  scrollable: false,
	  bordered: false,
	  scrollableMinHeight: 200
	};
	
	function SidebarRegion(props) {
	  return _react2.default.createElement(
	    _SidebarRegionStyled.SidebarRegionStyled,
	    {
	      spread: props.spread,
	      bordered: props.bordered,
	      scrollable: props.scrollable,
	      scrollableMinHeight: props.scrollableMinHeight
	    },
	    props.children
	  );
	}
	
	SidebarRegion.propTypes = propTypes;
	SidebarRegion.defaultProps = defaultProps;
	SidebarRegion.displayName = 'SidebarRegion';

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SidebarRegion = undefined;
	
	var _SidebarRegion = __webpack_require__(799);
	
	var _SidebarRegion2 = _interopRequireDefault(_SidebarRegion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.SidebarRegion = _SidebarRegion2.default;

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SidebarRegionStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  spread: _propTypes2.default.bool,
	  scrollable: _propTypes2.default.bool,
	  bordered: _propTypes2.default.bool,
	  scrollableMinHeight: _propTypes2.default.number,
	  theme: _propTypes2.default.object
	};
	
	var defaultProps = {
	  spread: false,
	  scrollable: false,
	  bordered: false,
	  scrollableMinHeight: 200
	};
	
	/** Prop Receivers */
	var spread = function spread(_ref) {
	  var spread = _ref.spread;
	  return spread ? 'flex-grow: 1;' : '';
	};
	
	var scrollable = function scrollable(_ref2) {
	  var scrollable = _ref2.scrollable,
	      scrollableMinHeight = _ref2.scrollableMinHeight,
	      themeFromProvider = _ref2.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var minHeightSource = scrollableMinHeight || theme.reactackle.components.sidebar.region.scrollableMinHeight;
	
	  return scrollable ? (0, _styledComponents.css)(['overflow-y:auto;overflow-x:hidden;min-height:', ';'], (0, _reactackleCore.getValueString)(minHeightSource)) : 'flex-shrink: 0;';
	};
	
	var bordered = function bordered(_ref3) {
	  var themeFromProvider = _ref3.theme,
	      bordered = _ref3.bordered;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var _theme$reactackle$com = theme.reactackle.components.sidebar.region.border,
	      thickness = _theme$reactackle$com.thickness,
	      color = _theme$reactackle$com.color;
	
	
	  return bordered ? 'border: ' + (0, _reactackleCore.getValueString)(thickness) + ' solid ' + color + ';' : '';
	};
	
	/** Styles */
	var SidebarRegionStyled = exports.SidebarRegionStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'SidebarRegionStyled'
	})(['display:flex;flex-direction:column;align-items:stretch;justify-content:flex-start;', ' ', ' ', ';'], spread, bordered, scrollable);
	
	SidebarRegionStyled.propTypes = propTypes;
	SidebarRegionStyled.defaultProps = defaultProps;
	SidebarRegionStyled.displayName = 'SidebarRegionStyled';

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactackleCore = __webpack_require__(3);
	
	var _SidebarToggleStyled = __webpack_require__(803);
	
	var _ToggleIconStyled = __webpack_require__(805);
	
	var _ToggleTextStyled = __webpack_require__(806);
	
	var _ToggleContentStyled = __webpack_require__(804);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  toggleButtonText: _propTypes2.default.string,
	  expanded: _propTypes2.default.bool,
	  autoCollapsing: _propTypes2.default.bool,
	  onClick: _propTypes2.default.func,
	  // eslint-disable-next-line react/require-default-props
	  theme: _propTypes2.default.object
	};
	
	var defaultProps = {
	  toggleButtonText: 'Collapse',
	  expanded: false,
	  autoCollapsing: false,
	  onClick: _reactackleCore.noop
	};
	
	function _SidebarToggle(props) {
	
	  return _react2.default.createElement(
	    _SidebarToggleStyled.SidebarToggleStyled,
	    {
	      expanded: props.expanded,
	      autoCollapsing: props.autoCollapsing,
	      onClick: props.onClick
	    },
	    _react2.default.createElement(
	      _ToggleIconStyled.ToggleIconStyled,
	      {
	        expanded: props.expanded,
	        autoCollapsing: props.autoCollapsing
	      },
	      props.theme.reactackle.components.sidebar.toggleButton.iconElement
	    ),
	    _react2.default.createElement(
	      _ToggleContentStyled.ToggleContentStyled,
	      null,
	      _react2.default.createElement(
	        _ToggleTextStyled.ToggleTextStyled,
	        {
	          expanded: props.expanded,
	          autoCollapsing: props.autoCollapsing
	        },
	        props.toggleButtonText
	      )
	    )
	  );
	}
	
	_SidebarToggle.propTypes = propTypes;
	_SidebarToggle.defaultProps = defaultProps;
	_SidebarToggle.displayName = 'SidebarToggle';
	
	exports.default = (0, _reactackleCore.withTheme)(_SidebarToggle);

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SidebarToggleStyled = undefined;
	
	var _templateObject = _taggedTemplateLiteral(['\n        ', '\n      '], ['\n        ', '\n      ']);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var propTypes = {
	  expanded: _propTypes2.default.bool,
	  autoCollapsing: _propTypes2.default.bool,
	  theme: _propTypes2.default.object
	};
	
	var defaultProps = {
	  expanded: false,
	  autoCollapsing: false
	};
	
	/** Prop Receivers */
	var style = function style(_ref) {
	  var themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var backgroundColor = theme.reactackle.components.sidebar.sidebar.backgroundColor;
	
	
	  var fontFamily = theme.reactackle.fontFamily[theme.reactackle.body.fontFamily];
	
	  return '\n    background-color: ' + backgroundColor + ';\n    \n    &,\n    & *,\n    *::after,\n    *::before {\n      font-family: ' + fontFamily + ';\n      box-sizing: border-box;\n    }\n  ';
	};
	
	var base = function base(_ref2) {
	  var themeFromProvider = _ref2.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var _theme$reactackle$com = theme.reactackle.components.sidebar.toggleButton,
	      height = _theme$reactackle$com.height,
	      fontSize = _theme$reactackle$com.fontSize,
	      lineHeight = _theme$reactackle$com.lineHeight,
	      fontWeight = _theme$reactackle$com.fontWeight,
	      textTransform = _theme$reactackle$com.textTransform,
	      zIndex = _theme$reactackle$com.zIndex,
	      paddingRight = _theme$reactackle$com.paddingRight;
	
	
	  return '\n    z-index: ' + zIndex + ';\n    margin-top: -' + (0, _reactackleCore.getValueString)(height) + ';\n    height: ' + (0, _reactackleCore.getValueString)(height) + ';\n    font-size: ' + (0, _reactackleCore.getValueString)(fontSize) + ';\n    font-weight: ' + fontWeight + ';\n    line-height: ' + lineHeight + ';\n    text-transform: ' + textTransform + ';\n    padding-right: ' + (0, _reactackleCore.getValueString)(paddingRight) + ';\n  ';
	};
	
	var state = function state(_ref3) {
	  var themeFromProvider = _ref3.theme,
	      expanded = _ref3.expanded,
	      autoCollapsing = _ref3.autoCollapsing;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var sidebarPath = theme.reactackle.components.sidebar.sidebar,
	      togglePath = theme.reactackle.components.sidebar.toggleButton.style,
	      widthChangingBreakpoint = sidebarPath.widthChangingBreakpoint,
	      expandedWidthValue = (0, _reactackleCore.getValueString)(sidebarPath.state.expanded.width);
	
	
	  var collapsedStyles = '\n    width: ' + expandedWidthValue + ';\n    background-color: ' + togglePath.collapsed.backgroundColor + ';\n    color: ' + togglePath.collapsed.fontColor + ';\n    \n    &:hover {\n      background-color: ' + togglePath.collapsed.hover.backgroundColor + ';\n      color: ' + togglePath.collapsed.hover.fontColor + ';\n    }\n    \n    &:focus {\n      background-color: ' + togglePath.collapsed.focus.backgroundColor + ';\n      color: ' + togglePath.collapsed.focus.fontColor + ';\n    }\n  ';
	
	  var expandedStyles = '\n    width: ' + expandedWidthValue + ';\n    background-color: ' + togglePath.expanded.backgroundColor + ';\n    color: ' + togglePath.expanded.fontColor + ';\n    \n    &:hover {\n      background-color: ' + togglePath.expanded.hover.backgroundColor + ';\n      color: ' + togglePath.expanded.hover.fontColor + ';\n    }\n    \n    &:focus {\n      background-color: ' + togglePath.expanded.focus.backgroundColor + ';\n      color: ' + togglePath.expanded.focus.fontColor + ';\n    }\n  ';
	
	  if (autoCollapsing) {
	    return (0, _styledComponents.css)(['', ' ', ''], expanded ? expandedStyles : collapsedStyles, (0, _reactackleCore.media)(widthChangingBreakpoint)(_templateObject, !expanded ? collapsedStyles : expandedStyles));
	  } else {
	    return (0, _styledComponents.css)(['', ''], !expanded ? collapsedStyles : expandedStyles);
	  }
	};
	
	/** Styles */
	var SidebarToggleStyled = exports.SidebarToggleStyled = _styledComponents2.default.button.withConfig({
	  displayName: 'SidebarToggleStyled'
	})(['position:absolute;cursor:pointer;text-align:left;display:flex;align-items:center;user-select:none;padding:0;z-index:1;&,&:hover,&:focus{border:0;outline:none;box-shadow:none;}', ' ', ' ', ' ', ';'], base, style, state, (0, _reactackleCore.transition)('width, background-color'));
	
	SidebarToggleStyled.propTypes = propTypes;
	SidebarToggleStyled.defaultProps = defaultProps;
	SidebarToggleStyled.displayName = 'SidebarToggleStyled';

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ToggleContentStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  theme: _propTypes2.default.object
	};
	
	/** Prop Receivers */
	var base = function base(_ref) {
	  var themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var _theme$reactackle$com = theme.reactackle.components.sidebar.toggleButton.content,
	      paddingY = _theme$reactackle$com.paddingY,
	      paddingX = _theme$reactackle$com.paddingX;
	
	
	  return '\n    padding: ' + (0, _reactackleCore.getValueString)(paddingY) + ' ' + (0, _reactackleCore.getValueString)(paddingX) + ';\n  ';
	};
	
	/** Styles */
	var ToggleContentStyled = exports.ToggleContentStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'ToggleContentStyled'
	})(['flex-grow:1;display:flex;align-items:center;', ' ', ';'], base, (0, _reactackleCore.transition)('opacity'));
	
	ToggleContentStyled.propTypes = propTypes;
	ToggleContentStyled.displayName = 'ToggleContentStyled';

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ToggleIconStyled = undefined;
	
	var _templateObject = _taggedTemplateLiteral(['\n        ', '\n      '], ['\n        ', '\n      ']);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleIcons = __webpack_require__(7);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var propTypes = {
	  expanded: _propTypes2.default.bool,
	  autoCollapsing: _propTypes2.default.bool
	};
	
	var defaultProps = {
	  expanded: false,
	  autoCollapsing: false
	};
	
	/** Prop Receivers */
	var iconSize = function iconSize(_ref) {
	  var themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var _theme$reactackle$com = theme.reactackle.components.sidebar.toggleButton.icon,
	      width = _theme$reactackle$com.width,
	      height = _theme$reactackle$com.height,
	      imgSize = _theme$reactackle$com.imgSize;
	
	
	  return (0, _styledComponents.css)(['     ', ''], (0, _reactackleCore.iconSizeMixin)((0, _reactackleCore.getValueString)(height), (0, _reactackleCore.getValueString)(imgSize || height), (0, _reactackleCore.getValueString)(width || height)));
	};
	
	var state = function state(_ref2) {
	  var themeFromProvider = _ref2.theme,
	      expanded = _ref2.expanded,
	      autoCollapsing = _ref2.autoCollapsing;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var iconPath = theme.reactackle.components.sidebar.toggleButton.icon.style,
	      widthChangingBreakpoint = theme.reactackle.components.sidebar.sidebar.widthChangingBreakpoint;
	
	
	  var collapsedStyles = '\n    width: ' + (0, _reactackleCore.getValueString)(iconPath.collapsed.width) + ';\n    margin-left: ' + (0, _reactackleCore.getValueString)(iconPath.collapsed.marginLeft) + ';\n    opacity: ' + iconPath.collapsed.opacity + ';\n    transform: rotate(180deg);\n    ' + (0, _reactackleIcons.iconStyleMixin)(iconPath.collapsed.color) + '\n    \n    &:hover {\n      color: ' + iconPath.collapsed.hover.color + ';\n      opacity: ' + iconPath.collapsed.hover.opacity + ';\n    }\n    \n    &:focus {\n      color: ' + iconPath.collapsed.focus.color + ';\n      opacity: ' + iconPath.collapsed.focus.opacity + ';\n    }\n  ';
	
	  var expandedStyles = '\n    width: ' + (0, _reactackleCore.getValueString)(iconPath.expanded.width) + ';\n    margin-left: ' + (0, _reactackleCore.getValueString)(iconPath.expanded.marginLeft) + ';\n    opacity: ' + iconPath.expanded.opacity + ';\n    ' + (0, _reactackleIcons.iconStyleMixin)(iconPath.expanded.color) + '\n    \n    &:hover {\n      color: ' + iconPath.expanded.hover.color + ';\n      opacity: ' + iconPath.expanded.hover.opacity + ';\n    }\n    \n    &:focus {\n      color: ' + iconPath.expanded.focus.color + ';\n      opacity: ' + iconPath.expanded.focus.opacity + ';\n    }\n  ';
	
	  if (autoCollapsing) {
	    return (0, _styledComponents.css)(['', ' ', ''], expanded ? expandedStyles : collapsedStyles, (0, _reactackleCore.media)(widthChangingBreakpoint)(_templateObject, !expanded ? collapsedStyles : expandedStyles));
	  } else {
	    return (0, _styledComponents.css)(['', ''], !expanded ? collapsedStyles : expandedStyles);
	  }
	};
	
	/** Styles */
	var ToggleIconStyled = exports.ToggleIconStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'ToggleIconStyled'
	})(['display:flex;position:relative;flex-shrink:0;justify-content:center;', ' ', ' ', ';'], iconSize, state, (0, _reactackleCore.transition)('transform, width, margin'));
	
	ToggleIconStyled.propTypes = propTypes;
	ToggleIconStyled.defaultProps = defaultProps;
	ToggleIconStyled.displayName = 'ToggleIconStyled';

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ToggleTextStyled = undefined;
	
	var _templateObject = _taggedTemplateLiteral(['\n        ', '\n      '], ['\n        ', '\n      ']);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var propTypes = {
	  expanded: _propTypes2.default.bool,
	  autoCollapsing: _propTypes2.default.bool,
	  theme: _propTypes2.default.object
	};
	
	var defaultProps = {
	  expanded: false,
	  autoCollapsing: false
	};
	
	var collapsing = function collapsing(_ref) {
	  var themeFromProvider = _ref.theme,
	      expanded = _ref.expanded,
	      autoCollapsing = _ref.autoCollapsing;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var sidebarPath = theme.reactackle.components.sidebar.sidebar,
	      widthChangingBreakpoint = sidebarPath.widthChangingBreakpoint;
	
	
	  var collapsedStyles = '\n    position: fixed;\n    opacity: 0;\n    pointer-events: none;\n  ';
	
	  var expandedStyles = '\n    position: relative;\n    opacity: 1;\n    pointer-events: initial;\n  ';
	
	  if (autoCollapsing) {
	    return (0, _styledComponents.css)(['', ' ', ''], expanded ? expandedStyles : collapsedStyles, (0, _reactackleCore.media)(widthChangingBreakpoint)(_templateObject, !expanded ? collapsedStyles : expandedStyles));
	  } else {
	    return (0, _styledComponents.css)(['', ''], !expanded ? collapsedStyles : expandedStyles);
	  }
	};
	
	/** Styles */
	var ToggleTextStyled = exports.ToggleTextStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'ToggleTextStyled'
	})(['flex-grow:1;word-break:break-word;', ' ', ';'], collapsing, (0, _reactackleCore.transition)('opacity'));
	
	ToggleTextStyled.propTypes = propTypes;
	ToggleTextStyled.defaultProps = defaultProps;
	ToggleTextStyled.displayName = 'ToggleTextStyled';

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Sidebar = undefined;
	
	var _SidebarToggle = __webpack_require__(231);
	
	Object.keys(_SidebarToggle).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _SidebarToggle[key];
	    }
	  });
	});
	
	var _SidebarRegion = __webpack_require__(800);
	
	Object.keys(_SidebarRegion).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _SidebarRegion[key];
	    }
	  });
	});
	
	var _Sidebar = __webpack_require__(798);
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Sidebar = _Sidebar2.default;

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SidebarBoxStyled = undefined;
	
	var _templateObject = _taggedTemplateLiteral(['\n        ', '\n      '], ['\n        ', '\n      ']);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var propTypes = {
	  haveToggleButton: _propTypes2.default.bool,
	  expanded: _propTypes2.default.bool,
	  attachToRight: _propTypes2.default.bool,
	  autoCollapsing: _propTypes2.default.bool,
	  theme: _propTypes2.default.object
	};
	
	var defaultProps = {
	  haveToggleButton: false,
	  expanded: false,
	  attachToRight: false,
	  autoCollapsing: false
	};
	
	/** Prop Receivers */
	var width = function width(_ref) {
	  var themeFromProvider = _ref.theme,
	      autoCollapsing = _ref.autoCollapsing,
	      expanded = _ref.expanded;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var componentPath = theme.reactackle.components.sidebar.sidebar,
	      widthChangingBreakpoint = componentPath.widthChangingBreakpoint,
	      zIndex = componentPath.zIndex,
	      collapsedWidthValue = (0, _reactackleCore.getValueString)(componentPath.state.collapsed.width),
	      expandedWidthValue = (0, _reactackleCore.getValueString)(componentPath.state.expanded.width);
	
	
	  if (autoCollapsing) {
	    return (0, _styledComponents.css)(['', ' ', ''], expanded ? '\n          width: ' + expandedWidthValue + ';\n          z-index: ' + zIndex + ';\n        ' : 'width: ' + collapsedWidthValue + ';', (0, _reactackleCore.media)(widthChangingBreakpoint)(_templateObject, !expanded ? 'width: ' + collapsedWidthValue + ';' : 'width: ' + expandedWidthValue + ';'));
	  } else {
	    return (0, _styledComponents.css)(['', ''], expanded ? 'width: ' + expandedWidthValue + ';' : 'width: ' + collapsedWidthValue + ';');
	  }
	};
	
	var style = function style(_ref2) {
	  var themeFromProvider = _ref2.theme,
	      attachToRight = _ref2.attachToRight;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var _theme$reactackle$com = theme.reactackle.components.sidebar.sidebar,
	      minHeight = _theme$reactackle$com.minHeight,
	      zIndex = _theme$reactackle$com.zIndex,
	      backgroundColor = _theme$reactackle$com.backgroundColor,
	      fontColor = _theme$reactackle$com.fontColor,
	      fontSize = _theme$reactackle$com.fontSize,
	      lineHeight = _theme$reactackle$com.lineHeight;
	
	
	  return (0, _styledComponents.css)(['background-color:', ';min-height:', ';color:', ';font-size:', ';line-height:', ';z-index:', ';', ''], backgroundColor, (0, _reactackleCore.getValueString)(minHeight), fontColor, (0, _reactackleCore.getValueString)(fontSize), lineHeight, zIndex, attachToRight ? '\n        left: auto;\n        right: 0;\n      ' : 'left: 0;');
	};
	
	var toggleButton = function toggleButton(_ref3) {
	  var haveToggleButton = _ref3.haveToggleButton,
	      themeFromProvider = _ref3.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var height = theme.reactackle.components.sidebar.toggleButton.height;
	
	
	  return haveToggleButton ? (0, _styledComponents.css)(['padding-top:', ';'], (0, _reactackleCore.getValueString)(height)) : '';
	};
	
	/** Styles */
	var SidebarBoxStyled = exports.SidebarBoxStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'SidebarBoxStyled'
	})(['flex-grow:1;display:flex;flex-direction:column;position:fixed;left:0;height:100%;max-height:100%;overflow-x:hidden;overflow-y:auto;', ';', ';', ';', ';'], width, style, toggleButton, (0, _reactackleCore.transition)('width'));
	
	SidebarBoxStyled.propTypes = propTypes;
	SidebarBoxStyled.defaultProps = defaultProps;
	SidebarBoxStyled.displayName = 'SidebarBoxStyled';

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SidebarStyled = undefined;
	
	var _templateObject = _taggedTemplateLiteral(['\n        ', '\n      '], ['\n        ', '\n      ']);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var propTypes = {
	  haveToggleButton: _propTypes2.default.bool,
	  expanded: _propTypes2.default.bool,
	  attachToRight: _propTypes2.default.bool,
	  autoCollapsing: _propTypes2.default.bool,
	  theme: _propTypes2.default.object
	};
	
	var defaultProps = {
	  haveToggleButton: false,
	  expanded: false,
	  attachToRight: false,
	  autoCollapsing: false
	};
	
	/** Prop Receivers */
	var width = function width(_ref) {
	  var themeFromProvider = _ref.theme,
	      autoCollapsing = _ref.autoCollapsing,
	      expanded = _ref.expanded;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var componentPath = theme.reactackle.components.sidebar.sidebar,
	      widthChangingBreakpoint = componentPath.widthChangingBreakpoint,
	      zIndex = componentPath.zIndex,
	      collapsedWidthValue = (0, _reactackleCore.getValueString)(componentPath.state.collapsed.width),
	      expandedWidthValue = (0, _reactackleCore.getValueString)(componentPath.state.expanded.width);
	
	
	  if (autoCollapsing) {
	    return (0, _styledComponents.css)(['width:', ';z-index:', ';', ''], collapsedWidthValue, zIndex, (0, _reactackleCore.media)(widthChangingBreakpoint)(_templateObject, !expanded ? 'width: ' + collapsedWidthValue + ';' : 'width: ' + expandedWidthValue + ';'));
	  } else {
	    return (0, _styledComponents.css)(['', ''], !expanded ? 'width: ' + collapsedWidthValue + ';' : 'width: ' + expandedWidthValue + ';');
	  }
	};
	
	var attachToRight = function attachToRight(_ref2) {
	  var attachToRight = _ref2.attachToRight;
	  return attachToRight ? 'order: 2;' : '';
	};
	
	var toggleButtonBase = function toggleButtonBase(_ref3) {
	  var themeFromProvider = _ref3.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var togglePath = theme.reactackle.components.sidebar.toggleButton,
	      height = togglePath.height;
	
	
	  return (0, _styledComponents.css)(['&::before{content:"";height:', 'px;position:fixed;top:0;left:0;', ';}'], height, (0, _reactackleCore.transition)('width, right'));
	};
	
	var toggleButtonState = function toggleButtonState(_ref4) {
	  var themeFromProvider = _ref4.theme,
	      expanded = _ref4.expanded,
	      autoCollapsing = _ref4.autoCollapsing;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var sidebarPath = theme.reactackle.components.sidebar.sidebar,
	      widthChangingBreakpoint = sidebarPath.widthChangingBreakpoint,
	      collapsedWidthValue = (0, _reactackleCore.getValueString)(sidebarPath.state.collapsed.width),
	      expandedWidthValue = (0, _reactackleCore.getValueString)(sidebarPath.state.expanded.width);
	
	
	  var collapsedStyles = '\n    width: ' + collapsedWidthValue + ';\n  ';
	
	  var expandedStyles = '\n    width: ' + expandedWidthValue + ';\n  ';
	
	  if (autoCollapsing) {
	    return (0, _styledComponents.css)(['', ' ', ''], expanded ? expandedStyles : collapsedStyles, (0, _reactackleCore.media)(widthChangingBreakpoint)(_templateObject, !expanded ? collapsedStyles : expandedStyles));
	  } else {
	    return (0, _styledComponents.css)(['', ''], expanded ? expandedStyles : collapsedStyles);
	  }
	};
	
	var toggleButton = function toggleButton(_ref5) {
	  var haveToggleButton = _ref5.haveToggleButton;
	  return haveToggleButton ? (0, _styledComponents.css)(['', ' ', ''], toggleButtonBase, toggleButtonState) : '';
	};
	
	var base = function base(_ref6) {
	  var themeFromProvider = _ref6.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var fontFamily = theme.reactackle.fontFamily[theme.reactackle.body.fontFamily];
	
	  return '\n    &,\n    & *,\n    *::after,\n    *::before {\n      font-family: ' + fontFamily + ';\n      box-sizing: border-box;\n    }\n  ';
	};
	
	/** Styles */
	var SidebarStyled = exports.SidebarStyled = _styledComponents2.default.aside.withConfig({
	  displayName: 'SidebarStyled'
	})(['display:block;position:relative;flex-shrink:0;z-index:2;', ';', ';', ';', ';', ';'], base, width, attachToRight, (0, _reactackleCore.transition)('width'), toggleButton);
	
	SidebarStyled.propTypes = propTypes;
	SidebarStyled.defaultProps = defaultProps;
	SidebarStyled.displayName = 'SidebarStyled';

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _color = __webpack_require__(812);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _reactackleCore = __webpack_require__(3);
	
	var _reactackleIcons = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** '+1' is needed to be sure that sidebar is placed over header */
	var sidebarZIndex = function sidebarZIndex(base) {
	  return (0, _reactackleCore.zIndexNav)(base) + 1;
	},
	    sidebarMinHeight = 40,
	    sidebarMinWidth = 50,
	    toggleHoverColor = function toggleHoverColor(base) {
	  return (0, _color2.default)((0, _reactackleCore.colorPaletteGrey900)(base)).darken(0.15);
	};
	
	exports.default = {
	  sidebar: {
	    minHeight: sidebarMinHeight,
	    backgroundColor: _reactackleCore.colorPaletteGrey800,
	    fontColor: _reactackleCore.bodyFontColorAlt,
	    fontSize: _reactackleCore.fontSizeBody,
	    lineHeight: 1.5,
	    zIndex: sidebarZIndex,
	    widthChangingBreakpoint: _reactackleCore.breakpointLarge,
	
	    state: {
	      collapsed: {
	        width: sidebarMinWidth
	      },
	
	      expanded: {
	        width: 250
	      }
	    }
	  },
	
	  region: {
	    scrollableMinHeight: 200,
	
	    border: {
	      thickness: 1,
	      color: _reactackleCore.colorPaletteGrey700
	    }
	  },
	
	  toggleButton: {
	    height: sidebarMinHeight,
	    fontSize: _reactackleCore.fontSizeBody,
	    fontWeight: _reactackleCore.fontWeightNormal,
	    lineHeight: 1.5,
	    textTransform: 'none',
	    zIndex: sidebarZIndex,
	    paddingRight: 0,
	    iconElement: _react2.default.createElement(_reactackleIcons.IconArrowChevronLeft, { size: 'custom', color: 'inherit' }),
	
	    style: {
	      collapsed: {
	        backgroundColor: _reactackleCore.colorPaletteGrey900,
	        fontColor: _reactackleCore.bodyFontColorAlt,
	
	        hover: {
	          backgroundColor: toggleHoverColor,
	          fontColor: _reactackleCore.bodyFontColorAlt
	        },
	
	        focus: {
	          backgroundColor: toggleHoverColor,
	          fontColor: _reactackleCore.bodyFontColorAlt
	        }
	      },
	
	      expanded: {
	        backgroundColor: _reactackleCore.colorPaletteGrey900,
	        fontColor: _reactackleCore.bodyFontColorAlt,
	
	        hover: {
	          backgroundColor: toggleHoverColor,
	          fontColor: _reactackleCore.bodyFontColorAlt
	        },
	
	        focus: {
	          backgroundColor: toggleHoverColor,
	          fontColor: _reactackleCore.bodyFontColorAlt
	        }
	      }
	    },
	
	    icon: {
	      height: 40,
	      width: null,
	      imgSize: null,
	
	      style: {
	        collapsed: {
	          width: sidebarMinWidth,
	          marginLeft: 0,
	          color: 'inherit',
	          opacity: 0.9,
	
	          hover: {
	            color: 'inherit',
	            opacity: 1
	          },
	
	          focus: {
	            color: 'inherit',
	            opacity: 1
	          }
	        },
	
	        expanded: {
	          width: 40,
	          marginLeft: (0, _reactackleCore.bmodule)(1.5),
	          color: 'inherit',
	          opacity: 0.9,
	
	          hover: {
	            color: 'inherit',
	            opacity: 1
	          },
	
	          focus: {
	            color: 'inherit',
	            opacity: 1
	          }
	        }
	      }
	    },
	
	    content: {
	      paddingY: (0, _reactackleCore.bmodule)(1),
	      paddingX: (0, _reactackleCore.bmodule)(1.5)
	    }
	  }
	};

/***/ }),
/* 811 */
362,
/* 812 */
[944, 811],
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LinkWrapper = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactackleCore = __webpack_require__(3);
	
	var _DefaultLinkComponent = __webpack_require__(135);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var propTypes = {
	  href: _propTypes2.default.string,
	  boxed: _propTypes2.default.bool,
	  title: _propTypes2.default.string,
	
	  icon: _propTypes2.default.shape({
	    /** Set icon's name (required for font-awesome icons */
	    name: _propTypes2.default.string,
	    /** Set icon's source (required for library icons */
	    src: _propTypes2.default.string,
	    /** Set icon type */
	    type: _propTypes2.default.oneOf(['font-awesome', 'library'])
	  }),
	
	  onClick: _propTypes2.default.func,
	  linkComponent: _propTypes2.default.func
	};
	var defaultProps = {
	  href: '#',
	  boxed: false,
	  title: '',
	
	  icon: {
	    name: '',
	    src: '',
	    type: 'font-awesome'
	  },
	
	  onClick: _reactackleCore.noop,
	  linkComponent: _DefaultLinkComponent.DefaultLinkComponent
	};
	
	var LinkWrapper = function LinkWrapper(props) {
	  var Link = props.linkComponent,
	      linkProps = _objectWithoutProperties(props, ['linkComponent']);
	
	  if (Link !== _DefaultLinkComponent.DefaultLinkComponent) delete linkProps.boxed;
	  return _react2.default.createElement(
	    Link,
	    linkProps,
	    props.children
	  );
	};
	exports.LinkWrapper = LinkWrapper;
	LinkWrapper.propTypes = propTypes;
	LinkWrapper.defaultProps = defaultProps;
	LinkWrapper.displayName = 'LinkWrapper';

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactackleCore = __webpack_require__(3);
	
	var _LinkWrapper = __webpack_require__(813);
	
	var _DefaultLinkComponent = __webpack_require__(135);
	
	var _TabStyled = __webpack_require__(819);
	
	var _TabContentWrapperStyled = __webpack_require__(817);
	
	var _TabContentStyled = __webpack_require__(816);
	
	var _TabTextStyled = __webpack_require__(820);
	
	var _TabIconStyled = __webpack_require__(818);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  /**
	   * Href that will be passed to Link inside Tab
	   */
	  linkHref: _propTypes2.default.string,
	  /**
	   * Determines whether to disable Tab
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * Determines whether Tab is selected
	   */
	  isSelected: _propTypes2.default.bool,
	  /**
	   * Text that will be displayed on Tab
	   */
	  text: _propTypes2.default.string,
	  /**
	   * Number of Tab
	   */
	  index: _propTypes2.default.number,
	  /**
	   * Color scheme of Tab
	   */
	  colorScheme: _propTypes2.default.oneOf(['light', 'dark']),
	  /**
	    * Specify link component
	    */
	  linkComponent: _propTypes2.default.func,
	  /**
	   * Icon that will be rendered on Tab (see IconSvg or IconCustom props)
	   */
	  icon: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func]),
	  /**
	   * Specify function that will be called on Tab selection
	   */
	  onSelect: _propTypes2.default.func
	};
	
	var defaultProps = {
	  linkHref: '',
	  disabled: false,
	  isSelected: false,
	  text: '',
	  index: 0,
	  colorScheme: 'dark',
	  linkComponent: _DefaultLinkComponent.DefaultLinkComponent,
	  icon: null,
	  onSelect: _reactackleCore.noop
	};
	
	var Tab = function (_Component) {
	  _inherits(Tab, _Component);
	
	  function Tab(props) {
	    _classCallCheck(this, Tab);
	
	    var _this = _possibleConstructorReturn(this, (Tab.__proto__ || Object.getPrototypeOf(Tab)).call(this, props));
	
	    _this._handleClick = _this._handleClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(Tab, [{
	    key: '_handleClick',
	    value: function _handleClick() {
	      if (!this.props.disabled) {
	        this.props.onSelect({
	          index: this.props.index
	        });
	      }
	    }
	  }, {
	    key: '_renderTabIcon',
	    value: function _renderTabIcon() {
	      var icon = this.props.icon;
	
	      if (!icon) return null;
	
	      var iconElement = void 0;
	
	      if (typeof this.props.icon === "function") {
	        var Icon = this.props.icon;
	        iconElement = _react2.default.createElement(Icon, null);
	      } else {
	        iconElement = this.props.icon;
	      }
	
	      return _react2.default.createElement(
	        _TabIconStyled.TabIconStyled,
	        {
	          colorScheme: this.props.colorScheme,
	          selected: this.props.isSelected
	        },
	        iconElement
	      );
	    }
	  }, {
	    key: '_renderTabTxt',
	    value: function _renderTabTxt() {
	      if (!this.props.text) return null;
	
	      return _react2.default.createElement(
	        _TabTextStyled.TabTextStyled,
	        { hasIcon: this.props.icon !== null },
	        this.props.text
	      );
	    }
	  }, {
	    key: '_renderTabContent',
	    value: function _renderTabContent() {
	      var _props = this.props,
	          disabled = _props.disabled,
	          linkHref = _props.linkHref,
	          linkComponent = _props.linkComponent,
	          text = _props.text,
	          tabIcon = this._renderTabIcon(),
	          tabTxt = this._renderTabTxt();
	
	      var tabContent = _react2.default.createElement(
	        _TabStyled.TabStyled,
	        {
	          onClick: this._handleClick,
	          colorScheme: this.props.colorScheme,
	          selected: this.props.isSelected
	        },
	        _react2.default.createElement(
	          _TabContentWrapperStyled.TabContentWrapperStyled,
	          null,
	          _react2.default.createElement(
	            _TabContentStyled.TabContentStyled,
	            null,
	            tabIcon,
	            tabTxt
	          )
	        )
	      );
	
	      if (!disabled && linkHref) {
	        return _react2.default.createElement(
	          _LinkWrapper.LinkWrapper,
	          { linkComponent: linkComponent, href: linkHref, title: text },
	          tabContent
	        );
	      }
	
	      return tabContent;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this._renderTabContent();
	    }
	  }]);
	
	  return Tab;
	}(_react.Component);
	
	exports.default = Tab;
	
	
	Tab.propTypes = propTypes;
	Tab.defaultProps = defaultProps;
	Tab.displayName = 'Tab';

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Tab = undefined;
	
	var _Tab = __webpack_require__(814);
	
	var _Tab2 = _interopRequireDefault(_Tab);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Tab = _Tab2.default;

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TabContentStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * Define theme
	   * See https://github.com/styled-components/styled-components/blob/master/docs/theming.md
	   * for more information
	   */
	  theme: _propTypes2.default.object
	};
	
	var base = function base(_ref) {
	  var themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var _theme$reactackle$com = theme.reactackle.components.tabs.tab,
	      paddingX = _theme$reactackle$com.paddingX,
	      paddingY = _theme$reactackle$com.paddingY;
	
	
	  return '\n    padding: ' + (0, _reactackleCore.getValueString)(paddingY) + ' ' + (0, _reactackleCore.getValueString)(paddingX) + ';\n  ';
	};
	
	var TabContentStyled = exports.TabContentStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'TabContentStyled'
	})(['text-align:center;', ';'], base);
	
	TabContentStyled.propTypes = propTypes;
	TabContentStyled.displayName = 'TabContentStyled';

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TabContentWrapperStyled = undefined;
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var content = function content() {
	  return '\n  & > * {\n    &,\n    &:hover,\n    &:focus {\n      color: inherit;\n      text-decoration: none;\n      cursor: inherit;\n    }\n  }\n';
	};
	
	var TabContentWrapperStyled = exports.TabContentWrapperStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'TabContentWrapperStyled'
	})(['flex-grow:1;display:flex;align-items:center;justify-content:center;', ';'], content);
	
	TabContentWrapperStyled.displayName = 'TabContentWrapperStyled';

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TabIconStyled = undefined;
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleIcons = __webpack_require__(7);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var size = function size(_ref) {
	  var themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var _theme$reactackle$com = theme.reactackle.components.tabs.icon,
	      width = _theme$reactackle$com.width,
	      height = _theme$reactackle$com.height,
	      imgSize = _theme$reactackle$com.imgSize;
	
	
	  return (0, _styledComponents.css)(['     ', ''], (0, _reactackleCore.iconSizeMixin)((0, _reactackleCore.getValueString)(height || width), (0, _reactackleCore.getValueString)(imgSize || height), (0, _reactackleCore.getValueString)(width || height)));
	};
	
	var style = function style(_ref2) {
	  var themeFromProvider = _ref2.theme,
	      selected = _ref2.selected,
	      colorScheme = _ref2.colorScheme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var source = theme.reactackle.components.tabs.icon.style[colorScheme];
	
	  return !selected ? (0, _styledComponents.css)(['', ';&:hover{color:', ';}&:focus{color:', ';}'], (0, _reactackleIcons.iconStyleMixin)(source.color), source.hover.color, source.focus.color) : (0, _styledComponents.css)(['       &,&:hover,&:focus{', ';}'], (0, _reactackleIcons.iconStyleMixin)(source.selected.color));
	};
	
	var TabIconStyled = exports.TabIconStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'TabIconStyled'
	})(['margin-left:auto;margin-right:auto;display:flex;', ' ', ';'], size, style);
	
	TabIconStyled.displayName = 'TabIconStyled';

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TabStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  colorScheme: _propTypes2.default.oneOf(['light', 'dark']),
	  /**
	   * Define button theme
	   * See https://github.com/styled-components/styled-components/blob/master/docs/theming.md
	   * for more information
	   */
	  theme: _propTypes2.default.object
	};
	
	var defaultProps = {
	  colorScheme: 'dark'
	};
	
	/** Prop Receivers */
	var base = function base(_ref) {
	  var themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var _theme$reactackle$com = theme.reactackle.components.tabs.tab,
	      fontSize = _theme$reactackle$com.fontSize,
	      lineHeight = _theme$reactackle$com.lineHeight,
	      textTransform = _theme$reactackle$com.textTransform,
	      minHeight = _theme$reactackle$com.minHeight,
	      minWidth = _theme$reactackle$com.minWidth,
	      maxWidth = _theme$reactackle$com.maxWidth;
	  var thickness = theme.reactackle.components.tabs.bar.thickness;
	
	
	  return '\n    font-size: ' + (0, _reactackleCore.getValueString)(fontSize) + ';\n    line-height: ' + lineHeight + ';\n    text-transform: ' + textTransform + ';\n    min-height: ' + (0, _reactackleCore.getValueString)(minHeight) + ';\n    min-width: ' + (0, _reactackleCore.getValueString)(minWidth) + ';\n    max-width: ' + (0, _reactackleCore.getValueString)(maxWidth) + ';\n    padding-top: ' + (0, _reactackleCore.getValueString)(thickness) + ';\n    padding-bottom: ' + (0, _reactackleCore.getValueString)(thickness) + ';\n  ';
	};
	
	var style = function style(_ref2) {
	  var themeFromProvider = _ref2.theme,
	      colorScheme = _ref2.colorScheme,
	      selected = _ref2.selected;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var source = theme.reactackle.components.tabs.tab.style[colorScheme];
	
	  return !selected ? '\n      color: ' + source.fontColor + ';\n      background-color: ' + source.backgroundColor + ';\n      font-weight: ' + source.fontWeight + ';\n      opacity: ' + source.opacity + ';\n      cursor: pointer;\n\n      &:hover {\n        color: ' + source.hover.fontColor + ';\n        background-color: ' + source.hover.backgroundColor + ';\n        font-weight: ' + source.hover.fontWeight + ';\n        opacity: ' + source.hover.opacity + ';\n      }\n\n      &:focus {\n        color: ' + source.focus.fontColor + ';\n        background-color: ' + source.focus.backgroundColor + ';\n        font-weight: ' + source.focus.fontWeight + ';\n        opacity: ' + source.focus.opacity + ';\n      }' : '\n      &,\n      &:hover,\n      &:focus {\n        color: ' + source.selected.fontColor + ';\n        background-color: ' + source.selected.backgroundColor + ';\n        font-weight: ' + source.selected.fontWeight + ';\n        opacity: ' + source.selected.opacity + ';\n        cursor: default;\n      }';
	};
	
	var bar = function bar(_ref3) {
	  var themeFromProvider = _ref3.theme,
	      selected = _ref3.selected,
	      colorScheme = _ref3.colorScheme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var thickness = theme.reactackle.components.tabs.bar.thickness,
	      backgroundColor = theme.reactackle.components.tabs.bar.style[colorScheme].backgroundColor;
	
	
	  return selected && '\n      background-color: ' + backgroundColor + ';\n      height: ' + (0, _reactackleCore.getValueString)(thickness) + ';\n  ';
	};
	
	/** Styles */
	var TabStyled = exports.TabStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'TabStyled'
	})(['flex-grow:1;display:flex;align-items:stretch;justify-content:center;position:relative;text-align:center;user-select:none;position:relative;', ' ', ' ', ' &::after{display:block;content:\'\';width:100%;position:absolute;bottom:0;left:0;z-index:1;', ';}'], base, style, (0, _reactackleCore.transition)('color, background-color, opacity'), bar);
	
	TabStyled.propTypes = propTypes;
	TabStyled.defaultProps = defaultProps;
	TabStyled.displayName = 'TabStyled';

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TabTextStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * Define theme
	   * See https://github.com/styled-components/styled-components/blob/master/docs/theming.md
	   * for more information
	   */
	  theme: _propTypes2.default.object
	};
	
	var baseProps = function baseProps(_ref) {
	  var themeFromProvider = _ref.theme,
	      hasIcon = _ref.hasIcon;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var marginTop = (0, _reactackleCore.getValueString)(theme.reactackle.components.tabs.icon.iconTextSpacing);
	
	  return hasIcon ? 'margin-top: ' + marginTop + ';' : '';
	};
	
	var TabTextStyled = exports.TabTextStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'TabTextStyled'
	})(['text-overflow:ellipsis;', ';'], baseProps);
	
	TabTextStyled.propTypes = propTypes;
	TabTextStyled.displayName = 'TabTextStyled';

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(115);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactackleCore = __webpack_require__(3);
	
	var _Tab = __webpack_require__(815);
	
	var _DefaultLinkComponent = __webpack_require__(135);
	
	var _TabsWrapperStyled = __webpack_require__(825);
	
	var _TabsListStyled = __webpack_require__(824);
	
	var _TabsContentWrapperStyled = __webpack_require__(823);
	
	var _theme = __webpack_require__(826);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	(0, _reactackleCore.registerDefaultComponentTheme)('tabs', _theme2.default);
	
	var propTypes = {
	  /**
	    * Props that will be passed to Tab Item
	    * @customType Tab.PropTypes
	    */
	  tabs: _propTypes2.default.arrayOf(_propTypes2.default.shape((0, _lodash2.default)(_Tab.Tab.propTypes, ['colorScheme', 'index', 'isSelected', 'onSelect']))),
	  /**
	   * Specify selected tab by number
	   */
	  selected: _propTypes2.default.number,
	  /**
	   * Specify color scheme
	   */
	  colorScheme: _propTypes2.default.oneOf(['light', 'dark']),
	  /**
	   * Specify link component that will be used in Tab
	   */
	  linkComponent: _propTypes2.default.func,
	  /**
	   * Specify function that will be called on selected Tab change
	   */
	  onChange: _propTypes2.default.func
	};
	
	var defaultProps = {
	  tabs: [],
	  selected: 0,
	  colorScheme: 'dark',
	  linkComponent: _DefaultLinkComponent.DefaultLinkComponent,
	  onChange: _reactackleCore.noop
	};
	
	var Tabs = function (_Component) {
	  _inherits(Tabs, _Component);
	
	  function Tabs(props) {
	    _classCallCheck(this, Tabs);
	
	    var _this = _possibleConstructorReturn(this, (Tabs.__proto__ || Object.getPrototypeOf(Tabs)).call(this, props));
	
	    _this.state = {
	      selected: props.selected
	    };
	
	    _this._handleTabSelection = _this._handleTabSelection.bind(_this);
	    return _this;
	  }
	
	  _createClass(Tabs, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(props) {
	      if (props.selected !== this.state.selected) this.setState({ selected: props.selected });
	    }
	  }, {
	    key: '_handleTabSelection',
	    value: function _handleTabSelection(_ref) {
	      var index = _ref.index;
	
	      this.setState({
	        selected: index
	      });
	
	      this.props.onChange({
	        value: index
	      });
	    }
	  }, {
	    key: '_renderTabs',
	    value: function _renderTabs() {
	      var _this2 = this;
	
	      var selected = this.state.selected;
	
	
	      return this.props.tabs.map(function (tab, key) {
	        var index = (0, _reactackleCore.getKey)(tab, key);
	        var tabProps = _extends({}, tab, {
	          index: index,
	          colorScheme: _this2.props.colorScheme,
	          onSelect: _this2._handleTabSelection,
	          isSelected: index === selected,
	          linkComponent: tab.linkComponent || _this2.props.linkComponent
	        });
	
	        return _react2.default.createElement(_Tab.Tab, _extends({}, tabProps, { key: index }));
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var tabs = this._renderTabs();
	
	      return _react2.default.createElement(
	        _TabsWrapperStyled.TabsWrapperStyled,
	        { colorScheme: this.props.colorScheme },
	        _react2.default.createElement(
	          _TabsContentWrapperStyled.TabsContentWrapperStyled,
	          null,
	          _react2.default.createElement(
	            _TabsListStyled.TabsListStyled,
	            null,
	            tabs
	          )
	        )
	      );
	    }
	  }]);
	
	  return Tabs;
	}(_react.Component);
	
	exports.default = Tabs;
	
	
	Tabs.propTypes = propTypes;
	Tabs.defaultProps = defaultProps;
	Tabs.displayName = 'Tabs';

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Tabs = undefined;
	
	var _Tabs = __webpack_require__(821);
	
	var _Tabs2 = _interopRequireDefault(_Tabs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Tabs = _Tabs2.default;

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TabsContentWrapperStyled = undefined;
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TabsContentWrapperStyled = exports.TabsContentWrapperStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'TabsContentWrapperStyled'
	})(['display:flex;align-items:stretch;position:relative;flex-grow:1;overflow:hidden;']);
	
	TabsContentWrapperStyled.displayName = 'TabsContentWrapperStyled';

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TabsListStyled = undefined;
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TabsListStyled = exports.TabsListStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'TabsListStyled'
	})(['display:flex;flex-grow:1;justify-content:center;', ';'], (0, _reactackleCore.transition)('transform'));
	
	TabsListStyled.displayName = 'TabsListStyled';

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TabsWrapperStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  colorScheme: _propTypes2.default.oneOf(['light', 'dark']),
	  /**
	   * Define theme
	   * See https://github.com/styled-components/styled-components/blob/master/docs/theming.md
	   * for more information
	   */
	  theme: _propTypes2.default.object
	};
	
	var defaultProps = {
	  colorScheme: 'dark'
	};
	
	var style = function style(_ref) {
	  var themeFromProvider = _ref.theme,
	      colorScheme = _ref.colorScheme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var backgroundColor = theme.reactackle.components.tabs.tabs.style[colorScheme].backgroundColor,
	      fontColor = theme.reactackle.components.tabs.tab.style[colorScheme].fontColor;
	
	
	  var fontFamily = theme.reactackle.fontFamily[theme.reactackle.body.fontFamily];
	
	  return '\n    background-color: ' + backgroundColor + ';\n    color: ' + fontColor + ';\n    \n    &,\n    & *,\n    *::after,\n    *::before {\n      font-family: ' + fontFamily + ';\n      box-sizing: border-box;\n    }\n  ';
	};
	
	var TabsWrapperStyled = exports.TabsWrapperStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'TabsWrapperStyled'
	})(['display:flex;align-items:stretch;position:relative;', ';'], style);
	
	TabsWrapperStyled.propTypes = propTypes;
	TabsWrapperStyled.defaultProps = defaultProps;
	TabsWrapperStyled.displayName = 'TabsWrapperStyled';

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactackleCore = __webpack_require__(3);
	
	exports.default = {
	  tabs: {
	    style: {
	      light: {
	        backgroundColor: _reactackleCore.colorTransparent
	      },
	
	      dark: {
	        backgroundColor: _reactackleCore.colorTransparent
	      }
	    }
	  },
	
	  tab: {
	    fontSize: _reactackleCore.fontSizeBody,
	    lineHeight: 1.25,
	    textTransform: 'uppercase',
	    paddingX: (0, _reactackleCore.bmodule)(1.5),
	    paddingY: (0, _reactackleCore.bmodule)(1),
	    minHeight: (0, _reactackleCore.bmodule)(6),
	    minWidth: 120,
	    maxWidth: 320,
	
	    style: {
	      light: {
	        fontColor: _reactackleCore.bodyFontColorAlt,
	        backgroundColor: _reactackleCore.colorTransparent,
	        fontWeight: _reactackleCore.fontWeightNormal,
	        opacity: 0.8,
	
	        hover: {
	          fontColor: _reactackleCore.bodyFontColorAlt,
	          backgroundColor: 'rgba(255, 255, 255, 0.1)',
	          fontWeight: _reactackleCore.fontWeightNormal,
	          opacity: 0.9
	        },
	
	        focus: {
	          fontColor: _reactackleCore.bodyFontColorAlt,
	          backgroundColor: 'rgba(255, 255, 255, 0.1)',
	          fontWeight: _reactackleCore.fontWeightNormal,
	          opacity: 1
	        },
	
	        selected: {
	          fontColor: _reactackleCore.bodyFontColorAlt,
	          backgroundColor: _reactackleCore.colorTransparent,
	          fontWeight: _reactackleCore.fontWeightSemibold,
	          opacity: 1
	        }
	      },
	
	      dark: {
	        fontColor: _reactackleCore.bodyFontColor,
	        backgroundColor: _reactackleCore.colorTransparent,
	        fontWeight: _reactackleCore.fontWeightNormal,
	        opacity: 0.8,
	
	        hover: {
	          fontColor: _reactackleCore.bodyFontColor,
	          backgroundColor: 'rgba(0, 0, 0, 0.1)',
	          fontWeight: _reactackleCore.fontWeightNormal,
	          opacity: 0.9
	        },
	
	        focus: {
	          fontColor: _reactackleCore.bodyFontColor,
	          backgroundColor: 'rgba(0, 0, 0, 0.1)',
	          fontWeight: _reactackleCore.fontWeightNormal,
	          opacity: 1
	        },
	
	        selected: {
	          fontColor: _reactackleCore.bodyFontColor,
	          backgroundColor: _reactackleCore.colorTransparent,
	          fontWeight: _reactackleCore.fontWeightSemibold,
	          opacity: 1
	        }
	      }
	    }
	  },
	
	  icon: {
	    height: 40,
	    width: null,
	    imgSize: null,
	    iconTextSpacing: (0, _reactackleCore.bmodule)(1),
	
	    style: {
	      light: {
	        color: 'inherit',
	
	        hover: {
	          color: 'inherit'
	        },
	
	        focus: {
	          color: 'inherit'
	        },
	
	        selected: {
	          color: 'inherit'
	        }
	      },
	
	      dark: {
	        color: 'inherit',
	
	        hover: {
	          color: 'inherit'
	        },
	
	        focus: {
	          color: 'inherit'
	        },
	
	        selected: {
	          color: 'inherit'
	        }
	      }
	    }
	  },
	
	  bar: {
	    thickness: 4,
	
	    style: {
	      light: {
	        backgroundColor: _reactackleCore.colorMain
	      },
	
	      dark: {
	        backgroundColor: _reactackleCore.colorMain
	      }
	    }
	  }
	};

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TagComponent = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactackleIcons = __webpack_require__(7);
	
	var _reactackleTooltip = __webpack_require__(66);
	
	var _reactackleCore = __webpack_require__(3);
	
	var _styles = __webpack_require__(834);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	(0, _reactackleCore.registerDefaultComponentTheme)('tag', _styles.componentTheme);
	
	/**
	 * Combined with tooltip
	 */
	
	var propTypes = {
	  /**
	   * Bounded tag has max width, long text may be cut
	   */
	  bounded: _propTypes2.default.bool,
	  /**
	   * Define icon component
	   */
	  icon: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func]),
	  /**
	   * Tag text
	   */
	  text: _propTypes2.default.string,
	  /**
	   * Tooltip text
	   */
	  tooltipText: _propTypes2.default.string,
	  /**
	   * Redefines background color
	   */
	  bgColor: _propTypes2.default.string,
	  /**
	   * Redefines text color
	   */
	  textColor: _propTypes2.default.string,
	  /**
	   * Redefines icon color
	   */
	  iconColor: _propTypes2.default.string,
	  /**
	   * Adds remove button
	   */
	  removable: _propTypes2.default.bool,
	  /**
	   * Remove Icon
	   */
	  iconRemove: _propTypes2.default.element,
	  /**
	   * Function to be called in remove button click
	   */
	  onRemove: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  toggleTooltip: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  showTooltip: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  hideTooltip: _propTypes2.default.func
	};
	
	var defaultProps = {
	  bounded: false,
	  icon: null,
	  text: '',
	  tooltipText: '',
	  bgColor: '',
	  textColor: '',
	  iconColor: '',
	  removable: false,
	  iconRemove: _react2.default.createElement(_reactackleIcons.IconCross, { size: 'custom', color: 'currentColor' }),
	  onRemove: _reactackleCore.noop,
	  toggleTooltip: _reactackleCore.noop,
	  showTooltip: _reactackleCore.noop,
	  hideTooltip: _reactackleCore.noop
	};
	
	var TagComponent = function TagComponent(_ref) {
	  var bounded = _ref.bounded,
	      removable = _ref.removable,
	      icon = _ref.icon,
	      iconRemove = _ref.iconRemove,
	      text = _ref.text,
	      tooltipText = _ref.tooltipText,
	      bgColor = _ref.bgColor,
	      textColor = _ref.textColor,
	      iconColor = _ref.iconColor,
	      children = _ref.children,
	      props = _objectWithoutProperties(_ref, ['bounded', 'removable', 'icon', 'iconRemove', 'text', 'tooltipText', 'bgColor', 'textColor', 'iconColor', 'children']);
	
	  var tooltip = tooltipText && _react2.default.createElement(
	    props.Tooltip,
	    null,
	    tooltipText
	  );
	
	  var textElement = text && _react2.default.createElement(
	    _styles.TextStyled,
	    { isBounded: bounded, title: text },
	    text
	  );
	
	  var removeButton = removable && _react2.default.createElement(
	    _styles.RemoveIconStyled,
	    { onClick: props.onRemove },
	    iconRemove
	  );
	
	  var iconElement = null;
	
	  if (icon) {
	    if (typeof icon === "function") {
	      var Icon = icon;
	      iconElement = _react2.default.createElement(
	        _styles.IconStyled,
	        { iconColor: iconColor },
	        _react2.default.createElement(Icon, null)
	      );
	    } else {
	      iconElement = _react2.default.createElement(
	        _styles.IconStyled,
	        { iconColor: iconColor },
	        icon
	      );
	    }
	  }
	
	  var wrapperProps = {
	    onClick: props.toggleTooltip,
	    onFocus: props.showTooltip,
	    onBlur: props.hideTooltip,
	    onMouseEnter: props.showTooltip,
	    onMouseLeave: props.hideTooltip
	  };
	
	  return _react2.default.createElement(
	    _styles.TagStyled,
	    _extends({}, wrapperProps, {
	      bgColorCustom: bgColor,
	      textColorCustom: textColor
	    }),
	    iconElement,
	    _react2.default.createElement(
	      _styles.ContentStyled,
	      {
	        hasIcon: !!icon,
	        isBounded: bounded,
	        isRemovable: removable
	      },
	      textElement,
	      children
	    ),
	    removeButton,
	    tooltip
	  );
	};
	
	exports.TagComponent = TagComponent;
	TagComponent.propTypes = propTypes;
	TagComponent.defaultProps = defaultProps;
	TagComponent.displayName = 'Tag';
	
	exports.default = (0, _reactackleTooltip.withTooltip)(TagComponent, true);

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Tag = undefined;
	
	var _Tag = __webpack_require__(827);
	
	var _Tag2 = _interopRequireDefault(_Tag);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Tag = _Tag2.default;

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ContentStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  hasIcon: _propTypes2.default.bool,
	  isBounded: _propTypes2.default.bool
	};
	
	var defaultProps = {
	  hasIcon: false,
	  isBounded: false
	};
	
	var padding = function padding(_ref) {
	  var hasIcon = _ref.hasIcon,
	      isRemovable = _ref.isRemovable,
	      themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var path = theme.reactackle.components.tag;
	
	  var _path$content = path.content,
	      paddingY = _path$content.paddingY,
	      paddingX = _path$content.paddingX,
	      iconTextOffset = _path$content.iconTextOffset;
	
	
	  return (0, _styledComponents.css)(['padding:', ' ', ';', ' ', ''], (0, _reactackleCore.getValueString)(paddingY), (0, _reactackleCore.getValueString)(paddingX), hasIcon && 'padding-left: ' + (0, _reactackleCore.getValueString)(iconTextOffset) + ';', isRemovable && '\n      padding-right: ' + (0, _reactackleCore.getValueString)(path.removeIcon.iconTextSpacing) + ';\n    ');
	};
	
	var isBounded = function isBounded(_ref2) {
	  var isBounded = _ref2.isBounded;
	  return isBounded && '\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n';
	};
	
	var ContentStyled = exports.ContentStyled = _styledComponents2.default.span.withConfig({
	  displayName: 'ContentStyled'
	})(['', ' ', ''], padding, isBounded);
	
	ContentStyled.propTypes = propTypes;
	ContentStyled.defaultProps = defaultProps;

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.IconStyled = undefined;
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var style = function style(_ref) {
	  var themeFromProvider = _ref.theme,
	      iconColor = _ref.iconColor;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var _theme$reactackle$com = theme.reactackle.components.tag.icon,
	      height = _theme$reactackle$com.height,
	      width = _theme$reactackle$com.width,
	      imgHeight = _theme$reactackle$com.imgHeight,
	      imgWidth = _theme$reactackle$com.imgWidth,
	      color = _theme$reactackle$com.color,
	      opacity = _theme$reactackle$com.opacity;
	
	
	  return (0, _styledComponents.css)(['color:', ';opacity:', ';', ''], iconColor || color, opacity, (0, _reactackleCore.iconSizeMixin)((0, _reactackleCore.getValueString)(height), (0, _reactackleCore.getValueString)(imgHeight || height), (0, _reactackleCore.getValueString)(width || height), (0, _reactackleCore.getValueString)(imgWidth || imgHeight || height)));
	};
	
	var IconStyled = exports.IconStyled = _styledComponents2.default.span.withConfig({
	  displayName: 'IconStyled'
	})(['', ''], style);

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.RemoveIconStyled = undefined;
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var size = function size(_ref) {
	  var themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var _theme$reactackle$com = theme.reactackle.components.tag.removeIcon,
	      height = _theme$reactackle$com.height,
	      width = _theme$reactackle$com.width,
	      imgHeight = _theme$reactackle$com.imgHeight,
	      imgWidth = _theme$reactackle$com.imgWidth,
	      iconTextSpacing = _theme$reactackle$com.iconTextSpacing;
	
	
	  return (0, _styledComponents.css)(['margin-left:', ';', ''], (0, _reactackleCore.getValueString)(iconTextSpacing), (0, _reactackleCore.iconSizeMixin)((0, _reactackleCore.getValueString)(height), (0, _reactackleCore.getValueString)(imgHeight || height), (0, _reactackleCore.getValueString)(width || height), (0, _reactackleCore.getValueString)(imgWidth || imgHeight || height)));
	};
	
	var style = function style(_ref2) {
	  var themeFromProvider = _ref2.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var path = theme.reactackle.components.tag.removeIcon.state;
	
	  var color = path.color,
	      backgroundColor = path.backgroundColor;
	  var _path$hover = path.hover,
	      hoverColor = _path$hover.color,
	      hoverBG = _path$hover.backgroundColor;
	  var _path$focus = path.focus,
	      focusColor = _path$focus.color,
	      focusBG = _path$focus.backgroundColor;
	
	
	  return (0, _styledComponents.css)(['color:', ';background-color:', ';&:hover{color:', ';background-color:', ';}&:focus{color:', ';background-color:', ';}'], color, backgroundColor, hoverColor || color, hoverBG || backgroundColor, focusColor || hoverColor || color, focusBG || hoverBG || backgroundColor);
	};
	
	var RemoveIconStyled = exports.RemoveIconStyled = _styledComponents2.default.button.withConfig({
	  displayName: 'RemoveIconStyled'
	})(['   &,&:hover,&:focus{cursor:pointer;outline:none;box-shadow:none;border:0;padding:0;}', ' ', ' ', ''], size, style, (0, _reactackleCore.transition)('color, background-color'));

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TagStyled = undefined;
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ALIGN_MAP = {
	  top: 'flex-start',
	  center: 'center',
	  bottom: 'flex-end'
	};
	
	var borderRadius = function borderRadius(_ref) {
	  var themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var borderRadius = theme.reactackle.components.tag.borderRadius;
	
	
	  return (0, _styledComponents.css)(['border-radius:', ';'], (0, _reactackleCore.getValueString)(borderRadius));
	};
	
	var colorScheme = function colorScheme(_ref2) {
	  var themeFromProvider = _ref2.theme,
	      bgColorCustom = _ref2.bgColorCustom,
	      textColorCustom = _ref2.textColorCustom;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var _theme$reactackle$com = theme.reactackle.components.tag,
	      backgroundColor = _theme$reactackle$com.backgroundColor,
	      textColor = _theme$reactackle$com.textColor;
	
	
	  return (0, _styledComponents.css)(['background-color:', ';color:', ';'], bgColorCustom || backgroundColor, textColorCustom || textColor);
	};
	
	var fontStyle = function fontStyle(_ref3) {
	  var themeFromProvider = _ref3.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var _theme$reactackle$com2 = theme.reactackle.components.tag,
	      fontSize = _theme$reactackle$com2.fontSize,
	      lineHeight = _theme$reactackle$com2.lineHeight;
	
	
	  return (0, _styledComponents.css)(['font-size:', ';line-height:', ';'], (0, _reactackleCore.getValueString)(fontSize), lineHeight);
	};
	
	var align = function align(_ref4) {
	  var themeFromProvider = _ref4.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var alignY = theme.reactackle.components.tag.content.alignY;
	
	
	  return (0, _styledComponents.css)(['align-items:', ';'], ALIGN_MAP[alignY]);
	};
	
	var TagStyled = exports.TagStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'TagStyled'
	})(['display:inline-flex;vertical-align:middle;user-select:none;max-width:100%;', ' ', ' ', ' ', ' ', ''], fontStyle, colorScheme, borderRadius, align, (0, _reactackleCore.transition)('background-color, color, opacity'));

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TextStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  isBounded: _propTypes2.default.bool
	};
	
	var defaultProps = {
	  isBounded: false
	};
	
	var textStyle = function textStyle(_ref) {
	  var themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var _theme$reactackle$com = theme.reactackle.components.tag,
	      fontSize = _theme$reactackle$com.fontSize,
	      lineHeight = _theme$reactackle$com.lineHeight;
	
	
	  return (0, _styledComponents.css)(['font-size:', ';line-height:', ';'], (0, _reactackleCore.getValueString)(fontSize), lineHeight);
	};
	
	var isBounded = function isBounded(_ref2) {
	  var isBounded = _ref2.isBounded;
	  return isBounded && '\n  white-space: nowrap;\n';
	};
	
	var TextStyled = exports.TextStyled = _styledComponents2.default.span.withConfig({
	  displayName: 'TextStyled'
	})(['color:currentColor;', ' ', ''], textStyle, isBounded);
	
	TextStyled.propTypes = propTypes;
	TextStyled.defaultProps = defaultProps;

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.componentTheme = undefined;
	
	var _TagStyled = __webpack_require__(832);
	
	Object.keys(_TagStyled).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _TagStyled[key];
	    }
	  });
	});
	
	var _IconStyled = __webpack_require__(830);
	
	Object.keys(_IconStyled).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _IconStyled[key];
	    }
	  });
	});
	
	var _ContentStyled = __webpack_require__(829);
	
	Object.keys(_ContentStyled).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ContentStyled[key];
	    }
	  });
	});
	
	var _TextStyled = __webpack_require__(833);
	
	Object.keys(_TextStyled).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _TextStyled[key];
	    }
	  });
	});
	
	var _RemoveIconStyled = __webpack_require__(831);
	
	Object.keys(_RemoveIconStyled).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _RemoveIconStyled[key];
	    }
	  });
	});
	
	var _theme = __webpack_require__(835);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.componentTheme = _theme2.default;

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactackleCore = __webpack_require__(3);
	
	exports.default = {
	  fontSize: _reactackleCore.fontSizeBody,
	  lineHeight: 1.2,
	  borderRadius: _reactackleCore.radiusDefault,
	  backgroundColor: _reactackleCore.colorPaletteGrey300,
	  textColor: _reactackleCore.bodyFontColor,
	
	  content: {
	    paddingX: (0, _reactackleCore.bmodule)(1),
	    paddingY: (0, _reactackleCore.bmodule)(0.5),
	    iconTextOffset: (0, _reactackleCore.bmodule)(1),
	    alignY: 'top' // one of ['top', 'center', 'bottom']
	  },
	
	  icon: {
	    height: 24,
	    width: null,
	    imgHeight: 20,
	    imgWidth: null,
	    color: 'currentColor',
	    opacity: 1
	  },
	
	  removeIcon: {
	    iconTextSpacing: (0, _reactackleCore.bmodule)(0.5),
	    height: 24,
	    width: null,
	    imgHeight: 20,
	    imgWidth: null,
	
	    state: {
	      color: _reactackleCore.bodyFontColor,
	      backgroundColor: 'transparent',
	
	      hover: {
	        color: null, // will take 'default' if null
	        backgroundColor: 'rgba(0,0,0,0.2)' // will take 'default' if null
	      },
	
	      focus: {
	        color: null, // will take 'hover' if null
	        backgroundColor: null // will take 'hover' if null
	      }
	    }
	  }
	};

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactackleTooltipIcon = __webpack_require__(52);
	
	var _reactackleCore = __webpack_require__(3);
	
	var _InfoBoxStyled = __webpack_require__(840);
	
	var _IconOuterStyled = __webpack_require__(839);
	
	var _IconInnerStyled = __webpack_require__(838);
	
	var _InnerButton = __webpack_require__(841);
	
	var _LabelSlidingStyled = __webpack_require__(842);
	
	var _LabelStyled = __webpack_require__(843);
	
	var _LabelTextStyled = __webpack_require__(844);
	
	var _MessageStyled = __webpack_require__(845);
	
	var _CounterStyled = __webpack_require__(837);
	
	var _PrefixStyled = __webpack_require__(848);
	
	var _PrefixTextStyled = __webpack_require__(849);
	
	var _PostfixStyled = __webpack_require__(846);
	
	var _PostfixTextStyled = __webpack_require__(847);
	
	var _TextFieldStyled = __webpack_require__(854);
	
	var _TextFieldGroupStyled = __webpack_require__(852);
	
	var _TextFieldElementStyled = __webpack_require__(851);
	
	var _TextFieldContentBoxStyled = __webpack_require__(850);
	
	var _TextFieldRowStyled = __webpack_require__(853);
	
	var _theme = __webpack_require__(855);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	(0, _reactackleCore.registerDefaultComponentTheme)('textfield', _theme2.default);
	
	var propTypes = {
	  /**
	   * Value of the TextField
	   */
	  value: _propTypes2.default.string,
	  /**
	   * Default value of the TextField
	   */
	  defaultValue: _propTypes2.default.string,
	  /**
	   * Placeholder of the TextField
	   */
	  placeholder: _propTypes2.default.string,
	  /**
	   * Type of the TextField
	   */
	  type: _propTypes2.default.oneOf(['text', 'number', 'email', 'tel', 'url', 'password']),
	  /**
	   * If bordered = false, Input will have only bottom border
	   */
	  bordered: _propTypes2.default.bool,
	  /**
	   * Full-width Input doesn't have borders
	   */
	  fullWidth: _propTypes2.default.bool,
	  /**
	   * If TextField is dense it has smaller paddings
	   */
	  dense: _propTypes2.default.bool,
	  /**
	   * If TextField's max symbol amount defined, symbol counter will be revealed
	   */
	  symbolLimit: _propTypes2.default.number,
	  /**
	   * Determines whether TextField is disabled
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * Defines label text
	   */
	  label: _propTypes2.default.string,
	  /**
	   * Defines TextField message (help or error text)
	   */
	  message: _propTypes2.default.string,
	  /**
	   * If clearingIcon = true, TextField can be cleared by clicking on clearing-icon
	   */
	  clearingIcon: _propTypes2.default.bool,
	  /**
	   * Add icon behind TextField (see IconSvg or IconCustom props)
	   */
	  iconOuter: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func]),
	  /**
	   * Show icon inside TextField's boundaries (see IconSvg or IconCustom props)
	   */
	  iconInner: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func]),
	  /**
	   * Define label position
	   */
	  labelPosition: _propTypes2.default.oneOf(['top', 'side']),
	  /**
	   * If slidingLabel = true, label will float to top
	   * when parent TextField is focused or filled
	   */
	  slidingLabel: _propTypes2.default.bool,
	  /**
	   * Automatically scroll window to the focused input
	   */
	  scrollOnFocus: _propTypes2.default.bool,
	  /**
	   * This prop will be passed to inner input element
	   */
	  autoComplete: _propTypes2.default.string,
	  /**
	   * Adds tooltip
	   */
	  tooltip: _propTypes2.default.string,
	  /**
	   * Defines component's colorScheme
	   */
	  colorScheme: _propTypes2.default.oneOf(['neutral', 'error', 'success']),
	  /**
	   * Add prefix text
	   */
	  prefix: _propTypes2.default.string,
	  /**
	   * Add postfix text
	   */
	  postfix: _propTypes2.default.string,
	  /**
	   * Determines whether to render TextField in textarea mode
	   */
	  multiline: _propTypes2.default.bool,
	  /**
	   * Determines max and min row amount, applies only if multiline prop is true
	   */
	  multilineRows: _propTypes2.default.shape({
	    min: _propTypes2.default.number,
	    max: _propTypes2.default.number
	  }),
	  /**
	   * Specify type of resizing, only applied in multiline TextField
	   */
	  resize: _propTypes2.default.oneOf(['none', 'manual', 'auto']),
	  /**
	   * @ignore
	   */
	  theme: _propTypes2.default.object,
	  /**
	   * Determines pattern to test input
	   */
	  pattern: _propTypes2.default.object,
	  /**
	   * Determines pattern function to test input
	   */
	  patternFn: _propTypes2.default.func,
	  /**
	   * Specify function to call on TextField value change
	   */
	  onChange: _propTypes2.default.func,
	  /**
	   * Specify function to call on TextField focus
	   */
	  onFocus: _propTypes2.default.func,
	  /**
	   * Specify function to call on onBlur
	   */
	  onBlur: _propTypes2.default.func,
	  /**
	   * Specify function to call on pattern error
	   */
	  onPatternError: _propTypes2.default.func,
	  /**
	   * Specify function to call on length error
	   */
	  onLengthError: _propTypes2.default.func,
	  /**
	   * Specify function to call on TextField click
	   */
	  onClick: _propTypes2.default.func
	};
	
	var defaultProps = {
	  value: void 0,
	  defaultValue: '',
	  placeholder: '',
	  type: 'text',
	  bordered: false,
	  fullWidth: false,
	  multiline: false,
	  multilineRows: { min: 2, max: 4 },
	  resize: 'auto',
	  dense: false,
	  symbolLimit: 0,
	  disabled: false,
	  label: '',
	  message: '',
	  clearingIcon: false,
	  iconOuter: null,
	  iconInner: null,
	  labelPosition: 'top',
	  slidingLabel: false,
	  scrollOnFocus: false,
	  autoComplete: 'off',
	  tooltip: null,
	  colorScheme: 'neutral',
	  prefix: '',
	  postfix: '',
	  theme: {},
	  pattern: /.*/,
	  patternFn: _reactackleCore.returnTrue,
	  onChange: _reactackleCore.noop,
	  onFocus: _reactackleCore.noop,
	  onBlur: _reactackleCore.noop,
	  onPatternError: _reactackleCore.noop,
	  onLengthError: _reactackleCore.noop,
	  onClick: _reactackleCore.noop
	};
	
	var _TextField = function (_Component) {
	  _inherits(_TextField, _Component);
	
	  function _TextField(props) {
	    _classCallCheck(this, _TextField);
	
	    var _this = _possibleConstructorReturn(this, (_TextField.__proto__ || Object.getPrototypeOf(_TextField)).call(this, props));
	
	    _this.id = _this.constructor.displayName + '_' + _this.constructor.nextId++;
	
	    _this.state = {
	      hidden: props.type === 'password' ? true : null,
	      value: _this._valueDefined() ? props.value : props.defaultValue,
	      focus: false,
	      lengthError: false,
	      patternError: false
	    };
	    _this.textFieldComponent = _this._getTextFieldComponentStyled();
	    _this._saveRef = _this._saveRef.bind(_this);
	    _this._saveRefWrap = _this._saveRefWrap.bind(_this);
	    _this._handleHideValue = _this._handleHideValue.bind(_this);
	    _this._handleClearValue = _this._handleClearValue.bind(_this);
	    _this._handleBlur = _this._handleBlur.bind(_this);
	    _this._handleChange = _this._handleChange.bind(_this);
	    _this._handleFocus = _this._handleFocus.bind(_this);
	    _this._handleClick = _this._handleClick.bind(_this);
	    _this._handleChange = _this._handleChange.bind(_this);
	    _this.focus = _this.focus.bind(_this);
	    _this.getValue = _this.getValue.bind(_this);
	    return _this;
	  }
	
	  _createClass(_TextField, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var isTypeChanged = this.props.type !== nextProps.type;
	      var isTextFieldChanged = this.props.multiline !== nextProps.multiline;
	
	      var isValueChanged = nextProps.value !== this.props.value;
	      var isDefaultValueChanged = nextProps.defaultValue !== this.props.defaultValue;
	
	      if (isValueChanged && this._valueDefined(nextProps)) this.setState({ value: nextProps.value });
	      if (isDefaultValueChanged && !this.state.value.length) this.setState({ value: nextProps.defaultValue });
	      if (isTypeChanged) this.setState({ hidden: nextProps.type === 'password' ? true : null });
	      if (isTextFieldChanged) this.textFieldComponent = this._getTextFieldComponentStyled();
	    }
	  }, {
	    key: 'getValue',
	    value: function getValue() {
	      return this._valueDefined() ? this.props.value : this.state.value;
	    }
	  }, {
	    key: 'focus',
	    value: function focus() {
	      if (this._domNodeInput) this._domNodeInput.focus();
	
	      this.setState({ focus: true });
	
	      this.props.onFocus();
	    }
	  }, {
	    key: '_valueDefined',
	    value: function _valueDefined() {
	      var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	
	      return !(0, _reactackleCore.isUndef)(source.value);
	    }
	  }, {
	    key: '_getTextFieldComponentStyled',
	    value: function _getTextFieldComponentStyled() {
	      if (!this.props.multiline) return _TextFieldElementStyled.InputStyled;
	
	      return this.props.resize === 'auto' ? _TextFieldElementStyled.TextareaAutosizeStyled : _TextFieldElementStyled.TextareaStyled;
	    }
	  }, {
	    key: '_parseValue',
	    value: function _parseValue(value) {
	      return value;
	    }
	  }, {
	    key: '_handleHideValue',
	    value: function _handleHideValue() {
	      this.setState(function (_ref) {
	        var hidden = _ref.hidden;
	        return { hidden: !hidden };
	      });
	    }
	  }, {
	    key: '_handleFocus',
	    value: function _handleFocus(event) {
	      if (this.props.scrollOnFocus && this._domNodeWrap && typeof this._domNodeWrap.scrollIntoView === 'function') this._domNodeWrap.scrollIntoView();
	
	      this.setState({ focus: true });
	
	      this.props.onFocus(event);
	    }
	  }, {
	    key: '_handleBlur',
	    value: function _handleBlur(event) {
	      this.setState({ focus: false });
	
	      this.props.onBlur(event);
	    }
	  }, {
	    key: '_handleClick',
	    value: function _handleClick(event) {
	      this.props.onClick(event);
	    }
	  }, {
	    key: '_handleChange',
	    value: function _handleChange(event) {
	      var value = this._parseValue((event.currentTarget || event.target).value // TODO fix tests
	      );
	
	      var lengthError = this.props.symbolLimit > 0 && value.length > this.props.symbolLimit;
	
	      if (lengthError) {
	        value = value.slice(0, this.props.symbolLimit);
	        this.props.onLengthError();
	      }
	
	      var patternError = !(this.props.patternFn(value) && this.props.pattern.test(value));
	
	      if (patternError) this.props.onPatternError();else this.props.onChange({ value: value });
	
	      if (!this._valueDefined()) this.setState({ value: value });
	
	      this.setState({
	        lengthError: lengthError,
	        patternError: patternError
	      });
	    }
	  }, {
	    key: '_saveRefWrap',
	    value: function _saveRefWrap(ref) {
	      this._domNodeWrap = ref;
	    }
	  }, {
	    key: '_saveRef',
	    value: function _saveRef(ref) {
	      this._domNodeInput = ref;
	    }
	  }, {
	    key: '_handleClearValue',
	    value: function _handleClearValue() {
	      this.setState({
	        value: '',
	        lengthError: false,
	        patternError: false
	      });
	      this.props.onChange({ value: '' });
	    }
	  }, {
	    key: '_renderCounter',
	    value: function _renderCounter() {
	      if (!this.props.symbolLimit) return null;
	
	      return _react2.default.createElement(
	        _CounterStyled.CounterStyled,
	        {
	          error: this.state.lengthError,
	          disabled: this.props.disabled,
	          focus: this.state.focus
	        },
	        _react2.default.createElement(
	          'span',
	          null,
	          this.state.value.length
	        ),
	        _react2.default.createElement(
	          'span',
	          null,
	          ' / '
	        ),
	        _react2.default.createElement(
	          'span',
	          null,
	          this.props.symbolLimit
	        )
	      );
	    }
	  }, {
	    key: '_renderMessage',
	    value: function _renderMessage() {
	      if (!this.props.message) return null;
	
	      return _react2.default.createElement(
	        _MessageStyled.MessageStyled,
	        {
	          colorScheme: this.props.colorScheme,
	          disabled: this.props.disabled,
	          focus: this.state.focus
	        },
	        this.props.message
	      );
	    }
	  }, {
	    key: '_renderLowerLine',
	    value: function _renderLowerLine() {
	      if (!this.props.message && !this.props.symbolLimit) return null;
	
	      var message = this._renderMessage(),
	          counter = this._renderCounter();
	
	      return _react2.default.createElement(
	        _InfoBoxStyled.InfoBoxStyled,
	        {
	          bordered: this.props.bordered,
	          labelPosition: this.props.labelPosition,
	          dense: this.props.dense,
	          fullWidth: this.props.fullWidth,
	          iconOuter: this.props.iconOuter
	        },
	        message,
	        counter
	      );
	    }
	  }, {
	    key: '_renderInnerButton',
	    value: function _renderInnerButton() {
	      var componentPath = this.props.theme.reactackle.components.textfield;
	
	      var clearingIconElement = componentPath.clearingIconElement;
	
	      var passwordIconElement = this.state.hidden ? componentPath.passwordIconShowElement : componentPath.passwordIconHideElement;
	
	      if (typeof this.state.hidden === 'boolean') {
	        return _react2.default.createElement(
	          _InnerButton.InnerButton,
	          {
	            disabled: this.props.disabled,
	            focus: this.state.focus,
	            dense: this.props.dense,
	            fullWidth: this.props.fullWidth,
	            colorScheme: this.props.colorScheme,
	            onClick: this._handleHideValue
	          },
	          passwordIconElement
	        );
	      } else if (this.props.clearingIcon) {
	        return _react2.default.createElement(
	          _InnerButton.InnerButton,
	          {
	            disabled: this.props.disabled,
	            focus: this.state.focus,
	            dense: this.props.dense,
	            fullWidth: this.props.fullWidth,
	            colorScheme: this.props.colorScheme,
	            onClick: this._handleClearValue
	          },
	          clearingIconElement
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: '_renderIconOuter',
	    value: function _renderIconOuter() {
	      var iconOuter = this.props.iconOuter;
	
	      if (!iconOuter) return null;
	
	      var iconElement = void 0;
	
	      if (typeof this.props.iconOuter === "function") {
	        var IconOuter = this.props.iconOuter;
	        iconElement = _react2.default.createElement(IconOuter, null);
	      } else {
	        iconElement = this.props.iconOuter;
	      }
	
	      return _react2.default.createElement(
	        _IconOuterStyled.IconOuterStyled,
	        {
	          disabled: this.props.disabled,
	          focus: this.state.focus,
	          dense: this.props.dense,
	          fullWidth: this.props.fullWidth,
	          colorScheme: this.props.colorScheme,
	          htmlFor: this.id
	        },
	        iconElement
	      );
	    }
	  }, {
	    key: '_renderIconInner',
	    value: function _renderIconInner() {
	      var iconInner = this.props.iconInner;
	
	      if (!iconInner) return null;
	
	      var iconElement = void 0;
	
	      if (typeof this.props.iconOuter === "function") {
	        var IconInner = this.props.iconInner;
	        iconElement = _react2.default.createElement(IconInner, null);
	      } else {
	        iconElement = this.props.iconInner;
	      }
	
	      return this.props.iconInner && _react2.default.createElement(
	        _IconInnerStyled.IconInnerStyled,
	        {
	          disabled: this.props.disabled,
	          focus: this.state.focus,
	          dense: this.props.dense,
	          fullWidth: this.props.fullWidth,
	          colorScheme: this.props.colorScheme
	        },
	        iconElement
	      );
	    }
	  }, {
	    key: '_renderPrefixText',
	    value: function _renderPrefixText() {
	      if (!this.props.prefix) return null;
	
	      return _react2.default.createElement(
	        _PrefixTextStyled.PrefixTextStyled,
	        {
	          disabled: this.props.disabled,
	          bordered: this.props.bordered,
	          colorScheme: this.props.colorScheme,
	          focus: this.state.focus,
	          dense: this.props.dense,
	          fullWidth: this.props.fullWidth
	        },
	        _react2.default.createElement(
	          'span',
	          null,
	          this.props.prefix
	        )
	      );
	    }
	  }, {
	    key: '_renderLabel',
	    value: function _renderLabel() {
	      if (!this.props.label) return null;
	
	      var tooltip = null;
	      if (this.props.tooltip) tooltip = _react2.default.createElement(_reactackleTooltipIcon.TooltipIcon, { text: this.props.tooltip });
	      var LabelTag = this.props.slidingLabel ? _LabelSlidingStyled.LabelSlidingStyled : _LabelStyled.LabelStyled;
	
	      return _react2.default.createElement(
	        LabelTag,
	        {
	          htmlFor: this.id,
	          labelPosition: this.props.labelPosition,
	          disabled: this.props.disabled,
	          focus: this.state.focus,
	          filled: !!this.state.value.length,
	          dense: this.props.dense,
	          fullWidth: this.props.fullWidth,
	          colorScheme: this.props.colorScheme,
	          iconOuter: this.props.iconOuter,
	          bordered: this.props.bordered
	        },
	        _react2.default.createElement(
	          _LabelTextStyled.LabelTextStyled,
	          null,
	          this.props.label
	        ),
	        tooltip
	      );
	    }
	  }, {
	    key: '_renderPrefix',
	    value: function _renderPrefix() {
	      if (!this.props.prefix && !this.props.iconInner) return null;
	
	      return _react2.default.createElement(
	        _PrefixStyled.PrefixStyled,
	        {
	          disabled: this.props.disabled,
	          bordered: this.props.bordered,
	          colorScheme: this.props.colorScheme,
	          focus: this.state.focus,
	          dense: this.props.dense,
	          fullWidth: this.props.fullWidth,
	          htmlFor: this.id
	        },
	        this._renderIconInner(),
	        this._renderPrefixText()
	      );
	    }
	  }, {
	    key: '_renderPostfixText',
	    value: function _renderPostfixText() {
	      return _react2.default.createElement(
	        _PostfixTextStyled.PostfixTextStyled,
	        {
	          disabled: this.props.disabled,
	          bordered: this.props.bordered,
	          colorScheme: this.props.colorScheme,
	          focus: this.state.focus,
	          dense: this.props.dense,
	          fullWidth: this.props.fullWidth
	        },
	        _react2.default.createElement(
	          'span',
	          null,
	          this.props.postfix
	        )
	      );
	    }
	  }, {
	    key: '_renderPostfix',
	    value: function _renderPostfix() {
	      if (!this.props.postfix) return null;
	
	      var postfixText = this._renderPostfixText();
	
	      return _react2.default.createElement(
	        _PostfixStyled.PostfixStyled,
	        {
	          disabled: this.props.disabled,
	          bordered: this.props.bordered,
	          colorScheme: this.props.colorScheme,
	          focus: this.state.focus,
	          dense: this.props.dense,
	          fullWidth: this.props.fullWidth,
	          htmlFor: this.id
	        },
	        postfixText
	      );
	    }
	  }, {
	    key: '_renderTextField',
	    value: function _renderTextField(textFieldProps) {
	      var TextFieldComponent = this.textFieldComponent;
	      var isPasswordUnhidden = textFieldProps.type === 'password' && !this.state.hidden;
	      var inputType = isPasswordUnhidden ? 'text' : textFieldProps.type;
	
	      var props = textFieldProps;
	      props.type = inputType;
	      if (this.props.multiline && this.props.resize !== 'auto') {
	        props.rows = this.props.multilineRows.min;
	      }
	
	      return _react2.default.createElement(TextFieldComponent, props);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _renderTextField2;
	
	      var isTextareaAutosize = this.props.multiline && this.props.resize === 'auto';
	      var iconOuter = this._renderIconOuter(),
	          prefix = this._renderPrefix(),
	          textField = this._renderTextField((_renderTextField2 = {
	        resize: this.props.resize
	      }, _defineProperty(_renderTextField2, isTextareaAutosize ? 'saveRef' : 'innerRef', this._saveRef), _defineProperty(_renderTextField2, 'id', this.id), _defineProperty(_renderTextField2, 'dense', this.props.dense), _defineProperty(_renderTextField2, 'fullWidth', this.props.fullWidth), _defineProperty(_renderTextField2, 'placeholder', this.props.placeholder), _defineProperty(_renderTextField2, 'bordered', this.props.bordered), _defineProperty(_renderTextField2, 'colorScheme', this.props.colorScheme), _defineProperty(_renderTextField2, 'focus', this.state.focus), _defineProperty(_renderTextField2, 'type', this.props.type), _defineProperty(_renderTextField2, 'value', this.state.value), _defineProperty(_renderTextField2, 'autoComplete', this.props.autoComplete), _defineProperty(_renderTextField2, 'onChange', this._handleChange), _defineProperty(_renderTextField2, 'onFocus', this._handleFocus), _defineProperty(_renderTextField2, 'onBlur', this._handleBlur), _defineProperty(_renderTextField2, 'onClick', this._handleClick), _defineProperty(_renderTextField2, 'maxRows', this.props.multilineRows.max), _defineProperty(_renderTextField2, 'minRows', this.props.multilineRows.min), _defineProperty(_renderTextField2, 'disabled', this.props.disabled), _renderTextField2)),
	          postfix = this._renderPostfix(),
	          button = this._renderInnerButton(),
	          label = this._renderLabel(),
	          lowerLine = this._renderLowerLine();
	
	      return _react2.default.createElement(
	        _TextFieldStyled.TextFieldStyled,
	        {
	          innerRef: this._saveRefWrap,
	          dense: this.props.dense,
	          fullWidth: this.props.fullWidth
	        },
	        _react2.default.createElement(
	          _TextFieldContentBoxStyled.TextFieldContentBoxStyled,
	          { labelPosition: this.props.labelPosition },
	          label,
	          _react2.default.createElement(
	            _TextFieldRowStyled.TextFieldRowStyled,
	            {
	              disabled: this.props.disabled,
	              bordered: this.props.bordered,
	              colorScheme: this.props.colorScheme,
	              focus: this.state.focus,
	              dense: this.props.dense,
	              fullWidth: this.props.fullWidth,
	              slidingLabel: this.props.slidingLabel
	            },
	            iconOuter,
	            _react2.default.createElement(
	              _TextFieldGroupStyled.TextFieldGroupStyled,
	              {
	                disabled: this.props.disabled,
	                bordered: this.props.bordered,
	                colorScheme: this.props.colorScheme,
	                focus: this.state.focus,
	                dense: this.props.dense,
	                fullWidth: this.props.fullWidth
	              },
	              prefix,
	              textField,
	              button,
	              postfix
	            )
	          )
	        ),
	        lowerLine
	      );
	    }
	  }]);
	
	  return _TextField;
	}(_react.Component);
	
	_TextField.nextId = 0;
	_TextField.propTypes = propTypes;
	_TextField.defaultProps = defaultProps;
	_TextField.displayName = 'TextField';
	
	var TextField = (0, _reactackleCore.withTheme)(_TextField);
	TextField._withoutHOC = _TextField;
	exports.default = TextField;

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CounterStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  disabled: _propTypes2.default.bool,
	  /**
	   * Define component theme config
	   * See https://github.com/styled-components/styled-components/blob/master/docs/theming.md
	   * for more information
	   */
	  theme: _propTypes2.default.object
	};
	
	var defaultProps = {
	  disabled: false
	};
	
	/** PROP RECEIVERS */
	var styleProps = function styleProps(_ref) {
	  var themeFromProvider = _ref.theme,
	      error = _ref.error,
	      focus = _ref.focus,
	      disabled = _ref.disabled;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var path = theme.reactackle.components.textfield.symbolCounter.style;
	
	  var source = null;
	  if (!disabled) {
	    if (error) source = path.error;else if (focus) source = path.focus;else source = path;
	  } else {
	    source = path.disabled;
	  }
	
	  var _source = source,
	      fontColor = _source.fontColor;
	
	
	  return 'color: ' + fontColor + ';';
	};
	
	var baseProps = function baseProps(_ref2) {
	  var themeFromProvider = _ref2.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var _theme$reactackle$com = theme.reactackle.components.textfield.symbolCounter,
	      counterSpacing = _theme$reactackle$com.counterSpacing,
	      counterMessageSpacing = _theme$reactackle$com.counterMessageSpacing,
	      fontSize = _theme$reactackle$com.fontSize,
	      lineHeight = _theme$reactackle$com.lineHeight;
	
	
	  return '\n    margin-top: ' + (0, _reactackleCore.getValueString)(counterSpacing) + ';\n    margin-left: ' + (0, _reactackleCore.getValueString)(counterMessageSpacing) + ';\n    font-size: ' + (0, _reactackleCore.getValueString)(fontSize) + ';\n    line-height: ' + lineHeight + ';\n  ';
	};
	
	var animationPulse = (0, _styledComponents.keyframes)(['from{-webkit-transform:scale3d(1,1,1);transform:scale3d(1,1,1);}50%{-webkit-transform:scale3d(1.1,1.1,1.1);transform:scale3d(1.1,1.1,1.1);}100%{-webkit-transform:scale3d(1,1,1);transform:scale3d(1,1,1);}']);
	
	var animation = function animation(_ref3) {
	  var error = _ref3.error;
	  return error && '\n  animation: ' + animationPulse + ' 200ms;\n  animation-iteration-count: 3;\n';
	};
	
	/** STYLES */
	var CounterStyled = exports.CounterStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'CounterStyled'
	})(['text-align:right;user-select:none;', ';', ';', ';'], baseProps, styleProps, animation);
	
	CounterStyled.propTypes = propTypes;
	CounterStyled.defaultProps = defaultProps;
	CounterStyled.displayName = 'CounterStyled';

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.IconInnerStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleIcons = __webpack_require__(7);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  disabled: _propTypes2.default.bool,
	  /**
	   * Full-width TextField doesn't have borders
	   */
	  fullWidth: _propTypes2.default.bool,
	  /**
	   * If textfield is dense it has smaller paddings
	   */
	  dense: _propTypes2.default.bool,
	  colorScheme: _propTypes2.default.oneOf(['neutral', 'error', 'success'])
	};
	
	var defaultProps = {
	  disabled: false,
	  fullWidth: false,
	  dense: false,
	  colorScheme: 'neutral'
	};
	
	/** PROP RECEIVERS */
	var iconBase = function iconBase(_ref) {
	  var themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var iconSpacing = theme.reactackle.components.textfield.iconInner.iconSpacing;
	
	
	  return '\n    margin-right: ' + (0, _reactackleCore.getValueString)(iconSpacing) + ';\n  ';
	};
	
	var iconStyle = function iconStyle(_ref2) {
	  var themeFromProvider = _ref2.theme,
	      disabled = _ref2.disabled,
	      colorScheme = _ref2.colorScheme,
	      focus = _ref2.focus;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var path = theme.reactackle.components.textfield.iconInner.state;
	
	  var source = null;
	  if (!disabled) {
	    if (colorScheme !== 'neutral') source = path[colorScheme];else if (focus) source = path.focus;else source = path;
	  } else {
	    source = path.disabled;
	  }
	
	  var _source = source,
	      color = _source.color,
	      opacity = _source.opacity;
	
	
	  return (0, _styledComponents.css)(['opacity:', ';', ''], opacity, (0, _reactackleIcons.iconStyleMixin)(color));
	};
	
	var iconSize = function iconSize(_ref3) {
	  var dense = _ref3.dense,
	      fullWidth = _ref3.fullWidth,
	      themeFromProvider = _ref3.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var path = theme.reactackle.components.textfield.iconInner;
	
	  var source = null;
	  if (dense && !fullWidth) source = path.size.dense;else if (dense && fullWidth) source = path.size.denseFullWidth;else if (!dense && fullWidth) source = path.size.fullWidth;else source = path.size;
	
	  var _source2 = source,
	      boxSize = _source2.boxSize,
	      imgSize = _source2.imgSize;
	
	
	  return (0, _styledComponents.css)(['     ', ''], (0, _reactackleCore.iconSizeMixin)((0, _reactackleCore.getValueString)(boxSize), (0, _reactackleCore.getValueString)(imgSize || boxSize), (0, _reactackleCore.getValueString)(boxSize)));
	};
	
	/** STYLES */
	var IconInnerStyled = exports.IconInnerStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'IconInnerStyled'
	})(['display:flex;', ';', ';', ';', ';'], iconBase, iconSize, iconStyle, (0, _reactackleCore.transition)('color, opacity'));
	
	IconInnerStyled.propTypes = propTypes;
	IconInnerStyled.defaultProps = defaultProps;
	IconInnerStyled.displayName = 'IconInnerStyled';

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.IconOuterStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleIcons = __webpack_require__(7);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  disabled: _propTypes2.default.bool,
	  /**
	   * Full-width TextField doesn't have borders
	   */
	  fullWidth: _propTypes2.default.bool,
	  /**
	   * If textfield is dense it has smaller paddings
	   */
	  dense: _propTypes2.default.bool,
	  colorScheme: _propTypes2.default.oneOf(['neutral', 'error', 'success'])
	};
	
	var defaultProps = {
	  disabled: false,
	  fullWidth: false,
	  dense: false,
	  colorScheme: 'neutral'
	};
	
	/** PROP RECEIVERS */
	var iconBase = function iconBase(_ref) {
	  var themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var iconSpacing = theme.reactackle.components.textfield.iconOuter.iconSpacing;
	
	
	  return '\n    padding-right: ' + (0, _reactackleCore.getValueString)(iconSpacing) + ';\n  ';
	};
	
	var iconStyle = function iconStyle(_ref2) {
	  var themeFromProvider = _ref2.theme,
	      disabled = _ref2.disabled,
	      colorScheme = _ref2.colorScheme,
	      focus = _ref2.focus;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var path = theme.reactackle.components.textfield.iconOuter.state;
	
	  var source = null;
	  if (!disabled) {
	    if (colorScheme !== 'neutral') source = path[colorScheme];else if (focus) source = path.focus;else source = path;
	  } else {
	    source = path.disabled;
	  }
	
	  var _source = source,
	      color = _source.color,
	      opacity = _source.opacity;
	
	
	  return (0, _styledComponents.css)(['opacity:', ';', ''], opacity, (0, _reactackleIcons.iconStyleMixin)(color));
	};
	
	var iconSize = function iconSize(_ref3) {
	  var dense = _ref3.dense,
	      fullWidth = _ref3.fullWidth,
	      themeFromProvider = _ref3.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var path = theme.reactackle.components.textfield.iconOuter;
	
	  var source = null;
	  if (dense && !fullWidth) source = path.size.dense;else if (dense && fullWidth) source = path.size.denseFullWidth;else if (!dense && fullWidth) source = path.size.fullWidth;else source = path.size;
	
	  var _source2 = source,
	      boxSize = _source2.boxSize,
	      imgSize = _source2.imgSize;
	
	
	  return (0, _styledComponents.css)(['     ', ''], (0, _reactackleCore.iconSizeMixin)((0, _reactackleCore.getValueString)(boxSize), (0, _reactackleCore.getValueString)(imgSize || boxSize), (0, _reactackleCore.getValueString)(boxSize)));
	};
	
	/** STYLES */
	var IconOuterStyled = exports.IconOuterStyled = _styledComponents2.default.label.withConfig({
	  displayName: 'IconOuterStyled'
	})(['display:flex;box-sizing:content-box !important;', ';', ';', ';', ';'], iconBase, iconSize, iconStyle, (0, _reactackleCore.transition)('color, opacity'));
	
	IconOuterStyled.propTypes = propTypes;
	IconOuterStyled.defaultProps = defaultProps;
	IconOuterStyled.displayName = 'IconOuterStyled';

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.InfoBoxStyled = undefined;
	
	var _templateObject = _taggedTemplateLiteral(['\n        padding-left: calc(', ' + ', ' + ', ');\n      '], ['\n        padding-left: calc(', ' + ', ' + ', ');\n      ']);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var propTypes = {
	  /**
	   * Full-width TextField doesn't have borders
	   */
	  fullWidth: _propTypes2.default.bool,
	  /**
	   * If textfield is dense it has smaller paddings
	   */
	  dense: _propTypes2.default.bool,
	  /**
	   * Define label position
	   */
	  labelPosition: _propTypes2.default.oneOf(['top', 'side']),
	  /**
	   * Add icon behind textfield
	   */
	  iconOuter: _propTypes2.default.element,
	  /**
	   * Define component theme config
	   * See https://github.com/styled-components/styled-components/blob/master/docs/theming.md
	   * for more information
	   */
	  theme: _propTypes2.default.object
	};
	
	var defaultProps = {
	  disabled: false,
	  fullWidth: false,
	  dense: false,
	  labelPosition: 'top',
	  iconOuter: null
	};
	
	/** PROP RECEIVERS */
	var offset = function offset(_ref) {
	  var themeFromProvider = _ref.theme,
	      labelPosition = _ref.labelPosition,
	      dense = _ref.dense,
	      fullWidth = _ref.fullWidth,
	      iconOuter = _ref.iconOuter,
	      bordered = _ref.bordered;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var labelPositionSide = theme.reactackle.components.textfield.label.positionSide,
	      labelPositionSideSizeType = bordered ? 'bordered' : 'underlined',
	      labelPositionSideSize = labelPositionSide.size[labelPositionSideSizeType],
	      iconOuterPath = theme.reactackle.components.textfield.iconOuter;
	
	  var labelSizeSource = labelPositionSideSize;
	  var iconSizeSource = iconOuterPath.size;
	
	  if (dense && !fullWidth) {
	    labelSizeSource = labelPositionSideSize.dense;
	    iconSizeSource = iconOuterPath.size.dense;
	  } else if (dense && fullWidth) {
	    labelSizeSource = labelPositionSideSize.denseFullWidth;
	    iconSizeSource = iconOuterPath.size.denseFullWidth;
	  } else if (!dense && fullWidth) {
	    labelSizeSource = labelPositionSideSize.fullWidth;
	    iconSizeSource = iconOuterPath.size.fullWidth;
	  }
	
	  var labelSpacing = (0, _reactackleCore.getValueString)(labelSizeSource.labelSpacing),
	      iconSpacing = (0, _reactackleCore.getValueString)(iconOuterPath.iconSpacing),
	      boxSize = (0, _reactackleCore.getValueString)(iconSizeSource.boxSize),
	      width = (0, _reactackleCore.getValueString)(labelPositionSide.width),
	      iconOffset = iconOuter ? 'calc(' + boxSize + ' + ' + iconSpacing + ')' : 0;
	
	  var breakpoints = labelPositionSide.breakpoints.map(function (item) {
	    var width = (0, _reactackleCore.getValueString)(item.width);
	
	    return (0, _styledComponents.css)(['', ''], (0, _reactackleCore.media)(item.breakpoint)(_templateObject, width, labelSpacing, iconOffset));
	  });
	
	  var defaultOffset = 'calc(' + width + ' + ' + labelSpacing + ' + ' + boxSize + ')';
	
	  return labelPosition === 'side' ? (0, _styledComponents.css)(['padding-left:', ';', ';'], defaultOffset, breakpoints) : iconOffset && 'padding-left: ' + iconOffset + ';';
	};
	
	/** STYLES */
	var InfoBoxStyled = exports.InfoBoxStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'InfoBoxStyled'
	})(['display:flex;justify-content:flex-end;', ';'], offset);
	
	InfoBoxStyled.propTypes = propTypes;
	InfoBoxStyled.defaultProps = defaultProps;
	InfoBoxStyled.displayName = 'InfoBoxStyled';

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.InnerButton = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleIcons = __webpack_require__(7);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  disabled: _propTypes2.default.bool,
	  /**
	   * Full-width TextField doesn't have borders
	   */
	  fullWidth: _propTypes2.default.bool,
	  /**
	   * If textfield is dense it has smaller paddings
	   */
	  dense: _propTypes2.default.bool,
	  colorScheme: _propTypes2.default.oneOf(['neutral', 'error', 'success'])
	};
	
	var defaultProps = {
	  disabled: false,
	  fullWidth: false,
	  dense: false,
	  colorScheme: 'neutral'
	};
	
	/** PROP RECEIVERS */
	var iconBase = function iconBase(_ref) {
	  var themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var iconSpacing = theme.reactackle.components.textfield.buttonInner.iconSpacing;
	
	
	  return '\n    margin-left: ' + (0, _reactackleCore.getValueString)(iconSpacing) + ';\n  ';
	};
	
	var iconStyle = function iconStyle(_ref2) {
	  var themeFromProvider = _ref2.theme,
	      disabled = _ref2.disabled,
	      colorScheme = _ref2.colorScheme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var path = theme.reactackle.components.textfield.buttonInner.state;
	  var source = null;
	
	  if (!disabled) source = colorScheme !== 'neutral' ? path[colorScheme] : path;else source = path.disabled;
	
	  var _source = source,
	      color = _source.color,
	      opacity = _source.opacity;
	
	
	  var disabledStyles = (0, _styledComponents.css)(['&,&:hover,&:focus{opacity:', ';cursor:default;box-shadow:none;', '}'], opacity, (0, _reactackleIcons.iconStyleMixin)(color));
	
	  var defaultStyles = (0, _styledComponents.css)(['opacity:', ';cursor:pointer;', ' &:hover{outline:none;color:', ';opacity:', ';box-shadow:none;}&:focus{outline:none;color:', ';opacity:', ';box-shadow:none;}'], opacity, (0, _reactackleIcons.iconStyleMixin)(color), path.hover.color, path.hover.opacity, path.focus.color, path.focus.opacity);
	
	  return disabled ? disabledStyles : defaultStyles;
	};
	
	var iconSize = function iconSize(_ref3) {
	  var dense = _ref3.dense,
	      fullWidth = _ref3.fullWidth,
	      themeFromProvider = _ref3.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var path = theme.reactackle.components.textfield.buttonInner;
	
	  var source = null;
	  if (dense && !fullWidth) source = path.size.dense;else if (dense && fullWidth) source = path.size.denseFullWidth;else if (!dense && fullWidth) source = path.size.fullWidth;else source = path.size;
	
	  var _source2 = source,
	      boxSize = _source2.boxSize,
	      imgSize = _source2.imgSize;
	
	
	  return (0, _styledComponents.css)(['     ', ''], (0, _reactackleCore.iconSizeMixin)((0, _reactackleCore.getValueString)(boxSize), (0, _reactackleCore.getValueString)(imgSize || boxSize), (0, _reactackleCore.getValueString)(boxSize)));
	};
	
	/** STYLES */
	var InnerButton = exports.InnerButton = _styledComponents2.default.div.withConfig({
	  displayName: 'InnerButton'
	})(['display:flex;background-color:transparent;border:0 solid transparent;padding:0;', ';', ';', ';', ';'], iconBase, iconSize, iconStyle, (0, _reactackleCore.transition)('color, opacity'));
	
	InnerButton.propTypes = propTypes;
	InnerButton.defaultProps = defaultProps;
	InnerButton.displayName = 'InnerButton';

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LabelSlidingStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _color = __webpack_require__(857);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  disabled: _propTypes2.default.bool,
	  /**
	   * Full-width TextField doesn't have borders
	   */
	  fullWidth: _propTypes2.default.bool,
	  /**
	   * If textfield is dense it has smaller paddings
	   */
	  dense: _propTypes2.default.bool,
	  /**
	   * If bordered = false, TextField will have only bottom border
	   */
	  bordered: _propTypes2.default.bool,
	  colorScheme: _propTypes2.default.oneOf(['neutral', 'error', 'success']),
	  /**
	   * Define label position
	   */
	  labelPosition: _propTypes2.default.oneOf(['top', 'side']),
	  /**
	   * If slidingLabel = true, label will float to top
	   * when parent textfield is focused or filled
	   */
	  slidingLabel: _propTypes2.default.bool,
	  /**
	   * Add icon behind textfield
	   */
	  iconOuter: _propTypes2.default.element,
	  /**
	   * Define component theme config
	   * See https://github.com/styled-components/styled-components/blob/master/docs/theming.md
	   * for more information
	   */
	  theme: _propTypes2.default.object
	};
	
	var defaultProps = {
	  disabled: false,
	  fullWidth: false,
	  dense: false,
	  bordered: false,
	  colorScheme: 'neutral',
	  labelPosition: 'top',
	  slidingLabel: false,
	  iconOuter: null
	};
	
	/** PROP RECEIVERS */
	var labelBase = function labelBase(_ref) {
	  var themeFromProvider = _ref.theme,
	      bordered = _ref.bordered,
	      focus = _ref.focus,
	      filled = _ref.filled,
	      dense = _ref.dense,
	      fullWidth = _ref.fullWidth;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var textfieldKey = bordered ? 'bordered' : 'underlined';
	  var textfieldPath = theme.reactackle.components.textfield.textfield;
	  var labelPath = theme.reactackle.components.textfield.label.positionTop;
	
	  var textfieldSource = null;
	  if (dense && !fullWidth) textfieldSource = textfieldPath.size.dense;else if (dense && fullWidth) textfieldSource = textfieldPath.size.denseFullWidth;else if (!dense && fullWidth) textfieldSource = textfieldPath.size.fullWidth;else textfieldSource = textfieldPath.size;
	
	  /**
	   * When textfield isn't in focus or filled, label should look like TextField's
	   * value
	   */
	
	  var _ref2 = focus || filled ? labelPath : textfieldSource,
	      fontSize = _ref2.fontSize,
	      lineHeight = _ref2.lineHeight;
	
	  var borderWidth = (0, _reactackleCore.getValueString)(textfieldPath[textfieldKey].borderWidth);
	  var borderWidthSubstraction = bordered ? borderWidth + ' * 2' : borderWidth;
	
	  var _textfieldSource = textfieldSource,
	      paddingY = _textfieldSource.paddingY;
	  var textTransform = labelPath.textTransform,
	      fontWeight = labelPath.fontWeight;
	
	
	  var filledStyles = '\n    height: auto;\n    bottom: auto;\n    cursor: text;\n    white-space: nowrap;\n    background-color: transparent;\n    top: 0;\n  ';
	
	  var defaultStyles = (0, _styledComponents.css)(['height:calc(100% - ', ');bottom:', ';cursor:default;font-weight:', ';text-transform:', ';align-items:flex-end;padding-bottom:', ';pointer-events:none;'], borderWidthSubstraction, borderWidth, fontWeight, textTransform, (0, _reactackleCore.getValueString)(paddingY));
	
	  return (0, _styledComponents.css)(['font-size:', ';line-height:', ';', ';', ';'], (0, _reactackleCore.getValueString)(fontSize), lineHeight, (0, _reactackleCore.transition)('color, font-size, height'), focus || filled ? filledStyles : defaultStyles);
	};
	
	var labelSpacing = function labelSpacing(_ref3) {
	  var bordered = _ref3.bordered,
	      labelPosition = _ref3.labelPosition,
	      dense = _ref3.dense,
	      fullWidth = _ref3.fullWidth,
	      themeFromProvider = _ref3.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var key = labelPosition === 'top' ? 'positionTop' : 'positionSide';
	  var labelSizeType = bordered ? 'bordered' : 'underlined';
	  var path = theme.reactackle.components.textfield.label[key].size[labelSizeType];
	  var source = null;
	
	  if (dense && !fullWidth) source = path.dense;else if (dense && fullWidth) source = path.denseFullWidth;else if (!dense && fullWidth) source = path.fullWidth;else source = path;
	
	  var labelSpacing = (0, _reactackleCore.getValueString)(source.labelSpacing);
	
	  return labelPosition === 'top' ? 'margin-bottom: ' + labelSpacing + ';' : 'margin-right: ' + labelSpacing + ';';
	};
	
	var labelStyle = function labelStyle(_ref4) {
	  var themeFromProvider = _ref4.theme,
	      disabled = _ref4.disabled,
	      colorScheme = _ref4.colorScheme,
	      labelPosition = _ref4.labelPosition,
	      focus = _ref4.focus,
	      filled = _ref4.filled;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider),
	      key = labelPosition === 'top' ? 'positionTop' : 'positionSide',
	      labelPath = theme.reactackle.components.textfield.label[key].style,
	      textfieldPath = theme.reactackle.components.textfield.textfield.state,
	      placeholderPath = theme.reactackle.components.textfield.placeholder;
	
	  var labelSource = null,
	      textfieldSource = null;
	
	  if (!disabled) {
	    if (colorScheme !== 'neutral') {
	      labelSource = labelPath[colorScheme];
	      textfieldSource = textfieldPath[colorScheme];
	    } else if (focus) {
	      labelSource = labelPath.focus;
	      textfieldSource = textfieldPath.focus;
	    } else {
	      labelSource = labelPath;
	      textfieldSource = textfieldPath;
	    }
	  } else {
	    labelSource = labelPath.disabled;
	    textfieldSource = textfieldPath.disabled;
	  }
	
	  var _ref5 = focus || filled ? labelSource : placeholderPath,
	      fontColor = _ref5.fontColor;
	
	  var textfieldBackgroundColor = (0, _color2.default)(textfieldSource.backgroundColor).alpha() ? textfieldSource : 'white';
	
	  var backgroundColor = focus || filled ? 'transparent' : textfieldBackgroundColor;
	
	  return '\n    background-color: ' + backgroundColor + ';\n    color: ' + fontColor + ';\n  ';
	};
	
	var offset = function offset(_ref6) {
	  var themeFromProvider = _ref6.theme,
	      dense = _ref6.dense,
	      fullWidth = _ref6.fullWidth,
	      iconOuter = _ref6.iconOuter;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var path = theme.reactackle.components.textfield.iconOuter;
	
	  var source = null;
	  if (dense && !fullWidth) source = path.size.dense;else if (dense && fullWidth) source = path.size.denseFullWidth;else if (!dense && fullWidth) source = path.size.fullWidth;else source = path.size;
	
	  var iconSpacing = (0, _reactackleCore.getValueString)(path.iconSpacing);
	  var boxSize = (0, _reactackleCore.getValueString)(source.boxSize);
	
	  var iconOffset = iconOuter ? 'calc(' + boxSize + ' + ' + iconSpacing + ')' : 0;
	
	  return iconOffset && '\n    left: ' + iconOffset + ';\n    max-width: calc(100% - ' + iconOffset + ');\n  ';
	};
	
	/** STYLES */
	var LabelSlidingStyled = exports.LabelSlidingStyled = _styledComponents2.default.label.withConfig({
	  displayName: 'LabelSlidingStyled'
	})(['display:flex;user-select:none;width:100%;position:absolute;z-index:2;justify-content:flex-start;', ';', ';', ';', ';'], labelBase, labelStyle, labelSpacing, offset);
	
	LabelSlidingStyled.propTypes = propTypes;
	LabelSlidingStyled.defaultProps = defaultProps;
	LabelSlidingStyled.displayName = 'LabelSlidingStyled';

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LabelStyled = undefined;
	
	var _templateObject = _taggedTemplateLiteral(['\n        width: ', ';\n      '], ['\n        width: ', ';\n      ']);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var propTypes = {
	  disabled: _propTypes2.default.bool,
	  fullWidth: _propTypes2.default.bool,
	  dense: _propTypes2.default.bool,
	  bordered: _propTypes2.default.bool,
	  colorScheme: _propTypes2.default.oneOf(['neutral', 'error', 'success']),
	  labelPosition: _propTypes2.default.oneOf(['top', 'side']),
	  slidingLabel: _propTypes2.default.bool,
	  iconOuter: _propTypes2.default.element,
	  theme: _propTypes2.default.object
	};
	
	var defaultProps = {
	  disabled: false,
	  fullWidth: false,
	  dense: false,
	  bordered: false,
	  colorScheme: 'neutral',
	  labelPosition: 'top',
	  slidingLabel: false,
	  iconOuter: null
	};
	
	/** PROP RECEIVERS */
	var labelBase = function labelBase(_ref) {
	  var labelPosition = _ref.labelPosition,
	      themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider),
	      path = theme.reactackle.components.textfield.label,
	      source = labelPosition === 'top' ? path.positionTop : path.positionSide;
	
	  var fontSize = source.fontSize,
	      lineHeight = source.lineHeight,
	      textTransform = source.textTransform,
	      fontWeight = source.fontWeight;
	
	
	  return (0, _styledComponents.css)(['font-size:', ';line-height:', ';text-transform:', ';font-weight:', ';', ''], (0, _reactackleCore.getValueString)(fontSize), lineHeight, textTransform, fontWeight, labelPosition === 'side' ? '\n        flex-direction: column;\n        justify-content: center;\n      ' : 'align-items: center;');
	};
	
	var labelSpacing = function labelSpacing(_ref2) {
	  var labelPosition = _ref2.labelPosition,
	      dense = _ref2.dense,
	      fullWidth = _ref2.fullWidth,
	      bordered = _ref2.bordered,
	      themeFromProvider = _ref2.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider),
	      key = labelPosition === 'top' ? 'positionTop' : 'positionSide',
	      textfieldStyleKey = bordered ? 'bordered' : 'underlined';
	
	  var path = theme.reactackle.components.textfield.label[key].size[textfieldStyleKey];
	
	  var source = null;
	
	  if (dense && !fullWidth) source = path.dense;else if (dense && fullWidth) source = path.denseFullWidth;else if (!dense && fullWidth) source = path.fullWidth;else source = path;
	
	  var labelSpacing = (0, _reactackleCore.getValueString)(source.labelSpacing);
	
	  return labelPosition === 'top' ? 'padding-bottom: ' + labelSpacing + ';' : 'margin-right: ' + labelSpacing + ';';
	};
	
	var labelStyle = function labelStyle(_ref3) {
	  var themeFromProvider = _ref3.theme,
	      disabled = _ref3.disabled,
	      colorScheme = _ref3.colorScheme,
	      labelPosition = _ref3.labelPosition,
	      focus = _ref3.focus;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider),
	      key = labelPosition === 'top' ? 'positionTop' : 'positionSide',
	      path = theme.reactackle.components.textfield.label[key].style;
	
	  var source = null;
	
	  if (!disabled) {
	    if (colorScheme !== 'neutral') source = path[colorScheme];else if (focus) source = path.focus;else source = path;
	  } else {
	    source = path.disabled;
	  }
	
	  return 'color: ' + source.fontColor + ';';
	};
	
	var labelSideWidth = function labelSideWidth(_ref4) {
	  var labelPosition = _ref4.labelPosition,
	      themeFromProvider = _ref4.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider),
	      source = theme.reactackle.components.textfield.label.positionSide;
	
	  var breakpoints = source.breakpoints.map(function (item) {
	    var width = (0, _reactackleCore.getValueString)(item.width);
	
	    return (0, _styledComponents.css)(['', ''], (0, _reactackleCore.media)(item.breakpoint)(_templateObject, width));
	  });
	
	  return labelPosition === 'side' && (0, _styledComponents.css)(['width:', ';', ';'], (0, _reactackleCore.getValueString)(source.width), breakpoints);
	};
	
	var offset = function offset(_ref5) {
	  var themeFromProvider = _ref5.theme,
	      bordered = _ref5.bordered,
	      labelPosition = _ref5.labelPosition,
	      dense = _ref5.dense,
	      fullWidth = _ref5.fullWidth,
	      iconOuter = _ref5.iconOuter;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider),
	      styleKey = bordered ? 'bordered' : 'underlined',
	      positionKey = labelPosition === 'side' ? 'positionSide' : 'positionTop',
	      textfieldPath = theme.reactackle.components.textfield.textfield,
	      iconPath = theme.reactackle.components.textfield.iconOuter;
	
	  var labelPath = theme.reactackle.components.textfield.label[positionKey].size[styleKey];
	
	  var textfieldSource = null,
	      labelSource = null,
	      iconSource = null;
	  if (dense && !fullWidth) {
	    textfieldSource = textfieldPath.size.dense;
	    labelSource = labelPath.dense;
	    iconSource = iconPath.size.dense;
	  } else if (dense && fullWidth) {
	    textfieldSource = textfieldPath.size.denseFullWidth;
	    labelSource = labelPath.denseFullWidth;
	    iconSource = iconPath.size.denseFullWidth;
	  } else if (!dense && fullWidth) {
	    textfieldSource = textfieldPath.size.fullWidth;
	    labelSource = labelPath.fullWidth;
	    iconSource = iconPath.size.fullWidth;
	  } else {
	    textfieldSource = textfieldPath.size;
	    labelSource = labelPath;
	    iconSource = iconPath.size;
	  }
	
	  var paddingX = (0, _reactackleCore.getValueString)(textfieldSource.paddingX[styleKey]),
	      iconSpacing = (0, _reactackleCore.getValueString)(iconPath.iconSpacing),
	      boxSize = (0, _reactackleCore.getValueString)(iconSource.boxSize);
	
	  var _labelSource = labelSource,
	      paddingTop = _labelSource.paddingTop,
	      paddingBottom = _labelSource.paddingBottom,
	      labelSpacing = _labelSource.labelSpacing;
	
	
	  var padBottom = labelPosition === 'side' ? (0, _reactackleCore.getValueString)(paddingBottom) : (0, _reactackleCore.getValueString)(labelSpacing);
	
	  var iconLeftOffset = iconOuter ? 'calc(' + boxSize + ' + ' + iconSpacing + ')' : 0;
	
	  var fwIconOffset = iconLeftOffset ? 'calc(' + iconLeftOffset + ' + ' + paddingX + ')' : paddingX;
	
	  var leftOffset = fullWidth ? fwIconOffset : paddingX;
	
	  var padLeft = labelPosition === 'side' ? paddingX : leftOffset;
	
	  return fullWidth ? '\n      padding-top: ' + (0, _reactackleCore.getValueString)(paddingTop) + ';\n      padding-bottom: ' + padBottom + ';\n      padding-left: ' + padLeft + ';\n      padding-right: ' + paddingX + ';\n    ' : labelPosition === 'top' && 'padding-left: ' + iconLeftOffset + ';';
	};
	
	/** STYLES */
	var LabelStyled = exports.LabelStyled = _styledComponents2.default.label.withConfig({
	  displayName: 'LabelStyled'
	})(['display:flex;user-select:none;', ';', ';', ';', ';', ';', ';'], labelBase, labelStyle, labelSpacing, labelSideWidth, offset, (0, _reactackleCore.transition)('color, font-size'));
	
	LabelStyled.propTypes = propTypes;
	LabelStyled.defaultProps = defaultProps;
	LabelStyled.displayName = 'LabelStyled';

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LabelTextStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  theme: _propTypes2.default.object
	};
	
	/** PROP RECEIVERS */
	var spacingProps = function spacingProps(_ref) {
	  var themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var marginRight = (0, _reactackleCore.getValueString)(theme.reactackle.components.textfield.label.labelTooltipSpacing);
	
	  return 'margin-right: ' + marginRight + ';';
	};
	var paddingBottom = 1; // To be sure that font descenders aren't cut
	
	/** STYLES */
	var LabelTextStyled = exports.LabelTextStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'LabelTextStyled'
	})(['overflow:hidden;text-overflow:ellipsis;padding-bottom:', 'px;', ';'], paddingBottom, spacingProps);
	
	LabelTextStyled.propTypes = propTypes;
	LabelTextStyled.displayName = 'LabelTextStyled';

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MessageStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  disabled: _propTypes2.default.bool,
	  colorScheme: _propTypes2.default.oneOf(['neutral', 'error', 'success']),
	  /**
	   * Define component theme config
	   * See https://github.com/styled-components/styled-components/blob/master/docs/theming.md
	   * for more information
	   */
	  theme: _propTypes2.default.object
	};
	
	var defaultProps = {
	  disabled: false,
	  colorScheme: 'neutral'
	};
	
	/** PROP RECEIVERS */
	var styleProps = function styleProps(_ref) {
	  var themeFromProvider = _ref.theme,
	      colorScheme = _ref.colorScheme,
	      focus = _ref.focus,
	      disabled = _ref.disabled;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var path = theme.reactackle.components.textfield.message.style;
	
	  var source = null;
	  if (!disabled) {
	    if (colorScheme !== 'neutral') source = path[colorScheme];else if (focus) source = path.focus;else source = path;
	  } else {
	    source = path.disabled;
	  }
	
	  var _source = source,
	      fontColor = _source.fontColor;
	
	
	  return 'color: ' + fontColor + ';';
	};
	
	var baseProps = function baseProps(_ref2) {
	  var themeFromProvider = _ref2.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var _theme$reactackle$com = theme.reactackle.components.textfield.message,
	      messageSpacing = _theme$reactackle$com.messageSpacing,
	      fontSize = _theme$reactackle$com.fontSize,
	      lineHeight = _theme$reactackle$com.lineHeight;
	
	
	  return '\n    margin-top: ' + (0, _reactackleCore.getValueString)(messageSpacing) + ';\n    font-size: ' + (0, _reactackleCore.getValueString)(fontSize) + ';\n    line-height: ' + lineHeight + ';\n  ';
	};
	
	/** STYLES */
	var MessageStyled = exports.MessageStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'MessageStyled'
	})(['flex-grow:1;', ';', ';', ';'], baseProps, styleProps, (0, _reactackleCore.transition)('color'));
	
	MessageStyled.propTypes = propTypes;
	MessageStyled.defaultProps = defaultProps;
	MessageStyled.displayName = 'MessageStyled';

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PostfixStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  disabled: _propTypes2.default.bool,
	  /**
	   * Full-width TextField doesn't have borders
	   */
	  fullWidth: _propTypes2.default.bool,
	  /**
	   * If textfield is dense it has smaller paddings
	   */
	  dense: _propTypes2.default.bool,
	  /**
	   * If bordered = false, TextField will have only bottom border
	   */
	  bordered: _propTypes2.default.bool,
	  colorScheme: _propTypes2.default.oneOf(['neutral', 'error', 'success']),
	  /**
	   * Define component theme config
	   * See https://github.com/styled-components/styled-components/blob/master/docs/theming.md
	   * for more information
	   */
	  theme: _propTypes2.default.object
	};
	
	var defaultProps = {
	  disabled: false,
	  fullWidth: false,
	  dense: false,
	  bordered: false,
	  colorScheme: 'neutral'
	};
	
	/** PROP RECEIVERS */
	var styleProps = function styleProps(_ref) {
	  var disabled = _ref.disabled,
	      focus = _ref.focus,
	      colorScheme = _ref.colorScheme,
	      themeFromProvider = _ref.theme,
	      bordered = _ref.bordered;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var TextFieldStyleKey = bordered ? 'bordered' : 'underlined';
	  var colorSource = theme.reactackle.components.textfield.postfix.state[TextFieldStyleKey];
	
	  var neutralStyles = colorScheme === 'neutral' && (0, _styledComponents.css)(['background-color:', ';color:', ';', ''], colorSource.backgroundColor, colorSource.fontColor, focus && '\n        outline: none;\n        background-color: ' + colorSource.focus.backgroundColor + ';\n        color: ' + colorSource.focus.fontColor + ';\n      ');
	
	  var stateStyles = colorScheme !== 'neutral' && (0, _styledComponents.css)(['&,&:hover,&:focus{background-color:', ';outline:none;color:', ';}'], colorSource[colorScheme].backgroundColor, colorSource[colorScheme].fontColor);
	
	  var disabledStyles = '\n    &,\n    &:hover,\n    &:focus {\n      background-color: ' + colorSource.disabled.backgroundColor + ';\n      outline: none;\n      cursor: default;\n      user-select: none;\n      color: ' + colorSource.disabled.fontColor + ';\n    }\n  ';
	
	  var styles = null;
	  if (disabled) styles = disabledStyles;else if (colorScheme === 'neutral') styles = neutralStyles;else styles = stateStyles;
	
	  return styles;
	};
	
	var sizeProps = function sizeProps(_ref2) {
	  var dense = _ref2.dense,
	      fullWidth = _ref2.fullWidth,
	      themeFromProvider = _ref2.theme,
	      bordered = _ref2.bordered;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider),
	      styleKey = bordered ? 'bordered' : 'underlined',
	      path = theme.reactackle.components.textfield.postfix.size,
	      textfieldPath = theme.reactackle.components.textfield.textfield.size;
	
	  var source = null;
	  var heightSource = null;
	  if (dense && !fullWidth) {
	    source = path.dense;
	    heightSource = textfieldPath.dense;
	  } else if (dense && fullWidth) {
	    source = path.denseFullWidth;
	    heightSource = textfieldPath.denseFullWidth;
	  } else if (!dense && fullWidth) {
	    source = path.fullWidth;
	    heightSource = textfieldPath.fullWidth;
	  } else {
	    source = path;
	    heightSource = textfieldPath;
	  }
	
	  var _source = source,
	      postfixEdgeSpacing = _source.postfixEdgeSpacing;
	  var _heightSource = heightSource,
	      paddingY = _heightSource.paddingY,
	      lineHeight = _heightSource.lineHeight;
	
	
	  var minHeight = 'calc(' + (0, _reactackleCore.getValueString)(paddingY) + ' * 2 + ' + lineHeight + 'em)';
	
	  return (0, _styledComponents.css)(['padding-right:', ';max-height:', ';'], (0, _reactackleCore.getValueString)(postfixEdgeSpacing[styleKey]), minHeight);
	};
	
	/** STYLES */
	var PostfixStyled = exports.PostfixStyled = _styledComponents2.default.label.withConfig({
	  displayName: 'PostfixStyled'
	})(['position:relative;display:flex;align-items:center;flex-shrink:0;', ';', ';'], styleProps, sizeProps);
	
	PostfixStyled.propTypes = propTypes;
	PostfixStyled.defaultProps = defaultProps;
	PostfixStyled.displayName = 'PostfixStyled';

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PostfixTextStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * Full-width TextField doesn't have borders
	   */
	  fullWidth: _propTypes2.default.bool,
	  /**
	   * If textfield is dense it has smaller paddings
	   */
	  dense: _propTypes2.default.bool,
	  /**
	   * Define component theme config
	   * See https://github.com/styled-components/styled-components/blob/master/docs/theming.md
	   * for more information
	   */
	  theme: _propTypes2.default.object
	};
	
	var defaultProps = {
	  fullWidth: false,
	  dense: false
	};
	
	/** PROP RECEIVERS */
	var baseProps = function baseProps(_ref) {
	  var themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var lineHeight = theme.reactackle.components.textfield.postfix.lineHeight;
	
	
	  return '\n    line-height: ' + lineHeight + ';\n  ';
	};
	
	var sizeProps = function sizeProps(_ref2) {
	  var dense = _ref2.dense,
	      fullWidth = _ref2.fullWidth,
	      themeFromProvider = _ref2.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var path = theme.reactackle.components.textfield.postfix.size;
	
	  var source = null;
	  if (dense && !fullWidth) source = path.dense;else if (dense && fullWidth) source = path.denseFullWidth;else if (!dense && fullWidth) source = path.fullWidth;else source = path;
	
	  var _source = source,
	      fontSize = _source.fontSize,
	      paddingY = _source.paddingY,
	      postfixSpacing = _source.postfixSpacing;
	
	
	  return (0, _styledComponents.css)(['font-size:', ';padding:', ';padding-left:', ';'], (0, _reactackleCore.getValueString)(fontSize), (0, _reactackleCore.getValueString)(paddingY), (0, _reactackleCore.getValueString)(postfixSpacing));
	};
	
	/** STYLES */
	var PostfixTextStyled = exports.PostfixTextStyled = _styledComponents2.default.span.withConfig({
	  displayName: 'PostfixTextStyled'
	})(['display:flex;align-items:center;color:inherit;', ';', ';', ';'], baseProps, sizeProps, (0, _reactackleCore.transition)('color'));
	
	PostfixTextStyled.propTypes = propTypes;
	PostfixTextStyled.defaultProps = defaultProps;
	PostfixTextStyled.displayName = 'PostfixTextStyled';

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PrefixStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  disabled: _propTypes2.default.bool,
	  fullWidth: _propTypes2.default.bool,
	  dense: _propTypes2.default.bool,
	  bordered: _propTypes2.default.bool,
	  colorScheme: _propTypes2.default.oneOf(['neutral', 'error', 'success']),
	  theme: _propTypes2.default.object
	};
	
	var defaultProps = {
	  disabled: false,
	  fullWidth: false,
	  dense: false,
	  bordered: false,
	  colorScheme: 'neutral'
	};
	
	/** PROP RECEIVERS */
	var styleProps = function styleProps(_ref) {
	  var disabled = _ref.disabled,
	      focus = _ref.focus,
	      colorScheme = _ref.colorScheme,
	      themeFromProvider = _ref.theme,
	      bordered = _ref.bordered;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider),
	      TextFieldStyleKey = bordered ? 'bordered' : 'underlined';
	
	  var colorSource = theme.reactackle.components.textfield.prefix.state[TextFieldStyleKey];
	
	  var neutralStyles = colorScheme === 'neutral' && (0, _styledComponents.css)(['background-color:', ';color:', ';&:hover{outline:none;}', ''], colorSource.backgroundColor, colorSource.fontColor, focus && '\n        outline: none;\n        background-color: ' + colorSource.focus.backgroundColor + ';\n        color: ' + colorSource.focus.fontColor + ';\n      ');
	
	  var stateStyles = colorScheme !== 'neutral' && (0, _styledComponents.css)(['&,&:hover,&:focus{background-color:', ';color:', ';outline:none;}'], colorSource[colorScheme].backgroundColor, colorSource[colorScheme].fontColor);
	
	  var disabledStyles = '\n    &,\n    &:hover,\n    &:focus {\n      cursor: default;\n      user-select: none;\n      background-color: ' + colorSource.disabled.backgroundColor + ';\n      outline: none;\n      color: ' + colorSource.disabled.fontColor + ';\n    }\n  ';
	
	  var styles = null;
	  if (disabled) styles = disabledStyles;else if (colorScheme === 'neutral') styles = neutralStyles;else styles = stateStyles;
	
	  return styles;
	};
	
	var sizeProps = function sizeProps(_ref2) {
	  var dense = _ref2.dense,
	      fullWidth = _ref2.fullWidth,
	      themeFromProvider = _ref2.theme,
	      bordered = _ref2.bordered;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var styleKey = bordered ? 'bordered' : 'underlined';
	  var path = theme.reactackle.components.textfield.prefix.size;
	  var textfieldPath = theme.reactackle.components.textfield.textfield.size;
	
	  var source = null;
	  var heightSource = null;
	  if (dense && !fullWidth) {
	    source = path.dense;
	    heightSource = textfieldPath.dense;
	  } else if (dense && fullWidth) {
	    source = path.denseFullWidth;
	    heightSource = textfieldPath.denseFullWidth;
	  } else if (!dense && fullWidth) {
	    source = path.fullWidth;
	    heightSource = textfieldPath.fullWidth;
	  } else {
	    source = path;
	    heightSource = textfieldPath;
	  }
	
	  var _source = source,
	      prefixEdgeSpacing = _source.prefixEdgeSpacing;
	  var _heightSource = heightSource,
	      paddingY = _heightSource.paddingY,
	      lineHeight = _heightSource.lineHeight;
	
	
	  var maxHeight = 'calc(' + (0, _reactackleCore.getValueString)(paddingY) + ' * 2 + ' + lineHeight + 'em)';
	
	  return (0, _styledComponents.css)(['padding-left:', ';max-height:', ';'], (0, _reactackleCore.getValueString)(prefixEdgeSpacing[styleKey]), (0, _reactackleCore.getValueString)(maxHeight));
	};
	
	/** STYLES */
	var PrefixStyled = exports.PrefixStyled = _styledComponents2.default.label.withConfig({
	  displayName: 'PrefixStyled'
	})(['position:relative;display:flex;align-items:center;flex-shrink:0;', ';', ';'], styleProps, sizeProps);
	
	PrefixStyled.propTypes = propTypes;
	PrefixStyled.defaultProps = defaultProps;
	PrefixStyled.displayName = 'PrefixStyled';

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PrefixTextStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * Full-width TextField doesn't have borders
	   */
	  fullWidth: _propTypes2.default.bool,
	  /**
	   * If textfield is dense it has smaller paddings
	   */
	  dense: _propTypes2.default.bool,
	  /**
	   * Define component theme config
	   * See https://github.com/styled-components/styled-components/blob/master/docs/theming.md
	   * for more information
	   */
	  theme: _propTypes2.default.object
	};
	
	var defaultProps = {
	  fullWidth: false,
	  dense: false
	};
	
	/** PROP RECEIVERS */
	var baseProps = function baseProps(_ref) {
	  var themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var lineHeight = theme.reactackle.components.textfield.prefix.lineHeight;
	
	
	  return '\n    line-height: ' + lineHeight + ';\n  ';
	};
	
	var sizeProps = function sizeProps(_ref2) {
	  var dense = _ref2.dense,
	      fullWidth = _ref2.fullWidth,
	      themeFromProvider = _ref2.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var path = theme.reactackle.components.textfield.prefix.size;
	
	  var source = null;
	  if (dense && !fullWidth) source = path.dense;else if (dense && fullWidth) source = path.denseFullWidth;else if (!dense && fullWidth) source = path.fullWidth;else source = path;
	
	  var _source = source,
	      fontSize = _source.fontSize,
	      paddingY = _source.paddingY,
	      prefixSpacing = _source.prefixSpacing;
	
	
	  return (0, _styledComponents.css)(['font-size:', ';padding:', ' 0;padding-right:', ';'], (0, _reactackleCore.getValueString)(fontSize), (0, _reactackleCore.getValueString)(paddingY), (0, _reactackleCore.getValueString)(prefixSpacing));
	};
	
	/** STYLES */
	var PrefixTextStyled = exports.PrefixTextStyled = _styledComponents2.default.span.withConfig({
	  displayName: 'PrefixTextStyled'
	})(['display:flex;align-items:center;color:inherit;', ';', ';', ';'], baseProps, sizeProps, (0, _reactackleCore.transition)('color'));
	
	PrefixTextStyled.propTypes = propTypes;
	PrefixTextStyled.defaultProps = defaultProps;
	PrefixTextStyled.displayName = 'PrefixTextStyled';

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TextFieldContentBoxStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * Define label position
	   */
	  labelPosition: _propTypes2.default.oneOf(['top', 'side'])
	};
	
	var defaultProps = {
	  labelPosition: 'top'
	};
	
	/** PROP RECEIVERS */
	var contentFlow = function contentFlow(_ref) {
	  var labelPosition = _ref.labelPosition;
	  return labelPosition === 'top' ? 'flex-direction: column;' : 'flex-direction: row;';
	};
	
	/** STYLES */
	/** ex textfield-content-box */
	var TextFieldContentBoxStyled = exports.TextFieldContentBoxStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'TextFieldContentBoxStyled'
	})(['display:flex;position:relative;max-width:100%;', ';'], contentFlow);
	
	TextFieldContentBoxStyled.propTypes = propTypes;
	TextFieldContentBoxStyled.defaultProps = defaultProps;
	TextFieldContentBoxStyled.displayName = 'TextFieldContentBoxStyled';

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.InputStyled = exports.TextareaStyled = exports.TextareaAutosizeStyled = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactTextareaAutosize = __webpack_require__(493);
	
	var _reactTextareaAutosize2 = _interopRequireDefault(_reactTextareaAutosize);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var propTypes = {
	  /**
	   * If bordered = false, TextField will have only bottom border
	   */
	  bordered: _propTypes2.default.bool,
	  /**
	   * Full-width TextField doesn't have borders
	   */
	  fullWidth: _propTypes2.default.bool,
	  /**
	   * If textfield is dense it has smaller paddings
	   */
	  dense: _propTypes2.default.bool,
	  disabled: _propTypes2.default.bool,
	  colorScheme: _propTypes2.default.oneOf(['neutral', 'error', 'success']),
	  /**
	   * Define component theme config
	   * See https://github.com/styled-components/styled-components/blob/master/docs/theming.md
	   * for more information
	   */
	  theme: _propTypes2.default.object
	};
	
	var defaultProps = {
	  bordered: false,
	  fullWidth: false,
	  dense: false,
	  disabled: false,
	  colorScheme: 'neutral'
	};
	
	var displayName = function displayName(name) {
	  return 'TextFieldStyled(' + name + ')';
	};
	
	/** PROP RECEIVERS */
	var textfieldSize = function textfieldSize(_ref) {
	  var dense = _ref.dense,
	      fullWidth = _ref.fullWidth,
	      bordered = _ref.bordered,
	      themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider),
	      styleKey = bordered ? 'bordered' : 'underlined';
	  var source = null;
	
	  if (dense && !fullWidth) {
	    source = theme.reactackle.components.textfield.textfield.size.dense;
	  } else if (dense && fullWidth) {
	    source = theme.reactackle.components.textfield.textfield.size.denseFullWidth;
	  } else if (!dense && fullWidth) {
	    source = theme.reactackle.components.textfield.textfield.size.fullWidth;
	  } else {
	    source = theme.reactackle.components.textfield.textfield.size;
	  }
	
	  var _source = source,
	      paddingY = _source.paddingY,
	      paddingX = _source.paddingX;
	
	
	  return '\n    padding: ' + (0, _reactackleCore.getValueString)(paddingY) + ' ' + (0, _reactackleCore.getValueString)(paddingX[styleKey]) + ';\n  ';
	};
	
	var basicStyles = function basicStyles(_ref2) {
	  var themeFromProvider = _ref2.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  return (0, _styledComponents.css)(['font-family:', ';'], theme.reactackle.components.textfield.textfield.fontFamily);
	};
	
	var textfieldStyle = function textfieldStyle(_ref3) {
	  var disabled = _ref3.disabled,
	      colorScheme = _ref3.colorScheme,
	      themeFromProvider = _ref3.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var source = theme.reactackle.components.textfield.textfield.state;
	
	  var neutralStyles = colorScheme === 'neutral' && (0, _styledComponents.css)(['background-color:', ';color:', ';&:hover{outline:none;background-color:', ';color:', ';}&:focus{outline:none;background-color:', ';color:', ';}'], source.backgroundColor, source.fontColor, source.hover.backgroundColor, source.hover.fontColor, source.focus.backgroundColor, source.focus.fontColor);
	
	  var stateStyles = colorScheme !== 'neutral' && (0, _styledComponents.css)(['&,&:hover,&:focus{background-color:', ';color:', ';outline:none;}'], source[colorScheme].backgroundColor, source[colorScheme].fontColor);
	
	  var disabledStyles = '\n    cursor: default;\n    user-select: none;\n\n    &,\n    &:hover,\n    &:focus {\n      background-color: ' + source.disabled.backgroundColor + ';\n      color: ' + source.disabled.fontColor + ';\n      outline: none;\n    }\n  ';
	
	  var styles = null;
	  if (disabled) styles = disabledStyles;else if (colorScheme === 'neutral') styles = neutralStyles;else styles = stateStyles;
	
	  return styles;
	};
	
	var placeholderStyles = function placeholderStyles(_ref4) {
	  var themeFromProvider = _ref4.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  return '\n    color: ' + theme.reactackle.components.textfield.placeholder.fontColor + ';\n  ';
	};
	
	/** STYLES */
	var styles = function styles(props) {
	  return (0, _styledComponents.css)(['border-width:0;text-overflow:ellipsis;flex-grow:1;width:100%;resize:', ';max-width:100%;font-size:inherit;line-height:inherit;z-index:1;', ' ', ' ', ' &::placeholder{', '}', ''], props.resize === 'none' ? 'none' : 'both', textfieldSize(props), basicStyles(props), textfieldStyle(props), placeholderStyles(props), (0, _reactackleCore.transition)('color, background-color, box-shadow'));
	};
	
	var TextareaAutosizeStyled = (0, _styledComponents2.default)(function (_ref5) {
	  var bordered = _ref5.bordered,
	      fullWidth = _ref5.fullWidth,
	      dense = _ref5.dense,
	      disabled = _ref5.disabled,
	      colorScheme = _ref5.colorScheme,
	      focus = _ref5.focus,
	      theme = _ref5.theme,
	      saveRef = _ref5.saveRef,
	      props = _objectWithoutProperties(_ref5, ['bordered', 'fullWidth', 'dense', 'disabled', 'colorScheme', 'focus', 'theme', 'saveRef']);
	
	  return _react2.default.createElement(_reactTextareaAutosize2.default, _extends({}, props, { inputRef: saveRef }));
	}).withConfig({
	  displayName: 'TextFieldElementStyled__TextareaAutosizeStyled'
	})(['', ''], styles);
	exports.TextareaAutosizeStyled = TextareaAutosizeStyled;
	TextareaAutosizeStyled.propTypes = _extends({}, propTypes, _reactTextareaAutosize2.default.propTypes, {
	  saveRef: _propTypes2.default.func.isRequired
	});
	TextareaAutosizeStyled.defaultProps = _extends({}, defaultProps, _reactTextareaAutosize2.default.defaultProps);
	TextareaAutosizeStyled.displayName = displayName(_reactTextareaAutosize2.default.displayName || 'TextareaAutosize');
	
	var TextareaStyled = exports.TextareaStyled = _styledComponents2.default.textarea.withConfig({
	  displayName: 'TextFieldElementStyled__TextareaStyled'
	})(['', ''], styles);
	TextareaStyled.propTypes = propTypes;
	TextareaStyled.defaultProps = defaultProps;
	TextareaStyled.displayName = displayName('Textarea');
	
	var InputStyled = exports.InputStyled = _styledComponents2.default.input.withConfig({
	  displayName: 'TextFieldElementStyled__InputStyled'
	})(['', ''], styles);
	InputStyled.propTypes = propTypes;
	InputStyled.defaultProps = defaultProps;
	InputStyled.displayName = displayName('Input');

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TextFieldGroupStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  disabled: _propTypes2.default.bool,
	  colorScheme: _propTypes2.default.oneOf(['neutral', 'error', 'success']),
	  /**
	   * Full-width TextField doesn't have borders
	   */
	  fullWidth: _propTypes2.default.bool,
	  /**
	   * Define component theme config
	   * See https://github.com/styled-components/styled-components/blob/master/docs/theming.md
	   * for more information
	   */
	  theme: _propTypes2.default.object
	};
	
	var defaultProps = {
	  disabled: false,
	  fullWidth: false,
	  colorScheme: 'neutral'
	};
	
	/** PROP RECEIVERS */
	var size = function size(_ref) {
	  var fullWidth = _ref.fullWidth;
	
	  var align = fullWidth ? 'center' : 'stretch';
	
	  return 'align-items: ' + align + ';';
	};
	
	var textfieldStyle = function textfieldStyle(_ref2) {
	  var disabled = _ref2.disabled,
	      focus = _ref2.focus,
	      colorScheme = _ref2.colorScheme,
	      themeFromProvider = _ref2.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var source = theme.reactackle.components.textfield.textfield.state;
	
	  var neutralStyles = (0, _styledComponents.css)(['background-color:', ';color:', ';border-color:', ';border-style:', ';&:hover{outline:none;background-color:', ';color:', ';border-color:', ';border-style:', ';}'], source.backgroundColor, source.fontColor, source.borderColor, source.borderStyle, source.hover.backgroundColor, source.hover.fontColor, source.hover.borderColor, source.hover.borderStyle);
	
	  var focusStyles = (0, _styledComponents.css)(['outline:none;background-color:', ';color:', ';border-color:', ';border-style:', ';'], source.focus.backgroundColor, source.focus.fontColor, source.focus.borderColor, source.focus.borderStyle);
	
	  var disabledStyles = (0, _styledComponents.css)(['cursor:default;user-select:none;&,&:hover,&:focus{background-color:', ';color:', ';border-color:', ';border-style:', ';outline:none;}'], source.disabled.backgroundColor, source.disabled.fontColor, source.disabled.borderColor, source.disabled.borderStyle);
	
	  var styles = null;
	  if (disabled) styles = disabledStyles;else if (colorScheme === 'neutral' && !focus && !disabled) styles = neutralStyles;else if (colorScheme === 'neutral' && focus && !disabled) styles = focusStyles;else {
	    styles = (0, _styledComponents.css)(['background-color:', ';color:', ';border-color:', ';border-style:', ';outline:none;&:hover,&:focus{background-color:', ';color:', ';border-color:', ';border-style:', ';outline:none;}'], source[colorScheme].backgroundColor, source[colorScheme].fontColor, source[colorScheme].borderColor, source[colorScheme].borderStyle, source[colorScheme].backgroundColor, source[colorScheme].fontColor, source[colorScheme].borderColor, source[colorScheme].borderStyle);
	  }
	
	  return styles;
	};
	
	var textfieldBorder = function textfieldBorder(_ref3) {
	  var bordered = _ref3.bordered,
	      fullWidth = _ref3.fullWidth,
	      themeFromProvider = _ref3.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var source = bordered ? theme.reactackle.components.textfield.textfield.bordered : theme.reactackle.components.textfield.textfield.underlined;
	
	  var borderWidth = (0, _reactackleCore.getValueString)(source.borderWidth),
	      borderRadius = (0, _reactackleCore.getValueString)(source.borderRadius);
	
	  return bordered ? (0, _styledComponents.css)(['border-width:', ';border-radius:', ';'], fullWidth ? '0' : borderWidth, borderRadius) : (0, _styledComponents.css)(['border-width:0;border-bottom-width:', ';border-radius:', ';'], fullWidth ? '0' : borderWidth, borderRadius);
	};
	
	/** STYLES */
	/** ex textfield-item-box */
	var TextFieldGroupStyled = exports.TextFieldGroupStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'TextFieldGroupStyled'
	})(['display:flex;position:relative;max-width:100%;flex-grow:1;', ';', ';', ';', ';'], size, textfieldStyle, textfieldBorder, (0, _reactackleCore.transition)('border-color, border-style'));
	
	TextFieldGroupStyled.propTypes = propTypes;
	TextFieldGroupStyled.defaultProps = defaultProps;
	TextFieldGroupStyled.displayName = 'TextFieldGroupStyled';

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TextFieldRowStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  disabled: _propTypes2.default.bool,
	  /**
	   * Full-width TextArea doesn't have borders
	   */
	  fullWidth: _propTypes2.default.bool,
	  /**
	   * If textfield is dense it has smaller paddings
	   */
	  dense: _propTypes2.default.bool,
	  /**
	   * If bordered = false, TextArea will have only bottom border
	   */
	  bordered: _propTypes2.default.bool,
	  colorScheme: _propTypes2.default.oneOf(['neutral', 'error', 'success']),
	  /**
	   * If slidingLabel = true, label will float to top
	   * when parent textfield is focused or filled
	   */
	  slidingLabel: _propTypes2.default.bool,
	  /**
	   * Define component theme config
	   * See https://github.com/styled-components/styled-components/blob/master/docs/theming.md
	   * for more information
	   */
	  theme: _propTypes2.default.object
	};
	
	var defaultProps = {
	  disabled: false,
	  fullWidth: false,
	  dense: false,
	  bordered: false,
	  colorScheme: 'neutral',
	  slidingLabel: false
	};
	
	/** PROP RECEIVERS */
	var size = function size(_ref) {
	  var dense = _ref.dense,
	      fullWidth = _ref.fullWidth,
	      themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var source = null;
	
	  if (dense && !fullWidth) {
	    source = theme.reactackle.components.textfield.textfield.size.dense;
	  } else if (dense && fullWidth) {
	    source = theme.reactackle.components.textfield.textfield.size.denseFullWidth;
	  } else if (!dense && fullWidth) {
	    source = theme.reactackle.components.textfield.textfield.size.fullWidth;
	  } else {
	    source = theme.reactackle.components.textfield.textfield.size;
	  }
	
	  var align = fullWidth ? 'center' : 'stretch';
	
	  var _source = source,
	      fontSize = _source.fontSize,
	      lineHeight = _source.lineHeight;
	
	
	  return '\n    font-size: ' + (0, _reactackleCore.getValueString)(fontSize) + ';\n    line-height: ' + lineHeight + ';\n    align-items: ' + align + ';\n  ';
	};
	
	var slidingLabelOffset = function slidingLabelOffset(_ref2) {
	  var slidingLabel = _ref2.slidingLabel,
	      dense = _ref2.dense,
	      fullWidth = _ref2.fullWidth,
	      bordered = _ref2.bordered,
	      themeFromProvider = _ref2.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var textfieldStyleKey = bordered ? 'bordered' : 'underlined';
	  var path = theme.reactackle.components.textfield.label.positionTop;
	  var source = null;
	
	  if (dense && !fullWidth) source = path.size[textfieldStyleKey].dense;else if (dense && fullWidth) source = path.size[textfieldStyleKey].denseFullWidth;else if (!dense && fullWidth) source = path.size[textfieldStyleKey].fullWidth;else source = path.size[textfieldStyleKey];
	
	  var _source2 = source,
	      labelSpacing = _source2.labelSpacing;
	  var lineHeight = path.lineHeight;
	
	
	  var paddingTop = 'calc(' + lineHeight + 'em + ' + (0, _reactackleCore.getValueString)(labelSpacing) + ')';
	
	  return slidingLabel && 'padding-top: ' + paddingTop + ';';
	};
	
	/** STYLES */
	var TextFieldRowStyled = exports.TextFieldRowStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'TextFieldRowStyled'
	})(['display:flex;position:relative;max-width:100%;flex-grow:1;', ';', ';'], size, slidingLabelOffset);
	
	TextFieldRowStyled.propTypes = propTypes;
	TextFieldRowStyled.defaultProps = defaultProps;
	TextFieldRowStyled.displayName = 'TextFieldRowStyled';

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TextFieldStyled = undefined;
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var base = function base(_ref) {
	  var themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var fontFamily = theme.reactackle.fontFamily[theme.reactackle.body.fontFamily];
	
	  return '\n    &,\n    & *,\n    *::after,\n    *::before {\n      font-family: ' + fontFamily + ';\n      box-sizing: border-box;\n    }\n  ';
	};
	
	var TextFieldStyled = exports.TextFieldStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'TextFieldStyled'
	})(['display:flex;flex-direction:column;max-width:100%;', ';'], base);
	
	TextFieldStyled.displayName = 'TextFieldStyled';

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactackleCore = __webpack_require__(3);
	
	var _reactackleIcons = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var constants = {
	  themeColor: _reactackleCore.colorSecondary,
	  fontColor: _reactackleCore.bodyFontColor,
	  backgroundColor: _reactackleCore.colorTransparent,
	  borderStyle: 'solid',
	
	  size: {
	    paddingY: (0, _reactackleCore.bmodule)(1),
	    fontSize: _reactackleCore.fontSizeBody,
	    lineHeight: 1.5,
	    paddingX: {
	      bordered: (0, _reactackleCore.bmodule)(1),
	      underlined: 0
	    },
	
	    dense: {
	      paddingY: (0, _reactackleCore.bmodule)(0.5),
	      fontSize: _reactackleCore.fontSizeBody,
	      lineHeight: 1.5,
	      paddingX: {
	        bordered: (0, _reactackleCore.bmodule)(0.5),
	        underlined: 0
	      }
	    },
	
	    fullWidth: {
	      paddingY: (0, _reactackleCore.bmodule)(1.5),
	      fontSize: _reactackleCore.fontSizeBody,
	      lineHeight: 1.5,
	      paddingX: {
	        bordered: (0, _reactackleCore.bmodule)(1.5),
	        underlined: (0, _reactackleCore.bmodule)(1.5)
	      }
	    },
	
	    denseFullWidth: {
	      paddingY: (0, _reactackleCore.bmodule)(1.5),
	      fontSize: _reactackleCore.fontSizeBody,
	      lineHeight: 1.5,
	      paddingX: {
	        bordered: (0, _reactackleCore.bmodule)(1.5),
	        underlined: (0, _reactackleCore.bmodule)(1.5)
	      }
	    }
	  },
	
	  underlined: {
	    paddingY: (0, _reactackleCore.bmodule)(1)
	  },
	
	  iconOuter: {
	    opacity: 0.54
	  },
	
	  iconInner: {
	    opacity: 0.54
	  }
	};
	
	exports.default = {
	  textfield: {
	    themeColor: constants.themeColor,
	    fontFamily: _reactackleCore.bodyFontFamily,
	
	    state: {
	      fontColor: constants.fontColor,
	      backgroundColor: constants.backgroundColor,
	      borderColor: _reactackleCore.colorPaletteGrey300,
	      borderStyle: constants.borderStyle,
	
	      hover: {
	        fontColor: constants.fontColor,
	        backgroundColor: constants.backgroundColor,
	        borderColor: constants.themeColor,
	        borderStyle: constants.borderStyle
	      },
	
	      focus: {
	        fontColor: constants.fontColor,
	        backgroundColor: constants.backgroundColor,
	        borderColor: constants.themeColor,
	        borderStyle: constants.borderStyle
	      },
	
	      disabled: {
	        fontColor: _reactackleCore.fontColorMedium,
	        backgroundColor: _reactackleCore.colorTransparent,
	        borderColor: _reactackleCore.colorPaletteGrey300,
	        borderStyle: 'dotted'
	      },
	
	      error: {
	        fontColor: _reactackleCore.colorAlert,
	        backgroundColor: constants.backgroundColor,
	        borderColor: _reactackleCore.colorAlert,
	        borderStyle: constants.borderStyle
	      },
	
	      success: {
	        fontColor: _reactackleCore.colorSuccess,
	        backgroundColor: constants.backgroundColor,
	        borderColor: _reactackleCore.colorSuccess,
	        borderStyle: constants.borderStyle
	      }
	    },
	
	    size: {
	      paddingY: constants.size.paddingY,
	      paddingX: constants.size.paddingX,
	      lineHeight: constants.size.lineHeight,
	      fontSize: constants.size.fontSize,
	
	      dense: {
	        paddingY: constants.size.dense.paddingY,
	        paddingX: constants.size.dense.paddingX,
	        lineHeight: constants.size.lineHeight,
	        fontSize: constants.size.dense.fontSize
	      },
	
	      fullWidth: {
	        paddingY: constants.size.fullWidth.paddingY,
	        paddingX: constants.size.fullWidth.paddingX,
	        lineHeight: constants.size.lineHeight,
	        fontSize: constants.size.fullWidth.fontSize
	      },
	
	      denseFullWidth: {
	        paddingY: constants.size.denseFullWidth.paddingY,
	        paddingX: constants.size.denseFullWidth.paddingX,
	        lineHeight: constants.size.lineHeight,
	        fontSize: constants.size.denseFullWidth.fontSize
	      }
	    },
	
	    bordered: {
	      borderWidth: 1,
	      borderRadius: _reactackleCore.radiusDefault
	    },
	
	    underlined: {
	      borderWidth: 2,
	      borderRadius: 0
	    }
	  },
	
	  placeholder: {
	    fontColor: _reactackleCore.colorPaletteGrey400
	  },
	
	  label: {
	    positionTop: {
	      fontSize: _reactackleCore.fontSizeSmall,
	      lineHeight: 1,
	      textTransform: 'none',
	      fontWeight: _reactackleCore.fontWeightNormal,
	
	      style: {
	        fontColor: _reactackleCore.fontColorMedium,
	
	        disabled: {
	          fontColor: _reactackleCore.fontColorMedium
	        },
	
	        focus: {
	          fontColor: constants.themeColor
	        },
	
	        error: {
	          fontColor: _reactackleCore.colorError
	        },
	
	        success: {
	          fontColor: _reactackleCore.colorSuccess
	        }
	      },
	
	      size: {
	        bordered: {
	          paddingTop: 0,
	          labelSpacing: (0, _reactackleCore.bmodule)(1),
	
	          dense: {
	            paddingTop: 0,
	            labelSpacing: (0, _reactackleCore.bmodule)(0.5)
	          },
	
	          fullWidth: {
	            paddingTop: (0, _reactackleCore.bmodule)(0.5),
	            labelSpacing: (0, _reactackleCore.bmodule)(0.5)
	          },
	
	          denseFullWidth: {
	            paddingTop: (0, _reactackleCore.bmodule)(0.5),
	            labelSpacing: (0, _reactackleCore.bmodule)(0.5)
	          }
	        },
	
	        underlined: {
	          paddingTop: 0,
	          labelSpacing: 0,
	
	          dense: {
	            paddingTop: 0,
	            labelSpacing: (0, _reactackleCore.bmodule)(0.5)
	          },
	
	          fullWidth: {
	            paddingTop: (0, _reactackleCore.bmodule)(0.5),
	            labelSpacing: (0, _reactackleCore.bmodule)(0.5)
	          },
	
	          denseFullWidth: {
	            paddingTop: (0, _reactackleCore.bmodule)(0.5),
	            labelSpacing: (0, _reactackleCore.bmodule)(0.5)
	          }
	        }
	      }
	    },
	
	    positionSide: {
	      fontSize: _reactackleCore.fontSizeBody,
	      lineHeight: _reactackleCore.bodyLineHeight,
	      textTransform: 'none',
	      fontWeight: _reactackleCore.fontWeightNormal,
	      width: '30%',
	
	      style: {
	        fontColor: _reactackleCore.bodyFontColor,
	
	        disabled: {
	          fontColor: _reactackleCore.fontColorMedium
	        },
	
	        focus: {
	          fontColor: constants.themeColor
	        },
	
	        error: {
	          fontColor: _reactackleCore.colorError
	        },
	
	        success: {
	          fontColor: _reactackleCore.colorSuccess
	        }
	      },
	
	      size: {
	        bordered: {
	          paddingTop: 0,
	          paddingBottom: 0,
	          labelSpacing: (0, _reactackleCore.bmodule)(1),
	
	          dense: {
	            paddingTop: 0,
	            paddingBottom: 0,
	            labelSpacing: (0, _reactackleCore.bmodule)(1)
	          },
	
	          fullWidth: {
	            paddingTop: (0, _reactackleCore.bmodule)(0.5),
	            paddingBottom: (0, _reactackleCore.bmodule)(0.5),
	            labelSpacing: (0, _reactackleCore.bmodule)(1)
	          },
	
	          denseFullWidth: {
	            paddingTop: (0, _reactackleCore.bmodule)(0.5),
	            paddingBottom: (0, _reactackleCore.bmodule)(0.5),
	            labelSpacing: (0, _reactackleCore.bmodule)(1)
	          }
	        },
	
	        underlined: {
	          paddingTop: 0,
	          paddingBottom: 0,
	          labelSpacing: (0, _reactackleCore.bmodule)(1),
	
	          dense: {
	            paddingTop: 0,
	            paddingBottom: 0,
	            labelSpacing: (0, _reactackleCore.bmodule)(1)
	          },
	
	          fullWidth: {
	            paddingTop: (0, _reactackleCore.bmodule)(0.5),
	            paddingBottom: (0, _reactackleCore.bmodule)(0.5),
	            labelSpacing: (0, _reactackleCore.bmodule)(1)
	          },
	
	          denseFullWidth: {
	            paddingTop: (0, _reactackleCore.bmodule)(0.5),
	            paddingBottom: (0, _reactackleCore.bmodule)(0.5),
	            labelSpacing: (0, _reactackleCore.bmodule)(1)
	          }
	        }
	      },
	
	      breakpoints: [{
	        breakpoint: _reactackleCore.breakpointMedium,
	        width: 150
	      }]
	    },
	
	    labelTooltipSpacing: (0, _reactackleCore.bmodule)(1)
	  },
	
	  iconOuter: {
	    iconSpacing: (0, _reactackleCore.bmodule)(1),
	
	    state: {
	      color: 'inherit',
	      opacity: constants.iconOuter.opacity,
	
	      disabled: {
	        color: 'inherit',
	        opacity: 0.25
	      },
	
	      focus: {
	        color: constants.themeColor,
	        opacity: constants.iconOuter.opacity
	      },
	
	      error: {
	        color: 'inherit',
	        opacity: constants.iconOuter.opacity
	      },
	
	      success: {
	        color: 'inherit',
	        opacity: constants.iconOuter.opacity
	      }
	    },
	
	    size: {
	      boxSize: function boxSize(base) {
	        return constants.size.fontSize(base) * constants.size.lineHeight + constants.size.paddingY(base) * 2;
	      },
	      imgSize: null,
	
	      dense: {
	        boxSize: function boxSize(base) {
	          return constants.size.dense.fontSize(base) * constants.size.dense.lineHeight + constants.size.dense.paddingY(base) * 2;
	        },
	        imgSize: null
	      },
	
	      fullWidth: {
	        boxSize: function boxSize(base) {
	          return constants.size.fullWidth.fontSize(base) * constants.size.fullWidth.lineHeight + constants.size.fullWidth.paddingY(base) * 2;
	        },
	        imgSize: null
	      },
	
	      denseFullWidth: {
	        boxSize: function boxSize(base) {
	          return constants.size.denseFullWidth.fontSize(base) * constants.size.denseFullWidth.lineHeight + constants.size.denseFullWidth.paddingY(base) * 2;
	        },
	        imgSize: null
	      }
	    }
	  },
	
	  iconInner: {
	    iconSpacing: (0, _reactackleCore.bmodule)(0.5),
	
	    state: {
	      color: 'inherit',
	      opacity: constants.iconInner.opacity,
	
	      disabled: {
	        color: 'inherit',
	        opacity: 0.35
	      },
	
	      hover: {
	        color: 'inherit',
	        opacity: 0.8
	      },
	
	      focus: {
	        color: 'inherit',
	        opacity: 1
	      },
	
	      error: {
	        color: 'inherit',
	        opacity: constants.iconInner.opacity
	      },
	
	      success: {
	        color: 'inherit',
	        opacity: constants.iconInner.opacity
	      }
	    },
	
	    size: {
	      boxSize: function boxSize(base) {
	        return constants.size.fontSize(base) * constants.size.lineHeight + constants.size.paddingY(base) * 2;
	      },
	      imgSize: null,
	
	      dense: {
	        boxSize: function boxSize(base) {
	          return constants.size.dense.fontSize(base) * constants.size.dense.lineHeight + constants.size.dense.paddingY(base) * 2;
	        },
	        imgSize: null
	      },
	
	      fullWidth: {
	        boxSize: function boxSize(base) {
	          return constants.size.fullWidth.fontSize(base) * constants.size.fullWidth.lineHeight + constants.size.fullWidth.paddingY(base) * 2;
	        },
	        imgSize: null
	      },
	
	      denseFullWidth: {
	        boxSize: function boxSize(base) {
	          return constants.size.denseFullWidth.fontSize(base) * constants.size.denseFullWidth.lineHeight + constants.size.denseFullWidth.paddingY(base) * 2;
	        },
	        imgSize: null
	      }
	    }
	  },
	
	  buttonInner: {
	    iconSpacing: (0, _reactackleCore.bmodule)(0.5),
	
	    state: {
	      color: constants.fontColor,
	      opacity: constants.iconInner.opacity,
	
	      disabled: {
	        color: 'inherit',
	        opacity: 0.35
	      },
	
	      hover: {
	        color: constants.fontColor,
	        opacity: 0.8
	      },
	
	      focus: {
	        color: constants.fontColor,
	        opacity: 1
	      },
	
	      error: {
	        color: constants.fontColor,
	        opacity: constants.iconInner.opacity
	      },
	
	      success: {
	        color: constants.fontColor,
	        opacity: constants.iconInner.opacity
	      }
	    },
	
	    size: {
	      boxSize: function boxSize(base) {
	        return constants.size.fontSize(base) * constants.size.lineHeight + constants.size.paddingY(base) * 2;
	      },
	      imgSize: 24,
	
	      dense: {
	        boxSize: function boxSize(base) {
	          return constants.size.dense.fontSize(base) * constants.size.dense.lineHeight + constants.size.dense.paddingY(base) * 2;
	        },
	        imgSize: 24
	      },
	
	      fullWidth: {
	        boxSize: function boxSize(base) {
	          return constants.size.fullWidth.fontSize(base) * constants.size.fullWidth.lineHeight + constants.size.fullWidth.paddingY(base) * 2;
	        },
	        imgSize: 24
	      },
	
	      denseFullWidth: {
	        boxSize: function boxSize(base) {
	          return constants.size.denseFullWidth.fontSize(base) * constants.size.denseFullWidth.lineHeight + constants.size.denseFullWidth.paddingY(base) * 2;
	        },
	        imgSize: 24
	      }
	    }
	  },
	  clearingIconElement: _react2.default.createElement(_reactackleIcons.IconCross, { size: 'custom', color: 'inherit' }),
	  passwordIconShowElement: _react2.default.createElement(_reactackleIcons.IconEye, { size: 'custom', color: 'inherit' }),
	  passwordIconHideElement: _react2.default.createElement(_reactackleIcons.IconEyeClosed, { size: 'custom', color: 'inherit' }),
	
	  message: {
	    messageSpacing: (0, _reactackleCore.bmodule)(1),
	    fontSize: _reactackleCore.fontSizeSmall,
	    lineHeight: 1,
	
	    style: {
	      fontColor: _reactackleCore.fontColorMedium,
	
	      disabled: {
	        fontColor: _reactackleCore.fontColorMedium
	      },
	
	      focus: {
	        fontColor: _reactackleCore.fontColorMedium
	      },
	
	      error: {
	        fontColor: _reactackleCore.colorAlert
	      },
	
	      success: {
	        fontColor: _reactackleCore.colorSuccess
	      }
	    }
	  },
	
	  symbolCounter: {
	    counterSpacing: (0, _reactackleCore.bmodule)(1),
	    counterMessageSpacing: (0, _reactackleCore.bmodule)(4),
	    fontSize: _reactackleCore.fontSizeSmall,
	    lineHeight: 1,
	
	    style: {
	      fontColor: _reactackleCore.fontColorMedium,
	
	      disabled: {
	        fontColor: _reactackleCore.fontColorMedium
	      },
	
	      focus: {
	        fontColor: _reactackleCore.fontColorMedium
	      },
	
	      error: {
	        fontColor: _reactackleCore.colorAlert
	      }
	    }
	  },
	
	  prefix: {
	    lineHeight: 'inherit',
	
	    size: {
	      fontSize: 'inherit',
	      paddingY: (0, _reactackleCore.bmodule)(0.5),
	      prefixSpacing: (0, _reactackleCore.bmodule)(2),
	      prefixEdgeSpacing: {
	        bordered: (0, _reactackleCore.bmodule)(1),
	        underlined: 0
	      },
	
	      dense: {
	        fontSize: 'inherit',
	        paddingY: (0, _reactackleCore.bmodule)(0.5),
	        prefixSpacing: (0, _reactackleCore.bmodule)(2),
	        prefixEdgeSpacing: {
	          bordered: (0, _reactackleCore.bmodule)(1),
	          underlined: 0
	        }
	      },
	
	      fullWidth: {
	        fontSize: 'inherit',
	        paddingY: (0, _reactackleCore.bmodule)(0.5),
	        prefixSpacing: (0, _reactackleCore.bmodule)(2),
	        prefixEdgeSpacing: {
	          bordered: (0, _reactackleCore.bmodule)(1),
	          underlined: 0
	        }
	      },
	
	      denseFullWidth: {
	        fontSize: 'inherit',
	        paddingY: (0, _reactackleCore.bmodule)(0.5),
	        prefixSpacing: (0, _reactackleCore.bmodule)(2),
	        prefixEdgeSpacing: {
	          bordered: (0, _reactackleCore.bmodule)(1),
	          underlined: 0
	        }
	      }
	    },
	
	    state: {
	      bordered: {
	        fontColor: _reactackleCore.fontColorMedium,
	        backgroundColor: 'inherit',
	
	        focus: {
	          fontColor: constants.fontColor,
	          backgroundColor: constants.backgroundColor
	        },
	
	        disabled: {
	          fontColor: _reactackleCore.fontColorMedium,
	          backgroundColor: _reactackleCore.colorTransparent
	        },
	
	        error: {
	          fontColor: _reactackleCore.colorAlert,
	          backgroundColor: constants.backgroundColor
	        },
	
	        success: {
	          fontColor: _reactackleCore.colorSuccess,
	          backgroundColor: constants.backgroundColor
	        }
	      },
	
	      underlined: {
	        fontColor: _reactackleCore.fontColorMedium,
	        backgroundColor: 'inherit',
	
	        focus: {
	          fontColor: constants.fontColor,
	          backgroundColor: constants.backgroundColor
	        },
	
	        disabled: {
	          fontColor: _reactackleCore.fontColorMedium,
	          backgroundColor: _reactackleCore.colorTransparent
	        },
	
	        error: {
	          fontColor: _reactackleCore.colorAlert,
	          backgroundColor: constants.backgroundColor
	        },
	
	        success: {
	          fontColor: _reactackleCore.colorSuccess,
	          backgroundColor: constants.backgroundColor
	        }
	      }
	    }
	  },
	
	  postfix: {
	    lineHeight: 'inherit',
	
	    size: {
	      fontSize: 'inherit',
	      paddingY: (0, _reactackleCore.bmodule)(0.5),
	      postfixSpacing: (0, _reactackleCore.bmodule)(2),
	      postfixEdgeSpacing: {
	        bordered: (0, _reactackleCore.bmodule)(1),
	        underlined: 0
	      },
	
	      dense: {
	        fontSize: 'inherit',
	        paddingY: (0, _reactackleCore.bmodule)(0.5),
	        postfixSpacing: (0, _reactackleCore.bmodule)(2),
	        postfixEdgeSpacing: {
	          bordered: (0, _reactackleCore.bmodule)(1),
	          underlined: 0
	        }
	      },
	
	      fullWidth: {
	        fontSize: 'inherit',
	        paddingY: (0, _reactackleCore.bmodule)(0.5),
	        postfixSpacing: (0, _reactackleCore.bmodule)(2),
	        postfixEdgeSpacing: {
	          bordered: (0, _reactackleCore.bmodule)(1),
	          underlined: 0
	        }
	      },
	
	      denseFullWidth: {
	        fontSize: 'inherit',
	        paddingY: (0, _reactackleCore.bmodule)(0.5),
	        postfixSpacing: (0, _reactackleCore.bmodule)(2),
	        postfixEdgeSpacing: {
	          bordered: (0, _reactackleCore.bmodule)(1),
	          underlined: 0
	        }
	      }
	    },
	
	    state: {
	      bordered: {
	        fontColor: _reactackleCore.fontColorMedium,
	        backgroundColor: 'inherit',
	
	        focus: {
	          fontColor: constants.fontColor,
	          backgroundColor: constants.backgroundColor
	        },
	
	        disabled: {
	          fontColor: _reactackleCore.fontColorMedium,
	          backgroundColor: _reactackleCore.colorTransparent
	        },
	
	        error: {
	          fontColor: _reactackleCore.colorAlert,
	          backgroundColor: constants.backgroundColor
	        },
	
	        success: {
	          fontColor: _reactackleCore.colorSuccess,
	          backgroundColor: constants.backgroundColor
	        }
	      },
	
	      underlined: {
	        fontColor: _reactackleCore.fontColorMedium,
	        backgroundColor: 'inherit',
	
	        focus: {
	          fontColor: constants.fontColor,
	          backgroundColor: constants.backgroundColor
	        },
	
	        disabled: {
	          fontColor: _reactackleCore.fontColorMedium,
	          backgroundColor: _reactackleCore.colorTransparent
	        },
	
	        error: {
	          fontColor: _reactackleCore.colorAlert,
	          backgroundColor: constants.backgroundColor
	        },
	
	        success: {
	          fontColor: _reactackleCore.colorSuccess,
	          backgroundColor: constants.backgroundColor
	        }
	      }
	    }
	  }
	};

/***/ }),
/* 856 */
362,
/* 857 */
[944, 856],
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactackleTooltip = __webpack_require__(66);
	
	var _reactackleCore = __webpack_require__(3);
	
	var _styles = __webpack_require__(861);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	(0, _reactackleCore.registerDefaultComponentTheme)('text', _styles.componentTheme);
	
	/**
	 * Combined with tooltip
	 */
	var propTypes = {
	  /**
	   * Text of the component
	   */
	  text: _propTypes2.default.string,
	  /**
	   * Text display type
	   */
	  display: _propTypes2.default.oneOf(['default', 'caption', 'body', 'bodyStrong', 'subheading', 'title', 'headline', 'display1', 'display2', 'display3', 'display4']),
	  /**
	   * Tooltip text
	   */
	  tooltipText: _propTypes2.default.string,
	  /**
	   * @ignore
	   */
	  toggleTooltip: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  showTooltip: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  hideTooltip: _propTypes2.default.func
	};
	
	var defaultProps = {
	  text: '',
	  display: 'default',
	  tooltipText: '',
	  toggleTooltip: _reactackleCore.noop,
	  showTooltip: _reactackleCore.noop,
	  hideTooltip: _reactackleCore.noop
	};
	
	var TextComponent = function TextComponent(_ref) {
	  var text = _ref.text,
	      display = _ref.display,
	      tooltipText = _ref.tooltipText,
	      children = _ref.children,
	      toggleTooltip = _ref.toggleTooltip,
	      showTooltip = _ref.showTooltip,
	      hideTooltip = _ref.hideTooltip,
	      props = _objectWithoutProperties(_ref, ['text', 'display', 'tooltipText', 'children', 'toggleTooltip', 'showTooltip', 'hideTooltip']);
	
	  var tooltipElement = tooltipText && _react2.default.createElement(
	    props.Tooltip,
	    null,
	    tooltipText
	  );
	
	  var wrapperProps = {
	    onClick: toggleTooltip,
	    onFocus: showTooltip,
	    onBlur: hideTooltip,
	    onMouseEnter: showTooltip,
	    onMouseLeave: hideTooltip
	  };
	
	  return _react2.default.createElement(
	    _styles.TextStyled,
	    _extends({}, wrapperProps, { display: display }),
	    text || children,
	    tooltipElement
	  );
	};
	
	TextComponent.propTypes = propTypes;
	TextComponent.defaultProps = defaultProps;
	TextComponent.displayName = 'Text';
	
	exports.default = (0, _reactackleTooltip.withTooltip)(TextComponent, true);

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Text = undefined;
	
	var _Text = __webpack_require__(858);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Text = _Text2.default;

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TextStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  display: _propTypes2.default.oneOf(['default', 'caption', 'body', 'bodyStrong', 'subheading', 'title', 'headline', 'display1', 'display2', 'display3', 'display4'])
	};
	
	var defaultProps = {
	  display: 'default'
	};
	
	var display = function display(_ref) {
	  var display = _ref.display,
	      themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var _theme$reactackle$com = theme.reactackle.components.text[display],
	      fontSize = _theme$reactackle$com.fontSize,
	      lineHeight = _theme$reactackle$com.lineHeight,
	      color = _theme$reactackle$com.color,
	      textTransform = _theme$reactackle$com.textTransform,
	      fontWeight = _theme$reactackle$com.fontWeight,
	      letterSpacing = _theme$reactackle$com.letterSpacing,
	      fontFamily = _theme$reactackle$com.fontFamily,
	      marginTop = _theme$reactackle$com.marginTop,
	      marginBottom = _theme$reactackle$com.marginBottom,
	      similarItemsSpacing = _theme$reactackle$com.similarItemsSpacing;
	
	
	  return (0, _styledComponents.css)(['font-size:', ';line-height:', ';color:', ';text-transform:', ';font-weight:', ';letter-spacing:', ';font-family:', ';margin-top:', ';margin-bottom:', ';& + &{margin-top:', ';}'], (0, _reactackleCore.getValueString)(fontSize), lineHeight, color, textTransform, fontWeight, (0, _reactackleCore.getValueString)(letterSpacing), fontFamily, (0, _reactackleCore.getValueString)(marginTop), (0, _reactackleCore.getValueString)(marginBottom), (0, _reactackleCore.getValueString)(similarItemsSpacing));
	};
	
	var TextStyled = exports.TextStyled = _styledComponents2.default.span.withConfig({
	  displayName: 'TextStyled'
	})(['display:inline-block;', ''], display);
	
	TextStyled.propTypes = propTypes;
	TextStyled.defaultProps = defaultProps;

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.componentTheme = undefined;
	
	var _TextStyled = __webpack_require__(860);
	
	Object.keys(_TextStyled).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _TextStyled[key];
	    }
	  });
	});
	
	var _theme = __webpack_require__(862);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.componentTheme = _theme2.default;

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactackleCore = __webpack_require__(3);
	
	exports.default = {
	  default: {
	    fontSize: 'inherit',
	    lineHeight: 'inherit',
	    color: 'currentColor',
	    textTransform: 'inherit',
	    fontWeight: 'inherit',
	    letterSpacing: 'inherit',
	    fontFamily: 'inherit',
	    marginTop: 0,
	    marginBottom: 0,
	    similarItemsSpacing: (0, _reactackleCore.bmodule)(1)
	  },
	
	  caption: {
	    fontSize: _reactackleCore.fontSizeSmall,
	    lineHeight: 1.25,
	    color: _reactackleCore.fontColorMedium,
	    textTransform: 'none',
	    fontWeight: _reactackleCore.fontWeightNormal,
	    letterSpacing: 'initial',
	    fontFamily: 'inherit',
	    marginTop: 0,
	    marginBottom: 0,
	    similarItemsSpacing: (0, _reactackleCore.bmodule)(0.5)
	  },
	
	  body: {
	    fontSize: _reactackleCore.fontSizeBody,
	    lineHeight: 1.6,
	    color: _reactackleCore.bodyFontColor,
	    textTransform: 'none',
	    fontWeight: _reactackleCore.fontWeightNormal,
	    letterSpacing: 'initial',
	    fontFamily: 'inherit',
	    marginTop: 0,
	    marginBottom: 0,
	    similarItemsSpacing: (0, _reactackleCore.bmodule)(1)
	  },
	
	  bodyStrong: {
	    fontSize: _reactackleCore.fontSizeBody,
	    lineHeight: 1.6,
	    color: _reactackleCore.bodyFontColor,
	    textTransform: 'none',
	    fontWeight: _reactackleCore.fontWeightSemibold,
	    letterSpacing: 'initial',
	    fontFamily: 'inherit',
	    marginTop: 0,
	    marginBottom: 0,
	    similarItemsSpacing: (0, _reactackleCore.bmodule)(1)
	  },
	
	  subheading: {
	    fontSize: _reactackleCore.fontSizeBody2,
	    lineHeight: 1.6,
	    color: _reactackleCore.bodyFontColor,
	    textTransform: 'none',
	    fontWeight: _reactackleCore.fontWeightNormal,
	    letterSpacing: 'initial',
	    fontFamily: 'inherit',
	    marginTop: 0,
	    marginBottom: 0,
	    similarItemsSpacing: (0, _reactackleCore.bmodule)(1)
	  },
	
	  title: {
	    fontSize: _reactackleCore.fontSizeTitle,
	    lineHeight: 1.6,
	    color: _reactackleCore.bodyFontColor,
	    textTransform: 'none',
	    fontWeight: _reactackleCore.fontWeightSemibold,
	    letterSpacing: 'initial',
	    fontFamily: 'inherit',
	    marginTop: 0,
	    marginBottom: 0,
	    similarItemsSpacing: (0, _reactackleCore.bmodule)(1)
	  },
	
	  headline: {
	    fontSize: _reactackleCore.fontSizeHeadline,
	    lineHeight: 1.6,
	    color: _reactackleCore.bodyFontColor,
	    textTransform: 'none',
	    fontWeight: _reactackleCore.fontWeightNormal,
	    letterSpacing: 'initial',
	    fontFamily: 'inherit',
	    marginTop: 0,
	    marginBottom: 0,
	    similarItemsSpacing: (0, _reactackleCore.bmodule)(1)
	  },
	
	  display1: {
	    fontSize: _reactackleCore.fontSizeDisplay1,
	    lineHeight: 1.6,
	    color: _reactackleCore.bodyFontColor,
	    textTransform: 'none',
	    fontWeight: _reactackleCore.fontWeightNormal,
	    letterSpacing: 'initial',
	    fontFamily: 'inherit',
	    marginTop: 0,
	    marginBottom: 0,
	    similarItemsSpacing: (0, _reactackleCore.bmodule)(1)
	  },
	
	  display2: {
	    fontSize: _reactackleCore.fontSizeDisplay2,
	    lineHeight: 1.6,
	    color: _reactackleCore.bodyFontColor,
	    textTransform: 'none',
	    fontWeight: _reactackleCore.fontWeightNormal,
	    letterSpacing: 'initial',
	    fontFamily: 'inherit',
	    marginTop: 0,
	    marginBottom: 0,
	    similarItemsSpacing: (0, _reactackleCore.bmodule)(1)
	  },
	
	  display3: {
	    fontSize: _reactackleCore.fontSizeDisplay3,
	    lineHeight: 1.3,
	    color: _reactackleCore.bodyFontColor,
	    textTransform: 'none',
	    fontWeight: _reactackleCore.fontWeightNormal,
	    letterSpacing: 'initial',
	    fontFamily: 'inherit',
	    marginTop: 0,
	    marginBottom: 0,
	    similarItemsSpacing: (0, _reactackleCore.bmodule)(1)
	  },
	
	  display4: {
	    fontSize: _reactackleCore.fontSizeDisplay4,
	    lineHeight: 1.3,
	    color: _reactackleCore.bodyFontColor,
	    textTransform: 'none',
	    fontWeight: _reactackleCore.fontWeightLight,
	    letterSpacing: 'initial',
	    fontFamily: 'inherit',
	    marginTop: 0,
	    marginBottom: 0,
	    similarItemsSpacing: (0, _reactackleCore.bmodule)(1)
	  }
	};

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactackleTooltipIcon = __webpack_require__(52);
	
	var _reactackleCore = __webpack_require__(3);
	
	var _ToggleStyled = __webpack_require__(871);
	
	var _ToggleBarBoxStyled = __webpack_require__(865);
	
	var _ToggleBarStyled = __webpack_require__(866);
	
	var _ToggleInputStyled = __webpack_require__(867);
	
	var _ToggleLabelStyled = __webpack_require__(868);
	
	var _ToggleLabelTextBoxStyled = __webpack_require__(869);
	
	var _ToggleLabelTextStyled = __webpack_require__(870);
	
	var _ToggleTooltipBoxStyled = __webpack_require__(872);
	
	var _theme = __webpack_require__(874);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	(0, _reactackleCore.registerDefaultComponentTheme)('toggleButton', _theme2.default);
	
	var propTypes = {
	  /**
	   * Determines whether ToggleButton is checked
	   */
	  checked: _propTypes2.default.bool,
	  /**
	   * Determines whether ToggleButton is checked by default
	   */
	  defaultChecked: _propTypes2.default.bool,
	  /**
	   * Determines whether ToggleButton is disabled
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * Determines ToggleButton label
	   */
	  label: _propTypes2.default.string,
	  /**
	   * Determines ToggleButton tooltip
	   */
	  tooltip: _propTypes2.default.string,
	  /**
	   * Determines ToggleButton label position
	   */
	  labelPosition: _propTypes2.default.oneOf(['left', 'right']),
	  /**
	   * Specify function to call on ToggleButton state change
	   */
	  onChange: _propTypes2.default.func
	};
	var defaultProps = {
	  checked: void 0,
	  defaultChecked: false,
	  disabled: false,
	  label: '',
	  tooltip: '',
	  labelPosition: 'left',
	  onChange: _reactackleCore.noop
	};
	
	var nextId = 0;
	
	var ToggleButton = function (_Component) {
	  _inherits(ToggleButton, _Component);
	
	  function ToggleButton(props) {
	    _classCallCheck(this, ToggleButton);
	
	    var _this = _possibleConstructorReturn(this, (ToggleButton.__proto__ || Object.getPrototypeOf(ToggleButton)).call(this, props));
	
	    _this._inputId = 'toggle-' + nextId++;
	
	    _this.state = {
	      checked: (0, _reactackleCore.isUndef)(props.checked) ? props.defaultChecked : props.checked,
	      hovered: false,
	      focused: false
	    };
	
	    _this._handleChange = _this._handleChange.bind(_this);
	    _this._handleMouseEnter = _this._handleMouseEnter.bind(_this);
	    _this._handleMouseLeave = _this._handleMouseLeave.bind(_this);
	    _this._handleFocus = _this._handleFocus.bind(_this);
	    _this._handleBlur = _this._handleBlur.bind(_this);
	    return _this;
	  }
	
	  _createClass(ToggleButton, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var isDefaultValueChanged = nextProps.defaultChecked !== this.props.defaultChecked;
	
	      if (isDefaultValueChanged) {
	        this.setState({ checked: nextProps.defaultChecked });
	      }
	    }
	  }, {
	    key: '_handleChange',
	    value: function _handleChange(event) {
	      var checked = event.target.checked;
	      this.props.onChange({
	        value: checked
	      });
	
	      if ((0, _reactackleCore.isUndef)(this.props.checked)) this.setState({ checked: checked });
	    }
	  }, {
	    key: '_handleMouseEnter',
	    value: function _handleMouseEnter() {
	      this.setState({
	        hovered: true
	      });
	    }
	  }, {
	    key: '_handleMouseLeave',
	    value: function _handleMouseLeave() {
	      this.setState({
	        hovered: false
	      });
	    }
	  }, {
	    key: '_handleFocus',
	    value: function _handleFocus() {
	      this.setState({ focused: true });
	    }
	  }, {
	    key: '_handleBlur',
	    value: function _handleBlur() {
	      this.setState({ focused: false });
	    }
	  }, {
	    key: '_renderTooltip',
	    value: function _renderTooltip() {
	      if (!this.props.tooltip) return null;
	
	      return _react2.default.createElement(
	        _ToggleTooltipBoxStyled.ToggleTooltipBoxStyled,
	        null,
	        _react2.default.createElement(_reactackleTooltipIcon.TooltipIcon, { text: this.props.tooltip })
	      );
	    }
	  }, {
	    key: '_renderLabel',
	    value: function _renderLabel() {
	      if (!this.props.label) return null;
	
	      var tooltip = this._renderTooltip(),
	          checked = (0, _reactackleCore.isUndef)(this.props.checked) ? this.state.checked : this.props.checked;
	
	      return _react2.default.createElement(
	        _ToggleLabelTextBoxStyled.ToggleLabelTextBoxStyled,
	        {
	          disabled: this.props.disabled,
	          checked: checked,
	          hasTooltip: this.props.tooltip,
	          labelPosition: this.props.labelPosition
	        },
	        _react2.default.createElement(
	          _ToggleLabelTextStyled.ToggleLabelTextStyled,
	          { hasTooltip: this.props.tooltip },
	          this.props.label
	        ),
	        tooltip
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var checked = (0, _reactackleCore.isUndef)(this.props.checked) ? this.state.checked : this.props.checked;
	
	      var label = this._renderLabel();
	
	      return _react2.default.createElement(
	        _ToggleStyled.ToggleStyled,
	        {
	          onMouseEnter: this._handleMouseEnter,
	          onMouseLeave: this._handleMouseLeave,
	          disabled: this.props.disabled
	        },
	        _react2.default.createElement(
	          _ToggleLabelStyled.ToggleLabelStyled,
	          {
	            htmlFor: this._inputId,
	            disabled: this.props.disabled
	          },
	          _react2.default.createElement(
	            _ToggleBarBoxStyled.ToggleBarBoxStyled,
	            {
	              labelPosition: this.props.labelPosition,
	              disabled: this.props.disabled
	            },
	            _react2.default.createElement(_ToggleBarStyled.ToggleBarStyled, {
	              htmlFor: this._inputId,
	              checked: checked,
	              disabled: this.props.disabled,
	              hover: this.state.hovered,
	              focus: this.state.focused
	            }),
	            _react2.default.createElement(_ToggleInputStyled.ToggleInputStyled, {
	              id: this._inputId,
	              type: 'checkbox',
	              disabled: this.props.disabled,
	              checked: checked,
	              onChange: this._handleChange,
	              tabIndex: 0,
	              onFocus: this._handleFocus,
	              onBlur: this._handleBlur
	            })
	          ),
	          label
	        )
	      );
	    }
	  }]);
	
	  return ToggleButton;
	}(_react.Component);
	
	exports.default = ToggleButton;
	
	
	ToggleButton.propTypes = propTypes;
	ToggleButton.defaultProps = defaultProps;
	ToggleButton.displayName = 'ToggleButton';

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ToggleButton = undefined;
	
	var _ToggleButton = __webpack_require__(863);
	
	var _ToggleButton2 = _interopRequireDefault(_ToggleButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.ToggleButton = _ToggleButton2.default;

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ToggleBarBoxStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  labelPosition: _propTypes2.default.oneOf(['left', 'right']),
	  disabled: _propTypes2.default.bool,
	  /**
	   * Define component theme config
	   * See https://github.com/styled-components/styled-components/blob/master/docs/theming.md
	   * for more information
	   */
	  theme: _propTypes2.default.object
	};
	
	var defaultProps = {
	  labelPosition: 'left',
	  disabled: false
	};
	
	/** PROP RECEIVERS */
	var positionProps = function positionProps(_ref) {
	  var labelPosition = _ref.labelPosition;
	
	  var spacingLeft = labelPosition === 'left' || !labelPosition ? 'auto' : '0',
	      spacingRight = labelPosition === 'left' ? '0' : 'auto';
	
	  return '\n    left: ' + spacingLeft + ';\n    right: ' + spacingRight + ';\n  ';
	};
	
	var sizeProps = function sizeProps(_ref2) {
	  var themeFromProvider = _ref2.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var width = theme.reactackle.components.toggleButton.toggleBar.width,
	      size = theme.reactackle.components.toggleButton.toggleThumb.size;
	
	
	  return '\n    width: ' + (0, _reactackleCore.getValueString)(width) + ';\n    height: ' + (0, _reactackleCore.getValueString)(size) + ';\n  ';
	};
	
	var disabled = function disabled(_ref3) {
	  var disabled = _ref3.disabled;
	  return disabled ? '\n      &,\n      & * {\n        cursor: default;\n      }\n    ' : '\n      &,\n      & * {\n        cursor: pointer;\n      }\n    ';
	};
	
	/** STYLES */
	var ToggleBarBoxStyled = exports.ToggleBarBoxStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'ToggleBarBoxStyled'
	})(['position:absolute;top:0;', ';', ';', ';'], positionProps, sizeProps, disabled);
	
	ToggleBarBoxStyled.propTypes = propTypes;
	ToggleBarBoxStyled.defaultProps = defaultProps;
	ToggleBarBoxStyled.displayName = 'ToggleBarBoxStyled';

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ToggleBarStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  checked: _propTypes2.default.bool,
	  disabled: _propTypes2.default.bool,
	  /**
	   * Define component theme config
	   * See https://github.com/styled-components/styled-components/blob/master/docs/theming.md
	   * for more information
	   */
	  theme: _propTypes2.default.object
	};
	
	var defaultProps = {
	  checked: false,
	  disabled: false
	};
	
	/** PROP RECEIVERS */
	var barBase = function barBase(_ref) {
	  var themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var _theme$reactackle$com = theme.reactackle.components.toggleButton.toggleBar,
	      width = _theme$reactackle$com.width,
	      height = _theme$reactackle$com.height;
	
	
	  var thumbSize = theme.reactackle.components.toggleButton.toggleThumb.size,
	      offsetTop = 'calc((' + (0, _reactackleCore.getValueString)(thumbSize) + ' - ' + (0, _reactackleCore.getValueString)(height) + ') / 2)';
	
	  return '\n    width: ' + (0, _reactackleCore.getValueString)(width) + ';\n    height: ' + (0, _reactackleCore.getValueString)(height) + ';\n    border-radius: ' + (0, _reactackleCore.getValueString)(height) + ';\n    top: ' + offsetTop + ';\n  ';
	};
	
	var barStyle = function barStyle(_ref2) {
	  var themeFromProvider = _ref2.theme,
	      checked = _ref2.checked,
	      disabled = _ref2.disabled;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var componentPath = theme.reactackle.components.toggleButton.toggleBar.state;
	  var source = null;
	
	  if (!disabled) source = checked ? componentPath.checked : componentPath.unchecked;else source = componentPath.disabled;
	
	  var backgroundColor = source.backgroundColor.toString();
	
	  return '\n    background-color: ' + backgroundColor + ';\n  ';
	};
	
	var thumbBase = function thumbBase(_ref3) {
	  var themeFromProvider = _ref3.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var _theme$reactackle$com2 = theme.reactackle.components.toggleButton.toggleThumb,
	      size = _theme$reactackle$com2.size,
	      borderRadius = _theme$reactackle$com2.borderRadius;
	
	
	  var barHeight = theme.reactackle.components.toggleButton.toggleBar.height;
	
	  var offsetTop = 'calc((' + (0, _reactackleCore.getValueString)(barHeight) + ' - ' + (0, _reactackleCore.getValueString)(size) + ') / 2)';
	
	  return (0, _styledComponents.css)(['width:', ';height:', ';top:', ';border-radius:', ';'], (0, _reactackleCore.getValueString)(size), (0, _reactackleCore.getValueString)(size), offsetTop, (0, _reactackleCore.getValueString)(borderRadius));
	};
	
	var thumbStyle = function thumbStyle(_ref4) {
	  var themeFromProvider = _ref4.theme,
	      checked = _ref4.checked,
	      disabled = _ref4.disabled,
	      hover = _ref4.hover,
	      focus = _ref4.focus;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var componentPath = theme.reactackle.components.toggleButton.toggleThumb.state;
	  var source = null;
	
	  if (!disabled) source = checked ? componentPath.checked : componentPath.unchecked;else source = componentPath.disabled;
	
	  var _source = source,
	      backgroundColor = _source.backgroundColor;
	
	
	  return (0, _styledComponents.css)(['background-color:', ';', ';', ';'], backgroundColor, !disabled && (0, _reactackleCore.boxShadow)(), !disabled && (hover || focus) && (0, _reactackleCore.boxShadow)(2));
	};
	
	var thumbPosition = function thumbPosition(_ref5) {
	  var checked = _ref5.checked,
	      disabled = _ref5.disabled,
	      hover = _ref5.hover,
	      focus = _ref5.focus,
	      themeFromProvider = _ref5.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var hoverOffset = theme.reactackle.components.toggleButton.toggleThumb.hoverOffset;
	
	  var offset = (hover || focus) && !disabled ? (0, _reactackleCore.getValueString)(hoverOffset) : 0;
	
	  var left = checked ? 'auto' : offset;
	  var right = checked ? offset : 'auto';
	
	  return '\n    left: ' + left + ';\n    right: ' + right + ';\n  ';
	};
	
	/** STYLES */
	var ToggleBarStyled = exports.ToggleBarStyled = _styledComponents2.default.label.withConfig({
	  displayName: 'ToggleBarStyled'
	})(['display:block;position:absolute;left:0;will-change:transform,box-shadow;', ';', ';', ';&::before{content:\'\';position:absolute;', ';', ';', ';', ';}'], barBase, barStyle, (0, _reactackleCore.transition)('background-color'), thumbBase, thumbPosition, thumbStyle, (0, _reactackleCore.transition)('left, box-shadow'));
	
	ToggleBarStyled.propTypes = propTypes;
	ToggleBarStyled.defaultProps = defaultProps;
	ToggleBarStyled.displayName = 'ToggleBarStyled';

/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ToggleInputStyled = undefined;
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {};
	var defaultProps = {};
	
	/** STYLES */
	var ToggleInputStyled = exports.ToggleInputStyled = _styledComponents2.default.input.withConfig({
	  displayName: 'ToggleInputStyled'
	})(['', ';', ';'], /* Prettier workarount until issue is not fixed: https://github.com/prettier/prettier/issues/2291 */'', _reactackleCore.elementInvisible);
	
	ToggleInputStyled.propTypes = propTypes;
	ToggleInputStyled.defaultProps = defaultProps;
	ToggleInputStyled.displayName = 'ToggleInputStyled';

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ToggleLabelStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  disabled: _propTypes2.default.bool,
	  theme: _propTypes2.default.object
	};
	
	var defaultProps = {
	  disabled: false
	};
	
	/** PROP RECEIVERS */
	var labelSize = function labelSize(_ref) {
	  var themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var width = theme.reactackle.components.toggleButton.toggleBar.width,
	      size = theme.reactackle.components.toggleButton.toggleThumb.size;
	
	
	  return '\n    min-width: ' + (0, _reactackleCore.getValueString)(width) + ';\n    min-height: ' + (0, _reactackleCore.getValueString)(size) + ';\n  ';
	};
	
	var disabled = function disabled(_ref2) {
	  var disabled = _ref2.disabled;
	  return disabled ? '\n      &,\n      & * {\n        cursor: default;\n      }\n    ' : '\n      &,\n      & * {\n        cursor: pointer;\n      }\n    ';
	};
	
	/** STYLES */
	var ToggleLabelStyled = exports.ToggleLabelStyled = _styledComponents2.default.label.withConfig({
	  displayName: 'ToggleLabelStyled'
	})(['position:relative;display:block;user-select:none;', ';', ';&:hover,&:focus{outline:none;}'], labelSize, disabled);
	
	ToggleLabelStyled.propTypes = propTypes;
	ToggleLabelStyled.defaultProps = defaultProps;
	ToggleLabelStyled.displayName = 'ToggleLabelStyled';

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ToggleLabelTextBoxStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  checked: _propTypes2.default.bool,
	  disabled: _propTypes2.default.bool,
	  labelPosition: _propTypes2.default.oneOf(['left', 'right']),
	  /**
	   * Define component theme config
	   * See https://github.com/styled-components/styled-components/blob/master/docs/theming.md
	   * for more information
	   */
	  theme: _propTypes2.default.object
	};
	
	var defaultProps = {
	  checked: false,
	  disabled: false,
	  labelPosition: 'left'
	};
	
	/** PROP RECEIVERS */
	var textBase = function textBase(_ref) {
	  var themeFromProvider = _ref.theme,
	      labelPosition = _ref.labelPosition;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var _theme$reactackle$com = theme.reactackle.components.toggleButton.label,
	      fontSize = _theme$reactackle$com.fontSize,
	      lineHeight = _theme$reactackle$com.lineHeight,
	      toggleLabelSpacing = _theme$reactackle$com.toggleLabelSpacing;
	  var width = theme.reactackle.components.toggleButton.toggleBar.width,
	      thumbSize = theme.reactackle.components.toggleButton.toggleThumb.size;
	
	
	  var thumbSizeValue = (0, _reactackleCore.getValueString)(thumbSize),
	      fontSizeValue = (0, _reactackleCore.getValueString)(fontSize);
	
	  var labelOffsetTop = 'calc((' + thumbSizeValue + ' - ' + fontSizeValue + ' * ' + lineHeight + ') / 2)';
	
	  var spacingLeft = labelPosition === 'left' || !labelPosition ? '0' : 'calc(' + (0, _reactackleCore.getValueString)(toggleLabelSpacing) + ' + ' + (0, _reactackleCore.getValueString)(width) + ')';
	
	  var spacingRight = labelPosition === 'left' ? 'calc(' + (0, _reactackleCore.getValueString)(toggleLabelSpacing) + ' + ' + (0, _reactackleCore.getValueString)(width) + ')' : '0';
	
	  return (0, _styledComponents.css)(['font-size:', ';line-height:', ';padding-top:', ';padding-left:', ';padding-right:', ';'], (0, _reactackleCore.getValueString)(fontSize), lineHeight, labelOffsetTop, spacingLeft, spacingRight);
	};
	
	var textStyle = function textStyle(_ref2) {
	  var checked = _ref2.checked,
	      disabled = _ref2.disabled,
	      themeFromProvider = _ref2.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var componentPath = theme.reactackle.components.toggleButton.label.state;
	  var source = null;
	
	  if (!disabled) source = checked ? componentPath.checked : componentPath.unchecked;else source = componentPath.disabled;
	
	  var _source = source,
	      fontColor = _source.fontColor;
	
	
	  return '\n    color: ' + fontColor + ';\n  ';
	};
	
	/** STYLES */
	var ToggleLabelTextBoxStyled = exports.ToggleLabelTextBoxStyled = _styledComponents2.default.span.withConfig({
	  displayName: 'ToggleLabelTextBoxStyled'
	})(['display:flex;', ';', ';'], textBase, textStyle);
	
	ToggleLabelTextBoxStyled.propTypes = propTypes;
	ToggleLabelTextBoxStyled.defaultProps = defaultProps;
	ToggleLabelTextBoxStyled.displayName = 'ToggleLabelTextBoxStyled';

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ToggleLabelTextStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  tooltip: _propTypes2.default.string,
	  /**
	   * Define component theme config
	   * See https://github.com/styled-components/styled-components/blob/master/docs/theming.md
	   * for more information
	   */
	  theme: _propTypes2.default.object
	};
	
	var defaultProps = {
	  tooltip: ''
	};
	
	/** PROP RECEIVERS */
	var spacing = function spacing(_ref) {
	  var themeFromProvider = _ref.theme,
	      hasTooltip = _ref.hasTooltip;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var labelTooltipSpacing = theme.reactackle.components.toggleButton.label.labelTooltipSpacing;
	
	
	  return hasTooltip ? 'margin-right: ' + (0, _reactackleCore.getValueString)(labelTooltipSpacing) + ';' : '';
	};
	
	/** STYLES */
	var ToggleLabelTextStyled = exports.ToggleLabelTextStyled = _styledComponents2.default.span.withConfig({
	  displayName: 'ToggleLabelTextStyled'
	})(['', ';', ';'], /* Prettier workarount until issue is not fixed: https://github.com/prettier/prettier/issues/2291 */'', spacing);
	
	ToggleLabelTextStyled.propTypes = propTypes;
	ToggleLabelTextStyled.defaultProps = defaultProps;
	ToggleLabelTextStyled.displayName = 'ToggleLabelStyled';

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ToggleStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  disabled: _propTypes2.default.bool
	};
	
	var defaultProps = {
	  disabled: false
	};
	
	/** PROP RECEIVERS */
	var stateProp = function stateProp(_ref) {
	  var disabled = _ref.disabled;
	  return disabled && 'cursor: default;';
	};
	
	var base = function base(_ref2) {
	  var themeFromProvider = _ref2.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	
	  var fontFamily = theme.reactackle.fontFamily[theme.reactackle.body.fontFamily];
	
	  return '\n    &,\n    & *,\n    *::after,\n    *::before {\n      font-family: ' + fontFamily + ';\n      box-sizing: border-box;\n    }\n  ';
	};
	
	/** STYLES */
	var ToggleStyled = exports.ToggleStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'ToggleStyled'
	})(['', ';', ';'], base, stateProp);
	
	ToggleStyled.propTypes = propTypes;
	ToggleStyled.defaultProps = defaultProps;
	ToggleStyled.displayName = 'ToggleStyled';

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ToggleTooltipBoxStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * Define component theme config
	   * See https://github.com/styled-components/styled-components/blob/master/docs/theming.md
	   * for more information
	   */
	  theme: _propTypes2.default.object
	};
	
	/** PROP RECEIVERS */
	var baseProps = function baseProps(_ref) {
	  var themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var _theme$reactackle$com = theme.reactackle.components.toggleButton.label,
	      fontSize = _theme$reactackle$com.fontSize,
	      lineHeight = _theme$reactackle$com.lineHeight,
	      size = 'calc(' + (0, _reactackleCore.getValueString)(fontSize) + ' * ' + lineHeight + ')';
	
	
	  return '\n    height: ' + size + ';\n  ';
	};
	
	/** STYLES */
	var ToggleTooltipBoxStyled = exports.ToggleTooltipBoxStyled = _styledComponents2.default.span.withConfig({
	  displayName: 'ToggleTooltipBoxStyled'
	})(['display:flex;align-items:center;', ';'], baseProps);
	
	ToggleTooltipBoxStyled.propTypes = propTypes;
	ToggleTooltipBoxStyled.displayName = 'ToggleTooltipBoxStyled';

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.toggleBarBackgroundColorChecked = undefined;
	
	var _color = __webpack_require__(876);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var toggleConstants = {
	  toggleThumb: {
	    backgroundColorChecked: _reactackleCore.colorSecondary
	  }
	};
	
	var toggleBarBackgroundColorChecked = exports.toggleBarBackgroundColorChecked = function toggleBarBackgroundColorChecked(base) {
	  return (0, _color2.default)(toggleConstants.toggleThumb.backgroundColorChecked(base)).lighten(0.54);
	};

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactackleCore = __webpack_require__(3);
	
	var _constants = __webpack_require__(873);
	
	exports.default = {
	  toggleBar: {
	    width: (0, _reactackleCore.bmodule)(4.5),
	    height: (0, _reactackleCore.bmodule)(2),
	
	    state: {
	      checked: {
	        backgroundColor: _constants.toggleBarBackgroundColorChecked
	      },
	
	      unchecked: {
	        backgroundColor: _reactackleCore.colorPaletteGrey300
	      },
	
	      disabled: {
	        backgroundColor: _reactackleCore.colorPaletteGrey200
	      }
	    }
	  },
	
	  toggleThumb: {
	    size: (0, _reactackleCore.bmodule)(2.5),
	    borderRadius: _reactackleCore.radiusRounded,
	
	    state: {
	      checked: {
	        backgroundColor: _reactackleCore.colorSecondary
	      },
	
	      unchecked: {
	        backgroundColor: _reactackleCore.colorPaletteGrey100
	      },
	
	      disabled: {
	        backgroundColor: _reactackleCore.colorPaletteGrey400
	      }
	    },
	
	    hoverOffset: 3
	  },
	
	  label: {
	    toggleLabelSpacing: (0, _reactackleCore.bmodule)(1),
	    labelTooltipSpacing: (0, _reactackleCore.bmodule)(1),
	    fontSize: _reactackleCore.fontSizeBody,
	    lineHeight: 1.5, // Only number's accepted
	
	    state: {
	      fontColor: _reactackleCore.bodyFontColor,
	
	      checked: {
	        fontColor: _reactackleCore.bodyFontColor
	      },
	
	      unchecked: {
	        fontColor: _reactackleCore.bodyFontColor
	      },
	
	      disabled: {
	        fontColor: _reactackleCore.fontColorMedium
	      }
	    }
	  }
	};

/***/ }),
/* 875 */
362,
/* 876 */
[944, 875],
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TooltipIconComponent = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactackleTooltip = __webpack_require__(66);
	
	var _reactackleCore = __webpack_require__(3);
	
	var _TooltipIconStyled = __webpack_require__(878);
	
	var _theme = __webpack_require__(879);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _reactackleCore.registerDefaultComponentTheme)('tooltipIcon', _theme2.default);
	
	/**
	 * Combined with tooltip
	 */
	var propTypes = {
	  /**
	   * Text of the Tooltip
	   */
	  text: _propTypes2.default.string.isRequired,
	  /**
	   * @ignore
	   */
	  toggleTooltip: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  showTooltip: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  hideTooltip: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  Tooltip: _propTypes2.default.func
	};
	
	var defaultProps = {
	  toggleTooltip: _reactackleCore.noop,
	  showTooltip: _reactackleCore.noop,
	  hideTooltip: _reactackleCore.noop,
	  Tooltip: _reactackleCore.noop
	};
	
	var TooltipIconComponent = exports.TooltipIconComponent = function TooltipIconComponent(props) {
	  var Tooltip = props.Tooltip;
	
	  var wrapperProps = {
	    onClick: props.toggleTooltip,
	    onFocus: props.showTooltip,
	    onBlur: props.hideTooltip,
	    onMouseEnter: props.showTooltip,
	    onMouseLeave: props.hideTooltip,
	    tabIndex: 0
	  };
	  return _react2.default.createElement(
	    _TooltipIconStyled.TooltipIconStyled,
	    wrapperProps,
	    _react2.default.createElement(
	      'span',
	      null,
	      '?'
	    ),
	    _react2.default.createElement(
	      Tooltip,
	      null,
	      props.text
	    )
	  );
	};
	
	TooltipIconComponent.propTypes = propTypes;
	TooltipIconComponent.defaultProps = defaultProps;
	TooltipIconComponent.displayName = 'TooltipIcon';
	
	exports.default = (0, _reactackleTooltip.withTooltip)(TooltipIconComponent, true);

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TooltipIconStyled = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactackleCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  theme: _propTypes2.default.object
	};
	
	var style = function style(_ref) {
	  var themeFromProvider = _ref.theme;
	
	  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
	  var path = theme.reactackle.components.tooltipIcon.style;
	
	  var fontFamily = theme.reactackle.fontFamily[theme.reactackle.body.fontFamily];
	
	  var _theme$reactackle$com = theme.reactackle.components.tooltipIcon,
	      diameter = _theme$reactackle$com.diameter,
	      fontSize = _theme$reactackle$com.fontSize;
	
	
	  return '\n    width: ' + (0, _reactackleCore.getValueString)(diameter) + ';\n    height: ' + (0, _reactackleCore.getValueString)(diameter) + ';\n    line-height: ' + (0, _reactackleCore.getValueString)(diameter) + ';\n    font-size: ' + (0, _reactackleCore.getValueString)(fontSize) + ';\n    border-radius: 50%;    \n    background-color: ' + path.backgroundColor + ';\n    color: ' + path.fontColor + ';\n\n    &:hover {\n      background-color: ' + path.hover.backgroundColor + ';\n      color: ' + path.hover.fontColor + ';\n      outline: none;\n    }\n\n    &:focus {\n      background-color: ' + path.focus.backgroundColor + ';\n      color: ' + path.focus.fontColor + ';\n      outline: none;\n    }\n    \n    &,\n    & *,\n    *::after,\n    *::before {\n      font-family: ' + fontFamily + ';\n      box-sizing: border-box;\n    }\n  ';
	};
	
	var TooltipIconStyled = exports.TooltipIconStyled = _styledComponents2.default.div.withConfig({
	  displayName: 'TooltipIconStyled'
	})(['display:inline-block;position:relative;text-align:center;flex-shrink:0;user-select:none;', ';', ';'], style, (0, _reactackleCore.transition)('color, background-color'));
	
	TooltipIconStyled.propTypes = propTypes;
	TooltipIconStyled.displayName = 'TooltipIconStyled';

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactackleCore = __webpack_require__(3);
	
	exports.default = {
	  diameter: _reactackleCore.doubleBaseModule,
	  fontSize: _reactackleCore.fontSizeXsmall,
	
	  style: {
	    fontColor: _reactackleCore.colorPaletteGrey500,
	    backgroundColor: _reactackleCore.colorPaletteGrey200,
	
	    hover: {
	      fontColor: _reactackleCore.colorPaletteGrey700,
	      backgroundColor: _reactackleCore.colorPaletteGrey400
	    },
	
	    focus: {
	      fontColor: _reactackleCore.colorPaletteGrey500,
	      backgroundColor: _reactackleCore.colorPaletteGrey900
	    }
	  }
	};

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DynamicTooltipSlot = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactackleCore = __webpack_require__(3);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactPortal = __webpack_require__(238);
	
	var _reactPortal2 = _interopRequireDefault(_reactPortal);
	
	var _TooltipWrapperStyled = __webpack_require__(237);
	
	var _common = __webpack_require__(234);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  /**
	   * Determines whether Tooltip is visible
	   */
	  visible: _propTypes2.default.bool,
	  /**
	   * @ignore
	   */
	  positionX: _propTypes2.default.oneOf(["right", "left"]),
	  /**
	   * @ignore
	   */
	  positionY: _propTypes2.default.oneOf(["top", "bottom"]),
	  /**
	   * Function to toggle event listener
	   */
	  toggleEventListener: _propTypes2.default.func,
	  /**
	   * Function to toggle event clean event listener
	   */
	  cleanEventListeners: _propTypes2.default.func
	};
	
	var defaultProps = {
	  visible: true,
	  positionX: 'left',
	  positionY: 'bottom',
	  toggleEventListener: _reactackleCore.noop,
	  cleanEventListeners: _reactackleCore.noop
	};
	
	var DynamicTooltipSlot = exports.DynamicTooltipSlot = function (_Component) {
	  _inherits(DynamicTooltipSlot, _Component);
	
	  function DynamicTooltipSlot(props) {
	    _classCallCheck(this, DynamicTooltipSlot);
	
	    var _this = _possibleConstructorReturn(this, (DynamicTooltipSlot.__proto__ || Object.getPrototypeOf(DynamicTooltipSlot)).call(this, props));
	
	    _this.state = {
	      positionX: void 0,
	      positionY: void 0,
	      top: 0,
	      left: 0
	    };
	
	    _this._element = null;
	    _this._createElementRef = _this._createElementRef.bind(_this);
	    _this._setPosition = _this._setPosition.bind(_this);
	    return _this;
	  }
	
	  _createClass(DynamicTooltipSlot, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var toggleEventListener = this.props.toggleEventListener;
	
	      toggleEventListener({
	        target: window,
	        event: 'resize',
	        cb: this._setPosition
	      });
	      toggleEventListener({
	        target: document,
	        event: 'mousemove',
	        cb: this._setPosition
	      });
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.cleanEventListeners();
	    }
	  }, {
	    key: '_setPosition',
	    value: function _setPosition(_ref) {
	      var _ref$clientX = _ref.clientX,
	          left = _ref$clientX === undefined ? 0 : _ref$clientX,
	          _ref$clientY = _ref.clientY,
	          top = _ref$clientY === undefined ? 0 : _ref$clientY;
	
	      if (!this._element || !this.props.visible) return;
	
	      var _element$getBoundingC = this._element.getBoundingClientRect(),
	          width = _element$getBoundingC.width,
	          height = _element$getBoundingC.height;
	
	      var positionX = void 0,
	          positionY = void 0;
	
	      if (left + width > document.body.clientWidth) positionX = 'left';else if (left < 0) positionX = 'right';
	
	      if (top + height > document.body.clientHeight) positionY = 'top';else if (top < 0) positionY = 'bottom';
	
	      this.setState({
	        left: left + 1,
	        top: top + 1,
	        positionX: positionX,
	        positionY: positionY
	      });
	    }
	  }, {
	    key: '_createElementRef',
	    value: function _createElementRef(ref) {
	      this._element = ref;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          left = _state.left,
	          top = _state.top,
	          children = this.props.children;
	
	
	      return _react2.default.createElement(
	        _reactPortal2.default,
	        {
	          isOpened: this.props.visible
	        },
	        _react2.default.createElement(
	          _TooltipWrapperStyled.TooltipWrapperStyled,
	          { style: { left: left, top: top } },
	          typeof children !== 'function' ? children : children({
	            positionX: this.state.positionX || this.props.positionX,
	            positionY: this.state.positionY || this.props.positionY,
	            tooltipRef: this._createElementRef
	          })
	        )
	      );
	    }
	  }]);
	
	  return DynamicTooltipSlot;
	}(_react.Component);
	
	DynamicTooltipSlot.propTypes = propTypes;
	DynamicTooltipSlot.defaultProps = defaultProps;
	
	exports.default = (0, _common.withEventListeners)(DynamicTooltipSlot);

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.StaticTooltipSlot = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(116);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactackleAutoposition = __webpack_require__(65);
	
	var _common = __webpack_require__(234);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AutoPositionPropsKeys = Object.keys(_reactackleAutoposition.AutoPosition.propTypes);
	
	var propTypes = _extends({}, _reactackleAutoposition.AutoPosition.propTypes, {
	  /**
	   * Determines should tooltip be closed by outside click
	   */
	  closeOnOutsideClick: _propTypes2.default.bool,
	  /**
	   * @ignore
	   */
	  positionX: _propTypes2.default.oneOf(['left', 'right']),
	  /**
	   * @ignore
	   */
	  positionY: _propTypes2.default.oneOf(['top', 'bottom']),
	  /**
	   * @ignore
	   */
	  direction: _propTypes2.default.oneOf(['vertical', 'horizontal']),
	  /**
	   * @ignore
	   */
	  type: _propTypes2.default.oneOf(['outer', 'inner']),
	  /**
	   * @ignore
	   */
	  hideTooltip: _propTypes2.default.func.isRequired,
	  /**
	   * @ignore
	   */
	  onVisibleCallback: _propTypes2.default.func.isRequired,
	  /**
	   * @ignore
	   */
	  cleanEventListeners: _propTypes2.default.func.isRequired,
	  /**
	   * @ignore
	   */
	  toggleEventListener: _propTypes2.default.func.isRequired,
	  /**
	   * @ignore
	   */
	  allowedSlideOnCurrentEdge: _propTypes2.default.bool,
	  /**
	   * @ignore
	   */
	  allowedSlideOnOppositeEdge: _propTypes2.default.bool,
	  /**
	   * @ignore
	   */
	  allowedSlideOnAdjacentEdge: _propTypes2.default.bool
	});
	
	var defaultProps = {
	  closeOnOutsideClick: true,
	  type: 'outer',
	  positionX: 'left',
	  positionY: 'bottom',
	  direction: 'vertical',
	  allowedSlideOnCurrentEdge: false,
	  allowedSlideOnOppositeEdge: false,
	  allowedSlideOnAdjacentEdge: false
	};
	
	var StaticTooltipSlot = exports.StaticTooltipSlot = function (_Component) {
	  _inherits(StaticTooltipSlot, _Component);
	
	  function StaticTooltipSlot(props) {
	    _classCallCheck(this, StaticTooltipSlot);
	
	    var _this = _possibleConstructorReturn(this, (StaticTooltipSlot.__proto__ || Object.getPrototypeOf(StaticTooltipSlot)).call(this, props));
	
	    _this.state = {
	      tooltipRef: null
	    };
	
	    _this._handleTooltipRef = _this._handleTooltipRef.bind(_this);
	    _this._handleOutsideClick = _this._handleOutsideClick.bind(_this);
	    _this._applyOutsideListener = _this._applyOutsideListener.bind(_this);
	
	    _this.props.onVisibleCallback(_this._applyOutsideListener);
	    return _this;
	  }
	
	  _createClass(StaticTooltipSlot, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.cleanEventListeners();
	    }
	  }, {
	    key: '_handleTooltipRef',
	    value: function _handleTooltipRef(ref) {
	      this.setState({ tooltipRef: ref });
	    }
	  }, {
	    key: '_applyOutsideListener',
	    value: function _applyOutsideListener() {
	      var _props = this.props,
	          toggleEventListener = _props.toggleEventListener,
	          closeOnOutsideClick = _props.closeOnOutsideClick;
	
	
	      if (!closeOnOutsideClick) return;
	      var listener = {
	        target: document,
	        event: 'click',
	        cb: this._handleOutsideClick
	      };
	      toggleEventListener(listener);
	    }
	  }, {
	    key: '_handleOutsideClick',
	    value: function _handleOutsideClick(e) {
	      if (!this.state.tooltipRef.contains(e.target)) {
	        this.props.hideTooltip();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var children = this.props.children;
	
	      var autoPositionProps = (0, _lodash2.default)(this.props, AutoPositionPropsKeys);
	
	      return !autoPositionProps.parent && !autoPositionProps.visible ? null : _react2.default.createElement(
	        _reactackleAutoposition.AutoPosition,
	        autoPositionProps,
	        function (_ref) {
	          var positionX = _ref.positionX,
	              positionY = _ref.positionY;
	          return typeof children !== 'function' ? children : children({
	            positionX: positionX,
	            positionY: positionY,
	            tooltipRef: _this2._handleTooltipRef
	          });
	        }
	      );
	    }
	  }]);
	
	  return StaticTooltipSlot;
	}(_react.Component);
	
	StaticTooltipSlot.propTypes = propTypes;
	StaticTooltipSlot.defaultProps = defaultProps;
	
	exports.default = (0, _common.withEventListeners)(StaticTooltipSlot);

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactackleCore = __webpack_require__(3);
	
	var _TooltipStyled = __webpack_require__(236);
	
	var _TooltipContentStyled = __webpack_require__(235);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  isVisible: _propTypes2.default.bool,
	  positionX: _propTypes2.default.oneOf(["right", "left"]),
	  positionY: _propTypes2.default.oneOf(["top", "bottom"]),
	  tooltipRef: _propTypes2.default.func
	};
	
	var defaultProps = {
	  isVisible: true,
	  positionX: "left",
	  positionY: "bottom",
	  tooltipRef: _reactackleCore.noop
	};
	
	var TooltipWrapper = function TooltipWrapper(_ref) {
	  var isVisible = _ref.isVisible,
	      positionX = _ref.positionX,
	      positionY = _ref.positionY,
	      tooltipRef = _ref.tooltipRef,
	      children = _ref.children;
	  return _react2.default.createElement(
	    _TooltipStyled.TooltipStyled,
	    {
	      visible: isVisible,
	      positionX: positionX,
	      positionY: positionY,
	      innerRef: tooltipRef
	    },
	    _react2.default.createElement(
	      _TooltipContentStyled.TooltipContentStyled,
	      null,
	      children
	    )
	  );
	};
	
	TooltipWrapper.propTypes = propTypes;
	TooltipWrapper.defaultProps = defaultProps;
	
	exports.default = TooltipWrapper;

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactackleCore = __webpack_require__(3);
	
	exports.default = {
	  backgroundColor: 'rgba(0,0,0,0.9)',
	  borderRadius: _reactackleCore.radiusDefault,
	  paddingY: _reactackleCore.halfBaseModule,
	  paddingX: _reactackleCore.baseModule,
	  minWidth: 120,
	  maxWidth: '100vw',
	  fontSize: _reactackleCore.fontSizeXsmall,
	  lineHeight: 1.3,
	  fontColor: _reactackleCore.colorWhite,
	  zIndex: _reactackleCore.zIndexTooltip,
	  tooltipRefererSpacing: _reactackleCore.baseModule
	};

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.withContentTooltip = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(17);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactackleAutoposition = __webpack_require__(65);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var wrapWithClass = function wrapWithClass(Component) {
	  var isFunctionalComponent = function isFunctionalComponent(Component) {
	    return !Component.prototype.render;
	  };
	  if (!isFunctionalComponent(Component)) return Component;
	  // eslint-disable-next-line react/prefer-stateless-function
	  return function (_React$Component) {
	    _inherits(ClassComponent, _React$Component);
	
	    function ClassComponent() {
	      _classCallCheck(this, ClassComponent);
	
	      return _possibleConstructorReturn(this, (ClassComponent.__proto__ || Object.getPrototypeOf(ClassComponent)).apply(this, arguments));
	    }
	
	    _createClass(ClassComponent, [{
	      key: 'render',
	      value: function render() {
	        return _react2.default.createElement(Component, this.props);
	      }
	    }]);
	
	    return ClassComponent;
	  }(_react2.default.Component);
	};
	
	var withContentTooltip = exports.withContentTooltip = function withContentTooltip(Component, TooltipContent) {
	  var propTypes = {
	    closeOnOutsideClick: _propTypes2.default.bool
	  };
	  var defaultProps = {
	    closeOnOutsideClick: true
	  };
	  // eslint-disable-next-line react/no-multi-comp
	
	  var WithTooltip = function (_React$Component2) {
	    _inherits(WithTooltip, _React$Component2);
	
	    function WithTooltip(props) {
	      _classCallCheck(this, WithTooltip);
	
	      var _this2 = _possibleConstructorReturn(this, (WithTooltip.__proto__ || Object.getPrototypeOf(WithTooltip)).call(this, props));
	
	      _this2.state = {
	        targetRef: null,
	        contentRef: null,
	        visible: false
	      };
	
	      _this2.TooltipTarget = wrapWithClass(Component);
	      _this2.TooltipContent = wrapWithClass(TooltipContent);
	
	      _this2._handleContentRef = _this2._handleContentRef.bind(_this2);
	      _this2._handleTargetRef = _this2._handleTargetRef.bind(_this2);
	      _this2._toggleTooltip = _this2._toggleTooltip.bind(_this2);
	      _this2._openTooltip = _this2._openTooltip.bind(_this2);
	      _this2._closeTooltip = _this2._closeTooltip.bind(_this2);
	      _this2._handleOutsideClick = _this2._handleOutsideClick.bind(_this2);
	      _this2._applyOutsideListener = _this2._applyOutsideListener.bind(_this2);
	      return _this2;
	    }
	
	    _createClass(WithTooltip, [{
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        document.removeEventListener('click', this._handleOutsideClick);
	      }
	    }, {
	      key: '_handleTargetRef',
	      value: function _handleTargetRef(ref) {
	        // eslint-disable-next-line
	        this.setState({ targetRef: _reactDom2.default.findDOMNode(ref) });
	      }
	    }, {
	      key: '_handleContentRef',
	      value: function _handleContentRef(ref) {
	        // eslint-disable-next-line
	        this.setState({ contentRef: _reactDom2.default.findDOMNode(ref) });
	      }
	    }, {
	      key: '_toggleTooltip',
	      value: function _toggleTooltip() {
	        this.setState(function (_ref) {
	          var visible = _ref.visible;
	          return {
	            visible: !visible
	          };
	        }, this._applyOutsideListener);
	      }
	    }, {
	      key: '_openTooltip',
	      value: function _openTooltip() {
	        this.setState({ visible: true }, this._applyOutsideListener);
	      }
	    }, {
	      key: '_closeTooltip',
	      value: function _closeTooltip() {
	        this.setState({ visible: false }, this._applyOutsideListener);
	      }
	    }, {
	      key: '_applyOutsideListener',
	      value: function _applyOutsideListener() {
	        if (!this.props.closeOnOutsideClick) return;
	
	        if (this.state.visible) {
	          document.addEventListener('click', this._handleOutsideClick);
	        } else {
	          document.removeEventListener('click', this._handleOutsideClick);
	        }
	      }
	    }, {
	      key: '_handleOutsideClick',
	      value: function _handleOutsideClick(e) {
	        if (!this.state.contentRef.contains(e.target)) {
	          this._closeTooltip();
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var TooltipTarget = this.TooltipTarget,
	            TooltipContent = this.TooltipContent;
	
	
	        var tooltipProps = {
	          openTooltip: this._openTooltip,
	          closeTooltip: this._closeTooltip,
	          toggleTooltip: this._toggleTooltip
	        };
	
	        var renderAutoPosition = !this.state.targetRef && !this.state.visible ? null : _react2.default.createElement(
	          _reactackleAutoposition.AutoPosition,
	          {
	            parent: this.state.targetRef,
	            type: 'outer',
	            visible: this.state.visible
	          },
	          _react2.default.createElement(TooltipContent, _extends({}, this.props, tooltipProps, {
	            ref: this._handleContentRef
	          }))
	        );
	
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(TooltipTarget, _extends({}, this.props, tooltipProps, {
	            ref: this._handleTargetRef
	          })),
	          renderAutoPosition
	        );
	      }
	    }]);
	
	    return WithTooltip;
	  }(_react2.default.Component);
	
	  WithTooltip.propTypes = propTypes;
	  WithTooltip.defaultProps = defaultProps;
	  WithTooltip.displayName = 'withContentTooltip(' + Component.displayName + ')';
	
	  return WithTooltip;
	};

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.withTooltip = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(17);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactackleCore = __webpack_require__(3);
	
	var _Tooltip = __webpack_require__(233);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _TooltipWrapper = __webpack_require__(882);
	
	var _TooltipWrapper2 = _interopRequireDefault(_TooltipWrapper);
	
	var _DynamicTooltipSlot = __webpack_require__(880);
	
	var _DynamicTooltipSlot2 = _interopRequireDefault(_DynamicTooltipSlot);
	
	var _StaticTooltipSlot = __webpack_require__(881);
	
	var _StaticTooltipSlot2 = _interopRequireDefault(_StaticTooltipSlot);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// eslint-disable-next-line
	
	// eslint-disable-next-line
	
	
	var wrapWithClass = function wrapWithClass(Component) {
	  var isFunctionalComponent = function isFunctionalComponent(Component) {
	    return !Component.prototype.render;
	  };
	  if (!isFunctionalComponent(Component)) return Component;
	  // eslint-disable-next-line react/prefer-stateless-function
	  return function (_React$Component) {
	    _inherits(ClassComponent, _React$Component);
	
	    function ClassComponent() {
	      _classCallCheck(this, ClassComponent);
	
	      return _possibleConstructorReturn(this, (ClassComponent.__proto__ || Object.getPrototypeOf(ClassComponent)).apply(this, arguments));
	    }
	
	    _createClass(ClassComponent, [{
	      key: "render",
	      value: function render() {
	        return _react2.default.createElement(Component, this.props);
	      }
	    }]);
	
	    return ClassComponent;
	  }(_react2.default.Component);
	};
	
	var propTypes = {
	  tooltip: _propTypes2.default.shape(_Tooltip2.default.propTypes),
	  hideTooltipAfter: _propTypes2.default.number
	};
	
	var defaultProps = {
	  tooltip: _Tooltip2.default.defaultProps
	};
	
	var withTooltip = exports.withTooltip = function withTooltip(WrappedComponent) {
	  var dontModifyProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  // eslint-disable-next-line
	  var WithTooltip = function (_Component) {
	    _inherits(WithTooltip, _Component);
	
	    // tooltip container in another component
	    function WithTooltip(props) {
	      var _this3 = this;
	
	      _classCallCheck(this, WithTooltip);
	
	      var _this2 = _possibleConstructorReturn(this, (WithTooltip.__proto__ || Object.getPrototypeOf(WithTooltip)).call(this, props));
	
	      _this2.state = { visible: false, ref: null };
	      _this2._toggleTooltip = _this2.toggleTooltip.bind(_this2);
	      _this2._showTooltip = _this2.showTooltip.bind(_this2);
	      _this2._hideTooltip = _this2.hideTooltip.bind(_this2);
	      _this2._handleRef = _this2._handleRef.bind(_this2);
	      _this2._handleVisibleCallback = _this2._handleVisibleCallback.bind(_this2);
	
	      _this2.TooltipSlot = function (props) {
	
	        var mode = _this2.props.mode || 'dynamic';
	
	        return mode === "dynamic" ? _react2.default.createElement(
	          _DynamicTooltipSlot2.default,
	          { visible: _this2.state.visible },
	          props.children
	        ) : _react2.default.createElement(
	          _StaticTooltipSlot2.default,
	          _extends({
	            visible: _this2.state.visible,
	            closeOnOutsideClick: _this2.props.closeOnOutsideClick,
	            onVisibleCallback: _this2._handleVisibleCallback,
	            parent: _this2.state.ref,
	            hideTooltip: _this2._hideTooltip
	          }, _this2.props),
	          props.children
	        );
	      };
	
	      _this2.Tooltip = function (_ref) {
	        var children = _ref.children;
	        return _react2.default.createElement(
	          _this3.TooltipSlot,
	          null,
	          function (slotProps) {
	            return _react2.default.createElement(
	              _TooltipWrapper2.default,
	              slotProps,
	              children
	            );
	          }
	        );
	      };
	
	      _this2.WrappedComponent = wrapWithClass(WrappedComponent);
	      return _this2;
	    }
	
	    _createClass(WithTooltip, [{
	      key: "componentWillUnmount",
	      value: function componentWillUnmount() {
	        this.clearHideTimeout();
	      }
	    }, {
	      key: "setHideTimeout",
	      value: function setHideTimeout(time) {
	        this.tooltipHideTimeout = setTimeout(this._hideTooltip, time);
	      }
	    }, {
	      key: "_handleRef",
	      value: function _handleRef(ref) {
	        // eslint-disable-next-line
	        var targetRef = _reactDom2.default.findDOMNode(ref);
	        this.setState({ ref: targetRef });
	      }
	    }, {
	      key: "_handleVisibleCallback",
	      value: function _handleVisibleCallback(cb) {
	        this.setState({ visibleCallback: cb });
	      }
	    }, {
	      key: "toggleTooltip",
	      value: function toggleTooltip(show) {
	        var _this4 = this;
	
	        var visible = typeof show === "boolean" ? show : !this.state.visible;
	
	        var hideTooltipAfter = this.props.hideTooltipAfter;
	        var visibleCallback = this.state.visibleCallback;
	
	
	        var cb = !visibleCallback ? function () {} : function () {
	          return visibleCallback(_this4.state.visible);
	        };
	        this.setState({ visible: visible }, cb);
	
	        if (!(0, _reactackleCore.isUndef)(hideTooltipAfter)) {
	          if (visible) this.setHideTimeout(hideTooltipAfter);else this.clearHideTimeout();
	        }
	      }
	    }, {
	      key: "showTooltip",
	      value: function showTooltip() {
	        this._toggleTooltip(true);
	      }
	    }, {
	      key: "hideTooltip",
	      value: function hideTooltip() {
	        this._toggleTooltip(false);
	      }
	    }, {
	      key: "clearHideTimeout",
	      value: function clearHideTimeout() {
	        clearTimeout(this.tooltipHideTimeout);
	      }
	    }, {
	      key: "render",
	      value: function render() {
	        var WrappedComponent = this.WrappedComponent;
	        return _react2.default.createElement(WrappedComponent, _extends({}, this.props, {
	          ref: this._handleRef,
	          toggleTooltip: this._toggleTooltip,
	          showTooltip: this._showTooltip,
	          hideTooltip: this._hideTooltip,
	          Tooltip: this.Tooltip,
	          TooltipSlot: this.TooltipSlot,
	          isTooltipActive: this.state.visible
	        }));
	      }
	    }]);
	
	    return WithTooltip;
	  }(_react.Component);
	
	  WithTooltip.propTypes = _extends({}, WrappedComponent.propTypes, !dontModifyProps ? propTypes : {});
	
	  WithTooltip.defaultProps = _extends({}, WrappedComponent.defaultProps, !dontModifyProps ? defaultProps : {});
	
	  WithTooltip.displayName = "WithTooltip(" + WrappedComponent.displayName + ")";
	
	  ["toggleTooltip", "visible", "hideTooltip", "showTooltip", "isTooltipActive", "Tooltip"].forEach(function (propName) {
	    delete WithTooltip.propTypes[propName];
	    delete WithTooltip.defaultProps[propName];
	  });
	
	  return WithTooltip;
	};

/***/ }),
/* 886 */
489,
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = freeze;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _deepFreezeStrict = __webpack_require__(381);
	
	var _deepFreezeStrict2 = _interopRequireDefault(_deepFreezeStrict);
	
	/**
	 * Middleware that prevents state from being mutated anywhere in the app.
	 */
	
	function freeze(store) {
	  freezeStoreState(store);
	  return function (next) {
	    return function (action) {
	      freezeStoreState(store);
	      try {
	        return next(action);
	      } finally {
	        freezeStoreState(store);
	      }
	    };
	  };
	}
	
	function freezeStoreState(store) {
	  var state = store.getState();
	  if (isFreezable(state)) {
	    (0, _deepFreezeStrict2['default'])(state);
	  }
	}
	
	function isFreezable(value) {
	  return value !== null && typeof value === 'object';
	}
	module.exports = exports['default'];

/***/ }),
/* 888 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	function createThunkMiddleware(extraArgument) {
	  return function (_ref) {
	    var dispatch = _ref.dispatch,
	        getState = _ref.getState;
	    return function (next) {
	      return function (action) {
	        if (typeof action === 'function') {
	          return action(dispatch, getState, extraArgument);
	        }
	
	        return next(action);
	      };
	    };
	  };
	}
	
	var thunk = createThunkMiddleware();
	thunk.withExtraArgument = createThunkMiddleware;
	
	exports['default'] = thunk;

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = applyMiddleware;
	
	var _compose = __webpack_require__(239);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function (reducer, preloadedState, enhancer) {
	      var store = createStore(reducer, preloadedState, enhancer);
	      var _dispatch = store.dispatch;
	      var chain = [];
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch(action) {
	          return _dispatch(action);
	        }
	      };
	      chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = _compose2['default'].apply(undefined, chain)(store.dispatch);
	
	      return _extends({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}

/***/ }),
/* 890 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = bindActionCreators;
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(undefined, arguments));
	  };
	}
	
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass a single function as the first argument,
	 * and get a function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
	  }
	
	  var keys = Object.keys(actionCreators);
	  var boundActionCreators = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var actionCreator = actionCreators[key];
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	  return boundActionCreators;
	}

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = combineReducers;
	
	var _createStore = __webpack_require__(240);
	
	var _isPlainObject = __webpack_require__(243);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(241);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
	
	  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!(0, _isPlainObject2['default'])(inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
	  });
	
	  unexpectedKeys.forEach(function (key) {
	    unexpectedKeyCache[key] = true;
	  });
	
	  if (unexpectedKeys.length > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerShape(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	
	    if (false) {
	      if (typeof reducers[key] === 'undefined') {
	        (0, _warning2['default'])('No reducer provided for key "' + key + '"');
	      }
	    }
	
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	  var finalReducerKeys = Object.keys(finalReducers);
	
	  var unexpectedKeyCache = void 0;
	  if (false) {
	    unexpectedKeyCache = {};
	  }
	
	  var shapeAssertionError = void 0;
	  try {
	    assertReducerShape(finalReducers);
	  } catch (e) {
	    shapeAssertionError = e;
	  }
	
	  return function combination() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments[1];
	
	    if (shapeAssertionError) {
	      throw shapeAssertionError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
	      if (warningMessage) {
	        (0, _warning2['default'])(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
	      var _key = finalReducerKeys[_i];
	      var reducer = finalReducers[_key];
	      var previousStateForKey = state[_key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(_key, action);
	        throw new Error(errorMessage);
	      }
	      nextState[_key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	    return hasChanged ? nextState : state;
	  };
	}

/***/ }),
/* 892 */
[939, 242, 895, 896],
/* 893 */
461,
/* 894 */
[940, 897],
/* 895 */
[941, 242],
/* 896 */
464,
/* 897 */
465,
/* 898 */
[942, 893],
/* 899 */
467,
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	var runtime = (function (exports) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  function define(obj, key, value) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	    return obj[key];
	  }
	  try {
	    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
	    define({}, "");
	  } catch (err) {
	    define = function(obj, key, value) {
	      return obj[key] = value;
	    };
	  }
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  exports.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunction.displayName = define(
	    GeneratorFunctionPrototype,
	    toStringTagSymbol,
	    "GeneratorFunction"
	  );
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      define(prototype, method, function(arg) {
	        return this._invoke(method, arg);
	      });
	    });
	  }
	
	  exports.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  exports.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      define(genFun, toStringTagSymbol, "GeneratorFunction");
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  exports.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator, PromiseImpl) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return PromiseImpl.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return PromiseImpl.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration.
	          result.value = unwrapped;
	          resolve(result);
	        }, function(error) {
	          // If a rejected Promise was yielded, throw the rejection back
	          // into the async generator function so it can be handled there.
	          return invoke("throw", error, resolve, reject);
	        });
	      }
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new PromiseImpl(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  exports.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
	    if (PromiseImpl === void 0) PromiseImpl = Promise;
	
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList),
	      PromiseImpl
	    );
	
	    return exports.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        // Note: ["return"] must be used for ES3 parsing compatibility.
	        if (delegate.iterator["return"]) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  define(Gp, toStringTagSymbol, "Generator");
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  exports.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  exports.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	
	  // Regardless of whether this script is executing as a CommonJS module
	  // or not, return the runtime object so that we can declare the variable
	  // regeneratorRuntime in the outer scope, which allows this module to be
	  // injected easily by `bin/regenerator --include-runtime script.js`.
	  return exports;
	
	}(
	  // If this script is executing as a CommonJS module, use module.exports
	  // as the regeneratorRuntime namespace. Otherwise create a new empty
	  // object. Either way, the resulting object will be used to initialize
	  // the regeneratorRuntime variable at the top of this file.
	   true ? module.exports : {}
	));
	
	try {
	  regeneratorRuntime = runtime;
	} catch (accidentalStrictMode) {
	  // This module should not be running in strict mode, so the above
	  // assignment should always work unless something is misconfigured. Just
	  // in case runtime.js accidentally runs in strict mode, we can escape
	  // strict mode using a global Function call. This could conceivably fail
	  // if a Content Security Policy forbids using Function, but in that case
	  // the proper solution is to fix the accidental strict mode problem. If
	  // you've misconfigured your bundler to force strict mode and applied a
	  // CSP to forbid Function, and you're not willing to fix either of those
	  // problems, please detail your unique predicament in a GitHub issue.
	  Function("r", "regeneratorRuntime = r")(runtime);
	}


/***/ }),
/* 901 */
/***/ (function(module, exports) {

	/** @license React v0.16.1
	 * scheduler.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';Object.defineProperty(exports,"__esModule",{value:!0});var f,g,h,k,l;
	if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
	y=window.setTimeout,z=window.clearTimeout,A=window.requestAnimationFrame,B=window.cancelAnimationFrame;"undefined"!==typeof console&&("function"!==typeof A&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"),"function"!==typeof B&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"));if("object"===typeof w&&
	"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var C=x.now();exports.unstable_now=function(){return x.now()-C}}var D=!1,E=null,F=-1,G=5,H=0;k=function(){return exports.unstable_now()>=H};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):G=0<a?Math.floor(1E3/a):33.33};var I=new MessageChannel,J=I.port2;I.port1.onmessage=
	function(){if(null!==E){var a=exports.unstable_now();H=a+G;try{E(!0,a)?J.postMessage(null):(D=!1,E=null)}catch(b){throw J.postMessage(null),b;}}else D=!1};f=function(a){E=a;D||(D=!0,J.postMessage(null))};g=function(a,b){F=y(function(){a(exports.unstable_now())},b)};h=function(){z(F);F=-1}}function K(a,b){var c=a.length;a.push(b);a:for(;;){var d=Math.floor((c-1)/2),e=a[d];if(void 0!==e&&0<L(e,b))a[d]=b,a[c]=e,c=d;else break a}}function M(a){a=a[0];return void 0===a?null:a}
	function N(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>L(n,c))void 0!==r&&0>L(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>L(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function L(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var O=[],P=[],Q=1,R=null,S=3,T=!1,U=!1,V=!1;
	function W(a){for(var b=M(P);null!==b;){if(null===b.callback)N(P);else if(b.startTime<=a)N(P),b.sortIndex=b.expirationTime,K(O,b);else break;b=M(P)}}function X(a){V=!1;W(a);if(!U)if(null!==M(O))U=!0,f(Y);else{var b=M(P);null!==b&&g(X,b.startTime-a)}}
	function Y(a,b){U=!1;V&&(V=!1,h());T=!0;var c=S;try{W(b);for(R=M(O);null!==R&&(!(R.expirationTime>b)||a&&!k());){var d=R.callback;if(null!==d){R.callback=null;S=R.priorityLevel;var e=d(R.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?R.callback=e:R===M(O)&&N(O);W(b)}else N(O);R=M(O)}if(null!==R)var m=!0;else{var n=M(P);null!==n&&g(X,n.startTime-b);m=!1}return m}finally{R=null,S=c,T=!1}}
	function Z(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var aa=l;exports.unstable_ImmediatePriority=1;exports.unstable_UserBlockingPriority=2;exports.unstable_NormalPriority=3;exports.unstable_IdlePriority=5;exports.unstable_LowPriority=4;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=S;S=a;try{return b()}finally{S=c}};
	exports.unstable_next=function(a){switch(S){case 1:case 2:case 3:var b=3;break;default:b=S}var c=S;S=b;try{return a()}finally{S=c}};
	exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Z(a)}else c=Z(a),e=d;c=e+c;a={id:Q++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,K(P,a),null===M(O)&&a===M(P)&&(V?h():V=!0,g(X,e-d))):(a.sortIndex=c,K(O,a),U||T||(U=!0,f(Y)));return a};exports.unstable_cancelCallback=function(a){a.callback=null};
	exports.unstable_wrapCallback=function(a){var b=S;return function(){var c=S;S=b;try{return a.apply(this,arguments)}finally{S=c}}};exports.unstable_getCurrentPriorityLevel=function(){return S};exports.unstable_shouldYield=function(){var a=exports.unstable_now();W(a);var b=M(O);return b!==R&&null!==R&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<R.expirationTime||k()};exports.unstable_requestPaint=aa;exports.unstable_continueExecution=function(){U||T||(U=!0,f(Y))};
	exports.unstable_pauseExecution=function(){};exports.unstable_getFirstCallbackNode=function(){return M(O)};exports.unstable_Profiling=null;


/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(901);
	} else {
	  module.exports = require('./cjs/scheduler.development.js');
	}


/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * Signature Pad v2.3.2
	 * https://github.com/szimek/signature_pad
	 *
	 * Copyright 2017 Szymon Nowak
	 * Released under the MIT license
	 *
	 * The main idea and some parts of the code (e.g. drawing variable width Bézier curve) are taken from:
	 * http://corner.squareup.com/2012/07/smoother-signatures.html
	 *
	 * Implementation of interpolation using cubic Bézier curves is taken from:
	 * http://benknowscode.wordpress.com/2012/09/14/path-interpolation-using-cubic-bezier-and-control-point-estimation-in-javascript
	 *
	 * Algorithm for approximated length of a Bézier curve is taken from:
	 * http://www.lemoda.net/maths/bezier-length/index.html
	 *
	 */
	
	(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.SignaturePad = factory());
	}(this, (function () { 'use strict';
	
	function Point(x, y, time) {
	  this.x = x;
	  this.y = y;
	  this.time = time || new Date().getTime();
	}
	
	Point.prototype.velocityFrom = function (start) {
	  return this.time !== start.time ? this.distanceTo(start) / (this.time - start.time) : 1;
	};
	
	Point.prototype.distanceTo = function (start) {
	  return Math.sqrt(Math.pow(this.x - start.x, 2) + Math.pow(this.y - start.y, 2));
	};
	
	Point.prototype.equals = function (other) {
	  return this.x === other.x && this.y === other.y && this.time === other.time;
	};
	
	function Bezier(startPoint, control1, control2, endPoint) {
	  this.startPoint = startPoint;
	  this.control1 = control1;
	  this.control2 = control2;
	  this.endPoint = endPoint;
	}
	
	// Returns approximated length.
	Bezier.prototype.length = function () {
	  var steps = 10;
	  var length = 0;
	  var px = void 0;
	  var py = void 0;
	
	  for (var i = 0; i <= steps; i += 1) {
	    var t = i / steps;
	    var cx = this._point(t, this.startPoint.x, this.control1.x, this.control2.x, this.endPoint.x);
	    var cy = this._point(t, this.startPoint.y, this.control1.y, this.control2.y, this.endPoint.y);
	    if (i > 0) {
	      var xdiff = cx - px;
	      var ydiff = cy - py;
	      length += Math.sqrt(xdiff * xdiff + ydiff * ydiff);
	    }
	    px = cx;
	    py = cy;
	  }
	
	  return length;
	};
	
	/* eslint-disable no-multi-spaces, space-in-parens */
	Bezier.prototype._point = function (t, start, c1, c2, end) {
	  return start * (1.0 - t) * (1.0 - t) * (1.0 - t) + 3.0 * c1 * (1.0 - t) * (1.0 - t) * t + 3.0 * c2 * (1.0 - t) * t * t + end * t * t * t;
	};
	
	/* eslint-disable */
	
	// http://stackoverflow.com/a/27078401/815507
	function throttle(func, wait, options) {
	  var context, args, result;
	  var timeout = null;
	  var previous = 0;
	  if (!options) options = {};
	  var later = function later() {
	    previous = options.leading === false ? 0 : Date.now();
	    timeout = null;
	    result = func.apply(context, args);
	    if (!timeout) context = args = null;
	  };
	  return function () {
	    var now = Date.now();
	    if (!previous && options.leading === false) previous = now;
	    var remaining = wait - (now - previous);
	    context = this;
	    args = arguments;
	    if (remaining <= 0 || remaining > wait) {
	      if (timeout) {
	        clearTimeout(timeout);
	        timeout = null;
	      }
	      previous = now;
	      result = func.apply(context, args);
	      if (!timeout) context = args = null;
	    } else if (!timeout && options.trailing !== false) {
	      timeout = setTimeout(later, remaining);
	    }
	    return result;
	  };
	}
	
	function SignaturePad(canvas, options) {
	  var self = this;
	  var opts = options || {};
	
	  this.velocityFilterWeight = opts.velocityFilterWeight || 0.7;
	  this.minWidth = opts.minWidth || 0.5;
	  this.maxWidth = opts.maxWidth || 2.5;
	  this.throttle = 'throttle' in opts ? opts.throttle : 16; // in miliseconds
	  this.minDistance = 'minDistance' in opts ? opts.minDistance : 5;
	
	  if (this.throttle) {
	    this._strokeMoveUpdate = throttle(SignaturePad.prototype._strokeUpdate, this.throttle);
	  } else {
	    this._strokeMoveUpdate = SignaturePad.prototype._strokeUpdate;
	  }
	
	  this.dotSize = opts.dotSize || function () {
	    return (this.minWidth + this.maxWidth) / 2;
	  };
	  this.penColor = opts.penColor || 'black';
	  this.backgroundColor = opts.backgroundColor || 'rgba(0,0,0,0)';
	  this.onBegin = opts.onBegin;
	  this.onEnd = opts.onEnd;
	
	  this._canvas = canvas;
	  this._ctx = canvas.getContext('2d');
	  this.clear();
	
	  // We need add these inline so they are available to unbind while still having
	  // access to 'self' we could use _.bind but it's not worth adding a dependency.
	  this._handleMouseDown = function (event) {
	    if (event.which === 1) {
	      self._mouseButtonDown = true;
	      self._strokeBegin(event);
	    }
	  };
	
	  this._handleMouseMove = function (event) {
	    if (self._mouseButtonDown) {
	      self._strokeMoveUpdate(event);
	    }
	  };
	
	  this._handleMouseUp = function (event) {
	    if (event.which === 1 && self._mouseButtonDown) {
	      self._mouseButtonDown = false;
	      self._strokeEnd(event);
	    }
	  };
	
	  this._handleTouchStart = function (event) {
	    if (event.targetTouches.length === 1) {
	      var touch = event.changedTouches[0];
	      self._strokeBegin(touch);
	    }
	  };
	
	  this._handleTouchMove = function (event) {
	    // Prevent scrolling.
	    event.preventDefault();
	
	    var touch = event.targetTouches[0];
	    self._strokeMoveUpdate(touch);
	  };
	
	  this._handleTouchEnd = function (event) {
	    var wasCanvasTouched = event.target === self._canvas;
	    if (wasCanvasTouched) {
	      event.preventDefault();
	      self._strokeEnd(event);
	    }
	  };
	
	  // Enable mouse and touch event handlers
	  this.on();
	}
	
	// Public methods
	SignaturePad.prototype.clear = function () {
	  var ctx = this._ctx;
	  var canvas = this._canvas;
	
	  ctx.fillStyle = this.backgroundColor;
	  ctx.clearRect(0, 0, canvas.width, canvas.height);
	  ctx.fillRect(0, 0, canvas.width, canvas.height);
	
	  this._data = [];
	  this._reset();
	  this._isEmpty = true;
	};
	
	SignaturePad.prototype.fromDataURL = function (dataUrl) {
	  var _this = this;
	
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  var image = new Image();
	  var ratio = options.ratio || window.devicePixelRatio || 1;
	  var width = options.width || this._canvas.width / ratio;
	  var height = options.height || this._canvas.height / ratio;
	
	  this._reset();
	  image.src = dataUrl;
	  image.onload = function () {
	    _this._ctx.drawImage(image, 0, 0, width, height);
	  };
	  this._isEmpty = false;
	};
	
	SignaturePad.prototype.toDataURL = function (type) {
	  var _canvas;
	
	  switch (type) {
	    case 'image/svg+xml':
	      return this._toSVG();
	    default:
	      for (var _len = arguments.length, options = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        options[_key - 1] = arguments[_key];
	      }
	
	      return (_canvas = this._canvas).toDataURL.apply(_canvas, [type].concat(options));
	  }
	};
	
	SignaturePad.prototype.on = function () {
	  this._handleMouseEvents();
	  this._handleTouchEvents();
	};
	
	SignaturePad.prototype.off = function () {
	  this._canvas.removeEventListener('mousedown', this._handleMouseDown);
	  this._canvas.removeEventListener('mousemove', this._handleMouseMove);
	  document.removeEventListener('mouseup', this._handleMouseUp);
	
	  this._canvas.removeEventListener('touchstart', this._handleTouchStart);
	  this._canvas.removeEventListener('touchmove', this._handleTouchMove);
	  this._canvas.removeEventListener('touchend', this._handleTouchEnd);
	};
	
	SignaturePad.prototype.isEmpty = function () {
	  return this._isEmpty;
	};
	
	// Private methods
	SignaturePad.prototype._strokeBegin = function (event) {
	  this._data.push([]);
	  this._reset();
	  this._strokeUpdate(event);
	
	  if (typeof this.onBegin === 'function') {
	    this.onBegin(event);
	  }
	};
	
	SignaturePad.prototype._strokeUpdate = function (event) {
	  var x = event.clientX;
	  var y = event.clientY;
	
	  var point = this._createPoint(x, y);
	  var lastPointGroup = this._data[this._data.length - 1];
	  var lastPoint = lastPointGroup && lastPointGroup[lastPointGroup.length - 1];
	  var isLastPointTooClose = lastPoint && point.distanceTo(lastPoint) < this.minDistance;
	
	  // Skip this point if it's too close to the previous one
	  if (!(lastPoint && isLastPointTooClose)) {
	    var _addPoint = this._addPoint(point),
	        curve = _addPoint.curve,
	        widths = _addPoint.widths;
	
	    if (curve && widths) {
	      this._drawCurve(curve, widths.start, widths.end);
	    }
	
	    this._data[this._data.length - 1].push({
	      x: point.x,
	      y: point.y,
	      time: point.time,
	      color: this.penColor
	    });
	  }
	};
	
	SignaturePad.prototype._strokeEnd = function (event) {
	  var canDrawCurve = this.points.length > 2;
	  var point = this.points[0]; // Point instance
	
	  if (!canDrawCurve && point) {
	    this._drawDot(point);
	  }
	
	  if (point) {
	    var lastPointGroup = this._data[this._data.length - 1];
	    var lastPoint = lastPointGroup[lastPointGroup.length - 1]; // plain object
	
	    // When drawing a dot, there's only one point in a group, so without this check
	    // such group would end up with exactly the same 2 points.
	    if (!point.equals(lastPoint)) {
	      lastPointGroup.push({
	        x: point.x,
	        y: point.y,
	        time: point.time,
	        color: this.penColor
	      });
	    }
	  }
	
	  if (typeof this.onEnd === 'function') {
	    this.onEnd(event);
	  }
	};
	
	SignaturePad.prototype._handleMouseEvents = function () {
	  this._mouseButtonDown = false;
	
	  this._canvas.addEventListener('mousedown', this._handleMouseDown);
	  this._canvas.addEventListener('mousemove', this._handleMouseMove);
	  document.addEventListener('mouseup', this._handleMouseUp);
	};
	
	SignaturePad.prototype._handleTouchEvents = function () {
	  // Pass touch events to canvas element on mobile IE11 and Edge.
	  this._canvas.style.msTouchAction = 'none';
	  this._canvas.style.touchAction = 'none';
	
	  this._canvas.addEventListener('touchstart', this._handleTouchStart);
	  this._canvas.addEventListener('touchmove', this._handleTouchMove);
	  this._canvas.addEventListener('touchend', this._handleTouchEnd);
	};
	
	SignaturePad.prototype._reset = function () {
	  this.points = [];
	  this._lastVelocity = 0;
	  this._lastWidth = (this.minWidth + this.maxWidth) / 2;
	  this._ctx.fillStyle = this.penColor;
	};
	
	SignaturePad.prototype._createPoint = function (x, y, time) {
	  var rect = this._canvas.getBoundingClientRect();
	
	  return new Point(x - rect.left, y - rect.top, time || new Date().getTime());
	};
	
	SignaturePad.prototype._addPoint = function (point) {
	  var points = this.points;
	  var tmp = void 0;
	
	  points.push(point);
	
	  if (points.length > 2) {
	    // To reduce the initial lag make it work with 3 points
	    // by copying the first point to the beginning.
	    if (points.length === 3) points.unshift(points[0]);
	
	    tmp = this._calculateCurveControlPoints(points[0], points[1], points[2]);
	    var c2 = tmp.c2;
	    tmp = this._calculateCurveControlPoints(points[1], points[2], points[3]);
	    var c3 = tmp.c1;
	    var curve = new Bezier(points[1], c2, c3, points[2]);
	    var widths = this._calculateCurveWidths(curve);
	
	    // Remove the first element from the list,
	    // so that we always have no more than 4 points in points array.
	    points.shift();
	
	    return { curve: curve, widths: widths };
	  }
	
	  return {};
	};
	
	SignaturePad.prototype._calculateCurveControlPoints = function (s1, s2, s3) {
	  var dx1 = s1.x - s2.x;
	  var dy1 = s1.y - s2.y;
	  var dx2 = s2.x - s3.x;
	  var dy2 = s2.y - s3.y;
	
	  var m1 = { x: (s1.x + s2.x) / 2.0, y: (s1.y + s2.y) / 2.0 };
	  var m2 = { x: (s2.x + s3.x) / 2.0, y: (s2.y + s3.y) / 2.0 };
	
	  var l1 = Math.sqrt(dx1 * dx1 + dy1 * dy1);
	  var l2 = Math.sqrt(dx2 * dx2 + dy2 * dy2);
	
	  var dxm = m1.x - m2.x;
	  var dym = m1.y - m2.y;
	
	  var k = l2 / (l1 + l2);
	  var cm = { x: m2.x + dxm * k, y: m2.y + dym * k };
	
	  var tx = s2.x - cm.x;
	  var ty = s2.y - cm.y;
	
	  return {
	    c1: new Point(m1.x + tx, m1.y + ty),
	    c2: new Point(m2.x + tx, m2.y + ty)
	  };
	};
	
	SignaturePad.prototype._calculateCurveWidths = function (curve) {
	  var startPoint = curve.startPoint;
	  var endPoint = curve.endPoint;
	  var widths = { start: null, end: null };
	
	  var velocity = this.velocityFilterWeight * endPoint.velocityFrom(startPoint) + (1 - this.velocityFilterWeight) * this._lastVelocity;
	
	  var newWidth = this._strokeWidth(velocity);
	
	  widths.start = this._lastWidth;
	  widths.end = newWidth;
	
	  this._lastVelocity = velocity;
	  this._lastWidth = newWidth;
	
	  return widths;
	};
	
	SignaturePad.prototype._strokeWidth = function (velocity) {
	  return Math.max(this.maxWidth / (velocity + 1), this.minWidth);
	};
	
	SignaturePad.prototype._drawPoint = function (x, y, size) {
	  var ctx = this._ctx;
	
	  ctx.moveTo(x, y);
	  ctx.arc(x, y, size, 0, 2 * Math.PI, false);
	  this._isEmpty = false;
	};
	
	SignaturePad.prototype._drawCurve = function (curve, startWidth, endWidth) {
	  var ctx = this._ctx;
	  var widthDelta = endWidth - startWidth;
	  var drawSteps = Math.floor(curve.length());
	
	  ctx.beginPath();
	
	  for (var i = 0; i < drawSteps; i += 1) {
	    // Calculate the Bezier (x, y) coordinate for this step.
	    var t = i / drawSteps;
	    var tt = t * t;
	    var ttt = tt * t;
	    var u = 1 - t;
	    var uu = u * u;
	    var uuu = uu * u;
	
	    var x = uuu * curve.startPoint.x;
	    x += 3 * uu * t * curve.control1.x;
	    x += 3 * u * tt * curve.control2.x;
	    x += ttt * curve.endPoint.x;
	
	    var y = uuu * curve.startPoint.y;
	    y += 3 * uu * t * curve.control1.y;
	    y += 3 * u * tt * curve.control2.y;
	    y += ttt * curve.endPoint.y;
	
	    var width = startWidth + ttt * widthDelta;
	    this._drawPoint(x, y, width);
	  }
	
	  ctx.closePath();
	  ctx.fill();
	};
	
	SignaturePad.prototype._drawDot = function (point) {
	  var ctx = this._ctx;
	  var width = typeof this.dotSize === 'function' ? this.dotSize() : this.dotSize;
	
	  ctx.beginPath();
	  this._drawPoint(point.x, point.y, width);
	  ctx.closePath();
	  ctx.fill();
	};
	
	SignaturePad.prototype._fromData = function (pointGroups, drawCurve, drawDot) {
	  for (var i = 0; i < pointGroups.length; i += 1) {
	    var group = pointGroups[i];
	
	    if (group.length > 1) {
	      for (var j = 0; j < group.length; j += 1) {
	        var rawPoint = group[j];
	        var point = new Point(rawPoint.x, rawPoint.y, rawPoint.time);
	        var color = rawPoint.color;
	
	        if (j === 0) {
	          // First point in a group. Nothing to draw yet.
	
	          // All points in the group have the same color, so it's enough to set
	          // penColor just at the beginning.
	          this.penColor = color;
	          this._reset();
	
	          this._addPoint(point);
	        } else if (j !== group.length - 1) {
	          // Middle point in a group.
	          var _addPoint2 = this._addPoint(point),
	              curve = _addPoint2.curve,
	              widths = _addPoint2.widths;
	
	          if (curve && widths) {
	            drawCurve(curve, widths, color);
	          }
	        } else {
	          // Last point in a group. Do nothing.
	        }
	      }
	    } else {
	      this._reset();
	      var _rawPoint = group[0];
	      drawDot(_rawPoint);
	    }
	  }
	};
	
	SignaturePad.prototype._toSVG = function () {
	  var _this2 = this;
	
	  var pointGroups = this._data;
	  var canvas = this._canvas;
	  var ratio = Math.max(window.devicePixelRatio || 1, 1);
	  var minX = 0;
	  var minY = 0;
	  var maxX = canvas.width / ratio;
	  var maxY = canvas.height / ratio;
	  var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
	
	  svg.setAttributeNS(null, 'width', canvas.width);
	  svg.setAttributeNS(null, 'height', canvas.height);
	
	  this._fromData(pointGroups, function (curve, widths, color) {
	    var path = document.createElement('path');
	
	    // Need to check curve for NaN values, these pop up when drawing
	    // lines on the canvas that are not continuous. E.g. Sharp corners
	    // or stopping mid-stroke and than continuing without lifting mouse.
	    if (!isNaN(curve.control1.x) && !isNaN(curve.control1.y) && !isNaN(curve.control2.x) && !isNaN(curve.control2.y)) {
	      var attr = 'M ' + curve.startPoint.x.toFixed(3) + ',' + curve.startPoint.y.toFixed(3) + ' ' + ('C ' + curve.control1.x.toFixed(3) + ',' + curve.control1.y.toFixed(3) + ' ') + (curve.control2.x.toFixed(3) + ',' + curve.control2.y.toFixed(3) + ' ') + (curve.endPoint.x.toFixed(3) + ',' + curve.endPoint.y.toFixed(3));
	
	      path.setAttribute('d', attr);
	      path.setAttribute('stroke-width', (widths.end * 2.25).toFixed(3));
	      path.setAttribute('stroke', color);
	      path.setAttribute('fill', 'none');
	      path.setAttribute('stroke-linecap', 'round');
	
	      svg.appendChild(path);
	    }
	  }, function (rawPoint) {
	    var circle = document.createElement('circle');
	    var dotSize = typeof _this2.dotSize === 'function' ? _this2.dotSize() : _this2.dotSize;
	    circle.setAttribute('r', dotSize);
	    circle.setAttribute('cx', rawPoint.x);
	    circle.setAttribute('cy', rawPoint.y);
	    circle.setAttribute('fill', rawPoint.color);
	
	    svg.appendChild(circle);
	  });
	
	  var prefix = 'data:image/svg+xml;base64,';
	  var header = '<svg' + ' xmlns="http://www.w3.org/2000/svg"' + ' xmlns:xlink="http://www.w3.org/1999/xlink"' + (' viewBox="' + minX + ' ' + minY + ' ' + maxX + ' ' + maxY + '"') + (' width="' + maxX + '"') + (' height="' + maxY + '"') + '>';
	  var body = svg.innerHTML;
	
	  // IE hack for missing innerHTML property on SVGElement
	  if (body === undefined) {
	    var dummy = document.createElement('dummy');
	    var nodes = svg.childNodes;
	    dummy.innerHTML = '';
	
	    for (var i = 0; i < nodes.length; i += 1) {
	      dummy.appendChild(nodes[i].cloneNode(true));
	    }
	
	    body = dummy.innerHTML;
	  }
	
	  var footer = '</svg>';
	  var data = header + body + footer;
	
	  return prefix + btoa(data);
	};
	
	SignaturePad.prototype.fromData = function (pointGroups) {
	  var _this3 = this;
	
	  this.clear();
	
	  this._fromData(pointGroups, function (curve, widths) {
	    return _this3._drawCurve(curve, widths.start, widths.end);
	  }, function (rawPoint) {
	    return _this3._drawDot(rawPoint);
	  });
	
	  this._data = pointGroups;
	};
	
	SignaturePad.prototype.toData = function () {
	  return this._data;
	};
	
	return SignaturePad;
	
	})));


/***/ }),
/* 904 */
/***/ (function(module, exports) {

	module.exports = function isArrayish(obj) {
		if (!obj || typeof obj === 'string') {
			return false;
		}
	
		return obj instanceof Array || Array.isArray(obj) ||
			(obj.length >= 0 && (obj.splice instanceof Function ||
				(Object.getOwnPropertyDescriptor(obj, (obj.length - 1)) && obj.constructor.name !== 'String')));
	};


/***/ }),
/* 905 */
/***/ (function(module, exports) {

	'use strict';
	
	var Sister;
	
	/**
	* @link https://github.com/gajus/sister for the canonical source repository
	* @license https://github.com/gajus/sister/blob/master/LICENSE BSD 3-Clause
	*/
	Sister = function () {
	    var sister = {},
	        events = {};
	
	    /**
	     * @name handler
	     * @function
	     * @param {Object} data Event data.
	     */
	
	    /**
	     * @param {String} name Event name.
	     * @param {handler} handler
	     * @return {listener}
	     */
	    sister.on = function (name, handler) {
	        var listener = {name: name, handler: handler};
	        events[name] = events[name] || [];
	        events[name].unshift(listener);
	        return listener;
	    };
	
	    /**
	     * @param {listener}
	     */
	    sister.off = function (listener) {
	        var index = events[listener.name].indexOf(listener);
	
	        if (index !== -1) {
	            events[listener.name].splice(index, 1);
	        }
	    };
	
	    /**
	     * @param {String} name Event name.
	     * @param {Object} data Event data.
	     */
	    sister.trigger = function (name, data) {
	        var listeners = events[name],
	            i;
	
	        if (listeners) {
	            i = listeners.length;
	            while (i--) {
	                listeners[i].handler(data);
	            }
	        }
	    };
	
	    return sister;
	};
	
	module.exports = Sister;


/***/ }),
/* 906 */
/***/ (function(module, exports) {

	'use strict';
	module.exports = function (str) {
		return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
			return '%' + c.charCodeAt(0).toString(16).toUpperCase();
		});
	};


/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(367);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(20)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../css-loader/index.js!./firebaseui.css", function() {
				var newContent = require("!!../../css-loader/index.js!./firebaseui.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(368);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(20)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../css-loader/index.js!./Calendar.css", function() {
				var newContent = require("!!../../css-loader/index.js!./Calendar.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(369);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(20)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../css-loader/index.js!./Clock.css", function() {
				var newContent = require("!!../../css-loader/index.js!./Clock.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(374);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(20)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!./sigpad.css", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!./sigpad.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(375);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(20)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!./login.css", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!./login.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(377);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(20)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!./index_home.css", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!./index_home.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(378);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(20)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!./DateTimePicker.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!./DateTimePicker.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {(function (factory) {
		 true ? (module['exports'] = factory()) :
			typeof define === 'function' && define['amd'] ? define(factory()) :
				(window['stylisRuleSheet'] = factory())
	}(function () {
	
		'use strict'
	
		return function (insertRule) {
			var delimiter = '/*|*/'
			var needle = delimiter+'}'
	
			function toSheet (block) {
				if (block)
					try {
						insertRule(block + '}')
					} catch (e) {}
			}
	
			return function ruleSheet (context, content, selectors, parents, line, column, length, ns, depth, at) {
				switch (context) {
					// property
					case 1:
						// @import
						if (depth === 0 && content.charCodeAt(0) === 64)
							return insertRule(content+';'), ''
						break
					// selector
					case 2:
						if (ns === 0)
							return content + delimiter
						break
					// at-rule
					case 3:
						switch (ns) {
							// @font-face, @page
							case 102:
							case 112:
								return insertRule(selectors[0]+content), ''
							default:
								return content + (at === 0 ? delimiter : '')
						}
					case -2:
						content.split(needle).forEach(toSheet)
				}
			}
		}
	}))
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(33)(module)))

/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

	!function(e){ true?module.exports=e(null):"function"==typeof define&&define.amd?define(e(null)):window.stylis=e(null)}(function e(a){"use strict";var r=/^\0+/g,c=/[\0\r\f]/g,s=/: */g,t=/zoo|gra/,i=/([,: ])(transform)/g,f=/,+\s*(?![^(]*[)])/g,n=/ +\s*(?![^(]*[)])/g,l=/ *[\0] */g,o=/,\r+?/g,h=/([\t\r\n ])*\f?&/g,u=/:global\(((?:[^\(\)\[\]]*|\[.*\]|\([^\(\)]*\))*)\)/g,d=/\W+/g,b=/@(k\w+)\s*(\S*)\s*/,p=/::(place)/g,k=/:(read-only)/g,g=/\s+(?=[{\];=:>])/g,A=/([[}=:>])\s+/g,C=/(\{[^{]+?);(?=\})/g,w=/\s{2,}/g,v=/([^\(])(:+) */g,m=/[svh]\w+-[tblr]{2}/,x=/\(\s*(.*)\s*\)/g,$=/([\s\S]*?);/g,y=/-self|flex-/g,O=/[^]*?(:[rp][el]a[\w-]+)[^]*/,j=/stretch|:\s*\w+\-(?:conte|avail)/,z=/([^-])(image-set\()/,N="-webkit-",S="-moz-",F="-ms-",W=59,q=125,B=123,D=40,E=41,G=91,H=93,I=10,J=13,K=9,L=64,M=32,P=38,Q=45,R=95,T=42,U=44,V=58,X=39,Y=34,Z=47,_=62,ee=43,ae=126,re=0,ce=12,se=11,te=107,ie=109,fe=115,ne=112,le=111,oe=105,he=99,ue=100,de=112,be=1,pe=1,ke=0,ge=1,Ae=1,Ce=1,we=0,ve=0,me=0,xe=[],$e=[],ye=0,Oe=null,je=-2,ze=-1,Ne=0,Se=1,Fe=2,We=3,qe=0,Be=1,De="",Ee="",Ge="";function He(e,a,s,t,i){for(var f,n,o=0,h=0,u=0,d=0,g=0,A=0,C=0,w=0,m=0,$=0,y=0,O=0,j=0,z=0,R=0,we=0,$e=0,Oe=0,je=0,ze=s.length,Je=ze-1,Re="",Te="",Ue="",Ve="",Xe="",Ye="";R<ze;){if(C=s.charCodeAt(R),R===Je)if(h+d+u+o!==0){if(0!==h)C=h===Z?I:Z;d=u=o=0,ze++,Je++}if(h+d+u+o===0){if(R===Je){if(we>0)Te=Te.replace(c,"");if(Te.trim().length>0){switch(C){case M:case K:case W:case J:case I:break;default:Te+=s.charAt(R)}C=W}}if(1===$e)switch(C){case B:case q:case W:case Y:case X:case D:case E:case U:$e=0;case K:case J:case I:case M:break;default:for($e=0,je=R,g=C,R--,C=W;je<ze;)switch(s.charCodeAt(je++)){case I:case J:case W:++R,C=g,je=ze;break;case V:if(we>0)++R,C=g;case B:je=ze}}switch(C){case B:for(g=(Te=Te.trim()).charCodeAt(0),y=1,je=++R;R<ze;){switch(C=s.charCodeAt(R)){case B:y++;break;case q:y--;break;case Z:switch(A=s.charCodeAt(R+1)){case T:case Z:R=Qe(A,R,Je,s)}break;case G:C++;case D:C++;case Y:case X:for(;R++<Je&&s.charCodeAt(R)!==C;);}if(0===y)break;R++}if(Ue=s.substring(je,R),g===re)g=(Te=Te.replace(r,"").trim()).charCodeAt(0);switch(g){case L:if(we>0)Te=Te.replace(c,"");switch(A=Te.charCodeAt(1)){case ue:case ie:case fe:case Q:f=a;break;default:f=xe}if(je=(Ue=He(a,f,Ue,A,i+1)).length,me>0&&0===je)je=Te.length;if(ye>0)if(f=Ie(xe,Te,Oe),n=Pe(We,Ue,f,a,pe,be,je,A,i,t),Te=f.join(""),void 0!==n)if(0===(je=(Ue=n.trim()).length))A=0,Ue="";if(je>0)switch(A){case fe:Te=Te.replace(x,Me);case ue:case ie:case Q:Ue=Te+"{"+Ue+"}";break;case te:if(Ue=(Te=Te.replace(b,"$1 $2"+(Be>0?De:"")))+"{"+Ue+"}",1===Ae||2===Ae&&Le("@"+Ue,3))Ue="@"+N+Ue+"@"+Ue;else Ue="@"+Ue;break;default:if(Ue=Te+Ue,t===de)Ve+=Ue,Ue=""}else Ue="";break;default:Ue=He(a,Ie(a,Te,Oe),Ue,t,i+1)}Xe+=Ue,O=0,$e=0,z=0,we=0,Oe=0,j=0,Te="",Ue="",C=s.charCodeAt(++R);break;case q:case W:if((je=(Te=(we>0?Te.replace(c,""):Te).trim()).length)>1){if(0===z)if((g=Te.charCodeAt(0))===Q||g>96&&g<123)je=(Te=Te.replace(" ",":")).length;if(ye>0)if(void 0!==(n=Pe(Se,Te,a,e,pe,be,Ve.length,t,i,t)))if(0===(je=(Te=n.trim()).length))Te="\0\0";switch(g=Te.charCodeAt(0),A=Te.charCodeAt(1),g){case re:break;case L:if(A===oe||A===he){Ye+=Te+s.charAt(R);break}default:if(Te.charCodeAt(je-1)===V)break;Ve+=Ke(Te,g,A,Te.charCodeAt(2))}}O=0,$e=0,z=0,we=0,Oe=0,Te="",C=s.charCodeAt(++R)}}switch(C){case J:case I:if(h+d+u+o+ve===0)switch($){case E:case X:case Y:case L:case ae:case _:case T:case ee:case Z:case Q:case V:case U:case W:case B:case q:break;default:if(z>0)$e=1}if(h===Z)h=0;else if(ge+O===0&&t!==te&&Te.length>0)we=1,Te+="\0";if(ye*qe>0)Pe(Ne,Te,a,e,pe,be,Ve.length,t,i,t);be=1,pe++;break;case W:case q:if(h+d+u+o===0){be++;break}default:switch(be++,Re=s.charAt(R),C){case K:case M:if(d+o+h===0)switch(w){case U:case V:case K:case M:Re="";break;default:if(C!==M)Re=" "}break;case re:Re="\\0";break;case ce:Re="\\f";break;case se:Re="\\v";break;case P:if(d+h+o===0&&ge>0)Oe=1,we=1,Re="\f"+Re;break;case 108:if(d+h+o+ke===0&&z>0)switch(R-z){case 2:if(w===ne&&s.charCodeAt(R-3)===V)ke=w;case 8:if(m===le)ke=m}break;case V:if(d+h+o===0)z=R;break;case U:if(h+u+d+o===0)we=1,Re+="\r";break;case Y:case X:if(0===h)d=d===C?0:0===d?C:d;break;case G:if(d+h+u===0)o++;break;case H:if(d+h+u===0)o--;break;case E:if(d+h+o===0)u--;break;case D:if(d+h+o===0){if(0===O)switch(2*w+3*m){case 533:break;default:y=0,O=1}u++}break;case L:if(h+u+d+o+z+j===0)j=1;break;case T:case Z:if(d+o+u>0)break;switch(h){case 0:switch(2*C+3*s.charCodeAt(R+1)){case 235:h=Z;break;case 220:je=R,h=T}break;case T:if(C===Z&&w===T&&je+2!==R){if(33===s.charCodeAt(je+2))Ve+=s.substring(je,R+1);Re="",h=0}}}if(0===h){if(ge+d+o+j===0&&t!==te&&C!==W)switch(C){case U:case ae:case _:case ee:case E:case D:if(0===O){switch(w){case K:case M:case I:case J:Re+="\0";break;default:Re="\0"+Re+(C===U?"":"\0")}we=1}else switch(C){case D:if(z+7===R&&108===w)z=0;O=++y;break;case E:if(0==(O=--y))we=1,Re+="\0"}break;case K:case M:switch(w){case re:case B:case q:case W:case U:case ce:case K:case M:case I:case J:break;default:if(0===O)we=1,Re+="\0"}}if(Te+=Re,C!==M&&C!==K)$=C}}m=w,w=C,R++}if(je=Ve.length,me>0)if(0===je&&0===Xe.length&&0===a[0].length==false)if(t!==ie||1===a.length&&(ge>0?Ee:Ge)===a[0])je=a.join(",").length+2;if(je>0){if(f=0===ge&&t!==te?function(e){for(var a,r,s=0,t=e.length,i=Array(t);s<t;++s){for(var f=e[s].split(l),n="",o=0,h=0,u=0,d=0,b=f.length;o<b;++o){if(0===(h=(r=f[o]).length)&&b>1)continue;if(u=n.charCodeAt(n.length-1),d=r.charCodeAt(0),a="",0!==o)switch(u){case T:case ae:case _:case ee:case M:case D:break;default:a=" "}switch(d){case P:r=a+Ee;case ae:case _:case ee:case M:case E:case D:break;case G:r=a+r+Ee;break;case V:switch(2*r.charCodeAt(1)+3*r.charCodeAt(2)){case 530:if(Ce>0){r=a+r.substring(8,h-1);break}default:if(o<1||f[o-1].length<1)r=a+Ee+r}break;case U:a="";default:if(h>1&&r.indexOf(":")>0)r=a+r.replace(v,"$1"+Ee+"$2");else r=a+r+Ee}n+=r}i[s]=n.replace(c,"").trim()}return i}(a):a,ye>0)if(void 0!==(n=Pe(Fe,Ve,f,e,pe,be,je,t,i,t))&&0===(Ve=n).length)return Ye+Ve+Xe;if(Ve=f.join(",")+"{"+Ve+"}",Ae*ke!=0){if(2===Ae&&!Le(Ve,2))ke=0;switch(ke){case le:Ve=Ve.replace(k,":"+S+"$1")+Ve;break;case ne:Ve=Ve.replace(p,"::"+N+"input-$1")+Ve.replace(p,"::"+S+"$1")+Ve.replace(p,":"+F+"input-$1")+Ve}ke=0}}return Ye+Ve+Xe}function Ie(e,a,r){var c=a.trim().split(o),s=c,t=c.length,i=e.length;switch(i){case 0:case 1:for(var f=0,n=0===i?"":e[0]+" ";f<t;++f)s[f]=Je(n,s[f],r,i).trim();break;default:f=0;var l=0;for(s=[];f<t;++f)for(var h=0;h<i;++h)s[l++]=Je(e[h]+" ",c[f],r,i).trim()}return s}function Je(e,a,r,c){var s=a,t=s.charCodeAt(0);if(t<33)t=(s=s.trim()).charCodeAt(0);switch(t){case P:switch(ge+c){case 0:case 1:if(0===e.trim().length)break;default:return s.replace(h,"$1"+e.trim())}break;case V:switch(s.charCodeAt(1)){case 103:if(Ce>0&&ge>0)return s.replace(u,"$1").replace(h,"$1"+Ge);break;default:return e.trim()+s.replace(h,"$1"+e.trim())}default:if(r*ge>0&&s.indexOf("\f")>0)return s.replace(h,(e.charCodeAt(0)===V?"":"$1")+e.trim())}return e+s}function Ke(e,a,r,c){var l,o=0,h=e+";",u=2*a+3*r+4*c;if(944===u)return function(e){var a=e.length,r=e.indexOf(":",9)+1,c=e.substring(0,r).trim(),s=e.substring(r,a-1).trim();switch(e.charCodeAt(9)*Be){case 0:break;case Q:if(110!==e.charCodeAt(10))break;default:for(var t=s.split((s="",f)),i=0,r=0,a=t.length;i<a;r=0,++i){for(var l=t[i],o=l.split(n);l=o[r];){var h=l.charCodeAt(0);if(1===Be&&(h>L&&h<90||h>96&&h<123||h===R||h===Q&&l.charCodeAt(1)!==Q))switch(isNaN(parseFloat(l))+(-1!==l.indexOf("("))){case 1:switch(l){case"infinite":case"alternate":case"backwards":case"running":case"normal":case"forwards":case"both":case"none":case"linear":case"ease":case"ease-in":case"ease-out":case"ease-in-out":case"paused":case"reverse":case"alternate-reverse":case"inherit":case"initial":case"unset":case"step-start":case"step-end":break;default:l+=De}}o[r++]=l}s+=(0===i?"":",")+o.join(" ")}}if(s=c+s+";",1===Ae||2===Ae&&Le(s,1))return N+s+s;return s}(h);else if(0===Ae||2===Ae&&!Le(h,1))return h;switch(u){case 1015:return 97===h.charCodeAt(10)?N+h+h:h;case 951:return 116===h.charCodeAt(3)?N+h+h:h;case 963:return 110===h.charCodeAt(5)?N+h+h:h;case 1009:if(100!==h.charCodeAt(4))break;case 969:case 942:return N+h+h;case 978:return N+h+S+h+h;case 1019:case 983:return N+h+S+h+F+h+h;case 883:if(h.charCodeAt(8)===Q)return N+h+h;if(h.indexOf("image-set(",11)>0)return h.replace(z,"$1"+N+"$2")+h;return h;case 932:if(h.charCodeAt(4)===Q)switch(h.charCodeAt(5)){case 103:return N+"box-"+h.replace("-grow","")+N+h+F+h.replace("grow","positive")+h;case 115:return N+h+F+h.replace("shrink","negative")+h;case 98:return N+h+F+h.replace("basis","preferred-size")+h}return N+h+F+h+h;case 964:return N+h+F+"flex-"+h+h;case 1023:if(99!==h.charCodeAt(8))break;return l=h.substring(h.indexOf(":",15)).replace("flex-","").replace("space-between","justify"),N+"box-pack"+l+N+h+F+"flex-pack"+l+h;case 1005:return t.test(h)?h.replace(s,":"+N)+h.replace(s,":"+S)+h:h;case 1e3:switch(o=(l=h.substring(13).trim()).indexOf("-")+1,l.charCodeAt(0)+l.charCodeAt(o)){case 226:l=h.replace(m,"tb");break;case 232:l=h.replace(m,"tb-rl");break;case 220:l=h.replace(m,"lr");break;default:return h}return N+h+F+l+h;case 1017:if(-1===h.indexOf("sticky",9))return h;case 975:switch(o=(h=e).length-10,u=(l=(33===h.charCodeAt(o)?h.substring(0,o):h).substring(e.indexOf(":",7)+1).trim()).charCodeAt(0)+(0|l.charCodeAt(7))){case 203:if(l.charCodeAt(8)<111)break;case 115:h=h.replace(l,N+l)+";"+h;break;case 207:case 102:h=h.replace(l,N+(u>102?"inline-":"")+"box")+";"+h.replace(l,N+l)+";"+h.replace(l,F+l+"box")+";"+h}return h+";";case 938:if(h.charCodeAt(5)===Q)switch(h.charCodeAt(6)){case 105:return l=h.replace("-items",""),N+h+N+"box-"+l+F+"flex-"+l+h;case 115:return N+h+F+"flex-item-"+h.replace(y,"")+h;default:return N+h+F+"flex-line-pack"+h.replace("align-content","").replace(y,"")+h}break;case 973:case 989:if(h.charCodeAt(3)!==Q||122===h.charCodeAt(4))break;case 931:case 953:if(true===j.test(e))if(115===(l=e.substring(e.indexOf(":")+1)).charCodeAt(0))return Ke(e.replace("stretch","fill-available"),a,r,c).replace(":fill-available",":stretch");else return h.replace(l,N+l)+h.replace(l,S+l.replace("fill-",""))+h;break;case 962:if(h=N+h+(102===h.charCodeAt(5)?F+h:"")+h,r+c===211&&105===h.charCodeAt(13)&&h.indexOf("transform",10)>0)return h.substring(0,h.indexOf(";",27)+1).replace(i,"$1"+N+"$2")+h}return h}function Le(e,a){var r=e.indexOf(1===a?":":"{"),c=e.substring(0,3!==a?r:10),s=e.substring(r+1,e.length-1);return Oe(2!==a?c:c.replace(O,"$1"),s,a)}function Me(e,a){var r=Ke(a,a.charCodeAt(0),a.charCodeAt(1),a.charCodeAt(2));return r!==a+";"?r.replace($," or ($1)").substring(4):"("+a+")"}function Pe(e,a,r,c,s,t,i,f,n,l){for(var o,h=0,u=a;h<ye;++h)switch(o=$e[h].call(Te,e,u,r,c,s,t,i,f,n,l)){case void 0:case false:case true:case null:break;default:u=o}if(u!==a)return u}function Qe(e,a,r,c){for(var s=a+1;s<r;++s)switch(c.charCodeAt(s)){case Z:if(e===T)if(c.charCodeAt(s-1)===T&&a+2!==s)return s+1;break;case I:if(e===Z)return s+1}return s}function Re(e){for(var a in e){var r=e[a];switch(a){case"keyframe":Be=0|r;break;case"global":Ce=0|r;break;case"cascade":ge=0|r;break;case"compress":we=0|r;break;case"semicolon":ve=0|r;break;case"preserve":me=0|r;break;case"prefix":if(Oe=null,!r)Ae=0;else if("function"!=typeof r)Ae=1;else Ae=2,Oe=r}}return Re}function Te(a,r){if(void 0!==this&&this.constructor===Te)return e(a);var s=a,t=s.charCodeAt(0);if(t<33)t=(s=s.trim()).charCodeAt(0);if(Be>0)De=s.replace(d,t===G?"":"-");if(t=1,1===ge)Ge=s;else Ee=s;var i,f=[Ge];if(ye>0)if(void 0!==(i=Pe(ze,r,f,f,pe,be,0,0,0,0))&&"string"==typeof i)r=i;var n=He(xe,f,r,0,0);if(ye>0)if(void 0!==(i=Pe(je,n,f,f,pe,be,n.length,0,0,0))&&"string"!=typeof(n=i))t=0;return De="",Ge="",Ee="",ke=0,pe=1,be=1,we*t==0?n:n.replace(c,"").replace(g,"").replace(A,"$1").replace(C,"$1").replace(w," ")}if(Te.use=function e(a){switch(a){case void 0:case null:ye=$e.length=0;break;default:if("function"==typeof a)$e[ye++]=a;else if("object"==typeof a)for(var r=0,c=a.length;r<c;++r)e(a[r]);else qe=0|!!a}return e},Te.set=Re,void 0!==a)Re(a);return Te});
	//# sourceMappingURL=stylis.min.js.map

/***/ }),
/* 916 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports['default'] = symbolObservablePonyfill;
	function symbolObservablePonyfill(root) {
		var result;
		var _Symbol = root.Symbol;
	
		if (typeof _Symbol === 'function') {
			if (_Symbol.observable) {
				result = _Symbol.observable;
			} else {
				result = _Symbol('observable');
				_Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};

/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

	!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.trimCanvas=t():e.trimCanvas=t()}(this,function(){return function(e){function t(n){if(r[n])return r[n].exports;var o=r[n]={exports:{},id:n,loaded:!1};return e[n].call(o.exports,o,o.exports,t),o.loaded=!0,o.exports}var r={};return t.m=e,t.c=r,t.p="",t(0)}([function(e,t){"use strict";function r(e){var t=e.getContext("2d"),r=e.width,n=e.height,o=t.getImageData(0,0,r,n).data,f=a(!0,r,n,o),i=a(!1,r,n,o),c=u(!0,r,n,o),d=u(!1,r,n,o),p=d-c+1,l=i-f+1,s=t.getImageData(c,f,p,l);return e.width=p,e.height=l,t.clearRect(0,0,p,l),t.putImageData(s,0,0),e}function n(e,t,r,n){return{red:n[4*(r*t+e)],green:n[4*(r*t+e)+1],blue:n[4*(r*t+e)+2],alpha:n[4*(r*t+e)+3]}}function o(e,t,r,o){return n(e,t,r,o).alpha}function a(e,t,r,n){for(var a=e?1:-1,u=e?0:r-1,f=u;e?f<r:f>-1;f+=a)for(var i=0;i<t;i++)if(o(i,f,t,n))return f;return null}function u(e,t,r,n){for(var a=e?1:-1,u=e?0:t-1,f=u;e?f<t:f>-1;f+=a)for(var i=0;i<r;i++)if(o(f,i,t,n))return f;return null}Object.defineProperty(t,"__esModule",{value:!0}),t.default=r}])});

/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * UAParser.js v0.7.20
	 * Lightweight JavaScript-based User-Agent string parser
	 * https://github.com/faisalman/ua-parser-js
	 *
	 * Copyright © 2012-2019 Faisal Salman <f@faisalman.com>
	 * Licensed under MIT License
	 */
	(function(window,undefined){"use strict";var LIBVERSION="0.7.20",EMPTY="",UNKNOWN="?",FUNC_TYPE="function",UNDEF_TYPE="undefined",OBJ_TYPE="object",STR_TYPE="string",MAJOR="major",MODEL="model",NAME="name",TYPE="type",VENDOR="vendor",VERSION="version",ARCHITECTURE="architecture",CONSOLE="console",MOBILE="mobile",TABLET="tablet",SMARTTV="smarttv",WEARABLE="wearable",EMBEDDED="embedded";var util={extend:function(regexes,extensions){var mergedRegexes={};for(var i in regexes){if(extensions[i]&&extensions[i].length%2===0){mergedRegexes[i]=extensions[i].concat(regexes[i])}else{mergedRegexes[i]=regexes[i]}}return mergedRegexes},has:function(str1,str2){if(typeof str1==="string"){return str2.toLowerCase().indexOf(str1.toLowerCase())!==-1}else{return false}},lowerize:function(str){return str.toLowerCase()},major:function(version){return typeof version===STR_TYPE?version.replace(/[^\d\.]/g,"").split(".")[0]:undefined},trim:function(str){return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,"")}};var mapper={rgx:function(ua,arrays){var i=0,j,k,p,q,matches,match;while(i<arrays.length&&!matches){var regex=arrays[i],props=arrays[i+1];j=k=0;while(j<regex.length&&!matches){matches=regex[j++].exec(ua);if(!!matches){for(p=0;p<props.length;p++){match=matches[++k];q=props[p];if(typeof q===OBJ_TYPE&&q.length>0){if(q.length==2){if(typeof q[1]==FUNC_TYPE){this[q[0]]=q[1].call(this,match)}else{this[q[0]]=q[1]}}else if(q.length==3){if(typeof q[1]===FUNC_TYPE&&!(q[1].exec&&q[1].test)){this[q[0]]=match?q[1].call(this,match,q[2]):undefined}else{this[q[0]]=match?match.replace(q[1],q[2]):undefined}}else if(q.length==4){this[q[0]]=match?q[3].call(this,match.replace(q[1],q[2])):undefined}}else{this[q]=match?match:undefined}}}}i+=2}},str:function(str,map){for(var i in map){if(typeof map[i]===OBJ_TYPE&&map[i].length>0){for(var j=0;j<map[i].length;j++){if(util.has(map[i][j],str)){return i===UNKNOWN?undefined:i}}}else if(util.has(map[i],str)){return i===UNKNOWN?undefined:i}}return str}};var maps={browser:{oldsafari:{version:{"1.0":"/8",1.2:"/1",1.3:"/3","2.0":"/412","2.0.2":"/416","2.0.3":"/417","2.0.4":"/419","?":"/"}}},device:{amazon:{model:{"Fire Phone":["SD","KF"]}},sprint:{model:{"Evo Shift 4G":"7373KT"},vendor:{HTC:"APA",Sprint:"Sprint"}}},os:{windows:{version:{ME:"4.90","NT 3.11":"NT3.51","NT 4.0":"NT4.0",2e3:"NT 5.0",XP:["NT 5.1","NT 5.2"],Vista:"NT 6.0",7:"NT 6.1",8:"NT 6.2",8.1:"NT 6.3",10:["NT 6.4","NT 10.0"],RT:"ARM"}}}};var regexes={browser:[[/(opera\smini)\/([\w\.-]+)/i,/(opera\s[mobiletab]+).+version\/([\w\.-]+)/i,/(opera).+version\/([\w\.]+)/i,/(opera)[\/\s]+([\w\.]+)/i],[NAME,VERSION],[/(opios)[\/\s]+([\w\.]+)/i],[[NAME,"Opera Mini"],VERSION],[/\s(opr)\/([\w\.]+)/i],[[NAME,"Opera"],VERSION],[/(kindle)\/([\w\.]+)/i,/(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?([\w\.]*)/i,/(avant\s|iemobile|slim|baidu)(?:browser)?[\/\s]?([\w\.]*)/i,/(?:ms|\()(ie)\s([\w\.]+)/i,/(rekonq)\/([\w\.]*)/i,/(chromium|flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon)\/([\w\.-]+)/i],[NAME,VERSION],[/(konqueror)\/([\w\.]+)/i],[[NAME,"Konqueror"],VERSION],[/(trident).+rv[:\s]([\w\.]+).+like\sgecko/i],[[NAME,"IE"],VERSION],[/(edge|edgios|edga|edg)\/((\d+)?[\w\.]+)/i],[[NAME,"Edge"],VERSION],[/(yabrowser)\/([\w\.]+)/i],[[NAME,"Yandex"],VERSION],[/(puffin)\/([\w\.]+)/i],[[NAME,"Puffin"],VERSION],[/(focus)\/([\w\.]+)/i],[[NAME,"Firefox Focus"],VERSION],[/(opt)\/([\w\.]+)/i],[[NAME,"Opera Touch"],VERSION],[/((?:[\s\/])uc?\s?browser|(?:juc.+)ucweb)[\/\s]?([\w\.]+)/i],[[NAME,"UCBrowser"],VERSION],[/(comodo_dragon)\/([\w\.]+)/i],[[NAME,/_/g," "],VERSION],[/(windowswechat qbcore)\/([\w\.]+)/i],[[NAME,"WeChat(Win) Desktop"],VERSION],[/(micromessenger)\/([\w\.]+)/i],[[NAME,"WeChat"],VERSION],[/(brave)\/([\w\.]+)/i],[[NAME,"Brave"],VERSION],[/(qqbrowserlite)\/([\w\.]+)/i],[NAME,VERSION],[/(QQ)\/([\d\.]+)/i],[NAME,VERSION],[/m?(qqbrowser)[\/\s]?([\w\.]+)/i],[NAME,VERSION],[/(BIDUBrowser)[\/\s]?([\w\.]+)/i],[NAME,VERSION],[/(2345Explorer)[\/\s]?([\w\.]+)/i],[NAME,VERSION],[/(MetaSr)[\/\s]?([\w\.]+)/i],[NAME],[/(LBBROWSER)/i],[NAME],[/xiaomi\/miuibrowser\/([\w\.]+)/i],[VERSION,[NAME,"MIUI Browser"]],[/;fbav\/([\w\.]+);/i],[VERSION,[NAME,"Facebook"]],[/safari\s(line)\/([\w\.]+)/i,/android.+(line)\/([\w\.]+)\/iab/i],[NAME,VERSION],[/headlesschrome(?:\/([\w\.]+)|\s)/i],[VERSION,[NAME,"Chrome Headless"]],[/\swv\).+(chrome)\/([\w\.]+)/i],[[NAME,/(.+)/,"$1 WebView"],VERSION],[/((?:oculus|samsung)browser)\/([\w\.]+)/i],[[NAME,/(.+(?:g|us))(.+)/,"$1 $2"],VERSION],[/android.+version\/([\w\.]+)\s+(?:mobile\s?safari|safari)*/i],[VERSION,[NAME,"Android Browser"]],[/(sailfishbrowser)\/([\w\.]+)/i],[[NAME,"Sailfish Browser"],VERSION],[/(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?([\w\.]+)/i],[NAME,VERSION],[/(dolfin)\/([\w\.]+)/i],[[NAME,"Dolphin"],VERSION],[/((?:android.+)crmo|crios)\/([\w\.]+)/i],[[NAME,"Chrome"],VERSION],[/(coast)\/([\w\.]+)/i],[[NAME,"Opera Coast"],VERSION],[/fxios\/([\w\.-]+)/i],[VERSION,[NAME,"Firefox"]],[/version\/([\w\.]+).+?mobile\/\w+\s(safari)/i],[VERSION,[NAME,"Mobile Safari"]],[/version\/([\w\.]+).+?(mobile\s?safari|safari)/i],[VERSION,NAME],[/webkit.+?(gsa)\/([\w\.]+).+?(mobile\s?safari|safari)(\/[\w\.]+)/i],[[NAME,"GSA"],VERSION],[/webkit.+?(mobile\s?safari|safari)(\/[\w\.]+)/i],[NAME,[VERSION,mapper.str,maps.browser.oldsafari.version]],[/(webkit|khtml)\/([\w\.]+)/i],[NAME,VERSION],[/(navigator|netscape)\/([\w\.-]+)/i],[[NAME,"Netscape"],VERSION],[/(swiftfox)/i,/(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?([\w\.\+]+)/i,/(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([\w\.-]+)$/i,/(mozilla)\/([\w\.]+).+rv\:.+gecko\/\d+/i,/(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir)[\/\s]?([\w\.]+)/i,/(links)\s\(([\w\.]+)/i,/(gobrowser)\/?([\w\.]*)/i,/(ice\s?browser)\/v?([\w\._]+)/i,/(mosaic)[\/\s]([\w\.]+)/i],[NAME,VERSION]],cpu:[[/(?:(amd|x(?:(?:86|64)[_-])?|wow|win)64)[;\)]/i],[[ARCHITECTURE,"amd64"]],[/(ia32(?=;))/i],[[ARCHITECTURE,util.lowerize]],[/((?:i[346]|x)86)[;\)]/i],[[ARCHITECTURE,"ia32"]],[/windows\s(ce|mobile);\sppc;/i],[[ARCHITECTURE,"arm"]],[/((?:ppc|powerpc)(?:64)?)(?:\smac|;|\))/i],[[ARCHITECTURE,/ower/,"",util.lowerize]],[/(sun4\w)[;\)]/i],[[ARCHITECTURE,"sparc"]],[/((?:avr32|ia64(?=;))|68k(?=\))|arm(?:64|(?=v\d+[;l]))|(?=atmel\s)avr|(?:irix|mips|sparc)(?:64)?(?=;)|pa-risc)/i],[[ARCHITECTURE,util.lowerize]]],device:[[/\((ipad|playbook);[\w\s\),;-]+(rim|apple)/i],[MODEL,VENDOR,[TYPE,TABLET]],[/applecoremedia\/[\w\.]+ \((ipad)/],[MODEL,[VENDOR,"Apple"],[TYPE,TABLET]],[/(apple\s{0,1}tv)/i],[[MODEL,"Apple TV"],[VENDOR,"Apple"]],[/(archos)\s(gamepad2?)/i,/(hp).+(touchpad)/i,/(hp).+(tablet)/i,/(kindle)\/([\w\.]+)/i,/\s(nook)[\w\s]+build\/(\w+)/i,/(dell)\s(strea[kpr\s\d]*[\dko])/i],[VENDOR,MODEL,[TYPE,TABLET]],[/(kf[A-z]+)\sbuild\/.+silk\//i],[MODEL,[VENDOR,"Amazon"],[TYPE,TABLET]],[/(sd|kf)[0349hijorstuw]+\sbuild\/.+silk\//i],[[MODEL,mapper.str,maps.device.amazon.model],[VENDOR,"Amazon"],[TYPE,MOBILE]],[/android.+aft([bms])\sbuild/i],[MODEL,[VENDOR,"Amazon"],[TYPE,SMARTTV]],[/\((ip[honed|\s\w*]+);.+(apple)/i],[MODEL,VENDOR,[TYPE,MOBILE]],[/\((ip[honed|\s\w*]+);/i],[MODEL,[VENDOR,"Apple"],[TYPE,MOBILE]],[/(blackberry)[\s-]?(\w+)/i,/(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[\s_-]?([\w-]*)/i,/(hp)\s([\w\s]+\w)/i,/(asus)-?(\w+)/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/\(bb10;\s(\w+)/i],[MODEL,[VENDOR,"BlackBerry"],[TYPE,MOBILE]],[/android.+(transfo[prime\s]{4,10}\s\w+|eeepc|slider\s\w+|nexus 7|padfone|p00c)/i],[MODEL,[VENDOR,"Asus"],[TYPE,TABLET]],[/(sony)\s(tablet\s[ps])\sbuild\//i,/(sony)?(?:sgp.+)\sbuild\//i],[[VENDOR,"Sony"],[MODEL,"Xperia Tablet"],[TYPE,TABLET]],[/android.+\s([c-g]\d{4}|so[-l]\w+)(?=\sbuild\/|\).+chrome\/(?![1-6]{0,1}\d\.))/i],[MODEL,[VENDOR,"Sony"],[TYPE,MOBILE]],[/\s(ouya)\s/i,/(nintendo)\s([wids3u]+)/i],[VENDOR,MODEL,[TYPE,CONSOLE]],[/android.+;\s(shield)\sbuild/i],[MODEL,[VENDOR,"Nvidia"],[TYPE,CONSOLE]],[/(playstation\s[34portablevi]+)/i],[MODEL,[VENDOR,"Sony"],[TYPE,CONSOLE]],[/(sprint\s(\w+))/i],[[VENDOR,mapper.str,maps.device.sprint.vendor],[MODEL,mapper.str,maps.device.sprint.model],[TYPE,MOBILE]],[/(htc)[;_\s-]+([\w\s]+(?=\)|\sbuild)|\w+)/i,/(zte)-(\w*)/i,/(alcatel|geeksphone|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]*)/i],[VENDOR,[MODEL,/_/g," "],[TYPE,MOBILE]],[/(nexus\s9)/i],[MODEL,[VENDOR,"HTC"],[TYPE,TABLET]],[/d\/huawei([\w\s-]+)[;\)]/i,/(nexus\s6p)/i],[MODEL,[VENDOR,"Huawei"],[TYPE,MOBILE]],[/(microsoft);\s(lumia[\s\w]+)/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/[\s\(;](xbox(?:\sone)?)[\s\);]/i],[MODEL,[VENDOR,"Microsoft"],[TYPE,CONSOLE]],[/(kin\.[onetw]{3})/i],[[MODEL,/\./g," "],[VENDOR,"Microsoft"],[TYPE,MOBILE]],[/\s(milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?:?(\s4g)?)[\w\s]+build\//i,/mot[\s-]?(\w*)/i,/(XT\d{3,4}) build\//i,/(nexus\s6)/i],[MODEL,[VENDOR,"Motorola"],[TYPE,MOBILE]],[/android.+\s(mz60\d|xoom[\s2]{0,2})\sbuild\//i],[MODEL,[VENDOR,"Motorola"],[TYPE,TABLET]],[/hbbtv\/\d+\.\d+\.\d+\s+\([\w\s]*;\s*(\w[^;]*);([^;]*)/i],[[VENDOR,util.trim],[MODEL,util.trim],[TYPE,SMARTTV]],[/hbbtv.+maple;(\d+)/i],[[MODEL,/^/,"SmartTV"],[VENDOR,"Samsung"],[TYPE,SMARTTV]],[/\(dtv[\);].+(aquos)/i],[MODEL,[VENDOR,"Sharp"],[TYPE,SMARTTV]],[/android.+((sch-i[89]0\d|shw-m380s|gt-p\d{4}|gt-n\d+|sgh-t8[56]9|nexus 10))/i,/((SM-T\w+))/i],[[VENDOR,"Samsung"],MODEL,[TYPE,TABLET]],[/smart-tv.+(samsung)/i],[VENDOR,[TYPE,SMARTTV],MODEL],[/((s[cgp]h-\w+|gt-\w+|galaxy\snexus|sm-\w[\w\d]+))/i,/(sam[sung]*)[\s-]*(\w+-?[\w-]*)/i,/sec-((sgh\w+))/i],[[VENDOR,"Samsung"],MODEL,[TYPE,MOBILE]],[/sie-(\w*)/i],[MODEL,[VENDOR,"Siemens"],[TYPE,MOBILE]],[/(maemo|nokia).*(n900|lumia\s\d+)/i,/(nokia)[\s_-]?([\w-]*)/i],[[VENDOR,"Nokia"],MODEL,[TYPE,MOBILE]],[/android[x\d\.\s;]+\s([ab][1-7]\-?[0178a]\d\d?)/i],[MODEL,[VENDOR,"Acer"],[TYPE,TABLET]],[/android.+([vl]k\-?\d{3})\s+build/i],[MODEL,[VENDOR,"LG"],[TYPE,TABLET]],[/android\s3\.[\s\w;-]{10}(lg?)-([06cv9]{3,4})/i],[[VENDOR,"LG"],MODEL,[TYPE,TABLET]],[/(lg) netcast\.tv/i],[VENDOR,MODEL,[TYPE,SMARTTV]],[/(nexus\s[45])/i,/lg[e;\s\/-]+(\w*)/i,/android.+lg(\-?[\d\w]+)\s+build/i],[MODEL,[VENDOR,"LG"],[TYPE,MOBILE]],[/(lenovo)\s?(s(?:5000|6000)(?:[\w-]+)|tab(?:[\s\w]+))/i],[VENDOR,MODEL,[TYPE,TABLET]],[/android.+(ideatab[a-z0-9\-\s]+)/i],[MODEL,[VENDOR,"Lenovo"],[TYPE,TABLET]],[/(lenovo)[_\s-]?([\w-]+)/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/linux;.+((jolla));/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/((pebble))app\/[\d\.]+\s/i],[VENDOR,MODEL,[TYPE,WEARABLE]],[/android.+;\s(oppo)\s?([\w\s]+)\sbuild/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/crkey/i],[[MODEL,"Chromecast"],[VENDOR,"Google"]],[/android.+;\s(glass)\s\d/i],[MODEL,[VENDOR,"Google"],[TYPE,WEARABLE]],[/android.+;\s(pixel c)[\s)]/i],[MODEL,[VENDOR,"Google"],[TYPE,TABLET]],[/android.+;\s(pixel( [23])?( xl)?)[\s)]/i],[MODEL,[VENDOR,"Google"],[TYPE,MOBILE]],[/android.+;\s(\w+)\s+build\/hm\1/i,/android.+(hm[\s\-_]*note?[\s_]*(?:\d\w)?)\s+build/i,/android.+(mi[\s\-_]*(?:a\d|one|one[\s_]plus|note lte)?[\s_]*(?:\d?\w?)[\s_]*(?:plus)?)\s+build/i,/android.+(redmi[\s\-_]*(?:note)?(?:[\s_]*[\w\s]+))\s+build/i],[[MODEL,/_/g," "],[VENDOR,"Xiaomi"],[TYPE,MOBILE]],[/android.+(mi[\s\-_]*(?:pad)(?:[\s_]*[\w\s]+))\s+build/i],[[MODEL,/_/g," "],[VENDOR,"Xiaomi"],[TYPE,TABLET]],[/android.+;\s(m[1-5]\snote)\sbuild/i],[MODEL,[VENDOR,"Meizu"],[TYPE,MOBILE]],[/(mz)-([\w-]{2,})/i],[[VENDOR,"Meizu"],MODEL,[TYPE,MOBILE]],[/android.+a000(1)\s+build/i,/android.+oneplus\s(a\d{4})\s+build/i],[MODEL,[VENDOR,"OnePlus"],[TYPE,MOBILE]],[/android.+[;\/]\s*(RCT[\d\w]+)\s+build/i],[MODEL,[VENDOR,"RCA"],[TYPE,TABLET]],[/android.+[;\/\s]+(Venue[\d\s]{2,7})\s+build/i],[MODEL,[VENDOR,"Dell"],[TYPE,TABLET]],[/android.+[;\/]\s*(Q[T|M][\d\w]+)\s+build/i],[MODEL,[VENDOR,"Verizon"],[TYPE,TABLET]],[/android.+[;\/]\s+(Barnes[&\s]+Noble\s+|BN[RT])(V?.*)\s+build/i],[[VENDOR,"Barnes & Noble"],MODEL,[TYPE,TABLET]],[/android.+[;\/]\s+(TM\d{3}.*\b)\s+build/i],[MODEL,[VENDOR,"NuVision"],[TYPE,TABLET]],[/android.+;\s(k88)\sbuild/i],[MODEL,[VENDOR,"ZTE"],[TYPE,TABLET]],[/android.+[;\/]\s*(gen\d{3})\s+build.*49h/i],[MODEL,[VENDOR,"Swiss"],[TYPE,MOBILE]],[/android.+[;\/]\s*(zur\d{3})\s+build/i],[MODEL,[VENDOR,"Swiss"],[TYPE,TABLET]],[/android.+[;\/]\s*((Zeki)?TB.*\b)\s+build/i],[MODEL,[VENDOR,"Zeki"],[TYPE,TABLET]],[/(android).+[;\/]\s+([YR]\d{2})\s+build/i,/android.+[;\/]\s+(Dragon[\-\s]+Touch\s+|DT)(\w{5})\sbuild/i],[[VENDOR,"Dragon Touch"],MODEL,[TYPE,TABLET]],[/android.+[;\/]\s*(NS-?\w{0,9})\sbuild/i],[MODEL,[VENDOR,"Insignia"],[TYPE,TABLET]],[/android.+[;\/]\s*((NX|Next)-?\w{0,9})\s+build/i],[MODEL,[VENDOR,"NextBook"],[TYPE,TABLET]],[/android.+[;\/]\s*(Xtreme\_)?(V(1[045]|2[015]|30|40|60|7[05]|90))\s+build/i],[[VENDOR,"Voice"],MODEL,[TYPE,MOBILE]],[/android.+[;\/]\s*(LVTEL\-)?(V1[12])\s+build/i],[[VENDOR,"LvTel"],MODEL,[TYPE,MOBILE]],[/android.+;\s(PH-1)\s/i],[MODEL,[VENDOR,"Essential"],[TYPE,MOBILE]],[/android.+[;\/]\s*(V(100MD|700NA|7011|917G).*\b)\s+build/i],[MODEL,[VENDOR,"Envizen"],[TYPE,TABLET]],[/android.+[;\/]\s*(Le[\s\-]+Pan)[\s\-]+(\w{1,9})\s+build/i],[VENDOR,MODEL,[TYPE,TABLET]],[/android.+[;\/]\s*(Trio[\s\-]*.*)\s+build/i],[MODEL,[VENDOR,"MachSpeed"],[TYPE,TABLET]],[/android.+[;\/]\s*(Trinity)[\-\s]*(T\d{3})\s+build/i],[VENDOR,MODEL,[TYPE,TABLET]],[/android.+[;\/]\s*TU_(1491)\s+build/i],[MODEL,[VENDOR,"Rotor"],[TYPE,TABLET]],[/android.+(KS(.+))\s+build/i],[MODEL,[VENDOR,"Amazon"],[TYPE,TABLET]],[/android.+(Gigaset)[\s\-]+(Q\w{1,9})\s+build/i],[VENDOR,MODEL,[TYPE,TABLET]],[/\s(tablet|tab)[;\/]/i,/\s(mobile)(?:[;\/]|\ssafari)/i],[[TYPE,util.lowerize],VENDOR,MODEL],[/[\s\/\(](smart-?tv)[;\)]/i],[[TYPE,SMARTTV]],[/(android[\w\.\s\-]{0,9});.+build/i],[MODEL,[VENDOR,"Generic"]]],engine:[[/windows.+\sedge\/([\w\.]+)/i],[VERSION,[NAME,"EdgeHTML"]],[/webkit\/537\.36.+chrome\/(?!27)/i],[[NAME,"Blink"]],[/(presto)\/([\w\.]+)/i,/(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,/(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i,/(icab)[\/\s]([23]\.[\d\.]+)/i],[NAME,VERSION],[/rv\:([\w\.]{1,9}).+(gecko)/i],[VERSION,NAME]],os:[[/microsoft\s(windows)\s(vista|xp)/i],[NAME,VERSION],[/(windows)\snt\s6\.2;\s(arm)/i,/(windows\sphone(?:\sos)*)[\s\/]?([\d\.\s\w]*)/i,/(windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)/i],[NAME,[VERSION,mapper.str,maps.os.windows.version]],[/(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i],[[NAME,"Windows"],[VERSION,mapper.str,maps.os.windows.version]],[/\((bb)(10);/i],[[NAME,"BlackBerry"],VERSION],[/(blackberry)\w*\/?([\w\.]*)/i,/(tizen)[\/\s]([\w\.]+)/i,/(android|webos|palm\sos|qnx|bada|rim\stablet\sos|meego|sailfish|contiki)[\/\s-]?([\w\.]*)/i],[NAME,VERSION],[/(symbian\s?os|symbos|s60(?=;))[\/\s-]?([\w\.]*)/i],[[NAME,"Symbian"],VERSION],[/\((series40);/i],[NAME],[/mozilla.+\(mobile;.+gecko.+firefox/i],[[NAME,"Firefox OS"],VERSION],[/(nintendo|playstation)\s([wids34portablevu]+)/i,/(mint)[\/\s\(]?(\w*)/i,/(mageia|vectorlinux)[;\s]/i,/(joli|[kxln]?ubuntu|debian|suse|opensuse|gentoo|(?=\s)arch|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk|linpus)[\/\s-]?(?!chrom)([\w\.-]*)/i,/(hurd|linux)\s?([\w\.]*)/i,/(gnu)\s?([\w\.]*)/i],[NAME,VERSION],[/(cros)\s[\w]+\s([\w\.]+\w)/i],[[NAME,"Chromium OS"],VERSION],[/(sunos)\s?([\w\.\d]*)/i],[[NAME,"Solaris"],VERSION],[/\s([frentopc-]{0,4}bsd|dragonfly)\s?([\w\.]*)/i],[NAME,VERSION],[/(haiku)\s(\w+)/i],[NAME,VERSION],[/cfnetwork\/.+darwin/i,/ip[honead]{2,4}(?:.*os\s([\w]+)\slike\smac|;\sopera)/i],[[VERSION,/_/g,"."],[NAME,"iOS"]],[/(mac\sos\sx)\s?([\w\s\.]*)/i,/(macintosh|mac(?=_powerpc)\s)/i],[[NAME,"Mac OS"],[VERSION,/_/g,"."]],[/((?:open)?solaris)[\/\s-]?([\w\.]*)/i,/(aix)\s((\d)(?=\.|\)|\s)[\w\.])*/i,/(plan\s9|minix|beos|os\/2|amigaos|morphos|risc\sos|openvms|fuchsia)/i,/(unix)\s?([\w\.]*)/i],[NAME,VERSION]]};var UAParser=function(uastring,extensions){if(typeof uastring==="object"){extensions=uastring;uastring=undefined}if(!(this instanceof UAParser)){return new UAParser(uastring,extensions).getResult()}var ua=uastring||(window&&window.navigator&&window.navigator.userAgent?window.navigator.userAgent:EMPTY);var rgxmap=extensions?util.extend(regexes,extensions):regexes;this.getBrowser=function(){var browser={name:undefined,version:undefined};mapper.rgx.call(browser,ua,rgxmap.browser);browser.major=util.major(browser.version);return browser};this.getCPU=function(){var cpu={architecture:undefined};mapper.rgx.call(cpu,ua,rgxmap.cpu);return cpu};this.getDevice=function(){var device={vendor:undefined,model:undefined,type:undefined};mapper.rgx.call(device,ua,rgxmap.device);return device};this.getEngine=function(){var engine={name:undefined,version:undefined};mapper.rgx.call(engine,ua,rgxmap.engine);return engine};this.getOS=function(){var os={name:undefined,version:undefined};mapper.rgx.call(os,ua,rgxmap.os);return os};this.getResult=function(){return{ua:this.getUA(),browser:this.getBrowser(),engine:this.getEngine(),os:this.getOS(),device:this.getDevice(),cpu:this.getCPU()}};this.getUA=function(){return ua};this.setUA=function(uastring){ua=uastring;return this};return this};UAParser.VERSION=LIBVERSION;UAParser.BROWSER={NAME:NAME,MAJOR:MAJOR,VERSION:VERSION};UAParser.CPU={ARCHITECTURE:ARCHITECTURE};UAParser.DEVICE={MODEL:MODEL,VENDOR:VENDOR,TYPE:TYPE,CONSOLE:CONSOLE,MOBILE:MOBILE,SMARTTV:SMARTTV,TABLET:TABLET,WEARABLE:WEARABLE,EMBEDDED:EMBEDDED};UAParser.ENGINE={NAME:NAME,VERSION:VERSION};UAParser.OS={NAME:NAME,VERSION:VERSION};if(typeof exports!==UNDEF_TYPE){if(typeof module!==UNDEF_TYPE&&module.exports){exports=module.exports=UAParser}exports.UAParser=UAParser}else{if(true){!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return UAParser}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))}else if(window){window.UAParser=UAParser}}var $=window&&(window.jQuery||window.Zepto);if(typeof $!==UNDEF_TYPE&&!$.ua){var parser=new UAParser;$.ua=parser.getResult();$.ua.get=function(){return parser.getUA()};$.ua.set=function(uastring){parser.setUA(uastring);var result=parser.getResult();for(var prop in result){$.ua[prop]=result[prop]}}}})(typeof window==="object"?window:this);

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define('underscore', factory) :
	  (function() {
	  	var current = global._;
	  	var exports = factory();
	  	global._ = exports;
	  	exports.noConflict = function() { global._ = current; return exports; };
	  })();
	}(this, (function () {
	
	  //     Underscore.js 1.10.2
	  //     https://underscorejs.org
	  //     (c) 2009-2020 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	  //     Underscore may be freely distributed under the MIT license.
	
	  // Baseline setup
	  // --------------
	
	  // Establish the root object, `window` (`self`) in the browser, `global`
	  // on the server, or `this` in some virtual machines. We use `self`
	  // instead of `window` for `WebWorker` support.
	  var root = typeof self == 'object' && self.self === self && self ||
	            typeof global == 'object' && global.global === global && global ||
	            Function('return this')() ||
	            {};
	
	  // Save bytes in the minified (but not gzipped) version:
	  var ArrayProto = Array.prototype, ObjProto = Object.prototype;
	  var SymbolProto = typeof Symbol !== 'undefined' ? Symbol.prototype : null;
	
	  // Create quick reference variables for speed access to core prototypes.
	  var push = ArrayProto.push,
	      slice = ArrayProto.slice,
	      toString = ObjProto.toString,
	      hasOwnProperty = ObjProto.hasOwnProperty;
	
	  // All **ECMAScript 5** native function implementations that we hope to use
	  // are declared here.
	  var nativeIsArray = Array.isArray,
	      nativeKeys = Object.keys,
	      nativeCreate = Object.create;
	
	  // Create references to these builtin functions because we override them.
	  var _isNaN = root.isNaN,
	      _isFinite = root.isFinite;
	
	  // Naked function reference for surrogate-prototype-swapping.
	  var Ctor = function(){};
	
	  // The Underscore object. All exported functions below are added to it in the
	  // modules/index-all.js using the mixin function.
	  function _(obj) {
	    if (obj instanceof _) return obj;
	    if (!(this instanceof _)) return new _(obj);
	    this._wrapped = obj;
	  }
	
	  // Current version.
	  var VERSION = _.VERSION = '1.10.2';
	
	  // Internal function that returns an efficient (for current engines) version
	  // of the passed-in callback, to be repeatedly applied in other Underscore
	  // functions.
	  function optimizeCb(func, context, argCount) {
	    if (context === void 0) return func;
	    switch (argCount == null ? 3 : argCount) {
	      case 1: return function(value) {
	        return func.call(context, value);
	      };
	      // The 2-argument case is omitted because we’re not using it.
	      case 3: return function(value, index, collection) {
	        return func.call(context, value, index, collection);
	      };
	      case 4: return function(accumulator, value, index, collection) {
	        return func.call(context, accumulator, value, index, collection);
	      };
	    }
	    return function() {
	      return func.apply(context, arguments);
	    };
	  }
	
	  // An internal function to generate callbacks that can be applied to each
	  // element in a collection, returning the desired result — either `identity`,
	  // an arbitrary callback, a property matcher, or a property accessor.
	  function baseIteratee(value, context, argCount) {
	    if (value == null) return identity;
	    if (isFunction(value)) return optimizeCb(value, context, argCount);
	    if (isObject(value) && !isArray(value)) return matcher(value);
	    return property(value);
	  }
	
	  // External wrapper for our callback generator. Users may customize
	  // `_.iteratee` if they want additional predicate/iteratee shorthand styles.
	  // This abstraction hides the internal-only argCount argument.
	  _.iteratee = iteratee;
	  function iteratee(value, context) {
	    return baseIteratee(value, context, Infinity);
	  }
	
	  // The function we actually call internally. It invokes _.iteratee if
	  // overridden, otherwise baseIteratee.
	  function cb(value, context, argCount) {
	    if (_.iteratee !== iteratee) return _.iteratee(value, context);
	    return baseIteratee(value, context, argCount);
	  }
	
	  // Some functions take a variable number of arguments, or a few expected
	  // arguments at the beginning and then a variable number of values to operate
	  // on. This helper accumulates all remaining arguments past the function’s
	  // argument length (or an explicit `startIndex`), into an array that becomes
	  // the last argument. Similar to ES6’s "rest parameter".
	  function restArguments(func, startIndex) {
	    startIndex = startIndex == null ? func.length - 1 : +startIndex;
	    return function() {
	      var length = Math.max(arguments.length - startIndex, 0),
	          rest = Array(length),
	          index = 0;
	      for (; index < length; index++) {
	        rest[index] = arguments[index + startIndex];
	      }
	      switch (startIndex) {
	        case 0: return func.call(this, rest);
	        case 1: return func.call(this, arguments[0], rest);
	        case 2: return func.call(this, arguments[0], arguments[1], rest);
	      }
	      var args = Array(startIndex + 1);
	      for (index = 0; index < startIndex; index++) {
	        args[index] = arguments[index];
	      }
	      args[startIndex] = rest;
	      return func.apply(this, args);
	    };
	  }
	
	  // An internal function for creating a new object that inherits from another.
	  function baseCreate(prototype) {
	    if (!isObject(prototype)) return {};
	    if (nativeCreate) return nativeCreate(prototype);
	    Ctor.prototype = prototype;
	    var result = new Ctor;
	    Ctor.prototype = null;
	    return result;
	  }
	
	  function shallowProperty(key) {
	    return function(obj) {
	      return obj == null ? void 0 : obj[key];
	    };
	  }
	
	  function _has(obj, path) {
	    return obj != null && hasOwnProperty.call(obj, path);
	  }
	
	  function deepGet(obj, path) {
	    var length = path.length;
	    for (var i = 0; i < length; i++) {
	      if (obj == null) return void 0;
	      obj = obj[path[i]];
	    }
	    return length ? obj : void 0;
	  }
	
	  // Helper for collection methods to determine whether a collection
	  // should be iterated as an array or as an object.
	  // Related: https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
	  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
	  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
	  var getLength = shallowProperty('length');
	  function isArrayLike(collection) {
	    var length = getLength(collection);
	    return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
	  }
	
	  // Collection Functions
	  // --------------------
	
	  // The cornerstone, an `each` implementation, aka `forEach`.
	  // Handles raw objects in addition to array-likes. Treats all
	  // sparse array-likes as if they were dense.
	  function each(obj, iteratee, context) {
	    iteratee = optimizeCb(iteratee, context);
	    var i, length;
	    if (isArrayLike(obj)) {
	      for (i = 0, length = obj.length; i < length; i++) {
	        iteratee(obj[i], i, obj);
	      }
	    } else {
	      var _keys = keys(obj);
	      for (i = 0, length = _keys.length; i < length; i++) {
	        iteratee(obj[_keys[i]], _keys[i], obj);
	      }
	    }
	    return obj;
	  }
	
	  // Return the results of applying the iteratee to each element.
	  function map(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    var _keys = !isArrayLike(obj) && keys(obj),
	        length = (_keys || obj).length,
	        results = Array(length);
	    for (var index = 0; index < length; index++) {
	      var currentKey = _keys ? _keys[index] : index;
	      results[index] = iteratee(obj[currentKey], currentKey, obj);
	    }
	    return results;
	  }
	
	  // Create a reducing function iterating left or right.
	  function createReduce(dir) {
	    // Wrap code that reassigns argument variables in a separate function than
	    // the one that accesses `arguments.length` to avoid a perf hit. (#1991)
	    var reducer = function(obj, iteratee, memo, initial) {
	      var _keys = !isArrayLike(obj) && keys(obj),
	          length = (_keys || obj).length,
	          index = dir > 0 ? 0 : length - 1;
	      if (!initial) {
	        memo = obj[_keys ? _keys[index] : index];
	        index += dir;
	      }
	      for (; index >= 0 && index < length; index += dir) {
	        var currentKey = _keys ? _keys[index] : index;
	        memo = iteratee(memo, obj[currentKey], currentKey, obj);
	      }
	      return memo;
	    };
	
	    return function(obj, iteratee, memo, context) {
	      var initial = arguments.length >= 3;
	      return reducer(obj, optimizeCb(iteratee, context, 4), memo, initial);
	    };
	  }
	
	  // **Reduce** builds up a single result from a list of values, aka `inject`,
	  // or `foldl`.
	  var reduce = createReduce(1);
	
	  // The right-associative version of reduce, also known as `foldr`.
	  var reduceRight = createReduce(-1);
	
	  // Return the first value which passes a truth test.
	  function find(obj, predicate, context) {
	    var keyFinder = isArrayLike(obj) ? findIndex : findKey;
	    var key = keyFinder(obj, predicate, context);
	    if (key !== void 0 && key !== -1) return obj[key];
	  }
	
	  // Return all the elements that pass a truth test.
	  function filter(obj, predicate, context) {
	    var results = [];
	    predicate = cb(predicate, context);
	    each(obj, function(value, index, list) {
	      if (predicate(value, index, list)) results.push(value);
	    });
	    return results;
	  }
	
	  // Return all the elements for which a truth test fails.
	  function reject(obj, predicate, context) {
	    return filter(obj, negate(cb(predicate)), context);
	  }
	
	  // Determine whether all of the elements match a truth test.
	  function every(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var _keys = !isArrayLike(obj) && keys(obj),
	        length = (_keys || obj).length;
	    for (var index = 0; index < length; index++) {
	      var currentKey = _keys ? _keys[index] : index;
	      if (!predicate(obj[currentKey], currentKey, obj)) return false;
	    }
	    return true;
	  }
	
	  // Determine if at least one element in the object matches a truth test.
	  function some(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var _keys = !isArrayLike(obj) && keys(obj),
	        length = (_keys || obj).length;
	    for (var index = 0; index < length; index++) {
	      var currentKey = _keys ? _keys[index] : index;
	      if (predicate(obj[currentKey], currentKey, obj)) return true;
	    }
	    return false;
	  }
	
	  // Determine if the array or object contains a given item (using `===`).
	  function contains(obj, item, fromIndex, guard) {
	    if (!isArrayLike(obj)) obj = values(obj);
	    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
	    return indexOf(obj, item, fromIndex) >= 0;
	  }
	
	  // Invoke a method (with arguments) on every item in a collection.
	  var invoke = restArguments(function(obj, path, args) {
	    var contextPath, func;
	    if (isFunction(path)) {
	      func = path;
	    } else if (isArray(path)) {
	      contextPath = path.slice(0, -1);
	      path = path[path.length - 1];
	    }
	    return map(obj, function(context) {
	      var method = func;
	      if (!method) {
	        if (contextPath && contextPath.length) {
	          context = deepGet(context, contextPath);
	        }
	        if (context == null) return void 0;
	        method = context[path];
	      }
	      return method == null ? method : method.apply(context, args);
	    });
	  });
	
	  // Convenience version of a common use case of `map`: fetching a property.
	  function pluck(obj, key) {
	    return map(obj, property(key));
	  }
	
	  // Convenience version of a common use case of `filter`: selecting only objects
	  // containing specific `key:value` pairs.
	  function where(obj, attrs) {
	    return filter(obj, matcher(attrs));
	  }
	
	  // Convenience version of a common use case of `find`: getting the first object
	  // containing specific `key:value` pairs.
	  function findWhere(obj, attrs) {
	    return find(obj, matcher(attrs));
	  }
	
	  // Return the maximum element (or element-based computation).
	  function max(obj, iteratee, context) {
	    var result = -Infinity, lastComputed = -Infinity,
	        value, computed;
	    if (iteratee == null || typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null) {
	      obj = isArrayLike(obj) ? obj : values(obj);
	      for (var i = 0, length = obj.length; i < length; i++) {
	        value = obj[i];
	        if (value != null && value > result) {
	          result = value;
	        }
	      }
	    } else {
	      iteratee = cb(iteratee, context);
	      each(obj, function(v, index, list) {
	        computed = iteratee(v, index, list);
	        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
	          result = v;
	          lastComputed = computed;
	        }
	      });
	    }
	    return result;
	  }
	
	  // Return the minimum element (or element-based computation).
	  function min(obj, iteratee, context) {
	    var result = Infinity, lastComputed = Infinity,
	        value, computed;
	    if (iteratee == null || typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null) {
	      obj = isArrayLike(obj) ? obj : values(obj);
	      for (var i = 0, length = obj.length; i < length; i++) {
	        value = obj[i];
	        if (value != null && value < result) {
	          result = value;
	        }
	      }
	    } else {
	      iteratee = cb(iteratee, context);
	      each(obj, function(v, index, list) {
	        computed = iteratee(v, index, list);
	        if (computed < lastComputed || computed === Infinity && result === Infinity) {
	          result = v;
	          lastComputed = computed;
	        }
	      });
	    }
	    return result;
	  }
	
	  // Shuffle a collection.
	  function shuffle(obj) {
	    return sample(obj, Infinity);
	  }
	
	  // Sample **n** random values from a collection using the modern version of the
	  // [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
	  // If **n** is not specified, returns a single random element.
	  // The internal `guard` argument allows it to work with `map`.
	  function sample(obj, n, guard) {
	    if (n == null || guard) {
	      if (!isArrayLike(obj)) obj = values(obj);
	      return obj[random(obj.length - 1)];
	    }
	    var sample = isArrayLike(obj) ? clone(obj) : values(obj);
	    var length = getLength(sample);
	    n = Math.max(Math.min(n, length), 0);
	    var last = length - 1;
	    for (var index = 0; index < n; index++) {
	      var rand = random(index, last);
	      var temp = sample[index];
	      sample[index] = sample[rand];
	      sample[rand] = temp;
	    }
	    return sample.slice(0, n);
	  }
	
	  // Sort the object's values by a criterion produced by an iteratee.
	  function sortBy(obj, iteratee, context) {
	    var index = 0;
	    iteratee = cb(iteratee, context);
	    return pluck(map(obj, function(value, key, list) {
	      return {
	        value: value,
	        index: index++,
	        criteria: iteratee(value, key, list)
	      };
	    }).sort(function(left, right) {
	      var a = left.criteria;
	      var b = right.criteria;
	      if (a !== b) {
	        if (a > b || a === void 0) return 1;
	        if (a < b || b === void 0) return -1;
	      }
	      return left.index - right.index;
	    }), 'value');
	  }
	
	  // An internal function used for aggregate "group by" operations.
	  function group(behavior, partition) {
	    return function(obj, iteratee, context) {
	      var result = partition ? [[], []] : {};
	      iteratee = cb(iteratee, context);
	      each(obj, function(value, index) {
	        var key = iteratee(value, index, obj);
	        behavior(result, value, key);
	      });
	      return result;
	    };
	  }
	
	  // Groups the object's values by a criterion. Pass either a string attribute
	  // to group by, or a function that returns the criterion.
	  var groupBy = group(function(result, value, key) {
	    if (_has(result, key)) result[key].push(value); else result[key] = [value];
	  });
	
	  // Indexes the object's values by a criterion, similar to `groupBy`, but for
	  // when you know that your index values will be unique.
	  var indexBy = group(function(result, value, key) {
	    result[key] = value;
	  });
	
	  // Counts instances of an object that group by a certain criterion. Pass
	  // either a string attribute to count by, or a function that returns the
	  // criterion.
	  var countBy = group(function(result, value, key) {
	    if (_has(result, key)) result[key]++; else result[key] = 1;
	  });
	
	  var reStrSymbol = /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;
	  // Safely create a real, live array from anything iterable.
	  function toArray(obj) {
	    if (!obj) return [];
	    if (isArray(obj)) return slice.call(obj);
	    if (isString(obj)) {
	      // Keep surrogate pair characters together
	      return obj.match(reStrSymbol);
	    }
	    if (isArrayLike(obj)) return map(obj, identity);
	    return values(obj);
	  }
	
	  // Return the number of elements in an object.
	  function size(obj) {
	    if (obj == null) return 0;
	    return isArrayLike(obj) ? obj.length : keys(obj).length;
	  }
	
	  // Split a collection into two arrays: one whose elements all satisfy the given
	  // predicate, and one whose elements all do not satisfy the predicate.
	  var partition = group(function(result, value, pass) {
	    result[pass ? 0 : 1].push(value);
	  }, true);
	
	  // Array Functions
	  // ---------------
	
	  // Get the first element of an array. Passing **n** will return the first N
	  // values in the array. The **guard** check allows it to work with `map`.
	  function first(array, n, guard) {
	    if (array == null || array.length < 1) return n == null ? void 0 : [];
	    if (n == null || guard) return array[0];
	    return initial(array, array.length - n);
	  }
	
	  // Returns everything but the last entry of the array. Especially useful on
	  // the arguments object. Passing **n** will return all the values in
	  // the array, excluding the last N.
	  function initial(array, n, guard) {
	    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
	  }
	
	  // Get the last element of an array. Passing **n** will return the last N
	  // values in the array.
	  function last(array, n, guard) {
	    if (array == null || array.length < 1) return n == null ? void 0 : [];
	    if (n == null || guard) return array[array.length - 1];
	    return rest(array, Math.max(0, array.length - n));
	  }
	
	  // Returns everything but the first entry of the array. Especially useful on
	  // the arguments object. Passing an **n** will return the rest N values in the
	  // array.
	  function rest(array, n, guard) {
	    return slice.call(array, n == null || guard ? 1 : n);
	  }
	
	  // Trim out all falsy values from an array.
	  function compact(array) {
	    return filter(array, Boolean);
	  }
	
	  // Internal implementation of a recursive `flatten` function.
	  function _flatten(input, shallow, strict, output) {
	    output = output || [];
	    var idx = output.length;
	    for (var i = 0, length = getLength(input); i < length; i++) {
	      var value = input[i];
	      if (isArrayLike(value) && (isArray(value) || isArguments(value))) {
	        // Flatten current level of array or arguments object.
	        if (shallow) {
	          var j = 0, len = value.length;
	          while (j < len) output[idx++] = value[j++];
	        } else {
	          _flatten(value, shallow, strict, output);
	          idx = output.length;
	        }
	      } else if (!strict) {
	        output[idx++] = value;
	      }
	    }
	    return output;
	  }
	
	  // Flatten out an array, either recursively (by default), or just one level.
	  function flatten(array, shallow) {
	    return _flatten(array, shallow, false);
	  }
	
	  // Return a version of the array that does not contain the specified value(s).
	  var without = restArguments(function(array, otherArrays) {
	    return difference(array, otherArrays);
	  });
	
	  // Produce a duplicate-free version of the array. If the array has already
	  // been sorted, you have the option of using a faster algorithm.
	  // The faster algorithm will not work with an iteratee if the iteratee
	  // is not a one-to-one function, so providing an iteratee will disable
	  // the faster algorithm.
	  function uniq(array, isSorted, iteratee, context) {
	    if (!isBoolean(isSorted)) {
	      context = iteratee;
	      iteratee = isSorted;
	      isSorted = false;
	    }
	    if (iteratee != null) iteratee = cb(iteratee, context);
	    var result = [];
	    var seen = [];
	    for (var i = 0, length = getLength(array); i < length; i++) {
	      var value = array[i],
	          computed = iteratee ? iteratee(value, i, array) : value;
	      if (isSorted && !iteratee) {
	        if (!i || seen !== computed) result.push(value);
	        seen = computed;
	      } else if (iteratee) {
	        if (!contains(seen, computed)) {
	          seen.push(computed);
	          result.push(value);
	        }
	      } else if (!contains(result, value)) {
	        result.push(value);
	      }
	    }
	    return result;
	  }
	
	  // Produce an array that contains the union: each distinct element from all of
	  // the passed-in arrays.
	  var union = restArguments(function(arrays) {
	    return uniq(_flatten(arrays, true, true));
	  });
	
	  // Produce an array that contains every item shared between all the
	  // passed-in arrays.
	  function intersection(array) {
	    var result = [];
	    var argsLength = arguments.length;
	    for (var i = 0, length = getLength(array); i < length; i++) {
	      var item = array[i];
	      if (contains(result, item)) continue;
	      var j;
	      for (j = 1; j < argsLength; j++) {
	        if (!contains(arguments[j], item)) break;
	      }
	      if (j === argsLength) result.push(item);
	    }
	    return result;
	  }
	
	  // Take the difference between one array and a number of other arrays.
	  // Only the elements present in just the first array will remain.
	  var difference = restArguments(function(array, rest) {
	    rest = _flatten(rest, true, true);
	    return filter(array, function(value){
	      return !contains(rest, value);
	    });
	  });
	
	  // Complement of zip. Unzip accepts an array of arrays and groups
	  // each array's elements on shared indices.
	  function unzip(array) {
	    var length = array && max(array, getLength).length || 0;
	    var result = Array(length);
	
	    for (var index = 0; index < length; index++) {
	      result[index] = pluck(array, index);
	    }
	    return result;
	  }
	
	  // Zip together multiple lists into a single array -- elements that share
	  // an index go together.
	  var zip = restArguments(unzip);
	
	  // Converts lists into objects. Pass either a single array of `[key, value]`
	  // pairs, or two parallel arrays of the same length -- one of keys, and one of
	  // the corresponding values. Passing by pairs is the reverse of pairs.
	  function object(list, values) {
	    var result = {};
	    for (var i = 0, length = getLength(list); i < length; i++) {
	      if (values) {
	        result[list[i]] = values[i];
	      } else {
	        result[list[i][0]] = list[i][1];
	      }
	    }
	    return result;
	  }
	
	  // Generator function to create the findIndex and findLastIndex functions.
	  function createPredicateIndexFinder(dir) {
	    return function(array, predicate, context) {
	      predicate = cb(predicate, context);
	      var length = getLength(array);
	      var index = dir > 0 ? 0 : length - 1;
	      for (; index >= 0 && index < length; index += dir) {
	        if (predicate(array[index], index, array)) return index;
	      }
	      return -1;
	    };
	  }
	
	  // Returns the first index on an array-like that passes a predicate test.
	  var findIndex = createPredicateIndexFinder(1);
	  var findLastIndex = createPredicateIndexFinder(-1);
	
	  // Use a comparator function to figure out the smallest index at which
	  // an object should be inserted so as to maintain order. Uses binary search.
	  function sortedIndex(array, obj, iteratee, context) {
	    iteratee = cb(iteratee, context, 1);
	    var value = iteratee(obj);
	    var low = 0, high = getLength(array);
	    while (low < high) {
	      var mid = Math.floor((low + high) / 2);
	      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
	    }
	    return low;
	  }
	
	  // Generator function to create the indexOf and lastIndexOf functions.
	  function createIndexFinder(dir, predicateFind, sortedIndex) {
	    return function(array, item, idx) {
	      var i = 0, length = getLength(array);
	      if (typeof idx == 'number') {
	        if (dir > 0) {
	          i = idx >= 0 ? idx : Math.max(idx + length, i);
	        } else {
	          length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
	        }
	      } else if (sortedIndex && idx && length) {
	        idx = sortedIndex(array, item);
	        return array[idx] === item ? idx : -1;
	      }
	      if (item !== item) {
	        idx = predicateFind(slice.call(array, i, length), isNaN);
	        return idx >= 0 ? idx + i : -1;
	      }
	      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
	        if (array[idx] === item) return idx;
	      }
	      return -1;
	    };
	  }
	
	  // Return the position of the first occurrence of an item in an array,
	  // or -1 if the item is not included in the array.
	  // If the array is large and already in sort order, pass `true`
	  // for **isSorted** to use binary search.
	  var indexOf = createIndexFinder(1, findIndex, sortedIndex);
	  var lastIndexOf = createIndexFinder(-1, findLastIndex);
	
	  // Generate an integer Array containing an arithmetic progression. A port of
	  // the native Python `range()` function. See
	  // [the Python documentation](https://docs.python.org/library/functions.html#range).
	  function range(start, stop, step) {
	    if (stop == null) {
	      stop = start || 0;
	      start = 0;
	    }
	    if (!step) {
	      step = stop < start ? -1 : 1;
	    }
	
	    var length = Math.max(Math.ceil((stop - start) / step), 0);
	    var range = Array(length);
	
	    for (var idx = 0; idx < length; idx++, start += step) {
	      range[idx] = start;
	    }
	
	    return range;
	  }
	
	  // Chunk a single array into multiple arrays, each containing `count` or fewer
	  // items.
	  function chunk(array, count) {
	    if (count == null || count < 1) return [];
	    var result = [];
	    var i = 0, length = array.length;
	    while (i < length) {
	      result.push(slice.call(array, i, i += count));
	    }
	    return result;
	  }
	
	  // Function (ahem) Functions
	  // ------------------
	
	  // Determines whether to execute a function as a constructor
	  // or a normal function with the provided arguments.
	  function executeBound(sourceFunc, boundFunc, context, callingContext, args) {
	    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
	    var self = baseCreate(sourceFunc.prototype);
	    var result = sourceFunc.apply(self, args);
	    if (isObject(result)) return result;
	    return self;
	  }
	
	  // Create a function bound to a given object (assigning `this`, and arguments,
	  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
	  // available.
	  var bind = restArguments(function(func, context, args) {
	    if (!isFunction(func)) throw new TypeError('Bind must be called on a function');
	    var bound = restArguments(function(callArgs) {
	      return executeBound(func, bound, context, this, args.concat(callArgs));
	    });
	    return bound;
	  });
	
	  // Partially apply a function by creating a version that has had some of its
	  // arguments pre-filled, without changing its dynamic `this` context. _ acts
	  // as a placeholder by default, allowing any combination of arguments to be
	  // pre-filled. Set `partial.placeholder` for a custom placeholder argument.
	  var partial = restArguments(function(func, boundArgs) {
	    var placeholder = partial.placeholder;
	    var bound = function() {
	      var position = 0, length = boundArgs.length;
	      var args = Array(length);
	      for (var i = 0; i < length; i++) {
	        args[i] = boundArgs[i] === placeholder ? arguments[position++] : boundArgs[i];
	      }
	      while (position < arguments.length) args.push(arguments[position++]);
	      return executeBound(func, bound, this, this, args);
	    };
	    return bound;
	  });
	
	  partial.placeholder = _;
	
	  // Bind a number of an object's methods to that object. Remaining arguments
	  // are the method names to be bound. Useful for ensuring that all callbacks
	  // defined on an object belong to it.
	  var bindAll = restArguments(function(obj, _keys) {
	    _keys = _flatten(_keys, false, false);
	    var index = _keys.length;
	    if (index < 1) throw new Error('bindAll must be passed function names');
	    while (index--) {
	      var key = _keys[index];
	      obj[key] = bind(obj[key], obj);
	    }
	  });
	
	  // Memoize an expensive function by storing its results.
	  function memoize(func, hasher) {
	    var memoize = function(key) {
	      var cache = memoize.cache;
	      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
	      if (!_has(cache, address)) cache[address] = func.apply(this, arguments);
	      return cache[address];
	    };
	    memoize.cache = {};
	    return memoize;
	  }
	
	  // Delays a function for the given number of milliseconds, and then calls
	  // it with the arguments supplied.
	  var delay = restArguments(function(func, wait, args) {
	    return setTimeout(function() {
	      return func.apply(null, args);
	    }, wait);
	  });
	
	  // Defers a function, scheduling it to run after the current call stack has
	  // cleared.
	  var defer = partial(delay, _, 1);
	
	  // Returns a function, that, when invoked, will only be triggered at most once
	  // during a given window of time. Normally, the throttled function will run
	  // as much as it can, without ever going more than once per `wait` duration;
	  // but if you'd like to disable the execution on the leading edge, pass
	  // `{leading: false}`. To disable execution on the trailing edge, ditto.
	  function throttle(func, wait, options) {
	    var timeout, context, args, result;
	    var previous = 0;
	    if (!options) options = {};
	
	    var later = function() {
	      previous = options.leading === false ? 0 : now();
	      timeout = null;
	      result = func.apply(context, args);
	      if (!timeout) context = args = null;
	    };
	
	    var throttled = function() {
	      var _now = now();
	      if (!previous && options.leading === false) previous = _now;
	      var remaining = wait - (_now - previous);
	      context = this;
	      args = arguments;
	      if (remaining <= 0 || remaining > wait) {
	        if (timeout) {
	          clearTimeout(timeout);
	          timeout = null;
	        }
	        previous = _now;
	        result = func.apply(context, args);
	        if (!timeout) context = args = null;
	      } else if (!timeout && options.trailing !== false) {
	        timeout = setTimeout(later, remaining);
	      }
	      return result;
	    };
	
	    throttled.cancel = function() {
	      clearTimeout(timeout);
	      previous = 0;
	      timeout = context = args = null;
	    };
	
	    return throttled;
	  }
	
	  // Returns a function, that, as long as it continues to be invoked, will not
	  // be triggered. The function will be called after it stops being called for
	  // N milliseconds. If `immediate` is passed, trigger the function on the
	  // leading edge, instead of the trailing.
	  function debounce(func, wait, immediate) {
	    var timeout, result;
	
	    var later = function(context, args) {
	      timeout = null;
	      if (args) result = func.apply(context, args);
	    };
	
	    var debounced = restArguments(function(args) {
	      if (timeout) clearTimeout(timeout);
	      if (immediate) {
	        var callNow = !timeout;
	        timeout = setTimeout(later, wait);
	        if (callNow) result = func.apply(this, args);
	      } else {
	        timeout = delay(later, wait, this, args);
	      }
	
	      return result;
	    });
	
	    debounced.cancel = function() {
	      clearTimeout(timeout);
	      timeout = null;
	    };
	
	    return debounced;
	  }
	
	  // Returns the first function passed as an argument to the second,
	  // allowing you to adjust arguments, run code before and after, and
	  // conditionally execute the original function.
	  function wrap(func, wrapper) {
	    return partial(wrapper, func);
	  }
	
	  // Returns a negated version of the passed-in predicate.
	  function negate(predicate) {
	    return function() {
	      return !predicate.apply(this, arguments);
	    };
	  }
	
	  // Returns a function that is the composition of a list of functions, each
	  // consuming the return value of the function that follows.
	  function compose() {
	    var args = arguments;
	    var start = args.length - 1;
	    return function() {
	      var i = start;
	      var result = args[start].apply(this, arguments);
	      while (i--) result = args[i].call(this, result);
	      return result;
	    };
	  }
	
	  // Returns a function that will only be executed on and after the Nth call.
	  function after(times, func) {
	    return function() {
	      if (--times < 1) {
	        return func.apply(this, arguments);
	      }
	    };
	  }
	
	  // Returns a function that will only be executed up to (but not including) the Nth call.
	  function before(times, func) {
	    var memo;
	    return function() {
	      if (--times > 0) {
	        memo = func.apply(this, arguments);
	      }
	      if (times <= 1) func = null;
	      return memo;
	    };
	  }
	
	  // Returns a function that will be executed at most one time, no matter how
	  // often you call it. Useful for lazy initialization.
	  var once = partial(before, 2);
	
	  // Object Functions
	  // ----------------
	
	  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
	  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
	  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
	    'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];
	
	  function collectNonEnumProps(obj, _keys) {
	    var nonEnumIdx = nonEnumerableProps.length;
	    var constructor = obj.constructor;
	    var proto = isFunction(constructor) && constructor.prototype || ObjProto;
	
	    // Constructor is a special case.
	    var prop = 'constructor';
	    if (_has(obj, prop) && !contains(_keys, prop)) _keys.push(prop);
	
	    while (nonEnumIdx--) {
	      prop = nonEnumerableProps[nonEnumIdx];
	      if (prop in obj && obj[prop] !== proto[prop] && !contains(_keys, prop)) {
	        _keys.push(prop);
	      }
	    }
	  }
	
	  // Retrieve the names of an object's own properties.
	  // Delegates to **ECMAScript 5**'s native `Object.keys`.
	  function keys(obj) {
	    if (!isObject(obj)) return [];
	    if (nativeKeys) return nativeKeys(obj);
	    var _keys = [];
	    for (var key in obj) if (_has(obj, key)) _keys.push(key);
	    // Ahem, IE < 9.
	    if (hasEnumBug) collectNonEnumProps(obj, _keys);
	    return _keys;
	  }
	
	  // Retrieve all the property names of an object.
	  function allKeys(obj) {
	    if (!isObject(obj)) return [];
	    var _keys = [];
	    for (var key in obj) _keys.push(key);
	    // Ahem, IE < 9.
	    if (hasEnumBug) collectNonEnumProps(obj, _keys);
	    return _keys;
	  }
	
	  // Retrieve the values of an object's properties.
	  function values(obj) {
	    var _keys = keys(obj);
	    var length = _keys.length;
	    var values = Array(length);
	    for (var i = 0; i < length; i++) {
	      values[i] = obj[_keys[i]];
	    }
	    return values;
	  }
	
	  // Returns the results of applying the iteratee to each element of the object.
	  // In contrast to map it returns an object.
	  function mapObject(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    var _keys = keys(obj),
	        length = _keys.length,
	        results = {};
	    for (var index = 0; index < length; index++) {
	      var currentKey = _keys[index];
	      results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
	    }
	    return results;
	  }
	
	  // Convert an object into a list of `[key, value]` pairs.
	  // The opposite of object.
	  function pairs(obj) {
	    var _keys = keys(obj);
	    var length = _keys.length;
	    var pairs = Array(length);
	    for (var i = 0; i < length; i++) {
	      pairs[i] = [_keys[i], obj[_keys[i]]];
	    }
	    return pairs;
	  }
	
	  // Invert the keys and values of an object. The values must be serializable.
	  function invert(obj) {
	    var result = {};
	    var _keys = keys(obj);
	    for (var i = 0, length = _keys.length; i < length; i++) {
	      result[obj[_keys[i]]] = _keys[i];
	    }
	    return result;
	  }
	
	  // Return a sorted list of the function names available on the object.
	  function functions(obj) {
	    var names = [];
	    for (var key in obj) {
	      if (isFunction(obj[key])) names.push(key);
	    }
	    return names.sort();
	  }
	
	  // An internal function for creating assigner functions.
	  function createAssigner(keysFunc, defaults) {
	    return function(obj) {
	      var length = arguments.length;
	      if (defaults) obj = Object(obj);
	      if (length < 2 || obj == null) return obj;
	      for (var index = 1; index < length; index++) {
	        var source = arguments[index],
	            _keys = keysFunc(source),
	            l = _keys.length;
	        for (var i = 0; i < l; i++) {
	          var key = _keys[i];
	          if (!defaults || obj[key] === void 0) obj[key] = source[key];
	        }
	      }
	      return obj;
	    };
	  }
	
	  // Extend a given object with all the properties in passed-in object(s).
	  var extend = createAssigner(allKeys);
	
	  // Assigns a given object with all the own properties in the passed-in object(s).
	  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
	  var extendOwn = createAssigner(keys);
	
	  // Returns the first key on an object that passes a predicate test.
	  function findKey(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var _keys = keys(obj), key;
	    for (var i = 0, length = _keys.length; i < length; i++) {
	      key = _keys[i];
	      if (predicate(obj[key], key, obj)) return key;
	    }
	  }
	
	  // Internal pick helper function to determine if `obj` has key `key`.
	  function keyInObj(value, key, obj) {
	    return key in obj;
	  }
	
	  // Return a copy of the object only containing the whitelisted properties.
	  var pick = restArguments(function(obj, _keys) {
	    var result = {}, iteratee = _keys[0];
	    if (obj == null) return result;
	    if (isFunction(iteratee)) {
	      if (_keys.length > 1) iteratee = optimizeCb(iteratee, _keys[1]);
	      _keys = allKeys(obj);
	    } else {
	      iteratee = keyInObj;
	      _keys = _flatten(_keys, false, false);
	      obj = Object(obj);
	    }
	    for (var i = 0, length = _keys.length; i < length; i++) {
	      var key = _keys[i];
	      var value = obj[key];
	      if (iteratee(value, key, obj)) result[key] = value;
	    }
	    return result;
	  });
	
	  // Return a copy of the object without the blacklisted properties.
	  var omit = restArguments(function(obj, _keys) {
	    var iteratee = _keys[0], context;
	    if (isFunction(iteratee)) {
	      iteratee = negate(iteratee);
	      if (_keys.length > 1) context = _keys[1];
	    } else {
	      _keys = map(_flatten(_keys, false, false), String);
	      iteratee = function(value, key) {
	        return !contains(_keys, key);
	      };
	    }
	    return pick(obj, iteratee, context);
	  });
	
	  // Fill in a given object with default properties.
	  var defaults = createAssigner(allKeys, true);
	
	  // Creates an object that inherits from the given prototype object.
	  // If additional properties are provided then they will be added to the
	  // created object.
	  function create(prototype, props) {
	    var result = baseCreate(prototype);
	    if (props) extendOwn(result, props);
	    return result;
	  }
	
	  // Create a (shallow-cloned) duplicate of an object.
	  function clone(obj) {
	    if (!isObject(obj)) return obj;
	    return isArray(obj) ? obj.slice() : extend({}, obj);
	  }
	
	  // Invokes interceptor with the obj, and then returns obj.
	  // The primary purpose of this method is to "tap into" a method chain, in
	  // order to perform operations on intermediate results within the chain.
	  function tap(obj, interceptor) {
	    interceptor(obj);
	    return obj;
	  }
	
	  // Returns whether an object has a given set of `key:value` pairs.
	  function isMatch(object, attrs) {
	    var _keys = keys(attrs), length = _keys.length;
	    if (object == null) return !length;
	    var obj = Object(object);
	    for (var i = 0; i < length; i++) {
	      var key = _keys[i];
	      if (attrs[key] !== obj[key] || !(key in obj)) return false;
	    }
	    return true;
	  }
	
	
	  // Internal recursive comparison function for `isEqual`.
	  function eq(a, b, aStack, bStack) {
	    // Identical objects are equal. `0 === -0`, but they aren't identical.
	    // See the [Harmony `egal` proposal](https://wiki.ecmascript.org/doku.php?id=harmony:egal).
	    if (a === b) return a !== 0 || 1 / a === 1 / b;
	    // `null` or `undefined` only equal to itself (strict comparison).
	    if (a == null || b == null) return false;
	    // `NaN`s are equivalent, but non-reflexive.
	    if (a !== a) return b !== b;
	    // Exhaust primitive checks
	    var type = typeof a;
	    if (type !== 'function' && type !== 'object' && typeof b != 'object') return false;
	    return deepEq(a, b, aStack, bStack);
	  }
	
	  // Internal recursive comparison function for `isEqual`.
	  function deepEq(a, b, aStack, bStack) {
	    // Unwrap any wrapped objects.
	    if (a instanceof _) a = a._wrapped;
	    if (b instanceof _) b = b._wrapped;
	    // Compare `[[Class]]` names.
	    var className = toString.call(a);
	    if (className !== toString.call(b)) return false;
	    switch (className) {
	      // Strings, numbers, regular expressions, dates, and booleans are compared by value.
	      case '[object RegExp]':
	      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
	      case '[object String]':
	        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
	        // equivalent to `new String("5")`.
	        return '' + a === '' + b;
	      case '[object Number]':
	        // `NaN`s are equivalent, but non-reflexive.
	        // Object(NaN) is equivalent to NaN.
	        if (+a !== +a) return +b !== +b;
	        // An `egal` comparison is performed for other numeric values.
	        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
	      case '[object Date]':
	      case '[object Boolean]':
	        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
	        // millisecond representations. Note that invalid dates with millisecond representations
	        // of `NaN` are not equivalent.
	        return +a === +b;
	      case '[object Symbol]':
	        return SymbolProto.valueOf.call(a) === SymbolProto.valueOf.call(b);
	    }
	
	    var areArrays = className === '[object Array]';
	    if (!areArrays) {
	      if (typeof a != 'object' || typeof b != 'object') return false;
	
	      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
	      // from different frames are.
	      var aCtor = a.constructor, bCtor = b.constructor;
	      if (aCtor !== bCtor && !(isFunction(aCtor) && aCtor instanceof aCtor &&
	                               isFunction(bCtor) && bCtor instanceof bCtor)
	                          && ('constructor' in a && 'constructor' in b)) {
	        return false;
	      }
	    }
	    // Assume equality for cyclic structures. The algorithm for detecting cyclic
	    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
	
	    // Initializing stack of traversed objects.
	    // It's done here since we only need them for objects and arrays comparison.
	    aStack = aStack || [];
	    bStack = bStack || [];
	    var length = aStack.length;
	    while (length--) {
	      // Linear search. Performance is inversely proportional to the number of
	      // unique nested structures.
	      if (aStack[length] === a) return bStack[length] === b;
	    }
	
	    // Add the first object to the stack of traversed objects.
	    aStack.push(a);
	    bStack.push(b);
	
	    // Recursively compare objects and arrays.
	    if (areArrays) {
	      // Compare array lengths to determine if a deep comparison is necessary.
	      length = a.length;
	      if (length !== b.length) return false;
	      // Deep compare the contents, ignoring non-numeric properties.
	      while (length--) {
	        if (!eq(a[length], b[length], aStack, bStack)) return false;
	      }
	    } else {
	      // Deep compare objects.
	      var _keys = keys(a), key;
	      length = _keys.length;
	      // Ensure that both objects contain the same number of properties before comparing deep equality.
	      if (keys(b).length !== length) return false;
	      while (length--) {
	        // Deep compare each member
	        key = _keys[length];
	        if (!(_has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
	      }
	    }
	    // Remove the first object from the stack of traversed objects.
	    aStack.pop();
	    bStack.pop();
	    return true;
	  }
	
	  // Perform a deep comparison to check if two objects are equal.
	  function isEqual(a, b) {
	    return eq(a, b);
	  }
	
	  // Is a given array, string, or object empty?
	  // An "empty" object has no enumerable own-properties.
	  function isEmpty(obj) {
	    if (obj == null) return true;
	    if (isArrayLike(obj) && (isArray(obj) || isString(obj) || isArguments(obj))) return obj.length === 0;
	    return keys(obj).length === 0;
	  }
	
	  // Is a given value a DOM element?
	  function isElement(obj) {
	    return !!(obj && obj.nodeType === 1);
	  }
	
	  // Internal function for creating a toString-based type tester.
	  function tagTester(name) {
	    return function(obj) {
	      return toString.call(obj) === '[object ' + name + ']';
	    };
	  }
	
	  // Is a given value an array?
	  // Delegates to ECMA5's native Array.isArray
	  var isArray = nativeIsArray || tagTester('Array');
	
	  // Is a given variable an object?
	  function isObject(obj) {
	    var type = typeof obj;
	    return type === 'function' || type === 'object' && !!obj;
	  }
	
	  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError, isMap, isWeakMap, isSet, isWeakSet.
	  var isArguments = tagTester('Arguments');
	  var isFunction = tagTester('Function');
	  var isString = tagTester('String');
	  var isNumber = tagTester('Number');
	  var isDate = tagTester('Date');
	  var isRegExp = tagTester('RegExp');
	  var isError = tagTester('Error');
	  var isSymbol = tagTester('Symbol');
	  var isMap = tagTester('Map');
	  var isWeakMap = tagTester('WeakMap');
	  var isSet = tagTester('Set');
	  var isWeakSet = tagTester('WeakSet');
	
	  // Define a fallback version of the method in browsers (ahem, IE < 9), where
	  // there isn't any inspectable "Arguments" type.
	  (function() {
	    if (!isArguments(arguments)) {
	      isArguments = function(obj) {
	        return _has(obj, 'callee');
	      };
	    }
	  }());
	
	  // Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
	  // IE 11 (#1621), Safari 8 (#1929), and PhantomJS (#2236).
	  var nodelist = root.document && root.document.childNodes;
	  if (typeof /./ != 'function' && typeof Int8Array != 'object' && typeof nodelist != 'function') {
	    isFunction = function(obj) {
	      return typeof obj == 'function' || false;
	    };
	  }
	
	  // Is a given object a finite number?
	  function isFinite(obj) {
	    return !isSymbol(obj) && _isFinite(obj) && !_isNaN(parseFloat(obj));
	  }
	
	  // Is the given value `NaN`?
	  function isNaN(obj) {
	    return isNumber(obj) && _isNaN(obj);
	  }
	
	  // Is a given value a boolean?
	  function isBoolean(obj) {
	    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
	  }
	
	  // Is a given value equal to null?
	  function isNull(obj) {
	    return obj === null;
	  }
	
	  // Is a given variable undefined?
	  function isUndefined(obj) {
	    return obj === void 0;
	  }
	
	  // Shortcut function for checking if an object has a given property directly
	  // on itself (in other words, not on a prototype).
	  function has(obj, path) {
	    if (!isArray(path)) {
	      return _has(obj, path);
	    }
	    var length = path.length;
	    for (var i = 0; i < length; i++) {
	      var key = path[i];
	      if (obj == null || !hasOwnProperty.call(obj, key)) {
	        return false;
	      }
	      obj = obj[key];
	    }
	    return !!length;
	  }
	
	  // Utility Functions
	  // -----------------
	
	  // Keep the identity function around for default iteratees.
	  function identity(value) {
	    return value;
	  }
	
	  // Predicate-generating functions. Often useful outside of Underscore.
	  function constant(value) {
	    return function() {
	      return value;
	    };
	  }
	
	  function noop(){}
	
	  // Creates a function that, when passed an object, will traverse that object’s
	  // properties down the given `path`, specified as an array of keys or indexes.
	  function property(path) {
	    if (!isArray(path)) {
	      return shallowProperty(path);
	    }
	    return function(obj) {
	      return deepGet(obj, path);
	    };
	  }
	
	  // Generates a function for a given object that returns a given property.
	  function propertyOf(obj) {
	    if (obj == null) {
	      return function(){};
	    }
	    return function(path) {
	      return !isArray(path) ? obj[path] : deepGet(obj, path);
	    };
	  }
	
	  // Returns a predicate for checking whether an object has a given set of
	  // `key:value` pairs.
	  function matcher(attrs) {
	    attrs = extendOwn({}, attrs);
	    return function(obj) {
	      return isMatch(obj, attrs);
	    };
	  }
	
	  // Run a function **n** times.
	  function times(n, iteratee, context) {
	    var accum = Array(Math.max(0, n));
	    iteratee = optimizeCb(iteratee, context, 1);
	    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
	    return accum;
	  }
	
	  // Return a random integer between min and max (inclusive).
	  function random(min, max) {
	    if (max == null) {
	      max = min;
	      min = 0;
	    }
	    return min + Math.floor(Math.random() * (max - min + 1));
	  }
	
	  // A (possibly faster) way to get the current timestamp as an integer.
	  var now = Date.now || function() {
	    return new Date().getTime();
	  };
	
	  // List of HTML entities for escaping.
	  var escapeMap = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#x27;',
	    '`': '&#x60;'
	  };
	  var unescapeMap = invert(escapeMap);
	
	  // Functions for escaping and unescaping strings to/from HTML interpolation.
	  function createEscaper(map) {
	    var escaper = function(match) {
	      return map[match];
	    };
	    // Regexes for identifying a key that needs to be escaped.
	    var source = '(?:' + keys(map).join('|') + ')';
	    var testRegexp = RegExp(source);
	    var replaceRegexp = RegExp(source, 'g');
	    return function(string) {
	      string = string == null ? '' : '' + string;
	      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
	    };
	  }
	  var escape = createEscaper(escapeMap);
	  var unescape = createEscaper(unescapeMap);
	
	  // Traverses the children of `obj` along `path`. If a child is a function, it
	  // is invoked with its parent as context. Returns the value of the final
	  // child, or `fallback` if any child is undefined.
	  function result(obj, path, fallback) {
	    if (!isArray(path)) path = [path];
	    var length = path.length;
	    if (!length) {
	      return isFunction(fallback) ? fallback.call(obj) : fallback;
	    }
	    for (var i = 0; i < length; i++) {
	      var prop = obj == null ? void 0 : obj[path[i]];
	      if (prop === void 0) {
	        prop = fallback;
	        i = length; // Ensure we don't continue iterating.
	      }
	      obj = isFunction(prop) ? prop.call(obj) : prop;
	    }
	    return obj;
	  }
	
	  // Generate a unique integer id (unique within the entire client session).
	  // Useful for temporary DOM ids.
	  var idCounter = 0;
	  function uniqueId(prefix) {
	    var id = ++idCounter + '';
	    return prefix ? prefix + id : id;
	  }
	
	  // By default, Underscore uses ERB-style template delimiters, change the
	  // following template settings to use alternative delimiters.
	  var templateSettings = _.templateSettings = {
	    evaluate: /<%([\s\S]+?)%>/g,
	    interpolate: /<%=([\s\S]+?)%>/g,
	    escape: /<%-([\s\S]+?)%>/g
	  };
	
	  // When customizing `templateSettings`, if you don't want to define an
	  // interpolation, evaluation or escaping regex, we need one that is
	  // guaranteed not to match.
	  var noMatch = /(.)^/;
	
	  // Certain characters need to be escaped so that they can be put into a
	  // string literal.
	  var escapes = {
	    "'": "'",
	    '\\': '\\',
	    '\r': 'r',
	    '\n': 'n',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  var escapeRegExp = /\\|'|\r|\n|\u2028|\u2029/g;
	
	  var escapeChar = function(match) {
	    return '\\' + escapes[match];
	  };
	
	  // JavaScript micro-templating, similar to John Resig's implementation.
	  // Underscore templating handles arbitrary delimiters, preserves whitespace,
	  // and correctly escapes quotes within interpolated code.
	  // NB: `oldSettings` only exists for backwards compatibility.
	  function template(text, settings, oldSettings) {
	    if (!settings && oldSettings) settings = oldSettings;
	    settings = defaults({}, settings, _.templateSettings);
	
	    // Combine delimiters into one regular expression via alternation.
	    var matcher = RegExp([
	      (settings.escape || noMatch).source,
	      (settings.interpolate || noMatch).source,
	      (settings.evaluate || noMatch).source
	    ].join('|') + '|$', 'g');
	
	    // Compile the template source, escaping string literals appropriately.
	    var index = 0;
	    var source = "__p+='";
	    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
	      source += text.slice(index, offset).replace(escapeRegExp, escapeChar);
	      index = offset + match.length;
	
	      if (escape) {
	        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
	      } else if (interpolate) {
	        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
	      } else if (evaluate) {
	        source += "';\n" + evaluate + "\n__p+='";
	      }
	
	      // Adobe VMs need the match returned to produce the correct offset.
	      return match;
	    });
	    source += "';\n";
	
	    // If a variable is not specified, place data values in local scope.
	    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';
	
	    source = "var __t,__p='',__j=Array.prototype.join," +
	      "print=function(){__p+=__j.call(arguments,'');};\n" +
	      source + 'return __p;\n';
	
	    var render;
	    try {
	      render = new Function(settings.variable || 'obj', '_', source);
	    } catch (e) {
	      e.source = source;
	      throw e;
	    }
	
	    var template = function(data) {
	      return render.call(this, data, _);
	    };
	
	    // Provide the compiled source as a convenience for precompilation.
	    var argument = settings.variable || 'obj';
	    template.source = 'function(' + argument + '){\n' + source + '}';
	
	    return template;
	  }
	
	  // Add a "chain" function. Start chaining a wrapped Underscore object.
	  function chain(obj) {
	    var instance = _(obj);
	    instance._chain = true;
	    return instance;
	  }
	
	  // OOP
	  // ---------------
	  // If Underscore is called as a function, it returns a wrapped object that
	  // can be used OO-style. This wrapper holds altered versions of all the
	  // underscore functions. Wrapped objects may be chained.
	
	  // Helper function to continue chaining intermediate results.
	  function chainResult(instance, obj) {
	    return instance._chain ? _(obj).chain() : obj;
	  }
	
	  // Add your own custom functions to the Underscore object.
	  function mixin(obj) {
	    each(functions(obj), function(name) {
	      var func = _[name] = obj[name];
	      _.prototype[name] = function() {
	        var args = [this._wrapped];
	        push.apply(args, arguments);
	        return chainResult(this, func.apply(_, args));
	      };
	    });
	    return _;
	  }
	
	  // Add all mutator Array functions to the wrapper.
	  each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
	    var method = ArrayProto[name];
	    _.prototype[name] = function() {
	      var obj = this._wrapped;
	      method.apply(obj, arguments);
	      if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
	      return chainResult(this, obj);
	    };
	  });
	
	  // Add all accessor Array functions to the wrapper.
	  each(['concat', 'join', 'slice'], function(name) {
	    var method = ArrayProto[name];
	    _.prototype[name] = function() {
	      return chainResult(this, method.apply(this._wrapped, arguments));
	    };
	  });
	
	  // Extracts the result from a wrapped and chained object.
	  _.prototype.value = function() {
	    return this._wrapped;
	  };
	
	  // Provide unwrapping proxy for some methods used in engine operations
	  // such as arithmetic and JSON stringification.
	  _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;
	
	  _.prototype.toString = function() {
	    return String(this._wrapped);
	  };
	
	  var allExports = ({
	    'default': _,
	    VERSION: VERSION,
	    iteratee: iteratee,
	    restArguments: restArguments,
	    each: each,
	    forEach: each,
	    map: map,
	    collect: map,
	    reduce: reduce,
	    foldl: reduce,
	    inject: reduce,
	    reduceRight: reduceRight,
	    foldr: reduceRight,
	    find: find,
	    detect: find,
	    filter: filter,
	    select: filter,
	    reject: reject,
	    every: every,
	    all: every,
	    some: some,
	    any: some,
	    contains: contains,
	    includes: contains,
	    include: contains,
	    invoke: invoke,
	    pluck: pluck,
	    where: where,
	    findWhere: findWhere,
	    max: max,
	    min: min,
	    shuffle: shuffle,
	    sample: sample,
	    sortBy: sortBy,
	    groupBy: groupBy,
	    indexBy: indexBy,
	    countBy: countBy,
	    toArray: toArray,
	    size: size,
	    partition: partition,
	    first: first,
	    head: first,
	    take: first,
	    initial: initial,
	    last: last,
	    rest: rest,
	    tail: rest,
	    drop: rest,
	    compact: compact,
	    flatten: flatten,
	    without: without,
	    uniq: uniq,
	    unique: uniq,
	    union: union,
	    intersection: intersection,
	    difference: difference,
	    unzip: unzip,
	    zip: zip,
	    object: object,
	    findIndex: findIndex,
	    findLastIndex: findLastIndex,
	    sortedIndex: sortedIndex,
	    indexOf: indexOf,
	    lastIndexOf: lastIndexOf,
	    range: range,
	    chunk: chunk,
	    bind: bind,
	    partial: partial,
	    bindAll: bindAll,
	    memoize: memoize,
	    delay: delay,
	    defer: defer,
	    throttle: throttle,
	    debounce: debounce,
	    wrap: wrap,
	    negate: negate,
	    compose: compose,
	    after: after,
	    before: before,
	    once: once,
	    keys: keys,
	    allKeys: allKeys,
	    values: values,
	    mapObject: mapObject,
	    pairs: pairs,
	    invert: invert,
	    functions: functions,
	    methods: functions,
	    extend: extend,
	    extendOwn: extendOwn,
	    assign: extendOwn,
	    findKey: findKey,
	    pick: pick,
	    omit: omit,
	    defaults: defaults,
	    create: create,
	    clone: clone,
	    tap: tap,
	    isMatch: isMatch,
	    isEqual: isEqual,
	    isEmpty: isEmpty,
	    isElement: isElement,
	    isArray: isArray,
	    isObject: isObject,
	    isArguments: isArguments,
	    isFunction: isFunction,
	    isString: isString,
	    isNumber: isNumber,
	    isDate: isDate,
	    isRegExp: isRegExp,
	    isError: isError,
	    isSymbol: isSymbol,
	    isMap: isMap,
	    isWeakMap: isWeakMap,
	    isSet: isSet,
	    isWeakSet: isWeakSet,
	    isFinite: isFinite,
	    isNaN: isNaN,
	    isBoolean: isBoolean,
	    isNull: isNull,
	    isUndefined: isUndefined,
	    has: has,
	    identity: identity,
	    constant: constant,
	    noop: noop,
	    property: property,
	    propertyOf: propertyOf,
	    matcher: matcher,
	    matches: matcher,
	    times: times,
	    random: random,
	    now: now,
	    escape: escape,
	    unescape: unescape,
	    result: result,
	    uniqueId: uniqueId,
	    templateSettings: templateSettings,
	    template: template,
	    chain: chain,
	    mixin: mixin
	  });
	
	  // Add all of the Underscore functions to the wrapper object.
	  var _$1 = mixin(allExports);
	  // Legacy Node.js API
	  _$1._ = _$1;
	
	  return _$1;
	
	})));
	//# sourceMappingURL=underscore.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3e1af3ef546b9e6ecef9f3ba197bf7d2.ttf";

/***/ }),
/* 921 */
/***/ (function(module, exports) {

	module.exports = function isBuffer(arg) {
	  return arg && typeof arg === 'object'
	    && typeof arg.copy === 'function'
	    && typeof arg.fill === 'function'
	    && typeof arg.readUInt8 === 'function';
	}

/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var formatRegExp = /%[sdj%]/g;
	exports.format = function(f) {
	  if (!isString(f)) {
	    var objects = [];
	    for (var i = 0; i < arguments.length; i++) {
	      objects.push(inspect(arguments[i]));
	    }
	    return objects.join(' ');
	  }
	
	  var i = 1;
	  var args = arguments;
	  var len = args.length;
	  var str = String(f).replace(formatRegExp, function(x) {
	    if (x === '%%') return '%';
	    if (i >= len) return x;
	    switch (x) {
	      case '%s': return String(args[i++]);
	      case '%d': return Number(args[i++]);
	      case '%j':
	        try {
	          return JSON.stringify(args[i++]);
	        } catch (_) {
	          return '[Circular]';
	        }
	      default:
	        return x;
	    }
	  });
	  for (var x = args[i]; i < len; x = args[++i]) {
	    if (isNull(x) || !isObject(x)) {
	      str += ' ' + x;
	    } else {
	      str += ' ' + inspect(x);
	    }
	  }
	  return str;
	};
	
	
	// Mark that a method should not be used.
	// Returns a modified function which warns once by default.
	// If --no-deprecation is set, then it is a no-op.
	exports.deprecate = function(fn, msg) {
	  // Allow for deprecating things in the process of starting up.
	  if (isUndefined(global.process)) {
	    return function() {
	      return exports.deprecate(fn, msg).apply(this, arguments);
	    };
	  }
	
	  if (process.noDeprecation === true) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (process.throwDeprecation) {
	        throw new Error(msg);
	      } else if (process.traceDeprecation) {
	        console.trace(msg);
	      } else {
	        console.error(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	};
	
	
	var debugs = {};
	var debugEnviron;
	exports.debuglog = function(set) {
	  if (isUndefined(debugEnviron))
	    debugEnviron = ({"NODE_ENV":"production"}).NODE_DEBUG || '';
	  set = set.toUpperCase();
	  if (!debugs[set]) {
	    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
	      var pid = process.pid;
	      debugs[set] = function() {
	        var msg = exports.format.apply(exports, arguments);
	        console.error('%s %d: %s', set, pid, msg);
	      };
	    } else {
	      debugs[set] = function() {};
	    }
	  }
	  return debugs[set];
	};
	
	
	/**
	 * Echos the value of a value. Trys to print the value out
	 * in the best way possible given the different types.
	 *
	 * @param {Object} obj The object to print out.
	 * @param {Object} opts Optional options object that alters the output.
	 */
	/* legacy: obj, showHidden, depth, colors*/
	function inspect(obj, opts) {
	  // default options
	  var ctx = {
	    seen: [],
	    stylize: stylizeNoColor
	  };
	  // legacy...
	  if (arguments.length >= 3) ctx.depth = arguments[2];
	  if (arguments.length >= 4) ctx.colors = arguments[3];
	  if (isBoolean(opts)) {
	    // legacy...
	    ctx.showHidden = opts;
	  } else if (opts) {
	    // got an "options" object
	    exports._extend(ctx, opts);
	  }
	  // set default options
	  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
	  if (isUndefined(ctx.depth)) ctx.depth = 2;
	  if (isUndefined(ctx.colors)) ctx.colors = false;
	  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
	  if (ctx.colors) ctx.stylize = stylizeWithColor;
	  return formatValue(ctx, obj, ctx.depth);
	}
	exports.inspect = inspect;
	
	
	// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
	inspect.colors = {
	  'bold' : [1, 22],
	  'italic' : [3, 23],
	  'underline' : [4, 24],
	  'inverse' : [7, 27],
	  'white' : [37, 39],
	  'grey' : [90, 39],
	  'black' : [30, 39],
	  'blue' : [34, 39],
	  'cyan' : [36, 39],
	  'green' : [32, 39],
	  'magenta' : [35, 39],
	  'red' : [31, 39],
	  'yellow' : [33, 39]
	};
	
	// Don't use 'blue' not visible on cmd.exe
	inspect.styles = {
	  'special': 'cyan',
	  'number': 'yellow',
	  'boolean': 'yellow',
	  'undefined': 'grey',
	  'null': 'bold',
	  'string': 'green',
	  'date': 'magenta',
	  // "name": intentionally not styling
	  'regexp': 'red'
	};
	
	
	function stylizeWithColor(str, styleType) {
	  var style = inspect.styles[styleType];
	
	  if (style) {
	    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
	           '\u001b[' + inspect.colors[style][1] + 'm';
	  } else {
	    return str;
	  }
	}
	
	
	function stylizeNoColor(str, styleType) {
	  return str;
	}
	
	
	function arrayToHash(array) {
	  var hash = {};
	
	  array.forEach(function(val, idx) {
	    hash[val] = true;
	  });
	
	  return hash;
	}
	
	
	function formatValue(ctx, value, recurseTimes) {
	  // Provide a hook for user-specified inspect functions.
	  // Check that value is an object with an inspect function on it
	  if (ctx.customInspect &&
	      value &&
	      isFunction(value.inspect) &&
	      // Filter out the util module, it's inspect function is special
	      value.inspect !== exports.inspect &&
	      // Also filter out any prototype objects using the circular check.
	      !(value.constructor && value.constructor.prototype === value)) {
	    var ret = value.inspect(recurseTimes, ctx);
	    if (!isString(ret)) {
	      ret = formatValue(ctx, ret, recurseTimes);
	    }
	    return ret;
	  }
	
	  // Primitive types cannot have properties
	  var primitive = formatPrimitive(ctx, value);
	  if (primitive) {
	    return primitive;
	  }
	
	  // Look up the keys of the object.
	  var keys = Object.keys(value);
	  var visibleKeys = arrayToHash(keys);
	
	  if (ctx.showHidden) {
	    keys = Object.getOwnPropertyNames(value);
	  }
	
	  // IE doesn't make error fields non-enumerable
	  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
	  if (isError(value)
	      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
	    return formatError(value);
	  }
	
	  // Some type of object without properties can be shortcutted.
	  if (keys.length === 0) {
	    if (isFunction(value)) {
	      var name = value.name ? ': ' + value.name : '';
	      return ctx.stylize('[Function' + name + ']', 'special');
	    }
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    }
	    if (isDate(value)) {
	      return ctx.stylize(Date.prototype.toString.call(value), 'date');
	    }
	    if (isError(value)) {
	      return formatError(value);
	    }
	  }
	
	  var base = '', array = false, braces = ['{', '}'];
	
	  // Make Array say that they are Array
	  if (isArray(value)) {
	    array = true;
	    braces = ['[', ']'];
	  }
	
	  // Make functions say that they are functions
	  if (isFunction(value)) {
	    var n = value.name ? ': ' + value.name : '';
	    base = ' [Function' + n + ']';
	  }
	
	  // Make RegExps say that they are RegExps
	  if (isRegExp(value)) {
	    base = ' ' + RegExp.prototype.toString.call(value);
	  }
	
	  // Make dates with properties first say the date
	  if (isDate(value)) {
	    base = ' ' + Date.prototype.toUTCString.call(value);
	  }
	
	  // Make error with message first say the error
	  if (isError(value)) {
	    base = ' ' + formatError(value);
	  }
	
	  if (keys.length === 0 && (!array || value.length == 0)) {
	    return braces[0] + base + braces[1];
	  }
	
	  if (recurseTimes < 0) {
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    } else {
	      return ctx.stylize('[Object]', 'special');
	    }
	  }
	
	  ctx.seen.push(value);
	
	  var output;
	  if (array) {
	    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
	  } else {
	    output = keys.map(function(key) {
	      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
	    });
	  }
	
	  ctx.seen.pop();
	
	  return reduceToSingleString(output, base, braces);
	}
	
	
	function formatPrimitive(ctx, value) {
	  if (isUndefined(value))
	    return ctx.stylize('undefined', 'undefined');
	  if (isString(value)) {
	    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
	                                             .replace(/'/g, "\\'")
	                                             .replace(/\\"/g, '"') + '\'';
	    return ctx.stylize(simple, 'string');
	  }
	  if (isNumber(value))
	    return ctx.stylize('' + value, 'number');
	  if (isBoolean(value))
	    return ctx.stylize('' + value, 'boolean');
	  // For some reason typeof null is "object", so special case here.
	  if (isNull(value))
	    return ctx.stylize('null', 'null');
	}
	
	
	function formatError(value) {
	  return '[' + Error.prototype.toString.call(value) + ']';
	}
	
	
	function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
	  var output = [];
	  for (var i = 0, l = value.length; i < l; ++i) {
	    if (hasOwnProperty(value, String(i))) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          String(i), true));
	    } else {
	      output.push('');
	    }
	  }
	  keys.forEach(function(key) {
	    if (!key.match(/^\d+$/)) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          key, true));
	    }
	  });
	  return output;
	}
	
	
	function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
	  var name, str, desc;
	  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
	  if (desc.get) {
	    if (desc.set) {
	      str = ctx.stylize('[Getter/Setter]', 'special');
	    } else {
	      str = ctx.stylize('[Getter]', 'special');
	    }
	  } else {
	    if (desc.set) {
	      str = ctx.stylize('[Setter]', 'special');
	    }
	  }
	  if (!hasOwnProperty(visibleKeys, key)) {
	    name = '[' + key + ']';
	  }
	  if (!str) {
	    if (ctx.seen.indexOf(desc.value) < 0) {
	      if (isNull(recurseTimes)) {
	        str = formatValue(ctx, desc.value, null);
	      } else {
	        str = formatValue(ctx, desc.value, recurseTimes - 1);
	      }
	      if (str.indexOf('\n') > -1) {
	        if (array) {
	          str = str.split('\n').map(function(line) {
	            return '  ' + line;
	          }).join('\n').substr(2);
	        } else {
	          str = '\n' + str.split('\n').map(function(line) {
	            return '   ' + line;
	          }).join('\n');
	        }
	      }
	    } else {
	      str = ctx.stylize('[Circular]', 'special');
	    }
	  }
	  if (isUndefined(name)) {
	    if (array && key.match(/^\d+$/)) {
	      return str;
	    }
	    name = JSON.stringify('' + key);
	    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
	      name = name.substr(1, name.length - 2);
	      name = ctx.stylize(name, 'name');
	    } else {
	      name = name.replace(/'/g, "\\'")
	                 .replace(/\\"/g, '"')
	                 .replace(/(^"|"$)/g, "'");
	      name = ctx.stylize(name, 'string');
	    }
	  }
	
	  return name + ': ' + str;
	}
	
	
	function reduceToSingleString(output, base, braces) {
	  var numLinesEst = 0;
	  var length = output.reduce(function(prev, cur) {
	    numLinesEst++;
	    if (cur.indexOf('\n') >= 0) numLinesEst++;
	    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
	  }, 0);
	
	  if (length > 60) {
	    return braces[0] +
	           (base === '' ? '' : base + '\n ') +
	           ' ' +
	           output.join(',\n  ') +
	           ' ' +
	           braces[1];
	  }
	
	  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
	}
	
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	function isArray(ar) {
	  return Array.isArray(ar);
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return isObject(re) && objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return isObject(d) && objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return isObject(e) &&
	      (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = __webpack_require__(921);
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	
	function pad(n) {
	  return n < 10 ? '0' + n.toString(10) : n.toString(10);
	}
	
	
	var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
	              'Oct', 'Nov', 'Dec'];
	
	// 26 Feb 16:19:34
	function timestamp() {
	  var d = new Date();
	  var time = [pad(d.getHours()),
	              pad(d.getMinutes()),
	              pad(d.getSeconds())].join(':');
	  return [d.getDate(), months[d.getMonth()], time].join(' ');
	}
	
	
	// log is just a thin wrapper to console.log that prepends a timestamp
	exports.log = function() {
	  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
	};
	
	
	/**
	 * Inherit the prototype methods from one constructor into another.
	 *
	 * The Function.prototype.inherits from lang.js rewritten as a standalone
	 * function (not on Function.prototype). NOTE: If this file is to be loaded
	 * during bootstrapping this function needs to be rewritten using some native
	 * functions as prototype setup using normal JavaScript does not work as
	 * expected during bootstrapping (see mirror.js in r114903).
	 *
	 * @param {function} ctor Constructor function which needs to inherit the
	 *     prototype.
	 * @param {function} superCtor Constructor function to inherit prototype from.
	 */
	exports.inherits = __webpack_require__(398);
	
	exports._extend = function(origin, add) {
	  // Don't do anything if add isn't an object
	  if (!add || !isObject(add)) return origin;
	
	  var keys = Object.keys(add);
	  var i = keys.length;
	  while (i--) {
	    origin[keys[i]] = add[keys[i]];
	  }
	  return origin;
	};
	
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(45)))

/***/ }),
/* 923 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	/*
	 * Browser-compatible JavaScript MD5
	 *
	 * Modification of JavaScript MD5
	 * https://github.com/blueimp/JavaScript-MD5
	 *
	 * Copyright 2011, Sebastian Tschan
	 * https://blueimp.net
	 *
	 * Licensed under the MIT license:
	 * https://opensource.org/licenses/MIT
	 *
	 * Based on
	 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
	 * Digest Algorithm, as defined in RFC 1321.
	 * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 * Distributed under the BSD License
	 * See http://pajhome.org.uk/crypt/md5 for more info.
	 */
	function md5(bytes) {
	  if (typeof bytes == 'string') {
	    var msg = unescape(encodeURIComponent(bytes)); // UTF8 escape
	
	    bytes = new Array(msg.length);
	
	    for (var i = 0; i < msg.length; i++) bytes[i] = msg.charCodeAt(i);
	  }
	
	  return md5ToHexEncodedArray(wordsToMd5(bytesToWords(bytes), bytes.length * 8));
	}
	/*
	 * Convert an array of little-endian words to an array of bytes
	 */
	
	
	function md5ToHexEncodedArray(input) {
	  var i;
	  var x;
	  var output = [];
	  var length32 = input.length * 32;
	  var hexTab = '0123456789abcdef';
	  var hex;
	
	  for (i = 0; i < length32; i += 8) {
	    x = input[i >> 5] >>> i % 32 & 0xff;
	    hex = parseInt(hexTab.charAt(x >>> 4 & 0x0f) + hexTab.charAt(x & 0x0f), 16);
	    output.push(hex);
	  }
	
	  return output;
	}
	/*
	 * Calculate the MD5 of an array of little-endian words, and a bit length.
	 */
	
	
	function wordsToMd5(x, len) {
	  /* append padding */
	  x[len >> 5] |= 0x80 << len % 32;
	  x[(len + 64 >>> 9 << 4) + 14] = len;
	  var i;
	  var olda;
	  var oldb;
	  var oldc;
	  var oldd;
	  var a = 1732584193;
	  var b = -271733879;
	  var c = -1732584194;
	  var d = 271733878;
	
	  for (i = 0; i < x.length; i += 16) {
	    olda = a;
	    oldb = b;
	    oldc = c;
	    oldd = d;
	    a = md5ff(a, b, c, d, x[i], 7, -680876936);
	    d = md5ff(d, a, b, c, x[i + 1], 12, -389564586);
	    c = md5ff(c, d, a, b, x[i + 2], 17, 606105819);
	    b = md5ff(b, c, d, a, x[i + 3], 22, -1044525330);
	    a = md5ff(a, b, c, d, x[i + 4], 7, -176418897);
	    d = md5ff(d, a, b, c, x[i + 5], 12, 1200080426);
	    c = md5ff(c, d, a, b, x[i + 6], 17, -1473231341);
	    b = md5ff(b, c, d, a, x[i + 7], 22, -45705983);
	    a = md5ff(a, b, c, d, x[i + 8], 7, 1770035416);
	    d = md5ff(d, a, b, c, x[i + 9], 12, -1958414417);
	    c = md5ff(c, d, a, b, x[i + 10], 17, -42063);
	    b = md5ff(b, c, d, a, x[i + 11], 22, -1990404162);
	    a = md5ff(a, b, c, d, x[i + 12], 7, 1804603682);
	    d = md5ff(d, a, b, c, x[i + 13], 12, -40341101);
	    c = md5ff(c, d, a, b, x[i + 14], 17, -1502002290);
	    b = md5ff(b, c, d, a, x[i + 15], 22, 1236535329);
	    a = md5gg(a, b, c, d, x[i + 1], 5, -165796510);
	    d = md5gg(d, a, b, c, x[i + 6], 9, -1069501632);
	    c = md5gg(c, d, a, b, x[i + 11], 14, 643717713);
	    b = md5gg(b, c, d, a, x[i], 20, -373897302);
	    a = md5gg(a, b, c, d, x[i + 5], 5, -701558691);
	    d = md5gg(d, a, b, c, x[i + 10], 9, 38016083);
	    c = md5gg(c, d, a, b, x[i + 15], 14, -660478335);
	    b = md5gg(b, c, d, a, x[i + 4], 20, -405537848);
	    a = md5gg(a, b, c, d, x[i + 9], 5, 568446438);
	    d = md5gg(d, a, b, c, x[i + 14], 9, -1019803690);
	    c = md5gg(c, d, a, b, x[i + 3], 14, -187363961);
	    b = md5gg(b, c, d, a, x[i + 8], 20, 1163531501);
	    a = md5gg(a, b, c, d, x[i + 13], 5, -1444681467);
	    d = md5gg(d, a, b, c, x[i + 2], 9, -51403784);
	    c = md5gg(c, d, a, b, x[i + 7], 14, 1735328473);
	    b = md5gg(b, c, d, a, x[i + 12], 20, -1926607734);
	    a = md5hh(a, b, c, d, x[i + 5], 4, -378558);
	    d = md5hh(d, a, b, c, x[i + 8], 11, -2022574463);
	    c = md5hh(c, d, a, b, x[i + 11], 16, 1839030562);
	    b = md5hh(b, c, d, a, x[i + 14], 23, -35309556);
	    a = md5hh(a, b, c, d, x[i + 1], 4, -1530992060);
	    d = md5hh(d, a, b, c, x[i + 4], 11, 1272893353);
	    c = md5hh(c, d, a, b, x[i + 7], 16, -155497632);
	    b = md5hh(b, c, d, a, x[i + 10], 23, -1094730640);
	    a = md5hh(a, b, c, d, x[i + 13], 4, 681279174);
	    d = md5hh(d, a, b, c, x[i], 11, -358537222);
	    c = md5hh(c, d, a, b, x[i + 3], 16, -722521979);
	    b = md5hh(b, c, d, a, x[i + 6], 23, 76029189);
	    a = md5hh(a, b, c, d, x[i + 9], 4, -640364487);
	    d = md5hh(d, a, b, c, x[i + 12], 11, -421815835);
	    c = md5hh(c, d, a, b, x[i + 15], 16, 530742520);
	    b = md5hh(b, c, d, a, x[i + 2], 23, -995338651);
	    a = md5ii(a, b, c, d, x[i], 6, -198630844);
	    d = md5ii(d, a, b, c, x[i + 7], 10, 1126891415);
	    c = md5ii(c, d, a, b, x[i + 14], 15, -1416354905);
	    b = md5ii(b, c, d, a, x[i + 5], 21, -57434055);
	    a = md5ii(a, b, c, d, x[i + 12], 6, 1700485571);
	    d = md5ii(d, a, b, c, x[i + 3], 10, -1894986606);
	    c = md5ii(c, d, a, b, x[i + 10], 15, -1051523);
	    b = md5ii(b, c, d, a, x[i + 1], 21, -2054922799);
	    a = md5ii(a, b, c, d, x[i + 8], 6, 1873313359);
	    d = md5ii(d, a, b, c, x[i + 15], 10, -30611744);
	    c = md5ii(c, d, a, b, x[i + 6], 15, -1560198380);
	    b = md5ii(b, c, d, a, x[i + 13], 21, 1309151649);
	    a = md5ii(a, b, c, d, x[i + 4], 6, -145523070);
	    d = md5ii(d, a, b, c, x[i + 11], 10, -1120210379);
	    c = md5ii(c, d, a, b, x[i + 2], 15, 718787259);
	    b = md5ii(b, c, d, a, x[i + 9], 21, -343485551);
	    a = safeAdd(a, olda);
	    b = safeAdd(b, oldb);
	    c = safeAdd(c, oldc);
	    d = safeAdd(d, oldd);
	  }
	
	  return [a, b, c, d];
	}
	/*
	 * Convert an array bytes to an array of little-endian words
	 * Characters >255 have their high-byte silently ignored.
	 */
	
	
	function bytesToWords(input) {
	  var i;
	  var output = [];
	  output[(input.length >> 2) - 1] = undefined;
	
	  for (i = 0; i < output.length; i += 1) {
	    output[i] = 0;
	  }
	
	  var length8 = input.length * 8;
	
	  for (i = 0; i < length8; i += 8) {
	    output[i >> 5] |= (input[i / 8] & 0xff) << i % 32;
	  }
	
	  return output;
	}
	/*
	 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
	 * to work around bugs in some JS interpreters.
	 */
	
	
	function safeAdd(x, y) {
	  var lsw = (x & 0xffff) + (y & 0xffff);
	  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
	  return msw << 16 | lsw & 0xffff;
	}
	/*
	 * Bitwise rotate a 32-bit number to the left.
	 */
	
	
	function bitRotateLeft(num, cnt) {
	  return num << cnt | num >>> 32 - cnt;
	}
	/*
	 * These functions implement the four basic operations the algorithm uses.
	 */
	
	
	function md5cmn(q, a, b, x, s, t) {
	  return safeAdd(bitRotateLeft(safeAdd(safeAdd(a, q), safeAdd(x, t)), s), b);
	}
	
	function md5ff(a, b, c, d, x, s, t) {
	  return md5cmn(b & c | ~b & d, a, b, x, s, t);
	}
	
	function md5gg(a, b, c, d, x, s, t) {
	  return md5cmn(b & d | c & ~d, a, b, x, s, t);
	}
	
	function md5hh(a, b, c, d, x, s, t) {
	  return md5cmn(b ^ c ^ d, a, b, x, s, t);
	}
	
	function md5ii(a, b, c, d, x, s, t) {
	  return md5cmn(c ^ (b | ~d), a, b, x, s, t);
	}
	
	var _default = md5;
	exports.default = _default;

/***/ }),
/* 924 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	// Adapted from Chris Veness' SHA1 code at
	// http://www.movable-type.co.uk/scripts/sha1.html
	function f(s, x, y, z) {
	  switch (s) {
	    case 0:
	      return x & y ^ ~x & z;
	
	    case 1:
	      return x ^ y ^ z;
	
	    case 2:
	      return x & y ^ x & z ^ y & z;
	
	    case 3:
	      return x ^ y ^ z;
	  }
	}
	
	function ROTL(x, n) {
	  return x << n | x >>> 32 - n;
	}
	
	function sha1(bytes) {
	  var K = [0x5a827999, 0x6ed9eba1, 0x8f1bbcdc, 0xca62c1d6];
	  var H = [0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0];
	
	  if (typeof bytes == 'string') {
	    var msg = unescape(encodeURIComponent(bytes)); // UTF8 escape
	
	    bytes = new Array(msg.length);
	
	    for (var i = 0; i < msg.length; i++) bytes[i] = msg.charCodeAt(i);
	  }
	
	  bytes.push(0x80);
	  var l = bytes.length / 4 + 2;
	  var N = Math.ceil(l / 16);
	  var M = new Array(N);
	
	  for (var i = 0; i < N; i++) {
	    M[i] = new Array(16);
	
	    for (var j = 0; j < 16; j++) {
	      M[i][j] = bytes[i * 64 + j * 4] << 24 | bytes[i * 64 + j * 4 + 1] << 16 | bytes[i * 64 + j * 4 + 2] << 8 | bytes[i * 64 + j * 4 + 3];
	    }
	  }
	
	  M[N - 1][14] = (bytes.length - 1) * 8 / Math.pow(2, 32);
	  M[N - 1][14] = Math.floor(M[N - 1][14]);
	  M[N - 1][15] = (bytes.length - 1) * 8 & 0xffffffff;
	
	  for (var i = 0; i < N; i++) {
	    var W = new Array(80);
	
	    for (var t = 0; t < 16; t++) W[t] = M[i][t];
	
	    for (var t = 16; t < 80; t++) {
	      W[t] = ROTL(W[t - 3] ^ W[t - 8] ^ W[t - 14] ^ W[t - 16], 1);
	    }
	
	    var a = H[0];
	    var b = H[1];
	    var c = H[2];
	    var d = H[3];
	    var e = H[4];
	
	    for (var t = 0; t < 80; t++) {
	      var s = Math.floor(t / 20);
	      var T = ROTL(a, 5) + f(s, b, c, d) + e + K[s] + W[t] >>> 0;
	      e = d;
	      d = c;
	      c = ROTL(b, 30) >>> 0;
	      b = a;
	      a = T;
	    }
	
	    H[0] = H[0] + a >>> 0;
	    H[1] = H[1] + b >>> 0;
	    H[2] = H[2] + c >>> 0;
	    H[3] = H[3] + d >>> 0;
	    H[4] = H[4] + e >>> 0;
	  }
	
	  return [H[0] >> 24 & 0xff, H[0] >> 16 & 0xff, H[0] >> 8 & 0xff, H[0] & 0xff, H[1] >> 24 & 0xff, H[1] >> 16 & 0xff, H[1] >> 8 & 0xff, H[1] & 0xff, H[2] >> 24 & 0xff, H[2] >> 16 & 0xff, H[2] >> 8 & 0xff, H[2] & 0xff, H[3] >> 24 & 0xff, H[3] >> 16 & 0xff, H[3] >> 8 & 0xff, H[3] & 0xff, H[4] >> 24 & 0xff, H[4] >> 16 & 0xff, H[4] >> 8 & 0xff, H[4] & 0xff];
	}
	
	var _default = sha1;
	exports.default = _default;

/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _rng = _interopRequireDefault(__webpack_require__(250));
	
	var _bytesToUuid = _interopRequireDefault(__webpack_require__(137));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// **`v1()` - Generate time-based UUID**
	//
	// Inspired by https://github.com/LiosK/UUID.js
	// and http://docs.python.org/library/uuid.html
	var _nodeId;
	
	var _clockseq; // Previous uuid creation time
	
	
	var _lastMSecs = 0;
	var _lastNSecs = 0; // See https://github.com/uuidjs/uuid for API details
	
	function v1(options, buf, offset) {
	  var i = buf && offset || 0;
	  var b = buf || [];
	  options = options || {};
	  var node = options.node || _nodeId;
	  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq; // node and clockseq need to be initialized to random values if they're not
	  // specified.  We do this lazily to minimize issues related to insufficient
	  // system entropy.  See #189
	
	  if (node == null || clockseq == null) {
	    var seedBytes = options.random || (options.rng || _rng.default)();
	
	    if (node == null) {
	      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
	      node = _nodeId = [seedBytes[0] | 0x01, seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]];
	    }
	
	    if (clockseq == null) {
	      // Per 4.2.2, randomize (14 bit) clockseq
	      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
	    }
	  } // UUID timestamps are 100 nano-second units since the Gregorian epoch,
	  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
	  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
	  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
	
	
	  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime(); // Per 4.2.1.2, use count of uuid's generated during the current clock
	  // cycle to simulate higher resolution clock
	
	  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1; // Time since last uuid creation (in msecs)
	
	  var dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 10000; // Per 4.2.1.2, Bump clockseq on clock regression
	
	  if (dt < 0 && options.clockseq === undefined) {
	    clockseq = clockseq + 1 & 0x3fff;
	  } // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
	  // time interval
	
	
	  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
	    nsecs = 0;
	  } // Per 4.2.1.2 Throw error if too many uuids are requested
	
	
	  if (nsecs >= 10000) {
	    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
	  }
	
	  _lastMSecs = msecs;
	  _lastNSecs = nsecs;
	  _clockseq = clockseq; // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
	
	  msecs += 12219292800000; // `time_low`
	
	  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
	  b[i++] = tl >>> 24 & 0xff;
	  b[i++] = tl >>> 16 & 0xff;
	  b[i++] = tl >>> 8 & 0xff;
	  b[i++] = tl & 0xff; // `time_mid`
	
	  var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
	  b[i++] = tmh >>> 8 & 0xff;
	  b[i++] = tmh & 0xff; // `time_high_and_version`
	
	  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
	
	  b[i++] = tmh >>> 16 & 0xff; // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
	
	  b[i++] = clockseq >>> 8 | 0x80; // `clock_seq_low`
	
	  b[i++] = clockseq & 0xff; // `node`
	
	  for (var n = 0; n < 6; ++n) {
	    b[i + n] = node[n];
	  }
	
	  return buf ? buf : (0, _bytesToUuid.default)(b);
	}
	
	var _default = v1;
	exports.default = _default;

/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _v = _interopRequireDefault(__webpack_require__(251));
	
	var _md = _interopRequireDefault(__webpack_require__(923));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	const v3 = (0, _v.default)('v3', 0x30, _md.default);
	var _default = v3;
	exports.default = _default;

/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _rng = _interopRequireDefault(__webpack_require__(250));
	
	var _bytesToUuid = _interopRequireDefault(__webpack_require__(137));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function v4(options, buf, offset) {
	  var i = buf && offset || 0;
	
	  if (typeof options == 'string') {
	    buf = options === 'binary' ? new Array(16) : null;
	    options = null;
	  }
	
	  options = options || {};
	
	  var rnds = options.random || (options.rng || _rng.default)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
	
	
	  rnds[6] = rnds[6] & 0x0f | 0x40;
	  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
	
	  if (buf) {
	    for (var ii = 0; ii < 16; ++ii) {
	      buf[i + ii] = rnds[ii];
	    }
	  }
	
	  return buf || (0, _bytesToUuid.default)(rnds);
	}
	
	var _default = v4;
	exports.default = _default;

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _v = _interopRequireDefault(__webpack_require__(251));
	
	var _sha = _interopRequireDefault(__webpack_require__(924));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	const v5 = (0, _v.default)('v5', 0x50, _sha.default);
	var _default = v5;
	exports.default = _default;

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PlayerStates = __webpack_require__(931);
	
	var _PlayerStates2 = _interopRequireDefault(_PlayerStates);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  pauseVideo: {
	    acceptableStates: [_PlayerStates2.default.ENDED, _PlayerStates2.default.PAUSED],
	    stateChangeRequired: false
	  },
	  playVideo: {
	    acceptableStates: [_PlayerStates2.default.ENDED, _PlayerStates2.default.PLAYING],
	    stateChangeRequired: false
	  },
	  seekTo: {
	    acceptableStates: [_PlayerStates2.default.ENDED, _PlayerStates2.default.PLAYING, _PlayerStates2.default.PAUSED],
	    stateChangeRequired: true,
	
	    // TRICKY: `seekTo` may not cause a state change if no buffering is
	    // required.
	    timeout: 3000
	  }
	};
	module.exports = exports['default'];

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _debug = __webpack_require__(379);
	
	var _debug2 = _interopRequireDefault(_debug);
	
	var _functionNames = __webpack_require__(933);
	
	var _functionNames2 = _interopRequireDefault(_functionNames);
	
	var _eventNames = __webpack_require__(932);
	
	var _eventNames2 = _interopRequireDefault(_eventNames);
	
	var _FunctionStateMap = __webpack_require__(929);
	
	var _FunctionStateMap2 = _interopRequireDefault(_FunctionStateMap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable promise/prefer-await-to-then */
	
	var debug = (0, _debug2.default)('youtube-player');
	
	var YouTubePlayer = {};
	
	/**
	 * Construct an object that defines an event handler for all of the YouTube
	 * player events. Proxy captured events through an event emitter.
	 *
	 * @todo Capture event parameters.
	 * @see https://developers.google.com/youtube/iframe_api_reference#Events
	 */
	YouTubePlayer.proxyEvents = function (emitter) {
	  var events = {};
	
	  var _loop = function _loop(eventName) {
	    var onEventName = 'on' + eventName.slice(0, 1).toUpperCase() + eventName.slice(1);
	
	    events[onEventName] = function (event) {
	      debug('event "%s"', onEventName, event);
	
	      emitter.trigger(eventName, event);
	    };
	  };
	
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = _eventNames2.default[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var eventName = _step.value;
	
	      _loop(eventName);
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  return events;
	};
	
	/**
	 * Delays player API method execution until player state is ready.
	 *
	 * @todo Proxy all of the methods using Object.keys.
	 * @todo See TRICKY below.
	 * @param playerAPIReady Promise that resolves when player is ready.
	 * @param strictState A flag designating whether or not to wait for
	 * an acceptable state when calling supported functions.
	 * @returns {Object}
	 */
	YouTubePlayer.promisifyPlayer = function (playerAPIReady) {
	  var strictState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var functions = {};
	
	  var _loop2 = function _loop2(functionName) {
	    if (strictState && _FunctionStateMap2.default[functionName]) {
	      functions[functionName] = function () {
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return playerAPIReady.then(function (player) {
	          var stateInfo = _FunctionStateMap2.default[functionName];
	          var playerState = player.getPlayerState();
	
	          // eslint-disable-next-line no-warning-comments
	          // TODO: Just spread the args into the function once Babel is fixed:
	          // https://github.com/babel/babel/issues/4270
	          //
	          // eslint-disable-next-line prefer-spread
	          var value = player[functionName].apply(player, args);
	
	          // TRICKY: For functions like `seekTo`, a change in state must be
	          // triggered given that the resulting state could match the initial
	          // state.
	          if (stateInfo.stateChangeRequired ||
	
	          // eslint-disable-next-line no-extra-parens
	          Array.isArray(stateInfo.acceptableStates) && stateInfo.acceptableStates.indexOf(playerState) === -1) {
	            return new Promise(function (resolve) {
	              var onPlayerStateChange = function onPlayerStateChange() {
	                var playerStateAfterChange = player.getPlayerState();
	
	                var timeout = void 0;
	
	                if (typeof stateInfo.timeout === 'number') {
	                  timeout = setTimeout(function () {
	                    player.removeEventListener('onStateChange', onPlayerStateChange);
	
	                    resolve();
	                  }, stateInfo.timeout);
	                }
	
	                if (Array.isArray(stateInfo.acceptableStates) && stateInfo.acceptableStates.indexOf(playerStateAfterChange) !== -1) {
	                  player.removeEventListener('onStateChange', onPlayerStateChange);
	
	                  clearTimeout(timeout);
	
	                  resolve();
	                }
	              };
	
	              player.addEventListener('onStateChange', onPlayerStateChange);
	            }).then(function () {
	              return value;
	            });
	          }
	
	          return value;
	        });
	      };
	    } else {
	      functions[functionName] = function () {
	        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	          args[_key2] = arguments[_key2];
	        }
	
	        return playerAPIReady.then(function (player) {
	          // eslint-disable-next-line no-warning-comments
	          // TODO: Just spread the args into the function once Babel is fixed:
	          // https://github.com/babel/babel/issues/4270
	          //
	          // eslint-disable-next-line prefer-spread
	          return player[functionName].apply(player, args);
	        });
	      };
	    }
	  };
	
	  var _iteratorNormalCompletion2 = true;
	  var _didIteratorError2 = false;
	  var _iteratorError2 = undefined;
	
	  try {
	    for (var _iterator2 = _functionNames2.default[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	      var functionName = _step2.value;
	
	      _loop2(functionName);
	    }
	  } catch (err) {
	    _didIteratorError2 = true;
	    _iteratorError2 = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion2 && _iterator2.return) {
	        _iterator2.return();
	      }
	    } finally {
	      if (_didIteratorError2) {
	        throw _iteratorError2;
	      }
	    }
	  }
	
	  return functions;
	};
	
	exports.default = YouTubePlayer;
	module.exports = exports['default'];

/***/ }),
/* 931 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  BUFFERING: 3,
	  ENDED: 0,
	  PAUSED: 2,
	  PLAYING: 1,
	  UNSTARTED: -1,
	  VIDEO_CUED: 5
	};
	module.exports = exports["default"];

/***/ }),
/* 932 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	/**
	 * @see https://developers.google.com/youtube/iframe_api_reference#Events
	 * `volumeChange` is not officially supported but seems to work
	 * it emits an object: `{volume: 82.6923076923077, muted: false}`
	 */
	exports.default = ['ready', 'stateChange', 'playbackQualityChange', 'playbackRateChange', 'error', 'apiChange', 'volumeChange'];
	module.exports = exports['default'];

/***/ }),
/* 933 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	/**
	 * @see https://developers.google.com/youtube/iframe_api_reference#Functions
	 */
	exports.default = ['cueVideoById', 'loadVideoById', 'cueVideoByUrl', 'loadVideoByUrl', 'playVideo', 'pauseVideo', 'stopVideo', 'getVideoLoadedFraction', 'cuePlaylist', 'loadPlaylist', 'nextVideo', 'previousVideo', 'playVideoAt', 'setShuffle', 'setLoop', 'getPlaylist', 'getPlaylistIndex', 'setOption', 'mute', 'unMute', 'isMuted', 'setVolume', 'getVolume', 'seekTo', 'getPlayerState', 'getPlaybackRate', 'setPlaybackRate', 'getAvailablePlaybackRates', 'getPlaybackQuality', 'setPlaybackQuality', 'getAvailableQualityLevels', 'getCurrentTime', 'getDuration', 'removeEventListener', 'getVideoUrl', 'getVideoEmbedCode', 'getOptions', 'getOption', 'addEventListener', 'destroy', 'setSize', 'getIframe'];
	module.exports = exports['default'];

/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _sister = __webpack_require__(905);
	
	var _sister2 = _interopRequireDefault(_sister);
	
	var _loadYouTubeIframeApi = __webpack_require__(935);
	
	var _loadYouTubeIframeApi2 = _interopRequireDefault(_loadYouTubeIframeApi);
	
	var _YouTubePlayer = __webpack_require__(930);
	
	var _YouTubePlayer2 = _interopRequireDefault(_YouTubePlayer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @typedef YT.Player
	 * @see https://developers.google.com/youtube/iframe_api_reference
	 * */
	
	/**
	 * @see https://developers.google.com/youtube/iframe_api_reference#Loading_a_Video_Player
	 */
	var youtubeIframeAPI = void 0;
	
	/**
	 * A factory function used to produce an instance of YT.Player and queue function calls and proxy events of the resulting object.
	 *
	 * @param maybeElementId Either An existing YT.Player instance,
	 * the DOM element or the id of the HTML element where the API will insert an <iframe>.
	 * @param options See `options` (Ignored when using an existing YT.Player instance).
	 * @param strictState A flag designating whether or not to wait for
	 * an acceptable state when calling supported functions. Default: `false`.
	 * See `FunctionStateMap.js` for supported functions and acceptable states.
	 */
	
	exports.default = function (maybeElementId) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var strictState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var emitter = (0, _sister2.default)();
	
	  if (!youtubeIframeAPI) {
	    youtubeIframeAPI = (0, _loadYouTubeIframeApi2.default)(emitter);
	  }
	
	  if (options.events) {
	    throw new Error('Event handlers cannot be overwritten.');
	  }
	
	  if (typeof maybeElementId === 'string' && !document.getElementById(maybeElementId)) {
	    throw new Error('Element "' + maybeElementId + '" does not exist.');
	  }
	
	  options.events = _YouTubePlayer2.default.proxyEvents(emitter);
	
	  var playerAPIReady = new Promise(function (resolve) {
	    if ((typeof maybeElementId === 'undefined' ? 'undefined' : _typeof(maybeElementId)) === 'object' && maybeElementId.playVideo instanceof Function) {
	      var player = maybeElementId;
	
	      resolve(player);
	    } else {
	      // asume maybeElementId can be rendered inside
	      // eslint-disable-next-line promise/catch-or-return
	      youtubeIframeAPI.then(function (YT) {
	        // eslint-disable-line promise/prefer-await-to-then
	        var player = new YT.Player(maybeElementId, options);
	
	        emitter.on('ready', function () {
	          resolve(player);
	        });
	
	        return null;
	      });
	    }
	  });
	
	  var playerApi = _YouTubePlayer2.default.promisifyPlayer(playerAPIReady, strictState);
	
	  playerApi.on = emitter.on;
	  playerApi.off = emitter.off;
	
	  return playerApi;
	};
	
	module.exports = exports['default'];

/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _loadScript = __webpack_require__(400);
	
	var _loadScript2 = _interopRequireDefault(_loadScript);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (emitter) {
	  /**
	   * A promise that is resolved when window.onYouTubeIframeAPIReady is called.
	   * The promise is resolved with a reference to window.YT object.
	   */
	  var iframeAPIReady = new Promise(function (resolve) {
	    if (window.YT && window.YT.Player && window.YT.Player instanceof Function) {
	      resolve(window.YT);
	
	      return;
	    } else {
	      var protocol = window.location.protocol === 'http:' ? 'http:' : 'https:';
	
	      (0, _loadScript2.default)(protocol + '//www.youtube.com/iframe_api', function (error) {
	        if (error) {
	          emitter.trigger('error', error);
	        }
	      });
	    }
	
	    var previous = window.onYouTubeIframeAPIReady;
	
	    // The API will call this function when page has finished downloading
	    // the JavaScript for the player API.
	    window.onYouTubeIframeAPIReady = function () {
	      if (previous) {
	        previous();
	      }
	
	      resolve(window.YT);
	    };
	  });
	
	  return iframeAPIReady;
	};
	
	module.exports = exports['default'];

/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var sheet = __webpack_require__(__webpack_module_template_argument_0__);
	var Stylis = _interopDefault(__webpack_require__(__webpack_module_template_argument_1__));
	__webpack_require__(__webpack_module_template_argument_2__);
	
	// https://github.com/thysultan/stylis.js/tree/master/plugins/rule-sheet
	// inlined to avoid umd wrapper and peerDep warnings/installing stylis
	// since we use stylis after closure compiler
	var delimiter = '/*|*/';
	var needle = delimiter + '}';
	
	function toSheet(block) {
	  if (block) {
	    Sheet.current.insert(block + '}');
	  }
	}
	
	var Sheet = {
	  current: null
	};
	var ruleSheet = function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
	  switch (context) {
	    // property
	    case 1:
	      {
	        switch (content.charCodeAt(0)) {
	          case 64:
	            {
	              // @import
	              Sheet.current.insert(content + ';');
	              return '';
	            }
	          // charcode for l
	
	          case 108:
	            {
	              // charcode for b
	              // this ignores label
	              if (content.charCodeAt(2) === 98) {
	                return '';
	              }
	            }
	        }
	
	        break;
	      }
	    // selector
	
	    case 2:
	      {
	        if (ns === 0) return content + delimiter;
	        break;
	      }
	    // at-rule
	
	    case 3:
	      {
	        switch (ns) {
	          // @font-face, @page
	          case 102:
	          case 112:
	            {
	              Sheet.current.insert(selectors[0] + content);
	              return '';
	            }
	
	          default:
	            {
	              return content + (at === 0 ? delimiter : '');
	            }
	        }
	      }
	
	    case -2:
	      {
	        content.split(needle).forEach(toSheet);
	      }
	  }
	};
	
	var createCache = function createCache(options) {
	  if (options === undefined) options = {};
	  var key = options.key || 'css';
	  var stylisOptions;
	
	  if (options.prefix !== undefined) {
	    stylisOptions = {
	      prefix: options.prefix
	    };
	  }
	
	  var stylis = new Stylis(stylisOptions);
	
	  if (false) {
	    // $FlowFixMe
	    if (/[^a-z-]/.test(key)) {
	      throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
	    }
	  }
	
	  var inserted = {}; // $FlowFixMe
	
	  var container;
	
	  {
	    container = options.container || document.head;
	    var nodes = document.querySelectorAll("style[data-emotion-" + key + "]");
	    Array.prototype.forEach.call(nodes, function (node) {
	      var attrib = node.getAttribute("data-emotion-" + key); // $FlowFixMe
	
	      attrib.split(' ').forEach(function (id) {
	        inserted[id] = true;
	      });
	
	      if (node.parentNode !== container) {
	        container.appendChild(node);
	      }
	    });
	  }
	
	  var _insert;
	
	  {
	    stylis.use(options.stylisPlugins)(ruleSheet);
	
	    _insert = function insert(selector, serialized, sheet, shouldCache) {
	      var name = serialized.name;
	      Sheet.current = sheet;
	
	      if (false) {
	        var map = serialized.map;
	        Sheet.current = {
	          insert: function insert(rule) {
	            sheet.insert(rule + map);
	          }
	        };
	      }
	
	      stylis(selector, serialized.styles);
	
	      if (shouldCache) {
	        cache.inserted[name] = true;
	      }
	    };
	  }
	
	  if (false) {
	    // https://esbench.com/bench/5bf7371a4cd7e6009ef61d0a
	    var commentStart = /\/\*/g;
	    var commentEnd = /\*\//g;
	    stylis.use(function (context, content) {
	      switch (context) {
	        case -1:
	          {
	            while (commentStart.test(content)) {
	              commentEnd.lastIndex = commentStart.lastIndex;
	
	              if (commentEnd.test(content)) {
	                commentStart.lastIndex = commentEnd.lastIndex;
	                continue;
	              }
	
	              throw new Error('Your styles have an unterminated comment ("/*" without corresponding "*/").');
	            }
	
	            commentStart.lastIndex = 0;
	            break;
	          }
	      }
	    });
	    stylis.use(function (context, content, selectors) {
	      switch (context) {
	        case -1:
	          {
	            var flag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';
	            var unsafePseudoClasses = content.match(/(:first|:nth|:nth-last)-child/g);
	
	            if (unsafePseudoClasses && cache.compat !== true) {
	              unsafePseudoClasses.forEach(function (unsafePseudoClass) {
	                var ignoreRegExp = new RegExp(unsafePseudoClass + ".*\\/\\* " + flag + " \\*\\/");
	                var ignore = ignoreRegExp.test(content);
	
	                if (unsafePseudoClass && !ignore) {
	                  console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
	                }
	              });
	            }
	
	            break;
	          }
	      }
	    });
	  }
	
	  var cache = {
	    key: key,
	    sheet: new sheet.StyleSheet({
	      key: key,
	      container: container,
	      nonce: options.nonce,
	      speedy: options.speedy
	    }),
	    nonce: options.nonce,
	    inserted: inserted,
	    registered: {},
	    insert: _insert
	  };
	  return cache;
	};
	
	exports.default = createCache;


/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var serialize = __webpack_require__(__webpack_module_template_argument_0__);
	
	function css() {
	  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  return serialize.serializeStyles(args);
	}
	
	exports.default = css;


/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var root = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var Symbol = __webpack_require__(__webpack_module_template_argument_0__),
	    getRawTag = __webpack_require__(__webpack_module_template_argument_1__),
	    objectToString = __webpack_require__(__webpack_module_template_argument_2__);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var overArg = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var Symbol = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var freeGlobal = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var baseGetTag = __webpack_require__(__webpack_module_template_argument_0__),
	    getPrototype = __webpack_require__(__webpack_module_template_argument_1__),
	    isObjectLike = __webpack_require__(__webpack_module_template_argument_2__);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	var colorString = __webpack_require__(__webpack_module_template_argument_0__);
	var convert = __webpack_require__(35);
	
	var _slice = [].slice;
	
	var skippedModels = [
		// to be honest, I don't really feel like keyword belongs in color convert, but eh.
		'keyword',
	
		// gray conflicts with some method names, and has its own method defined.
		'gray',
	
		// shouldn't really be in color-convert either...
		'hex'
	];
	
	var hashedModelKeys = {};
	Object.keys(convert).forEach(function (model) {
		hashedModelKeys[_slice.call(convert[model].labels).sort().join('')] = model;
	});
	
	var limiters = {};
	
	function Color(obj, model) {
		if (!(this instanceof Color)) {
			return new Color(obj, model);
		}
	
		if (model && model in skippedModels) {
			model = null;
		}
	
		if (model && !(model in convert)) {
			throw new Error('Unknown model: ' + model);
		}
	
		var i;
		var channels;
	
		if (!obj) {
			this.model = 'rgb';
			this.color = [0, 0, 0];
			this.valpha = 1;
		} else if (obj instanceof Color) {
			this.model = obj.model;
			this.color = obj.color.slice();
			this.valpha = obj.valpha;
		} else if (typeof obj === 'string') {
			var result = colorString.get(obj);
			if (result === null) {
				throw new Error('Unable to parse color from string: ' + obj);
			}
	
			this.model = result.model;
			channels = convert[this.model].channels;
			this.color = result.value.slice(0, channels);
			this.valpha = typeof result.value[channels] === 'number' ? result.value[channels] : 1;
		} else if (obj.length) {
			this.model = model || 'rgb';
			channels = convert[this.model].channels;
			var newArr = _slice.call(obj, 0, channels);
			this.color = zeroArray(newArr, channels);
			this.valpha = typeof obj[channels] === 'number' ? obj[channels] : 1;
		} else if (typeof obj === 'number') {
			// this is always RGB - can be converted later on.
			obj &= 0xFFFFFF;
			this.model = 'rgb';
			this.color = [
				(obj >> 16) & 0xFF,
				(obj >> 8) & 0xFF,
				obj & 0xFF
			];
			this.valpha = 1;
		} else {
			this.valpha = 1;
	
			var keys = Object.keys(obj);
			if ('alpha' in obj) {
				keys.splice(keys.indexOf('alpha'), 1);
				this.valpha = typeof obj.alpha === 'number' ? obj.alpha : 0;
			}
	
			var hashedKeys = keys.sort().join('');
			if (!(hashedKeys in hashedModelKeys)) {
				throw new Error('Unable to parse color from object: ' + JSON.stringify(obj));
			}
	
			this.model = hashedModelKeys[hashedKeys];
	
			var labels = convert[this.model].labels;
			var color = [];
			for (i = 0; i < labels.length; i++) {
				color.push(obj[labels[i]]);
			}
	
			this.color = zeroArray(color);
		}
	
		// perform limitations (clamping, etc.)
		if (limiters[this.model]) {
			channels = convert[this.model].channels;
			for (i = 0; i < channels; i++) {
				var limit = limiters[this.model][i];
				if (limit) {
					this.color[i] = limit(this.color[i]);
				}
			}
		}
	
		this.valpha = Math.max(0, Math.min(1, this.valpha));
	
		if (Object.freeze) {
			Object.freeze(this);
		}
	}
	
	Color.prototype = {
		toString: function () {
			return this.string();
		},
	
		toJSON: function () {
			return this[this.model]();
		},
	
		string: function (places) {
			var self = this.model in colorString.to ? this : this.rgb();
			self = self.round(typeof places === 'number' ? places : 1);
			var args = self.valpha === 1 ? self.color : self.color.concat(this.valpha);
			return colorString.to[self.model](args);
		},
	
		percentString: function (places) {
			var self = this.rgb().round(typeof places === 'number' ? places : 1);
			var args = self.valpha === 1 ? self.color : self.color.concat(this.valpha);
			return colorString.to.rgb.percent(args);
		},
	
		array: function () {
			return this.valpha === 1 ? this.color.slice() : this.color.concat(this.valpha);
		},
	
		object: function () {
			var result = {};
			var channels = convert[this.model].channels;
			var labels = convert[this.model].labels;
	
			for (var i = 0; i < channels; i++) {
				result[labels[i]] = this.color[i];
			}
	
			if (this.valpha !== 1) {
				result.alpha = this.valpha;
			}
	
			return result;
		},
	
		unitArray: function () {
			var rgb = this.rgb().color;
			rgb[0] /= 255;
			rgb[1] /= 255;
			rgb[2] /= 255;
	
			if (this.valpha !== 1) {
				rgb.push(this.valpha);
			}
	
			return rgb;
		},
	
		unitObject: function () {
			var rgb = this.rgb().object();
			rgb.r /= 255;
			rgb.g /= 255;
			rgb.b /= 255;
	
			if (this.valpha !== 1) {
				rgb.alpha = this.valpha;
			}
	
			return rgb;
		},
	
		round: function (places) {
			places = Math.max(places || 0, 0);
			return new Color(this.color.map(roundToPlace(places)).concat(this.valpha), this.model);
		},
	
		alpha: function (val) {
			if (arguments.length) {
				return new Color(this.color.concat(Math.max(0, Math.min(1, val))), this.model);
			}
	
			return this.valpha;
		},
	
		// rgb
		red: getset('rgb', 0, maxfn(255)),
		green: getset('rgb', 1, maxfn(255)),
		blue: getset('rgb', 2, maxfn(255)),
	
		hue: getset(['hsl', 'hsv', 'hsl', 'hwb', 'hcg'], 0, function (val) { return ((val % 360) + 360) % 360; }), // eslint-disable-line brace-style
	
		saturationl: getset('hsl', 1, maxfn(100)),
		lightness: getset('hsl', 2, maxfn(100)),
	
		saturationv: getset('hsv', 1, maxfn(100)),
		value: getset('hsv', 2, maxfn(100)),
	
		chroma: getset('hcg', 1, maxfn(100)),
		gray: getset('hcg', 2, maxfn(100)),
	
		white: getset('hwb', 1, maxfn(100)),
		wblack: getset('hwb', 2, maxfn(100)),
	
		cyan: getset('cmyk', 0, maxfn(100)),
		magenta: getset('cmyk', 1, maxfn(100)),
		yellow: getset('cmyk', 2, maxfn(100)),
		black: getset('cmyk', 3, maxfn(100)),
	
		x: getset('xyz', 0, maxfn(100)),
		y: getset('xyz', 1, maxfn(100)),
		z: getset('xyz', 2, maxfn(100)),
	
		l: getset('lab', 0, maxfn(100)),
		a: getset('lab', 1),
		b: getset('lab', 2),
	
		keyword: function (val) {
			if (arguments.length) {
				return new Color(val);
			}
	
			return convert[this.model].keyword(this.color);
		},
	
		hex: function (val) {
			if (arguments.length) {
				return new Color(val);
			}
	
			return colorString.to.hex(this.rgb().round().color);
		},
	
		rgbNumber: function () {
			var rgb = this.rgb().color;
			return ((rgb[0] & 0xFF) << 16) | ((rgb[1] & 0xFF) << 8) | (rgb[2] & 0xFF);
		},
	
		luminosity: function () {
			// http://www.w3.org/TR/WCAG20/#relativeluminancedef
			var rgb = this.rgb().color;
	
			var lum = [];
			for (var i = 0; i < rgb.length; i++) {
				var chan = rgb[i] / 255;
				lum[i] = (chan <= 0.03928) ? chan / 12.92 : Math.pow(((chan + 0.055) / 1.055), 2.4);
			}
	
			return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
		},
	
		contrast: function (color2) {
			// http://www.w3.org/TR/WCAG20/#contrast-ratiodef
			var lum1 = this.luminosity();
			var lum2 = color2.luminosity();
	
			if (lum1 > lum2) {
				return (lum1 + 0.05) / (lum2 + 0.05);
			}
	
			return (lum2 + 0.05) / (lum1 + 0.05);
		},
	
		level: function (color2) {
			var contrastRatio = this.contrast(color2);
			if (contrastRatio >= 7.1) {
				return 'AAA';
			}
	
			return (contrastRatio >= 4.5) ? 'AA' : '';
		},
	
		dark: function () {
			// YIQ equation from http://24ways.org/2010/calculating-color-contrast
			var rgb = this.rgb().color;
			var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
			return yiq < 128;
		},
	
		light: function () {
			return !this.dark();
		},
	
		negate: function () {
			var rgb = this.rgb();
			for (var i = 0; i < 3; i++) {
				rgb.color[i] = 255 - rgb.color[i];
			}
			return rgb;
		},
	
		lighten: function (ratio) {
			var hsl = this.hsl();
			hsl.color[2] += hsl.color[2] * ratio;
			return hsl;
		},
	
		darken: function (ratio) {
			var hsl = this.hsl();
			hsl.color[2] -= hsl.color[2] * ratio;
			return hsl;
		},
	
		saturate: function (ratio) {
			var hsl = this.hsl();
			hsl.color[1] += hsl.color[1] * ratio;
			return hsl;
		},
	
		desaturate: function (ratio) {
			var hsl = this.hsl();
			hsl.color[1] -= hsl.color[1] * ratio;
			return hsl;
		},
	
		whiten: function (ratio) {
			var hwb = this.hwb();
			hwb.color[1] += hwb.color[1] * ratio;
			return hwb;
		},
	
		blacken: function (ratio) {
			var hwb = this.hwb();
			hwb.color[2] += hwb.color[2] * ratio;
			return hwb;
		},
	
		grayscale: function () {
			// http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
			var rgb = this.rgb().color;
			var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
			return Color.rgb(val, val, val);
		},
	
		fade: function (ratio) {
			return this.alpha(this.valpha - (this.valpha * ratio));
		},
	
		opaquer: function (ratio) {
			return this.alpha(this.valpha + (this.valpha * ratio));
		},
	
		rotate: function (degrees) {
			var hsl = this.hsl();
			var hue = hsl.color[0];
			hue = (hue + degrees) % 360;
			hue = hue < 0 ? 360 + hue : hue;
			hsl.color[0] = hue;
			return hsl;
		},
	
		mix: function (mixinColor, weight) {
			// ported from sass implementation in C
			// https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
			var color1 = mixinColor.rgb();
			var color2 = this.rgb();
			var p = weight === undefined ? 0.5 : weight;
	
			var w = 2 * p - 1;
			var a = color1.alpha() - color2.alpha();
	
			var w1 = (((w * a === -1) ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
			var w2 = 1 - w1;
	
			return Color.rgb(
					w1 * color1.red() + w2 * color2.red(),
					w1 * color1.green() + w2 * color2.green(),
					w1 * color1.blue() + w2 * color2.blue(),
					color1.alpha() * p + color2.alpha() * (1 - p));
		}
	};
	
	// model conversion methods and static constructors
	Object.keys(convert).forEach(function (model) {
		if (skippedModels.indexOf(model) !== -1) {
			return;
		}
	
		var channels = convert[model].channels;
	
		// conversion methods
		Color.prototype[model] = function () {
			if (this.model === model) {
				return new Color(this);
			}
	
			if (arguments.length) {
				return new Color(arguments, model);
			}
	
			var newAlpha = typeof arguments[channels] === 'number' ? channels : this.valpha;
			return new Color(assertArray(convert[this.model][model].raw(this.color)).concat(newAlpha), model);
		};
	
		// 'static' construction methods
		Color[model] = function (color) {
			if (typeof color === 'number') {
				color = zeroArray(_slice.call(arguments), channels);
			}
			return new Color(color, model);
		};
	});
	
	function roundTo(num, places) {
		return Number(num.toFixed(places));
	}
	
	function roundToPlace(places) {
		return function (num) {
			return roundTo(num, places);
		};
	}
	
	function getset(model, channel, modifier) {
		model = Array.isArray(model) ? model : [model];
	
		model.forEach(function (m) {
			(limiters[m] || (limiters[m] = []))[channel] = modifier;
		});
	
		model = model[0];
	
		return function (val) {
			var result;
	
			if (arguments.length) {
				if (modifier) {
					val = modifier(val);
				}
	
				result = this[model]();
				result.color[channel] = val;
				return result;
			}
	
			result = this[model]().color[channel];
			if (modifier) {
				result = modifier(result);
			}
	
			return result;
		};
	}
	
	function maxfn(max) {
		return function (v) {
			return Math.max(0, Math.min(max, v));
		};
	}
	
	function assertArray(val) {
		return Array.isArray(val) ? val : [val];
	}
	
	function zeroArray(arr, length) {
		for (var i = 0; i < length; i++) {
			if (typeof arr[i] !== 'number') {
				arr[i] = 0;
			}
		}
	
		return arr;
	}
	
	module.exports = Color;


/***/ })
/******/ ])));


// WEBPACK FOOTER //
// /scripts/app.b31cbf17696e77a362c1.js